/**
* plotly.js v2.35.3
* Copyright 2012-2024, Plotly, Inc.
* All rights reserved.
* Licensed under the MIT license
*/
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Plotly"] = factory();
	else
		root["Plotly"] = factory();
})(self, function() {
return /******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 6713:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var rules = {
  "X,X div": "direction:ltr;font-family:\"Open Sans\",verdana,arial,sans-serif;margin:0;padding:0;",
  "X input,X button": "font-family:\"Open Sans\",verdana,arial,sans-serif;",
  "X input:focus,X button:focus": "outline:none;",
  "X a": "text-decoration:none;",
  "X a:hover": "text-decoration:none;",
  "X .crisp": "shape-rendering:crispEdges;",
  "X .user-select-none": "-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;-o-user-select:none;user-select:none;",
  "X svg": "overflow:hidden;",
  "X svg a": "fill:#447adb;",
  "X svg a:hover": "fill:#3c6dc5;",
  "X .main-svg": "position:absolute;top:0;left:0;pointer-events:none;",
  "X .main-svg .draglayer": "pointer-events:all;",
  "X .cursor-default": "cursor:default;",
  "X .cursor-pointer": "cursor:pointer;",
  "X .cursor-crosshair": "cursor:crosshair;",
  "X .cursor-move": "cursor:move;",
  "X .cursor-col-resize": "cursor:col-resize;",
  "X .cursor-row-resize": "cursor:row-resize;",
  "X .cursor-ns-resize": "cursor:ns-resize;",
  "X .cursor-ew-resize": "cursor:ew-resize;",
  "X .cursor-sw-resize": "cursor:sw-resize;",
  "X .cursor-s-resize": "cursor:s-resize;",
  "X .cursor-se-resize": "cursor:se-resize;",
  "X .cursor-w-resize": "cursor:w-resize;",
  "X .cursor-e-resize": "cursor:e-resize;",
  "X .cursor-nw-resize": "cursor:nw-resize;",
  "X .cursor-n-resize": "cursor:n-resize;",
  "X .cursor-ne-resize": "cursor:ne-resize;",
  "X .cursor-grab": "cursor:-webkit-grab;cursor:grab;",
  "X .modebar": "position:absolute;top:2px;right:2px;",
  "X .ease-bg": "-webkit-transition:background-color .3s ease 0s;-moz-transition:background-color .3s ease 0s;-ms-transition:background-color .3s ease 0s;-o-transition:background-color .3s ease 0s;transition:background-color .3s ease 0s;",
  "X .modebar--hover>:not(.watermark)": "opacity:0;-webkit-transition:opacity .3s ease 0s;-moz-transition:opacity .3s ease 0s;-ms-transition:opacity .3s ease 0s;-o-transition:opacity .3s ease 0s;transition:opacity .3s ease 0s;",
  "X:hover .modebar--hover .modebar-group": "opacity:1;",
  "X .modebar-group": "float:left;display:inline-block;box-sizing:border-box;padding-left:8px;position:relative;vertical-align:middle;white-space:nowrap;",
  "X .modebar-btn": "position:relative;font-size:16px;padding:3px 4px;height:22px;cursor:pointer;line-height:normal;box-sizing:border-box;",
  "X .modebar-btn svg": "position:relative;top:2px;",
  "X .modebar.vertical": "display:flex;flex-direction:column;flex-wrap:wrap;align-content:flex-end;max-height:100%;",
  "X .modebar.vertical svg": "top:-1px;",
  "X .modebar.vertical .modebar-group": "display:block;float:none;padding-left:0px;padding-bottom:8px;",
  "X .modebar.vertical .modebar-group .modebar-btn": "display:block;text-align:center;",
  "X [data-title]:before,X [data-title]:after": "position:absolute;-webkit-transform:translate3d(0, 0, 0);-moz-transform:translate3d(0, 0, 0);-ms-transform:translate3d(0, 0, 0);-o-transform:translate3d(0, 0, 0);transform:translate3d(0, 0, 0);display:none;opacity:0;z-index:1001;pointer-events:none;top:110%;right:50%;",
  "X [data-title]:hover:before,X [data-title]:hover:after": "display:block;opacity:1;",
  "X [data-title]:before": "content:\"\";position:absolute;background:rgba(0,0,0,0);border:6px solid rgba(0,0,0,0);z-index:1002;margin-top:-12px;border-bottom-color:#69738a;margin-right:-6px;",
  "X [data-title]:after": "content:attr(data-title);background:#69738a;color:#fff;padding:8px 10px;font-size:12px;line-height:12px;white-space:nowrap;margin-right:-18px;border-radius:2px;",
  "X .vertical [data-title]:before,X .vertical [data-title]:after": "top:0%;right:200%;",
  "X .vertical [data-title]:before": "border:6px solid rgba(0,0,0,0);border-left-color:#69738a;margin-top:8px;margin-right:-30px;",
  Y: "font-family:\"Open Sans\",verdana,arial,sans-serif;position:fixed;top:50px;right:20px;z-index:10000;font-size:10pt;max-width:180px;",
  "Y p": "margin:0;",
  "Y .notifier-note": "min-width:180px;max-width:250px;border:1px solid #fff;z-index:3000;margin:0;background-color:#8c97af;background-color:rgba(140,151,175,.9);color:#fff;padding:10px;overflow-wrap:break-word;word-wrap:break-word;-ms-hyphens:auto;-webkit-hyphens:auto;hyphens:auto;",
  "Y .notifier-close": "color:#fff;opacity:.8;float:right;padding:0 5px;background:none;border:none;font-size:20px;font-weight:bold;line-height:20px;",
  "Y .notifier-close:hover": "color:#444;text-decoration:none;cursor:pointer;"
};
for (var selector in rules) {
  var fullSelector = selector.replace(/^,/, ' ,').replace(/X/g, '.js-plotly-plot .plotly').replace(/Y/g, '.plotly-notifier');
  Lib.addStyleRule(fullSelector, rules[selector]);
}

/***/ }),

/***/ 14187:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(47908);

/***/ }),

/***/ 20273:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(58218);

/***/ }),

/***/ 6457:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(89362);

/***/ }),

/***/ 15849:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(53794);

/***/ }),

/***/ 38847:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(29698);

/***/ }),

/***/ 7659:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(51252);

/***/ }),

/***/ 60089:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(48050);

/***/ }),

/***/ 22084:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(58075);

/***/ }),

/***/ 35892:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(9419);

/***/ }),

/***/ 81204:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(28128);

/***/ }),

/***/ 55857:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(47050);

/***/ }),

/***/ 12862:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(91405);

/***/ }),

/***/ 97629:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(34406);

/***/ }),

/***/ 67549:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(17430);

/***/ }),

/***/ 2660:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(91995);

/***/ }),

/***/ 86071:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(81264);

/***/ }),

/***/ 66200:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(42849);

/***/ }),

/***/ 53446:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(52213);

/***/ }),

/***/ 86899:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(91132);

/***/ }),

/***/ 13430:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(50453);

/***/ }),

/***/ 21548:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(29251);

/***/ }),

/***/ 53939:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(72892);

/***/ }),

/***/ 1902:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(74461);

/***/ }),

/***/ 29096:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(66143);

/***/ }),

/***/ 23820:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(81955);

/***/ }),

/***/ 82017:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(36858);

/***/ }),

/***/ 113:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(92106);

/***/ }),

/***/ 20260:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Plotly = __webpack_require__(67549);
Plotly.register([
// traces
__webpack_require__(20273), __webpack_require__(15849), __webpack_require__(21548), __webpack_require__(1902), __webpack_require__(29096), __webpack_require__(23820), __webpack_require__(12862), __webpack_require__(1639), __webpack_require__(10067), __webpack_require__(53446), __webpack_require__(31014), __webpack_require__(113), __webpack_require__(78170), __webpack_require__(8202), __webpack_require__(92382), __webpack_require__(82017), __webpack_require__(86899), __webpack_require__(54357), __webpack_require__(66903), __webpack_require__(90594), __webpack_require__(71680), __webpack_require__(7412), __webpack_require__(55857), __webpack_require__(784), __webpack_require__(74221), __webpack_require__(22084), __webpack_require__(44001), __webpack_require__(97281), __webpack_require__(12345), __webpack_require__(53939), __webpack_require__(29117), __webpack_require__(5410), __webpack_require__(5057), __webpack_require__(81204), __webpack_require__(86071), __webpack_require__(14226), __webpack_require__(35892), __webpack_require__(2660), __webpack_require__(96599), __webpack_require__(28573), __webpack_require__(76832), __webpack_require__(60089), __webpack_require__(51469), __webpack_require__(97629), __webpack_require__(27700), __webpack_require__(7659), __webpack_require__(11780), __webpack_require__(27195), __webpack_require__(6457), __webpack_require__(84639),
// transforms
__webpack_require__(14187), __webpack_require__(66200), __webpack_require__(13430), __webpack_require__(90590),
// components
__webpack_require__(38847)]);
module.exports = Plotly;

/***/ }),

/***/ 28573:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(25638);

/***/ }),

/***/ 90594:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(75297);

/***/ }),

/***/ 7412:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(58859);

/***/ }),

/***/ 27700:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(12683);

/***/ }),

/***/ 5410:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(6305);

/***/ }),

/***/ 29117:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(83910);

/***/ }),

/***/ 78170:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(49913);

/***/ }),

/***/ 12345:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(15186);

/***/ }),

/***/ 96599:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(71760);

/***/ }),

/***/ 54357:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(17822);

/***/ }),

/***/ 51469:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(56534);

/***/ }),

/***/ 74221:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(18070);

/***/ }),

/***/ 44001:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(52378);

/***/ }),

/***/ 14226:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(30929);

/***/ }),

/***/ 5057:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(83866);

/***/ }),

/***/ 11780:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(66939);

/***/ }),

/***/ 27195:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(23748);

/***/ }),

/***/ 84639:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(73304);

/***/ }),

/***/ 1639:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(12864);

/***/ }),

/***/ 90590:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(99855);

/***/ }),

/***/ 97281:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(91450);

/***/ }),

/***/ 784:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(51943);

/***/ }),

/***/ 8202:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(80809);

/***/ }),

/***/ 66903:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(95984);

/***/ }),

/***/ 76832:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(51671);

/***/ }),

/***/ 92382:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(47181);

/***/ }),

/***/ 10067:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(37276);

/***/ }),

/***/ 71680:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(75703);

/***/ }),

/***/ 31014:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(38261);

/***/ }),

/***/ 11645:
/***/ (function(module) {

"use strict";


/**
 * All paths are tuned for maximum scalability of the arrowhead,
 * ie throughout arrowwidth=0.3..3 the head is joined smoothly
 * to the line, with the line coming from the left and ending at (0, 0).
 *
 * `backoff` is the distance to move the arrowhead and the end of the line,
 * in order that the arrowhead points to the desired place, either at
 * the tip of the arrow or (in the case of circle or square)
 * the center of the symbol.
 *
 * `noRotate`, if truthy, says that this arrowhead should not rotate with the
 * arrow. That's the case for squares, which should always be straight, and
 * circles, for which it's irrelevant.
 */
module.exports = [
// no arrow
{
  path: '',
  backoff: 0
},
// wide with flat back
{
  path: 'M-2.4,-3V3L0.6,0Z',
  backoff: 0.6
},
// narrower with flat back
{
  path: 'M-3.7,-2.5V2.5L1.3,0Z',
  backoff: 1.3
},
// barbed
{
  path: 'M-4.45,-3L-1.65,-0.2V0.2L-4.45,3L1.55,0Z',
  backoff: 1.55
},
// wide line-drawn
{
  path: 'M-2.2,-2.2L-0.2,-0.2V0.2L-2.2,2.2L-1.4,3L1.6,0L-1.4,-3Z',
  backoff: 1.6
},
// narrower line-drawn
{
  path: 'M-4.4,-2.1L-0.6,-0.2V0.2L-4.4,2.1L-4,3L2,0L-4,-3Z',
  backoff: 2
},
// circle
{
  path: 'M2,0A2,2 0 1,1 0,-2A2,2 0 0,1 2,0Z',
  backoff: 0,
  noRotate: true
},
// square
{
  path: 'M2,2V-2H-2V2Z',
  backoff: 0,
  noRotate: true
}];

/***/ }),

/***/ 50222:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var ARROWPATHS = __webpack_require__(11645);
var fontAttrs = __webpack_require__(80337);
var cartesianConstants = __webpack_require__(54826);
var templatedArray = (__webpack_require__(78032).templatedArray);
var axisPlaceableObjs = __webpack_require__(35081);
function arrowAxisRefDescription(axis) {
  return ['In order for absolute positioning of the arrow to work, *a' + axis + 'ref* must be exactly the same as *' + axis + 'ref*, otherwise *a' + axis + 'ref* will revert to *pixel* (explained next).', 'For relative positioning, *a' + axis + 'ref* can be set to *pixel*,', 'in which case the *a' + axis + '* value is specified in pixels', 'relative to *' + axis + '*.', 'Absolute positioning is useful', 'for trendline annotations which should continue to indicate', 'the correct trend when zoomed. Relative positioning is useful', 'for specifying the text offset for an annotated point.'].join(' ');
}
function arrowCoordinateDescription(axis, lower, upper) {
  return ['Sets the', axis, 'component of the arrow tail about the arrow head.', 'If `a' + axis + 'ref` is `pixel`, a positive (negative)', 'component corresponds to an arrow pointing', 'from', upper, 'to', lower, '(' + lower, 'to', upper + ').', 'If `a' + axis + 'ref` is not `pixel` and is exactly the same as `' + axis + 'ref`,', 'this is an absolute value on that axis,', 'like `' + axis + '`, specified in the same coordinates as `' + axis + 'ref`.'].join(' ');
}
module.exports = templatedArray('annotation', {
  visible: {
    valType: 'boolean',
    dflt: true,
    editType: 'calc+arraydraw'
  },
  text: {
    valType: 'string',
    editType: 'calc+arraydraw'
  },
  textangle: {
    valType: 'angle',
    dflt: 0,
    editType: 'calc+arraydraw'
  },
  font: fontAttrs({
    editType: 'calc+arraydraw',
    colorEditType: 'arraydraw'
  }),
  width: {
    valType: 'number',
    min: 1,
    dflt: null,
    editType: 'calc+arraydraw'
  },
  height: {
    valType: 'number',
    min: 1,
    dflt: null,
    editType: 'calc+arraydraw'
  },
  opacity: {
    valType: 'number',
    min: 0,
    max: 1,
    dflt: 1,
    editType: 'arraydraw'
  },
  align: {
    valType: 'enumerated',
    values: ['left', 'center', 'right'],
    dflt: 'center',
    editType: 'arraydraw'
  },
  valign: {
    valType: 'enumerated',
    values: ['top', 'middle', 'bottom'],
    dflt: 'middle',
    editType: 'arraydraw'
  },
  bgcolor: {
    valType: 'color',
    dflt: 'rgba(0,0,0,0)',
    editType: 'arraydraw'
  },
  bordercolor: {
    valType: 'color',
    dflt: 'rgba(0,0,0,0)',
    editType: 'arraydraw'
  },
  borderpad: {
    valType: 'number',
    min: 0,
    dflt: 1,
    editType: 'calc+arraydraw'
  },
  borderwidth: {
    valType: 'number',
    min: 0,
    dflt: 1,
    editType: 'calc+arraydraw'
  },
  // arrow
  showarrow: {
    valType: 'boolean',
    dflt: true,
    editType: 'calc+arraydraw'
  },
  arrowcolor: {
    valType: 'color',
    editType: 'arraydraw'
  },
  arrowhead: {
    valType: 'integer',
    min: 0,
    max: ARROWPATHS.length,
    dflt: 1,
    editType: 'arraydraw'
  },
  startarrowhead: {
    valType: 'integer',
    min: 0,
    max: ARROWPATHS.length,
    dflt: 1,
    editType: 'arraydraw'
  },
  arrowside: {
    valType: 'flaglist',
    flags: ['end', 'start'],
    extras: ['none'],
    dflt: 'end',
    editType: 'arraydraw'
  },
  arrowsize: {
    valType: 'number',
    min: 0.3,
    dflt: 1,
    editType: 'calc+arraydraw'
  },
  startarrowsize: {
    valType: 'number',
    min: 0.3,
    dflt: 1,
    editType: 'calc+arraydraw'
  },
  arrowwidth: {
    valType: 'number',
    min: 0.1,
    editType: 'calc+arraydraw'
  },
  standoff: {
    valType: 'number',
    min: 0,
    dflt: 0,
    editType: 'calc+arraydraw'
  },
  startstandoff: {
    valType: 'number',
    min: 0,
    dflt: 0,
    editType: 'calc+arraydraw'
  },
  ax: {
    valType: 'any',
    editType: 'calc+arraydraw'
  },
  ay: {
    valType: 'any',
    editType: 'calc+arraydraw'
  },
  axref: {
    valType: 'enumerated',
    dflt: 'pixel',
    values: ['pixel', cartesianConstants.idRegex.x.toString()],
    editType: 'calc'
  },
  ayref: {
    valType: 'enumerated',
    dflt: 'pixel',
    values: ['pixel', cartesianConstants.idRegex.y.toString()],
    editType: 'calc'
  },
  // positioning
  xref: {
    valType: 'enumerated',
    values: ['paper', cartesianConstants.idRegex.x.toString()],
    editType: 'calc'
  },
  x: {
    valType: 'any',
    editType: 'calc+arraydraw'
  },
  xanchor: {
    valType: 'enumerated',
    values: ['auto', 'left', 'center', 'right'],
    dflt: 'auto',
    editType: 'calc+arraydraw'
  },
  xshift: {
    valType: 'number',
    dflt: 0,
    editType: 'calc+arraydraw'
  },
  yref: {
    valType: 'enumerated',
    values: ['paper', cartesianConstants.idRegex.y.toString()],
    editType: 'calc'
  },
  y: {
    valType: 'any',
    editType: 'calc+arraydraw'
  },
  yanchor: {
    valType: 'enumerated',
    values: ['auto', 'top', 'middle', 'bottom'],
    dflt: 'auto',
    editType: 'calc+arraydraw'
  },
  yshift: {
    valType: 'number',
    dflt: 0,
    editType: 'calc+arraydraw'
  },
  clicktoshow: {
    valType: 'enumerated',
    values: [false, 'onoff', 'onout'],
    dflt: false,
    editType: 'arraydraw'
  },
  xclick: {
    valType: 'any',
    editType: 'arraydraw'
  },
  yclick: {
    valType: 'any',
    editType: 'arraydraw'
  },
  hovertext: {
    valType: 'string',
    editType: 'arraydraw'
  },
  hoverlabel: {
    bgcolor: {
      valType: 'color',
      editType: 'arraydraw'
    },
    bordercolor: {
      valType: 'color',
      editType: 'arraydraw'
    },
    font: fontAttrs({
      editType: 'arraydraw'
    }),
    editType: 'arraydraw'
  },
  captureevents: {
    valType: 'boolean',
    editType: 'arraydraw'
  },
  editType: 'calc',
  _deprecated: {
    ref: {
      valType: 'string',
      editType: 'calc'
    }
  }
});

/***/ }),

/***/ 60317:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var Axes = __webpack_require__(29714);
var draw = (__webpack_require__(3377).draw);
module.exports = function calcAutorange(gd) {
  var fullLayout = gd._fullLayout;
  var annotationList = Lib.filterVisible(fullLayout.annotations);
  if (annotationList.length && gd._fullData.length) {
    return Lib.syncOrAsync([draw, annAutorange], gd);
  }
};
function annAutorange(gd) {
  var fullLayout = gd._fullLayout;

  // find the bounding boxes for each of these annotations'
  // relative to their anchor points
  // use the arrow and the text bg rectangle,
  // as the whole anno may include hidden text in its bbox
  Lib.filterVisible(fullLayout.annotations).forEach(function (ann) {
    var xa = Axes.getFromId(gd, ann.xref);
    var ya = Axes.getFromId(gd, ann.yref);
    var xRefType = Axes.getRefType(ann.xref);
    var yRefType = Axes.getRefType(ann.yref);
    ann._extremes = {};
    if (xRefType === 'range') calcAxisExpansion(ann, xa);
    if (yRefType === 'range') calcAxisExpansion(ann, ya);
  });
}
function calcAxisExpansion(ann, ax) {
  var axId = ax._id;
  var letter = axId.charAt(0);
  var pos = ann[letter];
  var apos = ann['a' + letter];
  var ref = ann[letter + 'ref'];
  var aref = ann['a' + letter + 'ref'];
  var padplus = ann['_' + letter + 'padplus'];
  var padminus = ann['_' + letter + 'padminus'];
  var shift = {
    x: 1,
    y: -1
  }[letter] * ann[letter + 'shift'];
  var headSize = 3 * ann.arrowsize * ann.arrowwidth || 0;
  var headPlus = headSize + shift;
  var headMinus = headSize - shift;
  var startHeadSize = 3 * ann.startarrowsize * ann.arrowwidth || 0;
  var startHeadPlus = startHeadSize + shift;
  var startHeadMinus = startHeadSize - shift;
  var extremes;
  if (aref === ref) {
    // expand for the arrowhead (padded by arrowhead)
    var extremeArrowHead = Axes.findExtremes(ax, [ax.r2c(pos)], {
      ppadplus: headPlus,
      ppadminus: headMinus
    });
    // again for the textbox (padded by textbox)
    var extremeText = Axes.findExtremes(ax, [ax.r2c(apos)], {
      ppadplus: Math.max(padplus, startHeadPlus),
      ppadminus: Math.max(padminus, startHeadMinus)
    });
    extremes = {
      min: [extremeArrowHead.min[0], extremeText.min[0]],
      max: [extremeArrowHead.max[0], extremeText.max[0]]
    };
  } else {
    startHeadPlus = apos ? startHeadPlus + apos : startHeadPlus;
    startHeadMinus = apos ? startHeadMinus - apos : startHeadMinus;
    extremes = Axes.findExtremes(ax, [ax.r2c(pos)], {
      ppadplus: Math.max(padplus, headPlus, startHeadPlus),
      ppadminus: Math.max(padminus, headMinus, startHeadMinus)
    });
  }
  ann._extremes[axId] = extremes;
}

/***/ }),

/***/ 6035:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var Registry = __webpack_require__(33626);
var arrayEditor = (__webpack_require__(78032).arrayEditor);
module.exports = {
  hasClickToShow: hasClickToShow,
  onClick: onClick
};

/*
 * hasClickToShow: does the given hoverData have ANY annotations which will
 * turn ON if we click here? (used by hover events to set cursor)
 *
 * gd: graphDiv
 * hoverData: a hoverData array, as included with the *plotly_hover* or
 *     *plotly_click* events in the `points` attribute
 *
 * returns: boolean
 */
function hasClickToShow(gd, hoverData) {
  var sets = getToggleSets(gd, hoverData);
  return sets.on.length > 0 || sets.explicitOff.length > 0;
}

/*
 * onClick: perform the toggling (via Plotly.update) implied by clicking
 * at this hoverData
 *
 * gd: graphDiv
 * hoverData: a hoverData array, as included with the *plotly_hover* or
 *     *plotly_click* events in the `points` attribute
 *
 * returns: Promise that the update is complete
 */
function onClick(gd, hoverData) {
  var toggleSets = getToggleSets(gd, hoverData);
  var onSet = toggleSets.on;
  var offSet = toggleSets.off.concat(toggleSets.explicitOff);
  var update = {};
  var annotationsOut = gd._fullLayout.annotations;
  var i, editHelpers;
  if (!(onSet.length || offSet.length)) return;
  for (i = 0; i < onSet.length; i++) {
    editHelpers = arrayEditor(gd.layout, 'annotations', annotationsOut[onSet[i]]);
    editHelpers.modifyItem('visible', true);
    Lib.extendFlat(update, editHelpers.getUpdateObj());
  }
  for (i = 0; i < offSet.length; i++) {
    editHelpers = arrayEditor(gd.layout, 'annotations', annotationsOut[offSet[i]]);
    editHelpers.modifyItem('visible', false);
    Lib.extendFlat(update, editHelpers.getUpdateObj());
  }
  return Registry.call('update', gd, {}, update);
}

/*
 * getToggleSets: find the annotations which will turn on or off at this
 * hoverData
 *
 * gd: graphDiv
 * hoverData: a hoverData array, as included with the *plotly_hover* or
 *     *plotly_click* events in the `points` attribute
 *
 * returns: {
 *   on: Array (indices of annotations to turn on),
 *   off: Array (indices to turn off because you're not hovering on them),
 *   explicitOff: Array (indices to turn off because you *are* hovering on them)
 * }
 */
function getToggleSets(gd, hoverData) {
  var annotations = gd._fullLayout.annotations;
  var onSet = [];
  var offSet = [];
  var explicitOffSet = [];
  var hoverLen = (hoverData || []).length;
  var i, j, anni, showMode, pointj, xa, ya, toggleType;
  for (i = 0; i < annotations.length; i++) {
    anni = annotations[i];
    showMode = anni.clicktoshow;
    if (showMode) {
      for (j = 0; j < hoverLen; j++) {
        pointj = hoverData[j];
        xa = pointj.xaxis;
        ya = pointj.yaxis;
        if (xa._id === anni.xref && ya._id === anni.yref && xa.d2r(pointj.x) === clickData2r(anni._xclick, xa) && ya.d2r(pointj.y) === clickData2r(anni._yclick, ya)) {
          // match! toggle this annotation
          // regardless of its clicktoshow mode
          // but if it's onout mode, off is implicit
          if (anni.visible) {
            if (showMode === 'onout') toggleType = offSet;else toggleType = explicitOffSet;
          } else {
            toggleType = onSet;
          }
          toggleType.push(i);
          break;
        }
      }
      if (j === hoverLen) {
        // no match - only turn this annotation OFF, and only if
        // showmode is 'onout'
        if (anni.visible && showMode === 'onout') offSet.push(i);
      }
    }
  }
  return {
    on: onSet,
    off: offSet,
    explicitOff: explicitOffSet
  };
}

// to handle log axes until v3
function clickData2r(d, ax) {
  return ax.type === 'log' ? ax.l2r(d) : ax.d2r(d);
}

/***/ }),

/***/ 53271:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var Color = __webpack_require__(78766);

// defaults common to 'annotations' and 'annotations3d'
module.exports = function handleAnnotationCommonDefaults(annIn, annOut, fullLayout, coerce) {
  coerce('opacity');
  var bgColor = coerce('bgcolor');
  var borderColor = coerce('bordercolor');
  var borderOpacity = Color.opacity(borderColor);
  coerce('borderpad');
  var borderWidth = coerce('borderwidth');
  var showArrow = coerce('showarrow');
  coerce('text', showArrow ? ' ' : fullLayout._dfltTitle.annotation);
  coerce('textangle');
  Lib.coerceFont(coerce, 'font', fullLayout.font);
  coerce('width');
  coerce('align');
  var h = coerce('height');
  if (h) coerce('valign');
  if (showArrow) {
    var arrowside = coerce('arrowside');
    var arrowhead;
    var arrowsize;
    if (arrowside.indexOf('end') !== -1) {
      arrowhead = coerce('arrowhead');
      arrowsize = coerce('arrowsize');
    }
    if (arrowside.indexOf('start') !== -1) {
      coerce('startarrowhead', arrowhead);
      coerce('startarrowsize', arrowsize);
    }
    coerce('arrowcolor', borderOpacity ? annOut.bordercolor : Color.defaultLine);
    coerce('arrowwidth', (borderOpacity && borderWidth || 1) * 2);
    coerce('standoff');
    coerce('startstandoff');
  }
  var hoverText = coerce('hovertext');
  var globalHoverLabel = fullLayout.hoverlabel || {};
  if (hoverText) {
    var hoverBG = coerce('hoverlabel.bgcolor', globalHoverLabel.bgcolor || (Color.opacity(bgColor) ? Color.rgb(bgColor) : Color.defaultLine));
    var hoverBorder = coerce('hoverlabel.bordercolor', globalHoverLabel.bordercolor || Color.contrast(hoverBG));
    var fontDflt = Lib.extendFlat({}, globalHoverLabel.font);
    if (!fontDflt.color) {
      fontDflt.color = hoverBorder;
    }
    Lib.coerceFont(coerce, 'hoverlabel.font', fontDflt);
  }
  coerce('captureevents', !!hoverText);
};

/***/ }),

/***/ 59741:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isNumeric = __webpack_require__(10721);
var toLogRange = __webpack_require__(8083);

/*
 * convertCoords: when converting an axis between log and linear
 * you need to alter any annotations on that axis to keep them
 * pointing at the same data point.
 * In v3.0 this will become obsolete
 *
 * gd: the plot div
 * ax: the axis being changed
 * newType: the type it's getting
 * doExtra: function(attr, val) from inside relayout that sets the attribute.
 *     Use this to make the changes as it's aware if any other changes in the
 *     same relayout call should override this conversion.
 */
module.exports = function convertCoords(gd, ax, newType, doExtra) {
  ax = ax || {};
  var toLog = newType === 'log' && ax.type === 'linear';
  var fromLog = newType === 'linear' && ax.type === 'log';
  if (!(toLog || fromLog)) return;
  var annotations = gd._fullLayout.annotations;
  var axLetter = ax._id.charAt(0);
  var ann;
  var attrPrefix;
  function convert(attr) {
    var currentVal = ann[attr];
    var newVal = null;
    if (toLog) newVal = toLogRange(currentVal, ax.range);else newVal = Math.pow(10, currentVal);

    // if conversion failed, delete the value so it gets a default value
    if (!isNumeric(newVal)) newVal = null;
    doExtra(attrPrefix + attr, newVal);
  }
  for (var i = 0; i < annotations.length; i++) {
    ann = annotations[i];
    attrPrefix = 'annotations[' + i + '].';
    if (ann[axLetter + 'ref'] === ax._id) convert(axLetter);
    if (ann['a' + axLetter + 'ref'] === ax._id) convert('a' + axLetter);
  }
};

/***/ }),

/***/ 63737:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var Axes = __webpack_require__(29714);
var handleArrayContainerDefaults = __webpack_require__(59008);
var handleAnnotationCommonDefaults = __webpack_require__(53271);
var attributes = __webpack_require__(50222);
module.exports = function supplyLayoutDefaults(layoutIn, layoutOut) {
  handleArrayContainerDefaults(layoutIn, layoutOut, {
    name: 'annotations',
    handleItemDefaults: handleAnnotationDefaults
  });
};
function handleAnnotationDefaults(annIn, annOut, fullLayout) {
  function coerce(attr, dflt) {
    return Lib.coerce(annIn, annOut, attributes, attr, dflt);
  }
  var visible = coerce('visible');
  var clickToShow = coerce('clicktoshow');
  if (!(visible || clickToShow)) return;
  handleAnnotationCommonDefaults(annIn, annOut, fullLayout, coerce);
  var showArrow = annOut.showarrow;

  // positioning
  var axLetters = ['x', 'y'];
  var arrowPosDflt = [-10, -30];
  var gdMock = {
    _fullLayout: fullLayout
  };
  for (var i = 0; i < 2; i++) {
    var axLetter = axLetters[i];

    // xref, yref
    var axRef = Axes.coerceRef(annIn, annOut, gdMock, axLetter, '', 'paper');
    if (axRef !== 'paper') {
      var ax = Axes.getFromId(gdMock, axRef);
      ax._annIndices.push(annOut._index);
    }

    // x, y
    Axes.coercePosition(annOut, gdMock, coerce, axRef, axLetter, 0.5);
    if (showArrow) {
      var arrowPosAttr = 'a' + axLetter;
      // axref, ayref
      var aaxRef = Axes.coerceRef(annIn, annOut, gdMock, arrowPosAttr, 'pixel', ['pixel', 'paper']);

      // for now the arrow can only be on the same axis or specified as pixels
      // TODO: sometime it might be interesting to allow it to be on *any* axis
      // but that would require updates to drawing & autorange code and maybe more
      if (aaxRef !== 'pixel' && aaxRef !== axRef) {
        aaxRef = annOut[arrowPosAttr] = 'pixel';
      }

      // ax, ay
      var aDflt = aaxRef === 'pixel' ? arrowPosDflt[i] : 0.4;
      Axes.coercePosition(annOut, gdMock, coerce, aaxRef, arrowPosAttr, aDflt);
    }

    // xanchor, yanchor
    coerce(axLetter + 'anchor');

    // xshift, yshift
    coerce(axLetter + 'shift');
  }

  // if you have one coordinate you should have both
  Lib.noneOrAll(annIn, annOut, ['x', 'y']);

  // if you have one part of arrow length you should have both
  if (showArrow) {
    Lib.noneOrAll(annIn, annOut, ['ax', 'ay']);
  }
  if (clickToShow) {
    var xClick = coerce('xclick');
    var yClick = coerce('yclick');

    // put the actual click data to bind to into private attributes
    // so we don't have to do this little bit of logic on every hover event
    annOut._xclick = xClick === undefined ? annOut.x : Axes.cleanPosition(xClick, gdMock, annOut.xref);
    annOut._yclick = yClick === undefined ? annOut.y : Axes.cleanPosition(yClick, gdMock, annOut.yref);
  }
}

/***/ }),

/***/ 3377:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var Registry = __webpack_require__(33626);
var Plots = __webpack_require__(44122);
var Lib = __webpack_require__(34809);
var strTranslate = Lib.strTranslate;
var Axes = __webpack_require__(29714);
var Color = __webpack_require__(78766);
var Drawing = __webpack_require__(62203);
var Fx = __webpack_require__(32141);
var svgTextUtils = __webpack_require__(30635);
var setCursor = __webpack_require__(27983);
var dragElement = __webpack_require__(14751);
var arrayEditor = (__webpack_require__(78032).arrayEditor);
var drawArrowHead = __webpack_require__(23768);

// Annotations are stored in gd.layout.annotations, an array of objects
// index can point to one item in this array,
//  or non-numeric to simply add a new one
//  or -1 to modify all existing
// opt can be the full options object, or one key (to be set to value)
//  or undefined to simply redraw
// if opt is blank, val can be 'add' or a full options object to add a new
//  annotation at that point in the array, or 'remove' to delete this one

module.exports = {
  draw: draw,
  drawOne: drawOne,
  drawRaw: drawRaw
};

/*
 * draw: draw all annotations without any new modifications
 */
function draw(gd) {
  var fullLayout = gd._fullLayout;
  fullLayout._infolayer.selectAll('.annotation').remove();
  for (var i = 0; i < fullLayout.annotations.length; i++) {
    if (fullLayout.annotations[i].visible) {
      drawOne(gd, i);
    }
  }
  return Plots.previousPromises(gd);
}

/*
 * drawOne: draw a single cartesian or paper-ref annotation, potentially with modifications
 *
 * index (int): the annotation to draw
 */
function drawOne(gd, index) {
  var fullLayout = gd._fullLayout;
  var options = fullLayout.annotations[index] || {};
  var xa = Axes.getFromId(gd, options.xref);
  var ya = Axes.getFromId(gd, options.yref);
  if (xa) xa.setScale();
  if (ya) ya.setScale();
  drawRaw(gd, options, index, false, xa, ya);
}

// Convert pixels to the coordinates relevant for the axis referred to. For
// example, for paper it would convert to a value normalized by the dimension of
// the plot.
// axDomainRef: if true and axa defined, draws relative to axis domain,
// otherwise draws relative to data (if axa defined) or paper (if not).
function shiftPosition(axa, dAx, axLetter, gs, options) {
  var optAx = options[axLetter];
  var axRef = options[axLetter + 'ref'];
  var vertical = axLetter.indexOf('y') !== -1;
  var axDomainRef = Axes.getRefType(axRef) === 'domain';
  var gsDim = vertical ? gs.h : gs.w;
  if (axa) {
    if (axDomainRef) {
      // here optAx normalized to length of axis (e.g., normally in range
      // 0 to 1). But dAx is in pixels. So we normalize dAx to length of
      // axis before doing the math.
      return optAx + (vertical ? -dAx : dAx) / axa._length;
    } else {
      return axa.p2r(axa.r2p(optAx) + dAx);
    }
  } else {
    return optAx + (vertical ? -dAx : dAx) / gsDim;
  }
}

/**
 * drawRaw: draw a single annotation, potentially with modifications
 *
 * @param {DOM element} gd
 * @param {object} options : this annotation's fullLayout options
 * @param {integer} index : index in 'annotations' container of the annotation to draw
 * @param {string} subplotId : id of the annotation's subplot
 *  - use false for 2d (i.e. cartesian or paper-ref) annotations
 * @param {object | undefined} xa : full x-axis object to compute subplot pos-to-px
 * @param {object | undefined} ya : ... y-axis
 */
function drawRaw(gd, options, index, subplotId, xa, ya) {
  var fullLayout = gd._fullLayout;
  var gs = gd._fullLayout._size;
  var edits = gd._context.edits;
  var className, containerStr;
  if (subplotId) {
    className = 'annotation-' + subplotId;
    containerStr = subplotId + '.annotations';
  } else {
    className = 'annotation';
    containerStr = 'annotations';
  }
  var editHelpers = arrayEditor(gd.layout, containerStr, options);
  var modifyBase = editHelpers.modifyBase;
  var modifyItem = editHelpers.modifyItem;
  var getUpdateObj = editHelpers.getUpdateObj;

  // remove the existing annotation if there is one
  fullLayout._infolayer.selectAll('.' + className + '[data-index="' + index + '"]').remove();
  var annClipID = 'clip' + fullLayout._uid + '_ann' + index;

  // this annotation is gone - quit now after deleting it
  // TODO: use d3 idioms instead of deleting and redrawing every time
  if (!options._input || options.visible === false) {
    d3.selectAll('#' + annClipID).remove();
    return;
  }

  // calculated pixel positions
  // x & y each will get text, head, and tail as appropriate
  var annPosPx = {
    x: {},
    y: {}
  };
  var textangle = +options.textangle || 0;

  // create the components
  // made a single group to contain all, so opacity can work right
  // with border/arrow together this could handle a whole bunch of
  // cleanup at this point, but works for now
  var annGroup = fullLayout._infolayer.append('g').classed(className, true).attr('data-index', String(index)).style('opacity', options.opacity);

  // another group for text+background so that they can rotate together
  var annTextGroup = annGroup.append('g').classed('annotation-text-g', true);
  var editTextPosition = edits[options.showarrow ? 'annotationTail' : 'annotationPosition'];
  var textEvents = options.captureevents || edits.annotationText || editTextPosition;
  function makeEventData(initialEvent) {
    var eventData = {
      index: index,
      annotation: options._input,
      fullAnnotation: options,
      event: initialEvent
    };
    if (subplotId) {
      eventData.subplotId = subplotId;
    }
    return eventData;
  }
  var annTextGroupInner = annTextGroup.append('g').style('pointer-events', textEvents ? 'all' : null).call(setCursor, 'pointer').on('click', function () {
    gd._dragging = false;
    gd.emit('plotly_clickannotation', makeEventData(d3.event));
  });
  if (options.hovertext) {
    annTextGroupInner.on('mouseover', function () {
      var hoverOptions = options.hoverlabel;
      var hoverFont = hoverOptions.font;
      var bBox = this.getBoundingClientRect();
      var bBoxRef = gd.getBoundingClientRect();
      Fx.loneHover({
        x0: bBox.left - bBoxRef.left,
        x1: bBox.right - bBoxRef.left,
        y: (bBox.top + bBox.bottom) / 2 - bBoxRef.top,
        text: options.hovertext,
        color: hoverOptions.bgcolor,
        borderColor: hoverOptions.bordercolor,
        fontFamily: hoverFont.family,
        fontSize: hoverFont.size,
        fontColor: hoverFont.color,
        fontWeight: hoverFont.weight,
        fontStyle: hoverFont.style,
        fontVariant: hoverFont.variant,
        fontShadow: hoverFont.fontShadow,
        fontLineposition: hoverFont.fontLineposition,
        fontTextcase: hoverFont.fontTextcase
      }, {
        container: fullLayout._hoverlayer.node(),
        outerContainer: fullLayout._paper.node(),
        gd: gd
      });
    }).on('mouseout', function () {
      Fx.loneUnhover(fullLayout._hoverlayer.node());
    });
  }
  var borderwidth = options.borderwidth;
  var borderpad = options.borderpad;
  var borderfull = borderwidth + borderpad;
  var annTextBG = annTextGroupInner.append('rect').attr('class', 'bg').style('stroke-width', borderwidth + 'px').call(Color.stroke, options.bordercolor).call(Color.fill, options.bgcolor);
  var isSizeConstrained = options.width || options.height;
  var annTextClip = fullLayout._topclips.selectAll('#' + annClipID).data(isSizeConstrained ? [0] : []);
  annTextClip.enter().append('clipPath').classed('annclip', true).attr('id', annClipID).append('rect');
  annTextClip.exit().remove();
  var font = options.font;
  var text = fullLayout._meta ? Lib.templateString(options.text, fullLayout._meta) : options.text;
  var annText = annTextGroupInner.append('text').classed('annotation-text', true).text(text);
  function textLayout(s) {
    s.call(Drawing.font, font).attr({
      'text-anchor': {
        left: 'start',
        right: 'end'
      }[options.align] || 'middle'
    });
    svgTextUtils.convertToTspans(s, gd, drawGraphicalElements);
    return s;
  }
  function drawGraphicalElements() {
    // if the text has *only* a link, make the whole box into a link
    var anchor3 = annText.selectAll('a');
    if (anchor3.size() === 1 && anchor3.text() === annText.text()) {
      var wholeLink = annTextGroupInner.insert('a', ':first-child').attr({
        'xlink:xlink:href': anchor3.attr('xlink:href'),
        'xlink:xlink:show': anchor3.attr('xlink:show')
      }).style({
        cursor: 'pointer'
      });
      wholeLink.node().appendChild(annTextBG.node());
    }
    var mathjaxGroup = annTextGroupInner.select('.annotation-text-math-group');
    var hasMathjax = !mathjaxGroup.empty();
    var anntextBB = Drawing.bBox((hasMathjax ? mathjaxGroup : annText).node());
    var textWidth = anntextBB.width;
    var textHeight = anntextBB.height;
    var annWidth = options.width || textWidth;
    var annHeight = options.height || textHeight;
    var outerWidth = Math.round(annWidth + 2 * borderfull);
    var outerHeight = Math.round(annHeight + 2 * borderfull);
    function shiftFraction(v, anchor) {
      if (anchor === 'auto') {
        if (v < 1 / 3) anchor = 'left';else if (v > 2 / 3) anchor = 'right';else anchor = 'center';
      }
      return {
        center: 0,
        middle: 0,
        left: 0.5,
        bottom: -0.5,
        right: -0.5,
        top: 0.5
      }[anchor];
    }
    var annotationIsOffscreen = false;
    var letters = ['x', 'y'];
    for (var i = 0; i < letters.length; i++) {
      var axLetter = letters[i];
      var axRef = options[axLetter + 'ref'] || axLetter;
      var tailRef = options['a' + axLetter + 'ref'];
      var ax = {
        x: xa,
        y: ya
      }[axLetter];
      var dimAngle = (textangle + (axLetter === 'x' ? 0 : -90)) * Math.PI / 180;
      // note that these two can be either positive or negative
      var annSizeFromWidth = outerWidth * Math.cos(dimAngle);
      var annSizeFromHeight = outerHeight * Math.sin(dimAngle);
      // but this one is the positive total size
      var annSize = Math.abs(annSizeFromWidth) + Math.abs(annSizeFromHeight);
      var anchor = options[axLetter + 'anchor'];
      var overallShift = options[axLetter + 'shift'] * (axLetter === 'x' ? 1 : -1);
      var posPx = annPosPx[axLetter];
      var basePx;
      var textPadShift;
      var alignPosition;
      var autoAlignFraction;
      var textShift;
      var axRefType = Axes.getRefType(axRef);

      /*
       * calculate the *primary* pixel position
       * which is the arrowhead if there is one,
       * otherwise the text anchor point
       */
      if (ax && axRefType !== 'domain') {
        // check if annotation is off screen, to bypass DOM manipulations
        var posFraction = ax.r2fraction(options[axLetter]);
        if (posFraction < 0 || posFraction > 1) {
          if (tailRef === axRef) {
            posFraction = ax.r2fraction(options['a' + axLetter]);
            if (posFraction < 0 || posFraction > 1) {
              annotationIsOffscreen = true;
            }
          } else {
            annotationIsOffscreen = true;
          }
        }
        basePx = ax._offset + ax.r2p(options[axLetter]);
        autoAlignFraction = 0.5;
      } else {
        var axRefTypeEqDomain = axRefType === 'domain';
        if (axLetter === 'x') {
          alignPosition = options[axLetter];
          basePx = axRefTypeEqDomain ? ax._offset + ax._length * alignPosition : basePx = gs.l + gs.w * alignPosition;
        } else {
          alignPosition = 1 - options[axLetter];
          basePx = axRefTypeEqDomain ? ax._offset + ax._length * alignPosition : basePx = gs.t + gs.h * alignPosition;
        }
        autoAlignFraction = options.showarrow ? 0.5 : alignPosition;
      }

      // now translate this into pixel positions of head, tail, and text
      // as well as paddings for autorange
      if (options.showarrow) {
        posPx.head = basePx;
        var arrowLength = options['a' + axLetter];

        // with an arrow, the text rotates around the anchor point
        textShift = annSizeFromWidth * shiftFraction(0.5, options.xanchor) - annSizeFromHeight * shiftFraction(0.5, options.yanchor);
        if (tailRef === axRef) {
          // In the case tailRefType is 'domain' or 'paper', the arrow's
          // position is set absolutely, which is consistent with how
          // it behaves when its position is set in data ('range')
          // coordinates.
          var tailRefType = Axes.getRefType(tailRef);
          if (tailRefType === 'domain') {
            if (axLetter === 'y') {
              arrowLength = 1 - arrowLength;
            }
            posPx.tail = ax._offset + ax._length * arrowLength;
          } else if (tailRefType === 'paper') {
            if (axLetter === 'y') {
              arrowLength = 1 - arrowLength;
              posPx.tail = gs.t + gs.h * arrowLength;
            } else {
              posPx.tail = gs.l + gs.w * arrowLength;
            }
          } else {
            // assumed tailRef is range or paper referenced
            posPx.tail = ax._offset + ax.r2p(arrowLength);
          }
          // tail is range- or domain-referenced: autorange pads the
          // text in px from the tail
          textPadShift = textShift;
        } else {
          posPx.tail = basePx + arrowLength;
          // tail is specified in px from head, so autorange also pads vs head
          textPadShift = textShift + arrowLength;
        }
        posPx.text = posPx.tail + textShift;

        // constrain pixel/paper referenced so the draggers are at least
        // partially visible
        var maxPx = fullLayout[axLetter === 'x' ? 'width' : 'height'];
        if (axRef === 'paper') {
          posPx.head = Lib.constrain(posPx.head, 1, maxPx - 1);
        }
        if (tailRef === 'pixel') {
          var shiftPlus = -Math.max(posPx.tail - 3, posPx.text);
          var shiftMinus = Math.min(posPx.tail + 3, posPx.text) - maxPx;
          if (shiftPlus > 0) {
            posPx.tail += shiftPlus;
            posPx.text += shiftPlus;
          } else if (shiftMinus > 0) {
            posPx.tail -= shiftMinus;
            posPx.text -= shiftMinus;
          }
        }
        posPx.tail += overallShift;
        posPx.head += overallShift;
      } else {
        // with no arrow, the text rotates and *then* we put the anchor
        // relative to the new bounding box
        textShift = annSize * shiftFraction(autoAlignFraction, anchor);
        textPadShift = textShift;
        posPx.text = basePx + textShift;
      }
      posPx.text += overallShift;
      textShift += overallShift;
      textPadShift += overallShift;

      // padplus/minus are used by autorange
      options['_' + axLetter + 'padplus'] = annSize / 2 + textPadShift;
      options['_' + axLetter + 'padminus'] = annSize / 2 - textPadShift;

      // size/shift are used during dragging
      options['_' + axLetter + 'size'] = annSize;
      options['_' + axLetter + 'shift'] = textShift;
    }
    if (annotationIsOffscreen) {
      annTextGroupInner.remove();
      return;
    }
    var xShift = 0;
    var yShift = 0;
    if (options.align !== 'left') {
      xShift = (annWidth - textWidth) * (options.align === 'center' ? 0.5 : 1);
    }
    if (options.valign !== 'top') {
      yShift = (annHeight - textHeight) * (options.valign === 'middle' ? 0.5 : 1);
    }
    if (hasMathjax) {
      mathjaxGroup.select('svg').attr({
        x: borderfull + xShift - 1,
        y: borderfull + yShift
      }).call(Drawing.setClipUrl, isSizeConstrained ? annClipID : null, gd);
    } else {
      var texty = borderfull + yShift - anntextBB.top;
      var textx = borderfull + xShift - anntextBB.left;
      annText.call(svgTextUtils.positionText, textx, texty).call(Drawing.setClipUrl, isSizeConstrained ? annClipID : null, gd);
    }
    annTextClip.select('rect').call(Drawing.setRect, borderfull, borderfull, annWidth, annHeight);
    annTextBG.call(Drawing.setRect, borderwidth / 2, borderwidth / 2, outerWidth - borderwidth, outerHeight - borderwidth);
    annTextGroupInner.call(Drawing.setTranslate, Math.round(annPosPx.x.text - outerWidth / 2), Math.round(annPosPx.y.text - outerHeight / 2));

    /*
     * rotate text and background
     * we already calculated the text center position *as rotated*
     * because we needed that for autoranging anyway, so now whether
     * we have an arrow or not, we rotate about the text center.
     */
    annTextGroup.attr({
      transform: 'rotate(' + textangle + ',' + annPosPx.x.text + ',' + annPosPx.y.text + ')'
    });

    /*
     * add the arrow
     * uses options[arrowwidth,arrowcolor,arrowhead] for styling
     * dx and dy are normally zero, but when you are dragging the textbox
     * while the head stays put, dx and dy are the pixel offsets
     */
    var drawArrow = function (dx, dy) {
      annGroup.selectAll('.annotation-arrow-g').remove();
      var headX = annPosPx.x.head;
      var headY = annPosPx.y.head;
      var tailX = annPosPx.x.tail + dx;
      var tailY = annPosPx.y.tail + dy;
      var textX = annPosPx.x.text + dx;
      var textY = annPosPx.y.text + dy;

      // find the edge of the text box, where we'll start the arrow:
      // create transform matrix to rotate the text box corners
      var transform = Lib.rotationXYMatrix(textangle, textX, textY);
      var applyTransform = Lib.apply2DTransform(transform);
      var applyTransform2 = Lib.apply2DTransform2(transform);

      // calculate and transform bounding box
      var width = +annTextBG.attr('width');
      var height = +annTextBG.attr('height');
      var xLeft = textX - 0.5 * width;
      var xRight = xLeft + width;
      var yTop = textY - 0.5 * height;
      var yBottom = yTop + height;
      var edges = [[xLeft, yTop, xLeft, yBottom], [xLeft, yBottom, xRight, yBottom], [xRight, yBottom, xRight, yTop], [xRight, yTop, xLeft, yTop]].map(applyTransform2);

      // Remove the line if it ends inside the box.  Use ray
      // casting for rotated boxes: see which edges intersect a
      // line from the arrowhead to far away and reduce with xor
      // to get the parity of the number of intersections.
      if (edges.reduce(function (a, x) {
        return a ^ !!Lib.segmentsIntersect(headX, headY, headX + 1e6, headY + 1e6, x[0], x[1], x[2], x[3]);
      }, false)) {
        // no line or arrow - so quit drawArrow now
        return;
      }
      edges.forEach(function (x) {
        var p = Lib.segmentsIntersect(tailX, tailY, headX, headY, x[0], x[1], x[2], x[3]);
        if (p) {
          tailX = p.x;
          tailY = p.y;
        }
      });
      var strokewidth = options.arrowwidth;
      var arrowColor = options.arrowcolor;
      var arrowSide = options.arrowside;
      var arrowGroup = annGroup.append('g').style({
        opacity: Color.opacity(arrowColor)
      }).classed('annotation-arrow-g', true);
      var arrow = arrowGroup.append('path').attr('d', 'M' + tailX + ',' + tailY + 'L' + headX + ',' + headY).style('stroke-width', strokewidth + 'px').call(Color.stroke, Color.rgb(arrowColor));
      drawArrowHead(arrow, arrowSide, options);

      // the arrow dragger is a small square right at the head, then a line to the tail,
      // all expanded by a stroke width of 6px plus the arrow line width
      if (edits.annotationPosition && arrow.node().parentNode && !subplotId) {
        var arrowDragHeadX = headX;
        var arrowDragHeadY = headY;
        if (options.standoff) {
          var arrowLength = Math.sqrt(Math.pow(headX - tailX, 2) + Math.pow(headY - tailY, 2));
          arrowDragHeadX += options.standoff * (tailX - headX) / arrowLength;
          arrowDragHeadY += options.standoff * (tailY - headY) / arrowLength;
        }
        var arrowDrag = arrowGroup.append('path').classed('annotation-arrow', true).classed('anndrag', true).classed('cursor-move', true).attr({
          d: 'M3,3H-3V-3H3ZM0,0L' + (tailX - arrowDragHeadX) + ',' + (tailY - arrowDragHeadY),
          transform: strTranslate(arrowDragHeadX, arrowDragHeadY)
        }).style('stroke-width', strokewidth + 6 + 'px').call(Color.stroke, 'rgba(0,0,0,0)').call(Color.fill, 'rgba(0,0,0,0)');
        var annx0, anny0;

        // dragger for the arrow & head: translates the whole thing
        // (head/tail/text) all together
        dragElement.init({
          element: arrowDrag.node(),
          gd: gd,
          prepFn: function () {
            var pos = Drawing.getTranslate(annTextGroupInner);
            annx0 = pos.x;
            anny0 = pos.y;
            if (xa && xa.autorange) {
              modifyBase(xa._name + '.autorange', true);
            }
            if (ya && ya.autorange) {
              modifyBase(ya._name + '.autorange', true);
            }
          },
          moveFn: function (dx, dy) {
            var annxy0 = applyTransform(annx0, anny0);
            var xcenter = annxy0[0] + dx;
            var ycenter = annxy0[1] + dy;
            annTextGroupInner.call(Drawing.setTranslate, xcenter, ycenter);
            modifyItem('x', shiftPosition(xa, dx, 'x', gs, options));
            modifyItem('y', shiftPosition(ya, dy, 'y', gs, options));

            // for these 2 calls to shiftPosition, it is assumed xa, ya are
            // defined, so gsDim will not be used, but we put it in
            // anyways for consistency
            if (options.axref === options.xref) {
              modifyItem('ax', shiftPosition(xa, dx, 'ax', gs, options));
            }
            if (options.ayref === options.yref) {
              modifyItem('ay', shiftPosition(ya, dy, 'ay', gs, options));
            }
            arrowGroup.attr('transform', strTranslate(dx, dy));
            annTextGroup.attr({
              transform: 'rotate(' + textangle + ',' + xcenter + ',' + ycenter + ')'
            });
          },
          doneFn: function () {
            Registry.call('_guiRelayout', gd, getUpdateObj());
            var notesBox = document.querySelector('.js-notes-box-panel');
            if (notesBox) notesBox.redraw(notesBox.selectedObj);
          }
        });
      }
    };
    if (options.showarrow) drawArrow(0, 0);

    // user dragging the annotation (text, not arrow)
    if (editTextPosition) {
      var baseTextTransform;

      // dragger for the textbox: if there's an arrow, just drag the
      // textbox and tail, leave the head untouched
      dragElement.init({
        element: annTextGroupInner.node(),
        gd: gd,
        prepFn: function () {
          baseTextTransform = annTextGroup.attr('transform');
        },
        moveFn: function (dx, dy) {
          var csr = 'pointer';
          if (options.showarrow) {
            // for these 2 calls to shiftPosition, it is assumed xa, ya are
            // defined, so gsDim will not be used, but we put it in
            // anyways for consistency
            if (options.axref === options.xref) {
              modifyItem('ax', shiftPosition(xa, dx, 'ax', gs, options));
            } else {
              modifyItem('ax', options.ax + dx);
            }
            if (options.ayref === options.yref) {
              modifyItem('ay', shiftPosition(ya, dy, 'ay', gs.w, options));
            } else {
              modifyItem('ay', options.ay + dy);
            }
            drawArrow(dx, dy);
          } else if (!subplotId) {
            var xUpdate, yUpdate;
            if (xa) {
              // shiftPosition will not execute code where xa was
              // undefined, so we use to calculate xUpdate too
              xUpdate = shiftPosition(xa, dx, 'x', gs, options);
            } else {
              var widthFraction = options._xsize / gs.w;
              var xLeft = options.x + (options._xshift - options.xshift) / gs.w - widthFraction / 2;
              xUpdate = dragElement.align(xLeft + dx / gs.w, widthFraction, 0, 1, options.xanchor);
            }
            if (ya) {
              // shiftPosition will not execute code where ya was
              // undefined, so we use to calculate yUpdate too
              yUpdate = shiftPosition(ya, dy, 'y', gs, options);
            } else {
              var heightFraction = options._ysize / gs.h;
              var yBottom = options.y - (options._yshift + options.yshift) / gs.h - heightFraction / 2;
              yUpdate = dragElement.align(yBottom - dy / gs.h, heightFraction, 0, 1, options.yanchor);
            }
            modifyItem('x', xUpdate);
            modifyItem('y', yUpdate);
            if (!xa || !ya) {
              csr = dragElement.getCursor(xa ? 0.5 : xUpdate, ya ? 0.5 : yUpdate, options.xanchor, options.yanchor);
            }
          } else return;
          annTextGroup.attr({
            transform: strTranslate(dx, dy) + baseTextTransform
          });
          setCursor(annTextGroupInner, csr);
        },
        clickFn: function (_, initialEvent) {
          if (options.captureevents) {
            gd.emit('plotly_clickannotation', makeEventData(initialEvent));
          }
        },
        doneFn: function () {
          setCursor(annTextGroupInner);
          Registry.call('_guiRelayout', gd, getUpdateObj());
          var notesBox = document.querySelector('.js-notes-box-panel');
          if (notesBox) notesBox.redraw(notesBox.selectedObj);
        }
      });
    }
  }
  if (edits.annotationText) {
    annText.call(svgTextUtils.makeEditable, {
      delegate: annTextGroupInner,
      gd: gd
    }).call(textLayout).on('edit', function (_text) {
      options.text = _text;
      this.call(textLayout);
      modifyItem('text', _text);
      if (xa && xa.autorange) {
        modifyBase(xa._name + '.autorange', true);
      }
      if (ya && ya.autorange) {
        modifyBase(ya._name + '.autorange', true);
      }
      Registry.call('_guiRelayout', gd, getUpdateObj());
    });
  } else annText.call(textLayout);
}

/***/ }),

/***/ 23768:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var Color = __webpack_require__(78766);
var ARROWPATHS = __webpack_require__(11645);
var Lib = __webpack_require__(34809);
var strScale = Lib.strScale;
var strRotate = Lib.strRotate;
var strTranslate = Lib.strTranslate;

/**
 * Add arrowhead(s) to a path or line element
 *
 * @param {d3.selection} el3: a d3-selected line or path element
 *
 * @param {string} ends: 'none', 'start', 'end', or 'start+end' for which ends get arrowheads
 *
 * @param {object} options: style information. Must have all the following:
 * @param {number} options.arrowhead: end head style - see ./arrow_paths
 * @param {number} options.startarrowhead: start head style - see ./arrow_paths
 * @param {number} options.arrowsize: relative size of the end head vs line width
 * @param {number} options.startarrowsize: relative size of the start head vs line width
 * @param {number} options.standoff: distance in px to move the end arrow point from its target
 * @param {number} options.startstandoff: distance in px to move the start arrow point from its target
 * @param {number} options.arrowwidth: width of the arrow line
 * @param {string} options.arrowcolor: color of the arrow line, for the head to match
 *     Note that the opacity of this color is ignored, as it's assumed the container
 *     of both the line and head has opacity applied to it so there isn't greater opacity
 *     where they overlap.
 */
module.exports = function drawArrowHead(el3, ends, options) {
  var el = el3.node();
  var headStyle = ARROWPATHS[options.arrowhead || 0];
  var startHeadStyle = ARROWPATHS[options.startarrowhead || 0];
  var scale = (options.arrowwidth || 1) * (options.arrowsize || 1);
  var startScale = (options.arrowwidth || 1) * (options.startarrowsize || 1);
  var doStart = ends.indexOf('start') >= 0;
  var doEnd = ends.indexOf('end') >= 0;
  var backOff = headStyle.backoff * scale + options.standoff;
  var startBackOff = startHeadStyle.backoff * startScale + options.startstandoff;
  var start, end, startRot, endRot;
  if (el.nodeName === 'line') {
    start = {
      x: +el3.attr('x1'),
      y: +el3.attr('y1')
    };
    end = {
      x: +el3.attr('x2'),
      y: +el3.attr('y2')
    };
    var dx = start.x - end.x;
    var dy = start.y - end.y;
    startRot = Math.atan2(dy, dx);
    endRot = startRot + Math.PI;
    if (backOff && startBackOff) {
      if (backOff + startBackOff > Math.sqrt(dx * dx + dy * dy)) {
        hideLine();
        return;
      }
    }
    if (backOff) {
      if (backOff * backOff > dx * dx + dy * dy) {
        hideLine();
        return;
      }
      var backOffX = backOff * Math.cos(startRot);
      var backOffY = backOff * Math.sin(startRot);
      end.x += backOffX;
      end.y += backOffY;
      el3.attr({
        x2: end.x,
        y2: end.y
      });
    }
    if (startBackOff) {
      if (startBackOff * startBackOff > dx * dx + dy * dy) {
        hideLine();
        return;
      }
      var startBackOffX = startBackOff * Math.cos(startRot);
      var startbackOffY = startBackOff * Math.sin(startRot);
      start.x -= startBackOffX;
      start.y -= startbackOffY;
      el3.attr({
        x1: start.x,
        y1: start.y
      });
    }
  } else if (el.nodeName === 'path') {
    var pathlen = el.getTotalLength();
    // using dash to hide the backOff region of the path.
    // if we ever allow dash for the arrow we'll have to
    // do better than this hack... maybe just manually
    // combine the two
    var dashArray = '';
    if (pathlen < backOff + startBackOff) {
      hideLine();
      return;
    }
    var start0 = el.getPointAtLength(0);
    var dstart = el.getPointAtLength(0.1);
    startRot = Math.atan2(start0.y - dstart.y, start0.x - dstart.x);
    start = el.getPointAtLength(Math.min(startBackOff, pathlen));
    dashArray = '0px,' + startBackOff + 'px,';
    var end0 = el.getPointAtLength(pathlen);
    var dend = el.getPointAtLength(pathlen - 0.1);
    endRot = Math.atan2(end0.y - dend.y, end0.x - dend.x);
    end = el.getPointAtLength(Math.max(0, pathlen - backOff));
    var shortening = dashArray ? startBackOff + backOff : backOff;
    dashArray += pathlen - shortening + 'px,' + pathlen + 'px';
    el3.style('stroke-dasharray', dashArray);
  }
  function hideLine() {
    el3.style('stroke-dasharray', '0px,100px');
  }
  function drawhead(arrowHeadStyle, p, rot, arrowScale) {
    if (!arrowHeadStyle.path) return;
    if (arrowHeadStyle.noRotate) rot = 0;
    d3.select(el.parentNode).append('path').attr({
      class: el3.attr('class'),
      d: arrowHeadStyle.path,
      transform: strTranslate(p.x, p.y) + strRotate(rot * 180 / Math.PI) + strScale(arrowScale)
    }).style({
      fill: Color.rgb(options.arrowcolor),
      'stroke-width': 0
    });
  }
  if (doStart) drawhead(startHeadStyle, start, startRot, startScale);
  if (doEnd) drawhead(headStyle, end, endRot, scale);
};

/***/ }),

/***/ 3599:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var drawModule = __webpack_require__(3377);
var clickModule = __webpack_require__(6035);
module.exports = {
  moduleType: 'component',
  name: 'annotations',
  layoutAttributes: __webpack_require__(50222),
  supplyLayoutDefaults: __webpack_require__(63737),
  includeBasePlot: __webpack_require__(20706)('annotations'),
  calcAutorange: __webpack_require__(60317),
  draw: drawModule.draw,
  drawOne: drawModule.drawOne,
  drawRaw: drawModule.drawRaw,
  hasClickToShow: clickModule.hasClickToShow,
  onClick: clickModule.onClick,
  convertCoords: __webpack_require__(59741)
};

/***/ }),

/***/ 38239:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var annAttrs = __webpack_require__(50222);
var overrideAll = (__webpack_require__(13582).overrideAll);
var templatedArray = (__webpack_require__(78032).templatedArray);
module.exports = overrideAll(templatedArray('annotation', {
  visible: annAttrs.visible,
  x: {
    valType: 'any'
  },
  y: {
    valType: 'any'
  },
  z: {
    valType: 'any'
  },
  ax: {
    valType: 'number'
  },
  ay: {
    valType: 'number'
  },
  xanchor: annAttrs.xanchor,
  xshift: annAttrs.xshift,
  yanchor: annAttrs.yanchor,
  yshift: annAttrs.yshift,
  text: annAttrs.text,
  textangle: annAttrs.textangle,
  font: annAttrs.font,
  width: annAttrs.width,
  height: annAttrs.height,
  opacity: annAttrs.opacity,
  align: annAttrs.align,
  valign: annAttrs.valign,
  bgcolor: annAttrs.bgcolor,
  bordercolor: annAttrs.bordercolor,
  borderpad: annAttrs.borderpad,
  borderwidth: annAttrs.borderwidth,
  showarrow: annAttrs.showarrow,
  arrowcolor: annAttrs.arrowcolor,
  arrowhead: annAttrs.arrowhead,
  startarrowhead: annAttrs.startarrowhead,
  arrowside: annAttrs.arrowside,
  arrowsize: annAttrs.arrowsize,
  startarrowsize: annAttrs.startarrowsize,
  arrowwidth: annAttrs.arrowwidth,
  standoff: annAttrs.standoff,
  startstandoff: annAttrs.startstandoff,
  hovertext: annAttrs.hovertext,
  hoverlabel: annAttrs.hoverlabel,
  captureevents: annAttrs.captureevents

  // maybes later?
  // clicktoshow: annAttrs.clicktoshow,
  // xclick: annAttrs.xclick,
  // yclick: annAttrs.yclick,

  // not needed!
  // axref: 'pixel'
  // ayref: 'pixel'
  // xref: 'x'
  // yref: 'y
  // zref: 'z'
}), 'calc', 'from-root');

/***/ }),

/***/ 47979:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var Axes = __webpack_require__(29714);
module.exports = function convert(scene) {
  var fullSceneLayout = scene.fullSceneLayout;
  var anns = fullSceneLayout.annotations;
  for (var i = 0; i < anns.length; i++) {
    mockAnnAxes(anns[i], scene);
  }
  scene.fullLayout._infolayer.selectAll('.annotation-' + scene.id).remove();
};
function mockAnnAxes(ann, scene) {
  var fullSceneLayout = scene.fullSceneLayout;
  var domain = fullSceneLayout.domain;
  var size = scene.fullLayout._size;
  var base = {
    // this gets fill in on render
    pdata: null,
    // to get setConvert to not execute cleanly
    type: 'linear',
    // don't try to update them on `editable: true`
    autorange: false,
    // set infinite range so that annotation draw routine
    // does not try to remove 'outside-range' annotations,
    // this case is handled in the render loop
    range: [-Infinity, Infinity]
  };
  ann._xa = {};
  Lib.extendFlat(ann._xa, base);
  Axes.setConvert(ann._xa);
  ann._xa._offset = size.l + domain.x[0] * size.w;
  ann._xa.l2p = function () {
    return 0.5 * (1 + ann._pdata[0] / ann._pdata[3]) * size.w * (domain.x[1] - domain.x[0]);
  };
  ann._ya = {};
  Lib.extendFlat(ann._ya, base);
  Axes.setConvert(ann._ya);
  ann._ya._offset = size.t + (1 - domain.y[1]) * size.h;
  ann._ya.l2p = function () {
    return 0.5 * (1 - ann._pdata[1] / ann._pdata[3]) * size.h * (domain.y[1] - domain.y[0]);
  };
}

/***/ }),

/***/ 34232:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var Axes = __webpack_require__(29714);
var handleArrayContainerDefaults = __webpack_require__(59008);
var handleAnnotationCommonDefaults = __webpack_require__(53271);
var attributes = __webpack_require__(38239);
module.exports = function handleDefaults(sceneLayoutIn, sceneLayoutOut, opts) {
  handleArrayContainerDefaults(sceneLayoutIn, sceneLayoutOut, {
    name: 'annotations',
    handleItemDefaults: handleAnnotationDefaults,
    fullLayout: opts.fullLayout
  });
};
function handleAnnotationDefaults(annIn, annOut, sceneLayout, opts) {
  function coerce(attr, dflt) {
    return Lib.coerce(annIn, annOut, attributes, attr, dflt);
  }
  function coercePosition(axLetter) {
    var axName = axLetter + 'axis';

    // mock in such way that getFromId grabs correct 3D axis
    var gdMock = {
      _fullLayout: {}
    };
    gdMock._fullLayout[axName] = sceneLayout[axName];
    return Axes.coercePosition(annOut, gdMock, coerce, axLetter, axLetter, 0.5);
  }
  var visible = coerce('visible');
  if (!visible) return;
  handleAnnotationCommonDefaults(annIn, annOut, opts.fullLayout, coerce);
  coercePosition('x');
  coercePosition('y');
  coercePosition('z');

  // if you have one coordinate you should all three
  Lib.noneOrAll(annIn, annOut, ['x', 'y', 'z']);

  // hard-set here for completeness
  annOut.xref = 'x';
  annOut.yref = 'y';
  annOut.zref = 'z';
  coerce('xanchor');
  coerce('yanchor');
  coerce('xshift');
  coerce('yshift');
  if (annOut.showarrow) {
    annOut.axref = 'pixel';
    annOut.ayref = 'pixel';

    // TODO maybe default values should be bigger than the 2D case?
    coerce('ax', -10);
    coerce('ay', -30);

    // if you have one part of arrow length you should have both
    Lib.noneOrAll(annIn, annOut, ['ax', 'ay']);
  }
}

/***/ }),

/***/ 9756:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var drawRaw = (__webpack_require__(3377).drawRaw);
var project = __webpack_require__(25802);
var axLetters = ['x', 'y', 'z'];
module.exports = function draw(scene) {
  var fullSceneLayout = scene.fullSceneLayout;
  var dataScale = scene.dataScale;
  var anns = fullSceneLayout.annotations;
  for (var i = 0; i < anns.length; i++) {
    var ann = anns[i];
    var annotationIsOffscreen = false;
    for (var j = 0; j < 3; j++) {
      var axLetter = axLetters[j];
      var pos = ann[axLetter];
      var ax = fullSceneLayout[axLetter + 'axis'];
      var posFraction = ax.r2fraction(pos);
      if (posFraction < 0 || posFraction > 1) {
        annotationIsOffscreen = true;
        break;
      }
    }
    if (annotationIsOffscreen) {
      scene.fullLayout._infolayer.select('.annotation-' + scene.id + '[data-index="' + i + '"]').remove();
    } else {
      ann._pdata = project(scene.glplot.cameraParams, [fullSceneLayout.xaxis.r2l(ann.x) * dataScale[0], fullSceneLayout.yaxis.r2l(ann.y) * dataScale[1], fullSceneLayout.zaxis.r2l(ann.z) * dataScale[2]]);
      drawRaw(scene.graphDiv, ann, i, scene.id, ann._xa, ann._ya);
    }
  }
};

/***/ }),

/***/ 83348:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Registry = __webpack_require__(33626);
var Lib = __webpack_require__(34809);
module.exports = {
  moduleType: 'component',
  name: 'annotations3d',
  schema: {
    subplots: {
      scene: {
        annotations: __webpack_require__(38239)
      }
    }
  },
  layoutAttributes: __webpack_require__(38239),
  handleDefaults: __webpack_require__(34232),
  includeBasePlot: includeGL3D,
  convert: __webpack_require__(47979),
  draw: __webpack_require__(9756)
};
function includeGL3D(layoutIn, layoutOut) {
  var GL3D = Registry.subplotsRegistry.gl3d;
  if (!GL3D) return;
  var attrRegex = GL3D.attrRegex;
  var keys = Object.keys(layoutIn);
  for (var i = 0; i < keys.length; i++) {
    var k = keys[i];
    if (attrRegex.test(k) && (layoutIn[k].annotations || []).length) {
      Lib.pushUnique(layoutOut._basePlotModules, GL3D);
      Lib.pushUnique(layoutOut._subplots.gl3d, k);
    }
  }
}

/***/ }),

/***/ 37177:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


// a trimmed down version of:
// https://github.com/alexcjohnson/world-calendars/blob/master/dist/index.js
module.exports = __webpack_require__(24453);
__webpack_require__(23428);
__webpack_require__(1401);
__webpack_require__(72210);
__webpack_require__(28569);
__webpack_require__(81133);
__webpack_require__(78295);
__webpack_require__(25512);
__webpack_require__(42645);
__webpack_require__(62324);
__webpack_require__(91662);
__webpack_require__(66445);
__webpack_require__(50506);
__webpack_require__(84756);
__webpack_require__(41858);
__webpack_require__(57985);

/***/ }),

/***/ 29698:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var calendars = __webpack_require__(37177);
var Lib = __webpack_require__(34809);
var constants = __webpack_require__(63821);
var EPOCHJD = constants.EPOCHJD;
var ONEDAY = constants.ONEDAY;
var attributes = {
  valType: 'enumerated',
  values: Lib.sortObjectKeys(calendars.calendars),
  editType: 'calc',
  dflt: 'gregorian'
};
var handleDefaults = function (contIn, contOut, attr, dflt) {
  var attrs = {};
  attrs[attr] = attributes;
  return Lib.coerce(contIn, contOut, attrs, attr, dflt);
};
var handleTraceDefaults = function (traceIn, traceOut, coords, layout) {
  for (var i = 0; i < coords.length; i++) {
    handleDefaults(traceIn, traceOut, coords[i] + 'calendar', layout.calendar);
  }
};

// each calendar needs its own default canonical tick. I would love to use
// 2000-01-01 (or even 0000-01-01) for them all but they don't necessarily
// all support either of those dates. Instead I'll use the most significant
// number they *do* support, biased toward the present day.
var CANONICAL_TICK = {
  chinese: '2000-01-01',
  coptic: '2000-01-01',
  discworld: '2000-01-01',
  ethiopian: '2000-01-01',
  hebrew: '5000-01-01',
  islamic: '1000-01-01',
  julian: '2000-01-01',
  mayan: '5000-01-01',
  nanakshahi: '1000-01-01',
  nepali: '2000-01-01',
  persian: '1000-01-01',
  jalali: '1000-01-01',
  taiwan: '1000-01-01',
  thai: '2000-01-01',
  ummalqura: '1400-01-01'
};

// Start on a Sunday - for week ticks
// Discworld and Mayan calendars don't have 7-day weeks but we're going to give them
// 7-day week ticks so start on our Sundays.
// If anyone really cares we can customize the auto tick spacings for these calendars.
var CANONICAL_SUNDAY = {
  chinese: '2000-01-02',
  coptic: '2000-01-03',
  discworld: '2000-01-03',
  ethiopian: '2000-01-05',
  hebrew: '5000-01-01',
  islamic: '1000-01-02',
  julian: '2000-01-03',
  mayan: '5000-01-01',
  nanakshahi: '1000-01-05',
  nepali: '2000-01-05',
  persian: '1000-01-01',
  jalali: '1000-01-01',
  taiwan: '1000-01-04',
  thai: '2000-01-04',
  ummalqura: '1400-01-06'
};
var DFLTRANGE = {
  chinese: ['2000-01-01', '2001-01-01'],
  coptic: ['1700-01-01', '1701-01-01'],
  discworld: ['1800-01-01', '1801-01-01'],
  ethiopian: ['2000-01-01', '2001-01-01'],
  hebrew: ['5700-01-01', '5701-01-01'],
  islamic: ['1400-01-01', '1401-01-01'],
  julian: ['2000-01-01', '2001-01-01'],
  mayan: ['5200-01-01', '5201-01-01'],
  nanakshahi: ['0500-01-01', '0501-01-01'],
  nepali: ['2000-01-01', '2001-01-01'],
  persian: ['1400-01-01', '1401-01-01'],
  jalali: ['1400-01-01', '1401-01-01'],
  taiwan: ['0100-01-01', '0101-01-01'],
  thai: ['2500-01-01', '2501-01-01'],
  ummalqura: ['1400-01-01', '1401-01-01']
};

/*
 * convert d3 templates to world-calendars templates, so our users only need
 * to know d3's specifiers. Map space padding to no padding, and unknown fields
 * to an ugly placeholder
 */
var UNKNOWN = '##';
var d3ToWorldCalendars = {
  d: {
    0: 'dd',
    '-': 'd'
  },
  // 2-digit or unpadded day of month
  e: {
    0: 'd',
    '-': 'd'
  },
  // alternate, always unpadded day of month
  a: {
    0: 'D',
    '-': 'D'
  },
  // short weekday name
  A: {
    0: 'DD',
    '-': 'DD'
  },
  // full weekday name
  j: {
    0: 'oo',
    '-': 'o'
  },
  // 3-digit or unpadded day of the year
  W: {
    0: 'ww',
    '-': 'w'
  },
  // 2-digit or unpadded week of the year (Monday first)
  m: {
    0: 'mm',
    '-': 'm'
  },
  // 2-digit or unpadded month number
  b: {
    0: 'M',
    '-': 'M'
  },
  // short month name
  B: {
    0: 'MM',
    '-': 'MM'
  },
  // full month name
  y: {
    0: 'yy',
    '-': 'yy'
  },
  // 2-digit year (map unpadded to zero-padded)
  Y: {
    0: 'yyyy',
    '-': 'yyyy'
  },
  // 4-digit year (map unpadded to zero-padded)
  U: UNKNOWN,
  // Sunday-first week of the year
  w: UNKNOWN,
  // day of the week [0(sunday),6]
  // combined format, we replace the date part with the world-calendar version
  // and the %X stays there for d3 to handle with time parts
  c: {
    0: 'D M d %X yyyy',
    '-': 'D M d %X yyyy'
  },
  x: {
    0: 'mm/dd/yyyy',
    '-': 'mm/dd/yyyy'
  }
};
function worldCalFmt(fmt, x, calendar) {
  var dateJD = Math.floor((x + 0.05) / ONEDAY) + EPOCHJD;
  var cDate = getCal(calendar).fromJD(dateJD);
  var i = 0;
  var modifier, directive, directiveLen, directiveObj, replacementPart;
  while ((i = fmt.indexOf('%', i)) !== -1) {
    modifier = fmt.charAt(i + 1);
    if (modifier === '0' || modifier === '-' || modifier === '_') {
      directiveLen = 3;
      directive = fmt.charAt(i + 2);
      if (modifier === '_') modifier = '-';
    } else {
      directive = modifier;
      modifier = '0';
      directiveLen = 2;
    }
    directiveObj = d3ToWorldCalendars[directive];
    if (!directiveObj) {
      i += directiveLen;
    } else {
      // code is recognized as a date part but world-calendars doesn't support it
      if (directiveObj === UNKNOWN) replacementPart = UNKNOWN;

      // format the cDate according to the translated directive
      else replacementPart = cDate.formatDate(directiveObj[modifier]);
      fmt = fmt.substr(0, i) + replacementPart + fmt.substr(i + directiveLen);
      i += replacementPart.length;
    }
  }
  return fmt;
}

// cache world calendars, so we don't have to reinstantiate
// during each date-time conversion
var allCals = {};
function getCal(calendar) {
  var calendarObj = allCals[calendar];
  if (calendarObj) return calendarObj;
  calendarObj = allCals[calendar] = calendars.instance(calendar);
  return calendarObj;
}
function makeAttrs(description) {
  return Lib.extendFlat({}, attributes, {
    description: description
  });
}
function makeTraceAttrsDescription(coord) {
  return 'Sets the calendar system to use with `' + coord + '` date data.';
}
var xAttrs = {
  xcalendar: makeAttrs(makeTraceAttrsDescription('x'))
};
var xyAttrs = Lib.extendFlat({}, xAttrs, {
  ycalendar: makeAttrs(makeTraceAttrsDescription('y'))
});
var xyzAttrs = Lib.extendFlat({}, xyAttrs, {
  zcalendar: makeAttrs(makeTraceAttrsDescription('z'))
});
var axisAttrs = makeAttrs(['Sets the calendar system to use for `range` and `tick0`', 'if this is a date axis. This does not set the calendar for', 'interpreting data on this axis, that\'s specified in the trace', 'or via the global `layout.calendar`'].join(' '));
module.exports = {
  moduleType: 'component',
  name: 'calendars',
  schema: {
    traces: {
      scatter: xyAttrs,
      bar: xyAttrs,
      box: xyAttrs,
      heatmap: xyAttrs,
      contour: xyAttrs,
      histogram: xyAttrs,
      histogram2d: xyAttrs,
      histogram2dcontour: xyAttrs,
      scatter3d: xyzAttrs,
      surface: xyzAttrs,
      mesh3d: xyzAttrs,
      scattergl: xyAttrs,
      ohlc: xAttrs,
      candlestick: xAttrs
    },
    layout: {
      calendar: makeAttrs(['Sets the default calendar system to use for interpreting and', 'displaying dates throughout the plot.'].join(' '))
    },
    subplots: {
      xaxis: {
        calendar: axisAttrs
      },
      yaxis: {
        calendar: axisAttrs
      },
      scene: {
        xaxis: {
          calendar: axisAttrs
        },
        // TODO: it's actually redundant to include yaxis and zaxis here
        // because in the scene attributes these are the same object so merging
        // into one merges into them all. However, I left them in for parity with
        // cartesian, where yaxis is unused until we Plotschema.get() when we
        // use its presence or absence to determine whether to delete attributes
        // from yaxis if they only apply to x (rangeselector/rangeslider)
        yaxis: {
          calendar: axisAttrs
        },
        zaxis: {
          calendar: axisAttrs
        }
      },
      polar: {
        radialaxis: {
          calendar: axisAttrs
        }
      }
    },
    transforms: {
      filter: {
        valuecalendar: makeAttrs(['WARNING: All transforms are deprecated and may be removed from the API in next major version.', 'Sets the calendar system to use for `value`, if it is a date.'].join(' ')),
        targetcalendar: makeAttrs(['WARNING: All transforms are deprecated and may be removed from the API in next major version.', 'Sets the calendar system to use for `target`, if it is an', 'array of dates. If `target` is a string (eg *x*) we use the', 'corresponding trace attribute (eg `xcalendar`) if it exists,', 'even if `targetcalendar` is provided.'].join(' '))
      }
    }
  },
  layoutAttributes: attributes,
  handleDefaults: handleDefaults,
  handleTraceDefaults: handleTraceDefaults,
  CANONICAL_SUNDAY: CANONICAL_SUNDAY,
  CANONICAL_TICK: CANONICAL_TICK,
  DFLTRANGE: DFLTRANGE,
  getCal: getCal,
  worldCalFmt: worldCalFmt
};

/***/ }),

/***/ 10229:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


// IMPORTANT - default colors should be in hex for compatibility
exports.defaults = ['#1f77b4',
// muted blue
'#ff7f0e',
// safety orange
'#2ca02c',
// cooked asparagus green
'#d62728',
// brick red
'#9467bd',
// muted purple
'#8c564b',
// chestnut brown
'#e377c2',
// raspberry yogurt pink
'#7f7f7f',
// middle gray
'#bcbd22',
// curry yellow-green
'#17becf' // blue-teal
];
exports.defaultLine = '#444';
exports.lightLine = '#eee';
exports.background = '#fff';
exports.borderLine = '#BEC8D9';

// with axis.color and Color.interp we aren't using lightLine
// itself anymore, instead interpolating between axis.color
// and the background color using tinycolor.mix. lightFraction
// gives back exactly lightLine if the other colors are defaults.
exports.lightFraction = 100 * (0xe - 0x4) / (0xf - 0x4);

/***/ }),

/***/ 78766:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var tinycolor = __webpack_require__(65657);
var isNumeric = __webpack_require__(10721);
var isTypedArray = (__webpack_require__(87800).isTypedArray);
var color = module.exports = {};
var colorAttrs = __webpack_require__(10229);
color.defaults = colorAttrs.defaults;
var defaultLine = color.defaultLine = colorAttrs.defaultLine;
color.lightLine = colorAttrs.lightLine;
var background = color.background = colorAttrs.background;

/*
 * tinyRGB: turn a tinycolor into an rgb string, but
 * unlike the built-in tinycolor.toRgbString this never includes alpha
 */
color.tinyRGB = function (tc) {
  var c = tc.toRgb();
  return 'rgb(' + Math.round(c.r) + ', ' + Math.round(c.g) + ', ' + Math.round(c.b) + ')';
};
color.rgb = function (cstr) {
  return color.tinyRGB(tinycolor(cstr));
};
color.opacity = function (cstr) {
  return cstr ? tinycolor(cstr).getAlpha() : 0;
};
color.addOpacity = function (cstr, op) {
  var c = tinycolor(cstr).toRgb();
  return 'rgba(' + Math.round(c.r) + ', ' + Math.round(c.g) + ', ' + Math.round(c.b) + ', ' + op + ')';
};

// combine two colors into one apparent color
// if back has transparency or is missing,
// color.background is assumed behind it
color.combine = function (front, back) {
  var fc = tinycolor(front).toRgb();
  if (fc.a === 1) return tinycolor(front).toRgbString();
  var bc = tinycolor(back || background).toRgb();
  var bcflat = bc.a === 1 ? bc : {
    r: 255 * (1 - bc.a) + bc.r * bc.a,
    g: 255 * (1 - bc.a) + bc.g * bc.a,
    b: 255 * (1 - bc.a) + bc.b * bc.a
  };
  var fcflat = {
    r: bcflat.r * (1 - fc.a) + fc.r * fc.a,
    g: bcflat.g * (1 - fc.a) + fc.g * fc.a,
    b: bcflat.b * (1 - fc.a) + fc.b * fc.a
  };
  return tinycolor(fcflat).toRgbString();
};

/*
 * Linearly interpolate between two colors at a normalized interpolation position (0 to 1).
 *
 * Ignores alpha channel values.
 * The resulting color is computed as: factor * first + (1 - factor) * second.
 */
color.interpolate = function (first, second, factor) {
  var fc = tinycolor(first).toRgb();
  var sc = tinycolor(second).toRgb();
  var ic = {
    r: factor * fc.r + (1 - factor) * sc.r,
    g: factor * fc.g + (1 - factor) * sc.g,
    b: factor * fc.b + (1 - factor) * sc.b
  };
  return tinycolor(ic).toRgbString();
};

/*
 * Create a color that contrasts with cstr.
 *
 * If cstr is a dark color, we lighten it; if it's light, we darken.
 *
 * If lightAmount / darkAmount are used, we adjust by these percentages,
 * otherwise we go all the way to white or black.
 */
color.contrast = function (cstr, lightAmount, darkAmount) {
  var tc = tinycolor(cstr);
  if (tc.getAlpha() !== 1) tc = tinycolor(color.combine(cstr, background));
  var newColor = tc.isDark() ? lightAmount ? tc.lighten(lightAmount) : background : darkAmount ? tc.darken(darkAmount) : defaultLine;
  return newColor.toString();
};
color.stroke = function (s, c) {
  var tc = tinycolor(c);
  s.style({
    stroke: color.tinyRGB(tc),
    'stroke-opacity': tc.getAlpha()
  });
};
color.fill = function (s, c) {
  var tc = tinycolor(c);
  s.style({
    fill: color.tinyRGB(tc),
    'fill-opacity': tc.getAlpha()
  });
};

// search container for colors with the deprecated rgb(fractions) format
// and convert them to rgb(0-255 values)
color.clean = function (container) {
  if (!container || typeof container !== 'object') return;
  var keys = Object.keys(container);
  var i, j, key, val;
  for (i = 0; i < keys.length; i++) {
    key = keys[i];
    val = container[key];
    if (key.substr(key.length - 5) === 'color') {
      // only sanitize keys that end in "color" or "colorscale"

      if (Array.isArray(val)) {
        for (j = 0; j < val.length; j++) val[j] = cleanOne(val[j]);
      } else container[key] = cleanOne(val);
    } else if (key.substr(key.length - 10) === 'colorscale' && Array.isArray(val)) {
      // colorscales have the format [[0, color1], [frac, color2], ... [1, colorN]]

      for (j = 0; j < val.length; j++) {
        if (Array.isArray(val[j])) val[j][1] = cleanOne(val[j][1]);
      }
    } else if (Array.isArray(val)) {
      // recurse into arrays of objects, and plain objects

      var el0 = val[0];
      if (!Array.isArray(el0) && el0 && typeof el0 === 'object') {
        for (j = 0; j < val.length; j++) color.clean(val[j]);
      }
    } else if (val && typeof val === 'object' && !isTypedArray(val)) color.clean(val);
  }
};
function cleanOne(val) {
  if (isNumeric(val) || typeof val !== 'string') return val;
  var valTrim = val.trim();
  if (valTrim.substr(0, 3) !== 'rgb') return val;
  var match = valTrim.match(/^rgba?\s*\(([^()]*)\)$/);
  if (!match) return val;
  var parts = match[1].trim().split(/\s*[\s,]\s*/);
  var rgba = valTrim.charAt(3) === 'a' && parts.length === 4;
  if (!rgba && parts.length !== 3) return val;
  for (var i = 0; i < parts.length; i++) {
    if (!parts[i].length) return val;
    parts[i] = Number(parts[i]);
    if (!(parts[i] >= 0)) {
      // all parts must be non-negative numbers

      return val;
    }
    if (i === 3) {
      // alpha>1 gets clipped to 1

      if (parts[i] > 1) parts[i] = 1;
    } else if (parts[i] >= 1) {
      // r, g, b must be < 1 (ie 1 itself is not allowed)

      return val;
    }
  }
  var rgbStr = Math.round(parts[0] * 255) + ', ' + Math.round(parts[1] * 255) + ', ' + Math.round(parts[2] * 255);
  if (rgba) return 'rgba(' + rgbStr + ', ' + parts[3] + ')';
  return 'rgb(' + rgbStr + ')';
}

/***/ }),

/***/ 25158:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var axesAttrs = __webpack_require__(25829);
var fontAttrs = __webpack_require__(80337);
var extendFlat = (__webpack_require__(93049).extendFlat);
var overrideAll = (__webpack_require__(13582).overrideAll);
module.exports = overrideAll({
  orientation: {
    valType: 'enumerated',
    values: ['h', 'v'],
    dflt: 'v'
  },
  thicknessmode: {
    valType: 'enumerated',
    values: ['fraction', 'pixels'],
    dflt: 'pixels'
  },
  thickness: {
    valType: 'number',
    min: 0,
    dflt: 30
  },
  lenmode: {
    valType: 'enumerated',
    values: ['fraction', 'pixels'],
    dflt: 'fraction'
  },
  len: {
    valType: 'number',
    min: 0,
    dflt: 1
  },
  x: {
    valType: 'number'
  },
  xref: {
    valType: 'enumerated',
    dflt: 'paper',
    values: ['container', 'paper'],
    editType: 'layoutstyle'
  },
  xanchor: {
    valType: 'enumerated',
    values: ['left', 'center', 'right']
  },
  xpad: {
    valType: 'number',
    min: 0,
    dflt: 10
  },
  y: {
    valType: 'number'
  },
  yref: {
    valType: 'enumerated',
    dflt: 'paper',
    values: ['container', 'paper'],
    editType: 'layoutstyle'
  },
  yanchor: {
    valType: 'enumerated',
    values: ['top', 'middle', 'bottom']
  },
  ypad: {
    valType: 'number',
    min: 0,
    dflt: 10
  },
  // a possible line around the bar itself
  outlinecolor: axesAttrs.linecolor,
  outlinewidth: axesAttrs.linewidth,
  // Should outlinewidth have {dflt: 0} ?
  // another possible line outside the padding and tick labels
  bordercolor: axesAttrs.linecolor,
  borderwidth: {
    valType: 'number',
    min: 0,
    dflt: 0
  },
  bgcolor: {
    valType: 'color',
    dflt: 'rgba(0,0,0,0)'
  },
  // tick and title properties named and function exactly as in axes
  tickmode: axesAttrs.minor.tickmode,
  nticks: axesAttrs.nticks,
  tick0: axesAttrs.tick0,
  dtick: axesAttrs.dtick,
  tickvals: axesAttrs.tickvals,
  ticktext: axesAttrs.ticktext,
  ticks: extendFlat({}, axesAttrs.ticks, {
    dflt: ''
  }),
  ticklabeloverflow: extendFlat({}, axesAttrs.ticklabeloverflow, {}),
  // ticklabelposition: not used directly, as values depend on orientation
  // left/right options are for x axes, and top/bottom options are for y axes
  ticklabelposition: {
    valType: 'enumerated',
    values: ['outside', 'inside', 'outside top', 'inside top', 'outside left', 'inside left', 'outside right', 'inside right', 'outside bottom', 'inside bottom'],
    dflt: 'outside'
  },
  ticklen: axesAttrs.ticklen,
  tickwidth: axesAttrs.tickwidth,
  tickcolor: axesAttrs.tickcolor,
  ticklabelstep: axesAttrs.ticklabelstep,
  showticklabels: axesAttrs.showticklabels,
  labelalias: axesAttrs.labelalias,
  tickfont: fontAttrs({}),
  tickangle: axesAttrs.tickangle,
  tickformat: axesAttrs.tickformat,
  tickformatstops: axesAttrs.tickformatstops,
  tickprefix: axesAttrs.tickprefix,
  showtickprefix: axesAttrs.showtickprefix,
  ticksuffix: axesAttrs.ticksuffix,
  showticksuffix: axesAttrs.showticksuffix,
  separatethousands: axesAttrs.separatethousands,
  exponentformat: axesAttrs.exponentformat,
  minexponent: axesAttrs.minexponent,
  showexponent: axesAttrs.showexponent,
  title: {
    text: {
      valType: 'string'
    },
    font: fontAttrs({}),
    side: {
      valType: 'enumerated',
      values: ['right', 'top', 'bottom']
    }
  },
  _deprecated: {
    title: {
      valType: 'string'
    },
    titlefont: fontAttrs({}),
    titleside: {
      valType: 'enumerated',
      values: ['right', 'top', 'bottom'],
      dflt: 'top'
    }
  }
}, 'colorbars', 'from-root');

/***/ }),

/***/ 34554:
/***/ (function(module) {

"use strict";


module.exports = {
  cn: {
    colorbar: 'colorbar',
    cbbg: 'cbbg',
    cbfill: 'cbfill',
    cbfills: 'cbfills',
    cbline: 'cbline',
    cblines: 'cblines',
    cbaxis: 'cbaxis',
    cbtitleunshift: 'cbtitleunshift',
    cbtitle: 'cbtitle',
    cboutline: 'cboutline',
    crisp: 'crisp',
    jsPlaceholder: 'js-placeholder'
  }
};

/***/ }),

/***/ 42097:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var Template = __webpack_require__(78032);
var handleTickValueDefaults = __webpack_require__(22777);
var handleTickMarkDefaults = __webpack_require__(87433);
var handleTickLabelDefaults = __webpack_require__(12036);
var handlePrefixSuffixDefaults = __webpack_require__(54616);
var attributes = __webpack_require__(25158);
module.exports = function colorbarDefaults(containerIn, containerOut, layout) {
  var colorbarOut = Template.newContainer(containerOut, 'colorbar');
  var colorbarIn = containerIn.colorbar || {};
  function coerce(attr, dflt) {
    return Lib.coerce(colorbarIn, colorbarOut, attributes, attr, dflt);
  }
  var margin = layout.margin || {
    t: 0,
    b: 0,
    l: 0,
    r: 0
  };
  var w = layout.width - margin.l - margin.r;
  var h = layout.height - margin.t - margin.b;
  var orientation = coerce('orientation');
  var isVertical = orientation === 'v';
  var thicknessmode = coerce('thicknessmode');
  coerce('thickness', thicknessmode === 'fraction' ? 30 / (isVertical ? w : h) : 30);
  var lenmode = coerce('lenmode');
  coerce('len', lenmode === 'fraction' ? 1 : isVertical ? h : w);
  var yref = coerce('yref');
  var xref = coerce('xref');
  var isPaperY = yref === 'paper';
  var isPaperX = xref === 'paper';
  var defaultX, defaultY, defaultYAnchor;
  var defaultXAnchor = 'left';
  if (isVertical) {
    defaultYAnchor = 'middle';
    defaultXAnchor = isPaperX ? 'left' : 'right';
    defaultX = isPaperX ? 1.02 : 1;
    defaultY = 0.5;
  } else {
    defaultYAnchor = isPaperY ? 'bottom' : 'top';
    defaultXAnchor = 'center';
    defaultX = 0.5;
    defaultY = isPaperY ? 1.02 : 1;
  }
  Lib.coerce(colorbarIn, colorbarOut, {
    x: {
      valType: 'number',
      min: isPaperX ? -2 : 0,
      max: isPaperX ? 3 : 1,
      dflt: defaultX
    }
  }, 'x');
  Lib.coerce(colorbarIn, colorbarOut, {
    y: {
      valType: 'number',
      min: isPaperY ? -2 : 0,
      max: isPaperY ? 3 : 1,
      dflt: defaultY
    }
  }, 'y');
  coerce('xanchor', defaultXAnchor);
  coerce('xpad');
  coerce('yanchor', defaultYAnchor);
  coerce('ypad');
  Lib.noneOrAll(colorbarIn, colorbarOut, ['x', 'y']);
  coerce('outlinecolor');
  coerce('outlinewidth');
  coerce('bordercolor');
  coerce('borderwidth');
  coerce('bgcolor');
  var ticklabelposition = Lib.coerce(colorbarIn, colorbarOut, {
    ticklabelposition: {
      valType: 'enumerated',
      dflt: 'outside',
      values: isVertical ? ['outside', 'inside', 'outside top', 'inside top', 'outside bottom', 'inside bottom'] : ['outside', 'inside', 'outside left', 'inside left', 'outside right', 'inside right']
    }
  }, 'ticklabelposition');
  coerce('ticklabeloverflow', ticklabelposition.indexOf('inside') !== -1 ? 'hide past domain' : 'hide past div');
  handleTickValueDefaults(colorbarIn, colorbarOut, coerce, 'linear');
  var font = layout.font;
  var opts = {
    noAutotickangles: true,
    noTicklabelshift: true,
    noTicklabelstandoff: true,
    outerTicks: false,
    font: font
  };
  if (ticklabelposition.indexOf('inside') !== -1) {
    opts.bgColor = 'black'; // could we instead use the average of colors in the scale?
  }
  handlePrefixSuffixDefaults(colorbarIn, colorbarOut, coerce, 'linear', opts);
  handleTickLabelDefaults(colorbarIn, colorbarOut, coerce, 'linear', opts);
  handleTickMarkDefaults(colorbarIn, colorbarOut, coerce, 'linear', opts);
  coerce('title.text', layout._dfltTitle.colorbar);
  var tickFont = colorbarOut.showticklabels ? colorbarOut.tickfont : font;
  var dfltTitleFont = Lib.extendFlat({}, font, {
    family: tickFont.family,
    size: Lib.bigFont(tickFont.size)
  });
  Lib.coerceFont(coerce, 'title.font', dfltTitleFont);
  coerce('title.side', isVertical ? 'top' : 'right');
};

/***/ }),

/***/ 5881:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var tinycolor = __webpack_require__(65657);
var Plots = __webpack_require__(44122);
var Registry = __webpack_require__(33626);
var Axes = __webpack_require__(29714);
var dragElement = __webpack_require__(14751);
var Lib = __webpack_require__(34809);
var strTranslate = Lib.strTranslate;
var extendFlat = (__webpack_require__(93049).extendFlat);
var setCursor = __webpack_require__(27983);
var Drawing = __webpack_require__(62203);
var Color = __webpack_require__(78766);
var Titles = __webpack_require__(17240);
var svgTextUtils = __webpack_require__(30635);
var flipScale = (__webpack_require__(65477).flipScale);
var handleAxisDefaults = __webpack_require__(97655);
var handleAxisPositionDefaults = __webpack_require__(40957);
var axisLayoutAttrs = __webpack_require__(25829);
var alignmentConstants = __webpack_require__(4530);
var LINE_SPACING = alignmentConstants.LINE_SPACING;
var FROM_TL = alignmentConstants.FROM_TL;
var FROM_BR = alignmentConstants.FROM_BR;
var cn = (__webpack_require__(34554).cn);
function draw(gd) {
  var fullLayout = gd._fullLayout;
  var colorBars = fullLayout._infolayer.selectAll('g.' + cn.colorbar).data(makeColorBarData(gd), function (opts) {
    return opts._id;
  });
  colorBars.enter().append('g').attr('class', function (opts) {
    return opts._id;
  }).classed(cn.colorbar, true);
  colorBars.each(function (opts) {
    var g = d3.select(this);
    Lib.ensureSingle(g, 'rect', cn.cbbg);
    Lib.ensureSingle(g, 'g', cn.cbfills);
    Lib.ensureSingle(g, 'g', cn.cblines);
    Lib.ensureSingle(g, 'g', cn.cbaxis, function (s) {
      s.classed(cn.crisp, true);
    });
    Lib.ensureSingle(g, 'g', cn.cbtitleunshift, function (s) {
      s.append('g').classed(cn.cbtitle, true);
    });
    Lib.ensureSingle(g, 'rect', cn.cboutline);
    var done = drawColorBar(g, opts, gd);
    if (done && done.then) (gd._promises || []).push(done);
    if (gd._context.edits.colorbarPosition) {
      makeEditable(g, opts, gd);
    }
  });
  colorBars.exit().each(function (opts) {
    Plots.autoMargin(gd, opts._id);
  }).remove();
  colorBars.order();
}
function makeColorBarData(gd) {
  var fullLayout = gd._fullLayout;
  var calcdata = gd.calcdata;
  var out = [];

  // single out item
  var opts;
  // colorbar attr parent container
  var cont;
  // trace attr container
  var trace;
  // colorbar options
  var cbOpt;
  function initOpts(opts) {
    return extendFlat(opts, {
      // fillcolor can be a d3 scale, domain is z values, range is colors
      // or leave it out for no fill,
      // or set to a string constant for single-color fill
      _fillcolor: null,
      // line.color has the same options as fillcolor
      _line: {
        color: null,
        width: null,
        dash: null
      },
      // levels of lines to draw.
      // note that this DOES NOT determine the extent of the bar
      // that's given by the domain of fillcolor
      // (or line.color if no fillcolor domain)
      _levels: {
        start: null,
        end: null,
        size: null
      },
      // separate fill levels (for example, heatmap coloring of a
      // contour map) if this is omitted, fillcolors will be
      // evaluated halfway between levels
      _filllevels: null,
      // for continuous colorscales: fill with a gradient instead of explicit levels
      // value should be the colorscale [[0, c0], [v1, c1], ..., [1, cEnd]]
      _fillgradient: null,
      // when using a gradient, we need the data range specified separately
      _zrange: null
    });
  }
  function calcOpts() {
    if (typeof cbOpt.calc === 'function') {
      cbOpt.calc(gd, trace, opts);
    } else {
      opts._fillgradient = cont.reversescale ? flipScale(cont.colorscale) : cont.colorscale;
      opts._zrange = [cont[cbOpt.min], cont[cbOpt.max]];
    }
  }
  for (var i = 0; i < calcdata.length; i++) {
    var cd = calcdata[i];
    trace = cd[0].trace;
    if (!trace._module) continue;
    var moduleOpts = trace._module.colorbar;
    if (trace.visible === true && moduleOpts) {
      var allowsMultiplotCbs = Array.isArray(moduleOpts);
      var cbOpts = allowsMultiplotCbs ? moduleOpts : [moduleOpts];
      for (var j = 0; j < cbOpts.length; j++) {
        cbOpt = cbOpts[j];
        var contName = cbOpt.container;
        cont = contName ? trace[contName] : trace;
        if (cont && cont.showscale) {
          opts = initOpts(cont.colorbar);
          opts._id = 'cb' + trace.uid + (allowsMultiplotCbs && contName ? '-' + contName : '');
          opts._traceIndex = trace.index;
          opts._propPrefix = (contName ? contName + '.' : '') + 'colorbar.';
          opts._meta = trace._meta;
          calcOpts();
          out.push(opts);
        }
      }
    }
  }
  for (var k in fullLayout._colorAxes) {
    cont = fullLayout[k];
    if (cont.showscale) {
      var colorAxOpts = fullLayout._colorAxes[k];
      opts = initOpts(cont.colorbar);
      opts._id = 'cb' + k;
      opts._propPrefix = k + '.colorbar.';
      opts._meta = fullLayout._meta;
      cbOpt = {
        min: 'cmin',
        max: 'cmax'
      };
      if (colorAxOpts[0] !== 'heatmap') {
        trace = colorAxOpts[1];
        cbOpt.calc = trace._module.colorbar.calc;
      }
      calcOpts();
      out.push(opts);
    }
  }
  return out;
}
function drawColorBar(g, opts, gd) {
  var isVertical = opts.orientation === 'v';
  var len = opts.len;
  var lenmode = opts.lenmode;
  var thickness = opts.thickness;
  var thicknessmode = opts.thicknessmode;
  var outlinewidth = opts.outlinewidth;
  var borderwidth = opts.borderwidth;
  var bgcolor = opts.bgcolor;
  var xanchor = opts.xanchor;
  var yanchor = opts.yanchor;
  var xpad = opts.xpad;
  var ypad = opts.ypad;
  var optsX = opts.x;
  var optsY = isVertical ? opts.y : 1 - opts.y;
  var isPaperY = opts.yref === 'paper';
  var isPaperX = opts.xref === 'paper';
  var fullLayout = gd._fullLayout;
  var gs = fullLayout._size;
  var fillColor = opts._fillcolor;
  var line = opts._line;
  var title = opts.title;
  var titleSide = title.side;
  var zrange = opts._zrange || d3.extent((typeof fillColor === 'function' ? fillColor : line.color).domain());
  var lineColormap = typeof line.color === 'function' ? line.color : function () {
    return line.color;
  };
  var fillColormap = typeof fillColor === 'function' ? fillColor : function () {
    return fillColor;
  };
  var levelsIn = opts._levels;
  var levelsOut = calcLevels(gd, opts, zrange);
  var fillLevels = levelsOut.fill;
  var lineLevels = levelsOut.line;

  // we calculate pixel sizes based on the specified graph size,
  // not the actual (in case something pushed the margins around)
  // which is a little odd but avoids an odd iterative effect
  // when the colorbar itself is pushing the margins.
  // but then the fractional size is calculated based on the
  // actual graph size, so that the axes will size correctly.
  var thickPx = Math.round(thickness * (thicknessmode === 'fraction' ? isVertical ? gs.w : gs.h : 1));
  var thickFrac = thickPx / (isVertical ? gs.w : gs.h);
  var lenPx = Math.round(len * (lenmode === 'fraction' ? isVertical ? gs.h : gs.w : 1));
  var lenFrac = lenPx / (isVertical ? gs.h : gs.w);
  var posW = isPaperX ? gs.w : gd._fullLayout.width;
  var posH = isPaperY ? gs.h : gd._fullLayout.height;

  // x positioning: do it initially just for left anchor,
  // then fix at the end (since we don't know the width yet)
  var uPx = Math.round(isVertical ? optsX * posW + xpad : optsY * posH + ypad);
  var xRatio = {
    center: 0.5,
    right: 1
  }[xanchor] || 0;
  var yRatio = {
    top: 1,
    middle: 0.5
  }[yanchor] || 0;

  // for dragging... this is getting a little muddled...
  var uFrac = isVertical ? optsX - xRatio * thickFrac : optsY - yRatio * thickFrac;

  // y/x positioning (for v/h) we can do correctly from the start
  var vFrac = isVertical ? optsY - yRatio * lenFrac : optsX - xRatio * lenFrac;
  var vPx = Math.round(isVertical ? posH * (1 - vFrac) : posW * vFrac);

  // stash a few things for makeEditable
  opts._lenFrac = lenFrac;
  opts._thickFrac = thickFrac;
  opts._uFrac = uFrac;
  opts._vFrac = vFrac;

  // stash mocked axis for contour label formatting
  var ax = opts._axis = mockColorBarAxis(gd, opts, zrange);

  // position can't go in through supplyDefaults
  // because that restricts it to [0,1]
  ax.position = thickFrac + (isVertical ? optsX + xpad / gs.w : optsY + ypad / gs.h);
  var topOrBottom = ['top', 'bottom'].indexOf(titleSide) !== -1;
  if (isVertical && topOrBottom) {
    ax.title.side = titleSide;
    ax.titlex = optsX + xpad / gs.w;
    ax.titley = vFrac + (title.side === 'top' ? lenFrac - ypad / gs.h : ypad / gs.h);
  }
  if (!isVertical && !topOrBottom) {
    ax.title.side = titleSide;
    ax.titley = optsY + ypad / gs.h;
    ax.titlex = vFrac + xpad / gs.w; // right side
  }
  if (line.color && opts.tickmode === 'auto') {
    ax.tickmode = 'linear';
    ax.tick0 = levelsIn.start;
    var dtick = levelsIn.size;
    // expand if too many contours, so we don't get too many ticks
    var autoNtick = Lib.constrain(lenPx / 50, 4, 15) + 1;
    var dtFactor = (zrange[1] - zrange[0]) / ((opts.nticks || autoNtick) * dtick);
    if (dtFactor > 1) {
      var dtexp = Math.pow(10, Math.floor(Math.log(dtFactor) / Math.LN10));
      dtick *= dtexp * Lib.roundUp(dtFactor / dtexp, [2, 5, 10]);
      // if the contours are at round multiples, reset tick0
      // so they're still at round multiples. Otherwise,
      // keep the first label on the first contour level
      if ((Math.abs(levelsIn.start) / levelsIn.size + 1e-6) % 1 < 2e-6) {
        ax.tick0 = 0;
      }
    }
    ax.dtick = dtick;
  }

  // set domain after init, because we may want to
  // allow it outside [0,1]
  ax.domain = isVertical ? [vFrac + ypad / gs.h, vFrac + lenFrac - ypad / gs.h] : [vFrac + xpad / gs.w, vFrac + lenFrac - xpad / gs.w];
  ax.setScale();
  g.attr('transform', strTranslate(Math.round(gs.l), Math.round(gs.t)));
  var titleCont = g.select('.' + cn.cbtitleunshift).attr('transform', strTranslate(-Math.round(gs.l), -Math.round(gs.t)));
  var ticklabelposition = ax.ticklabelposition;
  var titleFontSize = ax.title.font.size;
  var axLayer = g.select('.' + cn.cbaxis);
  var titleEl;
  var titleHeight = 0;
  var titleWidth = 0;
  function drawTitle(titleClass, titleOpts) {
    var dfltTitleOpts = {
      propContainer: ax,
      propName: opts._propPrefix + 'title',
      traceIndex: opts._traceIndex,
      _meta: opts._meta,
      placeholder: fullLayout._dfltTitle.colorbar,
      containerGroup: g.select('.' + cn.cbtitle)
    };

    // this class-to-rotate thing with convertToTspans is
    // getting hackier and hackier... delete groups with the
    // wrong class (in case earlier the colorbar was drawn on
    // a different side, I think?)
    var otherClass = titleClass.charAt(0) === 'h' ? titleClass.substr(1) : 'h' + titleClass;
    g.selectAll('.' + otherClass + ',.' + otherClass + '-math-group').remove();
    Titles.draw(gd, titleClass, extendFlat(dfltTitleOpts, titleOpts || {}));
  }
  function drawDummyTitle() {
    // draw the title so we know how much room it needs
    // when we squish the axis.
    // On vertical colorbars this only applies to top or bottom titles, not right side.
    // On horizontal colorbars this only applies to right, etc.

    if (isVertical && topOrBottom || !isVertical && !topOrBottom) {
      var x, y;
      if (titleSide === 'top') {
        x = xpad + gs.l + posW * optsX;
        y = ypad + gs.t + posH * (1 - vFrac - lenFrac) + 3 + titleFontSize * 0.75;
      }
      if (titleSide === 'bottom') {
        x = xpad + gs.l + posW * optsX;
        y = ypad + gs.t + posH * (1 - vFrac) - 3 - titleFontSize * 0.25;
      }
      if (titleSide === 'right') {
        y = ypad + gs.t + posH * optsY + 3 + titleFontSize * 0.75;
        x = xpad + gs.l + posW * vFrac;
      }
      drawTitle(ax._id + 'title', {
        attributes: {
          x: x,
          y: y,
          'text-anchor': isVertical ? 'start' : 'middle'
        }
      });
    }
  }
  function drawCbTitle() {
    if (isVertical && !topOrBottom || !isVertical && topOrBottom) {
      var pos = ax.position || 0;
      var mid = ax._offset + ax._length / 2;
      var x, y;
      if (titleSide === 'right') {
        y = mid;
        x = gs.l + posW * pos + 10 + titleFontSize * (ax.showticklabels ? 1 : 0.5);
      } else {
        x = mid;
        if (titleSide === 'bottom') {
          y = gs.t + posH * pos + 10 + (ticklabelposition.indexOf('inside') === -1 ? ax.tickfont.size : 0) + (ax.ticks !== 'intside' ? opts.ticklen || 0 : 0);
        }
        if (titleSide === 'top') {
          var nlines = title.text.split('<br>').length;
          y = gs.t + posH * pos + 10 - thickPx - LINE_SPACING * titleFontSize * nlines;
        }
      }
      drawTitle((isVertical ?
      // the 'h' + is a hack to get around the fact that
      // convertToTspans rotates any 'y...' class by 90 degrees.
      // TODO: find a better way to control this.
      'h' : 'v') + ax._id + 'title', {
        avoid: {
          selection: d3.select(gd).selectAll('g.' + ax._id + 'tick'),
          side: titleSide,
          offsetTop: isVertical ? 0 : gs.t,
          offsetLeft: isVertical ? gs.l : 0,
          maxShift: isVertical ? fullLayout.width : fullLayout.height
        },
        attributes: {
          x: x,
          y: y,
          'text-anchor': 'middle'
        },
        transform: {
          rotate: isVertical ? -90 : 0,
          offset: 0
        }
      });
    }
  }
  function drawAxis() {
    if (!isVertical && !topOrBottom || isVertical && topOrBottom) {
      // squish the axis top to make room for the title
      var titleGroup = g.select('.' + cn.cbtitle);
      var titleText = titleGroup.select('text');
      var titleTrans = [-outlinewidth / 2, outlinewidth / 2];
      var mathJaxNode = titleGroup.select('.h' + ax._id + 'title-math-group').node();
      var lineSize = 15.6;
      if (titleText.node()) {
        lineSize = parseInt(titleText.node().style.fontSize, 10) * LINE_SPACING;
      }
      var bb;
      if (mathJaxNode) {
        bb = Drawing.bBox(mathJaxNode);
        titleWidth = bb.width;
        titleHeight = bb.height;
        if (titleHeight > lineSize) {
          // not entirely sure how mathjax is doing
          // vertical alignment, but this seems to work.
          titleTrans[1] -= (titleHeight - lineSize) / 2;
        }
      } else if (titleText.node() && !titleText.classed(cn.jsPlaceholder)) {
        bb = Drawing.bBox(titleText.node());
        titleWidth = bb.width;
        titleHeight = bb.height;
      }
      if (isVertical) {
        if (titleHeight) {
          // buffer btwn colorbar and title
          // TODO: configurable
          titleHeight += 5;
          if (titleSide === 'top') {
            ax.domain[1] -= titleHeight / gs.h;
            titleTrans[1] *= -1;
          } else {
            ax.domain[0] += titleHeight / gs.h;
            var nlines = svgTextUtils.lineCount(titleText);
            titleTrans[1] += (1 - nlines) * lineSize;
          }
          titleGroup.attr('transform', strTranslate(titleTrans[0], titleTrans[1]));
          ax.setScale();
        }
      } else {
        // horizontal colorbars
        if (titleWidth) {
          if (titleSide === 'right') {
            ax.domain[0] += (titleWidth + titleFontSize / 2) / gs.w;
          }
          titleGroup.attr('transform', strTranslate(titleTrans[0], titleTrans[1]));
          ax.setScale();
        }
      }
    }
    g.selectAll('.' + cn.cbfills + ',.' + cn.cblines).attr('transform', isVertical ? strTranslate(0, Math.round(gs.h * (1 - ax.domain[1]))) : strTranslate(Math.round(gs.w * ax.domain[0]), 0));
    axLayer.attr('transform', isVertical ? strTranslate(0, Math.round(-gs.t)) : strTranslate(Math.round(-gs.l), 0));
    var fills = g.select('.' + cn.cbfills).selectAll('rect.' + cn.cbfill).attr('style', '').data(fillLevels);
    fills.enter().append('rect').classed(cn.cbfill, true).attr('style', '');
    fills.exit().remove();
    var zBounds = zrange.map(ax.c2p).map(Math.round).sort(function (a, b) {
      return a - b;
    });
    fills.each(function (d, i) {
      var z = [i === 0 ? zrange[0] : (fillLevels[i] + fillLevels[i - 1]) / 2, i === fillLevels.length - 1 ? zrange[1] : (fillLevels[i] + fillLevels[i + 1]) / 2].map(ax.c2p).map(Math.round);

      // offset the side adjoining the next rectangle so they
      // overlap, to prevent antialiasing gaps
      if (isVertical) {
        z[1] = Lib.constrain(z[1] + (z[1] > z[0]) ? 1 : -1, zBounds[0], zBounds[1]);
      } /* else {
          // TODO: horizontal case
        } */

      // Colorbar cannot currently support opacities so we
      // use an opaque fill even when alpha channels present
      var fillEl = d3.select(this).attr(isVertical ? 'x' : 'y', uPx).attr(isVertical ? 'y' : 'x', d3.min(z)).attr(isVertical ? 'width' : 'height', Math.max(thickPx, 2)).attr(isVertical ? 'height' : 'width', Math.max(d3.max(z) - d3.min(z), 2));
      if (opts._fillgradient) {
        Drawing.gradient(fillEl, gd, opts._id, isVertical ? 'vertical' : 'horizontalreversed', opts._fillgradient, 'fill');
      } else {
        // tinycolor can't handle exponents and
        // at this scale, removing it makes no difference.
        var colorString = fillColormap(d).replace('e-', '');
        fillEl.attr('fill', tinycolor(colorString).toHexString());
      }
    });
    var lines = g.select('.' + cn.cblines).selectAll('path.' + cn.cbline).data(line.color && line.width ? lineLevels : []);
    lines.enter().append('path').classed(cn.cbline, true);
    lines.exit().remove();
    lines.each(function (d) {
      var a = uPx;
      var b = Math.round(ax.c2p(d)) + line.width / 2 % 1;
      d3.select(this).attr('d', 'M' + (isVertical ? a + ',' + b : b + ',' + a) + (isVertical ? 'h' : 'v') + thickPx).call(Drawing.lineGroupStyle, line.width, lineColormap(d), line.dash);
    });

    // force full redraw of labels and ticks
    axLayer.selectAll('g.' + ax._id + 'tick,path').remove();
    var shift = uPx + thickPx + (outlinewidth || 0) / 2 - (opts.ticks === 'outside' ? 1 : 0);
    var vals = Axes.calcTicks(ax);
    var tickSign = Axes.getTickSigns(ax)[2];
    Axes.drawTicks(gd, ax, {
      vals: ax.ticks === 'inside' ? Axes.clipEnds(ax, vals) : vals,
      layer: axLayer,
      path: Axes.makeTickPath(ax, shift, tickSign),
      transFn: Axes.makeTransTickFn(ax)
    });
    return Axes.drawLabels(gd, ax, {
      vals: vals,
      layer: axLayer,
      transFn: Axes.makeTransTickLabelFn(ax),
      labelFns: Axes.makeLabelFns(ax, shift)
    });
  }

  // wait for the axis & title to finish rendering before
  // continuing positioning
  // TODO: why are we redrawing multiple times now with this?
  // I guess autoMargin doesn't like being post-promise?
  function positionCB() {
    var bb;
    var innerThickness = thickPx + outlinewidth / 2;
    if (ticklabelposition.indexOf('inside') === -1) {
      bb = Drawing.bBox(axLayer.node());
      innerThickness += isVertical ? bb.width : bb.height;
    }
    titleEl = titleCont.select('text');
    var titleWidth = 0;
    var topSideVertical = isVertical && titleSide === 'top';
    var rightSideHorizontal = !isVertical && titleSide === 'right';
    var moveY = 0;
    if (titleEl.node() && !titleEl.classed(cn.jsPlaceholder)) {
      var _titleHeight;
      var mathJaxNode = titleCont.select('.h' + ax._id + 'title-math-group').node();
      if (mathJaxNode && (isVertical && topOrBottom || !isVertical && !topOrBottom)) {
        bb = Drawing.bBox(mathJaxNode);
        titleWidth = bb.width;
        _titleHeight = bb.height;
      } else {
        // note: the formula below works for all title sides,
        // (except for top/bottom mathjax, above)
        // but the weird gs.l is because the titleunshift
        // transform gets removed by Drawing.bBox
        bb = Drawing.bBox(titleCont.node());
        titleWidth = bb.right - gs.l - (isVertical ? uPx : vPx);
        _titleHeight = bb.bottom - gs.t - (isVertical ? vPx : uPx);
        if (!isVertical && titleSide === 'top') {
          innerThickness += bb.height;
          moveY = bb.height;
        }
      }
      if (rightSideHorizontal) {
        titleEl.attr('transform', strTranslate(titleWidth / 2 + titleFontSize / 2, 0));
        titleWidth *= 2;
      }
      innerThickness = Math.max(innerThickness, isVertical ? titleWidth : _titleHeight);
    }
    var outerThickness = (isVertical ? xpad : ypad) * 2 + innerThickness + borderwidth + outlinewidth / 2;
    var hColorbarMoveTitle = 0;
    if (!isVertical && title.text && yanchor === 'bottom' && optsY <= 0) {
      hColorbarMoveTitle = outerThickness / 2;
      outerThickness += hColorbarMoveTitle;
      moveY += hColorbarMoveTitle;
    }
    fullLayout._hColorbarMoveTitle = hColorbarMoveTitle;
    fullLayout._hColorbarMoveCBTitle = moveY;
    var extraW = borderwidth + outlinewidth;

    // TODO - are these the correct positions?
    var lx = (isVertical ? uPx : vPx) - extraW / 2 - (isVertical ? xpad : 0);
    var ly = (isVertical ? vPx : uPx) - (isVertical ? lenPx : ypad + moveY - hColorbarMoveTitle);
    g.select('.' + cn.cbbg).attr('x', lx).attr('y', ly).attr(isVertical ? 'width' : 'height', Math.max(outerThickness - hColorbarMoveTitle, 2)).attr(isVertical ? 'height' : 'width', Math.max(lenPx + extraW, 2)).call(Color.fill, bgcolor).call(Color.stroke, opts.bordercolor).style('stroke-width', borderwidth);
    var moveX = rightSideHorizontal ? Math.max(titleWidth - 10, 0) : 0;
    g.selectAll('.' + cn.cboutline).attr('x', (isVertical ? uPx : vPx + xpad) + moveX).attr('y', (isVertical ? vPx + ypad - lenPx : uPx) + (topSideVertical ? titleHeight : 0)).attr(isVertical ? 'width' : 'height', Math.max(thickPx, 2)).attr(isVertical ? 'height' : 'width', Math.max(lenPx - (isVertical ? 2 * ypad + titleHeight : 2 * xpad + moveX), 2)).call(Color.stroke, opts.outlinecolor).style({
      fill: 'none',
      'stroke-width': outlinewidth
    });
    var xShift = isVertical ? xRatio * outerThickness : 0;
    var yShift = isVertical ? 0 : (1 - yRatio) * outerThickness - moveY;
    xShift = isPaperX ? gs.l - xShift : -xShift;
    yShift = isPaperY ? gs.t - yShift : -yShift;
    g.attr('transform', strTranslate(xShift, yShift));
    if (!isVertical && (borderwidth || tinycolor(bgcolor).getAlpha() && !tinycolor.equals(fullLayout.paper_bgcolor, bgcolor))) {
      // for horizontal colorbars when there is a border line or having different background color
      // hide/adjust x positioning for the first/last tick labels if they go outside the border
      var tickLabels = axLayer.selectAll('text');
      var numTicks = tickLabels[0].length;
      var border = g.select('.' + cn.cbbg).node();
      var oBb = Drawing.bBox(border);
      var oTr = Drawing.getTranslate(g);
      var TEXTPAD = 2;
      tickLabels.each(function (d, i) {
        var first = 0;
        var last = numTicks - 1;
        if (i === first || i === last) {
          var iBb = Drawing.bBox(this);
          var iTr = Drawing.getTranslate(this);
          var deltaX;
          if (i === last) {
            var iRight = iBb.right + iTr.x;
            var oRight = oBb.right + oTr.x + vPx - borderwidth - TEXTPAD + optsX;
            deltaX = oRight - iRight;
            if (deltaX > 0) deltaX = 0;
          } else if (i === first) {
            var iLeft = iBb.left + iTr.x;
            var oLeft = oBb.left + oTr.x + vPx + borderwidth + TEXTPAD;
            deltaX = oLeft - iLeft;
            if (deltaX < 0) deltaX = 0;
          }
          if (deltaX) {
            if (numTicks < 3) {
              // adjust position
              this.setAttribute('transform', 'translate(' + deltaX + ',0) ' + this.getAttribute('transform'));
            } else {
              // hide
              this.setAttribute('visibility', 'hidden');
            }
          }
        }
      });
    }

    // auto margin adjustment
    var marginOpts = {};
    var lFrac = FROM_TL[xanchor];
    var rFrac = FROM_BR[xanchor];
    var tFrac = FROM_TL[yanchor];
    var bFrac = FROM_BR[yanchor];
    var extraThickness = outerThickness - thickPx;
    if (isVertical) {
      if (lenmode === 'pixels') {
        marginOpts.y = optsY;
        marginOpts.t = lenPx * tFrac;
        marginOpts.b = lenPx * bFrac;
      } else {
        marginOpts.t = marginOpts.b = 0;
        marginOpts.yt = optsY + len * tFrac;
        marginOpts.yb = optsY - len * bFrac;
      }
      if (thicknessmode === 'pixels') {
        marginOpts.x = optsX;
        marginOpts.l = outerThickness * lFrac;
        marginOpts.r = outerThickness * rFrac;
      } else {
        marginOpts.l = extraThickness * lFrac;
        marginOpts.r = extraThickness * rFrac;
        marginOpts.xl = optsX - thickness * lFrac;
        marginOpts.xr = optsX + thickness * rFrac;
      }
    } else {
      // horizontal colorbars
      if (lenmode === 'pixels') {
        marginOpts.x = optsX;
        marginOpts.l = lenPx * lFrac;
        marginOpts.r = lenPx * rFrac;
      } else {
        marginOpts.l = marginOpts.r = 0;
        marginOpts.xl = optsX + len * lFrac;
        marginOpts.xr = optsX - len * rFrac;
      }
      if (thicknessmode === 'pixels') {
        marginOpts.y = 1 - optsY;
        marginOpts.t = outerThickness * tFrac;
        marginOpts.b = outerThickness * bFrac;
      } else {
        marginOpts.t = extraThickness * tFrac;
        marginOpts.b = extraThickness * bFrac;
        marginOpts.yt = optsY - thickness * tFrac;
        marginOpts.yb = optsY + thickness * bFrac;
      }
    }
    var sideY = opts.y < 0.5 ? 'b' : 't';
    var sideX = opts.x < 0.5 ? 'l' : 'r';
    gd._fullLayout._reservedMargin[opts._id] = {};
    var possibleReservedMargins = {
      r: fullLayout.width - lx - xShift,
      l: lx + marginOpts.r,
      b: fullLayout.height - ly - yShift,
      t: ly + marginOpts.b
    };
    if (isPaperX && isPaperY) {
      Plots.autoMargin(gd, opts._id, marginOpts);
    } else if (isPaperX) {
      gd._fullLayout._reservedMargin[opts._id][sideY] = possibleReservedMargins[sideY];
    } else if (isPaperY) {
      gd._fullLayout._reservedMargin[opts._id][sideX] = possibleReservedMargins[sideX];
    } else {
      if (isVertical) {
        gd._fullLayout._reservedMargin[opts._id][sideX] = possibleReservedMargins[sideX];
      } else {
        gd._fullLayout._reservedMargin[opts._id][sideY] = possibleReservedMargins[sideY];
      }
    }
  }
  return Lib.syncOrAsync([Plots.previousPromises, drawDummyTitle, drawAxis, drawCbTitle, Plots.previousPromises, positionCB], gd);
}
function makeEditable(g, opts, gd) {
  var isVertical = opts.orientation === 'v';
  var fullLayout = gd._fullLayout;
  var gs = fullLayout._size;
  var t0, xf, yf;
  dragElement.init({
    element: g.node(),
    gd: gd,
    prepFn: function () {
      t0 = g.attr('transform');
      setCursor(g);
    },
    moveFn: function (dx, dy) {
      g.attr('transform', t0 + strTranslate(dx, dy));
      xf = dragElement.align((isVertical ? opts._uFrac : opts._vFrac) + dx / gs.w, isVertical ? opts._thickFrac : opts._lenFrac, 0, 1, opts.xanchor);
      yf = dragElement.align((isVertical ? opts._vFrac : 1 - opts._uFrac) - dy / gs.h, isVertical ? opts._lenFrac : opts._thickFrac, 0, 1, opts.yanchor);
      var csr = dragElement.getCursor(xf, yf, opts.xanchor, opts.yanchor);
      setCursor(g, csr);
    },
    doneFn: function () {
      setCursor(g);
      if (xf !== undefined && yf !== undefined) {
        var update = {};
        update[opts._propPrefix + 'x'] = xf;
        update[opts._propPrefix + 'y'] = yf;
        if (opts._traceIndex !== undefined) {
          Registry.call('_guiRestyle', gd, update, opts._traceIndex);
        } else {
          Registry.call('_guiRelayout', gd, update);
        }
      }
    }
  });
}
function calcLevels(gd, opts, zrange) {
  var levelsIn = opts._levels;
  var lineLevels = [];
  var fillLevels = [];
  var l;
  var i;
  var l0 = levelsIn.end + levelsIn.size / 100;
  var ls = levelsIn.size;
  var zr0 = 1.001 * zrange[0] - 0.001 * zrange[1];
  var zr1 = 1.001 * zrange[1] - 0.001 * zrange[0];
  for (i = 0; i < 1e5; i++) {
    l = levelsIn.start + i * ls;
    if (ls > 0 ? l >= l0 : l <= l0) break;
    if (l > zr0 && l < zr1) lineLevels.push(l);
  }
  if (opts._fillgradient) {
    fillLevels = [0];
  } else if (typeof opts._fillcolor === 'function') {
    var fillLevelsIn = opts._filllevels;
    if (fillLevelsIn) {
      l0 = fillLevelsIn.end + fillLevelsIn.size / 100;
      ls = fillLevelsIn.size;
      for (i = 0; i < 1e5; i++) {
        l = fillLevelsIn.start + i * ls;
        if (ls > 0 ? l >= l0 : l <= l0) break;
        if (l > zrange[0] && l < zrange[1]) fillLevels.push(l);
      }
    } else {
      fillLevels = lineLevels.map(function (v) {
        return v - levelsIn.size / 2;
      });
      fillLevels.push(fillLevels[fillLevels.length - 1] + levelsIn.size);
    }
  } else if (opts._fillcolor && typeof opts._fillcolor === 'string') {
    // doesn't matter what this value is, with a single value
    // we'll make a single fill rect covering the whole bar
    fillLevels = [0];
  }
  if (levelsIn.size < 0) {
    lineLevels.reverse();
    fillLevels.reverse();
  }
  return {
    line: lineLevels,
    fill: fillLevels
  };
}
function mockColorBarAxis(gd, opts, zrange) {
  var fullLayout = gd._fullLayout;
  var isVertical = opts.orientation === 'v';
  var cbAxisIn = {
    type: 'linear',
    range: zrange,
    tickmode: opts.tickmode,
    nticks: opts.nticks,
    tick0: opts.tick0,
    dtick: opts.dtick,
    tickvals: opts.tickvals,
    ticktext: opts.ticktext,
    ticks: opts.ticks,
    ticklen: opts.ticklen,
    tickwidth: opts.tickwidth,
    tickcolor: opts.tickcolor,
    showticklabels: opts.showticklabels,
    labelalias: opts.labelalias,
    ticklabelposition: opts.ticklabelposition,
    ticklabeloverflow: opts.ticklabeloverflow,
    ticklabelstep: opts.ticklabelstep,
    tickfont: opts.tickfont,
    tickangle: opts.tickangle,
    tickformat: opts.tickformat,
    exponentformat: opts.exponentformat,
    minexponent: opts.minexponent,
    separatethousands: opts.separatethousands,
    showexponent: opts.showexponent,
    showtickprefix: opts.showtickprefix,
    tickprefix: opts.tickprefix,
    showticksuffix: opts.showticksuffix,
    ticksuffix: opts.ticksuffix,
    title: opts.title,
    showline: true,
    anchor: 'free',
    side: isVertical ? 'right' : 'bottom',
    position: 1
  };
  var letter = isVertical ? 'y' : 'x';
  var cbAxisOut = {
    type: 'linear',
    _id: letter + opts._id
  };
  var axisOptions = {
    letter: letter,
    font: fullLayout.font,
    noAutotickangles: letter === 'y',
    noHover: true,
    noTickson: true,
    noTicklabelmode: true,
    noInsideRange: true,
    calendar: fullLayout.calendar // not really necessary (yet?)
  };
  function coerce(attr, dflt) {
    return Lib.coerce(cbAxisIn, cbAxisOut, axisLayoutAttrs, attr, dflt);
  }
  handleAxisDefaults(cbAxisIn, cbAxisOut, coerce, axisOptions, fullLayout);
  handleAxisPositionDefaults(cbAxisIn, cbAxisOut, coerce, axisOptions);
  return cbAxisOut;
}
module.exports = {
  draw: draw
};

/***/ }),

/***/ 91362:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
module.exports = function hasColorbar(container) {
  return Lib.isPlainObject(container.colorbar);
};

/***/ }),

/***/ 96919:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = {
  moduleType: 'component',
  name: 'colorbar',
  attributes: __webpack_require__(25158),
  supplyDefaults: __webpack_require__(42097),
  draw: (__webpack_require__(5881).draw),
  hasColorbar: __webpack_require__(91362)
};

/***/ }),

/***/ 87163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var colorbarAttrs = __webpack_require__(25158);
var counterRegex = (__webpack_require__(90694).counter);
var sortObjectKeys = __webpack_require__(62994);
var palettes = (__webpack_require__(19017).scales);
var paletteStr = sortObjectKeys(palettes);
function code(s) {
  return '`' + s + '`';
}

/**
 * Make colorscale attribute declarations for
 *
 * - colorscale,
 * - (c|z)auto, (c|z)min, (c|z)max,
 * - autocolorscale, reversescale,
 * - showscale (optionally)
 * - color (optionally)
 *
 * @param {string} context (dflt: '', i.e. from trace root):
 *     the container this is in ('', *marker*, *marker.line* etc)
 *
 * @param {object} opts:
 *   - cLetter {string} (dflt: 'c'):
 *     leading letter for 'min', 'max and 'auto' attribute (either 'z' or 'c')
 *
 *   - colorAttr {string} (dflt: 'z' if `cLetter: 'z'`, 'color' if `cLetter: 'c'`):
 *     (for descriptions) sets the name of the color attribute that maps to the colorscale.
 *
 *     N.B. if `colorAttr: 'color'`, we include the `color` declaration here.
 *
 *   - onlyIfNumerical {string} (dflt: false' if `cLetter: 'z'`, true if `cLetter: 'c'`):
 *     (for descriptions) set to true if colorscale attribute only
 *
 *   - colorscaleDflt {string}:
 *     overrides the colorscale dflt
 *
 *   - autoColorDflt {boolean} (dflt true):
 *     normally autocolorscale.dflt is `true`, but pass `false` to override
 *
 *   - noScale {boolean} (dflt: true if `context: 'marker.line'`, false otherwise):
 *     set to `false` to not include showscale attribute (e.g. for 'marker.line')
 *
 *   - showScaleDflt {boolean} (dflt: true if `cLetter: 'z'`, false otherwise)
 *
 *   - editTypeOverride {boolean} (dflt: ''):
 *     most of these attributes already require a recalc, but the ones that do not
 *     have editType *style* or *plot* unless you override (presumably with *calc*)
 *
 *   - anim {boolean) (dflt: undefined): is 'color' animatable?
 *
 * @return {object}
 */
module.exports = function colorScaleAttrs(context, opts) {
  context = context || '';
  opts = opts || {};
  var cLetter = opts.cLetter || 'c';
  var onlyIfNumerical = 'onlyIfNumerical' in opts ? opts.onlyIfNumerical : Boolean(context);
  var noScale = 'noScale' in opts ? opts.noScale : context === 'marker.line';
  var showScaleDflt = 'showScaleDflt' in opts ? opts.showScaleDflt : cLetter === 'z';
  var colorscaleDflt = typeof opts.colorscaleDflt === 'string' ? palettes[opts.colorscaleDflt] : null;
  var editTypeOverride = opts.editTypeOverride || '';
  var contextHead = context ? context + '.' : '';
  var colorAttr, colorAttrFull;
  if ('colorAttr' in opts) {
    colorAttr = opts.colorAttr;
    colorAttrFull = opts.colorAttr;
  } else {
    colorAttr = {
      z: 'z',
      c: 'color'
    }[cLetter];
    colorAttrFull = 'in ' + code(contextHead + colorAttr);
  }
  var effectDesc = onlyIfNumerical ? ' Has an effect only if ' + colorAttrFull + ' is set to a numerical array.' : '';
  var auto = cLetter + 'auto';
  var min = cLetter + 'min';
  var max = cLetter + 'max';
  var mid = cLetter + 'mid';
  var autoFull = code(contextHead + auto);
  var minFull = code(contextHead + min);
  var maxFull = code(contextHead + max);
  var minmaxFull = minFull + ' and ' + maxFull;
  var autoImpliedEdits = {};
  autoImpliedEdits[min] = autoImpliedEdits[max] = undefined;
  var minmaxImpliedEdits = {};
  minmaxImpliedEdits[auto] = false;
  var attrs = {};
  if (colorAttr === 'color') {
    attrs.color = {
      valType: 'color',
      arrayOk: true,
      editType: editTypeOverride || 'style'
    };
    if (opts.anim) {
      attrs.color.anim = true;
    }
  }
  attrs[auto] = {
    valType: 'boolean',
    dflt: true,
    editType: 'calc',
    impliedEdits: autoImpliedEdits
  };
  attrs[min] = {
    valType: 'number',
    dflt: null,
    editType: editTypeOverride || 'plot',
    impliedEdits: minmaxImpliedEdits
  };
  attrs[max] = {
    valType: 'number',
    dflt: null,
    editType: editTypeOverride || 'plot',
    impliedEdits: minmaxImpliedEdits
  };
  attrs[mid] = {
    valType: 'number',
    dflt: null,
    editType: 'calc',
    impliedEdits: autoImpliedEdits
  };
  attrs.colorscale = {
    valType: 'colorscale',
    editType: 'calc',
    dflt: colorscaleDflt,
    impliedEdits: {
      autocolorscale: false
    }
  };
  attrs.autocolorscale = {
    valType: 'boolean',
    // gets overrode in 'heatmap' & 'surface' for backwards comp.
    dflt: opts.autoColorDflt === false ? false : true,
    editType: 'calc',
    impliedEdits: {
      colorscale: undefined
    }
  };
  attrs.reversescale = {
    valType: 'boolean',
    dflt: false,
    editType: 'plot'
  };
  if (!noScale) {
    attrs.showscale = {
      valType: 'boolean',
      dflt: showScaleDflt,
      editType: 'calc'
    };
    attrs.colorbar = colorbarAttrs;
  }
  if (!opts.noColorAxis) {
    attrs.coloraxis = {
      valType: 'subplotid',
      regex: counterRegex('coloraxis'),
      dflt: null,
      editType: 'calc'
    };
  }
  return attrs;
};

/***/ }),

/***/ 28379:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isNumeric = __webpack_require__(10721);
var Lib = __webpack_require__(34809);
var extractOpts = (__webpack_require__(65477).extractOpts);
module.exports = function calc(gd, trace, opts) {
  var fullLayout = gd._fullLayout;
  var vals = opts.vals;
  var containerStr = opts.containerStr;
  var container = containerStr ? Lib.nestedProperty(trace, containerStr).get() : trace;
  var cOpts = extractOpts(container);
  var auto = cOpts.auto !== false;
  var min = cOpts.min;
  var max = cOpts.max;
  var mid = cOpts.mid;
  var minVal = function () {
    return Lib.aggNums(Math.min, null, vals);
  };
  var maxVal = function () {
    return Lib.aggNums(Math.max, null, vals);
  };
  if (min === undefined) {
    min = minVal();
  } else if (auto) {
    if (container._colorAx && isNumeric(min)) {
      min = Math.min(min, minVal());
    } else {
      min = minVal();
    }
  }
  if (max === undefined) {
    max = maxVal();
  } else if (auto) {
    if (container._colorAx && isNumeric(max)) {
      max = Math.max(max, maxVal());
    } else {
      max = maxVal();
    }
  }
  if (auto && mid !== undefined) {
    if (max - mid > mid - min) {
      min = mid - (max - mid);
    } else if (max - mid < mid - min) {
      max = mid + (mid - min);
    }
  }
  if (min === max) {
    min -= 0.5;
    max += 0.5;
  }
  cOpts._sync('min', min);
  cOpts._sync('max', max);
  if (cOpts.autocolorscale) {
    var scl;
    if (min * max < 0) scl = fullLayout.colorscale.diverging;else if (min >= 0) scl = fullLayout.colorscale.sequential;else scl = fullLayout.colorscale.sequentialminus;
    cOpts._sync('colorscale', scl);
  }
};

/***/ }),

/***/ 67623:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var hasColorscale = (__webpack_require__(65477).hasColorscale);
var extractOpts = (__webpack_require__(65477).extractOpts);
module.exports = function crossTraceDefaults(fullData, fullLayout) {
  function replace(cont, k) {
    var val = cont['_' + k];
    if (val !== undefined) {
      cont[k] = val;
    }
  }
  function relinkColorAttrs(outerCont, cbOpt) {
    var cont = cbOpt.container ? Lib.nestedProperty(outerCont, cbOpt.container).get() : outerCont;
    if (cont) {
      if (cont.coloraxis) {
        // stash ref to color axis
        cont._colorAx = fullLayout[cont.coloraxis];
      } else {
        var cOpts = extractOpts(cont);
        var isAuto = cOpts.auto;
        if (isAuto || cOpts.min === undefined) {
          replace(cont, cbOpt.min);
        }
        if (isAuto || cOpts.max === undefined) {
          replace(cont, cbOpt.max);
        }
        if (cOpts.autocolorscale) {
          replace(cont, 'colorscale');
        }
      }
    }
  }
  for (var i = 0; i < fullData.length; i++) {
    var trace = fullData[i];
    var cbOpts = trace._module.colorbar;
    if (cbOpts) {
      if (Array.isArray(cbOpts)) {
        for (var j = 0; j < cbOpts.length; j++) {
          relinkColorAttrs(trace, cbOpts[j]);
        }
      } else {
        relinkColorAttrs(trace, cbOpts);
      }
    }
    if (hasColorscale(trace, 'marker.line')) {
      relinkColorAttrs(trace, {
        container: 'marker.line',
        min: 'cmin',
        max: 'cmax'
      });
    }
  }
  for (var k in fullLayout._colorAxes) {
    relinkColorAttrs(fullLayout[k], {
      min: 'cmin',
      max: 'cmax'
    });
  }
};

/***/ }),

/***/ 39356:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isNumeric = __webpack_require__(10721);
var Lib = __webpack_require__(34809);
var hasColorbar = __webpack_require__(91362);
var colorbarDefaults = __webpack_require__(42097);
var isValidScale = (__webpack_require__(19017).isValid);
var traceIs = (__webpack_require__(33626).traceIs);
function npMaybe(parentCont, prefix) {
  var containerStr = prefix.slice(0, prefix.length - 1);
  return prefix ? Lib.nestedProperty(parentCont, containerStr).get() || {} : parentCont;
}

/**
 * Colorscale / colorbar default handler
 *
 * @param {object} parentContIn : user (input) parent container (e.g. trace or layout coloraxis object)
 * @param {object} parentContOut : full parent container
 * @param {object} layout : (full) layout object
 * @param {fn} coerce : Lib.coerce wrapper
 * @param {object} opts :
 * - prefix {string} : attr string prefix to colorscale container from parent root
 * - cLetter {string} : 'c or 'z' color letter
 */
module.exports = function colorScaleDefaults(parentContIn, parentContOut, layout, coerce, opts) {
  var prefix = opts.prefix;
  var cLetter = opts.cLetter;
  var inTrace = '_module' in parentContOut;
  var containerIn = npMaybe(parentContIn, prefix);
  var containerOut = npMaybe(parentContOut, prefix);
  var template = npMaybe(parentContOut._template || {}, prefix) || {};

  // colorScaleDefaults wrapper called if-ever we need to reset the colorscale
  // attributes for containers that were linked to invalid color axes
  var thisFn = function () {
    delete parentContIn.coloraxis;
    delete parentContOut.coloraxis;
    return colorScaleDefaults(parentContIn, parentContOut, layout, coerce, opts);
  };
  if (inTrace) {
    var colorAxes = layout._colorAxes || {};
    var colorAx = coerce(prefix + 'coloraxis');
    if (colorAx) {
      var colorbarVisuals = traceIs(parentContOut, 'contour') && Lib.nestedProperty(parentContOut, 'contours.coloring').get() || 'heatmap';
      var stash = colorAxes[colorAx];
      if (stash) {
        stash[2].push(thisFn);
        if (stash[0] !== colorbarVisuals) {
          stash[0] = false;
          Lib.warn(['Ignoring coloraxis:', colorAx, 'setting', 'as it is linked to incompatible colorscales.'].join(' '));
        }
      } else {
        // stash:
        // - colorbar visual 'type'
        // - colorbar options to help in Colorbar.draw
        // - list of colorScaleDefaults wrapper functions
        colorAxes[colorAx] = [colorbarVisuals, parentContOut, [thisFn]];
      }
      return;
    }
  }
  var minIn = containerIn[cLetter + 'min'];
  var maxIn = containerIn[cLetter + 'max'];
  var validMinMax = isNumeric(minIn) && isNumeric(maxIn) && minIn < maxIn;
  var auto = coerce(prefix + cLetter + 'auto', !validMinMax);
  if (auto) {
    coerce(prefix + cLetter + 'mid');
  } else {
    coerce(prefix + cLetter + 'min');
    coerce(prefix + cLetter + 'max');
  }

  // handles both the trace case (autocolorscale is false by default) and
  // the marker and marker.line case (autocolorscale is true by default)
  var sclIn = containerIn.colorscale;
  var sclTemplate = template.colorscale;
  var autoColorscaleDflt;
  if (sclIn !== undefined) autoColorscaleDflt = !isValidScale(sclIn);
  if (sclTemplate !== undefined) autoColorscaleDflt = !isValidScale(sclTemplate);
  coerce(prefix + 'autocolorscale', autoColorscaleDflt);
  coerce(prefix + 'colorscale');
  coerce(prefix + 'reversescale');
  if (prefix !== 'marker.line.') {
    // handles both the trace case where the dflt is listed in attributes and
    // the marker case where the dflt is determined by hasColorbar
    var showScaleDflt;
    if (prefix && inTrace) showScaleDflt = hasColorbar(containerIn);
    var showScale = coerce(prefix + 'showscale', showScaleDflt);
    if (showScale) {
      if (prefix && template) containerOut._template = template;
      colorbarDefaults(containerIn, containerOut, layout);
    }
  }
};

/***/ }),

/***/ 65477:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var tinycolor = __webpack_require__(65657);
var isNumeric = __webpack_require__(10721);
var Lib = __webpack_require__(34809);
var Color = __webpack_require__(78766);
var isValidScale = (__webpack_require__(19017).isValid);
function hasColorscale(trace, containerStr, colorKey) {
  var container = containerStr ? Lib.nestedProperty(trace, containerStr).get() || {} : trace;
  var color = container[colorKey || 'color'];
  if (color && color._inputArray) color = color._inputArray;
  var isArrayWithOneNumber = false;
  if (Lib.isArrayOrTypedArray(color)) {
    for (var i = 0; i < color.length; i++) {
      if (isNumeric(color[i])) {
        isArrayWithOneNumber = true;
        break;
      }
    }
  }
  return Lib.isPlainObject(container) && (isArrayWithOneNumber || container.showscale === true || isNumeric(container.cmin) && isNumeric(container.cmax) || isValidScale(container.colorscale) || Lib.isPlainObject(container.colorbar));
}
var constantAttrs = ['showscale', 'autocolorscale', 'colorscale', 'reversescale', 'colorbar'];
var letterAttrs = ['min', 'max', 'mid', 'auto'];

/**
 * Extract 'c' / 'z', trace / color axis colorscale options
 *
 * Note that it would be nice to replace all z* with c* equivalents in v3
 *
 * @param {object} cont : attribute container
 * @return {object}:
 *  - min: cmin or zmin
 *  - max: cmax or zmax
 *  - mid: cmid or zmid
 *  - auto: cauto or zauto
 *  - *scale: *scale attrs
 *  - colorbar: colorbar
 *  - _sync: function syncing attr and underscore dual (useful when calc'ing min/max)
 */
function extractOpts(cont) {
  var colorAx = cont._colorAx;
  var cont2 = colorAx ? colorAx : cont;
  var out = {};
  var cLetter;
  var i, k;
  for (i = 0; i < constantAttrs.length; i++) {
    k = constantAttrs[i];
    out[k] = cont2[k];
  }
  if (colorAx) {
    cLetter = 'c';
    for (i = 0; i < letterAttrs.length; i++) {
      k = letterAttrs[i];
      out[k] = cont2['c' + k];
    }
  } else {
    var k2;
    for (i = 0; i < letterAttrs.length; i++) {
      k = letterAttrs[i];
      k2 = 'c' + k;
      if (k2 in cont2) {
        out[k] = cont2[k2];
        continue;
      }
      k2 = 'z' + k;
      if (k2 in cont2) {
        out[k] = cont2[k2];
      }
    }
    cLetter = k2.charAt(0);
  }
  out._sync = function (k, v) {
    var k2 = letterAttrs.indexOf(k) !== -1 ? cLetter + k : k;
    cont2[k2] = cont2['_' + k2] = v;
  };
  return out;
}

/**
 * Extract colorscale into numeric domain and color range.
 *
 * @param {object} cont colorscale container (e.g. trace, marker)
 *  - colorscale {array of arrays}
 *  - cmin/zmin {number}
 *  - cmax/zmax {number}
 *  - reversescale {boolean}
 *
 * @return {object}
 *  - domain {array}
 *  - range {array}
 */
function extractScale(cont) {
  var cOpts = extractOpts(cont);
  var cmin = cOpts.min;
  var cmax = cOpts.max;
  var scl = cOpts.reversescale ? flipScale(cOpts.colorscale) : cOpts.colorscale;
  var N = scl.length;
  var domain = new Array(N);
  var range = new Array(N);
  for (var i = 0; i < N; i++) {
    var si = scl[i];
    domain[i] = cmin + si[0] * (cmax - cmin);
    range[i] = si[1];
  }
  return {
    domain: domain,
    range: range
  };
}
function flipScale(scl) {
  var N = scl.length;
  var sclNew = new Array(N);
  for (var i = N - 1, j = 0; i >= 0; i--, j++) {
    var si = scl[i];
    sclNew[j] = [1 - si[0], si[1]];
  }
  return sclNew;
}

/**
 * General colorscale function generator.
 *
 * @param {object} specs output of Colorscale.extractScale or precomputed domain, range.
 *  - domain {array}
 *  - range {array}
 *
 * @param {object} opts
 *  - noNumericCheck {boolean} if true, scale func bypasses numeric checks
 *  - returnArray {boolean} if true, scale func return 4-item array instead of color strings
 *
 * @return {function}
 */
function makeColorScaleFunc(specs, opts) {
  opts = opts || {};
  var domain = specs.domain;
  var range = specs.range;
  var N = range.length;
  var _range = new Array(N);
  for (var i = 0; i < N; i++) {
    var rgba = tinycolor(range[i]).toRgb();
    _range[i] = [rgba.r, rgba.g, rgba.b, rgba.a];
  }
  var _sclFunc = d3.scale.linear().domain(domain).range(_range).clamp(true);
  var noNumericCheck = opts.noNumericCheck;
  var returnArray = opts.returnArray;
  var sclFunc;
  if (noNumericCheck && returnArray) {
    sclFunc = _sclFunc;
  } else if (noNumericCheck) {
    sclFunc = function (v) {
      return colorArray2rbga(_sclFunc(v));
    };
  } else if (returnArray) {
    sclFunc = function (v) {
      if (isNumeric(v)) return _sclFunc(v);else if (tinycolor(v).isValid()) return v;else return Color.defaultLine;
    };
  } else {
    sclFunc = function (v) {
      if (isNumeric(v)) return colorArray2rbga(_sclFunc(v));else if (tinycolor(v).isValid()) return v;else return Color.defaultLine;
    };
  }

  // colorbar draw looks into the d3 scale closure for domain and range
  sclFunc.domain = _sclFunc.domain;
  sclFunc.range = function () {
    return range;
  };
  return sclFunc;
}
function makeColorScaleFuncFromTrace(trace, opts) {
  return makeColorScaleFunc(extractScale(trace), opts);
}
function colorArray2rbga(colorArray) {
  var colorObj = {
    r: colorArray[0],
    g: colorArray[1],
    b: colorArray[2],
    a: colorArray[3]
  };
  return tinycolor(colorObj).toRgbString();
}
module.exports = {
  hasColorscale: hasColorscale,
  extractOpts: extractOpts,
  extractScale: extractScale,
  flipScale: flipScale,
  makeColorScaleFunc: makeColorScaleFunc,
  makeColorScaleFuncFromTrace: makeColorScaleFuncFromTrace
};

/***/ }),

/***/ 88856:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var scales = __webpack_require__(19017);
var helpers = __webpack_require__(65477);
module.exports = {
  moduleType: 'component',
  name: 'colorscale',
  attributes: __webpack_require__(87163),
  layoutAttributes: __webpack_require__(56978),
  supplyLayoutDefaults: __webpack_require__(64613),
  handleDefaults: __webpack_require__(39356),
  crossTraceDefaults: __webpack_require__(67623),
  calc: __webpack_require__(28379),
  // ./scales.js is required in lib/coerce.js ;
  // it needs to be a separate module to avoid a circular dependency
  scales: scales.scales,
  defaultScale: scales.defaultScale,
  getScale: scales.get,
  isValidScale: scales.isValid,
  hasColorscale: helpers.hasColorscale,
  extractOpts: helpers.extractOpts,
  extractScale: helpers.extractScale,
  flipScale: helpers.flipScale,
  makeColorScaleFunc: helpers.makeColorScaleFunc,
  makeColorScaleFuncFromTrace: helpers.makeColorScaleFuncFromTrace
};

/***/ }),

/***/ 56978:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var extendFlat = (__webpack_require__(93049).extendFlat);
var colorScaleAttrs = __webpack_require__(87163);
var scales = (__webpack_require__(19017).scales);
var msg = 'Note that `autocolorscale` must be true for this attribute to work.';
module.exports = {
  editType: 'calc',
  colorscale: {
    editType: 'calc',
    sequential: {
      valType: 'colorscale',
      dflt: scales.Reds,
      editType: 'calc'
    },
    sequentialminus: {
      valType: 'colorscale',
      dflt: scales.Blues,
      editType: 'calc'
    },
    diverging: {
      valType: 'colorscale',
      dflt: scales.RdBu,
      editType: 'calc'
    }
  },
  coloraxis: extendFlat({
    // not really a 'subplot' attribute container,
    // but this is the flag we use to denote attributes that
    // support yaxis, yaxis2, yaxis3, ... counters
    _isSubplotObj: true,
    editType: 'calc'
  }, colorScaleAttrs('', {
    colorAttr: 'corresponding trace color array(s)',
    noColorAxis: true,
    showScaleDflt: true
  }))
};

/***/ }),

/***/ 64613:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var Template = __webpack_require__(78032);
var colorScaleAttrs = __webpack_require__(56978);
var colorScaleDefaults = __webpack_require__(39356);
module.exports = function supplyLayoutDefaults(layoutIn, layoutOut) {
  function coerce(attr, dflt) {
    return Lib.coerce(layoutIn, layoutOut, colorScaleAttrs, attr, dflt);
  }
  coerce('colorscale.sequential');
  coerce('colorscale.sequentialminus');
  coerce('colorscale.diverging');
  var colorAxes = layoutOut._colorAxes;
  var colorAxIn, colorAxOut;
  function coerceAx(attr, dflt) {
    return Lib.coerce(colorAxIn, colorAxOut, colorScaleAttrs.coloraxis, attr, dflt);
  }
  for (var k in colorAxes) {
    var stash = colorAxes[k];
    if (stash[0]) {
      colorAxIn = layoutIn[k] || {};
      colorAxOut = Template.newContainer(layoutOut, k, 'coloraxis');
      colorAxOut._name = k;
      colorScaleDefaults(colorAxIn, colorAxOut, layoutOut, coerceAx, {
        prefix: '',
        cLetter: 'c'
      });
    } else {
      // re-coerce colorscale attributes w/o coloraxis
      for (var i = 0; i < stash[2].length; i++) {
        stash[2][i]();
      }
      delete layoutOut._colorAxes[k];
    }
  }
};

/***/ }),

/***/ 19017:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var tinycolor = __webpack_require__(65657);
var scales = {
  Greys: [[0, 'rgb(0,0,0)'], [1, 'rgb(255,255,255)']],
  YlGnBu: [[0, 'rgb(8,29,88)'], [0.125, 'rgb(37,52,148)'], [0.25, 'rgb(34,94,168)'], [0.375, 'rgb(29,145,192)'], [0.5, 'rgb(65,182,196)'], [0.625, 'rgb(127,205,187)'], [0.75, 'rgb(199,233,180)'], [0.875, 'rgb(237,248,217)'], [1, 'rgb(255,255,217)']],
  Greens: [[0, 'rgb(0,68,27)'], [0.125, 'rgb(0,109,44)'], [0.25, 'rgb(35,139,69)'], [0.375, 'rgb(65,171,93)'], [0.5, 'rgb(116,196,118)'], [0.625, 'rgb(161,217,155)'], [0.75, 'rgb(199,233,192)'], [0.875, 'rgb(229,245,224)'], [1, 'rgb(247,252,245)']],
  YlOrRd: [[0, 'rgb(128,0,38)'], [0.125, 'rgb(189,0,38)'], [0.25, 'rgb(227,26,28)'], [0.375, 'rgb(252,78,42)'], [0.5, 'rgb(253,141,60)'], [0.625, 'rgb(254,178,76)'], [0.75, 'rgb(254,217,118)'], [0.875, 'rgb(255,237,160)'], [1, 'rgb(255,255,204)']],
  Bluered: [[0, 'rgb(0,0,255)'], [1, 'rgb(255,0,0)']],
  // modified RdBu based on
  // http://www.kennethmoreland.com/color-maps/
  RdBu: [[0, 'rgb(5,10,172)'], [0.35, 'rgb(106,137,247)'], [0.5, 'rgb(190,190,190)'], [0.6, 'rgb(220,170,132)'], [0.7, 'rgb(230,145,90)'], [1, 'rgb(178,10,28)']],
  // Scale for non-negative numeric values
  Reds: [[0, 'rgb(220,220,220)'], [0.2, 'rgb(245,195,157)'], [0.4, 'rgb(245,160,105)'], [1, 'rgb(178,10,28)']],
  // Scale for non-positive numeric values
  Blues: [[0, 'rgb(5,10,172)'], [0.35, 'rgb(40,60,190)'], [0.5, 'rgb(70,100,245)'], [0.6, 'rgb(90,120,245)'], [0.7, 'rgb(106,137,247)'], [1, 'rgb(220,220,220)']],
  Picnic: [[0, 'rgb(0,0,255)'], [0.1, 'rgb(51,153,255)'], [0.2, 'rgb(102,204,255)'], [0.3, 'rgb(153,204,255)'], [0.4, 'rgb(204,204,255)'], [0.5, 'rgb(255,255,255)'], [0.6, 'rgb(255,204,255)'], [0.7, 'rgb(255,153,255)'], [0.8, 'rgb(255,102,204)'], [0.9, 'rgb(255,102,102)'], [1, 'rgb(255,0,0)']],
  Rainbow: [[0, 'rgb(150,0,90)'], [0.125, 'rgb(0,0,200)'], [0.25, 'rgb(0,25,255)'], [0.375, 'rgb(0,152,255)'], [0.5, 'rgb(44,255,150)'], [0.625, 'rgb(151,255,0)'], [0.75, 'rgb(255,234,0)'], [0.875, 'rgb(255,111,0)'], [1, 'rgb(255,0,0)']],
  Portland: [[0, 'rgb(12,51,131)'], [0.25, 'rgb(10,136,186)'], [0.5, 'rgb(242,211,56)'], [0.75, 'rgb(242,143,56)'], [1, 'rgb(217,30,30)']],
  Jet: [[0, 'rgb(0,0,131)'], [0.125, 'rgb(0,60,170)'], [0.375, 'rgb(5,255,255)'], [0.625, 'rgb(255,255,0)'], [0.875, 'rgb(250,0,0)'], [1, 'rgb(128,0,0)']],
  Hot: [[0, 'rgb(0,0,0)'], [0.3, 'rgb(230,0,0)'], [0.6, 'rgb(255,210,0)'], [1, 'rgb(255,255,255)']],
  Blackbody: [[0, 'rgb(0,0,0)'], [0.2, 'rgb(230,0,0)'], [0.4, 'rgb(230,210,0)'], [0.7, 'rgb(255,255,255)'], [1, 'rgb(160,200,255)']],
  Earth: [[0, 'rgb(0,0,130)'], [0.1, 'rgb(0,180,180)'], [0.2, 'rgb(40,210,40)'], [0.4, 'rgb(230,230,50)'], [0.6, 'rgb(120,70,20)'], [1, 'rgb(255,255,255)']],
  Electric: [[0, 'rgb(0,0,0)'], [0.15, 'rgb(30,0,100)'], [0.4, 'rgb(120,0,100)'], [0.6, 'rgb(160,90,0)'], [0.8, 'rgb(230,200,0)'], [1, 'rgb(255,250,220)']],
  Viridis: [[0, '#440154'], [0.06274509803921569, '#48186a'], [0.12549019607843137, '#472d7b'], [0.18823529411764706, '#424086'], [0.25098039215686274, '#3b528b'], [0.3137254901960784, '#33638d'], [0.3764705882352941, '#2c728e'], [0.4392156862745098, '#26828e'], [0.5019607843137255, '#21918c'], [0.5647058823529412, '#1fa088'], [0.6274509803921569, '#28ae80'], [0.6901960784313725, '#3fbc73'], [0.7529411764705882, '#5ec962'], [0.8156862745098039, '#84d44b'], [0.8784313725490196, '#addc30'], [0.9411764705882353, '#d8e219'], [1, '#fde725']],
  Cividis: [[0.000000, 'rgb(0,32,76)'], [0.058824, 'rgb(0,42,102)'], [0.117647, 'rgb(0,52,110)'], [0.176471, 'rgb(39,63,108)'], [0.235294, 'rgb(60,74,107)'], [0.294118, 'rgb(76,85,107)'], [0.352941, 'rgb(91,95,109)'], [0.411765, 'rgb(104,106,112)'], [0.470588, 'rgb(117,117,117)'], [0.529412, 'rgb(131,129,120)'], [0.588235, 'rgb(146,140,120)'], [0.647059, 'rgb(161,152,118)'], [0.705882, 'rgb(176,165,114)'], [0.764706, 'rgb(192,177,109)'], [0.823529, 'rgb(209,191,102)'], [0.882353, 'rgb(225,204,92)'], [0.941176, 'rgb(243,219,79)'], [1.000000, 'rgb(255,233,69)']]
};
var defaultScale = scales.RdBu;
function getScale(scl, dflt) {
  if (!dflt) dflt = defaultScale;
  if (!scl) return dflt;
  function parseScale() {
    try {
      scl = scales[scl] || JSON.parse(scl);
    } catch (e) {
      scl = dflt;
    }
  }
  if (typeof scl === 'string') {
    parseScale();
    // occasionally scl is double-JSON encoded...
    if (typeof scl === 'string') parseScale();
  }
  if (!isValidScaleArray(scl)) return dflt;
  return scl;
}
function isValidScaleArray(scl) {
  var highestVal = 0;
  if (!Array.isArray(scl) || scl.length < 2) return false;
  if (!scl[0] || !scl[scl.length - 1]) return false;
  if (+scl[0][0] !== 0 || +scl[scl.length - 1][0] !== 1) return false;
  for (var i = 0; i < scl.length; i++) {
    var si = scl[i];
    if (si.length !== 2 || +si[0] < highestVal || !tinycolor(si[1]).isValid()) {
      return false;
    }
    highestVal = +si[0];
  }
  return true;
}
function isValidScale(scl) {
  if (scales[scl] !== undefined) return true;else return isValidScaleArray(scl);
}
module.exports = {
  scales: scales,
  defaultScale: defaultScale,
  get: getScale,
  isValid: isValidScale
};

/***/ }),

/***/ 53770:
/***/ (function(module) {

"use strict";


// for automatic alignment on dragging, <1/3 means left align,
// >2/3 means right, and between is center. Pick the right fraction
// based on where you are, and return the fraction corresponding to
// that position on the object
module.exports = function align(v, dv, v0, v1, anchor) {
  var vmin = (v - v0) / (v1 - v0);
  var vmax = vmin + dv / (v1 - v0);
  var vc = (vmin + vmax) / 2;

  // explicitly specified anchor
  if (anchor === 'left' || anchor === 'bottom') return vmin;
  if (anchor === 'center' || anchor === 'middle') return vc;
  if (anchor === 'right' || anchor === 'top') return vmax;

  // automatic based on position
  if (vmin < 2 / 3 - vc) return vmin;
  if (vmax > 4 / 3 - vc) return vmax;
  return vc;
};

/***/ }),

/***/ 4001:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);

// set cursors pointing toward the closest corner/side,
// to indicate alignment
// x and y are 0-1, fractions of the plot area
var cursorset = [['sw-resize', 's-resize', 'se-resize'], ['w-resize', 'move', 'e-resize'], ['nw-resize', 'n-resize', 'ne-resize']];
module.exports = function getCursor(x, y, xanchor, yanchor) {
  if (xanchor === 'left') x = 0;else if (xanchor === 'center') x = 1;else if (xanchor === 'right') x = 2;else x = Lib.constrain(Math.floor(x * 3), 0, 2);
  if (yanchor === 'bottom') y = 0;else if (yanchor === 'middle') y = 1;else if (yanchor === 'top') y = 2;else y = Lib.constrain(Math.floor(y * 3), 0, 2);
  return cursorset[y][x];
};

/***/ }),

/***/ 70414:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


exports.selectMode = function (dragmode) {
  return dragmode === 'lasso' || dragmode === 'select';
};
exports.drawMode = function (dragmode) {
  return dragmode === 'drawclosedpath' || dragmode === 'drawopenpath' || dragmode === 'drawline' || dragmode === 'drawrect' || dragmode === 'drawcircle';
};
exports.openMode = function (dragmode) {
  return dragmode === 'drawline' || dragmode === 'drawopenpath';
};
exports.rectMode = function (dragmode) {
  return dragmode === 'select' || dragmode === 'drawline' || dragmode === 'drawrect' || dragmode === 'drawcircle';
};
exports.freeMode = function (dragmode) {
  return dragmode === 'lasso' || dragmode === 'drawclosedpath' || dragmode === 'drawopenpath';
};
exports.selectingOrDrawing = function (dragmode) {
  return exports.freeMode(dragmode) || exports.rectMode(dragmode);
};

/***/ }),

/***/ 14751:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var mouseOffset = __webpack_require__(44039);
var hasHover = __webpack_require__(39784);
var supportsPassive = __webpack_require__(74043);
var removeElement = (__webpack_require__(34809).removeElement);
var constants = __webpack_require__(54826);
var dragElement = module.exports = {};
dragElement.align = __webpack_require__(53770);
dragElement.getCursor = __webpack_require__(4001);
var unhover = __webpack_require__(60148);
dragElement.unhover = unhover.wrapped;
dragElement.unhoverRaw = unhover.raw;

/**
 * Abstracts click & drag interactions
 *
 * During the interaction, a "coverSlip" element - a transparent
 * div covering the whole page - is created, which has two key effects:
 * - Lets you drag beyond the boundaries of the plot itself without
 *   dropping (but if you drag all the way out of the browser window the
 *   interaction will end)
 * - Freezes the cursor: whatever mouse cursor the drag element had when the
 *   interaction started gets copied to the coverSlip for use until mouseup
 *
 * If the user executes a drag bigger than MINDRAG, callbacks will fire as:
 *      prepFn, moveFn (1 or more times), doneFn
 * If the user does not drag enough, prepFn and clickFn will fire.
 *
 * Note: If you cancel contextmenu, clickFn will fire even with a right click
 * (unlike native events) so you'll get a `plotly_click` event. Cancel context eg:
 *    gd.addEventListener('contextmenu', function(e) { e.preventDefault(); });
 * TODO: we should probably turn this into a `config` parameter, so we can fix it
 * such that if you *don't* cancel contextmenu, we can prevent partial drags, which
 * put you in a weird state.
 *
 * If the user clicks multiple times quickly, clickFn will fire each time
 * but numClicks will increase to help you recognize doubleclicks.
 *
 * @param {object} options with keys:
 *      element (required) the DOM element to drag
 *      prepFn (optional) function(event, startX, startY)
 *          executed on mousedown
 *          startX and startY are the clientX and clientY pixel position
 *          of the mousedown event
 *      moveFn (optional) function(dx, dy)
 *          executed on move, ONLY after we've exceeded MINDRAG
 *          (we keep executing moveFn if you move back to where you started)
 *          dx and dy are the net pixel offset of the drag,
 *          dragged is true/false, has the mouse moved enough to
 *          constitute a drag
 *      doneFn (optional) function(e)
 *          executed on mouseup, ONLY if we exceeded MINDRAG (so you can be
 *          sure that moveFn has been called at least once)
 *          numClicks is how many clicks we've registered within
 *          a doubleclick time
 *          e is the original mouseup event
 *      clickFn (optional) function(numClicks, e)
 *          executed on mouseup if we have NOT exceeded MINDRAG (ie moveFn
 *          has not been called at all)
 *          numClicks is how many clicks we've registered within
 *          a doubleclick time
 *          e is the original mousedown event
 *      clampFn (optional, function(dx, dy) return [dx2, dy2])
 *          Provide custom clamping function for small displacements.
 *          By default, clamping is done using `minDrag` to x and y displacements
 *          independently.
 */
dragElement.init = function init(options) {
  var gd = options.gd;
  var numClicks = 1;
  var doubleClickDelay = gd._context.doubleClickDelay;
  var element = options.element;
  var startX, startY, newMouseDownTime, cursor, dragCover, initialEvent, initialTarget, rightClick;
  if (!gd._mouseDownTime) gd._mouseDownTime = 0;
  element.style.pointerEvents = 'all';
  element.onmousedown = onStart;
  if (!supportsPassive) {
    element.ontouchstart = onStart;
  } else {
    if (element._ontouchstart) {
      element.removeEventListener('touchstart', element._ontouchstart);
    }
    element._ontouchstart = onStart;
    element.addEventListener('touchstart', onStart, {
      passive: false
    });
  }
  function _clampFn(dx, dy, minDrag) {
    if (Math.abs(dx) < minDrag) dx = 0;
    if (Math.abs(dy) < minDrag) dy = 0;
    return [dx, dy];
  }
  var clampFn = options.clampFn || _clampFn;
  function onStart(e) {
    // make dragging and dragged into properties of gd
    // so that others can look at and modify them
    gd._dragged = false;
    gd._dragging = true;
    var offset = pointerOffset(e);
    startX = offset[0];
    startY = offset[1];
    initialTarget = e.target;
    initialEvent = e;
    rightClick = e.buttons === 2 || e.ctrlKey;

    // fix Fx.hover for touch events
    if (typeof e.clientX === 'undefined' && typeof e.clientY === 'undefined') {
      e.clientX = startX;
      e.clientY = startY;
    }
    newMouseDownTime = new Date().getTime();
    if (newMouseDownTime - gd._mouseDownTime < doubleClickDelay) {
      // in a click train
      numClicks += 1;
    } else {
      // new click train
      numClicks = 1;
      gd._mouseDownTime = newMouseDownTime;
    }
    if (options.prepFn) options.prepFn(e, startX, startY);
    if (hasHover && !rightClick) {
      dragCover = coverSlip();
      dragCover.style.cursor = window.getComputedStyle(element).cursor;
    } else if (!hasHover) {
      // document acts as a dragcover for mobile, bc we can't create dragcover dynamically
      dragCover = document;
      cursor = window.getComputedStyle(document.documentElement).cursor;
      document.documentElement.style.cursor = window.getComputedStyle(element).cursor;
    }
    document.addEventListener('mouseup', onDone);
    document.addEventListener('touchend', onDone);
    if (options.dragmode !== false) {
      e.preventDefault();
      document.addEventListener('mousemove', onMove);
      document.addEventListener('touchmove', onMove, {
        passive: false
      });
    }
    return;
  }
  function onMove(e) {
    e.preventDefault();
    var offset = pointerOffset(e);
    var minDrag = options.minDrag || constants.MINDRAG;
    var dxdy = clampFn(offset[0] - startX, offset[1] - startY, minDrag);
    var dx = dxdy[0];
    var dy = dxdy[1];
    if (dx || dy) {
      gd._dragged = true;
      dragElement.unhover(gd, e);
    }
    if (gd._dragged && options.moveFn && !rightClick) {
      gd._dragdata = {
        element: element,
        dx: dx,
        dy: dy
      };
      options.moveFn(dx, dy);
    }
    return;
  }
  function onDone(e) {
    delete gd._dragdata;
    if (options.dragmode !== false) {
      e.preventDefault();
      document.removeEventListener('mousemove', onMove);
      document.removeEventListener('touchmove', onMove);
    }
    document.removeEventListener('mouseup', onDone);
    document.removeEventListener('touchend', onDone);
    if (hasHover) {
      removeElement(dragCover);
    } else if (cursor) {
      dragCover.documentElement.style.cursor = cursor;
      cursor = null;
    }
    if (!gd._dragging) {
      gd._dragged = false;
      return;
    }
    gd._dragging = false;

    // don't count as a dblClick unless the mouseUp is also within
    // the dblclick delay
    if (new Date().getTime() - gd._mouseDownTime > doubleClickDelay) {
      numClicks = Math.max(numClicks - 1, 1);
    }
    if (gd._dragged) {
      if (options.doneFn) options.doneFn();
    } else {
      if (options.clickFn) options.clickFn(numClicks, initialEvent);

      // If we haven't dragged, this should be a click. But because of the
      // coverSlip changing the element, the natural system might not generate one,
      // so we need to make our own. But right clicks don't normally generate
      // click events, only contextmenu events, which happen on mousedown.
      if (!rightClick) {
        var e2;
        try {
          e2 = new MouseEvent('click', e);
        } catch (err) {
          var offset = pointerOffset(e);
          e2 = document.createEvent('MouseEvents');
          e2.initMouseEvent('click', e.bubbles, e.cancelable, e.view, e.detail, e.screenX, e.screenY, offset[0], offset[1], e.ctrlKey, e.altKey, e.shiftKey, e.metaKey, e.button, e.relatedTarget);
        }
        initialTarget.dispatchEvent(e2);
      }
    }
    gd._dragging = false;
    gd._dragged = false;
    return;
  }
};
function coverSlip() {
  var cover = document.createElement('div');
  cover.className = 'dragcover';
  var cStyle = cover.style;
  cStyle.position = 'fixed';
  cStyle.left = 0;
  cStyle.right = 0;
  cStyle.top = 0;
  cStyle.bottom = 0;
  cStyle.zIndex = 999999999;
  cStyle.background = 'none';
  document.body.appendChild(cover);
  return cover;
}
dragElement.coverSlip = coverSlip;
function pointerOffset(e) {
  return mouseOffset(e.changedTouches ? e.changedTouches[0] : e, document.body);
}

/***/ }),

/***/ 60148:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Events = __webpack_require__(68596);
var throttle = __webpack_require__(64025);
var getGraphDiv = (__webpack_require__(95425).getGraphDiv);
var hoverConstants = __webpack_require__(85988);
var unhover = module.exports = {};
unhover.wrapped = function (gd, evt, subplot) {
  gd = getGraphDiv(gd);

  // Important, clear any queued hovers
  if (gd._fullLayout) {
    throttle.clear(gd._fullLayout._uid + hoverConstants.HOVERID);
  }
  unhover.raw(gd, evt, subplot);
};

// remove hover effects on mouse out, and emit unhover event
unhover.raw = function raw(gd, evt) {
  var fullLayout = gd._fullLayout;
  var oldhoverdata = gd._hoverdata;
  if (!evt) evt = {};
  if (evt.target && !gd._dragged && Events.triggerHandler(gd, 'plotly_beforehover', evt) === false) {
    return;
  }
  fullLayout._hoverlayer.selectAll('g').remove();
  fullLayout._hoverlayer.selectAll('line').remove();
  fullLayout._hoverlayer.selectAll('circle').remove();
  gd._hoverdata = undefined;
  if (evt.target && oldhoverdata) {
    gd.emit('plotly_unhover', {
      event: evt,
      points: oldhoverdata
    });
  }
};

/***/ }),

/***/ 94850:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


exports.T = {
  valType: 'string',
  // string type usually doesn't take values... this one should really be
  // a special type or at least a special coercion function, from the GUI
  // you only get these values but elsewhere the user can supply a list of
  // dash lengths in px, and it will be honored
  values: ['solid', 'dot', 'dash', 'longdash', 'dashdot', 'longdashdot'],
  dflt: 'solid',
  editType: 'style'
};
exports.k = {
  shape: {
    valType: 'enumerated',
    values: ['', '/', '\\', 'x', '-', '|', '+', '.'],
    dflt: '',
    arrayOk: true,
    editType: 'style'
  },
  fillmode: {
    valType: 'enumerated',
    values: ['replace', 'overlay'],
    dflt: 'replace',
    editType: 'style'
  },
  bgcolor: {
    valType: 'color',
    arrayOk: true,
    editType: 'style'
  },
  fgcolor: {
    valType: 'color',
    arrayOk: true,
    editType: 'style'
  },
  fgopacity: {
    valType: 'number',
    editType: 'style',
    min: 0,
    max: 1
  },
  size: {
    valType: 'number',
    min: 0,
    dflt: 8,
    arrayOk: true,
    editType: 'style'
  },
  solidity: {
    valType: 'number',
    min: 0,
    max: 1,
    dflt: 0.3,
    arrayOk: true,
    editType: 'style'
  },
  editType: 'style'
};

/***/ }),

/***/ 62203:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var Lib = __webpack_require__(34809);
var numberFormat = Lib.numberFormat;
var isNumeric = __webpack_require__(10721);
var tinycolor = __webpack_require__(65657);
var Registry = __webpack_require__(33626);
var Color = __webpack_require__(78766);
var Colorscale = __webpack_require__(88856);
var strTranslate = Lib.strTranslate;
var svgTextUtils = __webpack_require__(30635);
var xmlnsNamespaces = __webpack_require__(62972);
var alignment = __webpack_require__(4530);
var LINE_SPACING = alignment.LINE_SPACING;
var DESELECTDIM = (__webpack_require__(20438).DESELECTDIM);
var subTypes = __webpack_require__(64726);
var makeBubbleSizeFn = __webpack_require__(92527);
var appendArrayPointValue = (__webpack_require__(36040).appendArrayPointValue);
var drawing = module.exports = {};

// -----------------------------------------------------
// styling functions for plot elements
// -----------------------------------------------------

drawing.font = function (s, font) {
  var variant = font.variant;
  var style = font.style;
  var weight = font.weight;
  var color = font.color;
  var size = font.size;
  var family = font.family;
  var shadow = font.shadow;
  var lineposition = font.lineposition;
  var textcase = font.textcase;
  if (family) s.style('font-family', family);
  if (size + 1) s.style('font-size', size + 'px');
  if (color) s.call(Color.fill, color);
  if (weight) s.style('font-weight', weight);
  if (style) s.style('font-style', style);
  if (variant) s.style('font-variant', variant);
  if (textcase) s.style('text-transform', dropNone(textcase2transform(textcase)));
  if (shadow) s.style('text-shadow', shadow === 'auto' ? svgTextUtils.makeTextShadow(Color.contrast(color)) : dropNone(shadow));
  if (lineposition) s.style('text-decoration-line', dropNone(lineposition2decorationLine(lineposition)));
};
function dropNone(a) {
  return a === 'none' ? undefined : a;
}
var textcase2transformOptions = {
  normal: 'none',
  lower: 'lowercase',
  upper: 'uppercase',
  'word caps': 'capitalize'
};
function textcase2transform(textcase) {
  return textcase2transformOptions[textcase];
}
function lineposition2decorationLine(lineposition) {
  return lineposition.replace('under', 'underline').replace('over', 'overline').replace('through', 'line-through').split('+').join(' ');
}

/*
 * Positioning helpers
 * Note: do not use `setPosition` with <text> nodes modified by
 * `svgTextUtils.convertToTspans`. Use `svgTextUtils.positionText`
 * instead, so that <tspan.line> elements get updated to match.
 */
drawing.setPosition = function (s, x, y) {
  s.attr('x', x).attr('y', y);
};
drawing.setSize = function (s, w, h) {
  s.attr('width', w).attr('height', h);
};
drawing.setRect = function (s, x, y, w, h) {
  s.call(drawing.setPosition, x, y).call(drawing.setSize, w, h);
};

/** Translate node
 *
 * @param {object} d : calcdata point item
 * @param {sel} sel : d3 selction of node to translate
 * @param {object} xa : corresponding full xaxis object
 * @param {object} ya : corresponding full yaxis object
 *
 * @return {boolean} :
 *  true if selection got translated
 *  false if selection could not get translated
 */
drawing.translatePoint = function (d, sel, xa, ya) {
  var x = xa.c2p(d.x);
  var y = ya.c2p(d.y);
  if (isNumeric(x) && isNumeric(y) && sel.node()) {
    // for multiline text this works better
    if (sel.node().nodeName === 'text') {
      sel.attr('x', x).attr('y', y);
    } else {
      sel.attr('transform', strTranslate(x, y));
    }
  } else {
    return false;
  }
  return true;
};
drawing.translatePoints = function (s, xa, ya) {
  s.each(function (d) {
    var sel = d3.select(this);
    drawing.translatePoint(d, sel, xa, ya);
  });
};
drawing.hideOutsideRangePoint = function (d, sel, xa, ya, xcalendar, ycalendar) {
  sel.attr('display', xa.isPtWithinRange(d, xcalendar) && ya.isPtWithinRange(d, ycalendar) ? null : 'none');
};
drawing.hideOutsideRangePoints = function (traceGroups, subplot) {
  if (!subplot._hasClipOnAxisFalse) return;
  var xa = subplot.xaxis;
  var ya = subplot.yaxis;
  traceGroups.each(function (d) {
    var trace = d[0].trace;
    var xcalendar = trace.xcalendar;
    var ycalendar = trace.ycalendar;
    var selector = Registry.traceIs(trace, 'bar-like') ? '.bartext' : '.point,.textpoint';
    traceGroups.selectAll(selector).each(function (d) {
      drawing.hideOutsideRangePoint(d, d3.select(this), xa, ya, xcalendar, ycalendar);
    });
  });
};
drawing.crispRound = function (gd, lineWidth, dflt) {
  // for lines that disable antialiasing we want to
  // make sure the width is an integer, and at least 1 if it's nonzero

  if (!lineWidth || !isNumeric(lineWidth)) return dflt || 0;

  // but not for static plots - these don't get antialiased anyway.
  if (gd._context.staticPlot) return lineWidth;
  if (lineWidth < 1) return 1;
  return Math.round(lineWidth);
};
drawing.singleLineStyle = function (d, s, lw, lc, ld) {
  s.style('fill', 'none');
  var line = (((d || [])[0] || {}).trace || {}).line || {};
  var lw1 = lw || line.width || 0;
  var dash = ld || line.dash || '';
  Color.stroke(s, lc || line.color);
  drawing.dashLine(s, dash, lw1);
};
drawing.lineGroupStyle = function (s, lw, lc, ld) {
  s.style('fill', 'none').each(function (d) {
    var line = (((d || [])[0] || {}).trace || {}).line || {};
    var lw1 = lw || line.width || 0;
    var dash = ld || line.dash || '';
    d3.select(this).call(Color.stroke, lc || line.color).call(drawing.dashLine, dash, lw1);
  });
};
drawing.dashLine = function (s, dash, lineWidth) {
  lineWidth = +lineWidth || 0;
  dash = drawing.dashStyle(dash, lineWidth);
  s.style({
    'stroke-dasharray': dash,
    'stroke-width': lineWidth + 'px'
  });
};
drawing.dashStyle = function (dash, lineWidth) {
  lineWidth = +lineWidth || 1;
  var dlw = Math.max(lineWidth, 3);
  if (dash === 'solid') dash = '';else if (dash === 'dot') dash = dlw + 'px,' + dlw + 'px';else if (dash === 'dash') dash = 3 * dlw + 'px,' + 3 * dlw + 'px';else if (dash === 'longdash') dash = 5 * dlw + 'px,' + 5 * dlw + 'px';else if (dash === 'dashdot') {
    dash = 3 * dlw + 'px,' + dlw + 'px,' + dlw + 'px,' + dlw + 'px';
  } else if (dash === 'longdashdot') {
    dash = 5 * dlw + 'px,' + 2 * dlw + 'px,' + dlw + 'px,' + 2 * dlw + 'px';
  }
  // otherwise user wrote the dasharray themselves - leave it be

  return dash;
};
function setFillStyle(sel, trace, gd, forLegend) {
  var markerPattern = trace.fillpattern;
  var fillgradient = trace.fillgradient;
  var patternShape = markerPattern && drawing.getPatternAttr(markerPattern.shape, 0, '');
  if (patternShape) {
    var patternBGColor = drawing.getPatternAttr(markerPattern.bgcolor, 0, null);
    var patternFGColor = drawing.getPatternAttr(markerPattern.fgcolor, 0, null);
    var patternFGOpacity = markerPattern.fgopacity;
    var patternSize = drawing.getPatternAttr(markerPattern.size, 0, 8);
    var patternSolidity = drawing.getPatternAttr(markerPattern.solidity, 0, 0.3);
    var patternID = trace.uid;
    drawing.pattern(sel, 'point', gd, patternID, patternShape, patternSize, patternSolidity, undefined, markerPattern.fillmode, patternBGColor, patternFGColor, patternFGOpacity);
  } else if (fillgradient && fillgradient.type !== 'none') {
    var direction = fillgradient.type;
    var gradientID = 'scatterfill-' + trace.uid;
    if (forLegend) {
      gradientID = 'legendfill-' + trace.uid;
    }
    if (!forLegend && (fillgradient.start !== undefined || fillgradient.stop !== undefined)) {
      var start, stop;
      if (direction === 'horizontal') {
        start = {
          x: fillgradient.start,
          y: 0
        };
        stop = {
          x: fillgradient.stop,
          y: 0
        };
      } else if (direction === 'vertical') {
        start = {
          x: 0,
          y: fillgradient.start
        };
        stop = {
          x: 0,
          y: fillgradient.stop
        };
      }
      start.x = trace._xA.c2p(start.x === undefined ? trace._extremes.x.min[0].val : start.x, true);
      start.y = trace._yA.c2p(start.y === undefined ? trace._extremes.y.min[0].val : start.y, true);
      stop.x = trace._xA.c2p(stop.x === undefined ? trace._extremes.x.max[0].val : stop.x, true);
      stop.y = trace._yA.c2p(stop.y === undefined ? trace._extremes.y.max[0].val : stop.y, true);
      sel.call(gradientWithBounds, gd, gradientID, 'linear', fillgradient.colorscale, 'fill', start, stop, true, false);
    } else {
      if (direction === 'horizontal') {
        direction = direction + 'reversed';
      }
      sel.call(drawing.gradient, gd, gradientID, direction, fillgradient.colorscale, 'fill');
    }
  } else if (trace.fillcolor) {
    sel.call(Color.fill, trace.fillcolor);
  }
}

// Same as fillGroupStyle, except in this case the selection may be a transition
drawing.singleFillStyle = function (sel, gd) {
  var node = d3.select(sel.node());
  var data = node.data();
  var trace = ((data[0] || [])[0] || {}).trace || {};
  setFillStyle(sel, trace, gd, false);
};
drawing.fillGroupStyle = function (s, gd, forLegend) {
  s.style('stroke-width', 0).each(function (d) {
    var shape = d3.select(this);
    // N.B. 'd' won't be a calcdata item when
    // fill !== 'none' on a segment-less and marker-less trace
    if (d[0].trace) {
      setFillStyle(shape, d[0].trace, gd, forLegend);
    }
  });
};
var SYMBOLDEFS = __webpack_require__(38882);
drawing.symbolNames = [];
drawing.symbolFuncs = [];
drawing.symbolBackOffs = [];
drawing.symbolNeedLines = {};
drawing.symbolNoDot = {};
drawing.symbolNoFill = {};
drawing.symbolList = [];
Object.keys(SYMBOLDEFS).forEach(function (k) {
  var symDef = SYMBOLDEFS[k];
  var n = symDef.n;
  drawing.symbolList.push(n, String(n), k, n + 100, String(n + 100), k + '-open');
  drawing.symbolNames[n] = k;
  drawing.symbolFuncs[n] = symDef.f;
  drawing.symbolBackOffs[n] = symDef.backoff || 0;
  if (symDef.needLine) {
    drawing.symbolNeedLines[n] = true;
  }
  if (symDef.noDot) {
    drawing.symbolNoDot[n] = true;
  } else {
    drawing.symbolList.push(n + 200, String(n + 200), k + '-dot', n + 300, String(n + 300), k + '-open-dot');
  }
  if (symDef.noFill) {
    drawing.symbolNoFill[n] = true;
  }
});
var MAXSYMBOL = drawing.symbolNames.length;
// add a dot in the middle of the symbol
var DOTPATH = 'M0,0.5L0.5,0L0,-0.5L-0.5,0Z';
drawing.symbolNumber = function (v) {
  if (isNumeric(v)) {
    v = +v;
  } else if (typeof v === 'string') {
    var vbase = 0;
    if (v.indexOf('-open') > 0) {
      vbase = 100;
      v = v.replace('-open', '');
    }
    if (v.indexOf('-dot') > 0) {
      vbase += 200;
      v = v.replace('-dot', '');
    }
    v = drawing.symbolNames.indexOf(v);
    if (v >= 0) {
      v += vbase;
    }
  }
  return v % 100 >= MAXSYMBOL || v >= 400 ? 0 : Math.floor(Math.max(v, 0));
};
function makePointPath(symbolNumber, r, t, s) {
  var base = symbolNumber % 100;
  return drawing.symbolFuncs[base](r, t, s) + (symbolNumber >= 200 ? DOTPATH : '');
}
var stopFormatter = numberFormat('~f');
var gradientInfo = {
  radial: {
    type: 'radial'
  },
  radialreversed: {
    type: 'radial',
    reversed: true
  },
  horizontal: {
    type: 'linear',
    start: {
      x: 1,
      y: 0
    },
    stop: {
      x: 0,
      y: 0
    }
  },
  horizontalreversed: {
    type: 'linear',
    start: {
      x: 1,
      y: 0
    },
    stop: {
      x: 0,
      y: 0
    },
    reversed: true
  },
  vertical: {
    type: 'linear',
    start: {
      x: 0,
      y: 1
    },
    stop: {
      x: 0,
      y: 0
    }
  },
  verticalreversed: {
    type: 'linear',
    start: {
      x: 0,
      y: 1
    },
    stop: {
      x: 0,
      y: 0
    },
    reversed: true
  }
};

/**
 * gradient: create and apply a gradient fill
 *
 * @param {object} sel: d3 selection to apply this gradient to
 *     You can use `selection.call(Drawing.gradient, ...)`
 * @param {DOM element} gd: the graph div `sel` is part of
 * @param {string} gradientID: a unique (within this plot) identifier
 *     for this gradient, so that we don't create unnecessary definitions
 * @param {string} type: 'radial', 'horizontal', or 'vertical', optionally with
 *     'reversed' at the end. Normally radial goes center to edge,
 *     horizontal goes right to left, and vertical goes bottom to top
 * @param {array} colorscale: as in attribute values, [[fraction, color], ...]
 * @param {string} prop: the property to apply to, 'fill' or 'stroke'
 */
drawing.gradient = function (sel, gd, gradientID, type, colorscale, prop) {
  var info = gradientInfo[type];
  return gradientWithBounds(sel, gd, gradientID, info.type, colorscale, prop, info.start, info.stop, false, info.reversed);
};

/**
 * gradient_with_bounds: create and apply a gradient fill for defined start and stop positions
 *
 * @param {object} sel: d3 selection to apply this gradient to
 *     You can use `selection.call(Drawing.gradient, ...)`
 * @param {DOM element} gd: the graph div `sel` is part of
 * @param {string} gradientID: a unique (within this plot) identifier
 *     for this gradient, so that we don't create unnecessary definitions
 * @param {string} type: 'radial' or 'linear'. Radial goes center to edge,
 *     horizontal goes as defined by start and stop
 * @param {array} colorscale: as in attribute values, [[fraction, color], ...]
 * @param {string} prop: the property to apply to, 'fill' or 'stroke'
 * @param {object} start: start point for linear gradients, { x: number, y: number }.
 *     Ignored if type is 'radial'.
 * @param {object} stop: stop point for linear gradients, { x: number, y: number }.
 *     Ignored if type is 'radial'.
 * @param {boolean} inUserSpace: If true, start and stop give absolute values in the plot.
 *     If false, start and stop are fractions of the traces extent along each axis.
 * @param {boolean} reversed: If true, the gradient is reversed between normal start and stop,
 *     i.e., the colorscale is applied in order from stop to start for linear, from edge
 *     to center for radial gradients.
 */
function gradientWithBounds(sel, gd, gradientID, type, colorscale, prop, start, stop, inUserSpace, reversed) {
  var len = colorscale.length;
  var info;
  if (type === 'linear') {
    info = {
      node: 'linearGradient',
      attrs: {
        x1: start.x,
        y1: start.y,
        x2: stop.x,
        y2: stop.y,
        gradientUnits: inUserSpace ? 'userSpaceOnUse' : 'objectBoundingBox'
      },
      reversed: reversed
    };
  } else if (type === 'radial') {
    info = {
      node: 'radialGradient',
      reversed: reversed
    };
  }
  var colorStops = new Array(len);
  for (var i = 0; i < len; i++) {
    if (info.reversed) {
      colorStops[len - 1 - i] = [stopFormatter((1 - colorscale[i][0]) * 100), colorscale[i][1]];
    } else {
      colorStops[i] = [stopFormatter(colorscale[i][0] * 100), colorscale[i][1]];
    }
  }
  var fullLayout = gd._fullLayout;
  var fullID = 'g' + fullLayout._uid + '-' + gradientID;
  var gradient = fullLayout._defs.select('.gradients').selectAll('#' + fullID).data([type + colorStops.join(';')], Lib.identity);
  gradient.exit().remove();
  gradient.enter().append(info.node).each(function () {
    var el = d3.select(this);
    if (info.attrs) el.attr(info.attrs);
    el.attr('id', fullID);
    var stops = el.selectAll('stop').data(colorStops);
    stops.exit().remove();
    stops.enter().append('stop');
    stops.each(function (d) {
      var tc = tinycolor(d[1]);
      d3.select(this).attr({
        offset: d[0] + '%',
        'stop-color': Color.tinyRGB(tc),
        'stop-opacity': tc.getAlpha()
      });
    });
  });
  sel.style(prop, getFullUrl(fullID, gd)).style(prop + '-opacity', null);
  sel.classed('gradient_filled', true);
}

/**
 * pattern: create and apply a pattern fill
 *
 * @param {object} sel: d3 selection to apply this pattern to
 *     You can use `selection.call(Drawing.pattern, ...)`
 * @param {string} calledBy: option to know the caller component
 * @param {DOM element} gd: the graph div `sel` is part of
 * @param {string} patternID: a unique (within this plot) identifier
 *     for this pattern, so that we don't create unnecessary definitions
 * @param {number} size: size of unit squares for repetition of this pattern
 * @param {number} solidity: how solid lines of this pattern are
 * @param {string} mcc: color when painted with colorscale
 * @param {string} fillmode: fillmode for this pattern
 * @param {string} bgcolor: background color for this pattern
 * @param {string} fgcolor: foreground color for this pattern
 * @param {number} fgopacity: foreground opacity for this pattern
 */
drawing.pattern = function (sel, calledBy, gd, patternID, shape, size, solidity, mcc, fillmode, bgcolor, fgcolor, fgopacity) {
  var isLegend = calledBy === 'legend';
  if (mcc) {
    if (fillmode === 'overlay') {
      bgcolor = mcc;
      fgcolor = Color.contrast(bgcolor);
    } else {
      bgcolor = undefined;
      fgcolor = mcc;
    }
  }
  var fullLayout = gd._fullLayout;
  var fullID = 'p' + fullLayout._uid + '-' + patternID;
  var width, height;

  // linear interpolation
  var linearFn = function (x, x0, x1, y0, y1) {
    return y0 + (y1 - y0) * (x - x0) / (x1 - x0);
  };
  var path, linewidth, radius;
  var patternTag;
  var patternAttrs = {};
  var fgC = tinycolor(fgcolor);
  var fgRGB = Color.tinyRGB(fgC);
  var fgAlpha = fgC.getAlpha();
  var opacity = fgopacity * fgAlpha;
  switch (shape) {
    case '/':
      width = size * Math.sqrt(2);
      height = size * Math.sqrt(2);
      path = 'M-' + width / 4 + ',' + height / 4 + 'l' + width / 2 + ',-' + height / 2 + 'M0,' + height + 'L' + width + ',0' + 'M' + width / 4 * 3 + ',' + height / 4 * 5 + 'l' + width / 2 + ',-' + height / 2;
      linewidth = solidity * size;
      patternTag = 'path';
      patternAttrs = {
        d: path,
        opacity: opacity,
        stroke: fgRGB,
        'stroke-width': linewidth + 'px'
      };
      break;
    case '\\':
      width = size * Math.sqrt(2);
      height = size * Math.sqrt(2);
      path = 'M' + width / 4 * 3 + ',-' + height / 4 + 'l' + width / 2 + ',' + height / 2 + 'M0,0L' + width + ',' + height + 'M-' + width / 4 + ',' + height / 4 * 3 + 'l' + width / 2 + ',' + height / 2;
      linewidth = solidity * size;
      patternTag = 'path';
      patternAttrs = {
        d: path,
        opacity: opacity,
        stroke: fgRGB,
        'stroke-width': linewidth + 'px'
      };
      break;
    case 'x':
      width = size * Math.sqrt(2);
      height = size * Math.sqrt(2);
      path = 'M-' + width / 4 + ',' + height / 4 + 'l' + width / 2 + ',-' + height / 2 + 'M0,' + height + 'L' + width + ',0' + 'M' + width / 4 * 3 + ',' + height / 4 * 5 + 'l' + width / 2 + ',-' + height / 2 + 'M' + width / 4 * 3 + ',-' + height / 4 + 'l' + width / 2 + ',' + height / 2 + 'M0,0L' + width + ',' + height + 'M-' + width / 4 + ',' + height / 4 * 3 + 'l' + width / 2 + ',' + height / 2;
      linewidth = size - size * Math.sqrt(1.0 - solidity);
      patternTag = 'path';
      patternAttrs = {
        d: path,
        opacity: opacity,
        stroke: fgRGB,
        'stroke-width': linewidth + 'px'
      };
      break;
    case '|':
      width = size;
      height = size;
      patternTag = 'path';
      path = 'M' + width / 2 + ',0L' + width / 2 + ',' + height;
      linewidth = solidity * size;
      patternTag = 'path';
      patternAttrs = {
        d: path,
        opacity: opacity,
        stroke: fgRGB,
        'stroke-width': linewidth + 'px'
      };
      break;
    case '-':
      width = size;
      height = size;
      patternTag = 'path';
      path = 'M0,' + height / 2 + 'L' + width + ',' + height / 2;
      linewidth = solidity * size;
      patternTag = 'path';
      patternAttrs = {
        d: path,
        opacity: opacity,
        stroke: fgRGB,
        'stroke-width': linewidth + 'px'
      };
      break;
    case '+':
      width = size;
      height = size;
      patternTag = 'path';
      path = 'M' + width / 2 + ',0L' + width / 2 + ',' + height + 'M0,' + height / 2 + 'L' + width + ',' + height / 2;
      linewidth = size - size * Math.sqrt(1.0 - solidity);
      patternTag = 'path';
      patternAttrs = {
        d: path,
        opacity: opacity,
        stroke: fgRGB,
        'stroke-width': linewidth + 'px'
      };
      break;
    case '.':
      width = size;
      height = size;
      if (solidity < Math.PI / 4) {
        radius = Math.sqrt(solidity * size * size / Math.PI);
      } else {
        radius = linearFn(solidity, Math.PI / 4, 1.0, size / 2, size / Math.sqrt(2));
      }
      patternTag = 'circle';
      patternAttrs = {
        cx: width / 2,
        cy: height / 2,
        r: radius,
        opacity: opacity,
        fill: fgRGB
      };
      break;
  }
  var str = [shape || 'noSh', bgcolor || 'noBg', fgcolor || 'noFg', size, solidity].join(';');
  var pattern = fullLayout._defs.select('.patterns').selectAll('#' + fullID).data([str], Lib.identity);
  pattern.exit().remove();
  pattern.enter().append('pattern').each(function () {
    var el = d3.select(this);
    el.attr({
      id: fullID,
      width: width + 'px',
      height: height + 'px',
      patternUnits: 'userSpaceOnUse',
      // for legends scale down patterns just a bit so that default size (i.e 8) nicely fit in small icons
      patternTransform: isLegend ? 'scale(0.8)' : ''
    });
    if (bgcolor) {
      var bgC = tinycolor(bgcolor);
      var bgRGB = Color.tinyRGB(bgC);
      var bgAlpha = bgC.getAlpha();
      var rects = el.selectAll('rect').data([0]);
      rects.exit().remove();
      rects.enter().append('rect').attr({
        width: width + 'px',
        height: height + 'px',
        fill: bgRGB,
        'fill-opacity': bgAlpha
      });
    }
    var patterns = el.selectAll(patternTag).data([0]);
    patterns.exit().remove();
    patterns.enter().append(patternTag).attr(patternAttrs);
  });
  sel.style('fill', getFullUrl(fullID, gd)).style('fill-opacity', null);
  sel.classed('pattern_filled', true);
};

/*
 * Make the gradients container and clear out any previous gradients.
 * We never collect all the gradients we need in one place,
 * so we can't ever remove gradients that have stopped being useful,
 * except all at once before a full redraw.
 * The upside of this is arbitrary points can share gradient defs
 */
drawing.initGradients = function (gd) {
  var fullLayout = gd._fullLayout;
  var gradientsGroup = Lib.ensureSingle(fullLayout._defs, 'g', 'gradients');
  gradientsGroup.selectAll('linearGradient,radialGradient').remove();
  d3.select(gd).selectAll('.gradient_filled').classed('gradient_filled', false);
};
drawing.initPatterns = function (gd) {
  var fullLayout = gd._fullLayout;
  var patternsGroup = Lib.ensureSingle(fullLayout._defs, 'g', 'patterns');
  patternsGroup.selectAll('pattern').remove();
  d3.select(gd).selectAll('.pattern_filled').classed('pattern_filled', false);
};
drawing.getPatternAttr = function (mp, i, dflt) {
  if (mp && Lib.isArrayOrTypedArray(mp)) {
    return i < mp.length ? mp[i] : dflt;
  }
  return mp;
};
drawing.pointStyle = function (s, trace, gd, pt) {
  if (!s.size()) return;
  var fns = drawing.makePointStyleFns(trace);
  s.each(function (d) {
    drawing.singlePointStyle(d, d3.select(this), trace, fns, gd, pt);
  });
};
drawing.singlePointStyle = function (d, sel, trace, fns, gd, pt) {
  var marker = trace.marker;
  var markerLine = marker.line;
  if (pt && pt.i >= 0 && d.i === undefined) d.i = pt.i;
  sel.style('opacity', fns.selectedOpacityFn ? fns.selectedOpacityFn(d) : d.mo === undefined ? marker.opacity : d.mo);
  if (fns.ms2mrc) {
    var r;

    // handle multi-trace graph edit case
    if (d.ms === 'various' || marker.size === 'various') {
      r = 3;
    } else {
      r = fns.ms2mrc(d.ms);
    }

    // store the calculated size so hover can use it
    d.mrc = r;
    if (fns.selectedSizeFn) {
      r = d.mrc = fns.selectedSizeFn(d);
    }

    // turn the symbol into a sanitized number
    var x = drawing.symbolNumber(d.mx || marker.symbol) || 0;

    // save if this marker is open
    // because that impacts how to handle colors
    d.om = x % 200 >= 100;
    var angle = getMarkerAngle(d, trace);
    var standoff = getMarkerStandoff(d, trace);
    sel.attr('d', makePointPath(x, r, angle, standoff));
  }
  var perPointGradient = false;
  var fillColor, lineColor, lineWidth;

  // 'so' is suspected outliers, for box plots
  if (d.so) {
    lineWidth = markerLine.outlierwidth;
    lineColor = markerLine.outliercolor;
    fillColor = marker.outliercolor;
  } else {
    var markerLineWidth = (markerLine || {}).width;
    lineWidth = (d.mlw + 1 || markerLineWidth + 1 ||
    // TODO: we need the latter for legends... can we get rid of it?
    (d.trace ? (d.trace.marker.line || {}).width : 0) + 1) - 1 || 0;
    if ('mlc' in d) lineColor = d.mlcc = fns.lineScale(d.mlc);
    // weird case: array wasn't long enough to apply to every point
    else if (Lib.isArrayOrTypedArray(markerLine.color)) lineColor = Color.defaultLine;else lineColor = markerLine.color;
    if (Lib.isArrayOrTypedArray(marker.color)) {
      fillColor = Color.defaultLine;
      perPointGradient = true;
    }
    if ('mc' in d) {
      fillColor = d.mcc = fns.markerScale(d.mc);
    } else {
      fillColor = marker.color || marker.colors || 'rgba(0,0,0,0)';
    }
    if (fns.selectedColorFn) {
      fillColor = fns.selectedColorFn(d);
    }
  }
  if (d.om) {
    // open markers can't have zero linewidth, default to 1px,
    // and use fill color as stroke color
    sel.call(Color.stroke, fillColor).style({
      'stroke-width': (lineWidth || 1) + 'px',
      fill: 'none'
    });
  } else {
    sel.style('stroke-width', (d.isBlank ? 0 : lineWidth) + 'px');
    var markerGradient = marker.gradient;
    var gradientType = d.mgt;
    if (gradientType) perPointGradient = true;else gradientType = markerGradient && markerGradient.type;

    // for legend - arrays will propagate through here, but we don't need
    // to treat it as per-point.
    if (Lib.isArrayOrTypedArray(gradientType)) {
      gradientType = gradientType[0];
      if (!gradientInfo[gradientType]) gradientType = 0;
    }
    var markerPattern = marker.pattern;
    var patternShape = markerPattern && drawing.getPatternAttr(markerPattern.shape, d.i, '');
    if (gradientType && gradientType !== 'none') {
      var gradientColor = d.mgc;
      if (gradientColor) perPointGradient = true;else gradientColor = markerGradient.color;
      var gradientID = trace.uid;
      if (perPointGradient) gradientID += '-' + d.i;
      drawing.gradient(sel, gd, gradientID, gradientType, [[0, gradientColor], [1, fillColor]], 'fill');
    } else if (patternShape) {
      var perPointPattern = false;
      var fgcolor = markerPattern.fgcolor;
      if (!fgcolor && pt && pt.color) {
        fgcolor = pt.color;
        perPointPattern = true;
      }
      var patternFGColor = drawing.getPatternAttr(fgcolor, d.i, pt && pt.color || null);
      var patternBGColor = drawing.getPatternAttr(markerPattern.bgcolor, d.i, null);
      var patternFGOpacity = markerPattern.fgopacity;
      var patternSize = drawing.getPatternAttr(markerPattern.size, d.i, 8);
      var patternSolidity = drawing.getPatternAttr(markerPattern.solidity, d.i, 0.3);
      perPointPattern = perPointPattern || d.mcc || Lib.isArrayOrTypedArray(markerPattern.shape) || Lib.isArrayOrTypedArray(markerPattern.bgcolor) || Lib.isArrayOrTypedArray(markerPattern.fgcolor) || Lib.isArrayOrTypedArray(markerPattern.size) || Lib.isArrayOrTypedArray(markerPattern.solidity);
      var patternID = trace.uid;
      if (perPointPattern) patternID += '-' + d.i;
      drawing.pattern(sel, 'point', gd, patternID, patternShape, patternSize, patternSolidity, d.mcc, markerPattern.fillmode, patternBGColor, patternFGColor, patternFGOpacity);
    } else {
      Lib.isArrayOrTypedArray(fillColor) ? Color.fill(sel, fillColor[d.i]) : Color.fill(sel, fillColor);
    }
    if (lineWidth) {
      Color.stroke(sel, lineColor);
    }
  }
};
drawing.makePointStyleFns = function (trace) {
  var out = {};
  var marker = trace.marker;

  // allow array marker and marker line colors to be
  // scaled by given max and min to colorscales
  out.markerScale = drawing.tryColorscale(marker, '');
  out.lineScale = drawing.tryColorscale(marker, 'line');
  if (Registry.traceIs(trace, 'symbols')) {
    out.ms2mrc = subTypes.isBubble(trace) ? makeBubbleSizeFn(trace) : function () {
      return (marker.size || 6) / 2;
    };
  }
  if (trace.selectedpoints) {
    Lib.extendFlat(out, drawing.makeSelectedPointStyleFns(trace));
  }
  return out;
};
drawing.makeSelectedPointStyleFns = function (trace) {
  var out = {};
  var selectedAttrs = trace.selected || {};
  var unselectedAttrs = trace.unselected || {};
  var marker = trace.marker || {};
  var selectedMarker = selectedAttrs.marker || {};
  var unselectedMarker = unselectedAttrs.marker || {};
  var mo = marker.opacity;
  var smo = selectedMarker.opacity;
  var usmo = unselectedMarker.opacity;
  var smoIsDefined = smo !== undefined;
  var usmoIsDefined = usmo !== undefined;
  if (Lib.isArrayOrTypedArray(mo) || smoIsDefined || usmoIsDefined) {
    out.selectedOpacityFn = function (d) {
      var base = d.mo === undefined ? marker.opacity : d.mo;
      if (d.selected) {
        return smoIsDefined ? smo : base;
      } else {
        return usmoIsDefined ? usmo : DESELECTDIM * base;
      }
    };
  }
  var mc = marker.color;
  var smc = selectedMarker.color;
  var usmc = unselectedMarker.color;
  if (smc || usmc) {
    out.selectedColorFn = function (d) {
      var base = d.mcc || mc;
      if (d.selected) {
        return smc || base;
      } else {
        return usmc || base;
      }
    };
  }
  var ms = marker.size;
  var sms = selectedMarker.size;
  var usms = unselectedMarker.size;
  var smsIsDefined = sms !== undefined;
  var usmsIsDefined = usms !== undefined;
  if (Registry.traceIs(trace, 'symbols') && (smsIsDefined || usmsIsDefined)) {
    out.selectedSizeFn = function (d) {
      var base = d.mrc || ms / 2;
      if (d.selected) {
        return smsIsDefined ? sms / 2 : base;
      } else {
        return usmsIsDefined ? usms / 2 : base;
      }
    };
  }
  return out;
};
drawing.makeSelectedTextStyleFns = function (trace) {
  var out = {};
  var selectedAttrs = trace.selected || {};
  var unselectedAttrs = trace.unselected || {};
  var textFont = trace.textfont || {};
  var selectedTextFont = selectedAttrs.textfont || {};
  var unselectedTextFont = unselectedAttrs.textfont || {};
  var tc = textFont.color;
  var stc = selectedTextFont.color;
  var utc = unselectedTextFont.color;
  out.selectedTextColorFn = function (d) {
    var base = d.tc || tc;
    if (d.selected) {
      return stc || base;
    } else {
      if (utc) return utc;else return stc ? base : Color.addOpacity(base, DESELECTDIM);
    }
  };
  return out;
};
drawing.selectedPointStyle = function (s, trace) {
  if (!s.size() || !trace.selectedpoints) return;
  var fns = drawing.makeSelectedPointStyleFns(trace);
  var marker = trace.marker || {};
  var seq = [];
  if (fns.selectedOpacityFn) {
    seq.push(function (pt, d) {
      pt.style('opacity', fns.selectedOpacityFn(d));
    });
  }
  if (fns.selectedColorFn) {
    seq.push(function (pt, d) {
      Color.fill(pt, fns.selectedColorFn(d));
    });
  }
  if (fns.selectedSizeFn) {
    seq.push(function (pt, d) {
      var mx = d.mx || marker.symbol || 0;
      var mrc2 = fns.selectedSizeFn(d);
      pt.attr('d', makePointPath(drawing.symbolNumber(mx), mrc2, getMarkerAngle(d, trace), getMarkerStandoff(d, trace)));

      // save for Drawing.selectedTextStyle
      d.mrc2 = mrc2;
    });
  }
  if (seq.length) {
    s.each(function (d) {
      var pt = d3.select(this);
      for (var i = 0; i < seq.length; i++) {
        seq[i](pt, d);
      }
    });
  }
};
drawing.tryColorscale = function (marker, prefix) {
  var cont = prefix ? Lib.nestedProperty(marker, prefix).get() : marker;
  if (cont) {
    var colorArray = cont.color;
    if ((cont.colorscale || cont._colorAx) && Lib.isArrayOrTypedArray(colorArray)) {
      return Colorscale.makeColorScaleFuncFromTrace(cont);
    }
  }
  return Lib.identity;
};
var TEXTOFFSETSIGN = {
  start: 1,
  end: -1,
  middle: 0,
  bottom: 1,
  top: -1
};
function textPointPosition(s, textPosition, fontSize, markerRadius, dontTouchParent) {
  var group = d3.select(s.node().parentNode);
  var v = textPosition.indexOf('top') !== -1 ? 'top' : textPosition.indexOf('bottom') !== -1 ? 'bottom' : 'middle';
  var h = textPosition.indexOf('left') !== -1 ? 'end' : textPosition.indexOf('right') !== -1 ? 'start' : 'middle';

  // if markers are shown, offset a little more than
  // the nominal marker size
  // ie 2/1.6 * nominal, bcs some markers are a bit bigger
  var r = markerRadius ? markerRadius / 0.8 + 1 : 0;
  var numLines = (svgTextUtils.lineCount(s) - 1) * LINE_SPACING + 1;
  var dx = TEXTOFFSETSIGN[h] * r;
  var dy = fontSize * 0.75 + TEXTOFFSETSIGN[v] * r + (TEXTOFFSETSIGN[v] - 1) * numLines * fontSize / 2;

  // fix the overall text group position
  s.attr('text-anchor', h);
  if (!dontTouchParent) {
    group.attr('transform', strTranslate(dx, dy));
  }
}
function extracTextFontSize(d, trace) {
  var fontSize = d.ts || trace.textfont.size;
  return isNumeric(fontSize) && fontSize > 0 ? fontSize : 0;
}

// draw text at points
drawing.textPointStyle = function (s, trace, gd) {
  if (!s.size()) return;
  var selectedTextColorFn;
  if (trace.selectedpoints) {
    var fns = drawing.makeSelectedTextStyleFns(trace);
    selectedTextColorFn = fns.selectedTextColorFn;
  }
  var texttemplate = trace.texttemplate;
  var fullLayout = gd._fullLayout;
  s.each(function (d) {
    var p = d3.select(this);
    var text = texttemplate ? Lib.extractOption(d, trace, 'txt', 'texttemplate') : Lib.extractOption(d, trace, 'tx', 'text');
    if (!text && text !== 0) {
      p.remove();
      return;
    }
    if (texttemplate) {
      var fn = trace._module.formatLabels;
      var labels = fn ? fn(d, trace, fullLayout) : {};
      var pointValues = {};
      appendArrayPointValue(pointValues, trace, d.i);
      var meta = trace._meta || {};
      text = Lib.texttemplateString(text, labels, fullLayout._d3locale, pointValues, d, meta);
    }
    var pos = d.tp || trace.textposition;
    var fontSize = extracTextFontSize(d, trace);
    var fontColor = selectedTextColorFn ? selectedTextColorFn(d) : d.tc || trace.textfont.color;
    p.call(drawing.font, {
      family: d.tf || trace.textfont.family,
      weight: d.tw || trace.textfont.weight,
      style: d.ty || trace.textfont.style,
      variant: d.tv || trace.textfont.variant,
      textcase: d.tC || trace.textfont.textcase,
      lineposition: d.tE || trace.textfont.lineposition,
      shadow: d.tS || trace.textfont.shadow,
      size: fontSize,
      color: fontColor
    }).text(text).call(svgTextUtils.convertToTspans, gd).call(textPointPosition, pos, fontSize, d.mrc);
  });
};
drawing.selectedTextStyle = function (s, trace) {
  if (!s.size() || !trace.selectedpoints) return;
  var fns = drawing.makeSelectedTextStyleFns(trace);
  s.each(function (d) {
    var tx = d3.select(this);
    var tc = fns.selectedTextColorFn(d);
    var tp = d.tp || trace.textposition;
    var fontSize = extracTextFontSize(d, trace);
    Color.fill(tx, tc);
    var dontTouchParent = Registry.traceIs(trace, 'bar-like');
    textPointPosition(tx, tp, fontSize, d.mrc2 || d.mrc, dontTouchParent);
  });
};

// generalized Catmull-Rom splines, per
// http://www.cemyuksel.com/research/catmullrom_param/catmullrom.pdf
var CatmullRomExp = 0.5;
drawing.smoothopen = function (pts, smoothness) {
  if (pts.length < 3) {
    return 'M' + pts.join('L');
  }
  var path = 'M' + pts[0];
  var tangents = [];
  var i;
  for (i = 1; i < pts.length - 1; i++) {
    tangents.push(makeTangent(pts[i - 1], pts[i], pts[i + 1], smoothness));
  }
  path += 'Q' + tangents[0][0] + ' ' + pts[1];
  for (i = 2; i < pts.length - 1; i++) {
    path += 'C' + tangents[i - 2][1] + ' ' + tangents[i - 1][0] + ' ' + pts[i];
  }
  path += 'Q' + tangents[pts.length - 3][1] + ' ' + pts[pts.length - 1];
  return path;
};
drawing.smoothclosed = function (pts, smoothness) {
  if (pts.length < 3) {
    return 'M' + pts.join('L') + 'Z';
  }
  var path = 'M' + pts[0];
  var pLast = pts.length - 1;
  var tangents = [makeTangent(pts[pLast], pts[0], pts[1], smoothness)];
  var i;
  for (i = 1; i < pLast; i++) {
    tangents.push(makeTangent(pts[i - 1], pts[i], pts[i + 1], smoothness));
  }
  tangents.push(makeTangent(pts[pLast - 1], pts[pLast], pts[0], smoothness));
  for (i = 1; i <= pLast; i++) {
    path += 'C' + tangents[i - 1][1] + ' ' + tangents[i][0] + ' ' + pts[i];
  }
  path += 'C' + tangents[pLast][1] + ' ' + tangents[0][0] + ' ' + pts[0] + 'Z';
  return path;
};
var lastDrawnX, lastDrawnY;
function roundEnd(pt, isY, isLastPoint) {
  if (isLastPoint) pt = applyBackoff(pt);
  return isY ? roundY(pt[1]) : roundX(pt[0]);
}
function roundX(p) {
  var v = d3.round(p, 2);
  lastDrawnX = v;
  return v;
}
function roundY(p) {
  var v = d3.round(p, 2);
  lastDrawnY = v;
  return v;
}
function makeTangent(prevpt, thispt, nextpt, smoothness) {
  var d1x = prevpt[0] - thispt[0];
  var d1y = prevpt[1] - thispt[1];
  var d2x = nextpt[0] - thispt[0];
  var d2y = nextpt[1] - thispt[1];
  var d1a = Math.pow(d1x * d1x + d1y * d1y, CatmullRomExp / 2);
  var d2a = Math.pow(d2x * d2x + d2y * d2y, CatmullRomExp / 2);
  var numx = (d2a * d2a * d1x - d1a * d1a * d2x) * smoothness;
  var numy = (d2a * d2a * d1y - d1a * d1a * d2y) * smoothness;
  var denom1 = 3 * d2a * (d1a + d2a);
  var denom2 = 3 * d1a * (d1a + d2a);
  return [[roundX(thispt[0] + (denom1 && numx / denom1)), roundY(thispt[1] + (denom1 && numy / denom1))], [roundX(thispt[0] - (denom2 && numx / denom2)), roundY(thispt[1] - (denom2 && numy / denom2))]];
}

// step paths - returns a generator function for paths
// with the given step shape
var STEPPATH = {
  hv: function (p0, p1, isLastPoint) {
    return 'H' + roundX(p1[0]) + 'V' + roundEnd(p1, 1, isLastPoint);
  },
  vh: function (p0, p1, isLastPoint) {
    return 'V' + roundY(p1[1]) + 'H' + roundEnd(p1, 0, isLastPoint);
  },
  hvh: function (p0, p1, isLastPoint) {
    return 'H' + roundX((p0[0] + p1[0]) / 2) + 'V' + roundY(p1[1]) + 'H' + roundEnd(p1, 0, isLastPoint);
  },
  vhv: function (p0, p1, isLastPoint) {
    return 'V' + roundY((p0[1] + p1[1]) / 2) + 'H' + roundX(p1[0]) + 'V' + roundEnd(p1, 1, isLastPoint);
  }
};
var STEPLINEAR = function (p0, p1, isLastPoint) {
  return 'L' + roundEnd(p1, 0, isLastPoint) + ',' + roundEnd(p1, 1, isLastPoint);
};
drawing.steps = function (shape) {
  var onestep = STEPPATH[shape] || STEPLINEAR;
  return function (pts) {
    var path = 'M' + roundX(pts[0][0]) + ',' + roundY(pts[0][1]);
    var len = pts.length;
    for (var i = 1; i < len; i++) {
      path += onestep(pts[i - 1], pts[i], i === len - 1);
    }
    return path;
  };
};
function applyBackoff(pt, start) {
  var backoff = pt.backoff;
  var trace = pt.trace;
  var d = pt.d;
  var i = pt.i;
  if (backoff && trace && trace.marker && trace.marker.angle % 360 === 0 && trace.line && trace.line.shape !== 'spline') {
    var arrayBackoff = Lib.isArrayOrTypedArray(backoff);
    var end = pt;
    var x1 = start ? start[0] : lastDrawnX || 0;
    var y1 = start ? start[1] : lastDrawnY || 0;
    var x2 = end[0];
    var y2 = end[1];
    var dx = x2 - x1;
    var dy = y2 - y1;
    var t = Math.atan2(dy, dx);
    var b = arrayBackoff ? backoff[i] : backoff;
    if (b === 'auto') {
      var endI = end.i;
      if (trace.type === 'scatter') endI--; // Why we need this hack?

      var endMarker = end.marker;
      var endMarkerSymbol = endMarker.symbol;
      if (Lib.isArrayOrTypedArray(endMarkerSymbol)) endMarkerSymbol = endMarkerSymbol[endI];
      var endMarkerSize = endMarker.size;
      if (Lib.isArrayOrTypedArray(endMarkerSize)) endMarkerSize = endMarkerSize[endI];
      b = endMarker ? drawing.symbolBackOffs[drawing.symbolNumber(endMarkerSymbol)] * endMarkerSize : 0;
      b += drawing.getMarkerStandoff(d[endI], trace) || 0;
    }
    var x = x2 - b * Math.cos(t);
    var y = y2 - b * Math.sin(t);
    if ((x <= x2 && x >= x1 || x >= x2 && x <= x1) && (y <= y2 && y >= y1 || y >= y2 && y <= y1)) {
      pt = [x, y];
    }
  }
  return pt;
}
drawing.applyBackoff = applyBackoff;

// off-screen svg render testing element, shared by the whole page
// uses the id 'js-plotly-tester' and stores it in drawing.tester
drawing.makeTester = function () {
  var tester = Lib.ensureSingleById(d3.select('body'), 'svg', 'js-plotly-tester', function (s) {
    s.attr(xmlnsNamespaces.svgAttrs).style({
      position: 'absolute',
      left: '-10000px',
      top: '-10000px',
      width: '9000px',
      height: '9000px',
      'z-index': '1'
    });
  });

  // browsers differ on how they describe the bounding rect of
  // the svg if its contents spill over... so make a 1x1px
  // reference point we can measure off of.
  var testref = Lib.ensureSingle(tester, 'path', 'js-reference-point', function (s) {
    s.attr('d', 'M0,0H1V1H0Z').style({
      'stroke-width': 0,
      fill: 'black'
    });
  });
  drawing.tester = tester;
  drawing.testref = testref;
};

/*
 * use our offscreen tester to get a clientRect for an element,
 * in a reference frame where it isn't translated (or transformed) and
 * its anchor point is at (0,0)
 * always returns a copy of the bbox, so the caller can modify it safely
 *
 * @param {SVGElement} node: the element to measure. If possible this should be
 *   a <text> or MathJax <g> element that's already passed through
 *   `convertToTspans` because in that case we can cache the results, but it's
 *   possible to pass in any svg element.
 *
 * @param {boolean} inTester: is this element already in `drawing.tester`?
 *   If you are measuring a dummy element, rather than one you really intend
 *   to use on the plot, making it in `drawing.tester` in the first place
 *   allows us to test faster because it cuts out cloning and appending it.
 *
 * @param {string} hash: for internal use only, if we already know the cache key
 *   for this element beforehand.
 *
 * @return {object}: a plain object containing the width, height, left, right,
 *   top, and bottom of `node`
 */
drawing.savedBBoxes = {};
var savedBBoxesCount = 0;
var maxSavedBBoxes = 10000;
drawing.bBox = function (node, inTester, hash) {
  /*
   * Cache elements we've already measured so we don't have to
   * remeasure the same thing many times
   * We have a few bBox callers though who pass a node larger than
   * a <text> or a MathJax <g>, such as an axis group containing many labels.
   * These will not generate a hash (unless we figure out an appropriate
   * hash key for them) and thus we will not hash them.
   */
  if (!hash) hash = nodeHash(node);
  var out;
  if (hash) {
    out = drawing.savedBBoxes[hash];
    if (out) return Lib.extendFlat({}, out);
  } else if (node.childNodes.length === 1) {
    /*
     * If we have only one child element, which is itself hashable, make
     * a new hash from this element plus its x,y,transform
     * These bounding boxes *include* x,y,transform - mostly for use by
     * callers trying to avoid overlaps (ie titles)
     */
    var innerNode = node.childNodes[0];
    hash = nodeHash(innerNode);
    if (hash) {
      var x = +innerNode.getAttribute('x') || 0;
      var y = +innerNode.getAttribute('y') || 0;
      var transform = innerNode.getAttribute('transform');
      if (!transform) {
        // in this case, just varying x and y, don't bother caching
        // the final bBox because the alteration is quick.
        var innerBB = drawing.bBox(innerNode, false, hash);
        if (x) {
          innerBB.left += x;
          innerBB.right += x;
        }
        if (y) {
          innerBB.top += y;
          innerBB.bottom += y;
        }
        return innerBB;
      }
      /*
       * else we have a transform - rather than make a complicated
       * (and error-prone and probably slow) transform parser/calculator,
       * just continue on calculating the boundingClientRect of the group
       * and use the new composite hash to cache it.
       * That said, `innerNode.transform.baseVal` is an array of
       * `SVGTransform` objects, that *do* seem to have a nice matrix
       * multiplication interface that we could use to avoid making
       * another getBoundingClientRect call...
       */
      hash += '~' + x + '~' + y + '~' + transform;
      out = drawing.savedBBoxes[hash];
      if (out) return Lib.extendFlat({}, out);
    }
  }
  var testNode, tester;
  if (inTester) {
    testNode = node;
  } else {
    tester = drawing.tester.node();

    // copy the node to test into the tester
    testNode = node.cloneNode(true);
    tester.appendChild(testNode);
  }

  // standardize its position (and newline tspans if any)
  d3.select(testNode).attr('transform', null).call(svgTextUtils.positionText, 0, 0);
  var testRect = testNode.getBoundingClientRect();
  var refRect = drawing.testref.node().getBoundingClientRect();
  if (!inTester) tester.removeChild(testNode);
  var bb = {
    height: testRect.height,
    width: testRect.width,
    left: testRect.left - refRect.left,
    top: testRect.top - refRect.top,
    right: testRect.right - refRect.left,
    bottom: testRect.bottom - refRect.top
  };

  // make sure we don't have too many saved boxes,
  // or a long session could overload on memory
  // by saving boxes for long-gone elements
  if (savedBBoxesCount >= maxSavedBBoxes) {
    drawing.savedBBoxes = {};
    savedBBoxesCount = 0;
  }

  // cache this bbox
  if (hash) drawing.savedBBoxes[hash] = bb;
  savedBBoxesCount++;
  return Lib.extendFlat({}, bb);
};

// capture everything about a node (at least in our usage) that
// impacts its bounding box, given that bBox clears x, y, and transform
function nodeHash(node) {
  var inputText = node.getAttribute('data-unformatted');
  if (inputText === null) return;
  return inputText + node.getAttribute('data-math') + node.getAttribute('text-anchor') + node.getAttribute('style');
}

/**
 * Set clipPath URL in a way that work for all situations.
 *
 * In details, graphs on pages with <base> HTML tags need to prepend
 * the clip path ids with the page's base url EXCEPT during toImage exports.
 *
 * @param {d3 selection} s : node to add clip-path attribute
 * @param {string} localId : local clip-path (w/o base url) id
 * @param {DOM element || object} gd
 * - context._baseUrl {string}
 * - context._exportedPlot {boolean}
 */
drawing.setClipUrl = function (s, localId, gd) {
  s.attr('clip-path', getFullUrl(localId, gd));
};
function getFullUrl(localId, gd) {
  if (!localId) return null;
  var context = gd._context;
  var baseUrl = context._exportedPlot ? '' : context._baseUrl || '';
  return baseUrl ? 'url(\'' + baseUrl + '#' + localId + '\')' : 'url(#' + localId + ')';
}
drawing.getTranslate = function (element) {
  // Note the separator [^\d] between x and y in this regex
  // We generally use ',' but IE will convert it to ' '
  var re = /.*\btranslate\((-?\d*\.?\d*)[^-\d]*(-?\d*\.?\d*)[^\d].*/;
  var getter = element.attr ? 'attr' : 'getAttribute';
  var transform = element[getter]('transform') || '';
  var translate = transform.replace(re, function (match, p1, p2) {
    return [p1, p2].join(' ');
  }).split(' ');
  return {
    x: +translate[0] || 0,
    y: +translate[1] || 0
  };
};
drawing.setTranslate = function (element, x, y) {
  var re = /(\btranslate\(.*?\);?)/;
  var getter = element.attr ? 'attr' : 'getAttribute';
  var setter = element.attr ? 'attr' : 'setAttribute';
  var transform = element[getter]('transform') || '';
  x = x || 0;
  y = y || 0;
  transform = transform.replace(re, '').trim();
  transform += strTranslate(x, y);
  transform = transform.trim();
  element[setter]('transform', transform);
  return transform;
};
drawing.getScale = function (element) {
  var re = /.*\bscale\((\d*\.?\d*)[^\d]*(\d*\.?\d*)[^\d].*/;
  var getter = element.attr ? 'attr' : 'getAttribute';
  var transform = element[getter]('transform') || '';
  var translate = transform.replace(re, function (match, p1, p2) {
    return [p1, p2].join(' ');
  }).split(' ');
  return {
    x: +translate[0] || 1,
    y: +translate[1] || 1
  };
};
drawing.setScale = function (element, x, y) {
  var re = /(\bscale\(.*?\);?)/;
  var getter = element.attr ? 'attr' : 'getAttribute';
  var setter = element.attr ? 'attr' : 'setAttribute';
  var transform = element[getter]('transform') || '';
  x = x || 1;
  y = y || 1;
  transform = transform.replace(re, '').trim();
  transform += 'scale(' + x + ',' + y + ')';
  transform = transform.trim();
  element[setter]('transform', transform);
  return transform;
};
var SCALE_RE = /\s*sc.*/;
drawing.setPointGroupScale = function (selection, xScale, yScale) {
  xScale = xScale || 1;
  yScale = yScale || 1;
  if (!selection) return;

  // The same scale transform for every point:
  var scale = xScale === 1 && yScale === 1 ? '' : 'scale(' + xScale + ',' + yScale + ')';
  selection.each(function () {
    var t = (this.getAttribute('transform') || '').replace(SCALE_RE, '');
    t += scale;
    t = t.trim();
    this.setAttribute('transform', t);
  });
};
var TEXT_POINT_LAST_TRANSLATION_RE = /translate\([^)]*\)\s*$/;
drawing.setTextPointsScale = function (selection, xScale, yScale) {
  if (!selection) return;
  selection.each(function () {
    var transforms;
    var el = d3.select(this);
    var text = el.select('text');
    if (!text.node()) return;
    var x = parseFloat(text.attr('x') || 0);
    var y = parseFloat(text.attr('y') || 0);
    var existingTransform = (el.attr('transform') || '').match(TEXT_POINT_LAST_TRANSLATION_RE);
    if (xScale === 1 && yScale === 1) {
      transforms = [];
    } else {
      transforms = [strTranslate(x, y), 'scale(' + xScale + ',' + yScale + ')', strTranslate(-x, -y)];
    }
    if (existingTransform) {
      transforms.push(existingTransform);
    }
    el.attr('transform', transforms.join(''));
  });
};
function getMarkerStandoff(d, trace) {
  var standoff;
  if (d) standoff = d.mf;
  if (standoff === undefined) {
    standoff = trace.marker ? trace.marker.standoff || 0 : 0;
  }
  if (!trace._geo && !trace._xA) {
    // case of legends
    return -standoff;
  }
  return standoff;
}
drawing.getMarkerStandoff = getMarkerStandoff;
var atan2 = Math.atan2;
var cos = Math.cos;
var sin = Math.sin;
function rotate(t, xy) {
  var x = xy[0];
  var y = xy[1];
  return [x * cos(t) - y * sin(t), x * sin(t) + y * cos(t)];
}
var previousLon;
var previousLat;
var previousX;
var previousY;
var previousI;
var previousTraceUid;
function getMarkerAngle(d, trace) {
  var angle = d.ma;
  if (angle === undefined) {
    angle = trace.marker.angle;
    if (!angle || Lib.isArrayOrTypedArray(angle)) {
      angle = 0;
    }
  }
  var x, y;
  var ref = trace.marker.angleref;
  if (ref === 'previous' || ref === 'north') {
    if (trace._geo) {
      var p = trace._geo.project(d.lonlat);
      x = p[0];
      y = p[1];
    } else {
      var xa = trace._xA;
      var ya = trace._yA;
      if (xa && ya) {
        x = xa.c2p(d.x);
        y = ya.c2p(d.y);
      } else {
        // case of legends
        return 90;
      }
    }
    if (trace._geo) {
      var lon = d.lonlat[0];
      var lat = d.lonlat[1];
      var north = trace._geo.project([lon, lat + 1e-5 // epsilon
      ]);
      var east = trace._geo.project([lon + 1e-5,
      // epsilon
      lat]);
      var u = atan2(east[1] - y, east[0] - x);
      var v = atan2(north[1] - y, north[0] - x);
      var t;
      if (ref === 'north') {
        t = angle / 180 * Math.PI;
        // To use counter-clockwise angles i.e.
        // East: 90, West: -90
        // to facilitate wind visualisations
        // in future we should use t = -t here.
      } else if (ref === 'previous') {
        var lon1 = lon / 180 * Math.PI;
        var lat1 = lat / 180 * Math.PI;
        var lon2 = previousLon / 180 * Math.PI;
        var lat2 = previousLat / 180 * Math.PI;
        var dLon = lon2 - lon1;
        var deltaY = cos(lat2) * sin(dLon);
        var deltaX = sin(lat2) * cos(lat1) - cos(lat2) * sin(lat1) * cos(dLon);
        t = -atan2(deltaY, deltaX) - Math.PI;
        previousLon = lon;
        previousLat = lat;
      }
      var A = rotate(u, [cos(t), 0]);
      var B = rotate(v, [sin(t), 0]);
      angle = atan2(A[1] + B[1], A[0] + B[0]) / Math.PI * 180;
      if (ref === 'previous' && !(previousTraceUid === trace.uid && d.i === previousI + 1)) {
        angle = null;
      }
    }
    if (ref === 'previous' && !trace._geo) {
      if (previousTraceUid === trace.uid && d.i === previousI + 1 && isNumeric(x) && isNumeric(y)) {
        var dX = x - previousX;
        var dY = y - previousY;
        var shape = trace.line ? trace.line.shape || '' : '';
        var lastShapeChar = shape.slice(shape.length - 1);
        if (lastShapeChar === 'h') dY = 0;
        if (lastShapeChar === 'v') dX = 0;
        angle += atan2(dY, dX) / Math.PI * 180 + 90;
      } else {
        angle = null;
      }
    }
  }
  previousX = x;
  previousY = y;
  previousI = d.i;
  previousTraceUid = trace.uid;
  return angle;
}
drawing.getMarkerAngle = getMarkerAngle;

/***/ }),

/***/ 38882:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var parseSvgPath = __webpack_require__(26953);
var round = (__webpack_require__(45568).round);

/** Marker symbol definitions
 * users can specify markers either by number or name
 * add 100 (or '-open') and you get an open marker
 *  open markers have no fill and use line color as the stroke color
 * add 200 (or '-dot') and you get a dot in the middle
 * add both and you get both
 */

var emptyPath = 'M0,0Z';
var sqrt2 = Math.sqrt(2);
var sqrt3 = Math.sqrt(3);
var PI = Math.PI;
var cos = Math.cos;
var sin = Math.sin;
module.exports = {
  circle: {
    n: 0,
    f: function (r, angle, standoff) {
      if (skipAngle(angle)) return emptyPath;
      var rs = round(r, 2);
      var circle = 'M' + rs + ',0A' + rs + ',' + rs + ' 0 1,1 0,-' + rs + 'A' + rs + ',' + rs + ' 0 0,1 ' + rs + ',0Z';
      return standoff ? align(angle, standoff, circle) : circle;
    }
  },
  square: {
    n: 1,
    f: function (r, angle, standoff) {
      if (skipAngle(angle)) return emptyPath;
      var rs = round(r, 2);
      return align(angle, standoff, 'M' + rs + ',' + rs + 'H-' + rs + 'V-' + rs + 'H' + rs + 'Z');
    }
  },
  diamond: {
    n: 2,
    f: function (r, angle, standoff) {
      if (skipAngle(angle)) return emptyPath;
      var rd = round(r * 1.3, 2);
      return align(angle, standoff, 'M' + rd + ',0L0,' + rd + 'L-' + rd + ',0L0,-' + rd + 'Z');
    }
  },
  cross: {
    n: 3,
    f: function (r, angle, standoff) {
      if (skipAngle(angle)) return emptyPath;
      var rc = round(r * 0.4, 2);
      var rc2 = round(r * 1.2, 2);
      return align(angle, standoff, 'M' + rc2 + ',' + rc + 'H' + rc + 'V' + rc2 + 'H-' + rc + 'V' + rc + 'H-' + rc2 + 'V-' + rc + 'H-' + rc + 'V-' + rc2 + 'H' + rc + 'V-' + rc + 'H' + rc2 + 'Z');
    }
  },
  x: {
    n: 4,
    f: function (r, angle, standoff) {
      if (skipAngle(angle)) return emptyPath;
      var rx = round(r * 0.8 / sqrt2, 2);
      var ne = 'l' + rx + ',' + rx;
      var se = 'l' + rx + ',-' + rx;
      var sw = 'l-' + rx + ',-' + rx;
      var nw = 'l-' + rx + ',' + rx;
      return align(angle, standoff, 'M0,' + rx + ne + se + sw + se + sw + nw + sw + nw + ne + nw + ne + 'Z');
    }
  },
  'triangle-up': {
    n: 5,
    f: function (r, angle, standoff) {
      if (skipAngle(angle)) return emptyPath;
      var rt = round(r * 2 / sqrt3, 2);
      var r2 = round(r / 2, 2);
      var rs = round(r, 2);
      return align(angle, standoff, 'M-' + rt + ',' + r2 + 'H' + rt + 'L0,-' + rs + 'Z');
    }
  },
  'triangle-down': {
    n: 6,
    f: function (r, angle, standoff) {
      if (skipAngle(angle)) return emptyPath;
      var rt = round(r * 2 / sqrt3, 2);
      var r2 = round(r / 2, 2);
      var rs = round(r, 2);
      return align(angle, standoff, 'M-' + rt + ',-' + r2 + 'H' + rt + 'L0,' + rs + 'Z');
    }
  },
  'triangle-left': {
    n: 7,
    f: function (r, angle, standoff) {
      if (skipAngle(angle)) return emptyPath;
      var rt = round(r * 2 / sqrt3, 2);
      var r2 = round(r / 2, 2);
      var rs = round(r, 2);
      return align(angle, standoff, 'M' + r2 + ',-' + rt + 'V' + rt + 'L-' + rs + ',0Z');
    }
  },
  'triangle-right': {
    n: 8,
    f: function (r, angle, standoff) {
      if (skipAngle(angle)) return emptyPath;
      var rt = round(r * 2 / sqrt3, 2);
      var r2 = round(r / 2, 2);
      var rs = round(r, 2);
      return align(angle, standoff, 'M-' + r2 + ',-' + rt + 'V' + rt + 'L' + rs + ',0Z');
    }
  },
  'triangle-ne': {
    n: 9,
    f: function (r, angle, standoff) {
      if (skipAngle(angle)) return emptyPath;
      var r1 = round(r * 0.6, 2);
      var r2 = round(r * 1.2, 2);
      return align(angle, standoff, 'M-' + r2 + ',-' + r1 + 'H' + r1 + 'V' + r2 + 'Z');
    }
  },
  'triangle-se': {
    n: 10,
    f: function (r, angle, standoff) {
      if (skipAngle(angle)) return emptyPath;
      var r1 = round(r * 0.6, 2);
      var r2 = round(r * 1.2, 2);
      return align(angle, standoff, 'M' + r1 + ',-' + r2 + 'V' + r1 + 'H-' + r2 + 'Z');
    }
  },
  'triangle-sw': {
    n: 11,
    f: function (r, angle, standoff) {
      if (skipAngle(angle)) return emptyPath;
      var r1 = round(r * 0.6, 2);
      var r2 = round(r * 1.2, 2);
      return align(angle, standoff, 'M' + r2 + ',' + r1 + 'H-' + r1 + 'V-' + r2 + 'Z');
    }
  },
  'triangle-nw': {
    n: 12,
    f: function (r, angle, standoff) {
      if (skipAngle(angle)) return emptyPath;
      var r1 = round(r * 0.6, 2);
      var r2 = round(r * 1.2, 2);
      return align(angle, standoff, 'M-' + r1 + ',' + r2 + 'V-' + r1 + 'H' + r2 + 'Z');
    }
  },
  pentagon: {
    n: 13,
    f: function (r, angle, standoff) {
      if (skipAngle(angle)) return emptyPath;
      var x1 = round(r * 0.951, 2);
      var x2 = round(r * 0.588, 2);
      var y0 = round(-r, 2);
      var y1 = round(r * -0.309, 2);
      var y2 = round(r * 0.809, 2);
      return align(angle, standoff, 'M' + x1 + ',' + y1 + 'L' + x2 + ',' + y2 + 'H-' + x2 + 'L-' + x1 + ',' + y1 + 'L0,' + y0 + 'Z');
    }
  },
  hexagon: {
    n: 14,
    f: function (r, angle, standoff) {
      if (skipAngle(angle)) return emptyPath;
      var y0 = round(r, 2);
      var y1 = round(r / 2, 2);
      var x = round(r * sqrt3 / 2, 2);
      return align(angle, standoff, 'M' + x + ',-' + y1 + 'V' + y1 + 'L0,' + y0 + 'L-' + x + ',' + y1 + 'V-' + y1 + 'L0,-' + y0 + 'Z');
    }
  },
  hexagon2: {
    n: 15,
    f: function (r, angle, standoff) {
      if (skipAngle(angle)) return emptyPath;
      var x0 = round(r, 2);
      var x1 = round(r / 2, 2);
      var y = round(r * sqrt3 / 2, 2);
      return align(angle, standoff, 'M-' + x1 + ',' + y + 'H' + x1 + 'L' + x0 + ',0L' + x1 + ',-' + y + 'H-' + x1 + 'L-' + x0 + ',0Z');
    }
  },
  octagon: {
    n: 16,
    f: function (r, angle, standoff) {
      if (skipAngle(angle)) return emptyPath;
      var a = round(r * 0.924, 2);
      var b = round(r * 0.383, 2);
      return align(angle, standoff, 'M-' + b + ',-' + a + 'H' + b + 'L' + a + ',-' + b + 'V' + b + 'L' + b + ',' + a + 'H-' + b + 'L-' + a + ',' + b + 'V-' + b + 'Z');
    }
  },
  star: {
    n: 17,
    f: function (r, angle, standoff) {
      if (skipAngle(angle)) return emptyPath;
      var rs = r * 1.4;
      var x1 = round(rs * 0.225, 2);
      var x2 = round(rs * 0.951, 2);
      var x3 = round(rs * 0.363, 2);
      var x4 = round(rs * 0.588, 2);
      var y0 = round(-rs, 2);
      var y1 = round(rs * -0.309, 2);
      var y3 = round(rs * 0.118, 2);
      var y4 = round(rs * 0.809, 2);
      var y5 = round(rs * 0.382, 2);
      return align(angle, standoff, 'M' + x1 + ',' + y1 + 'H' + x2 + 'L' + x3 + ',' + y3 + 'L' + x4 + ',' + y4 + 'L0,' + y5 + 'L-' + x4 + ',' + y4 + 'L-' + x3 + ',' + y3 + 'L-' + x2 + ',' + y1 + 'H-' + x1 + 'L0,' + y0 + 'Z');
    }
  },
  hexagram: {
    n: 18,
    f: function (r, angle, standoff) {
      if (skipAngle(angle)) return emptyPath;
      var y = round(r * 0.66, 2);
      var x1 = round(r * 0.38, 2);
      var x2 = round(r * 0.76, 2);
      return align(angle, standoff, 'M-' + x2 + ',0l-' + x1 + ',-' + y + 'h' + x2 + 'l' + x1 + ',-' + y + 'l' + x1 + ',' + y + 'h' + x2 + 'l-' + x1 + ',' + y + 'l' + x1 + ',' + y + 'h-' + x2 + 'l-' + x1 + ',' + y + 'l-' + x1 + ',-' + y + 'h-' + x2 + 'Z');
    }
  },
  'star-triangle-up': {
    n: 19,
    f: function (r, angle, standoff) {
      if (skipAngle(angle)) return emptyPath;
      var x = round(r * sqrt3 * 0.8, 2);
      var y1 = round(r * 0.8, 2);
      var y2 = round(r * 1.6, 2);
      var rc = round(r * 4, 2);
      var aPart = 'A ' + rc + ',' + rc + ' 0 0 1 ';
      return align(angle, standoff, 'M-' + x + ',' + y1 + aPart + x + ',' + y1 + aPart + '0,-' + y2 + aPart + '-' + x + ',' + y1 + 'Z');
    }
  },
  'star-triangle-down': {
    n: 20,
    f: function (r, angle, standoff) {
      if (skipAngle(angle)) return emptyPath;
      var x = round(r * sqrt3 * 0.8, 2);
      var y1 = round(r * 0.8, 2);
      var y2 = round(r * 1.6, 2);
      var rc = round(r * 4, 2);
      var aPart = 'A ' + rc + ',' + rc + ' 0 0 1 ';
      return align(angle, standoff, 'M' + x + ',-' + y1 + aPart + '-' + x + ',-' + y1 + aPart + '0,' + y2 + aPart + x + ',-' + y1 + 'Z');
    }
  },
  'star-square': {
    n: 21,
    f: function (r, angle, standoff) {
      if (skipAngle(angle)) return emptyPath;
      var rp = round(r * 1.1, 2);
      var rc = round(r * 2, 2);
      var aPart = 'A ' + rc + ',' + rc + ' 0 0 1 ';
      return align(angle, standoff, 'M-' + rp + ',-' + rp + aPart + '-' + rp + ',' + rp + aPart + rp + ',' + rp + aPart + rp + ',-' + rp + aPart + '-' + rp + ',-' + rp + 'Z');
    }
  },
  'star-diamond': {
    n: 22,
    f: function (r, angle, standoff) {
      if (skipAngle(angle)) return emptyPath;
      var rp = round(r * 1.4, 2);
      var rc = round(r * 1.9, 2);
      var aPart = 'A ' + rc + ',' + rc + ' 0 0 1 ';
      return align(angle, standoff, 'M-' + rp + ',0' + aPart + '0,' + rp + aPart + rp + ',0' + aPart + '0,-' + rp + aPart + '-' + rp + ',0' + 'Z');
    }
  },
  'diamond-tall': {
    n: 23,
    f: function (r, angle, standoff) {
      if (skipAngle(angle)) return emptyPath;
      var x = round(r * 0.7, 2);
      var y = round(r * 1.4, 2);
      return align(angle, standoff, 'M0,' + y + 'L' + x + ',0L0,-' + y + 'L-' + x + ',0Z');
    }
  },
  'diamond-wide': {
    n: 24,
    f: function (r, angle, standoff) {
      if (skipAngle(angle)) return emptyPath;
      var x = round(r * 1.4, 2);
      var y = round(r * 0.7, 2);
      return align(angle, standoff, 'M0,' + y + 'L' + x + ',0L0,-' + y + 'L-' + x + ',0Z');
    }
  },
  hourglass: {
    n: 25,
    f: function (r, angle, standoff) {
      if (skipAngle(angle)) return emptyPath;
      var rs = round(r, 2);
      return align(angle, standoff, 'M' + rs + ',' + rs + 'H-' + rs + 'L' + rs + ',-' + rs + 'H-' + rs + 'Z');
    },
    noDot: true
  },
  bowtie: {
    n: 26,
    f: function (r, angle, standoff) {
      if (skipAngle(angle)) return emptyPath;
      var rs = round(r, 2);
      return align(angle, standoff, 'M' + rs + ',' + rs + 'V-' + rs + 'L-' + rs + ',' + rs + 'V-' + rs + 'Z');
    },
    noDot: true
  },
  'circle-cross': {
    n: 27,
    f: function (r, angle, standoff) {
      if (skipAngle(angle)) return emptyPath;
      var rs = round(r, 2);
      return align(angle, standoff, 'M0,' + rs + 'V-' + rs + 'M' + rs + ',0H-' + rs + 'M' + rs + ',0A' + rs + ',' + rs + ' 0 1,1 0,-' + rs + 'A' + rs + ',' + rs + ' 0 0,1 ' + rs + ',0Z');
    },
    needLine: true,
    noDot: true
  },
  'circle-x': {
    n: 28,
    f: function (r, angle, standoff) {
      if (skipAngle(angle)) return emptyPath;
      var rs = round(r, 2);
      var rc = round(r / sqrt2, 2);
      return align(angle, standoff, 'M' + rc + ',' + rc + 'L-' + rc + ',-' + rc + 'M' + rc + ',-' + rc + 'L-' + rc + ',' + rc + 'M' + rs + ',0A' + rs + ',' + rs + ' 0 1,1 0,-' + rs + 'A' + rs + ',' + rs + ' 0 0,1 ' + rs + ',0Z');
    },
    needLine: true,
    noDot: true
  },
  'square-cross': {
    n: 29,
    f: function (r, angle, standoff) {
      if (skipAngle(angle)) return emptyPath;
      var rs = round(r, 2);
      return align(angle, standoff, 'M0,' + rs + 'V-' + rs + 'M' + rs + ',0H-' + rs + 'M' + rs + ',' + rs + 'H-' + rs + 'V-' + rs + 'H' + rs + 'Z');
    },
    needLine: true,
    noDot: true
  },
  'square-x': {
    n: 30,
    f: function (r, angle, standoff) {
      if (skipAngle(angle)) return emptyPath;
      var rs = round(r, 2);
      return align(angle, standoff, 'M' + rs + ',' + rs + 'L-' + rs + ',-' + rs + 'M' + rs + ',-' + rs + 'L-' + rs + ',' + rs + 'M' + rs + ',' + rs + 'H-' + rs + 'V-' + rs + 'H' + rs + 'Z');
    },
    needLine: true,
    noDot: true
  },
  'diamond-cross': {
    n: 31,
    f: function (r, angle, standoff) {
      if (skipAngle(angle)) return emptyPath;
      var rd = round(r * 1.3, 2);
      return align(angle, standoff, 'M' + rd + ',0L0,' + rd + 'L-' + rd + ',0L0,-' + rd + 'Z' + 'M0,-' + rd + 'V' + rd + 'M-' + rd + ',0H' + rd);
    },
    needLine: true,
    noDot: true
  },
  'diamond-x': {
    n: 32,
    f: function (r, angle, standoff) {
      if (skipAngle(angle)) return emptyPath;
      var rd = round(r * 1.3, 2);
      var r2 = round(r * 0.65, 2);
      return align(angle, standoff, 'M' + rd + ',0L0,' + rd + 'L-' + rd + ',0L0,-' + rd + 'Z' + 'M-' + r2 + ',-' + r2 + 'L' + r2 + ',' + r2 + 'M-' + r2 + ',' + r2 + 'L' + r2 + ',-' + r2);
    },
    needLine: true,
    noDot: true
  },
  'cross-thin': {
    n: 33,
    f: function (r, angle, standoff) {
      if (skipAngle(angle)) return emptyPath;
      var rc = round(r * 1.4, 2);
      return align(angle, standoff, 'M0,' + rc + 'V-' + rc + 'M' + rc + ',0H-' + rc);
    },
    needLine: true,
    noDot: true,
    noFill: true
  },
  'x-thin': {
    n: 34,
    f: function (r, angle, standoff) {
      if (skipAngle(angle)) return emptyPath;
      var rx = round(r, 2);
      return align(angle, standoff, 'M' + rx + ',' + rx + 'L-' + rx + ',-' + rx + 'M' + rx + ',-' + rx + 'L-' + rx + ',' + rx);
    },
    needLine: true,
    noDot: true,
    noFill: true
  },
  asterisk: {
    n: 35,
    f: function (r, angle, standoff) {
      if (skipAngle(angle)) return emptyPath;
      var rc = round(r * 1.2, 2);
      var rs = round(r * 0.85, 2);
      return align(angle, standoff, 'M0,' + rc + 'V-' + rc + 'M' + rc + ',0H-' + rc + 'M' + rs + ',' + rs + 'L-' + rs + ',-' + rs + 'M' + rs + ',-' + rs + 'L-' + rs + ',' + rs);
    },
    needLine: true,
    noDot: true,
    noFill: true
  },
  hash: {
    n: 36,
    f: function (r, angle, standoff) {
      if (skipAngle(angle)) return emptyPath;
      var r1 = round(r / 2, 2);
      var r2 = round(r, 2);
      return align(angle, standoff, 'M' + r1 + ',' + r2 + 'V-' + r2 + 'M' + (r1 - r2) + ',-' + r2 + 'V' + r2 + 'M' + r2 + ',' + r1 + 'H-' + r2 + 'M-' + r2 + ',' + (r1 - r2) + 'H' + r2);
    },
    needLine: true,
    noFill: true
  },
  'y-up': {
    n: 37,
    f: function (r, angle, standoff) {
      if (skipAngle(angle)) return emptyPath;
      var x = round(r * 1.2, 2);
      var y0 = round(r * 1.6, 2);
      var y1 = round(r * 0.8, 2);
      return align(angle, standoff, 'M-' + x + ',' + y1 + 'L0,0M' + x + ',' + y1 + 'L0,0M0,-' + y0 + 'L0,0');
    },
    needLine: true,
    noDot: true,
    noFill: true
  },
  'y-down': {
    n: 38,
    f: function (r, angle, standoff) {
      if (skipAngle(angle)) return emptyPath;
      var x = round(r * 1.2, 2);
      var y0 = round(r * 1.6, 2);
      var y1 = round(r * 0.8, 2);
      return align(angle, standoff, 'M-' + x + ',-' + y1 + 'L0,0M' + x + ',-' + y1 + 'L0,0M0,' + y0 + 'L0,0');
    },
    needLine: true,
    noDot: true,
    noFill: true
  },
  'y-left': {
    n: 39,
    f: function (r, angle, standoff) {
      if (skipAngle(angle)) return emptyPath;
      var y = round(r * 1.2, 2);
      var x0 = round(r * 1.6, 2);
      var x1 = round(r * 0.8, 2);
      return align(angle, standoff, 'M' + x1 + ',' + y + 'L0,0M' + x1 + ',-' + y + 'L0,0M-' + x0 + ',0L0,0');
    },
    needLine: true,
    noDot: true,
    noFill: true
  },
  'y-right': {
    n: 40,
    f: function (r, angle, standoff) {
      if (skipAngle(angle)) return emptyPath;
      var y = round(r * 1.2, 2);
      var x0 = round(r * 1.6, 2);
      var x1 = round(r * 0.8, 2);
      return align(angle, standoff, 'M-' + x1 + ',' + y + 'L0,0M-' + x1 + ',-' + y + 'L0,0M' + x0 + ',0L0,0');
    },
    needLine: true,
    noDot: true,
    noFill: true
  },
  'line-ew': {
    n: 41,
    f: function (r, angle, standoff) {
      if (skipAngle(angle)) return emptyPath;
      var rc = round(r * 1.4, 2);
      return align(angle, standoff, 'M' + rc + ',0H-' + rc);
    },
    needLine: true,
    noDot: true,
    noFill: true
  },
  'line-ns': {
    n: 42,
    f: function (r, angle, standoff) {
      if (skipAngle(angle)) return emptyPath;
      var rc = round(r * 1.4, 2);
      return align(angle, standoff, 'M0,' + rc + 'V-' + rc);
    },
    needLine: true,
    noDot: true,
    noFill: true
  },
  'line-ne': {
    n: 43,
    f: function (r, angle, standoff) {
      if (skipAngle(angle)) return emptyPath;
      var rx = round(r, 2);
      return align(angle, standoff, 'M' + rx + ',-' + rx + 'L-' + rx + ',' + rx);
    },
    needLine: true,
    noDot: true,
    noFill: true
  },
  'line-nw': {
    n: 44,
    f: function (r, angle, standoff) {
      if (skipAngle(angle)) return emptyPath;
      var rx = round(r, 2);
      return align(angle, standoff, 'M' + rx + ',' + rx + 'L-' + rx + ',-' + rx);
    },
    needLine: true,
    noDot: true,
    noFill: true
  },
  'arrow-up': {
    n: 45,
    f: function (r, angle, standoff) {
      if (skipAngle(angle)) return emptyPath;
      var rx = round(r, 2);
      var ry = round(r * 2, 2);
      return align(angle, standoff, 'M0,0L-' + rx + ',' + ry + 'H' + rx + 'Z');
    },
    backoff: 1,
    noDot: true
  },
  'arrow-down': {
    n: 46,
    f: function (r, angle, standoff) {
      if (skipAngle(angle)) return emptyPath;
      var rx = round(r, 2);
      var ry = round(r * 2, 2);
      return align(angle, standoff, 'M0,0L-' + rx + ',-' + ry + 'H' + rx + 'Z');
    },
    noDot: true
  },
  'arrow-left': {
    n: 47,
    f: function (r, angle, standoff) {
      if (skipAngle(angle)) return emptyPath;
      var rx = round(r * 2, 2);
      var ry = round(r, 2);
      return align(angle, standoff, 'M0,0L' + rx + ',-' + ry + 'V' + ry + 'Z');
    },
    noDot: true
  },
  'arrow-right': {
    n: 48,
    f: function (r, angle, standoff) {
      if (skipAngle(angle)) return emptyPath;
      var rx = round(r * 2, 2);
      var ry = round(r, 2);
      return align(angle, standoff, 'M0,0L-' + rx + ',-' + ry + 'V' + ry + 'Z');
    },
    noDot: true
  },
  'arrow-bar-up': {
    n: 49,
    f: function (r, angle, standoff) {
      if (skipAngle(angle)) return emptyPath;
      var rx = round(r, 2);
      var ry = round(r * 2, 2);
      return align(angle, standoff, 'M-' + rx + ',0H' + rx + 'M0,0L-' + rx + ',' + ry + 'H' + rx + 'Z');
    },
    backoff: 1,
    needLine: true,
    noDot: true
  },
  'arrow-bar-down': {
    n: 50,
    f: function (r, angle, standoff) {
      if (skipAngle(angle)) return emptyPath;
      var rx = round(r, 2);
      var ry = round(r * 2, 2);
      return align(angle, standoff, 'M-' + rx + ',0H' + rx + 'M0,0L-' + rx + ',-' + ry + 'H' + rx + 'Z');
    },
    needLine: true,
    noDot: true
  },
  'arrow-bar-left': {
    n: 51,
    f: function (r, angle, standoff) {
      if (skipAngle(angle)) return emptyPath;
      var rx = round(r * 2, 2);
      var ry = round(r, 2);
      return align(angle, standoff, 'M0,-' + ry + 'V' + ry + 'M0,0L' + rx + ',-' + ry + 'V' + ry + 'Z');
    },
    needLine: true,
    noDot: true
  },
  'arrow-bar-right': {
    n: 52,
    f: function (r, angle, standoff) {
      if (skipAngle(angle)) return emptyPath;
      var rx = round(r * 2, 2);
      var ry = round(r, 2);
      return align(angle, standoff, 'M0,-' + ry + 'V' + ry + 'M0,0L-' + rx + ',-' + ry + 'V' + ry + 'Z');
    },
    needLine: true,
    noDot: true
  },
  arrow: {
    n: 53,
    f: function (r, angle, standoff) {
      if (skipAngle(angle)) return emptyPath;
      var headAngle = PI / 2.5; // 36 degrees - golden ratio
      var x = 2 * r * cos(headAngle);
      var y = 2 * r * sin(headAngle);
      return align(angle, standoff, 'M0,0' + 'L' + -x + ',' + y + 'L' + x + ',' + y + 'Z');
    },
    backoff: 0.9,
    noDot: true
  },
  'arrow-wide': {
    n: 54,
    f: function (r, angle, standoff) {
      if (skipAngle(angle)) return emptyPath;
      var headAngle = PI / 4; // 90 degrees
      var x = 2 * r * cos(headAngle);
      var y = 2 * r * sin(headAngle);
      return align(angle, standoff, 'M0,0' + 'L' + -x + ',' + y + 'A ' + 2 * r + ',' + 2 * r + ' 0 0 1 ' + x + ',' + y + 'Z');
    },
    backoff: 0.4,
    noDot: true
  }
};
function skipAngle(angle) {
  return angle === null;
}
var lastPathIn, lastPathOut;
var lastAngle, lastStandoff;
function align(angle, standoff, path) {
  if ((!angle || angle % 360 === 0) && !standoff) return path;
  if (lastAngle === angle && lastStandoff === standoff && lastPathIn === path) return lastPathOut;
  lastAngle = angle;
  lastStandoff = standoff;
  lastPathIn = path;
  function rotate(t, xy) {
    var cosT = cos(t);
    var sinT = sin(t);
    var x = xy[0];
    var y = xy[1] + (standoff || 0);
    return [x * cosT - y * sinT, x * sinT + y * cosT];
  }
  var t = angle / 180 * PI;
  var x = 0;
  var y = 0;
  var cmd = parseSvgPath(path);
  var str = '';
  for (var i = 0; i < cmd.length; i++) {
    var cmdI = cmd[i];
    var op = cmdI[0];
    var x0 = x;
    var y0 = y;
    if (op === 'M' || op === 'L') {
      x = +cmdI[1];
      y = +cmdI[2];
    } else if (op === 'm' || op === 'l') {
      x += +cmdI[1];
      y += +cmdI[2];
    } else if (op === 'H') {
      x = +cmdI[1];
    } else if (op === 'h') {
      x += +cmdI[1];
    } else if (op === 'V') {
      y = +cmdI[1];
    } else if (op === 'v') {
      y += +cmdI[1];
    } else if (op === 'A') {
      x = +cmdI[1];
      y = +cmdI[2];
      var E = rotate(t, [+cmdI[6], +cmdI[7]]);
      cmdI[6] = E[0];
      cmdI[7] = E[1];
      cmdI[3] = +cmdI[3] + angle;
    }

    // change from H, V, h, v to L or l
    if (op === 'H' || op === 'V') op = 'L';
    if (op === 'h' || op === 'v') op = 'l';
    if (op === 'm' || op === 'l') {
      x -= x0;
      y -= y0;
    }
    var B = rotate(t, [x, y]);
    if (op === 'H' || op === 'V') op = 'L';
    if (op === 'M' || op === 'L' || op === 'm' || op === 'l') {
      cmdI[1] = B[0];
      cmdI[2] = B[1];
    }
    cmdI[0] = op;
    str += cmdI[0] + cmdI.slice(1).join(',');
  }
  lastPathOut = str;
  return str;
}

/***/ }),

/***/ 75568:
/***/ (function(module) {

"use strict";


module.exports = {
  visible: {
    valType: 'boolean',
    editType: 'calc'
  },
  type: {
    valType: 'enumerated',
    values: ['percent', 'constant', 'sqrt', 'data'],
    editType: 'calc'
  },
  symmetric: {
    valType: 'boolean',
    editType: 'calc'
  },
  array: {
    valType: 'data_array',
    editType: 'calc'
  },
  arrayminus: {
    valType: 'data_array',
    editType: 'calc'
  },
  value: {
    valType: 'number',
    min: 0,
    dflt: 10,
    editType: 'calc'
  },
  valueminus: {
    valType: 'number',
    min: 0,
    dflt: 10,
    editType: 'calc'
  },
  traceref: {
    valType: 'integer',
    min: 0,
    dflt: 0,
    editType: 'style'
  },
  tracerefminus: {
    valType: 'integer',
    min: 0,
    dflt: 0,
    editType: 'style'
  },
  copy_ystyle: {
    valType: 'boolean',
    editType: 'plot'
  },
  copy_zstyle: {
    valType: 'boolean',
    editType: 'style'
  },
  color: {
    valType: 'color',
    editType: 'style'
  },
  thickness: {
    valType: 'number',
    min: 0,
    dflt: 2,
    editType: 'style'
  },
  width: {
    valType: 'number',
    min: 0,
    editType: 'plot'
  },
  editType: 'calc',
  _deprecated: {
    opacity: {
      valType: 'number',
      editType: 'style'
    }
  }
};

/***/ }),

/***/ 352:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isNumeric = __webpack_require__(10721);
var Registry = __webpack_require__(33626);
var Axes = __webpack_require__(29714);
var Lib = __webpack_require__(34809);
var makeComputeError = __webpack_require__(25589);
module.exports = function calc(gd) {
  var calcdata = gd.calcdata;
  for (var i = 0; i < calcdata.length; i++) {
    var calcTrace = calcdata[i];
    var trace = calcTrace[0].trace;
    if (trace.visible === true && Registry.traceIs(trace, 'errorBarsOK')) {
      var xa = Axes.getFromId(gd, trace.xaxis);
      var ya = Axes.getFromId(gd, trace.yaxis);
      calcOneAxis(calcTrace, trace, xa, 'x');
      calcOneAxis(calcTrace, trace, ya, 'y');
    }
  }
};
function calcOneAxis(calcTrace, trace, axis, coord) {
  var opts = trace['error_' + coord] || {};
  var isVisible = opts.visible && ['linear', 'log'].indexOf(axis.type) !== -1;
  var vals = [];
  if (!isVisible) return;
  var computeError = makeComputeError(opts);
  for (var i = 0; i < calcTrace.length; i++) {
    var calcPt = calcTrace[i];
    var iIn = calcPt.i;

    // for types that don't include `i` in each calcdata point
    if (iIn === undefined) iIn = i;

    // for stacked area inserted points
    // TODO: errorbars have been tested cursorily with stacked area,
    // but not thoroughly. It's not even really clear what you want to do:
    // Should it just be calculated based on that trace's size data?
    // Should you add errors from below in quadrature?
    // And what about normalization, where in principle the errors shrink
    // again when you get up to the top end?
    // One option would be to forbid errorbars with stacking until we
    // decide how to handle these questions.
    else if (iIn === null) continue;
    var calcCoord = calcPt[coord];
    if (!isNumeric(axis.c2l(calcCoord))) continue;
    var errors = computeError(calcCoord, iIn);
    if (isNumeric(errors[0]) && isNumeric(errors[1])) {
      var shoe = calcPt[coord + 's'] = calcCoord - errors[0];
      var hat = calcPt[coord + 'h'] = calcCoord + errors[1];
      vals.push(shoe, hat);
    }
  }
  var axId = axis._id;
  var baseExtremes = trace._extremes[axId];
  var extremes = Axes.findExtremes(axis, vals, Lib.extendFlat({
    tozero: baseExtremes.opts.tozero
  }, {
    padded: true
  }));
  baseExtremes.min = baseExtremes.min.concat(extremes.min);
  baseExtremes.max = baseExtremes.max.concat(extremes.max);
}

/***/ }),

/***/ 25589:
/***/ (function(module) {

"use strict";


/**
 * Error bar computing function generator
 *
 * N.B. The generated function does not clean the dataPt entries. Non-numeric
 * entries result in undefined error magnitudes.
 *
 * @param {object} opts error bar attributes
 *
 * @return {function} :
 *      @param {numeric} dataPt data point from where to compute the error magnitude
 *      @param {number} index index of dataPt in its corresponding data array
 *      @return {array}
 *        - error[0] : error magnitude in the negative direction
 *        - error[1] : " " " " positive "
 */
module.exports = function makeComputeError(opts) {
  var type = opts.type;
  var symmetric = opts.symmetric;
  if (type === 'data') {
    var array = opts.array || [];
    if (symmetric) {
      return function computeError(dataPt, index) {
        var val = +array[index];
        return [val, val];
      };
    } else {
      var arrayminus = opts.arrayminus || [];
      return function computeError(dataPt, index) {
        var val = +array[index];
        var valMinus = +arrayminus[index];
        // in case one is present and the other is missing, fill in 0
        // so we still see the present one. Mostly useful during manual
        // data entry.
        if (!isNaN(val) || !isNaN(valMinus)) {
          return [valMinus || 0, val || 0];
        }
        return [NaN, NaN];
      };
    }
  } else {
    var computeErrorValue = makeComputeErrorValue(type, opts.value);
    var computeErrorValueMinus = makeComputeErrorValue(type, opts.valueminus);
    if (symmetric || opts.valueminus === undefined) {
      return function computeError(dataPt) {
        var val = computeErrorValue(dataPt);
        return [val, val];
      };
    } else {
      return function computeError(dataPt) {
        return [computeErrorValueMinus(dataPt), computeErrorValue(dataPt)];
      };
    }
  }
};

/**
 * Compute error bar magnitude (for all types except data)
 *
 * @param {string} type error bar type
 * @param {numeric} value error bar value
 *
 * @return {function} :
 *      @param {numeric} dataPt
 */
function makeComputeErrorValue(type, value) {
  if (type === 'percent') {
    return function (dataPt) {
      return Math.abs(dataPt * value / 100);
    };
  }
  if (type === 'constant') {
    return function () {
      return Math.abs(value);
    };
  }
  if (type === 'sqrt') {
    return function (dataPt) {
      return Math.sqrt(Math.abs(dataPt));
    };
  }
}

/***/ }),

/***/ 5543:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isNumeric = __webpack_require__(10721);
var Registry = __webpack_require__(33626);
var Lib = __webpack_require__(34809);
var Template = __webpack_require__(78032);
var attributes = __webpack_require__(75568);
module.exports = function (traceIn, traceOut, defaultColor, opts) {
  var objName = 'error_' + opts.axis;
  var containerOut = Template.newContainer(traceOut, objName);
  var containerIn = traceIn[objName] || {};
  function coerce(attr, dflt) {
    return Lib.coerce(containerIn, containerOut, attributes, attr, dflt);
  }
  var hasErrorBars = containerIn.array !== undefined || containerIn.value !== undefined || containerIn.type === 'sqrt';
  var visible = coerce('visible', hasErrorBars);
  if (visible === false) return;
  var type = coerce('type', 'array' in containerIn ? 'data' : 'percent');
  var symmetric = true;
  if (type !== 'sqrt') {
    symmetric = coerce('symmetric', !((type === 'data' ? 'arrayminus' : 'valueminus') in containerIn));
  }
  if (type === 'data') {
    coerce('array');
    coerce('traceref');
    if (!symmetric) {
      coerce('arrayminus');
      coerce('tracerefminus');
    }
  } else if (type === 'percent' || type === 'constant') {
    coerce('value');
    if (!symmetric) coerce('valueminus');
  }
  var copyAttr = 'copy_' + opts.inherit + 'style';
  if (opts.inherit) {
    var inheritObj = traceOut['error_' + opts.inherit];
    if ((inheritObj || {}).visible) {
      coerce(copyAttr, !(containerIn.color || isNumeric(containerIn.thickness) || isNumeric(containerIn.width)));
    }
  }
  if (!opts.inherit || !containerOut[copyAttr]) {
    coerce('color', defaultColor);
    coerce('thickness');
    coerce('width', Registry.traceIs(traceOut, 'gl3d') ? 0 : 4);
  }
};

/***/ }),

/***/ 77901:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var overrideAll = (__webpack_require__(13582).overrideAll);
var attributes = __webpack_require__(75568);
var xyAttrs = {
  error_x: Lib.extendFlat({}, attributes),
  error_y: Lib.extendFlat({}, attributes)
};
delete xyAttrs.error_x.copy_zstyle;
delete xyAttrs.error_y.copy_zstyle;
delete xyAttrs.error_y.copy_ystyle;
var xyzAttrs = {
  error_x: Lib.extendFlat({}, attributes),
  error_y: Lib.extendFlat({}, attributes),
  error_z: Lib.extendFlat({}, attributes)
};
delete xyzAttrs.error_x.copy_ystyle;
delete xyzAttrs.error_y.copy_ystyle;
delete xyzAttrs.error_z.copy_ystyle;
delete xyzAttrs.error_z.copy_zstyle;
module.exports = {
  moduleType: 'component',
  name: 'errorbars',
  schema: {
    traces: {
      scatter: xyAttrs,
      bar: xyAttrs,
      histogram: xyAttrs,
      scatter3d: overrideAll(xyzAttrs, 'calc', 'nested'),
      scattergl: overrideAll(xyAttrs, 'calc', 'nested')
    }
  },
  supplyDefaults: __webpack_require__(5543),
  calc: __webpack_require__(352),
  makeComputeError: __webpack_require__(25589),
  plot: __webpack_require__(42130),
  style: __webpack_require__(22800),
  hoverInfo: hoverInfo
};
function hoverInfo(calcPoint, trace, hoverPoint) {
  if ((trace.error_y || {}).visible) {
    hoverPoint.yerr = calcPoint.yh - calcPoint.y;
    if (!trace.error_y.symmetric) hoverPoint.yerrneg = calcPoint.y - calcPoint.ys;
  }
  if ((trace.error_x || {}).visible) {
    hoverPoint.xerr = calcPoint.xh - calcPoint.x;
    if (!trace.error_x.symmetric) hoverPoint.xerrneg = calcPoint.x - calcPoint.xs;
  }
}

/***/ }),

/***/ 42130:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var isNumeric = __webpack_require__(10721);
var Drawing = __webpack_require__(62203);
var subTypes = __webpack_require__(64726);
module.exports = function plot(gd, traces, plotinfo, transitionOpts) {
  var isNew;
  var xa = plotinfo.xaxis;
  var ya = plotinfo.yaxis;
  var hasAnimation = transitionOpts && transitionOpts.duration > 0;
  var isStatic = gd._context.staticPlot;
  traces.each(function (d) {
    var trace = d[0].trace;
    // || {} is in case the trace (specifically scatterternary)
    // doesn't support error bars at all, but does go through
    // the scatter.plot mechanics, which calls ErrorBars.plot
    // internally
    var xObj = trace.error_x || {};
    var yObj = trace.error_y || {};
    var keyFunc;
    if (trace.ids) {
      keyFunc = function (d) {
        return d.id;
      };
    }
    var sparse = subTypes.hasMarkers(trace) && trace.marker.maxdisplayed > 0;
    if (!yObj.visible && !xObj.visible) d = [];
    var errorbars = d3.select(this).selectAll('g.errorbar').data(d, keyFunc);
    errorbars.exit().remove();
    if (!d.length) return;
    if (!xObj.visible) errorbars.selectAll('path.xerror').remove();
    if (!yObj.visible) errorbars.selectAll('path.yerror').remove();
    errorbars.style('opacity', 1);
    var enter = errorbars.enter().append('g').classed('errorbar', true);
    if (hasAnimation) {
      enter.style('opacity', 0).transition().duration(transitionOpts.duration).style('opacity', 1);
    }
    Drawing.setClipUrl(errorbars, plotinfo.layerClipId, gd);
    errorbars.each(function (d) {
      var errorbar = d3.select(this);
      var coords = errorCoords(d, xa, ya);
      if (sparse && !d.vis) return;
      var path;
      var yerror = errorbar.select('path.yerror');
      if (yObj.visible && isNumeric(coords.x) && isNumeric(coords.yh) && isNumeric(coords.ys)) {
        var yw = yObj.width;
        path = 'M' + (coords.x - yw) + ',' + coords.yh + 'h' + 2 * yw +
        // hat
        'm-' + yw + ',0V' + coords.ys; // bar

        if (!coords.noYS) path += 'm-' + yw + ',0h' + 2 * yw; // shoe

        isNew = !yerror.size();
        if (isNew) {
          yerror = errorbar.append('path').style('vector-effect', isStatic ? 'none' : 'non-scaling-stroke').classed('yerror', true);
        } else if (hasAnimation) {
          yerror = yerror.transition().duration(transitionOpts.duration).ease(transitionOpts.easing);
        }
        yerror.attr('d', path);
      } else yerror.remove();
      var xerror = errorbar.select('path.xerror');
      if (xObj.visible && isNumeric(coords.y) && isNumeric(coords.xh) && isNumeric(coords.xs)) {
        var xw = (xObj.copy_ystyle ? yObj : xObj).width;
        path = 'M' + coords.xh + ',' + (coords.y - xw) + 'v' + 2 * xw +
        // hat
        'm0,-' + xw + 'H' + coords.xs; // bar

        if (!coords.noXS) path += 'm0,-' + xw + 'v' + 2 * xw; // shoe

        isNew = !xerror.size();
        if (isNew) {
          xerror = errorbar.append('path').style('vector-effect', isStatic ? 'none' : 'non-scaling-stroke').classed('xerror', true);
        } else if (hasAnimation) {
          xerror = xerror.transition().duration(transitionOpts.duration).ease(transitionOpts.easing);
        }
        xerror.attr('d', path);
      } else xerror.remove();
    });
  });
};

// compute the coordinates of the error-bar objects
function errorCoords(d, xa, ya) {
  var out = {
    x: xa.c2p(d.x),
    y: ya.c2p(d.y)
  };

  // calculate the error bar size and hat and shoe locations
  if (d.yh !== undefined) {
    out.yh = ya.c2p(d.yh);
    out.ys = ya.c2p(d.ys);

    // if the shoes go off-scale (ie log scale, error bars past zero)
    // clip the bar and hide the shoes
    if (!isNumeric(out.ys)) {
      out.noYS = true;
      out.ys = ya.c2p(d.ys, true);
    }
  }
  if (d.xh !== undefined) {
    out.xh = xa.c2p(d.xh);
    out.xs = xa.c2p(d.xs);
    if (!isNumeric(out.xs)) {
      out.noXS = true;
      out.xs = xa.c2p(d.xs, true);
    }
  }
  return out;
}

/***/ }),

/***/ 22800:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var Color = __webpack_require__(78766);
module.exports = function style(traces) {
  traces.each(function (d) {
    var trace = d[0].trace;
    var yObj = trace.error_y || {};
    var xObj = trace.error_x || {};
    var s = d3.select(this);
    s.selectAll('path.yerror').style('stroke-width', yObj.thickness + 'px').call(Color.stroke, yObj.color);
    if (xObj.copy_ystyle) xObj = yObj;
    s.selectAll('path.xerror').style('stroke-width', xObj.thickness + 'px').call(Color.stroke, xObj.color);
  });
};

/***/ }),

/***/ 70192:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var fontAttrs = __webpack_require__(80337);
var hoverLabelAttrs = (__webpack_require__(6811).hoverlabel);
var extendFlat = (__webpack_require__(93049).extendFlat);
module.exports = {
  hoverlabel: {
    bgcolor: extendFlat({}, hoverLabelAttrs.bgcolor, {
      arrayOk: true
    }),
    bordercolor: extendFlat({}, hoverLabelAttrs.bordercolor, {
      arrayOk: true
    }),
    font: fontAttrs({
      arrayOk: true,
      editType: 'none'
    }),
    align: extendFlat({}, hoverLabelAttrs.align, {
      arrayOk: true
    }),
    namelength: extendFlat({}, hoverLabelAttrs.namelength, {
      arrayOk: true
    }),
    editType: 'none'
  }
};

/***/ }),

/***/ 83552:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var Registry = __webpack_require__(33626);
module.exports = function calc(gd) {
  var calcdata = gd.calcdata;
  var fullLayout = gd._fullLayout;
  function makeCoerceHoverInfo(trace) {
    return function (val) {
      return Lib.coerceHoverinfo({
        hoverinfo: val
      }, {
        _module: trace._module
      }, fullLayout);
    };
  }
  for (var i = 0; i < calcdata.length; i++) {
    var cd = calcdata[i];
    var trace = cd[0].trace;

    // don't include hover calc fields for pie traces
    // as calcdata items might be sorted by value and
    // won't match the data array order.
    if (Registry.traceIs(trace, 'pie-like')) continue;
    var fillFn = Registry.traceIs(trace, '2dMap') ? paste : Lib.fillArray;
    fillFn(trace.hoverinfo, cd, 'hi', makeCoerceHoverInfo(trace));
    if (trace.hovertemplate) fillFn(trace.hovertemplate, cd, 'ht');
    if (!trace.hoverlabel) continue;
    fillFn(trace.hoverlabel.bgcolor, cd, 'hbg');
    fillFn(trace.hoverlabel.bordercolor, cd, 'hbc');
    fillFn(trace.hoverlabel.font.size, cd, 'hts');
    fillFn(trace.hoverlabel.font.color, cd, 'htc');
    fillFn(trace.hoverlabel.font.family, cd, 'htf');
    fillFn(trace.hoverlabel.font.weight, cd, 'htw');
    fillFn(trace.hoverlabel.font.style, cd, 'hty');
    fillFn(trace.hoverlabel.font.variant, cd, 'htv');
    fillFn(trace.hoverlabel.namelength, cd, 'hnl');
    fillFn(trace.hoverlabel.align, cd, 'hta');
  }
};
function paste(traceAttr, cd, cdAttr, fn) {
  fn = fn || Lib.identity;
  if (Array.isArray(traceAttr)) {
    cd[0][cdAttr] = fn(traceAttr);
  }
}

/***/ }),

/***/ 94225:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Registry = __webpack_require__(33626);
var hover = (__webpack_require__(38103).hover);
module.exports = function click(gd, evt, subplot) {
  var annotationsDone = Registry.getComponentMethod('annotations', 'onClick')(gd, gd._hoverdata);

  // fallback to fail-safe in case the plot type's hover method doesn't pass the subplot.
  // Ternary, for example, didn't, but it was caught because tested.
  if (subplot !== undefined) {
    // The true flag at the end causes it to re-run the hover computation to figure out *which*
    // point is being clicked. Without this, clicking is somewhat unreliable.
    hover(gd, evt, subplot, true);
  }
  function emitClick() {
    gd.emit('plotly_click', {
      points: gd._hoverdata,
      event: evt
    });
  }
  if (gd._hoverdata && evt && evt.target) {
    if (annotationsDone && annotationsDone.then) {
      annotationsDone.then(emitClick);
    } else emitClick();

    // why do we get a double event without this???
    if (evt.stopImmediatePropagation) evt.stopImmediatePropagation();
  }
};

/***/ }),

/***/ 85988:
/***/ (function(module) {

"use strict";


module.exports = {
  // hover labels for multiple horizontal bars get tilted by this angle
  YANGLE: 60,
  // size and display constants for hover text

  // pixel size of hover arrows
  HOVERARROWSIZE: 6,
  // pixels padding around text
  HOVERTEXTPAD: 3,
  // hover font
  HOVERFONTSIZE: 13,
  HOVERFONT: 'Arial, sans-serif',
  // minimum time (msec) between hover calls
  HOVERMINTIME: 50,
  // ID suffix (with fullLayout._uid) for hover events in the throttle cache
  HOVERID: '-hover'
};

/***/ }),

/***/ 3239:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var attributes = __webpack_require__(70192);
var handleHoverLabelDefaults = __webpack_require__(26430);
module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
  function coerce(attr, dflt) {
    return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
  }
  var opts = Lib.extendFlat({}, layout.hoverlabel);
  if (traceOut.hovertemplate) opts.namelength = -1;
  handleHoverLabelDefaults(traceIn, traceOut, coerce, opts);
};

/***/ }),

/***/ 36040:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);

// look for either subplot or xaxis and yaxis attributes
// does not handle splom case
exports.getSubplot = function (trace) {
  return trace.subplot || trace.xaxis + trace.yaxis || trace.geo;
};

// is trace in given list of subplots?
// does handle splom case
exports.isTraceInSubplots = function (trace, subplots) {
  if (trace.type === 'splom') {
    var xaxes = trace.xaxes || [];
    var yaxes = trace.yaxes || [];
    for (var i = 0; i < xaxes.length; i++) {
      for (var j = 0; j < yaxes.length; j++) {
        if (subplots.indexOf(xaxes[i] + yaxes[j]) !== -1) {
          return true;
        }
      }
    }
    return false;
  }
  return subplots.indexOf(exports.getSubplot(trace)) !== -1;
};

// convenience functions for mapping all relevant axes
exports.flat = function (subplots, v) {
  var out = new Array(subplots.length);
  for (var i = 0; i < subplots.length; i++) {
    out[i] = v;
  }
  return out;
};
exports.p2c = function (axArray, v) {
  var out = new Array(axArray.length);
  for (var i = 0; i < axArray.length; i++) {
    out[i] = axArray[i].p2c(v);
  }
  return out;
};
exports.getDistanceFunction = function (mode, dx, dy, dxy) {
  if (mode === 'closest') return dxy || exports.quadrature(dx, dy);
  return mode.charAt(0) === 'x' ? dx : dy;
};
exports.getClosest = function (cd, distfn, pointData) {
  // do we already have a point number? (array mode only)
  if (pointData.index !== false) {
    if (pointData.index >= 0 && pointData.index < cd.length) {
      pointData.distance = 0;
    } else pointData.index = false;
  } else {
    // apply the distance function to each data point
    // this is the longest loop... if this bogs down, we may need
    // to create pre-sorted data (by x or y), not sure how to
    // do this for 'closest'
    for (var i = 0; i < cd.length; i++) {
      var newDistance = distfn(cd[i]);
      if (newDistance <= pointData.distance) {
        pointData.index = i;
        pointData.distance = newDistance;
      }
    }
  }
  return pointData;
};

/*
 * pseudo-distance function for hover effects on areas: inside the region
 * distance is finite (`passVal`), outside it's Infinity.
 *
 * @param {number} v0: signed difference between the current position and the left edge
 * @param {number} v1: signed difference between the current position and the right edge
 * @param {number} passVal: the value to return on success
 */
exports.inbox = function (v0, v1, passVal) {
  return v0 * v1 < 0 || v0 === 0 ? passVal : Infinity;
};
exports.quadrature = function (dx, dy) {
  return function (di) {
    var x = dx(di);
    var y = dy(di);
    return Math.sqrt(x * x + y * y);
  };
};

/** Fill event data point object for hover and selection.
 *  Invokes _module.eventData if present.
 *
 * N.B. note that point 'index' corresponds to input data array index
 *  whereas 'number' is its post-transform version.
 *
 * If the hovered/selected pt corresponds to an multiple input points
 * (e.g. for histogram and transformed traces), 'pointNumbers` and 'pointIndices'
 * are include in the event data.
 *
 * @param {object} pt
 * @param {object} trace
 * @param {object} cd
 * @return {object}
 */
exports.makeEventData = function (pt, trace, cd) {
  // hover uses 'index', select uses 'pointNumber'
  var pointNumber = 'index' in pt ? pt.index : pt.pointNumber;
  var out = {
    data: trace._input,
    fullData: trace,
    curveNumber: trace.index,
    pointNumber: pointNumber
  };
  if (trace._indexToPoints) {
    var pointIndices = trace._indexToPoints[pointNumber];
    if (pointIndices.length === 1) {
      out.pointIndex = pointIndices[0];
    } else {
      out.pointIndices = pointIndices;
    }
  } else {
    out.pointIndex = pointNumber;
  }
  if (trace._module.eventData) {
    out = trace._module.eventData(out, pt, trace, cd, pointNumber);
  } else {
    if ('xVal' in pt) out.x = pt.xVal;else if ('x' in pt) out.x = pt.x;
    if ('yVal' in pt) out.y = pt.yVal;else if ('y' in pt) out.y = pt.y;
    if (pt.xa) out.xaxis = pt.xa;
    if (pt.ya) out.yaxis = pt.ya;
    if (pt.zLabelVal !== undefined) out.z = pt.zLabelVal;
  }
  exports.appendArrayPointValue(out, trace, pointNumber);
  return out;
};

/** Appends values inside array attributes corresponding to given point number
 *
 * @param {object} pointData : point data object (gets mutated here)
 * @param {object} trace : full trace object
 * @param {number|Array(number)} pointNumber : point number. May be a length-2 array
 *     [row, col] to dig into 2D arrays
 */
exports.appendArrayPointValue = function (pointData, trace, pointNumber) {
  var arrayAttrs = trace._arrayAttrs;
  if (!arrayAttrs) {
    return;
  }
  for (var i = 0; i < arrayAttrs.length; i++) {
    var astr = arrayAttrs[i];
    var key = getPointKey(astr);
    if (pointData[key] === undefined) {
      var val = Lib.nestedProperty(trace, astr).get();
      var pointVal = getPointData(val, pointNumber);
      if (pointVal !== undefined) pointData[key] = pointVal;
    }
  }
};

/**
 * Appends values inside array attributes corresponding to given point number array
 * For use when pointData references a plot entity that arose (or potentially arose)
 * from multiple points in the input data
 *
 * @param {object} pointData : point data object (gets mutated here)
 * @param {object} trace : full trace object
 * @param {Array(number)|Array(Array(number))} pointNumbers : Array of point numbers.
 *     Each entry in the array may itself be a length-2 array [row, col] to dig into 2D arrays
 */
exports.appendArrayMultiPointValues = function (pointData, trace, pointNumbers) {
  var arrayAttrs = trace._arrayAttrs;
  if (!arrayAttrs) {
    return;
  }
  for (var i = 0; i < arrayAttrs.length; i++) {
    var astr = arrayAttrs[i];
    var key = getPointKey(astr);
    if (pointData[key] === undefined) {
      var val = Lib.nestedProperty(trace, astr).get();
      var keyVal = new Array(pointNumbers.length);
      for (var j = 0; j < pointNumbers.length; j++) {
        keyVal[j] = getPointData(val, pointNumbers[j]);
      }
      pointData[key] = keyVal;
    }
  }
};
var pointKeyMap = {
  ids: 'id',
  locations: 'location',
  labels: 'label',
  values: 'value',
  'marker.colors': 'color',
  parents: 'parent'
};
function getPointKey(astr) {
  return pointKeyMap[astr] || astr;
}
function getPointData(val, pointNumber) {
  if (Array.isArray(pointNumber)) {
    if (Array.isArray(val) && Array.isArray(val[pointNumber[0]])) {
      return val[pointNumber[0]][pointNumber[1]];
    }
  } else {
    return val[pointNumber];
  }
}
var xyHoverMode = {
  x: true,
  y: true
};
var unifiedHoverMode = {
  'x unified': true,
  'y unified': true
};
exports.isUnifiedHover = function (hovermode) {
  if (typeof hovermode !== 'string') return false;
  return !!unifiedHoverMode[hovermode];
};
exports.isXYhover = function (hovermode) {
  if (typeof hovermode !== 'string') return false;
  return !!xyHoverMode[hovermode];
};

/***/ }),

/***/ 38103:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var isNumeric = __webpack_require__(10721);
var tinycolor = __webpack_require__(65657);
var Lib = __webpack_require__(34809);
var pushUnique = Lib.pushUnique;
var strTranslate = Lib.strTranslate;
var strRotate = Lib.strRotate;
var Events = __webpack_require__(68596);
var svgTextUtils = __webpack_require__(30635);
var overrideCursor = __webpack_require__(93134);
var Drawing = __webpack_require__(62203);
var Color = __webpack_require__(78766);
var dragElement = __webpack_require__(14751);
var Axes = __webpack_require__(29714);
var zindexSeparator = (__webpack_require__(54826).zindexSeparator);
var Registry = __webpack_require__(33626);
var helpers = __webpack_require__(36040);
var constants = __webpack_require__(85988);
var legendSupplyDefaults = __webpack_require__(73970);
var legendDraw = __webpack_require__(6134);

// hover labels for multiple horizontal bars get tilted by some angle,
// then need to be offset differently if they overlap
var YANGLE = constants.YANGLE;
var YA_RADIANS = Math.PI * YANGLE / 180;

// expansion of projected height
var YFACTOR = 1 / Math.sin(YA_RADIANS);

// to make the appropriate post-rotation x offset,
// you need both x and y offsets
var YSHIFTX = Math.cos(YA_RADIANS);
var YSHIFTY = Math.sin(YA_RADIANS);

// size and display constants for hover text
var HOVERARROWSIZE = constants.HOVERARROWSIZE;
var HOVERTEXTPAD = constants.HOVERTEXTPAD;
var multipleHoverPoints = {
  box: true,
  ohlc: true,
  violin: true,
  candlestick: true
};
var cartesianScatterPoints = {
  scatter: true,
  scattergl: true,
  splom: true
};
function distanceSort(a, b) {
  return a.distance - b.distance;
}

// fx.hover: highlight data on hover
// evt can be a mousemove event, or an object with data about what points
//   to hover on
//      {xpx,ypx[,hovermode]} - pixel locations from top left
//          (with optional overriding hovermode)
//      {xval,yval[,hovermode]} - data values
//      [{curveNumber,(pointNumber|xval and/or yval)}] -
//              array of specific points to highlight
//          pointNumber is a single integer if gd.data[curveNumber] is 1D,
//              or a two-element array if it's 2D
//          xval and yval are data values,
//              1D data may specify either or both,
//              2D data must specify both
// subplot is an id string (default "xy")
// makes use of gl.hovermode, which can be:
//      x (find the points with the closest x values, ie a column),
//      closest (find the single closest point)
//    internally there are two more that occasionally get used:
//      y (pick out a row - only used for multiple horizontal bar charts)
//      array (used when the user specifies an explicit
//          array of points to hover on)
//
// We wrap the hovers in a timer, to limit their frequency.
// The actual rendering is done by private function _hover.
exports.hover = function hover(gd, evt, subplot, noHoverEvent) {
  gd = Lib.getGraphDiv(gd);
  // The 'target' property changes when bubbling out of Shadow DOM.
  // Throttling can delay reading the target, so we save the current value.
  var eventTarget = evt.target;
  Lib.throttle(gd._fullLayout._uid + constants.HOVERID, constants.HOVERMINTIME, function () {
    _hover(gd, evt, subplot, noHoverEvent, eventTarget);
  });
};

/*
 * Draw a single hover item or an array of hover item in a pre-existing svg container somewhere
 * hoverItem should have keys:
 *    - x and y (or x0, x1, y0, and y1):
 *      the pixel position to mark, relative to opts.container
 *    - xLabel, yLabel, zLabel, text, and name:
 *      info to go in the label
 *    - color:
 *      the background color for the label.
 *    - idealAlign (optional):
 *      'left' or 'right' for which side of the x/y box to try to put this on first
 *    - borderColor (optional):
 *      color for the border, defaults to strongest contrast with color
 *    - fontFamily (optional):
 *      string, the font for this label, defaults to constants.HOVERFONT
 *    - fontSize (optional):
 *      the label font size, defaults to constants.HOVERFONTSIZE
 *    - fontColor (optional):
 *      defaults to borderColor
 * opts should have keys:
 *    - bgColor:
 *      the background color this is against, used if the trace is
 *      non-opaque, and for the name, which goes outside the box
 *    - container:
 *      a <svg> or <g> element to add the hover label to
 *    - outerContainer:
 *      normally a parent of `container`, sets the bounding box to use to
 *      constrain the hover label and determine whether to show it on the left or right
 * opts can have optional keys:
 *    - anchorIndex:
        the index of the hover item used as an anchor for positioning.
        The other hover items will be pushed up or down to prevent overlap.
 */
exports.loneHover = function loneHover(hoverItems, opts) {
  var multiHover = true;
  if (!Array.isArray(hoverItems)) {
    multiHover = false;
    hoverItems = [hoverItems];
  }
  var gd = opts.gd;
  var gTop = getTopOffset(gd);
  var gLeft = getLeftOffset(gd);
  var pointsData = hoverItems.map(function (hoverItem) {
    var _x0 = hoverItem._x0 || hoverItem.x0 || hoverItem.x || 0;
    var _x1 = hoverItem._x1 || hoverItem.x1 || hoverItem.x || 0;
    var _y0 = hoverItem._y0 || hoverItem.y0 || hoverItem.y || 0;
    var _y1 = hoverItem._y1 || hoverItem.y1 || hoverItem.y || 0;
    var eventData = hoverItem.eventData;
    if (eventData) {
      var x0 = Math.min(_x0, _x1);
      var x1 = Math.max(_x0, _x1);
      var y0 = Math.min(_y0, _y1);
      var y1 = Math.max(_y0, _y1);
      var trace = hoverItem.trace;
      if (Registry.traceIs(trace, 'gl3d')) {
        var container = gd._fullLayout[trace.scene]._scene.container;
        var dx = container.offsetLeft;
        var dy = container.offsetTop;
        x0 += dx;
        x1 += dx;
        y0 += dy;
        y1 += dy;
      } // TODO: handle heatmapgl

      eventData.bbox = {
        x0: x0 + gLeft,
        x1: x1 + gLeft,
        y0: y0 + gTop,
        y1: y1 + gTop
      };
      if (opts.inOut_bbox) {
        opts.inOut_bbox.push(eventData.bbox);
      }
    } else {
      eventData = false;
    }
    return {
      color: hoverItem.color || Color.defaultLine,
      x0: hoverItem.x0 || hoverItem.x || 0,
      x1: hoverItem.x1 || hoverItem.x || 0,
      y0: hoverItem.y0 || hoverItem.y || 0,
      y1: hoverItem.y1 || hoverItem.y || 0,
      xLabel: hoverItem.xLabel,
      yLabel: hoverItem.yLabel,
      zLabel: hoverItem.zLabel,
      text: hoverItem.text,
      name: hoverItem.name,
      idealAlign: hoverItem.idealAlign,
      // optional extra bits of styling
      borderColor: hoverItem.borderColor,
      fontFamily: hoverItem.fontFamily,
      fontSize: hoverItem.fontSize,
      fontColor: hoverItem.fontColor,
      fontWeight: hoverItem.fontWeight,
      fontStyle: hoverItem.fontStyle,
      fontVariant: hoverItem.fontVariant,
      nameLength: hoverItem.nameLength,
      textAlign: hoverItem.textAlign,
      // filler to make createHoverText happy
      trace: hoverItem.trace || {
        index: 0,
        hoverinfo: ''
      },
      xa: {
        _offset: 0
      },
      ya: {
        _offset: 0
      },
      index: 0,
      hovertemplate: hoverItem.hovertemplate || false,
      hovertemplateLabels: hoverItem.hovertemplateLabels || false,
      eventData: eventData
    };
  });
  var rotateLabels = false;
  var hoverText = createHoverText(pointsData, {
    gd: gd,
    hovermode: 'closest',
    rotateLabels: rotateLabels,
    bgColor: opts.bgColor || Color.background,
    container: d3.select(opts.container),
    outerContainer: opts.outerContainer || opts.container
  });
  var hoverLabel = hoverText.hoverLabels;

  // Fix vertical overlap
  var tooltipSpacing = 5;
  var lastBottomY = 0;
  var anchor = 0;
  hoverLabel.sort(function (a, b) {
    return a.y0 - b.y0;
  }).each(function (d, i) {
    var topY = d.y0 - d.by / 2;
    if (topY - tooltipSpacing < lastBottomY) {
      d.offset = lastBottomY - topY + tooltipSpacing;
    } else {
      d.offset = 0;
    }
    lastBottomY = topY + d.by + d.offset;
    if (i === opts.anchorIndex || 0) anchor = d.offset;
  }).each(function (d) {
    d.offset -= anchor;
  });
  var scaleX = gd._fullLayout._invScaleX;
  var scaleY = gd._fullLayout._invScaleY;
  alignHoverText(hoverLabel, rotateLabels, scaleX, scaleY);
  return multiHover ? hoverLabel : hoverLabel.node();
};

// The actual implementation is here:
function _hover(gd, evt, subplot, noHoverEvent, eventTarget) {
  if (!subplot) subplot = 'xy';
  if (typeof subplot === 'string') {
    // drop zindex from subplot id
    subplot = subplot.split(zindexSeparator)[0];
  }

  // if the user passed in an array of subplots,
  // use those instead of finding overlayed plots
  var subplots = Array.isArray(subplot) ? subplot : [subplot];
  var spId;
  var fullLayout = gd._fullLayout;
  var hoversubplots = fullLayout.hoversubplots;
  var plots = fullLayout._plots || [];
  var plotinfo = plots[subplot];
  var hasCartesian = fullLayout._has('cartesian');
  var hovermode = evt.hovermode || fullLayout.hovermode;
  var hovermodeHasX = (hovermode || '').charAt(0) === 'x';
  var hovermodeHasY = (hovermode || '').charAt(0) === 'y';
  var firstXaxis;
  var firstYaxis;
  if (hasCartesian && (hovermodeHasX || hovermodeHasY) && hoversubplots === 'axis') {
    var subplotsLength = subplots.length;
    for (var p = 0; p < subplotsLength; p++) {
      spId = subplots[p];
      if (plots[spId]) {
        // 'cartesian' case

        firstXaxis = Axes.getFromId(gd, spId, 'x');
        firstYaxis = Axes.getFromId(gd, spId, 'y');
        var subplotsWith = (hovermodeHasX ? firstXaxis : firstYaxis)._subplotsWith;
        if (subplotsWith && subplotsWith.length) {
          for (var q = 0; q < subplotsWith.length; q++) {
            pushUnique(subplots, subplotsWith[q]);
          }
        }
      }
    }
  }

  // list of all overlaid subplots to look at
  if (plotinfo && hoversubplots !== 'single') {
    var overlayedSubplots = plotinfo.overlays.map(function (pi) {
      return pi.id;
    });
    subplots = subplots.concat(overlayedSubplots);
  }
  var len = subplots.length;
  var xaArray = new Array(len);
  var yaArray = new Array(len);
  var supportsCompare = false;
  for (var i = 0; i < len; i++) {
    spId = subplots[i];
    if (plots[spId]) {
      // 'cartesian' case
      supportsCompare = true;
      xaArray[i] = plots[spId].xaxis;
      yaArray[i] = plots[spId].yaxis;
    } else if (fullLayout[spId] && fullLayout[spId]._subplot) {
      // other subplot types
      var _subplot = fullLayout[spId]._subplot;
      xaArray[i] = _subplot.xaxis;
      yaArray[i] = _subplot.yaxis;
    } else {
      Lib.warn('Unrecognized subplot: ' + spId);
      return;
    }
  }
  if (hovermode && !supportsCompare) hovermode = 'closest';
  if (['x', 'y', 'closest', 'x unified', 'y unified'].indexOf(hovermode) === -1 || !gd.calcdata || gd.querySelector('.zoombox') || gd._dragging) {
    return dragElement.unhoverRaw(gd, evt);
  }
  var hoverdistance = fullLayout.hoverdistance;
  if (hoverdistance === -1) hoverdistance = Infinity;
  var spikedistance = fullLayout.spikedistance;
  if (spikedistance === -1) spikedistance = Infinity;

  // hoverData: the set of candidate points we've found to highlight
  var hoverData = [];

  // searchData: the data to search in. Mostly this is just a copy of
  // gd.calcdata, filtered to the subplot and overlays we're on
  // but if a point array is supplied it will be a mapping
  // of indicated curves
  var searchData = [];

  // [x|y]valArray: the axis values of the hover event
  // mapped onto each of the currently selected overlaid subplots
  var xvalArray, yvalArray;
  var itemnum, curvenum, cd, trace, subplotId, subploti, _mode, xval, yval, pointData, closedataPreviousLength;

  // spikePoints: the set of candidate points we've found to draw spikes to
  var spikePoints = {
    hLinePoint: null,
    vLinePoint: null
  };

  // does subplot have one (or more) horizontal traces?
  // This is used to determine whether we rotate the labels or not
  var hasOneHorizontalTrace = false;

  // Figure out what we're hovering on:
  // mouse location or user-supplied data

  if (Array.isArray(evt)) {
    // user specified an array of points to highlight
    hovermode = 'array';
    for (itemnum = 0; itemnum < evt.length; itemnum++) {
      cd = gd.calcdata[evt[itemnum].curveNumber || 0];
      if (cd) {
        trace = cd[0].trace;
        if (cd[0].trace.hoverinfo !== 'skip') {
          searchData.push(cd);
          if (trace.orientation === 'h') {
            hasOneHorizontalTrace = true;
          }
        }
      }
    }
  } else {
    // take into account zorder
    var zorderedCalcdata = gd.calcdata.slice();
    zorderedCalcdata.sort(function (a, b) {
      var aZorder = a[0].trace.zorder || 0;
      var bZorder = b[0].trace.zorder || 0;
      return aZorder - bZorder;
    });
    for (curvenum = 0; curvenum < zorderedCalcdata.length; curvenum++) {
      cd = zorderedCalcdata[curvenum];
      trace = cd[0].trace;
      if (trace.hoverinfo !== 'skip' && helpers.isTraceInSubplots(trace, subplots)) {
        searchData.push(cd);
        if (trace.orientation === 'h') {
          hasOneHorizontalTrace = true;
        }
      }
    }

    // [x|y]px: the pixels (from top left) of the mouse location
    // on the currently selected plot area
    // add pointerX|Y property for drawing the spikes in spikesnap 'cursor' situation
    var hasUserCalledHover = !eventTarget;
    var xpx, ypx;
    if (hasUserCalledHover) {
      if ('xpx' in evt) xpx = evt.xpx;else xpx = xaArray[0]._length / 2;
      if ('ypx' in evt) ypx = evt.ypx;else ypx = yaArray[0]._length / 2;
    } else {
      // fire the beforehover event and quit if it returns false
      // note that we're only calling this on real mouse events, so
      // manual calls to fx.hover will always run.
      if (Events.triggerHandler(gd, 'plotly_beforehover', evt) === false) {
        return;
      }
      var dbb = eventTarget.getBoundingClientRect();
      xpx = evt.clientX - dbb.left;
      ypx = evt.clientY - dbb.top;
      fullLayout._calcInverseTransform(gd);
      var transformedCoords = Lib.apply3DTransform(fullLayout._invTransform)(xpx, ypx);
      xpx = transformedCoords[0];
      ypx = transformedCoords[1];

      // in case hover was called from mouseout into hovertext,
      // it's possible you're not actually over the plot anymore
      if (xpx < 0 || xpx > xaArray[0]._length || ypx < 0 || ypx > yaArray[0]._length) {
        return dragElement.unhoverRaw(gd, evt);
      }
    }
    evt.pointerX = xpx + xaArray[0]._offset;
    evt.pointerY = ypx + yaArray[0]._offset;
    if ('xval' in evt) xvalArray = helpers.flat(subplots, evt.xval);else xvalArray = helpers.p2c(xaArray, xpx);
    if ('yval' in evt) yvalArray = helpers.flat(subplots, evt.yval);else yvalArray = helpers.p2c(yaArray, ypx);
    if (!isNumeric(xvalArray[0]) || !isNumeric(yvalArray[0])) {
      Lib.warn('Fx.hover failed', evt, gd);
      return dragElement.unhoverRaw(gd, evt);
    }
  }

  // the pixel distance to beat as a matching point
  // in 'x' or 'y' mode this resets for each trace
  var distance = Infinity;

  // find the closest point in each trace
  // this is minimum dx and/or dy, depending on mode
  // and the pixel position for the label (labelXpx, labelYpx)
  function findHoverPoints(customXVal, customYVal) {
    for (curvenum = 0; curvenum < searchData.length; curvenum++) {
      cd = searchData[curvenum];

      // filter out invisible or broken data
      if (!cd || !cd[0] || !cd[0].trace) continue;
      trace = cd[0].trace;
      if (trace.visible !== true || trace._length === 0) continue;

      // Explicitly bail out for these two. I don't know how to otherwise prevent
      // the rest of this function from running and failing
      if (['carpet', 'contourcarpet'].indexOf(trace._module.name) !== -1) continue;

      // within one trace mode can sometimes be overridden
      _mode = hovermode;
      if (helpers.isUnifiedHover(_mode)) {
        _mode = _mode.charAt(0);
      }
      if (trace.type === 'splom') {
        // splom traces do not generate overlay subplots,
        // it is safe to assume here splom traces correspond to the 0th subplot
        subploti = 0;
        subplotId = subplots[subploti];
      } else {
        subplotId = helpers.getSubplot(trace);
        subploti = subplots.indexOf(subplotId);
      }

      // container for new point, also used to pass info into module.hoverPoints
      pointData = {
        // trace properties
        cd: cd,
        trace: trace,
        xa: xaArray[subploti],
        ya: yaArray[subploti],
        // max distances for hover and spikes - for points that want to show but do not
        // want to override other points, set distance/spikeDistance equal to max*Distance
        // and it will not get filtered out but it will be guaranteed to have a greater
        // distance than any point that calculated a real distance.
        maxHoverDistance: hoverdistance,
        maxSpikeDistance: spikedistance,
        // point properties - override all of these
        index: false,
        // point index in trace - only used by plotly.js hoverdata consumers
        distance: Math.min(distance, hoverdistance),
        // pixel distance or pseudo-distance

        // distance/pseudo-distance for spikes. This distance should always be calculated
        // as if in "closest" mode, and should only be set if this point should
        // generate a spike.
        spikeDistance: Infinity,
        // in some cases the spikes have different positioning from the hover label
        // they don't need x0/x1, just one position
        xSpike: undefined,
        ySpike: undefined,
        // where and how to display the hover label
        color: Color.defaultLine,
        // trace color
        name: trace.name,
        x0: undefined,
        x1: undefined,
        y0: undefined,
        y1: undefined,
        xLabelVal: undefined,
        yLabelVal: undefined,
        zLabelVal: undefined,
        text: undefined
      };

      // add ref to subplot object (non-cartesian case)
      if (fullLayout[subplotId]) {
        pointData.subplot = fullLayout[subplotId]._subplot;
      }
      // add ref to splom scene
      if (fullLayout._splomScenes && fullLayout._splomScenes[trace.uid]) {
        pointData.scene = fullLayout._splomScenes[trace.uid];
      }

      // for a highlighting array, figure out what
      // we're searching for with this element
      if (_mode === 'array') {
        var selection = evt[curvenum];
        if ('pointNumber' in selection) {
          pointData.index = selection.pointNumber;
          _mode = 'closest';
        } else {
          _mode = '';
          if ('xval' in selection) {
            xval = selection.xval;
            _mode = 'x';
          }
          if ('yval' in selection) {
            yval = selection.yval;
            _mode = _mode ? 'closest' : 'y';
          }
        }
      } else if (customXVal !== undefined && customYVal !== undefined) {
        xval = customXVal;
        yval = customYVal;
      } else {
        xval = xvalArray[subploti];
        yval = yvalArray[subploti];
      }
      closedataPreviousLength = hoverData.length;

      // Now if there is range to look in, find the points to hover.
      if (hoverdistance !== 0) {
        if (trace._module && trace._module.hoverPoints) {
          var newPoints = trace._module.hoverPoints(pointData, xval, yval, _mode, {
            finiteRange: true,
            hoverLayer: fullLayout._hoverlayer,
            // options for splom when hovering on same axis
            hoversubplots: hoversubplots,
            gd: gd
          });
          if (newPoints) {
            var newPoint;
            for (var newPointNum = 0; newPointNum < newPoints.length; newPointNum++) {
              newPoint = newPoints[newPointNum];
              if (isNumeric(newPoint.x0) && isNumeric(newPoint.y0)) {
                hoverData.push(cleanPoint(newPoint, hovermode));
              }
            }
          }
        } else {
          Lib.log('Unrecognized trace type in hover:', trace);
        }
      }

      // in closest mode, remove any existing (farther) points
      // and don't look any farther than this latest point (or points, some
      // traces like box & violin make multiple hover labels at once)
      if (hovermode === 'closest' && hoverData.length > closedataPreviousLength) {
        hoverData.splice(0, closedataPreviousLength);
        distance = hoverData[0].distance;
      }

      // Now if there is range to look in, find the points to draw the spikelines
      // Do it only if there is no hoverData
      if (hasCartesian && spikedistance !== 0) {
        if (hoverData.length === 0) {
          pointData.distance = spikedistance;
          pointData.index = false;
          var closestPoints = trace._module.hoverPoints(pointData, xval, yval, 'closest', {
            hoverLayer: fullLayout._hoverlayer
          });
          if (closestPoints) {
            closestPoints = closestPoints.filter(function (point) {
              // some hover points, like scatter fills, do not allow spikes,
              // so will generate a hover point but without a valid spikeDistance
              return point.spikeDistance <= spikedistance;
            });
          }
          if (closestPoints && closestPoints.length) {
            var tmpPoint;
            var closestVPoints = closestPoints.filter(function (point) {
              return point.xa.showspikes && point.xa.spikesnap !== 'hovered data';
            });
            if (closestVPoints.length) {
              var closestVPt = closestVPoints[0];
              if (isNumeric(closestVPt.x0) && isNumeric(closestVPt.y0)) {
                tmpPoint = fillSpikePoint(closestVPt);
                if (!spikePoints.vLinePoint || spikePoints.vLinePoint.spikeDistance > tmpPoint.spikeDistance) {
                  spikePoints.vLinePoint = tmpPoint;
                }
              }
            }
            var closestHPoints = closestPoints.filter(function (point) {
              return point.ya.showspikes && point.ya.spikesnap !== 'hovered data';
            });
            if (closestHPoints.length) {
              var closestHPt = closestHPoints[0];
              if (isNumeric(closestHPt.x0) && isNumeric(closestHPt.y0)) {
                tmpPoint = fillSpikePoint(closestHPt);
                if (!spikePoints.hLinePoint || spikePoints.hLinePoint.spikeDistance > tmpPoint.spikeDistance) {
                  spikePoints.hLinePoint = tmpPoint;
                }
              }
            }
          }
        }
      }
    }
  }
  findHoverPoints();
  function selectClosestPoint(pointsData, spikedistance, spikeOnWinning) {
    var resultPoint = null;
    var minDistance = Infinity;
    var thisSpikeDistance;
    for (var i = 0; i < pointsData.length; i++) {
      if (firstXaxis && firstXaxis._id !== pointsData[i].xa._id) continue;
      if (firstYaxis && firstYaxis._id !== pointsData[i].ya._id) continue;
      thisSpikeDistance = pointsData[i].spikeDistance;
      if (spikeOnWinning && i === 0) thisSpikeDistance = -Infinity;
      if (thisSpikeDistance <= minDistance && thisSpikeDistance <= spikedistance) {
        resultPoint = pointsData[i];
        minDistance = thisSpikeDistance;
      }
    }
    return resultPoint;
  }
  function fillSpikePoint(point) {
    if (!point) return null;
    return {
      xa: point.xa,
      ya: point.ya,
      x: point.xSpike !== undefined ? point.xSpike : (point.x0 + point.x1) / 2,
      y: point.ySpike !== undefined ? point.ySpike : (point.y0 + point.y1) / 2,
      distance: point.distance,
      spikeDistance: point.spikeDistance,
      curveNumber: point.trace.index,
      color: point.color,
      pointNumber: point.index
    };
  }
  var spikelineOpts = {
    fullLayout: fullLayout,
    container: fullLayout._hoverlayer,
    event: evt
  };
  var oldspikepoints = gd._spikepoints;
  var newspikepoints = {
    vLinePoint: spikePoints.vLinePoint,
    hLinePoint: spikePoints.hLinePoint
  };
  gd._spikepoints = newspikepoints;
  var sortHoverData = function () {
    // When sorting keep the points in the main subplot at the top
    // then add points in other subplots

    var hoverDataInSubplot = hoverData.filter(function (a) {
      return firstXaxis && firstXaxis._id === a.xa._id && firstYaxis && firstYaxis._id === a.ya._id;
    });
    var hoverDataOutSubplot = hoverData.filter(function (a) {
      return !(firstXaxis && firstXaxis._id === a.xa._id && firstYaxis && firstYaxis._id === a.ya._id);
    });
    hoverDataInSubplot.sort(distanceSort);
    hoverDataOutSubplot.sort(distanceSort);
    hoverData = hoverDataInSubplot.concat(hoverDataOutSubplot);

    // move period positioned points and box/bar-like traces to the end of the list
    hoverData = orderRangePoints(hoverData, hovermode);
  };
  sortHoverData();
  var axLetter = hovermode.charAt(0);
  var spikeOnWinning = (axLetter === 'x' || axLetter === 'y') && hoverData[0] && cartesianScatterPoints[hoverData[0].trace.type];

  // Now if it is not restricted by spikedistance option, set the points to draw the spikelines
  if (hasCartesian && spikedistance !== 0) {
    if (hoverData.length !== 0) {
      var tmpHPointData = hoverData.filter(function (point) {
        return point.ya.showspikes;
      });
      var tmpHPoint = selectClosestPoint(tmpHPointData, spikedistance, spikeOnWinning);
      spikePoints.hLinePoint = fillSpikePoint(tmpHPoint);
      var tmpVPointData = hoverData.filter(function (point) {
        return point.xa.showspikes;
      });
      var tmpVPoint = selectClosestPoint(tmpVPointData, spikedistance, spikeOnWinning);
      spikePoints.vLinePoint = fillSpikePoint(tmpVPoint);
    }
  }

  // if hoverData is empty check for the spikes to draw and quit if there are none
  if (hoverData.length === 0) {
    var result = dragElement.unhoverRaw(gd, evt);
    if (hasCartesian && (spikePoints.hLinePoint !== null || spikePoints.vLinePoint !== null)) {
      if (spikesChanged(oldspikepoints)) {
        createSpikelines(gd, spikePoints, spikelineOpts);
      }
    }
    return result;
  }
  if (hasCartesian) {
    if (spikesChanged(oldspikepoints)) {
      createSpikelines(gd, spikePoints, spikelineOpts);
    }
  }
  if (helpers.isXYhover(_mode) && hoverData[0].length !== 0 && hoverData[0].trace.type !== 'splom' // TODO: add support for splom
  ) {
    // pick winning point
    var winningPoint = hoverData[0];
    // discard other points
    if (multipleHoverPoints[winningPoint.trace.type]) {
      hoverData = hoverData.filter(function (d) {
        return d.trace.index === winningPoint.trace.index;
      });
    } else {
      hoverData = [winningPoint];
    }
    var initLen = hoverData.length;
    var winX = getCoord('x', winningPoint, fullLayout);
    var winY = getCoord('y', winningPoint, fullLayout);

    // in compare mode, select every point at position
    findHoverPoints(winX, winY);
    var finalPoints = [];
    var seen = {};
    var id = 0;
    var insert = function (newHd) {
      var key = multipleHoverPoints[newHd.trace.type] ? hoverDataKey(newHd) : newHd.trace.index;
      if (!seen[key]) {
        id++;
        seen[key] = id;
        finalPoints.push(newHd);
      } else {
        var oldId = seen[key] - 1;
        var oldHd = finalPoints[oldId];
        if (oldId > 0 && Math.abs(newHd.distance) < Math.abs(oldHd.distance)) {
          // replace with closest
          finalPoints[oldId] = newHd;
        }
      }
    };
    var k;
    // insert the winnig point(s) first
    for (k = 0; k < initLen; k++) {
      insert(hoverData[k]);
    }
    // override from the end
    for (k = hoverData.length - 1; k > initLen - 1; k--) {
      insert(hoverData[k]);
    }
    hoverData = finalPoints;
    sortHoverData();
  }

  // lastly, emit custom hover/unhover events
  var oldhoverdata = gd._hoverdata;
  var newhoverdata = [];
  var gTop = getTopOffset(gd);
  var gLeft = getLeftOffset(gd);

  // pull out just the data that's useful to
  // other people and send it to the event
  for (itemnum = 0; itemnum < hoverData.length; itemnum++) {
    var pt = hoverData[itemnum];
    var eventData = helpers.makeEventData(pt, pt.trace, pt.cd);
    if (pt.hovertemplate !== false) {
      var ht = false;
      if (pt.cd[pt.index] && pt.cd[pt.index].ht) {
        ht = pt.cd[pt.index].ht;
      }
      pt.hovertemplate = ht || pt.trace.hovertemplate || false;
    }
    if (pt.xa && pt.ya) {
      var _x0 = pt.x0 + pt.xa._offset;
      var _x1 = pt.x1 + pt.xa._offset;
      var _y0 = pt.y0 + pt.ya._offset;
      var _y1 = pt.y1 + pt.ya._offset;
      var x0 = Math.min(_x0, _x1);
      var x1 = Math.max(_x0, _x1);
      var y0 = Math.min(_y0, _y1);
      var y1 = Math.max(_y0, _y1);
      eventData.bbox = {
        x0: x0 + gLeft,
        x1: x1 + gLeft,
        y0: y0 + gTop,
        y1: y1 + gTop
      };
    }
    pt.eventData = [eventData];
    newhoverdata.push(eventData);
  }
  gd._hoverdata = newhoverdata;
  var rotateLabels = hovermode === 'y' && (searchData.length > 1 || hoverData.length > 1) || hovermode === 'closest' && hasOneHorizontalTrace && hoverData.length > 1;
  var bgColor = Color.combine(fullLayout.plot_bgcolor || Color.background, fullLayout.paper_bgcolor);
  var hoverText = createHoverText(hoverData, {
    gd: gd,
    hovermode: hovermode,
    rotateLabels: rotateLabels,
    bgColor: bgColor,
    container: fullLayout._hoverlayer,
    outerContainer: fullLayout._paper.node(),
    commonLabelOpts: fullLayout.hoverlabel,
    hoverdistance: fullLayout.hoverdistance
  });
  var hoverLabels = hoverText.hoverLabels;
  if (!helpers.isUnifiedHover(hovermode)) {
    hoverAvoidOverlaps(hoverLabels, rotateLabels, fullLayout, hoverText.commonLabelBoundingBox);
    alignHoverText(hoverLabels, rotateLabels, fullLayout._invScaleX, fullLayout._invScaleY);
  } // TODO: tagName hack is needed to appease geo.js's hack of using eventTarget=true
  // we should improve the "fx" API so other plots can use it without these hack.
  if (eventTarget && eventTarget.tagName) {
    var hasClickToShow = Registry.getComponentMethod('annotations', 'hasClickToShow')(gd, newhoverdata);
    overrideCursor(d3.select(eventTarget), hasClickToShow ? 'pointer' : '');
  }

  // don't emit events if called manually
  if (!eventTarget || noHoverEvent || !hoverChanged(gd, evt, oldhoverdata)) return;
  if (oldhoverdata) {
    gd.emit('plotly_unhover', {
      event: evt,
      points: oldhoverdata
    });
  }
  gd.emit('plotly_hover', {
    event: evt,
    points: gd._hoverdata,
    xaxes: xaArray,
    yaxes: yaArray,
    xvals: xvalArray,
    yvals: yvalArray
  });
}
function hoverDataKey(d) {
  return [d.trace.index, d.index, d.x0, d.y0, d.name, d.attr, d.xa ? d.xa._id : '', d.ya ? d.ya._id : ''].join(',');
}
var EXTRA_STRING_REGEX = /<extra>([\s\S]*)<\/extra>/;
function createHoverText(hoverData, opts) {
  var gd = opts.gd;
  var fullLayout = gd._fullLayout;
  var hovermode = opts.hovermode;
  var rotateLabels = opts.rotateLabels;
  var bgColor = opts.bgColor;
  var container = opts.container;
  var outerContainer = opts.outerContainer;
  var commonLabelOpts = opts.commonLabelOpts || {};
  // Early exit if no labels are drawn
  if (hoverData.length === 0) return [[]];

  // opts.fontFamily/Size are used for the common label
  // and as defaults for each hover label, though the individual labels
  // can override this.
  var fontFamily = opts.fontFamily || constants.HOVERFONT;
  var fontSize = opts.fontSize || constants.HOVERFONTSIZE;
  var fontWeight = opts.fontWeight || fullLayout.font.weight;
  var fontStyle = opts.fontStyle || fullLayout.font.style;
  var fontVariant = opts.fontVariant || fullLayout.font.variant;
  var fontTextcase = opts.fontTextcase || fullLayout.font.textcase;
  var fontLineposition = opts.fontLineposition || fullLayout.font.lineposition;
  var fontShadow = opts.fontShadow || fullLayout.font.shadow;
  var c0 = hoverData[0];
  var xa = c0.xa;
  var ya = c0.ya;
  var axLetter = hovermode.charAt(0);
  var axLabel = axLetter + 'Label';
  var t0 = c0[axLabel];

  // search in array for the label
  if (t0 === undefined && xa.type === 'multicategory') {
    for (var q = 0; q < hoverData.length; q++) {
      t0 = hoverData[q][axLabel];
      if (t0 !== undefined) break;
    }
  }
  var outerContainerBB = getBoundingClientRect(gd, outerContainer);
  var outerTop = outerContainerBB.top;
  var outerWidth = outerContainerBB.width;
  var outerHeight = outerContainerBB.height;

  // show the common label, if any, on the axis
  // never show a common label in array mode,
  // even if sometimes there could be one
  var showCommonLabel = t0 !== undefined && c0.distance <= opts.hoverdistance && (hovermode === 'x' || hovermode === 'y');

  // all hover traces hoverinfo must contain the hovermode
  // to have common labels
  if (showCommonLabel) {
    var allHaveZ = true;
    var i, traceHoverinfo;
    for (i = 0; i < hoverData.length; i++) {
      if (allHaveZ && hoverData[i].zLabel === undefined) allHaveZ = false;
      traceHoverinfo = hoverData[i].hoverinfo || hoverData[i].trace.hoverinfo;
      if (traceHoverinfo) {
        var parts = Array.isArray(traceHoverinfo) ? traceHoverinfo : traceHoverinfo.split('+');
        if (parts.indexOf('all') === -1 && parts.indexOf(hovermode) === -1) {
          showCommonLabel = false;
          break;
        }
      }
    }

    // xyz labels put all info in their main label, so have no need of a common label
    if (allHaveZ) showCommonLabel = false;
  }
  var commonLabel = container.selectAll('g.axistext').data(showCommonLabel ? [0] : []);
  commonLabel.enter().append('g').classed('axistext', true);
  commonLabel.exit().remove();

  // set rect (without arrow) behind label below for later collision detection
  var commonLabelRect = {
    minX: 0,
    maxX: 0,
    minY: 0,
    maxY: 0
  };
  commonLabel.each(function () {
    var label = d3.select(this);
    var lpath = Lib.ensureSingle(label, 'path', '', function (s) {
      s.style({
        'stroke-width': '1px'
      });
    });
    var ltext = Lib.ensureSingle(label, 'text', '', function (s) {
      // prohibit tex interpretation until we can handle
      // tex and regular text together
      s.attr('data-notex', 1);
    });
    var commonBgColor = commonLabelOpts.bgcolor || Color.defaultLine;
    var commonStroke = commonLabelOpts.bordercolor || Color.contrast(commonBgColor);
    var contrastColor = Color.contrast(commonBgColor);
    var commonLabelOptsFont = commonLabelOpts.font;
    var commonLabelFont = {
      weight: commonLabelOptsFont.weight || fontWeight,
      style: commonLabelOptsFont.style || fontStyle,
      variant: commonLabelOptsFont.variant || fontVariant,
      textcase: commonLabelOptsFont.textcase || fontTextcase,
      lineposition: commonLabelOptsFont.lineposition || fontLineposition,
      shadow: commonLabelOptsFont.shadow || fontShadow,
      family: commonLabelOptsFont.family || fontFamily,
      size: commonLabelOptsFont.size || fontSize,
      color: commonLabelOptsFont.color || contrastColor
    };
    lpath.style({
      fill: commonBgColor,
      stroke: commonStroke
    });
    ltext.text(t0).call(Drawing.font, commonLabelFont).call(svgTextUtils.positionText, 0, 0).call(svgTextUtils.convertToTspans, gd);
    label.attr('transform', '');
    var tbb = getBoundingClientRect(gd, ltext.node());
    var lx, ly;
    if (hovermode === 'x') {
      var topsign = xa.side === 'top' ? '-' : '';
      ltext.attr('text-anchor', 'middle').call(svgTextUtils.positionText, 0, xa.side === 'top' ? outerTop - tbb.bottom - HOVERARROWSIZE - HOVERTEXTPAD : outerTop - tbb.top + HOVERARROWSIZE + HOVERTEXTPAD);
      lx = xa._offset + (c0.x0 + c0.x1) / 2;
      ly = ya._offset + (xa.side === 'top' ? 0 : ya._length);
      var halfWidth = tbb.width / 2 + HOVERTEXTPAD;
      var tooltipMidX = lx;
      if (lx < halfWidth) {
        tooltipMidX = halfWidth;
      } else if (lx > fullLayout.width - halfWidth) {
        tooltipMidX = fullLayout.width - halfWidth;
      }
      lpath.attr('d', 'M' + (lx - tooltipMidX) + ',0' + 'L' + (lx - tooltipMidX + HOVERARROWSIZE) + ',' + topsign + HOVERARROWSIZE + 'H' + halfWidth + 'v' + topsign + (HOVERTEXTPAD * 2 + tbb.height) + 'H' + -halfWidth + 'V' + topsign + HOVERARROWSIZE + 'H' + (lx - tooltipMidX - HOVERARROWSIZE) + 'Z');
      lx = tooltipMidX;
      commonLabelRect.minX = lx - halfWidth;
      commonLabelRect.maxX = lx + halfWidth;
      if (xa.side === 'top') {
        // label on negative y side
        commonLabelRect.minY = ly - (HOVERTEXTPAD * 2 + tbb.height);
        commonLabelRect.maxY = ly - HOVERTEXTPAD;
      } else {
        commonLabelRect.minY = ly + HOVERTEXTPAD;
        commonLabelRect.maxY = ly + (HOVERTEXTPAD * 2 + tbb.height);
      }
    } else {
      var anchor;
      var sgn;
      var leftsign;
      if (ya.side === 'right') {
        anchor = 'start';
        sgn = 1;
        leftsign = '';
        lx = xa._offset + xa._length;
      } else {
        anchor = 'end';
        sgn = -1;
        leftsign = '-';
        lx = xa._offset;
      }
      ly = ya._offset + (c0.y0 + c0.y1) / 2;
      ltext.attr('text-anchor', anchor);
      lpath.attr('d', 'M0,0' + 'L' + leftsign + HOVERARROWSIZE + ',' + HOVERARROWSIZE + 'V' + (HOVERTEXTPAD + tbb.height / 2) + 'h' + leftsign + (HOVERTEXTPAD * 2 + tbb.width) + 'V-' + (HOVERTEXTPAD + tbb.height / 2) + 'H' + leftsign + HOVERARROWSIZE + 'V-' + HOVERARROWSIZE + 'Z');
      commonLabelRect.minY = ly - (HOVERTEXTPAD + tbb.height / 2);
      commonLabelRect.maxY = ly + (HOVERTEXTPAD + tbb.height / 2);
      if (ya.side === 'right') {
        commonLabelRect.minX = lx + HOVERARROWSIZE;
        commonLabelRect.maxX = lx + HOVERARROWSIZE + (HOVERTEXTPAD * 2 + tbb.width);
      } else {
        // label on negative x side
        commonLabelRect.minX = lx - HOVERARROWSIZE - (HOVERTEXTPAD * 2 + tbb.width);
        commonLabelRect.maxX = lx - HOVERARROWSIZE;
      }
      var halfHeight = tbb.height / 2;
      var lty = outerTop - tbb.top - halfHeight;
      var clipId = 'clip' + fullLayout._uid + 'commonlabel' + ya._id;
      var clipPath;
      if (lx < tbb.width + 2 * HOVERTEXTPAD + HOVERARROWSIZE) {
        clipPath = 'M-' + (HOVERARROWSIZE + HOVERTEXTPAD) + '-' + halfHeight + 'h-' + (tbb.width - HOVERTEXTPAD) + 'V' + halfHeight + 'h' + (tbb.width - HOVERTEXTPAD) + 'Z';
        var ltx = tbb.width - lx + HOVERTEXTPAD;
        svgTextUtils.positionText(ltext, ltx, lty);

        // shift each line (except the longest) so that start-of-line
        // is always visible
        if (anchor === 'end') {
          ltext.selectAll('tspan').each(function () {
            var s = d3.select(this);
            var dummy = Drawing.tester.append('text').text(s.text()).call(Drawing.font, commonLabelFont);
            var dummyBB = getBoundingClientRect(gd, dummy.node());
            if (Math.round(dummyBB.width) < Math.round(tbb.width)) {
              s.attr('x', ltx - dummyBB.width);
            }
            dummy.remove();
          });
        }
      } else {
        svgTextUtils.positionText(ltext, sgn * (HOVERTEXTPAD + HOVERARROWSIZE), lty);
        clipPath = null;
      }
      var textClip = fullLayout._topclips.selectAll('#' + clipId).data(clipPath ? [0] : []);
      textClip.enter().append('clipPath').attr('id', clipId).append('path');
      textClip.exit().remove();
      textClip.select('path').attr('d', clipPath);
      Drawing.setClipUrl(ltext, clipPath ? clipId : null, gd);
    }
    label.attr('transform', strTranslate(lx, ly));
  });

  // Show a single hover label
  if (helpers.isUnifiedHover(hovermode)) {
    // Delete leftover hover labels from other hovermodes
    container.selectAll('g.hovertext').remove();
    var groupedHoverData = hoverData.filter(function (data) {
      return data.hoverinfo !== 'none';
    });
    // Return early if nothing is hovered on
    if (groupedHoverData.length === 0) return [];

    // mock legend
    var hoverlabel = fullLayout.hoverlabel;
    var font = hoverlabel.font;
    var mockLayoutIn = {
      showlegend: true,
      legend: {
        title: {
          text: t0,
          font: font
        },
        font: font,
        bgcolor: hoverlabel.bgcolor,
        bordercolor: hoverlabel.bordercolor,
        borderwidth: 1,
        tracegroupgap: 7,
        traceorder: fullLayout.legend ? fullLayout.legend.traceorder : undefined,
        orientation: 'v'
      }
    };
    var mockLayoutOut = {
      font: font
    };
    legendSupplyDefaults(mockLayoutIn, mockLayoutOut, gd._fullData);
    var mockLegend = mockLayoutOut.legend;

    // prepare items for the legend
    mockLegend.entries = [];
    for (var j = 0; j < groupedHoverData.length; j++) {
      var pt = groupedHoverData[j];
      if (pt.hoverinfo === 'none') continue;
      var texts = getHoverLabelText(pt, true, hovermode, fullLayout, t0);
      var text = texts[0];
      var name = texts[1];
      pt.name = name;
      if (name !== '') {
        pt.text = name + ' : ' + text;
      } else {
        pt.text = text;
      }

      // pass through marker's calcdata to style legend items
      var cd = pt.cd[pt.index];
      if (cd) {
        if (cd.mc) pt.mc = cd.mc;
        if (cd.mcc) pt.mc = cd.mcc;
        if (cd.mlc) pt.mlc = cd.mlc;
        if (cd.mlcc) pt.mlc = cd.mlcc;
        if (cd.mlw) pt.mlw = cd.mlw;
        if (cd.mrc) pt.mrc = cd.mrc;
        if (cd.dir) pt.dir = cd.dir;
      }
      pt._distinct = true;
      mockLegend.entries.push([pt]);
    }
    mockLegend.entries.sort(function (a, b) {
      return a[0].trace.index - b[0].trace.index;
    });
    mockLegend.layer = container;

    // Draw unified hover label
    mockLegend._inHover = true;
    mockLegend._groupTitleFont = hoverlabel.grouptitlefont;
    legendDraw(gd, mockLegend);

    // Position the hover
    var legendContainer = container.select('g.legend');
    var tbb = getBoundingClientRect(gd, legendContainer.node());
    var tWidth = tbb.width + 2 * HOVERTEXTPAD;
    var tHeight = tbb.height + 2 * HOVERTEXTPAD;
    var winningPoint = groupedHoverData[0];
    var avgX = (winningPoint.x0 + winningPoint.x1) / 2;
    var avgY = (winningPoint.y0 + winningPoint.y1) / 2;
    // When a scatter (or e.g. heatmap) point wins, it's OK for the hovelabel to occlude the bar and other points.
    var pointWon = !(Registry.traceIs(winningPoint.trace, 'bar-like') || Registry.traceIs(winningPoint.trace, 'box-violin'));
    var lyBottom, lyTop;
    if (axLetter === 'y') {
      if (pointWon) {
        lyTop = avgY - HOVERTEXTPAD;
        lyBottom = avgY + HOVERTEXTPAD;
      } else {
        lyTop = Math.min.apply(null, groupedHoverData.map(function (c) {
          return Math.min(c.y0, c.y1);
        }));
        lyBottom = Math.max.apply(null, groupedHoverData.map(function (c) {
          return Math.max(c.y0, c.y1);
        }));
      }
    } else {
      lyTop = lyBottom = Lib.mean(groupedHoverData.map(function (c) {
        return (c.y0 + c.y1) / 2;
      })) - tHeight / 2;
    }
    var lxRight, lxLeft;
    if (axLetter === 'x') {
      if (pointWon) {
        lxRight = avgX + HOVERTEXTPAD;
        lxLeft = avgX - HOVERTEXTPAD;
      } else {
        lxRight = Math.max.apply(null, groupedHoverData.map(function (c) {
          return Math.max(c.x0, c.x1);
        }));
        lxLeft = Math.min.apply(null, groupedHoverData.map(function (c) {
          return Math.min(c.x0, c.x1);
        }));
      }
    } else {
      lxRight = lxLeft = Lib.mean(groupedHoverData.map(function (c) {
        return (c.x0 + c.x1) / 2;
      })) - tWidth / 2;
    }
    var xOffset = xa._offset;
    var yOffset = ya._offset;
    lyBottom += yOffset;
    lxRight += xOffset;
    lxLeft += xOffset - tWidth;
    lyTop += yOffset - tHeight;
    var lx, ly; // top and left positions of the hover box

    // horizontal alignment to end up on screen
    if (lxRight + tWidth < outerWidth && lxRight >= 0) {
      lx = lxRight;
    } else if (lxLeft + tWidth < outerWidth && lxLeft >= 0) {
      lx = lxLeft;
    } else if (xOffset + tWidth < outerWidth) {
      lx = xOffset; // subplot left corner
    } else {
      // closest left or right side of the paper
      if (lxRight - avgX < avgX - lxLeft + tWidth) {
        lx = outerWidth - tWidth;
      } else {
        lx = 0;
      }
    }
    lx += HOVERTEXTPAD;

    // vertical alignement to end up on screen
    if (lyBottom + tHeight < outerHeight && lyBottom >= 0) {
      ly = lyBottom;
    } else if (lyTop + tHeight < outerHeight && lyTop >= 0) {
      ly = lyTop;
    } else if (yOffset + tHeight < outerHeight) {
      ly = yOffset; // subplot top corner
    } else {
      // closest top or bottom side of the paper
      if (lyBottom - avgY < avgY - lyTop + tHeight) {
        ly = outerHeight - tHeight;
      } else {
        ly = 0;
      }
    }
    ly += HOVERTEXTPAD;
    legendContainer.attr('transform', strTranslate(lx - 1, ly - 1));
    return legendContainer;
  }

  // show all the individual labels

  // first create the objects
  var hoverLabels = container.selectAll('g.hovertext').data(hoverData, function (d) {
    // N.B. when multiple items have the same result key-function value,
    // only the first of those items in hoverData gets rendered
    return hoverDataKey(d);
  });
  hoverLabels.enter().append('g').classed('hovertext', true).each(function () {
    var g = d3.select(this);
    // trace name label (rect and text.name)
    g.append('rect').call(Color.fill, Color.addOpacity(bgColor, 0.8));
    g.append('text').classed('name', true);
    // trace data label (path and text.nums)
    g.append('path').style('stroke-width', '1px');
    g.append('text').classed('nums', true).call(Drawing.font, {
      weight: fontWeight,
      style: fontStyle,
      variant: fontVariant,
      textcase: fontTextcase,
      lineposition: fontLineposition,
      shadow: fontShadow,
      family: fontFamily,
      size: fontSize
    });
  });
  hoverLabels.exit().remove();

  // then put the text in, position the pointer to the data,
  // and figure out sizes
  hoverLabels.each(function (d) {
    var g = d3.select(this).attr('transform', '');
    var dColor = d.color;
    if (Array.isArray(dColor)) {
      dColor = dColor[d.eventData[0].pointNumber];
    }

    // combine possible non-opaque trace color with bgColor
    var color0 = d.bgcolor || dColor;
    // color for 'nums' part of the label
    var numsColor = Color.combine(Color.opacity(color0) ? color0 : Color.defaultLine, bgColor);
    // color for 'name' part of the label
    var nameColor = Color.combine(Color.opacity(dColor) ? dColor : Color.defaultLine, bgColor);
    // find a contrasting color for border and text
    var contrastColor = d.borderColor || Color.contrast(numsColor);
    var texts = getHoverLabelText(d, showCommonLabel, hovermode, fullLayout, t0, g);
    var text = texts[0];
    var name = texts[1];

    // main label
    var tx = g.select('text.nums').call(Drawing.font, {
      family: d.fontFamily || fontFamily,
      size: d.fontSize || fontSize,
      color: d.fontColor || contrastColor,
      weight: d.fontWeight || fontWeight,
      style: d.fontStyle || fontStyle,
      variant: d.fontVariant || fontVariant,
      textcase: d.fontTextcase || fontTextcase,
      lineposition: d.fontLineposition || fontLineposition,
      shadow: d.fontShadow || fontShadow
    }).text(text).attr('data-notex', 1).call(svgTextUtils.positionText, 0, 0).call(svgTextUtils.convertToTspans, gd);
    var tx2 = g.select('text.name');
    var tx2width = 0;
    var tx2height = 0;

    // secondary label for non-empty 'name'
    if (name && name !== text) {
      tx2.call(Drawing.font, {
        family: d.fontFamily || fontFamily,
        size: d.fontSize || fontSize,
        color: nameColor,
        weight: d.fontWeight || fontWeight,
        style: d.fontStyle || fontStyle,
        variant: d.fontVariant || fontVariant,
        textcase: d.fontTextcase || fontTextcase,
        lineposition: d.fontLineposition || fontLineposition,
        shadow: d.fontShadow || fontShadow
      }).text(name).attr('data-notex', 1).call(svgTextUtils.positionText, 0, 0).call(svgTextUtils.convertToTspans, gd);
      var t2bb = getBoundingClientRect(gd, tx2.node());
      tx2width = t2bb.width + 2 * HOVERTEXTPAD;
      tx2height = t2bb.height + 2 * HOVERTEXTPAD;
    } else {
      tx2.remove();
      g.select('rect').remove();
    }
    g.select('path').style({
      fill: numsColor,
      stroke: contrastColor
    });
    var htx = d.xa._offset + (d.x0 + d.x1) / 2;
    var hty = d.ya._offset + (d.y0 + d.y1) / 2;
    var dx = Math.abs(d.x1 - d.x0);
    var dy = Math.abs(d.y1 - d.y0);
    var tbb = getBoundingClientRect(gd, tx.node());
    var tbbWidth = tbb.width / fullLayout._invScaleX;
    var tbbHeight = tbb.height / fullLayout._invScaleY;
    d.ty0 = (outerTop - tbb.top) / fullLayout._invScaleY;
    d.bx = tbbWidth + 2 * HOVERTEXTPAD;
    d.by = Math.max(tbbHeight + 2 * HOVERTEXTPAD, tx2height);
    d.anchor = 'start';
    d.txwidth = tbbWidth;
    d.tx2width = tx2width;
    d.offset = 0;
    var txTotalWidth = (tbbWidth + HOVERARROWSIZE + HOVERTEXTPAD + tx2width) * fullLayout._invScaleX;
    var anchorStartOK, anchorEndOK;
    if (rotateLabels) {
      d.pos = htx;
      anchorStartOK = hty + dy / 2 + txTotalWidth <= outerHeight;
      anchorEndOK = hty - dy / 2 - txTotalWidth >= 0;
      if ((d.idealAlign === 'top' || !anchorStartOK) && anchorEndOK) {
        hty -= dy / 2;
        d.anchor = 'end';
      } else if (anchorStartOK) {
        hty += dy / 2;
        d.anchor = 'start';
      } else {
        d.anchor = 'middle';
      }
      d.crossPos = hty;
    } else {
      d.pos = hty;
      anchorStartOK = htx + dx / 2 + txTotalWidth <= outerWidth;
      anchorEndOK = htx - dx / 2 - txTotalWidth >= 0;
      if ((d.idealAlign === 'left' || !anchorStartOK) && anchorEndOK) {
        htx -= dx / 2;
        d.anchor = 'end';
      } else if (anchorStartOK) {
        htx += dx / 2;
        d.anchor = 'start';
      } else {
        d.anchor = 'middle';
        var txHalfWidth = txTotalWidth / 2;
        var overflowR = htx + txHalfWidth - outerWidth;
        var overflowL = htx - txHalfWidth;
        if (overflowR > 0) htx -= overflowR;
        if (overflowL < 0) htx += -overflowL;
      }
      d.crossPos = htx;
    }
    tx.attr('text-anchor', d.anchor);
    if (tx2width) tx2.attr('text-anchor', d.anchor);
    g.attr('transform', strTranslate(htx, hty) + (rotateLabels ? strRotate(YANGLE) : ''));
  });
  return {
    hoverLabels: hoverLabels,
    commonLabelBoundingBox: commonLabelRect
  };
}
function getHoverLabelText(d, showCommonLabel, hovermode, fullLayout, t0, g) {
  var name = '';
  var text = '';
  // to get custom 'name' labels pass cleanPoint
  if (d.nameOverride !== undefined) d.name = d.nameOverride;
  if (d.name) {
    if (d.trace._meta) {
      d.name = Lib.templateString(d.name, d.trace._meta);
    }
    name = plainText(d.name, d.nameLength);
  }
  var h0 = hovermode.charAt(0);
  var h1 = h0 === 'x' ? 'y' : 'x';
  if (d.zLabel !== undefined) {
    if (d.xLabel !== undefined) text += 'x: ' + d.xLabel + '<br>';
    if (d.yLabel !== undefined) text += 'y: ' + d.yLabel + '<br>';
    if (d.trace.type !== 'choropleth' && d.trace.type !== 'choroplethmapbox' && d.trace.type !== 'choroplethmap') {
      text += (text ? 'z: ' : '') + d.zLabel;
    }
  } else if (showCommonLabel && d[h0 + 'Label'] === t0) {
    text = d[h1 + 'Label'] || '';
  } else if (d.xLabel === undefined) {
    if (d.yLabel !== undefined && d.trace.type !== 'scattercarpet') {
      text = d.yLabel;
    }
  } else if (d.yLabel === undefined) text = d.xLabel;else text = '(' + d.xLabel + ', ' + d.yLabel + ')';
  if ((d.text || d.text === 0) && !Array.isArray(d.text)) {
    text += (text ? '<br>' : '') + d.text;
  }

  // used by other modules (initially just ternary) that
  // manage their own hoverinfo independent of cleanPoint
  // the rest of this will still apply, so such modules
  // can still put things in (x|y|z)Label, text, and name
  // and hoverinfo will still determine their visibility
  if (d.extraText !== undefined) text += (text ? '<br>' : '') + d.extraText;

  // if 'text' is empty at this point,
  // and hovertemplate is not defined,
  // put 'name' in main label and don't show secondary label
  if (g && text === '' && !d.hovertemplate) {
    // if 'name' is also empty, remove entire label
    if (name === '') g.remove();
    text = name;
  }

  // hovertemplate
  var hovertemplate = d.hovertemplate || false;
  if (hovertemplate) {
    var labels = d.hovertemplateLabels || d;
    if (d[h0 + 'Label'] !== t0) {
      labels[h0 + 'other'] = labels[h0 + 'Val'];
      labels[h0 + 'otherLabel'] = labels[h0 + 'Label'];
    }
    text = Lib.hovertemplateString(hovertemplate, labels, fullLayout._d3locale, d.eventData[0] || {}, d.trace._meta);
    text = text.replace(EXTRA_STRING_REGEX, function (match, extra) {
      // assign name for secondary text label
      name = plainText(extra, d.nameLength);
      // remove from main text label
      return '';
    });
  }
  return [text, name];
}

// Make groups of touching points, and within each group
// move each point so that no labels overlap, but the average
// label position is the same as it was before moving. Incidentally,
// this is equivalent to saying all the labels are on equal linear
// springs about their initial position. Initially, each point is
// its own group, but as we find overlaps we will clump the points.
//
// Also, there are hard constraints at the edges of the graphs,
// that push all groups to the middle so they are visible. I don't
// know what happens if the group spans all the way from one edge to
// the other, though it hardly matters - there's just too much
// information then.
function hoverAvoidOverlaps(hoverLabels, rotateLabels, fullLayout, commonLabelBoundingBox) {
  var axKey = rotateLabels ? 'xa' : 'ya';
  var crossAxKey = rotateLabels ? 'ya' : 'xa';
  var nummoves = 0;
  var axSign = 1;
  var nLabels = hoverLabels.size();

  // make groups of touching points
  var pointgroups = new Array(nLabels);
  var k = 0;

  // get extent of axis hover label
  var axisLabelMinX = commonLabelBoundingBox.minX;
  var axisLabelMaxX = commonLabelBoundingBox.maxX;
  var axisLabelMinY = commonLabelBoundingBox.minY;
  var axisLabelMaxY = commonLabelBoundingBox.maxY;
  var pX = function (x) {
    return x * fullLayout._invScaleX;
  };
  var pY = function (y) {
    return y * fullLayout._invScaleY;
  };
  hoverLabels.each(function (d) {
    var ax = d[axKey];
    var crossAx = d[crossAxKey];
    var axIsX = ax._id.charAt(0) === 'x';
    var rng = ax.range;
    if (k === 0 && rng && rng[0] > rng[1] !== axIsX) {
      axSign = -1;
    }
    var pmin = 0;
    var pmax = axIsX ? fullLayout.width : fullLayout.height;
    // in hovermode avoid overlap between hover labels and axis label
    if (fullLayout.hovermode === 'x' || fullLayout.hovermode === 'y') {
      // extent of rect behind hover label on cross axis:
      var offsets = getHoverLabelOffsets(d, rotateLabels);
      var anchor = d.anchor;
      var horzSign = anchor === 'end' ? -1 : 1;
      var labelMin;
      var labelMax;
      if (anchor === 'middle') {
        // use extent of centered rect either on x or y axis depending on current axis
        labelMin = d.crossPos + (axIsX ? pY(offsets.y - d.by / 2) : pX(d.bx / 2 + d.tx2width / 2));
        labelMax = labelMin + (axIsX ? pY(d.by) : pX(d.bx));
      } else {
        // use extend of path (see alignHoverText function) without arrow
        if (axIsX) {
          labelMin = d.crossPos + pY(HOVERARROWSIZE + offsets.y) - pY(d.by / 2 - HOVERARROWSIZE);
          labelMax = labelMin + pY(d.by);
        } else {
          var startX = pX(horzSign * HOVERARROWSIZE + offsets.x);
          var endX = startX + pX(horzSign * d.bx);
          labelMin = d.crossPos + Math.min(startX, endX);
          labelMax = d.crossPos + Math.max(startX, endX);
        }
      }
      if (axIsX) {
        if (axisLabelMinY !== undefined && axisLabelMaxY !== undefined && Math.min(labelMax, axisLabelMaxY) - Math.max(labelMin, axisLabelMinY) > 1) {
          // has at least 1 pixel overlap with axis label
          if (crossAx.side === 'left') {
            pmin = crossAx._mainLinePosition;
            pmax = fullLayout.width;
          } else {
            pmax = crossAx._mainLinePosition;
          }
        }
      } else {
        if (axisLabelMinX !== undefined && axisLabelMaxX !== undefined && Math.min(labelMax, axisLabelMaxX) - Math.max(labelMin, axisLabelMinX) > 1) {
          // has at least 1 pixel overlap with axis label
          if (crossAx.side === 'top') {
            pmin = crossAx._mainLinePosition;
            pmax = fullLayout.height;
          } else {
            pmax = crossAx._mainLinePosition;
          }
        }
      }
    }
    pointgroups[k++] = [{
      datum: d,
      traceIndex: d.trace.index,
      dp: 0,
      pos: d.pos,
      posref: d.posref,
      size: d.by * (axIsX ? YFACTOR : 1) / 2,
      pmin: pmin,
      pmax: pmax
    }];
  });
  pointgroups.sort(function (a, b) {
    return a[0].posref - b[0].posref ||
    // for equal positions, sort trace indices increasing or decreasing
    // depending on whether the axis is reversed or not... so stacked
    // traces will generally keep their order even if one trace adds
    // nothing to the stack.
    axSign * (b[0].traceIndex - a[0].traceIndex);
  });
  var donepositioning, topOverlap, bottomOverlap, i, j, pti, sumdp;
  function constrainGroup(grp) {
    var minPt = grp[0];
    var maxPt = grp[grp.length - 1];

    // overlap with the top - positive vals are overlaps
    topOverlap = minPt.pmin - minPt.pos - minPt.dp + minPt.size;

    // overlap with the bottom - positive vals are overlaps
    bottomOverlap = maxPt.pos + maxPt.dp + maxPt.size - minPt.pmax;

    // check for min overlap first, so that we always
    // see the largest labels
    // allow for .01px overlap, so we don't get an
    // infinite loop from rounding errors
    if (topOverlap > 0.01) {
      for (j = grp.length - 1; j >= 0; j--) grp[j].dp += topOverlap;
      donepositioning = false;
    }
    if (bottomOverlap < 0.01) return;
    if (topOverlap < -0.01) {
      // make sure we're not pushing back and forth
      for (j = grp.length - 1; j >= 0; j--) grp[j].dp -= bottomOverlap;
      donepositioning = false;
    }
    if (!donepositioning) return;

    // no room to fix positioning, delete off-screen points

    // first see how many points we need to delete
    var deleteCount = 0;
    for (i = 0; i < grp.length; i++) {
      pti = grp[i];
      if (pti.pos + pti.dp + pti.size > minPt.pmax) deleteCount++;
    }

    // start by deleting points whose data is off screen
    for (i = grp.length - 1; i >= 0; i--) {
      if (deleteCount <= 0) break;
      pti = grp[i];

      // pos has already been constrained to [pmin,pmax]
      // so look for points close to that to delete
      if (pti.pos > minPt.pmax - 1) {
        pti.del = true;
        deleteCount--;
      }
    }
    for (i = 0; i < grp.length; i++) {
      if (deleteCount <= 0) break;
      pti = grp[i];

      // pos has already been constrained to [pmin,pmax]
      // so look for points close to that to delete
      if (pti.pos < minPt.pmin + 1) {
        pti.del = true;
        deleteCount--;

        // shift the whole group minus into this new space
        bottomOverlap = pti.size * 2;
        for (j = grp.length - 1; j >= 0; j--) grp[j].dp -= bottomOverlap;
      }
    }
    // then delete points that go off the bottom
    for (i = grp.length - 1; i >= 0; i--) {
      if (deleteCount <= 0) break;
      pti = grp[i];
      if (pti.pos + pti.dp + pti.size > minPt.pmax) {
        pti.del = true;
        deleteCount--;
      }
    }
  }

  // loop through groups, combining them if they overlap,
  // until nothing moves
  while (!donepositioning && nummoves <= nLabels) {
    // to avoid infinite loops, don't move more times
    // than there are traces
    nummoves++;

    // assume nothing will move in this iteration,
    // reverse this if it does
    donepositioning = true;
    i = 0;
    while (i < pointgroups.length - 1) {
      // the higher (g0) and lower (g1) point group
      var g0 = pointgroups[i];
      var g1 = pointgroups[i + 1];

      // the lowest point in the higher group (p0)
      // the highest point in the lower group (p1)
      var p0 = g0[g0.length - 1];
      var p1 = g1[0];
      topOverlap = p0.pos + p0.dp + p0.size - p1.pos - p1.dp + p1.size;
      if (topOverlap > 0.01) {
        // push the new point(s) added to this group out of the way
        for (j = g1.length - 1; j >= 0; j--) g1[j].dp += topOverlap;

        // add them to the group
        g0.push.apply(g0, g1);
        pointgroups.splice(i + 1, 1);

        // adjust for minimum average movement
        sumdp = 0;
        for (j = g0.length - 1; j >= 0; j--) sumdp += g0[j].dp;
        bottomOverlap = sumdp / g0.length;
        for (j = g0.length - 1; j >= 0; j--) g0[j].dp -= bottomOverlap;
        donepositioning = false;
      } else i++;
    }

    // check if we're going off the plot on either side and fix
    pointgroups.forEach(constrainGroup);
  }

  // now put these offsets into hoverData
  for (i = pointgroups.length - 1; i >= 0; i--) {
    var grp = pointgroups[i];
    for (j = grp.length - 1; j >= 0; j--) {
      var pt = grp[j];
      var hoverPt = pt.datum;
      hoverPt.offset = pt.dp;
      hoverPt.del = pt.del;
    }
  }
}
function getHoverLabelOffsets(hoverLabel, rotateLabels) {
  var offsetX = 0;
  var offsetY = hoverLabel.offset;
  if (rotateLabels) {
    offsetY *= -YSHIFTY;
    offsetX = hoverLabel.offset * YSHIFTX;
  }
  return {
    x: offsetX,
    y: offsetY
  };
}

/**
 * Calculate the shift in x for text and text2 elements
 */
function getTextShiftX(hoverLabel) {
  var alignShift = {
    start: 1,
    end: -1,
    middle: 0
  }[hoverLabel.anchor];
  var textShiftX = alignShift * (HOVERARROWSIZE + HOVERTEXTPAD);
  var text2ShiftX = textShiftX + alignShift * (hoverLabel.txwidth + HOVERTEXTPAD);
  var isMiddle = hoverLabel.anchor === 'middle';
  if (isMiddle) {
    textShiftX -= hoverLabel.tx2width / 2;
    text2ShiftX += hoverLabel.txwidth / 2 + HOVERTEXTPAD;
  }
  return {
    alignShift: alignShift,
    textShiftX: textShiftX,
    text2ShiftX: text2ShiftX
  };
}
function alignHoverText(hoverLabels, rotateLabels, scaleX, scaleY) {
  var pX = function (x) {
    return x * scaleX;
  };
  var pY = function (y) {
    return y * scaleY;
  };

  // finally set the text positioning relative to the data and draw the
  // box around it
  hoverLabels.each(function (d) {
    var g = d3.select(this);
    if (d.del) return g.remove();
    var tx = g.select('text.nums');
    var anchor = d.anchor;
    var horzSign = anchor === 'end' ? -1 : 1;
    var shiftX = getTextShiftX(d);
    var offsets = getHoverLabelOffsets(d, rotateLabels);
    var offsetX = offsets.x;
    var offsetY = offsets.y;
    var isMiddle = anchor === 'middle';
    g.select('path').attr('d', isMiddle ?
    // middle aligned: rect centered on data
    'M-' + pX(d.bx / 2 + d.tx2width / 2) + ',' + pY(offsetY - d.by / 2) + 'h' + pX(d.bx) + 'v' + pY(d.by) + 'h-' + pX(d.bx) + 'Z' :
    // left or right aligned: side rect with arrow to data
    'M0,0L' + pX(horzSign * HOVERARROWSIZE + offsetX) + ',' + pY(HOVERARROWSIZE + offsetY) + 'v' + pY(d.by / 2 - HOVERARROWSIZE) + 'h' + pX(horzSign * d.bx) + 'v-' + pY(d.by) + 'H' + pX(horzSign * HOVERARROWSIZE + offsetX) + 'V' + pY(offsetY - HOVERARROWSIZE) + 'Z');
    var posX = offsetX + shiftX.textShiftX;
    var posY = offsetY + d.ty0 - d.by / 2 + HOVERTEXTPAD;
    var textAlign = d.textAlign || 'auto';
    if (textAlign !== 'auto') {
      if (textAlign === 'left' && anchor !== 'start') {
        tx.attr('text-anchor', 'start');
        posX = isMiddle ? -d.bx / 2 - d.tx2width / 2 + HOVERTEXTPAD : -d.bx - HOVERTEXTPAD;
      } else if (textAlign === 'right' && anchor !== 'end') {
        tx.attr('text-anchor', 'end');
        posX = isMiddle ? d.bx / 2 - d.tx2width / 2 - HOVERTEXTPAD : d.bx + HOVERTEXTPAD;
      }
    }
    tx.call(svgTextUtils.positionText, pX(posX), pY(posY));
    if (d.tx2width) {
      g.select('text.name').call(svgTextUtils.positionText, pX(shiftX.text2ShiftX + shiftX.alignShift * HOVERTEXTPAD + offsetX), pY(offsetY + d.ty0 - d.by / 2 + HOVERTEXTPAD));
      g.select('rect').call(Drawing.setRect, pX(shiftX.text2ShiftX + (shiftX.alignShift - 1) * d.tx2width / 2 + offsetX), pY(offsetY - d.by / 2 - 1), pX(d.tx2width), pY(d.by + 2));
    }
  });
}
function cleanPoint(d, hovermode) {
  var index = d.index;
  var trace = d.trace || {};
  var cd0 = d.cd[0];
  var cd = d.cd[index] || {};
  function pass(v) {
    return v || isNumeric(v) && v === 0;
  }
  var getVal = Array.isArray(index) ? function (calcKey, traceKey) {
    var v = Lib.castOption(cd0, index, calcKey);
    return pass(v) ? v : Lib.extractOption({}, trace, '', traceKey);
  } : function (calcKey, traceKey) {
    return Lib.extractOption(cd, trace, calcKey, traceKey);
  };
  function fill(key, calcKey, traceKey) {
    var val = getVal(calcKey, traceKey);
    if (pass(val)) d[key] = val;
  }
  fill('hoverinfo', 'hi', 'hoverinfo');
  fill('bgcolor', 'hbg', 'hoverlabel.bgcolor');
  fill('borderColor', 'hbc', 'hoverlabel.bordercolor');
  fill('fontFamily', 'htf', 'hoverlabel.font.family');
  fill('fontSize', 'hts', 'hoverlabel.font.size');
  fill('fontColor', 'htc', 'hoverlabel.font.color');
  fill('fontWeight', 'htw', 'hoverlabel.font.weight');
  fill('fontStyle', 'hty', 'hoverlabel.font.style');
  fill('fontVariant', 'htv', 'hoverlabel.font.variant');
  fill('nameLength', 'hnl', 'hoverlabel.namelength');
  fill('textAlign', 'hta', 'hoverlabel.align');
  d.posref = hovermode === 'y' || hovermode === 'closest' && trace.orientation === 'h' ? d.xa._offset + (d.x0 + d.x1) / 2 : d.ya._offset + (d.y0 + d.y1) / 2;

  // then constrain all the positions to be on the plot
  d.x0 = Lib.constrain(d.x0, 0, d.xa._length);
  d.x1 = Lib.constrain(d.x1, 0, d.xa._length);
  d.y0 = Lib.constrain(d.y0, 0, d.ya._length);
  d.y1 = Lib.constrain(d.y1, 0, d.ya._length);

  // and convert the x and y label values into formatted text
  if (d.xLabelVal !== undefined) {
    d.xLabel = 'xLabel' in d ? d.xLabel : Axes.hoverLabelText(d.xa, d.xLabelVal, trace.xhoverformat);
    d.xVal = d.xa.c2d(d.xLabelVal);
  }
  if (d.yLabelVal !== undefined) {
    d.yLabel = 'yLabel' in d ? d.yLabel : Axes.hoverLabelText(d.ya, d.yLabelVal, trace.yhoverformat);
    d.yVal = d.ya.c2d(d.yLabelVal);
  }

  // Traces like heatmaps generate the zLabel in their hoverPoints function
  if (d.zLabelVal !== undefined && d.zLabel === undefined) {
    d.zLabel = String(d.zLabelVal);
  }

  // for box means and error bars, add the range to the label
  if (!isNaN(d.xerr) && !(d.xa.type === 'log' && d.xerr <= 0)) {
    var xeText = Axes.tickText(d.xa, d.xa.c2l(d.xerr), 'hover').text;
    if (d.xerrneg !== undefined) {
      d.xLabel += ' +' + xeText + ' / -' + Axes.tickText(d.xa, d.xa.c2l(d.xerrneg), 'hover').text;
    } else d.xLabel += ' ± ' + xeText;

    // small distance penalty for error bars, so that if there are
    // traces with errors and some without, the error bar label will
    // hoist up to the point
    if (hovermode === 'x') d.distance += 1;
  }
  if (!isNaN(d.yerr) && !(d.ya.type === 'log' && d.yerr <= 0)) {
    var yeText = Axes.tickText(d.ya, d.ya.c2l(d.yerr), 'hover').text;
    if (d.yerrneg !== undefined) {
      d.yLabel += ' +' + yeText + ' / -' + Axes.tickText(d.ya, d.ya.c2l(d.yerrneg), 'hover').text;
    } else d.yLabel += ' ± ' + yeText;
    if (hovermode === 'y') d.distance += 1;
  }
  var infomode = d.hoverinfo || d.trace.hoverinfo;
  if (infomode && infomode !== 'all') {
    infomode = Array.isArray(infomode) ? infomode : infomode.split('+');
    if (infomode.indexOf('x') === -1) d.xLabel = undefined;
    if (infomode.indexOf('y') === -1) d.yLabel = undefined;
    if (infomode.indexOf('z') === -1) d.zLabel = undefined;
    if (infomode.indexOf('text') === -1) d.text = undefined;
    if (infomode.indexOf('name') === -1) d.name = undefined;
  }
  return d;
}
function createSpikelines(gd, closestPoints, opts) {
  var container = opts.container;
  var fullLayout = opts.fullLayout;
  var gs = fullLayout._size;
  var evt = opts.event;
  var showY = !!closestPoints.hLinePoint;
  var showX = !!closestPoints.vLinePoint;
  var xa, ya;

  // Remove old spikeline items
  container.selectAll('.spikeline').remove();
  if (!(showX || showY)) return;
  var contrastColor = Color.combine(fullLayout.plot_bgcolor, fullLayout.paper_bgcolor);

  // Horizontal line (to y-axis)
  if (showY) {
    var hLinePoint = closestPoints.hLinePoint;
    var hLinePointX, hLinePointY;
    xa = hLinePoint && hLinePoint.xa;
    ya = hLinePoint && hLinePoint.ya;
    var ySnap = ya.spikesnap;
    if (ySnap === 'cursor') {
      hLinePointX = evt.pointerX;
      hLinePointY = evt.pointerY;
    } else {
      hLinePointX = xa._offset + hLinePoint.x;
      hLinePointY = ya._offset + hLinePoint.y;
    }
    var dfltHLineColor = tinycolor.readability(hLinePoint.color, contrastColor) < 1.5 ? Color.contrast(contrastColor) : hLinePoint.color;
    var yMode = ya.spikemode;
    var yThickness = ya.spikethickness;
    var yColor = ya.spikecolor || dfltHLineColor;
    var xEdge = Axes.getPxPosition(gd, ya);
    var xBase, xEndSpike;
    if (yMode.indexOf('toaxis') !== -1 || yMode.indexOf('across') !== -1) {
      if (yMode.indexOf('toaxis') !== -1) {
        xBase = xEdge;
        xEndSpike = hLinePointX;
      }
      if (yMode.indexOf('across') !== -1) {
        var xAcross0 = ya._counterDomainMin;
        var xAcross1 = ya._counterDomainMax;
        if (ya.anchor === 'free') {
          xAcross0 = Math.min(xAcross0, ya.position);
          xAcross1 = Math.max(xAcross1, ya.position);
        }
        xBase = gs.l + xAcross0 * gs.w;
        xEndSpike = gs.l + xAcross1 * gs.w;
      }

      // Foreground horizontal line (to y-axis)
      container.insert('line', ':first-child').attr({
        x1: xBase,
        x2: xEndSpike,
        y1: hLinePointY,
        y2: hLinePointY,
        'stroke-width': yThickness,
        stroke: yColor,
        'stroke-dasharray': Drawing.dashStyle(ya.spikedash, yThickness)
      }).classed('spikeline', true).classed('crisp', true);

      // Background horizontal Line (to y-axis)
      container.insert('line', ':first-child').attr({
        x1: xBase,
        x2: xEndSpike,
        y1: hLinePointY,
        y2: hLinePointY,
        'stroke-width': yThickness + 2,
        stroke: contrastColor
      }).classed('spikeline', true).classed('crisp', true);
    }
    // Y axis marker
    if (yMode.indexOf('marker') !== -1) {
      container.insert('circle', ':first-child').attr({
        cx: xEdge + (ya.side !== 'right' ? yThickness : -yThickness),
        cy: hLinePointY,
        r: yThickness,
        fill: yColor
      }).classed('spikeline', true);
    }
  }
  if (showX) {
    var vLinePoint = closestPoints.vLinePoint;
    var vLinePointX, vLinePointY;
    xa = vLinePoint && vLinePoint.xa;
    ya = vLinePoint && vLinePoint.ya;
    var xSnap = xa.spikesnap;
    if (xSnap === 'cursor') {
      vLinePointX = evt.pointerX;
      vLinePointY = evt.pointerY;
    } else {
      vLinePointX = xa._offset + vLinePoint.x;
      vLinePointY = ya._offset + vLinePoint.y;
    }
    var dfltVLineColor = tinycolor.readability(vLinePoint.color, contrastColor) < 1.5 ? Color.contrast(contrastColor) : vLinePoint.color;
    var xMode = xa.spikemode;
    var xThickness = xa.spikethickness;
    var xColor = xa.spikecolor || dfltVLineColor;
    var yEdge = Axes.getPxPosition(gd, xa);
    var yBase, yEndSpike;
    if (xMode.indexOf('toaxis') !== -1 || xMode.indexOf('across') !== -1) {
      if (xMode.indexOf('toaxis') !== -1) {
        yBase = yEdge;
        yEndSpike = vLinePointY;
      }
      if (xMode.indexOf('across') !== -1) {
        var yAcross0 = xa._counterDomainMin;
        var yAcross1 = xa._counterDomainMax;
        if (xa.anchor === 'free') {
          yAcross0 = Math.min(yAcross0, xa.position);
          yAcross1 = Math.max(yAcross1, xa.position);
        }
        yBase = gs.t + (1 - yAcross1) * gs.h;
        yEndSpike = gs.t + (1 - yAcross0) * gs.h;
      }

      // Foreground vertical line (to x-axis)
      container.insert('line', ':first-child').attr({
        x1: vLinePointX,
        x2: vLinePointX,
        y1: yBase,
        y2: yEndSpike,
        'stroke-width': xThickness,
        stroke: xColor,
        'stroke-dasharray': Drawing.dashStyle(xa.spikedash, xThickness)
      }).classed('spikeline', true).classed('crisp', true);

      // Background vertical line (to x-axis)
      container.insert('line', ':first-child').attr({
        x1: vLinePointX,
        x2: vLinePointX,
        y1: yBase,
        y2: yEndSpike,
        'stroke-width': xThickness + 2,
        stroke: contrastColor
      }).classed('spikeline', true).classed('crisp', true);
    }

    // X axis marker
    if (xMode.indexOf('marker') !== -1) {
      container.insert('circle', ':first-child').attr({
        cx: vLinePointX,
        cy: yEdge - (xa.side !== 'top' ? xThickness : -xThickness),
        r: xThickness,
        fill: xColor
      }).classed('spikeline', true);
    }
  }
}
function hoverChanged(gd, evt, oldhoverdata) {
  // don't emit any events if nothing changed
  if (!oldhoverdata || oldhoverdata.length !== gd._hoverdata.length) return true;
  for (var i = oldhoverdata.length - 1; i >= 0; i--) {
    var oldPt = oldhoverdata[i];
    var newPt = gd._hoverdata[i];
    if (oldPt.curveNumber !== newPt.curveNumber || String(oldPt.pointNumber) !== String(newPt.pointNumber) || String(oldPt.pointNumbers) !== String(newPt.pointNumbers)) {
      return true;
    }
  }
  return false;
}
function spikesChanged(gd, oldspikepoints) {
  // don't relayout the plot because of new spikelines if spikelines points didn't change
  if (!oldspikepoints) return true;
  if (oldspikepoints.vLinePoint !== gd._spikepoints.vLinePoint || oldspikepoints.hLinePoint !== gd._spikepoints.hLinePoint) return true;
  return false;
}
function plainText(s, len) {
  return svgTextUtils.plainText(s || '', {
    len: len,
    allowedTags: ['br', 'sub', 'sup', 'b', 'i', 'em', 's', 'u']
  });
}
function orderRangePoints(hoverData, hovermode) {
  var axLetter = hovermode.charAt(0);
  var first = [];
  var second = [];
  var last = [];
  for (var i = 0; i < hoverData.length; i++) {
    var d = hoverData[i];
    if (Registry.traceIs(d.trace, 'bar-like') || Registry.traceIs(d.trace, 'box-violin')) {
      last.push(d);
    } else if (d.trace[axLetter + 'period']) {
      second.push(d);
    } else {
      first.push(d);
    }
  }
  return first.concat(second).concat(last);
}
function getCoord(axLetter, winningPoint, fullLayout) {
  var ax = winningPoint[axLetter + 'a'];
  var val = winningPoint[axLetter + 'Val'];
  var cd0 = winningPoint.cd[0];
  if (ax.type === 'category' || ax.type === 'multicategory') val = ax._categoriesMap[val];else if (ax.type === 'date') {
    var periodalignment = winningPoint.trace[axLetter + 'periodalignment'];
    if (periodalignment) {
      var d = winningPoint.cd[winningPoint.index];
      var start = d[axLetter + 'Start'];
      if (start === undefined) start = d[axLetter];
      var end = d[axLetter + 'End'];
      if (end === undefined) end = d[axLetter];
      var diff = end - start;
      if (periodalignment === 'end') {
        val += diff;
      } else if (periodalignment === 'middle') {
        val += diff / 2;
      }
    }
    val = ax.d2c(val);
  }
  if (cd0 && cd0.t && cd0.t.posLetter === ax._id) {
    if (fullLayout.boxmode === 'group' || fullLayout.violinmode === 'group') {
      val += cd0.t.dPos;
    }
  }
  return val;
}

// Top/left hover offsets relative to graph div. As long as hover content is
// a sibling of the graph div, it will be positioned correctly relative to
// the offset parent, whatever that may be.
function getTopOffset(gd) {
  return gd.offsetTop + gd.clientTop;
}
function getLeftOffset(gd) {
  return gd.offsetLeft + gd.clientLeft;
}
function getBoundingClientRect(gd, node) {
  var fullLayout = gd._fullLayout;
  var rect = node.getBoundingClientRect();
  var x0 = rect.left;
  var y0 = rect.top;
  var x1 = x0 + rect.width;
  var y1 = y0 + rect.height;
  var A = Lib.apply3DTransform(fullLayout._invTransform)(x0, y0);
  var B = Lib.apply3DTransform(fullLayout._invTransform)(x1, y1);
  var Ax = A[0];
  var Ay = A[1];
  var Bx = B[0];
  var By = B[1];
  return {
    x: Ax,
    y: Ay,
    width: Bx - Ax,
    height: By - Ay,
    top: Math.min(Ay, By),
    left: Math.min(Ax, Bx),
    right: Math.max(Ax, Bx),
    bottom: Math.max(Ay, By)
  };
}

/***/ }),

/***/ 26430:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var Color = __webpack_require__(78766);
var isUnifiedHover = (__webpack_require__(36040).isUnifiedHover);
module.exports = function handleHoverLabelDefaults(contIn, contOut, coerce, opts) {
  opts = opts || {};
  var hasLegend = contOut.legend;
  function inheritFontAttr(attr) {
    if (!opts.font[attr]) {
      opts.font[attr] = hasLegend ? contOut.legend.font[attr] : contOut.font[attr];
    }
  }

  // In unified hover, inherit from layout.legend if available or layout
  if (contOut && isUnifiedHover(contOut.hovermode)) {
    if (!opts.font) opts.font = {};
    inheritFontAttr('size');
    inheritFontAttr('family');
    inheritFontAttr('color');
    inheritFontAttr('weight');
    inheritFontAttr('style');
    inheritFontAttr('variant');
    if (hasLegend) {
      if (!opts.bgcolor) opts.bgcolor = Color.combine(contOut.legend.bgcolor, contOut.paper_bgcolor);
      if (!opts.bordercolor) opts.bordercolor = contOut.legend.bordercolor;
    } else {
      if (!opts.bgcolor) opts.bgcolor = contOut.paper_bgcolor;
    }
  }
  coerce('hoverlabel.bgcolor', opts.bgcolor);
  coerce('hoverlabel.bordercolor', opts.bordercolor);
  coerce('hoverlabel.namelength', opts.namelength);
  Lib.coerceFont(coerce, 'hoverlabel.font', opts.font);
  coerce('hoverlabel.align', opts.align);
};

/***/ }),

/***/ 45265:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var layoutAttributes = __webpack_require__(6811);
module.exports = function handleHoverModeDefaults(layoutIn, layoutOut) {
  function coerce(attr, dflt) {
    // don't coerce if it is already coerced in other place e.g. in cartesian defaults
    if (layoutOut[attr] !== undefined) return layoutOut[attr];
    return Lib.coerce(layoutIn, layoutOut, layoutAttributes, attr, dflt);
  }
  coerce('clickmode');
  coerce('hoversubplots');
  return coerce('hovermode');
};

/***/ }),

/***/ 32141:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var Lib = __webpack_require__(34809);
var dragElement = __webpack_require__(14751);
var helpers = __webpack_require__(36040);
var layoutAttributes = __webpack_require__(6811);
var hoverModule = __webpack_require__(38103);
module.exports = {
  moduleType: 'component',
  name: 'fx',
  constants: __webpack_require__(85988),
  schema: {
    layout: layoutAttributes
  },
  attributes: __webpack_require__(70192),
  layoutAttributes: layoutAttributes,
  supplyLayoutGlobalDefaults: __webpack_require__(5358),
  supplyDefaults: __webpack_require__(3239),
  supplyLayoutDefaults: __webpack_require__(8412),
  calc: __webpack_require__(83552),
  getDistanceFunction: helpers.getDistanceFunction,
  getClosest: helpers.getClosest,
  inbox: helpers.inbox,
  quadrature: helpers.quadrature,
  appendArrayPointValue: helpers.appendArrayPointValue,
  castHoverOption: castHoverOption,
  castHoverinfo: castHoverinfo,
  hover: hoverModule.hover,
  unhover: dragElement.unhover,
  loneHover: hoverModule.loneHover,
  loneUnhover: loneUnhover,
  click: __webpack_require__(94225)
};
function loneUnhover(containerOrSelection) {
  // duck type whether the arg is a d3 selection because ie9 doesn't
  // handle instanceof like modern browsers do.
  var selection = Lib.isD3Selection(containerOrSelection) ? containerOrSelection : d3.select(containerOrSelection);
  selection.selectAll('g.hovertext').remove();
  selection.selectAll('.spikeline').remove();
}

// helpers for traces that use Fx.loneHover

function castHoverOption(trace, ptNumber, attr) {
  return Lib.castOption(trace, ptNumber, 'hoverlabel.' + attr);
}
function castHoverinfo(trace, fullLayout, ptNumber) {
  function _coerce(val) {
    return Lib.coerceHoverinfo({
      hoverinfo: val
    }, {
      _module: trace._module
    }, fullLayout);
  }
  return Lib.castOption(trace, ptNumber, 'hoverinfo', _coerce);
}

/***/ }),

/***/ 6811:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var constants = __webpack_require__(85988);
var fontAttrs = __webpack_require__(80337);
var font = fontAttrs({
  editType: 'none'
});
font.family.dflt = constants.HOVERFONT;
font.size.dflt = constants.HOVERFONTSIZE;
module.exports = {
  clickmode: {
    valType: 'flaglist',
    flags: ['event', 'select'],
    dflt: 'event',
    editType: 'plot',
    extras: ['none']
  },
  dragmode: {
    valType: 'enumerated',
    values: ['zoom', 'pan', 'select', 'lasso', 'drawclosedpath', 'drawopenpath', 'drawline', 'drawrect', 'drawcircle', 'orbit', 'turntable', false],
    dflt: 'zoom',
    editType: 'modebar'
  },
  hovermode: {
    valType: 'enumerated',
    values: ['x', 'y', 'closest', false, 'x unified', 'y unified'],
    dflt: 'closest',
    editType: 'modebar'
  },
  hoversubplots: {
    valType: 'enumerated',
    values: ['single', 'overlaying', 'axis'],
    dflt: 'overlaying',
    editType: 'none'
  },
  hoverdistance: {
    valType: 'integer',
    min: -1,
    dflt: 20,
    editType: 'none'
  },
  spikedistance: {
    valType: 'integer',
    min: -1,
    dflt: -1,
    editType: 'none'
  },
  hoverlabel: {
    bgcolor: {
      valType: 'color',
      editType: 'none'
    },
    bordercolor: {
      valType: 'color',
      editType: 'none'
    },
    font: font,
    grouptitlefont: fontAttrs({
      editType: 'none'
    }),
    align: {
      valType: 'enumerated',
      values: ['left', 'right', 'auto'],
      dflt: 'auto',
      editType: 'none'
    },
    namelength: {
      valType: 'integer',
      min: -1,
      dflt: 15,
      editType: 'none'
    },
    editType: 'none'
  },
  selectdirection: {
    valType: 'enumerated',
    values: ['h', 'v', 'd', 'any'],
    dflt: 'any',
    editType: 'none'
  }
};

/***/ }),

/***/ 8412:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var layoutAttributes = __webpack_require__(6811);
var handleHoverModeDefaults = __webpack_require__(45265);
var handleHoverLabelDefaults = __webpack_require__(26430);
module.exports = function supplyLayoutDefaults(layoutIn, layoutOut) {
  function coerce(attr, dflt) {
    return Lib.coerce(layoutIn, layoutOut, layoutAttributes, attr, dflt);
  }
  var hoverMode = handleHoverModeDefaults(layoutIn, layoutOut);
  if (hoverMode) {
    coerce('hoverdistance');
    coerce('spikedistance');
  }
  var dragMode = coerce('dragmode');
  if (dragMode === 'select') coerce('selectdirection');

  // if only mapbox, map or geo subplots is present on graph,
  // reset 'zoom' dragmode to 'pan' until 'zoom' is implemented,
  // so that the correct modebar button is active
  var hasMapbox = layoutOut._has('mapbox');
  var hasMap = layoutOut._has('map');
  var hasGeo = layoutOut._has('geo');
  var len = layoutOut._basePlotModules.length;
  if (layoutOut.dragmode === 'zoom' && ((hasMapbox || hasMap || hasGeo) && len === 1 || (hasMapbox || hasMap) && hasGeo && len === 2)) {
    layoutOut.dragmode = 'pan';
  }
  handleHoverLabelDefaults(layoutIn, layoutOut, coerce);
  Lib.coerceFont(coerce, 'hoverlabel.grouptitlefont', layoutOut.hoverlabel.font);
};

/***/ }),

/***/ 5358:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var handleHoverLabelDefaults = __webpack_require__(26430);
var layoutAttributes = __webpack_require__(6811);
module.exports = function supplyLayoutGlobalDefaults(layoutIn, layoutOut) {
  function coerce(attr, dflt) {
    return Lib.coerce(layoutIn, layoutOut, layoutAttributes, attr, dflt);
  }
  handleHoverLabelDefaults(layoutIn, layoutOut, coerce);
};

/***/ }),

/***/ 83595:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var counterRegex = (__webpack_require__(90694).counter);
var domainAttrs = (__webpack_require__(13792)/* .attributes */ .u);
var cartesianIdRegex = (__webpack_require__(54826).idRegex);
var Template = __webpack_require__(78032);
var gridAttrs = {
  rows: {
    valType: 'integer',
    min: 1,
    editType: 'plot'
  },
  roworder: {
    valType: 'enumerated',
    values: ['top to bottom', 'bottom to top'],
    dflt: 'top to bottom',
    editType: 'plot'
  },
  columns: {
    valType: 'integer',
    min: 1,
    editType: 'plot'
  },
  subplots: {
    valType: 'info_array',
    freeLength: true,
    dimensions: 2,
    items: {
      valType: 'enumerated',
      values: [counterRegex('xy').toString(), ''],
      editType: 'plot'
    },
    editType: 'plot'
  },
  xaxes: {
    valType: 'info_array',
    freeLength: true,
    items: {
      valType: 'enumerated',
      values: [cartesianIdRegex.x.toString(), ''],
      editType: 'plot'
    },
    editType: 'plot'
  },
  yaxes: {
    valType: 'info_array',
    freeLength: true,
    items: {
      valType: 'enumerated',
      values: [cartesianIdRegex.y.toString(), ''],
      editType: 'plot'
    },
    editType: 'plot'
  },
  pattern: {
    valType: 'enumerated',
    values: ['independent', 'coupled'],
    dflt: 'coupled',
    editType: 'plot'
  },
  xgap: {
    valType: 'number',
    min: 0,
    max: 1,
    editType: 'plot'
  },
  ygap: {
    valType: 'number',
    min: 0,
    max: 1,
    editType: 'plot'
  },
  domain: domainAttrs({
    name: 'grid',
    editType: 'plot',
    noGridCell: true
  }, {}),
  xside: {
    valType: 'enumerated',
    values: ['bottom', 'bottom plot', 'top plot', 'top'],
    dflt: 'bottom plot',
    editType: 'plot'
  },
  yside: {
    valType: 'enumerated',
    values: ['left', 'left plot', 'right plot', 'right'],
    dflt: 'left plot',
    editType: 'plot'
  },
  editType: 'plot'
};
function getAxes(layout, grid, axLetter) {
  var gridVal = grid[axLetter + 'axes'];
  var splomVal = Object.keys((layout._splomAxes || {})[axLetter] || {});
  if (Array.isArray(gridVal)) return gridVal;
  if (splomVal.length) return splomVal;
}

// the shape of the grid - this needs to be done BEFORE supplyDataDefaults
// so that non-subplot traces can place themselves in the grid
function sizeDefaults(layoutIn, layoutOut) {
  var gridIn = layoutIn.grid || {};
  var xAxes = getAxes(layoutOut, gridIn, 'x');
  var yAxes = getAxes(layoutOut, gridIn, 'y');
  if (!layoutIn.grid && !xAxes && !yAxes) return;
  var hasSubplotGrid = Array.isArray(gridIn.subplots) && Array.isArray(gridIn.subplots[0]);
  var hasXaxes = Array.isArray(xAxes);
  var hasYaxes = Array.isArray(yAxes);
  var isSplomGenerated = hasXaxes && xAxes !== gridIn.xaxes && hasYaxes && yAxes !== gridIn.yaxes;
  var dfltRows, dfltColumns;
  if (hasSubplotGrid) {
    dfltRows = gridIn.subplots.length;
    dfltColumns = gridIn.subplots[0].length;
  } else {
    if (hasYaxes) dfltRows = yAxes.length;
    if (hasXaxes) dfltColumns = xAxes.length;
  }
  var gridOut = Template.newContainer(layoutOut, 'grid');
  function coerce(attr, dflt) {
    return Lib.coerce(gridIn, gridOut, gridAttrs, attr, dflt);
  }
  var rows = coerce('rows', dfltRows);
  var columns = coerce('columns', dfltColumns);
  if (!(rows * columns > 1)) {
    delete layoutOut.grid;
    return;
  }
  if (!hasSubplotGrid && !hasXaxes && !hasYaxes) {
    var useDefaultSubplots = coerce('pattern') === 'independent';
    if (useDefaultSubplots) hasSubplotGrid = true;
  }
  gridOut._hasSubplotGrid = hasSubplotGrid;
  var rowOrder = coerce('roworder');
  var reversed = rowOrder === 'top to bottom';
  var dfltGapX = hasSubplotGrid ? 0.2 : 0.1;
  var dfltGapY = hasSubplotGrid ? 0.3 : 0.1;
  var dfltSideX, dfltSideY;
  if (isSplomGenerated && layoutOut._splomGridDflt) {
    dfltSideX = layoutOut._splomGridDflt.xside;
    dfltSideY = layoutOut._splomGridDflt.yside;
  }
  gridOut._domains = {
    x: fillGridPositions('x', coerce, dfltGapX, dfltSideX, columns),
    y: fillGridPositions('y', coerce, dfltGapY, dfltSideY, rows, reversed)
  };
}

// coerce x or y sizing attributes and return an array of domains for this direction
function fillGridPositions(axLetter, coerce, dfltGap, dfltSide, len, reversed) {
  var dirGap = coerce(axLetter + 'gap', dfltGap);
  var domain = coerce('domain.' + axLetter);
  coerce(axLetter + 'side', dfltSide);
  var out = new Array(len);
  var start = domain[0];
  var step = (domain[1] - start) / (len - dirGap);
  var cellDomain = step * (1 - dirGap);
  for (var i = 0; i < len; i++) {
    var cellStart = start + step * i;
    out[reversed ? len - 1 - i : i] = [cellStart, cellStart + cellDomain];
  }
  return out;
}

// the (cartesian) contents of the grid - this needs to happen AFTER supplyDataDefaults
// so that we know what cartesian subplots are available
function contentDefaults(layoutIn, layoutOut) {
  var gridOut = layoutOut.grid;
  // make sure we got to the end of handleGridSizing
  if (!gridOut || !gridOut._domains) return;
  var gridIn = layoutIn.grid || {};
  var subplots = layoutOut._subplots;
  var hasSubplotGrid = gridOut._hasSubplotGrid;
  var rows = gridOut.rows;
  var columns = gridOut.columns;
  var useDefaultSubplots = gridOut.pattern === 'independent';
  var i, j, xId, yId, subplotId, subplotsOut, yPos;
  var axisMap = gridOut._axisMap = {};
  if (hasSubplotGrid) {
    var subplotsIn = gridIn.subplots || [];
    subplotsOut = gridOut.subplots = new Array(rows);
    var index = 1;
    for (i = 0; i < rows; i++) {
      var rowOut = subplotsOut[i] = new Array(columns);
      var rowIn = subplotsIn[i] || [];
      for (j = 0; j < columns; j++) {
        if (useDefaultSubplots) {
          subplotId = index === 1 ? 'xy' : 'x' + index + 'y' + index;
          index++;
        } else subplotId = rowIn[j];
        rowOut[j] = '';
        if (subplots.cartesian.indexOf(subplotId) !== -1) {
          yPos = subplotId.indexOf('y');
          xId = subplotId.slice(0, yPos);
          yId = subplotId.slice(yPos);
          if (axisMap[xId] !== undefined && axisMap[xId] !== j || axisMap[yId] !== undefined && axisMap[yId] !== i) {
            continue;
          }
          rowOut[j] = subplotId;
          axisMap[xId] = j;
          axisMap[yId] = i;
        }
      }
    }
  } else {
    var xAxes = getAxes(layoutOut, gridIn, 'x');
    var yAxes = getAxes(layoutOut, gridIn, 'y');
    gridOut.xaxes = fillGridAxes(xAxes, subplots.xaxis, columns, axisMap, 'x');
    gridOut.yaxes = fillGridAxes(yAxes, subplots.yaxis, rows, axisMap, 'y');
  }
  var anchors = gridOut._anchors = {};
  var reversed = gridOut.roworder === 'top to bottom';
  for (var axisId in axisMap) {
    var axLetter = axisId.charAt(0);
    var side = gridOut[axLetter + 'side'];
    var i0, inc, iFinal;
    if (side.length < 8) {
      // grid edge -  ie not "* plot" - make these as free axes
      // since we're not guaranteed to have a subplot there at all
      anchors[axisId] = 'free';
    } else if (axLetter === 'x') {
      if (side.charAt(0) === 't' === reversed) {
        i0 = 0;
        inc = 1;
        iFinal = rows;
      } else {
        i0 = rows - 1;
        inc = -1;
        iFinal = -1;
      }
      if (hasSubplotGrid) {
        var column = axisMap[axisId];
        for (i = i0; i !== iFinal; i += inc) {
          subplotId = subplotsOut[i][column];
          if (!subplotId) continue;
          yPos = subplotId.indexOf('y');
          if (subplotId.slice(0, yPos) === axisId) {
            anchors[axisId] = subplotId.slice(yPos);
            break;
          }
        }
      } else {
        for (i = i0; i !== iFinal; i += inc) {
          yId = gridOut.yaxes[i];
          if (subplots.cartesian.indexOf(axisId + yId) !== -1) {
            anchors[axisId] = yId;
            break;
          }
        }
      }
    } else {
      if (side.charAt(0) === 'l') {
        i0 = 0;
        inc = 1;
        iFinal = columns;
      } else {
        i0 = columns - 1;
        inc = -1;
        iFinal = -1;
      }
      if (hasSubplotGrid) {
        var row = axisMap[axisId];
        for (i = i0; i !== iFinal; i += inc) {
          subplotId = subplotsOut[row][i];
          if (!subplotId) continue;
          yPos = subplotId.indexOf('y');
          if (subplotId.slice(yPos) === axisId) {
            anchors[axisId] = subplotId.slice(0, yPos);
            break;
          }
        }
      } else {
        for (i = i0; i !== iFinal; i += inc) {
          xId = gridOut.xaxes[i];
          if (subplots.cartesian.indexOf(xId + axisId) !== -1) {
            anchors[axisId] = xId;
            break;
          }
        }
      }
    }
  }
}
function fillGridAxes(axesIn, axesAllowed, len, axisMap, axLetter) {
  var out = new Array(len);
  var i;
  function fillOneAxis(i, axisId) {
    if (axesAllowed.indexOf(axisId) !== -1 && axisMap[axisId] === undefined) {
      out[i] = axisId;
      axisMap[axisId] = i;
    } else out[i] = '';
  }
  if (Array.isArray(axesIn)) {
    for (i = 0; i < len; i++) {
      fillOneAxis(i, axesIn[i]);
    }
  } else {
    // default axis list is the first `len` axis ids
    fillOneAxis(0, axLetter);
    for (i = 1; i < len; i++) {
      fillOneAxis(i, axLetter + (i + 1));
    }
  }
  return out;
}
module.exports = {
  moduleType: 'component',
  name: 'grid',
  schema: {
    layout: {
      grid: gridAttrs
    }
  },
  layoutAttributes: gridAttrs,
  sizeDefaults: sizeDefaults,
  contentDefaults: contentDefaults
};

/***/ }),

/***/ 37260:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var cartesianConstants = __webpack_require__(54826);
var templatedArray = (__webpack_require__(78032).templatedArray);
var axisPlaceableObjs = __webpack_require__(35081);
module.exports = templatedArray('image', {
  visible: {
    valType: 'boolean',
    dflt: true,
    editType: 'arraydraw'
  },
  source: {
    valType: 'string',
    editType: 'arraydraw'
  },
  layer: {
    valType: 'enumerated',
    values: ['below', 'above'],
    dflt: 'above',
    editType: 'arraydraw'
  },
  sizex: {
    valType: 'number',
    dflt: 0,
    editType: 'arraydraw'
  },
  sizey: {
    valType: 'number',
    dflt: 0,
    editType: 'arraydraw'
  },
  sizing: {
    valType: 'enumerated',
    values: ['fill', 'contain', 'stretch'],
    dflt: 'contain',
    editType: 'arraydraw'
  },
  opacity: {
    valType: 'number',
    min: 0,
    max: 1,
    dflt: 1,
    editType: 'arraydraw'
  },
  x: {
    valType: 'any',
    dflt: 0,
    editType: 'arraydraw'
  },
  y: {
    valType: 'any',
    dflt: 0,
    editType: 'arraydraw'
  },
  xanchor: {
    valType: 'enumerated',
    values: ['left', 'center', 'right'],
    dflt: 'left',
    editType: 'arraydraw'
  },
  yanchor: {
    valType: 'enumerated',
    values: ['top', 'middle', 'bottom'],
    dflt: 'top',
    editType: 'arraydraw'
  },
  xref: {
    valType: 'enumerated',
    values: ['paper', cartesianConstants.idRegex.x.toString()],
    dflt: 'paper',
    editType: 'arraydraw'
  },
  yref: {
    valType: 'enumerated',
    values: ['paper', cartesianConstants.idRegex.y.toString()],
    dflt: 'paper',
    editType: 'arraydraw'
  },
  editType: 'arraydraw'
});

/***/ }),

/***/ 89443:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isNumeric = __webpack_require__(10721);
var toLogRange = __webpack_require__(8083);

/*
 * convertCoords: when converting an axis between log and linear
 * you need to alter any images on that axis to keep them
 * pointing at the same data point.
 * In v3.0 this will become obsolete (or perhaps size will still need conversion?)
 * we convert size by declaring that the maximum extent *in data units* should be
 * the same, assuming the image is anchored by its center (could remove that restriction
 * if we think it's important) even though the actual left and right values will not be
 * quite the same since the scale becomes nonlinear (and central anchor means the pixel
 * center of the image, not the data units center)
 *
 * gd: the plot div
 * ax: the axis being changed
 * newType: the type it's getting
 * doExtra: function(attr, val) from inside relayout that sets the attribute.
 *     Use this to make the changes as it's aware if any other changes in the
 *     same relayout call should override this conversion.
 */
module.exports = function convertCoords(gd, ax, newType, doExtra) {
  ax = ax || {};
  var toLog = newType === 'log' && ax.type === 'linear';
  var fromLog = newType === 'linear' && ax.type === 'log';
  if (!(toLog || fromLog)) return;
  var images = gd._fullLayout.images;
  var axLetter = ax._id.charAt(0);
  var image;
  var attrPrefix;
  for (var i = 0; i < images.length; i++) {
    image = images[i];
    attrPrefix = 'images[' + i + '].';
    if (image[axLetter + 'ref'] === ax._id) {
      var currentPos = image[axLetter];
      var currentSize = image['size' + axLetter];
      var newPos = null;
      var newSize = null;
      if (toLog) {
        newPos = toLogRange(currentPos, ax.range);

        // this is the inverse of the conversion we do in fromLog below
        // so that the conversion is reversible (notice the fromLog conversion
        // is like sinh, and this one looks like arcsinh)
        var dx = currentSize / Math.pow(10, newPos) / 2;
        newSize = 2 * Math.log(dx + Math.sqrt(1 + dx * dx)) / Math.LN10;
      } else {
        newPos = Math.pow(10, currentPos);
        newSize = newPos * (Math.pow(10, currentSize / 2) - Math.pow(10, -currentSize / 2));
      }

      // if conversion failed, delete the value so it can get a default later on
      if (!isNumeric(newPos)) {
        newPos = null;
        newSize = null;
      } else if (!isNumeric(newSize)) newSize = null;
      doExtra(attrPrefix + axLetter, newPos);
      doExtra(attrPrefix + 'size' + axLetter, newSize);
    }
  }
};

/***/ }),

/***/ 507:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var Axes = __webpack_require__(29714);
var handleArrayContainerDefaults = __webpack_require__(59008);
var attributes = __webpack_require__(37260);
var name = 'images';
module.exports = function supplyLayoutDefaults(layoutIn, layoutOut) {
  var opts = {
    name: name,
    handleItemDefaults: imageDefaults
  };
  handleArrayContainerDefaults(layoutIn, layoutOut, opts);
};
function imageDefaults(imageIn, imageOut, fullLayout) {
  function coerce(attr, dflt) {
    return Lib.coerce(imageIn, imageOut, attributes, attr, dflt);
  }
  var source = coerce('source');
  var visible = coerce('visible', !!source);
  if (!visible) return imageOut;
  coerce('layer');
  coerce('xanchor');
  coerce('yanchor');
  coerce('sizex');
  coerce('sizey');
  coerce('sizing');
  coerce('opacity');
  var gdMock = {
    _fullLayout: fullLayout
  };
  var axLetters = ['x', 'y'];
  for (var i = 0; i < 2; i++) {
    // 'paper' is the fallback axref
    var axLetter = axLetters[i];
    var axRef = Axes.coerceRef(imageIn, imageOut, gdMock, axLetter, 'paper', undefined);
    if (axRef !== 'paper') {
      var ax = Axes.getFromId(gdMock, axRef);
      ax._imgIndices.push(imageOut._index);
    }
    Axes.coercePosition(imageOut, gdMock, coerce, axRef, axLetter, 0);
  }
  return imageOut;
}

/***/ }),

/***/ 32211:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var Drawing = __webpack_require__(62203);
var Axes = __webpack_require__(29714);
var axisIds = __webpack_require__(5975);
var xmlnsNamespaces = __webpack_require__(62972);
module.exports = function draw(gd) {
  var fullLayout = gd._fullLayout;
  var imageDataAbove = [];
  var imageDataSubplot = {};
  var imageDataBelow = [];
  var subplot;
  var i;

  // Sort into top, subplot, and bottom layers
  for (i = 0; i < fullLayout.images.length; i++) {
    var img = fullLayout.images[i];
    if (img.visible) {
      if (img.layer === 'below' && img.xref !== 'paper' && img.yref !== 'paper') {
        subplot = axisIds.ref2id(img.xref) + axisIds.ref2id(img.yref);
        var plotinfo = fullLayout._plots[subplot];
        if (!plotinfo) {
          // Fall back to _imageLowerLayer in case the requested subplot doesn't exist.
          // This can happen if you reference the image to an x / y axis combination
          // that doesn't have any data on it (and layer is below)
          imageDataBelow.push(img);
          continue;
        }
        if (plotinfo.mainplot) {
          subplot = plotinfo.mainplot.id;
        }
        if (!imageDataSubplot[subplot]) {
          imageDataSubplot[subplot] = [];
        }
        imageDataSubplot[subplot].push(img);
      } else if (img.layer === 'above') {
        imageDataAbove.push(img);
      } else {
        imageDataBelow.push(img);
      }
    }
  }
  var anchors = {
    x: {
      left: {
        sizing: 'xMin',
        offset: 0
      },
      center: {
        sizing: 'xMid',
        offset: -1 / 2
      },
      right: {
        sizing: 'xMax',
        offset: -1
      }
    },
    y: {
      top: {
        sizing: 'YMin',
        offset: 0
      },
      middle: {
        sizing: 'YMid',
        offset: -1 / 2
      },
      bottom: {
        sizing: 'YMax',
        offset: -1
      }
    }
  };

  // Images must be converted to dataURL's for exporting.
  function setImage(d) {
    var thisImage = d3.select(this);
    if (this._imgSrc === d.source) {
      return;
    }
    thisImage.attr('xmlns', xmlnsNamespaces.svg);
    if (d.source && d.source.slice(0, 5) === 'data:') {
      thisImage.attr('xlink:href', d.source);
      this._imgSrc = d.source;
    } else {
      var imagePromise = new Promise(function (resolve) {
        var img = new Image();
        this.img = img;

        // If not set, a `tainted canvas` error is thrown
        img.setAttribute('crossOrigin', 'anonymous');
        img.onerror = errorHandler;
        img.onload = function () {
          var canvas = document.createElement('canvas');
          canvas.width = this.width;
          canvas.height = this.height;
          var ctx = canvas.getContext('2d', {
            willReadFrequently: true
          });
          ctx.drawImage(this, 0, 0);
          var dataURL = canvas.toDataURL('image/png');
          thisImage.attr('xlink:href', dataURL);

          // resolve promise in onload handler instead of on 'load' to support IE11
          // see https://github.com/plotly/plotly.js/issues/1685
          // for more details
          resolve();
        };
        thisImage.on('error', errorHandler);
        img.src = d.source;
        this._imgSrc = d.source;
        function errorHandler() {
          thisImage.remove();
          resolve();
        }
      }.bind(this));
      gd._promises.push(imagePromise);
    }
  }
  function applyAttributes(d) {
    var thisImage = d3.select(this);

    // Axes if specified
    var xa = Axes.getFromId(gd, d.xref);
    var ya = Axes.getFromId(gd, d.yref);
    var xIsDomain = Axes.getRefType(d.xref) === 'domain';
    var yIsDomain = Axes.getRefType(d.yref) === 'domain';
    var size = fullLayout._size;
    var width, height;
    if (xa !== undefined) {
      width = typeof d.xref === 'string' && xIsDomain ? xa._length * d.sizex : Math.abs(xa.l2p(d.sizex) - xa.l2p(0));
    } else {
      width = d.sizex * size.w;
    }
    if (ya !== undefined) {
      height = typeof d.yref === 'string' && yIsDomain ? ya._length * d.sizey : Math.abs(ya.l2p(d.sizey) - ya.l2p(0));
    } else {
      height = d.sizey * size.h;
    }

    // Offsets for anchor positioning
    var xOffset = width * anchors.x[d.xanchor].offset;
    var yOffset = height * anchors.y[d.yanchor].offset;
    var sizing = anchors.x[d.xanchor].sizing + anchors.y[d.yanchor].sizing;

    // Final positions
    var xPos, yPos;
    if (xa !== undefined) {
      xPos = typeof d.xref === 'string' && xIsDomain ? xa._length * d.x + xa._offset : xa.r2p(d.x) + xa._offset;
    } else {
      xPos = d.x * size.w + size.l;
    }
    xPos += xOffset;
    if (ya !== undefined) {
      yPos = typeof d.yref === 'string' && yIsDomain ?
      // consistent with "paper" yref value, where positive values
      // move up the page
      ya._length * (1 - d.y) + ya._offset : ya.r2p(d.y) + ya._offset;
    } else {
      yPos = size.h - d.y * size.h + size.t;
    }
    yPos += yOffset;

    // Construct the proper aspectRatio attribute
    switch (d.sizing) {
      case 'fill':
        sizing += ' slice';
        break;
      case 'stretch':
        sizing = 'none';
        break;
    }
    thisImage.attr({
      x: xPos,
      y: yPos,
      width: width,
      height: height,
      preserveAspectRatio: sizing,
      opacity: d.opacity
    });

    // Set proper clipping on images
    var xId = xa && Axes.getRefType(d.xref) !== 'domain' ? xa._id : '';
    var yId = ya && Axes.getRefType(d.yref) !== 'domain' ? ya._id : '';
    var clipAxes = xId + yId;
    Drawing.setClipUrl(thisImage, clipAxes ? 'clip' + fullLayout._uid + clipAxes : null, gd);
  }
  var imagesBelow = fullLayout._imageLowerLayer.selectAll('image').data(imageDataBelow);
  var imagesAbove = fullLayout._imageUpperLayer.selectAll('image').data(imageDataAbove);
  imagesBelow.enter().append('image');
  imagesAbove.enter().append('image');
  imagesBelow.exit().remove();
  imagesAbove.exit().remove();
  imagesBelow.each(function (d) {
    setImage.bind(this)(d);
    applyAttributes.bind(this)(d);
  });
  imagesAbove.each(function (d) {
    setImage.bind(this)(d);
    applyAttributes.bind(this)(d);
  });
  var allSubplots = Object.keys(fullLayout._plots);
  for (i = 0; i < allSubplots.length; i++) {
    subplot = allSubplots[i];
    var subplotObj = fullLayout._plots[subplot];

    // filter out overlaid plots (which have their images on the main plot)
    // and gl2d plots (which don't support below images, at least not yet)
    if (!subplotObj.imagelayer) continue;
    var imagesOnSubplot = subplotObj.imagelayer.selectAll('image')
    // even if there are no images on this subplot, we need to run
    // enter and exit in case there were previously
    .data(imageDataSubplot[subplot] || []);
    imagesOnSubplot.enter().append('image');
    imagesOnSubplot.exit().remove();
    imagesOnSubplot.each(function (d) {
      setImage.bind(this)(d);
      applyAttributes.bind(this)(d);
    });
  }
};

/***/ }),

/***/ 15553:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = {
  moduleType: 'component',
  name: 'images',
  layoutAttributes: __webpack_require__(37260),
  supplyLayoutDefaults: __webpack_require__(507),
  includeBasePlot: __webpack_require__(20706)('images'),
  draw: __webpack_require__(32211),
  convertCoords: __webpack_require__(89443)
};

/***/ }),

/***/ 86405:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var fontAttrs = __webpack_require__(80337);
var colorAttrs = __webpack_require__(10229);
module.exports = {
  // not really a 'subplot' attribute container,
  // but this is the flag we use to denote attributes that
  // support yaxis, yaxis2, yaxis3, ... counters
  _isSubplotObj: true,
  visible: {
    valType: 'boolean',
    dflt: true,
    editType: 'legend'
  },
  bgcolor: {
    valType: 'color',
    editType: 'legend'
  },
  bordercolor: {
    valType: 'color',
    dflt: colorAttrs.defaultLine,
    editType: 'legend'
  },
  borderwidth: {
    valType: 'number',
    min: 0,
    dflt: 0,
    editType: 'legend'
  },
  font: fontAttrs({
    editType: 'legend'
  }),
  grouptitlefont: fontAttrs({
    editType: 'legend'
  }),
  orientation: {
    valType: 'enumerated',
    values: ['v', 'h'],
    dflt: 'v',
    editType: 'legend'
  },
  traceorder: {
    valType: 'flaglist',
    flags: ['reversed', 'grouped'],
    extras: ['normal'],
    editType: 'legend'
  },
  tracegroupgap: {
    valType: 'number',
    min: 0,
    dflt: 10,
    editType: 'legend'
  },
  entrywidth: {
    valType: 'number',
    min: 0,
    editType: 'legend'
  },
  entrywidthmode: {
    valType: 'enumerated',
    values: ['fraction', 'pixels'],
    dflt: 'pixels',
    editType: 'legend'
  },
  indentation: {
    valType: 'number',
    min: -15,
    dflt: 0,
    editType: 'legend'
  },
  itemsizing: {
    valType: 'enumerated',
    values: ['trace', 'constant'],
    dflt: 'trace',
    editType: 'legend'
  },
  itemwidth: {
    valType: 'number',
    min: 30,
    dflt: 30,
    editType: 'legend'
  },
  itemclick: {
    valType: 'enumerated',
    values: ['toggle', 'toggleothers', false],
    dflt: 'toggle',
    editType: 'legend'
  },
  itemdoubleclick: {
    valType: 'enumerated',
    values: ['toggle', 'toggleothers', false],
    dflt: 'toggleothers',
    editType: 'legend'
  },
  groupclick: {
    valType: 'enumerated',
    values: ['toggleitem', 'togglegroup'],
    dflt: 'togglegroup',
    editType: 'legend'
  },
  x: {
    valType: 'number',
    editType: 'legend'
  },
  xref: {
    valType: 'enumerated',
    dflt: 'paper',
    values: ['container', 'paper'],
    editType: 'layoutstyle'
  },
  xanchor: {
    valType: 'enumerated',
    values: ['auto', 'left', 'center', 'right'],
    dflt: 'left',
    editType: 'legend'
  },
  y: {
    valType: 'number',
    editType: 'legend'
  },
  yref: {
    valType: 'enumerated',
    dflt: 'paper',
    values: ['container', 'paper'],
    editType: 'layoutstyle'
  },
  yanchor: {
    valType: 'enumerated',
    values: ['auto', 'top', 'middle', 'bottom'],
    editType: 'legend'
  },
  uirevision: {
    valType: 'any',
    editType: 'none'
  },
  valign: {
    valType: 'enumerated',
    values: ['top', 'middle', 'bottom'],
    dflt: 'middle',
    editType: 'legend'
  },
  title: {
    text: {
      valType: 'string',
      dflt: '',
      editType: 'legend'
    },
    font: fontAttrs({
      editType: 'legend'
    }),
    side: {
      valType: 'enumerated',
      values: ['top', 'left', 'top left', 'top center', 'top right'],
      editType: 'legend'
    },
    editType: 'legend'
  },
  editType: 'legend'
};

/***/ }),

/***/ 72783:
/***/ (function(module) {

"use strict";


module.exports = {
  scrollBarWidth: 6,
  scrollBarMinHeight: 20,
  scrollBarColor: '#808BA4',
  scrollBarMargin: 4,
  scrollBarEnterAttrs: {
    rx: 20,
    ry: 3,
    width: 0,
    height: 0
  },
  // number of px between legend title and (left) side of legend (always in x direction and from inner border)
  titlePad: 2,
  // number of px between each legend item (x and/or y direction)
  itemGap: 5
};

/***/ }),

/***/ 73970:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Registry = __webpack_require__(33626);
var Lib = __webpack_require__(34809);
var Template = __webpack_require__(78032);
var plotsAttrs = __webpack_require__(9829);
var attributes = __webpack_require__(86405);
var basePlotLayoutAttributes = __webpack_require__(6704);
var helpers = __webpack_require__(57599);
function groupDefaults(legendId, layoutIn, layoutOut, fullData) {
  var containerIn = layoutIn[legendId] || {};
  var containerOut = Template.newContainer(layoutOut, legendId);
  function coerce(attr, dflt) {
    return Lib.coerce(containerIn, containerOut, attributes, attr, dflt);
  }

  // N.B. unified hover needs to inherit from font, bgcolor & bordercolor even when legend.visible is false
  var itemFont = Lib.coerceFont(coerce, 'font', layoutOut.font);
  coerce('bgcolor', layoutOut.paper_bgcolor);
  coerce('bordercolor');
  var visible = coerce('visible');
  if (!visible) return;
  var trace;
  var traceCoerce = function (attr, dflt) {
    var traceIn = trace._input;
    var traceOut = trace;
    return Lib.coerce(traceIn, traceOut, plotsAttrs, attr, dflt);
  };
  var globalFont = layoutOut.font || {};
  var grouptitlefont = Lib.coerceFont(coerce, 'grouptitlefont', globalFont, {
    overrideDflt: {
      size: Math.round(globalFont.size * 1.1)
    }
  });
  var legendTraceCount = 0;
  var legendReallyHasATrace = false;
  var defaultOrder = 'normal';
  var shapesWithLegend = (layoutOut.shapes || []).filter(function (d) {
    return d.showlegend;
  });
  var allLegendItems = fullData.concat(shapesWithLegend).filter(function (d) {
    return legendId === (d.legend || 'legend');
  });
  for (var i = 0; i < allLegendItems.length; i++) {
    trace = allLegendItems[i];
    if (!trace.visible) continue;
    var isShape = trace._isShape;

    // Note that we explicitly count any trace that is either shown or
    // *would* be shown by default, toward the two traces you need to
    // ensure the legend is shown by default, because this can still help
    // disambiguate.
    if (trace.showlegend || trace._dfltShowLegend && !(trace._module && trace._module.attributes && trace._module.attributes.showlegend && trace._module.attributes.showlegend.dflt === false)) {
      legendTraceCount++;
      if (trace.showlegend) {
        legendReallyHasATrace = true;
        // Always show the legend by default if there's a pie,
        // or if there's only one trace but it's explicitly shown
        if (!isShape && Registry.traceIs(trace, 'pie-like') || trace._input.showlegend === true) {
          legendTraceCount++;
        }
      }
      Lib.coerceFont(traceCoerce, 'legendgrouptitle.font', grouptitlefont);
    }
    if (!isShape && Registry.traceIs(trace, 'bar') && layoutOut.barmode === 'stack' || ['tonextx', 'tonexty'].indexOf(trace.fill) !== -1) {
      defaultOrder = helpers.isGrouped({
        traceorder: defaultOrder
      }) ? 'grouped+reversed' : 'reversed';
    }
    if (trace.legendgroup !== undefined && trace.legendgroup !== '') {
      defaultOrder = helpers.isReversed({
        traceorder: defaultOrder
      }) ? 'reversed+grouped' : 'grouped';
    }
  }
  var showLegend = Lib.coerce(layoutIn, layoutOut, basePlotLayoutAttributes, 'showlegend', legendReallyHasATrace && legendTraceCount > (legendId === 'legend' ? 1 : 0));

  // delete legend
  if (showLegend === false) layoutOut[legendId] = undefined;
  if (showLegend === false && !containerIn.uirevision) return;
  coerce('uirevision', layoutOut.uirevision);
  if (showLegend === false) return;
  coerce('borderwidth');
  var orientation = coerce('orientation');
  var yref = coerce('yref');
  var xref = coerce('xref');
  var isHorizontal = orientation === 'h';
  var isPaperY = yref === 'paper';
  var isPaperX = xref === 'paper';
  var defaultX, defaultY, defaultYAnchor;
  var defaultXAnchor = 'left';
  if (isHorizontal) {
    defaultX = 0;
    if (Registry.getComponentMethod('rangeslider', 'isVisible')(layoutIn.xaxis)) {
      if (isPaperY) {
        defaultY = 1.1;
        defaultYAnchor = 'bottom';
      } else {
        defaultY = 1;
        defaultYAnchor = 'top';
      }
    } else {
      // maybe use y=1.1 / yanchor=bottom as above
      //   to avoid https://github.com/plotly/plotly.js/issues/1199
      //   in v3
      if (isPaperY) {
        defaultY = -0.1;
        defaultYAnchor = 'top';
      } else {
        defaultY = 0;
        defaultYAnchor = 'bottom';
      }
    }
  } else {
    defaultY = 1;
    defaultYAnchor = 'auto';
    if (isPaperX) {
      defaultX = 1.02;
    } else {
      defaultX = 1;
      defaultXAnchor = 'right';
    }
  }
  Lib.coerce(containerIn, containerOut, {
    x: {
      valType: 'number',
      editType: 'legend',
      min: isPaperX ? -2 : 0,
      max: isPaperX ? 3 : 1,
      dflt: defaultX
    }
  }, 'x');
  Lib.coerce(containerIn, containerOut, {
    y: {
      valType: 'number',
      editType: 'legend',
      min: isPaperY ? -2 : 0,
      max: isPaperY ? 3 : 1,
      dflt: defaultY
    }
  }, 'y');
  coerce('traceorder', defaultOrder);
  if (helpers.isGrouped(layoutOut[legendId])) coerce('tracegroupgap');
  coerce('entrywidth');
  coerce('entrywidthmode');
  coerce('indentation');
  coerce('itemsizing');
  coerce('itemwidth');
  coerce('itemclick');
  coerce('itemdoubleclick');
  coerce('groupclick');
  coerce('xanchor', defaultXAnchor);
  coerce('yanchor', defaultYAnchor);
  coerce('valign');
  Lib.noneOrAll(containerIn, containerOut, ['x', 'y']);
  var titleText = coerce('title.text');
  if (titleText) {
    coerce('title.side', isHorizontal ? 'left' : 'top');
    var dfltTitleFont = Lib.extendFlat({}, itemFont, {
      size: Lib.bigFont(itemFont.size)
    });
    Lib.coerceFont(coerce, 'title.font', dfltTitleFont);
  }
}
module.exports = function legendDefaults(layoutIn, layoutOut, fullData) {
  var i;
  var allLegendsData = fullData.slice();

  // shapes could also show up in legends
  var shapes = layoutOut.shapes;
  if (shapes) {
    for (i = 0; i < shapes.length; i++) {
      var shape = shapes[i];
      if (!shape.showlegend) continue;
      var mockTrace = {
        _input: shape._input,
        visible: shape.visible,
        showlegend: shape.showlegend,
        legend: shape.legend
      };
      allLegendsData.push(mockTrace);
    }
  }
  var legends = ['legend'];
  for (i = 0; i < allLegendsData.length; i++) {
    Lib.pushUnique(legends, allLegendsData[i].legend);
  }
  layoutOut._legends = [];
  for (i = 0; i < legends.length; i++) {
    var legendId = legends[i];
    groupDefaults(legendId, layoutIn, layoutOut, allLegendsData);
    if (layoutOut[legendId] && layoutOut[legendId].visible) {
      layoutOut[legendId]._id = legendId;
    }
    layoutOut._legends.push(legendId);
  }
};

/***/ }),

/***/ 6134:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var Lib = __webpack_require__(34809);
var Plots = __webpack_require__(44122);
var Registry = __webpack_require__(33626);
var Events = __webpack_require__(68596);
var dragElement = __webpack_require__(14751);
var Drawing = __webpack_require__(62203);
var Color = __webpack_require__(78766);
var svgTextUtils = __webpack_require__(30635);
var handleClick = __webpack_require__(22165);
var constants = __webpack_require__(72783);
var alignmentConstants = __webpack_require__(4530);
var LINE_SPACING = alignmentConstants.LINE_SPACING;
var FROM_TL = alignmentConstants.FROM_TL;
var FROM_BR = alignmentConstants.FROM_BR;
var getLegendData = __webpack_require__(851);
var style = __webpack_require__(14375);
var helpers = __webpack_require__(57599);
var MAIN_TITLE = 1;
var LEGEND_PATTERN = /^legend[0-9]*$/;
module.exports = function draw(gd, opts) {
  if (opts) {
    drawOne(gd, opts);
  } else {
    var fullLayout = gd._fullLayout;
    var newLegends = fullLayout._legends;

    // remove old legends that won't stay on the graph
    var oldLegends = fullLayout._infolayer.selectAll('[class^="legend"]');
    oldLegends.each(function () {
      var el = d3.select(this);
      var classes = el.attr('class');
      var cls = classes.split(' ')[0];
      if (cls.match(LEGEND_PATTERN) && newLegends.indexOf(cls) === -1) {
        el.remove();
      }
    });

    // draw/update new legends
    for (var i = 0; i < newLegends.length; i++) {
      var legendId = newLegends[i];
      var legendObj = gd._fullLayout[legendId];
      drawOne(gd, legendObj);
    }
  }
};

// After legend dimensions are calculated the title can be aligned horizontally left, center, right
function horizontalAlignTitle(titleEl, legendObj, bw) {
  if (legendObj.title.side !== 'top center' && legendObj.title.side !== 'top right') return;
  var font = legendObj.title.font;
  var lineHeight = font.size * LINE_SPACING;
  var titleOffset = 0;
  var textNode = titleEl.node();
  var width = Drawing.bBox(textNode).width; // width of the title text

  if (legendObj.title.side === 'top center') {
    titleOffset = 0.5 * (legendObj._width - 2 * bw - 2 * constants.titlePad - width);
  } else if (legendObj.title.side === 'top right') {
    titleOffset = legendObj._width - 2 * bw - 2 * constants.titlePad - width;
  }
  svgTextUtils.positionText(titleEl, bw + constants.titlePad + titleOffset, bw + lineHeight);
}
function drawOne(gd, opts) {
  var legendObj = opts || {};
  var fullLayout = gd._fullLayout;
  var legendId = getId(legendObj);
  var clipId, layer;
  var inHover = legendObj._inHover;
  if (inHover) {
    layer = legendObj.layer;
    clipId = 'hover';
  } else {
    layer = fullLayout._infolayer;
    clipId = legendId;
  }
  if (!layer) return;
  clipId += fullLayout._uid;
  if (!gd._legendMouseDownTime) gd._legendMouseDownTime = 0;
  var legendData;
  if (!inHover) {
    var calcdata = (gd.calcdata || []).slice();
    var shapes = fullLayout.shapes;
    for (var i = 0; i < shapes.length; i++) {
      var shape = shapes[i];
      if (!shape.showlegend) continue;
      var shapeLegend = {
        _isShape: true,
        _fullInput: shape,
        index: shape._index,
        name: shape.name || shape.label.text || 'shape ' + shape._index,
        legend: shape.legend,
        legendgroup: shape.legendgroup,
        legendgrouptitle: shape.legendgrouptitle,
        legendrank: shape.legendrank,
        legendwidth: shape.legendwidth,
        showlegend: shape.showlegend,
        visible: shape.visible,
        opacity: shape.opacity,
        mode: shape.type === 'line' ? 'lines' : 'markers',
        line: shape.line,
        marker: {
          line: shape.line,
          color: shape.fillcolor,
          size: 12,
          symbol: shape.type === 'rect' ? 'square' : shape.type === 'circle' ? 'circle' :
          // case of path
          'hexagon2'
        }
      };
      calcdata.push([{
        trace: shapeLegend
      }]);
    }
    legendData = fullLayout.showlegend && getLegendData(calcdata, legendObj, fullLayout._legends.length > 1);
  } else {
    if (!legendObj.entries) return;
    legendData = getLegendData(legendObj.entries, legendObj);
  }
  var hiddenSlices = fullLayout.hiddenlabels || [];
  if (!inHover && (!fullLayout.showlegend || !legendData.length)) {
    layer.selectAll('.' + legendId).remove();
    fullLayout._topdefs.select('#' + clipId).remove();
    return Plots.autoMargin(gd, legendId);
  }
  var legend = Lib.ensureSingle(layer, 'g', legendId, function (s) {
    if (!inHover) s.attr('pointer-events', 'all');
  });
  var clipPath = Lib.ensureSingleById(fullLayout._topdefs, 'clipPath', clipId, function (s) {
    s.append('rect');
  });
  var bg = Lib.ensureSingle(legend, 'rect', 'bg', function (s) {
    s.attr('shape-rendering', 'crispEdges');
  });
  bg.call(Color.stroke, legendObj.bordercolor).call(Color.fill, legendObj.bgcolor).style('stroke-width', legendObj.borderwidth + 'px');
  var scrollBox = Lib.ensureSingle(legend, 'g', 'scrollbox');
  var title = legendObj.title;
  legendObj._titleWidth = 0;
  legendObj._titleHeight = 0;
  var titleEl;
  if (title.text) {
    titleEl = Lib.ensureSingle(scrollBox, 'text', legendId + 'titletext');
    titleEl.attr('text-anchor', 'start').call(Drawing.font, title.font).text(title.text);
    textLayout(titleEl, scrollBox, gd, legendObj, MAIN_TITLE); // handle mathjax or multi-line text and compute title height
  } else {
    scrollBox.selectAll('.' + legendId + 'titletext').remove();
  }
  var scrollBar = Lib.ensureSingle(legend, 'rect', 'scrollbar', function (s) {
    s.attr(constants.scrollBarEnterAttrs).call(Color.fill, constants.scrollBarColor);
  });
  var groups = scrollBox.selectAll('g.groups').data(legendData);
  groups.enter().append('g').attr('class', 'groups');
  groups.exit().remove();
  var traces = groups.selectAll('g.traces').data(Lib.identity);
  traces.enter().append('g').attr('class', 'traces');
  traces.exit().remove();
  traces.style('opacity', function (d) {
    var trace = d[0].trace;
    if (Registry.traceIs(trace, 'pie-like')) {
      return hiddenSlices.indexOf(d[0].label) !== -1 ? 0.5 : 1;
    } else {
      return trace.visible === 'legendonly' ? 0.5 : 1;
    }
  }).each(function () {
    d3.select(this).call(drawTexts, gd, legendObj);
  }).call(style, gd, legendObj).each(function () {
    if (!inHover) d3.select(this).call(setupTraceToggle, gd, legendId);
  });
  Lib.syncOrAsync([Plots.previousPromises, function () {
    return computeLegendDimensions(gd, groups, traces, legendObj);
  }, function () {
    var gs = fullLayout._size;
    var bw = legendObj.borderwidth;
    var isPaperX = legendObj.xref === 'paper';
    var isPaperY = legendObj.yref === 'paper';

    // re-calculate title position after legend width is derived. To allow for horizontal alignment
    if (title.text) {
      horizontalAlignTitle(titleEl, legendObj, bw);
    }
    if (!inHover) {
      var lx, ly;
      if (isPaperX) {
        lx = gs.l + gs.w * legendObj.x - FROM_TL[getXanchor(legendObj)] * legendObj._width;
      } else {
        lx = fullLayout.width * legendObj.x - FROM_TL[getXanchor(legendObj)] * legendObj._width;
      }
      if (isPaperY) {
        ly = gs.t + gs.h * (1 - legendObj.y) - FROM_TL[getYanchor(legendObj)] * legendObj._effHeight;
      } else {
        ly = fullLayout.height * (1 - legendObj.y) - FROM_TL[getYanchor(legendObj)] * legendObj._effHeight;
      }
      var expMargin = expandMargin(gd, legendId, lx, ly);

      // IF expandMargin return a Promise (which is truthy),
      // we're under a doAutoMargin redraw, so we don't have to
      // draw the remaining pieces below
      if (expMargin) return;
      if (fullLayout.margin.autoexpand) {
        var lx0 = lx;
        var ly0 = ly;
        lx = isPaperX ? Lib.constrain(lx, 0, fullLayout.width - legendObj._width) : lx0;
        ly = isPaperY ? Lib.constrain(ly, 0, fullLayout.height - legendObj._effHeight) : ly0;
        if (lx !== lx0) {
          Lib.log('Constrain ' + legendId + '.x to make legend fit inside graph');
        }
        if (ly !== ly0) {
          Lib.log('Constrain ' + legendId + '.y to make legend fit inside graph');
        }
      }

      // Set size and position of all the elements that make up a legend:
      // legend, background and border, scroll box and scroll bar as well as title
      Drawing.setTranslate(legend, lx, ly);
    }

    // to be safe, remove previous listeners
    scrollBar.on('.drag', null);
    legend.on('wheel', null);
    if (inHover || legendObj._height <= legendObj._maxHeight || gd._context.staticPlot) {
      // if scrollbar should not be shown.
      var height = legendObj._effHeight;

      // if unified hover, let it be its full size
      if (inHover) height = legendObj._height;
      bg.attr({
        width: legendObj._width - bw,
        height: height - bw,
        x: bw / 2,
        y: bw / 2
      });
      Drawing.setTranslate(scrollBox, 0, 0);
      clipPath.select('rect').attr({
        width: legendObj._width - 2 * bw,
        height: height - 2 * bw,
        x: bw,
        y: bw
      });
      Drawing.setClipUrl(scrollBox, clipId, gd);
      Drawing.setRect(scrollBar, 0, 0, 0, 0);
      delete legendObj._scrollY;
    } else {
      var scrollBarHeight = Math.max(constants.scrollBarMinHeight, legendObj._effHeight * legendObj._effHeight / legendObj._height);
      var scrollBarYMax = legendObj._effHeight - scrollBarHeight - 2 * constants.scrollBarMargin;
      var scrollBoxYMax = legendObj._height - legendObj._effHeight;
      var scrollRatio = scrollBarYMax / scrollBoxYMax;
      var scrollBoxY = Math.min(legendObj._scrollY || 0, scrollBoxYMax);

      // increase the background and clip-path width
      // by the scrollbar width and margin
      bg.attr({
        width: legendObj._width - 2 * bw + constants.scrollBarWidth + constants.scrollBarMargin,
        height: legendObj._effHeight - bw,
        x: bw / 2,
        y: bw / 2
      });
      clipPath.select('rect').attr({
        width: legendObj._width - 2 * bw + constants.scrollBarWidth + constants.scrollBarMargin,
        height: legendObj._effHeight - 2 * bw,
        x: bw,
        y: bw + scrollBoxY
      });
      Drawing.setClipUrl(scrollBox, clipId, gd);
      scrollHandler(scrollBoxY, scrollBarHeight, scrollRatio);

      // scroll legend by mousewheel or touchpad swipe up/down
      legend.on('wheel', function () {
        scrollBoxY = Lib.constrain(legendObj._scrollY + d3.event.deltaY / scrollBarYMax * scrollBoxYMax, 0, scrollBoxYMax);
        scrollHandler(scrollBoxY, scrollBarHeight, scrollRatio);
        if (scrollBoxY !== 0 && scrollBoxY !== scrollBoxYMax) {
          d3.event.preventDefault();
        }
      });
      var eventY0, eventY1, scrollBoxY0;
      var getScrollBarDragY = function (scrollBoxY0, eventY0, eventY1) {
        var y = (eventY1 - eventY0) / scrollRatio + scrollBoxY0;
        return Lib.constrain(y, 0, scrollBoxYMax);
      };
      var getNaturalDragY = function (scrollBoxY0, eventY0, eventY1) {
        var y = (eventY0 - eventY1) / scrollRatio + scrollBoxY0;
        return Lib.constrain(y, 0, scrollBoxYMax);
      };

      // scroll legend by dragging scrollBAR
      var scrollBarDrag = d3.behavior.drag().on('dragstart', function () {
        var e = d3.event.sourceEvent;
        if (e.type === 'touchstart') {
          eventY0 = e.changedTouches[0].clientY;
        } else {
          eventY0 = e.clientY;
        }
        scrollBoxY0 = scrollBoxY;
      }).on('drag', function () {
        var e = d3.event.sourceEvent;
        if (e.buttons === 2 || e.ctrlKey) return;
        if (e.type === 'touchmove') {
          eventY1 = e.changedTouches[0].clientY;
        } else {
          eventY1 = e.clientY;
        }
        scrollBoxY = getScrollBarDragY(scrollBoxY0, eventY0, eventY1);
        scrollHandler(scrollBoxY, scrollBarHeight, scrollRatio);
      });
      scrollBar.call(scrollBarDrag);

      // scroll legend by touch-dragging scrollBOX
      var scrollBoxTouchDrag = d3.behavior.drag().on('dragstart', function () {
        var e = d3.event.sourceEvent;
        if (e.type === 'touchstart') {
          eventY0 = e.changedTouches[0].clientY;
          scrollBoxY0 = scrollBoxY;
        }
      }).on('drag', function () {
        var e = d3.event.sourceEvent;
        if (e.type === 'touchmove') {
          eventY1 = e.changedTouches[0].clientY;
          scrollBoxY = getNaturalDragY(scrollBoxY0, eventY0, eventY1);
          scrollHandler(scrollBoxY, scrollBarHeight, scrollRatio);
        }
      });
      scrollBox.call(scrollBoxTouchDrag);
    }
    function scrollHandler(scrollBoxY, scrollBarHeight, scrollRatio) {
      legendObj._scrollY = gd._fullLayout[legendId]._scrollY = scrollBoxY;
      Drawing.setTranslate(scrollBox, 0, -scrollBoxY);
      Drawing.setRect(scrollBar, legendObj._width, constants.scrollBarMargin + scrollBoxY * scrollRatio, constants.scrollBarWidth, scrollBarHeight);
      clipPath.select('rect').attr('y', bw + scrollBoxY);
    }
    if (gd._context.edits.legendPosition) {
      var xf, yf, x0, y0;
      legend.classed('cursor-move', true);
      dragElement.init({
        element: legend.node(),
        gd: gd,
        prepFn: function (e) {
          if (e.target === scrollBar.node()) {
            return;
          }
          var transform = Drawing.getTranslate(legend);
          x0 = transform.x;
          y0 = transform.y;
        },
        moveFn: function (dx, dy) {
          if (x0 !== undefined && y0 !== undefined) {
            var newX = x0 + dx;
            var newY = y0 + dy;
            Drawing.setTranslate(legend, newX, newY);
            xf = dragElement.align(newX, legendObj._width, gs.l, gs.l + gs.w, legendObj.xanchor);
            yf = dragElement.align(newY + legendObj._height, -legendObj._height, gs.t + gs.h, gs.t, legendObj.yanchor);
          }
        },
        doneFn: function () {
          if (xf !== undefined && yf !== undefined) {
            var obj = {};
            obj[legendId + '.x'] = xf;
            obj[legendId + '.y'] = yf;
            Registry.call('_guiRelayout', gd, obj);
          }
        },
        clickFn: function (numClicks, e) {
          var clickedTrace = layer.selectAll('g.traces').filter(function () {
            var bbox = this.getBoundingClientRect();
            return e.clientX >= bbox.left && e.clientX <= bbox.right && e.clientY >= bbox.top && e.clientY <= bbox.bottom;
          });
          if (clickedTrace.size() > 0) {
            clickOrDoubleClick(gd, legend, clickedTrace, numClicks, e);
          }
        }
      });
    }
  }], gd);
}
function getTraceWidth(d, legendObj, textGap) {
  var legendItem = d[0];
  var legendWidth = legendItem.width;
  var mode = legendObj.entrywidthmode;
  var traceLegendWidth = legendItem.trace.legendwidth || legendObj.entrywidth;
  if (mode === 'fraction') return legendObj._maxWidth * traceLegendWidth;
  return textGap + (traceLegendWidth || legendWidth);
}
function clickOrDoubleClick(gd, legend, legendItem, numClicks, evt) {
  var trace = legendItem.data()[0][0].trace;
  var evtData = {
    event: evt,
    node: legendItem.node(),
    curveNumber: trace.index,
    expandedIndex: trace._expandedIndex,
    data: gd.data,
    layout: gd.layout,
    frames: gd._transitionData._frames,
    config: gd._context,
    fullData: gd._fullData,
    fullLayout: gd._fullLayout
  };
  if (trace._group) {
    evtData.group = trace._group;
  }
  if (Registry.traceIs(trace, 'pie-like')) {
    evtData.label = legendItem.datum()[0].label;
  }
  var clickVal = Events.triggerHandler(gd, 'plotly_legendclick', evtData);
  if (numClicks === 1) {
    if (clickVal === false) return;
    legend._clickTimeout = setTimeout(function () {
      if (!gd._fullLayout) return;
      handleClick(legendItem, gd, numClicks);
    }, gd._context.doubleClickDelay);
  } else if (numClicks === 2) {
    if (legend._clickTimeout) clearTimeout(legend._clickTimeout);
    gd._legendMouseDownTime = 0;
    var dblClickVal = Events.triggerHandler(gd, 'plotly_legenddoubleclick', evtData);
    // Activate default double click behaviour only when both single click and double click values are not false
    if (dblClickVal !== false && clickVal !== false) handleClick(legendItem, gd, numClicks);
  }
}
function drawTexts(g, gd, legendObj) {
  var legendId = getId(legendObj);
  var legendItem = g.data()[0][0];
  var trace = legendItem.trace;
  var isPieLike = Registry.traceIs(trace, 'pie-like');
  var isEditable = !legendObj._inHover && gd._context.edits.legendText && !isPieLike;
  var maxNameLength = legendObj._maxNameLength;
  var name, font;
  if (legendItem.groupTitle) {
    name = legendItem.groupTitle.text;
    font = legendItem.groupTitle.font;
  } else {
    font = legendObj.font;
    if (!legendObj.entries) {
      name = isPieLike ? legendItem.label : trace.name;
      if (trace._meta) {
        name = Lib.templateString(name, trace._meta);
      }
    } else {
      name = legendItem.text;
    }
  }
  var textEl = Lib.ensureSingle(g, 'text', legendId + 'text');
  textEl.attr('text-anchor', 'start').call(Drawing.font, font).text(isEditable ? ensureLength(name, maxNameLength) : name);
  var textGap = legendObj.indentation + legendObj.itemwidth + constants.itemGap * 2;
  svgTextUtils.positionText(textEl, textGap, 0);
  if (isEditable) {
    textEl.call(svgTextUtils.makeEditable, {
      gd: gd,
      text: name
    }).call(textLayout, g, gd, legendObj).on('edit', function (newName) {
      this.text(ensureLength(newName, maxNameLength)).call(textLayout, g, gd, legendObj);
      var fullInput = legendItem.trace._fullInput || {};
      var update = {};
      if (Registry.hasTransform(fullInput, 'groupby')) {
        var groupbyIndices = Registry.getTransformIndices(fullInput, 'groupby');
        var _index = groupbyIndices[groupbyIndices.length - 1];
        var kcont = Lib.keyedContainer(fullInput, 'transforms[' + _index + '].styles', 'target', 'value.name');
        kcont.set(legendItem.trace._group, newName);
        update = kcont.constructUpdate();
      } else {
        update.name = newName;
      }
      if (fullInput._isShape) {
        return Registry.call('_guiRelayout', gd, 'shapes[' + trace.index + '].name', update.name);
      } else {
        return Registry.call('_guiRestyle', gd, update, trace.index);
      }
    });
  } else {
    textLayout(textEl, g, gd, legendObj);
  }
}

/*
 * Make sure we have a reasonably clickable region.
 * If this string is missing or very short, pad it with spaces out to at least
 * 4 characters, up to the max length of other labels, on the assumption that
 * most characters are wider than spaces so a string of spaces will usually be
 * no wider than the real labels.
 */
function ensureLength(str, maxLength) {
  var targetLength = Math.max(4, maxLength);
  if (str && str.trim().length >= targetLength / 2) return str;
  str = str || '';
  for (var i = targetLength - str.length; i > 0; i--) str += ' ';
  return str;
}
function setupTraceToggle(g, gd, legendId) {
  var doubleClickDelay = gd._context.doubleClickDelay;
  var newMouseDownTime;
  var numClicks = 1;
  var traceToggle = Lib.ensureSingle(g, 'rect', legendId + 'toggle', function (s) {
    if (!gd._context.staticPlot) {
      s.style('cursor', 'pointer').attr('pointer-events', 'all');
    }
    s.call(Color.fill, 'rgba(0,0,0,0)');
  });
  if (gd._context.staticPlot) return;
  traceToggle.on('mousedown', function () {
    newMouseDownTime = new Date().getTime();
    if (newMouseDownTime - gd._legendMouseDownTime < doubleClickDelay) {
      // in a click train
      numClicks += 1;
    } else {
      // new click train
      numClicks = 1;
      gd._legendMouseDownTime = newMouseDownTime;
    }
  });
  traceToggle.on('mouseup', function () {
    if (gd._dragged || gd._editing) return;
    var legend = gd._fullLayout[legendId];
    if (new Date().getTime() - gd._legendMouseDownTime > doubleClickDelay) {
      numClicks = Math.max(numClicks - 1, 1);
    }
    clickOrDoubleClick(gd, legend, g, numClicks, d3.event);
  });
}
function textLayout(s, g, gd, legendObj, aTitle) {
  if (legendObj._inHover) s.attr('data-notex', true); // do not process MathJax for unified hover
  svgTextUtils.convertToTspans(s, gd, function () {
    computeTextDimensions(g, gd, legendObj, aTitle);
  });
}
function computeTextDimensions(g, gd, legendObj, aTitle) {
  var legendItem = g.data()[0][0];
  if (!legendObj._inHover && legendItem && !legendItem.trace.showlegend) {
    g.remove();
    return;
  }
  var mathjaxGroup = g.select('g[class*=math-group]');
  var mathjaxNode = mathjaxGroup.node();
  var legendId = getId(legendObj);
  if (!legendObj) {
    legendObj = gd._fullLayout[legendId];
  }
  var bw = legendObj.borderwidth;
  var font;
  if (aTitle === MAIN_TITLE) {
    font = legendObj.title.font;
  } else if (legendItem.groupTitle) {
    font = legendItem.groupTitle.font;
  } else {
    font = legendObj.font;
  }
  var lineHeight = font.size * LINE_SPACING;
  var height, width;
  if (mathjaxNode) {
    var mathjaxBB = Drawing.bBox(mathjaxNode);
    height = mathjaxBB.height;
    width = mathjaxBB.width;
    if (aTitle === MAIN_TITLE) {
      Drawing.setTranslate(mathjaxGroup, bw, bw + height * 0.75);
    } else {
      // legend item
      Drawing.setTranslate(mathjaxGroup, 0, height * 0.25);
    }
  } else {
    var cls = '.' + legendId + (aTitle === MAIN_TITLE ? 'title' : '') + 'text';
    var textEl = g.select(cls);
    var textLines = svgTextUtils.lineCount(textEl);
    var textNode = textEl.node();
    height = lineHeight * textLines;
    width = textNode ? Drawing.bBox(textNode).width : 0;

    // approximation to height offset to center the font
    // to avoid getBoundingClientRect
    if (aTitle === MAIN_TITLE) {
      if (legendObj.title.side === 'left') {
        // add extra space between legend title and itmes
        width += constants.itemGap * 2;
      }
      svgTextUtils.positionText(textEl, bw + constants.titlePad, bw + lineHeight);
    } else {
      // legend item
      var x = constants.itemGap * 2 + legendObj.indentation + legendObj.itemwidth;
      if (legendItem.groupTitle) {
        x = constants.itemGap;
        width -= legendObj.indentation + legendObj.itemwidth;
      }
      svgTextUtils.positionText(textEl, x, -lineHeight * ((textLines - 1) / 2 - 0.3));
    }
  }
  if (aTitle === MAIN_TITLE) {
    legendObj._titleWidth = width;
    legendObj._titleHeight = height;
  } else {
    // legend item
    legendItem.lineHeight = lineHeight;
    legendItem.height = Math.max(height, 16) + 3;
    legendItem.width = width;
  }
}
function getTitleSize(legendObj) {
  var w = 0;
  var h = 0;
  var side = legendObj.title.side;
  if (side) {
    if (side.indexOf('left') !== -1) {
      w = legendObj._titleWidth;
    }
    if (side.indexOf('top') !== -1) {
      h = legendObj._titleHeight;
    }
  }
  return [w, h];
}

/*
 * Computes in fullLayout[legendId]:
 *
 *  - _height: legend height including items past scrollbox height
 *  - _maxHeight: maximum legend height before scrollbox is required
 *  - _effHeight: legend height w/ or w/o scrollbox
 *
 *  - _width: legend width
 *  - _maxWidth (for orientation:h only): maximum width before starting new row
 */
function computeLegendDimensions(gd, groups, traces, legendObj) {
  var fullLayout = gd._fullLayout;
  var legendId = getId(legendObj);
  if (!legendObj) {
    legendObj = fullLayout[legendId];
  }
  var gs = fullLayout._size;
  var isVertical = helpers.isVertical(legendObj);
  var isGrouped = helpers.isGrouped(legendObj);
  var isFraction = legendObj.entrywidthmode === 'fraction';
  var bw = legendObj.borderwidth;
  var bw2 = 2 * bw;
  var itemGap = constants.itemGap;
  var textGap = legendObj.indentation + legendObj.itemwidth + itemGap * 2;
  var endPad = 2 * (bw + itemGap);
  var yanchor = getYanchor(legendObj);
  var isBelowPlotArea = legendObj.y < 0 || legendObj.y === 0 && yanchor === 'top';
  var isAbovePlotArea = legendObj.y > 1 || legendObj.y === 1 && yanchor === 'bottom';
  var traceGroupGap = legendObj.tracegroupgap;
  var legendGroupWidths = {};

  // - if below/above plot area, give it the maximum potential margin-push value
  // - otherwise, extend the height of the plot area
  legendObj._maxHeight = Math.max(isBelowPlotArea || isAbovePlotArea ? fullLayout.height / 2 : gs.h, 30);
  var toggleRectWidth = 0;
  legendObj._width = 0;
  legendObj._height = 0;
  var titleSize = getTitleSize(legendObj);
  if (isVertical) {
    traces.each(function (d) {
      var h = d[0].height;
      Drawing.setTranslate(this, bw + titleSize[0], bw + titleSize[1] + legendObj._height + h / 2 + itemGap);
      legendObj._height += h;
      legendObj._width = Math.max(legendObj._width, d[0].width);
    });
    toggleRectWidth = textGap + legendObj._width;
    legendObj._width += itemGap + textGap + bw2;
    legendObj._height += endPad;
    if (isGrouped) {
      groups.each(function (d, i) {
        Drawing.setTranslate(this, 0, i * legendObj.tracegroupgap);
      });
      legendObj._height += (legendObj._lgroupsLength - 1) * legendObj.tracegroupgap;
    }
  } else {
    var xanchor = getXanchor(legendObj);
    var isLeftOfPlotArea = legendObj.x < 0 || legendObj.x === 0 && xanchor === 'right';
    var isRightOfPlotArea = legendObj.x > 1 || legendObj.x === 1 && xanchor === 'left';
    var isBeyondPlotAreaY = isAbovePlotArea || isBelowPlotArea;
    var hw = fullLayout.width / 2;

    // - if placed within x-margins, extend the width of the plot area
    // - else if below/above plot area and anchored in the margin, extend to opposite margin,
    // - otherwise give it the maximum potential margin-push value
    legendObj._maxWidth = Math.max(isLeftOfPlotArea ? isBeyondPlotAreaY && xanchor === 'left' ? gs.l + gs.w : hw : isRightOfPlotArea ? isBeyondPlotAreaY && xanchor === 'right' ? gs.r + gs.w : hw : gs.w, 2 * textGap);
    var maxItemWidth = 0;
    var combinedItemWidth = 0;
    traces.each(function (d) {
      var w = getTraceWidth(d, legendObj, textGap);
      maxItemWidth = Math.max(maxItemWidth, w);
      combinedItemWidth += w;
    });
    toggleRectWidth = null;
    var maxRowWidth = 0;
    if (isGrouped) {
      var maxGroupHeightInRow = 0;
      var groupOffsetX = 0;
      var groupOffsetY = 0;
      groups.each(function () {
        var maxWidthInGroup = 0;
        var offsetY = 0;
        d3.select(this).selectAll('g.traces').each(function (d) {
          var w = getTraceWidth(d, legendObj, textGap);
          var h = d[0].height;
          Drawing.setTranslate(this, titleSize[0], titleSize[1] + bw + itemGap + h / 2 + offsetY);
          offsetY += h;
          maxWidthInGroup = Math.max(maxWidthInGroup, w);
          legendGroupWidths[d[0].trace.legendgroup] = maxWidthInGroup;
        });
        var next = maxWidthInGroup + itemGap;

        // horizontal_wrapping
        if (
        // not on the first column already
        groupOffsetX > 0 &&
        // goes beyound limit
        next + bw + groupOffsetX > legendObj._maxWidth) {
          maxRowWidth = Math.max(maxRowWidth, groupOffsetX);
          groupOffsetX = 0;
          groupOffsetY += maxGroupHeightInRow + traceGroupGap;
          maxGroupHeightInRow = offsetY;
        } else {
          maxGroupHeightInRow = Math.max(maxGroupHeightInRow, offsetY);
        }
        Drawing.setTranslate(this, groupOffsetX, groupOffsetY);
        groupOffsetX += next;
      });
      legendObj._width = Math.max(maxRowWidth, groupOffsetX) + bw;
      legendObj._height = groupOffsetY + maxGroupHeightInRow + endPad;
    } else {
      var nTraces = traces.size();
      var oneRowLegend = combinedItemWidth + bw2 + (nTraces - 1) * itemGap < legendObj._maxWidth;
      var maxItemHeightInRow = 0;
      var offsetX = 0;
      var offsetY = 0;
      var rowWidth = 0;
      traces.each(function (d) {
        var h = d[0].height;
        var w = getTraceWidth(d, legendObj, textGap, isGrouped);
        var next = oneRowLegend ? w : maxItemWidth;
        if (!isFraction) {
          next += itemGap;
        }
        if (next + bw + offsetX - itemGap >= legendObj._maxWidth) {
          maxRowWidth = Math.max(maxRowWidth, rowWidth);
          offsetX = 0;
          offsetY += maxItemHeightInRow;
          legendObj._height += maxItemHeightInRow;
          maxItemHeightInRow = 0;
        }
        Drawing.setTranslate(this, titleSize[0] + bw + offsetX, titleSize[1] + bw + offsetY + h / 2 + itemGap);
        rowWidth = offsetX + w + itemGap;
        offsetX += next;
        maxItemHeightInRow = Math.max(maxItemHeightInRow, h);
      });
      if (oneRowLegend) {
        legendObj._width = offsetX + bw2;
        legendObj._height = maxItemHeightInRow + endPad;
      } else {
        legendObj._width = Math.max(maxRowWidth, rowWidth) + bw2;
        legendObj._height += maxItemHeightInRow + endPad;
      }
    }
  }
  legendObj._width = Math.ceil(Math.max(legendObj._width + titleSize[0], legendObj._titleWidth + 2 * (bw + constants.titlePad)));
  legendObj._height = Math.ceil(Math.max(legendObj._height + titleSize[1], legendObj._titleHeight + 2 * (bw + constants.itemGap)));
  legendObj._effHeight = Math.min(legendObj._height, legendObj._maxHeight);
  var edits = gd._context.edits;
  var isEditable = edits.legendText || edits.legendPosition;
  traces.each(function (d) {
    var traceToggle = d3.select(this).select('.' + legendId + 'toggle');
    var h = d[0].height;
    var legendgroup = d[0].trace.legendgroup;
    var traceWidth = getTraceWidth(d, legendObj, textGap);
    if (isGrouped && legendgroup !== '') {
      traceWidth = legendGroupWidths[legendgroup];
    }
    var w = isEditable ? textGap : toggleRectWidth || traceWidth;
    if (!isVertical && !isFraction) {
      w += itemGap / 2;
    }
    Drawing.setRect(traceToggle, 0, -h / 2, w, h);
  });
}
function expandMargin(gd, legendId, lx, ly) {
  var fullLayout = gd._fullLayout;
  var legendObj = fullLayout[legendId];
  var xanchor = getXanchor(legendObj);
  var yanchor = getYanchor(legendObj);
  var isPaperX = legendObj.xref === 'paper';
  var isPaperY = legendObj.yref === 'paper';
  gd._fullLayout._reservedMargin[legendId] = {};
  var sideY = legendObj.y < 0.5 ? 'b' : 't';
  var sideX = legendObj.x < 0.5 ? 'l' : 'r';
  var possibleReservedMargins = {
    r: fullLayout.width - lx,
    l: lx + legendObj._width,
    b: fullLayout.height - ly,
    t: ly + legendObj._effHeight
  };
  if (isPaperX && isPaperY) {
    return Plots.autoMargin(gd, legendId, {
      x: legendObj.x,
      y: legendObj.y,
      l: legendObj._width * FROM_TL[xanchor],
      r: legendObj._width * FROM_BR[xanchor],
      b: legendObj._effHeight * FROM_BR[yanchor],
      t: legendObj._effHeight * FROM_TL[yanchor]
    });
  } else if (isPaperX) {
    gd._fullLayout._reservedMargin[legendId][sideY] = possibleReservedMargins[sideY];
  } else if (isPaperY) {
    gd._fullLayout._reservedMargin[legendId][sideX] = possibleReservedMargins[sideX];
  } else {
    if (legendObj.orientation === 'v') {
      gd._fullLayout._reservedMargin[legendId][sideX] = possibleReservedMargins[sideX];
    } else {
      gd._fullLayout._reservedMargin[legendId][sideY] = possibleReservedMargins[sideY];
    }
  }
}
function getXanchor(legendObj) {
  return Lib.isRightAnchor(legendObj) ? 'right' : Lib.isCenterAnchor(legendObj) ? 'center' : 'left';
}
function getYanchor(legendObj) {
  return Lib.isBottomAnchor(legendObj) ? 'bottom' : Lib.isMiddleAnchor(legendObj) ? 'middle' : 'top';
}
function getId(legendObj) {
  return legendObj._id || 'legend';
}

/***/ }),

/***/ 851:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Registry = __webpack_require__(33626);
var helpers = __webpack_require__(57599);
module.exports = function getLegendData(calcdata, opts, hasMultipleLegends) {
  var inHover = opts._inHover;
  var grouped = helpers.isGrouped(opts);
  var reversed = helpers.isReversed(opts);
  var lgroupToTraces = {};
  var lgroups = [];
  var hasOneNonBlankGroup = false;
  var slicesShown = {};
  var lgroupi = 0;
  var maxNameLength = 0;
  var i, j;
  function addOneItem(legendId, legendGroup, legendItem) {
    if (opts.visible === false) return;
    if (hasMultipleLegends && legendId !== opts._id) return;

    // each '' legend group is treated as a separate group
    if (legendGroup === '' || !helpers.isGrouped(opts)) {
      // TODO: check this against fullData legendgroups?
      var uniqueGroup = '~~i' + lgroupi;
      lgroups.push(uniqueGroup);
      lgroupToTraces[uniqueGroup] = [legendItem];
      lgroupi++;
    } else if (lgroups.indexOf(legendGroup) === -1) {
      lgroups.push(legendGroup);
      hasOneNonBlankGroup = true;
      lgroupToTraces[legendGroup] = [legendItem];
    } else {
      lgroupToTraces[legendGroup].push(legendItem);
    }
  }

  // build an { legendgroup: [cd0, cd0], ... } object
  for (i = 0; i < calcdata.length; i++) {
    var cd = calcdata[i];
    var cd0 = cd[0];
    var trace = cd0.trace;
    var lid = trace.legend;
    var lgroup = trace.legendgroup;
    if (!inHover && (!trace.visible || !trace.showlegend)) continue;
    if (Registry.traceIs(trace, 'pie-like')) {
      if (!slicesShown[lgroup]) slicesShown[lgroup] = {};
      for (j = 0; j < cd.length; j++) {
        var labelj = cd[j].label;
        if (!slicesShown[lgroup][labelj]) {
          addOneItem(lid, lgroup, {
            label: labelj,
            color: cd[j].color,
            i: cd[j].i,
            trace: trace,
            pts: cd[j].pts
          });
          slicesShown[lgroup][labelj] = true;
          maxNameLength = Math.max(maxNameLength, (labelj || '').length);
        }
      }
    } else {
      addOneItem(lid, lgroup, cd0);
      maxNameLength = Math.max(maxNameLength, (trace.name || '').length);
    }
  }

  // won't draw a legend in this case
  if (!lgroups.length) return [];

  // collapse all groups into one if all groups are blank
  var shouldCollapse = !hasOneNonBlankGroup || !grouped;
  var legendData = [];
  for (i = 0; i < lgroups.length; i++) {
    var t = lgroupToTraces[lgroups[i]];
    if (shouldCollapse) {
      legendData.push(t[0]);
    } else {
      legendData.push(t);
    }
  }
  if (shouldCollapse) legendData = [legendData];
  for (i = 0; i < legendData.length; i++) {
    // find minimum rank within group
    var groupMinRank = Infinity;
    for (j = 0; j < legendData[i].length; j++) {
      var rank = legendData[i][j].trace.legendrank;
      if (groupMinRank > rank) groupMinRank = rank;
    }

    // record on first group element
    legendData[i][0]._groupMinRank = groupMinRank;
    legendData[i][0]._preGroupSort = i;
  }
  var orderFn1 = function (a, b) {
    return a[0]._groupMinRank - b[0]._groupMinRank || a[0]._preGroupSort - b[0]._preGroupSort // fallback for old Chrome < 70 https://bugs.chromium.org/p/v8/issues/detail?id=90
    ;
  };
  var orderFn2 = function (a, b) {
    return a.trace.legendrank - b.trace.legendrank || a._preSort - b._preSort // fallback for old Chrome < 70 https://bugs.chromium.org/p/v8/issues/detail?id=90
    ;
  };

  // sort considering minimum group legendrank
  legendData.forEach(function (a, k) {
    a[0]._preGroupSort = k;
  });
  legendData.sort(orderFn1);
  for (i = 0; i < legendData.length; i++) {
    // sort considering trace.legendrank and legend.traceorder
    legendData[i].forEach(function (a, k) {
      a._preSort = k;
    });
    legendData[i].sort(orderFn2);
    var firstItemTrace = legendData[i][0].trace;
    var groupTitle = null;
    // get group title text
    for (j = 0; j < legendData[i].length; j++) {
      var gt = legendData[i][j].trace.legendgrouptitle;
      if (gt && gt.text) {
        groupTitle = gt;
        if (inHover) gt.font = opts._groupTitleFont;
        break;
      }
    }

    // reverse order
    if (reversed) legendData[i].reverse();
    if (groupTitle) {
      var hasPieLike = false;
      for (j = 0; j < legendData[i].length; j++) {
        if (Registry.traceIs(legendData[i][j].trace, 'pie-like')) {
          hasPieLike = true;
          break;
        }
      }

      // set group title text
      legendData[i].unshift({
        i: -1,
        groupTitle: groupTitle,
        noClick: hasPieLike,
        trace: {
          showlegend: firstItemTrace.showlegend,
          legendgroup: firstItemTrace.legendgroup,
          visible: opts.groupclick === 'toggleitem' ? true : firstItemTrace.visible
        }
      });
    }

    // rearrange lgroupToTraces into a d3-friendly array of arrays
    for (j = 0; j < legendData[i].length; j++) {
      legendData[i][j] = [legendData[i][j]];
    }
  }

  // number of legend groups - needed in legend/draw.js
  opts._lgroupsLength = legendData.length;
  // maximum name/label length - needed in legend/draw.js
  opts._maxNameLength = maxNameLength;
  return legendData;
};

/***/ }),

/***/ 22165:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Registry = __webpack_require__(33626);
var Lib = __webpack_require__(34809);
var pushUnique = Lib.pushUnique;
var SHOWISOLATETIP = true;
module.exports = function handleClick(g, gd, numClicks) {
  var fullLayout = gd._fullLayout;
  if (gd._dragged || gd._editing) return;
  var itemClick = fullLayout.legend.itemclick;
  var itemDoubleClick = fullLayout.legend.itemdoubleclick;
  var groupClick = fullLayout.legend.groupclick;
  if (numClicks === 1 && itemClick === 'toggle' && itemDoubleClick === 'toggleothers' && SHOWISOLATETIP && gd.data && gd._context.showTips) {
    Lib.notifier(Lib._(gd, 'Double-click on legend to isolate one trace'), 'long');
    SHOWISOLATETIP = false;
  } else {
    SHOWISOLATETIP = false;
  }
  var mode;
  if (numClicks === 1) mode = itemClick;else if (numClicks === 2) mode = itemDoubleClick;
  if (!mode) return;
  var toggleGroup = groupClick === 'togglegroup';
  var hiddenSlices = fullLayout.hiddenlabels ? fullLayout.hiddenlabels.slice() : [];
  var legendItem = g.data()[0][0];
  if (legendItem.groupTitle && legendItem.noClick) return;
  var fullData = gd._fullData;
  var shapesWithLegend = (fullLayout.shapes || []).filter(function (d) {
    return d.showlegend;
  });
  var allLegendItems = fullData.concat(shapesWithLegend);
  var fullTrace = legendItem.trace;
  if (fullTrace._isShape) {
    fullTrace = fullTrace._fullInput;
  }
  var legendgroup = fullTrace.legendgroup;
  var i, j, kcont, key, keys, val;
  var dataUpdate = {};
  var dataIndices = [];
  var carrs = [];
  var carrIdx = [];
  function insertDataUpdate(traceIndex, value) {
    var attrIndex = dataIndices.indexOf(traceIndex);
    var valueArray = dataUpdate.visible;
    if (!valueArray) {
      valueArray = dataUpdate.visible = [];
    }
    if (dataIndices.indexOf(traceIndex) === -1) {
      dataIndices.push(traceIndex);
      attrIndex = dataIndices.length - 1;
    }
    valueArray[attrIndex] = value;
    return attrIndex;
  }
  var updatedShapes = (fullLayout.shapes || []).map(function (d) {
    return d._input;
  });
  var shapesUpdated = false;
  function insertShapesUpdate(shapeIndex, value) {
    updatedShapes[shapeIndex].visible = value;
    shapesUpdated = true;
  }
  function setVisibility(fullTrace, visibility) {
    if (legendItem.groupTitle && !toggleGroup) return;
    var fullInput = fullTrace._fullInput || fullTrace;
    var isShape = fullInput._isShape;
    var index = fullInput.index;
    if (index === undefined) index = fullInput._index;
    if (Registry.hasTransform(fullInput, 'groupby')) {
      var kcont = carrs[index];
      if (!kcont) {
        var groupbyIndices = Registry.getTransformIndices(fullInput, 'groupby');
        var lastGroupbyIndex = groupbyIndices[groupbyIndices.length - 1];
        kcont = Lib.keyedContainer(fullInput, 'transforms[' + lastGroupbyIndex + '].styles', 'target', 'value.visible');
        carrs[index] = kcont;
      }
      var curState = kcont.get(fullTrace._group);

      // If not specified, assume visible. This happens if there are other style
      // properties set for a group but not the visibility. There are many similar
      // ways to do this (e.g. why not just `curState = fullTrace.visible`??? The
      // answer is: because it breaks other things like groupby trace names in
      // subtle ways.)
      if (curState === undefined) {
        curState = true;
      }
      if (curState !== false) {
        // true -> legendonly. All others toggle to true:
        kcont.set(fullTrace._group, visibility);
      }
      carrIdx[index] = insertDataUpdate(index, fullInput.visible === false ? false : true);
    } else {
      // false -> false (not possible since will not be visible in legend)
      // true -> legendonly
      // legendonly -> true
      var nextVisibility = fullInput.visible === false ? false : visibility;
      if (isShape) {
        insertShapesUpdate(index, nextVisibility);
      } else {
        insertDataUpdate(index, nextVisibility);
      }
    }
  }
  var thisLegend = fullTrace.legend;
  var fullInput = fullTrace._fullInput;
  var isShape = fullInput && fullInput._isShape;
  if (!isShape && Registry.traceIs(fullTrace, 'pie-like')) {
    var thisLabel = legendItem.label;
    var thisLabelIndex = hiddenSlices.indexOf(thisLabel);
    if (mode === 'toggle') {
      if (thisLabelIndex === -1) hiddenSlices.push(thisLabel);else hiddenSlices.splice(thisLabelIndex, 1);
    } else if (mode === 'toggleothers') {
      var changed = thisLabelIndex !== -1;
      var unhideList = [];
      for (i = 0; i < gd.calcdata.length; i++) {
        var cdi = gd.calcdata[i];
        for (j = 0; j < cdi.length; j++) {
          var d = cdi[j];
          var dLabel = d.label;

          // ensure we toggle slices that are in this legend)
          if (thisLegend === cdi[0].trace.legend) {
            if (thisLabel !== dLabel) {
              if (hiddenSlices.indexOf(dLabel) === -1) changed = true;
              pushUnique(hiddenSlices, dLabel);
              unhideList.push(dLabel);
            }
          }
        }
      }
      if (!changed) {
        for (var q = 0; q < unhideList.length; q++) {
          var pos = hiddenSlices.indexOf(unhideList[q]);
          if (pos !== -1) {
            hiddenSlices.splice(pos, 1);
          }
        }
      }
    }
    Registry.call('_guiRelayout', gd, 'hiddenlabels', hiddenSlices);
  } else {
    var hasLegendgroup = legendgroup && legendgroup.length;
    var traceIndicesInGroup = [];
    var tracei;
    if (hasLegendgroup) {
      for (i = 0; i < allLegendItems.length; i++) {
        tracei = allLegendItems[i];
        if (!tracei.visible) continue;
        if (tracei.legendgroup === legendgroup) {
          traceIndicesInGroup.push(i);
        }
      }
    }
    if (mode === 'toggle') {
      var nextVisibility;
      switch (fullTrace.visible) {
        case true:
          nextVisibility = 'legendonly';
          break;
        case false:
          nextVisibility = false;
          break;
        case 'legendonly':
          nextVisibility = true;
          break;
      }
      if (hasLegendgroup) {
        if (toggleGroup) {
          for (i = 0; i < allLegendItems.length; i++) {
            var item = allLegendItems[i];
            if (item.visible !== false && item.legendgroup === legendgroup) {
              setVisibility(item, nextVisibility);
            }
          }
        } else {
          setVisibility(fullTrace, nextVisibility);
        }
      } else {
        setVisibility(fullTrace, nextVisibility);
      }
    } else if (mode === 'toggleothers') {
      // Compute the clicked index. expandedIndex does what we want for expanded traces
      // but also culls hidden traces. That means we have some work to do.
      var isClicked, isInGroup, notInLegend, otherState, _item;
      var isIsolated = true;
      for (i = 0; i < allLegendItems.length; i++) {
        _item = allLegendItems[i];
        isClicked = _item === fullTrace;
        notInLegend = _item.showlegend !== true;
        if (isClicked || notInLegend) continue;
        isInGroup = hasLegendgroup && _item.legendgroup === legendgroup;
        if (!isInGroup && _item.legend === thisLegend && _item.visible === true && !Registry.traceIs(_item, 'notLegendIsolatable')) {
          isIsolated = false;
          break;
        }
      }
      for (i = 0; i < allLegendItems.length; i++) {
        _item = allLegendItems[i];

        // False is sticky; we don't change it. Also ensure we don't change states of itmes in other legend
        if (_item.visible === false || _item.legend !== thisLegend) continue;
        if (Registry.traceIs(_item, 'notLegendIsolatable')) {
          continue;
        }
        switch (fullTrace.visible) {
          case 'legendonly':
            setVisibility(_item, true);
            break;
          case true:
            otherState = isIsolated ? true : 'legendonly';
            isClicked = _item === fullTrace;
            // N.B. consider traces that have a set legendgroup as toggleable
            notInLegend = _item.showlegend !== true && !_item.legendgroup;
            isInGroup = isClicked || hasLegendgroup && _item.legendgroup === legendgroup;
            setVisibility(_item, isInGroup || notInLegend ? true : otherState);
            break;
        }
      }
    }
    for (i = 0; i < carrs.length; i++) {
      kcont = carrs[i];
      if (!kcont) continue;
      var update = kcont.constructUpdate();
      var updateKeys = Object.keys(update);
      for (j = 0; j < updateKeys.length; j++) {
        key = updateKeys[j];
        val = dataUpdate[key] = dataUpdate[key] || [];
        val[carrIdx[i]] = update[key];
      }
    }

    // The length of the value arrays should be equal and any unspecified
    // values should be explicitly undefined for them to get properly culled
    // as updates and not accidentally reset to the default value. This fills
    // out sparse arrays with the required number of undefined values:
    keys = Object.keys(dataUpdate);
    for (i = 0; i < keys.length; i++) {
      key = keys[i];
      for (j = 0; j < dataIndices.length; j++) {
        // Use hasOwnProperty to protect against falsy values:
        if (!dataUpdate[key].hasOwnProperty(j)) {
          dataUpdate[key][j] = undefined;
        }
      }
    }
    if (shapesUpdated) {
      Registry.call('_guiUpdate', gd, dataUpdate, {
        shapes: updatedShapes
      }, dataIndices);
    } else {
      Registry.call('_guiRestyle', gd, dataUpdate, dataIndices);
    }
  }
};

/***/ }),

/***/ 57599:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


exports.isGrouped = function isGrouped(legendLayout) {
  return (legendLayout.traceorder || '').indexOf('grouped') !== -1;
};
exports.isVertical = function isVertical(legendLayout) {
  return legendLayout.orientation !== 'h';
};
exports.isReversed = function isReversed(legendLayout) {
  return (legendLayout.traceorder || '').indexOf('reversed') !== -1;
};

/***/ }),

/***/ 82494:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = {
  moduleType: 'component',
  name: 'legend',
  layoutAttributes: __webpack_require__(86405),
  supplyLayoutDefaults: __webpack_require__(73970),
  draw: __webpack_require__(6134),
  style: __webpack_require__(14375)
};

/***/ }),

/***/ 14375:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var Registry = __webpack_require__(33626);
var Lib = __webpack_require__(34809);
var strTranslate = Lib.strTranslate;
var Drawing = __webpack_require__(62203);
var Color = __webpack_require__(78766);
var extractOpts = (__webpack_require__(65477).extractOpts);
var subTypes = __webpack_require__(64726);
var stylePie = __webpack_require__(32891);
var pieCastOption = (__webpack_require__(37252).castOption);
var constants = __webpack_require__(72783);
var CST_MARKER_SIZE = 12;
var CST_LINE_WIDTH = 5;
var CST_MARKER_LINE_WIDTH = 2;
var MAX_LINE_WIDTH = 10;
var MAX_MARKER_LINE_WIDTH = 5;
module.exports = function style(s, gd, legend) {
  var fullLayout = gd._fullLayout;
  if (!legend) legend = fullLayout.legend;
  var constantItemSizing = legend.itemsizing === 'constant';
  var itemWidth = legend.itemwidth;
  var centerPos = (itemWidth + constants.itemGap * 2) / 2;
  var centerTransform = strTranslate(centerPos, 0);
  var boundLineWidth = function (mlw, cont, max, cst) {
    var v;
    if (mlw + 1) {
      v = mlw;
    } else if (cont && cont.width > 0) {
      v = cont.width;
    } else {
      return 0;
    }
    return constantItemSizing ? cst : Math.min(v, max);
  };
  s.each(function (d) {
    var traceGroup = d3.select(this);
    var layers = Lib.ensureSingle(traceGroup, 'g', 'layers');
    layers.style('opacity', d[0].trace.opacity);
    var indentation = legend.indentation;
    var valign = legend.valign;
    var lineHeight = d[0].lineHeight;
    var height = d[0].height;
    if (valign === 'middle' && indentation === 0 || !lineHeight || !height) {
      layers.attr('transform', null);
    } else {
      var factor = {
        top: 1,
        bottom: -1
      }[valign];
      var markerOffsetY = factor * (0.5 * (lineHeight - height + 3)) || 0;
      var markerOffsetX = legend.indentation;
      layers.attr('transform', strTranslate(markerOffsetX, markerOffsetY));
    }
    var fill = layers.selectAll('g.legendfill').data([d]);
    fill.enter().append('g').classed('legendfill', true);
    var line = layers.selectAll('g.legendlines').data([d]);
    line.enter().append('g').classed('legendlines', true);
    var symbol = layers.selectAll('g.legendsymbols').data([d]);
    symbol.enter().append('g').classed('legendsymbols', true);
    symbol.selectAll('g.legendpoints').data([d]).enter().append('g').classed('legendpoints', true);
  }).each(styleSpatial).each(styleWaterfalls).each(styleFunnels).each(styleBars).each(styleBoxes).each(styleFunnelareas).each(stylePies).each(styleLines).each(stylePoints).each(styleCandles).each(styleOHLC);
  function styleLines(d) {
    var styleGuide = getStyleGuide(d);
    var showFill = styleGuide.showFill;
    var showLine = styleGuide.showLine;
    var showGradientLine = styleGuide.showGradientLine;
    var showGradientFill = styleGuide.showGradientFill;
    var anyFill = styleGuide.anyFill;
    var anyLine = styleGuide.anyLine;
    var d0 = d[0];
    var trace = d0.trace;
    var dMod, tMod;
    var cOpts = extractOpts(trace);
    var colorscale = cOpts.colorscale;
    var reversescale = cOpts.reversescale;
    var fillStyle = function (s) {
      if (s.size()) {
        if (showFill) {
          Drawing.fillGroupStyle(s, gd, true);
        } else {
          var gradientID = 'legendfill-' + trace.uid;
          Drawing.gradient(s, gd, gradientID, getGradientDirection(reversescale), colorscale, 'fill');
        }
      }
    };
    var lineGradient = function (s) {
      if (s.size()) {
        var gradientID = 'legendline-' + trace.uid;
        Drawing.lineGroupStyle(s);
        Drawing.gradient(s, gd, gradientID, getGradientDirection(reversescale), colorscale, 'stroke');
      }
    };

    // with fill and no markers or text, move the line and fill up a bit
    // so it's more centered

    var pathStart = subTypes.hasMarkers(trace) || !anyFill ? 'M5,0' :
    // with a line leave it slightly below center, to leave room for the
    // line thickness and because the line is usually more prominent
    anyLine ? 'M5,-2' : 'M5,-3';
    var this3 = d3.select(this);
    var fill = this3.select('.legendfill').selectAll('path').data(showFill || showGradientFill ? [d] : []);
    fill.enter().append('path').classed('js-fill', true);
    fill.exit().remove();
    fill.attr('d', pathStart + 'h' + itemWidth + 'v6h-' + itemWidth + 'z').call(fillStyle);
    if (showLine || showGradientLine) {
      var lw = boundLineWidth(undefined, trace.line, MAX_LINE_WIDTH, CST_LINE_WIDTH);
      tMod = Lib.minExtend(trace, {
        line: {
          width: lw
        }
      });
      dMod = [Lib.minExtend(d0, {
        trace: tMod
      })];
    }
    var line = this3.select('.legendlines').selectAll('path').data(showLine || showGradientLine ? [dMod] : []);
    line.enter().append('path').classed('js-line', true);
    line.exit().remove();

    // this is ugly... but you can't apply a gradient to a perfectly
    // horizontal or vertical line. Presumably because then
    // the system doesn't know how to scale vertical variation, even
    // though there *is* no vertical variation in this case.
    // so add an invisibly small angle to the line
    // This issue (and workaround) exist across (Mac) Chrome, FF, and Safari
    line.attr('d', pathStart + (showGradientLine ? 'l' + itemWidth + ',0.0001' : 'h' + itemWidth)).call(showLine ? Drawing.lineGroupStyle : lineGradient);
  }
  function stylePoints(d) {
    var styleGuide = getStyleGuide(d);
    var anyFill = styleGuide.anyFill;
    var anyLine = styleGuide.anyLine;
    var showLine = styleGuide.showLine;
    var showMarker = styleGuide.showMarker;
    var d0 = d[0];
    var trace = d0.trace;
    var showText = !showMarker && !anyLine && !anyFill && subTypes.hasText(trace);
    var dMod, tMod;

    // 'scatter3d' don't use gd.calcdata,
    // use d0.trace to infer arrayOk attributes

    function boundVal(attrIn, arrayToValFn, bounds, cst) {
      var valIn = Lib.nestedProperty(trace, attrIn).get();
      var valToBound = Lib.isArrayOrTypedArray(valIn) && arrayToValFn ? arrayToValFn(valIn) : valIn;
      if (constantItemSizing && valToBound && cst !== undefined) {
        valToBound = cst;
      }
      if (bounds) {
        if (valToBound < bounds[0]) return bounds[0];else if (valToBound > bounds[1]) return bounds[1];
      }
      return valToBound;
    }
    function pickFirst(array) {
      if (d0._distinct && d0.index && array[d0.index]) return array[d0.index];
      return array[0];
    }

    // constrain text, markers, etc so they'll fit on the legend
    if (showMarker || showText || showLine) {
      var dEdit = {};
      var tEdit = {};
      if (showMarker) {
        dEdit.mc = boundVal('marker.color', pickFirst);
        dEdit.mx = boundVal('marker.symbol', pickFirst);
        dEdit.mo = boundVal('marker.opacity', Lib.mean, [0.2, 1]);
        dEdit.mlc = boundVal('marker.line.color', pickFirst);
        dEdit.mlw = boundVal('marker.line.width', Lib.mean, [0, 5], CST_MARKER_LINE_WIDTH);
        tEdit.marker = {
          sizeref: 1,
          sizemin: 1,
          sizemode: 'diameter'
        };
        var ms = boundVal('marker.size', Lib.mean, [2, 16], CST_MARKER_SIZE);
        dEdit.ms = ms;
        tEdit.marker.size = ms;
      }
      if (showLine) {
        tEdit.line = {
          width: boundVal('line.width', pickFirst, [0, 10], CST_LINE_WIDTH)
        };
      }
      if (showText) {
        dEdit.tx = 'Aa';
        dEdit.tp = boundVal('textposition', pickFirst);
        dEdit.ts = 10;
        dEdit.tc = boundVal('textfont.color', pickFirst);
        dEdit.tf = boundVal('textfont.family', pickFirst);
        dEdit.tw = boundVal('textfont.weight', pickFirst);
        dEdit.ty = boundVal('textfont.style', pickFirst);
        dEdit.tv = boundVal('textfont.variant', pickFirst);
        dEdit.tC = boundVal('textfont.textcase', pickFirst);
        dEdit.tE = boundVal('textfont.lineposition', pickFirst);
        dEdit.tS = boundVal('textfont.shadow', pickFirst);
      }
      dMod = [Lib.minExtend(d0, dEdit)];
      tMod = Lib.minExtend(trace, tEdit);

      // always show legend items in base state
      tMod.selectedpoints = null;

      // never show texttemplate
      tMod.texttemplate = null;
    }
    var ptgroup = d3.select(this).select('g.legendpoints');
    var pts = ptgroup.selectAll('path.scatterpts').data(showMarker ? dMod : []);
    // make sure marker is on the bottom, in case it enters after text
    pts.enter().insert('path', ':first-child').classed('scatterpts', true).attr('transform', centerTransform);
    pts.exit().remove();
    pts.call(Drawing.pointStyle, tMod, gd);

    // 'mrc' is set in pointStyle and used in textPointStyle:
    // constrain it here
    if (showMarker) dMod[0].mrc = 3;
    var txt = ptgroup.selectAll('g.pointtext').data(showText ? dMod : []);
    txt.enter().append('g').classed('pointtext', true).append('text').attr('transform', centerTransform);
    txt.exit().remove();
    txt.selectAll('text').call(Drawing.textPointStyle, tMod, gd);
  }
  function styleWaterfalls(d) {
    var trace = d[0].trace;
    var isWaterfall = trace.type === 'waterfall';
    if (d[0]._distinct && isWaterfall) {
      var cont = d[0].trace[d[0].dir].marker;
      d[0].mc = cont.color;
      d[0].mlw = cont.line.width;
      d[0].mlc = cont.line.color;
      return styleBarLike(d, this, 'waterfall');
    }
    var ptsData = [];
    if (trace.visible && isWaterfall) {
      ptsData = d[0].hasTotals ? [['increasing', 'M-6,-6V6H0Z'], ['totals', 'M6,6H0L-6,-6H-0Z'], ['decreasing', 'M6,6V-6H0Z']] : [['increasing', 'M-6,-6V6H6Z'], ['decreasing', 'M6,6V-6H-6Z']];
    }
    var pts = d3.select(this).select('g.legendpoints').selectAll('path.legendwaterfall').data(ptsData);
    pts.enter().append('path').classed('legendwaterfall', true).attr('transform', centerTransform).style('stroke-miterlimit', 1);
    pts.exit().remove();
    pts.each(function (dd) {
      var pt = d3.select(this);
      var cont = trace[dd[0]].marker;
      var lw = boundLineWidth(undefined, cont.line, MAX_MARKER_LINE_WIDTH, CST_MARKER_LINE_WIDTH);
      pt.attr('d', dd[1]).style('stroke-width', lw + 'px').call(Color.fill, cont.color);
      if (lw) {
        pt.call(Color.stroke, cont.line.color);
      }
    });
  }
  function styleBars(d) {
    styleBarLike(d, this);
  }
  function styleFunnels(d) {
    styleBarLike(d, this, 'funnel');
  }
  function styleBarLike(d, lThis, desiredType) {
    var trace = d[0].trace;
    var marker = trace.marker || {};
    var markerLine = marker.line || {};

    // If bar has rounded corners, round corners of legend icon
    var pathStr = marker.cornerradius ? 'M6,3a3,3,0,0,1-3,3H-3a3,3,0,0,1-3-3V-3a3,3,0,0,1,3-3H3a3,3,0,0,1,3,3Z' :
    // Square with rounded corners
    'M6,6H-6V-6H6Z'; // Normal square

    var isVisible = !desiredType ? Registry.traceIs(trace, 'bar') : trace.visible && trace.type === desiredType;
    var barpath = d3.select(lThis).select('g.legendpoints').selectAll('path.legend' + desiredType).data(isVisible ? [d] : []);
    barpath.enter().append('path').classed('legend' + desiredType, true).attr('d', pathStr).attr('transform', centerTransform);
    barpath.exit().remove();
    barpath.each(function (d) {
      var p = d3.select(this);
      var d0 = d[0];
      var w = boundLineWidth(d0.mlw, marker.line, MAX_MARKER_LINE_WIDTH, CST_MARKER_LINE_WIDTH);
      p.style('stroke-width', w + 'px');
      var mcc = d0.mcc;
      if (!legend._inHover && 'mc' in d0) {
        // not in unified hover but
        // for legend use the color in the middle of scale
        var cOpts = extractOpts(marker);
        var mid = cOpts.mid;
        if (mid === undefined) mid = (cOpts.max + cOpts.min) / 2;
        mcc = Drawing.tryColorscale(marker, '')(mid);
      }
      var fillColor = mcc || d0.mc || marker.color;
      var markerPattern = marker.pattern;
      var patternShape = markerPattern && Drawing.getPatternAttr(markerPattern.shape, 0, '');
      if (patternShape) {
        var patternBGColor = Drawing.getPatternAttr(markerPattern.bgcolor, 0, null);
        var patternFGColor = Drawing.getPatternAttr(markerPattern.fgcolor, 0, null);
        var patternFGOpacity = markerPattern.fgopacity;
        var patternSize = dimAttr(markerPattern.size, 8, 10);
        var patternSolidity = dimAttr(markerPattern.solidity, 0.5, 1);
        var patternID = 'legend-' + trace.uid;
        p.call(Drawing.pattern, 'legend', gd, patternID, patternShape, patternSize, patternSolidity, mcc, markerPattern.fillmode, patternBGColor, patternFGColor, patternFGOpacity);
      } else {
        p.call(Color.fill, fillColor);
      }
      if (w) Color.stroke(p, d0.mlc || markerLine.color);
    });
  }
  function styleBoxes(d) {
    var trace = d[0].trace;
    var pts = d3.select(this).select('g.legendpoints').selectAll('path.legendbox').data(trace.visible && Registry.traceIs(trace, 'box-violin') ? [d] : []);
    pts.enter().append('path').classed('legendbox', true)
    // if we want the median bar, prepend M6,0H-6
    .attr('d', 'M6,6H-6V-6H6Z').attr('transform', centerTransform);
    pts.exit().remove();
    pts.each(function () {
      var p = d3.select(this);
      if ((trace.boxpoints === 'all' || trace.points === 'all') && Color.opacity(trace.fillcolor) === 0 && Color.opacity((trace.line || {}).color) === 0) {
        var tMod = Lib.minExtend(trace, {
          marker: {
            size: constantItemSizing ? CST_MARKER_SIZE : Lib.constrain(trace.marker.size, 2, 16),
            sizeref: 1,
            sizemin: 1,
            sizemode: 'diameter'
          }
        });
        pts.call(Drawing.pointStyle, tMod, gd);
      } else {
        var w = boundLineWidth(undefined, trace.line, MAX_MARKER_LINE_WIDTH, CST_MARKER_LINE_WIDTH);
        p.style('stroke-width', w + 'px').call(Color.fill, trace.fillcolor);
        if (w) Color.stroke(p, trace.line.color);
      }
    });
  }
  function styleCandles(d) {
    var trace = d[0].trace;
    var pts = d3.select(this).select('g.legendpoints').selectAll('path.legendcandle').data(trace.visible && trace.type === 'candlestick' ? [d, d] : []);
    pts.enter().append('path').classed('legendcandle', true).attr('d', function (_, i) {
      if (i) return 'M-15,0H-8M-8,6V-6H8Z'; // increasing
      return 'M15,0H8M8,-6V6H-8Z'; // decreasing
    }).attr('transform', centerTransform).style('stroke-miterlimit', 1);
    pts.exit().remove();
    pts.each(function (_, i) {
      var p = d3.select(this);
      var cont = trace[i ? 'increasing' : 'decreasing'];
      var w = boundLineWidth(undefined, cont.line, MAX_MARKER_LINE_WIDTH, CST_MARKER_LINE_WIDTH);
      p.style('stroke-width', w + 'px').call(Color.fill, cont.fillcolor);
      if (w) Color.stroke(p, cont.line.color);
    });
  }
  function styleOHLC(d) {
    var trace = d[0].trace;
    var pts = d3.select(this).select('g.legendpoints').selectAll('path.legendohlc').data(trace.visible && trace.type === 'ohlc' ? [d, d] : []);
    pts.enter().append('path').classed('legendohlc', true).attr('d', function (_, i) {
      if (i) return 'M-15,0H0M-8,-6V0'; // increasing
      return 'M15,0H0M8,6V0'; // decreasing
    }).attr('transform', centerTransform).style('stroke-miterlimit', 1);
    pts.exit().remove();
    pts.each(function (_, i) {
      var p = d3.select(this);
      var cont = trace[i ? 'increasing' : 'decreasing'];
      var w = boundLineWidth(undefined, cont.line, MAX_MARKER_LINE_WIDTH, CST_MARKER_LINE_WIDTH);
      p.style('fill', 'none').call(Drawing.dashLine, cont.line.dash, w);
      if (w) Color.stroke(p, cont.line.color);
    });
  }
  function stylePies(d) {
    stylePieLike(d, this, 'pie');
  }
  function styleFunnelareas(d) {
    stylePieLike(d, this, 'funnelarea');
  }
  function stylePieLike(d, lThis, desiredType) {
    var d0 = d[0];
    var trace = d0.trace;
    var isVisible = !desiredType ? Registry.traceIs(trace, desiredType) : trace.visible && trace.type === desiredType;
    var pts = d3.select(lThis).select('g.legendpoints').selectAll('path.legend' + desiredType).data(isVisible ? [d] : []);
    pts.enter().append('path').classed('legend' + desiredType, true).attr('d', 'M6,6H-6V-6H6Z').attr('transform', centerTransform);
    pts.exit().remove();
    if (pts.size()) {
      var cont = trace.marker || {};
      var lw = boundLineWidth(pieCastOption(cont.line.width, d0.pts), cont.line, MAX_MARKER_LINE_WIDTH, CST_MARKER_LINE_WIDTH);
      var opt = 'pieLike';
      var tMod = Lib.minExtend(trace, {
        marker: {
          line: {
            width: lw
          }
        }
      }, opt);
      var d0Mod = Lib.minExtend(d0, {
        trace: tMod
      }, opt);
      stylePie(pts, d0Mod, tMod, gd);
    }
  }
  function styleSpatial(d) {
    // i.e. maninly traces having z and colorscale
    var trace = d[0].trace;
    var useGradient;
    var ptsData = [];
    if (trace.visible) {
      switch (trace.type) {
        case 'histogram2d':
        case 'heatmap':
          ptsData = [['M-15,-2V4H15V-2Z'] // similar to contour
          ];
          useGradient = true;
          break;
        case 'choropleth':
        case 'choroplethmapbox':
        case 'choroplethmap':
          ptsData = [['M-6,-6V6H6V-6Z']];
          useGradient = true;
          break;
        case 'densitymapbox':
        case 'densitymap':
          ptsData = [['M-6,0 a6,6 0 1,0 12,0 a 6,6 0 1,0 -12,0']];
          useGradient = 'radial';
          break;
        case 'cone':
          ptsData = [['M-6,2 A2,2 0 0,0 -6,6 V6L6,4Z'], ['M-6,-6 A2,2 0 0,0 -6,-2 L6,-4Z'], ['M-6,-2 A2,2 0 0,0 -6,2 L6,0Z']];
          useGradient = false;
          break;
        case 'streamtube':
          ptsData = [['M-6,2 A2,2 0 0,0 -6,6 H6 A2,2 0 0,1 6,2 Z'], ['M-6,-6 A2,2 0 0,0 -6,-2 H6 A2,2 0 0,1 6,-6 Z'], ['M-6,-2 A2,2 0 0,0 -6,2 H6 A2,2 0 0,1 6,-2 Z']];
          useGradient = false;
          break;
        case 'surface':
          ptsData = [['M-6,-6 A2,3 0 0,0 -6,0 H6 A2,3 0 0,1 6,-6 Z'], ['M-6,1 A2,3 0 0,1 -6,6 H6 A2,3 0 0,0 6,0 Z']];
          useGradient = true;
          break;
        case 'mesh3d':
          ptsData = [['M-6,6H0L-6,-6Z'], ['M6,6H0L6,-6Z'], ['M-6,-6H6L0,6Z']];
          useGradient = false;
          break;
        case 'volume':
          ptsData = [['M-6,6H0L-6,-6Z'], ['M6,6H0L6,-6Z'], ['M-6,-6H6L0,6Z']];
          useGradient = true;
          break;
        case 'isosurface':
          ptsData = [['M-6,6H0L-6,-6Z'], ['M6,6H0L6,-6Z'], ['M-6,-6 A12,24 0 0,0 6,-6 L0,6Z']];
          useGradient = false;
          break;
      }
    }
    var pts = d3.select(this).select('g.legendpoints').selectAll('path.legend3dandfriends').data(ptsData);
    pts.enter().append('path').classed('legend3dandfriends', true).attr('transform', centerTransform).style('stroke-miterlimit', 1);
    pts.exit().remove();
    pts.each(function (dd, i) {
      var pt = d3.select(this);
      var cOpts = extractOpts(trace);
      var colorscale = cOpts.colorscale;
      var reversescale = cOpts.reversescale;
      var fillGradient = function (s) {
        if (s.size()) {
          var gradientID = 'legendfill-' + trace.uid;
          Drawing.gradient(s, gd, gradientID, getGradientDirection(reversescale, useGradient === 'radial'), colorscale, 'fill');
        }
      };
      var fillColor;
      if (!colorscale) {
        var color = trace.vertexcolor || trace.facecolor || trace.color;
        fillColor = Lib.isArrayOrTypedArray(color) ? color[i] || color[0] : color;
      } else {
        if (!useGradient) {
          var len = colorscale.length;
          fillColor = i === 0 ? colorscale[reversescale ? len - 1 : 0][1] :
          // minimum
          i === 1 ? colorscale[reversescale ? 0 : len - 1][1] :
          // maximum
          colorscale[Math.floor((len - 1) / 2)][1]; // middle
        }
      }
      pt.attr('d', dd[0]);
      if (fillColor) {
        pt.call(Color.fill, fillColor);
      } else {
        pt.call(fillGradient);
      }
    });
  }
};
function getGradientDirection(reversescale, isRadial) {
  var str = isRadial ? 'radial' : 'horizontal';
  return str + (reversescale ? '' : 'reversed');
}
function getStyleGuide(d) {
  var trace = d[0].trace;
  var contours = trace.contours;
  var showLine = subTypes.hasLines(trace);
  var showMarker = subTypes.hasMarkers(trace);
  var showFill = trace.visible && trace.fill && trace.fill !== 'none';
  var showGradientLine = false;
  var showGradientFill = false;
  if (contours) {
    var coloring = contours.coloring;
    if (coloring === 'lines') {
      showGradientLine = true;
    } else {
      showLine = coloring === 'none' || coloring === 'heatmap' || contours.showlines;
    }
    if (contours.type === 'constraint') {
      showFill = contours._operation !== '=';
    } else if (coloring === 'fill' || coloring === 'heatmap') {
      showGradientFill = true;
    }
  }
  return {
    showMarker: showMarker,
    showLine: showLine,
    showFill: showFill,
    showGradientLine: showGradientLine,
    showGradientFill: showGradientFill,
    anyLine: showLine || showGradientLine,
    anyFill: showFill || showGradientFill
  };
}
function dimAttr(v, dflt, max) {
  if (v && Lib.isArrayOrTypedArray(v)) return dflt;
  if (v > max) return max;
  return v;
}

/***/ }),

/***/ 50308:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var constants = __webpack_require__(87632);
module.exports = {
  editType: 'modebar',
  orientation: {
    valType: 'enumerated',
    values: ['v', 'h'],
    dflt: 'h',
    editType: 'modebar'
  },
  bgcolor: {
    valType: 'color',
    editType: 'modebar'
  },
  color: {
    valType: 'color',
    editType: 'modebar'
  },
  activecolor: {
    valType: 'color',
    editType: 'modebar'
  },
  uirevision: {
    valType: 'any',
    editType: 'none'
  },
  add: {
    valType: 'string',
    arrayOk: true,
    dflt: '',
    editType: 'modebar'
  },
  remove: {
    valType: 'string',
    arrayOk: true,
    dflt: '',
    editType: 'modebar'
  }
};

/***/ }),

/***/ 5832:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Registry = __webpack_require__(33626);
var Plots = __webpack_require__(44122);
var axisIds = __webpack_require__(5975);
var Icons = __webpack_require__(35188);
var eraseActiveShape = (__webpack_require__(28231).eraseActiveShape);
var Lib = __webpack_require__(34809);
var _ = Lib._;
var modeBarButtons = module.exports = {};

/**
 * ModeBar buttons configuration
 *
 * @param {string} name
 *      name / id of the buttons (for tracking)
 * @param {string} title
 *      text that appears while hovering over the button,
 *      enter null, false or '' for no hover text
 * @param {string} icon
 *      svg icon object associated with the button
 *      can be linked to Plotly.Icons to use the default plotly icons
 * @param {string} [gravity]
 *      icon positioning
 * @param {function} click
 *      click handler associated with the button, a function of
 *      'gd' (the main graph object) and
 *      'ev' (the event object)
 * @param {string} [attr]
 *      attribute associated with button,
 *      use this with 'val' to keep track of the state
 * @param {*} [val]
 *      initial 'attr' value, can be a function of gd
 * @param {boolean} [toggle]
 *      is the button a toggle button?
 */
modeBarButtons.toImage = {
  name: 'toImage',
  title: function (gd) {
    var opts = gd._context.toImageButtonOptions || {};
    var format = opts.format || 'png';
    return format === 'png' ? _(gd, 'Download plot as a png') :
    // legacy text
    _(gd, 'Download plot'); // generic non-PNG text
  },
  icon: Icons.camera,
  click: function (gd) {
    var toImageButtonOptions = gd._context.toImageButtonOptions;
    var opts = {
      format: toImageButtonOptions.format || 'png'
    };
    Lib.notifier(_(gd, 'Taking snapshot - this may take a few seconds'), 'long');
    if (opts.format !== 'svg' && Lib.isIE()) {
      Lib.notifier(_(gd, 'IE only supports svg.  Changing format to svg.'), 'long');
      opts.format = 'svg';
    }
    ['filename', 'width', 'height', 'scale'].forEach(function (key) {
      if (key in toImageButtonOptions) {
        opts[key] = toImageButtonOptions[key];
      }
    });
    Registry.call('downloadImage', gd, opts).then(function (filename) {
      Lib.notifier(_(gd, 'Snapshot succeeded') + ' - ' + filename, 'long');
    }).catch(function () {
      Lib.notifier(_(gd, 'Sorry, there was a problem downloading your snapshot!'), 'long');
    });
  }
};
modeBarButtons.sendDataToCloud = {
  name: 'sendDataToCloud',
  title: function (gd) {
    return _(gd, 'Edit in Chart Studio');
  },
  icon: Icons.disk,
  click: function (gd) {
    Plots.sendDataToCloud(gd);
  }
};
modeBarButtons.editInChartStudio = {
  name: 'editInChartStudio',
  title: function (gd) {
    return _(gd, 'Edit in Chart Studio');
  },
  icon: Icons.pencil,
  click: function (gd) {
    Plots.sendDataToCloud(gd);
  }
};
modeBarButtons.zoom2d = {
  name: 'zoom2d',
  _cat: 'zoom',
  title: function (gd) {
    return _(gd, 'Zoom');
  },
  attr: 'dragmode',
  val: 'zoom',
  icon: Icons.zoombox,
  click: handleCartesian
};
modeBarButtons.pan2d = {
  name: 'pan2d',
  _cat: 'pan',
  title: function (gd) {
    return _(gd, 'Pan');
  },
  attr: 'dragmode',
  val: 'pan',
  icon: Icons.pan,
  click: handleCartesian
};
modeBarButtons.select2d = {
  name: 'select2d',
  _cat: 'select',
  title: function (gd) {
    return _(gd, 'Box Select');
  },
  attr: 'dragmode',
  val: 'select',
  icon: Icons.selectbox,
  click: handleCartesian
};
modeBarButtons.lasso2d = {
  name: 'lasso2d',
  _cat: 'lasso',
  title: function (gd) {
    return _(gd, 'Lasso Select');
  },
  attr: 'dragmode',
  val: 'lasso',
  icon: Icons.lasso,
  click: handleCartesian
};
modeBarButtons.drawclosedpath = {
  name: 'drawclosedpath',
  title: function (gd) {
    return _(gd, 'Draw closed freeform');
  },
  attr: 'dragmode',
  val: 'drawclosedpath',
  icon: Icons.drawclosedpath,
  click: handleCartesian
};
modeBarButtons.drawopenpath = {
  name: 'drawopenpath',
  title: function (gd) {
    return _(gd, 'Draw open freeform');
  },
  attr: 'dragmode',
  val: 'drawopenpath',
  icon: Icons.drawopenpath,
  click: handleCartesian
};
modeBarButtons.drawline = {
  name: 'drawline',
  title: function (gd) {
    return _(gd, 'Draw line');
  },
  attr: 'dragmode',
  val: 'drawline',
  icon: Icons.drawline,
  click: handleCartesian
};
modeBarButtons.drawrect = {
  name: 'drawrect',
  title: function (gd) {
    return _(gd, 'Draw rectangle');
  },
  attr: 'dragmode',
  val: 'drawrect',
  icon: Icons.drawrect,
  click: handleCartesian
};
modeBarButtons.drawcircle = {
  name: 'drawcircle',
  title: function (gd) {
    return _(gd, 'Draw circle');
  },
  attr: 'dragmode',
  val: 'drawcircle',
  icon: Icons.drawcircle,
  click: handleCartesian
};
modeBarButtons.eraseshape = {
  name: 'eraseshape',
  title: function (gd) {
    return _(gd, 'Erase active shape');
  },
  icon: Icons.eraseshape,
  click: eraseActiveShape
};
modeBarButtons.zoomIn2d = {
  name: 'zoomIn2d',
  _cat: 'zoomin',
  title: function (gd) {
    return _(gd, 'Zoom in');
  },
  attr: 'zoom',
  val: 'in',
  icon: Icons.zoom_plus,
  click: handleCartesian
};
modeBarButtons.zoomOut2d = {
  name: 'zoomOut2d',
  _cat: 'zoomout',
  title: function (gd) {
    return _(gd, 'Zoom out');
  },
  attr: 'zoom',
  val: 'out',
  icon: Icons.zoom_minus,
  click: handleCartesian
};
modeBarButtons.autoScale2d = {
  name: 'autoScale2d',
  _cat: 'autoscale',
  title: function (gd) {
    return _(gd, 'Autoscale');
  },
  attr: 'zoom',
  val: 'auto',
  icon: Icons.autoscale,
  click: handleCartesian
};
modeBarButtons.resetScale2d = {
  name: 'resetScale2d',
  _cat: 'resetscale',
  title: function (gd) {
    return _(gd, 'Reset axes');
  },
  attr: 'zoom',
  val: 'reset',
  icon: Icons.home,
  click: handleCartesian
};
modeBarButtons.hoverClosestCartesian = {
  name: 'hoverClosestCartesian',
  _cat: 'hoverclosest',
  title: function (gd) {
    return _(gd, 'Show closest data on hover');
  },
  attr: 'hovermode',
  val: 'closest',
  icon: Icons.tooltip_basic,
  gravity: 'ne',
  click: handleCartesian
};
modeBarButtons.hoverCompareCartesian = {
  name: 'hoverCompareCartesian',
  _cat: 'hoverCompare',
  title: function (gd) {
    return _(gd, 'Compare data on hover');
  },
  attr: 'hovermode',
  val: function (gd) {
    return gd._fullLayout._isHoriz ? 'y' : 'x';
  },
  icon: Icons.tooltip_compare,
  gravity: 'ne',
  click: handleCartesian
};
function handleCartesian(gd, ev) {
  var button = ev.currentTarget;
  var astr = button.getAttribute('data-attr');
  var val = button.getAttribute('data-val') || true;
  var fullLayout = gd._fullLayout;
  var aobj = {};
  var axList = axisIds.list(gd, null, true);
  var allSpikesEnabled = fullLayout._cartesianSpikesEnabled;
  var ax, i;
  if (astr === 'zoom') {
    var mag = val === 'in' ? 0.5 : 2;
    var r0 = (1 + mag) / 2;
    var r1 = (1 - mag) / 2;
    var axName;
    for (i = 0; i < axList.length; i++) {
      ax = axList[i];
      if (!ax.fixedrange) {
        axName = ax._name;
        if (val === 'auto') {
          aobj[axName + '.autorange'] = true;
        } else if (val === 'reset') {
          if (ax._rangeInitial0 === undefined && ax._rangeInitial1 === undefined) {
            aobj[axName + '.autorange'] = true;
          } else if (ax._rangeInitial0 === undefined) {
            aobj[axName + '.autorange'] = ax._autorangeInitial;
            aobj[axName + '.range'] = [null, ax._rangeInitial1];
          } else if (ax._rangeInitial1 === undefined) {
            aobj[axName + '.range'] = [ax._rangeInitial0, null];
            aobj[axName + '.autorange'] = ax._autorangeInitial;
          } else {
            aobj[axName + '.range'] = [ax._rangeInitial0, ax._rangeInitial1];
          }

          // N.B. "reset" also resets showspikes
          if (ax._showSpikeInitial !== undefined) {
            aobj[axName + '.showspikes'] = ax._showSpikeInitial;
            if (allSpikesEnabled === 'on' && !ax._showSpikeInitial) {
              allSpikesEnabled = 'off';
            }
          }
        } else {
          var rangeNow = [ax.r2l(ax.range[0]), ax.r2l(ax.range[1])];
          var rangeNew = [r0 * rangeNow[0] + r1 * rangeNow[1], r0 * rangeNow[1] + r1 * rangeNow[0]];
          aobj[axName + '.range[0]'] = ax.l2r(rangeNew[0]);
          aobj[axName + '.range[1]'] = ax.l2r(rangeNew[1]);
        }
      }
    }
  } else {
    // if ALL traces have orientation 'h', 'hovermode': 'x' otherwise: 'y'
    if (astr === 'hovermode' && (val === 'x' || val === 'y')) {
      val = fullLayout._isHoriz ? 'y' : 'x';
      button.setAttribute('data-val', val);
    }
    aobj[astr] = val;
  }
  fullLayout._cartesianSpikesEnabled = allSpikesEnabled;
  Registry.call('_guiRelayout', gd, aobj);
}
modeBarButtons.zoom3d = {
  name: 'zoom3d',
  _cat: 'zoom',
  title: function (gd) {
    return _(gd, 'Zoom');
  },
  attr: 'scene.dragmode',
  val: 'zoom',
  icon: Icons.zoombox,
  click: handleDrag3d
};
modeBarButtons.pan3d = {
  name: 'pan3d',
  _cat: 'pan',
  title: function (gd) {
    return _(gd, 'Pan');
  },
  attr: 'scene.dragmode',
  val: 'pan',
  icon: Icons.pan,
  click: handleDrag3d
};
modeBarButtons.orbitRotation = {
  name: 'orbitRotation',
  title: function (gd) {
    return _(gd, 'Orbital rotation');
  },
  attr: 'scene.dragmode',
  val: 'orbit',
  icon: Icons['3d_rotate'],
  click: handleDrag3d
};
modeBarButtons.tableRotation = {
  name: 'tableRotation',
  title: function (gd) {
    return _(gd, 'Turntable rotation');
  },
  attr: 'scene.dragmode',
  val: 'turntable',
  icon: Icons['z-axis'],
  click: handleDrag3d
};
function handleDrag3d(gd, ev) {
  var button = ev.currentTarget;
  var attr = button.getAttribute('data-attr');
  var val = button.getAttribute('data-val') || true;
  var sceneIds = gd._fullLayout._subplots.gl3d || [];
  var layoutUpdate = {};
  var parts = attr.split('.');
  for (var i = 0; i < sceneIds.length; i++) {
    layoutUpdate[sceneIds[i] + '.' + parts[1]] = val;
  }

  // for multi-type subplots
  var val2d = val === 'pan' ? val : 'zoom';
  layoutUpdate.dragmode = val2d;
  Registry.call('_guiRelayout', gd, layoutUpdate);
}
modeBarButtons.resetCameraDefault3d = {
  name: 'resetCameraDefault3d',
  _cat: 'resetCameraDefault',
  title: function (gd) {
    return _(gd, 'Reset camera to default');
  },
  attr: 'resetDefault',
  icon: Icons.home,
  click: handleCamera3d
};
modeBarButtons.resetCameraLastSave3d = {
  name: 'resetCameraLastSave3d',
  _cat: 'resetCameraLastSave',
  title: function (gd) {
    return _(gd, 'Reset camera to last save');
  },
  attr: 'resetLastSave',
  icon: Icons.movie,
  click: handleCamera3d
};
function handleCamera3d(gd, ev) {
  var button = ev.currentTarget;
  var attr = button.getAttribute('data-attr');
  var resetLastSave = attr === 'resetLastSave';
  var resetDefault = attr === 'resetDefault';
  var fullLayout = gd._fullLayout;
  var sceneIds = fullLayout._subplots.gl3d || [];
  var aobj = {};
  for (var i = 0; i < sceneIds.length; i++) {
    var sceneId = sceneIds[i];
    var camera = sceneId + '.camera';
    var aspectratio = sceneId + '.aspectratio';
    var aspectmode = sceneId + '.aspectmode';
    var scene = fullLayout[sceneId]._scene;
    var didUpdate;
    if (resetLastSave) {
      aobj[camera + '.up'] = scene.viewInitial.up;
      aobj[camera + '.eye'] = scene.viewInitial.eye;
      aobj[camera + '.center'] = scene.viewInitial.center;
      didUpdate = true;
    } else if (resetDefault) {
      aobj[camera + '.up'] = null;
      aobj[camera + '.eye'] = null;
      aobj[camera + '.center'] = null;
      didUpdate = true;
    }
    if (didUpdate) {
      aobj[aspectratio + '.x'] = scene.viewInitial.aspectratio.x;
      aobj[aspectratio + '.y'] = scene.viewInitial.aspectratio.y;
      aobj[aspectratio + '.z'] = scene.viewInitial.aspectratio.z;
      aobj[aspectmode] = scene.viewInitial.aspectmode;
    }
  }
  Registry.call('_guiRelayout', gd, aobj);
}
modeBarButtons.hoverClosest3d = {
  name: 'hoverClosest3d',
  _cat: 'hoverclosest',
  title: function (gd) {
    return _(gd, 'Toggle show closest data on hover');
  },
  attr: 'hovermode',
  val: null,
  toggle: true,
  icon: Icons.tooltip_basic,
  gravity: 'ne',
  click: handleHover3d
};
function getNextHover3d(gd, ev) {
  var button = ev.currentTarget;
  var val = button._previousVal;
  var fullLayout = gd._fullLayout;
  var sceneIds = fullLayout._subplots.gl3d || [];
  var axes = ['xaxis', 'yaxis', 'zaxis'];

  // initialize 'current spike' object to be stored in the DOM
  var currentSpikes = {};
  var layoutUpdate = {};
  if (val) {
    layoutUpdate = val;
    button._previousVal = null;
  } else {
    for (var i = 0; i < sceneIds.length; i++) {
      var sceneId = sceneIds[i];
      var sceneLayout = fullLayout[sceneId];
      var hovermodeAStr = sceneId + '.hovermode';
      currentSpikes[hovermodeAStr] = sceneLayout.hovermode;
      layoutUpdate[hovermodeAStr] = false;

      // copy all the current spike attrs
      for (var j = 0; j < 3; j++) {
        var axis = axes[j];
        var spikeAStr = sceneId + '.' + axis + '.showspikes';
        layoutUpdate[spikeAStr] = false;
        currentSpikes[spikeAStr] = sceneLayout[axis].showspikes;
      }
    }
    button._previousVal = currentSpikes;
  }
  return layoutUpdate;
}
function handleHover3d(gd, ev) {
  var layoutUpdate = getNextHover3d(gd, ev);
  Registry.call('_guiRelayout', gd, layoutUpdate);
}
modeBarButtons.zoomInGeo = {
  name: 'zoomInGeo',
  _cat: 'zoomin',
  title: function (gd) {
    return _(gd, 'Zoom in');
  },
  attr: 'zoom',
  val: 'in',
  icon: Icons.zoom_plus,
  click: handleGeo
};
modeBarButtons.zoomOutGeo = {
  name: 'zoomOutGeo',
  _cat: 'zoomout',
  title: function (gd) {
    return _(gd, 'Zoom out');
  },
  attr: 'zoom',
  val: 'out',
  icon: Icons.zoom_minus,
  click: handleGeo
};
modeBarButtons.resetGeo = {
  name: 'resetGeo',
  _cat: 'reset',
  title: function (gd) {
    return _(gd, 'Reset');
  },
  attr: 'reset',
  val: null,
  icon: Icons.autoscale,
  click: handleGeo
};
modeBarButtons.hoverClosestGeo = {
  name: 'hoverClosestGeo',
  _cat: 'hoverclosest',
  title: function (gd) {
    return _(gd, 'Toggle show closest data on hover');
  },
  attr: 'hovermode',
  val: null,
  toggle: true,
  icon: Icons.tooltip_basic,
  gravity: 'ne',
  click: toggleHover
};
function handleGeo(gd, ev) {
  var button = ev.currentTarget;
  var attr = button.getAttribute('data-attr');
  var val = button.getAttribute('data-val') || true;
  var fullLayout = gd._fullLayout;
  var geoIds = fullLayout._subplots.geo || [];
  for (var i = 0; i < geoIds.length; i++) {
    var id = geoIds[i];
    var geoLayout = fullLayout[id];
    if (attr === 'zoom') {
      var scale = geoLayout.projection.scale;
      var newScale = val === 'in' ? 2 * scale : 0.5 * scale;
      Registry.call('_guiRelayout', gd, id + '.projection.scale', newScale);
    }
  }
  if (attr === 'reset') {
    resetView(gd, 'geo');
  }
}
modeBarButtons.hoverClosestGl2d = {
  name: 'hoverClosestGl2d',
  _cat: 'hoverclosest',
  title: function (gd) {
    return _(gd, 'Toggle show closest data on hover');
  },
  attr: 'hovermode',
  val: null,
  toggle: true,
  icon: Icons.tooltip_basic,
  gravity: 'ne',
  click: toggleHover
};
modeBarButtons.hoverClosestPie = {
  name: 'hoverClosestPie',
  _cat: 'hoverclosest',
  title: function (gd) {
    return _(gd, 'Toggle show closest data on hover');
  },
  attr: 'hovermode',
  val: 'closest',
  icon: Icons.tooltip_basic,
  gravity: 'ne',
  click: toggleHover
};
function getNextHover(gd) {
  var fullLayout = gd._fullLayout;
  if (fullLayout.hovermode) return false;
  if (fullLayout._has('cartesian')) {
    return fullLayout._isHoriz ? 'y' : 'x';
  }
  return 'closest';
}
function toggleHover(gd) {
  var newHover = getNextHover(gd);
  Registry.call('_guiRelayout', gd, 'hovermode', newHover);
}
modeBarButtons.resetViewSankey = {
  name: 'resetSankeyGroup',
  title: function (gd) {
    return _(gd, 'Reset view');
  },
  icon: Icons.home,
  click: function (gd) {
    var aObj = {
      'node.groups': [],
      'node.x': [],
      'node.y': []
    };
    for (var i = 0; i < gd._fullData.length; i++) {
      var viewInitial = gd._fullData[i]._viewInitial;
      aObj['node.groups'].push(viewInitial.node.groups.slice());
      aObj['node.x'].push(viewInitial.node.x.slice());
      aObj['node.y'].push(viewInitial.node.y.slice());
    }
    Registry.call('restyle', gd, aObj);
  }
};

// buttons when more then one plot types are present

modeBarButtons.toggleHover = {
  name: 'toggleHover',
  title: function (gd) {
    return _(gd, 'Toggle show closest data on hover');
  },
  attr: 'hovermode',
  val: null,
  toggle: true,
  icon: Icons.tooltip_basic,
  gravity: 'ne',
  click: function (gd, ev) {
    var layoutUpdate = getNextHover3d(gd, ev);
    layoutUpdate.hovermode = getNextHover(gd);
    Registry.call('_guiRelayout', gd, layoutUpdate);
  }
};
modeBarButtons.resetViews = {
  name: 'resetViews',
  title: function (gd) {
    return _(gd, 'Reset views');
  },
  icon: Icons.home,
  click: function (gd, ev) {
    var button = ev.currentTarget;
    button.setAttribute('data-attr', 'zoom');
    button.setAttribute('data-val', 'reset');
    handleCartesian(gd, ev);
    button.setAttribute('data-attr', 'resetLastSave');
    handleCamera3d(gd, ev);
    resetView(gd, 'geo');
    resetView(gd, 'mapbox');
    resetView(gd, 'map');
  }
};
modeBarButtons.toggleSpikelines = {
  name: 'toggleSpikelines',
  title: function (gd) {
    return _(gd, 'Toggle Spike Lines');
  },
  icon: Icons.spikeline,
  attr: '_cartesianSpikesEnabled',
  val: 'on',
  click: function (gd) {
    var fullLayout = gd._fullLayout;
    var allSpikesEnabled = fullLayout._cartesianSpikesEnabled;
    fullLayout._cartesianSpikesEnabled = allSpikesEnabled === 'on' ? 'off' : 'on';
    Registry.call('_guiRelayout', gd, setSpikelineVisibility(gd));
  }
};
function setSpikelineVisibility(gd) {
  var fullLayout = gd._fullLayout;
  var areSpikesOn = fullLayout._cartesianSpikesEnabled === 'on';
  var axList = axisIds.list(gd, null, true);
  var aobj = {};
  for (var i = 0; i < axList.length; i++) {
    var ax = axList[i];
    aobj[ax._name + '.showspikes'] = areSpikesOn ? true : ax._showSpikeInitial;
  }
  return aobj;
}
modeBarButtons.resetViewMapbox = {
  name: 'resetViewMapbox',
  _cat: 'resetView',
  title: function (gd) {
    return _(gd, 'Reset view');
  },
  attr: 'reset',
  icon: Icons.home,
  click: function (gd) {
    resetView(gd, 'mapbox');
  }
};
modeBarButtons.resetViewMap = {
  name: 'resetViewMap',
  _cat: 'resetView',
  title: function (gd) {
    return _(gd, 'Reset view');
  },
  attr: 'reset',
  icon: Icons.home,
  click: function (gd) {
    resetView(gd, 'map');
  }
};
modeBarButtons.zoomInMapbox = {
  name: 'zoomInMapbox',
  _cat: 'zoomin',
  title: function (gd) {
    return _(gd, 'Zoom in');
  },
  attr: 'zoom',
  val: 'in',
  icon: Icons.zoom_plus,
  click: handleMapboxZoom
};
modeBarButtons.zoomInMap = {
  name: 'zoomInMap',
  _cat: 'zoomin',
  title: function (gd) {
    return _(gd, 'Zoom in');
  },
  attr: 'zoom',
  val: 'in',
  icon: Icons.zoom_plus,
  click: handleMapZoom
};
modeBarButtons.zoomOutMapbox = {
  name: 'zoomOutMapbox',
  _cat: 'zoomout',
  title: function (gd) {
    return _(gd, 'Zoom out');
  },
  attr: 'zoom',
  val: 'out',
  icon: Icons.zoom_minus,
  click: handleMapboxZoom
};
modeBarButtons.zoomOutMap = {
  name: 'zoomOutMap',
  _cat: 'zoomout',
  title: function (gd) {
    return _(gd, 'Zoom out');
  },
  attr: 'zoom',
  val: 'out',
  icon: Icons.zoom_minus,
  click: handleMapZoom
};
function handleMapboxZoom(gd, ev) {
  _handleMapZoom(gd, ev, 'mapbox');
}
function handleMapZoom(gd, ev) {
  _handleMapZoom(gd, ev, 'map');
}
function _handleMapZoom(gd, ev, mapType) {
  var button = ev.currentTarget;
  var val = button.getAttribute('data-val');
  var fullLayout = gd._fullLayout;
  var subplotIds = fullLayout._subplots[mapType] || [];
  var scalar = 1.05;
  var aObj = {};
  for (var i = 0; i < subplotIds.length; i++) {
    var id = subplotIds[i];
    var current = fullLayout[id].zoom;
    var next = val === 'in' ? scalar * current : current / scalar;
    aObj[id + '.zoom'] = next;
  }
  Registry.call('_guiRelayout', gd, aObj);
}
function resetView(gd, subplotType) {
  var fullLayout = gd._fullLayout;
  var subplotIds = fullLayout._subplots[subplotType] || [];
  var aObj = {};
  for (var i = 0; i < subplotIds.length; i++) {
    var id = subplotIds[i];
    var subplotObj = fullLayout[id]._subplot;
    var viewInitial = subplotObj.viewInitial;
    var viewKeys = Object.keys(viewInitial);
    for (var j = 0; j < viewKeys.length; j++) {
      var key = viewKeys[j];
      aObj[id + '.' + key] = viewInitial[key];
    }
  }
  Registry.call('_guiRelayout', gd, aObj);
}

/***/ }),

/***/ 87632:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var modeBarButtons = __webpack_require__(5832);
var buttonList = Object.keys(modeBarButtons);
var DRAW_MODES = ['drawline', 'drawopenpath', 'drawclosedpath', 'drawcircle', 'drawrect', 'eraseshape'];
var backButtons = ['v1hovermode', 'hoverclosest', 'hovercompare', 'togglehover', 'togglespikelines'].concat(DRAW_MODES);
var foreButtons = [];
var addToForeButtons = function (b) {
  if (backButtons.indexOf(b._cat || b.name) !== -1) return;
  // for convenience add lowercase shotname e.g. zoomin as well fullname zoomInGeo
  var name = b.name;
  var _cat = (b._cat || b.name).toLowerCase();
  if (foreButtons.indexOf(name) === -1) foreButtons.push(name);
  if (foreButtons.indexOf(_cat) === -1) foreButtons.push(_cat);
};
buttonList.forEach(function (k) {
  addToForeButtons(modeBarButtons[k]);
});
foreButtons.sort();
module.exports = {
  DRAW_MODES: DRAW_MODES,
  backButtons: backButtons,
  foreButtons: foreButtons
};

/***/ }),

/***/ 17683:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var Color = __webpack_require__(78766);
var Template = __webpack_require__(78032);
var attributes = __webpack_require__(50308);
module.exports = function supplyLayoutDefaults(layoutIn, layoutOut) {
  var containerIn = layoutIn.modebar || {};
  var containerOut = Template.newContainer(layoutOut, 'modebar');
  function coerce(attr, dflt) {
    return Lib.coerce(containerIn, containerOut, attributes, attr, dflt);
  }
  coerce('orientation');
  coerce('bgcolor', Color.addOpacity(layoutOut.paper_bgcolor, 0.5));
  var defaultColor = Color.contrast(Color.rgb(layoutOut.modebar.bgcolor));
  coerce('color', Color.addOpacity(defaultColor, 0.3));
  coerce('activecolor', Color.addOpacity(defaultColor, 0.7));
  coerce('uirevision', layoutOut.uirevision);
  coerce('add');
  coerce('remove');
};

/***/ }),

/***/ 95433:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = {
  moduleType: 'component',
  name: 'modebar',
  layoutAttributes: __webpack_require__(50308),
  supplyLayoutDefaults: __webpack_require__(17683),
  manage: __webpack_require__(75442)
};

/***/ }),

/***/ 75442:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var axisIds = __webpack_require__(5975);
var scatterSubTypes = __webpack_require__(64726);
var Registry = __webpack_require__(33626);
var isUnifiedHover = (__webpack_require__(36040).isUnifiedHover);
var createModeBar = __webpack_require__(85393);
var modeBarButtons = __webpack_require__(5832);
var DRAW_MODES = (__webpack_require__(87632).DRAW_MODES);
var extendDeep = (__webpack_require__(34809).extendDeep);

/**
 * ModeBar wrapper around 'create' and 'update',
 * chooses buttons to pass to ModeBar constructor based on
 * plot type and plot config.
 *
 * @param {object} gd main plot object
 *
 */
module.exports = function manageModeBar(gd) {
  var fullLayout = gd._fullLayout;
  var context = gd._context;
  var modeBar = fullLayout._modeBar;
  if (!context.displayModeBar && !context.watermark) {
    if (modeBar) {
      modeBar.destroy();
      delete fullLayout._modeBar;
    }
    return;
  }
  if (!Array.isArray(context.modeBarButtonsToRemove)) {
    throw new Error(['*modeBarButtonsToRemove* configuration options', 'must be an array.'].join(' '));
  }
  if (!Array.isArray(context.modeBarButtonsToAdd)) {
    throw new Error(['*modeBarButtonsToAdd* configuration options', 'must be an array.'].join(' '));
  }
  var customButtons = context.modeBarButtons;
  var buttonGroups;
  if (Array.isArray(customButtons) && customButtons.length) {
    buttonGroups = fillCustomButton(customButtons);
  } else if (!context.displayModeBar && context.watermark) {
    buttonGroups = [];
  } else {
    buttonGroups = getButtonGroups(gd);
  }
  if (modeBar) modeBar.update(gd, buttonGroups);else fullLayout._modeBar = createModeBar(gd, buttonGroups);
};

// logic behind which buttons are displayed by default
function getButtonGroups(gd) {
  var fullLayout = gd._fullLayout;
  var fullData = gd._fullData;
  var context = gd._context;
  function match(name, B) {
    if (typeof B === 'string') {
      if (B.toLowerCase() === name.toLowerCase()) return true;
    } else {
      var v0 = B.name;
      var v1 = B._cat || B.name;
      if (v0 === name || v1 === name.toLowerCase()) return true;
    }
    return false;
  }
  var layoutAdd = fullLayout.modebar.add;
  if (typeof layoutAdd === 'string') layoutAdd = [layoutAdd];
  var layoutRemove = fullLayout.modebar.remove;
  if (typeof layoutRemove === 'string') layoutRemove = [layoutRemove];
  var buttonsToAdd = context.modeBarButtonsToAdd.concat(layoutAdd.filter(function (e) {
    for (var i = 0; i < context.modeBarButtonsToRemove.length; i++) {
      if (match(e, context.modeBarButtonsToRemove[i])) return false;
    }
    return true;
  }));
  var buttonsToRemove = context.modeBarButtonsToRemove.concat(layoutRemove.filter(function (e) {
    for (var i = 0; i < context.modeBarButtonsToAdd.length; i++) {
      if (match(e, context.modeBarButtonsToAdd[i])) return false;
    }
    return true;
  }));
  var hasCartesian = fullLayout._has('cartesian');
  var hasGL3D = fullLayout._has('gl3d');
  var hasGeo = fullLayout._has('geo');
  var hasPie = fullLayout._has('pie');
  var hasFunnelarea = fullLayout._has('funnelarea');
  var hasGL2D = fullLayout._has('gl2d');
  var hasTernary = fullLayout._has('ternary');
  var hasMapbox = fullLayout._has('mapbox');
  var hasMap = fullLayout._has('map');
  var hasPolar = fullLayout._has('polar');
  var hasSmith = fullLayout._has('smith');
  var hasSankey = fullLayout._has('sankey');
  var allAxesFixed = areAllAxesFixed(fullLayout);
  var hasUnifiedHoverLabel = isUnifiedHover(fullLayout.hovermode);
  var groups = [];
  function addGroup(newGroup) {
    if (!newGroup.length) return;
    var out = [];
    for (var i = 0; i < newGroup.length; i++) {
      var name = newGroup[i];
      var B = modeBarButtons[name];
      var v0 = B.name.toLowerCase();
      var v1 = (B._cat || B.name).toLowerCase();
      var found = false;
      for (var q = 0; q < buttonsToRemove.length; q++) {
        var t = buttonsToRemove[q].toLowerCase();
        if (t === v0 || t === v1) {
          found = true;
          break;
        }
      }
      if (found) continue;
      out.push(modeBarButtons[name]);
    }
    groups.push(out);
  }

  // buttons common to all plot types
  var commonGroup = ['toImage'];
  if (context.showEditInChartStudio) commonGroup.push('editInChartStudio');else if (context.showSendToCloud) commonGroup.push('sendDataToCloud');
  addGroup(commonGroup);
  var zoomGroup = [];
  var hoverGroup = [];
  var resetGroup = [];
  var dragModeGroup = [];
  if ((hasCartesian || hasGL2D || hasPie || hasFunnelarea || hasTernary) + hasGeo + hasGL3D + hasMapbox + hasMap + hasPolar + hasSmith > 1) {
    // graphs with more than one plot types get 'union buttons'
    // which reset the view or toggle hover labels across all subplots.
    hoverGroup = ['toggleHover'];
    resetGroup = ['resetViews'];
  } else if (hasGeo) {
    zoomGroup = ['zoomInGeo', 'zoomOutGeo'];
    hoverGroup = ['hoverClosestGeo'];
    resetGroup = ['resetGeo'];
  } else if (hasGL3D) {
    hoverGroup = ['hoverClosest3d'];
    resetGroup = ['resetCameraDefault3d', 'resetCameraLastSave3d'];
  } else if (hasMapbox) {
    zoomGroup = ['zoomInMapbox', 'zoomOutMapbox'];
    hoverGroup = ['toggleHover'];
    resetGroup = ['resetViewMapbox'];
  } else if (hasMap) {
    zoomGroup = ['zoomInMap', 'zoomOutMap'];
    hoverGroup = ['toggleHover'];
    resetGroup = ['resetViewMap'];
  } else if (hasGL2D) {
    hoverGroup = ['hoverClosestGl2d'];
  } else if (hasPie) {
    hoverGroup = ['hoverClosestPie'];
  } else if (hasSankey) {
    hoverGroup = ['hoverClosestCartesian', 'hoverCompareCartesian'];
    resetGroup = ['resetViewSankey'];
  } else {
    // hasPolar, hasSmith, hasTernary
    // always show at least one hover icon.
    hoverGroup = ['toggleHover'];
  }
  // if we have cartesian, allow switching between closest and compare
  // regardless of what other types are on the plot, since they'll all
  // just treat any truthy hovermode as 'closest'
  if (hasCartesian) {
    hoverGroup.push('toggleSpikelines', 'hoverClosestCartesian', 'hoverCompareCartesian');
  }
  if (hasNoHover(fullData) || hasUnifiedHoverLabel) {
    hoverGroup = [];
  }
  if ((hasCartesian || hasGL2D) && !allAxesFixed) {
    zoomGroup = ['zoomIn2d', 'zoomOut2d', 'autoScale2d'];
    if (resetGroup[0] !== 'resetViews') resetGroup = ['resetScale2d'];
  }
  if (hasGL3D) {
    dragModeGroup = ['zoom3d', 'pan3d', 'orbitRotation', 'tableRotation'];
  } else if ((hasCartesian || hasGL2D) && !allAxesFixed || hasTernary) {
    dragModeGroup = ['zoom2d', 'pan2d'];
  } else if (hasMapbox || hasMap || hasGeo) {
    dragModeGroup = ['pan2d'];
  } else if (hasPolar) {
    dragModeGroup = ['zoom2d'];
  }
  if (isSelectable(fullData)) {
    dragModeGroup.push('select2d', 'lasso2d');
  }
  var enabledHoverGroup = [];
  var enableHover = function (a) {
    // return if already added
    if (enabledHoverGroup.indexOf(a) !== -1) return;
    // should be in hoverGroup
    if (hoverGroup.indexOf(a) !== -1) {
      enabledHoverGroup.push(a);
    }
  };
  if (Array.isArray(buttonsToAdd)) {
    var newList = [];
    for (var i = 0; i < buttonsToAdd.length; i++) {
      var b = buttonsToAdd[i];
      if (typeof b === 'string') {
        b = b.toLowerCase();
        if (DRAW_MODES.indexOf(b) !== -1) {
          // accept pre-defined drag modes i.e. shape drawing features as string
          if (fullLayout._has('mapbox') || fullLayout._has('map') ||
          // draw shapes in paper coordinate (could be improved in future to support data coordinate, when there is no pitch)
          fullLayout._has('cartesian') // draw shapes in data coordinate
          ) {
            dragModeGroup.push(b);
          }
        } else if (b === 'togglespikelines') {
          enableHover('toggleSpikelines');
        } else if (b === 'togglehover') {
          enableHover('toggleHover');
        } else if (b === 'hovercompare') {
          enableHover('hoverCompareCartesian');
        } else if (b === 'hoverclosest') {
          enableHover('hoverClosestCartesian');
          enableHover('hoverClosestGeo');
          enableHover('hoverClosest3d');
          enableHover('hoverClosestGl2d');
          enableHover('hoverClosestPie');
        } else if (b === 'v1hovermode') {
          enableHover('hoverClosestCartesian');
          enableHover('hoverCompareCartesian');
          enableHover('hoverClosestGeo');
          enableHover('hoverClosest3d');
          enableHover('hoverClosestGl2d');
          enableHover('hoverClosestPie');
        }
      } else newList.push(b);
    }
    buttonsToAdd = newList;
  }
  addGroup(dragModeGroup);
  addGroup(zoomGroup.concat(resetGroup));
  addGroup(enabledHoverGroup);
  return appendButtonsToGroups(groups, buttonsToAdd);
}
function areAllAxesFixed(fullLayout) {
  var axList = axisIds.list({
    _fullLayout: fullLayout
  }, null, true);
  for (var i = 0; i < axList.length; i++) {
    if (!axList[i].fixedrange) {
      return false;
    }
  }
  return true;
}

// look for traces that support selection
// to be updated as we add more selectPoints handlers
function isSelectable(fullData) {
  var selectable = false;
  for (var i = 0; i < fullData.length; i++) {
    if (selectable) break;
    var trace = fullData[i];
    if (!trace._module || !trace._module.selectPoints) continue;
    if (Registry.traceIs(trace, 'scatter-like')) {
      if (scatterSubTypes.hasMarkers(trace) || scatterSubTypes.hasText(trace)) {
        selectable = true;
      }
    } else if (Registry.traceIs(trace, 'box-violin')) {
      if (trace.boxpoints === 'all' || trace.points === 'all') {
        selectable = true;
      }
    } else {
      // assume that in general if the trace module has selectPoints,
      // then it's selectable. Scatter is an exception to this because it must
      // have markers or text, not just be a scatter type.

      selectable = true;
    }
  }
  return selectable;
}

// check whether all trace are 'noHover'
function hasNoHover(fullData) {
  for (var i = 0; i < fullData.length; i++) {
    if (!Registry.traceIs(fullData[i], 'noHover')) return false;
  }
  return true;
}
function appendButtonsToGroups(groups, buttons) {
  if (buttons.length) {
    if (Array.isArray(buttons[0])) {
      for (var i = 0; i < buttons.length; i++) {
        groups.push(buttons[i]);
      }
    } else groups.push(buttons);
  }
  return groups;
}

// fill in custom buttons referring to default mode bar buttons
function fillCustomButton(originalModeBarButtons) {
  var customButtons = extendDeep([], originalModeBarButtons);
  for (var i = 0; i < customButtons.length; i++) {
    var buttonGroup = customButtons[i];
    for (var j = 0; j < buttonGroup.length; j++) {
      var button = buttonGroup[j];
      if (typeof button === 'string') {
        if (modeBarButtons[button] !== undefined) {
          customButtons[i][j] = modeBarButtons[button];
        } else {
          throw new Error(['*modeBarButtons* configuration options', 'invalid button name'].join(' '));
        }
      }
    }
  }
  return customButtons;
}

/***/ }),

/***/ 85393:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var isNumeric = __webpack_require__(10721);
var Lib = __webpack_require__(34809);
var Icons = __webpack_require__(35188);
var version = (__webpack_require__(29697).version);
var Parser = new DOMParser();

/**
 * UI controller for interactive plots
 * @Class
 * @Param {object} opts
 * @Param {object} opts.buttons    nested arrays of grouped buttons config objects
 * @Param {object} opts.container  container div to append modeBar
 * @Param {object} opts.graphInfo  primary plot object containing data and layout
 */
function ModeBar(opts) {
  this.container = opts.container;
  this.element = document.createElement('div');
  this.update(opts.graphInfo, opts.buttons);
  this.container.appendChild(this.element);
}
var proto = ModeBar.prototype;

/**
 * Update modeBar (buttons and logo)
 *
 * @param {object} graphInfo  primary plot object containing data and layout
 * @param {array of arrays} buttons nested arrays of grouped buttons to initialize
 *
 */
proto.update = function (graphInfo, buttons) {
  this.graphInfo = graphInfo;
  var context = this.graphInfo._context;
  var fullLayout = this.graphInfo._fullLayout;
  var modeBarId = 'modebar-' + fullLayout._uid;
  this.element.setAttribute('id', modeBarId);
  this._uid = modeBarId;
  this.element.className = 'modebar';
  if (context.displayModeBar === 'hover') this.element.className += ' modebar--hover ease-bg';
  if (fullLayout.modebar.orientation === 'v') {
    this.element.className += ' vertical';
    buttons = buttons.reverse();
  }
  var style = fullLayout.modebar;
  var bgSelector = context.displayModeBar === 'hover' ? '.js-plotly-plot .plotly:hover ' : '';
  Lib.deleteRelatedStyleRule(modeBarId);
  Lib.addRelatedStyleRule(modeBarId, bgSelector + '#' + modeBarId + ' .modebar-group', 'background-color: ' + style.bgcolor);
  Lib.addRelatedStyleRule(modeBarId, '#' + modeBarId + ' .modebar-btn .icon path', 'fill: ' + style.color);
  Lib.addRelatedStyleRule(modeBarId, '#' + modeBarId + ' .modebar-btn:hover .icon path', 'fill: ' + style.activecolor);
  Lib.addRelatedStyleRule(modeBarId, '#' + modeBarId + ' .modebar-btn.active .icon path', 'fill: ' + style.activecolor);

  // if buttons or logo have changed, redraw modebar interior
  var needsNewButtons = !this.hasButtons(buttons);
  var needsNewLogo = this.hasLogo !== context.displaylogo;
  var needsNewLocale = this.locale !== context.locale;
  this.locale = context.locale;
  if (needsNewButtons || needsNewLogo || needsNewLocale) {
    this.removeAllButtons();
    this.updateButtons(buttons);
    if (context.watermark || context.displaylogo) {
      var logoGroup = this.getLogo();
      if (context.watermark) {
        logoGroup.className = logoGroup.className + ' watermark';
      }
      if (fullLayout.modebar.orientation === 'v') {
        this.element.insertBefore(logoGroup, this.element.childNodes[0]);
      } else {
        this.element.appendChild(logoGroup);
      }
      this.hasLogo = true;
    }
  }
  this.updateActiveButton();
};
proto.updateButtons = function (buttons) {
  var _this = this;
  this.buttons = buttons;
  this.buttonElements = [];
  this.buttonsNames = [];
  this.buttons.forEach(function (buttonGroup) {
    var group = _this.createGroup();
    buttonGroup.forEach(function (buttonConfig) {
      var buttonName = buttonConfig.name;
      if (!buttonName) {
        throw new Error('must provide button \'name\' in button config');
      }
      if (_this.buttonsNames.indexOf(buttonName) !== -1) {
        throw new Error('button name \'' + buttonName + '\' is taken');
      }
      _this.buttonsNames.push(buttonName);
      var button = _this.createButton(buttonConfig);
      _this.buttonElements.push(button);
      group.appendChild(button);
    });
    _this.element.appendChild(group);
  });
};

/**
 * Empty div for containing a group of buttons
 * @Return {HTMLelement}
 */
proto.createGroup = function () {
  var group = document.createElement('div');
  group.className = 'modebar-group';
  return group;
};

/**
 * Create a new button div and set constant and configurable attributes
 * @Param {object} config (see ./buttons.js for more info)
 * @Return {HTMLelement}
 */
proto.createButton = function (config) {
  var _this = this;
  var button = document.createElement('a');
  button.setAttribute('rel', 'tooltip');
  button.className = 'modebar-btn';
  var title = config.title;
  if (title === undefined) title = config.name;
  // for localization: allow title to be a callable that takes gd as arg
  else if (typeof title === 'function') title = title(this.graphInfo);
  if (title || title === 0) button.setAttribute('data-title', title);
  if (config.attr !== undefined) button.setAttribute('data-attr', config.attr);
  var val = config.val;
  if (val !== undefined) {
    if (typeof val === 'function') val = val(this.graphInfo);
    button.setAttribute('data-val', val);
  }
  var click = config.click;
  if (typeof click !== 'function') {
    throw new Error('must provide button \'click\' function in button config');
  } else {
    button.addEventListener('click', function (ev) {
      config.click(_this.graphInfo, ev);

      // only needed for 'hoverClosestGeo' which does not call relayout
      _this.updateActiveButton(ev.currentTarget);
    });
  }
  button.setAttribute('data-toggle', config.toggle || false);
  if (config.toggle) d3.select(button).classed('active', true);
  var icon = config.icon;
  if (typeof icon === 'function') {
    button.appendChild(icon());
  } else {
    button.appendChild(this.createIcon(icon || Icons.question));
  }
  button.setAttribute('data-gravity', config.gravity || 'n');
  return button;
};

/**
 * Add an icon to a button
 * @Param {object} thisIcon
 * @Param {number} thisIcon.width
 * @Param {string} thisIcon.path
 * @Param {string} thisIcon.color
 * @Return {HTMLelement}
 */
proto.createIcon = function (thisIcon) {
  var iconHeight = isNumeric(thisIcon.height) ? Number(thisIcon.height) : thisIcon.ascent - thisIcon.descent;
  var svgNS = 'http://www.w3.org/2000/svg';
  var icon;
  if (thisIcon.path) {
    icon = document.createElementNS(svgNS, 'svg');
    icon.setAttribute('viewBox', [0, 0, thisIcon.width, iconHeight].join(' '));
    icon.setAttribute('class', 'icon');
    var path = document.createElementNS(svgNS, 'path');
    path.setAttribute('d', thisIcon.path);
    if (thisIcon.transform) {
      path.setAttribute('transform', thisIcon.transform);
    } else if (thisIcon.ascent !== undefined) {
      // Legacy icon transform calculation
      path.setAttribute('transform', 'matrix(1 0 0 -1 0 ' + thisIcon.ascent + ')');
    }
    icon.appendChild(path);
  }
  if (thisIcon.svg) {
    var svgDoc = Parser.parseFromString(thisIcon.svg, 'application/xml');
    icon = svgDoc.childNodes[0];
  }
  icon.setAttribute('height', '1em');
  icon.setAttribute('width', '1em');
  return icon;
};

/**
 * Updates active button with attribute specified in layout
 * @Param {object} graphInfo plot object containing data and layout
 * @Return {HTMLelement}
 */
proto.updateActiveButton = function (buttonClicked) {
  var fullLayout = this.graphInfo._fullLayout;
  var dataAttrClicked = buttonClicked !== undefined ? buttonClicked.getAttribute('data-attr') : null;
  this.buttonElements.forEach(function (button) {
    var thisval = button.getAttribute('data-val') || true;
    var dataAttr = button.getAttribute('data-attr');
    var isToggleButton = button.getAttribute('data-toggle') === 'true';
    var button3 = d3.select(button);

    // Use 'data-toggle' and 'buttonClicked' to toggle buttons
    // that have no one-to-one equivalent in fullLayout
    if (isToggleButton) {
      if (dataAttr === dataAttrClicked) {
        button3.classed('active', !button3.classed('active'));
      }
    } else {
      var val = dataAttr === null ? dataAttr : Lib.nestedProperty(fullLayout, dataAttr).get();
      button3.classed('active', val === thisval);
    }
  });
};

/**
 * Check if modeBar is configured as button configuration argument
 *
 * @Param {object} buttons 2d array of grouped button config objects
 * @Return {boolean}
 */
proto.hasButtons = function (buttons) {
  var currentButtons = this.buttons;
  if (!currentButtons) return false;
  if (buttons.length !== currentButtons.length) return false;
  for (var i = 0; i < buttons.length; ++i) {
    if (buttons[i].length !== currentButtons[i].length) return false;
    for (var j = 0; j < buttons[i].length; j++) {
      if (buttons[i][j].name !== currentButtons[i][j].name) return false;
    }
  }
  return true;
};
function jsVersion(str) {
  return str + ' (v' + version + ')';
}

/**
 * @return {HTMLDivElement} The logo image wrapped in a group
 */
proto.getLogo = function () {
  var group = this.createGroup();
  var a = document.createElement('a');
  a.href = 'https://plotly.com/';
  a.target = '_blank';
  a.setAttribute('data-title', jsVersion(Lib._(this.graphInfo, 'Produced with Plotly.js')));
  a.className = 'modebar-btn plotlyjsicon modebar-btn--logo';
  a.appendChild(this.createIcon(Icons.newplotlylogo));
  group.appendChild(a);
  return group;
};
proto.removeAllButtons = function () {
  while (this.element.firstChild) {
    this.element.removeChild(this.element.firstChild);
  }
  this.hasLogo = false;
};
proto.destroy = function () {
  Lib.removeElement(this.container.querySelector('.modebar'));
  Lib.deleteRelatedStyleRule(this._uid);
};
function createModeBar(gd, buttons) {
  var fullLayout = gd._fullLayout;
  var modeBar = new ModeBar({
    graphInfo: gd,
    container: fullLayout._modebardiv.node(),
    buttons: buttons
  });
  if (fullLayout._privateplot) {
    d3.select(modeBar.element).append('span').classed('badge-private float--left', true).text('PRIVATE');
  }
  return modeBar;
}
module.exports = createModeBar;

/***/ }),

/***/ 91032:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var fontAttrs = __webpack_require__(80337);
var colorAttrs = __webpack_require__(10229);
var templatedArray = (__webpack_require__(78032).templatedArray);
var buttonAttrs = templatedArray('button', {
  visible: {
    valType: 'boolean',
    dflt: true,
    editType: 'plot'
  },
  step: {
    valType: 'enumerated',
    values: ['month', 'year', 'day', 'hour', 'minute', 'second', 'all'],
    dflt: 'month',
    editType: 'plot'
  },
  stepmode: {
    valType: 'enumerated',
    values: ['backward', 'todate'],
    dflt: 'backward',
    editType: 'plot'
  },
  count: {
    valType: 'number',
    min: 0,
    dflt: 1,
    editType: 'plot'
  },
  label: {
    valType: 'string',
    editType: 'plot'
  },
  editType: 'plot'
});
module.exports = {
  visible: {
    valType: 'boolean',
    editType: 'plot'
  },
  buttons: buttonAttrs,
  x: {
    valType: 'number',
    min: -2,
    max: 3,
    editType: 'plot'
  },
  xanchor: {
    valType: 'enumerated',
    values: ['auto', 'left', 'center', 'right'],
    dflt: 'left',
    editType: 'plot'
  },
  y: {
    valType: 'number',
    min: -2,
    max: 3,
    editType: 'plot'
  },
  yanchor: {
    valType: 'enumerated',
    values: ['auto', 'top', 'middle', 'bottom'],
    dflt: 'bottom',
    editType: 'plot'
  },
  font: fontAttrs({
    editType: 'plot'
  }),
  bgcolor: {
    valType: 'color',
    dflt: colorAttrs.lightLine,
    editType: 'plot'
  },
  activecolor: {
    valType: 'color',
    editType: 'plot'
  },
  bordercolor: {
    valType: 'color',
    dflt: colorAttrs.defaultLine,
    editType: 'plot'
  },
  borderwidth: {
    valType: 'number',
    min: 0,
    dflt: 0,
    editType: 'plot'
  },
  editType: 'plot'
};

/***/ }),

/***/ 68508:
/***/ (function(module) {

"use strict";


module.exports = {
  // 'y' position pad above counter axis domain
  yPad: 0.02,
  // minimum button width (regardless of text size)
  minButtonWidth: 30,
  // buttons rect radii
  rx: 3,
  ry: 3,
  // light fraction used to compute the 'activecolor' default
  lightAmount: 25,
  darkAmount: 10
};

/***/ }),

/***/ 86255:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var Color = __webpack_require__(78766);
var Template = __webpack_require__(78032);
var handleArrayContainerDefaults = __webpack_require__(59008);
var attributes = __webpack_require__(91032);
var constants = __webpack_require__(68508);
module.exports = function handleDefaults(containerIn, containerOut, layout, counterAxes, calendar) {
  var selectorIn = containerIn.rangeselector || {};
  var selectorOut = Template.newContainer(containerOut, 'rangeselector');
  function coerce(attr, dflt) {
    return Lib.coerce(selectorIn, selectorOut, attributes, attr, dflt);
  }
  var buttons = handleArrayContainerDefaults(selectorIn, selectorOut, {
    name: 'buttons',
    handleItemDefaults: buttonDefaults,
    calendar: calendar
  });
  var visible = coerce('visible', buttons.length > 0);
  if (visible) {
    var posDflt = getPosDflt(containerOut, layout, counterAxes);
    coerce('x', posDflt[0]);
    coerce('y', posDflt[1]);
    Lib.noneOrAll(containerIn, containerOut, ['x', 'y']);
    coerce('xanchor');
    coerce('yanchor');
    Lib.coerceFont(coerce, 'font', layout.font);
    var bgColor = coerce('bgcolor');
    coerce('activecolor', Color.contrast(bgColor, constants.lightAmount, constants.darkAmount));
    coerce('bordercolor');
    coerce('borderwidth');
  }
};
function buttonDefaults(buttonIn, buttonOut, selectorOut, opts) {
  var calendar = opts.calendar;
  function coerce(attr, dflt) {
    return Lib.coerce(buttonIn, buttonOut, attributes.buttons, attr, dflt);
  }
  var visible = coerce('visible');
  if (visible) {
    var step = coerce('step');
    if (step !== 'all') {
      if (calendar && calendar !== 'gregorian' && (step === 'month' || step === 'year')) {
        buttonOut.stepmode = 'backward';
      } else {
        coerce('stepmode');
      }
      coerce('count');
    }
    coerce('label');
  }
}
function getPosDflt(containerOut, layout, counterAxes) {
  var anchoredList = counterAxes.filter(function (ax) {
    return layout[ax].anchor === containerOut._id;
  });
  var posY = 0;
  for (var i = 0; i < anchoredList.length; i++) {
    var domain = layout[anchoredList[i]].domain;
    if (domain) posY = Math.max(domain[1], posY);
  }
  return [containerOut.domain[0], posY + constants.yPad];
}

/***/ }),

/***/ 45431:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var Registry = __webpack_require__(33626);
var Plots = __webpack_require__(44122);
var Color = __webpack_require__(78766);
var Drawing = __webpack_require__(62203);
var Lib = __webpack_require__(34809);
var strTranslate = Lib.strTranslate;
var svgTextUtils = __webpack_require__(30635);
var axisIds = __webpack_require__(5975);
var alignmentConstants = __webpack_require__(4530);
var LINE_SPACING = alignmentConstants.LINE_SPACING;
var FROM_TL = alignmentConstants.FROM_TL;
var FROM_BR = alignmentConstants.FROM_BR;
var constants = __webpack_require__(68508);
var getUpdateObject = __webpack_require__(16383);
module.exports = function draw(gd) {
  var fullLayout = gd._fullLayout;
  var selectors = fullLayout._infolayer.selectAll('.rangeselector').data(makeSelectorData(gd), selectorKeyFunc);
  selectors.enter().append('g').classed('rangeselector', true);
  selectors.exit().remove();
  selectors.style({
    cursor: 'pointer',
    'pointer-events': 'all'
  });
  selectors.each(function (d) {
    var selector = d3.select(this);
    var axisLayout = d;
    var selectorLayout = axisLayout.rangeselector;
    var buttons = selector.selectAll('g.button').data(Lib.filterVisible(selectorLayout.buttons));
    buttons.enter().append('g').classed('button', true);
    buttons.exit().remove();
    buttons.each(function (d) {
      var button = d3.select(this);
      var update = getUpdateObject(axisLayout, d);
      d._isActive = isActive(axisLayout, d, update);
      button.call(drawButtonRect, selectorLayout, d);
      button.call(drawButtonText, selectorLayout, d, gd);
      button.on('click', function () {
        if (gd._dragged) return;
        Registry.call('_guiRelayout', gd, update);
      });
      button.on('mouseover', function () {
        d._isHovered = true;
        button.call(drawButtonRect, selectorLayout, d);
      });
      button.on('mouseout', function () {
        d._isHovered = false;
        button.call(drawButtonRect, selectorLayout, d);
      });
    });
    reposition(gd, buttons, selectorLayout, axisLayout._name, selector);
  });
};
function makeSelectorData(gd) {
  var axes = axisIds.list(gd, 'x', true);
  var data = [];
  for (var i = 0; i < axes.length; i++) {
    var axis = axes[i];
    if (axis.rangeselector && axis.rangeselector.visible) {
      data.push(axis);
    }
  }
  return data;
}
function selectorKeyFunc(d) {
  return d._id;
}
function isActive(axisLayout, opts, update) {
  if (opts.step === 'all') {
    return axisLayout.autorange === true;
  } else {
    var keys = Object.keys(update);
    return axisLayout.range[0] === update[keys[0]] && axisLayout.range[1] === update[keys[1]];
  }
}
function drawButtonRect(button, selectorLayout, d) {
  var rect = Lib.ensureSingle(button, 'rect', 'selector-rect', function (s) {
    s.attr('shape-rendering', 'crispEdges');
  });
  rect.attr({
    rx: constants.rx,
    ry: constants.ry
  });
  rect.call(Color.stroke, selectorLayout.bordercolor).call(Color.fill, getFillColor(selectorLayout, d)).style('stroke-width', selectorLayout.borderwidth + 'px');
}
function getFillColor(selectorLayout, d) {
  return d._isActive || d._isHovered ? selectorLayout.activecolor : selectorLayout.bgcolor;
}
function drawButtonText(button, selectorLayout, d, gd) {
  function textLayout(s) {
    svgTextUtils.convertToTspans(s, gd);
  }
  var text = Lib.ensureSingle(button, 'text', 'selector-text', function (s) {
    s.attr('text-anchor', 'middle');
  });
  text.call(Drawing.font, selectorLayout.font).text(getLabel(d, gd._fullLayout._meta)).call(textLayout);
}
function getLabel(opts, _meta) {
  if (opts.label) {
    return _meta ? Lib.templateString(opts.label, _meta) : opts.label;
  }
  if (opts.step === 'all') return 'all';
  return opts.count + opts.step.charAt(0);
}
function reposition(gd, buttons, opts, axName, selector) {
  var width = 0;
  var height = 0;
  var borderWidth = opts.borderwidth;
  buttons.each(function () {
    var button = d3.select(this);
    var text = button.select('.selector-text');
    var tHeight = opts.font.size * LINE_SPACING;
    var hEff = Math.max(tHeight * svgTextUtils.lineCount(text), 16) + 3;
    height = Math.max(height, hEff);
  });
  buttons.each(function () {
    var button = d3.select(this);
    var rect = button.select('.selector-rect');
    var text = button.select('.selector-text');
    var tWidth = text.node() && Drawing.bBox(text.node()).width;
    var tHeight = opts.font.size * LINE_SPACING;
    var tLines = svgTextUtils.lineCount(text);
    var wEff = Math.max(tWidth + 10, constants.minButtonWidth);

    // TODO add MathJax support

    // TODO add buttongap attribute

    button.attr('transform', strTranslate(borderWidth + width, borderWidth));
    rect.attr({
      x: 0,
      y: 0,
      width: wEff,
      height: height
    });
    svgTextUtils.positionText(text, wEff / 2, height / 2 - (tLines - 1) * tHeight / 2 + 3);
    width += wEff + 5;
  });
  var graphSize = gd._fullLayout._size;
  var lx = graphSize.l + graphSize.w * opts.x;
  var ly = graphSize.t + graphSize.h * (1 - opts.y);
  var xanchor = 'left';
  if (Lib.isRightAnchor(opts)) {
    lx -= width;
    xanchor = 'right';
  }
  if (Lib.isCenterAnchor(opts)) {
    lx -= width / 2;
    xanchor = 'center';
  }
  var yanchor = 'top';
  if (Lib.isBottomAnchor(opts)) {
    ly -= height;
    yanchor = 'bottom';
  }
  if (Lib.isMiddleAnchor(opts)) {
    ly -= height / 2;
    yanchor = 'middle';
  }
  width = Math.ceil(width);
  height = Math.ceil(height);
  lx = Math.round(lx);
  ly = Math.round(ly);
  Plots.autoMargin(gd, axName + '-range-selector', {
    x: opts.x,
    y: opts.y,
    l: width * FROM_TL[xanchor],
    r: width * FROM_BR[xanchor],
    b: height * FROM_BR[yanchor],
    t: height * FROM_TL[yanchor]
  });
  selector.attr('transform', strTranslate(lx, ly));
}

/***/ }),

/***/ 16383:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3Time = __webpack_require__(50936);
var titleCase = (__webpack_require__(34809).titleCase);
module.exports = function getUpdateObject(axisLayout, buttonLayout) {
  var axName = axisLayout._name;
  var update = {};
  if (buttonLayout.step === 'all') {
    update[axName + '.autorange'] = true;
  } else {
    var xrange = getXRange(axisLayout, buttonLayout);
    update[axName + '.range[0]'] = xrange[0];
    update[axName + '.range[1]'] = xrange[1];
  }
  return update;
};
function getXRange(axisLayout, buttonLayout) {
  var currentRange = axisLayout.range;
  var base = new Date(axisLayout.r2l(currentRange[1]));
  var step = buttonLayout.step;
  var utcStep = d3Time['utc' + titleCase(step)];
  var count = buttonLayout.count;
  var range0;
  switch (buttonLayout.stepmode) {
    case 'backward':
      range0 = axisLayout.l2r(+utcStep.offset(base, -count));
      break;
    case 'todate':
      var base2 = utcStep.offset(base, -count);
      range0 = axisLayout.l2r(+utcStep.ceil(base2));
      break;
  }
  var range1 = currentRange[1];
  return [range0, range1];
}

/***/ }),

/***/ 44453:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = {
  moduleType: 'component',
  name: 'rangeselector',
  schema: {
    subplots: {
      xaxis: {
        rangeselector: __webpack_require__(91032)
      }
    }
  },
  layoutAttributes: __webpack_require__(91032),
  handleDefaults: __webpack_require__(86255),
  draw: __webpack_require__(45431)
};

/***/ }),

/***/ 63608:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var colorAttributes = __webpack_require__(10229);
module.exports = {
  bgcolor: {
    valType: 'color',
    dflt: colorAttributes.background,
    editType: 'plot'
  },
  bordercolor: {
    valType: 'color',
    dflt: colorAttributes.defaultLine,
    editType: 'plot'
  },
  borderwidth: {
    valType: 'integer',
    dflt: 0,
    min: 0,
    editType: 'plot'
  },
  autorange: {
    valType: 'boolean',
    dflt: true,
    editType: 'calc',
    impliedEdits: {
      'range[0]': undefined,
      'range[1]': undefined
    }
  },
  range: {
    valType: 'info_array',
    items: [{
      valType: 'any',
      editType: 'calc',
      impliedEdits: {
        '^autorange': false
      }
    }, {
      valType: 'any',
      editType: 'calc',
      impliedEdits: {
        '^autorange': false
      }
    }],
    editType: 'calc',
    impliedEdits: {
      autorange: false
    }
  },
  thickness: {
    valType: 'number',
    dflt: 0.15,
    min: 0,
    max: 1,
    editType: 'plot'
  },
  visible: {
    valType: 'boolean',
    dflt: true,
    editType: 'calc'
  },
  editType: 'calc'
};

/***/ }),

/***/ 46223:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var listAxes = (__webpack_require__(5975).list);
var getAutoRange = (__webpack_require__(32919).getAutoRange);
var constants = __webpack_require__(20604);
module.exports = function calcAutorange(gd) {
  var axes = listAxes(gd, 'x', true);

  // Compute new slider range using axis autorange if necessary.
  //
  // Copy back range to input range slider container to skip
  // this step in subsequent draw calls.

  for (var i = 0; i < axes.length; i++) {
    var ax = axes[i];
    var opts = ax[constants.name];
    if (opts && opts.visible && opts.autorange) {
      opts._input.autorange = true;
      opts._input.range = opts.range = getAutoRange(gd, ax);
    }
  }
};

/***/ }),

/***/ 20604:
/***/ (function(module) {

"use strict";


module.exports = {
  // attribute container name
  name: 'rangeslider',
  // class names

  containerClassName: 'rangeslider-container',
  bgClassName: 'rangeslider-bg',
  rangePlotClassName: 'rangeslider-rangeplot',
  maskMinClassName: 'rangeslider-mask-min',
  maskMaxClassName: 'rangeslider-mask-max',
  slideBoxClassName: 'rangeslider-slidebox',
  grabberMinClassName: 'rangeslider-grabber-min',
  grabAreaMinClassName: 'rangeslider-grabarea-min',
  handleMinClassName: 'rangeslider-handle-min',
  grabberMaxClassName: 'rangeslider-grabber-max',
  grabAreaMaxClassName: 'rangeslider-grabarea-max',
  handleMaxClassName: 'rangeslider-handle-max',
  maskMinOppAxisClassName: 'rangeslider-mask-min-opp-axis',
  maskMaxOppAxisClassName: 'rangeslider-mask-max-opp-axis',
  // style constants

  maskColor: 'rgba(0,0,0,0.4)',
  maskOppAxisColor: 'rgba(0,0,0,0.2)',
  slideBoxFill: 'transparent',
  slideBoxCursor: 'ew-resize',
  grabAreaFill: 'transparent',
  grabAreaCursor: 'col-resize',
  grabAreaWidth: 10,
  handleWidth: 4,
  handleRadius: 1,
  handleStrokeWidth: 1,
  extraPad: 15
};

/***/ }),

/***/ 41295:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var Template = __webpack_require__(78032);
var axisIds = __webpack_require__(5975);
var attributes = __webpack_require__(63608);
var oppAxisAttrs = __webpack_require__(66249);
module.exports = function handleDefaults(layoutIn, layoutOut, axName) {
  var axIn = layoutIn[axName];
  var axOut = layoutOut[axName];
  if (!(axIn.rangeslider || layoutOut._requestRangeslider[axOut._id])) return;

  // not super proud of this (maybe store _ in axis object instead
  if (!Lib.isPlainObject(axIn.rangeslider)) {
    axIn.rangeslider = {};
  }
  var containerIn = axIn.rangeslider;
  var containerOut = Template.newContainer(axOut, 'rangeslider');
  function coerce(attr, dflt) {
    return Lib.coerce(containerIn, containerOut, attributes, attr, dflt);
  }
  var rangeContainerIn, rangeContainerOut;
  function coerceRange(attr, dflt) {
    return Lib.coerce(rangeContainerIn, rangeContainerOut, oppAxisAttrs, attr, dflt);
  }
  var visible = coerce('visible');
  if (!visible) return;
  coerce('bgcolor', layoutOut.plot_bgcolor);
  coerce('bordercolor');
  coerce('borderwidth');
  coerce('thickness');
  coerce('autorange', !axOut.isValidRange(containerIn.range));
  coerce('range');
  var subplots = layoutOut._subplots;
  if (subplots) {
    var yIds = subplots.cartesian.filter(function (subplotId) {
      return subplotId.substr(0, subplotId.indexOf('y')) === axisIds.name2id(axName);
    }).map(function (subplotId) {
      return subplotId.substr(subplotId.indexOf('y'), subplotId.length);
    });
    var yNames = Lib.simpleMap(yIds, axisIds.id2name);
    for (var i = 0; i < yNames.length; i++) {
      var yName = yNames[i];
      rangeContainerIn = containerIn[yName] || {};
      rangeContainerOut = Template.newContainer(containerOut, yName, 'yaxis');
      var yAxOut = layoutOut[yName];
      var rangemodeDflt;
      if (rangeContainerIn.range && yAxOut.isValidRange(rangeContainerIn.range)) {
        rangemodeDflt = 'fixed';
      }
      var rangeMode = coerceRange('rangemode', rangemodeDflt);
      if (rangeMode !== 'match') {
        coerceRange('range', yAxOut.range.slice());
      }
    }
  }

  // to map back range slider (auto) range
  containerOut._input = containerIn;
};

/***/ }),

/***/ 88887:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var Registry = __webpack_require__(33626);
var Plots = __webpack_require__(44122);
var Lib = __webpack_require__(34809);
var strTranslate = Lib.strTranslate;
var Drawing = __webpack_require__(62203);
var Color = __webpack_require__(78766);
var Titles = __webpack_require__(17240);
var Cartesian = __webpack_require__(37703);
var axisIDs = __webpack_require__(5975);
var dragElement = __webpack_require__(14751);
var setCursor = __webpack_require__(27983);
var constants = __webpack_require__(20604);
module.exports = function (gd) {
  var fullLayout = gd._fullLayout;
  var rangeSliderData = fullLayout._rangeSliderData;
  for (var i = 0; i < rangeSliderData.length; i++) {
    var opts = rangeSliderData[i][constants.name];
    // fullLayout._uid may not exist when we call makeData
    opts._clipId = opts._id + '-' + fullLayout._uid;
  }

  /*
   * <g container />
   *  <rect bg />
   *  < .... range plot />
   *  <rect mask-min />
   *  <rect mask-max />
   *  <rect slidebox />
   *  <g grabber-min />
   *      <rect handle-min />
   *      <rect grabare-min />
   *  <g grabber-max />
   *      <rect handle-max />
   *      <rect grabare-max />
   *
   *  ...
   */

  function keyFunction(axisOpts) {
    return axisOpts._name;
  }
  var rangeSliders = fullLayout._infolayer.selectAll('g.' + constants.containerClassName).data(rangeSliderData, keyFunction);

  // remove exiting sliders and their corresponding clip paths
  rangeSliders.exit().each(function (axisOpts) {
    var opts = axisOpts[constants.name];
    fullLayout._topdefs.select('#' + opts._clipId).remove();
  }).remove();

  // return early if no range slider is visible
  if (rangeSliderData.length === 0) return;
  rangeSliders.enter().append('g').classed(constants.containerClassName, true).attr('pointer-events', 'all');

  // for all present range sliders
  rangeSliders.each(function (axisOpts) {
    var rangeSlider = d3.select(this);
    var opts = axisOpts[constants.name];
    var oppAxisOpts = fullLayout[axisIDs.id2name(axisOpts.anchor)];
    var oppAxisRangeOpts = opts[axisIDs.id2name(axisOpts.anchor)];

    // update range
    // Expand slider range to the axis range
    if (opts.range) {
      var rng = Lib.simpleMap(opts.range, axisOpts.r2l);
      var axRng = Lib.simpleMap(axisOpts.range, axisOpts.r2l);
      var newRng;
      if (axRng[0] < axRng[1]) {
        newRng = [Math.min(rng[0], axRng[0]), Math.max(rng[1], axRng[1])];
      } else {
        newRng = [Math.max(rng[0], axRng[0]), Math.min(rng[1], axRng[1])];
      }
      opts.range = opts._input.range = Lib.simpleMap(newRng, axisOpts.l2r);
    }
    axisOpts.cleanRange('rangeslider.range');

    // update range slider dimensions

    var gs = fullLayout._size;
    var domain = axisOpts.domain;
    opts._width = gs.w * (domain[1] - domain[0]);
    var x = Math.round(gs.l + gs.w * domain[0]);
    var y = Math.round(gs.t + gs.h * (1 - axisOpts._counterDomainMin) + (axisOpts.side === 'bottom' ? axisOpts._depth : 0) + opts._offsetShift + constants.extraPad);
    rangeSlider.attr('transform', strTranslate(x, y));

    // update data <--> pixel coordinate conversion methods

    opts._rl = Lib.simpleMap(opts.range, axisOpts.r2l);
    var rl0 = opts._rl[0];
    var rl1 = opts._rl[1];
    var drl = rl1 - rl0;
    opts.p2d = function (v) {
      return v / opts._width * drl + rl0;
    };
    opts.d2p = function (v) {
      return (v - rl0) / drl * opts._width;
    };
    if (axisOpts.rangebreaks) {
      var rsBreaks = axisOpts.locateBreaks(rl0, rl1);
      if (rsBreaks.length) {
        var j, brk;
        var lBreaks = 0;
        for (j = 0; j < rsBreaks.length; j++) {
          brk = rsBreaks[j];
          lBreaks += brk.max - brk.min;
        }

        // TODO fix for reversed-range axes !!!

        // compute slope and piecewise offsets
        var m2 = opts._width / (rl1 - rl0 - lBreaks);
        var _B = [-m2 * rl0];
        for (j = 0; j < rsBreaks.length; j++) {
          brk = rsBreaks[j];
          _B.push(_B[_B.length - 1] - m2 * (brk.max - brk.min));
        }
        opts.d2p = function (v) {
          var b = _B[0];
          for (var j = 0; j < rsBreaks.length; j++) {
            var brk = rsBreaks[j];
            if (v >= brk.max) b = _B[j + 1];else if (v < brk.min) break;
          }
          return b + m2 * v;
        };

        // fill pixel (i.e. 'p') min/max here,
        // to not have to loop through the _rangebreaks twice during `p2d`
        for (j = 0; j < rsBreaks.length; j++) {
          brk = rsBreaks[j];
          brk.pmin = opts.d2p(brk.min);
          brk.pmax = opts.d2p(brk.max);
        }
        opts.p2d = function (v) {
          var b = _B[0];
          for (var j = 0; j < rsBreaks.length; j++) {
            var brk = rsBreaks[j];
            if (v >= brk.pmax) b = _B[j + 1];else if (v < brk.pmin) break;
          }
          return (v - b) / m2;
        };
      }
    }
    if (oppAxisRangeOpts.rangemode !== 'match') {
      var range0OppAxis = oppAxisOpts.r2l(oppAxisRangeOpts.range[0]);
      var range1OppAxis = oppAxisOpts.r2l(oppAxisRangeOpts.range[1]);
      var distOppAxis = range1OppAxis - range0OppAxis;
      opts.d2pOppAxis = function (v) {
        return (v - range0OppAxis) / distOppAxis * opts._height;
      };
    }

    // update inner nodes

    rangeSlider.call(drawBg, gd, axisOpts, opts).call(addClipPath, gd, axisOpts, opts).call(drawRangePlot, gd, axisOpts, opts).call(drawMasks, gd, axisOpts, opts, oppAxisRangeOpts).call(drawSlideBox, gd, axisOpts, opts).call(drawGrabbers, gd, axisOpts, opts);

    // setup drag element
    setupDragElement(rangeSlider, gd, axisOpts, opts);

    // update current range
    setPixelRange(rangeSlider, gd, axisOpts, opts, oppAxisOpts, oppAxisRangeOpts);

    // title goes next to range slider instead of tick labels, so
    // just take it over and draw it from here
    if (axisOpts.side === 'bottom') {
      Titles.draw(gd, axisOpts._id + 'title', {
        propContainer: axisOpts,
        propName: axisOpts._name + '.title',
        placeholder: fullLayout._dfltTitle.x,
        attributes: {
          x: axisOpts._offset + axisOpts._length / 2,
          y: y + opts._height + opts._offsetShift + 10 + 1.5 * axisOpts.title.font.size,
          'text-anchor': 'middle'
        }
      });
    }
  });
};
function eventX(event) {
  if (typeof event.clientX === 'number') {
    return event.clientX;
  }
  if (event.touches && event.touches.length > 0) {
    return event.touches[0].clientX;
  }
  return 0;
}
function setupDragElement(rangeSlider, gd, axisOpts, opts) {
  if (gd._context.staticPlot) return;
  var slideBox = rangeSlider.select('rect.' + constants.slideBoxClassName).node();
  var grabAreaMin = rangeSlider.select('rect.' + constants.grabAreaMinClassName).node();
  var grabAreaMax = rangeSlider.select('rect.' + constants.grabAreaMaxClassName).node();
  function mouseDownHandler() {
    var event = d3.event;
    var target = event.target;
    var startX = eventX(event);
    var offsetX = startX - rangeSlider.node().getBoundingClientRect().left;
    var minVal = opts.d2p(axisOpts._rl[0]);
    var maxVal = opts.d2p(axisOpts._rl[1]);
    var dragCover = dragElement.coverSlip();
    this.addEventListener('touchmove', mouseMove);
    this.addEventListener('touchend', mouseUp);
    dragCover.addEventListener('mousemove', mouseMove);
    dragCover.addEventListener('mouseup', mouseUp);
    function mouseMove(e) {
      var clientX = eventX(e);
      var delta = +clientX - startX;
      var pixelMin, pixelMax, cursor;
      switch (target) {
        case slideBox:
          cursor = 'ew-resize';
          if (minVal + delta > axisOpts._length || maxVal + delta < 0) {
            return;
          }
          pixelMin = minVal + delta;
          pixelMax = maxVal + delta;
          break;
        case grabAreaMin:
          cursor = 'col-resize';
          if (minVal + delta > axisOpts._length) {
            return;
          }
          pixelMin = minVal + delta;
          pixelMax = maxVal;
          break;
        case grabAreaMax:
          cursor = 'col-resize';
          if (maxVal + delta < 0) {
            return;
          }
          pixelMin = minVal;
          pixelMax = maxVal + delta;
          break;
        default:
          cursor = 'ew-resize';
          pixelMin = offsetX;
          pixelMax = offsetX + delta;
          break;
      }
      if (pixelMax < pixelMin) {
        var tmp = pixelMax;
        pixelMax = pixelMin;
        pixelMin = tmp;
      }
      opts._pixelMin = pixelMin;
      opts._pixelMax = pixelMax;
      setCursor(d3.select(dragCover), cursor);
      setDataRange(rangeSlider, gd, axisOpts, opts);
    }
    function mouseUp() {
      dragCover.removeEventListener('mousemove', mouseMove);
      dragCover.removeEventListener('mouseup', mouseUp);
      this.removeEventListener('touchmove', mouseMove);
      this.removeEventListener('touchend', mouseUp);
      Lib.removeElement(dragCover);
    }
  }
  rangeSlider.on('mousedown', mouseDownHandler);
  rangeSlider.on('touchstart', mouseDownHandler);
}
function setDataRange(rangeSlider, gd, axisOpts, opts) {
  function clamp(v) {
    return axisOpts.l2r(Lib.constrain(v, opts._rl[0], opts._rl[1]));
  }
  var dataMin = clamp(opts.p2d(opts._pixelMin));
  var dataMax = clamp(opts.p2d(opts._pixelMax));
  window.requestAnimationFrame(function () {
    Registry.call('_guiRelayout', gd, axisOpts._name + '.range', [dataMin, dataMax]);
  });
}
function setPixelRange(rangeSlider, gd, axisOpts, opts, oppAxisOpts, oppAxisRangeOpts) {
  var hw2 = constants.handleWidth / 2;
  function clamp(v) {
    return Lib.constrain(v, 0, opts._width);
  }
  function clampOppAxis(v) {
    return Lib.constrain(v, 0, opts._height);
  }
  function clampHandle(v) {
    return Lib.constrain(v, -hw2, opts._width + hw2);
  }
  var pixelMin = clamp(opts.d2p(axisOpts._rl[0]));
  var pixelMax = clamp(opts.d2p(axisOpts._rl[1]));
  rangeSlider.select('rect.' + constants.slideBoxClassName).attr('x', pixelMin).attr('width', pixelMax - pixelMin);
  rangeSlider.select('rect.' + constants.maskMinClassName).attr('width', pixelMin);
  rangeSlider.select('rect.' + constants.maskMaxClassName).attr('x', pixelMax).attr('width', opts._width - pixelMax);
  if (oppAxisRangeOpts.rangemode !== 'match') {
    var pixelMinOppAxis = opts._height - clampOppAxis(opts.d2pOppAxis(oppAxisOpts._rl[1]));
    var pixelMaxOppAxis = opts._height - clampOppAxis(opts.d2pOppAxis(oppAxisOpts._rl[0]));
    rangeSlider.select('rect.' + constants.maskMinOppAxisClassName).attr('x', pixelMin).attr('height', pixelMinOppAxis).attr('width', pixelMax - pixelMin);
    rangeSlider.select('rect.' + constants.maskMaxOppAxisClassName).attr('x', pixelMin).attr('y', pixelMaxOppAxis).attr('height', opts._height - pixelMaxOppAxis).attr('width', pixelMax - pixelMin);
    rangeSlider.select('rect.' + constants.slideBoxClassName).attr('y', pixelMinOppAxis).attr('height', pixelMaxOppAxis - pixelMinOppAxis);
  }

  // add offset for crispier corners
  // https://github.com/plotly/plotly.js/pull/1409
  var offset = 0.5;
  var xMin = Math.round(clampHandle(pixelMin - hw2)) - offset;
  var xMax = Math.round(clampHandle(pixelMax - hw2)) + offset;
  rangeSlider.select('g.' + constants.grabberMinClassName).attr('transform', strTranslate(xMin, offset));
  rangeSlider.select('g.' + constants.grabberMaxClassName).attr('transform', strTranslate(xMax, offset));
}
function drawBg(rangeSlider, gd, axisOpts, opts) {
  var bg = Lib.ensureSingle(rangeSlider, 'rect', constants.bgClassName, function (s) {
    s.attr({
      x: 0,
      y: 0,
      'shape-rendering': 'crispEdges'
    });
  });
  var borderCorrect = opts.borderwidth % 2 === 0 ? opts.borderwidth : opts.borderwidth - 1;
  var offsetShift = -opts._offsetShift;
  var lw = Drawing.crispRound(gd, opts.borderwidth);
  bg.attr({
    width: opts._width + borderCorrect,
    height: opts._height + borderCorrect,
    transform: strTranslate(offsetShift, offsetShift),
    'stroke-width': lw
  }).call(Color.stroke, opts.bordercolor).call(Color.fill, opts.bgcolor);
}
function addClipPath(rangeSlider, gd, axisOpts, opts) {
  var fullLayout = gd._fullLayout;
  var clipPath = Lib.ensureSingleById(fullLayout._topdefs, 'clipPath', opts._clipId, function (s) {
    s.append('rect').attr({
      x: 0,
      y: 0
    });
  });
  clipPath.select('rect').attr({
    width: opts._width,
    height: opts._height
  });
}
function drawRangePlot(rangeSlider, gd, axisOpts, opts) {
  var calcData = gd.calcdata;
  var rangePlots = rangeSlider.selectAll('g.' + constants.rangePlotClassName).data(axisOpts._subplotsWith, Lib.identity);
  rangePlots.enter().append('g').attr('class', function (id) {
    return constants.rangePlotClassName + ' ' + id;
  }).call(Drawing.setClipUrl, opts._clipId, gd);
  rangePlots.order();
  rangePlots.exit().remove();
  var mainplotinfo;
  rangePlots.each(function (id, i) {
    var plotgroup = d3.select(this);
    var isMainPlot = i === 0;
    var oppAxisOpts = axisIDs.getFromId(gd, id, 'y');
    var oppAxisName = oppAxisOpts._name;
    var oppAxisRangeOpts = opts[oppAxisName];
    var mockFigure = {
      data: [],
      layout: {
        xaxis: {
          type: axisOpts.type,
          domain: [0, 1],
          range: opts.range.slice(),
          calendar: axisOpts.calendar
        },
        width: opts._width,
        height: opts._height,
        margin: {
          t: 0,
          b: 0,
          l: 0,
          r: 0
        }
      },
      _context: gd._context
    };
    if (axisOpts.rangebreaks) {
      mockFigure.layout.xaxis.rangebreaks = axisOpts.rangebreaks;
    }
    mockFigure.layout[oppAxisName] = {
      type: oppAxisOpts.type,
      domain: [0, 1],
      range: oppAxisRangeOpts.rangemode !== 'match' ? oppAxisRangeOpts.range.slice() : oppAxisOpts.range.slice(),
      calendar: oppAxisOpts.calendar
    };
    if (oppAxisOpts.rangebreaks) {
      mockFigure.layout[oppAxisName].rangebreaks = oppAxisOpts.rangebreaks;
    }
    Plots.supplyDefaults(mockFigure);
    var xa = mockFigure._fullLayout.xaxis;
    var ya = mockFigure._fullLayout[oppAxisName];
    xa.clearCalc();
    xa.setScale();
    ya.clearCalc();
    ya.setScale();
    var plotinfo = {
      id: id,
      plotgroup: plotgroup,
      xaxis: xa,
      yaxis: ya,
      isRangePlot: true
    };
    if (isMainPlot) mainplotinfo = plotinfo;else {
      plotinfo.mainplot = 'xy';
      plotinfo.mainplotinfo = mainplotinfo;
    }
    Cartesian.rangePlot(gd, plotinfo, filterRangePlotCalcData(calcData, id));
  });
}
function filterRangePlotCalcData(calcData, subplotId) {
  var out = [];
  for (var i = 0; i < calcData.length; i++) {
    var calcTrace = calcData[i];
    var trace = calcTrace[0].trace;
    if (trace.xaxis + trace.yaxis === subplotId) {
      out.push(calcTrace);
    }
  }
  return out;
}
function drawMasks(rangeSlider, gd, axisOpts, opts, oppAxisRangeOpts) {
  var maskMin = Lib.ensureSingle(rangeSlider, 'rect', constants.maskMinClassName, function (s) {
    s.attr({
      x: 0,
      y: 0,
      'shape-rendering': 'crispEdges'
    });
  });
  maskMin.attr('height', opts._height).call(Color.fill, constants.maskColor);
  var maskMax = Lib.ensureSingle(rangeSlider, 'rect', constants.maskMaxClassName, function (s) {
    s.attr({
      y: 0,
      'shape-rendering': 'crispEdges'
    });
  });
  maskMax.attr('height', opts._height).call(Color.fill, constants.maskColor);

  // masks used for oppAxis zoom
  if (oppAxisRangeOpts.rangemode !== 'match') {
    var maskMinOppAxis = Lib.ensureSingle(rangeSlider, 'rect', constants.maskMinOppAxisClassName, function (s) {
      s.attr({
        y: 0,
        'shape-rendering': 'crispEdges'
      });
    });
    maskMinOppAxis.attr('width', opts._width).call(Color.fill, constants.maskOppAxisColor);
    var maskMaxOppAxis = Lib.ensureSingle(rangeSlider, 'rect', constants.maskMaxOppAxisClassName, function (s) {
      s.attr({
        y: 0,
        'shape-rendering': 'crispEdges'
      });
    });
    maskMaxOppAxis.attr('width', opts._width).style('border-top', constants.maskOppBorder).call(Color.fill, constants.maskOppAxisColor);
  }
}
function drawSlideBox(rangeSlider, gd, axisOpts, opts) {
  if (gd._context.staticPlot) return;
  var slideBox = Lib.ensureSingle(rangeSlider, 'rect', constants.slideBoxClassName, function (s) {
    s.attr({
      y: 0,
      cursor: constants.slideBoxCursor,
      'shape-rendering': 'crispEdges'
    });
  });
  slideBox.attr({
    height: opts._height,
    fill: constants.slideBoxFill
  });
}
function drawGrabbers(rangeSlider, gd, axisOpts, opts) {
  // <g grabber />
  var grabberMin = Lib.ensureSingle(rangeSlider, 'g', constants.grabberMinClassName);
  var grabberMax = Lib.ensureSingle(rangeSlider, 'g', constants.grabberMaxClassName);

  // <g handle />
  var handleFixAttrs = {
    x: 0,
    width: constants.handleWidth,
    rx: constants.handleRadius,
    fill: Color.background,
    stroke: Color.defaultLine,
    'stroke-width': constants.handleStrokeWidth,
    'shape-rendering': 'crispEdges'
  };
  var handleDynamicAttrs = {
    y: Math.round(opts._height / 4),
    height: Math.round(opts._height / 2)
  };
  var handleMin = Lib.ensureSingle(grabberMin, 'rect', constants.handleMinClassName, function (s) {
    s.attr(handleFixAttrs);
  });
  handleMin.attr(handleDynamicAttrs);
  var handleMax = Lib.ensureSingle(grabberMax, 'rect', constants.handleMaxClassName, function (s) {
    s.attr(handleFixAttrs);
  });
  handleMax.attr(handleDynamicAttrs);

  // <g grabarea />
  var grabAreaFixAttrs = {
    width: constants.grabAreaWidth,
    x: 0,
    y: 0,
    fill: constants.grabAreaFill,
    cursor: !gd._context.staticPlot ? constants.grabAreaCursor : undefined
  };
  var grabAreaMin = Lib.ensureSingle(grabberMin, 'rect', constants.grabAreaMinClassName, function (s) {
    s.attr(grabAreaFixAttrs);
  });
  grabAreaMin.attr('height', opts._height);
  var grabAreaMax = Lib.ensureSingle(grabberMax, 'rect', constants.grabAreaMaxClassName, function (s) {
    s.attr(grabAreaFixAttrs);
  });
  grabAreaMax.attr('height', opts._height);
}

/***/ }),

/***/ 80400:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var axisIDs = __webpack_require__(5975);
var svgTextUtils = __webpack_require__(30635);
var constants = __webpack_require__(20604);
var LINE_SPACING = (__webpack_require__(4530).LINE_SPACING);
var name = constants.name;
function isVisible(ax) {
  var rangeSlider = ax && ax[name];
  return rangeSlider && rangeSlider.visible;
}
exports.isVisible = isVisible;
exports.makeData = function (fullLayout) {
  var axes = axisIDs.list({
    _fullLayout: fullLayout
  }, 'x', true);
  var margin = fullLayout.margin;
  var rangeSliderData = [];
  if (!fullLayout._has('gl2d')) {
    for (var i = 0; i < axes.length; i++) {
      var ax = axes[i];
      if (isVisible(ax)) {
        rangeSliderData.push(ax);
        var opts = ax[name];
        opts._id = name + ax._id;
        opts._height = (fullLayout.height - margin.b - margin.t) * opts.thickness;
        opts._offsetShift = Math.floor(opts.borderwidth / 2);
      }
    }
  }
  fullLayout._rangeSliderData = rangeSliderData;
};
exports.autoMarginOpts = function (gd, ax) {
  var fullLayout = gd._fullLayout;
  var opts = ax[name];
  var axLetter = ax._id.charAt(0);
  var bottomDepth = 0;
  var titleHeight = 0;
  if (ax.side === 'bottom') {
    bottomDepth = ax._depth;
    if (ax.title.text !== fullLayout._dfltTitle[axLetter]) {
      // as in rangeslider/draw.js
      titleHeight = 1.5 * ax.title.font.size + 10 + opts._offsetShift;
      // multi-line extra bump
      var extraLines = (ax.title.text.match(svgTextUtils.BR_TAG_ALL) || []).length;
      titleHeight += extraLines * ax.title.font.size * LINE_SPACING;
    }
  }
  return {
    x: 0,
    y: ax._counterDomainMin,
    l: 0,
    r: 0,
    t: 0,
    b: opts._height + bottomDepth + Math.max(fullLayout.margin.b, titleHeight),
    pad: constants.extraPad + opts._offsetShift * 2
  };
};

/***/ }),

/***/ 55429:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var attrs = __webpack_require__(63608);
var oppAxisAttrs = __webpack_require__(66249);
var helpers = __webpack_require__(80400);
module.exports = {
  moduleType: 'component',
  name: 'rangeslider',
  schema: {
    subplots: {
      xaxis: {
        rangeslider: Lib.extendFlat({}, attrs, {
          yaxis: oppAxisAttrs
        })
      }
    }
  },
  layoutAttributes: __webpack_require__(63608),
  handleDefaults: __webpack_require__(41295),
  calcAutorange: __webpack_require__(46223),
  draw: __webpack_require__(88887),
  isVisible: helpers.isVisible,
  makeData: helpers.makeData,
  autoMarginOpts: helpers.autoMarginOpts
};

/***/ }),

/***/ 66249:
/***/ (function(module) {

"use strict";


module.exports = {
  // not really a 'subplot' attribute container,
  // but this is the flag we use to denote attributes that
  // support yaxis, yaxis2, yaxis3, ... counters
  _isSubplotObj: true,
  rangemode: {
    valType: 'enumerated',
    values: ['auto', 'fixed', 'match'],
    dflt: 'match',
    editType: 'calc'
  },
  range: {
    valType: 'info_array',
    items: [{
      valType: 'any',
      editType: 'plot'
    }, {
      valType: 'any',
      editType: 'plot'
    }],
    editType: 'plot'
  },
  editType: 'calc'
};

/***/ }),

/***/ 4327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var annAttrs = __webpack_require__(50222);
var scatterLineAttrs = (__webpack_require__(36640).line);
var dash = (__webpack_require__(94850)/* .dash */ .T);
var extendFlat = (__webpack_require__(93049).extendFlat);
var overrideAll = (__webpack_require__(13582).overrideAll);
var templatedArray = (__webpack_require__(78032).templatedArray);
var axisPlaceableObjs = __webpack_require__(35081);
module.exports = overrideAll(templatedArray('selection', {
  type: {
    valType: 'enumerated',
    values: ['rect', 'path']
  },
  xref: extendFlat({}, annAttrs.xref, {}),
  yref: extendFlat({}, annAttrs.yref, {}),
  x0: {
    valType: 'any'
  },
  x1: {
    valType: 'any'
  },
  y0: {
    valType: 'any'
  },
  y1: {
    valType: 'any'
  },
  path: {
    valType: 'string',
    editType: 'arraydraw'
  },
  opacity: {
    valType: 'number',
    min: 0,
    max: 1,
    dflt: 0.7,
    editType: 'arraydraw'
  },
  line: {
    color: scatterLineAttrs.color,
    width: extendFlat({}, scatterLineAttrs.width, {
      min: 1,
      dflt: 1
    }),
    dash: extendFlat({}, dash, {
      dflt: 'dot'
    })
  }
}), 'arraydraw', 'from-root');

/***/ }),

/***/ 78865:
/***/ (function(module) {

"use strict";


module.exports = {
  // max pixels off straight before a lasso select line counts as bent
  BENDPX: 1.5,
  // smallest dimension allowed for a select box
  MINSELECT: 12,
  // throttling limit (ms) for selectPoints calls
  SELECTDELAY: 100,
  // cache ID suffix for throttle
  SELECTID: '-select'
};

/***/ }),

/***/ 2272:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var Axes = __webpack_require__(29714);
var handleArrayContainerDefaults = __webpack_require__(59008);
var attributes = __webpack_require__(4327);
var helpers = __webpack_require__(49728);
module.exports = function supplyLayoutDefaults(layoutIn, layoutOut) {
  handleArrayContainerDefaults(layoutIn, layoutOut, {
    name: 'selections',
    handleItemDefaults: handleSelectionDefaults
  });

  // Drop rect selections with undefined x0, y0, x1, x1 values.
  // In future we may accept partially defined rects e.g.
  // a case with only x0 and x1 may be used to define
  // [-Infinity, +Infinity] range on the y axis, etc.
  var selections = layoutOut.selections;
  for (var i = 0; i < selections.length; i++) {
    var selection = selections[i];
    if (!selection) continue;
    if (selection.path === undefined) {
      if (selection.x0 === undefined || selection.x1 === undefined || selection.y0 === undefined || selection.y1 === undefined) {
        layoutOut.selections[i] = null;
      }
    }
  }
};
function handleSelectionDefaults(selectionIn, selectionOut, fullLayout) {
  function coerce(attr, dflt) {
    return Lib.coerce(selectionIn, selectionOut, attributes, attr, dflt);
  }
  var path = coerce('path');
  var dfltType = path ? 'path' : 'rect';
  var selectionType = coerce('type', dfltType);
  var noPath = selectionType !== 'path';
  if (noPath) delete selectionOut.path;
  coerce('opacity');
  coerce('line.color');
  coerce('line.width');
  coerce('line.dash');

  // positioning
  var axLetters = ['x', 'y'];
  for (var i = 0; i < 2; i++) {
    var axLetter = axLetters[i];
    var gdMock = {
      _fullLayout: fullLayout
    };
    var ax;
    var pos2r;
    var r2pos;

    // xref, yref
    var axRef = Axes.coerceRef(selectionIn, selectionOut, gdMock, axLetter);

    // axRefType is 'range' for selections
    ax = Axes.getFromId(gdMock, axRef);
    ax._selectionIndices.push(selectionOut._index);
    r2pos = helpers.rangeToShapePosition(ax);
    pos2r = helpers.shapePositionToRange(ax);

    // Coerce x0, x1, y0, y1
    if (noPath) {
      // hack until V3.0 when log has regular range behavior - make it look like other
      // ranges to send to coerce, then put it back after
      // this is all to give reasonable default position behavior on log axes, which is
      // a pretty unimportant edge case so we could just ignore this.
      var attr0 = axLetter + '0';
      var attr1 = axLetter + '1';
      var in0 = selectionIn[attr0];
      var in1 = selectionIn[attr1];
      selectionIn[attr0] = pos2r(selectionIn[attr0], true);
      selectionIn[attr1] = pos2r(selectionIn[attr1], true);
      Axes.coercePosition(selectionOut, gdMock, coerce, axRef, attr0);
      Axes.coercePosition(selectionOut, gdMock, coerce, axRef, attr1);
      var p0 = selectionOut[attr0];
      var p1 = selectionOut[attr1];
      if (p0 !== undefined && p1 !== undefined) {
        // hack part 2
        selectionOut[attr0] = r2pos(p0);
        selectionOut[attr1] = r2pos(p1);
        selectionIn[attr0] = in0;
        selectionIn[attr1] = in1;
      }
    }
  }
  if (noPath) {
    Lib.noneOrAll(selectionIn, selectionOut, ['x0', 'x1', 'y0', 'y1']);
  }
}

/***/ }),

/***/ 7028:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var readPaths = (__webpack_require__(81055).readPaths);
var displayOutlines = __webpack_require__(561);
var clearOutlineControllers = (__webpack_require__(78534).clearOutlineControllers);
var Color = __webpack_require__(78766);
var Drawing = __webpack_require__(62203);
var arrayEditor = (__webpack_require__(78032).arrayEditor);
var helpers = __webpack_require__(49728);
var getPathString = helpers.getPathString;

// Selections are stored in gd.layout.selections, an array of objects
// index can point to one item in this array,
//  or non-numeric to simply add a new one
//  or -1 to modify all existing
// opt can be the full options object, or one key (to be set to value)
//  or undefined to simply redraw
// if opt is blank, val can be 'add' or a full options object to add a new
//  annotation at that point in the array, or 'remove' to delete this one

module.exports = {
  draw: draw,
  drawOne: drawOne,
  activateLastSelection: activateLastSelection
};
function draw(gd) {
  var fullLayout = gd._fullLayout;
  clearOutlineControllers(gd);

  // Remove previous selections before drawing new selections in fullLayout.selections
  fullLayout._selectionLayer.selectAll('path').remove();
  for (var k in fullLayout._plots) {
    var selectionLayer = fullLayout._plots[k].selectionLayer;
    if (selectionLayer) selectionLayer.selectAll('path').remove();
  }
  for (var i = 0; i < fullLayout.selections.length; i++) {
    drawOne(gd, i);
  }
}
function couldHaveActiveSelection(gd) {
  return gd._context.editSelection;
}
function drawOne(gd, index) {
  // remove the existing selection if there is one.
  // because indices can change, we need to look in all selection layers
  gd._fullLayout._paperdiv.selectAll('.selectionlayer [data-index="' + index + '"]').remove();
  var o = helpers.makeSelectionsOptionsAndPlotinfo(gd, index);
  var options = o.options;
  var plotinfo = o.plotinfo;

  // this selection is gone - quit now after deleting it
  // TODO: use d3 idioms instead of deleting and redrawing every time
  if (!options._input) return;
  drawSelection(gd._fullLayout._selectionLayer);
  function drawSelection(selectionLayer) {
    var d = getPathString(gd, options);
    var attrs = {
      'data-index': index,
      'fill-rule': 'evenodd',
      d: d
    };
    var opacity = options.opacity;
    var fillColor = 'rgba(0,0,0,0)';
    var lineColor = options.line.color || Color.contrast(gd._fullLayout.plot_bgcolor);
    var lineWidth = options.line.width;
    var lineDash = options.line.dash;
    if (!lineWidth) {
      // ensure invisible border to activate the selection
      lineWidth = 5;
      lineDash = 'solid';
    }
    var isActiveSelection = couldHaveActiveSelection(gd) && gd._fullLayout._activeSelectionIndex === index;
    if (isActiveSelection) {
      fillColor = gd._fullLayout.activeselection.fillcolor;
      opacity = gd._fullLayout.activeselection.opacity;
    }
    var allPaths = [];
    for (var sensory = 1; sensory >= 0; sensory--) {
      var path = selectionLayer.append('path').attr(attrs).style('opacity', sensory ? 0.1 : opacity).call(Color.stroke, lineColor).call(Color.fill, fillColor)
      // make it easier to select senory background path
      .call(Drawing.dashLine, sensory ? 'solid' : lineDash, sensory ? 4 + lineWidth : lineWidth);
      setClipPath(path, gd, options);
      if (isActiveSelection) {
        var editHelpers = arrayEditor(gd.layout, 'selections', options);
        path.style({
          cursor: 'move'
        });
        var dragOptions = {
          element: path.node(),
          plotinfo: plotinfo,
          gd: gd,
          editHelpers: editHelpers,
          isActiveSelection: true // i.e. to enable controllers
        };
        var polygons = readPaths(d, gd);
        // display polygons on the screen
        displayOutlines(polygons, path, dragOptions);
      } else {
        path.style('pointer-events', sensory ? 'all' : 'none');
      }
      allPaths[sensory] = path;
    }
    var forePath = allPaths[0];
    var backPath = allPaths[1];
    backPath.node().addEventListener('click', function () {
      return activateSelection(gd, forePath);
    });
  }
}
function setClipPath(selectionPath, gd, selectionOptions) {
  var clipAxes = selectionOptions.xref + selectionOptions.yref;
  Drawing.setClipUrl(selectionPath, 'clip' + gd._fullLayout._uid + clipAxes, gd);
}
function activateSelection(gd, path) {
  if (!couldHaveActiveSelection(gd)) return;
  var element = path.node();
  var id = +element.getAttribute('data-index');
  if (id >= 0) {
    // deactivate if already active
    if (id === gd._fullLayout._activeSelectionIndex) {
      deactivateSelection(gd);
      return;
    }
    gd._fullLayout._activeSelectionIndex = id;
    gd._fullLayout._deactivateSelection = deactivateSelection;
    draw(gd);
  }
}
function activateLastSelection(gd) {
  if (!couldHaveActiveSelection(gd)) return;
  var id = gd._fullLayout.selections.length - 1;
  gd._fullLayout._activeSelectionIndex = id;
  gd._fullLayout._deactivateSelection = deactivateSelection;
  draw(gd);
}
function deactivateSelection(gd) {
  if (!couldHaveActiveSelection(gd)) return;
  var id = gd._fullLayout._activeSelectionIndex;
  if (id >= 0) {
    clearOutlineControllers(gd);
    delete gd._fullLayout._activeSelectionIndex;
    draw(gd);
  }
}

/***/ }),

/***/ 52307:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var dash = (__webpack_require__(94850)/* .dash */ .T);
var extendFlat = (__webpack_require__(93049).extendFlat);
module.exports = {
  newselection: {
    mode: {
      valType: 'enumerated',
      values: ['immediate', 'gradual'],
      dflt: 'immediate',
      editType: 'none'
    },
    line: {
      color: {
        valType: 'color',
        editType: 'none'
      },
      width: {
        valType: 'number',
        min: 1,
        dflt: 1,
        editType: 'none'
      },
      dash: extendFlat({}, dash, {
        dflt: 'dot',
        editType: 'none'
      }),
      editType: 'none'
    },
    // no drawdirection here noting that layout.selectdirection is used instead.

    editType: 'none'
  },
  activeselection: {
    fillcolor: {
      valType: 'color',
      dflt: 'rgba(0,0,0,0)',
      editType: 'none'
    },
    opacity: {
      valType: 'number',
      min: 0,
      max: 1,
      dflt: 0.5,
      editType: 'none'
    },
    editType: 'none'
  }
};

/***/ }),

/***/ 43028:
/***/ (function(module) {

"use strict";


module.exports = function supplyDrawNewSelectionDefaults(layoutIn, layoutOut, coerce) {
  coerce('newselection.mode');
  var newselectionLineWidth = coerce('newselection.line.width');
  if (newselectionLineWidth) {
    coerce('newselection.line.color');
    coerce('newselection.line.dash');
  }
  coerce('activeselection.fillcolor');
  coerce('activeselection.opacity');
};

/***/ }),

/***/ 51817:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var dragHelpers = __webpack_require__(70414);
var selectMode = dragHelpers.selectMode;
var handleOutline = __webpack_require__(78534);
var clearOutline = handleOutline.clearOutline;
var helpers = __webpack_require__(81055);
var readPaths = helpers.readPaths;
var writePaths = helpers.writePaths;
var fixDatesForPaths = helpers.fixDatesForPaths;
module.exports = function newSelections(outlines, dragOptions) {
  if (!outlines.length) return;
  var e = outlines[0][0]; // pick first
  if (!e) return;
  var d = e.getAttribute('d');
  var gd = dragOptions.gd;
  var newStyle = gd._fullLayout.newselection;
  var plotinfo = dragOptions.plotinfo;
  var xaxis = plotinfo.xaxis;
  var yaxis = plotinfo.yaxis;
  var isActiveSelection = dragOptions.isActiveSelection;
  var dragmode = dragOptions.dragmode;
  var selections = (gd.layout || {}).selections || [];
  if (!selectMode(dragmode) && isActiveSelection !== undefined) {
    var id = gd._fullLayout._activeSelectionIndex;
    if (id < selections.length) {
      switch (gd._fullLayout.selections[id].type) {
        case 'rect':
          dragmode = 'select';
          break;
        case 'path':
          dragmode = 'lasso';
          break;
      }
    }
  }
  var polygons = readPaths(d, gd, plotinfo, isActiveSelection);
  var newSelection = {
    xref: xaxis._id,
    yref: yaxis._id,
    opacity: newStyle.opacity,
    line: {
      color: newStyle.line.color,
      width: newStyle.line.width,
      dash: newStyle.line.dash
    }
  };
  var cell;
  // rect can be in one cell
  // only define cell if there is single cell
  if (polygons.length === 1) cell = polygons[0];
  if (cell && cell.length === 5 &&
  // ensure we only have 4 corners for a rect
  dragmode === 'select') {
    newSelection.type = 'rect';
    newSelection.x0 = cell[0][1];
    newSelection.y0 = cell[0][2];
    newSelection.x1 = cell[2][1];
    newSelection.y1 = cell[2][2];
  } else {
    newSelection.type = 'path';
    if (xaxis && yaxis) fixDatesForPaths(polygons, xaxis, yaxis);
    newSelection.path = writePaths(polygons);
    cell = null;
  }
  clearOutline(gd);
  var editHelpers = dragOptions.editHelpers;
  var modifyItem = (editHelpers || {}).modifyItem;
  var allSelections = [];
  for (var q = 0; q < selections.length; q++) {
    var beforeEdit = gd._fullLayout.selections[q];
    if (!beforeEdit) {
      allSelections[q] = beforeEdit;
      continue;
    }
    allSelections[q] = beforeEdit._input;
    if (isActiveSelection !== undefined && q === gd._fullLayout._activeSelectionIndex) {
      var afterEdit = newSelection;
      switch (beforeEdit.type) {
        case 'rect':
          modifyItem('x0', afterEdit.x0);
          modifyItem('x1', afterEdit.x1);
          modifyItem('y0', afterEdit.y0);
          modifyItem('y1', afterEdit.y1);
          break;
        case 'path':
          modifyItem('path', afterEdit.path);
          break;
      }
    }
  }
  if (isActiveSelection === undefined) {
    allSelections.push(newSelection); // add new selection
    return allSelections;
  }
  return editHelpers ? editHelpers.getUpdateObj() : {};
};

/***/ }),

/***/ 49801:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var strTranslate = (__webpack_require__(34809).strTranslate);

// in v3 (once log ranges are fixed),
// we'll be able to p2r here for all axis types
function p2r(ax, v) {
  switch (ax.type) {
    case 'log':
      return ax.p2d(v);
    case 'date':
      return ax.p2r(v, 0, ax.calendar);
    default:
      return ax.p2r(v);
  }
}
function r2p(ax, v) {
  switch (ax.type) {
    case 'log':
      return ax.d2p(v);
    case 'date':
      return ax.r2p(v, 0, ax.calendar);
    default:
      return ax.r2p(v);
  }
}
function axValue(ax) {
  var index = ax._id.charAt(0) === 'y' ? 1 : 0;
  return function (v) {
    return p2r(ax, v[index]);
  };
}
function getTransform(plotinfo) {
  return strTranslate(plotinfo.xaxis._offset, plotinfo.yaxis._offset);
}
module.exports = {
  p2r: p2r,
  r2p: r2p,
  axValue: axValue,
  getTransform: getTransform
};

/***/ }),

/***/ 44844:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var drawModule = __webpack_require__(7028);
var select = __webpack_require__(88666);
module.exports = {
  moduleType: 'component',
  name: 'selections',
  layoutAttributes: __webpack_require__(4327),
  supplyLayoutDefaults: __webpack_require__(2272),
  supplyDrawNewSelectionDefaults: __webpack_require__(43028),
  includeBasePlot: __webpack_require__(20706)('selections'),
  draw: drawModule.draw,
  drawOne: drawModule.drawOne,
  reselect: select.reselect,
  prepSelect: select.prepSelect,
  clearOutline: select.clearOutline,
  clearSelectionsCache: select.clearSelectionsCache,
  selectOnClick: select.selectOnClick
};

/***/ }),

/***/ 88666:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var polybool = __webpack_require__(11516);
var pointInPolygon = __webpack_require__(52773); // could we use contains lib/polygon instead?

var Registry = __webpack_require__(33626);
var dashStyle = (__webpack_require__(62203).dashStyle);
var Color = __webpack_require__(78766);
var Fx = __webpack_require__(32141);
var makeEventData = (__webpack_require__(36040).makeEventData);
var dragHelpers = __webpack_require__(70414);
var freeMode = dragHelpers.freeMode;
var rectMode = dragHelpers.rectMode;
var drawMode = dragHelpers.drawMode;
var openMode = dragHelpers.openMode;
var selectMode = dragHelpers.selectMode;
var shapeHelpers = __webpack_require__(49728);
var shapeConstants = __webpack_require__(2956);
var displayOutlines = __webpack_require__(561);
var clearOutline = (__webpack_require__(78534).clearOutline);
var newShapeHelpers = __webpack_require__(81055);
var handleEllipse = newShapeHelpers.handleEllipse;
var readPaths = newShapeHelpers.readPaths;
var newShapes = (__webpack_require__(87562).newShapes);
var newSelections = __webpack_require__(51817);
var activateLastSelection = (__webpack_require__(7028).activateLastSelection);
var Lib = __webpack_require__(34809);
var ascending = Lib.sorterAsc;
var libPolygon = __webpack_require__(80899);
var throttle = __webpack_require__(64025);
var getFromId = (__webpack_require__(5975).getFromId);
var clearGlCanvases = __webpack_require__(34823);
var redrawReglTraces = (__webpack_require__(71817).redrawReglTraces);
var constants = __webpack_require__(78865);
var MINSELECT = constants.MINSELECT;
var filteredPolygon = libPolygon.filter;
var polygonTester = libPolygon.tester;
var helpers = __webpack_require__(49801);
var p2r = helpers.p2r;
var axValue = helpers.axValue;
var getTransform = helpers.getTransform;
function hasSubplot(dragOptions) {
  // N.B. subplot may be falsy e.g zero sankey index!
  return dragOptions.subplot !== undefined;
}
function prepSelect(evt, startX, startY, dragOptions, mode) {
  var isCartesian = !hasSubplot(dragOptions);
  var isFreeMode = freeMode(mode);
  var isRectMode = rectMode(mode);
  var isOpenMode = openMode(mode);
  var isDrawMode = drawMode(mode);
  var isSelectMode = selectMode(mode);
  var isLine = mode === 'drawline';
  var isEllipse = mode === 'drawcircle';
  var isLineOrEllipse = isLine || isEllipse; // cases with two start & end positions

  var gd = dragOptions.gd;
  var fullLayout = gd._fullLayout;
  var immediateSelect = isSelectMode && fullLayout.newselection.mode === 'immediate' && isCartesian; // N.B. only cartesian subplots have persistent selection

  var zoomLayer = fullLayout._zoomlayer;
  var dragBBox = dragOptions.element.getBoundingClientRect();
  var plotinfo = dragOptions.plotinfo;
  var transform = getTransform(plotinfo);
  var x0 = startX - dragBBox.left;
  var y0 = startY - dragBBox.top;
  fullLayout._calcInverseTransform(gd);
  var transformedCoords = Lib.apply3DTransform(fullLayout._invTransform)(x0, y0);
  x0 = transformedCoords[0];
  y0 = transformedCoords[1];
  var scaleX = fullLayout._invScaleX;
  var scaleY = fullLayout._invScaleY;
  var x1 = x0;
  var y1 = y0;
  var path0 = 'M' + x0 + ',' + y0;
  var xAxis = dragOptions.xaxes[0];
  var yAxis = dragOptions.yaxes[0];
  var pw = xAxis._length;
  var ph = yAxis._length;
  var subtract = evt.altKey && !(drawMode(mode) && isOpenMode);
  var filterPoly, selectionTesters, mergedPolygons, currentPolygon;
  var i, searchInfo, eventData;
  coerceSelectionsCache(evt, gd, dragOptions);
  if (isFreeMode) {
    filterPoly = filteredPolygon([[x0, y0]], constants.BENDPX);
  }
  var outlines = zoomLayer.selectAll('path.select-outline-' + plotinfo.id).data([1]);
  var newStyle = isDrawMode ? fullLayout.newshape : fullLayout.newselection;
  if (isDrawMode) {
    dragOptions.hasText = newStyle.label.text || newStyle.label.texttemplate;
  }
  var fillC = isDrawMode && !isOpenMode ? newStyle.fillcolor : 'rgba(0,0,0,0)';
  var strokeC = newStyle.line.color || (isCartesian ? Color.contrast(gd._fullLayout.plot_bgcolor) : '#7f7f7f' // non-cartesian subplot
  );
  outlines.enter().append('path').attr('class', 'select-outline select-outline-' + plotinfo.id).style({
    opacity: isDrawMode ? newStyle.opacity / 2 : 1,
    'stroke-dasharray': dashStyle(newStyle.line.dash, newStyle.line.width),
    'stroke-width': newStyle.line.width + 'px',
    'shape-rendering': 'crispEdges'
  }).call(Color.stroke, strokeC).call(Color.fill, fillC).attr('fill-rule', 'evenodd').classed('cursor-move', isDrawMode ? true : false).attr('transform', transform).attr('d', path0 + 'Z');
  var corners = zoomLayer.append('path').attr('class', 'zoombox-corners').style({
    fill: Color.background,
    stroke: Color.defaultLine,
    'stroke-width': 1
  }).attr('transform', transform).attr('d', 'M0,0Z');

  // create & style group for text label
  if (isDrawMode && dragOptions.hasText) {
    var shapeGroup = zoomLayer.select('.label-temp');
    if (shapeGroup.empty()) {
      shapeGroup = zoomLayer.append('g').classed('label-temp', true).classed('select-outline', true).style({
        opacity: 0.8
      });
    }
  }
  var throttleID = fullLayout._uid + constants.SELECTID;
  var selection = [];

  // find the traces to search for selection points
  var searchTraces = determineSearchTraces(gd, dragOptions.xaxes, dragOptions.yaxes, dragOptions.subplot);
  if (immediateSelect && !evt.shiftKey) {
    dragOptions._clearSubplotSelections = function () {
      if (!isCartesian) return;
      var xRef = xAxis._id;
      var yRef = yAxis._id;
      deselectSubplot(gd, xRef, yRef, searchTraces);
      var selections = (gd.layout || {}).selections || [];
      var list = [];
      var selectionErased = false;
      for (var q = 0; q < selections.length; q++) {
        var s = fullLayout.selections[q];
        if (s.xref !== xRef || s.yref !== yRef) {
          list.push(selections[q]);
        } else {
          selectionErased = true;
        }
      }
      if (selectionErased) {
        gd._fullLayout._noEmitSelectedAtStart = true;
        Registry.call('_guiRelayout', gd, {
          selections: list
        });
      }
    };
  }
  var fillRangeItems = getFillRangeItems(dragOptions);
  dragOptions.moveFn = function (dx0, dy0) {
    if (dragOptions._clearSubplotSelections) {
      dragOptions._clearSubplotSelections();
      dragOptions._clearSubplotSelections = undefined;
    }
    x1 = Math.max(0, Math.min(pw, scaleX * dx0 + x0));
    y1 = Math.max(0, Math.min(ph, scaleY * dy0 + y0));
    var dx = Math.abs(x1 - x0);
    var dy = Math.abs(y1 - y0);
    if (isRectMode) {
      var direction;
      var start, end;
      if (isSelectMode) {
        var q = fullLayout.selectdirection;
        if (q === 'any') {
          if (dy < Math.min(dx * 0.6, MINSELECT)) {
            direction = 'h';
          } else if (dx < Math.min(dy * 0.6, MINSELECT)) {
            direction = 'v';
          } else {
            direction = 'd';
          }
        } else {
          direction = q;
        }
        switch (direction) {
          case 'h':
            start = isEllipse ? ph / 2 : 0;
            end = ph;
            break;
          case 'v':
            start = isEllipse ? pw / 2 : 0;
            end = pw;
            break;
        }
      }
      if (isDrawMode) {
        switch (fullLayout.newshape.drawdirection) {
          case 'vertical':
            direction = 'h';
            start = isEllipse ? ph / 2 : 0;
            end = ph;
            break;
          case 'horizontal':
            direction = 'v';
            start = isEllipse ? pw / 2 : 0;
            end = pw;
            break;
          case 'ortho':
            if (dx < dy) {
              direction = 'h';
              start = y0;
              end = y1;
            } else {
              direction = 'v';
              start = x0;
              end = x1;
            }
            break;
          default:
            // i.e. case of 'diagonal'
            direction = 'd';
        }
      }
      if (direction === 'h') {
        // horizontal motion
        currentPolygon = isLineOrEllipse ? handleEllipse(isEllipse, [x1, start], [x1, end]) :
        // using x1 instead of x0 allows adjusting the line while drawing
        [[x0, start], [x0, end], [x1, end], [x1, start]]; // make a vertical box

        currentPolygon.xmin = isLineOrEllipse ? x1 : Math.min(x0, x1);
        currentPolygon.xmax = isLineOrEllipse ? x1 : Math.max(x0, x1);
        currentPolygon.ymin = Math.min(start, end);
        currentPolygon.ymax = Math.max(start, end);
        // extras to guide users in keeping a straight selection
        corners.attr('d', 'M' + currentPolygon.xmin + ',' + (y0 - MINSELECT) + 'h-4v' + 2 * MINSELECT + 'h4Z' + 'M' + (currentPolygon.xmax - 1) + ',' + (y0 - MINSELECT) + 'h4v' + 2 * MINSELECT + 'h-4Z');
      } else if (direction === 'v') {
        // vertical motion
        currentPolygon = isLineOrEllipse ? handleEllipse(isEllipse, [start, y1], [end, y1]) :
        // using y1 instead of y0 allows adjusting the line while drawing
        [[start, y0], [start, y1], [end, y1], [end, y0]]; // make a horizontal box

        currentPolygon.xmin = Math.min(start, end);
        currentPolygon.xmax = Math.max(start, end);
        currentPolygon.ymin = isLineOrEllipse ? y1 : Math.min(y0, y1);
        currentPolygon.ymax = isLineOrEllipse ? y1 : Math.max(y0, y1);
        corners.attr('d', 'M' + (x0 - MINSELECT) + ',' + currentPolygon.ymin + 'v-4h' + 2 * MINSELECT + 'v4Z' + 'M' + (x0 - MINSELECT) + ',' + (currentPolygon.ymax - 1) + 'v4h' + 2 * MINSELECT + 'v-4Z');
      } else if (direction === 'd') {
        // diagonal motion
        currentPolygon = isLineOrEllipse ? handleEllipse(isEllipse, [x0, y0], [x1, y1]) : [[x0, y0], [x0, y1], [x1, y1], [x1, y0]];
        currentPolygon.xmin = Math.min(x0, x1);
        currentPolygon.xmax = Math.max(x0, x1);
        currentPolygon.ymin = Math.min(y0, y1);
        currentPolygon.ymax = Math.max(y0, y1);
        corners.attr('d', 'M0,0Z');
      }
    } else if (isFreeMode) {
      filterPoly.addPt([x1, y1]);
      currentPolygon = filterPoly.filtered;
    }

    // create outline & tester
    if (dragOptions.selectionDefs && dragOptions.selectionDefs.length) {
      mergedPolygons = mergePolygons(dragOptions.mergedPolygons, currentPolygon, subtract);
      currentPolygon.subtract = subtract;
      selectionTesters = multiTester(dragOptions.selectionDefs.concat([currentPolygon]));
    } else {
      mergedPolygons = [currentPolygon];
      selectionTesters = polygonTester(currentPolygon);
    }

    // display polygons on the screen
    displayOutlines(convertPoly(mergedPolygons, isOpenMode), outlines, dragOptions);
    if (isSelectMode) {
      var _res = reselect(gd, false);
      var extraPoints = _res.eventData ? _res.eventData.points.slice() : [];
      _res = reselect(gd, false, selectionTesters, searchTraces, dragOptions);
      selectionTesters = _res.selectionTesters;
      eventData = _res.eventData;
      var poly;
      if (filterPoly) {
        poly = filterPoly.filtered;
      } else {
        poly = castMultiPolygon(mergedPolygons);
      }
      throttle.throttle(throttleID, constants.SELECTDELAY, function () {
        selection = _doSelect(selectionTesters, searchTraces);
        var newPoints = selection.slice();
        for (var w = 0; w < extraPoints.length; w++) {
          var p = extraPoints[w];
          var found = false;
          for (var u = 0; u < newPoints.length; u++) {
            if (newPoints[u].curveNumber === p.curveNumber && newPoints[u].pointNumber === p.pointNumber) {
              found = true;
              break;
            }
          }
          if (!found) newPoints.push(p);
        }
        if (newPoints.length) {
          if (!eventData) eventData = {};
          eventData.points = newPoints;
        }
        fillRangeItems(eventData, poly);
        emitSelecting(gd, eventData);
      });
    }
  };
  dragOptions.clickFn = function (numClicks, evt) {
    corners.remove();
    if (gd._fullLayout._activeShapeIndex >= 0) {
      gd._fullLayout._deactivateShape(gd);
      return;
    }
    if (isDrawMode) return;
    var clickmode = fullLayout.clickmode;
    throttle.done(throttleID).then(function () {
      throttle.clear(throttleID);
      if (numClicks === 2) {
        // clear selection on doubleclick
        outlines.remove();
        for (i = 0; i < searchTraces.length; i++) {
          searchInfo = searchTraces[i];
          searchInfo._module.selectPoints(searchInfo, false);
        }
        updateSelectedState(gd, searchTraces);
        clearSelectionsCache(dragOptions);
        emitDeselect(gd);
        if (searchTraces.length) {
          var clickedXaxis = searchTraces[0].xaxis;
          var clickedYaxis = searchTraces[0].yaxis;
          if (clickedXaxis && clickedYaxis) {
            // drop selections in the clicked subplot
            var subSelections = [];
            var allSelections = gd._fullLayout.selections;
            for (var k = 0; k < allSelections.length; k++) {
              var s = allSelections[k];
              if (!s) continue; // also drop null selections if any

              if (s.xref !== clickedXaxis._id || s.yref !== clickedYaxis._id) {
                subSelections.push(s);
              }
            }
            if (subSelections.length < allSelections.length) {
              gd._fullLayout._noEmitSelectedAtStart = true;
              Registry.call('_guiRelayout', gd, {
                selections: subSelections
              });
            }
          }
        }
      } else {
        if (clickmode.indexOf('select') > -1) {
          selectOnClick(evt, gd, dragOptions.xaxes, dragOptions.yaxes, dragOptions.subplot, dragOptions, outlines);
        }
        if (clickmode === 'event') {
          // TODO: remove in v3 - this was probably never intended to work as it does,
          // but in case anyone depends on it we don't want to break it now.
          // Note that click-to-select introduced pre v3 also emitts proper
          // event data when clickmode is having 'select' in its flag list.
          emitSelected(gd, undefined);
        }
      }
      Fx.click(gd, evt, plotinfo.id);
    }).catch(Lib.error);
  };
  dragOptions.doneFn = function () {
    corners.remove();
    throttle.done(throttleID).then(function () {
      throttle.clear(throttleID);
      if (!immediateSelect && currentPolygon && dragOptions.selectionDefs) {
        // save last polygons
        currentPolygon.subtract = subtract;
        dragOptions.selectionDefs.push(currentPolygon);

        // we have to keep reference to arrays container
        dragOptions.mergedPolygons.length = 0;
        [].push.apply(dragOptions.mergedPolygons, mergedPolygons);
      }
      if (immediateSelect || isDrawMode) {
        clearSelectionsCache(dragOptions, immediateSelect);
      }
      if (dragOptions.doneFnCompleted) {
        dragOptions.doneFnCompleted(selection);
      }
      if (isSelectMode) {
        emitSelected(gd, eventData);
      }
    }).catch(Lib.error);
  };
}
function selectOnClick(evt, gd, xAxes, yAxes, subplot, dragOptions, polygonOutlines) {
  var hoverData = gd._hoverdata;
  var fullLayout = gd._fullLayout;
  var clickmode = fullLayout.clickmode;
  var sendEvents = clickmode.indexOf('event') > -1;
  var selection = [];
  var searchTraces, searchInfo, currentSelectionDef, selectionTesters, traceSelection;
  var thisTracesSelection, pointOrBinSelected, subtract, eventData, i;
  if (isHoverDataSet(hoverData)) {
    coerceSelectionsCache(evt, gd, dragOptions);
    searchTraces = determineSearchTraces(gd, xAxes, yAxes, subplot);
    var clickedPtInfo = extractClickedPtInfo(hoverData, searchTraces);
    var isBinnedTrace = clickedPtInfo.pointNumbers.length > 0;

    // Note: potentially costly operation isPointOrBinSelected is
    // called as late as possible through the use of an assignment
    // in an if condition.
    if (isBinnedTrace ? isOnlyThisBinSelected(searchTraces, clickedPtInfo) : isOnlyOnePointSelected(searchTraces) && (pointOrBinSelected = isPointOrBinSelected(clickedPtInfo))) {
      if (polygonOutlines) polygonOutlines.remove();
      for (i = 0; i < searchTraces.length; i++) {
        searchInfo = searchTraces[i];
        searchInfo._module.selectPoints(searchInfo, false);
      }
      updateSelectedState(gd, searchTraces);
      clearSelectionsCache(dragOptions);
      if (sendEvents) {
        emitDeselect(gd);
      }
    } else {
      subtract = evt.shiftKey && (pointOrBinSelected !== undefined ? pointOrBinSelected : isPointOrBinSelected(clickedPtInfo));
      currentSelectionDef = newPointSelectionDef(clickedPtInfo.pointNumber, clickedPtInfo.searchInfo, subtract);
      var allSelectionDefs = dragOptions.selectionDefs.concat([currentSelectionDef]);
      selectionTesters = multiTester(allSelectionDefs, selectionTesters);
      for (i = 0; i < searchTraces.length; i++) {
        traceSelection = searchTraces[i]._module.selectPoints(searchTraces[i], selectionTesters);
        thisTracesSelection = fillSelectionItem(traceSelection, searchTraces[i]);
        if (selection.length) {
          for (var j = 0; j < thisTracesSelection.length; j++) {
            selection.push(thisTracesSelection[j]);
          }
        } else selection = thisTracesSelection;
      }
      eventData = {
        points: selection
      };
      updateSelectedState(gd, searchTraces, eventData);
      if (currentSelectionDef && dragOptions) {
        dragOptions.selectionDefs.push(currentSelectionDef);
      }
      if (polygonOutlines) {
        var polygons = dragOptions.mergedPolygons;
        var isOpenMode = openMode(dragOptions.dragmode);

        // display polygons on the screen
        displayOutlines(convertPoly(polygons, isOpenMode), polygonOutlines, dragOptions);
      }
      if (sendEvents) {
        emitSelected(gd, eventData);
      }
    }
  }
}

/**
 * Constructs a new point selection definition object.
 */
function newPointSelectionDef(pointNumber, searchInfo, subtract) {
  return {
    pointNumber: pointNumber,
    searchInfo: searchInfo,
    subtract: !!subtract
  };
}
function isPointSelectionDef(o) {
  return 'pointNumber' in o && 'searchInfo' in o;
}

/*
 * Constructs a new point number tester.
 */
function newPointNumTester(pointSelectionDef) {
  return {
    xmin: 0,
    xmax: 0,
    ymin: 0,
    ymax: 0,
    pts: [],
    contains: function (pt, omitFirstEdge, pointNumber, searchInfo) {
      var idxWantedTrace = pointSelectionDef.searchInfo.cd[0].trace._expandedIndex;
      var idxActualTrace = searchInfo.cd[0].trace._expandedIndex;
      return idxActualTrace === idxWantedTrace && pointNumber === pointSelectionDef.pointNumber;
    },
    isRect: false,
    degenerate: false,
    subtract: !!pointSelectionDef.subtract
  };
}

/**
 * Wraps multiple selection testers.
 *
 * @param {Array} list - An array of selection testers.
 *
 * @return a selection tester object with a contains function
 * that can be called to evaluate a point against all wrapped
 * selection testers that were passed in list.
 */
function multiTester(list) {
  if (!list.length) return;
  var testers = [];
  var xmin = isPointSelectionDef(list[0]) ? 0 : list[0][0][0];
  var xmax = xmin;
  var ymin = isPointSelectionDef(list[0]) ? 0 : list[0][0][1];
  var ymax = ymin;
  for (var i = 0; i < list.length; i++) {
    if (isPointSelectionDef(list[i])) {
      testers.push(newPointNumTester(list[i]));
    } else {
      var tester = polygonTester(list[i]);
      tester.subtract = !!list[i].subtract;
      testers.push(tester);
      xmin = Math.min(xmin, tester.xmin);
      xmax = Math.max(xmax, tester.xmax);
      ymin = Math.min(ymin, tester.ymin);
      ymax = Math.max(ymax, tester.ymax);
    }
  }

  /**
   * Tests if the given point is within this tester.
   *
   * @param {Array} pt - [0] is the x coordinate, [1] is the y coordinate of the point.
   * @param {*} arg - An optional parameter to pass down to wrapped testers.
   * @param {number} pointNumber - The point number of the point within the underlying data array.
   * @param {number} searchInfo - An object identifying the trace the point is contained in.
   *
   * @return {boolean} true if point is considered to be selected, false otherwise.
   */
  function contains(pt, arg, pointNumber, searchInfo) {
    var contained = false;
    for (var i = 0; i < testers.length; i++) {
      if (testers[i].contains(pt, arg, pointNumber, searchInfo)) {
        // if contained by subtract tester - exclude the point
        contained = !testers[i].subtract;
      }
    }
    return contained;
  }
  return {
    xmin: xmin,
    xmax: xmax,
    ymin: ymin,
    ymax: ymax,
    pts: [],
    contains: contains,
    isRect: false,
    degenerate: false
  };
}
function coerceSelectionsCache(evt, gd, dragOptions) {
  var fullLayout = gd._fullLayout;
  var plotinfo = dragOptions.plotinfo;
  var dragmode = dragOptions.dragmode;
  var selectingOnSameSubplot = fullLayout._lastSelectedSubplot && fullLayout._lastSelectedSubplot === plotinfo.id;
  var hasModifierKey = (evt.shiftKey || evt.altKey) && !(drawMode(dragmode) && openMode(dragmode));
  if (selectingOnSameSubplot && hasModifierKey && plotinfo.selection && plotinfo.selection.selectionDefs && !dragOptions.selectionDefs) {
    // take over selection definitions from prev mode, if any
    dragOptions.selectionDefs = plotinfo.selection.selectionDefs;
    dragOptions.mergedPolygons = plotinfo.selection.mergedPolygons;
  } else if (!hasModifierKey || !plotinfo.selection) {
    clearSelectionsCache(dragOptions);
  }

  // clear selection outline when selecting a different subplot
  if (!selectingOnSameSubplot) {
    clearOutline(gd);
    fullLayout._lastSelectedSubplot = plotinfo.id;
  }
}
function hasActiveShape(gd) {
  return gd._fullLayout._activeShapeIndex >= 0;
}
function hasActiveSelection(gd) {
  return gd._fullLayout._activeSelectionIndex >= 0;
}
function clearSelectionsCache(dragOptions, immediateSelect) {
  var dragmode = dragOptions.dragmode;
  var plotinfo = dragOptions.plotinfo;
  var gd = dragOptions.gd;
  if (hasActiveShape(gd)) {
    gd._fullLayout._deactivateShape(gd);
  }
  if (hasActiveSelection(gd)) {
    gd._fullLayout._deactivateSelection(gd);
  }
  var fullLayout = gd._fullLayout;
  var zoomLayer = fullLayout._zoomlayer;
  var isDrawMode = drawMode(dragmode);
  var isSelectMode = selectMode(dragmode);
  if (isDrawMode || isSelectMode) {
    var outlines = zoomLayer.selectAll('.select-outline-' + plotinfo.id);
    if (outlines && gd._fullLayout._outlining) {
      // add shape
      var shapes;
      if (isDrawMode) {
        shapes = newShapes(outlines, dragOptions);
      }
      if (shapes) {
        Registry.call('_guiRelayout', gd, {
          shapes: shapes
        });
      }

      // add selection
      var selections;
      if (isSelectMode && !hasSubplot(dragOptions) // only allow cartesian - no maps for now
      ) {
        selections = newSelections(outlines, dragOptions);
      }
      if (selections) {
        gd._fullLayout._noEmitSelectedAtStart = true;
        Registry.call('_guiRelayout', gd, {
          selections: selections
        }).then(function () {
          if (immediateSelect) {
            activateLastSelection(gd);
          }
        });
      }
      gd._fullLayout._outlining = false;
    }
  }
  plotinfo.selection = {};
  plotinfo.selection.selectionDefs = dragOptions.selectionDefs = [];
  plotinfo.selection.mergedPolygons = dragOptions.mergedPolygons = [];
}
function getAxId(ax) {
  return ax._id;
}
function determineSearchTraces(gd, xAxes, yAxes, subplot) {
  if (!gd.calcdata) return [];
  var searchTraces = [];
  var xAxisIds = xAxes.map(getAxId);
  var yAxisIds = yAxes.map(getAxId);
  var cd, trace, i;
  for (i = 0; i < gd.calcdata.length; i++) {
    cd = gd.calcdata[i];
    trace = cd[0].trace;
    if (trace.visible !== true || !trace._module || !trace._module.selectPoints) continue;
    if (hasSubplot({
      subplot: subplot
    }) && (trace.subplot === subplot || trace.geo === subplot)) {
      searchTraces.push(createSearchInfo(trace._module, cd, xAxes[0], yAxes[0]));
    } else if (trace.type === 'splom') {
      // FIXME: make sure we don't have more than single axis for splom
      if (trace._xaxes[xAxisIds[0]] && trace._yaxes[yAxisIds[0]]) {
        var info = createSearchInfo(trace._module, cd, xAxes[0], yAxes[0]);
        info.scene = gd._fullLayout._splomScenes[trace.uid];
        searchTraces.push(info);
      }
    } else if (trace.type === 'sankey') {
      var sankeyInfo = createSearchInfo(trace._module, cd, xAxes[0], yAxes[0]);
      searchTraces.push(sankeyInfo);
    } else {
      if (xAxisIds.indexOf(trace.xaxis) === -1 && (!trace._xA || !trace._xA.overlaying)) continue;
      if (yAxisIds.indexOf(trace.yaxis) === -1 && (!trace._yA || !trace._yA.overlaying)) continue;
      searchTraces.push(createSearchInfo(trace._module, cd, getFromId(gd, trace.xaxis), getFromId(gd, trace.yaxis)));
    }
  }
  return searchTraces;
}
function createSearchInfo(module, calcData, xaxis, yaxis) {
  return {
    _module: module,
    cd: calcData,
    xaxis: xaxis,
    yaxis: yaxis
  };
}
function isHoverDataSet(hoverData) {
  return hoverData && Array.isArray(hoverData) && hoverData[0].hoverOnBox !== true;
}
function extractClickedPtInfo(hoverData, searchTraces) {
  var hoverDatum = hoverData[0];
  var pointNumber = -1;
  var pointNumbers = [];
  var searchInfo, i;
  for (i = 0; i < searchTraces.length; i++) {
    searchInfo = searchTraces[i];
    if (hoverDatum.fullData._expandedIndex === searchInfo.cd[0].trace._expandedIndex) {
      // Special case for box (and violin)
      if (hoverDatum.hoverOnBox === true) {
        break;
      }

      // Hint: in some traces like histogram, one graphical element
      // doesn't correspond to one particular data point, but to
      // bins of data points. Thus, hoverDatum can have a binNumber
      // property instead of pointNumber.
      if (hoverDatum.pointNumber !== undefined) {
        pointNumber = hoverDatum.pointNumber;
      } else if (hoverDatum.binNumber !== undefined) {
        pointNumber = hoverDatum.binNumber;
        pointNumbers = hoverDatum.pointNumbers;
      }
      break;
    }
  }
  return {
    pointNumber: pointNumber,
    pointNumbers: pointNumbers,
    searchInfo: searchInfo
  };
}
function isPointOrBinSelected(clickedPtInfo) {
  var trace = clickedPtInfo.searchInfo.cd[0].trace;
  var ptNum = clickedPtInfo.pointNumber;
  var ptNums = clickedPtInfo.pointNumbers;
  var ptNumsSet = ptNums.length > 0;

  // When pointsNumbers is set (e.g. histogram's binning),
  // it is assumed that when the first point of
  // a bin is selected, all others are as well
  var ptNumToTest = ptNumsSet ? ptNums[0] : ptNum;

  // TODO potential performance improvement
  // Primarily we need this function to determine if a click adds
  // or subtracts from a selection.
  // In cases `trace.selectedpoints` is a huge array, indexOf
  // might be slow. One remedy would be to introduce a hash somewhere.
  return trace.selectedpoints ? trace.selectedpoints.indexOf(ptNumToTest) > -1 : false;
}
function isOnlyThisBinSelected(searchTraces, clickedPtInfo) {
  var tracesWithSelectedPts = [];
  var searchInfo, trace, isSameTrace, i;
  for (i = 0; i < searchTraces.length; i++) {
    searchInfo = searchTraces[i];
    if (searchInfo.cd[0].trace.selectedpoints && searchInfo.cd[0].trace.selectedpoints.length > 0) {
      tracesWithSelectedPts.push(searchInfo);
    }
  }
  if (tracesWithSelectedPts.length === 1) {
    isSameTrace = tracesWithSelectedPts[0] === clickedPtInfo.searchInfo;
    if (isSameTrace) {
      trace = clickedPtInfo.searchInfo.cd[0].trace;
      if (trace.selectedpoints.length === clickedPtInfo.pointNumbers.length) {
        for (i = 0; i < clickedPtInfo.pointNumbers.length; i++) {
          if (trace.selectedpoints.indexOf(clickedPtInfo.pointNumbers[i]) < 0) {
            return false;
          }
        }
        return true;
      }
    }
  }
  return false;
}
function isOnlyOnePointSelected(searchTraces) {
  var len = 0;
  var searchInfo, trace, i;
  for (i = 0; i < searchTraces.length; i++) {
    searchInfo = searchTraces[i];
    trace = searchInfo.cd[0].trace;
    if (trace.selectedpoints) {
      if (trace.selectedpoints.length > 1) return false;
      len += trace.selectedpoints.length;
      if (len > 1) return false;
    }
  }
  return len === 1;
}
function updateSelectedState(gd, searchTraces, eventData) {
  var i;

  // before anything else, update preGUI if necessary
  for (i = 0; i < searchTraces.length; i++) {
    var fullInputTrace = searchTraces[i].cd[0].trace._fullInput;
    var tracePreGUI = gd._fullLayout._tracePreGUI[fullInputTrace.uid] || {};
    if (tracePreGUI.selectedpoints === undefined) {
      tracePreGUI.selectedpoints = fullInputTrace._input.selectedpoints || null;
    }
  }
  var trace;
  if (eventData) {
    var pts = eventData.points || [];
    for (i = 0; i < searchTraces.length; i++) {
      trace = searchTraces[i].cd[0].trace;
      trace._input.selectedpoints = trace._fullInput.selectedpoints = [];
      if (trace._fullInput !== trace) trace.selectedpoints = [];
    }
    for (var k = 0; k < pts.length; k++) {
      var pt = pts[k];
      var data = pt.data;
      var fullData = pt.fullData;
      var pointIndex = pt.pointIndex;
      var pointIndices = pt.pointIndices;
      if (pointIndices) {
        [].push.apply(data.selectedpoints, pointIndices);
        if (trace._fullInput !== trace) {
          [].push.apply(fullData.selectedpoints, pointIndices);
        }
      } else {
        data.selectedpoints.push(pointIndex);
        if (trace._fullInput !== trace) {
          fullData.selectedpoints.push(pointIndex);
        }
      }
    }
  } else {
    for (i = 0; i < searchTraces.length; i++) {
      trace = searchTraces[i].cd[0].trace;
      delete trace.selectedpoints;
      delete trace._input.selectedpoints;
      if (trace._fullInput !== trace) {
        delete trace._fullInput.selectedpoints;
      }
    }
  }
  updateReglSelectedState(gd, searchTraces);
}
function updateReglSelectedState(gd, searchTraces) {
  var hasRegl = false;
  for (var i = 0; i < searchTraces.length; i++) {
    var searchInfo = searchTraces[i];
    var cd = searchInfo.cd;
    if (Registry.traceIs(cd[0].trace, 'regl')) {
      hasRegl = true;
    }
    var _module = searchInfo._module;
    var fn = _module.styleOnSelect || _module.style;
    if (fn) {
      fn(gd, cd, cd[0].node3);
      if (cd[0].nodeRangePlot3) fn(gd, cd, cd[0].nodeRangePlot3);
    }
  }
  if (hasRegl) {
    clearGlCanvases(gd);
    redrawReglTraces(gd);
  }
}
function mergePolygons(list, poly, subtract) {
  var fn = subtract ? polybool.difference : polybool.union;
  var res = fn({
    regions: list
  }, {
    regions: [poly]
  });
  var allPolygons = res.regions.reverse();
  for (var i = 0; i < allPolygons.length; i++) {
    var polygon = allPolygons[i];
    polygon.subtract = getSubtract(polygon, allPolygons.slice(0, i));
  }
  return allPolygons;
}
function fillSelectionItem(selection, searchInfo) {
  if (Array.isArray(selection)) {
    var cd = searchInfo.cd;
    var trace = searchInfo.cd[0].trace;
    for (var i = 0; i < selection.length; i++) {
      selection[i] = makeEventData(selection[i], trace, cd);
    }
  }
  return selection;
}
function convertPoly(polygonsIn, isOpenMode) {
  // add M and L command to draft positions
  var polygonsOut = [];
  for (var i = 0; i < polygonsIn.length; i++) {
    polygonsOut[i] = [];
    for (var j = 0; j < polygonsIn[i].length; j++) {
      polygonsOut[i][j] = [];
      polygonsOut[i][j][0] = j ? 'L' : 'M';
      for (var k = 0; k < polygonsIn[i][j].length; k++) {
        polygonsOut[i][j].push(polygonsIn[i][j][k]);
      }
    }
    if (!isOpenMode) {
      polygonsOut[i].push(['Z', polygonsOut[i][0][1],
      // initial x
      polygonsOut[i][0][2] // initial y
      ]);
    }
  }
  return polygonsOut;
}
function _doSelect(selectionTesters, searchTraces) {
  var allSelections = [];
  var thisSelection;
  var traceSelections = [];
  var traceSelection;
  for (var i = 0; i < searchTraces.length; i++) {
    var searchInfo = searchTraces[i];
    traceSelection = searchInfo._module.selectPoints(searchInfo, selectionTesters);
    traceSelections.push(traceSelection);
    thisSelection = fillSelectionItem(traceSelection, searchInfo);
    allSelections = allSelections.concat(thisSelection);
  }
  return allSelections;
}
function reselect(gd, mayEmitSelected, selectionTesters, searchTraces, dragOptions) {
  var hadSearchTraces = !!searchTraces;
  var plotinfo, xRef, yRef;
  if (dragOptions) {
    plotinfo = dragOptions.plotinfo;
    xRef = dragOptions.xaxes[0]._id;
    yRef = dragOptions.yaxes[0]._id;
  }
  var allSelections = [];
  var allSearchTraces = [];

  // select layout.selection polygons
  var layoutPolygons = getLayoutPolygons(gd);

  // add draft outline polygons to layoutPolygons
  var fullLayout = gd._fullLayout;
  if (plotinfo) {
    var zoomLayer = fullLayout._zoomlayer;
    var mode = fullLayout.dragmode;
    var isDrawMode = drawMode(mode);
    var isSelectMode = selectMode(mode);
    if (isDrawMode || isSelectMode) {
      var xaxis = getFromId(gd, xRef, 'x');
      var yaxis = getFromId(gd, yRef, 'y');
      if (xaxis && yaxis) {
        var outlines = zoomLayer.selectAll('.select-outline-' + plotinfo.id);
        if (outlines && gd._fullLayout._outlining) {
          if (outlines.length) {
            var e = outlines[0][0]; // pick first
            var d = e.getAttribute('d');
            var outlinePolys = readPaths(d, gd, plotinfo);
            var draftPolygons = [];
            for (var u = 0; u < outlinePolys.length; u++) {
              var p = outlinePolys[u];
              var polygon = [];
              for (var t = 0; t < p.length; t++) {
                polygon.push([convert(xaxis, p[t][1]), convert(yaxis, p[t][2])]);
              }
              polygon.xref = xRef;
              polygon.yref = yRef;
              polygon.subtract = getSubtract(polygon, draftPolygons);
              draftPolygons.push(polygon);
            }
            layoutPolygons = layoutPolygons.concat(draftPolygons);
          }
        }
      }
    }
  }
  var subplots = xRef && yRef ? [xRef + yRef] : fullLayout._subplots.cartesian;
  epmtySplomSelectionBatch(gd);
  var seenSplom = {};
  for (var i = 0; i < subplots.length; i++) {
    var subplot = subplots[i];
    var yAt = subplot.indexOf('y');
    var _xRef = subplot.slice(0, yAt);
    var _yRef = subplot.slice(yAt);
    var _selectionTesters = xRef && yRef ? selectionTesters : undefined;
    _selectionTesters = addTester(layoutPolygons, _xRef, _yRef, _selectionTesters);
    if (_selectionTesters) {
      var _searchTraces = searchTraces;
      if (!hadSearchTraces) {
        var _xA = getFromId(gd, _xRef, 'x');
        var _yA = getFromId(gd, _yRef, 'y');
        _searchTraces = determineSearchTraces(gd, [_xA], [_yA], subplot);
        for (var w = 0; w < _searchTraces.length; w++) {
          var s = _searchTraces[w];
          var cd0 = s.cd[0];
          var trace = cd0.trace;
          if (s._module.name === 'scattergl' && !cd0.t.xpx) {
            var x = trace.x;
            var y = trace.y;
            var len = trace._length;
            // generate stash for scattergl
            cd0.t.xpx = [];
            cd0.t.ypx = [];
            for (var j = 0; j < len; j++) {
              cd0.t.xpx[j] = _xA.c2p(x[j]);
              cd0.t.ypx[j] = _yA.c2p(y[j]);
            }
          }
          if (s._module.name === 'splom') {
            if (!seenSplom[trace.uid]) {
              seenSplom[trace.uid] = true;
            }
          }
        }
      }
      var selection = _doSelect(_selectionTesters, _searchTraces);
      allSelections = allSelections.concat(selection);
      allSearchTraces = allSearchTraces.concat(_searchTraces);
    }
  }
  var eventData = {
    points: allSelections
  };
  updateSelectedState(gd, allSearchTraces, eventData);
  var clickmode = fullLayout.clickmode;
  var sendEvents = clickmode.indexOf('event') > -1 && mayEmitSelected;
  if (!plotinfo &&
  // get called from plot_api & plots
  mayEmitSelected) {
    var activePolygons = getLayoutPolygons(gd, true);
    if (activePolygons.length) {
      var xref = activePolygons[0].xref;
      var yref = activePolygons[0].yref;
      if (xref && yref) {
        var poly = castMultiPolygon(activePolygons);
        var fillRangeItems = makeFillRangeItems([getFromId(gd, xref, 'x'), getFromId(gd, yref, 'y')]);
        fillRangeItems(eventData, poly);
      }
    }
    if (gd._fullLayout._noEmitSelectedAtStart) {
      gd._fullLayout._noEmitSelectedAtStart = false;
    } else {
      if (sendEvents) emitSelected(gd, eventData);
    }
    fullLayout._reselect = false;
  }
  if (!plotinfo &&
  // get called from plot_api & plots
  fullLayout._deselect) {
    var deselect = fullLayout._deselect;
    xRef = deselect.xref;
    yRef = deselect.yref;
    if (!subplotSelected(xRef, yRef, allSearchTraces)) {
      deselectSubplot(gd, xRef, yRef, searchTraces);
    }
    if (sendEvents) {
      if (eventData.points.length) {
        emitSelected(gd, eventData);
      } else {
        emitDeselect(gd);
      }
    }
    fullLayout._deselect = false;
  }
  return {
    eventData: eventData,
    selectionTesters: selectionTesters
  };
}
function epmtySplomSelectionBatch(gd) {
  var cd = gd.calcdata;
  if (!cd) return;
  for (var i = 0; i < cd.length; i++) {
    var cd0 = cd[i][0];
    var trace = cd0.trace;
    var splomScenes = gd._fullLayout._splomScenes;
    if (splomScenes) {
      var scene = splomScenes[trace.uid];
      if (scene) {
        scene.selectBatch = [];
      }
    }
  }
}
function subplotSelected(xRef, yRef, searchTraces) {
  for (var i = 0; i < searchTraces.length; i++) {
    var s = searchTraces[i];
    if (s.xaxis && s.xaxis._id === xRef && s.yaxis && s.yaxis._id === yRef) {
      return true;
    }
  }
  return false;
}
function deselectSubplot(gd, xRef, yRef, searchTraces) {
  searchTraces = determineSearchTraces(gd, [getFromId(gd, xRef, 'x')], [getFromId(gd, yRef, 'y')], xRef + yRef);
  for (var k = 0; k < searchTraces.length; k++) {
    var searchInfo = searchTraces[k];
    searchInfo._module.selectPoints(searchInfo, false);
  }
  updateSelectedState(gd, searchTraces);
}
function addTester(layoutPolygons, xRef, yRef, selectionTesters) {
  var mergedPolygons;
  for (var i = 0; i < layoutPolygons.length; i++) {
    var currentPolygon = layoutPolygons[i];
    if (xRef !== currentPolygon.xref || yRef !== currentPolygon.yref) continue;
    if (mergedPolygons) {
      var subtract = !!currentPolygon.subtract;
      mergedPolygons = mergePolygons(mergedPolygons, currentPolygon, subtract);
      selectionTesters = multiTester(mergedPolygons);
    } else {
      mergedPolygons = [currentPolygon];
      selectionTesters = polygonTester(currentPolygon);
    }
  }
  return selectionTesters;
}
function getLayoutPolygons(gd, onlyActiveOnes) {
  var allPolygons = [];
  var fullLayout = gd._fullLayout;
  var allSelections = fullLayout.selections;
  var len = allSelections.length;
  for (var i = 0; i < len; i++) {
    if (onlyActiveOnes && i !== fullLayout._activeSelectionIndex) continue;
    var selection = allSelections[i];
    if (!selection) continue;
    var xref = selection.xref;
    var yref = selection.yref;
    var xaxis = getFromId(gd, xref, 'x');
    var yaxis = getFromId(gd, yref, 'y');
    var xmin, xmax, ymin, ymax;
    var polygon;
    if (selection.type === 'rect') {
      polygon = [];
      var x0 = convert(xaxis, selection.x0);
      var x1 = convert(xaxis, selection.x1);
      var y0 = convert(yaxis, selection.y0);
      var y1 = convert(yaxis, selection.y1);
      polygon = [[x0, y0], [x0, y1], [x1, y1], [x1, y0]];
      xmin = Math.min(x0, x1);
      xmax = Math.max(x0, x1);
      ymin = Math.min(y0, y1);
      ymax = Math.max(y0, y1);
      polygon.xmin = xmin;
      polygon.xmax = xmax;
      polygon.ymin = ymin;
      polygon.ymax = ymax;
      polygon.xref = xref;
      polygon.yref = yref;
      polygon.subtract = false;
      polygon.isRect = true;
      allPolygons.push(polygon);
    } else if (selection.type === 'path') {
      var segments = selection.path.split('Z');
      var multiPolygons = [];
      for (var j = 0; j < segments.length; j++) {
        var path = segments[j];
        if (!path) continue;
        path += 'Z';
        var allX = shapeHelpers.extractPathCoords(path, shapeConstants.paramIsX, 'raw');
        var allY = shapeHelpers.extractPathCoords(path, shapeConstants.paramIsY, 'raw');
        xmin = Infinity;
        xmax = -Infinity;
        ymin = Infinity;
        ymax = -Infinity;
        polygon = [];
        for (var k = 0; k < allX.length; k++) {
          var x = convert(xaxis, allX[k]);
          var y = convert(yaxis, allY[k]);
          polygon.push([x, y]);
          xmin = Math.min(x, xmin);
          xmax = Math.max(x, xmax);
          ymin = Math.min(y, ymin);
          ymax = Math.max(y, ymax);
        }
        polygon.xmin = xmin;
        polygon.xmax = xmax;
        polygon.ymin = ymin;
        polygon.ymax = ymax;
        polygon.xref = xref;
        polygon.yref = yref;
        polygon.subtract = getSubtract(polygon, multiPolygons);
        multiPolygons.push(polygon);
        allPolygons.push(polygon);
      }
    }
  }
  return allPolygons;
}
function getSubtract(polygon, previousPolygons) {
  var subtract = false;
  for (var i = 0; i < previousPolygons.length; i++) {
    var previousPolygon = previousPolygons[i];

    // find out if a point of polygon is inside previous polygons
    for (var k = 0; k < polygon.length; k++) {
      if (pointInPolygon(polygon[k], previousPolygon)) {
        subtract = !subtract;
        break;
      }
    }
  }
  return subtract;
}
function convert(ax, d) {
  if (ax.type === 'date') d = d.replace('_', ' ');
  return ax.type === 'log' ? ax.c2p(d) : ax.r2p(d, null, ax.calendar);
}
function castMultiPolygon(allPolygons) {
  var len = allPolygons.length;

  // descibe multi polygons in one polygon
  var p = [];
  for (var i = 0; i < len; i++) {
    var polygon = allPolygons[i];
    p = p.concat(polygon);

    // add starting vertex to close
    // which indicates next polygon
    p = p.concat([polygon[0]]);
  }
  return computeRectAndRanges(p);
}
function computeRectAndRanges(poly) {
  poly.isRect = poly.length === 5 && poly[0][0] === poly[4][0] && poly[0][1] === poly[4][1] && poly[0][0] === poly[1][0] && poly[2][0] === poly[3][0] && poly[0][1] === poly[3][1] && poly[1][1] === poly[2][1] || poly[0][1] === poly[1][1] && poly[2][1] === poly[3][1] && poly[0][0] === poly[3][0] && poly[1][0] === poly[2][0];
  if (poly.isRect) {
    poly.xmin = Math.min(poly[0][0], poly[2][0]);
    poly.xmax = Math.max(poly[0][0], poly[2][0]);
    poly.ymin = Math.min(poly[0][1], poly[2][1]);
    poly.ymax = Math.max(poly[0][1], poly[2][1]);
  }
  return poly;
}
function makeFillRangeItems(allAxes) {
  return function (eventData, poly) {
    var range;
    var lassoPoints;
    for (var i = 0; i < allAxes.length; i++) {
      var ax = allAxes[i];
      var id = ax._id;
      var axLetter = id.charAt(0);
      if (poly.isRect) {
        if (!range) range = {};
        var min = poly[axLetter + 'min'];
        var max = poly[axLetter + 'max'];
        if (min !== undefined && max !== undefined) {
          range[id] = [p2r(ax, min), p2r(ax, max)].sort(ascending);
        }
      } else {
        if (!lassoPoints) lassoPoints = {};
        lassoPoints[id] = poly.map(axValue(ax));
      }
    }
    if (range) {
      eventData.range = range;
    }
    if (lassoPoints) {
      eventData.lassoPoints = lassoPoints;
    }
  };
}
function getFillRangeItems(dragOptions) {
  var plotinfo = dragOptions.plotinfo;
  return plotinfo.fillRangeItems ||
  // allow subplots (i.e. geo, mapbox, map, sankey) to override fillRangeItems routine
  makeFillRangeItems(dragOptions.xaxes.concat(dragOptions.yaxes));
}
function emitSelecting(gd, eventData) {
  gd.emit('plotly_selecting', eventData);
}
function emitSelected(gd, eventData) {
  if (eventData) {
    eventData.selections = (gd.layout || {}).selections || [];
  }
  gd.emit('plotly_selected', eventData);
}
function emitDeselect(gd) {
  gd.emit('plotly_deselect', null);
}
module.exports = {
  reselect: reselect,
  prepSelect: prepSelect,
  clearOutline: clearOutline,
  clearSelectionsCache: clearSelectionsCache,
  selectOnClick: selectOnClick
};

/***/ }),

/***/ 43144:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var annAttrs = __webpack_require__(50222);
var fontAttrs = __webpack_require__(80337);
var scatterLineAttrs = (__webpack_require__(36640).line);
var dash = (__webpack_require__(94850)/* .dash */ .T);
var extendFlat = (__webpack_require__(93049).extendFlat);
var templatedArray = (__webpack_require__(78032).templatedArray);
var axisPlaceableObjs = __webpack_require__(35081);
var basePlotAttributes = __webpack_require__(9829);
var shapeTexttemplateAttrs = (__webpack_require__(3208)/* .shapeTexttemplateAttrs */ .LF);
var shapeLabelTexttemplateVars = __webpack_require__(41235);
module.exports = templatedArray('shape', {
  visible: extendFlat({}, basePlotAttributes.visible, {
    editType: 'calc+arraydraw'
  }),
  showlegend: {
    valType: 'boolean',
    dflt: false,
    editType: 'calc+arraydraw'
  },
  legend: extendFlat({}, basePlotAttributes.legend, {
    editType: 'calc+arraydraw'
  }),
  legendgroup: extendFlat({}, basePlotAttributes.legendgroup, {
    editType: 'calc+arraydraw'
  }),
  legendgrouptitle: {
    text: extendFlat({}, basePlotAttributes.legendgrouptitle.text, {
      editType: 'calc+arraydraw'
    }),
    font: fontAttrs({
      editType: 'calc+arraydraw'
    }),
    editType: 'calc+arraydraw'
  },
  legendrank: extendFlat({}, basePlotAttributes.legendrank, {
    editType: 'calc+arraydraw'
  }),
  legendwidth: extendFlat({}, basePlotAttributes.legendwidth, {
    editType: 'calc+arraydraw'
  }),
  type: {
    valType: 'enumerated',
    values: ['circle', 'rect', 'path', 'line'],
    editType: 'calc+arraydraw'
  },
  layer: {
    valType: 'enumerated',
    values: ['below', 'above', 'between'],
    dflt: 'above',
    editType: 'arraydraw'
  },
  xref: extendFlat({}, annAttrs.xref, {}),
  xsizemode: {
    valType: 'enumerated',
    values: ['scaled', 'pixel'],
    dflt: 'scaled',
    editType: 'calc+arraydraw'
  },
  xanchor: {
    valType: 'any',
    editType: 'calc+arraydraw'
  },
  x0: {
    valType: 'any',
    editType: 'calc+arraydraw'
  },
  x1: {
    valType: 'any',
    editType: 'calc+arraydraw'
  },
  x0shift: {
    valType: 'number',
    dflt: 0,
    min: -1,
    max: 1,
    editType: 'calc'
  },
  x1shift: {
    valType: 'number',
    dflt: 0,
    min: -1,
    max: 1,
    editType: 'calc'
  },
  yref: extendFlat({}, annAttrs.yref, {}),
  ysizemode: {
    valType: 'enumerated',
    values: ['scaled', 'pixel'],
    dflt: 'scaled',
    editType: 'calc+arraydraw'
  },
  yanchor: {
    valType: 'any',
    editType: 'calc+arraydraw'
  },
  y0: {
    valType: 'any',
    editType: 'calc+arraydraw'
  },
  y1: {
    valType: 'any',
    editType: 'calc+arraydraw'
  },
  y0shift: {
    valType: 'number',
    dflt: 0,
    min: -1,
    max: 1,
    editType: 'calc'
  },
  y1shift: {
    valType: 'number',
    dflt: 0,
    min: -1,
    max: 1,
    editType: 'calc'
  },
  path: {
    valType: 'string',
    editType: 'calc+arraydraw'
  },
  opacity: {
    valType: 'number',
    min: 0,
    max: 1,
    dflt: 1,
    editType: 'arraydraw'
  },
  line: {
    color: extendFlat({}, scatterLineAttrs.color, {
      editType: 'arraydraw'
    }),
    width: extendFlat({}, scatterLineAttrs.width, {
      editType: 'calc+arraydraw'
    }),
    dash: extendFlat({}, dash, {
      editType: 'arraydraw'
    }),
    editType: 'calc+arraydraw'
  },
  fillcolor: {
    valType: 'color',
    dflt: 'rgba(0,0,0,0)',
    editType: 'arraydraw'
  },
  fillrule: {
    valType: 'enumerated',
    values: ['evenodd', 'nonzero'],
    dflt: 'evenodd',
    editType: 'arraydraw'
  },
  editable: {
    valType: 'boolean',
    dflt: false,
    editType: 'calc+arraydraw'
  },
  label: {
    text: {
      valType: 'string',
      dflt: '',
      editType: 'arraydraw'
    },
    texttemplate: shapeTexttemplateAttrs({}, {
      keys: Object.keys(shapeLabelTexttemplateVars)
    }),
    font: fontAttrs({
      editType: 'calc+arraydraw',
      colorEditType: 'arraydraw'
    }),
    textposition: {
      valType: 'enumerated',
      values: ['top left', 'top center', 'top right', 'middle left', 'middle center', 'middle right', 'bottom left', 'bottom center', 'bottom right', 'start', 'middle', 'end'],
      editType: 'arraydraw'
    },
    textangle: {
      valType: 'angle',
      dflt: 'auto',
      editType: 'calc+arraydraw'
    },
    xanchor: {
      valType: 'enumerated',
      values: ['auto', 'left', 'center', 'right'],
      dflt: 'auto',
      editType: 'calc+arraydraw'
    },
    yanchor: {
      valType: 'enumerated',
      values: ['top', 'middle', 'bottom'],
      editType: 'calc+arraydraw'
    },
    padding: {
      valType: 'number',
      dflt: 3,
      min: 0,
      editType: 'arraydraw'
    },
    editType: 'arraydraw'
  },
  editType: 'arraydraw'
});

/***/ }),

/***/ 44959:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var Axes = __webpack_require__(29714);
var constants = __webpack_require__(2956);
var helpers = __webpack_require__(49728);
module.exports = function calcAutorange(gd) {
  var fullLayout = gd._fullLayout;
  var shapeList = Lib.filterVisible(fullLayout.shapes);
  if (!shapeList.length || !gd._fullData.length) return;
  for (var i = 0; i < shapeList.length; i++) {
    var shape = shapeList[i];
    shape._extremes = {};
    var ax;
    var bounds;
    var xRefType = Axes.getRefType(shape.xref);
    var yRefType = Axes.getRefType(shape.yref);

    // paper and axis domain referenced shapes don't affect autorange
    if (shape.xref !== 'paper' && xRefType !== 'domain') {
      ax = Axes.getFromId(gd, shape.xref);
      bounds = shapeBounds(ax, shape, constants.paramIsX);
      if (bounds) {
        shape._extremes[ax._id] = Axes.findExtremes(ax, bounds, calcXPaddingOptions(shape));
      }
    }
    if (shape.yref !== 'paper' && yRefType !== 'domain') {
      ax = Axes.getFromId(gd, shape.yref);
      bounds = shapeBounds(ax, shape, constants.paramIsY);
      if (bounds) {
        shape._extremes[ax._id] = Axes.findExtremes(ax, bounds, calcYPaddingOptions(shape));
      }
    }
  }
};
function calcXPaddingOptions(shape) {
  return calcPaddingOptions(shape.line.width, shape.xsizemode, shape.x0, shape.x1, shape.path, false);
}
function calcYPaddingOptions(shape) {
  return calcPaddingOptions(shape.line.width, shape.ysizemode, shape.y0, shape.y1, shape.path, true);
}
function calcPaddingOptions(lineWidth, sizeMode, v0, v1, path, isYAxis) {
  var ppad = lineWidth / 2;
  var axisDirectionReverted = isYAxis;
  if (sizeMode === 'pixel') {
    var coords = path ? helpers.extractPathCoords(path, isYAxis ? constants.paramIsY : constants.paramIsX) : [v0, v1];
    var maxValue = Lib.aggNums(Math.max, null, coords);
    var minValue = Lib.aggNums(Math.min, null, coords);
    var beforePad = minValue < 0 ? Math.abs(minValue) + ppad : ppad;
    var afterPad = maxValue > 0 ? maxValue + ppad : ppad;
    return {
      ppad: ppad,
      ppadplus: axisDirectionReverted ? beforePad : afterPad,
      ppadminus: axisDirectionReverted ? afterPad : beforePad
    };
  } else {
    return {
      ppad: ppad
    };
  }
}
function shapeBounds(ax, shape, paramsToUse) {
  var dim = ax._id.charAt(0) === 'x' ? 'x' : 'y';
  var isCategory = ax.type === 'category' || ax.type === 'multicategory';
  var v0;
  var v1;
  var shiftStart = 0;
  var shiftEnd = 0;
  var convertVal = isCategory ? ax.r2c : ax.d2c;
  var isSizeModeScale = shape[dim + 'sizemode'] === 'scaled';
  if (isSizeModeScale) {
    v0 = shape[dim + '0'];
    v1 = shape[dim + '1'];
    if (isCategory) {
      shiftStart = shape[dim + '0shift'];
      shiftEnd = shape[dim + '1shift'];
    }
  } else {
    v0 = shape[dim + 'anchor'];
    v1 = shape[dim + 'anchor'];
  }
  if (v0 !== undefined) return [convertVal(v0) + shiftStart, convertVal(v1) + shiftEnd];
  if (!shape.path) return;
  var min = Infinity;
  var max = -Infinity;
  var segments = shape.path.match(constants.segmentRE);
  var i;
  var segment;
  var drawnParam;
  var params;
  var val;
  if (ax.type === 'date') convertVal = helpers.decodeDate(convertVal);
  for (i = 0; i < segments.length; i++) {
    segment = segments[i];
    drawnParam = paramsToUse[segment.charAt(0)].drawn;
    if (drawnParam === undefined) continue;
    params = segments[i].substr(1).match(constants.paramRE);
    if (!params || params.length < drawnParam) continue;
    val = convertVal(params[drawnParam]);
    if (val < min) min = val;
    if (val > max) max = val;
  }
  if (max >= min) return [min, max];
}

/***/ }),

/***/ 2956:
/***/ (function(module) {

"use strict";


module.exports = {
  segmentRE: /[MLHVQCTSZ][^MLHVQCTSZ]*/g,
  paramRE: /[^\s,]+/g,
  // which numbers in each path segment are x (or y) values
  // drawn is which param is a drawn point, as opposed to a
  // control point (which doesn't count toward autorange.
  // TODO: this means curved paths could extend beyond the
  // autorange bounds. This is a bit tricky to get right
  // unless we revert to bounding boxes, but perhaps there's
  // a calculation we could do...)
  paramIsX: {
    M: {
      0: true,
      drawn: 0
    },
    L: {
      0: true,
      drawn: 0
    },
    H: {
      0: true,
      drawn: 0
    },
    V: {},
    Q: {
      0: true,
      2: true,
      drawn: 2
    },
    C: {
      0: true,
      2: true,
      4: true,
      drawn: 4
    },
    T: {
      0: true,
      drawn: 0
    },
    S: {
      0: true,
      2: true,
      drawn: 2
    },
    // A: {0: true, 5: true},
    Z: {}
  },
  paramIsY: {
    M: {
      1: true,
      drawn: 1
    },
    L: {
      1: true,
      drawn: 1
    },
    H: {},
    V: {
      0: true,
      drawn: 0
    },
    Q: {
      1: true,
      3: true,
      drawn: 3
    },
    C: {
      1: true,
      3: true,
      5: true,
      drawn: 5
    },
    T: {
      1: true,
      drawn: 1
    },
    S: {
      1: true,
      3: true,
      drawn: 5
    },
    // A: {1: true, 6: true},
    Z: {}
  },
  numParams: {
    M: 2,
    L: 2,
    H: 1,
    V: 1,
    Q: 4,
    C: 6,
    T: 2,
    S: 4,
    // A: 7,
    Z: 0
  }
};

/***/ }),

/***/ 74367:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var Axes = __webpack_require__(29714);
var handleArrayContainerDefaults = __webpack_require__(59008);
var attributes = __webpack_require__(43144);
var helpers = __webpack_require__(49728);
module.exports = function supplyLayoutDefaults(layoutIn, layoutOut) {
  handleArrayContainerDefaults(layoutIn, layoutOut, {
    name: 'shapes',
    handleItemDefaults: handleShapeDefaults
  });
};
function dfltLabelYanchor(isLine, labelTextPosition) {
  // If shape is a line, default y-anchor is 'bottom' (so that text is above line by default)
  // Otherwise, default y-anchor is equal to y-component of `textposition`
  // (so that text is positioned inside shape bounding box by default)
  return isLine ? 'bottom' : labelTextPosition.indexOf('top') !== -1 ? 'top' : labelTextPosition.indexOf('bottom') !== -1 ? 'bottom' : 'middle';
}
function handleShapeDefaults(shapeIn, shapeOut, fullLayout) {
  function coerce(attr, dflt) {
    return Lib.coerce(shapeIn, shapeOut, attributes, attr, dflt);
  }
  shapeOut._isShape = true;
  var visible = coerce('visible');
  if (!visible) return;
  var showlegend = coerce('showlegend');
  if (showlegend) {
    coerce('legend');
    coerce('legendwidth');
    coerce('legendgroup');
    coerce('legendgrouptitle.text');
    Lib.coerceFont(coerce, 'legendgrouptitle.font');
    coerce('legendrank');
  }
  var path = coerce('path');
  var dfltType = path ? 'path' : 'rect';
  var shapeType = coerce('type', dfltType);
  var noPath = shapeType !== 'path';
  if (noPath) delete shapeOut.path;
  coerce('editable');
  coerce('layer');
  coerce('opacity');
  coerce('fillcolor');
  coerce('fillrule');
  var lineWidth = coerce('line.width');
  if (lineWidth) {
    coerce('line.color');
    coerce('line.dash');
  }
  var xSizeMode = coerce('xsizemode');
  var ySizeMode = coerce('ysizemode');

  // positioning
  var axLetters = ['x', 'y'];
  for (var i = 0; i < 2; i++) {
    var axLetter = axLetters[i];
    var attrAnchor = axLetter + 'anchor';
    var sizeMode = axLetter === 'x' ? xSizeMode : ySizeMode;
    var gdMock = {
      _fullLayout: fullLayout
    };
    var ax;
    var pos2r;
    var r2pos;

    // xref, yref
    var axRef = Axes.coerceRef(shapeIn, shapeOut, gdMock, axLetter, undefined, 'paper');
    var axRefType = Axes.getRefType(axRef);
    if (axRefType === 'range') {
      ax = Axes.getFromId(gdMock, axRef);
      ax._shapeIndices.push(shapeOut._index);
      r2pos = helpers.rangeToShapePosition(ax);
      pos2r = helpers.shapePositionToRange(ax);
      if (ax.type === 'category' || ax.type === 'multicategory') {
        coerce(axLetter + '0shift');
        coerce(axLetter + '1shift');
      }
    } else {
      pos2r = r2pos = Lib.identity;
    }

    // Coerce x0, x1, y0, y1
    if (noPath) {
      var dflt0 = 0.25;
      var dflt1 = 0.75;

      // hack until V3.0 when log has regular range behavior - make it look like other
      // ranges to send to coerce, then put it back after
      // this is all to give reasonable default position behavior on log axes, which is
      // a pretty unimportant edge case so we could just ignore this.
      var attr0 = axLetter + '0';
      var attr1 = axLetter + '1';
      var in0 = shapeIn[attr0];
      var in1 = shapeIn[attr1];
      shapeIn[attr0] = pos2r(shapeIn[attr0], true);
      shapeIn[attr1] = pos2r(shapeIn[attr1], true);
      if (sizeMode === 'pixel') {
        coerce(attr0, 0);
        coerce(attr1, 10);
      } else {
        Axes.coercePosition(shapeOut, gdMock, coerce, axRef, attr0, dflt0);
        Axes.coercePosition(shapeOut, gdMock, coerce, axRef, attr1, dflt1);
      }

      // hack part 2
      shapeOut[attr0] = r2pos(shapeOut[attr0]);
      shapeOut[attr1] = r2pos(shapeOut[attr1]);
      shapeIn[attr0] = in0;
      shapeIn[attr1] = in1;
    }

    // Coerce xanchor and yanchor
    if (sizeMode === 'pixel') {
      // Hack for log axis described above
      var inAnchor = shapeIn[attrAnchor];
      shapeIn[attrAnchor] = pos2r(shapeIn[attrAnchor], true);
      Axes.coercePosition(shapeOut, gdMock, coerce, axRef, attrAnchor, 0.25);

      // Hack part 2
      shapeOut[attrAnchor] = r2pos(shapeOut[attrAnchor]);
      shapeIn[attrAnchor] = inAnchor;
    }
  }
  if (noPath) {
    Lib.noneOrAll(shapeIn, shapeOut, ['x0', 'x1', 'y0', 'y1']);
  }

  // Label options
  var isLine = shapeType === 'line';
  var labelTextTemplate, labelText;
  if (noPath) {
    labelTextTemplate = coerce('label.texttemplate');
  }
  if (!labelTextTemplate) {
    labelText = coerce('label.text');
  }
  if (labelText || labelTextTemplate) {
    coerce('label.textangle');
    var labelTextPosition = coerce('label.textposition', isLine ? 'middle' : 'middle center');
    coerce('label.xanchor');
    coerce('label.yanchor', dfltLabelYanchor(isLine, labelTextPosition));
    coerce('label.padding');
    Lib.coerceFont(coerce, 'label.font', fullLayout.font);
  }
}

/***/ }),

/***/ 44433:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var Axes = __webpack_require__(29714);
var svgTextUtils = __webpack_require__(30635);
var Drawing = __webpack_require__(62203);
var readPaths = (__webpack_require__(81055).readPaths);
var helpers = __webpack_require__(49728);
var getPathString = helpers.getPathString;
var shapeLabelTexttemplateVars = __webpack_require__(41235);
var FROM_TL = (__webpack_require__(4530).FROM_TL);
module.exports = function drawLabel(gd, index, options, shapeGroup) {
  // Remove existing label
  shapeGroup.selectAll('.shape-label').remove();

  // If no label text or texttemplate, return
  if (!(options.label.text || options.label.texttemplate)) return;

  // Text template overrides text
  var text;
  if (options.label.texttemplate) {
    var templateValues = {};
    if (options.type !== 'path') {
      var _xa = Axes.getFromId(gd, options.xref);
      var _ya = Axes.getFromId(gd, options.yref);
      for (var key in shapeLabelTexttemplateVars) {
        var val = shapeLabelTexttemplateVars[key](options, _xa, _ya);
        if (val !== undefined) templateValues[key] = val;
      }
    }
    text = Lib.texttemplateStringForShapes(options.label.texttemplate, {}, gd._fullLayout._d3locale, templateValues);
  } else {
    text = options.label.text;
  }
  var labelGroupAttrs = {
    'data-index': index
  };
  var font = options.label.font;
  var labelTextAttrs = {
    'data-notex': 1
  };
  var labelGroup = shapeGroup.append('g').attr(labelGroupAttrs).classed('shape-label', true);
  var labelText = labelGroup.append('text').attr(labelTextAttrs).classed('shape-label-text', true).text(text);

  // Get x and y bounds of shape
  var shapex0, shapex1, shapey0, shapey1;
  if (options.path) {
    // If shape is defined as a path, get the
    // min and max bounds across all polygons in path
    var d = getPathString(gd, options);
    var polygons = readPaths(d, gd);
    shapex0 = Infinity;
    shapey0 = Infinity;
    shapex1 = -Infinity;
    shapey1 = -Infinity;
    for (var i = 0; i < polygons.length; i++) {
      for (var j = 0; j < polygons[i].length; j++) {
        var p = polygons[i][j];
        for (var k = 1; k < p.length; k += 2) {
          var _x = p[k];
          var _y = p[k + 1];
          shapex0 = Math.min(shapex0, _x);
          shapex1 = Math.max(shapex1, _x);
          shapey0 = Math.min(shapey0, _y);
          shapey1 = Math.max(shapey1, _y);
        }
      }
    }
  } else {
    // Otherwise, we use the x and y bounds defined in the shape options
    // and convert them to pixel coordinates
    // Setup conversion functions
    var xa = Axes.getFromId(gd, options.xref);
    var xShiftStart = options.x0shift;
    var xShiftEnd = options.x1shift;
    var xRefType = Axes.getRefType(options.xref);
    var ya = Axes.getFromId(gd, options.yref);
    var yShiftStart = options.y0shift;
    var yShiftEnd = options.y1shift;
    var yRefType = Axes.getRefType(options.yref);
    var x2p = function (v, shift) {
      var dataToPixel = helpers.getDataToPixel(gd, xa, shift, false, xRefType);
      return dataToPixel(v);
    };
    var y2p = function (v, shift) {
      var dataToPixel = helpers.getDataToPixel(gd, ya, shift, true, yRefType);
      return dataToPixel(v);
    };
    shapex0 = x2p(options.x0, xShiftStart);
    shapex1 = x2p(options.x1, xShiftEnd);
    shapey0 = y2p(options.y0, yShiftStart);
    shapey1 = y2p(options.y1, yShiftEnd);
  }

  // Handle `auto` angle
  var textangle = options.label.textangle;
  if (textangle === 'auto') {
    if (options.type === 'line') {
      // Auto angle for line is same angle as line
      textangle = calcTextAngle(shapex0, shapey0, shapex1, shapey1);
    } else {
      // Auto angle for all other shapes is 0
      textangle = 0;
    }
  }

  // Do an initial render so we can get the text bounding box height
  labelText.call(function (s) {
    s.call(Drawing.font, font).attr({});
    svgTextUtils.convertToTspans(s, gd);
    return s;
  });
  var textBB = Drawing.bBox(labelText.node());

  // Calculate correct (x,y) for text
  // We also determine true xanchor since xanchor depends on position when set to 'auto'
  var textPos = calcTextPosition(shapex0, shapey0, shapex1, shapey1, options, textangle, textBB);
  var textx = textPos.textx;
  var texty = textPos.texty;
  var xanchor = textPos.xanchor;

  // Update (x,y) position, xanchor, and angle
  labelText.attr({
    'text-anchor': {
      left: 'start',
      center: 'middle',
      right: 'end'
    }[xanchor],
    y: texty,
    x: textx,
    transform: 'rotate(' + textangle + ',' + textx + ',' + texty + ')'
  }).call(svgTextUtils.positionText, textx, texty);
};
function calcTextAngle(shapex0, shapey0, shapex1, shapey1) {
  var dy, dx;
  dx = Math.abs(shapex1 - shapex0);
  if (shapex1 >= shapex0) {
    dy = shapey0 - shapey1;
  } else {
    dy = shapey1 - shapey0;
  }
  return -180 / Math.PI * Math.atan2(dy, dx);
}
function calcTextPosition(shapex0, shapey0, shapex1, shapey1, shapeOptions, actualTextAngle, textBB) {
  var textPosition = shapeOptions.label.textposition;
  var textAngle = shapeOptions.label.textangle;
  var textPadding = shapeOptions.label.padding;
  var shapeType = shapeOptions.type;
  var textAngleRad = Math.PI / 180 * actualTextAngle;
  var sinA = Math.sin(textAngleRad);
  var cosA = Math.cos(textAngleRad);
  var xanchor = shapeOptions.label.xanchor;
  var yanchor = shapeOptions.label.yanchor;
  var textx, texty, paddingX, paddingY;

  // Text position functions differently for lines vs. other shapes
  if (shapeType === 'line') {
    // Set base position for start vs. center vs. end of line (default is 'center')
    if (textPosition === 'start') {
      textx = shapex0;
      texty = shapey0;
    } else if (textPosition === 'end') {
      textx = shapex1;
      texty = shapey1;
    } else {
      // Default: center
      textx = (shapex0 + shapex1) / 2;
      texty = (shapey0 + shapey1) / 2;
    }

    // Set xanchor if xanchor is 'auto'
    if (xanchor === 'auto') {
      if (textPosition === 'start') {
        if (textAngle === 'auto') {
          if (shapex1 > shapex0) xanchor = 'left';else if (shapex1 < shapex0) xanchor = 'right';else xanchor = 'center';
        } else {
          if (shapex1 > shapex0) xanchor = 'right';else if (shapex1 < shapex0) xanchor = 'left';else xanchor = 'center';
        }
      } else if (textPosition === 'end') {
        if (textAngle === 'auto') {
          if (shapex1 > shapex0) xanchor = 'right';else if (shapex1 < shapex0) xanchor = 'left';else xanchor = 'center';
        } else {
          if (shapex1 > shapex0) xanchor = 'left';else if (shapex1 < shapex0) xanchor = 'right';else xanchor = 'center';
        }
      } else {
        xanchor = 'center';
      }
    }

    // Special case for padding when angle is 'auto' for lines
    // Padding should be treated as an orthogonal offset in this case
    // Otherwise, padding is just a simple x and y offset
    var paddingConstantsX = {
      left: 1,
      center: 0,
      right: -1
    };
    var paddingConstantsY = {
      bottom: -1,
      middle: 0,
      top: 1
    };
    if (textAngle === 'auto') {
      // Set direction to apply padding (based on `yanchor` only)
      var paddingDirection = paddingConstantsY[yanchor];
      paddingX = -textPadding * sinA * paddingDirection;
      paddingY = textPadding * cosA * paddingDirection;
    } else {
      // Set direction to apply padding (based on `xanchor` and `yanchor`)
      var paddingDirectionX = paddingConstantsX[xanchor];
      var paddingDirectionY = paddingConstantsY[yanchor];
      paddingX = textPadding * paddingDirectionX;
      paddingY = textPadding * paddingDirectionY;
    }
    textx = textx + paddingX;
    texty = texty + paddingY;
  } else {
    // Text position for shapes that are not lines
    // calc horizontal position
    // Horizontal needs a little extra padding to look balanced
    paddingX = textPadding + 3;
    if (textPosition.indexOf('right') !== -1) {
      textx = Math.max(shapex0, shapex1) - paddingX;
      if (xanchor === 'auto') xanchor = 'right';
    } else if (textPosition.indexOf('left') !== -1) {
      textx = Math.min(shapex0, shapex1) + paddingX;
      if (xanchor === 'auto') xanchor = 'left';
    } else {
      // Default: center
      textx = (shapex0 + shapex1) / 2;
      if (xanchor === 'auto') xanchor = 'center';
    }

    // calc vertical position
    if (textPosition.indexOf('top') !== -1) {
      texty = Math.min(shapey0, shapey1);
    } else if (textPosition.indexOf('bottom') !== -1) {
      texty = Math.max(shapey0, shapey1);
    } else {
      texty = (shapey0 + shapey1) / 2;
    }
    // Apply padding
    paddingY = textPadding;
    if (yanchor === 'bottom') {
      texty = texty - paddingY;
    } else if (yanchor === 'top') {
      texty = texty + paddingY;
    }
  }

  // Shift vertical (& horizontal) position according to `yanchor`
  var shiftFraction = FROM_TL[yanchor];
  // Adjust so that text is anchored at top of first line rather than at baseline of first line
  var baselineAdjust = shapeOptions.label.font.size;
  var textHeight = textBB.height;
  var xshift = (textHeight * shiftFraction - baselineAdjust) * sinA;
  var yshift = -(textHeight * shiftFraction - baselineAdjust) * cosA;
  return {
    textx: textx + xshift,
    texty: texty + yshift,
    xanchor: xanchor
  };
}

/***/ }),

/***/ 561:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var strTranslate = Lib.strTranslate;
var dragElement = __webpack_require__(14751);
var dragHelpers = __webpack_require__(70414);
var drawMode = dragHelpers.drawMode;
var selectMode = dragHelpers.selectMode;
var Registry = __webpack_require__(33626);
var Color = __webpack_require__(78766);
var constants = __webpack_require__(93391);
var i000 = constants.i000;
var i090 = constants.i090;
var i180 = constants.i180;
var i270 = constants.i270;
var handleOutline = __webpack_require__(78534);
var clearOutlineControllers = handleOutline.clearOutlineControllers;
var helpers = __webpack_require__(81055);
var pointsOnRectangle = helpers.pointsOnRectangle;
var pointsOnEllipse = helpers.pointsOnEllipse;
var writePaths = helpers.writePaths;
var newShapes = (__webpack_require__(87562).newShapes);
var createShapeObj = (__webpack_require__(87562).createShapeObj);
var newSelections = __webpack_require__(51817);
var drawLabel = __webpack_require__(44433);
module.exports = function displayOutlines(polygons, outlines, dragOptions, nCalls) {
  if (!nCalls) nCalls = 0;
  var gd = dragOptions.gd;
  function redraw() {
    // recursive call
    displayOutlines(polygons, outlines, dragOptions, nCalls++);
    if (pointsOnEllipse(polygons[0]) || dragOptions.hasText) {
      update({
        redrawing: true
      });
    }
  }
  function update(opts) {
    var updateObject = {};
    if (dragOptions.isActiveShape !== undefined) {
      dragOptions.isActiveShape = false; // i.e. to disable shape controllers
      updateObject = newShapes(outlines, dragOptions);
    }
    if (dragOptions.isActiveSelection !== undefined) {
      dragOptions.isActiveSelection = false; // i.e. to disable selection controllers
      updateObject = newSelections(outlines, dragOptions);
      gd._fullLayout._reselect = true;
    }
    if (Object.keys(updateObject).length) {
      Registry.call((opts || {}).redrawing ? 'relayout' : '_guiRelayout', gd, updateObject);
    }
  }
  var fullLayout = gd._fullLayout;
  var zoomLayer = fullLayout._zoomlayer;
  var dragmode = dragOptions.dragmode;
  var isDrawMode = drawMode(dragmode);
  var isSelectMode = selectMode(dragmode);
  if (isDrawMode || isSelectMode) {
    gd._fullLayout._outlining = true;
  }
  clearOutlineControllers(gd);

  // make outline
  outlines.attr('d', writePaths(polygons));

  // add controllers
  var vertexDragOptions;
  var groupDragOptions;
  var indexI; // cell index
  var indexJ; // vertex or cell-controller index
  var copyPolygons;
  if (!nCalls && (dragOptions.isActiveShape || dragOptions.isActiveSelection)) {
    copyPolygons = recordPositions([], polygons);
    var g = zoomLayer.append('g').attr('class', 'outline-controllers');
    addVertexControllers(g);
    addGroupControllers();
  }

  // draw label
  if (isDrawMode && dragOptions.hasText) {
    var shapeGroup = zoomLayer.select('.label-temp');
    var shapeOptions = createShapeObj(outlines, dragOptions, dragOptions.dragmode);
    drawLabel(gd, 'label-temp', shapeOptions, shapeGroup);
  }
  function startDragVertex(evt) {
    indexI = +evt.srcElement.getAttribute('data-i');
    indexJ = +evt.srcElement.getAttribute('data-j');
    vertexDragOptions[indexI][indexJ].moveFn = moveVertexController;
  }
  function moveVertexController(dx, dy) {
    if (!polygons.length) return;
    var x0 = copyPolygons[indexI][indexJ][1];
    var y0 = copyPolygons[indexI][indexJ][2];
    var cell = polygons[indexI];
    var len = cell.length;
    if (pointsOnRectangle(cell)) {
      var _dx = dx;
      var _dy = dy;
      if (dragOptions.isActiveSelection) {
        // handle an edge contoller for rect selections
        var nextPoint = getNextPoint(cell, indexJ);
        if (nextPoint[1] === cell[indexJ][1]) {
          // a vertical edge
          _dy = 0;
        } else {
          // a horizontal edge
          _dx = 0;
        }
      }
      for (var q = 0; q < len; q++) {
        if (q === indexJ) continue;

        // move other corners of rectangle
        var pos = cell[q];
        if (pos[1] === cell[indexJ][1]) {
          pos[1] = x0 + _dx;
        }
        if (pos[2] === cell[indexJ][2]) {
          pos[2] = y0 + _dy;
        }
      }
      // move the corner
      cell[indexJ][1] = x0 + _dx;
      cell[indexJ][2] = y0 + _dy;
      if (!pointsOnRectangle(cell)) {
        // reject result to rectangles with ensure areas
        for (var j = 0; j < len; j++) {
          for (var k = 0; k < cell[j].length; k++) {
            cell[j][k] = copyPolygons[indexI][j][k];
          }
        }
      }
    } else {
      // other polylines
      cell[indexJ][1] = x0 + dx;
      cell[indexJ][2] = y0 + dy;
    }
    redraw();
  }
  function endDragVertexController() {
    update();
  }
  function removeVertex() {
    if (!polygons.length) return;
    if (!polygons[indexI]) return;
    if (!polygons[indexI].length) return;
    var newPolygon = [];
    for (var j = 0; j < polygons[indexI].length; j++) {
      if (j !== indexJ) {
        newPolygon.push(polygons[indexI][j]);
      }
    }
    if (newPolygon.length > 1 && !(newPolygon.length === 2 && newPolygon[1][0] === 'Z')) {
      if (indexJ === 0) {
        newPolygon[0][0] = 'M';
      }
      polygons[indexI] = newPolygon;
      redraw();
      update();
    }
  }
  function clickVertexController(numClicks, evt) {
    if (numClicks === 2) {
      indexI = +evt.srcElement.getAttribute('data-i');
      indexJ = +evt.srcElement.getAttribute('data-j');
      var cell = polygons[indexI];
      if (!pointsOnRectangle(cell) && !pointsOnEllipse(cell)) {
        removeVertex();
      }
    }
  }
  function addVertexControllers(g) {
    vertexDragOptions = [];
    for (var i = 0; i < polygons.length; i++) {
      var cell = polygons[i];
      var onRect = pointsOnRectangle(cell);
      var onEllipse = !onRect && pointsOnEllipse(cell);
      vertexDragOptions[i] = [];
      var len = cell.length;
      for (var j = 0; j < len; j++) {
        if (cell[j][0] === 'Z') continue;
        if (onEllipse && j !== i000 && j !== i090 && j !== i180 && j !== i270) {
          continue;
        }
        var rectSelection = onRect && dragOptions.isActiveSelection;
        var nextPoint;
        if (rectSelection) nextPoint = getNextPoint(cell, j);
        var x = cell[j][1];
        var y = cell[j][2];
        var vertex = g.append(rectSelection ? 'rect' : 'circle').attr('data-i', i).attr('data-j', j).style({
          fill: Color.background,
          stroke: Color.defaultLine,
          'stroke-width': 1,
          'shape-rendering': 'crispEdges'
        });
        if (rectSelection) {
          // convert a vertex controller to an edge controller for rect selections
          var dx = nextPoint[1] - x;
          var dy = nextPoint[2] - y;
          var width = dy ? 5 : Math.max(Math.min(25, Math.abs(dx) - 5), 5);
          var height = dx ? 5 : Math.max(Math.min(25, Math.abs(dy) - 5), 5);
          vertex.classed(dy ? 'cursor-ew-resize' : 'cursor-ns-resize', true).attr('width', width).attr('height', height).attr('x', x - width / 2).attr('y', y - height / 2).attr('transform', strTranslate(dx / 2, dy / 2));
        } else {
          vertex.classed('cursor-grab', true).attr('r', 5).attr('cx', x).attr('cy', y);
        }
        vertexDragOptions[i][j] = {
          element: vertex.node(),
          gd: gd,
          prepFn: startDragVertex,
          doneFn: endDragVertexController,
          clickFn: clickVertexController
        };
        dragElement.init(vertexDragOptions[i][j]);
      }
    }
  }
  function moveGroup(dx, dy) {
    if (!polygons.length) return;
    for (var i = 0; i < polygons.length; i++) {
      for (var j = 0; j < polygons[i].length; j++) {
        for (var k = 0; k + 2 < polygons[i][j].length; k += 2) {
          polygons[i][j][k + 1] = copyPolygons[i][j][k + 1] + dx;
          polygons[i][j][k + 2] = copyPolygons[i][j][k + 2] + dy;
        }
      }
    }
  }
  function moveGroupController(dx, dy) {
    moveGroup(dx, dy);
    redraw();
  }
  function startDragGroupController(evt) {
    indexI = +evt.srcElement.getAttribute('data-i');
    if (!indexI) indexI = 0; // ensure non-existing move button get zero index

    groupDragOptions[indexI].moveFn = moveGroupController;
  }
  function endDragGroupController() {
    update();
  }
  function clickGroupController(numClicks) {
    if (numClicks === 2) {
      eraseActiveSelection(gd);
    }
  }
  function addGroupControllers() {
    groupDragOptions = [];
    if (!polygons.length) return;
    var i = 0;
    groupDragOptions[i] = {
      element: outlines[0][0],
      gd: gd,
      prepFn: startDragGroupController,
      doneFn: endDragGroupController,
      clickFn: clickGroupController
    };
    dragElement.init(groupDragOptions[i]);
  }
};
function recordPositions(polygonsOut, polygonsIn) {
  for (var i = 0; i < polygonsIn.length; i++) {
    var cell = polygonsIn[i];
    polygonsOut[i] = [];
    for (var j = 0; j < cell.length; j++) {
      polygonsOut[i][j] = [];
      for (var k = 0; k < cell[j].length; k++) {
        polygonsOut[i][j][k] = cell[j][k];
      }
    }
  }
  return polygonsOut;
}
function getNextPoint(cell, j) {
  var x = cell[j][1];
  var y = cell[j][2];
  var len = cell.length;
  var nextJ, nextX, nextY;
  nextJ = (j + 1) % len;
  nextX = cell[nextJ][1];
  nextY = cell[nextJ][2];

  // avoid potential double points (closing points)
  if (nextX === x && nextY === y) {
    nextJ = (j + 2) % len;
    nextX = cell[nextJ][1];
    nextY = cell[nextJ][2];
  }
  return [nextJ, nextX, nextY];
}
function eraseActiveSelection(gd) {
  // Do not allow removal of selections on other dragmodes.
  // This ensures the user could still double click to
  // deselect all trace.selectedpoints,
  // if that's what they wanted.
  // Also double click to zoom back won't result in
  // any surprising selection removal.
  if (!selectMode(gd._fullLayout.dragmode)) return;
  clearOutlineControllers(gd);
  var id = gd._fullLayout._activeSelectionIndex;
  var selections = (gd.layout || {}).selections || [];
  if (id < selections.length) {
    var list = [];
    for (var q = 0; q < selections.length; q++) {
      if (q !== id) {
        list.push(selections[q]);
      }
    }
    delete gd._fullLayout._activeSelectionIndex;
    var erasedSelection = gd._fullLayout.selections[id];
    gd._fullLayout._deselect = {
      xref: erasedSelection.xref,
      yref: erasedSelection.yref
    };
    Registry.call('_guiRelayout', gd, {
      selections: list
    });
  }
}

/***/ }),

/***/ 28231:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var Registry = __webpack_require__(33626);
var Lib = __webpack_require__(34809);
var Axes = __webpack_require__(29714);
var readPaths = (__webpack_require__(81055).readPaths);
var displayOutlines = __webpack_require__(561);
var drawLabel = __webpack_require__(44433);
var clearOutlineControllers = (__webpack_require__(78534).clearOutlineControllers);
var Color = __webpack_require__(78766);
var Drawing = __webpack_require__(62203);
var arrayEditor = (__webpack_require__(78032).arrayEditor);
var dragElement = __webpack_require__(14751);
var setCursor = __webpack_require__(27983);
var constants = __webpack_require__(2956);
var helpers = __webpack_require__(49728);
var getPathString = helpers.getPathString;

// Shapes are stored in gd.layout.shapes, an array of objects
// index can point to one item in this array,
//  or non-numeric to simply add a new one
//  or -1 to modify all existing
// opt can be the full options object, or one key (to be set to value)
//  or undefined to simply redraw
// if opt is blank, val can be 'add' or a full options object to add a new
//  annotation at that point in the array, or 'remove' to delete this one

module.exports = {
  draw: draw,
  drawOne: drawOne,
  eraseActiveShape: eraseActiveShape,
  drawLabel: drawLabel
};
function draw(gd) {
  var fullLayout = gd._fullLayout;

  // Remove previous shapes before drawing new in shapes in fullLayout.shapes
  fullLayout._shapeUpperLayer.selectAll('path').remove();
  fullLayout._shapeLowerLayer.selectAll('path').remove();
  fullLayout._shapeUpperLayer.selectAll('text').remove();
  fullLayout._shapeLowerLayer.selectAll('text').remove();
  for (var k in fullLayout._plots) {
    var shapelayer = fullLayout._plots[k].shapelayer;
    if (shapelayer) {
      shapelayer.selectAll('path').remove();
      shapelayer.selectAll('text').remove();
    }
  }
  for (var i = 0; i < fullLayout.shapes.length; i++) {
    if (fullLayout.shapes[i].visible === true) {
      drawOne(gd, i);
    }
  }

  // may need to resurrect this if we put text (LaTeX) in shapes
  // return Plots.previousPromises(gd);
}
function shouldSkipEdits(gd) {
  return !!gd._fullLayout._outlining;
}
function couldHaveActiveShape(gd) {
  // for now keep config.editable: true as it was before shape-drawing PR
  return !gd._context.edits.shapePosition;
}
function drawOne(gd, index) {
  // remove the existing shape if there is one.
  // because indices can change, we need to look in all shape layers
  gd._fullLayout._paperdiv.selectAll('.shapelayer [data-index="' + index + '"]').remove();
  var o = helpers.makeShapesOptionsAndPlotinfo(gd, index);
  var options = o.options;
  var plotinfo = o.plotinfo;

  // this shape is gone - quit now after deleting it
  // TODO: use d3 idioms instead of deleting and redrawing every time
  if (!options._input || options.visible !== true) return;
  if (options.layer === 'above') {
    drawShape(gd._fullLayout._shapeUpperLayer);
  } else if (options.xref === 'paper' || options.yref === 'paper') {
    drawShape(gd._fullLayout._shapeLowerLayer);
  } else if (options.layer === 'between') {
    drawShape(plotinfo.shapelayerBetween);
  } else {
    if (plotinfo._hadPlotinfo) {
      var mainPlot = plotinfo.mainplotinfo || plotinfo;
      drawShape(mainPlot.shapelayer);
    } else {
      // Fall back to _shapeLowerLayer in case the requested subplot doesn't exist.
      // This can happen if you reference the shape to an x / y axis combination
      // that doesn't have any data on it (and layer is below)
      drawShape(gd._fullLayout._shapeLowerLayer);
    }
  }
  function drawShape(shapeLayer) {
    var d = getPathString(gd, options);
    var attrs = {
      'data-index': index,
      'fill-rule': options.fillrule,
      d: d
    };
    var opacity = options.opacity;
    var fillColor = options.fillcolor;
    var lineColor = options.line.width ? options.line.color : 'rgba(0,0,0,0)';
    var lineWidth = options.line.width;
    var lineDash = options.line.dash;
    if (!lineWidth && options.editable === true) {
      // ensure invisible border to activate the shape
      lineWidth = 5;
      lineDash = 'solid';
    }
    var isOpen = d[d.length - 1] !== 'Z';
    var isActiveShape = couldHaveActiveShape(gd) && options.editable && gd._fullLayout._activeShapeIndex === index;
    if (isActiveShape) {
      fillColor = isOpen ? 'rgba(0,0,0,0)' : gd._fullLayout.activeshape.fillcolor;
      opacity = gd._fullLayout.activeshape.opacity;
    }
    var shapeGroup = shapeLayer.append('g').classed('shape-group', true).attr({
      'data-index': index
    });
    var path = shapeGroup.append('path').attr(attrs).style('opacity', opacity).call(Color.stroke, lineColor).call(Color.fill, fillColor).call(Drawing.dashLine, lineDash, lineWidth);
    setClipPath(shapeGroup, gd, options);

    // Draw or clear the label
    drawLabel(gd, index, options, shapeGroup);
    var editHelpers;
    if (isActiveShape || gd._context.edits.shapePosition) editHelpers = arrayEditor(gd.layout, 'shapes', options);
    if (isActiveShape) {
      path.style({
        cursor: 'move'
      });
      var dragOptions = {
        element: path.node(),
        plotinfo: plotinfo,
        gd: gd,
        editHelpers: editHelpers,
        hasText: options.label.text || options.label.texttemplate,
        isActiveShape: true // i.e. to enable controllers
      };
      var polygons = readPaths(d, gd);
      // display polygons on the screen
      displayOutlines(polygons, path, dragOptions);
    } else {
      if (gd._context.edits.shapePosition) {
        setupDragElement(gd, path, options, index, shapeLayer, editHelpers);
      } else if (options.editable === true) {
        path.style('pointer-events', isOpen || Color.opacity(fillColor) * opacity <= 0.5 ? 'stroke' : 'all');
      }
    }
    path.node().addEventListener('click', function () {
      return activateShape(gd, path);
    });
  }
}
function setClipPath(shapePath, gd, shapeOptions) {
  // note that for layer="below" the clipAxes can be different from the
  // subplot we're drawing this in. This could cause problems if the shape
  // spans two subplots. See https://github.com/plotly/plotly.js/issues/1452
  //
  // if axis is 'paper' or an axis with " domain" appended, then there is no
  // clip axis
  var clipAxes = (shapeOptions.xref + shapeOptions.yref).replace(/paper/g, '').replace(/[xyz][1-9]* *domain/g, '');
  Drawing.setClipUrl(shapePath, clipAxes ? 'clip' + gd._fullLayout._uid + clipAxes : null, gd);
}
function setupDragElement(gd, shapePath, shapeOptions, index, shapeLayer, editHelpers) {
  var MINWIDTH = 10;
  var MINHEIGHT = 10;
  var xPixelSized = shapeOptions.xsizemode === 'pixel';
  var yPixelSized = shapeOptions.ysizemode === 'pixel';
  var isLine = shapeOptions.type === 'line';
  var isPath = shapeOptions.type === 'path';
  var modifyItem = editHelpers.modifyItem;
  var x0, y0, x1, y1, xAnchor, yAnchor;
  var n0, s0, w0, e0, optN, optS, optW, optE;
  var pathIn;
  var shapeGroup = d3.select(shapePath.node().parentNode);

  // setup conversion functions
  var xa = Axes.getFromId(gd, shapeOptions.xref);
  var xRefType = Axes.getRefType(shapeOptions.xref);
  var ya = Axes.getFromId(gd, shapeOptions.yref);
  var yRefType = Axes.getRefType(shapeOptions.yref);
  var shiftXStart = shapeOptions.x0shift;
  var shiftXEnd = shapeOptions.x1shift;
  var shiftYStart = shapeOptions.y0shift;
  var shiftYEnd = shapeOptions.y1shift;
  var x2p = function (v, shift) {
    var dataToPixel = helpers.getDataToPixel(gd, xa, shift, false, xRefType);
    return dataToPixel(v);
  };
  var y2p = function (v, shift) {
    var dataToPixel = helpers.getDataToPixel(gd, ya, shift, true, yRefType);
    return dataToPixel(v);
  };
  var p2x = helpers.getPixelToData(gd, xa, false, xRefType);
  var p2y = helpers.getPixelToData(gd, ya, true, yRefType);
  var sensoryElement = obtainSensoryElement();
  var dragOptions = {
    element: sensoryElement.node(),
    gd: gd,
    prepFn: startDrag,
    doneFn: endDrag,
    clickFn: abortDrag
  };
  var dragMode;
  dragElement.init(dragOptions);
  sensoryElement.node().onmousemove = updateDragMode;
  function obtainSensoryElement() {
    return isLine ? createLineDragHandles() : shapePath;
  }
  function createLineDragHandles() {
    var minSensoryWidth = 10;
    var sensoryWidth = Math.max(shapeOptions.line.width, minSensoryWidth);

    // Helper shapes group
    // Note that by setting the `data-index` attr, it is ensured that
    // the helper group is purged in this modules `draw` function
    var g = shapeLayer.append('g').attr('data-index', index).attr('drag-helper', true);

    // Helper path for moving
    g.append('path').attr('d', shapePath.attr('d')).style({
      cursor: 'move',
      'stroke-width': sensoryWidth,
      'stroke-opacity': '0' // ensure not visible
    });

    // Helper circles for resizing
    var circleStyle = {
      'fill-opacity': '0' // ensure not visible
    };
    var circleRadius = Math.max(sensoryWidth / 2, minSensoryWidth);
    g.append('circle').attr({
      'data-line-point': 'start-point',
      cx: xPixelSized ? x2p(shapeOptions.xanchor) + shapeOptions.x0 : x2p(shapeOptions.x0, shiftXStart),
      cy: yPixelSized ? y2p(shapeOptions.yanchor) - shapeOptions.y0 : y2p(shapeOptions.y0, shiftYStart),
      r: circleRadius
    }).style(circleStyle).classed('cursor-grab', true);
    g.append('circle').attr({
      'data-line-point': 'end-point',
      cx: xPixelSized ? x2p(shapeOptions.xanchor) + shapeOptions.x1 : x2p(shapeOptions.x1, shiftXEnd),
      cy: yPixelSized ? y2p(shapeOptions.yanchor) - shapeOptions.y1 : y2p(shapeOptions.y1, shiftYEnd),
      r: circleRadius
    }).style(circleStyle).classed('cursor-grab', true);
    return g;
  }
  function updateDragMode(evt) {
    if (shouldSkipEdits(gd)) {
      dragMode = null;
      return;
    }
    if (isLine) {
      if (evt.target.tagName === 'path') {
        dragMode = 'move';
      } else {
        dragMode = evt.target.attributes['data-line-point'].value === 'start-point' ? 'resize-over-start-point' : 'resize-over-end-point';
      }
    } else {
      // element might not be on screen at time of setup,
      // so obtain bounding box here
      var dragBBox = dragOptions.element.getBoundingClientRect();

      // choose 'move' or 'resize'
      // based on initial position of cursor within the drag element
      var w = dragBBox.right - dragBBox.left;
      var h = dragBBox.bottom - dragBBox.top;
      var x = evt.clientX - dragBBox.left;
      var y = evt.clientY - dragBBox.top;
      var cursor = !isPath && w > MINWIDTH && h > MINHEIGHT && !evt.shiftKey ? dragElement.getCursor(x / w, 1 - y / h) : 'move';
      setCursor(shapePath, cursor);

      // possible values 'move', 'sw', 'w', 'se', 'e', 'ne', 'n', 'nw' and 'w'
      dragMode = cursor.split('-')[0];
    }
  }
  function startDrag(evt) {
    if (shouldSkipEdits(gd)) return;

    // setup update strings and initial values
    if (xPixelSized) {
      xAnchor = x2p(shapeOptions.xanchor);
    }
    if (yPixelSized) {
      yAnchor = y2p(shapeOptions.yanchor);
    }
    if (shapeOptions.type === 'path') {
      pathIn = shapeOptions.path;
    } else {
      x0 = xPixelSized ? shapeOptions.x0 : x2p(shapeOptions.x0);
      y0 = yPixelSized ? shapeOptions.y0 : y2p(shapeOptions.y0);
      x1 = xPixelSized ? shapeOptions.x1 : x2p(shapeOptions.x1);
      y1 = yPixelSized ? shapeOptions.y1 : y2p(shapeOptions.y1);
    }
    if (x0 < x1) {
      w0 = x0;
      optW = 'x0';
      e0 = x1;
      optE = 'x1';
    } else {
      w0 = x1;
      optW = 'x1';
      e0 = x0;
      optE = 'x0';
    }

    // For fixed size shapes take opposing direction of y-axis into account.
    // Hint: For data sized shapes this is done by the y2p function.
    if (!yPixelSized && y0 < y1 || yPixelSized && y0 > y1) {
      n0 = y0;
      optN = 'y0';
      s0 = y1;
      optS = 'y1';
    } else {
      n0 = y1;
      optN = 'y1';
      s0 = y0;
      optS = 'y0';
    }

    // setup dragMode and the corresponding handler
    updateDragMode(evt);
    renderVisualCues(shapeLayer, shapeOptions);
    deactivateClipPathTemporarily(shapePath, shapeOptions, gd);
    dragOptions.moveFn = dragMode === 'move' ? moveShape : resizeShape;
    dragOptions.altKey = evt.altKey;
  }
  function endDrag() {
    if (shouldSkipEdits(gd)) return;
    setCursor(shapePath);
    removeVisualCues(shapeLayer);

    // Don't rely on clipPath being activated during re-layout
    setClipPath(shapePath, gd, shapeOptions);
    Registry.call('_guiRelayout', gd, editHelpers.getUpdateObj());
  }
  function abortDrag() {
    if (shouldSkipEdits(gd)) return;
    removeVisualCues(shapeLayer);
  }
  function moveShape(dx, dy) {
    if (shapeOptions.type === 'path') {
      var noOp = function (coord) {
        return coord;
      };
      var moveX = noOp;
      var moveY = noOp;
      if (xPixelSized) {
        modifyItem('xanchor', shapeOptions.xanchor = p2x(xAnchor + dx));
      } else {
        moveX = function moveX(x) {
          return p2x(x2p(x) + dx);
        };
        if (xa && xa.type === 'date') moveX = helpers.encodeDate(moveX);
      }
      if (yPixelSized) {
        modifyItem('yanchor', shapeOptions.yanchor = p2y(yAnchor + dy));
      } else {
        moveY = function moveY(y) {
          return p2y(y2p(y) + dy);
        };
        if (ya && ya.type === 'date') moveY = helpers.encodeDate(moveY);
      }
      modifyItem('path', shapeOptions.path = movePath(pathIn, moveX, moveY));
    } else {
      if (xPixelSized) {
        modifyItem('xanchor', shapeOptions.xanchor = p2x(xAnchor + dx));
      } else {
        modifyItem('x0', shapeOptions.x0 = p2x(x0 + dx));
        modifyItem('x1', shapeOptions.x1 = p2x(x1 + dx));
      }
      if (yPixelSized) {
        modifyItem('yanchor', shapeOptions.yanchor = p2y(yAnchor + dy));
      } else {
        modifyItem('y0', shapeOptions.y0 = p2y(y0 + dy));
        modifyItem('y1', shapeOptions.y1 = p2y(y1 + dy));
      }
    }
    shapePath.attr('d', getPathString(gd, shapeOptions));
    renderVisualCues(shapeLayer, shapeOptions);
    drawLabel(gd, index, shapeOptions, shapeGroup);
  }
  function resizeShape(dx, dy) {
    if (isPath) {
      // TODO: implement path resize, don't forget to update dragMode code
      var noOp = function (coord) {
        return coord;
      };
      var moveX = noOp;
      var moveY = noOp;
      if (xPixelSized) {
        modifyItem('xanchor', shapeOptions.xanchor = p2x(xAnchor + dx));
      } else {
        moveX = function moveX(x) {
          return p2x(x2p(x) + dx);
        };
        if (xa && xa.type === 'date') moveX = helpers.encodeDate(moveX);
      }
      if (yPixelSized) {
        modifyItem('yanchor', shapeOptions.yanchor = p2y(yAnchor + dy));
      } else {
        moveY = function moveY(y) {
          return p2y(y2p(y) + dy);
        };
        if (ya && ya.type === 'date') moveY = helpers.encodeDate(moveY);
      }
      modifyItem('path', shapeOptions.path = movePath(pathIn, moveX, moveY));
    } else if (isLine) {
      if (dragMode === 'resize-over-start-point') {
        var newX0 = x0 + dx;
        var newY0 = yPixelSized ? y0 - dy : y0 + dy;
        modifyItem('x0', shapeOptions.x0 = xPixelSized ? newX0 : p2x(newX0));
        modifyItem('y0', shapeOptions.y0 = yPixelSized ? newY0 : p2y(newY0));
      } else if (dragMode === 'resize-over-end-point') {
        var newX1 = x1 + dx;
        var newY1 = yPixelSized ? y1 - dy : y1 + dy;
        modifyItem('x1', shapeOptions.x1 = xPixelSized ? newX1 : p2x(newX1));
        modifyItem('y1', shapeOptions.y1 = yPixelSized ? newY1 : p2y(newY1));
      }
    } else {
      var has = function (str) {
        return dragMode.indexOf(str) !== -1;
      };
      var hasN = has('n');
      var hasS = has('s');
      var hasW = has('w');
      var hasE = has('e');
      var newN = hasN ? n0 + dy : n0;
      var newS = hasS ? s0 + dy : s0;
      var newW = hasW ? w0 + dx : w0;
      var newE = hasE ? e0 + dx : e0;
      if (yPixelSized) {
        // Do things in opposing direction for y-axis.
        // Hint: for data-sized shapes the reversal of axis direction is done in p2y.
        if (hasN) newN = n0 - dy;
        if (hasS) newS = s0 - dy;
      }

      // Update shape eventually. Again, be aware of the
      // opposing direction of the y-axis of fixed size shapes.
      if (!yPixelSized && newS - newN > MINHEIGHT || yPixelSized && newN - newS > MINHEIGHT) {
        modifyItem(optN, shapeOptions[optN] = yPixelSized ? newN : p2y(newN));
        modifyItem(optS, shapeOptions[optS] = yPixelSized ? newS : p2y(newS));
      }
      if (newE - newW > MINWIDTH) {
        modifyItem(optW, shapeOptions[optW] = xPixelSized ? newW : p2x(newW));
        modifyItem(optE, shapeOptions[optE] = xPixelSized ? newE : p2x(newE));
      }
    }
    shapePath.attr('d', getPathString(gd, shapeOptions));
    renderVisualCues(shapeLayer, shapeOptions);
    drawLabel(gd, index, shapeOptions, shapeGroup);
  }
  function renderVisualCues(shapeLayer, shapeOptions) {
    if (xPixelSized || yPixelSized) {
      renderAnchor();
    }
    function renderAnchor() {
      var isNotPath = shapeOptions.type !== 'path';

      // d3 join with dummy data to satisfy d3 data-binding
      var visualCues = shapeLayer.selectAll('.visual-cue').data([0]);

      // Enter
      var strokeWidth = 1;
      visualCues.enter().append('path').attr({
        fill: '#fff',
        'fill-rule': 'evenodd',
        stroke: '#000',
        'stroke-width': strokeWidth
      }).classed('visual-cue', true);

      // Update
      var posX = x2p(xPixelSized ? shapeOptions.xanchor : Lib.midRange(isNotPath ? [shapeOptions.x0, shapeOptions.x1] : helpers.extractPathCoords(shapeOptions.path, constants.paramIsX)));
      var posY = y2p(yPixelSized ? shapeOptions.yanchor : Lib.midRange(isNotPath ? [shapeOptions.y0, shapeOptions.y1] : helpers.extractPathCoords(shapeOptions.path, constants.paramIsY)));
      posX = helpers.roundPositionForSharpStrokeRendering(posX, strokeWidth);
      posY = helpers.roundPositionForSharpStrokeRendering(posY, strokeWidth);
      if (xPixelSized && yPixelSized) {
        var crossPath = 'M' + (posX - 1 - strokeWidth) + ',' + (posY - 1 - strokeWidth) + 'h-8v2h8 v8h2v-8 h8v-2h-8 v-8h-2 Z';
        visualCues.attr('d', crossPath);
      } else if (xPixelSized) {
        var vBarPath = 'M' + (posX - 1 - strokeWidth) + ',' + (posY - 9 - strokeWidth) + 'v18 h2 v-18 Z';
        visualCues.attr('d', vBarPath);
      } else {
        var hBarPath = 'M' + (posX - 9 - strokeWidth) + ',' + (posY - 1 - strokeWidth) + 'h18 v2 h-18 Z';
        visualCues.attr('d', hBarPath);
      }
    }
  }
  function removeVisualCues(shapeLayer) {
    shapeLayer.selectAll('.visual-cue').remove();
  }
  function deactivateClipPathTemporarily(shapePath, shapeOptions, gd) {
    var xref = shapeOptions.xref;
    var yref = shapeOptions.yref;
    var xa = Axes.getFromId(gd, xref);
    var ya = Axes.getFromId(gd, yref);
    var clipAxes = '';
    if (xref !== 'paper' && !xa.autorange) clipAxes += xref;
    if (yref !== 'paper' && !ya.autorange) clipAxes += yref;
    Drawing.setClipUrl(shapePath, clipAxes ? 'clip' + gd._fullLayout._uid + clipAxes : null, gd);
  }
}
function movePath(pathIn, moveX, moveY) {
  return pathIn.replace(constants.segmentRE, function (segment) {
    var paramNumber = 0;
    var segmentType = segment.charAt(0);
    var xParams = constants.paramIsX[segmentType];
    var yParams = constants.paramIsY[segmentType];
    var nParams = constants.numParams[segmentType];
    var paramString = segment.substr(1).replace(constants.paramRE, function (param) {
      if (paramNumber >= nParams) return param;
      if (xParams[paramNumber]) param = moveX(param);else if (yParams[paramNumber]) param = moveY(param);
      paramNumber++;
      return param;
    });
    return segmentType + paramString;
  });
}
function activateShape(gd, path) {
  if (!couldHaveActiveShape(gd)) return;
  var element = path.node();
  var id = +element.getAttribute('data-index');
  if (id >= 0) {
    // deactivate if already active
    if (id === gd._fullLayout._activeShapeIndex) {
      deactivateShape(gd);
      return;
    }
    gd._fullLayout._activeShapeIndex = id;
    gd._fullLayout._deactivateShape = deactivateShape;
    draw(gd);
  }
}
function deactivateShape(gd) {
  if (!couldHaveActiveShape(gd)) return;
  var id = gd._fullLayout._activeShapeIndex;
  if (id >= 0) {
    clearOutlineControllers(gd);
    delete gd._fullLayout._activeShapeIndex;
    draw(gd);
  }
}
function eraseActiveShape(gd) {
  if (!couldHaveActiveShape(gd)) return;
  clearOutlineControllers(gd);
  var id = gd._fullLayout._activeShapeIndex;
  var shapes = (gd.layout || {}).shapes || [];
  if (id < shapes.length) {
    var list = [];
    for (var q = 0; q < shapes.length; q++) {
      if (q !== id) {
        list.push(shapes[q]);
      }
    }
    delete gd._fullLayout._activeShapeIndex;
    return Registry.call('_guiRelayout', gd, {
      shapes: list
    });
  }
}

/***/ }),

/***/ 64101:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var overrideAll = (__webpack_require__(13582).overrideAll);
var basePlotAttributes = __webpack_require__(9829);
var fontAttrs = __webpack_require__(80337);
var dash = (__webpack_require__(94850)/* .dash */ .T);
var extendFlat = (__webpack_require__(93049).extendFlat);
var shapeTexttemplateAttrs = (__webpack_require__(3208)/* .shapeTexttemplateAttrs */ .LF);
var shapeLabelTexttemplateVars = __webpack_require__(41235);
module.exports = overrideAll({
  newshape: {
    visible: extendFlat({}, basePlotAttributes.visible, {}),
    showlegend: {
      valType: 'boolean',
      dflt: false
    },
    legend: extendFlat({}, basePlotAttributes.legend, {}),
    legendgroup: extendFlat({}, basePlotAttributes.legendgroup, {}),
    legendgrouptitle: {
      text: extendFlat({}, basePlotAttributes.legendgrouptitle.text, {}),
      font: fontAttrs({})
    },
    legendrank: extendFlat({}, basePlotAttributes.legendrank, {}),
    legendwidth: extendFlat({}, basePlotAttributes.legendwidth, {}),
    line: {
      color: {
        valType: 'color'
      },
      width: {
        valType: 'number',
        min: 0,
        dflt: 4
      },
      dash: extendFlat({}, dash, {
        dflt: 'solid'
      })
    },
    fillcolor: {
      valType: 'color',
      dflt: 'rgba(0,0,0,0)'
    },
    fillrule: {
      valType: 'enumerated',
      values: ['evenodd', 'nonzero'],
      dflt: 'evenodd'
    },
    opacity: {
      valType: 'number',
      min: 0,
      max: 1,
      dflt: 1
    },
    layer: {
      valType: 'enumerated',
      values: ['below', 'above', 'between'],
      dflt: 'above'
    },
    drawdirection: {
      valType: 'enumerated',
      values: ['ortho', 'horizontal', 'vertical', 'diagonal'],
      dflt: 'diagonal'
    },
    name: extendFlat({}, basePlotAttributes.name, {}),
    label: {
      text: {
        valType: 'string',
        dflt: ''
      },
      texttemplate: shapeTexttemplateAttrs({
        newshape: true
      }, {
        keys: Object.keys(shapeLabelTexttemplateVars)
      }),
      font: fontAttrs({}),
      textposition: {
        valType: 'enumerated',
        values: ['top left', 'top center', 'top right', 'middle left', 'middle center', 'middle right', 'bottom left', 'bottom center', 'bottom right', 'start', 'middle', 'end']
      },
      textangle: {
        valType: 'angle',
        dflt: 'auto'
      },
      xanchor: {
        valType: 'enumerated',
        values: ['auto', 'left', 'center', 'right'],
        dflt: 'auto'
      },
      yanchor: {
        valType: 'enumerated',
        values: ['top', 'middle', 'bottom']
      },
      padding: {
        valType: 'number',
        dflt: 3,
        min: 0
      }
    }
  },
  activeshape: {
    fillcolor: {
      valType: 'color',
      dflt: 'rgb(255,0,255)'
    },
    opacity: {
      valType: 'number',
      min: 0,
      max: 1,
      dflt: 0.5
    }
  }
}, 'none', 'from-root');

/***/ }),

/***/ 93391:
/***/ (function(module) {

"use strict";


var CIRCLE_SIDES = 32; // should be divisible by 4

module.exports = {
  CIRCLE_SIDES: CIRCLE_SIDES,
  i000: 0,
  i090: CIRCLE_SIDES / 4,
  i180: CIRCLE_SIDES / 2,
  i270: CIRCLE_SIDES / 4 * 3,
  cos45: Math.cos(Math.PI / 4),
  sin45: Math.sin(Math.PI / 4),
  SQRT2: Math.sqrt(2)
};

/***/ }),

/***/ 85522:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Color = __webpack_require__(78766);
var Lib = __webpack_require__(34809);
function dfltLabelYanchor(isLine, labelTextPosition) {
  // If shape is a line, default y-anchor is 'bottom' (so that text is above line by default)
  // Otherwise, default y-anchor is equal to y-component of `textposition`
  // (so that text is positioned inside shape bounding box by default)
  return isLine ? 'bottom' : labelTextPosition.indexOf('top') !== -1 ? 'top' : labelTextPosition.indexOf('bottom') !== -1 ? 'bottom' : 'middle';
}
module.exports = function supplyDrawNewShapeDefaults(layoutIn, layoutOut, coerce) {
  coerce('newshape.visible');
  coerce('newshape.name');
  coerce('newshape.showlegend');
  coerce('newshape.legend');
  coerce('newshape.legendwidth');
  coerce('newshape.legendgroup');
  coerce('newshape.legendgrouptitle.text');
  Lib.coerceFont(coerce, 'newshape.legendgrouptitle.font');
  coerce('newshape.legendrank');
  coerce('newshape.drawdirection');
  coerce('newshape.layer');
  coerce('newshape.fillcolor');
  coerce('newshape.fillrule');
  coerce('newshape.opacity');
  var newshapeLineWidth = coerce('newshape.line.width');
  if (newshapeLineWidth) {
    var bgcolor = (layoutIn || {}).plot_bgcolor || '#FFF';
    coerce('newshape.line.color', Color.contrast(bgcolor));
    coerce('newshape.line.dash');
  }
  var isLine = layoutIn.dragmode === 'drawline';
  var labelText = coerce('newshape.label.text');
  var labelTextTemplate = coerce('newshape.label.texttemplate');
  if (labelText || labelTextTemplate) {
    coerce('newshape.label.textangle');
    var labelTextPosition = coerce('newshape.label.textposition', isLine ? 'middle' : 'middle center');
    coerce('newshape.label.xanchor');
    coerce('newshape.label.yanchor', dfltLabelYanchor(isLine, labelTextPosition));
    coerce('newshape.label.padding');
    Lib.coerceFont(coerce, 'newshape.label.font', layoutOut.font);
  }
  coerce('activeshape.fillcolor');
  coerce('activeshape.opacity');
};

/***/ }),

/***/ 81055:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var parseSvgPath = __webpack_require__(26953);
var constants = __webpack_require__(93391);
var CIRCLE_SIDES = constants.CIRCLE_SIDES;
var SQRT2 = constants.SQRT2;
var cartesianHelpers = __webpack_require__(49801);
var p2r = cartesianHelpers.p2r;
var r2p = cartesianHelpers.r2p;
var iC = [0, 3, 4, 5, 6, 1, 2];
var iQS = [0, 3, 4, 1, 2];
exports.writePaths = function (polygons) {
  var nI = polygons.length;
  if (!nI) return 'M0,0Z';
  var str = '';
  for (var i = 0; i < nI; i++) {
    var nJ = polygons[i].length;
    for (var j = 0; j < nJ; j++) {
      var w = polygons[i][j][0];
      if (w === 'Z') {
        str += 'Z';
      } else {
        var nK = polygons[i][j].length;
        for (var k = 0; k < nK; k++) {
          var realK = k;
          if (w === 'Q' || w === 'S') {
            realK = iQS[k];
          } else if (w === 'C') {
            realK = iC[k];
          }
          str += polygons[i][j][realK];
          if (k > 0 && k < nK - 1) {
            str += ',';
          }
        }
      }
    }
  }
  return str;
};
exports.readPaths = function (str, gd, plotinfo, isActiveShape) {
  var cmd = parseSvgPath(str);
  var polys = [];
  var n = -1;
  var newPoly = function () {
    n++;
    polys[n] = [];
  };
  var k;
  var x = 0;
  var y = 0;
  var initX;
  var initY;
  var recStart = function () {
    initX = x;
    initY = y;
  };
  recStart();
  for (var i = 0; i < cmd.length; i++) {
    var newPos = [];
    var x1, x2, y1, y2; // i.e. extra params for curves

    var c = cmd[i][0];
    var w = c;
    switch (c) {
      case 'M':
        newPoly();
        x = +cmd[i][1];
        y = +cmd[i][2];
        newPos.push([w, x, y]);
        recStart();
        break;
      case 'Q':
      case 'S':
        x1 = +cmd[i][1];
        y1 = +cmd[i][2];
        x = +cmd[i][3];
        y = +cmd[i][4];
        newPos.push([w, x, y, x1, y1]); // -> iQS order
        break;
      case 'C':
        x1 = +cmd[i][1];
        y1 = +cmd[i][2];
        x2 = +cmd[i][3];
        y2 = +cmd[i][4];
        x = +cmd[i][5];
        y = +cmd[i][6];
        newPos.push([w, x, y, x1, y1, x2, y2]); // -> iC order
        break;
      case 'T':
      case 'L':
        x = +cmd[i][1];
        y = +cmd[i][2];
        newPos.push([w, x, y]);
        break;
      case 'H':
        w = 'L'; // convert to line (for now)
        x = +cmd[i][1];
        newPos.push([w, x, y]);
        break;
      case 'V':
        w = 'L'; // convert to line (for now)
        y = +cmd[i][1];
        newPos.push([w, x, y]);
        break;
      case 'A':
        w = 'L'; // convert to line to handle circle
        var rx = +cmd[i][1];
        var ry = +cmd[i][2];
        if (!+cmd[i][4]) {
          rx = -rx;
          ry = -ry;
        }
        var cenX = x - rx;
        var cenY = y;
        for (k = 1; k <= CIRCLE_SIDES / 2; k++) {
          var t = 2 * Math.PI * k / CIRCLE_SIDES;
          newPos.push([w, cenX + rx * Math.cos(t), cenY + ry * Math.sin(t)]);
        }
        break;
      case 'Z':
        if (x !== initX || y !== initY) {
          x = initX;
          y = initY;
          newPos.push([w, x, y]);
        }
        break;
    }
    var domain = (plotinfo || {}).domain;
    var size = gd._fullLayout._size;
    var xPixelSized = plotinfo && plotinfo.xsizemode === 'pixel';
    var yPixelSized = plotinfo && plotinfo.ysizemode === 'pixel';
    var noOffset = isActiveShape === false;
    for (var j = 0; j < newPos.length; j++) {
      for (k = 0; k + 2 < 7; k += 2) {
        var _x = newPos[j][k + 1];
        var _y = newPos[j][k + 2];
        if (_x === undefined || _y === undefined) continue;
        // keep track of end point for Z
        x = _x;
        y = _y;
        if (plotinfo) {
          if (plotinfo.xaxis && plotinfo.xaxis.p2r) {
            if (noOffset) _x -= plotinfo.xaxis._offset;
            if (xPixelSized) {
              _x = r2p(plotinfo.xaxis, plotinfo.xanchor) + _x;
            } else {
              _x = p2r(plotinfo.xaxis, _x);
            }
          } else {
            if (noOffset) _x -= size.l;
            if (domain) _x = domain.x[0] + _x / size.w;else _x = _x / size.w;
          }
          if (plotinfo.yaxis && plotinfo.yaxis.p2r) {
            if (noOffset) _y -= plotinfo.yaxis._offset;
            if (yPixelSized) {
              _y = r2p(plotinfo.yaxis, plotinfo.yanchor) - _y;
            } else {
              _y = p2r(plotinfo.yaxis, _y);
            }
          } else {
            if (noOffset) _y -= size.t;
            if (domain) _y = domain.y[1] - _y / size.h;else _y = 1 - _y / size.h;
          }
        }
        newPos[j][k + 1] = _x;
        newPos[j][k + 2] = _y;
      }
      polys[n].push(newPos[j].slice());
    }
  }
  return polys;
};
function almostEq(a, b) {
  return Math.abs(a - b) <= 1e-6;
}
function dist(a, b) {
  var dx = b[1] - a[1];
  var dy = b[2] - a[2];
  return Math.sqrt(dx * dx + dy * dy);
}
exports.pointsOnRectangle = function (cell) {
  var len = cell.length;
  if (len !== 5) return false;
  for (var j = 1; j < 3; j++) {
    var e01 = cell[0][j] - cell[1][j];
    var e32 = cell[3][j] - cell[2][j];
    if (!almostEq(e01, e32)) return false;
    var e03 = cell[0][j] - cell[3][j];
    var e12 = cell[1][j] - cell[2][j];
    if (!almostEq(e03, e12)) return false;
  }

  // N.B. rotated rectangles are not valid rects since rotation is not supported in shapes for now.
  if (!almostEq(cell[0][1], cell[1][1]) && !almostEq(cell[0][1], cell[3][1])) return false;

  // reject cases with zero area
  return !!(dist(cell[0], cell[1]) * dist(cell[0], cell[3]));
};
exports.pointsOnEllipse = function (cell) {
  var len = cell.length;
  if (len !== CIRCLE_SIDES + 1) return false;

  // opposite diagonals should be the same
  len = CIRCLE_SIDES;
  for (var i = 0; i < len; i++) {
    var k = (len * 2 - i) % len;
    var k2 = (len / 2 + k) % len;
    var i2 = (len / 2 + i) % len;
    if (!almostEq(dist(cell[i], cell[i2]), dist(cell[k], cell[k2]))) return false;
  }
  return true;
};
exports.handleEllipse = function (isEllipse, start, end) {
  if (!isEllipse) return [start, end]; // i.e. case of line

  var pos = exports.ellipseOver({
    x0: start[0],
    y0: start[1],
    x1: end[0],
    y1: end[1]
  });
  var cx = (pos.x1 + pos.x0) / 2;
  var cy = (pos.y1 + pos.y0) / 2;
  var rx = (pos.x1 - pos.x0) / 2;
  var ry = (pos.y1 - pos.y0) / 2;

  // make a circle when one dimension is zero
  if (!rx) rx = ry = ry / SQRT2;
  if (!ry) ry = rx = rx / SQRT2;
  var cell = [];
  for (var i = 0; i < CIRCLE_SIDES; i++) {
    var t = i * 2 * Math.PI / CIRCLE_SIDES;
    cell.push([cx + rx * Math.cos(t), cy + ry * Math.sin(t)]);
  }
  return cell;
};
exports.ellipseOver = function (pos) {
  var x0 = pos.x0;
  var y0 = pos.y0;
  var x1 = pos.x1;
  var y1 = pos.y1;
  var dx = x1 - x0;
  var dy = y1 - y0;
  x0 -= dx;
  y0 -= dy;
  var cx = (x0 + x1) / 2;
  var cy = (y0 + y1) / 2;
  var scale = SQRT2;
  dx *= scale;
  dy *= scale;
  return {
    x0: cx - dx,
    y0: cy - dy,
    x1: cx + dx,
    y1: cy + dy
  };
};
exports.fixDatesForPaths = function (polygons, xaxis, yaxis) {
  var xIsDate = xaxis.type === 'date';
  var yIsDate = yaxis.type === 'date';
  if (!xIsDate && !yIsDate) return polygons;
  for (var i = 0; i < polygons.length; i++) {
    for (var j = 0; j < polygons[i].length; j++) {
      for (var k = 0; k + 2 < polygons[i][j].length; k += 2) {
        if (xIsDate) polygons[i][j][k + 1] = polygons[i][j][k + 1].replace(' ', '_');
        if (yIsDate) polygons[i][j][k + 2] = polygons[i][j][k + 2].replace(' ', '_');
      }
    }
  }
  return polygons;
};

/***/ }),

/***/ 87562:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var dragHelpers = __webpack_require__(70414);
var drawMode = dragHelpers.drawMode;
var openMode = dragHelpers.openMode;
var constants = __webpack_require__(93391);
var i000 = constants.i000;
var i090 = constants.i090;
var i180 = constants.i180;
var i270 = constants.i270;
var cos45 = constants.cos45;
var sin45 = constants.sin45;
var cartesianHelpers = __webpack_require__(49801);
var p2r = cartesianHelpers.p2r;
var r2p = cartesianHelpers.r2p;
var handleOutline = __webpack_require__(78534);
var clearOutline = handleOutline.clearOutline;
var helpers = __webpack_require__(81055);
var readPaths = helpers.readPaths;
var writePaths = helpers.writePaths;
var ellipseOver = helpers.ellipseOver;
var fixDatesForPaths = helpers.fixDatesForPaths;
function newShapes(outlines, dragOptions) {
  if (!outlines.length) return;
  var e = outlines[0][0]; // pick first
  if (!e) return;
  var gd = dragOptions.gd;
  var isActiveShape = dragOptions.isActiveShape;
  var dragmode = dragOptions.dragmode;
  var shapes = (gd.layout || {}).shapes || [];
  if (!drawMode(dragmode) && isActiveShape !== undefined) {
    var id = gd._fullLayout._activeShapeIndex;
    if (id < shapes.length) {
      switch (gd._fullLayout.shapes[id].type) {
        case 'rect':
          dragmode = 'drawrect';
          break;
        case 'circle':
          dragmode = 'drawcircle';
          break;
        case 'line':
          dragmode = 'drawline';
          break;
        case 'path':
          var path = shapes[id].path || '';
          if (path[path.length - 1] === 'Z') {
            dragmode = 'drawclosedpath';
          } else {
            dragmode = 'drawopenpath';
          }
          break;
      }
    }
  }
  var newShape = createShapeObj(outlines, dragOptions, dragmode);
  clearOutline(gd);
  var editHelpers = dragOptions.editHelpers;
  var modifyItem = (editHelpers || {}).modifyItem;
  var allShapes = [];
  for (var q = 0; q < shapes.length; q++) {
    var beforeEdit = gd._fullLayout.shapes[q];
    allShapes[q] = beforeEdit._input;
    if (isActiveShape !== undefined && q === gd._fullLayout._activeShapeIndex) {
      var afterEdit = newShape;
      switch (beforeEdit.type) {
        case 'line':
        case 'rect':
        case 'circle':
          modifyItem('x0', afterEdit.x0 - (beforeEdit.x0shift || 0));
          modifyItem('x1', afterEdit.x1 - (beforeEdit.x1shift || 0));
          modifyItem('y0', afterEdit.y0 - (beforeEdit.y0shift || 0));
          modifyItem('y1', afterEdit.y1 - (beforeEdit.y1shift || 0));
          break;
        case 'path':
          modifyItem('path', afterEdit.path);
          break;
      }
    }
  }
  if (isActiveShape === undefined) {
    allShapes.push(newShape); // add new shape
    return allShapes;
  }
  return editHelpers ? editHelpers.getUpdateObj() : {};
}
function createShapeObj(outlines, dragOptions, dragmode) {
  var e = outlines[0][0]; // pick first outline
  var gd = dragOptions.gd;
  var d = e.getAttribute('d');
  var newStyle = gd._fullLayout.newshape;
  var plotinfo = dragOptions.plotinfo;
  var isActiveShape = dragOptions.isActiveShape;
  var xaxis = plotinfo.xaxis;
  var yaxis = plotinfo.yaxis;
  var xPaper = !!plotinfo.domain || !plotinfo.xaxis;
  var yPaper = !!plotinfo.domain || !plotinfo.yaxis;
  var isOpenMode = openMode(dragmode);
  var polygons = readPaths(d, gd, plotinfo, isActiveShape);
  var newShape = {
    editable: true,
    visible: newStyle.visible,
    name: newStyle.name,
    showlegend: newStyle.showlegend,
    legend: newStyle.legend,
    legendwidth: newStyle.legendwidth,
    legendgroup: newStyle.legendgroup,
    legendgrouptitle: {
      text: newStyle.legendgrouptitle.text,
      font: newStyle.legendgrouptitle.font
    },
    legendrank: newStyle.legendrank,
    label: newStyle.label,
    xref: xPaper ? 'paper' : xaxis._id,
    yref: yPaper ? 'paper' : yaxis._id,
    layer: newStyle.layer,
    opacity: newStyle.opacity,
    line: {
      color: newStyle.line.color,
      width: newStyle.line.width,
      dash: newStyle.line.dash
    }
  };
  if (!isOpenMode) {
    newShape.fillcolor = newStyle.fillcolor;
    newShape.fillrule = newStyle.fillrule;
  }
  var cell;
  // line, rect and circle can be in one cell
  // only define cell if there is single cell
  if (polygons.length === 1) cell = polygons[0];
  if (cell && cell.length === 5 &&
  // ensure we only have 4 corners for a rect
  dragmode === 'drawrect') {
    newShape.type = 'rect';
    newShape.x0 = cell[0][1];
    newShape.y0 = cell[0][2];
    newShape.x1 = cell[2][1];
    newShape.y1 = cell[2][2];
  } else if (cell && dragmode === 'drawline') {
    newShape.type = 'line';
    newShape.x0 = cell[0][1];
    newShape.y0 = cell[0][2];
    newShape.x1 = cell[1][1];
    newShape.y1 = cell[1][2];
  } else if (cell && dragmode === 'drawcircle') {
    newShape.type = 'circle'; // an ellipse!

    var xA = cell[i000][1];
    var xB = cell[i090][1];
    var xC = cell[i180][1];
    var xD = cell[i270][1];
    var yA = cell[i000][2];
    var yB = cell[i090][2];
    var yC = cell[i180][2];
    var yD = cell[i270][2];
    var xDateOrLog = plotinfo.xaxis && (plotinfo.xaxis.type === 'date' || plotinfo.xaxis.type === 'log');
    var yDateOrLog = plotinfo.yaxis && (plotinfo.yaxis.type === 'date' || plotinfo.yaxis.type === 'log');
    if (xDateOrLog) {
      xA = r2p(plotinfo.xaxis, xA);
      xB = r2p(plotinfo.xaxis, xB);
      xC = r2p(plotinfo.xaxis, xC);
      xD = r2p(plotinfo.xaxis, xD);
    }
    if (yDateOrLog) {
      yA = r2p(plotinfo.yaxis, yA);
      yB = r2p(plotinfo.yaxis, yB);
      yC = r2p(plotinfo.yaxis, yC);
      yD = r2p(plotinfo.yaxis, yD);
    }
    var x0 = (xB + xD) / 2;
    var y0 = (yA + yC) / 2;
    var rx = (xD - xB + xC - xA) / 2;
    var ry = (yD - yB + yC - yA) / 2;
    var pos = ellipseOver({
      x0: x0,
      y0: y0,
      x1: x0 + rx * cos45,
      y1: y0 + ry * sin45
    });
    if (xDateOrLog) {
      pos.x0 = p2r(plotinfo.xaxis, pos.x0);
      pos.x1 = p2r(plotinfo.xaxis, pos.x1);
    }
    if (yDateOrLog) {
      pos.y0 = p2r(plotinfo.yaxis, pos.y0);
      pos.y1 = p2r(plotinfo.yaxis, pos.y1);
    }
    newShape.x0 = pos.x0;
    newShape.y0 = pos.y0;
    newShape.x1 = pos.x1;
    newShape.y1 = pos.y1;
  } else {
    newShape.type = 'path';
    if (xaxis && yaxis) fixDatesForPaths(polygons, xaxis, yaxis);
    newShape.path = writePaths(polygons);
    cell = null;
  }
  return newShape;
}
module.exports = {
  newShapes: newShapes,
  createShapeObj: createShapeObj
};

/***/ }),

/***/ 78534:
/***/ (function(module) {

"use strict";


function clearOutlineControllers(gd) {
  var zoomLayer = gd._fullLayout._zoomlayer;
  if (zoomLayer) {
    zoomLayer.selectAll('.outline-controllers').remove();
  }
}
function clearOutline(gd) {
  var zoomLayer = gd._fullLayout._zoomlayer;
  if (zoomLayer) {
    // until we get around to persistent selections, remove the outline
    // here. The selection itself will be removed when the plot redraws
    // at the end.
    zoomLayer.selectAll('.select-outline').remove();
  }
  gd._fullLayout._outlining = false;
}
module.exports = {
  clearOutlineControllers: clearOutlineControllers,
  clearOutline: clearOutline
};

/***/ }),

/***/ 49728:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var constants = __webpack_require__(2956);
var Lib = __webpack_require__(34809);
var Axes = __webpack_require__(29714);

// special position conversion functions... category axis positions can't be
// specified by their data values, because they don't make a continuous mapping.
// so these have to be specified in terms of the category serial numbers,
// but can take fractional values. Other axis types we specify position based on
// the actual data values.
// TODO: in V3.0 (when log axis ranges are in data units) range and shape position
// will be identical, so rangeToShapePosition and shapePositionToRange can be
// removed entirely.

exports.rangeToShapePosition = function (ax) {
  return ax.type === 'log' ? ax.r2d : function (v) {
    return v;
  };
};
exports.shapePositionToRange = function (ax) {
  return ax.type === 'log' ? ax.d2r : function (v) {
    return v;
  };
};
exports.decodeDate = function (convertToPx) {
  return function (v) {
    if (v.replace) v = v.replace('_', ' ');
    return convertToPx(v);
  };
};
exports.encodeDate = function (convertToDate) {
  return function (v) {
    return convertToDate(v).replace(' ', '_');
  };
};
exports.extractPathCoords = function (path, paramsToUse, isRaw) {
  var extractedCoordinates = [];
  var segments = path.match(constants.segmentRE);
  segments.forEach(function (segment) {
    var relevantParamIdx = paramsToUse[segment.charAt(0)].drawn;
    if (relevantParamIdx === undefined) return;
    var params = segment.substr(1).match(constants.paramRE);
    if (!params || params.length < relevantParamIdx) return;
    var str = params[relevantParamIdx];
    var pos = isRaw ? str : Lib.cleanNumber(str);
    extractedCoordinates.push(pos);
  });
  return extractedCoordinates;
};
exports.getDataToPixel = function (gd, axis, shift, isVertical, refType) {
  var gs = gd._fullLayout._size;
  var dataToPixel;
  if (axis) {
    if (refType === 'domain') {
      dataToPixel = function (v) {
        return axis._length * (isVertical ? 1 - v : v) + axis._offset;
      };
    } else {
      var d2r = exports.shapePositionToRange(axis);
      dataToPixel = function (v) {
        var shiftPixels = getPixelShift(axis, shift);
        return axis._offset + axis.r2p(d2r(v, true)) + shiftPixels;
      };
      if (axis.type === 'date') dataToPixel = exports.decodeDate(dataToPixel);
    }
  } else if (isVertical) {
    dataToPixel = function (v) {
      return gs.t + gs.h * (1 - v);
    };
  } else {
    dataToPixel = function (v) {
      return gs.l + gs.w * v;
    };
  }
  return dataToPixel;
};
exports.getPixelToData = function (gd, axis, isVertical, opt) {
  var gs = gd._fullLayout._size;
  var pixelToData;
  if (axis) {
    if (opt === 'domain') {
      pixelToData = function (p) {
        var q = (p - axis._offset) / axis._length;
        return isVertical ? 1 - q : q;
      };
    } else {
      var r2d = exports.rangeToShapePosition(axis);
      pixelToData = function (p) {
        return r2d(axis.p2r(p - axis._offset));
      };
    }
  } else if (isVertical) {
    pixelToData = function (p) {
      return 1 - (p - gs.t) / gs.h;
    };
  } else {
    pixelToData = function (p) {
      return (p - gs.l) / gs.w;
    };
  }
  return pixelToData;
};

/**
 * Based on the given stroke width, rounds the passed
 * position value to represent either a full or half pixel.
 *
 * In case of an odd stroke width (e.g. 1), this measure ensures
 * that a stroke positioned at the returned position isn't rendered
 * blurry due to anti-aliasing.
 *
 * In case of an even stroke width (e.g. 2), this measure ensures
 * that the position value is transformed to a full pixel value
 * so that anti-aliasing doesn't take effect either.
 *
 * @param {number} pos The raw position value to be transformed
 * @param {number} strokeWidth The stroke width
 * @returns {number} either an integer or a .5 decimal number
 */
exports.roundPositionForSharpStrokeRendering = function (pos, strokeWidth) {
  var strokeWidthIsOdd = Math.round(strokeWidth % 2) === 1;
  var posValAsInt = Math.round(pos);
  return strokeWidthIsOdd ? posValAsInt + 0.5 : posValAsInt;
};
exports.makeShapesOptionsAndPlotinfo = function (gd, index) {
  var options = gd._fullLayout.shapes[index] || {};
  var plotinfo = gd._fullLayout._plots[options.xref + options.yref];
  var hasPlotinfo = !!plotinfo;
  if (hasPlotinfo) {
    plotinfo._hadPlotinfo = true;
  } else {
    plotinfo = {};
    if (options.xref && options.xref !== 'paper') plotinfo.xaxis = gd._fullLayout[options.xref + 'axis'];
    if (options.yref && options.yref !== 'paper') plotinfo.yaxis = gd._fullLayout[options.yref + 'axis'];
  }
  plotinfo.xsizemode = options.xsizemode;
  plotinfo.ysizemode = options.ysizemode;
  plotinfo.xanchor = options.xanchor;
  plotinfo.yanchor = options.yanchor;
  return {
    options: options,
    plotinfo: plotinfo
  };
};

// TODO: move to selections helpers?
exports.makeSelectionsOptionsAndPlotinfo = function (gd, index) {
  var options = gd._fullLayout.selections[index] || {};
  var plotinfo = gd._fullLayout._plots[options.xref + options.yref];
  var hasPlotinfo = !!plotinfo;
  if (hasPlotinfo) {
    plotinfo._hadPlotinfo = true;
  } else {
    plotinfo = {};
    if (options.xref) plotinfo.xaxis = gd._fullLayout[options.xref + 'axis'];
    if (options.yref) plotinfo.yaxis = gd._fullLayout[options.yref + 'axis'];
  }
  return {
    options: options,
    plotinfo: plotinfo
  };
};
exports.getPathString = function (gd, options) {
  var type = options.type;
  var xRefType = Axes.getRefType(options.xref);
  var yRefType = Axes.getRefType(options.yref);
  var xa = Axes.getFromId(gd, options.xref);
  var ya = Axes.getFromId(gd, options.yref);
  var gs = gd._fullLayout._size;
  var x2r, x2p, y2r, y2p;
  var xShiftStart = getPixelShift(xa, options.x0shift);
  var xShiftEnd = getPixelShift(xa, options.x1shift);
  var yShiftStart = getPixelShift(ya, options.y0shift);
  var yShiftEnd = getPixelShift(ya, options.y1shift);
  var x0, x1, y0, y1;
  if (xa) {
    if (xRefType === 'domain') {
      x2p = function (v) {
        return xa._offset + xa._length * v;
      };
    } else {
      x2r = exports.shapePositionToRange(xa);
      x2p = function (v) {
        return xa._offset + xa.r2p(x2r(v, true));
      };
    }
  } else {
    x2p = function (v) {
      return gs.l + gs.w * v;
    };
  }
  if (ya) {
    if (yRefType === 'domain') {
      y2p = function (v) {
        return ya._offset + ya._length * (1 - v);
      };
    } else {
      y2r = exports.shapePositionToRange(ya);
      y2p = function (v) {
        return ya._offset + ya.r2p(y2r(v, true));
      };
    }
  } else {
    y2p = function (v) {
      return gs.t + gs.h * (1 - v);
    };
  }
  if (type === 'path') {
    if (xa && xa.type === 'date') x2p = exports.decodeDate(x2p);
    if (ya && ya.type === 'date') y2p = exports.decodeDate(y2p);
    return convertPath(options, x2p, y2p);
  }
  if (options.xsizemode === 'pixel') {
    var xAnchorPos = x2p(options.xanchor);
    x0 = xAnchorPos + options.x0 + xShiftStart;
    x1 = xAnchorPos + options.x1 + xShiftEnd;
  } else {
    x0 = x2p(options.x0) + xShiftStart;
    x1 = x2p(options.x1) + xShiftEnd;
  }
  if (options.ysizemode === 'pixel') {
    var yAnchorPos = y2p(options.yanchor);
    y0 = yAnchorPos - options.y0 + yShiftStart;
    y1 = yAnchorPos - options.y1 + yShiftEnd;
  } else {
    y0 = y2p(options.y0) + yShiftStart;
    y1 = y2p(options.y1) + yShiftEnd;
  }
  if (type === 'line') return 'M' + x0 + ',' + y0 + 'L' + x1 + ',' + y1;
  if (type === 'rect') return 'M' + x0 + ',' + y0 + 'H' + x1 + 'V' + y1 + 'H' + x0 + 'Z';

  // circle
  var cx = (x0 + x1) / 2;
  var cy = (y0 + y1) / 2;
  var rx = Math.abs(cx - x0);
  var ry = Math.abs(cy - y0);
  var rArc = 'A' + rx + ',' + ry;
  var rightPt = cx + rx + ',' + cy;
  var topPt = cx + ',' + (cy - ry);
  return 'M' + rightPt + rArc + ' 0 1,1 ' + topPt + rArc + ' 0 0,1 ' + rightPt + 'Z';
};
function convertPath(options, x2p, y2p) {
  var pathIn = options.path;
  var xSizemode = options.xsizemode;
  var ySizemode = options.ysizemode;
  var xAnchor = options.xanchor;
  var yAnchor = options.yanchor;
  return pathIn.replace(constants.segmentRE, function (segment) {
    var paramNumber = 0;
    var segmentType = segment.charAt(0);
    var xParams = constants.paramIsX[segmentType];
    var yParams = constants.paramIsY[segmentType];
    var nParams = constants.numParams[segmentType];
    var paramString = segment.substr(1).replace(constants.paramRE, function (param) {
      if (xParams[paramNumber]) {
        if (xSizemode === 'pixel') param = x2p(xAnchor) + Number(param);else param = x2p(param);
      } else if (yParams[paramNumber]) {
        if (ySizemode === 'pixel') param = y2p(yAnchor) - Number(param);else param = y2p(param);
      }
      paramNumber++;
      if (paramNumber > nParams) param = 'X';
      return param;
    });
    if (paramNumber > nParams) {
      paramString = paramString.replace(/[\s,]*X.*/, '');
      Lib.log('Ignoring extra params in segment ' + segment);
    }
    return segmentType + paramString;
  });
}
function getPixelShift(axis, shift) {
  shift = shift || 0;
  var shiftPixels = 0;
  if (shift && axis && (axis.type === 'category' || axis.type === 'multicategory')) {
    shiftPixels = (axis.r2p(1) - axis.r2p(0)) * shift;
  }
  return shiftPixels;
}

/***/ }),

/***/ 43701:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var drawModule = __webpack_require__(28231);
module.exports = {
  moduleType: 'component',
  name: 'shapes',
  layoutAttributes: __webpack_require__(43144),
  supplyLayoutDefaults: __webpack_require__(74367),
  supplyDrawNewShapeDefaults: __webpack_require__(85522),
  includeBasePlot: __webpack_require__(20706)('shapes'),
  calcAutorange: __webpack_require__(44959),
  draw: drawModule.draw,
  drawOne: drawModule.drawOne
};

/***/ }),

/***/ 41235:
/***/ (function(module) {

"use strict";


// Wrapper functions to handle paper-referenced shapes, which have no axis
function d2l(v, axis) {
  return axis ? axis.d2l(v) : v;
}
function l2d(v, axis) {
  return axis ? axis.l2d(v) : v;
}
function x0Fn(shape) {
  return shape.x0;
}
function x1Fn(shape) {
  return shape.x1;
}
function y0Fn(shape) {
  return shape.y0;
}
function y1Fn(shape) {
  return shape.y1;
}
function x0shiftFn(shape) {
  return shape.x0shift || 0;
}
function x1shiftFn(shape) {
  return shape.x1shift || 0;
}
function y0shiftFn(shape) {
  return shape.y0shift || 0;
}
function y1shiftFn(shape) {
  return shape.y1shift || 0;
}
function dxFn(shape, xa) {
  return d2l(shape.x1, xa) + x1shiftFn(shape) - d2l(shape.x0, xa) - x0shiftFn(shape);
}
function dyFn(shape, xa, ya) {
  return d2l(shape.y1, ya) + y1shiftFn(shape) - d2l(shape.y0, ya) - y0shiftFn(shape);
}
function widthFn(shape, xa) {
  return Math.abs(dxFn(shape, xa));
}
function heightFn(shape, xa, ya) {
  return Math.abs(dyFn(shape, xa, ya));
}
function lengthFn(shape, xa, ya) {
  return shape.type !== 'line' ? undefined : Math.sqrt(Math.pow(dxFn(shape, xa), 2) + Math.pow(dyFn(shape, xa, ya), 2));
}
function xcenterFn(shape, xa) {
  return l2d((d2l(shape.x1, xa) + x1shiftFn(shape) + d2l(shape.x0, xa) + x0shiftFn(shape)) / 2, xa);
}
function ycenterFn(shape, xa, ya) {
  return l2d((d2l(shape.y1, ya) + y1shiftFn(shape) + d2l(shape.y0, ya) + y0shiftFn(shape)) / 2, ya);
}
function slopeFn(shape, xa, ya) {
  return shape.type !== 'line' ? undefined : dyFn(shape, xa, ya) / dxFn(shape, xa);
}
module.exports = {
  x0: x0Fn,
  x1: x1Fn,
  y0: y0Fn,
  y1: y1Fn,
  slope: slopeFn,
  dx: dxFn,
  dy: dyFn,
  width: widthFn,
  height: heightFn,
  length: lengthFn,
  xcenter: xcenterFn,
  ycenter: ycenterFn
};

/***/ }),

/***/ 8606:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var fontAttrs = __webpack_require__(80337);
var padAttrs = __webpack_require__(57891);
var extendDeepAll = (__webpack_require__(93049).extendDeepAll);
var overrideAll = (__webpack_require__(13582).overrideAll);
var animationAttrs = __webpack_require__(49722);
var templatedArray = (__webpack_require__(78032).templatedArray);
var constants = __webpack_require__(64194);
var stepsAttrs = templatedArray('step', {
  visible: {
    valType: 'boolean',
    dflt: true
  },
  method: {
    valType: 'enumerated',
    values: ['restyle', 'relayout', 'animate', 'update', 'skip'],
    dflt: 'restyle'
  },
  args: {
    valType: 'info_array',
    freeLength: true,
    items: [{
      valType: 'any'
    }, {
      valType: 'any'
    }, {
      valType: 'any'
    }]
  },
  label: {
    valType: 'string'
  },
  value: {
    valType: 'string'
  },
  execute: {
    valType: 'boolean',
    dflt: true
  }
});
module.exports = overrideAll(templatedArray('slider', {
  visible: {
    valType: 'boolean',
    dflt: true
  },
  active: {
    valType: 'number',
    min: 0,
    dflt: 0
  },
  steps: stepsAttrs,
  lenmode: {
    valType: 'enumerated',
    values: ['fraction', 'pixels'],
    dflt: 'fraction'
  },
  len: {
    valType: 'number',
    min: 0,
    dflt: 1
  },
  x: {
    valType: 'number',
    min: -2,
    max: 3,
    dflt: 0
  },
  pad: extendDeepAll(padAttrs({
    editType: 'arraydraw'
  }), {}, {
    t: {
      dflt: 20
    }
  }),
  xanchor: {
    valType: 'enumerated',
    values: ['auto', 'left', 'center', 'right'],
    dflt: 'left'
  },
  y: {
    valType: 'number',
    min: -2,
    max: 3,
    dflt: 0
  },
  yanchor: {
    valType: 'enumerated',
    values: ['auto', 'top', 'middle', 'bottom'],
    dflt: 'top'
  },
  transition: {
    duration: {
      valType: 'number',
      min: 0,
      dflt: 150
    },
    easing: {
      valType: 'enumerated',
      values: animationAttrs.transition.easing.values,
      dflt: 'cubic-in-out'
    }
  },
  currentvalue: {
    visible: {
      valType: 'boolean',
      dflt: true
    },
    xanchor: {
      valType: 'enumerated',
      values: ['left', 'center', 'right'],
      dflt: 'left'
    },
    offset: {
      valType: 'number',
      dflt: 10
    },
    prefix: {
      valType: 'string'
    },
    suffix: {
      valType: 'string'
    },
    font: fontAttrs({})
  },
  font: fontAttrs({}),
  activebgcolor: {
    valType: 'color',
    dflt: constants.gripBgActiveColor
  },
  bgcolor: {
    valType: 'color',
    dflt: constants.railBgColor
  },
  bordercolor: {
    valType: 'color',
    dflt: constants.railBorderColor
  },
  borderwidth: {
    valType: 'number',
    min: 0,
    dflt: constants.railBorderWidth
  },
  ticklen: {
    valType: 'number',
    min: 0,
    dflt: constants.tickLength
  },
  tickcolor: {
    valType: 'color',
    dflt: constants.tickColor
  },
  tickwidth: {
    valType: 'number',
    min: 0,
    dflt: 1
  },
  minorticklen: {
    valType: 'number',
    min: 0,
    dflt: constants.minorTickLength
  }
}), 'arraydraw', 'from-root');

/***/ }),

/***/ 64194:
/***/ (function(module) {

"use strict";


module.exports = {
  // layout attribute name
  name: 'sliders',
  // class names
  containerClassName: 'slider-container',
  groupClassName: 'slider-group',
  inputAreaClass: 'slider-input-area',
  railRectClass: 'slider-rail-rect',
  railTouchRectClass: 'slider-rail-touch-rect',
  gripRectClass: 'slider-grip-rect',
  tickRectClass: 'slider-tick-rect',
  inputProxyClass: 'slider-input-proxy',
  labelsClass: 'slider-labels',
  labelGroupClass: 'slider-label-group',
  labelClass: 'slider-label',
  currentValueClass: 'slider-current-value',
  railHeight: 5,
  // DOM attribute name in button group keeping track
  // of active update menu
  menuIndexAttrName: 'slider-active-index',
  // id root pass to Plots.autoMargin
  autoMarginIdRoot: 'slider-',
  // min item width / height
  minWidth: 30,
  minHeight: 30,
  // padding around item text
  textPadX: 40,
  // arrow offset off right edge
  arrowOffsetX: 4,
  railRadius: 2,
  railWidth: 5,
  railBorder: 4,
  railBorderWidth: 1,
  railBorderColor: '#bec8d9',
  railBgColor: '#f8fafc',
  // The distance of the rail from the edge of the touchable area
  // Slightly less than the step inset because of the curved edges
  // of the rail
  railInset: 8,
  // The distance from the extremal tick marks to the edge of the
  // touchable area. This is basically the same as the grip radius,
  // but for other styles it wouldn't really need to be.
  stepInset: 10,
  gripRadius: 10,
  gripWidth: 20,
  gripHeight: 20,
  gripBorder: 20,
  gripBorderWidth: 1,
  gripBorderColor: '#bec8d9',
  gripBgColor: '#f6f8fa',
  gripBgActiveColor: '#dbdde0',
  labelPadding: 8,
  labelOffset: 0,
  tickWidth: 1,
  tickColor: '#333',
  tickOffset: 25,
  tickLength: 7,
  minorTickOffset: 25,
  minorTickColor: '#333',
  minorTickLength: 4,
  // Extra space below the current value label:
  currentValuePadding: 8,
  currentValueInset: 0
};

/***/ }),

/***/ 74537:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var handleArrayContainerDefaults = __webpack_require__(59008);
var attributes = __webpack_require__(8606);
var constants = __webpack_require__(64194);
var name = constants.name;
var stepAttrs = attributes.steps;
module.exports = function slidersDefaults(layoutIn, layoutOut) {
  handleArrayContainerDefaults(layoutIn, layoutOut, {
    name: name,
    handleItemDefaults: sliderDefaults
  });
};
function sliderDefaults(sliderIn, sliderOut, layoutOut) {
  function coerce(attr, dflt) {
    return Lib.coerce(sliderIn, sliderOut, attributes, attr, dflt);
  }
  var steps = handleArrayContainerDefaults(sliderIn, sliderOut, {
    name: 'steps',
    handleItemDefaults: stepDefaults
  });
  var stepCount = 0;
  for (var i = 0; i < steps.length; i++) {
    if (steps[i].visible) stepCount++;
  }
  var visible;
  // If it has fewer than two options, it's not really a slider
  if (stepCount < 2) visible = sliderOut.visible = false;else visible = coerce('visible');
  if (!visible) return;
  sliderOut._stepCount = stepCount;
  var visSteps = sliderOut._visibleSteps = Lib.filterVisible(steps);
  var active = coerce('active');
  if (!(steps[active] || {}).visible) sliderOut.active = visSteps[0]._index;
  coerce('x');
  coerce('y');
  Lib.noneOrAll(sliderIn, sliderOut, ['x', 'y']);
  coerce('xanchor');
  coerce('yanchor');
  coerce('len');
  coerce('lenmode');
  coerce('pad.t');
  coerce('pad.r');
  coerce('pad.b');
  coerce('pad.l');
  Lib.coerceFont(coerce, 'font', layoutOut.font);
  var currentValueIsVisible = coerce('currentvalue.visible');
  if (currentValueIsVisible) {
    coerce('currentvalue.xanchor');
    coerce('currentvalue.prefix');
    coerce('currentvalue.suffix');
    coerce('currentvalue.offset');
    Lib.coerceFont(coerce, 'currentvalue.font', sliderOut.font);
  }
  coerce('transition.duration');
  coerce('transition.easing');
  coerce('bgcolor');
  coerce('activebgcolor');
  coerce('bordercolor');
  coerce('borderwidth');
  coerce('ticklen');
  coerce('tickwidth');
  coerce('tickcolor');
  coerce('minorticklen');
}
function stepDefaults(valueIn, valueOut) {
  function coerce(attr, dflt) {
    return Lib.coerce(valueIn, valueOut, stepAttrs, attr, dflt);
  }
  var visible;
  if (valueIn.method !== 'skip' && !Array.isArray(valueIn.args)) {
    visible = valueOut.visible = false;
  } else visible = coerce('visible');
  if (visible) {
    coerce('method');
    coerce('args');
    var label = coerce('label', 'step-' + valueOut._index);
    coerce('value', label);
    coerce('execute');
  }
}

/***/ }),

/***/ 44097:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var Plots = __webpack_require__(44122);
var Color = __webpack_require__(78766);
var Drawing = __webpack_require__(62203);
var Lib = __webpack_require__(34809);
var strTranslate = Lib.strTranslate;
var svgTextUtils = __webpack_require__(30635);
var arrayEditor = (__webpack_require__(78032).arrayEditor);
var constants = __webpack_require__(64194);
var alignmentConstants = __webpack_require__(4530);
var LINE_SPACING = alignmentConstants.LINE_SPACING;
var FROM_TL = alignmentConstants.FROM_TL;
var FROM_BR = alignmentConstants.FROM_BR;
module.exports = function draw(gd) {
  var staticPlot = gd._context.staticPlot;
  var fullLayout = gd._fullLayout;
  var sliderData = makeSliderData(fullLayout, gd);

  // draw a container for *all* sliders:
  var sliders = fullLayout._infolayer.selectAll('g.' + constants.containerClassName).data(sliderData.length > 0 ? [0] : []);
  sliders.enter().append('g').classed(constants.containerClassName, true).style('cursor', staticPlot ? null : 'ew-resize');
  function clearSlider(sliderOpts) {
    if (sliderOpts._commandObserver) {
      sliderOpts._commandObserver.remove();
      delete sliderOpts._commandObserver;
    }

    // Most components don't need to explicitly remove autoMargin, because
    // marginPushers does this - but slider updates don't go through
    // a full replot so we need to explicitly remove it.
    Plots.autoMargin(gd, autoMarginId(sliderOpts));
  }
  sliders.exit().each(function () {
    d3.select(this).selectAll('g.' + constants.groupClassName).each(clearSlider);
  }).remove();

  // Return early if no menus visible:
  if (sliderData.length === 0) return;
  var sliderGroups = sliders.selectAll('g.' + constants.groupClassName).data(sliderData, keyFunction);
  sliderGroups.enter().append('g').classed(constants.groupClassName, true);
  sliderGroups.exit().each(clearSlider).remove();

  // Find the dimensions of the sliders:
  for (var i = 0; i < sliderData.length; i++) {
    var sliderOpts = sliderData[i];
    findDimensions(gd, sliderOpts);
  }
  sliderGroups.each(function (sliderOpts) {
    var gSlider = d3.select(this);
    computeLabelSteps(sliderOpts);
    Plots.manageCommandObserver(gd, sliderOpts, sliderOpts._visibleSteps, function (data) {
      // NB: Same as below. This is *not* always the same as sliderOpts since
      // if a new set of steps comes in, the reference in this callback would
      // be invalid. We need to refetch it from the slider group, which is
      // the join data that creates this slider. So if this slider still exists,
      // the group should be valid, *to the best of my knowledge.* If not,
      // we'd have to look it up by d3 data join index/key.
      var opts = gSlider.data()[0];
      if (opts.active === data.index) return;
      if (opts._dragging) return;
      setActive(gd, gSlider, opts, data.index, false, true);
    });
    drawSlider(gd, d3.select(this), sliderOpts);
  });
};
function autoMarginId(sliderOpts) {
  return constants.autoMarginIdRoot + sliderOpts._index;
}

// This really only just filters by visibility:
function makeSliderData(fullLayout, gd) {
  var contOpts = fullLayout[constants.name];
  var sliderData = [];
  for (var i = 0; i < contOpts.length; i++) {
    var item = contOpts[i];
    if (!item.visible) continue;
    item._gd = gd;
    sliderData.push(item);
  }
  return sliderData;
}

// This is set in the defaults step:
function keyFunction(opts) {
  return opts._index;
}

// Compute the dimensions (mutates sliderOpts):
function findDimensions(gd, sliderOpts) {
  var sliderLabels = Drawing.tester.selectAll('g.' + constants.labelGroupClass).data(sliderOpts._visibleSteps);
  sliderLabels.enter().append('g').classed(constants.labelGroupClass, true);

  // loop over fake buttons to find width / height
  var maxLabelWidth = 0;
  var labelHeight = 0;
  sliderLabels.each(function (stepOpts) {
    var labelGroup = d3.select(this);
    var text = drawLabel(labelGroup, {
      step: stepOpts
    }, sliderOpts);
    var textNode = text.node();
    if (textNode) {
      var bBox = Drawing.bBox(textNode);
      labelHeight = Math.max(labelHeight, bBox.height);
      maxLabelWidth = Math.max(maxLabelWidth, bBox.width);
    }
  });
  sliderLabels.remove();
  var dims = sliderOpts._dims = {};
  dims.inputAreaWidth = Math.max(constants.railWidth, constants.gripHeight);

  // calculate some overall dimensions - some of these are needed for
  // calculating the currentValue dimensions
  var graphSize = gd._fullLayout._size;
  dims.lx = graphSize.l + graphSize.w * sliderOpts.x;
  dims.ly = graphSize.t + graphSize.h * (1 - sliderOpts.y);
  if (sliderOpts.lenmode === 'fraction') {
    // fraction:
    dims.outerLength = Math.round(graphSize.w * sliderOpts.len);
  } else {
    // pixels:
    dims.outerLength = sliderOpts.len;
  }

  // The length of the rail, *excluding* padding on either end:
  dims.inputAreaStart = 0;
  dims.inputAreaLength = Math.round(dims.outerLength - sliderOpts.pad.l - sliderOpts.pad.r);
  var textableInputLength = dims.inputAreaLength - 2 * constants.stepInset;
  var availableSpacePerLabel = textableInputLength / (sliderOpts._stepCount - 1);
  var computedSpacePerLabel = maxLabelWidth + constants.labelPadding;
  dims.labelStride = Math.max(1, Math.ceil(computedSpacePerLabel / availableSpacePerLabel));
  dims.labelHeight = labelHeight;

  // loop over all possible values for currentValue to find the
  // area we need for it
  dims.currentValueMaxWidth = 0;
  dims.currentValueHeight = 0;
  dims.currentValueTotalHeight = 0;
  dims.currentValueMaxLines = 1;
  if (sliderOpts.currentvalue.visible) {
    // Get the dimensions of the current value label:
    var dummyGroup = Drawing.tester.append('g');
    sliderLabels.each(function (stepOpts) {
      var curValPrefix = drawCurrentValue(dummyGroup, sliderOpts, stepOpts.label);
      var curValSize = curValPrefix.node() && Drawing.bBox(curValPrefix.node()) || {
        width: 0,
        height: 0
      };
      var lines = svgTextUtils.lineCount(curValPrefix);
      dims.currentValueMaxWidth = Math.max(dims.currentValueMaxWidth, Math.ceil(curValSize.width));
      dims.currentValueHeight = Math.max(dims.currentValueHeight, Math.ceil(curValSize.height));
      dims.currentValueMaxLines = Math.max(dims.currentValueMaxLines, lines);
    });
    dims.currentValueTotalHeight = dims.currentValueHeight + sliderOpts.currentvalue.offset;
    dummyGroup.remove();
  }
  dims.height = dims.currentValueTotalHeight + constants.tickOffset + sliderOpts.ticklen + constants.labelOffset + dims.labelHeight + sliderOpts.pad.t + sliderOpts.pad.b;
  var xanchor = 'left';
  if (Lib.isRightAnchor(sliderOpts)) {
    dims.lx -= dims.outerLength;
    xanchor = 'right';
  }
  if (Lib.isCenterAnchor(sliderOpts)) {
    dims.lx -= dims.outerLength / 2;
    xanchor = 'center';
  }
  var yanchor = 'top';
  if (Lib.isBottomAnchor(sliderOpts)) {
    dims.ly -= dims.height;
    yanchor = 'bottom';
  }
  if (Lib.isMiddleAnchor(sliderOpts)) {
    dims.ly -= dims.height / 2;
    yanchor = 'middle';
  }
  dims.outerLength = Math.ceil(dims.outerLength);
  dims.height = Math.ceil(dims.height);
  dims.lx = Math.round(dims.lx);
  dims.ly = Math.round(dims.ly);
  var marginOpts = {
    y: sliderOpts.y,
    b: dims.height * FROM_BR[yanchor],
    t: dims.height * FROM_TL[yanchor]
  };
  if (sliderOpts.lenmode === 'fraction') {
    marginOpts.l = 0;
    marginOpts.xl = sliderOpts.x - sliderOpts.len * FROM_TL[xanchor];
    marginOpts.r = 0;
    marginOpts.xr = sliderOpts.x + sliderOpts.len * FROM_BR[xanchor];
  } else {
    marginOpts.x = sliderOpts.x;
    marginOpts.l = dims.outerLength * FROM_TL[xanchor];
    marginOpts.r = dims.outerLength * FROM_BR[xanchor];
  }
  Plots.autoMargin(gd, autoMarginId(sliderOpts), marginOpts);
}
function drawSlider(gd, sliderGroup, sliderOpts) {
  // This is related to the other long notes in this file regarding what happens
  // when slider steps disappear. This particular fix handles what happens when
  // the *current* slider step is removed. The drawing functions will error out
  // when they fail to find it, so the fix for now is that it will just draw the
  // slider in the first position but will not execute the command.
  if (!(sliderOpts.steps[sliderOpts.active] || {}).visible) {
    sliderOpts.active = sliderOpts._visibleSteps[0]._index;
  }

  // These are carefully ordered for proper z-ordering:
  sliderGroup.call(drawCurrentValue, sliderOpts).call(drawRail, sliderOpts).call(drawLabelGroup, sliderOpts).call(drawTicks, sliderOpts).call(drawTouchRect, gd, sliderOpts).call(drawGrip, gd, sliderOpts);
  var dims = sliderOpts._dims;

  // Position the rectangle:
  Drawing.setTranslate(sliderGroup, dims.lx + sliderOpts.pad.l, dims.ly + sliderOpts.pad.t);
  sliderGroup.call(setGripPosition, sliderOpts, false);
  sliderGroup.call(drawCurrentValue, sliderOpts);
}
function drawCurrentValue(sliderGroup, sliderOpts, valueOverride) {
  if (!sliderOpts.currentvalue.visible) return;
  var dims = sliderOpts._dims;
  var x0, textAnchor;
  switch (sliderOpts.currentvalue.xanchor) {
    case 'right':
      // This is anchored left and adjusted by the width of the longest label
      // so that the prefix doesn't move. The goal of this is to emphasize
      // what's actually changing and make the update less distracting.
      x0 = dims.inputAreaLength - constants.currentValueInset - dims.currentValueMaxWidth;
      textAnchor = 'left';
      break;
    case 'center':
      x0 = dims.inputAreaLength * 0.5;
      textAnchor = 'middle';
      break;
    default:
      x0 = constants.currentValueInset;
      textAnchor = 'left';
  }
  var text = Lib.ensureSingle(sliderGroup, 'text', constants.labelClass, function (s) {
    s.attr({
      'text-anchor': textAnchor,
      'data-notex': 1
    });
  });
  var str = sliderOpts.currentvalue.prefix ? sliderOpts.currentvalue.prefix : '';
  if (typeof valueOverride === 'string') {
    str += valueOverride;
  } else {
    var curVal = sliderOpts.steps[sliderOpts.active].label;
    var _meta = sliderOpts._gd._fullLayout._meta;
    if (_meta) curVal = Lib.templateString(curVal, _meta);
    str += curVal;
  }
  if (sliderOpts.currentvalue.suffix) {
    str += sliderOpts.currentvalue.suffix;
  }
  text.call(Drawing.font, sliderOpts.currentvalue.font).text(str).call(svgTextUtils.convertToTspans, sliderOpts._gd);
  var lines = svgTextUtils.lineCount(text);
  var y0 = (dims.currentValueMaxLines + 1 - lines) * sliderOpts.currentvalue.font.size * LINE_SPACING;
  svgTextUtils.positionText(text, x0, y0);
  return text;
}
function drawGrip(sliderGroup, gd, sliderOpts) {
  var grip = Lib.ensureSingle(sliderGroup, 'rect', constants.gripRectClass, function (s) {
    s.call(attachGripEvents, gd, sliderGroup, sliderOpts).style('pointer-events', 'all');
  });
  grip.attr({
    width: constants.gripWidth,
    height: constants.gripHeight,
    rx: constants.gripRadius,
    ry: constants.gripRadius
  }).call(Color.stroke, sliderOpts.bordercolor).call(Color.fill, sliderOpts.bgcolor).style('stroke-width', sliderOpts.borderwidth + 'px');
}
function drawLabel(item, data, sliderOpts) {
  var text = Lib.ensureSingle(item, 'text', constants.labelClass, function (s) {
    s.attr({
      'text-anchor': 'middle',
      'data-notex': 1
    });
  });
  var tx = data.step.label;
  var _meta = sliderOpts._gd._fullLayout._meta;
  if (_meta) tx = Lib.templateString(tx, _meta);
  text.call(Drawing.font, sliderOpts.font).text(tx).call(svgTextUtils.convertToTspans, sliderOpts._gd);
  return text;
}
function drawLabelGroup(sliderGroup, sliderOpts) {
  var labels = Lib.ensureSingle(sliderGroup, 'g', constants.labelsClass);
  var dims = sliderOpts._dims;
  var labelItems = labels.selectAll('g.' + constants.labelGroupClass).data(dims.labelSteps);
  labelItems.enter().append('g').classed(constants.labelGroupClass, true);
  labelItems.exit().remove();
  labelItems.each(function (d) {
    var item = d3.select(this);
    item.call(drawLabel, d, sliderOpts);
    Drawing.setTranslate(item, normalizedValueToPosition(sliderOpts, d.fraction), constants.tickOffset + sliderOpts.ticklen +
    // position is the baseline of the top line of text only, even
    // if the label spans multiple lines
    sliderOpts.font.size * LINE_SPACING + constants.labelOffset + dims.currentValueTotalHeight);
  });
}
function handleInput(gd, sliderGroup, sliderOpts, normalizedPosition, doTransition) {
  var quantizedPosition = Math.round(normalizedPosition * (sliderOpts._stepCount - 1));
  var quantizedIndex = sliderOpts._visibleSteps[quantizedPosition]._index;
  if (quantizedIndex !== sliderOpts.active) {
    setActive(gd, sliderGroup, sliderOpts, quantizedIndex, true, doTransition);
  }
}
function setActive(gd, sliderGroup, sliderOpts, index, doCallback, doTransition) {
  var previousActive = sliderOpts.active;
  sliderOpts.active = index;

  // due to templating, it's possible this slider doesn't even exist yet
  arrayEditor(gd.layout, constants.name, sliderOpts).applyUpdate('active', index);
  var step = sliderOpts.steps[sliderOpts.active];
  sliderGroup.call(setGripPosition, sliderOpts, doTransition);
  sliderGroup.call(drawCurrentValue, sliderOpts);
  gd.emit('plotly_sliderchange', {
    slider: sliderOpts,
    step: sliderOpts.steps[sliderOpts.active],
    interaction: doCallback,
    previousActive: previousActive
  });
  if (step && step.method && doCallback) {
    if (sliderGroup._nextMethod) {
      // If we've already queued up an update, just overwrite it with the most recent:
      sliderGroup._nextMethod.step = step;
      sliderGroup._nextMethod.doCallback = doCallback;
      sliderGroup._nextMethod.doTransition = doTransition;
    } else {
      sliderGroup._nextMethod = {
        step: step,
        doCallback: doCallback,
        doTransition: doTransition
      };
      sliderGroup._nextMethodRaf = window.requestAnimationFrame(function () {
        var _step = sliderGroup._nextMethod.step;
        if (!_step.method) return;
        if (_step.execute) {
          Plots.executeAPICommand(gd, _step.method, _step.args);
        }
        sliderGroup._nextMethod = null;
        sliderGroup._nextMethodRaf = null;
      });
    }
  }
}
function attachGripEvents(item, gd, sliderGroup) {
  if (gd._context.staticPlot) return;
  var node = sliderGroup.node();
  var $gd = d3.select(gd);

  // NB: This is *not* the same as sliderOpts itself! These callbacks
  // are in a closure so this array won't actually be correct if the
  // steps have changed since this was initialized. The sliderGroup,
  // however, has not changed since that *is* the slider, so it must
  // be present to receive mouse events.
  function getSliderOpts() {
    return sliderGroup.data()[0];
  }
  function mouseDownHandler() {
    var sliderOpts = getSliderOpts();
    gd.emit('plotly_sliderstart', {
      slider: sliderOpts
    });
    var grip = sliderGroup.select('.' + constants.gripRectClass);
    d3.event.stopPropagation();
    d3.event.preventDefault();
    grip.call(Color.fill, sliderOpts.activebgcolor);
    var normalizedPosition = positionToNormalizedValue(sliderOpts, d3.mouse(node)[0]);
    handleInput(gd, sliderGroup, sliderOpts, normalizedPosition, true);
    sliderOpts._dragging = true;
    function mouseMoveHandler() {
      var sliderOpts = getSliderOpts();
      var normalizedPosition = positionToNormalizedValue(sliderOpts, d3.mouse(node)[0]);
      handleInput(gd, sliderGroup, sliderOpts, normalizedPosition, false);
    }
    $gd.on('mousemove', mouseMoveHandler);
    $gd.on('touchmove', mouseMoveHandler);
    function mouseUpHandler() {
      var sliderOpts = getSliderOpts();
      sliderOpts._dragging = false;
      grip.call(Color.fill, sliderOpts.bgcolor);
      $gd.on('mouseup', null);
      $gd.on('mousemove', null);
      $gd.on('touchend', null);
      $gd.on('touchmove', null);
      gd.emit('plotly_sliderend', {
        slider: sliderOpts,
        step: sliderOpts.steps[sliderOpts.active]
      });
    }
    $gd.on('mouseup', mouseUpHandler);
    $gd.on('touchend', mouseUpHandler);
  }
  item.on('mousedown', mouseDownHandler);
  item.on('touchstart', mouseDownHandler);
}
function drawTicks(sliderGroup, sliderOpts) {
  var tick = sliderGroup.selectAll('rect.' + constants.tickRectClass).data(sliderOpts._visibleSteps);
  var dims = sliderOpts._dims;
  tick.enter().append('rect').classed(constants.tickRectClass, true);
  tick.exit().remove();
  tick.attr({
    width: sliderOpts.tickwidth + 'px',
    'shape-rendering': 'crispEdges'
  });
  tick.each(function (d, i) {
    var isMajor = i % dims.labelStride === 0;
    var item = d3.select(this);
    item.attr({
      height: isMajor ? sliderOpts.ticklen : sliderOpts.minorticklen
    }).call(Color.fill, isMajor ? sliderOpts.tickcolor : sliderOpts.tickcolor);
    Drawing.setTranslate(item, normalizedValueToPosition(sliderOpts, i / (sliderOpts._stepCount - 1)) - 0.5 * sliderOpts.tickwidth, (isMajor ? constants.tickOffset : constants.minorTickOffset) + dims.currentValueTotalHeight);
  });
}
function computeLabelSteps(sliderOpts) {
  var dims = sliderOpts._dims;
  dims.labelSteps = [];
  var nsteps = sliderOpts._stepCount;
  for (var i = 0; i < nsteps; i += dims.labelStride) {
    dims.labelSteps.push({
      fraction: i / (nsteps - 1),
      step: sliderOpts._visibleSteps[i]
    });
  }
}
function setGripPosition(sliderGroup, sliderOpts, doTransition) {
  var grip = sliderGroup.select('rect.' + constants.gripRectClass);
  var quantizedIndex = 0;
  for (var i = 0; i < sliderOpts._stepCount; i++) {
    if (sliderOpts._visibleSteps[i]._index === sliderOpts.active) {
      quantizedIndex = i;
      break;
    }
  }
  var x = normalizedValueToPosition(sliderOpts, quantizedIndex / (sliderOpts._stepCount - 1));

  // If this is true, then *this component* is already invoking its own command
  // and has triggered its own animation.
  if (sliderOpts._invokingCommand) return;
  var el = grip;
  if (doTransition && sliderOpts.transition.duration > 0) {
    el = el.transition().duration(sliderOpts.transition.duration).ease(sliderOpts.transition.easing);
  }

  // Drawing.setTranslate doesn't work here because of the transition duck-typing.
  // It's also not necessary because there are no other transitions to preserve.
  el.attr('transform', strTranslate(x - constants.gripWidth * 0.5, sliderOpts._dims.currentValueTotalHeight));
}

// Convert a number from [0-1] to a pixel position relative to the slider group container:
function normalizedValueToPosition(sliderOpts, normalizedPosition) {
  var dims = sliderOpts._dims;
  return dims.inputAreaStart + constants.stepInset + (dims.inputAreaLength - 2 * constants.stepInset) * Math.min(1, Math.max(0, normalizedPosition));
}

// Convert a position relative to the slider group to a nubmer in [0, 1]
function positionToNormalizedValue(sliderOpts, position) {
  var dims = sliderOpts._dims;
  return Math.min(1, Math.max(0, (position - constants.stepInset - dims.inputAreaStart) / (dims.inputAreaLength - 2 * constants.stepInset - 2 * dims.inputAreaStart)));
}
function drawTouchRect(sliderGroup, gd, sliderOpts) {
  var dims = sliderOpts._dims;
  var rect = Lib.ensureSingle(sliderGroup, 'rect', constants.railTouchRectClass, function (s) {
    s.call(attachGripEvents, gd, sliderGroup, sliderOpts).style('pointer-events', 'all');
  });
  rect.attr({
    width: dims.inputAreaLength,
    height: Math.max(dims.inputAreaWidth, constants.tickOffset + sliderOpts.ticklen + dims.labelHeight)
  }).call(Color.fill, sliderOpts.bgcolor).attr('opacity', 0);
  Drawing.setTranslate(rect, 0, dims.currentValueTotalHeight);
}
function drawRail(sliderGroup, sliderOpts) {
  var dims = sliderOpts._dims;
  var computedLength = dims.inputAreaLength - constants.railInset * 2;
  var rect = Lib.ensureSingle(sliderGroup, 'rect', constants.railRectClass);
  rect.attr({
    width: computedLength,
    height: constants.railWidth,
    rx: constants.railRadius,
    ry: constants.railRadius,
    'shape-rendering': 'crispEdges'
  }).call(Color.stroke, sliderOpts.bordercolor).call(Color.fill, sliderOpts.bgcolor).style('stroke-width', sliderOpts.borderwidth + 'px');
  Drawing.setTranslate(rect, constants.railInset, (dims.inputAreaWidth - constants.railWidth) * 0.5 + dims.currentValueTotalHeight);
}

/***/ }),

/***/ 15359:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var constants = __webpack_require__(64194);
module.exports = {
  moduleType: 'component',
  name: constants.name,
  layoutAttributes: __webpack_require__(8606),
  supplyLayoutDefaults: __webpack_require__(74537),
  draw: __webpack_require__(44097)
};

/***/ }),

/***/ 17240:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var isNumeric = __webpack_require__(10721);
var Plots = __webpack_require__(44122);
var Registry = __webpack_require__(33626);
var Lib = __webpack_require__(34809);
var strTranslate = Lib.strTranslate;
var Drawing = __webpack_require__(62203);
var Color = __webpack_require__(78766);
var svgTextUtils = __webpack_require__(30635);
var interactConstants = __webpack_require__(20438);
var OPPOSITE_SIDE = (__webpack_require__(4530).OPPOSITE_SIDE);
var numStripRE = / [XY][0-9]* /;
var SUBTITLE_PADDING_MATHJAX_EM = 1.6;
var SUBTITLE_PADDING_EM = 1.6;

/**
 * Titles - (re)draw titles on the axes and plot:
 * @param {DOM element} gd - the graphDiv
 * @param {string} titleClass - the css class of this title
 * @param {object} options - how and what to draw
 *      propContainer - the layout object containing `title` and `titlefont`
 *          attributes that apply to this title
 *      propName - the full name of the title property (for Plotly.relayout)
 *      [traceIndex] - include only if this property applies to one trace
 *          (such as a colorbar title) - then editing pipes to Plotly.restyle
 *          instead of Plotly.relayout
 *      placeholder - placeholder text for an empty editable title
 *      [avoid] {object} - include if this title should move to avoid other elements
 *          selection - d3 selection of elements to avoid
 *          side - which direction to move if there is a conflict
 *          [offsetLeft] - if these elements are subject to a translation
 *              wrt the title element
 *          [offsetTop]
 *      attributes {object} - position and alignment attributes
 *          x - pixels
 *          y - pixels
 *          text-anchor - start|middle|end
 *      transform {object} - how to transform the title after positioning
 *          rotate - degrees
 *          offset - shift up/down in the rotated frame (unused?)
 *      containerGroup - if an svg <g> element already exists to hold this
 *          title, include here. Otherwise it will go in fullLayout._infolayer
 *      _meta {object (optional} - meta key-value to for title with
 *          Lib.templateString, default to fullLayout._meta, if not provided
 *
 *  @return {selection} d3 selection of title container group
 */
function draw(gd, titleClass, options) {
  var fullLayout = gd._fullLayout;
  var cont = options.propContainer;
  var prop = options.propName;
  var placeholder = options.placeholder;
  var traceIndex = options.traceIndex;
  var avoid = options.avoid || {};
  var attributes = options.attributes;
  var transform = options.transform;
  var group = options.containerGroup;
  var opacity = 1;
  var title = cont.title;
  var txt = (title && title.text ? title.text : '').trim();
  var titleIsPlaceholder = false;
  var font = title && title.font ? title.font : {};
  var fontFamily = font.family;
  var fontSize = font.size;
  var fontColor = font.color;
  var fontWeight = font.weight;
  var fontStyle = font.style;
  var fontVariant = font.variant;
  var fontTextcase = font.textcase;
  var fontLineposition = font.lineposition;
  var fontShadow = font.shadow;

  // Get subtitle properties
  var subtitleProp = options.subtitlePropName;
  var subtitleEnabled = !!subtitleProp;
  var subtitlePlaceholder = options.subtitlePlaceholder;
  var subtitle = (cont.title || {}).subtitle || {
    text: '',
    font: {}
  };
  var subtitleTxt = subtitle.text.trim();
  var subtitleIsPlaceholder = false;
  var subtitleOpacity = 1;
  var subtitleFont = subtitle.font;
  var subFontFamily = subtitleFont.family;
  var subFontSize = subtitleFont.size;
  var subFontColor = subtitleFont.color;
  var subFontWeight = subtitleFont.weight;
  var subFontStyle = subtitleFont.style;
  var subFontVariant = subtitleFont.variant;
  var subFontTextcase = subtitleFont.textcase;
  var subFontLineposition = subtitleFont.lineposition;
  var subFontShadow = subtitleFont.shadow;

  // only make this title editable if we positively identify its property
  // as one that has editing enabled.
  // Subtitle is editable if and only if title is editable
  var editAttr;
  if (prop === 'title.text') editAttr = 'titleText';else if (prop.indexOf('axis') !== -1) editAttr = 'axisTitleText';else if (prop.indexOf('colorbar' !== -1)) editAttr = 'colorbarTitleText';
  var editable = gd._context.edits[editAttr];
  function matchesPlaceholder(text, placeholder) {
    if (text === undefined || placeholder === undefined) return false;
    // look for placeholder text while stripping out numbers from eg X2, Y3
    // this is just for backward compatibility with the old version that had
    // "Click to enter X2 title" and may have gotten saved in some old plots,
    // we don't want this to show up when these are displayed.
    return text.replace(numStripRE, ' % ') === placeholder.replace(numStripRE, ' % ');
  }
  if (txt === '') opacity = 0;else if (matchesPlaceholder(txt, placeholder)) {
    if (!editable) txt = '';
    opacity = 0.2;
    titleIsPlaceholder = true;
  }
  if (subtitleEnabled) {
    if (subtitleTxt === '') subtitleOpacity = 0;else if (matchesPlaceholder(subtitleTxt, subtitlePlaceholder)) {
      if (!editable) subtitleTxt = '';
      subtitleOpacity = 0.2;
      subtitleIsPlaceholder = true;
    }
  }
  if (options._meta) {
    txt = Lib.templateString(txt, options._meta);
  } else if (fullLayout._meta) {
    txt = Lib.templateString(txt, fullLayout._meta);
  }
  var elShouldExist = txt || subtitleTxt || editable;
  var hColorbarMoveTitle;
  if (!group) {
    group = Lib.ensureSingle(fullLayout._infolayer, 'g', 'g-' + titleClass);
    hColorbarMoveTitle = fullLayout._hColorbarMoveTitle;
  }
  var el = group.selectAll('text.' + titleClass).data(elShouldExist ? [0] : []);
  el.enter().append('text');
  el.text(txt)
  // this is hacky, but convertToTspans uses the class
  // to determine whether to rotate mathJax...
  // so we need to clear out any old class and put the
  // correct one (only relevant for colorbars, at least
  // for now) - ie don't use .classed
  .attr('class', titleClass);
  el.exit().remove();
  var subtitleEl = null;
  var subtitleClass = titleClass + '-subtitle';
  var subtitleElShouldExist = subtitleTxt || editable;
  if (subtitleEnabled && subtitleElShouldExist) {
    subtitleEl = group.selectAll('text.' + subtitleClass).data(subtitleElShouldExist ? [0] : []);
    subtitleEl.enter().append('text');
    subtitleEl.text(subtitleTxt).attr('class', subtitleClass);
    subtitleEl.exit().remove();
  }
  if (!elShouldExist) return group;
  function titleLayout(titleEl, subtitleEl) {
    Lib.syncOrAsync([drawTitle, scootTitle], {
      title: titleEl,
      subtitle: subtitleEl
    });
  }
  function drawTitle(titleAndSubtitleEls) {
    var titleEl = titleAndSubtitleEls.title;
    var subtitleEl = titleAndSubtitleEls.subtitle;
    var transformVal;
    if (!transform && hColorbarMoveTitle) {
      transform = {};
    }
    if (transform) {
      transformVal = '';
      if (transform.rotate) {
        transformVal += 'rotate(' + [transform.rotate, attributes.x, attributes.y] + ')';
      }
      if (transform.offset || hColorbarMoveTitle) {
        transformVal += strTranslate(0, (transform.offset || 0) - (hColorbarMoveTitle || 0));
      }
    } else {
      transformVal = null;
    }
    titleEl.attr('transform', transformVal);

    // Callback to adjust the subtitle position after mathjax is rendered
    // Mathjax is rendered asynchronously, which is why this step needs to be
    // passed as a callback
    function adjustSubtitlePosition(titleElMathGroup) {
      if (!titleElMathGroup) return;
      var subtitleElement = d3.select(titleElMathGroup.node().parentNode).select('.' + subtitleClass);
      if (!subtitleElement.empty()) {
        var titleElMathBbox = titleElMathGroup.node().getBBox();
        if (titleElMathBbox.height) {
          // Position subtitle based on bottom of Mathjax title
          var subtitleY = titleElMathBbox.y + titleElMathBbox.height + SUBTITLE_PADDING_MATHJAX_EM * subFontSize;
          subtitleElement.attr('y', subtitleY);
        }
      }
    }
    titleEl.style('opacity', opacity * Color.opacity(fontColor)).call(Drawing.font, {
      color: Color.rgb(fontColor),
      size: d3.round(fontSize, 2),
      family: fontFamily,
      weight: fontWeight,
      style: fontStyle,
      variant: fontVariant,
      textcase: fontTextcase,
      shadow: fontShadow,
      lineposition: fontLineposition
    }).attr(attributes).call(svgTextUtils.convertToTspans, gd, adjustSubtitlePosition);
    if (subtitleEl) {
      // Set subtitle y position based on bottom of title
      // We need to check the Mathjax group as well, in case the Mathjax
      // has already rendered
      var titleElMathGroup = group.select('.' + titleClass + '-math-group');
      var titleElBbox = titleEl.node().getBBox();
      var titleElMathBbox = titleElMathGroup.node() ? titleElMathGroup.node().getBBox() : undefined;
      var subtitleY = titleElMathBbox ? titleElMathBbox.y + titleElMathBbox.height + SUBTITLE_PADDING_MATHJAX_EM * subFontSize : titleElBbox.y + titleElBbox.height + SUBTITLE_PADDING_EM * subFontSize;
      var subtitleAttributes = Lib.extendFlat({}, attributes, {
        y: subtitleY
      });
      subtitleEl.attr('transform', transformVal);
      subtitleEl.style('opacity', subtitleOpacity * Color.opacity(subFontColor)).call(Drawing.font, {
        color: Color.rgb(subFontColor),
        size: d3.round(subFontSize, 2),
        family: subFontFamily,
        weight: subFontWeight,
        style: subFontStyle,
        variant: subFontVariant,
        textcase: subFontTextcase,
        shadow: subFontShadow,
        lineposition: subFontLineposition
      }).attr(subtitleAttributes).call(svgTextUtils.convertToTspans, gd);
    }
    return Plots.previousPromises(gd);
  }
  function scootTitle(titleAndSubtitleEls) {
    var titleElIn = titleAndSubtitleEls.title;
    var titleGroup = d3.select(titleElIn.node().parentNode);
    if (avoid && avoid.selection && avoid.side && txt) {
      titleGroup.attr('transform', null);

      // move toward avoid.side (= left, right, top, bottom) if needed
      // can include pad (pixels, default 2)
      var backside = OPPOSITE_SIDE[avoid.side];
      var shiftSign = avoid.side === 'left' || avoid.side === 'top' ? -1 : 1;
      var pad = isNumeric(avoid.pad) ? avoid.pad : 2;
      var titlebb = Drawing.bBox(titleGroup.node());

      // Account for reservedMargins
      var reservedMargins = {
        t: 0,
        b: 0,
        l: 0,
        r: 0
      };
      var margins = gd._fullLayout._reservedMargin;
      for (var key in margins) {
        for (var side in margins[key]) {
          var val = margins[key][side];
          reservedMargins[side] = Math.max(reservedMargins[side], val);
        }
      }
      var paperbb = {
        left: reservedMargins.l,
        top: reservedMargins.t,
        right: fullLayout.width - reservedMargins.r,
        bottom: fullLayout.height - reservedMargins.b
      };
      var maxshift = avoid.maxShift || shiftSign * (paperbb[avoid.side] - titlebb[avoid.side]);
      var shift = 0;

      // Prevent the title going off the paper
      if (maxshift < 0) {
        shift = maxshift;
      } else {
        // so we don't have to offset each avoided element,
        // give the title the opposite offset
        var offsetLeft = avoid.offsetLeft || 0;
        var offsetTop = avoid.offsetTop || 0;
        titlebb.left -= offsetLeft;
        titlebb.right -= offsetLeft;
        titlebb.top -= offsetTop;
        titlebb.bottom -= offsetTop;

        // iterate over a set of elements (avoid.selection)
        // to avoid collisions with
        avoid.selection.each(function () {
          var avoidbb = Drawing.bBox(this);
          if (Lib.bBoxIntersect(titlebb, avoidbb, pad)) {
            shift = Math.max(shift, shiftSign * (avoidbb[avoid.side] - titlebb[backside]) + pad);
          }
        });
        shift = Math.min(maxshift, shift);
        // Keeping track of this for calculation of full axis size if needed
        cont._titleScoot = Math.abs(shift);
      }
      if (shift > 0 || maxshift < 0) {
        var shiftTemplate = {
          left: [-shift, 0],
          right: [shift, 0],
          top: [0, -shift],
          bottom: [0, shift]
        }[avoid.side];
        titleGroup.attr('transform', strTranslate(shiftTemplate[0], shiftTemplate[1]));
      }
    }
  }
  el.call(titleLayout, subtitleEl);
  function setPlaceholder(element, placeholderText) {
    element.text(placeholderText).on('mouseover.opacity', function () {
      d3.select(this).transition().duration(interactConstants.SHOW_PLACEHOLDER).style('opacity', 1);
    }).on('mouseout.opacity', function () {
      d3.select(this).transition().duration(interactConstants.HIDE_PLACEHOLDER).style('opacity', 0);
    });
  }
  if (editable) {
    if (!txt) {
      setPlaceholder(el, placeholder);
      titleIsPlaceholder = true;
    } else el.on('.opacity', null);
    el.call(svgTextUtils.makeEditable, {
      gd: gd
    }).on('edit', function (text) {
      if (traceIndex !== undefined) {
        Registry.call('_guiRestyle', gd, prop, text, traceIndex);
      } else {
        Registry.call('_guiRelayout', gd, prop, text);
      }
    }).on('cancel', function () {
      this.text(this.attr('data-unformatted')).call(titleLayout);
    }).on('input', function (d) {
      this.text(d || ' ').call(svgTextUtils.positionText, attributes.x, attributes.y);
    });
    if (subtitleEnabled) {
      // Adjust subtitle position now that title placeholder has been added
      // Only adjust if subtitle is enabled and title text was originally empty
      if (subtitleEnabled && !txt) {
        var titleElBbox = el.node().getBBox();
        var subtitleY = titleElBbox.y + titleElBbox.height + SUBTITLE_PADDING_EM * subFontSize;
        subtitleEl.attr('y', subtitleY);
      }
      if (!subtitleTxt) {
        setPlaceholder(subtitleEl, subtitlePlaceholder);
        subtitleIsPlaceholder = true;
      } else subtitleEl.on('.opacity', null);
      subtitleEl.call(svgTextUtils.makeEditable, {
        gd: gd
      }).on('edit', function (text) {
        Registry.call('_guiRelayout', gd, 'title.subtitle.text', text);
      }).on('cancel', function () {
        this.text(this.attr('data-unformatted')).call(titleLayout);
      }).on('input', function (d) {
        this.text(d || ' ').call(svgTextUtils.positionText, subtitleEl.attr('x'), subtitleEl.attr('y'));
      });
    }
  }
  el.classed('js-placeholder', titleIsPlaceholder);
  if (subtitleEl) subtitleEl.classed('js-placeholder', subtitleIsPlaceholder);
  return group;
}
module.exports = {
  draw: draw,
  SUBTITLE_PADDING_EM: SUBTITLE_PADDING_EM,
  SUBTITLE_PADDING_MATHJAX_EM: SUBTITLE_PADDING_MATHJAX_EM
};

/***/ }),

/***/ 85389:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var fontAttrs = __webpack_require__(80337);
var colorAttrs = __webpack_require__(10229);
var extendFlat = (__webpack_require__(93049).extendFlat);
var overrideAll = (__webpack_require__(13582).overrideAll);
var padAttrs = __webpack_require__(57891);
var templatedArray = (__webpack_require__(78032).templatedArray);
var buttonsAttrs = templatedArray('button', {
  visible: {
    valType: 'boolean'
  },
  method: {
    valType: 'enumerated',
    values: ['restyle', 'relayout', 'animate', 'update', 'skip'],
    dflt: 'restyle'
  },
  args: {
    valType: 'info_array',
    freeLength: true,
    items: [{
      valType: 'any'
    }, {
      valType: 'any'
    }, {
      valType: 'any'
    }]
  },
  args2: {
    valType: 'info_array',
    freeLength: true,
    items: [{
      valType: 'any'
    }, {
      valType: 'any'
    }, {
      valType: 'any'
    }]
  },
  label: {
    valType: 'string',
    dflt: ''
  },
  execute: {
    valType: 'boolean',
    dflt: true
  }
});
module.exports = overrideAll(templatedArray('updatemenu', {
  _arrayAttrRegexps: [/^updatemenus\[(0|[1-9][0-9]+)\]\.buttons/],
  visible: {
    valType: 'boolean'
  },
  type: {
    valType: 'enumerated',
    values: ['dropdown', 'buttons'],
    dflt: 'dropdown'
  },
  direction: {
    valType: 'enumerated',
    values: ['left', 'right', 'up', 'down'],
    dflt: 'down'
  },
  active: {
    valType: 'integer',
    min: -1,
    dflt: 0
  },
  showactive: {
    valType: 'boolean',
    dflt: true
  },
  buttons: buttonsAttrs,
  x: {
    valType: 'number',
    min: -2,
    max: 3,
    dflt: -0.05
  },
  xanchor: {
    valType: 'enumerated',
    values: ['auto', 'left', 'center', 'right'],
    dflt: 'right'
  },
  y: {
    valType: 'number',
    min: -2,
    max: 3,
    dflt: 1
  },
  yanchor: {
    valType: 'enumerated',
    values: ['auto', 'top', 'middle', 'bottom'],
    dflt: 'top'
  },
  pad: extendFlat(padAttrs({
    editType: 'arraydraw'
  }), {}),
  font: fontAttrs({}),
  bgcolor: {
    valType: 'color'
  },
  bordercolor: {
    valType: 'color',
    dflt: colorAttrs.borderLine
  },
  borderwidth: {
    valType: 'number',
    min: 0,
    dflt: 1,
    editType: 'arraydraw'
  }
}), 'arraydraw', 'from-root');

/***/ }),

/***/ 71559:
/***/ (function(module) {

"use strict";


module.exports = {
  // layout attribute name
  name: 'updatemenus',
  // class names
  containerClassName: 'updatemenu-container',
  headerGroupClassName: 'updatemenu-header-group',
  headerClassName: 'updatemenu-header',
  headerArrowClassName: 'updatemenu-header-arrow',
  dropdownButtonGroupClassName: 'updatemenu-dropdown-button-group',
  dropdownButtonClassName: 'updatemenu-dropdown-button',
  buttonClassName: 'updatemenu-button',
  itemRectClassName: 'updatemenu-item-rect',
  itemTextClassName: 'updatemenu-item-text',
  // DOM attribute name in button group keeping track
  // of active update menu
  menuIndexAttrName: 'updatemenu-active-index',
  // id root pass to Plots.autoMargin
  autoMarginIdRoot: 'updatemenu-',
  // options when 'active: -1'
  blankHeaderOpts: {
    label: '  '
  },
  // min item width / height
  minWidth: 30,
  minHeight: 30,
  // padding around item text
  textPadX: 24,
  arrowPadX: 16,
  // item rect radii
  rx: 2,
  ry: 2,
  // item  text x offset off left edge
  textOffsetX: 12,
  // item  text y offset (w.r.t. middle)
  textOffsetY: 3,
  // arrow offset off right edge
  arrowOffsetX: 4,
  // gap between header and buttons
  gapButtonHeader: 5,
  // gap between between buttons
  gapButton: 2,
  // color given to active buttons
  activeColor: '#F4FAFF',
  // color given to hovered buttons
  hoverColor: '#F4FAFF',
  // symbol for menu open arrow
  arrowSymbol: {
    left: '◄',
    right: '►',
    up: '▲',
    down: '▼'
  }
};

/***/ }),

/***/ 42746:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var handleArrayContainerDefaults = __webpack_require__(59008);
var attributes = __webpack_require__(85389);
var constants = __webpack_require__(71559);
var name = constants.name;
var buttonAttrs = attributes.buttons;
module.exports = function updateMenusDefaults(layoutIn, layoutOut) {
  var opts = {
    name: name,
    handleItemDefaults: menuDefaults
  };
  handleArrayContainerDefaults(layoutIn, layoutOut, opts);
};
function menuDefaults(menuIn, menuOut, layoutOut) {
  function coerce(attr, dflt) {
    return Lib.coerce(menuIn, menuOut, attributes, attr, dflt);
  }
  var buttons = handleArrayContainerDefaults(menuIn, menuOut, {
    name: 'buttons',
    handleItemDefaults: buttonDefaults
  });
  var visible = coerce('visible', buttons.length > 0);
  if (!visible) return;
  coerce('active');
  coerce('direction');
  coerce('type');
  coerce('showactive');
  coerce('x');
  coerce('y');
  Lib.noneOrAll(menuIn, menuOut, ['x', 'y']);
  coerce('xanchor');
  coerce('yanchor');
  coerce('pad.t');
  coerce('pad.r');
  coerce('pad.b');
  coerce('pad.l');
  Lib.coerceFont(coerce, 'font', layoutOut.font);
  coerce('bgcolor', layoutOut.paper_bgcolor);
  coerce('bordercolor');
  coerce('borderwidth');
}
function buttonDefaults(buttonIn, buttonOut) {
  function coerce(attr, dflt) {
    return Lib.coerce(buttonIn, buttonOut, buttonAttrs, attr, dflt);
  }
  var visible = coerce('visible', buttonIn.method === 'skip' || Array.isArray(buttonIn.args));
  if (visible) {
    coerce('method');
    coerce('args');
    coerce('args2');
    coerce('label');
    coerce('execute');
  }
}

/***/ }),

/***/ 40974:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var Plots = __webpack_require__(44122);
var Color = __webpack_require__(78766);
var Drawing = __webpack_require__(62203);
var Lib = __webpack_require__(34809);
var svgTextUtils = __webpack_require__(30635);
var arrayEditor = (__webpack_require__(78032).arrayEditor);
var LINE_SPACING = (__webpack_require__(4530).LINE_SPACING);
var constants = __webpack_require__(71559);
var ScrollBox = __webpack_require__(21736);
module.exports = function draw(gd) {
  var fullLayout = gd._fullLayout;
  var menuData = Lib.filterVisible(fullLayout[constants.name]);

  /* Update menu data is bound to the header-group.
   * The items in the header group are always present.
   *
   * Upon clicking on a header its corresponding button
   * data is bound to the button-group.
   *
   * We draw all headers in one group before all buttons
   * so that the buttons *always* appear above the headers.
   *
   * Note that only one set of buttons are visible at once.
   *
   * <g container />
   *
   *     <g header-group />
   *         <g item header />
   *         <text item header-arrow />
   *     <g header-group />
   *         <g item header />
   *         <text item header-arrow />
   *     ...
   *
   *     <g button-group />
   *         <g item button />
   *         <g item button />
   *         ...
   */

  function clearAutoMargin(menuOpts) {
    Plots.autoMargin(gd, autoMarginId(menuOpts));
  }

  // draw update menu container
  var menus = fullLayout._menulayer.selectAll('g.' + constants.containerClassName).data(menuData.length > 0 ? [0] : []);
  menus.enter().append('g').classed(constants.containerClassName, true).style('cursor', 'pointer');
  menus.exit().each(function () {
    // Most components don't need to explicitly remove autoMargin, because
    // marginPushers does this - but updatemenu updates don't go through
    // a full replot so we need to explicitly remove it.
    // This is for removing *all* updatemenus, removing individuals is
    // handled below, in headerGroups.exit
    d3.select(this).selectAll('g.' + constants.headerGroupClassName).each(clearAutoMargin);
  }).remove();

  // return early if no update menus are visible
  if (menuData.length === 0) return;

  // join header group
  var headerGroups = menus.selectAll('g.' + constants.headerGroupClassName).data(menuData, keyFunction);
  headerGroups.enter().append('g').classed(constants.headerGroupClassName, true);

  // draw dropdown button container
  var gButton = Lib.ensureSingle(menus, 'g', constants.dropdownButtonGroupClassName, function (s) {
    s.style('pointer-events', 'all');
  });

  // find dimensions before plotting anything (this mutates menuOpts)
  for (var i = 0; i < menuData.length; i++) {
    var menuOpts = menuData[i];
    findDimensions(gd, menuOpts);
  }

  // setup scrollbox
  var scrollBoxId = 'updatemenus' + fullLayout._uid;
  var scrollBox = new ScrollBox(gd, gButton, scrollBoxId);

  // remove exiting header, remove dropped buttons and reset margins
  if (headerGroups.enter().size()) {
    // make sure gButton is on top of all headers
    gButton.node().parentNode.appendChild(gButton.node());
    gButton.call(removeAllButtons);
  }
  headerGroups.exit().each(function (menuOpts) {
    gButton.call(removeAllButtons);
    clearAutoMargin(menuOpts);
  }).remove();

  // draw headers!
  headerGroups.each(function (menuOpts) {
    var gHeader = d3.select(this);
    var _gButton = menuOpts.type === 'dropdown' ? gButton : null;
    Plots.manageCommandObserver(gd, menuOpts, menuOpts.buttons, function (data) {
      setActive(gd, menuOpts, menuOpts.buttons[data.index], gHeader, _gButton, scrollBox, data.index, true);
    });
    if (menuOpts.type === 'dropdown') {
      drawHeader(gd, gHeader, gButton, scrollBox, menuOpts);

      // if this menu is active, update the dropdown container
      if (isActive(gButton, menuOpts)) {
        drawButtons(gd, gHeader, gButton, scrollBox, menuOpts);
      }
    } else {
      drawButtons(gd, gHeader, null, null, menuOpts);
    }
  });
};

// Note that '_index' is set at the default step,
// it corresponds to the menu index in the user layout update menu container.
// Because a menu can be set invisible,
// this is a more 'consistent' field than the index in the menuData.
function keyFunction(menuOpts) {
  return menuOpts._index;
}
function isFolded(gButton) {
  return +gButton.attr(constants.menuIndexAttrName) === -1;
}
function isActive(gButton, menuOpts) {
  return +gButton.attr(constants.menuIndexAttrName) === menuOpts._index;
}
function setActive(gd, menuOpts, buttonOpts, gHeader, gButton, scrollBox, buttonIndex, isSilentUpdate) {
  // update 'active' attribute in menuOpts
  menuOpts.active = buttonIndex;

  // due to templating, it's possible this slider doesn't even exist yet
  arrayEditor(gd.layout, constants.name, menuOpts).applyUpdate('active', buttonIndex);
  if (menuOpts.type === 'buttons') {
    drawButtons(gd, gHeader, null, null, menuOpts);
  } else if (menuOpts.type === 'dropdown') {
    // fold up buttons and redraw header
    gButton.attr(constants.menuIndexAttrName, '-1');
    drawHeader(gd, gHeader, gButton, scrollBox, menuOpts);
    if (!isSilentUpdate) {
      drawButtons(gd, gHeader, gButton, scrollBox, menuOpts);
    }
  }
}
function drawHeader(gd, gHeader, gButton, scrollBox, menuOpts) {
  var header = Lib.ensureSingle(gHeader, 'g', constants.headerClassName, function (s) {
    s.style('pointer-events', 'all');
  });
  var dims = menuOpts._dims;
  var active = menuOpts.active;
  var headerOpts = menuOpts.buttons[active] || constants.blankHeaderOpts;
  var posOpts = {
    y: menuOpts.pad.t,
    yPad: 0,
    x: menuOpts.pad.l,
    xPad: 0,
    index: 0
  };
  var positionOverrides = {
    width: dims.headerWidth,
    height: dims.headerHeight
  };
  header.call(drawItem, menuOpts, headerOpts, gd).call(setItemPosition, menuOpts, posOpts, positionOverrides);

  // draw drop arrow at the right edge
  var arrow = Lib.ensureSingle(gHeader, 'text', constants.headerArrowClassName, function (s) {
    s.attr('text-anchor', 'end').call(Drawing.font, menuOpts.font).text(constants.arrowSymbol[menuOpts.direction]);
  });
  arrow.attr({
    x: dims.headerWidth - constants.arrowOffsetX + menuOpts.pad.l,
    y: dims.headerHeight / 2 + constants.textOffsetY + menuOpts.pad.t
  });
  header.on('click', function () {
    gButton.call(removeAllButtons, String(isActive(gButton, menuOpts) ? -1 : menuOpts._index));
    drawButtons(gd, gHeader, gButton, scrollBox, menuOpts);
  });
  header.on('mouseover', function () {
    header.call(styleOnMouseOver);
  });
  header.on('mouseout', function () {
    header.call(styleOnMouseOut, menuOpts);
  });

  // translate header group
  Drawing.setTranslate(gHeader, dims.lx, dims.ly);
}
function drawButtons(gd, gHeader, gButton, scrollBox, menuOpts) {
  // If this is a set of buttons, set pointer events = all since we play
  // some minor games with which container is which in order to simplify
  // the drawing of *either* buttons or menus
  if (!gButton) {
    gButton = gHeader;
    gButton.attr('pointer-events', 'all');
  }
  var buttonData = !isFolded(gButton) || menuOpts.type === 'buttons' ? menuOpts.buttons : [];
  var klass = menuOpts.type === 'dropdown' ? constants.dropdownButtonClassName : constants.buttonClassName;
  var buttons = gButton.selectAll('g.' + klass).data(Lib.filterVisible(buttonData));
  var enter = buttons.enter().append('g').classed(klass, true);
  var exit = buttons.exit();
  if (menuOpts.type === 'dropdown') {
    enter.attr('opacity', '0').transition().attr('opacity', '1');
    exit.transition().attr('opacity', '0').remove();
  } else {
    exit.remove();
  }
  var x0 = 0;
  var y0 = 0;
  var dims = menuOpts._dims;
  var isVertical = ['up', 'down'].indexOf(menuOpts.direction) !== -1;
  if (menuOpts.type === 'dropdown') {
    if (isVertical) {
      y0 = dims.headerHeight + constants.gapButtonHeader;
    } else {
      x0 = dims.headerWidth + constants.gapButtonHeader;
    }
  }
  if (menuOpts.type === 'dropdown' && menuOpts.direction === 'up') {
    y0 = -constants.gapButtonHeader + constants.gapButton - dims.openHeight;
  }
  if (menuOpts.type === 'dropdown' && menuOpts.direction === 'left') {
    x0 = -constants.gapButtonHeader + constants.gapButton - dims.openWidth;
  }
  var posOpts = {
    x: dims.lx + x0 + menuOpts.pad.l,
    y: dims.ly + y0 + menuOpts.pad.t,
    yPad: constants.gapButton,
    xPad: constants.gapButton,
    index: 0
  };
  var scrollBoxPosition = {
    l: posOpts.x + menuOpts.borderwidth,
    t: posOpts.y + menuOpts.borderwidth
  };
  buttons.each(function (buttonOpts, buttonIndex) {
    var button = d3.select(this);
    button.call(drawItem, menuOpts, buttonOpts, gd).call(setItemPosition, menuOpts, posOpts);
    button.on('click', function () {
      // skip `dragend` events
      if (d3.event.defaultPrevented) return;
      if (buttonOpts.execute) {
        if (buttonOpts.args2 && menuOpts.active === buttonIndex) {
          setActive(gd, menuOpts, buttonOpts, gHeader, gButton, scrollBox, -1);
          Plots.executeAPICommand(gd, buttonOpts.method, buttonOpts.args2);
        } else {
          setActive(gd, menuOpts, buttonOpts, gHeader, gButton, scrollBox, buttonIndex);
          Plots.executeAPICommand(gd, buttonOpts.method, buttonOpts.args);
        }
      }
      gd.emit('plotly_buttonclicked', {
        menu: menuOpts,
        button: buttonOpts,
        active: menuOpts.active
      });
    });
    button.on('mouseover', function () {
      button.call(styleOnMouseOver);
    });
    button.on('mouseout', function () {
      button.call(styleOnMouseOut, menuOpts);
      buttons.call(styleButtons, menuOpts);
    });
  });
  buttons.call(styleButtons, menuOpts);
  if (isVertical) {
    scrollBoxPosition.w = Math.max(dims.openWidth, dims.headerWidth);
    scrollBoxPosition.h = posOpts.y - scrollBoxPosition.t;
  } else {
    scrollBoxPosition.w = posOpts.x - scrollBoxPosition.l;
    scrollBoxPosition.h = Math.max(dims.openHeight, dims.headerHeight);
  }
  scrollBoxPosition.direction = menuOpts.direction;
  if (scrollBox) {
    if (buttons.size()) {
      drawScrollBox(gd, gHeader, gButton, scrollBox, menuOpts, scrollBoxPosition);
    } else {
      hideScrollBox(scrollBox);
    }
  }
}
function drawScrollBox(gd, gHeader, gButton, scrollBox, menuOpts, position) {
  // enable the scrollbox
  var direction = menuOpts.direction;
  var isVertical = direction === 'up' || direction === 'down';
  var dims = menuOpts._dims;
  var active = menuOpts.active;
  var translateX, translateY;
  var i;
  if (isVertical) {
    translateY = 0;
    for (i = 0; i < active; i++) {
      translateY += dims.heights[i] + constants.gapButton;
    }
  } else {
    translateX = 0;
    for (i = 0; i < active; i++) {
      translateX += dims.widths[i] + constants.gapButton;
    }
  }
  scrollBox.enable(position, translateX, translateY);
  if (scrollBox.hbar) {
    scrollBox.hbar.attr('opacity', '0').transition().attr('opacity', '1');
  }
  if (scrollBox.vbar) {
    scrollBox.vbar.attr('opacity', '0').transition().attr('opacity', '1');
  }
}
function hideScrollBox(scrollBox) {
  var hasHBar = !!scrollBox.hbar;
  var hasVBar = !!scrollBox.vbar;
  if (hasHBar) {
    scrollBox.hbar.transition().attr('opacity', '0').each('end', function () {
      hasHBar = false;
      if (!hasVBar) scrollBox.disable();
    });
  }
  if (hasVBar) {
    scrollBox.vbar.transition().attr('opacity', '0').each('end', function () {
      hasVBar = false;
      if (!hasHBar) scrollBox.disable();
    });
  }
}
function drawItem(item, menuOpts, itemOpts, gd) {
  item.call(drawItemRect, menuOpts).call(drawItemText, menuOpts, itemOpts, gd);
}
function drawItemRect(item, menuOpts) {
  var rect = Lib.ensureSingle(item, 'rect', constants.itemRectClassName, function (s) {
    s.attr({
      rx: constants.rx,
      ry: constants.ry,
      'shape-rendering': 'crispEdges'
    });
  });
  rect.call(Color.stroke, menuOpts.bordercolor).call(Color.fill, menuOpts.bgcolor).style('stroke-width', menuOpts.borderwidth + 'px');
}
function drawItemText(item, menuOpts, itemOpts, gd) {
  var text = Lib.ensureSingle(item, 'text', constants.itemTextClassName, function (s) {
    s.attr({
      'text-anchor': 'start',
      'data-notex': 1
    });
  });
  var tx = itemOpts.label;
  var _meta = gd._fullLayout._meta;
  if (_meta) tx = Lib.templateString(tx, _meta);
  text.call(Drawing.font, menuOpts.font).text(tx).call(svgTextUtils.convertToTspans, gd);
}
function styleButtons(buttons, menuOpts) {
  var active = menuOpts.active;
  buttons.each(function (buttonOpts, i) {
    var button = d3.select(this);
    if (i === active && menuOpts.showactive) {
      button.select('rect.' + constants.itemRectClassName).call(Color.fill, constants.activeColor);
    }
  });
}
function styleOnMouseOver(item) {
  item.select('rect.' + constants.itemRectClassName).call(Color.fill, constants.hoverColor);
}
function styleOnMouseOut(item, menuOpts) {
  item.select('rect.' + constants.itemRectClassName).call(Color.fill, menuOpts.bgcolor);
}

// find item dimensions (this mutates menuOpts)
function findDimensions(gd, menuOpts) {
  var dims = menuOpts._dims = {
    width1: 0,
    height1: 0,
    heights: [],
    widths: [],
    totalWidth: 0,
    totalHeight: 0,
    openWidth: 0,
    openHeight: 0,
    lx: 0,
    ly: 0
  };
  var fakeButtons = Drawing.tester.selectAll('g.' + constants.dropdownButtonClassName).data(Lib.filterVisible(menuOpts.buttons));
  fakeButtons.enter().append('g').classed(constants.dropdownButtonClassName, true);
  var isVertical = ['up', 'down'].indexOf(menuOpts.direction) !== -1;

  // loop over fake buttons to find width / height
  fakeButtons.each(function (buttonOpts, i) {
    var button = d3.select(this);
    button.call(drawItem, menuOpts, buttonOpts, gd);
    var text = button.select('.' + constants.itemTextClassName);

    // width is given by max width of all buttons
    var tWidth = text.node() && Drawing.bBox(text.node()).width;
    var wEff = Math.max(tWidth + constants.textPadX, constants.minWidth);

    // height is determined by item text
    var tHeight = menuOpts.font.size * LINE_SPACING;
    var tLines = svgTextUtils.lineCount(text);
    var hEff = Math.max(tHeight * tLines, constants.minHeight) + constants.textOffsetY;
    hEff = Math.ceil(hEff);
    wEff = Math.ceil(wEff);

    // Store per-item sizes since a row of horizontal buttons, for example,
    // don't all need to be the same width:
    dims.widths[i] = wEff;
    dims.heights[i] = hEff;

    // Height and width of individual element:
    dims.height1 = Math.max(dims.height1, hEff);
    dims.width1 = Math.max(dims.width1, wEff);
    if (isVertical) {
      dims.totalWidth = Math.max(dims.totalWidth, wEff);
      dims.openWidth = dims.totalWidth;
      dims.totalHeight += hEff + constants.gapButton;
      dims.openHeight += hEff + constants.gapButton;
    } else {
      dims.totalWidth += wEff + constants.gapButton;
      dims.openWidth += wEff + constants.gapButton;
      dims.totalHeight = Math.max(dims.totalHeight, hEff);
      dims.openHeight = dims.totalHeight;
    }
  });
  if (isVertical) {
    dims.totalHeight -= constants.gapButton;
  } else {
    dims.totalWidth -= constants.gapButton;
  }
  dims.headerWidth = dims.width1 + constants.arrowPadX;
  dims.headerHeight = dims.height1;
  if (menuOpts.type === 'dropdown') {
    if (isVertical) {
      dims.width1 += constants.arrowPadX;
      dims.totalHeight = dims.height1;
    } else {
      dims.totalWidth = dims.width1;
    }
    dims.totalWidth += constants.arrowPadX;
  }
  fakeButtons.remove();
  var paddedWidth = dims.totalWidth + menuOpts.pad.l + menuOpts.pad.r;
  var paddedHeight = dims.totalHeight + menuOpts.pad.t + menuOpts.pad.b;
  var graphSize = gd._fullLayout._size;
  dims.lx = graphSize.l + graphSize.w * menuOpts.x;
  dims.ly = graphSize.t + graphSize.h * (1 - menuOpts.y);
  var xanchor = 'left';
  if (Lib.isRightAnchor(menuOpts)) {
    dims.lx -= paddedWidth;
    xanchor = 'right';
  }
  if (Lib.isCenterAnchor(menuOpts)) {
    dims.lx -= paddedWidth / 2;
    xanchor = 'center';
  }
  var yanchor = 'top';
  if (Lib.isBottomAnchor(menuOpts)) {
    dims.ly -= paddedHeight;
    yanchor = 'bottom';
  }
  if (Lib.isMiddleAnchor(menuOpts)) {
    dims.ly -= paddedHeight / 2;
    yanchor = 'middle';
  }
  dims.totalWidth = Math.ceil(dims.totalWidth);
  dims.totalHeight = Math.ceil(dims.totalHeight);
  dims.lx = Math.round(dims.lx);
  dims.ly = Math.round(dims.ly);
  Plots.autoMargin(gd, autoMarginId(menuOpts), {
    x: menuOpts.x,
    y: menuOpts.y,
    l: paddedWidth * ({
      right: 1,
      center: 0.5
    }[xanchor] || 0),
    r: paddedWidth * ({
      left: 1,
      center: 0.5
    }[xanchor] || 0),
    b: paddedHeight * ({
      top: 1,
      middle: 0.5
    }[yanchor] || 0),
    t: paddedHeight * ({
      bottom: 1,
      middle: 0.5
    }[yanchor] || 0)
  });
}
function autoMarginId(menuOpts) {
  return constants.autoMarginIdRoot + menuOpts._index;
}

// set item positions (mutates posOpts)
function setItemPosition(item, menuOpts, posOpts, overrideOpts) {
  overrideOpts = overrideOpts || {};
  var rect = item.select('.' + constants.itemRectClassName);
  var text = item.select('.' + constants.itemTextClassName);
  var borderWidth = menuOpts.borderwidth;
  var index = posOpts.index;
  var dims = menuOpts._dims;
  Drawing.setTranslate(item, borderWidth + posOpts.x, borderWidth + posOpts.y);
  var isVertical = ['up', 'down'].indexOf(menuOpts.direction) !== -1;
  var finalHeight = overrideOpts.height || (isVertical ? dims.heights[index] : dims.height1);
  rect.attr({
    x: 0,
    y: 0,
    width: overrideOpts.width || (isVertical ? dims.width1 : dims.widths[index]),
    height: finalHeight
  });
  var tHeight = menuOpts.font.size * LINE_SPACING;
  var tLines = svgTextUtils.lineCount(text);
  var spanOffset = (tLines - 1) * tHeight / 2;
  svgTextUtils.positionText(text, constants.textOffsetX, finalHeight / 2 - spanOffset + constants.textOffsetY);
  if (isVertical) {
    posOpts.y += dims.heights[index] + posOpts.yPad;
  } else {
    posOpts.x += dims.widths[index] + posOpts.xPad;
  }
  posOpts.index++;
}
function removeAllButtons(gButton, newMenuIndexAttr) {
  gButton.attr(constants.menuIndexAttrName, newMenuIndexAttr || '-1').selectAll('g.' + constants.dropdownButtonClassName).remove();
}

/***/ }),

/***/ 46230:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var constants = __webpack_require__(71559);
module.exports = {
  moduleType: 'component',
  name: constants.name,
  layoutAttributes: __webpack_require__(85389),
  supplyLayoutDefaults: __webpack_require__(42746),
  draw: __webpack_require__(40974)
};

/***/ }),

/***/ 21736:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = ScrollBox;
var d3 = __webpack_require__(45568);
var Color = __webpack_require__(78766);
var Drawing = __webpack_require__(62203);
var Lib = __webpack_require__(34809);

/**
 * Helper class to setup a scroll box
 *
 * @class
 * @param           gd          Plotly's graph div
 * @param           container   Container to be scroll-boxed (as a D3 selection)
 * @param {string}  id          Id for the clip path to implement the scroll box
 */
function ScrollBox(gd, container, id) {
  this.gd = gd;
  this.container = container;
  this.id = id;

  // See ScrollBox.prototype.enable for further definition
  this.position = null; // scrollbox position
  this.translateX = null; // scrollbox horizontal translation
  this.translateY = null; // scrollbox vertical translation
  this.hbar = null; // horizontal scrollbar D3 selection
  this.vbar = null; // vertical scrollbar D3 selection

  // <rect> element to capture pointer events
  this.bg = this.container.selectAll('rect.scrollbox-bg').data([0]);
  this.bg.exit().on('.drag', null).on('wheel', null).remove();
  this.bg.enter().append('rect').classed('scrollbox-bg', true).style('pointer-events', 'all').attr({
    opacity: 0,
    x: 0,
    y: 0,
    width: 0,
    height: 0
  });
}

// scroll bar dimensions
ScrollBox.barWidth = 2;
ScrollBox.barLength = 20;
ScrollBox.barRadius = 2;
ScrollBox.barPad = 1;
ScrollBox.barColor = '#808BA4';

/**
 * If needed, setup a clip path and scrollbars
 *
 * @method
 * @param {Object}  position
 * @param {number}  position.l  Left side position (in pixels)
 * @param {number}  position.t  Top side (in pixels)
 * @param {number}  position.w  Width (in pixels)
 * @param {number}  position.h  Height (in pixels)
 * @param {string}  [position.direction='down']
 *                  Either 'down', 'left', 'right' or 'up'
 * @param {number}  [translateX=0]  Horizontal offset (in pixels)
 * @param {number}  [translateY=0]  Vertical offset (in pixels)
 */
ScrollBox.prototype.enable = function enable(position, translateX, translateY) {
  var fullLayout = this.gd._fullLayout;
  var fullWidth = fullLayout.width;
  var fullHeight = fullLayout.height;

  // compute position of scrollbox
  this.position = position;
  var l = this.position.l;
  var w = this.position.w;
  var t = this.position.t;
  var h = this.position.h;
  var direction = this.position.direction;
  var isDown = direction === 'down';
  var isLeft = direction === 'left';
  var isRight = direction === 'right';
  var isUp = direction === 'up';
  var boxW = w;
  var boxH = h;
  var boxL, boxR;
  var boxT, boxB;
  if (!isDown && !isLeft && !isRight && !isUp) {
    this.position.direction = 'down';
    isDown = true;
  }
  var isVertical = isDown || isUp;
  if (isVertical) {
    boxL = l;
    boxR = boxL + boxW;
    if (isDown) {
      // anchor to top side
      boxT = t;
      boxB = Math.min(boxT + boxH, fullHeight);
      boxH = boxB - boxT;
    } else {
      // anchor to bottom side
      boxB = t + boxH;
      boxT = Math.max(boxB - boxH, 0);
      boxH = boxB - boxT;
    }
  } else {
    boxT = t;
    boxB = boxT + boxH;
    if (isLeft) {
      // anchor to right side
      boxR = l + boxW;
      boxL = Math.max(boxR - boxW, 0);
      boxW = boxR - boxL;
    } else {
      // anchor to left side
      boxL = l;
      boxR = Math.min(boxL + boxW, fullWidth);
      boxW = boxR - boxL;
    }
  }
  this._box = {
    l: boxL,
    t: boxT,
    w: boxW,
    h: boxH
  };

  // compute position of horizontal scroll bar
  var needsHorizontalScrollBar = w > boxW;
  var hbarW = ScrollBox.barLength + 2 * ScrollBox.barPad;
  var hbarH = ScrollBox.barWidth + 2 * ScrollBox.barPad;
  // draw horizontal scrollbar on the bottom side
  var hbarL = l;
  var hbarT = t + h;
  if (hbarT + hbarH > fullHeight) hbarT = fullHeight - hbarH;
  var hbar = this.container.selectAll('rect.scrollbar-horizontal').data(needsHorizontalScrollBar ? [0] : []);
  hbar.exit().on('.drag', null).remove();
  hbar.enter().append('rect').classed('scrollbar-horizontal', true).call(Color.fill, ScrollBox.barColor);
  if (needsHorizontalScrollBar) {
    this.hbar = hbar.attr({
      rx: ScrollBox.barRadius,
      ry: ScrollBox.barRadius,
      x: hbarL,
      y: hbarT,
      width: hbarW,
      height: hbarH
    });

    // hbar center moves between hbarXMin and hbarXMin + hbarTranslateMax
    this._hbarXMin = hbarL + hbarW / 2;
    this._hbarTranslateMax = boxW - hbarW;
  } else {
    delete this.hbar;
    delete this._hbarXMin;
    delete this._hbarTranslateMax;
  }

  // compute position of vertical scroll bar
  var needsVerticalScrollBar = h > boxH;
  var vbarW = ScrollBox.barWidth + 2 * ScrollBox.barPad;
  var vbarH = ScrollBox.barLength + 2 * ScrollBox.barPad;
  // draw vertical scrollbar on the right side
  var vbarL = l + w;
  var vbarT = t;
  if (vbarL + vbarW > fullWidth) vbarL = fullWidth - vbarW;
  var vbar = this.container.selectAll('rect.scrollbar-vertical').data(needsVerticalScrollBar ? [0] : []);
  vbar.exit().on('.drag', null).remove();
  vbar.enter().append('rect').classed('scrollbar-vertical', true).call(Color.fill, ScrollBox.barColor);
  if (needsVerticalScrollBar) {
    this.vbar = vbar.attr({
      rx: ScrollBox.barRadius,
      ry: ScrollBox.barRadius,
      x: vbarL,
      y: vbarT,
      width: vbarW,
      height: vbarH
    });

    // vbar center moves between vbarYMin and vbarYMin + vbarTranslateMax
    this._vbarYMin = vbarT + vbarH / 2;
    this._vbarTranslateMax = boxH - vbarH;
  } else {
    delete this.vbar;
    delete this._vbarYMin;
    delete this._vbarTranslateMax;
  }

  // setup a clip path (if scroll bars are needed)
  var clipId = this.id;
  var clipL = boxL - 0.5;
  var clipR = needsVerticalScrollBar ? boxR + vbarW + 0.5 : boxR + 0.5;
  var clipT = boxT - 0.5;
  var clipB = needsHorizontalScrollBar ? boxB + hbarH + 0.5 : boxB + 0.5;
  var clipPath = fullLayout._topdefs.selectAll('#' + clipId).data(needsHorizontalScrollBar || needsVerticalScrollBar ? [0] : []);
  clipPath.exit().remove();
  clipPath.enter().append('clipPath').attr('id', clipId).append('rect');
  if (needsHorizontalScrollBar || needsVerticalScrollBar) {
    this._clipRect = clipPath.select('rect').attr({
      x: Math.floor(clipL),
      y: Math.floor(clipT),
      width: Math.ceil(clipR) - Math.floor(clipL),
      height: Math.ceil(clipB) - Math.floor(clipT)
    });
    this.container.call(Drawing.setClipUrl, clipId, this.gd);
    this.bg.attr({
      x: l,
      y: t,
      width: w,
      height: h
    });
  } else {
    this.bg.attr({
      width: 0,
      height: 0
    });
    this.container.on('wheel', null).on('.drag', null).call(Drawing.setClipUrl, null);
    delete this._clipRect;
  }

  // set up drag listeners (if scroll bars are needed)
  if (needsHorizontalScrollBar || needsVerticalScrollBar) {
    var onBoxDrag = d3.behavior.drag().on('dragstart', function () {
      d3.event.sourceEvent.preventDefault();
    }).on('drag', this._onBoxDrag.bind(this));
    this.container.on('wheel', null).on('wheel', this._onBoxWheel.bind(this)).on('.drag', null).call(onBoxDrag);
    var onBarDrag = d3.behavior.drag().on('dragstart', function () {
      d3.event.sourceEvent.preventDefault();
      d3.event.sourceEvent.stopPropagation();
    }).on('drag', this._onBarDrag.bind(this));
    if (needsHorizontalScrollBar) {
      this.hbar.on('.drag', null).call(onBarDrag);
    }
    if (needsVerticalScrollBar) {
      this.vbar.on('.drag', null).call(onBarDrag);
    }
  }

  // set scrollbox translation
  this.setTranslate(translateX, translateY);
};

/**
 * If present, remove clip-path and scrollbars
 *
 * @method
 */
ScrollBox.prototype.disable = function disable() {
  if (this.hbar || this.vbar) {
    this.bg.attr({
      width: 0,
      height: 0
    });
    this.container.on('wheel', null).on('.drag', null).call(Drawing.setClipUrl, null);
    delete this._clipRect;
  }
  if (this.hbar) {
    this.hbar.on('.drag', null);
    this.hbar.remove();
    delete this.hbar;
    delete this._hbarXMin;
    delete this._hbarTranslateMax;
  }
  if (this.vbar) {
    this.vbar.on('.drag', null);
    this.vbar.remove();
    delete this.vbar;
    delete this._vbarYMin;
    delete this._vbarTranslateMax;
  }
};

/**
 * Handles scroll box drag events
 *
 * @method
 */
ScrollBox.prototype._onBoxDrag = function _onBoxDrag() {
  var translateX = this.translateX;
  var translateY = this.translateY;
  if (this.hbar) {
    translateX -= d3.event.dx;
  }
  if (this.vbar) {
    translateY -= d3.event.dy;
  }
  this.setTranslate(translateX, translateY);
};

/**
 * Handles scroll box wheel events
 *
 * @method
 */
ScrollBox.prototype._onBoxWheel = function _onBoxWheel() {
  var translateX = this.translateX;
  var translateY = this.translateY;
  if (this.hbar) {
    translateX += d3.event.deltaY;
  }
  if (this.vbar) {
    translateY += d3.event.deltaY;
  }
  this.setTranslate(translateX, translateY);
};

/**
 * Handles scroll bar drag events
 *
 * @method
 */
ScrollBox.prototype._onBarDrag = function _onBarDrag() {
  var translateX = this.translateX;
  var translateY = this.translateY;
  if (this.hbar) {
    var xMin = translateX + this._hbarXMin;
    var xMax = xMin + this._hbarTranslateMax;
    var x = Lib.constrain(d3.event.x, xMin, xMax);
    var xf = (x - xMin) / (xMax - xMin);
    var translateXMax = this.position.w - this._box.w;
    translateX = xf * translateXMax;
  }
  if (this.vbar) {
    var yMin = translateY + this._vbarYMin;
    var yMax = yMin + this._vbarTranslateMax;
    var y = Lib.constrain(d3.event.y, yMin, yMax);
    var yf = (y - yMin) / (yMax - yMin);
    var translateYMax = this.position.h - this._box.h;
    translateY = yf * translateYMax;
  }
  this.setTranslate(translateX, translateY);
};

/**
 * Set clip path and scroll bar translate transform
 *
 * @method
 * @param {number}  [translateX=0]  Horizontal offset (in pixels)
 * @param {number}  [translateY=0]  Vertical offset (in pixels)
 */
ScrollBox.prototype.setTranslate = function setTranslate(translateX, translateY) {
  // store translateX and translateY (needed by mouse event handlers)
  var translateXMax = this.position.w - this._box.w;
  var translateYMax = this.position.h - this._box.h;
  translateX = Lib.constrain(translateX || 0, 0, translateXMax);
  translateY = Lib.constrain(translateY || 0, 0, translateYMax);
  this.translateX = translateX;
  this.translateY = translateY;
  this.container.call(Drawing.setTranslate, this._box.l - this.position.l - translateX, this._box.t - this.position.t - translateY);
  if (this._clipRect) {
    this._clipRect.attr({
      x: Math.floor(this.position.l + translateX - 0.5),
      y: Math.floor(this.position.t + translateY - 0.5)
    });
  }
  if (this.hbar) {
    var xf = translateX / translateXMax;
    this.hbar.call(Drawing.setTranslate, translateX + xf * this._hbarTranslateMax, translateY);
  }
  if (this.vbar) {
    var yf = translateY / translateYMax;
    this.vbar.call(Drawing.setTranslate, translateX, translateY + yf * this._vbarTranslateMax);
  }
};

/***/ }),

/***/ 4530:
/***/ (function(module) {

"use strict";


// fraction of some size to get to a named position
module.exports = {
  // from bottom left: this is the origin of our paper-reference
  // positioning system
  FROM_BL: {
    left: 0,
    center: 0.5,
    right: 1,
    bottom: 0,
    middle: 0.5,
    top: 1
  },
  // from top left: this is the screen pixel positioning origin
  FROM_TL: {
    left: 0,
    center: 0.5,
    right: 1,
    bottom: 1,
    middle: 0.5,
    top: 0
  },
  // from bottom right: sometimes you just need the opposite of ^^
  FROM_BR: {
    left: 1,
    center: 0.5,
    right: 0,
    bottom: 0,
    middle: 0.5,
    top: 1
  },
  // multiple of fontSize to get the vertical offset between lines
  LINE_SPACING: 1.3,
  // multiple of fontSize to shift from the baseline
  // to the cap (captical letter) line
  // (to use when we don't calculate this shift from Drawing.bBox)
  // This is an approximation since in reality cap height can differ
  // from font to font. However, according to Wikipedia
  //   an "average" font might have a cap height of 70% of the em
  // https://en.wikipedia.org/wiki/Em_(typography)#History
  CAP_SHIFT: 0.70,
  // half the cap height (distance between baseline and cap line)
  // of an "average" font (for more info see above).
  MID_SHIFT: 0.35,
  OPPOSITE_SIDE: {
    left: 'right',
    right: 'left',
    top: 'bottom',
    bottom: 'top'
  }
};

/***/ }),

/***/ 35081:
/***/ (function(module) {

"use strict";


module.exports = {
  axisRefDescription: function (axisname, lower, upper) {
    return ['If set to a', axisname, 'axis id (e.g. *' + axisname + '* or', '*' + axisname + '2*), the `' + axisname + '` position refers to a', axisname, 'coordinate. If set to *paper*, the `' + axisname + '`', 'position refers to the distance from the', lower, 'of the plotting', 'area in normalized coordinates where *0* (*1*) corresponds to the', lower, '(' + upper + '). If set to a', axisname, 'axis ID followed by', '*domain* (separated by a space), the position behaves like for', '*paper*, but refers to the distance in fractions of the domain', 'length from the', lower, 'of the domain of that axis: e.g.,', '*' + axisname + '2 domain* refers to the domain of the second', axisname, ' axis and a', axisname, 'position of 0.5 refers to the', 'point between the', lower, 'and the', upper, 'of the domain of the', 'second', axisname, 'axis.'].join(' ');
  }
};

/***/ }),

/***/ 20909:
/***/ (function(module) {

"use strict";


module.exports = {
  INCREASING: {
    COLOR: '#3D9970',
    SYMBOL: '▲'
  },
  DECREASING: {
    COLOR: '#FF4136',
    SYMBOL: '▼'
  }
};

/***/ }),

/***/ 87296:
/***/ (function(module) {

"use strict";


module.exports = {
  FORMAT_LINK: 'https://github.com/d3/d3-format/tree/v1.4.5#d3-format',
  DATE_FORMAT_LINK: 'https://github.com/d3/d3-time-format/tree/v2.2.3#locale_format'
};

/***/ }),

/***/ 20726:
/***/ (function(module) {

"use strict";


module.exports = {
  COMPARISON_OPS: ['=', '!=', '<', '>=', '>', '<='],
  COMPARISON_OPS2: ['=', '<', '>=', '>', '<='],
  INTERVAL_OPS: ['[]', '()', '[)', '(]', '][', ')(', '](', ')['],
  SET_OPS: ['{}', '}{'],
  CONSTRAINT_REDUCTION: {
    // for contour constraints, open/closed endpoints are equivalent
    '=': '=',
    '<': '<',
    '<=': '<',
    '>': '>',
    '>=': '>',
    '[]': '[]',
    '()': '[]',
    '[)': '[]',
    '(]': '[]',
    '][': '][',
    ')(': '][',
    '](': '][',
    ')[': ']['
  }
};

/***/ }),

/***/ 84770:
/***/ (function(module) {

"use strict";


module.exports = {
  solid: [[], 0],
  dot: [[0.5, 1], 200],
  dash: [[0.5, 1], 50],
  longdash: [[0.5, 1], 10],
  dashdot: [[0.5, 0.625, 0.875, 1], 50],
  longdashdot: [[0.5, 0.7, 0.8, 1], 10]
};

/***/ }),

/***/ 49467:
/***/ (function(module) {

"use strict";


module.exports = {
  circle: '●',
  'circle-open': '○',
  square: '■',
  'square-open': '□',
  diamond: '◆',
  'diamond-open': '◇',
  cross: '+',
  x: '❌'
};

/***/ }),

/***/ 20438:
/***/ (function(module) {

"use strict";


module.exports = {
  /**
   * Timing information for interactive elements
   */
  SHOW_PLACEHOLDER: 100,
  HIDE_PLACEHOLDER: 1000,
  // opacity dimming fraction for points that are not in selection
  DESELECTDIM: 0.2
};

/***/ }),

/***/ 63821:
/***/ (function(module) {

"use strict";


module.exports = {
  /**
   * Standardize all missing data in calcdata to use undefined
   * never null or NaN.
   * That way we can use !==undefined, or !== BADNUM,
   * to test for real data
   */
  BADNUM: undefined,
  /*
   * Limit certain operations to well below floating point max value
   * to avoid glitches: Make sure that even when you multiply it by the
   * number of pixels on a giant screen it still works
   */
  FP_SAFE: Number.MAX_VALUE * 1e-4,
  /*
   * conversion of date units to milliseconds
   * year and month constants are marked "AVG"
   * to remind us that not all years and months
   * have the same length
   */
  ONEMAXYEAR: 31622400000,
  // 366 * ONEDAY
  ONEAVGYEAR: 31557600000,
  // 365.25 days
  ONEMINYEAR: 31536000000,
  // 365 * ONEDAY
  ONEMAXQUARTER: 7948800000,
  // 92 * ONEDAY
  ONEAVGQUARTER: 7889400000,
  // 1/4 of ONEAVGYEAR
  ONEMINQUARTER: 7689600000,
  // 89 * ONEDAY
  ONEMAXMONTH: 2678400000,
  // 31 * ONEDAY
  ONEAVGMONTH: 2629800000,
  // 1/12 of ONEAVGYEAR
  ONEMINMONTH: 2419200000,
  // 28 * ONEDAY
  ONEWEEK: 604800000,
  // 7 * ONEDAY
  ONEDAY: 86400000,
  // 24 * ONEHOUR
  ONEHOUR: 3600000,
  ONEMIN: 60000,
  ONESEC: 1000,
  ONEMILLI: 1,
  ONEMICROSEC: 0.001,
  /*
   * For fast conversion btwn world calendars and epoch ms, the Julian Day Number
   * of the unix epoch. From calendars.instance().newDate(1970, 1, 1).toJD()
   */
  EPOCHJD: 2440587.5,
  /*
   * Are two values nearly equal? Compare to 1PPM
   */
  ALMOST_EQUAL: 1 - 1e-6,
  /*
   * If we're asked to clip a non-positive log value, how far off-screen
   * do we put it?
   */
  LOG_CLIP: 10,
  /*
   * not a number, but for displaying numbers: the "minus sign" symbol is
   * wider than the regular ascii dash "-"
   */
  MINUS_SIGN: '\u2212'
};

/***/ }),

/***/ 1837:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


// Pixelated image rendering
// The actual CSS declaration is prepended with fallbacks for older browsers.
// NB. IE's `-ms-interpolation-mode` works only with <img> not with SVG <image>
// https://developer.mozilla.org/en-US/docs/Web/CSS/image-rendering
// https://caniuse.com/?search=image-rendering
// http://phrogz.net/tmp/canvas_image_zoom.html
exports.CSS_DECLARATIONS = [['image-rendering', 'optimizeSpeed'], ['image-rendering', '-moz-crisp-edges'], ['image-rendering', '-o-crisp-edges'], ['image-rendering', '-webkit-optimize-contrast'], ['image-rendering', 'optimize-contrast'], ['image-rendering', 'crisp-edges'], ['image-rendering', 'pixelated']];
exports.STYLE = exports.CSS_DECLARATIONS.map(function (d) {
  return d.join(': ') + '; ';
}).join('');

/***/ }),

/***/ 62972:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


exports.xmlns = 'http://www.w3.org/2000/xmlns/';
exports.svg = 'http://www.w3.org/2000/svg';
exports.xlink = 'http://www.w3.org/1999/xlink';

// the 'old' d3 quirk got fix in v3.5.7
// https://github.com/mbostock/d3/commit/a6f66e9dd37f764403fc7c1f26be09ab4af24fed
exports.svgAttrs = {
  xmlns: exports.svg,
  'xmlns:xlink': exports.xlink
};

/***/ }),

/***/ 17430:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


exports.version = __webpack_require__(29697).version;

// inject promise polyfill
__webpack_require__(71116);

// inject plot css
__webpack_require__(6713);

// include registry module and expose register method
var Registry = __webpack_require__(33626);
var register = exports.register = Registry.register;

// expose plot api methods
var plotApi = __webpack_require__(90742);
var methodNames = Object.keys(plotApi);
for (var i = 0; i < methodNames.length; i++) {
  var name = methodNames[i];
  // _ -> private API methods, but still registered for internal use
  if (name.charAt(0) !== '_') exports[name] = plotApi[name];
  register({
    moduleType: 'apiMethod',
    name: name,
    fn: plotApi[name]
  });
}

// scatter is the only trace included by default
register(__webpack_require__(69693));

// register all registrable components modules
register([__webpack_require__(3599), __webpack_require__(83348), __webpack_require__(44844), __webpack_require__(43701), __webpack_require__(15553), __webpack_require__(46230), __webpack_require__(15359), __webpack_require__(55429), __webpack_require__(44453), __webpack_require__(83595), __webpack_require__(77901), __webpack_require__(88856), __webpack_require__(96919), __webpack_require__(82494),
// legend needs to come after shape | legend defaults depends on shapes
__webpack_require__(32141),
// fx needs to come after legend | unified hover defaults depends on legends
__webpack_require__(95433)]);

// locales en and en-US are required for default behavior
register([__webpack_require__(30227), __webpack_require__(44611)]);

// locales that are present in the window should be loaded
if (window.PlotlyLocales && Array.isArray(window.PlotlyLocales)) {
  register(window.PlotlyLocales);
  delete window.PlotlyLocales;
}

// plot icons
exports.Icons = __webpack_require__(35188);

// unofficial 'beta' plot methods, use at your own risk
var Fx = __webpack_require__(32141);
var Plots = __webpack_require__(44122);
exports.Plots = {
  resize: Plots.resize,
  graphJson: Plots.graphJson,
  sendDataToCloud: Plots.sendDataToCloud
};
exports.Fx = {
  hover: Fx.hover,
  unhover: Fx.unhover,
  loneHover: Fx.loneHover,
  loneUnhover: Fx.loneUnhover
};
exports.Snapshot = __webpack_require__(6170);
exports.PlotSchema = __webpack_require__(57297);

/***/ }),

/***/ 35188:
/***/ (function(module) {

"use strict";


module.exports = {
  undo: {
    width: 857.1,
    height: 1000,
    path: 'm857 350q0-87-34-166t-91-137-137-92-166-34q-96 0-183 41t-147 114q-4 6-4 13t5 11l76 77q6 5 14 5 9-1 13-7 41-53 100-82t126-29q58 0 110 23t92 61 61 91 22 111-22 111-61 91-92 61-110 23q-55 0-105-20t-90-57l77-77q17-16 8-38-10-23-33-23h-250q-15 0-25 11t-11 25v250q0 24 22 33 22 10 39-8l72-72q60 57 137 88t159 31q87 0 166-34t137-92 91-137 34-166z',
    transform: 'matrix(1 0 0 -1 0 850)'
  },
  home: {
    width: 928.6,
    height: 1000,
    path: 'm786 296v-267q0-15-11-26t-25-10h-214v214h-143v-214h-214q-15 0-25 10t-11 26v267q0 1 0 2t0 2l321 264 321-264q1-1 1-4z m124 39l-34-41q-5-5-12-6h-2q-7 0-12 3l-386 322-386-322q-7-4-13-4-7 2-12 7l-35 41q-4 5-3 13t6 12l401 334q18 15 42 15t43-15l136-114v109q0 8 5 13t13 5h107q8 0 13-5t5-13v-227l122-102q5-5 6-12t-4-13z',
    transform: 'matrix(1 0 0 -1 0 850)'
  },
  'camera-retro': {
    width: 1000,
    height: 1000,
    path: 'm518 386q0 8-5 13t-13 5q-37 0-63-27t-26-63q0-8 5-13t13-5 12 5 5 13q0 23 16 38t38 16q8 0 13 5t5 13z m125-73q0-59-42-101t-101-42-101 42-42 101 42 101 101 42 101-42 42-101z m-572-320h858v71h-858v-71z m643 320q0 89-62 152t-152 62-151-62-63-152 63-151 151-63 152 63 62 151z m-571 358h214v72h-214v-72z m-72-107h858v143h-462l-36-71h-360v-72z m929 143v-714q0-30-21-51t-50-21h-858q-29 0-50 21t-21 51v714q0 30 21 51t50 21h858q29 0 50-21t21-51z',
    transform: 'matrix(1 0 0 -1 0 850)'
  },
  zoombox: {
    width: 1000,
    height: 1000,
    path: 'm1000-25l-250 251c40 63 63 138 63 218 0 224-182 406-407 406-224 0-406-182-406-406s183-406 407-406c80 0 155 22 218 62l250-250 125 125z m-812 250l0 438 437 0 0-438-437 0z m62 375l313 0 0-312-313 0 0 312z',
    transform: 'matrix(1 0 0 -1 0 850)'
  },
  pan: {
    width: 1000,
    height: 1000,
    path: 'm1000 350l-187 188 0-125-250 0 0 250 125 0-188 187-187-187 125 0 0-250-250 0 0 125-188-188 186-187 0 125 252 0 0-250-125 0 187-188 188 188-125 0 0 250 250 0 0-126 187 188z',
    transform: 'matrix(1 0 0 -1 0 850)'
  },
  zoom_plus: {
    width: 875,
    height: 1000,
    path: 'm1 787l0-875 875 0 0 875-875 0z m687-500l-187 0 0-187-125 0 0 187-188 0 0 125 188 0 0 187 125 0 0-187 187 0 0-125z',
    transform: 'matrix(1 0 0 -1 0 850)'
  },
  zoom_minus: {
    width: 875,
    height: 1000,
    path: 'm0 788l0-876 875 0 0 876-875 0z m688-500l-500 0 0 125 500 0 0-125z',
    transform: 'matrix(1 0 0 -1 0 850)'
  },
  autoscale: {
    width: 1000,
    height: 1000,
    path: 'm250 850l-187 0-63 0 0-62 0-188 63 0 0 188 187 0 0 62z m688 0l-188 0 0-62 188 0 0-188 62 0 0 188 0 62-62 0z m-875-938l0 188-63 0 0-188 0-62 63 0 187 0 0 62-187 0z m875 188l0-188-188 0 0-62 188 0 62 0 0 62 0 188-62 0z m-125 188l-1 0-93-94-156 156 156 156 92-93 2 0 0 250-250 0 0-2 93-92-156-156-156 156 94 92 0 2-250 0 0-250 0 0 93 93 157-156-157-156-93 94 0 0 0-250 250 0 0 0-94 93 156 157 156-157-93-93 0 0 250 0 0 250z',
    transform: 'matrix(1 0 0 -1 0 850)'
  },
  tooltip_basic: {
    width: 1500,
    height: 1000,
    path: 'm375 725l0 0-375-375 375-374 0-1 1125 0 0 750-1125 0z',
    transform: 'matrix(1 0 0 -1 0 850)'
  },
  tooltip_compare: {
    width: 1125,
    height: 1000,
    path: 'm187 786l0 2-187-188 188-187 0 0 937 0 0 373-938 0z m0-499l0 1-187-188 188-188 0 0 937 0 0 376-938-1z',
    transform: 'matrix(1 0 0 -1 0 850)'
  },
  plotlylogo: {
    width: 1542,
    height: 1000,
    path: 'm0-10h182v-140h-182v140z m228 146h183v-286h-183v286z m225 714h182v-1000h-182v1000z m225-285h182v-715h-182v715z m225 142h183v-857h-183v857z m231-428h182v-429h-182v429z m225-291h183v-138h-183v138z',
    transform: 'matrix(1 0 0 -1 0 850)'
  },
  'z-axis': {
    width: 1000,
    height: 1000,
    path: 'm833 5l-17 108v41l-130-65 130-66c0 0 0 38 0 39 0-1 36-14 39-25 4-15-6-22-16-30-15-12-39-16-56-20-90-22-187-23-279-23-261 0-341 34-353 59 3 60 228 110 228 110-140-8-351-35-351-116 0-120 293-142 474-142 155 0 477 22 477 142 0 50-74 79-163 96z m-374 94c-58-5-99-21-99-40 0-24 65-43 144-43 79 0 143 19 143 43 0 19-42 34-98 40v216h87l-132 135-133-135h88v-216z m167 515h-136v1c16 16 31 34 46 52l84 109v54h-230v-71h124v-1c-16-17-28-32-44-51l-89-114v-51h245v72z',
    transform: 'matrix(1 0 0 -1 0 850)'
  },
  '3d_rotate': {
    width: 1000,
    height: 1000,
    path: 'm922 660c-5 4-9 7-14 11-359 263-580-31-580-31l-102 28 58-400c0 1 1 1 2 2 118 108 351 249 351 249s-62 27-100 42c88 83 222 183 347 122 16-8 30-17 44-27-2 1-4 2-6 4z m36-329c0 0 64 229-88 296-62 27-124 14-175-11 157-78 225-208 249-266 8-19 11-31 11-31 2 5 6 15 11 32-5-13-8-20-8-20z m-775-239c70-31 117-50 198-32-121 80-199 346-199 346l-96-15-58-12c0 0 55-226 155-287z m603 133l-317-139c0 0 4-4 19-14 7-5 24-15 24-15s-177-147-389 4c235-287 536-112 536-112l31-22 100 299-4-1z m-298-153c6-4 14-9 24-15 0 0-17 10-24 15z',
    transform: 'matrix(1 0 0 -1 0 850)'
  },
  camera: {
    width: 1000,
    height: 1000,
    path: 'm500 450c-83 0-150-67-150-150 0-83 67-150 150-150 83 0 150 67 150 150 0 83-67 150-150 150z m400 150h-120c-16 0-34 13-39 29l-31 93c-6 15-23 28-40 28h-340c-16 0-34-13-39-28l-31-94c-6-15-23-28-40-28h-120c-55 0-100-45-100-100v-450c0-55 45-100 100-100h800c55 0 100 45 100 100v450c0 55-45 100-100 100z m-400-550c-138 0-250 112-250 250 0 138 112 250 250 250 138 0 250-112 250-250 0-138-112-250-250-250z m365 380c-19 0-35 16-35 35 0 19 16 35 35 35 19 0 35-16 35-35 0-19-16-35-35-35z',
    transform: 'matrix(1 0 0 -1 0 850)'
  },
  movie: {
    width: 1000,
    height: 1000,
    path: 'm938 413l-188-125c0 37-17 71-44 94 64 38 107 107 107 187 0 121-98 219-219 219-121 0-219-98-219-219 0-61 25-117 66-156h-115c30 33 49 76 49 125 0 103-84 187-187 187s-188-84-188-187c0-57 26-107 65-141-38-22-65-62-65-109v-250c0-70 56-126 125-126h500c69 0 125 56 125 126l188-126c34 0 62 28 62 63v375c0 35-28 63-62 63z m-750 0c-69 0-125 56-125 125s56 125 125 125 125-56 125-125-56-125-125-125z m406-1c-87 0-157 70-157 157 0 86 70 156 157 156s156-70 156-156-70-157-156-157z',
    transform: 'matrix(1 0 0 -1 0 850)'
  },
  question: {
    width: 857.1,
    height: 1000,
    path: 'm500 82v107q0 8-5 13t-13 5h-107q-8 0-13-5t-5-13v-107q0-8 5-13t13-5h107q8 0 13 5t5 13z m143 375q0 49-31 91t-77 65-95 23q-136 0-207-119-9-14 4-24l74-55q4-4 10-4 9 0 14 7 30 38 48 51 19 14 48 14 27 0 48-15t21-33q0-21-11-34t-38-25q-35-16-65-48t-29-70v-20q0-8 5-13t13-5h107q8 0 13 5t5 13q0 10 12 27t30 28q18 10 28 16t25 19 25 27 16 34 7 45z m214-107q0-117-57-215t-156-156-215-58-216 58-155 156-58 215 58 215 155 156 216 58 215-58 156-156 57-215z',
    transform: 'matrix(1 0 0 -1 0 850)'
  },
  disk: {
    width: 857.1,
    height: 1000,
    path: 'm214-7h429v214h-429v-214z m500 0h72v500q0 8-6 21t-11 20l-157 156q-5 6-19 12t-22 5v-232q0-22-15-38t-38-16h-322q-22 0-37 16t-16 38v232h-72v-714h72v232q0 22 16 38t37 16h465q22 0 38-16t15-38v-232z m-214 518v178q0 8-5 13t-13 5h-107q-7 0-13-5t-5-13v-178q0-8 5-13t13-5h107q7 0 13 5t5 13z m357-18v-518q0-22-15-38t-38-16h-750q-23 0-38 16t-16 38v750q0 22 16 38t38 16h517q23 0 50-12t42-26l156-157q16-15 27-42t11-49z',
    transform: 'matrix(1 0 0 -1 0 850)'
  },
  drawopenpath: {
    width: 70,
    height: 70,
    path: 'M33.21,85.65a7.31,7.31,0,0,1-2.59-.48c-8.16-3.11-9.27-19.8-9.88-41.3-.1-3.58-.19-6.68-.35-9-.15-2.1-.67-3.48-1.43-3.79-2.13-.88-7.91,2.32-12,5.86L3,32.38c1.87-1.64,11.55-9.66,18.27-6.9,2.13.87,4.75,3.14,5.17,9,.17,2.43.26,5.59.36,9.25a224.17,224.17,0,0,0,1.5,23.4c1.54,10.76,4,12.22,4.48,12.4.84.32,2.79-.46,5.76-3.59L43,80.07C41.53,81.57,37.68,85.64,33.21,85.65ZM74.81,69a11.34,11.34,0,0,0,6.09-6.72L87.26,44.5,74.72,32,56.9,38.35c-2.37.86-5.57,3.42-6.61,6L38.65,72.14l8.42,8.43ZM55,46.27a7.91,7.91,0,0,1,3.64-3.17l14.8-5.3,8,8L76.11,60.6l-.06.19a6.37,6.37,0,0,1-3,3.43L48.25,74.59,44.62,71Zm16.57,7.82A6.9,6.9,0,1,0,64.64,61,6.91,6.91,0,0,0,71.54,54.09Zm-4.05,0a2.85,2.85,0,1,1-2.85-2.85A2.86,2.86,0,0,1,67.49,54.09Zm-4.13,5.22L60.5,56.45,44.26,72.7l2.86,2.86ZM97.83,35.67,84.14,22l-8.57,8.57L89.26,44.24Zm-13.69-8,8,8-2.85,2.85-8-8Z',
    transform: 'matrix(1 0 0 1 -15 -15)'
  },
  drawclosedpath: {
    width: 90,
    height: 90,
    path: 'M88.41,21.12a26.56,26.56,0,0,0-36.18,0l-2.07,2-2.07-2a26.57,26.57,0,0,0-36.18,0,23.74,23.74,0,0,0,0,34.8L48,90.12a3.22,3.22,0,0,0,4.42,0l36-34.21a23.73,23.73,0,0,0,0-34.79ZM84,51.24,50.16,83.35,16.35,51.25a17.28,17.28,0,0,1,0-25.47,20,20,0,0,1,27.3,0l4.29,4.07a3.23,3.23,0,0,0,4.44,0l4.29-4.07a20,20,0,0,1,27.3,0,17.27,17.27,0,0,1,0,25.46ZM66.76,47.68h-33v6.91h33ZM53.35,35H46.44V68h6.91Z',
    transform: 'matrix(1 0 0 1 -5 -5)'
  },
  lasso: {
    width: 1031,
    height: 1000,
    path: 'm1018 538c-36 207-290 336-568 286-277-48-473-256-436-463 10-57 36-108 76-151-13-66 11-137 68-183 34-28 75-41 114-42l-55-70 0 0c-2-1-3-2-4-3-10-14-8-34 5-45 14-11 34-8 45 4 1 1 2 3 2 5l0 0 113 140c16 11 31 24 45 40 4 3 6 7 8 11 48-3 100 0 151 9 278 48 473 255 436 462z m-624-379c-80 14-149 48-197 96 42 42 109 47 156 9 33-26 47-66 41-105z m-187-74c-19 16-33 37-39 60 50-32 109-55 174-68-42-25-95-24-135 8z m360 75c-34-7-69-9-102-8 8 62-16 128-68 170-73 59-175 54-244-5-9 20-16 40-20 61-28 159 121 317 333 354s407-60 434-217c28-159-121-318-333-355z',
    transform: 'matrix(1 0 0 -1 0 850)'
  },
  selectbox: {
    width: 1000,
    height: 1000,
    path: 'm0 850l0-143 143 0 0 143-143 0z m286 0l0-143 143 0 0 143-143 0z m285 0l0-143 143 0 0 143-143 0z m286 0l0-143 143 0 0 143-143 0z m-857-286l0-143 143 0 0 143-143 0z m857 0l0-143 143 0 0 143-143 0z m-857-285l0-143 143 0 0 143-143 0z m857 0l0-143 143 0 0 143-143 0z m-857-286l0-143 143 0 0 143-143 0z m286 0l0-143 143 0 0 143-143 0z m285 0l0-143 143 0 0 143-143 0z m286 0l0-143 143 0 0 143-143 0z',
    transform: 'matrix(1 0 0 -1 0 850)'
  },
  drawline: {
    width: 70,
    height: 70,
    path: 'M60.64,62.3a11.29,11.29,0,0,0,6.09-6.72l6.35-17.72L60.54,25.31l-17.82,6.4c-2.36.86-5.57,3.41-6.6,6L24.48,65.5l8.42,8.42ZM40.79,39.63a7.89,7.89,0,0,1,3.65-3.17l14.79-5.31,8,8L61.94,54l-.06.19a6.44,6.44,0,0,1-3,3.43L34.07,68l-3.62-3.63Zm16.57,7.81a6.9,6.9,0,1,0-6.89,6.9A6.9,6.9,0,0,0,57.36,47.44Zm-4,0a2.86,2.86,0,1,1-2.85-2.85A2.86,2.86,0,0,1,53.32,47.44Zm-4.13,5.22L46.33,49.8,30.08,66.05l2.86,2.86ZM83.65,29,70,15.34,61.4,23.9,75.09,37.59ZM70,21.06l8,8-2.84,2.85-8-8ZM87,80.49H10.67V87H87Z',
    transform: 'matrix(1 0 0 1 -15 -15)'
  },
  drawrect: {
    width: 80,
    height: 80,
    path: 'M78,22V79H21V22H78m9-9H12V88H87V13ZM68,46.22H31V54H68ZM53,32H45.22V69H53Z',
    transform: 'matrix(1 0 0 1 -10 -10)'
  },
  drawcircle: {
    width: 80,
    height: 80,
    path: 'M50,84.72C26.84,84.72,8,69.28,8,50.3S26.84,15.87,50,15.87,92,31.31,92,50.3,73.16,84.72,50,84.72Zm0-60.59c-18.6,0-33.74,11.74-33.74,26.17S31.4,76.46,50,76.46,83.74,64.72,83.74,50.3,68.6,24.13,50,24.13Zm17.15,22h-34v7.11h34Zm-13.8-13H46.24v34h7.11Z',
    transform: 'matrix(1 0 0 1 -10 -10)'
  },
  eraseshape: {
    width: 80,
    height: 80,
    path: 'M82.77,78H31.85L6,49.57,31.85,21.14H82.77a8.72,8.72,0,0,1,8.65,8.77V69.24A8.72,8.72,0,0,1,82.77,78ZM35.46,69.84H82.77a.57.57,0,0,0,.49-.6V29.91a.57.57,0,0,0-.49-.61H35.46L17,49.57Zm32.68-34.7-24,24,5,5,24-24Zm-19,.53-5,5,24,24,5-5Z',
    transform: 'matrix(1 0 0 1 -10 -10)'
  },
  spikeline: {
    width: 1000,
    height: 1000,
    path: 'M512 409c0-57-46-104-103-104-57 0-104 47-104 104 0 57 47 103 104 103 57 0 103-46 103-103z m-327-39l92 0 0 92-92 0z m-185 0l92 0 0 92-92 0z m370-186l92 0 0 93-92 0z m0-184l92 0 0 92-92 0z',
    transform: 'matrix(1.5 0 0 -1.5 0 850)'
  },
  pencil: {
    width: 1792,
    height: 1792,
    path: 'M491 1536l91-91-235-235-91 91v107h128v128h107zm523-928q0-22-22-22-10 0-17 7l-542 542q-7 7-7 17 0 22 22 22 10 0 17-7l542-542q7-7 7-17zm-54-192l416 416-832 832h-416v-416zm683 96q0 53-37 90l-166 166-416-416 166-165q36-38 90-38 53 0 91 38l235 234q37 39 37 91z',
    transform: 'matrix(1 0 0 1 0 1)'
  },
  newplotlylogo: {
    name: 'newplotlylogo',
    svg: ['<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 132 132\'>', '<defs>', ' <style>', '  .cls-0{fill:#000;}', '  .cls-1{fill:#FFF;}', '  .cls-2{fill:#F26;}', '  .cls-3{fill:#D69;}', '  .cls-4{fill:#BAC;}', '  .cls-5{fill:#9EF;}', ' </style>', '</defs>', ' <title>plotly-logomark</title>', ' <g id=\'symbol\'>', '  <rect class=\'cls-0\' x=\'0\' y=\'0\' width=\'132\' height=\'132\' rx=\'18\' ry=\'18\'/>', '  <circle class=\'cls-5\' cx=\'102\' cy=\'30\' r=\'6\'/>', '  <circle class=\'cls-4\' cx=\'78\' cy=\'30\' r=\'6\'/>', '  <circle class=\'cls-4\' cx=\'78\' cy=\'54\' r=\'6\'/>', '  <circle class=\'cls-3\' cx=\'54\' cy=\'30\' r=\'6\'/>', '  <circle class=\'cls-2\' cx=\'30\' cy=\'30\' r=\'6\'/>', '  <circle class=\'cls-2\' cx=\'30\' cy=\'54\' r=\'6\'/>', '  <path class=\'cls-1\' d=\'M30,72a6,6,0,0,0-6,6v24a6,6,0,0,0,12,0V78A6,6,0,0,0,30,72Z\'/>', '  <path class=\'cls-1\' d=\'M78,72a6,6,0,0,0-6,6v24a6,6,0,0,0,12,0V78A6,6,0,0,0,78,72Z\'/>', '  <path class=\'cls-1\' d=\'M54,48a6,6,0,0,0-6,6v48a6,6,0,0,0,12,0V54A6,6,0,0,0,54,48Z\'/>', '  <path class=\'cls-1\' d=\'M102,48a6,6,0,0,0-6,6v48a6,6,0,0,0,12,0V54A6,6,0,0,0,102,48Z\'/>', ' </g>', '</svg>'].join('')
  }
};

/***/ }),

/***/ 32546:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


/**
 * Determine the position anchor property of x/y xanchor/yanchor components.
 *
 * - values < 1/3 align the low side at that fraction,
 * - values [1/3, 2/3] align the center at that fraction,
 * - values > 2/3 align the right at that fraction.
 */
exports.isLeftAnchor = function isLeftAnchor(opts) {
  return opts.xanchor === 'left' || opts.xanchor === 'auto' && opts.x <= 1 / 3;
};
exports.isCenterAnchor = function isCenterAnchor(opts) {
  return opts.xanchor === 'center' || opts.xanchor === 'auto' && opts.x > 1 / 3 && opts.x < 2 / 3;
};
exports.isRightAnchor = function isRightAnchor(opts) {
  return opts.xanchor === 'right' || opts.xanchor === 'auto' && opts.x >= 2 / 3;
};
exports.isTopAnchor = function isTopAnchor(opts) {
  return opts.yanchor === 'top' || opts.yanchor === 'auto' && opts.y >= 2 / 3;
};
exports.isMiddleAnchor = function isMiddleAnchor(opts) {
  return opts.yanchor === 'middle' || opts.yanchor === 'auto' && opts.y > 1 / 3 && opts.y < 2 / 3;
};
exports.isBottomAnchor = function isBottomAnchor(opts) {
  return opts.yanchor === 'bottom' || opts.yanchor === 'auto' && opts.y <= 1 / 3;
};

/***/ }),

/***/ 44313:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var modModule = __webpack_require__(98953);
var mod = modModule.mod;
var modHalf = modModule.modHalf;
var PI = Math.PI;
var twoPI = 2 * PI;
function deg2rad(deg) {
  return deg / 180 * PI;
}
function rad2deg(rad) {
  return rad / PI * 180;
}

/**
 * is sector a full circle?
 * ... this comes up a lot in SVG path-drawing routines
 *
 * N.B. we consider all sectors that span more that 2pi 'full' circles
 *
 * @param {2-item array} aBnds : angular bounds in *radians*
 * @return {boolean}
 */
function isFullCircle(aBnds) {
  return Math.abs(aBnds[1] - aBnds[0]) > twoPI - 1e-14;
}

/**
 * angular delta between angle 'a' and 'b'
 * solution taken from: https://stackoverflow.com/a/2007279
 *
 * @param {number} a : first angle in *radians*
 * @param {number} b : second angle in *radians*
 * @return {number} angular delta in *radians*
 */
function angleDelta(a, b) {
  return modHalf(b - a, twoPI);
}

/**
 * angular distance between angle 'a' and 'b'
 *
 * @param {number} a : first angle in *radians*
 * @param {number} b : second angle in *radians*
 * @return {number} angular distance in *radians*
 */
function angleDist(a, b) {
  return Math.abs(angleDelta(a, b));
}

/**
 * is angle inside sector?
 *
 * @param {number} a : angle to test in *radians*
 * @param {2-item array} aBnds : sector's angular bounds in *radians*
 * @param {boolean}
 */
function isAngleInsideSector(a, aBnds) {
  if (isFullCircle(aBnds)) return true;
  var s0, s1;
  if (aBnds[0] < aBnds[1]) {
    s0 = aBnds[0];
    s1 = aBnds[1];
  } else {
    s0 = aBnds[1];
    s1 = aBnds[0];
  }
  s0 = mod(s0, twoPI);
  s1 = mod(s1, twoPI);
  if (s0 > s1) s1 += twoPI;
  var a0 = mod(a, twoPI);
  var a1 = a0 + twoPI;
  return a0 >= s0 && a0 <= s1 || a1 >= s0 && a1 <= s1;
}

/**
 * is pt (r,a) inside sector?
 *
 * @param {number} r : pt's radial coordinate
 * @param {number} a : pt's angular coordinate in *radians*
 * @param {2-item array} rBnds : sector's radial bounds
 * @param {2-item array} aBnds : sector's angular bounds in *radians*
 * @return {boolean}
 */
function isPtInsideSector(r, a, rBnds, aBnds) {
  if (!isAngleInsideSector(a, aBnds)) return false;
  var r0, r1;
  if (rBnds[0] < rBnds[1]) {
    r0 = rBnds[0];
    r1 = rBnds[1];
  } else {
    r0 = rBnds[1];
    r1 = rBnds[0];
  }
  return r >= r0 && r <= r1;
}

// common to pathArc, pathSector and pathAnnulus
function _path(r0, r1, a0, a1, cx, cy, isClosed) {
  cx = cx || 0;
  cy = cy || 0;
  var isCircle = isFullCircle([a0, a1]);
  var aStart, aMid, aEnd;
  var rStart, rEnd;
  if (isCircle) {
    aStart = 0;
    aMid = PI;
    aEnd = twoPI;
  } else {
    if (a0 < a1) {
      aStart = a0;
      aEnd = a1;
    } else {
      aStart = a1;
      aEnd = a0;
    }
  }
  if (r0 < r1) {
    rStart = r0;
    rEnd = r1;
  } else {
    rStart = r1;
    rEnd = r0;
  }

  // N.B. svg coordinates here, where y increases downward
  function pt(r, a) {
    return [r * Math.cos(a) + cx, cy - r * Math.sin(a)];
  }
  var largeArc = Math.abs(aEnd - aStart) <= PI ? 0 : 1;
  function arc(r, a, cw) {
    return 'A' + [r, r] + ' ' + [0, largeArc, cw] + ' ' + pt(r, a);
  }
  var p;
  if (isCircle) {
    if (rStart === null) {
      p = 'M' + pt(rEnd, aStart) + arc(rEnd, aMid, 0) + arc(rEnd, aEnd, 0) + 'Z';
    } else {
      p = 'M' + pt(rStart, aStart) + arc(rStart, aMid, 0) + arc(rStart, aEnd, 0) + 'Z' + 'M' + pt(rEnd, aStart) + arc(rEnd, aMid, 1) + arc(rEnd, aEnd, 1) + 'Z';
    }
  } else {
    if (rStart === null) {
      p = 'M' + pt(rEnd, aStart) + arc(rEnd, aEnd, 0);
      if (isClosed) p += 'L0,0Z';
    } else {
      p = 'M' + pt(rStart, aStart) + 'L' + pt(rEnd, aStart) + arc(rEnd, aEnd, 0) + 'L' + pt(rStart, aEnd) + arc(rStart, aStart, 1) + 'Z';
    }
  }
  return p;
}

/**
 * path an arc
 *
 * @param {number} r : radius
 * @param {number} a0 : first angular coordinate in *radians*
 * @param {number} a1 : second angular coordinate in *radians*
 * @param {number (optional)} cx : x coordinate of center
 * @param {number (optional)} cy : y coordinate of center
 * @return {string} svg path
 */
function pathArc(r, a0, a1, cx, cy) {
  return _path(null, r, a0, a1, cx, cy, 0);
}

/**
 * path a sector
 *
 * @param {number} r : radius
 * @param {number} a0 : first angular coordinate in *radians*
 * @param {number} a1 : second angular coordinate in *radians*
 * @param {number (optional)} cx : x coordinate of center
 * @param {number (optional)} cy : y coordinate of center
 * @return {string} svg path
 */
function pathSector(r, a0, a1, cx, cy) {
  return _path(null, r, a0, a1, cx, cy, 1);
}

/**
 * path an annulus
 *
 * @param {number} r0 : first radial coordinate
 * @param {number} r1 : second radial coordinate
 * @param {number} a0 : first angular coordinate in *radians*
 * @param {number} a1 : second angular coordinate in *radians*
 * @param {number (optional)} cx : x coordinate of center
 * @param {number (optional)} cy : y coordinate of center
 * @return {string} svg path
 */
function pathAnnulus(r0, r1, a0, a1, cx, cy) {
  return _path(r0, r1, a0, a1, cx, cy, 1);
}
module.exports = {
  deg2rad: deg2rad,
  rad2deg: rad2deg,
  angleDelta: angleDelta,
  angleDist: angleDist,
  isFullCircle: isFullCircle,
  isAngleInsideSector: isAngleInsideSector,
  isPtInsideSector: isPtInsideSector,
  pathArc: pathArc,
  pathSector: pathSector,
  pathAnnulus: pathAnnulus
};

/***/ }),

/***/ 87800:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var b64decode = (__webpack_require__(93229).decode);
var isPlainObject = __webpack_require__(56174);
var isArray = Array.isArray;
var ab = ArrayBuffer;
var dv = DataView;
function isTypedArray(a) {
  return ab.isView(a) && !(a instanceof dv);
}
exports.isTypedArray = isTypedArray;
function isArrayOrTypedArray(a) {
  return isArray(a) || isTypedArray(a);
}
exports.isArrayOrTypedArray = isArrayOrTypedArray;

/*
 * Test whether an input object is 1D.
 *
 * Assumes we already know the object is an array.
 *
 * Looks only at the first element, if the dimensionality is
 * not consistent we won't figure that out here.
 */
function isArray1D(a) {
  return !isArrayOrTypedArray(a[0]);
}
exports.isArray1D = isArray1D;

/*
 * Ensures an array has the right amount of storage space. If it doesn't
 * exist, it creates an array. If it does exist, it returns it if too
 * short or truncates it in-place.
 *
 * The goal is to just reuse memory to avoid a bit of excessive garbage
 * collection.
 */
exports.ensureArray = function (out, n) {
  // TODO: typed array support here? This is only used in
  // traces/carpet/compute_control_points
  if (!isArray(out)) out = [];

  // If too long, truncate. (If too short, it will grow
  // automatically so we don't care about that case)
  out.length = n;
  return out;
};
var typedArrays = {
  u1c: typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
  // not supported in numpy?

  i1: typeof Int8Array === 'undefined' ? undefined : Int8Array,
  u1: typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
  i2: typeof Int16Array === 'undefined' ? undefined : Int16Array,
  u2: typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
  i4: typeof Int32Array === 'undefined' ? undefined : Int32Array,
  u4: typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
  f4: typeof Float32Array === 'undefined' ? undefined : Float32Array,
  f8: typeof Float64Array === 'undefined' ? undefined : Float64Array

  /* TODO: potentially add Big Int
   i8: typeof BigInt64Array === 'undefined' ? undefined :
             BigInt64Array,
   u8: typeof BigUint64Array === 'undefined' ? undefined :
             BigUint64Array,
  */
};
typedArrays.uint8c = typedArrays.u1c;
typedArrays.uint8 = typedArrays.u1;
typedArrays.int8 = typedArrays.i1;
typedArrays.uint16 = typedArrays.u2;
typedArrays.int16 = typedArrays.i2;
typedArrays.uint32 = typedArrays.u4;
typedArrays.int32 = typedArrays.i4;
typedArrays.float32 = typedArrays.f4;
typedArrays.float64 = typedArrays.f8;
function isArrayBuffer(a) {
  return a.constructor === ArrayBuffer;
}
exports.isArrayBuffer = isArrayBuffer;
exports.decodeTypedArraySpec = function (vIn) {
  var out = [];
  var v = coerceTypedArraySpec(vIn);
  var dtype = v.dtype;
  var T = typedArrays[dtype];
  if (!T) throw new Error('Error in dtype: "' + dtype + '"');
  var BYTES_PER_ELEMENT = T.BYTES_PER_ELEMENT;
  var buffer = v.bdata;
  if (!isArrayBuffer(buffer)) {
    buffer = b64decode(buffer);
  }
  var shape = v.shape === undefined ?
  // detect 1-d length
  [buffer.byteLength / BYTES_PER_ELEMENT] :
  // convert number to string and split to array
  ('' + v.shape).split(',');
  shape.reverse(); // i.e. to match numpy order
  var ndim = shape.length;
  var nj, j;
  var ni = +shape[0];
  var rowBytes = BYTES_PER_ELEMENT * ni;
  var pos = 0;
  if (ndim === 1) {
    out = new T(buffer);
  } else if (ndim === 2) {
    nj = +shape[1];
    for (j = 0; j < nj; j++) {
      out[j] = new T(buffer, pos, ni);
      pos += rowBytes;
    }
  } else if (ndim === 3) {
    nj = +shape[1];
    var nk = +shape[2];
    for (var k = 0; k < nk; k++) {
      out[k] = [];
      for (j = 0; j < nj; j++) {
        out[k][j] = new T(buffer, pos, ni);
        pos += rowBytes;
      }
    }
  } else {
    throw new Error('ndim: ' + ndim + 'is not supported with the shape:"' + v.shape + '"');
  }

  // attach bdata, dtype & shape to array for json export
  out.bdata = v.bdata;
  out.dtype = v.dtype;
  out.shape = shape.reverse().join(',');
  vIn._inputArray = out;
  return out;
};
exports.isTypedArraySpec = function (v) {
  return isPlainObject(v) && v.hasOwnProperty('dtype') && typeof v.dtype === 'string' && v.hasOwnProperty('bdata') && (typeof v.bdata === 'string' || isArrayBuffer(v.bdata)) && (v.shape === undefined || v.hasOwnProperty('shape') && (typeof v.shape === 'string' || typeof v.shape === 'number'));
};
function coerceTypedArraySpec(v) {
  return {
    bdata: v.bdata,
    dtype: v.dtype,
    shape: v.shape
  };
}

/*
 * TypedArray-compatible concatenation of n arrays
 * if all arrays are the same type it will preserve that type,
 * otherwise it falls back on Array.
 * Also tries to avoid copying, in case one array has zero length
 * But never mutates an existing array
 */
exports.concat = function () {
  var args = [];
  var allArray = true;
  var totalLen = 0;
  var _constructor, arg0, i, argi, posi, leni, out, j;
  for (i = 0; i < arguments.length; i++) {
    argi = arguments[i];
    leni = argi.length;
    if (leni) {
      if (arg0) args.push(argi);else {
        arg0 = argi;
        posi = leni;
      }
      if (isArray(argi)) {
        _constructor = false;
      } else {
        allArray = false;
        if (!totalLen) {
          _constructor = argi.constructor;
        } else if (_constructor !== argi.constructor) {
          // TODO: in principle we could upgrade here,
          // ie keep typed array but convert all to Float64Array?
          _constructor = false;
        }
      }
      totalLen += leni;
    }
  }
  if (!totalLen) return [];
  if (!args.length) return arg0;
  if (allArray) return arg0.concat.apply(arg0, args);
  if (_constructor) {
    // matching typed arrays
    out = new _constructor(totalLen);
    out.set(arg0);
    for (i = 0; i < args.length; i++) {
      argi = args[i];
      out.set(argi, posi);
      posi += argi.length;
    }
    return out;
  }

  // mismatched types or Array + typed
  out = new Array(totalLen);
  for (j = 0; j < arg0.length; j++) out[j] = arg0[j];
  for (i = 0; i < args.length; i++) {
    argi = args[i];
    for (j = 0; j < argi.length; j++) out[posi + j] = argi[j];
    posi += j;
  }
  return out;
};
exports.maxRowLength = function (z) {
  return _rowLength(z, Math.max, 0);
};
exports.minRowLength = function (z) {
  return _rowLength(z, Math.min, Infinity);
};
function _rowLength(z, fn, len0) {
  if (isArrayOrTypedArray(z)) {
    if (isArrayOrTypedArray(z[0])) {
      var len = len0;
      for (var i = 0; i < z.length; i++) {
        len = fn(len, z[i].length);
      }
      return len;
    } else {
      return z.length;
    }
  }
  return 0;
}

/***/ }),

/***/ 44498:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isNumeric = __webpack_require__(10721);
var BADNUM = (__webpack_require__(63821).BADNUM);

// precompile for speed
var JUNK = /^['"%,$#\s']+|[, ]|['"%,$#\s']+$/g;

/**
 * cleanNumber: remove common leading and trailing cruft
 * Always returns either a number or BADNUM.
 */
module.exports = function cleanNumber(v) {
  if (typeof v === 'string') {
    v = v.replace(JUNK, '');
  }
  if (isNumeric(v)) return Number(v);
  return BADNUM;
};

/***/ }),

/***/ 34823:
/***/ (function(module) {

"use strict";


/**
 * Clear gl frame (if any). This is a common pattern as
 * we usually set `preserveDrawingBuffer: true` during
 * gl context creation (e.g. via `reglUtils.prepare`).
 *
 * @param {DOM node or object} gd : graph div object
 */
module.exports = function clearGlCanvases(gd) {
  var fullLayout = gd._fullLayout;
  if (fullLayout._glcanvas && fullLayout._glcanvas.size()) {
    fullLayout._glcanvas.each(function (d) {
      if (d.regl) d.regl.clear({
        color: true,
        depth: true
      });
    });
  }
};

/***/ }),

/***/ 23493:
/***/ (function(module) {

"use strict";


/**
 * Clear responsive handlers (if any).
 *
 * @param {DOM node or object} gd : graph div object
 */
module.exports = function clearResponsive(gd) {
  if (gd._responsiveChartHandler) {
    window.removeEventListener('resize', gd._responsiveChartHandler);
    delete gd._responsiveChartHandler;
  }
};

/***/ }),

/***/ 34220:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var isNumeric = __webpack_require__(10721);
var tinycolor = __webpack_require__(65657);
var extendFlat = (__webpack_require__(93049).extendFlat);
var baseTraceAttrs = __webpack_require__(9829);
var colorscales = __webpack_require__(19017);
var Color = __webpack_require__(78766);
var DESELECTDIM = (__webpack_require__(20438).DESELECTDIM);
var nestedProperty = __webpack_require__(35632);
var counterRegex = (__webpack_require__(90694).counter);
var modHalf = (__webpack_require__(98953).modHalf);
var isArrayOrTypedArray = (__webpack_require__(87800).isArrayOrTypedArray);
var isTypedArraySpec = (__webpack_require__(87800).isTypedArraySpec);
var decodeTypedArraySpec = (__webpack_require__(87800).decodeTypedArraySpec);
exports.valObjectMeta = {
  data_array: {
    // You can use *dflt=[] to force said array to exist though.
    coerceFunction: function (v, propOut, dflt) {
      propOut.set(isArrayOrTypedArray(v) ? v : isTypedArraySpec(v) ? decodeTypedArraySpec(v) : dflt);
    }
  },
  enumerated: {
    coerceFunction: function (v, propOut, dflt, opts) {
      if (opts.coerceNumber) v = +v;
      if (opts.values.indexOf(v) === -1) propOut.set(dflt);else propOut.set(v);
    },
    validateFunction: function (v, opts) {
      if (opts.coerceNumber) v = +v;
      var values = opts.values;
      for (var i = 0; i < values.length; i++) {
        var k = String(values[i]);
        if (k.charAt(0) === '/' && k.charAt(k.length - 1) === '/') {
          var regex = new RegExp(k.substr(1, k.length - 2));
          if (regex.test(v)) return true;
        } else if (v === values[i]) return true;
      }
      return false;
    }
  },
  boolean: {
    coerceFunction: function (v, propOut, dflt) {
      if (v === true || v === false) propOut.set(v);else propOut.set(dflt);
    }
  },
  number: {
    coerceFunction: function (v, propOut, dflt, opts) {
      if (isTypedArraySpec(v)) v = decodeTypedArraySpec(v);
      if (!isNumeric(v) || opts.min !== undefined && v < opts.min || opts.max !== undefined && v > opts.max) {
        propOut.set(dflt);
      } else propOut.set(+v);
    }
  },
  integer: {
    coerceFunction: function (v, propOut, dflt, opts) {
      if ((opts.extras || []).indexOf(v) !== -1) {
        propOut.set(v);
        return;
      }
      if (isTypedArraySpec(v)) v = decodeTypedArraySpec(v);
      if (v % 1 || !isNumeric(v) || opts.min !== undefined && v < opts.min || opts.max !== undefined && v > opts.max) {
        propOut.set(dflt);
      } else propOut.set(+v);
    }
  },
  string: {
    // TODO 'values shouldn't be in there (edge case: 'dash' in Scatter)
    coerceFunction: function (v, propOut, dflt, opts) {
      if (typeof v !== 'string') {
        var okToCoerce = typeof v === 'number';
        if (opts.strict === true || !okToCoerce) propOut.set(dflt);else propOut.set(String(v));
      } else if (opts.noBlank && !v) propOut.set(dflt);else propOut.set(v);
    }
  },
  color: {
    coerceFunction: function (v, propOut, dflt) {
      if (isTypedArraySpec(v)) v = decodeTypedArraySpec(v);
      if (tinycolor(v).isValid()) propOut.set(v);else propOut.set(dflt);
    }
  },
  colorlist: {
    coerceFunction: function (v, propOut, dflt) {
      function isColor(color) {
        return tinycolor(color).isValid();
      }
      if (!Array.isArray(v) || !v.length) propOut.set(dflt);else if (v.every(isColor)) propOut.set(v);else propOut.set(dflt);
    }
  },
  colorscale: {
    coerceFunction: function (v, propOut, dflt) {
      propOut.set(colorscales.get(v, dflt));
    }
  },
  angle: {
    coerceFunction: function (v, propOut, dflt) {
      if (isTypedArraySpec(v)) v = decodeTypedArraySpec(v);
      if (v === 'auto') propOut.set('auto');else if (!isNumeric(v)) propOut.set(dflt);else propOut.set(modHalf(+v, 360));
    }
  },
  subplotid: {
    coerceFunction: function (v, propOut, dflt, opts) {
      var regex = opts.regex || counterRegex(dflt);
      if (typeof v === 'string' && regex.test(v)) {
        propOut.set(v);
        return;
      }
      propOut.set(dflt);
    },
    validateFunction: function (v, opts) {
      var dflt = opts.dflt;
      if (v === dflt) return true;
      if (typeof v !== 'string') return false;
      if (counterRegex(dflt).test(v)) return true;
      return false;
    }
  },
  flaglist: {
    coerceFunction: function (v, propOut, dflt, opts) {
      if ((opts.extras || []).indexOf(v) !== -1) {
        propOut.set(v);
        return;
      }
      if (typeof v !== 'string') {
        propOut.set(dflt);
        return;
      }
      var vParts = v.split('+');
      var i = 0;
      while (i < vParts.length) {
        var vi = vParts[i];
        if (opts.flags.indexOf(vi) === -1 || vParts.indexOf(vi) < i) {
          vParts.splice(i, 1);
        } else i++;
      }
      if (!vParts.length) propOut.set(dflt);else propOut.set(vParts.join('+'));
    }
  },
  any: {
    coerceFunction: function (v, propOut, dflt) {
      if (v === undefined) {
        propOut.set(dflt);
      } else {
        propOut.set(isTypedArraySpec(v) ? decodeTypedArraySpec(v) : v);
      }
    }
  },
  info_array: {
    // set `dimensions=2` for a 2D array or '1-2' for either
    // `items` may be a single object instead of an array, in which case
    // `freeLength` must be true.
    // if `dimensions='1-2'` and items is a 1D array, then the value can
    // either be a matching 1D array or an array of such matching 1D arrays
    coerceFunction: function (v, propOut, dflt, opts) {
      // simplified coerce function just for array items
      function coercePart(v, opts, dflt) {
        var out;
        var propPart = {
          set: function (v) {
            out = v;
          }
        };
        if (dflt === undefined) dflt = opts.dflt;
        exports.valObjectMeta[opts.valType].coerceFunction(v, propPart, dflt, opts);
        return out;
      }
      if (isTypedArraySpec(v)) v = decodeTypedArraySpec(v);
      if (!isArrayOrTypedArray(v)) {
        propOut.set(dflt);
        return;
      }
      var twoD = opts.dimensions === 2 || opts.dimensions === '1-2' && Array.isArray(v) && isArrayOrTypedArray(v[0]);
      var items = opts.items;
      var vOut = [];
      var arrayItems = Array.isArray(items);
      var arrayItems2D = arrayItems && twoD && isArrayOrTypedArray(items[0]);
      var innerItemsOnly = twoD && arrayItems && !arrayItems2D;
      var len = arrayItems && !innerItemsOnly ? items.length : v.length;
      var i, j, row, item, len2, vNew;
      dflt = Array.isArray(dflt) ? dflt : [];
      if (twoD) {
        for (i = 0; i < len; i++) {
          vOut[i] = [];
          row = isArrayOrTypedArray(v[i]) ? v[i] : [];
          if (innerItemsOnly) len2 = items.length;else if (arrayItems) len2 = items[i].length;else len2 = row.length;
          for (j = 0; j < len2; j++) {
            if (innerItemsOnly) item = items[j];else if (arrayItems) item = items[i][j];else item = items;
            vNew = coercePart(row[j], item, (dflt[i] || [])[j]);
            if (vNew !== undefined) vOut[i][j] = vNew;
          }
        }
      } else {
        for (i = 0; i < len; i++) {
          vNew = coercePart(v[i], arrayItems ? items[i] : items, dflt[i]);
          if (vNew !== undefined) vOut[i] = vNew;
        }
      }
      propOut.set(vOut);
    },
    validateFunction: function (v, opts) {
      if (!isArrayOrTypedArray(v)) return false;
      var items = opts.items;
      var arrayItems = Array.isArray(items);
      var twoD = opts.dimensions === 2;

      // when free length is off, input and declared lengths must match
      if (!opts.freeLength && v.length !== items.length) return false;

      // valid when all input items are valid
      for (var i = 0; i < v.length; i++) {
        if (twoD) {
          if (!isArrayOrTypedArray(v[i]) || !opts.freeLength && v[i].length !== items[i].length) {
            return false;
          }
          for (var j = 0; j < v[i].length; j++) {
            if (!validate(v[i][j], arrayItems ? items[i][j] : items)) {
              return false;
            }
          }
        } else if (!validate(v[i], arrayItems ? items[i] : items)) return false;
      }
      return true;
    }
  }
};

/**
 * Ensures that container[attribute] has a valid value.
 *
 * attributes[attribute] is an object with possible keys:
 * - valType: data_array, enumerated, boolean, ... as in valObjectMeta
 * - values: (enumerated only) array of allowed vals
 * - min, max: (number, integer only) inclusive bounds on allowed vals
 *      either or both may be omitted
 * - dflt: if attribute is invalid or missing, use this default
 *      if dflt is provided as an argument to lib.coerce it takes precedence
 *      as a convenience, returns the value it finally set
 */
exports.coerce = function (containerIn, containerOut, attributes, attribute, dflt) {
  var opts = nestedProperty(attributes, attribute).get();
  var propIn = nestedProperty(containerIn, attribute);
  var propOut = nestedProperty(containerOut, attribute);
  var v = propIn.get();
  var template = containerOut._template;
  if (v === undefined && template) {
    v = nestedProperty(template, attribute).get();
    // already used the template value, so short-circuit the second check
    template = 0;
  }
  if (dflt === undefined) dflt = opts.dflt;
  if (opts.arrayOk) {
    if (isArrayOrTypedArray(v)) {
      /**
       * arrayOk: value MAY be an array, then we do no value checking
       * at this point, because it can be more complicated than the
       * individual form (eg. some array vals can be numbers, even if the
       * single values must be color strings)
       */

      propOut.set(v);
      return v;
    } else {
      if (isTypedArraySpec(v)) {
        v = decodeTypedArraySpec(v);
        propOut.set(v);
        return v;
      }
    }
  }
  var coerceFunction = exports.valObjectMeta[opts.valType].coerceFunction;
  coerceFunction(v, propOut, dflt, opts);
  var out = propOut.get();
  // in case v was provided but invalid, try the template again so it still
  // overrides the regular default
  if (template && out === dflt && !validate(v, opts)) {
    v = nestedProperty(template, attribute).get();
    coerceFunction(v, propOut, dflt, opts);
    out = propOut.get();
  }
  return out;
};

/**
 * Variation on coerce
 *
 * Uses coerce to get attribute value if user input is valid,
 * returns attribute default if user input it not valid or
 * returns false if there is no user input.
 */
exports.coerce2 = function (containerIn, containerOut, attributes, attribute, dflt) {
  var propIn = nestedProperty(containerIn, attribute);
  var propOut = exports.coerce(containerIn, containerOut, attributes, attribute, dflt);
  var valIn = propIn.get();
  return valIn !== undefined && valIn !== null ? propOut : false;
};

/*
 * Shortcut to coerce the three font attributes
 *
 * 'coerce' is a lib.coerce wrapper with implied first three arguments
 */
exports.coerceFont = function (coerce, attr, dfltObj, opts) {
  if (!opts) opts = {};
  dfltObj = extendFlat({}, dfltObj);
  dfltObj = extendFlat(dfltObj, opts.overrideDflt || {});
  var out = {
    family: coerce(attr + '.family', dfltObj.family),
    size: coerce(attr + '.size', dfltObj.size),
    color: coerce(attr + '.color', dfltObj.color),
    weight: coerce(attr + '.weight', dfltObj.weight),
    style: coerce(attr + '.style', dfltObj.style)
  };
  if (!opts.noFontVariant) out.variant = coerce(attr + '.variant', dfltObj.variant);
  if (!opts.noFontLineposition) out.lineposition = coerce(attr + '.lineposition', dfltObj.lineposition);
  if (!opts.noFontTextcase) out.textcase = coerce(attr + '.textcase', dfltObj.textcase);
  if (!opts.noFontShadow) {
    var dfltShadow = dfltObj.shadow;
    if (dfltShadow === 'none' && opts.autoShadowDflt) {
      dfltShadow = 'auto';
    }
    out.shadow = coerce(attr + '.shadow', dfltShadow);
  }
  return out;
};

/*
 * Shortcut to coerce the pattern attributes
 */
exports.coercePattern = function (coerce, attr, markerColor, hasMarkerColorscale) {
  var shape = coerce(attr + '.shape');
  if (shape) {
    coerce(attr + '.solidity');
    coerce(attr + '.size');
    var fillmode = coerce(attr + '.fillmode');
    var isOverlay = fillmode === 'overlay';
    if (!hasMarkerColorscale) {
      var bgcolor = coerce(attr + '.bgcolor', isOverlay ? markerColor : undefined);
      coerce(attr + '.fgcolor', isOverlay ? Color.contrast(bgcolor) : markerColor);
    }
    coerce(attr + '.fgopacity', isOverlay ? 0.5 : 1);
  }
};

/** Coerce shortcut for 'hoverinfo'
 * handling 1-vs-multi-trace dflt logic
 *
 * @param {object} traceIn : user trace object
 * @param {object} traceOut : full trace object (requires _module ref)
 * @param {object} layoutOut : full layout object (require _dataLength ref)
 * @return {any} : the coerced value
 */
exports.coerceHoverinfo = function (traceIn, traceOut, layoutOut) {
  var moduleAttrs = traceOut._module.attributes;
  var attrs = moduleAttrs.hoverinfo ? moduleAttrs : baseTraceAttrs;
  var valObj = attrs.hoverinfo;
  var dflt;
  if (layoutOut._dataLength === 1) {
    var flags = valObj.dflt === 'all' ? valObj.flags.slice() : valObj.dflt.split('+');
    flags.splice(flags.indexOf('name'), 1);
    dflt = flags.join('+');
  }
  return exports.coerce(traceIn, traceOut, attrs, 'hoverinfo', dflt);
};

/** Coerce shortcut for [un]selected.marker.opacity,
 *  which has special default logic, to ensure that it corresponds to the
 *  default selection behavior while allowing to be overtaken by any other
 *  [un]selected attribute.
 *
 *  N.B. This must be called *after* coercing all the other [un]selected attrs,
 *  to give the intended result.
 *
 * @param {object} traceOut : fullData item
 * @param {function} coerce : lib.coerce wrapper with implied first three arguments
 */
exports.coerceSelectionMarkerOpacity = function (traceOut, coerce) {
  if (!traceOut.marker) return;
  var mo = traceOut.marker.opacity;
  // you can still have a `marker` container with no markers if there's text
  if (mo === undefined) return;
  var smoDflt;
  var usmoDflt;

  // Don't give [un]selected.marker.opacity a default value if
  // marker.opacity is an array: handle this during style step.
  //
  // Only give [un]selected.marker.opacity a default value if you don't
  // set any other [un]selected attributes.
  if (!isArrayOrTypedArray(mo) && !traceOut.selected && !traceOut.unselected) {
    smoDflt = mo;
    usmoDflt = DESELECTDIM * mo;
  }
  coerce('selected.marker.opacity', smoDflt);
  coerce('unselected.marker.opacity', usmoDflt);
};
function validate(value, opts) {
  var valObjectDef = exports.valObjectMeta[opts.valType];
  if (opts.arrayOk && isArrayOrTypedArray(value)) return true;
  if (valObjectDef.validateFunction) {
    return valObjectDef.validateFunction(value, opts);
  }
  var failed = {};
  var out = failed;
  var propMock = {
    set: function (v) {
      out = v;
    }
  };

  // 'failed' just something mutable that won't be === anything else

  valObjectDef.coerceFunction(value, propMock, failed, opts);
  return out !== failed;
}
exports.validate = validate;

/***/ }),

/***/ 92596:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var timeFormat = (__webpack_require__(42696)/* .timeFormat */ .DC);
var isNumeric = __webpack_require__(10721);
var Loggers = __webpack_require__(48636);
var mod = (__webpack_require__(98953).mod);
var constants = __webpack_require__(63821);
var BADNUM = constants.BADNUM;
var ONEDAY = constants.ONEDAY;
var ONEHOUR = constants.ONEHOUR;
var ONEMIN = constants.ONEMIN;
var ONESEC = constants.ONESEC;
var EPOCHJD = constants.EPOCHJD;
var Registry = __webpack_require__(33626);
var utcFormat = (__webpack_require__(42696)/* .utcFormat */ .aL);
var DATETIME_REGEXP = /^\s*(-?\d\d\d\d|\d\d)(-(\d?\d)(-(\d?\d)([ Tt]([01]?\d|2[0-3])(:([0-5]\d)(:([0-5]\d(\.\d+)?))?(Z|z|[+\-]\d\d(:?\d\d)?)?)?)?)?)?\s*$/m;
// special regex for chinese calendars to support yyyy-mmi-dd etc for intercalary months
var DATETIME_REGEXP_CN = /^\s*(-?\d\d\d\d|\d\d)(-(\d?\di?)(-(\d?\d)([ Tt]([01]?\d|2[0-3])(:([0-5]\d)(:([0-5]\d(\.\d+)?))?(Z|z|[+\-]\d\d(:?\d\d)?)?)?)?)?)?\s*$/m;

// for 2-digit years, the first year we map them onto
var YFIRST = new Date().getFullYear() - 70;
function isWorldCalendar(calendar) {
  return calendar && Registry.componentsRegistry.calendars && typeof calendar === 'string' && calendar !== 'gregorian';
}

/*
 * dateTick0: get the canonical tick for this calendar
 *
 * integer weekdays : Saturday: 0, Sunday: 1, Monday: 2, etc.
 */
exports.dateTick0 = function (calendar, dayOfWeek) {
  var tick0 = _dateTick0(calendar, !!dayOfWeek);
  if (dayOfWeek < 2) return tick0;
  var v = exports.dateTime2ms(tick0, calendar);
  v += ONEDAY * (dayOfWeek - 1); // shift Sunday to Monday, etc.
  return exports.ms2DateTime(v, 0, calendar);
};

/*
 * _dateTick0: get the canonical tick for this calendar
 *
 * bool sunday is for week ticks, shift it to a Sunday.
 */
function _dateTick0(calendar, sunday) {
  if (isWorldCalendar(calendar)) {
    return sunday ? Registry.getComponentMethod('calendars', 'CANONICAL_SUNDAY')[calendar] : Registry.getComponentMethod('calendars', 'CANONICAL_TICK')[calendar];
  } else {
    return sunday ? '2000-01-02' : '2000-01-01';
  }
}

/*
 * dfltRange: for each calendar, give a valid default range
 */
exports.dfltRange = function (calendar) {
  if (isWorldCalendar(calendar)) {
    return Registry.getComponentMethod('calendars', 'DFLTRANGE')[calendar];
  } else {
    return ['2000-01-01', '2001-01-01'];
  }
};

// is an object a javascript date?
exports.isJSDate = function (v) {
  return typeof v === 'object' && v !== null && typeof v.getTime === 'function';
};

// The absolute limits of our date-time system
// This is a little weird: we use MIN_MS and MAX_MS in dateTime2ms
// but we use dateTime2ms to calculate them (after defining it!)
var MIN_MS, MAX_MS;

/**
 * dateTime2ms - turn a date object or string s into milliseconds
 * (relative to 1970-01-01, per javascript standard)
 * optional calendar (string) to use a non-gregorian calendar
 *
 * Returns BADNUM if it doesn't find a date
 *
 * strings should have the form:
 *
 *    -?YYYY-mm-dd<sep>HH:MM:SS.sss<tzInfo>?
 *
 * <sep>: space (our normal standard) or T or t (ISO-8601)
 * <tzInfo>: Z, z, [+\-]HH:?MM or [+\-]HH and we THROW IT AWAY
 * this format comes from https://tools.ietf.org/html/rfc3339#section-5.6
 * and 4.2.5.1 Difference between local time and UTC of day (ISO-8601)
 * but we allow it even with a space as the separator
 *
 * May truncate after any full field, and sss can be any length
 * even >3 digits, though javascript dates truncate to milliseconds,
 * we keep as much as javascript numeric precision can hold, but we only
 * report back up to 100 microsecond precision, because most dates support
 * this precision (close to 1970 support more, very far away support less)
 *
 * Expanded to support negative years to -9999 but you must always
 * give 4 digits, except for 2-digit positive years which we assume are
 * near the present time.
 * Note that we follow ISO 8601:2004: there *is* a year 0, which
 * is 1BC/BCE, and -1===2BC etc.
 *
 * World calendars: not all of these *have* agreed extensions to this full range,
 * if you have another calendar system but want a date range outside its validity,
 * you can use a gregorian date string prefixed with 'G' or 'g'.
 *
 * Where to cut off 2-digit years between 1900s and 2000s?
 * from https://docs.microsoft.com/en-us/office/troubleshoot/excel/two-digit-year-numbers#the-2029-rule:
 *   1930-2029 (the most retro of all...)
 * but in my mac chrome from eg. d=new Date(Date.parse('8/19/50')):
 *   1950-2049
 * by Java, from http://stackoverflow.com/questions/2024273/:
 *   now-80 - now+19
 * or FileMaker Pro, from
 *      https://fmhelp.filemaker.com/help/18/fmp/en/index.html#page/FMP_Help/dates-with-two-digit-years.html:
 *   now-70 - now+29
 * but python strptime etc, via
 *      http://docs.python.org/py3k/library/time.html:
 *   1969-2068 (super forward-looking, but static, not sliding!)
 *
 * lets go with now-70 to now+29, and if anyone runs into this problem
 * they can learn the hard way not to use 2-digit years, as no choice we
 * make now will cover all possibilities. mostly this will all be taken
 * care of in initial parsing, should only be an issue for hand-entered data
 * currently (2016) this range is:
 *   1946-2045
 */
exports.dateTime2ms = function (s, calendar) {
  // first check if s is a date object
  if (exports.isJSDate(s)) {
    // Convert to the UTC milliseconds that give the same
    // hours as this date has in the local timezone
    var tzOffset = s.getTimezoneOffset() * ONEMIN;
    var offsetTweak = (s.getUTCMinutes() - s.getMinutes()) * ONEMIN + (s.getUTCSeconds() - s.getSeconds()) * ONESEC + (s.getUTCMilliseconds() - s.getMilliseconds());
    if (offsetTweak) {
      var comb = 3 * ONEMIN;
      tzOffset = tzOffset - comb / 2 + mod(offsetTweak - tzOffset + comb / 2, comb);
    }
    s = Number(s) - tzOffset;
    if (s >= MIN_MS && s <= MAX_MS) return s;
    return BADNUM;
  }
  // otherwise only accept strings and numbers
  if (typeof s !== 'string' && typeof s !== 'number') return BADNUM;
  s = String(s);
  var isWorld = isWorldCalendar(calendar);

  // to handle out-of-range dates in international calendars, accept
  // 'G' as a prefix to force the built-in gregorian calendar.
  var s0 = s.charAt(0);
  if (isWorld && (s0 === 'G' || s0 === 'g')) {
    s = s.substr(1);
    calendar = '';
  }
  var isChinese = isWorld && calendar.substr(0, 7) === 'chinese';
  var match = s.match(isChinese ? DATETIME_REGEXP_CN : DATETIME_REGEXP);
  if (!match) return BADNUM;
  var y = match[1];
  var m = match[3] || '1';
  var d = Number(match[5] || 1);
  var H = Number(match[7] || 0);
  var M = Number(match[9] || 0);
  var S = Number(match[11] || 0);
  if (isWorld) {
    // disallow 2-digit years for world calendars
    if (y.length === 2) return BADNUM;
    y = Number(y);
    var cDate;
    try {
      var calInstance = Registry.getComponentMethod('calendars', 'getCal')(calendar);
      if (isChinese) {
        var isIntercalary = m.charAt(m.length - 1) === 'i';
        m = parseInt(m, 10);
        cDate = calInstance.newDate(y, calInstance.toMonthIndex(y, m, isIntercalary), d);
      } else {
        cDate = calInstance.newDate(y, Number(m), d);
      }
    } catch (e) {
      return BADNUM;
    } // Invalid ... date

    if (!cDate) return BADNUM;
    return (cDate.toJD() - EPOCHJD) * ONEDAY + H * ONEHOUR + M * ONEMIN + S * ONESEC;
  }
  if (y.length === 2) {
    y = (Number(y) + 2000 - YFIRST) % 100 + YFIRST;
  } else y = Number(y);

  // new Date uses months from 0; subtract 1 here just so we
  // don't have to do it again during the validity test below
  m -= 1;

  // javascript takes new Date(0..99,m,d) to mean 1900-1999, so
  // to support years 0-99 we need to use setFullYear explicitly
  // Note that 2000 is a leap year.
  var date = new Date(Date.UTC(2000, m, d, H, M));
  date.setUTCFullYear(y);
  if (date.getUTCMonth() !== m) return BADNUM;
  if (date.getUTCDate() !== d) return BADNUM;
  return date.getTime() + S * ONESEC;
};
MIN_MS = exports.MIN_MS = exports.dateTime2ms('-9999');
MAX_MS = exports.MAX_MS = exports.dateTime2ms('9999-12-31 23:59:59.9999');

// is string s a date? (see above)
exports.isDateTime = function (s, calendar) {
  return exports.dateTime2ms(s, calendar) !== BADNUM;
};

// pad a number with zeroes, to given # of digits before the decimal point
function lpad(val, digits) {
  return String(val + Math.pow(10, digits)).substr(1);
}

/**
 * Turn ms into string of the form YYYY-mm-dd HH:MM:SS.ssss
 * Crop any trailing zeros in time, except never stop right after hours
 * (we could choose to crop '-01' from date too but for now we always
 * show the whole date)
 * Optional range r is the data range that applies, also in ms.
 * If rng is big, the later parts of time will be omitted
 */
var NINETYDAYS = 90 * ONEDAY;
var THREEHOURS = 3 * ONEHOUR;
var FIVEMIN = 5 * ONEMIN;
exports.ms2DateTime = function (ms, r, calendar) {
  if (typeof ms !== 'number' || !(ms >= MIN_MS && ms <= MAX_MS)) return BADNUM;
  if (!r) r = 0;
  var msecTenths = Math.floor(mod(ms + 0.05, 1) * 10);
  var msRounded = Math.round(ms - msecTenths / 10);
  var dateStr, h, m, s, msec10, d;
  if (isWorldCalendar(calendar)) {
    var dateJD = Math.floor(msRounded / ONEDAY) + EPOCHJD;
    var timeMs = Math.floor(mod(ms, ONEDAY));
    try {
      dateStr = Registry.getComponentMethod('calendars', 'getCal')(calendar).fromJD(dateJD).formatDate('yyyy-mm-dd');
    } catch (e) {
      // invalid date in this calendar - fall back to Gyyyy-mm-dd
      dateStr = utcFormat('G%Y-%m-%d')(new Date(msRounded));
    }

    // yyyy does NOT guarantee 4-digit years. YYYY mostly does, but does
    // other things for a few calendars, so we can't trust it. Just pad
    // it manually (after the '-' if there is one)
    if (dateStr.charAt(0) === '-') {
      while (dateStr.length < 11) dateStr = '-0' + dateStr.substr(1);
    } else {
      while (dateStr.length < 10) dateStr = '0' + dateStr;
    }

    // TODO: if this is faster, we could use this block for extracting
    // the time components of regular gregorian too
    h = r < NINETYDAYS ? Math.floor(timeMs / ONEHOUR) : 0;
    m = r < NINETYDAYS ? Math.floor(timeMs % ONEHOUR / ONEMIN) : 0;
    s = r < THREEHOURS ? Math.floor(timeMs % ONEMIN / ONESEC) : 0;
    msec10 = r < FIVEMIN ? timeMs % ONESEC * 10 + msecTenths : 0;
  } else {
    d = new Date(msRounded);
    dateStr = utcFormat('%Y-%m-%d')(d);

    // <90 days: add hours and minutes - never *only* add hours
    h = r < NINETYDAYS ? d.getUTCHours() : 0;
    m = r < NINETYDAYS ? d.getUTCMinutes() : 0;
    // <3 hours: add seconds
    s = r < THREEHOURS ? d.getUTCSeconds() : 0;
    // <5 minutes: add ms (plus one extra digit, this is msec*10)
    msec10 = r < FIVEMIN ? d.getUTCMilliseconds() * 10 + msecTenths : 0;
  }
  return includeTime(dateStr, h, m, s, msec10);
};

// For converting old-style milliseconds to date strings,
// we use the local timezone rather than UTC like we use
// everywhere else, both for backward compatibility and
// because that's how people mostly use javasript date objects.
// Clip one extra day off our date range though so we can't get
// thrown beyond the range by the timezone shift.
exports.ms2DateTimeLocal = function (ms) {
  if (!(ms >= MIN_MS + ONEDAY && ms <= MAX_MS - ONEDAY)) return BADNUM;
  var msecTenths = Math.floor(mod(ms + 0.05, 1) * 10);
  var d = new Date(Math.round(ms - msecTenths / 10));
  var dateStr = timeFormat('%Y-%m-%d')(d);
  var h = d.getHours();
  var m = d.getMinutes();
  var s = d.getSeconds();
  var msec10 = d.getUTCMilliseconds() * 10 + msecTenths;
  return includeTime(dateStr, h, m, s, msec10);
};
function includeTime(dateStr, h, m, s, msec10) {
  // include each part that has nonzero data in or after it
  if (h || m || s || msec10) {
    dateStr += ' ' + lpad(h, 2) + ':' + lpad(m, 2);
    if (s || msec10) {
      dateStr += ':' + lpad(s, 2);
      if (msec10) {
        var digits = 4;
        while (msec10 % 10 === 0) {
          digits -= 1;
          msec10 /= 10;
        }
        dateStr += '.' + lpad(msec10, digits);
      }
    }
  }
  return dateStr;
}

// normalize date format to date string, in case it starts as
// a Date object or milliseconds
// optional dflt is the return value if cleaning fails
exports.cleanDate = function (v, dflt, calendar) {
  // let us use cleanDate to provide a missing default without an error
  if (v === BADNUM) return dflt;
  if (exports.isJSDate(v) || typeof v === 'number' && isFinite(v)) {
    // do not allow milliseconds (old) or jsdate objects (inherently
    // described as gregorian dates) with world calendars
    if (isWorldCalendar(calendar)) {
      Loggers.error('JS Dates and milliseconds are incompatible with world calendars', v);
      return dflt;
    }

    // NOTE: if someone puts in a year as a number rather than a string,
    // this will mistakenly convert it thinking it's milliseconds from 1970
    // that is: '2012' -> Jan. 1, 2012, but 2012 -> 2012 epoch milliseconds
    v = exports.ms2DateTimeLocal(+v);
    if (!v && dflt !== undefined) return dflt;
  } else if (!exports.isDateTime(v, calendar)) {
    Loggers.error('unrecognized date', v);
    return dflt;
  }
  return v;
};

/*
 *  Date formatting for ticks and hovertext
 */

/*
 * modDateFormat: Support world calendars, and add two items to
 * d3's vocabulary:
 * %{n}f where n is the max number of digits of fractional seconds
 * %h formats: half of the year as a decimal number [1,2]
 */
var fracMatch = /%\d?f/g;
var halfYearMatch = /%h/g;
var quarterToHalfYear = {
  1: '1',
  2: '1',
  3: '2',
  4: '2'
};
function modDateFormat(fmt, x, formatter, calendar) {
  fmt = fmt.replace(fracMatch, function (match) {
    var digits = Math.min(+match.charAt(1) || 6, 6);
    var fracSecs = (x / 1000 % 1 + 2).toFixed(digits).substr(2).replace(/0+$/, '') || '0';
    return fracSecs;
  });
  var d = new Date(Math.floor(x + 0.05));
  fmt = fmt.replace(halfYearMatch, function () {
    return quarterToHalfYear[formatter('%q')(d)];
  });
  if (isWorldCalendar(calendar)) {
    try {
      fmt = Registry.getComponentMethod('calendars', 'worldCalFmt')(fmt, x, calendar);
    } catch (e) {
      return 'Invalid';
    }
  }
  return formatter(fmt)(d);
}

/*
 * formatTime: create a time string from:
 *   x: milliseconds
 *   tr: tickround ('M', 'S', or # digits)
 * only supports UTC times (where every day is 24 hours and 0 is at midnight)
 */
var MAXSECONDS = [59, 59.9, 59.99, 59.999, 59.9999];
function formatTime(x, tr) {
  var timePart = mod(x + 0.05, ONEDAY);
  var timeStr = lpad(Math.floor(timePart / ONEHOUR), 2) + ':' + lpad(mod(Math.floor(timePart / ONEMIN), 60), 2);
  if (tr !== 'M') {
    if (!isNumeric(tr)) tr = 0; // should only be 'S'

    /*
     * this is a weird one - and shouldn't come up unless people
     * monkey with tick0 in weird ways, but we need to do something!
     * IN PARTICULAR we had better not display garbage (see below)
     * for numbers we always round to the nearest increment of the
     * precision we're showing, and this seems like the right way to
     * handle seconds and milliseconds, as they have a decimal point
     * and people will interpret that to mean rounding like numbers.
     * but for larger increments we floor the value: it's always
     * 2013 until the ball drops on the new year. We could argue about
     * which field it is where we start rounding (should 12:08:59
     * round to 12:09 if we're stopping at minutes?) but for now I'll
     * say we round seconds but floor everything else. BUT that means
     * we need to never round up to 60 seconds, ie 23:59:60
     */
    var sec = Math.min(mod(x / ONESEC, 60), MAXSECONDS[tr]);
    var secStr = (100 + sec).toFixed(tr).substr(1);
    if (tr > 0) {
      secStr = secStr.replace(/0+$/, '').replace(/[\.]$/, '');
    }
    timeStr += ':' + secStr;
  }
  return timeStr;
}

/*
 * formatDate: turn a date into tick or hover label text.
 *
 *   x: milliseconds, the value to convert
 *   fmt: optional, an explicit format string (d3 format, even for world calendars)
 *   tr: tickround ('y', 'm', 'd', 'M', 'S', or # digits)
 *      used if no explicit fmt is provided
 *   formatter: locale-aware d3 date formatter for standard gregorian calendars
 *      should be the result of exports.getD3DateFormat(gd)
 *   calendar: optional string, the world calendar system to use
 *
 * returns the date/time as a string, potentially with the leading portion
 * on a separate line (after '\n')
 * Note that this means if you provide an explicit format which includes '\n'
 * the axis may choose to strip things after it when they don't change from
 * one tick to the next (as it does with automatic formatting)
 */
exports.formatDate = function (x, fmt, tr, formatter, calendar, extraFormat) {
  calendar = isWorldCalendar(calendar) && calendar;
  if (!fmt) {
    if (tr === 'y') fmt = extraFormat.year;else if (tr === 'm') fmt = extraFormat.month;else if (tr === 'd') {
      fmt = extraFormat.dayMonth + '\n' + extraFormat.year;
    } else {
      return formatTime(x, tr) + '\n' + modDateFormat(extraFormat.dayMonthYear, x, formatter, calendar);
    }
  }
  return modDateFormat(fmt, x, formatter, calendar);
};

/*
 * incrementMonth: make a new milliseconds value from the given one,
 * having changed the month
 *
 * special case for world calendars: multiples of 12 are treated as years,
 * even for calendar systems that don't have (always or ever) 12 months/year
 * TODO: perhaps we need a different code for year increments to support this?
 *
 * ms (number): the initial millisecond value
 * dMonth (int): the (signed) number of months to shift
 * calendar (string): the calendar system to use
 *
 * changing month does not (and CANNOT) always preserve day, since
 * months have different lengths. The worst example of this is:
 *   d = new Date(1970,0,31); d.setMonth(1) -> Feb 31 turns into Mar 3
 *
 * But we want to be able to iterate over the last day of each month,
 * regardless of what its number is.
 * So shift 3 days forward, THEN set the new month, then unshift:
 *   1/31 -> 2/28 (or 29) -> 3/31 -> 4/30 -> ...
 *
 * Note that odd behavior still exists if you start from the 26th-28th:
 *   1/28 -> 2/28 -> 3/31
 * but at least you can't shift any dates into the wrong month,
 * and ticks on these days incrementing by month would be very unusual
 */
var THREEDAYS = 3 * ONEDAY;
exports.incrementMonth = function (ms, dMonth, calendar) {
  calendar = isWorldCalendar(calendar) && calendar;

  // pull time out and operate on pure dates, then add time back at the end
  // this gives maximum precision - not that we *normally* care if we're
  // incrementing by month, but better to be safe!
  var timeMs = mod(ms, ONEDAY);
  ms = Math.round(ms - timeMs);
  if (calendar) {
    try {
      var dateJD = Math.round(ms / ONEDAY) + EPOCHJD;
      var calInstance = Registry.getComponentMethod('calendars', 'getCal')(calendar);
      var cDate = calInstance.fromJD(dateJD);
      if (dMonth % 12) calInstance.add(cDate, dMonth, 'm');else calInstance.add(cDate, dMonth / 12, 'y');
      return (cDate.toJD() - EPOCHJD) * ONEDAY + timeMs;
    } catch (e) {
      Loggers.error('invalid ms ' + ms + ' in calendar ' + calendar);
      // then keep going in gregorian even though the result will be 'Invalid'
    }
  }
  var y = new Date(ms + THREEDAYS);
  return y.setUTCMonth(y.getUTCMonth() + dMonth) + timeMs - THREEDAYS;
};

/*
 * findExactDates: what fraction of data is exact days, months, or years?
 *
 * data: array of millisecond values
 * calendar (string) the calendar to test against
 */
exports.findExactDates = function (data, calendar) {
  var exactYears = 0;
  var exactMonths = 0;
  var exactDays = 0;
  var blankCount = 0;
  var d;
  var di;
  var calInstance = isWorldCalendar(calendar) && Registry.getComponentMethod('calendars', 'getCal')(calendar);
  for (var i = 0; i < data.length; i++) {
    di = data[i];

    // not date data at all
    if (!isNumeric(di)) {
      blankCount++;
      continue;
    }

    // not an exact date
    if (di % ONEDAY) continue;
    if (calInstance) {
      try {
        d = calInstance.fromJD(di / ONEDAY + EPOCHJD);
        if (d.day() === 1) {
          if (d.month() === 1) exactYears++;else exactMonths++;
        } else exactDays++;
      } catch (e) {
        // invalid date in this calendar - ignore it here.
      }
    } else {
      d = new Date(di);
      if (d.getUTCDate() === 1) {
        if (d.getUTCMonth() === 0) exactYears++;else exactMonths++;
      } else exactDays++;
    }
  }
  exactMonths += exactYears;
  exactDays += exactMonths;
  var dataCount = data.length - blankCount;
  return {
    exactYears: exactYears / dataCount,
    exactMonths: exactMonths / dataCount,
    exactDays: exactDays / dataCount
  };
};

/***/ }),

/***/ 95425:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var loggers = __webpack_require__(48636);
var matrix = __webpack_require__(15236);
var mat4X4 = __webpack_require__(11191);

/**
 * Allow referencing a graph DOM element either directly
 * or by its id string
 *
 * @param {HTMLDivElement|string} gd: a graph element or its id
 *
 * @returns {HTMLDivElement} the DOM element of the graph
 */
function getGraphDiv(gd) {
  var gdElement;
  if (typeof gd === 'string') {
    gdElement = document.getElementById(gd);
    if (gdElement === null) {
      throw new Error('No DOM element with id \'' + gd + '\' exists on the page.');
    }
    return gdElement;
  } else if (gd === null || gd === undefined) {
    throw new Error('DOM element provided is null or undefined');
  }

  // otherwise assume that gd is a DOM element
  return gd;
}
function isPlotDiv(el) {
  var el3 = d3.select(el);
  return el3.node() instanceof HTMLElement && el3.size() && el3.classed('js-plotly-plot');
}
function removeElement(el) {
  var elParent = el && el.parentNode;
  if (elParent) elParent.removeChild(el);
}

/**
 * for dynamically adding style rules
 * makes one stylesheet that contains all rules added
 * by all calls to this function
 */
function addStyleRule(selector, styleString) {
  addRelatedStyleRule('global', selector, styleString);
}

/**
 * for dynamically adding style rules
 * to a stylesheet uniquely identified by a uid
 */
function addRelatedStyleRule(uid, selector, styleString) {
  var id = 'plotly.js-style-' + uid;
  var style = document.getElementById(id);
  if (!style) {
    style = document.createElement('style');
    style.setAttribute('id', id);
    // WebKit hack :(
    style.appendChild(document.createTextNode(''));
    document.head.appendChild(style);
  }
  var styleSheet = style.sheet;
  if (styleSheet.insertRule) {
    styleSheet.insertRule(selector + '{' + styleString + '}', 0);
  } else if (styleSheet.addRule) {
    styleSheet.addRule(selector, styleString, 0);
  } else loggers.warn('addStyleRule failed');
}

/**
 * to remove from the page a stylesheet identified by a given uid
 */
function deleteRelatedStyleRule(uid) {
  var id = 'plotly.js-style-' + uid;
  var style = document.getElementById(id);
  if (style) removeElement(style);
}
function getFullTransformMatrix(element) {
  var allElements = getElementAndAncestors(element);
  // the identity matrix
  var out = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
  allElements.forEach(function (e) {
    var t = getElementTransformMatrix(e);
    if (t) {
      var m = matrix.convertCssMatrix(t);
      out = mat4X4.multiply(out, out, m);
    }
  });
  return out;
}

/**
 * extracts and parses the 2d css style transform matrix from some element
 */
function getElementTransformMatrix(element) {
  var style = window.getComputedStyle(element, null);
  var transform = style.getPropertyValue('-webkit-transform') || style.getPropertyValue('-moz-transform') || style.getPropertyValue('-ms-transform') || style.getPropertyValue('-o-transform') || style.getPropertyValue('transform');
  if (transform === 'none') return null;
  // the transform is a string in the form of matrix(a, b, ...) or matrix3d(...)
  return transform.replace('matrix', '').replace('3d', '').slice(1, -1).split(',').map(function (n) {
    return +n;
  });
}
/**
 * retrieve all DOM elements that are ancestors of the specified one (including itself)
 */
function getElementAndAncestors(element) {
  var allElements = [];
  while (isTransformableElement(element)) {
    allElements.push(element);
    element = element.parentNode;
    if (typeof ShadowRoot === 'function' && element instanceof ShadowRoot) {
      element = element.host;
    }
  }
  return allElements;
}
function isTransformableElement(element) {
  return element && (element instanceof Element || element instanceof HTMLElement);
}
function equalDomRects(a, b) {
  return a && b && a.top === b.top && a.left === b.left && a.right === b.right && a.bottom === b.bottom;
}
module.exports = {
  getGraphDiv: getGraphDiv,
  isPlotDiv: isPlotDiv,
  removeElement: removeElement,
  addStyleRule: addStyleRule,
  addRelatedStyleRule: addRelatedStyleRule,
  deleteRelatedStyleRule: deleteRelatedStyleRule,
  getFullTransformMatrix: getFullTransformMatrix,
  getElementTransformMatrix: getElementTransformMatrix,
  getElementAndAncestors: getElementAndAncestors,
  equalDomRects: equalDomRects
};

/***/ }),

/***/ 68596:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


/* global jQuery:false */
var EventEmitter = (__webpack_require__(7683).EventEmitter);
var Events = {
  init: function (plotObj) {
    /*
     * If we have already instantiated an emitter for this plot
     * return early.
     */
    if (plotObj._ev instanceof EventEmitter) return plotObj;
    var ev = new EventEmitter();
    var internalEv = new EventEmitter();

    /*
     * Assign to plot._ev while we still live in a land
     * where plot is a DOM element with stuff attached to it.
     * In the future we can make plot the event emitter itself.
     */
    plotObj._ev = ev;

    /*
     * Create a second event handler that will manage events *internally*.
     * This allows parts of plotly to respond to thing like relayout without
     * having to use the user-facing event handler. They cannot peacefully
     * coexist on the same handler because a user invoking
     * plotObj.removeAllListeners() would detach internal events, breaking
     * plotly.
     */
    plotObj._internalEv = internalEv;

    /*
     * Assign bound methods from the ev to the plot object. These methods
     * will reference the 'this' of plot._ev even though they are methods
     * of plot. This will keep the event machinery away from the plot object
     * which currently is often a DOM element but presents an API that will
     * continue to function when plot becomes an emitter. Not all EventEmitter
     * methods have been bound to `plot` as some do not currently add value to
     * the Plotly event API.
     */
    plotObj.on = ev.on.bind(ev);
    plotObj.once = ev.once.bind(ev);
    plotObj.removeListener = ev.removeListener.bind(ev);
    plotObj.removeAllListeners = ev.removeAllListeners.bind(ev);

    /*
     * Create functions for managing internal events. These are *only* triggered
     * by the mirroring of external events via the emit function.
     */
    plotObj._internalOn = internalEv.on.bind(internalEv);
    plotObj._internalOnce = internalEv.once.bind(internalEv);
    plotObj._removeInternalListener = internalEv.removeListener.bind(internalEv);
    plotObj._removeAllInternalListeners = internalEv.removeAllListeners.bind(internalEv);

    /*
     * We must wrap emit to continue to support JQuery events. The idea
     * is to check to see if the user is using JQuery events, if they are
     * we emit JQuery events to trigger user handlers as well as the EventEmitter
     * events.
     */
    plotObj.emit = function (event, data) {
      if (typeof jQuery !== 'undefined') {
        jQuery(plotObj).trigger(event, data);
      }
      ev.emit(event, data);
      internalEv.emit(event, data);
    };
    return plotObj;
  },
  /*
   * This function behaves like jQuery's triggerHandler. It calls
   * all handlers for a particular event and returns the return value
   * of the LAST handler. This function also triggers jQuery's
   * triggerHandler for backwards compatibility.
   */
  triggerHandler: function (plotObj, event, data) {
    var jQueryHandlerValue;
    var nodeEventHandlerValue;

    /*
     * If jQuery exists run all its handlers for this event and
     * collect the return value of the LAST handler function
     */
    if (typeof jQuery !== 'undefined') {
      jQueryHandlerValue = jQuery(plotObj).triggerHandler(event, data);
    }

    /*
     * Now run all the node style event handlers
     */
    var ev = plotObj._ev;
    if (!ev) return jQueryHandlerValue;
    var handlers = ev._events[event];
    if (!handlers) return jQueryHandlerValue;

    // making sure 'this' is the EventEmitter instance
    function apply(handler) {
      // The 'once' case, we can't just call handler() as we need
      // the return value here. So,
      // - remove handler
      // - call listener and grab return value!
      // - stash 'fired' key to not call handler twice
      if (handler.listener) {
        ev.removeListener(event, handler.listener);
        if (!handler.fired) {
          handler.fired = true;
          return handler.listener.apply(ev, [data]);
        }
      } else {
        return handler.apply(ev, [data]);
      }
    }

    // handlers can be function or an array of functions
    handlers = Array.isArray(handlers) ? handlers : [handlers];
    var i;
    for (i = 0; i < handlers.length - 1; i++) {
      apply(handlers[i]);
    }
    // now call the final handler and collect its value
    nodeEventHandlerValue = apply(handlers[i]);

    /*
     * Return either the jQuery handler value if it exists or the
     * nodeEventHandler value. jQuery event value supersedes nodejs
     * events for backwards compatibility reasons.
     */
    return jQueryHandlerValue !== undefined ? jQueryHandlerValue : nodeEventHandlerValue;
  },
  purge: function (plotObj) {
    delete plotObj._ev;
    delete plotObj.on;
    delete plotObj.once;
    delete plotObj.removeListener;
    delete plotObj.removeAllListeners;
    delete plotObj.emit;
    delete plotObj._ev;
    delete plotObj._internalEv;
    delete plotObj._internalOn;
    delete plotObj._internalOnce;
    delete plotObj._removeInternalListener;
    delete plotObj._removeAllInternalListeners;
    return plotObj;
  }
};
module.exports = Events;

/***/ }),

/***/ 93049:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var isPlainObject = __webpack_require__(56174);
var isArray = Array.isArray;
function primitivesLoopSplice(source, target) {
  var i, value;
  for (i = 0; i < source.length; i++) {
    value = source[i];
    if (value !== null && typeof value === 'object') {
      return false;
    }
    if (value !== void 0) {
      target[i] = value;
    }
  }
  return true;
}
exports.extendFlat = function () {
  return _extend(arguments, false, false, false);
};
exports.extendDeep = function () {
  return _extend(arguments, true, false, false);
};
exports.extendDeepAll = function () {
  return _extend(arguments, true, true, false);
};
exports.extendDeepNoArrays = function () {
  return _extend(arguments, true, false, true);
};

/*
 * Inspired by https://github.com/justmoon/node-extend/blob/master/index.js
 * All credit to the jQuery authors for perfecting this amazing utility.
 *
 * API difference with jQuery version:
 * - No optional boolean (true -> deep extend) first argument,
 *   use `extendFlat` for first-level only extend and
 *   use `extendDeep` for a deep extend.
 *
 * Other differences with jQuery version:
 * - Uses a modern (and faster) isPlainObject routine.
 * - Expected to work with object {} and array [] arguments only.
 * - Does not check for circular structure.
 *   FYI: jQuery only does a check across one level.
 *   Warning: this might result in infinite loops.
 *
 */
function _extend(inputs, isDeep, keepAllKeys, noArrayCopies) {
  var target = inputs[0];
  var length = inputs.length;
  var input, key, src, copy, copyIsArray, clone, allPrimitives;

  // TODO does this do the right thing for typed arrays?

  if (length === 2 && isArray(target) && isArray(inputs[1]) && target.length === 0) {
    allPrimitives = primitivesLoopSplice(inputs[1], target);
    if (allPrimitives) {
      return target;
    } else {
      target.splice(0, target.length); // reset target and continue to next block
    }
  }
  for (var i = 1; i < length; i++) {
    input = inputs[i];
    for (key in input) {
      src = target[key];
      copy = input[key];
      if (noArrayCopies && isArray(copy)) {
        // Stop early and just transfer the array if array copies are disallowed:

        target[key] = copy;
      } else if (isDeep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
        // recurse if we're merging plain objects or arrays

        if (copyIsArray) {
          copyIsArray = false;
          clone = src && isArray(src) ? src : [];
        } else {
          clone = src && isPlainObject(src) ? src : {};
        }

        // never move original objects, clone them
        target[key] = _extend([clone, copy], isDeep, keepAllKeys, noArrayCopies);
      } else if (typeof copy !== 'undefined' || keepAllKeys) {
        // don't bring in undefined values, except for extendDeepAll

        target[key] = copy;
      }
    }
  }
  return target;
}

/***/ }),

/***/ 48965:
/***/ (function(module) {

"use strict";


/**
 * Return news array containing only the unique items
 * found in input array.
 *
 * IMPORTANT: Note that items are considered unique
 * if `String({})` is unique. For example;
 *
 *  Lib.filterUnique([ { a: 1 }, { b: 2 } ])
 *
 *  returns [{ a: 1 }]
 *
 * and
 *
 *  Lib.filterUnique([ '1', 1 ])
 *
 *  returns ['1']
 *
 *
 * @param {array} array base array
 * @return {array} new filtered array
 */
module.exports = function filterUnique(array) {
  var seen = {};
  var out = [];
  var j = 0;
  for (var i = 0; i < array.length; i++) {
    var item = array[i];
    if (seen[item] !== 1) {
      seen[item] = 1;
      out[j++] = item;
    }
  }
  return out;
};

/***/ }),

/***/ 78926:
/***/ (function(module) {

"use strict";


/** Filter out object items with visible !== true
 *  insider array container.
 *
 *  @param {array of objects} container
 *  @return {array of objects} of length <= container
 *
 */
module.exports = function filterVisible(container) {
  var filterFn = isCalcData(container) ? calcDataFilter : baseFilter;
  var out = [];
  for (var i = 0; i < container.length; i++) {
    var item = container[i];
    if (filterFn(item)) out.push(item);
  }
  return out;
};
function baseFilter(item) {
  return item.visible === true;
}
function calcDataFilter(item) {
  var trace = item[0].trace;
  return trace.visible === true && trace._length !== 0;
}
function isCalcData(cont) {
  return Array.isArray(cont) && Array.isArray(cont[0]) && cont[0][0] && cont[0][0].trace;
}

/***/ }),

/***/ 3994:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var countryRegex = __webpack_require__(78171);
var {
  area: turfArea
} = __webpack_require__(61990);
var {
  centroid: turfCentroid
} = __webpack_require__(30035);
var {
  bbox: turfBbox
} = __webpack_require__(25368);
var identity = __webpack_require__(29527);
var loggers = __webpack_require__(48636);
var isPlainObject = __webpack_require__(56174);
var nestedProperty = __webpack_require__(35632);
var polygon = __webpack_require__(80899);

// make list of all country iso3 ids from at runtime
var countryIds = Object.keys(countryRegex);
var locationmodeToIdFinder = {
  'ISO-3': identity,
  'USA-states': identity,
  'country names': countryNameToISO3
};
function countryNameToISO3(countryName) {
  for (var i = 0; i < countryIds.length; i++) {
    var iso3 = countryIds[i];
    var regex = new RegExp(countryRegex[iso3]);
    if (regex.test(countryName.trim().toLowerCase())) return iso3;
  }
  loggers.log('Unrecognized country name: ' + countryName + '.');
  return false;
}
function locationToFeature(locationmode, location, features) {
  if (!location || typeof location !== 'string') return false;
  var locationId = locationmodeToIdFinder[locationmode](location);
  var filteredFeatures;
  var f, i;
  if (locationId) {
    if (locationmode === 'USA-states') {
      // Filter out features out in USA
      //
      // This is important as the Natural Earth files
      // include state/provinces from USA, Canada, Australia and Brazil
      // which have some overlay in their two-letter ids. For example,
      // 'WA' is used for both Washington state and Western Australia.
      filteredFeatures = [];
      for (i = 0; i < features.length; i++) {
        f = features[i];
        if (f.properties && f.properties.gu && f.properties.gu === 'USA') {
          filteredFeatures.push(f);
        }
      }
    } else {
      filteredFeatures = features;
    }
    for (i = 0; i < filteredFeatures.length; i++) {
      f = filteredFeatures[i];
      if (f.id === locationId) return f;
    }
    loggers.log(['Location with id', locationId, 'does not have a matching topojson feature at this resolution.'].join(' '));
  }
  return false;
}
function feature2polygons(feature) {
  var geometry = feature.geometry;
  var coords = geometry.coordinates;
  var loc = feature.id;
  var polygons = [];
  var appendPolygon, j, k, m;
  function doesCrossAntiMerdian(pts) {
    for (var l = 0; l < pts.length - 1; l++) {
      if (pts[l][0] > 0 && pts[l + 1][0] < 0) return l;
    }
    return null;
  }
  if (loc === 'RUS' || loc === 'FJI') {
    // Russia and Fiji have landmasses that cross the antimeridian,
    // we need to add +360 to their longitude coordinates, so that
    // polygon 'contains' doesn't get confused when crossing the antimeridian.
    //
    // Note that other countries have polygons on either side of the antimeridian
    // (e.g. some Aleutian island for the USA), but those don't confuse
    // the 'contains' method; these are skipped here.
    appendPolygon = function (_pts) {
      var pts;
      if (doesCrossAntiMerdian(_pts) === null) {
        pts = _pts;
      } else {
        pts = new Array(_pts.length);
        for (m = 0; m < _pts.length; m++) {
          // do not mutate calcdata[i][j].geojson !!
          pts[m] = [_pts[m][0] < 0 ? _pts[m][0] + 360 : _pts[m][0], _pts[m][1]];
        }
      }
      polygons.push(polygon.tester(pts));
    };
  } else if (loc === 'ATA') {
    // Antarctica has a landmass that wraps around every longitudes which
    // confuses the 'contains' methods.
    appendPolygon = function (pts) {
      var crossAntiMeridianIndex = doesCrossAntiMerdian(pts);

      // polygon that do not cross anti-meridian need no special handling
      if (crossAntiMeridianIndex === null) {
        return polygons.push(polygon.tester(pts));
      }

      // stitch polygon by adding pt over South Pole,
      // so that it covers the projected region covers all latitudes
      //
      // Note that the algorithm below only works for polygons that
      // start and end on longitude -180 (like the ones built by
      // https://github.com/etpinard/sane-topojson).
      var stitch = new Array(pts.length + 1);
      var si = 0;
      for (m = 0; m < pts.length; m++) {
        if (m > crossAntiMeridianIndex) {
          stitch[si++] = [pts[m][0] + 360, pts[m][1]];
        } else if (m === crossAntiMeridianIndex) {
          stitch[si++] = pts[m];
          stitch[si++] = [pts[m][0], -90];
        } else {
          stitch[si++] = pts[m];
        }
      }

      // polygon.tester by default appends pt[0] to the points list,
      // we must remove it here, to avoid a jump in longitude from 180 to -180,
      // that would confuse the 'contains' method
      var tester = polygon.tester(stitch);
      tester.pts.pop();
      polygons.push(tester);
    };
  } else {
    // otherwise using same array ref is fine
    appendPolygon = function (pts) {
      polygons.push(polygon.tester(pts));
    };
  }
  switch (geometry.type) {
    case 'MultiPolygon':
      for (j = 0; j < coords.length; j++) {
        for (k = 0; k < coords[j].length; k++) {
          appendPolygon(coords[j][k]);
        }
      }
      break;
    case 'Polygon':
      for (j = 0; j < coords.length; j++) {
        appendPolygon(coords[j]);
      }
      break;
  }
  return polygons;
}
function getTraceGeojson(trace) {
  var g = trace.geojson;
  var PlotlyGeoAssets = window.PlotlyGeoAssets || {};
  var geojsonIn = typeof g === 'string' ? PlotlyGeoAssets[g] : g;

  // This should not happen, but just in case something goes
  // really wrong when fetching the GeoJSON
  if (!isPlainObject(geojsonIn)) {
    loggers.error('Oops ... something went wrong when fetching ' + g);
    return false;
  }
  return geojsonIn;
}
function extractTraceFeature(calcTrace) {
  var trace = calcTrace[0].trace;
  var geojsonIn = getTraceGeojson(trace);
  if (!geojsonIn) return false;
  var lookup = {};
  var featuresOut = [];
  var i;
  for (i = 0; i < trace._length; i++) {
    var cdi = calcTrace[i];
    if (cdi.loc || cdi.loc === 0) {
      lookup[cdi.loc] = cdi;
    }
  }
  function appendFeature(fIn) {
    var id = nestedProperty(fIn, trace.featureidkey || 'id').get();
    var cdi = lookup[id];
    if (cdi) {
      var geometry = fIn.geometry;
      if (geometry.type === 'Polygon' || geometry.type === 'MultiPolygon') {
        var fOut = {
          type: 'Feature',
          id: id,
          geometry: geometry,
          properties: {}
        };

        // Compute centroid, add it to the properties
        if (fOut.geometry.coordinates.length > 0) {
          fOut.properties.ct = findCentroid(fOut);
        } else {
          fOut.properties.ct = [NaN, NaN];
        }

        // Mutate in in/out features into calcdata
        cdi.fIn = fIn;
        cdi.fOut = fOut;
        featuresOut.push(fOut);
      } else {
        loggers.log(['Location', cdi.loc, 'does not have a valid GeoJSON geometry.', 'Traces with locationmode *geojson-id* only support', '*Polygon* and *MultiPolygon* geometries.'].join(' '));
      }
    }

    // remove key from lookup, so that we can track (if any)
    // the locations that did not have a corresponding GeoJSON feature
    delete lookup[id];
  }
  switch (geojsonIn.type) {
    case 'FeatureCollection':
      var featuresIn = geojsonIn.features;
      for (i = 0; i < featuresIn.length; i++) {
        appendFeature(featuresIn[i]);
      }
      break;
    case 'Feature':
      appendFeature(geojsonIn);
      break;
    default:
      loggers.warn(['Invalid GeoJSON type', (geojsonIn.type || 'none') + '.', 'Traces with locationmode *geojson-id* only support', '*FeatureCollection* and *Feature* types.'].join(' '));
      return false;
  }
  for (var loc in lookup) {
    loggers.log(['Location *' + loc + '*', 'does not have a matching feature with id-key', '*' + trace.featureidkey + '*.'].join(' '));
  }
  return featuresOut;
}

// TODO this find the centroid of the polygon of maxArea
// (just like we currently do for geo choropleth polygons),
// maybe instead it would make more sense to compute the centroid
// of each polygon and consider those on hover/select
function findCentroid(feature) {
  var geometry = feature.geometry;
  var poly;
  if (geometry.type === 'MultiPolygon') {
    var coords = geometry.coordinates;
    var maxArea = 0;
    for (var i = 0; i < coords.length; i++) {
      var polyi = {
        type: 'Polygon',
        coordinates: coords[i]
      };
      var area = turfArea(polyi);
      if (area > maxArea) {
        maxArea = area;
        poly = polyi;
      }
    }
  } else {
    poly = geometry;
  }
  return turfCentroid(poly).geometry.coordinates;
}
function fetchTraceGeoData(calcData) {
  var PlotlyGeoAssets = window.PlotlyGeoAssets || {};
  var promises = [];
  function fetch(url) {
    return new Promise(function (resolve, reject) {
      d3.json(url, function (err, d) {
        if (err) {
          delete PlotlyGeoAssets[url];
          var msg = err.status === 404 ? 'GeoJSON at URL "' + url + '" does not exist.' : 'Unexpected error while fetching from ' + url;
          return reject(new Error(msg));
        }
        PlotlyGeoAssets[url] = d;
        return resolve(d);
      });
    });
  }
  function wait(url) {
    return new Promise(function (resolve, reject) {
      var cnt = 0;
      var interval = setInterval(function () {
        if (PlotlyGeoAssets[url] && PlotlyGeoAssets[url] !== 'pending') {
          clearInterval(interval);
          return resolve(PlotlyGeoAssets[url]);
        }
        if (cnt > 100) {
          clearInterval(interval);
          return reject('Unexpected error while fetching from ' + url);
        }
        cnt++;
      }, 50);
    });
  }
  for (var i = 0; i < calcData.length; i++) {
    var trace = calcData[i][0].trace;
    var url = trace.geojson;
    if (typeof url === 'string') {
      if (!PlotlyGeoAssets[url]) {
        PlotlyGeoAssets[url] = 'pending';
        promises.push(fetch(url));
      } else if (PlotlyGeoAssets[url] === 'pending') {
        promises.push(wait(url));
      }
    }
  }
  return promises;
}

// TODO `turf/bbox` gives wrong result when the input feature/geometry
// crosses the anti-meridian. We should try to implement our own bbox logic.
function computeBbox(d) {
  return turfBbox(d);
}
module.exports = {
  locationToFeature: locationToFeature,
  feature2polygons: feature2polygons,
  getTraceGeojson: getTraceGeojson,
  extractTraceFeature: extractTraceFeature,
  fetchTraceGeoData: fetchTraceGeoData,
  computeBbox: computeBbox
};

/***/ }),

/***/ 39532:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var BADNUM = (__webpack_require__(63821).BADNUM);

/**
 * Convert calcTrace to GeoJSON 'MultiLineString' coordinate arrays
 *
 * @param {object} calcTrace
 *  gd.calcdata item.
 *  Note that calcTrace[i].lonlat is assumed to be defined
 *
 * @return {array}
 *  return line coords array (or array of arrays)
 *
 */
exports.calcTraceToLineCoords = function (calcTrace) {
  var trace = calcTrace[0].trace;
  var connectgaps = trace.connectgaps;
  var coords = [];
  var lineString = [];
  for (var i = 0; i < calcTrace.length; i++) {
    var calcPt = calcTrace[i];
    var lonlat = calcPt.lonlat;
    if (lonlat[0] !== BADNUM) {
      lineString.push(lonlat);
    } else if (!connectgaps && lineString.length > 0) {
      coords.push(lineString);
      lineString = [];
    }
  }
  if (lineString.length > 0) {
    coords.push(lineString);
  }
  return coords;
};

/**
 * Make line ('LineString' or 'MultiLineString') GeoJSON
 *
 * @param {array} coords
 *  results form calcTraceToLineCoords
 * @return {object} out
 *  GeoJSON object
 *
 */
exports.makeLine = function (coords) {
  if (coords.length === 1) {
    return {
      type: 'LineString',
      coordinates: coords[0]
    };
  } else {
    return {
      type: 'MultiLineString',
      coordinates: coords
    };
  }
};

/**
 * Make polygon ('Polygon' or 'MultiPolygon') GeoJSON
 *
 * @param {array} coords
 *  results form calcTraceToLineCoords
 * @return {object} out
 *  GeoJSON object
 */
exports.makePolygon = function (coords) {
  if (coords.length === 1) {
    return {
      type: 'Polygon',
      coordinates: coords
    };
  } else {
    var _coords = new Array(coords.length);
    for (var i = 0; i < coords.length; i++) {
      _coords[i] = [coords[i]];
    }
    return {
      type: 'MultiPolygon',
      coordinates: _coords
    };
  }
};

/**
 * Make blank GeoJSON
 *
 * @return {object}
 *  Blank GeoJSON object
 *
 */
exports.makeBlank = function () {
  return {
    type: 'Point',
    coordinates: []
  };
};

/***/ }),

/***/ 3447:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var mod = (__webpack_require__(98953).mod);

/*
 * look for intersection of two line segments
 *   (1->2 and 3->4) - returns array [x,y] if they do, null if not
 */
exports.segmentsIntersect = segmentsIntersect;
function segmentsIntersect(x1, y1, x2, y2, x3, y3, x4, y4) {
  var a = x2 - x1;
  var b = x3 - x1;
  var c = x4 - x3;
  var d = y2 - y1;
  var e = y3 - y1;
  var f = y4 - y3;
  var det = a * f - c * d;
  // parallel lines? intersection is undefined
  // ignore the case where they are colinear
  if (det === 0) return null;
  var t = (b * f - c * e) / det;
  var u = (b * d - a * e) / det;
  // segments do not intersect?
  if (u < 0 || u > 1 || t < 0 || t > 1) return null;
  return {
    x: x1 + a * t,
    y: y1 + d * t
  };
}

/*
 * find the minimum distance between two line segments (1->2 and 3->4)
 */
exports.segmentDistance = function segmentDistance(x1, y1, x2, y2, x3, y3, x4, y4) {
  if (segmentsIntersect(x1, y1, x2, y2, x3, y3, x4, y4)) return 0;

  // the two segments and their lengths squared
  var x12 = x2 - x1;
  var y12 = y2 - y1;
  var x34 = x4 - x3;
  var y34 = y4 - y3;
  var ll12 = x12 * x12 + y12 * y12;
  var ll34 = x34 * x34 + y34 * y34;

  // calculate distance squared, then take the sqrt at the very end
  var dist2 = Math.min(perpDistance2(x12, y12, ll12, x3 - x1, y3 - y1), perpDistance2(x12, y12, ll12, x4 - x1, y4 - y1), perpDistance2(x34, y34, ll34, x1 - x3, y1 - y3), perpDistance2(x34, y34, ll34, x2 - x3, y2 - y3));
  return Math.sqrt(dist2);
};

/*
 * distance squared from segment ab to point c
 * [xab, yab] is the vector b-a
 * [xac, yac] is the vector c-a
 * llab is the length squared of (b-a), just to simplify calculation
 */
function perpDistance2(xab, yab, llab, xac, yac) {
  var fcAB = xac * xab + yac * yab;
  if (fcAB < 0) {
    // point c is closer to point a
    return xac * xac + yac * yac;
  } else if (fcAB > llab) {
    // point c is closer to point b
    var xbc = xac - xab;
    var ybc = yac - yab;
    return xbc * xbc + ybc * ybc;
  } else {
    // perpendicular distance is the shortest
    var crossProduct = xac * yab - yac * xab;
    return crossProduct * crossProduct / llab;
  }
}

// a very short-term cache for getTextLocation, just because
// we're often looping over the same locations multiple times
// invalidated as soon as we look at a different path
var locationCache, workingPath, workingTextWidth;

// turn a path and position along it into x, y, and angle for the given text
exports.getTextLocation = function getTextLocation(path, totalPathLen, positionOnPath, textWidth) {
  if (path !== workingPath || textWidth !== workingTextWidth) {
    locationCache = {};
    workingPath = path;
    workingTextWidth = textWidth;
  }
  if (locationCache[positionOnPath]) {
    return locationCache[positionOnPath];
  }

  // for the angle, use points on the path separated by the text width
  // even though due to curvature, the text will cover a bit more than that
  var p0 = path.getPointAtLength(mod(positionOnPath - textWidth / 2, totalPathLen));
  var p1 = path.getPointAtLength(mod(positionOnPath + textWidth / 2, totalPathLen));
  // note: atan handles 1/0 nicely
  var theta = Math.atan((p1.y - p0.y) / (p1.x - p0.x));
  // center the text at 2/3 of the center position plus 1/3 the p0/p1 midpoint
  // that's the average position of this segment, assuming it's roughly quadratic
  var pCenter = path.getPointAtLength(mod(positionOnPath, totalPathLen));
  var x = (pCenter.x * 4 + p0.x + p1.x) / 6;
  var y = (pCenter.y * 4 + p0.y + p1.y) / 6;
  var out = {
    x: x,
    y: y,
    theta: theta
  };
  locationCache[positionOnPath] = out;
  return out;
};
exports.clearLocationCache = function () {
  workingPath = null;
};

/*
 * Find the segment of `path` that's within the visible area
 * given by `bounds` {left, right, top, bottom}, to within a
 * precision of `buffer` px
 *
 * returns: undefined if nothing is visible, else object:
 * {
 *   min: position where the path first enters bounds, or 0 if it
 *        starts within bounds
 *   max: position where the path last exits bounds, or the path length
 *        if it finishes within bounds
 *   len: max - min, ie the length of visible path
 *   total: the total path length - just included so the caller doesn't
 *        need to call path.getTotalLength() again
 *   isClosed: true iff the start and end points of the path are both visible
 *        and are at the same point
 * }
 *
 * Works by starting from either end and repeatedly finding the distance from
 * that point to the plot area, and if it's outside the plot, moving along the
 * path by that distance (because the plot must be at least that far away on
 * the path). Note that if a path enters, exits, and re-enters the plot, we
 * will not capture this behavior.
 */
exports.getVisibleSegment = function getVisibleSegment(path, bounds, buffer) {
  var left = bounds.left;
  var right = bounds.right;
  var top = bounds.top;
  var bottom = bounds.bottom;
  var pMin = 0;
  var pTotal = path.getTotalLength();
  var pMax = pTotal;
  var pt0, ptTotal;
  function getDistToPlot(len) {
    var pt = path.getPointAtLength(len);

    // hold on to the start and end points for `closed`
    if (len === 0) pt0 = pt;else if (len === pTotal) ptTotal = pt;
    var dx = pt.x < left ? left - pt.x : pt.x > right ? pt.x - right : 0;
    var dy = pt.y < top ? top - pt.y : pt.y > bottom ? pt.y - bottom : 0;
    return Math.sqrt(dx * dx + dy * dy);
  }
  var distToPlot = getDistToPlot(pMin);
  while (distToPlot) {
    pMin += distToPlot + buffer;
    if (pMin > pMax) return;
    distToPlot = getDistToPlot(pMin);
  }
  distToPlot = getDistToPlot(pMax);
  while (distToPlot) {
    pMax -= distToPlot + buffer;
    if (pMin > pMax) return;
    distToPlot = getDistToPlot(pMax);
  }
  return {
    min: pMin,
    max: pMax,
    len: pMax - pMin,
    total: pTotal,
    isClosed: pMin === 0 && pMax === pTotal && Math.abs(pt0.x - ptTotal.x) < 0.1 && Math.abs(pt0.y - ptTotal.y) < 0.1
  };
};

/**
 * Find point on SVG path corresponding to a given constraint coordinate
 *
 * @param {SVGPathElement} path
 * @param {Number} val : constraint coordinate value
 * @param {String} coord : 'x' or 'y' the constraint coordinate
 * @param {Object} opts :
 *  - {Number} pathLength : supply total path length before hand
 *  - {Number} tolerance
 *  - {Number} iterationLimit
 * @return {SVGPoint}
 */
exports.findPointOnPath = function findPointOnPath(path, val, coord, opts) {
  opts = opts || {};
  var pathLength = opts.pathLength || path.getTotalLength();
  var tolerance = opts.tolerance || 1e-3;
  var iterationLimit = opts.iterationLimit || 30;

  // if path starts at a val greater than the path tail (like on vertical violins),
  // we must flip the sign of the computed diff.
  var mul = path.getPointAtLength(0)[coord] > path.getPointAtLength(pathLength)[coord] ? -1 : 1;
  var i = 0;
  var b0 = 0;
  var b1 = pathLength;
  var mid;
  var pt;
  var diff;
  while (i < iterationLimit) {
    mid = (b0 + b1) / 2;
    pt = path.getPointAtLength(mid);
    diff = pt[coord] - val;
    if (Math.abs(diff) < tolerance) {
      return pt;
    } else {
      if (mul * diff > 0) {
        b1 = mid;
      } else {
        b0 = mid;
      }
      i++;
    }
  }
  return pt;
};

/***/ }),

/***/ 46998:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isNumeric = __webpack_require__(10721);
var tinycolor = __webpack_require__(65657);
var rgba = __webpack_require__(162);
var Colorscale = __webpack_require__(88856);
var colorDflt = (__webpack_require__(10229).defaultLine);
var isArrayOrTypedArray = (__webpack_require__(87800).isArrayOrTypedArray);
var colorDfltRgba = rgba(colorDflt);
var opacityDflt = 1;
function calculateColor(colorIn, opacityIn) {
  var colorOut = colorIn;
  colorOut[3] *= opacityIn;
  return colorOut;
}
function validateColor(colorIn) {
  if (isNumeric(colorIn)) return colorDfltRgba;
  var colorOut = rgba(colorIn);
  return colorOut.length ? colorOut : colorDfltRgba;
}
function validateOpacity(opacityIn) {
  return isNumeric(opacityIn) ? opacityIn : opacityDflt;
}
function formatColor(containerIn, opacityIn, len) {
  var colorIn = containerIn.color;
  if (colorIn && colorIn._inputArray) colorIn = colorIn._inputArray;
  var isArrayColorIn = isArrayOrTypedArray(colorIn);
  var isArrayOpacityIn = isArrayOrTypedArray(opacityIn);
  var cOpts = Colorscale.extractOpts(containerIn);
  var colorOut = [];
  var sclFunc, getColor, getOpacity, colori, opacityi;
  if (cOpts.colorscale !== undefined) {
    sclFunc = Colorscale.makeColorScaleFuncFromTrace(containerIn);
  } else {
    sclFunc = validateColor;
  }
  if (isArrayColorIn) {
    getColor = function (c, i) {
      // FIXME: there is double work, considering that sclFunc does the opposite
      return c[i] === undefined ? colorDfltRgba : rgba(sclFunc(c[i]));
    };
  } else getColor = validateColor;
  if (isArrayOpacityIn) {
    getOpacity = function (o, i) {
      return o[i] === undefined ? opacityDflt : validateOpacity(o[i]);
    };
  } else getOpacity = validateOpacity;
  if (isArrayColorIn || isArrayOpacityIn) {
    for (var i = 0; i < len; i++) {
      colori = getColor(colorIn, i);
      opacityi = getOpacity(opacityIn, i);
      colorOut[i] = calculateColor(colori, opacityi);
    }
  } else colorOut = calculateColor(rgba(colorIn), opacityIn);
  return colorOut;
}
function parseColorScale(cont) {
  var cOpts = Colorscale.extractOpts(cont);
  var colorscale = cOpts.colorscale;
  if (cOpts.reversescale) colorscale = Colorscale.flipScale(cOpts.colorscale);
  return colorscale.map(function (elem) {
    var index = elem[0];
    var color = tinycolor(elem[1]);
    var rgb = color.toRgb();
    return {
      index: index,
      rgb: [rgb.r, rgb.g, rgb.b, rgb.a]
    };
  });
}
module.exports = {
  formatColor: formatColor,
  parseColorScale: parseColorScale
};

/***/ }),

/***/ 71293:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var identity = __webpack_require__(29527);
function wrap(d) {
  return [d];
}
module.exports = {
  // The D3 data binding concept and the General Update Pattern promotes the idea of
  // traversing into the scenegraph by using the `.data(fun, keyFun)` call.
  // The `fun` is most often a `repeat`, ie. the elements beneath a `<g>` element need
  // access to the same data, or a `descend`, which fans a scenegraph node into a bunch of
  // of elements, e.g. points, lines, rows, requiring an array as input.
  // The role of the `keyFun` is to identify what elements are being entered/exited/updated,
  // otherwise D3 reverts to using a plain index which would screw up `transition`s.
  keyFun: function (d) {
    return d.key;
  },
  repeat: wrap,
  descend: identity,
  // Plotly.js uses a convention of storing the actual contents of the `calcData` as the
  // element zero of a container array. These helpers are just used for clarity as a
  // newcomer to the codebase may not know what the `[0]` is, and whether there can be further
  // elements (not atm).
  wrap: wrap,
  unwrap: function (d) {
    return d[0];
  }
};

/***/ }),

/***/ 29527:
/***/ (function(module) {

"use strict";


// Simple helper functions
// none of these need any external deps
module.exports = function identity(d) {
  return d;
};

/***/ }),

/***/ 10688:
/***/ (function(module) {

"use strict";


module.exports = function incrementNumeric(x, delta) {
  if (!delta) return x;

  // Note 1:
  // 0.3 != 0.1 + 0.2 == 0.30000000000000004
  // but 0.3 == (10 * 0.1 + 10 * 0.2) / 10
  // Attempt to use integer steps to increment
  var scale = 1 / Math.abs(delta);
  var newX = scale > 1 ? (scale * x + scale * delta) / scale : x + delta;

  // Note 2:
  // now we may also consider rounding to cover few more edge cases
  // e.g. 0.3 * 3 = 0.8999999999999999
  var lenX1 = String(newX).length;
  if (lenX1 > 16) {
    var lenDt = String(delta).length;
    var lenX0 = String(x).length;
    if (lenX1 >= lenX0 + lenDt) {
      // likely a rounding error!
      var s = parseFloat(newX).toPrecision(12);
      if (s.indexOf('e+') === -1) newX = +s;
    }
  }
  return newX;
};

/***/ }),

/***/ 34809:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var utcFormat = (__webpack_require__(42696)/* .utcFormat */ .aL);
var d3Format = (__webpack_require__(36464)/* .format */ .GP);
var isNumeric = __webpack_require__(10721);
var numConstants = __webpack_require__(63821);
var MAX_SAFE = numConstants.FP_SAFE;
var MIN_SAFE = -MAX_SAFE;
var BADNUM = numConstants.BADNUM;
var lib = module.exports = {};
lib.adjustFormat = function adjustFormat(formatStr) {
  if (!formatStr || /^\d[.]\df/.test(formatStr) || /[.]\d%/.test(formatStr)) return formatStr;
  if (formatStr === '0.f') return '~f';
  if (/^\d%/.test(formatStr)) return '~%';
  if (/^\ds/.test(formatStr)) return '~s';

  // try adding tilde to the start of format in order to trim
  if (!/^[~,.0$]/.test(formatStr) && /[&fps]/.test(formatStr)) return '~' + formatStr;
  return formatStr;
};
var seenBadFormats = {};
lib.warnBadFormat = function (f) {
  var key = String(f);
  if (!seenBadFormats[key]) {
    seenBadFormats[key] = 1;
    lib.warn('encountered bad format: "' + key + '"');
  }
};
lib.noFormat = function (value) {
  return String(value);
};
lib.numberFormat = function (formatStr) {
  var fn;
  try {
    fn = d3Format(lib.adjustFormat(formatStr));
  } catch (e) {
    lib.warnBadFormat(formatStr);
    return lib.noFormat;
  }
  return fn;
};
lib.nestedProperty = __webpack_require__(35632);
lib.keyedContainer = __webpack_require__(34967);
lib.relativeAttr = __webpack_require__(82047);
lib.isPlainObject = __webpack_require__(56174);
lib.toLogRange = __webpack_require__(8083);
lib.relinkPrivateKeys = __webpack_require__(80428);
var arrayModule = __webpack_require__(87800);
lib.isArrayBuffer = arrayModule.isArrayBuffer;
lib.isTypedArray = arrayModule.isTypedArray;
lib.isArrayOrTypedArray = arrayModule.isArrayOrTypedArray;
lib.isArray1D = arrayModule.isArray1D;
lib.ensureArray = arrayModule.ensureArray;
lib.concat = arrayModule.concat;
lib.maxRowLength = arrayModule.maxRowLength;
lib.minRowLength = arrayModule.minRowLength;
var modModule = __webpack_require__(98953);
lib.mod = modModule.mod;
lib.modHalf = modModule.modHalf;
var coerceModule = __webpack_require__(34220);
lib.valObjectMeta = coerceModule.valObjectMeta;
lib.coerce = coerceModule.coerce;
lib.coerce2 = coerceModule.coerce2;
lib.coerceFont = coerceModule.coerceFont;
lib.coercePattern = coerceModule.coercePattern;
lib.coerceHoverinfo = coerceModule.coerceHoverinfo;
lib.coerceSelectionMarkerOpacity = coerceModule.coerceSelectionMarkerOpacity;
lib.validate = coerceModule.validate;
var datesModule = __webpack_require__(92596);
lib.dateTime2ms = datesModule.dateTime2ms;
lib.isDateTime = datesModule.isDateTime;
lib.ms2DateTime = datesModule.ms2DateTime;
lib.ms2DateTimeLocal = datesModule.ms2DateTimeLocal;
lib.cleanDate = datesModule.cleanDate;
lib.isJSDate = datesModule.isJSDate;
lib.formatDate = datesModule.formatDate;
lib.incrementMonth = datesModule.incrementMonth;
lib.dateTick0 = datesModule.dateTick0;
lib.dfltRange = datesModule.dfltRange;
lib.findExactDates = datesModule.findExactDates;
lib.MIN_MS = datesModule.MIN_MS;
lib.MAX_MS = datesModule.MAX_MS;
var searchModule = __webpack_require__(98813);
lib.findBin = searchModule.findBin;
lib.sorterAsc = searchModule.sorterAsc;
lib.sorterDes = searchModule.sorterDes;
lib.distinctVals = searchModule.distinctVals;
lib.roundUp = searchModule.roundUp;
lib.sort = searchModule.sort;
lib.findIndexOfMin = searchModule.findIndexOfMin;
lib.sortObjectKeys = __webpack_require__(62994);
var statsModule = __webpack_require__(89258);
lib.aggNums = statsModule.aggNums;
lib.len = statsModule.len;
lib.mean = statsModule.mean;
lib.geometricMean = statsModule.geometricMean;
lib.median = statsModule.median;
lib.midRange = statsModule.midRange;
lib.variance = statsModule.variance;
lib.stdev = statsModule.stdev;
lib.interp = statsModule.interp;
var matrixModule = __webpack_require__(15236);
lib.init2dArray = matrixModule.init2dArray;
lib.transposeRagged = matrixModule.transposeRagged;
lib.dot = matrixModule.dot;
lib.translationMatrix = matrixModule.translationMatrix;
lib.rotationMatrix = matrixModule.rotationMatrix;
lib.rotationXYMatrix = matrixModule.rotationXYMatrix;
lib.apply3DTransform = matrixModule.apply3DTransform;
lib.apply2DTransform = matrixModule.apply2DTransform;
lib.apply2DTransform2 = matrixModule.apply2DTransform2;
lib.convertCssMatrix = matrixModule.convertCssMatrix;
lib.inverseTransformMatrix = matrixModule.inverseTransformMatrix;
var anglesModule = __webpack_require__(44313);
lib.deg2rad = anglesModule.deg2rad;
lib.rad2deg = anglesModule.rad2deg;
lib.angleDelta = anglesModule.angleDelta;
lib.angleDist = anglesModule.angleDist;
lib.isFullCircle = anglesModule.isFullCircle;
lib.isAngleInsideSector = anglesModule.isAngleInsideSector;
lib.isPtInsideSector = anglesModule.isPtInsideSector;
lib.pathArc = anglesModule.pathArc;
lib.pathSector = anglesModule.pathSector;
lib.pathAnnulus = anglesModule.pathAnnulus;
var anchorUtils = __webpack_require__(32546);
lib.isLeftAnchor = anchorUtils.isLeftAnchor;
lib.isCenterAnchor = anchorUtils.isCenterAnchor;
lib.isRightAnchor = anchorUtils.isRightAnchor;
lib.isTopAnchor = anchorUtils.isTopAnchor;
lib.isMiddleAnchor = anchorUtils.isMiddleAnchor;
lib.isBottomAnchor = anchorUtils.isBottomAnchor;
var geom2dModule = __webpack_require__(3447);
lib.segmentsIntersect = geom2dModule.segmentsIntersect;
lib.segmentDistance = geom2dModule.segmentDistance;
lib.getTextLocation = geom2dModule.getTextLocation;
lib.clearLocationCache = geom2dModule.clearLocationCache;
lib.getVisibleSegment = geom2dModule.getVisibleSegment;
lib.findPointOnPath = geom2dModule.findPointOnPath;
var extendModule = __webpack_require__(93049);
lib.extendFlat = extendModule.extendFlat;
lib.extendDeep = extendModule.extendDeep;
lib.extendDeepAll = extendModule.extendDeepAll;
lib.extendDeepNoArrays = extendModule.extendDeepNoArrays;
var loggersModule = __webpack_require__(48636);
lib.log = loggersModule.log;
lib.warn = loggersModule.warn;
lib.error = loggersModule.error;
var regexModule = __webpack_require__(90694);
lib.counterRegex = regexModule.counter;
var throttleModule = __webpack_require__(64025);
lib.throttle = throttleModule.throttle;
lib.throttleDone = throttleModule.done;
lib.clearThrottle = throttleModule.clear;
var domModule = __webpack_require__(95425);
lib.getGraphDiv = domModule.getGraphDiv;
lib.isPlotDiv = domModule.isPlotDiv;
lib.removeElement = domModule.removeElement;
lib.addStyleRule = domModule.addStyleRule;
lib.addRelatedStyleRule = domModule.addRelatedStyleRule;
lib.deleteRelatedStyleRule = domModule.deleteRelatedStyleRule;
lib.getFullTransformMatrix = domModule.getFullTransformMatrix;
lib.getElementTransformMatrix = domModule.getElementTransformMatrix;
lib.getElementAndAncestors = domModule.getElementAndAncestors;
lib.equalDomRects = domModule.equalDomRects;
lib.clearResponsive = __webpack_require__(23493);
lib.preserveDrawingBuffer = __webpack_require__(32521);
lib.makeTraceGroups = __webpack_require__(75944);
lib._ = __webpack_require__(38514);
lib.notifier = __webpack_require__(87355);
lib.filterUnique = __webpack_require__(48965);
lib.filterVisible = __webpack_require__(78926);
lib.pushUnique = __webpack_require__(36539);
lib.increment = __webpack_require__(10688);
lib.cleanNumber = __webpack_require__(44498);
lib.ensureNumber = function ensureNumber(v) {
  if (!isNumeric(v)) return BADNUM;
  v = Number(v);
  return v > MAX_SAFE || v < MIN_SAFE ? BADNUM : v;
};

/**
 * Is v a valid array index? Accepts numeric strings as well as numbers.
 *
 * @param {any} v: the value to test
 * @param {Optional[integer]} len: the array length we are indexing
 *
 * @return {bool}: v is a valid array index
 */
lib.isIndex = function (v, len) {
  if (len !== undefined && v >= len) return false;
  return isNumeric(v) && v >= 0 && v % 1 === 0;
};
lib.noop = __webpack_require__(4969);
lib.identity = __webpack_require__(29527);

/**
 * create an array of length 'cnt' filled with 'v' at all indices
 *
 * @param {any} v
 * @param {number} cnt
 * @return {array}
 */
lib.repeat = function (v, cnt) {
  var out = new Array(cnt);
  for (var i = 0; i < cnt; i++) {
    out[i] = v;
  }
  return out;
};

/**
 * swap x and y of the same attribute in container cont
 * specify attr with a ? in place of x/y
 * you can also swap other things than x/y by providing part1 and part2
 */
lib.swapAttrs = function (cont, attrList, part1, part2) {
  if (!part1) part1 = 'x';
  if (!part2) part2 = 'y';
  for (var i = 0; i < attrList.length; i++) {
    var attr = attrList[i];
    var xp = lib.nestedProperty(cont, attr.replace('?', part1));
    var yp = lib.nestedProperty(cont, attr.replace('?', part2));
    var temp = xp.get();
    xp.set(yp.get());
    yp.set(temp);
  }
};

/**
 * SVG painter's algo worked around with reinsertion
 */
lib.raiseToTop = function raiseToTop(elem) {
  elem.parentNode.appendChild(elem);
};

/**
 * cancel a possibly pending transition; returned selection may be used by caller
 */
lib.cancelTransition = function (selection) {
  return selection.transition().duration(0);
};

// constrain - restrict a number v to be between v0 and v1
lib.constrain = function (v, v0, v1) {
  if (v0 > v1) return Math.max(v1, Math.min(v0, v));
  return Math.max(v0, Math.min(v1, v));
};

/**
 * do two bounding boxes from getBoundingClientRect,
 * ie {left,right,top,bottom,width,height}, overlap?
 * takes optional padding pixels
 */
lib.bBoxIntersect = function (a, b, pad) {
  pad = pad || 0;
  return a.left <= b.right + pad && b.left <= a.right + pad && a.top <= b.bottom + pad && b.top <= a.bottom + pad;
};

/*
 * simpleMap: alternative to Array.map that only
 * passes on the element and up to 2 extra args you
 * provide (but not the array index or the whole array)
 *
 * array: the array to map it to
 * func: the function to apply
 * x1, x2: optional extra args
 */
lib.simpleMap = function (array, func, x1, x2, opts) {
  var len = array.length;
  var out = new Array(len);
  for (var i = 0; i < len; i++) out[i] = func(array[i], x1, x2, opts);
  return out;
};

/**
 * Random string generator
 *
 * @param {object} existing
 *     pass in strings to avoid as keys with truthy values
 * @param {int} bits
 *     bits of information in the output string, default 24
 * @param {int} base
 *     base of string representation, default 16. Should be a power of 2.
 */
lib.randstr = function randstr(existing, bits, base, _recursion) {
  if (!base) base = 16;
  if (bits === undefined) bits = 24;
  if (bits <= 0) return '0';
  var digits = Math.log(Math.pow(2, bits)) / Math.log(base);
  var res = '';
  var i, b, x;
  for (i = 2; digits === Infinity; i *= 2) {
    digits = Math.log(Math.pow(2, bits / i)) / Math.log(base) * i;
  }
  var rem = digits - Math.floor(digits);
  for (i = 0; i < Math.floor(digits); i++) {
    x = Math.floor(Math.random() * base).toString(base);
    res = x + res;
  }
  if (rem) {
    b = Math.pow(base, rem);
    x = Math.floor(Math.random() * b).toString(base);
    res = x + res;
  }
  var parsed = parseInt(res, base);
  if (existing && existing[res] || parsed !== Infinity && parsed >= Math.pow(2, bits)) {
    if (_recursion > 10) {
      lib.warn('randstr failed uniqueness');
      return res;
    }
    return randstr(existing, bits, base, (_recursion || 0) + 1);
  } else return res;
};
lib.OptionControl = function (opt, optname) {
  /*
   * An environment to contain all option setters and
   * getters that collectively modify opts.
   *
   * You can call up opts from any function in new object
   * as this.optname || this.opt
   *
   * See FitOpts for example of usage
   */
  if (!opt) opt = {};
  if (!optname) optname = 'opt';
  var self = {};
  self.optionList = [];
  self._newoption = function (optObj) {
    optObj[optname] = opt;
    self[optObj.name] = optObj;
    self.optionList.push(optObj);
  };
  self['_' + optname] = opt;
  return self;
};

/**
 * lib.smooth: smooth arrayIn by convolving with
 * a hann window with given full width at half max
 * bounce the ends in, so the output has the same length as the input
 */
lib.smooth = function (arrayIn, FWHM) {
  FWHM = Math.round(FWHM) || 0; // only makes sense for integers
  if (FWHM < 2) return arrayIn;
  var alen = arrayIn.length;
  var alen2 = 2 * alen;
  var wlen = 2 * FWHM - 1;
  var w = new Array(wlen);
  var arrayOut = new Array(alen);
  var i;
  var j;
  var k;
  var v;

  // first make the window array
  for (i = 0; i < wlen; i++) {
    w[i] = (1 - Math.cos(Math.PI * (i + 1) / FWHM)) / (2 * FWHM);
  }

  // now do the convolution
  for (i = 0; i < alen; i++) {
    v = 0;
    for (j = 0; j < wlen; j++) {
      k = i + j + 1 - FWHM;

      // multibounce
      if (k < -alen) k -= alen2 * Math.round(k / alen2);else if (k >= alen2) k -= alen2 * Math.floor(k / alen2);

      // single bounce
      if (k < 0) k = -1 - k;else if (k >= alen) k = alen2 - 1 - k;
      v += arrayIn[k] * w[j];
    }
    arrayOut[i] = v;
  }
  return arrayOut;
};

/**
 * syncOrAsync: run a sequence of functions synchronously
 * as long as its returns are not promises (ie have no .then)
 * includes one argument arg to send to all functions...
 * this is mainly just to prevent us having to make wrapper functions
 * when the only purpose of the wrapper is to reference gd
 * and a final step to be executed at the end
 * TODO: if there's an error and everything is sync,
 * this doesn't happen yet because we want to make sure
 * that it gets reported
 */
lib.syncOrAsync = function (sequence, arg, finalStep) {
  var ret, fni;
  function continueAsync() {
    return lib.syncOrAsync(sequence, arg, finalStep);
  }
  while (sequence.length) {
    fni = sequence.splice(0, 1)[0];
    ret = fni(arg);
    if (ret && ret.then) {
      return ret.then(continueAsync);
    }
  }
  return finalStep && finalStep(arg);
};

/**
 * Helper to strip trailing slash, from
 * http://stackoverflow.com/questions/6680825/return-string-without-trailing-slash
 */
lib.stripTrailingSlash = function (str) {
  if (str.substr(-1) === '/') return str.substr(0, str.length - 1);
  return str;
};
lib.noneOrAll = function (containerIn, containerOut, attrList) {
  /**
   * some attributes come together, so if you have one of them
   * in the input, you should copy the default values of the others
   * to the input as well.
   */
  if (!containerIn) return;
  var hasAny = false;
  var hasAll = true;
  var i;
  var val;
  for (i = 0; i < attrList.length; i++) {
    val = containerIn[attrList[i]];
    if (val !== undefined && val !== null) hasAny = true;else hasAll = false;
  }
  if (hasAny && !hasAll) {
    for (i = 0; i < attrList.length; i++) {
      containerIn[attrList[i]] = containerOut[attrList[i]];
    }
  }
};

/** merges calcdata field (given by cdAttr) with traceAttr values
 *
 * N.B. Loop over minimum of cd.length and traceAttr.length
 * i.e. it does not try to fill in beyond traceAttr.length-1
 *
 * @param {array} traceAttr : trace attribute
 * @param {object} cd : calcdata trace
 * @param {string} cdAttr : calcdata key
 */
lib.mergeArray = function (traceAttr, cd, cdAttr, fn) {
  var hasFn = typeof fn === 'function';
  if (lib.isArrayOrTypedArray(traceAttr)) {
    var imax = Math.min(traceAttr.length, cd.length);
    for (var i = 0; i < imax; i++) {
      var v = traceAttr[i];
      cd[i][cdAttr] = hasFn ? fn(v) : v;
    }
  }
};

// cast numbers to positive numbers, returns 0 if not greater than 0
lib.mergeArrayCastPositive = function (traceAttr, cd, cdAttr) {
  return lib.mergeArray(traceAttr, cd, cdAttr, function (v) {
    var w = +v;
    return !isFinite(w) ? 0 : w > 0 ? w : 0;
  });
};

/** fills calcdata field (given by cdAttr) with traceAttr values
 *  or function of traceAttr values (e.g. some fallback)
 *
 * N.B. Loops over all cd items.
 *
 * @param {array} traceAttr : trace attribute
 * @param {object} cd : calcdata trace
 * @param {string} cdAttr : calcdata key
 * @param {function} [fn] : optional function to apply to each array item
 */
lib.fillArray = function (traceAttr, cd, cdAttr, fn) {
  fn = fn || lib.identity;
  if (lib.isArrayOrTypedArray(traceAttr)) {
    for (var i = 0; i < cd.length; i++) {
      cd[i][cdAttr] = fn(traceAttr[i]);
    }
  }
};

/** Handler for trace-wide vs per-point options
 *
 * @param {object} trace : (full) trace object
 * @param {number} ptNumber : index of the point in question
 * @param {string} astr : attribute string
 * @param {function} [fn] : optional function to apply to each array item
 *
 * @return {any}
 */
lib.castOption = function (trace, ptNumber, astr, fn) {
  fn = fn || lib.identity;
  var val = lib.nestedProperty(trace, astr).get();
  if (lib.isArrayOrTypedArray(val)) {
    if (Array.isArray(ptNumber) && lib.isArrayOrTypedArray(val[ptNumber[0]])) {
      return fn(val[ptNumber[0]][ptNumber[1]]);
    } else {
      return fn(val[ptNumber]);
    }
  } else {
    return val;
  }
};

/** Extract option from calcdata item, correctly falling back to
 *  trace value if not found.
 *
 *  @param {object} calcPt : calcdata[i][j] item
 *  @param {object} trace : (full) trace object
 *  @param {string} calcKey : calcdata key
 *  @param {string} traceKey : aka trace attribute string
 *  @return {any}
 */
lib.extractOption = function (calcPt, trace, calcKey, traceKey) {
  if (calcKey in calcPt) return calcPt[calcKey];

  // fallback to trace value,
  //   must check if value isn't itself an array
  //   which means the trace attribute has a corresponding
  //   calcdata key, but its value is falsy
  var traceVal = lib.nestedProperty(trace, traceKey).get();
  if (!Array.isArray(traceVal)) return traceVal;
};
function makePtIndex2PtNumber(indexToPoints) {
  var ptIndex2ptNumber = {};
  for (var k in indexToPoints) {
    var pts = indexToPoints[k];
    for (var j = 0; j < pts.length; j++) {
      ptIndex2ptNumber[pts[j]] = +k;
    }
  }
  return ptIndex2ptNumber;
}

/** Tag selected calcdata items
 *
 * N.B. note that point 'index' corresponds to input data array index
 *  whereas 'number' is its post-transform version.
 *
 * @param {array} calcTrace
 * @param {object} trace
 *  - selectedpoints {array}
 *  - _indexToPoints {object}
 * @param {ptNumber2cdIndex} ptNumber2cdIndex (optional)
 *  optional map object for trace types that do not have 1-to-1 point number to
 *  calcdata item index correspondence (e.g. histogram)
 */
lib.tagSelected = function (calcTrace, trace, ptNumber2cdIndex) {
  var selectedpoints = trace.selectedpoints;
  var indexToPoints = trace._indexToPoints;
  var ptIndex2ptNumber;

  // make pt index-to-number map object, which takes care of transformed traces
  if (indexToPoints) {
    ptIndex2ptNumber = makePtIndex2PtNumber(indexToPoints);
  }
  function isCdIndexValid(v) {
    return v !== undefined && v < calcTrace.length;
  }
  for (var i = 0; i < selectedpoints.length; i++) {
    var ptIndex = selectedpoints[i];
    if (lib.isIndex(ptIndex) || lib.isArrayOrTypedArray(ptIndex) && lib.isIndex(ptIndex[0]) && lib.isIndex(ptIndex[1])) {
      var ptNumber = ptIndex2ptNumber ? ptIndex2ptNumber[ptIndex] : ptIndex;
      var cdIndex = ptNumber2cdIndex ? ptNumber2cdIndex[ptNumber] : ptNumber;
      if (isCdIndexValid(cdIndex)) {
        calcTrace[cdIndex].selected = 1;
      }
    }
  }
};
lib.selIndices2selPoints = function (trace) {
  var selectedpoints = trace.selectedpoints;
  var indexToPoints = trace._indexToPoints;
  if (indexToPoints) {
    var ptIndex2ptNumber = makePtIndex2PtNumber(indexToPoints);
    var out = [];
    for (var i = 0; i < selectedpoints.length; i++) {
      var ptIndex = selectedpoints[i];
      if (lib.isIndex(ptIndex)) {
        var ptNumber = ptIndex2ptNumber[ptIndex];
        if (lib.isIndex(ptNumber)) {
          out.push(ptNumber);
        }
      }
    }
    return out;
  } else {
    return selectedpoints;
  }
};

/** Returns target as set by 'target' transform attribute
 *
 * @param {object} trace : full trace object
 * @param {object} transformOpts : transform option object
 *  - target (string} :
 *      either an attribute string referencing an array in the trace object, or
 *      a set array.
 *
 * @return {array or false} : the target array (NOT a copy!!) or false if invalid
 */
lib.getTargetArray = function (trace, transformOpts) {
  var target = transformOpts.target;
  if (typeof target === 'string' && target) {
    var array = lib.nestedProperty(trace, target).get();
    return lib.isArrayOrTypedArray(array) ? array : false;
  } else if (lib.isArrayOrTypedArray(target)) {
    return target;
  }
  return false;
};

/**
 * modified version of jQuery's extend to strip out private objs and functions,
 * and cut arrays down to first <arraylen> or 1 elements
 * because extend-like algorithms are hella slow
 * obj2 is assumed to already be clean of these things (including no arrays)
 */
function minExtend(obj1, obj2, opt) {
  var objOut = {};
  if (typeof obj2 !== 'object') obj2 = {};
  var arrayLen = opt === 'pieLike' ? -1 : 3;
  var keys = Object.keys(obj1);
  var i, k, v;
  for (i = 0; i < keys.length; i++) {
    k = keys[i];
    v = obj1[k];
    if (k.charAt(0) === '_' || typeof v === 'function') continue;else if (k === 'module') objOut[k] = v;else if (Array.isArray(v)) {
      if (k === 'colorscale' || arrayLen === -1) {
        objOut[k] = v.slice();
      } else {
        objOut[k] = v.slice(0, arrayLen);
      }
    } else if (lib.isTypedArray(v)) {
      if (arrayLen === -1) {
        objOut[k] = v.subarray();
      } else {
        objOut[k] = v.subarray(0, arrayLen);
      }
    } else if (v && typeof v === 'object') objOut[k] = minExtend(obj1[k], obj2[k], opt);else objOut[k] = v;
  }
  keys = Object.keys(obj2);
  for (i = 0; i < keys.length; i++) {
    k = keys[i];
    v = obj2[k];
    if (typeof v !== 'object' || !(k in objOut) || typeof objOut[k] !== 'object') {
      objOut[k] = v;
    }
  }
  return objOut;
}
lib.minExtend = minExtend;
lib.titleCase = function (s) {
  return s.charAt(0).toUpperCase() + s.substr(1);
};
lib.containsAny = function (s, fragments) {
  for (var i = 0; i < fragments.length; i++) {
    if (s.indexOf(fragments[i]) !== -1) return true;
  }
  return false;
};
lib.isIE = function () {
  return typeof window.navigator.msSaveBlob !== 'undefined';
};
var IS_SAFARI_REGEX = /Version\/[\d\.]+.*Safari/;
lib.isSafari = function () {
  return IS_SAFARI_REGEX.test(window.navigator.userAgent);
};
var IS_IOS_REGEX = /iPad|iPhone|iPod/;
lib.isIOS = function () {
  return IS_IOS_REGEX.test(window.navigator.userAgent);
};
var FIREFOX_VERSION_REGEX = /Firefox\/(\d+)\.\d+/;
lib.getFirefoxVersion = function () {
  var match = FIREFOX_VERSION_REGEX.exec(window.navigator.userAgent);
  if (match && match.length === 2) {
    var versionInt = parseInt(match[1]);
    if (!isNaN(versionInt)) {
      return versionInt;
    }
  }
  return null;
};
lib.isD3Selection = function (obj) {
  return obj instanceof d3.selection;
};

/**
 * Append element to DOM only if not present.
 *
 * @param {d3 selection} parent : parent selection of the element in question
 * @param {string} nodeType : node type of element to append
 * @param {string} className (optional) : class name of element in question
 * @param {fn} enterFn (optional) : optional fn applied to entering elements only
 * @return {d3 selection} selection of new layer
 *
 * Previously, we were using the following pattern:
 *
 * ```
 * var sel = parent.selectAll('.' + className)
 *     .data([0]);
 *
 * sel.enter().append(nodeType)
 *     .classed(className, true);
 *
 * return sel;
 * ```
 *
 * in numerous places in our codebase to achieve the same behavior.
 *
 * The logic below performs much better, mostly as we are using
 * `.select` instead `.selectAll` that is `querySelector` instead of
 * `querySelectorAll`.
 *
 */
lib.ensureSingle = function (parent, nodeType, className, enterFn) {
  var sel = parent.select(nodeType + (className ? '.' + className : ''));
  if (sel.size()) return sel;
  var layer = parent.append(nodeType);
  if (className) layer.classed(className, true);
  if (enterFn) layer.call(enterFn);
  return layer;
};

/**
 * Same as Lib.ensureSingle, but using id as selector.
 * This version is mostly used for clipPath nodes.
 *
 * @param {d3 selection} parent : parent selection of the element in question
 * @param {string} nodeType : node type of element to append
 * @param {string} id : id of element in question
 * @param {fn} enterFn (optional) : optional fn applied to entering elements only
 * @return {d3 selection} selection of new layer
 */
lib.ensureSingleById = function (parent, nodeType, id, enterFn) {
  var sel = parent.select(nodeType + '#' + id);
  if (sel.size()) return sel;
  var layer = parent.append(nodeType).attr('id', id);
  if (enterFn) layer.call(enterFn);
  return layer;
};

/**
 * Converts a string path to an object.
 *
 * When given a string containing an array element, it will create a `null`
 * filled array of the given size.
 *
 * @example
 * lib.objectFromPath('nested.test[2].path', 'value');
 * // returns { nested: { test: [null, null, { path: 'value' }]}
 *
 * @param   {string}    path to nested value
 * @param   {*}         any value to be set
 *
 * @return {Object} the constructed object with a full nested path
 */
lib.objectFromPath = function (path, value) {
  var keys = path.split('.');
  var tmpObj;
  var obj = tmpObj = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var el = null;
    var parts = keys[i].match(/(.*)\[([0-9]+)\]/);
    if (parts) {
      key = parts[1];
      el = parts[2];
      tmpObj = tmpObj[key] = [];
      if (i === keys.length - 1) {
        tmpObj[el] = value;
      } else {
        tmpObj[el] = {};
      }
      tmpObj = tmpObj[el];
    } else {
      if (i === keys.length - 1) {
        tmpObj[key] = value;
      } else {
        tmpObj[key] = {};
      }
      tmpObj = tmpObj[key];
    }
  }
  return obj;
};

/**
 * Iterate through an object in-place, converting dotted properties to objects.
 *
 * Examples:
 *
 *   lib.expandObjectPaths({'nested.test.path': 'value'});
 *     => { nested: { test: {path: 'value'}}}
 *
 * It also handles array notation, e.g.:
 *
 *   lib.expandObjectPaths({'foo[1].bar': 'value'});
 *     => { foo: [null, {bar: value}] }
 *
 * It handles merges the results when two properties are specified in parallel:
 *
 *   lib.expandObjectPaths({'foo[1].bar': 10, 'foo[0].bar': 20});
 *     => { foo: [{bar: 10}, {bar: 20}] }
 *
 * It does NOT, however, merge multiple multiply-nested arrays::
 *
 *   lib.expandObjectPaths({'marker[1].range[1]': 5, 'marker[1].range[0]': 4})
 *     => { marker: [null, {range: 4}] }
 */

// Store this to avoid recompiling regex on *every* prop since this may happen many
// many times for animations. Could maybe be inside the function. Not sure about
// scoping vs. recompilation tradeoff, but at least it's not just inlining it into
// the inner loop.
var dottedPropertyRegex = /^([^\[\.]+)\.(.+)?/;
var indexedPropertyRegex = /^([^\.]+)\[([0-9]+)\](\.)?(.+)?/;
function notValid(prop) {
  // guard against polluting __proto__ and other internals getters and setters
  return prop.slice(0, 2) === '__';
}
lib.expandObjectPaths = function (data) {
  var match, key, prop, datum, idx, dest, trailingPath;
  if (typeof data === 'object' && !Array.isArray(data)) {
    for (key in data) {
      if (data.hasOwnProperty(key)) {
        if (match = key.match(dottedPropertyRegex)) {
          datum = data[key];
          prop = match[1];
          if (notValid(prop)) continue;
          delete data[key];
          data[prop] = lib.extendDeepNoArrays(data[prop] || {}, lib.objectFromPath(key, lib.expandObjectPaths(datum))[prop]);
        } else if (match = key.match(indexedPropertyRegex)) {
          datum = data[key];
          prop = match[1];
          if (notValid(prop)) continue;
          idx = parseInt(match[2]);
          delete data[key];
          data[prop] = data[prop] || [];
          if (match[3] === '.') {
            // This is the case where theere are subsequent properties into which
            // we must recurse, e.g. transforms[0].value
            trailingPath = match[4];
            dest = data[prop][idx] = data[prop][idx] || {};

            // NB: Extend deep no arrays prevents this from working on multiple
            // nested properties in the same object, e.g.
            //
            // {
            //   foo[0].bar[1].range
            //   foo[0].bar[0].range
            // }
            //
            // In this case, the extendDeepNoArrays will overwrite one array with
            // the other, so that both properties *will not* be present in the
            // result. Fixing this would require a more intelligent tracking
            // of changes and merging than extendDeepNoArrays currently accomplishes.
            lib.extendDeepNoArrays(dest, lib.objectFromPath(trailingPath, lib.expandObjectPaths(datum)));
          } else {
            // This is the case where this property is the end of the line,
            // e.g. xaxis.range[0]

            if (notValid(prop)) continue;
            data[prop][idx] = lib.expandObjectPaths(datum);
          }
        } else {
          if (notValid(key)) continue;
          data[key] = lib.expandObjectPaths(data[key]);
        }
      }
    }
  }
  return data;
};

/**
 * Converts value to string separated by the provided separators.
 *
 * @example
 * lib.numSeparate(2016, '.,');
 * // returns '2016'
 *
 * @example
 * lib.numSeparate(3000, '.,', true);
 * // returns '3,000'
 *
 * @example
 * lib.numSeparate(1234.56, '|,')
 * // returns '1,234|56'
 *
 * @param   {string|number} value       the value to be converted
 * @param   {string}    separators  string of decimal, then thousands separators
 * @param   {boolean}    separatethousands  boolean, 4-digit integers are separated if true
 *
 * @return  {string}    the value that has been separated
 */
lib.numSeparate = function (value, separators, separatethousands) {
  if (!separatethousands) separatethousands = false;
  if (typeof separators !== 'string' || separators.length === 0) {
    throw new Error('Separator string required for formatting!');
  }
  if (typeof value === 'number') {
    value = String(value);
  }
  var thousandsRe = /(\d+)(\d{3})/;
  var decimalSep = separators.charAt(0);
  var thouSep = separators.charAt(1);
  var x = value.split('.');
  var x1 = x[0];
  var x2 = x.length > 1 ? decimalSep + x[1] : '';

  // Years are ignored for thousands separators
  if (thouSep && (x.length > 1 || x1.length > 4 || separatethousands)) {
    while (thousandsRe.test(x1)) {
      x1 = x1.replace(thousandsRe, '$1' + thouSep + '$2');
    }
  }
  return x1 + x2;
};
lib.TEMPLATE_STRING_REGEX = /%{([^\s%{}:]*)([:|\|][^}]*)?}/g;
var SIMPLE_PROPERTY_REGEX = /^\w*$/;

/**
 * Substitute values from an object into a string
 *
 * Examples:
 *  Lib.templateString('name: %{trace}', {trace: 'asdf'}) --> 'name: asdf'
 *  Lib.templateString('name: %{trace[0].name}', {trace: [{name: 'asdf'}]}) --> 'name: asdf'
 *
 * @param {string}  input string containing %{...} template strings
 * @param {obj}     data object containing substitution values
 *
 * @return {string} templated string
 */
lib.templateString = function (string, obj) {
  // Not all that useful, but cache nestedProperty instantiation
  // just in case it speeds things up *slightly*:
  var getterCache = {};
  return string.replace(lib.TEMPLATE_STRING_REGEX, function (dummy, key) {
    var v;
    if (SIMPLE_PROPERTY_REGEX.test(key)) {
      v = obj[key];
    } else {
      getterCache[key] = getterCache[key] || lib.nestedProperty(obj, key).get;
      v = getterCache[key]();
    }
    return lib.isValidTextValue(v) ? v : '';
  });
};
var hovertemplateWarnings = {
  max: 10,
  count: 0,
  name: 'hovertemplate'
};
lib.hovertemplateString = function () {
  return templateFormatString.apply(hovertemplateWarnings, arguments);
};
var texttemplateWarnings = {
  max: 10,
  count: 0,
  name: 'texttemplate'
};
lib.texttemplateString = function () {
  return templateFormatString.apply(texttemplateWarnings, arguments);
};

// Regex for parsing multiplication and division operations applied to a template key
// Used for shape.label.texttemplate
// Matches a key name (non-whitespace characters), followed by a * or / character, followed by a number
// For example, the following strings are matched: `x0*2`, `slope/1.60934`, `y1*2.54`
var MULT_DIV_REGEX = /^(\S+)([\*\/])(-?\d+(\.\d+)?)$/;
function multDivParser(inputStr) {
  var match = inputStr.match(MULT_DIV_REGEX);
  if (match) return {
    key: match[1],
    op: match[2],
    number: Number(match[3])
  };
  return {
    key: inputStr,
    op: null,
    number: null
  };
}
var texttemplateWarningsForShapes = {
  max: 10,
  count: 0,
  name: 'texttemplate',
  parseMultDiv: true
};
lib.texttemplateStringForShapes = function () {
  return templateFormatString.apply(texttemplateWarningsForShapes, arguments);
};
var TEMPLATE_STRING_FORMAT_SEPARATOR = /^[:|\|]/;
/**
 * Substitute values from an object into a string and optionally formats them using d3-format,
 * or fallback to associated labels.
 *
 * Examples:
 *  Lib.hovertemplateString('name: %{trace}', {trace: 'asdf'}) --> 'name: asdf'
 *  Lib.hovertemplateString('name: %{trace[0].name}', {trace: [{name: 'asdf'}]}) --> 'name: asdf'
 *  Lib.hovertemplateString('price: %{y:$.2f}', {y: 1}) --> 'price: $1.00'
 *
 * @param {string}  input string containing %{...:...} template strings
 * @param {obj}     data object containing fallback text when no formatting is specified, ex.: {yLabel: 'formattedYValue'}
 * @param {obj}     d3 locale
 * @param {obj}     data objects containing substitution values
 *
 * @return {string} templated string
 */
function templateFormatString(string, labels, d3locale) {
  var opts = this;
  var args = arguments;
  if (!labels) labels = {};
  // Not all that useful, but cache nestedProperty instantiation
  // just in case it speeds things up *slightly*:
  var getterCache = {};
  return string.replace(lib.TEMPLATE_STRING_REGEX, function (match, rawKey, format) {
    var isOther = rawKey === 'xother' || rawKey === 'yother';
    var isSpaceOther = rawKey === '_xother' || rawKey === '_yother';
    var isSpaceOtherSpace = rawKey === '_xother_' || rawKey === '_yother_';
    var isOtherSpace = rawKey === 'xother_' || rawKey === 'yother_';
    var hasOther = isOther || isSpaceOther || isOtherSpace || isSpaceOtherSpace;
    var key = rawKey;
    if (isSpaceOther || isSpaceOtherSpace) key = key.substring(1);
    if (isOtherSpace || isSpaceOtherSpace) key = key.substring(0, key.length - 1);

    // Shape labels support * and / operators in template string
    // Parse these if the parseMultDiv param is set to true
    var parsedOp = null;
    var parsedNumber = null;
    if (opts.parseMultDiv) {
      var _match = multDivParser(key);
      key = _match.key;
      parsedOp = _match.op;
      parsedNumber = _match.number;
    }
    var value;
    if (hasOther) {
      value = labels[key];
      if (value === undefined) return '';
    } else {
      var obj, i;
      for (i = 3; i < args.length; i++) {
        obj = args[i];
        if (!obj) continue;
        if (obj.hasOwnProperty(key)) {
          value = obj[key];
          break;
        }
        if (!SIMPLE_PROPERTY_REGEX.test(key)) {
          value = lib.nestedProperty(obj, key).get();
          value = getterCache[key] || lib.nestedProperty(obj, key).get();
          if (value) getterCache[key] = value;
        }
        if (value !== undefined) break;
      }
    }

    // Apply mult/div operation (if applicable)
    if (value !== undefined) {
      if (parsedOp === '*') value *= parsedNumber;
      if (parsedOp === '/') value /= parsedNumber;
    }
    if (value === undefined && opts) {
      if (opts.count < opts.max) {
        lib.warn('Variable \'' + key + '\' in ' + opts.name + ' could not be found!');
        value = match;
      }
      if (opts.count === opts.max) {
        lib.warn('Too many ' + opts.name + ' warnings - additional warnings will be suppressed');
      }
      opts.count++;
      return match;
    }
    if (format) {
      var fmt;
      if (format[0] === ':') {
        fmt = d3locale ? d3locale.numberFormat : lib.numberFormat;
        if (value !== '') {
          // e.g. skip missing data on heatmap
          value = fmt(format.replace(TEMPLATE_STRING_FORMAT_SEPARATOR, ''))(value);
        }
      }
      if (format[0] === '|') {
        fmt = d3locale ? d3locale.timeFormat : utcFormat;
        var ms = lib.dateTime2ms(value);
        value = lib.formatDate(ms, format.replace(TEMPLATE_STRING_FORMAT_SEPARATOR, ''), false, fmt);
      }
    } else {
      var keyLabel = key + 'Label';
      if (labels.hasOwnProperty(keyLabel)) value = labels[keyLabel];
    }
    if (hasOther) {
      value = '(' + value + ')';
      if (isSpaceOther || isSpaceOtherSpace) value = ' ' + value;
      if (isOtherSpace || isSpaceOtherSpace) value = value + ' ';
    }
    return value;
  });
}

/*
 * alphanumeric string sort, tailored for subplot IDs like scene2, scene10, x10y13 etc
 */
var char0 = 48;
var char9 = 57;
lib.subplotSort = function (a, b) {
  var l = Math.min(a.length, b.length) + 1;
  var numA = 0;
  var numB = 0;
  for (var i = 0; i < l; i++) {
    var charA = a.charCodeAt(i) || 0;
    var charB = b.charCodeAt(i) || 0;
    var isNumA = charA >= char0 && charA <= char9;
    var isNumB = charB >= char0 && charB <= char9;
    if (isNumA) numA = 10 * numA + charA - char0;
    if (isNumB) numB = 10 * numB + charB - char0;
    if (!isNumA || !isNumB) {
      if (numA !== numB) return numA - numB;
      if (charA !== charB) return charA - charB;
    }
  }
  return numB - numA;
};

// repeatable pseudorandom generator
var randSeed = 2000000000;
lib.seedPseudoRandom = function () {
  randSeed = 2000000000;
};
lib.pseudoRandom = function () {
  var lastVal = randSeed;
  randSeed = (69069 * randSeed + 1) % 4294967296;
  // don't let consecutive vals be too close together
  // gets away from really trying to be random, in favor of better local uniformity
  if (Math.abs(randSeed - lastVal) < 429496729) return lib.pseudoRandom();
  return randSeed / 4294967296;
};

/** Fill hover 'pointData' container with 'correct' hover text value
 *
 * - If trace hoverinfo contains a 'text' flag and hovertext is not set,
 *   the text elements will be seen in the hover labels.
 *
 * - If trace hoverinfo contains a 'text' flag and hovertext is set,
 *   hovertext takes precedence over text
 *   i.e. the hoverinfo elements will be seen in the hover labels
 *
 *  @param {object} calcPt
 *  @param {object} trace
 *  @param {object || array} contOut (mutated here)
 */
lib.fillText = function (calcPt, trace, contOut) {
  var fill = Array.isArray(contOut) ? function (v) {
    contOut.push(v);
  } : function (v) {
    contOut.text = v;
  };
  var htx = lib.extractOption(calcPt, trace, 'htx', 'hovertext');
  if (lib.isValidTextValue(htx)) return fill(htx);
  var tx = lib.extractOption(calcPt, trace, 'tx', 'text');
  if (lib.isValidTextValue(tx)) return fill(tx);
};

// accept all truthy values and 0 (which gets cast to '0' in the hover labels)
lib.isValidTextValue = function (v) {
  return v || v === 0;
};

/**
 * @param {number} ratio
 * @param {number} n (number of decimal places)
 */
lib.formatPercent = function (ratio, n) {
  n = n || 0;
  var str = (Math.round(100 * ratio * Math.pow(10, n)) * Math.pow(0.1, n)).toFixed(n) + '%';
  for (var i = 0; i < n; i++) {
    if (str.indexOf('.') !== -1) {
      str = str.replace('0%', '%');
      str = str.replace('.%', '%');
    }
  }
  return str;
};
lib.isHidden = function (gd) {
  var display = window.getComputedStyle(gd).display;
  return !display || display === 'none';
};
lib.strTranslate = function (x, y) {
  return x || y ? 'translate(' + x + ',' + y + ')' : '';
};
lib.strRotate = function (a) {
  return a ? 'rotate(' + a + ')' : '';
};
lib.strScale = function (s) {
  return s !== 1 ? 'scale(' + s + ')' : '';
};

/** Return transform text for bar bar-like rectangles and pie-like slices
 *  @param {object} transform
 *  - targetX: desired position on the x-axis
 *  - targetY: desired position on the y-axis
 *  - textX: text middle position on the x-axis
 *  - textY: text middle position on the y-axis
 *  - anchorX: (optional) text anchor position on the x-axis (computed from textX), zero for middle anchor
 *  - anchorY: (optional) text anchor position on the y-axis (computed from textY), zero for middle anchor
 *  - scale: (optional) scale applied after translate
 *  - rotate: (optional) rotation applied after scale
 *  - noCenter: when defined no extra arguments needed in rotation
 */
lib.getTextTransform = function (transform) {
  var noCenter = transform.noCenter;
  var textX = transform.textX;
  var textY = transform.textY;
  var targetX = transform.targetX;
  var targetY = transform.targetY;
  var anchorX = transform.anchorX || 0;
  var anchorY = transform.anchorY || 0;
  var rotate = transform.rotate;
  var scale = transform.scale;
  if (!scale) scale = 0;else if (scale > 1) scale = 1;
  return lib.strTranslate(targetX - scale * (textX + anchorX), targetY - scale * (textY + anchorY)) + lib.strScale(scale) + (rotate ? 'rotate(' + rotate + (noCenter ? '' : ' ' + textX + ' ' + textY) + ')' : '');
};
lib.setTransormAndDisplay = function (s, transform) {
  s.attr('transform', lib.getTextTransform(transform));
  s.style('display', transform.scale ? null : 'none');
};
lib.ensureUniformFontSize = function (gd, baseFont) {
  var out = lib.extendFlat({}, baseFont);
  out.size = Math.max(baseFont.size, gd._fullLayout.uniformtext.minsize || 0);
  return out;
};

/**
 * provide a human-readable list e.g. "A, B, C and D" with an ending separator
 *
 * @param {array} arr : the array to join
 * @param {string} mainSeparator : main separator
 * @param {string} lastSeparator : last separator
 *
 * @return {string} : joined list
 */
lib.join2 = function (arr, mainSeparator, lastSeparator) {
  var len = arr.length;
  if (len > 1) {
    return arr.slice(0, -1).join(mainSeparator) + lastSeparator + arr[len - 1];
  }
  return arr.join(mainSeparator);
};
lib.bigFont = function (size) {
  return Math.round(1.2 * size);
};
var firefoxVersion = lib.getFirefoxVersion();
// see https://bugzilla.mozilla.org/show_bug.cgi?id=1684973
var isProblematicFirefox = firefoxVersion !== null && firefoxVersion < 86;

/**
 * Return the mouse position from the last event registered by D3.
 * @returns An array with two numbers, representing the x and y coordinates of the mouse pointer
 *   at the event relative to the targeted node.
 */
lib.getPositionFromD3Event = function () {
  if (isProblematicFirefox) {
    // layerX and layerY are non-standard, so we only fallback to them when we have to:
    return [d3.event.layerX, d3.event.layerY];
  } else {
    return [d3.event.offsetX, d3.event.offsetY];
  }
};

/***/ }),

/***/ 56174:
/***/ (function(module) {

"use strict";


// more info: http://stackoverflow.com/questions/18531624/isplainobject-thing
module.exports = function isPlainObject(obj) {
  // We need to be a little less strict in the `imagetest` container because
  // of how async image requests are handled.
  //
  // N.B. isPlainObject(new Constructor()) will return true in `imagetest`
  if (window && window.process && window.process.versions) {
    return Object.prototype.toString.call(obj) === '[object Object]';
  }
  return Object.prototype.toString.call(obj) === '[object Object]' && Object.getPrototypeOf(obj).hasOwnProperty('hasOwnProperty');
};

/***/ }),

/***/ 34967:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var nestedProperty = __webpack_require__(35632);
var SIMPLE_PROPERTY_REGEX = /^\w*$/;

// bitmask for deciding what's updated. Sometimes the name needs to be updated,
// sometimes the value needs to be updated, and sometimes both do. This is just
// a simple way to track what's updated such that it's a simple OR operation to
// assimilate new updates.
//
// The only exception is the UNSET bit that tracks when we need to explicitly
// unset and remove the property. This concrn arises because of the special
// way in which nestedProperty handles null/undefined. When you specify `null`,
// it prunes any unused items in the tree. I ran into some issues with it getting
// null vs undefined confused, so UNSET is just a bit that forces the property
// update to send `null`, removing the property explicitly rather than setting
// it to undefined.
var NONE = 0;
var NAME = 1;
var VALUE = 2;
var BOTH = 3;
var UNSET = 4;
module.exports = function keyedContainer(baseObj, path, keyName, valueName) {
  keyName = keyName || 'name';
  valueName = valueName || 'value';
  var i, arr, baseProp;
  var changeTypes = {};
  if (path && path.length) {
    baseProp = nestedProperty(baseObj, path);
    arr = baseProp.get();
  } else {
    arr = baseObj;
  }
  path = path || '';

  // Construct an index:
  var indexLookup = {};
  if (arr) {
    for (i = 0; i < arr.length; i++) {
      indexLookup[arr[i][keyName]] = i;
    }
  }
  var isSimpleValueProp = SIMPLE_PROPERTY_REGEX.test(valueName);
  var obj = {
    set: function (name, value) {
      var changeType = value === null ? UNSET : NONE;

      // create the base array if necessary
      if (!arr) {
        if (!baseProp || changeType === UNSET) return;
        arr = [];
        baseProp.set(arr);
      }
      var idx = indexLookup[name];
      if (idx === undefined) {
        if (changeType === UNSET) return;
        changeType = changeType | BOTH;
        idx = arr.length;
        indexLookup[name] = idx;
      } else if (value !== (isSimpleValueProp ? arr[idx][valueName] : nestedProperty(arr[idx], valueName).get())) {
        changeType = changeType | VALUE;
      }
      var newValue = arr[idx] = arr[idx] || {};
      newValue[keyName] = name;
      if (isSimpleValueProp) {
        newValue[valueName] = value;
      } else {
        nestedProperty(newValue, valueName).set(value);
      }

      // If it's not an unset, force that bit to be unset. This is all related to the fact
      // that undefined and null are a bit specially implemented in nestedProperties.
      if (value !== null) {
        changeType = changeType & ~UNSET;
      }
      changeTypes[idx] = changeTypes[idx] | changeType;
      return obj;
    },
    get: function (name) {
      if (!arr) return;
      var idx = indexLookup[name];
      if (idx === undefined) {
        return undefined;
      } else if (isSimpleValueProp) {
        return arr[idx][valueName];
      } else {
        return nestedProperty(arr[idx], valueName).get();
      }
    },
    rename: function (name, newName) {
      var idx = indexLookup[name];
      if (idx === undefined) return obj;
      changeTypes[idx] = changeTypes[idx] | NAME;
      indexLookup[newName] = idx;
      delete indexLookup[name];
      arr[idx][keyName] = newName;
      return obj;
    },
    remove: function (name) {
      var idx = indexLookup[name];
      if (idx === undefined) return obj;
      var object = arr[idx];
      if (Object.keys(object).length > 2) {
        // This object contains more than just the key/value, so unset
        // the value without modifying the entry otherwise:
        changeTypes[idx] = changeTypes[idx] | VALUE;
        return obj.set(name, null);
      }
      if (isSimpleValueProp) {
        for (i = idx; i < arr.length; i++) {
          changeTypes[i] = changeTypes[i] | BOTH;
        }
        for (i = idx; i < arr.length; i++) {
          indexLookup[arr[i][keyName]]--;
        }
        arr.splice(idx, 1);
        delete indexLookup[name];
      } else {
        // Perform this update *strictly* so we can check whether the result's
        // been pruned. If so, it's a removal. If not, it's a value unset only.
        nestedProperty(object, valueName).set(null);

        // Now check if the top level nested property has any keys left. If so,
        // the object still has values so we only want to unset the key. If not,
        // the entire object can be removed since there's no other data.
        // var topLevelKeys = Object.keys(object[valueName.split('.')[0]] || []);

        changeTypes[idx] = changeTypes[idx] | VALUE | UNSET;
      }
      return obj;
    },
    constructUpdate: function () {
      var astr, idx;
      var update = {};
      var changed = Object.keys(changeTypes);
      for (var i = 0; i < changed.length; i++) {
        idx = changed[i];
        astr = path + '[' + idx + ']';
        if (arr[idx]) {
          if (changeTypes[idx] & NAME) {
            update[astr + '.' + keyName] = arr[idx][keyName];
          }
          if (changeTypes[idx] & VALUE) {
            if (isSimpleValueProp) {
              update[astr + '.' + valueName] = changeTypes[idx] & UNSET ? null : arr[idx][valueName];
            } else {
              update[astr + '.' + valueName] = changeTypes[idx] & UNSET ? null : nestedProperty(arr[idx], valueName).get();
            }
          }
        } else {
          update[astr] = null;
        }
      }
      return update;
    }
  };
  return obj;
};

/***/ }),

/***/ 38514:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Registry = __webpack_require__(33626);

/**
 * localize: translate a string for the current locale
 *
 * @param {object} gd: the graphDiv for context
 *  gd._context.locale determines the language (& optional region/country)
 *  the dictionary for each locale may either be supplied in
 *  gd._context.locales or globally via Plotly.register
 * @param {string} s: the string to translate
 */
module.exports = function localize(gd, s) {
  var locale = gd._context.locale;

  /*
   * Priority of lookup:
   *     contextDicts[locale],
   *     registeredDicts[locale],
   *     contextDicts[baseLocale], (if baseLocale is distinct)
   *     registeredDicts[baseLocale]
   * Return the first translation we find.
   * This way if you have a regionalization you are allowed to specify
   * only what's different from the base locale, everything else will
   * fall back on the base.
   */
  for (var i = 0; i < 2; i++) {
    var locales = gd._context.locales;
    for (var j = 0; j < 2; j++) {
      var dict = (locales[locale] || {}).dictionary;
      if (dict) {
        var out = dict[s];
        if (out) return out;
      }
      locales = Registry.localeRegistry;
    }
    var baseLocale = locale.split('-')[0];
    if (baseLocale === locale) break;
    locale = baseLocale;
  }
  return s;
};

/***/ }),

/***/ 48636:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


/* eslint-disable no-console */
var dfltConfig = (__webpack_require__(24452).dfltConfig);
var notifier = __webpack_require__(87355);
var loggers = module.exports = {};

/**
 * ------------------------------------------
 * debugging tools
 * ------------------------------------------
 */

loggers.log = function () {
  var i;
  if (dfltConfig.logging > 1) {
    var messages = ['LOG:'];
    for (i = 0; i < arguments.length; i++) {
      messages.push(arguments[i]);
    }
    console.trace.apply(console, messages);
  }
  if (dfltConfig.notifyOnLogging > 1) {
    var lines = [];
    for (i = 0; i < arguments.length; i++) {
      lines.push(arguments[i]);
    }
    notifier(lines.join('<br>'), 'long');
  }
};
loggers.warn = function () {
  var i;
  if (dfltConfig.logging > 0) {
    var messages = ['WARN:'];
    for (i = 0; i < arguments.length; i++) {
      messages.push(arguments[i]);
    }
    console.trace.apply(console, messages);
  }
  if (dfltConfig.notifyOnLogging > 0) {
    var lines = [];
    for (i = 0; i < arguments.length; i++) {
      lines.push(arguments[i]);
    }
    notifier(lines.join('<br>'), 'stick');
  }
};
loggers.error = function () {
  var i;
  if (dfltConfig.logging > 0) {
    var messages = ['ERROR:'];
    for (i = 0; i < arguments.length; i++) {
      messages.push(arguments[i]);
    }
    console.error.apply(console, messages);
  }
  if (dfltConfig.notifyOnLogging > 0) {
    var lines = [];
    for (i = 0; i < arguments.length; i++) {
      lines.push(arguments[i]);
    }
    notifier(lines.join('<br>'), 'stick');
  }
};

/***/ }),

/***/ 75944:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);

/**
 * General helper to manage trace groups based on calcdata
 *
 * @param {d3.selection} traceLayer: a selection containing a single group
 *     to draw these traces into
 * @param {array} cdModule: array of calcdata items for this
 *     module and subplot combination. Assumes the calcdata item for each
 *     trace is an array with the fullData trace attached to the first item.
 * @param {string} cls: the class attribute to give each trace group
 *     so you can give multiple classes separated by spaces
 */
module.exports = function makeTraceGroups(traceLayer, cdModule, cls) {
  var traces = traceLayer.selectAll('g.' + cls.replace(/\s/g, '.')).data(cdModule, function (cd) {
    return cd[0].trace.uid;
  });
  traces.exit().remove();
  traces.enter().append('g').attr('class', cls);
  traces.order();

  // stash ref node to trace group in calcdata,
  // useful for (fast) styleOnSelect
  var k = traceLayer.classed('rangeplot') ? 'nodeRangePlot3' : 'node3';
  traces.each(function (cd) {
    cd[0][k] = d3.select(this);
  });
  return traces;
};

/***/ }),

/***/ 15236:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var mat4X4 = __webpack_require__(11191);
exports.init2dArray = function (rowLength, colLength) {
  var array = new Array(rowLength);
  for (var i = 0; i < rowLength; i++) array[i] = new Array(colLength);
  return array;
};

/**
 * transpose a (possibly ragged) 2d array z. inspired by
 * http://stackoverflow.com/questions/17428587/
 * transposing-a-2d-array-in-javascript
 */
exports.transposeRagged = function (z) {
  var maxlen = 0;
  var zlen = z.length;
  var i, j;
  // Maximum row length:
  for (i = 0; i < zlen; i++) maxlen = Math.max(maxlen, z[i].length);
  var t = new Array(maxlen);
  for (i = 0; i < maxlen; i++) {
    t[i] = new Array(zlen);
    for (j = 0; j < zlen; j++) t[i][j] = z[j][i];
  }
  return t;
};

// our own dot function so that we don't need to include numeric
exports.dot = function (x, y) {
  if (!(x.length && y.length) || x.length !== y.length) return null;
  var len = x.length;
  var out;
  var i;
  if (x[0].length) {
    // mat-vec or mat-mat
    out = new Array(len);
    for (i = 0; i < len; i++) out[i] = exports.dot(x[i], y);
  } else if (y[0].length) {
    // vec-mat
    var yTranspose = exports.transposeRagged(y);
    out = new Array(yTranspose.length);
    for (i = 0; i < yTranspose.length; i++) out[i] = exports.dot(x, yTranspose[i]);
  } else {
    // vec-vec
    out = 0;
    for (i = 0; i < len; i++) out += x[i] * y[i];
  }
  return out;
};

// translate by (x,y)
exports.translationMatrix = function (x, y) {
  return [[1, 0, x], [0, 1, y], [0, 0, 1]];
};

// rotate by alpha around (0,0)
exports.rotationMatrix = function (alpha) {
  var a = alpha * Math.PI / 180;
  return [[Math.cos(a), -Math.sin(a), 0], [Math.sin(a), Math.cos(a), 0], [0, 0, 1]];
};

// rotate by alpha around (x,y)
exports.rotationXYMatrix = function (a, x, y) {
  return exports.dot(exports.dot(exports.translationMatrix(x, y), exports.rotationMatrix(a)), exports.translationMatrix(-x, -y));
};

// applies a 3D transformation matrix to either x, y and z params
// Note: z is optional
exports.apply3DTransform = function (transform) {
  return function () {
    var args = arguments;
    var xyz = arguments.length === 1 ? args[0] : [args[0], args[1], args[2] || 0];
    return exports.dot(transform, [xyz[0], xyz[1], xyz[2], 1]).slice(0, 3);
  };
};

// applies a 2D transformation matrix to either x and y params or an [x,y] array
exports.apply2DTransform = function (transform) {
  return function () {
    var args = arguments;
    if (args.length === 3) {
      args = args[0];
    } // from map
    var xy = arguments.length === 1 ? args[0] : [args[0], args[1]];
    return exports.dot(transform, [xy[0], xy[1], 1]).slice(0, 2);
  };
};

// applies a 2D transformation matrix to an [x1,y1,x2,y2] array (to transform a segment)
exports.apply2DTransform2 = function (transform) {
  var at = exports.apply2DTransform(transform);
  return function (xys) {
    return at(xys.slice(0, 2)).concat(at(xys.slice(2, 4)));
  };
};
exports.convertCssMatrix = function (m) {
  if (m) {
    var len = m.length;
    if (len === 16) return m;
    if (len === 6) {
      // converts a 2x3 css transform matrix to a 4x4 matrix see https://developer.mozilla.org/en-US/docs/Web/CSS/transform-function/matrix
      return [m[0], m[1], 0, 0, m[2], m[3], 0, 0, 0, 0, 1, 0, m[4], m[5], 0, 1];
    }
  }
  return [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
};

// find the inverse for a 4x4 affine transform matrix
exports.inverseTransformMatrix = function (m) {
  var out = [];
  mat4X4.invert(out, m);
  return [[out[0], out[1], out[2], out[3]], [out[4], out[5], out[6], out[7]], [out[8], out[9], out[10], out[11]], [out[12], out[13], out[14], out[15]]];
};

/***/ }),

/***/ 98953:
/***/ (function(module) {

"use strict";


/**
 * sanitized modulus function that always returns in the range [0, d)
 * rather than (-d, 0] if v is negative
 */
function mod(v, d) {
  var out = v % d;
  return out < 0 ? out + d : out;
}

/**
 * sanitized modulus function that always returns in the range [-d/2, d/2]
 * rather than (-d, 0] if v is negative
 */
function modHalf(v, d) {
  return Math.abs(v) > d / 2 ? v - Math.round(v / d) * d : v;
}
module.exports = {
  mod: mod,
  modHalf: modHalf
};

/***/ }),

/***/ 35632:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isNumeric = __webpack_require__(10721);
var isArrayOrTypedArray = (__webpack_require__(87800).isArrayOrTypedArray);

/**
 * convert a string s (such as 'xaxis.range[0]')
 * representing a property of nested object into set and get methods
 * also return the string and object so we don't have to keep track of them
 * allows [-1] for an array index, to set a property inside all elements
 * of an array
 * eg if obj = {arr: [{a: 1}, {a: 2}]}
 * you can do p = nestedProperty(obj, 'arr[-1].a')
 * but you cannot set the array itself this way, to do that
 * just set the whole array.
 * eg if obj = {arr: [1, 2, 3]}
 * you can't do nestedProperty(obj, 'arr[-1]').set(5)
 * but you can do nestedProperty(obj, 'arr').set([5, 5, 5])
 */
module.exports = function nestedProperty(container, propStr) {
  if (isNumeric(propStr)) propStr = String(propStr);else if (typeof propStr !== 'string' || propStr.substr(propStr.length - 4) === '[-1]') {
    throw 'bad property string';
  }
  var propParts = propStr.split('.');
  var indexed;
  var indices;
  var i, j;
  for (j = 0; j < propParts.length; j++) {
    // guard against polluting __proto__ and other internals
    if (String(propParts[j]).slice(0, 2) === '__') {
      throw 'bad property string';
    }
  }

  // check for parts of the nesting hierarchy that are numbers (ie array elements)
  j = 0;
  while (j < propParts.length) {
    // look for non-bracket chars, then any number of [##] blocks
    indexed = String(propParts[j]).match(/^([^\[\]]*)((\[\-?[0-9]*\])+)$/);
    if (indexed) {
      if (indexed[1]) propParts[j] = indexed[1];
      // allow propStr to start with bracketed array indices
      else if (j === 0) propParts.splice(0, 1);else throw 'bad property string';
      indices = indexed[2].substr(1, indexed[2].length - 2).split('][');
      for (i = 0; i < indices.length; i++) {
        j++;
        propParts.splice(j, 0, Number(indices[i]));
      }
    }
    j++;
  }
  if (typeof container !== 'object') {
    return badContainer(container, propStr, propParts);
  }
  return {
    set: npSet(container, propParts, propStr),
    get: npGet(container, propParts),
    astr: propStr,
    parts: propParts,
    obj: container
  };
};
function npGet(cont, parts) {
  return function () {
    var curCont = cont;
    var curPart;
    var allSame;
    var out;
    var i;
    var j;
    for (i = 0; i < parts.length - 1; i++) {
      curPart = parts[i];
      if (curPart === -1) {
        allSame = true;
        out = [];
        for (j = 0; j < curCont.length; j++) {
          out[j] = npGet(curCont[j], parts.slice(i + 1))();
          if (out[j] !== out[0]) allSame = false;
        }
        return allSame ? out[0] : out;
      }
      if (typeof curPart === 'number' && !isArrayOrTypedArray(curCont)) {
        return undefined;
      }
      curCont = curCont[curPart];
      if (typeof curCont !== 'object' || curCont === null) {
        return undefined;
      }
    }

    // only hit this if parts.length === 1
    if (typeof curCont !== 'object' || curCont === null) return undefined;
    out = curCont[parts[i]];
    if (out === null) return undefined;
    return out;
  };
}

/*
 * Can this value be deleted? We can delete `undefined`, and `null` except INSIDE an
 * *args* array.
 *
 * Previously we also deleted some `{}` and `[]`, in order to try and make set/unset
 * a net noop; but this causes far more complication than it's worth, and still had
 * lots of exceptions. See https://github.com/plotly/plotly.js/issues/1410
 *
 * *args* arrays get passed directly to API methods and we should respect null if
 * the user put it there, but otherwise null is deleted as we use it as code
 * in restyle/relayout/update for "delete this value" whereas undefined means
 * "ignore this edit"
 */
var ARGS_PATTERN = /(^|\.)args\[/;
function isDeletable(val, propStr) {
  return val === undefined || val === null && !propStr.match(ARGS_PATTERN);
}
function npSet(cont, parts, propStr) {
  return function (val) {
    var curCont = cont;
    var propPart = '';
    var containerLevels = [[cont, propPart]];
    var toDelete = isDeletable(val, propStr);
    var curPart;
    var i;
    for (i = 0; i < parts.length - 1; i++) {
      curPart = parts[i];
      if (typeof curPart === 'number' && !isArrayOrTypedArray(curCont)) {
        throw 'array index but container is not an array';
      }

      // handle special -1 array index
      if (curPart === -1) {
        toDelete = !setArrayAll(curCont, parts.slice(i + 1), val, propStr);
        if (toDelete) break;else return;
      }
      if (!checkNewContainer(curCont, curPart, parts[i + 1], toDelete)) {
        break;
      }
      curCont = curCont[curPart];
      if (typeof curCont !== 'object' || curCont === null) {
        throw 'container is not an object';
      }
      propPart = joinPropStr(propPart, curPart);
      containerLevels.push([curCont, propPart]);
    }
    if (toDelete) {
      if (i === parts.length - 1) {
        delete curCont[parts[i]];

        // The one bit of pruning we still do: drop `undefined` from the end of arrays.
        // In case someone has already unset previous items, continue until we hit a
        // non-undefined value.
        if (Array.isArray(curCont) && +parts[i] === curCont.length - 1) {
          while (curCont.length && curCont[curCont.length - 1] === undefined) {
            curCont.pop();
          }
        }
      }
    } else curCont[parts[i]] = val;
  };
}
function joinPropStr(propStr, newPart) {
  var toAdd = newPart;
  if (isNumeric(newPart)) toAdd = '[' + newPart + ']';else if (propStr) toAdd = '.' + newPart;
  return propStr + toAdd;
}

// handle special -1 array index
function setArrayAll(containerArray, innerParts, val, propStr) {
  var arrayVal = isArrayOrTypedArray(val);
  var allSet = true;
  var thisVal = val;
  var thisPropStr = propStr.replace('-1', 0);
  var deleteThis = arrayVal ? false : isDeletable(val, thisPropStr);
  var firstPart = innerParts[0];
  var i;
  for (i = 0; i < containerArray.length; i++) {
    thisPropStr = propStr.replace('-1', i);
    if (arrayVal) {
      thisVal = val[i % val.length];
      deleteThis = isDeletable(thisVal, thisPropStr);
    }
    if (deleteThis) allSet = false;
    if (!checkNewContainer(containerArray, i, firstPart, deleteThis)) {
      continue;
    }
    npSet(containerArray[i], innerParts, propStr.replace('-1', i))(thisVal);
  }
  return allSet;
}

/**
 * make new sub-container as needed.
 * returns false if there's no container and none is needed
 * because we're only deleting an attribute
 */
function checkNewContainer(container, part, nextPart, toDelete) {
  if (container[part] === undefined) {
    if (toDelete) return false;
    if (typeof nextPart === 'number') container[part] = [];else container[part] = {};
  }
  return true;
}
function badContainer(container, propStr, propParts) {
  return {
    set: function () {
      throw 'bad container';
    },
    get: function () {},
    astr: propStr,
    parts: propParts,
    obj: container
  };
}

/***/ }),

/***/ 4969:
/***/ (function(module) {

"use strict";


// Simple helper functions
// none of these need any external deps
module.exports = function noop() {};

/***/ }),

/***/ 87355:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var isNumeric = __webpack_require__(10721);
var NOTEDATA = [];

/**
 * notifier
 * @param {String} text The person's user name
 * @param {Number} [delay=1000] The delay time in milliseconds
 *          or 'long' which provides 2000 ms delay time.
 * @return {undefined} this function does not return a value
 */
module.exports = function (text, displayLength) {
  if (NOTEDATA.indexOf(text) !== -1) return;
  NOTEDATA.push(text);
  var ts = 1000;
  if (isNumeric(displayLength)) ts = displayLength;else if (displayLength === 'long') ts = 3000;
  var notifierContainer = d3.select('body').selectAll('.plotly-notifier').data([0]);
  notifierContainer.enter().append('div').classed('plotly-notifier', true);
  var notes = notifierContainer.selectAll('.notifier-note').data(NOTEDATA);
  function killNote(transition) {
    transition.duration(700).style('opacity', 0).each('end', function (thisText) {
      var thisIndex = NOTEDATA.indexOf(thisText);
      if (thisIndex !== -1) NOTEDATA.splice(thisIndex, 1);
      d3.select(this).remove();
    });
  }
  notes.enter().append('div').classed('notifier-note', true).style('opacity', 0).each(function (thisText) {
    var note = d3.select(this);
    note.append('button').classed('notifier-close', true).html('&times;').on('click', function () {
      note.transition().call(killNote);
    });
    var p = note.append('p');
    var lines = thisText.split(/<br\s*\/?>/g);
    for (var i = 0; i < lines.length; i++) {
      if (i) p.append('br');
      p.append('span').text(lines[i]);
    }
    if (displayLength === 'stick') {
      note.transition().duration(350).style('opacity', 1);
    } else {
      note.transition().duration(700).style('opacity', 1).transition().delay(ts).call(killNote);
    }
  });
};

/***/ }),

/***/ 93134:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var setCursor = __webpack_require__(27983);
var STASHATTR = 'data-savedcursor';
var NO_CURSOR = '!!';

/*
 * works with our CSS cursor classes (see css/_cursor.scss)
 * to override a previous cursor set on d3 single-element selections,
 * by moving the name of the original cursor to the data-savedcursor attr.
 * omit cursor to revert to the previously set value.
 */
module.exports = function overrideCursor(el3, csr) {
  var savedCursor = el3.attr(STASHATTR);
  if (csr) {
    if (!savedCursor) {
      var classes = (el3.attr('class') || '').split(' ');
      for (var i = 0; i < classes.length; i++) {
        var cls = classes[i];
        if (cls.indexOf('cursor-') === 0) {
          el3.attr(STASHATTR, cls.substr(7)).classed(cls, false);
        }
      }
      if (!el3.attr(STASHATTR)) {
        el3.attr(STASHATTR, NO_CURSOR);
      }
    }
    setCursor(el3, csr);
  } else if (savedCursor) {
    el3.attr(STASHATTR, null);
    if (savedCursor === NO_CURSOR) setCursor(el3);else setCursor(el3, savedCursor);
  }
};

/***/ }),

/***/ 80899:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var dot = (__webpack_require__(15236).dot);
var BADNUM = (__webpack_require__(63821).BADNUM);
var polygon = module.exports = {};

/**
 * Turn an array of [x, y] pairs into a polygon object
 * that can test if points are inside it
 *
 * @param ptsIn Array of [x, y] pairs
 *
 * @returns polygon Object {xmin, xmax, ymin, ymax, pts, contains}
 *      (x|y)(min|max) are the bounding rect of the polygon
 *      pts is the original array, with the first pair repeated at the end
 *      contains is a function: (pt, omitFirstEdge)
 *          pt is the [x, y] pair to test
 *          omitFirstEdge truthy means points exactly on the first edge don't
 *              count. This is for use adding one polygon to another so we
 *              don't double-count the edge where they meet.
 *          returns boolean: is pt inside the polygon (including on its edges)
 */
polygon.tester = function tester(ptsIn) {
  var pts = ptsIn.slice();
  var xmin = pts[0][0];
  var xmax = xmin;
  var ymin = pts[0][1];
  var ymax = ymin;
  var i;
  if (pts[pts.length - 1][0] !== pts[0][0] || pts[pts.length - 1][1] !== pts[0][1]) {
    // close the polygon
    pts.push(pts[0]);
  }
  for (i = 1; i < pts.length; i++) {
    xmin = Math.min(xmin, pts[i][0]);
    xmax = Math.max(xmax, pts[i][0]);
    ymin = Math.min(ymin, pts[i][1]);
    ymax = Math.max(ymax, pts[i][1]);
  }

  // do we have a rectangle? Handle this here, so we can use the same
  // tester for the rectangular case without sacrificing speed

  var isRect = false;
  var rectFirstEdgeTest;
  if (pts.length === 5) {
    if (pts[0][0] === pts[1][0]) {
      // vert, horz, vert, horz
      if (pts[2][0] === pts[3][0] && pts[0][1] === pts[3][1] && pts[1][1] === pts[2][1]) {
        isRect = true;
        rectFirstEdgeTest = function (pt) {
          return pt[0] === pts[0][0];
        };
      }
    } else if (pts[0][1] === pts[1][1]) {
      // horz, vert, horz, vert
      if (pts[2][1] === pts[3][1] && pts[0][0] === pts[3][0] && pts[1][0] === pts[2][0]) {
        isRect = true;
        rectFirstEdgeTest = function (pt) {
          return pt[1] === pts[0][1];
        };
      }
    }
  }
  function rectContains(pt, omitFirstEdge) {
    var x = pt[0];
    var y = pt[1];
    if (x === BADNUM || x < xmin || x > xmax || y === BADNUM || y < ymin || y > ymax) {
      // pt is outside the bounding box of polygon
      return false;
    }
    if (omitFirstEdge && rectFirstEdgeTest(pt)) return false;
    return true;
  }
  function contains(pt, omitFirstEdge) {
    var x = pt[0];
    var y = pt[1];
    if (x === BADNUM || x < xmin || x > xmax || y === BADNUM || y < ymin || y > ymax) {
      // pt is outside the bounding box of polygon
      return false;
    }
    var imax = pts.length;
    var x1 = pts[0][0];
    var y1 = pts[0][1];
    var crossings = 0;
    var i;
    var x0;
    var y0;
    var xmini;
    var ycross;
    for (i = 1; i < imax; i++) {
      // find all crossings of a vertical line upward from pt with
      // polygon segments
      // crossings exactly at xmax don't count, unless the point is
      // exactly on the segment, then it counts as inside.
      x0 = x1;
      y0 = y1;
      x1 = pts[i][0];
      y1 = pts[i][1];
      xmini = Math.min(x0, x1);
      if (x < xmini || x > Math.max(x0, x1) || y > Math.max(y0, y1)) {
        // outside the bounding box of this segment, it's only a crossing
        // if it's below the box.

        continue;
      } else if (y < Math.min(y0, y1)) {
        // don't count the left-most point of the segment as a crossing
        // because we don't want to double-count adjacent crossings
        // UNLESS the polygon turns past vertical at exactly this x
        // Note that this is repeated below, but we can't factor it out
        // because
        if (x !== xmini) crossings++;
      } else {
        // inside the bounding box, check the actual line intercept

        // vertical segment - we know already that the point is exactly
        // on the segment, so mark the crossing as exactly at the point.
        if (x1 === x0) ycross = y;
        // any other angle
        else ycross = y0 + (x - x0) * (y1 - y0) / (x1 - x0);

        // exactly on the edge: counts as inside the polygon, unless it's the
        // first edge and we're omitting it.
        if (y === ycross) {
          if (i === 1 && omitFirstEdge) return false;
          return true;
        }
        if (y <= ycross && x !== xmini) crossings++;
      }
    }

    // if we've gotten this far, odd crossings means inside, even is outside
    return crossings % 2 === 1;
  }

  // detect if poly is degenerate
  var degenerate = true;
  var lastPt = pts[0];
  for (i = 1; i < pts.length; i++) {
    if (lastPt[0] !== pts[i][0] || lastPt[1] !== pts[i][1]) {
      degenerate = false;
      break;
    }
  }
  return {
    xmin: xmin,
    xmax: xmax,
    ymin: ymin,
    ymax: ymax,
    pts: pts,
    contains: isRect ? rectContains : contains,
    isRect: isRect,
    degenerate: degenerate
  };
};

/**
 * Test if a segment of a points array is bent or straight
 *
 * @param pts Array of [x, y] pairs
 * @param start the index of the proposed start of the straight section
 * @param end the index of the proposed end point
 * @param tolerance the max distance off the line connecting start and end
 *      before the line counts as bent
 * @returns boolean: true means this segment is bent, false means straight
 */
polygon.isSegmentBent = function isSegmentBent(pts, start, end, tolerance) {
  var startPt = pts[start];
  var segment = [pts[end][0] - startPt[0], pts[end][1] - startPt[1]];
  var segmentSquared = dot(segment, segment);
  var segmentLen = Math.sqrt(segmentSquared);
  var unitPerp = [-segment[1] / segmentLen, segment[0] / segmentLen];
  var i;
  var part;
  var partParallel;
  for (i = start + 1; i < end; i++) {
    part = [pts[i][0] - startPt[0], pts[i][1] - startPt[1]];
    partParallel = dot(part, segment);
    if (partParallel < 0 || partParallel > segmentSquared || Math.abs(dot(part, unitPerp)) > tolerance) return true;
  }
  return false;
};

/**
 * Make a filtering polygon, to minimize the number of segments
 *
 * @param pts Array of [x, y] pairs (must start with at least 1 pair)
 * @param tolerance the maximum deviation from straight allowed for
 *      removing points to simplify the polygon
 *
 * @returns Object {addPt, raw, filtered}
 *      addPt is a function(pt: [x, y] pair) to add a raw point and
 *          continue filtering
 *      raw is all the input points
 *      filtered is the resulting filtered Array of [x, y] pairs
 */
polygon.filter = function filter(pts, tolerance) {
  var ptsFiltered = [pts[0]];
  var doneRawIndex = 0;
  var doneFilteredIndex = 0;
  function addPt(pt) {
    pts.push(pt);
    var prevFilterLen = ptsFiltered.length;
    var iLast = doneRawIndex;
    ptsFiltered.splice(doneFilteredIndex + 1);
    for (var i = iLast + 1; i < pts.length; i++) {
      if (i === pts.length - 1 || polygon.isSegmentBent(pts, iLast, i + 1, tolerance)) {
        ptsFiltered.push(pts[i]);
        if (ptsFiltered.length < prevFilterLen - 2) {
          doneRawIndex = i;
          doneFilteredIndex = ptsFiltered.length - 1;
        }
        iLast = i;
      }
    }
  }
  if (pts.length > 1) {
    var lastPt = pts.pop();
    addPt(lastPt);
  }
  return {
    addPt: addPt,
    raw: pts,
    filtered: ptsFiltered
  };
};

/***/ }),

/***/ 22459:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var showNoWebGlMsg = __webpack_require__(97464);

// Note that this module should be ONLY required into
// files corresponding to regl trace modules
// so that bundles with non-regl only don't include
// regl and all its bytes.
var createRegl = __webpack_require__(81330);

/**
 * Idempotent version of createRegl. Create regl instances
 * in the correct canvases with the correct attributes and
 * options
 *
 * @param {DOM node or object} gd : graph div object
 * @param {array} extensions : list of extension to pass to createRegl
 *
 * @return {boolean} true if all createRegl calls succeeded, false otherwise
 */
module.exports = function prepareRegl(gd, extensions, reglPrecompiled) {
  var fullLayout = gd._fullLayout;
  var success = true;
  fullLayout._glcanvas.each(function (d) {
    if (d.regl) {
      d.regl.preloadCachedCode(reglPrecompiled);
      return;
    }
    // only parcoords needs pick layer
    if (d.pick && !fullLayout._has('parcoords')) return;
    try {
      d.regl = createRegl({
        canvas: this,
        attributes: {
          antialias: !d.pick,
          preserveDrawingBuffer: true
        },
        pixelRatio: gd._context.plotGlPixelRatio || __webpack_require__.g.devicePixelRatio,
        extensions: extensions || [],
        cachedCode: reglPrecompiled || {}
      });
    } catch (e) {
      success = false;
    }
    if (!d.regl) success = false;
    if (success) {
      this.addEventListener('webglcontextlost', function (event) {
        if (gd && gd.emit) {
          gd.emit('plotly_webglcontextlost', {
            event: event,
            layer: d.key
          });
        }
      }, false);
    }
  });
  if (!success) {
    showNoWebGlMsg({
      container: fullLayout._glcontainer.node()
    });
  }
  return success;
};

/***/ }),

/***/ 32521:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isNumeric = __webpack_require__(10721);
var isMobileOrTablet = __webpack_require__(13087);
module.exports = function preserveDrawingBuffer(opts) {
  var ua;
  if (opts && opts.hasOwnProperty('userAgent')) {
    ua = opts.userAgent;
  } else {
    ua = getUserAgent();
  }
  if (typeof ua !== 'string') return true;
  var enable = isMobileOrTablet({
    ua: {
      headers: {
        'user-agent': ua
      }
    },
    tablet: true,
    featureDetect: false
  });
  if (!enable) {
    var allParts = ua.split(' ');
    for (var i = 1; i < allParts.length; i++) {
      var part = allParts[i];
      if (part.indexOf('Safari') !== -1) {
        // find Safari version
        for (var k = i - 1; k > -1; k--) {
          var prevPart = allParts[k];
          if (prevPart.substr(0, 8) === 'Version/') {
            var v = prevPart.substr(8).split('.')[0];
            if (isNumeric(v)) v = +v;
            if (v >= 13) return true;
          }
        }
      }
    }
  }
  return enable;
};
function getUserAgent() {
  // similar to https://github.com/juliangruber/is-mobile/blob/91ca39ccdd4cfc5edfb5391e2515b923a730fbea/index.js#L14-L17
  var ua;
  if (typeof navigator !== 'undefined') {
    ua = navigator.userAgent;
  }
  if (ua && ua.headers && typeof ua.headers['user-agent'] === 'string') {
    ua = ua.headers['user-agent'];
  }
  return ua;
}

/***/ }),

/***/ 36539:
/***/ (function(module) {

"use strict";


/**
 * Push array with unique items
 *
 * Ignores falsy items, except 0 so we can use it to construct arrays of indices.
 *
 * @param {array} array
 *  array to be filled
 * @param {any} item
 *  item to be or not to be inserted
 * @return {array}
 *  ref to array (now possibly containing one more item)
 *
 */
module.exports = function pushUnique(array, item) {
  if (item instanceof RegExp) {
    var itemStr = item.toString();
    for (var i = 0; i < array.length; i++) {
      if (array[i] instanceof RegExp && array[i].toString() === itemStr) {
        return array;
      }
    }
    array.push(item);
  } else if ((item || item === 0) && array.indexOf(item) === -1) array.push(item);
  return array;
};

/***/ }),

/***/ 40486:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var dfltConfig = (__webpack_require__(24452).dfltConfig);

/**
 * Copy arg array *without* removing `undefined` values from objects.
 *
 * @param gd
 * @param args
 * @returns {Array}
 */
function copyArgArray(gd, args) {
  var copy = [];
  var arg;
  for (var i = 0; i < args.length; i++) {
    arg = args[i];
    if (arg === gd) copy[i] = arg;else if (typeof arg === 'object') {
      copy[i] = Array.isArray(arg) ? Lib.extendDeep([], arg) : Lib.extendDeepAll({}, arg);
    } else copy[i] = arg;
  }
  return copy;
}

// -----------------------------------------------------
// Undo/Redo queue for plots
// -----------------------------------------------------

var queue = {};

// TODO: disable/enable undo and redo buttons appropriately

/**
 * Add an item to the undoQueue for a graphDiv
 *
 * @param gd
 * @param undoFunc Function undo this operation
 * @param undoArgs Args to supply undoFunc with
 * @param redoFunc Function to redo this operation
 * @param redoArgs Args to supply redoFunc with
 */
queue.add = function (gd, undoFunc, undoArgs, redoFunc, redoArgs) {
  var queueObj, queueIndex;

  // make sure we have the queue and our position in it
  gd.undoQueue = gd.undoQueue || {
    index: 0,
    queue: [],
    sequence: false
  };
  queueIndex = gd.undoQueue.index;

  // if we're already playing an undo or redo, or if this is an auto operation
  // (like pane resize... any others?) then we don't save this to the undo queue
  if (gd.autoplay) {
    if (!gd.undoQueue.inSequence) gd.autoplay = false;
    return;
  }

  // if we're not in a sequence or are just starting, we need a new queue item
  if (!gd.undoQueue.sequence || gd.undoQueue.beginSequence) {
    queueObj = {
      undo: {
        calls: [],
        args: []
      },
      redo: {
        calls: [],
        args: []
      }
    };
    gd.undoQueue.queue.splice(queueIndex, gd.undoQueue.queue.length - queueIndex, queueObj);
    gd.undoQueue.index += 1;
  } else {
    queueObj = gd.undoQueue.queue[queueIndex - 1];
  }
  gd.undoQueue.beginSequence = false;

  // we unshift to handle calls for undo in a forward for loop later
  if (queueObj) {
    queueObj.undo.calls.unshift(undoFunc);
    queueObj.undo.args.unshift(undoArgs);
    queueObj.redo.calls.push(redoFunc);
    queueObj.redo.args.push(redoArgs);
  }
  if (gd.undoQueue.queue.length > dfltConfig.queueLength) {
    gd.undoQueue.queue.shift();
    gd.undoQueue.index--;
  }
};

/**
 * Begin a sequence of undoQueue changes
 *
 * @param gd
 */
queue.startSequence = function (gd) {
  gd.undoQueue = gd.undoQueue || {
    index: 0,
    queue: [],
    sequence: false
  };
  gd.undoQueue.sequence = true;
  gd.undoQueue.beginSequence = true;
};

/**
 * Stop a sequence of undoQueue changes
 *
 * Call this *after* you're sure your undo chain has ended
 *
 * @param gd
 */
queue.stopSequence = function (gd) {
  gd.undoQueue = gd.undoQueue || {
    index: 0,
    queue: [],
    sequence: false
  };
  gd.undoQueue.sequence = false;
  gd.undoQueue.beginSequence = false;
};

/**
 * Move one step back in the undo queue, and undo the object there.
 *
 * @param gd
 */
queue.undo = function undo(gd) {
  var queueObj, i;
  if (gd.undoQueue === undefined || isNaN(gd.undoQueue.index) || gd.undoQueue.index <= 0) {
    return;
  }

  // index is pointing to next *forward* queueObj, point to the one we're undoing
  gd.undoQueue.index--;

  // get the queueObj for instructions on how to undo
  queueObj = gd.undoQueue.queue[gd.undoQueue.index];

  // this sequence keeps things from adding to the queue during undo/redo
  gd.undoQueue.inSequence = true;
  for (i = 0; i < queueObj.undo.calls.length; i++) {
    queue.plotDo(gd, queueObj.undo.calls[i], queueObj.undo.args[i]);
  }
  gd.undoQueue.inSequence = false;
  gd.autoplay = false;
};

/**
 * Redo the current object in the undo, then move forward in the queue.
 *
 * @param gd
 */
queue.redo = function redo(gd) {
  var queueObj, i;
  if (gd.undoQueue === undefined || isNaN(gd.undoQueue.index) || gd.undoQueue.index >= gd.undoQueue.queue.length) {
    return;
  }

  // get the queueObj for instructions on how to undo
  queueObj = gd.undoQueue.queue[gd.undoQueue.index];

  // this sequence keeps things from adding to the queue during undo/redo
  gd.undoQueue.inSequence = true;
  for (i = 0; i < queueObj.redo.calls.length; i++) {
    queue.plotDo(gd, queueObj.redo.calls[i], queueObj.redo.args[i]);
  }
  gd.undoQueue.inSequence = false;
  gd.autoplay = false;

  // index is pointing to the thing we just redid, move it
  gd.undoQueue.index++;
};

/**
 * Called by undo/redo to make the actual changes.
 *
 * Not meant to be called publically, but included for mocking out in tests.
 *
 * @param gd
 * @param func
 * @param args
 */
queue.plotDo = function (gd, func, args) {
  gd.autoplay = true;

  // this *won't* copy gd and it preserves `undefined` properties!
  args = copyArgArray(gd, args);

  // call the supplied function
  func.apply(null, args);
};
module.exports = queue;

/***/ }),

/***/ 90694:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


/*
 * make a regex for matching counter ids/names ie xaxis, xaxis2, xaxis10...
 *
 * @param {string} head: the head of the pattern, eg 'x' matches 'x', 'x2', 'x10' etc.
 *      'xy' is a special case for cartesian subplots: it matches 'x2y3' etc
 * @param {Optional(string)} tail: a fixed piece after the id
 *      eg counterRegex('scene', '.annotations') for scene2.annotations etc.
 * @param {boolean} openEnded: if true, the string may continue past the match.
 * @param {boolean} matchBeginning: if false, the string may start before the match.
 */
exports.counter = function (head, tail, openEnded, matchBeginning) {
  var fullTail = (tail || '') + (openEnded ? '' : '$');
  var startWithPrefix = matchBeginning === false ? '' : '^';
  if (head === 'xy') {
    return new RegExp(startWithPrefix + 'x([2-9]|[1-9][0-9]+)?y([2-9]|[1-9][0-9]+)?' + fullTail);
  }
  return new RegExp(startWithPrefix + head + '([2-9]|[1-9][0-9]+)?' + fullTail);
};

/***/ }),

/***/ 82047:
/***/ (function(module) {

"use strict";


// ASCEND: chop off the last nesting level - either [<n>] or .<key> - to ascend
// the attribute tree. the remaining attrString is in match[1]
var ASCEND = /^(.*)(\.[^\.\[\]]+|\[\d\])$/;

// SIMPLEATTR: is this an un-nested attribute? (no dots or brackets)
var SIMPLEATTR = /^[^\.\[\]]+$/;

/*
 * calculate a relative attribute string, similar to a relative path
 *
 * @param {string} baseAttr:
 *   an attribute string, such as 'annotations[3].x'. The "current location"
 *   is the attribute string minus the last component ('annotations[3]')
 * @param {string} relativeAttr:
 *   a route to the desired attribute string, using '^' to ascend
 *
 * @return {string} attrString:
 *   for example:
 *     relativeAttr('annotations[3].x', 'y') = 'annotations[3].y'
 *     relativeAttr('annotations[3].x', '^[2].z') = 'annotations[2].z'
 *     relativeAttr('annotations[3].x', '^^margin') = 'margin'
 *     relativeAttr('annotations[3].x', '^^margin.r') = 'margin.r'
 */
module.exports = function (baseAttr, relativeAttr) {
  while (relativeAttr) {
    var match = baseAttr.match(ASCEND);
    if (match) baseAttr = match[1];else if (baseAttr.match(SIMPLEATTR)) baseAttr = '';else throw new Error('bad relativeAttr call:' + [baseAttr, relativeAttr]);
    if (relativeAttr.charAt(0) === '^') relativeAttr = relativeAttr.slice(1);else break;
  }
  if (baseAttr && relativeAttr.charAt(0) !== '[') {
    return baseAttr + '.' + relativeAttr;
  }
  return baseAttr + relativeAttr;
};

/***/ }),

/***/ 80428:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isArrayOrTypedArray = (__webpack_require__(87800).isArrayOrTypedArray);
var isPlainObject = __webpack_require__(56174);

/**
 * Relink private _keys and keys with a function value from one container
 * to the new container.
 * Relink means copying if object is pass-by-value and adding a reference
 * if object is pass-by-ref.
 * This prevents deepCopying massive structures like a webgl context.
 */
module.exports = function relinkPrivateKeys(toContainer, fromContainer) {
  for (var k in fromContainer) {
    var fromVal = fromContainer[k];
    var toVal = toContainer[k];
    if (toVal === fromVal) continue;
    if (k.charAt(0) === '_' || typeof fromVal === 'function') {
      // if it already exists at this point, it's something
      // that we recreate each time around, so ignore it
      if (k in toContainer) continue;
      toContainer[k] = fromVal;
    } else if (isArrayOrTypedArray(fromVal) && isArrayOrTypedArray(toVal) && isPlainObject(fromVal[0])) {
      // filter out data_array items that can contain user objects
      // most of the time the toVal === fromVal check will catch these early
      // but if the user makes new ones we also don't want to recurse in.
      if (k === 'customdata' || k === 'ids') continue;

      // recurse into arrays containers
      var minLen = Math.min(fromVal.length, toVal.length);
      for (var j = 0; j < minLen; j++) {
        if (toVal[j] !== fromVal[j] && isPlainObject(fromVal[j]) && isPlainObject(toVal[j])) {
          relinkPrivateKeys(toVal[j], fromVal[j]);
        }
      }
    } else if (isPlainObject(fromVal) && isPlainObject(toVal)) {
      // recurse into objects, but only if they still exist
      relinkPrivateKeys(toVal, fromVal);
      if (!Object.keys(toVal).length) delete toContainer[k];
    }
  }
};

/***/ }),

/***/ 98813:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var isNumeric = __webpack_require__(10721);
var loggers = __webpack_require__(48636);
var identity = __webpack_require__(29527);
var BADNUM = (__webpack_require__(63821).BADNUM);

// don't trust floating point equality - fraction of bin size to call
// "on the line" and ensure that they go the right way specified by
// linelow
var roundingError = 1e-9;

/**
 * findBin - find the bin for val - note that it can return outside the
 * bin range any pos. or neg. integer for linear bins, or -1 or
 * bins.length-1 for explicit.
 * bins is either an object {start,size,end} or an array length #bins+1
 * bins can be either increasing or decreasing but must be monotonic
 * for linear bins, we can just calculate. For listed bins, run a binary
 * search linelow (truthy) says the bin boundary should be attributed to
 * the lower bin rather than the default upper bin
 */
exports.findBin = function (val, bins, linelow) {
  if (isNumeric(bins.start)) {
    return linelow ? Math.ceil((val - bins.start) / bins.size - roundingError) - 1 : Math.floor((val - bins.start) / bins.size + roundingError);
  } else {
    var n1 = 0;
    var n2 = bins.length;
    var c = 0;
    var binSize = n2 > 1 ? (bins[n2 - 1] - bins[0]) / (n2 - 1) : 1;
    var n, test;
    if (binSize >= 0) {
      test = linelow ? lessThan : lessOrEqual;
    } else {
      test = linelow ? greaterOrEqual : greaterThan;
    }
    val += binSize * roundingError * (linelow ? -1 : 1) * (binSize >= 0 ? 1 : -1);
    // c is just to avoid infinite loops if there's an error
    while (n1 < n2 && c++ < 100) {
      n = Math.floor((n1 + n2) / 2);
      if (test(bins[n], val)) n1 = n + 1;else n2 = n;
    }
    if (c > 90) loggers.log('Long binary search...');
    return n1 - 1;
  }
};
function lessThan(a, b) {
  return a < b;
}
function lessOrEqual(a, b) {
  return a <= b;
}
function greaterThan(a, b) {
  return a > b;
}
function greaterOrEqual(a, b) {
  return a >= b;
}
exports.sorterAsc = function (a, b) {
  return a - b;
};
exports.sorterDes = function (a, b) {
  return b - a;
};

/**
 * find distinct values in an array, lumping together ones that appear to
 * just be off by a rounding error
 * return the distinct values and the minimum difference between any two
 */
exports.distinctVals = function (valsIn) {
  var vals = valsIn.slice(); // otherwise we sort the original array...
  vals.sort(exports.sorterAsc); // undefined listed in the end - also works on IE11

  var last;
  for (last = vals.length - 1; last > -1; last--) {
    if (vals[last] !== BADNUM) break;
  }
  var minDiff = vals[last] - vals[0] || 1;
  var errDiff = minDiff / (last || 1) / 10000;
  var newVals = [];
  var preV;
  for (var i = 0; i <= last; i++) {
    var v = vals[i];

    // make sure values aren't just off by a rounding error
    var diff = v - preV;
    if (preV === undefined) {
      newVals.push(v);
      preV = v;
    } else if (diff > errDiff) {
      minDiff = Math.min(minDiff, diff);
      newVals.push(v);
      preV = v;
    }
  }
  return {
    vals: newVals,
    minDiff: minDiff
  };
};

/**
 * return the smallest element from (sorted) array arrayIn that's bigger than val,
 * or (reverse) the largest element smaller than val
 * used to find the best tick given the minimum (non-rounded) tick
 * particularly useful for date/time where things are not powers of 10
 * binary search is probably overkill here...
 */
exports.roundUp = function (val, arrayIn, reverse) {
  var low = 0;
  var high = arrayIn.length - 1;
  var mid;
  var c = 0;
  var dlow = reverse ? 0 : 1;
  var dhigh = reverse ? 1 : 0;
  var rounded = reverse ? Math.ceil : Math.floor;
  // c is just to avoid infinite loops if there's an error
  while (low < high && c++ < 100) {
    mid = rounded((low + high) / 2);
    if (arrayIn[mid] <= val) low = mid + dlow;else high = mid - dhigh;
  }
  return arrayIn[low];
};

/**
 * Tweak to Array.sort(sortFn) that improves performance for pre-sorted arrays
 *
 * Note that newer browsers (such as Chrome v70+) are starting to pick up
 * on pre-sorted arrays which may render the following optimization unnecessary
 * in the future.
 *
 * Motivation: sometimes we need to sort arrays but the input is likely to
 * already be sorted. Browsers don't seem to pick up on pre-sorted arrays,
 * and in fact Chrome is actually *slower* sorting pre-sorted arrays than purely
 * random arrays. FF is at least faster if the array is pre-sorted, but still
 * not as fast as it could be.
 * Here's how this plays out sorting a length-1e6 array:
 *
 * Calls to Sort FN  |  Chrome bare  |  FF bare  |  Chrome tweak  |  FF tweak
 *                   |  v68.0 Mac    |  v61.0 Mac|                |
 * ------------------+---------------+-----------+----------------+------------
 * ordered           |  30.4e6       |  10.1e6   |  1e6           |  1e6
 * reversed          |  29.4e6       |  9.9e6    |  1e6 + reverse |  1e6 + reverse
 * random            |  ~21e6        |  ~18.7e6  |  ~21e6         |  ~18.7e6
 *
 * So this is a substantial win for pre-sorted (ordered or exactly reversed)
 * arrays. Including this wrapper on an unsorted array adds a penalty that will
 * in general be only a few calls to the sort function. The only case this
 * penalty will be significant is if the array is mostly sorted but there are
 * a few unsorted items near the end, but the penalty is still at most N calls
 * out of (for N=1e6) ~20N total calls
 *
 * @param {Array} array: the array, to be sorted in place
 * @param {function} sortFn: As in Array.sort, function(a, b) that puts
 *     item a before item b if the return is negative, a after b if positive,
 *     and no change if zero.
 * @return {Array}: the original array, sorted in place.
 */
exports.sort = function (array, sortFn) {
  var notOrdered = 0;
  var notReversed = 0;
  for (var i = 1; i < array.length; i++) {
    var pairOrder = sortFn(array[i], array[i - 1]);
    if (pairOrder < 0) notOrdered = 1;else if (pairOrder > 0) notReversed = 1;
    if (notOrdered && notReversed) return array.sort(sortFn);
  }
  return notReversed ? array : array.reverse();
};

/**
 * find index in array 'arr' that minimizes 'fn'
 *
 * @param {array} arr : array where to search
 * @param {fn (optional)} fn : function to minimize,
 *   if not given, fn is the identity function
 * @return {integer}
 */
exports.findIndexOfMin = function (arr, fn) {
  fn = fn || identity;
  var min = Infinity;
  var ind;
  for (var i = 0; i < arr.length; i++) {
    var v = fn(arr[i]);
    if (v < min) {
      min = v;
      ind = i;
    }
  }
  return ind;
};

/***/ }),

/***/ 27983:
/***/ (function(module) {

"use strict";


// works with our CSS cursor classes (see css/_cursor.scss)
// to apply cursors to d3 single-element selections.
// omit cursor to revert to the default.
module.exports = function setCursor(el3, csr) {
  (el3.attr('class') || '').split(' ').forEach(function (cls) {
    if (cls.indexOf('cursor-') === 0) el3.classed(cls, false);
  });
  if (csr) el3.classed('cursor-' + csr, true);
};

/***/ }),

/***/ 97464:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Color = __webpack_require__(78766);
var noop = function () {};

/**
 * Prints a no webgl error message into the scene container
 * @param {scene instance} scene
 *
 * Expects 'scene' to have property 'container'
 *
 */
module.exports = function showNoWebGlMsg(scene) {
  for (var prop in scene) {
    if (typeof scene[prop] === 'function') scene[prop] = noop;
  }
  scene.destroy = function () {
    scene.container.parentNode.removeChild(scene.container);
  };
  var div = document.createElement('div');
  div.className = 'no-webgl';
  div.style.cursor = 'pointer';
  div.style.fontSize = '24px';
  div.style.color = Color.defaults[0];
  div.style.position = 'absolute';
  div.style.left = div.style.top = '0px';
  div.style.width = div.style.height = '100%';
  div.style['background-color'] = Color.lightLine;
  div.style['z-index'] = 30;
  var p = document.createElement('p');
  p.textContent = 'WebGL is not supported by your browser - visit https://get.webgl.org for more info';
  p.style.position = 'relative';
  p.style.top = '50%';
  p.style.left = '50%';
  p.style.height = '30%';
  p.style.width = '50%';
  p.style.margin = '-15% 0 0 -25%';
  div.appendChild(p);
  scene.container.appendChild(div);
  scene.container.style.background = '#FFFFFF';
  scene.container.onclick = function () {
    window.open('https://get.webgl.org');
  };

  // return before setting up camera and onrender methods
  return false;
};

/***/ }),

/***/ 62994:
/***/ (function(module) {

"use strict";


module.exports = function sortObjectKeys(obj) {
  return Object.keys(obj).sort();
};

/***/ }),

/***/ 89258:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var isNumeric = __webpack_require__(10721);
var isArrayOrTypedArray = (__webpack_require__(87800).isArrayOrTypedArray);

/**
 * aggNums() returns the result of an aggregate function applied to an array of
 * values, where non-numerical values have been tossed out.
 *
 * @param {function} f - aggregation function (e.g., Math.min)
 * @param {Number} v - initial value (continuing from previous calls)
 *      if there's no continuing value, use null for selector-type
 *      functions (max,min), or 0 for summations
 * @param {Array} a - array to aggregate (may be nested, we will recurse,
 *                    but all elements must have the same dimension)
 * @param {Number} len - maximum length of a to aggregate
 * @return {Number} - result of f applied to a starting from v
 */
exports.aggNums = function (f, v, a, len) {
  var i, b;
  if (!len || len > a.length) len = a.length;
  if (!isNumeric(v)) v = false;
  if (isArrayOrTypedArray(a[0])) {
    b = new Array(len);
    for (i = 0; i < len; i++) b[i] = exports.aggNums(f, v, a[i]);
    a = b;
  }
  for (i = 0; i < len; i++) {
    if (!isNumeric(v)) v = a[i];else if (isNumeric(a[i])) v = f(+v, +a[i]);
  }
  return v;
};

/**
 * mean & std dev functions using aggNums, so it handles non-numerics nicely
 * even need to use aggNums instead of .length, to toss out non-numerics
 */
exports.len = function (data) {
  return exports.aggNums(function (a) {
    return a + 1;
  }, 0, data);
};
exports.mean = function (data, len) {
  if (!len) len = exports.len(data);
  return exports.aggNums(function (a, b) {
    return a + b;
  }, 0, data) / len;
};
exports.geometricMean = function (data, len) {
  if (!len) len = exports.len(data);
  return Math.pow(exports.aggNums(function (a, b) {
    return a * b;
  }, 1, data), 1 / len);
};
exports.midRange = function (numArr) {
  if (numArr === undefined || numArr.length === 0) return undefined;
  return (exports.aggNums(Math.max, null, numArr) + exports.aggNums(Math.min, null, numArr)) / 2;
};
exports.variance = function (data, len, mean) {
  if (!len) len = exports.len(data);
  if (!isNumeric(mean)) mean = exports.mean(data, len);
  return exports.aggNums(function (a, b) {
    return a + Math.pow(b - mean, 2);
  }, 0, data) / len;
};
exports.stdev = function (data, len, mean) {
  return Math.sqrt(exports.variance(data, len, mean));
};

/**
 * median of a finite set of numbers
 * reference page: https://en.wikipedia.org/wiki/Median#Finite_set_of_numbers
**/
exports.median = function (data) {
  var b = data.slice().sort();
  return exports.interp(b, 0.5);
};

/**
 * interp() computes a percentile (quantile) for a given distribution.
 * We interpolate the distribution (to compute quantiles, we follow method #10 here:
 * http://jse.amstat.org/v14n3/langford.html).
 * Typically the index or rank (n * arr.length) may be non-integer.
 * For reference: ends are clipped to the extreme values in the array;
 * For box plots: index you get is half a point too high (see
 * http://en.wikipedia.org/wiki/Percentile#Nearest_rank) but note that this definition
 * indexes from 1 rather than 0, so we subtract 1/2 (instead of add).
 *
 * @param {Array} arr - This array contains the values that make up the distribution.
 * @param {Number} n - Between 0 and 1, n = p/100 is such that we compute the p^th percentile.
 * For example, the 50th percentile (or median) corresponds to n = 0.5
 * @return {Number} - percentile
 */
exports.interp = function (arr, n) {
  if (!isNumeric(n)) throw 'n should be a finite number';
  n = n * arr.length - 0.5;
  if (n < 0) return arr[0];
  if (n > arr.length - 1) return arr[arr.length - 1];
  var frac = n % 1;
  return frac * arr[Math.ceil(n)] + (1 - frac) * arr[Math.floor(n)];
};

/***/ }),

/***/ 55010:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var rgba = __webpack_require__(162);
function str2RgbaArray(color) {
  if (!color) return [0, 0, 0, 1];
  return rgba(color);
}
module.exports = str2RgbaArray;

/***/ }),

/***/ 95544:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var constants = __webpack_require__(1837);
var Drawing = __webpack_require__(62203);
var Lib = __webpack_require__(34809);
var _supportsPixelated = null;

/**
 * Check browser support for pixelated image rendering
 *
 * @return {boolean}
 */
function supportsPixelatedImage() {
  if (_supportsPixelated !== null) {
    // only run the feature detection once
    return _supportsPixelated;
  }
  _supportsPixelated = false;

  // @see https://github.com/plotly/plotly.js/issues/6604
  var unsupportedBrowser = Lib.isIE() || Lib.isSafari() || Lib.isIOS();
  if (window.navigator.userAgent && !unsupportedBrowser) {
    var declarations = Array.from(constants.CSS_DECLARATIONS).reverse();
    var supports = window.CSS && window.CSS.supports || window.supportsCSS;
    if (typeof supports === 'function') {
      _supportsPixelated = declarations.some(function (d) {
        return supports.apply(null, d);
      });
    } else {
      var image3 = Drawing.tester.append('image').attr('style', constants.STYLE);
      var cStyles = window.getComputedStyle(image3.node());
      var imageRendering = cStyles.imageRendering;
      _supportsPixelated = declarations.some(function (d) {
        var value = d[1];
        return imageRendering === value || imageRendering === value.toLowerCase();
      });
      image3.remove();
    }
  }
  return _supportsPixelated;
}
module.exports = supportsPixelatedImage;

/***/ }),

/***/ 30635:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


/* global MathJax:false */
var d3 = __webpack_require__(45568);
var Lib = __webpack_require__(34809);
var strTranslate = Lib.strTranslate;
var xmlnsNamespaces = __webpack_require__(62972);
var LINE_SPACING = (__webpack_require__(4530).LINE_SPACING);

// text converter

var FIND_TEX = /([^$]*)([$]+[^$]*[$]+)([^$]*)/;
exports.convertToTspans = function (_context, gd, _callback) {
  var str = _context.text();

  // Until we get tex integrated more fully (so it can be used along with non-tex)
  // allow some elements to prohibit it by attaching 'data-notex' to the original
  var tex = !_context.attr('data-notex') && gd && gd._context.typesetMath && typeof MathJax !== 'undefined' && str.match(FIND_TEX);
  var parent = d3.select(_context.node().parentNode);
  if (parent.empty()) return;
  var svgClass = _context.attr('class') ? _context.attr('class').split(' ')[0] : 'text';
  svgClass += '-math';
  parent.selectAll('svg.' + svgClass).remove();
  parent.selectAll('g.' + svgClass + '-group').remove();
  _context.style('display', null).attr({
    // some callers use data-unformatted *from the <text> element* in 'cancel'
    // so we need it here even if we're going to turn it into math
    // these two (plus style and text-anchor attributes) form the key we're
    // going to use for Drawing.bBox
    'data-unformatted': str,
    'data-math': 'N'
  });
  function showText() {
    if (!parent.empty()) {
      svgClass = _context.attr('class') + '-math';
      parent.select('svg.' + svgClass).remove();
    }
    _context.text('').style('white-space', 'pre');
    var hasLink = buildSVGText(_context.node(), str);
    if (hasLink) {
      // at least in Chrome, pointer-events does not seem
      // to be honored in children of <text> elements
      // so if we have an anchor, we have to make the
      // whole element respond
      _context.style('pointer-events', 'all');
    }
    exports.positionText(_context);
    if (_callback) _callback.call(_context);
  }
  if (tex) {
    (gd && gd._promises || []).push(new Promise(function (resolve) {
      _context.style('display', 'none');
      var fontSize = parseInt(_context.node().style.fontSize, 10);
      var config = {
        fontSize: fontSize
      };
      texToSVG(tex[2], config, function (_svgEl, _glyphDefs, _svgBBox) {
        parent.selectAll('svg.' + svgClass).remove();
        parent.selectAll('g.' + svgClass + '-group').remove();
        var newSvg = _svgEl && _svgEl.select('svg');
        if (!newSvg || !newSvg.node()) {
          showText();
          resolve();
          return;
        }
        var mathjaxGroup = parent.append('g').classed(svgClass + '-group', true).attr({
          'pointer-events': 'none',
          'data-unformatted': str,
          'data-math': 'Y'
        });
        mathjaxGroup.node().appendChild(newSvg.node());

        // stitch the glyph defs
        if (_glyphDefs && _glyphDefs.node()) {
          newSvg.node().insertBefore(_glyphDefs.node().cloneNode(true), newSvg.node().firstChild);
        }
        var w0 = _svgBBox.width;
        var h0 = _svgBBox.height;
        newSvg.attr({
          class: svgClass,
          height: h0,
          preserveAspectRatio: 'xMinYMin meet'
        }).style({
          overflow: 'visible',
          'pointer-events': 'none'
        });
        var fill = _context.node().style.fill || 'black';
        var g = newSvg.select('g');
        g.attr({
          fill: fill,
          stroke: fill
        });
        var bb = g.node().getBoundingClientRect();
        var w = bb.width;
        var h = bb.height;
        if (w > w0 || h > h0) {
          // this happen in firefox v82+ | see https://bugzilla.mozilla.org/show_bug.cgi?id=1709251 addressed
          // temporary fix:
          newSvg.style('overflow', 'hidden');
          bb = newSvg.node().getBoundingClientRect();
          w = bb.width;
          h = bb.height;
        }
        var x = +_context.attr('x');
        var y = +_context.attr('y');

        // font baseline is about 1/4 fontSize below centerline
        var textHeight = fontSize || _context.node().getBoundingClientRect().height;
        var dy = -textHeight / 4;
        if (svgClass[0] === 'y') {
          mathjaxGroup.attr({
            transform: 'rotate(' + [-90, x, y] + ')' + strTranslate(-w / 2, dy - h / 2)
          });
        } else if (svgClass[0] === 'l') {
          y = dy - h / 2;
        } else if (svgClass[0] === 'a' && svgClass.indexOf('atitle') !== 0) {
          x = 0;
          y = dy;
        } else {
          var anchor = _context.attr('text-anchor');
          x = x - w * (anchor === 'middle' ? 0.5 : anchor === 'end' ? 1 : 0);
          y = y + dy - h / 2;
        }
        newSvg.attr({
          x: x,
          y: y
        });
        if (_callback) _callback.call(_context, mathjaxGroup);
        resolve(mathjaxGroup);
      });
    }));
  } else showText();
  return _context;
};

// MathJax

var LT_MATCH = /(<|&lt;|&#60;)/g;
var GT_MATCH = /(>|&gt;|&#62;)/g;
function cleanEscapesForTex(s) {
  return s.replace(LT_MATCH, '\\lt ').replace(GT_MATCH, '\\gt ');
}
var inlineMath = [['$', '$'], ['\\(', '\\)']];
function texToSVG(_texString, _config, _callback) {
  var MathJaxVersion = parseInt((MathJax.version || '').split('.')[0]);
  if (MathJaxVersion !== 2 && MathJaxVersion !== 3) {
    Lib.warn('No MathJax version:', MathJax.version);
    return;
  }
  var originalRenderer, originalConfig, originalProcessSectionDelay, tmpDiv;
  var setConfig2 = function () {
    originalConfig = Lib.extendDeepAll({}, MathJax.Hub.config);
    originalProcessSectionDelay = MathJax.Hub.processSectionDelay;
    if (MathJax.Hub.processSectionDelay !== undefined) {
      // MathJax 2.5+ but not 3+
      MathJax.Hub.processSectionDelay = 0;
    }
    return MathJax.Hub.Config({
      messageStyle: 'none',
      tex2jax: {
        inlineMath: inlineMath
      },
      displayAlign: 'left'
    });
  };
  var setConfig3 = function () {
    originalConfig = Lib.extendDeepAll({}, MathJax.config);
    if (!MathJax.config.tex) {
      MathJax.config.tex = {};
    }
    MathJax.config.tex.inlineMath = inlineMath;
  };
  var setRenderer2 = function () {
    originalRenderer = MathJax.Hub.config.menuSettings.renderer;
    if (originalRenderer !== 'SVG') {
      return MathJax.Hub.setRenderer('SVG');
    }
  };
  var setRenderer3 = function () {
    originalRenderer = MathJax.config.startup.output;
    if (originalRenderer !== 'svg') {
      MathJax.config.startup.output = 'svg';
    }
  };
  var initiateMathJax = function () {
    var randomID = 'math-output-' + Lib.randstr({}, 64);
    tmpDiv = d3.select('body').append('div').attr({
      id: randomID
    }).style({
      visibility: 'hidden',
      position: 'absolute',
      'font-size': _config.fontSize + 'px'
    }).text(cleanEscapesForTex(_texString));
    var tmpNode = tmpDiv.node();
    return MathJaxVersion === 2 ? MathJax.Hub.Typeset(tmpNode) : MathJax.typeset([tmpNode]);
  };
  var finalizeMathJax = function () {
    var sel = tmpDiv.select(MathJaxVersion === 2 ? '.MathJax_SVG' : '.MathJax');
    var node = !sel.empty() && tmpDiv.select('svg').node();
    if (!node) {
      Lib.log('There was an error in the tex syntax.', _texString);
      _callback();
    } else {
      var nodeBBox = node.getBoundingClientRect();
      var glyphDefs;
      if (MathJaxVersion === 2) {
        glyphDefs = d3.select('body').select('#MathJax_SVG_glyphs');
      } else {
        glyphDefs = sel.select('defs');
      }
      _callback(sel, glyphDefs, nodeBBox);
    }
    tmpDiv.remove();
  };
  var resetRenderer2 = function () {
    if (originalRenderer !== 'SVG') {
      return MathJax.Hub.setRenderer(originalRenderer);
    }
  };
  var resetRenderer3 = function () {
    if (originalRenderer !== 'svg') {
      MathJax.config.startup.output = originalRenderer;
    }
  };
  var resetConfig2 = function () {
    if (originalProcessSectionDelay !== undefined) {
      MathJax.Hub.processSectionDelay = originalProcessSectionDelay;
    }
    return MathJax.Hub.Config(originalConfig);
  };
  var resetConfig3 = function () {
    MathJax.config = originalConfig;
  };
  if (MathJaxVersion === 2) {
    MathJax.Hub.Queue(setConfig2, setRenderer2, initiateMathJax, finalizeMathJax, resetRenderer2, resetConfig2);
  } else if (MathJaxVersion === 3) {
    setConfig3();
    setRenderer3();
    MathJax.startup.defaultReady();
    MathJax.startup.promise.then(function () {
      initiateMathJax();
      finalizeMathJax();
      resetRenderer3();
      resetConfig3();
    });
  }
}
var TAG_STYLES = {
  // would like to use baseline-shift for sub/sup but FF doesn't support it
  // so we need to use dy along with the uber hacky shift-back-to
  // baseline below
  sup: 'font-size:70%',
  sub: 'font-size:70%',
  s: 'text-decoration:line-through',
  u: 'text-decoration:underline',
  b: 'font-weight:bold',
  i: 'font-style:italic',
  a: 'cursor:pointer',
  span: '',
  em: 'font-style:italic;font-weight:bold'
};

// baseline shifts for sub and sup
var SHIFT_DY = {
  sub: '0.3em',
  sup: '-0.6em'
};
// reset baseline by adding a tspan (empty except for a zero-width space)
// with dy of -70% * SHIFT_DY (because font-size=70%)
var RESET_DY = {
  sub: '-0.21em',
  sup: '0.42em'
};
var ZERO_WIDTH_SPACE = '\u200b';

/*
 * Whitelist of protocols in user-supplied urls. Mostly we want to avoid javascript
 * and related attack vectors. The empty items are there for IE, that in various
 * versions treats relative paths as having different flavors of no protocol, while
 * other browsers have these explicitly inherit the protocol of the page they're in.
 */
var PROTOCOLS = ['http:', 'https:', 'mailto:', '', undefined, ':'];
var NEWLINES = exports.NEWLINES = /(\r\n?|\n)/g;
var SPLIT_TAGS = /(<[^<>]*>)/;
var ONE_TAG = /<(\/?)([^ >]*)(\s+(.*))?>/i;
var BR_TAG = /<br(\s+.*)?>/i;
exports.BR_TAG_ALL = /<br(\s+.*)?>/gi;

/*
 * style and href: pull them out of either single or double quotes. Also
 * - target: (_blank|_self|_parent|_top|framename)
 *     note that you can't use target to get a popup but if you use popup,
 *     a `framename` will be passed along as the name of the popup window.
 *     per the spec, cannot contain whitespace.
 *     for backward compatibility we default to '_blank'
 * - popup: a custom one for us to enable popup (new window) links. String
 *     for window.open -> strWindowFeatures, like 'menubar=yes,width=500,height=550'
 *     note that at least in Chrome, you need to give at least one property
 *     in this string or the page will open in a new tab anyway. We follow this
 *     convention and will not make a popup if this string is empty.
 *     per the spec, cannot contain whitespace.
 *
 * Because we hack in other attributes with style (sub & sup), drop any trailing
 * semicolon in user-supplied styles so we can consistently append the tag-dependent style
 *
 * These are for tag attributes; Chrome anyway will convert entities in
 * attribute values, but not in attribute names
 * you can test this by for example:
 * > p = document.createElement('p')
 * > p.innerHTML = '<span styl&#x65;="font-color:r&#x65;d;">Hi</span>'
 * > p.innerHTML
 * <- '<span styl&#x65;="font-color:red;">Hi</span>'
 */
var STYLEMATCH = /(^|[\s"'])style\s*=\s*("([^"]*);?"|'([^']*);?')/i;
var HREFMATCH = /(^|[\s"'])href\s*=\s*("([^"]*)"|'([^']*)')/i;
var TARGETMATCH = /(^|[\s"'])target\s*=\s*("([^"\s]*)"|'([^'\s]*)')/i;
var POPUPMATCH = /(^|[\s"'])popup\s*=\s*("([\w=,]*)"|'([\w=,]*)')/i;

// dedicated matcher for these quoted regexes, that can return their results
// in two different places
function getQuotedMatch(_str, re) {
  if (!_str) return null;
  var match = _str.match(re);
  var result = match && (match[3] || match[4]);
  return result && convertEntities(result);
}
var COLORMATCH = /(^|;)\s*color:/;

/**
 * Strip string of tags
 *
 * @param {string} _str : input string
 * @param {object} opts :
 * - len {number} max length of output string
 * - allowedTags {array} list of pseudo-html tags to NOT strip
 * @return {string}
 */
exports.plainText = function (_str, opts) {
  opts = opts || {};
  var len = opts.len !== undefined && opts.len !== -1 ? opts.len : Infinity;
  var allowedTags = opts.allowedTags !== undefined ? opts.allowedTags : ['br'];
  var ellipsis = '...';
  var eLen = ellipsis.length;
  var oldParts = _str.split(SPLIT_TAGS);
  var newParts = [];
  var prevTag = '';
  var l = 0;
  for (var i = 0; i < oldParts.length; i++) {
    var p = oldParts[i];
    var match = p.match(ONE_TAG);
    var tagType = match && match[2].toLowerCase();
    if (tagType) {
      // N.B. tags do not count towards string length
      if (allowedTags.indexOf(tagType) !== -1) {
        newParts.push(p);
        prevTag = tagType;
      }
    } else {
      var pLen = p.length;
      if (l + pLen < len) {
        newParts.push(p);
        l += pLen;
      } else if (l < len) {
        var pLen2 = len - l;
        if (prevTag && (prevTag !== 'br' || pLen2 <= eLen || pLen <= eLen)) {
          newParts.pop();
        }
        if (len > eLen) {
          newParts.push(p.substr(0, pLen2 - eLen) + ellipsis);
        } else {
          newParts.push(p.substr(0, pLen2));
        }
        break;
      }
      prevTag = '';
    }
  }
  return newParts.join('');
};

/*
 * N.B. HTML entities are listed without the leading '&' and trailing ';'
 * https://www.freeformatter.com/html-entities.html
 *
 * FWIW if we wanted to support the full set, it has 2261 entries:
 * https://www.w3.org/TR/html5/entities.json
 * though I notice that some of these are duplicates and/or are missing ";"
 * eg: "&amp;", "&amp", "&AMP;", and "&AMP" all map to "&"
 * We no longer need to include numeric entities here, these are now handled
 * by String.fromCodePoint/fromCharCode
 *
 * Anyway the only ones that are really important to allow are the HTML special
 * chars <, >, and &, because these ones can trigger special processing if not
 * replaced by the corresponding entity.
 */
var entityToUnicode = {
  mu: 'μ',
  amp: '&',
  lt: '<',
  gt: '>',
  nbsp: ' ',
  times: '×',
  plusmn: '±',
  deg: '°'
};

// NOTE: in general entities can contain uppercase too (so [a-zA-Z]) but all the
// ones we support use only lowercase. If we ever change that, update the regex.
var ENTITY_MATCH = /&(#\d+|#x[\da-fA-F]+|[a-z]+);/g;
function convertEntities(_str) {
  return _str.replace(ENTITY_MATCH, function (fullMatch, innerMatch) {
    var outChar;
    if (innerMatch.charAt(0) === '#') {
      // cannot use String.fromCodePoint in IE
      outChar = fromCodePoint(innerMatch.charAt(1) === 'x' ? parseInt(innerMatch.substr(2), 16) : parseInt(innerMatch.substr(1), 10));
    } else outChar = entityToUnicode[innerMatch];

    // as in regular HTML, if we didn't decode the entity just
    // leave the raw text in place.
    return outChar || fullMatch;
  });
}
exports.convertEntities = convertEntities;
function fromCodePoint(code) {
  // Don't allow overflow. In Chrome this turns into � but I feel like it's
  // more useful to just not convert it at all.
  if (code > 0x10FFFF) return;
  var stringFromCodePoint = String.fromCodePoint;
  if (stringFromCodePoint) return stringFromCodePoint(code);

  // IE doesn't have String.fromCodePoint
  // see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/fromCodePoint
  var stringFromCharCode = String.fromCharCode;
  if (code <= 0xFFFF) return stringFromCharCode(code);
  return stringFromCharCode((code >> 10) + 0xD7C0, code % 0x400 + 0xDC00);
}

/*
 * buildSVGText: convert our pseudo-html into SVG tspan elements, and attach these
 * to containerNode
 *
 * @param {svg text element} containerNode: the <text> node to insert this text into
 * @param {string} str: the pseudo-html string to convert to svg
 *
 * @returns {bool}: does the result contain any links? We need to handle the text element
 *   somewhat differently if it does, so just keep track of this when it happens.
 */
function buildSVGText(containerNode, str) {
  /*
   * Normalize behavior between IE and others wrt newlines and whitespace:pre
   * this combination makes IE barf https://github.com/plotly/plotly.js/issues/746
   * Chrome and FF display \n, \r, or \r\n as a space in this mode.
   * I feel like at some point we turned these into <br> but currently we don't so
   * I'm just going to cement what we do now in Chrome and FF
   */
  str = str.replace(NEWLINES, ' ');
  var hasLink = false;

  // as we're building the text, keep track of what elements we're nested inside
  // nodeStack will be an array of {node, type, style, href, target, popup}
  // where only type: 'a' gets the last 3 and node is only added when it's created
  var nodeStack = [];
  var currentNode;
  var currentLine = -1;
  function newLine() {
    currentLine++;
    var lineNode = document.createElementNS(xmlnsNamespaces.svg, 'tspan');
    d3.select(lineNode).attr({
      class: 'line',
      dy: currentLine * LINE_SPACING + 'em'
    });
    containerNode.appendChild(lineNode);
    currentNode = lineNode;
    var oldNodeStack = nodeStack;
    nodeStack = [{
      node: lineNode
    }];
    if (oldNodeStack.length > 1) {
      for (var i = 1; i < oldNodeStack.length; i++) {
        enterNode(oldNodeStack[i]);
      }
    }
  }
  function enterNode(nodeSpec) {
    var type = nodeSpec.type;
    var nodeAttrs = {};
    var nodeType;
    if (type === 'a') {
      nodeType = 'a';
      var target = nodeSpec.target;
      var href = nodeSpec.href;
      var popup = nodeSpec.popup;
      if (href) {
        nodeAttrs = {
          'xlink:xlink:show': target === '_blank' || target.charAt(0) !== '_' ? 'new' : 'replace',
          target: target,
          'xlink:xlink:href': href
        };
        if (popup) {
          // security: href and target are not inserted as code but
          // as attributes. popup is, but limited to /[A-Za-z0-9_=,]/
          nodeAttrs.onclick = 'window.open(this.href.baseVal,this.target.baseVal,"' + popup + '");return false;';
        }
      }
    } else nodeType = 'tspan';
    if (nodeSpec.style) nodeAttrs.style = nodeSpec.style;
    var newNode = document.createElementNS(xmlnsNamespaces.svg, nodeType);
    if (type === 'sup' || type === 'sub') {
      addTextNode(currentNode, ZERO_WIDTH_SPACE);
      currentNode.appendChild(newNode);
      var resetter = document.createElementNS(xmlnsNamespaces.svg, 'tspan');
      addTextNode(resetter, ZERO_WIDTH_SPACE);
      d3.select(resetter).attr('dy', RESET_DY[type]);
      nodeAttrs.dy = SHIFT_DY[type];
      currentNode.appendChild(newNode);
      currentNode.appendChild(resetter);
    } else {
      currentNode.appendChild(newNode);
    }
    d3.select(newNode).attr(nodeAttrs);
    currentNode = nodeSpec.node = newNode;
    nodeStack.push(nodeSpec);
  }
  function addTextNode(node, text) {
    node.appendChild(document.createTextNode(text));
  }
  function exitNode(type) {
    // A bare closing tag can't close the root node. If we encounter this it
    // means there's an extra closing tag that can just be ignored:
    if (nodeStack.length === 1) {
      Lib.log('Ignoring unexpected end tag </' + type + '>.', str);
      return;
    }
    var innerNode = nodeStack.pop();
    if (type !== innerNode.type) {
      Lib.log('Start tag <' + innerNode.type + '> doesnt match end tag <' + type + '>. Pretending it did match.', str);
    }
    currentNode = nodeStack[nodeStack.length - 1].node;
  }
  var hasLines = BR_TAG.test(str);
  if (hasLines) newLine();else {
    currentNode = containerNode;
    nodeStack = [{
      node: containerNode
    }];
  }
  var parts = str.split(SPLIT_TAGS);
  for (var i = 0; i < parts.length; i++) {
    var parti = parts[i];
    var match = parti.match(ONE_TAG);
    var tagType = match && match[2].toLowerCase();
    var tagStyle = TAG_STYLES[tagType];
    if (tagType === 'br') {
      newLine();
    } else if (tagStyle === undefined) {
      addTextNode(currentNode, convertEntities(parti));
    } else {
      // tag - open or close
      if (match[1]) {
        exitNode(tagType);
      } else {
        var extra = match[4];
        var nodeSpec = {
          type: tagType
        };

        // now add style, from both the tag name and any extra css
        // Most of the svg css that users will care about is just like html,
        // but font color is different (uses fill). Let our users ignore this.
        var css = getQuotedMatch(extra, STYLEMATCH);
        if (css) {
          css = css.replace(COLORMATCH, '$1 fill:');
          if (tagStyle) css += ';' + tagStyle;
        } else if (tagStyle) css = tagStyle;
        if (css) nodeSpec.style = css;
        if (tagType === 'a') {
          hasLink = true;
          var href = getQuotedMatch(extra, HREFMATCH);
          if (href) {
            var safeHref = sanitizeHref(href);
            if (safeHref) {
              nodeSpec.href = safeHref;
              nodeSpec.target = getQuotedMatch(extra, TARGETMATCH) || '_blank';
              nodeSpec.popup = getQuotedMatch(extra, POPUPMATCH);
            }
          }
        }
        enterNode(nodeSpec);
      }
    }
  }
  return hasLink;
}
function sanitizeHref(href) {
  var decodedHref = encodeURI(decodeURI(href));
  var dummyAnchor1 = document.createElement('a');
  var dummyAnchor2 = document.createElement('a');
  dummyAnchor1.href = href;
  dummyAnchor2.href = decodedHref;
  var p1 = dummyAnchor1.protocol;
  var p2 = dummyAnchor2.protocol;

  // check safe protocols
  if (PROTOCOLS.indexOf(p1) !== -1 && PROTOCOLS.indexOf(p2) !== -1) {
    return decodedHref;
  } else {
    return '';
  }
}

/*
 * sanitizeHTML: port of buildSVGText aimed at providing a clean subset of HTML
 * @param {string} str: the html string to clean
 * @returns {string}: a cleaned and normalized version of the input,
 *     supporting only a small subset of html
 */
exports.sanitizeHTML = function sanitizeHTML(str) {
  str = str.replace(NEWLINES, ' ');
  var rootNode = document.createElement('p');
  var currentNode = rootNode;
  var nodeStack = [];
  var parts = str.split(SPLIT_TAGS);
  for (var i = 0; i < parts.length; i++) {
    var parti = parts[i];
    var match = parti.match(ONE_TAG);
    var tagType = match && match[2].toLowerCase();
    if (tagType in TAG_STYLES) {
      if (match[1]) {
        if (nodeStack.length) {
          currentNode = nodeStack.pop();
        }
      } else {
        var extra = match[4];
        var css = getQuotedMatch(extra, STYLEMATCH);
        var nodeAttrs = css ? {
          style: css
        } : {};
        if (tagType === 'a') {
          var href = getQuotedMatch(extra, HREFMATCH);
          if (href) {
            var safeHref = sanitizeHref(href);
            if (safeHref) {
              nodeAttrs.href = safeHref;
              var target = getQuotedMatch(extra, TARGETMATCH);
              if (target) {
                nodeAttrs.target = target;
              }
            }
          }
        }
        var newNode = document.createElement(tagType);
        currentNode.appendChild(newNode);
        d3.select(newNode).attr(nodeAttrs);
        currentNode = newNode;
        nodeStack.push(newNode);
      }
    } else {
      currentNode.appendChild(document.createTextNode(convertEntities(parti)));
    }
  }
  var key = 'innerHTML'; // i.e. to avoid pass test-syntax
  return rootNode[key];
};
exports.lineCount = function lineCount(s) {
  return s.selectAll('tspan.line').size() || 1;
};
exports.positionText = function positionText(s, x, y) {
  return s.each(function () {
    var text = d3.select(this);
    function setOrGet(attr, val) {
      if (val === undefined) {
        val = text.attr(attr);
        if (val === null) {
          text.attr(attr, 0);
          val = 0;
        }
      } else text.attr(attr, val);
      return val;
    }
    var thisX = setOrGet('x', x);
    var thisY = setOrGet('y', y);
    if (this.nodeName === 'text') {
      text.selectAll('tspan.line').attr({
        x: thisX,
        y: thisY
      });
    }
  });
};
function alignHTMLWith(_base, container, options) {
  var alignH = options.horizontalAlign;
  var alignV = options.verticalAlign || 'top';
  var bRect = _base.node().getBoundingClientRect();
  var cRect = container.node().getBoundingClientRect();
  var thisRect;
  var getTop;
  var getLeft;
  if (alignV === 'bottom') {
    getTop = function () {
      return bRect.bottom - thisRect.height;
    };
  } else if (alignV === 'middle') {
    getTop = function () {
      return bRect.top + (bRect.height - thisRect.height) / 2;
    };
  } else {
    // default: top
    getTop = function () {
      return bRect.top;
    };
  }
  if (alignH === 'right') {
    getLeft = function () {
      return bRect.right - thisRect.width;
    };
  } else if (alignH === 'center') {
    getLeft = function () {
      return bRect.left + (bRect.width - thisRect.width) / 2;
    };
  } else {
    // default: left
    getLeft = function () {
      return bRect.left;
    };
  }
  return function () {
    thisRect = this.node().getBoundingClientRect();
    var x0 = getLeft() - cRect.left;
    var y0 = getTop() - cRect.top;
    var gd = options.gd || {};
    if (options.gd) {
      gd._fullLayout._calcInverseTransform(gd);
      var transformedCoords = Lib.apply3DTransform(gd._fullLayout._invTransform)(x0, y0);
      x0 = transformedCoords[0];
      y0 = transformedCoords[1];
    }
    this.style({
      top: y0 + 'px',
      left: x0 + 'px',
      'z-index': 1000
    });
    return this;
  };
}
var onePx = '1px ';
exports.makeTextShadow = function (color) {
  var x = onePx;
  var y = onePx;
  var b = onePx;
  return x + y + b + color + ', ' + '-' + x + '-' + y + b + color + ', ' + x + '-' + y + b + color + ', ' + '-' + x + y + b + color;
};

/*
 * Editable title
 * @param {d3.selection} context: the element being edited. Normally text,
 *   but if it isn't, you should provide the styling options
 * @param {object} options:
 *   @param {div} options.gd: graphDiv
 *   @param {d3.selection} options.delegate: item to bind events to if not this
 *   @param {boolean} options.immediate: start editing now (true) or on click (false, default)
 *   @param {string} options.fill: font color if not as shown
 *   @param {string} options.background: background color if not as shown
 *   @param {string} options.text: initial text, if not as shown
 *   @param {string} options.horizontalAlign: alignment of the edit box wrt. the bound element
 *   @param {string} options.verticalAlign: alignment of the edit box wrt. the bound element
 */

exports.makeEditable = function (context, options) {
  var gd = options.gd;
  var _delegate = options.delegate;
  var dispatch = d3.dispatch('edit', 'input', 'cancel');
  var handlerElement = _delegate || context;
  context.style({
    'pointer-events': _delegate ? 'none' : 'all'
  });
  if (context.size() !== 1) throw new Error('boo');
  function handleClick() {
    appendEditable();
    context.style({
      opacity: 0
    });
    // also hide any mathjax svg
    var svgClass = handlerElement.attr('class');
    var mathjaxClass;
    if (svgClass) mathjaxClass = '.' + svgClass.split(' ')[0] + '-math-group';else mathjaxClass = '[class*=-math-group]';
    if (mathjaxClass) {
      d3.select(context.node().parentNode).select(mathjaxClass).style({
        opacity: 0
      });
    }
  }
  function selectElementContents(_el) {
    var el = _el.node();
    var range = document.createRange();
    range.selectNodeContents(el);
    var sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);
    el.focus();
  }
  function appendEditable() {
    var plotDiv = d3.select(gd);
    var container = plotDiv.select('.svg-container');
    var div = container.append('div');
    var cStyle = context.node().style;
    var fontSize = parseFloat(cStyle.fontSize || 12);
    var initialText = options.text;
    if (initialText === undefined) initialText = context.attr('data-unformatted');
    div.classed('plugin-editable editable', true).style({
      position: 'absolute',
      'font-family': cStyle.fontFamily || 'Arial',
      'font-size': fontSize,
      color: options.fill || cStyle.fill || 'black',
      opacity: 1,
      'background-color': options.background || 'transparent',
      outline: '#ffffff33 1px solid',
      margin: [-fontSize / 8 + 1, 0, 0, -1].join('px ') + 'px',
      padding: '0',
      'box-sizing': 'border-box'
    }).attr({
      contenteditable: true
    }).text(initialText).call(alignHTMLWith(context, container, options)).on('blur', function () {
      gd._editing = false;
      context.text(this.textContent).style({
        opacity: 1
      });
      var svgClass = d3.select(this).attr('class');
      var mathjaxClass;
      if (svgClass) mathjaxClass = '.' + svgClass.split(' ')[0] + '-math-group';else mathjaxClass = '[class*=-math-group]';
      if (mathjaxClass) {
        d3.select(context.node().parentNode).select(mathjaxClass).style({
          opacity: 0
        });
      }
      var text = this.textContent;
      d3.select(this).transition().duration(0).remove();
      d3.select(document).on('mouseup', null);
      dispatch.edit.call(context, text);
    }).on('focus', function () {
      var editDiv = this;
      gd._editing = true;
      d3.select(document).on('mouseup', function () {
        if (d3.event.target === editDiv) return false;
        if (document.activeElement === div.node()) div.node().blur();
      });
    }).on('keyup', function () {
      if (d3.event.which === 27) {
        gd._editing = false;
        context.style({
          opacity: 1
        });
        d3.select(this).style({
          opacity: 0
        }).on('blur', function () {
          return false;
        }).transition().remove();
        dispatch.cancel.call(context, this.textContent);
      } else {
        dispatch.input.call(context, this.textContent);
        d3.select(this).call(alignHTMLWith(context, container, options));
      }
    }).on('keydown', function () {
      if (d3.event.which === 13) this.blur();
    }).call(selectElementContents);
  }
  if (options.immediate) handleClick();else handlerElement.on('click', handleClick);
  return d3.rebind(context, dispatch, 'on');
};

/***/ }),

/***/ 64025:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


var timerCache = {};

/**
 * Throttle a callback. `callback` executes synchronously only if
 * more than `minInterval` milliseconds have already elapsed since the latest
 * call (if any). Otherwise we wait until `minInterval` is over and execute the
 * last callback received while waiting.
 * So the first and last events in a train are always executed (eventually)
 * but some of the events in the middle can be dropped.
 *
 * @param {string} id: an identifier to mark events to throttle together
 * @param {number} minInterval: minimum time, in milliseconds, between
 *   invocations of `callback`
 * @param {function} callback: the function to throttle. `callback` itself
 *   should be a purely synchronous function.
 */
exports.throttle = function throttle(id, minInterval, callback) {
  var cache = timerCache[id];
  var now = Date.now();
  if (!cache) {
    /*
     * Throw out old items before making a new one, to prevent the cache
     * getting overgrown, for example from old plots that have been replaced.
     * 1 minute age is arbitrary.
     */
    for (var idi in timerCache) {
      if (timerCache[idi].ts < now - 60000) {
        delete timerCache[idi];
      }
    }
    cache = timerCache[id] = {
      ts: 0,
      timer: null
    };
  }
  _clearTimeout(cache);
  function exec() {
    callback();
    cache.ts = Date.now();
    if (cache.onDone) {
      cache.onDone();
      cache.onDone = null;
    }
  }
  if (now > cache.ts + minInterval) {
    exec();
    return;
  }
  cache.timer = setTimeout(function () {
    exec();
    cache.timer = null;
  }, minInterval);
};
exports.done = function (id) {
  var cache = timerCache[id];
  if (!cache || !cache.timer) return Promise.resolve();
  return new Promise(function (resolve) {
    var previousOnDone = cache.onDone;
    cache.onDone = function onDone() {
      if (previousOnDone) previousOnDone();
      resolve();
      cache.onDone = null;
    };
  });
};

/**
 * Clear the throttle cache for one or all timers
 * @param {optional string} id:
 *   if provided, clear just this timer
 *   if omitted, clear all timers (mainly useful for testing)
 */
exports.clear = function (id) {
  if (id) {
    _clearTimeout(timerCache[id]);
    delete timerCache[id];
  } else {
    for (var idi in timerCache) exports.clear(idi);
  }
};
function _clearTimeout(cache) {
  if (cache && cache.timer !== null) {
    clearTimeout(cache.timer);
    cache.timer = null;
  }
}

/***/ }),

/***/ 8083:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isNumeric = __webpack_require__(10721);

/**
 * convert a linear value into a logged value, folding negative numbers into
 * the given range
 */
module.exports = function toLogRange(val, range) {
  if (val > 0) return Math.log(val) / Math.LN10;

  // move a negative value reference to a log axis - just put the
  // result at the lowest range value on the plot (or if the range also went negative,
  // one millionth of the top of the range)
  var newVal = Math.log(Math.min(range[0], range[1])) / Math.LN10;
  if (!isNumeric(newVal)) newVal = Math.log(Math.max(range[0], range[1])) / Math.LN10 - 6;
  return newVal;
};

/***/ }),

/***/ 11577:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var topojsonUtils = module.exports = {};
var locationmodeToLayer = (__webpack_require__(74285).locationmodeToLayer);
var topojsonFeature = (__webpack_require__(48640)/* .feature */ .N4);
topojsonUtils.getTopojsonName = function (geoLayout) {
  return [geoLayout.scope.replace(/ /g, '-'), '_', geoLayout.resolution.toString(), 'm'].join('');
};
topojsonUtils.getTopojsonPath = function (topojsonURL, topojsonName) {
  return topojsonURL + topojsonName + '.json';
};
topojsonUtils.getTopojsonFeatures = function (trace, topojson) {
  var layer = locationmodeToLayer[trace.locationmode];
  var obj = topojson.objects[layer];
  return topojsonFeature(topojson, obj).features;
};

/***/ }),

/***/ 44611:
/***/ (function(module) {

"use strict";


module.exports = {
  moduleType: 'locale',
  name: 'en-US',
  dictionary: {
    'Click to enter Colorscale title': 'Click to enter Colorscale title'
  },
  format: {
    date: '%m/%d/%Y'
  }
};

/***/ }),

/***/ 30227:
/***/ (function(module) {

"use strict";


module.exports = {
  moduleType: 'locale',
  name: 'en',
  dictionary: {
    'Click to enter Colorscale title': 'Click to enter Colourscale title'
  },
  format: {
    days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    shortDays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    periods: ['AM', 'PM'],
    dateTime: '%a %b %e %X %Y',
    date: '%d/%m/%Y',
    time: '%H:%M:%S',
    decimal: '.',
    thousands: ',',
    grouping: [3],
    currency: ['$', ''],
    year: '%Y',
    month: '%b %Y',
    dayMonth: '%b %-d',
    dayMonthYear: '%b %-d, %Y'
  }
};

/***/ }),

/***/ 56037:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Registry = __webpack_require__(33626);

/*
 * containerArrayMatch: does this attribute string point into a
 * layout container array?
 *
 * @param {String} astr: an attribute string, like *annotations[2].text*
 *
 * @returns {Object | false} Returns false if `astr` doesn't match a container
 *  array. If it does, returns:
 *     {array: {String}, index: {Number}, property: {String}}
 *  ie the attribute string for the array, the index within the array (or ''
 *  if the whole array) and the property within that (or '' if the whole array
 *  or the whole object)
 */
module.exports = function containerArrayMatch(astr) {
  var rootContainers = Registry.layoutArrayContainers;
  var regexpContainers = Registry.layoutArrayRegexes;
  var rootPart = astr.split('[')[0];
  var arrayStr;
  var match;

  // look for regexp matches first, because they may be nested inside root matches
  // eg updatemenus[i].buttons is nested inside updatemenus
  for (var i = 0; i < regexpContainers.length; i++) {
    match = astr.match(regexpContainers[i]);
    if (match && match.index === 0) {
      arrayStr = match[0];
      break;
    }
  }

  // now look for root matches
  if (!arrayStr) arrayStr = rootContainers[rootContainers.indexOf(rootPart)];
  if (!arrayStr) return false;
  var tail = astr.substr(arrayStr.length);
  if (!tail) return {
    array: arrayStr,
    index: '',
    property: ''
  };
  match = tail.match(/^\[(0|[1-9][0-9]*)\](\.(.+))?$/);
  if (!match) return false;
  return {
    array: arrayStr,
    index: Number(match[1]),
    property: match[3] || ''
  };
};

/***/ }),

/***/ 13582:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var extendFlat = (__webpack_require__(93049).extendFlat);
var isPlainObject = __webpack_require__(56174);
var traceOpts = {
  valType: 'flaglist',
  extras: ['none'],
  flags: ['calc', 'clearAxisTypes', 'plot', 'style', 'markerSize', 'colorbars']
};
var layoutOpts = {
  valType: 'flaglist',
  extras: ['none'],
  flags: ['calc', 'plot', 'legend', 'ticks', 'axrange', 'layoutstyle', 'modebar', 'camera', 'arraydraw', 'colorbars']
};

// flags for inside restyle/relayout include a few extras
// that shouldn't be used in attributes, to deal with certain
// combinations and conditionals efficiently
var traceEditTypeFlags = traceOpts.flags.slice().concat(['fullReplot']);
var layoutEditTypeFlags = layoutOpts.flags.slice().concat('layoutReplot');
module.exports = {
  traces: traceOpts,
  layout: layoutOpts,
  /*
   * default (all false) edit flags for restyle (traces)
   * creates a new object each call, so the caller can mutate freely
   */
  traceFlags: function () {
    return falseObj(traceEditTypeFlags);
  },
  /*
   * default (all false) edit flags for relayout
   * creates a new object each call, so the caller can mutate freely
   */
  layoutFlags: function () {
    return falseObj(layoutEditTypeFlags);
  },
  /*
   * update `flags` with the `editType` values found in `attr`
   */
  update: function (flags, attr) {
    var editType = attr.editType;
    if (editType && editType !== 'none') {
      var editTypeParts = editType.split('+');
      for (var i = 0; i < editTypeParts.length; i++) {
        flags[editTypeParts[i]] = true;
      }
    }
  },
  overrideAll: overrideAll
};
function falseObj(keys) {
  var out = {};
  for (var i = 0; i < keys.length; i++) out[keys[i]] = false;
  return out;
}

/**
 * For attributes that are largely copied from elsewhere into a plot type that doesn't
 * support partial redraws - overrides the editType field of all attributes in the object
 *
 * @param {object} attrs: the attributes to override. Will not be mutated.
 * @param {string} editTypeOverride: the new editType to use
 * @param {'nested'|'from-root'} overrideContainers:
 *   - 'nested' will override editType for nested containers but not the root.
 *   - 'from-root' will also override editType of the root container.
 *   Containers below the absolute top level (trace or layout root) DO need an
 *   editType even if they are not `valObject`s themselves (eg `scatter.marker`)
 *   to handle the case where you edit the whole container.
 *
 * @return {object} a new attributes object with `editType` modified as directed
 */
function overrideAll(attrs, editTypeOverride, overrideContainers) {
  var out = extendFlat({}, attrs);
  for (var key in out) {
    var attr = out[key];
    if (isPlainObject(attr)) {
      out[key] = overrideOne(attr, editTypeOverride, overrideContainers, key);
    }
  }
  if (overrideContainers === 'from-root') out.editType = editTypeOverride;
  return out;
}
function overrideOne(attr, editTypeOverride, overrideContainers, key) {
  if (attr.valType) {
    var out = extendFlat({}, attr);
    out.editType = editTypeOverride;
    if (Array.isArray(attr.items)) {
      out.items = new Array(attr.items.length);
      for (var i = 0; i < attr.items.length; i++) {
        out.items[i] = overrideOne(attr.items[i], editTypeOverride, 'from-root');
      }
    }
    return out;
  } else {
    // don't provide an editType for the _deprecated container
    return overrideAll(attr, editTypeOverride, key.charAt(0) === '_' ? 'nested' : 'from-root');
  }
}

/***/ }),

/***/ 10887:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var isNumeric = __webpack_require__(10721);
var m4FromQuat = __webpack_require__(36472);
var Registry = __webpack_require__(33626);
var Lib = __webpack_require__(34809);
var Plots = __webpack_require__(44122);
var AxisIds = __webpack_require__(5975);
var Color = __webpack_require__(78766);
var cleanId = AxisIds.cleanId;
var getFromTrace = AxisIds.getFromTrace;
var traceIs = Registry.traceIs;

// clear the promise queue if one of them got rejected
exports.clearPromiseQueue = function (gd) {
  if (Array.isArray(gd._promises) && gd._promises.length > 0) {
    Lib.log('Clearing previous rejected promises from queue.');
  }
  gd._promises = [];
};

// make a few changes to the layout right away
// before it gets used for anything
// backward compatibility and cleanup of nonstandard options
exports.cleanLayout = function (layout) {
  var i, j;
  if (!layout) layout = {};

  // cannot have (x|y)axis1, numbering goes axis, axis2, axis3...
  if (layout.xaxis1) {
    if (!layout.xaxis) layout.xaxis = layout.xaxis1;
    delete layout.xaxis1;
  }
  if (layout.yaxis1) {
    if (!layout.yaxis) layout.yaxis = layout.yaxis1;
    delete layout.yaxis1;
  }
  if (layout.scene1) {
    if (!layout.scene) layout.scene = layout.scene1;
    delete layout.scene1;
  }
  var axisAttrRegex = (Plots.subplotsRegistry.cartesian || {}).attrRegex;
  var polarAttrRegex = (Plots.subplotsRegistry.polar || {}).attrRegex;
  var ternaryAttrRegex = (Plots.subplotsRegistry.ternary || {}).attrRegex;
  var sceneAttrRegex = (Plots.subplotsRegistry.gl3d || {}).attrRegex;
  var keys = Object.keys(layout);
  for (i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (axisAttrRegex && axisAttrRegex.test(key)) {
      // modifications to cartesian axes

      var ax = layout[key];
      if (ax.anchor && ax.anchor !== 'free') {
        ax.anchor = cleanId(ax.anchor);
      }
      if (ax.overlaying) ax.overlaying = cleanId(ax.overlaying);

      // old method of axis type - isdate and islog (before category existed)
      if (!ax.type) {
        if (ax.isdate) ax.type = 'date';else if (ax.islog) ax.type = 'log';else if (ax.isdate === false && ax.islog === false) ax.type = 'linear';
      }
      if (ax.autorange === 'withzero' || ax.autorange === 'tozero') {
        ax.autorange = true;
        ax.rangemode = 'tozero';
      }
      if (ax.insiderange) delete ax.range;
      delete ax.islog;
      delete ax.isdate;
      delete ax.categories; // replaced by _categories

      // prune empty domain arrays made before the new nestedProperty
      if (emptyContainer(ax, 'domain')) delete ax.domain;

      // autotick -> tickmode
      if (ax.autotick !== undefined) {
        if (ax.tickmode === undefined) {
          ax.tickmode = ax.autotick ? 'auto' : 'linear';
        }
        delete ax.autotick;
      }
      cleanTitle(ax);
    } else if (polarAttrRegex && polarAttrRegex.test(key)) {
      // modifications for polar

      var polar = layout[key];
      cleanTitle(polar.radialaxis);
    } else if (ternaryAttrRegex && ternaryAttrRegex.test(key)) {
      // modifications for ternary

      var ternary = layout[key];
      cleanTitle(ternary.aaxis);
      cleanTitle(ternary.baxis);
      cleanTitle(ternary.caxis);
    } else if (sceneAttrRegex && sceneAttrRegex.test(key)) {
      // modifications for 3D scenes

      var scene = layout[key];

      // clean old Camera coords
      var cameraposition = scene.cameraposition;
      if (Array.isArray(cameraposition) && cameraposition[0].length === 4) {
        var rotation = cameraposition[0];
        var center = cameraposition[1];
        var radius = cameraposition[2];
        var mat = m4FromQuat([], rotation);
        var eye = [];
        for (j = 0; j < 3; ++j) {
          eye[j] = center[j] + radius * mat[2 + 4 * j];
        }
        scene.camera = {
          eye: {
            x: eye[0],
            y: eye[1],
            z: eye[2]
          },
          center: {
            x: center[0],
            y: center[1],
            z: center[2]
          },
          up: {
            x: 0,
            y: 0,
            z: 1
          } // we just ignore calculating camera z up in this case
        };
        delete scene.cameraposition;
      }

      // clean axis titles
      cleanTitle(scene.xaxis);
      cleanTitle(scene.yaxis);
      cleanTitle(scene.zaxis);
    }
  }
  var annotationsLen = Array.isArray(layout.annotations) ? layout.annotations.length : 0;
  for (i = 0; i < annotationsLen; i++) {
    var ann = layout.annotations[i];
    if (!Lib.isPlainObject(ann)) continue;
    if (ann.ref) {
      if (ann.ref === 'paper') {
        ann.xref = 'paper';
        ann.yref = 'paper';
      } else if (ann.ref === 'data') {
        ann.xref = 'x';
        ann.yref = 'y';
      }
      delete ann.ref;
    }
    cleanAxRef(ann, 'xref');
    cleanAxRef(ann, 'yref');
  }
  var shapesLen = Array.isArray(layout.shapes) ? layout.shapes.length : 0;
  for (i = 0; i < shapesLen; i++) {
    var shape = layout.shapes[i];
    if (!Lib.isPlainObject(shape)) continue;
    cleanAxRef(shape, 'xref');
    cleanAxRef(shape, 'yref');
  }
  var imagesLen = Array.isArray(layout.images) ? layout.images.length : 0;
  for (i = 0; i < imagesLen; i++) {
    var image = layout.images[i];
    if (!Lib.isPlainObject(image)) continue;
    cleanAxRef(image, 'xref');
    cleanAxRef(image, 'yref');
  }
  var legend = layout.legend;
  if (legend) {
    // check for old-style legend positioning (x or y is +/- 100)
    if (legend.x > 3) {
      legend.x = 1.02;
      legend.xanchor = 'left';
    } else if (legend.x < -2) {
      legend.x = -0.02;
      legend.xanchor = 'right';
    }
    if (legend.y > 3) {
      legend.y = 1.02;
      legend.yanchor = 'bottom';
    } else if (legend.y < -2) {
      legend.y = -0.02;
      legend.yanchor = 'top';
    }
  }

  // clean plot title
  cleanTitle(layout);

  /*
   * Moved from rotate -> orbit for dragmode
   */
  if (layout.dragmode === 'rotate') layout.dragmode = 'orbit';

  // sanitize rgb(fractions) and rgba(fractions) that old tinycolor
  // supported, but new tinycolor does not because they're not valid css
  Color.clean(layout);

  // clean the layout container in layout.template
  if (layout.template && layout.template.layout) {
    exports.cleanLayout(layout.template.layout);
  }
  return layout;
};
function cleanAxRef(container, attr) {
  var valIn = container[attr];
  var axLetter = attr.charAt(0);
  if (valIn && valIn !== 'paper') {
    container[attr] = cleanId(valIn, axLetter, true);
  }
}

/**
 * Cleans up old title attribute structure (flat) in favor of the new one (nested).
 *
 * @param {Object} titleContainer - an object potentially including deprecated title attributes
 */
function cleanTitle(titleContainer) {
  if (titleContainer) {
    // title -> title.text
    // (although title used to be a string attribute,
    // numbers are accepted as well)
    if (typeof titleContainer.title === 'string' || typeof titleContainer.title === 'number') {
      titleContainer.title = {
        text: titleContainer.title
      };
    }
    rewireAttr('titlefont', 'font');
    rewireAttr('titleposition', 'position');
    rewireAttr('titleside', 'side');
    rewireAttr('titleoffset', 'offset');
  }
  function rewireAttr(oldAttrName, newAttrName) {
    var oldAttrSet = titleContainer[oldAttrName];
    var newAttrSet = titleContainer.title && titleContainer.title[newAttrName];
    if (oldAttrSet && !newAttrSet) {
      // Ensure title object exists
      if (!titleContainer.title) {
        titleContainer.title = {};
      }
      titleContainer.title[newAttrName] = titleContainer[oldAttrName];
      delete titleContainer[oldAttrName];
    }
  }
}

/*
 * cleanData: Make a few changes to the data for backward compatibility
 * before it gets used for anything. Modifies the data traces users provide.
 *
 * Important: if you're going to add something here that modifies a data array,
 * update it in place so the new array === the old one.
 */
exports.cleanData = function (data) {
  for (var tracei = 0; tracei < data.length; tracei++) {
    var trace = data[tracei];
    var i;

    // use xbins to bin data in x, and ybins to bin data in y
    if (trace.type === 'histogramy' && 'xbins' in trace && !('ybins' in trace)) {
      trace.ybins = trace.xbins;
      delete trace.xbins;
    }

    // error_y.opacity is obsolete - merge into color
    if (trace.error_y && 'opacity' in trace.error_y) {
      var dc = Color.defaults;
      var yeColor = trace.error_y.color || (traceIs(trace, 'bar') ? Color.defaultLine : dc[tracei % dc.length]);
      trace.error_y.color = Color.addOpacity(Color.rgb(yeColor), Color.opacity(yeColor) * trace.error_y.opacity);
      delete trace.error_y.opacity;
    }

    // convert bardir to orientation, and put the data into
    // the axes it's eventually going to be used with
    if ('bardir' in trace) {
      if (trace.bardir === 'h' && (traceIs(trace, 'bar') || trace.type.substr(0, 9) === 'histogram')) {
        trace.orientation = 'h';
        exports.swapXYData(trace);
      }
      delete trace.bardir;
    }

    // now we have only one 1D histogram type, and whether
    // it uses x or y data depends on trace.orientation
    if (trace.type === 'histogramy') exports.swapXYData(trace);
    if (trace.type === 'histogramx' || trace.type === 'histogramy') {
      trace.type = 'histogram';
    }

    // scl->scale, reversescl->reversescale
    if ('scl' in trace && !('colorscale' in trace)) {
      trace.colorscale = trace.scl;
      delete trace.scl;
    }
    if ('reversescl' in trace && !('reversescale' in trace)) {
      trace.reversescale = trace.reversescl;
      delete trace.reversescl;
    }

    // axis ids x1 -> x, y1-> y
    if (trace.xaxis) trace.xaxis = cleanId(trace.xaxis, 'x');
    if (trace.yaxis) trace.yaxis = cleanId(trace.yaxis, 'y');

    // scene ids scene1 -> scene
    if (traceIs(trace, 'gl3d') && trace.scene) {
      trace.scene = Plots.subplotsRegistry.gl3d.cleanId(trace.scene);
    }
    if (!traceIs(trace, 'pie-like') && !traceIs(trace, 'bar-like')) {
      if (Array.isArray(trace.textposition)) {
        for (i = 0; i < trace.textposition.length; i++) {
          trace.textposition[i] = cleanTextPosition(trace.textposition[i]);
        }
      } else if (trace.textposition) {
        trace.textposition = cleanTextPosition(trace.textposition);
      }
    }

    // fix typo in colorscale definition
    var _module = Registry.getModule(trace);
    if (_module && _module.colorbar) {
      var containerName = _module.colorbar.container;
      var container = containerName ? trace[containerName] : trace;
      if (container && container.colorscale) {
        if (container.colorscale === 'YIGnBu') container.colorscale = 'YlGnBu';
        if (container.colorscale === 'YIOrRd') container.colorscale = 'YlOrRd';
      }
    }

    // fix typo in surface 'highlight*' definitions
    if (trace.type === 'surface' && Lib.isPlainObject(trace.contours)) {
      var dims = ['x', 'y', 'z'];
      for (i = 0; i < dims.length; i++) {
        var opts = trace.contours[dims[i]];
        if (!Lib.isPlainObject(opts)) continue;
        if (opts.highlightColor) {
          opts.highlightcolor = opts.highlightColor;
          delete opts.highlightColor;
        }
        if (opts.highlightWidth) {
          opts.highlightwidth = opts.highlightWidth;
          delete opts.highlightWidth;
        }
      }
    }

    // fixes from converting finance from transforms to real trace types
    if (trace.type === 'candlestick' || trace.type === 'ohlc') {
      var increasingShowlegend = (trace.increasing || {}).showlegend !== false;
      var decreasingShowlegend = (trace.decreasing || {}).showlegend !== false;
      var increasingName = cleanFinanceDir(trace.increasing);
      var decreasingName = cleanFinanceDir(trace.decreasing);

      // now figure out something smart to do with the separate direction
      // names we removed
      if (increasingName !== false && decreasingName !== false) {
        // both sub-names existed: base name previously had no effect
        // so ignore it and try to find a shared part of the sub-names

        var newName = commonPrefix(increasingName, decreasingName, increasingShowlegend, decreasingShowlegend);
        // if no common part, leave whatever name was (or wasn't) there
        if (newName) trace.name = newName;
      } else if ((increasingName || decreasingName) && !trace.name) {
        // one sub-name existed but not the base name - just use the sub-name
        trace.name = increasingName || decreasingName;
      }
    }

    // transforms backward compatibility fixes
    if (Array.isArray(trace.transforms)) {
      var transforms = trace.transforms;
      for (i = 0; i < transforms.length; i++) {
        var transform = transforms[i];
        if (!Lib.isPlainObject(transform)) continue;
        switch (transform.type) {
          case 'filter':
            if (transform.filtersrc) {
              transform.target = transform.filtersrc;
              delete transform.filtersrc;
            }
            if (transform.calendar) {
              if (!transform.valuecalendar) {
                transform.valuecalendar = transform.calendar;
              }
              delete transform.calendar;
            }
            break;
          case 'groupby':
            // Name has changed from `style` to `styles`, so use `style` but prefer `styles`:
            transform.styles = transform.styles || transform.style;
            if (transform.styles && !Array.isArray(transform.styles)) {
              var prevStyles = transform.styles;
              var styleKeys = Object.keys(prevStyles);
              transform.styles = [];
              for (var j = 0; j < styleKeys.length; j++) {
                transform.styles.push({
                  target: styleKeys[j],
                  value: prevStyles[styleKeys[j]]
                });
              }
            }
            break;
        }
      }
    }

    // prune empty containers made before the new nestedProperty
    if (emptyContainer(trace, 'line')) delete trace.line;
    if ('marker' in trace) {
      if (emptyContainer(trace.marker, 'line')) delete trace.marker.line;
      if (emptyContainer(trace, 'marker')) delete trace.marker;
    }

    // sanitize rgb(fractions) and rgba(fractions) that old tinycolor
    // supported, but new tinycolor does not because they're not valid css
    Color.clean(trace);

    // remove obsolete autobin(x|y) attributes, but only if true
    // if false, this needs to happen in Histogram.calc because it
    // can be a one-time autobin so we need to know the results before
    // we can push them back into the trace.
    if (trace.autobinx) {
      delete trace.autobinx;
      delete trace.xbins;
    }
    if (trace.autobiny) {
      delete trace.autobiny;
      delete trace.ybins;
    }
    cleanTitle(trace);
    if (trace.colorbar) cleanTitle(trace.colorbar);
    if (trace.marker && trace.marker.colorbar) cleanTitle(trace.marker.colorbar);
    if (trace.line && trace.line.colorbar) cleanTitle(trace.line.colorbar);
    if (trace.aaxis) cleanTitle(trace.aaxis);
    if (trace.baxis) cleanTitle(trace.baxis);
  }
};
function cleanFinanceDir(dirContainer) {
  if (!Lib.isPlainObject(dirContainer)) return false;
  var dirName = dirContainer.name;
  delete dirContainer.name;
  delete dirContainer.showlegend;
  return (typeof dirName === 'string' || typeof dirName === 'number') && String(dirName);
}
function commonPrefix(name1, name2, show1, show2) {
  // if only one is shown in the legend, use that
  if (show1 && !show2) return name1;
  if (show2 && !show1) return name2;

  // if both or neither are in the legend, check if one is blank (or whitespace)
  // and use the other one
  // note that hover labels can still use the name even if the legend doesn't
  if (!name1.trim()) return name2;
  if (!name2.trim()) return name1;
  var minLen = Math.min(name1.length, name2.length);
  var i;
  for (i = 0; i < minLen; i++) {
    if (name1.charAt(i) !== name2.charAt(i)) break;
  }
  var out = name1.substr(0, i);
  return out.trim();
}

// textposition - support partial attributes (ie just 'top')
// and incorrect use of middle / center etc.
function cleanTextPosition(textposition) {
  var posY = 'middle';
  var posX = 'center';
  if (typeof textposition === 'string') {
    if (textposition.indexOf('top') !== -1) posY = 'top';else if (textposition.indexOf('bottom') !== -1) posY = 'bottom';
    if (textposition.indexOf('left') !== -1) posX = 'left';else if (textposition.indexOf('right') !== -1) posX = 'right';
  }
  return posY + ' ' + posX;
}
function emptyContainer(outer, innerStr) {
  return innerStr in outer && typeof outer[innerStr] === 'object' && Object.keys(outer[innerStr]).length === 0;
}

// swap all the data and data attributes associated with x and y
exports.swapXYData = function (trace) {
  var i;
  Lib.swapAttrs(trace, ['?', '?0', 'd?', '?bins', 'nbins?', 'autobin?', '?src', 'error_?']);
  if (Array.isArray(trace.z) && Array.isArray(trace.z[0])) {
    if (trace.transpose) delete trace.transpose;else trace.transpose = true;
  }
  if (trace.error_x && trace.error_y) {
    var errorY = trace.error_y;
    var copyYstyle = 'copy_ystyle' in errorY ? errorY.copy_ystyle : !(errorY.color || errorY.thickness || errorY.width);
    Lib.swapAttrs(trace, ['error_?.copy_ystyle']);
    if (copyYstyle) {
      Lib.swapAttrs(trace, ['error_?.color', 'error_?.thickness', 'error_?.width']);
    }
  }
  if (typeof trace.hoverinfo === 'string') {
    var hoverInfoParts = trace.hoverinfo.split('+');
    for (i = 0; i < hoverInfoParts.length; i++) {
      if (hoverInfoParts[i] === 'x') hoverInfoParts[i] = 'y';else if (hoverInfoParts[i] === 'y') hoverInfoParts[i] = 'x';
    }
    trace.hoverinfo = hoverInfoParts.join('+');
  }
};

// coerce traceIndices input to array of trace indices
exports.coerceTraceIndices = function (gd, traceIndices) {
  if (isNumeric(traceIndices)) {
    return [traceIndices];
  } else if (!Array.isArray(traceIndices) || !traceIndices.length) {
    return gd.data.map(function (_, i) {
      return i;
    });
  } else if (Array.isArray(traceIndices)) {
    var traceIndicesOut = [];
    for (var i = 0; i < traceIndices.length; i++) {
      if (Lib.isIndex(traceIndices[i], gd.data.length)) {
        traceIndicesOut.push(traceIndices[i]);
      } else {
        Lib.warn('trace index (', traceIndices[i], ') is not a number or is out of bounds');
      }
    }
    return traceIndicesOut;
  }
  return traceIndices;
};

/**
 * Manages logic around array container item creation / deletion / update
 * that nested property alone can't handle.
 *
 * @param {Object} np
 *  nested property of update attribute string about trace or layout object
 * @param {*} newVal
 *  update value passed to restyle / relayout / update
 * @param {Object} undoit
 *  undo hash (N.B. undoit may be mutated here).
 *
 */
exports.manageArrayContainers = function (np, newVal, undoit) {
  var obj = np.obj;
  var parts = np.parts;
  var pLength = parts.length;
  var pLast = parts[pLength - 1];
  var pLastIsNumber = isNumeric(pLast);
  if (pLastIsNumber && newVal === null) {
    // delete item

    // Clear item in array container when new value is null
    var contPath = parts.slice(0, pLength - 1).join('.');
    var cont = Lib.nestedProperty(obj, contPath).get();
    cont.splice(pLast, 1);

    // Note that nested property clears null / undefined at end of
    // array container, but not within them.
  } else if (pLastIsNumber && np.get() === undefined) {
    // create item

    // When adding a new item, make sure undo command will remove it
    if (np.get() === undefined) undoit[np.astr] = null;
    np.set(newVal);
  } else {
    // update item

    // If the last part of attribute string isn't a number,
    // np.set is all we need.
    np.set(newVal);
  }
};

/*
 * Match the part to strip off to turn an attribute into its parent
 * really it should be either '.some_characters' or '[number]'
 * but we're a little more permissive here and match either
 * '.not_brackets_or_dot' or '[not_brackets_or_dot]'
 */
var ATTR_TAIL_RE = /(\.[^\[\]\.]+|\[[^\[\]\.]+\])$/;
function getParent(attr) {
  var tail = attr.search(ATTR_TAIL_RE);
  if (tail > 0) return attr.substr(0, tail);
}

/*
 * hasParent: does an attribute object contain a parent of the given attribute?
 * for example, given 'images[2].x' do we also have 'images' or 'images[2]'?
 *
 * @param {Object} aobj
 *  update object, whose keys are attribute strings and values are their new settings
 * @param {string} attr
 *  the attribute string to test against
 * @returns {Boolean}
 *  is a parent of attr present in aobj?
 */
exports.hasParent = function (aobj, attr) {
  var attrParent = getParent(attr);
  while (attrParent) {
    if (attrParent in aobj) return true;
    attrParent = getParent(attrParent);
  }
  return false;
};

/**
 * Empty out types for all axes containing these traces so we auto-set them again
 *
 * @param {object} gd
 * @param {[integer]} traces: trace indices to search for axes to clear the types of
 * @param {object} layoutUpdate: any update being done concurrently to the layout,
 *   which may supercede clearing the axis types
 */
var axLetters = ['x', 'y', 'z'];
exports.clearAxisTypes = function (gd, traces, layoutUpdate) {
  for (var i = 0; i < traces.length; i++) {
    var trace = gd._fullData[i];
    for (var j = 0; j < 3; j++) {
      var ax = getFromTrace(gd, trace, axLetters[j]);

      // do not clear log type - that's never an auto result so must have been intentional
      if (ax && ax.type !== 'log') {
        var axAttr = ax._name;
        var sceneName = ax._id.substr(1);
        if (sceneName.substr(0, 5) === 'scene') {
          if (layoutUpdate[sceneName] !== undefined) continue;
          axAttr = sceneName + '.' + axAttr;
        }
        var typeAttr = axAttr + '.type';
        if (layoutUpdate[axAttr] === undefined && layoutUpdate[typeAttr] === undefined) {
          Lib.nestedProperty(gd.layout, typeAttr).set(null);
        }
      }
    }
  }
};

/***/ }),

/***/ 90742:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var main = __webpack_require__(31420);
exports._doPlot = main._doPlot;
exports.newPlot = main.newPlot;
exports.restyle = main.restyle;
exports.relayout = main.relayout;
exports.redraw = main.redraw;
exports.update = main.update;
exports._guiRestyle = main._guiRestyle;
exports._guiRelayout = main._guiRelayout;
exports._guiUpdate = main._guiUpdate;
exports._storeDirectGUIEdit = main._storeDirectGUIEdit;
exports.react = main.react;
exports.extendTraces = main.extendTraces;
exports.prependTraces = main.prependTraces;
exports.addTraces = main.addTraces;
exports.deleteTraces = main.deleteTraces;
exports.moveTraces = main.moveTraces;
exports.purge = main.purge;
exports.addFrames = main.addFrames;
exports.deleteFrames = main.deleteFrames;
exports.animate = main.animate;
exports.setPlotConfig = main.setPlotConfig;
var getGraphDiv = (__webpack_require__(95425).getGraphDiv);
var eraseActiveShape = (__webpack_require__(28231).eraseActiveShape);
exports.deleteActiveShape = function (gd) {
  return eraseActiveShape(getGraphDiv(gd));
};
exports.toImage = __webpack_require__(80491);
exports.validate = __webpack_require__(2466);
exports.downloadImage = __webpack_require__(26452);
var templateApi = __webpack_require__(53853);
exports.makeTemplate = templateApi.makeTemplate;
exports.validateTemplate = templateApi.validateTemplate;

/***/ }),

/***/ 85844:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var isPlainObject = __webpack_require__(56174);
var noop = __webpack_require__(4969);
var Loggers = __webpack_require__(48636);
var sorterAsc = (__webpack_require__(98813).sorterAsc);
var Registry = __webpack_require__(33626);
exports.containerArrayMatch = __webpack_require__(56037);
var isAddVal = exports.isAddVal = function isAddVal(val) {
  return val === 'add' || isPlainObject(val);
};
var isRemoveVal = exports.isRemoveVal = function isRemoveVal(val) {
  return val === null || val === 'remove';
};

/*
 * applyContainerArrayChanges: for managing arrays of layout components in relayout
 * handles them all with a consistent interface.
 *
 * Here are the supported actions -> relayout calls -> edits we get here
 * (as prepared in _relayout):
 *
 * add an empty obj -> {'annotations[2]': 'add'} -> {2: {'': 'add'}}
 * add a specific obj -> {'annotations[2]': {attrs}} -> {2: {'': {attrs}}}
 * delete an obj -> {'annotations[2]': 'remove'} -> {2: {'': 'remove'}}
 *               -> {'annotations[2]': null} -> {2: {'': null}}
 * delete the whole array -> {'annotations': 'remove'} -> {'': {'': 'remove'}}
 *                        -> {'annotations': null} -> {'': {'': null}}
 * edit an object -> {'annotations[2].text': 'boo'} -> {2: {'text': 'boo'}}
 *
 * You can combine many edits to different objects. Objects are added and edited
 * in ascending order, then removed in descending order.
 * For example, starting with [a, b, c], if you want to:
 * - replace b with d:
 *   {'annotations[1]': d, 'annotations[2]': null} (b is item 2 after adding d)
 * - add a new item d between a and b, and edit b:
 *    {'annotations[1]': d, 'annotations[2].x': newX} (b is item 2 after adding d)
 * - delete b and edit c:
 *    {'annotations[1]': null, 'annotations[2].x': newX} (c is edited before b is removed)
 *
 * You CANNOT combine adding/deleting an item at index `i` with edits to the same index `i`
 * You CANNOT combine replacing/deleting the whole array with anything else (for the same array).
 *
 * @param {HTMLDivElement} gd
 *  the DOM element of the graph container div
 * @param {Lib.nestedProperty} componentType: the array we are editing
 * @param {Object} edits
 *  the changes to make; keys are indices to edit, values are themselves objects:
 *  {attr: newValue} of changes to make to that index (with add/remove behavior
 *  in special values of the empty attr)
 * @param {Object} flags
 *  the flags for which actions we're going to perform to display these (and
 *  any other) changes. If we're already `recalc`ing, we don't need to redraw
 *  individual items
 * @param {function} _nestedProperty
 *  a (possibly modified for gui edits) nestedProperty constructor
 *  The modified version takes a 3rd argument, for a prefix to the attribute
 *  string necessary for storing GUI edits
 *
 * @returns {bool} `true` if it managed to complete drawing of the changes
 *  `false` would mean the parent should replot.
 */
exports.applyContainerArrayChanges = function applyContainerArrayChanges(gd, np, edits, flags, _nestedProperty) {
  var componentType = np.astr;
  var supplyComponentDefaults = Registry.getComponentMethod(componentType, 'supplyLayoutDefaults');
  var draw = Registry.getComponentMethod(componentType, 'draw');
  var drawOne = Registry.getComponentMethod(componentType, 'drawOne');
  var replotLater = flags.replot || flags.recalc || supplyComponentDefaults === noop || draw === noop;
  var layout = gd.layout;
  var fullLayout = gd._fullLayout;
  if (edits['']) {
    if (Object.keys(edits).length > 1) {
      Loggers.warn('Full array edits are incompatible with other edits', componentType);
    }
    var fullVal = edits[''][''];
    if (isRemoveVal(fullVal)) np.set(null);else if (Array.isArray(fullVal)) np.set(fullVal);else {
      Loggers.warn('Unrecognized full array edit value', componentType, fullVal);
      return true;
    }
    if (replotLater) return false;
    supplyComponentDefaults(layout, fullLayout);
    draw(gd);
    return true;
  }
  var componentNums = Object.keys(edits).map(Number).sort(sorterAsc);
  var componentArrayIn = np.get();
  var componentArray = componentArrayIn || [];
  // componentArrayFull is used just to keep splices in line between
  // full and input arrays, so private keys can be copied over after
  // redoing supplyDefaults
  // TODO: this assumes componentArray is in gd.layout - which will not be
  // true after we extend this to restyle
  var componentArrayFull = _nestedProperty(fullLayout, componentType).get();
  var deletes = [];
  var firstIndexChange = -1;
  var maxIndex = componentArray.length;
  var i;
  var j;
  var componentNum;
  var objEdits;
  var objKeys;
  var objVal;
  var adding, prefix;

  // first make the add and edit changes
  for (i = 0; i < componentNums.length; i++) {
    componentNum = componentNums[i];
    objEdits = edits[componentNum];
    objKeys = Object.keys(objEdits);
    objVal = objEdits[''], adding = isAddVal(objVal);
    if (componentNum < 0 || componentNum > componentArray.length - (adding ? 0 : 1)) {
      Loggers.warn('index out of range', componentType, componentNum);
      continue;
    }
    if (objVal !== undefined) {
      if (objKeys.length > 1) {
        Loggers.warn('Insertion & removal are incompatible with edits to the same index.', componentType, componentNum);
      }
      if (isRemoveVal(objVal)) {
        deletes.push(componentNum);
      } else if (adding) {
        if (objVal === 'add') objVal = {};
        componentArray.splice(componentNum, 0, objVal);
        if (componentArrayFull) componentArrayFull.splice(componentNum, 0, {});
      } else {
        Loggers.warn('Unrecognized full object edit value', componentType, componentNum, objVal);
      }
      if (firstIndexChange === -1) firstIndexChange = componentNum;
    } else {
      for (j = 0; j < objKeys.length; j++) {
        prefix = componentType + '[' + componentNum + '].';
        _nestedProperty(componentArray[componentNum], objKeys[j], prefix).set(objEdits[objKeys[j]]);
      }
    }
  }

  // now do deletes
  for (i = deletes.length - 1; i >= 0; i--) {
    componentArray.splice(deletes[i], 1);
    // TODO: this drops private keys that had been stored in componentArrayFull
    // does this have any ill effects?
    if (componentArrayFull) componentArrayFull.splice(deletes[i], 1);
  }
  if (!componentArray.length) np.set(null);else if (!componentArrayIn) np.set(componentArray);
  if (replotLater) return false;
  supplyComponentDefaults(layout, fullLayout);

  // finally draw all the components we need to
  // if we added or removed any, redraw all after it
  if (drawOne !== noop) {
    var indicesToDraw;
    if (firstIndexChange === -1) {
      // there's no re-indexing to do, so only redraw components that changed
      indicesToDraw = componentNums;
    } else {
      // in case the component array was shortened, we still need do call
      // drawOne on the latter items so they get properly removed
      maxIndex = Math.max(componentArray.length, maxIndex);
      indicesToDraw = [];
      for (i = 0; i < componentNums.length; i++) {
        componentNum = componentNums[i];
        if (componentNum >= firstIndexChange) break;
        indicesToDraw.push(componentNum);
      }
      for (i = firstIndexChange; i < maxIndex; i++) {
        indicesToDraw.push(i);
      }
    }
    for (i = 0; i < indicesToDraw.length; i++) {
      drawOne(gd, indicesToDraw[i]);
    }
  } else draw(gd);
  return true;
};

/***/ }),

/***/ 31420:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var isNumeric = __webpack_require__(10721);
var hasHover = __webpack_require__(39784);
var Lib = __webpack_require__(34809);
var nestedProperty = Lib.nestedProperty;
var Events = __webpack_require__(68596);
var Queue = __webpack_require__(40486);
var Registry = __webpack_require__(33626);
var PlotSchema = __webpack_require__(57297);
var Plots = __webpack_require__(44122);
var Axes = __webpack_require__(29714);
var handleRangeDefaults = __webpack_require__(90259);
var cartesianLayoutAttributes = __webpack_require__(25829);
var Drawing = __webpack_require__(62203);
var Color = __webpack_require__(78766);
var initInteractions = (__webpack_require__(95284).initInteractions);
var xmlnsNamespaces = __webpack_require__(62972);
var clearOutline = (__webpack_require__(44844).clearOutline);
var dfltConfig = (__webpack_require__(24452).dfltConfig);
var manageArrays = __webpack_require__(85844);
var helpers = __webpack_require__(10887);
var subroutines = __webpack_require__(71817);
var editTypes = __webpack_require__(13582);
var AX_NAME_PATTERN = (__webpack_require__(54826).AX_NAME_PATTERN);
var numericNameWarningCount = 0;
var numericNameWarningCountLimit = 5;

/**
 * Internal plot-creation function
 *
 * @param {string id or DOM element} gd
 *      the id or DOM element of the graph container div
 * @param {array of objects} data
 *      array of traces, containing the data and display information for each trace
 * @param {object} layout
 *      object describing the overall display of the plot,
 *      all the stuff that doesn't pertain to any individual trace
 * @param {object} config
 *      configuration options (see ./plot_config.js for more info)
 *
 * OR
 *
 * @param {string id or DOM element} gd
 *      the id or DOM element of the graph container div
 * @param {object} figure
 *      object containing `data`, `layout`, `config`, and `frames` members
 *
 */
function _doPlot(gd, data, layout, config) {
  var frames;
  gd = Lib.getGraphDiv(gd);

  // Events.init is idempotent and bails early if gd has already been init'd
  Events.init(gd);
  if (Lib.isPlainObject(data)) {
    var obj = data;
    data = obj.data;
    layout = obj.layout;
    config = obj.config;
    frames = obj.frames;
  }
  var okToPlot = Events.triggerHandler(gd, 'plotly_beforeplot', [data, layout, config]);
  if (okToPlot === false) return Promise.reject();

  // if there's no data or layout, and this isn't yet a plotly plot
  // container, log a warning to help plotly.js users debug
  if (!data && !layout && !Lib.isPlotDiv(gd)) {
    Lib.warn('Calling _doPlot as if redrawing ' + 'but this container doesn\'t yet have a plot.', gd);
  }
  function addFrames() {
    if (frames) {
      return exports.addFrames(gd, frames);
    }
  }

  // transfer configuration options to gd until we move over to
  // a more OO like model
  setPlotContext(gd, config);
  if (!layout) layout = {};

  // hook class for plots main container (in case of plotly.js
  // this won't be #embedded-graph or .js-tab-contents)
  d3.select(gd).classed('js-plotly-plot', true);

  // off-screen getBoundingClientRect testing space,
  // in #js-plotly-tester (and stored as Drawing.tester)
  // so we can share cached text across tabs
  Drawing.makeTester();

  // collect promises for any async actions during plotting
  // any part of the plotting code can push to gd._promises, then
  // before we move to the next step, we check that they're all
  // complete, and empty out the promise list again.
  if (!Array.isArray(gd._promises)) gd._promises = [];
  var graphWasEmpty = (gd.data || []).length === 0 && Array.isArray(data);

  // if there is already data on the graph, append the new data
  // if you only want to redraw, pass a non-array for data
  if (Array.isArray(data)) {
    helpers.cleanData(data);
    if (graphWasEmpty) gd.data = data;else gd.data.push.apply(gd.data, data);

    // for routines outside graph_obj that want a clean tab
    // (rather than appending to an existing one) gd.empty
    // is used to determine whether to make a new tab
    gd.empty = false;
  }
  if (!gd.layout || graphWasEmpty) {
    gd.layout = helpers.cleanLayout(layout);
  }
  Plots.supplyDefaults(gd);
  var fullLayout = gd._fullLayout;
  var hasCartesian = fullLayout._has('cartesian');

  // so we don't try to re-call _doPlot from inside
  // legend and colorbar, if margins changed
  fullLayout._replotting = true;

  // make or remake the framework if we need to
  if (graphWasEmpty || fullLayout._shouldCreateBgLayer) {
    makePlotFramework(gd);
    if (fullLayout._shouldCreateBgLayer) {
      delete fullLayout._shouldCreateBgLayer;
    }
  }

  // clear gradient and pattern defs on each .plot call, because we know we'll loop through all traces
  Drawing.initGradients(gd);
  Drawing.initPatterns(gd);

  // save initial show spikes once per graph
  if (graphWasEmpty) Axes.saveShowSpikeInitial(gd);

  // prepare the data and find the autorange

  // generate calcdata, if we need to
  // to force redoing calcdata, just delete it before calling _doPlot
  var recalc = !gd.calcdata || gd.calcdata.length !== (gd._fullData || []).length;
  if (recalc) Plots.doCalcdata(gd);

  // in case it has changed, attach fullData traces to calcdata
  for (var i = 0; i < gd.calcdata.length; i++) {
    gd.calcdata[i][0].trace = gd._fullData[i];
  }

  // make the figure responsive
  if (gd._context.responsive) {
    if (!gd._responsiveChartHandler) {
      // Keep a reference to the resize handler to purge it down the road
      gd._responsiveChartHandler = function () {
        if (!Lib.isHidden(gd)) Plots.resize(gd);
      };

      // Listen to window resize
      window.addEventListener('resize', gd._responsiveChartHandler);
    }
  } else {
    Lib.clearResponsive(gd);
  }

  /*
   * start async-friendly code - now we're actually drawing things
   */

  var oldMargins = Lib.extendFlat({}, fullLayout._size);

  // draw framework first so that margin-pushing
  // components can position themselves correctly
  var drawFrameworkCalls = 0;
  function drawFramework() {
    var basePlotModules = fullLayout._basePlotModules;
    for (var i = 0; i < basePlotModules.length; i++) {
      if (basePlotModules[i].drawFramework) {
        basePlotModules[i].drawFramework(gd);
      }
    }
    if (!fullLayout._glcanvas && fullLayout._has('gl')) {
      fullLayout._glcanvas = fullLayout._glcontainer.selectAll('.gl-canvas').data([{
        key: 'contextLayer',
        context: true,
        pick: false
      }, {
        key: 'focusLayer',
        context: false,
        pick: false
      }, {
        key: 'pickLayer',
        context: false,
        pick: true
      }], function (d) {
        return d.key;
      });
      fullLayout._glcanvas.enter().append('canvas').attr('class', function (d) {
        return 'gl-canvas gl-canvas-' + d.key.replace('Layer', '');
      }).style({
        position: 'absolute',
        top: 0,
        left: 0,
        overflow: 'visible',
        'pointer-events': 'none'
      });
    }
    var plotGlPixelRatio = gd._context.plotGlPixelRatio;
    if (fullLayout._glcanvas) {
      fullLayout._glcanvas.attr('width', fullLayout.width * plotGlPixelRatio).attr('height', fullLayout.height * plotGlPixelRatio).style('width', fullLayout.width + 'px').style('height', fullLayout.height + 'px');
      var regl = fullLayout._glcanvas.data()[0].regl;
      if (regl) {
        // Unfortunately, this can happen when relayouting to large
        // width/height on some browsers.
        if (Math.floor(fullLayout.width * plotGlPixelRatio) !== regl._gl.drawingBufferWidth || Math.floor(fullLayout.height * plotGlPixelRatio) !== regl._gl.drawingBufferHeight) {
          var msg = 'WebGL context buffer and canvas dimensions do not match due to browser/WebGL bug.';
          if (drawFrameworkCalls) {
            Lib.error(msg);
          } else {
            Lib.log(msg + ' Clearing graph and plotting again.');
            Plots.cleanPlot([], {}, gd._fullData, fullLayout);
            Plots.supplyDefaults(gd);
            fullLayout = gd._fullLayout;
            Plots.doCalcdata(gd);
            drawFrameworkCalls++;
            return drawFramework();
          }
        }
      }
    }
    if (fullLayout.modebar.orientation === 'h') {
      fullLayout._modebardiv.style('height', null).style('width', '100%');
    } else {
      fullLayout._modebardiv.style('width', null).style('height', fullLayout.height + 'px');
    }
    return Plots.previousPromises(gd);
  }

  // draw anything that can affect margins.
  function marginPushers() {
    // First reset the list of things that are allowed to change the margins
    // So any deleted traces or components will be wiped out of the
    // automargin calculation.
    // This means *every* margin pusher must be listed here, even if it
    // doesn't actually try to push the margins until later.
    Plots.clearAutoMarginIds(gd);
    subroutines.drawMarginPushers(gd);
    Axes.allowAutoMargin(gd);
    if (gd._fullLayout.title.text && gd._fullLayout.title.automargin) Plots.allowAutoMargin(gd, 'title.automargin');

    // TODO can this be moved elsewhere?
    if (fullLayout._has('pie')) {
      var fullData = gd._fullData;
      for (var i = 0; i < fullData.length; i++) {
        var trace = fullData[i];
        if (trace.type === 'pie' && trace.automargin) {
          Plots.allowAutoMargin(gd, 'pie.' + trace.uid + '.automargin');
        }
      }
    }
    Plots.doAutoMargin(gd);
    return Plots.previousPromises(gd);
  }

  // in case the margins changed, draw margin pushers again
  function marginPushersAgain() {
    if (!Plots.didMarginChange(oldMargins, fullLayout._size)) return;
    return Lib.syncOrAsync([marginPushers, subroutines.layoutStyles], gd);
  }
  function positionAndAutorange() {
    if (!recalc) {
      doAutoRangeAndConstraints();
      return;
    }

    // TODO: autosize extra for text markers and images
    // see https://github.com/plotly/plotly.js/issues/1111
    return Lib.syncOrAsync([Registry.getComponentMethod('shapes', 'calcAutorange'), Registry.getComponentMethod('annotations', 'calcAutorange'), doAutoRangeAndConstraints], gd);
  }
  function doAutoRangeAndConstraints() {
    if (gd._transitioning) return;
    subroutines.doAutoRangeAndConstraints(gd);

    // store initial ranges *after* enforcing constraints, otherwise
    // we will never look like we're at the initial ranges
    if (graphWasEmpty) Axes.saveRangeInitial(gd);

    // this one is different from shapes/annotations calcAutorange
    // the others incorporate those components into ax._extremes,
    // this one actually sets the ranges in rangesliders.
    Registry.getComponentMethod('rangeslider', 'calcAutorange')(gd);
  }

  // draw ticks, titles, and calculate axis scaling (._b, ._m)
  function drawAxes() {
    return Axes.draw(gd, graphWasEmpty ? '' : 'redraw');
  }
  var seq = [Plots.previousPromises, addFrames, drawFramework, marginPushers, marginPushersAgain];
  if (hasCartesian) seq.push(positionAndAutorange);
  seq.push(subroutines.layoutStyles);
  if (hasCartesian) {
    seq.push(drawAxes, function insideTickLabelsAutorange(gd) {
      var insideTickLabelsUpdaterange = gd._fullLayout._insideTickLabelsUpdaterange;
      if (insideTickLabelsUpdaterange) {
        gd._fullLayout._insideTickLabelsUpdaterange = undefined;
        return relayout(gd, insideTickLabelsUpdaterange).then(function () {
          Axes.saveRangeInitial(gd, true);
        });
      }
    });
  }
  seq.push(subroutines.drawData, subroutines.finalDraw, initInteractions, Plots.addLinks, Plots.rehover, Plots.redrag, Plots.reselect,
  // TODO: doAutoMargin is only needed here for axis automargin, which
  // happens outside of marginPushers where all the other automargins are
  // calculated. Would be much better to separate margin calculations from
  // component drawing - see https://github.com/plotly/plotly.js/issues/2704
  Plots.doAutoMargin, Plots.previousPromises);

  // even if everything we did was synchronous, return a promise
  // so that the caller doesn't care which route we took
  var plotDone = Lib.syncOrAsync(seq, gd);
  if (!plotDone || !plotDone.then) plotDone = Promise.resolve();
  return plotDone.then(function () {
    emitAfterPlot(gd);
    return gd;
  });
}
function emitAfterPlot(gd) {
  var fullLayout = gd._fullLayout;
  if (fullLayout._redrawFromAutoMarginCount) {
    fullLayout._redrawFromAutoMarginCount--;
  } else {
    gd.emit('plotly_afterplot');
  }
}
function setPlotConfig(obj) {
  return Lib.extendFlat(dfltConfig, obj);
}
function setBackground(gd, bgColor) {
  try {
    gd._fullLayout._paper.style('background', bgColor);
  } catch (e) {
    Lib.error(e);
  }
}
function opaqueSetBackground(gd, bgColor) {
  var blend = Color.combine(bgColor, 'white');
  setBackground(gd, blend);
}
function setPlotContext(gd, config) {
  if (!gd._context) {
    gd._context = Lib.extendDeep({}, dfltConfig);

    // stash <base> href, used to make robust clipPath URLs
    var base = d3.select('base');
    gd._context._baseUrl = base.size() && base.attr('href') ? window.location.href.split('#')[0] : '';
  }
  var context = gd._context;
  var i, keys, key;
  if (config) {
    keys = Object.keys(config);
    for (i = 0; i < keys.length; i++) {
      key = keys[i];
      if (key === 'editable' || key === 'edits') continue;
      if (key in context) {
        if (key === 'setBackground' && config[key] === 'opaque') {
          context[key] = opaqueSetBackground;
        } else {
          context[key] = config[key];
        }
      }
    }

    // map plot3dPixelRatio to plotGlPixelRatio for backward compatibility
    if (config.plot3dPixelRatio && !context.plotGlPixelRatio) {
      context.plotGlPixelRatio = context.plot3dPixelRatio;
    }

    // now deal with editable and edits - first editable overrides
    // everything, then edits refines
    var editable = config.editable;
    if (editable !== undefined) {
      // we're not going to *use* context.editable, we're only going to
      // use context.edits... but keep it for the record
      context.editable = editable;
      keys = Object.keys(context.edits);
      for (i = 0; i < keys.length; i++) {
        context.edits[keys[i]] = editable;
      }
    }
    if (config.edits) {
      keys = Object.keys(config.edits);
      for (i = 0; i < keys.length; i++) {
        key = keys[i];
        if (key in context.edits) {
          context.edits[key] = config.edits[key];
        }
      }
    }

    // not part of the user-facing config options
    context._exportedPlot = config._exportedPlot;
  }

  // staticPlot forces a bunch of others:
  if (context.staticPlot) {
    context.editable = false;
    context.edits = {};
    context.autosizable = false;
    context.scrollZoom = false;
    context.doubleClick = false;
    context.showTips = false;
    context.showLink = false;
    context.displayModeBar = false;
  }

  // make sure hover-only devices have mode bar visible
  if (context.displayModeBar === 'hover' && !hasHover) {
    context.displayModeBar = true;
  }

  // default and fallback for setBackground
  if (context.setBackground === 'transparent' || typeof context.setBackground !== 'function') {
    context.setBackground = setBackground;
  }

  // Check if gd has a specified widht/height to begin with
  context._hasZeroHeight = context._hasZeroHeight || gd.clientHeight === 0;
  context._hasZeroWidth = context._hasZeroWidth || gd.clientWidth === 0;

  // fill context._scrollZoom helper to help manage scrollZoom flaglist
  var szIn = context.scrollZoom;
  var szOut = context._scrollZoom = {};
  if (szIn === true) {
    szOut.cartesian = 1;
    szOut.gl3d = 1;
    szOut.geo = 1;
    szOut.mapbox = 1;
    szOut.map = 1;
  } else if (typeof szIn === 'string') {
    var parts = szIn.split('+');
    for (i = 0; i < parts.length; i++) {
      szOut[parts[i]] = 1;
    }
  } else if (szIn !== false) {
    szOut.gl3d = 1;
    szOut.geo = 1;
    szOut.mapbox = 1;
    szOut.map = 1;
  }
}

// convenience function to force a full redraw, mostly for use by plotly.js
function redraw(gd) {
  gd = Lib.getGraphDiv(gd);
  if (!Lib.isPlotDiv(gd)) {
    throw new Error('This element is not a Plotly plot: ' + gd);
  }
  helpers.cleanData(gd.data);
  helpers.cleanLayout(gd.layout);
  gd.calcdata = undefined;
  return exports._doPlot(gd).then(function () {
    gd.emit('plotly_redraw');
    return gd;
  });
}

/**
 * Convenience function to make idempotent plot option obvious to users.
 *
 * @param gd
 * @param {Object[]} data
 * @param {Object} layout
 * @param {Object} config
 */
function newPlot(gd, data, layout, config) {
  gd = Lib.getGraphDiv(gd);

  // remove gl contexts
  Plots.cleanPlot([], {}, gd._fullData || [], gd._fullLayout || {});
  Plots.purge(gd);
  return exports._doPlot(gd, data, layout, config);
}

/**
 * Wrap negative indicies to their positive counterparts.
 *
 * @param {Number[]} indices An array of indices
 * @param {Number} maxIndex The maximum index allowable (arr.length - 1)
 */
function positivifyIndices(indices, maxIndex) {
  var parentLength = maxIndex + 1;
  var positiveIndices = [];
  var i;
  var index;
  for (i = 0; i < indices.length; i++) {
    index = indices[i];
    if (index < 0) {
      positiveIndices.push(parentLength + index);
    } else {
      positiveIndices.push(index);
    }
  }
  return positiveIndices;
}

/**
 * Ensures that an index array for manipulating gd.data is valid.
 *
 * Intended for use with addTraces, deleteTraces, and moveTraces.
 *
 * @param gd
 * @param indices
 * @param arrayName
 */
function assertIndexArray(gd, indices, arrayName) {
  var i, index;
  for (i = 0; i < indices.length; i++) {
    index = indices[i];

    // validate that indices are indeed integers
    if (index !== parseInt(index, 10)) {
      throw new Error('all values in ' + arrayName + ' must be integers');
    }

    // check that all indices are in bounds for given gd.data array length
    if (index >= gd.data.length || index < -gd.data.length) {
      throw new Error(arrayName + ' must be valid indices for gd.data.');
    }

    // check that indices aren't repeated
    if (indices.indexOf(index, i + 1) > -1 || index >= 0 && indices.indexOf(-gd.data.length + index) > -1 || index < 0 && indices.indexOf(gd.data.length + index) > -1) {
      throw new Error('each index in ' + arrayName + ' must be unique.');
    }
  }
}

/**
 * Private function used by Plotly.moveTraces to check input args
 *
 * @param gd
 * @param currentIndices
 * @param newIndices
 */
function checkMoveTracesArgs(gd, currentIndices, newIndices) {
  // check that gd has attribute 'data' and 'data' is array
  if (!Array.isArray(gd.data)) {
    throw new Error('gd.data must be an array.');
  }

  // validate currentIndices array
  if (typeof currentIndices === 'undefined') {
    throw new Error('currentIndices is a required argument.');
  } else if (!Array.isArray(currentIndices)) {
    currentIndices = [currentIndices];
  }
  assertIndexArray(gd, currentIndices, 'currentIndices');

  // validate newIndices array if it exists
  if (typeof newIndices !== 'undefined' && !Array.isArray(newIndices)) {
    newIndices = [newIndices];
  }
  if (typeof newIndices !== 'undefined') {
    assertIndexArray(gd, newIndices, 'newIndices');
  }

  // check currentIndices and newIndices are the same length if newIdices exists
  if (typeof newIndices !== 'undefined' && currentIndices.length !== newIndices.length) {
    throw new Error('current and new indices must be of equal length.');
  }
}
/**
 * A private function to reduce the type checking clutter in addTraces.
 *
 * @param gd
 * @param traces
 * @param newIndices
 */
function checkAddTracesArgs(gd, traces, newIndices) {
  var i, value;

  // check that gd has attribute 'data' and 'data' is array
  if (!Array.isArray(gd.data)) {
    throw new Error('gd.data must be an array.');
  }

  // make sure traces exists
  if (typeof traces === 'undefined') {
    throw new Error('traces must be defined.');
  }

  // make sure traces is an array
  if (!Array.isArray(traces)) {
    traces = [traces];
  }

  // make sure each value in traces is an object
  for (i = 0; i < traces.length; i++) {
    value = traces[i];
    if (typeof value !== 'object' || Array.isArray(value) || value === null) {
      throw new Error('all values in traces array must be non-array objects');
    }
  }

  // make sure we have an index for each trace
  if (typeof newIndices !== 'undefined' && !Array.isArray(newIndices)) {
    newIndices = [newIndices];
  }
  if (typeof newIndices !== 'undefined' && newIndices.length !== traces.length) {
    throw new Error('if indices is specified, traces.length must equal indices.length');
  }
}

/**
 * A private function to reduce the type checking clutter in spliceTraces.
 * Get all update Properties from gd.data. Validate inputs and outputs.
 * Used by prependTrace and extendTraces
 *
 * @param gd
 * @param update
 * @param indices
 * @param maxPoints
 */
function assertExtendTracesArgs(gd, update, indices, maxPoints) {
  var maxPointsIsObject = Lib.isPlainObject(maxPoints);
  if (!Array.isArray(gd.data)) {
    throw new Error('gd.data must be an array');
  }
  if (!Lib.isPlainObject(update)) {
    throw new Error('update must be a key:value object');
  }
  if (typeof indices === 'undefined') {
    throw new Error('indices must be an integer or array of integers');
  }
  assertIndexArray(gd, indices, 'indices');
  for (var key in update) {
    /*
     * Verify that the attribute to be updated contains as many trace updates
     * as indices. Failure must result in throw and no-op
     */
    if (!Array.isArray(update[key]) || update[key].length !== indices.length) {
      throw new Error('attribute ' + key + ' must be an array of length equal to indices array length');
    }

    /*
     * if maxPoints is an object it must match keys and array lengths of 'update' 1:1
     */
    if (maxPointsIsObject && (!(key in maxPoints) || !Array.isArray(maxPoints[key]) || maxPoints[key].length !== update[key].length)) {
      throw new Error('when maxPoints is set as a key:value object it must contain a 1:1 ' + 'corrispondence with the keys and number of traces in the update object');
    }
  }
}

/**
 * A private function to reduce the type checking clutter in spliceTraces.
 *
 * @param {Object|HTMLDivElement} gd
 * @param {Object} update
 * @param {Number[]} indices
 * @param {Number||Object} maxPoints
 * @return {Object[]}
 */
function getExtendProperties(gd, update, indices, maxPoints) {
  var maxPointsIsObject = Lib.isPlainObject(maxPoints);
  var updateProps = [];
  var trace, target, prop, insert, maxp;

  // allow scalar index to represent a single trace position
  if (!Array.isArray(indices)) indices = [indices];

  // negative indices are wrapped around to their positive value. Equivalent to python indexing.
  indices = positivifyIndices(indices, gd.data.length - 1);

  // loop through all update keys and traces and harvest validated data.
  for (var key in update) {
    for (var j = 0; j < indices.length; j++) {
      /*
       * Choose the trace indexed by the indices map argument and get the prop setter-getter
       * instance that references the key and value for this particular trace.
       */
      trace = gd.data[indices[j]];
      prop = nestedProperty(trace, key);

      /*
       * Target is the existing gd.data.trace.dataArray value like "x" or "marker.size"
       * Target must exist as an Array to allow the extend operation to be performed.
       */
      target = prop.get();
      insert = update[key][j];
      if (!Lib.isArrayOrTypedArray(insert)) {
        throw new Error('attribute: ' + key + ' index: ' + j + ' must be an array');
      }
      if (!Lib.isArrayOrTypedArray(target)) {
        throw new Error('cannot extend missing or non-array attribute: ' + key);
      }
      if (target.constructor !== insert.constructor) {
        throw new Error('cannot extend array with an array of a different type: ' + key);
      }

      /*
       * maxPoints may be an object map or a scalar. If object select the key:value, else
       * Use the scalar maxPoints for all key and trace combinations.
       */
      maxp = maxPointsIsObject ? maxPoints[key][j] : maxPoints;

      // could have chosen null here, -1 just tells us to not take a window
      if (!isNumeric(maxp)) maxp = -1;

      /*
       * Wrap the nestedProperty in an object containing required data
       * for lengthening and windowing this particular trace - key combination.
       * Flooring maxp mirrors the behaviour of floats in the Array.slice JSnative function.
       */
      updateProps.push({
        prop: prop,
        target: target,
        insert: insert,
        maxp: Math.floor(maxp)
      });
    }
  }

  // all target and insertion data now validated
  return updateProps;
}

/**
 * A private function to key Extend and Prepend traces DRY
 *
 * @param {Object|HTMLDivElement} gd
 * @param {Object} update
 * @param {Number[]} indices
 * @param {Number||Object} maxPoints
 * @param {Function} updateArray
 * @return {Object}
 */
function spliceTraces(gd, update, indices, maxPoints, updateArray) {
  assertExtendTracesArgs(gd, update, indices, maxPoints);
  var updateProps = getExtendProperties(gd, update, indices, maxPoints);
  var undoUpdate = {};
  var undoPoints = {};
  for (var i = 0; i < updateProps.length; i++) {
    var prop = updateProps[i].prop;
    var maxp = updateProps[i].maxp;

    // return new array and remainder
    var out = updateArray(updateProps[i].target, updateProps[i].insert, maxp);
    prop.set(out[0]);

    // build the inverse update object for the undo operation
    if (!Array.isArray(undoUpdate[prop.astr])) undoUpdate[prop.astr] = [];
    undoUpdate[prop.astr].push(out[1]);

    // build the matching maxPoints undo object containing original trace lengths
    if (!Array.isArray(undoPoints[prop.astr])) undoPoints[prop.astr] = [];
    undoPoints[prop.astr].push(updateProps[i].target.length);
  }
  return {
    update: undoUpdate,
    maxPoints: undoPoints
  };
}
function concatTypedArray(arr0, arr1) {
  var arr2 = new arr0.constructor(arr0.length + arr1.length);
  arr2.set(arr0);
  arr2.set(arr1, arr0.length);
  return arr2;
}

/**
 * extend && prepend traces at indices with update arrays, window trace lengths to maxPoints
 *
 * Extend and Prepend have identical APIs. Prepend inserts an array at the head while Extend
 * inserts an array off the tail. Prepend truncates the tail of the array - counting maxPoints
 * from the head, whereas Extend truncates the head of the array, counting backward maxPoints
 * from the tail.
 *
 * If maxPoints is undefined, nonNumeric, negative or greater than extended trace length no
 * truncation / windowing will be performed. If its zero, well the whole trace is truncated.
 *
 * @param {Object|HTMLDivElement} gd The graph div
 * @param {Object} update The key:array map of target attributes to extend
 * @param {Number|Number[]} indices The locations of traces to be extended
 * @param {Number|Object} [maxPoints] Number of points for trace window after lengthening.
 *
 */
function extendTraces(gd, update, indices, maxPoints) {
  gd = Lib.getGraphDiv(gd);
  function updateArray(target, insert, maxp) {
    var newArray, remainder;
    if (Lib.isTypedArray(target)) {
      if (maxp < 0) {
        var none = new target.constructor(0);
        var both = concatTypedArray(target, insert);
        if (maxp < 0) {
          newArray = both;
          remainder = none;
        } else {
          newArray = none;
          remainder = both;
        }
      } else {
        newArray = new target.constructor(maxp);
        remainder = new target.constructor(target.length + insert.length - maxp);
        if (maxp === insert.length) {
          newArray.set(insert);
          remainder.set(target);
        } else if (maxp < insert.length) {
          var numberOfItemsFromInsert = insert.length - maxp;
          newArray.set(insert.subarray(numberOfItemsFromInsert));
          remainder.set(target);
          remainder.set(insert.subarray(0, numberOfItemsFromInsert), target.length);
        } else {
          var numberOfItemsFromTarget = maxp - insert.length;
          var targetBegin = target.length - numberOfItemsFromTarget;
          newArray.set(target.subarray(targetBegin));
          newArray.set(insert, numberOfItemsFromTarget);
          remainder.set(target.subarray(0, targetBegin));
        }
      }
    } else {
      newArray = target.concat(insert);
      remainder = maxp >= 0 && maxp < newArray.length ? newArray.splice(0, newArray.length - maxp) : [];
    }
    return [newArray, remainder];
  }
  var undo = spliceTraces(gd, update, indices, maxPoints, updateArray);
  var promise = exports.redraw(gd);
  var undoArgs = [gd, undo.update, indices, undo.maxPoints];
  Queue.add(gd, exports.prependTraces, undoArgs, extendTraces, arguments);
  return promise;
}
function prependTraces(gd, update, indices, maxPoints) {
  gd = Lib.getGraphDiv(gd);
  function updateArray(target, insert, maxp) {
    var newArray, remainder;
    if (Lib.isTypedArray(target)) {
      if (maxp <= 0) {
        var none = new target.constructor(0);
        var both = concatTypedArray(insert, target);
        if (maxp < 0) {
          newArray = both;
          remainder = none;
        } else {
          newArray = none;
          remainder = both;
        }
      } else {
        newArray = new target.constructor(maxp);
        remainder = new target.constructor(target.length + insert.length - maxp);
        if (maxp === insert.length) {
          newArray.set(insert);
          remainder.set(target);
        } else if (maxp < insert.length) {
          var numberOfItemsFromInsert = insert.length - maxp;
          newArray.set(insert.subarray(0, numberOfItemsFromInsert));
          remainder.set(insert.subarray(numberOfItemsFromInsert));
          remainder.set(target, numberOfItemsFromInsert);
        } else {
          var numberOfItemsFromTarget = maxp - insert.length;
          newArray.set(insert);
          newArray.set(target.subarray(0, numberOfItemsFromTarget), insert.length);
          remainder.set(target.subarray(numberOfItemsFromTarget));
        }
      }
    } else {
      newArray = insert.concat(target);
      remainder = maxp >= 0 && maxp < newArray.length ? newArray.splice(maxp, newArray.length) : [];
    }
    return [newArray, remainder];
  }
  var undo = spliceTraces(gd, update, indices, maxPoints, updateArray);
  var promise = exports.redraw(gd);
  var undoArgs = [gd, undo.update, indices, undo.maxPoints];
  Queue.add(gd, exports.extendTraces, undoArgs, prependTraces, arguments);
  return promise;
}

/**
 * Add data traces to an existing graph div.
 *
 * @param {Object|HTMLDivElement} gd The graph div
 * @param {Object[]} gd.data The array of traces we're adding to
 * @param {Object[]|Object} traces The object or array of objects to add
 * @param {Number[]|Number} [newIndices=[gd.data.length]] Locations to add traces
 *
 */
function addTraces(gd, traces, newIndices) {
  gd = Lib.getGraphDiv(gd);
  var currentIndices = [];
  var undoFunc = exports.deleteTraces;
  var redoFunc = addTraces;
  var undoArgs = [gd, currentIndices];
  var redoArgs = [gd, traces]; // no newIndices here
  var i;
  var promise;

  // all validation is done elsewhere to remove clutter here
  checkAddTracesArgs(gd, traces, newIndices);

  // make sure traces is an array
  if (!Array.isArray(traces)) {
    traces = [traces];
  }

  // make sure traces do not repeat existing ones
  traces = traces.map(function (trace) {
    return Lib.extendFlat({}, trace);
  });
  helpers.cleanData(traces);

  // add the traces to gd.data (no redrawing yet!)
  for (i = 0; i < traces.length; i++) {
    gd.data.push(traces[i]);
  }

  // to continue, we need to call moveTraces which requires currentIndices
  for (i = 0; i < traces.length; i++) {
    currentIndices.push(-traces.length + i);
  }

  // if the user didn't define newIndices, they just want the traces appended
  // i.e., we can simply redraw and be done
  if (typeof newIndices === 'undefined') {
    promise = exports.redraw(gd);
    Queue.add(gd, undoFunc, undoArgs, redoFunc, redoArgs);
    return promise;
  }

  // make sure indices is property defined
  if (!Array.isArray(newIndices)) {
    newIndices = [newIndices];
  }
  try {
    // this is redundant, but necessary to not catch later possible errors!
    checkMoveTracesArgs(gd, currentIndices, newIndices);
  } catch (error) {
    // something went wrong, reset gd to be safe and rethrow error
    gd.data.splice(gd.data.length - traces.length, traces.length);
    throw error;
  }

  // if we're here, the user has defined specific places to place the new traces
  // this requires some extra work that moveTraces will do
  Queue.startSequence(gd);
  Queue.add(gd, undoFunc, undoArgs, redoFunc, redoArgs);
  promise = exports.moveTraces(gd, currentIndices, newIndices);
  Queue.stopSequence(gd);
  return promise;
}

/**
 * Delete traces at `indices` from gd.data array.
 *
 * @param {Object|HTMLDivElement} gd The graph div
 * @param {Object[]} gd.data The array of traces we're removing from
 * @param {Number|Number[]} indices The indices
 */
function deleteTraces(gd, indices) {
  gd = Lib.getGraphDiv(gd);
  var traces = [];
  var undoFunc = exports.addTraces;
  var redoFunc = deleteTraces;
  var undoArgs = [gd, traces, indices];
  var redoArgs = [gd, indices];
  var i;
  var deletedTrace;

  // make sure indices are defined
  if (typeof indices === 'undefined') {
    throw new Error('indices must be an integer or array of integers.');
  } else if (!Array.isArray(indices)) {
    indices = [indices];
  }
  assertIndexArray(gd, indices, 'indices');

  // convert negative indices to positive indices
  indices = positivifyIndices(indices, gd.data.length - 1);

  // we want descending here so that splicing later doesn't affect indexing
  indices.sort(Lib.sorterDes);
  for (i = 0; i < indices.length; i += 1) {
    deletedTrace = gd.data.splice(indices[i], 1)[0];
    traces.push(deletedTrace);
  }
  var promise = exports.redraw(gd);
  Queue.add(gd, undoFunc, undoArgs, redoFunc, redoArgs);
  return promise;
}

/**
 * Move traces at currentIndices array to locations in newIndices array.
 *
 * If newIndices is omitted, currentIndices will be moved to the end. E.g.,
 * these are equivalent:
 *
 * Plotly.moveTraces(gd, [1, 2, 3], [-3, -2, -1])
 * Plotly.moveTraces(gd, [1, 2, 3])
 *
 * @param {Object|HTMLDivElement} gd The graph div
 * @param {Object[]} gd.data The array of traces we're removing from
 * @param {Number|Number[]} currentIndices The locations of traces to be moved
 * @param {Number|Number[]} [newIndices] The locations to move traces to
 *
 * Example calls:
 *
 *      // move trace i to location x
 *      Plotly.moveTraces(gd, i, x)
 *
 *      // move trace i to end of array
 *      Plotly.moveTraces(gd, i)
 *
 *      // move traces i, j, k to end of array (i != j != k)
 *      Plotly.moveTraces(gd, [i, j, k])
 *
 *      // move traces [i, j, k] to [x, y, z] (i != j != k) (x != y != z)
 *      Plotly.moveTraces(gd, [i, j, k], [x, y, z])
 *
 *      // reorder all traces (assume there are 5--a, b, c, d, e)
 *      Plotly.moveTraces(gd, [b, d, e, a, c])  // same as 'move to end'
 */
function moveTraces(gd, currentIndices, newIndices) {
  gd = Lib.getGraphDiv(gd);
  var newData = [];
  var movingTraceMap = [];
  var undoFunc = moveTraces;
  var redoFunc = moveTraces;
  var undoArgs = [gd, newIndices, currentIndices];
  var redoArgs = [gd, currentIndices, newIndices];
  var i;

  // to reduce complexity here, check args elsewhere
  // this throws errors where appropriate
  checkMoveTracesArgs(gd, currentIndices, newIndices);

  // make sure currentIndices is an array
  currentIndices = Array.isArray(currentIndices) ? currentIndices : [currentIndices];

  // if undefined, define newIndices to point to the end of gd.data array
  if (typeof newIndices === 'undefined') {
    newIndices = [];
    for (i = 0; i < currentIndices.length; i++) {
      newIndices.push(-currentIndices.length + i);
    }
  }

  // make sure newIndices is an array if it's user-defined
  newIndices = Array.isArray(newIndices) ? newIndices : [newIndices];

  // convert negative indices to positive indices (they're the same length)
  currentIndices = positivifyIndices(currentIndices, gd.data.length - 1);
  newIndices = positivifyIndices(newIndices, gd.data.length - 1);

  // at this point, we've coerced the index arrays into predictable forms

  // get the traces that aren't being moved around
  for (i = 0; i < gd.data.length; i++) {
    // if index isn't in currentIndices, include it in ignored!
    if (currentIndices.indexOf(i) === -1) {
      newData.push(gd.data[i]);
    }
  }

  // get a mapping of indices to moving traces
  for (i = 0; i < currentIndices.length; i++) {
    movingTraceMap.push({
      newIndex: newIndices[i],
      trace: gd.data[currentIndices[i]]
    });
  }

  // reorder this mapping by newIndex, ascending
  movingTraceMap.sort(function (a, b) {
    return a.newIndex - b.newIndex;
  });

  // now, add the moving traces back in, in order!
  for (i = 0; i < movingTraceMap.length; i += 1) {
    newData.splice(movingTraceMap[i].newIndex, 0, movingTraceMap[i].trace);
  }
  gd.data = newData;
  var promise = exports.redraw(gd);
  Queue.add(gd, undoFunc, undoArgs, redoFunc, redoArgs);
  return promise;
}

/**
 * restyle: update trace attributes of an existing plot
 *
 * Can be called two ways.
 *
 * Signature 1:
 * @param {String | HTMLDivElement} gd
 *  the id or DOM element of the graph container div
 * @param {String} astr
 *  attribute string (like `'marker.symbol'`) to update
 * @param {*} val
 *  value to give this attribute
 * @param {Number[] | Number} [traces]
 *  integer or array of integers for the traces to alter (all if omitted)
 *
 * Signature 2:
 * @param {String | HTMLDivElement} gd
 *  (as in signature 1)
 * @param {Object} aobj
 *  attribute object `{astr1: val1, astr2: val2 ...}`
 *  allows setting multiple attributes simultaneously
 * @param {Number[] | Number} [traces]
 *  (as in signature 1)
 *
 * `val` (or `val1`, `val2` ... in the object form) can be an array,
 * to apply different values to each trace.
 *
 * If the array is too short, it will wrap around (useful for
 * style files that want to specify cyclical default values).
 */
function restyle(gd, astr, val, _traces) {
  gd = Lib.getGraphDiv(gd);
  helpers.clearPromiseQueue(gd);
  var aobj = {};
  if (typeof astr === 'string') aobj[astr] = val;else if (Lib.isPlainObject(astr)) {
    // the 3-arg form
    aobj = Lib.extendFlat({}, astr);
    if (_traces === undefined) _traces = val;
  } else {
    Lib.warn('Restyle fail.', astr, val, _traces);
    return Promise.reject();
  }
  if (Object.keys(aobj).length) gd.changed = true;
  var traces = helpers.coerceTraceIndices(gd, _traces);
  var specs = _restyle(gd, aobj, traces);
  var flags = specs.flags;

  // clear calcdata and/or axis types if required so they get regenerated
  if (flags.calc) gd.calcdata = undefined;
  if (flags.clearAxisTypes) helpers.clearAxisTypes(gd, traces, {});

  // fill in redraw sequence
  var seq = [];
  if (flags.fullReplot) {
    seq.push(exports._doPlot);
  } else {
    seq.push(Plots.previousPromises);

    // maybe only call Plots.supplyDataDefaults in the splom case,
    // to skip over long and slow axes defaults
    Plots.supplyDefaults(gd);
    if (flags.markerSize) {
      Plots.doCalcdata(gd);
      addAxRangeSequence(seq);

      // TODO
      // if all axes have autorange:false, then
      // proceed to subroutines.doTraceStyle(),
      // otherwise we must go through addAxRangeSequence,
      // which in general must redraws 'all' axes
    }
    if (flags.style) seq.push(subroutines.doTraceStyle);
    if (flags.colorbars) seq.push(subroutines.doColorBars);
    seq.push(emitAfterPlot);
  }
  seq.push(Plots.rehover, Plots.redrag, Plots.reselect);
  Queue.add(gd, restyle, [gd, specs.undoit, specs.traces], restyle, [gd, specs.redoit, specs.traces]);
  var plotDone = Lib.syncOrAsync(seq, gd);
  if (!plotDone || !plotDone.then) plotDone = Promise.resolve();
  return plotDone.then(function () {
    gd.emit('plotly_restyle', specs.eventData);
    return gd;
  });
}

// for undo: undefined initial vals must be turned into nulls
// so that we unset rather than ignore them
function undefinedToNull(val) {
  if (val === undefined) return null;
  return val;
}

/**
 * Factory function to wrap nestedProperty with GUI edits if necessary
 * with GUI edits we add an optional prefix to the nestedProperty constructor
 * to prepend to the attribute string in the preGUI store.
 */
function makeNP(preGUI, guiEditFlag) {
  if (!guiEditFlag) return nestedProperty;
  return function (container, attr, prefix) {
    var np = nestedProperty(container, attr);
    var npSet = np.set;
    np.set = function (val) {
      var fullAttr = (prefix || '') + attr;
      storeCurrent(fullAttr, np.get(), val, preGUI);
      npSet(val);
    };
    return np;
  };
}
function storeCurrent(attr, val, newVal, preGUI) {
  if (Array.isArray(val) || Array.isArray(newVal)) {
    var arrayVal = Array.isArray(val) ? val : [];
    var arrayNew = Array.isArray(newVal) ? newVal : [];
    var maxLen = Math.max(arrayVal.length, arrayNew.length);
    for (var i = 0; i < maxLen; i++) {
      storeCurrent(attr + '[' + i + ']', arrayVal[i], arrayNew[i], preGUI);
    }
  } else if (Lib.isPlainObject(val) || Lib.isPlainObject(newVal)) {
    var objVal = Lib.isPlainObject(val) ? val : {};
    var objNew = Lib.isPlainObject(newVal) ? newVal : {};
    var objBoth = Lib.extendFlat({}, objVal, objNew);
    for (var key in objBoth) {
      storeCurrent(attr + '.' + key, objVal[key], objNew[key], preGUI);
    }
  } else if (preGUI[attr] === undefined) {
    preGUI[attr] = undefinedToNull(val);
  }
}

/**
 * storeDirectGUIEdit: for routines that skip restyle/relayout and mock it
 * by emitting a plotly_restyle or plotly_relayout event, this routine
 * keeps track of the initial state in _preGUI for use by uirevision
 * Does *not* apply these changes to data/layout - that's the responsibility
 * of the calling routine.
 *
 * @param {object} container: the input attributes container (eg `layout` or a `trace`)
 * @param {object} preGUI: where original values should be stored, either
 *     `layout._preGUI` or `layout._tracePreGUI[uid]`
 * @param {object} edits: the {attr: val} object as normally passed to `relayout` etc
 */
function _storeDirectGUIEdit(container, preGUI, edits) {
  for (var attr in edits) {
    var np = nestedProperty(container, attr);
    storeCurrent(attr, np.get(), edits[attr], preGUI);
  }
}
function _restyle(gd, aobj, traces) {
  var fullLayout = gd._fullLayout;
  var fullData = gd._fullData;
  var data = gd.data;
  var guiEditFlag = fullLayout._guiEditing;
  var layoutNP = makeNP(fullLayout._preGUI, guiEditFlag);
  var eventData = Lib.extendDeepAll({}, aobj);
  var i;
  cleanDeprecatedAttributeKeys(aobj);

  // initialize flags
  var flags = editTypes.traceFlags();

  // copies of the change (and previous values of anything affected)
  // for the undo / redo queue
  var redoit = {};
  var undoit = {};
  var axlist;

  // make a new empty vals array for undoit
  function a0() {
    return traces.map(function () {
      return undefined;
    });
  }

  // for autoranging multiple axes
  function addToAxlist(axid) {
    var axName = Axes.id2name(axid);
    if (axlist.indexOf(axName) === -1) axlist.push(axName);
  }
  function autorangeAttr(axName) {
    return 'LAYOUT' + axName + '.autorange';
  }
  function rangeAttr(axName) {
    return 'LAYOUT' + axName + '.range';
  }
  function getFullTrace(traceIndex) {
    // usually fullData maps 1:1 onto data, but with groupby transforms
    // the fullData index can be greater. Take the *first* matching trace.
    for (var j = traceIndex; j < fullData.length; j++) {
      if (fullData[j]._input === data[traceIndex]) return fullData[j];
    }
    // should never get here - and if we *do* it should cause an error
    // later on undefined fullTrace is passed to nestedProperty.
  }

  // for attrs that interact (like scales & autoscales), save the
  // old vals before making the change
  // val=undefined will not set a value, just record what the value was.
  // val=null will delete the attribute
  // attr can be an array to set several at once (all to the same val)
  function doextra(attr, val, i) {
    if (Array.isArray(attr)) {
      attr.forEach(function (a) {
        doextra(a, val, i);
      });
      return;
    }
    // quit if explicitly setting this elsewhere
    if (attr in aobj || helpers.hasParent(aobj, attr)) return;
    var extraparam;
    if (attr.substr(0, 6) === 'LAYOUT') {
      extraparam = layoutNP(gd.layout, attr.replace('LAYOUT', ''));
    } else {
      var tracei = traces[i];
      var preGUI = fullLayout._tracePreGUI[getFullTrace(tracei)._fullInput.uid];
      extraparam = makeNP(preGUI, guiEditFlag)(data[tracei], attr);
    }
    if (!(attr in undoit)) {
      undoit[attr] = a0();
    }
    if (undoit[attr][i] === undefined) {
      undoit[attr][i] = undefinedToNull(extraparam.get());
    }
    if (val !== undefined) {
      extraparam.set(val);
    }
  }
  function allBins(binAttr) {
    return function (j) {
      return fullData[j][binAttr];
    };
  }
  function arrayBins(binAttr) {
    return function (vij, j) {
      return vij === false ? fullData[traces[j]][binAttr] : null;
    };
  }

  // now make the changes to gd.data (and occasionally gd.layout)
  // and figure out what kind of graphics update we need to do
  for (var ai in aobj) {
    if (helpers.hasParent(aobj, ai)) {
      throw new Error('cannot set ' + ai + ' and a parent attribute simultaneously');
    }
    var vi = aobj[ai];
    var cont;
    var contFull;
    var param;
    var oldVal;
    var newVal;
    var valObject;

    // Backward compatibility shim for turning histogram autobin on,
    // or freezing previous autobinned values.
    // Replace obsolete `autobin(x|y): true` with `(x|y)bins: null`
    // and `autobin(x|y): false` with the `(x|y)bins` in `fullData`
    if (ai === 'autobinx' || ai === 'autobiny') {
      ai = ai.charAt(ai.length - 1) + 'bins';
      if (Array.isArray(vi)) vi = vi.map(arrayBins(ai));else if (vi === false) vi = traces.map(allBins(ai));else vi = null;
    }
    redoit[ai] = vi;
    if (ai.substr(0, 6) === 'LAYOUT') {
      param = layoutNP(gd.layout, ai.replace('LAYOUT', ''));
      undoit[ai] = [undefinedToNull(param.get())];
      // since we're allowing val to be an array, allow it here too,
      // even though that's meaningless
      param.set(Array.isArray(vi) ? vi[0] : vi);
      // ironically, the layout attrs in restyle only require replot,
      // not relayout
      flags.calc = true;
      continue;
    }

    // set attribute in gd.data
    undoit[ai] = a0();
    for (i = 0; i < traces.length; i++) {
      cont = data[traces[i]];
      contFull = getFullTrace(traces[i]);
      var preGUI = fullLayout._tracePreGUI[contFull._fullInput.uid];
      param = makeNP(preGUI, guiEditFlag)(cont, ai);
      oldVal = param.get();
      newVal = Array.isArray(vi) ? vi[i % vi.length] : vi;
      if (newVal === undefined) continue;
      var finalPart = param.parts[param.parts.length - 1];
      var prefix = ai.substr(0, ai.length - finalPart.length - 1);
      var prefixDot = prefix ? prefix + '.' : '';
      var innerContFull = prefix ? nestedProperty(contFull, prefix).get() : contFull;
      valObject = PlotSchema.getTraceValObject(contFull, param.parts);
      if (valObject && valObject.impliedEdits && newVal !== null) {
        for (var impliedKey in valObject.impliedEdits) {
          doextra(Lib.relativeAttr(ai, impliedKey), valObject.impliedEdits[impliedKey], i);
        }
      } else if ((finalPart === 'thicknessmode' || finalPart === 'lenmode') && oldVal !== newVal && (newVal === 'fraction' || newVal === 'pixels') && innerContFull) {
        // changing colorbar size modes,
        // make the resulting size not change
        // note that colorbar fractional sizing is based on the
        // original plot size, before anything (like a colorbar)
        // increases the margins

        var gs = fullLayout._size;
        var orient = innerContFull.orient;
        var topOrBottom = orient === 'top' || orient === 'bottom';
        if (finalPart === 'thicknessmode') {
          var thicknorm = topOrBottom ? gs.h : gs.w;
          doextra(prefixDot + 'thickness', innerContFull.thickness * (newVal === 'fraction' ? 1 / thicknorm : thicknorm), i);
        } else {
          var lennorm = topOrBottom ? gs.w : gs.h;
          doextra(prefixDot + 'len', innerContFull.len * (newVal === 'fraction' ? 1 / lennorm : lennorm), i);
        }
      } else if (ai === 'type' && (newVal === 'pie' !== (oldVal === 'pie') || newVal === 'funnelarea' !== (oldVal === 'funnelarea'))) {
        var labelsTo = 'x';
        var valuesTo = 'y';
        if ((newVal === 'bar' || oldVal === 'bar') && cont.orientation === 'h') {
          labelsTo = 'y';
          valuesTo = 'x';
        }
        Lib.swapAttrs(cont, ['?', '?src'], 'labels', labelsTo);
        Lib.swapAttrs(cont, ['d?', '?0'], 'label', labelsTo);
        Lib.swapAttrs(cont, ['?', '?src'], 'values', valuesTo);
        if (oldVal === 'pie' || oldVal === 'funnelarea') {
          nestedProperty(cont, 'marker.color').set(nestedProperty(cont, 'marker.colors').get());

          // super kludgy - but if all pies are gone we won't remove them otherwise
          fullLayout._pielayer.selectAll('g.trace').remove();
        } else if (Registry.traceIs(cont, 'cartesian')) {
          nestedProperty(cont, 'marker.colors').set(nestedProperty(cont, 'marker.color').get());
        }
      }
      undoit[ai][i] = undefinedToNull(oldVal);
      // set the new value - if val is an array, it's one el per trace
      // first check for attributes that get more complex alterations
      var swapAttrs = ['swapxy', 'swapxyaxes', 'orientation', 'orientationaxes'];
      if (swapAttrs.indexOf(ai) !== -1) {
        // setting an orientation: make sure it's changing
        // before we swap everything else
        if (ai === 'orientation') {
          param.set(newVal);
          // obnoxious that we need this level of coupling... but in order to
          // properly handle setting orientation to `null` we need to mimic
          // the logic inside Bars.supplyDefaults for default orientation
          var defaultOrientation = cont.x && !cont.y ? 'h' : 'v';
          if ((param.get() || defaultOrientation) === contFull.orientation) {
            continue;
          }
        } else if (ai === 'orientationaxes') {
          // orientationaxes has no value,
          // it flips everything and the axes

          cont.orientation = {
            v: 'h',
            h: 'v'
          }[contFull.orientation];
        }
        helpers.swapXYData(cont);
        flags.calc = flags.clearAxisTypes = true;
      } else if (Plots.dataArrayContainers.indexOf(param.parts[0]) !== -1) {
        // TODO: use manageArrays.applyContainerArrayChanges here too
        helpers.manageArrayContainers(param, newVal, undoit);
        flags.calc = true;
      } else {
        if (valObject) {
          // must redo calcdata when restyling array values of arrayOk attributes
          // ... but no need to this for regl-based traces
          if (valObject.arrayOk && !Registry.traceIs(contFull, 'regl') && (Lib.isArrayOrTypedArray(newVal) || Lib.isArrayOrTypedArray(oldVal))) {
            flags.calc = true;
          } else editTypes.update(flags, valObject);
        } else {
          /*
           * if we couldn't find valObject,  assume a full recalc.
           * This can happen if you're changing type and making
           * some other edits too, so the modules we're
           * looking at don't have these attributes in them.
           */
          flags.calc = true;
        }

        // all the other ones, just modify that one attribute
        param.set(newVal);
      }
    }

    // swap the data attributes of the relevant x and y axes?
    if (['swapxyaxes', 'orientationaxes'].indexOf(ai) !== -1) {
      Axes.swap(gd, traces);
    }

    // swap hovermode if set to "compare x/y data"
    if (ai === 'orientationaxes') {
      var hovermode = nestedProperty(gd.layout, 'hovermode');
      var h = hovermode.get();
      if (h === 'x') {
        hovermode.set('y');
      } else if (h === 'y') {
        hovermode.set('x');
      } else if (h === 'x unified') {
        hovermode.set('y unified');
      } else if (h === 'y unified') {
        hovermode.set('x unified');
      }
    }

    // Major enough changes deserve autoscale and
    // non-reversed axes so people don't get confused
    //
    // Note: autobin (or its new analog bin clearing) is not included here
    // since we're not pushing bins back to gd.data, so if we have bin
    // info it was explicitly provided by the user.
    if (['orientation', 'type'].indexOf(ai) !== -1) {
      axlist = [];
      for (i = 0; i < traces.length; i++) {
        var trace = data[traces[i]];
        if (Registry.traceIs(trace, 'cartesian')) {
          addToAxlist(trace.xaxis || 'x');
          addToAxlist(trace.yaxis || 'y');
        }
      }
      doextra(axlist.map(autorangeAttr), true, 0);
      doextra(axlist.map(rangeAttr), [0, 1], 0);
    }
  }
  if (flags.calc || flags.plot) {
    flags.fullReplot = true;
  }
  return {
    flags: flags,
    undoit: undoit,
    redoit: redoit,
    traces: traces,
    eventData: Lib.extendDeepNoArrays([], [eventData, traces])
  };
}

/**
 * Converts deprecated attribute keys to
 * the current API to ensure backwards compatibility.
 *
 * This is needed for the update mechanism to determine which
 * subroutines to run based on the actual attribute
 * definitions (that don't include the deprecated ones).
 *
 * E.g. Maps {'xaxis.title': 'A chart'} to {'xaxis.title.text': 'A chart'}
 * and {titlefont: {...}} to {'title.font': {...}}.
 *
 * @param aobj
 */
function cleanDeprecatedAttributeKeys(aobj) {
  var oldAxisTitleRegex = Lib.counterRegex('axis', '\.title', false, false);
  var colorbarRegex = /colorbar\.title$/;
  var keys = Object.keys(aobj);
  var i, key, value;
  for (i = 0; i < keys.length; i++) {
    key = keys[i];
    value = aobj[key];
    if ((key === 'title' || oldAxisTitleRegex.test(key) || colorbarRegex.test(key)) && (typeof value === 'string' || typeof value === 'number')) {
      replace(key, key.replace('title', 'title.text'));
    } else if (key.indexOf('titlefont') > -1 && key.indexOf('grouptitlefont') === -1) {
      replace(key, key.replace('titlefont', 'title.font'));
    } else if (key.indexOf('titleposition') > -1) {
      replace(key, key.replace('titleposition', 'title.position'));
    } else if (key.indexOf('titleside') > -1) {
      replace(key, key.replace('titleside', 'title.side'));
    } else if (key.indexOf('titleoffset') > -1) {
      replace(key, key.replace('titleoffset', 'title.offset'));
    }
  }
  function replace(oldAttrStr, newAttrStr) {
    aobj[newAttrStr] = aobj[oldAttrStr];
    delete aobj[oldAttrStr];
  }
}

/**
 * relayout: update layout attributes of an existing plot
 *
 * Can be called two ways:
 *
 * Signature 1:
 * @param {String | HTMLDivElement} gd
 *  the id or dom element of the graph container div
 * @param {String} astr
 *  attribute string (like `'xaxis.range[0]'`) to update
 * @param {*} val
 *  value to give this attribute
 *
 * Signature 2:
 * @param {String | HTMLDivElement} gd
 *  (as in signature 1)
 * @param {Object} aobj
 *  attribute object `{astr1: val1, astr2: val2 ...}`
 *  allows setting multiple attributes simultaneously
 */
function relayout(gd, astr, val) {
  gd = Lib.getGraphDiv(gd);
  helpers.clearPromiseQueue(gd);
  var aobj = {};
  if (typeof astr === 'string') {
    aobj[astr] = val;
  } else if (Lib.isPlainObject(astr)) {
    aobj = Lib.extendFlat({}, astr);
  } else {
    Lib.warn('Relayout fail.', astr, val);
    return Promise.reject();
  }
  if (Object.keys(aobj).length) gd.changed = true;
  var specs = _relayout(gd, aobj);
  var flags = specs.flags;

  // clear calcdata if required
  if (flags.calc) gd.calcdata = undefined;

  // fill in redraw sequence

  // even if we don't have anything left in aobj,
  // something may have happened within relayout that we
  // need to wait for
  var seq = [Plots.previousPromises];
  if (flags.layoutReplot) {
    seq.push(subroutines.layoutReplot);
  } else if (Object.keys(aobj).length) {
    axRangeSupplyDefaultsByPass(gd, flags, specs) || Plots.supplyDefaults(gd);
    if (flags.legend) seq.push(subroutines.doLegend);
    if (flags.layoutstyle) seq.push(subroutines.layoutStyles);
    if (flags.axrange) addAxRangeSequence(seq, specs.rangesAltered);
    if (flags.ticks) seq.push(subroutines.doTicksRelayout);
    if (flags.modebar) seq.push(subroutines.doModeBar);
    if (flags.camera) seq.push(subroutines.doCamera);
    if (flags.colorbars) seq.push(subroutines.doColorBars);
    seq.push(emitAfterPlot);
  }
  seq.push(Plots.rehover, Plots.redrag, Plots.reselect);
  Queue.add(gd, relayout, [gd, specs.undoit], relayout, [gd, specs.redoit]);
  var plotDone = Lib.syncOrAsync(seq, gd);
  if (!plotDone || !plotDone.then) plotDone = Promise.resolve(gd);
  return plotDone.then(function () {
    gd.emit('plotly_relayout', specs.eventData);
    return gd;
  });
}

// Optimization mostly for large splom traces where
// Plots.supplyDefaults can take > 100ms
function axRangeSupplyDefaultsByPass(gd, flags, specs) {
  var fullLayout = gd._fullLayout;
  if (!flags.axrange) return false;
  for (var k in flags) {
    if (k !== 'axrange' && flags[k]) return false;
  }
  var axIn, axOut;
  var coerce = function (attr, dflt) {
    return Lib.coerce(axIn, axOut, cartesianLayoutAttributes, attr, dflt);
  };
  var options = {}; // passing empty options for now!

  for (var axId in specs.rangesAltered) {
    var axName = Axes.id2name(axId);
    axIn = gd.layout[axName];
    axOut = fullLayout[axName];
    handleRangeDefaults(axIn, axOut, coerce, options);
    if (axOut._matchGroup) {
      for (var axId2 in axOut._matchGroup) {
        if (axId2 !== axId) {
          var ax2 = fullLayout[Axes.id2name(axId2)];
          ax2.autorange = axOut.autorange;
          ax2.range = axOut.range.slice();
          ax2._input.range = axOut.range.slice();
        }
      }
    }
  }
  return true;
}
function addAxRangeSequence(seq, rangesAltered) {
  // N.B. leave as sequence of subroutines (for now) instead of
  // subroutine of its own so that finalDraw always gets
  // executed after drawData
  var drawAxes = rangesAltered ? function (gd) {
    var axIds = [];
    var skipTitle = true;
    for (var id in rangesAltered) {
      var ax = Axes.getFromId(gd, id);
      axIds.push(id);
      if ((ax.ticklabelposition || '').indexOf('inside') !== -1) {
        if (ax._anchorAxis) {
          axIds.push(ax._anchorAxis._id);
        }
      }
      if (ax._matchGroup) {
        for (var id2 in ax._matchGroup) {
          if (!rangesAltered[id2]) {
            axIds.push(id2);
          }
        }
      }
    }
    return Axes.draw(gd, axIds, {
      skipTitle: skipTitle
    });
  } : function (gd) {
    return Axes.draw(gd, 'redraw');
  };
  seq.push(clearOutline, subroutines.doAutoRangeAndConstraints, drawAxes, subroutines.drawData, subroutines.finalDraw);
}
var AX_RANGE_RE = /^[xyz]axis[0-9]*\.range(\[[0|1]\])?$/;
var AX_AUTORANGE_RE = /^[xyz]axis[0-9]*\.autorange$/;
var AX_DOMAIN_RE = /^[xyz]axis[0-9]*\.domain(\[[0|1]\])?$/;
function _relayout(gd, aobj) {
  var layout = gd.layout;
  var fullLayout = gd._fullLayout;
  var guiEditFlag = fullLayout._guiEditing;
  var layoutNP = makeNP(fullLayout._preGUI, guiEditFlag);
  var keys = Object.keys(aobj);
  var axes = Axes.list(gd);
  var eventData = Lib.extendDeepAll({}, aobj);
  var arrayEdits = {};
  var arrayStr, i, j;
  cleanDeprecatedAttributeKeys(aobj);
  keys = Object.keys(aobj);

  // look for 'allaxes', split out into all axes
  // in case of 3D the axis are nested within a scene which is held in _id
  for (i = 0; i < keys.length; i++) {
    if (keys[i].indexOf('allaxes') === 0) {
      for (j = 0; j < axes.length; j++) {
        var scene = axes[j]._id.substr(1);
        var axisAttr = scene.indexOf('scene') !== -1 ? scene + '.' : '';
        var newkey = keys[i].replace('allaxes', axisAttr + axes[j]._name);
        if (!aobj[newkey]) aobj[newkey] = aobj[keys[i]];
      }
      delete aobj[keys[i]];
    }
  }

  // initialize flags
  var flags = editTypes.layoutFlags();

  // copies of the change (and previous values of anything affected)
  // for the undo / redo queue
  var redoit = {};
  var undoit = {};

  // for attrs that interact (like scales & autoscales), save the
  // old vals before making the change
  // val=undefined will not set a value, just record what the value was.
  // attr can be an array to set several at once (all to the same val)
  function doextra(attr, val) {
    if (Array.isArray(attr)) {
      attr.forEach(function (a) {
        doextra(a, val);
      });
      return;
    }

    // if we have another value for this attribute (explicitly or
    // via a parent) do not override with this auto-generated extra
    if (attr in aobj || helpers.hasParent(aobj, attr)) return;
    var p = layoutNP(layout, attr);
    if (!(attr in undoit)) {
      undoit[attr] = undefinedToNull(p.get());
    }
    if (val !== undefined) p.set(val);
  }

  // for constraint enforcement: keep track of all axes (as {id: name})
  // we're editing the (auto)range of, so we can tell the others constrained
  // to scale with them that it's OK for them to shrink
  var rangesAltered = {};
  var ax;
  function recordAlteredAxis(pleafPlus) {
    var axId = Axes.name2id(pleafPlus.split('.')[0]);
    rangesAltered[axId] = 1;
    return axId;
  }

  // alter gd.layout
  for (var ai in aobj) {
    if (helpers.hasParent(aobj, ai)) {
      throw new Error('cannot set ' + ai + ' and a parent attribute simultaneously');
    }
    var p = layoutNP(layout, ai);
    var vi = aobj[ai];
    var plen = p.parts.length;
    // p.parts may end with an index integer if the property is an array
    var pend = plen - 1;
    while (pend > 0 && typeof p.parts[pend] !== 'string') pend--;
    // last property in chain (leaf node)
    var pleaf = p.parts[pend];
    // leaf plus immediate parent
    var pleafPlus = p.parts[pend - 1] + '.' + pleaf;
    // trunk nodes (everything except the leaf)
    var ptrunk = p.parts.slice(0, pend).join('.');
    var parentIn = nestedProperty(gd.layout, ptrunk).get();
    var parentFull = nestedProperty(fullLayout, ptrunk).get();
    var vOld = p.get();
    if (vi === undefined) continue;
    redoit[ai] = vi;

    // axis reverse is special - it is its own inverse
    // op and has no flag.
    undoit[ai] = pleaf === 'reverse' ? vi : undefinedToNull(vOld);
    var valObject = PlotSchema.getLayoutValObject(fullLayout, p.parts);
    if (valObject && valObject.impliedEdits && vi !== null) {
      for (var impliedKey in valObject.impliedEdits) {
        doextra(Lib.relativeAttr(ai, impliedKey), valObject.impliedEdits[impliedKey]);
      }
    }

    // Setting width or height to null must reset the graph's width / height
    // back to its initial value as computed during the first pass in Plots.plotAutoSize.
    //
    // To do so, we must manually set them back here using the _initialAutoSize cache.
    // can't use impliedEdits for this because behavior depends on vi
    if (['width', 'height'].indexOf(ai) !== -1) {
      if (vi) {
        doextra('autosize', null);
        // currently we don't support autosize one dim only - so
        // explicitly set the other one. Note that doextra will
        // ignore this if the same relayout call also provides oppositeAttr
        var oppositeAttr = ai === 'height' ? 'width' : 'height';
        doextra(oppositeAttr, fullLayout[oppositeAttr]);
      } else {
        fullLayout[ai] = gd._initialAutoSize[ai];
      }
    } else if (ai === 'autosize') {
      // depends on vi here too, so again can't use impliedEdits
      doextra('width', vi ? null : fullLayout.width);
      doextra('height', vi ? null : fullLayout.height);
    } else if (pleafPlus.match(AX_RANGE_RE)) {
      // check autorange vs range

      recordAlteredAxis(pleafPlus);
      nestedProperty(fullLayout, ptrunk + '._inputRange').set(null);
    } else if (pleafPlus.match(AX_AUTORANGE_RE)) {
      recordAlteredAxis(pleafPlus);
      nestedProperty(fullLayout, ptrunk + '._inputRange').set(null);
      var axFull = nestedProperty(fullLayout, ptrunk).get();
      if (axFull._inputDomain) {
        // if we're autoranging and this axis has a constrained domain,
        // reset it so we don't get locked into a shrunken size
        axFull._input.domain = axFull._inputDomain.slice();
      }
    } else if (pleafPlus.match(AX_DOMAIN_RE)) {
      nestedProperty(fullLayout, ptrunk + '._inputDomain').set(null);
    }

    // toggling axis type between log and linear: we need to convert
    // positions for components that are still using linearized values,
    // not data values like newer components.
    // previously we did this for log <-> not-log, but now only do it
    // for log <-> linear
    if (pleaf === 'type') {
      ax = parentIn;
      var toLog = parentFull.type === 'linear' && vi === 'log';
      var fromLog = parentFull.type === 'log' && vi === 'linear';
      if (toLog || fromLog) {
        if (!ax || !ax.range) {
          // 2D never gets here, but 3D does
          // I don't think this is needed, but left here in case there
          // are edge cases I'm not thinking of.
          doextra(ptrunk + '.autorange', true);
        } else if (!parentFull.autorange) {
          // toggling log without autorange: need to also recalculate ranges
          // because log axes use linearized values for range endpoints
          var r0 = ax.range[0];
          var r1 = ax.range[1];
          if (toLog) {
            // if both limits are negative, autorange
            if (r0 <= 0 && r1 <= 0) {
              doextra(ptrunk + '.autorange', true);
            }
            // if one is negative, set it 6 orders below the other.
            if (r0 <= 0) r0 = r1 / 1e6;else if (r1 <= 0) r1 = r0 / 1e6;
            // now set the range values as appropriate
            doextra(ptrunk + '.range[0]', Math.log(r0) / Math.LN10);
            doextra(ptrunk + '.range[1]', Math.log(r1) / Math.LN10);
          } else {
            doextra(ptrunk + '.range[0]', Math.pow(10, r0));
            doextra(ptrunk + '.range[1]', Math.pow(10, r1));
          }
        } else if (toLog) {
          // just make sure the range is positive and in the right
          // order, it'll get recalculated later
          ax.range = ax.range[1] > ax.range[0] ? [1, 2] : [2, 1];
        }

        // clear polar view initial stash for radial range so that
        // value get recomputed in correct units
        if (Array.isArray(fullLayout._subplots.polar) && fullLayout._subplots.polar.length && fullLayout[p.parts[0]] && p.parts[1] === 'radialaxis') {
          delete fullLayout[p.parts[0]]._subplot.viewInitial['radialaxis.range'];
        }

        // Annotations and images also need to convert to/from linearized coords
        // Shapes do not need this :)
        Registry.getComponentMethod('annotations', 'convertCoords')(gd, parentFull, vi, doextra);
        Registry.getComponentMethod('images', 'convertCoords')(gd, parentFull, vi, doextra);
      } else {
        // any other type changes: the range from the previous type
        // will not make sense, so autorange it.
        doextra(ptrunk + '.autorange', true);
        doextra(ptrunk + '.range', null);
      }
      nestedProperty(fullLayout, ptrunk + '._inputRange').set(null);
    } else if (pleaf.match(AX_NAME_PATTERN)) {
      var fullProp = nestedProperty(fullLayout, ai).get();
      var newType = (vi || {}).type;

      // This can potentially cause strange behavior if the autotype is not
      // numeric (linear, because we don't auto-log) but the previous type
      // was log. That's a very strange edge case though
      if (!newType || newType === '-') newType = 'linear';
      Registry.getComponentMethod('annotations', 'convertCoords')(gd, fullProp, newType, doextra);
      Registry.getComponentMethod('images', 'convertCoords')(gd, fullProp, newType, doextra);
    }

    // alter gd.layout

    // collect array component edits for execution all together
    // so we can ensure consistent behavior adding/removing items
    // and order-independence for add/remove/edit all together in
    // one relayout call
    var containerArrayMatch = manageArrays.containerArrayMatch(ai);
    if (containerArrayMatch) {
      arrayStr = containerArrayMatch.array;
      i = containerArrayMatch.index;
      var propStr = containerArrayMatch.property;
      var updateValObject = valObject || {
        editType: 'calc'
      };
      if (i !== '' && propStr === '') {
        // special handling of undoit if we're adding or removing an element
        // ie 'annotations[2]' which can be {...} (add) or null,
        // does not work when replacing the entire array
        if (manageArrays.isAddVal(vi)) {
          undoit[ai] = null;
        } else if (manageArrays.isRemoveVal(vi)) {
          undoit[ai] = (nestedProperty(layout, arrayStr).get() || [])[i];
        } else {
          Lib.warn('unrecognized full object value', aobj);
        }
      }
      editTypes.update(flags, updateValObject);

      // prepare the edits object we'll send to applyContainerArrayChanges
      if (!arrayEdits[arrayStr]) arrayEdits[arrayStr] = {};
      var objEdits = arrayEdits[arrayStr][i];
      if (!objEdits) objEdits = arrayEdits[arrayStr][i] = {};
      objEdits[propStr] = vi;
      delete aobj[ai];
    } else if (pleaf === 'reverse') {
      // handle axis reversal explicitly, as there's no 'reverse' attribute

      if (parentIn.range) parentIn.range.reverse();else {
        doextra(ptrunk + '.autorange', true);
        parentIn.range = [1, 0];
      }
      if (parentFull.autorange) flags.calc = true;else flags.plot = true;
    } else {
      if (ai === 'dragmode' && (vi === false && vOld !== false || vi !== false && vOld === false)) {
        flags.plot = true;
      } else if (fullLayout._has('scatter-like') && fullLayout._has('regl') && ai === 'dragmode' && (vi === 'lasso' || vi === 'select') && !(vOld === 'lasso' || vOld === 'select')) {
        flags.plot = true;
      } else if (fullLayout._has('gl2d')) {
        flags.plot = true;
      } else if (valObject) editTypes.update(flags, valObject);else flags.calc = true;
      p.set(vi);
    }
  }

  // now we've collected component edits - execute them all together
  for (arrayStr in arrayEdits) {
    var finished = manageArrays.applyContainerArrayChanges(gd, layoutNP(layout, arrayStr), arrayEdits[arrayStr], flags, layoutNP);
    if (!finished) flags.plot = true;
  }

  // figure out if we need to recalculate axis constraints
  for (var axId in rangesAltered) {
    ax = Axes.getFromId(gd, axId);
    var group = ax && ax._constraintGroup;
    if (group) {
      // Always recalc if we're changing constrained ranges.
      // Otherwise it's possible to violate the constraints by
      // specifying arbitrary ranges for all axes in the group.
      // this way some ranges may expand beyond what's specified,
      // as they do at first draw, to satisfy the constraints.
      flags.calc = true;
      for (var groupAxId in group) {
        if (!rangesAltered[groupAxId]) {
          Axes.getFromId(gd, groupAxId)._constraintShrinkable = true;
        }
      }
    }
  }

  // If the autosize changed or height or width was explicitly specified,
  // this triggers a redraw
  // TODO: do we really need special aobj.height/width handling here?
  // couldn't editType do this?
  if (updateAutosize(gd) || aobj.height || aobj.width) flags.plot = true;

  // update shape legends
  var shapes = fullLayout.shapes;
  for (i = 0; i < shapes.length; i++) {
    if (shapes[i].showlegend) {
      flags.calc = true;
      break;
    }
  }
  if (flags.plot || flags.calc) {
    flags.layoutReplot = true;
  }

  // now all attribute mods are done, as are
  // redo and undo so we can save them

  return {
    flags: flags,
    rangesAltered: rangesAltered,
    undoit: undoit,
    redoit: redoit,
    eventData: eventData
  };
}

/*
 * updateAutosize: we made a change, does it change the autosize result?
 * puts the new size into fullLayout
 * returns true if either height or width changed
 */
function updateAutosize(gd) {
  var fullLayout = gd._fullLayout;
  var oldWidth = fullLayout.width;
  var oldHeight = fullLayout.height;

  // calculate autosizing
  if (gd.layout.autosize) Plots.plotAutoSize(gd, gd.layout, fullLayout);
  return fullLayout.width !== oldWidth || fullLayout.height !== oldHeight;
}

/**
 * update: update trace and layout attributes of an existing plot
 *
 * @param {String | HTMLDivElement} gd
 *  the id or DOM element of the graph container div
 * @param {Object} traceUpdate
 *  attribute object `{astr1: val1, astr2: val2 ...}`
 *  corresponding to updates in the plot's traces
 * @param {Object} layoutUpdate
 *  attribute object `{astr1: val1, astr2: val2 ...}`
 *  corresponding to updates in the plot's layout
 * @param {Number[] | Number} [traces]
 *  integer or array of integers for the traces to alter (all if omitted)
 *
 */
function update(gd, traceUpdate, layoutUpdate, _traces) {
  gd = Lib.getGraphDiv(gd);
  helpers.clearPromiseQueue(gd);
  if (!Lib.isPlainObject(traceUpdate)) traceUpdate = {};
  if (!Lib.isPlainObject(layoutUpdate)) layoutUpdate = {};
  if (Object.keys(traceUpdate).length) gd.changed = true;
  if (Object.keys(layoutUpdate).length) gd.changed = true;
  var traces = helpers.coerceTraceIndices(gd, _traces);
  var restyleSpecs = _restyle(gd, Lib.extendFlat({}, traceUpdate), traces);
  var restyleFlags = restyleSpecs.flags;
  var relayoutSpecs = _relayout(gd, Lib.extendFlat({}, layoutUpdate));
  var relayoutFlags = relayoutSpecs.flags;

  // clear calcdata and/or axis types if required
  if (restyleFlags.calc || relayoutFlags.calc) gd.calcdata = undefined;
  if (restyleFlags.clearAxisTypes) helpers.clearAxisTypes(gd, traces, layoutUpdate);

  // fill in redraw sequence
  var seq = [];
  if (relayoutFlags.layoutReplot) {
    // N.B. works fine when both
    // relayoutFlags.layoutReplot and restyleFlags.fullReplot are true
    seq.push(subroutines.layoutReplot);
  } else if (restyleFlags.fullReplot) {
    seq.push(exports._doPlot);
  } else {
    seq.push(Plots.previousPromises);
    axRangeSupplyDefaultsByPass(gd, relayoutFlags, relayoutSpecs) || Plots.supplyDefaults(gd);
    if (restyleFlags.style) seq.push(subroutines.doTraceStyle);
    if (restyleFlags.colorbars || relayoutFlags.colorbars) seq.push(subroutines.doColorBars);
    if (relayoutFlags.legend) seq.push(subroutines.doLegend);
    if (relayoutFlags.layoutstyle) seq.push(subroutines.layoutStyles);
    if (relayoutFlags.axrange) addAxRangeSequence(seq, relayoutSpecs.rangesAltered);
    if (relayoutFlags.ticks) seq.push(subroutines.doTicksRelayout);
    if (relayoutFlags.modebar) seq.push(subroutines.doModeBar);
    if (relayoutFlags.camera) seq.push(subroutines.doCamera);
    seq.push(emitAfterPlot);
  }
  seq.push(Plots.rehover, Plots.redrag, Plots.reselect);
  Queue.add(gd, update, [gd, restyleSpecs.undoit, relayoutSpecs.undoit, restyleSpecs.traces], update, [gd, restyleSpecs.redoit, relayoutSpecs.redoit, restyleSpecs.traces]);
  var plotDone = Lib.syncOrAsync(seq, gd);
  if (!plotDone || !plotDone.then) plotDone = Promise.resolve(gd);
  return plotDone.then(function () {
    gd.emit('plotly_update', {
      data: restyleSpecs.eventData,
      layout: relayoutSpecs.eventData
    });
    return gd;
  });
}

/*
 * internal-use-only restyle/relayout/update variants that record the initial
 * values in (fullLayout|fullTrace)._preGUI so changes can be persisted across
 * Plotly.react data updates, dependent on uirevision attributes
 */
function guiEdit(func) {
  return function wrappedEdit(gd) {
    gd._fullLayout._guiEditing = true;
    var p = func.apply(null, arguments);
    gd._fullLayout._guiEditing = false;
    return p;
  };
}

// For connecting edited layout attributes to uirevision attrs
// If no `attr` we use `match[1] + '.uirevision'`
// Ordered by most common edits first, to minimize our search time
var layoutUIControlPatterns = [{
  pattern: /^hiddenlabels/,
  attr: 'legend.uirevision'
}, {
  pattern: /^((x|y)axis\d*)\.((auto)?range|title\.text)/
},
// showspikes and modes include those nested inside scenes
{
  pattern: /axis\d*\.showspikes$/,
  attr: 'modebar.uirevision'
}, {
  pattern: /(hover|drag)mode$/,
  attr: 'modebar.uirevision'
}, {
  pattern: /^(scene\d*)\.camera/
}, {
  pattern: /^(geo\d*)\.(projection|center|fitbounds)/
}, {
  pattern: /^(ternary\d*\.[abc]axis)\.(min|title\.text)$/
}, {
  pattern: /^(polar\d*\.radialaxis)\.((auto)?range|angle|title\.text)/
}, {
  pattern: /^(polar\d*\.angularaxis)\.rotation/
}, {
  pattern: /^(mapbox\d*)\.(center|zoom|bearing|pitch)/
}, {
  pattern: /^(map\d*)\.(center|zoom|bearing|pitch)/
}, {
  pattern: /^legend\.(x|y)$/,
  attr: 'editrevision'
}, {
  pattern: /^(shapes|annotations)/,
  attr: 'editrevision'
}, {
  pattern: /^title\.text$/,
  attr: 'editrevision'
}];

// same for trace attributes: if `attr` is given it's in layout,
// or with no `attr` we use `trace.uirevision`
var traceUIControlPatterns = [{
  pattern: /^selectedpoints$/,
  attr: 'selectionrevision'
},
// "visible" includes trace.transforms[i].styles[j].value.visible
{
  pattern: /(^|value\.)visible$/,
  attr: 'legend.uirevision'
}, {
  pattern: /^dimensions\[\d+\]\.constraintrange/
}, {
  pattern: /^node\.(x|y|groups)/
},
// for Sankey nodes
{
  pattern: /^level$/
},
// for Sunburst, Treemap and Icicle traces

// below this you must be in editable: true mode
// TODO: I still put name and title with `trace.uirevision`
// reasonable or should these be `editrevision`?
// Also applies to axis titles up in the layout section

// "name" also includes transform.styles
{
  pattern: /(^|value\.)name$/
},
// including nested colorbar attributes (ie marker.colorbar)
{
  pattern: /colorbar\.title\.text$/
}, {
  pattern: /colorbar\.(x|y)$/,
  attr: 'editrevision'
}];
function findUIPattern(key, patternSpecs) {
  for (var i = 0; i < patternSpecs.length; i++) {
    var spec = patternSpecs[i];
    var match = key.match(spec.pattern);
    if (match) {
      var head = match[1] || '';
      return {
        head: head,
        tail: key.substr(head.length + 1),
        attr: spec.attr
      };
    }
  }
}

// We're finding the new uirevision before supplyDefaults, so do the
// inheritance manually. Note that only `undefined` inherits - other
// falsy values are returned.
function getNewRev(revAttr, container) {
  var newRev = nestedProperty(container, revAttr).get();
  if (newRev !== undefined) return newRev;
  var parts = revAttr.split('.');
  parts.pop();
  while (parts.length > 1) {
    parts.pop();
    newRev = nestedProperty(container, parts.join('.') + '.uirevision').get();
    if (newRev !== undefined) return newRev;
  }
  return container.uirevision;
}
function getFullTraceIndexFromUid(uid, fullData) {
  for (var i = 0; i < fullData.length; i++) {
    if (fullData[i]._fullInput.uid === uid) return i;
  }
  return -1;
}
function getTraceIndexFromUid(uid, data, tracei) {
  for (var i = 0; i < data.length; i++) {
    if (data[i].uid === uid) return i;
  }
  // fall back on trace order, but only if user didn't provide a uid for that trace
  return !data[tracei] || data[tracei].uid ? -1 : tracei;
}
function valsMatch(v1, v2) {
  var v1IsObj = Lib.isPlainObject(v1);
  var v1IsArray = Array.isArray(v1);
  if (v1IsObj || v1IsArray) {
    return (v1IsObj && Lib.isPlainObject(v2) || v1IsArray && Array.isArray(v2)) && JSON.stringify(v1) === JSON.stringify(v2);
  }
  return v1 === v2;
}
function applyUIRevisions(data, layout, oldFullData, oldFullLayout) {
  var layoutPreGUI = oldFullLayout._preGUI;
  var key, revAttr, oldRev, newRev, match, preGUIVal, newNP, newVal, head, tail;
  var bothInheritAutorange = [];
  var newAutorangeIn = {};
  var newRangeAccepted = {};
  for (key in layoutPreGUI) {
    match = findUIPattern(key, layoutUIControlPatterns);
    if (match) {
      head = match.head;
      tail = match.tail;
      revAttr = match.attr || head + '.uirevision';
      oldRev = nestedProperty(oldFullLayout, revAttr).get();
      newRev = oldRev && getNewRev(revAttr, layout);
      if (newRev && newRev === oldRev) {
        preGUIVal = layoutPreGUI[key];
        if (preGUIVal === null) preGUIVal = undefined;
        newNP = nestedProperty(layout, key);
        newVal = newNP.get();
        if (valsMatch(newVal, preGUIVal)) {
          if (newVal === undefined && tail === 'autorange') {
            bothInheritAutorange.push(head);
          }
          newNP.set(undefinedToNull(nestedProperty(oldFullLayout, key).get()));
          continue;
        } else if (tail === 'autorange' || tail.substr(0, 6) === 'range[') {
          // Special case for (auto)range since we push it back into the layout
          // so all null should be treated equivalently to autorange: true with any range
          var pre0 = layoutPreGUI[head + '.range[0]'];
          var pre1 = layoutPreGUI[head + '.range[1]'];
          var preAuto = layoutPreGUI[head + '.autorange'];
          if (preAuto || preAuto === null && pre0 === null && pre1 === null) {
            // Only read the input layout once and stash the result,
            // so we get it before we start modifying it
            if (!(head in newAutorangeIn)) {
              var newContainer = nestedProperty(layout, head).get();
              newAutorangeIn[head] = newContainer && (newContainer.autorange || newContainer.autorange !== false && (!newContainer.range || newContainer.range.length !== 2));
            }
            if (newAutorangeIn[head]) {
              newNP.set(undefinedToNull(nestedProperty(oldFullLayout, key).get()));
              continue;
            }
          }
        }
      }
    } else {
      Lib.warn('unrecognized GUI edit: ' + key);
    }
    // if we got this far, the new value was accepted as the new starting
    // point (either because it changed or revision changed)
    // so remove it from _preGUI for next time.
    delete layoutPreGUI[key];
    if (match && match.tail.substr(0, 6) === 'range[') {
      newRangeAccepted[match.head] = 1;
    }
  }

  // More special logic for `autorange`, since it interacts with `range`:
  // If the new figure's matching `range` was kept, and `autorange`
  // wasn't supplied explicitly in either the original or the new figure,
  // we shouldn't alter that - but we may just have done that, so fix it.
  for (var i = 0; i < bothInheritAutorange.length; i++) {
    var axAttr = bothInheritAutorange[i];
    if (newRangeAccepted[axAttr]) {
      var newAx = nestedProperty(layout, axAttr).get();
      if (newAx) delete newAx.autorange;
    }
  }

  // Now traces - try to match them up by uid (in case we added/deleted in
  // the middle), then fall back on index.
  var allTracePreGUI = oldFullLayout._tracePreGUI;
  for (var uid in allTracePreGUI) {
    var tracePreGUI = allTracePreGUI[uid];
    var newTrace = null;
    var fullInput;
    for (key in tracePreGUI) {
      // wait until we know we have preGUI values to look for traces
      // but if we don't find both, stop looking at this uid
      if (!newTrace) {
        var fulli = getFullTraceIndexFromUid(uid, oldFullData);
        if (fulli < 0) {
          // Somehow we didn't even have this trace in oldFullData...
          // I guess this could happen with `deleteTraces` or something
          delete allTracePreGUI[uid];
          break;
        }
        var fullTrace = oldFullData[fulli];
        fullInput = fullTrace._fullInput;
        var newTracei = getTraceIndexFromUid(uid, data, fullInput.index);
        if (newTracei < 0) {
          // No match in new data
          delete allTracePreGUI[uid];
          break;
        }
        newTrace = data[newTracei];
      }
      match = findUIPattern(key, traceUIControlPatterns);
      if (match) {
        if (match.attr) {
          oldRev = nestedProperty(oldFullLayout, match.attr).get();
          newRev = oldRev && getNewRev(match.attr, layout);
        } else {
          oldRev = fullInput.uirevision;
          // inheritance for trace.uirevision is simple, just layout.uirevision
          newRev = newTrace.uirevision;
          if (newRev === undefined) newRev = layout.uirevision;
        }
        if (newRev && newRev === oldRev) {
          preGUIVal = tracePreGUI[key];
          if (preGUIVal === null) preGUIVal = undefined;
          newNP = nestedProperty(newTrace, key);
          newVal = newNP.get();
          if (valsMatch(newVal, preGUIVal)) {
            newNP.set(undefinedToNull(nestedProperty(fullInput, key).get()));
            continue;
          }
        }
      } else {
        Lib.warn('unrecognized GUI edit: ' + key + ' in trace uid ' + uid);
      }
      delete tracePreGUI[key];
    }
  }
}

/**
 * Plotly.react:
 * A plot/update method that takes the full plot state (same API as plot/newPlot)
 * and diffs to determine the minimal update pathway
 *
 * @param {string id or DOM element} gd
 *      the id or DOM element of the graph container div
 * @param {array of objects} data
 *      array of traces, containing the data and display information for each trace
 * @param {object} layout
 *      object describing the overall display of the plot,
 *      all the stuff that doesn't pertain to any individual trace
 * @param {object} config
 *      configuration options (see ./plot_config.js for more info)
 *
 * OR
 *
 * @param {string id or DOM element} gd
 *      the id or DOM element of the graph container div
 * @param {object} figure
 *      object containing `data`, `layout`, `config`, and `frames` members
 *
 */
function react(gd, data, layout, config) {
  var frames, plotDone;
  function addFrames() {
    return exports.addFrames(gd, frames);
  }
  gd = Lib.getGraphDiv(gd);
  helpers.clearPromiseQueue(gd);
  var oldFullData = gd._fullData;
  var oldFullLayout = gd._fullLayout;

  // you can use this as the initial draw as well as to update
  if (!Lib.isPlotDiv(gd) || !oldFullData || !oldFullLayout) {
    plotDone = exports.newPlot(gd, data, layout, config);
  } else {
    if (Lib.isPlainObject(data)) {
      var obj = data;
      data = obj.data;
      layout = obj.layout;
      config = obj.config;
      frames = obj.frames;
    }
    var configChanged = false;
    // assume that if there's a config at all, we're reacting to it too,
    // and completely replace the previous config
    if (config) {
      var oldConfig = Lib.extendDeep({}, gd._context);
      gd._context = undefined;
      setPlotContext(gd, config);
      configChanged = diffConfig(oldConfig, gd._context);
    }
    gd.data = data || [];
    helpers.cleanData(gd.data);
    gd.layout = layout || {};
    helpers.cleanLayout(gd.layout);
    applyUIRevisions(gd.data, gd.layout, oldFullData, oldFullLayout);

    // "true" skips updating calcdata and remapping arrays from calcTransforms,
    // which supplyDefaults usually does at the end, but we may need to NOT do
    // if the diff (which we haven't determined yet) says we'll recalc
    Plots.supplyDefaults(gd, {
      skipUpdateCalc: true
    });
    var newFullData = gd._fullData;
    var newFullLayout = gd._fullLayout;
    var immutable = newFullLayout.datarevision === undefined;
    var transition = newFullLayout.transition;
    var relayoutFlags = diffLayout(gd, oldFullLayout, newFullLayout, immutable, transition);
    var newDataRevision = relayoutFlags.newDataRevision;
    var restyleFlags = diffData(gd, oldFullData, newFullData, immutable, transition, newDataRevision);

    // TODO: how to translate this part of relayout to Plotly.react?
    // // Setting width or height to null must reset the graph's width / height
    // // back to its initial value as computed during the first pass in Plots.plotAutoSize.
    // //
    // // To do so, we must manually set them back here using the _initialAutoSize cache.
    // if(['width', 'height'].indexOf(ai) !== -1 && vi === null) {
    //     fullLayout[ai] = gd._initialAutoSize[ai];
    // }

    if (updateAutosize(gd)) relayoutFlags.layoutReplot = true;

    // clear calcdata and empty categories if required
    if (restyleFlags.calc || relayoutFlags.calc) {
      gd.calcdata = undefined;
      var allNames = Object.getOwnPropertyNames(newFullLayout);
      for (var q = 0; q < allNames.length; q++) {
        var name = allNames[q];
        var start = name.substring(0, 5);
        if (start === 'xaxis' || start === 'yaxis') {
          var emptyCategories = newFullLayout[name]._emptyCategories;
          if (emptyCategories) emptyCategories();
        }
      }
      // otherwise do the calcdata updates and calcTransform array remaps that we skipped earlier
    } else {
      Plots.supplyDefaultsUpdateCalc(gd.calcdata, newFullData);
    }

    // Note: what restyle/relayout use impliedEdits and clearAxisTypes for
    // must be handled by the user when using Plotly.react.

    // fill in redraw sequence
    var seq = [];
    if (frames) {
      gd._transitionData = {};
      Plots.createTransitionData(gd);
      seq.push(addFrames);
    }

    // Transition pathway,
    // only used when 'transition' is set by user and
    // when at least one animatable attribute has changed,
    // N.B. config changed aren't animatable
    if (newFullLayout.transition && !configChanged && (restyleFlags.anim || relayoutFlags.anim)) {
      if (relayoutFlags.ticks) seq.push(subroutines.doTicksRelayout);
      Plots.doCalcdata(gd);
      subroutines.doAutoRangeAndConstraints(gd);
      seq.push(function () {
        return Plots.transitionFromReact(gd, restyleFlags, relayoutFlags, oldFullLayout);
      });
    } else if (restyleFlags.fullReplot || relayoutFlags.layoutReplot || configChanged) {
      gd._fullLayout._skipDefaults = true;
      seq.push(exports._doPlot);
    } else {
      for (var componentType in relayoutFlags.arrays) {
        var indices = relayoutFlags.arrays[componentType];
        if (indices.length) {
          var drawOne = Registry.getComponentMethod(componentType, 'drawOne');
          if (drawOne !== Lib.noop) {
            for (var i = 0; i < indices.length; i++) {
              drawOne(gd, indices[i]);
            }
          } else {
            var draw = Registry.getComponentMethod(componentType, 'draw');
            if (draw === Lib.noop) {
              throw new Error('cannot draw components: ' + componentType);
            }
            draw(gd);
          }
        }
      }
      seq.push(Plots.previousPromises);
      if (restyleFlags.style) seq.push(subroutines.doTraceStyle);
      if (restyleFlags.colorbars || relayoutFlags.colorbars) seq.push(subroutines.doColorBars);
      if (relayoutFlags.legend) seq.push(subroutines.doLegend);
      if (relayoutFlags.layoutstyle) seq.push(subroutines.layoutStyles);
      if (relayoutFlags.axrange) addAxRangeSequence(seq);
      if (relayoutFlags.ticks) seq.push(subroutines.doTicksRelayout);
      if (relayoutFlags.modebar) seq.push(subroutines.doModeBar);
      if (relayoutFlags.camera) seq.push(subroutines.doCamera);
      seq.push(emitAfterPlot);
    }
    seq.push(Plots.rehover, Plots.redrag, Plots.reselect);
    plotDone = Lib.syncOrAsync(seq, gd);
    if (!plotDone || !plotDone.then) plotDone = Promise.resolve(gd);
  }
  return plotDone.then(function () {
    gd.emit('plotly_react', {
      data: data,
      layout: layout
    });
    return gd;
  });
}
function diffData(gd, oldFullData, newFullData, immutable, transition, newDataRevision) {
  var sameTraceLength = oldFullData.length === newFullData.length;
  if (!transition && !sameTraceLength) {
    return {
      fullReplot: true,
      calc: true
    };
  }
  var flags = editTypes.traceFlags();
  flags.arrays = {};
  flags.nChanges = 0;
  flags.nChangesAnim = 0;
  var i, trace;
  function getTraceValObject(parts) {
    var out = PlotSchema.getTraceValObject(trace, parts);
    if (!trace._module.animatable && out.anim) {
      out.anim = false;
    }
    return out;
  }
  var diffOpts = {
    getValObject: getTraceValObject,
    flags: flags,
    immutable: immutable,
    transition: transition,
    newDataRevision: newDataRevision,
    gd: gd
  };
  var seenUIDs = {};
  for (i = 0; i < oldFullData.length; i++) {
    if (newFullData[i]) {
      trace = newFullData[i]._fullInput;
      if (Plots.hasMakesDataTransform(trace)) trace = newFullData[i];
      if (seenUIDs[trace.uid]) continue;
      seenUIDs[trace.uid] = 1;
      getDiffFlags(oldFullData[i]._fullInput, trace, [], diffOpts);
    }
  }
  if (flags.calc || flags.plot) {
    flags.fullReplot = true;
  }
  if (transition && flags.nChanges && flags.nChangesAnim) {
    flags.anim = flags.nChanges === flags.nChangesAnim && sameTraceLength ? 'all' : 'some';
  }
  return flags;
}
function diffLayout(gd, oldFullLayout, newFullLayout, immutable, transition) {
  var flags = editTypes.layoutFlags();
  flags.arrays = {};
  flags.rangesAltered = {};
  flags.nChanges = 0;
  flags.nChangesAnim = 0;
  function getLayoutValObject(parts) {
    return PlotSchema.getLayoutValObject(newFullLayout, parts);
  }
  var diffOpts = {
    getValObject: getLayoutValObject,
    flags: flags,
    immutable: immutable,
    transition: transition,
    gd: gd
  };
  getDiffFlags(oldFullLayout, newFullLayout, [], diffOpts);
  if (flags.plot || flags.calc) {
    flags.layoutReplot = true;
  }
  if (transition && flags.nChanges && flags.nChangesAnim) {
    flags.anim = flags.nChanges === flags.nChangesAnim ? 'all' : 'some';
  }
  return flags;
}
function getDiffFlags(oldContainer, newContainer, outerparts, opts) {
  var valObject, key, astr;
  var getValObject = opts.getValObject;
  var flags = opts.flags;
  var immutable = opts.immutable;
  var inArray = opts.inArray;
  var arrayIndex = opts.arrayIndex;
  function changed() {
    var editType = valObject.editType;
    if (inArray && editType.indexOf('arraydraw') !== -1) {
      Lib.pushUnique(flags.arrays[inArray], arrayIndex);
      return;
    }
    editTypes.update(flags, valObject);
    if (editType !== 'none') {
      flags.nChanges++;
    }

    // track animatable changes
    if (opts.transition && valObject.anim) {
      flags.nChangesAnim++;
    }

    // track cartesian axes with altered ranges
    if (AX_RANGE_RE.test(astr) || AX_AUTORANGE_RE.test(astr)) {
      flags.rangesAltered[outerparts[0]] = 1;
    }

    // clear _inputDomain on cartesian axes with altered domains
    if (AX_DOMAIN_RE.test(astr)) {
      nestedProperty(newContainer, '_inputDomain').set(null);
    }

    // track datarevision changes
    if (key === 'datarevision') {
      flags.newDataRevision = 1;
    }
  }
  function valObjectCanBeDataArray(valObject) {
    return valObject.valType === 'data_array' || valObject.arrayOk;
  }
  for (key in oldContainer) {
    // short-circuit based on previous calls or previous keys that already maximized the pathway
    if (flags.calc && !opts.transition) return;
    var oldVal = oldContainer[key];
    var newVal = newContainer[key];
    var parts = outerparts.concat(key);
    astr = parts.join('.');
    if (key.charAt(0) === '_' || typeof oldVal === 'function' || oldVal === newVal) continue;

    // FIXME: ax.tick0 and dtick get filled in during plotting (except for geo subplots),
    // and unlike other auto values they don't make it back into the input,
    // so newContainer won't have them.
    if ((key === 'tick0' || key === 'dtick') && outerparts[0] !== 'geo') {
      var tickMode = newContainer.tickmode;
      if (tickMode === 'auto' || tickMode === 'array' || !tickMode) continue;
    }
    // FIXME: Similarly for axis ranges for 3D
    // contourcarpet doesn't HAVE zmin/zmax, they're just auto-added. It needs them.
    if (key === 'range' && newContainer.autorange) continue;
    if ((key === 'zmin' || key === 'zmax') && newContainer.type === 'contourcarpet') continue;
    valObject = getValObject(parts);

    // in case type changed, we may not even *have* a valObject.
    if (!valObject) continue;
    if (valObject._compareAsJSON && JSON.stringify(oldVal) === JSON.stringify(newVal)) continue;
    var valType = valObject.valType;
    var i;
    var canBeDataArray = valObjectCanBeDataArray(valObject);
    var wasArray = Array.isArray(oldVal);
    var nowArray = Array.isArray(newVal);

    // hack for traces that modify the data in supplyDefaults, like
    // converting 1D to 2D arrays, which will always create new objects
    if (wasArray && nowArray) {
      var inputKey = '_input_' + key;
      var oldValIn = oldContainer[inputKey];
      var newValIn = newContainer[inputKey];
      if (Array.isArray(oldValIn) && oldValIn === newValIn) continue;
    }
    if (newVal === undefined) {
      if (canBeDataArray && wasArray) flags.calc = true;else changed();
    } else if (valObject._isLinkedToArray) {
      var arrayEditIndices = [];
      var extraIndices = false;
      if (!inArray) flags.arrays[key] = arrayEditIndices;
      var minLen = Math.min(oldVal.length, newVal.length);
      var maxLen = Math.max(oldVal.length, newVal.length);
      if (minLen !== maxLen) {
        if (valObject.editType === 'arraydraw') {
          extraIndices = true;
        } else {
          changed();
          continue;
        }
      }
      for (i = 0; i < minLen; i++) {
        getDiffFlags(oldVal[i], newVal[i], parts.concat(i),
        // add array indices, but not if we're already in an array
        Lib.extendFlat({
          inArray: key,
          arrayIndex: i
        }, opts));
      }

      // put this at the end so that we know our collected array indices are sorted
      // but the check for length changes happens up front so we can short-circuit
      // diffing if appropriate
      if (extraIndices) {
        for (i = minLen; i < maxLen; i++) {
          arrayEditIndices.push(i);
        }
      }
    } else if (!valType && Lib.isPlainObject(oldVal)) {
      getDiffFlags(oldVal, newVal, parts, opts);
    } else if (canBeDataArray) {
      if (wasArray && nowArray) {
        // don't try to diff two data arrays. If immutable we know the data changed,
        // if not, assume it didn't and let `layout.datarevision` tell us if it did
        if (immutable) {
          flags.calc = true;
        }

        // look for animatable attributes when the data changed
        if (immutable || opts.newDataRevision) {
          changed();
        }
      } else if (wasArray !== nowArray) {
        flags.calc = true;
      } else changed();
    } else if (wasArray && nowArray) {
      // info array, colorscale, 'any' - these are short, just stringify.
      // I don't *think* that covers up any real differences post-validation, does it?
      // otherwise we need to dive in 1 (info_array) or 2 (colorscale) levels and compare
      // all elements.
      if (oldVal.length !== newVal.length || String(oldVal) !== String(newVal)) {
        changed();
      }
    } else {
      changed();
    }
  }
  for (key in newContainer) {
    if (!(key in oldContainer || key.charAt(0) === '_' || typeof newContainer[key] === 'function')) {
      valObject = getValObject(outerparts.concat(key));
      if (valObjectCanBeDataArray(valObject) && Array.isArray(newContainer[key])) {
        flags.calc = true;
        return;
      } else changed();
    }
  }
}

/*
 * simple diff for config - for now, just treat all changes as equivalent
 */
function diffConfig(oldConfig, newConfig) {
  var key;
  for (key in oldConfig) {
    if (key.charAt(0) === '_') continue;
    var oldVal = oldConfig[key];
    var newVal = newConfig[key];
    if (oldVal !== newVal) {
      if (Lib.isPlainObject(oldVal) && Lib.isPlainObject(newVal)) {
        if (diffConfig(oldVal, newVal)) {
          return true;
        }
      } else if (Array.isArray(oldVal) && Array.isArray(newVal)) {
        if (oldVal.length !== newVal.length) {
          return true;
        }
        for (var i = 0; i < oldVal.length; i++) {
          if (oldVal[i] !== newVal[i]) {
            if (Lib.isPlainObject(oldVal[i]) && Lib.isPlainObject(newVal[i])) {
              if (diffConfig(oldVal[i], newVal[i])) {
                return true;
              }
            } else {
              return true;
            }
          }
        }
      } else {
        return true;
      }
    }
  }
}

/**
 * Animate to a frame, sequence of frame, frame group, or frame definition
 *
 * @param {string id or DOM element} gd
 *      the id or DOM element of the graph container div
 *
 * @param {string or object or array of strings or array of objects} frameOrGroupNameOrFrameList
 *      a single frame, array of frames, or group to which to animate. The intent is
 *      inferred by the type of the input. Valid inputs are:
 *
 *      - string, e.g. 'groupname': animate all frames of a given `group` in the order
 *            in which they are defined via `Plotly.addFrames`.
 *
 *      - array of strings, e.g. ['frame1', frame2']: a list of frames by name to which
 *            to animate in sequence
 *
 *      - object: {data: ...}: a frame definition to which to animate. The frame is not
 *            and does not need to be added via `Plotly.addFrames`. It may contain any of
 *            the properties of a frame, including `data`, `layout`, and `traces`. The
 *            frame is used as provided and does not use the `baseframe` property.
 *
 *      - array of objects, e.g. [{data: ...}, {data: ...}]: a list of frame objects,
 *            each following the same rules as a single `object`.
 *
 * @param {object} animationOpts
 *      configuration for the animation
 */
function animate(gd, frameOrGroupNameOrFrameList, animationOpts) {
  gd = Lib.getGraphDiv(gd);
  if (!Lib.isPlotDiv(gd)) {
    throw new Error('This element is not a Plotly plot: ' + gd + '. It\'s likely that you\'ve failed ' + 'to create a plot before animating it. For more details, see ' + 'https://plotly.com/javascript/animations/');
  }
  var trans = gd._transitionData;

  // This is the queue of frames that will be animated as soon as possible. They
  // are popped immediately upon the *start* of a transition:
  if (!trans._frameQueue) {
    trans._frameQueue = [];
  }
  animationOpts = Plots.supplyAnimationDefaults(animationOpts);
  var transitionOpts = animationOpts.transition;
  var frameOpts = animationOpts.frame;

  // Since frames are popped immediately, an empty queue only means all frames have
  // *started* to transition, not that the animation is complete. To solve that,
  // track a separate counter that increments at the same time as frames are added
  // to the queue, but decrements only when the transition is complete.
  if (trans._frameWaitingCnt === undefined) {
    trans._frameWaitingCnt = 0;
  }
  function getTransitionOpts(i) {
    if (Array.isArray(transitionOpts)) {
      if (i >= transitionOpts.length) {
        return transitionOpts[0];
      } else {
        return transitionOpts[i];
      }
    } else {
      return transitionOpts;
    }
  }
  function getFrameOpts(i) {
    if (Array.isArray(frameOpts)) {
      if (i >= frameOpts.length) {
        return frameOpts[0];
      } else {
        return frameOpts[i];
      }
    } else {
      return frameOpts;
    }
  }

  // Execute a callback after the wrapper function has been called n times.
  // This is used to defer the resolution until a transition has resolved *and*
  // the frame has completed. If it's not done this way, then we get a race
  // condition in which the animation might resolve before a transition is complete
  // or vice versa.
  function callbackOnNthTime(cb, n) {
    var cnt = 0;
    return function () {
      if (cb && ++cnt === n) {
        return cb();
      }
    };
  }
  return new Promise(function (resolve, reject) {
    function discardExistingFrames() {
      if (trans._frameQueue.length === 0) {
        return;
      }
      while (trans._frameQueue.length) {
        var next = trans._frameQueue.pop();
        if (next.onInterrupt) {
          next.onInterrupt();
        }
      }
      gd.emit('plotly_animationinterrupted', []);
    }
    function queueFrames(frameList) {
      if (frameList.length === 0) return;
      for (var i = 0; i < frameList.length; i++) {
        var computedFrame;
        if (frameList[i].type === 'byname') {
          // If it's a named frame, compute it:
          computedFrame = Plots.computeFrame(gd, frameList[i].name);
        } else {
          // Otherwise we must have been given a simple object, so treat
          // the input itself as the computed frame.
          computedFrame = frameList[i].data;
        }
        var frameOpts = getFrameOpts(i);
        var transitionOpts = getTransitionOpts(i);

        // It doesn't make much sense for the transition duration to be greater than
        // the frame duration, so limit it:
        transitionOpts.duration = Math.min(transitionOpts.duration, frameOpts.duration);
        var nextFrame = {
          frame: computedFrame,
          name: frameList[i].name,
          frameOpts: frameOpts,
          transitionOpts: transitionOpts
        };
        if (i === frameList.length - 1) {
          // The last frame in this .animate call stores the promise resolve
          // and reject callbacks. This is how we ensure that the animation
          // loop (which may exist as a result of a *different* .animate call)
          // still resolves or rejecdts this .animate call's promise. once it's
          // complete.
          nextFrame.onComplete = callbackOnNthTime(resolve, 2);
          nextFrame.onInterrupt = reject;
        }
        trans._frameQueue.push(nextFrame);
      }

      // Set it as never having transitioned to a frame. This will cause the animation
      // loop to immediately transition to the next frame (which, for immediate mode,
      // is the first frame in the list since all others would have been discarded
      // below)
      if (animationOpts.mode === 'immediate') {
        trans._lastFrameAt = -Infinity;
      }

      // Only it's not already running, start a RAF loop. This could be avoided in the
      // case that there's only one frame, but it significantly complicated the logic
      // and only sped things up by about 5% or so for a lorenz attractor simulation.
      // It would be a fine thing to implement, but the benefit of that optimization
      // doesn't seem worth the extra complexity.
      if (!trans._animationRaf) {
        beginAnimationLoop();
      }
    }
    function stopAnimationLoop() {
      gd.emit('plotly_animated');

      // Be sure to unset also since it's how we know whether a loop is already running:
      window.cancelAnimationFrame(trans._animationRaf);
      trans._animationRaf = null;
    }
    function nextFrame() {
      if (trans._currentFrame && trans._currentFrame.onComplete) {
        // Execute the callback and unset it to ensure it doesn't
        // accidentally get called twice
        trans._currentFrame.onComplete();
      }
      var newFrame = trans._currentFrame = trans._frameQueue.shift();
      if (newFrame) {
        // Since it's sometimes necessary to do deep digging into frame data,
        // we'll consider it not 100% impossible for nulls or numbers to sneak through,
        // so check when casting the name, just to be absolutely certain:
        var stringName = newFrame.name ? newFrame.name.toString() : null;
        gd._fullLayout._currentFrame = stringName;
        trans._lastFrameAt = Date.now();
        trans._timeToNext = newFrame.frameOpts.duration;

        // This is simply called and it's left to .transition to decide how to manage
        // interrupting current transitions. That means we don't need to worry about
        // how it resolves or what happens after this:
        Plots.transition(gd, newFrame.frame.data, newFrame.frame.layout, helpers.coerceTraceIndices(gd, newFrame.frame.traces), newFrame.frameOpts, newFrame.transitionOpts).then(function () {
          if (newFrame.onComplete) {
            newFrame.onComplete();
          }
        });
        gd.emit('plotly_animatingframe', {
          name: stringName,
          frame: newFrame.frame,
          animation: {
            frame: newFrame.frameOpts,
            transition: newFrame.transitionOpts
          }
        });
      } else {
        // If there are no more frames, then stop the RAF loop:
        stopAnimationLoop();
      }
    }
    function beginAnimationLoop() {
      gd.emit('plotly_animating');

      // If no timer is running, then set last frame = long ago so that the next
      // frame is immediately transitioned:
      trans._lastFrameAt = -Infinity;
      trans._timeToNext = 0;
      trans._runningTransitions = 0;
      trans._currentFrame = null;
      var doFrame = function () {
        // This *must* be requested before nextFrame since nextFrame may decide
        // to cancel it if there's nothing more to animated:
        trans._animationRaf = window.requestAnimationFrame(doFrame);

        // Check if we're ready for a new frame:
        if (Date.now() - trans._lastFrameAt > trans._timeToNext) {
          nextFrame();
        }
      };
      doFrame();
    }

    // This is an animate-local counter that helps match up option input list
    // items with the particular frame.
    var configCounter = 0;
    function setTransitionConfig(frame) {
      if (Array.isArray(transitionOpts)) {
        if (configCounter >= transitionOpts.length) {
          frame.transitionOpts = transitionOpts[configCounter];
        } else {
          frame.transitionOpts = transitionOpts[0];
        }
      } else {
        frame.transitionOpts = transitionOpts;
      }
      configCounter++;
      return frame;
    }

    // Disambiguate what's sort of frames have been received
    var i, frame;
    var frameList = [];
    var allFrames = frameOrGroupNameOrFrameList === undefined || frameOrGroupNameOrFrameList === null;
    var isFrameArray = Array.isArray(frameOrGroupNameOrFrameList);
    var isSingleFrame = !allFrames && !isFrameArray && Lib.isPlainObject(frameOrGroupNameOrFrameList);
    if (isSingleFrame) {
      // In this case, a simple object has been passed to animate.
      frameList.push({
        type: 'object',
        data: setTransitionConfig(Lib.extendFlat({}, frameOrGroupNameOrFrameList))
      });
    } else if (allFrames || ['string', 'number'].indexOf(typeof frameOrGroupNameOrFrameList) !== -1) {
      // In this case, null or undefined has been passed so that we want to
      // animate *all* currently defined frames
      for (i = 0; i < trans._frames.length; i++) {
        frame = trans._frames[i];
        if (!frame) continue;
        if (allFrames || String(frame.group) === String(frameOrGroupNameOrFrameList)) {
          frameList.push({
            type: 'byname',
            name: String(frame.name),
            data: setTransitionConfig({
              name: frame.name
            })
          });
        }
      }
    } else if (isFrameArray) {
      for (i = 0; i < frameOrGroupNameOrFrameList.length; i++) {
        var frameOrName = frameOrGroupNameOrFrameList[i];
        if (['number', 'string'].indexOf(typeof frameOrName) !== -1) {
          frameOrName = String(frameOrName);
          // In this case, there's an array and this frame is a string name:
          frameList.push({
            type: 'byname',
            name: frameOrName,
            data: setTransitionConfig({
              name: frameOrName
            })
          });
        } else if (Lib.isPlainObject(frameOrName)) {
          frameList.push({
            type: 'object',
            data: setTransitionConfig(Lib.extendFlat({}, frameOrName))
          });
        }
      }
    }

    // Verify that all of these frames actually exist; return and reject if not:
    for (i = 0; i < frameList.length; i++) {
      frame = frameList[i];
      if (frame.type === 'byname' && !trans._frameHash[frame.data.name]) {
        Lib.warn('animate failure: frame not found: "' + frame.data.name + '"');
        reject();
        return;
      }
    }

    // If the mode is either next or immediate, then all currently queued frames must
    // be dumped and the corresponding .animate promises rejected.
    if (['next', 'immediate'].indexOf(animationOpts.mode) !== -1) {
      discardExistingFrames();
    }
    if (animationOpts.direction === 'reverse') {
      frameList.reverse();
    }
    var currentFrame = gd._fullLayout._currentFrame;
    if (currentFrame && animationOpts.fromcurrent) {
      var idx = -1;
      for (i = 0; i < frameList.length; i++) {
        frame = frameList[i];
        if (frame.type === 'byname' && frame.name === currentFrame) {
          idx = i;
          break;
        }
      }
      if (idx > 0 && idx < frameList.length - 1) {
        var filteredFrameList = [];
        for (i = 0; i < frameList.length; i++) {
          frame = frameList[i];
          if (frameList[i].type !== 'byname' || i > idx) {
            filteredFrameList.push(frame);
          }
        }
        frameList = filteredFrameList;
      }
    }
    if (frameList.length > 0) {
      queueFrames(frameList);
    } else {
      // This is the case where there were simply no frames. It's a little strange
      // since there's not much to do:
      gd.emit('plotly_animated');
      resolve();
    }
  });
}

/**
 * Register new frames
 *
 * @param {string id or DOM element} gd
 *      the id or DOM element of the graph container div
 *
 * @param {array of objects} frameList
 *      list of frame definitions, in which each object includes any of:
 *      - name: {string} name of frame to add
 *      - data: {array of objects} trace data
 *      - layout {object} layout definition
 *      - traces {array} trace indices
 *      - baseframe {string} name of frame from which this frame gets defaults
 *
 *  @param {array of integers} indices
 *      an array of integer indices matching the respective frames in `frameList`. If not
 *      provided, an index will be provided in serial order. If already used, the frame
 *      will be overwritten.
 */
function addFrames(gd, frameList, indices) {
  gd = Lib.getGraphDiv(gd);
  if (frameList === null || frameList === undefined) {
    return Promise.resolve();
  }
  if (!Lib.isPlotDiv(gd)) {
    throw new Error('This element is not a Plotly plot: ' + gd + '. It\'s likely that you\'ve failed ' + 'to create a plot before adding frames. For more details, see ' + 'https://plotly.com/javascript/animations/');
  }
  var i, frame, j, idx;
  var _frames = gd._transitionData._frames;
  var _frameHash = gd._transitionData._frameHash;
  if (!Array.isArray(frameList)) {
    throw new Error('addFrames failure: frameList must be an Array of frame definitions' + frameList);
  }

  // Create a sorted list of insertions since we run into lots of problems if these
  // aren't in ascending order of index:
  //
  // Strictly for sorting. Make sure this is guaranteed to never collide with any
  // already-exisisting indices:
  var bigIndex = _frames.length + frameList.length * 2;
  var insertions = [];
  var _frameHashLocal = {};
  for (i = frameList.length - 1; i >= 0; i--) {
    if (!Lib.isPlainObject(frameList[i])) continue;

    // The entire logic for checking for this type of name collision can be removed once we migrate to ES6 and
    // use a Map instead of an Object instance, as Map keys aren't converted to strings.
    var lookupName = frameList[i].name;
    var name = (_frameHash[lookupName] || _frameHashLocal[lookupName] || {}).name;
    var newName = frameList[i].name;
    var collisionPresent = _frameHash[name] || _frameHashLocal[name];
    if (name && newName && typeof newName === 'number' && collisionPresent && numericNameWarningCount < numericNameWarningCountLimit) {
      numericNameWarningCount++;
      Lib.warn('addFrames: overwriting frame "' + (_frameHash[name] || _frameHashLocal[name]).name + '" with a frame whose name of type "number" also equates to "' + name + '". This is valid but may potentially lead to unexpected ' + 'behavior since all plotly.js frame names are stored internally ' + 'as strings.');
      if (numericNameWarningCount === numericNameWarningCountLimit) {
        Lib.warn('addFrames: This API call has yielded too many of these warnings. ' + 'For the rest of this call, further warnings about numeric frame ' + 'names will be suppressed.');
      }
    }
    _frameHashLocal[lookupName] = {
      name: lookupName
    };
    insertions.push({
      frame: Plots.supplyFrameDefaults(frameList[i]),
      index: indices && indices[i] !== undefined && indices[i] !== null ? indices[i] : bigIndex + i
    });
  }

  // Sort this, taking note that undefined insertions end up at the end:
  insertions.sort(function (a, b) {
    if (a.index > b.index) return -1;
    if (a.index < b.index) return 1;
    return 0;
  });
  var ops = [];
  var revops = [];
  var frameCount = _frames.length;
  for (i = insertions.length - 1; i >= 0; i--) {
    frame = insertions[i].frame;
    if (typeof frame.name === 'number') {
      Lib.warn('Warning: addFrames accepts frames with numeric names, but the numbers are' + 'implicitly cast to strings');
    }
    if (!frame.name) {
      // Repeatedly assign a default name, incrementing the counter each time until
      // we get a name that's not in the hashed lookup table:
      while (_frameHash[frame.name = 'frame ' + gd._transitionData._counter++]);
    }
    if (_frameHash[frame.name]) {
      // If frame is present, overwrite its definition:
      for (j = 0; j < _frames.length; j++) {
        if ((_frames[j] || {}).name === frame.name) break;
      }
      ops.push({
        type: 'replace',
        index: j,
        value: frame
      });
      revops.unshift({
        type: 'replace',
        index: j,
        value: _frames[j]
      });
    } else {
      // Otherwise insert it at the end of the list:
      idx = Math.max(0, Math.min(insertions[i].index, frameCount));
      ops.push({
        type: 'insert',
        index: idx,
        value: frame
      });
      revops.unshift({
        type: 'delete',
        index: idx
      });
      frameCount++;
    }
  }
  var undoFunc = Plots.modifyFrames;
  var redoFunc = Plots.modifyFrames;
  var undoArgs = [gd, revops];
  var redoArgs = [gd, ops];
  if (Queue) Queue.add(gd, undoFunc, undoArgs, redoFunc, redoArgs);
  return Plots.modifyFrames(gd, ops);
}

/**
 * Delete frame
 *
 * @param {string id or DOM element} gd
 *      the id or DOM element of the graph container div
 *
 * @param {array of integers} frameList
 *      list of integer indices of frames to be deleted
 */
function deleteFrames(gd, frameList) {
  gd = Lib.getGraphDiv(gd);
  if (!Lib.isPlotDiv(gd)) {
    throw new Error('This element is not a Plotly plot: ' + gd);
  }
  var i, idx;
  var _frames = gd._transitionData._frames;
  var ops = [];
  var revops = [];
  if (!frameList) {
    frameList = [];
    for (i = 0; i < _frames.length; i++) {
      frameList.push(i);
    }
  }
  frameList = frameList.slice();
  frameList.sort();
  for (i = frameList.length - 1; i >= 0; i--) {
    idx = frameList[i];
    ops.push({
      type: 'delete',
      index: idx
    });
    revops.unshift({
      type: 'insert',
      index: idx,
      value: _frames[idx]
    });
  }
  var undoFunc = Plots.modifyFrames;
  var redoFunc = Plots.modifyFrames;
  var undoArgs = [gd, revops];
  var redoArgs = [gd, ops];
  if (Queue) Queue.add(gd, undoFunc, undoArgs, redoFunc, redoArgs);
  return Plots.modifyFrames(gd, ops);
}

/**
 * Purge a graph container div back to its initial pre-_doPlot state
 *
 * @param {string id or DOM element} gd
 *      the id or DOM element of the graph container div
 */
function purge(gd) {
  gd = Lib.getGraphDiv(gd);
  var fullLayout = gd._fullLayout || {};
  var fullData = gd._fullData || [];

  // remove gl contexts
  Plots.cleanPlot([], {}, fullData, fullLayout);

  // purge properties
  Plots.purge(gd);

  // purge event emitter methods
  Events.purge(gd);

  // remove plot container
  if (fullLayout._container) fullLayout._container.remove();

  // in contrast to _doPlots.purge which does NOT clear _context!
  delete gd._context;
  return gd;
}

// determines if the graph div requires a recalculation of its inverse matrix transforms by comparing old + new bounding boxes.
function calcInverseTransform(gd) {
  var fullLayout = gd._fullLayout;
  var newBBox = gd.getBoundingClientRect();
  if (Lib.equalDomRects(newBBox, fullLayout._lastBBox)) return;
  var m = fullLayout._invTransform = Lib.inverseTransformMatrix(Lib.getFullTransformMatrix(gd));
  fullLayout._invScaleX = Math.sqrt(m[0][0] * m[0][0] + m[0][1] * m[0][1] + m[0][2] * m[0][2]);
  fullLayout._invScaleY = Math.sqrt(m[1][0] * m[1][0] + m[1][1] * m[1][1] + m[1][2] * m[1][2]);
  fullLayout._lastBBox = newBBox;
}

// -------------------------------------------------------
// makePlotFramework: Create the plot container and axes
// -------------------------------------------------------
function makePlotFramework(gd) {
  var gd3 = d3.select(gd);
  var fullLayout = gd._fullLayout;
  fullLayout._calcInverseTransform = calcInverseTransform;
  fullLayout._calcInverseTransform(gd);

  // Plot container
  fullLayout._container = gd3.selectAll('.plot-container').data([0]);
  fullLayout._container.enter().insert('div', ':first-child').classed('plot-container', true).classed('plotly', true)
  // The plot container should always take the full with the height of its
  // parent (the graph div). This ensures that for responsive plots
  // without a height or width set, the paper div will take up the full
  // height & width of the graph div. 
  // So, for responsive plots without a height or width set, if the plot
  // container's height is left to 'auto', its height will be dictated by
  // its childrens' height. (The plot container's only child is the paper
  // div.) 
  // In this scenario, the paper div's height will be set to 100%,
  // which will be 100% of the plot container's auto height. That is
  // meaninglesss, so the browser will use the paper div's children to set
  // the height of the plot container instead. However, the paper div's
  // children do not have any height, because they are all positioned
  // absolutely, and therefore take up no space.
  .style({
    width: "100%",
    height: "100%"
  });

  // Make the svg container
  fullLayout._paperdiv = fullLayout._container.selectAll('.svg-container').data([0]);
  fullLayout._paperdiv.enter().append('div').classed('user-select-none', true).classed('svg-container', true).style('position', 'relative');

  // Make the graph containers
  // start fresh each time we get here, so we know the order comes out
  // right, rather than enter/exit which can muck up the order
  // TODO: sort out all the ordering so we don't have to
  // explicitly delete anything
  // FIXME: parcoords reuses this object, not the best pattern
  fullLayout._glcontainer = fullLayout._paperdiv.selectAll('.gl-container').data([{}]);
  fullLayout._glcontainer.enter().append('div').classed('gl-container', true);
  fullLayout._paperdiv.selectAll('.main-svg').remove();
  fullLayout._paperdiv.select('.modebar-container').remove();
  fullLayout._paper = fullLayout._paperdiv.insert('svg', ':first-child').classed('main-svg', true);
  fullLayout._toppaper = fullLayout._paperdiv.append('svg').classed('main-svg', true);
  fullLayout._modebardiv = fullLayout._paperdiv.append('div');
  delete fullLayout._modeBar;
  fullLayout._hoverpaper = fullLayout._paperdiv.append('svg').classed('main-svg', true);
  if (!fullLayout._uid) {
    var otherUids = {};
    d3.selectAll('defs').each(function () {
      if (this.id) otherUids[this.id.split('-')[1]] = 1;
    });
    fullLayout._uid = Lib.randstr(otherUids);
  }
  fullLayout._paperdiv.selectAll('.main-svg').attr(xmlnsNamespaces.svgAttrs);
  fullLayout._defs = fullLayout._paper.append('defs').attr('id', 'defs-' + fullLayout._uid);
  fullLayout._clips = fullLayout._defs.append('g').classed('clips', true);
  fullLayout._topdefs = fullLayout._toppaper.append('defs').attr('id', 'topdefs-' + fullLayout._uid);
  fullLayout._topclips = fullLayout._topdefs.append('g').classed('clips', true);
  fullLayout._bgLayer = fullLayout._paper.append('g').classed('bglayer', true);
  fullLayout._draggers = fullLayout._paper.append('g').classed('draglayer', true);

  // lower shape/image layer - note that this is behind
  // all subplots data/grids but above the backgrounds
  // except inset subplots, whose backgrounds are drawn
  // inside their own group so that they appear above
  // the data for the main subplot
  // lower shapes and images which are fully referenced to
  // a subplot still get drawn within the subplot's group
  // so they will work correctly on insets
  var layerBelow = fullLayout._paper.append('g').classed('layer-below', true);
  fullLayout._imageLowerLayer = layerBelow.append('g').classed('imagelayer', true);
  fullLayout._shapeLowerLayer = layerBelow.append('g').classed('shapelayer', true);

  // single cartesian layer for the whole plot
  fullLayout._cartesianlayer = fullLayout._paper.append('g').classed('cartesianlayer', true);

  // single polar layer for the whole plot
  fullLayout._polarlayer = fullLayout._paper.append('g').classed('polarlayer', true);

  // single smith layer for the whole plot
  fullLayout._smithlayer = fullLayout._paper.append('g').classed('smithlayer', true);

  // single ternary layer for the whole plot
  fullLayout._ternarylayer = fullLayout._paper.append('g').classed('ternarylayer', true);

  // single geo layer for the whole plot
  fullLayout._geolayer = fullLayout._paper.append('g').classed('geolayer', true);

  // single funnelarea layer for the whole plot
  fullLayout._funnelarealayer = fullLayout._paper.append('g').classed('funnelarealayer', true);

  // single pie layer for the whole plot
  fullLayout._pielayer = fullLayout._paper.append('g').classed('pielayer', true);

  // single treemap layer for the whole plot
  fullLayout._iciclelayer = fullLayout._paper.append('g').classed('iciclelayer', true);

  // single treemap layer for the whole plot
  fullLayout._treemaplayer = fullLayout._paper.append('g').classed('treemaplayer', true);

  // single sunburst layer for the whole plot
  fullLayout._sunburstlayer = fullLayout._paper.append('g').classed('sunburstlayer', true);

  // single indicator layer for the whole plot
  fullLayout._indicatorlayer = fullLayout._toppaper.append('g').classed('indicatorlayer', true);

  // fill in image server scrape-svg
  fullLayout._glimages = fullLayout._paper.append('g').classed('glimages', true);

  // lastly upper shapes, info (legend, annotations) and hover layers go on top
  // these are in a different svg element normally, but get collapsed into a single
  // svg when exporting (after inserting 3D)
  // upper shapes/images are only those drawn above the whole plot, including subplots
  var layerAbove = fullLayout._toppaper.append('g').classed('layer-above', true);
  fullLayout._imageUpperLayer = layerAbove.append('g').classed('imagelayer', true);
  fullLayout._shapeUpperLayer = layerAbove.append('g').classed('shapelayer', true);
  fullLayout._selectionLayer = fullLayout._toppaper.append('g').classed('selectionlayer', true);
  fullLayout._infolayer = fullLayout._toppaper.append('g').classed('infolayer', true);
  fullLayout._menulayer = fullLayout._toppaper.append('g').classed('menulayer', true);
  fullLayout._zoomlayer = fullLayout._toppaper.append('g').classed('zoomlayer', true);
  fullLayout._hoverlayer = fullLayout._hoverpaper.append('g').classed('hoverlayer', true);

  // Make the modebar container
  fullLayout._modebardiv.classed('modebar-container', true).style('position', 'absolute').style('top', '0px').style('right', '0px');
  gd.emit('plotly_framework');
}
exports.animate = animate;
exports.addFrames = addFrames;
exports.deleteFrames = deleteFrames;
exports.addTraces = addTraces;
exports.deleteTraces = deleteTraces;
exports.extendTraces = extendTraces;
exports.moveTraces = moveTraces;
exports.prependTraces = prependTraces;
exports.newPlot = newPlot;
exports._doPlot = _doPlot;
exports.purge = purge;
exports.react = react;
exports.redraw = redraw;
exports.relayout = relayout;
exports.restyle = restyle;
exports.setPlotConfig = setPlotConfig;
exports.update = update;
exports._guiRelayout = guiEdit(relayout);
exports._guiRestyle = guiEdit(restyle);
exports._guiUpdate = guiEdit(update);
exports._storeDirectGUIEdit = _storeDirectGUIEdit;

/***/ }),

/***/ 24452:
/***/ (function(module) {

"use strict";


/**
 * This will be transferred over to gd and overridden by
 * config args to Plotly.newPlot.
 *
 * The defaults are the appropriate settings for plotly.js,
 * so we get the right experience without any config argument.
 *
 * N.B. the config options are not coerced using Lib.coerce so keys
 * like `valType` and `values` are only set for documentation purposes
 * at the moment.
 */
var configAttributes = {
  staticPlot: {
    valType: 'boolean',
    dflt: false
  },
  typesetMath: {
    valType: 'boolean',
    dflt: true
  },
  plotlyServerURL: {
    valType: 'string',
    dflt: ''
  },
  editable: {
    valType: 'boolean',
    dflt: false
  },
  edits: {
    annotationPosition: {
      valType: 'boolean',
      dflt: false
    },
    annotationTail: {
      valType: 'boolean',
      dflt: false
    },
    annotationText: {
      valType: 'boolean',
      dflt: false
    },
    axisTitleText: {
      valType: 'boolean',
      dflt: false
    },
    colorbarPosition: {
      valType: 'boolean',
      dflt: false
    },
    colorbarTitleText: {
      valType: 'boolean',
      dflt: false
    },
    legendPosition: {
      valType: 'boolean',
      dflt: false
    },
    legendText: {
      valType: 'boolean',
      dflt: false
    },
    shapePosition: {
      valType: 'boolean',
      dflt: false
    },
    titleText: {
      valType: 'boolean',
      dflt: false
    }
  },
  editSelection: {
    valType: 'boolean',
    dflt: true
  },
  autosizable: {
    valType: 'boolean',
    dflt: false
  },
  responsive: {
    valType: 'boolean',
    dflt: false
  },
  fillFrame: {
    valType: 'boolean',
    dflt: false
  },
  frameMargins: {
    valType: 'number',
    dflt: 0,
    min: 0,
    max: 0.5
  },
  scrollZoom: {
    valType: 'flaglist',
    flags: ['cartesian', 'gl3d', 'geo', 'mapbox', 'map'],
    extras: [true, false],
    dflt: 'gl3d+geo+map'
  },
  doubleClick: {
    valType: 'enumerated',
    values: [false, 'reset', 'autosize', 'reset+autosize'],
    dflt: 'reset+autosize'
  },
  doubleClickDelay: {
    valType: 'number',
    dflt: 300,
    min: 0
  },
  showAxisDragHandles: {
    valType: 'boolean',
    dflt: true
  },
  showAxisRangeEntryBoxes: {
    valType: 'boolean',
    dflt: true
  },
  showTips: {
    valType: 'boolean',
    dflt: true
  },
  showLink: {
    valType: 'boolean',
    dflt: false
  },
  linkText: {
    valType: 'string',
    dflt: 'Edit chart',
    noBlank: true
  },
  sendData: {
    valType: 'boolean',
    dflt: true
  },
  showSources: {
    valType: 'any',
    dflt: false
  },
  displayModeBar: {
    valType: 'enumerated',
    values: ['hover', true, false],
    dflt: 'hover'
  },
  showSendToCloud: {
    valType: 'boolean',
    dflt: false
  },
  showEditInChartStudio: {
    valType: 'boolean',
    dflt: false
  },
  modeBarButtonsToRemove: {
    valType: 'any',
    dflt: []
  },
  modeBarButtonsToAdd: {
    valType: 'any',
    dflt: []
  },
  modeBarButtons: {
    valType: 'any',
    dflt: false
  },
  toImageButtonOptions: {
    valType: 'any',
    dflt: {}
  },
  displaylogo: {
    valType: 'boolean',
    dflt: true
  },
  watermark: {
    valType: 'boolean',
    dflt: false
  },
  plotGlPixelRatio: {
    valType: 'number',
    dflt: 2,
    min: 1,
    max: 4
  },
  setBackground: {
    valType: 'any',
    dflt: 'transparent'
  },
  topojsonURL: {
    valType: 'string',
    noBlank: true,
    dflt: 'https://cdn.plot.ly/'
  },
  mapboxAccessToken: {
    valType: 'string',
    dflt: null
  },
  logging: {
    valType: 'integer',
    min: 0,
    max: 2,
    dflt: 1
  },
  notifyOnLogging: {
    valType: 'integer',
    min: 0,
    max: 2,
    dflt: 0
  },
  queueLength: {
    valType: 'integer',
    min: 0,
    dflt: 0
  },
  globalTransforms: {
    valType: 'any',
    dflt: []
  },
  locale: {
    valType: 'string',
    dflt: 'en-US'
  },
  locales: {
    valType: 'any',
    dflt: {}
  }
};
var dfltConfig = {};
function crawl(src, target) {
  for (var k in src) {
    var obj = src[k];
    if (obj.valType) {
      target[k] = obj.dflt;
    } else {
      if (!target[k]) {
        target[k] = {};
      }
      crawl(obj, target[k]);
    }
  }
}
crawl(configAttributes, dfltConfig);
module.exports = {
  configAttributes: configAttributes,
  dfltConfig: dfltConfig
};

/***/ }),

/***/ 57297:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var Registry = __webpack_require__(33626);
var Lib = __webpack_require__(34809);
var baseAttributes = __webpack_require__(9829);
var baseLayoutAttributes = __webpack_require__(6704);
var frameAttributes = __webpack_require__(58935);
var animationAttributes = __webpack_require__(49722);
var configAttributes = (__webpack_require__(24452).configAttributes);
var editTypes = __webpack_require__(13582);
var extendDeepAll = Lib.extendDeepAll;
var isPlainObject = Lib.isPlainObject;
var isArrayOrTypedArray = Lib.isArrayOrTypedArray;
var nestedProperty = Lib.nestedProperty;
var valObjectMeta = Lib.valObjectMeta;
var IS_SUBPLOT_OBJ = '_isSubplotObj';
var IS_LINKED_TO_ARRAY = '_isLinkedToArray';
var ARRAY_ATTR_REGEXPS = '_arrayAttrRegexps';
var DEPRECATED = '_deprecated';
var UNDERSCORE_ATTRS = [IS_SUBPLOT_OBJ, IS_LINKED_TO_ARRAY, ARRAY_ATTR_REGEXPS, DEPRECATED];
exports.IS_SUBPLOT_OBJ = IS_SUBPLOT_OBJ;
exports.IS_LINKED_TO_ARRAY = IS_LINKED_TO_ARRAY;
exports.DEPRECATED = DEPRECATED;
exports.UNDERSCORE_ATTRS = UNDERSCORE_ATTRS;

/** Outputs the full plotly.js plot schema
 *
 * @return {object}
 *  - defs
 *  - traces
 *  - layout
 *  - transforms
 *  - frames
 *  - animations
 *  - config
 */
exports.get = function () {
  var traces = {};
  Registry.allTypes.forEach(function (type) {
    traces[type] = getTraceAttributes(type);
  });
  var transforms = {};
  Object.keys(Registry.transformsRegistry).forEach(function (type) {
    transforms[type] = getTransformAttributes(type);
  });
  return {
    defs: {
      valObjects: valObjectMeta,
      metaKeys: UNDERSCORE_ATTRS.concat(['description', 'role', 'editType', 'impliedEdits']),
      editType: {
        traces: editTypes.traces,
        layout: editTypes.layout
      },
      impliedEdits: {}
    },
    traces: traces,
    layout: getLayoutAttributes(),
    transforms: transforms,
    frames: getFramesAttributes(),
    animation: formatAttributes(animationAttributes),
    config: formatAttributes(configAttributes)
  };
};

/**
 * Crawl the attribute tree, recursively calling a callback function
 *
 * @param {object} attrs
 *  The node of the attribute tree (e.g. the root) from which recursion originates
 * @param {Function} callback
 *  A callback function with the signature:
 *          @callback callback
 *          @param {object} attr an attribute
 *          @param {String} attrName name string
 *          @param {object[]} attrs all the attributes
 *          @param {Number} level the recursion level, 0 at the root
 *          @param {String} fullAttrString full attribute name (ie 'marker.line')
 * @param {Number} [specifiedLevel]
 *  The level in the tree, in order to let the callback function detect descend or backtrack,
 *  typically unsupplied (implied 0), just used by the self-recursive call.
 *  The necessity arises because the tree traversal is not controlled by callback return values.
 *  The decision to not use callback return values for controlling tree pruning arose from
 *  the goal of keeping the crawler backwards compatible. Observe that one of the pruning conditions
 *  precedes the callback call.
 * @param {string} [attrString]
 *  the path to the current attribute, as an attribute string (ie 'marker.line')
 *  typically unsupplied, but you may supply it if you want to disambiguate which attrs tree you
 *  are starting from
 *
 * @return {object} transformOut
 *  copy of transformIn that contains attribute defaults
 */
exports.crawl = function (attrs, callback, specifiedLevel, attrString) {
  var level = specifiedLevel || 0;
  attrString = attrString || '';
  Object.keys(attrs).forEach(function (attrName) {
    var attr = attrs[attrName];
    if (UNDERSCORE_ATTRS.indexOf(attrName) !== -1) return;
    var fullAttrString = (attrString ? attrString + '.' : '') + attrName;
    callback(attr, attrName, attrs, level, fullAttrString);
    if (exports.isValObject(attr)) return;
    if (isPlainObject(attr) && attrName !== 'impliedEdits') {
      exports.crawl(attr, callback, level + 1, fullAttrString);
    }
  });
};

/** Is object a value object (or a container object)?
 *
 * @param {object} obj
 * @return {boolean}
 *  returns true for a valid value object and
 *  false for tree nodes in the attribute hierarchy
 */
exports.isValObject = function (obj) {
  return obj && obj.valType !== undefined;
};

/**
 * Find all data array attributes in a given trace object - including
 * `arrayOk` attributes.
 *
 * @param {object} trace
 *  full trace object that contains a reference to `_module.attributes`
 *
 * @return {array} arrayAttributes
 *  list of array attributes for the given trace
 */
exports.findArrayAttributes = function (trace) {
  var arrayAttributes = [];
  var stack = [];
  var isArrayStack = [];
  var baseContainer, baseAttrName;
  function callback(attr, attrName, attrs, level) {
    stack = stack.slice(0, level).concat([attrName]);
    isArrayStack = isArrayStack.slice(0, level).concat([attr && attr._isLinkedToArray]);
    var splittableAttr = attr && (attr.valType === 'data_array' || attr.arrayOk === true) && !(stack[level - 1] === 'colorbar' && (attrName === 'ticktext' || attrName === 'tickvals'));

    // Manually exclude 'colorbar.tickvals' and 'colorbar.ticktext' for now
    // which are declared as `valType: 'data_array'` but scale independently of
    // the coordinate arrays.
    //
    // Down the road, we might want to add a schema field (e.g `uncorrelatedArray: true`)
    // to distinguish attributes of the likes.

    if (!splittableAttr) return;
    crawlIntoTrace(baseContainer, 0, '');
  }
  function crawlIntoTrace(container, i, astrPartial) {
    var item = container[stack[i]];
    var newAstrPartial = astrPartial + stack[i];
    if (i === stack.length - 1) {
      if (isArrayOrTypedArray(item)) {
        arrayAttributes.push(baseAttrName + newAstrPartial);
      }
    } else {
      if (isArrayStack[i]) {
        if (Array.isArray(item)) {
          for (var j = 0; j < item.length; j++) {
            if (isPlainObject(item[j])) {
              crawlIntoTrace(item[j], i + 1, newAstrPartial + '[' + j + '].');
            }
          }
        }
      } else if (isPlainObject(item)) {
        crawlIntoTrace(item, i + 1, newAstrPartial + '.');
      }
    }
  }
  baseContainer = trace;
  baseAttrName = '';
  exports.crawl(baseAttributes, callback);
  if (trace._module && trace._module.attributes) {
    exports.crawl(trace._module.attributes, callback);
  }
  var transforms = trace.transforms;
  if (transforms) {
    for (var i = 0; i < transforms.length; i++) {
      var transform = transforms[i];
      var module = transform._module;
      if (module) {
        baseAttrName = 'transforms[' + i + '].';
        baseContainer = transform;
        exports.crawl(module.attributes, callback);
      }
    }
  }
  return arrayAttributes;
};

/*
 * Find the valObject for one attribute in an existing trace
 *
 * @param {object} trace
 *  full trace object that contains a reference to `_module.attributes`
 * @param {object} parts
 *  an array of parts, like ['transforms', 1, 'value']
 *  typically from nestedProperty(...).parts
 *
 * @return {object|false}
 *  the valObject for this attribute, or the last found parent
 *  in some cases the innermost valObject will not exist, for example
 *  `valType: 'any'` attributes where we might set a part of the attribute.
 *  In that case, stop at the deepest valObject we *do* find.
 */
exports.getTraceValObject = function (trace, parts) {
  var head = parts[0];
  var i = 1; // index to start recursing from
  var moduleAttrs, valObject;
  if (head === 'transforms') {
    if (parts.length === 1) {
      return baseAttributes.transforms;
    }
    var transforms = trace.transforms;
    if (!Array.isArray(transforms) || !transforms.length) return false;
    var tNum = parts[1];
    if (!isIndex(tNum) || tNum >= transforms.length) {
      return false;
    }
    moduleAttrs = (Registry.transformsRegistry[transforms[tNum].type] || {}).attributes;
    valObject = moduleAttrs && moduleAttrs[parts[2]];
    i = 3; // start recursing only inside the transform
  } else {
    // first look in the module for this trace
    // components have already merged their trace attributes in here
    var _module = trace._module;
    if (!_module) _module = (Registry.modules[trace.type || baseAttributes.type.dflt] || {})._module;
    if (!_module) return false;
    moduleAttrs = _module.attributes;
    valObject = moduleAttrs && moduleAttrs[head];

    // then look in the subplot attributes
    if (!valObject) {
      var subplotModule = _module.basePlotModule;
      if (subplotModule && subplotModule.attributes) {
        valObject = subplotModule.attributes[head];
      }
    }

    // finally look in the global attributes
    if (!valObject) valObject = baseAttributes[head];
  }
  return recurseIntoValObject(valObject, parts, i);
};

/*
 * Find the valObject for one layout attribute
 *
 * @param {array} parts
 *  an array of parts, like ['annotations', 1, 'x']
 *  typically from nestedProperty(...).parts
 *
 * @return {object|false}
 *  the valObject for this attribute, or the last found parent
 *  in some cases the innermost valObject will not exist, for example
 *  `valType: 'any'` attributes where we might set a part of the attribute.
 *  In that case, stop at the deepest valObject we *do* find.
 */
exports.getLayoutValObject = function (fullLayout, parts) {
  var valObject = layoutHeadAttr(fullLayout, parts[0]);
  return recurseIntoValObject(valObject, parts, 1);
};
function layoutHeadAttr(fullLayout, head) {
  var i, key, _module, attributes;

  // look for attributes of the subplot types used on the plot
  var basePlotModules = fullLayout._basePlotModules;
  if (basePlotModules) {
    var out;
    for (i = 0; i < basePlotModules.length; i++) {
      _module = basePlotModules[i];
      if (_module.attrRegex && _module.attrRegex.test(head)) {
        // if a module defines overrides, these take precedence
        // initially this is to allow gl2d different editTypes from svg cartesian
        if (_module.layoutAttrOverrides) return _module.layoutAttrOverrides;

        // otherwise take the first attributes we find
        if (!out && _module.layoutAttributes) out = _module.layoutAttributes;
      }

      // a module can also override the behavior of base (and component) module layout attrs
      // again see gl2d for initial use case
      var baseOverrides = _module.baseLayoutAttrOverrides;
      if (baseOverrides && head in baseOverrides) return baseOverrides[head];
    }
    if (out) return out;
  }

  // look for layout attributes contributed by traces on the plot
  var modules = fullLayout._modules;
  if (modules) {
    for (i = 0; i < modules.length; i++) {
      attributes = modules[i].layoutAttributes;
      if (attributes && head in attributes) {
        return attributes[head];
      }
    }
  }

  /*
   * Next look in components.
   * Components that define a schema have already merged this into
   * base and subplot attribute defs, so ignore these.
   * Others (older style) all put all their attributes
   * inside a container matching the module `name`
   * eg `attributes` (array) or `legend` (object)
   */
  for (key in Registry.componentsRegistry) {
    _module = Registry.componentsRegistry[key];
    if (_module.name === 'colorscale' && head.indexOf('coloraxis') === 0) {
      return _module.layoutAttributes[head];
    } else if (!_module.schema && head === _module.name) {
      return _module.layoutAttributes;
    }
  }
  if (head in baseLayoutAttributes) return baseLayoutAttributes[head];
  return false;
}
function recurseIntoValObject(valObject, parts, i) {
  if (!valObject) return false;
  if (valObject._isLinkedToArray) {
    // skip array index, abort if we try to dive into an array without an index
    if (isIndex(parts[i])) i++;else if (i < parts.length) return false;
  }

  // now recurse as far as we can. Occasionally we have an attribute
  // setting an internal part below what's in the schema; just return
  // the innermost schema item we find.
  for (; i < parts.length; i++) {
    var newValObject = valObject[parts[i]];
    if (isPlainObject(newValObject)) valObject = newValObject;else break;
    if (i === parts.length - 1) break;
    if (valObject._isLinkedToArray) {
      i++;
      if (!isIndex(parts[i])) return false;
    } else if (valObject.valType === 'info_array') {
      i++;
      var index = parts[i];
      if (!isIndex(index)) return false;
      var items = valObject.items;
      if (Array.isArray(items)) {
        if (index >= items.length) return false;
        if (valObject.dimensions === 2) {
          i++;
          if (parts.length === i) return valObject;
          var index2 = parts[i];
          if (!isIndex(index2)) return false;
          valObject = items[index][index2];
        } else valObject = items[index];
      } else {
        valObject = items;
      }
    }
  }
  return valObject;
}

// note: this is different from Lib.isIndex, this one doesn't accept numeric
// strings, only actual numbers.
function isIndex(val) {
  return val === Math.round(val) && val >= 0;
}
function getTraceAttributes(type) {
  var _module, basePlotModule;
  _module = Registry.modules[type]._module, basePlotModule = _module.basePlotModule;
  var attributes = {};

  // make 'type' the first attribute in the object
  attributes.type = null;
  var copyBaseAttributes = extendDeepAll({}, baseAttributes);
  var copyModuleAttributes = extendDeepAll({}, _module.attributes);

  // prune global-level trace attributes that are already defined in a trace
  exports.crawl(copyModuleAttributes, function (attr, attrName, attrs, level, fullAttrString) {
    nestedProperty(copyBaseAttributes, fullAttrString).set(undefined);
    // Prune undefined attributes
    if (attr === undefined) nestedProperty(copyModuleAttributes, fullAttrString).set(undefined);
  });

  // base attributes (same for all trace types)
  extendDeepAll(attributes, copyBaseAttributes);

  // prune-out base attributes based on trace module categories
  if (Registry.traceIs(type, 'noOpacity')) {
    delete attributes.opacity;
  }
  if (!Registry.traceIs(type, 'showLegend')) {
    delete attributes.showlegend;
    delete attributes.legendgroup;
  }
  if (Registry.traceIs(type, 'noHover')) {
    delete attributes.hoverinfo;
    delete attributes.hoverlabel;
  }
  if (!_module.selectPoints) {
    delete attributes.selectedpoints;
  }

  // module attributes
  extendDeepAll(attributes, copyModuleAttributes);

  // subplot attributes
  if (basePlotModule.attributes) {
    extendDeepAll(attributes, basePlotModule.attributes);
  }

  // 'type' gets overwritten by baseAttributes; reset it here
  attributes.type = type;
  var out = {
    meta: _module.meta || {},
    categories: _module.categories || {},
    animatable: Boolean(_module.animatable),
    type: type,
    attributes: formatAttributes(attributes)
  };

  // trace-specific layout attributes
  if (_module.layoutAttributes) {
    var layoutAttributes = {};
    extendDeepAll(layoutAttributes, _module.layoutAttributes);
    out.layoutAttributes = formatAttributes(layoutAttributes);
  }

  // drop anim:true in non-animatable modules
  if (!_module.animatable) {
    exports.crawl(out, function (attr) {
      if (exports.isValObject(attr) && 'anim' in attr) {
        delete attr.anim;
      }
    });
  }
  return out;
}
function getLayoutAttributes() {
  var layoutAttributes = {};
  var key, _module;

  // global layout attributes
  extendDeepAll(layoutAttributes, baseLayoutAttributes);

  // add base plot module layout attributes
  for (key in Registry.subplotsRegistry) {
    _module = Registry.subplotsRegistry[key];
    if (!_module.layoutAttributes) continue;
    if (Array.isArray(_module.attr)) {
      for (var i = 0; i < _module.attr.length; i++) {
        handleBasePlotModule(layoutAttributes, _module, _module.attr[i]);
      }
    } else {
      var astr = _module.attr === 'subplot' ? _module.name : _module.attr;
      handleBasePlotModule(layoutAttributes, _module, astr);
    }
  }

  // add registered components layout attributes
  for (key in Registry.componentsRegistry) {
    _module = Registry.componentsRegistry[key];
    var schema = _module.schema;
    if (schema && (schema.subplots || schema.layout)) {
      /*
       * Components with defined schema have already been merged in at register time
       * but a few components define attributes that apply only to xaxis
       * not yaxis (rangeselector, rangeslider) - delete from y schema.
       * Note that the input attributes for xaxis/yaxis are the same object
       * so it's not possible to only add them to xaxis from the start.
       * If we ever have such asymmetry the other way, or anywhere else,
       * we will need to extend both this code and mergeComponentAttrsToSubplot
       * (which will not find yaxis only for example)
       */
      var subplots = schema.subplots;
      if (subplots && subplots.xaxis && !subplots.yaxis) {
        for (var xkey in subplots.xaxis) {
          delete layoutAttributes.yaxis[xkey];
        }
      }

      /*
       * Also some attributes e.g. shift & autoshift only implemented on the yaxis
       * at the moment. Remove them from the xaxis.
      */
      delete layoutAttributes.xaxis.shift;
      delete layoutAttributes.xaxis.autoshift;
    } else if (_module.name === 'colorscale') {
      extendDeepAll(layoutAttributes, _module.layoutAttributes);
    } else if (_module.layoutAttributes) {
      // older style without schema need to be explicitly merged in now
      insertAttrs(layoutAttributes, _module.layoutAttributes, _module.name);
    }
  }
  return {
    layoutAttributes: formatAttributes(layoutAttributes)
  };
}
function getTransformAttributes(type) {
  var _module = Registry.transformsRegistry[type];
  var attributes = extendDeepAll({}, _module.attributes);

  // add registered components transform attributes
  Object.keys(Registry.componentsRegistry).forEach(function (k) {
    var _module = Registry.componentsRegistry[k];
    if (_module.schema && _module.schema.transforms && _module.schema.transforms[type]) {
      Object.keys(_module.schema.transforms[type]).forEach(function (v) {
        insertAttrs(attributes, _module.schema.transforms[type][v], v);
      });
    }
  });
  return {
    attributes: formatAttributes(attributes)
  };
}
function getFramesAttributes() {
  var attrs = {
    frames: extendDeepAll({}, frameAttributes)
  };
  formatAttributes(attrs);
  return attrs.frames;
}
function formatAttributes(attrs) {
  mergeValTypeAndRole(attrs);
  formatArrayContainers(attrs);
  stringify(attrs);
  return attrs;
}
function mergeValTypeAndRole(attrs) {
  function makeSrcAttr(attrName) {
    return {
      valType: 'string',
      editType: 'none'
    };
  }
  function callback(attr, attrName, attrs) {
    if (exports.isValObject(attr)) {
      if (attr.arrayOk === true || attr.valType === 'data_array') {
        // all 'arrayOk' and 'data_array' attrs have a corresponding 'src' attr
        attrs[attrName + 'src'] = makeSrcAttr(attrName);
      }
    } else if (isPlainObject(attr)) {
      // all attrs container objects get role 'object'
      attr.role = 'object';
    }
  }
  exports.crawl(attrs, callback);
}
function formatArrayContainers(attrs) {
  function callback(attr, attrName, attrs) {
    if (!attr) return;
    var itemName = attr[IS_LINKED_TO_ARRAY];
    if (!itemName) return;
    delete attr[IS_LINKED_TO_ARRAY];
    attrs[attrName] = {
      items: {}
    };
    attrs[attrName].items[itemName] = attr;
    attrs[attrName].role = 'object';
  }
  exports.crawl(attrs, callback);
}

// this can take around 10ms and should only be run from PlotSchema.get(),
// to ensure JSON.stringify(PlotSchema.get()) gives the intended result.
function stringify(attrs) {
  function walk(attr) {
    for (var k in attr) {
      if (isPlainObject(attr[k])) {
        walk(attr[k]);
      } else if (Array.isArray(attr[k])) {
        for (var i = 0; i < attr[k].length; i++) {
          walk(attr[k][i]);
        }
      } else {
        // as JSON.stringify(/test/) // => {}
        if (attr[k] instanceof RegExp) {
          attr[k] = attr[k].toString();
        }
      }
    }
  }
  walk(attrs);
}
function handleBasePlotModule(layoutAttributes, _module, astr) {
  var np = nestedProperty(layoutAttributes, astr);
  var attrs = extendDeepAll({}, _module.layoutAttributes);
  attrs[IS_SUBPLOT_OBJ] = true;
  np.set(attrs);
}
function insertAttrs(baseAttrs, newAttrs, astr) {
  var np = nestedProperty(baseAttrs, astr);
  np.set(extendDeepAll(np.get() || {}, newAttrs));
}

/***/ }),

/***/ 78032:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var plotAttributes = __webpack_require__(9829);
var TEMPLATEITEMNAME = 'templateitemname';
var templateAttrs = {
  name: {
    valType: 'string',
    editType: 'none'
  }
};
templateAttrs[TEMPLATEITEMNAME] = {
  valType: 'string',
  editType: 'calc'
};

/**
 * templatedArray: decorate an attributes object with templating (and array)
 * properties.
 *
 * @param {string} name: the singular form of the array name. Sets
 *     `_isLinkedToArray` to this, so the schema knows to treat this as an array.
 * @param {object} attrs: the item attributes. Since all callers are expected
 *     to be constructing this object on the spot, we mutate it here for
 *     performance, rather than extending a new object with it.
 *
 * @returns {object}: the decorated `attrs` object
 */
exports.templatedArray = function (name, attrs) {
  attrs._isLinkedToArray = name;
  attrs.name = templateAttrs.name;
  attrs[TEMPLATEITEMNAME] = templateAttrs[TEMPLATEITEMNAME];
  return attrs;
};

/**
 * traceTemplater: logic for matching traces to trace templates
 *
 * @param {object} dataTemplate: collection of {traceType: [{template}, ...]}
 *     ie each type the template applies to contains a list of template objects,
 *     to be provided cyclically to data traces of that type.
 *
 * @returns {object}: {newTrace}, a function:
 *     newTrace(traceIn): that takes the input traceIn, coerces its type, then
 *         uses that type to find the next template to apply. returns the output
 *         traceOut with template attached, ready to continue supplyDefaults.
 */
exports.traceTemplater = function (dataTemplate) {
  var traceCounts = {};
  var traceType, typeTemplates;
  for (traceType in dataTemplate) {
    typeTemplates = dataTemplate[traceType];
    if (Array.isArray(typeTemplates) && typeTemplates.length) {
      traceCounts[traceType] = 0;
    }
  }
  function newTrace(traceIn) {
    traceType = Lib.coerce(traceIn, {}, plotAttributes, 'type');
    var traceOut = {
      type: traceType,
      _template: null
    };
    if (traceType in traceCounts) {
      typeTemplates = dataTemplate[traceType];
      // cycle through traces in the template set for this type
      var typei = traceCounts[traceType] % typeTemplates.length;
      traceCounts[traceType]++;
      traceOut._template = typeTemplates[typei];
    } else {
      // TODO: anything we should do for types missing from the template?
      // try to apply some other type? Or just bail as we do here?
      // Actually I think yes, we should apply other types; would be nice
      // if all scatter* could inherit from each other, and if histogram
      // could inherit from bar, etc... but how to specify this? And do we
      // compose them, or if a type is present require it to be complete?
      // Actually this could apply to layout too - 3D annotations
      // inheriting from 2D, axes of different types inheriting from each
      // other...
    }
    return traceOut;
  }
  return {
    newTrace: newTrace
    // TODO: function to figure out what's left & what didn't work
  };
};

/**
 * newContainer: Create a new sub-container inside `container` and propagate any
 * applicable template to it. If there's no template, still propagates
 * `undefined` so relinkPrivate will not retain an old template!
 *
 * @param {object} container: the outer container, should already have _template
 *     if there *is* a template for this plot
 * @param {string} name: the key of the new container to make
 * @param {string} baseName: if applicable, a base attribute to take the
 *     template from, ie for xaxis3 the base would be xaxis
 *
 * @returns {object}: an object for inclusion _full*, empty except for the
 *     appropriate template piece
 */
exports.newContainer = function (container, name, baseName) {
  var template = container._template;
  var part = template && (template[name] || baseName && template[baseName]);
  if (!Lib.isPlainObject(part)) part = null;
  var out = container[name] = {
    _template: part
  };
  return out;
};

/**
 * arrayTemplater: special logic for templating both defaults and specific items
 * in a container array (annotations etc)
 *
 * @param {object} container: the outer container, should already have _template
 *     if there *is* a template for this plot
 * @param {string} name: the name of the array to template (ie 'annotations')
 *     will be used to find default ('annotationdefaults' object) and specific
 *     ('annotations' array) template specs.
 * @param {string} inclusionAttr: the attribute determining this item's
 *     inclusion in the output, usually 'visible' or 'enabled'
 *
 * @returns {object}: {newItem, defaultItems}, both functions:
 *     newItem(itemIn): create an output item, bare except for the correct
 *         template and name(s), as the base for supplyDefaults
 *     defaultItems(): to be called after all newItem calls, return any
 *         specific template items that have not already beeen included,
 *         also as bare output items ready for supplyDefaults.
 */
exports.arrayTemplater = function (container, name, inclusionAttr) {
  var template = container._template;
  var defaultsTemplate = template && template[arrayDefaultKey(name)];
  var templateItems = template && template[name];
  if (!Array.isArray(templateItems) || !templateItems.length) {
    templateItems = [];
  }
  var usedNames = {};
  function newItem(itemIn) {
    // include name and templateitemname in the output object for ALL
    // container array items. Note: you could potentially use different
    // name and templateitemname, if you're using one template to make
    // another template. templateitemname would be the name in the original
    // template, and name is the new "subclassed" item name.
    var out = {
      name: itemIn.name,
      _input: itemIn
    };
    var templateItemName = out[TEMPLATEITEMNAME] = itemIn[TEMPLATEITEMNAME];

    // no itemname: use the default template
    if (!validItemName(templateItemName)) {
      out._template = defaultsTemplate;
      return out;
    }

    // look for an item matching this itemname
    // note these do not inherit from the default template, only the item.
    for (var i = 0; i < templateItems.length; i++) {
      var templateItem = templateItems[i];
      if (templateItem.name === templateItemName) {
        // Note: it's OK to use a template item more than once
        // but using it at least once will stop it from generating
        // a default item at the end.
        usedNames[templateItemName] = 1;
        out._template = templateItem;
        return out;
      }
    }

    // Didn't find a matching template item, so since this item is intended
    // to only be modifications it's most likely broken. Hide it unless
    // it's explicitly marked visible - in which case it gets NO template,
    // not even the default.
    out[inclusionAttr] = itemIn[inclusionAttr] || false;
    // special falsy value we can look for in validateTemplate
    out._template = false;
    return out;
  }
  function defaultItems() {
    var out = [];
    for (var i = 0; i < templateItems.length; i++) {
      var templateItem = templateItems[i];
      var name = templateItem.name;
      // only allow named items to be added as defaults,
      // and only allow each name once
      if (validItemName(name) && !usedNames[name]) {
        var outi = {
          _template: templateItem,
          name: name,
          _input: {
            _templateitemname: name
          }
        };
        outi[TEMPLATEITEMNAME] = templateItem[TEMPLATEITEMNAME];
        out.push(outi);
        usedNames[name] = 1;
      }
    }
    return out;
  }
  return {
    newItem: newItem,
    defaultItems: defaultItems
  };
};
function validItemName(name) {
  return name && typeof name === 'string';
}
function arrayDefaultKey(name) {
  var lastChar = name.length - 1;
  if (name.charAt(lastChar) !== 's') {
    Lib.warn('bad argument to arrayDefaultKey: ' + name);
  }
  return name.substr(0, name.length - 1) + 'defaults';
}
exports.arrayDefaultKey = arrayDefaultKey;

/**
 * arrayEditor: helper for editing array items that may have come from
 *     template defaults (in which case they will not exist in the input yet)
 *
 * @param {object} parentIn: the input container (eg gd.layout)
 * @param {string} containerStr: the attribute string for the container inside
 *     `parentIn`.
 * @param {object} itemOut: the _full* item (eg gd._fullLayout.annotations[0])
 *     that we'll be editing. Assumed to have been created by `arrayTemplater`.
 *
 * @returns {object}: {modifyBase, modifyItem, getUpdateObj, applyUpdate}, all functions:
 *     modifyBase(attr, value): Add an update that's *not* related to the item.
 *         `attr` is the full attribute string.
 *     modifyItem(attr, value): Add an update to the item. `attr` is just the
 *         portion of the attribute string inside the item.
 *     getUpdateObj(): Get the final constructed update object, to use in
 *         `restyle` or `relayout`. Also resets the update object in case this
 *         update was canceled.
 *     applyUpdate(attr, value): optionally add an update `attr: value`,
 *         then apply it to `parent` which should be the parent of `containerIn`,
 *         ie the object to which `containerStr` is the attribute string.
 */
exports.arrayEditor = function (parentIn, containerStr, itemOut) {
  var lengthIn = (Lib.nestedProperty(parentIn, containerStr).get() || []).length;
  var index = itemOut._index;
  // Check that we are indeed off the end of this container.
  // Otherwise a devious user could put a key `_templateitemname` in their
  // own input and break lots of things.
  var templateItemName = index >= lengthIn && (itemOut._input || {})._templateitemname;
  if (templateItemName) index = lengthIn;
  var itemStr = containerStr + '[' + index + ']';
  var update;
  function resetUpdate() {
    update = {};
    if (templateItemName) {
      update[itemStr] = {};
      update[itemStr][TEMPLATEITEMNAME] = templateItemName;
    }
  }
  resetUpdate();
  function modifyBase(attr, value) {
    update[attr] = value;
  }
  function modifyItem(attr, value) {
    if (templateItemName) {
      // we're making a new object: edit that object
      Lib.nestedProperty(update[itemStr], attr).set(value);
    } else {
      // we're editing an existing object: include *just* the edit
      update[itemStr + '.' + attr] = value;
    }
  }
  function getUpdateObj() {
    var updateOut = update;
    resetUpdate();
    return updateOut;
  }
  function applyUpdate(attr, value) {
    if (attr) modifyItem(attr, value);
    var updateToApply = getUpdateObj();
    for (var key in updateToApply) {
      Lib.nestedProperty(parentIn, key).set(updateToApply[key]);
    }
  }
  return {
    modifyBase: modifyBase,
    modifyItem: modifyItem,
    getUpdateObj: getUpdateObj,
    applyUpdate: applyUpdate
  };
};

/***/ }),

/***/ 71817:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var Registry = __webpack_require__(33626);
var Plots = __webpack_require__(44122);
var Lib = __webpack_require__(34809);
var svgTextUtils = __webpack_require__(30635);
var clearGlCanvases = __webpack_require__(34823);
var Color = __webpack_require__(78766);
var Drawing = __webpack_require__(62203);
var Titles = __webpack_require__(17240);
var ModeBar = __webpack_require__(95433);
var Axes = __webpack_require__(29714);
var alignmentConstants = __webpack_require__(4530);
var axisConstraints = __webpack_require__(84391);
var enforceAxisConstraints = axisConstraints.enforce;
var cleanAxisConstraints = axisConstraints.clean;
var doAutoRange = (__webpack_require__(32919).doAutoRange);
var SVG_TEXT_ANCHOR_START = 'start';
var SVG_TEXT_ANCHOR_MIDDLE = 'middle';
var SVG_TEXT_ANCHOR_END = 'end';
var zindexSeparator = (__webpack_require__(54826).zindexSeparator);
exports.layoutStyles = function (gd) {
  return Lib.syncOrAsync([Plots.doAutoMargin, lsInner], gd);
};
function overlappingDomain(xDomain, yDomain, domains) {
  for (var i = 0; i < domains.length; i++) {
    var existingX = domains[i][0];
    var existingY = domains[i][1];
    if (existingX[0] >= xDomain[1] || existingX[1] <= xDomain[0]) {
      continue;
    }
    if (existingY[0] < yDomain[1] && existingY[1] > yDomain[0]) {
      return true;
    }
  }
  return false;
}
function lsInner(gd) {
  var fullLayout = gd._fullLayout;
  var gs = fullLayout._size;
  var pad = gs.p;
  var axList = Axes.list(gd, '', true);
  var i, subplot, plotinfo, ax, xa, ya;

  // Set the width and height of the paper div ('.svg-container') in
  // accordance with the users configuration and layout. 
  // If the plot is responsive and the user has not set a width/height, then
  // the width/height of the paper div is set to 100% to fill the parent
  // container. 
  // We can't leave the height or width unset because all of the contents of
  // the paper div are positioned absolutely (and will therefore not take up
  // any space).
  fullLayout._paperdiv.style({
    width: gd._context.responsive && fullLayout.autosize && !gd._context._hasZeroWidth && !gd.layout.width ? '100%' : fullLayout.width + 'px',
    height: gd._context.responsive && fullLayout.autosize && !gd._context._hasZeroHeight && !gd.layout.height ? '100%' : fullLayout.height + 'px'
  }).selectAll('.main-svg').call(Drawing.setSize, fullLayout.width, fullLayout.height);
  gd._context.setBackground(gd, fullLayout.paper_bgcolor);
  exports.drawMainTitle(gd);
  ModeBar.manage(gd);

  // _has('cartesian') means SVG specifically, not GL2D - but GL2D
  // can still get here because it makes some of the SVG structure
  // for shared features like selections.
  if (!fullLayout._has('cartesian')) {
    return Plots.previousPromises(gd);
  }
  function getLinePosition(ax, counterAx, side) {
    var lwHalf = ax._lw / 2;
    if (ax._id.charAt(0) === 'x') {
      if (!counterAx) return gs.t + gs.h * (1 - (ax.position || 0)) + lwHalf % 1;else if (side === 'top') return counterAx._offset - pad - lwHalf;
      return counterAx._offset + counterAx._length + pad + lwHalf;
    }
    if (!counterAx) return gs.l + gs.w * (ax.position || 0) + lwHalf % 1;else if (side === 'right') return counterAx._offset + counterAx._length + pad + lwHalf;
    return counterAx._offset - pad - lwHalf;
  }

  // some preparation of axis position info
  for (i = 0; i < axList.length; i++) {
    ax = axList[i];
    var counterAx = ax._anchorAxis;

    // clear axis line positions, to be set in the subplot loop below
    ax._linepositions = {};

    // stash crispRounded linewidth so we don't need to pass gd all over the place
    ax._lw = Drawing.crispRound(gd, ax.linewidth, 1);

    // figure out the main axis line and main mirror line position.
    // it's easier to follow the logic if we handle these separately from
    // ax._linepositions, which are only used by mirror=allticks
    // for non-main-subplot ticks, and mirror=all(ticks)? for zero line
    // hiding logic
    ax._mainLinePosition = getLinePosition(ax, counterAx, ax.side);
    ax._mainMirrorPosition = ax.mirror && counterAx ? getLinePosition(ax, counterAx, alignmentConstants.OPPOSITE_SIDE[ax.side]) : null;
  }

  // figure out which backgrounds we need to draw,
  // and in which layers to put them
  var lowerBackgroundIDs = [];
  var backgroundIds = [];
  var lowerDomains = [];
  // no need to draw background when paper and plot color are the same color,
  // activate mode just for large splom (which benefit the most from this
  // optimization), but this could apply to all cartesian subplots.
  var noNeedForBg = Color.opacity(fullLayout.paper_bgcolor) === 1 && Color.opacity(fullLayout.plot_bgcolor) === 1 && fullLayout.paper_bgcolor === fullLayout.plot_bgcolor;
  for (subplot in fullLayout._plots) {
    plotinfo = fullLayout._plots[subplot];
    if (plotinfo.mainplot) {
      // mainplot is a reference to the main plot this one is overlaid on
      // so if it exists, this is an overlaid plot and we don't need to
      // give it its own background
      if (plotinfo.bg) {
        plotinfo.bg.remove();
      }
      plotinfo.bg = undefined;
    } else {
      var xDomain = plotinfo.xaxis.domain;
      var yDomain = plotinfo.yaxis.domain;
      var plotgroup = plotinfo.plotgroup;
      if (overlappingDomain(xDomain, yDomain, lowerDomains) && subplot.indexOf(zindexSeparator) === -1) {
        var pgNode = plotgroup.node();
        var plotgroupBg = plotinfo.bg = Lib.ensureSingle(plotgroup, 'rect', 'bg');
        pgNode.insertBefore(plotgroupBg.node(), pgNode.childNodes[0]);
        backgroundIds.push(subplot);
      } else {
        plotgroup.select('rect.bg').remove();
        lowerDomains.push([xDomain, yDomain]);
        if (!noNeedForBg) {
          lowerBackgroundIDs.push(subplot);
          backgroundIds.push(subplot);
        }
      }
    }
  }

  // now create all the lower-layer backgrounds at once now that
  // we have the list of subplots that need them
  var lowerBackgrounds = fullLayout._bgLayer.selectAll('.bg').data(lowerBackgroundIDs);
  lowerBackgrounds.enter().append('rect').classed('bg', true);
  lowerBackgrounds.exit().remove();
  lowerBackgrounds.each(function (subplot) {
    fullLayout._plots[subplot].bg = d3.select(this);
  });

  // style all backgrounds
  for (i = 0; i < backgroundIds.length; i++) {
    plotinfo = fullLayout._plots[backgroundIds[i]];
    xa = plotinfo.xaxis;
    ya = plotinfo.yaxis;
    if (plotinfo.bg && xa._offset !== undefined && ya._offset !== undefined) {
      plotinfo.bg.call(Drawing.setRect, xa._offset - pad, ya._offset - pad, xa._length + 2 * pad, ya._length + 2 * pad).call(Color.fill, fullLayout.plot_bgcolor).style('stroke-width', 0);
    }
  }
  if (!fullLayout._hasOnlyLargeSploms) {
    for (subplot in fullLayout._plots) {
      plotinfo = fullLayout._plots[subplot];
      xa = plotinfo.xaxis;
      ya = plotinfo.yaxis;

      // Clip so that data only shows up on the plot area.
      var clipId = plotinfo.clipId = 'clip' + fullLayout._uid + subplot + 'plot';
      var plotClip = Lib.ensureSingleById(fullLayout._clips, 'clipPath', clipId, function (s) {
        s.classed('plotclip', true).append('rect');
      });
      plotinfo.clipRect = plotClip.select('rect').attr({
        width: xa._length,
        height: ya._length
      });
      Drawing.setTranslate(plotinfo.plot, xa._offset, ya._offset);
      var plotClipId;
      var layerClipId;
      if (plotinfo._hasClipOnAxisFalse) {
        plotClipId = null;
        layerClipId = clipId;
      } else {
        plotClipId = clipId;
        layerClipId = null;
      }
      Drawing.setClipUrl(plotinfo.plot, plotClipId, gd);

      // stash layer clipId value (null or same as clipId)
      // to DRY up Drawing.setClipUrl calls on trace-module and trace layers
      // downstream
      plotinfo.layerClipId = layerClipId;
    }
  }
  var xLinesXLeft, xLinesXRight, xLinesYBottom, xLinesYTop, leftYLineWidth, rightYLineWidth;
  var yLinesYBottom, yLinesYTop, yLinesXLeft, yLinesXRight, connectYBottom, connectYTop;
  var extraSubplot;
  function xLinePath(y) {
    return 'M' + xLinesXLeft + ',' + y + 'H' + xLinesXRight;
  }
  function xLinePathFree(y) {
    return 'M' + xa._offset + ',' + y + 'h' + xa._length;
  }
  function yLinePath(x) {
    return 'M' + x + ',' + yLinesYTop + 'V' + yLinesYBottom;
  }
  function yLinePathFree(x) {
    if (ya._shift !== undefined) {
      x += ya._shift;
    }
    return 'M' + x + ',' + ya._offset + 'v' + ya._length;
  }
  function mainPath(ax, pathFn, pathFnFree) {
    if (!ax.showline || subplot !== ax._mainSubplot) return '';
    if (!ax._anchorAxis) return pathFnFree(ax._mainLinePosition);
    var out = pathFn(ax._mainLinePosition);
    if (ax.mirror) out += pathFn(ax._mainMirrorPosition);
    return out;
  }
  for (subplot in fullLayout._plots) {
    plotinfo = fullLayout._plots[subplot];
    xa = plotinfo.xaxis;
    ya = plotinfo.yaxis;

    /*
     * x lines get longer where they meet y lines, to make a crisp corner.
     * The x lines get the padding (margin.pad) plus the y line width to
     * fill up the corner nicely. Free x lines are excluded - they always
     * span exactly the data area of the plot
     *
     *  | XXXXX
     *  | XXXXX
     *  |
     *  +------
     *     x1
     *    -----
     *     x2
     */
    var xPath = 'M0,0';
    if (shouldShowLinesOrTicks(xa, subplot)) {
      leftYLineWidth = findCounterAxisLineWidth(xa, 'left', ya, axList);
      xLinesXLeft = xa._offset - (leftYLineWidth ? pad + leftYLineWidth : 0);
      rightYLineWidth = findCounterAxisLineWidth(xa, 'right', ya, axList);
      xLinesXRight = xa._offset + xa._length + (rightYLineWidth ? pad + rightYLineWidth : 0);
      xLinesYBottom = getLinePosition(xa, ya, 'bottom');
      xLinesYTop = getLinePosition(xa, ya, 'top');

      // save axis line positions for extra ticks to reference
      // each subplot that gets ticks from "allticks" gets an entry:
      //    [left or bottom, right or top]
      extraSubplot = !xa._anchorAxis || subplot !== xa._mainSubplot;
      if (extraSubplot && (xa.mirror === 'allticks' || xa.mirror === 'all')) {
        xa._linepositions[subplot] = [xLinesYBottom, xLinesYTop];
      }
      xPath = mainPath(xa, xLinePath, xLinePathFree);
      if (extraSubplot && xa.showline && (xa.mirror === 'all' || xa.mirror === 'allticks')) {
        xPath += xLinePath(xLinesYBottom) + xLinePath(xLinesYTop);
      }
      plotinfo.xlines.style('stroke-width', xa._lw + 'px').call(Color.stroke, xa.showline ? xa.linecolor : 'rgba(0,0,0,0)');
    }
    plotinfo.xlines.attr('d', xPath);

    /*
     * y lines that meet x axes get longer only by margin.pad, because
     * the x axes fill in the corner space. Free y axes, like free x axes,
     * always span exactly the data area of the plot
     *
     *   |   | XXXX
     * y2| y1| XXXX
     *   |   | XXXX
     *       |
     *       +-----
     */
    var yPath = 'M0,0';
    if (shouldShowLinesOrTicks(ya, subplot)) {
      connectYBottom = findCounterAxisLineWidth(ya, 'bottom', xa, axList);
      yLinesYBottom = ya._offset + ya._length + (connectYBottom ? pad : 0);
      connectYTop = findCounterAxisLineWidth(ya, 'top', xa, axList);
      yLinesYTop = ya._offset - (connectYTop ? pad : 0);
      yLinesXLeft = getLinePosition(ya, xa, 'left');
      yLinesXRight = getLinePosition(ya, xa, 'right');
      extraSubplot = !ya._anchorAxis || subplot !== ya._mainSubplot;
      if (extraSubplot && (ya.mirror === 'allticks' || ya.mirror === 'all')) {
        ya._linepositions[subplot] = [yLinesXLeft, yLinesXRight];
      }
      yPath = mainPath(ya, yLinePath, yLinePathFree);
      if (extraSubplot && ya.showline && (ya.mirror === 'all' || ya.mirror === 'allticks')) {
        yPath += yLinePath(yLinesXLeft) + yLinePath(yLinesXRight);
      }
      plotinfo.ylines.style('stroke-width', ya._lw + 'px').call(Color.stroke, ya.showline ? ya.linecolor : 'rgba(0,0,0,0)');
    }
    plotinfo.ylines.attr('d', yPath);
  }
  Axes.makeClipPaths(gd);
  return Plots.previousPromises(gd);
}
function shouldShowLinesOrTicks(ax, subplot) {
  return (ax.ticks || ax.showline) && (subplot === ax._mainSubplot || ax.mirror === 'all' || ax.mirror === 'allticks');
}

/*
 * should we draw a line on counterAx at this side of ax?
 * It's assumed that counterAx is known to overlay the subplot we're working on
 * but it may not be its main axis.
 */
function shouldShowLineThisSide(ax, side, counterAx) {
  // does counterAx get a line at all?
  if (!counterAx.showline || !counterAx._lw) return false;

  // are we drawing *all* lines for counterAx?
  if (counterAx.mirror === 'all' || counterAx.mirror === 'allticks') return true;
  var anchorAx = counterAx._anchorAxis;

  // is this a free axis? free axes can only have a subplot side-line with all(ticks)? mirroring
  if (!anchorAx) return false;

  // in order to handle cases where the user forgot to anchor this axis correctly
  // (because its default anchor has the same domain on the relevant end)
  // check whether the relevant position is the same.
  var sideIndex = alignmentConstants.FROM_BL[side];
  if (counterAx.side === side) {
    return anchorAx.domain[sideIndex] === ax.domain[sideIndex];
  }
  return counterAx.mirror && anchorAx.domain[1 - sideIndex] === ax.domain[1 - sideIndex];
}

/*
 * Is there another axis intersecting `side` end of `ax`?
 * First look at `counterAx` (the axis for this subplot),
 * then at all other potential counteraxes on or overlaying this subplot.
 * Take the line width from the first one that has a line.
 */
function findCounterAxisLineWidth(ax, side, counterAx, axList) {
  if (shouldShowLineThisSide(ax, side, counterAx)) {
    return counterAx._lw;
  }
  for (var i = 0; i < axList.length; i++) {
    var axi = axList[i];
    if (axi._mainAxis === counterAx._mainAxis && shouldShowLineThisSide(ax, side, axi)) {
      return axi._lw;
    }
  }
  return 0;
}
exports.drawMainTitle = function (gd) {
  var title = gd._fullLayout.title;
  var fullLayout = gd._fullLayout;
  var textAnchor = getMainTitleTextAnchor(fullLayout);
  var dy = getMainTitleDy(fullLayout);
  var y = getMainTitleY(fullLayout, dy);
  var x = getMainTitleX(fullLayout, textAnchor);
  Titles.draw(gd, 'gtitle', {
    propContainer: fullLayout,
    propName: 'title.text',
    subtitlePropName: 'title.subtitle.text',
    placeholder: fullLayout._dfltTitle.plot,
    subtitlePlaceholder: fullLayout._dfltTitle.subtitle,
    attributes: {
      x: x,
      y: y,
      'text-anchor': textAnchor,
      dy: dy
    }
  });
  if (title.text && title.automargin) {
    var titleObj = d3.selectAll('.gtitle');
    var titleHeight = Drawing.bBox(d3.selectAll('.g-gtitle').node()).height;
    var pushMargin = needsMarginPush(gd, title, titleHeight);
    if (pushMargin > 0) {
      applyTitleAutoMargin(gd, y, pushMargin, titleHeight);
      // Re-position the title once we know where it needs to be
      titleObj.attr({
        x: x,
        y: y,
        'text-anchor': textAnchor,
        dy: getMainTitleDyAdj(title.yanchor)
      }).call(svgTextUtils.positionText, x, y);
      var extraLines = (title.text.match(svgTextUtils.BR_TAG_ALL) || []).length;
      if (extraLines) {
        var delta = alignmentConstants.LINE_SPACING * extraLines + alignmentConstants.MID_SHIFT;
        if (title.y === 0) {
          delta = -delta;
        }
        titleObj.selectAll('.line').each(function () {
          var newDy = +this.getAttribute('dy').slice(0, -2) - delta + 'em';
          this.setAttribute('dy', newDy);
        });
      }

      // If there is a subtitle
      var subtitleObj = d3.selectAll('.gtitle-subtitle');
      if (subtitleObj.node()) {
        // Get bottom edge of title bounding box
        var titleBB = titleObj.node().getBBox();
        var titleBottom = titleBB.y + titleBB.height;
        var subtitleY = titleBottom + Titles.SUBTITLE_PADDING_EM * title.subtitle.font.size;
        subtitleObj.attr({
          x: x,
          y: subtitleY,
          'text-anchor': textAnchor,
          dy: getMainTitleDyAdj(title.yanchor)
        }).call(svgTextUtils.positionText, x, subtitleY);
      }
    }
  }
};
function isOutsideContainer(gd, title, position, y, titleHeight) {
  var plotHeight = title.yref === 'paper' ? gd._fullLayout._size.h : gd._fullLayout.height;
  var yPosTop = Lib.isTopAnchor(title) ? y : y - titleHeight; // Standardize to the top of the title
  var yPosRel = position === 'b' ? plotHeight - yPosTop : yPosTop; // Position relative to the top or bottom of plot
  if (Lib.isTopAnchor(title) && position === 't' || Lib.isBottomAnchor(title) && position === 'b') {
    return false;
  } else {
    return yPosRel < titleHeight;
  }
}
function containerPushVal(position, titleY, titleYanchor, height, titleDepth) {
  var push = 0;
  if (titleYanchor === 'middle') {
    push += titleDepth / 2;
  }
  if (position === 't') {
    if (titleYanchor === 'top') {
      push += titleDepth;
    }
    push += height - titleY * height;
  } else {
    if (titleYanchor === 'bottom') {
      push += titleDepth;
    }
    push += titleY * height;
  }
  return push;
}
function needsMarginPush(gd, title, titleHeight) {
  var titleY = title.y;
  var titleYanchor = title.yanchor;
  var position = titleY > 0.5 ? 't' : 'b';
  var curMargin = gd._fullLayout.margin[position];
  var pushMargin = 0;
  if (title.yref === 'paper') {
    pushMargin = titleHeight + title.pad.t + title.pad.b;
  } else if (title.yref === 'container') {
    pushMargin = containerPushVal(position, titleY, titleYanchor, gd._fullLayout.height, titleHeight) + title.pad.t + title.pad.b;
  }
  if (pushMargin > curMargin) {
    return pushMargin;
  }
  return 0;
}
function applyTitleAutoMargin(gd, y, pushMargin, titleHeight) {
  var titleID = 'title.automargin';
  var title = gd._fullLayout.title;
  var position = title.y > 0.5 ? 't' : 'b';
  var push = {
    x: title.x,
    y: title.y,
    t: 0,
    b: 0
  };
  var reservedPush = {};
  if (title.yref === 'paper' && isOutsideContainer(gd, title, position, y, titleHeight)) {
    push[position] = pushMargin;
  } else if (title.yref === 'container') {
    reservedPush[position] = pushMargin;
    gd._fullLayout._reservedMargin[titleID] = reservedPush;
  }
  Plots.allowAutoMargin(gd, titleID);
  Plots.autoMargin(gd, titleID, push);
}
function getMainTitleX(fullLayout, textAnchor) {
  var title = fullLayout.title;
  var gs = fullLayout._size;
  var hPadShift = 0;
  if (textAnchor === SVG_TEXT_ANCHOR_START) {
    hPadShift = title.pad.l;
  } else if (textAnchor === SVG_TEXT_ANCHOR_END) {
    hPadShift = -title.pad.r;
  }
  switch (title.xref) {
    case 'paper':
      return gs.l + gs.w * title.x + hPadShift;
    case 'container':
    default:
      return fullLayout.width * title.x + hPadShift;
  }
}
function getMainTitleY(fullLayout, dy) {
  var title = fullLayout.title;
  var gs = fullLayout._size;
  var vPadShift = 0;
  if (dy === '0em' || !dy) {
    vPadShift = -title.pad.b;
  } else if (dy === alignmentConstants.CAP_SHIFT + 'em') {
    vPadShift = title.pad.t;
  }
  if (title.y === 'auto') {
    return gs.t / 2;
  } else {
    switch (title.yref) {
      case 'paper':
        return gs.t + gs.h - gs.h * title.y + vPadShift;
      case 'container':
      default:
        return fullLayout.height - fullLayout.height * title.y + vPadShift;
    }
  }
}
function getMainTitleDyAdj(yanchor) {
  if (yanchor === 'top') {
    return alignmentConstants.CAP_SHIFT + 0.3 + 'em';
  } else if (yanchor === 'bottom') {
    return '-0.3em';
  } else {
    return alignmentConstants.MID_SHIFT + 'em';
  }
}
function getMainTitleTextAnchor(fullLayout) {
  var title = fullLayout.title;
  var textAnchor = SVG_TEXT_ANCHOR_MIDDLE;
  if (Lib.isRightAnchor(title)) {
    textAnchor = SVG_TEXT_ANCHOR_END;
  } else if (Lib.isLeftAnchor(title)) {
    textAnchor = SVG_TEXT_ANCHOR_START;
  }
  return textAnchor;
}
function getMainTitleDy(fullLayout) {
  var title = fullLayout.title;
  var dy = '0em';
  if (Lib.isTopAnchor(title)) {
    dy = alignmentConstants.CAP_SHIFT + 'em';
  } else if (Lib.isMiddleAnchor(title)) {
    dy = alignmentConstants.MID_SHIFT + 'em';
  }
  return dy;
}
exports.doTraceStyle = function (gd) {
  var calcdata = gd.calcdata;
  var editStyleCalls = [];
  var i;
  for (i = 0; i < calcdata.length; i++) {
    var cd = calcdata[i];
    var cd0 = cd[0] || {};
    var trace = cd0.trace || {};
    var _module = trace._module || {};

    // See if we need to do arraysToCalcdata
    // call it regardless of what change we made, in case
    // supplyDefaults brought in an array that was already
    // in gd.data but not in gd._fullData previously
    var arraysToCalcdata = _module.arraysToCalcdata;
    if (arraysToCalcdata) arraysToCalcdata(cd, trace);
    var editStyle = _module.editStyle;
    if (editStyle) editStyleCalls.push({
      fn: editStyle,
      cd0: cd0
    });
  }
  if (editStyleCalls.length) {
    for (i = 0; i < editStyleCalls.length; i++) {
      var edit = editStyleCalls[i];
      edit.fn(gd, edit.cd0);
    }
    clearGlCanvases(gd);
    exports.redrawReglTraces(gd);
  }
  Plots.style(gd);
  Registry.getComponentMethod('legend', 'draw')(gd);
  return Plots.previousPromises(gd);
};
exports.doColorBars = function (gd) {
  Registry.getComponentMethod('colorbar', 'draw')(gd);
  return Plots.previousPromises(gd);
};

// force plot() to redo the layout and replot with the modified layout
exports.layoutReplot = function (gd) {
  var layout = gd.layout;
  gd.layout = undefined;
  return Registry.call('_doPlot', gd, '', layout);
};
exports.doLegend = function (gd) {
  Registry.getComponentMethod('legend', 'draw')(gd);
  return Plots.previousPromises(gd);
};
exports.doTicksRelayout = function (gd) {
  Axes.draw(gd, 'redraw');
  if (gd._fullLayout._hasOnlyLargeSploms) {
    Registry.subplotsRegistry.splom.updateGrid(gd);
    clearGlCanvases(gd);
    exports.redrawReglTraces(gd);
  }
  exports.drawMainTitle(gd);
  return Plots.previousPromises(gd);
};
exports.doModeBar = function (gd) {
  var fullLayout = gd._fullLayout;
  ModeBar.manage(gd);
  for (var i = 0; i < fullLayout._basePlotModules.length; i++) {
    var updateFx = fullLayout._basePlotModules[i].updateFx;
    if (updateFx) updateFx(gd);
  }
  return Plots.previousPromises(gd);
};
exports.doCamera = function (gd) {
  var fullLayout = gd._fullLayout;
  var sceneIds = fullLayout._subplots.gl3d;
  for (var i = 0; i < sceneIds.length; i++) {
    var sceneLayout = fullLayout[sceneIds[i]];
    var scene = sceneLayout._scene;
    scene.setViewport(sceneLayout);
  }
};
exports.drawData = function (gd) {
  var fullLayout = gd._fullLayout;
  clearGlCanvases(gd);

  // loop over the base plot modules present on graph
  var basePlotModules = fullLayout._basePlotModules;
  for (var i = 0; i < basePlotModules.length; i++) {
    basePlotModules[i].plot(gd);
  }
  exports.redrawReglTraces(gd);

  // styling separate from drawing
  Plots.style(gd);

  // draw components that can be drawn on axes,
  // and that do not push the margins
  Registry.getComponentMethod('selections', 'draw')(gd);
  Registry.getComponentMethod('shapes', 'draw')(gd);
  Registry.getComponentMethod('annotations', 'draw')(gd);
  Registry.getComponentMethod('images', 'draw')(gd);

  // Mark the first render as complete
  fullLayout._replotting = false;
  return Plots.previousPromises(gd);
};

// Draw (or redraw) all regl-based traces in one go,
// useful during drag and selection where buffers of targeted traces are updated,
// but all traces need to be redrawn following clearGlCanvases.
//
// Note that _module.plot for regl trace does NOT draw things
// on the canvas, they only update the buffers.
// Drawing is perform here.
//
// TODO try adding per-subplot option using gl.SCISSOR_TEST for
// non-overlaying, disjoint subplots.
//
// TODO try to include parcoords in here.
// https://github.com/plotly/plotly.js/issues/3069
exports.redrawReglTraces = function (gd) {
  var fullLayout = gd._fullLayout;
  if (fullLayout._has('regl')) {
    var fullData = gd._fullData;
    var cartesianIds = [];
    var polarIds = [];
    var i, sp;
    if (fullLayout._hasOnlyLargeSploms) {
      fullLayout._splomGrid.draw();
    }

    // N.B.
    // - Loop over fullData (not _splomScenes) to preserve splom trace-to-trace ordering
    // - Fill list if subplot ids (instead of fullLayout._subplots) to handle cases where all traces
    //   of a given module are `visible !== true`
    for (i = 0; i < fullData.length; i++) {
      var trace = fullData[i];
      if (trace.visible === true && trace._length !== 0) {
        if (trace.type === 'splom') {
          fullLayout._splomScenes[trace.uid].draw();
        } else if (trace.type === 'scattergl') {
          Lib.pushUnique(cartesianIds, trace.xaxis + trace.yaxis);
        } else if (trace.type === 'scatterpolargl') {
          Lib.pushUnique(polarIds, trace.subplot);
        }
      }
    }
    for (i = 0; i < cartesianIds.length; i++) {
      sp = fullLayout._plots[cartesianIds[i]];
      if (sp._scene) sp._scene.draw();
    }
    for (i = 0; i < polarIds.length; i++) {
      sp = fullLayout[polarIds[i]]._subplot;
      if (sp._scene) sp._scene.draw();
    }
  }
};
exports.doAutoRangeAndConstraints = function (gd) {
  var axList = Axes.list(gd, '', true);
  var ax;
  var autoRangeDone = {};
  for (var i = 0; i < axList.length; i++) {
    ax = axList[i];
    if (!autoRangeDone[ax._id]) {
      autoRangeDone[ax._id] = 1;
      cleanAxisConstraints(gd, ax);
      doAutoRange(gd, ax);

      // For matching axes, just propagate this autorange to the group.
      // The extra arg to doAutoRange avoids recalculating the range,
      // since doAutoRange by itself accounts for all matching axes. but
      // there are other side-effects of doAutoRange that we still want.
      var matchGroup = ax._matchGroup;
      if (matchGroup) {
        for (var id2 in matchGroup) {
          var ax2 = Axes.getFromId(gd, id2);
          doAutoRange(gd, ax2, ax.range);
          autoRangeDone[id2] = 1;
        }
      }
    }
  }
  enforceAxisConstraints(gd);
};

// An initial paint must be completed before these components can be
// correctly sized and the whole plot re-margined. fullLayout._replotting must
// be set to false before these will work properly.
exports.finalDraw = function (gd) {
  // TODO: rangesliders really belong in marginPushers but they need to be
  // drawn after data - can we at least get the margin pushing part separated
  // out and done earlier?
  Registry.getComponentMethod('rangeslider', 'draw')(gd);
  // TODO: rangeselector only needs to be here (in addition to drawMarginPushers)
  // because the margins need to be fully determined before we can call
  // autorange and update axis ranges (which rangeselector needs to know which
  // button is active). Can we break out its automargin step from its draw step?
  Registry.getComponentMethod('rangeselector', 'draw')(gd);
};
exports.drawMarginPushers = function (gd) {
  Registry.getComponentMethod('legend', 'draw')(gd);
  Registry.getComponentMethod('rangeselector', 'draw')(gd);
  Registry.getComponentMethod('sliders', 'draw')(gd);
  Registry.getComponentMethod('updatemenus', 'draw')(gd);
  Registry.getComponentMethod('colorbar', 'draw')(gd);
};

/***/ }),

/***/ 53853:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var isPlainObject = Lib.isPlainObject;
var PlotSchema = __webpack_require__(57297);
var Plots = __webpack_require__(44122);
var plotAttributes = __webpack_require__(9829);
var Template = __webpack_require__(78032);
var dfltConfig = (__webpack_require__(24452).dfltConfig);

/**
 * Plotly.makeTemplate: create a template off an existing figure to reuse
 * style attributes on other figures.
 *
 * Note: separated from the rest of templates because otherwise we get circular
 * references due to PlotSchema.
 *
 * @param {object|DOM element|string} figure: The figure to base the template on
 *     should contain a trace array `figure.data`
 *     and a layout object `figure.layout`
 * @returns {object} template: the extracted template - can then be used as
 *     `layout.template` in another figure.
 */
exports.makeTemplate = function (figure) {
  figure = Lib.isPlainObject(figure) ? figure : Lib.getGraphDiv(figure);
  figure = Lib.extendDeep({
    _context: dfltConfig
  }, {
    data: figure.data,
    layout: figure.layout
  });
  Plots.supplyDefaults(figure);
  var data = figure.data || [];
  var layout = figure.layout || {};
  // copy over a few items to help follow the schema
  layout._basePlotModules = figure._fullLayout._basePlotModules;
  layout._modules = figure._fullLayout._modules;
  var template = {
    data: {},
    layout: {}
  };

  /*
   * Note: we do NOT validate template values, we just take what's in the
   * user inputs data and layout, not the validated values in fullData and
   * fullLayout. Even if we were to validate here, there's no guarantee that
   * these values would still be valid when applied to a new figure, which
   * may contain different trace modes, different axes, etc. So it's
   * important that when applying a template we still validate the template
   * values, rather than just using them as defaults.
   */

  data.forEach(function (trace) {
    // TODO: What if no style info is extracted for this trace. We may
    // not want an empty object as the null value.
    // TODO: allow transforms to contribute to templates?
    // as it stands they are ignored, which may be for the best...

    var traceTemplate = {};
    walkStyleKeys(trace, traceTemplate, getTraceInfo.bind(null, trace));
    var traceType = Lib.coerce(trace, {}, plotAttributes, 'type');
    var typeTemplates = template.data[traceType];
    if (!typeTemplates) typeTemplates = template.data[traceType] = [];
    typeTemplates.push(traceTemplate);
  });
  walkStyleKeys(layout, template.layout, getLayoutInfo.bind(null, layout));

  /*
   * Compose the new template with an existing one to the same effect
   *
   * NOTE: there's a possibility of slightly different behavior: if the plot
   * has an invalid value and the old template has a valid value for the same
   * attribute, the plot will use the old template value but this routine
   * will pull the invalid value (resulting in the original default).
   * In the general case it's not possible to solve this with a single value,
   * since valid options can be context-dependent. It could be solved with
   * a *list* of values, but that would be huge complexity for little gain.
   */
  delete template.layout.template;
  var oldTemplate = layout.template;
  if (isPlainObject(oldTemplate)) {
    var oldLayoutTemplate = oldTemplate.layout;
    var i, traceType, oldTypeTemplates, oldTypeLen, typeTemplates, typeLen;
    if (isPlainObject(oldLayoutTemplate)) {
      mergeTemplates(oldLayoutTemplate, template.layout);
    }
    var oldDataTemplate = oldTemplate.data;
    if (isPlainObject(oldDataTemplate)) {
      for (traceType in template.data) {
        oldTypeTemplates = oldDataTemplate[traceType];
        if (Array.isArray(oldTypeTemplates)) {
          typeTemplates = template.data[traceType];
          typeLen = typeTemplates.length;
          oldTypeLen = oldTypeTemplates.length;
          for (i = 0; i < typeLen; i++) {
            mergeTemplates(oldTypeTemplates[i % oldTypeLen], typeTemplates[i]);
          }
          for (i = typeLen; i < oldTypeLen; i++) {
            typeTemplates.push(Lib.extendDeep({}, oldTypeTemplates[i]));
          }
        }
      }
      for (traceType in oldDataTemplate) {
        if (!(traceType in template.data)) {
          template.data[traceType] = Lib.extendDeep([], oldDataTemplate[traceType]);
        }
      }
    }
  }
  return template;
};
function mergeTemplates(oldTemplate, newTemplate) {
  // we don't care about speed here, just make sure we have a totally
  // distinct object from the previous template
  oldTemplate = Lib.extendDeep({}, oldTemplate);

  // sort keys so we always get annotationdefaults before annotations etc
  // so arrayTemplater will work right
  var oldKeys = Object.keys(oldTemplate).sort();
  var i, j;
  function mergeOne(oldVal, newVal, key) {
    if (isPlainObject(newVal) && isPlainObject(oldVal)) {
      mergeTemplates(oldVal, newVal);
    } else if (Array.isArray(newVal) && Array.isArray(oldVal)) {
      // Note: omitted `inclusionAttr` from arrayTemplater here,
      // it's irrelevant as we only want the resulting `_template`.
      var templater = Template.arrayTemplater({
        _template: oldTemplate
      }, key);
      for (j = 0; j < newVal.length; j++) {
        var item = newVal[j];
        var oldItem = templater.newItem(item)._template;
        if (oldItem) mergeTemplates(oldItem, item);
      }
      var defaultItems = templater.defaultItems();
      for (j = 0; j < defaultItems.length; j++) newVal.push(defaultItems[j]._template);

      // templateitemname only applies to receiving plots
      for (j = 0; j < newVal.length; j++) delete newVal[j].templateitemname;
    }
  }
  for (i = 0; i < oldKeys.length; i++) {
    var key = oldKeys[i];
    var oldVal = oldTemplate[key];
    if (key in newTemplate) {
      mergeOne(oldVal, newTemplate[key], key);
    } else newTemplate[key] = oldVal;

    // if this is a base key from the old template (eg xaxis), look for
    // extended keys (eg xaxis2) in the new template to merge into
    if (getBaseKey(key) === key) {
      for (var key2 in newTemplate) {
        var baseKey2 = getBaseKey(key2);
        if (key2 !== baseKey2 && baseKey2 === key && !(key2 in oldTemplate)) {
          mergeOne(oldVal, newTemplate[key2], key);
        }
      }
    }
  }
}
function getBaseKey(key) {
  return key.replace(/[0-9]+$/, '');
}
function walkStyleKeys(parent, templateOut, getAttributeInfo, path, basePath) {
  var pathAttr = basePath && getAttributeInfo(basePath);
  for (var key in parent) {
    var child = parent[key];
    var nextPath = getNextPath(parent, key, path);
    var nextBasePath = getNextPath(parent, key, basePath);
    var attr = getAttributeInfo(nextBasePath);
    if (!attr) {
      var baseKey = getBaseKey(key);
      if (baseKey !== key) {
        nextBasePath = getNextPath(parent, baseKey, basePath);
        attr = getAttributeInfo(nextBasePath);
      }
    }

    // we'll get an attr if path starts with a valid part, then has an
    // invalid ending. Make sure we got all the way to the end.
    if (pathAttr && pathAttr === attr) continue;
    if (!attr || attr._noTemplating || attr.valType === 'data_array' || attr.arrayOk && Array.isArray(child)) {
      continue;
    }
    if (!attr.valType && isPlainObject(child)) {
      walkStyleKeys(child, templateOut, getAttributeInfo, nextPath, nextBasePath);
    } else if (attr._isLinkedToArray && Array.isArray(child)) {
      var dfltDone = false;
      var namedIndex = 0;
      var usedNames = {};
      for (var i = 0; i < child.length; i++) {
        var item = child[i];
        if (isPlainObject(item)) {
          var name = item.name;
          if (name) {
            if (!usedNames[name]) {
              // named array items: allow all attributes except data arrays
              walkStyleKeys(item, templateOut, getAttributeInfo, getNextPath(child, namedIndex, nextPath), getNextPath(child, namedIndex, nextBasePath));
              namedIndex++;
              usedNames[name] = 1;
            }
          } else if (!dfltDone) {
            var dfltKey = Template.arrayDefaultKey(key);
            var dfltPath = getNextPath(parent, dfltKey, path);

            // getAttributeInfo will fail if we try to use dfltKey directly.
            // Instead put this item into the next array element, then
            // pull it out and move it to dfltKey.
            var pathInArray = getNextPath(child, namedIndex, nextPath);
            walkStyleKeys(item, templateOut, getAttributeInfo, pathInArray, getNextPath(child, namedIndex, nextBasePath));
            var itemPropInArray = Lib.nestedProperty(templateOut, pathInArray);
            var dfltProp = Lib.nestedProperty(templateOut, dfltPath);
            dfltProp.set(itemPropInArray.get());
            itemPropInArray.set(null);
            dfltDone = true;
          }
        }
      }
    } else {
      var templateProp = Lib.nestedProperty(templateOut, nextPath);
      templateProp.set(child);
    }
  }
}
function getLayoutInfo(layout, path) {
  return PlotSchema.getLayoutValObject(layout, Lib.nestedProperty({}, path).parts);
}
function getTraceInfo(trace, path) {
  return PlotSchema.getTraceValObject(trace, Lib.nestedProperty({}, path).parts);
}
function getNextPath(parent, key, path) {
  var nextPath;
  if (!path) nextPath = key;else if (Array.isArray(parent)) nextPath = path + '[' + key + ']';else nextPath = path + '.' + key;
  return nextPath;
}

/**
 * validateTemplate: Test for consistency between the given figure and
 * a template, either already included in the figure or given separately.
 * Note that not every issue we identify here is necessarily a problem,
 * it depends on what you're using the template for.
 *
 * @param {object|DOM element} figure: the plot, with {data, layout} members,
 *     to test the template against
 * @param {Optional(object)} template: the template, with its own {data, layout},
 *     to test. If omitted, we will look for a template already attached as the
 *     plot's `layout.template` attribute.
 *
 * @returns {array} array of error objects each containing:
 *  - {string} code
 *      error code ('missing', 'unused', 'reused', 'noLayout', 'noData')
 *  - {string} msg
 *      a full readable description of the issue.
 */
exports.validateTemplate = function (figureIn, template) {
  var figure = Lib.extendDeep({}, {
    _context: dfltConfig,
    data: figureIn.data,
    layout: figureIn.layout
  });
  var layout = figure.layout || {};
  if (!isPlainObject(template)) template = layout.template || {};
  var layoutTemplate = template.layout;
  var dataTemplate = template.data;
  var errorList = [];
  figure.layout = layout;
  figure.layout.template = template;
  Plots.supplyDefaults(figure);
  var fullLayout = figure._fullLayout;
  var fullData = figure._fullData;
  var layoutPaths = {};
  function crawlLayoutForContainers(obj, paths) {
    for (var key in obj) {
      if (key.charAt(0) !== '_' && isPlainObject(obj[key])) {
        var baseKey = getBaseKey(key);
        var nextPaths = [];
        var i;
        for (i = 0; i < paths.length; i++) {
          nextPaths.push(getNextPath(obj, key, paths[i]));
          if (baseKey !== key) nextPaths.push(getNextPath(obj, baseKey, paths[i]));
        }
        for (i = 0; i < nextPaths.length; i++) {
          layoutPaths[nextPaths[i]] = 1;
        }
        crawlLayoutForContainers(obj[key], nextPaths);
      }
    }
  }
  function crawlLayoutTemplateForContainers(obj, path) {
    for (var key in obj) {
      if (key.indexOf('defaults') === -1 && isPlainObject(obj[key])) {
        var nextPath = getNextPath(obj, key, path);
        if (layoutPaths[nextPath]) {
          crawlLayoutTemplateForContainers(obj[key], nextPath);
        } else {
          errorList.push({
            code: 'unused',
            path: nextPath
          });
        }
      }
    }
  }
  if (!isPlainObject(layoutTemplate)) {
    errorList.push({
      code: 'layout'
    });
  } else {
    crawlLayoutForContainers(fullLayout, ['layout']);
    crawlLayoutTemplateForContainers(layoutTemplate, 'layout');
  }
  if (!isPlainObject(dataTemplate)) {
    errorList.push({
      code: 'data'
    });
  } else {
    var typeCount = {};
    var traceType;
    for (var i = 0; i < fullData.length; i++) {
      var fullTrace = fullData[i];
      traceType = fullTrace.type;
      typeCount[traceType] = (typeCount[traceType] || 0) + 1;
      if (!fullTrace._fullInput._template) {
        // this takes care of the case of traceType in the data but not
        // the template
        errorList.push({
          code: 'missing',
          index: fullTrace._fullInput.index,
          traceType: traceType
        });
      }
    }
    for (traceType in dataTemplate) {
      var templateCount = dataTemplate[traceType].length;
      var dataCount = typeCount[traceType] || 0;
      if (templateCount > dataCount) {
        errorList.push({
          code: 'unused',
          traceType: traceType,
          templateCount: templateCount,
          dataCount: dataCount
        });
      } else if (dataCount > templateCount) {
        errorList.push({
          code: 'reused',
          traceType: traceType,
          templateCount: templateCount,
          dataCount: dataCount
        });
      }
    }
  }

  // _template: false is when someone tried to modify an array item
  // but there was no template with matching name
  function crawlForMissingTemplates(obj, path) {
    for (var key in obj) {
      if (key.charAt(0) === '_') continue;
      var val = obj[key];
      var nextPath = getNextPath(obj, key, path);
      if (isPlainObject(val)) {
        if (Array.isArray(obj) && val._template === false && val.templateitemname) {
          errorList.push({
            code: 'missing',
            path: nextPath,
            templateitemname: val.templateitemname
          });
        }
        crawlForMissingTemplates(val, nextPath);
      } else if (Array.isArray(val) && hasPlainObject(val)) {
        crawlForMissingTemplates(val, nextPath);
      }
    }
  }
  crawlForMissingTemplates({
    data: fullData,
    layout: fullLayout
  }, '');
  if (errorList.length) return errorList.map(format);
};
function hasPlainObject(arr) {
  for (var i = 0; i < arr.length; i++) {
    if (isPlainObject(arr[i])) return true;
  }
}
function format(opts) {
  var msg;
  switch (opts.code) {
    case 'data':
      msg = 'The template has no key data.';
      break;
    case 'layout':
      msg = 'The template has no key layout.';
      break;
    case 'missing':
      if (opts.path) {
        msg = 'There are no templates for item ' + opts.path + ' with name ' + opts.templateitemname;
      } else {
        msg = 'There are no templates for trace ' + opts.index + ', of type ' + opts.traceType + '.';
      }
      break;
    case 'unused':
      if (opts.path) {
        msg = 'The template item at ' + opts.path + ' was not used in constructing the plot.';
      } else if (opts.dataCount) {
        msg = 'Some of the templates of type ' + opts.traceType + ' were not used. The template has ' + opts.templateCount + ' traces, the data only has ' + opts.dataCount + ' of this type.';
      } else {
        msg = 'The template has ' + opts.templateCount + ' traces of type ' + opts.traceType + ' but there are none in the data.';
      }
      break;
    case 'reused':
      msg = 'Some of the templates of type ' + opts.traceType + ' were used more than once. The template has ' + opts.templateCount + ' traces, the data has ' + opts.dataCount + ' of this type.';
      break;
  }
  opts.msg = msg;
  return opts;
}

/***/ }),

/***/ 80491:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isNumeric = __webpack_require__(10721);
var plotApi = __webpack_require__(31420);
var plots = __webpack_require__(44122);
var Lib = __webpack_require__(34809);
var helpers = __webpack_require__(84619);
var toSVG = __webpack_require__(6243);
var svgToImg = __webpack_require__(72914);
var version = (__webpack_require__(29697).version);
var attrs = {
  format: {
    valType: 'enumerated',
    values: ['png', 'jpeg', 'webp', 'svg', 'full-json'],
    dflt: 'png'
  },
  width: {
    valType: 'number',
    min: 1
  },
  height: {
    valType: 'number',
    min: 1
  },
  scale: {
    valType: 'number',
    min: 0,
    dflt: 1
  },
  setBackground: {
    valType: 'any',
    dflt: false
  },
  imageDataOnly: {
    valType: 'boolean',
    dflt: false
  }
};

/** Plotly.toImage
 *
 * @param {object | string | HTML div} gd
 *   can either be a data/layout/config object
 *   or an existing graph <div>
 *   or an id to an existing graph <div>
 * @param {object} opts (see above)
 * @return {promise}
 */
function toImage(gd, opts) {
  opts = opts || {};
  var data;
  var layout;
  var config;
  var fullLayout;
  if (Lib.isPlainObject(gd)) {
    data = gd.data || [];
    layout = gd.layout || {};
    config = gd.config || {};
    fullLayout = {};
  } else {
    gd = Lib.getGraphDiv(gd);
    data = Lib.extendDeep([], gd.data);
    layout = Lib.extendDeep({}, gd.layout);
    config = gd._context;
    fullLayout = gd._fullLayout || {};
  }
  function isImpliedOrValid(attr) {
    return !(attr in opts) || Lib.validate(opts[attr], attrs[attr]);
  }
  if (!isImpliedOrValid('width') && opts.width !== null || !isImpliedOrValid('height') && opts.height !== null) {
    throw new Error('Height and width should be pixel values.');
  }
  if (!isImpliedOrValid('format')) {
    throw new Error('Export format is not ' + Lib.join2(attrs.format.values, ', ', ' or ') + '.');
  }
  var fullOpts = {};
  function coerce(attr, dflt) {
    return Lib.coerce(opts, fullOpts, attrs, attr, dflt);
  }
  var format = coerce('format');
  var width = coerce('width');
  var height = coerce('height');
  var scale = coerce('scale');
  var setBackground = coerce('setBackground');
  var imageDataOnly = coerce('imageDataOnly');

  // put the cloned div somewhere off screen before attaching to DOM
  var clonedGd = document.createElement('div');
  clonedGd.style.position = 'absolute';
  clonedGd.style.left = '-5000px';
  document.body.appendChild(clonedGd);

  // extend layout with image options
  var layoutImage = Lib.extendFlat({}, layout);
  if (width) {
    layoutImage.width = width;
  } else if (opts.width === null && isNumeric(fullLayout.width)) {
    layoutImage.width = fullLayout.width;
  }
  if (height) {
    layoutImage.height = height;
  } else if (opts.height === null && isNumeric(fullLayout.height)) {
    layoutImage.height = fullLayout.height;
  }

  // extend config for static plot
  var configImage = Lib.extendFlat({}, config, {
    _exportedPlot: true,
    staticPlot: true,
    setBackground: setBackground
  });
  var redrawFunc = helpers.getRedrawFunc(clonedGd);
  function wait() {
    return new Promise(function (resolve) {
      setTimeout(resolve, helpers.getDelay(clonedGd._fullLayout));
    });
  }
  function convert() {
    return new Promise(function (resolve, reject) {
      var svg = toSVG(clonedGd, format, scale);
      var width = clonedGd._fullLayout.width;
      var height = clonedGd._fullLayout.height;
      function cleanup() {
        plotApi.purge(clonedGd);
        document.body.removeChild(clonedGd);
      }
      if (format === 'full-json') {
        var json = plots.graphJson(clonedGd, false, 'keepdata', 'object', true, true);
        json.version = version;
        json = JSON.stringify(json);
        cleanup();
        if (imageDataOnly) {
          return resolve(json);
        } else {
          return resolve(helpers.encodeJSON(json));
        }
      }
      cleanup();
      if (format === 'svg') {
        if (imageDataOnly) {
          return resolve(svg);
        } else {
          return resolve(helpers.encodeSVG(svg));
        }
      }
      var canvas = document.createElement('canvas');
      canvas.id = Lib.randstr();
      svgToImg({
        format: format,
        width: width,
        height: height,
        scale: scale,
        canvas: canvas,
        svg: svg,
        // ask svgToImg to return a Promise
        //  rather than EventEmitter
        //  leave EventEmitter for backward
        //  compatibility
        promise: true
      }).then(resolve).catch(reject);
    });
  }
  function urlToImageData(url) {
    if (imageDataOnly) {
      return url.replace(helpers.IMAGE_URL_PREFIX, '');
    } else {
      return url;
    }
  }
  return new Promise(function (resolve, reject) {
    plotApi.newPlot(clonedGd, data, layoutImage, configImage).then(redrawFunc).then(wait).then(convert).then(function (url) {
      resolve(urlToImageData(url));
    }).catch(function (err) {
      reject(err);
    });
  });
}
module.exports = toImage;

/***/ }),

/***/ 2466:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var Plots = __webpack_require__(44122);
var PlotSchema = __webpack_require__(57297);
var dfltConfig = (__webpack_require__(24452).dfltConfig);
var isPlainObject = Lib.isPlainObject;
var isArray = Array.isArray;
var isArrayOrTypedArray = Lib.isArrayOrTypedArray;

/**
 * Validate a data array and layout object.
 *
 * @param {array} data
 * @param {object} layout
 *
 * @return {array} array of error objects each containing:
 *  - {string} code
 *      error code ('object', 'array', 'schema', 'unused', 'invisible' or 'value')
 *  - {string} container
 *      container where the error occurs ('data' or 'layout')
 *  - {number} trace
 *      trace index of the 'data' container where the error occurs
 *  - {array} path
 *      nested path to the key that causes the error
 *  - {string} astr
 *      attribute string variant of 'path' compatible with Plotly.restyle and
 *      Plotly.relayout.
 *  - {string} msg
 *      error message (shown in console in logger config argument is enable)
 */
module.exports = function validate(data, layout) {
  if (data === undefined) data = [];
  if (layout === undefined) layout = {};
  var schema = PlotSchema.get();
  var errorList = [];
  var gd = {
    _context: Lib.extendFlat({}, dfltConfig)
  };
  var dataIn, layoutIn;
  if (isArray(data)) {
    gd.data = Lib.extendDeep([], data);
    dataIn = data;
  } else {
    gd.data = [];
    dataIn = [];
    errorList.push(format('array', 'data'));
  }
  if (isPlainObject(layout)) {
    gd.layout = Lib.extendDeep({}, layout);
    layoutIn = layout;
  } else {
    gd.layout = {};
    layoutIn = {};
    if (arguments.length > 1) {
      errorList.push(format('object', 'layout'));
    }
  }

  // N.B. dataIn and layoutIn are in general not the same as
  // gd.data and gd.layout after supplyDefaults as some attributes
  // in gd.data and gd.layout (still) get mutated during this step.

  Plots.supplyDefaults(gd);
  var dataOut = gd._fullData;
  var len = dataIn.length;
  for (var i = 0; i < len; i++) {
    var traceIn = dataIn[i];
    var base = ['data', i];
    if (!isPlainObject(traceIn)) {
      errorList.push(format('object', base));
      continue;
    }
    var traceOut = dataOut[i];
    var traceType = traceOut.type;
    var traceSchema = schema.traces[traceType].attributes;

    // PlotSchema does something fancy with trace 'type', reset it here
    // to make the trace schema compatible with Lib.validate.
    traceSchema.type = {
      valType: 'enumerated',
      values: [traceType]
    };
    if (traceOut.visible === false && traceIn.visible !== false) {
      errorList.push(format('invisible', base));
    }
    crawl(traceIn, traceOut, traceSchema, errorList, base);
    var transformsIn = traceIn.transforms;
    var transformsOut = traceOut.transforms;
    if (transformsIn) {
      if (!isArray(transformsIn)) {
        errorList.push(format('array', base, ['transforms']));
      }
      base.push('transforms');
      for (var j = 0; j < transformsIn.length; j++) {
        var path = ['transforms', j];
        var transformType = transformsIn[j].type;
        if (!isPlainObject(transformsIn[j])) {
          errorList.push(format('object', base, path));
          continue;
        }
        var transformSchema = schema.transforms[transformType] ? schema.transforms[transformType].attributes : {};

        // add 'type' to transform schema to validate the transform type
        transformSchema.type = {
          valType: 'enumerated',
          values: Object.keys(schema.transforms)
        };
        crawl(transformsIn[j], transformsOut[j], transformSchema, errorList, base, path);
      }
    }
  }
  var layoutOut = gd._fullLayout;
  var layoutSchema = fillLayoutSchema(schema, dataOut);
  crawl(layoutIn, layoutOut, layoutSchema, errorList, 'layout');

  // return undefined if no validation errors were found
  return errorList.length === 0 ? void 0 : errorList;
};
function crawl(objIn, objOut, schema, list, base, path) {
  path = path || [];
  var keys = Object.keys(objIn);
  for (var i = 0; i < keys.length; i++) {
    var k = keys[i];

    // transforms are handled separately
    if (k === 'transforms') continue;
    var p = path.slice();
    p.push(k);
    var valIn = objIn[k];
    var valOut = objOut[k];
    var nestedSchema = getNestedSchema(schema, k);
    var nestedValType = (nestedSchema || {}).valType;
    var isInfoArray = nestedValType === 'info_array';
    var isColorscale = nestedValType === 'colorscale';
    var items = (nestedSchema || {}).items;
    if (!isInSchema(schema, k)) {
      list.push(format('schema', base, p));
    } else if (isPlainObject(valIn) && isPlainObject(valOut) && nestedValType !== 'any') {
      crawl(valIn, valOut, nestedSchema, list, base, p);
    } else if (isInfoArray && isArray(valIn)) {
      if (valIn.length > valOut.length) {
        list.push(format('unused', base, p.concat(valOut.length)));
      }
      var len = valOut.length;
      var arrayItems = Array.isArray(items);
      if (arrayItems) len = Math.min(len, items.length);
      var m, n, item, valInPart, valOutPart;
      if (nestedSchema.dimensions === 2) {
        for (n = 0; n < len; n++) {
          if (isArray(valIn[n])) {
            if (valIn[n].length > valOut[n].length) {
              list.push(format('unused', base, p.concat(n, valOut[n].length)));
            }
            var len2 = valOut[n].length;
            for (m = 0; m < (arrayItems ? Math.min(len2, items[n].length) : len2); m++) {
              item = arrayItems ? items[n][m] : items;
              valInPart = valIn[n][m];
              valOutPart = valOut[n][m];
              if (!Lib.validate(valInPart, item)) {
                list.push(format('value', base, p.concat(n, m), valInPart));
              } else if (valOutPart !== valInPart && valOutPart !== +valInPart) {
                list.push(format('dynamic', base, p.concat(n, m), valInPart, valOutPart));
              }
            }
          } else {
            list.push(format('array', base, p.concat(n), valIn[n]));
          }
        }
      } else {
        for (n = 0; n < len; n++) {
          item = arrayItems ? items[n] : items;
          valInPart = valIn[n];
          valOutPart = valOut[n];
          if (!Lib.validate(valInPart, item)) {
            list.push(format('value', base, p.concat(n), valInPart));
          } else if (valOutPart !== valInPart && valOutPart !== +valInPart) {
            list.push(format('dynamic', base, p.concat(n), valInPart, valOutPart));
          }
        }
      }
    } else if (nestedSchema.items && !isInfoArray && isArray(valIn)) {
      var _nestedSchema = items[Object.keys(items)[0]];
      var indexList = [];
      var j, _p;

      // loop over valOut items while keeping track of their
      // corresponding input container index (given by _index)
      for (j = 0; j < valOut.length; j++) {
        var _index = valOut[j]._index || j;
        _p = p.slice();
        _p.push(_index);
        if (isPlainObject(valIn[_index]) && isPlainObject(valOut[j])) {
          indexList.push(_index);
          var valInj = valIn[_index];
          var valOutj = valOut[j];
          if (isPlainObject(valInj) && valInj.visible !== false && valOutj.visible === false) {
            list.push(format('invisible', base, _p));
          } else crawl(valInj, valOutj, _nestedSchema, list, base, _p);
        }
      }

      // loop over valIn to determine where it went wrong for some items
      for (j = 0; j < valIn.length; j++) {
        _p = p.slice();
        _p.push(j);
        if (!isPlainObject(valIn[j])) {
          list.push(format('object', base, _p, valIn[j]));
        } else if (indexList.indexOf(j) === -1) {
          list.push(format('unused', base, _p));
        }
      }
    } else if (!isPlainObject(valIn) && isPlainObject(valOut)) {
      list.push(format('object', base, p, valIn));
    } else if (!isArrayOrTypedArray(valIn) && isArrayOrTypedArray(valOut) && !isInfoArray && !isColorscale) {
      list.push(format('array', base, p, valIn));
    } else if (!(k in objOut)) {
      list.push(format('unused', base, p, valIn));
    } else if (!Lib.validate(valIn, nestedSchema)) {
      list.push(format('value', base, p, valIn));
    } else if (nestedSchema.valType === 'enumerated' && (nestedSchema.coerceNumber && valIn !== +valOut || valIn !== valOut)) {
      list.push(format('dynamic', base, p, valIn, valOut));
    }
  }
  return list;
}

// the 'full' layout schema depends on the traces types presents
function fillLayoutSchema(schema, dataOut) {
  var layoutSchema = schema.layout.layoutAttributes;
  for (var i = 0; i < dataOut.length; i++) {
    var traceOut = dataOut[i];
    var traceSchema = schema.traces[traceOut.type];
    var traceLayoutAttr = traceSchema.layoutAttributes;
    if (traceLayoutAttr) {
      if (traceOut.subplot) {
        Lib.extendFlat(layoutSchema[traceSchema.attributes.subplot.dflt], traceLayoutAttr);
      } else {
        Lib.extendFlat(layoutSchema, traceLayoutAttr);
      }
    }
  }
  return layoutSchema;
}

// validation error codes
var code2msgFunc = {
  object: function (base, astr) {
    var prefix;
    if (base === 'layout' && astr === '') prefix = 'The layout argument';else if (base[0] === 'data' && astr === '') {
      prefix = 'Trace ' + base[1] + ' in the data argument';
    } else prefix = inBase(base) + 'key ' + astr;
    return prefix + ' must be linked to an object container';
  },
  array: function (base, astr) {
    var prefix;
    if (base === 'data') prefix = 'The data argument';else prefix = inBase(base) + 'key ' + astr;
    return prefix + ' must be linked to an array container';
  },
  schema: function (base, astr) {
    return inBase(base) + 'key ' + astr + ' is not part of the schema';
  },
  unused: function (base, astr, valIn) {
    var target = isPlainObject(valIn) ? 'container' : 'key';
    return inBase(base) + target + ' ' + astr + ' did not get coerced';
  },
  dynamic: function (base, astr, valIn, valOut) {
    return [inBase(base) + 'key', astr, '(set to \'' + valIn + '\')', 'got reset to', '\'' + valOut + '\'', 'during defaults.'].join(' ');
  },
  invisible: function (base, astr) {
    return (astr ? inBase(base) + 'item ' + astr : 'Trace ' + base[1]) + ' got defaulted to be not visible';
  },
  value: function (base, astr, valIn) {
    return [inBase(base) + 'key ' + astr, 'is set to an invalid value (' + valIn + ')'].join(' ');
  }
};
function inBase(base) {
  if (isArray(base)) return 'In data trace ' + base[1] + ', ';
  return 'In ' + base + ', ';
}
function format(code, base, path, valIn, valOut) {
  path = path || '';
  var container, trace;

  // container is either 'data' or 'layout
  // trace is the trace index if 'data', null otherwise

  if (isArray(base)) {
    container = base[0];
    trace = base[1];
  } else {
    container = base;
    trace = null;
  }
  var astr = convertPathToAttributeString(path);
  var msg = code2msgFunc[code](base, astr, valIn, valOut);

  // log to console if logger config option is enabled
  Lib.log(msg);
  return {
    code: code,
    container: container,
    trace: trace,
    path: path,
    astr: astr,
    msg: msg
  };
}
function isInSchema(schema, key) {
  var parts = splitKey(key);
  var keyMinusId = parts.keyMinusId;
  var id = parts.id;
  if (keyMinusId in schema && schema[keyMinusId]._isSubplotObj && id) {
    return true;
  }
  return key in schema;
}
function getNestedSchema(schema, key) {
  if (key in schema) return schema[key];
  var parts = splitKey(key);
  return schema[parts.keyMinusId];
}
var idRegex = Lib.counterRegex('([a-z]+)');
function splitKey(key) {
  var idMatch = key.match(idRegex);
  return {
    keyMinusId: idMatch && idMatch[1],
    id: idMatch && idMatch[2]
  };
}
function convertPathToAttributeString(path) {
  if (!isArray(path)) return String(path);
  var astr = '';
  for (var i = 0; i < path.length; i++) {
    var p = path[i];
    if (typeof p === 'number') {
      astr = astr.substr(0, astr.length - 1) + '[' + p + ']';
    } else {
      astr += p;
    }
    if (i < path.length - 1) astr += '.';
  }
  return astr;
}

/***/ }),

/***/ 49722:
/***/ (function(module) {

"use strict";


module.exports = {
  mode: {
    valType: 'enumerated',
    dflt: 'afterall',
    values: ['immediate', 'next', 'afterall']
  },
  direction: {
    valType: 'enumerated',
    values: ['forward', 'reverse'],
    dflt: 'forward'
  },
  fromcurrent: {
    valType: 'boolean',
    dflt: false
  },
  frame: {
    duration: {
      valType: 'number',
      min: 0,
      dflt: 500
    },
    redraw: {
      valType: 'boolean',
      dflt: true
    }
  },
  transition: {
    duration: {
      valType: 'number',
      min: 0,
      dflt: 500,
      editType: 'none'
    },
    easing: {
      valType: 'enumerated',
      dflt: 'cubic-in-out',
      values: ['linear', 'quad', 'cubic', 'sin', 'exp', 'circle', 'elastic', 'back', 'bounce', 'linear-in', 'quad-in', 'cubic-in', 'sin-in', 'exp-in', 'circle-in', 'elastic-in', 'back-in', 'bounce-in', 'linear-out', 'quad-out', 'cubic-out', 'sin-out', 'exp-out', 'circle-out', 'elastic-out', 'back-out', 'bounce-out', 'linear-in-out', 'quad-in-out', 'cubic-in-out', 'sin-in-out', 'exp-in-out', 'circle-in-out', 'elastic-in-out', 'back-in-out', 'bounce-in-out'],
      editType: 'none'
    },
    ordering: {
      valType: 'enumerated',
      values: ['layout first', 'traces first'],
      dflt: 'layout first',
      editType: 'none'
    }
  }
};

/***/ }),

/***/ 59008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var Template = __webpack_require__(78032);

/** Convenience wrapper for making array container logic DRY and consistent
 *
 * @param {object} parentObjIn
 *  user input object where the container in question is linked
 *  (i.e. either a user trace object or the user layout object)
 *
 * @param {object} parentObjOut
 *  full object where the coerced container will be linked
 *  (i.e. either a full trace object or the full layout object)
 *
 * @param {object} opts
 *  options object:
 *   - name {string}
 *      name of the key linking the container in question
 *   - inclusionAttr {string}
 *      name of the item attribute for inclusion/exclusion. Default is 'visible'.
 *      Since inclusion is true, use eg 'enabled' instead of 'disabled'.
 *   - handleItemDefaults {function}
 *      defaults method to be called on each item in the array container in question
 *
 *      Its arguments are:
 *          - itemIn {object} item in user layout
 *          - itemOut {object} item in full layout
 *          - parentObj {object} (as in closure)
 *          - opts {object} (as in closure)
 * N.B.
 *
 *  - opts is passed to handleItemDefaults so it can also store
 *    links to supplementary data (e.g. fullData for layout components)
 *
 */
module.exports = function handleArrayContainerDefaults(parentObjIn, parentObjOut, opts) {
  var name = opts.name;
  var inclusionAttr = opts.inclusionAttr || 'visible';
  var previousContOut = parentObjOut[name];
  var contIn = Lib.isArrayOrTypedArray(parentObjIn[name]) ? parentObjIn[name] : [];
  var contOut = parentObjOut[name] = [];
  var templater = Template.arrayTemplater(parentObjOut, name, inclusionAttr);
  var i, itemOut;
  for (i = 0; i < contIn.length; i++) {
    var itemIn = contIn[i];
    if (!Lib.isPlainObject(itemIn)) {
      itemOut = templater.newItem({});
      itemOut[inclusionAttr] = false;
    } else {
      itemOut = templater.newItem(itemIn);
    }
    itemOut._index = i;
    if (itemOut[inclusionAttr] !== false) {
      opts.handleItemDefaults(itemIn, itemOut, parentObjOut, opts);
    }
    contOut.push(itemOut);
  }
  var defaultItems = templater.defaultItems();
  for (i = 0; i < defaultItems.length; i++) {
    itemOut = defaultItems[i];
    itemOut._index = contOut.length;
    opts.handleItemDefaults({}, itemOut, parentObjOut, opts, {});
    contOut.push(itemOut);
  }

  // in case this array gets its defaults rebuilt independent of the whole layout,
  // relink the private keys just for this array.
  if (Lib.isArrayOrTypedArray(previousContOut)) {
    var len = Math.min(previousContOut.length, contOut.length);
    for (i = 0; i < len; i++) {
      Lib.relinkPrivateKeys(contOut[i], previousContOut[i]);
    }
  }
  return contOut;
};

/***/ }),

/***/ 9829:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var fontAttrs = __webpack_require__(80337);
var fxAttrs = __webpack_require__(70192);
module.exports = {
  type: {
    valType: 'enumerated',
    values: [],
    // listed dynamically
    dflt: 'scatter',
    editType: 'calc+clearAxisTypes',
    _noTemplating: true // we handle this at a higher level
  },
  visible: {
    valType: 'enumerated',
    values: [true, false, 'legendonly'],
    dflt: true,
    editType: 'calc'
  },
  showlegend: {
    valType: 'boolean',
    dflt: true,
    editType: 'style'
  },
  legend: {
    valType: 'subplotid',
    dflt: 'legend',
    editType: 'style'
  },
  legendgroup: {
    valType: 'string',
    dflt: '',
    editType: 'style'
  },
  legendgrouptitle: {
    text: {
      valType: 'string',
      dflt: '',
      editType: 'style'
    },
    font: fontAttrs({
      editType: 'style'
    }),
    editType: 'style'
  },
  legendrank: {
    valType: 'number',
    dflt: 1000,
    editType: 'style'
  },
  legendwidth: {
    valType: 'number',
    min: 0,
    editType: 'style'
  },
  opacity: {
    valType: 'number',
    min: 0,
    max: 1,
    dflt: 1,
    editType: 'style'
  },
  name: {
    valType: 'string',
    editType: 'style'
  },
  uid: {
    valType: 'string',
    editType: 'plot',
    anim: true
  },
  ids: {
    valType: 'data_array',
    editType: 'calc',
    anim: true
  },
  customdata: {
    valType: 'data_array',
    editType: 'calc'
  },
  meta: {
    valType: 'any',
    arrayOk: true,
    editType: 'plot'
  },
  // N.B. these cannot be 'data_array' as they do not have the same length as
  // other data arrays and arrayOk attributes in general
  //
  // Maybe add another valType:
  // https://github.com/plotly/plotly.js/issues/1894
  selectedpoints: {
    valType: 'any',
    editType: 'calc'
  },
  hoverinfo: {
    valType: 'flaglist',
    flags: ['x', 'y', 'z', 'text', 'name'],
    extras: ['all', 'none', 'skip'],
    arrayOk: true,
    dflt: 'all',
    editType: 'none'
  },
  hoverlabel: fxAttrs.hoverlabel,
  stream: {
    token: {
      valType: 'string',
      noBlank: true,
      strict: true,
      editType: 'calc'
    },
    maxpoints: {
      valType: 'number',
      min: 0,
      max: 10000,
      dflt: 500,
      editType: 'calc'
    },
    editType: 'calc'
  },
  transforms: {
    _isLinkedToArray: 'transform',
    editType: 'calc'
  },
  uirevision: {
    valType: 'any',
    editType: 'none'
  }
};

/***/ }),

/***/ 40528:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isNumeric = __webpack_require__(10721);
var Lib = __webpack_require__(34809);
var dateTime2ms = Lib.dateTime2ms;
var incrementMonth = Lib.incrementMonth;
var constants = __webpack_require__(63821);
var ONEAVGMONTH = constants.ONEAVGMONTH;
module.exports = function alignPeriod(trace, ax, axLetter, vals) {
  if (ax.type !== 'date') return {
    vals: vals
  };
  var alignment = trace[axLetter + 'periodalignment'];
  if (!alignment) return {
    vals: vals
  };
  var period = trace[axLetter + 'period'];
  var mPeriod;
  if (isNumeric(period)) {
    period = +period;
    if (period <= 0) return {
      vals: vals
    };
  } else if (typeof period === 'string' && period.charAt(0) === 'M') {
    var n = +period.substring(1);
    if (n > 0 && Math.round(n) === n) {
      mPeriod = n;
    } else return {
      vals: vals
    };
  }
  var calendar = ax.calendar;
  var isStart = 'start' === alignment;
  // var isMiddle = 'middle' === alignment;
  var isEnd = 'end' === alignment;
  var period0 = trace[axLetter + 'period0'];
  var base = dateTime2ms(period0, calendar) || 0;
  var newVals = [];
  var starts = [];
  var ends = [];
  var len = vals.length;
  for (var i = 0; i < len; i++) {
    var v = vals[i];
    var nEstimated, startTime, endTime;
    if (mPeriod) {
      // guess at how many periods away from base we are
      nEstimated = Math.round((v - base) / (mPeriod * ONEAVGMONTH));
      endTime = incrementMonth(base, mPeriod * nEstimated, calendar);

      // iterate to get the exact bounds before and after v
      // there may be ways to make this faster, but most of the time
      // we'll only execute each loop zero or one time.
      while (endTime > v) {
        endTime = incrementMonth(endTime, -mPeriod, calendar);
      }
      while (endTime <= v) {
        endTime = incrementMonth(endTime, mPeriod, calendar);
      }

      // now we know endTime is the boundary immediately after v
      // so startTime is obtained by incrementing backward one period.
      startTime = incrementMonth(endTime, -mPeriod, calendar);
    } else {
      // case of ms
      nEstimated = Math.round((v - base) / period);
      endTime = base + nEstimated * period;
      while (endTime > v) {
        endTime -= period;
      }
      while (endTime <= v) {
        endTime += period;
      }
      startTime = endTime - period;
    }
    newVals[i] = isStart ? startTime : isEnd ? endTime : (startTime + endTime) / 2;
    starts[i] = startTime;
    ends[i] = endTime;
  }
  return {
    vals: newVals,
    starts: starts,
    ends: ends
  };
};

/***/ }),

/***/ 55126:
/***/ (function(module) {

"use strict";


module.exports = {
  xaxis: {
    valType: 'subplotid',
    dflt: 'x',
    editType: 'calc+clearAxisTypes'
  },
  yaxis: {
    valType: 'subplotid',
    dflt: 'y',
    editType: 'calc+clearAxisTypes'
  }
};

/***/ }),

/***/ 32919:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var isNumeric = __webpack_require__(10721);
var Lib = __webpack_require__(34809);
var FP_SAFE = (__webpack_require__(63821).FP_SAFE);
var Registry = __webpack_require__(33626);
var Drawing = __webpack_require__(62203);
var axIds = __webpack_require__(5975);
var getFromId = axIds.getFromId;
var isLinked = axIds.isLinked;
module.exports = {
  applyAutorangeOptions: applyAutorangeOptions,
  getAutoRange: getAutoRange,
  makePadFn: makePadFn,
  doAutoRange: doAutoRange,
  findExtremes: findExtremes,
  concatExtremes: concatExtremes
};

/**
 * getAutoRange
 *
 * Collects all _extremes values corresponding to a given axis
 * and computes its auto range.
 *
 * Note that getAutoRange uses return values from findExtremes.
 *
 * @param {object} gd:
 *   graph div object with filled-in fullData and fullLayout, in particular
 *   with filled-in '_extremes' containers:
 *   {
 *      val: calcdata value,
 *      pad: extra pixels beyond this value,
 *      extrapad: bool, does this point want 5% extra padding
 *   }
 * @param {object} ax:
 *   full axis object, in particular with filled-in '_traceIndices'
 *   and '_annIndices' / '_shapeIndices' if applicable
 * @return {array}
 *   an array of [min, max]. These are calcdata for log and category axes
 *   and data for linear and date axes.
 *
 * TODO: we want to change log to data as well, but it's hard to do this
 * maintaining backward compatibility. category will always have to use calcdata
 * though, because otherwise values between categories (or outside all categories)
 * would be impossible.
 */
function getAutoRange(gd, ax) {
  var i, j;
  var newRange = [];
  var fullLayout = gd._fullLayout;
  var getPadMin = makePadFn(fullLayout, ax, 0);
  var getPadMax = makePadFn(fullLayout, ax, 1);
  var extremes = concatExtremes(gd, ax);
  var minArray = extremes.min;
  var maxArray = extremes.max;
  if (minArray.length === 0 || maxArray.length === 0) {
    return Lib.simpleMap(ax.range, ax.r2l);
  }
  var minmin = minArray[0].val;
  var maxmax = maxArray[0].val;
  for (i = 1; i < minArray.length; i++) {
    if (minmin !== maxmax) break;
    minmin = Math.min(minmin, minArray[i].val);
  }
  for (i = 1; i < maxArray.length; i++) {
    if (minmin !== maxmax) break;
    maxmax = Math.max(maxmax, maxArray[i].val);
  }
  var autorange = ax.autorange;
  var axReverse = autorange === 'reversed' || autorange === 'min reversed' || autorange === 'max reversed';
  if (!axReverse && ax.range) {
    var rng = Lib.simpleMap(ax.range, ax.r2l);
    axReverse = rng[1] < rng[0];
  }

  // one-time setting to easily reverse the axis
  // when plotting from code
  if (ax.autorange === 'reversed') {
    ax.autorange = true;
  }
  var rangeMode = ax.rangemode;
  var toZero = rangeMode === 'tozero';
  var nonNegative = rangeMode === 'nonnegative';
  var axLen = ax._length;
  // don't allow padding to reduce the data to < 10% of the length
  var minSpan = axLen / 10;
  var mbest = 0;
  var minpt, maxpt, minbest, maxbest, dp, dv;
  for (i = 0; i < minArray.length; i++) {
    minpt = minArray[i];
    for (j = 0; j < maxArray.length; j++) {
      maxpt = maxArray[j];
      dv = maxpt.val - minpt.val - calcBreaksLength(ax, minpt.val, maxpt.val);
      if (dv > 0) {
        dp = axLen - getPadMin(minpt) - getPadMax(maxpt);
        if (dp > minSpan) {
          if (dv / dp > mbest) {
            minbest = minpt;
            maxbest = maxpt;
            mbest = dv / dp;
          }
        } else if (dv / axLen > mbest) {
          // in case of padding longer than the axis
          // at least include the unpadded data values.
          minbest = {
            val: minpt.val,
            nopad: 1
          };
          maxbest = {
            val: maxpt.val,
            nopad: 1
          };
          mbest = dv / axLen;
        }
      }
    }
  }
  function maximumPad(prev, pt) {
    return Math.max(prev, getPadMax(pt));
  }
  if (minmin === maxmax) {
    var lower = minmin - 1;
    var upper = minmin + 1;
    if (toZero) {
      if (minmin === 0) {
        // The only value we have on this axis is 0, and we want to
        // autorange so zero is one end.
        // In principle this could be [0, 1] or [-1, 0] but usually
        // 'tozero' pins 0 to the low end, so follow that.
        newRange = [0, 1];
      } else {
        var maxPad = (minmin > 0 ? maxArray : minArray).reduce(maximumPad, 0);
        // we're pushing a single value away from the edge due to its
        // padding, with the other end clamped at zero
        // 0.5 means don't push it farther than the center.
        var rangeEnd = minmin / (1 - Math.min(0.5, maxPad / axLen));
        newRange = minmin > 0 ? [0, rangeEnd] : [rangeEnd, 0];
      }
    } else if (nonNegative) {
      newRange = [Math.max(0, lower), Math.max(1, upper)];
    } else {
      newRange = [lower, upper];
    }
  } else {
    if (toZero) {
      if (minbest.val >= 0) {
        minbest = {
          val: 0,
          nopad: 1
        };
      }
      if (maxbest.val <= 0) {
        maxbest = {
          val: 0,
          nopad: 1
        };
      }
    } else if (nonNegative) {
      if (minbest.val - mbest * getPadMin(minbest) < 0) {
        minbest = {
          val: 0,
          nopad: 1
        };
      }
      if (maxbest.val <= 0) {
        maxbest = {
          val: 1,
          nopad: 1
        };
      }
    }

    // in case it changed again...
    mbest = (maxbest.val - minbest.val - calcBreaksLength(ax, minpt.val, maxpt.val)) / (axLen - getPadMin(minbest) - getPadMax(maxbest));
    newRange = [minbest.val - mbest * getPadMin(minbest), maxbest.val + mbest * getPadMax(maxbest)];
  }
  newRange = applyAutorangeOptions(newRange, ax);
  if (ax.limitRange) ax.limitRange();

  // maintain reversal
  if (axReverse) newRange.reverse();
  return Lib.simpleMap(newRange, ax.l2r || Number);
}

// find axis rangebreaks in [v0,v1] and compute its length in value space
function calcBreaksLength(ax, v0, v1) {
  var lBreaks = 0;
  if (ax.rangebreaks) {
    var rangebreaksOut = ax.locateBreaks(v0, v1);
    for (var i = 0; i < rangebreaksOut.length; i++) {
      var brk = rangebreaksOut[i];
      lBreaks += brk.max - brk.min;
    }
  }
  return lBreaks;
}

/*
 * calculate the pixel padding for ax._min and ax._max entries with
 * optional extrapad as 5% of the total axis length
 */
function makePadFn(fullLayout, ax, max) {
  // 5% padding for points that specify extrapad: true
  var extrappad = 0.05 * ax._length;
  var anchorAxis = ax._anchorAxis || {};
  if ((ax.ticklabelposition || '').indexOf('inside') !== -1 || (anchorAxis.ticklabelposition || '').indexOf('inside') !== -1) {
    var axReverse = ax.isReversed();
    if (!axReverse) {
      var rng = Lib.simpleMap(ax.range, ax.r2l);
      axReverse = rng[1] < rng[0];
    }
    if (axReverse) max = !max;
  }
  var zero = 0;
  if (!isLinked(fullLayout, ax._id)) {
    zero = padInsideLabelsOnAnchorAxis(fullLayout, ax, max);
  }
  extrappad = Math.max(zero, extrappad);

  // domain-constrained axes: base extrappad on the unconstrained
  // domain so it's consistent as the domain changes
  if (ax.constrain === 'domain' && ax._inputDomain) {
    extrappad *= (ax._inputDomain[1] - ax._inputDomain[0]) / (ax.domain[1] - ax.domain[0]);
  }
  return function getPad(pt) {
    if (pt.nopad) return 0;
    return pt.pad + (pt.extrapad ? extrappad : zero);
  };
}
var TEXTPAD = 3;
function padInsideLabelsOnAnchorAxis(fullLayout, ax, max) {
  var pad = 0;
  var isX = ax._id.charAt(0) === 'x';
  for (var subplot in fullLayout._plots) {
    var plotinfo = fullLayout._plots[subplot];
    if (ax._id !== plotinfo.xaxis._id && ax._id !== plotinfo.yaxis._id) continue;
    var anchorAxis = (isX ? plotinfo.yaxis : plotinfo.xaxis) || {};
    if ((anchorAxis.ticklabelposition || '').indexOf('inside') !== -1) {
      // increase padding to make more room for inside tick labels of the counter axis
      if (!max && (anchorAxis.side === 'left' || anchorAxis.side === 'bottom') || max && (anchorAxis.side === 'top' || anchorAxis.side === 'right')) {
        if (anchorAxis._vals) {
          var rad = Lib.deg2rad(anchorAxis._tickAngles[anchorAxis._id + 'tick'] || 0);
          var cosA = Math.abs(Math.cos(rad));
          var sinA = Math.abs(Math.sin(rad));

          // no stashed bounding boxes - stash bounding boxes
          if (!anchorAxis._vals[0].bb) {
            var cls = anchorAxis._id + 'tick';
            var tickLabels = anchorAxis._selections[cls];
            tickLabels.each(function (d) {
              var thisLabel = d3.select(this);
              var mathjaxGroup = thisLabel.select('.text-math-group');
              if (mathjaxGroup.empty()) {
                d.bb = Drawing.bBox(thisLabel.node());
              }
            });
          }

          // use bounding boxes
          for (var i = 0; i < anchorAxis._vals.length; i++) {
            var t = anchorAxis._vals[i];
            var bb = t.bb;
            if (bb) {
              var w = 2 * TEXTPAD + bb.width;
              var h = 2 * TEXTPAD + bb.height;
              pad = Math.max(pad, isX ? Math.max(w * cosA, h * sinA) : Math.max(h * cosA, w * sinA));
            }
          }
        }
        if (anchorAxis.ticks === 'inside' && anchorAxis.ticklabelposition === 'inside') {
          pad += anchorAxis.ticklen || 0;
        }
      }
    }
  }
  return pad;
}
function concatExtremes(gd, ax, noMatch) {
  var axId = ax._id;
  var fullData = gd._fullData;
  var fullLayout = gd._fullLayout;
  var minArray = [];
  var maxArray = [];
  var i, j, d;
  function _concat(cont, indices) {
    for (i = 0; i < indices.length; i++) {
      var item = cont[indices[i]];
      var extremes = (item._extremes || {})[axId];
      if (item.visible === true && extremes) {
        for (j = 0; j < extremes.min.length; j++) {
          d = extremes.min[j];
          collapseMinArray(minArray, d.val, d.pad, {
            extrapad: d.extrapad
          });
        }
        for (j = 0; j < extremes.max.length; j++) {
          d = extremes.max[j];
          collapseMaxArray(maxArray, d.val, d.pad, {
            extrapad: d.extrapad
          });
        }
      }
    }
  }
  _concat(fullData, ax._traceIndices);
  _concat(fullLayout.annotations || [], ax._annIndices || []);
  _concat(fullLayout.shapes || [], ax._shapeIndices || []);

  // Include the extremes from other matched axes with this one
  if (ax._matchGroup && !noMatch) {
    for (var axId2 in ax._matchGroup) {
      if (axId2 !== ax._id) {
        var ax2 = getFromId(gd, axId2);
        var extremes2 = concatExtremes(gd, ax2, true);
        // convert padding on the second axis to the first with lenRatio
        var lenRatio = ax._length / ax2._length;
        for (j = 0; j < extremes2.min.length; j++) {
          d = extremes2.min[j];
          collapseMinArray(minArray, d.val, d.pad * lenRatio, {
            extrapad: d.extrapad
          });
        }
        for (j = 0; j < extremes2.max.length; j++) {
          d = extremes2.max[j];
          collapseMaxArray(maxArray, d.val, d.pad * lenRatio, {
            extrapad: d.extrapad
          });
        }
      }
    }
  }
  return {
    min: minArray,
    max: maxArray
  };
}
function doAutoRange(gd, ax, presetRange) {
  ax.setScale();
  if (ax.autorange) {
    ax.range = presetRange ? presetRange.slice() : getAutoRange(gd, ax);
    ax._r = ax.range.slice();
    ax._rl = Lib.simpleMap(ax._r, ax.r2l);

    // doAutoRange will get called on fullLayout,
    // but we want to report its results back to layout

    var axIn = ax._input;

    // before we edit _input, store preGUI values
    var edits = {};
    edits[ax._attr + '.range'] = ax.range;
    edits[ax._attr + '.autorange'] = ax.autorange;
    Registry.call('_storeDirectGUIEdit', gd.layout, gd._fullLayout._preGUI, edits);
    axIn.range = ax.range.slice();
    axIn.autorange = ax.autorange;
  }
  var anchorAx = ax._anchorAxis;
  if (anchorAx && anchorAx.rangeslider) {
    var axeRangeOpts = anchorAx.rangeslider[ax._name];
    if (axeRangeOpts) {
      if (axeRangeOpts.rangemode === 'auto') {
        axeRangeOpts.range = getAutoRange(gd, ax);
      }
    }
    anchorAx._input.rangeslider[ax._name] = Lib.extendFlat({}, axeRangeOpts);
  }
}

/**
 * findExtremes
 *
 * Find min/max extremes of an array of coordinates on a given axis.
 *
 * Note that findExtremes is called during `calc`, when we don't yet know the axis
 * length; all the inputs should be based solely on the trace data, nothing
 * about the axis layout.
 *
 * Note that `ppad` and `vpad` as well as their asymmetric variants refer to
 * the before and after padding of the passed `data` array, not to the whole axis.
 *
 * @param {object} ax: full axis object
 *   relies on
 *   - ax.type
 *   - ax._m (just its sign)
 *   - ax.d2l
 * @param {array} data:
 *  array of numbers (i.e. already run though ax.d2c)
 * @param {object} opts:
 *  available keys are:
 *      vpad: (number or number array) pad values (data value +-vpad)
 *      ppad: (number or number array) pad pixels (pixel location +-ppad)
 *      ppadplus, ppadminus, vpadplus, vpadminus:
 *          separate padding for each side, overrides symmetric
 *      padded: (boolean) add 5% padding to both ends
 *          (unless one end is overridden by tozero)
 *      tozero: (boolean) make sure to include zero if axis is linear,
 *          and make it a tight bound if possible
 *      vpadLinearized: (boolean) whether or not vpad (or vpadplus/vpadminus)
 *          is linearized (for log scale axes)
 *
 * @return {object}
 *  - min {array of objects}
 *  - max {array of objects}
 *  each object item has fields:
 *    - val {number}
 *    - pad {number}
 *    - extrappad {number}
 *  - opts {object}: a ref to the passed "options" object
 */
function findExtremes(ax, data, opts) {
  if (!opts) opts = {};
  if (!ax._m) ax.setScale();
  var minArray = [];
  var maxArray = [];
  var len = data.length;
  var extrapad = opts.padded || false;
  var tozero = opts.tozero && (ax.type === 'linear' || ax.type === '-');
  var isLog = ax.type === 'log';
  var hasArrayOption = false;
  var vpadLinearized = opts.vpadLinearized || false;
  var i, v, di, dmin, dmax, ppadiplus, ppadiminus, vmin, vmax;
  function makePadAccessor(item) {
    if (Array.isArray(item)) {
      hasArrayOption = true;
      return function (i) {
        return Math.max(Number(item[i] || 0), 0);
      };
    } else {
      var v = Math.max(Number(item || 0), 0);
      return function () {
        return v;
      };
    }
  }
  var ppadplus = makePadAccessor((ax._m > 0 ? opts.ppadplus : opts.ppadminus) || opts.ppad || 0);
  var ppadminus = makePadAccessor((ax._m > 0 ? opts.ppadminus : opts.ppadplus) || opts.ppad || 0);
  var vpadplus = makePadAccessor(opts.vpadplus || opts.vpad);
  var vpadminus = makePadAccessor(opts.vpadminus || opts.vpad);
  if (!hasArrayOption) {
    // with no arrays other than `data` we don't need to consider
    // every point, only the extreme data points
    vmin = Infinity;
    vmax = -Infinity;
    if (isLog) {
      for (i = 0; i < len; i++) {
        v = data[i];
        // data is not linearized yet so we still have to filter out negative logs
        if (v < vmin && v > 0) vmin = v;
        if (v > vmax && v < FP_SAFE) vmax = v;
      }
    } else {
      for (i = 0; i < len; i++) {
        v = data[i];
        if (v < vmin && v > -FP_SAFE) vmin = v;
        if (v > vmax && v < FP_SAFE) vmax = v;
      }
    }
    data = [vmin, vmax];
    len = 2;
  }
  var collapseOpts = {
    tozero: tozero,
    extrapad: extrapad
  };
  function addItem(i) {
    di = data[i];
    if (!isNumeric(di)) return;
    ppadiplus = ppadplus(i);
    ppadiminus = ppadminus(i);
    if (vpadLinearized) {
      dmin = ax.c2l(di) - vpadminus(i);
      dmax = ax.c2l(di) + vpadplus(i);
    } else {
      vmin = di - vpadminus(i);
      vmax = di + vpadplus(i);
      // special case for log axes: if vpad makes this object span
      // more than an order of mag, clip it to one order. This is so
      // we don't have non-positive errors or absurdly large lower
      // range due to rounding errors
      if (isLog && vmin < vmax / 10) vmin = vmax / 10;
      dmin = ax.c2l(vmin);
      dmax = ax.c2l(vmax);
    }
    if (tozero) {
      dmin = Math.min(0, dmin);
      dmax = Math.max(0, dmax);
    }
    if (goodNumber(dmin)) {
      collapseMinArray(minArray, dmin, ppadiminus, collapseOpts);
    }
    if (goodNumber(dmax)) {
      collapseMaxArray(maxArray, dmax, ppadiplus, collapseOpts);
    }
  }

  // For efficiency covering monotonic or near-monotonic data,
  // check a few points at both ends first and then sweep
  // through the middle
  var iMax = Math.min(6, len);
  for (i = 0; i < iMax; i++) addItem(i);
  for (i = len - 1; i >= iMax; i--) addItem(i);
  return {
    min: minArray,
    max: maxArray,
    opts: opts
  };
}
function collapseMinArray(array, newVal, newPad, opts) {
  collapseArray(array, newVal, newPad, opts, lessOrEqual);
}
function collapseMaxArray(array, newVal, newPad, opts) {
  collapseArray(array, newVal, newPad, opts, greaterOrEqual);
}

/**
 * collapseArray
 *
 * Takes items from 'array' and compares them to 'newVal', 'newPad'.
 *
 * @param {array} array:
 *  current set of min or max extremes
 * @param {number} newVal:
 *  new value to compare against
 * @param {number} newPad:
 *  pad value associated with 'newVal'
 * @param {object} opts:
 *  - tozero {boolean}
 *  - extrapad {number}
 * @param {function} atLeastAsExtreme:
 *  comparison function, use
 *  - lessOrEqual for min 'array' and
 *  - greaterOrEqual for max 'array'
 *
 * In practice, 'array' is either
 *  - 'extremes[ax._id].min' or
 *  - 'extremes[ax._id].max
 *  found in traces and layout items that affect autorange.
 *
 * Since we don't yet know the relationship between pixels and values
 * (that's what we're trying to figure out!) AND we don't yet know how
 * many pixels `extrapad` represents (it's going to be 5% of the length,
 * but we don't want to have to redo calc just because length changed)
 * two point must satisfy three criteria simultaneously for one to supersede the other:
 *  - at least as extreme a `val`
 *  - at least as big a `pad`
 *  - an unpadded point cannot supersede a padded point, but any other combination can
 *
 * Then:
 * - If the item supersedes the new point, set includeThis false
 * - If the new pt supersedes the item, delete it from 'array'
 */
function collapseArray(array, newVal, newPad, opts, atLeastAsExtreme) {
  var tozero = opts.tozero;
  var extrapad = opts.extrapad;
  var includeThis = true;
  for (var j = 0; j < array.length && includeThis; j++) {
    var v = array[j];
    if (atLeastAsExtreme(v.val, newVal) && v.pad >= newPad && (v.extrapad || !extrapad)) {
      includeThis = false;
      break;
    } else if (atLeastAsExtreme(newVal, v.val) && v.pad <= newPad && (extrapad || !v.extrapad)) {
      array.splice(j, 1);
      j--;
    }
  }
  if (includeThis) {
    var clipAtZero = tozero && newVal === 0;
    array.push({
      val: newVal,
      pad: clipAtZero ? 0 : newPad,
      extrapad: clipAtZero ? false : extrapad
    });
  }
}

// In order to stop overflow errors, don't consider points
// too close to the limits of js floating point
function goodNumber(v) {
  return isNumeric(v) && Math.abs(v) < FP_SAFE;
}
function lessOrEqual(v0, v1) {
  return v0 <= v1;
}
function greaterOrEqual(v0, v1) {
  return v0 >= v1;
}
function applyAutorangeMinOptions(v, ax) {
  var autorangeoptions = ax.autorangeoptions;
  if (autorangeoptions && autorangeoptions.minallowed !== undefined && hasValidMinAndMax(ax, autorangeoptions.minallowed, autorangeoptions.maxallowed)) {
    return autorangeoptions.minallowed;
  }
  if (autorangeoptions && autorangeoptions.clipmin !== undefined && hasValidMinAndMax(ax, autorangeoptions.clipmin, autorangeoptions.clipmax)) {
    return Math.max(v, ax.d2l(autorangeoptions.clipmin));
  }
  return v;
}
function applyAutorangeMaxOptions(v, ax) {
  var autorangeoptions = ax.autorangeoptions;
  if (autorangeoptions && autorangeoptions.maxallowed !== undefined && hasValidMinAndMax(ax, autorangeoptions.minallowed, autorangeoptions.maxallowed)) {
    return autorangeoptions.maxallowed;
  }
  if (autorangeoptions && autorangeoptions.clipmax !== undefined && hasValidMinAndMax(ax, autorangeoptions.clipmin, autorangeoptions.clipmax)) {
    return Math.min(v, ax.d2l(autorangeoptions.clipmax));
  }
  return v;
}
function hasValidMinAndMax(ax, min, max) {
  // in case both min and max are defined, ensure min < max
  if (min !== undefined && max !== undefined) {
    min = ax.d2l(min);
    max = ax.d2l(max);
    return min < max;
  }
  return true;
}

// this function should be (and is) called before reversing the range
// so range[0] is the minimum and range[1] is the maximum
function applyAutorangeOptions(range, ax) {
  if (!ax || !ax.autorangeoptions) return range;
  var min = range[0];
  var max = range[1];
  var include = ax.autorangeoptions.include;
  if (include !== undefined) {
    var lMin = ax.d2l(min);
    var lMax = ax.d2l(max);
    if (!Lib.isArrayOrTypedArray(include)) include = [include];
    for (var i = 0; i < include.length; i++) {
      var v = ax.d2l(include[i]);
      if (lMin >= v) {
        lMin = v;
        min = v;
      }
      if (lMax <= v) {
        lMax = v;
        max = v;
      }
    }
  }
  min = applyAutorangeMinOptions(min, ax);
  max = applyAutorangeMaxOptions(max, ax);
  return [min, max];
}

/***/ }),

/***/ 75511:
/***/ (function(module) {

"use strict";


module.exports = function handleAutorangeOptionsDefaults(coerce, autorange, range) {
  var minRange, maxRange;
  if (range) {
    var isReversed = autorange === 'reversed' || autorange === 'min reversed' || autorange === 'max reversed';
    minRange = range[isReversed ? 1 : 0];
    maxRange = range[isReversed ? 0 : 1];
  }
  var minallowed = coerce('autorangeoptions.minallowed', maxRange === null ? minRange : undefined);
  var maxallowed = coerce('autorangeoptions.maxallowed', minRange === null ? maxRange : undefined);
  if (minallowed === undefined) coerce('autorangeoptions.clipmin');
  if (maxallowed === undefined) coerce('autorangeoptions.clipmax');
  coerce('autorangeoptions.include');
};

/***/ }),

/***/ 29714:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var isNumeric = __webpack_require__(10721);
var Plots = __webpack_require__(44122);
var Registry = __webpack_require__(33626);
var Lib = __webpack_require__(34809);
var strTranslate = Lib.strTranslate;
var svgTextUtils = __webpack_require__(30635);
var Titles = __webpack_require__(17240);
var Color = __webpack_require__(78766);
var Drawing = __webpack_require__(62203);
var axAttrs = __webpack_require__(25829);
var cleanTicks = __webpack_require__(68599);
var constants = __webpack_require__(63821);
var ONEMAXYEAR = constants.ONEMAXYEAR;
var ONEAVGYEAR = constants.ONEAVGYEAR;
var ONEMINYEAR = constants.ONEMINYEAR;
var ONEMAXQUARTER = constants.ONEMAXQUARTER;
var ONEAVGQUARTER = constants.ONEAVGQUARTER;
var ONEMINQUARTER = constants.ONEMINQUARTER;
var ONEMAXMONTH = constants.ONEMAXMONTH;
var ONEAVGMONTH = constants.ONEAVGMONTH;
var ONEMINMONTH = constants.ONEMINMONTH;
var ONEWEEK = constants.ONEWEEK;
var ONEDAY = constants.ONEDAY;
var HALFDAY = ONEDAY / 2;
var ONEHOUR = constants.ONEHOUR;
var ONEMIN = constants.ONEMIN;
var ONESEC = constants.ONESEC;
var ONEMILLI = constants.ONEMILLI;
var ONEMICROSEC = constants.ONEMICROSEC;
var MINUS_SIGN = constants.MINUS_SIGN;
var BADNUM = constants.BADNUM;
var ZERO_PATH = {
  K: 'zeroline'
};
var GRID_PATH = {
  K: 'gridline',
  L: 'path'
};
var MINORGRID_PATH = {
  K: 'minor-gridline',
  L: 'path'
};
var TICK_PATH = {
  K: 'tick',
  L: 'path'
};
var TICK_TEXT = {
  K: 'tick',
  L: 'text'
};
var MARGIN_MAPPING = {
  width: ['x', 'r', 'l', 'xl', 'xr'],
  height: ['y', 't', 'b', 'yt', 'yb'],
  right: ['r', 'xr'],
  left: ['l', 'xl'],
  top: ['t', 'yt'],
  bottom: ['b', 'yb']
};
var alignmentConstants = __webpack_require__(4530);
var MID_SHIFT = alignmentConstants.MID_SHIFT;
var CAP_SHIFT = alignmentConstants.CAP_SHIFT;
var LINE_SPACING = alignmentConstants.LINE_SPACING;
var OPPOSITE_SIDE = alignmentConstants.OPPOSITE_SIDE;
var TEXTPAD = 3;
var axes = module.exports = {};
axes.setConvert = __webpack_require__(19091);
var autoType = __webpack_require__(9666);
var axisIds = __webpack_require__(5975);
var idSort = axisIds.idSort;
var isLinked = axisIds.isLinked;

// tight coupling to chart studio
axes.id2name = axisIds.id2name;
axes.name2id = axisIds.name2id;
axes.cleanId = axisIds.cleanId;
axes.list = axisIds.list;
axes.listIds = axisIds.listIds;
axes.getFromId = axisIds.getFromId;
axes.getFromTrace = axisIds.getFromTrace;
var autorange = __webpack_require__(32919);
axes.getAutoRange = autorange.getAutoRange;
axes.findExtremes = autorange.findExtremes;
var epsilon = 0.0001;
function expandRange(range) {
  var delta = (range[1] - range[0]) * epsilon;
  return [range[0] - delta, range[1] + delta];
}

/*
 * find the list of possible axes to reference with an xref or yref attribute
 * and coerce it to that list
 *
 * attr: the attribute we're generating a reference for. Should end in 'x' or 'y'
 *     but can be prefixed, like 'ax' for annotation's arrow x
 * dflt: the default to coerce to, or blank to use the first axis (falling back on
 *     extraOption if there is no axis)
 * extraOption: aside from existing axes with this letter, what non-axis value is allowed?
 *     Only required if it's different from `dflt`
 */
axes.coerceRef = function (containerIn, containerOut, gd, attr, dflt, extraOption) {
  var axLetter = attr.charAt(attr.length - 1);
  var axlist = gd._fullLayout._subplots[axLetter + 'axis'];
  var refAttr = attr + 'ref';
  var attrDef = {};
  if (!dflt) dflt = axlist[0] || (typeof extraOption === 'string' ? extraOption : extraOption[0]);
  if (!extraOption) extraOption = dflt;
  axlist = axlist.concat(axlist.map(function (x) {
    return x + ' domain';
  }));

  // data-ref annotations are not supported in gl2d yet

  attrDef[refAttr] = {
    valType: 'enumerated',
    values: axlist.concat(extraOption ? typeof extraOption === 'string' ? [extraOption] : extraOption : []),
    dflt: dflt
  };

  // xref, yref
  return Lib.coerce(containerIn, containerOut, attrDef, refAttr);
};

/*
 * Get the type of an axis reference. This can be 'range', 'domain', or 'paper'.
 * This assumes ar is a valid axis reference and returns 'range' if it doesn't
 * match the patterns for 'paper' or 'domain'.
 *
 * ar: the axis reference string
 *
 */
axes.getRefType = function (ar) {
  if (ar === undefined) {
    return ar;
  }
  if (ar === 'paper') {
    return 'paper';
  }
  if (ar === 'pixel') {
    return 'pixel';
  }
  if (/( domain)$/.test(ar)) {
    return 'domain';
  } else {
    return 'range';
  }
};

/*
 * coerce position attributes (range-type) that can be either on axes or absolute
 * (paper or pixel) referenced. The biggest complication here is that we don't know
 * before looking at the axis whether the value must be a number or not (it may be
 * a date string), so we can't use the regular valType='number' machinery
 *
 * axRef (string): the axis this position is referenced to, or:
 *     paper: fraction of the plot area
 *     pixel: pixels relative to some starting position
 * attr (string): the attribute in containerOut we are coercing
 * dflt (number): the default position, as a fraction or pixels. If the attribute
 *     is to be axis-referenced, this will be converted to an axis data value
 *
 * Also cleans the values, since the attribute definition itself has to say
 * valType: 'any' to handle date axes. This allows us to accept:
 * - for category axes: category names, and convert them here into serial numbers.
 *   Note that this will NOT work for axis range endpoints, because we don't know
 *   the category list yet (it's set by ax.makeCalcdata during calc)
 *   but it works for component (note, shape, images) positions.
 * - for date axes: JS Dates or milliseconds, and convert to date strings
 * - for other types: coerce them to numbers
 */
axes.coercePosition = function (containerOut, gd, coerce, axRef, attr, dflt) {
  var cleanPos, pos;
  var axRefType = axes.getRefType(axRef);
  if (axRefType !== 'range') {
    cleanPos = Lib.ensureNumber;
    pos = coerce(attr, dflt);
  } else {
    var ax = axes.getFromId(gd, axRef);
    dflt = ax.fraction2r(dflt);
    pos = coerce(attr, dflt);
    cleanPos = ax.cleanPos;
  }
  containerOut[attr] = cleanPos(pos);
};
axes.cleanPosition = function (pos, gd, axRef) {
  var cleanPos = axRef === 'paper' || axRef === 'pixel' ? Lib.ensureNumber : axes.getFromId(gd, axRef).cleanPos;
  return cleanPos(pos);
};
axes.redrawComponents = function (gd, axIds) {
  axIds = axIds ? axIds : axes.listIds(gd);
  var fullLayout = gd._fullLayout;
  function _redrawOneComp(moduleName, methodName, stashName, shortCircuit) {
    var method = Registry.getComponentMethod(moduleName, methodName);
    var stash = {};
    for (var i = 0; i < axIds.length; i++) {
      var ax = fullLayout[axes.id2name(axIds[i])];
      var indices = ax[stashName];
      for (var j = 0; j < indices.length; j++) {
        var ind = indices[j];
        if (!stash[ind]) {
          method(gd, ind);
          stash[ind] = 1;
          // once is enough for images (which doesn't use the `i` arg anyway)
          if (shortCircuit) return;
        }
      }
    }
  }

  // annotations and shapes 'draw' method is slow,
  // use the finer-grained 'drawOne' method instead
  _redrawOneComp('annotations', 'drawOne', '_annIndices');
  _redrawOneComp('shapes', 'drawOne', '_shapeIndices');
  _redrawOneComp('images', 'draw', '_imgIndices', true);
  _redrawOneComp('selections', 'drawOne', '_selectionIndices');
};
var getDataConversions = axes.getDataConversions = function (gd, trace, target, targetArray) {
  var ax;

  // If target points to an axis, use the type we already have for that
  // axis to find the data type. Otherwise use the values to autotype.
  var d2cTarget = target === 'x' || target === 'y' || target === 'z' ? target : targetArray;

  // In the case of an array target, make a mock data array
  // and call supplyDefaults to the data type and
  // setup the data-to-calc method.
  if (Lib.isArrayOrTypedArray(d2cTarget)) {
    ax = {
      type: autoType(targetArray, undefined, {
        autotypenumbers: gd._fullLayout.autotypenumbers
      }),
      _categories: []
    };
    axes.setConvert(ax);

    // build up ax._categories (usually done during ax.makeCalcdata()
    if (ax.type === 'category') {
      for (var i = 0; i < targetArray.length; i++) {
        ax.d2c(targetArray[i]);
      }
    }
    // TODO what to do for transforms?
  } else {
    ax = axes.getFromTrace(gd, trace, d2cTarget);
  }

  // if 'target' has corresponding axis
  // -> use setConvert method
  if (ax) return {
    d2c: ax.d2c,
    c2d: ax.c2d
  };

  // special case for 'ids'
  // -> cast to String
  if (d2cTarget === 'ids') return {
    d2c: toString,
    c2d: toString
  };

  // otherwise (e.g. numeric-array of 'marker.color' or 'marker.size')
  // -> cast to Number

  return {
    d2c: toNum,
    c2d: toNum
  };
};
function toNum(v) {
  return +v;
}
function toString(v) {
  return String(v);
}
axes.getDataToCoordFunc = function (gd, trace, target, targetArray) {
  return getDataConversions(gd, trace, target, targetArray).d2c;
};

// get counteraxis letter for this axis (name or id)
// this can also be used as the id for default counter axis
axes.counterLetter = function (id) {
  var axLetter = id.charAt(0);
  if (axLetter === 'x') return 'y';
  if (axLetter === 'y') return 'x';
};

// incorporate a new minimum difference and first tick into
// forced
// note that _forceTick0 is linearized, so needs to be turned into
// a range value for setting tick0
axes.minDtick = function (ax, newDiff, newFirst, allow) {
  // doesn't make sense to do forced min dTick on log or category axes,
  // and the plot itself may decide to cancel (ie non-grouped bars)
  if (['log', 'category', 'multicategory'].indexOf(ax.type) !== -1 || !allow) {
    ax._minDtick = 0;
  } else if (ax._minDtick === undefined) {
    // undefined means there's nothing there yet

    ax._minDtick = newDiff;
    ax._forceTick0 = newFirst;
  } else if (ax._minDtick) {
    if ((ax._minDtick / newDiff + 1e-6) % 1 < 2e-6 &&
    // existing minDtick is an integer multiple of newDiff
    // (within rounding err)
    // and forceTick0 can be shifted to newFirst

    ((newFirst - ax._forceTick0) / newDiff % 1 + 1.000001) % 1 < 2e-6) {
      ax._minDtick = newDiff;
      ax._forceTick0 = newFirst;
    } else if ((newDiff / ax._minDtick + 1e-6) % 1 > 2e-6 ||
    // if the converse is true (newDiff is a multiple of minDtick and
    // newFirst can be shifted to forceTick0) then do nothing - same
    // forcing stands. Otherwise, cancel forced minimum

    ((newFirst - ax._forceTick0) / ax._minDtick % 1 + 1.000001) % 1 > 2e-6) {
      ax._minDtick = 0;
    }
  }
};

// save a copy of the initial axis ranges in fullLayout
// use them in mode bar and dblclick events
axes.saveRangeInitial = function (gd, overwrite) {
  var axList = axes.list(gd, '', true);
  var hasOneAxisChanged = false;
  for (var i = 0; i < axList.length; i++) {
    var ax = axList[i];
    var isNew = ax._rangeInitial0 === undefined && ax._rangeInitial1 === undefined;
    var hasChanged = isNew || ax.range[0] !== ax._rangeInitial0 || ax.range[1] !== ax._rangeInitial1;
    var autorange = ax.autorange;
    if (isNew && autorange !== true || overwrite && hasChanged) {
      ax._rangeInitial0 = autorange === 'min' || autorange === 'max reversed' ? undefined : ax.range[0];
      ax._rangeInitial1 = autorange === 'max' || autorange === 'min reversed' ? undefined : ax.range[1];
      ax._autorangeInitial = autorange;
      hasOneAxisChanged = true;
    }
  }
  return hasOneAxisChanged;
};

// save a copy of the initial spike visibility
axes.saveShowSpikeInitial = function (gd, overwrite) {
  var axList = axes.list(gd, '', true);
  var hasOneAxisChanged = false;
  var allSpikesEnabled = 'on';
  for (var i = 0; i < axList.length; i++) {
    var ax = axList[i];
    var isNew = ax._showSpikeInitial === undefined;
    var hasChanged = isNew || !(ax.showspikes === ax._showspikes);
    if (isNew || overwrite && hasChanged) {
      ax._showSpikeInitial = ax.showspikes;
      hasOneAxisChanged = true;
    }
    if (allSpikesEnabled === 'on' && !ax.showspikes) {
      allSpikesEnabled = 'off';
    }
  }
  gd._fullLayout._cartesianSpikesEnabled = allSpikesEnabled;
  return hasOneAxisChanged;
};
axes.autoBin = function (data, ax, nbins, is2d, calendar, size) {
  var dataMin = Lib.aggNums(Math.min, null, data);
  var dataMax = Lib.aggNums(Math.max, null, data);
  if (ax.type === 'category' || ax.type === 'multicategory') {
    return {
      start: dataMin - 0.5,
      end: dataMax + 0.5,
      size: Math.max(1, Math.round(size) || 1),
      _dataSpan: dataMax - dataMin
    };
  }
  if (!calendar) calendar = ax.calendar;

  // piggyback off tick code to make "nice" bin sizes and edges
  var dummyAx;
  if (ax.type === 'log') {
    dummyAx = {
      type: 'linear',
      range: [dataMin, dataMax]
    };
  } else {
    dummyAx = {
      type: ax.type,
      range: Lib.simpleMap([dataMin, dataMax], ax.c2r, 0, calendar),
      calendar: calendar
    };
  }
  axes.setConvert(dummyAx);
  size = size && cleanTicks.dtick(size, dummyAx.type);
  if (size) {
    dummyAx.dtick = size;
    dummyAx.tick0 = cleanTicks.tick0(undefined, dummyAx.type, calendar);
  } else {
    var size0;
    if (nbins) size0 = (dataMax - dataMin) / nbins;else {
      // totally auto: scale off std deviation so the highest bin is
      // somewhat taller than the total number of bins, but don't let
      // the size get smaller than the 'nice' rounded down minimum
      // difference between values
      var distinctData = Lib.distinctVals(data);
      var msexp = Math.pow(10, Math.floor(Math.log(distinctData.minDiff) / Math.LN10));
      var minSize = msexp * Lib.roundUp(distinctData.minDiff / msexp, [0.9, 1.9, 4.9, 9.9], true);
      size0 = Math.max(minSize, 2 * Lib.stdev(data) / Math.pow(data.length, is2d ? 0.25 : 0.4));

      // fallback if ax.d2c output BADNUMs
      // e.g. when user try to plot categorical bins
      // on a layout.xaxis.type: 'linear'
      if (!isNumeric(size0)) size0 = 1;
    }
    axes.autoTicks(dummyAx, size0);
  }
  var finalSize = dummyAx.dtick;
  var binStart = axes.tickIncrement(axes.tickFirst(dummyAx), finalSize, 'reverse', calendar);
  var binEnd, bincount;

  // check for too many data points right at the edges of bins
  // (>50% within 1% of bin edges) or all data points integral
  // and offset the bins accordingly
  if (typeof finalSize === 'number') {
    binStart = autoShiftNumericBins(binStart, data, dummyAx, dataMin, dataMax);
    bincount = 1 + Math.floor((dataMax - binStart) / finalSize);
    binEnd = binStart + bincount * finalSize;
  } else {
    // month ticks - should be the only nonlinear kind we have at this point.
    // dtick (as supplied by axes.autoTick) only has nonlinear values on
    // date and log axes, but even if you display a histogram on a log axis
    // we bin it on a linear axis (which one could argue against, but that's
    // a separate issue)
    if (dummyAx.dtick.charAt(0) === 'M') {
      binStart = autoShiftMonthBins(binStart, data, finalSize, dataMin, calendar);
    }

    // calculate the endpoint for nonlinear ticks - you have to
    // just increment until you're done
    binEnd = binStart;
    bincount = 0;
    while (binEnd <= dataMax) {
      binEnd = axes.tickIncrement(binEnd, finalSize, false, calendar);
      bincount++;
    }
  }
  return {
    start: ax.c2r(binStart, 0, calendar),
    end: ax.c2r(binEnd, 0, calendar),
    size: finalSize,
    _dataSpan: dataMax - dataMin
  };
};
function autoShiftNumericBins(binStart, data, ax, dataMin, dataMax) {
  var edgecount = 0;
  var midcount = 0;
  var intcount = 0;
  var blankCount = 0;
  function nearEdge(v) {
    // is a value within 1% of a bin edge?
    return (1 + (v - binStart) * 100 / ax.dtick) % 100 < 2;
  }
  for (var i = 0; i < data.length; i++) {
    if (data[i] % 1 === 0) intcount++;else if (!isNumeric(data[i])) blankCount++;
    if (nearEdge(data[i])) edgecount++;
    if (nearEdge(data[i] + ax.dtick / 2)) midcount++;
  }
  var dataCount = data.length - blankCount;
  if (intcount === dataCount && ax.type !== 'date') {
    if (ax.dtick < 1) {
      // all integers: if bin size is <1, it's because
      // that was specifically requested (large nbins)
      // so respect that... but center the bins containing
      // integers on those integers

      binStart = dataMin - 0.5 * ax.dtick;
    } else {
      // otherwise start half an integer down regardless of
      // the bin size, just enough to clear up endpoint
      // ambiguity about which integers are in which bins.

      binStart -= 0.5;
      if (binStart + ax.dtick < dataMin) binStart += ax.dtick;
    }
  } else if (midcount < dataCount * 0.1) {
    if (edgecount > dataCount * 0.3 || nearEdge(dataMin) || nearEdge(dataMax)) {
      // lots of points at the edge, not many in the middle
      // shift half a bin
      var binshift = ax.dtick / 2;
      binStart += binStart + binshift < dataMin ? binshift : -binshift;
    }
  }
  return binStart;
}
function autoShiftMonthBins(binStart, data, dtick, dataMin, calendar) {
  var stats = Lib.findExactDates(data, calendar);
  // number of data points that needs to be an exact value
  // to shift that increment to (near) the bin center
  var threshold = 0.8;
  if (stats.exactDays > threshold) {
    var numMonths = Number(dtick.substr(1));
    if (stats.exactYears > threshold && numMonths % 12 === 0) {
      // The exact middle of a non-leap-year is 1.5 days into July
      // so if we start the bins here, all but leap years will
      // get hover-labeled as exact years.
      binStart = axes.tickIncrement(binStart, 'M6', 'reverse') + ONEDAY * 1.5;
    } else if (stats.exactMonths > threshold) {
      // Months are not as clean, but if we shift half the *longest*
      // month (31/2 days) then 31-day months will get labeled exactly
      // and shorter months will get labeled with the correct month
      // but shifted 12-36 hours into it.
      binStart = axes.tickIncrement(binStart, 'M1', 'reverse') + ONEDAY * 15.5;
    } else {
      // Shifting half a day is exact, but since these are month bins it
      // will always give a somewhat odd-looking label, until we do something
      // smarter like showing the bin boundaries (or the bounds of the actual
      // data in each bin)
      binStart -= HALFDAY;
    }
    var nextBinStart = axes.tickIncrement(binStart, dtick);
    if (nextBinStart <= dataMin) return nextBinStart;
  }
  return binStart;
}

// ----------------------------------------------------
// Ticks and grids
// ----------------------------------------------------

// ensure we have minor tick0 and dtick calculated
axes.prepMinorTicks = function (mockAx, ax, opts) {
  if (!ax.minor.dtick) {
    delete mockAx.dtick;
    var hasMajor = ax.dtick && isNumeric(ax._tmin);
    var mockMinorRange;
    if (hasMajor) {
      var tick2 = axes.tickIncrement(ax._tmin, ax.dtick, true);
      // mock range a tiny bit smaller than one major tick interval
      mockMinorRange = [ax._tmin, tick2 * 0.99 + ax._tmin * 0.01];
    } else {
      var rl = Lib.simpleMap(ax.range, ax.r2l);
      // If we don't have a major dtick, the concept of minor ticks is a little
      // ambiguous - just take a stab and say minor.nticks should span 1/5 the axis
      mockMinorRange = [rl[0], 0.8 * rl[0] + 0.2 * rl[1]];
    }
    mockAx.range = Lib.simpleMap(mockMinorRange, ax.l2r);
    mockAx._isMinor = true;
    axes.prepTicks(mockAx, opts);
    if (hasMajor) {
      var numericMajor = isNumeric(ax.dtick);
      var numericMinor = isNumeric(mockAx.dtick);
      var majorNum = numericMajor ? ax.dtick : +ax.dtick.substring(1);
      var minorNum = numericMinor ? mockAx.dtick : +mockAx.dtick.substring(1);
      if (numericMajor && numericMinor) {
        if (!isMultiple(majorNum, minorNum)) {
          // give up on minor ticks - outside the below exceptions,
          // this can only happen if minor.nticks is smaller than two jumps
          // in the auto-tick scale and the first jump is not an even multiple
          // (5 -> 2 or for dates 3 ->2, 15 -> 10 etc)  or if you provided
          // an explicit dtick, in which case it's fine to give up,
          // you can provide an explicit minor.dtick.
          if (majorNum === 2 * ONEWEEK && minorNum === 3 * ONEDAY) {
            mockAx.dtick = ONEWEEK;
          } else if (majorNum === ONEWEEK && !(ax._input.minor || {}).nticks) {
            // minor.nticks defaults to 5, but in this one case we want 7,
            // so the minor ticks show on all days of the week
            mockAx.dtick = ONEDAY;
          } else if (isClose(majorNum / minorNum, 2.5)) {
            // 5*10^n -> 2*10^n and you've set nticks < 5
            // quarters are pretty common, we don't do this by default as it
            // would add an extra digit to display, but minor has no labels
            mockAx.dtick = majorNum / 2;
          } else {
            mockAx.dtick = majorNum;
          }
        } else if (majorNum === 2 * ONEWEEK && minorNum === 2 * ONEDAY) {
          // this is a weird one: we don't want to automatically choose
          // 2-day minor ticks for 2-week major, even though it IS an even multiple,
          // because people would expect to see the weeks clearly
          mockAx.dtick = ONEWEEK;
        }
      } else if (String(ax.dtick).charAt(0) === 'M') {
        if (numericMinor) {
          mockAx.dtick = 'M1';
        } else {
          if (!isMultiple(majorNum, minorNum)) {
            // unless you provided an explicit ax.dtick (in which case
            // it's OK for us to give up, you can provide an explicit
            // minor.dtick too), this can only happen with:
            // minor.nticks < 3 and dtick === M3, or
            // minor.nticks < 5 and dtick === 5 * 10^n years
            // so in all cases we just give up.
            mockAx.dtick = ax.dtick;
          } else if (majorNum >= 12 && minorNum === 2) {
            // another special carve-out: for year major ticks, don't show
            // 2-month minor ticks, bump to quarters
            mockAx.dtick = 'M3';
          }
        }
      } else if (String(mockAx.dtick).charAt(0) === 'L') {
        if (String(ax.dtick).charAt(0) === 'L') {
          if (!isMultiple(majorNum, minorNum)) {
            mockAx.dtick = isClose(majorNum / minorNum, 2.5) ? ax.dtick / 2 : ax.dtick;
          }
        } else {
          mockAx.dtick = 'D1';
        }
      } else if (mockAx.dtick === 'D2' && +ax.dtick > 1) {
        // the D2 log axis tick spacing is confusing for unlabeled minor ticks if
        // the major dtick is more than one order of magnitude.
        mockAx.dtick = 1;
      }
    }
    // put back the original range, to use to find the full set of minor ticks
    mockAx.range = ax.range;
  }
  if (ax.minor._tick0Init === undefined) {
    // ensure identical tick0
    mockAx.tick0 = ax.tick0;
  }
};
function isMultiple(bigger, smaller) {
  return Math.abs((bigger / smaller + 0.5) % 1 - 0.5) < 0.001;
}
function isClose(a, b) {
  return Math.abs(a / b - 1) < 0.001;
}

// ensure we have tick0, dtick, and tick rounding calculated
axes.prepTicks = function (ax, opts) {
  var rng = Lib.simpleMap(ax.range, ax.r2l, undefined, undefined, opts);

  // calculate max number of (auto) ticks to display based on plot size
  if (ax.tickmode === 'auto' || !ax.dtick) {
    var nt = ax.nticks;
    var minPx;
    if (!nt) {
      if (ax.type === 'category' || ax.type === 'multicategory') {
        minPx = ax.tickfont ? Lib.bigFont(ax.tickfont.size || 12) : 15;
        nt = ax._length / minPx;
      } else {
        minPx = ax._id.charAt(0) === 'y' ? 40 : 80;
        nt = Lib.constrain(ax._length / minPx, 4, 9) + 1;
      }

      // radial axes span half their domain,
      // multiply nticks value by two to get correct number of auto ticks.
      if (ax._name === 'radialaxis') nt *= 2;
    }
    if (!(ax.minor && ax.minor.tickmode !== 'array')) {
      // add a couple of extra digits for filling in ticks when we
      // have explicit tickvals without tick text
      if (ax.tickmode === 'array') nt *= 100;
    }
    ax._roughDTick = Math.abs(rng[1] - rng[0]) / nt;
    axes.autoTicks(ax, ax._roughDTick);

    // check for a forced minimum dtick
    if (ax._minDtick > 0 && ax.dtick < ax._minDtick * 2) {
      ax.dtick = ax._minDtick;
      ax.tick0 = ax.l2r(ax._forceTick0);
    }
  }
  if (ax.ticklabelmode === 'period') {
    adjustPeriodDelta(ax);
  }

  // check for missing tick0
  if (!ax.tick0) {
    ax.tick0 = ax.type === 'date' ? '2000-01-01' : 0;
  }

  // ensure we don't try to make ticks below our minimum precision
  // see https://github.com/plotly/plotly.js/issues/2892
  if (ax.type === 'date' && ax.dtick < 0.1) ax.dtick = 0.1;

  // now figure out rounding of tick values
  autoTickRound(ax);
};
function nMonths(dtick) {
  return +dtick.substring(1);
}
function adjustPeriodDelta(ax) {
  // adjusts ax.dtick and sets ax._definedDelta
  var definedDelta;
  function mDate() {
    return !(isNumeric(ax.dtick) || ax.dtick.charAt(0) !== 'M');
  }
  var isMDate = mDate();
  var tickformat = axes.getTickFormat(ax);
  if (tickformat) {
    var noDtick = ax._dtickInit !== ax.dtick;
    if (!/%[fLQsSMX]/.test(tickformat)
    // %f: microseconds as a decimal number [000000, 999999]
    // %L: milliseconds as a decimal number [000, 999]
    // %Q: milliseconds since UNIX epoch
    // %s: seconds since UNIX epoch
    // %S: second as a decimal number [00,61]
    // %M: minute as a decimal number [00,59]
    // %X: the locale’s time, such as %-I:%M:%S %p
    ) {
      if (/%[HI]/.test(tickformat)
      // %H: hour (24-hour clock) as a decimal number [00,23]
      // %I: hour (12-hour clock) as a decimal number [01,12]
      ) {
        definedDelta = ONEHOUR;
        if (noDtick && !isMDate && ax.dtick < ONEHOUR) ax.dtick = ONEHOUR;
      } else if (/%p/.test(tickformat) // %p: either AM or PM
      ) {
        definedDelta = HALFDAY;
        if (noDtick && !isMDate && ax.dtick < HALFDAY) ax.dtick = HALFDAY;
      } else if (/%[Aadejuwx]/.test(tickformat)
      // %A: full weekday name
      // %a: abbreviated weekday name
      // %d: zero-padded day of the month as a decimal number [01,31]
      // %e: space-padded day of the month as a decimal number [ 1,31]
      // %j: day of the year as a decimal number [001,366]
      // %u: Monday-based (ISO 8601) weekday as a decimal number [1,7]
      // %w: Sunday-based weekday as a decimal number [0,6]
      // %x: the locale’s date, such as %-m/%-d/%Y
      ) {
        definedDelta = ONEDAY;
        if (noDtick && !isMDate && ax.dtick < ONEDAY) ax.dtick = ONEDAY;
      } else if (/%[UVW]/.test(tickformat)
      // %U: Sunday-based week of the year as a decimal number [00,53]
      // %V: ISO 8601 week of the year as a decimal number [01, 53]
      // %W: Monday-based week of the year as a decimal number [00,53]
      ) {
        definedDelta = ONEWEEK;
        if (noDtick && !isMDate && ax.dtick < ONEWEEK) ax.dtick = ONEWEEK;
      } else if (/%[Bbm]/.test(tickformat)
      // %B: full month name
      // %b: abbreviated month name
      // %m: month as a decimal number [01,12]
      ) {
        definedDelta = ONEAVGMONTH;
        if (noDtick && (isMDate ? nMonths(ax.dtick) < 1 : ax.dtick < ONEMINMONTH)) ax.dtick = 'M1';
      } else if (/%[q]/.test(tickformat)
      // %q: quarter of the year as a decimal number [1,4]
      ) {
        definedDelta = ONEAVGQUARTER;
        if (noDtick && (isMDate ? nMonths(ax.dtick) < 3 : ax.dtick < ONEMINQUARTER)) ax.dtick = 'M3';
      } else if (/%[Yy]/.test(tickformat)
      // %Y: year with century as a decimal number, such as 1999
      // %y: year without century as a decimal number [00,99]
      ) {
        definedDelta = ONEAVGYEAR;
        if (noDtick && (isMDate ? nMonths(ax.dtick) < 12 : ax.dtick < ONEMINYEAR)) ax.dtick = 'M12';
      }
    }
  }
  isMDate = mDate();
  if (isMDate && ax.tick0 === ax._dowTick0) {
    // discard Sunday/Monday tweaks
    ax.tick0 = ax._rawTick0;
  }
  ax._definedDelta = definedDelta;
}
function positionPeriodTicks(tickVals, ax, definedDelta) {
  for (var i = 0; i < tickVals.length; i++) {
    var v = tickVals[i].value;
    var a = i;
    var b = i + 1;
    if (i < tickVals.length - 1) {
      a = i;
      b = i + 1;
    } else if (i > 0) {
      a = i - 1;
      b = i;
    } else {
      a = i;
      b = i;
    }
    var A = tickVals[a].value;
    var B = tickVals[b].value;
    var actualDelta = Math.abs(B - A);
    var delta = definedDelta || actualDelta;
    var periodLength = 0;
    if (delta >= ONEMINYEAR) {
      if (actualDelta >= ONEMINYEAR && actualDelta <= ONEMAXYEAR) {
        periodLength = actualDelta;
      } else {
        periodLength = ONEAVGYEAR;
      }
    } else if (definedDelta === ONEAVGQUARTER && delta >= ONEMINQUARTER) {
      if (actualDelta >= ONEMINQUARTER && actualDelta <= ONEMAXQUARTER) {
        periodLength = actualDelta;
      } else {
        periodLength = ONEAVGQUARTER;
      }
    } else if (delta >= ONEMINMONTH) {
      if (actualDelta >= ONEMINMONTH && actualDelta <= ONEMAXMONTH) {
        periodLength = actualDelta;
      } else {
        periodLength = ONEAVGMONTH;
      }
    } else if (definedDelta === ONEWEEK && delta >= ONEWEEK) {
      periodLength = ONEWEEK;
    } else if (delta >= ONEDAY) {
      periodLength = ONEDAY;
    } else if (definedDelta === HALFDAY && delta >= HALFDAY) {
      periodLength = HALFDAY;
    } else if (definedDelta === ONEHOUR && delta >= ONEHOUR) {
      periodLength = ONEHOUR;
    }
    var inBetween;
    if (periodLength >= actualDelta) {
      // ensure new label positions remain between ticks
      periodLength = actualDelta;
      inBetween = true;
    }
    var endPeriod = v + periodLength;
    if (ax.rangebreaks && periodLength > 0) {
      var nAll = 84; // highly divisible 7 * 12
      var n = 0;
      for (var c = 0; c < nAll; c++) {
        var r = (c + 0.5) / nAll;
        if (ax.maskBreaks(v * (1 - r) + r * endPeriod) !== BADNUM) n++;
      }
      periodLength *= n / nAll;
      if (!periodLength) {
        tickVals[i].drop = true;
      }
      if (inBetween && actualDelta > ONEWEEK) periodLength = actualDelta; // center monthly & longer periods
    }
    if (periodLength > 0 ||
    // not instant
    i === 0 // taking care first tick added
    ) {
      tickVals[i].periodX = v + periodLength / 2;
    }
  }
}

// calculate the ticks: text, values, positioning
// if ticks are set to automatic, determine the right values (tick0,dtick)
// in any case, set tickround to # of digits to round tick labels to,
// or codes to this effect for log and date scales
axes.calcTicks = function calcTicks(ax, opts) {
  var type = ax.type;
  var calendar = ax.calendar;
  var ticklabelstep = ax.ticklabelstep;
  var isPeriod = ax.ticklabelmode === 'period';
  var isReversed = ax.range[0] > ax.range[1];
  var ticklabelIndex = !ax.ticklabelindex || Lib.isArrayOrTypedArray(ax.ticklabelindex) ? ax.ticklabelindex : [ax.ticklabelindex];
  var rng = Lib.simpleMap(ax.range, ax.r2l, undefined, undefined, opts);
  var axrev = rng[1] < rng[0];
  var minRange = Math.min(rng[0], rng[1]);
  var maxRange = Math.max(rng[0], rng[1]);
  var maxTicks = Math.max(1000, ax._length || 0);
  var ticksOut = [];
  var minorTicks = [];
  var tickVals = [];
  var minorTickVals = [];
  // all ticks for which labels are drawn which is not necessarily the major ticks when
  // `ticklabelindex` is set.
  var allTicklabelVals = [];
  var hasMinor = ax.minor && (ax.minor.ticks || ax.minor.showgrid);

  // calc major first
  for (var major = 1; major >= (hasMinor ? 0 : 1); major--) {
    var isMinor = !major;
    if (major) {
      ax._dtickInit = ax.dtick;
      ax._tick0Init = ax.tick0;
    } else {
      ax.minor._dtickInit = ax.minor.dtick;
      ax.minor._tick0Init = ax.minor.tick0;
    }
    var mockAx = major ? ax : Lib.extendFlat({}, ax, ax.minor);
    if (isMinor) {
      axes.prepMinorTicks(mockAx, ax, opts);
    } else {
      axes.prepTicks(mockAx, opts);
    }

    // now that we've figured out the auto values for formatting
    // in case we're missing some ticktext, we can break out for array ticks
    if (mockAx.tickmode === 'array') {
      if (major) {
        tickVals = [];
        ticksOut = arrayTicks(ax, !isMinor);
      } else {
        minorTickVals = [];
        minorTicks = arrayTicks(ax, !isMinor);
      }
      continue;
    }

    // fill tickVals based on overlaying axis
    if (mockAx.tickmode === 'sync') {
      tickVals = [];
      ticksOut = syncTicks(ax);
      continue;
    }

    // add a tiny bit so we get ticks which may have rounded out
    var exRng = expandRange(rng);
    var startTick = exRng[0];
    var endTick = exRng[1];
    var numDtick = isNumeric(mockAx.dtick);
    var isDLog = type === 'log' && !(numDtick || mockAx.dtick.charAt(0) === 'L');

    // find the first tick
    var x0 = axes.tickFirst(mockAx, opts);
    if (major) {
      ax._tmin = x0;

      // No visible ticks? Quit.
      // I've only seen this on category axes with all categories off the edge.
      if (x0 < startTick !== axrev) break;

      // return the full set of tick vals
      if (type === 'category' || type === 'multicategory') {
        endTick = axrev ? Math.max(-0.5, endTick) : Math.min(ax._categories.length - 0.5, endTick);
      }
    }
    var prevX = null;
    var x = x0;
    var majorId;
    if (major) {
      // ids for ticklabelstep
      var _dTick;
      if (numDtick) {
        _dTick = ax.dtick;
      } else {
        if (type === 'date') {
          if (typeof ax.dtick === 'string' && ax.dtick.charAt(0) === 'M') {
            _dTick = ONEAVGMONTH * ax.dtick.substring(1);
          }
        } else {
          _dTick = ax._roughDTick;
        }
      }
      majorId = Math.round((ax.r2l(x) - ax.r2l(ax.tick0)) / _dTick) - 1;
    }
    var dtick = mockAx.dtick;
    if (mockAx.rangebreaks && mockAx._tick0Init !== mockAx.tick0) {
      // adjust tick0
      x = moveOutsideBreak(x, ax);
      if (!axrev) {
        x = axes.tickIncrement(x, dtick, !axrev, calendar);
      }
    }
    if (major && isPeriod) {
      // add one item to label period before tick0
      x = axes.tickIncrement(x, dtick, !axrev, calendar);
      majorId--;
    }
    for (; axrev ? x >= endTick : x <= endTick; x = axes.tickIncrement(x, dtick, axrev, calendar)) {
      if (major) majorId++;
      if (mockAx.rangebreaks) {
        if (!axrev) {
          if (x < startTick) continue;
          if (mockAx.maskBreaks(x) === BADNUM && moveOutsideBreak(x, mockAx) >= maxRange) break;
        }
      }

      // prevent infinite loops - no more than one tick per pixel,
      // and make sure each value is different from the previous
      if (tickVals.length > maxTicks || x === prevX) break;
      prevX = x;
      var obj = {
        value: x
      };
      if (major) {
        if (isDLog && x !== (x | 0)) {
          obj.simpleLabel = true;
        }
        if (ticklabelstep > 1 && majorId % ticklabelstep) {
          obj.skipLabel = true;
        }
        tickVals.push(obj);
      } else {
        obj.minor = true;
        minorTickVals.push(obj);
      }
    }
  }

  // check if ticklabelIndex makes sense, otherwise ignore it
  if (!minorTickVals || minorTickVals.length < 2) {
    ticklabelIndex = false;
  } else {
    var diff = (minorTickVals[1].value - minorTickVals[0].value) * (isReversed ? -1 : 1);
    if (!periodCompatibleWithTickformat(diff, ax.tickformat)) {
      ticklabelIndex = false;
    }
  }
  // Determine for which ticks to draw labels
  if (!ticklabelIndex) {
    allTicklabelVals = tickVals;
  } else {
    // Collect and sort all major and minor ticks, to find the minor ticks `ticklabelIndex`
    // steps away from each major tick. For those minor ticks we want to draw the label.

    var allTickVals = tickVals.concat(minorTickVals);
    if (isPeriod && tickVals.length) {
      // first major tick was just added for period handling
      allTickVals = allTickVals.slice(1);
    }
    allTickVals = allTickVals.sort(function (a, b) {
      return a.value - b.value;
    }).filter(function (tick, index, self) {
      return index === 0 || tick.value !== self[index - 1].value;
    });
    var majorTickIndices = allTickVals.map(function (item, index) {
      return item.minor === undefined && !item.skipLabel ? index : null;
    }).filter(function (index) {
      return index !== null;
    });
    majorTickIndices.forEach(function (majorIdx) {
      ticklabelIndex.map(function (nextLabelIdx) {
        var minorIdx = majorIdx + nextLabelIdx;
        if (minorIdx >= 0 && minorIdx < allTickVals.length) {
          Lib.pushUnique(allTicklabelVals, allTickVals[minorIdx]);
        }
      });
    });
  }
  if (hasMinor) {
    var canOverlap = ax.minor.ticks === 'inside' && ax.ticks === 'outside' || ax.minor.ticks === 'outside' && ax.ticks === 'inside';
    if (!canOverlap) {
      // remove duplicate minors

      var majorValues = tickVals.map(function (d) {
        return d.value;
      });
      var list = [];
      for (var k = 0; k < minorTickVals.length; k++) {
        var T = minorTickVals[k];
        var v = T.value;
        if (majorValues.indexOf(v) !== -1) {
          continue;
        }
        var found = false;
        for (var q = 0; !found && q < tickVals.length; q++) {
          if (
          // add 10e6 to eliminate problematic digits
          10e6 + tickVals[q].value === 10e6 + v) {
            found = true;
          }
        }
        if (!found) list.push(T);
      }
      minorTickVals = list;
    }
  }
  if (isPeriod) positionPeriodTicks(allTicklabelVals, ax, ax._definedDelta);
  var i;
  if (ax.rangebreaks) {
    var flip = ax._id.charAt(0) === 'y';
    var fontSize = 1; // one pixel minimum
    if (ax.tickmode === 'auto') {
      fontSize = ax.tickfont ? ax.tickfont.size : 12;
    }
    var prevL = NaN;
    for (i = tickVals.length - 1; i > -1; i--) {
      if (tickVals[i].drop) {
        tickVals.splice(i, 1);
        continue;
      }
      tickVals[i].value = moveOutsideBreak(tickVals[i].value, ax);

      // avoid overlaps
      var l = ax.c2p(tickVals[i].value);
      if (flip ? prevL > l - fontSize : prevL < l + fontSize) {
        // ensure one pixel minimum
        tickVals.splice(axrev ? i + 1 : i, 1);
      } else {
        prevL = l;
      }
    }
  }

  // If same angle over a full circle, the last tick vals is a duplicate.
  // TODO must do something similar for angular date axes.
  if (isAngular(ax) && Math.abs(rng[1] - rng[0]) === 360) {
    tickVals.pop();
  }

  // save the last tick as well as first, so we can
  // show the exponent only on the last one
  ax._tmax = (tickVals[tickVals.length - 1] || {}).value;

  // for showing the rest of a date when the main tick label is only the
  // latter part: ax._prevDateHead holds what we showed most recently.
  // Start with it cleared and mark that we're in calcTicks (ie calculating a
  // whole string of these so we should care what the previous date head was!)
  ax._prevDateHead = '';
  ax._inCalcTicks = true;
  var lastVisibleHead;
  var hideLabel = function (tick) {
    tick.text = '';
    ax._prevDateHead = lastVisibleHead;
  };
  tickVals = tickVals.concat(minorTickVals);
  function setTickLabel(ax, tickVal) {
    var text = axes.tickText(ax, tickVal.value, false,
    // hover
    tickVal.simpleLabel // noSuffixPrefix
    );
    var p = tickVal.periodX;
    if (p !== undefined) {
      text.periodX = p;
      if (p > maxRange || p < minRange) {
        // hide label if outside the range
        if (p > maxRange) text.periodX = maxRange;
        if (p < minRange) text.periodX = minRange;
        hideLabel(text);
      }
    }
    return text;
  }
  var t;
  for (i = 0; i < tickVals.length; i++) {
    var _minor = tickVals[i].minor;
    var _value = tickVals[i].value;
    if (_minor) {
      if (ticklabelIndex && allTicklabelVals.indexOf(tickVals[i]) !== -1) {
        t = setTickLabel(ax, tickVals[i]);
      } else {
        t = {
          x: _value
        };
      }
      t.minor = true;
      minorTicks.push(t);
    } else {
      lastVisibleHead = ax._prevDateHead;
      t = setTickLabel(ax, tickVals[i]);
      if (tickVals[i].skipLabel || ticklabelIndex && allTicklabelVals.indexOf(tickVals[i]) === -1) {
        hideLabel(t);
      }
      ticksOut.push(t);
    }
  }
  ticksOut = ticksOut.concat(minorTicks);
  ax._inCalcTicks = false;
  if (isPeriod && ticksOut.length) {
    // drop very first tick that we added to handle period
    ticksOut[0].noTick = true;
  }
  return ticksOut;
};
function filterRangeBreaks(ax, ticksOut) {
  if (ax.rangebreaks) {
    // remove ticks falling inside rangebreaks
    ticksOut = ticksOut.filter(function (d) {
      return ax.maskBreaks(d.x) !== BADNUM;
    });
  }
  return ticksOut;
}
function syncTicks(ax) {
  // get the overlaying axis
  var baseAxis = ax._mainAxis;
  var ticksOut = [];
  if (baseAxis._vals) {
    for (var i = 0; i < baseAxis._vals.length; i++) {
      // filter vals with noTick flag
      if (baseAxis._vals[i].noTick) {
        continue;
      }

      // get the position of the every tick
      var pos = baseAxis.l2p(baseAxis._vals[i].x);

      // get the tick for the current axis based on position
      var vali = ax.p2l(pos);
      var obj = axes.tickText(ax, vali);

      // assign minor ticks
      if (baseAxis._vals[i].minor) {
        obj.minor = true;
        obj.text = '';
      }
      ticksOut.push(obj);
    }
  }
  ticksOut = filterRangeBreaks(ax, ticksOut);
  return ticksOut;
}
function arrayTicks(ax, majorOnly) {
  var rng = Lib.simpleMap(ax.range, ax.r2l);
  var exRng = expandRange(rng);
  var tickMin = Math.min(exRng[0], exRng[1]);
  var tickMax = Math.max(exRng[0], exRng[1]);

  // make sure showing ticks doesn't accidentally add new categories
  // TODO multicategory, if we allow ticktext / tickvals
  var tickVal2l = ax.type === 'category' ? ax.d2l_noadd : ax.d2l;

  // array ticks on log axes always show the full number
  // (if no explicit ticktext overrides it)
  if (ax.type === 'log' && String(ax.dtick).charAt(0) !== 'L') {
    ax.dtick = 'L' + Math.pow(10, Math.floor(Math.min(ax.range[0], ax.range[1])) - 1);
  }
  var ticksOut = [];
  for (var isMinor = 0; isMinor <= 1; isMinor++) {
    if (majorOnly !== undefined && (majorOnly && isMinor || majorOnly === false && !isMinor)) continue;
    if (isMinor && !ax.minor) continue;
    var vals = !isMinor ? ax.tickvals : ax.minor.tickvals;
    var text = !isMinor ? ax.ticktext : [];
    if (!vals) continue;

    // without a text array, just format the given values as any other ticks
    // except with more precision to the numbers
    if (!Lib.isArrayOrTypedArray(text)) text = [];
    for (var i = 0; i < vals.length; i++) {
      var vali = tickVal2l(vals[i]);
      if (vali > tickMin && vali < tickMax) {
        var obj = axes.tickText(ax, vali, false, String(text[i]));
        if (isMinor) {
          obj.minor = true;
          obj.text = '';
        }
        ticksOut.push(obj);
      }
    }
  }
  ticksOut = filterRangeBreaks(ax, ticksOut);
  return ticksOut;
}
var roundBase10 = [2, 5, 10];
var roundBase24 = [1, 2, 3, 6, 12];
var roundBase60 = [1, 2, 5, 10, 15, 30];
// 2&3 day ticks are weird, but need something btwn 1&7
var roundDays = [1, 2, 3, 7, 14];
// approx. tick positions for log axes, showing all (1) and just 1, 2, 5 (2)
// these don't have to be exact, just close enough to round to the right value
var roundLog1 = [-0.046, 0, 0.301, 0.477, 0.602, 0.699, 0.778, 0.845, 0.903, 0.954, 1];
var roundLog2 = [-0.301, 0, 0.301, 0.699, 1];
// N.B. `thetaunit; 'radians' angular axes must be converted to degrees
var roundAngles = [15, 30, 45, 90, 180];
function roundDTick(roughDTick, base, roundingSet) {
  return base * Lib.roundUp(roughDTick / base, roundingSet);
}

// autoTicks: calculate best guess at pleasant ticks for this axis
// inputs:
//      ax - an axis object
//      roughDTick - rough tick spacing (to be turned into a nice round number)
// outputs (into ax):
//   tick0: starting point for ticks (not necessarily on the graph)
//      usually 0 for numeric (=10^0=1 for log) or jan 1, 2000 for dates
//   dtick: the actual, nice round tick spacing, usually a little larger than roughDTick
//      if the ticks are spaced linearly (linear scale, categories,
//          log with only full powers, date ticks < month),
//          this will just be a number
//      months: M#
//      years: M# where # is 12*number of years
//      log with linear ticks: L# where # is the linear tick spacing
//      log showing powers plus some intermediates:
//          D1 shows all digits, D2 shows 2 and 5
axes.autoTicks = function (ax, roughDTick, isMinor) {
  var base;
  function getBase(v) {
    return Math.pow(v, Math.floor(Math.log(roughDTick) / Math.LN10));
  }
  if (ax.type === 'date') {
    ax.tick0 = Lib.dateTick0(ax.calendar, 0);

    // the criteria below are all based on the rough spacing we calculate
    // being > half of the final unit - so precalculate twice the rough val
    var roughX2 = 2 * roughDTick;
    if (roughX2 > ONEAVGYEAR) {
      roughDTick /= ONEAVGYEAR;
      base = getBase(10);
      ax.dtick = 'M' + 12 * roundDTick(roughDTick, base, roundBase10);
    } else if (roughX2 > ONEAVGMONTH) {
      roughDTick /= ONEAVGMONTH;
      ax.dtick = 'M' + roundDTick(roughDTick, 1, roundBase24);
    } else if (roughX2 > ONEDAY) {
      ax.dtick = roundDTick(roughDTick, ONEDAY, ax._hasDayOfWeekBreaks ? [1, 2, 7, 14] : roundDays);
      if (!isMinor) {
        // get week ticks on sunday
        // this will also move the base tick off 2000-01-01 if dtick is
        // 2 or 3 days... but that's a weird enough case that we'll ignore it.
        var tickformat = axes.getTickFormat(ax);
        var isPeriod = ax.ticklabelmode === 'period';
        if (isPeriod) ax._rawTick0 = ax.tick0;
        if (/%[uVW]/.test(tickformat)) {
          ax.tick0 = Lib.dateTick0(ax.calendar, 2); // Monday
        } else {
          ax.tick0 = Lib.dateTick0(ax.calendar, 1); // Sunday
        }
        if (isPeriod) ax._dowTick0 = ax.tick0;
      }
    } else if (roughX2 > ONEHOUR) {
      ax.dtick = roundDTick(roughDTick, ONEHOUR, roundBase24);
    } else if (roughX2 > ONEMIN) {
      ax.dtick = roundDTick(roughDTick, ONEMIN, roundBase60);
    } else if (roughX2 > ONESEC) {
      ax.dtick = roundDTick(roughDTick, ONESEC, roundBase60);
    } else {
      // milliseconds
      base = getBase(10);
      ax.dtick = roundDTick(roughDTick, base, roundBase10);
    }
  } else if (ax.type === 'log') {
    ax.tick0 = 0;
    var rng = Lib.simpleMap(ax.range, ax.r2l);
    if (ax._isMinor) {
      // Log axes by default get MORE than nTicks based on the metrics below
      // But for minor ticks we don't want this increase, we already have
      // the major ticks.
      roughDTick *= 1.5;
    }
    if (roughDTick > 0.7) {
      // only show powers of 10
      ax.dtick = Math.ceil(roughDTick);
    } else if (Math.abs(rng[1] - rng[0]) < 1) {
      // span is less than one power of 10
      var nt = 1.5 * Math.abs((rng[1] - rng[0]) / roughDTick);

      // ticks on a linear scale, labeled fully
      roughDTick = Math.abs(Math.pow(10, rng[1]) - Math.pow(10, rng[0])) / nt;
      base = getBase(10);
      ax.dtick = 'L' + roundDTick(roughDTick, base, roundBase10);
    } else {
      // include intermediates between powers of 10,
      // labeled with small digits
      // ax.dtick = "D2" (show 2 and 5) or "D1" (show all digits)
      ax.dtick = roughDTick > 0.3 ? 'D2' : 'D1';
    }
  } else if (ax.type === 'category' || ax.type === 'multicategory') {
    ax.tick0 = 0;
    ax.dtick = Math.ceil(Math.max(roughDTick, 1));
  } else if (isAngular(ax)) {
    ax.tick0 = 0;
    base = 1;
    ax.dtick = roundDTick(roughDTick, base, roundAngles);
  } else {
    // auto ticks always start at 0
    ax.tick0 = 0;
    base = getBase(10);
    ax.dtick = roundDTick(roughDTick, base, roundBase10);
  }

  // prevent infinite loops
  if (ax.dtick === 0) ax.dtick = 1;

  // TODO: this is from log axis histograms with autorange off
  if (!isNumeric(ax.dtick) && typeof ax.dtick !== 'string') {
    var olddtick = ax.dtick;
    ax.dtick = 1;
    throw 'ax.dtick error: ' + String(olddtick);
  }
};

// after dtick is already known, find tickround = precision
// to display in tick labels
//   for numeric ticks, integer # digits after . to round to
//   for date ticks, the last date part to show (y,m,d,H,M,S)
//      or an integer # digits past seconds
function autoTickRound(ax) {
  var dtick = ax.dtick;
  ax._tickexponent = 0;
  if (!isNumeric(dtick) && typeof dtick !== 'string') {
    dtick = 1;
  }
  if (ax.type === 'category' || ax.type === 'multicategory') {
    ax._tickround = null;
  }
  if (ax.type === 'date') {
    // If tick0 is unusual, give tickround a bit more information
    // not necessarily *all* the information in tick0 though, if it's really odd
    // minimal string length for tick0: 'd' is 10, 'M' is 16, 'S' is 19
    // take off a leading minus (year < 0) and i (intercalary month) so length is consistent
    var tick0ms = ax.r2l(ax.tick0);
    var tick0str = ax.l2r(tick0ms).replace(/(^-|i)/g, '');
    var tick0len = tick0str.length;
    if (String(dtick).charAt(0) === 'M') {
      // any tick0 more specific than a year: alway show the full date
      if (tick0len > 10 || tick0str.substr(5) !== '01-01') ax._tickround = 'd';
      // show the month unless ticks are full multiples of a year
      else ax._tickround = +dtick.substr(1) % 12 === 0 ? 'y' : 'm';
    } else if (dtick >= ONEDAY && tick0len <= 10 || dtick >= ONEDAY * 15) ax._tickround = 'd';else if (dtick >= ONEMIN && tick0len <= 16 || dtick >= ONEHOUR) ax._tickround = 'M';else if (dtick >= ONESEC && tick0len <= 19 || dtick >= ONEMIN) ax._tickround = 'S';else {
      // tickround is a number of digits of fractional seconds
      // of any two adjacent ticks, at least one will have the maximum fractional digits
      // of all possible ticks - so take the max. length of tick0 and the next one
      var tick1len = ax.l2r(tick0ms + dtick).replace(/^-/, '').length;
      ax._tickround = Math.max(tick0len, tick1len) - 20;

      // We shouldn't get here... but in case there's a situation I'm
      // not thinking of where tick0str and tick1str are identical or
      // something, fall back on maximum precision
      if (ax._tickround < 0) ax._tickround = 4;
    }
  } else if (isNumeric(dtick) || dtick.charAt(0) === 'L') {
    // linear or log (except D1, D2)
    var rng = ax.range.map(ax.r2d || Number);
    if (!isNumeric(dtick)) dtick = Number(dtick.substr(1));
    // 2 digits past largest digit of dtick
    ax._tickround = 2 - Math.floor(Math.log(dtick) / Math.LN10 + 0.01);
    var maxend = Math.max(Math.abs(rng[0]), Math.abs(rng[1]));
    var rangeexp = Math.floor(Math.log(maxend) / Math.LN10 + 0.01);
    var minexponent = ax.minexponent === undefined ? 3 : ax.minexponent;
    if (Math.abs(rangeexp) > minexponent) {
      if (isSIFormat(ax.exponentformat) && !beyondSI(rangeexp)) {
        ax._tickexponent = 3 * Math.round((rangeexp - 1) / 3);
      } else ax._tickexponent = rangeexp;
    }
  } else {
    // D1 or D2 (log)
    ax._tickround = null;
  }
}

// months and years don't have constant millisecond values
// (but a year is always 12 months so we only need months)
// log-scale ticks are also not consistently spaced, except
// for pure powers of 10
// numeric ticks always have constant differences, other datetime ticks
// can all be calculated as constant number of milliseconds
axes.tickIncrement = function (x, dtick, axrev, calendar) {
  var axSign = axrev ? -1 : 1;

  // includes linear, all dates smaller than month, and pure 10^n in log
  if (isNumeric(dtick)) return Lib.increment(x, axSign * dtick);

  // everything else is a string, one character plus a number
  var tType = dtick.charAt(0);
  var dtSigned = axSign * Number(dtick.substr(1));

  // Dates: months (or years - see Lib.incrementMonth)
  if (tType === 'M') return Lib.incrementMonth(x, dtSigned, calendar);

  // Log scales: Linear, Digits
  if (tType === 'L') return Math.log(Math.pow(10, x) + dtSigned) / Math.LN10;

  // log10 of 2,5,10, or all digits (logs just have to be
  // close enough to round)
  if (tType === 'D') {
    var tickset = dtick === 'D2' ? roundLog2 : roundLog1;
    var x2 = x + axSign * 0.01;
    var frac = Lib.roundUp(Lib.mod(x2, 1), tickset, axrev);
    return Math.floor(x2) + Math.log(d3.round(Math.pow(10, frac), 1)) / Math.LN10;
  }
  throw 'unrecognized dtick ' + String(dtick);
};

// calculate the first tick on an axis
axes.tickFirst = function (ax, opts) {
  var r2l = ax.r2l || Number;
  var rng = Lib.simpleMap(ax.range, r2l, undefined, undefined, opts);
  var axrev = rng[1] < rng[0];
  var sRound = axrev ? Math.floor : Math.ceil;
  // add a tiny extra bit to make sure we get ticks
  // that may have been rounded out
  var r0 = expandRange(rng)[0];
  var dtick = ax.dtick;
  var tick0 = r2l(ax.tick0);
  if (isNumeric(dtick)) {
    var tmin = sRound((r0 - tick0) / dtick) * dtick + tick0;

    // make sure no ticks outside the category list
    if (ax.type === 'category' || ax.type === 'multicategory') {
      tmin = Lib.constrain(tmin, 0, ax._categories.length - 1);
    }
    return tmin;
  }
  var tType = dtick.charAt(0);
  var dtNum = Number(dtick.substr(1));

  // Dates: months (or years)
  if (tType === 'M') {
    var cnt = 0;
    var t0 = tick0;
    var t1, mult, newDTick;

    // This algorithm should work for *any* nonlinear (but close to linear!)
    // tick spacing. Limit to 10 iterations, for gregorian months it's normally <=3.
    while (cnt < 10) {
      t1 = axes.tickIncrement(t0, dtick, axrev, ax.calendar);
      if ((t1 - r0) * (t0 - r0) <= 0) {
        // t1 and t0 are on opposite sides of r0! we've succeeded!
        if (axrev) return Math.min(t0, t1);
        return Math.max(t0, t1);
      }
      mult = (r0 - (t0 + t1) / 2) / (t1 - t0);
      newDTick = tType + (Math.abs(Math.round(mult)) || 1) * dtNum;
      t0 = axes.tickIncrement(t0, newDTick, mult < 0 ? !axrev : axrev, ax.calendar);
      cnt++;
    }
    Lib.error('tickFirst did not converge', ax);
    return t0;
  } else if (tType === 'L') {
    // Log scales: Linear, Digits

    return Math.log(sRound((Math.pow(10, r0) - tick0) / dtNum) * dtNum + tick0) / Math.LN10;
  } else if (tType === 'D') {
    var tickset = dtick === 'D2' ? roundLog2 : roundLog1;
    var frac = Lib.roundUp(Lib.mod(r0, 1), tickset, axrev);
    return Math.floor(r0) + Math.log(d3.round(Math.pow(10, frac), 1)) / Math.LN10;
  } else throw 'unrecognized dtick ' + String(dtick);
};

// draw the text for one tick.
// px,py are the location on gd.paper
// prefix is there so the x axis ticks can be dropped a line
// ax is the axis layout, x is the tick value
// hover is a (truthy) flag for whether to show numbers with a bit
// more precision for hovertext
axes.tickText = function (ax, x, hover, noSuffixPrefix) {
  var out = tickTextObj(ax, x);
  var arrayMode = ax.tickmode === 'array';
  var extraPrecision = hover || arrayMode;
  var axType = ax.type;
  // TODO multicategory, if we allow ticktext / tickvals
  var tickVal2l = axType === 'category' ? ax.d2l_noadd : ax.d2l;
  var i;
  var inbounds = function (v) {
    var p = ax.l2p(v);
    return p >= 0 && p <= ax._length ? v : null;
  };
  if (arrayMode && Lib.isArrayOrTypedArray(ax.ticktext)) {
    var rng = Lib.simpleMap(ax.range, ax.r2l);
    var minDiff = (Math.abs(rng[1] - rng[0]) - (ax._lBreaks || 0)) / 10000;
    for (i = 0; i < ax.ticktext.length; i++) {
      if (Math.abs(x - tickVal2l(ax.tickvals[i])) < minDiff) break;
    }
    if (i < ax.ticktext.length) {
      out.text = String(ax.ticktext[i]);
      out.xbnd = [inbounds(out.x - 0.5), inbounds(out.x + ax.dtick - 0.5)];
      return out;
    }
  }
  function isHidden(showAttr) {
    if (showAttr === undefined) return true;
    if (hover) return showAttr === 'none';
    var firstOrLast = {
      first: ax._tmin,
      last: ax._tmax
    }[showAttr];
    return showAttr !== 'all' && x !== firstOrLast;
  }
  var hideexp = hover ? 'never' : ax.exponentformat !== 'none' && isHidden(ax.showexponent) ? 'hide' : '';
  if (axType === 'date') formatDate(ax, out, hover, extraPrecision);else if (axType === 'log') formatLog(ax, out, hover, extraPrecision, hideexp);else if (axType === 'category') formatCategory(ax, out);else if (axType === 'multicategory') formatMultiCategory(ax, out, hover);else if (isAngular(ax)) formatAngle(ax, out, hover, extraPrecision, hideexp);else formatLinear(ax, out, hover, extraPrecision, hideexp);

  // add prefix and suffix
  if (!noSuffixPrefix) {
    if (ax.tickprefix && !isHidden(ax.showtickprefix)) out.text = ax.tickprefix + out.text;
    if (ax.ticksuffix && !isHidden(ax.showticksuffix)) out.text += ax.ticksuffix;
  }
  if (ax.labelalias && ax.labelalias.hasOwnProperty(out.text)) {
    var t = ax.labelalias[out.text];
    if (typeof t === 'string') out.text = t;
  }

  // Setup ticks and grid lines boundaries
  // at 1/2 a 'category' to the left/bottom
  if (ax.tickson === 'boundaries' || ax.showdividers) {
    out.xbnd = [inbounds(out.x - 0.5), inbounds(out.x + ax.dtick - 0.5)];
  }
  return out;
};

/**
 * create text for a hover label on this axis, with special handling of
 * log axes (where negative values can't be displayed but can appear in hover text)
 *
 * @param {object} ax: the axis to format text for
 * @param {number or array of numbers} values: calcdata value(s) to format
 * @param {Optional(string)} hoverformat: trace (x|y)hoverformat to override axis.hoverformat
 *
 * @returns {string} `val` formatted as a string appropriate to this axis, or
 *     first value and second value as a range (ie '<val1> - <val2>') if the second value is provided and
 *     it's different from the first value.
 */
axes.hoverLabelText = function (ax, values, hoverformat) {
  if (hoverformat) ax = Lib.extendFlat({}, ax, {
    hoverformat: hoverformat
  });
  var val = Lib.isArrayOrTypedArray(values) ? values[0] : values;
  var val2 = Lib.isArrayOrTypedArray(values) ? values[1] : undefined;
  if (val2 !== undefined && val2 !== val) {
    return axes.hoverLabelText(ax, val, hoverformat) + ' - ' + axes.hoverLabelText(ax, val2, hoverformat);
  }
  var logOffScale = ax.type === 'log' && val <= 0;
  var tx = axes.tickText(ax, ax.c2l(logOffScale ? -val : val), 'hover').text;
  if (logOffScale) {
    return val === 0 ? '0' : MINUS_SIGN + tx;
  }

  // TODO: should we do something special if the axis calendar and
  // the data calendar are different? Somehow display both dates with
  // their system names? Right now it will just display in the axis calendar
  // but users could add the other one as text.
  return tx;
};
function tickTextObj(ax, x, text) {
  var tf = ax.tickfont || {};
  return {
    x: x,
    dx: 0,
    dy: 0,
    text: text || '',
    fontSize: tf.size,
    font: tf.family,
    fontWeight: tf.weight,
    fontStyle: tf.style,
    fontVariant: tf.variant,
    fontTextcase: tf.textcase,
    fontLineposition: tf.lineposition,
    fontShadow: tf.shadow,
    fontColor: tf.color
  };
}
function formatDate(ax, out, hover, extraPrecision) {
  var tr = ax._tickround;
  var fmt = hover && ax.hoverformat || axes.getTickFormat(ax);

  // Only apply extra precision if no explicit format was provided.
  extraPrecision = !fmt && extraPrecision;
  if (extraPrecision) {
    // second or sub-second precision: extra always shows max digits.
    // for other fields, extra precision just adds one field.
    if (isNumeric(tr)) tr = 4;else tr = {
      y: 'm',
      m: 'd',
      d: 'M',
      M: 'S',
      S: 4
    }[tr];
  }
  var dateStr = Lib.formatDate(out.x, fmt, tr, ax._dateFormat, ax.calendar, ax._extraFormat);
  var headStr;
  var splitIndex = dateStr.indexOf('\n');
  if (splitIndex !== -1) {
    headStr = dateStr.substr(splitIndex + 1);
    dateStr = dateStr.substr(0, splitIndex);
  }
  if (extraPrecision) {
    // if extraPrecision led to trailing zeros, strip them off
    // actually, this can lead to removing even more zeros than
    // in the original rounding, but that's fine because in these
    // contexts uniformity is not so important (if there's even
    // anything to be uniform with!)

    // can we remove the whole time part?
    if (headStr !== undefined && (dateStr === '00:00:00' || dateStr === '00:00')) {
      dateStr = headStr;
      headStr = '';
    } else if (dateStr.length === 8) {
      // strip off seconds if they're zero (zero fractional seconds
      // are already omitted)
      // but we never remove minutes and leave just hours
      dateStr = dateStr.replace(/:00$/, '');
    }
  }
  if (headStr) {
    if (hover) {
      // hover puts it all on one line, so headPart works best up front
      // except for year headPart: turn this into "Jan 1, 2000" etc.
      if (tr === 'd') dateStr += ', ' + headStr;else dateStr = headStr + (dateStr ? ', ' + dateStr : '');
    } else {
      if (!ax._inCalcTicks || ax._prevDateHead !== headStr) {
        ax._prevDateHead = headStr;
        dateStr += '<br>' + headStr;
      } else {
        var isInside = insideTicklabelposition(ax);
        var side = ax._trueSide || ax.side; // polar mocks the side of the radial axis
        if (!isInside && side === 'top' || isInside && side === 'bottom') {
          dateStr += '<br> ';
        }
      }
    }
  }
  out.text = dateStr;
}
function formatLog(ax, out, hover, extraPrecision, hideexp) {
  var dtick = ax.dtick;
  var x = out.x;
  var tickformat = ax.tickformat;
  var dtChar0 = typeof dtick === 'string' && dtick.charAt(0);
  if (hideexp === 'never') {
    // If this is a hover label, then we must *never* hide the exponent
    // for the sake of display, which could give the wrong value by
    // potentially many orders of magnitude. If hideexp was 'never', then
    // it's now succeeded by preventing the other condition from automating
    // this choice. Thus we can unset it so that the axis formatting takes
    // precedence.
    hideexp = '';
  }
  if (extraPrecision && dtChar0 !== 'L') {
    dtick = 'L3';
    dtChar0 = 'L';
  }
  if (tickformat || dtChar0 === 'L') {
    out.text = numFormat(Math.pow(10, x), ax, hideexp, extraPrecision);
  } else if (isNumeric(dtick) || dtChar0 === 'D' && Lib.mod(x + 0.01, 1) < 0.1) {
    var p = Math.round(x);
    var absP = Math.abs(p);
    var exponentFormat = ax.exponentformat;
    if (exponentFormat === 'power' || isSIFormat(exponentFormat) && beyondSI(p)) {
      if (p === 0) out.text = 1;else if (p === 1) out.text = '10';else out.text = '10<sup>' + (p > 1 ? '' : MINUS_SIGN) + absP + '</sup>';
      out.fontSize *= 1.25;
    } else if ((exponentFormat === 'e' || exponentFormat === 'E') && absP > 2) {
      out.text = '1' + exponentFormat + (p > 0 ? '+' : MINUS_SIGN) + absP;
    } else {
      out.text = numFormat(Math.pow(10, x), ax, '', 'fakehover');
      if (dtick === 'D1' && ax._id.charAt(0) === 'y') {
        out.dy -= out.fontSize / 6;
      }
    }
  } else if (dtChar0 === 'D') {
    out.text = String(Math.round(Math.pow(10, Lib.mod(x, 1))));
    out.fontSize *= 0.75;
  } else throw 'unrecognized dtick ' + String(dtick);

  // if 9's are printed on log scale, move the 10's away a bit
  if (ax.dtick === 'D1') {
    var firstChar = String(out.text).charAt(0);
    if (firstChar === '0' || firstChar === '1') {
      if (ax._id.charAt(0) === 'y') {
        out.dx -= out.fontSize / 4;
      } else {
        out.dy += out.fontSize / 2;
        out.dx += (ax.range[1] > ax.range[0] ? 1 : -1) * out.fontSize * (x < 0 ? 0.5 : 0.25);
      }
    }
  }
}
function formatCategory(ax, out) {
  var tt = ax._categories[Math.round(out.x)];
  if (tt === undefined) tt = '';
  out.text = String(tt);
}
function formatMultiCategory(ax, out, hover) {
  var v = Math.round(out.x);
  var cats = ax._categories[v] || [];
  var tt = cats[1] === undefined ? '' : String(cats[1]);
  var tt2 = cats[0] === undefined ? '' : String(cats[0]);
  if (hover) {
    // TODO is this what we want?
    out.text = tt2 + ' - ' + tt;
  } else {
    // setup for secondary labels
    out.text = tt;
    out.text2 = tt2;
  }
}
function formatLinear(ax, out, hover, extraPrecision, hideexp) {
  if (hideexp === 'never') {
    // If this is a hover label, then we must *never* hide the exponent
    // for the sake of display, which could give the wrong value by
    // potentially many orders of magnitude. If hideexp was 'never', then
    // it's now succeeded by preventing the other condition from automating
    // this choice. Thus we can unset it so that the axis formatting takes
    // precedence.
    hideexp = '';
  } else if (ax.showexponent === 'all' && Math.abs(out.x / ax.dtick) < 1e-6) {
    // don't add an exponent to zero if we're showing all exponents
    // so the only reason you'd show an exponent on zero is if it's the
    // ONLY tick to get an exponent (first or last)
    hideexp = 'hide';
  }
  out.text = numFormat(out.x, ax, hideexp, extraPrecision);
}
function formatAngle(ax, out, hover, extraPrecision, hideexp) {
  if (ax.thetaunit === 'radians' && !hover) {
    var num = out.x / 180;
    if (num === 0) {
      out.text = '0';
    } else {
      var frac = num2frac(num);
      if (frac[1] >= 100) {
        out.text = numFormat(Lib.deg2rad(out.x), ax, hideexp, extraPrecision);
      } else {
        var isNeg = out.x < 0;
        if (frac[1] === 1) {
          if (frac[0] === 1) out.text = 'π';else out.text = frac[0] + 'π';
        } else {
          out.text = ['<sup>', frac[0], '</sup>', '⁄', '<sub>', frac[1], '</sub>', 'π'].join('');
        }
        if (isNeg) out.text = MINUS_SIGN + out.text;
      }
    }
  } else {
    out.text = numFormat(out.x, ax, hideexp, extraPrecision);
  }
}

// inspired by
// https://github.com/yisibl/num2fraction/blob/master/index.js
function num2frac(num) {
  function almostEq(a, b) {
    return Math.abs(a - b) <= 1e-6;
  }
  function findGCD(a, b) {
    return almostEq(b, 0) ? a : findGCD(b, a % b);
  }
  function findPrecision(n) {
    var e = 1;
    while (!almostEq(Math.round(n * e) / e, n)) {
      e *= 10;
    }
    return e;
  }
  var precision = findPrecision(num);
  var number = num * precision;
  var gcd = Math.abs(findGCD(number, precision));
  return [
  // numerator
  Math.round(number / gcd),
  // denominator
  Math.round(precision / gcd)];
}

// format a number (tick value) according to the axis settings
// new, more reliable procedure than d3.round or similar:
// add half the rounding increment, then stringify and truncate
// also automatically switch to sci. notation
var SIPREFIXES = ['f', 'p', 'n', 'μ', 'm', '', 'k', 'M', 'G', 'T'];
function isSIFormat(exponentFormat) {
  return exponentFormat === 'SI' || exponentFormat === 'B';
}

// are we beyond the range of common SI prefixes?
// 10^-16 -> 1x10^-16
// 10^-15 -> 1f
// ...
// 10^14 -> 100T
// 10^15 -> 1x10^15
// 10^16 -> 1x10^16
function beyondSI(exponent) {
  return exponent > 14 || exponent < -15;
}
function numFormat(v, ax, fmtoverride, hover) {
  var isNeg = v < 0;
  // max number of digits past decimal point to show
  var tickRound = ax._tickround;
  var exponentFormat = fmtoverride || ax.exponentformat || 'B';
  var exponent = ax._tickexponent;
  var tickformat = axes.getTickFormat(ax);
  var separatethousands = ax.separatethousands;

  // special case for hover: set exponent just for this value, and
  // add a couple more digits of precision over tick labels
  if (hover) {
    // make a dummy axis obj to get the auto rounding and exponent
    var ah = {
      exponentformat: exponentFormat,
      minexponent: ax.minexponent,
      dtick: ax.showexponent === 'none' ? ax.dtick : isNumeric(v) ? Math.abs(v) || 1 : 1,
      // if not showing any exponents, don't change the exponent
      // from what we calculate
      range: ax.showexponent === 'none' ? ax.range.map(ax.r2d) : [0, v || 1]
    };
    autoTickRound(ah);
    tickRound = (Number(ah._tickround) || 0) + 4;
    exponent = ah._tickexponent;
    if (ax.hoverformat) tickformat = ax.hoverformat;
  }
  if (tickformat) return ax._numFormat(tickformat)(v).replace(/-/g, MINUS_SIGN);

  // 'epsilon' - rounding increment
  var e = Math.pow(10, -tickRound) / 2;

  // exponentFormat codes:
  // 'e' (1.2e+6, default)
  // 'E' (1.2E+6)
  // 'SI' (1.2M)
  // 'B' (same as SI except 10^9=B not G)
  // 'none' (1200000)
  // 'power' (1.2x10^6)
  // 'hide' (1.2, use 3rd argument=='hide' to eg
  //      only show exponent on last tick)
  if (exponentFormat === 'none') exponent = 0;

  // take the sign out, put it back manually at the end
  // - makes cases easier
  v = Math.abs(v);
  if (v < e) {
    // 0 is just 0, but may get exponent if it's the last tick
    v = '0';
    isNeg = false;
  } else {
    v += e;
    // take out a common exponent, if any
    if (exponent) {
      v *= Math.pow(10, -exponent);
      tickRound += exponent;
    }
    // round the mantissa
    if (tickRound === 0) v = String(Math.floor(v));else if (tickRound < 0) {
      v = String(Math.round(v));
      v = v.substr(0, v.length + tickRound);
      for (var i = tickRound; i < 0; i++) v += '0';
    } else {
      v = String(v);
      var dp = v.indexOf('.') + 1;
      if (dp) v = v.substr(0, dp + tickRound).replace(/\.?0+$/, '');
    }
    // insert appropriate decimal point and thousands separator
    v = Lib.numSeparate(v, ax._separators, separatethousands);
  }

  // add exponent
  if (exponent && exponentFormat !== 'hide') {
    if (isSIFormat(exponentFormat) && beyondSI(exponent)) exponentFormat = 'power';
    var signedExponent;
    if (exponent < 0) signedExponent = MINUS_SIGN + -exponent;else if (exponentFormat !== 'power') signedExponent = '+' + exponent;else signedExponent = String(exponent);
    if (exponentFormat === 'e' || exponentFormat === 'E') {
      v += exponentFormat + signedExponent;
    } else if (exponentFormat === 'power') {
      v += '×10<sup>' + signedExponent + '</sup>';
    } else if (exponentFormat === 'B' && exponent === 9) {
      v += 'B';
    } else if (isSIFormat(exponentFormat)) {
      v += SIPREFIXES[exponent / 3 + 5];
    }
  }

  // put sign back in and return
  // replace standard minus character (which is technically a hyphen)
  // with a true minus sign
  if (isNeg) return MINUS_SIGN + v;
  return v;
}
axes.getTickFormat = function (ax) {
  var i;
  function convertToMs(dtick) {
    return typeof dtick !== 'string' ? dtick : Number(dtick.replace('M', '')) * ONEAVGMONTH;
  }
  function compareLogTicks(left, right) {
    var priority = ['L', 'D'];
    if (typeof left === typeof right) {
      if (typeof left === 'number') {
        return left - right;
      } else {
        var leftPriority = priority.indexOf(left.charAt(0));
        var rightPriority = priority.indexOf(right.charAt(0));
        if (leftPriority === rightPriority) {
          return Number(left.replace(/(L|D)/g, '')) - Number(right.replace(/(L|D)/g, ''));
        } else {
          return leftPriority - rightPriority;
        }
      }
    } else {
      return typeof left === 'number' ? 1 : -1;
    }
  }
  function isProperStop(dtick, range, convert) {
    var convertFn = convert || function (x) {
      return x;
    };
    var leftDtick = range[0];
    var rightDtick = range[1];
    return (!leftDtick && typeof leftDtick !== 'number' || convertFn(leftDtick) <= convertFn(dtick)) && (!rightDtick && typeof rightDtick !== 'number' || convertFn(rightDtick) >= convertFn(dtick));
  }
  function isProperLogStop(dtick, range) {
    var isLeftDtickNull = range[0] === null;
    var isRightDtickNull = range[1] === null;
    var isDtickInRangeLeft = compareLogTicks(dtick, range[0]) >= 0;
    var isDtickInRangeRight = compareLogTicks(dtick, range[1]) <= 0;
    return (isLeftDtickNull || isDtickInRangeLeft) && (isRightDtickNull || isDtickInRangeRight);
  }
  var tickstop, stopi;
  if (ax.tickformatstops && ax.tickformatstops.length > 0) {
    switch (ax.type) {
      case 'date':
      case 'linear':
        {
          for (i = 0; i < ax.tickformatstops.length; i++) {
            stopi = ax.tickformatstops[i];
            if (stopi.enabled && isProperStop(ax.dtick, stopi.dtickrange, convertToMs)) {
              tickstop = stopi;
              break;
            }
          }
          break;
        }
      case 'log':
        {
          for (i = 0; i < ax.tickformatstops.length; i++) {
            stopi = ax.tickformatstops[i];
            if (stopi.enabled && isProperLogStop(ax.dtick, stopi.dtickrange)) {
              tickstop = stopi;
              break;
            }
          }
          break;
        }
      default:
    }
  }
  return tickstop ? tickstop.value : ax.tickformat;
};

// getSubplots - extract all subplot IDs we need
// as an array of items like 'xy', 'x2y', 'x2y2'...
// sorted by x (x,x2,x3...) then y
// optionally restrict to only subplots containing axis object ax
//
// NOTE: this is currently only used OUTSIDE plotly.js (toolpanel, webapp)
// ideally we get rid of it there (or just copy this there) and remove it here
axes.getSubplots = function (gd, ax) {
  var subplotObj = gd._fullLayout._subplots;
  var allSubplots = subplotObj.cartesian.concat(subplotObj.gl2d || []);
  var out = ax ? axes.findSubplotsWithAxis(allSubplots, ax) : allSubplots;
  out.sort(function (a, b) {
    var aParts = a.substr(1).split('y');
    var bParts = b.substr(1).split('y');
    if (aParts[0] === bParts[0]) return +aParts[1] - +bParts[1];
    return +aParts[0] - +bParts[0];
  });
  return out;
};

// find all subplots with axis 'ax'
// NOTE: this is only used in axes.getSubplots (only used outside plotly.js) and
// gl2d/convert (where it restricts axis subplots to only those with gl2d)
axes.findSubplotsWithAxis = function (subplots, ax) {
  var axMatch = new RegExp(ax._id.charAt(0) === 'x' ? '^' + ax._id + 'y' : ax._id + '$');
  var subplotsWithAx = [];
  for (var i = 0; i < subplots.length; i++) {
    var sp = subplots[i];
    if (axMatch.test(sp)) subplotsWithAx.push(sp);
  }
  return subplotsWithAx;
};

// makeClipPaths: prepare clipPaths for all single axes and all possible xy pairings
axes.makeClipPaths = function (gd) {
  var fullLayout = gd._fullLayout;

  // for more info: https://github.com/plotly/plotly.js/issues/2595
  if (fullLayout._hasOnlyLargeSploms) return;
  var fullWidth = {
    _offset: 0,
    _length: fullLayout.width,
    _id: ''
  };
  var fullHeight = {
    _offset: 0,
    _length: fullLayout.height,
    _id: ''
  };
  var xaList = axes.list(gd, 'x', true);
  var yaList = axes.list(gd, 'y', true);
  var clipList = [];
  var i, j;
  for (i = 0; i < xaList.length; i++) {
    clipList.push({
      x: xaList[i],
      y: fullHeight
    });
    for (j = 0; j < yaList.length; j++) {
      if (i === 0) clipList.push({
        x: fullWidth,
        y: yaList[j]
      });
      clipList.push({
        x: xaList[i],
        y: yaList[j]
      });
    }
  }

  // selectors don't work right with camelCase tags,
  // have to use class instead
  // https://groups.google.com/forum/#!topic/d3-js/6EpAzQ2gU9I
  var axClips = fullLayout._clips.selectAll('.axesclip').data(clipList, function (d) {
    return d.x._id + d.y._id;
  });
  axClips.enter().append('clipPath').classed('axesclip', true).attr('id', function (d) {
    return 'clip' + fullLayout._uid + d.x._id + d.y._id;
  }).append('rect');
  axClips.exit().remove();
  axClips.each(function (d) {
    d3.select(this).select('rect').attr({
      x: d.x._offset || 0,
      y: d.y._offset || 0,
      width: d.x._length || 1,
      height: d.y._length || 1
    });
  });
};

/**
 * Main multi-axis drawing routine!
 *
 * @param {DOM element} gd : graph div
 * @param {string or array of strings} arg : polymorphic argument
 * @param {object} opts:
 * - @param {boolean} skipTitle : optional flag to skip axis title draw/update
 *
 * Signature 1: Axes.draw(gd, 'redraw')
 *   use this to clear and redraw all axes on graph
 *
 * Signature 2: Axes.draw(gd, '')
 *   use this to draw all axes on graph w/o the selectAll().remove()
 *   of the 'redraw' signature
 *
 * Signature 3: Axes.draw(gd, [axId, axId2, ...])
 *   where the items are axis id string,
 *   use this to update multiple axes in one call
 *
 * N.B draw updates:
 * - ax._r (stored range for use by zoom/pan)
 * - ax._rl (stored linearized range for use by zoom/pan)
 */
axes.draw = function (gd, arg, opts) {
  var fullLayout = gd._fullLayout;
  if (arg === 'redraw') {
    fullLayout._paper.selectAll('g.subplot').each(function (d) {
      var id = d[0];
      var plotinfo = fullLayout._plots[id];
      if (plotinfo) {
        var xa = plotinfo.xaxis;
        var ya = plotinfo.yaxis;
        plotinfo.xaxislayer.selectAll('.' + xa._id + 'tick').remove();
        plotinfo.yaxislayer.selectAll('.' + ya._id + 'tick').remove();
        plotinfo.xaxislayer.selectAll('.' + xa._id + 'tick2').remove();
        plotinfo.yaxislayer.selectAll('.' + ya._id + 'tick2').remove();
        plotinfo.xaxislayer.selectAll('.' + xa._id + 'divider').remove();
        plotinfo.yaxislayer.selectAll('.' + ya._id + 'divider').remove();
        if (plotinfo.minorGridlayer) plotinfo.minorGridlayer.selectAll('path').remove();
        if (plotinfo.gridlayer) plotinfo.gridlayer.selectAll('path').remove();
        if (plotinfo.zerolinelayer) plotinfo.zerolinelayer.selectAll('path').remove();
        fullLayout._infolayer.select('.g-' + xa._id + 'title').remove();
        fullLayout._infolayer.select('.g-' + ya._id + 'title').remove();
      }
    });
  }
  var axList = !arg || arg === 'redraw' ? axes.listIds(gd) : arg;
  var fullAxList = axes.list(gd);
  // Get the list of the overlaying axis for all 'shift' axes
  var overlayingShiftedAx = fullAxList.filter(function (ax) {
    return ax.autoshift;
  }).map(function (ax) {
    return ax.overlaying;
  });

  // order axes that have dependency to other axes
  axList.map(function (axId) {
    var ax = axes.getFromId(gd, axId);
    if (ax.tickmode === 'sync' && ax.overlaying) {
      var overlayingIndex = axList.findIndex(function (axis) {
        return axis === ax.overlaying;
      });
      if (overlayingIndex >= 0) {
        axList.unshift(axList.splice(overlayingIndex, 1).shift());
      }
    }
  });
  var axShifts = {
    false: {
      left: 0,
      right: 0
    }
  };
  return Lib.syncOrAsync(axList.map(function (axId) {
    return function () {
      if (!axId) return;
      var ax = axes.getFromId(gd, axId);
      if (!opts) opts = {};
      opts.axShifts = axShifts;
      opts.overlayingShiftedAx = overlayingShiftedAx;
      var axDone = axes.drawOne(gd, ax, opts);
      if (ax._shiftPusher) {
        incrementShift(ax, ax._fullDepth || 0, axShifts, true);
      }
      ax._r = ax.range.slice();
      ax._rl = Lib.simpleMap(ax._r, ax.r2l);
      return axDone;
    };
  }));
};

/**
 * Draw one cartesian axis
 *
 * @param {DOM element} gd
 * @param {object} ax (full) axis object
 * @param {object} opts
 * - @param {boolean} skipTitle (set to true to skip axis title draw call)
 *
 * Depends on:
 * - ax._mainSubplot (from linkSubplots)
 * - ax._mainAxis
 * - ax._anchorAxis
 * - ax._subplotsWith
 * - ax._counterDomainMin, ax._counterDomainMax (optionally, from linkSubplots)
 * - ax._tickAngles (on redraw only, old value relinked during supplyDefaults)
 * - ax._mainLinePosition (from lsInner)
 * - ax._mainMirrorPosition
 * - ax._linepositions
 *
 * Fills in:
 * - ax._vals:
 * - ax._gridVals:
 * - ax._selections:
 * - ax._tickAngles:
 * - ax._depth (when required only):
 * - and calls ax.setScale
 */
axes.drawOne = function (gd, ax, opts) {
  opts = opts || {};
  var axShifts = opts.axShifts || {};
  var overlayingShiftedAx = opts.overlayingShiftedAx || [];
  var i, sp, plotinfo;
  ax.setScale();
  var fullLayout = gd._fullLayout;
  var axId = ax._id;
  var axLetter = axId.charAt(0);
  var counterLetter = axes.counterLetter(axId);
  var mainPlotinfo = fullLayout._plots[ax._mainSubplot];

  // this happens when updating matched group with 'missing' axes
  if (!mainPlotinfo) return;
  ax._shiftPusher = ax.autoshift || overlayingShiftedAx.indexOf(ax._id) !== -1 || overlayingShiftedAx.indexOf(ax.overlaying) !== -1;
  // An axis is also shifted by 1/2 of its own linewidth and inside tick length if applicable
  // as well as its manually specified `shift` val if we're in the context of `autoshift`
  if (ax._shiftPusher & ax.anchor === 'free') {
    var selfPush = ax.linewidth / 2 || 0;
    if (ax.ticks === 'inside') {
      selfPush += ax.ticklen;
    }
    incrementShift(ax, selfPush, axShifts, true);
    incrementShift(ax, ax.shift || 0, axShifts, false);
  }

  // Somewhat inelegant way of making sure that the shift value is only updated when the
  // Axes.DrawOne() function is called from the right context. An issue when redrawing the
  // axis as result of using the dragbox, for example.
  if (opts.skipTitle !== true || ax._shift === undefined) ax._shift = setShiftVal(ax, axShifts);
  var mainAxLayer = mainPlotinfo[axLetter + 'axislayer'];
  var mainLinePosition = ax._mainLinePosition;
  var mainLinePositionShift = mainLinePosition += ax._shift;
  var mainMirrorPosition = ax._mainMirrorPosition;
  var vals = ax._vals = axes.calcTicks(ax);

  // Add a couple of axis properties that should cause us to recreate
  // elements. Used in d3 data function.
  var axInfo = [ax.mirror, mainLinePositionShift, mainMirrorPosition].join('_');
  for (i = 0; i < vals.length; i++) {
    vals[i].axInfo = axInfo;
  }

  // stash selections to avoid DOM queries e.g.
  // - stash tickLabels selection, so that drawTitle can use it to scoot title
  ax._selections = {};
  // stash tick angle (including the computed 'auto' values) per tick-label class
  // linkup 'previous' tick angles on redraws
  if (ax._tickAngles) ax._prevTickAngles = ax._tickAngles;
  ax._tickAngles = {};
  // measure [in px] between axis position and outward-most part of bounding box
  // (touching either the tick label or ticks)
  // depth can be expansive to compute, so we only do so when required
  ax._depth = null;

  // calcLabelLevelBbox can be expensive,
  // so make sure to not call it twice during the same Axes.drawOne call
  // by stashing label-level bounding boxes per tick-label class
  var llbboxes = {};
  function getLabelLevelBbox(suffix) {
    var cls = axId + (suffix || 'tick');
    if (!llbboxes[cls]) llbboxes[cls] = calcLabelLevelBbox(ax, cls, mainLinePositionShift);
    return llbboxes[cls];
  }
  if (!ax.visible) return;
  var transTickFn = axes.makeTransTickFn(ax);
  var transTickLabelFn = axes.makeTransTickLabelFn(ax);
  var tickVals;
  // We remove zero lines, grid lines, and inside ticks if they're within 1px of the end
  // The key case here is removing zero lines when the axis bound is zero
  var valsClipped;
  var insideTicks = ax.ticks === 'inside';
  var outsideTicks = ax.ticks === 'outside';
  if (ax.tickson === 'boundaries') {
    var boundaryVals = getBoundaryVals(ax, vals);
    valsClipped = axes.clipEnds(ax, boundaryVals);
    tickVals = insideTicks ? valsClipped : boundaryVals;
  } else {
    valsClipped = axes.clipEnds(ax, vals);
    tickVals = insideTicks && ax.ticklabelmode !== 'period' ? valsClipped : vals;
  }
  var gridVals = ax._gridVals = valsClipped;
  var dividerVals = getDividerVals(ax, vals);
  if (!fullLayout._hasOnlyLargeSploms) {
    var subplotsWithAx = ax._subplotsWith;

    // keep track of which subplots (by main counter axis) we've already
    // drawn grids for, so we don't overdraw overlaying subplots
    var finishedGrids = {};
    for (i = 0; i < subplotsWithAx.length; i++) {
      sp = subplotsWithAx[i];
      plotinfo = fullLayout._plots[sp];
      var counterAxis = plotinfo[counterLetter + 'axis'];
      var mainCounterID = counterAxis._mainAxis._id;
      if (finishedGrids[mainCounterID]) continue;
      finishedGrids[mainCounterID] = 1;
      var gridPath = axLetter === 'x' ? 'M0,' + counterAxis._offset + 'v' + counterAxis._length : 'M' + counterAxis._offset + ',0h' + counterAxis._length;
      axes.drawGrid(gd, ax, {
        vals: gridVals,
        counterAxis: counterAxis,
        layer: plotinfo.gridlayer.select('.' + axId),
        minorLayer: plotinfo.minorGridlayer.select('.' + axId),
        path: gridPath,
        transFn: transTickFn
      });
      axes.drawZeroLine(gd, ax, {
        counterAxis: counterAxis,
        layer: plotinfo.zerolinelayer,
        path: gridPath,
        transFn: transTickFn
      });
    }
  }
  var tickPath;
  var majorTickSigns = axes.getTickSigns(ax);
  var minorTickSigns = axes.getTickSigns(ax, 'minor');
  if (ax.ticks || ax.minor && ax.minor.ticks) {
    var majorTickPath = axes.makeTickPath(ax, mainLinePositionShift, majorTickSigns[2]);
    var minorTickPath = axes.makeTickPath(ax, mainLinePositionShift, minorTickSigns[2], {
      minor: true
    });
    var mirrorMajorTickPath;
    var mirrorMinorTickPath;
    var fullMajorTickPath;
    var fullMinorTickPath;
    if (ax._anchorAxis && ax.mirror && ax.mirror !== true) {
      mirrorMajorTickPath = axes.makeTickPath(ax, mainMirrorPosition, majorTickSigns[3]);
      mirrorMinorTickPath = axes.makeTickPath(ax, mainMirrorPosition, minorTickSigns[3], {
        minor: true
      });
      fullMajorTickPath = majorTickPath + mirrorMajorTickPath;
      fullMinorTickPath = minorTickPath + mirrorMinorTickPath;
    } else {
      mirrorMajorTickPath = '';
      mirrorMinorTickPath = '';
      fullMajorTickPath = majorTickPath;
      fullMinorTickPath = minorTickPath;
    }
    if (ax.showdividers && outsideTicks && ax.tickson === 'boundaries') {
      var dividerLookup = {};
      for (i = 0; i < dividerVals.length; i++) {
        dividerLookup[dividerVals[i].x] = 1;
      }
      tickPath = function (d) {
        return dividerLookup[d.x] ? mirrorMajorTickPath : fullMajorTickPath;
      };
    } else {
      tickPath = function (d) {
        return d.minor ? fullMinorTickPath : fullMajorTickPath;
      };
    }
  }
  axes.drawTicks(gd, ax, {
    vals: tickVals,
    layer: mainAxLayer,
    path: tickPath,
    transFn: transTickFn
  });
  if (ax.mirror === 'allticks') {
    var tickSubplots = Object.keys(ax._linepositions || {});
    for (i = 0; i < tickSubplots.length; i++) {
      sp = tickSubplots[i];
      plotinfo = fullLayout._plots[sp];
      // [bottom or left, top or right], free and main are handled above
      var linepositions = ax._linepositions[sp] || [];
      var p0 = linepositions[0];
      var p1 = linepositions[1];
      var isMinor = linepositions[2];
      var spTickPath = axes.makeTickPath(ax, p0, isMinor ? majorTickSigns[0] : minorTickSigns[0], {
        minor: isMinor
      }) + axes.makeTickPath(ax, p1, isMinor ? majorTickSigns[1] : minorTickSigns[1], {
        minor: isMinor
      });
      axes.drawTicks(gd, ax, {
        vals: tickVals,
        layer: plotinfo[axLetter + 'axislayer'],
        path: spTickPath,
        transFn: transTickFn
      });
    }
  }
  var seq = [];

  // tick labels - for now just the main labels.
  // TODO: mirror labels, esp for subplots

  seq.push(function () {
    return axes.drawLabels(gd, ax, {
      vals: vals,
      layer: mainAxLayer,
      plotinfo: plotinfo,
      transFn: transTickLabelFn,
      labelFns: axes.makeLabelFns(ax, mainLinePositionShift)
    });
  });
  if (ax.type === 'multicategory') {
    var pad = {
      x: 2,
      y: 10
    }[axLetter];
    seq.push(function () {
      var bboxKey = {
        x: 'height',
        y: 'width'
      }[axLetter];
      var standoff = getLabelLevelBbox()[bboxKey] + pad + (ax._tickAngles[axId + 'tick'] ? ax.tickfont.size * LINE_SPACING : 0);
      return axes.drawLabels(gd, ax, {
        vals: getSecondaryLabelVals(ax, vals),
        layer: mainAxLayer,
        cls: axId + 'tick2',
        repositionOnUpdate: true,
        secondary: true,
        transFn: transTickFn,
        labelFns: axes.makeLabelFns(ax, mainLinePositionShift + standoff * majorTickSigns[4])
      });
    });
    seq.push(function () {
      ax._depth = majorTickSigns[4] * (getLabelLevelBbox('tick2')[ax.side] - mainLinePositionShift);
      return drawDividers(gd, ax, {
        vals: dividerVals,
        layer: mainAxLayer,
        path: axes.makeTickPath(ax, mainLinePositionShift, majorTickSigns[4], {
          len: ax._depth
        }),
        transFn: transTickFn
      });
    });
  } else if (ax.title.hasOwnProperty('standoff')) {
    seq.push(function () {
      ax._depth = majorTickSigns[4] * (getLabelLevelBbox()[ax.side] - mainLinePositionShift);
    });
  }
  var hasRangeSlider = Registry.getComponentMethod('rangeslider', 'isVisible')(ax);
  if (!opts.skipTitle && !(hasRangeSlider && ax.side === 'bottom')) {
    seq.push(function () {
      return drawTitle(gd, ax);
    });
  }
  seq.push(function () {
    var s = ax.side.charAt(0);
    var sMirror = OPPOSITE_SIDE[ax.side].charAt(0);
    var pos = axes.getPxPosition(gd, ax);
    var outsideTickLen = outsideTicks ? ax.ticklen : 0;
    var llbbox;
    var push;
    var mirrorPush;
    var rangeSliderPush;
    if (ax.automargin || hasRangeSlider || ax._shiftPusher) {
      if (ax.type === 'multicategory') {
        llbbox = getLabelLevelBbox('tick2');
      } else {
        llbbox = getLabelLevelBbox();
        if (axLetter === 'x' && s === 'b') {
          ax._depth = Math.max(llbbox.width > 0 ? llbbox.bottom - pos : 0, outsideTickLen);
        }
      }
    }
    var axDepth = 0;
    var titleDepth = 0;
    if (ax._shiftPusher) {
      axDepth = Math.max(outsideTickLen, llbbox.height > 0 ? s === 'l' ? pos - llbbox.left : llbbox.right - pos : 0);
      if (ax.title.text !== fullLayout._dfltTitle[axLetter]) {
        titleDepth = (ax._titleStandoff || 0) + (ax._titleScoot || 0);
        if (s === 'l') {
          titleDepth += approxTitleDepth(ax);
        }
      }
      ax._fullDepth = Math.max(axDepth, titleDepth);
    }
    if (ax.automargin) {
      push = {
        x: 0,
        y: 0,
        r: 0,
        l: 0,
        t: 0,
        b: 0
      };
      var domainIndices = [0, 1];
      var shift = typeof ax._shift === 'number' ? ax._shift : 0;
      if (axLetter === 'x') {
        if (s === 'b') {
          push[s] = ax._depth;
        } else {
          push[s] = ax._depth = Math.max(llbbox.width > 0 ? pos - llbbox.top : 0, outsideTickLen);
          domainIndices.reverse();
        }
        if (llbbox.width > 0) {
          var rExtra = llbbox.right - (ax._offset + ax._length);
          if (rExtra > 0) {
            push.xr = 1;
            push.r = rExtra;
          }
          var lExtra = ax._offset - llbbox.left;
          if (lExtra > 0) {
            push.xl = 0;
            push.l = lExtra;
          }
        }
      } else {
        if (s === 'l') {
          ax._depth = Math.max(llbbox.height > 0 ? pos - llbbox.left : 0, outsideTickLen);
          push[s] = ax._depth - shift;
        } else {
          ax._depth = Math.max(llbbox.height > 0 ? llbbox.right - pos : 0, outsideTickLen);
          push[s] = ax._depth + shift;
          domainIndices.reverse();
        }
        if (llbbox.height > 0) {
          var bExtra = llbbox.bottom - (ax._offset + ax._length);
          if (bExtra > 0) {
            push.yb = 0;
            push.b = bExtra;
          }
          var tExtra = ax._offset - llbbox.top;
          if (tExtra > 0) {
            push.yt = 1;
            push.t = tExtra;
          }
        }
      }
      push[counterLetter] = ax.anchor === 'free' ? ax.position : ax._anchorAxis.domain[domainIndices[0]];
      if (ax.title.text !== fullLayout._dfltTitle[axLetter]) {
        push[s] += approxTitleDepth(ax) + (ax.title.standoff || 0);
      }
      if (ax.mirror && ax.anchor !== 'free') {
        mirrorPush = {
          x: 0,
          y: 0,
          r: 0,
          l: 0,
          t: 0,
          b: 0
        };
        mirrorPush[sMirror] = ax.linewidth;
        if (ax.mirror && ax.mirror !== true) mirrorPush[sMirror] += outsideTickLen;
        if (ax.mirror === true || ax.mirror === 'ticks') {
          mirrorPush[counterLetter] = ax._anchorAxis.domain[domainIndices[1]];
        } else if (ax.mirror === 'all' || ax.mirror === 'allticks') {
          mirrorPush[counterLetter] = [ax._counterDomainMin, ax._counterDomainMax][domainIndices[1]];
        }
      }
    }
    if (hasRangeSlider) {
      rangeSliderPush = Registry.getComponentMethod('rangeslider', 'autoMarginOpts')(gd, ax);
    }
    if (typeof ax.automargin === 'string') {
      filterPush(push, ax.automargin);
      filterPush(mirrorPush, ax.automargin);
    }
    Plots.autoMargin(gd, axAutoMarginID(ax), push);
    Plots.autoMargin(gd, axMirrorAutoMarginID(ax), mirrorPush);
    Plots.autoMargin(gd, rangeSliderAutoMarginID(ax), rangeSliderPush);
  });
  return Lib.syncOrAsync(seq);
};
function filterPush(push, automargin) {
  if (!push) return;
  var keepMargin = Object.keys(MARGIN_MAPPING).reduce(function (data, nextKey) {
    if (automargin.indexOf(nextKey) !== -1) {
      MARGIN_MAPPING[nextKey].forEach(function (key) {
        data[key] = 1;
      });
    }
    return data;
  }, {});
  Object.keys(push).forEach(function (key) {
    if (!keepMargin[key]) {
      if (key.length === 1) push[key] = 0;else delete push[key];
    }
  });
}
function getBoundaryVals(ax, vals) {
  var out = [];
  var i;

  // boundaryVals are never used for labels;
  // no need to worry about the other tickTextObj keys
  var _push = function (d, bndIndex) {
    var xb = d.xbnd[bndIndex];
    if (xb !== null) {
      out.push(Lib.extendFlat({}, d, {
        x: xb
      }));
    }
  };
  if (vals.length) {
    for (i = 0; i < vals.length; i++) {
      _push(vals[i], 0);
    }
    _push(vals[i - 1], 1);
  }
  return out;
}
function getSecondaryLabelVals(ax, vals) {
  var out = [];
  var lookup = {};
  for (var i = 0; i < vals.length; i++) {
    var d = vals[i];
    if (lookup[d.text2]) {
      lookup[d.text2].push(d.x);
    } else {
      lookup[d.text2] = [d.x];
    }
  }
  for (var k in lookup) {
    out.push(tickTextObj(ax, Lib.interp(lookup[k], 0.5), k));
  }
  return out;
}
function getDividerVals(ax, vals) {
  var out = [];
  var i, current;
  var reversed = vals.length && vals[vals.length - 1].x < vals[0].x;

  // never used for labels;
  // no need to worry about the other tickTextObj keys
  var _push = function (d, bndIndex) {
    var xb = d.xbnd[bndIndex];
    if (xb !== null) {
      out.push(Lib.extendFlat({}, d, {
        x: xb
      }));
    }
  };
  if (ax.showdividers && vals.length) {
    for (i = 0; i < vals.length; i++) {
      var d = vals[i];
      if (d.text2 !== current) {
        _push(d, reversed ? 1 : 0);
      }
      current = d.text2;
    }
    _push(vals[i - 1], reversed ? 0 : 1);
  }
  return out;
}
function calcLabelLevelBbox(ax, cls, mainLinePositionShift) {
  var top, bottom;
  var left, right;
  if (ax._selections[cls].size()) {
    top = Infinity;
    bottom = -Infinity;
    left = Infinity;
    right = -Infinity;
    ax._selections[cls].each(function () {
      var thisLabel = selectTickLabel(this);
      // Use parent node <g.(x|y)tick>, to make Drawing.bBox
      // retrieve a bbox computed with transform info
      //
      // To improve perf, it would be nice to use `thisLabel.node()`
      // (like in fixLabelOverlaps) instead and use Axes.getPxPosition
      // together with the makeLabelFns outputs and `tickangle`
      // to compute one bbox per (tick value x tick style)
      var bb = Drawing.bBox(thisLabel.node().parentNode);
      top = Math.min(top, bb.top);
      bottom = Math.max(bottom, bb.bottom);
      left = Math.min(left, bb.left);
      right = Math.max(right, bb.right);
    });
  } else {
    var dummyCalc = axes.makeLabelFns(ax, mainLinePositionShift);
    top = bottom = dummyCalc.yFn({
      dx: 0,
      dy: 0,
      fontSize: 0
    });
    left = right = dummyCalc.xFn({
      dx: 0,
      dy: 0,
      fontSize: 0
    });
  }
  return {
    top: top,
    bottom: bottom,
    left: left,
    right: right,
    height: bottom - top,
    width: right - left
  };
}

/**
 * Which direction do the 'ax.side' values, and free ticks go?
 *
 * @param {object} ax (full) axis object
 *  - {string} _id (starting with 'x' or 'y')
 *  - {string} side
 *  - {string} ticks
 * @return {array} all entries are either -1 or 1
 *  - [0]: sign for top/right ticks (i.e. negative SVG direction)
 *  - [1]: sign for bottom/left ticks (i.e. positive SVG direction)
 *  - [2]: sign for ticks corresponding to 'ax.side'
 *  - [3]: sign for ticks mirroring 'ax.side'
 *  - [4]: sign of arrow starting at axis pointing towards margin
 */
axes.getTickSigns = function (ax, minor) {
  var axLetter = ax._id.charAt(0);
  var sideOpposite = {
    x: 'top',
    y: 'right'
  }[axLetter];
  var main = ax.side === sideOpposite ? 1 : -1;
  var out = [-1, 1, main, -main];
  // then we flip if outside XOR y axis

  var ticks = minor ? (ax.minor || {}).ticks : ax.ticks;
  if (ticks !== 'inside' === (axLetter === 'x')) {
    out = out.map(function (v) {
      return -v;
    });
  }
  // independent of `ticks`; do not flip this one
  if (ax.side) {
    out.push({
      l: -1,
      t: -1,
      r: 1,
      b: 1
    }[ax.side.charAt(0)]);
  }
  return out;
};

/**
 * Make axis translate transform function
 *
 * @param {object} ax (full) axis object
 *  - {string} _id
 *  - {number} _offset
 *  - {fn} l2p
 * @return {fn} function of calcTicks items
 */
axes.makeTransTickFn = function (ax) {
  return ax._id.charAt(0) === 'x' ? function (d) {
    return strTranslate(ax._offset + ax.l2p(d.x), 0);
  } : function (d) {
    return strTranslate(0, ax._offset + ax.l2p(d.x));
  };
};
axes.makeTransTickLabelFn = function (ax) {
  var uv = getTickLabelUV(ax);
  var shift = ax.ticklabelshift || 0;
  var standoff = ax.ticklabelstandoff || 0;
  var u = uv[0];
  var v = uv[1];
  var isReversed = ax.range[0] > ax.range[1];
  var labelsInside = ax.ticklabelposition && ax.ticklabelposition.indexOf('inside') !== -1;
  var labelsOutside = !labelsInside;
  if (shift) {
    var shiftSign = isReversed ? -1 : 1;
    shift = shift * shiftSign;
  }
  if (standoff) {
    var side = ax.side;
    var standoffSign = labelsInside && (side === 'top' || side === 'left') || labelsOutside && (side === 'bottom' || side === 'right') ? 1 : -1;
    standoff = standoff * standoffSign;
  }
  return ax._id.charAt(0) === 'x' ? function (d) {
    return strTranslate(u + ax._offset + ax.l2p(getPosX(d)) + shift, v + standoff);
  } : function (d) {
    return strTranslate(v + standoff, u + ax._offset + ax.l2p(getPosX(d)) + shift);
  };
};
function getPosX(d) {
  return d.periodX !== undefined ? d.periodX : d.x;
}

// u is a shift along the axis,
// v is a shift perpendicular to the axis
function getTickLabelUV(ax) {
  var ticklabelposition = ax.ticklabelposition || '';
  var has = function (str) {
    return ticklabelposition.indexOf(str) !== -1;
  };
  var isTop = has('top');
  var isLeft = has('left');
  var isRight = has('right');
  var isBottom = has('bottom');
  var isInside = has('inside');
  var isAligned = isBottom || isLeft || isTop || isRight;

  // early return
  if (!isAligned && !isInside) return [0, 0];
  var side = ax.side;
  var u = isAligned ? (ax.tickwidth || 0) / 2 : 0;
  var v = TEXTPAD;
  var fontSize = ax.tickfont ? ax.tickfont.size : 12;
  if (isBottom || isTop) {
    u += fontSize * CAP_SHIFT;
    v += (ax.linewidth || 0) / 2;
  }
  if (isLeft || isRight) {
    u += (ax.linewidth || 0) / 2;
    v += TEXTPAD;
  }
  if (isInside && side === 'top') {
    v -= fontSize * (1 - CAP_SHIFT);
  }
  if (isLeft || isTop) u = -u;
  if (side === 'bottom' || side === 'right') v = -v;
  return [isAligned ? u : 0, isInside ? v : 0];
}

/**
 * Make axis tick path string
 *
 * @param {object} ax (full) axis object
 *  - {string} _id
 *  - {number} ticklen
 *  - {number} linewidth
 * @param {number} shift along direction of ticklen
 * @param {1 or -1} sgn tick sign
 * @param {object} opts
 * - {number (optional)} len tick length
 * @return {string}
 */
axes.makeTickPath = function (ax, shift, sgn, opts) {
  if (!opts) opts = {};
  var minor = opts.minor;
  if (minor && !ax.minor) return '';
  var len = opts.len !== undefined ? opts.len : minor ? ax.minor.ticklen : ax.ticklen;
  var axLetter = ax._id.charAt(0);
  var pad = (ax.linewidth || 1) / 2;
  return axLetter === 'x' ? 'M0,' + (shift + pad * sgn) + 'v' + len * sgn : 'M' + (shift + pad * sgn) + ',0h' + len * sgn;
};

/**
 * Make axis tick label x, y and anchor functions
 *
 * @param {object} ax (full) axis object
 *  - {string} _id
 *  - {string} ticks
 *  - {number} ticklen
 *  - {string} side
 *  - {number} linewidth
 *  - {number} tickfont.size
 *  - {boolean} showline
 * @param {number} shift
 * @param {number} angle [in degrees] ...
 * @return {object}
 *  - {fn} xFn
 *  - {fn} yFn
 *  - {fn} anchorFn
 *  - {fn} heightFn
 *  - {number} labelStandoff (gap parallel to ticks)
 *  - {number} labelShift (gap perpendicular to ticks)
 */
axes.makeLabelFns = function (ax, shift, angle) {
  var ticklabelposition = ax.ticklabelposition || '';
  var has = function (str) {
    return ticklabelposition.indexOf(str) !== -1;
  };
  var isTop = has('top');
  var isLeft = has('left');
  var isRight = has('right');
  var isBottom = has('bottom');
  var isAligned = isBottom || isLeft || isTop || isRight;
  var insideTickLabels = has('inside');
  var labelsOverTicks = ticklabelposition === 'inside' && ax.ticks === 'inside' || !insideTickLabels && ax.ticks === 'outside' && ax.tickson !== 'boundaries';
  var labelStandoff = 0;
  var labelShift = 0;
  var tickLen = labelsOverTicks ? ax.ticklen : 0;
  if (insideTickLabels) {
    tickLen *= -1;
  } else if (isAligned) {
    tickLen = 0;
  }
  if (labelsOverTicks) {
    labelStandoff += tickLen;
    if (angle) {
      var rad = Lib.deg2rad(angle);
      labelStandoff = tickLen * Math.cos(rad) + 1;
      labelShift = tickLen * Math.sin(rad);
    }
  }
  if (ax.showticklabels && (labelsOverTicks || ax.showline)) {
    labelStandoff += 0.2 * ax.tickfont.size;
  }
  labelStandoff += (ax.linewidth || 1) / 2 * (insideTickLabels ? -1 : 1);
  var out = {
    labelStandoff: labelStandoff,
    labelShift: labelShift
  };
  var x0, y0, ff, flipIt;
  var xQ = 0;
  var side = ax.side;
  var axLetter = ax._id.charAt(0);
  var tickangle = ax.tickangle;
  var endSide;
  if (axLetter === 'x') {
    endSide = !insideTickLabels && side === 'bottom' || insideTickLabels && side === 'top';
    flipIt = endSide ? 1 : -1;
    if (insideTickLabels) flipIt *= -1;
    x0 = labelShift * flipIt;
    y0 = shift + labelStandoff * flipIt;
    ff = endSide ? 1 : -0.2;
    if (Math.abs(tickangle) === 90) {
      if (insideTickLabels) {
        ff += MID_SHIFT;
      } else {
        if (tickangle === -90 && side === 'bottom') {
          ff = CAP_SHIFT;
        } else if (tickangle === 90 && side === 'top') {
          ff = MID_SHIFT;
        } else {
          ff = 0.5;
        }
      }
      xQ = MID_SHIFT / 2 * (tickangle / 90);
    }
    out.xFn = function (d) {
      return d.dx + x0 + xQ * d.fontSize;
    };
    out.yFn = function (d) {
      return d.dy + y0 + d.fontSize * ff;
    };
    out.anchorFn = function (d, a) {
      if (isAligned) {
        if (isLeft) return 'end';
        if (isRight) return 'start';
      }
      if (!isNumeric(a) || a === 0 || a === 180) {
        return 'middle';
      }
      return a * flipIt < 0 !== insideTickLabels ? 'end' : 'start';
    };
    out.heightFn = function (d, a, h) {
      return a < -60 || a > 60 ? -0.5 * h : ax.side === 'top' !== insideTickLabels ? -h : 0;
    };
  } else if (axLetter === 'y') {
    endSide = !insideTickLabels && side === 'left' || insideTickLabels && side === 'right';
    flipIt = endSide ? 1 : -1;
    if (insideTickLabels) flipIt *= -1;
    x0 = labelStandoff;
    y0 = labelShift * flipIt;
    ff = 0;
    if (!insideTickLabels && Math.abs(tickangle) === 90) {
      if (tickangle === -90 && side === 'left' || tickangle === 90 && side === 'right') {
        ff = CAP_SHIFT;
      } else {
        ff = 0.5;
      }
    }
    if (insideTickLabels) {
      var ang = isNumeric(tickangle) ? +tickangle : 0;
      if (ang !== 0) {
        var rA = Lib.deg2rad(ang);
        xQ = Math.abs(Math.sin(rA)) * CAP_SHIFT * flipIt;
        ff = 0;
      }
    }
    out.xFn = function (d) {
      return d.dx + shift - (x0 + d.fontSize * ff) * flipIt + xQ * d.fontSize;
    };
    out.yFn = function (d) {
      return d.dy + y0 + d.fontSize * MID_SHIFT;
    };
    out.anchorFn = function (d, a) {
      if (isNumeric(a) && Math.abs(a) === 90) {
        return 'middle';
      }
      return endSide ? 'end' : 'start';
    };
    out.heightFn = function (d, a, h) {
      if (ax.side === 'right') a *= -1;
      return a < -30 ? -h : a < 30 ? -0.5 * h : 0;
    };
  }
  return out;
};
function tickDataFn(d) {
  return [d.text, d.x, d.axInfo, d.font, d.fontSize, d.fontColor].join('_');
}

/**
 * Draw axis ticks
 *
 * @param {DOM element} gd
 * @param {object} ax (full) axis object
 *  - {string} _id
 *  - {string} ticks
 *  - {number} linewidth
 *  - {string} tickcolor
 * @param {object} opts
 * - {array of object} vals (calcTicks output-like)
 * - {d3 selection} layer
 * - {string or fn} path
 * - {fn} transFn
 * - {boolean} crisp (set to false to unset crisp-edge SVG rendering)
 */
axes.drawTicks = function (gd, ax, opts) {
  opts = opts || {};
  var cls = ax._id + 'tick';
  var vals = [].concat(ax.minor && ax.minor.ticks ?
  // minor vals
  opts.vals.filter(function (d) {
    return d.minor && !d.noTick;
  }) : []).concat(ax.ticks ?
  // major vals
  opts.vals.filter(function (d) {
    return !d.minor && !d.noTick;
  }) : []);
  var ticks = opts.layer.selectAll('path.' + cls).data(vals, tickDataFn);
  ticks.exit().remove();
  ticks.enter().append('path').classed(cls, 1).classed('ticks', 1).classed('crisp', opts.crisp !== false).each(function (d) {
    return Color.stroke(d3.select(this), d.minor ? ax.minor.tickcolor : ax.tickcolor);
  }).style('stroke-width', function (d) {
    return Drawing.crispRound(gd, d.minor ? ax.minor.tickwidth : ax.tickwidth, 1) + 'px';
  }).attr('d', opts.path).style('display', null); // visible

  hideCounterAxisInsideTickLabels(ax, [TICK_PATH]);
  ticks.attr('transform', opts.transFn);
};

/**
 * Draw axis grid
 *
 * @param {DOM element} gd
 * @param {object} ax (full) axis object
 *  - {string} _id
 *  - {boolean} showgrid
 *  - {string} gridcolor
 *  - {string} gridwidth
 *  - {string} griddash
 *  - {boolean} zeroline
 *  - {string} type
 *  - {string} dtick
 * @param {object} opts
 * - {array of object} vals (calcTicks output-like)
 * - {d3 selection} layer
 * - {object} counterAxis (full axis object corresponding to counter axis)
 *     optional - only required if this axis supports zero lines
 * - {string or fn} path
 * - {fn} transFn
 * - {boolean} crisp (set to false to unset crisp-edge SVG rendering)
 */
axes.drawGrid = function (gd, ax, opts) {
  opts = opts || {};
  if (ax.tickmode === 'sync') {
    // for tickmode sync we use the overlaying axis grid
    return;
  }
  var cls = ax._id + 'grid';
  var hasMinor = ax.minor && ax.minor.showgrid;
  var minorVals = hasMinor ? opts.vals.filter(function (d) {
    return d.minor;
  }) : [];
  var majorVals = ax.showgrid ? opts.vals.filter(function (d) {
    return !d.minor;
  }) : [];
  var counterAx = opts.counterAxis;
  if (counterAx && axes.shouldShowZeroLine(gd, ax, counterAx)) {
    var isArrayMode = ax.tickmode === 'array';
    for (var i = 0; i < majorVals.length; i++) {
      var xi = majorVals[i].x;
      if (isArrayMode ? !xi : Math.abs(xi) < ax.dtick / 100) {
        majorVals = majorVals.slice(0, i).concat(majorVals.slice(i + 1));
        // In array mode you can in principle have multiple
        // ticks at 0, so test them all. Otherwise once we found
        // one we can stop.
        if (isArrayMode) i--;else break;
      }
    }
  }
  ax._gw = Drawing.crispRound(gd, ax.gridwidth, 1);
  var wMinor = !hasMinor ? 0 : Drawing.crispRound(gd, ax.minor.gridwidth, 1);
  var majorLayer = opts.layer;
  var minorLayer = opts.minorLayer;
  for (var major = 1; major >= 0; major--) {
    var layer = major ? majorLayer : minorLayer;
    if (!layer) continue;
    var grid = layer.selectAll('path.' + cls).data(major ? majorVals : minorVals, tickDataFn);
    grid.exit().remove();
    grid.enter().append('path').classed(cls, 1).classed('crisp', opts.crisp !== false);
    grid.attr('transform', opts.transFn).attr('d', opts.path).each(function (d) {
      return Color.stroke(d3.select(this), d.minor ? ax.minor.gridcolor : ax.gridcolor || '#ddd');
    }).style('stroke-dasharray', function (d) {
      return Drawing.dashStyle(d.minor ? ax.minor.griddash : ax.griddash, d.minor ? ax.minor.gridwidth : ax.gridwidth);
    }).style('stroke-width', function (d) {
      return (d.minor ? wMinor : ax._gw) + 'px';
    }).style('display', null); // visible

    if (typeof opts.path === 'function') grid.attr('d', opts.path);
  }
  hideCounterAxisInsideTickLabels(ax, [GRID_PATH, MINORGRID_PATH]);
};

/**
 * Draw axis zero-line
 *
 * @param {DOM element} gd
 * @param {object} ax (full) axis object
 *  - {string} _id
 *  - {boolean} zeroline
 *  - {number} zerolinewidth
 *  - {string} zerolinecolor
 *  - {number (optional)} _gridWidthCrispRound
 * @param {object} opts
 * - {d3 selection} layer
 * - {object} counterAxis (full axis object corresponding to counter axis)
 * - {string or fn} path
 * - {fn} transFn
 * - {boolean} crisp (set to false to unset crisp-edge SVG rendering)
 */
axes.drawZeroLine = function (gd, ax, opts) {
  opts = opts || opts;
  var cls = ax._id + 'zl';
  var show = axes.shouldShowZeroLine(gd, ax, opts.counterAxis);
  var zl = opts.layer.selectAll('path.' + cls).data(show ? [{
    x: 0,
    id: ax._id
  }] : []);
  zl.exit().remove();
  zl.enter().append('path').classed(cls, 1).classed('zl', 1).classed('crisp', opts.crisp !== false).each(function () {
    // use the fact that only one element can enter to trigger a sort.
    // If several zerolines enter at the same time we will sort once per,
    // but generally this should be a minimal overhead.
    opts.layer.selectAll('path').sort(function (da, db) {
      return idSort(da.id, db.id);
    });
  });
  zl.attr('transform', opts.transFn).attr('d', opts.path).call(Color.stroke, ax.zerolinecolor || Color.defaultLine).style('stroke-width', Drawing.crispRound(gd, ax.zerolinewidth, ax._gw || 1) + 'px').style('display', null); // visible

  hideCounterAxisInsideTickLabels(ax, [ZERO_PATH]);
};

/**
 * Draw axis tick labels
 *
 * @param {DOM element} gd
 * @param {object} ax (full) axis object
 *  - {string} _id
 *  - {boolean} showticklabels
 *  - {number} tickangle
 *  - {object (optional)} _selections
 *  - {object} (optional)} _tickAngles
 *  - {object} (optional)} _prevTickAngles
 * @param {object} opts
 * - {array of object} vals (calcTicks output-like)
 * - {d3 selection} layer
 * - {string (optional)} cls (node className)
 * - {boolean} repositionOnUpdate (set to true to reposition update selection)
 * - {boolean} secondary
 * - {fn} transFn
 * - {object} labelFns
 *  + {fn} xFn
 *  + {fn} yFn
 *  + {fn} anchorFn
 *  + {fn} heightFn
 */
axes.drawLabels = function (gd, ax, opts) {
  opts = opts || {};
  var fullLayout = gd._fullLayout;
  var axId = ax._id;
  var cls = opts.cls || axId + 'tick';
  var vals = opts.vals.filter(function (d) {
    return d.text;
  });
  var labelFns = opts.labelFns;
  var tickAngle = opts.secondary ? 0 : ax.tickangle;
  var prevAngle = (ax._prevTickAngles || {})[cls];
  var tickLabels = opts.layer.selectAll('g.' + cls).data(ax.showticklabels ? vals : [], tickDataFn);
  var labelsReady = [];
  tickLabels.enter().append('g').classed(cls, 1).append('text')
  // only so tex has predictable alignment that we can
  // alter later
  .attr('text-anchor', 'middle').each(function (d) {
    var thisLabel = d3.select(this);
    var newPromise = gd._promises.length;
    thisLabel.call(svgTextUtils.positionText, labelFns.xFn(d), labelFns.yFn(d)).call(Drawing.font, {
      family: d.font,
      size: d.fontSize,
      color: d.fontColor,
      weight: d.fontWeight,
      style: d.fontStyle,
      variant: d.fontVariant,
      textcase: d.fontTextcase,
      lineposition: d.fontLineposition,
      shadow: d.fontShadow
    }).text(d.text).call(svgTextUtils.convertToTspans, gd);
    if (gd._promises[newPromise]) {
      // if we have an async label, we'll deal with that
      // all here so take it out of gd._promises and
      // instead position the label and promise this in
      // labelsReady
      labelsReady.push(gd._promises.pop().then(function () {
        positionLabels(thisLabel, tickAngle);
      }));
    } else {
      // sync label: just position it now.
      positionLabels(thisLabel, tickAngle);
    }
  });
  hideCounterAxisInsideTickLabels(ax, [TICK_TEXT]);
  tickLabels.exit().remove();
  if (opts.repositionOnUpdate) {
    tickLabels.each(function (d) {
      d3.select(this).select('text').call(svgTextUtils.positionText, labelFns.xFn(d), labelFns.yFn(d));
    });
  }
  function positionLabels(s, angle) {
    s.each(function (d) {
      var thisLabel = d3.select(this);
      var mathjaxGroup = thisLabel.select('.text-math-group');
      var anchor = labelFns.anchorFn(d, angle);
      var transform = opts.transFn.call(thisLabel.node(), d) + (isNumeric(angle) && +angle !== 0 ? ' rotate(' + angle + ',' + labelFns.xFn(d) + ',' + (labelFns.yFn(d) - d.fontSize / 2) + ')' : '');

      // how much to shift a multi-line label to center it vertically.
      var nLines = svgTextUtils.lineCount(thisLabel);
      var lineHeight = LINE_SPACING * d.fontSize;
      var anchorHeight = labelFns.heightFn(d, isNumeric(angle) ? +angle : 0, (nLines - 1) * lineHeight);
      if (anchorHeight) {
        transform += strTranslate(0, anchorHeight);
      }
      if (mathjaxGroup.empty()) {
        var thisText = thisLabel.select('text');
        thisText.attr({
          transform: transform,
          'text-anchor': anchor
        });
        thisText.style('opacity', 1); // visible

        if (ax._adjustTickLabelsOverflow) {
          ax._adjustTickLabelsOverflow();
        }
      } else {
        var mjWidth = Drawing.bBox(mathjaxGroup.node()).width;
        var mjShift = mjWidth * {
          end: -0.5,
          start: 0.5
        }[anchor];
        mathjaxGroup.attr('transform', transform + strTranslate(mjShift, 0));
      }
    });
  }
  ax._adjustTickLabelsOverflow = function () {
    var ticklabeloverflow = ax.ticklabeloverflow;
    if (!ticklabeloverflow || ticklabeloverflow === 'allow') return;
    var hideOverflow = ticklabeloverflow.indexOf('hide') !== -1;
    var isX = ax._id.charAt(0) === 'x';
    // div positions
    var p0 = 0;
    var p1 = isX ? gd._fullLayout.width : gd._fullLayout.height;
    if (ticklabeloverflow.indexOf('domain') !== -1) {
      // domain positions
      var rl = Lib.simpleMap(ax.range, ax.r2l);
      p0 = ax.l2p(rl[0]) + ax._offset;
      p1 = ax.l2p(rl[1]) + ax._offset;
    }
    var min = Math.min(p0, p1);
    var max = Math.max(p0, p1);
    var side = ax.side;
    var visibleLabelMin = Infinity;
    var visibleLabelMax = -Infinity;
    tickLabels.each(function (d) {
      var thisLabel = d3.select(this);
      var mathjaxGroup = thisLabel.select('.text-math-group');
      if (mathjaxGroup.empty()) {
        var bb = Drawing.bBox(thisLabel.node());
        var adjust = 0;
        if (isX) {
          if (bb.right > max) adjust = 1;else if (bb.left < min) adjust = 1;
        } else {
          if (bb.bottom > max) adjust = 1;else if (bb.top + (ax.tickangle ? 0 : d.fontSize / 4) < min) adjust = 1;
        }
        var t = thisLabel.select('text');
        if (adjust) {
          if (hideOverflow) t.style('opacity', 0); // hidden
        } else {
          t.style('opacity', 1); // visible

          if (side === 'bottom' || side === 'right') {
            visibleLabelMin = Math.min(visibleLabelMin, isX ? bb.top : bb.left);
          } else {
            visibleLabelMin = -Infinity;
          }
          if (side === 'top' || side === 'left') {
            visibleLabelMax = Math.max(visibleLabelMax, isX ? bb.bottom : bb.right);
          } else {
            visibleLabelMax = Infinity;
          }
        }
      } // TODO: hide mathjax?
    });
    for (var subplot in fullLayout._plots) {
      var plotinfo = fullLayout._plots[subplot];
      if (ax._id !== plotinfo.xaxis._id && ax._id !== plotinfo.yaxis._id) continue;
      var anchorAx = isX ? plotinfo.yaxis : plotinfo.xaxis;
      if (anchorAx) {
        anchorAx['_visibleLabelMin_' + ax._id] = visibleLabelMin;
        anchorAx['_visibleLabelMax_' + ax._id] = visibleLabelMax;
      }
    }
  };
  ax._hideCounterAxisInsideTickLabels = function (partialOpts) {
    var isX = ax._id.charAt(0) === 'x';
    var anchoredAxes = [];
    for (var subplot in fullLayout._plots) {
      var plotinfo = fullLayout._plots[subplot];
      if (ax._id !== plotinfo.xaxis._id && ax._id !== plotinfo.yaxis._id) continue;
      anchoredAxes.push(isX ? plotinfo.yaxis : plotinfo.xaxis);
    }
    anchoredAxes.forEach(function (anchorAx, idx) {
      if (anchorAx && insideTicklabelposition(anchorAx)) {
        (partialOpts || [ZERO_PATH, MINORGRID_PATH, GRID_PATH, TICK_PATH, TICK_TEXT]).forEach(function (e) {
          var isPeriodLabel = e.K === 'tick' && e.L === 'text' && ax.ticklabelmode === 'period';
          var mainPlotinfo = fullLayout._plots[ax._mainSubplot];
          var sel;
          if (e.K === ZERO_PATH.K) sel = mainPlotinfo.zerolinelayer.selectAll('.' + ax._id + 'zl');else if (e.K === MINORGRID_PATH.K) sel = mainPlotinfo.minorGridlayer.selectAll('.' + ax._id);else if (e.K === GRID_PATH.K) sel = mainPlotinfo.gridlayer.selectAll('.' + ax._id);else sel = mainPlotinfo[ax._id.charAt(0) + 'axislayer'];
          sel.each(function () {
            var w = d3.select(this);
            if (e.L) w = w.selectAll(e.L);
            w.each(function (d) {
              var q = ax.l2p(isPeriodLabel ? getPosX(d) : d.x) + ax._offset;
              var t = d3.select(this);
              if (q < ax['_visibleLabelMax_' + anchorAx._id] && q > ax['_visibleLabelMin_' + anchorAx._id]) {
                t.style('display', 'none'); // hidden
              } else if (e.K === 'tick' && !idx) {
                t.style('display', null); // visible
              }
            });
          });
        });
      }
    });
  };

  // make sure all labels are correctly positioned at their base angle
  // the positionLabels call above is only for newly drawn labels.
  // do this without waiting, using the last calculated angle to
  // minimize flicker, then do it again when we know all labels are
  // there, putting back the prescribed angle to check for overlaps.
  positionLabels(tickLabels, prevAngle + 1 ? prevAngle : tickAngle);
  function allLabelsReady() {
    return labelsReady.length && Promise.all(labelsReady);
  }
  var autoangle = null;
  function fixLabelOverlaps() {
    positionLabels(tickLabels, tickAngle);

    // check for auto-angling if x labels overlap
    // don't auto-angle at all for log axes with
    // base and digit format
    if (vals.length && ax.autotickangles && (ax.type !== 'log' || String(ax.dtick).charAt(0) !== 'D')) {
      autoangle = ax.autotickangles[0];
      var maxFontSize = 0;
      var lbbArray = [];
      var i;
      var maxLines = 1;
      tickLabels.each(function (d) {
        maxFontSize = Math.max(maxFontSize, d.fontSize);
        var x = ax.l2p(d.x);
        var thisLabel = selectTickLabel(this);
        var bb = Drawing.bBox(thisLabel.node());
        maxLines = Math.max(maxLines, svgTextUtils.lineCount(thisLabel));
        lbbArray.push({
          // ignore about y, just deal with x overlaps
          top: 0,
          bottom: 10,
          height: 10,
          left: x - bb.width / 2,
          // impose a 2px gap
          right: x + bb.width / 2 + 2,
          width: bb.width + 2
        });
      });

      // autotickangles
      // if there are dividers or ticks on boundaries, the labels will be in between and
      // we need to prevent overlap with the next divider/tick. Else the labels will be on
      // the ticks and we need to prevent overlap with the next label.

      // TODO should secondary labels also fall into this fix-overlap regime?
      var preventOverlapWithTick = (ax.tickson === 'boundaries' || ax.showdividers) && !opts.secondary;
      var vLen = vals.length;
      var tickSpacing = Math.abs((vals[vLen - 1].x - vals[0].x) * ax._m) / (vLen - 1);
      var adjacent = preventOverlapWithTick ? tickSpacing / 2 : tickSpacing;
      var opposite = preventOverlapWithTick ? ax.ticklen : maxFontSize * 1.25 * maxLines;
      var hypotenuse = Math.sqrt(Math.pow(adjacent, 2) + Math.pow(opposite, 2));
      var maxCos = adjacent / hypotenuse;
      var autoTickAnglesRadians = ax.autotickangles.map(function (degrees) {
        return degrees * Math.PI / 180;
      });
      var angleRadians = autoTickAnglesRadians.find(function (angle) {
        return Math.abs(Math.cos(angle)) <= maxCos;
      });
      if (angleRadians === undefined) {
        // no angle with smaller cosine than maxCos, just pick the angle with smallest cosine
        angleRadians = autoTickAnglesRadians.reduce(function (currentMax, nextAngle) {
          return Math.abs(Math.cos(currentMax)) < Math.abs(Math.cos(nextAngle)) ? currentMax : nextAngle;
        }, autoTickAnglesRadians[0]);
      }
      var newAngle = angleRadians * (180 / Math.PI /* to degrees */);
      if (preventOverlapWithTick) {
        var gap = 2;
        if (ax.ticks) gap += ax.tickwidth / 2;
        for (i = 0; i < lbbArray.length; i++) {
          var xbnd = vals[i].xbnd;
          var lbb = lbbArray[i];
          if (xbnd[0] !== null && lbb.left - ax.l2p(xbnd[0]) < gap || xbnd[1] !== null && ax.l2p(xbnd[1]) - lbb.right < gap) {
            autoangle = newAngle;
            break;
          }
        }
      } else {
        var ticklabelposition = ax.ticklabelposition || '';
        var has = function (str) {
          return ticklabelposition.indexOf(str) !== -1;
        };
        var isTop = has('top');
        var isLeft = has('left');
        var isRight = has('right');
        var isBottom = has('bottom');
        var isAligned = isBottom || isLeft || isTop || isRight;
        var pad = !isAligned ? 0 : (ax.tickwidth || 0) + 2 * TEXTPAD;
        for (i = 0; i < lbbArray.length - 1; i++) {
          if (Lib.bBoxIntersect(lbbArray[i], lbbArray[i + 1], pad)) {
            autoangle = newAngle;
            break;
          }
        }
      }
      if (autoangle) {
        positionLabels(tickLabels, autoangle);
      }
    }
  }
  if (ax._selections) {
    ax._selections[cls] = tickLabels;
  }
  var seq = [allLabelsReady];

  // N.B. during auto-margin redraws, if the axis fixed its label overlaps
  // by rotating 90 degrees, do not attempt to re-fix its label overlaps
  // as this can lead to infinite redraw loops!
  if (ax.automargin && fullLayout._redrawFromAutoMarginCount && prevAngle === 90) {
    autoangle = prevAngle;
    seq.push(function () {
      positionLabels(tickLabels, prevAngle);
    });
  } else {
    seq.push(fixLabelOverlaps);
  }

  // save current tick angle for future redraws
  if (ax._tickAngles) {
    seq.push(function () {
      ax._tickAngles[cls] = autoangle === null ? isNumeric(tickAngle) ? tickAngle : 0 : autoangle;
    });
  }
  var computeTickLabelBoundingBoxes = function () {
    var labelsMaxW = 0;
    var labelsMaxH = 0;
    tickLabels.each(function (d, i) {
      var thisLabel = selectTickLabel(this);
      var mathjaxGroup = thisLabel.select('.text-math-group');
      if (mathjaxGroup.empty()) {
        var bb;
        if (ax._vals[i]) {
          bb = ax._vals[i].bb || Drawing.bBox(thisLabel.node());
          ax._vals[i].bb = bb;
        }
        labelsMaxW = Math.max(labelsMaxW, bb.width);
        labelsMaxH = Math.max(labelsMaxH, bb.height);
      }
    });
    return {
      labelsMaxW: labelsMaxW,
      labelsMaxH: labelsMaxH
    };
  };
  var anchorAx = ax._anchorAxis;
  if (anchorAx && (anchorAx.autorange || anchorAx.insiderange) && insideTicklabelposition(ax) && !isLinked(fullLayout, ax._id)) {
    if (!fullLayout._insideTickLabelsUpdaterange) {
      fullLayout._insideTickLabelsUpdaterange = {};
    }
    if (anchorAx.autorange) {
      fullLayout._insideTickLabelsUpdaterange[anchorAx._name + '.autorange'] = anchorAx.autorange;
      seq.push(computeTickLabelBoundingBoxes);
    }
    if (anchorAx.insiderange) {
      var BBs = computeTickLabelBoundingBoxes();
      var move = ax._id.charAt(0) === 'y' ? BBs.labelsMaxW : BBs.labelsMaxH;
      move += 2 * TEXTPAD;
      if (ax.ticklabelposition === 'inside') {
        move += ax.ticklen || 0;
      }
      var sgn = ax.side === 'right' || ax.side === 'top' ? 1 : -1;
      var index = sgn === 1 ? 1 : 0;
      var otherIndex = sgn === 1 ? 0 : 1;
      var newRange = [];
      newRange[otherIndex] = anchorAx.range[otherIndex];
      var anchorAxRange = anchorAx.range;
      var p0 = anchorAx.r2p(anchorAxRange[index]);
      var p1 = anchorAx.r2p(anchorAxRange[otherIndex]);
      var _tempNewRange = fullLayout._insideTickLabelsUpdaterange[anchorAx._name + '.range'];
      if (_tempNewRange) {
        // case of having multiple anchored axes having insideticklabel
        var q0 = anchorAx.r2p(_tempNewRange[index]);
        var q1 = anchorAx.r2p(_tempNewRange[otherIndex]);
        var dir = sgn * (ax._id.charAt(0) === 'y' ? 1 : -1);
        if (dir * p0 < dir * q0) {
          p0 = q0;
          newRange[index] = anchorAxRange[index] = _tempNewRange[index];
        }
        if (dir * p1 > dir * q1) {
          p1 = q1;
          newRange[otherIndex] = anchorAxRange[otherIndex] = _tempNewRange[otherIndex];
        }
      }
      var dist = Math.abs(p1 - p0);
      if (dist - move > 0) {
        dist -= move;
        move *= 1 + move / dist;
      } else {
        move = 0;
      }
      if (ax._id.charAt(0) !== 'y') move = -move;
      newRange[index] = anchorAx.p2r(anchorAx.r2p(anchorAxRange[index]) + sgn * move);

      // handle partial ranges in insiderange
      if (anchorAx.autorange === 'min' || anchorAx.autorange === 'max reversed') {
        newRange[0] = null;
        anchorAx._rangeInitial0 = undefined;
        anchorAx._rangeInitial1 = undefined;
      } else if (anchorAx.autorange === 'max' || anchorAx.autorange === 'min reversed') {
        newRange[1] = null;
        anchorAx._rangeInitial0 = undefined;
        anchorAx._rangeInitial1 = undefined;
      }
      fullLayout._insideTickLabelsUpdaterange[anchorAx._name + '.range'] = newRange;
    }
  }
  var done = Lib.syncOrAsync(seq);
  if (done && done.then) gd._promises.push(done);
  return done;
};

/**
 * Draw axis dividers
 *
 * @param {DOM element} gd
 * @param {object} ax (full) axis object
 *  - {string} _id
 *  - {string} showdividers
 *  - {number} dividerwidth
 *  - {string} dividercolor
 * @param {object} opts
 * - {array of object} vals (calcTicks output-like)
 * - {d3 selection} layer
 * - {fn} path
 * - {fn} transFn
 */
function drawDividers(gd, ax, opts) {
  var cls = ax._id + 'divider';
  var vals = opts.vals;
  var dividers = opts.layer.selectAll('path.' + cls).data(vals, tickDataFn);
  dividers.exit().remove();
  dividers.enter().insert('path', ':first-child').classed(cls, 1).classed('crisp', 1).call(Color.stroke, ax.dividercolor).style('stroke-width', Drawing.crispRound(gd, ax.dividerwidth, 1) + 'px');
  dividers.attr('transform', opts.transFn).attr('d', opts.path);
}

/**
 * Get axis position in px, that is the distance for the graph's
 * top (left) edge for x (y) axes.
 *
 * @param {DOM element} gd
 * @param {object} ax (full) axis object
 *  - {string} _id
 *  - {string} side
 *  if anchored:
 *  - {object} _anchorAxis
 *  Otherwise:
 *  - {number} position
 * @return {number}
 */
axes.getPxPosition = function (gd, ax) {
  var gs = gd._fullLayout._size;
  var axLetter = ax._id.charAt(0);
  var side = ax.side;
  var anchorAxis;
  if (ax.anchor !== 'free') {
    anchorAxis = ax._anchorAxis;
  } else if (axLetter === 'x') {
    anchorAxis = {
      _offset: gs.t + (1 - (ax.position || 0)) * gs.h,
      _length: 0
    };
  } else if (axLetter === 'y') {
    anchorAxis = {
      _offset: gs.l + (ax.position || 0) * gs.w + ax._shift,
      _length: 0
    };
  }
  if (side === 'top' || side === 'left') {
    return anchorAxis._offset;
  } else if (side === 'bottom' || side === 'right') {
    return anchorAxis._offset + anchorAxis._length;
  }
};

/**
 * Approximate axis title depth (w/o computing its bounding box)
 *
 * @param {object} ax (full) axis object
 *  - {string} title.text
 *  - {number} title.font.size
 *  - {number} title.standoff
 * @return {number} (in px)
 */
function approxTitleDepth(ax) {
  var fontSize = ax.title.font.size;
  var extraLines = (ax.title.text.match(svgTextUtils.BR_TAG_ALL) || []).length;
  if (ax.title.hasOwnProperty('standoff')) {
    return fontSize * (CAP_SHIFT + extraLines * LINE_SPACING);
  } else {
    return extraLines ? fontSize * (extraLines + 1) * LINE_SPACING : fontSize;
  }
}

/**
 * Draw axis title, compute default standoff if necessary
 *
 * @param {DOM element} gd
 * @param {object} ax (full) axis object
 *  - {string} _id
 *  - {string} _name
 *  - {string} side
 *  - {number} title.font.size
 *  - {object} _selections
 *
 *  - {number} _depth
 *  - {number} title.standoff
 *  OR
 *  - {number} linewidth
 *  - {boolean} showticklabels
 */
function drawTitle(gd, ax) {
  var fullLayout = gd._fullLayout;
  var axId = ax._id;
  var axLetter = axId.charAt(0);
  var fontSize = ax.title.font.size;
  var titleStandoff;
  var extraLines = (ax.title.text.match(svgTextUtils.BR_TAG_ALL) || []).length;
  if (ax.title.hasOwnProperty('standoff')) {
    // With ax._depth the initial drawing baseline is at the outer axis border (where the
    // ticklabels are drawn). Since the title text will be drawn above the baseline,
    // bottom/right axes must be shifted by 1 text line to draw below ticklabels instead of on
    // top of them, whereas for top/left axes, the first line would be drawn
    // before the ticklabels, but we need an offset for the descender portion of the first line
    // and all subsequent lines.
    if (ax.side === 'bottom' || ax.side === 'right') {
      titleStandoff = ax._depth + ax.title.standoff + fontSize * CAP_SHIFT;
    } else if (ax.side === 'top' || ax.side === 'left') {
      titleStandoff = ax._depth + ax.title.standoff + fontSize * (MID_SHIFT + extraLines * LINE_SPACING);
    }
  } else {
    var isInside = insideTicklabelposition(ax);
    if (ax.type === 'multicategory') {
      titleStandoff = ax._depth;
    } else {
      var offsetBase = 1.5 * fontSize;
      if (isInside) {
        offsetBase = 0.5 * fontSize;
        if (ax.ticks === 'outside') {
          offsetBase += ax.ticklen;
        }
      }
      titleStandoff = 10 + offsetBase + (ax.linewidth ? ax.linewidth - 1 : 0);
    }
    if (!isInside) {
      if (axLetter === 'x') {
        titleStandoff += ax.side === 'top' ? fontSize * (ax.showticklabels ? 1 : 0) : fontSize * (ax.showticklabels ? 1.5 : 0.5);
      } else {
        titleStandoff += ax.side === 'right' ? fontSize * (ax.showticklabels ? 1 : 0.5) : fontSize * (ax.showticklabels ? 0.5 : 0);
      }
    }
  }
  var pos = axes.getPxPosition(gd, ax);
  var transform, x, y;
  if (axLetter === 'x') {
    x = ax._offset + ax._length / 2;
    y = ax.side === 'top' ? pos - titleStandoff : pos + titleStandoff;
  } else {
    y = ax._offset + ax._length / 2;
    x = ax.side === 'right' ? pos + titleStandoff : pos - titleStandoff;
    transform = {
      rotate: '-90',
      offset: 0
    };
  }
  var avoid;
  if (ax.type !== 'multicategory') {
    var tickLabels = ax._selections[ax._id + 'tick'];
    avoid = {
      selection: tickLabels,
      side: ax.side
    };
    if (tickLabels && tickLabels.node() && tickLabels.node().parentNode) {
      var translation = Drawing.getTranslate(tickLabels.node().parentNode);
      avoid.offsetLeft = translation.x;
      avoid.offsetTop = translation.y;
    }
    if (ax.title.hasOwnProperty('standoff')) {
      avoid.pad = 0;
    }
  }
  ax._titleStandoff = titleStandoff;
  return Titles.draw(gd, axId + 'title', {
    propContainer: ax,
    propName: ax._name + '.title.text',
    placeholder: fullLayout._dfltTitle[axLetter],
    avoid: avoid,
    transform: transform,
    attributes: {
      x: x,
      y: y,
      'text-anchor': 'middle'
    }
  });
}
axes.shouldShowZeroLine = function (gd, ax, counterAxis) {
  var rng = Lib.simpleMap(ax.range, ax.r2l);
  return rng[0] * rng[1] <= 0 && ax.zeroline && (ax.type === 'linear' || ax.type === '-') && !(ax.rangebreaks && ax.maskBreaks(0) === BADNUM) && (clipEnds(ax, 0) || !anyCounterAxLineAtZero(gd, ax, counterAxis, rng) || hasBarsOrFill(gd, ax));
};
axes.clipEnds = function (ax, vals) {
  return vals.filter(function (d) {
    return clipEnds(ax, d.x);
  });
};
function clipEnds(ax, l) {
  var p = ax.l2p(l);
  return p > 1 && p < ax._length - 1;
}
function anyCounterAxLineAtZero(gd, ax, counterAxis, rng) {
  var mainCounterAxis = counterAxis._mainAxis;
  if (!mainCounterAxis) return;
  var fullLayout = gd._fullLayout;
  var axLetter = ax._id.charAt(0);
  var counterLetter = axes.counterLetter(ax._id);
  var zeroPosition = ax._offset + (Math.abs(rng[0]) < Math.abs(rng[1]) === (axLetter === 'x') ? 0 : ax._length);
  function lineNearZero(ax2) {
    if (!ax2.showline || !ax2.linewidth) return false;
    var tolerance = Math.max((ax2.linewidth + ax.zerolinewidth) / 2, 1);
    function closeEnough(pos2) {
      return typeof pos2 === 'number' && Math.abs(pos2 - zeroPosition) < tolerance;
    }
    if (closeEnough(ax2._mainLinePosition) || closeEnough(ax2._mainMirrorPosition)) {
      return true;
    }
    var linePositions = ax2._linepositions || {};
    for (var k in linePositions) {
      if (closeEnough(linePositions[k][0]) || closeEnough(linePositions[k][1])) {
        return true;
      }
    }
  }
  var plotinfo = fullLayout._plots[counterAxis._mainSubplot];
  if (!(plotinfo.mainplotinfo || plotinfo).overlays.length) {
    return lineNearZero(counterAxis, zeroPosition);
  }
  var counterLetterAxes = axes.list(gd, counterLetter);
  for (var i = 0; i < counterLetterAxes.length; i++) {
    var counterAxis2 = counterLetterAxes[i];
    if (counterAxis2._mainAxis === mainCounterAxis && lineNearZero(counterAxis2, zeroPosition)) {
      return true;
    }
  }
}
function hasBarsOrFill(gd, ax) {
  var fullData = gd._fullData;
  var subplot = ax._mainSubplot;
  var axLetter = ax._id.charAt(0);
  for (var i = 0; i < fullData.length; i++) {
    var trace = fullData[i];
    if (trace.visible === true && trace.xaxis + trace.yaxis === subplot) {
      if (Registry.traceIs(trace, 'bar-like') && trace.orientation === {
        x: 'h',
        y: 'v'
      }[axLetter]) return true;
      if (trace.fill && trace.fill.charAt(trace.fill.length - 1) === axLetter) return true;
    }
  }
  return false;
}
function selectTickLabel(gTick) {
  var s = d3.select(gTick);
  var mj = s.select('.text-math-group');
  return mj.empty() ? s.select('text') : mj;
}

/**
 * Find all margin pushers for 2D axes and reserve them for later use
 * Both label and rangeslider automargin calculations happen later so
 * we need to explicitly allow their ids in order to not delete them.
 *
 * TODO: can we pull the actual automargin calls forward to avoid this hack?
 * We're probably also doing multiple redraws in this case, would be faster
 * if we can just do the whole calculation ahead of time and draw once.
 */
axes.allowAutoMargin = function (gd) {
  var axList = axes.list(gd, '', true);
  for (var i = 0; i < axList.length; i++) {
    var ax = axList[i];
    if (ax.automargin) {
      Plots.allowAutoMargin(gd, axAutoMarginID(ax));
      if (ax.mirror) {
        Plots.allowAutoMargin(gd, axMirrorAutoMarginID(ax));
      }
    }
    if (Registry.getComponentMethod('rangeslider', 'isVisible')(ax)) {
      Plots.allowAutoMargin(gd, rangeSliderAutoMarginID(ax));
    }
  }
};
function axAutoMarginID(ax) {
  return ax._id + '.automargin';
}
function axMirrorAutoMarginID(ax) {
  return axAutoMarginID(ax) + '.mirror';
}
function rangeSliderAutoMarginID(ax) {
  return ax._id + '.rangeslider';
}

// swap all the presentation attributes of the axes showing these traces
axes.swap = function (gd, traces) {
  var axGroups = makeAxisGroups(gd, traces);
  for (var i = 0; i < axGroups.length; i++) {
    swapAxisGroup(gd, axGroups[i].x, axGroups[i].y);
  }
};
function makeAxisGroups(gd, traces) {
  var groups = [];
  var i, j;
  for (i = 0; i < traces.length; i++) {
    var groupsi = [];
    var xi = gd._fullData[traces[i]].xaxis;
    var yi = gd._fullData[traces[i]].yaxis;
    if (!xi || !yi) continue; // not a 2D cartesian trace?

    for (j = 0; j < groups.length; j++) {
      if (groups[j].x.indexOf(xi) !== -1 || groups[j].y.indexOf(yi) !== -1) {
        groupsi.push(j);
      }
    }
    if (!groupsi.length) {
      groups.push({
        x: [xi],
        y: [yi]
      });
      continue;
    }
    var group0 = groups[groupsi[0]];
    var groupj;
    if (groupsi.length > 1) {
      for (j = 1; j < groupsi.length; j++) {
        groupj = groups[groupsi[j]];
        mergeAxisGroups(group0.x, groupj.x);
        mergeAxisGroups(group0.y, groupj.y);
      }
    }
    mergeAxisGroups(group0.x, [xi]);
    mergeAxisGroups(group0.y, [yi]);
  }
  return groups;
}
function mergeAxisGroups(intoSet, fromSet) {
  for (var i = 0; i < fromSet.length; i++) {
    if (intoSet.indexOf(fromSet[i]) === -1) intoSet.push(fromSet[i]);
  }
}
function swapAxisGroup(gd, xIds, yIds) {
  var xFullAxes = [];
  var yFullAxes = [];
  var layout = gd.layout;
  var i, j;
  for (i = 0; i < xIds.length; i++) xFullAxes.push(axes.getFromId(gd, xIds[i]));
  for (i = 0; i < yIds.length; i++) yFullAxes.push(axes.getFromId(gd, yIds[i]));
  var allAxKeys = Object.keys(axAttrs);
  var noSwapAttrs = ['anchor', 'domain', 'overlaying', 'position', 'side', 'tickangle', 'editType'];
  var numericTypes = ['linear', 'log'];
  for (i = 0; i < allAxKeys.length; i++) {
    var keyi = allAxKeys[i];
    var xVal = xFullAxes[0][keyi];
    var yVal = yFullAxes[0][keyi];
    var allEqual = true;
    var coerceLinearX = false;
    var coerceLinearY = false;
    if (keyi.charAt(0) === '_' || typeof xVal === 'function' || noSwapAttrs.indexOf(keyi) !== -1) {
      continue;
    }
    for (j = 1; j < xFullAxes.length && allEqual; j++) {
      var xVali = xFullAxes[j][keyi];
      if (keyi === 'type' && numericTypes.indexOf(xVal) !== -1 && numericTypes.indexOf(xVali) !== -1 && xVal !== xVali) {
        // type is special - if we find a mixture of linear and log,
        // coerce them all to linear on flipping
        coerceLinearX = true;
      } else if (xVali !== xVal) allEqual = false;
    }
    for (j = 1; j < yFullAxes.length && allEqual; j++) {
      var yVali = yFullAxes[j][keyi];
      if (keyi === 'type' && numericTypes.indexOf(yVal) !== -1 && numericTypes.indexOf(yVali) !== -1 && yVal !== yVali) {
        // type is special - if we find a mixture of linear and log,
        // coerce them all to linear on flipping
        coerceLinearY = true;
      } else if (yFullAxes[j][keyi] !== yVal) allEqual = false;
    }
    if (allEqual) {
      if (coerceLinearX) layout[xFullAxes[0]._name].type = 'linear';
      if (coerceLinearY) layout[yFullAxes[0]._name].type = 'linear';
      swapAxisAttrs(layout, keyi, xFullAxes, yFullAxes, gd._fullLayout._dfltTitle);
    }
  }

  // now swap x&y for any annotations anchored to these x & y
  for (i = 0; i < gd._fullLayout.annotations.length; i++) {
    var ann = gd._fullLayout.annotations[i];
    if (xIds.indexOf(ann.xref) !== -1 && yIds.indexOf(ann.yref) !== -1) {
      Lib.swapAttrs(layout.annotations[i], ['?']);
    }
  }
}
function swapAxisAttrs(layout, key, xFullAxes, yFullAxes, dfltTitle) {
  // in case the value is the default for either axis,
  // look at the first axis in each list and see if
  // this key's value is undefined
  var np = Lib.nestedProperty;
  var xVal = np(layout[xFullAxes[0]._name], key).get();
  var yVal = np(layout[yFullAxes[0]._name], key).get();
  var i;
  if (key === 'title') {
    // special handling of placeholder titles
    if (xVal && xVal.text === dfltTitle.x) {
      xVal.text = dfltTitle.y;
    }
    if (yVal && yVal.text === dfltTitle.y) {
      yVal.text = dfltTitle.x;
    }
  }
  for (i = 0; i < xFullAxes.length; i++) {
    np(layout, xFullAxes[i]._name + '.' + key).set(yVal);
  }
  for (i = 0; i < yFullAxes.length; i++) {
    np(layout, yFullAxes[i]._name + '.' + key).set(xVal);
  }
}
function isAngular(ax) {
  return ax._id === 'angularaxis';
}
function moveOutsideBreak(v, ax) {
  var len = ax._rangebreaks.length;
  for (var k = 0; k < len; k++) {
    var brk = ax._rangebreaks[k];
    if (v >= brk.min && v < brk.max) {
      return brk.max;
    }
  }
  return v;
}
function insideTicklabelposition(ax) {
  return (ax.ticklabelposition || '').indexOf('inside') !== -1;
}
function hideCounterAxisInsideTickLabels(ax, opts) {
  if (insideTicklabelposition(ax._anchorAxis || {})) {
    if (ax._hideCounterAxisInsideTickLabels) {
      ax._hideCounterAxisInsideTickLabels(opts);
    }
  }
}
function incrementShift(ax, shiftVal, axShifts, normalize) {
  // Need to set 'overlay' for anchored axis
  var overlay = ax.anchor !== 'free' && (ax.overlaying === undefined || ax.overlaying === false) ? ax._id : ax.overlaying;
  var shiftValAdj;
  if (normalize) {
    shiftValAdj = ax.side === 'right' ? shiftVal : -shiftVal;
  } else {
    shiftValAdj = shiftVal;
  }
  if (!(overlay in axShifts)) {
    axShifts[overlay] = {};
  }
  if (!(ax.side in axShifts[overlay])) {
    axShifts[overlay][ax.side] = 0;
  }
  axShifts[overlay][ax.side] += shiftValAdj;
}
function setShiftVal(ax, axShifts) {
  return ax.autoshift ? axShifts[ax.overlaying][ax.side] : ax.shift || 0;
}

/**
 * Checks if the given period is at least the period described by the tickformat or larger. If that
 * is the case, they are compatible, because then the tickformat can be used to describe the period.
 * E.g. it doesn't make sense to put a year label on a period spanning only a month.
 * @param {number} period in ms
 * @param {string} tickformat
 * @returns {boolean}
 */
function periodCompatibleWithTickformat(period, tickformat) {
  return /%f/.test(tickformat) ? period >= ONEMICROSEC : /%L/.test(tickformat) ? period >= ONEMILLI : /%[SX]/.test(tickformat) ? period >= ONESEC : /%M/.test(tickformat) ? period >= ONEMIN : /%[HI]/.test(tickformat) ? period >= ONEHOUR : /%p/.test(tickformat) ? period >= HALFDAY : /%[Aadejuwx]/.test(tickformat) ? period >= ONEDAY : /%[UVW]/.test(tickformat) ? period >= ONEWEEK : /%[Bbm]/.test(tickformat) ? period >= ONEMINMONTH : /%[q]/.test(tickformat) ? period >= ONEMINQUARTER : /%[Yy]/.test(tickformat) ? period >= ONEMINYEAR : true;
}

/***/ }),

/***/ 9666:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isNumeric = __webpack_require__(10721);
var Lib = __webpack_require__(34809);
var BADNUM = (__webpack_require__(63821).BADNUM);
var isArrayOrTypedArray = Lib.isArrayOrTypedArray;
var isDateTime = Lib.isDateTime;
var cleanNumber = Lib.cleanNumber;
var round = Math.round;
module.exports = function autoType(array, calendar, opts) {
  var a = array;
  var noMultiCategory = opts.noMultiCategory;
  if (isArrayOrTypedArray(a) && !a.length) return '-';
  if (!noMultiCategory && multiCategory(a)) return 'multicategory';
  if (noMultiCategory && Array.isArray(a[0])) {
    // no need to flat typed arrays here
    var b = [];
    for (var i = 0; i < a.length; i++) {
      if (isArrayOrTypedArray(a[i])) {
        for (var j = 0; j < a[i].length; j++) {
          b.push(a[i][j]);
        }
      }
    }
    a = b;
  }
  if (moreDates(a, calendar)) return 'date';
  var convertNumeric = opts.autotypenumbers !== 'strict'; // compare against strict, just in case autotypenumbers was not provided in opts
  if (category(a, convertNumeric)) return 'category';
  if (linearOK(a, convertNumeric)) return 'linear';
  return '-';
};
function hasTypeNumber(v, convertNumeric) {
  return convertNumeric ? isNumeric(v) : typeof v === 'number';
}

// is there at least one number in array? If not, we should leave
// ax.type empty so it can be autoset later
function linearOK(a, convertNumeric) {
  var len = a.length;
  for (var i = 0; i < len; i++) {
    if (hasTypeNumber(a[i], convertNumeric)) return true;
  }
  return false;
}

// does the array a have mostly dates rather than numbers?
// note: some values can be neither (such as blanks, text)
// 2- or 4-digit integers can be both, so require twice as many
// dates as non-dates, to exclude cases with mostly 2 & 4 digit
// numbers and a few dates
// as with categories, consider DISTINCT values only.
function moreDates(a, calendar) {
  var len = a.length;
  var inc = getIncrement(len);
  var dats = 0;
  var nums = 0;
  var seen = {};
  for (var f = 0; f < len; f += inc) {
    var i = round(f);
    var ai = a[i];
    var stri = String(ai);
    if (seen[stri]) continue;
    seen[stri] = 1;
    if (isDateTime(ai, calendar)) dats++;
    if (isNumeric(ai)) nums++;
  }
  return dats > nums * 2;
}

// return increment to test at most 1000 points, evenly spaced
function getIncrement(len) {
  return Math.max(1, (len - 1) / 1000);
}

// are the (x,y)-values in gd.data mostly text?
// require twice as many DISTINCT categories as distinct numbers
function category(a, convertNumeric) {
  var len = a.length;
  var inc = getIncrement(len);
  var nums = 0;
  var cats = 0;
  var seen = {};
  for (var f = 0; f < len; f += inc) {
    var i = round(f);
    var ai = a[i];
    var stri = String(ai);
    if (seen[stri]) continue;
    seen[stri] = 1;
    var t = typeof ai;
    if (t === 'boolean') cats++;else if (convertNumeric ? cleanNumber(ai) !== BADNUM : t === 'number') nums++;else if (t === 'string') cats++;
  }
  return cats > nums * 2;
}

// very-loose requirements for multicategory,
// trace modules that should never auto-type to multicategory
// should be declared with 'noMultiCategory'
function multiCategory(a) {
  return isArrayOrTypedArray(a[0]) && isArrayOrTypedArray(a[1]);
}

/***/ }),

/***/ 97655:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isNumeric = __webpack_require__(10721);
var Registry = __webpack_require__(33626);
var Lib = __webpack_require__(34809);
var Template = __webpack_require__(78032);
var handleArrayContainerDefaults = __webpack_require__(59008);
var layoutAttributes = __webpack_require__(25829);
var handleTickValueDefaults = __webpack_require__(22777);
var handleTickMarkDefaults = __webpack_require__(87433);
var handleTickLabelDefaults = __webpack_require__(12036);
var handlePrefixSuffixDefaults = __webpack_require__(54616);
var handleCategoryOrderDefaults = __webpack_require__(46473);
var handleLineGridDefaults = __webpack_require__(97405);
var handleRangeDefaults = __webpack_require__(90259);
var setConvert = __webpack_require__(19091);
var DAY_OF_WEEK = (__webpack_require__(54826).WEEKDAY_PATTERN);
var HOUR = (__webpack_require__(54826).HOUR_PATTERN);

/**
 * options: object containing:
 *
 *  letter: 'x' or 'y'
 *  title: name of the axis (ie 'Colorbar') to go in default title
 *  font: the default font to inherit
 *  outerTicks: boolean, should ticks default to outside?
 *  showGrid: boolean, should gridlines be shown by default?
 *  noHover: boolean, this axis doesn't support hover effects?
 *  noTickson: boolean, this axis doesn't support 'tickson'
 *  data: the plot data, used to manage categories
 *  bgColor: the plot background color, to calculate default gridline colors
 *  calendar:
 *  splomStash:
 *  visibleDflt: boolean
 *  reverseDflt: boolean
 *  automargin: boolean
 */
module.exports = function handleAxisDefaults(containerIn, containerOut, coerce, options, layoutOut) {
  var letter = options.letter;
  var font = options.font || {};
  var splomStash = options.splomStash || {};
  var visible = coerce('visible', !options.visibleDflt);
  var axTemplate = containerOut._template || {};
  var axType = containerOut.type || axTemplate.type || '-';
  var ticklabelmode;
  if (axType === 'date') {
    var handleCalendarDefaults = Registry.getComponentMethod('calendars', 'handleDefaults');
    handleCalendarDefaults(containerIn, containerOut, 'calendar', options.calendar);
    if (!options.noTicklabelmode) {
      ticklabelmode = coerce('ticklabelmode');
    }
  }
  if (!options.noTicklabelindex && (axType === 'date' || axType === 'linear')) {
    coerce('ticklabelindex');
  }
  var ticklabelposition = '';
  if (!options.noTicklabelposition || axType === 'multicategory') {
    ticklabelposition = Lib.coerce(containerIn, containerOut, {
      ticklabelposition: {
        valType: 'enumerated',
        dflt: 'outside',
        values: ticklabelmode === 'period' ? ['outside', 'inside'] : letter === 'x' ? ['outside', 'inside', 'outside left', 'inside left', 'outside right', 'inside right'] : ['outside', 'inside', 'outside top', 'inside top', 'outside bottom', 'inside bottom']
      }
    }, 'ticklabelposition');
  }
  if (!options.noTicklabeloverflow) {
    coerce('ticklabeloverflow', ticklabelposition.indexOf('inside') !== -1 ? 'hide past domain' : axType === 'category' || axType === 'multicategory' ? 'allow' : 'hide past div');
  }
  setConvert(containerOut, layoutOut);
  handleRangeDefaults(containerIn, containerOut, coerce, options);
  handleCategoryOrderDefaults(containerIn, containerOut, coerce, options);
  if (axType !== 'category' && !options.noHover) coerce('hoverformat');
  var dfltColor = coerce('color');
  // if axis.color was provided, use it for fonts too; otherwise,
  // inherit from global font color in case that was provided.
  // Compare to dflt rather than to containerIn, so we can provide color via
  // template too.
  var dfltFontColor = dfltColor !== layoutAttributes.color.dflt ? dfltColor : font.color;
  // try to get default title from splom trace, fallback to graph-wide value
  var dfltTitle = splomStash.label || layoutOut._dfltTitle[letter];
  handlePrefixSuffixDefaults(containerIn, containerOut, coerce, axType, options);
  if (!visible) return containerOut;
  coerce('title.text', dfltTitle);
  Lib.coerceFont(coerce, 'title.font', font, {
    overrideDflt: {
      size: Lib.bigFont(font.size),
      color: dfltFontColor
    }
  });

  // major ticks
  handleTickValueDefaults(containerIn, containerOut, coerce, axType);
  var hasMinor = options.hasMinor;
  if (hasMinor) {
    // minor ticks
    Template.newContainer(containerOut, 'minor');
    handleTickValueDefaults(containerIn, containerOut, coerce, axType, {
      isMinor: true
    });
  }
  handleTickLabelDefaults(containerIn, containerOut, coerce, axType, options);

  // major and minor ticks
  handleTickMarkDefaults(containerIn, containerOut, coerce, options);
  if (hasMinor) {
    var keepIsMinor = options.isMinor;
    options.isMinor = true;
    handleTickMarkDefaults(containerIn, containerOut, coerce, options);
    options.isMinor = keepIsMinor;
  }
  handleLineGridDefaults(containerIn, containerOut, coerce, {
    dfltColor: dfltColor,
    bgColor: options.bgColor,
    showGrid: options.showGrid,
    hasMinor: hasMinor,
    attributes: layoutAttributes
  });

  // delete minor when no minor ticks or gridlines
  if (hasMinor && !containerOut.minor.ticks && !containerOut.minor.showgrid) {
    delete containerOut.minor;
  }

  // mirror
  if (containerOut.showline || containerOut.ticks) coerce('mirror');
  var isMultiCategory = axType === 'multicategory';
  if (!options.noTickson && (axType === 'category' || isMultiCategory) && (containerOut.ticks || containerOut.showgrid)) {
    var ticksonDflt;
    if (isMultiCategory) ticksonDflt = 'boundaries';
    var tickson = coerce('tickson', ticksonDflt);
    if (tickson === 'boundaries') {
      delete containerOut.ticklabelposition;
    }
  }
  if (isMultiCategory) {
    var showDividers = coerce('showdividers');
    if (showDividers) {
      coerce('dividercolor');
      coerce('dividerwidth');
    }
  }
  if (axType === 'date') {
    handleArrayContainerDefaults(containerIn, containerOut, {
      name: 'rangebreaks',
      inclusionAttr: 'enabled',
      handleItemDefaults: rangebreaksDefaults
    });
    if (!containerOut.rangebreaks.length) {
      delete containerOut.rangebreaks;
    } else {
      for (var k = 0; k < containerOut.rangebreaks.length; k++) {
        if (containerOut.rangebreaks[k].pattern === DAY_OF_WEEK) {
          containerOut._hasDayOfWeekBreaks = true;
          break;
        }
      }
      setConvert(containerOut, layoutOut);
      if (layoutOut._has('scattergl') || layoutOut._has('splom')) {
        for (var i = 0; i < options.data.length; i++) {
          var trace = options.data[i];
          if (trace.type === 'scattergl' || trace.type === 'splom') {
            trace.visible = false;
            Lib.warn(trace.type + ' traces do not work on axes with rangebreaks.' + ' Setting trace ' + trace.index + ' to `visible: false`.');
          }
        }
      }
    }
  }
  return containerOut;
};
function rangebreaksDefaults(itemIn, itemOut, containerOut) {
  function coerce(attr, dflt) {
    return Lib.coerce(itemIn, itemOut, layoutAttributes.rangebreaks, attr, dflt);
  }
  var enabled = coerce('enabled');
  if (enabled) {
    var bnds = coerce('bounds');
    if (bnds && bnds.length >= 2) {
      var dfltPattern = '';
      var i, q;
      if (bnds.length === 2) {
        for (i = 0; i < 2; i++) {
          q = indexOfDay(bnds[i]);
          if (q) {
            dfltPattern = DAY_OF_WEEK;
            break;
          }
        }
      }
      var pattern = coerce('pattern', dfltPattern);
      if (pattern === DAY_OF_WEEK) {
        for (i = 0; i < 2; i++) {
          q = indexOfDay(bnds[i]);
          if (q) {
            // convert to integers i.e 'Sunday' --> 0
            itemOut.bounds[i] = bnds[i] = q - 1;
          }
        }
      }
      if (pattern) {
        // ensure types and ranges
        for (i = 0; i < 2; i++) {
          q = bnds[i];
          switch (pattern) {
            case DAY_OF_WEEK:
              if (!isNumeric(q)) {
                itemOut.enabled = false;
                return;
              }
              q = +q;
              if (q !== Math.floor(q) ||
              // don't accept fractional days for mow
              q < 0 || q >= 7) {
                itemOut.enabled = false;
                return;
              }
              // use number
              itemOut.bounds[i] = bnds[i] = q;
              break;
            case HOUR:
              if (!isNumeric(q)) {
                itemOut.enabled = false;
                return;
              }
              q = +q;
              if (q < 0 || q > 24) {
                // accept 24
                itemOut.enabled = false;
                return;
              }
              // use number
              itemOut.bounds[i] = bnds[i] = q;
              break;
          }
        }
      }
      if (containerOut.autorange === false) {
        var rng = containerOut.range;

        // if bounds are bigger than the (set) range, disable break
        if (rng[0] < rng[1]) {
          if (bnds[0] < rng[0] && bnds[1] > rng[1]) {
            itemOut.enabled = false;
            return;
          }
        } else if (bnds[0] > rng[0] && bnds[1] < rng[1]) {
          itemOut.enabled = false;
          return;
        }
      }
    } else {
      var values = coerce('values');
      if (values && values.length) {
        coerce('dvalue');
      } else {
        itemOut.enabled = false;
        return;
      }
    }
  }
}

// these numbers are one more than what bounds would be mapped to
var dayStrToNum = {
  sun: 1,
  mon: 2,
  tue: 3,
  wed: 4,
  thu: 5,
  fri: 6,
  sat: 7
};
function indexOfDay(v) {
  if (typeof v !== 'string') return;
  return dayStrToNum[v.substr(0, 3).toLowerCase()];
}

/***/ }),

/***/ 80712:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var docs = __webpack_require__(87296);
var FORMAT_LINK = docs.FORMAT_LINK;
var DATE_FORMAT_LINK = docs.DATE_FORMAT_LINK;
function axisHoverFormat(x, noDates) {
  return {
    valType: 'string',
    dflt: '',
    editType: 'none',
    description: (noDates ? descriptionOnlyNumbers : descriptionWithDates)('hover text', x) + ['By default the values are formatted using ' + (noDates ? 'generic number format' : '`' + x + 'axis.hoverformat`') + '.'].join(' ')
  };
}
function descriptionOnlyNumbers(label, x) {
  return ['Sets the ' + label + ' formatting rule' + (x ? 'for `' + x + '` ' : ''), 'using d3 formatting mini-languages', 'which are very similar to those in Python. For numbers, see: ' + FORMAT_LINK + '.'].join(' ');
}
function descriptionWithDates(label, x) {
  return descriptionOnlyNumbers(label, x) + [' And for dates see: ' + DATE_FORMAT_LINK + '.', 'We add two items to d3\'s date formatter:', '*%h* for half of the year as a decimal number as well as', '*%{n}f* for fractional seconds', 'with n digits. For example, *2016-10-13 09:15:23.456* with tickformat', '*%H~%M~%S.%2f* would display *09~15~23.46*'].join(' ');
}
module.exports = {
  axisHoverFormat: axisHoverFormat,
  descriptionOnlyNumbers: descriptionOnlyNumbers,
  descriptionWithDates: descriptionWithDates
};

/***/ }),

/***/ 5975:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var Registry = __webpack_require__(33626);
var constants = __webpack_require__(54826);

// convert between axis names (xaxis, xaxis2, etc, elements of gd.layout)
// and axis id's (x, x2, etc). Would probably have ditched 'xaxis'
// completely in favor of just 'x' if it weren't ingrained in the API etc.
exports.id2name = function id2name(id) {
  if (typeof id !== 'string' || !id.match(constants.AX_ID_PATTERN)) return;
  var axNum = id.split(' ')[0].substr(1);
  if (axNum === '1') axNum = '';
  return id.charAt(0) + 'axis' + axNum;
};
exports.name2id = function name2id(name) {
  if (!name.match(constants.AX_NAME_PATTERN)) return;
  var axNum = name.substr(5);
  if (axNum === '1') axNum = '';
  return name.charAt(0) + axNum;
};

/*
 * Cleans up the number of an axis, e.g., 'x002'->'x2', 'x0'->'x', 'x1' -> 'x',
 * etc.
 * If domainId is true, then id could be a domain reference and if it is, the
 * ' domain' part is kept at the end of the axis ID string.
 */
exports.cleanId = function cleanId(id, axLetter, domainId) {
  var domainTest = /( domain)$/.test(id);
  if (typeof id !== 'string' || !id.match(constants.AX_ID_PATTERN)) return;
  if (axLetter && id.charAt(0) !== axLetter) return;
  if (domainTest && !domainId) return;
  var axNum = id.split(' ')[0].substr(1).replace(/^0+/, '');
  if (axNum === '1') axNum = '';
  return id.charAt(0) + axNum + (domainTest && domainId ? ' domain' : '');
};

// get all axis objects, as restricted in listNames
exports.list = function (gd, axLetter, only2d) {
  var fullLayout = gd._fullLayout;
  if (!fullLayout) return [];
  var idList = exports.listIds(gd, axLetter);
  var out = new Array(idList.length);
  var i;
  for (i = 0; i < idList.length; i++) {
    var idi = idList[i];
    out[i] = fullLayout[idi.charAt(0) + 'axis' + idi.substr(1)];
  }
  if (!only2d) {
    var sceneIds3D = fullLayout._subplots.gl3d || [];
    for (i = 0; i < sceneIds3D.length; i++) {
      var scene = fullLayout[sceneIds3D[i]];
      if (axLetter) out.push(scene[axLetter + 'axis']);else out.push(scene.xaxis, scene.yaxis, scene.zaxis);
    }
  }
  return out;
};

// get all axis ids, optionally restricted by letter
// this only makes sense for 2d axes
exports.listIds = function (gd, axLetter) {
  var fullLayout = gd._fullLayout;
  if (!fullLayout) return [];
  var subplotLists = fullLayout._subplots;
  if (axLetter) return subplotLists[axLetter + 'axis'];
  return subplotLists.xaxis.concat(subplotLists.yaxis);
};

// get an axis object from its id 'x','x2' etc
// optionally, id can be a subplot (ie 'x2y3') and type gets x or y from it
exports.getFromId = function (gd, id, type) {
  var fullLayout = gd._fullLayout;
  // remove "domain" suffix
  id = id === undefined || typeof id !== 'string' ? id : id.replace(' domain', '');
  if (type === 'x') id = id.replace(/y[0-9]*/, '');else if (type === 'y') id = id.replace(/x[0-9]*/, '');
  return fullLayout[exports.id2name(id)];
};

// get an axis object of specified type from the containing trace
exports.getFromTrace = function (gd, fullTrace, type) {
  var fullLayout = gd._fullLayout;
  var ax = null;
  if (Registry.traceIs(fullTrace, 'gl3d')) {
    var scene = fullTrace.scene;
    if (scene.substr(0, 5) === 'scene') {
      ax = fullLayout[scene][type + 'axis'];
    }
  } else {
    ax = exports.getFromId(gd, fullTrace[type + 'axis'] || type);
  }
  return ax;
};

// sort x, x2, x10, y, y2, y10...
exports.idSort = function (id1, id2) {
  var letter1 = id1.charAt(0);
  var letter2 = id2.charAt(0);
  if (letter1 !== letter2) return letter1 > letter2 ? 1 : -1;
  return +(id1.substr(1) || 1) - +(id2.substr(1) || 1);
};

/*
 * An axis reference (e.g., the contents at the 'xref' key of an object) might
 * have extra information appended. Extract the axis ID only.
 *
 * ar: the axis reference string
 *
 */
exports.ref2id = function (ar) {
  // This assumes ar has been coerced via coerceRef, and uses the shortcut of
  // checking if the first letter matches [xyz] to determine if it should
  // return the axis ID. Otherwise it returns false.
  return /^[xyz]/.test(ar) ? ar.split(' ')[0] : false;
};
function isFound(axId, list) {
  if (list && list.length) {
    for (var i = 0; i < list.length; i++) {
      if (list[i][axId]) return true;
    }
  }
  return false;
}
exports.isLinked = function (fullLayout, axId) {
  return isFound(axId, fullLayout._axisMatchGroups) || isFound(axId, fullLayout._axisConstraintGroups);
};

/***/ }),

/***/ 46473:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isTypedArraySpec = (__webpack_require__(87800).isTypedArraySpec);
function findCategories(ax, opts) {
  var dataAttr = opts.dataAttr || ax._id.charAt(0);
  var lookup = {};
  var axData;
  var i, j;
  if (opts.axData) {
    // non-x/y case
    axData = opts.axData;
  } else {
    // x/y case
    axData = [];
    for (i = 0; i < opts.data.length; i++) {
      var trace = opts.data[i];
      if (trace[dataAttr + 'axis'] === ax._id) {
        axData.push(trace);
      }
    }
  }
  for (i = 0; i < axData.length; i++) {
    var vals = axData[i][dataAttr];
    for (j = 0; j < vals.length; j++) {
      var v = vals[j];
      if (v !== null && v !== undefined) {
        lookup[v] = 1;
      }
    }
  }
  return Object.keys(lookup);
}

/**
 * Fills in category* default and initial categories.
 *
 * @param {object} containerIn : input axis object
 * @param {object} containerOut : full axis object
 * @param {function} coerce : Lib.coerce fn wrapper
 * @param {object} opts :
 *   - data {array} : (full) data trace
 * OR
 *   - axData {array} : (full) data associated with axis being coerced here
 *   - dataAttr {string} : attribute name corresponding to coordinate array
 */
module.exports = function handleCategoryOrderDefaults(containerIn, containerOut, coerce, opts) {
  if (containerOut.type !== 'category') return;
  var arrayIn = containerIn.categoryarray;
  var isValidArray = Array.isArray(arrayIn) && arrayIn.length > 0 || isTypedArraySpec(arrayIn);

  // override default 'categoryorder' value when non-empty array is supplied
  var orderDefault;
  if (isValidArray) orderDefault = 'array';
  var order = coerce('categoryorder', orderDefault);
  var array;

  // coerce 'categoryarray' only in array order case
  if (order === 'array') {
    array = coerce('categoryarray');
  }

  // cannot set 'categoryorder' to 'array' with an invalid 'categoryarray'
  if (!isValidArray && order === 'array') {
    order = containerOut.categoryorder = 'trace';
  }

  // set up things for makeCalcdata
  if (order === 'trace') {
    containerOut._initialCategories = [];
  } else if (order === 'array') {
    containerOut._initialCategories = array.slice();
  } else {
    array = findCategories(containerOut, opts).sort();
    if (order === 'category ascending') {
      containerOut._initialCategories = array;
    } else if (order === 'category descending') {
      containerOut._initialCategories = array.reverse();
    }
  }
};

/***/ }),

/***/ 68599:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var isNumeric = __webpack_require__(10721);
var Lib = __webpack_require__(34809);
var constants = __webpack_require__(63821);
var ONEDAY = constants.ONEDAY;
var ONEWEEK = constants.ONEWEEK;

/**
 * Return a validated dtick value for this axis
 *
 * @param {any} dtick: the candidate dtick. valid values are numbers and strings,
 *     and further constrained depending on the axis type.
 * @param {string} axType: the axis type
 */
exports.dtick = function (dtick, axType) {
  var isLog = axType === 'log';
  var isDate = axType === 'date';
  var isCat = axType === 'category';
  var dtickDflt = isDate ? ONEDAY : 1;
  if (!dtick) return dtickDflt;
  if (isNumeric(dtick)) {
    dtick = Number(dtick);
    if (dtick <= 0) return dtickDflt;
    if (isCat) {
      // category dtick must be positive integers
      return Math.max(1, Math.round(dtick));
    }
    if (isDate) {
      // date dtick must be at least 0.1ms (our current precision)
      return Math.max(0.1, dtick);
    }
    return dtick;
  }
  if (typeof dtick !== 'string' || !(isDate || isLog)) {
    return dtickDflt;
  }
  var prefix = dtick.charAt(0);
  var dtickNum = dtick.substr(1);
  dtickNum = isNumeric(dtickNum) ? Number(dtickNum) : 0;
  if (dtickNum <= 0 || !(
  // "M<n>" gives ticks every (integer) n months
  isDate && prefix === 'M' && dtickNum === Math.round(dtickNum) ||
  // "L<f>" gives ticks linearly spaced in data (not in position) every (float) f
  isLog && prefix === 'L' ||
  // "D1" gives powers of 10 with all small digits between, "D2" gives only 2 and 5
  isLog && prefix === 'D' && (dtickNum === 1 || dtickNum === 2))) {
    return dtickDflt;
  }
  return dtick;
};

/**
 * Return a validated tick0 for this axis
 *
 * @param {any} tick0: the candidate tick0. Valid values are numbers and strings,
 *     further constrained depending on the axis type
 * @param {string} axType: the axis type
 * @param {string} calendar: for date axes, the calendar to validate/convert with
 * @param {any} dtick: an already valid dtick. Only used for D1 and D2 log dticks,
 *     which do not support tick0 at all.
 */
exports.tick0 = function (tick0, axType, calendar, dtick) {
  if (axType === 'date') {
    return Lib.cleanDate(tick0, Lib.dateTick0(calendar, dtick % ONEWEEK === 0 ? 1 : 0));
  }
  if (dtick === 'D1' || dtick === 'D2') {
    // D1 and D2 modes ignore tick0 entirely
    return undefined;
  }
  // Aside from date axes, tick0 must be numeric
  return isNumeric(tick0) ? Number(tick0) : 0;
};

/***/ }),

/***/ 54826:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var counterRegex = (__webpack_require__(90694).counter);
module.exports = {
  idRegex: {
    x: counterRegex('x', '( domain)?'),
    y: counterRegex('y', '( domain)?')
  },
  attrRegex: counterRegex('[xy]axis'),
  // axis match regular expression
  xAxisMatch: counterRegex('xaxis'),
  yAxisMatch: counterRegex('yaxis'),
  // pattern matching axis ids and names
  // note that this is more permissive than counterRegex, as
  // id2name, name2id, and cleanId accept "x1" etc
  AX_ID_PATTERN: /^[xyz][0-9]*( domain)?$/,
  AX_NAME_PATTERN: /^[xyz]axis[0-9]*$/,
  // and for 2D subplots
  SUBPLOT_PATTERN: /^x([0-9]*)y([0-9]*)$/,
  HOUR_PATTERN: 'hour',
  WEEKDAY_PATTERN: 'day of week',
  // pixels to move mouse before you stop clamping to starting point
  MINDRAG: 8,
  // smallest dimension allowed for a zoombox
  MINZOOM: 20,
  // width of axis drag regions
  DRAGGERSIZE: 20,
  // delay before a redraw (relayout) after smooth panning and zooming
  REDRAWDELAY: 50,
  // last resort axis ranges for x and y axes if we have no data
  DFLTRANGEX: [-1, 6],
  DFLTRANGEY: [-1, 4],
  // Layers to keep trace types in the right order
  // N.B. each  'unique' plot method must have its own layer
  traceLayerClasses: ['imagelayer', 'heatmaplayer', 'contourcarpetlayer', 'contourlayer', 'funnellayer', 'waterfalllayer', 'barlayer', 'carpetlayer', 'violinlayer', 'boxlayer', 'ohlclayer', 'scattercarpetlayer', 'scatterlayer'],
  clipOnAxisFalseQuery: ['.scatterlayer', '.barlayer', '.funnellayer', '.waterfalllayer'],
  layerValue2layerClass: {
    'above traces': 'above',
    'below traces': 'below'
  },
  zindexSeparator: 'z' // used for zindex of cartesian subplots e.g. xy, xyz2, xyz3, etc.
};

/***/ }),

/***/ 84391:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var autorange = __webpack_require__(32919);
var id2name = (__webpack_require__(5975).id2name);
var layoutAttributes = __webpack_require__(25829);
var scaleZoom = __webpack_require__(67611);
var setConvert = __webpack_require__(19091);
var ALMOST_EQUAL = (__webpack_require__(63821).ALMOST_EQUAL);
var FROM_BL = (__webpack_require__(4530).FROM_BL);
exports.handleDefaults = function (layoutIn, layoutOut, opts) {
  var axIds = opts.axIds;
  var axHasImage = opts.axHasImage;

  // sets of axes linked by `scaleanchor` OR `matches` along with the
  // scaleratios compounded together, populated in handleConstraintDefaults
  var constraintGroups = layoutOut._axisConstraintGroups = [];
  // similar to _axisConstraintGroups, but only matching axes
  var matchGroups = layoutOut._axisMatchGroups = [];
  var i, group, axId, axName, axIn, axOut, attr, val;
  for (i = 0; i < axIds.length; i++) {
    axName = id2name(axIds[i]);
    axIn = layoutIn[axName];
    axOut = layoutOut[axName];
    handleOneAxDefaults(axIn, axOut, {
      axIds: axIds,
      layoutOut: layoutOut,
      hasImage: axHasImage[axName]
    });
  }

  // save matchGroup on each matching axis
  function stash(groups, stashAttr) {
    for (i = 0; i < groups.length; i++) {
      group = groups[i];
      for (axId in group) {
        layoutOut[id2name(axId)][stashAttr] = group;
      }
    }
  }
  stash(matchGroups, '_matchGroup');

  // If any axis in a constraint group is fixedrange, they all get fixed
  // This covers matches axes, as they're now in the constraintgroup too
  // and have not yet been removed (if the group is *only* matching)
  for (i = 0; i < constraintGroups.length; i++) {
    group = constraintGroups[i];
    for (axId in group) {
      axOut = layoutOut[id2name(axId)];
      if (axOut.fixedrange) {
        for (var axId2 in group) {
          var axName2 = id2name(axId2);
          if ((layoutIn[axName2] || {}).fixedrange === false) {
            Lib.warn('fixedrange was specified as false for axis ' + axName2 + ' but was overridden because another ' + 'axis in its constraint group has fixedrange true');
          }
          layoutOut[axName2].fixedrange = true;
        }
        break;
      }
    }
  }

  // remove constraint groups that simply duplicate match groups
  i = 0;
  while (i < constraintGroups.length) {
    group = constraintGroups[i];
    for (axId in group) {
      axOut = layoutOut[id2name(axId)];
      if (axOut._matchGroup && Object.keys(axOut._matchGroup).length === Object.keys(group).length) {
        constraintGroups.splice(i, 1);
        i--;
      }
      break;
    }
    i++;
  }

  // save constraintGroup on each constrained axis
  stash(constraintGroups, '_constraintGroup');

  // make sure `matching` axes share values of necessary attributes
  // Precedence (base axis is the one that doesn't list a `matches`, ie others
  // all point to it):
  // (1) explicitly defined value in the base axis
  // (2) explicitly defined in another axis (arbitrary order)
  // (3) default in the base axis
  var matchAttrs = ['constrain', 'range', 'autorange', 'rangemode', 'rangebreaks', 'categoryorder', 'categoryarray'];
  var hasRange = false;
  var hasDayOfWeekBreaks = false;
  function setAttrVal() {
    val = axOut[attr];
    if (attr === 'rangebreaks') {
      hasDayOfWeekBreaks = axOut._hasDayOfWeekBreaks;
    }
  }
  for (i = 0; i < matchGroups.length; i++) {
    group = matchGroups[i];

    // find 'matching' range attrs
    for (var j = 0; j < matchAttrs.length; j++) {
      attr = matchAttrs[j];
      val = null;
      var baseAx;
      for (axId in group) {
        axName = id2name(axId);
        axIn = layoutIn[axName];
        axOut = layoutOut[axName];
        if (!(attr in axOut)) {
          continue;
        }
        if (!axOut.matches) {
          baseAx = axOut;
          // top priority: explicit value in base axis
          if (attr in axIn) {
            setAttrVal();
            break;
          }
        }
        if (val === null && attr in axIn) {
          // second priority: first explicit value in another axis
          setAttrVal();
        }
      }

      // special logic for coupling of range and autorange
      // if nobody explicitly specifies autorange, but someone does
      // explicitly specify range, autorange must be disabled.
      if (attr === 'range' && val && axIn.range && axIn.range.length === 2 && axIn.range[0] !== null && axIn.range[1] !== null) {
        hasRange = true;
      }
      if (attr === 'autorange' && val === null && hasRange) {
        val = false;
      }
      if (val === null && attr in baseAx) {
        // fallback: default value in base axis
        val = baseAx[attr];
      }
      // but we still might not have a value, which is fine.
      if (val !== null) {
        for (axId in group) {
          axOut = layoutOut[id2name(axId)];
          axOut[attr] = attr === 'range' ? val.slice() : val;
          if (attr === 'rangebreaks') {
            axOut._hasDayOfWeekBreaks = hasDayOfWeekBreaks;
            setConvert(axOut, layoutOut);
          }
        }
      }
    }
  }
};
function handleOneAxDefaults(axIn, axOut, opts) {
  var axIds = opts.axIds;
  var layoutOut = opts.layoutOut;
  var hasImage = opts.hasImage;
  var constraintGroups = layoutOut._axisConstraintGroups;
  var matchGroups = layoutOut._axisMatchGroups;
  var axId = axOut._id;
  var axLetter = axId.charAt(0);
  var splomStash = ((layoutOut._splomAxes || {})[axLetter] || {})[axId] || {};
  var thisID = axOut._id;
  var isX = thisID.charAt(0) === 'x';

  // Clear _matchGroup & _constraintGroup so relinkPrivateKeys doesn't keep
  // an old one around. If this axis is in a group we'll set this again later
  axOut._matchGroup = null;
  axOut._constraintGroup = null;
  function coerce(attr, dflt) {
    return Lib.coerce(axIn, axOut, layoutAttributes, attr, dflt);
  }

  // coerce the constraint mechanics even if this axis has no scaleanchor
  // because it may be the anchor of another axis.
  coerce('constrain', hasImage ? 'domain' : 'range');
  Lib.coerce(axIn, axOut, {
    constraintoward: {
      valType: 'enumerated',
      values: isX ? ['left', 'center', 'right'] : ['bottom', 'middle', 'top'],
      dflt: isX ? 'center' : 'middle'
    }
  }, 'constraintoward');

  // If this axis is already part of a constraint group, we can't
  // scaleanchor any other axis in that group, or we'd make a loop.
  // Filter axIds to enforce this, also matching axis types.
  var thisType = axOut.type;
  var i, idi;
  var linkableAxes = [];
  for (i = 0; i < axIds.length; i++) {
    idi = axIds[i];
    if (idi === thisID) continue;
    var axi = layoutOut[id2name(idi)];
    if (axi.type === thisType) {
      linkableAxes.push(idi);
    }
  }
  var thisGroup = getConstraintGroup(constraintGroups, thisID);
  if (thisGroup) {
    var linkableAxesNoLoops = [];
    for (i = 0; i < linkableAxes.length; i++) {
      idi = linkableAxes[i];
      if (!thisGroup[idi]) linkableAxesNoLoops.push(idi);
    }
    linkableAxes = linkableAxesNoLoops;
  }
  var canLink = linkableAxes.length;
  var matches, scaleanchor;
  if (canLink && (axIn.matches || splomStash.matches)) {
    matches = Lib.coerce(axIn, axOut, {
      matches: {
        valType: 'enumerated',
        values: linkableAxes,
        dflt: linkableAxes.indexOf(splomStash.matches) !== -1 ? splomStash.matches : undefined
      }
    }, 'matches');
  }

  // 'matches' wins over 'scaleanchor' - each axis can only specify one
  // constraint, but you can chain matches and scaleanchor constraints by
  // specifying them in separate axes.
  var scaleanchorDflt = hasImage && !isX ? axOut.anchor : undefined;
  if (canLink && !matches && (axIn.scaleanchor || scaleanchorDflt)) {
    scaleanchor = Lib.coerce(axIn, axOut, {
      scaleanchor: {
        valType: 'enumerated',
        values: linkableAxes.concat([false])
      }
    }, 'scaleanchor', scaleanchorDflt);
  }
  if (matches) {
    axOut._matchGroup = updateConstraintGroups(matchGroups, thisID, matches, 1);

    // Also include match constraints in the scale groups
    var matchedAx = layoutOut[id2name(matches)];
    var matchRatio = extent(layoutOut, axOut) / extent(layoutOut, matchedAx);
    if (isX !== (matches.charAt(0) === 'x')) {
      // We don't yet know the actual scale ratio of x/y matches constraints,
      // due to possible automargins, so just leave a placeholder for this:
      // 'x' means "x size over y size", 'y' means the inverse.
      // in principle in the constraint group you could get multiple of these.
      matchRatio = (isX ? 'x' : 'y') + matchRatio;
    }
    updateConstraintGroups(constraintGroups, thisID, matches, matchRatio);
  } else if (axIn.matches && axIds.indexOf(axIn.matches) !== -1) {
    Lib.warn('ignored ' + axOut._name + '.matches: "' + axIn.matches + '" to avoid an infinite loop');
  }
  if (scaleanchor) {
    var scaleratio = coerce('scaleratio');

    // TODO: I suppose I could do attribute.min: Number.MIN_VALUE to avoid zero,
    // but that seems hacky. Better way to say "must be a positive number"?
    // Of course if you use several super-tiny values you could eventually
    // force a product of these to zero and all hell would break loose...
    // Likewise with super-huge values.
    if (!scaleratio) scaleratio = axOut.scaleratio = 1;
    updateConstraintGroups(constraintGroups, thisID, scaleanchor, scaleratio);
  } else if (axIn.scaleanchor && axIds.indexOf(axIn.scaleanchor) !== -1) {
    Lib.warn('ignored ' + axOut._name + '.scaleanchor: "' + axIn.scaleanchor + '" to avoid either an infinite loop ' + 'and possibly inconsistent scaleratios, or because this axis ' + 'declares a *matches* constraint.');
  }
}
function extent(layoutOut, ax) {
  var domain = ax.domain;
  if (!domain) {
    // at this point overlaying axes haven't yet inherited their main domains
    // TODO: constrain: domain with overlaying axes is likely a bug.
    domain = layoutOut[id2name(ax.overlaying)].domain;
  }
  return domain[1] - domain[0];
}
function getConstraintGroup(groups, thisID) {
  for (var i = 0; i < groups.length; i++) {
    if (groups[i][thisID]) {
      return groups[i];
    }
  }
  return null;
}

/*
 * Add this axis to the axis constraint groups, which is the collection
 * of axes that are all constrained together on scale (or matching).
 *
 * constraintGroups: a list of objects. each object is
 * {axis_id: scale_within_group}, where scale_within_group is
 * only important relative to the rest of the group, and defines
 * the relative scales between all axes in the group
 *
 * thisGroup: the group the current axis is already in
 * thisID: the id if the current axis
 * thatID: the id of the axis to scale it with
 * scaleratio: the ratio of this axis to the thatID axis
 */
function updateConstraintGroups(constraintGroups, thisID, thatID, scaleratio) {
  var i, j, groupi, keyj, thisGroupIndex;
  var thisGroup = getConstraintGroup(constraintGroups, thisID);
  if (thisGroup === null) {
    thisGroup = {};
    thisGroup[thisID] = 1;
    thisGroupIndex = constraintGroups.length;
    constraintGroups.push(thisGroup);
  } else {
    thisGroupIndex = constraintGroups.indexOf(thisGroup);
  }
  var thisGroupKeys = Object.keys(thisGroup);

  // we know that this axis isn't in any other groups, but we don't know
  // about the thatID axis. If it is, we need to merge the groups.
  for (i = 0; i < constraintGroups.length; i++) {
    groupi = constraintGroups[i];
    if (i !== thisGroupIndex && groupi[thatID]) {
      var baseScale = groupi[thatID];
      for (j = 0; j < thisGroupKeys.length; j++) {
        keyj = thisGroupKeys[j];
        groupi[keyj] = multiplyScales(baseScale, multiplyScales(scaleratio, thisGroup[keyj]));
      }
      constraintGroups.splice(thisGroupIndex, 1);
      return;
    }
  }

  // otherwise, we insert the new thatID axis as the base scale (1)
  // in its group, and scale the rest of the group to it
  if (scaleratio !== 1) {
    for (j = 0; j < thisGroupKeys.length; j++) {
      var key = thisGroupKeys[j];
      thisGroup[key] = multiplyScales(scaleratio, thisGroup[key]);
    }
  }
  thisGroup[thatID] = 1;
}

// scales may be numbers or 'x1.3', 'yy4.5' etc to multiply by as-yet-unknown
// ratios between x and y plot sizes n times
function multiplyScales(a, b) {
  var aPrefix = '';
  var bPrefix = '';
  var aLen, bLen;
  if (typeof a === 'string') {
    aPrefix = a.match(/^[xy]*/)[0];
    aLen = aPrefix.length;
    a = +a.substr(aLen);
  }
  if (typeof b === 'string') {
    bPrefix = b.match(/^[xy]*/)[0];
    bLen = bPrefix.length;
    b = +b.substr(bLen);
  }
  var c = a * b;

  // just two numbers
  if (!aLen && !bLen) {
    return c;
  }

  // one or more prefixes of the same type
  if (!aLen || !bLen || aPrefix.charAt(0) === bPrefix.charAt(0)) {
    return aPrefix + bPrefix + a * b;
  }

  // x and y cancel each other out exactly - back to a number
  if (aLen === bLen) {
    return c;
  }

  // partial cancelation of prefixes
  return (aLen > bLen ? aPrefix.substr(bLen) : bPrefix.substr(aLen)) + c;
}
function finalRatios(group, fullLayout) {
  var size = fullLayout._size;
  var yRatio = size.h / size.w;
  var out = {};
  var keys = Object.keys(group);
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var val = group[key];
    if (typeof val === 'string') {
      var prefix = val.match(/^[xy]*/)[0];
      var pLen = prefix.length;
      val = +val.substr(pLen);
      var mult = prefix.charAt(0) === 'y' ? yRatio : 1 / yRatio;
      for (var j = 0; j < pLen; j++) {
        val *= mult;
      }
    }
    out[key] = val;
  }
  return out;
}
exports.enforce = function enforce(gd) {
  var fullLayout = gd._fullLayout;
  var constraintGroups = fullLayout._axisConstraintGroups || [];
  var i, j, group, axisID, ax, normScale, mode, factor;

  // matching constraints are handled in the autorange code when autoranged,
  // or in the supplyDefaults code when explicitly ranged.
  // now we just need to handle scaleanchor constraints
  // matches constraints that chain with scaleanchor constraints are included
  // here too, but because matches has already been satisfied,
  // any changes here should preserve that.
  for (i = 0; i < constraintGroups.length; i++) {
    group = finalRatios(constraintGroups[i], fullLayout);
    var axisIDs = Object.keys(group);
    var minScale = Infinity;
    var maxScale = 0;
    // mostly matchScale will be the same as minScale
    // ie we expand axis ranges to encompass *everything*
    // that's currently in any of their ranges, but during
    // autorange of a subset of axes we will ignore other
    // axes for this purpose.
    var matchScale = Infinity;
    var normScales = {};
    var axes = {};
    var hasAnyDomainConstraint = false;

    // find the (normalized) scale of each axis in the group
    for (j = 0; j < axisIDs.length; j++) {
      axisID = axisIDs[j];
      axes[axisID] = ax = fullLayout[id2name(axisID)];
      if (ax._inputDomain) ax.domain = ax._inputDomain.slice();else ax._inputDomain = ax.domain.slice();
      if (!ax._inputRange) ax._inputRange = ax.range.slice();

      // set axis scale here so we can use _m rather than
      // having to calculate it from length and range
      ax.setScale();

      // abs: inverted scales still satisfy the constraint
      normScales[axisID] = normScale = Math.abs(ax._m) / group[axisID];
      minScale = Math.min(minScale, normScale);
      if (ax.constrain === 'domain' || !ax._constraintShrinkable) {
        matchScale = Math.min(matchScale, normScale);
      }

      // this has served its purpose, so remove it
      delete ax._constraintShrinkable;
      maxScale = Math.max(maxScale, normScale);
      if (ax.constrain === 'domain') hasAnyDomainConstraint = true;
    }

    // Do we have a constraint mismatch? Give a small buffer for rounding errors
    if (minScale > ALMOST_EQUAL * maxScale && !hasAnyDomainConstraint) continue;

    // now increase any ranges we need to until all normalized scales are equal
    for (j = 0; j < axisIDs.length; j++) {
      axisID = axisIDs[j];
      normScale = normScales[axisID];
      ax = axes[axisID];
      mode = ax.constrain;

      // even if the scale didn't change, if we're shrinking domain
      // we need to recalculate in case `constraintoward` changed
      if (normScale !== matchScale || mode === 'domain') {
        factor = normScale / matchScale;
        if (mode === 'range') {
          scaleZoom(ax, factor);
        } else {
          // mode === 'domain'

          var inputDomain = ax._inputDomain;
          var domainShrunk = (ax.domain[1] - ax.domain[0]) / (inputDomain[1] - inputDomain[0]);
          var rangeShrunk = (ax.r2l(ax.range[1]) - ax.r2l(ax.range[0])) / (ax.r2l(ax._inputRange[1]) - ax.r2l(ax._inputRange[0]));
          factor /= domainShrunk;
          if (factor * rangeShrunk < 1) {
            // we've asked to magnify the axis more than we can just by
            // enlarging the domain - so we need to constrict range
            ax.domain = ax._input.domain = inputDomain.slice();
            scaleZoom(ax, factor);
            continue;
          }
          if (rangeShrunk < 1) {
            // the range has previously been constricted by ^^, but we've
            // switched to the domain-constricted regime, so reset range
            ax.range = ax._input.range = ax._inputRange.slice();
            factor *= rangeShrunk;
          }
          if (ax.autorange) {
            /*
             * range & factor may need to change because range was
             * calculated for the larger scaling, so some pixel
             * paddings may get cut off when we reduce the domain.
             *
             * This is easier than the regular autorange calculation
             * because we already know the scaling `m`, but we still
             * need to cut out impossible constraints (like
             * annotations with super-long arrows). That's what
             * outerMin/Max are for - if the expansion was going to
             * go beyond the original domain, it must be impossible
             */
            var rl0 = ax.r2l(ax.range[0]);
            var rl1 = ax.r2l(ax.range[1]);
            var rangeCenter = (rl0 + rl1) / 2;
            var rangeMin = rangeCenter;
            var rangeMax = rangeCenter;
            var halfRange = Math.abs(rl1 - rangeCenter);
            // extra tiny bit for rounding errors, in case we actually
            // *are* expanding to the full domain
            var outerMin = rangeCenter - halfRange * factor * 1.0001;
            var outerMax = rangeCenter + halfRange * factor * 1.0001;
            var getPadMin = autorange.makePadFn(fullLayout, ax, 0);
            var getPadMax = autorange.makePadFn(fullLayout, ax, 1);
            updateDomain(ax, factor);
            var m = Math.abs(ax._m);
            var extremes = autorange.concatExtremes(gd, ax);
            var minArray = extremes.min;
            var maxArray = extremes.max;
            var newVal;
            var k;
            for (k = 0; k < minArray.length; k++) {
              newVal = minArray[k].val - getPadMin(minArray[k]) / m;
              if (newVal > outerMin && newVal < rangeMin) {
                rangeMin = newVal;
              }
            }
            for (k = 0; k < maxArray.length; k++) {
              newVal = maxArray[k].val + getPadMax(maxArray[k]) / m;
              if (newVal < outerMax && newVal > rangeMax) {
                rangeMax = newVal;
              }
            }
            var domainExpand = (rangeMax - rangeMin) / (2 * halfRange);
            factor /= domainExpand;
            rangeMin = ax.l2r(rangeMin);
            rangeMax = ax.l2r(rangeMax);
            ax.range = ax._input.range = rl0 < rl1 ? [rangeMin, rangeMax] : [rangeMax, rangeMin];
          }
          updateDomain(ax, factor);
        }
      }
    }
  }
};
exports.getAxisGroup = function getAxisGroup(fullLayout, axId) {
  var matchGroups = fullLayout._axisMatchGroups;
  for (var i = 0; i < matchGroups.length; i++) {
    var group = matchGroups[i];
    if (group[axId]) return 'g' + i;
  }
  return axId;
};

// For use before autoranging, check if this axis was previously constrained
// by domain but no longer is
exports.clean = function clean(gd, ax) {
  if (ax._inputDomain) {
    var isConstrained = false;
    var axId = ax._id;
    var constraintGroups = gd._fullLayout._axisConstraintGroups;
    for (var j = 0; j < constraintGroups.length; j++) {
      if (constraintGroups[j][axId]) {
        isConstrained = true;
        break;
      }
    }
    if (!isConstrained || ax.constrain !== 'domain') {
      ax._input.domain = ax.domain = ax._inputDomain;
      delete ax._inputDomain;
    }
  }
};
function updateDomain(ax, factor) {
  var inputDomain = ax._inputDomain;
  var centerFraction = FROM_BL[ax.constraintoward];
  var center = inputDomain[0] + (inputDomain[1] - inputDomain[0]) * centerFraction;
  ax.domain = ax._input.domain = [center + (inputDomain[0] - center) / factor, center + (inputDomain[1] - center) / factor];
  ax.setScale();
}

/***/ }),

/***/ 51680:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var Lib = __webpack_require__(34809);
var numberFormat = Lib.numberFormat;
var tinycolor = __webpack_require__(65657);
var supportsPassive = __webpack_require__(74043);
var Registry = __webpack_require__(33626);
var strTranslate = Lib.strTranslate;
var svgTextUtils = __webpack_require__(30635);
var Color = __webpack_require__(78766);
var Drawing = __webpack_require__(62203);
var Fx = __webpack_require__(32141);
var Axes = __webpack_require__(29714);
var setCursor = __webpack_require__(27983);
var dragElement = __webpack_require__(14751);
var helpers = __webpack_require__(70414);
var selectingOrDrawing = helpers.selectingOrDrawing;
var freeMode = helpers.freeMode;
var FROM_TL = (__webpack_require__(4530).FROM_TL);
var clearGlCanvases = __webpack_require__(34823);
var redrawReglTraces = (__webpack_require__(71817).redrawReglTraces);
var Plots = __webpack_require__(44122);
var getFromId = (__webpack_require__(5975).getFromId);
var prepSelect = (__webpack_require__(44844).prepSelect);
var clearOutline = (__webpack_require__(44844).clearOutline);
var selectOnClick = (__webpack_require__(44844).selectOnClick);
var scaleZoom = __webpack_require__(67611);
var constants = __webpack_require__(54826);
var MINDRAG = constants.MINDRAG;
var MINZOOM = constants.MINZOOM;

// flag for showing "doubleclick to zoom out" only at the beginning
var SHOWZOOMOUTTIP = true;

// dragBox: create an element to drag one or more axis ends
// inputs:
//      plotinfo - which subplot are we making dragboxes on?
//      x,y,w,h - left, top, width, height of the box
//      ns - how does this drag the vertical axis?
//          'n' - top only
//          's' - bottom only
//          'ns' - top and bottom together, difference unchanged
//      ew - same for horizontal axis
function makeDragBox(gd, plotinfo, x, y, w, h, ns, ew) {
  // mouseDown stores ms of first mousedown event in the last
  // `gd._context.doubleClickDelay` ms on the drag bars
  // numClicks stores how many mousedowns have been seen
  // within `gd._context.doubleClickDelay` so we can check for click or doubleclick events
  // dragged stores whether a drag has occurred, so we don't have to
  // redraw unnecessarily, ie if no move bigger than MINDRAG or MINZOOM px
  var zoomlayer = gd._fullLayout._zoomlayer;
  var isMainDrag = ns + ew === 'nsew';
  var singleEnd = (ns + ew).length === 1;

  // main subplot x and y (i.e. found in plotinfo - the main ones)
  var xa0, ya0;
  // {ax._id: ax} hash objects
  var xaHash, yaHash;
  // xaHash/yaHash values (arrays)
  var xaxes, yaxes;
  // main axis offsets
  var xs, ys;
  // main axis lengths
  var pw, ph;
  // contains keys 'xaHash', 'yaHash', 'xaxes', and 'yaxes'
  // which are the x/y {ax._id: ax} hash objects and their values
  // for linked axis relative to this subplot
  var links;
  // similar to `links` but for matching axes
  var matches;
  // set to ew/ns val when active, set to '' when inactive
  var xActive, yActive;
  // are all axes in this subplot are fixed?
  var allFixedRanges;
  // do we need to edit x/y ranges?
  var editX, editY;
  // graph-wide optimization flags
  var hasScatterGl, hasSplom, hasSVG;
  // collected changes to be made to the plot by relayout at the end
  var updates;
  // scaling factors from css transform
  var scaleX;
  var scaleY;

  // offset the x location of the box if needed
  x += plotinfo.yaxis._shift;
  function recomputeAxisLists() {
    xa0 = plotinfo.xaxis;
    ya0 = plotinfo.yaxis;
    pw = xa0._length;
    ph = ya0._length;
    xs = xa0._offset;
    ys = ya0._offset;
    xaHash = {};
    xaHash[xa0._id] = xa0;
    yaHash = {};
    yaHash[ya0._id] = ya0;

    // if we're dragging two axes at once, also drag overlays
    if (ns && ew) {
      var overlays = plotinfo.overlays;
      for (var i = 0; i < overlays.length; i++) {
        var xa = overlays[i].xaxis;
        xaHash[xa._id] = xa;
        var ya = overlays[i].yaxis;
        yaHash[ya._id] = ya;
      }
    }
    xaxes = hashValues(xaHash);
    yaxes = hashValues(yaHash);
    xActive = isDirectionActive(xaxes, ew);
    yActive = isDirectionActive(yaxes, ns);
    allFixedRanges = !yActive && !xActive;
    matches = calcLinks(gd, gd._fullLayout._axisMatchGroups, xaHash, yaHash);
    links = calcLinks(gd, gd._fullLayout._axisConstraintGroups, xaHash, yaHash, matches);
    var spConstrained = links.isSubplotConstrained || matches.isSubplotConstrained;
    editX = ew || spConstrained;
    editY = ns || spConstrained;
    var fullLayout = gd._fullLayout;
    hasScatterGl = fullLayout._has('scattergl');
    hasSplom = fullLayout._has('splom');
    hasSVG = fullLayout._has('svg');
  }
  recomputeAxisLists();
  var cursor = getDragCursor(yActive + xActive, gd._fullLayout.dragmode, isMainDrag);
  var dragger = makeRectDragger(plotinfo, ns + ew + 'drag', cursor, x, y, w, h);

  // still need to make the element if the axes are disabled
  // but nuke its events (except for maindrag which needs them for hover)
  // and stop there
  if (allFixedRanges && !isMainDrag) {
    dragger.onmousedown = null;
    dragger.style.pointerEvents = 'none';
    return dragger;
  }
  var dragOptions = {
    element: dragger,
    gd: gd,
    plotinfo: plotinfo
  };
  dragOptions.prepFn = function (e, startX, startY) {
    var dragModePrev = dragOptions.dragmode;
    var dragModeNow = gd._fullLayout.dragmode;
    if (dragModeNow !== dragModePrev) {
      dragOptions.dragmode = dragModeNow;
    }
    recomputeAxisLists();
    scaleX = gd._fullLayout._invScaleX;
    scaleY = gd._fullLayout._invScaleY;
    if (!allFixedRanges) {
      if (isMainDrag) {
        // main dragger handles all drag modes, and changes
        // to pan (or to zoom if it already is pan) on shift
        if (e.shiftKey) {
          if (dragModeNow === 'pan') dragModeNow = 'zoom';else if (!selectingOrDrawing(dragModeNow)) dragModeNow = 'pan';
        } else if (e.ctrlKey) {
          dragModeNow = 'pan';
        }
      } else {
        // all other draggers just pan
        dragModeNow = 'pan';
      }
    }
    if (freeMode(dragModeNow)) dragOptions.minDrag = 1;else dragOptions.minDrag = undefined;
    if (selectingOrDrawing(dragModeNow)) {
      dragOptions.xaxes = xaxes;
      dragOptions.yaxes = yaxes;
      // this attaches moveFn, clickFn, doneFn on dragOptions
      prepSelect(e, startX, startY, dragOptions, dragModeNow);
    } else {
      dragOptions.clickFn = clickFn;
      if (selectingOrDrawing(dragModePrev)) {
        // TODO Fix potential bug
        // Note: clearing / resetting selection state only happens, when user
        // triggers at least one interaction in pan/zoom mode. Otherwise, the
        // select/lasso outlines are deleted (in plots.js.cleanPlot) but the selection
        // cache isn't cleared. So when the user switches back to select/lasso and
        // 'adds to a selection' with Shift, the "old", seemingly removed outlines
        // are redrawn again because the selection cache still holds their coordinates.
        // However, this isn't easily solved, since plots.js would need
        // to have a reference to the dragOptions object (which holds the
        // selection cache).
        clearAndResetSelect();
      }
      if (!allFixedRanges) {
        if (dragModeNow === 'zoom') {
          dragOptions.moveFn = zoomMove;
          dragOptions.doneFn = zoomDone;

          // zoomMove takes care of the threshold, but we need to
          // minimize this so that constrained zoom boxes will flip
          // orientation at the right place
          dragOptions.minDrag = 1;
          zoomPrep(e, startX, startY);
        } else if (dragModeNow === 'pan') {
          dragOptions.moveFn = plotDrag;
          dragOptions.doneFn = dragTail;
        }
      }
    }
    gd._fullLayout._redrag = function () {
      var dragDataNow = gd._dragdata;
      if (dragDataNow && dragDataNow.element === dragger) {
        var dragModeNow = gd._fullLayout.dragmode;
        if (!selectingOrDrawing(dragModeNow)) {
          recomputeAxisLists();
          updateSubplots([0, 0, pw, ph]);
          dragOptions.moveFn(dragDataNow.dx, dragDataNow.dy);
        }
      }
    };
  };
  function clearAndResetSelect() {
    // clear selection polygon cache (if any)
    dragOptions.plotinfo.selection = false;
    // clear selection outlines
    clearOutline(gd);
  }
  function clickFn(numClicks, evt) {
    var gd = dragOptions.gd;
    if (gd._fullLayout._activeShapeIndex >= 0) {
      gd._fullLayout._deactivateShape(gd);
      return;
    }
    var clickmode = gd._fullLayout.clickmode;
    removeZoombox(gd);
    if (numClicks === 2 && !singleEnd) doubleClick();
    if (isMainDrag) {
      if (clickmode.indexOf('select') > -1) {
        selectOnClick(evt, gd, xaxes, yaxes, plotinfo.id, dragOptions);
      }
      if (clickmode.indexOf('event') > -1) {
        Fx.click(gd, evt, plotinfo.id);
      }
    } else if (numClicks === 1 && singleEnd) {
      var ax = ns ? ya0 : xa0;
      var end = ns === 's' || ew === 'w' ? 0 : 1;
      var attrStr = ax._name + '.range[' + end + ']';
      var initialText = getEndText(ax, end);
      var hAlign = 'left';
      var vAlign = 'middle';
      if (ax.fixedrange) return;
      if (ns) {
        vAlign = ns === 'n' ? 'top' : 'bottom';
        if (ax.side === 'right') hAlign = 'right';
      } else if (ew === 'e') hAlign = 'right';
      if (gd._context.showAxisRangeEntryBoxes) {
        d3.select(dragger).call(svgTextUtils.makeEditable, {
          gd: gd,
          immediate: true,
          background: gd._fullLayout.paper_bgcolor,
          text: String(initialText),
          fill: ax.tickfont ? ax.tickfont.color : '#444',
          horizontalAlign: hAlign,
          verticalAlign: vAlign
        }).on('edit', function (text) {
          var v = ax.d2r(text);
          if (v !== undefined) {
            Registry.call('_guiRelayout', gd, attrStr, v);
          }
        });
      }
    }
  }
  dragElement.init(dragOptions);

  // x/y px position at start of drag
  var x0, y0;
  // bbox object of the zoombox
  var box;
  // luminance of bg behind zoombox
  var lum;
  // zoombox path outline
  var path0;
  // is zoombox dimmed (during drag)
  var dimmed;
  // 'x'-only, 'y' or 'xy' zooming
  var zoomMode;
  // zoombox d3 selection
  var zb;
  // zoombox corner d3 selection
  var corners;
  // zoom takes over minDrag, so it also has to take over gd._dragged
  var zoomDragged;
  function zoomPrep(e, startX, startY) {
    var dragBBox = dragger.getBoundingClientRect();
    x0 = startX - dragBBox.left;
    y0 = startY - dragBBox.top;
    gd._fullLayout._calcInverseTransform(gd);
    var transformedCoords = Lib.apply3DTransform(gd._fullLayout._invTransform)(x0, y0);
    x0 = transformedCoords[0];
    y0 = transformedCoords[1];
    box = {
      l: x0,
      r: x0,
      w: 0,
      t: y0,
      b: y0,
      h: 0
    };
    lum = gd._hmpixcount ? gd._hmlumcount / gd._hmpixcount : tinycolor(gd._fullLayout.plot_bgcolor).getLuminance();
    path0 = 'M0,0H' + pw + 'V' + ph + 'H0V0';
    dimmed = false;
    zoomMode = 'xy';
    zoomDragged = false;
    zb = makeZoombox(zoomlayer, lum, xs, ys, path0);
    corners = makeCorners(zoomlayer, xs, ys);
  }
  function zoomMove(dx0, dy0) {
    if (gd._transitioningWithDuration) {
      return false;
    }
    var x1 = Math.max(0, Math.min(pw, scaleX * dx0 + x0));
    var y1 = Math.max(0, Math.min(ph, scaleY * dy0 + y0));
    var dx = Math.abs(x1 - x0);
    var dy = Math.abs(y1 - y0);
    box.l = Math.min(x0, x1);
    box.r = Math.max(x0, x1);
    box.t = Math.min(y0, y1);
    box.b = Math.max(y0, y1);
    function noZoom() {
      zoomMode = '';
      box.r = box.l;
      box.t = box.b;
      corners.attr('d', 'M0,0Z');
    }
    if (links.isSubplotConstrained) {
      if (dx > MINZOOM || dy > MINZOOM) {
        zoomMode = 'xy';
        if (dx / pw > dy / ph) {
          dy = dx * ph / pw;
          if (y0 > y1) box.t = y0 - dy;else box.b = y0 + dy;
        } else {
          dx = dy * pw / ph;
          if (x0 > x1) box.l = x0 - dx;else box.r = x0 + dx;
        }
        corners.attr('d', xyCorners(box));
      } else {
        noZoom();
      }
    } else if (matches.isSubplotConstrained) {
      if (dx > MINZOOM || dy > MINZOOM) {
        zoomMode = 'xy';
        var r0 = Math.min(box.l / pw, (ph - box.b) / ph);
        var r1 = Math.max(box.r / pw, (ph - box.t) / ph);
        box.l = r0 * pw;
        box.r = r1 * pw;
        box.b = (1 - r0) * ph;
        box.t = (1 - r1) * ph;
        corners.attr('d', xyCorners(box));
      } else {
        noZoom();
      }
    } else if (!yActive || dy < Math.min(Math.max(dx * 0.6, MINDRAG), MINZOOM)) {
      // look for small drags in one direction or the other,
      // and only drag the other axis

      if (dx < MINDRAG || !xActive) {
        noZoom();
      } else {
        box.t = 0;
        box.b = ph;
        zoomMode = 'x';
        corners.attr('d', xCorners(box, y0));
      }
    } else if (!xActive || dx < Math.min(dy * 0.6, MINZOOM)) {
      box.l = 0;
      box.r = pw;
      zoomMode = 'y';
      corners.attr('d', yCorners(box, x0));
    } else {
      zoomMode = 'xy';
      corners.attr('d', xyCorners(box));
    }
    box.w = box.r - box.l;
    box.h = box.b - box.t;
    if (zoomMode) zoomDragged = true;
    gd._dragged = zoomDragged;
    updateZoombox(zb, corners, box, path0, dimmed, lum);
    computeZoomUpdates();
    gd.emit('plotly_relayouting', updates);
    dimmed = true;
  }
  function computeZoomUpdates() {
    updates = {};

    // TODO: edit linked axes in zoomAxRanges and in dragTail
    if (zoomMode === 'xy' || zoomMode === 'x') {
      zoomAxRanges(xaxes, box.l / pw, box.r / pw, updates, links.xaxes);
      updateMatchedAxRange('x', updates);
    }
    if (zoomMode === 'xy' || zoomMode === 'y') {
      zoomAxRanges(yaxes, (ph - box.b) / ph, (ph - box.t) / ph, updates, links.yaxes);
      updateMatchedAxRange('y', updates);
    }
  }
  function zoomDone() {
    computeZoomUpdates();
    removeZoombox(gd);
    dragTail();
    showDoubleClickNotifier(gd);
  }

  // scroll zoom, on all draggers except corners
  var scrollViewBox = [0, 0, pw, ph];
  // wait a little after scrolling before redrawing
  var redrawTimer = null;
  var REDRAWDELAY = constants.REDRAWDELAY;
  var mainplot = plotinfo.mainplot ? gd._fullLayout._plots[plotinfo.mainplot] : plotinfo;
  function zoomWheel(e) {
    // deactivate mousewheel scrolling on embedded graphs
    // devs can override this with layout._enablescrollzoom,
    // but _ ensures this setting won't leave their page
    if (!gd._context._scrollZoom.cartesian && !gd._fullLayout._enablescrollzoom) {
      return;
    }
    clearAndResetSelect();

    // If a transition is in progress, then disable any behavior:
    if (gd._transitioningWithDuration) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    recomputeAxisLists();
    clearTimeout(redrawTimer);
    var wheelDelta = -e.deltaY;
    if (!isFinite(wheelDelta)) wheelDelta = e.wheelDelta / 10;
    if (!isFinite(wheelDelta)) {
      Lib.log('Did not find wheel motion attributes: ', e);
      return;
    }
    var zoom = Math.exp(-Math.min(Math.max(wheelDelta, -20), 20) / 200);
    var gbb = mainplot.draglayer.select('.nsewdrag').node().getBoundingClientRect();
    var xfrac = (e.clientX - gbb.left) / gbb.width;
    var yfrac = (gbb.bottom - e.clientY) / gbb.height;
    var i;
    function zoomWheelOneAxis(ax, centerFraction, zoom) {
      if (ax.fixedrange) return;
      var axRange = Lib.simpleMap(ax.range, ax.r2l);
      var v0 = axRange[0] + (axRange[1] - axRange[0]) * centerFraction;
      function doZoom(v) {
        return ax.l2r(v0 + (v - v0) * zoom);
      }
      ax.range = axRange.map(doZoom);
    }
    if (editX) {
      // if we're only zooming this axis because of constraints,
      // zoom it about the center
      if (!ew) xfrac = 0.5;
      for (i = 0; i < xaxes.length; i++) {
        zoomWheelOneAxis(xaxes[i], xfrac, zoom);
      }
      updateMatchedAxRange('x');
      scrollViewBox[2] *= zoom;
      scrollViewBox[0] += scrollViewBox[2] * xfrac * (1 / zoom - 1);
    }
    if (editY) {
      if (!ns) yfrac = 0.5;
      for (i = 0; i < yaxes.length; i++) {
        zoomWheelOneAxis(yaxes[i], yfrac, zoom);
      }
      updateMatchedAxRange('y');
      scrollViewBox[3] *= zoom;
      scrollViewBox[1] += scrollViewBox[3] * (1 - yfrac) * (1 / zoom - 1);
    }

    // viewbox redraw at first
    updateSubplots(scrollViewBox);
    ticksAndAnnotations();
    gd.emit('plotly_relayouting', updates);

    // then replot after a delay to make sure
    // no more scrolling is coming
    redrawTimer = setTimeout(function () {
      if (!gd._fullLayout) return;
      scrollViewBox = [0, 0, pw, ph];
      dragTail();
    }, REDRAWDELAY);
    e.preventDefault();
    return;
  }

  // everything but the corners gets wheel zoom
  if (ns.length * ew.length !== 1) {
    attachWheelEventHandler(dragger, zoomWheel);
  }

  // plotDrag: move the plot in response to a drag
  function plotDrag(dx, dy) {
    dx = dx * scaleX;
    dy = dy * scaleY;
    // If a transition is in progress, then disable any behavior:
    if (gd._transitioningWithDuration) {
      return;
    }

    // prevent axis drawing from monkeying with margins until we're done
    gd._fullLayout._replotting = true;
    if (xActive === 'ew' || yActive === 'ns') {
      var spDx = xActive ? -dx : 0;
      var spDy = yActive ? -dy : 0;
      if (matches.isSubplotConstrained) {
        if (xActive && yActive) {
          var frac = (dx / pw - dy / ph) / 2;
          dx = frac * pw;
          dy = -frac * ph;
          spDx = -dx;
          spDy = -dy;
        }
        if (yActive) {
          spDx = -spDy * pw / ph;
        } else {
          spDy = -spDx * ph / pw;
        }
      }
      if (xActive) {
        dragAxList(xaxes, dx);
        updateMatchedAxRange('x');
      }
      if (yActive) {
        dragAxList(yaxes, dy);
        updateMatchedAxRange('y');
      }
      updateSubplots([spDx, spDy, pw, ph]);
      ticksAndAnnotations();
      gd.emit('plotly_relayouting', updates);
      return;
    }

    // dz: set a new value for one end (0 or 1) of an axis array axArray,
    // and return a pixel shift for that end for the viewbox
    // based on pixel drag distance d
    // TODO: this makes (generally non-fatal) errors when you get
    // near floating point limits
    function dz(axArray, end, d) {
      var otherEnd = 1 - end;
      var movedAx;
      var newLinearizedEnd;
      for (var i = 0; i < axArray.length; i++) {
        var axi = axArray[i];
        if (axi.fixedrange) continue;
        movedAx = axi;
        newLinearizedEnd = axi._rl[otherEnd] + (axi._rl[end] - axi._rl[otherEnd]) / dZoom(d / axi._length);
        var newEnd = axi.l2r(newLinearizedEnd);

        // if l2r comes back false or undefined, it means we've dragged off
        // the end of valid ranges - so stop.
        if (newEnd !== false && newEnd !== undefined) axi.range[end] = newEnd;
      }
      return movedAx._length * (movedAx._rl[end] - newLinearizedEnd) / (movedAx._rl[end] - movedAx._rl[otherEnd]);
    }
    var dxySign = xActive === 'w' === (yActive === 'n') ? 1 : -1;
    if (xActive && yActive && (links.isSubplotConstrained || matches.isSubplotConstrained)) {
      // dragging a corner of a constrained subplot:
      // respect the fixed corner, but harmonize dx and dy
      var dxyFraction = (dx / pw + dxySign * dy / ph) / 2;
      dx = dxyFraction * pw;
      dy = dxySign * dxyFraction * ph;
    }
    var xStart, yStart;
    if (xActive === 'w') dx = dz(xaxes, 0, dx);else if (xActive === 'e') dx = dz(xaxes, 1, -dx);else if (!xActive) dx = 0;
    if (yActive === 'n') dy = dz(yaxes, 1, dy);else if (yActive === 's') dy = dz(yaxes, 0, -dy);else if (!yActive) dy = 0;
    xStart = xActive === 'w' ? dx : 0;
    yStart = yActive === 'n' ? dy : 0;
    if (links.isSubplotConstrained && !matches.isSubplotConstrained ||
    // NW or SE on matching axes - create a symmetric zoom
    matches.isSubplotConstrained && xActive && yActive && dxySign > 0) {
      var i;
      if (matches.isSubplotConstrained || !xActive && yActive.length === 1) {
        // dragging one end of the y axis of a constrained subplot
        // scale the other axis the same about its middle
        for (i = 0; i < xaxes.length; i++) {
          xaxes[i].range = xaxes[i]._r.slice();
          scaleZoom(xaxes[i], 1 - dy / ph);
        }
        dx = dy * pw / ph;
        xStart = dx / 2;
      }
      if (matches.isSubplotConstrained || !yActive && xActive.length === 1) {
        for (i = 0; i < yaxes.length; i++) {
          yaxes[i].range = yaxes[i]._r.slice();
          scaleZoom(yaxes[i], 1 - dx / pw);
        }
        dy = dx * ph / pw;
        yStart = dy / 2;
      }
    }
    if (!matches.isSubplotConstrained || !yActive) {
      updateMatchedAxRange('x');
    }
    if (!matches.isSubplotConstrained || !xActive) {
      updateMatchedAxRange('y');
    }
    var xSize = pw - dx;
    var ySize = ph - dy;
    if (matches.isSubplotConstrained && !(xActive && yActive)) {
      if (xActive) {
        yStart = xStart ? 0 : dx * ph / pw;
        ySize = xSize * ph / pw;
      } else {
        xStart = yStart ? 0 : dy * pw / ph;
        xSize = ySize * pw / ph;
      }
    }
    updateSubplots([xStart, yStart, xSize, ySize]);
    ticksAndAnnotations();
    gd.emit('plotly_relayouting', updates);
  }
  function updateMatchedAxRange(axLetter, out) {
    var matchedAxes = matches.isSubplotConstrained ? {
      x: yaxes,
      y: xaxes
    }[axLetter] : matches[axLetter + 'axes'];
    var constrainedAxes = matches.isSubplotConstrained ? {
      x: xaxes,
      y: yaxes
    }[axLetter] : [];
    for (var i = 0; i < matchedAxes.length; i++) {
      var ax = matchedAxes[i];
      var axId = ax._id;
      var axId2 = matches.xLinks[axId] || matches.yLinks[axId];
      var ax2 = constrainedAxes[0] || xaHash[axId2] || yaHash[axId2];
      if (ax2) {
        if (out) {
          // zoombox case - don't mutate 'range', just add keys in 'updates'
          out[ax._name + '.range[0]'] = out[ax2._name + '.range[0]'];
          out[ax._name + '.range[1]'] = out[ax2._name + '.range[1]'];
        } else {
          ax.range = ax2.range.slice();
        }
      }
    }
  }

  // Draw ticks and annotations (and other components) when ranges change.
  // Also records the ranges that have changed for use by update at the end.
  function ticksAndAnnotations() {
    var activeAxIds = [];
    var i;
    function pushActiveAxIds(axList) {
      for (i = 0; i < axList.length; i++) {
        if (!axList[i].fixedrange) activeAxIds.push(axList[i]._id);
      }
    }
    function pushActiveAxIdsSynced(axList, axisType) {
      for (i = 0; i < axList.length; i++) {
        var axListI = axList[i];
        var axListIType = axListI[axisType];
        if (!axListI.fixedrange && axListIType.tickmode === 'sync') activeAxIds.push(axListIType._id);
      }
    }
    if (editX) {
      pushActiveAxIds(xaxes);
      pushActiveAxIds(links.xaxes);
      pushActiveAxIds(matches.xaxes);
      pushActiveAxIdsSynced(plotinfo.overlays, 'xaxis');
    }
    if (editY) {
      pushActiveAxIds(yaxes);
      pushActiveAxIds(links.yaxes);
      pushActiveAxIds(matches.yaxes);
      pushActiveAxIdsSynced(plotinfo.overlays, 'yaxis');
    }
    updates = {};
    for (i = 0; i < activeAxIds.length; i++) {
      var axId = activeAxIds[i];
      var ax = getFromId(gd, axId);
      Axes.drawOne(gd, ax, {
        skipTitle: true
      });
      updates[ax._name + '.range[0]'] = ax.range[0];
      updates[ax._name + '.range[1]'] = ax.range[1];
    }
    Axes.redrawComponents(gd, activeAxIds);
  }
  function doubleClick() {
    if (gd._transitioningWithDuration) return;
    var doubleClickConfig = gd._context.doubleClick;
    var axList = [];
    if (xActive) axList = axList.concat(xaxes);
    if (yActive) axList = axList.concat(yaxes);
    if (matches.xaxes) axList = axList.concat(matches.xaxes);
    if (matches.yaxes) axList = axList.concat(matches.yaxes);
    var attrs = {};
    var ax, i;

    // For reset+autosize mode:
    // If *any* of the main axes is not at its initial range
    // (or autoranged, if we have no initial range, to match the logic in
    // doubleClickConfig === 'reset' below), we reset.
    // If they are *all* at their initial ranges, then we autosize.
    if (doubleClickConfig === 'reset+autosize') {
      doubleClickConfig = 'autosize';
      for (i = 0; i < axList.length; i++) {
        ax = axList[i];
        var r0 = ax._rangeInitial0;
        var r1 = ax._rangeInitial1;
        var hasRangeInitial = r0 !== undefined || r1 !== undefined;
        if (hasRangeInitial && (r0 !== undefined && r0 !== ax.range[0] || r1 !== undefined && r1 !== ax.range[1]) || !hasRangeInitial && ax.autorange !== true) {
          doubleClickConfig = 'reset';
          break;
        }
      }
    }
    if (doubleClickConfig === 'autosize') {
      // don't set the linked axes here, so relayout marks them as shrinkable
      // and we autosize just to the requested axis/axes
      for (i = 0; i < axList.length; i++) {
        ax = axList[i];
        if (!ax.fixedrange) attrs[ax._name + '.autorange'] = true;
      }
    } else if (doubleClickConfig === 'reset') {
      // when we're resetting, reset all linked axes too, so we get back
      // to the fully-auto-with-constraints situation
      if (xActive || links.isSubplotConstrained) axList = axList.concat(links.xaxes);
      if (yActive && !links.isSubplotConstrained) axList = axList.concat(links.yaxes);
      if (links.isSubplotConstrained) {
        if (!xActive) axList = axList.concat(xaxes);else if (!yActive) axList = axList.concat(yaxes);
      }
      for (i = 0; i < axList.length; i++) {
        ax = axList[i];
        if (!ax.fixedrange) {
          var axName = ax._name;
          var autorangeInitial = ax._autorangeInitial;
          if (ax._rangeInitial0 === undefined && ax._rangeInitial1 === undefined) {
            attrs[axName + '.autorange'] = true;
          } else if (ax._rangeInitial0 === undefined) {
            attrs[axName + '.autorange'] = autorangeInitial;
            attrs[axName + '.range'] = [null, ax._rangeInitial1];
          } else if (ax._rangeInitial1 === undefined) {
            attrs[axName + '.range'] = [ax._rangeInitial0, null];
            attrs[axName + '.autorange'] = autorangeInitial;
          } else {
            attrs[axName + '.range'] = [ax._rangeInitial0, ax._rangeInitial1];
          }
        }
      }
    }
    gd.emit('plotly_doubleclick', null);
    Registry.call('_guiRelayout', gd, attrs);
  }

  // dragTail - finish a drag event with a redraw
  function dragTail() {
    // put the subplot viewboxes back to default (Because we're going to)
    // be repositioning the data in the relayout. But DON'T call
    // ticksAndAnnotations again - it's unnecessary and would overwrite `updates`
    updateSubplots([0, 0, pw, ph]);

    // since we may have been redrawing some things during the drag, we may have
    // accumulated MathJax promises - wait for them before we relayout.
    Lib.syncOrAsync([Plots.previousPromises, function () {
      gd._fullLayout._replotting = false;
      Registry.call('_guiRelayout', gd, updates);
    }], gd);
  }

  // updateSubplots - find all plot viewboxes that should be
  // affected by this drag, and update them. look for all plots
  // sharing an affected axis (including the one being dragged),
  // includes also scattergl and splom logic.
  function updateSubplots(viewBox) {
    var fullLayout = gd._fullLayout;
    var plotinfos = fullLayout._plots;
    var subplots = fullLayout._subplots.cartesian;
    var i, sp, xa, ya;
    if (hasSplom) {
      Registry.subplotsRegistry.splom.drag(gd);
    }
    if (hasScatterGl) {
      for (i = 0; i < subplots.length; i++) {
        sp = plotinfos[subplots[i]];
        xa = sp.xaxis;
        ya = sp.yaxis;
        if (sp._scene) {
          if (xa.limitRange) xa.limitRange();
          if (ya.limitRange) ya.limitRange();
          var xrng = Lib.simpleMap(xa.range, xa.r2l);
          var yrng = Lib.simpleMap(ya.range, ya.r2l);
          sp._scene.update({
            range: [xrng[0], yrng[0], xrng[1], yrng[1]]
          });
        }
      }
    }
    if (hasSplom || hasScatterGl) {
      clearGlCanvases(gd);
      redrawReglTraces(gd);
    }
    if (hasSVG) {
      var xScaleFactor = viewBox[2] / xa0._length;
      var yScaleFactor = viewBox[3] / ya0._length;
      for (i = 0; i < subplots.length; i++) {
        sp = plotinfos[subplots[i]];
        xa = sp.xaxis;
        ya = sp.yaxis;
        var editX2 = (editX || matches.isSubplotConstrained) && !xa.fixedrange && xaHash[xa._id];
        var editY2 = (editY || matches.isSubplotConstrained) && !ya.fixedrange && yaHash[ya._id];
        var xScaleFactor2, yScaleFactor2;
        var clipDx, clipDy;
        if (editX2) {
          xScaleFactor2 = xScaleFactor;
          clipDx = ew || matches.isSubplotConstrained ? viewBox[0] : getShift(xa, xScaleFactor2);
        } else if (matches.xaHash[xa._id]) {
          xScaleFactor2 = xScaleFactor;
          clipDx = viewBox[0] * xa._length / xa0._length;
        } else if (matches.yaHash[xa._id]) {
          xScaleFactor2 = yScaleFactor;
          clipDx = yActive === 'ns' ? -viewBox[1] * xa._length / ya0._length : getShift(xa, xScaleFactor2, {
            n: 'top',
            s: 'bottom'
          }[yActive]);
        } else {
          xScaleFactor2 = getLinkedScaleFactor(xa, xScaleFactor, yScaleFactor);
          clipDx = scaleAndGetShift(xa, xScaleFactor2);
        }
        if (xScaleFactor2 > 1 && (xa.maxallowed !== undefined && editX === (xa.range[0] < xa.range[1] ? 'e' : 'w') || xa.minallowed !== undefined && editX === (xa.range[0] < xa.range[1] ? 'w' : 'e'))) {
          xScaleFactor2 = 1;
          clipDx = 0;
        }
        if (editY2) {
          yScaleFactor2 = yScaleFactor;
          clipDy = ns || matches.isSubplotConstrained ? viewBox[1] : getShift(ya, yScaleFactor2);
        } else if (matches.yaHash[ya._id]) {
          yScaleFactor2 = yScaleFactor;
          clipDy = viewBox[1] * ya._length / ya0._length;
        } else if (matches.xaHash[ya._id]) {
          yScaleFactor2 = xScaleFactor;
          clipDy = xActive === 'ew' ? -viewBox[0] * ya._length / xa0._length : getShift(ya, yScaleFactor2, {
            e: 'right',
            w: 'left'
          }[xActive]);
        } else {
          yScaleFactor2 = getLinkedScaleFactor(ya, xScaleFactor, yScaleFactor);
          clipDy = scaleAndGetShift(ya, yScaleFactor2);
        }
        if (yScaleFactor2 > 1 && (ya.maxallowed !== undefined && editY === (ya.range[0] < ya.range[1] ? 'n' : 's') || ya.minallowed !== undefined && editY === (ya.range[0] < ya.range[1] ? 's' : 'n'))) {
          yScaleFactor2 = 1;
          clipDy = 0;
        }

        // don't scale at all if neither axis is scalable here
        if (!xScaleFactor2 && !yScaleFactor2) {
          continue;
        }

        // but if only one is, reset the other axis scaling
        if (!xScaleFactor2) xScaleFactor2 = 1;
        if (!yScaleFactor2) yScaleFactor2 = 1;
        var plotDx = xa._offset - clipDx / xScaleFactor2;
        var plotDy = ya._offset - clipDy / yScaleFactor2;

        // TODO could be more efficient here:
        // setTranslate and setScale do a lot of extra work
        // when working independently, should perhaps combine
        // them into a single routine.
        sp.clipRect.call(Drawing.setTranslate, clipDx, clipDy).call(Drawing.setScale, xScaleFactor2, yScaleFactor2);
        sp.plot.call(Drawing.setTranslate, plotDx, plotDy).call(Drawing.setScale, 1 / xScaleFactor2, 1 / yScaleFactor2);

        // apply an inverse scale to individual points to counteract
        // the scale of the trace group.
        // apply only when scale changes, as adjusting the scale of
        // all the points can be expansive.
        if (xScaleFactor2 !== sp.xScaleFactor || yScaleFactor2 !== sp.yScaleFactor) {
          Drawing.setPointGroupScale(sp.zoomScalePts, xScaleFactor2, yScaleFactor2);
          Drawing.setTextPointsScale(sp.zoomScaleTxt, xScaleFactor2, yScaleFactor2);
        }
        Drawing.hideOutsideRangePoints(sp.clipOnAxisFalseTraces, sp);

        // update x/y scaleFactor stash
        sp.xScaleFactor = xScaleFactor2;
        sp.yScaleFactor = yScaleFactor2;
      }
    }
  }

  // Find the appropriate scaling for this axis, if it's linked to the
  // dragged axes by constraints. 0 is special, it means this axis shouldn't
  // ever be scaled (will be converted to 1 if the other axis is scaled)
  function getLinkedScaleFactor(ax, xScaleFactor, yScaleFactor) {
    if (ax.fixedrange) return 0;
    if (editX && links.xaHash[ax._id]) {
      return xScaleFactor;
    }
    if (editY && (links.isSubplotConstrained ? links.xaHash : links.yaHash)[ax._id]) {
      return yScaleFactor;
    }
    return 0;
  }
  function scaleAndGetShift(ax, scaleFactor) {
    if (scaleFactor) {
      ax.range = ax._r.slice();
      scaleZoom(ax, scaleFactor);
      return getShift(ax, scaleFactor);
    }
    return 0;
  }
  function getShift(ax, scaleFactor, from) {
    return ax._length * (1 - scaleFactor) * FROM_TL[from || ax.constraintoward || 'middle'];
  }
  return dragger;
}
function makeDragger(plotinfo, nodeName, dragClass, cursor) {
  var dragger3 = Lib.ensureSingle(plotinfo.draglayer, nodeName, dragClass, function (s) {
    s.classed('drag', true).style({
      fill: 'transparent',
      'stroke-width': 0
    }).attr('data-subplot', plotinfo.id);
  });
  dragger3.call(setCursor, cursor);
  return dragger3.node();
}
function makeRectDragger(plotinfo, dragClass, cursor, x, y, w, h) {
  var dragger = makeDragger(plotinfo, 'rect', dragClass, cursor);
  d3.select(dragger).call(Drawing.setRect, x, y, w, h);
  return dragger;
}
function isDirectionActive(axList, activeVal) {
  for (var i = 0; i < axList.length; i++) {
    if (!axList[i].fixedrange) return activeVal;
  }
  return '';
}
function getEndText(ax, end) {
  var initialVal = ax.range[end];
  var diff = Math.abs(initialVal - ax.range[1 - end]);
  var dig;

  // TODO: this should basically be ax.r2d but we're doing extra
  // rounding here... can we clean up at all?
  if (ax.type === 'date') {
    return initialVal;
  } else if (ax.type === 'log') {
    dig = Math.ceil(Math.max(0, -Math.log(diff) / Math.LN10)) + 3;
    return numberFormat('.' + dig + 'g')(Math.pow(10, initialVal));
  } else {
    // linear numeric (or category... but just show numbers here)
    dig = Math.floor(Math.log(Math.abs(initialVal)) / Math.LN10) - Math.floor(Math.log(diff) / Math.LN10) + 4;
    return numberFormat('.' + String(dig) + 'g')(initialVal);
  }
}
function zoomAxRanges(axList, r0Fraction, r1Fraction, updates, linkedAxes) {
  for (var i = 0; i < axList.length; i++) {
    var axi = axList[i];
    if (axi.fixedrange) continue;
    if (axi.rangebreaks) {
      var isY = axi._id.charAt(0) === 'y';
      var r0F = isY ? 1 - r0Fraction : r0Fraction;
      var r1F = isY ? 1 - r1Fraction : r1Fraction;
      updates[axi._name + '.range[0]'] = axi.l2r(axi.p2l(r0F * axi._length));
      updates[axi._name + '.range[1]'] = axi.l2r(axi.p2l(r1F * axi._length));
    } else {
      var axRangeLinear0 = axi._rl[0];
      var axRangeLinearSpan = axi._rl[1] - axRangeLinear0;
      updates[axi._name + '.range[0]'] = axi.l2r(axRangeLinear0 + axRangeLinearSpan * r0Fraction);
      updates[axi._name + '.range[1]'] = axi.l2r(axRangeLinear0 + axRangeLinearSpan * r1Fraction);
    }
  }

  // zoom linked axes about their centers
  if (linkedAxes && linkedAxes.length) {
    var linkedR0Fraction = (r0Fraction + (1 - r1Fraction)) / 2;
    zoomAxRanges(linkedAxes, linkedR0Fraction, 1 - linkedR0Fraction, updates, []);
  }
}
function dragAxList(axList, pix) {
  for (var i = 0; i < axList.length; i++) {
    var axi = axList[i];
    if (!axi.fixedrange) {
      if (axi.rangebreaks) {
        var p0 = 0;
        var p1 = axi._length;
        var d0 = axi.p2l(p0 + pix) - axi.p2l(p0);
        var d1 = axi.p2l(p1 + pix) - axi.p2l(p1);
        var delta = (d0 + d1) / 2;
        axi.range = [axi.l2r(axi._rl[0] - delta), axi.l2r(axi._rl[1] - delta)];
      } else {
        axi.range = [axi.l2r(axi._rl[0] - pix / axi._m), axi.l2r(axi._rl[1] - pix / axi._m)];
      }
      if (axi.limitRange) axi.limitRange();
    }
  }
}

// common transform for dragging one end of an axis
// d>0 is compressing scale (cursor is over the plot,
//  the axis end should move with the cursor)
// d<0 is expanding (cursor is off the plot, axis end moves
//  nonlinearly so you can expand far)
function dZoom(d) {
  return 1 - (d >= 0 ? Math.min(d, 0.9) : 1 / (1 / Math.max(d, -0.3) + 3.222));
}
function getDragCursor(nsew, dragmode, isMainDrag) {
  if (!nsew) return 'pointer';
  if (nsew === 'nsew') {
    // in this case here, clear cursor and
    // use the cursor style set on <g .draglayer>
    if (isMainDrag) return '';
    if (dragmode === 'pan') return 'move';
    return 'crosshair';
  }
  return nsew.toLowerCase() + '-resize';
}
function makeZoombox(zoomlayer, lum, xs, ys, path0) {
  return zoomlayer.append('path').attr('class', 'zoombox').style({
    fill: lum > 0.2 ? 'rgba(0,0,0,0)' : 'rgba(255,255,255,0)',
    'stroke-width': 0
  }).attr('transform', strTranslate(xs, ys)).attr('d', path0 + 'Z');
}
function makeCorners(zoomlayer, xs, ys) {
  return zoomlayer.append('path').attr('class', 'zoombox-corners').style({
    fill: Color.background,
    stroke: Color.defaultLine,
    'stroke-width': 1,
    opacity: 0
  }).attr('transform', strTranslate(xs, ys)).attr('d', 'M0,0Z');
}
function updateZoombox(zb, corners, box, path0, dimmed, lum) {
  zb.attr('d', path0 + 'M' + box.l + ',' + box.t + 'v' + box.h + 'h' + box.w + 'v-' + box.h + 'h-' + box.w + 'Z');
  transitionZoombox(zb, corners, dimmed, lum);
}
function transitionZoombox(zb, corners, dimmed, lum) {
  if (!dimmed) {
    zb.transition().style('fill', lum > 0.2 ? 'rgba(0,0,0,0.4)' : 'rgba(255,255,255,0.3)').duration(200);
    corners.transition().style('opacity', 1).duration(200);
  }
}
function removeZoombox(gd) {
  d3.select(gd).selectAll('.zoombox,.js-zoombox-backdrop,.js-zoombox-menu,.zoombox-corners').remove();
}
function showDoubleClickNotifier(gd) {
  if (SHOWZOOMOUTTIP && gd.data && gd._context.showTips) {
    Lib.notifier(Lib._(gd, 'Double-click to zoom back out'), 'long');
    SHOWZOOMOUTTIP = false;
  }
}
function xCorners(box, y0) {
  return 'M' + (box.l - 0.5) + ',' + (y0 - MINZOOM - 0.5) + 'h-3v' + (2 * MINZOOM + 1) + 'h3ZM' + (box.r + 0.5) + ',' + (y0 - MINZOOM - 0.5) + 'h3v' + (2 * MINZOOM + 1) + 'h-3Z';
}
function yCorners(box, x0) {
  return 'M' + (x0 - MINZOOM - 0.5) + ',' + (box.t - 0.5) + 'v-3h' + (2 * MINZOOM + 1) + 'v3ZM' + (x0 - MINZOOM - 0.5) + ',' + (box.b + 0.5) + 'v3h' + (2 * MINZOOM + 1) + 'v-3Z';
}
function xyCorners(box) {
  var clen = Math.floor(Math.min(box.b - box.t, box.r - box.l, MINZOOM) / 2);
  return 'M' + (box.l - 3.5) + ',' + (box.t - 0.5 + clen) + 'h3v' + -clen + 'h' + clen + 'v-3h-' + (clen + 3) + 'ZM' + (box.r + 3.5) + ',' + (box.t - 0.5 + clen) + 'h-3v' + -clen + 'h' + -clen + 'v-3h' + (clen + 3) + 'ZM' + (box.r + 3.5) + ',' + (box.b + 0.5 - clen) + 'h-3v' + clen + 'h' + -clen + 'v3h' + (clen + 3) + 'ZM' + (box.l - 3.5) + ',' + (box.b + 0.5 - clen) + 'h3v' + clen + 'h' + clen + 'v3h-' + (clen + 3) + 'Z';
}
function calcLinks(gd, groups, xaHash, yaHash, exclude) {
  var isSubplotConstrained = false;
  var xLinks = {};
  var yLinks = {};
  var xID, yID, xLinkID, yLinkID;
  var xExclude = (exclude || {}).xaHash;
  var yExclude = (exclude || {}).yaHash;
  for (var i = 0; i < groups.length; i++) {
    var group = groups[i];
    // check if any of the x axes we're dragging is in this constraint group
    for (xID in xaHash) {
      if (group[xID]) {
        // put the rest of these axes into xLinks, if we're not already
        // dragging them, so we know to scale these axes automatically too
        // to match the changes in the dragged x axes
        for (xLinkID in group) {
          if (!(exclude && (xExclude[xLinkID] || yExclude[xLinkID])) && !(xLinkID.charAt(0) === 'x' ? xaHash : yaHash)[xLinkID]) {
            xLinks[xLinkID] = xID;
          }
        }

        // check if the x and y axes of THIS drag are linked
        for (yID in yaHash) {
          if (!(exclude && (xExclude[yID] || yExclude[yID])) && group[yID]) {
            isSubplotConstrained = true;
          }
        }
      }
    }

    // now check if any of the y axes we're dragging is in this constraint group
    // only look for outside links, as we've already checked for links within the dragger
    for (yID in yaHash) {
      if (group[yID]) {
        for (yLinkID in group) {
          if (!(exclude && (xExclude[yLinkID] || yExclude[yLinkID])) && !(yLinkID.charAt(0) === 'x' ? xaHash : yaHash)[yLinkID]) {
            yLinks[yLinkID] = yID;
          }
        }
      }
    }
  }
  if (isSubplotConstrained) {
    // merge xLinks and yLinks if the subplot is constrained,
    // since we'll always apply both anyway and the two will contain
    // duplicates
    Lib.extendFlat(xLinks, yLinks);
    yLinks = {};
  }
  var xaHashLinked = {};
  var xaxesLinked = [];
  for (xLinkID in xLinks) {
    var xa = getFromId(gd, xLinkID);
    xaxesLinked.push(xa);
    xaHashLinked[xa._id] = xa;
  }
  var yaHashLinked = {};
  var yaxesLinked = [];
  for (yLinkID in yLinks) {
    var ya = getFromId(gd, yLinkID);
    yaxesLinked.push(ya);
    yaHashLinked[ya._id] = ya;
  }
  return {
    xaHash: xaHashLinked,
    yaHash: yaHashLinked,
    xaxes: xaxesLinked,
    yaxes: yaxesLinked,
    xLinks: xLinks,
    yLinks: yLinks,
    isSubplotConstrained: isSubplotConstrained
  };
}

// still seems to be some confusion about onwheel vs onmousewheel...
function attachWheelEventHandler(element, handler) {
  if (!supportsPassive) {
    if (element.onwheel !== undefined) element.onwheel = handler;else if (element.onmousewheel !== undefined) element.onmousewheel = handler;else if (!element.isAddedWheelEvent) {
      element.isAddedWheelEvent = true;
      element.addEventListener('wheel', handler, {
        passive: false
      });
    }
  } else {
    var wheelEventName = element.onwheel !== undefined ? 'wheel' : 'mousewheel';
    if (element._onwheel) {
      element.removeEventListener(wheelEventName, element._onwheel);
    }
    element._onwheel = handler;
    element.addEventListener(wheelEventName, handler, {
      passive: false
    });
  }
}
function hashValues(hash) {
  var out = [];
  for (var k in hash) out.push(hash[k]);
  return out;
}
module.exports = {
  makeDragBox: makeDragBox,
  makeDragger: makeDragger,
  makeRectDragger: makeRectDragger,
  makeZoombox: makeZoombox,
  makeCorners: makeCorners,
  updateZoombox: updateZoombox,
  xyCorners: xyCorners,
  transitionZoombox: transitionZoombox,
  removeZoombox: removeZoombox,
  showDoubleClickNotifier: showDoubleClickNotifier,
  attachWheelEventHandler: attachWheelEventHandler
};

/***/ }),

/***/ 95284:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var Fx = __webpack_require__(32141);
var dragElement = __webpack_require__(14751);
var setCursor = __webpack_require__(27983);
var makeDragBox = (__webpack_require__(51680).makeDragBox);
var DRAGGERSIZE = (__webpack_require__(54826).DRAGGERSIZE);
exports.initInteractions = function initInteractions(gd) {
  var fullLayout = gd._fullLayout;
  if (gd._context.staticPlot) {
    // this sweeps up more than just cartesian drag elements...
    d3.select(gd).selectAll('.drag').remove();
    return;
  }
  if (!fullLayout._has('cartesian') && !fullLayout._has('splom')) return;
  var subplots = Object.keys(fullLayout._plots || {}).sort(function (a, b) {
    // sort overlays last, then by x axis number, then y axis number
    if ((fullLayout._plots[a].mainplot && true) === (fullLayout._plots[b].mainplot && true)) {
      var aParts = a.split('y');
      var bParts = b.split('y');
      return aParts[0] === bParts[0] ? Number(aParts[1] || 1) - Number(bParts[1] || 1) : Number(aParts[0] || 1) - Number(bParts[0] || 1);
    }
    return fullLayout._plots[a].mainplot ? 1 : -1;
  });
  subplots.forEach(function (subplot) {
    var plotinfo = fullLayout._plots[subplot];
    var xa = plotinfo.xaxis;
    var ya = plotinfo.yaxis;

    // main and corner draggers need not be repeated for
    // overlaid subplots - these draggers drag them all
    if (!plotinfo.mainplot) {
      // main dragger goes over the grids and data, so we use its
      // mousemove events for all data hover effects
      var maindrag = makeDragBox(gd, plotinfo, xa._offset, ya._offset, xa._length, ya._length, 'ns', 'ew');
      maindrag.onmousemove = function (evt) {
        // This is on `gd._fullLayout`, *not* fullLayout because the reference
        // changes by the time this is called again.
        gd._fullLayout._rehover = function () {
          if (gd._fullLayout._hoversubplot === subplot && gd._fullLayout._plots[subplot]) {
            Fx.hover(gd, evt, subplot);
          }
        };
        Fx.hover(gd, evt, subplot);

        // Note that we have *not* used the cached fullLayout variable here
        // since that may be outdated when this is called as a callback later on
        gd._fullLayout._lasthover = maindrag;
        gd._fullLayout._hoversubplot = subplot;
      };

      /*
       * IMPORTANT:
       * We must check for the presence of the drag cover here.
       * If we don't, a 'mouseout' event is triggered on the
       * maindrag before each 'click' event, which has the effect
       * of clearing the hoverdata; thus, cancelling the click event.
       */
      maindrag.onmouseout = function (evt) {
        if (gd._dragging) return;

        // When the mouse leaves this maindrag, unset the hovered subplot.
        // This may cause problems if it leaves the subplot directly *onto*
        // another subplot, but that's a tiny corner case at the moment.
        gd._fullLayout._hoversubplot = null;
        dragElement.unhover(gd, evt);
      };

      // corner draggers
      if (gd._context.showAxisDragHandles) {
        makeDragBox(gd, plotinfo, xa._offset - DRAGGERSIZE, ya._offset - DRAGGERSIZE, DRAGGERSIZE, DRAGGERSIZE, 'n', 'w');
        makeDragBox(gd, plotinfo, xa._offset + xa._length, ya._offset - DRAGGERSIZE, DRAGGERSIZE, DRAGGERSIZE, 'n', 'e');
        makeDragBox(gd, plotinfo, xa._offset - DRAGGERSIZE, ya._offset + ya._length, DRAGGERSIZE, DRAGGERSIZE, 's', 'w');
        makeDragBox(gd, plotinfo, xa._offset + xa._length, ya._offset + ya._length, DRAGGERSIZE, DRAGGERSIZE, 's', 'e');
      }
    }
    if (gd._context.showAxisDragHandles) {
      // x axis draggers - if you have overlaid plots,
      // these drag each axis separately
      if (subplot === xa._mainSubplot) {
        // the y position of the main x axis line
        var y0 = xa._mainLinePosition;
        if (xa.side === 'top') y0 -= DRAGGERSIZE;
        makeDragBox(gd, plotinfo, xa._offset + xa._length * 0.1, y0, xa._length * 0.8, DRAGGERSIZE, '', 'ew');
        makeDragBox(gd, plotinfo, xa._offset, y0, xa._length * 0.1, DRAGGERSIZE, '', 'w');
        makeDragBox(gd, plotinfo, xa._offset + xa._length * 0.9, y0, xa._length * 0.1, DRAGGERSIZE, '', 'e');
      }
      // y axis draggers
      if (subplot === ya._mainSubplot) {
        // the x position of the main y axis line
        var x0 = ya._mainLinePosition;
        if (ya.side !== 'right') x0 -= DRAGGERSIZE;
        makeDragBox(gd, plotinfo, x0, ya._offset + ya._length * 0.1, DRAGGERSIZE, ya._length * 0.8, 'ns', '');
        makeDragBox(gd, plotinfo, x0, ya._offset + ya._length * 0.9, DRAGGERSIZE, ya._length * 0.1, 's', '');
        makeDragBox(gd, plotinfo, x0, ya._offset, DRAGGERSIZE, ya._length * 0.1, 'n', '');
      }
    }
  });

  // In case you mousemove over some hovertext, send it to Fx.hover too
  // we do this so that we can put the hover text in front of everything,
  // but still be able to interact with everything as if it isn't there
  var hoverLayer = fullLayout._hoverlayer.node();
  hoverLayer.onmousemove = function (evt) {
    evt.target = gd._fullLayout._lasthover;
    Fx.hover(gd, evt, fullLayout._hoversubplot);
  };
  hoverLayer.onclick = function (evt) {
    evt.target = gd._fullLayout._lasthover;
    Fx.click(gd, evt);
  };

  // also delegate mousedowns... TODO: does this actually work?
  hoverLayer.onmousedown = function (evt) {
    gd._fullLayout._lasthover.onmousedown(evt);
  };
  exports.updateFx(gd);
};

// Minimal set of update needed on 'modebar' edits.
// We only need to update the <g .draglayer> cursor style.
//
// Note that changing the axis configuration and/or the fixedrange attribute
// should trigger a full initInteractions.
exports.updateFx = function (gd) {
  var fullLayout = gd._fullLayout;
  var cursor = fullLayout.dragmode === 'pan' ? 'move' : 'crosshair';
  setCursor(fullLayout._draggers, cursor);
};

/***/ }),

/***/ 20706:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Registry = __webpack_require__(33626);
var Lib = __webpack_require__(34809);
var axisIds = __webpack_require__(5975);

/**
 * Factory function for checking component arrays for subplot references.
 *
 * @param {string} containerArrayName: the top-level array in gd.layout to check
 *   If an item in this container is found that references a cartesian x and/or y axis,
 *   ensure cartesian is marked as a base plot module and record the axes (and subplot
 *   if both refs are axes) in gd._fullLayout
 *
 * @return {function}: with args layoutIn (gd.layout) and layoutOut (gd._fullLayout)
 * as expected of a component includeBasePlot method
 */
module.exports = function makeIncludeComponents(containerArrayName) {
  return function includeComponents(layoutIn, layoutOut) {
    var array = layoutIn[containerArrayName];
    if (!Array.isArray(array)) return;
    var Cartesian = Registry.subplotsRegistry.cartesian;
    var idRegex = Cartesian.idRegex;
    var subplots = layoutOut._subplots;
    var xaList = subplots.xaxis;
    var yaList = subplots.yaxis;
    var cartesianList = subplots.cartesian;
    var hasCartesianOrGL2D = layoutOut._has('cartesian') || layoutOut._has('gl2d');
    for (var i = 0; i < array.length; i++) {
      var itemi = array[i];
      if (!Lib.isPlainObject(itemi)) continue;

      // call cleanId because if xref, or yref has something appended
      // (e.g., ' domain') this will get removed.
      var xref = axisIds.cleanId(itemi.xref, 'x', false);
      var yref = axisIds.cleanId(itemi.yref, 'y', false);
      var hasXref = idRegex.x.test(xref);
      var hasYref = idRegex.y.test(yref);
      if (hasXref || hasYref) {
        if (!hasCartesianOrGL2D) Lib.pushUnique(layoutOut._basePlotModules, Cartesian);
        var newAxis = false;
        if (hasXref && xaList.indexOf(xref) === -1) {
          xaList.push(xref);
          newAxis = true;
        }
        if (hasYref && yaList.indexOf(yref) === -1) {
          yaList.push(yref);
          newAxis = true;
        }

        /*
         * Notice the logic here: only add a subplot for a component if
         * it's referencing both x and y axes AND it's creating a new axis
         * so for example if your plot already has xy and x2y2, an annotation
         * on x2y or xy2 will not create a new subplot.
         */
        if (newAxis && hasXref && hasYref) {
          cartesianList.push(xref + yref);
        }
      }
    }
  };
};

/***/ }),

/***/ 37703:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var Registry = __webpack_require__(33626);
var Lib = __webpack_require__(34809);
var Plots = __webpack_require__(44122);
var Drawing = __webpack_require__(62203);
var getModuleCalcData = (__webpack_require__(4173)/* .getModuleCalcData */ .eV);
var axisIds = __webpack_require__(5975);
var constants = __webpack_require__(54826);
var xmlnsNamespaces = __webpack_require__(62972);
var ensureSingle = Lib.ensureSingle;
function ensureSingleAndAddDatum(parent, nodeType, className) {
  return Lib.ensureSingle(parent, nodeType, className, function (s) {
    s.datum(className);
  });
}
var zindexSeparator = constants.zindexSeparator;
exports.name = 'cartesian';
exports.attr = ['xaxis', 'yaxis'];
exports.idRoot = ['x', 'y'];
exports.idRegex = constants.idRegex;
exports.attrRegex = constants.attrRegex;
exports.attributes = __webpack_require__(55126);
exports.layoutAttributes = __webpack_require__(25829);
exports.supplyLayoutDefaults = __webpack_require__(74098);
exports.transitionAxes = __webpack_require__(84982);
exports.finalizeSubplots = function (layoutIn, layoutOut) {
  var subplots = layoutOut._subplots;
  var xList = subplots.xaxis;
  var yList = subplots.yaxis;
  var spSVG = subplots.cartesian;
  var spAll = spSVG.concat(subplots.gl2d || []);
  var allX = {};
  var allY = {};
  var i, xi, yi;
  for (i = 0; i < spAll.length; i++) {
    var parts = spAll[i].split('y');
    allX[parts[0]] = 1;
    allY['y' + parts[1]] = 1;
  }

  // check for x axes with no subplot, and make one from the anchor of that x axis
  for (i = 0; i < xList.length; i++) {
    xi = xList[i];
    if (!allX[xi]) {
      yi = (layoutIn[axisIds.id2name(xi)] || {}).anchor;
      if (!constants.idRegex.y.test(yi)) yi = 'y';
      spSVG.push(xi + yi);
      spAll.push(xi + yi);
      if (!allY[yi]) {
        allY[yi] = 1;
        Lib.pushUnique(yList, yi);
      }
    }
  }

  // same for y axes with no subplot
  for (i = 0; i < yList.length; i++) {
    yi = yList[i];
    if (!allY[yi]) {
      xi = (layoutIn[axisIds.id2name(yi)] || {}).anchor;
      if (!constants.idRegex.x.test(xi)) xi = 'x';
      spSVG.push(xi + yi);
      spAll.push(xi + yi);
      if (!allX[xi]) {
        allX[xi] = 1;
        Lib.pushUnique(xList, xi);
      }
    }
  }

  // finally, if we've gotten here we're supposed to show cartesian...
  // so if there are NO subplots at all, make one from the first
  // x & y axes in the input layout
  if (!spAll.length) {
    xi = '';
    yi = '';
    for (var ki in layoutIn) {
      if (constants.attrRegex.test(ki)) {
        var axLetter = ki.charAt(0);
        if (axLetter === 'x') {
          if (!xi || +ki.substr(5) < +xi.substr(5)) {
            xi = ki;
          }
        } else if (!yi || +ki.substr(5) < +yi.substr(5)) {
          yi = ki;
        }
      }
    }
    xi = xi ? axisIds.name2id(xi) : 'x';
    yi = yi ? axisIds.name2id(yi) : 'y';
    xList.push(xi);
    yList.push(yi);
    spSVG.push(xi + yi);
  }
};

/**
 * Cartesian.plot
 *
 * @param {DOM div | object} gd
 * @param {array (optional)} traces
 *  array of traces indices to plot
 *  if undefined, plots all cartesian traces,
 * @param {object} (optional) transitionOpts
 *  transition option object
 * @param {function} (optional) makeOnCompleteCallback
 *  transition make callback function from Plots.transition
 */
exports.plot = function (gd, traces, transitionOpts, makeOnCompleteCallback) {
  var fullLayout = gd._fullLayout;
  var subplots = fullLayout._subplots.cartesian;
  var calcdata = gd.calcdata;
  var i;

  // Traces is a list of trace indices to (re)plot. If it's not provided,
  // then it's a complete replot so we create a new list and add all trace indices
  // which are in calcdata.

  if (!Array.isArray(traces)) {
    // If traces is not provided, then it's a complete replot and missing
    // traces are removed
    traces = [];
    for (i = 0; i < calcdata.length; i++) traces.push(i);
  }
  var zindices = fullLayout._zindices;
  // Plot each zorder group in ascending order
  for (var z = 0; z < zindices.length; z++) {
    var zorder = zindices[z];

    // For each subplot
    for (i = 0; i < subplots.length; i++) {
      var subplot = subplots[i];
      var subplotInfo = fullLayout._plots[subplot];
      if (z > 0) {
        var idWithZ = subplotInfo.id;
        if (idWithZ.indexOf(zindexSeparator) !== -1) continue;
        idWithZ += zindexSeparator + (z + 1);
        subplotInfo = Lib.extendFlat({}, subplotInfo, {
          id: idWithZ,
          plot: fullLayout._cartesianlayer.selectAll('.subplot').select('.' + idWithZ)
        });
      }

      // Get all calcdata (traces) for this subplot:
      var cdSubplot = [];
      var pcd;

      // For each trace
      for (var j = 0; j < calcdata.length; j++) {
        var cd = calcdata[j];
        var trace = cd[0].trace;
        if (zorder !== (trace.zorder || 0)) continue;

        // Skip trace if whitelist provided and it's not whitelisted:
        // if (Array.isArray(traces) && traces.indexOf(i) === -1) continue;
        if (trace.xaxis + trace.yaxis === subplot) {
          // XXX: Should trace carpet dependencies. Only replot all carpet plots if the carpet
          // axis has actually changed:
          //
          // If this trace is specifically requested, add it to the list:
          if (traces.indexOf(trace.index) !== -1 || trace.carpet) {
            // Okay, so example: traces 0, 1, and 2 have fill = tonext. You animate
            // traces 0 and 2. Trace 1 also needs to be updated, otherwise its fill
            // is outdated. So this retroactively adds the previous trace if the
            // traces are interdependent.
            if (pcd && pcd[0].trace.xaxis + pcd[0].trace.yaxis === subplot && ['tonextx', 'tonexty', 'tonext'].indexOf(trace.fill) !== -1 && cdSubplot.indexOf(pcd) === -1) {
              cdSubplot.push(pcd);
            }
            cdSubplot.push(cd);
          }

          // Track the previous trace on this subplot for the retroactive-add step
          // above:
          pcd = cd;
        }
      }
      // Plot the traces for this subplot
      plotOne(gd, subplotInfo, cdSubplot, transitionOpts, makeOnCompleteCallback);
    }
  }
};
function plotOne(gd, plotinfo, cdSubplot, transitionOpts, makeOnCompleteCallback) {
  var traceLayerClasses = constants.traceLayerClasses;
  var fullLayout = gd._fullLayout;
  var zindices = fullLayout._zindices;
  var modules = fullLayout._modules;
  var _module, cdModuleAndOthers, cdModule;
  var layerData = [];
  var zoomScaleQueryParts = [];

  // Plot each zorder group in ascending order
  for (var z = 0; z < zindices.length; z++) {
    var zorder = zindices[z];
    // For each "module" (trace type)
    for (var i = 0; i < modules.length; i++) {
      _module = modules[i];
      var name = _module.name;
      var categories = Registry.modules[name].categories;
      if (categories.svg) {
        var classBaseName = _module.layerName || name + 'layer';
        var className = classBaseName + (z ? Number(z) + 1 : '');
        var plotMethod = _module.plot;

        // plot all visible traces of this type on this subplot at once
        cdModuleAndOthers = getModuleCalcData(cdSubplot, plotMethod, zorder);
        cdModule = cdModuleAndOthers[0];
        // don't need to search the found traces again - in fact we need to NOT
        // so that if two modules share the same plotter we don't double-plot
        cdSubplot = cdModuleAndOthers[1];
        if (cdModule.length) {
          layerData.push({
            i: traceLayerClasses.indexOf(classBaseName),
            zindex: z,
            className: className,
            plotMethod: plotMethod,
            cdModule: cdModule
          });
        }
        if (categories.zoomScale) {
          zoomScaleQueryParts.push('.' + className);
        }
      }
    }
  }
  // Sort the layers primarily by zindex, then by i
  layerData.sort(function (a, b) {
    return (a.zindex || 0) - (b.zindex || 0) || a.i - b.i;
  });
  var layers = plotinfo.plot.selectAll('g.mlayer').data(layerData, function (d) {
    return d.className;
  });
  layers.enter().append('g').attr('class', function (d) {
    return d.className;
  }).classed('mlayer', true).classed('rangeplot', plotinfo.isRangePlot);
  layers.exit().remove();
  layers.order();
  layers.each(function (d) {
    var sel = d3.select(this);
    var className = d.className;
    d.plotMethod(gd, plotinfo, d.cdModule, sel, transitionOpts, makeOnCompleteCallback);

    // layers that allow `cliponaxis: false`
    if (constants.clipOnAxisFalseQuery.indexOf('.' + className) === -1) {
      Drawing.setClipUrl(sel, plotinfo.layerClipId, gd);
    }
  });

  // call Scattergl.plot separately
  if (fullLayout._has('scattergl')) {
    _module = Registry.getModule('scattergl');
    cdModule = getModuleCalcData(cdSubplot, _module)[0];
    _module.plot(gd, plotinfo, cdModule);
  }

  // stash "hot" selections for faster interaction on drag and scroll
  if (!gd._context.staticPlot) {
    if (plotinfo._hasClipOnAxisFalse) {
      plotinfo.clipOnAxisFalseTraces = plotinfo.plot.selectAll(constants.clipOnAxisFalseQuery.join(',')).selectAll('.trace');
    }
    if (zoomScaleQueryParts.length) {
      var traces = plotinfo.plot.selectAll(zoomScaleQueryParts.join(',')).selectAll('.trace');
      plotinfo.zoomScalePts = traces.selectAll('path.point');
      plotinfo.zoomScaleTxt = traces.selectAll('.textpoint');
    }
  }
}
exports.clean = function (newFullData, newFullLayout, oldFullData, oldFullLayout) {
  var oldPlots = oldFullLayout._plots || {};
  var newPlots = newFullLayout._plots || {};
  var oldSubplotList = oldFullLayout._subplots || {};
  var plotinfo;
  var i, k;

  // when going from a large splom graph to something else,
  // we need to clear <g subplot> so that the new cartesian subplot
  // can have the correct layer ordering
  if (oldFullLayout._hasOnlyLargeSploms && !newFullLayout._hasOnlyLargeSploms) {
    for (k in oldPlots) {
      plotinfo = oldPlots[k];
      if (plotinfo.plotgroup) plotinfo.plotgroup.remove();
    }
  }
  var hadGl = oldFullLayout._has && oldFullLayout._has('gl');
  var hasGl = newFullLayout._has && newFullLayout._has('gl');
  if (hadGl && !hasGl) {
    for (k in oldPlots) {
      plotinfo = oldPlots[k];
      if (plotinfo._scene) plotinfo._scene.destroy();
    }
  }

  // delete any titles we don't need anymore
  // check if axis list has changed, and if so clear old titles
  if (oldSubplotList.xaxis && oldSubplotList.yaxis) {
    var oldAxIDs = axisIds.listIds({
      _fullLayout: oldFullLayout
    });
    for (i = 0; i < oldAxIDs.length; i++) {
      var oldAxId = oldAxIDs[i];
      if (!newFullLayout[axisIds.id2name(oldAxId)]) {
        oldFullLayout._infolayer.selectAll('.g-' + oldAxId + 'title').remove();
      }
    }
  }
  var hadCartesian = oldFullLayout._has && oldFullLayout._has('cartesian');
  var hasCartesian = newFullLayout._has && newFullLayout._has('cartesian');
  if (hadCartesian && !hasCartesian) {
    // if we've gotten rid of all cartesian traces, remove all the subplot svg items

    purgeSubplotLayers(oldFullLayout._cartesianlayer.selectAll('.subplot'), oldFullLayout);
    oldFullLayout._defs.selectAll('.axesclip').remove();
    delete oldFullLayout._axisConstraintGroups;
    delete oldFullLayout._axisMatchGroups;
  } else if (oldSubplotList.cartesian) {
    // otherwise look for subplots we need to remove

    for (i = 0; i < oldSubplotList.cartesian.length; i++) {
      var oldSubplotId = oldSubplotList.cartesian[i];

      // skip zindex layes in this process
      if (oldSubplotId.indexOf(zindexSeparator) !== -1) continue;
      if (!newPlots[oldSubplotId]) {
        var selector = '.' + oldSubplotId + ',.' + oldSubplotId + '-x,.' + oldSubplotId + '-y';
        oldFullLayout._cartesianlayer.selectAll(selector).remove();
        removeSubplotExtras(oldSubplotId, oldFullLayout);
      }
    }
  }
};
exports.drawFramework = function (gd) {
  var fullLayout = gd._fullLayout;
  var calcdata = gd.calcdata;
  var i;

  // Separate traces by zorder and plot each zorder group separately
  var traceZorderGroups = {};
  for (i = 0; i < calcdata.length; i++) {
    var cdi = calcdata[i][0];
    var trace = cdi.trace;
    var zi = trace.zorder || 0;
    if (!traceZorderGroups[zi]) traceZorderGroups[zi] = [];
    traceZorderGroups[zi].push(cdi);
  }

  // Group by zorder group in ascending order
  var zindices = Object.keys(traceZorderGroups).map(Number).sort(Lib.sorterAsc);
  if (!zindices.length) zindices = [0];
  fullLayout._zindices = zindices;
  var initialSubplotData = makeSubplotData(gd);
  var len = initialSubplotData.length;
  var subplotData = [];
  for (i = 0; i < len; i++) {
    subplotData[i] = initialSubplotData[i].slice();
  }
  for (var z = 1; z < zindices.length; z++) {
    var newSubplotData = [];
    for (i = 0; i < len; i++) {
      newSubplotData[i] = initialSubplotData[i].slice();
      newSubplotData[i][0] += zindexSeparator + (z + 1);
    }
    subplotData = subplotData.concat(newSubplotData);
  }
  var subplotLayers = fullLayout._cartesianlayer.selectAll('.subplot').data(subplotData, String);
  subplotLayers.enter().append('g').attr('class', function (d) {
    return 'subplot ' + d[0];
  });
  subplotLayers.order();
  subplotLayers.exit().call(purgeSubplotLayers, fullLayout);
  subplotLayers.each(function (d) {
    var id = d[0];
    var posZ = id.indexOf(zindexSeparator);
    var hasZ = posZ !== -1;
    var idWithoutZ = hasZ ? id.slice(0, posZ) : id;
    var plotinfo = fullLayout._plots[id];
    if (!plotinfo) {
      plotinfo = Lib.extendFlat({}, fullLayout._plots[idWithoutZ]);
      if (plotinfo) {
        plotinfo.id = id;
        fullLayout._plots[id] = plotinfo;
        fullLayout._subplots.cartesian.push(id);
      }
    }
    if (plotinfo) {
      plotinfo.plotgroup = d3.select(this);
      makeSubplotLayer(gd, plotinfo);
      if (!hasZ) {
        // make separate drag layers for each subplot,
        // but append them to paper rather than the plot groups,
        // so they end up on top of the rest
        plotinfo.draglayer = ensureSingle(fullLayout._draggers, 'g', id);
      }
    }
  });
};
exports.rangePlot = function (gd, plotinfo, cdSubplot) {
  makeSubplotLayer(gd, plotinfo);
  plotOne(gd, plotinfo, cdSubplot);
  Plots.style(gd);
};
function makeSubplotData(gd) {
  var fullLayout = gd._fullLayout;
  var numZ = fullLayout._zindices.length;
  var ids = fullLayout._subplots.cartesian;
  var len = ids.length;
  var i, j, id, plotinfo, xa, ya;

  // split 'regular' and 'overlaying' subplots
  var regulars = [];
  var overlays = [];
  for (i = 0; i < len; i++) {
    id = ids[i];
    plotinfo = fullLayout._plots[id];
    xa = plotinfo.xaxis;
    ya = plotinfo.yaxis;
    var xa2 = xa._mainAxis;
    var ya2 = ya._mainAxis;
    var mainplot = xa2._id + ya2._id;
    var mainplotinfo = fullLayout._plots[mainplot];
    plotinfo.overlays = [];
    if (mainplot !== id && mainplotinfo) {
      plotinfo.mainplot = mainplot;
      plotinfo.mainplotinfo = mainplotinfo;
      overlays.push(id);
    } else {
      plotinfo.mainplot = undefined;
      plotinfo.mainplotinfo = undefined;
      regulars.push(id);
    }
  }

  // fill in list of overlaying subplots in 'main plot'
  for (i = 0; i < overlays.length; i++) {
    id = overlays[i];
    plotinfo = fullLayout._plots[id];
    plotinfo.mainplotinfo.overlays.push(plotinfo);
  }

  // put 'regular' subplot data before 'overlaying'
  var subplotIds = regulars.concat(overlays);
  var subplotData = [];
  for (i = 0; i < len; i++) {
    id = subplotIds[i];
    plotinfo = fullLayout._plots[id];
    xa = plotinfo.xaxis;
    ya = plotinfo.yaxis;
    var d = [];
    for (var z = 1; z <= numZ; z++) {
      var zStr = '';
      if (z > 1) zStr += zindexSeparator + z;

      // use info about axis layer and overlaying pattern
      // to clean what need to be cleaned up in exit selection
      d.push(id + zStr);
      for (j = 0; j < plotinfo.overlays.length; j++) {
        d.push(plotinfo.overlays[j].id + zStr);
      }
    }
    d = d.concat([xa.layer, ya.layer, xa.overlaying || '', ya.overlaying || '']);
    subplotData.push(d);
  }
  return subplotData;
}
function makeSubplotLayer(gd, plotinfo) {
  var fullLayout = gd._fullLayout;
  var plotgroup = plotinfo.plotgroup;
  var id = plotinfo.id;
  var posZ = id.indexOf(zindexSeparator);
  var hasZ = posZ !== -1;
  var xLayer = constants.layerValue2layerClass[plotinfo.xaxis.layer];
  var yLayer = constants.layerValue2layerClass[plotinfo.yaxis.layer];
  var hasOnlyLargeSploms = fullLayout._hasOnlyLargeSploms;
  if (!plotinfo.mainplot || fullLayout._zindices.length > 1) {
    if (hasOnlyLargeSploms) {
      // TODO could do even better
      // - we don't need plot (but we would have to mock it in lsInner
      //   and other places
      // - we don't (x|y)lines and (x|y)axislayer for most subplots
      //   usually just the bottom x and left y axes.
      plotinfo.xlines = ensureSingle(plotgroup, 'path', 'xlines-above');
      plotinfo.ylines = ensureSingle(plotgroup, 'path', 'ylines-above');
      plotinfo.xaxislayer = ensureSingle(plotgroup, 'g', 'xaxislayer-above');
      plotinfo.yaxislayer = ensureSingle(plotgroup, 'g', 'yaxislayer-above');
    } else {
      if (!hasZ) {
        var backLayer = ensureSingle(plotgroup, 'g', 'layer-subplot');
        plotinfo.shapelayer = ensureSingle(backLayer, 'g', 'shapelayer');
        plotinfo.imagelayer = ensureSingle(backLayer, 'g', 'imagelayer');
        plotinfo.minorGridlayer = ensureSingle(plotgroup, 'g', 'minor-gridlayer');
        plotinfo.gridlayer = ensureSingle(plotgroup, 'g', 'gridlayer');
        plotinfo.zerolinelayer = ensureSingle(plotgroup, 'g', 'zerolinelayer');
        var betweenLayer = ensureSingle(plotgroup, 'g', 'layer-between');
        plotinfo.shapelayerBetween = ensureSingle(betweenLayer, 'g', 'shapelayer');
        plotinfo.imagelayerBetween = ensureSingle(betweenLayer, 'g', 'imagelayer');
        ensureSingle(plotgroup, 'path', 'xlines-below');
        ensureSingle(plotgroup, 'path', 'ylines-below');
        plotinfo.overlinesBelow = ensureSingle(plotgroup, 'g', 'overlines-below');
        ensureSingle(plotgroup, 'g', 'xaxislayer-below');
        ensureSingle(plotgroup, 'g', 'yaxislayer-below');
        plotinfo.overaxesBelow = ensureSingle(plotgroup, 'g', 'overaxes-below');
      }
      plotinfo.overplot = ensureSingle(plotgroup, 'g', 'overplot');
      plotinfo.plot = ensureSingle(plotinfo.overplot, 'g', id);
      if (!hasZ) {
        plotinfo.xlines = ensureSingle(plotgroup, 'path', 'xlines-above');
        plotinfo.ylines = ensureSingle(plotgroup, 'path', 'ylines-above');
        plotinfo.overlinesAbove = ensureSingle(plotgroup, 'g', 'overlines-above');
        ensureSingle(plotgroup, 'g', 'xaxislayer-above');
        ensureSingle(plotgroup, 'g', 'yaxislayer-above');
        plotinfo.overaxesAbove = ensureSingle(plotgroup, 'g', 'overaxes-above');

        // set refs to correct layers as determined by 'axis.layer'
        plotinfo.xlines = plotgroup.select('.xlines-' + xLayer);
        plotinfo.ylines = plotgroup.select('.ylines-' + yLayer);
        plotinfo.xaxislayer = plotgroup.select('.xaxislayer-' + xLayer);
        plotinfo.yaxislayer = plotgroup.select('.yaxislayer-' + yLayer);
      }
    }
  } else {
    var mainplotinfo = plotinfo.mainplotinfo;
    var mainplotgroup = mainplotinfo.plotgroup;
    var xId = id + '-x';
    var yId = id + '-y';

    // now make the components of overlaid subplots
    // overlays don't have backgrounds, and append all
    // their other components to the corresponding
    // extra groups of their main plots.

    plotinfo.minorGridlayer = mainplotinfo.minorGridlayer;
    plotinfo.gridlayer = mainplotinfo.gridlayer;
    plotinfo.zerolinelayer = mainplotinfo.zerolinelayer;
    ensureSingle(mainplotinfo.overlinesBelow, 'path', xId);
    ensureSingle(mainplotinfo.overlinesBelow, 'path', yId);
    ensureSingle(mainplotinfo.overaxesBelow, 'g', xId);
    ensureSingle(mainplotinfo.overaxesBelow, 'g', yId);
    plotinfo.plot = ensureSingle(mainplotinfo.overplot, 'g', id);
    ensureSingle(mainplotinfo.overlinesAbove, 'path', xId);
    ensureSingle(mainplotinfo.overlinesAbove, 'path', yId);
    ensureSingle(mainplotinfo.overaxesAbove, 'g', xId);
    ensureSingle(mainplotinfo.overaxesAbove, 'g', yId);

    // set refs to correct layers as determined by 'abovetraces'
    plotinfo.xlines = mainplotgroup.select('.overlines-' + xLayer).select('.' + xId);
    plotinfo.ylines = mainplotgroup.select('.overlines-' + yLayer).select('.' + yId);
    plotinfo.xaxislayer = mainplotgroup.select('.overaxes-' + xLayer).select('.' + xId);
    plotinfo.yaxislayer = mainplotgroup.select('.overaxes-' + yLayer).select('.' + yId);
  }
  if (!hasZ) {
    // common attributes for all subplots, overlays or not

    if (!hasOnlyLargeSploms) {
      ensureSingleAndAddDatum(plotinfo.minorGridlayer, 'g', plotinfo.xaxis._id);
      ensureSingleAndAddDatum(plotinfo.minorGridlayer, 'g', plotinfo.yaxis._id);
      plotinfo.minorGridlayer.selectAll('g').map(function (d) {
        return d[0];
      }).sort(axisIds.idSort);
      ensureSingleAndAddDatum(plotinfo.gridlayer, 'g', plotinfo.xaxis._id);
      ensureSingleAndAddDatum(plotinfo.gridlayer, 'g', plotinfo.yaxis._id);
      plotinfo.gridlayer.selectAll('g').map(function (d) {
        return d[0];
      }).sort(axisIds.idSort);
    }
    plotinfo.xlines.style('fill', 'none').classed('crisp', true);
    plotinfo.ylines.style('fill', 'none').classed('crisp', true);
  }
}
function purgeSubplotLayers(layers, fullLayout) {
  if (!layers) return;
  var overlayIdsToRemove = {};
  layers.each(function (d) {
    var id = d[0];
    var plotgroup = d3.select(this);
    plotgroup.remove();
    removeSubplotExtras(id, fullLayout);
    overlayIdsToRemove[id] = true;

    // do not remove individual axis <clipPath>s here
    // as other subplots may need them
  });

  // must remove overlaid subplot trace layers 'manually'

  for (var k in fullLayout._plots) {
    var subplotInfo = fullLayout._plots[k];
    var overlays = subplotInfo.overlays || [];
    for (var j = 0; j < overlays.length; j++) {
      var overlayInfo = overlays[j];
      if (overlayIdsToRemove[overlayInfo.id]) {
        overlayInfo.plot.selectAll('.trace').remove();
      }
    }
  }
}
function removeSubplotExtras(subplotId, fullLayout) {
  fullLayout._draggers.selectAll('g.' + subplotId).remove();
  fullLayout._defs.select('#clip' + fullLayout._uid + subplotId + 'plot').remove();
}
exports.toSVG = function (gd) {
  var imageRoot = gd._fullLayout._glimages;
  var root = d3.select(gd).selectAll('.svg-container');
  var canvases = root.filter(function (d, i) {
    return i === root.size() - 1;
  }).selectAll('.gl-canvas-context, .gl-canvas-focus');
  function canvasToImage() {
    var canvas = this;
    var imageData = canvas.toDataURL('image/png');
    var image = imageRoot.append('svg:image');
    image.attr({
      xmlns: xmlnsNamespaces.svg,
      'xlink:href': imageData,
      preserveAspectRatio: 'none',
      x: 0,
      y: 0,
      width: canvas.style.width,
      height: canvas.style.height
    });
  }
  canvases.each(canvasToImage);
};
exports.updateFx = __webpack_require__(95284).updateFx;

/***/ }),

/***/ 25829:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var fontAttrs = __webpack_require__(80337);
var colorAttrs = __webpack_require__(10229);
var dash = (__webpack_require__(94850)/* .dash */ .T);
var extendFlat = (__webpack_require__(93049).extendFlat);
var templatedArray = (__webpack_require__(78032).templatedArray);
var descriptionWithDates = (__webpack_require__(80712).descriptionWithDates);
var ONEDAY = (__webpack_require__(63821).ONEDAY);
var constants = __webpack_require__(54826);
var HOUR = constants.HOUR_PATTERN;
var DAY_OF_WEEK = constants.WEEKDAY_PATTERN;
var minorTickmode = {
  valType: 'enumerated',
  values: ['auto', 'linear', 'array'],
  editType: 'ticks',
  impliedEdits: {
    tick0: undefined,
    dtick: undefined
  }
};
var tickmode = extendFlat({}, minorTickmode, {
  values: minorTickmode.values.slice().concat(['sync'])
});
function makeNticks(minor) {
  return {
    valType: 'integer',
    min: 0,
    dflt: minor ? 5 : 0,
    editType: 'ticks'
  };
}
var tick0 = {
  valType: 'any',
  editType: 'ticks',
  impliedEdits: {
    tickmode: 'linear'
  }
};
var dtick = {
  valType: 'any',
  editType: 'ticks',
  impliedEdits: {
    tickmode: 'linear'
  }
};
var tickvals = {
  valType: 'data_array',
  editType: 'ticks'
};
var ticks = {
  valType: 'enumerated',
  values: ['outside', 'inside', ''],
  editType: 'ticks'
};
function makeTicklen(minor) {
  var obj = {
    valType: 'number',
    min: 0,
    editType: 'ticks'
  };
  if (!minor) obj.dflt = 5;
  return obj;
}
function makeTickwidth(minor) {
  var obj = {
    valType: 'number',
    min: 0,
    editType: 'ticks'
  };
  if (!minor) obj.dflt = 1;
  return obj;
}
var tickcolor = {
  valType: 'color',
  dflt: colorAttrs.defaultLine,
  editType: 'ticks'
};
var gridcolor = {
  valType: 'color',
  dflt: colorAttrs.lightLine,
  editType: 'ticks'
};
function makeGridwidth(minor) {
  var obj = {
    valType: 'number',
    min: 0,
    editType: 'ticks'
  };
  if (!minor) obj.dflt = 1;
  return obj;
}
var griddash = extendFlat({}, dash, {
  editType: 'ticks'
});
var showgrid = {
  valType: 'boolean',
  editType: 'ticks'
};
module.exports = {
  visible: {
    valType: 'boolean',
    editType: 'plot'
  },
  color: {
    valType: 'color',
    dflt: colorAttrs.defaultLine,
    editType: 'ticks'
  },
  title: {
    text: {
      valType: 'string',
      editType: 'ticks'
    },
    font: fontAttrs({
      editType: 'ticks'
    }),
    standoff: {
      valType: 'number',
      min: 0,
      editType: 'ticks'
    },
    editType: 'ticks'
  },
  type: {
    valType: 'enumerated',
    // '-' means we haven't yet run autotype or couldn't find any data
    // it gets turned into linear in gd._fullLayout but not copied back
    // to gd.data like the others are.
    values: ['-', 'linear', 'log', 'date', 'category', 'multicategory'],
    dflt: '-',
    editType: 'calc',
    // we forget when an axis has been autotyped, just writing the auto
    // value back to the input - so it doesn't make sense to template this.
    // Note: we do NOT prohibit this in `coerce`, so if someone enters a
    // type in the template explicitly it will be honored as the default.
    _noTemplating: true
  },
  autotypenumbers: {
    valType: 'enumerated',
    values: ['convert types', 'strict'],
    dflt: 'convert types',
    editType: 'calc'
  },
  autorange: {
    valType: 'enumerated',
    values: [true, false, 'reversed', 'min reversed', 'max reversed', 'min', 'max'],
    dflt: true,
    editType: 'axrange',
    impliedEdits: {
      'range[0]': undefined,
      'range[1]': undefined
    }
  },
  autorangeoptions: {
    minallowed: {
      valType: 'any',
      editType: 'plot',
      impliedEdits: {
        'range[0]': undefined,
        'range[1]': undefined
      }
    },
    maxallowed: {
      valType: 'any',
      editType: 'plot',
      impliedEdits: {
        'range[0]': undefined,
        'range[1]': undefined
      }
    },
    clipmin: {
      valType: 'any',
      editType: 'plot',
      impliedEdits: {
        'range[0]': undefined,
        'range[1]': undefined
      }
    },
    clipmax: {
      valType: 'any',
      editType: 'plot',
      impliedEdits: {
        'range[0]': undefined,
        'range[1]': undefined
      }
    },
    include: {
      valType: 'any',
      arrayOk: true,
      editType: 'plot',
      impliedEdits: {
        'range[0]': undefined,
        'range[1]': undefined
      }
    },
    editType: 'plot'
  },
  rangemode: {
    valType: 'enumerated',
    values: ['normal', 'tozero', 'nonnegative'],
    dflt: 'normal',
    editType: 'plot'
  },
  range: {
    valType: 'info_array',
    items: [{
      valType: 'any',
      editType: 'axrange',
      impliedEdits: {
        '^autorange': false
      },
      anim: true
    }, {
      valType: 'any',
      editType: 'axrange',
      impliedEdits: {
        '^autorange': false
      },
      anim: true
    }],
    editType: 'axrange',
    impliedEdits: {
      autorange: false
    },
    anim: true
  },
  minallowed: {
    valType: 'any',
    editType: 'plot',
    impliedEdits: {
      '^autorange': false
    }
  },
  maxallowed: {
    valType: 'any',
    editType: 'plot',
    impliedEdits: {
      '^autorange': false
    }
  },
  fixedrange: {
    valType: 'boolean',
    dflt: false,
    editType: 'calc'
  },
  insiderange: {
    valType: 'info_array',
    items: [{
      valType: 'any',
      editType: 'plot'
    }, {
      valType: 'any',
      editType: 'plot'
    }],
    editType: 'plot'
  },
  // scaleanchor: not used directly, just put here for reference
  // values are any opposite-letter axis id, or `false`.
  scaleanchor: {
    valType: 'enumerated',
    values: [constants.idRegex.x.toString(), constants.idRegex.y.toString(), false],
    editType: 'plot'
  },
  scaleratio: {
    valType: 'number',
    min: 0,
    dflt: 1,
    editType: 'plot'
  },
  constrain: {
    valType: 'enumerated',
    values: ['range', 'domain'],
    editType: 'plot'
  },
  // constraintoward: not used directly, just put here for reference
  constraintoward: {
    valType: 'enumerated',
    values: ['left', 'center', 'right', 'top', 'middle', 'bottom'],
    editType: 'plot'
  },
  matches: {
    valType: 'enumerated',
    values: [constants.idRegex.x.toString(), constants.idRegex.y.toString()],
    editType: 'calc'
  },
  rangebreaks: templatedArray('rangebreak', {
    enabled: {
      valType: 'boolean',
      dflt: true,
      editType: 'calc'
    },
    bounds: {
      valType: 'info_array',
      items: [{
        valType: 'any',
        editType: 'calc'
      }, {
        valType: 'any',
        editType: 'calc'
      }],
      editType: 'calc'
    },
    pattern: {
      valType: 'enumerated',
      values: [DAY_OF_WEEK, HOUR, ''],
      editType: 'calc'
    },
    values: {
      valType: 'info_array',
      freeLength: true,
      editType: 'calc',
      items: {
        valType: 'any',
        editType: 'calc'
      }
    },
    dvalue: {
      // TODO could become 'any' to add support for 'months', 'years'
      valType: 'number',
      editType: 'calc',
      min: 0,
      dflt: ONEDAY
    },
    /*
    gap: {
        valType: 'number',
        min: 0,
        dflt: 0, // for *date* axes, maybe something else for *linear*
        editType: 'calc',
    },
    gapmode: {
        valType: 'enumerated',
        values: ['pixels', 'fraction'],
        dflt: 'pixels',
        editType: 'calc',
    },
    */

    // To complete https://github.com/plotly/plotly.js/issues/4210
    // we additionally need `gap` and make this work on *linear*, and
    // possibly all other cartesian axis types. We possibly would also need
    // some style attributes controlling the zig-zag on the corresponding
    // axis.

    editType: 'calc'
  }),
  // ticks
  tickmode: tickmode,
  nticks: makeNticks(),
  tick0: tick0,
  dtick: dtick,
  ticklabelstep: {
    valType: 'integer',
    min: 1,
    dflt: 1,
    editType: 'ticks'
  },
  tickvals: tickvals,
  ticktext: {
    valType: 'data_array',
    editType: 'ticks'
  },
  ticks: ticks,
  tickson: {
    valType: 'enumerated',
    values: ['labels', 'boundaries'],
    dflt: 'labels',
    editType: 'ticks'
  },
  ticklabelmode: {
    valType: 'enumerated',
    values: ['instant', 'period'],
    dflt: 'instant',
    editType: 'ticks'
  },
  // ticklabelposition: not used directly, as values depend on direction (similar to side)
  // left/right options are for x axes, and top/bottom options are for y axes
  ticklabelposition: {
    valType: 'enumerated',
    values: ['outside', 'inside', 'outside top', 'inside top', 'outside left', 'inside left', 'outside right', 'inside right', 'outside bottom', 'inside bottom'],
    dflt: 'outside',
    editType: 'calc'
  },
  ticklabeloverflow: {
    valType: 'enumerated',
    values: ['allow', 'hide past div', 'hide past domain'],
    editType: 'calc'
  },
  ticklabelshift: {
    valType: 'integer',
    dflt: 0,
    editType: 'ticks'
  },
  ticklabelstandoff: {
    valType: 'integer',
    dflt: 0,
    editType: 'ticks'
  },
  ticklabelindex: {
    // in the future maybe add `extras: ['all', 'minor']` to allow showing labels for all ticks
    // or for all minor ticks.
    valType: 'integer',
    arrayOk: true,
    editType: 'calc'
  },
  mirror: {
    valType: 'enumerated',
    values: [true, 'ticks', false, 'all', 'allticks'],
    dflt: false,
    editType: 'ticks+layoutstyle'
  },
  ticklen: makeTicklen(),
  tickwidth: makeTickwidth(),
  tickcolor: tickcolor,
  showticklabels: {
    valType: 'boolean',
    dflt: true,
    editType: 'ticks'
  },
  labelalias: {
    valType: 'any',
    dflt: false,
    editType: 'ticks'
  },
  automargin: {
    valType: 'flaglist',
    flags: ['height', 'width', 'left', 'right', 'top', 'bottom'],
    extras: [true, false],
    dflt: false,
    editType: 'ticks'
  },
  showspikes: {
    valType: 'boolean',
    dflt: false,
    editType: 'modebar'
  },
  spikecolor: {
    valType: 'color',
    dflt: null,
    editType: 'none'
  },
  spikethickness: {
    valType: 'number',
    dflt: 3,
    editType: 'none'
  },
  spikedash: extendFlat({}, dash, {
    dflt: 'dash',
    editType: 'none'
  }),
  spikemode: {
    valType: 'flaglist',
    flags: ['toaxis', 'across', 'marker'],
    dflt: 'toaxis',
    editType: 'none'
  },
  spikesnap: {
    valType: 'enumerated',
    values: ['data', 'cursor', 'hovered data'],
    dflt: 'hovered data',
    editType: 'none'
  },
  tickfont: fontAttrs({
    editType: 'ticks'
  }),
  tickangle: {
    valType: 'angle',
    dflt: 'auto',
    editType: 'ticks'
  },
  autotickangles: {
    valType: 'info_array',
    freeLength: true,
    items: {
      valType: 'angle'
    },
    dflt: [0, 30, 90],
    editType: 'ticks'
  },
  tickprefix: {
    valType: 'string',
    dflt: '',
    editType: 'ticks'
  },
  showtickprefix: {
    valType: 'enumerated',
    values: ['all', 'first', 'last', 'none'],
    dflt: 'all',
    editType: 'ticks'
  },
  ticksuffix: {
    valType: 'string',
    dflt: '',
    editType: 'ticks'
  },
  showticksuffix: {
    valType: 'enumerated',
    values: ['all', 'first', 'last', 'none'],
    dflt: 'all',
    editType: 'ticks'
  },
  showexponent: {
    valType: 'enumerated',
    values: ['all', 'first', 'last', 'none'],
    dflt: 'all',
    editType: 'ticks'
  },
  exponentformat: {
    valType: 'enumerated',
    values: ['none', 'e', 'E', 'power', 'SI', 'B'],
    dflt: 'B',
    editType: 'ticks'
  },
  minexponent: {
    valType: 'number',
    dflt: 3,
    min: 0,
    editType: 'ticks'
  },
  separatethousands: {
    valType: 'boolean',
    dflt: false,
    editType: 'ticks'
  },
  tickformat: {
    valType: 'string',
    dflt: '',
    editType: 'ticks',
    description: descriptionWithDates('tick label')
  },
  tickformatstops: templatedArray('tickformatstop', {
    enabled: {
      valType: 'boolean',
      dflt: true,
      editType: 'ticks'
    },
    dtickrange: {
      valType: 'info_array',
      items: [{
        valType: 'any',
        editType: 'ticks'
      }, {
        valType: 'any',
        editType: 'ticks'
      }],
      editType: 'ticks'
    },
    value: {
      valType: 'string',
      dflt: '',
      editType: 'ticks'
    },
    editType: 'ticks'
  }),
  hoverformat: {
    valType: 'string',
    dflt: '',
    editType: 'none',
    description: descriptionWithDates('hover text')
  },
  // lines and grids
  showline: {
    valType: 'boolean',
    dflt: false,
    editType: 'ticks+layoutstyle'
  },
  linecolor: {
    valType: 'color',
    dflt: colorAttrs.defaultLine,
    editType: 'layoutstyle'
  },
  linewidth: {
    valType: 'number',
    min: 0,
    dflt: 1,
    editType: 'ticks+layoutstyle'
  },
  showgrid: showgrid,
  gridcolor: gridcolor,
  gridwidth: makeGridwidth(),
  griddash: griddash,
  zeroline: {
    valType: 'boolean',
    editType: 'ticks'
  },
  zerolinecolor: {
    valType: 'color',
    dflt: colorAttrs.defaultLine,
    editType: 'ticks'
  },
  zerolinewidth: {
    valType: 'number',
    dflt: 1,
    editType: 'ticks'
  },
  showdividers: {
    valType: 'boolean',
    dflt: true,
    editType: 'ticks'
  },
  dividercolor: {
    valType: 'color',
    dflt: colorAttrs.defaultLine,
    editType: 'ticks'
  },
  dividerwidth: {
    valType: 'number',
    dflt: 1,
    editType: 'ticks'
  },
  // TODO dividerlen: that would override "to label base" length?

  // positioning attributes
  // anchor: not used directly, just put here for reference
  // values are any opposite-letter axis id
  anchor: {
    valType: 'enumerated',
    values: ['free', constants.idRegex.x.toString(), constants.idRegex.y.toString()],
    editType: 'plot'
  },
  // side: not used directly, as values depend on direction
  // values are top, bottom for x axes, and left, right for y
  side: {
    valType: 'enumerated',
    values: ['top', 'bottom', 'left', 'right'],
    editType: 'plot'
  },
  // overlaying: not used directly, just put here for reference
  // values are false and any other same-letter axis id that's not
  // itself overlaying anything
  overlaying: {
    valType: 'enumerated',
    values: ['free', constants.idRegex.x.toString(), constants.idRegex.y.toString()],
    editType: 'plot'
  },
  minor: {
    tickmode: minorTickmode,
    nticks: makeNticks('minor'),
    tick0: tick0,
    dtick: dtick,
    tickvals: tickvals,
    ticks: ticks,
    ticklen: makeTicklen('minor'),
    tickwidth: makeTickwidth('minor'),
    tickcolor: tickcolor,
    gridcolor: gridcolor,
    gridwidth: makeGridwidth('minor'),
    griddash: griddash,
    showgrid: showgrid,
    editType: 'ticks'
  },
  layer: {
    valType: 'enumerated',
    values: ['above traces', 'below traces'],
    dflt: 'above traces',
    editType: 'plot'
  },
  domain: {
    valType: 'info_array',
    items: [{
      valType: 'number',
      min: 0,
      max: 1,
      editType: 'plot'
    }, {
      valType: 'number',
      min: 0,
      max: 1,
      editType: 'plot'
    }],
    dflt: [0, 1],
    editType: 'plot'
  },
  position: {
    valType: 'number',
    min: 0,
    max: 1,
    dflt: 0,
    editType: 'plot'
  },
  autoshift: {
    valType: 'boolean',
    dflt: false,
    editType: 'plot'
  },
  shift: {
    valType: 'number',
    editType: 'plot'
  },
  categoryorder: {
    valType: 'enumerated',
    values: ['trace', 'category ascending', 'category descending', 'array', 'total ascending', 'total descending', 'min ascending', 'min descending', 'max ascending', 'max descending', 'sum ascending', 'sum descending', 'mean ascending', 'mean descending', 'geometric mean ascending', 'geometric mean descending', 'median ascending', 'median descending'],
    dflt: 'trace',
    editType: 'calc'
  },
  categoryarray: {
    valType: 'data_array',
    editType: 'calc'
  },
  uirevision: {
    valType: 'any',
    editType: 'none'
  },
  editType: 'calc',
  _deprecated: {
    autotick: {
      valType: 'boolean',
      editType: 'ticks'
    },
    title: {
      valType: 'string',
      editType: 'ticks'
    },
    titlefont: fontAttrs({
      editType: 'ticks'
    })
  }
};

/***/ }),

/***/ 74098:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var Color = __webpack_require__(78766);
var isUnifiedHover = (__webpack_require__(36040).isUnifiedHover);
var handleHoverModeDefaults = __webpack_require__(45265);
var Template = __webpack_require__(78032);
var basePlotLayoutAttributes = __webpack_require__(6704);
var layoutAttributes = __webpack_require__(25829);
var handleTypeDefaults = __webpack_require__(4392);
var handleAxisDefaults = __webpack_require__(97655);
var constraints = __webpack_require__(84391);
var handlePositionDefaults = __webpack_require__(40957);
var axisIds = __webpack_require__(5975);
var id2name = axisIds.id2name;
var name2id = axisIds.name2id;
var AX_ID_PATTERN = (__webpack_require__(54826).AX_ID_PATTERN);
var Registry = __webpack_require__(33626);
var traceIs = Registry.traceIs;
var getComponentMethod = Registry.getComponentMethod;
function appendList(cont, k, item) {
  if (Array.isArray(cont[k])) cont[k].push(item);else cont[k] = [item];
}
module.exports = function supplyLayoutDefaults(layoutIn, layoutOut, fullData) {
  var autotypenumbersDflt = layoutOut.autotypenumbers;
  var ax2traces = {};
  var xaMayHide = {};
  var yaMayHide = {};
  var xaMustDisplay = {};
  var yaMustDisplay = {};
  var yaMustNotReverse = {};
  var yaMayReverse = {};
  var axHasImage = {};
  var outerTicks = {};
  var noGrids = {};
  var i, j;

  // look for axes in the data
  for (i = 0; i < fullData.length; i++) {
    var trace = fullData[i];
    if (!traceIs(trace, 'cartesian') && !traceIs(trace, 'gl2d')) continue;
    var xaName;
    if (trace.xaxis) {
      xaName = id2name(trace.xaxis);
      appendList(ax2traces, xaName, trace);
    } else if (trace.xaxes) {
      for (j = 0; j < trace.xaxes.length; j++) {
        appendList(ax2traces, id2name(trace.xaxes[j]), trace);
      }
    }
    var yaName;
    if (trace.yaxis) {
      yaName = id2name(trace.yaxis);
      appendList(ax2traces, yaName, trace);
    } else if (trace.yaxes) {
      for (j = 0; j < trace.yaxes.length; j++) {
        appendList(ax2traces, id2name(trace.yaxes[j]), trace);
      }
    }

    // logic for funnels
    if (trace.type === 'funnel') {
      if (trace.orientation === 'h') {
        if (xaName) xaMayHide[xaName] = true;
        if (yaName) yaMayReverse[yaName] = true;
      } else {
        if (yaName) yaMayHide[yaName] = true;
      }
    } else if (trace.type === 'image') {
      if (yaName) axHasImage[yaName] = true;
      if (xaName) axHasImage[xaName] = true;
    } else {
      if (yaName) {
        yaMustDisplay[yaName] = true;
        yaMustNotReverse[yaName] = true;
      }
      if (!traceIs(trace, 'carpet') || trace.type === 'carpet' && !trace._cheater) {
        if (xaName) xaMustDisplay[xaName] = true;
      }
    }

    // Two things trigger axis visibility:
    // 1. is not carpet
    // 2. carpet that's not cheater

    // The above check for definitely-not-cheater is not adequate. This
    // second list tracks which axes *could* be a cheater so that the
    // full condition triggering hiding is:
    //   *could* be a cheater and *is not definitely visible*
    if (trace.type === 'carpet' && trace._cheater) {
      if (xaName) xaMayHide[xaName] = true;
    }

    // check for default formatting tweaks
    if (traceIs(trace, '2dMap')) {
      outerTicks[xaName] = true;
      outerTicks[yaName] = true;
    }
    if (traceIs(trace, 'oriented')) {
      var positionAxis = trace.orientation === 'h' ? yaName : xaName;
      noGrids[positionAxis] = true;
    }
  }
  var subplots = layoutOut._subplots;
  var xIds = subplots.xaxis;
  var yIds = subplots.yaxis;
  var xNames = Lib.simpleMap(xIds, id2name);
  var yNames = Lib.simpleMap(yIds, id2name);
  var axNames = xNames.concat(yNames);

  // plot_bgcolor only makes sense if there's a (2D) plot!
  // TODO: bgcolor for each subplot, to inherit from the main one
  var plotBgColor = Color.background;
  if (xIds.length && yIds.length) {
    plotBgColor = Lib.coerce(layoutIn, layoutOut, basePlotLayoutAttributes, 'plot_bgcolor');
  }
  var bgColor = Color.combine(plotBgColor, layoutOut.paper_bgcolor);

  // name of single axis (e.g. 'xaxis', 'yaxis2')
  var axName;
  // id of single axis (e.g. 'y', 'x5')
  var axId;
  // 'x' or 'y'
  var axLetter;
  // input layout axis container
  var axLayoutIn;
  // full layout axis container
  var axLayoutOut;
  function newAxLayoutOut() {
    var traces = ax2traces[axName] || [];
    axLayoutOut._traceIndices = traces.map(function (t) {
      return t._expandedIndex;
    });
    axLayoutOut._annIndices = [];
    axLayoutOut._shapeIndices = [];
    axLayoutOut._selectionIndices = [];
    axLayoutOut._imgIndices = [];
    axLayoutOut._subplotsWith = [];
    axLayoutOut._counterAxes = [];
    axLayoutOut._name = axLayoutOut._attr = axName;
    axLayoutOut._id = axId;
  }
  function coerce(attr, dflt) {
    return Lib.coerce(axLayoutIn, axLayoutOut, layoutAttributes, attr, dflt);
  }
  function coerce2(attr, dflt) {
    return Lib.coerce2(axLayoutIn, axLayoutOut, layoutAttributes, attr, dflt);
  }
  function getCounterAxes(axLetter) {
    return axLetter === 'x' ? yIds : xIds;
  }
  function getOverlayableAxes(axLetter, axName) {
    var list = axLetter === 'x' ? xNames : yNames;
    var out = [];
    for (var j = 0; j < list.length; j++) {
      var axName2 = list[j];
      if (axName2 !== axName && !(layoutIn[axName2] || {}).overlaying) {
        out.push(name2id(axName2));
      }
    }
    return out;
  }

  // list of available counter axis names
  var counterAxes = {
    x: getCounterAxes('x'),
    y: getCounterAxes('y')
  };
  // list of all x AND y axis ids
  var allAxisIds = counterAxes.x.concat(counterAxes.y);
  // lookup and list of axis ids that axes in axNames have a reference to,
  // even though they are missing from allAxisIds
  var missingMatchedAxisIdsLookup = {};
  var missingMatchedAxisIds = [];

  // fill in 'missing' axis lookup when an axis is set to match an axis
  // not part of the allAxisIds list, save axis type so that we can propagate
  // it to the missing axes
  function addMissingMatchedAxis() {
    var matchesIn = axLayoutIn.matches;
    if (AX_ID_PATTERN.test(matchesIn) && allAxisIds.indexOf(matchesIn) === -1) {
      missingMatchedAxisIdsLookup[matchesIn] = axLayoutIn.type;
      missingMatchedAxisIds = Object.keys(missingMatchedAxisIdsLookup);
    }
  }
  var hovermode = handleHoverModeDefaults(layoutIn, layoutOut);
  var unifiedHover = isUnifiedHover(hovermode);

  // first pass creates the containers, determines types, and handles most of the settings
  for (i = 0; i < axNames.length; i++) {
    axName = axNames[i];
    axId = name2id(axName);
    axLetter = axName.charAt(0);
    if (!Lib.isPlainObject(layoutIn[axName])) {
      layoutIn[axName] = {};
    }
    axLayoutIn = layoutIn[axName];
    axLayoutOut = Template.newContainer(layoutOut, axName, axLetter + 'axis');
    newAxLayoutOut();
    var visibleDflt = axLetter === 'x' && !xaMustDisplay[axName] && xaMayHide[axName] || axLetter === 'y' && !yaMustDisplay[axName] && yaMayHide[axName];
    var reverseDflt = axLetter === 'y' && (!yaMustNotReverse[axName] && yaMayReverse[axName] || axHasImage[axName]);
    var defaultOptions = {
      hasMinor: true,
      letter: axLetter,
      font: layoutOut.font,
      outerTicks: outerTicks[axName],
      showGrid: !noGrids[axName],
      data: ax2traces[axName] || [],
      bgColor: bgColor,
      calendar: layoutOut.calendar,
      automargin: true,
      visibleDflt: visibleDflt,
      reverseDflt: reverseDflt,
      autotypenumbersDflt: autotypenumbersDflt,
      splomStash: ((layoutOut._splomAxes || {})[axLetter] || {})[axId],
      noAutotickangles: axLetter === 'y'
    };
    coerce('uirevision', layoutOut.uirevision);
    handleTypeDefaults(axLayoutIn, axLayoutOut, coerce, defaultOptions);
    handleAxisDefaults(axLayoutIn, axLayoutOut, coerce, defaultOptions, layoutOut);
    var unifiedSpike = unifiedHover && axLetter === hovermode.charAt(0);
    var spikecolor = coerce2('spikecolor', unifiedHover ? axLayoutOut.color : undefined);
    var spikethickness = coerce2('spikethickness', unifiedHover ? 1.5 : undefined);
    var spikedash = coerce2('spikedash', unifiedHover ? 'dot' : undefined);
    var spikemode = coerce2('spikemode', unifiedHover ? 'across' : undefined);
    var spikesnap = coerce2('spikesnap');
    var showSpikes = coerce('showspikes', !!unifiedSpike || !!spikecolor || !!spikethickness || !!spikedash || !!spikemode || !!spikesnap);
    if (!showSpikes) {
      delete axLayoutOut.spikecolor;
      delete axLayoutOut.spikethickness;
      delete axLayoutOut.spikedash;
      delete axLayoutOut.spikemode;
      delete axLayoutOut.spikesnap;
    }

    // If it exists, the the domain of the axis for the anchor of the overlaying axis
    var overlayingAxis = id2name(axLayoutIn.overlaying);
    var overlayingAnchorDomain = [0, 1];
    if (layoutOut[overlayingAxis] !== undefined) {
      var overlayingAnchor = id2name(layoutOut[overlayingAxis].anchor);
      if (layoutOut[overlayingAnchor] !== undefined) {
        overlayingAnchorDomain = layoutOut[overlayingAnchor].domain;
      }
    }
    handlePositionDefaults(axLayoutIn, axLayoutOut, coerce, {
      letter: axLetter,
      counterAxes: counterAxes[axLetter],
      overlayableAxes: getOverlayableAxes(axLetter, axName),
      grid: layoutOut.grid,
      overlayingDomain: overlayingAnchorDomain
    });
    coerce('title.standoff');
    addMissingMatchedAxis();
    axLayoutOut._input = axLayoutIn;
  }

  // coerce the 'missing' axes
  i = 0;
  while (i < missingMatchedAxisIds.length) {
    axId = missingMatchedAxisIds[i++];
    axName = id2name(axId);
    axLetter = axName.charAt(0);
    if (!Lib.isPlainObject(layoutIn[axName])) {
      layoutIn[axName] = {};
    }
    axLayoutIn = layoutIn[axName];
    axLayoutOut = Template.newContainer(layoutOut, axName, axLetter + 'axis');
    newAxLayoutOut();
    var defaultOptions2 = {
      letter: axLetter,
      font: layoutOut.font,
      outerTicks: outerTicks[axName],
      showGrid: !noGrids[axName],
      data: [],
      bgColor: bgColor,
      calendar: layoutOut.calendar,
      automargin: true,
      visibleDflt: false,
      reverseDflt: false,
      autotypenumbersDflt: autotypenumbersDflt,
      splomStash: ((layoutOut._splomAxes || {})[axLetter] || {})[axId]
    };
    coerce('uirevision', layoutOut.uirevision);
    axLayoutOut.type = missingMatchedAxisIdsLookup[axId] || 'linear';
    handleAxisDefaults(axLayoutIn, axLayoutOut, coerce, defaultOptions2, layoutOut);
    handlePositionDefaults(axLayoutIn, axLayoutOut, coerce, {
      letter: axLetter,
      counterAxes: counterAxes[axLetter],
      overlayableAxes: getOverlayableAxes(axLetter, axName),
      grid: layoutOut.grid
    });
    coerce('fixedrange');
    addMissingMatchedAxis();
    axLayoutOut._input = axLayoutIn;
  }

  // quick second pass for range slider and selector defaults
  var rangeSliderDefaults = getComponentMethod('rangeslider', 'handleDefaults');
  var rangeSelectorDefaults = getComponentMethod('rangeselector', 'handleDefaults');
  for (i = 0; i < xNames.length; i++) {
    axName = xNames[i];
    axLayoutIn = layoutIn[axName];
    axLayoutOut = layoutOut[axName];
    rangeSliderDefaults(layoutIn, layoutOut, axName);
    if (axLayoutOut.type === 'date') {
      rangeSelectorDefaults(axLayoutIn, axLayoutOut, layoutOut, yNames, axLayoutOut.calendar);
    }
    coerce('fixedrange');
  }
  for (i = 0; i < yNames.length; i++) {
    axName = yNames[i];
    axLayoutIn = layoutIn[axName];
    axLayoutOut = layoutOut[axName];
    var anchoredAxis = layoutOut[id2name(axLayoutOut.anchor)];
    var fixedRangeDflt = getComponentMethod('rangeslider', 'isVisible')(anchoredAxis);
    coerce('fixedrange', fixedRangeDflt);
  }

  // Finally, handle scale constraints and matching axes.
  //
  // We need to do this after all axes have coerced both `type`
  // (so we link only axes of the same type) and
  // `fixedrange` (so we can avoid linking from OR TO a fixed axis).
  constraints.handleDefaults(layoutIn, layoutOut, {
    axIds: allAxisIds.concat(missingMatchedAxisIds).sort(axisIds.idSort),
    axHasImage: axHasImage
  });
};

/***/ }),

/***/ 97405:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var colorMix = (__webpack_require__(65657).mix);
var colorAttrs = __webpack_require__(10229);
var Lib = __webpack_require__(34809);

/**
 * @param {object} opts :
 *   - dfltColor {string} : default axis color
 *   - bgColor {string} : combined subplot bg color
 *   - blend {number, optional} : blend percentage (to compute dflt grid color)
 *   - showLine {boolean} : show line by default
 *   - showGrid {boolean} : show grid by default
 *   - noZeroLine {boolean} : don't coerce zeroline* attributes
 *   - attributes {object} : attribute object associated with input containers
 */
module.exports = function handleLineGridDefaults(containerIn, containerOut, coerce, opts) {
  opts = opts || {};
  var dfltColor = opts.dfltColor;
  function coerce2(attr, dflt) {
    return Lib.coerce2(containerIn, containerOut, opts.attributes, attr, dflt);
  }
  var lineColor = coerce2('linecolor', dfltColor);
  var lineWidth = coerce2('linewidth');
  var showLine = coerce('showline', opts.showLine || !!lineColor || !!lineWidth);
  if (!showLine) {
    delete containerOut.linecolor;
    delete containerOut.linewidth;
  }
  var gridColorDflt = colorMix(dfltColor, opts.bgColor, opts.blend || colorAttrs.lightFraction).toRgbString();
  var gridColor = coerce2('gridcolor', gridColorDflt);
  var gridWidth = coerce2('gridwidth');
  var gridDash = coerce2('griddash');
  var showGridLines = coerce('showgrid', opts.showGrid || !!gridColor || !!gridWidth || !!gridDash);
  if (!showGridLines) {
    delete containerOut.gridcolor;
    delete containerOut.gridwidth;
    delete containerOut.griddash;
  }
  if (opts.hasMinor) {
    var minorGridColorDflt = colorMix(containerOut.gridcolor, opts.bgColor, 67).toRgbString();
    var minorGridColor = coerce2('minor.gridcolor', minorGridColorDflt);
    var minorGridWidth = coerce2('minor.gridwidth', containerOut.gridwidth || 1);
    var minorGridDash = coerce2('minor.griddash', containerOut.griddash || 'solid');
    var minorShowGridLines = coerce('minor.showgrid', !!minorGridColor || !!minorGridWidth || !!minorGridDash);
    if (!minorShowGridLines) {
      delete containerOut.minor.gridcolor;
      delete containerOut.minor.gridwidth;
      delete containerOut.minor.griddash;
    }
  }
  if (!opts.noZeroLine) {
    var zeroLineColor = coerce2('zerolinecolor', dfltColor);
    var zeroLineWidth = coerce2('zerolinewidth');
    var showZeroLine = coerce('zeroline', opts.showGrid || !!zeroLineColor || !!zeroLineWidth);
    if (!showZeroLine) {
      delete containerOut.zerolinecolor;
      delete containerOut.zerolinewidth;
    }
  }
};

/***/ }),

/***/ 40957:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isNumeric = __webpack_require__(10721);
var Lib = __webpack_require__(34809);
module.exports = function handlePositionDefaults(containerIn, containerOut, coerce, options) {
  var counterAxes = options.counterAxes || [];
  var overlayableAxes = options.overlayableAxes || [];
  var letter = options.letter;
  var grid = options.grid;
  var overlayingDomain = options.overlayingDomain;
  var dfltAnchor, dfltDomain, dfltSide, dfltPosition, dfltShift, dfltAutomargin;
  if (grid) {
    dfltDomain = grid._domains[letter][grid._axisMap[containerOut._id]];
    dfltAnchor = grid._anchors[containerOut._id];
    if (dfltDomain) {
      dfltSide = grid[letter + 'side'].split(' ')[0];
      dfltPosition = grid.domain[letter][dfltSide === 'right' || dfltSide === 'top' ? 1 : 0];
    }
  }

  // Even if there's a grid, this axis may not be in it - fall back on non-grid defaults
  dfltDomain = dfltDomain || [0, 1];
  dfltAnchor = dfltAnchor || (isNumeric(containerIn.position) ? 'free' : counterAxes[0] || 'free');
  dfltSide = dfltSide || (letter === 'x' ? 'bottom' : 'left');
  dfltPosition = dfltPosition || 0;
  dfltShift = 0;
  dfltAutomargin = false;
  var anchor = Lib.coerce(containerIn, containerOut, {
    anchor: {
      valType: 'enumerated',
      values: ['free'].concat(counterAxes),
      dflt: dfltAnchor
    }
  }, 'anchor');
  var side = Lib.coerce(containerIn, containerOut, {
    side: {
      valType: 'enumerated',
      values: letter === 'x' ? ['bottom', 'top'] : ['left', 'right'],
      dflt: dfltSide
    }
  }, 'side');
  if (anchor === 'free') {
    if (letter === 'y') {
      var autoshift = coerce('autoshift');
      if (autoshift) {
        dfltPosition = side === 'left' ? overlayingDomain[0] : overlayingDomain[1];
        dfltAutomargin = containerOut.automargin ? containerOut.automargin : true;
        dfltShift = side === 'left' ? -3 : 3;
      }
      coerce('shift', dfltShift);
    }
    coerce('position', dfltPosition);
  }
  coerce('automargin', dfltAutomargin);
  var overlaying = false;
  if (overlayableAxes.length) {
    overlaying = Lib.coerce(containerIn, containerOut, {
      overlaying: {
        valType: 'enumerated',
        values: [false].concat(overlayableAxes),
        dflt: false
      }
    }, 'overlaying');
  }
  if (!overlaying) {
    // TODO: right now I'm copying this domain over to overlaying axes
    // in ax.setscale()... but this means we still need (imperfect) logic
    // in the axes popover to hide domain for the overlaying axis.
    // perhaps I should make a private version _domain that all axes get???
    var domain = coerce('domain', dfltDomain);

    // according to https://www.npmjs.com/package/canvas-size
    // the minimum value of max canvas width across browsers and devices is 4096
    // which applied in the calculation below:
    if (domain[0] > domain[1] - 1 / 4096) containerOut.domain = dfltDomain;
    Lib.noneOrAll(containerIn.domain, containerOut.domain, dfltDomain);

    // tickmode sync needs an overlaying axis, otherwise
    // we should default it to 'auto'
    if (containerOut.tickmode === 'sync') {
      containerOut.tickmode = 'auto';
    }
  }
  coerce('layer');
  return containerOut;
};

/***/ }),

/***/ 54616:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var getShowAttrDflt = __webpack_require__(87703);
module.exports = function handlePrefixSuffixDefaults(containerIn, containerOut, coerce, axType, options) {
  if (!options) options = {};
  var tickSuffixDflt = options.tickSuffixDflt;
  var showAttrDflt = getShowAttrDflt(containerIn);
  var tickPrefix = coerce('tickprefix');
  if (tickPrefix) coerce('showtickprefix', showAttrDflt);
  var tickSuffix = coerce('ticksuffix', tickSuffixDflt);
  if (tickSuffix) coerce('showticksuffix', showAttrDflt);
};

/***/ }),

/***/ 90259:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var handleAutorangeOptionsDefaults = __webpack_require__(75511);
module.exports = function handleRangeDefaults(containerIn, containerOut, coerce, options) {
  var axTemplate = containerOut._template || {};
  var axType = containerOut.type || axTemplate.type || '-';
  coerce('minallowed');
  coerce('maxallowed');
  var range = coerce('range');
  if (!range) {
    var insiderange;
    if (!options.noInsiderange && axType !== 'log') {
      insiderange = coerce('insiderange');

      // We may support partial insideranges in future
      // For now it is out of scope
      if (insiderange && (insiderange[0] === null || insiderange[1] === null)) {
        containerOut.insiderange = false;
        insiderange = undefined;
      }
      if (insiderange) range = coerce('range', insiderange);
    }
  }
  var autorangeDflt = containerOut.getAutorangeDflt(range, options);
  var autorange = coerce('autorange', autorangeDflt);
  var shouldAutorange;

  // validate range and set autorange true for invalid partial ranges
  if (range && (range[0] === null && range[1] === null || (range[0] === null || range[1] === null) && (autorange === 'reversed' || autorange === true) || range[0] !== null && (autorange === 'min' || autorange === 'max reversed') || range[1] !== null && (autorange === 'max' || autorange === 'min reversed'))) {
    range = undefined;
    delete containerOut.range;
    containerOut.autorange = true;
    shouldAutorange = true;
  }
  if (!shouldAutorange) {
    autorangeDflt = containerOut.getAutorangeDflt(range, options);
    autorange = coerce('autorange', autorangeDflt);
  }
  if (autorange) {
    handleAutorangeOptionsDefaults(coerce, autorange, range);
    if (axType === 'linear' || axType === '-') coerce('rangemode');
  }
  containerOut.cleanRange();
};

/***/ }),

/***/ 67611:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var FROM_BL = (__webpack_require__(4530).FROM_BL);
module.exports = function scaleZoom(ax, factor, centerFraction) {
  if (centerFraction === undefined) {
    centerFraction = FROM_BL[ax.constraintoward || 'center'];
  }
  var rangeLinear = [ax.r2l(ax.range[0]), ax.r2l(ax.range[1])];
  var center = rangeLinear[0] + (rangeLinear[1] - rangeLinear[0]) * centerFraction;
  ax.range = ax._input.range = [ax.l2r(center + (rangeLinear[0] - center) * factor), ax.l2r(center + (rangeLinear[1] - center) * factor)];
  ax.setScale();
};

/***/ }),

/***/ 19091:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var utcFormat = (__webpack_require__(42696)/* .utcFormat */ .aL);
var Lib = __webpack_require__(34809);
var numberFormat = Lib.numberFormat;
var isNumeric = __webpack_require__(10721);
var cleanNumber = Lib.cleanNumber;
var ms2DateTime = Lib.ms2DateTime;
var dateTime2ms = Lib.dateTime2ms;
var ensureNumber = Lib.ensureNumber;
var isArrayOrTypedArray = Lib.isArrayOrTypedArray;
var numConstants = __webpack_require__(63821);
var FP_SAFE = numConstants.FP_SAFE;
var BADNUM = numConstants.BADNUM;
var LOG_CLIP = numConstants.LOG_CLIP;
var ONEWEEK = numConstants.ONEWEEK;
var ONEDAY = numConstants.ONEDAY;
var ONEHOUR = numConstants.ONEHOUR;
var ONEMIN = numConstants.ONEMIN;
var ONESEC = numConstants.ONESEC;
var axisIds = __webpack_require__(5975);
var constants = __webpack_require__(54826);
var HOUR_PATTERN = constants.HOUR_PATTERN;
var WEEKDAY_PATTERN = constants.WEEKDAY_PATTERN;
function fromLog(v) {
  return Math.pow(10, v);
}
function isValidCategory(v) {
  return v !== null && v !== undefined;
}

/**
 * Define the conversion functions for an axis data is used in 5 ways:
 *
 *  d: data, in whatever form it's provided
 *  c: calcdata: turned into numbers, but not linearized
 *  l: linearized - same as c except for log axes (and other nonlinear
 *      mappings later?) this is used when we need to know if it's
 *      *possible* to show some data on this axis, without caring about
 *      the current range
 *  p: pixel value - mapped to the screen with current size and zoom
 *  r: ranges, tick0, and annotation positions match one of the above
 *     but are handled differently for different types:
 *     - linear and date: data format (d)
 *     - category: calcdata format (c), and will stay that way because
 *       the data format has no continuous mapping
 *     - log: linearized (l) format
 *       TODO: in v3.0 we plan to change it to data format. At that point
 *       shapes will work the same way as ranges, tick0, and annotations
 *       so they can use this conversion too.
 *
 * Creates/updates these conversion functions, and a few more utilities
 * like cleanRange, and makeCalcdata
 *
 * also clears the autotick constraints ._minDtick, ._forceTick0
 */
module.exports = function setConvert(ax, fullLayout) {
  fullLayout = fullLayout || {};
  var axId = ax._id || 'x';
  var axLetter = axId.charAt(0);
  function toLog(v, clip) {
    if (v > 0) return Math.log(v) / Math.LN10;else if (v <= 0 && clip && ax.range && ax.range.length === 2) {
      // clip NaN (ie past negative infinity) to LOG_CLIP axis
      // length past the negative edge
      var r0 = ax.range[0];
      var r1 = ax.range[1];
      return 0.5 * (r0 + r1 - 2 * LOG_CLIP * Math.abs(r0 - r1));
    } else return BADNUM;
  }

  /*
   * wrapped dateTime2ms that:
   * - accepts ms numbers for backward compatibility
   * - inserts a dummy arg so calendar is the 3rd arg (see notes below).
   * - defaults to ax.calendar
   */
  function dt2ms(v, _, calendar, opts) {
    if ((opts || {}).msUTC && isNumeric(v)) {
      // For now it is only used
      // to fix bar length in milliseconds & gl3d ticks
      // It could be applied in other places in v3
      return +v;
    }

    // NOTE: Changed this behavior: previously we took any numeric value
    // to be a ms, even if it was a string that could be a bare year.
    // Now we convert it as a date if at all possible, and only try
    // as (local) ms if that fails.
    var ms = dateTime2ms(v, calendar || ax.calendar);
    if (ms === BADNUM) {
      if (isNumeric(v)) {
        v = +v;
        // keep track of tenths of ms, that `new Date` will drop
        // same logic as in Lib.ms2DateTime
        var msecTenths = Math.floor(Lib.mod(v + 0.05, 1) * 10);
        var msRounded = Math.round(v - msecTenths / 10);
        ms = dateTime2ms(new Date(msRounded)) + msecTenths / 10;
      } else return BADNUM;
    }
    return ms;
  }

  // wrapped ms2DateTime to insert default ax.calendar
  function ms2dt(v, r, calendar) {
    return ms2DateTime(v, r, calendar || ax.calendar);
  }
  function getCategoryName(v) {
    return ax._categories[Math.round(v)];
  }

  /*
   * setCategoryIndex: return the index of category v,
   * inserting it in the list if it's not already there
   *
   * this will enter the categories in the order it
   * encounters them, ie all the categories from the
   * first data set, then all the ones from the second
   * that aren't in the first etc.
   *
   * it is assumed that this function is being invoked in the
   * already sorted category order; otherwise there would be
   * a disconnect between the array and the index returned
   */
  function setCategoryIndex(v) {
    if (isValidCategory(v)) {
      if (ax._categoriesMap === undefined) {
        ax._categoriesMap = {};
      }
      if (ax._categoriesMap[v] !== undefined) {
        return ax._categoriesMap[v];
      } else {
        ax._categories.push(typeof v === 'number' ? String(v) : v);
        var curLength = ax._categories.length - 1;
        ax._categoriesMap[v] = curLength;
        return curLength;
      }
    }
    return BADNUM;
  }
  function setMultiCategoryIndex(arrayIn, len) {
    var arrayOut = new Array(len);
    for (var i = 0; i < len; i++) {
      var v0 = (arrayIn[0] || [])[i];
      var v1 = (arrayIn[1] || [])[i];
      arrayOut[i] = getCategoryIndex([v0, v1]);
    }
    return arrayOut;
  }
  function getCategoryIndex(v) {
    if (ax._categoriesMap) {
      return ax._categoriesMap[v];
    }
  }
  function getCategoryPosition(v) {
    // d2l/d2c variant that that won't add categories but will also
    // allow numbers to be mapped to the linearized axis positions
    var index = getCategoryIndex(v);
    if (index !== undefined) return index;
    if (isNumeric(v)) return +v;
  }
  function getRangePosition(v) {
    return isNumeric(v) ? +v : getCategoryIndex(v);
  }

  // include 2 fractional digits on pixel, for PDF zooming etc
  function _l2p(v, m, b) {
    return d3.round(b + m * v, 2);
  }
  function _p2l(px, m, b) {
    return (px - b) / m;
  }
  var l2p = function l2p(v) {
    if (!isNumeric(v)) return BADNUM;
    return _l2p(v, ax._m, ax._b);
  };
  var p2l = function (px) {
    return _p2l(px, ax._m, ax._b);
  };
  if (ax.rangebreaks) {
    var isY = axLetter === 'y';
    l2p = function (v) {
      if (!isNumeric(v)) return BADNUM;
      var len = ax._rangebreaks.length;
      if (!len) return _l2p(v, ax._m, ax._b);
      var flip = isY;
      if (ax.range[0] > ax.range[1]) flip = !flip;
      var signAx = flip ? -1 : 1;
      var pos = signAx * v;
      var q = 0;
      for (var i = 0; i < len; i++) {
        var min = signAx * ax._rangebreaks[i].min;
        var max = signAx * ax._rangebreaks[i].max;
        if (pos < min) break;
        if (pos > max) q = i + 1;else {
          // when falls into break, pick 'closest' offset
          q = pos < (min + max) / 2 ? i : i + 1;
          break;
        }
      }
      var b2 = ax._B[q] || 0;
      if (!isFinite(b2)) return 0; // avoid NaN translate e.g. in positionLabels if one keep zooming exactly into a break
      return _l2p(v, ax._m2, b2);
    };
    p2l = function (px) {
      var len = ax._rangebreaks.length;
      if (!len) return _p2l(px, ax._m, ax._b);
      var q = 0;
      for (var i = 0; i < len; i++) {
        if (px < ax._rangebreaks[i].pmin) break;
        if (px > ax._rangebreaks[i].pmax) q = i + 1;
      }
      return _p2l(px, ax._m2, ax._B[q]);
    };
  }

  // conversions among c/l/p are fairly simple - do them together for all axis types
  ax.c2l = ax.type === 'log' ? toLog : ensureNumber;
  ax.l2c = ax.type === 'log' ? fromLog : ensureNumber;
  ax.l2p = l2p;
  ax.p2l = p2l;
  ax.c2p = ax.type === 'log' ? function (v, clip) {
    return l2p(toLog(v, clip));
  } : l2p;
  ax.p2c = ax.type === 'log' ? function (px) {
    return fromLog(p2l(px));
  } : p2l;

  /*
   * now type-specific conversions for **ALL** other combinations
   * they're all written out, instead of being combinations of each other, for
   * both clarity and speed.
   */
  if (['linear', '-'].indexOf(ax.type) !== -1) {
    // all are data vals, but d and r need cleaning
    ax.d2r = ax.r2d = ax.d2c = ax.r2c = ax.d2l = ax.r2l = cleanNumber;
    ax.c2d = ax.c2r = ax.l2d = ax.l2r = ensureNumber;
    ax.d2p = ax.r2p = function (v) {
      return ax.l2p(cleanNumber(v));
    };
    ax.p2d = ax.p2r = p2l;
    ax.cleanPos = ensureNumber;
  } else if (ax.type === 'log') {
    // d and c are data vals, r and l are logged (but d and r need cleaning)
    ax.d2r = ax.d2l = function (v, clip) {
      return toLog(cleanNumber(v), clip);
    };
    ax.r2d = ax.r2c = function (v) {
      return fromLog(cleanNumber(v));
    };
    ax.d2c = ax.r2l = cleanNumber;
    ax.c2d = ax.l2r = ensureNumber;
    ax.c2r = toLog;
    ax.l2d = fromLog;
    ax.d2p = function (v, clip) {
      return ax.l2p(ax.d2r(v, clip));
    };
    ax.p2d = function (px) {
      return fromLog(p2l(px));
    };
    ax.r2p = function (v) {
      return ax.l2p(cleanNumber(v));
    };
    ax.p2r = p2l;
    ax.cleanPos = ensureNumber;
  } else if (ax.type === 'date') {
    // r and d are date strings, l and c are ms

    /*
     * Any of these functions with r and d on either side, calendar is the
     * **3rd** argument. log has reserved the second argument.
     *
     * Unless you need the special behavior of the second arg (ms2DateTime
     * uses this to limit precision, toLog uses true to clip negatives
     * to offscreen low rather than undefined), it's safe to pass 0.
     */
    ax.d2r = ax.r2d = Lib.identity;
    ax.d2c = ax.r2c = ax.d2l = ax.r2l = dt2ms;
    ax.c2d = ax.c2r = ax.l2d = ax.l2r = ms2dt;
    ax.d2p = ax.r2p = function (v, _, calendar) {
      return ax.l2p(dt2ms(v, 0, calendar));
    };
    ax.p2d = ax.p2r = function (px, r, calendar) {
      return ms2dt(p2l(px), r, calendar);
    };
    ax.cleanPos = function (v) {
      return Lib.cleanDate(v, BADNUM, ax.calendar);
    };
  } else if (ax.type === 'category') {
    // d is categories (string)
    // c and l are indices (numbers)
    // r is categories or numbers

    ax.d2c = ax.d2l = setCategoryIndex;
    ax.r2d = ax.c2d = ax.l2d = getCategoryName;
    ax.d2r = ax.d2l_noadd = getCategoryPosition;
    ax.r2c = function (v) {
      var index = getRangePosition(v);
      return index !== undefined ? index : ax.fraction2r(0.5);
    };
    ax.l2r = ax.c2r = ensureNumber;
    ax.r2l = getRangePosition;
    ax.d2p = function (v) {
      return ax.l2p(ax.r2c(v));
    };
    ax.p2d = function (px) {
      return getCategoryName(p2l(px));
    };
    ax.r2p = ax.d2p;
    ax.p2r = p2l;
    ax.cleanPos = function (v) {
      if (typeof v === 'string' && v !== '') return v;
      return ensureNumber(v);
    };
  } else if (ax.type === 'multicategory') {
    // N.B. multicategory axes don't define d2c and d2l,
    // as 'data-to-calcdata' conversion needs to take into
    // account all data array items as in ax.makeCalcdata.

    ax.r2d = ax.c2d = ax.l2d = getCategoryName;
    ax.d2r = ax.d2l_noadd = getCategoryPosition;
    ax.r2c = function (v) {
      var index = getCategoryPosition(v);
      return index !== undefined ? index : ax.fraction2r(0.5);
    };
    ax.r2c_just_indices = getCategoryIndex;
    ax.l2r = ax.c2r = ensureNumber;
    ax.r2l = getCategoryPosition;
    ax.d2p = function (v) {
      return ax.l2p(ax.r2c(v));
    };
    ax.p2d = function (px) {
      return getCategoryName(p2l(px));
    };
    ax.r2p = ax.d2p;
    ax.p2r = p2l;
    ax.cleanPos = function (v) {
      if (Array.isArray(v) || typeof v === 'string' && v !== '') return v;
      return ensureNumber(v);
    };
    ax.setupMultiCategory = function (fullData) {
      var traceIndices = ax._traceIndices;
      var i, j;
      var group = ax._matchGroup;
      if (group && ax._categories.length === 0) {
        for (var axId2 in group) {
          if (axId2 !== axId) {
            var ax2 = fullLayout[axisIds.id2name(axId2)];
            traceIndices = traceIndices.concat(ax2._traceIndices);
          }
        }
      }

      // [ [cnt, {$cat: index}], for 1,2 ]
      var seen = [[0, {}], [0, {}]];
      // [ [arrayIn[0][i], arrayIn[1][i]], for i .. N ]
      var list = [];
      for (i = 0; i < traceIndices.length; i++) {
        var trace = fullData[traceIndices[i]];
        if (axLetter in trace) {
          var arrayIn = trace[axLetter];
          var len = trace._length || Lib.minRowLength(arrayIn);
          if (isArrayOrTypedArray(arrayIn[0]) && isArrayOrTypedArray(arrayIn[1])) {
            for (j = 0; j < len; j++) {
              var v0 = arrayIn[0][j];
              var v1 = arrayIn[1][j];
              if (isValidCategory(v0) && isValidCategory(v1)) {
                list.push([v0, v1]);
                if (!(v0 in seen[0][1])) {
                  seen[0][1][v0] = seen[0][0]++;
                }
                if (!(v1 in seen[1][1])) {
                  seen[1][1][v1] = seen[1][0]++;
                }
              }
            }
          }
        }
      }
      list.sort(function (a, b) {
        var ind0 = seen[0][1];
        var d = ind0[a[0]] - ind0[b[0]];
        if (d) return d;
        var ind1 = seen[1][1];
        return ind1[a[1]] - ind1[b[1]];
      });
      for (i = 0; i < list.length; i++) {
        setCategoryIndex(list[i]);
      }
    };
  }

  // find the range value at the specified (linear) fraction of the axis
  ax.fraction2r = function (v) {
    var rl0 = ax.r2l(ax.range[0]);
    var rl1 = ax.r2l(ax.range[1]);
    return ax.l2r(rl0 + v * (rl1 - rl0));
  };

  // find the fraction of the range at the specified range value
  ax.r2fraction = function (v) {
    var rl0 = ax.r2l(ax.range[0]);
    var rl1 = ax.r2l(ax.range[1]);
    return (ax.r2l(v) - rl0) / (rl1 - rl0);
  };
  ax.limitRange = function (rangeAttr) {
    var minallowed = ax.minallowed;
    var maxallowed = ax.maxallowed;
    if (minallowed === undefined && maxallowed === undefined) return;
    if (!rangeAttr) rangeAttr = 'range';
    var range = Lib.nestedProperty(ax, rangeAttr).get();
    var rng = Lib.simpleMap(range, ax.r2l);
    var axrev = rng[1] < rng[0];
    if (axrev) rng.reverse();
    var bounds = Lib.simpleMap([minallowed, maxallowed], ax.r2l);
    if (minallowed !== undefined && rng[0] < bounds[0]) range[axrev ? 1 : 0] = minallowed;
    if (maxallowed !== undefined && rng[1] > bounds[1]) range[axrev ? 0 : 1] = maxallowed;
    if (range[0] === range[1]) {
      var minL = ax.l2r(minallowed);
      var maxL = ax.l2r(maxallowed);
      if (minallowed !== undefined) {
        var _max = minL + 1;
        if (maxallowed !== undefined) _max = Math.min(_max, maxL);
        range[axrev ? 1 : 0] = _max;
      }
      if (maxallowed !== undefined) {
        var _min = maxL + 1;
        if (minallowed !== undefined) _min = Math.max(_min, minL);
        range[axrev ? 0 : 1] = _min;
      }
    }
  };

  /*
   * cleanRange: make sure range is a couplet of valid & distinct values
   * keep numbers away from the limits of floating point numbers,
   * and dates away from the ends of our date system (+/- 9999 years)
   *
   * optional param rangeAttr: operate on a different attribute, like
   * ax._r, rather than ax.range
   */
  ax.cleanRange = function (rangeAttr, opts) {
    ax._cleanRange(rangeAttr, opts);
    ax.limitRange(rangeAttr);
  };
  ax._cleanRange = function (rangeAttr, opts) {
    if (!opts) opts = {};
    if (!rangeAttr) rangeAttr = 'range';
    var range = Lib.nestedProperty(ax, rangeAttr).get();
    var i, dflt;
    if (ax.type === 'date') dflt = Lib.dfltRange(ax.calendar);else if (axLetter === 'y') dflt = constants.DFLTRANGEY;else if (ax._name === 'realaxis') dflt = [0, 1];else dflt = opts.dfltRange || constants.DFLTRANGEX;

    // make sure we don't later mutate the defaults
    dflt = dflt.slice();
    if (ax.rangemode === 'tozero' || ax.rangemode === 'nonnegative') {
      dflt[0] = 0;
    }
    if (!range || range.length !== 2) {
      Lib.nestedProperty(ax, rangeAttr).set(dflt);
      return;
    }
    var nullRange0 = range[0] === null;
    var nullRange1 = range[1] === null;
    if (ax.type === 'date' && !ax.autorange) {
      // check if milliseconds or js date objects are provided for range
      // and convert to date strings
      range[0] = Lib.cleanDate(range[0], BADNUM, ax.calendar);
      range[1] = Lib.cleanDate(range[1], BADNUM, ax.calendar);
    }
    for (i = 0; i < 2; i++) {
      if (ax.type === 'date') {
        if (!Lib.isDateTime(range[i], ax.calendar)) {
          ax[rangeAttr] = dflt;
          break;
        }
        if (ax.r2l(range[0]) === ax.r2l(range[1])) {
          // split by +/- 1 second
          var linCenter = Lib.constrain(ax.r2l(range[0]), Lib.MIN_MS + 1000, Lib.MAX_MS - 1000);
          range[0] = ax.l2r(linCenter - 1000);
          range[1] = ax.l2r(linCenter + 1000);
          break;
        }
      } else {
        if (!isNumeric(range[i])) {
          if (!(nullRange0 || nullRange1) && isNumeric(range[1 - i])) {
            range[i] = range[1 - i] * (i ? 10 : 0.1);
          } else {
            ax[rangeAttr] = dflt;
            break;
          }
        }
        if (range[i] < -FP_SAFE) range[i] = -FP_SAFE;else if (range[i] > FP_SAFE) range[i] = FP_SAFE;
        if (range[0] === range[1]) {
          // somewhat arbitrary: split by 1 or 1ppm, whichever is bigger
          var inc = Math.max(1, Math.abs(range[0] * 1e-6));
          range[0] -= inc;
          range[1] += inc;
        }
      }
    }
  };

  // set scaling to pixels
  ax.setScale = function (usePrivateRange) {
    var gs = fullLayout._size;

    // make sure we have a domain (pull it in from the axis
    // this one is overlaying if necessary)
    if (ax.overlaying) {
      var ax2 = axisIds.getFromId({
        _fullLayout: fullLayout
      }, ax.overlaying);
      ax.domain = ax2.domain;
    }

    // While transitions are occurring, we get a double-transform
    // issue if we transform the drawn layer *and* use the new axis range to
    // draw the data. This allows us to construct setConvert using the pre-
    // interaction values of the range:
    var rangeAttr = usePrivateRange && ax._r ? '_r' : 'range';
    var calendar = ax.calendar;
    ax.cleanRange(rangeAttr);
    var rl0 = ax.r2l(ax[rangeAttr][0], calendar);
    var rl1 = ax.r2l(ax[rangeAttr][1], calendar);
    var isY = axLetter === 'y';
    if (isY) {
      ax._offset = gs.t + (1 - ax.domain[1]) * gs.h;
      ax._length = gs.h * (ax.domain[1] - ax.domain[0]);
      ax._m = ax._length / (rl0 - rl1);
      ax._b = -ax._m * rl1;
    } else {
      ax._offset = gs.l + ax.domain[0] * gs.w;
      ax._length = gs.w * (ax.domain[1] - ax.domain[0]);
      ax._m = ax._length / (rl1 - rl0);
      ax._b = -ax._m * rl0;
    }

    // set of "N" disjoint rangebreaks inside the range
    ax._rangebreaks = [];
    // length of these rangebreaks in value space - negative on reversed axes
    ax._lBreaks = 0;
    // l2p slope (same for all intervals)
    ax._m2 = 0;
    // set of l2p offsets (one for each of the (N+1) piecewise intervals)
    ax._B = [];
    if (ax.rangebreaks) {
      var i, brk;
      ax._rangebreaks = ax.locateBreaks(Math.min(rl0, rl1), Math.max(rl0, rl1));
      if (ax._rangebreaks.length) {
        for (i = 0; i < ax._rangebreaks.length; i++) {
          brk = ax._rangebreaks[i];
          ax._lBreaks += Math.abs(brk.max - brk.min);
        }
        var flip = isY;
        if (rl0 > rl1) flip = !flip;
        if (flip) ax._rangebreaks.reverse();
        var sign = flip ? -1 : 1;
        ax._m2 = sign * ax._length / (Math.abs(rl1 - rl0) - ax._lBreaks);
        ax._B.push(-ax._m2 * (isY ? rl1 : rl0));
        for (i = 0; i < ax._rangebreaks.length; i++) {
          brk = ax._rangebreaks[i];
          ax._B.push(ax._B[ax._B.length - 1] - sign * ax._m2 * (brk.max - brk.min));
        }

        // fill pixel (i.e. 'p') min/max here,
        // to not have to loop through the _rangebreaks twice during `p2l`
        for (i = 0; i < ax._rangebreaks.length; i++) {
          brk = ax._rangebreaks[i];
          brk.pmin = l2p(brk.min);
          brk.pmax = l2p(brk.max);
        }
      }
    }
    if (!isFinite(ax._m) || !isFinite(ax._b) || ax._length < 0) {
      fullLayout._replotting = false;
      throw new Error('Something went wrong with axis scaling');
    }
  };
  ax.maskBreaks = function (v) {
    var rangebreaksIn = ax.rangebreaks || [];
    var bnds, b0, b1, vb, vDate;
    if (!rangebreaksIn._cachedPatterns) {
      rangebreaksIn._cachedPatterns = rangebreaksIn.map(function (brk) {
        return brk.enabled && brk.bounds ? Lib.simpleMap(brk.bounds, brk.pattern ? cleanNumber : ax.d2c // case of pattern: ''
        ) : null;
      });
    }
    if (!rangebreaksIn._cachedValues) {
      rangebreaksIn._cachedValues = rangebreaksIn.map(function (brk) {
        return brk.enabled && brk.values ? Lib.simpleMap(brk.values, ax.d2c).sort(Lib.sorterAsc) : null;
      });
    }
    for (var i = 0; i < rangebreaksIn.length; i++) {
      var brk = rangebreaksIn[i];
      if (brk.enabled) {
        if (brk.bounds) {
          var pattern = brk.pattern;
          bnds = rangebreaksIn._cachedPatterns[i];
          b0 = bnds[0];
          b1 = bnds[1];
          switch (pattern) {
            case WEEKDAY_PATTERN:
              vDate = new Date(v);
              vb = vDate.getUTCDay();
              if (b0 > b1) {
                b1 += 7;
                if (vb < b0) vb += 7;
              }
              break;
            case HOUR_PATTERN:
              vDate = new Date(v);
              var hours = vDate.getUTCHours();
              var minutes = vDate.getUTCMinutes();
              var seconds = vDate.getUTCSeconds();
              var milliseconds = vDate.getUTCMilliseconds();
              vb = hours + (minutes / 60 + seconds / 3600 + milliseconds / 3600000);
              if (b0 > b1) {
                b1 += 24;
                if (vb < b0) vb += 24;
              }
              break;
            case '':
              // N.B. should work on date axes as well!
              // e.g. { bounds: ['2020-01-04', '2020-01-05 23:59'] }
              // TODO should work with reversed-range axes
              vb = v;
              break;
          }
          if (vb >= b0 && vb < b1) return BADNUM;
        } else {
          var vals = rangebreaksIn._cachedValues[i];
          for (var j = 0; j < vals.length; j++) {
            b0 = vals[j];
            b1 = b0 + brk.dvalue;
            if (v >= b0 && v < b1) return BADNUM;
          }
        }
      }
    }
    return v;
  };
  ax.locateBreaks = function (r0, r1) {
    var i, bnds, b0, b1;
    var rangebreaksOut = [];
    if (!ax.rangebreaks) return rangebreaksOut;
    var rangebreaksIn = ax.rangebreaks.slice().sort(function (a, b) {
      if (a.pattern === WEEKDAY_PATTERN && b.pattern === HOUR_PATTERN) return -1;
      if (b.pattern === WEEKDAY_PATTERN && a.pattern === HOUR_PATTERN) return 1;
      return 0;
    });
    var addBreak = function (min, max) {
      min = Lib.constrain(min, r0, r1);
      max = Lib.constrain(max, r0, r1);
      if (min === max) return;
      var isNewBreak = true;
      for (var j = 0; j < rangebreaksOut.length; j++) {
        var brkj = rangebreaksOut[j];
        if (min < brkj.max && max >= brkj.min) {
          if (min < brkj.min) {
            brkj.min = min;
          }
          if (max > brkj.max) {
            brkj.max = max;
          }
          isNewBreak = false;
        }
      }
      if (isNewBreak) {
        rangebreaksOut.push({
          min: min,
          max: max
        });
      }
    };
    for (i = 0; i < rangebreaksIn.length; i++) {
      var brk = rangebreaksIn[i];
      if (brk.enabled) {
        if (brk.bounds) {
          var t0 = r0;
          var t1 = r1;
          if (brk.pattern) {
            // to remove decimal (most often found in auto ranges)
            t0 = Math.floor(t0);
          }
          bnds = Lib.simpleMap(brk.bounds, brk.pattern ? cleanNumber : ax.r2l);
          b0 = bnds[0];
          b1 = bnds[1];

          // r0 value as date
          var t0Date = new Date(t0);
          // r0 value for break pattern
          var bndDelta;
          // step in ms between rangebreaks
          var step;
          switch (brk.pattern) {
            case WEEKDAY_PATTERN:
              step = ONEWEEK;
              bndDelta = ((b1 < b0 ? 7 : 0) + (b1 - b0)) * ONEDAY;
              t0 += b0 * ONEDAY - (t0Date.getUTCDay() * ONEDAY + t0Date.getUTCHours() * ONEHOUR + t0Date.getUTCMinutes() * ONEMIN + t0Date.getUTCSeconds() * ONESEC + t0Date.getUTCMilliseconds());
              break;
            case HOUR_PATTERN:
              step = ONEDAY;
              bndDelta = ((b1 < b0 ? 24 : 0) + (b1 - b0)) * ONEHOUR;
              t0 += b0 * ONEHOUR - (t0Date.getUTCHours() * ONEHOUR + t0Date.getUTCMinutes() * ONEMIN + t0Date.getUTCSeconds() * ONESEC + t0Date.getUTCMilliseconds());
              break;
            default:
              t0 = Math.min(bnds[0], bnds[1]);
              t1 = Math.max(bnds[0], bnds[1]);
              step = t1 - t0;
              bndDelta = step;
          }
          for (var t = t0; t < t1; t += step) {
            addBreak(t, t + bndDelta);
          }
        } else {
          var vals = Lib.simpleMap(brk.values, ax.d2c);
          for (var j = 0; j < vals.length; j++) {
            b0 = vals[j];
            b1 = b0 + brk.dvalue;
            addBreak(b0, b1);
          }
        }
      }
    }
    rangebreaksOut.sort(function (a, b) {
      return a.min - b.min;
    });
    return rangebreaksOut;
  };

  // makeCalcdata: takes an x or y array and converts it
  // to a position on the axis object "ax"
  // inputs:
  //      trace - a data object from gd.data
  //      axLetter - a string, either 'x' or 'y', for which item
  //          to convert (TODO: is this now always the same as
  //          the first letter of ax._id?)
  // in case the expected data isn't there, make a list of
  // integers based on the opposite data
  ax.makeCalcdata = function (trace, axLetter, opts) {
    var arrayIn, arrayOut, i, len;
    var axType = ax.type;
    var cal = axType === 'date' && trace[axLetter + 'calendar'];
    if (axLetter in trace) {
      arrayIn = trace[axLetter];
      len = trace._length || Lib.minRowLength(arrayIn);
      if (Lib.isTypedArray(arrayIn) && (axType === 'linear' || axType === 'log')) {
        if (len === arrayIn.length) {
          return arrayIn;
        } else if (arrayIn.subarray) {
          return arrayIn.subarray(0, len);
        }
      }
      if (axType === 'multicategory') {
        return setMultiCategoryIndex(arrayIn, len);
      }
      arrayOut = new Array(len);
      for (i = 0; i < len; i++) {
        arrayOut[i] = ax.d2c(arrayIn[i], 0, cal, opts);
      }
    } else {
      var v0 = axLetter + '0' in trace ? ax.d2c(trace[axLetter + '0'], 0, cal) : 0;
      var dv = trace['d' + axLetter] ? Number(trace['d' + axLetter]) : 1;

      // the opposing data, for size if we have x and dx etc
      arrayIn = trace[{
        x: 'y',
        y: 'x'
      }[axLetter]];
      len = trace._length || arrayIn.length;
      arrayOut = new Array(len);
      for (i = 0; i < len; i++) {
        arrayOut[i] = v0 + i * dv;
      }
    }

    // mask (i.e. set to BADNUM) coords that fall inside rangebreaks
    if (ax.rangebreaks) {
      for (i = 0; i < len; i++) {
        arrayOut[i] = ax.maskBreaks(arrayOut[i]);
      }
    }
    return arrayOut;
  };
  ax.isValidRange = function (range, nullOk) {
    return Array.isArray(range) && range.length === 2 && (nullOk && range[0] === null || isNumeric(ax.r2l(range[0]))) && (nullOk && range[1] === null || isNumeric(ax.r2l(range[1])));
  };
  ax.getAutorangeDflt = function (range, options) {
    var autorangeDflt = !ax.isValidRange(range, 'nullOk');
    if (autorangeDflt && options && options.reverseDflt) autorangeDflt = 'reversed';else if (range) {
      if (range[0] === null && range[1] === null) {
        autorangeDflt = true;
      } else if (range[0] === null && range[1] !== null) {
        autorangeDflt = 'min';
      } else if (range[0] !== null && range[1] === null) {
        autorangeDflt = 'max';
      }
    }
    return autorangeDflt;
  };
  ax.isReversed = function () {
    var autorange = ax.autorange;
    return autorange === 'reversed' || autorange === 'min reversed' || autorange === 'max reversed';
  };
  ax.isPtWithinRange = function (d, calendar) {
    var coord = ax.c2l(d[axLetter], null, calendar);
    var r0 = ax.r2l(ax.range[0]);
    var r1 = ax.r2l(ax.range[1]);
    if (r0 < r1) {
      return r0 <= coord && coord <= r1;
    } else {
      // Reversed axis case.
      return r1 <= coord && coord <= r0;
    }
  };
  ax._emptyCategories = function () {
    ax._categories = [];
    ax._categoriesMap = {};
  };

  // should skip if not category nor multicategory
  ax.clearCalc = function () {
    var group = ax._matchGroup;
    if (group) {
      var categories = null;
      var categoriesMap = null;
      for (var axId2 in group) {
        var ax2 = fullLayout[axisIds.id2name(axId2)];
        if (ax2._categories) {
          categories = ax2._categories;
          categoriesMap = ax2._categoriesMap;
          break;
        }
      }
      if (categories && categoriesMap) {
        ax._categories = categories;
        ax._categoriesMap = categoriesMap;
      } else {
        ax._emptyCategories();
      }
    } else {
      ax._emptyCategories();
    }
    if (ax._initialCategories) {
      for (var j = 0; j < ax._initialCategories.length; j++) {
        setCategoryIndex(ax._initialCategories[j]);
      }
    }
  };

  // sort the axis (and all the matching ones) by _initialCategories
  // returns the indices of the traces affected by the reordering
  ax.sortByInitialCategories = function () {
    var affectedTraces = [];
    ax._emptyCategories();
    if (ax._initialCategories) {
      for (var j = 0; j < ax._initialCategories.length; j++) {
        setCategoryIndex(ax._initialCategories[j]);
      }
    }
    affectedTraces = affectedTraces.concat(ax._traceIndices);

    // Propagate to matching axes
    var group = ax._matchGroup;
    for (var axId2 in group) {
      if (axId === axId2) continue;
      var ax2 = fullLayout[axisIds.id2name(axId2)];
      ax2._categories = ax._categories;
      ax2._categoriesMap = ax._categoriesMap;
      affectedTraces = affectedTraces.concat(ax2._traceIndices);
    }
    return affectedTraces;
  };

  // Propagate localization into the axis so that
  // methods in Axes can use it w/o having to pass fullLayout
  // Default (non-d3) number formatting uses separators directly
  // dates and d3-formatted numbers use the d3 locale
  // Fall back on default format for dummy axes that don't care about formatting
  var locale = fullLayout._d3locale;
  if (ax.type === 'date') {
    ax._dateFormat = locale ? locale.timeFormat : utcFormat;
    ax._extraFormat = fullLayout._extraFormat;
  }
  // occasionally we need _numFormat to pass through
  // even though it won't be needed by this axis
  ax._separators = fullLayout.separators;
  ax._numFormat = locale ? locale.numberFormat : numberFormat;

  // and for bar charts and box plots: reset forced minimum tick spacing
  delete ax._minDtick;
  delete ax._forceTick0;
};

/***/ }),

/***/ 87703:
/***/ (function(module) {

"use strict";


/*
 * Attributes 'showexponent', 'showtickprefix' and 'showticksuffix'
 * share values.
 *
 * If only 1 attribute is set,
 * the remaining attributes inherit that value.
 *
 * If 2 attributes are set to the same value,
 * the remaining attribute inherits that value.
 *
 * If 2 attributes are set to different values,
 * the remaining is set to its dflt value.
 *
 */
module.exports = function getShowAttrDflt(containerIn) {
  var showAttrsAll = ['showexponent', 'showtickprefix', 'showticksuffix'];
  var showAttrs = showAttrsAll.filter(function (a) {
    return containerIn[a] !== undefined;
  });
  var sameVal = function (a) {
    return containerIn[a] === containerIn[showAttrs[0]];
  };
  if (showAttrs.every(sameVal) || showAttrs.length === 1) {
    return containerIn[showAttrs[0]];
  }
};

/***/ }),

/***/ 12036:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var contrast = (__webpack_require__(78766).contrast);
var layoutAttributes = __webpack_require__(25829);
var getShowAttrDflt = __webpack_require__(87703);
var handleArrayContainerDefaults = __webpack_require__(59008);
module.exports = function handleTickLabelDefaults(containerIn, containerOut, coerce, axType, options) {
  if (!options) options = {};
  var labelalias = coerce('labelalias');
  if (!Lib.isPlainObject(labelalias)) delete containerOut.labelalias;
  var showAttrDflt = getShowAttrDflt(containerIn);
  var showTickLabels = coerce('showticklabels');
  if (showTickLabels) {
    if (!options.noTicklabelshift) {
      coerce('ticklabelshift');
    }
    if (!options.noTicklabelstandoff) {
      coerce('ticklabelstandoff');
    }
    var font = options.font || {};
    var contColor = containerOut.color;
    var position = containerOut.ticklabelposition || '';
    var dfltFontColor = position.indexOf('inside') !== -1 ? contrast(options.bgColor) :
    // as with titlefont.color, inherit axis.color only if one was
    // explicitly provided
    contColor && contColor !== layoutAttributes.color.dflt ? contColor : font.color;
    Lib.coerceFont(coerce, 'tickfont', font, {
      overrideDflt: {
        color: dfltFontColor
      }
    });
    if (!options.noTicklabelstep && axType !== 'multicategory' && axType !== 'log') {
      coerce('ticklabelstep');
    }
    if (!options.noAng) {
      var tickAngle = coerce('tickangle');
      if (!options.noAutotickangles && tickAngle === 'auto') {
        coerce('autotickangles');
      }
    }
    if (axType !== 'category') {
      var tickFormat = coerce('tickformat');
      handleArrayContainerDefaults(containerIn, containerOut, {
        name: 'tickformatstops',
        inclusionAttr: 'enabled',
        handleItemDefaults: tickformatstopDefaults
      });
      if (!containerOut.tickformatstops.length) {
        delete containerOut.tickformatstops;
      }
      if (!options.noExp && !tickFormat && axType !== 'date') {
        coerce('showexponent', showAttrDflt);
        coerce('exponentformat');
        coerce('minexponent');
        coerce('separatethousands');
      }
    }
  }
};
function tickformatstopDefaults(valueIn, valueOut) {
  function coerce(attr, dflt) {
    return Lib.coerce(valueIn, valueOut, layoutAttributes.tickformatstops, attr, dflt);
  }
  var enabled = coerce('enabled');
  if (enabled) {
    coerce('dtickrange');
    coerce('value');
  }
}

/***/ }),

/***/ 87433:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var layoutAttributes = __webpack_require__(25829);

/**
 * options: inherits outerTicks from axes.handleAxisDefaults
 */
module.exports = function handleTickMarkDefaults(containerIn, containerOut, coerce, options) {
  var isMinor = options.isMinor;
  var cIn = isMinor ? containerIn.minor || {} : containerIn;
  var cOut = isMinor ? containerOut.minor : containerOut;
  var lAttr = isMinor ? layoutAttributes.minor : layoutAttributes;
  var prefix = isMinor ? 'minor.' : '';
  var tickLen = Lib.coerce2(cIn, cOut, lAttr, 'ticklen', isMinor ? (containerOut.ticklen || 5) * 0.6 : undefined);
  var tickWidth = Lib.coerce2(cIn, cOut, lAttr, 'tickwidth', isMinor ? containerOut.tickwidth || 1 : undefined);
  var tickColor = Lib.coerce2(cIn, cOut, lAttr, 'tickcolor', (isMinor ? containerOut.tickcolor : undefined) || cOut.color);
  var showTicks = coerce(prefix + 'ticks', !isMinor && options.outerTicks || tickLen || tickWidth || tickColor ? 'outside' : '');
  if (!showTicks) {
    delete cOut.ticklen;
    delete cOut.tickwidth;
    delete cOut.tickcolor;
  }
};

/***/ }),

/***/ 22777:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var cleanTicks = __webpack_require__(68599);
var isArrayOrTypedArray = (__webpack_require__(34809).isArrayOrTypedArray);
var isTypedArraySpec = (__webpack_require__(87800).isTypedArraySpec);
var decodeTypedArraySpec = (__webpack_require__(87800).decodeTypedArraySpec);
module.exports = function handleTickValueDefaults(containerIn, containerOut, coerce, axType, opts) {
  if (!opts) opts = {};
  var isMinor = opts.isMinor;
  var cIn = isMinor ? containerIn.minor || {} : containerIn;
  var cOut = isMinor ? containerOut.minor : containerOut;
  var prefix = isMinor ? 'minor.' : '';
  function readInput(attr) {
    var v = cIn[attr];
    if (isTypedArraySpec(v)) v = decodeTypedArraySpec(v);
    return v !== undefined ? v : (cOut._template || {})[attr];
  }
  var _tick0 = readInput('tick0');
  var _dtick = readInput('dtick');
  var _tickvals = readInput('tickvals');
  var tickmodeDefault = isArrayOrTypedArray(_tickvals) ? 'array' : _dtick ? 'linear' : 'auto';
  var tickmode = coerce(prefix + 'tickmode', tickmodeDefault);
  if (tickmode === 'auto' || tickmode === 'sync') {
    coerce(prefix + 'nticks');
  } else if (tickmode === 'linear') {
    // dtick is usually a positive number, but there are some
    // special strings available for log or date axes
    // tick0 also has special logic
    var dtick = cOut.dtick = cleanTicks.dtick(_dtick, axType);
    cOut.tick0 = cleanTicks.tick0(_tick0, axType, containerOut.calendar, dtick);
  } else if (axType !== 'multicategory') {
    var tickvals = coerce(prefix + 'tickvals');
    if (tickvals === undefined) cOut.tickmode = 'auto';else if (!isMinor) coerce('ticktext');
  }
};

/***/ }),

/***/ 84982:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var Registry = __webpack_require__(33626);
var Lib = __webpack_require__(34809);
var Drawing = __webpack_require__(62203);
var Axes = __webpack_require__(29714);

/**
 * transitionAxes
 *
 * transition axes from one set of ranges to another, using a svg
 * transformations, similar to during panning.
 *
 * @param {DOM element | object} gd
 * @param {array} edits : array of 'edits', each item with
 * - plotinfo {object} subplot object
 * - xr0 {array} initial x-range
 * - xr1 {array} end x-range
 * - yr0 {array} initial y-range
 * - yr1 {array} end y-range
 * @param {object} transitionOpts
 * @param {function} makeOnCompleteCallback
 */
module.exports = function transitionAxes(gd, edits, transitionOpts, makeOnCompleteCallback) {
  var fullLayout = gd._fullLayout;

  // special case for redraw:false Plotly.animate that relies on this
  // to update axis-referenced layout components
  if (edits.length === 0) {
    Axes.redrawComponents(gd);
    return;
  }
  function unsetSubplotTransform(subplot) {
    var xa = subplot.xaxis;
    var ya = subplot.yaxis;
    fullLayout._defs.select('#' + subplot.clipId + '> rect').call(Drawing.setTranslate, 0, 0).call(Drawing.setScale, 1, 1);
    subplot.plot.call(Drawing.setTranslate, xa._offset, ya._offset).call(Drawing.setScale, 1, 1);
    var traceGroups = subplot.plot.selectAll('.scatterlayer .trace');

    // This is specifically directed at scatter traces, applying an inverse
    // scale to individual points to counteract the scale of the trace
    // as a whole:
    traceGroups.selectAll('.point').call(Drawing.setPointGroupScale, 1, 1);
    traceGroups.selectAll('.textpoint').call(Drawing.setTextPointsScale, 1, 1);
    traceGroups.call(Drawing.hideOutsideRangePoints, subplot);
  }
  function updateSubplot(edit, progress) {
    var plotinfo = edit.plotinfo;
    var xa = plotinfo.xaxis;
    var ya = plotinfo.yaxis;
    var xlen = xa._length;
    var ylen = ya._length;
    var editX = !!edit.xr1;
    var editY = !!edit.yr1;
    var viewBox = [];
    if (editX) {
      var xr0 = Lib.simpleMap(edit.xr0, xa.r2l);
      var xr1 = Lib.simpleMap(edit.xr1, xa.r2l);
      var dx0 = xr0[1] - xr0[0];
      var dx1 = xr1[1] - xr1[0];
      viewBox[0] = (xr0[0] * (1 - progress) + progress * xr1[0] - xr0[0]) / (xr0[1] - xr0[0]) * xlen;
      viewBox[2] = xlen * (1 - progress + progress * dx1 / dx0);
      xa.range[0] = xa.l2r(xr0[0] * (1 - progress) + progress * xr1[0]);
      xa.range[1] = xa.l2r(xr0[1] * (1 - progress) + progress * xr1[1]);
    } else {
      viewBox[0] = 0;
      viewBox[2] = xlen;
    }
    if (editY) {
      var yr0 = Lib.simpleMap(edit.yr0, ya.r2l);
      var yr1 = Lib.simpleMap(edit.yr1, ya.r2l);
      var dy0 = yr0[1] - yr0[0];
      var dy1 = yr1[1] - yr1[0];
      viewBox[1] = (yr0[1] * (1 - progress) + progress * yr1[1] - yr0[1]) / (yr0[0] - yr0[1]) * ylen;
      viewBox[3] = ylen * (1 - progress + progress * dy1 / dy0);
      ya.range[0] = xa.l2r(yr0[0] * (1 - progress) + progress * yr1[0]);
      ya.range[1] = ya.l2r(yr0[1] * (1 - progress) + progress * yr1[1]);
    } else {
      viewBox[1] = 0;
      viewBox[3] = ylen;
    }
    Axes.drawOne(gd, xa, {
      skipTitle: true
    });
    Axes.drawOne(gd, ya, {
      skipTitle: true
    });
    Axes.redrawComponents(gd, [xa._id, ya._id]);
    var xScaleFactor = editX ? xlen / viewBox[2] : 1;
    var yScaleFactor = editY ? ylen / viewBox[3] : 1;
    var clipDx = editX ? viewBox[0] : 0;
    var clipDy = editY ? viewBox[1] : 0;
    var fracDx = editX ? viewBox[0] / viewBox[2] * xlen : 0;
    var fracDy = editY ? viewBox[1] / viewBox[3] * ylen : 0;
    var plotDx = xa._offset - fracDx;
    var plotDy = ya._offset - fracDy;
    plotinfo.clipRect.call(Drawing.setTranslate, clipDx, clipDy).call(Drawing.setScale, 1 / xScaleFactor, 1 / yScaleFactor);
    plotinfo.plot.call(Drawing.setTranslate, plotDx, plotDy).call(Drawing.setScale, xScaleFactor, yScaleFactor);

    // apply an inverse scale to individual points to counteract
    // the scale of the trace group.
    Drawing.setPointGroupScale(plotinfo.zoomScalePts, 1 / xScaleFactor, 1 / yScaleFactor);
    Drawing.setTextPointsScale(plotinfo.zoomScaleTxt, 1 / xScaleFactor, 1 / yScaleFactor);
  }
  var onComplete;
  if (makeOnCompleteCallback) {
    // This module makes the choice whether or not it notifies Plotly.transition
    // about completion:
    onComplete = makeOnCompleteCallback();
  }
  function transitionComplete() {
    var aobj = {};
    for (var i = 0; i < edits.length; i++) {
      var edit = edits[i];
      var xa = edit.plotinfo.xaxis;
      var ya = edit.plotinfo.yaxis;
      if (edit.xr1) aobj[xa._name + '.range'] = edit.xr1.slice();
      if (edit.yr1) aobj[ya._name + '.range'] = edit.yr1.slice();
    }

    // Signal that this transition has completed:
    onComplete && onComplete();
    return Registry.call('relayout', gd, aobj).then(function () {
      for (var i = 0; i < edits.length; i++) {
        unsetSubplotTransform(edits[i].plotinfo);
      }
    });
  }
  function transitionInterrupt() {
    var aobj = {};
    for (var i = 0; i < edits.length; i++) {
      var edit = edits[i];
      var xa = edit.plotinfo.xaxis;
      var ya = edit.plotinfo.yaxis;
      if (edit.xr0) aobj[xa._name + '.range'] = edit.xr0.slice();
      if (edit.yr0) aobj[ya._name + '.range'] = edit.yr0.slice();
    }
    return Registry.call('relayout', gd, aobj).then(function () {
      for (var i = 0; i < edits.length; i++) {
        unsetSubplotTransform(edits[i].plotinfo);
      }
    });
  }
  var t1, t2, raf;
  var easeFn = d3.ease(transitionOpts.easing);
  gd._transitionData._interruptCallbacks.push(function () {
    window.cancelAnimationFrame(raf);
    raf = null;
    return transitionInterrupt();
  });
  function doFrame() {
    t2 = Date.now();
    var tInterp = Math.min(1, (t2 - t1) / transitionOpts.duration);
    var progress = easeFn(tInterp);
    for (var i = 0; i < edits.length; i++) {
      updateSubplot(edits[i], progress);
    }
    if (t2 - t1 > transitionOpts.duration) {
      transitionComplete();
      raf = window.cancelAnimationFrame(doFrame);
    } else {
      raf = window.requestAnimationFrame(doFrame);
    }
  }
  t1 = Date.now();
  raf = window.requestAnimationFrame(doFrame);
  return Promise.resolve();
};

/***/ }),

/***/ 4392:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var traceIs = (__webpack_require__(33626).traceIs);
var autoType = __webpack_require__(9666);

/*
 *  data: the plot data to use in choosing auto type
 *  name: axis object name (ie 'xaxis') if one should be stored
 */
module.exports = function handleTypeDefaults(containerIn, containerOut, coerce, options) {
  coerce('autotypenumbers', options.autotypenumbersDflt);
  var axType = coerce('type', (options.splomStash || {}).type);
  if (axType === '-') {
    setAutoType(containerOut, options.data);
    if (containerOut.type === '-') {
      containerOut.type = 'linear';
    } else {
      // copy autoType back to input axis
      // note that if this object didn't exist
      // in the input layout, we have to put it in
      // this happens in the main supplyDefaults function
      containerIn.type = containerOut.type;
    }
  }
};
function setAutoType(ax, data) {
  // new logic: let people specify any type they want,
  // only autotype if type is '-'
  if (ax.type !== '-') return;
  var id = ax._id;
  var axLetter = id.charAt(0);
  var i;

  // support 3d
  if (id.indexOf('scene') !== -1) id = axLetter;
  var d0 = getFirstNonEmptyTrace(data, id, axLetter);
  if (!d0) return;

  // first check for histograms, as the count direction
  // should always default to a linear axis
  if (d0.type === 'histogram' && axLetter === {
    v: 'y',
    h: 'x'
  }[d0.orientation || 'v']) {
    ax.type = 'linear';
    return;
  }
  var calAttr = axLetter + 'calendar';
  var calendar = d0[calAttr];
  var opts = {
    noMultiCategory: !traceIs(d0, 'cartesian') || traceIs(d0, 'noMultiCategory')
  };

  // To not confuse 2D x/y used for per-box sample points for multicategory coordinates
  if (d0.type === 'box' && d0._hasPreCompStats && axLetter === {
    h: 'x',
    v: 'y'
  }[d0.orientation || 'v']) {
    opts.noMultiCategory = true;
  }
  opts.autotypenumbers = ax.autotypenumbers;

  // check all boxes on this x axis to see
  // if they're dates, numbers, or categories
  if (isBoxWithoutPositionCoords(d0, axLetter)) {
    var posLetter = getBoxPosLetter(d0);
    var boxPositions = [];
    for (i = 0; i < data.length; i++) {
      var trace = data[i];
      if (!traceIs(trace, 'box-violin') || (trace[axLetter + 'axis'] || axLetter) !== id) continue;
      if (trace[posLetter] !== undefined) boxPositions.push(trace[posLetter][0]);else if (trace.name !== undefined) boxPositions.push(trace.name);else boxPositions.push('text');
      if (trace[calAttr] !== calendar) calendar = undefined;
    }
    ax.type = autoType(boxPositions, calendar, opts);
  } else if (d0.type === 'splom') {
    var dimensions = d0.dimensions;
    var dim = dimensions[d0._axesDim[id]];
    if (dim.visible) ax.type = autoType(dim.values, calendar, opts);
  } else {
    ax.type = autoType(d0[axLetter] || [d0[axLetter + '0']], calendar, opts);
  }
}
function getFirstNonEmptyTrace(data, id, axLetter) {
  for (var i = 0; i < data.length; i++) {
    var trace = data[i];
    if (trace.type === 'splom' && trace._length > 0 && (trace['_' + axLetter + 'axes'] || {})[id]) {
      return trace;
    }
    if ((trace[axLetter + 'axis'] || axLetter) === id) {
      if (isBoxWithoutPositionCoords(trace, axLetter)) {
        return trace;
      } else if ((trace[axLetter] || []).length || trace[axLetter + '0']) {
        return trace;
      }
    }
  }
}
function getBoxPosLetter(trace) {
  return {
    v: 'x',
    h: 'y'
  }[trace.orientation || 'v'];
}
function isBoxWithoutPositionCoords(trace, axLetter) {
  var posLetter = getBoxPosLetter(trace);
  var isBox = traceIs(trace, 'box-violin');
  var isCandlestick = traceIs(trace._fullInput || {}, 'candlestick');
  return isBox && !isCandlestick && axLetter === posLetter && trace[posLetter] === undefined && trace[posLetter + '0'] === undefined;
}

/***/ }),

/***/ 90251:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var Registry = __webpack_require__(33626);
var Lib = __webpack_require__(34809);

/*
 * Create or update an observer. This function is designed to be
 * idempotent so that it can be called over and over as the component
 * updates, and will attach and detach listeners as needed.
 *
 * @param {optional object} container
 *      An object on which the observer is stored. This is the mechanism
 *      by which it is idempotent. If it already exists, another won't be
 *      added. Each time it's called, the value lookup table is updated.
 * @param {array} commandList
 *      An array of commands, following either `buttons` of `updatemenus`
 *      or `steps` of `sliders`.
 * @param {function} onchange
 *      A listener called when the value is changed. Receives data object
 *      with information about the new state.
 */
exports.manageCommandObserver = function (gd, container, commandList, onchange) {
  var ret = {};
  var enabled = true;
  if (container && container._commandObserver) {
    ret = container._commandObserver;
  }
  if (!ret.cache) {
    ret.cache = {};
  }

  // Either create or just recompute this:
  ret.lookupTable = {};
  var binding = exports.hasSimpleAPICommandBindings(gd, commandList, ret.lookupTable);
  if (container && container._commandObserver) {
    if (!binding) {
      // If container exists and there are no longer any bindings,
      // remove existing:
      if (container._commandObserver.remove) {
        container._commandObserver.remove();
        container._commandObserver = null;
        return ret;
      }
    } else {
      // If container exists and there *are* bindings, then the lookup
      // table should have been updated and check is already attached,
      // so there's nothing to be done:
      return ret;
    }
  }

  // Determine whether there's anything to do for this binding:

  if (binding) {
    // Build the cache:
    bindingValueHasChanged(gd, binding, ret.cache);
    ret.check = function check() {
      if (!enabled) return;
      var update = bindingValueHasChanged(gd, binding, ret.cache);
      if (update.changed && onchange) {
        // Disable checks for the duration of this command in order to avoid
        // infinite loops:
        if (ret.lookupTable[update.value] !== undefined) {
          ret.disable();
          Promise.resolve(onchange({
            value: update.value,
            type: binding.type,
            prop: binding.prop,
            traces: binding.traces,
            index: ret.lookupTable[update.value]
          })).then(ret.enable, ret.enable);
        }
      }
      return update.changed;
    };
    var checkEvents = ['plotly_relayout', 'plotly_redraw', 'plotly_restyle', 'plotly_update', 'plotly_animatingframe', 'plotly_afterplot'];
    for (var i = 0; i < checkEvents.length; i++) {
      gd._internalOn(checkEvents[i], ret.check);
    }
    ret.remove = function () {
      for (var i = 0; i < checkEvents.length; i++) {
        gd._removeInternalListener(checkEvents[i], ret.check);
      }
    };
  } else {
    // TODO: It'd be really neat to actually give a *reason* for this, but at least a warning
    // is a start
    Lib.log('Unable to automatically bind plot updates to API command');
    ret.lookupTable = {};
    ret.remove = function () {};
  }
  ret.disable = function disable() {
    enabled = false;
  };
  ret.enable = function enable() {
    enabled = true;
  };
  if (container) {
    container._commandObserver = ret;
  }
  return ret;
};

/*
 * This function checks to see if an array of objects containing
 * method and args properties is compatible with automatic two-way
 * binding. The criteria right now are that
 *
 *   1. multiple traces may be affected
 *   2. only one property may be affected
 *   3. the same property must be affected by all commands
 */
exports.hasSimpleAPICommandBindings = function (gd, commandList, bindingsByValue) {
  var i;
  var n = commandList.length;
  var refBinding;
  for (i = 0; i < n; i++) {
    var binding;
    var command = commandList[i];
    var method = command.method;
    var args = command.args;
    if (!Array.isArray(args)) args = [];

    // If any command has no method, refuse to bind:
    if (!method) {
      return false;
    }
    var bindings = exports.computeAPICommandBindings(gd, method, args);

    // Right now, handle one and *only* one property being set:
    if (bindings.length !== 1) {
      return false;
    }
    if (!refBinding) {
      refBinding = bindings[0];
      if (Array.isArray(refBinding.traces)) {
        refBinding.traces.sort();
      }
    } else {
      binding = bindings[0];
      if (binding.type !== refBinding.type) {
        return false;
      }
      if (binding.prop !== refBinding.prop) {
        return false;
      }
      if (Array.isArray(refBinding.traces)) {
        if (Array.isArray(binding.traces)) {
          binding.traces.sort();
          for (var j = 0; j < refBinding.traces.length; j++) {
            if (refBinding.traces[j] !== binding.traces[j]) {
              return false;
            }
          }
        } else {
          return false;
        }
      } else {
        if (binding.prop !== refBinding.prop) {
          return false;
        }
      }
    }
    binding = bindings[0];
    var value = binding.value;
    if (Array.isArray(value)) {
      if (value.length === 1) {
        value = value[0];
      } else {
        return false;
      }
    }
    if (bindingsByValue) {
      bindingsByValue[value] = i;
    }
  }
  return refBinding;
};
function bindingValueHasChanged(gd, binding, cache) {
  var container, value, obj;
  var changed = false;
  if (binding.type === 'data') {
    // If it's data, we need to get a trace. Based on the limited scope
    // of what we cover, we can just take the first trace from the list,
    // or otherwise just the first trace:
    container = gd._fullData[binding.traces !== null ? binding.traces[0] : 0];
  } else if (binding.type === 'layout') {
    container = gd._fullLayout;
  } else {
    return false;
  }
  value = Lib.nestedProperty(container, binding.prop).get();
  obj = cache[binding.type] = cache[binding.type] || {};
  if (obj.hasOwnProperty(binding.prop)) {
    if (obj[binding.prop] !== value) {
      changed = true;
    }
  }
  obj[binding.prop] = value;
  return {
    changed: changed,
    value: value
  };
}

/*
 * Execute an API command. There's really not much to this; it just provides
 * a common hook so that implementations don't need to be synchronized across
 * multiple components with the ability to invoke API commands.
 *
 * @param {string} method
 *      The name of the plotly command to execute. Must be one of 'animate',
 *      'restyle', 'relayout', 'update'.
 * @param {array} args
 *      A list of arguments passed to the API command
 */
exports.executeAPICommand = function (gd, method, args) {
  if (method === 'skip') return Promise.resolve();
  var _method = Registry.apiMethodRegistry[method];
  var allArgs = [gd];
  if (!Array.isArray(args)) args = [];
  for (var i = 0; i < args.length; i++) {
    allArgs.push(args[i]);
  }
  return _method.apply(null, allArgs).catch(function (err) {
    Lib.warn('API call to Plotly.' + method + ' rejected.', err);
    return Promise.reject(err);
  });
};
exports.computeAPICommandBindings = function (gd, method, args) {
  var bindings;
  if (!Array.isArray(args)) args = [];
  switch (method) {
    case 'restyle':
      bindings = computeDataBindings(gd, args);
      break;
    case 'relayout':
      bindings = computeLayoutBindings(gd, args);
      break;
    case 'update':
      bindings = computeDataBindings(gd, [args[0], args[2]]).concat(computeLayoutBindings(gd, [args[1]]));
      break;
    case 'animate':
      bindings = computeAnimateBindings(gd, args);
      break;
    default:
      // This is the case where intelligent logic about what affects
      // this command is not implemented. It causes no ill effects.
      // For example, addFrames simply won't bind to a control component.
      bindings = [];
  }
  return bindings;
};
function computeAnimateBindings(gd, args) {
  // We'll assume that the only relevant modification an animation
  // makes that's meaningfully tracked is the frame:
  if (Array.isArray(args[0]) && args[0].length === 1 && ['string', 'number'].indexOf(typeof args[0][0]) !== -1) {
    return [{
      type: 'layout',
      prop: '_currentFrame',
      value: args[0][0].toString()
    }];
  } else {
    return [];
  }
}
function computeLayoutBindings(gd, args) {
  var bindings = [];
  var astr = args[0];
  var aobj = {};
  if (typeof astr === 'string') {
    aobj[astr] = args[1];
  } else if (Lib.isPlainObject(astr)) {
    aobj = astr;
  } else {
    return bindings;
  }
  crawl(aobj, function (path, attrName, attr) {
    bindings.push({
      type: 'layout',
      prop: path,
      value: attr
    });
  }, '', 0);
  return bindings;
}
function computeDataBindings(gd, args) {
  var traces, astr, val, aobj;
  var bindings = [];

  // Logic copied from Plotly.restyle:
  astr = args[0];
  val = args[1];
  traces = args[2];
  aobj = {};
  if (typeof astr === 'string') {
    aobj[astr] = val;
  } else if (Lib.isPlainObject(astr)) {
    // the 3-arg form
    aobj = astr;
    if (traces === undefined) {
      traces = val;
    }
  } else {
    return bindings;
  }
  if (traces === undefined) {
    // Explicitly assign this to null instead of undefined:
    traces = null;
  }
  crawl(aobj, function (path, attrName, _attr) {
    var thisTraces;
    var attr;
    if (Array.isArray(_attr)) {
      attr = _attr.slice();
      var nAttr = Math.min(attr.length, gd.data.length);
      if (traces) {
        nAttr = Math.min(nAttr, traces.length);
      }
      thisTraces = [];
      for (var j = 0; j < nAttr; j++) {
        thisTraces[j] = traces ? traces[j] : j;
      }
    } else {
      attr = _attr;
      thisTraces = traces ? traces.slice() : null;
    }

    // Convert [7] to just 7 when traces is null:
    if (thisTraces === null) {
      if (Array.isArray(attr)) {
        attr = attr[0];
      }
    } else if (Array.isArray(thisTraces)) {
      if (!Array.isArray(attr)) {
        var tmp = attr;
        attr = [];
        for (var i = 0; i < thisTraces.length; i++) {
          attr[i] = tmp;
        }
      }
      attr.length = Math.min(thisTraces.length, attr.length);
    }
    bindings.push({
      type: 'data',
      prop: path,
      traces: thisTraces,
      value: attr
    });
  }, '', 0);
  return bindings;
}
function crawl(attrs, callback, path, depth) {
  Object.keys(attrs).forEach(function (attrName) {
    var attr = attrs[attrName];
    if (attrName[0] === '_') return;
    var thisPath = path + (depth > 0 ? '.' : '') + attrName;
    if (Lib.isPlainObject(attr)) {
      crawl(attr, callback, thisPath, depth + 1);
    } else {
      // Only execute the callback on leaf nodes:
      callback(thisPath, attrName, attr);
    }
  });
}

/***/ }),

/***/ 13792:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var extendFlat = (__webpack_require__(93049).extendFlat);

/**
 * Make a xy domain attribute group
 *
 * @param {object} opts
 *   @param {string}
 *     opts.name: name to be inserted in the default description
 *   @param {boolean}
 *     opts.trace: set to true for trace containers
 *   @param {string}
 *     opts.editType: editType for all pieces
 *   @param {boolean}
 *     opts.noGridCell: set to true to omit `row` and `column`
 *
 * @param {object} extra
 *   @param {string}
 *     extra.description: extra description. N.B we use
 *     a separate extra container to make it compatible with
 *     the compress_attributes transform.
 *
 * @return {object} attributes object containing {x,y} as specified
 */
exports.u = function (opts, extra) {
  opts = opts || {};
  extra = extra || {};
  var base = {
    valType: 'info_array',
    editType: opts.editType,
    items: [{
      valType: 'number',
      min: 0,
      max: 1,
      editType: opts.editType
    }, {
      valType: 'number',
      min: 0,
      max: 1,
      editType: opts.editType
    }],
    dflt: [0, 1]
  };
  var namePart = opts.name ? opts.name + ' ' : '';
  var contPart = opts.trace ? 'trace ' : 'subplot ';
  var descPart = extra.description ? ' ' + extra.description : '';
  var out = {
    x: extendFlat({}, base, {}),
    y: extendFlat({}, base, {}),
    editType: opts.editType
  };
  if (!opts.noGridCell) {
    out.row = {
      valType: 'integer',
      min: 0,
      dflt: 0,
      editType: opts.editType
    };
    out.column = {
      valType: 'integer',
      min: 0,
      dflt: 0,
      editType: opts.editType
    };
  }
  return out;
};
exports.N = function (containerOut, layout, coerce, dfltDomains) {
  var dfltX = dfltDomains && dfltDomains.x || [0, 1];
  var dfltY = dfltDomains && dfltDomains.y || [0, 1];
  var grid = layout.grid;
  if (grid) {
    var column = coerce('domain.column');
    if (column !== undefined) {
      if (column < grid.columns) dfltX = grid._domains.x[column];else delete containerOut.domain.column;
    }
    var row = coerce('domain.row');
    if (row !== undefined) {
      if (row < grid.rows) dfltY = grid._domains.y[row];else delete containerOut.domain.row;
    }
  }
  var x = coerce('domain.x', dfltX);
  var y = coerce('domain.y', dfltY);

  // don't accept bad input data
  if (!(x[0] < x[1])) containerOut.domain.x = dfltX.slice();
  if (!(y[0] < y[1])) containerOut.domain.y = dfltY.slice();
};

/***/ }),

/***/ 80337:
/***/ (function(module) {

"use strict";


/*
 * make a font attribute group
 *
 * @param {object} opts
 *   @param {string}
 *     opts.description: where & how this font is used
 *   @param {optional bool} arrayOk:
 *     should each part (family, size, color) be arrayOk? default false.
 *   @param {string} editType:
 *     the editType for all pieces of this font
 *   @param {optional string} colorEditType:
 *     a separate editType just for color
 *
 * @return {object} attributes object containing {family, size, color} as specified
 */
module.exports = function (opts) {
  var variantValues = opts.variantValues;
  var editType = opts.editType;
  var colorEditType = opts.colorEditType;
  if (colorEditType === undefined) colorEditType = editType;
  var weight = {
    editType: editType,
    valType: 'integer',
    min: 1,
    max: 1000,
    extras: ['normal', 'bold'],
    dflt: 'normal'
  };
  if (opts.noNumericWeightValues) {
    weight.valType = 'enumerated';
    weight.values = weight.extras;
    weight.extras = undefined;
    weight.min = undefined;
    weight.max = undefined;
  }
  var attrs = {
    family: {
      valType: 'string',
      noBlank: true,
      strict: true,
      editType: editType
    },
    size: {
      valType: 'number',
      min: 1,
      editType: editType
    },
    color: {
      valType: 'color',
      editType: colorEditType
    },
    weight: weight,
    style: {
      editType: editType,
      valType: 'enumerated',
      values: ['normal', 'italic'],
      dflt: 'normal'
    },
    variant: opts.noFontVariant ? undefined : {
      editType: editType,
      valType: 'enumerated',
      values: variantValues || ['normal', 'small-caps', 'all-small-caps', 'all-petite-caps', 'petite-caps', 'unicase'],
      dflt: 'normal'
    },
    textcase: opts.noFontTextcase ? undefined : {
      editType: editType,
      valType: 'enumerated',
      values: ['normal', 'word caps', 'upper', 'lower'],
      dflt: 'normal'
    },
    lineposition: opts.noFontLineposition ? undefined : {
      editType: editType,
      valType: 'flaglist',
      flags: ['under', 'over', 'through'],
      extras: ['none'],
      dflt: 'none'
    },
    shadow: opts.noFontShadow ? undefined : {
      editType: editType,
      valType: 'string',
      dflt: opts.autoShadowDflt ? 'auto' : 'none'
    },
    editType: editType
    // blank strings so compress_attributes can remove
    // TODO - that's uber hacky... better solution?
  };
  if (opts.autoSize) attrs.size.dflt = 'auto';
  if (opts.autoColor) attrs.color.dflt = 'auto';
  if (opts.arrayOk) {
    attrs.family.arrayOk = true;
    attrs.weight.arrayOk = true;
    attrs.style.arrayOk = true;
    if (!opts.noFontVariant) {
      attrs.variant.arrayOk = true;
    }
    if (!opts.noFontTextcase) {
      attrs.textcase.arrayOk = true;
    }
    if (!opts.noFontLineposition) {
      attrs.lineposition.arrayOk = true;
    }
    if (!opts.noFontShadow) {
      attrs.shadow.arrayOk = true;
    }
    attrs.size.arrayOk = true;
    attrs.color.arrayOk = true;
  }
  return attrs;
};

/***/ }),

/***/ 58935:
/***/ (function(module) {

"use strict";


module.exports = {
  _isLinkedToArray: 'frames_entry',
  group: {
    valType: 'string'
  },
  name: {
    valType: 'string'
  },
  traces: {
    valType: 'any'
  },
  baseframe: {
    valType: 'string'
  },
  data: {
    valType: 'any'
  },
  layout: {
    valType: 'any'
  }
};

/***/ }),

/***/ 74285:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


// projection names to d3 function name
exports.projNames = {
  airy: 'airy',
  aitoff: 'aitoff',
  'albers usa': 'albersUsa',
  albers: 'albers',
  // 'armadillo': 'armadillo',
  august: 'august',
  'azimuthal equal area': 'azimuthalEqualArea',
  'azimuthal equidistant': 'azimuthalEquidistant',
  baker: 'baker',
  // 'berghaus': 'berghaus',
  bertin1953: 'bertin1953',
  boggs: 'boggs',
  bonne: 'bonne',
  bottomley: 'bottomley',
  bromley: 'bromley',
  // 'chamberlin africa': 'chamberlinAfrica',
  // 'chamberlin': 'chamberlin',
  collignon: 'collignon',
  'conic conformal': 'conicConformal',
  'conic equal area': 'conicEqualArea',
  'conic equidistant': 'conicEquidistant',
  craig: 'craig',
  craster: 'craster',
  'cylindrical equal area': 'cylindricalEqualArea',
  'cylindrical stereographic': 'cylindricalStereographic',
  eckert1: 'eckert1',
  eckert2: 'eckert2',
  eckert3: 'eckert3',
  eckert4: 'eckert4',
  eckert5: 'eckert5',
  eckert6: 'eckert6',
  eisenlohr: 'eisenlohr',
  'equal earth': 'equalEarth',
  equirectangular: 'equirectangular',
  fahey: 'fahey',
  'foucaut sinusoidal': 'foucautSinusoidal',
  foucaut: 'foucaut',
  // 'gilbert': 'gilbert',
  // 'gingery': 'gingery',
  ginzburg4: 'ginzburg4',
  ginzburg5: 'ginzburg5',
  ginzburg6: 'ginzburg6',
  ginzburg8: 'ginzburg8',
  ginzburg9: 'ginzburg9',
  gnomonic: 'gnomonic',
  'gringorten quincuncial': 'gringortenQuincuncial',
  gringorten: 'gringorten',
  guyou: 'guyou',
  // 'hammer retroazimuthal': 'hammerRetroazimuthal',
  hammer: 'hammer',
  // 'healpix': 'healpix',
  hill: 'hill',
  homolosine: 'homolosine',
  hufnagel: 'hufnagel',
  hyperelliptical: 'hyperelliptical',
  // 'interrupted boggs': 'interruptedBoggs',
  // 'interrupted homolosine': 'interruptedHomolosine',
  // 'interrupted mollweide hemispheres': 'interruptedMollweideHemispheres',
  // 'interrupted mollweide': 'interruptedMollweide',
  // 'interrupted quartic authalic': 'interruptedQuarticAuthalic',
  // 'interrupted sinu mollweide': 'interruptedSinuMollweide',
  // 'interrupted sinusoidal': 'interruptedSinusoidal',
  kavrayskiy7: 'kavrayskiy7',
  lagrange: 'lagrange',
  larrivee: 'larrivee',
  laskowski: 'laskowski',
  // 'littrow': 'littrow',
  loximuthal: 'loximuthal',
  mercator: 'mercator',
  miller: 'miller',
  // 'modified stereographic alaska': 'modifiedStereographicAlaska',
  // 'modified stereographic gs48': 'modifiedStereographicGs48',
  // 'modified stereographic gs50': 'modifiedStereographicGs50',
  // 'modified stereographic lee': 'modifiedStereographicLee',
  // 'modified stereographic miller': 'modifiedStereographicMiller',
  // 'modified stereographic': 'modifiedStereographic',
  mollweide: 'mollweide',
  'mt flat polar parabolic': 'mtFlatPolarParabolic',
  'mt flat polar quartic': 'mtFlatPolarQuartic',
  'mt flat polar sinusoidal': 'mtFlatPolarSinusoidal',
  'natural earth': 'naturalEarth',
  'natural earth1': 'naturalEarth1',
  'natural earth2': 'naturalEarth2',
  'nell hammer': 'nellHammer',
  nicolosi: 'nicolosi',
  orthographic: 'orthographic',
  patterson: 'patterson',
  'peirce quincuncial': 'peirceQuincuncial',
  polyconic: 'polyconic',
  // 'polyhedral butterfly': 'polyhedralButterfly',
  // 'polyhedral collignon': 'polyhedralCollignon',
  // 'polyhedral waterman': 'polyhedralWaterman',
  'rectangular polyconic': 'rectangularPolyconic',
  robinson: 'robinson',
  satellite: 'satellite',
  'sinu mollweide': 'sinuMollweide',
  sinusoidal: 'sinusoidal',
  stereographic: 'stereographic',
  times: 'times',
  'transverse mercator': 'transverseMercator',
  // 'two point azimuthalUsa': 'twoPointAzimuthalUsa',
  // 'two point azimuthal': 'twoPointAzimuthal',
  // 'two point equidistantUsa': 'twoPointEquidistantUsa',
  // 'two point equidistant': 'twoPointEquidistant',
  'van der grinten': 'vanDerGrinten',
  'van der grinten2': 'vanDerGrinten2',
  'van der grinten3': 'vanDerGrinten3',
  'van der grinten4': 'vanDerGrinten4',
  wagner4: 'wagner4',
  wagner6: 'wagner6',
  // 'wagner7': 'wagner7',
  // 'wagner': 'wagner',
  wiechel: 'wiechel',
  'winkel tripel': 'winkel3',
  winkel3: 'winkel3'
};

// name of the axes
exports.axesNames = ['lonaxis', 'lataxis'];

// max longitudinal angular span (EXPERIMENTAL)
exports.lonaxisSpan = {
  orthographic: 180,
  'azimuthal equal area': 360,
  'azimuthal equidistant': 360,
  'conic conformal': 180,
  gnomonic: 160,
  stereographic: 180,
  'transverse mercator': 180,
  '*': 360
};

// max latitudinal angular span (EXPERIMENTAL)
exports.lataxisSpan = {
  'conic conformal': 150,
  stereographic: 179.5,
  '*': 180
};

// defaults for each scope
exports.scopeDefaults = {
  world: {
    lonaxisRange: [-180, 180],
    lataxisRange: [-90, 90],
    projType: 'equirectangular',
    projRotate: [0, 0, 0]
  },
  usa: {
    lonaxisRange: [-180, -50],
    lataxisRange: [15, 80],
    projType: 'albers usa'
  },
  europe: {
    lonaxisRange: [-30, 60],
    lataxisRange: [30, 85],
    projType: 'conic conformal',
    projRotate: [15, 0, 0],
    projParallels: [0, 60]
  },
  asia: {
    lonaxisRange: [22, 160],
    lataxisRange: [-15, 55],
    projType: 'mercator',
    projRotate: [0, 0, 0]
  },
  africa: {
    lonaxisRange: [-30, 60],
    lataxisRange: [-40, 40],
    projType: 'mercator',
    projRotate: [0, 0, 0]
  },
  'north america': {
    lonaxisRange: [-180, -45],
    lataxisRange: [5, 85],
    projType: 'conic conformal',
    projRotate: [-100, 0, 0],
    projParallels: [29.5, 45.5]
  },
  'south america': {
    lonaxisRange: [-100, -30],
    lataxisRange: [-60, 15],
    projType: 'mercator',
    projRotate: [0, 0, 0]
  }
};

// angular pad to avoid rounding error around clip angles
exports.clipPad = 1e-3;

// map projection precision
exports.precision = 0.1;

// default land and water fill colors
exports.landColor = '#F0DC82';
exports.waterColor = '#3399FF';

// locationmode to layer name
exports.locationmodeToLayer = {
  'ISO-3': 'countries',
  'USA-states': 'subunits',
  'country names': 'countries'
};

// SVG element for a sphere (use to frame maps)
exports.sphereSVG = {
  type: 'Sphere'
};

// N.B. base layer names must be the same as in the topojson files

// base layer with a fill color
exports.fillLayers = {
  ocean: 1,
  land: 1,
  lakes: 1
};

// base layer with a only a line color
exports.lineLayers = {
  subunits: 1,
  countries: 1,
  coastlines: 1,
  rivers: 1,
  frame: 1
};
exports.layers = ['bg', 'ocean', 'land', 'lakes', 'subunits', 'countries', 'coastlines', 'rivers', 'lataxis', 'lonaxis', 'frame', 'backplot', 'frontplot'];
exports.layersForChoropleth = ['bg', 'ocean', 'land', 'subunits', 'countries', 'coastlines', 'lataxis', 'lonaxis', 'frame', 'backplot', 'rivers', 'lakes', 'frontplot'];
exports.layerNameToAdjective = {
  ocean: 'ocean',
  land: 'land',
  lakes: 'lake',
  subunits: 'subunit',
  countries: 'country',
  coastlines: 'coastline',
  rivers: 'river',
  frame: 'frame'
};

/***/ }),

/***/ 6493:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


/* global PlotlyGeoAssets:false */
var d3 = __webpack_require__(45568);
var geo = __webpack_require__(70884);
var geoPath = geo.geoPath;
var geoDistance = geo.geoDistance;
var geoProjection = __webpack_require__(75987);
var Registry = __webpack_require__(33626);
var Lib = __webpack_require__(34809);
var strTranslate = Lib.strTranslate;
var Color = __webpack_require__(78766);
var Drawing = __webpack_require__(62203);
var Fx = __webpack_require__(32141);
var Plots = __webpack_require__(44122);
var Axes = __webpack_require__(29714);
var getAutoRange = (__webpack_require__(32919).getAutoRange);
var dragElement = __webpack_require__(14751);
var prepSelect = (__webpack_require__(44844).prepSelect);
var clearOutline = (__webpack_require__(44844).clearOutline);
var selectOnClick = (__webpack_require__(44844).selectOnClick);
var createGeoZoom = __webpack_require__(14309);
var constants = __webpack_require__(74285);
var geoUtils = __webpack_require__(3994);
var topojsonUtils = __webpack_require__(11577);
var topojsonFeature = (__webpack_require__(48640)/* .feature */ .N4);
function Geo(opts) {
  this.id = opts.id;
  this.graphDiv = opts.graphDiv;
  this.container = opts.container;
  this.topojsonURL = opts.topojsonURL;
  this.isStatic = opts.staticPlot;
  this.topojsonName = null;
  this.topojson = null;
  this.projection = null;
  this.scope = null;
  this.viewInitial = null;
  this.fitScale = null;
  this.bounds = null;
  this.midPt = null;
  this.hasChoropleth = false;
  this.traceHash = {};
  this.layers = {};
  this.basePaths = {};
  this.dataPaths = {};
  this.dataPoints = {};
  this.clipDef = null;
  this.clipRect = null;
  this.bgRect = null;
  this.makeFramework();
}
var proto = Geo.prototype;
module.exports = function createGeo(opts) {
  return new Geo(opts);
};
proto.plot = function (geoCalcData, fullLayout, promises, replot) {
  var _this = this;
  if (replot) return _this.update(geoCalcData, fullLayout, true);
  _this._geoCalcData = geoCalcData;
  _this._fullLayout = fullLayout;
  var geoLayout = fullLayout[this.id];
  var geoPromises = [];
  var needsTopojson = false;
  for (var k in constants.layerNameToAdjective) {
    if (k !== 'frame' && geoLayout['show' + k]) {
      needsTopojson = true;
      break;
    }
  }
  var hasMarkerAngles = false;
  for (var i = 0; i < geoCalcData.length; i++) {
    var trace = geoCalcData[0][0].trace;
    trace._geo = _this;
    if (trace.locationmode) {
      needsTopojson = true;
    }
    var marker = trace.marker;
    if (marker) {
      var angle = marker.angle;
      var angleref = marker.angleref;
      if (angle || angleref === 'north' || angleref === 'previous') hasMarkerAngles = true;
    }
  }
  this._hasMarkerAngles = hasMarkerAngles;
  if (needsTopojson) {
    var topojsonNameNew = topojsonUtils.getTopojsonName(geoLayout);
    if (_this.topojson === null || topojsonNameNew !== _this.topojsonName) {
      _this.topojsonName = topojsonNameNew;
      if (PlotlyGeoAssets.topojson[_this.topojsonName] === undefined) {
        geoPromises.push(_this.fetchTopojson());
      }
    }
  }
  geoPromises = geoPromises.concat(geoUtils.fetchTraceGeoData(geoCalcData));
  promises.push(new Promise(function (resolve, reject) {
    Promise.all(geoPromises).then(function () {
      _this.topojson = PlotlyGeoAssets.topojson[_this.topojsonName];
      _this.update(geoCalcData, fullLayout);
      resolve();
    }).catch(reject);
  }));
};
proto.fetchTopojson = function () {
  var _this = this;
  var topojsonPath = topojsonUtils.getTopojsonPath(_this.topojsonURL, _this.topojsonName);
  return new Promise(function (resolve, reject) {
    d3.json(topojsonPath, function (err, topojson) {
      if (err) {
        if (err.status === 404) {
          return reject(new Error(['plotly.js could not find topojson file at', topojsonPath + '.', 'Make sure the *topojsonURL* plot config option', 'is set properly.'].join(' ')));
        } else {
          return reject(new Error(['unexpected error while fetching topojson file at', topojsonPath].join(' ')));
        }
      }
      PlotlyGeoAssets.topojson[_this.topojsonName] = topojson;
      resolve();
    });
  });
};
proto.update = function (geoCalcData, fullLayout, replot) {
  var geoLayout = fullLayout[this.id];

  // important: maps with choropleth traces have a different layer order
  this.hasChoropleth = false;
  for (var i = 0; i < geoCalcData.length; i++) {
    var calcTrace = geoCalcData[i];
    var trace = calcTrace[0].trace;
    if (trace.type === 'choropleth') {
      this.hasChoropleth = true;
    }
    if (trace.visible === true && trace._length > 0) {
      trace._module.calcGeoJSON(calcTrace, fullLayout);
    }
  }
  if (!replot) {
    var hasInvalidBounds = this.updateProjection(geoCalcData, fullLayout);
    if (hasInvalidBounds) return;
    if (!this.viewInitial || this.scope !== geoLayout.scope) {
      this.saveViewInitial(geoLayout);
    }
  }
  this.scope = geoLayout.scope;
  this.updateBaseLayers(fullLayout, geoLayout);
  this.updateDims(fullLayout, geoLayout);
  this.updateFx(fullLayout, geoLayout);
  Plots.generalUpdatePerTraceModule(this.graphDiv, this, geoCalcData, geoLayout);
  var scatterLayer = this.layers.frontplot.select('.scatterlayer');
  this.dataPoints.point = scatterLayer.selectAll('.point');
  this.dataPoints.text = scatterLayer.selectAll('text');
  this.dataPaths.line = scatterLayer.selectAll('.js-line');
  var choroplethLayer = this.layers.backplot.select('.choroplethlayer');
  this.dataPaths.choropleth = choroplethLayer.selectAll('path');
  this._render();
};
proto.updateProjection = function (geoCalcData, fullLayout) {
  var gd = this.graphDiv;
  var geoLayout = fullLayout[this.id];
  var gs = fullLayout._size;
  var domain = geoLayout.domain;
  var projLayout = geoLayout.projection;
  var lonaxis = geoLayout.lonaxis;
  var lataxis = geoLayout.lataxis;
  var axLon = lonaxis._ax;
  var axLat = lataxis._ax;
  var projection = this.projection = getProjection(geoLayout);

  // setup subplot extent [[x0,y0], [x1,y1]]
  var extent = [[gs.l + gs.w * domain.x[0], gs.t + gs.h * (1 - domain.y[1])], [gs.l + gs.w * domain.x[1], gs.t + gs.h * (1 - domain.y[0])]];
  var center = geoLayout.center || {};
  var rotation = projLayout.rotation || {};
  var lonaxisRange = lonaxis.range || [];
  var lataxisRange = lataxis.range || [];
  if (geoLayout.fitbounds) {
    axLon._length = extent[1][0] - extent[0][0];
    axLat._length = extent[1][1] - extent[0][1];
    axLon.range = getAutoRange(gd, axLon);
    axLat.range = getAutoRange(gd, axLat);
    var midLon = (axLon.range[0] + axLon.range[1]) / 2;
    var midLat = (axLat.range[0] + axLat.range[1]) / 2;
    if (geoLayout._isScoped) {
      center = {
        lon: midLon,
        lat: midLat
      };
    } else if (geoLayout._isClipped) {
      center = {
        lon: midLon,
        lat: midLat
      };
      rotation = {
        lon: midLon,
        lat: midLat,
        roll: rotation.roll
      };
      var projType = projLayout.type;
      var lonHalfSpan = constants.lonaxisSpan[projType] / 2 || 180;
      var latHalfSpan = constants.lataxisSpan[projType] / 2 || 90;
      lonaxisRange = [midLon - lonHalfSpan, midLon + lonHalfSpan];
      lataxisRange = [midLat - latHalfSpan, midLat + latHalfSpan];
    } else {
      center = {
        lon: midLon,
        lat: midLat
      };
      rotation = {
        lon: midLon,
        lat: rotation.lat,
        roll: rotation.roll
      };
    }
  }

  // set 'pre-fit' projection
  projection.center([center.lon - rotation.lon, center.lat - rotation.lat]).rotate([-rotation.lon, -rotation.lat, rotation.roll]).parallels(projLayout.parallels);

  // fit projection 'scale' and 'translate' to set lon/lat ranges
  var rangeBox = makeRangeBox(lonaxisRange, lataxisRange);
  projection.fitExtent(extent, rangeBox);
  var b = this.bounds = projection.getBounds(rangeBox);
  var s = this.fitScale = projection.scale();
  var t = projection.translate();
  if (geoLayout.fitbounds) {
    var b2 = projection.getBounds(makeRangeBox(axLon.range, axLat.range));
    var k2 = Math.min((b[1][0] - b[0][0]) / (b2[1][0] - b2[0][0]), (b[1][1] - b[0][1]) / (b2[1][1] - b2[0][1]));
    if (isFinite(k2)) {
      projection.scale(k2 * s);
    } else {
      Lib.warn('Something went wrong during' + this.id + 'fitbounds computations.');
    }
  } else {
    // adjust projection to user setting
    projection.scale(projLayout.scale * s);
  }

  // px coordinates of view mid-point,
  // useful to update `geo.center` after interactions
  var midPt = this.midPt = [(b[0][0] + b[1][0]) / 2, (b[0][1] + b[1][1]) / 2];
  projection.translate([t[0] + (midPt[0] - t[0]), t[1] + (midPt[1] - t[1])]).clipExtent(b);

  // the 'albers usa' projection does not expose a 'center' method
  // so here's this hack to make it respond to 'geoLayout.center'
  if (geoLayout._isAlbersUsa) {
    var centerPx = projection([center.lon, center.lat]);
    var tt = projection.translate();
    projection.translate([tt[0] - (centerPx[0] - tt[0]), tt[1] - (centerPx[1] - tt[1])]);
  }
};
proto.updateBaseLayers = function (fullLayout, geoLayout) {
  var _this = this;
  var topojson = _this.topojson;
  var layers = _this.layers;
  var basePaths = _this.basePaths;
  function isAxisLayer(d) {
    return d === 'lonaxis' || d === 'lataxis';
  }
  function isLineLayer(d) {
    return Boolean(constants.lineLayers[d]);
  }
  function isFillLayer(d) {
    return Boolean(constants.fillLayers[d]);
  }
  var allLayers = this.hasChoropleth ? constants.layersForChoropleth : constants.layers;
  var layerData = allLayers.filter(function (d) {
    return isLineLayer(d) || isFillLayer(d) ? geoLayout['show' + d] : isAxisLayer(d) ? geoLayout[d].showgrid : true;
  });
  var join = _this.framework.selectAll('.layer').data(layerData, String);
  join.exit().each(function (d) {
    delete layers[d];
    delete basePaths[d];
    d3.select(this).remove();
  });
  join.enter().append('g').attr('class', function (d) {
    return 'layer ' + d;
  }).each(function (d) {
    var layer = layers[d] = d3.select(this);
    if (d === 'bg') {
      _this.bgRect = layer.append('rect').style('pointer-events', 'all');
    } else if (isAxisLayer(d)) {
      basePaths[d] = layer.append('path').style('fill', 'none');
    } else if (d === 'backplot') {
      layer.append('g').classed('choroplethlayer', true);
    } else if (d === 'frontplot') {
      layer.append('g').classed('scatterlayer', true);
    } else if (isLineLayer(d)) {
      basePaths[d] = layer.append('path').style('fill', 'none').style('stroke-miterlimit', 2);
    } else if (isFillLayer(d)) {
      basePaths[d] = layer.append('path').style('stroke', 'none');
    }
  });
  join.order();
  join.each(function (d) {
    var path = basePaths[d];
    var adj = constants.layerNameToAdjective[d];
    if (d === 'frame') {
      path.datum(constants.sphereSVG);
    } else if (isLineLayer(d) || isFillLayer(d)) {
      path.datum(topojsonFeature(topojson, topojson.objects[d]));
    } else if (isAxisLayer(d)) {
      path.datum(makeGraticule(d, geoLayout, fullLayout)).call(Color.stroke, geoLayout[d].gridcolor).call(Drawing.dashLine, geoLayout[d].griddash, geoLayout[d].gridwidth);
    }
    if (isLineLayer(d)) {
      path.call(Color.stroke, geoLayout[adj + 'color']).call(Drawing.dashLine, '', geoLayout[adj + 'width']);
    } else if (isFillLayer(d)) {
      path.call(Color.fill, geoLayout[adj + 'color']);
    }
  });
};
proto.updateDims = function (fullLayout, geoLayout) {
  var b = this.bounds;
  var hFrameWidth = (geoLayout.framewidth || 0) / 2;
  var l = b[0][0] - hFrameWidth;
  var t = b[0][1] - hFrameWidth;
  var w = b[1][0] - l + hFrameWidth;
  var h = b[1][1] - t + hFrameWidth;
  Drawing.setRect(this.clipRect, l, t, w, h);
  this.bgRect.call(Drawing.setRect, l, t, w, h).call(Color.fill, geoLayout.bgcolor);
  this.xaxis._offset = l;
  this.xaxis._length = w;
  this.yaxis._offset = t;
  this.yaxis._length = h;
};
proto.updateFx = function (fullLayout, geoLayout) {
  var _this = this;
  var gd = _this.graphDiv;
  var bgRect = _this.bgRect;
  var dragMode = fullLayout.dragmode;
  var clickMode = fullLayout.clickmode;
  if (_this.isStatic) return;
  function zoomReset() {
    var viewInitial = _this.viewInitial;
    var updateObj = {};
    for (var k in viewInitial) {
      updateObj[_this.id + '.' + k] = viewInitial[k];
    }
    Registry.call('_guiRelayout', gd, updateObj);
    gd.emit('plotly_doubleclick', null);
  }
  function invert(lonlat) {
    return _this.projection.invert([lonlat[0] + _this.xaxis._offset, lonlat[1] + _this.yaxis._offset]);
  }
  var fillRangeItems = function (eventData, poly) {
    if (poly.isRect) {
      var ranges = eventData.range = {};
      ranges[_this.id] = [invert([poly.xmin, poly.ymin]), invert([poly.xmax, poly.ymax])];
    } else {
      var dataPts = eventData.lassoPoints = {};
      dataPts[_this.id] = poly.map(invert);
    }
  };

  // Note: dragOptions is needed to be declared for all dragmodes because
  // it's the object that holds persistent selection state.
  var dragOptions = {
    element: _this.bgRect.node(),
    gd: gd,
    plotinfo: {
      id: _this.id,
      xaxis: _this.xaxis,
      yaxis: _this.yaxis,
      fillRangeItems: fillRangeItems
    },
    xaxes: [_this.xaxis],
    yaxes: [_this.yaxis],
    subplot: _this.id,
    clickFn: function (numClicks) {
      if (numClicks === 2) {
        clearOutline(gd);
      }
    }
  };
  if (dragMode === 'pan') {
    bgRect.node().onmousedown = null;
    bgRect.call(createGeoZoom(_this, geoLayout));
    bgRect.on('dblclick.zoom', zoomReset);
    if (!gd._context._scrollZoom.geo) {
      bgRect.on('wheel.zoom', null);
    }
  } else if (dragMode === 'select' || dragMode === 'lasso') {
    bgRect.on('.zoom', null);
    dragOptions.prepFn = function (e, startX, startY) {
      prepSelect(e, startX, startY, dragOptions, dragMode);
    };
    dragElement.init(dragOptions);
  }
  bgRect.on('mousemove', function () {
    var lonlat = _this.projection.invert(Lib.getPositionFromD3Event());
    if (!lonlat) {
      return dragElement.unhover(gd, d3.event);
    }
    _this.xaxis.p2c = function () {
      return lonlat[0];
    };
    _this.yaxis.p2c = function () {
      return lonlat[1];
    };
    Fx.hover(gd, d3.event, _this.id);
  });
  bgRect.on('mouseout', function () {
    if (gd._dragging) return;
    dragElement.unhover(gd, d3.event);
  });
  bgRect.on('click', function () {
    // For select and lasso the dragElement is handling clicks
    if (dragMode !== 'select' && dragMode !== 'lasso') {
      if (clickMode.indexOf('select') > -1) {
        selectOnClick(d3.event, gd, [_this.xaxis], [_this.yaxis], _this.id, dragOptions);
      }
      if (clickMode.indexOf('event') > -1) {
        // TODO: like pie and maps, this doesn't support right-click
        // actually this one is worse, as right-click starts a pan, or leaves
        // select in a weird state.
        // Also, only tangentially related, we should cancel hover during pan
        Fx.click(gd, d3.event);
      }
    }
  });
};
proto.makeFramework = function () {
  var _this = this;
  var gd = _this.graphDiv;
  var fullLayout = gd._fullLayout;
  var clipId = 'clip' + fullLayout._uid + _this.id;
  _this.clipDef = fullLayout._clips.append('clipPath').attr('id', clipId);
  _this.clipRect = _this.clipDef.append('rect');
  _this.framework = d3.select(_this.container).append('g').attr('class', 'geo ' + _this.id).call(Drawing.setClipUrl, clipId, gd);

  // sane lonlat to px
  _this.project = function (v) {
    var px = _this.projection(v);
    return px ? [px[0] - _this.xaxis._offset, px[1] - _this.yaxis._offset] : [null, null];
  };
  _this.xaxis = {
    _id: 'x',
    c2p: function (v) {
      return _this.project(v)[0];
    }
  };
  _this.yaxis = {
    _id: 'y',
    c2p: function (v) {
      return _this.project(v)[1];
    }
  };

  // mock axis for hover formatting
  _this.mockAxis = {
    type: 'linear',
    showexponent: 'all',
    exponentformat: 'B'
  };
  Axes.setConvert(_this.mockAxis, fullLayout);
};
proto.saveViewInitial = function (geoLayout) {
  var center = geoLayout.center || {};
  var projLayout = geoLayout.projection;
  var rotation = projLayout.rotation || {};
  this.viewInitial = {
    fitbounds: geoLayout.fitbounds,
    'projection.scale': projLayout.scale
  };
  var extra;
  if (geoLayout._isScoped) {
    extra = {
      'center.lon': center.lon,
      'center.lat': center.lat
    };
  } else if (geoLayout._isClipped) {
    extra = {
      'projection.rotation.lon': rotation.lon,
      'projection.rotation.lat': rotation.lat
    };
  } else {
    extra = {
      'center.lon': center.lon,
      'center.lat': center.lat,
      'projection.rotation.lon': rotation.lon
    };
  }
  Lib.extendFlat(this.viewInitial, extra);
};
proto.render = function (mayRedrawOnUpdates) {
  if (this._hasMarkerAngles && mayRedrawOnUpdates) {
    this.plot(this._geoCalcData, this._fullLayout, [], true);
  } else {
    this._render();
  }
};

// [hot code path] (re)draw all paths which depend on the projection
proto._render = function () {
  var projection = this.projection;
  var pathFn = projection.getPath();
  var k;
  function translatePoints(d) {
    var lonlatPx = projection(d.lonlat);
    return lonlatPx ? strTranslate(lonlatPx[0], lonlatPx[1]) : null;
  }
  function hideShowPoints(d) {
    return projection.isLonLatOverEdges(d.lonlat) ? 'none' : null;
  }
  for (k in this.basePaths) {
    this.basePaths[k].attr('d', pathFn);
  }
  for (k in this.dataPaths) {
    this.dataPaths[k].attr('d', function (d) {
      return pathFn(d.geojson);
    });
  }
  for (k in this.dataPoints) {
    this.dataPoints[k].attr('display', hideShowPoints).attr('transform', translatePoints); // TODO: need to redraw points with marker angle instead of calling translatePoints
  }
};

// Helper that wraps d3[geo + /* Projection name /*]() which:
//
// - adds 'getPath', 'getBounds' convenience methods
// - scopes logic related to 'clipAngle'
// - adds 'isLonLatOverEdges' method
// - sets projection precision
// - sets methods that aren't always defined depending
//   on the projection type to a dummy 'd3-esque' function,
//
// This wrapper alleviates subsequent code of (many) annoying if-statements.
function getProjection(geoLayout) {
  var projLayout = geoLayout.projection;
  var projType = projLayout.type;
  var projName = constants.projNames[projType];
  // uppercase the first letter and add geo to the start of method name
  projName = 'geo' + Lib.titleCase(projName);
  var projFn = geo[projName] || geoProjection[projName];
  var projection = projFn();
  var clipAngle = geoLayout._isSatellite ? Math.acos(1 / projLayout.distance) * 180 / Math.PI : geoLayout._isClipped ? constants.lonaxisSpan[projType] / 2 : null;
  var methods = ['center', 'rotate', 'parallels', 'clipExtent'];
  var dummyFn = function (_) {
    return _ ? projection : [];
  };
  for (var i = 0; i < methods.length; i++) {
    var m = methods[i];
    if (typeof projection[m] !== 'function') {
      projection[m] = dummyFn;
    }
  }
  projection.isLonLatOverEdges = function (lonlat) {
    if (projection(lonlat) === null) {
      return true;
    }
    if (clipAngle) {
      var r = projection.rotate();
      var angle = geoDistance(lonlat, [-r[0], -r[1]]);
      var maxAngle = clipAngle * Math.PI / 180;
      return angle > maxAngle;
    } else {
      return false;
    }
  };
  projection.getPath = function () {
    return geoPath().projection(projection);
  };
  projection.getBounds = function (object) {
    return projection.getPath().bounds(object);
  };
  projection.precision(constants.precision);
  if (geoLayout._isSatellite) {
    projection.tilt(projLayout.tilt).distance(projLayout.distance);
  }
  if (clipAngle) {
    projection.clipAngle(clipAngle - constants.clipPad);
  }
  return projection;
}
function makeGraticule(axisName, geoLayout, fullLayout) {
  // equivalent to the d3 "ε"
  var epsilon = 1e-6;
  // same as the geoGraticule default
  var precision = 2.5;
  var axLayout = geoLayout[axisName];
  var scopeDefaults = constants.scopeDefaults[geoLayout.scope];
  var rng;
  var oppRng;
  var coordFn;
  if (axisName === 'lonaxis') {
    rng = scopeDefaults.lonaxisRange;
    oppRng = scopeDefaults.lataxisRange;
    coordFn = function (v, l) {
      return [v, l];
    };
  } else if (axisName === 'lataxis') {
    rng = scopeDefaults.lataxisRange;
    oppRng = scopeDefaults.lonaxisRange;
    coordFn = function (v, l) {
      return [l, v];
    };
  }
  var dummyAx = {
    type: 'linear',
    range: [rng[0], rng[1] - epsilon],
    tick0: axLayout.tick0,
    dtick: axLayout.dtick
  };
  Axes.setConvert(dummyAx, fullLayout);
  var vals = Axes.calcTicks(dummyAx);

  // remove duplicate on antimeridian
  if (!geoLayout.isScoped && axisName === 'lonaxis') {
    vals.pop();
  }
  var len = vals.length;
  var coords = new Array(len);
  for (var i = 0; i < len; i++) {
    var v = vals[i].x;
    var line = coords[i] = [];
    for (var l = oppRng[0]; l < oppRng[1] + precision; l += precision) {
      line.push(coordFn(v, l));
    }
  }
  return {
    type: 'MultiLineString',
    coordinates: coords
  };
}

// Returns polygon GeoJSON corresponding to lon/lat range box
// with well-defined direction
//
// Note that clipPad padding is added around range to avoid aliasing.
function makeRangeBox(lon, lat) {
  var clipPad = constants.clipPad;
  var lon0 = lon[0] + clipPad;
  var lon1 = lon[1] - clipPad;
  var lat0 = lat[0] + clipPad;
  var lat1 = lat[1] - clipPad;

  // to cross antimeridian w/o ambiguity
  if (lon0 > 0 && lon1 < 0) lon1 += 360;
  var dlon4 = (lon1 - lon0) / 4;
  return {
    type: 'Polygon',
    coordinates: [[[lon0, lat0], [lon0, lat1], [lon0 + dlon4, lat1], [lon0 + 2 * dlon4, lat1], [lon0 + 3 * dlon4, lat1], [lon1, lat1], [lon1, lat0], [lon1 - dlon4, lat0], [lon1 - 2 * dlon4, lat0], [lon1 - 3 * dlon4, lat0], [lon0, lat0]]]
  };
}

/***/ }),

/***/ 47544:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var getSubplotCalcData = (__webpack_require__(4173)/* .getSubplotCalcData */ .fX);
var counterRegex = (__webpack_require__(34809).counterRegex);
var createGeo = __webpack_require__(6493);
var GEO = 'geo';
var counter = counterRegex(GEO);
var attributes = {};
attributes[GEO] = {
  valType: 'subplotid',
  dflt: GEO,
  editType: 'calc'
};
function plotGeo(gd) {
  var fullLayout = gd._fullLayout;
  var calcData = gd.calcdata;
  var geoIds = fullLayout._subplots[GEO];
  for (var i = 0; i < geoIds.length; i++) {
    var geoId = geoIds[i];
    var geoCalcData = getSubplotCalcData(calcData, GEO, geoId);
    var geoLayout = fullLayout[geoId];
    var geo = geoLayout._subplot;
    if (!geo) {
      geo = createGeo({
        id: geoId,
        graphDiv: gd,
        container: fullLayout._geolayer.node(),
        topojsonURL: gd._context.topojsonURL,
        staticPlot: gd._context.staticPlot
      });
      fullLayout[geoId]._subplot = geo;
    }
    geo.plot(geoCalcData, fullLayout, gd._promises);
  }
}
function clean(newFullData, newFullLayout, oldFullData, oldFullLayout) {
  var oldGeoKeys = oldFullLayout._subplots[GEO] || [];
  for (var i = 0; i < oldGeoKeys.length; i++) {
    var oldGeoKey = oldGeoKeys[i];
    var oldGeo = oldFullLayout[oldGeoKey]._subplot;
    if (!newFullLayout[oldGeoKey] && !!oldGeo) {
      oldGeo.framework.remove();
      oldGeo.clipDef.remove();
    }
  }
}
function updateFx(gd) {
  var fullLayout = gd._fullLayout;
  var subplotIds = fullLayout._subplots[GEO];
  for (var i = 0; i < subplotIds.length; i++) {
    var subplotLayout = fullLayout[subplotIds[i]];
    var subplotObj = subplotLayout._subplot;
    subplotObj.updateFx(fullLayout, subplotLayout);
  }
}
module.exports = {
  attr: GEO,
  name: GEO,
  idRoot: GEO,
  idRegex: counter,
  attrRegex: counter,
  attributes: attributes,
  layoutAttributes: __webpack_require__(42194),
  supplyLayoutDefaults: __webpack_require__(31653),
  plot: plotGeo,
  updateFx: updateFx,
  clean: clean
};

/***/ }),

/***/ 42194:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var colorAttrs = __webpack_require__(10229);
var domainAttrs = (__webpack_require__(13792)/* .attributes */ .u);
var dash = (__webpack_require__(94850)/* .dash */ .T);
var constants = __webpack_require__(74285);
var overrideAll = (__webpack_require__(13582).overrideAll);
var sortObjectKeys = __webpack_require__(62994);
var geoAxesAttrs = {
  range: {
    valType: 'info_array',
    items: [{
      valType: 'number'
    }, {
      valType: 'number'
    }]
  },
  showgrid: {
    valType: 'boolean',
    dflt: false
  },
  tick0: {
    valType: 'number',
    dflt: 0
  },
  dtick: {
    valType: 'number'
  },
  gridcolor: {
    valType: 'color',
    dflt: colorAttrs.lightLine
  },
  gridwidth: {
    valType: 'number',
    min: 0,
    dflt: 1
  },
  griddash: dash
};
var attrs = module.exports = overrideAll({
  domain: domainAttrs({
    name: 'geo'
  }, {}),
  fitbounds: {
    valType: 'enumerated',
    values: [false, 'locations', 'geojson'],
    dflt: false,
    editType: 'plot'
  },
  resolution: {
    valType: 'enumerated',
    values: [110, 50],
    dflt: 110,
    coerceNumber: true
  },
  scope: {
    valType: 'enumerated',
    values: sortObjectKeys(constants.scopeDefaults),
    dflt: 'world'
  },
  projection: {
    type: {
      valType: 'enumerated',
      values: sortObjectKeys(constants.projNames)
    },
    rotation: {
      lon: {
        valType: 'number'
      },
      lat: {
        valType: 'number'
      },
      roll: {
        valType: 'number'
      }
    },
    tilt: {
      valType: 'number',
      dflt: 0
    },
    distance: {
      valType: 'number',
      min: 1.001,
      dflt: 2
    },
    parallels: {
      valType: 'info_array',
      items: [{
        valType: 'number'
      }, {
        valType: 'number'
      }]
    },
    scale: {
      valType: 'number',
      min: 0,
      dflt: 1
    }
  },
  center: {
    lon: {
      valType: 'number'
    },
    lat: {
      valType: 'number'
    }
  },
  visible: {
    valType: 'boolean',
    dflt: true
  },
  showcoastlines: {
    valType: 'boolean'
  },
  coastlinecolor: {
    valType: 'color',
    dflt: colorAttrs.defaultLine
  },
  coastlinewidth: {
    valType: 'number',
    min: 0,
    dflt: 1
  },
  showland: {
    valType: 'boolean',
    dflt: false
  },
  landcolor: {
    valType: 'color',
    dflt: constants.landColor
  },
  showocean: {
    valType: 'boolean',
    dflt: false
  },
  oceancolor: {
    valType: 'color',
    dflt: constants.waterColor
  },
  showlakes: {
    valType: 'boolean',
    dflt: false
  },
  lakecolor: {
    valType: 'color',
    dflt: constants.waterColor
  },
  showrivers: {
    valType: 'boolean',
    dflt: false
  },
  rivercolor: {
    valType: 'color',
    dflt: constants.waterColor
  },
  riverwidth: {
    valType: 'number',
    min: 0,
    dflt: 1
  },
  showcountries: {
    valType: 'boolean'
  },
  countrycolor: {
    valType: 'color',
    dflt: colorAttrs.defaultLine
  },
  countrywidth: {
    valType: 'number',
    min: 0,
    dflt: 1
  },
  showsubunits: {
    valType: 'boolean'
  },
  subunitcolor: {
    valType: 'color',
    dflt: colorAttrs.defaultLine
  },
  subunitwidth: {
    valType: 'number',
    min: 0,
    dflt: 1
  },
  showframe: {
    valType: 'boolean'
  },
  framecolor: {
    valType: 'color',
    dflt: colorAttrs.defaultLine
  },
  framewidth: {
    valType: 'number',
    min: 0,
    dflt: 1
  },
  bgcolor: {
    valType: 'color',
    dflt: colorAttrs.background
  },
  lonaxis: geoAxesAttrs,
  lataxis: geoAxesAttrs
}, 'plot', 'from-root');

// set uirevision outside of overrideAll so it can be `editType: 'none'`
attrs.uirevision = {
  valType: 'any',
  editType: 'none'
};

/***/ }),

/***/ 31653:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var handleSubplotDefaults = __webpack_require__(4448);
var getSubplotData = (__webpack_require__(4173)/* .getSubplotData */ .KO);
var constants = __webpack_require__(74285);
var layoutAttributes = __webpack_require__(42194);
var axesNames = constants.axesNames;
module.exports = function supplyLayoutDefaults(layoutIn, layoutOut, fullData) {
  handleSubplotDefaults(layoutIn, layoutOut, fullData, {
    type: 'geo',
    attributes: layoutAttributes,
    handleDefaults: handleGeoDefaults,
    fullData: fullData,
    partition: 'y'
  });
};
function handleGeoDefaults(geoLayoutIn, geoLayoutOut, coerce, opts) {
  var subplotData = getSubplotData(opts.fullData, 'geo', opts.id);
  var traceIndices = subplotData.map(function (t) {
    return t._expandedIndex;
  });
  var resolution = coerce('resolution');
  var scope = coerce('scope');
  var scopeParams = constants.scopeDefaults[scope];
  var projType = coerce('projection.type', scopeParams.projType);
  var isAlbersUsa = geoLayoutOut._isAlbersUsa = projType === 'albers usa';

  // no other scopes are allowed for 'albers usa' projection
  if (isAlbersUsa) scope = geoLayoutOut.scope = 'usa';
  var isScoped = geoLayoutOut._isScoped = scope !== 'world';
  var isSatellite = geoLayoutOut._isSatellite = projType === 'satellite';
  var isConic = geoLayoutOut._isConic = projType.indexOf('conic') !== -1 || projType === 'albers';
  var isClipped = geoLayoutOut._isClipped = !!constants.lonaxisSpan[projType];
  if (geoLayoutIn.visible === false) {
    // should override template.layout.geo.show* - see issue 4482

    // make a copy
    var newTemplate = Lib.extendDeep({}, geoLayoutOut._template);

    // override show*
    newTemplate.showcoastlines = false;
    newTemplate.showcountries = false;
    newTemplate.showframe = false;
    newTemplate.showlakes = false;
    newTemplate.showland = false;
    newTemplate.showocean = false;
    newTemplate.showrivers = false;
    newTemplate.showsubunits = false;
    if (newTemplate.lonaxis) newTemplate.lonaxis.showgrid = false;
    if (newTemplate.lataxis) newTemplate.lataxis.showgrid = false;

    // set ref to copy
    geoLayoutOut._template = newTemplate;
  }
  var visible = coerce('visible');
  var show;
  for (var i = 0; i < axesNames.length; i++) {
    var axisName = axesNames[i];
    var dtickDflt = [30, 10][i];
    var rangeDflt;
    if (isScoped) {
      rangeDflt = scopeParams[axisName + 'Range'];
    } else {
      var dfltSpans = constants[axisName + 'Span'];
      var hSpan = (dfltSpans[projType] || dfltSpans['*']) / 2;
      var rot = coerce('projection.rotation.' + axisName.substr(0, 3), scopeParams.projRotate[i]);
      rangeDflt = [rot - hSpan, rot + hSpan];
    }
    var range = coerce(axisName + '.range', rangeDflt);
    coerce(axisName + '.tick0');
    coerce(axisName + '.dtick', dtickDflt);
    show = coerce(axisName + '.showgrid', !visible ? false : undefined);
    if (show) {
      coerce(axisName + '.gridcolor');
      coerce(axisName + '.gridwidth');
      coerce(axisName + '.griddash');
    }

    // mock axis for autorange computations
    geoLayoutOut[axisName]._ax = {
      type: 'linear',
      _id: axisName.slice(0, 3),
      _traceIndices: traceIndices,
      setScale: Lib.identity,
      c2l: Lib.identity,
      r2l: Lib.identity,
      autorange: true,
      range: range.slice(),
      _m: 1,
      _input: {}
    };
  }
  var lonRange = geoLayoutOut.lonaxis.range;
  var latRange = geoLayoutOut.lataxis.range;

  // to cross antimeridian w/o ambiguity
  var lon0 = lonRange[0];
  var lon1 = lonRange[1];
  if (lon0 > 0 && lon1 < 0) lon1 += 360;
  var centerLon = (lon0 + lon1) / 2;
  var projLon;
  if (!isAlbersUsa) {
    var dfltProjRotate = isScoped ? scopeParams.projRotate : [centerLon, 0, 0];
    projLon = coerce('projection.rotation.lon', dfltProjRotate[0]);
    coerce('projection.rotation.lat', dfltProjRotate[1]);
    coerce('projection.rotation.roll', dfltProjRotate[2]);
    show = coerce('showcoastlines', !isScoped && visible);
    if (show) {
      coerce('coastlinecolor');
      coerce('coastlinewidth');
    }
    show = coerce('showocean', !visible ? false : undefined);
    if (show) coerce('oceancolor');
  }
  var centerLonDflt;
  var centerLatDflt;
  if (isAlbersUsa) {
    // 'albers usa' does not have a 'center',
    // these values were found using via:
    //   projection.invert([geoLayout.center.lon, geoLayoutIn.center.lat])
    centerLonDflt = -96.6;
    centerLatDflt = 38.7;
  } else {
    centerLonDflt = isScoped ? centerLon : projLon;
    centerLatDflt = (latRange[0] + latRange[1]) / 2;
  }
  coerce('center.lon', centerLonDflt);
  coerce('center.lat', centerLatDflt);
  if (isSatellite) {
    coerce('projection.tilt');
    coerce('projection.distance');
  }
  if (isConic) {
    var dfltProjParallels = scopeParams.projParallels || [0, 60];
    coerce('projection.parallels', dfltProjParallels);
  }
  coerce('projection.scale');
  show = coerce('showland', !visible ? false : undefined);
  if (show) coerce('landcolor');
  show = coerce('showlakes', !visible ? false : undefined);
  if (show) coerce('lakecolor');
  show = coerce('showrivers', !visible ? false : undefined);
  if (show) {
    coerce('rivercolor');
    coerce('riverwidth');
  }
  show = coerce('showcountries', isScoped && scope !== 'usa' && visible);
  if (show) {
    coerce('countrycolor');
    coerce('countrywidth');
  }
  if (scope === 'usa' || scope === 'north america' && resolution === 50) {
    // Only works for:
    //   USA states at 110m
    //   USA states + Canada provinces at 50m
    coerce('showsubunits', visible);
    coerce('subunitcolor');
    coerce('subunitwidth');
  }
  if (!isScoped) {
    // Does not work in non-world scopes
    show = coerce('showframe', visible);
    if (show) {
      coerce('framecolor');
      coerce('framewidth');
    }
  }
  coerce('bgcolor');
  var fitBounds = coerce('fitbounds');

  // clear attributes that will get auto-filled later
  if (fitBounds) {
    delete geoLayoutOut.projection.scale;
    if (isScoped) {
      delete geoLayoutOut.center.lon;
      delete geoLayoutOut.center.lat;
    } else if (isClipped) {
      delete geoLayoutOut.center.lon;
      delete geoLayoutOut.center.lat;
      delete geoLayoutOut.projection.rotation.lon;
      delete geoLayoutOut.projection.rotation.lat;
      delete geoLayoutOut.lonaxis.range;
      delete geoLayoutOut.lataxis.range;
    } else {
      delete geoLayoutOut.center.lon;
      delete geoLayoutOut.center.lat;
      delete geoLayoutOut.projection.rotation.lon;
    }
  }
}

/***/ }),

/***/ 14309:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var Lib = __webpack_require__(34809);
var Registry = __webpack_require__(33626);
var radians = Math.PI / 180;
var degrees = 180 / Math.PI;
var zoomstartStyle = {
  cursor: 'pointer'
};
var zoomendStyle = {
  cursor: 'auto'
};
function createGeoZoom(geo, geoLayout) {
  var projection = geo.projection;
  var zoomConstructor;
  if (geoLayout._isScoped) {
    zoomConstructor = zoomScoped;
  } else if (geoLayout._isClipped) {
    zoomConstructor = zoomClipped;
  } else {
    zoomConstructor = zoomNonClipped;
  }

  // TODO add a conic-specific zoom

  return zoomConstructor(geo, projection);
}
module.exports = createGeoZoom;

// common to all zoom types
function initZoom(geo, projection) {
  return d3.behavior.zoom().translate(projection.translate()).scale(projection.scale());
}

// sync zoom updates with user & full layout
function sync(geo, projection, cb) {
  var id = geo.id;
  var gd = geo.graphDiv;
  var layout = gd.layout;
  var userOpts = layout[id];
  var fullLayout = gd._fullLayout;
  var fullOpts = fullLayout[id];
  var preGUI = {};
  var eventData = {};
  function set(propStr, val) {
    preGUI[id + '.' + propStr] = Lib.nestedProperty(userOpts, propStr).get();
    Registry.call('_storeDirectGUIEdit', layout, fullLayout._preGUI, preGUI);
    var fullNp = Lib.nestedProperty(fullOpts, propStr);
    if (fullNp.get() !== val) {
      fullNp.set(val);
      Lib.nestedProperty(userOpts, propStr).set(val);
      eventData[id + '.' + propStr] = val;
    }
  }
  cb(set);
  set('projection.scale', projection.scale() / geo.fitScale);
  set('fitbounds', false);
  gd.emit('plotly_relayout', eventData);
}

// zoom for scoped projections
function zoomScoped(geo, projection) {
  var zoom = initZoom(geo, projection);
  function handleZoomstart() {
    d3.select(this).style(zoomstartStyle);
  }
  function handleZoom() {
    projection.scale(d3.event.scale).translate(d3.event.translate);
    geo.render(true);
    var center = projection.invert(geo.midPt);
    geo.graphDiv.emit('plotly_relayouting', {
      'geo.projection.scale': projection.scale() / geo.fitScale,
      'geo.center.lon': center[0],
      'geo.center.lat': center[1]
    });
  }
  function syncCb(set) {
    var center = projection.invert(geo.midPt);
    set('center.lon', center[0]);
    set('center.lat', center[1]);
  }
  function handleZoomend() {
    d3.select(this).style(zoomendStyle);
    sync(geo, projection, syncCb);
  }
  zoom.on('zoomstart', handleZoomstart).on('zoom', handleZoom).on('zoomend', handleZoomend);
  return zoom;
}

// zoom for non-clipped projections
function zoomNonClipped(geo, projection) {
  var zoom = initZoom(geo, projection);
  var INSIDETOLORANCEPXS = 2;
  var mouse0, rotate0, translate0, lastRotate, zoomPoint, mouse1, rotate1, point1, didZoom;
  function position(x) {
    return projection.invert(x);
  }
  function outside(x) {
    var pos = position(x);
    if (!pos) return true;
    var pt = projection(pos);
    return Math.abs(pt[0] - x[0]) > INSIDETOLORANCEPXS || Math.abs(pt[1] - x[1]) > INSIDETOLORANCEPXS;
  }
  function handleZoomstart() {
    d3.select(this).style(zoomstartStyle);
    mouse0 = d3.mouse(this);
    rotate0 = projection.rotate();
    translate0 = projection.translate();
    lastRotate = rotate0;
    zoomPoint = position(mouse0);
  }
  function handleZoom() {
    mouse1 = d3.mouse(this);
    if (outside(mouse0)) {
      zoom.scale(projection.scale());
      zoom.translate(projection.translate());
      return;
    }
    projection.scale(d3.event.scale);
    projection.translate([translate0[0], d3.event.translate[1]]);
    if (!zoomPoint) {
      mouse0 = mouse1;
      zoomPoint = position(mouse0);
    } else if (position(mouse1)) {
      point1 = position(mouse1);
      rotate1 = [lastRotate[0] + (point1[0] - zoomPoint[0]), rotate0[1], rotate0[2]];
      projection.rotate(rotate1);
      lastRotate = rotate1;
    }
    didZoom = true;
    geo.render(true);
    var rotate = projection.rotate();
    var center = projection.invert(geo.midPt);
    geo.graphDiv.emit('plotly_relayouting', {
      'geo.projection.scale': projection.scale() / geo.fitScale,
      'geo.center.lon': center[0],
      'geo.center.lat': center[1],
      'geo.projection.rotation.lon': -rotate[0]
    });
  }
  function handleZoomend() {
    d3.select(this).style(zoomendStyle);
    if (didZoom) sync(geo, projection, syncCb);
  }
  function syncCb(set) {
    var rotate = projection.rotate();
    var center = projection.invert(geo.midPt);
    set('projection.rotation.lon', -rotate[0]);
    set('center.lon', center[0]);
    set('center.lat', center[1]);
  }
  zoom.on('zoomstart', handleZoomstart).on('zoom', handleZoom).on('zoomend', handleZoomend);
  return zoom;
}

// zoom for clipped projections
// inspired by https://www.jasondavies.com/maps/d3.geo.zoom.js
function zoomClipped(geo, projection) {
  var view = {
    r: projection.rotate(),
    k: projection.scale()
  };
  var zoom = initZoom(geo, projection);
  var event = d3eventDispatch(zoom, 'zoomstart', 'zoom', 'zoomend');
  var zooming = 0;
  var zoomOn = zoom.on;
  var zoomPoint;
  zoom.on('zoomstart', function () {
    d3.select(this).style(zoomstartStyle);
    var mouse0 = d3.mouse(this);
    var rotate0 = projection.rotate();
    var lastRotate = rotate0;
    var translate0 = projection.translate();
    var q = quaternionFromEuler(rotate0);
    zoomPoint = position(projection, mouse0);
    zoomOn.call(zoom, 'zoom', function () {
      var mouse1 = d3.mouse(this);
      projection.scale(view.k = d3.event.scale);
      if (!zoomPoint) {
        // if no zoomPoint, the mouse wasn't over the actual geography yet
        // maybe this point is the start... we'll find out next time!
        mouse0 = mouse1;
        zoomPoint = position(projection, mouse0);
      } else if (position(projection, mouse1)) {
        // check if the point is on the map
        // if not, don't do anything new but scale
        // if it is, then we can assume between will exist below
        // so we don't need the 'bank' function, whatever that is.

        // go back to original projection temporarily
        // except for scale... that's kind of independent?
        projection.rotate(rotate0).translate(translate0);

        // calculate the new params
        var point1 = position(projection, mouse1);
        var between = rotateBetween(zoomPoint, point1);
        var newEuler = eulerFromQuaternion(multiply(q, between));
        var rotateAngles = view.r = unRoll(newEuler, zoomPoint, lastRotate);
        if (!isFinite(rotateAngles[0]) || !isFinite(rotateAngles[1]) || !isFinite(rotateAngles[2])) {
          rotateAngles = lastRotate;
        }

        // update the projection
        projection.rotate(rotateAngles);
        lastRotate = rotateAngles;
      }
      zoomed(event.of(this, arguments));
    });
    zoomstarted(event.of(this, arguments));
  }).on('zoomend', function () {
    d3.select(this).style(zoomendStyle);
    zoomOn.call(zoom, 'zoom', null);
    zoomended(event.of(this, arguments));
    sync(geo, projection, syncCb);
  }).on('zoom.redraw', function () {
    geo.render(true);
    var _rotate = projection.rotate();
    geo.graphDiv.emit('plotly_relayouting', {
      'geo.projection.scale': projection.scale() / geo.fitScale,
      'geo.projection.rotation.lon': -_rotate[0],
      'geo.projection.rotation.lat': -_rotate[1]
    });
  });
  function zoomstarted(dispatch) {
    if (!zooming++) dispatch({
      type: 'zoomstart'
    });
  }
  function zoomed(dispatch) {
    dispatch({
      type: 'zoom'
    });
  }
  function zoomended(dispatch) {
    if (! --zooming) dispatch({
      type: 'zoomend'
    });
  }
  function syncCb(set) {
    var _rotate = projection.rotate();
    set('projection.rotation.lon', -_rotate[0]);
    set('projection.rotation.lat', -_rotate[1]);
  }
  return d3.rebind(zoom, event, 'on');
}

// -- helper functions for zoomClipped

function position(projection, point) {
  var spherical = projection.invert(point);
  return spherical && isFinite(spherical[0]) && isFinite(spherical[1]) && cartesian(spherical);
}
function quaternionFromEuler(euler) {
  var lambda = 0.5 * euler[0] * radians;
  var phi = 0.5 * euler[1] * radians;
  var gamma = 0.5 * euler[2] * radians;
  var sinLambda = Math.sin(lambda);
  var cosLambda = Math.cos(lambda);
  var sinPhi = Math.sin(phi);
  var cosPhi = Math.cos(phi);
  var sinGamma = Math.sin(gamma);
  var cosGamma = Math.cos(gamma);
  return [cosLambda * cosPhi * cosGamma + sinLambda * sinPhi * sinGamma, sinLambda * cosPhi * cosGamma - cosLambda * sinPhi * sinGamma, cosLambda * sinPhi * cosGamma + sinLambda * cosPhi * sinGamma, cosLambda * cosPhi * sinGamma - sinLambda * sinPhi * cosGamma];
}
function multiply(a, b) {
  var a0 = a[0];
  var a1 = a[1];
  var a2 = a[2];
  var a3 = a[3];
  var b0 = b[0];
  var b1 = b[1];
  var b2 = b[2];
  var b3 = b[3];
  return [a0 * b0 - a1 * b1 - a2 * b2 - a3 * b3, a0 * b1 + a1 * b0 + a2 * b3 - a3 * b2, a0 * b2 - a1 * b3 + a2 * b0 + a3 * b1, a0 * b3 + a1 * b2 - a2 * b1 + a3 * b0];
}
function rotateBetween(a, b) {
  if (!a || !b) return;
  var axis = cross(a, b);
  var norm = Math.sqrt(dot(axis, axis));
  var halfgamma = 0.5 * Math.acos(Math.max(-1, Math.min(1, dot(a, b))));
  var k = Math.sin(halfgamma) / norm;
  return norm && [Math.cos(halfgamma), axis[2] * k, -axis[1] * k, axis[0] * k];
}

// input:
//   rotateAngles: a calculated set of Euler angles
//   pt: a point (cartesian in 3-space) to keep fixed
//   roll0: an initial roll, to be preserved
// output:
//   a set of Euler angles that preserve the projection of pt
//     but set roll (output[2]) equal to roll0
//     note that this doesn't depend on the particular projection,
//     just on the rotation angles
function unRoll(rotateAngles, pt, lastRotate) {
  // calculate the fixed point transformed by these Euler angles
  // but with the desired roll undone
  var ptRotated = rotateCartesian(pt, 2, rotateAngles[0]);
  ptRotated = rotateCartesian(ptRotated, 1, rotateAngles[1]);
  ptRotated = rotateCartesian(ptRotated, 0, rotateAngles[2] - lastRotate[2]);
  var x = pt[0];
  var y = pt[1];
  var z = pt[2];
  var f = ptRotated[0];
  var g = ptRotated[1];
  var h = ptRotated[2];

  // the following essentially solves:
  // ptRotated = rotateCartesian(rotateCartesian(pt, 2, newYaw), 1, newPitch)
  // for newYaw and newPitch, as best it can
  var theta = Math.atan2(y, x) * degrees;
  var a = Math.sqrt(x * x + y * y);
  var b;
  var newYaw1;
  if (Math.abs(g) > a) {
    newYaw1 = (g > 0 ? 90 : -90) - theta;
    b = 0;
  } else {
    newYaw1 = Math.asin(g / a) * degrees - theta;
    b = Math.sqrt(a * a - g * g);
  }
  var newYaw2 = 180 - newYaw1 - 2 * theta;
  var newPitch1 = (Math.atan2(h, f) - Math.atan2(z, b)) * degrees;
  var newPitch2 = (Math.atan2(h, f) - Math.atan2(z, -b)) * degrees;

  // which is closest to lastRotate[0,1]: newYaw/Pitch or newYaw2/Pitch2?
  var dist1 = angleDistance(lastRotate[0], lastRotate[1], newYaw1, newPitch1);
  var dist2 = angleDistance(lastRotate[0], lastRotate[1], newYaw2, newPitch2);
  if (dist1 <= dist2) return [newYaw1, newPitch1, lastRotate[2]];else return [newYaw2, newPitch2, lastRotate[2]];
}
function angleDistance(yaw0, pitch0, yaw1, pitch1) {
  var dYaw = angleMod(yaw1 - yaw0);
  var dPitch = angleMod(pitch1 - pitch0);
  return Math.sqrt(dYaw * dYaw + dPitch * dPitch);
}

// reduce an angle in degrees to [-180,180]
function angleMod(angle) {
  return (angle % 360 + 540) % 360 - 180;
}

// rotate a cartesian vector
// axis is 0 (x), 1 (y), or 2 (z)
// angle is in degrees
function rotateCartesian(vector, axis, angle) {
  var angleRads = angle * radians;
  var vectorOut = vector.slice();
  var ax1 = axis === 0 ? 1 : 0;
  var ax2 = axis === 2 ? 1 : 2;
  var cosa = Math.cos(angleRads);
  var sina = Math.sin(angleRads);
  vectorOut[ax1] = vector[ax1] * cosa - vector[ax2] * sina;
  vectorOut[ax2] = vector[ax2] * cosa + vector[ax1] * sina;
  return vectorOut;
}
function eulerFromQuaternion(q) {
  return [Math.atan2(2 * (q[0] * q[1] + q[2] * q[3]), 1 - 2 * (q[1] * q[1] + q[2] * q[2])) * degrees, Math.asin(Math.max(-1, Math.min(1, 2 * (q[0] * q[2] - q[3] * q[1])))) * degrees, Math.atan2(2 * (q[0] * q[3] + q[1] * q[2]), 1 - 2 * (q[2] * q[2] + q[3] * q[3])) * degrees];
}
function cartesian(spherical) {
  var lambda = spherical[0] * radians;
  var phi = spherical[1] * radians;
  var cosPhi = Math.cos(phi);
  return [cosPhi * Math.cos(lambda), cosPhi * Math.sin(lambda), Math.sin(phi)];
}
function dot(a, b) {
  var s = 0;
  for (var i = 0, n = a.length; i < n; ++i) s += a[i] * b[i];
  return s;
}
function cross(a, b) {
  return [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]];
}

// Like d3.dispatch, but for custom events abstracting native UI events. These
// events have a target component (such as a brush), a target element (such as
// the svg:g element containing the brush) and the standard arguments `d` (the
// target element's data) and `i` (the selection index of the target element).
function d3eventDispatch(target) {
  var i = 0;
  var n = arguments.length;
  var argumentz = [];
  while (++i < n) argumentz.push(arguments[i]);
  var dispatch = d3.dispatch.apply(null, argumentz);

  // Creates a dispatch context for the specified `thiz` (typically, the target
  // DOM element that received the source event) and `argumentz` (typically, the
  // data `d` and index `i` of the target element). The returned function can be
  // used to dispatch an event to any registered listeners; the function takes a
  // single argument as input, being the event to dispatch. The event must have
  // a "type" attribute which corresponds to a type registered in the
  // constructor. This context will automatically populate the "sourceEvent" and
  // "target" attributes of the event, as well as setting the `d3.event` global
  // for the duration of the notification.
  dispatch.of = function (thiz, argumentz) {
    return function (e1) {
      var e0;
      try {
        e0 = e1.sourceEvent = d3.event;
        e1.target = target;
        d3.event = e1;
        dispatch[e1.type].apply(thiz, argumentz);
      } finally {
        d3.event = e0;
      }
    };
  };
  return dispatch;
}

/***/ }),

/***/ 4173:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var Registry = __webpack_require__(33626);
var SUBPLOT_PATTERN = (__webpack_require__(54826).SUBPLOT_PATTERN);

/**
 * Get calcdata trace(s) associated with a given subplot
 *
 * @param {array} calcData: as in gd.calcdata
 * @param {string} type: subplot type
 * @param {string} subplotId: subplot id to look for
 *
 * @return {array} array of calcdata traces
 */
exports.fX = function (calcData, type, subplotId) {
  var basePlotModule = Registry.subplotsRegistry[type];
  if (!basePlotModule) return [];
  var attr = basePlotModule.attr;
  var subplotCalcData = [];
  for (var i = 0; i < calcData.length; i++) {
    var calcTrace = calcData[i];
    var trace = calcTrace[0].trace;
    if (trace[attr] === subplotId) subplotCalcData.push(calcTrace);
  }
  return subplotCalcData;
};
/**
 * Get calcdata trace(s) that can be plotted with a given module
 * NOTE: this isn't necessarily just exactly matching trace type,
 * if multiple trace types use the same plotting routine, they will be
 * collected here.
 * In order to not plot the same thing multiple times, we return two arrays,
 * the calcdata we *will* plot with this module, and the ones we *won't*
 *
 * @param {array} calcdata: as in gd.calcdata
 * @param {object|string|fn} arg1:
 *  the plotting module, or its name, or its plot method
 * @param {int} arg2: (optional) zorder to filter on
 * @return {array[array]} [foundCalcdata, remainingCalcdata]
 */
exports.eV = function (calcdata, arg1, arg2) {
  var moduleCalcData = [];
  var remainingCalcData = [];
  var plotMethod;
  if (typeof arg1 === 'string') {
    plotMethod = Registry.getModule(arg1).plot;
  } else if (typeof arg1 === 'function') {
    plotMethod = arg1;
  } else {
    plotMethod = arg1.plot;
  }
  if (!plotMethod) {
    return [moduleCalcData, calcdata];
  }
  var zorder = arg2;
  for (var i = 0; i < calcdata.length; i++) {
    var cd = calcdata[i];
    var trace = cd[0].trace;
    var filterByZ = trace.zorder !== undefined;
    // N.B.
    // - 'legendonly' traces do not make it past here
    // - skip over 'visible' traces that got trimmed completely during calc transforms
    if (trace.visible !== true || trace._length === 0) continue;

    // group calcdata trace not by 'module' (as the name of this function
    // would suggest), but by 'module plot method' so that if some traces
    // share the same module plot method (e.g. bar and histogram), we
    // only call it one!
    if (trace._module && trace._module.plot === plotMethod && (!filterByZ || trace.zorder === zorder)) {
      moduleCalcData.push(cd);
    } else {
      remainingCalcData.push(cd);
    }
  }
  return [moduleCalcData, remainingCalcData];
};

/**
 * Get the data trace(s) associated with a given subplot.
 *
 * @param {array} data  plotly full data array.
 * @param {string} type subplot type to look for.
 * @param {string} subplotId subplot id to look for.
 *
 * @return {array} list of trace objects.
 *
 */
exports.KO = function getSubplotData(data, type, subplotId) {
  if (!Registry.subplotsRegistry[type]) return [];
  var attr = Registry.subplotsRegistry[type].attr;
  var subplotData = [];
  var trace, subplotX, subplotY;
  if (type === 'gl2d') {
    var spmatch = subplotId.match(SUBPLOT_PATTERN);
    subplotX = 'x' + spmatch[1];
    subplotY = 'y' + spmatch[2];
  }
  for (var i = 0; i < data.length; i++) {
    trace = data[i];
    if (type === 'gl2d' && Registry.traceIs(trace, 'gl2d')) {
      if (trace[attr[0]] === subplotX && trace[attr[1]] === subplotY) {
        subplotData.push(trace);
      }
    } else {
      if (trace[attr] === subplotId) subplotData.push(trace);
    }
  }
  return subplotData;
};

/***/ }),

/***/ 77055:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var mouseChange = __webpack_require__(99978);
var mouseWheel = __webpack_require__(20573);
var mouseOffset = __webpack_require__(44039);
var cartesianConstants = __webpack_require__(54826);
var hasPassive = __webpack_require__(74043);
module.exports = createCamera;
function Camera2D(element, plot) {
  this.element = element;
  this.plot = plot;
  this.mouseListener = null;
  this.wheelListener = null;
  this.lastInputTime = Date.now();
  this.lastPos = [0, 0];
  this.boxEnabled = false;
  this.boxInited = false;
  this.boxStart = [0, 0];
  this.boxEnd = [0, 0];
  this.dragStart = [0, 0];
}
function createCamera(scene) {
  var element = scene.mouseContainer;
  var plot = scene.glplot;
  var result = new Camera2D(element, plot);
  function unSetAutoRange() {
    scene.xaxis.autorange = false;
    scene.yaxis.autorange = false;
  }
  function getSubplotConstraint() {
    // note: this assumes we only have one x and one y axis on this subplot
    // when this constraint is lifted this block won't make sense
    var constraints = scene.graphDiv._fullLayout._axisConstraintGroups;
    var xaId = scene.xaxis._id;
    var yaId = scene.yaxis._id;
    for (var i = 0; i < constraints.length; i++) {
      if (constraints[i][xaId] !== -1) {
        if (constraints[i][yaId] !== -1) return true;
        break;
      }
    }
    return false;
  }
  result.mouseListener = mouseChange(element, handleInteraction);

  // enable simple touch interactions
  element.addEventListener('touchstart', function (ev) {
    var xy = mouseOffset(ev.changedTouches[0], element);
    handleInteraction(0, xy[0], xy[1]);
    handleInteraction(1, xy[0], xy[1]);
    ev.preventDefault();
  }, hasPassive ? {
    passive: false
  } : false);
  element.addEventListener('touchmove', function (ev) {
    ev.preventDefault();
    var xy = mouseOffset(ev.changedTouches[0], element);
    handleInteraction(1, xy[0], xy[1]);
    ev.preventDefault();
  }, hasPassive ? {
    passive: false
  } : false);
  element.addEventListener('touchend', function (ev) {
    handleInteraction(0, result.lastPos[0], result.lastPos[1]);
    ev.preventDefault();
  }, hasPassive ? {
    passive: false
  } : false);
  function handleInteraction(buttons, x, y) {
    var dataBox = scene.calcDataBox();
    var viewBox = plot.viewBox;
    var lastX = result.lastPos[0];
    var lastY = result.lastPos[1];
    var MINDRAG = cartesianConstants.MINDRAG * plot.pixelRatio;
    var MINZOOM = cartesianConstants.MINZOOM * plot.pixelRatio;
    var dx, dy;
    x *= plot.pixelRatio;
    y *= plot.pixelRatio;

    // mouseChange gives y about top; convert to about bottom
    y = viewBox[3] - viewBox[1] - y;
    function updateRange(i0, start, end) {
      var range0 = Math.min(start, end);
      var range1 = Math.max(start, end);
      if (range0 !== range1) {
        dataBox[i0] = range0;
        dataBox[i0 + 2] = range1;
        result.dataBox = dataBox;
        scene.setRanges(dataBox);
      } else {
        scene.selectBox.selectBox = [0, 0, 1, 1];
        scene.glplot.setDirty();
      }
    }
    switch (scene.fullLayout.dragmode) {
      case 'zoom':
        if (buttons) {
          var dataX = x / (viewBox[2] - viewBox[0]) * (dataBox[2] - dataBox[0]) + dataBox[0];
          var dataY = y / (viewBox[3] - viewBox[1]) * (dataBox[3] - dataBox[1]) + dataBox[1];
          if (!result.boxInited) {
            result.boxStart[0] = dataX;
            result.boxStart[1] = dataY;
            result.dragStart[0] = x;
            result.dragStart[1] = y;
          }
          result.boxEnd[0] = dataX;
          result.boxEnd[1] = dataY;

          // we need to mark the box as initialized right away
          // so that we can tell the start and end points apart
          result.boxInited = true;

          // but don't actually enable the box until the cursor moves
          if (!result.boxEnabled && (result.boxStart[0] !== result.boxEnd[0] || result.boxStart[1] !== result.boxEnd[1])) {
            result.boxEnabled = true;
          }

          // constrain aspect ratio if the axes require it
          var smallDx = Math.abs(result.dragStart[0] - x) < MINZOOM;
          var smallDy = Math.abs(result.dragStart[1] - y) < MINZOOM;
          if (getSubplotConstraint() && !(smallDx && smallDy)) {
            dx = result.boxEnd[0] - result.boxStart[0];
            dy = result.boxEnd[1] - result.boxStart[1];
            var dydx = (dataBox[3] - dataBox[1]) / (dataBox[2] - dataBox[0]);
            if (Math.abs(dx * dydx) > Math.abs(dy)) {
              result.boxEnd[1] = result.boxStart[1] + Math.abs(dx) * dydx * (dy >= 0 ? 1 : -1);

              // gl-select-box clips to the plot area bounds,
              // which breaks the axis constraint, so don't allow
              // this box to go out of bounds
              if (result.boxEnd[1] < dataBox[1]) {
                result.boxEnd[1] = dataBox[1];
                result.boxEnd[0] = result.boxStart[0] + (dataBox[1] - result.boxStart[1]) / Math.abs(dydx);
              } else if (result.boxEnd[1] > dataBox[3]) {
                result.boxEnd[1] = dataBox[3];
                result.boxEnd[0] = result.boxStart[0] + (dataBox[3] - result.boxStart[1]) / Math.abs(dydx);
              }
            } else {
              result.boxEnd[0] = result.boxStart[0] + Math.abs(dy) / dydx * (dx >= 0 ? 1 : -1);
              if (result.boxEnd[0] < dataBox[0]) {
                result.boxEnd[0] = dataBox[0];
                result.boxEnd[1] = result.boxStart[1] + (dataBox[0] - result.boxStart[0]) * Math.abs(dydx);
              } else if (result.boxEnd[0] > dataBox[2]) {
                result.boxEnd[0] = dataBox[2];
                result.boxEnd[1] = result.boxStart[1] + (dataBox[2] - result.boxStart[0]) * Math.abs(dydx);
              }
            }
          } else {
            // otherwise clamp small changes to the origin so we get 1D zoom

            if (smallDx) result.boxEnd[0] = result.boxStart[0];
            if (smallDy) result.boxEnd[1] = result.boxStart[1];
          }
        } else if (result.boxEnabled) {
          dx = result.boxStart[0] !== result.boxEnd[0];
          dy = result.boxStart[1] !== result.boxEnd[1];
          if (dx || dy) {
            if (dx) {
              updateRange(0, result.boxStart[0], result.boxEnd[0]);
              scene.xaxis.autorange = false;
            }
            if (dy) {
              updateRange(1, result.boxStart[1], result.boxEnd[1]);
              scene.yaxis.autorange = false;
            }
            scene.relayoutCallback();
          } else {
            scene.glplot.setDirty();
          }
          result.boxEnabled = false;
          result.boxInited = false;
        } else if (result.boxInited) {
          // if box was inited but button released then - reset the box

          result.boxInited = false;
        }
        break;
      case 'pan':
        result.boxEnabled = false;
        result.boxInited = false;
        if (buttons) {
          if (!result.panning) {
            result.dragStart[0] = x;
            result.dragStart[1] = y;
          }
          if (Math.abs(result.dragStart[0] - x) < MINDRAG) x = result.dragStart[0];
          if (Math.abs(result.dragStart[1] - y) < MINDRAG) y = result.dragStart[1];
          dx = (lastX - x) * (dataBox[2] - dataBox[0]) / (plot.viewBox[2] - plot.viewBox[0]);
          dy = (lastY - y) * (dataBox[3] - dataBox[1]) / (plot.viewBox[3] - plot.viewBox[1]);
          dataBox[0] += dx;
          dataBox[2] += dx;
          dataBox[1] += dy;
          dataBox[3] += dy;
          scene.setRanges(dataBox);
          result.panning = true;
          result.lastInputTime = Date.now();
          unSetAutoRange();
          scene.cameraChanged();
          scene.handleAnnotations();
        } else if (result.panning) {
          result.panning = false;
          scene.relayoutCallback();
        }
        break;
    }
    result.lastPos[0] = x;
    result.lastPos[1] = y;
  }
  result.wheelListener = mouseWheel(element, function (dx, dy) {
    if (!scene.scrollZoom) return false;
    var dataBox = scene.calcDataBox();
    var viewBox = plot.viewBox;
    var lastX = result.lastPos[0];
    var lastY = result.lastPos[1];
    var scale = Math.exp(5.0 * dy / (viewBox[3] - viewBox[1]));
    var cx = lastX / (viewBox[2] - viewBox[0]) * (dataBox[2] - dataBox[0]) + dataBox[0];
    var cy = lastY / (viewBox[3] - viewBox[1]) * (dataBox[3] - dataBox[1]) + dataBox[1];
    dataBox[0] = (dataBox[0] - cx) * scale + cx;
    dataBox[2] = (dataBox[2] - cx) * scale + cx;
    dataBox[1] = (dataBox[1] - cy) * scale + cy;
    dataBox[3] = (dataBox[3] - cy) * scale + cy;
    scene.setRanges(dataBox);
    result.lastInputTime = Date.now();
    unSetAutoRange();
    scene.cameraChanged();
    scene.handleAnnotations();
    scene.relayoutCallback();
    return true;
  }, true);
  return result;
}

/***/ }),

/***/ 10749:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Axes = __webpack_require__(29714);
var str2RGBArray = __webpack_require__(55010);
function Axes2DOptions(scene) {
  this.scene = scene;
  this.gl = scene.gl;
  this.pixelRatio = scene.pixelRatio;
  this.screenBox = [0, 0, 1, 1];
  this.viewBox = [0, 0, 1, 1];
  this.dataBox = [-1, -1, 1, 1];
  this.borderLineEnable = [false, false, false, false];
  this.borderLineWidth = [1, 1, 1, 1];
  this.borderLineColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]];
  this.ticks = [[], []];
  this.tickEnable = [true, true, false, false];
  this.tickPad = [15, 15, 15, 15];
  this.tickAngle = [0, 0, 0, 0];
  this.tickColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]];
  this.tickMarkLength = [0, 0, 0, 0];
  this.tickMarkWidth = [0, 0, 0, 0];
  this.tickMarkColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]];
  this.labels = ['x', 'y'];
  this.labelEnable = [true, true, false, false];
  this.labelAngle = [0, Math.PI / 2, 0, 3.0 * Math.PI / 2];
  this.labelPad = [15, 15, 15, 15];
  this.labelSize = [12, 12];
  this.labelFont = ['sans-serif', 'sans-serif'];
  this.labelColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]];
  this.title = '';
  this.titleEnable = true;
  this.titleCenter = [0, 0, 0, 0];
  this.titleAngle = 0;
  this.titleColor = [0, 0, 0, 1];
  this.titleFont = 'sans-serif';
  this.titleSize = 18;
  this.gridLineEnable = [true, true];
  this.gridLineColor = [[0, 0, 0, 0.5], [0, 0, 0, 0.5]];
  this.gridLineWidth = [1, 1];
  this.zeroLineEnable = [true, true];
  this.zeroLineWidth = [1, 1];
  this.zeroLineColor = [[0, 0, 0, 1], [0, 0, 0, 1]];
  this.borderColor = [0, 0, 0, 0];
  this.backgroundColor = [0, 0, 0, 0];
  this.static = this.scene.staticPlot;
}
var proto = Axes2DOptions.prototype;
var AXES = ['xaxis', 'yaxis'];
proto.merge = function (options) {
  // titles are rendered in SVG
  this.titleEnable = false;
  this.backgroundColor = str2RGBArray(options.plot_bgcolor);
  var axisName, ax, axTitle, axMirror;
  var hasAxisInDfltPos, hasAxisInAltrPos, hasSharedAxis, mirrorLines, mirrorTicks;
  var i, j;
  for (i = 0; i < 2; ++i) {
    axisName = AXES[i];
    var axisLetter = axisName.charAt(0);

    // get options relevant to this subplot,
    // '_name' is e.g. xaxis, xaxis2, yaxis, yaxis4 ...
    ax = options[this.scene[axisName]._name];
    axTitle = ax.title.text === this.scene.fullLayout._dfltTitle[axisLetter] ? '' : ax.title.text;
    for (j = 0; j <= 2; j += 2) {
      this.labelEnable[i + j] = false;
      this.labels[i + j] = axTitle;
      this.labelColor[i + j] = str2RGBArray(ax.title.font.color);
      this.labelFont[i + j] = ax.title.font.family;
      this.labelSize[i + j] = ax.title.font.size;
      this.labelPad[i + j] = this.getLabelPad(axisName, ax);
      this.tickEnable[i + j] = false;
      this.tickColor[i + j] = str2RGBArray((ax.tickfont || {}).color);
      this.tickAngle[i + j] = ax.tickangle === 'auto' ? 0 : Math.PI * -ax.tickangle / 180;
      this.tickPad[i + j] = this.getTickPad(ax);
      this.tickMarkLength[i + j] = 0;
      this.tickMarkWidth[i + j] = ax.tickwidth || 0;
      this.tickMarkColor[i + j] = str2RGBArray(ax.tickcolor);
      this.borderLineEnable[i + j] = false;
      this.borderLineColor[i + j] = str2RGBArray(ax.linecolor);
      this.borderLineWidth[i + j] = ax.linewidth || 0;
    }
    hasSharedAxis = this.hasSharedAxis(ax);
    hasAxisInDfltPos = this.hasAxisInDfltPos(axisName, ax) && !hasSharedAxis;
    hasAxisInAltrPos = this.hasAxisInAltrPos(axisName, ax) && !hasSharedAxis;
    axMirror = ax.mirror || false;
    mirrorLines = hasSharedAxis ? String(axMirror).indexOf('all') !== -1 :
    // 'all' or 'allticks'
    !!axMirror; // all but false
    mirrorTicks = hasSharedAxis ? axMirror === 'allticks' : String(axMirror).indexOf('ticks') !== -1; // 'ticks' or 'allticks'

    // Axis titles and tick labels can only appear of one side of the scene
    //  and are never show on subplots that share existing axes.

    if (hasAxisInDfltPos) this.labelEnable[i] = true;else if (hasAxisInAltrPos) this.labelEnable[i + 2] = true;
    if (hasAxisInDfltPos) this.tickEnable[i] = ax.showticklabels;else if (hasAxisInAltrPos) this.tickEnable[i + 2] = ax.showticklabels;

    // Grid lines and ticks can appear on both sides of the scene
    //  and can appear on subplot that share existing axes via `ax.mirror`.

    if (hasAxisInDfltPos || mirrorLines) this.borderLineEnable[i] = ax.showline;
    if (hasAxisInAltrPos || mirrorLines) this.borderLineEnable[i + 2] = ax.showline;
    if (hasAxisInDfltPos || mirrorTicks) this.tickMarkLength[i] = this.getTickMarkLength(ax);
    if (hasAxisInAltrPos || mirrorTicks) this.tickMarkLength[i + 2] = this.getTickMarkLength(ax);
    this.gridLineEnable[i] = ax.showgrid;
    this.gridLineColor[i] = str2RGBArray(ax.gridcolor);
    this.gridLineWidth[i] = ax.gridwidth;
    this.zeroLineEnable[i] = ax.zeroline;
    this.zeroLineColor[i] = str2RGBArray(ax.zerolinecolor);
    this.zeroLineWidth[i] = ax.zerolinewidth;
  }
};

// is an axis shared with an already-drawn subplot ?
proto.hasSharedAxis = function (ax) {
  var scene = this.scene;
  var subplotIds = scene.fullLayout._subplots.gl2d;
  var list = Axes.findSubplotsWithAxis(subplotIds, ax);

  // if index === 0, then the subplot is already drawn as subplots
  // are drawn in order.
  return list.indexOf(scene.id) !== 0;
};

// has an axis in default position (i.e. bottom/left) ?
proto.hasAxisInDfltPos = function (axisName, ax) {
  var axSide = ax.side;
  if (axisName === 'xaxis') return axSide === 'bottom';else if (axisName === 'yaxis') return axSide === 'left';
};

// has an axis in alternate position (i.e. top/right) ?
proto.hasAxisInAltrPos = function (axisName, ax) {
  var axSide = ax.side;
  if (axisName === 'xaxis') return axSide === 'top';else if (axisName === 'yaxis') return axSide === 'right';
};
proto.getLabelPad = function (axisName, ax) {
  var offsetBase = 1.5;
  var fontSize = ax.title.font.size;
  var showticklabels = ax.showticklabels;
  if (axisName === 'xaxis') {
    return ax.side === 'top' ? -10 + fontSize * (offsetBase + (showticklabels ? 1 : 0)) : -10 + fontSize * (offsetBase + (showticklabels ? 0.5 : 0));
  } else if (axisName === 'yaxis') {
    return ax.side === 'right' ? 10 + fontSize * (offsetBase + (showticklabels ? 1 : 0.5)) : 10 + fontSize * (offsetBase + (showticklabels ? 0.5 : 0));
  }
};
proto.getTickPad = function (ax) {
  return ax.ticks === 'outside' ? 10 + ax.ticklen : 15;
};
proto.getTickMarkLength = function (ax) {
  if (!ax.ticks) return 0;
  var ticklen = ax.ticklen;
  return ax.ticks === 'inside' ? -ticklen : ticklen;
};
function createAxes2D(scene) {
  return new Axes2DOptions(scene);
}
module.exports = createAxes2D;

/***/ }),

/***/ 24585:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var overrideAll = (__webpack_require__(13582).overrideAll);
var Scene2D = __webpack_require__(27672);
var layoutGlobalAttrs = __webpack_require__(6704);
var xmlnsNamespaces = __webpack_require__(62972);
var constants = __webpack_require__(54826);
var Cartesian = __webpack_require__(37703);
var fxAttrs = __webpack_require__(6811);
var getSubplotData = (__webpack_require__(4173)/* .getSubplotData */ .KO);
exports.name = 'gl2d';
exports.attr = ['xaxis', 'yaxis'];
exports.idRoot = ['x', 'y'];
exports.idRegex = constants.idRegex;
exports.attrRegex = constants.attrRegex;
exports.attributes = __webpack_require__(55126);
exports.supplyLayoutDefaults = function (layoutIn, layoutOut, fullData) {
  if (!layoutOut._has('cartesian')) {
    Cartesian.supplyLayoutDefaults(layoutIn, layoutOut, fullData);
  }
};

// gl2d uses svg axis attributes verbatim, but overrides editType
// this could potentially be just `layoutAttributes` but it would
// still need special handling somewhere to give it precedence over
// the svg version when both are in use on one plot
exports.layoutAttrOverrides = overrideAll(Cartesian.layoutAttributes, 'plot', 'from-root');

// similar overrides for base plot attributes (and those added by components)
exports.baseLayoutAttrOverrides = overrideAll({
  plot_bgcolor: layoutGlobalAttrs.plot_bgcolor,
  hoverlabel: fxAttrs.hoverlabel
  // dragmode needs calc but only when transitioning TO lasso or select
  // so for now it's left inside _relayout
  // dragmode: fxAttrs.dragmode
}, 'plot', 'nested');
exports.plot = function plot(gd) {
  var fullLayout = gd._fullLayout;
  var fullData = gd._fullData;
  var subplotIds = fullLayout._subplots.gl2d;
  for (var i = 0; i < subplotIds.length; i++) {
    var subplotId = subplotIds[i];
    var subplotObj = fullLayout._plots[subplotId];
    var fullSubplotData = getSubplotData(fullData, 'gl2d', subplotId);

    // ref. to corresp. Scene instance
    var scene = subplotObj._scene2d;

    // If Scene is not instantiated, create one!
    if (scene === undefined) {
      scene = new Scene2D({
        id: subplotId,
        graphDiv: gd,
        container: gd.querySelector('.gl-container'),
        staticPlot: gd._context.staticPlot,
        plotGlPixelRatio: gd._context.plotGlPixelRatio
      }, fullLayout);

      // set ref to Scene instance
      subplotObj._scene2d = scene;
    }
    scene.plot(fullSubplotData, gd.calcdata, fullLayout, gd.layout);
  }
};
exports.clean = function (newFullData, newFullLayout, oldFullData, oldFullLayout) {
  var oldSceneKeys = oldFullLayout._subplots.gl2d || [];
  for (var i = 0; i < oldSceneKeys.length; i++) {
    var id = oldSceneKeys[i];
    var oldSubplot = oldFullLayout._plots[id];

    // old subplot wasn't gl2d; nothing to do
    if (!oldSubplot._scene2d) continue;

    // if no traces are present, delete gl2d subplot
    var subplotData = getSubplotData(newFullData, 'gl2d', id);
    if (subplotData.length === 0) {
      oldSubplot._scene2d.destroy();
      delete oldFullLayout._plots[id];
    }
  }

  // since we use cartesian interactions, do cartesian clean
  Cartesian.clean.apply(this, arguments);
};
exports.drawFramework = function (gd) {
  if (!gd._context.staticPlot) {
    Cartesian.drawFramework(gd);
  }
};
exports.toSVG = function (gd) {
  var fullLayout = gd._fullLayout;
  var subplotIds = fullLayout._subplots.gl2d;
  for (var i = 0; i < subplotIds.length; i++) {
    var subplot = fullLayout._plots[subplotIds[i]];
    var scene = subplot._scene2d;
    var imageData = scene.toImage('png');
    var image = fullLayout._glimages.append('svg:image');
    image.attr({
      xmlns: xmlnsNamespaces.svg,
      'xlink:href': imageData,
      x: 0,
      y: 0,
      width: '100%',
      height: '100%',
      preserveAspectRatio: 'none'
    });
    scene.destroy();
  }
};
exports.updateFx = function (gd) {
  var fullLayout = gd._fullLayout;
  var subplotIds = fullLayout._subplots.gl2d;
  for (var i = 0; i < subplotIds.length; i++) {
    var subplotObj = fullLayout._plots[subplotIds[i]]._scene2d;
    subplotObj.updateFx(fullLayout.dragmode);
  }
};

/***/ }),

/***/ 27672:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Registry = __webpack_require__(33626);
var Axes = __webpack_require__(29714);
var Fx = __webpack_require__(32141);
var createPlot2D = (__webpack_require__(99098).gl_plot2d);
var createSpikes = (__webpack_require__(99098).gl_spikes2d);
var createSelectBox = (__webpack_require__(99098).gl_select_box);
var getContext = __webpack_require__(22248);
var createOptions = __webpack_require__(10749);
var createCamera = __webpack_require__(77055);
var showNoWebGlMsg = __webpack_require__(97464);
var axisConstraints = __webpack_require__(84391);
var enforceAxisConstraints = axisConstraints.enforce;
var cleanAxisConstraints = axisConstraints.clean;
var doAutoRange = (__webpack_require__(32919).doAutoRange);
var dragHelpers = __webpack_require__(70414);
var drawMode = dragHelpers.drawMode;
var selectMode = dragHelpers.selectMode;
var AXES = ['xaxis', 'yaxis'];
var STATIC_CANVAS, STATIC_CONTEXT;
var SUBPLOT_PATTERN = (__webpack_require__(54826).SUBPLOT_PATTERN);
function Scene2D(options, fullLayout) {
  this.container = options.container;
  this.graphDiv = options.graphDiv;
  this.pixelRatio = options.plotGlPixelRatio || window.devicePixelRatio;
  this.id = options.id;
  this.staticPlot = !!options.staticPlot;
  this.scrollZoom = this.graphDiv._context._scrollZoom.cartesian;
  this.fullData = null;
  this.updateRefs(fullLayout);
  this.makeFramework();
  if (this.stopped) return;

  // update options
  this.glplotOptions = createOptions(this);
  this.glplotOptions.merge(fullLayout);

  // create the plot
  this.glplot = createPlot2D(this.glplotOptions);

  // create camera
  this.camera = createCamera(this);

  // trace set
  this.traces = {};

  // create axes spikes
  this.spikes = createSpikes(this.glplot);
  this.selectBox = createSelectBox(this.glplot, {
    innerFill: false,
    outerFill: true
  });

  // last button state
  this.lastButtonState = 0;

  // last pick result
  this.pickResult = null;

  // is the mouse over the plot?
  // it's OK if this says true when it's not, so long as
  // when we get a mouseout we set it to false before handling
  this.isMouseOver = true;

  // flag to stop render loop
  this.stopped = false;

  // redraw the plot
  this.redraw = this.draw.bind(this);
  this.redraw();
}
module.exports = Scene2D;
var proto = Scene2D.prototype;
proto.makeFramework = function () {
  // create canvas and gl context
  if (this.staticPlot) {
    if (!STATIC_CONTEXT) {
      STATIC_CANVAS = document.createElement('canvas');
      STATIC_CONTEXT = getContext({
        canvas: STATIC_CANVAS,
        preserveDrawingBuffer: false,
        premultipliedAlpha: true,
        antialias: true
      });
      if (!STATIC_CONTEXT) {
        throw new Error('Error creating static canvas/context for image server');
      }
    }
    this.canvas = STATIC_CANVAS;
    this.gl = STATIC_CONTEXT;
  } else {
    var liveCanvas = this.container.querySelector('.gl-canvas-focus');
    var gl = getContext({
      canvas: liveCanvas,
      preserveDrawingBuffer: true,
      premultipliedAlpha: true
    });
    if (!gl) {
      showNoWebGlMsg(this);
      this.stopped = true;
      return;
    }
    this.canvas = liveCanvas;
    this.gl = gl;
  }

  // position the canvas
  var canvas = this.canvas;
  canvas.style.width = '100%';
  canvas.style.height = '100%';
  canvas.style.position = 'absolute';
  canvas.style.top = '0px';
  canvas.style.left = '0px';
  canvas.style['pointer-events'] = 'none';
  this.updateSize(canvas);

  // create SVG container for hover text
  var svgContainer = this.svgContainer = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  svgContainer.style.position = 'absolute';
  svgContainer.style.top = svgContainer.style.left = '0px';
  svgContainer.style.width = svgContainer.style.height = '100%';
  svgContainer.style['z-index'] = 20;
  svgContainer.style['pointer-events'] = 'none';

  // create div to catch the mouse event
  var mouseContainer = this.mouseContainer = document.createElement('div');
  mouseContainer.style.position = 'absolute';
  mouseContainer.style['pointer-events'] = 'auto';
  this.pickCanvas = this.container.querySelector('.gl-canvas-pick');

  // append canvas, hover svg and mouse div to container
  var container = this.container;
  container.appendChild(svgContainer);
  container.appendChild(mouseContainer);
  var self = this;
  mouseContainer.addEventListener('mouseout', function () {
    self.isMouseOver = false;
    self.unhover();
  });
  mouseContainer.addEventListener('mouseover', function () {
    self.isMouseOver = true;
  });
};
proto.toImage = function (format) {
  if (!format) format = 'png';
  this.stopped = true;
  if (this.staticPlot) this.container.appendChild(STATIC_CANVAS);

  // update canvas size
  this.updateSize(this.canvas);

  // grab context and yank out pixels
  var gl = this.glplot.gl;
  var w = gl.drawingBufferWidth;
  var h = gl.drawingBufferHeight;

  // force redraw
  gl.clearColor(1, 1, 1, 0);
  gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
  this.glplot.setDirty();
  this.glplot.draw();
  gl.bindFramebuffer(gl.FRAMEBUFFER, null);
  var pixels = new Uint8Array(w * h * 4);
  gl.readPixels(0, 0, w, h, gl.RGBA, gl.UNSIGNED_BYTE, pixels);

  // flip pixels
  for (var j = 0, k = h - 1; j < k; ++j, --k) {
    for (var i = 0; i < w; ++i) {
      for (var l = 0; l < 4; ++l) {
        var tmp = pixels[4 * (w * j + i) + l];
        pixels[4 * (w * j + i) + l] = pixels[4 * (w * k + i) + l];
        pixels[4 * (w * k + i) + l] = tmp;
      }
    }
  }
  var canvas = document.createElement('canvas');
  canvas.width = w;
  canvas.height = h;
  var context = canvas.getContext('2d', {
    willReadFrequently: true
  });
  var imageData = context.createImageData(w, h);
  imageData.data.set(pixels);
  context.putImageData(imageData, 0, 0);
  var dataURL;
  switch (format) {
    case 'jpeg':
      dataURL = canvas.toDataURL('image/jpeg');
      break;
    case 'webp':
      dataURL = canvas.toDataURL('image/webp');
      break;
    default:
      dataURL = canvas.toDataURL('image/png');
  }
  if (this.staticPlot) this.container.removeChild(STATIC_CANVAS);
  return dataURL;
};
proto.updateSize = function (canvas) {
  if (!canvas) canvas = this.canvas;
  var pixelRatio = this.pixelRatio;
  var fullLayout = this.fullLayout;
  var width = fullLayout.width;
  var height = fullLayout.height;
  var pixelWidth = Math.ceil(pixelRatio * width) | 0;
  var pixelHeight = Math.ceil(pixelRatio * height) | 0;

  // check for resize
  if (canvas.width !== pixelWidth || canvas.height !== pixelHeight) {
    canvas.width = pixelWidth;
    canvas.height = pixelHeight;
  }
  return canvas;
};
proto.computeTickMarks = function () {
  this.xaxis.setScale();
  this.yaxis.setScale();
  var nextTicks = [Axes.calcTicks(this.xaxis), Axes.calcTicks(this.yaxis)];
  for (var j = 0; j < 2; ++j) {
    for (var i = 0; i < nextTicks[j].length; ++i) {
      // coercing tick value (may not be a string) to a string
      nextTicks[j][i].text = nextTicks[j][i].text + '';
    }
  }
  return nextTicks;
};
function compareTicks(a, b) {
  for (var i = 0; i < 2; ++i) {
    var aticks = a[i];
    var bticks = b[i];
    if (aticks.length !== bticks.length) return true;
    for (var j = 0; j < aticks.length; ++j) {
      if (aticks[j].x !== bticks[j].x) return true;
    }
  }
  return false;
}
proto.updateRefs = function (newFullLayout) {
  this.fullLayout = newFullLayout;
  var spmatch = this.id.match(SUBPLOT_PATTERN);
  var xaxisName = 'xaxis' + spmatch[1];
  var yaxisName = 'yaxis' + spmatch[2];
  this.xaxis = this.fullLayout[xaxisName];
  this.yaxis = this.fullLayout[yaxisName];
};
proto.relayoutCallback = function () {
  var graphDiv = this.graphDiv;
  var xaxis = this.xaxis;
  var yaxis = this.yaxis;
  var layout = graphDiv.layout;

  // make a meaningful value to be passed on to possible 'plotly_relayout' subscriber(s)
  var update = {};
  var xrange = update[xaxis._name + '.range'] = xaxis.range.slice();
  var yrange = update[yaxis._name + '.range'] = yaxis.range.slice();
  update[xaxis._name + '.autorange'] = xaxis.autorange;
  update[yaxis._name + '.autorange'] = yaxis.autorange;
  Registry.call('_storeDirectGUIEdit', graphDiv.layout, graphDiv._fullLayout._preGUI, update);

  // update the input layout
  var xaIn = layout[xaxis._name];
  xaIn.range = xrange;
  xaIn.autorange = xaxis.autorange;
  var yaIn = layout[yaxis._name];
  yaIn.range = yrange;
  yaIn.autorange = yaxis.autorange;

  // lastInputTime helps determine which one is the latest input (if async)
  update.lastInputTime = this.camera.lastInputTime;
  graphDiv.emit('plotly_relayout', update);
};
proto.cameraChanged = function () {
  var camera = this.camera;
  this.glplot.setDataBox(this.calcDataBox());
  var nextTicks = this.computeTickMarks();
  var curTicks = this.glplotOptions.ticks;
  if (compareTicks(nextTicks, curTicks)) {
    this.glplotOptions.ticks = nextTicks;
    this.glplotOptions.dataBox = camera.dataBox;
    this.glplot.update(this.glplotOptions);
    this.handleAnnotations();
  }
};
proto.handleAnnotations = function () {
  var gd = this.graphDiv;
  var annotations = this.fullLayout.annotations;
  for (var i = 0; i < annotations.length; i++) {
    var ann = annotations[i];
    if (ann.xref === this.xaxis._id && ann.yref === this.yaxis._id) {
      Registry.getComponentMethod('annotations', 'drawOne')(gd, i);
    }
  }
};
proto.destroy = function () {
  if (!this.glplot) return;
  var traces = this.traces;
  if (traces) {
    Object.keys(traces).map(function (key) {
      traces[key].dispose();
      delete traces[key];
    });
  }
  this.glplot.dispose();
  this.container.removeChild(this.svgContainer);
  this.container.removeChild(this.mouseContainer);
  this.fullData = null;
  this.glplot = null;
  this.stopped = true;
  this.camera.mouseListener.enabled = false;
  this.mouseContainer.removeEventListener('wheel', this.camera.wheelListener);
  this.camera = null;
};
proto.plot = function (fullData, calcData, fullLayout) {
  var glplot = this.glplot;
  this.updateRefs(fullLayout);
  this.xaxis.clearCalc();
  this.yaxis.clearCalc();
  this.updateTraces(fullData, calcData);
  this.updateFx(fullLayout.dragmode);
  var width = fullLayout.width;
  var height = fullLayout.height;
  this.updateSize(this.canvas);
  var options = this.glplotOptions;
  options.merge(fullLayout);
  options.screenBox = [0, 0, width, height];
  var mockGraphDiv = {
    _fullLayout: {
      _axisConstraintGroups: fullLayout._axisConstraintGroups,
      xaxis: this.xaxis,
      yaxis: this.yaxis,
      _size: fullLayout._size
    }
  };
  cleanAxisConstraints(mockGraphDiv, this.xaxis);
  cleanAxisConstraints(mockGraphDiv, this.yaxis);
  var size = fullLayout._size;
  var domainX = this.xaxis.domain;
  var domainY = this.yaxis.domain;
  options.viewBox = [size.l + domainX[0] * size.w, size.b + domainY[0] * size.h, width - size.r - (1 - domainX[1]) * size.w, height - size.t - (1 - domainY[1]) * size.h];
  this.mouseContainer.style.width = size.w * (domainX[1] - domainX[0]) + 'px';
  this.mouseContainer.style.height = size.h * (domainY[1] - domainY[0]) + 'px';
  this.mouseContainer.height = size.h * (domainY[1] - domainY[0]);
  this.mouseContainer.style.left = size.l + domainX[0] * size.w + 'px';
  this.mouseContainer.style.top = size.t + (1 - domainY[1]) * size.h + 'px';
  var ax, i;
  for (i = 0; i < 2; ++i) {
    ax = this[AXES[i]];
    ax._length = options.viewBox[i + 2] - options.viewBox[i];
    doAutoRange(this.graphDiv, ax);
    ax.setScale();
  }
  enforceAxisConstraints(mockGraphDiv);
  options.ticks = this.computeTickMarks();
  options.dataBox = this.calcDataBox();
  options.merge(fullLayout);
  glplot.update(options);

  // force redraw so that promise is returned when rendering is completed
  this.glplot.draw();
};
proto.calcDataBox = function () {
  var xaxis = this.xaxis;
  var yaxis = this.yaxis;
  var xrange = xaxis.range;
  var yrange = yaxis.range;
  var xr2l = xaxis.r2l;
  var yr2l = yaxis.r2l;
  return [xr2l(xrange[0]), yr2l(yrange[0]), xr2l(xrange[1]), yr2l(yrange[1])];
};
proto.setRanges = function (dataBox) {
  var xaxis = this.xaxis;
  var yaxis = this.yaxis;
  var xl2r = xaxis.l2r;
  var yl2r = yaxis.l2r;
  xaxis.range = [xl2r(dataBox[0]), xl2r(dataBox[2])];
  yaxis.range = [yl2r(dataBox[1]), yl2r(dataBox[3])];
};
proto.updateTraces = function (fullData, calcData) {
  var traceIds = Object.keys(this.traces);
  var i, j, fullTrace;
  this.fullData = fullData;

  // remove empty traces
  traceIdLoop: for (i = 0; i < traceIds.length; i++) {
    var oldUid = traceIds[i];
    var oldTrace = this.traces[oldUid];
    for (j = 0; j < fullData.length; j++) {
      fullTrace = fullData[j];
      if (fullTrace.uid === oldUid && fullTrace.type === oldTrace.type) {
        continue traceIdLoop;
      }
    }
    oldTrace.dispose();
    delete this.traces[oldUid];
  }

  // update / create trace objects
  for (i = 0; i < fullData.length; i++) {
    fullTrace = fullData[i];
    var calcTrace = calcData[i];
    var traceObj = this.traces[fullTrace.uid];
    if (traceObj) traceObj.update(fullTrace, calcTrace);else {
      traceObj = fullTrace._module.plot(this, fullTrace, calcTrace);
      this.traces[fullTrace.uid] = traceObj;
    }
  }

  // order object per traces
  this.glplot.objects.sort(function (a, b) {
    return a._trace.index - b._trace.index;
  });
};
proto.updateFx = function (dragmode) {
  // switch to svg interactions in lasso/select mode & shape drawing
  if (selectMode(dragmode) || drawMode(dragmode)) {
    this.pickCanvas.style['pointer-events'] = 'none';
    this.mouseContainer.style['pointer-events'] = 'none';
  } else {
    this.pickCanvas.style['pointer-events'] = 'auto';
    this.mouseContainer.style['pointer-events'] = 'auto';
  }

  // set proper cursor
  if (dragmode === 'pan') {
    this.mouseContainer.style.cursor = 'move';
  } else if (dragmode === 'zoom') {
    this.mouseContainer.style.cursor = 'crosshair';
  } else {
    this.mouseContainer.style.cursor = null;
  }
};
proto.emitPointAction = function (nextSelection, eventType) {
  var uid = nextSelection.trace.uid;
  var ptNumber = nextSelection.pointIndex;
  var trace;
  for (var i = 0; i < this.fullData.length; i++) {
    if (this.fullData[i].uid === uid) {
      trace = this.fullData[i];
    }
  }
  var pointData = {
    x: nextSelection.traceCoord[0],
    y: nextSelection.traceCoord[1],
    curveNumber: trace.index,
    pointNumber: ptNumber,
    data: trace._input,
    fullData: this.fullData,
    xaxis: this.xaxis,
    yaxis: this.yaxis
  };
  Fx.appendArrayPointValue(pointData, trace, ptNumber);
  this.graphDiv.emit(eventType, {
    points: [pointData]
  });
};
proto.draw = function () {
  if (this.stopped) return;
  requestAnimationFrame(this.redraw);
  var glplot = this.glplot;
  var camera = this.camera;
  var mouseListener = camera.mouseListener;
  var mouseUp = this.lastButtonState === 1 && mouseListener.buttons === 0;
  var fullLayout = this.fullLayout;
  this.lastButtonState = mouseListener.buttons;
  this.cameraChanged();
  var x = mouseListener.x * glplot.pixelRatio;
  var y = this.canvas.height - glplot.pixelRatio * mouseListener.y;
  var result;
  if (camera.boxEnabled && fullLayout.dragmode === 'zoom') {
    this.selectBox.enabled = true;
    var selectBox = this.selectBox.selectBox = [Math.min(camera.boxStart[0], camera.boxEnd[0]), Math.min(camera.boxStart[1], camera.boxEnd[1]), Math.max(camera.boxStart[0], camera.boxEnd[0]), Math.max(camera.boxStart[1], camera.boxEnd[1])];

    // 1D zoom
    for (var i = 0; i < 2; i++) {
      if (camera.boxStart[i] === camera.boxEnd[i]) {
        selectBox[i] = glplot.dataBox[i];
        selectBox[i + 2] = glplot.dataBox[i + 2];
      }
    }
    glplot.setDirty();
  } else if (!camera.panning && this.isMouseOver) {
    this.selectBox.enabled = false;
    var size = fullLayout._size;
    var domainX = this.xaxis.domain;
    var domainY = this.yaxis.domain;
    result = glplot.pick(x / glplot.pixelRatio + size.l + domainX[0] * size.w, y / glplot.pixelRatio - (size.t + (1 - domainY[1]) * size.h));
    var nextSelection = result && result.object._trace.handlePick(result);
    if (nextSelection && mouseUp) {
      this.emitPointAction(nextSelection, 'plotly_click');
    }
    if (result && result.object._trace.hoverinfo !== 'skip' && fullLayout.hovermode) {
      if (nextSelection && (!this.lastPickResult || this.lastPickResult.traceUid !== nextSelection.trace.uid || this.lastPickResult.dataCoord[0] !== nextSelection.dataCoord[0] || this.lastPickResult.dataCoord[1] !== nextSelection.dataCoord[1])) {
        var selection = nextSelection;
        this.lastPickResult = {
          traceUid: nextSelection.trace ? nextSelection.trace.uid : null,
          dataCoord: nextSelection.dataCoord.slice()
        };
        this.spikes.update({
          center: result.dataCoord
        });
        selection.screenCoord = [((glplot.viewBox[2] - glplot.viewBox[0]) * (result.dataCoord[0] - glplot.dataBox[0]) / (glplot.dataBox[2] - glplot.dataBox[0]) + glplot.viewBox[0]) / glplot.pixelRatio, (this.canvas.height - (glplot.viewBox[3] - glplot.viewBox[1]) * (result.dataCoord[1] - glplot.dataBox[1]) / (glplot.dataBox[3] - glplot.dataBox[1]) - glplot.viewBox[1]) / glplot.pixelRatio];

        // this needs to happen before the next block that deletes traceCoord data
        // also it's important to copy, otherwise data is lost by the time event data is read
        this.emitPointAction(nextSelection, 'plotly_hover');
        var trace = this.fullData[selection.trace.index] || {};
        var ptNumber = selection.pointIndex;
        var hoverinfo = Fx.castHoverinfo(trace, fullLayout, ptNumber);
        if (hoverinfo && hoverinfo !== 'all') {
          var parts = hoverinfo.split('+');
          if (parts.indexOf('x') === -1) selection.traceCoord[0] = undefined;
          if (parts.indexOf('y') === -1) selection.traceCoord[1] = undefined;
          if (parts.indexOf('z') === -1) selection.traceCoord[2] = undefined;
          if (parts.indexOf('text') === -1) selection.textLabel = undefined;
          if (parts.indexOf('name') === -1) selection.name = undefined;
        }
        Fx.loneHover({
          x: selection.screenCoord[0],
          y: selection.screenCoord[1],
          xLabel: this.hoverFormatter('xaxis', selection.traceCoord[0]),
          yLabel: this.hoverFormatter('yaxis', selection.traceCoord[1]),
          zLabel: selection.traceCoord[2],
          text: selection.textLabel,
          name: selection.name,
          color: Fx.castHoverOption(trace, ptNumber, 'bgcolor') || selection.color,
          borderColor: Fx.castHoverOption(trace, ptNumber, 'bordercolor'),
          fontFamily: Fx.castHoverOption(trace, ptNumber, 'font.family'),
          fontSize: Fx.castHoverOption(trace, ptNumber, 'font.size'),
          fontColor: Fx.castHoverOption(trace, ptNumber, 'font.color'),
          nameLength: Fx.castHoverOption(trace, ptNumber, 'namelength'),
          textAlign: Fx.castHoverOption(trace, ptNumber, 'align')
        }, {
          container: this.svgContainer,
          gd: this.graphDiv
        });
      }
    }
  }

  // Remove hover effects if we're not over a point OR
  // if we're zooming or panning (in which case result is not set)
  if (!result) {
    this.unhover();
  }
  glplot.draw();
};
proto.unhover = function () {
  if (this.lastPickResult) {
    this.spikes.update({});
    this.lastPickResult = null;
    this.graphDiv.emit('plotly_unhover');
    Fx.loneUnhover(this.svgContainer);
  }
};
proto.hoverFormatter = function (axisName, val) {
  if (val === undefined) return undefined;
  var axis = this[axisName];
  return Axes.tickText(axis, axis.c2l(val), 'hover').text;
};

/***/ }),

/***/ 2487:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var overrideAll = (__webpack_require__(13582).overrideAll);
var fxAttrs = __webpack_require__(6811);
var Scene = __webpack_require__(20299);
var getSubplotData = (__webpack_require__(4173)/* .getSubplotData */ .KO);
var Lib = __webpack_require__(34809);
var xmlnsNamespaces = __webpack_require__(62972);
var GL3D = 'gl3d';
var SCENE = 'scene';
exports.name = GL3D;
exports.attr = SCENE;
exports.idRoot = SCENE;
exports.idRegex = exports.attrRegex = Lib.counterRegex('scene');
exports.attributes = __webpack_require__(22597);
exports.layoutAttributes = __webpack_require__(77168);
exports.baseLayoutAttrOverrides = overrideAll({
  hoverlabel: fxAttrs.hoverlabel
}, 'plot', 'nested');
exports.supplyLayoutDefaults = __webpack_require__(15250);
exports.plot = function plot(gd) {
  var fullLayout = gd._fullLayout;
  var fullData = gd._fullData;
  var sceneIds = fullLayout._subplots[GL3D];
  for (var i = 0; i < sceneIds.length; i++) {
    var sceneId = sceneIds[i];
    var fullSceneData = getSubplotData(fullData, GL3D, sceneId);
    var sceneLayout = fullLayout[sceneId];
    var camera = sceneLayout.camera;
    var scene = sceneLayout._scene;
    if (!scene) {
      scene = new Scene({
        id: sceneId,
        graphDiv: gd,
        container: gd.querySelector('.gl-container'),
        staticPlot: gd._context.staticPlot,
        plotGlPixelRatio: gd._context.plotGlPixelRatio,
        camera: camera
      }, fullLayout);

      // set ref to Scene instance
      sceneLayout._scene = scene;
    }

    // save 'initial' camera view settings for modebar button
    if (!scene.viewInitial) {
      scene.viewInitial = {
        up: {
          x: camera.up.x,
          y: camera.up.y,
          z: camera.up.z
        },
        eye: {
          x: camera.eye.x,
          y: camera.eye.y,
          z: camera.eye.z
        },
        center: {
          x: camera.center.x,
          y: camera.center.y,
          z: camera.center.z
        }
      };
    }
    scene.plot(fullSceneData, fullLayout, gd.layout);
  }
};
exports.clean = function (newFullData, newFullLayout, oldFullData, oldFullLayout) {
  var oldSceneKeys = oldFullLayout._subplots[GL3D] || [];
  for (var i = 0; i < oldSceneKeys.length; i++) {
    var oldSceneKey = oldSceneKeys[i];
    if (!newFullLayout[oldSceneKey] && !!oldFullLayout[oldSceneKey]._scene) {
      oldFullLayout[oldSceneKey]._scene.destroy();
      if (oldFullLayout._infolayer) {
        oldFullLayout._infolayer.selectAll('.annotation-' + oldSceneKey).remove();
      }
    }
  }
};
exports.toSVG = function (gd) {
  var fullLayout = gd._fullLayout;
  var sceneIds = fullLayout._subplots[GL3D];
  var size = fullLayout._size;
  for (var i = 0; i < sceneIds.length; i++) {
    var sceneLayout = fullLayout[sceneIds[i]];
    var domain = sceneLayout.domain;
    var scene = sceneLayout._scene;
    var imageData = scene.toImage('png');
    var image = fullLayout._glimages.append('svg:image');
    image.attr({
      xmlns: xmlnsNamespaces.svg,
      'xlink:href': imageData,
      x: size.l + size.w * domain.x[0],
      y: size.t + size.h * (1 - domain.y[1]),
      width: size.w * (domain.x[1] - domain.x[0]),
      height: size.h * (domain.y[1] - domain.y[0]),
      preserveAspectRatio: 'none'
    });
    scene.destroy();
  }
};

// clean scene ids, 'scene1' -> 'scene'
exports.cleanId = function cleanId(id) {
  if (!id.match(/^scene[0-9]*$/)) return;
  var sceneNum = id.substr(5);
  if (sceneNum === '1') sceneNum = '';
  return SCENE + sceneNum;
};
exports.updateFx = function (gd) {
  var fullLayout = gd._fullLayout;
  var subplotIds = fullLayout._subplots[GL3D];
  for (var i = 0; i < subplotIds.length; i++) {
    var subplotObj = fullLayout[subplotIds[i]]._scene;
    subplotObj.updateFx(fullLayout.dragmode, fullLayout.hovermode);
  }
};

/***/ }),

/***/ 22597:
/***/ (function(module) {

"use strict";


module.exports = {
  scene: {
    valType: 'subplotid',
    dflt: 'scene',
    editType: 'calc+clearAxisTypes'
  }
};

/***/ }),

/***/ 63397:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Color = __webpack_require__(78766);
var axesAttrs = __webpack_require__(25829);
var extendFlat = (__webpack_require__(93049).extendFlat);
var overrideAll = (__webpack_require__(13582).overrideAll);
module.exports = overrideAll({
  visible: axesAttrs.visible,
  showspikes: {
    valType: 'boolean',
    dflt: true
  },
  spikesides: {
    valType: 'boolean',
    dflt: true
  },
  spikethickness: {
    valType: 'number',
    min: 0,
    dflt: 2
  },
  spikecolor: {
    valType: 'color',
    dflt: Color.defaultLine
  },
  showbackground: {
    valType: 'boolean',
    dflt: false
  },
  backgroundcolor: {
    valType: 'color',
    dflt: 'rgba(204, 204, 204, 0.5)'
  },
  showaxeslabels: {
    valType: 'boolean',
    dflt: true
  },
  color: axesAttrs.color,
  categoryorder: axesAttrs.categoryorder,
  categoryarray: axesAttrs.categoryarray,
  title: {
    text: axesAttrs.title.text,
    font: axesAttrs.title.font
  },
  type: extendFlat({}, axesAttrs.type, {
    values: ['-', 'linear', 'log', 'date', 'category']
  }),
  autotypenumbers: axesAttrs.autotypenumbers,
  autorange: axesAttrs.autorange,
  autorangeoptions: {
    minallowed: axesAttrs.autorangeoptions.minallowed,
    maxallowed: axesAttrs.autorangeoptions.maxallowed,
    clipmin: axesAttrs.autorangeoptions.clipmin,
    clipmax: axesAttrs.autorangeoptions.clipmax,
    include: axesAttrs.autorangeoptions.include,
    editType: 'plot'
  },
  rangemode: axesAttrs.rangemode,
  minallowed: axesAttrs.minallowed,
  maxallowed: axesAttrs.maxallowed,
  range: extendFlat({}, axesAttrs.range, {
    items: [{
      valType: 'any',
      editType: 'plot',
      impliedEdits: {
        '^autorange': false
      }
    }, {
      valType: 'any',
      editType: 'plot',
      impliedEdits: {
        '^autorange': false
      }
    }],
    anim: false
  }),
  // ticks
  tickmode: axesAttrs.minor.tickmode,
  nticks: axesAttrs.nticks,
  tick0: axesAttrs.tick0,
  dtick: axesAttrs.dtick,
  tickvals: axesAttrs.tickvals,
  ticktext: axesAttrs.ticktext,
  ticks: axesAttrs.ticks,
  mirror: axesAttrs.mirror,
  ticklen: axesAttrs.ticklen,
  tickwidth: axesAttrs.tickwidth,
  tickcolor: axesAttrs.tickcolor,
  showticklabels: axesAttrs.showticklabels,
  labelalias: axesAttrs.labelalias,
  tickfont: axesAttrs.tickfont,
  tickangle: axesAttrs.tickangle,
  tickprefix: axesAttrs.tickprefix,
  showtickprefix: axesAttrs.showtickprefix,
  ticksuffix: axesAttrs.ticksuffix,
  showticksuffix: axesAttrs.showticksuffix,
  showexponent: axesAttrs.showexponent,
  exponentformat: axesAttrs.exponentformat,
  minexponent: axesAttrs.minexponent,
  separatethousands: axesAttrs.separatethousands,
  tickformat: axesAttrs.tickformat,
  tickformatstops: axesAttrs.tickformatstops,
  hoverformat: axesAttrs.hoverformat,
  // lines and grids
  showline: axesAttrs.showline,
  linecolor: axesAttrs.linecolor,
  linewidth: axesAttrs.linewidth,
  showgrid: axesAttrs.showgrid,
  gridcolor: extendFlat({}, axesAttrs.gridcolor,
  // shouldn't this be on-par with 2D?
  {
    dflt: 'rgb(204, 204, 204)'
  }),
  gridwidth: axesAttrs.gridwidth,
  zeroline: axesAttrs.zeroline,
  zerolinecolor: axesAttrs.zerolinecolor,
  zerolinewidth: axesAttrs.zerolinewidth,
  _deprecated: {
    title: axesAttrs._deprecated.title,
    titlefont: axesAttrs._deprecated.titlefont
  }
}, 'plot', 'from-root');

/***/ }),

/***/ 34258:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var colorMix = (__webpack_require__(65657).mix);
var Lib = __webpack_require__(34809);
var Template = __webpack_require__(78032);
var layoutAttributes = __webpack_require__(63397);
var handleTypeDefaults = __webpack_require__(4392);
var handleAxisDefaults = __webpack_require__(97655);
var axesNames = ['xaxis', 'yaxis', 'zaxis'];

// TODO: hard-coded lightness fraction based on gridline default colors
// that differ from other subplot types.
var gridLightness = 100 * (204 - 0x44) / (255 - 0x44);
module.exports = function supplyLayoutDefaults(layoutIn, layoutOut, options) {
  var containerIn, containerOut;
  function coerce(attr, dflt) {
    return Lib.coerce(containerIn, containerOut, layoutAttributes, attr, dflt);
  }
  for (var j = 0; j < axesNames.length; j++) {
    var axName = axesNames[j];
    containerIn = layoutIn[axName] || {};
    containerOut = Template.newContainer(layoutOut, axName);
    containerOut._id = axName[0] + options.scene;
    containerOut._name = axName;
    handleTypeDefaults(containerIn, containerOut, coerce, options);
    handleAxisDefaults(containerIn, containerOut, coerce, {
      font: options.font,
      letter: axName[0],
      data: options.data,
      showGrid: true,
      noAutotickangles: true,
      noTicklabelindex: true,
      noTickson: true,
      noTicklabelmode: true,
      noTicklabelshift: true,
      noTicklabelstandoff: true,
      noTicklabelstep: true,
      noTicklabelposition: true,
      noTicklabeloverflow: true,
      noInsiderange: true,
      bgColor: options.bgColor,
      calendar: options.calendar
    }, options.fullLayout);
    coerce('gridcolor', colorMix(containerOut.color, options.bgColor, gridLightness).toRgbString());
    coerce('title.text', axName[0]); // shouldn't this be on-par with 2D?

    containerOut.setScale = Lib.noop;
    if (coerce('showspikes')) {
      coerce('spikesides');
      coerce('spikethickness');
      coerce('spikecolor', containerOut.color);
    }
    coerce('showaxeslabels');
    if (coerce('showbackground')) coerce('backgroundcolor');
  }
};

/***/ }),

/***/ 95701:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var str2RgbaArray = __webpack_require__(55010);
var Lib = __webpack_require__(34809);
var AXES_NAMES = ['xaxis', 'yaxis', 'zaxis'];
function AxesOptions() {
  this.bounds = [[-10, -10, -10], [10, 10, 10]];
  this.ticks = [[], [], []];
  this.tickEnable = [true, true, true];
  this.tickFont = ['sans-serif', 'sans-serif', 'sans-serif'];
  this.tickSize = [12, 12, 12];
  this.tickFontWeight = ['normal', 'normal', 'normal', 'normal'];
  this.tickFontStyle = ['normal', 'normal', 'normal', 'normal'];
  this.tickFontVariant = ['normal', 'normal', 'normal', 'normal'];
  this.tickAngle = [0, 0, 0];
  this.tickColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]];
  this.tickPad = [18, 18, 18];
  this.labels = ['x', 'y', 'z'];
  this.labelEnable = [true, true, true];
  this.labelFont = ['Open Sans', 'Open Sans', 'Open Sans'];
  this.labelSize = [20, 20, 20];
  this.labelFontWeight = ['normal', 'normal', 'normal', 'normal'];
  this.labelFontStyle = ['normal', 'normal', 'normal', 'normal'];
  this.labelFontVariant = ['normal', 'normal', 'normal', 'normal'];
  this.labelColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]];
  this.labelPad = [30, 30, 30];
  this.lineEnable = [true, true, true];
  this.lineMirror = [false, false, false];
  this.lineWidth = [1, 1, 1];
  this.lineColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]];
  this.lineTickEnable = [true, true, true];
  this.lineTickMirror = [false, false, false];
  this.lineTickLength = [10, 10, 10];
  this.lineTickWidth = [1, 1, 1];
  this.lineTickColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]];
  this.gridEnable = [true, true, true];
  this.gridWidth = [1, 1, 1];
  this.gridColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]];
  this.zeroEnable = [true, true, true];
  this.zeroLineColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]];
  this.zeroLineWidth = [2, 2, 2];
  this.backgroundEnable = [true, true, true];
  this.backgroundColor = [[0.8, 0.8, 0.8, 0.5], [0.8, 0.8, 0.8, 0.5], [0.8, 0.8, 0.8, 0.5]];

  // some default values are stored for applying model transforms
  this._defaultTickPad = this.tickPad.slice();
  this._defaultLabelPad = this.labelPad.slice();
  this._defaultLineTickLength = this.lineTickLength.slice();
}
var proto = AxesOptions.prototype;
proto.merge = function (fullLayout, sceneLayout) {
  var opts = this;
  for (var i = 0; i < 3; ++i) {
    var axes = sceneLayout[AXES_NAMES[i]];
    if (!axes.visible) {
      opts.tickEnable[i] = false;
      opts.labelEnable[i] = false;
      opts.lineEnable[i] = false;
      opts.lineTickEnable[i] = false;
      opts.gridEnable[i] = false;
      opts.zeroEnable[i] = false;
      opts.backgroundEnable[i] = false;
      continue;
    }

    // Axes labels
    opts.labels[i] = fullLayout._meta ? Lib.templateString(axes.title.text, fullLayout._meta) : axes.title.text;
    if ('font' in axes.title) {
      if (axes.title.font.color) opts.labelColor[i] = str2RgbaArray(axes.title.font.color);
      if (axes.title.font.family) opts.labelFont[i] = axes.title.font.family;
      if (axes.title.font.size) opts.labelSize[i] = axes.title.font.size;
      if (axes.title.font.weight) opts.labelFontWeight[i] = axes.title.font.weight;
      if (axes.title.font.style) opts.labelFontStyle[i] = axes.title.font.style;
      if (axes.title.font.variant) opts.labelFontVariant[i] = axes.title.font.variant;
    }

    // Lines
    if ('showline' in axes) opts.lineEnable[i] = axes.showline;
    if ('linecolor' in axes) opts.lineColor[i] = str2RgbaArray(axes.linecolor);
    if ('linewidth' in axes) opts.lineWidth[i] = axes.linewidth;
    if ('showgrid' in axes) opts.gridEnable[i] = axes.showgrid;
    if ('gridcolor' in axes) opts.gridColor[i] = str2RgbaArray(axes.gridcolor);
    if ('gridwidth' in axes) opts.gridWidth[i] = axes.gridwidth;

    // Remove zeroline if axis type is log
    // otherwise the zeroline is incorrectly drawn at 1 on log axes
    if (axes.type === 'log') opts.zeroEnable[i] = false;else if ('zeroline' in axes) opts.zeroEnable[i] = axes.zeroline;
    if ('zerolinecolor' in axes) opts.zeroLineColor[i] = str2RgbaArray(axes.zerolinecolor);
    if ('zerolinewidth' in axes) opts.zeroLineWidth[i] = axes.zerolinewidth;

    // tick lines
    if ('ticks' in axes && !!axes.ticks) opts.lineTickEnable[i] = true;else opts.lineTickEnable[i] = false;
    if ('ticklen' in axes) {
      opts.lineTickLength[i] = opts._defaultLineTickLength[i] = axes.ticklen;
    }
    if ('tickcolor' in axes) opts.lineTickColor[i] = str2RgbaArray(axes.tickcolor);
    if ('tickwidth' in axes) opts.lineTickWidth[i] = axes.tickwidth;
    if ('tickangle' in axes) {
      opts.tickAngle[i] = axes.tickangle === 'auto' ? -3600 :
      // i.e. special number to set auto option
      Math.PI * -axes.tickangle / 180;
    }

    // tick labels
    if ('showticklabels' in axes) opts.tickEnable[i] = axes.showticklabels;
    if ('tickfont' in axes) {
      if (axes.tickfont.color) opts.tickColor[i] = str2RgbaArray(axes.tickfont.color);
      if (axes.tickfont.family) opts.tickFont[i] = axes.tickfont.family;
      if (axes.tickfont.size) opts.tickSize[i] = axes.tickfont.size;
      if (axes.tickfont.weight) opts.tickFontWeight[i] = axes.tickfont.weight;
      if (axes.tickfont.style) opts.tickFontStyle[i] = axes.tickfont.style;
      if (axes.tickfont.variant) opts.tickFontVariant[i] = axes.tickfont.variant;
    }
    if ('mirror' in axes) {
      if (['ticks', 'all', 'allticks'].indexOf(axes.mirror) !== -1) {
        opts.lineTickMirror[i] = true;
        opts.lineMirror[i] = true;
      } else if (axes.mirror === true) {
        opts.lineTickMirror[i] = false;
        opts.lineMirror[i] = true;
      } else {
        opts.lineTickMirror[i] = false;
        opts.lineMirror[i] = false;
      }
    } else opts.lineMirror[i] = false;

    // grid background
    if ('showbackground' in axes && axes.showbackground !== false) {
      opts.backgroundEnable[i] = true;
      opts.backgroundColor[i] = str2RgbaArray(axes.backgroundcolor);
    } else opts.backgroundEnable[i] = false;
  }
};
function createAxesOptions(fullLayout, sceneLayout) {
  var result = new AxesOptions();
  result.merge(fullLayout, sceneLayout);
  return result;
}
module.exports = createAxesOptions;

/***/ }),

/***/ 15250:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var Color = __webpack_require__(78766);
var Registry = __webpack_require__(33626);
var handleSubplotDefaults = __webpack_require__(4448);
var supplyGl3dAxisLayoutDefaults = __webpack_require__(34258);
var layoutAttributes = __webpack_require__(77168);
var getSubplotData = (__webpack_require__(4173)/* .getSubplotData */ .KO);
var GL3D = 'gl3d';
module.exports = function supplyLayoutDefaults(layoutIn, layoutOut, fullData) {
  var hasNon3D = layoutOut._basePlotModules.length > 1;

  // some layout-wide attribute are used in all scenes
  // if 3D is the only visible plot type
  function getDfltFromLayout(attr) {
    if (hasNon3D) return;
    var isValid = Lib.validate(layoutIn[attr], layoutAttributes[attr]);
    if (isValid) return layoutIn[attr];
  }
  handleSubplotDefaults(layoutIn, layoutOut, fullData, {
    type: GL3D,
    attributes: layoutAttributes,
    handleDefaults: handleGl3dDefaults,
    fullLayout: layoutOut,
    font: layoutOut.font,
    fullData: fullData,
    getDfltFromLayout: getDfltFromLayout,
    autotypenumbersDflt: layoutOut.autotypenumbers,
    paper_bgcolor: layoutOut.paper_bgcolor,
    calendar: layoutOut.calendar
  });
};
function handleGl3dDefaults(sceneLayoutIn, sceneLayoutOut, coerce, opts) {
  /*
   * Scene numbering proceeds as follows
   * scene
   * scene2
   * scene3
   *
   * and d.scene will be undefined or some number or number string
   *
   * Also write back a blank scene object to user layout so that some
   * attributes like aspectratio can be written back dynamically.
   */

  var bgcolor = coerce('bgcolor');
  var bgColorCombined = Color.combine(bgcolor, opts.paper_bgcolor);
  var cameraKeys = ['up', 'center', 'eye'];
  for (var j = 0; j < cameraKeys.length; j++) {
    coerce('camera.' + cameraKeys[j] + '.x');
    coerce('camera.' + cameraKeys[j] + '.y');
    coerce('camera.' + cameraKeys[j] + '.z');
  }
  coerce('camera.projection.type');

  /*
   * coerce to positive number (min 0) but also do not accept 0 (>0 not >=0)
   * note that 0's go false with the !! call
   */
  var hasAspect = !!coerce('aspectratio.x') && !!coerce('aspectratio.y') && !!coerce('aspectratio.z');
  var defaultAspectMode = hasAspect ? 'manual' : 'auto';
  var aspectMode = coerce('aspectmode', defaultAspectMode);

  /*
   * We need aspectratio object in all the Layouts as it is dynamically set
   * in the calculation steps, ie, we cant set the correct data now, it happens later.
   * We must also account for the case the user sends bad ratio data with 'manual' set
   * for the mode. In this case we must force change it here as the default coerce
   * misses it above.
   */
  if (!hasAspect) {
    sceneLayoutIn.aspectratio = sceneLayoutOut.aspectratio = {
      x: 1,
      y: 1,
      z: 1
    };
    if (aspectMode === 'manual') sceneLayoutOut.aspectmode = 'auto';

    /*
     * kind of like autorange - we need the calculated aspectmode back in
     * the input layout or relayout can cause problems later
     */
    sceneLayoutIn.aspectmode = sceneLayoutOut.aspectmode;
  }
  var fullGl3dData = getSubplotData(opts.fullData, GL3D, opts.id);
  supplyGl3dAxisLayoutDefaults(sceneLayoutIn, sceneLayoutOut, {
    font: opts.font,
    scene: opts.id,
    data: fullGl3dData,
    bgColor: bgColorCombined,
    calendar: opts.calendar,
    autotypenumbersDflt: opts.autotypenumbersDflt,
    fullLayout: opts.fullLayout
  });
  Registry.getComponentMethod('annotations3d', 'handleDefaults')(sceneLayoutIn, sceneLayoutOut, opts);
  var dragmode = opts.getDfltFromLayout('dragmode');
  if (dragmode !== false) {
    if (!dragmode) {
      dragmode = 'orbit';
      if (sceneLayoutIn.camera && sceneLayoutIn.camera.up) {
        var x = sceneLayoutIn.camera.up.x;
        var y = sceneLayoutIn.camera.up.y;
        var z = sceneLayoutIn.camera.up.z;
        if (z !== 0) {
          if (!x || !y || !z) {
            dragmode = 'turntable';
          } else if (z / Math.sqrt(x * x + y * y + z * z) > 0.999) {
            dragmode = 'turntable';
          }
        }
      } else {
        dragmode = 'turntable';
      }
    }
  }
  coerce('dragmode', dragmode);
  coerce('hovermode', opts.getDfltFromLayout('hovermode'));
}

/***/ }),

/***/ 77168:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var gl3dAxisAttrs = __webpack_require__(63397);
var domainAttrs = (__webpack_require__(13792)/* .attributes */ .u);
var extendFlat = (__webpack_require__(93049).extendFlat);
var counterRegex = (__webpack_require__(34809).counterRegex);
function makeCameraVector(x, y, z) {
  return {
    x: {
      valType: 'number',
      dflt: x,
      editType: 'camera'
    },
    y: {
      valType: 'number',
      dflt: y,
      editType: 'camera'
    },
    z: {
      valType: 'number',
      dflt: z,
      editType: 'camera'
    },
    editType: 'camera'
  };
}
module.exports = {
  _arrayAttrRegexps: [counterRegex('scene', '.annotations', true)],
  bgcolor: {
    valType: 'color',
    dflt: 'rgba(0,0,0,0)',
    editType: 'plot'
  },
  camera: {
    up: extendFlat(makeCameraVector(0, 0, 1), {}),
    center: extendFlat(makeCameraVector(0, 0, 0), {}),
    eye: extendFlat(makeCameraVector(1.25, 1.25, 1.25), {}),
    projection: {
      type: {
        valType: 'enumerated',
        values: ['perspective', 'orthographic'],
        dflt: 'perspective',
        editType: 'calc'
      },
      editType: 'calc'
    },
    editType: 'camera'
  },
  domain: domainAttrs({
    name: 'scene',
    editType: 'plot'
  }),
  aspectmode: {
    valType: 'enumerated',
    values: ['auto', 'cube', 'data', 'manual'],
    dflt: 'auto',
    editType: 'plot',
    impliedEdits: {
      'aspectratio.x': undefined,
      'aspectratio.y': undefined,
      'aspectratio.z': undefined
    }
  },
  aspectratio: {
    // must be positive (0's are coerced to 1)
    x: {
      valType: 'number',
      min: 0,
      editType: 'plot',
      impliedEdits: {
        '^aspectmode': 'manual'
      }
    },
    y: {
      valType: 'number',
      min: 0,
      editType: 'plot',
      impliedEdits: {
        '^aspectmode': 'manual'
      }
    },
    z: {
      valType: 'number',
      min: 0,
      editType: 'plot',
      impliedEdits: {
        '^aspectmode': 'manual'
      }
    },
    editType: 'plot',
    impliedEdits: {
      aspectmode: 'manual'
    }
  },
  xaxis: gl3dAxisAttrs,
  yaxis: gl3dAxisAttrs,
  zaxis: gl3dAxisAttrs,
  dragmode: {
    valType: 'enumerated',
    values: ['orbit', 'turntable', 'zoom', 'pan', false],
    editType: 'plot'
  },
  hovermode: {
    valType: 'enumerated',
    values: ['closest', false],
    dflt: 'closest',
    editType: 'modebar'
  },
  uirevision: {
    valType: 'any',
    editType: 'none'
  },
  editType: 'plot',
  _deprecated: {
    cameraposition: {
      valType: 'info_array',
      editType: 'camera'
    }
  }
};

/***/ }),

/***/ 64087:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var str2RGBArray = __webpack_require__(55010);
var AXES_NAMES = ['xaxis', 'yaxis', 'zaxis'];
function SpikeOptions() {
  this.enabled = [true, true, true];
  this.colors = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]];
  this.drawSides = [true, true, true];
  this.lineWidth = [1, 1, 1];
}
var proto = SpikeOptions.prototype;
proto.merge = function (sceneLayout) {
  for (var i = 0; i < 3; ++i) {
    var axes = sceneLayout[AXES_NAMES[i]];
    if (!axes.visible) {
      this.enabled[i] = false;
      this.drawSides[i] = false;
      continue;
    }
    this.enabled[i] = axes.showspikes;
    this.colors[i] = str2RGBArray(axes.spikecolor);
    this.drawSides[i] = axes.spikesides;
    this.lineWidth[i] = axes.spikethickness;
  }
};
function createSpikeOptions(layout) {
  var result = new SpikeOptions();
  result.merge(layout);
  return result;
}
module.exports = createSpikeOptions;

/***/ }),

/***/ 32412:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint block-scoped-var: 0*/
/* eslint no-redeclare: 0*/



module.exports = computeTickMarks;
var Axes = __webpack_require__(29714);
var Lib = __webpack_require__(34809);
var AXES_NAMES = ['xaxis', 'yaxis', 'zaxis'];
var centerPoint = [0, 0, 0];
function contourLevelsFromTicks(ticks) {
  var result = new Array(3);
  for (var i = 0; i < 3; ++i) {
    var tlevel = ticks[i];
    var clevel = new Array(tlevel.length);
    for (var j = 0; j < tlevel.length; ++j) {
      clevel[j] = tlevel[j].x;
    }
    result[i] = clevel;
  }
  return result;
}
function computeTickMarks(scene) {
  var axesOptions = scene.axesOptions;
  var glRange = scene.glplot.axesPixels;
  var sceneLayout = scene.fullSceneLayout;
  var ticks = [[], [], []];
  for (var i = 0; i < 3; ++i) {
    var axes = sceneLayout[AXES_NAMES[i]];
    axes._length = (glRange[i].hi - glRange[i].lo) * glRange[i].pixelsPerDataUnit / scene.dataScale[i];
    if (Math.abs(axes._length) === Infinity || isNaN(axes._length)) {
      ticks[i] = [];
    } else {
      axes._input_range = axes.range.slice();
      axes.range[0] = glRange[i].lo / scene.dataScale[i];
      axes.range[1] = glRange[i].hi / scene.dataScale[i];
      axes._m = 1.0 / (scene.dataScale[i] * glRange[i].pixelsPerDataUnit);
      if (axes.range[0] === axes.range[1]) {
        axes.range[0] -= 1;
        axes.range[1] += 1;
      }
      // this is necessary to short-circuit the 'y' handling
      // in autotick part of calcTicks... Treating all axes as 'y' in this case
      // running the autoticks here, then setting
      // autoticks to false to get around the 2D handling in calcTicks.
      var tickModeCached = axes.tickmode;
      if (axes.tickmode === 'auto') {
        axes.tickmode = 'linear';
        var nticks = axes.nticks || Lib.constrain(axes._length / 40, 4, 9);
        Axes.autoTicks(axes, Math.abs(axes.range[1] - axes.range[0]) / nticks);
      }
      var dataTicks = Axes.calcTicks(axes, {
        msUTC: true
      });
      for (var j = 0; j < dataTicks.length; ++j) {
        dataTicks[j].x = dataTicks[j].x * scene.dataScale[i];
        if (axes.type === 'date') {
          dataTicks[j].text = dataTicks[j].text.replace(/\<br\>/g, ' ');
        }
      }
      ticks[i] = dataTicks;
      axes.tickmode = tickModeCached;
    }
  }
  axesOptions.ticks = ticks;

  // Calculate tick lengths dynamically
  for (var i = 0; i < 3; ++i) {
    centerPoint[i] = 0.5 * (scene.glplot.bounds[0][i] + scene.glplot.bounds[1][i]);
    for (var j = 0; j < 2; ++j) {
      axesOptions.bounds[j][i] = scene.glplot.bounds[j][i];
    }
  }
  scene.contourLevels = contourLevelsFromTicks(ticks);
}

/***/ }),

/***/ 25802:
/***/ (function(module) {

"use strict";


function xformMatrix(m, v) {
  var out = [0, 0, 0, 0];
  var i, j;
  for (i = 0; i < 4; ++i) {
    for (j = 0; j < 4; ++j) {
      out[j] += m[4 * i + j] * v[i];
    }
  }
  return out;
}
function project(camera, v) {
  var p = xformMatrix(camera.projection, xformMatrix(camera.view, xformMatrix(camera.model, [v[0], v[1], v[2], 1])));
  return p;
}
module.exports = project;

/***/ }),

/***/ 20299:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var glPlot3d = (__webpack_require__(99098).gl_plot3d);
var createCamera = glPlot3d.createCamera;
var createPlot = glPlot3d.createScene;
var getContext = __webpack_require__(22248);
var passiveSupported = __webpack_require__(74043);
var Registry = __webpack_require__(33626);
var Lib = __webpack_require__(34809);
var preserveDrawingBuffer = Lib.preserveDrawingBuffer();
var Axes = __webpack_require__(29714);
var Fx = __webpack_require__(32141);
var str2RGBAarray = __webpack_require__(55010);
var showNoWebGlMsg = __webpack_require__(97464);
var project = __webpack_require__(25802);
var createAxesOptions = __webpack_require__(95701);
var createSpikeOptions = __webpack_require__(64087);
var computeTickMarks = __webpack_require__(32412);
var applyAutorangeOptions = (__webpack_require__(32919).applyAutorangeOptions);
var STATIC_CANVAS, STATIC_CONTEXT;
var tabletmode = false;
function Scene(options, fullLayout) {
  // create sub container for plot
  var sceneContainer = document.createElement('div');
  var plotContainer = options.container;

  // keep a ref to the graph div to fire hover+click events
  this.graphDiv = options.graphDiv;

  // create SVG container for hover text
  var svgContainer = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  svgContainer.style.position = 'absolute';
  svgContainer.style.top = svgContainer.style.left = '0px';
  svgContainer.style.width = svgContainer.style.height = '100%';
  svgContainer.style['z-index'] = 20;
  svgContainer.style['pointer-events'] = 'none';
  sceneContainer.appendChild(svgContainer);
  this.svgContainer = svgContainer;

  // Tag the container with the sceneID
  sceneContainer.id = options.id;
  sceneContainer.style.position = 'absolute';
  sceneContainer.style.top = sceneContainer.style.left = '0px';
  sceneContainer.style.width = sceneContainer.style.height = '100%';
  plotContainer.appendChild(sceneContainer);
  this.fullLayout = fullLayout;
  this.id = options.id || 'scene';
  this.fullSceneLayout = fullLayout[this.id];

  // Saved from last call to plot()
  this.plotArgs = [[], {}, {}];

  /*
   * Move this to calc step? Why does it work here?
   */
  this.axesOptions = createAxesOptions(fullLayout, fullLayout[this.id]);
  this.spikeOptions = createSpikeOptions(fullLayout[this.id]);
  this.container = sceneContainer;
  this.staticMode = !!options.staticPlot;
  this.pixelRatio = this.pixelRatio || options.plotGlPixelRatio || 2;

  // Coordinate rescaling
  this.dataScale = [1, 1, 1];
  this.contourLevels = [[], [], []];
  this.convertAnnotations = Registry.getComponentMethod('annotations3d', 'convert');
  this.drawAnnotations = Registry.getComponentMethod('annotations3d', 'draw');
  this.initializeGLPlot();
}
var proto = Scene.prototype;
proto.prepareOptions = function () {
  var scene = this;
  var opts = {
    canvas: scene.canvas,
    gl: scene.gl,
    glOptions: {
      preserveDrawingBuffer: preserveDrawingBuffer,
      premultipliedAlpha: true,
      antialias: true
    },
    container: scene.container,
    axes: scene.axesOptions,
    spikes: scene.spikeOptions,
    pickRadius: 10,
    snapToData: true,
    autoScale: true,
    autoBounds: false,
    cameraObject: scene.camera,
    pixelRatio: scene.pixelRatio
  };

  // for static plots, we reuse the WebGL context
  //  as WebKit doesn't collect them reliably
  if (scene.staticMode) {
    if (!STATIC_CONTEXT) {
      STATIC_CANVAS = document.createElement('canvas');
      STATIC_CONTEXT = getContext({
        canvas: STATIC_CANVAS,
        preserveDrawingBuffer: true,
        premultipliedAlpha: true,
        antialias: true
      });
      if (!STATIC_CONTEXT) {
        throw new Error('error creating static canvas/context for image server');
      }
    }
    opts.gl = STATIC_CONTEXT;
    opts.canvas = STATIC_CANVAS;
  }
  return opts;
};
var firstInit = true;
proto.tryCreatePlot = function () {
  var scene = this;
  var opts = scene.prepareOptions();
  var success = true;
  try {
    scene.glplot = createPlot(opts);
  } catch (e) {
    if (scene.staticMode || !firstInit || preserveDrawingBuffer) {
      success = false;
    } else {
      // try second time
      // enable preserveDrawingBuffer setup
      // in case is-mobile not detecting the right device
      Lib.warn(['webgl setup failed possibly due to', 'false preserveDrawingBuffer config.', 'The mobile/tablet device may not be detected by is-mobile module.', 'Enabling preserveDrawingBuffer in second attempt to create webgl scene...'].join(' '));
      try {
        // invert preserveDrawingBuffer
        preserveDrawingBuffer = opts.glOptions.preserveDrawingBuffer = true;
        scene.glplot = createPlot(opts);
      } catch (e) {
        // revert changes to preserveDrawingBuffer
        preserveDrawingBuffer = opts.glOptions.preserveDrawingBuffer = false;
        success = false;
      }
    }
  }
  firstInit = false;
  return success;
};
proto.initializeGLCamera = function () {
  var scene = this;
  var cameraData = scene.fullSceneLayout.camera;
  var isOrtho = cameraData.projection.type === 'orthographic';
  scene.camera = createCamera(scene.container, {
    center: [cameraData.center.x, cameraData.center.y, cameraData.center.z],
    eye: [cameraData.eye.x, cameraData.eye.y, cameraData.eye.z],
    up: [cameraData.up.x, cameraData.up.y, cameraData.up.z],
    _ortho: isOrtho,
    zoomMin: 0.01,
    zoomMax: 100,
    mode: 'orbit'
  });
};
proto.initializeGLPlot = function () {
  var scene = this;
  scene.initializeGLCamera();
  var success = scene.tryCreatePlot();
  /*
  * createPlot will throw when webgl is not enabled in the client.
  * Lets return an instance of the module with all functions noop'd.
  * The destroy method - which will remove the container from the DOM
  * is overridden with a function that removes the container only.
  */
  if (!success) return showNoWebGlMsg(scene);

  // List of scene objects
  scene.traces = {};
  scene.make4thDimension();
  var gd = scene.graphDiv;
  var layout = gd.layout;
  var makeUpdate = function () {
    var update = {};
    if (scene.isCameraChanged(layout)) {
      // camera updates
      update[scene.id + '.camera'] = scene.getCamera();
    }
    if (scene.isAspectChanged(layout)) {
      // scene updates
      update[scene.id + '.aspectratio'] = scene.glplot.getAspectratio();
      if (layout[scene.id].aspectmode !== 'manual') {
        scene.fullSceneLayout.aspectmode = layout[scene.id].aspectmode = update[scene.id + '.aspectmode'] = 'manual';
      }
    }
    return update;
  };
  var relayoutCallback = function (scene) {
    if (scene.fullSceneLayout.dragmode === false) return;
    var update = makeUpdate();
    scene.saveLayout(layout);
    scene.graphDiv.emit('plotly_relayout', update);
  };
  if (scene.glplot.canvas) {
    scene.glplot.canvas.addEventListener('mouseup', function () {
      relayoutCallback(scene);
    });
    scene.glplot.canvas.addEventListener('touchstart', function () {
      tabletmode = true;
    });
    scene.glplot.canvas.addEventListener('wheel', function (e) {
      if (gd._context._scrollZoom.gl3d) {
        if (scene.camera._ortho) {
          var s = e.deltaX > e.deltaY ? 1.1 : 1.0 / 1.1;
          var o = scene.glplot.getAspectratio();
          scene.glplot.setAspectratio({
            x: s * o.x,
            y: s * o.y,
            z: s * o.z
          });
        }
        relayoutCallback(scene);
      }
    }, passiveSupported ? {
      passive: false
    } : false);
    scene.glplot.canvas.addEventListener('mousemove', function () {
      if (scene.fullSceneLayout.dragmode === false) return;
      if (scene.camera.mouseListener.buttons === 0) return;
      var update = makeUpdate();
      scene.graphDiv.emit('plotly_relayouting', update);
    });
    if (!scene.staticMode) {
      scene.glplot.canvas.addEventListener('webglcontextlost', function (event) {
        if (gd && gd.emit) {
          gd.emit('plotly_webglcontextlost', {
            event: event,
            layer: scene.id
          });
        }
      }, false);
    }
  }
  scene.glplot.oncontextloss = function () {
    scene.recoverContext();
  };
  scene.glplot.onrender = function () {
    scene.render();
  };
  return true;
};
proto.render = function () {
  var scene = this;
  var gd = scene.graphDiv;
  var trace;

  // update size of svg container
  var svgContainer = scene.svgContainer;
  var clientRect = scene.container.getBoundingClientRect();
  gd._fullLayout._calcInverseTransform(gd);
  var scaleX = gd._fullLayout._invScaleX;
  var scaleY = gd._fullLayout._invScaleY;
  var width = clientRect.width * scaleX;
  var height = clientRect.height * scaleY;
  svgContainer.setAttributeNS(null, 'viewBox', '0 0 ' + width + ' ' + height);
  svgContainer.setAttributeNS(null, 'width', width);
  svgContainer.setAttributeNS(null, 'height', height);
  computeTickMarks(scene);
  scene.glplot.axes.update(scene.axesOptions);

  // check if pick has changed
  var keys = Object.keys(scene.traces);
  var lastPicked = null;
  var selection = scene.glplot.selection;
  for (var i = 0; i < keys.length; ++i) {
    trace = scene.traces[keys[i]];
    if (trace.data.hoverinfo !== 'skip' && trace.handlePick(selection)) {
      lastPicked = trace;
    }
    if (trace.setContourLevels) trace.setContourLevels();
  }
  function formatter(axLetter, val, hoverformat) {
    var ax = scene.fullSceneLayout[axLetter + 'axis'];
    if (ax.type !== 'log') {
      val = ax.d2l(val);
    }
    return Axes.hoverLabelText(ax, val, hoverformat);
  }
  if (lastPicked !== null) {
    var pdata = project(scene.glplot.cameraParams, selection.dataCoordinate);
    trace = lastPicked.data;
    var traceNow = gd._fullData[trace.index];
    var ptNumber = selection.index;
    var labels = {
      xLabel: formatter('x', selection.traceCoordinate[0], trace.xhoverformat),
      yLabel: formatter('y', selection.traceCoordinate[1], trace.yhoverformat),
      zLabel: formatter('z', selection.traceCoordinate[2], trace.zhoverformat)
    };
    var hoverinfo = Fx.castHoverinfo(traceNow, scene.fullLayout, ptNumber);
    var hoverinfoParts = (hoverinfo || '').split('+');
    var isHoverinfoAll = hoverinfo && hoverinfo === 'all';
    if (!traceNow.hovertemplate && !isHoverinfoAll) {
      if (hoverinfoParts.indexOf('x') === -1) labels.xLabel = undefined;
      if (hoverinfoParts.indexOf('y') === -1) labels.yLabel = undefined;
      if (hoverinfoParts.indexOf('z') === -1) labels.zLabel = undefined;
      if (hoverinfoParts.indexOf('text') === -1) selection.textLabel = undefined;
      if (hoverinfoParts.indexOf('name') === -1) lastPicked.name = undefined;
    }
    var tx;
    var vectorTx = [];
    if (trace.type === 'cone' || trace.type === 'streamtube') {
      labels.uLabel = formatter('x', selection.traceCoordinate[3], trace.uhoverformat);
      if (isHoverinfoAll || hoverinfoParts.indexOf('u') !== -1) {
        vectorTx.push('u: ' + labels.uLabel);
      }
      labels.vLabel = formatter('y', selection.traceCoordinate[4], trace.vhoverformat);
      if (isHoverinfoAll || hoverinfoParts.indexOf('v') !== -1) {
        vectorTx.push('v: ' + labels.vLabel);
      }
      labels.wLabel = formatter('z', selection.traceCoordinate[5], trace.whoverformat);
      if (isHoverinfoAll || hoverinfoParts.indexOf('w') !== -1) {
        vectorTx.push('w: ' + labels.wLabel);
      }
      labels.normLabel = selection.traceCoordinate[6].toPrecision(3);
      if (isHoverinfoAll || hoverinfoParts.indexOf('norm') !== -1) {
        vectorTx.push('norm: ' + labels.normLabel);
      }
      if (trace.type === 'streamtube') {
        labels.divergenceLabel = selection.traceCoordinate[7].toPrecision(3);
        if (isHoverinfoAll || hoverinfoParts.indexOf('divergence') !== -1) {
          vectorTx.push('divergence: ' + labels.divergenceLabel);
        }
      }
      if (selection.textLabel) {
        vectorTx.push(selection.textLabel);
      }
      tx = vectorTx.join('<br>');
    } else if (trace.type === 'isosurface' || trace.type === 'volume') {
      labels.valueLabel = Axes.hoverLabelText(scene._mockAxis, scene._mockAxis.d2l(selection.traceCoordinate[3]), trace.valuehoverformat);
      vectorTx.push('value: ' + labels.valueLabel);
      if (selection.textLabel) {
        vectorTx.push(selection.textLabel);
      }
      tx = vectorTx.join('<br>');
    } else {
      tx = selection.textLabel;
    }
    var pointData = {
      x: selection.traceCoordinate[0],
      y: selection.traceCoordinate[1],
      z: selection.traceCoordinate[2],
      data: traceNow._input,
      fullData: traceNow,
      curveNumber: traceNow.index,
      pointNumber: ptNumber
    };
    Fx.appendArrayPointValue(pointData, traceNow, ptNumber);
    if (trace._module.eventData) {
      pointData = traceNow._module.eventData(pointData, selection, traceNow, {}, ptNumber);
    }
    var eventData = {
      points: [pointData]
    };
    if (scene.fullSceneLayout.hovermode) {
      var bbox = [];
      Fx.loneHover({
        trace: traceNow,
        x: (0.5 + 0.5 * pdata[0] / pdata[3]) * width,
        y: (0.5 - 0.5 * pdata[1] / pdata[3]) * height,
        xLabel: labels.xLabel,
        yLabel: labels.yLabel,
        zLabel: labels.zLabel,
        text: tx,
        name: lastPicked.name,
        color: Fx.castHoverOption(traceNow, ptNumber, 'bgcolor') || lastPicked.color,
        borderColor: Fx.castHoverOption(traceNow, ptNumber, 'bordercolor'),
        fontFamily: Fx.castHoverOption(traceNow, ptNumber, 'font.family'),
        fontSize: Fx.castHoverOption(traceNow, ptNumber, 'font.size'),
        fontColor: Fx.castHoverOption(traceNow, ptNumber, 'font.color'),
        nameLength: Fx.castHoverOption(traceNow, ptNumber, 'namelength'),
        textAlign: Fx.castHoverOption(traceNow, ptNumber, 'align'),
        hovertemplate: Lib.castOption(traceNow, ptNumber, 'hovertemplate'),
        hovertemplateLabels: Lib.extendFlat({}, pointData, labels),
        eventData: [pointData]
      }, {
        container: svgContainer,
        gd: gd,
        inOut_bbox: bbox
      });
      pointData.bbox = bbox[0];
    }
    if (selection.distance < 5 && (selection.buttons || tabletmode)) {
      gd.emit('plotly_click', eventData);
    } else {
      gd.emit('plotly_hover', eventData);
    }
    this.oldEventData = eventData;
  } else {
    Fx.loneUnhover(svgContainer);
    if (this.oldEventData) gd.emit('plotly_unhover', this.oldEventData);
    this.oldEventData = undefined;
  }
  scene.drawAnnotations(scene);
};
proto.recoverContext = function () {
  var scene = this;
  scene.glplot.dispose();
  var tryRecover = function () {
    if (scene.glplot.gl.isContextLost()) {
      requestAnimationFrame(tryRecover);
      return;
    }
    if (!scene.initializeGLPlot()) {
      Lib.error('Catastrophic and unrecoverable WebGL error. Context lost.');
      return;
    }
    scene.plot.apply(scene, scene.plotArgs);
  };
  requestAnimationFrame(tryRecover);
};
var axisProperties = ['xaxis', 'yaxis', 'zaxis'];
function computeTraceBounds(scene, trace, bounds) {
  var fullSceneLayout = scene.fullSceneLayout;
  for (var d = 0; d < 3; d++) {
    var axisName = axisProperties[d];
    var axLetter = axisName.charAt(0);
    var ax = fullSceneLayout[axisName];
    var coords = trace[axLetter];
    var calendar = trace[axLetter + 'calendar'];
    var len = trace['_' + axLetter + 'length'];
    if (!Lib.isArrayOrTypedArray(coords)) {
      bounds[0][d] = Math.min(bounds[0][d], 0);
      bounds[1][d] = Math.max(bounds[1][d], len - 1);
    } else {
      var v;
      for (var i = 0; i < (len || coords.length); i++) {
        if (Lib.isArrayOrTypedArray(coords[i])) {
          for (var j = 0; j < coords[i].length; ++j) {
            v = ax.d2l(coords[i][j], 0, calendar);
            if (!isNaN(v) && isFinite(v)) {
              bounds[0][d] = Math.min(bounds[0][d], v);
              bounds[1][d] = Math.max(bounds[1][d], v);
            }
          }
        } else {
          v = ax.d2l(coords[i], 0, calendar);
          if (!isNaN(v) && isFinite(v)) {
            bounds[0][d] = Math.min(bounds[0][d], v);
            bounds[1][d] = Math.max(bounds[1][d], v);
          }
        }
      }
    }
  }
}
function computeAnnotationBounds(scene, bounds) {
  var fullSceneLayout = scene.fullSceneLayout;
  var annotations = fullSceneLayout.annotations || [];
  for (var d = 0; d < 3; d++) {
    var axisName = axisProperties[d];
    var axLetter = axisName.charAt(0);
    var ax = fullSceneLayout[axisName];
    for (var j = 0; j < annotations.length; j++) {
      var ann = annotations[j];
      if (ann.visible) {
        var pos = ax.r2l(ann[axLetter]);
        if (!isNaN(pos) && isFinite(pos)) {
          bounds[0][d] = Math.min(bounds[0][d], pos);
          bounds[1][d] = Math.max(bounds[1][d], pos);
        }
      }
    }
  }
}
proto.plot = function (sceneData, fullLayout, layout) {
  var scene = this;

  // Save parameters
  scene.plotArgs = [sceneData, fullLayout, layout];
  if (scene.glplot.contextLost) return;
  var data, trace;
  var i, j, axis, axisType;
  var fullSceneLayout = fullLayout[scene.id];
  var sceneLayout = layout[scene.id];

  // Update layout
  scene.fullLayout = fullLayout;
  scene.fullSceneLayout = fullSceneLayout;
  scene.axesOptions.merge(fullLayout, fullSceneLayout);
  scene.spikeOptions.merge(fullSceneLayout);

  // Update camera and camera mode
  scene.setViewport(fullSceneLayout);
  scene.updateFx(fullSceneLayout.dragmode, fullSceneLayout.hovermode);
  scene.camera.enableWheel = scene.graphDiv._context._scrollZoom.gl3d;

  // Update scene background
  scene.glplot.setClearColor(str2RGBAarray(fullSceneLayout.bgcolor));

  // Update axes functions BEFORE updating traces
  scene.setConvert(axis);

  // Convert scene data
  if (!sceneData) sceneData = [];else if (!Array.isArray(sceneData)) sceneData = [sceneData];

  // Compute trace bounding box
  var dataBounds = [[Infinity, Infinity, Infinity], [-Infinity, -Infinity, -Infinity]];
  for (i = 0; i < sceneData.length; ++i) {
    data = sceneData[i];
    if (data.visible !== true || data._length === 0) continue;
    computeTraceBounds(this, data, dataBounds);
  }
  computeAnnotationBounds(this, dataBounds);
  var dataScale = [1, 1, 1];
  for (j = 0; j < 3; ++j) {
    if (dataBounds[1][j] === dataBounds[0][j]) {
      dataScale[j] = 1.0;
    } else {
      dataScale[j] = 1.0 / (dataBounds[1][j] - dataBounds[0][j]);
    }
  }

  // Save scale
  scene.dataScale = dataScale;

  // after computeTraceBounds where ax._categories are filled in
  scene.convertAnnotations(this);

  // Update traces
  for (i = 0; i < sceneData.length; ++i) {
    data = sceneData[i];
    if (data.visible !== true || data._length === 0) {
      continue;
    }
    trace = scene.traces[data.uid];
    if (trace) {
      if (trace.data.type === data.type) {
        trace.update(data);
      } else {
        trace.dispose();
        trace = data._module.plot(this, data);
        scene.traces[data.uid] = trace;
      }
    } else {
      trace = data._module.plot(this, data);
      scene.traces[data.uid] = trace;
    }
    trace.name = data.name;
  }

  // Remove empty traces
  var traceIds = Object.keys(scene.traces);
  traceIdLoop: for (i = 0; i < traceIds.length; ++i) {
    for (j = 0; j < sceneData.length; ++j) {
      if (sceneData[j].uid === traceIds[i] && sceneData[j].visible === true && sceneData[j]._length !== 0) {
        continue traceIdLoop;
      }
    }
    trace = scene.traces[traceIds[i]];
    trace.dispose();
    delete scene.traces[traceIds[i]];
  }

  // order object per trace index
  scene.glplot.objects.sort(function (a, b) {
    return a._trace.data.index - b._trace.data.index;
  });

  // Update ranges (needs to be called *after* objects are added due to updates)
  var sceneBounds = [[0, 0, 0], [0, 0, 0]];
  var axisDataRange = [];
  var axisTypeRatios = {};
  for (i = 0; i < 3; ++i) {
    axis = fullSceneLayout[axisProperties[i]];
    axisType = axis.type;
    if (axisType in axisTypeRatios) {
      axisTypeRatios[axisType].acc *= dataScale[i];
      axisTypeRatios[axisType].count += 1;
    } else {
      axisTypeRatios[axisType] = {
        acc: dataScale[i],
        count: 1
      };
    }
    var range;
    if (axis.autorange) {
      sceneBounds[0][i] = Infinity;
      sceneBounds[1][i] = -Infinity;
      var objects = scene.glplot.objects;
      var annotations = scene.fullSceneLayout.annotations || [];
      var axLetter = axis._name.charAt(0);
      for (j = 0; j < objects.length; j++) {
        var obj = objects[j];
        var objBounds = obj.bounds;
        var pad = obj._trace.data._pad || 0;
        if (obj.constructor.name === 'ErrorBars' && axis._lowerLogErrorBound) {
          sceneBounds[0][i] = Math.min(sceneBounds[0][i], axis._lowerLogErrorBound);
        } else {
          sceneBounds[0][i] = Math.min(sceneBounds[0][i], objBounds[0][i] / dataScale[i] - pad);
        }
        sceneBounds[1][i] = Math.max(sceneBounds[1][i], objBounds[1][i] / dataScale[i] + pad);
      }
      for (j = 0; j < annotations.length; j++) {
        var ann = annotations[j];

        // N.B. not taking into consideration the arrowhead
        if (ann.visible) {
          var pos = axis.r2l(ann[axLetter]);
          sceneBounds[0][i] = Math.min(sceneBounds[0][i], pos);
          sceneBounds[1][i] = Math.max(sceneBounds[1][i], pos);
        }
      }
      if ('rangemode' in axis && axis.rangemode === 'tozero') {
        sceneBounds[0][i] = Math.min(sceneBounds[0][i], 0);
        sceneBounds[1][i] = Math.max(sceneBounds[1][i], 0);
      }
      if (sceneBounds[0][i] > sceneBounds[1][i]) {
        sceneBounds[0][i] = -1;
        sceneBounds[1][i] = 1;
      } else {
        var d = sceneBounds[1][i] - sceneBounds[0][i];
        sceneBounds[0][i] -= d / 32.0;
        sceneBounds[1][i] += d / 32.0;
      }
      range = [sceneBounds[0][i], sceneBounds[1][i]];
      range = applyAutorangeOptions(range, axis);
      sceneBounds[0][i] = range[0];
      sceneBounds[1][i] = range[1];
      if (axis.isReversed()) {
        // swap bounds:
        var tmp = sceneBounds[0][i];
        sceneBounds[0][i] = sceneBounds[1][i];
        sceneBounds[1][i] = tmp;
      }
    } else {
      range = axis.range;
      sceneBounds[0][i] = axis.r2l(range[0]);
      sceneBounds[1][i] = axis.r2l(range[1]);
    }
    if (sceneBounds[0][i] === sceneBounds[1][i]) {
      sceneBounds[0][i] -= 1;
      sceneBounds[1][i] += 1;
    }
    axisDataRange[i] = sceneBounds[1][i] - sceneBounds[0][i];
    axis.range = [sceneBounds[0][i], sceneBounds[1][i]];
    axis.limitRange();

    // Update plot bounds
    scene.glplot.setBounds(i, {
      min: axis.range[0] * dataScale[i],
      max: axis.range[1] * dataScale[i]
    });
  }

  /*
   * Dynamically set the aspect ratio depending on the users aspect settings
   */
  var aspectRatio;
  var aspectmode = fullSceneLayout.aspectmode;
  if (aspectmode === 'cube') {
    aspectRatio = [1, 1, 1];
  } else if (aspectmode === 'manual') {
    var userRatio = fullSceneLayout.aspectratio;
    aspectRatio = [userRatio.x, userRatio.y, userRatio.z];
  } else if (aspectmode === 'auto' || aspectmode === 'data') {
    var axesScaleRatio = [1, 1, 1];
    // Compute axis scale per category
    for (i = 0; i < 3; ++i) {
      axis = fullSceneLayout[axisProperties[i]];
      axisType = axis.type;
      var axisRatio = axisTypeRatios[axisType];
      axesScaleRatio[i] = Math.pow(axisRatio.acc, 1.0 / axisRatio.count) / dataScale[i];
    }
    if (aspectmode === 'data') {
      aspectRatio = axesScaleRatio;
    } else {
      // i.e. 'auto' option
      if (Math.max.apply(null, axesScaleRatio) / Math.min.apply(null, axesScaleRatio) <= 4) {
        // USE DATA MODE WHEN AXIS RANGE DIMENSIONS ARE RELATIVELY EQUAL
        aspectRatio = axesScaleRatio;
      } else {
        // USE EQUAL MODE WHEN AXIS RANGE DIMENSIONS ARE HIGHLY UNEQUAL
        aspectRatio = [1, 1, 1];
      }
    }
  } else {
    throw new Error('scene.js aspectRatio was not one of the enumerated types');
  }

  /*
   * Write aspect Ratio back to user data and fullLayout so that it is modifies as user
   * manipulates the aspectmode settings and the fullLayout is up-to-date.
   */
  fullSceneLayout.aspectratio.x = sceneLayout.aspectratio.x = aspectRatio[0];
  fullSceneLayout.aspectratio.y = sceneLayout.aspectratio.y = aspectRatio[1];
  fullSceneLayout.aspectratio.z = sceneLayout.aspectratio.z = aspectRatio[2];

  /*
   * Finally assign the computed aspecratio to the glplot module. This will have an effect
   * on the next render cycle.
   */
  scene.glplot.setAspectratio(fullSceneLayout.aspectratio);

  // save 'initial' aspectratio & aspectmode view settings for modebar buttons
  if (!scene.viewInitial.aspectratio) {
    scene.viewInitial.aspectratio = {
      x: fullSceneLayout.aspectratio.x,
      y: fullSceneLayout.aspectratio.y,
      z: fullSceneLayout.aspectratio.z
    };
  }
  if (!scene.viewInitial.aspectmode) {
    scene.viewInitial.aspectmode = fullSceneLayout.aspectmode;
  }

  // Update frame position for multi plots
  var domain = fullSceneLayout.domain || null;
  var size = fullLayout._size || null;
  if (domain && size) {
    var containerStyle = scene.container.style;
    containerStyle.position = 'absolute';
    containerStyle.left = size.l + domain.x[0] * size.w + 'px';
    containerStyle.top = size.t + (1 - domain.y[1]) * size.h + 'px';
    containerStyle.width = size.w * (domain.x[1] - domain.x[0]) + 'px';
    containerStyle.height = size.h * (domain.y[1] - domain.y[0]) + 'px';
  }

  // force redraw so that promise is returned when rendering is completed
  scene.glplot.redraw();
};
proto.destroy = function () {
  var scene = this;
  if (!scene.glplot) return;
  scene.camera.mouseListener.enabled = false;
  scene.container.removeEventListener('wheel', scene.camera.wheelListener);
  scene.camera = null;
  scene.glplot.dispose();
  scene.container.parentNode.removeChild(scene.container);
  scene.glplot = null;
};

// getCameraArrays :: plotly_coords -> gl-plot3d_coords
// inverse of getLayoutCamera
function getCameraArrays(camera) {
  return [[camera.eye.x, camera.eye.y, camera.eye.z], [camera.center.x, camera.center.y, camera.center.z], [camera.up.x, camera.up.y, camera.up.z]];
}

// getLayoutCamera :: gl-plot3d_coords -> plotly_coords
// inverse of getCameraArrays
function getLayoutCamera(camera) {
  return {
    up: {
      x: camera.up[0],
      y: camera.up[1],
      z: camera.up[2]
    },
    center: {
      x: camera.center[0],
      y: camera.center[1],
      z: camera.center[2]
    },
    eye: {
      x: camera.eye[0],
      y: camera.eye[1],
      z: camera.eye[2]
    },
    projection: {
      type: camera._ortho === true ? 'orthographic' : 'perspective'
    }
  };
}

// get camera position in plotly coords from 'gl-plot3d' coords
proto.getCamera = function () {
  var scene = this;
  scene.camera.view.recalcMatrix(scene.camera.view.lastT());
  return getLayoutCamera(scene.camera);
};

// set gl-plot3d camera position and scene aspects with a set of plotly coords
proto.setViewport = function (sceneLayout) {
  var scene = this;
  var cameraData = sceneLayout.camera;
  scene.camera.lookAt.apply(this, getCameraArrays(cameraData));
  scene.glplot.setAspectratio(sceneLayout.aspectratio);
  var newOrtho = cameraData.projection.type === 'orthographic';
  var oldOrtho = scene.camera._ortho;
  if (newOrtho !== oldOrtho) {
    scene.glplot.redraw(); // TODO: figure out why we need to redraw here?
    scene.glplot.clearRGBA();
    scene.glplot.dispose();
    scene.initializeGLPlot();
  }
};
proto.isCameraChanged = function (layout) {
  var scene = this;
  var cameraData = scene.getCamera();
  var cameraNestedProp = Lib.nestedProperty(layout, scene.id + '.camera');
  var cameraDataLastSave = cameraNestedProp.get();
  function same(x, y, i, j) {
    var vectors = ['up', 'center', 'eye'];
    var components = ['x', 'y', 'z'];
    return y[vectors[i]] && x[vectors[i]][components[j]] === y[vectors[i]][components[j]];
  }
  var changed = false;
  if (cameraDataLastSave === undefined) {
    changed = true;
  } else {
    for (var i = 0; i < 3; i++) {
      for (var j = 0; j < 3; j++) {
        if (!same(cameraData, cameraDataLastSave, i, j)) {
          changed = true;
          break;
        }
      }
    }
    if (!cameraDataLastSave.projection || cameraData.projection && cameraData.projection.type !== cameraDataLastSave.projection.type) {
      changed = true;
    }
  }
  return changed;
};
proto.isAspectChanged = function (layout) {
  var scene = this;
  var aspectData = scene.glplot.getAspectratio();
  var aspectNestedProp = Lib.nestedProperty(layout, scene.id + '.aspectratio');
  var aspectDataLastSave = aspectNestedProp.get();
  return aspectDataLastSave === undefined || aspectDataLastSave.x !== aspectData.x || aspectDataLastSave.y !== aspectData.y || aspectDataLastSave.z !== aspectData.z;
};

// save camera to user layout (i.e. gd.layout)
proto.saveLayout = function (layout) {
  var scene = this;
  var fullLayout = scene.fullLayout;
  var cameraData;
  var cameraNestedProp;
  var cameraDataLastSave;
  var aspectData;
  var aspectNestedProp;
  var aspectDataLastSave;
  var cameraChanged = scene.isCameraChanged(layout);
  var aspectChanged = scene.isAspectChanged(layout);
  var hasChanged = cameraChanged || aspectChanged;
  if (hasChanged) {
    var preGUI = {};
    if (cameraChanged) {
      cameraData = scene.getCamera();
      cameraNestedProp = Lib.nestedProperty(layout, scene.id + '.camera');
      cameraDataLastSave = cameraNestedProp.get();
      preGUI[scene.id + '.camera'] = cameraDataLastSave;
    }
    if (aspectChanged) {
      aspectData = scene.glplot.getAspectratio();
      aspectNestedProp = Lib.nestedProperty(layout, scene.id + '.aspectratio');
      aspectDataLastSave = aspectNestedProp.get();
      preGUI[scene.id + '.aspectratio'] = aspectDataLastSave;
    }
    Registry.call('_storeDirectGUIEdit', layout, fullLayout._preGUI, preGUI);
    if (cameraChanged) {
      cameraNestedProp.set(cameraData);
      var cameraFullNP = Lib.nestedProperty(fullLayout, scene.id + '.camera');
      cameraFullNP.set(cameraData);
    }
    if (aspectChanged) {
      aspectNestedProp.set(aspectData);
      var aspectFullNP = Lib.nestedProperty(fullLayout, scene.id + '.aspectratio');
      aspectFullNP.set(aspectData);
      scene.glplot.redraw();
    }
  }
  return hasChanged;
};
proto.updateFx = function (dragmode, hovermode) {
  var scene = this;
  var camera = scene.camera;
  if (camera) {
    // rotate and orbital are synonymous
    if (dragmode === 'orbit') {
      camera.mode = 'orbit';
      camera.keyBindingMode = 'rotate';
    } else if (dragmode === 'turntable') {
      camera.up = [0, 0, 1];
      camera.mode = 'turntable';
      camera.keyBindingMode = 'rotate';

      // The setter for camera.mode animates the transition to z-up,
      // but only if we *don't* explicitly set z-up earlier via the
      // relayout. So push `up` back to layout & fullLayout manually now.
      var gd = scene.graphDiv;
      var fullLayout = gd._fullLayout;
      var fullCamera = scene.fullSceneLayout.camera;
      var x = fullCamera.up.x;
      var y = fullCamera.up.y;
      var z = fullCamera.up.z;
      // only push `up` back to (full)layout if it's going to change
      if (z / Math.sqrt(x * x + y * y + z * z) < 0.999) {
        var attr = scene.id + '.camera.up';
        var zUp = {
          x: 0,
          y: 0,
          z: 1
        };
        var edits = {};
        edits[attr] = zUp;
        var layout = gd.layout;
        Registry.call('_storeDirectGUIEdit', layout, fullLayout._preGUI, edits);
        fullCamera.up = zUp;
        Lib.nestedProperty(layout, attr).set(zUp);
      }
    } else {
      // none rotation modes [pan or zoom]
      camera.keyBindingMode = dragmode;
    }
  }

  // to put dragmode and hovermode on the same grounds from relayout
  scene.fullSceneLayout.hovermode = hovermode;
};
function flipPixels(pixels, w, h) {
  for (var i = 0, q = h - 1; i < q; ++i, --q) {
    for (var j = 0; j < w; ++j) {
      for (var k = 0; k < 4; ++k) {
        var a = 4 * (w * i + j) + k;
        var b = 4 * (w * q + j) + k;
        var tmp = pixels[a];
        pixels[a] = pixels[b];
        pixels[b] = tmp;
      }
    }
  }
}
function correctRGB(pixels, w, h) {
  for (var i = 0; i < h; ++i) {
    for (var j = 0; j < w; ++j) {
      var k = 4 * (w * i + j);
      var a = pixels[k + 3]; // alpha
      if (a > 0) {
        var q = 255 / a;
        for (var l = 0; l < 3; ++l) {
          // RGB
          pixels[k + l] = Math.min(q * pixels[k + l], 255);
        }
      }
    }
  }
}
proto.toImage = function (format) {
  var scene = this;
  if (!format) format = 'png';
  if (scene.staticMode) scene.container.appendChild(STATIC_CANVAS);

  // Force redraw
  scene.glplot.redraw();

  // Grab context and yank out pixels
  var gl = scene.glplot.gl;
  var w = gl.drawingBufferWidth;
  var h = gl.drawingBufferHeight;
  gl.bindFramebuffer(gl.FRAMEBUFFER, null);
  var pixels = new Uint8Array(w * h * 4);
  gl.readPixels(0, 0, w, h, gl.RGBA, gl.UNSIGNED_BYTE, pixels);
  flipPixels(pixels, w, h);
  correctRGB(pixels, w, h);
  var canvas = document.createElement('canvas');
  canvas.width = w;
  canvas.height = h;
  var context = canvas.getContext('2d', {
    willReadFrequently: true
  });
  var imageData = context.createImageData(w, h);
  imageData.data.set(pixels);
  context.putImageData(imageData, 0, 0);
  var dataURL;
  switch (format) {
    case 'jpeg':
      dataURL = canvas.toDataURL('image/jpeg');
      break;
    case 'webp':
      dataURL = canvas.toDataURL('image/webp');
      break;
    default:
      dataURL = canvas.toDataURL('image/png');
  }
  if (scene.staticMode) scene.container.removeChild(STATIC_CANVAS);
  return dataURL;
};
proto.setConvert = function () {
  var scene = this;
  for (var i = 0; i < 3; i++) {
    var ax = scene.fullSceneLayout[axisProperties[i]];
    Axes.setConvert(ax, scene.fullLayout);
    ax.setScale = Lib.noop;
  }
};
proto.make4thDimension = function () {
  var scene = this;
  var gd = scene.graphDiv;
  var fullLayout = gd._fullLayout;

  // mock axis for hover formatting
  scene._mockAxis = {
    type: 'linear',
    showexponent: 'all',
    exponentformat: 'B'
  };
  Axes.setConvert(scene._mockAxis, fullLayout);
};
module.exports = Scene;

/***/ }),

/***/ 88239:
/***/ (function(module) {

"use strict";


module.exports = function zip3(x, y, z, len) {
  len = len || x.length;
  var result = new Array(len);
  for (var i = 0; i < len; i++) {
    result[i] = [x[i], y[i], z[i]];
  }
  return result;
};

/***/ }),

/***/ 6704:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var fontAttrs = __webpack_require__(80337);
var animationAttrs = __webpack_require__(49722);
var colorAttrs = __webpack_require__(10229);
var drawNewShapeAttrs = __webpack_require__(64101);
var drawNewSelectionAttrs = __webpack_require__(52307);
var padAttrs = __webpack_require__(57891);
var extendFlat = (__webpack_require__(93049).extendFlat);
var globalFont = fontAttrs({
  editType: 'calc'
});
globalFont.family.dflt = '"Open Sans", verdana, arial, sans-serif';
globalFont.size.dflt = 12;
globalFont.color.dflt = colorAttrs.defaultLine;
module.exports = {
  font: globalFont,
  title: {
    text: {
      valType: 'string',
      editType: 'layoutstyle'
    },
    font: fontAttrs({
      editType: 'layoutstyle'
    }),
    subtitle: {
      text: {
        valType: 'string',
        editType: 'layoutstyle'
      },
      font: fontAttrs({
        editType: 'layoutstyle'
      }),
      editType: 'layoutstyle'
    },
    xref: {
      valType: 'enumerated',
      dflt: 'container',
      values: ['container', 'paper'],
      editType: 'layoutstyle'
    },
    yref: {
      valType: 'enumerated',
      dflt: 'container',
      values: ['container', 'paper'],
      editType: 'layoutstyle'
    },
    x: {
      valType: 'number',
      min: 0,
      max: 1,
      dflt: 0.5,
      editType: 'layoutstyle'
    },
    y: {
      valType: 'number',
      min: 0,
      max: 1,
      dflt: 'auto',
      editType: 'layoutstyle'
    },
    xanchor: {
      valType: 'enumerated',
      dflt: 'auto',
      values: ['auto', 'left', 'center', 'right'],
      editType: 'layoutstyle'
    },
    yanchor: {
      valType: 'enumerated',
      dflt: 'auto',
      values: ['auto', 'top', 'middle', 'bottom'],
      editType: 'layoutstyle'
    },
    pad: extendFlat(padAttrs({
      editType: 'layoutstyle'
    }), {}),
    automargin: {
      valType: 'boolean',
      dflt: false,
      editType: 'plot'
    },
    editType: 'layoutstyle'
  },
  uniformtext: {
    mode: {
      valType: 'enumerated',
      values: [false, 'hide', 'show'],
      dflt: false,
      editType: 'plot'
    },
    minsize: {
      valType: 'number',
      min: 0,
      dflt: 0,
      editType: 'plot'
    },
    editType: 'plot'
  },
  autosize: {
    valType: 'boolean',
    dflt: false,
    // autosize, width, and height get special editType treatment in _relayout
    // so we can handle noop resizes more efficiently
    editType: 'none'
  },
  width: {
    valType: 'number',
    min: 10,
    dflt: 700,
    editType: 'plot'
  },
  height: {
    valType: 'number',
    min: 10,
    dflt: 450,
    editType: 'plot'
  },
  minreducedwidth: {
    valType: 'number',
    min: 2,
    dflt: 64,
    editType: 'plot'
  },
  minreducedheight: {
    valType: 'number',
    min: 2,
    dflt: 64,
    editType: 'plot'
  },
  margin: {
    l: {
      valType: 'number',
      min: 0,
      dflt: 80,
      editType: 'plot'
    },
    r: {
      valType: 'number',
      min: 0,
      dflt: 80,
      editType: 'plot'
    },
    t: {
      valType: 'number',
      min: 0,
      dflt: 100,
      editType: 'plot'
    },
    b: {
      valType: 'number',
      min: 0,
      dflt: 80,
      editType: 'plot'
    },
    pad: {
      valType: 'number',
      min: 0,
      dflt: 0,
      editType: 'plot'
    },
    autoexpand: {
      valType: 'boolean',
      dflt: true,
      editType: 'plot'
    },
    editType: 'plot'
  },
  computed: {
    valType: 'any',
    editType: 'none'
  },
  paper_bgcolor: {
    valType: 'color',
    dflt: colorAttrs.background,
    editType: 'plot'
  },
  plot_bgcolor: {
    // defined here, but set in cartesian.supplyLayoutDefaults
    // because it needs to know if there are (2D) axes or not
    valType: 'color',
    dflt: colorAttrs.background,
    editType: 'layoutstyle'
  },
  autotypenumbers: {
    valType: 'enumerated',
    values: ['convert types', 'strict'],
    dflt: 'convert types',
    editType: 'calc'
  },
  separators: {
    valType: 'string',
    editType: 'plot'
  },
  hidesources: {
    valType: 'boolean',
    dflt: false,
    editType: 'plot'
  },
  showlegend: {
    // handled in legend.supplyLayoutDefaults
    // but included here because it's not in the legend object
    valType: 'boolean',
    editType: 'legend'
  },
  colorway: {
    valType: 'colorlist',
    dflt: colorAttrs.defaults,
    editType: 'calc'
  },
  datarevision: {
    valType: 'any',
    editType: 'calc'
  },
  uirevision: {
    valType: 'any',
    editType: 'none'
  },
  editrevision: {
    valType: 'any',
    editType: 'none'
  },
  selectionrevision: {
    valType: 'any',
    editType: 'none'
  },
  template: {
    valType: 'any',
    editType: 'calc'
  },
  newshape: drawNewShapeAttrs.newshape,
  activeshape: drawNewShapeAttrs.activeshape,
  newselection: drawNewSelectionAttrs.newselection,
  activeselection: drawNewSelectionAttrs.activeselection,
  meta: {
    valType: 'any',
    arrayOk: true,
    editType: 'plot'
  },
  transition: extendFlat({}, animationAttrs.transition, {
    editType: 'none'
  }),
  _deprecated: {
    title: {
      valType: 'string',
      editType: 'layoutstyle'
    },
    titlefont: fontAttrs({
      editType: 'layoutstyle'
    })
  }
};

/***/ }),

/***/ 8814:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var sortObjectKeys = __webpack_require__(62994);
var arcgisSatHybrid = __webpack_require__(37071); // https://raw.githubusercontent.com/go2garret/maps/v1.0.0/LICENSE
var arcgisSat = __webpack_require__(51962);
var OSM = '© <a target="_blank" href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';
var cartoPositron = 'https://basemaps.cartocdn.com/gl/positron-gl-style/style.json';
var cartoDarkmatter = 'https://basemaps.cartocdn.com/gl/dark-matter-gl-style/style.json';
var cartoVoyager = 'https://basemaps.cartocdn.com/gl/voyager-gl-style/style.json';
var cartoPositronNoLabels = 'https://basemaps.cartocdn.com/gl/positron-nolabels-gl-style/style.json';
var cartoDarkmatterNoLabels = 'https://basemaps.cartocdn.com/gl/dark-matter-nolabels-gl-style/style.json';
var cartoVoyagerNoLabels = 'https://basemaps.cartocdn.com/gl/voyager-nolabels-gl-style/style.json';
var stylesMap = {
  basic: cartoVoyager,
  streets: cartoVoyager,
  outdoors: cartoVoyager,
  light: cartoPositron,
  dark: cartoDarkmatter,
  satellite: arcgisSat,
  'satellite-streets': arcgisSatHybrid,
  'open-street-map': {
    id: 'osm',
    version: 8,
    sources: {
      'plotly-osm-tiles': {
        type: 'raster',
        attribution: OSM,
        tiles: ['https://tile.openstreetmap.org/{z}/{x}/{y}.png'],
        tileSize: 256
      }
    },
    layers: [{
      id: 'plotly-osm-tiles',
      type: 'raster',
      source: 'plotly-osm-tiles',
      minzoom: 0,
      maxzoom: 22
    }],
    glyphs: 'https://fonts.openmaptiles.org/{fontstack}/{range}.pbf'
  },
  'white-bg': {
    id: 'white-bg',
    version: 8,
    sources: {},
    layers: [{
      id: 'white-bg',
      type: 'background',
      paint: {
        'background-color': '#FFFFFF'
      },
      minzoom: 0,
      maxzoom: 22
    }],
    glyphs: 'https://fonts.openmaptiles.org/{fontstack}/{range}.pbf'
  },
  'carto-positron': cartoPositron,
  'carto-darkmatter': cartoDarkmatter,
  'carto-voyager': cartoVoyager,
  'carto-positron-nolabels': cartoPositronNoLabels,
  'carto-darkmatter-nolabels': cartoDarkmatterNoLabels,
  'carto-voyager-nolabels': cartoVoyagerNoLabels
};
var styleValuesMap = sortObjectKeys(stylesMap);
module.exports = {
  styleValueDflt: 'basic',
  stylesMap: stylesMap,
  styleValuesMap: styleValuesMap,
  traceLayerPrefix: 'plotly-trace-layer-',
  layoutLayerPrefix: 'plotly-layout-layer-',
  missingStyleErrorMsg: ['No valid maplibre style found, please set `map.style` to one of:', styleValuesMap.join(', '), 'or use a tile service.'].join('\n'),
  mapOnErrorMsg: 'Map error.'
};

/***/ }),

/***/ 4657:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);

/**
 * Convert plotly.js 'textposition' to map-gl 'anchor' and 'offset'
 * (with the help of the icon size).
 *
 * @param {string} textpostion : plotly.js textposition value
 * @param {number} iconSize : plotly.js icon size (e.g. marker.size for traces)
 *
 * @return {object}
 *      - anchor
 *      - offset
 */
module.exports = function convertTextOpts(textposition, iconSize) {
  var parts = textposition.split(' ');
  var vPos = parts[0];
  var hPos = parts[1];

  // ballpack values
  var factor = Lib.isArrayOrTypedArray(iconSize) ? Lib.mean(iconSize) : iconSize;
  var xInc = 0.5 + factor / 100;
  var yInc = 1.5 + factor / 100;
  var anchorVals = ['', ''];
  var offset = [0, 0];
  switch (vPos) {
    case 'top':
      anchorVals[0] = 'top';
      offset[1] = -yInc;
      break;
    case 'bottom':
      anchorVals[0] = 'bottom';
      offset[1] = yInc;
      break;
  }
  switch (hPos) {
    case 'left':
      anchorVals[1] = 'right';
      offset[0] = -xInc;
      break;
    case 'right':
      anchorVals[1] = 'left';
      offset[0] = xInc;
      break;
  }

  // Map text-anchor must be one of:
  //  center, left, right, top, bottom,
  //  top-left, top-right, bottom-left, bottom-right

  var anchor;
  if (anchorVals[0] && anchorVals[1]) anchor = anchorVals.join('-');else if (anchorVals[0]) anchor = anchorVals[0];else if (anchorVals[1]) anchor = anchorVals[1];else anchor = 'center';
  return {
    anchor: anchor,
    offset: offset
  };
};

/***/ }),

/***/ 34091:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var strTranslate = Lib.strTranslate;
var strScale = Lib.strScale;
var getSubplotCalcData = (__webpack_require__(4173)/* .getSubplotCalcData */ .fX);
var xmlnsNamespaces = __webpack_require__(62972);
var d3 = __webpack_require__(45568);
var Drawing = __webpack_require__(62203);
var svgTextUtils = __webpack_require__(30635);
var Map = __webpack_require__(38793);
var MAP = 'map';
exports.name = MAP;
exports.attr = 'subplot';
exports.idRoot = MAP;
exports.idRegex = exports.attrRegex = Lib.counterRegex(MAP);
exports.attributes = {
  subplot: {
    valType: 'subplotid',
    dflt: 'map',
    editType: 'calc'
  }
};
exports.layoutAttributes = __webpack_require__(8257);
exports.supplyLayoutDefaults = __webpack_require__(97446);
exports.plot = function plot(gd) {
  var fullLayout = gd._fullLayout;
  var calcData = gd.calcdata;
  var mapIds = fullLayout._subplots[MAP];
  for (var i = 0; i < mapIds.length; i++) {
    var id = mapIds[i];
    var subplotCalcData = getSubplotCalcData(calcData, MAP, id);
    var opts = fullLayout[id];
    var map = opts._subplot;
    if (!map) {
      map = new Map(gd, id);
      fullLayout[id]._subplot = map;
    }
    if (!map.viewInitial) {
      map.viewInitial = {
        center: Lib.extendFlat({}, opts.center),
        zoom: opts.zoom,
        bearing: opts.bearing,
        pitch: opts.pitch
      };
    }
    map.plot(subplotCalcData, fullLayout, gd._promises);
  }
};
exports.clean = function (newFullData, newFullLayout, oldFullData, oldFullLayout) {
  var oldMapKeys = oldFullLayout._subplots[MAP] || [];
  for (var i = 0; i < oldMapKeys.length; i++) {
    var oldMapKey = oldMapKeys[i];
    if (!newFullLayout[oldMapKey] && !!oldFullLayout[oldMapKey]._subplot) {
      oldFullLayout[oldMapKey]._subplot.destroy();
    }
  }
};
exports.toSVG = function (gd) {
  var fullLayout = gd._fullLayout;
  var subplotIds = fullLayout._subplots[MAP];
  var size = fullLayout._size;
  for (var i = 0; i < subplotIds.length; i++) {
    var opts = fullLayout[subplotIds[i]];
    var domain = opts.domain;
    var map = opts._subplot;
    var imageData = map.toImage('png');
    var image = fullLayout._glimages.append('svg:image');
    image.attr({
      xmlns: xmlnsNamespaces.svg,
      'xlink:href': imageData,
      x: size.l + size.w * domain.x[0],
      y: size.t + size.h * (1 - domain.y[1]),
      width: size.w * (domain.x[1] - domain.x[0]),
      height: size.h * (domain.y[1] - domain.y[0]),
      preserveAspectRatio: 'none'
    });
    var subplotDiv = d3.select(opts._subplot.div);

    // Add attributions
    var attributions = subplotDiv.select('.maplibregl-ctrl-attrib').text().replace('Improve this map', '');
    var attributionGroup = fullLayout._glimages.append('g');
    var attributionText = attributionGroup.append('text');
    attributionText.text(attributions).classed('static-attribution', true).attr({
      'font-size': 12,
      'font-family': 'Arial',
      color: 'rgba(0, 0, 0, 0.75)',
      'text-anchor': 'end',
      'data-unformatted': attributions
    });
    var bBox = Drawing.bBox(attributionText.node());

    // Break into multiple lines twice larger than domain
    var maxWidth = size.w * (domain.x[1] - domain.x[0]);
    if (bBox.width > maxWidth / 2) {
      var multilineAttributions = attributions.split('|').join('<br>');
      attributionText.text(multilineAttributions).attr('data-unformatted', multilineAttributions).call(svgTextUtils.convertToTspans, gd);
      bBox = Drawing.bBox(attributionText.node());
    }
    attributionText.attr('transform', strTranslate(-3, -bBox.height + 8));

    // Draw white rectangle behind text
    attributionGroup.insert('rect', '.static-attribution').attr({
      x: -bBox.width - 6,
      y: -bBox.height - 3,
      width: bBox.width + 6,
      height: bBox.height + 3,
      fill: 'rgba(255, 255, 255, 0.75)'
    });

    // Scale down if larger than domain
    var scaleRatio = 1;
    if (bBox.width + 6 > maxWidth) scaleRatio = maxWidth / (bBox.width + 6);
    var offset = [size.l + size.w * domain.x[1], size.t + size.h * (1 - domain.y[0])];
    attributionGroup.attr('transform', strTranslate(offset[0], offset[1]) + strScale(scaleRatio));
  }
};
exports.updateFx = function (gd) {
  var fullLayout = gd._fullLayout;
  var subplotIds = fullLayout._subplots[MAP];
  for (var i = 0; i < subplotIds.length; i++) {
    var subplotObj = fullLayout[subplotIds[i]]._subplot;
    subplotObj.updateFx(fullLayout);
  }
};

/***/ }),

/***/ 33389:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var sanitizeHTML = (__webpack_require__(30635).sanitizeHTML);
var convertTextOpts = __webpack_require__(4657);
var constants = __webpack_require__(8814);
function MapLayer(subplot, index) {
  this.subplot = subplot;
  this.uid = subplot.uid + '-' + index;
  this.index = index;
  this.idSource = 'source-' + this.uid;
  this.idLayer = constants.layoutLayerPrefix + this.uid;

  // some state variable to check if a remove/add step is needed
  this.sourceType = null;
  this.source = null;
  this.layerType = null;
  this.below = null;

  // is layer currently visible
  this.visible = false;
}
var proto = MapLayer.prototype;
proto.update = function update(opts) {
  if (!this.visible) {
    // IMPORTANT: must create source before layer to not cause errors
    this.updateSource(opts);
    this.updateLayer(opts);
  } else if (this.needsNewImage(opts)) {
    this.updateImage(opts);
  } else if (this.needsNewSource(opts)) {
    // IMPORTANT: must delete layer before source to not cause errors
    this.removeLayer();
    this.updateSource(opts);
    this.updateLayer(opts);
  } else if (this.needsNewLayer(opts)) {
    this.updateLayer(opts);
  } else {
    this.updateStyle(opts);
  }
  this.visible = isVisible(opts);
};
proto.needsNewImage = function (opts) {
  var map = this.subplot.map;
  return map.getSource(this.idSource) && this.sourceType === 'image' && opts.sourcetype === 'image' && (this.source !== opts.source || JSON.stringify(this.coordinates) !== JSON.stringify(opts.coordinates));
};
proto.needsNewSource = function (opts) {
  // for some reason changing layer to 'fill' or 'symbol'
  // w/o changing the source throws an exception in map-gl 0.18 ;
  // stay safe and make new source on type changes
  return this.sourceType !== opts.sourcetype || JSON.stringify(this.source) !== JSON.stringify(opts.source) || this.layerType !== opts.type;
};
proto.needsNewLayer = function (opts) {
  return this.layerType !== opts.type || this.below !== this.subplot.belowLookup['layout-' + this.index];
};
proto.lookupBelow = function () {
  return this.subplot.belowLookup['layout-' + this.index];
};
proto.updateImage = function (opts) {
  var map = this.subplot.map;
  map.getSource(this.idSource).updateImage({
    url: opts.source,
    coordinates: opts.coordinates
  });

  // Since the `updateImage` control flow doesn't call updateLayer,
  // We need to take care of moving the image layer to match the location
  // where updateLayer would have placed it.
  var _below = this.findFollowingMapLayerId(this.lookupBelow());
  if (_below !== null) {
    this.subplot.map.moveLayer(this.idLayer, _below);
  }
};
proto.updateSource = function (opts) {
  var map = this.subplot.map;
  if (map.getSource(this.idSource)) map.removeSource(this.idSource);
  this.sourceType = opts.sourcetype;
  this.source = opts.source;
  if (!isVisible(opts)) return;
  var sourceOpts = convertSourceOpts(opts);
  map.addSource(this.idSource, sourceOpts);
};
proto.findFollowingMapLayerId = function (below) {
  if (below === 'traces') {
    var mapLayers = this.subplot.getMapLayers();

    // find id of first plotly trace layer
    for (var i = 0; i < mapLayers.length; i++) {
      var layerId = mapLayers[i].id;
      if (typeof layerId === 'string' && layerId.indexOf(constants.traceLayerPrefix) === 0) {
        below = layerId;
        break;
      }
    }
  }
  return below;
};
proto.updateLayer = function (opts) {
  var subplot = this.subplot;
  var convertedOpts = convertOpts(opts);
  var below = this.lookupBelow();
  var _below = this.findFollowingMapLayerId(below);
  this.removeLayer();
  if (isVisible(opts)) {
    subplot.addLayer({
      id: this.idLayer,
      source: this.idSource,
      'source-layer': opts.sourcelayer || '',
      type: opts.type,
      minzoom: opts.minzoom,
      maxzoom: opts.maxzoom,
      layout: convertedOpts.layout,
      paint: convertedOpts.paint
    }, _below);
  }
  this.layerType = opts.type;
  this.below = below;
};
proto.updateStyle = function (opts) {
  if (isVisible(opts)) {
    var convertedOpts = convertOpts(opts);
    this.subplot.setOptions(this.idLayer, 'setLayoutProperty', convertedOpts.layout);
    this.subplot.setOptions(this.idLayer, 'setPaintProperty', convertedOpts.paint);
  }
};
proto.removeLayer = function () {
  var map = this.subplot.map;
  if (map.getLayer(this.idLayer)) {
    map.removeLayer(this.idLayer);
  }
};
proto.dispose = function () {
  var map = this.subplot.map;
  if (map.getLayer(this.idLayer)) map.removeLayer(this.idLayer);
  if (map.getSource(this.idSource)) map.removeSource(this.idSource);
};
function isVisible(opts) {
  if (!opts.visible) return false;
  var source = opts.source;
  if (Array.isArray(source) && source.length > 0) {
    for (var i = 0; i < source.length; i++) {
      if (typeof source[i] !== 'string' || source[i].length === 0) {
        return false;
      }
    }
    return true;
  }
  return Lib.isPlainObject(source) || typeof source === 'string' && source.length > 0;
}
function convertOpts(opts) {
  var layout = {};
  var paint = {};
  switch (opts.type) {
    case 'circle':
      Lib.extendFlat(paint, {
        'circle-radius': opts.circle.radius,
        'circle-color': opts.color,
        'circle-opacity': opts.opacity
      });
      break;
    case 'line':
      Lib.extendFlat(paint, {
        'line-width': opts.line.width,
        'line-color': opts.color,
        'line-opacity': opts.opacity,
        'line-dasharray': opts.line.dash
      });
      break;
    case 'fill':
      Lib.extendFlat(paint, {
        'fill-color': opts.color,
        'fill-outline-color': opts.fill.outlinecolor,
        'fill-opacity': opts.opacity

        // no way to pass specify outline width at the moment
      });
      break;
    case 'symbol':
      var symbol = opts.symbol;
      var textOpts = convertTextOpts(symbol.textposition, symbol.iconsize);
      Lib.extendFlat(layout, {
        'icon-image': symbol.icon + '-15',
        'icon-size': symbol.iconsize / 10,
        'text-field': symbol.text,
        'text-size': symbol.textfont.size,
        'text-anchor': textOpts.anchor,
        'text-offset': textOpts.offset,
        'symbol-placement': symbol.placement

        // TODO font family
        // 'text-font': symbol.textfont.family.split(', '),
      });
      Lib.extendFlat(paint, {
        'icon-color': opts.color,
        'text-color': symbol.textfont.color,
        'text-opacity': opts.opacity
      });
      break;
    case 'raster':
      Lib.extendFlat(paint, {
        'raster-fade-duration': 0,
        'raster-opacity': opts.opacity
      });
      break;
  }
  return {
    layout: layout,
    paint: paint
  };
}
function convertSourceOpts(opts) {
  var sourceType = opts.sourcetype;
  var source = opts.source;
  var sourceOpts = {
    type: sourceType
  };
  var field;
  if (sourceType === 'geojson') {
    field = 'data';
  } else if (sourceType === 'vector') {
    field = typeof source === 'string' ? 'url' : 'tiles';
  } else if (sourceType === 'raster') {
    field = 'tiles';
    sourceOpts.tileSize = 256;
  } else if (sourceType === 'image') {
    field = 'url';
    sourceOpts.coordinates = opts.coordinates;
  }
  sourceOpts[field] = source;
  if (opts.sourceattribution) {
    sourceOpts.attribution = sanitizeHTML(opts.sourceattribution);
  }
  return sourceOpts;
}
module.exports = function createMapLayer(subplot, index, opts) {
  var mapLayer = new MapLayer(subplot, index);
  mapLayer.update(opts);
  return mapLayer;
};

/***/ }),

/***/ 8257:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var defaultLine = (__webpack_require__(78766).defaultLine);
var domainAttrs = (__webpack_require__(13792)/* .attributes */ .u);
var fontAttrs = __webpack_require__(80337);
var textposition = (__webpack_require__(36640).textposition);
var overrideAll = (__webpack_require__(13582).overrideAll);
var templatedArray = (__webpack_require__(78032).templatedArray);
var constants = __webpack_require__(8814);
var fontAttr = fontAttrs({
  noFontVariant: true,
  noFontShadow: true,
  noFontLineposition: true,
  noFontTextcase: true
});
fontAttr.family.dflt = 'Open Sans Regular, Arial Unicode MS Regular';
var attrs = module.exports = overrideAll({
  _arrayAttrRegexps: [Lib.counterRegex('map', '.layers', true)],
  domain: domainAttrs({
    name: 'map'
  }),
  style: {
    valType: 'any',
    values: constants.styleValuesMap,
    dflt: constants.styleValueDflt
  },
  center: {
    lon: {
      valType: 'number',
      dflt: 0
    },
    lat: {
      valType: 'number',
      dflt: 0
    }
  },
  zoom: {
    valType: 'number',
    dflt: 1
  },
  bearing: {
    valType: 'number',
    dflt: 0
  },
  pitch: {
    valType: 'number',
    dflt: 0
  },
  bounds: {
    west: {
      valType: 'number'
    },
    east: {
      valType: 'number'
    },
    south: {
      valType: 'number'
    },
    north: {
      valType: 'number'
    }
  },
  layers: templatedArray('layer', {
    visible: {
      valType: 'boolean',
      dflt: true
    },
    sourcetype: {
      valType: 'enumerated',
      values: ['geojson', 'vector', 'raster', 'image'],
      dflt: 'geojson'
    },
    source: {
      valType: 'any'
    },
    sourcelayer: {
      valType: 'string',
      dflt: ''
    },
    sourceattribution: {
      valType: 'string'
    },
    type: {
      valType: 'enumerated',
      values: ['circle', 'line', 'fill', 'symbol', 'raster'],
      dflt: 'circle'
    },
    coordinates: {
      valType: 'any'
    },
    // attributes shared between all types
    below: {
      valType: 'string'
    },
    color: {
      valType: 'color',
      dflt: defaultLine
    },
    opacity: {
      valType: 'number',
      min: 0,
      max: 1,
      dflt: 1
    },
    minzoom: {
      valType: 'number',
      min: 0,
      max: 24,
      dflt: 0
    },
    maxzoom: {
      valType: 'number',
      min: 0,
      max: 24,
      dflt: 24
    },
    // type-specific style attributes
    circle: {
      radius: {
        valType: 'number',
        dflt: 15
      }
    },
    line: {
      width: {
        valType: 'number',
        dflt: 2
      },
      dash: {
        valType: 'data_array'
      }
    },
    fill: {
      outlinecolor: {
        valType: 'color',
        dflt: defaultLine
      }
    },
    symbol: {
      icon: {
        valType: 'string',
        dflt: 'marker'
      },
      iconsize: {
        valType: 'number',
        dflt: 10
      },
      text: {
        valType: 'string',
        dflt: ''
      },
      placement: {
        valType: 'enumerated',
        values: ['point', 'line', 'line-center'],
        dflt: 'point'
      },
      textfont: fontAttr,
      textposition: Lib.extendFlat({}, textposition, {
        arrayOk: false
      })
    }
  })
}, 'plot', 'from-root');

// set uirevision outside of overrideAll so it can be `editType: 'none'`
attrs.uirevision = {
  valType: 'any',
  editType: 'none'
};

/***/ }),

/***/ 97446:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var handleSubplotDefaults = __webpack_require__(4448);
var handleArrayContainerDefaults = __webpack_require__(59008);
var layoutAttributes = __webpack_require__(8257);
module.exports = function supplyLayoutDefaults(layoutIn, layoutOut, fullData) {
  handleSubplotDefaults(layoutIn, layoutOut, fullData, {
    type: 'map',
    attributes: layoutAttributes,
    handleDefaults: handleDefaults,
    partition: 'y'
  });
};
function handleDefaults(containerIn, containerOut, coerce) {
  coerce('style');
  coerce('center.lon');
  coerce('center.lat');
  coerce('zoom');
  coerce('bearing');
  coerce('pitch');
  var west = coerce('bounds.west');
  var east = coerce('bounds.east');
  var south = coerce('bounds.south');
  var north = coerce('bounds.north');
  if (west === undefined || east === undefined || south === undefined || north === undefined) {
    delete containerOut.bounds;
  }
  handleArrayContainerDefaults(containerIn, containerOut, {
    name: 'layers',
    handleItemDefaults: handleLayerDefaults
  });

  // copy ref to input container to update 'center' and 'zoom' on map move
  containerOut._input = containerIn;
}
function handleLayerDefaults(layerIn, layerOut) {
  function coerce(attr, dflt) {
    return Lib.coerce(layerIn, layerOut, layoutAttributes.layers, attr, dflt);
  }
  var visible = coerce('visible');
  if (visible) {
    var sourceType = coerce('sourcetype');
    var mustBeRasterLayer = sourceType === 'raster' || sourceType === 'image';
    coerce('source');
    coerce('sourceattribution');
    if (sourceType === 'vector') {
      coerce('sourcelayer');
    }
    if (sourceType === 'image') {
      coerce('coordinates');
    }
    var typeDflt;
    if (mustBeRasterLayer) typeDflt = 'raster';
    var type = coerce('type', typeDflt);
    if (mustBeRasterLayer && type !== 'raster') {
      type = layerOut.type = 'raster';
      Lib.log('Source types *raster* and *image* must drawn *raster* layer type.');
    }
    coerce('below');
    coerce('color');
    coerce('opacity');
    coerce('minzoom');
    coerce('maxzoom');
    if (type === 'circle') {
      coerce('circle.radius');
    }
    if (type === 'line') {
      coerce('line.width');
      coerce('line.dash');
    }
    if (type === 'fill') {
      coerce('fill.outlinecolor');
    }
    if (type === 'symbol') {
      coerce('symbol.icon');
      coerce('symbol.iconsize');
      coerce('symbol.text');
      Lib.coerceFont(coerce, 'symbol.textfont', undefined, {
        noFontVariant: true,
        noFontShadow: true,
        noFontLineposition: true,
        noFontTextcase: true
      });
      coerce('symbol.textposition');
      coerce('symbol.placement');
    }
  }
}

/***/ }),

/***/ 38793:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var maplibregl = __webpack_require__(89380);
var Lib = __webpack_require__(34809);
var geoUtils = __webpack_require__(3994);
var Registry = __webpack_require__(33626);
var Axes = __webpack_require__(29714);
var dragElement = __webpack_require__(14751);
var Fx = __webpack_require__(32141);
var dragHelpers = __webpack_require__(70414);
var drawMode = dragHelpers.drawMode;
var selectMode = dragHelpers.selectMode;
var prepSelect = (__webpack_require__(44844).prepSelect);
var clearOutline = (__webpack_require__(44844).clearOutline);
var clearSelectionsCache = (__webpack_require__(44844).clearSelectionsCache);
var selectOnClick = (__webpack_require__(44844).selectOnClick);
var constants = __webpack_require__(8814);
var createMapLayer = __webpack_require__(33389);
function Map(gd, id) {
  this.id = id;
  this.gd = gd;
  var fullLayout = gd._fullLayout;
  var context = gd._context;
  this.container = fullLayout._glcontainer.node();
  this.isStatic = context.staticPlot;

  // unique id for this Map instance
  this.uid = fullLayout._uid + '-' + this.id;

  // create framework on instantiation for a smoother first plot call
  this.div = null;
  this.xaxis = null;
  this.yaxis = null;
  this.createFramework(fullLayout);

  // state variables used to infer how and what to update
  this.map = null;
  this.styleObj = null;
  this.traceHash = {};
  this.layerList = [];
  this.belowLookup = {};
  this.dragging = false;
  this.wheeling = false;
}
var proto = Map.prototype;
proto.plot = function (calcData, fullLayout, promises) {
  var self = this;
  var promise;
  if (!self.map) {
    promise = new Promise(function (resolve, reject) {
      self.createMap(calcData, fullLayout, resolve, reject);
    });
  } else {
    promise = new Promise(function (resolve, reject) {
      self.updateMap(calcData, fullLayout, resolve, reject);
    });
  }
  promises.push(promise);
};
proto.createMap = function (calcData, fullLayout, resolve, reject) {
  var self = this;
  var opts = fullLayout[self.id];

  // store style id and URL or object
  var styleObj = self.styleObj = getStyleObj(opts.style);
  var bounds = opts.bounds;
  var maxBounds = bounds ? [[bounds.west, bounds.south], [bounds.east, bounds.north]] : null;

  // create the map!
  var map = self.map = new maplibregl.Map({
    container: self.div,
    style: styleObj.style,
    center: convertCenter(opts.center),
    zoom: opts.zoom,
    bearing: opts.bearing,
    pitch: opts.pitch,
    maxBounds: maxBounds,
    interactive: !self.isStatic,
    preserveDrawingBuffer: self.isStatic,
    doubleClickZoom: false,
    boxZoom: false,
    attributionControl: false
  }).addControl(new maplibregl.AttributionControl({
    compact: true
  }));
  var requestedIcons = {};
  map.on('styleimagemissing', function (e) {
    var id = e.id;
    if (!requestedIcons[id] && id.includes('-15')) {
      requestedIcons[id] = true;
      var img = new Image(15, 15);
      img.onload = function () {
        map.addImage(id, img);
      };
      img.crossOrigin = 'Anonymous';
      img.src = 'https://unpkg.com/maki@2.1.0/icons/' + id + '.svg';
    }
  });
  map.setTransformRequest(function (url) {
    url = url.replace('https://fonts.openmaptiles.org/Open Sans Extrabold', 'https://fonts.openmaptiles.org/Open Sans Extra Bold');
    url = url.replace('https://tiles.basemaps.cartocdn.com/fonts/Open Sans Extrabold', 'https://fonts.openmaptiles.org/Open Sans Extra Bold');
    url = url.replace('https://fonts.openmaptiles.org/Open Sans Regular,Arial Unicode MS Regular', 'https://fonts.openmaptiles.org/Klokantech Noto Sans Regular');
    return {
      url: url
    };
  });

  // make sure canvas does not inherit left and top css
  map._canvas.style.left = '0px';
  map._canvas.style.top = '0px';
  self.rejectOnError(reject);
  if (!self.isStatic) {
    self.initFx(calcData, fullLayout);
  }
  var promises = [];
  promises.push(new Promise(function (resolve) {
    map.once('load', resolve);
  }));
  promises = promises.concat(geoUtils.fetchTraceGeoData(calcData));
  Promise.all(promises).then(function () {
    self.fillBelowLookup(calcData, fullLayout);
    self.updateData(calcData);
    self.updateLayout(fullLayout);
    self.resolveOnRender(resolve);
  }).catch(reject);
};
proto.updateMap = function (calcData, fullLayout, resolve, reject) {
  var self = this;
  var map = self.map;
  var opts = fullLayout[this.id];
  self.rejectOnError(reject);
  var promises = [];
  var styleObj = getStyleObj(opts.style);
  if (JSON.stringify(self.styleObj) !== JSON.stringify(styleObj)) {
    self.styleObj = styleObj;
    map.setStyle(styleObj.style);

    // need to rebuild trace layers on reload
    // to avoid 'lost event' errors
    self.traceHash = {};
    promises.push(new Promise(function (resolve) {
      map.once('styledata', resolve);
    }));
  }
  promises = promises.concat(geoUtils.fetchTraceGeoData(calcData));
  Promise.all(promises).then(function () {
    self.fillBelowLookup(calcData, fullLayout);
    self.updateData(calcData);
    self.updateLayout(fullLayout);
    self.resolveOnRender(resolve);
  }).catch(reject);
};
proto.fillBelowLookup = function (calcData, fullLayout) {
  var opts = fullLayout[this.id];
  var layers = opts.layers;
  var i, val;
  var belowLookup = this.belowLookup = {};
  var hasTraceAtTop = false;
  for (i = 0; i < calcData.length; i++) {
    var trace = calcData[i][0].trace;
    var _module = trace._module;
    if (typeof trace.below === 'string') {
      val = trace.below;
    } else if (_module.getBelow) {
      // 'smart' default that depend the map's base layers
      val = _module.getBelow(trace, this);
    }
    if (val === '') {
      hasTraceAtTop = true;
    }
    belowLookup['trace-' + trace.uid] = val || '';
  }
  for (i = 0; i < layers.length; i++) {
    var item = layers[i];
    if (typeof item.below === 'string') {
      val = item.below;
    } else if (hasTraceAtTop) {
      // if one or more trace(s) set `below:''` and
      // layers[i].below is unset,
      // place layer below traces
      val = 'traces';
    } else {
      val = '';
    }
    belowLookup['layout-' + i] = val;
  }

  // N.B. If multiple layers have the 'below' value,
  // we must clear the stashed 'below' field in order
  // to make `traceHash[k].update()` and `layerList[i].update()`
  // remove/add the all those layers to have preserve
  // the correct layer ordering
  var val2list = {};
  var k, id;
  for (k in belowLookup) {
    val = belowLookup[k];
    if (val2list[val]) {
      val2list[val].push(k);
    } else {
      val2list[val] = [k];
    }
  }
  for (val in val2list) {
    var list = val2list[val];
    if (list.length > 1) {
      for (i = 0; i < list.length; i++) {
        k = list[i];
        if (k.indexOf('trace-') === 0) {
          id = k.split('trace-')[1];
          if (this.traceHash[id]) {
            this.traceHash[id].below = null;
          }
        } else if (k.indexOf('layout-') === 0) {
          id = k.split('layout-')[1];
          if (this.layerList[id]) {
            this.layerList[id].below = null;
          }
        }
      }
    }
  }
};
var traceType2orderIndex = {
  choroplethmap: 0,
  densitymap: 1,
  scattermap: 2
};
proto.updateData = function (calcData) {
  var traceHash = this.traceHash;
  var traceObj, trace, i, j;

  // Need to sort here by trace type here,
  // in case traces with different `type` have the same
  // below value, but sorting we ensure that
  // e.g. choroplethmap traces will be below scattermap traces
  var calcDataSorted = calcData.slice().sort(function (a, b) {
    return traceType2orderIndex[a[0].trace.type] - traceType2orderIndex[b[0].trace.type];
  });

  // update or create trace objects
  for (i = 0; i < calcDataSorted.length; i++) {
    var calcTrace = calcDataSorted[i];
    trace = calcTrace[0].trace;
    traceObj = traceHash[trace.uid];
    var didUpdate = false;
    if (traceObj) {
      if (traceObj.type === trace.type) {
        traceObj.update(calcTrace);
        didUpdate = true;
      } else {
        traceObj.dispose();
      }
    }
    if (!didUpdate && trace._module) {
      traceHash[trace.uid] = trace._module.plot(this, calcTrace);
    }
  }

  // remove empty trace objects
  var ids = Object.keys(traceHash);
  idLoop: for (i = 0; i < ids.length; i++) {
    var id = ids[i];
    for (j = 0; j < calcData.length; j++) {
      trace = calcData[j][0].trace;
      if (id === trace.uid) continue idLoop;
    }
    traceObj = traceHash[id];
    traceObj.dispose();
    delete traceHash[id];
  }
};
proto.updateLayout = function (fullLayout) {
  var map = this.map;
  var opts = fullLayout[this.id];
  if (!this.dragging && !this.wheeling) {
    map.setCenter(convertCenter(opts.center));
    map.setZoom(opts.zoom);
    map.setBearing(opts.bearing);
    map.setPitch(opts.pitch);
  }
  this.updateLayers(fullLayout);
  this.updateFramework(fullLayout);
  this.updateFx(fullLayout);
  this.map.resize();
  if (this.gd._context._scrollZoom.map) {
    map.scrollZoom.enable();
  } else {
    map.scrollZoom.disable();
  }
};
proto.resolveOnRender = function (resolve) {
  var map = this.map;
  map.on('render', function onRender() {
    if (map.loaded()) {
      map.off('render', onRender);
      // resolve at end of render loop
      //
      // Need a 10ms delay (0ms should suffice to skip a thread in the
      // render loop) to workaround map-gl bug introduced in v1.3.0
      setTimeout(resolve, 10);
    }
  });
};
proto.rejectOnError = function (reject) {
  var map = this.map;
  function handler() {
    reject(new Error(constants.mapOnErrorMsg));
  }
  map.once('error', handler);
  map.once('style.error', handler);
  map.once('source.error', handler);
  map.once('tile.error', handler);
  map.once('layer.error', handler);
};
proto.createFramework = function (fullLayout) {
  var self = this;
  var div = self.div = document.createElement('div');
  div.id = self.uid;
  div.style.position = 'absolute';
  self.container.appendChild(div);

  // create mock x/y axes for hover routine
  self.xaxis = {
    _id: 'x',
    c2p: function (v) {
      return self.project(v).x;
    }
  };
  self.yaxis = {
    _id: 'y',
    c2p: function (v) {
      return self.project(v).y;
    }
  };
  self.updateFramework(fullLayout);

  // mock axis for hover formatting
  self.mockAxis = {
    type: 'linear',
    showexponent: 'all',
    exponentformat: 'B'
  };
  Axes.setConvert(self.mockAxis, fullLayout);
};
proto.initFx = function (calcData, fullLayout) {
  var self = this;
  var gd = self.gd;
  var map = self.map;

  // keep track of pan / zoom in user layout and emit relayout event
  map.on('moveend', function (evt) {
    if (!self.map) return;
    var fullLayoutNow = gd._fullLayout;

    // 'moveend' gets triggered by map.setCenter, map.setZoom,
    // map.setBearing and map.setPitch.
    //
    // Here, we make sure that state updates amd 'plotly_relayout'
    // are triggered only when the 'moveend' originates from a
    // mouse target (filtering out API calls) to not
    // duplicate 'plotly_relayout' events.

    if (evt.originalEvent || self.wheeling) {
      var optsNow = fullLayoutNow[self.id];
      Registry.call('_storeDirectGUIEdit', gd.layout, fullLayoutNow._preGUI, self.getViewEdits(optsNow));
      var viewNow = self.getView();
      optsNow._input.center = optsNow.center = viewNow.center;
      optsNow._input.zoom = optsNow.zoom = viewNow.zoom;
      optsNow._input.bearing = optsNow.bearing = viewNow.bearing;
      optsNow._input.pitch = optsNow.pitch = viewNow.pitch;
      gd.emit('plotly_relayout', self.getViewEditsWithDerived(viewNow));
    }
    if (evt.originalEvent && evt.originalEvent.type === 'mouseup') {
      self.dragging = false;
    } else if (self.wheeling) {
      self.wheeling = false;
    }
    if (fullLayoutNow && fullLayoutNow._rehover) {
      fullLayoutNow._rehover();
    }
  });
  map.on('wheel', function () {
    self.wheeling = true;
  });
  map.on('mousemove', function (evt) {
    var bb = self.div.getBoundingClientRect();
    var xy = [evt.originalEvent.offsetX, evt.originalEvent.offsetY];
    evt.target.getBoundingClientRect = function () {
      return bb;
    };
    self.xaxis.p2c = function () {
      return map.unproject(xy).lng;
    };
    self.yaxis.p2c = function () {
      return map.unproject(xy).lat;
    };
    gd._fullLayout._rehover = function () {
      if (gd._fullLayout._hoversubplot === self.id && gd._fullLayout[self.id]) {
        Fx.hover(gd, evt, self.id);
      }
    };
    Fx.hover(gd, evt, self.id);
    gd._fullLayout._hoversubplot = self.id;
  });
  function unhover() {
    Fx.loneUnhover(fullLayout._hoverlayer);
  }
  map.on('dragstart', function () {
    self.dragging = true;
    unhover();
  });
  map.on('zoomstart', unhover);
  map.on('mouseout', function () {
    gd._fullLayout._hoversubplot = null;
  });
  function emitUpdate() {
    var viewNow = self.getView();
    gd.emit('plotly_relayouting', self.getViewEditsWithDerived(viewNow));
  }
  map.on('drag', emitUpdate);
  map.on('zoom', emitUpdate);
  map.on('dblclick', function () {
    var optsNow = gd._fullLayout[self.id];
    Registry.call('_storeDirectGUIEdit', gd.layout, gd._fullLayout._preGUI, self.getViewEdits(optsNow));
    var viewInitial = self.viewInitial;
    map.setCenter(convertCenter(viewInitial.center));
    map.setZoom(viewInitial.zoom);
    map.setBearing(viewInitial.bearing);
    map.setPitch(viewInitial.pitch);
    var viewNow = self.getView();
    optsNow._input.center = optsNow.center = viewNow.center;
    optsNow._input.zoom = optsNow.zoom = viewNow.zoom;
    optsNow._input.bearing = optsNow.bearing = viewNow.bearing;
    optsNow._input.pitch = optsNow.pitch = viewNow.pitch;
    gd.emit('plotly_doubleclick', null);
    gd.emit('plotly_relayout', self.getViewEditsWithDerived(viewNow));
  });

  // define event handlers on map creation, to keep one ref per map,
  // so that map.on / map.off in updateFx works as expected
  self.clearOutline = function () {
    clearSelectionsCache(self.dragOptions);
    clearOutline(self.dragOptions.gd);
  };

  /**
   * Returns a click handler function that is supposed
   * to handle clicks in pan mode.
   */
  self.onClickInPanFn = function (dragOptions) {
    return function (evt) {
      var clickMode = gd._fullLayout.clickmode;
      if (clickMode.indexOf('select') > -1) {
        selectOnClick(evt.originalEvent, gd, [self.xaxis], [self.yaxis], self.id, dragOptions);
      }
      if (clickMode.indexOf('event') > -1) {
        // TODO: this does not support right-click. If we want to support it, we
        // would likely need to change map to use dragElement instead of straight
        // map event binding. Or perhaps better, make a simple wrapper with the
        // right mousedown, mousemove, and mouseup handlers just for a left/right click
        // pie would use this too.
        Fx.click(gd, evt.originalEvent);
      }
    };
  };
};
proto.updateFx = function (fullLayout) {
  var self = this;
  var map = self.map;
  var gd = self.gd;
  if (self.isStatic) return;
  function invert(pxpy) {
    var obj = self.map.unproject(pxpy);
    return [obj.lng, obj.lat];
  }
  var dragMode = fullLayout.dragmode;
  var fillRangeItems;
  fillRangeItems = function (eventData, poly) {
    if (poly.isRect) {
      var ranges = eventData.range = {};
      ranges[self.id] = [invert([poly.xmin, poly.ymin]), invert([poly.xmax, poly.ymax])];
    } else {
      var dataPts = eventData.lassoPoints = {};
      dataPts[self.id] = poly.map(invert);
    }
  };

  // Note: dragOptions is needed to be declared for all dragmodes because
  // it's the object that holds persistent selection state.
  // Merge old dragOptions with new to keep possibly initialized
  // persistent selection state.
  var oldDragOptions = self.dragOptions;
  self.dragOptions = Lib.extendDeep(oldDragOptions || {}, {
    dragmode: fullLayout.dragmode,
    element: self.div,
    gd: gd,
    plotinfo: {
      id: self.id,
      domain: fullLayout[self.id].domain,
      xaxis: self.xaxis,
      yaxis: self.yaxis,
      fillRangeItems: fillRangeItems
    },
    xaxes: [self.xaxis],
    yaxes: [self.yaxis],
    subplot: self.id
  });

  // Unregister the old handler before potentially registering
  // a new one. Otherwise multiple click handlers might
  // be registered resulting in unwanted behavior.
  map.off('click', self.onClickInPanHandler);
  if (selectMode(dragMode) || drawMode(dragMode)) {
    map.dragPan.disable();
    map.on('zoomstart', self.clearOutline);
    self.dragOptions.prepFn = function (e, startX, startY) {
      prepSelect(e, startX, startY, self.dragOptions, dragMode);
    };
    dragElement.init(self.dragOptions);
  } else {
    map.dragPan.enable();
    map.off('zoomstart', self.clearOutline);
    self.div.onmousedown = null;
    self.div.ontouchstart = null;
    self.div.removeEventListener('touchstart', self.div._ontouchstart);
    // TODO: this does not support right-click. If we want to support it, we
    // would likely need to change map to use dragElement instead of straight
    // map event binding. Or perhaps better, make a simple wrapper with the
    // right mousedown, mousemove, and mouseup handlers just for a left/right click
    // pie would use this too.
    self.onClickInPanHandler = self.onClickInPanFn(self.dragOptions);
    map.on('click', self.onClickInPanHandler);
  }
};
proto.updateFramework = function (fullLayout) {
  var domain = fullLayout[this.id].domain;
  var size = fullLayout._size;
  var style = this.div.style;
  style.width = size.w * (domain.x[1] - domain.x[0]) + 'px';
  style.height = size.h * (domain.y[1] - domain.y[0]) + 'px';
  style.left = size.l + domain.x[0] * size.w + 'px';
  style.top = size.t + (1 - domain.y[1]) * size.h + 'px';
  this.xaxis._offset = size.l + domain.x[0] * size.w;
  this.xaxis._length = size.w * (domain.x[1] - domain.x[0]);
  this.yaxis._offset = size.t + (1 - domain.y[1]) * size.h;
  this.yaxis._length = size.h * (domain.y[1] - domain.y[0]);
};
proto.updateLayers = function (fullLayout) {
  var opts = fullLayout[this.id];
  var layers = opts.layers;
  var layerList = this.layerList;
  var i;

  // if the layer arrays don't match,
  // don't try to be smart,
  // delete them all, and start all over.

  if (layers.length !== layerList.length) {
    for (i = 0; i < layerList.length; i++) {
      layerList[i].dispose();
    }
    layerList = this.layerList = [];
    for (i = 0; i < layers.length; i++) {
      layerList.push(createMapLayer(this, i, layers[i]));
    }
  } else {
    for (i = 0; i < layers.length; i++) {
      layerList[i].update(layers[i]);
    }
  }
};
proto.destroy = function () {
  if (this.map) {
    this.map.remove();
    this.map = null;
    this.container.removeChild(this.div);
  }
};
proto.toImage = function () {
  this.map.stop();
  return this.map.getCanvas().toDataURL();
};

// convenience wrapper to create set multiple layer
// 'layout' or 'paint options at once.
proto.setOptions = function (id, methodName, opts) {
  for (var k in opts) {
    this.map[methodName](id, k, opts[k]);
  }
};
proto.getMapLayers = function () {
  return this.map.getStyle().layers;
};

// convenience wrapper that first check in 'below' references
// a layer that exist and then add the layer to the map,
proto.addLayer = function (opts, below) {
  var map = this.map;
  if (typeof below === 'string') {
    if (below === '') {
      map.addLayer(opts, below);
      return;
    }
    var mapLayers = this.getMapLayers();
    for (var i = 0; i < mapLayers.length; i++) {
      if (below === mapLayers[i].id) {
        map.addLayer(opts, below);
        return;
      }
    }
    Lib.warn(['Trying to add layer with *below* value', below, 'referencing a layer that does not exist', 'or that does not yet exist.'].join(' '));
  }
  map.addLayer(opts);
};

// convenience method to project a [lon, lat] array to pixel coords
proto.project = function (v) {
  return this.map.project(new maplibregl.LngLat(v[0], v[1]));
};

// get map's current view values in plotly.js notation
proto.getView = function () {
  var map = this.map;
  var mapCenter = map.getCenter();
  var lon = mapCenter.lng;
  var lat = mapCenter.lat;
  var center = {
    lon: lon,
    lat: lat
  };
  var canvas = map.getCanvas();
  var w = parseInt(canvas.style.width);
  var h = parseInt(canvas.style.height);
  return {
    center: center,
    zoom: map.getZoom(),
    bearing: map.getBearing(),
    pitch: map.getPitch(),
    _derived: {
      coordinates: [map.unproject([0, 0]).toArray(), map.unproject([w, 0]).toArray(), map.unproject([w, h]).toArray(), map.unproject([0, h]).toArray()]
    }
  };
};
proto.getViewEdits = function (cont) {
  var id = this.id;
  var keys = ['center', 'zoom', 'bearing', 'pitch'];
  var obj = {};
  for (var i = 0; i < keys.length; i++) {
    var k = keys[i];
    obj[id + '.' + k] = cont[k];
  }
  return obj;
};
proto.getViewEditsWithDerived = function (cont) {
  var id = this.id;
  var obj = this.getViewEdits(cont);
  obj[id + '._derived'] = cont._derived;
  return obj;
};
function getStyleObj(val) {
  var styleObj = {};
  if (Lib.isPlainObject(val)) {
    styleObj.id = val.id;
    styleObj.style = val;
  } else if (typeof val === 'string') {
    styleObj.id = val;
    if (constants.stylesMap[val]) {
      styleObj.style = constants.stylesMap[val];
    } else {
      styleObj.style = val;
    }
  } else {
    styleObj.id = constants.styleValueDflt;
    styleObj.style = convertStyleVal(constants.styleValueDflt);
  }
  styleObj.transition = {
    duration: 0,
    delay: 0
  };
  return styleObj;
}

// if style is part of the 'official' map values, add URL prefix and suffix
function convertStyleVal(val) {
  return constants.styleUrlPrefix + val + '-' + constants.styleUrlSuffix;
}
function convertCenter(center) {
  return [center.lon, center.lat];
}
module.exports = Map;

/***/ }),

/***/ 44245:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var sortObjectKeys = __webpack_require__(62994);
var requiredVersion = '1.13.4';
var OSM = '© <a target="_blank" href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';
var carto = ['© <a target="_blank" href="https://carto.com/">Carto</a>', OSM].join(' ');
var stamenTerrainOrToner = ['Map tiles by <a target="_blank" href="https://stamen.com">Stamen Design</a>', 'under <a target="_blank" href="https://creativecommons.org/licenses/by/3.0">CC BY 3.0</a>', '|', 'Data by <a target="_blank" href="https://openstreetmap.org">OpenStreetMap</a> contributors', 'under <a target="_blank" href="https://www.openstreetmap.org/copyright">ODbL</a>'].join(' ');
var stamenWaterColor = ['Map tiles by <a target="_blank" href="https://stamen.com">Stamen Design</a>', 'under <a target="_blank" href="https://creativecommons.org/licenses/by/3.0">CC BY 3.0</a>', '|', 'Data by <a target="_blank" href="https://openstreetmap.org">OpenStreetMap</a> contributors', 'under <a target="_blank" href="https://creativecommons.org/licenses/by-sa/3.0">CC BY SA</a>'].join(' ');
var stylesNonMapbox = {
  'open-street-map': {
    id: 'osm',
    version: 8,
    sources: {
      'plotly-osm-tiles': {
        type: 'raster',
        attribution: OSM,
        tiles: ['https://a.tile.openstreetmap.org/{z}/{x}/{y}.png', 'https://b.tile.openstreetmap.org/{z}/{x}/{y}.png'],
        tileSize: 256
      }
    },
    layers: [{
      id: 'plotly-osm-tiles',
      type: 'raster',
      source: 'plotly-osm-tiles',
      minzoom: 0,
      maxzoom: 22
    }],
    glyphs: 'https://fonts.openmaptiles.org/{fontstack}/{range}.pbf'
  },
  'white-bg': {
    id: 'white-bg',
    version: 8,
    sources: {},
    layers: [{
      id: 'white-bg',
      type: 'background',
      paint: {
        'background-color': '#FFFFFF'
      },
      minzoom: 0,
      maxzoom: 22
    }],
    glyphs: 'https://fonts.openmaptiles.org/{fontstack}/{range}.pbf'
  },
  'carto-positron': {
    id: 'carto-positron',
    version: 8,
    sources: {
      'plotly-carto-positron': {
        type: 'raster',
        attribution: carto,
        tiles: ['https://cartodb-basemaps-c.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png'],
        tileSize: 256
      }
    },
    layers: [{
      id: 'plotly-carto-positron',
      type: 'raster',
      source: 'plotly-carto-positron',
      minzoom: 0,
      maxzoom: 22
    }],
    glyphs: 'https://fonts.openmaptiles.org/{fontstack}/{range}.pbf'
  },
  'carto-darkmatter': {
    id: 'carto-darkmatter',
    version: 8,
    sources: {
      'plotly-carto-darkmatter': {
        type: 'raster',
        attribution: carto,
        tiles: ['https://cartodb-basemaps-c.global.ssl.fastly.net/dark_all/{z}/{x}/{y}.png'],
        tileSize: 256
      }
    },
    layers: [{
      id: 'plotly-carto-darkmatter',
      type: 'raster',
      source: 'plotly-carto-darkmatter',
      minzoom: 0,
      maxzoom: 22
    }],
    glyphs: 'https://fonts.openmaptiles.org/{fontstack}/{range}.pbf'
  },
  'stamen-terrain': {
    id: 'stamen-terrain',
    version: 8,
    sources: {
      'plotly-stamen-terrain': {
        type: 'raster',
        attribution: stamenTerrainOrToner,
        tiles: ['https://tiles.stadiamaps.com/tiles/stamen_terrain/{z}/{x}/{y}.png?api_key='],
        tileSize: 256
      }
    },
    layers: [{
      id: 'plotly-stamen-terrain',
      type: 'raster',
      source: 'plotly-stamen-terrain',
      minzoom: 0,
      maxzoom: 22
    }],
    glyphs: 'https://fonts.openmaptiles.org/{fontstack}/{range}.pbf'
  },
  'stamen-toner': {
    id: 'stamen-toner',
    version: 8,
    sources: {
      'plotly-stamen-toner': {
        type: 'raster',
        attribution: stamenTerrainOrToner,
        tiles: ['https://tiles.stadiamaps.com/tiles/stamen_toner/{z}/{x}/{y}.png?api_key='],
        tileSize: 256
      }
    },
    layers: [{
      id: 'plotly-stamen-toner',
      type: 'raster',
      source: 'plotly-stamen-toner',
      minzoom: 0,
      maxzoom: 22
    }],
    glyphs: 'https://fonts.openmaptiles.org/{fontstack}/{range}.pbf'
  },
  'stamen-watercolor': {
    id: 'stamen-watercolor',
    version: 8,
    sources: {
      'plotly-stamen-watercolor': {
        type: 'raster',
        attribution: stamenWaterColor,
        tiles: ['https://tiles.stadiamaps.com/tiles/stamen_watercolor/{z}/{x}/{y}.jpg?api_key='],
        tileSize: 256
      }
    },
    layers: [{
      id: 'plotly-stamen-watercolor',
      type: 'raster',
      source: 'plotly-stamen-watercolor',
      minzoom: 0,
      maxzoom: 22
    }],
    glyphs: 'https://fonts.openmaptiles.org/{fontstack}/{range}.pbf'
  }
};
var styleValuesNonMapbox = sortObjectKeys(stylesNonMapbox);
module.exports = {
  requiredVersion: requiredVersion,
  styleUrlPrefix: 'mapbox://styles/mapbox/',
  styleUrlSuffix: 'v9',
  styleValuesMapbox: ['basic', 'streets', 'outdoors', 'light', 'dark', 'satellite', 'satellite-streets'],
  styleValueDflt: 'basic',
  stylesNonMapbox: stylesNonMapbox,
  styleValuesNonMapbox: styleValuesNonMapbox,
  traceLayerPrefix: 'plotly-trace-layer-',
  layoutLayerPrefix: 'plotly-layout-layer-',
  wrongVersionErrorMsg: ['Your custom plotly.js bundle is not using the correct mapbox-gl version', 'Please install @plotly/mapbox-gl@' + requiredVersion + '.'].join('\n'),
  noAccessTokenErrorMsg: ['Missing Mapbox access token.', 'Mapbox trace type require a Mapbox access token to be registered.', 'For example:', '  Plotly.newPlot(gd, data, layout, { mapboxAccessToken: \'my-access-token\' });', 'More info here: https://www.mapbox.com/help/define-access-token/'].join('\n'),
  missingStyleErrorMsg: ['No valid mapbox style found, please set `mapbox.style` to one of:', styleValuesNonMapbox.join(', '), 'or register a Mapbox access token to use a Mapbox-served style.'].join('\n'),
  multipleTokensErrorMsg: ['Set multiple mapbox access token across different mapbox subplot,', 'using first token found as mapbox-gl does not allow multiple' + 'access tokens on the same page.'].join('\n'),
  mapOnErrorMsg: 'Mapbox error.',
  // Mapbox logo for static export
  mapboxLogo: {
    path0: 'm 10.5,1.24 c -5.11,0 -9.25,4.15 -9.25,9.25 0,5.1 4.15,9.25 9.25,9.25 5.1,0 9.25,-4.15 9.25,-9.25 0,-5.11 -4.14,-9.25 -9.25,-9.25 z m 4.39,11.53 c -1.93,1.93 -4.78,2.31 -6.7,2.31 -0.7,0 -1.41,-0.05 -2.1,-0.16 0,0 -1.02,-5.64 2.14,-8.81 0.83,-0.83 1.95,-1.28 3.13,-1.28 1.27,0 2.49,0.51 3.39,1.42 1.84,1.84 1.89,4.75 0.14,6.52 z',
    path1: 'M 10.5,-0.01 C 4.7,-0.01 0,4.7 0,10.49 c 0,5.79 4.7,10.5 10.5,10.5 5.8,0 10.5,-4.7 10.5,-10.5 C 20.99,4.7 16.3,-0.01 10.5,-0.01 Z m 0,19.75 c -5.11,0 -9.25,-4.15 -9.25,-9.25 0,-5.1 4.14,-9.26 9.25,-9.26 5.11,0 9.25,4.15 9.25,9.25 0,5.13 -4.14,9.26 -9.25,9.26 z',
    path2: 'M 14.74,6.25 C 12.9,4.41 9.98,4.35 8.23,6.1 5.07,9.27 6.09,14.91 6.09,14.91 c 0,0 5.64,1.02 8.81,-2.14 C 16.64,11 16.59,8.09 14.74,6.25 Z m -2.27,4.09 -0.91,1.87 -0.9,-1.87 -1.86,-0.91 1.86,-0.9 0.9,-1.87 0.91,1.87 1.86,0.9 z',
    polygon: '11.56,12.21 10.66,10.34 8.8,9.43 10.66,8.53 11.56,6.66 12.47,8.53 14.33,9.43 12.47,10.34'
  },
  // a subset of node_modules/mapbox-gl/dist/mapbox-gl.css
  styleRules: {
    map: 'overflow:hidden;position:relative;',
    'missing-css': 'display:none;',
    canary: 'background-color:salmon;',
    // Reusing CSS directives from: https://api.tiles.mapbox.com/mapbox-gl-js/v1.1.1/mapbox-gl.css
    'ctrl-bottom-left': 'position: absolute; pointer-events: none; z-index: 2; bottom: 0; left: 0;',
    'ctrl-bottom-right': 'position: absolute; pointer-events: none; z-index: 2; right: 0; bottom: 0;',
    ctrl: 'clear: both; pointer-events: auto; transform: translate(0, 0);',
    // Compact ctrl
    'ctrl-attrib.mapboxgl-compact .mapboxgl-ctrl-attrib-inner': 'display: none;',
    'ctrl-attrib.mapboxgl-compact:hover .mapboxgl-ctrl-attrib-inner': 'display: block; margin-top:2px',
    'ctrl-attrib.mapboxgl-compact:hover': 'padding: 2px 24px 2px 4px; visibility: visible; margin-top: 6px;',
    'ctrl-attrib.mapboxgl-compact::after': 'content: ""; cursor: pointer; position: absolute; background-image: url(\'data:image/svg+xml;charset=utf-8,%3Csvg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"%3E %3Cpath fill="%23333333" fill-rule="evenodd" d="M4,10a6,6 0 1,0 12,0a6,6 0 1,0 -12,0 M9,7a1,1 0 1,0 2,0a1,1 0 1,0 -2,0 M9,10a1,1 0 1,1 2,0l0,3a1,1 0 1,1 -2,0"/%3E %3C/svg%3E\'); background-color: rgba(255, 255, 255, 0.5); width: 24px; height: 24px; box-sizing: border-box; border-radius: 12px;',
    'ctrl-attrib.mapboxgl-compact': 'min-height: 20px; padding: 0; margin: 10px; position: relative; background-color: #fff; border-radius: 3px 12px 12px 3px;',
    'ctrl-bottom-right > .mapboxgl-ctrl-attrib.mapboxgl-compact::after': 'bottom: 0; right: 0',
    'ctrl-bottom-left > .mapboxgl-ctrl-attrib.mapboxgl-compact::after': 'bottom: 0; left: 0',
    'ctrl-bottom-left .mapboxgl-ctrl': 'margin: 0 0 10px 10px; float: left;',
    'ctrl-bottom-right .mapboxgl-ctrl': 'margin: 0 10px 10px 0; float: right;',
    'ctrl-attrib': 'color: rgba(0, 0, 0, 0.75); text-decoration: none; font-size: 12px',
    'ctrl-attrib a': 'color: rgba(0, 0, 0, 0.75); text-decoration: none; font-size: 12px',
    'ctrl-attrib a:hover': 'color: inherit; text-decoration: underline;',
    'ctrl-attrib .mapbox-improve-map': 'font-weight: bold; margin-left: 2px;',
    'attrib-empty': 'display: none;',
    // Compact Mapbox logo without text
    'ctrl-logo': 'display:block; width: 21px; height: 21px; background-image: url(\'data:image/svg+xml;charset=utf-8,%3C?xml version="1.0" encoding="utf-8"?%3E %3Csvg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 21 21" style="enable-background:new 0 0 21 21;" xml:space="preserve"%3E%3Cg transform="translate(0,0.01)"%3E%3Cpath d="m 10.5,1.24 c -5.11,0 -9.25,4.15 -9.25,9.25 0,5.1 4.15,9.25 9.25,9.25 5.1,0 9.25,-4.15 9.25,-9.25 0,-5.11 -4.14,-9.25 -9.25,-9.25 z m 4.39,11.53 c -1.93,1.93 -4.78,2.31 -6.7,2.31 -0.7,0 -1.41,-0.05 -2.1,-0.16 0,0 -1.02,-5.64 2.14,-8.81 0.83,-0.83 1.95,-1.28 3.13,-1.28 1.27,0 2.49,0.51 3.39,1.42 1.84,1.84 1.89,4.75 0.14,6.52 z" style="opacity:0.9;fill:%23ffffff;enable-background:new" class="st0"/%3E%3Cpath d="M 10.5,-0.01 C 4.7,-0.01 0,4.7 0,10.49 c 0,5.79 4.7,10.5 10.5,10.5 5.8,0 10.5,-4.7 10.5,-10.5 C 20.99,4.7 16.3,-0.01 10.5,-0.01 Z m 0,19.75 c -5.11,0 -9.25,-4.15 -9.25,-9.25 0,-5.1 4.14,-9.26 9.25,-9.26 5.11,0 9.25,4.15 9.25,9.25 0,5.13 -4.14,9.26 -9.25,9.26 z" style="opacity:0.35;enable-background:new" class="st1"/%3E%3Cpath d="M 14.74,6.25 C 12.9,4.41 9.98,4.35 8.23,6.1 5.07,9.27 6.09,14.91 6.09,14.91 c 0,0 5.64,1.02 8.81,-2.14 C 16.64,11 16.59,8.09 14.74,6.25 Z m -2.27,4.09 -0.91,1.87 -0.9,-1.87 -1.86,-0.91 1.86,-0.9 0.9,-1.87 0.91,1.87 1.86,0.9 z" style="opacity:0.35;enable-background:new" class="st1"/%3E%3Cpolygon points="11.56,12.21 10.66,10.34 8.8,9.43 10.66,8.53 11.56,6.66 12.47,8.53 14.33,9.43 12.47,10.34 " style="opacity:0.9;fill:%23ffffff;enable-background:new" class="st0"/%3E%3C/g%3E%3C/svg%3E\')'

    // Mapbox logo WITH text below (commented out for now)
    // 'ctrl-logo': 'width: 85px; height: 21px; margin: 0 0 -3px -3px; display: block; background-repeat: no-repeat; cursor: pointer; background-image: url(\'data:image/svg+xml;charset=utf-8,%3C?xml version="1.0" encoding="utf-8"?%3E%3Csvg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 84.49 21" style="enable-background:new 0 0 84.49 21;" xml:space="preserve"%3E%3Cg%3E %3Cpath class="st0" style="opacity:0.9; fill: %23FFFFFF; enable-background: new;" d="M83.25,14.26c0,0.12-0.09,0.21-0.21,0.21h-1.61c-0.13,0-0.24-0.06-0.3-0.17l-1.44-2.39l-1.44,2.39 c-0.06,0.11-0.18,0.17-0.3,0.17h-1.61c-0.04,0-0.08-0.01-0.12-0.03c-0.09-0.06-0.13-0.19-0.06-0.28l0,0l2.43-3.68L76.2,6.84 c-0.02-0.03-0.03-0.07-0.03-0.12c0-0.12,0.09-0.21,0.21-0.21h1.61c0.13,0,0.24,0.06,0.3,0.17l1.41,2.36l1.4-2.35 c0.06-0.11,0.18-0.17,0.3-0.17H83c0.04,0,0.08,0.01,0.12,0.03c0.09,0.06,0.13,0.19,0.06,0.28l0,0l-2.37,3.63l2.43,3.67 C83.24,14.18,83.25,14.22,83.25,14.26z"/%3E %3Cpath class="st0" style="opacity:0.9; fill: %23FFFFFF; enable-background: new;" d="M66.24,9.59c-0.39-1.88-1.96-3.28-3.84-3.28c-1.03,0-2.03,0.42-2.73,1.18V3.51c0-0.13-0.1-0.23-0.23-0.23h-1.4 c-0.13,0-0.23,0.11-0.23,0.23v10.72c0,0.13,0.1,0.23,0.23,0.23h1.4c0.13,0,0.23-0.11,0.23-0.23V13.5c0.71,0.75,1.7,1.18,2.73,1.18 c1.88,0,3.45-1.41,3.84-3.29C66.37,10.79,66.37,10.18,66.24,9.59L66.24,9.59z M62.08,13c-1.32,0-2.39-1.11-2.41-2.48v-0.06 c0.02-1.38,1.09-2.48,2.41-2.48s2.42,1.12,2.42,2.51S63.41,13,62.08,13z"/%3E %3Cpath class="st0" style="opacity:0.9; fill: %23FFFFFF; enable-background: new;" d="M71.67,6.32c-1.98-0.01-3.72,1.35-4.16,3.29c-0.13,0.59-0.13,1.19,0,1.77c0.44,1.94,2.17,3.32,4.17,3.3 c2.35,0,4.26-1.87,4.26-4.19S74.04,6.32,71.67,6.32z M71.65,13.01c-1.33,0-2.42-1.12-2.42-2.51s1.08-2.52,2.42-2.52 c1.33,0,2.42,1.12,2.42,2.51S72.99,13,71.65,13.01L71.65,13.01z"/%3E %3Cpath class="st1" style="opacity:0.35; enable-background:new;" d="M62.08,7.98c-1.32,0-2.39,1.11-2.41,2.48v0.06C59.68,11.9,60.75,13,62.08,13s2.42-1.12,2.42-2.51 S63.41,7.98,62.08,7.98z M62.08,11.76c-0.63,0-1.14-0.56-1.17-1.25v-0.04c0.01-0.69,0.54-1.25,1.17-1.25 c0.63,0,1.17,0.57,1.17,1.27C63.24,11.2,62.73,11.76,62.08,11.76z"/%3E %3Cpath class="st1" style="opacity:0.35; enable-background:new;" d="M71.65,7.98c-1.33,0-2.42,1.12-2.42,2.51S70.32,13,71.65,13s2.42-1.12,2.42-2.51S72.99,7.98,71.65,7.98z M71.65,11.76c-0.64,0-1.17-0.57-1.17-1.27c0-0.7,0.53-1.26,1.17-1.26s1.17,0.57,1.17,1.27C72.82,11.21,72.29,11.76,71.65,11.76z"/%3E %3Cpath class="st0" style="opacity:0.9; fill: %23FFFFFF; enable-background: new;" d="M45.74,6.53h-1.4c-0.13,0-0.23,0.11-0.23,0.23v0.73c-0.71-0.75-1.7-1.18-2.73-1.18 c-2.17,0-3.94,1.87-3.94,4.19s1.77,4.19,3.94,4.19c1.04,0,2.03-0.43,2.73-1.19v0.73c0,0.13,0.1,0.23,0.23,0.23h1.4 c0.13,0,0.23-0.11,0.23-0.23V6.74c0-0.12-0.09-0.22-0.22-0.22C45.75,6.53,45.75,6.53,45.74,6.53z M44.12,10.53 C44.11,11.9,43.03,13,41.71,13s-2.42-1.12-2.42-2.51s1.08-2.52,2.4-2.52c1.33,0,2.39,1.11,2.41,2.48L44.12,10.53z"/%3E %3Cpath class="st1" style="opacity:0.35; enable-background:new;" d="M41.71,7.98c-1.33,0-2.42,1.12-2.42,2.51S40.37,13,41.71,13s2.39-1.11,2.41-2.48v-0.06 C44.1,9.09,43.03,7.98,41.71,7.98z M40.55,10.49c0-0.7,0.52-1.27,1.17-1.27c0.64,0,1.14,0.56,1.17,1.25v0.04 c-0.01,0.68-0.53,1.24-1.17,1.24C41.08,11.75,40.55,11.19,40.55,10.49z"/%3E %3Cpath class="st0" style="opacity:0.9; fill: %23FFFFFF; enable-background: new;" d="M52.41,6.32c-1.03,0-2.03,0.42-2.73,1.18V6.75c0-0.13-0.1-0.23-0.23-0.23h-1.4c-0.13,0-0.23,0.11-0.23,0.23 v10.72c0,0.13,0.1,0.23,0.23,0.23h1.4c0.13,0,0.23-0.1,0.23-0.23V13.5c0.71,0.75,1.7,1.18,2.74,1.18c2.17,0,3.94-1.87,3.94-4.19 S54.58,6.32,52.41,6.32z M52.08,13.01c-1.32,0-2.39-1.11-2.42-2.48v-0.07c0.02-1.38,1.09-2.49,2.4-2.49c1.32,0,2.41,1.12,2.41,2.51 S53.4,13,52.08,13.01L52.08,13.01z"/%3E %3Cpath class="st1" style="opacity:0.35; enable-background:new;" d="M52.08,7.98c-1.32,0-2.39,1.11-2.42,2.48v0.06c0.03,1.38,1.1,2.48,2.42,2.48s2.41-1.12,2.41-2.51 S53.4,7.98,52.08,7.98z M52.08,11.76c-0.63,0-1.14-0.56-1.17-1.25v-0.04c0.01-0.69,0.54-1.25,1.17-1.25c0.63,0,1.17,0.58,1.17,1.27 S52.72,11.76,52.08,11.76z"/%3E %3Cpath class="st0" style="opacity:0.9; fill: %23FFFFFF; enable-background: new;" d="M36.08,14.24c0,0.13-0.1,0.23-0.23,0.23h-1.41c-0.13,0-0.23-0.11-0.23-0.23V9.68c0-0.98-0.74-1.71-1.62-1.71 c-0.8,0-1.46,0.7-1.59,1.62l0.01,4.66c0,0.13-0.11,0.23-0.23,0.23h-1.41c-0.13,0-0.23-0.11-0.23-0.23V9.68 c0-0.98-0.74-1.71-1.62-1.71c-0.85,0-1.54,0.79-1.6,1.8v4.48c0,0.13-0.1,0.23-0.23,0.23h-1.4c-0.13,0-0.23-0.11-0.23-0.23V6.74 c0.01-0.13,0.1-0.22,0.23-0.22h1.4c0.13,0,0.22,0.11,0.23,0.22V7.4c0.5-0.68,1.3-1.09,2.16-1.1h0.03c1.09,0,2.09,0.6,2.6,1.55 c0.45-0.95,1.4-1.55,2.44-1.56c1.62,0,2.93,1.25,2.9,2.78L36.08,14.24z"/%3E %3Cpath class="st1" style="opacity:0.35; enable-background:new;" d="M84.34,13.59l-0.07-0.13l-1.96-2.99l1.94-2.95c0.44-0.67,0.26-1.56-0.41-2.02c-0.02,0-0.03,0-0.04-0.01 c-0.23-0.15-0.5-0.22-0.78-0.22h-1.61c-0.56,0-1.08,0.29-1.37,0.78L79.72,6.6l-0.34-0.56C79.09,5.56,78.57,5.27,78,5.27h-1.6 c-0.6,0-1.13,0.37-1.35,0.92c-2.19-1.66-5.28-1.47-7.26,0.45c-0.35,0.34-0.65,0.72-0.89,1.14c-0.9-1.62-2.58-2.72-4.5-2.72 c-0.5,0-1.01,0.07-1.48,0.23V3.51c0-0.82-0.66-1.48-1.47-1.48h-1.4c-0.81,0-1.47,0.66-1.47,1.47v3.75 c-0.95-1.36-2.5-2.18-4.17-2.19c-0.74,0-1.46,0.16-2.12,0.47c-0.24-0.17-0.54-0.26-0.84-0.26h-1.4c-0.45,0-0.87,0.21-1.15,0.56 c-0.02-0.03-0.04-0.05-0.07-0.08c-0.28-0.3-0.68-0.47-1.09-0.47h-1.39c-0.3,0-0.6,0.09-0.84,0.26c-0.67-0.3-1.39-0.46-2.12-0.46 c-1.83,0-3.43,1-4.37,2.5c-0.2-0.46-0.48-0.89-0.83-1.25c-0.8-0.81-1.89-1.25-3.02-1.25h-0.01c-0.89,0.01-1.75,0.33-2.46,0.88 c-0.74-0.57-1.64-0.88-2.57-0.88H28.1c-0.29,0-0.58,0.03-0.86,0.11c-0.28,0.06-0.56,0.16-0.82,0.28c-0.21-0.12-0.45-0.18-0.7-0.18 h-1.4c-0.82,0-1.47,0.66-1.47,1.47v7.5c0,0.82,0.66,1.47,1.47,1.47h1.4c0.82,0,1.48-0.66,1.48-1.48l0,0V9.79 c0.03-0.36,0.23-0.59,0.36-0.59c0.18,0,0.38,0.18,0.38,0.47v4.57c0,0.82,0.66,1.47,1.47,1.47h1.41c0.82,0,1.47-0.66,1.47-1.47 l-0.01-4.57c0.06-0.32,0.25-0.47,0.35-0.47c0.18,0,0.38,0.18,0.38,0.47v4.57c0,0.82,0.66,1.47,1.47,1.47h1.41 c0.82,0,1.47-0.66,1.47-1.47v-0.38c0.96,1.29,2.46,2.06,4.06,2.06c0.74,0,1.46-0.16,2.12-0.47c0.24,0.17,0.54,0.26,0.84,0.26h1.39 c0.3,0,0.6-0.09,0.84-0.26v2.01c0,0.82,0.66,1.47,1.47,1.47h1.4c0.82,0,1.47-0.66,1.47-1.47v-1.77c0.48,0.15,0.99,0.23,1.49,0.22 c1.7,0,3.22-0.87,4.17-2.2v0.52c0,0.82,0.66,1.47,1.47,1.47h1.4c0.3,0,0.6-0.09,0.84-0.26c0.66,0.31,1.39,0.47,2.12,0.47 c1.92,0,3.6-1.1,4.49-2.73c1.54,2.65,4.95,3.53,7.58,1.98c0.18-0.11,0.36-0.22,0.53-0.36c0.22,0.55,0.76,0.91,1.35,0.9H78 c0.56,0,1.08-0.29,1.37-0.78l0.37-0.61l0.37,0.61c0.29,0.48,0.81,0.78,1.38,0.78h1.6c0.81,0,1.46-0.66,1.45-1.46 C84.49,14.02,84.44,13.8,84.34,13.59L84.34,13.59z M35.86,14.47h-1.41c-0.13,0-0.23-0.11-0.23-0.23V9.68 c0-0.98-0.74-1.71-1.62-1.71c-0.8,0-1.46,0.7-1.59,1.62l0.01,4.66c0,0.13-0.1,0.23-0.23,0.23h-1.41c-0.13,0-0.23-0.11-0.23-0.23 V9.68c0-0.98-0.74-1.71-1.62-1.71c-0.85,0-1.54,0.79-1.6,1.8v4.48c0,0.13-0.1,0.23-0.23,0.23h-1.4c-0.13,0-0.23-0.11-0.23-0.23 V6.74c0.01-0.13,0.11-0.22,0.23-0.22h1.4c0.13,0,0.22,0.11,0.23,0.22V7.4c0.5-0.68,1.3-1.09,2.16-1.1h0.03 c1.09,0,2.09,0.6,2.6,1.55c0.45-0.95,1.4-1.55,2.44-1.56c1.62,0,2.93,1.25,2.9,2.78l0.01,5.16C36.09,14.36,35.98,14.46,35.86,14.47 L35.86,14.47z M45.97,14.24c0,0.13-0.1,0.23-0.23,0.23h-1.4c-0.13,0-0.23-0.11-0.23-0.23V13.5c-0.7,0.76-1.69,1.18-2.72,1.18 c-2.17,0-3.94-1.87-3.94-4.19s1.77-4.19,3.94-4.19c1.03,0,2.02,0.43,2.73,1.18V6.74c0-0.13,0.1-0.23,0.23-0.23h1.4 c0.12-0.01,0.22,0.08,0.23,0.21c0,0.01,0,0.01,0,0.02v7.51h-0.01V14.24z M52.41,14.67c-1.03,0-2.02-0.43-2.73-1.18v3.97 c0,0.13-0.1,0.23-0.23,0.23h-1.4c-0.13,0-0.23-0.1-0.23-0.23V6.75c0-0.13,0.1-0.22,0.23-0.22h1.4c0.13,0,0.23,0.11,0.23,0.23v0.73 c0.71-0.76,1.7-1.18,2.73-1.18c2.17,0,3.94,1.86,3.94,4.18S54.58,14.67,52.41,14.67z M66.24,11.39c-0.39,1.87-1.96,3.29-3.84,3.29 c-1.03,0-2.02-0.43-2.73-1.18v0.73c0,0.13-0.1,0.23-0.23,0.23h-1.4c-0.13,0-0.23-0.11-0.23-0.23V3.51c0-0.13,0.1-0.23,0.23-0.23 h1.4c0.13,0,0.23,0.11,0.23,0.23v3.97c0.71-0.75,1.7-1.18,2.73-1.17c1.88,0,3.45,1.4,3.84,3.28C66.37,10.19,66.37,10.8,66.24,11.39 L66.24,11.39L66.24,11.39z M71.67,14.68c-2,0.01-3.73-1.35-4.17-3.3c-0.13-0.59-0.13-1.19,0-1.77c0.44-1.94,2.17-3.31,4.17-3.3 c2.36,0,4.26,1.87,4.26,4.19S74.03,14.68,71.67,14.68L71.67,14.68z M83.04,14.47h-1.61c-0.13,0-0.24-0.06-0.3-0.17l-1.44-2.39 l-1.44,2.39c-0.06,0.11-0.18,0.17-0.3,0.17h-1.61c-0.04,0-0.08-0.01-0.12-0.03c-0.09-0.06-0.13-0.19-0.06-0.28l0,0l2.43-3.68 L76.2,6.84c-0.02-0.03-0.03-0.07-0.03-0.12c0-0.12,0.09-0.21,0.21-0.21h1.61c0.13,0,0.24,0.06,0.3,0.17l1.41,2.36l1.41-2.36 c0.06-0.11,0.18-0.17,0.3-0.17h1.61c0.04,0,0.08,0.01,0.12,0.03c0.09,0.06,0.13,0.19,0.06,0.28l0,0l-2.38,3.64l2.43,3.67 c0.02,0.03,0.03,0.07,0.03,0.12C83.25,14.38,83.16,14.47,83.04,14.47L83.04,14.47L83.04,14.47z"/%3E %3Cpath class="st0" style="opacity:0.9; fill: %23FFFFFF; enable-background: new;" d="M10.5,1.24c-5.11,0-9.25,4.15-9.25,9.25s4.15,9.25,9.25,9.25s9.25-4.15,9.25-9.25 C19.75,5.38,15.61,1.24,10.5,1.24z M14.89,12.77c-1.93,1.93-4.78,2.31-6.7,2.31c-0.7,0-1.41-0.05-2.1-0.16c0,0-1.02-5.64,2.14-8.81 c0.83-0.83,1.95-1.28,3.13-1.28c1.27,0,2.49,0.51,3.39,1.42C16.59,8.09,16.64,11,14.89,12.77z"/%3E %3Cpath class="st1" style="opacity:0.35; enable-background:new;" d="M10.5-0.01C4.7-0.01,0,4.7,0,10.49s4.7,10.5,10.5,10.5S21,16.29,21,10.49C20.99,4.7,16.3-0.01,10.5-0.01z M10.5,19.74c-5.11,0-9.25-4.15-9.25-9.25s4.14-9.26,9.25-9.26s9.25,4.15,9.25,9.25C19.75,15.61,15.61,19.74,10.5,19.74z"/%3E %3Cpath class="st1" style="opacity:0.35; enable-background:new;" d="M14.74,6.25C12.9,4.41,9.98,4.35,8.23,6.1c-3.16,3.17-2.14,8.81-2.14,8.81s5.64,1.02,8.81-2.14 C16.64,11,16.59,8.09,14.74,6.25z M12.47,10.34l-0.91,1.87l-0.9-1.87L8.8,9.43l1.86-0.9l0.9-1.87l0.91,1.87l1.86,0.9L12.47,10.34z"/%3E %3Cpolygon class="st0" style="opacity:0.9; fill: %23FFFFFF; enable-background: new;" points="14.33,9.43 12.47,10.34 11.56,12.21 10.66,10.34 8.8,9.43 10.66,8.53 11.56,6.66 12.47,8.53 "/%3E%3C/g%3E%3C/svg%3E\');'
  }
};

/***/ }),

/***/ 2178:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);

/**
 * Convert plotly.js 'textposition' to mapbox-gl 'anchor' and 'offset'
 * (with the help of the icon size).
 *
 * @param {string} textpostion : plotly.js textposition value
 * @param {number} iconSize : plotly.js icon size (e.g. marker.size for traces)
 *
 * @return {object}
 *      - anchor
 *      - offset
 */
module.exports = function convertTextOpts(textposition, iconSize) {
  var parts = textposition.split(' ');
  var vPos = parts[0];
  var hPos = parts[1];

  // ballpack values
  var factor = Lib.isArrayOrTypedArray(iconSize) ? Lib.mean(iconSize) : iconSize;
  var xInc = 0.5 + factor / 100;
  var yInc = 1.5 + factor / 100;
  var anchorVals = ['', ''];
  var offset = [0, 0];
  switch (vPos) {
    case 'top':
      anchorVals[0] = 'top';
      offset[1] = -yInc;
      break;
    case 'bottom':
      anchorVals[0] = 'bottom';
      offset[1] = yInc;
      break;
  }
  switch (hPos) {
    case 'left':
      anchorVals[1] = 'right';
      offset[0] = -xInc;
      break;
    case 'right':
      anchorVals[1] = 'left';
      offset[0] = xInc;
      break;
  }

  // Mapbox text-anchor must be one of:
  //  center, left, right, top, bottom,
  //  top-left, top-right, bottom-left, bottom-right

  var anchor;
  if (anchorVals[0] && anchorVals[1]) anchor = anchorVals.join('-');else if (anchorVals[0]) anchor = anchorVals[0];else if (anchorVals[1]) anchor = anchorVals[1];else anchor = 'center';
  return {
    anchor: anchor,
    offset: offset
  };
};

/***/ }),

/***/ 68192:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var mapboxgl = __webpack_require__(32280);
var Lib = __webpack_require__(34809);
var strTranslate = Lib.strTranslate;
var strScale = Lib.strScale;
var getSubplotCalcData = (__webpack_require__(4173)/* .getSubplotCalcData */ .fX);
var xmlnsNamespaces = __webpack_require__(62972);
var d3 = __webpack_require__(45568);
var Drawing = __webpack_require__(62203);
var svgTextUtils = __webpack_require__(30635);
var Mapbox = __webpack_require__(5417);
var MAPBOX = 'mapbox';
var constants = exports.constants = __webpack_require__(44245);
exports.name = MAPBOX;
exports.attr = 'subplot';
exports.idRoot = MAPBOX;
exports.idRegex = exports.attrRegex = Lib.counterRegex(MAPBOX);
var deprecationWarning = ['mapbox subplots and traces are deprecated!', 'Please consider switching to `map` subplots and traces.', 'Learn more at: https://plotly.com/javascript/maplibre-migration/'].join(' ');
exports.attributes = {
  subplot: {
    valType: 'subplotid',
    dflt: 'mapbox',
    editType: 'calc'
  }
};
exports.layoutAttributes = __webpack_require__(67514);
exports.supplyLayoutDefaults = __webpack_require__(86989);
var firstPlot = true;
exports.plot = function plot(gd) {
  if (firstPlot) {
    firstPlot = false;
    Lib.warn(deprecationWarning);
  }
  var fullLayout = gd._fullLayout;
  var calcData = gd.calcdata;
  var mapboxIds = fullLayout._subplots[MAPBOX];
  if (mapboxgl.version !== constants.requiredVersion) {
    throw new Error(constants.wrongVersionErrorMsg);
  }
  var accessToken = findAccessToken(gd, mapboxIds);
  mapboxgl.accessToken = accessToken;
  for (var i = 0; i < mapboxIds.length; i++) {
    var id = mapboxIds[i];
    var subplotCalcData = getSubplotCalcData(calcData, MAPBOX, id);
    var opts = fullLayout[id];
    var mapbox = opts._subplot;
    if (!mapbox) {
      mapbox = new Mapbox(gd, id);
      fullLayout[id]._subplot = mapbox;
    }
    if (!mapbox.viewInitial) {
      mapbox.viewInitial = {
        center: Lib.extendFlat({}, opts.center),
        zoom: opts.zoom,
        bearing: opts.bearing,
        pitch: opts.pitch
      };
    }
    mapbox.plot(subplotCalcData, fullLayout, gd._promises);
  }
};
exports.clean = function (newFullData, newFullLayout, oldFullData, oldFullLayout) {
  var oldMapboxKeys = oldFullLayout._subplots[MAPBOX] || [];
  for (var i = 0; i < oldMapboxKeys.length; i++) {
    var oldMapboxKey = oldMapboxKeys[i];
    if (!newFullLayout[oldMapboxKey] && !!oldFullLayout[oldMapboxKey]._subplot) {
      oldFullLayout[oldMapboxKey]._subplot.destroy();
    }
  }
};
exports.toSVG = function (gd) {
  var fullLayout = gd._fullLayout;
  var subplotIds = fullLayout._subplots[MAPBOX];
  var size = fullLayout._size;
  for (var i = 0; i < subplotIds.length; i++) {
    var opts = fullLayout[subplotIds[i]];
    var domain = opts.domain;
    var mapbox = opts._subplot;
    var imageData = mapbox.toImage('png');
    var image = fullLayout._glimages.append('svg:image');
    image.attr({
      xmlns: xmlnsNamespaces.svg,
      'xlink:href': imageData,
      x: size.l + size.w * domain.x[0],
      y: size.t + size.h * (1 - domain.y[1]),
      width: size.w * (domain.x[1] - domain.x[0]),
      height: size.h * (domain.y[1] - domain.y[0]),
      preserveAspectRatio: 'none'
    });
    var subplotDiv = d3.select(opts._subplot.div);

    // Append logo if visible
    var hidden = subplotDiv.select('.mapboxgl-ctrl-logo').node().offsetParent === null;
    if (!hidden) {
      var logo = fullLayout._glimages.append('g');
      logo.attr('transform', strTranslate(size.l + size.w * domain.x[0] + 10, size.t + size.h * (1 - domain.y[0]) - 31));
      logo.append('path').attr('d', constants.mapboxLogo.path0).style({
        opacity: 0.9,
        fill: '#ffffff',
        'enable-background': 'new'
      });
      logo.append('path').attr('d', constants.mapboxLogo.path1).style('opacity', 0.35).style('enable-background', 'new');
      logo.append('path').attr('d', constants.mapboxLogo.path2).style('opacity', 0.35).style('enable-background', 'new');
      logo.append('polygon').attr('points', constants.mapboxLogo.polygon).style({
        opacity: 0.9,
        fill: '#ffffff',
        'enable-background': 'new'
      });
    }

    // Add attributions
    var attributions = subplotDiv.select('.mapboxgl-ctrl-attrib').text().replace('Improve this map', '');
    var attributionGroup = fullLayout._glimages.append('g');
    var attributionText = attributionGroup.append('text');
    attributionText.text(attributions).classed('static-attribution', true).attr({
      'font-size': 12,
      'font-family': 'Arial',
      color: 'rgba(0, 0, 0, 0.75)',
      'text-anchor': 'end',
      'data-unformatted': attributions
    });
    var bBox = Drawing.bBox(attributionText.node());

    // Break into multiple lines twice larger than domain
    var maxWidth = size.w * (domain.x[1] - domain.x[0]);
    if (bBox.width > maxWidth / 2) {
      var multilineAttributions = attributions.split('|').join('<br>');
      attributionText.text(multilineAttributions).attr('data-unformatted', multilineAttributions).call(svgTextUtils.convertToTspans, gd);
      bBox = Drawing.bBox(attributionText.node());
    }
    attributionText.attr('transform', strTranslate(-3, -bBox.height + 8));

    // Draw white rectangle behind text
    attributionGroup.insert('rect', '.static-attribution').attr({
      x: -bBox.width - 6,
      y: -bBox.height - 3,
      width: bBox.width + 6,
      height: bBox.height + 3,
      fill: 'rgba(255, 255, 255, 0.75)'
    });

    // Scale down if larger than domain
    var scaleRatio = 1;
    if (bBox.width + 6 > maxWidth) scaleRatio = maxWidth / (bBox.width + 6);
    var offset = [size.l + size.w * domain.x[1], size.t + size.h * (1 - domain.y[0])];
    attributionGroup.attr('transform', strTranslate(offset[0], offset[1]) + strScale(scaleRatio));
  }
};

// N.B. mapbox-gl only allows one accessToken to be set per page:
// https://github.com/mapbox/mapbox-gl-js/issues/6331
function findAccessToken(gd, mapboxIds) {
  var fullLayout = gd._fullLayout;
  var context = gd._context;

  // special case for Mapbox Atlas users
  if (context.mapboxAccessToken === '') return '';
  var tokensUseful = [];
  var tokensListed = [];
  var hasOneSetMapboxStyle = false;
  var wontWork = false;

  // Take the first token we find in a mapbox subplot.
  // These default to the context value but may be overridden.
  for (var i = 0; i < mapboxIds.length; i++) {
    var opts = fullLayout[mapboxIds[i]];
    var token = opts.accesstoken;
    if (isStyleRequireAccessToken(opts.style)) {
      if (token) {
        Lib.pushUnique(tokensUseful, token);
      } else {
        if (isStyleRequireAccessToken(opts._input.style)) {
          Lib.error('Uses Mapbox map style, but did not set an access token.');
          hasOneSetMapboxStyle = true;
        }
        wontWork = true;
      }
    }
    if (token) {
      Lib.pushUnique(tokensListed, token);
    }
  }
  if (wontWork) {
    var msg = hasOneSetMapboxStyle ? constants.noAccessTokenErrorMsg : constants.missingStyleErrorMsg;
    Lib.error(msg);
    throw new Error(msg);
  }
  if (tokensUseful.length) {
    if (tokensUseful.length > 1) {
      Lib.warn(constants.multipleTokensErrorMsg);
    }
    return tokensUseful[0];
  } else {
    if (tokensListed.length) {
      Lib.log(['Listed mapbox access token(s)', tokensListed.join(','), 'but did not use a Mapbox map style, ignoring token(s).'].join(' '));
    }
    return '';
  }
}
function isStyleRequireAccessToken(s) {
  return typeof s === 'string' && (constants.styleValuesMapbox.indexOf(s) !== -1 || s.indexOf('mapbox://') === 0 || s.indexOf('stamen') === 0);
}
exports.updateFx = function (gd) {
  var fullLayout = gd._fullLayout;
  var subplotIds = fullLayout._subplots[MAPBOX];
  for (var i = 0; i < subplotIds.length; i++) {
    var subplotObj = fullLayout[subplotIds[i]]._subplot;
    subplotObj.updateFx(fullLayout);
  }
};

/***/ }),

/***/ 51276:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var sanitizeHTML = (__webpack_require__(30635).sanitizeHTML);
var convertTextOpts = __webpack_require__(2178);
var constants = __webpack_require__(44245);
function MapboxLayer(subplot, index) {
  this.subplot = subplot;
  this.uid = subplot.uid + '-' + index;
  this.index = index;
  this.idSource = 'source-' + this.uid;
  this.idLayer = constants.layoutLayerPrefix + this.uid;

  // some state variable to check if a remove/add step is needed
  this.sourceType = null;
  this.source = null;
  this.layerType = null;
  this.below = null;

  // is layer currently visible
  this.visible = false;
}
var proto = MapboxLayer.prototype;
proto.update = function update(opts) {
  if (!this.visible) {
    // IMPORTANT: must create source before layer to not cause errors
    this.updateSource(opts);
    this.updateLayer(opts);
  } else if (this.needsNewImage(opts)) {
    this.updateImage(opts);
  } else if (this.needsNewSource(opts)) {
    // IMPORTANT: must delete layer before source to not cause errors
    this.removeLayer();
    this.updateSource(opts);
    this.updateLayer(opts);
  } else if (this.needsNewLayer(opts)) {
    this.updateLayer(opts);
  } else {
    this.updateStyle(opts);
  }
  this.visible = isVisible(opts);
};
proto.needsNewImage = function (opts) {
  var map = this.subplot.map;
  return map.getSource(this.idSource) && this.sourceType === 'image' && opts.sourcetype === 'image' && (this.source !== opts.source || JSON.stringify(this.coordinates) !== JSON.stringify(opts.coordinates));
};
proto.needsNewSource = function (opts) {
  // for some reason changing layer to 'fill' or 'symbol'
  // w/o changing the source throws an exception in mapbox-gl 0.18 ;
  // stay safe and make new source on type changes
  return this.sourceType !== opts.sourcetype || JSON.stringify(this.source) !== JSON.stringify(opts.source) || this.layerType !== opts.type;
};
proto.needsNewLayer = function (opts) {
  return this.layerType !== opts.type || this.below !== this.subplot.belowLookup['layout-' + this.index];
};
proto.lookupBelow = function () {
  return this.subplot.belowLookup['layout-' + this.index];
};
proto.updateImage = function (opts) {
  var map = this.subplot.map;
  map.getSource(this.idSource).updateImage({
    url: opts.source,
    coordinates: opts.coordinates
  });

  // Since the `updateImage` control flow doesn't call updateLayer,
  // We need to take care of moving the image layer to match the location
  // where updateLayer would have placed it.
  var _below = this.findFollowingMapboxLayerId(this.lookupBelow());
  if (_below !== null) {
    this.subplot.map.moveLayer(this.idLayer, _below);
  }
};
proto.updateSource = function (opts) {
  var map = this.subplot.map;
  if (map.getSource(this.idSource)) map.removeSource(this.idSource);
  this.sourceType = opts.sourcetype;
  this.source = opts.source;
  if (!isVisible(opts)) return;
  var sourceOpts = convertSourceOpts(opts);
  map.addSource(this.idSource, sourceOpts);
};
proto.findFollowingMapboxLayerId = function (below) {
  if (below === 'traces') {
    var mapLayers = this.subplot.getMapLayers();

    // find id of first plotly trace layer
    for (var i = 0; i < mapLayers.length; i++) {
      var layerId = mapLayers[i].id;
      if (typeof layerId === 'string' && layerId.indexOf(constants.traceLayerPrefix) === 0) {
        below = layerId;
        break;
      }
    }
  }
  return below;
};
proto.updateLayer = function (opts) {
  var subplot = this.subplot;
  var convertedOpts = convertOpts(opts);
  var below = this.lookupBelow();
  var _below = this.findFollowingMapboxLayerId(below);
  this.removeLayer();
  if (isVisible(opts)) {
    subplot.addLayer({
      id: this.idLayer,
      source: this.idSource,
      'source-layer': opts.sourcelayer || '',
      type: opts.type,
      minzoom: opts.minzoom,
      maxzoom: opts.maxzoom,
      layout: convertedOpts.layout,
      paint: convertedOpts.paint
    }, _below);
  }
  this.layerType = opts.type;
  this.below = below;
};
proto.updateStyle = function (opts) {
  if (isVisible(opts)) {
    var convertedOpts = convertOpts(opts);
    this.subplot.setOptions(this.idLayer, 'setLayoutProperty', convertedOpts.layout);
    this.subplot.setOptions(this.idLayer, 'setPaintProperty', convertedOpts.paint);
  }
};
proto.removeLayer = function () {
  var map = this.subplot.map;
  if (map.getLayer(this.idLayer)) {
    map.removeLayer(this.idLayer);
  }
};
proto.dispose = function () {
  var map = this.subplot.map;
  if (map.getLayer(this.idLayer)) map.removeLayer(this.idLayer);
  if (map.getSource(this.idSource)) map.removeSource(this.idSource);
};
function isVisible(opts) {
  if (!opts.visible) return false;
  var source = opts.source;
  if (Array.isArray(source) && source.length > 0) {
    for (var i = 0; i < source.length; i++) {
      if (typeof source[i] !== 'string' || source[i].length === 0) {
        return false;
      }
    }
    return true;
  }
  return Lib.isPlainObject(source) || typeof source === 'string' && source.length > 0;
}
function convertOpts(opts) {
  var layout = {};
  var paint = {};
  switch (opts.type) {
    case 'circle':
      Lib.extendFlat(paint, {
        'circle-radius': opts.circle.radius,
        'circle-color': opts.color,
        'circle-opacity': opts.opacity
      });
      break;
    case 'line':
      Lib.extendFlat(paint, {
        'line-width': opts.line.width,
        'line-color': opts.color,
        'line-opacity': opts.opacity,
        'line-dasharray': opts.line.dash
      });
      break;
    case 'fill':
      Lib.extendFlat(paint, {
        'fill-color': opts.color,
        'fill-outline-color': opts.fill.outlinecolor,
        'fill-opacity': opts.opacity

        // no way to pass specify outline width at the moment
      });
      break;
    case 'symbol':
      var symbol = opts.symbol;
      var textOpts = convertTextOpts(symbol.textposition, symbol.iconsize);
      Lib.extendFlat(layout, {
        'icon-image': symbol.icon + '-15',
        'icon-size': symbol.iconsize / 10,
        'text-field': symbol.text,
        'text-size': symbol.textfont.size,
        'text-anchor': textOpts.anchor,
        'text-offset': textOpts.offset,
        'symbol-placement': symbol.placement

        // TODO font family
        // 'text-font': symbol.textfont.family.split(', '),
      });
      Lib.extendFlat(paint, {
        'icon-color': opts.color,
        'text-color': symbol.textfont.color,
        'text-opacity': opts.opacity
      });
      break;
    case 'raster':
      Lib.extendFlat(paint, {
        'raster-fade-duration': 0,
        'raster-opacity': opts.opacity
      });
      break;
  }
  return {
    layout: layout,
    paint: paint
  };
}
function convertSourceOpts(opts) {
  var sourceType = opts.sourcetype;
  var source = opts.source;
  var sourceOpts = {
    type: sourceType
  };
  var field;
  if (sourceType === 'geojson') {
    field = 'data';
  } else if (sourceType === 'vector') {
    field = typeof source === 'string' ? 'url' : 'tiles';
  } else if (sourceType === 'raster') {
    field = 'tiles';
    sourceOpts.tileSize = 256;
  } else if (sourceType === 'image') {
    field = 'url';
    sourceOpts.coordinates = opts.coordinates;
  }
  sourceOpts[field] = source;
  if (opts.sourceattribution) {
    sourceOpts.attribution = sanitizeHTML(opts.sourceattribution);
  }
  return sourceOpts;
}
module.exports = function createMapboxLayer(subplot, index, opts) {
  var mapboxLayer = new MapboxLayer(subplot, index);
  mapboxLayer.update(opts);
  return mapboxLayer;
};

/***/ }),

/***/ 67514:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var defaultLine = (__webpack_require__(78766).defaultLine);
var domainAttrs = (__webpack_require__(13792)/* .attributes */ .u);
var fontAttrs = __webpack_require__(80337);
var textposition = (__webpack_require__(36640).textposition);
var overrideAll = (__webpack_require__(13582).overrideAll);
var templatedArray = (__webpack_require__(78032).templatedArray);
var constants = __webpack_require__(44245);
var fontAttr = fontAttrs({
  noFontVariant: true,
  noFontShadow: true,
  noFontLineposition: true,
  noFontTextcase: true
});
fontAttr.family.dflt = 'Open Sans Regular, Arial Unicode MS Regular';
var attrs = module.exports = overrideAll({
  _arrayAttrRegexps: [Lib.counterRegex('mapbox', '.layers', true)],
  domain: domainAttrs({
    name: 'mapbox'
  }),
  accesstoken: {
    valType: 'string',
    noBlank: true,
    strict: true
  },
  style: {
    valType: 'any',
    values: constants.styleValuesMapbox.concat(constants.styleValuesNonMapbox),
    dflt: constants.styleValueDflt
  },
  center: {
    lon: {
      valType: 'number',
      dflt: 0
    },
    lat: {
      valType: 'number',
      dflt: 0
    }
  },
  zoom: {
    valType: 'number',
    dflt: 1
  },
  bearing: {
    valType: 'number',
    dflt: 0
  },
  pitch: {
    valType: 'number',
    dflt: 0
  },
  bounds: {
    west: {
      valType: 'number'
    },
    east: {
      valType: 'number'
    },
    south: {
      valType: 'number'
    },
    north: {
      valType: 'number'
    }
  },
  layers: templatedArray('layer', {
    visible: {
      valType: 'boolean',
      dflt: true
    },
    sourcetype: {
      valType: 'enumerated',
      values: ['geojson', 'vector', 'raster', 'image'],
      dflt: 'geojson'
    },
    source: {
      valType: 'any'
    },
    sourcelayer: {
      valType: 'string',
      dflt: ''
    },
    sourceattribution: {
      valType: 'string'
    },
    type: {
      valType: 'enumerated',
      values: ['circle', 'line', 'fill', 'symbol', 'raster'],
      dflt: 'circle'
    },
    coordinates: {
      valType: 'any'
    },
    // attributes shared between all types
    below: {
      valType: 'string'
    },
    color: {
      valType: 'color',
      dflt: defaultLine
    },
    opacity: {
      valType: 'number',
      min: 0,
      max: 1,
      dflt: 1
    },
    minzoom: {
      valType: 'number',
      min: 0,
      max: 24,
      dflt: 0
    },
    maxzoom: {
      valType: 'number',
      min: 0,
      max: 24,
      dflt: 24
    },
    // type-specific style attributes
    circle: {
      radius: {
        valType: 'number',
        dflt: 15
      }
    },
    line: {
      width: {
        valType: 'number',
        dflt: 2
      },
      dash: {
        valType: 'data_array'
      }
    },
    fill: {
      outlinecolor: {
        valType: 'color',
        dflt: defaultLine
      }
    },
    symbol: {
      icon: {
        valType: 'string',
        dflt: 'marker'
      },
      iconsize: {
        valType: 'number',
        dflt: 10
      },
      text: {
        valType: 'string',
        dflt: ''
      },
      placement: {
        valType: 'enumerated',
        values: ['point', 'line', 'line-center'],
        dflt: 'point'
      },
      textfont: fontAttr,
      textposition: Lib.extendFlat({}, textposition, {
        arrayOk: false
      })
    }
  })
}, 'plot', 'from-root');

// set uirevision outside of overrideAll so it can be `editType: 'none'`
attrs.uirevision = {
  valType: 'any',
  editType: 'none'
};

/***/ }),

/***/ 86989:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var handleSubplotDefaults = __webpack_require__(4448);
var handleArrayContainerDefaults = __webpack_require__(59008);
var layoutAttributes = __webpack_require__(67514);
module.exports = function supplyLayoutDefaults(layoutIn, layoutOut, fullData) {
  handleSubplotDefaults(layoutIn, layoutOut, fullData, {
    type: 'mapbox',
    attributes: layoutAttributes,
    handleDefaults: handleDefaults,
    partition: 'y',
    accessToken: layoutOut._mapboxAccessToken
  });
};
function handleDefaults(containerIn, containerOut, coerce, opts) {
  coerce('accesstoken', opts.accessToken);
  coerce('style');
  coerce('center.lon');
  coerce('center.lat');
  coerce('zoom');
  coerce('bearing');
  coerce('pitch');
  var west = coerce('bounds.west');
  var east = coerce('bounds.east');
  var south = coerce('bounds.south');
  var north = coerce('bounds.north');
  if (west === undefined || east === undefined || south === undefined || north === undefined) {
    delete containerOut.bounds;
  }
  handleArrayContainerDefaults(containerIn, containerOut, {
    name: 'layers',
    handleItemDefaults: handleLayerDefaults
  });

  // copy ref to input container to update 'center' and 'zoom' on map move
  containerOut._input = containerIn;
}
function handleLayerDefaults(layerIn, layerOut) {
  function coerce(attr, dflt) {
    return Lib.coerce(layerIn, layerOut, layoutAttributes.layers, attr, dflt);
  }
  var visible = coerce('visible');
  if (visible) {
    var sourceType = coerce('sourcetype');
    var mustBeRasterLayer = sourceType === 'raster' || sourceType === 'image';
    coerce('source');
    coerce('sourceattribution');
    if (sourceType === 'vector') {
      coerce('sourcelayer');
    }
    if (sourceType === 'image') {
      coerce('coordinates');
    }
    var typeDflt;
    if (mustBeRasterLayer) typeDflt = 'raster';
    var type = coerce('type', typeDflt);
    if (mustBeRasterLayer && type !== 'raster') {
      type = layerOut.type = 'raster';
      Lib.log('Source types *raster* and *image* must drawn *raster* layer type.');
    }
    coerce('below');
    coerce('color');
    coerce('opacity');
    coerce('minzoom');
    coerce('maxzoom');
    if (type === 'circle') {
      coerce('circle.radius');
    }
    if (type === 'line') {
      coerce('line.width');
      coerce('line.dash');
    }
    if (type === 'fill') {
      coerce('fill.outlinecolor');
    }
    if (type === 'symbol') {
      coerce('symbol.icon');
      coerce('symbol.iconsize');
      coerce('symbol.text');
      Lib.coerceFont(coerce, 'symbol.textfont', undefined, {
        noFontVariant: true,
        noFontShadow: true,
        noFontLineposition: true,
        noFontTextcase: true
      });
      coerce('symbol.textposition');
      coerce('symbol.placement');
    }
  }
}

/***/ }),

/***/ 5417:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var mapboxgl = __webpack_require__(32280);
var Lib = __webpack_require__(34809);
var geoUtils = __webpack_require__(3994);
var Registry = __webpack_require__(33626);
var Axes = __webpack_require__(29714);
var dragElement = __webpack_require__(14751);
var Fx = __webpack_require__(32141);
var dragHelpers = __webpack_require__(70414);
var drawMode = dragHelpers.drawMode;
var selectMode = dragHelpers.selectMode;
var prepSelect = (__webpack_require__(44844).prepSelect);
var clearOutline = (__webpack_require__(44844).clearOutline);
var clearSelectionsCache = (__webpack_require__(44844).clearSelectionsCache);
var selectOnClick = (__webpack_require__(44844).selectOnClick);
var constants = __webpack_require__(44245);
var createMapboxLayer = __webpack_require__(51276);
function Mapbox(gd, id) {
  this.id = id;
  this.gd = gd;
  var fullLayout = gd._fullLayout;
  var context = gd._context;
  this.container = fullLayout._glcontainer.node();
  this.isStatic = context.staticPlot;

  // unique id for this Mapbox instance
  this.uid = fullLayout._uid + '-' + this.id;

  // create framework on instantiation for a smoother first plot call
  this.div = null;
  this.xaxis = null;
  this.yaxis = null;
  this.createFramework(fullLayout);

  // state variables used to infer how and what to update
  this.map = null;
  this.accessToken = null;
  this.styleObj = null;
  this.traceHash = {};
  this.layerList = [];
  this.belowLookup = {};
  this.dragging = false;
  this.wheeling = false;
}
var proto = Mapbox.prototype;
proto.plot = function (calcData, fullLayout, promises) {
  var self = this;
  var opts = fullLayout[self.id];

  // remove map and create a new map if access token has change
  if (self.map && opts.accesstoken !== self.accessToken) {
    self.map.remove();
    self.map = null;
    self.styleObj = null;
    self.traceHash = {};
    self.layerList = [];
  }
  var promise;
  if (!self.map) {
    promise = new Promise(function (resolve, reject) {
      self.createMap(calcData, fullLayout, resolve, reject);
    });
  } else {
    promise = new Promise(function (resolve, reject) {
      self.updateMap(calcData, fullLayout, resolve, reject);
    });
  }
  promises.push(promise);
};
proto.createMap = function (calcData, fullLayout, resolve, reject) {
  var self = this;
  var opts = fullLayout[self.id];

  // store style id and URL or object
  var styleObj = self.styleObj = getStyleObj(opts.style, fullLayout);

  // store access token associated with this map
  self.accessToken = opts.accesstoken;
  var bounds = opts.bounds;
  var maxBounds = bounds ? [[bounds.west, bounds.south], [bounds.east, bounds.north]] : null;

  // create the map!
  var map = self.map = new mapboxgl.Map({
    container: self.div,
    style: styleObj.style,
    center: convertCenter(opts.center),
    zoom: opts.zoom,
    bearing: opts.bearing,
    pitch: opts.pitch,
    maxBounds: maxBounds,
    interactive: !self.isStatic,
    preserveDrawingBuffer: self.isStatic,
    doubleClickZoom: false,
    boxZoom: false,
    attributionControl: false
  }).addControl(new mapboxgl.AttributionControl({
    compact: true
  }));

  // make sure canvas does not inherit left and top css
  map._canvas.style.left = '0px';
  map._canvas.style.top = '0px';
  self.rejectOnError(reject);
  if (!self.isStatic) {
    self.initFx(calcData, fullLayout);
  }
  var promises = [];
  promises.push(new Promise(function (resolve) {
    map.once('load', resolve);
  }));
  promises = promises.concat(geoUtils.fetchTraceGeoData(calcData));
  Promise.all(promises).then(function () {
    self.fillBelowLookup(calcData, fullLayout);
    self.updateData(calcData);
    self.updateLayout(fullLayout);
    self.resolveOnRender(resolve);
  }).catch(reject);
};
proto.updateMap = function (calcData, fullLayout, resolve, reject) {
  var self = this;
  var map = self.map;
  var opts = fullLayout[this.id];
  self.rejectOnError(reject);
  var promises = [];
  var styleObj = getStyleObj(opts.style, fullLayout);
  if (JSON.stringify(self.styleObj) !== JSON.stringify(styleObj)) {
    self.styleObj = styleObj;
    map.setStyle(styleObj.style);

    // need to rebuild trace layers on reload
    // to avoid 'lost event' errors
    self.traceHash = {};
    promises.push(new Promise(function (resolve) {
      map.once('styledata', resolve);
    }));
  }
  promises = promises.concat(geoUtils.fetchTraceGeoData(calcData));
  Promise.all(promises).then(function () {
    self.fillBelowLookup(calcData, fullLayout);
    self.updateData(calcData);
    self.updateLayout(fullLayout);
    self.resolveOnRender(resolve);
  }).catch(reject);
};
proto.fillBelowLookup = function (calcData, fullLayout) {
  var opts = fullLayout[this.id];
  var layers = opts.layers;
  var i, val;
  var belowLookup = this.belowLookup = {};
  var hasTraceAtTop = false;
  for (i = 0; i < calcData.length; i++) {
    var trace = calcData[i][0].trace;
    var _module = trace._module;
    if (typeof trace.below === 'string') {
      val = trace.below;
    } else if (_module.getBelow) {
      // 'smart' default that depend the map's base layers
      val = _module.getBelow(trace, this);
    }
    if (val === '') {
      hasTraceAtTop = true;
    }
    belowLookup['trace-' + trace.uid] = val || '';
  }
  for (i = 0; i < layers.length; i++) {
    var item = layers[i];
    if (typeof item.below === 'string') {
      val = item.below;
    } else if (hasTraceAtTop) {
      // if one or more trace(s) set `below:''` and
      // layers[i].below is unset,
      // place layer below traces
      val = 'traces';
    } else {
      val = '';
    }
    belowLookup['layout-' + i] = val;
  }

  // N.B. If multiple layers have the 'below' value,
  // we must clear the stashed 'below' field in order
  // to make `traceHash[k].update()` and `layerList[i].update()`
  // remove/add the all those layers to have preserve
  // the correct layer ordering
  var val2list = {};
  var k, id;
  for (k in belowLookup) {
    val = belowLookup[k];
    if (val2list[val]) {
      val2list[val].push(k);
    } else {
      val2list[val] = [k];
    }
  }
  for (val in val2list) {
    var list = val2list[val];
    if (list.length > 1) {
      for (i = 0; i < list.length; i++) {
        k = list[i];
        if (k.indexOf('trace-') === 0) {
          id = k.split('trace-')[1];
          if (this.traceHash[id]) {
            this.traceHash[id].below = null;
          }
        } else if (k.indexOf('layout-') === 0) {
          id = k.split('layout-')[1];
          if (this.layerList[id]) {
            this.layerList[id].below = null;
          }
        }
      }
    }
  }
};
var traceType2orderIndex = {
  choroplethmapbox: 0,
  densitymapbox: 1,
  scattermapbox: 2
};
proto.updateData = function (calcData) {
  var traceHash = this.traceHash;
  var traceObj, trace, i, j;

  // Need to sort here by trace type here,
  // in case traces with different `type` have the same
  // below value, but sorting we ensure that
  // e.g. choroplethmapbox traces will be below scattermapbox traces
  var calcDataSorted = calcData.slice().sort(function (a, b) {
    return traceType2orderIndex[a[0].trace.type] - traceType2orderIndex[b[0].trace.type];
  });

  // update or create trace objects
  for (i = 0; i < calcDataSorted.length; i++) {
    var calcTrace = calcDataSorted[i];
    trace = calcTrace[0].trace;
    traceObj = traceHash[trace.uid];
    var didUpdate = false;
    if (traceObj) {
      if (traceObj.type === trace.type) {
        traceObj.update(calcTrace);
        didUpdate = true;
      } else {
        traceObj.dispose();
      }
    }
    if (!didUpdate && trace._module) {
      traceHash[trace.uid] = trace._module.plot(this, calcTrace);
    }
  }

  // remove empty trace objects
  var ids = Object.keys(traceHash);
  idLoop: for (i = 0; i < ids.length; i++) {
    var id = ids[i];
    for (j = 0; j < calcData.length; j++) {
      trace = calcData[j][0].trace;
      if (id === trace.uid) continue idLoop;
    }
    traceObj = traceHash[id];
    traceObj.dispose();
    delete traceHash[id];
  }
};
proto.updateLayout = function (fullLayout) {
  var map = this.map;
  var opts = fullLayout[this.id];
  if (!this.dragging && !this.wheeling) {
    map.setCenter(convertCenter(opts.center));
    map.setZoom(opts.zoom);
    map.setBearing(opts.bearing);
    map.setPitch(opts.pitch);
  }
  this.updateLayers(fullLayout);
  this.updateFramework(fullLayout);
  this.updateFx(fullLayout);
  this.map.resize();
  if (this.gd._context._scrollZoom.mapbox) {
    map.scrollZoom.enable();
  } else {
    map.scrollZoom.disable();
  }
};
proto.resolveOnRender = function (resolve) {
  var map = this.map;
  map.on('render', function onRender() {
    if (map.loaded()) {
      map.off('render', onRender);
      // resolve at end of render loop
      //
      // Need a 10ms delay (0ms should suffice to skip a thread in the
      // render loop) to workaround mapbox-gl bug introduced in v1.3.0
      setTimeout(resolve, 10);
    }
  });
};
proto.rejectOnError = function (reject) {
  var map = this.map;
  function handler() {
    reject(new Error(constants.mapOnErrorMsg));
  }
  map.once('error', handler);
  map.once('style.error', handler);
  map.once('source.error', handler);
  map.once('tile.error', handler);
  map.once('layer.error', handler);
};
proto.createFramework = function (fullLayout) {
  var self = this;
  var div = self.div = document.createElement('div');
  div.id = self.uid;
  div.style.position = 'absolute';
  self.container.appendChild(div);

  // create mock x/y axes for hover routine
  self.xaxis = {
    _id: 'x',
    c2p: function (v) {
      return self.project(v).x;
    }
  };
  self.yaxis = {
    _id: 'y',
    c2p: function (v) {
      return self.project(v).y;
    }
  };
  self.updateFramework(fullLayout);

  // mock axis for hover formatting
  self.mockAxis = {
    type: 'linear',
    showexponent: 'all',
    exponentformat: 'B'
  };
  Axes.setConvert(self.mockAxis, fullLayout);
};
proto.initFx = function (calcData, fullLayout) {
  var self = this;
  var gd = self.gd;
  var map = self.map;

  // keep track of pan / zoom in user layout and emit relayout event
  map.on('moveend', function (evt) {
    if (!self.map) return;
    var fullLayoutNow = gd._fullLayout;

    // 'moveend' gets triggered by map.setCenter, map.setZoom,
    // map.setBearing and map.setPitch.
    //
    // Here, we make sure that state updates amd 'plotly_relayout'
    // are triggered only when the 'moveend' originates from a
    // mouse target (filtering out API calls) to not
    // duplicate 'plotly_relayout' events.

    if (evt.originalEvent || self.wheeling) {
      var optsNow = fullLayoutNow[self.id];
      Registry.call('_storeDirectGUIEdit', gd.layout, fullLayoutNow._preGUI, self.getViewEdits(optsNow));
      var viewNow = self.getView();
      optsNow._input.center = optsNow.center = viewNow.center;
      optsNow._input.zoom = optsNow.zoom = viewNow.zoom;
      optsNow._input.bearing = optsNow.bearing = viewNow.bearing;
      optsNow._input.pitch = optsNow.pitch = viewNow.pitch;
      gd.emit('plotly_relayout', self.getViewEditsWithDerived(viewNow));
    }
    if (evt.originalEvent && evt.originalEvent.type === 'mouseup') {
      self.dragging = false;
    } else if (self.wheeling) {
      self.wheeling = false;
    }
    if (fullLayoutNow._rehover) {
      fullLayoutNow._rehover();
    }
  });
  map.on('wheel', function () {
    self.wheeling = true;
  });
  map.on('mousemove', function (evt) {
    var bb = self.div.getBoundingClientRect();
    var xy = [evt.originalEvent.offsetX, evt.originalEvent.offsetY];
    evt.target.getBoundingClientRect = function () {
      return bb;
    };
    self.xaxis.p2c = function () {
      return map.unproject(xy).lng;
    };
    self.yaxis.p2c = function () {
      return map.unproject(xy).lat;
    };
    gd._fullLayout._rehover = function () {
      if (gd._fullLayout._hoversubplot === self.id && gd._fullLayout[self.id]) {
        Fx.hover(gd, evt, self.id);
      }
    };
    Fx.hover(gd, evt, self.id);
    gd._fullLayout._hoversubplot = self.id;
  });
  function unhover() {
    Fx.loneUnhover(fullLayout._hoverlayer);
  }
  map.on('dragstart', function () {
    self.dragging = true;
    unhover();
  });
  map.on('zoomstart', unhover);
  map.on('mouseout', function () {
    gd._fullLayout._hoversubplot = null;
  });
  function emitUpdate() {
    var viewNow = self.getView();
    gd.emit('plotly_relayouting', self.getViewEditsWithDerived(viewNow));
  }
  map.on('drag', emitUpdate);
  map.on('zoom', emitUpdate);
  map.on('dblclick', function () {
    var optsNow = gd._fullLayout[self.id];
    Registry.call('_storeDirectGUIEdit', gd.layout, gd._fullLayout._preGUI, self.getViewEdits(optsNow));
    var viewInitial = self.viewInitial;
    map.setCenter(convertCenter(viewInitial.center));
    map.setZoom(viewInitial.zoom);
    map.setBearing(viewInitial.bearing);
    map.setPitch(viewInitial.pitch);
    var viewNow = self.getView();
    optsNow._input.center = optsNow.center = viewNow.center;
    optsNow._input.zoom = optsNow.zoom = viewNow.zoom;
    optsNow._input.bearing = optsNow.bearing = viewNow.bearing;
    optsNow._input.pitch = optsNow.pitch = viewNow.pitch;
    gd.emit('plotly_doubleclick', null);
    gd.emit('plotly_relayout', self.getViewEditsWithDerived(viewNow));
  });

  // define event handlers on map creation, to keep one ref per map,
  // so that map.on / map.off in updateFx works as expected
  self.clearOutline = function () {
    clearSelectionsCache(self.dragOptions);
    clearOutline(self.dragOptions.gd);
  };

  /**
   * Returns a click handler function that is supposed
   * to handle clicks in pan mode.
   */
  self.onClickInPanFn = function (dragOptions) {
    return function (evt) {
      var clickMode = gd._fullLayout.clickmode;
      if (clickMode.indexOf('select') > -1) {
        selectOnClick(evt.originalEvent, gd, [self.xaxis], [self.yaxis], self.id, dragOptions);
      }
      if (clickMode.indexOf('event') > -1) {
        // TODO: this does not support right-click. If we want to support it, we
        // would likely need to change mapbox to use dragElement instead of straight
        // mapbox event binding. Or perhaps better, make a simple wrapper with the
        // right mousedown, mousemove, and mouseup handlers just for a left/right click
        // pie would use this too.
        Fx.click(gd, evt.originalEvent);
      }
    };
  };
};
proto.updateFx = function (fullLayout) {
  var self = this;
  var map = self.map;
  var gd = self.gd;
  if (self.isStatic) return;
  function invert(pxpy) {
    var obj = self.map.unproject(pxpy);
    return [obj.lng, obj.lat];
  }
  var dragMode = fullLayout.dragmode;
  var fillRangeItems;
  fillRangeItems = function (eventData, poly) {
    if (poly.isRect) {
      var ranges = eventData.range = {};
      ranges[self.id] = [invert([poly.xmin, poly.ymin]), invert([poly.xmax, poly.ymax])];
    } else {
      var dataPts = eventData.lassoPoints = {};
      dataPts[self.id] = poly.map(invert);
    }
  };

  // Note: dragOptions is needed to be declared for all dragmodes because
  // it's the object that holds persistent selection state.
  // Merge old dragOptions with new to keep possibly initialized
  // persistent selection state.
  var oldDragOptions = self.dragOptions;
  self.dragOptions = Lib.extendDeep(oldDragOptions || {}, {
    dragmode: fullLayout.dragmode,
    element: self.div,
    gd: gd,
    plotinfo: {
      id: self.id,
      domain: fullLayout[self.id].domain,
      xaxis: self.xaxis,
      yaxis: self.yaxis,
      fillRangeItems: fillRangeItems
    },
    xaxes: [self.xaxis],
    yaxes: [self.yaxis],
    subplot: self.id
  });

  // Unregister the old handler before potentially registering
  // a new one. Otherwise multiple click handlers might
  // be registered resulting in unwanted behavior.
  map.off('click', self.onClickInPanHandler);
  if (selectMode(dragMode) || drawMode(dragMode)) {
    map.dragPan.disable();
    map.on('zoomstart', self.clearOutline);
    self.dragOptions.prepFn = function (e, startX, startY) {
      prepSelect(e, startX, startY, self.dragOptions, dragMode);
    };
    dragElement.init(self.dragOptions);
  } else {
    map.dragPan.enable();
    map.off('zoomstart', self.clearOutline);
    self.div.onmousedown = null;
    self.div.ontouchstart = null;
    self.div.removeEventListener('touchstart', self.div._ontouchstart);
    // TODO: this does not support right-click. If we want to support it, we
    // would likely need to change mapbox to use dragElement instead of straight
    // mapbox event binding. Or perhaps better, make a simple wrapper with the
    // right mousedown, mousemove, and mouseup handlers just for a left/right click
    // pie would use this too.
    self.onClickInPanHandler = self.onClickInPanFn(self.dragOptions);
    map.on('click', self.onClickInPanHandler);
  }
};
proto.updateFramework = function (fullLayout) {
  var domain = fullLayout[this.id].domain;
  var size = fullLayout._size;
  var style = this.div.style;
  style.width = size.w * (domain.x[1] - domain.x[0]) + 'px';
  style.height = size.h * (domain.y[1] - domain.y[0]) + 'px';
  style.left = size.l + domain.x[0] * size.w + 'px';
  style.top = size.t + (1 - domain.y[1]) * size.h + 'px';
  this.xaxis._offset = size.l + domain.x[0] * size.w;
  this.xaxis._length = size.w * (domain.x[1] - domain.x[0]);
  this.yaxis._offset = size.t + (1 - domain.y[1]) * size.h;
  this.yaxis._length = size.h * (domain.y[1] - domain.y[0]);
};
proto.updateLayers = function (fullLayout) {
  var opts = fullLayout[this.id];
  var layers = opts.layers;
  var layerList = this.layerList;
  var i;

  // if the layer arrays don't match,
  // don't try to be smart,
  // delete them all, and start all over.

  if (layers.length !== layerList.length) {
    for (i = 0; i < layerList.length; i++) {
      layerList[i].dispose();
    }
    layerList = this.layerList = [];
    for (i = 0; i < layers.length; i++) {
      layerList.push(createMapboxLayer(this, i, layers[i]));
    }
  } else {
    for (i = 0; i < layers.length; i++) {
      layerList[i].update(layers[i]);
    }
  }
};
proto.destroy = function () {
  if (this.map) {
    this.map.remove();
    this.map = null;
    this.container.removeChild(this.div);
  }
};
proto.toImage = function () {
  this.map.stop();
  return this.map.getCanvas().toDataURL();
};

// convenience wrapper to create set multiple layer
// 'layout' or 'paint options at once.
proto.setOptions = function (id, methodName, opts) {
  for (var k in opts) {
    this.map[methodName](id, k, opts[k]);
  }
};
proto.getMapLayers = function () {
  return this.map.getStyle().layers;
};

// convenience wrapper that first check in 'below' references
// a layer that exist and then add the layer to the map,
proto.addLayer = function (opts, below) {
  var map = this.map;
  if (typeof below === 'string') {
    if (below === '') {
      map.addLayer(opts, below);
      return;
    }
    var mapLayers = this.getMapLayers();
    for (var i = 0; i < mapLayers.length; i++) {
      if (below === mapLayers[i].id) {
        map.addLayer(opts, below);
        return;
      }
    }
    Lib.warn(['Trying to add layer with *below* value', below, 'referencing a layer that does not exist', 'or that does not yet exist.'].join(' '));
  }
  map.addLayer(opts);
};

// convenience method to project a [lon, lat] array to pixel coords
proto.project = function (v) {
  return this.map.project(new mapboxgl.LngLat(v[0], v[1]));
};

// get map's current view values in plotly.js notation
proto.getView = function () {
  var map = this.map;
  var mapCenter = map.getCenter();
  var lon = mapCenter.lng;
  var lat = mapCenter.lat;
  var center = {
    lon: lon,
    lat: lat
  };
  var canvas = map.getCanvas();
  var w = parseInt(canvas.style.width);
  var h = parseInt(canvas.style.height);
  return {
    center: center,
    zoom: map.getZoom(),
    bearing: map.getBearing(),
    pitch: map.getPitch(),
    _derived: {
      coordinates: [map.unproject([0, 0]).toArray(), map.unproject([w, 0]).toArray(), map.unproject([w, h]).toArray(), map.unproject([0, h]).toArray()]
    }
  };
};
proto.getViewEdits = function (cont) {
  var id = this.id;
  var keys = ['center', 'zoom', 'bearing', 'pitch'];
  var obj = {};
  for (var i = 0; i < keys.length; i++) {
    var k = keys[i];
    obj[id + '.' + k] = cont[k];
  }
  return obj;
};
proto.getViewEditsWithDerived = function (cont) {
  var id = this.id;
  var obj = this.getViewEdits(cont);
  obj[id + '._derived'] = cont._derived;
  return obj;
};
function getStyleObj(val, fullLayout) {
  var styleObj = {};
  if (Lib.isPlainObject(val)) {
    styleObj.id = val.id;
    styleObj.style = val;
  } else if (typeof val === 'string') {
    styleObj.id = val;
    if (constants.styleValuesMapbox.indexOf(val) !== -1) {
      styleObj.style = convertStyleVal(val);
    } else if (constants.stylesNonMapbox[val]) {
      styleObj.style = constants.stylesNonMapbox[val];
      var spec = styleObj.style.sources['plotly-' + val];
      var tiles = spec ? spec.tiles : undefined;
      if (tiles && tiles[0] && tiles[0].slice(-9) === '?api_key=') {
        // provide api_key for stamen styles
        tiles[0] += fullLayout._mapboxAccessToken;
      }
    } else {
      styleObj.style = val;
    }
  } else {
    styleObj.id = constants.styleValueDflt;
    styleObj.style = convertStyleVal(constants.styleValueDflt);
  }
  styleObj.transition = {
    duration: 0,
    delay: 0
  };
  return styleObj;
}

// if style is part of the 'official' mapbox values, add URL prefix and suffix
function convertStyleVal(val) {
  return constants.styleUrlPrefix + val + '-' + constants.styleUrlSuffix;
}
function convertCenter(center) {
  return [center.lon, center.lat];
}
module.exports = Mapbox;

/***/ }),

/***/ 57891:
/***/ (function(module) {

"use strict";


/**
 * Creates a set of padding attributes.
 *
 * @param {object} opts
 *   @param {string} editType:
 *     the editType for all pieces of this padding definition
 *
 * @return {object} attributes object containing {t, r, b, l} as specified
 */
module.exports = function (opts) {
  var editType = opts.editType;
  return {
    t: {
      valType: 'number',
      dflt: 0,
      editType: editType
    },
    r: {
      valType: 'number',
      dflt: 0,
      editType: editType
    },
    b: {
      valType: 'number',
      dflt: 0,
      editType: editType
    },
    l: {
      valType: 'number',
      dflt: 0,
      editType: editType
    },
    editType: editType
  };
};

/***/ }),

/***/ 44122:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var timeFormatLocale = (__webpack_require__(42696)/* .timeFormatLocale */ .de);
var formatLocale = (__webpack_require__(36464)/* .formatLocale */ .OE);
var isNumeric = __webpack_require__(10721);
var b64encode = __webpack_require__(93229);
var Registry = __webpack_require__(33626);
var PlotSchema = __webpack_require__(57297);
var Template = __webpack_require__(78032);
var Lib = __webpack_require__(34809);
var Color = __webpack_require__(78766);
var BADNUM = (__webpack_require__(63821).BADNUM);
var axisIDs = __webpack_require__(5975);
var clearOutline = (__webpack_require__(78534).clearOutline);
var scatterAttrs = __webpack_require__(26667);
var animationAttrs = __webpack_require__(49722);
var frameAttrs = __webpack_require__(58935);
var getModuleCalcData = (__webpack_require__(4173)/* .getModuleCalcData */ .eV);
var relinkPrivateKeys = Lib.relinkPrivateKeys;
var _ = Lib._;
var plots = module.exports = {};

// Expose registry methods on Plots for backward-compatibility
Lib.extendFlat(plots, Registry);
plots.attributes = __webpack_require__(9829);
plots.attributes.type.values = plots.allTypes;
plots.fontAttrs = __webpack_require__(80337);
plots.layoutAttributes = __webpack_require__(6704);
var transformsRegistry = plots.transformsRegistry;
var commandModule = __webpack_require__(90251);
plots.executeAPICommand = commandModule.executeAPICommand;
plots.computeAPICommandBindings = commandModule.computeAPICommandBindings;
plots.manageCommandObserver = commandModule.manageCommandObserver;
plots.hasSimpleAPICommandBindings = commandModule.hasSimpleAPICommandBindings;

// in some cases the browser doesn't seem to know how big
// the text is at first, so it needs to draw it,
// then wait a little, then draw it again
plots.redrawText = function (gd) {
  gd = Lib.getGraphDiv(gd);
  return new Promise(function (resolve) {
    setTimeout(function () {
      if (!gd._fullLayout) return;
      Registry.getComponentMethod('annotations', 'draw')(gd);
      Registry.getComponentMethod('legend', 'draw')(gd);
      Registry.getComponentMethod('colorbar', 'draw')(gd);
      resolve(plots.previousPromises(gd));
    }, 300);
  });
};

// resize plot about the container size
plots.resize = function (gd) {
  gd = Lib.getGraphDiv(gd);
  var resolveLastResize;
  var p = new Promise(function (resolve, reject) {
    if (!gd || Lib.isHidden(gd)) {
      reject(new Error('Resize must be passed a displayed plot div element.'));
    }
    if (gd._redrawTimer) clearTimeout(gd._redrawTimer);
    if (gd._resolveResize) resolveLastResize = gd._resolveResize;
    gd._resolveResize = resolve;
    gd._redrawTimer = setTimeout(function () {
      // return if there is nothing to resize or is hidden
      if (!gd.layout || gd.layout.width && gd.layout.height || Lib.isHidden(gd)) {
        resolve(gd);
        return;
      }
      delete gd.layout.width;
      delete gd.layout.height;

      // autosizing doesn't count as a change that needs saving
      var oldchanged = gd.changed;

      // nor should it be included in the undo queue
      gd.autoplay = true;
      Registry.call('relayout', gd, {
        autosize: true
      }).then(function () {
        gd.changed = oldchanged;
        // Only resolve if a new call hasn't been made!
        if (gd._resolveResize === resolve) {
          delete gd._resolveResize;
          resolve(gd);
        }
      });
    }, 100);
  });
  if (resolveLastResize) resolveLastResize(p);
  return p;
};

// for use in Lib.syncOrAsync, check if there are any
// pending promises in this plot and wait for them
plots.previousPromises = function (gd) {
  if ((gd._promises || []).length) {
    return Promise.all(gd._promises).then(function () {
      gd._promises = [];
    });
  }
};

/**
 * Adds the 'Edit chart' link.
 * Note that now _doPlot calls this so it can regenerate whenever it replots
 *
 * Add source links to your graph inside the 'showSources' config argument.
 */
plots.addLinks = function (gd) {
  // Do not do anything if showLink and showSources are not set to true in config
  if (!gd._context.showLink && !gd._context.showSources) return;
  var fullLayout = gd._fullLayout;
  var linkContainer = Lib.ensureSingle(fullLayout._paper, 'text', 'js-plot-link-container', function (s) {
    s.style({
      'font-family': '"Open Sans", Arial, sans-serif',
      'font-size': '12px',
      fill: Color.defaultLine,
      'pointer-events': 'all'
    }).each(function () {
      var links = d3.select(this);
      links.append('tspan').classed('js-link-to-tool', true);
      links.append('tspan').classed('js-link-spacer', true);
      links.append('tspan').classed('js-sourcelinks', true);
    });
  });

  // The text node inside svg
  var text = linkContainer.node();
  var attrs = {
    y: fullLayout._paper.attr('height') - 9
  };

  // If text's width is bigger than the layout
  // Check that text is a child node or document.body
  // because otherwise IE/Edge might throw an exception
  // when calling getComputedTextLength().
  // Apparently offsetParent is null for invisibles.
  if (document.body.contains(text) && text.getComputedTextLength() >= fullLayout.width - 20) {
    // Align the text at the left
    attrs['text-anchor'] = 'start';
    attrs.x = 5;
  } else {
    // Align the text at the right
    attrs['text-anchor'] = 'end';
    attrs.x = fullLayout._paper.attr('width') - 7;
  }
  linkContainer.attr(attrs);
  var toolspan = linkContainer.select('.js-link-to-tool');
  var spacespan = linkContainer.select('.js-link-spacer');
  var sourcespan = linkContainer.select('.js-sourcelinks');
  if (gd._context.showSources) gd._context.showSources(gd);

  // 'view in plotly' link for embedded plots
  if (gd._context.showLink) positionPlayWithData(gd, toolspan);

  // separator if we have both sources and tool link
  spacespan.text(toolspan.text() && sourcespan.text() ? ' - ' : '');
};

// note that now this function is only adding the brand in
// iframes and 3rd-party apps
function positionPlayWithData(gd, container) {
  container.text('');
  var link = container.append('a').attr({
    'xlink:xlink:href': '#',
    class: 'link--impt link--embedview',
    'font-weight': 'bold'
  }).text(gd._context.linkText + ' ' + String.fromCharCode(187));
  if (gd._context.sendData) {
    link.on('click', function () {
      plots.sendDataToCloud(gd);
    });
  } else {
    var path = window.location.pathname.split('/');
    var query = window.location.search;
    link.attr({
      'xlink:xlink:show': 'new',
      'xlink:xlink:href': '/' + path[2].split('.')[0] + '/' + path[1] + query
    });
  }
}
plots.sendDataToCloud = function (gd) {
  var baseUrl = (window.PLOTLYENV || {}).BASE_URL || gd._context.plotlyServerURL;
  if (!baseUrl) return;
  gd.emit('plotly_beforeexport');
  var hiddenformDiv = d3.select(gd).append('div').attr('id', 'hiddenform').style('display', 'none');
  var hiddenform = hiddenformDiv.append('form').attr({
    action: baseUrl + '/external',
    method: 'post',
    target: '_blank'
  });
  var hiddenformInput = hiddenform.append('input').attr({
    type: 'text',
    name: 'data'
  });
  hiddenformInput.node().value = plots.graphJson(gd, false, 'keepdata');
  hiddenform.node().submit();
  hiddenformDiv.remove();
  gd.emit('plotly_afterexport');
  return false;
};
var d3FormatKeys = ['days', 'shortDays', 'months', 'shortMonths', 'periods', 'dateTime', 'date', 'time', 'decimal', 'thousands', 'grouping', 'currency'];
var extraFormatKeys = ['year', 'month', 'dayMonth', 'dayMonthYear'];

/*
 * Fill in default values
 * @param {DOM element} gd
 * @param {object} opts
 * @param {boolean} opts.skipUpdateCalc: normally if the existing gd.calcdata looks
 *   compatible with the new gd._fullData we finish by linking the new _fullData traces
 *   to the old gd.calcdata, so it's correctly set if we're not going to recalc. But also,
 *   if there are calcTransforms on the trace, we first remap data arrays from the old full
 *   trace into the new one. Use skipUpdateCalc to defer this (needed by Plotly.react)
 *
 * gd.data, gd.layout:
 *   are precisely what the user specified (except as modified by cleanData/cleanLayout),
 *   these fields shouldn't be modified (except for filling in some auto values)
 *   nor used directly after the supply defaults step.
 *
 * gd._fullData, gd._fullLayout:
 *   are complete descriptions of how to draw the plot,
 *   use these fields in all required computations.
 *
 * gd._fullLayout._modules
 *   is a list of all the trace modules required to draw the plot.
 *
 * gd._fullLayout._visibleModules
 *   subset of _modules, a list of modules corresponding to visible:true traces.
 *
 * gd._fullLayout._basePlotModules
 *   is a list of all the plot modules required to draw the plot.
 *
 * gd._fullLayout._transformModules
 *   is a list of all the transform modules invoked.
 *
 */
plots.supplyDefaults = function (gd, opts) {
  var skipUpdateCalc = opts && opts.skipUpdateCalc;
  var oldFullLayout = gd._fullLayout || {};
  if (oldFullLayout._skipDefaults) {
    delete oldFullLayout._skipDefaults;
    return;
  }
  var newFullLayout = gd._fullLayout = {};
  var newLayout = gd.layout || {};
  var oldFullData = gd._fullData || [];
  var newFullData = gd._fullData = [];
  var newData = gd.data || [];
  var oldCalcdata = gd.calcdata || [];
  var context = gd._context || {};
  var i;

  // Create all the storage space for frames, but only if doesn't already exist
  if (!gd._transitionData) plots.createTransitionData(gd);

  // So we only need to do this once (and since we have gd here)
  // get the translated placeholder titles.
  // These ones get used as default values so need to be known at supplyDefaults
  // others keep their blank defaults but render the placeholder as desired later
  // TODO: make these work the same way, only inserting the placeholder text at draw time?
  // The challenge is that this has slightly different behavior right now in editable mode:
  // using the placeholder as default makes this text permanently (but lightly) visible,
  // but explicit '' for these titles gives you a placeholder that's hidden until you mouse
  // over it - so you're not distracted by it if you really don't want a title, but if you do
  // and you're new to plotly you may not be able to find it.
  // When editable=false the two behave the same, no title is drawn.
  newFullLayout._dfltTitle = {
    plot: _(gd, 'Click to enter Plot title'),
    subtitle: _(gd, 'Click to enter Plot subtitle'),
    x: _(gd, 'Click to enter X axis title'),
    y: _(gd, 'Click to enter Y axis title'),
    colorbar: _(gd, 'Click to enter Colorscale title'),
    annotation: _(gd, 'new text')
  };
  newFullLayout._traceWord = _(gd, 'trace');
  var formatObj = getFormatObj(gd, d3FormatKeys);

  // stash the token from context so mapbox subplots can use it as default
  newFullLayout._mapboxAccessToken = context.mapboxAccessToken;

  // first fill in what we can of layout without looking at data
  // because fullData needs a few things from layout
  if (oldFullLayout._initialAutoSizeIsDone) {
    // coerce the updated layout while preserving width and height
    var oldWidth = oldFullLayout.width;
    var oldHeight = oldFullLayout.height;
    plots.supplyLayoutGlobalDefaults(newLayout, newFullLayout, formatObj);
    if (!newLayout.width) newFullLayout.width = oldWidth;
    if (!newLayout.height) newFullLayout.height = oldHeight;
    plots.sanitizeMargins(newFullLayout);
  } else {
    // coerce the updated layout and autosize if needed
    plots.supplyLayoutGlobalDefaults(newLayout, newFullLayout, formatObj);
    var missingWidthOrHeight = !newLayout.width || !newLayout.height;
    var autosize = newFullLayout.autosize;
    var autosizable = context.autosizable;
    var initialAutoSize = missingWidthOrHeight && (autosize || autosizable);
    if (initialAutoSize) plots.plotAutoSize(gd, newLayout, newFullLayout);else if (missingWidthOrHeight) plots.sanitizeMargins(newFullLayout);

    // for backwards-compatibility with Plotly v1.x.x
    if (!autosize && missingWidthOrHeight) {
      newLayout.width = newFullLayout.width;
      newLayout.height = newFullLayout.height;
    }
  }
  newFullLayout._d3locale = getFormatter(formatObj, newFullLayout.separators);
  newFullLayout._extraFormat = getFormatObj(gd, extraFormatKeys);
  newFullLayout._initialAutoSizeIsDone = true;

  // keep track of how many traces are inputted
  newFullLayout._dataLength = newData.length;

  // clear the lists of trace and baseplot modules, and subplots
  newFullLayout._modules = [];
  newFullLayout._visibleModules = [];
  newFullLayout._basePlotModules = [];
  var subplots = newFullLayout._subplots = emptySubplotLists();

  // initialize axis and subplot hash objects for splom-generated grids
  var splomAxes = newFullLayout._splomAxes = {
    x: {},
    y: {}
  };
  var splomSubplots = newFullLayout._splomSubplots = {};
  // initialize splom grid defaults
  newFullLayout._splomGridDflt = {};

  // for stacked area traces to share config across traces
  newFullLayout._scatterStackOpts = {};
  // for the first scatter trace on each subplot (so it knows tonext->tozero)
  newFullLayout._firstScatter = {};
  // for grouped bar/box/violin trace to share config across traces
  newFullLayout._alignmentOpts = {};
  // track color axes referenced in the data
  newFullLayout._colorAxes = {};

  // for traces to request a default rangeslider on their x axes
  // eg set `_requestRangeslider.x2 = true` for xaxis2
  newFullLayout._requestRangeslider = {};

  // pull uids from old data to use as new defaults
  newFullLayout._traceUids = getTraceUids(oldFullData, newData);

  // then do the data
  newFullLayout._globalTransforms = (gd._context || {}).globalTransforms;
  plots.supplyDataDefaults(newData, newFullData, newLayout, newFullLayout);

  // redo grid size defaults with info about splom x/y axes,
  // and fill in generated cartesian axes and subplots
  var splomXa = Object.keys(splomAxes.x);
  var splomYa = Object.keys(splomAxes.y);
  if (splomXa.length > 1 && splomYa.length > 1) {
    Registry.getComponentMethod('grid', 'sizeDefaults')(newLayout, newFullLayout);
    for (i = 0; i < splomXa.length; i++) {
      Lib.pushUnique(subplots.xaxis, splomXa[i]);
    }
    for (i = 0; i < splomYa.length; i++) {
      Lib.pushUnique(subplots.yaxis, splomYa[i]);
    }
    for (var k in splomSubplots) {
      Lib.pushUnique(subplots.cartesian, k);
    }
  }

  // attach helper method to check whether a plot type is present on graph
  newFullLayout._has = plots._hasPlotType.bind(newFullLayout);
  if (oldFullData.length === newFullData.length) {
    for (i = 0; i < newFullData.length; i++) {
      relinkPrivateKeys(newFullData[i], oldFullData[i]);
    }
  }

  // finally, fill in the pieces of layout that may need to look at data
  plots.supplyLayoutModuleDefaults(newLayout, newFullLayout, newFullData, gd._transitionData);

  // Special cases that introduce interactions between traces.
  // This is after relinkPrivateKeys so we can use those in crossTraceDefaults
  // and after layout module defaults, so we can use eg barmode
  var _modules = newFullLayout._visibleModules;
  var crossTraceDefaultsFuncs = [];
  for (i = 0; i < _modules.length; i++) {
    var funci = _modules[i].crossTraceDefaults;
    // some trace types share crossTraceDefaults (ie histogram2d, histogram2dcontour)
    if (funci) Lib.pushUnique(crossTraceDefaultsFuncs, funci);
  }
  for (i = 0; i < crossTraceDefaultsFuncs.length; i++) {
    crossTraceDefaultsFuncs[i](newFullData, newFullLayout);
  }

  // turn on flag to optimize large splom-only graphs
  // mostly by omitting SVG layers during Cartesian.drawFramework
  newFullLayout._hasOnlyLargeSploms = newFullLayout._basePlotModules.length === 1 && newFullLayout._basePlotModules[0].name === 'splom' && splomXa.length > 15 && splomYa.length > 15 && newFullLayout.shapes.length === 0 && newFullLayout.images.length === 0;

  // relink / initialize subplot axis objects
  plots.linkSubplots(newFullData, newFullLayout, oldFullData, oldFullLayout);

  // clean subplots and other artifacts from previous plot calls
  plots.cleanPlot(newFullData, newFullLayout, oldFullData, oldFullLayout);
  var hadGL2D = !!(oldFullLayout._has && oldFullLayout._has('gl2d'));
  var hasGL2D = !!(newFullLayout._has && newFullLayout._has('gl2d'));
  var hadCartesian = !!(oldFullLayout._has && oldFullLayout._has('cartesian'));
  var hasCartesian = !!(newFullLayout._has && newFullLayout._has('cartesian'));
  var hadBgLayer = hadCartesian || hadGL2D;
  var hasBgLayer = hasCartesian || hasGL2D;
  if (hadBgLayer && !hasBgLayer) {
    // remove bgLayer
    oldFullLayout._bgLayer.remove();
  } else if (hasBgLayer && !hadBgLayer) {
    // create bgLayer
    newFullLayout._shouldCreateBgLayer = true;
  }

  // clear selection outline until we implement persistent selection,
  // don't clear them though when drag handlers (e.g. listening to
  // `plotly_selecting`) update the graph.
  // we should try to come up with a better solution when implementing
  // https://github.com/plotly/plotly.js/issues/1851
  if (oldFullLayout._zoomlayer && !gd._dragging) {
    clearOutline({
      // mock old gd
      _fullLayout: oldFullLayout
    });
  }

  // fill in meta helpers
  fillMetaTextHelpers(newFullData, newFullLayout);

  // relink functions and _ attributes to promote consistency between plots
  relinkPrivateKeys(newFullLayout, oldFullLayout);

  // colorscale crossTraceDefaults needs newFullLayout with relinked keys
  Registry.getComponentMethod('colorscale', 'crossTraceDefaults')(newFullData, newFullLayout);

  // For persisting GUI-driven changes in layout
  // _preGUI and _tracePreGUI were already copied over in relinkPrivateKeys
  if (!newFullLayout._preGUI) newFullLayout._preGUI = {};
  // track trace GUI changes by uid rather than by trace index
  if (!newFullLayout._tracePreGUI) newFullLayout._tracePreGUI = {};
  var tracePreGUI = newFullLayout._tracePreGUI;
  var uids = {};
  var uid;
  for (uid in tracePreGUI) uids[uid] = 'old';
  for (i = 0; i < newFullData.length; i++) {
    uid = newFullData[i]._fullInput.uid;
    if (!uids[uid]) tracePreGUI[uid] = {};
    uids[uid] = 'new';
  }
  for (uid in uids) {
    if (uids[uid] === 'old') delete tracePreGUI[uid];
  }

  // set up containers for margin calculations
  initMargins(newFullLayout);

  // collect and do some initial calculations for rangesliders
  Registry.getComponentMethod('rangeslider', 'makeData')(newFullLayout);

  // update object references in calcdata
  if (!skipUpdateCalc && oldCalcdata.length === newFullData.length) {
    plots.supplyDefaultsUpdateCalc(oldCalcdata, newFullData);
  }
};
plots.supplyDefaultsUpdateCalc = function (oldCalcdata, newFullData) {
  for (var i = 0; i < newFullData.length; i++) {
    var newTrace = newFullData[i];
    var cd0 = (oldCalcdata[i] || [])[0];
    if (cd0 && cd0.trace) {
      var oldTrace = cd0.trace;
      if (oldTrace._hasCalcTransform) {
        var arrayAttrs = oldTrace._arrayAttrs;
        var j, astr, oldArrayVal;
        for (j = 0; j < arrayAttrs.length; j++) {
          astr = arrayAttrs[j];
          oldArrayVal = Lib.nestedProperty(oldTrace, astr).get().slice();
          Lib.nestedProperty(newTrace, astr).set(oldArrayVal);
        }
      }
      cd0.trace = newTrace;
    }
  }
};

/**
 * Create a list of uid strings satisfying (in this order of importance):
 * 1. all unique, all strings
 * 2. matches input uids if provided
 * 3. matches previous data uids
 */
function getTraceUids(oldFullData, newData) {
  var len = newData.length;
  var oldFullInput = [];
  var i, prevFullInput;
  for (i = 0; i < oldFullData.length; i++) {
    var thisFullInput = oldFullData[i]._fullInput;
    if (thisFullInput !== prevFullInput) oldFullInput.push(thisFullInput);
    prevFullInput = thisFullInput;
  }
  var oldLen = oldFullInput.length;
  var out = new Array(len);
  var seenUids = {};
  function setUid(uid, i) {
    out[i] = uid;
    seenUids[uid] = 1;
  }
  function tryUid(uid, i) {
    if (uid && typeof uid === 'string' && !seenUids[uid]) {
      setUid(uid, i);
      return true;
    }
  }
  for (i = 0; i < len; i++) {
    var newUid = newData[i].uid;
    if (typeof newUid === 'number') newUid = String(newUid);
    if (tryUid(newUid, i)) continue;
    if (i < oldLen && tryUid(oldFullInput[i].uid, i)) continue;
    setUid(Lib.randstr(seenUids), i);
  }
  return out;
}

/**
 * Make a container for collecting subplots we need to display.
 *
 * Finds all subplot types we need to enumerate once and caches it,
 * but makes a new output object each time.
 * Single-trace subplots (which have no `id`) such as pie, table, etc
 * do not need to be collected because we just draw all visible traces.
 */
function emptySubplotLists() {
  var collectableSubplotTypes = Registry.collectableSubplotTypes;
  var out = {};
  var i, j;
  if (!collectableSubplotTypes) {
    collectableSubplotTypes = [];
    var subplotsRegistry = Registry.subplotsRegistry;
    for (var subplotType in subplotsRegistry) {
      var subplotModule = subplotsRegistry[subplotType];
      var subplotAttr = subplotModule.attr;
      if (subplotAttr) {
        collectableSubplotTypes.push(subplotType);

        // special case, currently just for cartesian:
        // we need to enumerate axes, not just subplots
        if (Array.isArray(subplotAttr)) {
          for (j = 0; j < subplotAttr.length; j++) {
            Lib.pushUnique(collectableSubplotTypes, subplotAttr[j]);
          }
        }
      }
    }
  }
  for (i = 0; i < collectableSubplotTypes.length; i++) {
    out[collectableSubplotTypes[i]] = [];
  }
  return out;
}

/**
 * getFormatObj: use _context to get the format object from locale.
 * Used to get d3.locale argument object and extraFormat argument object
 *
 * Regarding d3.locale argument :
 * decimal and thousands can be overridden later by layout.separators
 * grouping and currency are not presently used by our automatic number
 * formatting system but can be used by custom formats.
 *
 * @returns {object} d3.locale format object
 */
function getFormatObj(gd, formatKeys) {
  var locale = gd._context.locale;
  if (!locale) locale = 'en-US';
  var formatDone = false;
  var formatObj = {};
  function includeFormat(newFormat) {
    var formatFinished = true;
    for (var i = 0; i < formatKeys.length; i++) {
      var formatKey = formatKeys[i];
      if (!formatObj[formatKey]) {
        if (newFormat[formatKey]) {
          formatObj[formatKey] = newFormat[formatKey];
        } else formatFinished = false;
      }
    }
    if (formatFinished) formatDone = true;
  }

  // same as localize, look for format parts in each format spec in the chain
  for (var i = 0; i < 2; i++) {
    var locales = gd._context.locales;
    for (var j = 0; j < 2; j++) {
      var formatj = (locales[locale] || {}).format;
      if (formatj) {
        includeFormat(formatj);
        if (formatDone) break;
      }
      locales = Registry.localeRegistry;
    }
    var baseLocale = locale.split('-')[0];
    if (formatDone || baseLocale === locale) break;
    locale = baseLocale;
  }

  // lastly pick out defaults from english (non-US, as DMY is so much more common)
  if (!formatDone) includeFormat(Registry.localeRegistry.en.format);
  return formatObj;
}

/**
 * getFormatter: combine the final separators with the locale formatting object
 * we pulled earlier to generate number and time formatters
 * TODO: remove separators in v3, only use locale, so we don't need this step?
 *
 * @param {object} formatObj: d3.locale format object
 * @param {string} separators: length-2 string to override decimal and thousands
 *   separators in number formatting
 *
 * @returns {object} {numberFormat, timeFormat} d3 formatter factory functions
 *   for numbers and time
 */
function getFormatter(formatObj, separators) {
  formatObj.decimal = separators.charAt(0);
  formatObj.thousands = separators.charAt(1);
  return {
    numberFormat: function (formatStr) {
      try {
        formatStr = formatLocale(formatObj).format(Lib.adjustFormat(formatStr));
      } catch (e) {
        Lib.warnBadFormat(formatStr);
        return Lib.noFormat;
      }
      return formatStr;
    },
    timeFormat: timeFormatLocale(formatObj).utcFormat
  };
}
function fillMetaTextHelpers(newFullData, newFullLayout) {
  var _meta;
  var meta4data = [];
  if (newFullLayout.meta) {
    _meta = newFullLayout._meta = {
      meta: newFullLayout.meta,
      layout: {
        meta: newFullLayout.meta
      }
    };
  }
  for (var i = 0; i < newFullData.length; i++) {
    var trace = newFullData[i];
    if (trace.meta) {
      meta4data[trace.index] = trace._meta = {
        meta: trace.meta
      };
    } else if (newFullLayout.meta) {
      trace._meta = {
        meta: newFullLayout.meta
      };
    }
    if (newFullLayout.meta) {
      trace._meta.layout = {
        meta: newFullLayout.meta
      };
    }
  }
  if (meta4data.length) {
    if (!_meta) {
      _meta = newFullLayout._meta = {};
    }
    _meta.data = meta4data;
  }
}

// Create storage for all of the data related to frames and transitions:
plots.createTransitionData = function (gd) {
  // Set up the default keyframe if it doesn't exist:
  if (!gd._transitionData) {
    gd._transitionData = {};
  }
  if (!gd._transitionData._frames) {
    gd._transitionData._frames = [];
  }
  if (!gd._transitionData._frameHash) {
    gd._transitionData._frameHash = {};
  }
  if (!gd._transitionData._counter) {
    gd._transitionData._counter = 0;
  }
  if (!gd._transitionData._interruptCallbacks) {
    gd._transitionData._interruptCallbacks = [];
  }
};

// helper function to be bound to fullLayout to check
// whether a certain plot type is present on plot
// or trace has a category
plots._hasPlotType = function (category) {
  var i;

  // check base plot modules
  var basePlotModules = this._basePlotModules || [];
  for (i = 0; i < basePlotModules.length; i++) {
    if (basePlotModules[i].name === category) return true;
  }

  // check trace modules (including non-visible:true)
  var modules = this._modules || [];
  for (i = 0; i < modules.length; i++) {
    var name = modules[i].name;
    if (name === category) return true;
    // N.B. this is modules[i] along with 'categories' as a hash object
    var _module = Registry.modules[name];
    if (_module && _module.categories[category]) return true;
  }
  return false;
};
plots.cleanPlot = function (newFullData, newFullLayout, oldFullData, oldFullLayout) {
  var i, j;
  var basePlotModules = oldFullLayout._basePlotModules || [];
  for (i = 0; i < basePlotModules.length; i++) {
    var _module = basePlotModules[i];
    if (_module.clean) {
      _module.clean(newFullData, newFullLayout, oldFullData, oldFullLayout);
    }
  }
  var hadGl = oldFullLayout._has && oldFullLayout._has('gl');
  var hasGl = newFullLayout._has && newFullLayout._has('gl');
  if (hadGl && !hasGl) {
    if (oldFullLayout._glcontainer !== undefined) {
      oldFullLayout._glcontainer.selectAll('.gl-canvas').remove();
      oldFullLayout._glcontainer.selectAll('.no-webgl').remove();
      oldFullLayout._glcanvas = null;
    }
  }
  var hasInfoLayer = !!oldFullLayout._infolayer;
  oldLoop: for (i = 0; i < oldFullData.length; i++) {
    var oldTrace = oldFullData[i];
    var oldUid = oldTrace.uid;
    for (j = 0; j < newFullData.length; j++) {
      var newTrace = newFullData[j];
      if (oldUid === newTrace.uid) continue oldLoop;
    }

    // clean old colorbars
    if (hasInfoLayer) {
      oldFullLayout._infolayer.select('.cb' + oldUid).remove();
    }
  }
};
plots.linkSubplots = function (newFullData, newFullLayout, oldFullData, oldFullLayout) {
  var i, j;
  var oldSubplots = oldFullLayout._plots || {};
  var newSubplots = newFullLayout._plots = {};
  var newSubplotList = newFullLayout._subplots;
  var mockGd = {
    _fullData: newFullData,
    _fullLayout: newFullLayout
  };
  var ids = newSubplotList.cartesian.concat(newSubplotList.gl2d || []);
  for (i = 0; i < ids.length; i++) {
    var id = ids[i];
    var oldSubplot = oldSubplots[id];
    var xaxis = axisIDs.getFromId(mockGd, id, 'x');
    var yaxis = axisIDs.getFromId(mockGd, id, 'y');
    var plotinfo;

    // link or create subplot object
    if (oldSubplot) {
      plotinfo = newSubplots[id] = oldSubplot;
    } else {
      plotinfo = newSubplots[id] = {};
      plotinfo.id = id;
    }

    // add these axis ids to each others' subplot lists
    xaxis._counterAxes.push(yaxis._id);
    yaxis._counterAxes.push(xaxis._id);
    xaxis._subplotsWith.push(id);
    yaxis._subplotsWith.push(id);

    // update x and y axis layout object refs
    plotinfo.xaxis = xaxis;
    plotinfo.yaxis = yaxis;

    // By default, we clip at the subplot level,
    // but if one trace on a given subplot has *cliponaxis* set to false,
    // we need to clip at the trace module layer level;
    // find this out here, once of for all.
    plotinfo._hasClipOnAxisFalse = false;
    for (j = 0; j < newFullData.length; j++) {
      var trace = newFullData[j];
      if (trace.xaxis === plotinfo.xaxis._id && trace.yaxis === plotinfo.yaxis._id && trace.cliponaxis === false) {
        plotinfo._hasClipOnAxisFalse = true;
        break;
      }
    }
  }

  // while we're at it, link overlaying axes to their main axes and
  // anchored axes to the axes they're anchored to
  var axList = axisIDs.list(mockGd, null, true);
  var ax;
  for (i = 0; i < axList.length; i++) {
    ax = axList[i];
    var mainAx = null;
    if (ax.overlaying) {
      mainAx = axisIDs.getFromId(mockGd, ax.overlaying);

      // you cannot overlay an axis that's already overlaying another
      if (mainAx && mainAx.overlaying) {
        ax.overlaying = false;
        mainAx = null;
      }
    }
    ax._mainAxis = mainAx || ax;

    /*
     * For now force overlays to overlay completely... so they
     * can drag together correctly and share backgrounds.
     * Later perhaps we make separate axis domain and
     * tick/line domain or something, so they can still share
     * the (possibly larger) dragger and background but don't
     * have to both be drawn over that whole domain
     */
    if (mainAx) ax.domain = mainAx.domain.slice();
    ax._anchorAxis = ax.anchor === 'free' ? null : axisIDs.getFromId(mockGd, ax.anchor);
  }

  // finally, we can find the main subplot for each axis
  // (on which the ticks & labels are drawn)
  for (i = 0; i < axList.length; i++) {
    ax = axList[i];
    ax._counterAxes.sort(axisIDs.idSort);
    ax._subplotsWith.sort(Lib.subplotSort);
    ax._mainSubplot = findMainSubplot(ax, newFullLayout);

    // find "full" domain span of counter axes,
    // this loop can be costly, so only compute it when required
    if (ax._counterAxes.length && (ax.spikemode && ax.spikemode.indexOf('across') !== -1 || ax.automargin && ax.mirror && ax.anchor !== 'free' || Registry.getComponentMethod('rangeslider', 'isVisible')(ax))) {
      var min = 1;
      var max = 0;
      for (j = 0; j < ax._counterAxes.length; j++) {
        var ax2 = axisIDs.getFromId(mockGd, ax._counterAxes[j]);
        min = Math.min(min, ax2.domain[0]);
        max = Math.max(max, ax2.domain[1]);
      }
      if (min < max) {
        ax._counterDomainMin = min;
        ax._counterDomainMax = max;
      }
    }
  }
};
function findMainSubplot(ax, fullLayout) {
  var mockGd = {
    _fullLayout: fullLayout
  };
  var isX = ax._id.charAt(0) === 'x';
  var anchorAx = ax._mainAxis._anchorAxis;
  var mainSubplotID = '';
  var nextBestMainSubplotID = '';
  var anchorID = '';

  // First try the main ID with the anchor
  if (anchorAx) {
    anchorID = anchorAx._mainAxis._id;
    mainSubplotID = isX ? ax._id + anchorID : anchorID + ax._id;
  }

  // Then look for a subplot with the counteraxis overlaying the anchor
  // If that fails just use the first subplot including this axis
  if (!mainSubplotID || !fullLayout._plots[mainSubplotID]) {
    mainSubplotID = '';
    var counterIDs = ax._counterAxes;
    for (var j = 0; j < counterIDs.length; j++) {
      var counterPart = counterIDs[j];
      var id = isX ? ax._id + counterPart : counterPart + ax._id;
      if (!nextBestMainSubplotID) nextBestMainSubplotID = id;
      var counterAx = axisIDs.getFromId(mockGd, counterPart);
      if (anchorID && counterAx.overlaying === anchorID) {
        mainSubplotID = id;
        break;
      }
    }
  }
  return mainSubplotID || nextBestMainSubplotID;
}

// This function clears any trace attributes with valType: color and
// no set dflt filed in the plot schema. This is needed because groupby (which
// is the only transform for which this currently applies) supplies parent
// trace defaults, then expanded trace defaults. The result is that `null`
// colors are default-supplied and inherited as a color instead of a null.
// The result is that expanded trace default colors have no effect, with
// the final result that groups are indistinguishable. This function clears
// those colors so that individual groupby groups get unique colors.
plots.clearExpandedTraceDefaultColors = function (trace) {
  var colorAttrs, path, i;

  // This uses weird closure state in order to satisfy the linter rule
  // that we can't create functions in a loop.
  function locateColorAttrs(attr, attrName, attrs, level) {
    path[level] = attrName;
    path.length = level + 1;
    if (attr.valType === 'color' && attr.dflt === undefined) {
      colorAttrs.push(path.join('.'));
    }
  }
  path = [];

  // Get the cached colorAttrs:
  colorAttrs = trace._module._colorAttrs;

  // Or else compute and cache the colorAttrs on the module:
  if (!colorAttrs) {
    trace._module._colorAttrs = colorAttrs = [];
    PlotSchema.crawl(trace._module.attributes, locateColorAttrs);
  }
  for (i = 0; i < colorAttrs.length; i++) {
    var origprop = Lib.nestedProperty(trace, '_input.' + colorAttrs[i]);
    if (!origprop.get()) {
      Lib.nestedProperty(trace, colorAttrs[i]).set(null);
    }
  }
};
plots.supplyDataDefaults = function (dataIn, dataOut, layout, fullLayout) {
  var modules = fullLayout._modules;
  var visibleModules = fullLayout._visibleModules;
  var basePlotModules = fullLayout._basePlotModules;
  var cnt = 0;
  var colorCnt = 0;
  var i, fullTrace, trace;
  fullLayout._transformModules = [];
  function pushModule(fullTrace) {
    dataOut.push(fullTrace);
    var _module = fullTrace._module;
    if (!_module) return;
    Lib.pushUnique(modules, _module);
    if (fullTrace.visible === true) Lib.pushUnique(visibleModules, _module);
    Lib.pushUnique(basePlotModules, fullTrace._module.basePlotModule);
    cnt++;

    // TODO: do we really want color not to increment for explicitly invisible traces?
    // This logic is weird, but matches previous behavior: traces that you explicitly
    // set to visible:false do not increment the color, but traces WE determine to be
    // empty or invalid (and thus set to visible:false) DO increment color.
    // I kind of think we should just let all traces increment color, visible or not.
    // see mock: axes-autotype-empty vs. a test of restyling visible: false that
    // I can't find right now...
    if (fullTrace._input.visible !== false) colorCnt++;
  }
  var carpetIndex = {};
  var carpetDependents = [];
  var dataTemplate = (layout.template || {}).data || {};
  var templater = Template.traceTemplater(dataTemplate);
  for (i = 0; i < dataIn.length; i++) {
    trace = dataIn[i];

    // reuse uid we may have pulled out of oldFullData
    // Note: templater supplies trace type
    fullTrace = templater.newTrace(trace);
    fullTrace.uid = fullLayout._traceUids[i];
    plots.supplyTraceDefaults(trace, fullTrace, colorCnt, fullLayout, i);
    fullTrace.index = i;
    fullTrace._input = trace;
    fullTrace._expandedIndex = cnt;
    if (fullTrace.transforms && fullTrace.transforms.length) {
      var sdInvisible = trace.visible !== false && fullTrace.visible === false;
      var expandedTraces = applyTransforms(fullTrace, dataOut, layout, fullLayout);
      for (var j = 0; j < expandedTraces.length; j++) {
        var expandedTrace = expandedTraces[j];

        // No further templating during transforms.
        var fullExpandedTrace = {
          _template: fullTrace._template,
          type: fullTrace.type,
          // set uid using parent uid and expanded index
          // to promote consistency between update calls
          uid: fullTrace.uid + j
        };

        // If the first supplyDefaults created `visible: false`,
        // clear it before running supplyDefaults a second time,
        // because sometimes there are items we still want to coerce
        // inside trace modules before determining that the trace is
        // again `visible: false`, for example partial visibilities
        // in `splom` traces.
        if (sdInvisible && expandedTrace.visible === false) {
          delete expandedTrace.visible;
        }
        plots.supplyTraceDefaults(expandedTrace, fullExpandedTrace, cnt, fullLayout, i);

        // relink private (i.e. underscore) keys expanded trace to full expanded trace so
        // that transform supply-default methods can set _ keys for future use.
        relinkPrivateKeys(fullExpandedTrace, expandedTrace);

        // add info about parent data trace
        fullExpandedTrace.index = i;
        fullExpandedTrace._input = trace;
        fullExpandedTrace._fullInput = fullTrace;

        // add info about the expanded data
        fullExpandedTrace._expandedIndex = cnt;
        fullExpandedTrace._expandedInput = expandedTrace;
        pushModule(fullExpandedTrace);
      }
    } else {
      // add identify refs for consistency with transformed traces
      fullTrace._fullInput = fullTrace;
      fullTrace._expandedInput = fullTrace;
      pushModule(fullTrace);
    }
    if (Registry.traceIs(fullTrace, 'carpetAxis')) {
      carpetIndex[fullTrace.carpet] = fullTrace;
    }
    if (Registry.traceIs(fullTrace, 'carpetDependent')) {
      carpetDependents.push(i);
    }
  }
  for (i = 0; i < carpetDependents.length; i++) {
    fullTrace = dataOut[carpetDependents[i]];
    if (!fullTrace.visible) continue;
    var carpetAxis = carpetIndex[fullTrace.carpet];
    fullTrace._carpet = carpetAxis;
    if (!carpetAxis || !carpetAxis.visible) {
      fullTrace.visible = false;
      continue;
    }
    fullTrace.xaxis = carpetAxis.xaxis;
    fullTrace.yaxis = carpetAxis.yaxis;
  }
};
plots.supplyAnimationDefaults = function (opts) {
  opts = opts || {};
  var i;
  var optsOut = {};
  function coerce(attr, dflt) {
    return Lib.coerce(opts || {}, optsOut, animationAttrs, attr, dflt);
  }
  coerce('mode');
  coerce('direction');
  coerce('fromcurrent');
  if (Array.isArray(opts.frame)) {
    optsOut.frame = [];
    for (i = 0; i < opts.frame.length; i++) {
      optsOut.frame[i] = plots.supplyAnimationFrameDefaults(opts.frame[i] || {});
    }
  } else {
    optsOut.frame = plots.supplyAnimationFrameDefaults(opts.frame || {});
  }
  if (Array.isArray(opts.transition)) {
    optsOut.transition = [];
    for (i = 0; i < opts.transition.length; i++) {
      optsOut.transition[i] = plots.supplyAnimationTransitionDefaults(opts.transition[i] || {});
    }
  } else {
    optsOut.transition = plots.supplyAnimationTransitionDefaults(opts.transition || {});
  }
  return optsOut;
};
plots.supplyAnimationFrameDefaults = function (opts) {
  var optsOut = {};
  function coerce(attr, dflt) {
    return Lib.coerce(opts || {}, optsOut, animationAttrs.frame, attr, dflt);
  }
  coerce('duration');
  coerce('redraw');
  return optsOut;
};
plots.supplyAnimationTransitionDefaults = function (opts) {
  var optsOut = {};
  function coerce(attr, dflt) {
    return Lib.coerce(opts || {}, optsOut, animationAttrs.transition, attr, dflt);
  }
  coerce('duration');
  coerce('easing');
  return optsOut;
};
plots.supplyFrameDefaults = function (frameIn) {
  var frameOut = {};
  function coerce(attr, dflt) {
    return Lib.coerce(frameIn, frameOut, frameAttrs, attr, dflt);
  }
  coerce('group');
  coerce('name');
  coerce('traces');
  coerce('baseframe');
  coerce('data');
  coerce('layout');
  return frameOut;
};
plots.supplyTraceDefaults = function (traceIn, traceOut, colorIndex, layout, traceInIndex) {
  var colorway = layout.colorway || Color.defaults;
  var defaultColor = colorway[colorIndex % colorway.length];
  var i;
  function coerce(attr, dflt) {
    return Lib.coerce(traceIn, traceOut, plots.attributes, attr, dflt);
  }
  var visible = coerce('visible');
  coerce('type');
  coerce('name', layout._traceWord + ' ' + traceInIndex);
  coerce('uirevision', layout.uirevision);

  // we want even invisible traces to make their would-be subplots visible
  // so coerce the subplot id(s) now no matter what
  var _module = plots.getModule(traceOut);
  traceOut._module = _module;
  if (_module) {
    var basePlotModule = _module.basePlotModule;
    var subplotAttr = basePlotModule.attr;
    var subplotAttrs = basePlotModule.attributes;
    if (subplotAttr && subplotAttrs) {
      var subplots = layout._subplots;
      var subplotId = '';
      if (visible || basePlotModule.name !== 'gl2d' // for now just drop empty gl2d subplots
      // TODO - currently if we draw an empty gl2d subplot, it draws
      // nothing then gets stuck and you can't get it back without newPlot
      // sort this out in the regl refactor?
      ) {
        if (Array.isArray(subplotAttr)) {
          for (i = 0; i < subplotAttr.length; i++) {
            var attri = subplotAttr[i];
            var vali = Lib.coerce(traceIn, traceOut, subplotAttrs, attri);
            if (subplots[attri]) Lib.pushUnique(subplots[attri], vali);
            subplotId += vali;
          }
        } else {
          subplotId = Lib.coerce(traceIn, traceOut, subplotAttrs, subplotAttr);
        }
        if (subplots[basePlotModule.name]) {
          Lib.pushUnique(subplots[basePlotModule.name], subplotId);
        }
      }
    }
  }
  if (visible) {
    coerce('customdata');
    coerce('ids');
    coerce('meta');
    if (Registry.traceIs(traceOut, 'showLegend')) {
      Lib.coerce(traceIn, traceOut, _module.attributes.showlegend ? _module.attributes : plots.attributes, 'showlegend');
      coerce('legend');
      coerce('legendwidth');
      coerce('legendgroup');
      coerce('legendgrouptitle.text');
      coerce('legendrank');
      traceOut._dfltShowLegend = true;
    } else {
      traceOut._dfltShowLegend = false;
    }
    if (_module) {
      _module.supplyDefaults(traceIn, traceOut, defaultColor, layout);
    }
    if (!Registry.traceIs(traceOut, 'noOpacity')) {
      coerce('opacity');
    }
    if (Registry.traceIs(traceOut, 'notLegendIsolatable')) {
      // This clears out the legendonly state for traces like carpet that
      // cannot be isolated in the legend
      traceOut.visible = !!traceOut.visible;
    }
    if (!Registry.traceIs(traceOut, 'noHover')) {
      if (!traceOut.hovertemplate) Lib.coerceHoverinfo(traceIn, traceOut, layout);

      // parcats support hover, but not hoverlabel stylings (yet)
      if (traceOut.type !== 'parcats') {
        Registry.getComponentMethod('fx', 'supplyDefaults')(traceIn, traceOut, defaultColor, layout);
      }
    }
    if (_module && _module.selectPoints) {
      var selectedpoints = coerce('selectedpoints');
      if (Lib.isTypedArray(selectedpoints)) {
        traceOut.selectedpoints = Array.from(selectedpoints);
      }
    }
    plots.supplyTransformDefaults(traceIn, traceOut, layout);
  }
  return traceOut;
};

/**
 * hasMakesDataTransform: does this trace have a transform that makes its own
 * data, either by grabbing it from somewhere else or by creating it from input
 * parameters? If so, we should still keep going with supplyDefaults
 * even if the trace is invisible, which may just be because it has no data yet.
 */
function hasMakesDataTransform(trace) {
  var transforms = trace.transforms;
  if (Array.isArray(transforms) && transforms.length) {
    for (var i = 0; i < transforms.length; i++) {
      var ti = transforms[i];
      var _module = ti._module || transformsRegistry[ti.type];
      if (_module && _module.makesData) return true;
    }
  }
  return false;
}
plots.hasMakesDataTransform = hasMakesDataTransform;
plots.supplyTransformDefaults = function (traceIn, traceOut, layout) {
  // For now we only allow transforms on 1D traces, ie those that specify a _length.
  // If we were to implement 2D transforms, we'd need to have each transform
  // describe its own applicability and disable itself when it doesn't apply.
  // Also allow transforms that make their own data, but not in globalTransforms
  if (!(traceOut._length || hasMakesDataTransform(traceIn))) return;
  var globalTransforms = layout._globalTransforms || [];
  var transformModules = layout._transformModules || [];
  if (!Array.isArray(traceIn.transforms) && globalTransforms.length === 0) return;
  var containerIn = traceIn.transforms || [];
  var transformList = globalTransforms.concat(containerIn);
  var containerOut = traceOut.transforms = [];
  for (var i = 0; i < transformList.length; i++) {
    var transformIn = transformList[i];
    var type = transformIn.type;
    var _module = transformsRegistry[type];
    var transformOut;

    /*
     * Supply defaults may run twice. First pass runs all supply defaults steps
     * and adds the _module to any output transforms.
     * If transforms exist another pass is run so that any generated traces also
     * go through supply defaults. This has the effect of rerunning
     * supplyTransformDefaults. If the transform does not have a `transform`
     * function it could not have generated any new traces and the second stage
     * is unnecessary. We detect this case with the following variables.
     */
    var isFirstStage = !(transformIn._module && transformIn._module === _module);
    var doLaterStages = _module && typeof _module.transform === 'function';
    if (!_module) Lib.warn('Unrecognized transform type ' + type + '.');
    if (_module && _module.supplyDefaults && (isFirstStage || doLaterStages)) {
      transformOut = _module.supplyDefaults(transformIn, traceOut, layout, traceIn);
      transformOut.type = type;
      transformOut._module = _module;
      Lib.pushUnique(transformModules, _module);
    } else {
      transformOut = Lib.extendFlat({}, transformIn);
    }
    containerOut.push(transformOut);
  }
};
function applyTransforms(fullTrace, fullData, layout, fullLayout) {
  var container = fullTrace.transforms;
  var dataOut = [fullTrace];
  for (var i = 0; i < container.length; i++) {
    var transform = container[i];
    var _module = transformsRegistry[transform.type];
    if (_module && _module.transform) {
      dataOut = _module.transform(dataOut, {
        transform: transform,
        fullTrace: fullTrace,
        fullData: fullData,
        layout: layout,
        fullLayout: fullLayout,
        transformIndex: i
      });
    }
  }
  return dataOut;
}
plots.supplyLayoutGlobalDefaults = function (layoutIn, layoutOut, formatObj) {
  function coerce(attr, dflt) {
    return Lib.coerce(layoutIn, layoutOut, plots.layoutAttributes, attr, dflt);
  }
  var template = layoutIn.template;
  if (Lib.isPlainObject(template)) {
    layoutOut.template = template;
    layoutOut._template = template.layout;
    layoutOut._dataTemplate = template.data;
  }
  coerce('autotypenumbers');
  var font = Lib.coerceFont(coerce, 'font');
  var fontSize = font.size;
  Lib.coerceFont(coerce, 'title.font', font, {
    overrideDflt: {
      size: Math.round(fontSize * 1.4)
    }
  });
  coerce('title.text', layoutOut._dfltTitle.plot);
  coerce('title.xref');
  var titleYref = coerce('title.yref');
  coerce('title.pad.t');
  coerce('title.pad.r');
  coerce('title.pad.b');
  coerce('title.pad.l');
  var titleAutomargin = coerce('title.automargin');
  coerce('title.x');
  coerce('title.xanchor');
  coerce('title.y');
  coerce('title.yanchor');
  coerce('title.subtitle.text', layoutOut._dfltTitle.subtitle);
  Lib.coerceFont(coerce, 'title.subtitle.font', font, {
    overrideDflt: {
      size: Math.round(layoutOut.title.font.size * 0.7)
    }
  });
  if (titleAutomargin) {
    // when automargin=true
    // title.y is 1 or 0 if paper ref
    // 'auto' is not supported for either title.y or title.yanchor

    // TODO: mention this smart default in the title.y and title.yanchor descriptions

    if (titleYref === 'paper') {
      if (layoutOut.title.y !== 0) layoutOut.title.y = 1;
      if (layoutOut.title.yanchor === 'auto') {
        layoutOut.title.yanchor = layoutOut.title.y === 0 ? 'top' : 'bottom';
      }
    }
    if (titleYref === 'container') {
      if (layoutOut.title.y === 'auto') layoutOut.title.y = 1;
      if (layoutOut.title.yanchor === 'auto') {
        layoutOut.title.yanchor = layoutOut.title.y < 0.5 ? 'bottom' : 'top';
      }
    }
  }
  var uniformtextMode = coerce('uniformtext.mode');
  if (uniformtextMode) {
    coerce('uniformtext.minsize');
  }

  // Make sure that autosize is defaulted to *true*
  // on layouts with no set width and height for backward compatibly,
  // in particular https://plotly.com/javascript/responsive-fluid-layout/
  //
  // Before https://github.com/plotly/plotly.js/pull/635 ,
  // layouts with no set width and height were set temporary set to 'initial'
  // to pass through the autosize routine
  //
  // This behavior is subject to change in v3.
  coerce('autosize', !(layoutIn.width && layoutIn.height));
  coerce('width');
  coerce('height');
  coerce('minreducedwidth');
  coerce('minreducedheight');
  coerce('margin.l');
  coerce('margin.r');
  coerce('margin.t');
  coerce('margin.b');
  coerce('margin.pad');
  coerce('margin.autoexpand');
  if (layoutIn.width && layoutIn.height) plots.sanitizeMargins(layoutOut);
  Registry.getComponentMethod('grid', 'sizeDefaults')(layoutIn, layoutOut);
  coerce('paper_bgcolor');
  coerce('separators', formatObj.decimal + formatObj.thousands);
  coerce('hidesources');
  coerce('colorway');
  coerce('datarevision');
  var uirevision = coerce('uirevision');
  coerce('editrevision', uirevision);
  coerce('selectionrevision', uirevision);
  Registry.getComponentMethod('modebar', 'supplyLayoutDefaults')(layoutIn, layoutOut);
  Registry.getComponentMethod('shapes', 'supplyDrawNewShapeDefaults')(layoutIn, layoutOut, coerce);
  Registry.getComponentMethod('selections', 'supplyDrawNewSelectionDefaults')(layoutIn, layoutOut, coerce);
  coerce('meta');

  // do not include defaults in fullLayout when users do not set transition
  if (Lib.isPlainObject(layoutIn.transition)) {
    coerce('transition.duration');
    coerce('transition.easing');
    coerce('transition.ordering');
  }
  Registry.getComponentMethod('calendars', 'handleDefaults')(layoutIn, layoutOut, 'calendar');
  Registry.getComponentMethod('fx', 'supplyLayoutGlobalDefaults')(layoutIn, layoutOut, coerce);
  Lib.coerce(layoutIn, layoutOut, scatterAttrs, 'scattermode');
};
function getComputedSize(attr) {
  return typeof attr === 'string' && attr.substr(attr.length - 2) === 'px' && parseFloat(attr);
}
plots.plotAutoSize = function plotAutoSize(gd, layout, fullLayout) {
  var context = gd._context || {};
  var frameMargins = context.frameMargins;
  var newWidth;
  var newHeight;
  var isPlotDiv = Lib.isPlotDiv(gd);
  if (isPlotDiv) gd.emit('plotly_autosize');

  // embedded in an iframe - just take the full iframe size
  // if we get to this point, with no aspect ratio restrictions
  if (context.fillFrame) {
    newWidth = window.innerWidth;
    newHeight = window.innerHeight;

    // somehow we get a few extra px height sometimes...
    // just hide it
    document.body.style.overflow = 'hidden';
  } else {
    // plotly.js - let the developers do what they want, either
    // provide height and width for the container div,
    // specify size in layout, or take the defaults,
    // but don't enforce any ratio restrictions
    var computedStyle = isPlotDiv ? window.getComputedStyle(gd) : {};
    newWidth = getComputedSize(computedStyle.width) || getComputedSize(computedStyle.maxWidth) || fullLayout.width;
    newHeight = getComputedSize(computedStyle.height) || getComputedSize(computedStyle.maxHeight) || fullLayout.height;
    if (isNumeric(frameMargins) && frameMargins > 0) {
      var factor = 1 - 2 * frameMargins;
      newWidth = Math.round(factor * newWidth);
      newHeight = Math.round(factor * newHeight);
    }
  }
  var minWidth = plots.layoutAttributes.width.min;
  var minHeight = plots.layoutAttributes.height.min;
  if (newWidth < minWidth) newWidth = minWidth;
  if (newHeight < minHeight) newHeight = minHeight;
  var widthHasChanged = !layout.width && Math.abs(fullLayout.width - newWidth) > 1;
  var heightHasChanged = !layout.height && Math.abs(fullLayout.height - newHeight) > 1;
  if (heightHasChanged || widthHasChanged) {
    if (widthHasChanged) fullLayout.width = newWidth;
    if (heightHasChanged) fullLayout.height = newHeight;
  }

  // cache initial autosize value, used in relayout when
  // width or height values are set to null
  if (!gd._initialAutoSize) {
    gd._initialAutoSize = {
      width: newWidth,
      height: newHeight
    };
  }
  plots.sanitizeMargins(fullLayout);
};
plots.supplyLayoutModuleDefaults = function (layoutIn, layoutOut, fullData, transitionData) {
  var componentsRegistry = Registry.componentsRegistry;
  var basePlotModules = layoutOut._basePlotModules;
  var component, i, _module;
  var Cartesian = Registry.subplotsRegistry.cartesian;

  // check if any components need to add more base plot modules
  // that weren't captured by traces
  for (component in componentsRegistry) {
    _module = componentsRegistry[component];
    if (_module.includeBasePlot) {
      _module.includeBasePlot(layoutIn, layoutOut);
    }
  }

  // make sure we *at least* have some cartesian axes
  if (!basePlotModules.length) {
    basePlotModules.push(Cartesian);
  }

  // ensure all cartesian axes have at least one subplot
  if (layoutOut._has('cartesian')) {
    Registry.getComponentMethod('grid', 'contentDefaults')(layoutIn, layoutOut);
    Cartesian.finalizeSubplots(layoutIn, layoutOut);
  }

  // sort subplot lists
  for (var subplotType in layoutOut._subplots) {
    layoutOut._subplots[subplotType].sort(Lib.subplotSort);
  }

  // base plot module layout defaults
  for (i = 0; i < basePlotModules.length; i++) {
    _module = basePlotModules[i];

    // e.g. pie does not have a layout-defaults step
    if (_module.supplyLayoutDefaults) {
      _module.supplyLayoutDefaults(layoutIn, layoutOut, fullData);
    }
  }

  // trace module layout defaults
  // use _modules rather than _visibleModules so that even
  // legendonly traces can include settings - eg barmode, which affects
  // legend.traceorder default value.
  var modules = layoutOut._modules;
  for (i = 0; i < modules.length; i++) {
    _module = modules[i];
    if (_module.supplyLayoutDefaults) {
      _module.supplyLayoutDefaults(layoutIn, layoutOut, fullData);
    }
  }

  // transform module layout defaults
  var transformModules = layoutOut._transformModules;
  for (i = 0; i < transformModules.length; i++) {
    _module = transformModules[i];
    if (_module.supplyLayoutDefaults) {
      _module.supplyLayoutDefaults(layoutIn, layoutOut, fullData, transitionData);
    }
  }
  for (component in componentsRegistry) {
    _module = componentsRegistry[component];
    if (_module.supplyLayoutDefaults) {
      _module.supplyLayoutDefaults(layoutIn, layoutOut, fullData);
    }
  }
};

// Remove all plotly attributes from a div so it can be replotted fresh
// TODO: these really need to be encapsulated into a much smaller set...
plots.purge = function (gd) {
  // note: we DO NOT remove _context because it doesn't change when we insert
  // a new plot, and may have been set outside of our scope.

  var fullLayout = gd._fullLayout || {};
  if (fullLayout._glcontainer !== undefined) {
    fullLayout._glcontainer.selectAll('.gl-canvas').remove();
    fullLayout._glcontainer.remove();
    fullLayout._glcanvas = null;
  }

  // remove modebar
  if (fullLayout._modeBar) fullLayout._modeBar.destroy();
  if (gd._transitionData) {
    // Ensure any dangling callbacks are simply dropped if the plot is purged.
    // This is more or less only actually important for testing.
    if (gd._transitionData._interruptCallbacks) {
      gd._transitionData._interruptCallbacks.length = 0;
    }
    if (gd._transitionData._animationRaf) {
      window.cancelAnimationFrame(gd._transitionData._animationRaf);
    }
  }

  // remove any planned throttles
  Lib.clearThrottle();

  // remove responsive handler
  Lib.clearResponsive(gd);

  // data and layout
  delete gd.data;
  delete gd.layout;
  delete gd._fullData;
  delete gd._fullLayout;
  delete gd.calcdata;
  delete gd.empty;
  delete gd.fid;
  delete gd.undoqueue; // action queue
  delete gd.undonum;
  delete gd.autoplay; // are we doing an action that doesn't go in undo queue?
  delete gd.changed;

  // these get recreated on _doPlot anyway, but just to be safe
  // (and to have a record of them...)
  delete gd._promises;
  delete gd._redrawTimer;
  delete gd._hmlumcount;
  delete gd._hmpixcount;
  delete gd._transitionData;
  delete gd._transitioning;
  delete gd._initialAutoSize;
  delete gd._transitioningWithDuration;

  // created during certain events, that *should* clean them up
  // themselves, but may not if there was an error
  delete gd._dragging;
  delete gd._dragged;
  delete gd._dragdata;
  delete gd._hoverdata;
  delete gd._snapshotInProgress;
  delete gd._editing;
  delete gd._mouseDownTime;
  delete gd._legendMouseDownTime;

  // remove all event listeners
  if (gd.removeAllListeners) gd.removeAllListeners();
};
plots.style = function (gd) {
  var _modules = gd._fullLayout._visibleModules;
  var styleModules = [];
  var i;

  // some trace modules reuse the same style method,
  // make sure to not unnecessary call them multiple times.

  for (i = 0; i < _modules.length; i++) {
    var _module = _modules[i];
    if (_module.style) {
      Lib.pushUnique(styleModules, _module.style);
    }
  }
  for (i = 0; i < styleModules.length; i++) {
    styleModules[i](gd);
  }
};
plots.sanitizeMargins = function (fullLayout) {
  // polar doesn't do margins...
  if (!fullLayout || !fullLayout.margin) return;
  var width = fullLayout.width;
  var height = fullLayout.height;
  var margin = fullLayout.margin;
  var plotWidth = width - (margin.l + margin.r);
  var plotHeight = height - (margin.t + margin.b);
  var correction;

  // if margin.l + margin.r = 0 then plotWidth > 0
  // as width >= 10 by supplyDefaults
  // similarly for margin.t + margin.b

  if (plotWidth < 0) {
    correction = (width - 1) / (margin.l + margin.r);
    margin.l = Math.floor(correction * margin.l);
    margin.r = Math.floor(correction * margin.r);
  }
  if (plotHeight < 0) {
    correction = (height - 1) / (margin.t + margin.b);
    margin.t = Math.floor(correction * margin.t);
    margin.b = Math.floor(correction * margin.b);
  }
};
plots.clearAutoMarginIds = function (gd) {
  gd._fullLayout._pushmarginIds = {};
};
plots.allowAutoMargin = function (gd, id) {
  gd._fullLayout._pushmarginIds[id] = 1;
};
function initMargins(fullLayout) {
  var margin = fullLayout.margin;
  if (!fullLayout._size) {
    var gs = fullLayout._size = {
      l: Math.round(margin.l),
      r: Math.round(margin.r),
      t: Math.round(margin.t),
      b: Math.round(margin.b),
      p: Math.round(margin.pad)
    };
    gs.w = Math.round(fullLayout.width) - gs.l - gs.r;
    gs.h = Math.round(fullLayout.height) - gs.t - gs.b;
  }
  if (!fullLayout._pushmargin) fullLayout._pushmargin = {};
  if (!fullLayout._pushmarginIds) fullLayout._pushmarginIds = {};
  if (!fullLayout._reservedMargin) fullLayout._reservedMargin = {};
}

// non-negotiable - this is the smallest height we will allow users to specify via explicit margins
var MIN_SPECIFIED_WIDTH = 2;
var MIN_SPECIFIED_HEIGHT = 2;

/**
 * autoMargin: called by components that may need to expand the margins to
 * be rendered on-plot.
 *
 * @param {DOM element} gd
 * @param {string} id - an identifier unique (within this plot) to this object,
 *     so we can remove a previous margin expansion from the same object.
 * @param {object} o - the margin requirements of this object, or omit to delete
 *     this entry (like if it's hidden). Keys are:
 *     x, y: plot fraction of the anchor point.
 *     xl, xr, yt, yb: if the object has an extent defined in plot fraction,
 *         you can specify both edges as plot fractions in each dimension
 *     l, r, t, b: the pixels to pad past the plot fraction x[l|r] and y[t|b]
 *     pad: extra pixels to add in all directions, default 12 (why?)
 */
plots.autoMargin = function (gd, id, o) {
  var fullLayout = gd._fullLayout;
  var width = fullLayout.width;
  var height = fullLayout.height;
  var margin = fullLayout.margin;
  var minreducedwidth = fullLayout.minreducedwidth;
  var minreducedheight = fullLayout.minreducedheight;
  var minFinalWidth = Lib.constrain(width - margin.l - margin.r, MIN_SPECIFIED_WIDTH, minreducedwidth);
  var minFinalHeight = Lib.constrain(height - margin.t - margin.b, MIN_SPECIFIED_HEIGHT, minreducedheight);
  var maxSpaceW = Math.max(0, width - minFinalWidth);
  var maxSpaceH = Math.max(0, height - minFinalHeight);
  var pushMargin = fullLayout._pushmargin;
  var pushMarginIds = fullLayout._pushmarginIds;
  if (margin.autoexpand !== false) {
    if (!o) {
      delete pushMargin[id];
      delete pushMarginIds[id];
    } else {
      var pad = o.pad;
      if (pad === undefined) {
        // if no explicit pad is given, use 12px unless there's a
        // specified margin that's smaller than that
        pad = Math.min(12, margin.l, margin.r, margin.t, margin.b);
      }

      // if the item is too big, just give it enough automargin to
      // make sure you can still grab it and bring it back
      if (maxSpaceW) {
        var rW = (o.l + o.r) / maxSpaceW;
        if (rW > 1) {
          o.l /= rW;
          o.r /= rW;
        }
      }
      if (maxSpaceH) {
        var rH = (o.t + o.b) / maxSpaceH;
        if (rH > 1) {
          o.t /= rH;
          o.b /= rH;
        }
      }
      var xl = o.xl !== undefined ? o.xl : o.x;
      var xr = o.xr !== undefined ? o.xr : o.x;
      var yt = o.yt !== undefined ? o.yt : o.y;
      var yb = o.yb !== undefined ? o.yb : o.y;
      pushMargin[id] = {
        l: {
          val: xl,
          size: o.l + pad
        },
        r: {
          val: xr,
          size: o.r + pad
        },
        b: {
          val: yb,
          size: o.b + pad
        },
        t: {
          val: yt,
          size: o.t + pad
        }
      };
      pushMarginIds[id] = 1;
    }
    if (!fullLayout._replotting) {
      return plots.doAutoMargin(gd);
    }
  }
};
function needsRedrawForShift(gd) {
  if ('_redrawFromAutoMarginCount' in gd._fullLayout) {
    return false;
  }
  var axList = axisIDs.list(gd, '', true);
  for (var ax in axList) {
    if (axList[ax].autoshift || axList[ax].shift) return true;
  }
  return false;
}
plots.doAutoMargin = function (gd) {
  var fullLayout = gd._fullLayout;
  var width = fullLayout.width;
  var height = fullLayout.height;
  if (!fullLayout._size) fullLayout._size = {};
  initMargins(fullLayout);
  var gs = fullLayout._size;
  var margin = fullLayout.margin;
  var reservedMargins = {
    t: 0,
    b: 0,
    l: 0,
    r: 0
  };
  var oldMargins = Lib.extendFlat({}, gs);

  // adjust margins for outside components
  // fullLayout.margin is the requested margin,
  // fullLayout._size has margins and plotsize after adjustment
  var ml = margin.l;
  var mr = margin.r;
  var mt = margin.t;
  var mb = margin.b;
  var pushMargin = fullLayout._pushmargin;
  var pushMarginIds = fullLayout._pushmarginIds;
  var minreducedwidth = fullLayout.minreducedwidth;
  var minreducedheight = fullLayout.minreducedheight;
  if (margin.autoexpand !== false) {
    for (var k in pushMargin) {
      if (!pushMarginIds[k]) delete pushMargin[k];
    }
    var margins = gd._fullLayout._reservedMargin;
    for (var key in margins) {
      for (var side in margins[key]) {
        var val = margins[key][side];
        reservedMargins[side] = Math.max(reservedMargins[side], val);
      }
    }
    // fill in the requested margins
    pushMargin.base = {
      l: {
        val: 0,
        size: ml
      },
      r: {
        val: 1,
        size: mr
      },
      t: {
        val: 1,
        size: mt
      },
      b: {
        val: 0,
        size: mb
      }
    };

    // make sure that the reservedMargin is the minimum needed
    for (var s in reservedMargins) {
      var autoMarginPush = 0;
      for (var m in pushMargin) {
        if (m !== 'base') {
          if (isNumeric(pushMargin[m][s].size)) {
            autoMarginPush = pushMargin[m][s].size > autoMarginPush ? pushMargin[m][s].size : autoMarginPush;
          }
        }
      }
      var extraMargin = Math.max(0, margin[s] - autoMarginPush);
      reservedMargins[s] = Math.max(0, reservedMargins[s] - extraMargin);
    }

    // now cycle through all the combinations of l and r
    // (and t and b) to find the required margins
    for (var k1 in pushMargin) {
      var pushleft = pushMargin[k1].l || {};
      var pushbottom = pushMargin[k1].b || {};
      var fl = pushleft.val;
      var pl = pushleft.size;
      var fb = pushbottom.val;
      var pb = pushbottom.size;
      var availableWidth = width - reservedMargins.r - reservedMargins.l;
      var availableHeight = height - reservedMargins.t - reservedMargins.b;
      for (var k2 in pushMargin) {
        if (isNumeric(pl) && pushMargin[k2].r) {
          var fr = pushMargin[k2].r.val;
          var pr = pushMargin[k2].r.size;
          if (fr > fl) {
            var newL = (pl * fr + (pr - availableWidth) * fl) / (fr - fl);
            var newR = (pr * (1 - fl) + (pl - availableWidth) * (1 - fr)) / (fr - fl);
            if (newL + newR > ml + mr) {
              ml = newL;
              mr = newR;
            }
          }
        }
        if (isNumeric(pb) && pushMargin[k2].t) {
          var ft = pushMargin[k2].t.val;
          var pt = pushMargin[k2].t.size;
          if (ft > fb) {
            var newB = (pb * ft + (pt - availableHeight) * fb) / (ft - fb);
            var newT = (pt * (1 - fb) + (pb - availableHeight) * (1 - ft)) / (ft - fb);
            if (newB + newT > mb + mt) {
              mb = newB;
              mt = newT;
            }
          }
        }
      }
    }
  }
  var minFinalWidth = Lib.constrain(width - margin.l - margin.r, MIN_SPECIFIED_WIDTH, minreducedwidth);
  var minFinalHeight = Lib.constrain(height - margin.t - margin.b, MIN_SPECIFIED_HEIGHT, minreducedheight);
  var maxSpaceW = Math.max(0, width - minFinalWidth);
  var maxSpaceH = Math.max(0, height - minFinalHeight);
  if (maxSpaceW) {
    var rW = (ml + mr) / maxSpaceW;
    if (rW > 1) {
      ml /= rW;
      mr /= rW;
    }
  }
  if (maxSpaceH) {
    var rH = (mb + mt) / maxSpaceH;
    if (rH > 1) {
      mb /= rH;
      mt /= rH;
    }
  }
  gs.l = Math.round(ml) + reservedMargins.l;
  gs.r = Math.round(mr) + reservedMargins.r;
  gs.t = Math.round(mt) + reservedMargins.t;
  gs.b = Math.round(mb) + reservedMargins.b;
  gs.p = Math.round(margin.pad);
  gs.w = Math.round(width) - gs.l - gs.r;
  gs.h = Math.round(height) - gs.t - gs.b;

  // if things changed and we're not already redrawing, trigger a redraw
  if (!fullLayout._replotting && (plots.didMarginChange(oldMargins, gs) || needsRedrawForShift(gd))) {
    if ('_redrawFromAutoMarginCount' in fullLayout) {
      fullLayout._redrawFromAutoMarginCount++;
    } else {
      fullLayout._redrawFromAutoMarginCount = 1;
    }

    // Always allow at least one redraw and give each margin-push
    // call 3 loops to converge. Of course, for most cases this way too many,
    // but let's keep things on the safe side until we fix our
    // auto-margin pipeline problems:
    // https://github.com/plotly/plotly.js/issues/2704
    var maxNumberOfRedraws = 3 * (1 + Object.keys(pushMarginIds).length);
    if (fullLayout._redrawFromAutoMarginCount < maxNumberOfRedraws) {
      return Registry.call('_doPlot', gd);
    } else {
      fullLayout._size = oldMargins;
      Lib.warn('Too many auto-margin redraws.');
    }
  }
  refineTicks(gd);
};
function refineTicks(gd) {
  var axList = axisIDs.list(gd, '', true);
  ['_adjustTickLabelsOverflow', '_hideCounterAxisInsideTickLabels'].forEach(function (k) {
    for (var i = 0; i < axList.length; i++) {
      var hideFn = axList[i][k];
      if (hideFn) hideFn();
    }
  });
}
var marginKeys = ['l', 'r', 't', 'b', 'p', 'w', 'h'];
plots.didMarginChange = function (margin0, margin1) {
  for (var i = 0; i < marginKeys.length; i++) {
    var k = marginKeys[i];
    var m0 = margin0[k];
    var m1 = margin1[k];
    // use 1px tolerance in case we old/new differ only
    // by rounding errors, which can lead to infinite loops
    if (!isNumeric(m0) || Math.abs(m1 - m0) > 1) {
      return true;
    }
  }
  return false;
};

/**
 * JSONify the graph data and layout
 *
 * This function needs to recurse because some src can be inside
 * sub-objects.
 *
 * It also strips out functions and private (starts with _) elements.
 * Therefore, we can add temporary things to data and layout that don't
 * get saved.
 *
 * @param gd The graphDiv
 * @param {Boolean} dataonly If true, don't return layout.
 * @param {'keepref'|'keepdata'|'keepall'} [mode='keepref'] Filter what's kept
 *      keepref: remove data for which there's a src present
 *          eg if there's xsrc present (and xsrc is well-formed,
 *          ie has : and some chars before it), strip out x
 *      keepdata: remove all src tags, don't remove the data itself
 *      keepall: keep data and src
 * @param {String} output If you specify 'object', the result will not be stringified
 * @param {Boolean} useDefaults If truthy, use _fullLayout and _fullData
 * @param {Boolean} includeConfig If truthy, include _context
 * @returns {Object|String}
 */
plots.graphJson = function (gd, dataonly, mode, output, useDefaults, includeConfig) {
  // if the defaults aren't supplied yet, we need to do that...
  if (useDefaults && dataonly && !gd._fullData || useDefaults && !dataonly && !gd._fullLayout) {
    plots.supplyDefaults(gd);
  }
  var data = useDefaults ? gd._fullData : gd.data;
  var layout = useDefaults ? gd._fullLayout : gd.layout;
  var frames = (gd._transitionData || {})._frames;
  function stripObj(d, keepFunction) {
    if (typeof d === 'function') {
      return keepFunction ? '_function_' : null;
    }
    if (Lib.isPlainObject(d)) {
      var o = {};
      var src;
      Object.keys(d).sort().forEach(function (v) {
        // remove private elements and functions
        // _ is for private, [ is a mistake ie [object Object]
        if (['_', '['].indexOf(v.charAt(0)) !== -1) return;

        // if a function, add if necessary then move on
        if (typeof d[v] === 'function') {
          if (keepFunction) o[v] = '_function';
          return;
        }

        // look for src/data matches and remove the appropriate one
        if (mode === 'keepdata') {
          // keepdata: remove all ...src tags
          if (v.substr(v.length - 3) === 'src') {
            return;
          }
        } else if (mode === 'keepstream') {
          // keep sourced data if it's being streamed.
          // similar to keepref, but if the 'stream' object exists
          // in a trace, we will keep the data array.
          src = d[v + 'src'];
          if (typeof src === 'string' && src.indexOf(':') > 0) {
            if (!Lib.isPlainObject(d.stream)) {
              return;
            }
          }
        } else if (mode !== 'keepall') {
          // keepref: remove sourced data but only
          // if the source tag is well-formed
          src = d[v + 'src'];
          if (typeof src === 'string' && src.indexOf(':') > 0) {
            return;
          }
        }

        // OK, we're including this... recurse into it
        o[v] = stripObj(d[v], keepFunction);
      });
      return o;
    }
    var dIsArray = Array.isArray(d);
    var dIsTypedArray = Lib.isTypedArray(d);
    if ((dIsArray || dIsTypedArray) && d.dtype && d.shape) {
      var bdata = d.bdata;
      return stripObj({
        dtype: d.dtype,
        shape: d.shape,
        bdata:
        // case of ArrayBuffer
        Lib.isArrayBuffer(bdata) ? b64encode.encode(bdata) :
        // case of b64 string
        bdata
      }, keepFunction);
    }
    if (dIsArray) {
      return d.map(function (x) {
        return stripObj(x, keepFunction);
      });
    }
    if (dIsTypedArray) {
      return Lib.simpleMap(d, Lib.identity);
    }

    // convert native dates to date strings...
    // mostly for external users exporting to plotly
    if (Lib.isJSDate(d)) return Lib.ms2DateTimeLocal(+d);
    return d;
  }
  var obj = {
    data: (data || []).map(function (v) {
      var d = stripObj(v);
      // fit has some little arrays in it that don't contain data,
      // just fit params and meta
      if (dataonly) {
        delete d.fit;
      }
      return d;
    })
  };
  if (!dataonly) {
    obj.layout = stripObj(layout);
    if (useDefaults) {
      var gs = layout._size;
      obj.layout.computed = {
        margin: {
          b: gs.b,
          l: gs.l,
          r: gs.r,
          t: gs.t
        }
      };
    }
  }
  if (frames) obj.frames = stripObj(frames);
  if (includeConfig) obj.config = stripObj(gd._context, true);
  return output === 'object' ? obj : JSON.stringify(obj);
};

/**
 * Modify a keyframe using a list of operations:
 *
 * @param {array of objects} operations
 *      Sequence of operations to be performed on the keyframes
 */
plots.modifyFrames = function (gd, operations) {
  var i, op, frame;
  var _frames = gd._transitionData._frames;
  var _frameHash = gd._transitionData._frameHash;
  for (i = 0; i < operations.length; i++) {
    op = operations[i];
    switch (op.type) {
      // No reason this couldn't exist, but is currently unused/untested:
      /* case 'rename':
          frame = _frames[op.index];
          delete _frameHash[frame.name];
          _frameHash[op.name] = frame;
          frame.name = op.name;
          break;*/
      case 'replace':
        frame = op.value;
        var oldName = (_frames[op.index] || {}).name;
        var newName = frame.name;
        _frames[op.index] = _frameHash[newName] = frame;
        if (newName !== oldName) {
          // If name has changed in addition to replacement, then update
          // the lookup table:
          delete _frameHash[oldName];
          _frameHash[newName] = frame;
        }
        break;
      case 'insert':
        frame = op.value;
        _frameHash[frame.name] = frame;
        _frames.splice(op.index, 0, frame);
        break;
      case 'delete':
        frame = _frames[op.index];
        delete _frameHash[frame.name];
        _frames.splice(op.index, 1);
        break;
    }
  }
  return Promise.resolve();
};

/*
 * Compute a keyframe. Merge a keyframe into its base frame(s) and
 * expand properties.
 *
 * @param {object} frameLookup
 *      An object containing frames keyed by name (i.e. gd._transitionData._frameHash)
 * @param {string} frame
 *      The name of the keyframe to be computed
 *
 * Returns: a new object with the merged content
 */
plots.computeFrame = function (gd, frameName) {
  var frameLookup = gd._transitionData._frameHash;
  var i, traceIndices, traceIndex, destIndex;

  // Null or undefined will fail on .toString(). We'll allow numbers since we
  // make it clear frames must be given string names, but we'll allow numbers
  // here since they're otherwise fine for looking up frames as long as they're
  // properly cast to strings. We really just want to ensure here that this
  // 1) doesn't fail, and
  // 2) doens't give an incorrect answer (which String(frameName) would)
  if (!frameName) {
    throw new Error('computeFrame must be given a string frame name');
  }
  var framePtr = frameLookup[frameName.toString()];

  // Return false if the name is invalid:
  if (!framePtr) {
    return false;
  }
  var frameStack = [framePtr];
  var frameNameStack = [framePtr.name];

  // Follow frame pointers:
  while (framePtr.baseframe && (framePtr = frameLookup[framePtr.baseframe.toString()])) {
    // Avoid infinite loops:
    if (frameNameStack.indexOf(framePtr.name) !== -1) break;
    frameStack.push(framePtr);
    frameNameStack.push(framePtr.name);
  }

  // A new object for the merged result:
  var result = {};

  // Merge, starting with the last and ending with the desired frame:
  while (framePtr = frameStack.pop()) {
    if (framePtr.layout) {
      result.layout = plots.extendLayout(result.layout, framePtr.layout);
    }
    if (framePtr.data) {
      if (!result.data) {
        result.data = [];
      }
      traceIndices = framePtr.traces;
      if (!traceIndices) {
        // If not defined, assume serial order starting at zero
        traceIndices = [];
        for (i = 0; i < framePtr.data.length; i++) {
          traceIndices[i] = i;
        }
      }
      if (!result.traces) {
        result.traces = [];
      }
      for (i = 0; i < framePtr.data.length; i++) {
        // Loop through this frames data, find out where it should go,
        // and merge it!
        traceIndex = traceIndices[i];
        if (traceIndex === undefined || traceIndex === null) {
          continue;
        }
        destIndex = result.traces.indexOf(traceIndex);
        if (destIndex === -1) {
          destIndex = result.data.length;
          result.traces[destIndex] = traceIndex;
        }
        result.data[destIndex] = plots.extendTrace(result.data[destIndex], framePtr.data[i]);
      }
    }
  }
  return result;
};

/*
 * Recompute the lookup table that maps frame name -> frame object. addFrames/
 * deleteFrames already manages this data one at a time, so the only time this
 * is necessary is if you poke around manually in `gd._transitionData._frames`
 * and create and haven't updated the lookup table.
 */
plots.recomputeFrameHash = function (gd) {
  var hash = gd._transitionData._frameHash = {};
  var frames = gd._transitionData._frames;
  for (var i = 0; i < frames.length; i++) {
    var frame = frames[i];
    if (frame && frame.name) {
      hash[frame.name] = frame;
    }
  }
};

/**
 * Extend an object, treating container arrays very differently by extracting
 * their contents and merging them separately.
 *
 * This exists so that we can extendDeepNoArrays and avoid stepping into data
 * arrays without knowledge of the plot schema, but so that we may also manually
 * recurse into known container arrays, such as transforms.
 *
 * See extendTrace and extendLayout below for usage.
 */
plots.extendObjectWithContainers = function (dest, src, containerPaths) {
  var containerProp, containerVal, i, j, srcProp, destProp, srcContainer, destContainer;
  var copy = Lib.extendDeepNoArrays({}, src || {});
  var expandedObj = Lib.expandObjectPaths(copy);
  var containerObj = {};

  // Step through and extract any container properties. Otherwise extendDeepNoArrays
  // will clobber any existing properties with an empty array and then supplyDefaults
  // will reset everything to defaults.
  if (containerPaths && containerPaths.length) {
    for (i = 0; i < containerPaths.length; i++) {
      containerProp = Lib.nestedProperty(expandedObj, containerPaths[i]);
      containerVal = containerProp.get();
      if (containerVal === undefined) {
        Lib.nestedProperty(containerObj, containerPaths[i]).set(null);
      } else {
        containerProp.set(null);
        Lib.nestedProperty(containerObj, containerPaths[i]).set(containerVal);
      }
    }
  }
  dest = Lib.extendDeepNoArrays(dest || {}, expandedObj);
  if (containerPaths && containerPaths.length) {
    for (i = 0; i < containerPaths.length; i++) {
      srcProp = Lib.nestedProperty(containerObj, containerPaths[i]);
      srcContainer = srcProp.get();
      if (!srcContainer) continue;
      destProp = Lib.nestedProperty(dest, containerPaths[i]);
      destContainer = destProp.get();
      if (!Array.isArray(destContainer)) {
        destContainer = [];
        destProp.set(destContainer);
      }
      for (j = 0; j < srcContainer.length; j++) {
        var srcObj = srcContainer[j];
        if (srcObj === null) destContainer[j] = null;else {
          destContainer[j] = plots.extendObjectWithContainers(destContainer[j], srcObj);
        }
      }
      destProp.set(destContainer);
    }
  }
  return dest;
};
plots.dataArrayContainers = ['transforms', 'dimensions'];
plots.layoutArrayContainers = Registry.layoutArrayContainers;

/*
 * Extend a trace definition. This method:
 *
 *  1. directly transfers any array references
 *  2. manually recurses into container arrays like transforms
 *
 * The result is the original object reference with the new contents merged in.
 */
plots.extendTrace = function (destTrace, srcTrace) {
  return plots.extendObjectWithContainers(destTrace, srcTrace, plots.dataArrayContainers);
};

/*
 * Extend a layout definition. This method:
 *
 *  1. directly transfers any array references (not critically important for
 *     layout since there aren't really data arrays)
 *  2. manually recurses into container arrays like annotations
 *
 * The result is the original object reference with the new contents merged in.
 */
plots.extendLayout = function (destLayout, srcLayout) {
  return plots.extendObjectWithContainers(destLayout, srcLayout, plots.layoutArrayContainers);
};

/**
 * Transition to a set of new data and layout properties from Plotly.animate
 *
 * @param {DOM element} gd
 * @param {Object[]} data
 *      an array of data objects following the normal Plotly data definition format
 * @param {Object} layout
 *      a layout object, following normal Plotly layout format
 * @param {Number[]} traces
 *      indices of the corresponding traces specified in `data`
 * @param {Object} frameOpts
 *      options for the frame (i.e. whether to redraw post-transition)
 * @param {Object} transitionOpts
 *      options for the transition
 */
plots.transition = function (gd, data, layout, traces, frameOpts, transitionOpts) {
  var opts = {
    redraw: frameOpts.redraw
  };
  var transitionedTraces = {};
  var axEdits = [];
  opts.prepareFn = function () {
    var dataLength = Array.isArray(data) ? data.length : 0;
    var traceIndices = traces.slice(0, dataLength);
    for (var i = 0; i < traceIndices.length; i++) {
      var traceIdx = traceIndices[i];
      var trace = gd._fullData[traceIdx];
      var _module = trace._module;

      // There's nothing to do if this module is not defined:
      if (!_module) continue;

      // Don't register the trace as transitioned if it doesn't know what to do.
      // If it *is* registered, it will receive a callback that it's responsible
      // for calling in order to register the transition as having completed.
      if (_module.animatable) {
        var n = _module.basePlotModule.name;
        if (!transitionedTraces[n]) transitionedTraces[n] = [];
        transitionedTraces[n].push(traceIdx);
      }
      gd.data[traceIndices[i]] = plots.extendTrace(gd.data[traceIndices[i]], data[i]);
    }

    // Follow the same procedure. Clone it so we don't mangle the input, then
    // expand any object paths so we can merge deep into gd.layout:
    var layoutUpdate = Lib.expandObjectPaths(Lib.extendDeepNoArrays({}, layout));

    // Before merging though, we need to modify the incoming layout. We only
    // know how to *transition* layout ranges, so it's imperative that a new
    // range not be sent to the layout before the transition has started. So
    // we must remove the things we can transition:
    var axisAttrRe = /^[xy]axis[0-9]*$/;
    for (var attr in layoutUpdate) {
      if (!axisAttrRe.test(attr)) continue;
      delete layoutUpdate[attr].range;
    }
    plots.extendLayout(gd.layout, layoutUpdate);

    // Supply defaults after applying the incoming properties. Note that any attempt
    // to simplify this step and reduce the amount of work resulted in the reconstruction
    // of essentially the whole supplyDefaults step, so that it seems sensible to just use
    // supplyDefaults even though it's heavier than would otherwise be desired for
    // transitions:

    // first delete calcdata so supplyDefaults knows a calc step is coming
    delete gd.calcdata;
    plots.supplyDefaults(gd);
    plots.doCalcdata(gd);
    var newLayout = Lib.expandObjectPaths(layout);
    if (newLayout) {
      var subplots = gd._fullLayout._plots;
      for (var k in subplots) {
        var plotinfo = subplots[k];
        var xa = plotinfo.xaxis;
        var ya = plotinfo.yaxis;
        var xr0 = xa.range.slice();
        var yr0 = ya.range.slice();
        var xr1 = null;
        var yr1 = null;
        var editX = null;
        var editY = null;
        if (Array.isArray(newLayout[xa._name + '.range'])) {
          xr1 = newLayout[xa._name + '.range'].slice();
        } else if (Array.isArray((newLayout[xa._name] || {}).range)) {
          xr1 = newLayout[xa._name].range.slice();
        }
        if (Array.isArray(newLayout[ya._name + '.range'])) {
          yr1 = newLayout[ya._name + '.range'].slice();
        } else if (Array.isArray((newLayout[ya._name] || {}).range)) {
          yr1 = newLayout[ya._name].range.slice();
        }
        if (xr0 && xr1 && (xa.r2l(xr0[0]) !== xa.r2l(xr1[0]) || xa.r2l(xr0[1]) !== xa.r2l(xr1[1]))) {
          editX = {
            xr0: xr0,
            xr1: xr1
          };
        }
        if (yr0 && yr1 && (ya.r2l(yr0[0]) !== ya.r2l(yr1[0]) || ya.r2l(yr0[1]) !== ya.r2l(yr1[1]))) {
          editY = {
            yr0: yr0,
            yr1: yr1
          };
        }
        if (editX || editY) {
          axEdits.push(Lib.extendFlat({
            plotinfo: plotinfo
          }, editX, editY));
        }
      }
    }
    return Promise.resolve();
  };
  opts.runFn = function (makeCallback) {
    var traceTransitionOpts;
    var basePlotModules = gd._fullLayout._basePlotModules;
    var hasAxisTransition = axEdits.length;
    var i;
    if (layout) {
      for (i = 0; i < basePlotModules.length; i++) {
        if (basePlotModules[i].transitionAxes) {
          basePlotModules[i].transitionAxes(gd, axEdits, transitionOpts, makeCallback);
        }
      }
    }

    // Here handle the exception that we refuse to animate scales and axes at the same
    // time. In other words, if there's an axis transition, then set the data transition
    // to instantaneous.
    if (hasAxisTransition) {
      traceTransitionOpts = Lib.extendFlat({}, transitionOpts);
      traceTransitionOpts.duration = 0;
      // This means do not transition cartesian traces,
      // this happens on layout-only (e.g. axis range) animations
      delete transitionedTraces.cartesian;
    } else {
      traceTransitionOpts = transitionOpts;
    }

    // Note that we pass a callback to *create* the callback that must be invoked on completion.
    // This is since not all traces know about transitions, so it greatly simplifies matters if
    // the trace is responsible for creating a callback, if needed, and then executing it when
    // the time is right.
    for (var n in transitionedTraces) {
      var traceIndices = transitionedTraces[n];
      var _module = gd._fullData[traceIndices[0]]._module;
      _module.basePlotModule.plot(gd, traceIndices, traceTransitionOpts, makeCallback);
    }
  };
  return _transition(gd, transitionOpts, opts);
};

/**
 * Transition to a set of new data and layout properties from Plotly.react
 *
 * @param {DOM element} gd
 * @param {object} restyleFlags
 * - anim {'all'|'some'}
 * @param {object} relayoutFlags
 * - anim {'all'|'some'}
 * @param {object} oldFullLayout : old (pre Plotly.react) fullLayout
 */
plots.transitionFromReact = function (gd, restyleFlags, relayoutFlags, oldFullLayout) {
  var fullLayout = gd._fullLayout;
  var transitionOpts = fullLayout.transition;
  var opts = {};
  var axEdits = [];
  opts.prepareFn = function () {
    var subplots = fullLayout._plots;

    // no need to redraw at end of transition,
    // if all changes are animatable
    opts.redraw = false;
    if (restyleFlags.anim === 'some') opts.redraw = true;
    if (relayoutFlags.anim === 'some') opts.redraw = true;
    for (var k in subplots) {
      var plotinfo = subplots[k];
      var xa = plotinfo.xaxis;
      var ya = plotinfo.yaxis;
      var xr0 = oldFullLayout[xa._name].range.slice();
      var yr0 = oldFullLayout[ya._name].range.slice();
      var xr1 = xa.range.slice();
      var yr1 = ya.range.slice();
      xa.setScale();
      ya.setScale();
      var editX = null;
      var editY = null;
      if (xa.r2l(xr0[0]) !== xa.r2l(xr1[0]) || xa.r2l(xr0[1]) !== xa.r2l(xr1[1])) {
        editX = {
          xr0: xr0,
          xr1: xr1
        };
      }
      if (ya.r2l(yr0[0]) !== ya.r2l(yr1[0]) || ya.r2l(yr0[1]) !== ya.r2l(yr1[1])) {
        editY = {
          yr0: yr0,
          yr1: yr1
        };
      }
      if (editX || editY) {
        axEdits.push(Lib.extendFlat({
          plotinfo: plotinfo
        }, editX, editY));
      }
    }
    return Promise.resolve();
  };
  opts.runFn = function (makeCallback) {
    var fullData = gd._fullData;
    var fullLayout = gd._fullLayout;
    var basePlotModules = fullLayout._basePlotModules;
    var axisTransitionOpts;
    var traceTransitionOpts;
    var transitionedTraces;
    var allTraceIndices = [];
    for (var i = 0; i < fullData.length; i++) {
      allTraceIndices.push(i);
    }
    function transitionAxes() {
      if (!gd._fullLayout) return;
      for (var j = 0; j < basePlotModules.length; j++) {
        if (basePlotModules[j].transitionAxes) {
          basePlotModules[j].transitionAxes(gd, axEdits, axisTransitionOpts, makeCallback);
        }
      }
    }
    function transitionTraces() {
      if (!gd._fullLayout) return;
      for (var j = 0; j < basePlotModules.length; j++) {
        basePlotModules[j].plot(gd, transitionedTraces, traceTransitionOpts, makeCallback);
      }
    }
    if (axEdits.length && restyleFlags.anim) {
      if (transitionOpts.ordering === 'traces first') {
        axisTransitionOpts = Lib.extendFlat({}, transitionOpts, {
          duration: 0
        });
        transitionedTraces = allTraceIndices;
        traceTransitionOpts = transitionOpts;
        setTimeout(transitionAxes, transitionOpts.duration);
        transitionTraces();
      } else {
        axisTransitionOpts = transitionOpts;
        transitionedTraces = null;
        traceTransitionOpts = Lib.extendFlat({}, transitionOpts, {
          duration: 0
        });
        setTimeout(transitionTraces, axisTransitionOpts.duration);
        transitionAxes();
      }
    } else if (axEdits.length) {
      axisTransitionOpts = transitionOpts;
      transitionAxes();
    } else if (restyleFlags.anim) {
      transitionedTraces = allTraceIndices;
      traceTransitionOpts = transitionOpts;
      transitionTraces();
    }
  };
  return _transition(gd, transitionOpts, opts);
};

/**
 * trace/layout transition wrapper that works
 * for transitions initiated by Plotly.animate and Plotly.react.
 *
 * @param {DOM element} gd
 * @param {object} transitionOpts
 * @param {object} opts
 * - redraw {boolean}
 * - prepareFn {function} *should return a Promise*
 * - runFn {function} ran inside executeTransitions
 */
function _transition(gd, transitionOpts, opts) {
  var aborted = false;
  function executeCallbacks(list) {
    var p = Promise.resolve();
    if (!list) return p;
    while (list.length) {
      p = p.then(list.shift());
    }
    return p;
  }
  function flushCallbacks(list) {
    if (!list) return;
    while (list.length) {
      list.shift();
    }
  }
  function executeTransitions() {
    gd.emit('plotly_transitioning', []);
    return new Promise(function (resolve) {
      // This flag is used to disabled things like autorange:
      gd._transitioning = true;

      // When instantaneous updates are coming through quickly, it's too much to simply disable
      // all interaction, so store this flag so we can disambiguate whether mouse interactions
      // should be fully disabled or not:
      if (transitionOpts.duration > 0) {
        gd._transitioningWithDuration = true;
      }

      // If another transition is triggered, this callback will be executed simply because it's
      // in the interruptCallbacks queue. If this transition completes, it will instead flush
      // that queue and forget about this callback.
      gd._transitionData._interruptCallbacks.push(function () {
        aborted = true;
      });
      if (opts.redraw) {
        gd._transitionData._interruptCallbacks.push(function () {
          return Registry.call('redraw', gd);
        });
      }

      // Emit this and make sure it happens last:
      gd._transitionData._interruptCallbacks.push(function () {
        gd.emit('plotly_transitioninterrupted', []);
      });

      // Construct callbacks that are executed on transition end. This ensures the d3 transitions
      // are *complete* before anything else is done.
      var numCallbacks = 0;
      var numCompleted = 0;
      function makeCallback() {
        numCallbacks++;
        return function () {
          numCompleted++;
          // When all are complete, perform a redraw:
          if (!aborted && numCompleted === numCallbacks) {
            completeTransition(resolve);
          }
        };
      }
      opts.runFn(makeCallback);

      // If nothing else creates a callback, then this will trigger the completion in the next tick:
      setTimeout(makeCallback());
    });
  }
  function completeTransition(callback) {
    // This a simple workaround for tests which purge the graph before animations
    // have completed. That's not a very common case, so this is the simplest
    // fix.
    if (!gd._transitionData) return;
    flushCallbacks(gd._transitionData._interruptCallbacks);
    return Promise.resolve().then(function () {
      if (opts.redraw) {
        return Registry.call('redraw', gd);
      }
    }).then(function () {
      // Set transitioning false again once the redraw has occurred. This is used, for example,
      // to prevent the trailing redraw from autoranging:
      gd._transitioning = false;
      gd._transitioningWithDuration = false;
      gd.emit('plotly_transitioned', []);
    }).then(callback);
  }
  function interruptPreviousTransitions() {
    // Fail-safe against purged plot:
    if (!gd._transitionData) return;

    // If a transition is interrupted, set this to false. At the moment, the only thing that would
    // interrupt a transition is another transition, so that it will momentarily be set to true
    // again, but this determines whether autorange or dragbox work, so it's for the sake of
    // cleanliness:
    gd._transitioning = false;
    return executeCallbacks(gd._transitionData._interruptCallbacks);
  }
  var seq = [plots.previousPromises, interruptPreviousTransitions, opts.prepareFn, plots.rehover, plots.reselect, executeTransitions];
  var transitionStarting = Lib.syncOrAsync(seq, gd);
  if (!transitionStarting || !transitionStarting.then) {
    transitionStarting = Promise.resolve();
  }
  return transitionStarting.then(function () {
    return gd;
  });
}
plots.doCalcdata = function (gd, traces) {
  var axList = axisIDs.list(gd);
  var fullData = gd._fullData;
  var fullLayout = gd._fullLayout;
  var trace, _module, i, j;

  // XXX: Is this correct? Needs a closer look so that *some* traces can be recomputed without
  // *all* needing doCalcdata:
  var calcdata = new Array(fullData.length);
  var oldCalcdata = (gd.calcdata || []).slice();
  gd.calcdata = calcdata;

  // extra helper variables

  // how many box/violins plots do we have (in case they're grouped)
  fullLayout._numBoxes = 0;
  fullLayout._numViolins = 0;

  // initialize violin per-scale-group stats container
  fullLayout._violinScaleGroupStats = {};

  // for calculating avg luminosity of heatmaps
  gd._hmpixcount = 0;
  gd._hmlumcount = 0;

  // for sharing colors across pies / sunbursts / treemap / icicle / funnelarea (and for legend)
  fullLayout._piecolormap = {};
  fullLayout._sunburstcolormap = {};
  fullLayout._treemapcolormap = {};
  fullLayout._iciclecolormap = {};
  fullLayout._funnelareacolormap = {};

  // If traces were specified and this trace was not included,
  // then transfer it over from the old calcdata:
  for (i = 0; i < fullData.length; i++) {
    if (Array.isArray(traces) && traces.indexOf(i) === -1) {
      calcdata[i] = oldCalcdata[i];
      continue;
    }
  }
  for (i = 0; i < fullData.length; i++) {
    trace = fullData[i];
    trace._arrayAttrs = PlotSchema.findArrayAttributes(trace);

    // keep track of trace extremes (for autorange) in here
    trace._extremes = {};
  }

  // add polar axes to axis list
  var polarIds = fullLayout._subplots.polar || [];
  for (i = 0; i < polarIds.length; i++) {
    axList.push(fullLayout[polarIds[i]].radialaxis, fullLayout[polarIds[i]].angularaxis);
  }

  // clear relinked cmin/cmax values in shared axes to start aggregation from scratch
  for (var k in fullLayout._colorAxes) {
    var cOpts = fullLayout[k];
    if (cOpts.cauto !== false) {
      delete cOpts.cmin;
      delete cOpts.cmax;
    }
  }
  var hasCalcTransform = false;
  function transformCalci(i) {
    trace = fullData[i];
    _module = trace._module;
    if (trace.visible === true && trace.transforms) {
      // we need one round of trace module calc before
      // the calc transform to 'fill in' the categories list
      // used for example in the data-to-coordinate method
      if (_module && _module.calc) {
        var cdi = _module.calc(gd, trace);

        // must clear scene 'batches', so that 2nd
        // _module.calc call starts from scratch
        if (cdi[0] && cdi[0].t && cdi[0].t._scene) {
          delete cdi[0].t._scene.dirty;
        }
      }
      for (j = 0; j < trace.transforms.length; j++) {
        var transform = trace.transforms[j];
        _module = transformsRegistry[transform.type];
        if (_module && _module.calcTransform) {
          trace._hasCalcTransform = true;
          hasCalcTransform = true;
          _module.calcTransform(gd, trace, transform);
        }
      }
    }
  }
  function calci(i, isContainer) {
    trace = fullData[i];
    _module = trace._module;
    if (!!_module.isContainer !== isContainer) return;
    var cd = [];
    if (trace.visible === true && trace._length !== 0) {
      // clear existing ref in case it got relinked
      delete trace._indexToPoints;
      // keep ref of index-to-points map object of the *last* enabled transform,
      // this index-to-points map object is required to determine the calcdata indices
      // that correspond to input indices (e.g. from 'selectedpoints')
      var transforms = trace.transforms || [];
      for (j = transforms.length - 1; j >= 0; j--) {
        if (transforms[j].enabled) {
          trace._indexToPoints = transforms[j]._indexToPoints;
          break;
        }
      }
      if (_module && _module.calc) {
        cd = _module.calc(gd, trace);
      }
    }

    // Make sure there is a first point.
    //
    // This ensures there is a calcdata item for every trace,
    // even if cartesian logic doesn't handle it (for things like legends).
    if (!Array.isArray(cd) || !cd[0]) {
      cd = [{
        x: BADNUM,
        y: BADNUM
      }];
    }

    // add the trace-wide properties to the first point,
    // per point properties to every point
    // t is the holder for trace-wide properties
    if (!cd[0].t) cd[0].t = {};
    cd[0].trace = trace;
    calcdata[i] = cd;
  }
  setupAxisCategories(axList, fullData, fullLayout);

  // 'transform' loop - must calc container traces first
  // so that if their dependent traces can get transform properly
  for (i = 0; i < fullData.length; i++) calci(i, true);
  for (i = 0; i < fullData.length; i++) transformCalci(i);

  // clear stuff that should recomputed in 'regular' loop
  if (hasCalcTransform) setupAxisCategories(axList, fullData, fullLayout);

  // 'regular' loop - make sure container traces (eg carpet) calc before
  // contained traces (eg contourcarpet)
  for (i = 0; i < fullData.length; i++) calci(i, true);
  for (i = 0; i < fullData.length; i++) calci(i, false);
  doCrossTraceCalc(gd);

  // Sort axis categories per value if specified
  var sorted = sortAxisCategoriesByValue(axList, gd);
  if (sorted.length) {
    // how many box/violins plots do we have (in case they're grouped)
    fullLayout._numBoxes = 0;
    fullLayout._numViolins = 0;
    // If a sort operation was performed, run calc() again
    for (i = 0; i < sorted.length; i++) calci(sorted[i], true);
    for (i = 0; i < sorted.length; i++) calci(sorted[i], false);
    doCrossTraceCalc(gd);
  }
  Registry.getComponentMethod('fx', 'calc')(gd);
  Registry.getComponentMethod('errorbars', 'calc')(gd);
};
var sortAxisCategoriesByValueRegex = /(total|sum|min|max|mean|geometric mean|median) (ascending|descending)/;
function sortAxisCategoriesByValue(axList, gd) {
  var affectedTraces = [];
  var i, j, k, l, o;
  function zMapCategory(type, ax, value) {
    var axLetter = ax._id.charAt(0);
    if (type === 'histogram2dcontour') {
      var counterAxLetter = ax._counterAxes[0];
      var counterAx = axisIDs.getFromId(gd, counterAxLetter);
      var xCategorical = axLetter === 'x' || counterAxLetter === 'x' && counterAx.type === 'category';
      var yCategorical = axLetter === 'y' || counterAxLetter === 'y' && counterAx.type === 'category';
      return function (o, l) {
        if (o === 0 || l === 0) return -1; // Skip first row and column
        if (xCategorical && o === value[l].length - 1) return -1;
        if (yCategorical && l === value.length - 1) return -1;
        return (axLetter === 'y' ? l : o) - 1;
      };
    } else {
      return function (o, l) {
        return axLetter === 'y' ? l : o;
      };
    }
  }
  var aggFn = {
    min: function (values) {
      return Lib.aggNums(Math.min, null, values);
    },
    max: function (values) {
      return Lib.aggNums(Math.max, null, values);
    },
    sum: function (values) {
      return Lib.aggNums(function (a, b) {
        return a + b;
      }, null, values);
    },
    total: function (values) {
      return Lib.aggNums(function (a, b) {
        return a + b;
      }, null, values);
    },
    mean: function (values) {
      return Lib.mean(values);
    },
    'geometric mean': function (values) {
      return Lib.geometricMean(values);
    },
    median: function (values) {
      return Lib.median(values);
    }
  };
  function sortAscending(a, b) {
    return a[1] - b[1];
  }
  function sortDescending(a, b) {
    return b[1] - a[1];
  }
  for (i = 0; i < axList.length; i++) {
    var ax = axList[i];
    if (ax.type !== 'category') continue;

    // Order by value
    var match = ax.categoryorder.match(sortAxisCategoriesByValueRegex);
    if (match) {
      var aggregator = match[1];
      var order = match[2];
      var axLetter = ax._id.charAt(0);
      var isX = axLetter === 'x';

      // Store values associated with each category
      var categoriesValue = [];
      for (j = 0; j < ax._categories.length; j++) {
        categoriesValue.push([ax._categories[j], []]);
      }

      // Collect values across traces
      for (j = 0; j < ax._traceIndices.length; j++) {
        var traceIndex = ax._traceIndices[j];
        var fullTrace = gd._fullData[traceIndex];

        // Skip over invisible traces
        if (fullTrace.visible !== true) continue;
        var type = fullTrace.type;
        if (Registry.traceIs(fullTrace, 'histogram')) {
          delete fullTrace._xautoBinFinished;
          delete fullTrace._yautoBinFinished;
        }
        var isSplom = type === 'splom';
        var isScattergl = type === 'scattergl';
        var cd = gd.calcdata[traceIndex];
        for (k = 0; k < cd.length; k++) {
          var cdi = cd[k];
          var catIndex, value;
          if (isSplom) {
            // If `splom`, collect values across dimensions
            // Find which dimension the current axis is representing
            var currentDimensionIndex = fullTrace._axesDim[ax._id];

            // Apply logic to associated x axis if it's defined
            if (!isX) {
              var associatedXAxisID = fullTrace._diag[currentDimensionIndex][0];
              if (associatedXAxisID) ax = gd._fullLayout[axisIDs.id2name(associatedXAxisID)];
            }
            var categories = cdi.trace.dimensions[currentDimensionIndex].values;
            for (l = 0; l < categories.length; l++) {
              catIndex = ax._categoriesMap[categories[l]];

              // Collect associated values at index `l` over all other dimensions
              for (o = 0; o < cdi.trace.dimensions.length; o++) {
                if (o === currentDimensionIndex) continue;
                var dimension = cdi.trace.dimensions[o];
                categoriesValue[catIndex][1].push(dimension.values[l]);
              }
            }
          } else if (isScattergl) {
            // If `scattergl`, collect all values stashed under cdi.t
            for (l = 0; l < cdi.t.x.length; l++) {
              if (isX) {
                catIndex = cdi.t.x[l];
                value = cdi.t.y[l];
              } else {
                catIndex = cdi.t.y[l];
                value = cdi.t.x[l];
              }
              categoriesValue[catIndex][1].push(value);
            }
            // must clear scene 'batches', so that 2nd
            // _module.calc call starts from scratch
            if (cdi.t && cdi.t._scene) {
              delete cdi.t._scene.dirty;
            }
          } else if (cdi.hasOwnProperty('z')) {
            // If 2dMap, collect values in `z`
            value = cdi.z;
            var mapping = zMapCategory(fullTrace.type, ax, value);
            for (l = 0; l < value.length; l++) {
              for (o = 0; o < value[l].length; o++) {
                catIndex = mapping(o, l);
                if (catIndex + 1) categoriesValue[catIndex][1].push(value[l][o]);
              }
            }
          } else {
            // For all other 2d cartesian traces
            catIndex = cdi.p;
            if (catIndex === undefined) catIndex = cdi[axLetter];
            value = cdi.s;
            if (value === undefined) value = cdi.v;
            if (value === undefined) value = isX ? cdi.y : cdi.x;
            if (!Array.isArray(value)) {
              if (value === undefined) value = [];else value = [value];
            }
            for (l = 0; l < value.length; l++) {
              categoriesValue[catIndex][1].push(value[l]);
            }
          }
        }
      }
      ax._categoriesValue = categoriesValue;
      var categoriesAggregatedValue = [];
      for (j = 0; j < categoriesValue.length; j++) {
        categoriesAggregatedValue.push([categoriesValue[j][0], aggFn[aggregator](categoriesValue[j][1])]);
      }

      // Sort by aggregated value
      categoriesAggregatedValue.sort(order === 'descending' ? sortDescending : sortAscending);
      ax._categoriesAggregatedValue = categoriesAggregatedValue;

      // Set new category order
      ax._initialCategories = categoriesAggregatedValue.map(function (c) {
        return c[0];
      });

      // Sort all matching axes
      affectedTraces = affectedTraces.concat(ax.sortByInitialCategories());
    }
  }
  return affectedTraces;
}
function setupAxisCategories(axList, fullData, fullLayout) {
  var axLookup = {};
  function setupOne(ax) {
    ax.clearCalc();
    if (ax.type === 'multicategory') {
      ax.setupMultiCategory(fullData);
    }
    axLookup[ax._id] = 1;
  }
  Lib.simpleMap(axList, setupOne);

  // look into match groups for 'missing' axes
  var matchGroups = fullLayout._axisMatchGroups || [];
  for (var i = 0; i < matchGroups.length; i++) {
    for (var axId in matchGroups[i]) {
      if (!axLookup[axId]) {
        setupOne(fullLayout[axisIDs.id2name(axId)]);
      }
    }
  }
}
function doCrossTraceCalc(gd) {
  var fullLayout = gd._fullLayout;
  var modules = fullLayout._visibleModules;
  var hash = {};
  var i, j, k;

  // position and range calculations for traces that
  // depend on each other ie bars (stacked or grouped)
  // and boxes (grouped) push each other out of the way

  for (j = 0; j < modules.length; j++) {
    var _module = modules[j];
    var fn = _module.crossTraceCalc;
    if (fn) {
      var spType = _module.basePlotModule.name;
      if (hash[spType]) {
        Lib.pushUnique(hash[spType], fn);
      } else {
        hash[spType] = [fn];
      }
    }
  }
  for (k in hash) {
    var methods = hash[k];
    var subplots = fullLayout._subplots[k];
    if (Array.isArray(subplots)) {
      for (i = 0; i < subplots.length; i++) {
        var sp = subplots[i];
        var spInfo = k === 'cartesian' ? fullLayout._plots[sp] : fullLayout[sp];
        for (j = 0; j < methods.length; j++) {
          methods[j](gd, spInfo, sp);
        }
      }
    } else {
      for (j = 0; j < methods.length; j++) {
        methods[j](gd);
      }
    }
  }
}
plots.rehover = function (gd) {
  if (gd._fullLayout._rehover) {
    gd._fullLayout._rehover();
  }
};
plots.redrag = function (gd) {
  if (gd._fullLayout._redrag) {
    gd._fullLayout._redrag();
  }
};
plots.reselect = function (gd) {
  var fullLayout = gd._fullLayout;
  var A = (gd.layout || {}).selections;
  var B = fullLayout._previousSelections;
  fullLayout._previousSelections = A;
  var mayEmitSelected = fullLayout._reselect || JSON.stringify(A) !== JSON.stringify(B);
  Registry.getComponentMethod('selections', 'reselect')(gd, mayEmitSelected);
};
plots.generalUpdatePerTraceModule = function (gd, subplot, subplotCalcData, subplotLayout) {
  var traceHashOld = subplot.traceHash;
  var traceHash = {};
  var i;

  // build up moduleName -> calcData hash
  for (i = 0; i < subplotCalcData.length; i++) {
    var calcTraces = subplotCalcData[i];
    var trace = calcTraces[0].trace;

    // skip over visible === false traces
    // as they don't have `_module` ref
    if (trace.visible) {
      traceHash[trace.type] = traceHash[trace.type] || [];
      traceHash[trace.type].push(calcTraces);
    }
  }

  // when a trace gets deleted, make sure that its module's
  // plot method is called so that it is properly
  // removed from the DOM.
  for (var moduleNameOld in traceHashOld) {
    if (!traceHash[moduleNameOld]) {
      var fakeCalcTrace = traceHashOld[moduleNameOld][0];
      var fakeTrace = fakeCalcTrace[0].trace;
      fakeTrace.visible = false;
      traceHash[moduleNameOld] = [fakeCalcTrace];
    }
  }

  // call module plot method
  for (var moduleName in traceHash) {
    var moduleCalcData = traceHash[moduleName];
    var _module = moduleCalcData[0][0].trace._module;
    _module.plot(gd, subplot, Lib.filterVisible(moduleCalcData), subplotLayout);
  }

  // update moduleName -> calcData hash
  subplot.traceHash = traceHash;
};
plots.plotBasePlot = function (desiredType, gd, traces, transitionOpts, makeOnCompleteCallback) {
  var _module = Registry.getModule(desiredType);
  var cdmodule = getModuleCalcData(gd.calcdata, _module)[0];
  _module.plot(gd, cdmodule, transitionOpts, makeOnCompleteCallback);
};
plots.cleanBasePlot = function (desiredType, newFullData, newFullLayout, oldFullData, oldFullLayout) {
  var had = oldFullLayout._has && oldFullLayout._has(desiredType);
  var has = newFullLayout._has && newFullLayout._has(desiredType);
  if (had && !has) {
    oldFullLayout['_' + desiredType + 'layer'].selectAll('g.trace').remove();
  }
};

/***/ }),

/***/ 26484:
/***/ (function(module) {

"use strict";


module.exports = {
  attr: 'subplot',
  name: 'polar',
  axisNames: ['angularaxis', 'radialaxis'],
  axisName2dataArray: {
    angularaxis: 'theta',
    radialaxis: 'r'
  },
  layerNames: ['draglayer', 'plotbg', 'backplot', 'angular-grid', 'radial-grid', 'frontplot', 'angular-line', 'radial-line', 'angular-axis', 'radial-axis'],
  radialDragBoxSize: 50,
  angularDragBoxSize: 30,
  cornerLen: 25,
  cornerHalfWidth: 2,
  // pixels to move mouse before you stop clamping to starting point
  MINDRAG: 8,
  // smallest radial distance [px] allowed for a zoombox
  MINZOOM: 20,
  // distance [px] off (r=0) or (r=radius) where we transition
  // from single-sided to two-sided radial zoom
  OFFEDGE: 20
};

/***/ }),

/***/ 95928:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var polygonTester = (__webpack_require__(80899).tester);
var findIndexOfMin = Lib.findIndexOfMin;
var isAngleInsideSector = Lib.isAngleInsideSector;
var angleDelta = Lib.angleDelta;
var angleDist = Lib.angleDist;

/**
 * is pt (r,a) inside polygon made up vertices at angles 'vangles'
 * inside a given polar sector
 *
 * @param {number} r : pt's radial coordinate
 * @param {number} a : pt's angular coordinate in *radians*
 * @param {2-item array} rBnds : sector's radial bounds
 * @param {2-item array} aBnds : sector's angular bounds *radians*
 * @param {array} vangles : angles of polygon vertices in *radians*
 * @return {boolean}
 */
function isPtInsidePolygon(r, a, rBnds, aBnds, vangles) {
  if (!isAngleInsideSector(a, aBnds)) return false;
  var r0, r1;
  if (rBnds[0] < rBnds[1]) {
    r0 = rBnds[0];
    r1 = rBnds[1];
  } else {
    r0 = rBnds[1];
    r1 = rBnds[0];
  }
  var polygonIn = polygonTester(makePolygon(r0, aBnds[0], aBnds[1], vangles));
  var polygonOut = polygonTester(makePolygon(r1, aBnds[0], aBnds[1], vangles));
  var xy = [r * Math.cos(a), r * Math.sin(a)];
  return polygonOut.contains(xy) && !polygonIn.contains(xy);
}

// find intersection of 'v0' <-> 'v1' edge with a ray at angle 'a'
// (i.e. a line that starts from the origin at angle 'a')
// given an (xp,yp) pair on the 'v0' <-> 'v1' line
// (N.B. 'v0' and 'v1' are angles in radians)
function findIntersectionXY(v0, v1, a, xpyp) {
  var xstar, ystar;
  var xp = xpyp[0];
  var yp = xpyp[1];
  var dsin = clampTiny(Math.sin(v1) - Math.sin(v0));
  var dcos = clampTiny(Math.cos(v1) - Math.cos(v0));
  var tanA = Math.tan(a);
  var cotanA = clampTiny(1 / tanA);
  var m = dsin / dcos;
  var b = yp - m * xp;
  if (cotanA) {
    if (dsin && dcos) {
      // given
      //  g(x) := v0 -> v1 line = m*x + b
      //  h(x) := ray at angle 'a' = m*x = tanA*x
      // solve g(xstar) = h(xstar)
      xstar = b / (tanA - m);
      ystar = tanA * xstar;
    } else if (dcos) {
      // horizontal v0 -> v1
      xstar = yp * cotanA;
      ystar = yp;
    } else {
      // vertical v0 -> v1
      xstar = xp;
      ystar = xp * tanA;
    }
  } else {
    // vertical ray
    if (dsin && dcos) {
      xstar = 0;
      ystar = b;
    } else if (dcos) {
      xstar = 0;
      ystar = yp;
    } else {
      // does this case exists?
      xstar = ystar = NaN;
    }
  }
  return [xstar, ystar];
}

// solves l^2 = (f(x)^2 - yp)^2 + (x - xp)^2
// rearranged into 0 = a*x^2 + b * x + c
//
// where f(x) = m*x + t + yp
// and   (x0, x1) = (-b +/- del) / (2*a)
function findXYatLength(l, m, xp, yp) {
  var t = -m * xp;
  var a = m * m + 1;
  var b = 2 * (m * t - xp);
  var c = t * t + xp * xp - l * l;
  var del = Math.sqrt(b * b - 4 * a * c);
  var x0 = (-b + del) / (2 * a);
  var x1 = (-b - del) / (2 * a);
  return [[x0, m * x0 + t + yp], [x1, m * x1 + t + yp]];
}
function makeRegularPolygon(r, vangles) {
  var len = vangles.length;
  var vertices = new Array(len + 1);
  var i;
  for (i = 0; i < len; i++) {
    var va = vangles[i];
    vertices[i] = [r * Math.cos(va), r * Math.sin(va)];
  }
  vertices[i] = vertices[0].slice();
  return vertices;
}
function makeClippedPolygon(r, a0, a1, vangles) {
  var len = vangles.length;
  var vertices = [];
  var i, j;
  function a2xy(a) {
    return [r * Math.cos(a), r * Math.sin(a)];
  }
  function findXY(va0, va1, s) {
    return findIntersectionXY(va0, va1, s, a2xy(va0));
  }
  function cycleIndex(ind) {
    return Lib.mod(ind, len);
  }
  function isInside(v) {
    return isAngleInsideSector(v, [a0, a1]);
  }

  // find index in sector closest to a0
  // use it to find intersection of v[i0] <-> v[i0-1] edge with sector radius
  var i0 = findIndexOfMin(vangles, function (v) {
    return isInside(v) ? angleDist(v, a0) : Infinity;
  });
  var xy0 = findXY(vangles[i0], vangles[cycleIndex(i0 - 1)], a0);
  vertices.push(xy0);

  // fill in in-sector vertices
  for (i = i0, j = 0; j < len; i++, j++) {
    var va = vangles[cycleIndex(i)];
    if (!isInside(va)) break;
    vertices.push(a2xy(va));
  }

  // find index in sector closest to a1,
  // use it to find intersection of v[iN] <-> v[iN+1] edge with sector radius
  var iN = findIndexOfMin(vangles, function (v) {
    return isInside(v) ? angleDist(v, a1) : Infinity;
  });
  var xyN = findXY(vangles[iN], vangles[cycleIndex(iN + 1)], a1);
  vertices.push(xyN);
  vertices.push([0, 0]);
  vertices.push(vertices[0].slice());
  return vertices;
}
function makePolygon(r, a0, a1, vangles) {
  return Lib.isFullCircle([a0, a1]) ? makeRegularPolygon(r, vangles) : makeClippedPolygon(r, a0, a1, vangles);
}
function findPolygonOffset(r, a0, a1, vangles) {
  var minX = Infinity;
  var minY = Infinity;
  var vertices = makePolygon(r, a0, a1, vangles);
  for (var i = 0; i < vertices.length; i++) {
    var v = vertices[i];
    minX = Math.min(minX, v[0]);
    minY = Math.min(minY, -v[1]);
  }
  return [minX, minY];
}

/**
 * find vertex angles (in 'vangles') the enclose angle 'a'
 *
 * @param {number} a : angle in *radians*
 * @param {array} vangles : angles of polygon vertices in *radians*
 * @return {2-item array}
 */
function findEnclosingVertexAngles(a, vangles) {
  var minFn = function (v) {
    var adelta = angleDelta(v, a);
    return adelta > 0 ? adelta : Infinity;
  };
  var i0 = findIndexOfMin(vangles, minFn);
  var i1 = Lib.mod(i0 + 1, vangles.length);
  return [vangles[i0], vangles[i1]];
}

// to more easily catch 'almost zero' numbers in if-else blocks
function clampTiny(v) {
  return Math.abs(v) > 1e-10 ? v : 0;
}
function transformForSVG(pts0, cx, cy) {
  cx = cx || 0;
  cy = cy || 0;
  var len = pts0.length;
  var pts1 = new Array(len);
  for (var i = 0; i < len; i++) {
    var pt = pts0[i];
    pts1[i] = [cx + pt[0], cy - pt[1]];
  }
  return pts1;
}

/**
 * path polygon
 *
 * @param {number} r : polygon 'radius'
 * @param {number} a0 : first angular coordinate in *radians*
 * @param {number} a1 : second angular coordinate in *radians*
 * @param {array} vangles : angles of polygon vertices in *radians*
 * @param {number (optional)} cx : x coordinate of center
 * @param {number (optional)} cy : y coordinate of center
 * @return {string} svg path
 *
 */
function pathPolygon(r, a0, a1, vangles, cx, cy) {
  var poly = makePolygon(r, a0, a1, vangles);
  return 'M' + transformForSVG(poly, cx, cy).join('L');
}

/**
 * path a polygon 'annulus'
 * i.e. a polygon with a concentric hole
 *
 * N.B. this routine uses the evenodd SVG rule
 *
 * @param {number} r0 : first radial coordinate
 * @param {number} r1 : second radial coordinate
 * @param {number} a0 : first angular coordinate in *radians*
 * @param {number} a1 : second angular coordinate in *radians*
 * @param {array} vangles : angles of polygon vertices in *radians*
 * @param {number (optional)} cx : x coordinate of center
 * @param {number (optional)} cy : y coordinate of center
 * @return {string} svg path
 *
 */
function pathPolygonAnnulus(r0, r1, a0, a1, vangles, cx, cy) {
  var rStart, rEnd;
  if (r0 < r1) {
    rStart = r0;
    rEnd = r1;
  } else {
    rStart = r1;
    rEnd = r0;
  }
  var inner = transformForSVG(makePolygon(rStart, a0, a1, vangles), cx, cy);
  var outer = transformForSVG(makePolygon(rEnd, a0, a1, vangles), cx, cy);
  return 'M' + outer.reverse().join('L') + 'M' + inner.join('L');
}
module.exports = {
  isPtInsidePolygon: isPtInsidePolygon,
  findPolygonOffset: findPolygonOffset,
  findEnclosingVertexAngles: findEnclosingVertexAngles,
  findIntersectionXY: findIntersectionXY,
  findXYatLength: findXYatLength,
  clampTiny: clampTiny,
  pathPolygon: pathPolygon,
  pathPolygonAnnulus: pathPolygonAnnulus
};

/***/ }),

/***/ 31645:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var getSubplotCalcData = (__webpack_require__(4173)/* .getSubplotCalcData */ .fX);
var counterRegex = (__webpack_require__(34809).counterRegex);
var createPolar = __webpack_require__(35785);
var constants = __webpack_require__(26484);
var attr = constants.attr;
var name = constants.name;
var counter = counterRegex(name);
var attributes = {};
attributes[attr] = {
  valType: 'subplotid',
  dflt: name,
  editType: 'calc'
};
function plot(gd) {
  var fullLayout = gd._fullLayout;
  var calcData = gd.calcdata;
  var subplotIds = fullLayout._subplots[name];
  for (var i = 0; i < subplotIds.length; i++) {
    var id = subplotIds[i];
    var subplotCalcData = getSubplotCalcData(calcData, name, id);
    var subplot = fullLayout[id]._subplot;
    if (!subplot) {
      subplot = createPolar(gd, id);
      fullLayout[id]._subplot = subplot;
    }
    subplot.plot(subplotCalcData, fullLayout, gd._promises);
  }
}
function clean(newFullData, newFullLayout, oldFullData, oldFullLayout) {
  var oldIds = oldFullLayout._subplots[name] || [];
  var hadGl = oldFullLayout._has && oldFullLayout._has('gl');
  var hasGl = newFullLayout._has && newFullLayout._has('gl');
  var mustCleanScene = hadGl && !hasGl;
  for (var i = 0; i < oldIds.length; i++) {
    var id = oldIds[i];
    var oldSubplot = oldFullLayout[id]._subplot;
    if (!newFullLayout[id] && !!oldSubplot) {
      oldSubplot.framework.remove();
      oldSubplot.layers['radial-axis-title'].remove();
      for (var k in oldSubplot.clipPaths) {
        oldSubplot.clipPaths[k].remove();
      }
    }
    if (mustCleanScene && oldSubplot._scene) {
      oldSubplot._scene.destroy();
      oldSubplot._scene = null;
    }
  }
}
module.exports = {
  attr: attr,
  name: name,
  idRoot: name,
  idRegex: counter,
  attrRegex: counter,
  attributes: attributes,
  layoutAttributes: __webpack_require__(42219),
  supplyLayoutDefaults: __webpack_require__(84588),
  plot: plot,
  clean: clean,
  toSVG: (__webpack_require__(37703).toSVG)
};

/***/ }),

/***/ 42219:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var colorAttrs = __webpack_require__(10229);
var axesAttrs = __webpack_require__(25829);
var domainAttrs = (__webpack_require__(13792)/* .attributes */ .u);
var extendFlat = (__webpack_require__(34809).extendFlat);
var overrideAll = (__webpack_require__(13582).overrideAll);
var axisLineGridAttr = overrideAll({
  color: axesAttrs.color,
  showline: extendFlat({}, axesAttrs.showline, {
    dflt: true
  }),
  linecolor: axesAttrs.linecolor,
  linewidth: axesAttrs.linewidth,
  showgrid: extendFlat({}, axesAttrs.showgrid, {
    dflt: true
  }),
  gridcolor: axesAttrs.gridcolor,
  gridwidth: axesAttrs.gridwidth,
  griddash: axesAttrs.griddash

  // TODO add spike* attributes down the road

  // should we add zeroline* attributes?
}, 'plot', 'from-root');
var axisTickAttrs = overrideAll({
  tickmode: axesAttrs.minor.tickmode,
  nticks: axesAttrs.nticks,
  tick0: axesAttrs.tick0,
  dtick: axesAttrs.dtick,
  tickvals: axesAttrs.tickvals,
  ticktext: axesAttrs.ticktext,
  ticks: axesAttrs.ticks,
  ticklen: axesAttrs.ticklen,
  tickwidth: axesAttrs.tickwidth,
  tickcolor: axesAttrs.tickcolor,
  ticklabelstep: axesAttrs.ticklabelstep,
  showticklabels: axesAttrs.showticklabels,
  labelalias: axesAttrs.labelalias,
  showtickprefix: axesAttrs.showtickprefix,
  tickprefix: axesAttrs.tickprefix,
  showticksuffix: axesAttrs.showticksuffix,
  ticksuffix: axesAttrs.ticksuffix,
  showexponent: axesAttrs.showexponent,
  exponentformat: axesAttrs.exponentformat,
  minexponent: axesAttrs.minexponent,
  separatethousands: axesAttrs.separatethousands,
  tickfont: axesAttrs.tickfont,
  tickangle: axesAttrs.tickangle,
  tickformat: axesAttrs.tickformat,
  tickformatstops: axesAttrs.tickformatstops,
  layer: axesAttrs.layer
}, 'plot', 'from-root');
var radialAxisAttrs = {
  visible: extendFlat({}, axesAttrs.visible, {
    dflt: true
  }),
  type: extendFlat({}, axesAttrs.type, {
    values: ['-', 'linear', 'log', 'date', 'category']
  }),
  autotypenumbers: axesAttrs.autotypenumbers,
  autorangeoptions: {
    minallowed: axesAttrs.autorangeoptions.minallowed,
    maxallowed: axesAttrs.autorangeoptions.maxallowed,
    clipmin: axesAttrs.autorangeoptions.clipmin,
    clipmax: axesAttrs.autorangeoptions.clipmax,
    include: axesAttrs.autorangeoptions.include,
    editType: 'plot'
  },
  autorange: extendFlat({}, axesAttrs.autorange, {
    editType: 'plot'
  }),
  rangemode: {
    valType: 'enumerated',
    values: ['tozero', 'nonnegative', 'normal'],
    dflt: 'tozero',
    editType: 'calc'
  },
  minallowed: extendFlat({}, axesAttrs.minallowed, {
    editType: 'plot'
  }),
  maxallowed: extendFlat({}, axesAttrs.maxallowed, {
    editType: 'plot'
  }),
  range: extendFlat({}, axesAttrs.range, {
    items: [{
      valType: 'any',
      editType: 'plot',
      impliedEdits: {
        '^autorange': false
      }
    }, {
      valType: 'any',
      editType: 'plot',
      impliedEdits: {
        '^autorange': false
      }
    }],
    editType: 'plot'
  }),
  categoryorder: axesAttrs.categoryorder,
  categoryarray: axesAttrs.categoryarray,
  angle: {
    valType: 'angle',
    editType: 'plot'
  },
  autotickangles: axesAttrs.autotickangles,
  side: {
    valType: 'enumerated',
    // TODO add 'center' for `showline: false` radial axes
    values: ['clockwise', 'counterclockwise'],
    dflt: 'clockwise',
    editType: 'plot'
  },
  title: {
    // radial title is not gui-editable at the moment,
    // so it needs dflt: '', similar to carpet axes.
    text: extendFlat({}, axesAttrs.title.text, {
      editType: 'plot',
      dflt: ''
    }),
    font: extendFlat({}, axesAttrs.title.font, {
      editType: 'plot'
    }),
    // TODO
    // - might need a 'titleside' and even 'titledirection' down the road
    // - what about standoff ??

    editType: 'plot'
  },
  hoverformat: axesAttrs.hoverformat,
  uirevision: {
    valType: 'any',
    editType: 'none'
  },
  editType: 'calc',
  _deprecated: {
    title: axesAttrs._deprecated.title,
    titlefont: axesAttrs._deprecated.titlefont
  }
};
extendFlat(radialAxisAttrs,
// N.B. radialaxis grid lines are circular,
// but radialaxis lines are straight from circle center to outer bound
axisLineGridAttr, axisTickAttrs);
var angularAxisAttrs = {
  visible: extendFlat({}, axesAttrs.visible, {
    dflt: true
  }),
  type: {
    valType: 'enumerated',
    // 'linear' should maybe be called 'angle' or 'angular' here
    // to make clear that axis here is periodic and more tightly match
    // `thetaunit`?
    //
    // skip 'date' for first push
    // no 'log' for now
    values: ['-', 'linear', 'category'],
    dflt: '-',
    editType: 'calc',
    _noTemplating: true
  },
  autotypenumbers: axesAttrs.autotypenumbers,
  categoryorder: axesAttrs.categoryorder,
  categoryarray: axesAttrs.categoryarray,
  thetaunit: {
    valType: 'enumerated',
    values: ['radians', 'degrees'],
    dflt: 'degrees',
    editType: 'calc'
  },
  period: {
    valType: 'number',
    editType: 'calc',
    min: 0
    // Examples for date axes:
    //
    // - period that equals the timeseries length
    //  http://flowingdata.com/2017/01/24/one-dataset-visualized-25-ways/18-polar-coordinates/
    // - and 1-year periods (focusing on seasonal change0
    //  http://otexts.org/fpp2/seasonal-plots.html
    //  https://blogs.scientificamerican.com/sa-visual/why-are-so-many-babies-born-around-8-00-a-m/
    //  http://www.seasonaladjustment.com/2012/09/05/clock-plot-visualising-seasonality-using-r-and-ggplot2-part-3/
    //  https://i.pinimg.com/736x/49/b9/72/49b972ccb3206a1a6d6f870dac543280.jpg
    //  https://www.climate-lab-book.ac.uk/spirals/
  },
  direction: {
    valType: 'enumerated',
    values: ['counterclockwise', 'clockwise'],
    dflt: 'counterclockwise',
    editType: 'calc'
  },
  rotation: {
    valType: 'angle',
    editType: 'calc'
  },
  hoverformat: axesAttrs.hoverformat,
  uirevision: {
    valType: 'any',
    editType: 'none'
  },
  editType: 'calc'
};
extendFlat(angularAxisAttrs,
// N.B. angular grid lines are straight lines from circle center to outer bound
// the angular line is circular bounding the polar plot area.
axisLineGridAttr,
// N.B. ticksuffix defaults to '°' for angular axes with `thetaunit: 'degrees'`
axisTickAttrs);
module.exports = {
  // TODO for x/y/zoom system for paper-based zooming:
  // x: {},
  // y: {},
  // zoom: {},

  domain: domainAttrs({
    name: 'polar',
    editType: 'plot'
  }),
  sector: {
    valType: 'info_array',
    items: [{
      valType: 'number',
      editType: 'plot'
    }, {
      valType: 'number',
      editType: 'plot'
    }],
    dflt: [0, 360],
    editType: 'plot'
  },
  hole: {
    valType: 'number',
    min: 0,
    max: 1,
    dflt: 0,
    editType: 'plot'
  },
  bgcolor: {
    valType: 'color',
    editType: 'plot',
    dflt: colorAttrs.background
  },
  radialaxis: radialAxisAttrs,
  angularaxis: angularAxisAttrs,
  gridshape: {
    valType: 'enumerated',
    values: ['circular', 'linear'],
    dflt: 'circular',
    editType: 'plot'
  },
  // TODO maybe?
  // annotations:

  uirevision: {
    valType: 'any',
    editType: 'none'
  },
  editType: 'calc'
};

/***/ }),

/***/ 84588:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var Color = __webpack_require__(78766);
var Template = __webpack_require__(78032);
var handleSubplotDefaults = __webpack_require__(4448);
var getSubplotData = (__webpack_require__(4173)/* .getSubplotData */ .KO);
var handleTickValueDefaults = __webpack_require__(22777);
var handleTickMarkDefaults = __webpack_require__(87433);
var handleTickLabelDefaults = __webpack_require__(12036);
var handlePrefixSuffixDefaults = __webpack_require__(54616);
var handleCategoryOrderDefaults = __webpack_require__(46473);
var handleLineGridDefaults = __webpack_require__(97405);
var handleAutorangeOptionsDefaults = __webpack_require__(75511);
var autoType = __webpack_require__(9666);
var layoutAttributes = __webpack_require__(42219);
var setConvert = __webpack_require__(51937);
var constants = __webpack_require__(26484);
var axisNames = constants.axisNames;
function handleDefaults(contIn, contOut, coerce, opts) {
  var bgColor = coerce('bgcolor');
  opts.bgColor = Color.combine(bgColor, opts.paper_bgcolor);
  var sector = coerce('sector');
  coerce('hole');

  // could optimize, subplotData is not always needed!
  var subplotData = getSubplotData(opts.fullData, constants.name, opts.id);
  var layoutOut = opts.layoutOut;
  var axName;
  function coerceAxis(attr, dflt) {
    return coerce(axName + '.' + attr, dflt);
  }
  for (var i = 0; i < axisNames.length; i++) {
    axName = axisNames[i];
    if (!Lib.isPlainObject(contIn[axName])) {
      contIn[axName] = {};
    }
    var axIn = contIn[axName];
    var axOut = Template.newContainer(contOut, axName);
    axOut._id = axOut._name = axName;
    axOut._attr = opts.id + '.' + axName;
    axOut._traceIndices = subplotData.map(function (t) {
      return t._expandedIndex;
    });
    var dataAttr = constants.axisName2dataArray[axName];
    var axType = handleAxisTypeDefaults(axIn, axOut, coerceAxis, subplotData, dataAttr, opts);
    handleCategoryOrderDefaults(axIn, axOut, coerceAxis, {
      axData: subplotData,
      dataAttr: dataAttr
    });
    var visible = coerceAxis('visible');
    setConvert(axOut, contOut, layoutOut);
    coerceAxis('uirevision', contOut.uirevision);

    // We don't want to make downstream code call ax.setScale,
    // as both radial and angular axes don't have a set domain.
    // Furthermore, angular axes don't have a set range.
    //
    // Mocked domains and ranges are set by the polar subplot instances,
    // but Axes.findExtremes uses the sign of _m to determine which padding value
    // to use.
    //
    // By setting, _m to 1 here, we make Axes.findExtremes think that
    // range[1] > range[0], and vice-versa for `autorange: 'reversed'` below.
    axOut._m = 1;
    switch (axName) {
      case 'radialaxis':
        coerceAxis('minallowed');
        coerceAxis('maxallowed');
        var range = coerceAxis('range');
        var autorangeDflt = axOut.getAutorangeDflt(range);
        var autorange = coerceAxis('autorange', autorangeDflt);
        var shouldAutorange;

        // validate range and set autorange true for invalid partial ranges
        if (range && (range[0] === null && range[1] === null || (range[0] === null || range[1] === null) && (autorange === 'reversed' || autorange === true) || range[0] !== null && (autorange === 'min' || autorange === 'max reversed') || range[1] !== null && (autorange === 'max' || autorange === 'min reversed'))) {
          range = undefined;
          delete axOut.range;
          axOut.autorange = true;
          shouldAutorange = true;
        }
        if (!shouldAutorange) {
          autorangeDflt = axOut.getAutorangeDflt(range);
          autorange = coerceAxis('autorange', autorangeDflt);
        }
        axIn.autorange = autorange;
        if (autorange) {
          handleAutorangeOptionsDefaults(coerceAxis, autorange, range);
          if (axType === 'linear' || axType === '-') coerceAxis('rangemode');
          if (axOut.isReversed()) axOut._m = -1;
        }
        axOut.cleanRange('range', {
          dfltRange: [0, 1]
        });
        break;
      case 'angularaxis':
        // We do not support 'true' date angular axes yet,
        // users can still plot dates on angular axes by setting
        // `angularaxis.type: 'category'`.
        //
        // Here, if a date angular axes is detected, we make
        // all its corresponding traces invisible, so that
        // when we do add support for data angular axes, the new
        // behavior won't conflict with existing behavior
        if (axType === 'date') {
          Lib.log('Polar plots do not support date angular axes yet.');
          for (var j = 0; j < subplotData.length; j++) {
            subplotData[j].visible = false;
          }

          // turn this into a 'dummy' linear axis so that
          // the subplot still renders ok
          axType = axIn.type = axOut.type = 'linear';
        }
        if (axType === 'linear') {
          coerceAxis('thetaunit');
        } else {
          coerceAxis('period');
        }
        var direction = coerceAxis('direction');
        coerceAxis('rotation', {
          counterclockwise: 0,
          clockwise: 90
        }[direction]);
        break;
    }
    handlePrefixSuffixDefaults(axIn, axOut, coerceAxis, axOut.type, {
      tickSuffixDflt: axOut.thetaunit === 'degrees' ? '°' : undefined
    });
    if (visible) {
      var dfltColor;
      var dfltFontColor;
      var dfltFontSize;
      var dfltFontFamily;
      var dfltFontWeight;
      var dfltFontStyle;
      var dfltFontVariant;
      var dfltFontTextcase;
      var dfltFontLineposition;
      var dfltFontShadow;
      var font = opts.font || {};
      dfltColor = coerceAxis('color');
      dfltFontColor = dfltColor === axIn.color ? dfltColor : font.color;
      dfltFontSize = font.size;
      dfltFontFamily = font.family;
      dfltFontWeight = font.weight;
      dfltFontStyle = font.style;
      dfltFontVariant = font.variant;
      dfltFontTextcase = font.textcase;
      dfltFontLineposition = font.lineposition;
      dfltFontShadow = font.shadow;
      handleTickValueDefaults(axIn, axOut, coerceAxis, axOut.type);
      handleTickLabelDefaults(axIn, axOut, coerceAxis, axOut.type, {
        font: {
          weight: dfltFontWeight,
          style: dfltFontStyle,
          variant: dfltFontVariant,
          textcase: dfltFontTextcase,
          lineposition: dfltFontLineposition,
          shadow: dfltFontShadow,
          color: dfltFontColor,
          size: dfltFontSize,
          family: dfltFontFamily
        },
        noAutotickangles: axName === 'angularaxis',
        noTicklabelshift: true,
        noTicklabelstandoff: true
      });
      handleTickMarkDefaults(axIn, axOut, coerceAxis, {
        outerTicks: true
      });
      handleLineGridDefaults(axIn, axOut, coerceAxis, {
        dfltColor: dfltColor,
        bgColor: opts.bgColor,
        // default grid color is darker here (60%, vs cartesian default ~91%)
        // because the grid is not square so the eye needs heavier cues to follow
        blend: 60,
        showLine: true,
        showGrid: true,
        noZeroLine: true,
        attributes: layoutAttributes[axName]
      });
      coerceAxis('layer');
      if (axName === 'radialaxis') {
        coerceAxis('side');
        coerceAxis('angle', sector[0]);
        coerceAxis('title.text');
        Lib.coerceFont(coerceAxis, 'title.font', {
          weight: dfltFontWeight,
          style: dfltFontStyle,
          variant: dfltFontVariant,
          textcase: dfltFontTextcase,
          lineposition: dfltFontLineposition,
          shadow: dfltFontShadow,
          color: dfltFontColor,
          size: Lib.bigFont(dfltFontSize),
          family: dfltFontFamily
        });
      }
    }
    if (axType !== 'category') coerceAxis('hoverformat');
    axOut._input = axIn;
  }
  if (contOut.angularaxis.type === 'category') {
    coerce('gridshape');
  }
}
function handleAxisTypeDefaults(axIn, axOut, coerce, subplotData, dataAttr, options) {
  var autotypenumbers = coerce('autotypenumbers', options.autotypenumbersDflt);
  var axType = coerce('type');
  if (axType === '-') {
    var trace;
    for (var i = 0; i < subplotData.length; i++) {
      if (subplotData[i].visible) {
        trace = subplotData[i];
        break;
      }
    }
    if (trace && trace[dataAttr]) {
      axOut.type = autoType(trace[dataAttr], 'gregorian', {
        noMultiCategory: true,
        autotypenumbers: autotypenumbers
      });
    }
    if (axOut.type === '-') {
      axOut.type = 'linear';
    } else {
      // copy autoType back to input axis
      // note that if this object didn't exist
      // in the input layout, we have to put it in
      // this happens in the main supplyDefaults function
      axIn.type = axOut.type;
    }
  }
  return axOut.type;
}
module.exports = function supplyLayoutDefaults(layoutIn, layoutOut, fullData) {
  handleSubplotDefaults(layoutIn, layoutOut, fullData, {
    type: constants.name,
    attributes: layoutAttributes,
    handleDefaults: handleDefaults,
    font: layoutOut.font,
    autotypenumbersDflt: layoutOut.autotypenumbers,
    paper_bgcolor: layoutOut.paper_bgcolor,
    fullData: fullData,
    layoutOut: layoutOut
  });
};

/***/ }),

/***/ 35785:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var tinycolor = __webpack_require__(65657);
var Registry = __webpack_require__(33626);
var Lib = __webpack_require__(34809);
var strRotate = Lib.strRotate;
var strTranslate = Lib.strTranslate;
var Color = __webpack_require__(78766);
var Drawing = __webpack_require__(62203);
var Plots = __webpack_require__(44122);
var Axes = __webpack_require__(29714);
var setConvertCartesian = __webpack_require__(19091);
var setConvertPolar = __webpack_require__(51937);
var doAutoRange = (__webpack_require__(32919).doAutoRange);
var dragBox = __webpack_require__(51680);
var dragElement = __webpack_require__(14751);
var Fx = __webpack_require__(32141);
var Titles = __webpack_require__(17240);
var prepSelect = (__webpack_require__(44844).prepSelect);
var selectOnClick = (__webpack_require__(44844).selectOnClick);
var clearOutline = (__webpack_require__(44844).clearOutline);
var setCursor = __webpack_require__(27983);
var clearGlCanvases = __webpack_require__(34823);
var redrawReglTraces = (__webpack_require__(71817).redrawReglTraces);
var MID_SHIFT = (__webpack_require__(4530).MID_SHIFT);
var constants = __webpack_require__(26484);
var helpers = __webpack_require__(95928);
var smithHelpers = __webpack_require__(52007);
var smith = smithHelpers.smith;
var reactanceArc = smithHelpers.reactanceArc;
var resistanceArc = smithHelpers.resistanceArc;
var smithTransform = smithHelpers.smithTransform;
var _ = Lib._;
var mod = Lib.mod;
var deg2rad = Lib.deg2rad;
var rad2deg = Lib.rad2deg;
function Polar(gd, id, isSmith) {
  this.isSmith = isSmith || false;
  this.id = id;
  this.gd = gd;
  this._hasClipOnAxisFalse = null;
  this.vangles = null;
  this.radialAxisAngle = null;
  this.traceHash = {};
  this.layers = {};
  this.clipPaths = {};
  this.clipIds = {};
  this.viewInitial = {};
  var fullLayout = gd._fullLayout;
  var clipIdBase = 'clip' + fullLayout._uid + id;
  this.clipIds.forTraces = clipIdBase + '-for-traces';
  this.clipPaths.forTraces = fullLayout._clips.append('clipPath').attr('id', this.clipIds.forTraces);
  this.clipPaths.forTraces.append('path');
  this.framework = fullLayout['_' + (isSmith ? 'smith' : 'polar') + 'layer'].append('g').attr('class', id);
  this.getHole = function (s) {
    return this.isSmith ? 0 : s.hole;
  };
  this.getSector = function (s) {
    return this.isSmith ? [0, 360] : s.sector;
  };
  this.getRadial = function (s) {
    return this.isSmith ? s.realaxis : s.radialaxis;
  };
  this.getAngular = function (s) {
    return this.isSmith ? s.imaginaryaxis : s.angularaxis;
  };
  if (!isSmith) {
    // unfortunately, we have to keep track of some axis tick settings
    // as polar subplots do not implement the 'ticks' editType
    this.radialTickLayout = null;
    this.angularTickLayout = null;
  }
}
var proto = Polar.prototype;
module.exports = function createPolar(gd, id, isSmith) {
  return new Polar(gd, id, isSmith);
};
proto.plot = function (polarCalcData, fullLayout) {
  var _this = this;
  var polarLayout = fullLayout[_this.id];
  var found = false;
  for (var i = 0; i < polarCalcData.length; i++) {
    var trace = polarCalcData[i][0].trace;
    if (trace.cliponaxis === false) {
      found = true;
      break;
    }
  }
  _this._hasClipOnAxisFalse = found;
  _this.updateLayers(fullLayout, polarLayout);
  _this.updateLayout(fullLayout, polarLayout);
  Plots.generalUpdatePerTraceModule(_this.gd, _this, polarCalcData, polarLayout);
  _this.updateFx(fullLayout, polarLayout);
  if (_this.isSmith) {
    delete polarLayout.realaxis.range;
    delete polarLayout.imaginaryaxis.range;
  }
};
proto.updateLayers = function (fullLayout, polarLayout) {
  var _this = this;
  var isSmith = _this.isSmith;
  var layers = _this.layers;
  var radialLayout = _this.getRadial(polarLayout);
  var angularLayout = _this.getAngular(polarLayout);
  var layerNames = constants.layerNames;
  var frontPlotIndex = layerNames.indexOf('frontplot');
  var layerData = layerNames.slice(0, frontPlotIndex);
  var isAngularAxisBelowTraces = angularLayout.layer === 'below traces';
  var isRadialAxisBelowTraces = radialLayout.layer === 'below traces';
  if (isAngularAxisBelowTraces) layerData.push('angular-line');
  if (isRadialAxisBelowTraces) layerData.push('radial-line');
  if (isAngularAxisBelowTraces) layerData.push('angular-axis');
  if (isRadialAxisBelowTraces) layerData.push('radial-axis');
  layerData.push('frontplot');
  if (!isAngularAxisBelowTraces) layerData.push('angular-line');
  if (!isRadialAxisBelowTraces) layerData.push('radial-line');
  if (!isAngularAxisBelowTraces) layerData.push('angular-axis');
  if (!isRadialAxisBelowTraces) layerData.push('radial-axis');
  var subLayer = (isSmith ? 'smith' : 'polar') + 'sublayer';
  var join = _this.framework.selectAll('.' + subLayer).data(layerData, String);
  join.enter().append('g').attr('class', function (d) {
    return subLayer + ' ' + d;
  }).each(function (d) {
    var sel = layers[d] = d3.select(this);
    switch (d) {
      case 'frontplot':
        // TODO add option to place in 'backplot' layer??
        if (!isSmith) {
          sel.append('g').classed('barlayer', true);
        }
        sel.append('g').classed('scatterlayer', true);
        break;
      case 'backplot':
        sel.append('g').classed('maplayer', true);
        break;
      case 'plotbg':
        layers.bg = sel.append('path');
        break;
      case 'radial-grid':
        sel.style('fill', 'none');
        break;
      case 'angular-grid':
        sel.style('fill', 'none');
        break;
      case 'radial-line':
        sel.append('line').style('fill', 'none');
        break;
      case 'angular-line':
        sel.append('path').style('fill', 'none');
        break;
    }
  });
  join.order();
};

/* Polar subplots juggle with 6 'axis objects' (!), these are:
 *
 * - getRadial(polarLayout) (aka radialLayout in this file):
 * - getAngular(polarLayout) (aka angularLayout in this file):
 *   used for data -> calcdata conversions (aka d2c) during the calc step
 *
 * - this.radialAxis
 *   extends getRadial(polarLayout), adds mocked 'domain' and
 *   few other keys in order to reuse Cartesian doAutoRange and the Axes
 *   drawing routines.
 *   used for calcdata -> geometric conversions (aka c2g) during the plot step
 *   + setGeometry setups ax.c2g for given ax.range
 *   + setScale setups ax._m,ax._b for given ax.range
 *
 * - this.angularAxis
 *   extends getAngular(polarLayout), adds mocked 'range' and 'domain' and
 *   a few other keys in order to reuse the Axes drawing routines.
 *   used for calcdata -> geometric conversions (aka c2g) during the plot step
 *   + setGeometry setups ax.c2g given ax.rotation, ax.direction & ax._categories,
 *                 and mocks ax.range
 *   + setScale setups ax._m,ax._b with that mocked ax.range
 *
 * - this.xaxis
 * - this.yaxis
 *   setup so that polar traces can reuse plot methods of Cartesian traces
 *   which mostly rely on 2pixel methods (e.g ax.c2p)
 */
proto.updateLayout = function (fullLayout, polarLayout) {
  var _this = this;
  var layers = _this.layers;
  var gs = fullLayout._size;

  // axis attributes
  var radialLayout = _this.getRadial(polarLayout);
  var angularLayout = _this.getAngular(polarLayout);
  // layout domains
  var xDomain = polarLayout.domain.x;
  var yDomain = polarLayout.domain.y;
  // offsets from paper edge to layout domain box
  _this.xOffset = gs.l + gs.w * xDomain[0];
  _this.yOffset = gs.t + gs.h * (1 - yDomain[1]);
  // lengths of the layout domain box
  var xLength = _this.xLength = gs.w * (xDomain[1] - xDomain[0]);
  var yLength = _this.yLength = gs.h * (yDomain[1] - yDomain[0]);
  // sector to plot
  var sector = _this.getSector(polarLayout);
  _this.sectorInRad = sector.map(deg2rad);
  var sectorBBox = _this.sectorBBox = computeSectorBBox(sector);
  var dxSectorBBox = sectorBBox[2] - sectorBBox[0];
  var dySectorBBox = sectorBBox[3] - sectorBBox[1];
  // aspect ratios
  var arDomain = yLength / xLength;
  var arSector = Math.abs(dySectorBBox / dxSectorBBox);
  // actual lengths and domains of subplot box
  var xLength2, yLength2;
  var xDomain2, yDomain2;
  var gap;
  if (arDomain > arSector) {
    xLength2 = xLength;
    yLength2 = xLength * arSector;
    gap = (yLength - yLength2) / gs.h / 2;
    xDomain2 = [xDomain[0], xDomain[1]];
    yDomain2 = [yDomain[0] + gap, yDomain[1] - gap];
  } else {
    xLength2 = yLength / arSector;
    yLength2 = yLength;
    gap = (xLength - xLength2) / gs.w / 2;
    xDomain2 = [xDomain[0] + gap, xDomain[1] - gap];
    yDomain2 = [yDomain[0], yDomain[1]];
  }
  _this.xLength2 = xLength2;
  _this.yLength2 = yLength2;
  _this.xDomain2 = xDomain2;
  _this.yDomain2 = yDomain2;
  // actual offsets from paper edge to the subplot box top-left corner
  var xOffset2 = _this.xOffset2 = gs.l + gs.w * xDomain2[0];
  var yOffset2 = _this.yOffset2 = gs.t + gs.h * (1 - yDomain2[1]);
  // circle radius in px
  var radius = _this.radius = xLength2 / dxSectorBBox;
  // 'inner' radius in px (when polar.hole is set)
  var innerRadius = _this.innerRadius = _this.getHole(polarLayout) * radius;
  // circle center position in px
  var cx = _this.cx = xOffset2 - radius * sectorBBox[0];
  var cy = _this.cy = yOffset2 + radius * sectorBBox[3];
  // circle center in the coordinate system of plot area
  var cxx = _this.cxx = cx - xOffset2;
  var cyy = _this.cyy = cy - yOffset2;
  var side = radialLayout.side;
  var trueSide;
  if (side === 'counterclockwise') {
    trueSide = side;
    side = 'top';
  } else if (side === 'clockwise') {
    trueSide = side;
    side = 'bottom';
  }
  _this.radialAxis = _this.mockAxis(fullLayout, polarLayout, radialLayout, {
    // make this an 'x' axis to make positioning (especially rotation) easier
    _id: 'x',
    // convert to 'x' axis equivalent
    side: side,
    // keep track of real side
    _trueSide: trueSide,
    // spans length 1 radius
    domain: [innerRadius / gs.w, radius / gs.w]
  });
  _this.angularAxis = _this.mockAxis(fullLayout, polarLayout, angularLayout, {
    side: 'right',
    // to get auto nticks right
    domain: [0, Math.PI],
    // don't pass through autorange logic
    autorange: false
  });
  _this.doAutoRange(fullLayout, polarLayout);
  // N.B. this sets _this.vangles
  _this.updateAngularAxis(fullLayout, polarLayout);
  // N.B. this sets _this.radialAxisAngle
  _this.updateRadialAxis(fullLayout, polarLayout);
  _this.updateRadialAxisTitle(fullLayout, polarLayout);
  _this.xaxis = _this.mockCartesianAxis(fullLayout, polarLayout, {
    _id: 'x',
    domain: xDomain2
  });
  _this.yaxis = _this.mockCartesianAxis(fullLayout, polarLayout, {
    _id: 'y',
    domain: yDomain2
  });
  var dPath = _this.pathSubplot();
  _this.clipPaths.forTraces.select('path').attr('d', dPath).attr('transform', strTranslate(cxx, cyy));
  layers.frontplot.attr('transform', strTranslate(xOffset2, yOffset2)).call(Drawing.setClipUrl, _this._hasClipOnAxisFalse ? null : _this.clipIds.forTraces, _this.gd);
  layers.bg.attr('d', dPath).attr('transform', strTranslate(cx, cy)).call(Color.fill, polarLayout.bgcolor);
};
proto.mockAxis = function (fullLayout, polarLayout, axLayout, opts) {
  var ax = Lib.extendFlat({}, axLayout, opts);
  setConvertPolar(ax, polarLayout, fullLayout);
  return ax;
};
proto.mockCartesianAxis = function (fullLayout, polarLayout, opts) {
  var _this = this;
  var isSmith = _this.isSmith;
  var axId = opts._id;
  var ax = Lib.extendFlat({
    type: 'linear'
  }, opts);
  setConvertCartesian(ax, fullLayout);
  var bboxIndices = {
    x: [0, 2],
    y: [1, 3]
  };
  ax.setRange = function () {
    var sectorBBox = _this.sectorBBox;
    var ind = bboxIndices[axId];
    var rl = _this.radialAxis._rl;
    var drl = (rl[1] - rl[0]) / (1 - _this.getHole(polarLayout));
    ax.range = [sectorBBox[ind[0]] * drl, sectorBBox[ind[1]] * drl];
  };
  ax.isPtWithinRange = axId === 'x' && !isSmith ? function (d) {
    return _this.isPtInside(d);
  } : function () {
    return true;
  };
  ax.setRange();
  ax.setScale();
  return ax;
};
proto.doAutoRange = function (fullLayout, polarLayout) {
  var _this = this;
  var gd = _this.gd;
  var radialAxis = _this.radialAxis;
  var radialLayout = _this.getRadial(polarLayout);
  doAutoRange(gd, radialAxis);
  var rng = radialAxis.range;
  radialLayout.range = rng.slice();
  radialLayout._input.range = rng.slice();
  radialAxis._rl = [radialAxis.r2l(rng[0], null, 'gregorian'), radialAxis.r2l(rng[1], null, 'gregorian')];
  if (radialAxis.minallowed !== undefined) {
    var minallowed = radialAxis.r2l(radialAxis.minallowed);
    if (radialAxis._rl[0] > radialAxis._rl[1]) {
      radialAxis._rl[1] = Math.max(radialAxis._rl[1], minallowed);
    } else {
      radialAxis._rl[0] = Math.max(radialAxis._rl[0], minallowed);
    }
  }
  if (radialAxis.maxallowed !== undefined) {
    var maxallowed = radialAxis.r2l(radialAxis.maxallowed);
    if (radialAxis._rl[0] < radialAxis._rl[1]) {
      radialAxis._rl[1] = Math.min(radialAxis._rl[1], maxallowed);
    } else {
      radialAxis._rl[0] = Math.min(radialAxis._rl[0], maxallowed);
    }
  }
};
proto.updateRadialAxis = function (fullLayout, polarLayout) {
  var _this = this;
  var gd = _this.gd;
  var layers = _this.layers;
  var radius = _this.radius;
  var innerRadius = _this.innerRadius;
  var cx = _this.cx;
  var cy = _this.cy;
  var radialLayout = _this.getRadial(polarLayout);
  var a0 = mod(_this.getSector(polarLayout)[0], 360);
  var ax = _this.radialAxis;
  var hasRoomForIt = innerRadius < radius;
  var isSmith = _this.isSmith;
  if (!isSmith) {
    _this.fillViewInitialKey('radialaxis.angle', radialLayout.angle);
    _this.fillViewInitialKey('radialaxis.range', ax.range.slice());
    ax.setGeometry();
  }

  // rotate auto tick labels by 180 if in quadrant II and III to make them
  // readable from left-to-right
  //
  // TODO try moving deeper in Axes.drawLabels for better results?
  if (ax.tickangle === 'auto' && a0 > 90 && a0 <= 270) {
    ax.tickangle = 180;
  }

  // easier to set rotate angle with custom translate function
  var transFn = isSmith ? function (d) {
    var t = smithTransform(_this, smith([d.x, 0]));
    return strTranslate(t[0] - cx, t[1] - cy);
  } : function (d) {
    return strTranslate(ax.l2p(d.x) + innerRadius, 0);
  };

  // set special grid path function
  var gridPathFn = isSmith ? function (d) {
    return resistanceArc(_this, d.x, -Infinity, Infinity);
  } : function (d) {
    return _this.pathArc(ax.r2p(d.x) + innerRadius);
  };
  var newTickLayout = strTickLayout(radialLayout);
  if (_this.radialTickLayout !== newTickLayout) {
    layers['radial-axis'].selectAll('.xtick').remove();
    _this.radialTickLayout = newTickLayout;
  }
  if (hasRoomForIt) {
    ax.setScale();
    var labelShift = 0;
    var vals = isSmith ? (ax.tickvals || []).filter(function (x) {
      // filter negative
      return x >= 0;
    }).map(function (x) {
      return Axes.tickText(ax, x, true, false);
    }) : Axes.calcTicks(ax);
    var valsClipped = isSmith ? vals : Axes.clipEnds(ax, vals);
    var tickSign = Axes.getTickSigns(ax)[2];
    if (isSmith) {
      if (ax.ticks === 'top' && ax.side === 'bottom' || ax.ticks === 'bottom' && ax.side === 'top') {
        // invert sign
        tickSign = -tickSign;
      }
      if (ax.ticks === 'top' && ax.side === 'top') labelShift = -ax.ticklen;
      if (ax.ticks === 'bottom' && ax.side === 'bottom') labelShift = ax.ticklen;
    }
    Axes.drawTicks(gd, ax, {
      vals: vals,
      layer: layers['radial-axis'],
      path: Axes.makeTickPath(ax, 0, tickSign),
      transFn: transFn,
      crisp: false
    });
    Axes.drawGrid(gd, ax, {
      vals: valsClipped,
      layer: layers['radial-grid'],
      path: gridPathFn,
      transFn: Lib.noop,
      crisp: false
    });
    Axes.drawLabels(gd, ax, {
      vals: vals,
      layer: layers['radial-axis'],
      transFn: transFn,
      labelFns: Axes.makeLabelFns(ax, labelShift)
    });
  }

  // stash 'actual' radial axis angle for drag handlers (in degrees)
  var angle = _this.radialAxisAngle = _this.vangles ? rad2deg(snapToVertexAngle(deg2rad(radialLayout.angle), _this.vangles)) : radialLayout.angle;
  var tLayer = strTranslate(cx, cy);
  var tLayer2 = tLayer + strRotate(-angle);
  updateElement(layers['radial-axis'], hasRoomForIt && (radialLayout.showticklabels || radialLayout.ticks), {
    transform: tLayer2
  });
  updateElement(layers['radial-grid'], hasRoomForIt && radialLayout.showgrid, {
    transform: isSmith ? '' : tLayer
  });
  updateElement(layers['radial-line'].select('line'), hasRoomForIt && radialLayout.showline, {
    x1: isSmith ? -radius : innerRadius,
    y1: 0,
    x2: radius,
    y2: 0,
    transform: tLayer2
  }).attr('stroke-width', radialLayout.linewidth).call(Color.stroke, radialLayout.linecolor);
};
proto.updateRadialAxisTitle = function (fullLayout, polarLayout, _angle) {
  if (this.isSmith) return;
  var _this = this;
  var gd = _this.gd;
  var radius = _this.radius;
  var cx = _this.cx;
  var cy = _this.cy;
  var radialLayout = _this.getRadial(polarLayout);
  var titleClass = _this.id + 'title';
  var pad = 0;

  // Hint: no need to check if there is in fact a title.text set
  // because if plot is editable, pad needs to be calculated anyways
  // to properly show placeholder text when title is empty.
  if (radialLayout.title) {
    var h = Drawing.bBox(_this.layers['radial-axis'].node()).height;
    var ts = radialLayout.title.font.size;
    var side = radialLayout.side;
    pad = side === 'top' ? ts : side === 'counterclockwise' ? -(h + ts * 0.4) : h + ts * 0.8;
  }
  var angle = _angle !== undefined ? _angle : _this.radialAxisAngle;
  var angleRad = deg2rad(angle);
  var cosa = Math.cos(angleRad);
  var sina = Math.sin(angleRad);
  var x = cx + radius / 2 * cosa + pad * sina;
  var y = cy - radius / 2 * sina + pad * cosa;
  _this.layers['radial-axis-title'] = Titles.draw(gd, titleClass, {
    propContainer: radialLayout,
    propName: _this.id + '.radialaxis.title',
    placeholder: _(gd, 'Click to enter radial axis title'),
    attributes: {
      x: x,
      y: y,
      'text-anchor': 'middle'
    },
    transform: {
      rotate: -angle
    }
  });
};
proto.updateAngularAxis = function (fullLayout, polarLayout) {
  var _this = this;
  var gd = _this.gd;
  var layers = _this.layers;
  var radius = _this.radius;
  var innerRadius = _this.innerRadius;
  var cx = _this.cx;
  var cy = _this.cy;
  var angularLayout = _this.getAngular(polarLayout);
  var ax = _this.angularAxis;
  var isSmith = _this.isSmith;
  if (!isSmith) {
    _this.fillViewInitialKey('angularaxis.rotation', angularLayout.rotation);
    ax.setGeometry();
    ax.setScale();
  }

  // 't'ick to 'g'eometric radians is used all over the place here
  var t2g = isSmith ? function (d) {
    var t = smithTransform(_this, smith([0, d.x]));
    return Math.atan2(t[0] - cx, t[1] - cy) - Math.PI / 2;
  } : function (d) {
    return ax.t2g(d.x);
  };

  // run rad2deg on tick0 and ditck for thetaunit: 'radians' axes
  if (ax.type === 'linear' && ax.thetaunit === 'radians') {
    ax.tick0 = rad2deg(ax.tick0);
    ax.dtick = rad2deg(ax.dtick);
  }
  var _transFn = function (rad) {
    return strTranslate(cx + radius * Math.cos(rad), cy - radius * Math.sin(rad));
  };
  var transFn = isSmith ? function (d) {
    var t = smithTransform(_this, smith([0, d.x]));
    return strTranslate(t[0], t[1]);
  } : function (d) {
    return _transFn(t2g(d));
  };
  var transFn2 = isSmith ? function (d) {
    var t = smithTransform(_this, smith([0, d.x]));
    var rad = Math.atan2(t[0] - cx, t[1] - cy) - Math.PI / 2;
    return strTranslate(t[0], t[1]) + strRotate(-rad2deg(rad));
  } : function (d) {
    var rad = t2g(d);
    return _transFn(rad) + strRotate(-rad2deg(rad));
  };
  var gridPathFn = isSmith ? function (d) {
    return reactanceArc(_this, d.x, 0, Infinity);
  } : function (d) {
    var rad = t2g(d);
    var cosRad = Math.cos(rad);
    var sinRad = Math.sin(rad);
    return 'M' + [cx + innerRadius * cosRad, cy - innerRadius * sinRad] + 'L' + [cx + radius * cosRad, cy - radius * sinRad];
  };
  var out = Axes.makeLabelFns(ax, 0);
  var labelStandoff = out.labelStandoff;
  var labelFns = {};
  labelFns.xFn = function (d) {
    var rad = t2g(d);
    return Math.cos(rad) * labelStandoff;
  };
  labelFns.yFn = function (d) {
    var rad = t2g(d);
    var ff = Math.sin(rad) > 0 ? 0.2 : 1;
    return -Math.sin(rad) * (labelStandoff + d.fontSize * ff) + Math.abs(Math.cos(rad)) * (d.fontSize * MID_SHIFT);
  };
  labelFns.anchorFn = function (d) {
    var rad = t2g(d);
    var cos = Math.cos(rad);
    return Math.abs(cos) < 0.1 ? 'middle' : cos > 0 ? 'start' : 'end';
  };
  labelFns.heightFn = function (d, a, h) {
    var rad = t2g(d);
    return -0.5 * (1 + Math.sin(rad)) * h;
  };
  var newTickLayout = strTickLayout(angularLayout);
  if (_this.angularTickLayout !== newTickLayout) {
    layers['angular-axis'].selectAll('.' + ax._id + 'tick').remove();
    _this.angularTickLayout = newTickLayout;
  }
  var vals = isSmith ? [Infinity].concat(ax.tickvals || []).map(function (x) {
    return Axes.tickText(ax, x, true, false);
  }) : Axes.calcTicks(ax);
  if (isSmith) {
    vals[0].text = '∞';
    vals[0].fontSize *= 1.75;
  }

  // angle of polygon vertices in geometric radians (null means circles)
  // TODO what to do when ax.period > ax._categories ??
  var vangles;
  if (polarLayout.gridshape === 'linear') {
    vangles = vals.map(t2g);

    // ax._vals should be always ordered, make them
    // always turn counterclockwise for convenience here
    if (Lib.angleDelta(vangles[0], vangles[1]) < 0) {
      vangles = vangles.slice().reverse();
    }
  } else {
    vangles = null;
  }
  _this.vangles = vangles;

  // Use tickval filter for category axes instead of tweaking
  // the range w.r.t sector, so that sectors that cross 360 can
  // show all their ticks.
  if (ax.type === 'category') {
    vals = vals.filter(function (d) {
      return Lib.isAngleInsideSector(t2g(d), _this.sectorInRad);
    });
  }
  if (ax.visible) {
    var tickSign = ax.ticks === 'inside' ? -1 : 1;
    var pad = (ax.linewidth || 1) / 2;
    Axes.drawTicks(gd, ax, {
      vals: vals,
      layer: layers['angular-axis'],
      path: 'M' + tickSign * pad + ',0h' + tickSign * ax.ticklen,
      transFn: transFn2,
      crisp: false
    });
    Axes.drawGrid(gd, ax, {
      vals: vals,
      layer: layers['angular-grid'],
      path: gridPathFn,
      transFn: Lib.noop,
      crisp: false
    });
    Axes.drawLabels(gd, ax, {
      vals: vals,
      layer: layers['angular-axis'],
      repositionOnUpdate: true,
      transFn: transFn,
      labelFns: labelFns
    });
  }

  // TODO maybe two arcs is better here?
  // maybe split style attributes between inner and outer angular axes?

  updateElement(layers['angular-line'].select('path'), angularLayout.showline, {
    d: _this.pathSubplot(),
    transform: strTranslate(cx, cy)
  }).attr('stroke-width', angularLayout.linewidth).call(Color.stroke, angularLayout.linecolor);
};
proto.updateFx = function (fullLayout, polarLayout) {
  if (!this.gd._context.staticPlot) {
    var hasDrag = !this.isSmith;
    if (hasDrag) {
      this.updateAngularDrag(fullLayout);
      this.updateRadialDrag(fullLayout, polarLayout, 0);
      this.updateRadialDrag(fullLayout, polarLayout, 1);
    }
    this.updateHoverAndMainDrag(fullLayout);
  }
};
proto.updateHoverAndMainDrag = function (fullLayout) {
  var _this = this;
  var isSmith = _this.isSmith;
  var gd = _this.gd;
  var layers = _this.layers;
  var zoomlayer = fullLayout._zoomlayer;
  var MINZOOM = constants.MINZOOM;
  var OFFEDGE = constants.OFFEDGE;
  var radius = _this.radius;
  var innerRadius = _this.innerRadius;
  var cx = _this.cx;
  var cy = _this.cy;
  var cxx = _this.cxx;
  var cyy = _this.cyy;
  var sectorInRad = _this.sectorInRad;
  var vangles = _this.vangles;
  var radialAxis = _this.radialAxis;
  var clampTiny = helpers.clampTiny;
  var findXYatLength = helpers.findXYatLength;
  var findEnclosingVertexAngles = helpers.findEnclosingVertexAngles;
  var chw = constants.cornerHalfWidth;
  var chl = constants.cornerLen / 2;
  var scaleX;
  var scaleY;
  var mainDrag = dragBox.makeDragger(layers, 'path', 'maindrag', fullLayout.dragmode === false ? 'none' : 'crosshair');
  d3.select(mainDrag).attr('d', _this.pathSubplot()).attr('transform', strTranslate(cx, cy));
  mainDrag.onmousemove = function (evt) {
    Fx.hover(gd, evt, _this.id);
    gd._fullLayout._lasthover = mainDrag;
    gd._fullLayout._hoversubplot = _this.id;
  };
  mainDrag.onmouseout = function (evt) {
    if (gd._dragging) return;
    dragElement.unhover(gd, evt);
  };
  var dragOpts = {
    element: mainDrag,
    gd: gd,
    subplot: _this.id,
    plotinfo: {
      id: _this.id,
      xaxis: _this.xaxis,
      yaxis: _this.yaxis
    },
    xaxes: [_this.xaxis],
    yaxes: [_this.yaxis]
  };

  // mouse px position at drag start (0), move (1)
  var x0, y0;
  // radial distance from circle center at drag start (0), move (1)
  var r0, r1;
  // zoombox persistent quantities
  var path0, dimmed, lum;
  // zoombox, corners elements
  var zb, corners;
  function norm(x, y) {
    return Math.sqrt(x * x + y * y);
  }
  function xy2r(x, y) {
    return norm(x - cxx, y - cyy);
  }
  function xy2a(x, y) {
    return Math.atan2(cyy - y, x - cxx);
  }
  function ra2xy(r, a) {
    return [r * Math.cos(a), r * Math.sin(-a)];
  }
  function pathCorner(r, a) {
    if (r === 0) return _this.pathSector(2 * chw);
    var da = chl / r;
    var am = a - da;
    var ap = a + da;
    var rb = Math.max(0, Math.min(r, radius));
    var rm = rb - chw;
    var rp = rb + chw;
    return 'M' + ra2xy(rm, am) + 'A' + [rm, rm] + ' 0,0,0 ' + ra2xy(rm, ap) + 'L' + ra2xy(rp, ap) + 'A' + [rp, rp] + ' 0,0,1 ' + ra2xy(rp, am) + 'Z';
  }

  // (x,y) is the pt at middle of the va0 <-> va1 edge
  //
  // ... we could eventually add another mode for cursor
  // angles 'close to' enough to a particular vertex.
  function pathCornerForPolygons(r, va0, va1) {
    if (r === 0) return _this.pathSector(2 * chw);
    var xy0 = ra2xy(r, va0);
    var xy1 = ra2xy(r, va1);
    var x = clampTiny((xy0[0] + xy1[0]) / 2);
    var y = clampTiny((xy0[1] + xy1[1]) / 2);
    var innerPts, outerPts;
    if (x && y) {
      var m = y / x;
      var mperp = -1 / m;
      var midPts = findXYatLength(chw, m, x, y);
      innerPts = findXYatLength(chl, mperp, midPts[0][0], midPts[0][1]);
      outerPts = findXYatLength(chl, mperp, midPts[1][0], midPts[1][1]);
    } else {
      var dx, dy;
      if (y) {
        // horizontal handles
        dx = chl;
        dy = chw;
      } else {
        // vertical handles
        dx = chw;
        dy = chl;
      }
      innerPts = [[x - dx, y - dy], [x + dx, y - dy]];
      outerPts = [[x - dx, y + dy], [x + dx, y + dy]];
    }
    return 'M' + innerPts.join('L') + 'L' + outerPts.reverse().join('L') + 'Z';
  }
  function zoomPrep() {
    r0 = null;
    r1 = null;
    path0 = _this.pathSubplot();
    dimmed = false;
    var polarLayoutNow = gd._fullLayout[_this.id];
    lum = tinycolor(polarLayoutNow.bgcolor).getLuminance();
    zb = dragBox.makeZoombox(zoomlayer, lum, cx, cy, path0);
    zb.attr('fill-rule', 'evenodd');
    corners = dragBox.makeCorners(zoomlayer, cx, cy);
    clearOutline(gd);
  }

  // N.B. this sets scoped 'r0' and 'r1'
  // return true if 'valid' zoom distance, false otherwise
  function clampAndSetR0R1(rr0, rr1) {
    rr1 = Math.max(Math.min(rr1, radius), innerRadius);

    // starting or ending drag near center (outer edge),
    // clamps radial distance at origin (at r=radius)
    if (rr0 < OFFEDGE) rr0 = 0;else if (radius - rr0 < OFFEDGE) rr0 = radius;else if (rr1 < OFFEDGE) rr1 = 0;else if (radius - rr1 < OFFEDGE) rr1 = radius;

    // make sure r0 < r1,
    // to get correct fill pattern in path1 below
    if (Math.abs(rr1 - rr0) > MINZOOM) {
      if (rr0 < rr1) {
        r0 = rr0;
        r1 = rr1;
      } else {
        r0 = rr1;
        r1 = rr0;
      }
      return true;
    } else {
      r0 = null;
      r1 = null;
      return false;
    }
  }
  function applyZoomMove(path1, cpath) {
    path1 = path1 || path0;
    cpath = cpath || 'M0,0Z';
    zb.attr('d', path1);
    corners.attr('d', cpath);
    dragBox.transitionZoombox(zb, corners, dimmed, lum);
    dimmed = true;
    var updateObj = {};
    computeZoomUpdates(updateObj);
    gd.emit('plotly_relayouting', updateObj);
  }
  function zoomMove(dx, dy) {
    dx = dx * scaleX;
    dy = dy * scaleY;
    var x1 = x0 + dx;
    var y1 = y0 + dy;
    var rr0 = xy2r(x0, y0);
    var rr1 = Math.min(xy2r(x1, y1), radius);
    var a0 = xy2a(x0, y0);
    var path1;
    var cpath;
    if (clampAndSetR0R1(rr0, rr1)) {
      path1 = path0 + _this.pathSector(r1);
      if (r0) path1 += _this.pathSector(r0);
      // keep 'starting' angle
      cpath = pathCorner(r0, a0) + pathCorner(r1, a0);
    }
    applyZoomMove(path1, cpath);
  }
  function findPolygonRadius(x, y, va0, va1) {
    var xy = helpers.findIntersectionXY(va0, va1, va0, [x - cxx, cyy - y]);
    return norm(xy[0], xy[1]);
  }
  function zoomMoveForPolygons(dx, dy) {
    var x1 = x0 + dx;
    var y1 = y0 + dy;
    var a0 = xy2a(x0, y0);
    var a1 = xy2a(x1, y1);
    var vangles0 = findEnclosingVertexAngles(a0, vangles);
    var vangles1 = findEnclosingVertexAngles(a1, vangles);
    var rr0 = findPolygonRadius(x0, y0, vangles0[0], vangles0[1]);
    var rr1 = Math.min(findPolygonRadius(x1, y1, vangles1[0], vangles1[1]), radius);
    var path1;
    var cpath;
    if (clampAndSetR0R1(rr0, rr1)) {
      path1 = path0 + _this.pathSector(r1);
      if (r0) path1 += _this.pathSector(r0);
      // keep 'starting' angle here too
      cpath = [pathCornerForPolygons(r0, vangles0[0], vangles0[1]), pathCornerForPolygons(r1, vangles0[0], vangles0[1])].join(' ');
    }
    applyZoomMove(path1, cpath);
  }
  function zoomDone() {
    dragBox.removeZoombox(gd);
    if (r0 === null || r1 === null) return;
    var updateObj = {};
    computeZoomUpdates(updateObj);
    dragBox.showDoubleClickNotifier(gd);
    Registry.call('_guiRelayout', gd, updateObj);
  }
  function computeZoomUpdates(update) {
    var rl = radialAxis._rl;
    var m = (rl[1] - rl[0]) / (1 - innerRadius / radius) / radius;
    var newRng = [rl[0] + (r0 - innerRadius) * m, rl[0] + (r1 - innerRadius) * m];
    update[_this.id + '.radialaxis.range'] = newRng;
  }
  function zoomClick(numClicks, evt) {
    var clickMode = gd._fullLayout.clickmode;
    dragBox.removeZoombox(gd);

    // TODO double once vs twice logic (autorange vs fixed range)
    if (numClicks === 2) {
      var updateObj = {};
      for (var k in _this.viewInitial) {
        updateObj[_this.id + '.' + k] = _this.viewInitial[k];
      }
      gd.emit('plotly_doubleclick', null);
      Registry.call('_guiRelayout', gd, updateObj);
    }
    if (clickMode.indexOf('select') > -1 && numClicks === 1) {
      selectOnClick(evt, gd, [_this.xaxis], [_this.yaxis], _this.id, dragOpts);
    }
    if (clickMode.indexOf('event') > -1) {
      Fx.click(gd, evt, _this.id);
    }
  }
  dragOpts.prepFn = function (evt, startX, startY) {
    var dragModeNow = gd._fullLayout.dragmode;
    var bbox = mainDrag.getBoundingClientRect();
    gd._fullLayout._calcInverseTransform(gd);
    var inverse = gd._fullLayout._invTransform;
    scaleX = gd._fullLayout._invScaleX;
    scaleY = gd._fullLayout._invScaleY;
    var transformedCoords = Lib.apply3DTransform(inverse)(startX - bbox.left, startY - bbox.top);
    x0 = transformedCoords[0];
    y0 = transformedCoords[1];

    // need to offset x/y as bbox center does not
    // match origin for asymmetric polygons
    if (vangles) {
      var offset = helpers.findPolygonOffset(radius, sectorInRad[0], sectorInRad[1], vangles);
      x0 += cxx + offset[0];
      y0 += cyy + offset[1];
    }
    switch (dragModeNow) {
      case 'zoom':
        dragOpts.clickFn = zoomClick;
        if (!isSmith) {
          if (vangles) {
            dragOpts.moveFn = zoomMoveForPolygons;
          } else {
            dragOpts.moveFn = zoomMove;
          }
          dragOpts.doneFn = zoomDone;
          zoomPrep(evt, startX, startY);
        }
        break;
      case 'select':
      case 'lasso':
        prepSelect(evt, startX, startY, dragOpts, dragModeNow);
        break;
    }
  };
  dragElement.init(dragOpts);
};
proto.updateRadialDrag = function (fullLayout, polarLayout, rngIndex) {
  var _this = this;
  var gd = _this.gd;
  var layers = _this.layers;
  var radius = _this.radius;
  var innerRadius = _this.innerRadius;
  var cx = _this.cx;
  var cy = _this.cy;
  var radialAxis = _this.radialAxis;
  var bl = constants.radialDragBoxSize;
  var bl2 = bl / 2;
  if (!radialAxis.visible) return;
  var angle0 = deg2rad(_this.radialAxisAngle);
  var rl = radialAxis._rl;
  var rl0 = rl[0];
  var rl1 = rl[1];
  var rbase = rl[rngIndex];
  var m = 0.75 * (rl[1] - rl[0]) / (1 - _this.getHole(polarLayout)) / radius;
  var tx, ty, className;
  if (rngIndex) {
    tx = cx + (radius + bl2) * Math.cos(angle0);
    ty = cy - (radius + bl2) * Math.sin(angle0);
    className = 'radialdrag';
  } else {
    // the 'inner' box can get called:
    // - when polar.hole>0
    // - when polar.sector isn't a full circle
    // otherwise it is hidden behind the main drag.
    tx = cx + (innerRadius - bl2) * Math.cos(angle0);
    ty = cy - (innerRadius - bl2) * Math.sin(angle0);
    className = 'radialdrag-inner';
  }
  var radialDrag = dragBox.makeRectDragger(layers, className, 'crosshair', -bl2, -bl2, bl, bl);
  var dragOpts = {
    element: radialDrag,
    gd: gd
  };
  if (fullLayout.dragmode === false) {
    dragOpts.dragmode = false;
  }
  updateElement(d3.select(radialDrag), radialAxis.visible && innerRadius < radius, {
    transform: strTranslate(tx, ty)
  });

  // move function (either rotate or re-range flavor)
  var moveFn2;
  // rotate angle on done
  var angle1;
  // re-range range[1] (or range[0]) on done
  var rprime;
  function moveFn(dx, dy) {
    if (moveFn2) {
      moveFn2(dx, dy);
    } else {
      var dvec = [dx, -dy];
      var rvec = [Math.cos(angle0), Math.sin(angle0)];
      var comp = Math.abs(Lib.dot(dvec, rvec) / Math.sqrt(Lib.dot(dvec, dvec)));

      // mostly perpendicular motions rotate,
      // mostly parallel motions re-range
      if (!isNaN(comp)) {
        moveFn2 = comp < 0.5 ? rotateMove : rerangeMove;
      }
    }
    var update = {};
    computeRadialAxisUpdates(update);
    gd.emit('plotly_relayouting', update);
  }
  function computeRadialAxisUpdates(update) {
    if (angle1 !== null) {
      update[_this.id + '.radialaxis.angle'] = angle1;
    } else if (rprime !== null) {
      update[_this.id + '.radialaxis.range[' + rngIndex + ']'] = rprime;
    }
  }
  function doneFn() {
    if (angle1 !== null) {
      Registry.call('_guiRelayout', gd, _this.id + '.radialaxis.angle', angle1);
    } else if (rprime !== null) {
      Registry.call('_guiRelayout', gd, _this.id + '.radialaxis.range[' + rngIndex + ']', rprime);
    }
  }
  function rotateMove(dx, dy) {
    // disable for inner drag boxes
    if (rngIndex === 0) return;
    var x1 = tx + dx;
    var y1 = ty + dy;
    angle1 = Math.atan2(cy - y1, x1 - cx);
    if (_this.vangles) angle1 = snapToVertexAngle(angle1, _this.vangles);
    angle1 = rad2deg(angle1);
    var transform = strTranslate(cx, cy) + strRotate(-angle1);
    layers['radial-axis'].attr('transform', transform);
    layers['radial-line'].select('line').attr('transform', transform);
    var fullLayoutNow = _this.gd._fullLayout;
    var polarLayoutNow = fullLayoutNow[_this.id];
    _this.updateRadialAxisTitle(fullLayoutNow, polarLayoutNow, angle1);
  }
  function rerangeMove(dx, dy) {
    // project (dx, dy) unto unit radial axis vector
    var dr = Lib.dot([dx, -dy], [Math.cos(angle0), Math.sin(angle0)]);
    rprime = rbase - m * dr;

    // make sure rprime does not change the range[0] -> range[1] sign
    if (m > 0 !== (rngIndex ? rprime > rl0 : rprime < rl1)) {
      rprime = null;
      return;
    }
    var fullLayoutNow = gd._fullLayout;
    var polarLayoutNow = fullLayoutNow[_this.id];

    // update radial range -> update c2g -> update _m,_b
    radialAxis.range[rngIndex] = rprime;
    radialAxis._rl[rngIndex] = rprime;
    _this.updateRadialAxis(fullLayoutNow, polarLayoutNow);
    _this.xaxis.setRange();
    _this.xaxis.setScale();
    _this.yaxis.setRange();
    _this.yaxis.setScale();
    var hasRegl = false;
    for (var traceType in _this.traceHash) {
      var moduleCalcData = _this.traceHash[traceType];
      var moduleCalcDataVisible = Lib.filterVisible(moduleCalcData);
      var _module = moduleCalcData[0][0].trace._module;
      _module.plot(gd, _this, moduleCalcDataVisible, polarLayoutNow);
      if (Registry.traceIs(traceType, 'gl') && moduleCalcDataVisible.length) hasRegl = true;
    }
    if (hasRegl) {
      clearGlCanvases(gd);
      redrawReglTraces(gd);
    }
  }
  dragOpts.prepFn = function () {
    moveFn2 = null;
    angle1 = null;
    rprime = null;
    dragOpts.moveFn = moveFn;
    dragOpts.doneFn = doneFn;
    clearOutline(gd);
  };
  dragOpts.clampFn = function (dx, dy) {
    if (Math.sqrt(dx * dx + dy * dy) < constants.MINDRAG) {
      dx = 0;
      dy = 0;
    }
    return [dx, dy];
  };
  dragElement.init(dragOpts);
};
proto.updateAngularDrag = function (fullLayout) {
  var _this = this;
  var gd = _this.gd;
  var layers = _this.layers;
  var radius = _this.radius;
  var angularAxis = _this.angularAxis;
  var cx = _this.cx;
  var cy = _this.cy;
  var cxx = _this.cxx;
  var cyy = _this.cyy;
  var dbs = constants.angularDragBoxSize;
  var angularDrag = dragBox.makeDragger(layers, 'path', 'angulardrag', fullLayout.dragmode === false ? 'none' : 'move');
  var dragOpts = {
    element: angularDrag,
    gd: gd
  };
  if (fullLayout.dragmode === false) {
    dragOpts.dragmode = false;
  } else {
    d3.select(angularDrag).attr('d', _this.pathAnnulus(radius, radius + dbs)).attr('transform', strTranslate(cx, cy)).call(setCursor, 'move');
  }
  function xy2a(x, y) {
    return Math.atan2(cyy + dbs - y, x - cxx - dbs);
  }

  // scatter trace, points and textpoints selections
  var scatterTraces = layers.frontplot.select('.scatterlayer').selectAll('.trace');
  var scatterPoints = scatterTraces.selectAll('.point');
  var scatterTextPoints = scatterTraces.selectAll('.textpoint');

  // mouse px position at drag start (0), move (1)
  var x0, y0;
  // angular axis angle rotation at drag start (0), move (1)
  var rot0, rot1;
  // induced radial axis rotation (only used on polygon grids)
  var rrot1;
  // angle about circle center at drag start
  var a0;
  function moveFn(dx, dy) {
    var fullLayoutNow = _this.gd._fullLayout;
    var polarLayoutNow = fullLayoutNow[_this.id];
    var x1 = x0 + dx * fullLayout._invScaleX;
    var y1 = y0 + dy * fullLayout._invScaleY;
    var a1 = xy2a(x1, y1);
    var da = rad2deg(a1 - a0);
    rot1 = rot0 + da;
    layers.frontplot.attr('transform', strTranslate(_this.xOffset2, _this.yOffset2) + strRotate([-da, cxx, cyy]));
    if (_this.vangles) {
      rrot1 = _this.radialAxisAngle + da;
      var trans = strTranslate(cx, cy) + strRotate(-da);
      var trans2 = strTranslate(cx, cy) + strRotate(-rrot1);
      layers.bg.attr('transform', trans);
      layers['radial-grid'].attr('transform', trans);
      layers['radial-axis'].attr('transform', trans2);
      layers['radial-line'].select('line').attr('transform', trans2);
      _this.updateRadialAxisTitle(fullLayoutNow, polarLayoutNow, rrot1);
    } else {
      _this.clipPaths.forTraces.select('path').attr('transform', strTranslate(cxx, cyy) + strRotate(da));
    }

    // 'un-rotate' marker and text points
    scatterPoints.each(function () {
      var sel = d3.select(this);
      var xy = Drawing.getTranslate(sel);
      sel.attr('transform', strTranslate(xy.x, xy.y) + strRotate([da]));
    });
    scatterTextPoints.each(function () {
      var sel = d3.select(this);
      var tx = sel.select('text');
      var xy = Drawing.getTranslate(sel);
      // N.B rotate -> translate ordering matters
      sel.attr('transform', strRotate([da, tx.attr('x'), tx.attr('y')]) + strTranslate(xy.x, xy.y));
    });

    // update rotation -> range -> _m,_b
    angularAxis.rotation = Lib.modHalf(rot1, 360);
    _this.updateAngularAxis(fullLayoutNow, polarLayoutNow);
    if (_this._hasClipOnAxisFalse && !Lib.isFullCircle(_this.sectorInRad)) {
      scatterTraces.call(Drawing.hideOutsideRangePoints, _this);
    }
    var hasRegl = false;
    for (var traceType in _this.traceHash) {
      if (Registry.traceIs(traceType, 'gl')) {
        var moduleCalcData = _this.traceHash[traceType];
        var moduleCalcDataVisible = Lib.filterVisible(moduleCalcData);
        var _module = moduleCalcData[0][0].trace._module;
        _module.plot(gd, _this, moduleCalcDataVisible, polarLayoutNow);
        if (moduleCalcDataVisible.length) hasRegl = true;
      }
    }
    if (hasRegl) {
      clearGlCanvases(gd);
      redrawReglTraces(gd);
    }
    var update = {};
    computeRotationUpdates(update);
    gd.emit('plotly_relayouting', update);
  }
  function computeRotationUpdates(updateObj) {
    updateObj[_this.id + '.angularaxis.rotation'] = rot1;
    if (_this.vangles) {
      updateObj[_this.id + '.radialaxis.angle'] = rrot1;
    }
  }
  function doneFn() {
    scatterTextPoints.select('text').attr('transform', null);
    var updateObj = {};
    computeRotationUpdates(updateObj);
    Registry.call('_guiRelayout', gd, updateObj);
  }
  dragOpts.prepFn = function (evt, startX, startY) {
    var polarLayoutNow = fullLayout[_this.id];
    rot0 = polarLayoutNow.angularaxis.rotation;
    var bbox = angularDrag.getBoundingClientRect();
    x0 = startX - bbox.left;
    y0 = startY - bbox.top;
    gd._fullLayout._calcInverseTransform(gd);
    var transformedCoords = Lib.apply3DTransform(fullLayout._invTransform)(x0, y0);
    x0 = transformedCoords[0];
    y0 = transformedCoords[1];
    a0 = xy2a(x0, y0);
    dragOpts.moveFn = moveFn;
    dragOpts.doneFn = doneFn;
    clearOutline(gd);
  };

  // I don't what we should do in this case, skip we now
  if (_this.vangles && !Lib.isFullCircle(_this.sectorInRad)) {
    dragOpts.prepFn = Lib.noop;
    setCursor(d3.select(angularDrag), null);
  }
  dragElement.init(dragOpts);
};
proto.isPtInside = function (d) {
  if (this.isSmith) return true;
  var sectorInRad = this.sectorInRad;
  var vangles = this.vangles;
  var thetag = this.angularAxis.c2g(d.theta);
  var radialAxis = this.radialAxis;
  var r = radialAxis.c2l(d.r);
  var rl = radialAxis._rl;
  var fn = vangles ? helpers.isPtInsidePolygon : Lib.isPtInsideSector;
  return fn(r, thetag, rl, sectorInRad, vangles);
};
proto.pathArc = function (r) {
  var sectorInRad = this.sectorInRad;
  var vangles = this.vangles;
  var fn = vangles ? helpers.pathPolygon : Lib.pathArc;
  return fn(r, sectorInRad[0], sectorInRad[1], vangles);
};
proto.pathSector = function (r) {
  var sectorInRad = this.sectorInRad;
  var vangles = this.vangles;
  var fn = vangles ? helpers.pathPolygon : Lib.pathSector;
  return fn(r, sectorInRad[0], sectorInRad[1], vangles);
};
proto.pathAnnulus = function (r0, r1) {
  var sectorInRad = this.sectorInRad;
  var vangles = this.vangles;
  var fn = vangles ? helpers.pathPolygonAnnulus : Lib.pathAnnulus;
  return fn(r0, r1, sectorInRad[0], sectorInRad[1], vangles);
};
proto.pathSubplot = function () {
  var r0 = this.innerRadius;
  var r1 = this.radius;
  return r0 ? this.pathAnnulus(r0, r1) : this.pathSector(r1);
};
proto.fillViewInitialKey = function (key, val) {
  if (!(key in this.viewInitial)) {
    this.viewInitial[key] = val;
  }
};
function strTickLayout(axLayout) {
  var out = axLayout.ticks + String(axLayout.ticklen) + String(axLayout.showticklabels);
  if ('side' in axLayout) out += axLayout.side;
  return out;
}

// Finds the bounding box of a given circle sector,
// inspired by https://math.stackexchange.com/q/1852703
//
// assumes:
// - sector[0] < sector[1]
// - counterclockwise rotation
function computeSectorBBox(sector) {
  var s0 = sector[0];
  var s1 = sector[1];
  var arc = s1 - s0;
  var a0 = mod(s0, 360);
  var a1 = a0 + arc;
  var ax0 = Math.cos(deg2rad(a0));
  var ay0 = Math.sin(deg2rad(a0));
  var ax1 = Math.cos(deg2rad(a1));
  var ay1 = Math.sin(deg2rad(a1));
  var x0, y0, x1, y1;
  if (a0 <= 90 && a1 >= 90 || a0 > 90 && a1 >= 450) {
    y1 = 1;
  } else if (ay0 <= 0 && ay1 <= 0) {
    y1 = 0;
  } else {
    y1 = Math.max(ay0, ay1);
  }
  if (a0 <= 180 && a1 >= 180 || a0 > 180 && a1 >= 540) {
    x0 = -1;
  } else if (ax0 >= 0 && ax1 >= 0) {
    x0 = 0;
  } else {
    x0 = Math.min(ax0, ax1);
  }
  if (a0 <= 270 && a1 >= 270 || a0 > 270 && a1 >= 630) {
    y0 = -1;
  } else if (ay0 >= 0 && ay1 >= 0) {
    y0 = 0;
  } else {
    y0 = Math.min(ay0, ay1);
  }
  if (a1 >= 360) {
    x1 = 1;
  } else if (ax0 <= 0 && ax1 <= 0) {
    x1 = 0;
  } else {
    x1 = Math.max(ax0, ax1);
  }
  return [x0, y0, x1, y1];
}
function snapToVertexAngle(a, vangles) {
  var fn = function (v) {
    return Lib.angleDist(a, v);
  };
  var ind = Lib.findIndexOfMin(vangles, fn);
  return vangles[ind];
}
function updateElement(sel, showAttr, attrs) {
  if (showAttr) {
    sel.attr('display', null);
    sel.attr(attrs);
  } else if (sel) {
    sel.attr('display', 'none');
  }
  return sel;
}

/***/ }),

/***/ 51937:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var setConvertCartesian = __webpack_require__(19091);
var deg2rad = Lib.deg2rad;
var rad2deg = Lib.rad2deg;

/**
 * setConvert for polar axes!
 *
 * @param {object} ax
 *   axis in question (works for both radial and angular axes)
 * @param {object} polarLayout
 *   full polar layout of the subplot associated with 'ax'
 * @param {object} fullLayout
 *   full layout
 *
 * Here, reuse some of the Cartesian setConvert logic,
 * but we must extend some of it, as both radial and angular axes
 * don't have domains and angular axes don't have _true_ ranges.
 *
 * Moreover, we introduce two new coordinate systems:
 * - 'g' for geometric coordinates and
 * - 't' for angular ticks
 *
 * Radial axis coordinate systems:
 * - d, c and l: same as for cartesian axes
 * - g: like calcdata but translated about `radialaxis.range[0]` & `polar.hole`
 *
 * Angular axis coordinate systems:
 * - d: data, in whatever form it's provided
 * - c: calcdata, turned into radians (for linear axes)
 *      or category indices (category axes)
 * - t: tick calcdata, just like 'c' but in degrees for linear axes
 * - g: geometric calcdata, radians coordinates that take into account
 *      axis rotation and direction
 *
 * Then, 'g'eometric data is ready to be converted to (x,y).
 */
module.exports = function setConvert(ax, polarLayout, fullLayout) {
  setConvertCartesian(ax, fullLayout);
  switch (ax._id) {
    case 'x':
    case 'radialaxis':
      setConvertRadial(ax, polarLayout);
      break;
    case 'angularaxis':
      setConvertAngular(ax, polarLayout);
      break;
  }
};
function setConvertRadial(ax, polarLayout) {
  var subplot = polarLayout._subplot;
  ax.setGeometry = function () {
    var rl0 = ax._rl[0];
    var rl1 = ax._rl[1];
    var b = subplot.innerRadius;
    var m = (subplot.radius - b) / (rl1 - rl0);
    var b2 = b / m;
    var rFilter = rl0 > rl1 ? function (v) {
      return v <= 0;
    } : function (v) {
      return v >= 0;
    };
    ax.c2g = function (v) {
      var r = ax.c2l(v) - rl0;
      return (rFilter(r) ? r : 0) + b2;
    };
    ax.g2c = function (v) {
      return ax.l2c(v + rl0 - b2);
    };
    ax.g2p = function (v) {
      return v * m;
    };
    ax.c2p = function (v) {
      return ax.g2p(ax.c2g(v));
    };
  };
}
function toRadians(v, unit) {
  return unit === 'degrees' ? deg2rad(v) : v;
}
function fromRadians(v, unit) {
  return unit === 'degrees' ? rad2deg(v) : v;
}
function setConvertAngular(ax, polarLayout) {
  var axType = ax.type;
  if (axType === 'linear') {
    var _d2c = ax.d2c;
    var _c2d = ax.c2d;
    ax.d2c = function (v, unit) {
      return toRadians(_d2c(v), unit);
    };
    ax.c2d = function (v, unit) {
      return _c2d(fromRadians(v, unit));
    };
  }

  // override makeCalcdata to handle thetaunit and special theta0/dtheta logic
  ax.makeCalcdata = function (trace, coord) {
    var arrayIn = trace[coord];
    var len = trace._length;
    var arrayOut, i;
    var _d2c = function (v) {
      return ax.d2c(v, trace.thetaunit);
    };
    if (arrayIn) {
      arrayOut = new Array(len);
      for (i = 0; i < len; i++) {
        arrayOut[i] = _d2c(arrayIn[i]);
      }
    } else {
      var coord0 = coord + '0';
      var dcoord = 'd' + coord;
      var v0 = coord0 in trace ? _d2c(trace[coord0]) : 0;
      var dv = trace[dcoord] ? _d2c(trace[dcoord]) : (ax.period || 2 * Math.PI) / len;
      arrayOut = new Array(len);
      for (i = 0; i < len; i++) {
        arrayOut[i] = v0 + i * dv;
      }
    }
    return arrayOut;
  };

  // N.B. we mock the axis 'range' here
  ax.setGeometry = function () {
    var sector = polarLayout.sector;
    var sectorInRad = sector.map(deg2rad);
    var dir = {
      clockwise: -1,
      counterclockwise: 1
    }[ax.direction];
    var rot = deg2rad(ax.rotation);
    var rad2g = function (v) {
      return dir * v + rot;
    };
    var g2rad = function (v) {
      return (v - rot) / dir;
    };
    var rad2c, c2rad;
    var rad2t, t2rad;
    switch (axType) {
      case 'linear':
        c2rad = rad2c = Lib.identity;
        t2rad = deg2rad;
        rad2t = rad2deg;

        // Set the angular range in degrees to make auto-tick computation cleaner,
        // changing rotation/direction should not affect the angular tick value.
        ax.range = Lib.isFullCircle(sectorInRad) ? [sector[0], sector[0] + 360] : sectorInRad.map(g2rad).map(rad2deg);
        break;
      case 'category':
        var catLen = ax._categories.length;
        var _period = ax.period ? Math.max(ax.period, catLen) : catLen;

        // fallback in case all categories have been filtered out
        if (_period === 0) _period = 1;
        c2rad = t2rad = function (v) {
          return v * 2 * Math.PI / _period;
        };
        rad2c = rad2t = function (v) {
          return v * _period / Math.PI / 2;
        };
        ax.range = [0, _period];
        break;
    }
    ax.c2g = function (v) {
      return rad2g(c2rad(v));
    };
    ax.g2c = function (v) {
      return rad2c(g2rad(v));
    };
    ax.t2g = function (v) {
      return rad2g(t2rad(v));
    };
    ax.g2t = function (v) {
      return rad2t(g2rad(v));
    };
  };
}

/***/ }),

/***/ 70951:
/***/ (function(module) {

"use strict";


module.exports = {
  attr: 'subplot',
  name: 'smith',
  axisNames: ['realaxis', 'imaginaryaxis' // imaginary axis should be second here so that the `tickvals` defaults could be inherited from realaxis
  ],
  axisName2dataArray: {
    imaginaryaxis: 'imag',
    realaxis: 'real'
  }
};

/***/ }),

/***/ 52007:
/***/ (function(module) {

"use strict";


function sign(x) {
  return x < 0 ? -1 : x > 0 ? 1 : 0;
}

// adapted from Mike Bostock's https://observablehq.com/@mbostock/smith-chart
function smith(a) {
  var R = a[0];
  var X = a[1];
  if (!isFinite(R) || !isFinite(X)) return [1, 0];
  var D = (R + 1) * (R + 1) + X * X;
  return [(R * R + X * X - 1) / D, 2 * X / D];
}
function transform(subplot, a) {
  var x = a[0];
  var y = a[1];
  return [x * subplot.radius + subplot.cx, -y * subplot.radius + subplot.cy];
}
function scale(subplot, r) {
  return r * subplot.radius;
}
function reactanceArc(subplot, X, R1, R2) {
  var t1 = transform(subplot, smith([R1, X]));
  var x1 = t1[0];
  var y1 = t1[1];
  var t2 = transform(subplot, smith([R2, X]));
  var x2 = t2[0];
  var y2 = t2[1];
  if (X === 0) {
    return ['M' + x1 + ',' + y1, 'L' + x2 + ',' + y2].join(' ');
  }
  var r = scale(subplot, 1 / Math.abs(X));
  return ['M' + x1 + ',' + y1, 'A' + r + ',' + r + ' 0 0,' + (X < 0 ? 1 : 0) + ' ' + x2 + ',' + y2].join(' ');
}
function resistanceArc(subplot, R, X1, X2) {
  var r = scale(subplot, 1 / (R + 1));
  var t1 = transform(subplot, smith([R, X1]));
  var x1 = t1[0];
  var y1 = t1[1];
  var t2 = transform(subplot, smith([R, X2]));
  var x2 = t2[0];
  var y2 = t2[1];
  if (sign(X1) !== sign(X2)) {
    var t0 = transform(subplot, smith([R, 0]));
    var x0 = t0[0];
    var y0 = t0[1];
    return ['M' + x1 + ',' + y1, 'A' + r + ',' + r + ' 0 0,' + (0 < X1 ? 0 : 1) + ' ' + x0 + ',' + y0, 'A' + r + ',' + r + ' 0 0,' + (X2 < 0 ? 0 : 1) + x2 + ',' + y2].join(' ');
  }
  return ['M' + x1 + ',' + y1, 'A' + r + ',' + r + ' 0 0,' + (X2 < X1 ? 0 : 1) + ' ' + x2 + ',' + y2].join(' ');
}
module.exports = {
  smith: smith,
  reactanceArc: reactanceArc,
  resistanceArc: resistanceArc,
  smithTransform: transform
};

/***/ }),

/***/ 50358:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var getSubplotCalcData = (__webpack_require__(4173)/* .getSubplotCalcData */ .fX);
var counterRegex = (__webpack_require__(34809).counterRegex);
var createPolar = __webpack_require__(35785);
var constants = __webpack_require__(70951);
var attr = constants.attr;
var name = constants.name;
var counter = counterRegex(name);
var attributes = {};
attributes[attr] = {
  valType: 'subplotid',
  dflt: name,
  editType: 'calc'
};
function plot(gd) {
  var fullLayout = gd._fullLayout;
  var calcData = gd.calcdata;
  var subplotIds = fullLayout._subplots[name];
  for (var i = 0; i < subplotIds.length; i++) {
    var id = subplotIds[i];
    var subplotCalcData = getSubplotCalcData(calcData, name, id);
    var subplot = fullLayout[id]._subplot;
    if (!subplot) {
      subplot = createPolar(gd, id, true);
      fullLayout[id]._subplot = subplot;
    }
    subplot.plot(subplotCalcData, fullLayout, gd._promises);
  }
}
function clean(newFullData, newFullLayout, oldFullData, oldFullLayout) {
  var oldIds = oldFullLayout._subplots[name] || [];
  for (var i = 0; i < oldIds.length; i++) {
    var id = oldIds[i];
    var oldSubplot = oldFullLayout[id]._subplot;
    if (!newFullLayout[id] && !!oldSubplot) {
      oldSubplot.framework.remove();
      for (var k in oldSubplot.clipPaths) {
        oldSubplot.clipPaths[k].remove();
      }
    }
  }
}
module.exports = {
  attr: attr,
  name: name,
  idRoot: name,
  idRegex: counter,
  attrRegex: counter,
  attributes: attributes,
  layoutAttributes: __webpack_require__(93288),
  supplyLayoutDefaults: __webpack_require__(31359),
  plot: plot,
  clean: clean,
  toSVG: (__webpack_require__(37703).toSVG)
};

/***/ }),

/***/ 93288:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var colorAttrs = __webpack_require__(10229);
var axesAttrs = __webpack_require__(25829);
var domainAttrs = (__webpack_require__(13792)/* .attributes */ .u);
var extendFlat = (__webpack_require__(34809).extendFlat);
var overrideAll = (__webpack_require__(13582).overrideAll);
var axisLineGridAttr = overrideAll({
  color: axesAttrs.color,
  showline: extendFlat({}, axesAttrs.showline, {
    dflt: true
  }),
  linecolor: axesAttrs.linecolor,
  linewidth: axesAttrs.linewidth,
  showgrid: extendFlat({}, axesAttrs.showgrid, {
    dflt: true
  }),
  gridcolor: axesAttrs.gridcolor,
  gridwidth: axesAttrs.gridwidth,
  griddash: axesAttrs.griddash
}, 'plot', 'from-root');
var axisTickAttrs = overrideAll({
  ticklen: axesAttrs.ticklen,
  tickwidth: extendFlat({}, axesAttrs.tickwidth, {
    dflt: 2
  }),
  tickcolor: axesAttrs.tickcolor,
  showticklabels: axesAttrs.showticklabels,
  labelalias: axesAttrs.labelalias,
  showtickprefix: axesAttrs.showtickprefix,
  tickprefix: axesAttrs.tickprefix,
  showticksuffix: axesAttrs.showticksuffix,
  ticksuffix: axesAttrs.ticksuffix,
  tickfont: axesAttrs.tickfont,
  tickformat: axesAttrs.tickformat,
  hoverformat: axesAttrs.hoverformat,
  layer: axesAttrs.layer
}, 'plot', 'from-root');
var realAxisAttrs = extendFlat({
  visible: extendFlat({}, axesAttrs.visible, {
    dflt: true
  }),
  tickvals: {
    dflt: [0.2, 0.5, 1, 2, 5],
    valType: 'data_array',
    editType: 'plot'
  },
  tickangle: extendFlat({}, axesAttrs.tickangle, {
    dflt: 90
  }),
  ticks: {
    valType: 'enumerated',
    values: ['top', 'bottom', ''],
    editType: 'ticks'
  },
  side: {
    valType: 'enumerated',
    values: ['top', 'bottom'],
    dflt: 'top',
    editType: 'plot'
  },
  editType: 'calc'
}, axisLineGridAttr, axisTickAttrs);
var imaginaryAxisAttrs = extendFlat({
  visible: extendFlat({}, axesAttrs.visible, {
    dflt: true
  }),
  tickvals: {
    valType: 'data_array',
    editType: 'plot'
  },
  ticks: axesAttrs.ticks,
  editType: 'calc'
}, axisLineGridAttr, axisTickAttrs);
module.exports = {
  domain: domainAttrs({
    name: 'smith',
    editType: 'plot'
  }),
  bgcolor: {
    valType: 'color',
    editType: 'plot',
    dflt: colorAttrs.background
  },
  realaxis: realAxisAttrs,
  imaginaryaxis: imaginaryAxisAttrs,
  editType: 'calc'
};

/***/ }),

/***/ 31359:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var Color = __webpack_require__(78766);
var Template = __webpack_require__(78032);
var handleSubplotDefaults = __webpack_require__(4448);
var getSubplotData = (__webpack_require__(4173)/* .getSubplotData */ .KO);
var handlePrefixSuffixDefaults = __webpack_require__(54616);
var handleTickLabelDefaults = __webpack_require__(12036);
var handleLineGridDefaults = __webpack_require__(97405);
var setConvertCartesian = __webpack_require__(19091);
var layoutAttributes = __webpack_require__(93288);
var constants = __webpack_require__(70951);
var axisNames = constants.axisNames;
var makeImagDflt = memoize(function (realTickvals) {
  // TODO: handle this case outside supply defaults step
  if (Lib.isTypedArray(realTickvals)) realTickvals = Array.from(realTickvals);
  return realTickvals.slice().reverse().map(function (x) {
    return -x;
  }).concat([0]).concat(realTickvals);
}, String);
function handleDefaults(contIn, contOut, coerce, opts) {
  var bgColor = coerce('bgcolor');
  opts.bgColor = Color.combine(bgColor, opts.paper_bgcolor);
  var subplotData = getSubplotData(opts.fullData, constants.name, opts.id);
  var layoutOut = opts.layoutOut;
  var axName;
  function coerceAxis(attr, dflt) {
    return coerce(axName + '.' + attr, dflt);
  }
  for (var i = 0; i < axisNames.length; i++) {
    axName = axisNames[i];
    if (!Lib.isPlainObject(contIn[axName])) {
      contIn[axName] = {};
    }
    var axIn = contIn[axName];
    var axOut = Template.newContainer(contOut, axName);
    axOut._id = axOut._name = axName;
    axOut._attr = opts.id + '.' + axName;
    axOut._traceIndices = subplotData.map(function (t) {
      return t._expandedIndex;
    });
    var visible = coerceAxis('visible');
    axOut.type = 'linear';
    setConvertCartesian(axOut, layoutOut);
    handlePrefixSuffixDefaults(axIn, axOut, coerceAxis, axOut.type);
    if (visible) {
      var isRealAxis = axName === 'realaxis';
      if (isRealAxis) coerceAxis('side');
      if (isRealAxis) {
        coerceAxis('tickvals');
      } else {
        var imagTickvalsDflt = makeImagDflt(contOut.realaxis.tickvals || layoutAttributes.realaxis.tickvals.dflt);
        coerceAxis('tickvals', imagTickvalsDflt);
      }

      // TODO: handle this case outside supply defaults step
      if (Lib.isTypedArray(axOut.tickvals)) axOut.tickvals = Array.from(axOut.tickvals);
      var dfltColor;
      var dfltFontColor;
      var dfltFontSize;
      var dfltFontFamily;
      var font = opts.font || {};
      if (visible) {
        dfltColor = coerceAxis('color');
        dfltFontColor = dfltColor === axIn.color ? dfltColor : font.color;
        dfltFontSize = font.size;
        dfltFontFamily = font.family;
      }
      handleTickLabelDefaults(axIn, axOut, coerceAxis, axOut.type, {
        noAutotickangles: true,
        noTicklabelshift: true,
        noTicklabelstandoff: true,
        noTicklabelstep: true,
        noAng: !isRealAxis,
        noExp: true,
        font: {
          color: dfltFontColor,
          size: dfltFontSize,
          family: dfltFontFamily
        }
      });
      Lib.coerce2(contIn, contOut, layoutAttributes, axName + '.ticklen');
      Lib.coerce2(contIn, contOut, layoutAttributes, axName + '.tickwidth');
      Lib.coerce2(contIn, contOut, layoutAttributes, axName + '.tickcolor', contOut.color);
      var showTicks = coerceAxis('ticks');
      if (!showTicks) {
        delete contOut[axName].ticklen;
        delete contOut[axName].tickwidth;
        delete contOut[axName].tickcolor;
      }
      handleLineGridDefaults(axIn, axOut, coerceAxis, {
        dfltColor: dfltColor,
        bgColor: opts.bgColor,
        // default grid color is darker here (60%, vs cartesian default ~91%)
        // because the grid is not square so the eye needs heavier cues to follow
        blend: 60,
        showLine: true,
        showGrid: true,
        noZeroLine: true,
        attributes: layoutAttributes[axName]
      });
      coerceAxis('layer');
    }
    coerceAxis('hoverformat');
    delete axOut.type;
    axOut._input = axIn;
  }
}
module.exports = function supplyLayoutDefaults(layoutIn, layoutOut, fullData) {
  handleSubplotDefaults(layoutIn, layoutOut, fullData, {
    noUirevision: true,
    type: constants.name,
    attributes: layoutAttributes,
    handleDefaults: handleDefaults,
    font: layoutOut.font,
    paper_bgcolor: layoutOut.paper_bgcolor,
    fullData: fullData,
    layoutOut: layoutOut
  });
};
function memoize(fn, keyFn) {
  var cache = {};
  return function (val) {
    var newKey = keyFn ? keyFn(val) : val;
    if (newKey in cache) {
      return cache[newKey];
    }
    var out = fn(val);
    cache[newKey] = out;
    return out;
  };
}

/***/ }),

/***/ 4448:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var Template = __webpack_require__(78032);
var handleDomainDefaults = (__webpack_require__(13792)/* .defaults */ .N);

/**
 * Find and supply defaults to all subplots of a given type
 * This handles subplots that are contained within one container - so
 * gl3d, geo, ternary... but not 2d axes which have separate x and y axes
 * finds subplots, coerces their `domain` attributes, then calls the
 * given handleDefaults function to fill in everything else.
 *
 * layoutIn: the complete user-supplied input layout
 * layoutOut: the complete finished layout
 * fullData: the finished data array, used only to find subplots
 * opts: {
 *  type: subplot type string
 *  attributes: subplot attributes object
 *  partition: 'x' or 'y', which direction to divide domain space by default
 *      (default 'x', ie side-by-side subplots)
 *      TODO: this option is only here because 3D and geo made opposite
 *      choices in this regard previously and I didn't want to change it.
 *      Instead we should do:
 *      - something consistent
 *      - something more square (4 cuts 2x2, 5/6 cuts 2x3, etc.)
 *      - something that includes all subplot types in one arrangement,
 *        now that we can have them together!
 *  handleDefaults: function of (subplotLayoutIn, subplotLayoutOut, coerce, opts)
 *      this opts object is passed through to handleDefaults, so attach any
 *      additional items needed by this function here as well
 * }
 */
module.exports = function handleSubplotDefaults(layoutIn, layoutOut, fullData, opts) {
  var subplotType = opts.type;
  var subplotAttributes = opts.attributes;
  var handleDefaults = opts.handleDefaults;
  var partition = opts.partition || 'x';
  var ids = layoutOut._subplots[subplotType];
  var idsLength = ids.length;
  var baseId = idsLength && ids[0].replace(/\d+$/, '');
  var subplotLayoutIn, subplotLayoutOut;
  function coerce(attr, dflt) {
    return Lib.coerce(subplotLayoutIn, subplotLayoutOut, subplotAttributes, attr, dflt);
  }
  for (var i = 0; i < idsLength; i++) {
    var id = ids[i];

    // ternary traces get a layout ternary for free!
    if (layoutIn[id]) subplotLayoutIn = layoutIn[id];else subplotLayoutIn = layoutIn[id] = {};
    subplotLayoutOut = Template.newContainer(layoutOut, id, baseId);
    if (!opts.noUirevision) coerce('uirevision', layoutOut.uirevision);
    var dfltDomains = {};
    dfltDomains[partition] = [i / idsLength, (i + 1) / idsLength];
    handleDomainDefaults(subplotLayoutOut, layoutOut, coerce, dfltDomains);
    opts.id = id;
    handleDefaults(subplotLayoutIn, subplotLayoutOut, coerce, opts);
  }
};

/***/ }),

/***/ 3208:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var docs = __webpack_require__(87296);
var FORMAT_LINK = docs.FORMAT_LINK;
var DATE_FORMAT_LINK = docs.DATE_FORMAT_LINK;
function templateFormatStringDescription(opts) {
  var supportOther = opts && opts.supportOther;
  return ['Variables are inserted using %{variable},', 'for example "y: %{y}"' + (supportOther ? ' as well as %{xother}, {%_xother}, {%_xother_}, {%xother_}. When showing info for several points, *xother* will be added to those with different x positions from the first point. An underscore before or after *(x|y)other* will add a space on that side, only when this field is shown.' : '.'), 'Numbers are formatted using d3-format\'s syntax %{variable:d3-format}, for example "Price: %{y:$.2f}".', FORMAT_LINK, 'for details on the formatting syntax.', 'Dates are formatted using d3-time-format\'s syntax %{variable|d3-time-format}, for example "Day: %{2019-01-01|%A}".', DATE_FORMAT_LINK, 'for details on the date formatting syntax.'].join(' ');
}
function shapeTemplateFormatStringDescription() {
  return ['Variables are inserted using %{variable},', 'for example "x0: %{x0}".', 'Numbers are formatted using d3-format\'s syntax %{variable:d3-format}, for example "Price: %{x0:$.2f}". See', FORMAT_LINK, 'for details on the formatting syntax.', 'Dates are formatted using d3-time-format\'s syntax %{variable|d3-time-format}, for example "Day: %{x0|%m %b %Y}". See', DATE_FORMAT_LINK, 'for details on the date formatting syntax.', 'A single multiplication or division operation may be applied to numeric variables, and combined with', 'd3 number formatting, for example "Length in cm: %{x0*2.54}", "%{slope*60:.1f} meters per second."', 'For log axes, variable values are given in log units.', 'For date axes, x/y coordinate variables and center variables use datetimes, while all other variable values use values in ms.'].join(' ');
}
function describeVariables(extra) {
  var descPart = extra.description ? ' ' + extra.description : '';
  var keys = extra.keys || [];
  if (keys.length > 0) {
    var quotedKeys = [];
    for (var i = 0; i < keys.length; i++) {
      quotedKeys[i] = '`' + keys[i] + '`';
    }
    descPart = descPart + 'Finally, the template string has access to ';
    if (keys.length === 1) {
      descPart = descPart + 'variable ' + quotedKeys[0];
    } else {
      descPart = descPart + 'variables ' + quotedKeys.slice(0, -1).join(', ') + ' and ' + quotedKeys.slice(-1) + '.';
    }
  }
  return descPart;
}
exports.rb = function (opts, extra) {
  opts = opts || {};
  extra = extra || {};
  var descPart = describeVariables(extra);
  var hovertemplate = {
    valType: 'string',
    dflt: '',
    editType: opts.editType || 'none'
  };
  if (opts.arrayOk !== false) {
    hovertemplate.arrayOk = true;
  }
  return hovertemplate;
};
exports.ay = function (opts, extra) {
  opts = opts || {};
  extra = extra || {};
  var descPart = describeVariables(extra);
  var texttemplate = {
    valType: 'string',
    dflt: '',
    editType: opts.editType || 'calc'
  };
  if (opts.arrayOk !== false) {
    texttemplate.arrayOk = true;
  }
  return texttemplate;
};
exports.LF = function (opts, extra) {
  opts = opts || {};
  extra = extra || {};
  var newStr = opts.newshape ? 'new ' : '';
  var descPart = describeVariables(extra);
  var texttemplate = {
    valType: 'string',
    dflt: '',
    editType: opts.editType || 'arraydraw'
  };
  return texttemplate;
};

/***/ }),

/***/ 7638:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var Ternary = __webpack_require__(83637);
var getSubplotCalcData = (__webpack_require__(4173)/* .getSubplotCalcData */ .fX);
var counterRegex = (__webpack_require__(34809).counterRegex);
var TERNARY = 'ternary';
exports.name = TERNARY;
var attr = exports.attr = 'subplot';
exports.idRoot = TERNARY;
exports.idRegex = exports.attrRegex = counterRegex(TERNARY);
var attributes = exports.attributes = {};
attributes[attr] = {
  valType: 'subplotid',
  dflt: 'ternary',
  editType: 'calc'
};
exports.layoutAttributes = __webpack_require__(77416);
exports.supplyLayoutDefaults = __webpack_require__(25247);
exports.plot = function plot(gd) {
  var fullLayout = gd._fullLayout;
  var calcData = gd.calcdata;
  var ternaryIds = fullLayout._subplots[TERNARY];
  for (var i = 0; i < ternaryIds.length; i++) {
    var ternaryId = ternaryIds[i];
    var ternaryCalcData = getSubplotCalcData(calcData, TERNARY, ternaryId);
    var ternary = fullLayout[ternaryId]._subplot;

    // If ternary is not instantiated, create one!
    if (!ternary) {
      ternary = new Ternary({
        id: ternaryId,
        graphDiv: gd,
        container: fullLayout._ternarylayer.node()
      }, fullLayout);
      fullLayout[ternaryId]._subplot = ternary;
    }
    ternary.plot(ternaryCalcData, fullLayout, gd._promises);
  }
};
exports.clean = function (newFullData, newFullLayout, oldFullData, oldFullLayout) {
  var oldTernaryKeys = oldFullLayout._subplots[TERNARY] || [];
  for (var i = 0; i < oldTernaryKeys.length; i++) {
    var oldTernaryKey = oldTernaryKeys[i];
    var oldTernary = oldFullLayout[oldTernaryKey]._subplot;
    if (!newFullLayout[oldTernaryKey] && !!oldTernary) {
      oldTernary.plotContainer.remove();
      oldTernary.clipDef.remove();
      oldTernary.clipDefRelative.remove();
      oldTernary.layers['a-title'].remove();
      oldTernary.layers['b-title'].remove();
      oldTernary.layers['c-title'].remove();
    }
  }
};
exports.updateFx = function (gd) {
  var fullLayout = gd._fullLayout;
  fullLayout._ternarylayer.selectAll('g.toplevel').style('cursor', fullLayout.dragmode === 'pan' ? 'move' : 'crosshair');
};

/***/ }),

/***/ 77416:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var colorAttrs = __webpack_require__(10229);
var domainAttrs = (__webpack_require__(13792)/* .attributes */ .u);
var axesAttrs = __webpack_require__(25829);
var overrideAll = (__webpack_require__(13582).overrideAll);
var extendFlat = (__webpack_require__(93049).extendFlat);
var ternaryAxesAttrs = {
  title: {
    text: axesAttrs.title.text,
    font: axesAttrs.title.font
    // TODO does standoff here make sense?
  },
  color: axesAttrs.color,
  // ticks
  tickmode: axesAttrs.minor.tickmode,
  nticks: extendFlat({}, axesAttrs.nticks, {
    dflt: 6,
    min: 1
  }),
  tick0: axesAttrs.tick0,
  dtick: axesAttrs.dtick,
  tickvals: axesAttrs.tickvals,
  ticktext: axesAttrs.ticktext,
  ticks: axesAttrs.ticks,
  ticklen: axesAttrs.ticklen,
  tickwidth: axesAttrs.tickwidth,
  tickcolor: axesAttrs.tickcolor,
  ticklabelstep: axesAttrs.ticklabelstep,
  showticklabels: axesAttrs.showticklabels,
  labelalias: axesAttrs.labelalias,
  showtickprefix: axesAttrs.showtickprefix,
  tickprefix: axesAttrs.tickprefix,
  showticksuffix: axesAttrs.showticksuffix,
  ticksuffix: axesAttrs.ticksuffix,
  showexponent: axesAttrs.showexponent,
  exponentformat: axesAttrs.exponentformat,
  minexponent: axesAttrs.minexponent,
  separatethousands: axesAttrs.separatethousands,
  tickfont: axesAttrs.tickfont,
  tickangle: axesAttrs.tickangle,
  tickformat: axesAttrs.tickformat,
  tickformatstops: axesAttrs.tickformatstops,
  hoverformat: axesAttrs.hoverformat,
  // lines and grids
  showline: extendFlat({}, axesAttrs.showline, {
    dflt: true
  }),
  linecolor: axesAttrs.linecolor,
  linewidth: axesAttrs.linewidth,
  showgrid: extendFlat({}, axesAttrs.showgrid, {
    dflt: true
  }),
  gridcolor: axesAttrs.gridcolor,
  gridwidth: axesAttrs.gridwidth,
  griddash: axesAttrs.griddash,
  layer: axesAttrs.layer,
  // range
  min: {
    valType: 'number',
    dflt: 0,
    min: 0
  },
  _deprecated: {
    title: axesAttrs._deprecated.title,
    titlefont: axesAttrs._deprecated.titlefont
  }
};
var attrs = module.exports = overrideAll({
  domain: domainAttrs({
    name: 'ternary'
  }),
  bgcolor: {
    valType: 'color',
    dflt: colorAttrs.background
  },
  sum: {
    valType: 'number',
    dflt: 1,
    min: 0
  },
  aaxis: ternaryAxesAttrs,
  baxis: ternaryAxesAttrs,
  caxis: ternaryAxesAttrs
}, 'plot', 'from-root');

// set uirevisions outside of `overrideAll` so we can get `editType: none`
attrs.uirevision = {
  valType: 'any',
  editType: 'none'
};
attrs.aaxis.uirevision = attrs.baxis.uirevision = attrs.caxis.uirevision = {
  valType: 'any',
  editType: 'none'
};

/***/ }),

/***/ 25247:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Color = __webpack_require__(78766);
var Template = __webpack_require__(78032);
var Lib = __webpack_require__(34809);
var handleSubplotDefaults = __webpack_require__(4448);
var handleTickLabelDefaults = __webpack_require__(12036);
var handlePrefixSuffixDefaults = __webpack_require__(54616);
var handleTickMarkDefaults = __webpack_require__(87433);
var handleTickValueDefaults = __webpack_require__(22777);
var handleLineGridDefaults = __webpack_require__(97405);
var layoutAttributes = __webpack_require__(77416);
var axesNames = ['aaxis', 'baxis', 'caxis'];
module.exports = function supplyLayoutDefaults(layoutIn, layoutOut, fullData) {
  handleSubplotDefaults(layoutIn, layoutOut, fullData, {
    type: 'ternary',
    attributes: layoutAttributes,
    handleDefaults: handleTernaryDefaults,
    font: layoutOut.font,
    paper_bgcolor: layoutOut.paper_bgcolor
  });
};
function handleTernaryDefaults(ternaryLayoutIn, ternaryLayoutOut, coerce, options) {
  var bgColor = coerce('bgcolor');
  var sum = coerce('sum');
  options.bgColor = Color.combine(bgColor, options.paper_bgcolor);
  var axName, containerIn, containerOut;

  // TODO: allow most (if not all) axis attributes to be set
  // in the outer container and used as defaults in the individual axes?

  for (var j = 0; j < axesNames.length; j++) {
    axName = axesNames[j];
    containerIn = ternaryLayoutIn[axName] || {};
    containerOut = Template.newContainer(ternaryLayoutOut, axName);
    containerOut._name = axName;
    handleAxisDefaults(containerIn, containerOut, options, ternaryLayoutOut);
  }

  // if the min values contradict each other, set them all to default (0)
  // and delete *all* the inputs so the user doesn't get confused later by
  // changing one and having them all change.
  var aaxis = ternaryLayoutOut.aaxis;
  var baxis = ternaryLayoutOut.baxis;
  var caxis = ternaryLayoutOut.caxis;
  if (aaxis.min + baxis.min + caxis.min >= sum) {
    aaxis.min = 0;
    baxis.min = 0;
    caxis.min = 0;
    if (ternaryLayoutIn.aaxis) delete ternaryLayoutIn.aaxis.min;
    if (ternaryLayoutIn.baxis) delete ternaryLayoutIn.baxis.min;
    if (ternaryLayoutIn.caxis) delete ternaryLayoutIn.caxis.min;
  }
}
function handleAxisDefaults(containerIn, containerOut, options, ternaryLayoutOut) {
  var axAttrs = layoutAttributes[containerOut._name];
  function coerce(attr, dflt) {
    return Lib.coerce(containerIn, containerOut, axAttrs, attr, dflt);
  }
  coerce('uirevision', ternaryLayoutOut.uirevision);
  containerOut.type = 'linear'; // no other types allowed for ternary

  var dfltColor = coerce('color');
  // if axis.color was provided, use it for fonts too; otherwise,
  // inherit from global font color in case that was provided.
  var dfltFontColor = dfltColor !== axAttrs.color.dflt ? dfltColor : options.font.color;
  var axName = containerOut._name;
  var letterUpper = axName.charAt(0).toUpperCase();
  var dfltTitle = 'Component ' + letterUpper;
  var title = coerce('title.text', dfltTitle);
  containerOut._hovertitle = title === dfltTitle ? title : letterUpper;
  Lib.coerceFont(coerce, 'title.font', options.font, {
    overrideDflt: {
      size: Lib.bigFont(options.font.size),
      color: dfltFontColor
    }
  });

  // range is just set by 'min' - max is determined by the other axes mins
  coerce('min');
  handleTickValueDefaults(containerIn, containerOut, coerce, 'linear');
  handlePrefixSuffixDefaults(containerIn, containerOut, coerce, 'linear');
  handleTickLabelDefaults(containerIn, containerOut, coerce, 'linear', {
    noAutotickangles: true,
    noTicklabelshift: true,
    noTicklabelstandoff: true
  });
  handleTickMarkDefaults(containerIn, containerOut, coerce, {
    outerTicks: true
  });
  var showTickLabels = coerce('showticklabels');
  if (showTickLabels) {
    Lib.coerceFont(coerce, 'tickfont', options.font, {
      overrideDflt: {
        color: dfltFontColor
      }
    });
    coerce('tickangle');
    coerce('tickformat');
  }
  handleLineGridDefaults(containerIn, containerOut, coerce, {
    dfltColor: dfltColor,
    bgColor: options.bgColor,
    // default grid color is darker here (60%, vs cartesian default ~91%)
    // because the grid is not square so the eye needs heavier cues to follow
    blend: 60,
    showLine: true,
    showGrid: true,
    noZeroLine: true,
    attributes: axAttrs
  });
  coerce('hoverformat');
  coerce('layer');
}

/***/ }),

/***/ 83637:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var tinycolor = __webpack_require__(65657);
var Registry = __webpack_require__(33626);
var Lib = __webpack_require__(34809);
var strTranslate = Lib.strTranslate;
var _ = Lib._;
var Color = __webpack_require__(78766);
var Drawing = __webpack_require__(62203);
var setConvert = __webpack_require__(19091);
var extendFlat = (__webpack_require__(93049).extendFlat);
var Plots = __webpack_require__(44122);
var Axes = __webpack_require__(29714);
var dragElement = __webpack_require__(14751);
var Fx = __webpack_require__(32141);
var dragHelpers = __webpack_require__(70414);
var freeMode = dragHelpers.freeMode;
var rectMode = dragHelpers.rectMode;
var Titles = __webpack_require__(17240);
var prepSelect = (__webpack_require__(44844).prepSelect);
var selectOnClick = (__webpack_require__(44844).selectOnClick);
var clearOutline = (__webpack_require__(44844).clearOutline);
var clearSelectionsCache = (__webpack_require__(44844).clearSelectionsCache);
var constants = __webpack_require__(54826);
function Ternary(options, fullLayout) {
  this.id = options.id;
  this.graphDiv = options.graphDiv;
  this.init(fullLayout);
  this.makeFramework(fullLayout);
  this.updateFx(fullLayout);

  // unfortunately, we have to keep track of some axis tick settings
  // as ternary subplots do not implement the 'ticks' editType
  this.aTickLayout = null;
  this.bTickLayout = null;
  this.cTickLayout = null;
}
module.exports = Ternary;
var proto = Ternary.prototype;
proto.init = function (fullLayout) {
  this.container = fullLayout._ternarylayer;
  this.defs = fullLayout._defs;
  this.layoutId = fullLayout._uid;
  this.traceHash = {};
  this.layers = {};
};
proto.plot = function (ternaryCalcData, fullLayout) {
  var _this = this;
  var ternaryLayout = fullLayout[_this.id];
  var graphSize = fullLayout._size;
  _this._hasClipOnAxisFalse = false;
  for (var i = 0; i < ternaryCalcData.length; i++) {
    var trace = ternaryCalcData[i][0].trace;
    if (trace.cliponaxis === false) {
      _this._hasClipOnAxisFalse = true;
      break;
    }
  }
  _this.updateLayers(ternaryLayout);
  _this.adjustLayout(ternaryLayout, graphSize);
  Plots.generalUpdatePerTraceModule(_this.graphDiv, _this, ternaryCalcData, ternaryLayout);
  _this.layers.plotbg.select('path').call(Color.fill, ternaryLayout.bgcolor);
};
proto.makeFramework = function (fullLayout) {
  var _this = this;
  var gd = _this.graphDiv;
  var ternaryLayout = fullLayout[_this.id];
  var clipId = _this.clipId = 'clip' + _this.layoutId + _this.id;
  var clipIdRelative = _this.clipIdRelative = 'clip-relative' + _this.layoutId + _this.id;

  // clippath for this ternary subplot
  _this.clipDef = Lib.ensureSingleById(fullLayout._clips, 'clipPath', clipId, function (s) {
    s.append('path').attr('d', 'M0,0Z');
  });

  // 'relative' clippath (i.e. no translation) for this ternary subplot
  _this.clipDefRelative = Lib.ensureSingleById(fullLayout._clips, 'clipPath', clipIdRelative, function (s) {
    s.append('path').attr('d', 'M0,0Z');
  });

  // container for everything in this ternary subplot
  _this.plotContainer = Lib.ensureSingle(_this.container, 'g', _this.id);
  _this.updateLayers(ternaryLayout);
  Drawing.setClipUrl(_this.layers.backplot, clipId, gd);
  Drawing.setClipUrl(_this.layers.grids, clipId, gd);
};
proto.updateFx = function (fullLayout) {
  fullLayout._ternarylayer.selectAll('g.toplevel').style('cursor', fullLayout.dragmode === 'pan' ? 'move' : 'crosshair');
};
proto.updateLayers = function (ternaryLayout) {
  var _this = this;
  var layers = _this.layers;

  // inside that container, we have one container for the data, and
  // one each for the three axes around it.

  var plotLayers = ['draglayer', 'plotbg', 'backplot', 'grids'];
  if (ternaryLayout.aaxis.layer === 'below traces') {
    plotLayers.push('aaxis', 'aline');
  }
  if (ternaryLayout.baxis.layer === 'below traces') {
    plotLayers.push('baxis', 'bline');
  }
  if (ternaryLayout.caxis.layer === 'below traces') {
    plotLayers.push('caxis', 'cline');
  }
  plotLayers.push('frontplot');
  if (ternaryLayout.aaxis.layer === 'above traces') {
    plotLayers.push('aaxis', 'aline');
  }
  if (ternaryLayout.baxis.layer === 'above traces') {
    plotLayers.push('baxis', 'bline');
  }
  if (ternaryLayout.caxis.layer === 'above traces') {
    plotLayers.push('caxis', 'cline');
  }
  var toplevel = _this.plotContainer.selectAll('g.toplevel').data(plotLayers, String);
  var grids = ['agrid', 'bgrid', 'cgrid'];
  toplevel.enter().append('g').attr('class', function (d) {
    return 'toplevel ' + d;
  }).each(function (d) {
    var s = d3.select(this);
    layers[d] = s;

    // containers for different trace types.
    // NOTE - this is different from cartesian, where all traces
    // are in front of grids. Here I'm putting maps behind the grids
    // so the grids will always be visible if they're requested.
    // Perhaps we want that for cartesian too?
    if (d === 'frontplot') {
      s.append('g').classed('scatterlayer', true);
    } else if (d === 'backplot') {
      s.append('g').classed('maplayer', true);
    } else if (d === 'plotbg') {
      s.append('path').attr('d', 'M0,0Z');
    } else if (d === 'aline' || d === 'bline' || d === 'cline') {
      s.append('path');
    } else if (d === 'grids') {
      grids.forEach(function (d) {
        layers[d] = s.append('g').classed('grid ' + d, true);
      });
    }
  });
  toplevel.order();
};
var whRatio = Math.sqrt(4 / 3);
proto.adjustLayout = function (ternaryLayout, graphSize) {
  var _this = this;
  var domain = ternaryLayout.domain;
  var xDomainCenter = (domain.x[0] + domain.x[1]) / 2;
  var yDomainCenter = (domain.y[0] + domain.y[1]) / 2;
  var xDomain = domain.x[1] - domain.x[0];
  var yDomain = domain.y[1] - domain.y[0];
  var wmax = xDomain * graphSize.w;
  var hmax = yDomain * graphSize.h;
  var sum = ternaryLayout.sum;
  var amin = ternaryLayout.aaxis.min;
  var bmin = ternaryLayout.baxis.min;
  var cmin = ternaryLayout.caxis.min;
  var x0, y0, w, h, xDomainFinal, yDomainFinal;
  if (wmax > whRatio * hmax) {
    h = hmax;
    w = h * whRatio;
  } else {
    w = wmax;
    h = w / whRatio;
  }
  xDomainFinal = xDomain * w / wmax;
  yDomainFinal = yDomain * h / hmax;
  x0 = graphSize.l + graphSize.w * xDomainCenter - w / 2;
  y0 = graphSize.t + graphSize.h * (1 - yDomainCenter) - h / 2;
  _this.x0 = x0;
  _this.y0 = y0;
  _this.w = w;
  _this.h = h;
  _this.sum = sum;

  // set up the x and y axis objects we'll use to lay out the points
  _this.xaxis = {
    type: 'linear',
    range: [amin + 2 * cmin - sum, sum - amin - 2 * bmin],
    domain: [xDomainCenter - xDomainFinal / 2, xDomainCenter + xDomainFinal / 2],
    _id: 'x'
  };
  setConvert(_this.xaxis, _this.graphDiv._fullLayout);
  _this.xaxis.setScale();
  _this.xaxis.isPtWithinRange = function (d) {
    return d.a >= _this.aaxis.range[0] && d.a <= _this.aaxis.range[1] && d.b >= _this.baxis.range[1] && d.b <= _this.baxis.range[0] && d.c >= _this.caxis.range[1] && d.c <= _this.caxis.range[0];
  };
  _this.yaxis = {
    type: 'linear',
    range: [amin, sum - bmin - cmin],
    domain: [yDomainCenter - yDomainFinal / 2, yDomainCenter + yDomainFinal / 2],
    _id: 'y'
  };
  setConvert(_this.yaxis, _this.graphDiv._fullLayout);
  _this.yaxis.setScale();
  _this.yaxis.isPtWithinRange = function () {
    return true;
  };

  // set up the modified axes for tick drawing
  var yDomain0 = _this.yaxis.domain[0];

  // aaxis goes up the left side. Set it up as a y axis, but with
  // fictitious angles and domain, but then rotate and translate
  // it into place at the end
  var aaxis = _this.aaxis = extendFlat({}, ternaryLayout.aaxis, {
    range: [amin, sum - bmin - cmin],
    side: 'left',
    // tickangle = 'auto' means 0 anyway for a y axis, need to coerce to 0 here
    // so we can shift by 30.
    tickangle: (+ternaryLayout.aaxis.tickangle || 0) - 30,
    domain: [yDomain0, yDomain0 + yDomainFinal * whRatio],
    anchor: 'free',
    position: 0,
    _id: 'y',
    _length: w
  });
  setConvert(aaxis, _this.graphDiv._fullLayout);
  aaxis.setScale();

  // baxis goes across the bottom (backward). We can set it up as an x axis
  // without any enclosing transformation.
  var baxis = _this.baxis = extendFlat({}, ternaryLayout.baxis, {
    range: [sum - amin - cmin, bmin],
    side: 'bottom',
    domain: _this.xaxis.domain,
    anchor: 'free',
    position: 0,
    _id: 'x',
    _length: w
  });
  setConvert(baxis, _this.graphDiv._fullLayout);
  baxis.setScale();

  // caxis goes down the right side. Set it up as a y axis, with
  // post-transformation similar to aaxis
  var caxis = _this.caxis = extendFlat({}, ternaryLayout.caxis, {
    range: [sum - amin - bmin, cmin],
    side: 'right',
    tickangle: (+ternaryLayout.caxis.tickangle || 0) + 30,
    domain: [yDomain0, yDomain0 + yDomainFinal * whRatio],
    anchor: 'free',
    position: 0,
    _id: 'y',
    _length: w
  });
  setConvert(caxis, _this.graphDiv._fullLayout);
  caxis.setScale();
  var triangleClip = 'M' + x0 + ',' + (y0 + h) + 'h' + w + 'l-' + w / 2 + ',-' + h + 'Z';
  _this.clipDef.select('path').attr('d', triangleClip);
  _this.layers.plotbg.select('path').attr('d', triangleClip);
  var triangleClipRelative = 'M0,' + h + 'h' + w + 'l-' + w / 2 + ',-' + h + 'Z';
  _this.clipDefRelative.select('path').attr('d', triangleClipRelative);
  var plotTransform = strTranslate(x0, y0);
  _this.plotContainer.selectAll('.scatterlayer,.maplayer').attr('transform', plotTransform);
  _this.clipDefRelative.select('path').attr('transform', null);

  // TODO: shift axes to accommodate linewidth*sin(30) tick mark angle

  // TODO: there's probably an easier way to handle these translations/offsets now...
  var bTransform = strTranslate(x0 - baxis._offset, y0 + h);
  _this.layers.baxis.attr('transform', bTransform);
  _this.layers.bgrid.attr('transform', bTransform);
  var aTransform = strTranslate(x0 + w / 2, y0) + 'rotate(30)' + strTranslate(0, -aaxis._offset);
  _this.layers.aaxis.attr('transform', aTransform);
  _this.layers.agrid.attr('transform', aTransform);
  var cTransform = strTranslate(x0 + w / 2, y0) + 'rotate(-30)' + strTranslate(0, -caxis._offset);
  _this.layers.caxis.attr('transform', cTransform);
  _this.layers.cgrid.attr('transform', cTransform);
  _this.drawAxes(true);
  _this.layers.aline.select('path').attr('d', aaxis.showline ? 'M' + x0 + ',' + (y0 + h) + 'l' + w / 2 + ',-' + h : 'M0,0').call(Color.stroke, aaxis.linecolor || '#000').style('stroke-width', (aaxis.linewidth || 0) + 'px');
  _this.layers.bline.select('path').attr('d', baxis.showline ? 'M' + x0 + ',' + (y0 + h) + 'h' + w : 'M0,0').call(Color.stroke, baxis.linecolor || '#000').style('stroke-width', (baxis.linewidth || 0) + 'px');
  _this.layers.cline.select('path').attr('d', caxis.showline ? 'M' + (x0 + w / 2) + ',' + y0 + 'l' + w / 2 + ',' + h : 'M0,0').call(Color.stroke, caxis.linecolor || '#000').style('stroke-width', (caxis.linewidth || 0) + 'px');
  if (!_this.graphDiv._context.staticPlot) {
    _this.initInteractions();
  }
  Drawing.setClipUrl(_this.layers.frontplot, _this._hasClipOnAxisFalse ? null : _this.clipId, _this.graphDiv);
};
proto.drawAxes = function (doTitles) {
  var _this = this;
  var gd = _this.graphDiv;
  var titlesuffix = _this.id.substr(7) + 'title';
  var layers = _this.layers;
  var aaxis = _this.aaxis;
  var baxis = _this.baxis;
  var caxis = _this.caxis;
  _this.drawAx(aaxis);
  _this.drawAx(baxis);
  _this.drawAx(caxis);
  if (doTitles) {
    var apad = Math.max(aaxis.showticklabels ? aaxis.tickfont.size / 2 : 0, (caxis.showticklabels ? caxis.tickfont.size * 0.75 : 0) + (caxis.ticks === 'outside' ? caxis.ticklen * 0.87 : 0));
    var bpad = (baxis.showticklabels ? baxis.tickfont.size : 0) + (baxis.ticks === 'outside' ? baxis.ticklen : 0) + 3;
    layers['a-title'] = Titles.draw(gd, 'a' + titlesuffix, {
      propContainer: aaxis,
      propName: _this.id + '.aaxis.title',
      placeholder: _(gd, 'Click to enter Component A title'),
      attributes: {
        x: _this.x0 + _this.w / 2,
        y: _this.y0 - aaxis.title.font.size / 3 - apad,
        'text-anchor': 'middle'
      }
    });
    layers['b-title'] = Titles.draw(gd, 'b' + titlesuffix, {
      propContainer: baxis,
      propName: _this.id + '.baxis.title',
      placeholder: _(gd, 'Click to enter Component B title'),
      attributes: {
        x: _this.x0 - bpad,
        y: _this.y0 + _this.h + baxis.title.font.size * 0.83 + bpad,
        'text-anchor': 'middle'
      }
    });
    layers['c-title'] = Titles.draw(gd, 'c' + titlesuffix, {
      propContainer: caxis,
      propName: _this.id + '.caxis.title',
      placeholder: _(gd, 'Click to enter Component C title'),
      attributes: {
        x: _this.x0 + _this.w + bpad,
        y: _this.y0 + _this.h + caxis.title.font.size * 0.83 + bpad,
        'text-anchor': 'middle'
      }
    });
  }
};
proto.drawAx = function (ax) {
  var _this = this;
  var gd = _this.graphDiv;
  var axName = ax._name;
  var axLetter = axName.charAt(0);
  var axId = ax._id;
  var axLayer = _this.layers[axName];
  var counterAngle = 30;
  var stashKey = axLetter + 'tickLayout';
  var newTickLayout = strTickLayout(ax);
  if (_this[stashKey] !== newTickLayout) {
    axLayer.selectAll('.' + axId + 'tick').remove();
    _this[stashKey] = newTickLayout;
  }
  ax.setScale();
  var vals = Axes.calcTicks(ax);
  var valsClipped = Axes.clipEnds(ax, vals);
  var transFn = Axes.makeTransTickFn(ax);
  var tickSign = Axes.getTickSigns(ax)[2];
  var caRad = Lib.deg2rad(counterAngle);
  var pad = tickSign * (ax.linewidth || 1) / 2;
  var len = tickSign * ax.ticklen;
  var w = _this.w;
  var h = _this.h;
  var tickPath = axLetter === 'b' ? 'M0,' + pad + 'l' + Math.sin(caRad) * len + ',' + Math.cos(caRad) * len : 'M' + pad + ',0l' + Math.cos(caRad) * len + ',' + -Math.sin(caRad) * len;
  var gridPath = {
    a: 'M0,0l' + h + ',-' + w / 2,
    b: 'M0,0l-' + w / 2 + ',-' + h,
    c: 'M0,0l-' + h + ',' + w / 2
  }[axLetter];
  Axes.drawTicks(gd, ax, {
    vals: ax.ticks === 'inside' ? valsClipped : vals,
    layer: axLayer,
    path: tickPath,
    transFn: transFn,
    crisp: false
  });
  Axes.drawGrid(gd, ax, {
    vals: valsClipped,
    layer: _this.layers[axLetter + 'grid'],
    path: gridPath,
    transFn: transFn,
    crisp: false
  });
  Axes.drawLabels(gd, ax, {
    vals: vals,
    layer: axLayer,
    transFn: transFn,
    labelFns: Axes.makeLabelFns(ax, 0, counterAngle)
  });
};
function strTickLayout(axLayout) {
  return axLayout.ticks + String(axLayout.ticklen) + String(axLayout.showticklabels);
}

// hard coded paths for zoom corners
// uses the same sizing as cartesian, length is MINZOOM/2, width is 3px
var CLEN = constants.MINZOOM / 2 + 0.87;
var BLPATH = 'm-0.87,.5h' + CLEN + 'v3h-' + (CLEN + 5.2) + 'l' + (CLEN / 2 + 2.6) + ',-' + (CLEN * 0.87 + 4.5) + 'l2.6,1.5l-' + CLEN / 2 + ',' + CLEN * 0.87 + 'Z';
var BRPATH = 'm0.87,.5h-' + CLEN + 'v3h' + (CLEN + 5.2) + 'l-' + (CLEN / 2 + 2.6) + ',-' + (CLEN * 0.87 + 4.5) + 'l-2.6,1.5l' + CLEN / 2 + ',' + CLEN * 0.87 + 'Z';
var TOPPATH = 'm0,1l' + CLEN / 2 + ',' + CLEN * 0.87 + 'l2.6,-1.5l-' + (CLEN / 2 + 2.6) + ',-' + (CLEN * 0.87 + 4.5) + 'l-' + (CLEN / 2 + 2.6) + ',' + (CLEN * 0.87 + 4.5) + 'l2.6,1.5l' + CLEN / 2 + ',-' + CLEN * 0.87 + 'Z';
var STARTMARKER = 'm0.5,0.5h5v-2h-5v-5h-2v5h-5v2h5v5h2Z';

// I guess this could be shared with cartesian... but for now it's separate.
var SHOWZOOMOUTTIP = true;
proto.clearOutline = function () {
  clearSelectionsCache(this.dragOptions);
  clearOutline(this.dragOptions.gd);
};
proto.initInteractions = function () {
  var _this = this;
  var dragger = _this.layers.plotbg.select('path').node();
  var gd = _this.graphDiv;
  var zoomLayer = gd._fullLayout._zoomlayer;
  var scaleX;
  var scaleY;

  // use plotbg for the main interactions
  this.dragOptions = {
    element: dragger,
    gd: gd,
    plotinfo: {
      id: _this.id,
      domain: gd._fullLayout[_this.id].domain,
      xaxis: _this.xaxis,
      yaxis: _this.yaxis
    },
    subplot: _this.id,
    prepFn: function (e, startX, startY) {
      // these aren't available yet when initInteractions
      // is called
      _this.dragOptions.xaxes = [_this.xaxis];
      _this.dragOptions.yaxes = [_this.yaxis];
      scaleX = gd._fullLayout._invScaleX;
      scaleY = gd._fullLayout._invScaleY;
      var dragModeNow = _this.dragOptions.dragmode = gd._fullLayout.dragmode;
      if (freeMode(dragModeNow)) _this.dragOptions.minDrag = 1;else _this.dragOptions.minDrag = undefined;
      if (dragModeNow === 'zoom') {
        _this.dragOptions.moveFn = zoomMove;
        _this.dragOptions.clickFn = clickZoomPan;
        _this.dragOptions.doneFn = zoomDone;
        zoomPrep(e, startX, startY);
      } else if (dragModeNow === 'pan') {
        _this.dragOptions.moveFn = plotDrag;
        _this.dragOptions.clickFn = clickZoomPan;
        _this.dragOptions.doneFn = dragDone;
        panPrep();
        _this.clearOutline(gd);
      } else if (rectMode(dragModeNow) || freeMode(dragModeNow)) {
        prepSelect(e, startX, startY, _this.dragOptions, dragModeNow);
      }
    }
  };
  var x0, y0, mins0, span0, mins, lum, path0, dimmed, zb, corners;
  function makeUpdate(_mins) {
    var attrs = {};
    attrs[_this.id + '.aaxis.min'] = _mins.a;
    attrs[_this.id + '.baxis.min'] = _mins.b;
    attrs[_this.id + '.caxis.min'] = _mins.c;
    return attrs;
  }
  function clickZoomPan(numClicks, evt) {
    var clickMode = gd._fullLayout.clickmode;
    removeZoombox(gd);
    if (numClicks === 2) {
      gd.emit('plotly_doubleclick', null);
      Registry.call('_guiRelayout', gd, makeUpdate({
        a: 0,
        b: 0,
        c: 0
      }));
    }
    if (clickMode.indexOf('select') > -1 && numClicks === 1) {
      selectOnClick(evt, gd, [_this.xaxis], [_this.yaxis], _this.id, _this.dragOptions);
    }
    if (clickMode.indexOf('event') > -1) {
      Fx.click(gd, evt, _this.id);
    }
  }
  function zoomPrep(e, startX, startY) {
    var dragBBox = dragger.getBoundingClientRect();
    x0 = startX - dragBBox.left;
    y0 = startY - dragBBox.top;
    gd._fullLayout._calcInverseTransform(gd);
    var inverse = gd._fullLayout._invTransform;
    var transformedCoords = Lib.apply3DTransform(inverse)(x0, y0);
    x0 = transformedCoords[0];
    y0 = transformedCoords[1];
    mins0 = {
      a: _this.aaxis.range[0],
      b: _this.baxis.range[1],
      c: _this.caxis.range[1]
    };
    mins = mins0;
    span0 = _this.aaxis.range[1] - mins0.a;
    lum = tinycolor(_this.graphDiv._fullLayout[_this.id].bgcolor).getLuminance();
    path0 = 'M0,' + _this.h + 'L' + _this.w / 2 + ', 0L' + _this.w + ',' + _this.h + 'Z';
    dimmed = false;
    zb = zoomLayer.append('path').attr('class', 'zoombox').attr('transform', strTranslate(_this.x0, _this.y0)).style({
      fill: lum > 0.2 ? 'rgba(0,0,0,0)' : 'rgba(255,255,255,0)',
      'stroke-width': 0
    }).attr('d', path0);
    corners = zoomLayer.append('path').attr('class', 'zoombox-corners').attr('transform', strTranslate(_this.x0, _this.y0)).style({
      fill: Color.background,
      stroke: Color.defaultLine,
      'stroke-width': 1,
      opacity: 0
    }).attr('d', 'M0,0Z');
    _this.clearOutline(gd);
  }
  function getAFrac(x, y) {
    return 1 - y / _this.h;
  }
  function getBFrac(x, y) {
    return 1 - (x + (_this.h - y) / Math.sqrt(3)) / _this.w;
  }
  function getCFrac(x, y) {
    return (x - (_this.h - y) / Math.sqrt(3)) / _this.w;
  }
  function zoomMove(dx0, dy0) {
    var x1 = x0 + dx0 * scaleX;
    var y1 = y0 + dy0 * scaleY;
    var afrac = Math.max(0, Math.min(1, getAFrac(x0, y0), getAFrac(x1, y1)));
    var bfrac = Math.max(0, Math.min(1, getBFrac(x0, y0), getBFrac(x1, y1)));
    var cfrac = Math.max(0, Math.min(1, getCFrac(x0, y0), getCFrac(x1, y1)));
    var xLeft = (afrac / 2 + cfrac) * _this.w;
    var xRight = (1 - afrac / 2 - bfrac) * _this.w;
    var xCenter = (xLeft + xRight) / 2;
    var xSpan = xRight - xLeft;
    var yBottom = (1 - afrac) * _this.h;
    var yTop = yBottom - xSpan / whRatio;
    if (xSpan < constants.MINZOOM) {
      mins = mins0;
      zb.attr('d', path0);
      corners.attr('d', 'M0,0Z');
    } else {
      mins = {
        a: mins0.a + afrac * span0,
        b: mins0.b + bfrac * span0,
        c: mins0.c + cfrac * span0
      };
      zb.attr('d', path0 + 'M' + xLeft + ',' + yBottom + 'H' + xRight + 'L' + xCenter + ',' + yTop + 'L' + xLeft + ',' + yBottom + 'Z');
      corners.attr('d', 'M' + x0 + ',' + y0 + STARTMARKER + 'M' + xLeft + ',' + yBottom + BLPATH + 'M' + xRight + ',' + yBottom + BRPATH + 'M' + xCenter + ',' + yTop + TOPPATH);
    }
    if (!dimmed) {
      zb.transition().style('fill', lum > 0.2 ? 'rgba(0,0,0,0.4)' : 'rgba(255,255,255,0.3)').duration(200);
      corners.transition().style('opacity', 1).duration(200);
      dimmed = true;
    }
    gd.emit('plotly_relayouting', makeUpdate(mins));
  }
  function zoomDone() {
    removeZoombox(gd);
    if (mins === mins0) return;
    Registry.call('_guiRelayout', gd, makeUpdate(mins));
    if (SHOWZOOMOUTTIP && gd.data && gd._context.showTips) {
      Lib.notifier(_(gd, 'Double-click to zoom back out'), 'long');
      SHOWZOOMOUTTIP = false;
    }
  }
  function panPrep() {
    mins0 = {
      a: _this.aaxis.range[0],
      b: _this.baxis.range[1],
      c: _this.caxis.range[1]
    };
    mins = mins0;
  }
  function plotDrag(dx, dy) {
    var dxScaled = dx / _this.xaxis._m;
    var dyScaled = dy / _this.yaxis._m;
    mins = {
      a: mins0.a - dyScaled,
      b: mins0.b + (dxScaled + dyScaled) / 2,
      c: mins0.c - (dxScaled - dyScaled) / 2
    };
    var minsorted = [mins.a, mins.b, mins.c].sort(Lib.sorterAsc);
    var minindices = {
      a: minsorted.indexOf(mins.a),
      b: minsorted.indexOf(mins.b),
      c: minsorted.indexOf(mins.c)
    };
    if (minsorted[0] < 0) {
      if (minsorted[1] + minsorted[0] / 2 < 0) {
        minsorted[2] += minsorted[0] + minsorted[1];
        minsorted[0] = minsorted[1] = 0;
      } else {
        minsorted[2] += minsorted[0] / 2;
        minsorted[1] += minsorted[0] / 2;
        minsorted[0] = 0;
      }
      mins = {
        a: minsorted[minindices.a],
        b: minsorted[minindices.b],
        c: minsorted[minindices.c]
      };
      dy = (mins0.a - mins.a) * _this.yaxis._m;
      dx = (mins0.c - mins.c - mins0.b + mins.b) * _this.xaxis._m;
    }

    // move the data (translate, don't redraw)
    var plotTransform = strTranslate(_this.x0 + dx, _this.y0 + dy);
    _this.plotContainer.selectAll('.scatterlayer,.maplayer').attr('transform', plotTransform);
    var plotTransform2 = strTranslate(-dx, -dy);
    _this.clipDefRelative.select('path').attr('transform', plotTransform2);

    // move the ticks
    _this.aaxis.range = [mins.a, _this.sum - mins.b - mins.c];
    _this.baxis.range = [_this.sum - mins.a - mins.c, mins.b];
    _this.caxis.range = [_this.sum - mins.a - mins.b, mins.c];
    _this.drawAxes(false);
    if (_this._hasClipOnAxisFalse) {
      _this.plotContainer.select('.scatterlayer').selectAll('.trace').call(Drawing.hideOutsideRangePoints, _this);
    }
    gd.emit('plotly_relayouting', makeUpdate(mins));
  }
  function dragDone() {
    Registry.call('_guiRelayout', gd, makeUpdate(mins));
  }

  // finally, set up hover and click
  // these event handlers must already be set before dragElement.init
  // so it can stash them and override them.
  dragger.onmousemove = function (evt) {
    Fx.hover(gd, evt, _this.id);
    gd._fullLayout._lasthover = dragger;
    gd._fullLayout._hoversubplot = _this.id;
  };
  dragger.onmouseout = function (evt) {
    if (gd._dragging) return;
    dragElement.unhover(gd, evt);
  };
  dragElement.init(this.dragOptions);
};
function removeZoombox(gd) {
  d3.select(gd).selectAll('.zoombox,.js-zoombox-backdrop,.js-zoombox-menu,.zoombox-corners').remove();
}

/***/ }),

/***/ 33626:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var Loggers = __webpack_require__(48636);
var noop = __webpack_require__(4969);
var pushUnique = __webpack_require__(36539);
var isPlainObject = __webpack_require__(56174);
var addStyleRule = (__webpack_require__(95425).addStyleRule);
var ExtendModule = __webpack_require__(93049);
var basePlotAttributes = __webpack_require__(9829);
var baseLayoutAttributes = __webpack_require__(6704);
var extendFlat = ExtendModule.extendFlat;
var extendDeepAll = ExtendModule.extendDeepAll;
exports.modules = {};
exports.allCategories = {};
exports.allTypes = [];
exports.subplotsRegistry = {};
exports.transformsRegistry = {};
exports.componentsRegistry = {};
exports.layoutArrayContainers = [];
exports.layoutArrayRegexes = [];
exports.traceLayoutAttributes = {};
exports.localeRegistry = {};
exports.apiMethodRegistry = {};
exports.collectableSubplotTypes = null;

/**
 * Top-level register routine, exported as Plotly.register
 *
 * @param {object array or array of objects} _modules :
 *  module object or list of module object to register.
 *
 *  A valid `moduleType: 'trace'` module has fields:
 *  - name {string} : the trace type
 *  - categories {array} : categories associated with this trace type,
 *                         tested with Register.traceIs()
 *  - meta {object} : meta info (mostly for plot-schema)
 *
 *  A valid `moduleType: 'locale'` module has fields:
 *  - name {string} : the locale name. Should be a 2-digit language string ('en', 'de')
 *                    optionally with a country/region code ('en-GB', 'de-CH'). If a country
 *                    code is used but the base language locale has not yet been supplied,
 *                    we will use this locale for the base as well.
 *  - dictionary {object} : the dictionary mapping input strings to localized strings
 *                          generally the keys should be the literal input strings, but
 *                          if default translations are provided you can use any string as a key.
 *  - format {object} : a `d3.locale` format specifier for this locale
 *                      any omitted keys we'll fall back on en-US.
 *
 *  A valid `moduleType: 'transform'` module has fields:
 *  - name {string} : transform name
 *  - transform {function} : default-level transform function
 *  - calcTransform {function} : calc-level transform function
 *  - attributes {object} : transform attributes declarations
 *  - supplyDefaults {function} : attributes default-supply function
 *
 *  A valid `moduleType: 'component'` module has fields:
 *  - name {string} : the component name, used it with Register.getComponentMethod()
 *                    to employ component method.
 *
 *  A valid `moduleType: 'apiMethod'` module has fields:
 *  - name {string} : the api method name.
 *  - fn {function} : the api method called with Register.call();
 *
 */
exports.register = function register(_modules) {
  exports.collectableSubplotTypes = null;
  if (!_modules) {
    throw new Error('No argument passed to Plotly.register.');
  } else if (_modules && !Array.isArray(_modules)) {
    _modules = [_modules];
  }
  for (var i = 0; i < _modules.length; i++) {
    var newModule = _modules[i];
    if (!newModule) {
      throw new Error('Invalid module was attempted to be registered!');
    }
    switch (newModule.moduleType) {
      case 'trace':
        registerTraceModule(newModule);
        break;
      case 'transform':
        registerTransformModule(newModule);
        break;
      case 'component':
        registerComponentModule(newModule);
        break;
      case 'locale':
        registerLocale(newModule);
        break;
      case 'apiMethod':
        var name = newModule.name;
        exports.apiMethodRegistry[name] = newModule.fn;
        break;
      default:
        throw new Error('Invalid module was attempted to be registered!');
    }
  }
};

/**
 * Get registered module using trace object or trace type
 *
 * @param {object||string} trace
 *  trace object with prop 'type' or trace type as a string
 * @return {object}
 *  module object corresponding to trace type
 */
exports.getModule = function (trace) {
  var _module = exports.modules[getTraceType(trace)];
  if (!_module) return false;
  return _module._module;
};

/**
 * Determine if this trace type is in a given category
 *
 * @param {object||string} traceType
 *  a trace (object) or trace type (string)
 * @param {string} category
 *  category in question
 * @return {boolean}
 */
exports.traceIs = function (traceType, category) {
  traceType = getTraceType(traceType);

  // old Chart Studio Cloud workspace hack, nothing to see here
  if (traceType === 'various') return false;
  var _module = exports.modules[traceType];
  if (!_module) {
    if (traceType) {
      Loggers.log('Unrecognized trace type ' + traceType + '.');
    }
    _module = exports.modules[basePlotAttributes.type.dflt];
  }
  return !!_module.categories[category];
};

/**
 * Determine if this trace has a transform of the given type and return
 * array of matching indices.
 *
 * @param {object} data
 *  a trace object (member of data or fullData)
 * @param {string} type
 *  type of trace to test
 * @return {array}
 *  array of matching indices. If none found, returns []
 */
exports.getTransformIndices = function (data, type) {
  var indices = [];
  var transforms = data.transforms || [];
  for (var i = 0; i < transforms.length; i++) {
    if (transforms[i].type === type) {
      indices.push(i);
    }
  }
  return indices;
};

/**
 * Determine if this trace has a transform of the given type
 *
 * @param {object} data
 *  a trace object (member of data or fullData)
 * @param {string} type
 *  type of trace to test
 * @return {boolean}
 */
exports.hasTransform = function (data, type) {
  var transforms = data.transforms || [];
  for (var i = 0; i < transforms.length; i++) {
    if (transforms[i].type === type) {
      return true;
    }
  }
  return false;
};

/**
 * Retrieve component module method. Falls back on noop if either the
 * module or the method is missing, so the result can always be safely called
 *
 * @param {string} name
 *  name of component (as declared in component module)
 * @param {string} method
 *  name of component module method
 * @return {function}
 */
exports.getComponentMethod = function (name, method) {
  var _module = exports.componentsRegistry[name];
  if (!_module) return noop;
  return _module[method] || noop;
};

/**
 * Call registered api method.
 *
 * @param {string} name : api method name
 * @param {...array} args : arguments passed to api method
 * @return {any} : returns api method output
 */
exports.call = function () {
  var name = arguments[0];
  var args = [].slice.call(arguments, 1);
  return exports.apiMethodRegistry[name].apply(null, args);
};
function registerTraceModule(_module) {
  var thisType = _module.name;
  var categoriesIn = _module.categories;
  var meta = _module.meta;
  if (exports.modules[thisType]) {
    Loggers.log('Type ' + thisType + ' already registered');
    return;
  }
  if (!exports.subplotsRegistry[_module.basePlotModule.name]) {
    registerSubplot(_module.basePlotModule);
  }
  var categoryObj = {};
  for (var i = 0; i < categoriesIn.length; i++) {
    categoryObj[categoriesIn[i]] = true;
    exports.allCategories[categoriesIn[i]] = true;
  }
  exports.modules[thisType] = {
    _module: _module,
    categories: categoryObj
  };
  if (meta && Object.keys(meta).length) {
    exports.modules[thisType].meta = meta;
  }
  exports.allTypes.push(thisType);
  for (var componentName in exports.componentsRegistry) {
    mergeComponentAttrsToTrace(componentName, thisType);
  }

  /*
   * Collect all trace layout attributes in one place for easier lookup later
   * but don't merge them into the base schema as it would confuse the docs
   * (at least after https://github.com/plotly/documentation/issues/202 gets done!)
   */
  if (_module.layoutAttributes) {
    extendFlat(exports.traceLayoutAttributes, _module.layoutAttributes);
  }
  var basePlotModule = _module.basePlotModule;
  var bpmName = basePlotModule.name;

  // add mapbox-gl CSS here to avoid console warning on instantiation
  if (bpmName === 'mapbox') {
    var styleRules = basePlotModule.constants.styleRules;
    for (var k in styleRules) {
      addStyleRule('.js-plotly-plot .plotly .mapboxgl-' + k, styleRules[k]);
    }
  }

  // add maplibre-gl CSS here to avoid console warning on instantiation
  if (bpmName === 'map') {
    __webpack_require__(96144);
  }

  // if `plotly-geo-assets.js` is not included,
  // add `PlotlyGeoAssets` global to stash references to all fetched
  // topojson / geojson data
  if ((bpmName === 'geo' || bpmName === 'mapbox' || bpmName === 'map') && window.PlotlyGeoAssets === undefined) {
    window.PlotlyGeoAssets = {
      topojson: {}
    };
  }
}
function registerSubplot(_module) {
  var plotType = _module.name;
  if (exports.subplotsRegistry[plotType]) {
    Loggers.log('Plot type ' + plotType + ' already registered.');
    return;
  }

  // relayout array handling will look for component module methods with this
  // name and won't find them because this is a subplot module... but that
  // should be fine, it will just fall back on redrawing the plot.
  findArrayRegexps(_module);

  // not sure what's best for the 'cartesian' type at this point
  exports.subplotsRegistry[plotType] = _module;
  for (var componentName in exports.componentsRegistry) {
    mergeComponentAttrsToSubplot(componentName, _module.name);
  }
}
function registerComponentModule(_module) {
  if (typeof _module.name !== 'string') {
    throw new Error('Component module *name* must be a string.');
  }
  var name = _module.name;
  exports.componentsRegistry[name] = _module;
  if (_module.layoutAttributes) {
    if (_module.layoutAttributes._isLinkedToArray) {
      pushUnique(exports.layoutArrayContainers, name);
    }
    findArrayRegexps(_module);
  }
  for (var traceType in exports.modules) {
    mergeComponentAttrsToTrace(name, traceType);
  }
  for (var subplotName in exports.subplotsRegistry) {
    mergeComponentAttrsToSubplot(name, subplotName);
  }
  for (var transformType in exports.transformsRegistry) {
    mergeComponentAttrsToTransform(name, transformType);
  }
  if (_module.schema && _module.schema.layout) {
    extendDeepAll(baseLayoutAttributes, _module.schema.layout);
  }
}
function registerTransformModule(_module) {
  if (typeof _module.name !== 'string') {
    throw new Error('Transform module *name* must be a string.');
  }
  var prefix = 'Transform module ' + _module.name;
  var hasTransform = typeof _module.transform === 'function';
  var hasCalcTransform = typeof _module.calcTransform === 'function';
  if (!hasTransform && !hasCalcTransform) {
    throw new Error(prefix + ' is missing a *transform* or *calcTransform* method.');
  }
  if (hasTransform && hasCalcTransform) {
    Loggers.log([prefix + ' has both a *transform* and *calcTransform* methods.', 'Please note that all *transform* methods are executed', 'before all *calcTransform* methods.'].join(' '));
  }
  if (!isPlainObject(_module.attributes)) {
    Loggers.log(prefix + ' registered without an *attributes* object.');
  }
  if (typeof _module.supplyDefaults !== 'function') {
    Loggers.log(prefix + ' registered without a *supplyDefaults* method.');
  }
  exports.transformsRegistry[_module.name] = _module;
  for (var componentName in exports.componentsRegistry) {
    mergeComponentAttrsToTransform(componentName, _module.name);
  }
}
function registerLocale(_module) {
  var locale = _module.name;
  var baseLocale = locale.split('-')[0];
  var newDict = _module.dictionary;
  var newFormat = _module.format;
  var hasDict = newDict && Object.keys(newDict).length;
  var hasFormat = newFormat && Object.keys(newFormat).length;
  var locales = exports.localeRegistry;
  var localeObj = locales[locale];
  if (!localeObj) locales[locale] = localeObj = {};

  // Should we use this dict for the base locale?
  // In case we're overwriting a previous dict for this locale, check
  // whether the base matches the full locale dict now. If we're not
  // overwriting, locales[locale] is undefined so this just checks if
  // baseLocale already had a dict or not.
  // Same logic for dateFormats
  if (baseLocale !== locale) {
    var baseLocaleObj = locales[baseLocale];
    if (!baseLocaleObj) locales[baseLocale] = baseLocaleObj = {};
    if (hasDict && baseLocaleObj.dictionary === localeObj.dictionary) {
      baseLocaleObj.dictionary = newDict;
    }
    if (hasFormat && baseLocaleObj.format === localeObj.format) {
      baseLocaleObj.format = newFormat;
    }
  }
  if (hasDict) localeObj.dictionary = newDict;
  if (hasFormat) localeObj.format = newFormat;
}
function findArrayRegexps(_module) {
  if (_module.layoutAttributes) {
    var arrayAttrRegexps = _module.layoutAttributes._arrayAttrRegexps;
    if (arrayAttrRegexps) {
      for (var i = 0; i < arrayAttrRegexps.length; i++) {
        pushUnique(exports.layoutArrayRegexes, arrayAttrRegexps[i]);
      }
    }
  }
}
function mergeComponentAttrsToTrace(componentName, traceType) {
  var componentSchema = exports.componentsRegistry[componentName].schema;
  if (!componentSchema || !componentSchema.traces) return;
  var traceAttrs = componentSchema.traces[traceType];
  if (traceAttrs) {
    extendDeepAll(exports.modules[traceType]._module.attributes, traceAttrs);
  }
}
function mergeComponentAttrsToTransform(componentName, transformType) {
  var componentSchema = exports.componentsRegistry[componentName].schema;
  if (!componentSchema || !componentSchema.transforms) return;
  var transformAttrs = componentSchema.transforms[transformType];
  if (transformAttrs) {
    extendDeepAll(exports.transformsRegistry[transformType].attributes, transformAttrs);
  }
}
function mergeComponentAttrsToSubplot(componentName, subplotName) {
  var componentSchema = exports.componentsRegistry[componentName].schema;
  if (!componentSchema || !componentSchema.subplots) return;
  var subplotModule = exports.subplotsRegistry[subplotName];
  var subplotAttrs = subplotModule.layoutAttributes;
  var subplotAttr = subplotModule.attr === 'subplot' ? subplotModule.name : subplotModule.attr;
  if (Array.isArray(subplotAttr)) subplotAttr = subplotAttr[0];
  var componentLayoutAttrs = componentSchema.subplots[subplotAttr];
  if (subplotAttrs && componentLayoutAttrs) {
    extendDeepAll(subplotAttrs, componentLayoutAttrs);
  }
}
function getTraceType(traceType) {
  if (typeof traceType === 'object') traceType = traceType.type;
  return traceType;
}

/***/ }),

/***/ 3164:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Registry = __webpack_require__(33626);
var Lib = __webpack_require__(34809);
var extendFlat = Lib.extendFlat;
var extendDeep = Lib.extendDeep;

// Put default plotTile layouts here
function cloneLayoutOverride(tileClass) {
  var override;
  switch (tileClass) {
    case 'themes__thumb':
      override = {
        autosize: true,
        width: 150,
        height: 150,
        title: {
          text: ''
        },
        showlegend: false,
        margin: {
          l: 5,
          r: 5,
          t: 5,
          b: 5,
          pad: 0
        },
        annotations: []
      };
      break;
    case 'thumbnail':
      override = {
        title: {
          text: ''
        },
        hidesources: true,
        showlegend: false,
        borderwidth: 0,
        bordercolor: '',
        margin: {
          l: 1,
          r: 1,
          t: 1,
          b: 1,
          pad: 0
        },
        annotations: []
      };
      break;
    default:
      override = {};
  }
  return override;
}
function keyIsAxis(keyName) {
  var types = ['xaxis', 'yaxis', 'zaxis'];
  return types.indexOf(keyName.slice(0, 5)) > -1;
}
module.exports = function clonePlot(graphObj, options) {
  var i;
  var oldData = graphObj.data;
  var oldLayout = graphObj.layout;
  var newData = extendDeep([], oldData);
  var newLayout = extendDeep({}, oldLayout, cloneLayoutOverride(options.tileClass));
  var context = graphObj._context || {};
  if (options.width) newLayout.width = options.width;
  if (options.height) newLayout.height = options.height;
  if (options.tileClass === 'thumbnail' || options.tileClass === 'themes__thumb') {
    // kill annotations
    newLayout.annotations = [];
    var keys = Object.keys(newLayout);
    for (i = 0; i < keys.length; i++) {
      if (keyIsAxis(keys[i])) {
        newLayout[keys[i]].title = {
          text: ''
        };
      }
    }

    // kill colorbar and pie labels
    for (i = 0; i < newData.length; i++) {
      var trace = newData[i];
      trace.showscale = false;
      if (trace.marker) trace.marker.showscale = false;
      if (Registry.traceIs(trace, 'pie-like')) trace.textposition = 'none';
    }
  }
  if (Array.isArray(options.annotations)) {
    for (i = 0; i < options.annotations.length; i++) {
      newLayout.annotations.push(options.annotations[i]);
    }
  }

  // TODO: does this scene modification really belong here?
  // If we still need it, can it move into the gl3d module?
  var sceneIds = Object.keys(newLayout).filter(function (key) {
    return key.match(/^scene\d*$/);
  });
  if (sceneIds.length) {
    var axesImageOverride = {};
    if (options.tileClass === 'thumbnail') {
      axesImageOverride = {
        title: {
          text: ''
        },
        showaxeslabels: false,
        showticklabels: false,
        linetickenable: false
      };
    }
    for (i = 0; i < sceneIds.length; i++) {
      var scene = newLayout[sceneIds[i]];
      if (!scene.xaxis) {
        scene.xaxis = {};
      }
      if (!scene.yaxis) {
        scene.yaxis = {};
      }
      if (!scene.zaxis) {
        scene.zaxis = {};
      }
      extendFlat(scene.xaxis, axesImageOverride);
      extendFlat(scene.yaxis, axesImageOverride);
      extendFlat(scene.zaxis, axesImageOverride);

      // TODO what does this do?
      scene._scene = null;
    }
  }
  var gd = document.createElement('div');
  if (options.tileClass) gd.className = options.tileClass;
  var plotTile = {
    gd: gd,
    td: gd,
    // for external (image server) compatibility
    layout: newLayout,
    data: newData,
    config: {
      staticPlot: options.staticPlot === undefined ? true : options.staticPlot,
      plotGlPixelRatio: options.plotGlPixelRatio === undefined ? 2 : options.plotGlPixelRatio,
      displaylogo: options.displaylogo || false,
      showLink: options.showLink || false,
      showTips: options.showTips || false,
      mapboxAccessToken: context.mapboxAccessToken
    }
  };
  if (options.setBackground !== 'transparent') {
    plotTile.config.setBackground = options.setBackground || 'opaque';
  }

  // attaching the default Layout the gd, so you can grab it later
  plotTile.gd.defaultLayout = cloneLayoutOverride(options.tileClass);
  return plotTile;
};

/***/ }),

/***/ 26452:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var toImage = __webpack_require__(80491);
var fileSaver = __webpack_require__(33353);
var helpers = __webpack_require__(84619);

/**
 * Plotly.downloadImage
 *
 * @param {object | string | HTML div} gd
 *   can either be a data/layout/config object
 *   or an existing graph <div>
 *   or an id to an existing graph <div>
 * @param {object} opts (see Plotly.toImage in ../plot_api/to_image)
 * @return {promise}
 */
function downloadImage(gd, opts) {
  var _gd;
  if (!Lib.isPlainObject(gd)) _gd = Lib.getGraphDiv(gd);
  opts = opts || {};
  opts.format = opts.format || 'png';
  opts.width = opts.width || null;
  opts.height = opts.height || null;
  opts.imageDataOnly = true;
  return new Promise(function (resolve, reject) {
    if (_gd && _gd._snapshotInProgress) {
      reject(new Error('Snapshotting already in progress.'));
    }

    // see comments within svgtoimg for additional
    //   discussion of problems with IE
    //   can now draw to canvas, but CORS tainted canvas
    //   does not allow toDataURL
    //   svg format will work though
    if (Lib.isIE() && opts.format !== 'svg') {
      reject(new Error(helpers.MSG_IE_BAD_FORMAT));
    }
    if (_gd) _gd._snapshotInProgress = true;
    var promise = toImage(gd, opts);
    var filename = opts.filename || gd.fn || 'newplot';
    filename += '.' + opts.format.replace('-', '.');
    promise.then(function (result) {
      if (_gd) _gd._snapshotInProgress = false;
      return fileSaver(result, filename, opts.format);
    }).then(function (name) {
      resolve(name);
    }).catch(function (err) {
      if (_gd) _gd._snapshotInProgress = false;
      reject(err);
    });
  });
}
module.exports = downloadImage;

/***/ }),

/***/ 33353:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var helpers = __webpack_require__(84619);

/*
* substantial portions of this code from FileSaver.js
* https://github.com/eligrey/FileSaver.js
* License: https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md
* FileSaver.js
* A saveAs() FileSaver implementation.
* 1.1.20160328
*
* By Eli Grey, http://eligrey.com
* License: MIT
*   See https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md
*/
function fileSaver(url, name, format) {
  var saveLink = document.createElement('a');
  var canUseSaveLink = 'download' in saveLink;
  var promise = new Promise(function (resolve, reject) {
    var blob;
    var objectUrl;

    // IE 10+ (native saveAs)
    if (Lib.isIE()) {
      // At this point we are only dealing with a decoded SVG as
      // a data URL (since IE only supports SVG)
      blob = helpers.createBlob(url, 'svg');
      window.navigator.msSaveBlob(blob, name);
      blob = null;
      return resolve(name);
    }
    if (canUseSaveLink) {
      blob = helpers.createBlob(url, format);
      objectUrl = helpers.createObjectURL(blob);
      saveLink.href = objectUrl;
      saveLink.download = name;
      document.body.appendChild(saveLink);
      saveLink.click();
      document.body.removeChild(saveLink);
      helpers.revokeObjectURL(objectUrl);
      blob = null;
      return resolve(name);
    }

    // Older versions of Safari did not allow downloading of blob urls
    if (Lib.isSafari()) {
      var prefix = format === 'svg' ? ',' : ';base64,';
      helpers.octetStream(prefix + encodeURIComponent(url));
      return resolve(name);
    }
    reject(new Error('download error'));
  });
  return promise;
}
module.exports = fileSaver;

/***/ }),

/***/ 84619:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var Registry = __webpack_require__(33626);
exports.getDelay = function (fullLayout) {
  if (!fullLayout._has) return 0;
  return fullLayout._has('gl3d') || fullLayout._has('gl2d') || fullLayout._has('mapbox') || fullLayout._has('map') ? 500 : 0;
};
exports.getRedrawFunc = function (gd) {
  return function () {
    Registry.getComponentMethod('colorbar', 'draw')(gd);
  };
};
exports.encodeSVG = function (svg) {
  return 'data:image/svg+xml,' + encodeURIComponent(svg);
};
exports.encodeJSON = function (json) {
  return 'data:application/json,' + encodeURIComponent(json);
};
var DOM_URL = window.URL || window.webkitURL;
exports.createObjectURL = function (blob) {
  return DOM_URL.createObjectURL(blob);
};
exports.revokeObjectURL = function (url) {
  return DOM_URL.revokeObjectURL(url);
};
exports.createBlob = function (url, format) {
  if (format === 'svg') {
    return new window.Blob([url], {
      type: 'image/svg+xml;charset=utf-8'
    });
  } else if (format === 'full-json') {
    return new window.Blob([url], {
      type: 'application/json;charset=utf-8'
    });
  } else {
    var binary = fixBinary(window.atob(url));
    return new window.Blob([binary], {
      type: 'image/' + format
    });
  }
};
exports.octetStream = function (s) {
  document.location.href = 'data:application/octet-stream' + s;
};

// Taken from https://bl.ocks.org/nolanlawson/0eac306e4dac2114c752
function fixBinary(b) {
  var len = b.length;
  var buf = new ArrayBuffer(len);
  var arr = new Uint8Array(buf);
  for (var i = 0; i < len; i++) {
    arr[i] = b.charCodeAt(i);
  }
  return buf;
}
exports.IMAGE_URL_PREFIX = /^data:image\/\w+;base64,/;
exports.MSG_IE_BAD_FORMAT = 'Sorry IE does not support downloading from canvas. Try {format:\'svg\'} instead.';

/***/ }),

/***/ 6170:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__(84619);
var Snapshot = {
  getDelay: helpers.getDelay,
  getRedrawFunc: helpers.getRedrawFunc,
  clone: __webpack_require__(3164),
  toSVG: __webpack_require__(6243),
  svgToImg: __webpack_require__(72914),
  toImage: __webpack_require__(76896),
  downloadImage: __webpack_require__(26452)
};
module.exports = Snapshot;

/***/ }),

/***/ 72914:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var EventEmitter = (__webpack_require__(7683).EventEmitter);
var helpers = __webpack_require__(84619);
function svgToImg(opts) {
  var ev = opts.emitter || new EventEmitter();
  var promise = new Promise(function (resolve, reject) {
    var Image = window.Image;
    var svg = opts.svg;
    var format = opts.format || 'png';

    // IE only support svg
    if (Lib.isIE() && format !== 'svg') {
      var ieSvgError = new Error(helpers.MSG_IE_BAD_FORMAT);
      reject(ieSvgError);
      // eventually remove the ev
      //  in favor of promises
      if (!opts.promise) {
        return ev.emit('error', ieSvgError);
      } else {
        return promise;
      }
    }
    var canvas = opts.canvas;
    var scale = opts.scale || 1;
    var w0 = opts.width || 300;
    var h0 = opts.height || 150;
    var w1 = scale * w0;
    var h1 = scale * h0;
    var ctx = canvas.getContext('2d', {
      willReadFrequently: true
    });
    var img = new Image();
    var svgBlob, url;
    if (format === 'svg' || Lib.isSafari()) {
      url = helpers.encodeSVG(svg);
    } else {
      svgBlob = helpers.createBlob(svg, 'svg');
      url = helpers.createObjectURL(svgBlob);
    }
    canvas.width = w1;
    canvas.height = h1;
    img.onload = function () {
      var imgData;
      svgBlob = null;
      helpers.revokeObjectURL(url);

      // don't need to draw to canvas if svg
      //  save some time and also avoid failure on IE
      if (format !== 'svg') {
        ctx.drawImage(img, 0, 0, w1, h1);
      }
      switch (format) {
        case 'jpeg':
          imgData = canvas.toDataURL('image/jpeg');
          break;
        case 'png':
          imgData = canvas.toDataURL('image/png');
          break;
        case 'webp':
          imgData = canvas.toDataURL('image/webp');
          break;
        case 'svg':
          imgData = url;
          break;
        default:
          var errorMsg = 'Image format is not jpeg, png, svg or webp.';
          reject(new Error(errorMsg));
          // eventually remove the ev
          //  in favor of promises
          if (!opts.promise) {
            return ev.emit('error', errorMsg);
          }
      }
      resolve(imgData);
      // eventually remove the ev
      //  in favor of promises
      if (!opts.promise) {
        ev.emit('success', imgData);
      }
    };
    img.onerror = function (err) {
      svgBlob = null;
      helpers.revokeObjectURL(url);
      reject(err);
      // eventually remove the ev
      //  in favor of promises
      if (!opts.promise) {
        return ev.emit('error', err);
      }
    };
    img.src = url;
  });

  // temporary for backward compatibility
  //  move to only Promise in 2.0.0
  //  and eliminate the EventEmitter
  if (opts.promise) {
    return promise;
  }
  return ev;
}
module.exports = svgToImg;

/***/ }),

/***/ 76896:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var EventEmitter = (__webpack_require__(7683).EventEmitter);
var Registry = __webpack_require__(33626);
var Lib = __webpack_require__(34809);
var helpers = __webpack_require__(84619);
var clonePlot = __webpack_require__(3164);
var toSVG = __webpack_require__(6243);
var svgToImg = __webpack_require__(72914);

/**
 * @param {object} gd figure Object
 * @param {object} opts option object
 * @param opts.format 'jpeg' | 'png' | 'webp' | 'svg'
 */
function toImage(gd, opts) {
  // first clone the GD so we can operate in a clean environment
  var ev = new EventEmitter();
  var clone = clonePlot(gd, {
    format: 'png'
  });
  var clonedGd = clone.gd;

  // put the cloned div somewhere off screen before attaching to DOM
  clonedGd.style.position = 'absolute';
  clonedGd.style.left = '-5000px';
  document.body.appendChild(clonedGd);
  function wait() {
    var delay = helpers.getDelay(clonedGd._fullLayout);
    setTimeout(function () {
      var svg = toSVG(clonedGd);
      var canvas = document.createElement('canvas');
      canvas.id = Lib.randstr();
      ev = svgToImg({
        format: opts.format,
        width: clonedGd._fullLayout.width,
        height: clonedGd._fullLayout.height,
        canvas: canvas,
        emitter: ev,
        svg: svg
      });
      ev.clean = function () {
        if (clonedGd) document.body.removeChild(clonedGd);
      };
    }, delay);
  }
  var redrawFunc = helpers.getRedrawFunc(clonedGd);
  Registry.call('_doPlot', clonedGd, clone.data, clone.layout, clone.config).then(redrawFunc).then(wait).catch(function (err) {
    ev.emit('error', err);
  });
  return ev;
}
module.exports = toImage;

/***/ }),

/***/ 6243:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var Lib = __webpack_require__(34809);
var Drawing = __webpack_require__(62203);
var Color = __webpack_require__(78766);
var xmlnsNamespaces = __webpack_require__(62972);
var DOUBLEQUOTE_REGEX = /"/g;
var DUMMY_SUB = 'TOBESTRIPPED';
var DUMMY_REGEX = new RegExp('("' + DUMMY_SUB + ')|(' + DUMMY_SUB + '")', 'g');
function htmlEntityDecode(s) {
  var hiddenDiv = d3.select('body').append('div').style({
    display: 'none'
  }).html('');
  var replaced = s.replace(/(&[^;]*;)/gi, function (d) {
    if (d === '&lt;') {
      return '&#60;';
    } // special handling for brackets
    if (d === '&rt;') {
      return '&#62;';
    }
    if (d.indexOf('<') !== -1 || d.indexOf('>') !== -1) {
      return '';
    }
    return hiddenDiv.html(d).text(); // everything else, let the browser decode it to unicode
  });
  hiddenDiv.remove();
  return replaced;
}
function xmlEntityEncode(str) {
  return str.replace(/&(?!\w+;|\#[0-9]+;| \#x[0-9A-F]+;)/g, '&amp;');
}
module.exports = function toSVG(gd, format, scale) {
  var fullLayout = gd._fullLayout;
  var svg = fullLayout._paper;
  var toppaper = fullLayout._toppaper;
  var width = fullLayout.width;
  var height = fullLayout.height;
  var i;

  // make background color a rect in the svg, then revert after scraping
  // all other alterations have been dealt with by properly preparing the svg
  // in the first place... like setting cursors with css classes so we don't
  // have to remove them, and providing the right namespaces in the svg to
  // begin with
  svg.insert('rect', ':first-child').call(Drawing.setRect, 0, 0, width, height).call(Color.fill, fullLayout.paper_bgcolor);

  // subplot-specific to-SVG methods
  // which notably add the contents of the gl-container
  // into the main svg node
  var basePlotModules = fullLayout._basePlotModules || [];
  for (i = 0; i < basePlotModules.length; i++) {
    var _module = basePlotModules[i];
    if (_module.toSVG) _module.toSVG(gd);
  }

  // add top items above them assumes everything in toppaper is either
  // a group or a defs, and if it's empty (like hoverlayer) we can ignore it.
  if (toppaper) {
    var nodes = toppaper.node().childNodes;

    // make copy of nodes as childNodes prop gets mutated in loop below
    var topGroups = Array.prototype.slice.call(nodes);
    for (i = 0; i < topGroups.length; i++) {
      var topGroup = topGroups[i];
      if (topGroup.childNodes.length) svg.node().appendChild(topGroup);
    }
  }

  // remove draglayer for Adobe Illustrator compatibility
  if (fullLayout._draggers) {
    fullLayout._draggers.remove();
  }

  // in case the svg element had an explicit background color, remove this
  // we want the rect to get the color so it's the right size; svg bg will
  // fill whatever container it's displayed in regardless of plot size.
  svg.node().style.background = '';
  svg.selectAll('text').attr({
    'data-unformatted': null,
    'data-math': null
  }).each(function () {
    var txt = d3.select(this);

    // hidden text is pre-formatting mathjax, the browser ignores it
    // but in a static plot it's useless and it can confuse batik
    // we've tried to standardize on display:none but make sure we still
    // catch visibility:hidden if it ever arises
    if (this.style.visibility === 'hidden' || this.style.display === 'none') {
      txt.remove();
      return;
    } else {
      // clear other visibility/display values to default
      // to not potentially confuse non-browser SVG implementations
      txt.style({
        visibility: null,
        display: null
      });
    }

    // Font family styles break things because of quotation marks,
    // so we must remove them *after* the SVG DOM has been serialized
    // to a string (browsers convert singles back)
    var ff = this.style.fontFamily;
    if (ff && ff.indexOf('"') !== -1) {
      txt.style('font-family', ff.replace(DOUBLEQUOTE_REGEX, DUMMY_SUB));
    }

    // Drop normal font-weight, font-style and font-variant to reduce the size
    var fw = this.style.fontWeight;
    if (fw && (fw === 'normal' || fw === '400')) {
      // font-weight 400 is similar to normal
      txt.style('font-weight', undefined);
    }
    var fs = this.style.fontStyle;
    if (fs && fs === 'normal') {
      txt.style('font-style', undefined);
    }
    var fv = this.style.fontVariant;
    if (fv && fv === 'normal') {
      txt.style('font-variant', undefined);
    }
  });
  svg.selectAll('.gradient_filled,.pattern_filled').each(function () {
    var pt = d3.select(this);

    // similar to font family styles above,
    // we must remove " after the SVG DOM has been serialized
    var fill = this.style.fill;
    if (fill && fill.indexOf('url(') !== -1) {
      pt.style('fill', fill.replace(DOUBLEQUOTE_REGEX, DUMMY_SUB));
    }
    var stroke = this.style.stroke;
    if (stroke && stroke.indexOf('url(') !== -1) {
      pt.style('stroke', stroke.replace(DOUBLEQUOTE_REGEX, DUMMY_SUB));
    }
  });
  if (format === 'pdf' || format === 'eps') {
    // these formats make the extra line MathJax adds around symbols look super thick in some cases
    // it looks better if this is removed entirely.
    svg.selectAll('#MathJax_SVG_glyphs path').attr('stroke-width', 0);
  }

  // fix for IE namespacing quirk?
  // http://stackoverflow.com/questions/19610089/unwanted-namespaces-on-svg-markup-when-using-xmlserializer-in-javascript-with-ie
  svg.node().setAttributeNS(xmlnsNamespaces.xmlns, 'xmlns', xmlnsNamespaces.svg);
  svg.node().setAttributeNS(xmlnsNamespaces.xmlns, 'xmlns:xlink', xmlnsNamespaces.xlink);
  if (format === 'svg' && scale) {
    svg.attr('width', scale * width);
    svg.attr('height', scale * height);
    svg.attr('viewBox', '0 0 ' + width + ' ' + height);
  }
  var s = new window.XMLSerializer().serializeToString(svg.node());
  s = htmlEntityDecode(s);
  s = xmlEntityEncode(s);

  // Fix quotations around font strings and gradient URLs
  s = s.replace(DUMMY_REGEX, '\'');

  // Do we need this process now that IE9 and IE10 are not supported?

  // IE is very strict, so we will need to clean
  //  svg with the following regex
  //  yes this is messy, but do not know a better way
  // Even with this IE will not work due to tainted canvas
  //  see https://github.com/kangax/fabric.js/issues/1957
  //      http://stackoverflow.com/questions/18112047/canvas-todataurl-working-in-all-browsers-except-ie10
  // Leave here just in case the CORS/tainted IE issue gets resolved
  if (Lib.isIE()) {
    // replace double quote with single quote
    s = s.replace(/"/gi, '\'');
    // url in svg are single quoted
    //   since we changed double to single
    //   we'll need to change these to double-quoted
    s = s.replace(/(\('#)([^']*)('\))/gi, '(\"#$2\")');
    // font names with spaces will be escaped single-quoted
    //   we'll need to change these to double-quoted
    s = s.replace(/(\\')/gi, '\"');
  }
  return s;
};

/***/ }),

/***/ 35374:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);

// arrayOk attributes, merge them into calcdata array
module.exports = function arraysToCalcdata(cd, trace) {
  for (var i = 0; i < cd.length; i++) cd[i].i = i;
  Lib.mergeArray(trace.text, cd, 'tx');
  Lib.mergeArray(trace.hovertext, cd, 'htx');
  var marker = trace.marker;
  if (marker) {
    Lib.mergeArray(marker.opacity, cd, 'mo', true);
    Lib.mergeArray(marker.color, cd, 'mc');
    var markerLine = marker.line;
    if (markerLine) {
      Lib.mergeArray(markerLine.color, cd, 'mlc');
      Lib.mergeArrayCastPositive(markerLine.width, cd, 'mlw');
    }
  }
};

/***/ }),

/***/ 81481:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var scatterAttrs = __webpack_require__(36640);
var axisHoverFormat = (__webpack_require__(80712).axisHoverFormat);
var hovertemplateAttrs = (__webpack_require__(3208)/* .hovertemplateAttrs */ .rb);
var texttemplateAttrs = (__webpack_require__(3208)/* .texttemplateAttrs */ .ay);
var colorScaleAttrs = __webpack_require__(87163);
var fontAttrs = __webpack_require__(80337);
var constants = __webpack_require__(56155);
var pattern = (__webpack_require__(94850)/* .pattern */ .k);
var extendFlat = (__webpack_require__(93049).extendFlat);
var textFontAttrs = fontAttrs({
  editType: 'calc',
  arrayOk: true,
  colorEditType: 'style'
});
var scatterMarkerAttrs = scatterAttrs.marker;
var scatterMarkerLineAttrs = scatterMarkerAttrs.line;
var markerLineWidth = extendFlat({}, scatterMarkerLineAttrs.width, {
  dflt: 0
});
var markerLine = extendFlat({
  width: markerLineWidth,
  editType: 'calc'
}, colorScaleAttrs('marker.line'));
var marker = extendFlat({
  line: markerLine,
  editType: 'calc'
}, colorScaleAttrs('marker'), {
  opacity: {
    valType: 'number',
    arrayOk: true,
    dflt: 1,
    min: 0,
    max: 1,
    editType: 'style'
  },
  pattern: pattern,
  cornerradius: {
    valType: 'any',
    editType: 'calc'
  }
});
module.exports = {
  x: scatterAttrs.x,
  x0: scatterAttrs.x0,
  dx: scatterAttrs.dx,
  y: scatterAttrs.y,
  y0: scatterAttrs.y0,
  dy: scatterAttrs.dy,
  xperiod: scatterAttrs.xperiod,
  yperiod: scatterAttrs.yperiod,
  xperiod0: scatterAttrs.xperiod0,
  yperiod0: scatterAttrs.yperiod0,
  xperiodalignment: scatterAttrs.xperiodalignment,
  yperiodalignment: scatterAttrs.yperiodalignment,
  xhoverformat: axisHoverFormat('x'),
  yhoverformat: axisHoverFormat('y'),
  text: scatterAttrs.text,
  texttemplate: texttemplateAttrs({
    editType: 'plot'
  }, {
    keys: constants.eventDataKeys
  }),
  hovertext: scatterAttrs.hovertext,
  hovertemplate: hovertemplateAttrs({}, {
    keys: constants.eventDataKeys
  }),
  textposition: {
    valType: 'enumerated',
    values: ['inside', 'outside', 'auto', 'none'],
    dflt: 'auto',
    arrayOk: true,
    editType: 'calc'
  },
  insidetextanchor: {
    valType: 'enumerated',
    values: ['end', 'middle', 'start'],
    dflt: 'end',
    editType: 'plot'
  },
  textangle: {
    valType: 'angle',
    dflt: 'auto',
    editType: 'plot'
  },
  textfont: extendFlat({}, textFontAttrs, {}),
  insidetextfont: extendFlat({}, textFontAttrs, {}),
  outsidetextfont: extendFlat({}, textFontAttrs, {}),
  constraintext: {
    valType: 'enumerated',
    values: ['inside', 'outside', 'both', 'none'],
    dflt: 'both',
    editType: 'calc'
  },
  cliponaxis: extendFlat({}, scatterAttrs.cliponaxis, {}),
  orientation: {
    valType: 'enumerated',
    values: ['v', 'h'],
    editType: 'calc+clearAxisTypes'
  },
  base: {
    valType: 'any',
    dflt: null,
    arrayOk: true,
    editType: 'calc'
  },
  offset: {
    valType: 'number',
    dflt: null,
    arrayOk: true,
    editType: 'calc'
  },
  width: {
    valType: 'number',
    dflt: null,
    min: 0,
    arrayOk: true,
    editType: 'calc'
  },
  marker: marker,
  offsetgroup: scatterAttrs.offsetgroup,
  alignmentgroup: scatterAttrs.alignmentgroup,
  selected: {
    marker: {
      opacity: scatterAttrs.selected.marker.opacity,
      color: scatterAttrs.selected.marker.color,
      editType: 'style'
    },
    textfont: scatterAttrs.selected.textfont,
    editType: 'style'
  },
  unselected: {
    marker: {
      opacity: scatterAttrs.unselected.marker.opacity,
      color: scatterAttrs.unselected.marker.color,
      editType: 'style'
    },
    textfont: scatterAttrs.unselected.textfont,
    editType: 'style'
  },
  zorder: scatterAttrs.zorder,
  _deprecated: {
    bardir: {
      valType: 'enumerated',
      editType: 'calc',
      values: ['v', 'h']
    }
  }
};

/***/ }),

/***/ 67565:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Axes = __webpack_require__(29714);
var alignPeriod = __webpack_require__(40528);
var hasColorscale = (__webpack_require__(65477).hasColorscale);
var colorscaleCalc = __webpack_require__(28379);
var arraysToCalcdata = __webpack_require__(35374);
var calcSelection = __webpack_require__(48861);
module.exports = function calc(gd, trace) {
  var xa = Axes.getFromId(gd, trace.xaxis || 'x');
  var ya = Axes.getFromId(gd, trace.yaxis || 'y');
  var size, pos, origPos, pObj, hasPeriod, pLetter;
  var sizeOpts = {
    msUTC: !!(trace.base || trace.base === 0)
  };
  if (trace.orientation === 'h') {
    size = xa.makeCalcdata(trace, 'x', sizeOpts);
    origPos = ya.makeCalcdata(trace, 'y');
    pObj = alignPeriod(trace, ya, 'y', origPos);
    hasPeriod = !!trace.yperiodalignment;
    pLetter = 'y';
  } else {
    size = ya.makeCalcdata(trace, 'y', sizeOpts);
    origPos = xa.makeCalcdata(trace, 'x');
    pObj = alignPeriod(trace, xa, 'x', origPos);
    hasPeriod = !!trace.xperiodalignment;
    pLetter = 'x';
  }
  pos = pObj.vals;

  // create the "calculated data" to plot
  var serieslen = Math.min(pos.length, size.length);
  var cd = new Array(serieslen);

  // set position and size
  for (var i = 0; i < serieslen; i++) {
    cd[i] = {
      p: pos[i],
      s: size[i]
    };
    if (hasPeriod) {
      cd[i].orig_p = origPos[i]; // used by hover
      cd[i][pLetter + 'End'] = pObj.ends[i];
      cd[i][pLetter + 'Start'] = pObj.starts[i];
    }
    if (trace.ids) {
      cd[i].id = String(trace.ids[i]);
    }
  }

  // auto-z and autocolorscale if applicable
  if (hasColorscale(trace, 'marker')) {
    colorscaleCalc(gd, trace, {
      vals: trace.marker.color,
      containerStr: 'marker',
      cLetter: 'c'
    });
  }
  if (hasColorscale(trace, 'marker.line')) {
    colorscaleCalc(gd, trace, {
      vals: trace.marker.line.color,
      containerStr: 'marker.line',
      cLetter: 'c'
    });
  }
  arraysToCalcdata(cd, trace);
  calcSelection(cd, trace);
  return cd;
};

/***/ }),

/***/ 56155:
/***/ (function(module) {

"use strict";


module.exports = {
  // padding in pixels around text
  TEXTPAD: 3,
  // 'value' and 'label' are not really necessary for bar traces,
  // but they were made available to `texttemplate` (maybe by accident)
  // via tokens `%{value}` and `%{label}` starting in 1.50.0,
  // so let's include them in the event data also.
  eventDataKeys: ['value', 'label']
};

/***/ }),

/***/ 24782:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isNumeric = __webpack_require__(10721);
var isArrayOrTypedArray = (__webpack_require__(34809).isArrayOrTypedArray);
var BADNUM = (__webpack_require__(63821).BADNUM);
var Registry = __webpack_require__(33626);
var Axes = __webpack_require__(29714);
var getAxisGroup = (__webpack_require__(84391).getAxisGroup);
var Sieve = __webpack_require__(2880);

/*
 * Bar chart stacking/grouping positioning and autoscaling calculations
 * for each direction separately calculate the ranges and positions
 * note that this handles histograms too
 * now doing this one subplot at a time
 */

function crossTraceCalc(gd, plotinfo) {
  var xa = plotinfo.xaxis;
  var ya = plotinfo.yaxis;
  var fullLayout = gd._fullLayout;
  var fullTraces = gd._fullData;
  var calcTraces = gd.calcdata;
  var calcTracesHorz = [];
  var calcTracesVert = [];
  for (var i = 0; i < fullTraces.length; i++) {
    var fullTrace = fullTraces[i];
    if (fullTrace.visible === true && Registry.traceIs(fullTrace, 'bar') && fullTrace.xaxis === xa._id && fullTrace.yaxis === ya._id) {
      if (fullTrace.orientation === 'h') {
        calcTracesHorz.push(calcTraces[i]);
      } else {
        calcTracesVert.push(calcTraces[i]);
      }
      if (fullTrace._computePh) {
        var cd = gd.calcdata[i];
        for (var j = 0; j < cd.length; j++) {
          if (typeof cd[j].ph0 === 'function') cd[j].ph0 = cd[j].ph0();
          if (typeof cd[j].ph1 === 'function') cd[j].ph1 = cd[j].ph1();
        }
      }
    }
  }
  var opts = {
    xCat: xa.type === 'category' || xa.type === 'multicategory',
    yCat: ya.type === 'category' || ya.type === 'multicategory',
    mode: fullLayout.barmode,
    norm: fullLayout.barnorm,
    gap: fullLayout.bargap,
    groupgap: fullLayout.bargroupgap
  };
  setGroupPositions(gd, xa, ya, calcTracesVert, opts);
  setGroupPositions(gd, ya, xa, calcTracesHorz, opts);
}
function setGroupPositions(gd, pa, sa, calcTraces, opts) {
  if (!calcTraces.length) return;
  var excluded;
  var included;
  var i, calcTrace, fullTrace;
  initBase(sa, calcTraces);
  switch (opts.mode) {
    case 'overlay':
      setGroupPositionsInOverlayMode(pa, sa, calcTraces, opts);
      break;
    case 'group':
      // exclude from the group those traces for which the user set an offset
      excluded = [];
      included = [];
      for (i = 0; i < calcTraces.length; i++) {
        calcTrace = calcTraces[i];
        fullTrace = calcTrace[0].trace;
        if (fullTrace.offset === undefined) included.push(calcTrace);else excluded.push(calcTrace);
      }
      if (included.length) {
        setGroupPositionsInGroupMode(gd, pa, sa, included, opts);
      }
      if (excluded.length) {
        setGroupPositionsInOverlayMode(pa, sa, excluded, opts);
      }
      break;
    case 'stack':
    case 'relative':
      // exclude from the stack those traces for which the user set a base
      excluded = [];
      included = [];
      for (i = 0; i < calcTraces.length; i++) {
        calcTrace = calcTraces[i];
        fullTrace = calcTrace[0].trace;
        if (fullTrace.base === undefined) included.push(calcTrace);else excluded.push(calcTrace);
      }

      // If any trace in `included` has a cornerradius, set cornerradius of all bars
      // in `included` to match the first trace which has a cornerradius
      standardizeCornerradius(included);
      if (included.length) {
        setGroupPositionsInStackOrRelativeMode(gd, pa, sa, included, opts);
      }
      if (excluded.length) {
        setGroupPositionsInOverlayMode(pa, sa, excluded, opts);
      }
      break;
  }
  setCornerradius(calcTraces);
  collectExtents(calcTraces, pa);
}

// Set cornerradiusvalue and cornerradiusform in calcTraces[0].t
function setCornerradius(calcTraces) {
  var i, calcTrace, fullTrace, t, cr, crValue, crForm;
  for (i = 0; i < calcTraces.length; i++) {
    calcTrace = calcTraces[i];
    fullTrace = calcTrace[0].trace;
    t = calcTrace[0].t;
    if (t.cornerradiusvalue === undefined) {
      cr = fullTrace.marker ? fullTrace.marker.cornerradius : undefined;
      if (cr !== undefined) {
        crValue = isNumeric(cr) ? +cr : +cr.slice(0, -1);
        crForm = isNumeric(cr) ? 'px' : '%';
        t.cornerradiusvalue = crValue;
        t.cornerradiusform = crForm;
      }
    }
  }
}

// Make sure all traces in a stack use the same cornerradius
function standardizeCornerradius(calcTraces) {
  if (calcTraces.length < 2) return;
  var i, calcTrace, fullTrace, t;
  var cr, crValue, crForm;
  for (i = 0; i < calcTraces.length; i++) {
    calcTrace = calcTraces[i];
    fullTrace = calcTrace[0].trace;
    cr = fullTrace.marker ? fullTrace.marker.cornerradius : undefined;
    if (cr !== undefined) break;
  }
  // If any trace has cornerradius, store first cornerradius
  // in calcTrace[0].t so that all traces in stack use same cornerradius
  if (cr !== undefined) {
    crValue = isNumeric(cr) ? +cr : +cr.slice(0, -1);
    crForm = isNumeric(cr) ? 'px' : '%';
    for (i = 0; i < calcTraces.length; i++) {
      calcTrace = calcTraces[i];
      t = calcTrace[0].t;
      t.cornerradiusvalue = crValue;
      t.cornerradiusform = crForm;
    }
  }
}
function initBase(sa, calcTraces) {
  var i, j;
  for (i = 0; i < calcTraces.length; i++) {
    var cd = calcTraces[i];
    var trace = cd[0].trace;
    var base = trace.type === 'funnel' ? trace._base : trace.base;
    var b;

    // not sure if it really makes sense to have dates for bar size data...
    // ideally if we want to make gantt charts or something we'd treat
    // the actual size (trace.x or y) as time delta but base as absolute
    // time. But included here for completeness.
    var scalendar = trace.orientation === 'h' ? trace.xcalendar : trace.ycalendar;

    // 'base' on categorical axes makes no sense
    var d2c = sa.type === 'category' || sa.type === 'multicategory' ? function () {
      return null;
    } : sa.d2c;
    if (isArrayOrTypedArray(base)) {
      for (j = 0; j < Math.min(base.length, cd.length); j++) {
        b = d2c(base[j], 0, scalendar);
        if (isNumeric(b)) {
          cd[j].b = +b;
          cd[j].hasB = 1;
        } else cd[j].b = 0;
      }
      for (; j < cd.length; j++) {
        cd[j].b = 0;
      }
    } else {
      b = d2c(base, 0, scalendar);
      var hasBase = isNumeric(b);
      b = hasBase ? b : 0;
      for (j = 0; j < cd.length; j++) {
        cd[j].b = b;
        if (hasBase) cd[j].hasB = 1;
      }
    }
  }
}
function setGroupPositionsInOverlayMode(pa, sa, calcTraces, opts) {
  // update position axis and set bar offsets and widths
  for (var i = 0; i < calcTraces.length; i++) {
    var calcTrace = calcTraces[i];
    var sieve = new Sieve([calcTrace], {
      posAxis: pa,
      sepNegVal: false,
      overlapNoMerge: !opts.norm
    });

    // set bar offsets and widths, and update position axis
    setOffsetAndWidth(pa, sieve, opts);

    // set bar bases and sizes, and update size axis
    //
    // (note that `setGroupPositionsInOverlayMode` handles the case barnorm
    // is defined, because this function is also invoked for traces that
    // can't be grouped or stacked)
    if (opts.norm) {
      sieveBars(sieve);
      normalizeBars(sa, sieve, opts);
    } else {
      setBaseAndTop(sa, sieve);
    }
  }
}
function setGroupPositionsInGroupMode(gd, pa, sa, calcTraces, opts) {
  var sieve = new Sieve(calcTraces, {
    posAxis: pa,
    sepNegVal: false,
    overlapNoMerge: !opts.norm
  });

  // set bar offsets and widths, and update position axis
  setOffsetAndWidthInGroupMode(gd, pa, sieve, opts);

  // relative-stack bars within the same trace that would otherwise
  // be hidden
  unhideBarsWithinTrace(sieve, pa);

  // set bar bases and sizes, and update size axis
  if (opts.norm) {
    sieveBars(sieve);
    normalizeBars(sa, sieve, opts);
  } else {
    setBaseAndTop(sa, sieve);
  }
}
function setGroupPositionsInStackOrRelativeMode(gd, pa, sa, calcTraces, opts) {
  var sieve = new Sieve(calcTraces, {
    posAxis: pa,
    sepNegVal: opts.mode === 'relative',
    overlapNoMerge: !(opts.norm || opts.mode === 'stack' || opts.mode === 'relative')
  });

  // set bar offsets and widths, and update position axis
  setOffsetAndWidth(pa, sieve, opts);

  // set bar bases and sizes, and update size axis
  stackBars(sa, sieve, opts);

  // flag the outmost bar (for text display purposes)
  for (var i = 0; i < calcTraces.length; i++) {
    var calcTrace = calcTraces[i];
    for (var j = 0; j < calcTrace.length; j++) {
      var bar = calcTrace[j];
      if (bar.s !== BADNUM) {
        var isOutmostBar = bar.b + bar.s === sieve.get(bar.p, bar.s);
        if (isOutmostBar) bar._outmost = true;
      }
    }
  }

  // Note that marking the outmost bars has to be done
  // before `normalizeBars` changes `bar.b` and `bar.s`.
  if (opts.norm) normalizeBars(sa, sieve, opts);
}
function setOffsetAndWidth(pa, sieve, opts) {
  var minDiff = sieve.minDiff;
  var calcTraces = sieve.traces;

  // set bar offsets and widths
  var barGroupWidth = minDiff * (1 - opts.gap);
  var barWidthPlusGap = barGroupWidth;
  var barWidth = barWidthPlusGap * (1 - (opts.groupgap || 0));

  // computer bar group center and bar offset
  var offsetFromCenter = -barWidth / 2;
  for (var i = 0; i < calcTraces.length; i++) {
    var calcTrace = calcTraces[i];
    var t = calcTrace[0].t;

    // store bar width and offset for this trace
    t.barwidth = barWidth;
    t.poffset = offsetFromCenter;
    t.bargroupwidth = barGroupWidth;
    t.bardelta = minDiff;
  }

  // stack bars that only differ by rounding
  sieve.binWidth = calcTraces[0][0].t.barwidth / 100;

  // if defined, apply trace offset and width
  applyAttributes(sieve);

  // store the bar center in each calcdata item
  setBarCenterAndWidth(pa, sieve);

  // update position axes
  updatePositionAxis(pa, sieve);
}
function setOffsetAndWidthInGroupMode(gd, pa, sieve, opts) {
  var fullLayout = gd._fullLayout;
  var positions = sieve.positions;
  var distinctPositions = sieve.distinctPositions;
  var minDiff = sieve.minDiff;
  var calcTraces = sieve.traces;
  var nTraces = calcTraces.length;

  // if there aren't any overlapping positions,
  // let them have full width even if mode is group
  var overlap = positions.length !== distinctPositions.length;
  var barGroupWidth = minDiff * (1 - opts.gap);
  var groupId = getAxisGroup(fullLayout, pa._id) + calcTraces[0][0].trace.orientation;
  var alignmentGroups = fullLayout._alignmentOpts[groupId] || {};
  for (var i = 0; i < nTraces; i++) {
    var calcTrace = calcTraces[i];
    var trace = calcTrace[0].trace;
    var alignmentGroupOpts = alignmentGroups[trace.alignmentgroup] || {};
    var nOffsetGroups = Object.keys(alignmentGroupOpts.offsetGroups || {}).length;
    var barWidthPlusGap;
    if (nOffsetGroups) {
      barWidthPlusGap = barGroupWidth / nOffsetGroups;
    } else {
      barWidthPlusGap = overlap ? barGroupWidth / nTraces : barGroupWidth;
    }
    var barWidth = barWidthPlusGap * (1 - (opts.groupgap || 0));
    var offsetFromCenter;
    if (nOffsetGroups) {
      offsetFromCenter = ((2 * trace._offsetIndex + 1 - nOffsetGroups) * barWidthPlusGap - barWidth) / 2;
    } else {
      offsetFromCenter = overlap ? ((2 * i + 1 - nTraces) * barWidthPlusGap - barWidth) / 2 : -barWidth / 2;
    }
    var t = calcTrace[0].t;
    t.barwidth = barWidth;
    t.poffset = offsetFromCenter;
    t.bargroupwidth = barGroupWidth;
    t.bardelta = minDiff;
  }

  // stack bars that only differ by rounding
  sieve.binWidth = calcTraces[0][0].t.barwidth / 100;

  // if defined, apply trace width
  applyAttributes(sieve);

  // store the bar center in each calcdata item
  setBarCenterAndWidth(pa, sieve);

  // update position axes
  updatePositionAxis(pa, sieve, overlap);
}
function applyAttributes(sieve) {
  var calcTraces = sieve.traces;
  var i, j;
  for (i = 0; i < calcTraces.length; i++) {
    var calcTrace = calcTraces[i];
    var calcTrace0 = calcTrace[0];
    var fullTrace = calcTrace0.trace;
    var t = calcTrace0.t;
    var offset = fullTrace._offset || fullTrace.offset;
    var initialPoffset = t.poffset;
    var newPoffset;
    if (isArrayOrTypedArray(offset)) {
      // if offset is an array, then clone it into t.poffset.
      newPoffset = Array.prototype.slice.call(offset, 0, calcTrace.length);

      // guard against non-numeric items
      for (j = 0; j < newPoffset.length; j++) {
        if (!isNumeric(newPoffset[j])) {
          newPoffset[j] = initialPoffset;
        }
      }

      // if the length of the array is too short,
      // then extend it with the initial value of t.poffset
      for (j = newPoffset.length; j < calcTrace.length; j++) {
        newPoffset.push(initialPoffset);
      }
      t.poffset = newPoffset;
    } else if (offset !== undefined) {
      t.poffset = offset;
    }
    var width = fullTrace._width || fullTrace.width;
    var initialBarwidth = t.barwidth;
    if (isArrayOrTypedArray(width)) {
      // if width is an array, then clone it into t.barwidth.
      var newBarwidth = Array.prototype.slice.call(width, 0, calcTrace.length);

      // guard against non-numeric items
      for (j = 0; j < newBarwidth.length; j++) {
        if (!isNumeric(newBarwidth[j])) newBarwidth[j] = initialBarwidth;
      }

      // if the length of the array is too short,
      // then extend it with the initial value of t.barwidth
      for (j = newBarwidth.length; j < calcTrace.length; j++) {
        newBarwidth.push(initialBarwidth);
      }
      t.barwidth = newBarwidth;

      // if user didn't set offset,
      // then correct t.poffset to ensure bars remain centered
      if (offset === undefined) {
        newPoffset = [];
        for (j = 0; j < calcTrace.length; j++) {
          newPoffset.push(initialPoffset + (initialBarwidth - newBarwidth[j]) / 2);
        }
        t.poffset = newPoffset;
      }
    } else if (width !== undefined) {
      t.barwidth = width;

      // if user didn't set offset,
      // then correct t.poffset to ensure bars remain centered
      if (offset === undefined) {
        t.poffset = initialPoffset + (initialBarwidth - width) / 2;
      }
    }
  }
}
function setBarCenterAndWidth(pa, sieve) {
  var calcTraces = sieve.traces;
  var pLetter = getAxisLetter(pa);
  for (var i = 0; i < calcTraces.length; i++) {
    var calcTrace = calcTraces[i];
    var t = calcTrace[0].t;
    var poffset = t.poffset;
    var poffsetIsArray = isArrayOrTypedArray(poffset);
    var barwidth = t.barwidth;
    var barwidthIsArray = isArrayOrTypedArray(barwidth);
    for (var j = 0; j < calcTrace.length; j++) {
      var calcBar = calcTrace[j];

      // store the actual bar width and position, for use by hover
      var width = calcBar.w = barwidthIsArray ? barwidth[j] : barwidth;
      if (calcBar.p === undefined) {
        calcBar.p = calcBar[pLetter];
        calcBar['orig_' + pLetter] = calcBar[pLetter];
      }
      var delta = (poffsetIsArray ? poffset[j] : poffset) + width / 2;
      calcBar[pLetter] = calcBar.p + delta;
    }
  }
}
function updatePositionAxis(pa, sieve, allowMinDtick) {
  var calcTraces = sieve.traces;
  var minDiff = sieve.minDiff;
  var vpad = minDiff / 2;
  Axes.minDtick(pa, sieve.minDiff, sieve.distinctPositions[0], allowMinDtick);
  for (var i = 0; i < calcTraces.length; i++) {
    var calcTrace = calcTraces[i];
    var calcTrace0 = calcTrace[0];
    var fullTrace = calcTrace0.trace;
    var pts = [];
    var bar, l, r, j;
    for (j = 0; j < calcTrace.length; j++) {
      bar = calcTrace[j];
      l = bar.p - vpad;
      r = bar.p + vpad;
      pts.push(l, r);
    }
    if (fullTrace.width || fullTrace.offset) {
      var t = calcTrace0.t;
      var poffset = t.poffset;
      var barwidth = t.barwidth;
      var poffsetIsArray = isArrayOrTypedArray(poffset);
      var barwidthIsArray = isArrayOrTypedArray(barwidth);
      for (j = 0; j < calcTrace.length; j++) {
        bar = calcTrace[j];
        var calcBarOffset = poffsetIsArray ? poffset[j] : poffset;
        var calcBarWidth = barwidthIsArray ? barwidth[j] : barwidth;
        l = bar.p + calcBarOffset;
        r = l + calcBarWidth;
        pts.push(l, r);
      }
    }
    fullTrace._extremes[pa._id] = Axes.findExtremes(pa, pts, {
      padded: false
    });
  }
}

// store these bar bases and tops in calcdata
// and make sure the size axis includes zero,
// along with the bases and tops of each bar.
function setBaseAndTop(sa, sieve) {
  var calcTraces = sieve.traces;
  var sLetter = getAxisLetter(sa);
  for (var i = 0; i < calcTraces.length; i++) {
    var calcTrace = calcTraces[i];
    var fullTrace = calcTrace[0].trace;
    var isScatter = fullTrace.type === 'scatter';
    var isVertical = fullTrace.orientation === 'v';
    var pts = [];
    var tozero = false;
    for (var j = 0; j < calcTrace.length; j++) {
      var bar = calcTrace[j];
      var base = isScatter ? 0 : bar.b;
      var top = isScatter ? isVertical ? bar.y : bar.x : base + bar.s;
      bar[sLetter] = top;
      pts.push(top);
      if (bar.hasB) pts.push(base);
      if (!bar.hasB || !bar.b) {
        tozero = true;
      }
    }
    fullTrace._extremes[sa._id] = Axes.findExtremes(sa, pts, {
      tozero: tozero,
      padded: true
    });
  }
}
function stackBars(sa, sieve, opts) {
  var sLetter = getAxisLetter(sa);
  var calcTraces = sieve.traces;
  var calcTrace;
  var fullTrace;
  var isFunnel;
  var i, j;
  var bar;
  for (i = 0; i < calcTraces.length; i++) {
    calcTrace = calcTraces[i];
    fullTrace = calcTrace[0].trace;
    if (fullTrace.type === 'funnel') {
      for (j = 0; j < calcTrace.length; j++) {
        bar = calcTrace[j];
        if (bar.s !== BADNUM) {
          // create base of funnels
          sieve.put(bar.p, -0.5 * bar.s);
        }
      }
    }
  }
  for (i = 0; i < calcTraces.length; i++) {
    calcTrace = calcTraces[i];
    fullTrace = calcTrace[0].trace;
    isFunnel = fullTrace.type === 'funnel';
    var pts = [];
    for (j = 0; j < calcTrace.length; j++) {
      bar = calcTrace[j];
      if (bar.s !== BADNUM) {
        // stack current bar and get previous sum
        var value;
        if (isFunnel) {
          value = bar.s;
        } else {
          value = bar.s + bar.b;
        }
        var base = sieve.put(bar.p, value);
        var top = base + value;

        // store the bar base and top in each calcdata item
        bar.b = base;
        bar[sLetter] = top;
        if (!opts.norm) {
          pts.push(top);
          if (bar.hasB) {
            pts.push(base);
          }
        }
      }
    }

    // if barnorm is set, let normalizeBars update the axis range
    if (!opts.norm) {
      fullTrace._extremes[sa._id] = Axes.findExtremes(sa, pts, {
        // N.B. we don't stack base with 'base',
        // so set tozero:true always!
        tozero: true,
        padded: true
      });
    }
  }
}
function sieveBars(sieve) {
  var calcTraces = sieve.traces;
  for (var i = 0; i < calcTraces.length; i++) {
    var calcTrace = calcTraces[i];
    for (var j = 0; j < calcTrace.length; j++) {
      var bar = calcTrace[j];
      if (bar.s !== BADNUM) {
        sieve.put(bar.p, bar.b + bar.s);
      }
    }
  }
}
function unhideBarsWithinTrace(sieve, pa) {
  var calcTraces = sieve.traces;
  for (var i = 0; i < calcTraces.length; i++) {
    var calcTrace = calcTraces[i];
    var fullTrace = calcTrace[0].trace;
    if (fullTrace.base === undefined) {
      var inTraceSieve = new Sieve([calcTrace], {
        posAxis: pa,
        sepNegVal: true,
        overlapNoMerge: true
      });
      for (var j = 0; j < calcTrace.length; j++) {
        var bar = calcTrace[j];
        if (bar.p !== BADNUM) {
          // stack current bar and get previous sum
          var base = inTraceSieve.put(bar.p, bar.b + bar.s);

          // if previous sum if non-zero, this means:
          // multiple bars have same starting point are potentially hidden,
          // shift them vertically so that all bars are visible by default
          if (base) bar.b = base;
        }
      }
    }
  }
}

// Note:
//
// normalizeBars requires that either sieveBars or stackBars has been
// previously invoked.
function normalizeBars(sa, sieve, opts) {
  var calcTraces = sieve.traces;
  var sLetter = getAxisLetter(sa);
  var sTop = opts.norm === 'fraction' ? 1 : 100;
  var sTiny = sTop / 1e9; // in case of rounding error in sum
  var sMin = sa.l2c(sa.c2l(0));
  var sMax = opts.mode === 'stack' ? sTop : sMin;
  function needsPadding(v) {
    return isNumeric(sa.c2l(v)) && (v < sMin - sTiny || v > sMax + sTiny || !isNumeric(sMin));
  }
  for (var i = 0; i < calcTraces.length; i++) {
    var calcTrace = calcTraces[i];
    var fullTrace = calcTrace[0].trace;
    var pts = [];
    var tozero = false;
    var padded = false;
    for (var j = 0; j < calcTrace.length; j++) {
      var bar = calcTrace[j];
      if (bar.s !== BADNUM) {
        var scale = Math.abs(sTop / sieve.get(bar.p, bar.s));
        bar.b *= scale;
        bar.s *= scale;
        var base = bar.b;
        var top = base + bar.s;
        bar[sLetter] = top;
        pts.push(top);
        padded = padded || needsPadding(top);
        if (bar.hasB) {
          pts.push(base);
          padded = padded || needsPadding(base);
        }
        if (!bar.hasB || !bar.b) {
          tozero = true;
        }
      }
    }
    fullTrace._extremes[sa._id] = Axes.findExtremes(sa, pts, {
      tozero: tozero,
      padded: padded
    });
  }
}

// Add an `_sMin` and `_sMax` value for each bar representing the min and max size value
// across all bars sharing the same position as that bar. These values are used for rounded
// bar corners, to carry rounding down to lower bars in the stack as needed.
function setHelperValuesForRoundedCorners(calcTraces, sMinByPos, sMaxByPos, pa) {
  var pLetter = getAxisLetter(pa);
  // Set `_sMin` and `_sMax` value for each bar
  for (var i = 0; i < calcTraces.length; i++) {
    var calcTrace = calcTraces[i];
    for (var j = 0; j < calcTrace.length; j++) {
      var bar = calcTrace[j];
      var pos = bar[pLetter];
      bar._sMin = sMinByPos[pos];
      bar._sMax = sMaxByPos[pos];
    }
  }
}

// find the full position span of bars at each position
// for use by hover, to ensure labels move in if bars are
// narrower than the space they're in.
// run once per trace group (subplot & direction) and
// the same mapping is attached to all calcdata traces
function collectExtents(calcTraces, pa) {
  var pLetter = getAxisLetter(pa);
  var extents = {};
  var i, j, cd;
  var pMin = Infinity;
  var pMax = -Infinity;
  for (i = 0; i < calcTraces.length; i++) {
    cd = calcTraces[i];
    for (j = 0; j < cd.length; j++) {
      var p = cd[j].p;
      if (isNumeric(p)) {
        pMin = Math.min(pMin, p);
        pMax = Math.max(pMax, p);
      }
    }
  }

  // this is just for positioning of hover labels, and nobody will care if
  // the label is 1px too far out; so round positions to 1/10K in case
  // position values don't exactly match from trace to trace
  var roundFactor = 10000 / (pMax - pMin);
  var round = extents.round = function (p) {
    return String(Math.round(roundFactor * (p - pMin)));
  };

  // Find min and max size axis extent for each position
  // This is used for rounded bar corners, to carry rounding
  // down to lower bars in the case of stacked bars
  var sMinByPos = {};
  var sMaxByPos = {};

  // Check whether any trace has rounded corners
  var anyTraceHasCornerradius = calcTraces.some(function (x) {
    var trace = x[0].trace;
    return 'marker' in trace && trace.marker.cornerradius;
  });
  for (i = 0; i < calcTraces.length; i++) {
    cd = calcTraces[i];
    cd[0].t.extents = extents;
    var poffset = cd[0].t.poffset;
    var poffsetIsArray = isArrayOrTypedArray(poffset);
    for (j = 0; j < cd.length; j++) {
      var di = cd[j];
      var p0 = di[pLetter] - di.w / 2;
      if (isNumeric(p0)) {
        var p1 = di[pLetter] + di.w / 2;
        var pVal = round(di.p);
        if (extents[pVal]) {
          extents[pVal] = [Math.min(p0, extents[pVal][0]), Math.max(p1, extents[pVal][1])];
        } else {
          extents[pVal] = [p0, p1];
        }
      }
      di.p0 = di.p + (poffsetIsArray ? poffset[j] : poffset);
      di.p1 = di.p0 + di.w;
      di.s0 = di.b;
      di.s1 = di.s0 + di.s;
      if (anyTraceHasCornerradius) {
        var sMin = Math.min(di.s0, di.s1) || 0;
        var sMax = Math.max(di.s0, di.s1) || 0;
        var pos = di[pLetter];
        sMinByPos[pos] = pos in sMinByPos ? Math.min(sMinByPos[pos], sMin) : sMin;
        sMaxByPos[pos] = pos in sMaxByPos ? Math.max(sMaxByPos[pos], sMax) : sMax;
      }
    }
  }
  if (anyTraceHasCornerradius) {
    setHelperValuesForRoundedCorners(calcTraces, sMinByPos, sMaxByPos, pa);
  }
}
function getAxisLetter(ax) {
  return ax._id.charAt(0);
}
module.exports = {
  crossTraceCalc: crossTraceCalc,
  setGroupPositions: setGroupPositions
};

/***/ }),

/***/ 17550:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isNumeric = __webpack_require__(10721);
var Lib = __webpack_require__(34809);
var Color = __webpack_require__(78766);
var Registry = __webpack_require__(33626);
var handleXYDefaults = __webpack_require__(99867);
var handlePeriodDefaults = __webpack_require__(99669);
var handleStyleDefaults = __webpack_require__(59760);
var handleGroupingDefaults = __webpack_require__(36301);
var attributes = __webpack_require__(81481);
var coerceFont = Lib.coerceFont;
function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
  function coerce(attr, dflt) {
    return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
  }
  var len = handleXYDefaults(traceIn, traceOut, layout, coerce);
  if (!len) {
    traceOut.visible = false;
    return;
  }
  handlePeriodDefaults(traceIn, traceOut, layout, coerce);
  coerce('xhoverformat');
  coerce('yhoverformat');
  coerce('zorder');
  coerce('orientation', traceOut.x && !traceOut.y ? 'h' : 'v');
  coerce('base');
  coerce('offset');
  coerce('width');
  coerce('text');
  coerce('hovertext');
  coerce('hovertemplate');
  var textposition = coerce('textposition');
  handleText(traceIn, traceOut, layout, coerce, textposition, {
    moduleHasSelected: true,
    moduleHasUnselected: true,
    moduleHasConstrain: true,
    moduleHasCliponaxis: true,
    moduleHasTextangle: true,
    moduleHasInsideanchor: true
  });
  handleStyleDefaults(traceIn, traceOut, coerce, defaultColor, layout);
  var lineColor = (traceOut.marker.line || {}).color;

  // override defaultColor for error bars with defaultLine
  var errorBarsSupplyDefaults = Registry.getComponentMethod('errorbars', 'supplyDefaults');
  errorBarsSupplyDefaults(traceIn, traceOut, lineColor || Color.defaultLine, {
    axis: 'y'
  });
  errorBarsSupplyDefaults(traceIn, traceOut, lineColor || Color.defaultLine, {
    axis: 'x',
    inherit: 'y'
  });
  Lib.coerceSelectionMarkerOpacity(traceOut, coerce);
}
function crossTraceDefaults(fullData, fullLayout) {
  var traceIn, traceOut;
  function coerce(attr, dflt) {
    return Lib.coerce(traceOut._input, traceOut, attributes, attr, dflt);
  }
  for (var i = 0; i < fullData.length; i++) {
    traceOut = fullData[i];
    if (traceOut.type === 'bar') {
      traceIn = traceOut._input;
      // `marker.cornerradius` needs to be coerced here rather than in handleStyleDefaults()
      // because it needs to happen after `layout.barcornerradius` has been coerced
      var r = coerce('marker.cornerradius', fullLayout.barcornerradius);
      if (traceOut.marker) {
        traceOut.marker.cornerradius = validateCornerradius(r);
      }
      if (fullLayout.barmode === 'group') {
        handleGroupingDefaults(traceIn, traceOut, fullLayout, coerce);
      }
    }
  }
}

// Returns a value equivalent to the given cornerradius value, if valid;
// otherwise returns`undefined`.
// Valid cornerradius values must be either:
//   - a numeric value (string or number) >= 0, or
//   - a string consisting of a number >= 0 followed by a % sign
// If the given cornerradius value is a numeric string, it will be converted
// to a number.
function validateCornerradius(r) {
  if (isNumeric(r)) {
    r = +r;
    if (r >= 0) return r;
  } else if (typeof r === 'string') {
    r = r.trim();
    if (r.slice(-1) === '%' && isNumeric(r.slice(0, -1))) {
      r = +r.slice(0, -1);
      if (r >= 0) return r + '%';
    }
  }
  return undefined;
}
function handleText(traceIn, traceOut, layout, coerce, textposition, opts) {
  opts = opts || {};
  var moduleHasSelected = !(opts.moduleHasSelected === false);
  var moduleHasUnselected = !(opts.moduleHasUnselected === false);
  var moduleHasConstrain = !(opts.moduleHasConstrain === false);
  var moduleHasCliponaxis = !(opts.moduleHasCliponaxis === false);
  var moduleHasTextangle = !(opts.moduleHasTextangle === false);
  var moduleHasInsideanchor = !(opts.moduleHasInsideanchor === false);
  var hasPathbar = !!opts.hasPathbar;
  var hasBoth = Array.isArray(textposition) || textposition === 'auto';
  var hasInside = hasBoth || textposition === 'inside';
  var hasOutside = hasBoth || textposition === 'outside';
  if (hasInside || hasOutside) {
    var dfltFont = coerceFont(coerce, 'textfont', layout.font);

    // Note that coercing `insidetextfont` is always needed –
    // even if `textposition` is `outside` for each trace – since
    // an outside label can become an inside one, for example because
    // of a bar being stacked on top of it.
    var insideTextFontDefault = Lib.extendFlat({}, dfltFont);
    var isTraceTextfontColorSet = traceIn.textfont && traceIn.textfont.color;
    var isColorInheritedFromLayoutFont = !isTraceTextfontColorSet;
    if (isColorInheritedFromLayoutFont) {
      delete insideTextFontDefault.color;
    }
    coerceFont(coerce, 'insidetextfont', insideTextFontDefault);
    if (hasPathbar) {
      var pathbarTextFontDefault = Lib.extendFlat({}, dfltFont);
      if (isColorInheritedFromLayoutFont) {
        delete pathbarTextFontDefault.color;
      }
      coerceFont(coerce, 'pathbar.textfont', pathbarTextFontDefault);
    }
    if (hasOutside) coerceFont(coerce, 'outsidetextfont', dfltFont);
    if (moduleHasSelected) coerce('selected.textfont.color');
    if (moduleHasUnselected) coerce('unselected.textfont.color');
    if (moduleHasConstrain) coerce('constraintext');
    if (moduleHasCliponaxis) coerce('cliponaxis');
    if (moduleHasTextangle) coerce('textangle');
    coerce('texttemplate');
  }
  if (hasInside) {
    if (moduleHasInsideanchor) coerce('insidetextanchor');
  }
}
module.exports = {
  supplyDefaults: supplyDefaults,
  crossTraceDefaults: crossTraceDefaults,
  handleText: handleText,
  validateCornerradius: validateCornerradius
};

/***/ }),

/***/ 59541:
/***/ (function(module) {

"use strict";


module.exports = function eventData(out, pt, trace) {
  // standard cartesian event data
  out.x = 'xVal' in pt ? pt.xVal : pt.x;
  out.y = 'yVal' in pt ? pt.yVal : pt.y;
  if (pt.xa) out.xaxis = pt.xa;
  if (pt.ya) out.yaxis = pt.ya;
  if (trace.orientation === 'h') {
    out.label = out.y;
    out.value = out.x;
  } else {
    out.label = out.x;
    out.value = out.y;
  }
  return out;
};

/***/ }),

/***/ 42843:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var isNumeric = __webpack_require__(10721);
var tinycolor = __webpack_require__(65657);
var isArrayOrTypedArray = (__webpack_require__(34809).isArrayOrTypedArray);
exports.coerceString = function (attributeDefinition, value, defaultValue) {
  if (typeof value === 'string') {
    if (value || !attributeDefinition.noBlank) return value;
  } else if (typeof value === 'number' || value === true) {
    if (!attributeDefinition.strict) return String(value);
  }
  return defaultValue !== undefined ? defaultValue : attributeDefinition.dflt;
};
exports.coerceNumber = function (attributeDefinition, value, defaultValue) {
  if (isNumeric(value)) {
    value = +value;
    var min = attributeDefinition.min;
    var max = attributeDefinition.max;
    var isOutOfBounds = min !== undefined && value < min || max !== undefined && value > max;
    if (!isOutOfBounds) return value;
  }
  return defaultValue !== undefined ? defaultValue : attributeDefinition.dflt;
};
exports.coerceColor = function (attributeDefinition, value, defaultValue) {
  if (tinycolor(value).isValid()) return value;
  return defaultValue !== undefined ? defaultValue : attributeDefinition.dflt;
};
exports.coerceEnumerated = function (attributeDefinition, value, defaultValue) {
  if (attributeDefinition.coerceNumber) value = +value;
  if (attributeDefinition.values.indexOf(value) !== -1) return value;
  return defaultValue !== undefined ? defaultValue : attributeDefinition.dflt;
};
exports.getValue = function (arrayOrScalar, index) {
  var value;
  if (!isArrayOrTypedArray(arrayOrScalar)) value = arrayOrScalar;else if (index < arrayOrScalar.length) value = arrayOrScalar[index];
  return value;
};
exports.getLineWidth = function (trace, di) {
  var w = 0 < di.mlw ? di.mlw : !isArrayOrTypedArray(trace.marker.line.width) ? trace.marker.line.width : 0;
  return w;
};

/***/ }),

/***/ 91664:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Fx = __webpack_require__(32141);
var Registry = __webpack_require__(33626);
var Color = __webpack_require__(78766);
var fillText = (__webpack_require__(34809).fillText);
var getLineWidth = (__webpack_require__(42843).getLineWidth);
var hoverLabelText = (__webpack_require__(29714).hoverLabelText);
var BADNUM = (__webpack_require__(63821).BADNUM);
function hoverPoints(pointData, xval, yval, hovermode, opts) {
  var barPointData = hoverOnBars(pointData, xval, yval, hovermode, opts);
  if (barPointData) {
    var cd = barPointData.cd;
    var trace = cd[0].trace;
    var di = cd[barPointData.index];
    barPointData.color = getTraceColor(trace, di);
    Registry.getComponentMethod('errorbars', 'hoverInfo')(di, trace, barPointData);
    return [barPointData];
  }
}
function hoverOnBars(pointData, xval, yval, hovermode, opts) {
  var cd = pointData.cd;
  var trace = cd[0].trace;
  var t = cd[0].t;
  var isClosest = hovermode === 'closest';
  var isWaterfall = trace.type === 'waterfall';
  var maxHoverDistance = pointData.maxHoverDistance;
  var maxSpikeDistance = pointData.maxSpikeDistance;
  var posVal, sizeVal, posLetter, sizeLetter, dx, dy, pRangeCalc;
  if (trace.orientation === 'h') {
    posVal = yval;
    sizeVal = xval;
    posLetter = 'y';
    sizeLetter = 'x';
    dx = sizeFn;
    dy = positionFn;
  } else {
    posVal = xval;
    sizeVal = yval;
    posLetter = 'x';
    sizeLetter = 'y';
    dy = sizeFn;
    dx = positionFn;
  }
  var period = trace[posLetter + 'period'];
  var isClosestOrPeriod = isClosest || period;
  function thisBarMinPos(di) {
    return thisBarExtPos(di, -1);
  }
  function thisBarMaxPos(di) {
    return thisBarExtPos(di, 1);
  }
  function thisBarExtPos(di, sgn) {
    var w = di.w;
    return di[posLetter] + sgn * w / 2;
  }
  function periodLength(di) {
    return di[posLetter + 'End'] - di[posLetter + 'Start'];
  }
  var minPos = isClosest ? thisBarMinPos : period ? function (di) {
    return di.p - periodLength(di) / 2;
  } : function (di) {
    /*
     * In compare mode, accept a bar if you're on it *or* its group.
     * Nearly always it's the group that matters, but in case the bar
     * was explicitly set wider than its group we'd better accept the
     * whole bar.
     *
     * use `bardelta` instead of `bargroupwidth` so we accept hover
     * in the gap. That way hover doesn't flash on and off as you
     * mouse over the plot in compare modes.
     * In 'closest' mode though the flashing seems inevitable,
     * without far more complex logic
     */
    return Math.min(thisBarMinPos(di), di.p - t.bardelta / 2);
  };
  var maxPos = isClosest ? thisBarMaxPos : period ? function (di) {
    return di.p + periodLength(di) / 2;
  } : function (di) {
    return Math.max(thisBarMaxPos(di), di.p + t.bardelta / 2);
  };
  function inbox(_minPos, _maxPos, maxDistance) {
    if (opts.finiteRange) maxDistance = 0;

    // add a little to the pseudo-distance for wider bars, so that like scatter,
    // if you are over two overlapping bars, the narrower one wins.
    return Fx.inbox(_minPos - posVal, _maxPos - posVal, maxDistance + Math.min(1, Math.abs(_maxPos - _minPos) / pRangeCalc) - 1);
  }
  function positionFn(di) {
    return inbox(minPos(di), maxPos(di), maxHoverDistance);
  }
  function thisBarPositionFn(di) {
    return inbox(thisBarMinPos(di), thisBarMaxPos(di), maxSpikeDistance);
  }
  function getSize(di) {
    var s = di[sizeLetter];
    if (isWaterfall) {
      var rawS = Math.abs(di.rawS) || 0;
      if (sizeVal > 0) {
        s += rawS;
      } else if (sizeVal < 0) {
        s -= rawS;
      }
    }
    return s;
  }
  function sizeFn(di) {
    var v = sizeVal;
    var b = di.b;
    var s = getSize(di);

    // add a gradient so hovering near the end of a
    // bar makes it a little closer match
    return Fx.inbox(b - v, s - v, maxHoverDistance + (s - v) / (s - b) - 1);
  }
  function thisBarSizeFn(di) {
    var v = sizeVal;
    var b = di.b;
    var s = getSize(di);

    // add a gradient so hovering near the end of a
    // bar makes it a little closer match
    return Fx.inbox(b - v, s - v, maxSpikeDistance + (s - v) / (s - b) - 1);
  }
  var pa = pointData[posLetter + 'a'];
  var sa = pointData[sizeLetter + 'a'];
  pRangeCalc = Math.abs(pa.r2c(pa.range[1]) - pa.r2c(pa.range[0]));
  function dxy(di) {
    return (dx(di) + dy(di)) / 2;
  }
  var distfn = Fx.getDistanceFunction(hovermode, dx, dy, dxy);
  Fx.getClosest(cd, distfn, pointData);

  // skip the rest (for this trace) if we didn't find a close point
  if (pointData.index === false) return;

  // skip points inside axis rangebreaks
  if (cd[pointData.index].p === BADNUM) return;

  // if we get here and we're not in 'closest' mode, push min/max pos back
  // onto the group - even though that means occasionally the mouse will be
  // over the hover label.
  if (!isClosestOrPeriod) {
    minPos = function (di) {
      return Math.min(thisBarMinPos(di), di.p - t.bargroupwidth / 2);
    };
    maxPos = function (di) {
      return Math.max(thisBarMaxPos(di), di.p + t.bargroupwidth / 2);
    };
  }

  // the closest data point
  var index = pointData.index;
  var di = cd[index];
  var size = trace.base ? di.b + di.s : di.s;
  pointData[sizeLetter + '0'] = pointData[sizeLetter + '1'] = sa.c2p(di[sizeLetter], true);
  pointData[sizeLetter + 'LabelVal'] = size;
  var extent = t.extents[t.extents.round(di.p)];
  pointData[posLetter + '0'] = pa.c2p(isClosest ? minPos(di) : extent[0], true);
  pointData[posLetter + '1'] = pa.c2p(isClosest ? maxPos(di) : extent[1], true);
  var hasPeriod = di.orig_p !== undefined;
  pointData[posLetter + 'LabelVal'] = hasPeriod ? di.orig_p : di.p;
  pointData.labelLabel = hoverLabelText(pa, pointData[posLetter + 'LabelVal'], trace[posLetter + 'hoverformat']);
  pointData.valueLabel = hoverLabelText(sa, pointData[sizeLetter + 'LabelVal'], trace[sizeLetter + 'hoverformat']);
  pointData.baseLabel = hoverLabelText(sa, di.b, trace[sizeLetter + 'hoverformat']);

  // spikelines always want "closest" distance regardless of hovermode
  pointData.spikeDistance = (thisBarSizeFn(di) + thisBarPositionFn(di)) / 2;
  // they also want to point to the data value, regardless of where the label goes
  // in case of bars shifted within groups
  pointData[posLetter + 'Spike'] = pa.c2p(di.p, true);
  fillText(di, trace, pointData);
  pointData.hovertemplate = trace.hovertemplate;
  return pointData;
}
function getTraceColor(trace, di) {
  var mc = di.mcc || trace.marker.color;
  var mlc = di.mlcc || trace.marker.line.color;
  var mlw = getLineWidth(trace, di);
  if (Color.opacity(mc)) return mc;else if (Color.opacity(mlc) && mlw) return mlc;
}
module.exports = {
  hoverPoints: hoverPoints,
  hoverOnBars: hoverOnBars,
  getTraceColor: getTraceColor
};

/***/ }),

/***/ 58218:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = {
  attributes: __webpack_require__(81481),
  layoutAttributes: __webpack_require__(25412),
  supplyDefaults: (__webpack_require__(17550).supplyDefaults),
  crossTraceDefaults: (__webpack_require__(17550).crossTraceDefaults),
  supplyLayoutDefaults: __webpack_require__(78931),
  calc: __webpack_require__(67565),
  crossTraceCalc: (__webpack_require__(24782).crossTraceCalc),
  colorbar: __webpack_require__(21146),
  arraysToCalcdata: __webpack_require__(35374),
  plot: (__webpack_require__(32995).plot),
  style: (__webpack_require__(6851).style),
  styleOnSelect: (__webpack_require__(6851).styleOnSelect),
  hoverPoints: (__webpack_require__(91664).hoverPoints),
  eventData: __webpack_require__(59541),
  selectPoints: __webpack_require__(88384),
  moduleType: 'trace',
  name: 'bar',
  basePlotModule: __webpack_require__(37703),
  categories: ['bar-like', 'cartesian', 'svg', 'bar', 'oriented', 'errorBarsOK', 'showLegend', 'zoomScale'],
  animatable: true,
  meta: {}
};

/***/ }),

/***/ 25412:
/***/ (function(module) {

"use strict";


module.exports = {
  barmode: {
    valType: 'enumerated',
    values: ['stack', 'group', 'overlay', 'relative'],
    dflt: 'group',
    editType: 'calc'
  },
  barnorm: {
    valType: 'enumerated',
    values: ['', 'fraction', 'percent'],
    dflt: '',
    editType: 'calc'
  },
  bargap: {
    valType: 'number',
    min: 0,
    max: 1,
    editType: 'calc'
  },
  bargroupgap: {
    valType: 'number',
    min: 0,
    max: 1,
    dflt: 0,
    editType: 'calc'
  },
  barcornerradius: {
    valType: 'any',
    editType: 'calc'
  }
};

/***/ }),

/***/ 78931:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Registry = __webpack_require__(33626);
var Axes = __webpack_require__(29714);
var Lib = __webpack_require__(34809);
var layoutAttributes = __webpack_require__(25412);
var validateCornerradius = (__webpack_require__(17550).validateCornerradius);
module.exports = function (layoutIn, layoutOut, fullData) {
  function coerce(attr, dflt) {
    return Lib.coerce(layoutIn, layoutOut, layoutAttributes, attr, dflt);
  }
  var hasBars = false;
  var shouldBeGapless = false;
  var gappedAnyway = false;
  var usedSubplots = {};
  var mode = coerce('barmode');
  for (var i = 0; i < fullData.length; i++) {
    var trace = fullData[i];
    if (Registry.traceIs(trace, 'bar') && trace.visible) hasBars = true;else continue;

    // if we have at least 2 grouped bar traces on the same subplot,
    // we should default to a gap anyway, even if the data is histograms
    if (mode === 'group') {
      var subploti = trace.xaxis + trace.yaxis;
      if (usedSubplots[subploti]) gappedAnyway = true;
      usedSubplots[subploti] = true;
    }
    if (trace.visible && trace.type === 'histogram') {
      var pa = Axes.getFromId({
        _fullLayout: layoutOut
      }, trace[trace.orientation === 'v' ? 'xaxis' : 'yaxis']);
      if (pa.type !== 'category') shouldBeGapless = true;
    }
  }
  if (!hasBars) {
    delete layoutOut.barmode;
    return;
  }
  if (mode !== 'overlay') coerce('barnorm');
  coerce('bargap', shouldBeGapless && !gappedAnyway ? 0 : 0.2);
  coerce('bargroupgap');
  var r = coerce('barcornerradius');
  layoutOut.barcornerradius = validateCornerradius(r);
};

/***/ }),

/***/ 32995:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var isNumeric = __webpack_require__(10721);
var Lib = __webpack_require__(34809);
var svgTextUtils = __webpack_require__(30635);
var Color = __webpack_require__(78766);
var Drawing = __webpack_require__(62203);
var Registry = __webpack_require__(33626);
var tickText = (__webpack_require__(29714).tickText);
var uniformText = __webpack_require__(84102);
var recordMinTextSize = uniformText.recordMinTextSize;
var clearMinTextSize = uniformText.clearMinTextSize;
var style = __webpack_require__(6851);
var helpers = __webpack_require__(42843);
var constants = __webpack_require__(56155);
var attributes = __webpack_require__(81481);
var attributeText = attributes.text;
var attributeTextPosition = attributes.textposition;
var appendArrayPointValue = (__webpack_require__(36040).appendArrayPointValue);
var TEXTPAD = constants.TEXTPAD;
function keyFunc(d) {
  return d.id;
}
function getKeyFunc(trace) {
  if (trace.ids) {
    return keyFunc;
  }
}

// Returns -1 if v < 0, 1 if v > 0, and 0 if v == 0
function sign(v) {
  return (v > 0) - (v < 0);
}

// Returns 1 if a < b and -1 otherwise
// (For the purposes of this module we don't care about the case where a == b)
function dirSign(a, b) {
  return a < b ? 1 : -1;
}
function getXY(di, xa, ya, isHorizontal) {
  var s = [];
  var p = [];
  var sAxis = isHorizontal ? xa : ya;
  var pAxis = isHorizontal ? ya : xa;
  s[0] = sAxis.c2p(di.s0, true);
  p[0] = pAxis.c2p(di.p0, true);
  s[1] = sAxis.c2p(di.s1, true);
  p[1] = pAxis.c2p(di.p1, true);
  return isHorizontal ? [s, p] : [p, s];
}
function transition(selection, fullLayout, opts, makeOnCompleteCallback) {
  if (!fullLayout.uniformtext.mode && hasTransition(opts)) {
    var onComplete;
    if (makeOnCompleteCallback) {
      onComplete = makeOnCompleteCallback();
    }
    return selection.transition().duration(opts.duration).ease(opts.easing).each('end', function () {
      onComplete && onComplete();
    }).each('interrupt', function () {
      onComplete && onComplete();
    });
  } else {
    return selection;
  }
}
function hasTransition(transitionOpts) {
  return transitionOpts && transitionOpts.duration > 0;
}
function plot(gd, plotinfo, cdModule, traceLayer, opts, makeOnCompleteCallback) {
  var xa = plotinfo.xaxis;
  var ya = plotinfo.yaxis;
  var fullLayout = gd._fullLayout;
  var isStatic = gd._context.staticPlot;
  if (!opts) {
    opts = {
      mode: fullLayout.barmode,
      norm: fullLayout.barmode,
      gap: fullLayout.bargap,
      groupgap: fullLayout.bargroupgap
    };

    // don't clear bar when this is called from waterfall or funnel
    clearMinTextSize('bar', fullLayout);
  }
  var bartraces = Lib.makeTraceGroups(traceLayer, cdModule, 'trace bars').each(function (cd) {
    var plotGroup = d3.select(this);
    var trace = cd[0].trace;
    var t = cd[0].t;
    var isWaterfall = trace.type === 'waterfall';
    var isFunnel = trace.type === 'funnel';
    var isHistogram = trace.type === 'histogram';
    var isBar = trace.type === 'bar';
    var shouldDisplayZeros = isBar || isFunnel;
    var adjustPixel = 0;
    if (isWaterfall && trace.connector.visible && trace.connector.mode === 'between') {
      adjustPixel = trace.connector.line.width / 2;
    }
    var isHorizontal = trace.orientation === 'h';
    var withTransition = hasTransition(opts);
    var pointGroup = Lib.ensureSingle(plotGroup, 'g', 'points');
    var keyFunc = getKeyFunc(trace);
    var bars = pointGroup.selectAll('g.point').data(Lib.identity, keyFunc);
    bars.enter().append('g').classed('point', true);
    bars.exit().remove();
    bars.each(function (di, i) {
      var bar = d3.select(this);

      // now display the bar
      // clipped xf/yf (2nd arg true): non-positive
      // log values go off-screen by plotwidth
      // so you see them continue if you drag the plot
      var xy = getXY(di, xa, ya, isHorizontal);
      var x0 = xy[0][0];
      var x1 = xy[0][1];
      var y0 = xy[1][0];
      var y1 = xy[1][1];

      // empty bars
      var isBlank = (isHorizontal ? x1 - x0 : y1 - y0) === 0;

      // display zeros if line.width > 0
      if (isBlank && shouldDisplayZeros && helpers.getLineWidth(trace, di)) {
        isBlank = false;
      }

      // skip nulls
      if (!isBlank) {
        isBlank = !isNumeric(x0) || !isNumeric(x1) || !isNumeric(y0) || !isNumeric(y1);
      }

      // record isBlank
      di.isBlank = isBlank;

      // for blank bars, ensure start and end positions are equal - important for smooth transitions
      if (isBlank) {
        if (isHorizontal) {
          x1 = x0;
        } else {
          y1 = y0;
        }
      }

      // in waterfall mode `between` we need to adjust bar end points to match the connector width
      if (adjustPixel && !isBlank) {
        if (isHorizontal) {
          x0 -= dirSign(x0, x1) * adjustPixel;
          x1 += dirSign(x0, x1) * adjustPixel;
        } else {
          y0 -= dirSign(y0, y1) * adjustPixel;
          y1 += dirSign(y0, y1) * adjustPixel;
        }
      }
      var lw;
      var mc;
      if (trace.type === 'waterfall') {
        if (!isBlank) {
          var cont = trace[di.dir].marker;
          lw = cont.line.width;
          mc = cont.color;
        }
      } else {
        lw = helpers.getLineWidth(trace, di);
        mc = di.mc || trace.marker.color;
      }
      function roundWithLine(v) {
        var offset = d3.round(lw / 2 % 1, 2);

        // if there are explicit gaps, don't round,
        // it can make the gaps look crappy
        return opts.gap === 0 && opts.groupgap === 0 ? d3.round(Math.round(v) - offset, 2) : v;
      }
      function expandToVisible(v, vc, hideZeroSpan) {
        if (hideZeroSpan && v === vc) {
          // should not expand zero span bars
          // when start and end positions are identical
          // i.e. for vertical when y0 === y1
          // and for horizontal when x0 === x1
          return v;
        }

        // if it's not in danger of disappearing entirely,
        // round more precisely
        return Math.abs(v - vc) >= 2 ? roundWithLine(v) :
        // but if it's very thin, expand it so it's
        // necessarily visible, even if it might overlap
        // its neighbor
        v > vc ? Math.ceil(v) : Math.floor(v);
      }
      var op = Color.opacity(mc);
      var fixpx = op < 1 || lw > 0.01 ? roundWithLine : expandToVisible;
      if (!gd._context.staticPlot) {
        // if bars are not fully opaque or they have a line
        // around them, round to integer pixels, mainly for
        // safari so we prevent overlaps from its expansive
        // pixelation. if the bars ARE fully opaque and have
        // no line, expand to a full pixel to make sure we
        // can see them
        x0 = fixpx(x0, x1, isHorizontal);
        x1 = fixpx(x1, x0, isHorizontal);
        y0 = fixpx(y0, y1, !isHorizontal);
        y1 = fixpx(y1, y0, !isHorizontal);
      }

      // Function to convert from size axis values to pixels
      var c2p = isHorizontal ? xa.c2p : ya.c2p;

      // Decide whether to use upper or lower bound of current bar stack
      // as reference point for rounding
      var outerBound;
      if (di.s0 > 0) {
        outerBound = di._sMax;
      } else if (di.s0 < 0) {
        outerBound = di._sMin;
      } else {
        outerBound = di.s1 > 0 ? di._sMax : di._sMin;
      }

      // Calculate corner radius of bar in pixels
      function calcCornerRadius(crValue, crForm) {
        if (!crValue) return 0;
        var barWidth = isHorizontal ? Math.abs(y1 - y0) : Math.abs(x1 - x0);
        var barLength = isHorizontal ? Math.abs(x1 - x0) : Math.abs(y1 - y0);
        var stackedBarTotalLength = fixpx(Math.abs(c2p(outerBound, true) - c2p(0, true)));
        var maxRadius = di.hasB ? Math.min(barWidth / 2, barLength / 2) : Math.min(barWidth / 2, stackedBarTotalLength);
        var crPx;
        if (crForm === '%') {
          // If radius is given as a % string, convert to number of pixels
          var crPercent = Math.min(50, crValue);
          crPx = barWidth * (crPercent / 100);
        } else {
          // Otherwise, it's already a number of pixels, use the given value
          crPx = crValue;
        }
        return fixpx(Math.max(Math.min(crPx, maxRadius), 0));
      }
      // Exclude anything which is not explicitly a bar or histogram chart from rounding
      var r = isBar || isHistogram ? calcCornerRadius(t.cornerradiusvalue, t.cornerradiusform) : 0;
      // Construct path string for bar
      var path, h;
      // Default rectangular path (used if no rounding)
      var rectanglePath = 'M' + x0 + ',' + y0 + 'V' + y1 + 'H' + x1 + 'V' + y0 + 'Z';
      var overhead = 0;
      if (r && di.s) {
        // Bar has cornerradius, and nonzero size
        // Check amount of 'overhead' (bars stacked above this one)
        // to see whether we need to round or not
        var refPoint = sign(di.s0) === 0 || sign(di.s) === sign(di.s0) ? di.s1 : di.s0;
        overhead = fixpx(!di.hasB ? Math.abs(c2p(outerBound, true) - c2p(refPoint, true)) : 0);
        if (overhead < r) {
          // Calculate parameters for rounded corners
          var xdir = dirSign(x0, x1);
          var ydir = dirSign(y0, y1);
          // Sweep direction for rounded corner arcs
          var cornersweep = xdir === -ydir ? 1 : 0;
          if (isHorizontal) {
            // Horizontal bars
            if (di.hasB) {
              // Floating base: Round 1st & 2nd, and 3rd & 4th corners
              path = 'M' + (x0 + r * xdir) + ',' + y0 + 'A ' + r + ',' + r + ' 0 0 ' + cornersweep + ' ' + x0 + ',' + (y0 + r * ydir) + 'V' + (y1 - r * ydir) + 'A ' + r + ',' + r + ' 0 0 ' + cornersweep + ' ' + (x0 + r * xdir) + ',' + y1 + 'H' + (x1 - r * xdir) + 'A ' + r + ',' + r + ' 0 0 ' + cornersweep + ' ' + x1 + ',' + (y1 - r * ydir) + 'V' + (y0 + r * ydir) + 'A ' + r + ',' + r + ' 0 0 ' + cornersweep + ' ' + (x1 - r * xdir) + ',' + y0 + 'Z';
            } else {
              // Base on axis: Round 3rd and 4th corners

              // Helper variables to help with extending rounding down to lower bars
              h = Math.abs(x1 - x0) + overhead;
              var dy1 = h < r ? r - Math.sqrt(h * (2 * r - h)) : 0;
              var dy2 = overhead > 0 ? Math.sqrt(overhead * (2 * r - overhead)) : 0;
              var xminfunc = xdir > 0 ? Math.max : Math.min;
              path = 'M' + x0 + ',' + y0 + 'V' + (y1 - dy1 * ydir) + 'H' + xminfunc(x1 - (r - overhead) * xdir, x0) + 'A ' + r + ',' + r + ' 0 0 ' + cornersweep + ' ' + x1 + ',' + (y1 - r * ydir - dy2) + 'V' + (y0 + r * ydir + dy2) + 'A ' + r + ',' + r + ' 0 0 ' + cornersweep + ' ' + xminfunc(x1 - (r - overhead) * xdir, x0) + ',' + (y0 + dy1 * ydir) + 'Z';
            }
          } else {
            // Vertical bars
            if (di.hasB) {
              // Floating base: Round 1st & 4th, and 2nd & 3rd corners
              path = 'M' + (x0 + r * xdir) + ',' + y0 + 'A ' + r + ',' + r + ' 0 0 ' + cornersweep + ' ' + x0 + ',' + (y0 + r * ydir) + 'V' + (y1 - r * ydir) + 'A ' + r + ',' + r + ' 0 0 ' + cornersweep + ' ' + (x0 + r * xdir) + ',' + y1 + 'H' + (x1 - r * xdir) + 'A ' + r + ',' + r + ' 0 0 ' + cornersweep + ' ' + x1 + ',' + (y1 - r * ydir) + 'V' + (y0 + r * ydir) + 'A ' + r + ',' + r + ' 0 0 ' + cornersweep + ' ' + (x1 - r * xdir) + ',' + y0 + 'Z';
            } else {
              // Base on axis: Round 2nd and 3rd corners

              // Helper variables to help with extending rounding down to lower bars
              h = Math.abs(y1 - y0) + overhead;
              var dx1 = h < r ? r - Math.sqrt(h * (2 * r - h)) : 0;
              var dx2 = overhead > 0 ? Math.sqrt(overhead * (2 * r - overhead)) : 0;
              var yminfunc = ydir > 0 ? Math.max : Math.min;
              path = 'M' + (x0 + dx1 * xdir) + ',' + y0 + 'V' + yminfunc(y1 - (r - overhead) * ydir, y0) + 'A ' + r + ',' + r + ' 0 0 ' + cornersweep + ' ' + (x0 + r * xdir - dx2) + ',' + y1 + 'H' + (x1 - r * xdir + dx2) + 'A ' + r + ',' + r + ' 0 0 ' + cornersweep + ' ' + (x1 - dx1 * xdir) + ',' + yminfunc(y1 - (r - overhead) * ydir, y0) + 'V' + y0 + 'Z';
            }
          }
        } else {
          // There is a cornerradius, but bar is too far down the stack to be rounded; just draw a rectangle
          path = rectanglePath;
        }
      } else {
        // No cornerradius, just draw a rectangle
        path = rectanglePath;
      }
      var sel = transition(Lib.ensureSingle(bar, 'path'), fullLayout, opts, makeOnCompleteCallback);
      sel.style('vector-effect', isStatic ? 'none' : 'non-scaling-stroke').attr('d', isNaN((x1 - x0) * (y1 - y0)) || isBlank && gd._context.staticPlot ? 'M0,0Z' : path).call(Drawing.setClipUrl, plotinfo.layerClipId, gd);
      if (!fullLayout.uniformtext.mode && withTransition) {
        var styleFns = Drawing.makePointStyleFns(trace);
        Drawing.singlePointStyle(di, sel, trace, styleFns, gd);
      }
      appendBarText(gd, plotinfo, bar, cd, i, x0, x1, y0, y1, r, overhead, opts, makeOnCompleteCallback);
      if (plotinfo.layerClipId) {
        Drawing.hideOutsideRangePoint(di, bar.select('text'), xa, ya, trace.xcalendar, trace.ycalendar);
      }
    });

    // lastly, clip points groups of `cliponaxis !== false` traces
    // on `plotinfo._hasClipOnAxisFalse === true` subplots
    var hasClipOnAxisFalse = trace.cliponaxis === false;
    Drawing.setClipUrl(plotGroup, hasClipOnAxisFalse ? null : plotinfo.layerClipId, gd);
  });

  // error bars are on the top
  Registry.getComponentMethod('errorbars', 'plot')(gd, bartraces, plotinfo, opts);
}
function appendBarText(gd, plotinfo, bar, cd, i, x0, x1, y0, y1, r, overhead, opts, makeOnCompleteCallback) {
  var xa = plotinfo.xaxis;
  var ya = plotinfo.yaxis;
  var fullLayout = gd._fullLayout;
  var textPosition;
  function appendTextNode(bar, text, font) {
    var textSelection = Lib.ensureSingle(bar, 'text').text(text).attr({
      class: 'bartext bartext-' + textPosition,
      'text-anchor': 'middle',
      // prohibit tex interpretation until we can handle
      // tex and regular text together
      'data-notex': 1
    }).call(Drawing.font, font).call(svgTextUtils.convertToTspans, gd);
    return textSelection;
  }

  // get trace attributes
  var trace = cd[0].trace;
  var isHorizontal = trace.orientation === 'h';
  var text = getText(fullLayout, cd, i, xa, ya);
  textPosition = getTextPosition(trace, i);

  // compute text position
  var inStackOrRelativeMode = opts.mode === 'stack' || opts.mode === 'relative';
  var calcBar = cd[i];
  var isOutmostBar = !inStackOrRelativeMode || calcBar._outmost;
  var hasB = calcBar.hasB;
  var barIsRounded = r && r - overhead > TEXTPAD;
  if (!text || textPosition === 'none' || (calcBar.isBlank || x0 === x1 || y0 === y1) && (textPosition === 'auto' || textPosition === 'inside')) {
    bar.select('text').remove();
    return;
  }
  var layoutFont = fullLayout.font;
  var barColor = style.getBarColor(cd[i], trace);
  var insideTextFont = style.getInsideTextFont(trace, i, layoutFont, barColor);
  var outsideTextFont = style.getOutsideTextFont(trace, i, layoutFont);
  var insidetextanchor = trace.insidetextanchor || 'end';

  // Special case: don't use the c2p(v, true) value on log size axes,
  // so that we can get correctly inside text scaling
  var di = bar.datum();
  if (isHorizontal) {
    if (xa.type === 'log' && di.s0 <= 0) {
      if (xa.range[0] < xa.range[1]) {
        x0 = 0;
      } else {
        x0 = xa._length;
      }
    }
  } else {
    if (ya.type === 'log' && di.s0 <= 0) {
      if (ya.range[0] < ya.range[1]) {
        y0 = ya._length;
      } else {
        y0 = 0;
      }
    }
  }

  // Compute width and height of bar
  var lx = Math.abs(x1 - x0);
  var ly = Math.abs(y1 - y0);

  // padding excluded
  var barWidth = lx - 2 * TEXTPAD;
  var barHeight = ly - 2 * TEXTPAD;
  var textSelection;
  var textBB;
  var textWidth;
  var textHeight;
  var font;
  if (textPosition === 'outside') {
    if (!isOutmostBar && !calcBar.hasB) textPosition = 'inside';
  }
  if (textPosition === 'auto') {
    if (isOutmostBar) {
      // draw text using insideTextFont and check if it fits inside bar
      textPosition = 'inside';
      font = Lib.ensureUniformFontSize(gd, insideTextFont);
      textSelection = appendTextNode(bar, text, font);
      textBB = Drawing.bBox(textSelection.node());
      textWidth = textBB.width;
      textHeight = textBB.height;
      var textHasSize = textWidth > 0 && textHeight > 0;
      var fitsInside;
      if (barIsRounded) {
        // If bar is rounded, check if text fits between rounded corners
        if (hasB) {
          fitsInside = textfitsInsideBar(barWidth - 2 * r, barHeight, textWidth, textHeight, isHorizontal) || textfitsInsideBar(barWidth, barHeight - 2 * r, textWidth, textHeight, isHorizontal);
        } else if (isHorizontal) {
          fitsInside = textfitsInsideBar(barWidth - (r - overhead), barHeight, textWidth, textHeight, isHorizontal) || textfitsInsideBar(barWidth, barHeight - 2 * (r - overhead), textWidth, textHeight, isHorizontal);
        } else {
          fitsInside = textfitsInsideBar(barWidth, barHeight - (r - overhead), textWidth, textHeight, isHorizontal) || textfitsInsideBar(barWidth - 2 * (r - overhead), barHeight, textWidth, textHeight, isHorizontal);
        }
      } else {
        fitsInside = textfitsInsideBar(barWidth, barHeight, textWidth, textHeight, isHorizontal);
      }
      if (textHasSize && fitsInside) {
        textPosition = 'inside';
      } else {
        textPosition = 'outside';
        textSelection.remove();
        textSelection = null;
      }
    } else {
      textPosition = 'inside';
    }
  }
  if (!textSelection) {
    font = Lib.ensureUniformFontSize(gd, textPosition === 'outside' ? outsideTextFont : insideTextFont);
    textSelection = appendTextNode(bar, text, font);
    var currentTransform = textSelection.attr('transform');
    textSelection.attr('transform', '');
    textBB = Drawing.bBox(textSelection.node()), textWidth = textBB.width, textHeight = textBB.height;
    textSelection.attr('transform', currentTransform);
    if (textWidth <= 0 || textHeight <= 0) {
      textSelection.remove();
      return;
    }
  }
  var angle = trace.textangle;

  // compute text transform
  var transform, constrained;
  if (textPosition === 'outside') {
    constrained = trace.constraintext === 'both' || trace.constraintext === 'outside';
    transform = toMoveOutsideBar(x0, x1, y0, y1, textBB, {
      isHorizontal: isHorizontal,
      constrained: constrained,
      angle: angle
    });
  } else {
    constrained = trace.constraintext === 'both' || trace.constraintext === 'inside';
    transform = toMoveInsideBar(x0, x1, y0, y1, textBB, {
      isHorizontal: isHorizontal,
      constrained: constrained,
      angle: angle,
      anchor: insidetextanchor,
      hasB: hasB,
      r: r,
      overhead: overhead
    });
  }
  transform.fontSize = font.size;
  recordMinTextSize(trace.type === 'histogram' ? 'bar' : trace.type, transform, fullLayout);
  calcBar.transform = transform;
  var s = transition(textSelection, fullLayout, opts, makeOnCompleteCallback);
  Lib.setTransormAndDisplay(s, transform);
}
function textfitsInsideBar(barWidth, barHeight, textWidth, textHeight, isHorizontal) {
  if (barWidth < 0 || barHeight < 0) return false;
  var fitsInside = textWidth <= barWidth && textHeight <= barHeight;
  var fitsInsideIfRotated = textWidth <= barHeight && textHeight <= barWidth;
  var fitsInsideIfShrunk = isHorizontal ? barWidth >= textWidth * (barHeight / textHeight) : barHeight >= textHeight * (barWidth / textWidth);
  return fitsInside || fitsInsideIfRotated || fitsInsideIfShrunk;
}
function getRotateFromAngle(angle) {
  return angle === 'auto' ? 0 : angle;
}
function getRotatedTextSize(textBB, rotate) {
  var a = Math.PI / 180 * rotate;
  var absSin = Math.abs(Math.sin(a));
  var absCos = Math.abs(Math.cos(a));
  return {
    x: textBB.width * absCos + textBB.height * absSin,
    y: textBB.width * absSin + textBB.height * absCos
  };
}
function toMoveInsideBar(x0, x1, y0, y1, textBB, opts) {
  var isHorizontal = !!opts.isHorizontal;
  var constrained = !!opts.constrained;
  var angle = opts.angle || 0;
  var anchor = opts.anchor;
  var isEnd = anchor === 'end';
  var isStart = anchor === 'start';
  var leftToRight = opts.leftToRight || 0; // left: -1, center: 0, right: 1
  var toRight = (leftToRight + 1) / 2;
  var toLeft = 1 - toRight;
  var hasB = opts.hasB;
  var r = opts.r;
  var overhead = opts.overhead;
  var textWidth = textBB.width;
  var textHeight = textBB.height;
  var lx = Math.abs(x1 - x0);
  var ly = Math.abs(y1 - y0);

  // compute remaining space
  var textpad = lx > 2 * TEXTPAD && ly > 2 * TEXTPAD ? TEXTPAD : 0;
  lx -= 2 * textpad;
  ly -= 2 * textpad;
  var rotate = getRotateFromAngle(angle);
  if (angle === 'auto' && !(textWidth <= lx && textHeight <= ly) && (textWidth > lx || textHeight > ly) && (!(textWidth > ly || textHeight > lx) || textWidth < textHeight !== lx < ly)) {
    rotate += 90;
  }
  var t = getRotatedTextSize(textBB, rotate);
  var scale, padForRounding;
  // Scale text for rounded bars
  if (r && r - overhead > TEXTPAD) {
    var scaleAndPad = scaleTextForRoundedBar(x0, x1, y0, y1, t, r, overhead, isHorizontal, hasB);
    scale = scaleAndPad.scale;
    padForRounding = scaleAndPad.pad;
    // Scale text for non-rounded bars
  } else {
    scale = 1;
    if (constrained) {
      scale = Math.min(1, lx / t.x, ly / t.y);
    }
    padForRounding = 0;
  }

  // compute text and target positions
  var textX = textBB.left * toLeft + textBB.right * toRight;
  var textY = (textBB.top + textBB.bottom) / 2;
  var targetX = (x0 + TEXTPAD) * toLeft + (x1 - TEXTPAD) * toRight;
  var targetY = (y0 + y1) / 2;
  var anchorX = 0;
  var anchorY = 0;
  if (isStart || isEnd) {
    var extrapad = (isHorizontal ? t.x : t.y) / 2;
    if (r && (isEnd || hasB)) {
      textpad += padForRounding;
    }
    var dir = isHorizontal ? dirSign(x0, x1) : dirSign(y0, y1);
    if (isHorizontal) {
      if (isStart) {
        targetX = x0 + dir * textpad;
        anchorX = -dir * extrapad;
      } else {
        targetX = x1 - dir * textpad;
        anchorX = dir * extrapad;
      }
    } else {
      if (isStart) {
        targetY = y0 + dir * textpad;
        anchorY = -dir * extrapad;
      } else {
        targetY = y1 - dir * textpad;
        anchorY = dir * extrapad;
      }
    }
  }
  return {
    textX: textX,
    textY: textY,
    targetX: targetX,
    targetY: targetY,
    anchorX: anchorX,
    anchorY: anchorY,
    scale: scale,
    rotate: rotate
  };
}
function scaleTextForRoundedBar(x0, x1, y0, y1, t, r, overhead, isHorizontal, hasB) {
  var barWidth = Math.max(0, Math.abs(x1 - x0) - 2 * TEXTPAD);
  var barHeight = Math.max(0, Math.abs(y1 - y0) - 2 * TEXTPAD);
  var R = r - TEXTPAD;
  var clippedR = overhead ? R - Math.sqrt(R * R - (R - overhead) * (R - overhead)) : R;
  var rX = hasB ? R * 2 : isHorizontal ? R - overhead : 2 * clippedR;
  var rY = hasB ? R * 2 : isHorizontal ? 2 * clippedR : R - overhead;
  var a, b, c;
  var scale, pad;
  if (t.y / t.x >= barHeight / (barWidth - rX)) {
    // Case 1 (Tall text)
    scale = barHeight / t.y;
  } else if (t.y / t.x <= (barHeight - rY) / barWidth) {
    // Case 2 (Wide text)
    scale = barWidth / t.x;
  } else if (!hasB && isHorizontal) {
    // Case 3a (Quadratic case, two side corners are rounded)
    a = t.x * t.x + t.y * t.y / 4;
    b = -2 * t.x * (barWidth - R) - t.y * (barHeight / 2 - R);
    c = (barWidth - R) * (barWidth - R) + (barHeight / 2 - R) * (barHeight / 2 - R) - R * R;
    scale = (-b + Math.sqrt(b * b - 4 * a * c)) / (2 * a);
  } else if (!hasB) {
    // Case 3b (Quadratic case, two top/bottom corners are rounded)
    a = t.x * t.x / 4 + t.y * t.y;
    b = -t.x * (barWidth / 2 - R) - 2 * t.y * (barHeight - R);
    c = (barWidth / 2 - R) * (barWidth / 2 - R) + (barHeight - R) * (barHeight - R) - R * R;
    scale = (-b + Math.sqrt(b * b - 4 * a * c)) / (2 * a);
  } else {
    // Case 4 (Quadratic case, all four corners are rounded)
    a = (t.x * t.x + t.y * t.y) / 4;
    b = -t.x * (barWidth / 2 - R) - t.y * (barHeight / 2 - R);
    c = (barWidth / 2 - R) * (barWidth / 2 - R) + (barHeight / 2 - R) * (barHeight / 2 - R) - R * R;
    scale = (-b + Math.sqrt(b * b - 4 * a * c)) / (2 * a);
  }

  // Scale should not be larger than 1
  scale = Math.min(1, scale);
  if (isHorizontal) {
    pad = Math.max(0, R - Math.sqrt(Math.max(0, R * R - (R - (barHeight - t.y * scale) / 2) * (R - (barHeight - t.y * scale) / 2))) - overhead);
  } else {
    pad = Math.max(0, R - Math.sqrt(Math.max(0, R * R - (R - (barWidth - t.x * scale) / 2) * (R - (barWidth - t.x * scale) / 2))) - overhead);
  }
  return {
    scale: scale,
    pad: pad
  };
}
function toMoveOutsideBar(x0, x1, y0, y1, textBB, opts) {
  var isHorizontal = !!opts.isHorizontal;
  var constrained = !!opts.constrained;
  var angle = opts.angle || 0;
  var textWidth = textBB.width;
  var textHeight = textBB.height;
  var lx = Math.abs(x1 - x0);
  var ly = Math.abs(y1 - y0);
  var textpad;
  // Keep the padding so the text doesn't sit right against
  // the bars, but don't factor it into barWidth
  if (isHorizontal) {
    textpad = ly > 2 * TEXTPAD ? TEXTPAD : 0;
  } else {
    textpad = lx > 2 * TEXTPAD ? TEXTPAD : 0;
  }

  // compute rotate and scale
  var scale = 1;
  if (constrained) {
    scale = isHorizontal ? Math.min(1, ly / textHeight) : Math.min(1, lx / textWidth);
  }
  var rotate = getRotateFromAngle(angle);
  var t = getRotatedTextSize(textBB, rotate);

  // compute text and target positions
  var extrapad = (isHorizontal ? t.x : t.y) / 2;
  var textX = (textBB.left + textBB.right) / 2;
  var textY = (textBB.top + textBB.bottom) / 2;
  var targetX = (x0 + x1) / 2;
  var targetY = (y0 + y1) / 2;
  var anchorX = 0;
  var anchorY = 0;
  var dir = isHorizontal ? dirSign(x1, x0) : dirSign(y0, y1);
  if (isHorizontal) {
    targetX = x1 - dir * textpad;
    anchorX = dir * extrapad;
  } else {
    targetY = y1 + dir * textpad;
    anchorY = -dir * extrapad;
  }
  return {
    textX: textX,
    textY: textY,
    targetX: targetX,
    targetY: targetY,
    anchorX: anchorX,
    anchorY: anchorY,
    scale: scale,
    rotate: rotate
  };
}
function getText(fullLayout, cd, index, xa, ya) {
  var trace = cd[0].trace;
  var texttemplate = trace.texttemplate;
  var value;
  if (texttemplate) {
    value = calcTexttemplate(fullLayout, cd, index, xa, ya);
  } else if (trace.textinfo) {
    value = calcTextinfo(cd, index, xa, ya);
  } else {
    value = helpers.getValue(trace.text, index);
  }
  return helpers.coerceString(attributeText, value);
}
function getTextPosition(trace, index) {
  var value = helpers.getValue(trace.textposition, index);
  return helpers.coerceEnumerated(attributeTextPosition, value);
}
function calcTexttemplate(fullLayout, cd, index, xa, ya) {
  var trace = cd[0].trace;
  var texttemplate = Lib.castOption(trace, index, 'texttemplate');
  if (!texttemplate) return '';
  var isHistogram = trace.type === 'histogram';
  var isWaterfall = trace.type === 'waterfall';
  var isFunnel = trace.type === 'funnel';
  var isHorizontal = trace.orientation === 'h';
  var pLetter, pAxis;
  var vLetter, vAxis;
  if (isHorizontal) {
    pLetter = 'y';
    pAxis = ya;
    vLetter = 'x';
    vAxis = xa;
  } else {
    pLetter = 'x';
    pAxis = xa;
    vLetter = 'y';
    vAxis = ya;
  }
  function formatLabel(u) {
    return tickText(pAxis, pAxis.c2l(u), true).text;
  }
  function formatNumber(v) {
    return tickText(vAxis, vAxis.c2l(v), true).text;
  }
  var cdi = cd[index];
  var obj = {};
  obj.label = cdi.p;
  obj.labelLabel = obj[pLetter + 'Label'] = formatLabel(cdi.p);
  var tx = Lib.castOption(trace, cdi.i, 'text');
  if (tx === 0 || tx) obj.text = tx;
  obj.value = cdi.s;
  obj.valueLabel = obj[vLetter + 'Label'] = formatNumber(cdi.s);
  var pt = {};
  appendArrayPointValue(pt, trace, cdi.i);
  if (isHistogram || pt.x === undefined) pt.x = isHorizontal ? obj.value : obj.label;
  if (isHistogram || pt.y === undefined) pt.y = isHorizontal ? obj.label : obj.value;
  if (isHistogram || pt.xLabel === undefined) pt.xLabel = isHorizontal ? obj.valueLabel : obj.labelLabel;
  if (isHistogram || pt.yLabel === undefined) pt.yLabel = isHorizontal ? obj.labelLabel : obj.valueLabel;
  if (isWaterfall) {
    obj.delta = +cdi.rawS || cdi.s;
    obj.deltaLabel = formatNumber(obj.delta);
    obj.final = cdi.v;
    obj.finalLabel = formatNumber(obj.final);
    obj.initial = obj.final - obj.delta;
    obj.initialLabel = formatNumber(obj.initial);
  }
  if (isFunnel) {
    obj.value = cdi.s;
    obj.valueLabel = formatNumber(obj.value);
    obj.percentInitial = cdi.begR;
    obj.percentInitialLabel = Lib.formatPercent(cdi.begR);
    obj.percentPrevious = cdi.difR;
    obj.percentPreviousLabel = Lib.formatPercent(cdi.difR);
    obj.percentTotal = cdi.sumR;
    obj.percenTotalLabel = Lib.formatPercent(cdi.sumR);
  }
  var customdata = Lib.castOption(trace, cdi.i, 'customdata');
  if (customdata) obj.customdata = customdata;
  return Lib.texttemplateString(texttemplate, obj, fullLayout._d3locale, pt, obj, trace._meta || {});
}
function calcTextinfo(cd, index, xa, ya) {
  var trace = cd[0].trace;
  var isHorizontal = trace.orientation === 'h';
  var isWaterfall = trace.type === 'waterfall';
  var isFunnel = trace.type === 'funnel';
  function formatLabel(u) {
    var pAxis = isHorizontal ? ya : xa;
    return tickText(pAxis, u, true).text;
  }
  function formatNumber(v) {
    var sAxis = isHorizontal ? xa : ya;
    return tickText(sAxis, +v, true).text;
  }
  var textinfo = trace.textinfo;
  var cdi = cd[index];
  var parts = textinfo.split('+');
  var text = [];
  var tx;
  var hasFlag = function (flag) {
    return parts.indexOf(flag) !== -1;
  };
  if (hasFlag('label')) {
    text.push(formatLabel(cd[index].p));
  }
  if (hasFlag('text')) {
    tx = Lib.castOption(trace, cdi.i, 'text');
    if (tx === 0 || tx) text.push(tx);
  }
  if (isWaterfall) {
    var delta = +cdi.rawS || cdi.s;
    var final = cdi.v;
    var initial = final - delta;
    if (hasFlag('initial')) text.push(formatNumber(initial));
    if (hasFlag('delta')) text.push(formatNumber(delta));
    if (hasFlag('final')) text.push(formatNumber(final));
  }
  if (isFunnel) {
    if (hasFlag('value')) text.push(formatNumber(cdi.s));
    var nPercent = 0;
    if (hasFlag('percent initial')) nPercent++;
    if (hasFlag('percent previous')) nPercent++;
    if (hasFlag('percent total')) nPercent++;
    var hasMultiplePercents = nPercent > 1;
    if (hasFlag('percent initial')) {
      tx = Lib.formatPercent(cdi.begR);
      if (hasMultiplePercents) tx += ' of initial';
      text.push(tx);
    }
    if (hasFlag('percent previous')) {
      tx = Lib.formatPercent(cdi.difR);
      if (hasMultiplePercents) tx += ' of previous';
      text.push(tx);
    }
    if (hasFlag('percent total')) {
      tx = Lib.formatPercent(cdi.sumR);
      if (hasMultiplePercents) tx += ' of total';
      text.push(tx);
    }
  }
  return text.join('<br>');
}
module.exports = {
  plot: plot,
  toMoveInsideBar: toMoveInsideBar
};

/***/ }),

/***/ 88384:
/***/ (function(module) {

"use strict";


module.exports = function selectPoints(searchInfo, selectionTester) {
  var cd = searchInfo.cd;
  var xa = searchInfo.xaxis;
  var ya = searchInfo.yaxis;
  var trace = cd[0].trace;
  var isFunnel = trace.type === 'funnel';
  var isHorizontal = trace.orientation === 'h';
  var selection = [];
  var i;
  if (selectionTester === false) {
    // clear selection
    for (i = 0; i < cd.length; i++) {
      cd[i].selected = 0;
    }
  } else {
    for (i = 0; i < cd.length; i++) {
      var di = cd[i];
      var ct = 'ct' in di ? di.ct : getCentroid(di, xa, ya, isHorizontal, isFunnel);
      if (selectionTester.contains(ct, false, i, searchInfo)) {
        selection.push({
          pointNumber: i,
          x: xa.c2d(di.x),
          y: ya.c2d(di.y)
        });
        di.selected = 1;
      } else {
        di.selected = 0;
      }
    }
  }
  return selection;
};
function getCentroid(d, xa, ya, isHorizontal, isFunnel) {
  var x0 = xa.c2p(isHorizontal ? d.s0 : d.p0, true);
  var x1 = xa.c2p(isHorizontal ? d.s1 : d.p1, true);
  var y0 = ya.c2p(isHorizontal ? d.p0 : d.s0, true);
  var y1 = ya.c2p(isHorizontal ? d.p1 : d.s1, true);
  if (isFunnel) {
    return [(x0 + x1) / 2, (y0 + y1) / 2];
  } else {
    if (isHorizontal) {
      return [x1, (y0 + y1) / 2];
    } else {
      return [(x0 + x1) / 2, y1];
    }
  }
}

/***/ }),

/***/ 2880:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = Sieve;
var distinctVals = (__webpack_require__(34809).distinctVals);

/**
 * Helper class to sieve data from traces into bins
 *
 * @class
 *
 * @param {Array} traces
*   Array of calculated traces
 * @param {object} opts
 *  - @param {boolean} [sepNegVal]
 *      If true, then split data at the same position into a bar
 *      for positive values and another for negative values
 *  - @param {boolean} [overlapNoMerge]
 *     If true, then don't merge overlapping bars into a single bar
 */
function Sieve(traces, opts) {
  this.traces = traces;
  this.sepNegVal = opts.sepNegVal;
  this.overlapNoMerge = opts.overlapNoMerge;

  // for single-bin histograms - see histogram/calc
  var width1 = Infinity;
  var axLetter = opts.posAxis._id.charAt(0);
  var positions = [];
  for (var i = 0; i < traces.length; i++) {
    var trace = traces[i];
    for (var j = 0; j < trace.length; j++) {
      var bar = trace[j];
      var pos = bar.p;
      if (pos === undefined) {
        pos = bar[axLetter];
      }
      if (pos !== undefined) positions.push(pos);
    }
    if (trace[0] && trace[0].width1) {
      width1 = Math.min(trace[0].width1, width1);
    }
  }
  this.positions = positions;
  var dv = distinctVals(positions);
  this.distinctPositions = dv.vals;
  if (dv.vals.length === 1 && width1 !== Infinity) this.minDiff = width1;else this.minDiff = Math.min(dv.minDiff, width1);
  var type = (opts.posAxis || {}).type;
  if (type === 'category' || type === 'multicategory') {
    this.minDiff = 1;
  }
  this.binWidth = this.minDiff;
  this.bins = {};
}

/**
 * Sieve datum
 *
 * @method
 * @param {number} position
 * @param {number} value
 * @returns {number} Previous bin value
 */
Sieve.prototype.put = function put(position, value) {
  var label = this.getLabel(position, value);
  var oldValue = this.bins[label] || 0;
  this.bins[label] = oldValue + value;
  return oldValue;
};

/**
 * Get current bin value for a given datum
 *
 * @method
 * @param {number} position  Position of datum
 * @param {number} [value]   Value of datum
 *                           (required if this.sepNegVal is true)
 * @returns {number} Current bin value
 */
Sieve.prototype.get = function get(position, value) {
  var label = this.getLabel(position, value);
  return this.bins[label] || 0;
};

/**
 * Get bin label for a given datum
 *
 * @method
 * @param {number} position  Position of datum
 * @param {number} [value]   Value of datum
 *                           (required if this.sepNegVal is true)
 * @returns {string} Bin label
 * (prefixed with a 'v' if value is negative and this.sepNegVal is
 * true; otherwise prefixed with '^')
 */
Sieve.prototype.getLabel = function getLabel(position, value) {
  var prefix = value < 0 && this.sepNegVal ? 'v' : '^';
  var label = this.overlapNoMerge ? position : Math.round(position / this.binWidth);
  return prefix + label;
};

/***/ }),

/***/ 6851:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var Color = __webpack_require__(78766);
var Drawing = __webpack_require__(62203);
var Lib = __webpack_require__(34809);
var Registry = __webpack_require__(33626);
var resizeText = (__webpack_require__(84102).resizeText);
var attributes = __webpack_require__(81481);
var attributeTextFont = attributes.textfont;
var attributeInsideTextFont = attributes.insidetextfont;
var attributeOutsideTextFont = attributes.outsidetextfont;
var helpers = __webpack_require__(42843);
function style(gd) {
  var s = d3.select(gd).selectAll('g[class^="barlayer"]').selectAll('g.trace');
  resizeText(gd, s, 'bar');
  var barcount = s.size();
  var fullLayout = gd._fullLayout;

  // trace styling
  s.style('opacity', function (d) {
    return d[0].trace.opacity;
  })

  // for gapless (either stacked or neighboring grouped) bars use
  // crispEdges to turn off antialiasing so an artificial gap
  // isn't introduced.
  .each(function (d) {
    if (fullLayout.barmode === 'stack' && barcount > 1 || fullLayout.bargap === 0 && fullLayout.bargroupgap === 0 && !d[0].trace.marker.line.width) {
      d3.select(this).attr('shape-rendering', 'crispEdges');
    }
  });
  s.selectAll('g.points').each(function (d) {
    var sel = d3.select(this);
    var trace = d[0].trace;
    stylePoints(sel, trace, gd);
  });
  Registry.getComponentMethod('errorbars', 'style')(s);
}
function stylePoints(sel, trace, gd) {
  Drawing.pointStyle(sel.selectAll('path'), trace, gd);
  styleTextPoints(sel, trace, gd);
}
function styleTextPoints(sel, trace, gd) {
  sel.selectAll('text').each(function (d) {
    var tx = d3.select(this);
    var font = Lib.ensureUniformFontSize(gd, determineFont(tx, d, trace, gd));
    Drawing.font(tx, font);
  });
}
function styleOnSelect(gd, cd, sel) {
  var trace = cd[0].trace;
  if (trace.selectedpoints) {
    stylePointsInSelectionMode(sel, trace, gd);
  } else {
    stylePoints(sel, trace, gd);
    Registry.getComponentMethod('errorbars', 'style')(sel);
  }
}
function stylePointsInSelectionMode(s, trace, gd) {
  Drawing.selectedPointStyle(s.selectAll('path'), trace);
  styleTextInSelectionMode(s.selectAll('text'), trace, gd);
}
function styleTextInSelectionMode(txs, trace, gd) {
  txs.each(function (d) {
    var tx = d3.select(this);
    var font;
    if (d.selected) {
      font = Lib.ensureUniformFontSize(gd, determineFont(tx, d, trace, gd));
      var selectedFontColor = trace.selected.textfont && trace.selected.textfont.color;
      if (selectedFontColor) {
        font.color = selectedFontColor;
      }
      Drawing.font(tx, font);
    } else {
      Drawing.selectedTextStyle(tx, trace);
    }
  });
}
function determineFont(tx, d, trace, gd) {
  var layoutFont = gd._fullLayout.font;
  var textFont = trace.textfont;
  if (tx.classed('bartext-inside')) {
    var barColor = getBarColor(d, trace);
    textFont = getInsideTextFont(trace, d.i, layoutFont, barColor);
  } else if (tx.classed('bartext-outside')) {
    textFont = getOutsideTextFont(trace, d.i, layoutFont);
  }
  return textFont;
}
function getTextFont(trace, index, defaultValue) {
  return getFontValue(attributeTextFont, trace.textfont, index, defaultValue);
}
function getInsideTextFont(trace, index, layoutFont, barColor) {
  var defaultFont = getTextFont(trace, index, layoutFont);
  var wouldFallBackToLayoutFont = trace._input.textfont === undefined || trace._input.textfont.color === undefined || Array.isArray(trace.textfont.color) && trace.textfont.color[index] === undefined;
  if (wouldFallBackToLayoutFont) {
    defaultFont = {
      color: Color.contrast(barColor),
      family: defaultFont.family,
      size: defaultFont.size,
      weight: defaultFont.weight,
      style: defaultFont.style,
      variant: defaultFont.variant,
      textcase: defaultFont.textcase,
      lineposition: defaultFont.lineposition,
      shadow: defaultFont.shadow
    };
  }
  return getFontValue(attributeInsideTextFont, trace.insidetextfont, index, defaultFont);
}
function getOutsideTextFont(trace, index, layoutFont) {
  var defaultFont = getTextFont(trace, index, layoutFont);
  return getFontValue(attributeOutsideTextFont, trace.outsidetextfont, index, defaultFont);
}
function getFontValue(attributeDefinition, attributeValue, index, defaultValue) {
  attributeValue = attributeValue || {};
  var familyValue = helpers.getValue(attributeValue.family, index);
  var sizeValue = helpers.getValue(attributeValue.size, index);
  var colorValue = helpers.getValue(attributeValue.color, index);
  var weightValue = helpers.getValue(attributeValue.weight, index);
  var styleValue = helpers.getValue(attributeValue.style, index);
  var variantValue = helpers.getValue(attributeValue.variant, index);
  var textcaseValue = helpers.getValue(attributeValue.textcase, index);
  var linepositionValue = helpers.getValue(attributeValue.lineposition, index);
  var shadowValue = helpers.getValue(attributeValue.shadow, index);
  return {
    family: helpers.coerceString(attributeDefinition.family, familyValue, defaultValue.family),
    size: helpers.coerceNumber(attributeDefinition.size, sizeValue, defaultValue.size),
    color: helpers.coerceColor(attributeDefinition.color, colorValue, defaultValue.color),
    weight: helpers.coerceString(attributeDefinition.weight, weightValue, defaultValue.weight),
    style: helpers.coerceString(attributeDefinition.style, styleValue, defaultValue.style),
    variant: helpers.coerceString(attributeDefinition.variant, variantValue, defaultValue.variant),
    textcase: helpers.coerceString(attributeDefinition.variant, textcaseValue, defaultValue.textcase),
    lineposition: helpers.coerceString(attributeDefinition.variant, linepositionValue, defaultValue.lineposition),
    shadow: helpers.coerceString(attributeDefinition.variant, shadowValue, defaultValue.shadow)
  };
}
function getBarColor(cd, trace) {
  if (trace.type === 'waterfall') {
    return trace[cd.dir].marker.color;
  }
  return cd.mcc || cd.mc || trace.marker.color;
}
module.exports = {
  style: style,
  styleTextPoints: styleTextPoints,
  styleOnSelect: styleOnSelect,
  getInsideTextFont: getInsideTextFont,
  getOutsideTextFont: getOutsideTextFont,
  getBarColor: getBarColor,
  resizeText: resizeText
};

/***/ }),

/***/ 59760:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Color = __webpack_require__(78766);
var hasColorscale = (__webpack_require__(65477).hasColorscale);
var colorscaleDefaults = __webpack_require__(39356);
var coercePattern = (__webpack_require__(34809).coercePattern);
module.exports = function handleStyleDefaults(traceIn, traceOut, coerce, defaultColor, layout) {
  var markerColor = coerce('marker.color', defaultColor);
  var hasMarkerColorscale = hasColorscale(traceIn, 'marker');
  if (hasMarkerColorscale) {
    colorscaleDefaults(traceIn, traceOut, layout, coerce, {
      prefix: 'marker.',
      cLetter: 'c'
    });
  }
  coerce('marker.line.color', Color.defaultLine);
  if (hasColorscale(traceIn, 'marker.line')) {
    colorscaleDefaults(traceIn, traceOut, layout, coerce, {
      prefix: 'marker.line.',
      cLetter: 'c'
    });
  }
  coerce('marker.line.width');
  coerce('marker.opacity');
  coercePattern(coerce, 'marker.pattern', markerColor, hasMarkerColorscale);
  coerce('selected.marker.color');
  coerce('unselected.marker.color');
};

/***/ }),

/***/ 84102:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var Lib = __webpack_require__(34809);
function resizeText(gd, gTrace, traceType) {
  var fullLayout = gd._fullLayout;
  var minSize = fullLayout['_' + traceType + 'Text_minsize'];
  if (minSize) {
    var shouldHide = fullLayout.uniformtext.mode === 'hide';
    var selector;
    switch (traceType) {
      case 'funnelarea':
      case 'pie':
      case 'sunburst':
        selector = 'g.slice';
        break;
      case 'treemap':
      case 'icicle':
        selector = 'g.slice, g.pathbar';
        break;
      default:
        selector = 'g.points > g.point';
    }
    gTrace.selectAll(selector).each(function (d) {
      var transform = d.transform;
      if (transform) {
        transform.scale = shouldHide && transform.hide ? 0 : minSize / transform.fontSize;
        var el = d3.select(this).select('text');
        Lib.setTransormAndDisplay(el, transform);
      }
    });
  }
}
function recordMinTextSize(traceType,
// in
transform,
// inout
fullLayout // inout
) {
  if (fullLayout.uniformtext.mode) {
    var minKey = getMinKey(traceType);
    var minSize = fullLayout.uniformtext.minsize;
    var size = transform.scale * transform.fontSize;
    transform.hide = size < minSize;
    fullLayout[minKey] = fullLayout[minKey] || Infinity;
    if (!transform.hide) {
      fullLayout[minKey] = Math.min(fullLayout[minKey], Math.max(size, minSize));
    }
  }
}
function clearMinTextSize(traceType,
// in
fullLayout // inout
) {
  var minKey = getMinKey(traceType);
  fullLayout[minKey] = undefined;
}
function getMinKey(traceType) {
  return '_' + traceType + 'Text_minsize';
}
module.exports = {
  recordMinTextSize: recordMinTextSize,
  clearMinTextSize: clearMinTextSize,
  resizeText: resizeText
};

/***/ }),

/***/ 32225:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var hovertemplateAttrs = (__webpack_require__(3208)/* .hovertemplateAttrs */ .rb);
var extendFlat = (__webpack_require__(93049).extendFlat);
var scatterPolarAttrs = __webpack_require__(8738);
var barAttrs = __webpack_require__(81481);
module.exports = {
  r: scatterPolarAttrs.r,
  theta: scatterPolarAttrs.theta,
  r0: scatterPolarAttrs.r0,
  dr: scatterPolarAttrs.dr,
  theta0: scatterPolarAttrs.theta0,
  dtheta: scatterPolarAttrs.dtheta,
  thetaunit: scatterPolarAttrs.thetaunit,
  // orientation: {
  //     valType: 'enumerated',
  //     values: ['radial', 'angular'],
  //     editType: 'calc+clearAxisTypes',
  //
  // },

  base: extendFlat({}, barAttrs.base, {}),
  offset: extendFlat({}, barAttrs.offset, {}),
  width: extendFlat({}, barAttrs.width, {}),
  text: extendFlat({}, barAttrs.text, {}),
  hovertext: extendFlat({}, barAttrs.hovertext, {}),
  // textposition: {},
  // textfont: {},
  // insidetextfont: {},
  // outsidetextfont: {},
  // constraintext: {},
  // cliponaxis: extendFlat({}, barAttrs.cliponaxis, {dflt: false}),

  marker: barPolarMarker(),
  hoverinfo: scatterPolarAttrs.hoverinfo,
  hovertemplate: hovertemplateAttrs(),
  selected: barAttrs.selected,
  unselected: barAttrs.unselected

  // error_x (error_r, error_theta)
  // error_y
};
function barPolarMarker() {
  var marker = extendFlat({}, barAttrs.marker);
  delete marker.cornerradius;
  return marker;
}

/***/ }),

/***/ 27941:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var hasColorscale = (__webpack_require__(65477).hasColorscale);
var colorscaleCalc = __webpack_require__(28379);
var isArrayOrTypedArray = (__webpack_require__(34809).isArrayOrTypedArray);
var arraysToCalcdata = __webpack_require__(35374);
var setGroupPositions = (__webpack_require__(24782).setGroupPositions);
var calcSelection = __webpack_require__(48861);
var traceIs = (__webpack_require__(33626).traceIs);
var extendFlat = (__webpack_require__(34809).extendFlat);
function calc(gd, trace) {
  var fullLayout = gd._fullLayout;
  var subplotId = trace.subplot;
  var radialAxis = fullLayout[subplotId].radialaxis;
  var angularAxis = fullLayout[subplotId].angularaxis;
  var rArray = radialAxis.makeCalcdata(trace, 'r');
  var thetaArray = angularAxis.makeCalcdata(trace, 'theta');
  var len = trace._length;
  var cd = new Array(len);

  // 'size' axis variables
  var sArray = rArray;
  // 'pos' axis variables
  var pArray = thetaArray;
  for (var i = 0; i < len; i++) {
    cd[i] = {
      p: pArray[i],
      s: sArray[i]
    };
  }

  // convert width and offset in 'c' coordinate,
  // set 'c' value(s) in trace._width and trace._offset,
  // to make Bar.crossTraceCalc "just work"
  function d2c(attr) {
    var val = trace[attr];
    if (val !== undefined) {
      trace['_' + attr] = isArrayOrTypedArray(val) ? angularAxis.makeCalcdata(trace, attr) : angularAxis.d2c(val, trace.thetaunit);
    }
  }
  if (angularAxis.type === 'linear') {
    d2c('width');
    d2c('offset');
  }
  if (hasColorscale(trace, 'marker')) {
    colorscaleCalc(gd, trace, {
      vals: trace.marker.color,
      containerStr: 'marker',
      cLetter: 'c'
    });
  }
  if (hasColorscale(trace, 'marker.line')) {
    colorscaleCalc(gd, trace, {
      vals: trace.marker.line.color,
      containerStr: 'marker.line',
      cLetter: 'c'
    });
  }
  arraysToCalcdata(cd, trace);
  calcSelection(cd, trace);
  return cd;
}
function crossTraceCalc(gd, polarLayout, subplotId) {
  var calcdata = gd.calcdata;
  var barPolarCd = [];
  for (var i = 0; i < calcdata.length; i++) {
    var cdi = calcdata[i];
    var trace = cdi[0].trace;
    if (trace.visible === true && traceIs(trace, 'bar') && trace.subplot === subplotId) {
      barPolarCd.push(cdi);
    }
  }

  // to make _extremes is filled in correctly so that
  // polar._subplot.radialAxis can get auotrange'd
  // TODO clean up!
  // I think we want to call getAutorange on polar.radialaxis
  // NOT on polar._subplot.radialAxis
  var rAxis = extendFlat({}, polarLayout.radialaxis, {
    _id: 'x'
  });
  var aAxis = polarLayout.angularaxis;
  setGroupPositions(gd, aAxis, rAxis, barPolarCd, {
    mode: polarLayout.barmode,
    norm: polarLayout.barnorm,
    gap: polarLayout.bargap,
    groupgap: polarLayout.bargroupgap
  });
}
module.exports = {
  calc: calc,
  crossTraceCalc: crossTraceCalc
};

/***/ }),

/***/ 77318:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var handleRThetaDefaults = (__webpack_require__(73749).handleRThetaDefaults);
var handleStyleDefaults = __webpack_require__(59760);
var attributes = __webpack_require__(32225);
module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
  function coerce(attr, dflt) {
    return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
  }
  var len = handleRThetaDefaults(traceIn, traceOut, layout, coerce);
  if (!len) {
    traceOut.visible = false;
    return;
  }

  // coerce('orientation', (traceOut.theta && !traceOut.r) ? 'angular' : 'radial');

  coerce('thetaunit');
  coerce('base');
  coerce('offset');
  coerce('width');
  coerce('text');
  coerce('hovertext');
  coerce('hovertemplate');

  // var textPosition = coerce('textposition');
  // var hasBoth = Array.isArray(textPosition) || textPosition === 'auto';
  // var hasInside = hasBoth || textPosition === 'inside';
  // var hasOutside = hasBoth || textPosition === 'outside';

  // if(hasInside || hasOutside) {
  //     var textFont = coerceFont(coerce, 'textfont', layout.font);
  //     if(hasInside) coerceFont(coerce, 'insidetextfont', textFont);
  //     if(hasOutside) coerceFont(coerce, 'outsidetextfont', textFont);
  //     coerce('constraintext');
  //     coerce('selected.textfont.color');
  //     coerce('unselected.textfont.color');
  //     coerce('cliponaxis');
  // }

  handleStyleDefaults(traceIn, traceOut, coerce, defaultColor, layout);
  Lib.coerceSelectionMarkerOpacity(traceOut, coerce);
};

/***/ }),

/***/ 83080:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Fx = __webpack_require__(32141);
var Lib = __webpack_require__(34809);
var getTraceColor = (__webpack_require__(91664).getTraceColor);
var fillText = Lib.fillText;
var makeHoverPointText = (__webpack_require__(29709).makeHoverPointText);
var isPtInsidePolygon = (__webpack_require__(95928).isPtInsidePolygon);
module.exports = function hoverPoints(pointData, xval, yval) {
  var cd = pointData.cd;
  var trace = cd[0].trace;
  var subplot = pointData.subplot;
  var radialAxis = subplot.radialAxis;
  var angularAxis = subplot.angularAxis;
  var vangles = subplot.vangles;
  var inboxFn = vangles ? isPtInsidePolygon : Lib.isPtInsideSector;
  var maxHoverDistance = pointData.maxHoverDistance;
  var period = angularAxis._period || 2 * Math.PI;
  var rVal = Math.abs(radialAxis.g2p(Math.sqrt(xval * xval + yval * yval)));
  var thetaVal = Math.atan2(yval, xval);

  // polar.(x|y)axis.p2c doesn't get the reversed radial axis range case right
  if (radialAxis.range[0] > radialAxis.range[1]) {
    thetaVal += Math.PI;
  }
  var distFn = function (di) {
    if (inboxFn(rVal, thetaVal, [di.rp0, di.rp1], [di.thetag0, di.thetag1], vangles)) {
      return maxHoverDistance +
      // add a little to the pseudo-distance for wider bars, so that like scatter,
      // if you are over two overlapping bars, the narrower one wins.
      Math.min(1, Math.abs(di.thetag1 - di.thetag0) / period) - 1 +
      // add a gradient so hovering near the end of a
      // bar makes it a little closer match
      (di.rp1 - rVal) / (di.rp1 - di.rp0) - 1;
    } else {
      return Infinity;
    }
  };
  Fx.getClosest(cd, distFn, pointData);
  if (pointData.index === false) return;
  var index = pointData.index;
  var cdi = cd[index];
  pointData.x0 = pointData.x1 = cdi.ct[0];
  pointData.y0 = pointData.y1 = cdi.ct[1];
  var _cdi = Lib.extendFlat({}, cdi, {
    r: cdi.s,
    theta: cdi.p
  });
  fillText(cdi, trace, pointData);
  makeHoverPointText(_cdi, trace, subplot, pointData);
  pointData.hovertemplate = trace.hovertemplate;
  pointData.color = getTraceColor(trace, cdi);
  pointData.xLabelVal = pointData.yLabelVal = undefined;
  if (cdi.s < 0) {
    pointData.idealAlign = 'left';
  }
  return [pointData];
};

/***/ }),

/***/ 89362:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = {
  moduleType: 'trace',
  name: 'barpolar',
  basePlotModule: __webpack_require__(31645),
  categories: ['polar', 'bar', 'showLegend'],
  attributes: __webpack_require__(32225),
  layoutAttributes: __webpack_require__(42956),
  supplyDefaults: __webpack_require__(77318),
  supplyLayoutDefaults: __webpack_require__(60507),
  calc: (__webpack_require__(27941).calc),
  crossTraceCalc: (__webpack_require__(27941).crossTraceCalc),
  plot: __webpack_require__(11627),
  colorbar: __webpack_require__(21146),
  formatLabels: __webpack_require__(33368),
  style: (__webpack_require__(6851).style),
  styleOnSelect: (__webpack_require__(6851).styleOnSelect),
  hoverPoints: __webpack_require__(83080),
  selectPoints: __webpack_require__(88384),
  meta: {}
};

/***/ }),

/***/ 42956:
/***/ (function(module) {

"use strict";


module.exports = {
  barmode: {
    valType: 'enumerated',
    values: ['stack', 'overlay'],
    dflt: 'stack',
    editType: 'calc'
  },
  bargap: {
    valType: 'number',
    dflt: 0.1,
    min: 0,
    max: 1,
    editType: 'calc'
  }
};

/***/ }),

/***/ 60507:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var attrs = __webpack_require__(42956);
module.exports = function (layoutIn, layoutOut, fullData) {
  var subplotsDone = {};
  var sp;
  function coerce(attr, dflt) {
    return Lib.coerce(layoutIn[sp] || {}, layoutOut[sp], attrs, attr, dflt);
  }
  for (var i = 0; i < fullData.length; i++) {
    var trace = fullData[i];
    if (trace.type === 'barpolar' && trace.visible === true) {
      sp = trace.subplot;
      if (!subplotsDone[sp]) {
        coerce('barmode');
        coerce('bargap');
        subplotsDone[sp] = 1;
      }
    }
  }
};

/***/ }),

/***/ 11627:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var isNumeric = __webpack_require__(10721);
var Lib = __webpack_require__(34809);
var Drawing = __webpack_require__(62203);
var helpers = __webpack_require__(95928);
module.exports = function plot(gd, subplot, cdbar) {
  var isStatic = gd._context.staticPlot;
  var xa = subplot.xaxis;
  var ya = subplot.yaxis;
  var radialAxis = subplot.radialAxis;
  var angularAxis = subplot.angularAxis;
  var pathFn = makePathFn(subplot);
  var barLayer = subplot.layers.frontplot.select('g.barlayer');
  Lib.makeTraceGroups(barLayer, cdbar, 'trace bars').each(function () {
    var plotGroup = d3.select(this);
    var pointGroup = Lib.ensureSingle(plotGroup, 'g', 'points');
    var bars = pointGroup.selectAll('g.point').data(Lib.identity);
    bars.enter().append('g').style('vector-effect', isStatic ? 'none' : 'non-scaling-stroke').style('stroke-miterlimit', 2).classed('point', true);
    bars.exit().remove();
    bars.each(function (di) {
      var bar = d3.select(this);
      var rp0 = di.rp0 = radialAxis.c2p(di.s0);
      var rp1 = di.rp1 = radialAxis.c2p(di.s1);
      var thetag0 = di.thetag0 = angularAxis.c2g(di.p0);
      var thetag1 = di.thetag1 = angularAxis.c2g(di.p1);
      var dPath;
      if (!isNumeric(rp0) || !isNumeric(rp1) || !isNumeric(thetag0) || !isNumeric(thetag1) || rp0 === rp1 || thetag0 === thetag1) {
        // do not remove blank bars, to keep data-to-node
        // mapping intact during radial drag, that we
        // can skip calling _module.style during interactions
        dPath = 'M0,0Z';
      } else {
        // this 'center' pt is used for selections and hover labels
        var rg1 = radialAxis.c2g(di.s1);
        var thetagMid = (thetag0 + thetag1) / 2;
        di.ct = [xa.c2p(rg1 * Math.cos(thetagMid)), ya.c2p(rg1 * Math.sin(thetagMid))];
        dPath = pathFn(rp0, rp1, thetag0, thetag1);
      }
      Lib.ensureSingle(bar, 'path').attr('d', dPath);
    });

    // clip plotGroup, when trace layer isn't clipped
    Drawing.setClipUrl(plotGroup, subplot._hasClipOnAxisFalse ? subplot.clipIds.forTraces : null, gd);
  });
};
function makePathFn(subplot) {
  var cxx = subplot.cxx;
  var cyy = subplot.cyy;
  if (subplot.vangles) {
    return function (r0, r1, _a0, _a1) {
      var a0, a1;
      if (Lib.angleDelta(_a0, _a1) > 0) {
        a0 = _a0;
        a1 = _a1;
      } else {
        a0 = _a1;
        a1 = _a0;
      }
      var va0 = helpers.findEnclosingVertexAngles(a0, subplot.vangles)[0];
      var va1 = helpers.findEnclosingVertexAngles(a1, subplot.vangles)[1];
      var vaBar = [va0, (a0 + a1) / 2, va1];
      return helpers.pathPolygonAnnulus(r0, r1, a0, a1, vaBar, cxx, cyy);
    };
  }
  return function (r0, r1, a0, a1) {
    return Lib.pathAnnulus(r0, r1, a0, a1, cxx, cyy);
  };
}

/***/ }),

/***/ 64625:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var makeFillcolorAttr = __webpack_require__(19326);
var scatterAttrs = __webpack_require__(36640);
var barAttrs = __webpack_require__(81481);
var colorAttrs = __webpack_require__(10229);
var axisHoverFormat = (__webpack_require__(80712).axisHoverFormat);
var hovertemplateAttrs = (__webpack_require__(3208)/* .hovertemplateAttrs */ .rb);
var extendFlat = (__webpack_require__(93049).extendFlat);
var scatterMarkerAttrs = scatterAttrs.marker;
var scatterMarkerLineAttrs = scatterMarkerAttrs.line;
module.exports = {
  y: {
    valType: 'data_array',
    editType: 'calc+clearAxisTypes'
  },
  x: {
    valType: 'data_array',
    editType: 'calc+clearAxisTypes'
  },
  x0: {
    valType: 'any',
    editType: 'calc+clearAxisTypes'
  },
  y0: {
    valType: 'any',
    editType: 'calc+clearAxisTypes'
  },
  dx: {
    valType: 'number',
    editType: 'calc'
  },
  dy: {
    valType: 'number',
    editType: 'calc'
  },
  xperiod: scatterAttrs.xperiod,
  yperiod: scatterAttrs.yperiod,
  xperiod0: scatterAttrs.xperiod0,
  yperiod0: scatterAttrs.yperiod0,
  xperiodalignment: scatterAttrs.xperiodalignment,
  yperiodalignment: scatterAttrs.yperiodalignment,
  xhoverformat: axisHoverFormat('x'),
  yhoverformat: axisHoverFormat('y'),
  name: {
    valType: 'string',
    editType: 'calc+clearAxisTypes'
  },
  q1: {
    valType: 'data_array',
    editType: 'calc+clearAxisTypes'
  },
  median: {
    valType: 'data_array',
    editType: 'calc+clearAxisTypes'
  },
  q3: {
    valType: 'data_array',
    editType: 'calc+clearAxisTypes'
  },
  lowerfence: {
    valType: 'data_array',
    editType: 'calc'
  },
  upperfence: {
    valType: 'data_array',
    editType: 'calc'
  },
  notched: {
    valType: 'boolean',
    editType: 'calc'
  },
  notchwidth: {
    valType: 'number',
    min: 0,
    max: 0.5,
    dflt: 0.25,
    editType: 'calc'
  },
  notchspan: {
    valType: 'data_array',
    editType: 'calc'
  },
  // TODO
  // maybe add
  // - loweroutlierbound / upperoutlierbound
  // - lowersuspectedoutlierbound / uppersuspectedoutlierbound

  boxpoints: {
    valType: 'enumerated',
    values: ['all', 'outliers', 'suspectedoutliers', false],
    editType: 'calc'
  },
  jitter: {
    valType: 'number',
    min: 0,
    max: 1,
    editType: 'calc'
  },
  pointpos: {
    valType: 'number',
    min: -2,
    max: 2,
    editType: 'calc'
  },
  sdmultiple: {
    valType: 'number',
    min: 0,
    editType: 'calc',
    dflt: 1
  },
  sizemode: {
    valType: 'enumerated',
    values: ['quartiles', 'sd'],
    editType: 'calc',
    dflt: 'quartiles'
  },
  boxmean: {
    valType: 'enumerated',
    values: [true, 'sd', false],
    editType: 'calc'
  },
  mean: {
    valType: 'data_array',
    editType: 'calc'
  },
  sd: {
    valType: 'data_array',
    editType: 'calc'
  },
  orientation: {
    valType: 'enumerated',
    values: ['v', 'h'],
    editType: 'calc+clearAxisTypes'
  },
  quartilemethod: {
    valType: 'enumerated',
    values: ['linear', 'exclusive', 'inclusive'],
    dflt: 'linear',
    editType: 'calc'
  },
  width: {
    valType: 'number',
    min: 0,
    dflt: 0,
    editType: 'calc'
  },
  marker: {
    outliercolor: {
      valType: 'color',
      dflt: 'rgba(0, 0, 0, 0)',
      editType: 'style'
    },
    symbol: extendFlat({}, scatterMarkerAttrs.symbol, {
      arrayOk: false,
      editType: 'plot'
    }),
    opacity: extendFlat({}, scatterMarkerAttrs.opacity, {
      arrayOk: false,
      dflt: 1,
      editType: 'style'
    }),
    angle: extendFlat({}, scatterMarkerAttrs.angle, {
      arrayOk: false,
      editType: 'calc'
    }),
    size: extendFlat({}, scatterMarkerAttrs.size, {
      arrayOk: false,
      editType: 'calc'
    }),
    color: extendFlat({}, scatterMarkerAttrs.color, {
      arrayOk: false,
      editType: 'style'
    }),
    line: {
      color: extendFlat({}, scatterMarkerLineAttrs.color, {
        arrayOk: false,
        dflt: colorAttrs.defaultLine,
        editType: 'style'
      }),
      width: extendFlat({}, scatterMarkerLineAttrs.width, {
        arrayOk: false,
        dflt: 0,
        editType: 'style'
      }),
      outliercolor: {
        valType: 'color',
        editType: 'style'
      },
      outlierwidth: {
        valType: 'number',
        min: 0,
        dflt: 1,
        editType: 'style'
      },
      editType: 'style'
    },
    editType: 'plot'
  },
  line: {
    color: {
      valType: 'color',
      editType: 'style'
    },
    width: {
      valType: 'number',
      min: 0,
      dflt: 2,
      editType: 'style'
    },
    editType: 'plot'
  },
  fillcolor: makeFillcolorAttr(),
  whiskerwidth: {
    valType: 'number',
    min: 0,
    max: 1,
    dflt: 0.5,
    editType: 'calc'
  },
  showwhiskers: {
    valType: 'boolean',
    editType: 'calc'
  },
  offsetgroup: barAttrs.offsetgroup,
  alignmentgroup: barAttrs.alignmentgroup,
  selected: {
    marker: scatterAttrs.selected.marker,
    editType: 'style'
  },
  unselected: {
    marker: scatterAttrs.unselected.marker,
    editType: 'style'
  },
  text: extendFlat({}, scatterAttrs.text, {}),
  hovertext: extendFlat({}, scatterAttrs.hovertext, {}),
  hovertemplate: hovertemplateAttrs({}),
  hoveron: {
    valType: 'flaglist',
    flags: ['boxes', 'points'],
    dflt: 'boxes+points',
    editType: 'style'
  },
  zorder: scatterAttrs.zorder
};

/***/ }),

/***/ 89429:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isNumeric = __webpack_require__(10721);
var Axes = __webpack_require__(29714);
var alignPeriod = __webpack_require__(40528);
var Lib = __webpack_require__(34809);
var BADNUM = (__webpack_require__(63821).BADNUM);
var _ = Lib._;
module.exports = function calc(gd, trace) {
  var fullLayout = gd._fullLayout;
  var xa = Axes.getFromId(gd, trace.xaxis || 'x');
  var ya = Axes.getFromId(gd, trace.yaxis || 'y');
  var cd = [];

  // N.B. violin reuses same Box.calc
  var numKey = trace.type === 'violin' ? '_numViolins' : '_numBoxes';
  var i, j;
  var valAxis, valLetter;
  var posAxis, posLetter;
  var hasPeriod;
  if (trace.orientation === 'h') {
    valAxis = xa;
    valLetter = 'x';
    posAxis = ya;
    posLetter = 'y';
    hasPeriod = !!trace.yperiodalignment;
  } else {
    valAxis = ya;
    valLetter = 'y';
    posAxis = xa;
    posLetter = 'x';
    hasPeriod = !!trace.xperiodalignment;
  }
  var allPosArrays = getPosArrays(trace, posLetter, posAxis, fullLayout[numKey]);
  var posArray = allPosArrays[0];
  var origPos = allPosArrays[1];
  var dv = Lib.distinctVals(posArray, posAxis);
  var posDistinct = dv.vals;
  var dPos = dv.minDiff / 2;

  // item in trace calcdata
  var cdi;
  // array of {v: v, i, i} sample pts
  var pts;
  // values of the `pts` array of objects
  var boxVals;
  // length of sample
  var N;
  // single sample point
  var pt;
  // single sample value
  var v;

  // filter function for outlier pts
  // outlier definition based on http://www.physics.csbsju.edu/stats/box2.html
  var ptFilterFn = (trace.boxpoints || trace.points) === 'all' ? Lib.identity : function (pt) {
    return pt.v < cdi.lf || pt.v > cdi.uf;
  };
  if (trace._hasPreCompStats) {
    var valArrayRaw = trace[valLetter];
    var d2c = function (k) {
      return valAxis.d2c((trace[k] || [])[i]);
    };
    var minVal = Infinity;
    var maxVal = -Infinity;
    for (i = 0; i < trace._length; i++) {
      var posi = posArray[i];
      if (!isNumeric(posi)) continue;
      cdi = {};
      cdi.pos = cdi[posLetter] = posi;
      if (hasPeriod && origPos) {
        cdi.orig_p = origPos[i]; // used by hover
      }
      cdi.q1 = d2c('q1');
      cdi.med = d2c('median');
      cdi.q3 = d2c('q3');
      pts = [];
      if (valArrayRaw && Lib.isArrayOrTypedArray(valArrayRaw[i])) {
        for (j = 0; j < valArrayRaw[i].length; j++) {
          v = valAxis.d2c(valArrayRaw[i][j]);
          if (v !== BADNUM) {
            pt = {
              v: v,
              i: [i, j]
            };
            arraysToCalcdata(pt, trace, [i, j]);
            pts.push(pt);
          }
        }
      }
      cdi.pts = pts.sort(sortByVal);
      boxVals = cdi[valLetter] = pts.map(extractVal);
      N = boxVals.length;
      if (cdi.med !== BADNUM && cdi.q1 !== BADNUM && cdi.q3 !== BADNUM && cdi.med >= cdi.q1 && cdi.q3 >= cdi.med) {
        var lf = d2c('lowerfence');
        cdi.lf = lf !== BADNUM && lf <= cdi.q1 ? lf : computeLowerFence(cdi, boxVals, N);
        var uf = d2c('upperfence');
        cdi.uf = uf !== BADNUM && uf >= cdi.q3 ? uf : computeUpperFence(cdi, boxVals, N);
        var mean = d2c('mean');
        cdi.mean = mean !== BADNUM ? mean : N ? Lib.mean(boxVals, N) : (cdi.q1 + cdi.q3) / 2;
        var sd = d2c('sd');
        cdi.sd = mean !== BADNUM && sd >= 0 ? sd : N ? Lib.stdev(boxVals, N, cdi.mean) : cdi.q3 - cdi.q1;
        cdi.lo = computeLowerOutlierBound(cdi);
        cdi.uo = computeUpperOutlierBound(cdi);
        var ns = d2c('notchspan');
        ns = ns !== BADNUM && ns > 0 ? ns : computeNotchSpan(cdi, N);
        cdi.ln = cdi.med - ns;
        cdi.un = cdi.med + ns;
        var imin = cdi.lf;
        var imax = cdi.uf;
        if (trace.boxpoints && boxVals.length) {
          imin = Math.min(imin, boxVals[0]);
          imax = Math.max(imax, boxVals[N - 1]);
        }
        if (trace.notched) {
          imin = Math.min(imin, cdi.ln);
          imax = Math.max(imax, cdi.un);
        }
        cdi.min = imin;
        cdi.max = imax;
      } else {
        Lib.warn(['Invalid input - make sure that q1 <= median <= q3', 'q1 = ' + cdi.q1, 'median = ' + cdi.med, 'q3 = ' + cdi.q3].join('\n'));
        var v0;
        if (cdi.med !== BADNUM) {
          v0 = cdi.med;
        } else if (cdi.q1 !== BADNUM) {
          if (cdi.q3 !== BADNUM) v0 = (cdi.q1 + cdi.q3) / 2;else v0 = cdi.q1;
        } else if (cdi.q3 !== BADNUM) {
          v0 = cdi.q3;
        } else {
          v0 = 0;
        }

        // draw box as line segment
        cdi.med = v0;
        cdi.q1 = cdi.q3 = v0;
        cdi.lf = cdi.uf = v0;
        cdi.mean = cdi.sd = v0;
        cdi.ln = cdi.un = v0;
        cdi.min = cdi.max = v0;
      }
      minVal = Math.min(minVal, cdi.min);
      maxVal = Math.max(maxVal, cdi.max);
      cdi.pts2 = pts.filter(ptFilterFn);
      cd.push(cdi);
    }
    trace._extremes[valAxis._id] = Axes.findExtremes(valAxis, [minVal, maxVal], {
      padded: true
    });
  } else {
    var valArray = valAxis.makeCalcdata(trace, valLetter);
    var posBins = makeBins(posDistinct, dPos);
    var pLen = posDistinct.length;
    var ptsPerBin = initNestedArray(pLen);

    // bin pts info per position bins
    for (i = 0; i < trace._length; i++) {
      v = valArray[i];
      if (!isNumeric(v)) continue;
      var n = Lib.findBin(posArray[i], posBins);
      if (n >= 0 && n < pLen) {
        pt = {
          v: v,
          i: i
        };
        arraysToCalcdata(pt, trace, i);
        ptsPerBin[n].push(pt);
      }
    }
    var minLowerNotch = Infinity;
    var maxUpperNotch = -Infinity;
    var quartilemethod = trace.quartilemethod;
    var usesExclusive = quartilemethod === 'exclusive';
    var usesInclusive = quartilemethod === 'inclusive';

    // build calcdata trace items, one item per distinct position
    for (i = 0; i < pLen; i++) {
      if (ptsPerBin[i].length > 0) {
        cdi = {};
        cdi.pos = cdi[posLetter] = posDistinct[i];
        pts = cdi.pts = ptsPerBin[i].sort(sortByVal);
        boxVals = cdi[valLetter] = pts.map(extractVal);
        N = boxVals.length;
        cdi.min = boxVals[0];
        cdi.max = boxVals[N - 1];
        cdi.mean = Lib.mean(boxVals, N);
        cdi.sd = Lib.stdev(boxVals, N, cdi.mean) * trace.sdmultiple;
        cdi.med = Lib.interp(boxVals, 0.5);
        if (N % 2 && (usesExclusive || usesInclusive)) {
          var lower;
          var upper;
          if (usesExclusive) {
            // do NOT include the median in either half
            lower = boxVals.slice(0, N / 2);
            upper = boxVals.slice(N / 2 + 1);
          } else if (usesInclusive) {
            // include the median in either half
            lower = boxVals.slice(0, N / 2 + 1);
            upper = boxVals.slice(N / 2);
          }
          cdi.q1 = Lib.interp(lower, 0.5);
          cdi.q3 = Lib.interp(upper, 0.5);
        } else {
          cdi.q1 = Lib.interp(boxVals, 0.25);
          cdi.q3 = Lib.interp(boxVals, 0.75);
        }

        // lower and upper fences
        cdi.lf = computeLowerFence(cdi, boxVals, N);
        cdi.uf = computeUpperFence(cdi, boxVals, N);

        // lower and upper outliers bounds
        cdi.lo = computeLowerOutlierBound(cdi);
        cdi.uo = computeUpperOutlierBound(cdi);

        // lower and upper notches
        var mci = computeNotchSpan(cdi, N);
        cdi.ln = cdi.med - mci;
        cdi.un = cdi.med + mci;
        minLowerNotch = Math.min(minLowerNotch, cdi.ln);
        maxUpperNotch = Math.max(maxUpperNotch, cdi.un);
        cdi.pts2 = pts.filter(ptFilterFn);
        cd.push(cdi);
      }
    }
    if (trace.notched && Lib.isTypedArray(valArray)) valArray = Array.from(valArray);
    trace._extremes[valAxis._id] = Axes.findExtremes(valAxis, trace.notched ? valArray.concat([minLowerNotch, maxUpperNotch]) : valArray, {
      padded: true
    });
  }
  calcSelection(cd, trace);
  if (cd.length > 0) {
    cd[0].t = {
      num: fullLayout[numKey],
      dPos: dPos,
      posLetter: posLetter,
      valLetter: valLetter,
      labels: {
        med: _(gd, 'median:'),
        min: _(gd, 'min:'),
        q1: _(gd, 'q1:'),
        q3: _(gd, 'q3:'),
        max: _(gd, 'max:'),
        mean: trace.boxmean === 'sd' || trace.sizemode === 'sd' ? _(gd, 'mean ± σ:').replace('σ', trace.sdmultiple === 1 ? 'σ' : trace.sdmultiple + 'σ') :
        // displaying mean +- Nσ whilst supporting translations
        _(gd, 'mean:'),
        lf: _(gd, 'lower fence:'),
        uf: _(gd, 'upper fence:')
      }
    };
    fullLayout[numKey]++;
    return cd;
  } else {
    return [{
      t: {
        empty: true
      }
    }];
  }
};

// In vertical (horizontal) box plots:
// if no x (y) data, use x0 (y0), or name
// so if you want one box
// per trace, set x0 (y0) to the x (y) value or category for this trace
// (or set x (y) to a constant array matching y (x))
function getPosArrays(trace, posLetter, posAxis, num) {
  var hasPosArray = posLetter in trace;
  var hasPos0 = posLetter + '0' in trace;
  var hasPosStep = 'd' + posLetter in trace;
  if (hasPosArray || hasPos0 && hasPosStep) {
    var origPos = posAxis.makeCalcdata(trace, posLetter);
    var pos = alignPeriod(trace, posAxis, posLetter, origPos).vals;
    return [pos, origPos];
  }
  var pos0;
  if (hasPos0) {
    pos0 = trace[posLetter + '0'];
  } else if ('name' in trace && (posAxis.type === 'category' || isNumeric(trace.name) && ['linear', 'log'].indexOf(posAxis.type) !== -1 || Lib.isDateTime(trace.name) && posAxis.type === 'date')) {
    pos0 = trace.name;
  } else {
    pos0 = num;
  }
  var pos0c = posAxis.type === 'multicategory' ? posAxis.r2c_just_indices(pos0) : posAxis.d2c(pos0, 0, trace[posLetter + 'calendar']);
  var len = trace._length;
  var out = new Array(len);
  for (var i = 0; i < len; i++) out[i] = pos0c;
  return [out];
}
function makeBins(x, dx) {
  var len = x.length;
  var bins = new Array(len + 1);
  for (var i = 0; i < len; i++) {
    bins[i] = x[i] - dx;
  }
  bins[len] = x[len - 1] + dx;
  return bins;
}
function initNestedArray(len) {
  var arr = new Array(len);
  for (var i = 0; i < len; i++) {
    arr[i] = [];
  }
  return arr;
}
var TRACE_TO_CALC = {
  text: 'tx',
  hovertext: 'htx'
};
function arraysToCalcdata(pt, trace, ptNumber) {
  for (var k in TRACE_TO_CALC) {
    if (Lib.isArrayOrTypedArray(trace[k])) {
      if (Array.isArray(ptNumber)) {
        if (Lib.isArrayOrTypedArray(trace[k][ptNumber[0]])) {
          pt[TRACE_TO_CALC[k]] = trace[k][ptNumber[0]][ptNumber[1]];
        }
      } else {
        pt[TRACE_TO_CALC[k]] = trace[k][ptNumber];
      }
    }
  }
}
function calcSelection(cd, trace) {
  if (Lib.isArrayOrTypedArray(trace.selectedpoints)) {
    for (var i = 0; i < cd.length; i++) {
      var pts = cd[i].pts || [];
      var ptNumber2cdIndex = {};
      for (var j = 0; j < pts.length; j++) {
        ptNumber2cdIndex[pts[j].i] = j;
      }
      Lib.tagSelected(pts, trace, ptNumber2cdIndex);
    }
  }
}
function sortByVal(a, b) {
  return a.v - b.v;
}
function extractVal(o) {
  return o.v;
}

// last point below 1.5 * IQR
function computeLowerFence(cdi, boxVals, N) {
  if (N === 0) return cdi.q1;
  return Math.min(cdi.q1, boxVals[Math.min(Lib.findBin(2.5 * cdi.q1 - 1.5 * cdi.q3, boxVals, true) + 1, N - 1)]);
}

// last point above 1.5 * IQR
function computeUpperFence(cdi, boxVals, N) {
  if (N === 0) return cdi.q3;
  return Math.max(cdi.q3, boxVals[Math.max(Lib.findBin(2.5 * cdi.q3 - 1.5 * cdi.q1, boxVals), 0)]);
}

// 3 IQR below (don't clip to max/min,
// this is only for discriminating suspected & far outliers)
function computeLowerOutlierBound(cdi) {
  return 4 * cdi.q1 - 3 * cdi.q3;
}

// 3 IQR above (don't clip to max/min,
// this is only for discriminating suspected & far outliers)
function computeUpperOutlierBound(cdi) {
  return 4 * cdi.q3 - 3 * cdi.q1;
}

// 95% confidence intervals for median
function computeNotchSpan(cdi, N) {
  if (N === 0) return 0;
  return 1.57 * (cdi.q3 - cdi.q1) / Math.sqrt(N);
}

/***/ }),

/***/ 81606:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Axes = __webpack_require__(29714);
var Lib = __webpack_require__(34809);
var getAxisGroup = (__webpack_require__(84391).getAxisGroup);
var orientations = ['v', 'h'];
function crossTraceCalc(gd, plotinfo) {
  var calcdata = gd.calcdata;
  var xa = plotinfo.xaxis;
  var ya = plotinfo.yaxis;
  for (var i = 0; i < orientations.length; i++) {
    var orientation = orientations[i];
    var posAxis = orientation === 'h' ? ya : xa;
    var boxList = [];

    // make list of boxes / candlesticks
    // For backward compatibility, candlesticks are treated as if they *are* box traces here
    for (var j = 0; j < calcdata.length; j++) {
      var cd = calcdata[j];
      var t = cd[0].t;
      var trace = cd[0].trace;
      if (trace.visible === true && (trace.type === 'box' || trace.type === 'candlestick') && !t.empty && (trace.orientation || 'v') === orientation && trace.xaxis === xa._id && trace.yaxis === ya._id) {
        boxList.push(j);
      }
    }
    setPositionOffset('box', gd, boxList, posAxis);
  }
}
function setPositionOffset(traceType, gd, boxList, posAxis) {
  var calcdata = gd.calcdata;
  var fullLayout = gd._fullLayout;
  var axId = posAxis._id;
  var axLetter = axId.charAt(0);
  var i, j, calcTrace;
  var pointList = [];
  var shownPts = 0;

  // make list of box points
  for (i = 0; i < boxList.length; i++) {
    calcTrace = calcdata[boxList[i]];
    for (j = 0; j < calcTrace.length; j++) {
      pointList.push(posAxis.c2l(calcTrace[j].pos, true));
      shownPts += (calcTrace[j].pts2 || []).length;
    }
  }
  if (!pointList.length) return;

  // box plots - update dPos based on multiple traces
  var boxdv = Lib.distinctVals(pointList);
  if (posAxis.type === 'category' || posAxis.type === 'multicategory') {
    boxdv.minDiff = 1;
  }
  var dPos0 = boxdv.minDiff / 2;

  // check for forced minimum dtick
  Axes.minDtick(posAxis, boxdv.minDiff, boxdv.vals[0], true);
  var numKey = traceType === 'violin' ? '_numViolins' : '_numBoxes';
  var numTotal = fullLayout[numKey];
  var group = fullLayout[traceType + 'mode'] === 'group' && numTotal > 1;
  var groupFraction = 1 - fullLayout[traceType + 'gap'];
  var groupGapFraction = 1 - fullLayout[traceType + 'groupgap'];
  for (i = 0; i < boxList.length; i++) {
    calcTrace = calcdata[boxList[i]];
    var trace = calcTrace[0].trace;
    var t = calcTrace[0].t;
    var width = trace.width;
    var side = trace.side;

    // position coordinate delta
    var dPos;
    // box half width;
    var bdPos;
    // box center offset
    var bPos;
    // half-width within which to accept hover for this box/violin
    // always split the distance to the closest box/violin
    var wHover;
    if (width) {
      dPos = bdPos = wHover = width / 2;
      bPos = 0;
    } else {
      dPos = dPos0;
      if (group) {
        var groupId = getAxisGroup(fullLayout, posAxis._id) + trace.orientation;
        var alignmentGroups = fullLayout._alignmentOpts[groupId] || {};
        var alignmentGroupOpts = alignmentGroups[trace.alignmentgroup] || {};
        var nOffsetGroups = Object.keys(alignmentGroupOpts.offsetGroups || {}).length;
        var num = nOffsetGroups || numTotal;
        var shift = nOffsetGroups ? trace._offsetIndex : t.num;
        bdPos = dPos * groupFraction * groupGapFraction / num;
        bPos = 2 * dPos * (-0.5 + (shift + 0.5) / num) * groupFraction;
        wHover = dPos * groupFraction / num;
      } else {
        bdPos = dPos * groupFraction * groupGapFraction;
        bPos = 0;
        wHover = dPos;
      }
    }
    t.dPos = dPos;
    t.bPos = bPos;
    t.bdPos = bdPos;
    t.wHover = wHover;

    // box/violin-only value-space push value
    var pushplus;
    var pushminus;
    // edge of box/violin
    var edge = bPos + bdPos;
    var edgeplus;
    var edgeminus;
    // value-space padding
    var vpadplus;
    var vpadminus;
    // pixel-space padding
    var ppadplus;
    var ppadminus;
    // do we add 5% of both sides (more logic for points beyond box/violin below)
    var padded = Boolean(width);
    // does this trace show points?
    var hasPts = (trace.boxpoints || trace.points) && shownPts > 0;
    if (side === 'positive') {
      pushplus = dPos * (width ? 1 : 0.5);
      edgeplus = edge;
      pushminus = edgeplus = bPos;
    } else if (side === 'negative') {
      pushplus = edgeplus = bPos;
      pushminus = dPos * (width ? 1 : 0.5);
      edgeminus = edge;
    } else {
      pushplus = pushminus = dPos;
      edgeplus = edgeminus = edge;
    }
    if (hasPts) {
      var pointpos = trace.pointpos;
      var jitter = trace.jitter;
      var ms = trace.marker.size / 2;
      var pp = 0;
      if (pointpos + jitter >= 0) {
        pp = edge * (pointpos + jitter);
        if (pp > pushplus) {
          // (++) beyond plus-value, use pp
          padded = true;
          ppadplus = ms;
          vpadplus = pp;
        } else if (pp > edgeplus) {
          // (+), use push-value (it's bigger), but add px-pad
          ppadplus = ms;
          vpadplus = pushplus;
        }
      }
      if (pp <= pushplus) {
        // (->) fallback to push value
        vpadplus = pushplus;
      }
      var pm = 0;
      if (pointpos - jitter <= 0) {
        pm = -edge * (pointpos - jitter);
        if (pm > pushminus) {
          // (--) beyond plus-value, use pp
          padded = true;
          ppadminus = ms;
          vpadminus = pm;
        } else if (pm > edgeminus) {
          // (-), use push-value (it's bigger), but add px-pad
          ppadminus = ms;
          vpadminus = pushminus;
        }
      }
      if (pm <= pushminus) {
        // (<-) fallback to push value
        vpadminus = pushminus;
      }
    } else {
      vpadplus = pushplus;
      vpadminus = pushminus;
    }
    var pos = new Array(calcTrace.length);
    for (j = 0; j < calcTrace.length; j++) {
      pos[j] = calcTrace[j].pos;
    }
    trace._extremes[axId] = Axes.findExtremes(posAxis, pos, {
      padded: padded,
      vpadminus: vpadminus,
      vpadplus: vpadplus,
      vpadLinearized: true,
      // N.B. SVG px-space positive/negative
      ppadminus: {
        x: ppadminus,
        y: ppadplus
      }[axLetter],
      ppadplus: {
        x: ppadplus,
        y: ppadminus
      }[axLetter]
    });
  }
}
module.exports = {
  crossTraceCalc: crossTraceCalc,
  setPositionOffset: setPositionOffset
};

/***/ }),

/***/ 62294:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var Registry = __webpack_require__(33626);
var Color = __webpack_require__(78766);
var handlePeriodDefaults = __webpack_require__(99669);
var handleGroupingDefaults = __webpack_require__(36301);
var autoType = __webpack_require__(9666);
var attributes = __webpack_require__(64625);
function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
  function coerce(attr, dflt) {
    return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
  }
  handleSampleDefaults(traceIn, traceOut, coerce, layout);
  if (traceOut.visible === false) return;
  handlePeriodDefaults(traceIn, traceOut, layout, coerce);
  coerce('xhoverformat');
  coerce('yhoverformat');
  var hasPreCompStats = traceOut._hasPreCompStats;
  if (hasPreCompStats) {
    coerce('lowerfence');
    coerce('upperfence');
  }
  coerce('line.color', (traceIn.marker || {}).color || defaultColor);
  coerce('line.width');
  coerce('fillcolor', Color.addOpacity(traceOut.line.color, 0.5));
  var boxmeanDflt = false;
  if (hasPreCompStats) {
    var mean = coerce('mean');
    var sd = coerce('sd');
    if (mean && mean.length) {
      boxmeanDflt = true;
      if (sd && sd.length) boxmeanDflt = 'sd';
    }
  }
  coerce('whiskerwidth');
  var sizemode = coerce('sizemode');
  var boxmean;
  if (sizemode === 'quartiles') {
    boxmean = coerce('boxmean', boxmeanDflt);
  }
  coerce('showwhiskers', sizemode === 'quartiles');
  if (sizemode === 'sd' || boxmean === 'sd') {
    coerce('sdmultiple');
  }
  coerce('width');
  coerce('quartilemethod');
  var notchedDflt = false;
  if (hasPreCompStats) {
    var notchspan = coerce('notchspan');
    if (notchspan && notchspan.length) {
      notchedDflt = true;
    }
  } else if (Lib.validate(traceIn.notchwidth, attributes.notchwidth)) {
    notchedDflt = true;
  }
  var notched = coerce('notched', notchedDflt);
  if (notched) coerce('notchwidth');
  handlePointsDefaults(traceIn, traceOut, coerce, {
    prefix: 'box'
  });
  coerce('zorder');
}
function handleSampleDefaults(traceIn, traceOut, coerce, layout) {
  function getDims(arr) {
    var dims = 0;
    if (arr && arr.length) {
      dims += 1;
      if (Lib.isArrayOrTypedArray(arr[0]) && arr[0].length) {
        dims += 1;
      }
    }
    return dims;
  }
  function valid(astr) {
    return Lib.validate(traceIn[astr], attributes[astr]);
  }
  var y = coerce('y');
  var x = coerce('x');
  var sLen;
  if (traceOut.type === 'box') {
    var q1 = coerce('q1');
    var median = coerce('median');
    var q3 = coerce('q3');
    traceOut._hasPreCompStats = q1 && q1.length && median && median.length && q3 && q3.length;
    sLen = Math.min(Lib.minRowLength(q1), Lib.minRowLength(median), Lib.minRowLength(q3));
  }
  var yDims = getDims(y);
  var xDims = getDims(x);
  var yLen = yDims && Lib.minRowLength(y);
  var xLen = xDims && Lib.minRowLength(x);
  var calendar = layout.calendar;
  var opts = {
    autotypenumbers: layout.autotypenumbers
  };
  var defaultOrientation, len;
  if (traceOut._hasPreCompStats) {
    switch (String(xDims) + String(yDims)) {
      // no x / no y
      case '00':
        var setInX = valid('x0') || valid('dx');
        var setInY = valid('y0') || valid('dy');
        if (setInY && !setInX) {
          defaultOrientation = 'h';
        } else {
          defaultOrientation = 'v';
        }
        len = sLen;
        break;
      // just x
      case '10':
        defaultOrientation = 'v';
        len = Math.min(sLen, xLen);
        break;
      case '20':
        defaultOrientation = 'h';
        len = Math.min(sLen, x.length);
        break;
      // just y
      case '01':
        defaultOrientation = 'h';
        len = Math.min(sLen, yLen);
        break;
      case '02':
        defaultOrientation = 'v';
        len = Math.min(sLen, y.length);
        break;
      // both
      case '12':
        defaultOrientation = 'v';
        len = Math.min(sLen, xLen, y.length);
        break;
      case '21':
        defaultOrientation = 'h';
        len = Math.min(sLen, x.length, yLen);
        break;
      case '11':
        // this one is ill-defined
        len = 0;
        break;
      case '22':
        var hasCategories = false;
        var i;
        for (i = 0; i < x.length; i++) {
          if (autoType(x[i], calendar, opts) === 'category') {
            hasCategories = true;
            break;
          }
        }
        if (hasCategories) {
          defaultOrientation = 'v';
          len = Math.min(sLen, xLen, y.length);
        } else {
          for (i = 0; i < y.length; i++) {
            if (autoType(y[i], calendar, opts) === 'category') {
              hasCategories = true;
              break;
            }
          }
          if (hasCategories) {
            defaultOrientation = 'h';
            len = Math.min(sLen, x.length, yLen);
          } else {
            defaultOrientation = 'v';
            len = Math.min(sLen, xLen, y.length);
          }
        }
        break;
    }
  } else if (yDims > 0) {
    defaultOrientation = 'v';
    if (xDims > 0) {
      len = Math.min(xLen, yLen);
    } else {
      len = Math.min(yLen);
    }
  } else if (xDims > 0) {
    defaultOrientation = 'h';
    len = Math.min(xLen);
  } else {
    len = 0;
  }
  if (!len) {
    traceOut.visible = false;
    return;
  }
  traceOut._length = len;
  var orientation = coerce('orientation', defaultOrientation);

  // these are just used for positioning, they never define the sample
  if (traceOut._hasPreCompStats) {
    if (orientation === 'v' && xDims === 0) {
      coerce('x0', 0);
      coerce('dx', 1);
    } else if (orientation === 'h' && yDims === 0) {
      coerce('y0', 0);
      coerce('dy', 1);
    }
  } else {
    if (orientation === 'v' && xDims === 0) {
      coerce('x0');
    } else if (orientation === 'h' && yDims === 0) {
      coerce('y0');
    }
  }
  var handleCalendarDefaults = Registry.getComponentMethod('calendars', 'handleTraceDefaults');
  handleCalendarDefaults(traceIn, traceOut, ['x', 'y'], layout);
}
function handlePointsDefaults(traceIn, traceOut, coerce, opts) {
  var prefix = opts.prefix;
  var outlierColorDflt = Lib.coerce2(traceIn, traceOut, attributes, 'marker.outliercolor');
  var lineoutliercolor = coerce('marker.line.outliercolor');
  var modeDflt = 'outliers';
  if (traceOut._hasPreCompStats) {
    modeDflt = 'all';
  } else if (outlierColorDflt || lineoutliercolor) {
    modeDflt = 'suspectedoutliers';
  }
  var mode = coerce(prefix + 'points', modeDflt);
  if (mode) {
    coerce('jitter', mode === 'all' ? 0.3 : 0);
    coerce('pointpos', mode === 'all' ? -1.5 : 0);
    coerce('marker.symbol');
    coerce('marker.opacity');
    coerce('marker.size');
    coerce('marker.angle');
    coerce('marker.color', traceOut.line.color);
    coerce('marker.line.color');
    coerce('marker.line.width');
    if (mode === 'suspectedoutliers') {
      coerce('marker.line.outliercolor', traceOut.marker.color);
      coerce('marker.line.outlierwidth');
    }
    coerce('selected.marker.color');
    coerce('unselected.marker.color');
    coerce('selected.marker.size');
    coerce('unselected.marker.size');
    coerce('text');
    coerce('hovertext');
  } else {
    delete traceOut.marker;
  }
  var hoveron = coerce('hoveron');
  if (hoveron === 'all' || hoveron.indexOf('points') !== -1) {
    coerce('hovertemplate');
  }
  Lib.coerceSelectionMarkerOpacity(traceOut, coerce);
}
function crossTraceDefaults(fullData, fullLayout) {
  var traceIn, traceOut;
  function coerce(attr) {
    return Lib.coerce(traceOut._input, traceOut, attributes, attr);
  }
  for (var i = 0; i < fullData.length; i++) {
    traceOut = fullData[i];
    var traceType = traceOut.type;
    if (traceType === 'box' || traceType === 'violin') {
      traceIn = traceOut._input;
      if (fullLayout[traceType + 'mode'] === 'group') {
        handleGroupingDefaults(traceIn, traceOut, fullLayout, coerce);
      }
    }
  }
}
module.exports = {
  supplyDefaults: supplyDefaults,
  crossTraceDefaults: crossTraceDefaults,
  handleSampleDefaults: handleSampleDefaults,
  handlePointsDefaults: handlePointsDefaults
};

/***/ }),

/***/ 76429:
/***/ (function(module) {

"use strict";


module.exports = function eventData(out, pt) {
  // Note: hoverOnBox property is needed for click-to-select
  // to ignore when a box was clicked. This is the reason box
  // implements this custom eventData function.
  if (pt.hoverOnBox) out.hoverOnBox = pt.hoverOnBox;
  if ('xVal' in pt) out.x = pt.xVal;
  if ('yVal' in pt) out.y = pt.yVal;
  if (pt.xa) out.xaxis = pt.xa;
  if (pt.ya) out.yaxis = pt.ya;
  return out;
};

/***/ }),

/***/ 11448:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Axes = __webpack_require__(29714);
var Lib = __webpack_require__(34809);
var Fx = __webpack_require__(32141);
var Color = __webpack_require__(78766);
var fillText = Lib.fillText;
function hoverPoints(pointData, xval, yval, hovermode) {
  var cd = pointData.cd;
  var trace = cd[0].trace;
  var hoveron = trace.hoveron;
  var closeBoxData = [];
  var closePtData;
  if (hoveron.indexOf('boxes') !== -1) {
    closeBoxData = closeBoxData.concat(hoverOnBoxes(pointData, xval, yval, hovermode));
  }
  if (hoveron.indexOf('points') !== -1) {
    closePtData = hoverOnPoints(pointData, xval, yval);
  }

  // If there's a point in range and hoveron has points, show the best single point only.
  // If hoveron has boxes and there's no point in range (or hoveron doesn't have points), show the box stats.
  if (hovermode === 'closest') {
    if (closePtData) return [closePtData];
    return closeBoxData;
  }

  // Otherwise in compare mode, allow a point AND the box stats to be labeled
  // If there are multiple boxes in range (ie boxmode = 'overlay') we'll see stats for all of them.
  if (closePtData) {
    closeBoxData.push(closePtData);
    return closeBoxData;
  }
  return closeBoxData;
}
function hoverOnBoxes(pointData, xval, yval, hovermode) {
  var cd = pointData.cd;
  var xa = pointData.xa;
  var ya = pointData.ya;
  var trace = cd[0].trace;
  var t = cd[0].t;
  var isViolin = trace.type === 'violin';
  var pLetter, vLetter, pAxis, vAxis, vVal, pVal, dx, dy, dPos, hoverPseudoDistance, spikePseudoDistance;
  var boxDelta = t.bdPos;
  var boxDeltaPos, boxDeltaNeg;
  var posAcceptance = t.wHover;
  var shiftPos = function (di) {
    return pAxis.c2l(di.pos) + t.bPos - pAxis.c2l(pVal);
  };
  if (isViolin && trace.side !== 'both') {
    if (trace.side === 'positive') {
      dPos = function (di) {
        var pos = shiftPos(di);
        return Fx.inbox(pos, pos + posAcceptance, hoverPseudoDistance);
      };
      boxDeltaPos = boxDelta;
      boxDeltaNeg = 0;
    }
    if (trace.side === 'negative') {
      dPos = function (di) {
        var pos = shiftPos(di);
        return Fx.inbox(pos - posAcceptance, pos, hoverPseudoDistance);
      };
      boxDeltaPos = 0;
      boxDeltaNeg = boxDelta;
    }
  } else {
    dPos = function (di) {
      var pos = shiftPos(di);
      return Fx.inbox(pos - posAcceptance, pos + posAcceptance, hoverPseudoDistance);
    };
    boxDeltaPos = boxDeltaNeg = boxDelta;
  }
  var dVal;
  if (isViolin) {
    dVal = function (di) {
      return Fx.inbox(di.span[0] - vVal, di.span[1] - vVal, hoverPseudoDistance);
    };
  } else {
    dVal = function (di) {
      return Fx.inbox(di.min - vVal, di.max - vVal, hoverPseudoDistance);
    };
  }
  if (trace.orientation === 'h') {
    vVal = xval;
    pVal = yval;
    dx = dVal;
    dy = dPos;
    pLetter = 'y';
    pAxis = ya;
    vLetter = 'x';
    vAxis = xa;
  } else {
    vVal = yval;
    pVal = xval;
    dx = dPos;
    dy = dVal;
    pLetter = 'x';
    pAxis = xa;
    vLetter = 'y';
    vAxis = ya;
  }

  // if two boxes are overlaying, let the narrowest one win
  var pseudoDistance = Math.min(1, boxDelta / Math.abs(pAxis.r2c(pAxis.range[1]) - pAxis.r2c(pAxis.range[0])));
  hoverPseudoDistance = pointData.maxHoverDistance - pseudoDistance;
  spikePseudoDistance = pointData.maxSpikeDistance - pseudoDistance;
  function dxy(di) {
    return (dx(di) + dy(di)) / 2;
  }
  var distfn = Fx.getDistanceFunction(hovermode, dx, dy, dxy);
  Fx.getClosest(cd, distfn, pointData);

  // skip the rest (for this trace) if we didn't find a close point
  // and create the item(s) in closedata for this point
  if (pointData.index === false) return [];
  var di = cd[pointData.index];
  var lc = trace.line.color;
  var mc = (trace.marker || {}).color;
  if (Color.opacity(lc) && trace.line.width) pointData.color = lc;else if (Color.opacity(mc) && trace.boxpoints) pointData.color = mc;else pointData.color = trace.fillcolor;
  pointData[pLetter + '0'] = pAxis.c2p(di.pos + t.bPos - boxDeltaNeg, true);
  pointData[pLetter + '1'] = pAxis.c2p(di.pos + t.bPos + boxDeltaPos, true);
  pointData[pLetter + 'LabelVal'] = di.orig_p !== undefined ? di.orig_p : di.pos;
  var spikePosAttr = pLetter + 'Spike';
  pointData.spikeDistance = dxy(di) * spikePseudoDistance / hoverPseudoDistance;
  pointData[spikePosAttr] = pAxis.c2p(di.pos, true);
  var hasMean = trace.boxmean || trace.sizemode === 'sd' || (trace.meanline || {}).visible;
  var hasFences = trace.boxpoints || trace.points;

  // labels with equal values (e.g. when min === q1) should still be presented in the order they have when they're unequal
  var attrs = hasFences && hasMean ? ['max', 'uf', 'q3', 'med', 'mean', 'q1', 'lf', 'min'] : hasFences && !hasMean ? ['max', 'uf', 'q3', 'med', 'q1', 'lf', 'min'] : !hasFences && hasMean ? ['max', 'q3', 'med', 'mean', 'q1', 'min'] : ['max', 'q3', 'med', 'q1', 'min'];
  var rev = vAxis.range[1] < vAxis.range[0];
  if (trace.orientation === (rev ? 'v' : 'h')) {
    attrs.reverse();
  }
  var spikeDistance = pointData.spikeDistance;
  var spikePosition = pointData[spikePosAttr];
  var closeBoxData = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!(attr in di)) continue;

    // copy out to a new object for each value to label
    var val = di[attr];
    var valPx = vAxis.c2p(val, true);
    var pointData2 = Lib.extendFlat({}, pointData);
    pointData2.attr = attr;
    pointData2[vLetter + '0'] = pointData2[vLetter + '1'] = valPx;
    pointData2[vLetter + 'LabelVal'] = val;
    pointData2[vLetter + 'Label'] = (t.labels ? t.labels[attr] + ' ' : '') + Axes.hoverLabelText(vAxis, val, trace[vLetter + 'hoverformat']);

    // Note: introduced to be able to distinguish a
    // clicked point from a box during click-to-select
    pointData2.hoverOnBox = true;
    if (attr === 'mean' && 'sd' in di && (trace.boxmean === 'sd' || trace.sizemode === 'sd')) {
      pointData2[vLetter + 'err'] = di.sd;
    }

    // no hovertemplate support yet
    pointData2.hovertemplate = false;
    closeBoxData.push(pointData2);
  }

  // only keep name and spikes on the median
  pointData.name = '';
  pointData.spikeDistance = undefined;
  pointData[spikePosAttr] = undefined;
  for (var k = 0; k < closeBoxData.length; k++) {
    if (closeBoxData[k].attr !== 'med') {
      closeBoxData[k].name = '';
      closeBoxData[k].spikeDistance = undefined;
      closeBoxData[k][spikePosAttr] = undefined;
    } else {
      closeBoxData[k].spikeDistance = spikeDistance;
      closeBoxData[k][spikePosAttr] = spikePosition;
    }
  }
  return closeBoxData;
}
function hoverOnPoints(pointData, xval, yval) {
  var cd = pointData.cd;
  var xa = pointData.xa;
  var ya = pointData.ya;
  var trace = cd[0].trace;
  var xPx = xa.c2p(xval);
  var yPx = ya.c2p(yval);
  var closePtData;
  var dx = function (di) {
    var rad = Math.max(3, di.mrc || 0);
    return Math.max(Math.abs(xa.c2p(di.x) - xPx) - rad, 1 - 3 / rad);
  };
  var dy = function (di) {
    var rad = Math.max(3, di.mrc || 0);
    return Math.max(Math.abs(ya.c2p(di.y) - yPx) - rad, 1 - 3 / rad);
  };
  var distfn = Fx.quadrature(dx, dy);

  // show one point per trace
  var ijClosest = false;
  var di, pt;
  for (var i = 0; i < cd.length; i++) {
    di = cd[i];
    for (var j = 0; j < (di.pts || []).length; j++) {
      pt = di.pts[j];
      var newDistance = distfn(pt);
      if (newDistance <= pointData.distance) {
        pointData.distance = newDistance;
        ijClosest = [i, j];
      }
    }
  }
  if (!ijClosest) return false;
  di = cd[ijClosest[0]];
  pt = di.pts[ijClosest[1]];
  var xc = xa.c2p(pt.x, true);
  var yc = ya.c2p(pt.y, true);
  var rad = pt.mrc || 1;
  closePtData = Lib.extendFlat({}, pointData, {
    // corresponds to index in x/y input data array
    index: pt.i,
    color: (trace.marker || {}).color,
    name: trace.name,
    x0: xc - rad,
    x1: xc + rad,
    y0: yc - rad,
    y1: yc + rad,
    spikeDistance: pointData.distance,
    hovertemplate: trace.hovertemplate
  });
  var origPos = di.orig_p;
  var pos = origPos !== undefined ? origPos : di.pos;
  var pa;
  if (trace.orientation === 'h') {
    pa = ya;
    closePtData.xLabelVal = pt.x;
    closePtData.yLabelVal = pos;
  } else {
    pa = xa;
    closePtData.xLabelVal = pos;
    closePtData.yLabelVal = pt.y;
  }
  var pLetter = pa._id.charAt(0);
  closePtData[pLetter + 'Spike'] = pa.c2p(di.pos, true);
  fillText(pt, trace, closePtData);
  return closePtData;
}
module.exports = {
  hoverPoints: hoverPoints,
  hoverOnBoxes: hoverOnBoxes,
  hoverOnPoints: hoverOnPoints
};

/***/ }),

/***/ 53794:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = {
  attributes: __webpack_require__(64625),
  layoutAttributes: __webpack_require__(64636),
  supplyDefaults: (__webpack_require__(62294).supplyDefaults),
  crossTraceDefaults: (__webpack_require__(62294).crossTraceDefaults),
  supplyLayoutDefaults: (__webpack_require__(65067).supplyLayoutDefaults),
  calc: __webpack_require__(89429),
  crossTraceCalc: (__webpack_require__(81606).crossTraceCalc),
  plot: (__webpack_require__(95419).plot),
  style: (__webpack_require__(59979).style),
  styleOnSelect: (__webpack_require__(59979).styleOnSelect),
  hoverPoints: (__webpack_require__(11448).hoverPoints),
  eventData: __webpack_require__(76429),
  selectPoints: __webpack_require__(72488),
  moduleType: 'trace',
  name: 'box',
  basePlotModule: __webpack_require__(37703),
  categories: ['cartesian', 'svg', 'symbols', 'oriented', 'box-violin', 'showLegend', 'boxLayout', 'zoomScale'],
  meta: {}
};

/***/ }),

/***/ 64636:
/***/ (function(module) {

"use strict";


module.exports = {
  boxmode: {
    valType: 'enumerated',
    values: ['group', 'overlay'],
    dflt: 'overlay',
    editType: 'calc'
  },
  boxgap: {
    valType: 'number',
    min: 0,
    max: 1,
    dflt: 0.3,
    editType: 'calc'
  },
  boxgroupgap: {
    valType: 'number',
    min: 0,
    max: 1,
    dflt: 0.3,
    editType: 'calc'
  }
};

/***/ }),

/***/ 65067:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Registry = __webpack_require__(33626);
var Lib = __webpack_require__(34809);
var layoutAttributes = __webpack_require__(64636);
function _supply(layoutIn, layoutOut, fullData, coerce, traceType) {
  var category = traceType + 'Layout';
  var hasTraceType = false;
  for (var i = 0; i < fullData.length; i++) {
    var trace = fullData[i];
    if (Registry.traceIs(trace, category)) {
      hasTraceType = true;
      break;
    }
  }
  if (!hasTraceType) return;
  coerce(traceType + 'mode');
  coerce(traceType + 'gap');
  coerce(traceType + 'groupgap');
}
function supplyLayoutDefaults(layoutIn, layoutOut, fullData) {
  function coerce(attr, dflt) {
    return Lib.coerce(layoutIn, layoutOut, layoutAttributes, attr, dflt);
  }
  _supply(layoutIn, layoutOut, fullData, coerce, 'box');
}
module.exports = {
  supplyLayoutDefaults: supplyLayoutDefaults,
  _supply: _supply
};

/***/ }),

/***/ 95419:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var Lib = __webpack_require__(34809);
var Drawing = __webpack_require__(62203);

// constants for dynamic jitter (ie less jitter for sparser points)
var JITTERCOUNT = 5; // points either side of this to include
var JITTERSPREAD = 0.01; // fraction of IQR to count as "dense"

function plot(gd, plotinfo, cdbox, boxLayer) {
  var isStatic = gd._context.staticPlot;
  var xa = plotinfo.xaxis;
  var ya = plotinfo.yaxis;
  Lib.makeTraceGroups(boxLayer, cdbox, 'trace boxes').each(function (cd) {
    var plotGroup = d3.select(this);
    var cd0 = cd[0];
    var t = cd0.t;
    var trace = cd0.trace;

    // whisker width
    t.wdPos = t.bdPos * trace.whiskerwidth;
    if (trace.visible !== true || t.empty) {
      plotGroup.remove();
      return;
    }
    var posAxis, valAxis;
    if (trace.orientation === 'h') {
      posAxis = ya;
      valAxis = xa;
    } else {
      posAxis = xa;
      valAxis = ya;
    }
    plotBoxAndWhiskers(plotGroup, {
      pos: posAxis,
      val: valAxis
    }, trace, t, isStatic);
    plotPoints(plotGroup, {
      x: xa,
      y: ya
    }, trace, t);
    plotBoxMean(plotGroup, {
      pos: posAxis,
      val: valAxis
    }, trace, t);
  });
}
function plotBoxAndWhiskers(sel, axes, trace, t, isStatic) {
  var isHorizontal = trace.orientation === 'h';
  var valAxis = axes.val;
  var posAxis = axes.pos;
  var posHasRangeBreaks = !!posAxis.rangebreaks;
  var bPos = t.bPos;
  var wdPos = t.wdPos || 0;
  var bPosPxOffset = t.bPosPxOffset || 0;
  var whiskerWidth = trace.whiskerwidth || 0;
  var showWhiskers = trace.showwhiskers !== false;
  var notched = trace.notched || false;
  var nw = notched ? 1 - 2 * trace.notchwidth : 1;

  // to support for one-sided box
  var bdPos0;
  var bdPos1;
  if (Array.isArray(t.bdPos)) {
    bdPos0 = t.bdPos[0];
    bdPos1 = t.bdPos[1];
  } else {
    bdPos0 = t.bdPos;
    bdPos1 = t.bdPos;
  }
  var paths = sel.selectAll('path.box').data(trace.type !== 'violin' || trace.box.visible ? Lib.identity : []);
  paths.enter().append('path').style('vector-effect', isStatic ? 'none' : 'non-scaling-stroke').attr('class', 'box');
  paths.exit().remove();
  paths.each(function (d) {
    if (d.empty) return d3.select(this).attr('d', 'M0,0Z');
    var lcenter = posAxis.c2l(d.pos + bPos, true);
    var pos0 = posAxis.l2p(lcenter - bdPos0) + bPosPxOffset;
    var pos1 = posAxis.l2p(lcenter + bdPos1) + bPosPxOffset;
    var posc = posHasRangeBreaks ? (pos0 + pos1) / 2 : posAxis.l2p(lcenter) + bPosPxOffset;
    var r = trace.whiskerwidth;
    var posw0 = posHasRangeBreaks ? pos0 * r + (1 - r) * posc : posAxis.l2p(lcenter - wdPos) + bPosPxOffset;
    var posw1 = posHasRangeBreaks ? pos1 * r + (1 - r) * posc : posAxis.l2p(lcenter + wdPos) + bPosPxOffset;
    var posm0 = posAxis.l2p(lcenter - bdPos0 * nw) + bPosPxOffset;
    var posm1 = posAxis.l2p(lcenter + bdPos1 * nw) + bPosPxOffset;
    var sdmode = trace.sizemode === 'sd';
    var q1 = valAxis.c2p(sdmode ? d.mean - d.sd : d.q1, true);
    var q3 = sdmode ? valAxis.c2p(d.mean + d.sd, true) : valAxis.c2p(d.q3, true);
    // make sure median isn't identical to either of the
    // quartiles, so we can see it
    var m = Lib.constrain(sdmode ? valAxis.c2p(d.mean, true) : valAxis.c2p(d.med, true), Math.min(q1, q3) + 1, Math.max(q1, q3) - 1);

    // for compatibility with box, violin, and candlestick
    // perhaps we should put this into cd0.t instead so it's more explicit,
    // but what we have now is:
    // - box always has d.lf, but boxpoints can be anything
    // - violin has d.lf and should always use it (boxpoints is undefined)
    // - candlestick has only min/max
    var useExtremes = d.lf === undefined || trace.boxpoints === false || sdmode;
    var lf = valAxis.c2p(useExtremes ? d.min : d.lf, true);
    var uf = valAxis.c2p(useExtremes ? d.max : d.uf, true);
    var ln = valAxis.c2p(d.ln, true);
    var un = valAxis.c2p(d.un, true);
    if (isHorizontal) {
      d3.select(this).attr('d', 'M' + m + ',' + posm0 + 'V' + posm1 +
      // median line
      'M' + q1 + ',' + pos0 + 'V' + pos1 + (
      // left edge
      notched ? 'H' + ln + 'L' + m + ',' + posm1 + 'L' + un + ',' + pos1 : '') +
      // top notched edge
      'H' + q3 +
      // end of the top edge
      'V' + pos0 + (
      // right edge
      notched ? 'H' + un + 'L' + m + ',' + posm0 + 'L' + ln + ',' + pos0 : '') +
      // bottom notched edge
      'Z' + (
      // end of the box
      showWhiskers ? 'M' + q1 + ',' + posc + 'H' + lf + 'M' + q3 + ',' + posc + 'H' + uf + (
      // whiskers
      whiskerWidth === 0 ? '' :
      // whisker caps
      'M' + lf + ',' + posw0 + 'V' + posw1 + 'M' + uf + ',' + posw0 + 'V' + posw1) : ''));
    } else {
      d3.select(this).attr('d', 'M' + posm0 + ',' + m + 'H' + posm1 +
      // median line
      'M' + pos0 + ',' + q1 + 'H' + pos1 + (
      // top of the box
      notched ? 'V' + ln + 'L' + posm1 + ',' + m + 'L' + pos1 + ',' + un : '') +
      // notched right edge
      'V' + q3 +
      // end of the right edge
      'H' + pos0 + (
      // bottom of the box
      notched ? 'V' + un + 'L' + posm0 + ',' + m + 'L' + pos0 + ',' + ln : '') +
      // notched left edge
      'Z' + (
      // end of the box
      showWhiskers ? 'M' + posc + ',' + q1 + 'V' + lf + 'M' + posc + ',' + q3 + 'V' + uf + (
      // whiskers
      whiskerWidth === 0 ? '' :
      // whisker caps
      'M' + posw0 + ',' + lf + 'H' + posw1 + 'M' + posw0 + ',' + uf + 'H' + posw1) : ''));
    }
  });
}
function plotPoints(sel, axes, trace, t) {
  var xa = axes.x;
  var ya = axes.y;
  var bdPos = t.bdPos;
  var bPos = t.bPos;

  // to support violin points
  var mode = trace.boxpoints || trace.points;

  // repeatable pseudo-random number generator
  Lib.seedPseudoRandom();

  // since box plot points get an extra level of nesting, each
  // box needs the trace styling info
  var fn = function (d) {
    d.forEach(function (v) {
      v.t = t;
      v.trace = trace;
    });
    return d;
  };
  var gPoints = sel.selectAll('g.points').data(mode ? fn : []);
  gPoints.enter().append('g').attr('class', 'points');
  gPoints.exit().remove();
  var paths = gPoints.selectAll('path').data(function (d) {
    var i;
    var pts = d.pts2;

    // normally use IQR, but if this is 0 or too small, use max-min
    var typicalSpread = Math.max((d.max - d.min) / 10, d.q3 - d.q1);
    var minSpread = typicalSpread * 1e-9;
    var spreadLimit = typicalSpread * JITTERSPREAD;
    var jitterFactors = [];
    var maxJitterFactor = 0;
    var newJitter;

    // dynamic jitter
    if (trace.jitter) {
      if (typicalSpread === 0) {
        // edge case of no spread at all: fall back to max jitter
        maxJitterFactor = 1;
        jitterFactors = new Array(pts.length);
        for (i = 0; i < pts.length; i++) {
          jitterFactors[i] = 1;
        }
      } else {
        for (i = 0; i < pts.length; i++) {
          var i0 = Math.max(0, i - JITTERCOUNT);
          var pmin = pts[i0].v;
          var i1 = Math.min(pts.length - 1, i + JITTERCOUNT);
          var pmax = pts[i1].v;
          if (mode !== 'all') {
            if (pts[i].v < d.lf) pmax = Math.min(pmax, d.lf);else pmin = Math.max(pmin, d.uf);
          }
          var jitterFactor = Math.sqrt(spreadLimit * (i1 - i0) / (pmax - pmin + minSpread)) || 0;
          jitterFactor = Lib.constrain(Math.abs(jitterFactor), 0, 1);
          jitterFactors.push(jitterFactor);
          maxJitterFactor = Math.max(jitterFactor, maxJitterFactor);
        }
      }
      newJitter = trace.jitter * 2 / (maxJitterFactor || 1);
    }

    // fills in 'x' and 'y' in calcdata 'pts' item
    for (i = 0; i < pts.length; i++) {
      var pt = pts[i];
      var v = pt.v;
      var jitterOffset = trace.jitter ? newJitter * jitterFactors[i] * (Lib.pseudoRandom() - 0.5) : 0;
      var posPx = d.pos + bPos + bdPos * (trace.pointpos + jitterOffset);
      if (trace.orientation === 'h') {
        pt.y = posPx;
        pt.x = v;
      } else {
        pt.x = posPx;
        pt.y = v;
      }

      // tag suspected outliers
      if (mode === 'suspectedoutliers' && v < d.uo && v > d.lo) {
        pt.so = true;
      }
    }
    return pts;
  });
  paths.enter().append('path').classed('point', true);
  paths.exit().remove();
  paths.call(Drawing.translatePoints, xa, ya);
}
function plotBoxMean(sel, axes, trace, t) {
  var valAxis = axes.val;
  var posAxis = axes.pos;
  var posHasRangeBreaks = !!posAxis.rangebreaks;
  var bPos = t.bPos;
  var bPosPxOffset = t.bPosPxOffset || 0;

  // to support violin mean lines
  var mode = trace.boxmean || (trace.meanline || {}).visible;

  // to support for one-sided box
  var bdPos0;
  var bdPos1;
  if (Array.isArray(t.bdPos)) {
    bdPos0 = t.bdPos[0];
    bdPos1 = t.bdPos[1];
  } else {
    bdPos0 = t.bdPos;
    bdPos1 = t.bdPos;
  }
  var paths = sel.selectAll('path.mean').data(trace.type === 'box' && trace.boxmean || trace.type === 'violin' && trace.box.visible && trace.meanline.visible ? Lib.identity : []);
  paths.enter().append('path').attr('class', 'mean').style({
    fill: 'none',
    'vector-effect': 'non-scaling-stroke'
  });
  paths.exit().remove();
  paths.each(function (d) {
    var lcenter = posAxis.c2l(d.pos + bPos, true);
    var pos0 = posAxis.l2p(lcenter - bdPos0) + bPosPxOffset;
    var pos1 = posAxis.l2p(lcenter + bdPos1) + bPosPxOffset;
    var posc = posHasRangeBreaks ? (pos0 + pos1) / 2 : posAxis.l2p(lcenter) + bPosPxOffset;
    var m = valAxis.c2p(d.mean, true);
    var sl = valAxis.c2p(d.mean - d.sd, true);
    var sh = valAxis.c2p(d.mean + d.sd, true);
    if (trace.orientation === 'h') {
      d3.select(this).attr('d', 'M' + m + ',' + pos0 + 'V' + pos1 + (mode === 'sd' ? 'm0,0L' + sl + ',' + posc + 'L' + m + ',' + pos0 + 'L' + sh + ',' + posc + 'Z' : ''));
    } else {
      d3.select(this).attr('d', 'M' + pos0 + ',' + m + 'H' + pos1 + (mode === 'sd' ? 'm0,0L' + posc + ',' + sl + 'L' + pos0 + ',' + m + 'L' + posc + ',' + sh + 'Z' : ''));
    }
  });
}
module.exports = {
  plot: plot,
  plotBoxAndWhiskers: plotBoxAndWhiskers,
  plotPoints: plotPoints,
  plotBoxMean: plotBoxMean
};

/***/ }),

/***/ 72488:
/***/ (function(module) {

"use strict";


module.exports = function selectPoints(searchInfo, selectionTester) {
  var cd = searchInfo.cd;
  var xa = searchInfo.xaxis;
  var ya = searchInfo.yaxis;
  var selection = [];
  var i, j;
  if (selectionTester === false) {
    for (i = 0; i < cd.length; i++) {
      for (j = 0; j < (cd[i].pts || []).length; j++) {
        // clear selection
        cd[i].pts[j].selected = 0;
      }
    }
  } else {
    for (i = 0; i < cd.length; i++) {
      for (j = 0; j < (cd[i].pts || []).length; j++) {
        var pt = cd[i].pts[j];
        var x = xa.c2p(pt.x);
        var y = ya.c2p(pt.y);
        if (selectionTester.contains([x, y], null, pt.i, searchInfo)) {
          selection.push({
            pointNumber: pt.i,
            x: xa.c2d(pt.x),
            y: ya.c2d(pt.y)
          });
          pt.selected = 1;
        } else {
          pt.selected = 0;
        }
      }
    }
  }
  return selection;
};

/***/ }),

/***/ 59979:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var Color = __webpack_require__(78766);
var Drawing = __webpack_require__(62203);
function style(gd, cd, sel) {
  var s = sel ? sel : d3.select(gd).selectAll('g.trace.boxes');
  s.style('opacity', function (d) {
    return d[0].trace.opacity;
  });
  s.each(function (d) {
    var el = d3.select(this);
    var trace = d[0].trace;
    var lineWidth = trace.line.width;
    function styleBox(boxSel, lineWidth, lineColor, fillColor) {
      boxSel.style('stroke-width', lineWidth + 'px').call(Color.stroke, lineColor).call(Color.fill, fillColor);
    }
    var allBoxes = el.selectAll('path.box');
    if (trace.type === 'candlestick') {
      allBoxes.each(function (boxData) {
        if (boxData.empty) return;
        var thisBox = d3.select(this);
        var container = trace[boxData.dir]; // dir = 'increasing' or 'decreasing'
        styleBox(thisBox, container.line.width, container.line.color, container.fillcolor);
        // TODO: custom selection style for candlesticks
        thisBox.style('opacity', trace.selectedpoints && !boxData.selected ? 0.3 : 1);
      });
    } else {
      styleBox(allBoxes, lineWidth, trace.line.color, trace.fillcolor);
      el.selectAll('path.mean').style({
        'stroke-width': lineWidth,
        'stroke-dasharray': 2 * lineWidth + 'px,' + lineWidth + 'px'
      }).call(Color.stroke, trace.line.color);
      var pts = el.selectAll('path.point');
      Drawing.pointStyle(pts, trace, gd);
    }
  });
}
function styleOnSelect(gd, cd, sel) {
  var trace = cd[0].trace;
  var pts = sel.selectAll('path.point');
  if (trace.selectedpoints) {
    Drawing.selectedPointStyle(pts, trace);
  } else {
    Drawing.pointStyle(pts, trace, gd);
  }
}
module.exports = {
  style: style,
  styleOnSelect: styleOnSelect
};

/***/ }),

/***/ 24319:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var extendFlat = (__webpack_require__(34809).extendFlat);
var axisHoverFormat = (__webpack_require__(80712).axisHoverFormat);
var OHLCattrs = __webpack_require__(86706);
var boxAttrs = __webpack_require__(64625);
function directionAttrs(lineColorDefault) {
  return {
    line: {
      color: extendFlat({}, boxAttrs.line.color, {
        dflt: lineColorDefault
      }),
      width: boxAttrs.line.width,
      editType: 'style'
    },
    fillcolor: boxAttrs.fillcolor,
    editType: 'style'
  };
}
module.exports = {
  xperiod: OHLCattrs.xperiod,
  xperiod0: OHLCattrs.xperiod0,
  xperiodalignment: OHLCattrs.xperiodalignment,
  xhoverformat: axisHoverFormat('x'),
  yhoverformat: axisHoverFormat('y'),
  x: OHLCattrs.x,
  open: OHLCattrs.open,
  high: OHLCattrs.high,
  low: OHLCattrs.low,
  close: OHLCattrs.close,
  line: {
    width: extendFlat({}, boxAttrs.line.width, {}),
    editType: 'style'
  },
  increasing: directionAttrs(OHLCattrs.increasing.line.color.dflt),
  decreasing: directionAttrs(OHLCattrs.decreasing.line.color.dflt),
  text: OHLCattrs.text,
  hovertext: OHLCattrs.hovertext,
  whiskerwidth: extendFlat({}, boxAttrs.whiskerwidth, {
    dflt: 0
  }),
  hoverlabel: OHLCattrs.hoverlabel,
  zorder: boxAttrs.zorder
};

/***/ }),

/***/ 63679:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var Axes = __webpack_require__(29714);
var alignPeriod = __webpack_require__(40528);
var calcCommon = (__webpack_require__(95694).calcCommon);
module.exports = function (gd, trace) {
  var fullLayout = gd._fullLayout;
  var xa = Axes.getFromId(gd, trace.xaxis);
  var ya = Axes.getFromId(gd, trace.yaxis);
  var origX = xa.makeCalcdata(trace, 'x');
  var x = alignPeriod(trace, xa, 'x', origX).vals;
  var cd = calcCommon(gd, trace, origX, x, ya, ptFunc);
  if (cd.length) {
    Lib.extendFlat(cd[0].t, {
      num: fullLayout._numBoxes,
      dPos: Lib.distinctVals(x).minDiff / 2,
      posLetter: 'x',
      valLetter: 'y'
    });
    fullLayout._numBoxes++;
    return cd;
  } else {
    return [{
      t: {
        empty: true
      }
    }];
  }
};
function ptFunc(o, h, l, c) {
  return {
    min: l,
    q1: Math.min(o, c),
    med: c,
    q3: Math.max(o, c),
    max: h
  };
}

/***/ }),

/***/ 57336:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var Color = __webpack_require__(78766);
var handleOHLC = __webpack_require__(28270);
var handlePeriodDefaults = __webpack_require__(99669);
var attributes = __webpack_require__(24319);
module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
  function coerce(attr, dflt) {
    return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
  }
  var len = handleOHLC(traceIn, traceOut, coerce, layout);
  if (!len) {
    traceOut.visible = false;
    return;
  }
  handlePeriodDefaults(traceIn, traceOut, layout, coerce, {
    x: true
  });
  coerce('xhoverformat');
  coerce('yhoverformat');
  coerce('line.width');
  handleDirection(traceIn, traceOut, coerce, 'increasing');
  handleDirection(traceIn, traceOut, coerce, 'decreasing');
  coerce('text');
  coerce('hovertext');
  coerce('whiskerwidth');
  layout._requestRangeslider[traceOut.xaxis] = true;
  coerce('zorder');
};
function handleDirection(traceIn, traceOut, coerce, direction) {
  var lineColor = coerce(direction + '.line.color');
  coerce(direction + '.line.width', traceOut.line.width);
  coerce(direction + '.fillcolor', Color.addOpacity(lineColor, 0.5));
}

/***/ }),

/***/ 51252:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = {
  moduleType: 'trace',
  name: 'candlestick',
  basePlotModule: __webpack_require__(37703),
  categories: ['cartesian', 'svg', 'showLegend', 'candlestick', 'boxLayout'],
  meta: {},
  attributes: __webpack_require__(24319),
  layoutAttributes: __webpack_require__(64636),
  supplyLayoutDefaults: (__webpack_require__(65067).supplyLayoutDefaults),
  crossTraceCalc: (__webpack_require__(81606).crossTraceCalc),
  supplyDefaults: __webpack_require__(57336),
  calc: __webpack_require__(63679),
  plot: (__webpack_require__(95419).plot),
  layerName: 'boxlayer',
  style: (__webpack_require__(59979).style),
  hoverPoints: (__webpack_require__(93245).hoverPoints),
  selectPoints: __webpack_require__(49343)
};

/***/ }),

/***/ 8432:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var handleAxisDefaults = __webpack_require__(6038);
var Template = __webpack_require__(78032);
module.exports = function handleABDefaults(traceIn, traceOut, fullLayout, coerce, dfltColor) {
  var a = coerce('a');
  if (!a) {
    coerce('da');
    coerce('a0');
  }
  var b = coerce('b');
  if (!b) {
    coerce('db');
    coerce('b0');
  }
  mimickAxisDefaults(traceIn, traceOut, fullLayout, dfltColor);
};
function mimickAxisDefaults(traceIn, traceOut, fullLayout, dfltColor) {
  var axesList = ['aaxis', 'baxis'];
  axesList.forEach(function (axName) {
    var axLetter = axName.charAt(0);
    var axIn = traceIn[axName] || {};
    var axOut = Template.newContainer(traceOut, axName);
    var defaultOptions = {
      noAutotickangles: true,
      noTicklabelshift: true,
      noTicklabelstandoff: true,
      noTicklabelstep: true,
      tickfont: 'x',
      id: axLetter + 'axis',
      letter: axLetter,
      font: traceOut.font,
      name: axName,
      data: traceIn[axLetter],
      calendar: traceOut.calendar,
      dfltColor: dfltColor,
      bgColor: fullLayout.paper_bgcolor,
      autotypenumbersDflt: fullLayout.autotypenumbers,
      fullLayout: fullLayout
    };
    handleAxisDefaults(axIn, axOut, defaultOptions);
    axOut._categories = axOut._categories || [];

    // so we don't have to repeat autotype unnecessarily,
    // copy an autotype back to traceIn
    if (!traceIn[axName] && axIn.type !== '-') {
      traceIn[axName] = {
        type: axIn.type
      };
    }
  });
}

/***/ }),

/***/ 97052:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isArrayOrTypedArray = (__webpack_require__(34809).isArrayOrTypedArray);
module.exports = function (a) {
  return minMax(a, 0);
};
function minMax(a, depth) {
  // Limit to ten dimensional datasets. This seems *exceedingly* unlikely to
  // ever cause problems or even be a concern. It's include strictly so that
  // circular arrays could never cause this to loop.
  if (!isArrayOrTypedArray(a) || depth >= 10) {
    return null;
  }
  var min = Infinity;
  var max = -Infinity;
  var n = a.length;
  for (var i = 0; i < n; i++) {
    var datum = a[i];
    if (isArrayOrTypedArray(datum)) {
      var result = minMax(datum, depth + 1);
      if (result) {
        min = Math.min(result[0], min);
        max = Math.max(result[1], max);
      }
    } else {
      min = Math.min(datum, min);
      max = Math.max(datum, max);
    }
  }
  return [min, max];
}

/***/ }),

/***/ 43745:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var fontAttrs = __webpack_require__(80337);
var axisAttrs = __webpack_require__(86961);
var colorAttrs = __webpack_require__(10229);
var carpetFont = fontAttrs({
  editType: 'calc'
});
var zorder = (__webpack_require__(36640).zorder);

// TODO: inherit from global font
carpetFont.family.dflt = '"Open Sans", verdana, arial, sans-serif';
carpetFont.size.dflt = 12;
carpetFont.color.dflt = colorAttrs.defaultLine;
module.exports = {
  carpet: {
    valType: 'string',
    editType: 'calc'
  },
  x: {
    valType: 'data_array',
    editType: 'calc+clearAxisTypes'
  },
  y: {
    valType: 'data_array',
    editType: 'calc+clearAxisTypes'
  },
  a: {
    valType: 'data_array',
    editType: 'calc'
  },
  a0: {
    valType: 'number',
    dflt: 0,
    editType: 'calc'
  },
  da: {
    valType: 'number',
    dflt: 1,
    editType: 'calc'
  },
  b: {
    valType: 'data_array',
    editType: 'calc'
  },
  b0: {
    valType: 'number',
    dflt: 0,
    editType: 'calc'
  },
  db: {
    valType: 'number',
    dflt: 1,
    editType: 'calc'
  },
  cheaterslope: {
    valType: 'number',
    dflt: 1,
    editType: 'calc'
  },
  aaxis: axisAttrs,
  baxis: axisAttrs,
  font: carpetFont,
  color: {
    valType: 'color',
    dflt: colorAttrs.defaultLine,
    editType: 'plot'
  },
  transforms: undefined,
  zorder: zorder
};

/***/ }),

/***/ 94903:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isArrayOrTypedArray = (__webpack_require__(34809).isArrayOrTypedArray);

/* This function retrns a set of control points that define a curve aligned along
 * either the a or b axis. Exactly one of a or b must be an array defining the range
 * spanned.
 *
 * Honestly this is the most complicated function I've implemente here so far because
 * of the way it handles knot insertion and direction/axis-agnostic slices.
 */
module.exports = function (carpet, carpetcd, a, b) {
  var idx, tangent, tanIsoIdx, tanIsoPar, segment, refidx;
  var p0, p1, v0, v1, start, end, range;
  var axis = isArrayOrTypedArray(a) ? 'a' : 'b';
  var ax = axis === 'a' ? carpet.aaxis : carpet.baxis;
  var smoothing = ax.smoothing;
  var toIdx = axis === 'a' ? carpet.a2i : carpet.b2j;
  var pt = axis === 'a' ? a : b;
  var iso = axis === 'a' ? b : a;
  var n = axis === 'a' ? carpetcd.a.length : carpetcd.b.length;
  var m = axis === 'a' ? carpetcd.b.length : carpetcd.a.length;
  var isoIdx = Math.floor(axis === 'a' ? carpet.b2j(iso) : carpet.a2i(iso));
  var xy = axis === 'a' ? function (value) {
    return carpet.evalxy([], value, isoIdx);
  } : function (value) {
    return carpet.evalxy([], isoIdx, value);
  };
  if (smoothing) {
    tanIsoIdx = Math.max(0, Math.min(m - 2, isoIdx));
    tanIsoPar = isoIdx - tanIsoIdx;
    tangent = axis === 'a' ? function (i, ti) {
      return carpet.dxydi([], i, tanIsoIdx, ti, tanIsoPar);
    } : function (j, tj) {
      return carpet.dxydj([], tanIsoIdx, j, tanIsoPar, tj);
    };
  }
  var vstart = toIdx(pt[0]);
  var vend = toIdx(pt[1]);

  // So that we can make this work in two directions, flip all of the
  // math functions if the direction is from higher to lower indices:
  //
  // Note that the tolerance is directional!
  var dir = vstart < vend ? 1 : -1;
  var tol = (vend - vstart) * 1e-8;
  var dirfloor = dir > 0 ? Math.floor : Math.ceil;
  var dirceil = dir > 0 ? Math.ceil : Math.floor;
  var dirmin = dir > 0 ? Math.min : Math.max;
  var dirmax = dir > 0 ? Math.max : Math.min;
  var idx0 = dirfloor(vstart + tol);
  var idx1 = dirceil(vend - tol);
  p0 = xy(vstart);
  var segments = [[p0]];
  for (idx = idx0; idx * dir < idx1 * dir; idx += dir) {
    segment = [];
    start = dirmax(vstart, idx);
    end = dirmin(vend, idx + dir);
    range = end - start;

    // In order to figure out which cell we're in for the derivative (remember,
    // the derivatives are *not* constant across grid lines), let's just average
    // the start and end points. This cuts out just a tiny bit of logic and
    // there's really no computational difference:
    refidx = Math.max(0, Math.min(n - 2, Math.floor(0.5 * (start + end))));
    p1 = xy(end);
    if (smoothing) {
      v0 = tangent(refidx, start - refidx);
      v1 = tangent(refidx, end - refidx);
      segment.push([p0[0] + v0[0] / 3 * range, p0[1] + v0[1] / 3 * range]);
      segment.push([p1[0] - v1[0] / 3 * range, p1[1] - v1[1] / 3 * range]);
    }
    segment.push(p1);
    segments.push(segment);
    p0 = p1;
  }
  return segments;
};

/***/ }),

/***/ 86961:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var fontAttrs = __webpack_require__(80337);
var colorAttrs = __webpack_require__(10229);
var axesAttrs = __webpack_require__(25829);
var descriptionWithDates = (__webpack_require__(80712).descriptionWithDates);
var overrideAll = (__webpack_require__(13582).overrideAll);
var dash = (__webpack_require__(94850)/* .dash */ .T);
var extendFlat = (__webpack_require__(93049).extendFlat);
module.exports = {
  color: {
    valType: 'color',
    editType: 'calc'
  },
  smoothing: {
    valType: 'number',
    dflt: 1,
    min: 0,
    max: 1.3,
    editType: 'calc'
  },
  title: {
    text: {
      valType: 'string',
      dflt: '',
      editType: 'calc'
    },
    font: fontAttrs({
      editType: 'calc'
    }),
    // TODO how is this different than `title.standoff`
    offset: {
      valType: 'number',
      dflt: 10,
      editType: 'calc'
    },
    editType: 'calc'
  },
  type: {
    valType: 'enumerated',
    // '-' means we haven't yet run autotype or couldn't find any data
    // it gets turned into linear in gd._fullLayout but not copied back
    // to gd.data like the others are.
    values: ['-', 'linear', 'date', 'category'],
    dflt: '-',
    editType: 'calc'
  },
  autotypenumbers: axesAttrs.autotypenumbers,
  autorange: {
    valType: 'enumerated',
    values: [true, false, 'reversed'],
    dflt: true,
    editType: 'calc'
  },
  rangemode: {
    valType: 'enumerated',
    values: ['normal', 'tozero', 'nonnegative'],
    dflt: 'normal',
    editType: 'calc'
  },
  range: {
    valType: 'info_array',
    editType: 'calc',
    items: [{
      valType: 'any',
      editType: 'calc'
    }, {
      valType: 'any',
      editType: 'calc'
    }]
  },
  fixedrange: {
    valType: 'boolean',
    dflt: false,
    editType: 'calc'
  },
  cheatertype: {
    valType: 'enumerated',
    values: ['index', 'value'],
    dflt: 'value',
    editType: 'calc'
  },
  tickmode: {
    valType: 'enumerated',
    values: ['linear', 'array'],
    dflt: 'array',
    editType: 'calc'
  },
  nticks: {
    valType: 'integer',
    min: 0,
    dflt: 0,
    editType: 'calc'
  },
  tickvals: {
    valType: 'data_array',
    editType: 'calc'
  },
  ticktext: {
    valType: 'data_array',
    editType: 'calc'
  },
  showticklabels: {
    valType: 'enumerated',
    values: ['start', 'end', 'both', 'none'],
    dflt: 'start',
    editType: 'calc'
  },
  labelalias: extendFlat({}, axesAttrs.labelalias, {
    editType: 'calc'
  }),
  tickfont: fontAttrs({
    editType: 'calc'
  }),
  tickangle: {
    valType: 'angle',
    dflt: 'auto',
    editType: 'calc'
  },
  tickprefix: {
    valType: 'string',
    dflt: '',
    editType: 'calc'
  },
  showtickprefix: {
    valType: 'enumerated',
    values: ['all', 'first', 'last', 'none'],
    dflt: 'all',
    editType: 'calc'
  },
  ticksuffix: {
    valType: 'string',
    dflt: '',
    editType: 'calc'
  },
  showticksuffix: {
    valType: 'enumerated',
    values: ['all', 'first', 'last', 'none'],
    dflt: 'all',
    editType: 'calc'
  },
  showexponent: {
    valType: 'enumerated',
    values: ['all', 'first', 'last', 'none'],
    dflt: 'all',
    editType: 'calc'
  },
  exponentformat: {
    valType: 'enumerated',
    values: ['none', 'e', 'E', 'power', 'SI', 'B'],
    dflt: 'B',
    editType: 'calc'
  },
  minexponent: {
    valType: 'number',
    dflt: 3,
    min: 0,
    editType: 'calc'
  },
  separatethousands: {
    valType: 'boolean',
    dflt: false,
    editType: 'calc'
  },
  tickformat: {
    valType: 'string',
    dflt: '',
    editType: 'calc',
    description: descriptionWithDates('tick label')
  },
  tickformatstops: overrideAll(axesAttrs.tickformatstops, 'calc', 'from-root'),
  categoryorder: {
    valType: 'enumerated',
    values: ['trace', 'category ascending', 'category descending', 'array'
    /* , 'value ascending', 'value descending'*/ // value ascending / descending to be implemented later
    ],
    dflt: 'trace',
    editType: 'calc'
  },
  categoryarray: {
    valType: 'data_array',
    editType: 'calc'
  },
  labelpadding: {
    valType: 'integer',
    dflt: 10,
    editType: 'calc'
  },
  labelprefix: {
    valType: 'string',
    editType: 'calc'
  },
  labelsuffix: {
    valType: 'string',
    dflt: '',
    editType: 'calc'
  },
  // lines and grids
  showline: {
    valType: 'boolean',
    dflt: false,
    editType: 'calc'
  },
  linecolor: {
    valType: 'color',
    dflt: colorAttrs.defaultLine,
    editType: 'calc'
  },
  linewidth: {
    valType: 'number',
    min: 0,
    dflt: 1,
    editType: 'calc'
  },
  gridcolor: {
    valType: 'color',
    editType: 'calc'
  },
  gridwidth: {
    valType: 'number',
    min: 0,
    dflt: 1,
    editType: 'calc'
  },
  griddash: extendFlat({}, dash, {
    editType: 'calc'
  }),
  showgrid: {
    valType: 'boolean',
    dflt: true,
    editType: 'calc'
  },
  minorgridcount: {
    valType: 'integer',
    min: 0,
    dflt: 0,
    editType: 'calc'
  },
  minorgridwidth: {
    valType: 'number',
    min: 0,
    dflt: 1,
    editType: 'calc'
  },
  minorgriddash: extendFlat({}, dash, {
    editType: 'calc'
  }),
  minorgridcolor: {
    valType: 'color',
    dflt: colorAttrs.lightLine,
    editType: 'calc'
  },
  startline: {
    valType: 'boolean',
    editType: 'calc'
  },
  startlinecolor: {
    valType: 'color',
    editType: 'calc'
  },
  startlinewidth: {
    valType: 'number',
    dflt: 1,
    editType: 'calc'
  },
  endline: {
    valType: 'boolean',
    editType: 'calc'
  },
  endlinewidth: {
    valType: 'number',
    dflt: 1,
    editType: 'calc'
  },
  endlinecolor: {
    valType: 'color',
    editType: 'calc'
  },
  tick0: {
    valType: 'number',
    min: 0,
    dflt: 0,
    editType: 'calc'
  },
  dtick: {
    valType: 'number',
    min: 0,
    dflt: 1,
    editType: 'calc'
  },
  arraytick0: {
    valType: 'integer',
    min: 0,
    dflt: 0,
    editType: 'calc'
  },
  arraydtick: {
    valType: 'integer',
    min: 1,
    dflt: 1,
    editType: 'calc'
  },
  _deprecated: {
    title: {
      valType: 'string',
      editType: 'calc'
    },
    titlefont: fontAttrs({
      editType: 'calc'
    }),
    titleoffset: {
      valType: 'number',
      dflt: 10,
      editType: 'calc'
    }
  },
  editType: 'calc'
};

/***/ }),

/***/ 6038:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var carpetAttrs = __webpack_require__(43745);
var addOpacity = (__webpack_require__(78766).addOpacity);
var Registry = __webpack_require__(33626);
var Lib = __webpack_require__(34809);
var handleTickValueDefaults = __webpack_require__(22777);
var handleTickLabelDefaults = __webpack_require__(12036);
var handlePrefixSuffixDefaults = __webpack_require__(54616);
var handleCategoryOrderDefaults = __webpack_require__(46473);
var setConvert = __webpack_require__(19091);
var autoType = __webpack_require__(9666);

/**
 * options: object containing:
 *
 *  letter: 'a' or 'b'
 *  title: name of the axis (ie 'Colorbar') to go in default title
 *  name: axis object name (ie 'xaxis') if one should be stored
 *  font: the default font to inherit
 *  outerTicks: boolean, should ticks default to outside?
 *  showGrid: boolean, should gridlines be shown by default?
 *  data: the plot data to use in choosing auto type
 *  bgColor: the plot background color, to calculate default gridline colors
 */
module.exports = function handleAxisDefaults(containerIn, containerOut, options) {
  var letter = options.letter;
  var font = options.font || {};
  var attributes = carpetAttrs[letter + 'axis'];
  function coerce(attr, dflt) {
    return Lib.coerce(containerIn, containerOut, attributes, attr, dflt);
  }
  function coerce2(attr, dflt) {
    return Lib.coerce2(containerIn, containerOut, attributes, attr, dflt);
  }

  // set up some private properties
  if (options.name) {
    containerOut._name = options.name;
    containerOut._id = options.name;
  }

  // now figure out type and do some more initialization
  coerce('autotypenumbers', options.autotypenumbersDflt);
  var axType = coerce('type');
  if (axType === '-') {
    if (options.data) setAutoType(containerOut, options.data);
    if (containerOut.type === '-') {
      containerOut.type = 'linear';
    } else {
      // copy autoType back to input axis
      // note that if this object didn't exist
      // in the input layout, we have to put it in
      // this happens in the main supplyDefaults function
      axType = containerIn.type = containerOut.type;
    }
  }
  coerce('smoothing');
  coerce('cheatertype');
  coerce('showticklabels');
  coerce('labelprefix', letter + ' = ');
  coerce('labelsuffix');
  coerce('showtickprefix');
  coerce('showticksuffix');
  coerce('separatethousands');
  coerce('tickformat');
  coerce('exponentformat');
  coerce('minexponent');
  coerce('showexponent');
  coerce('categoryorder');
  coerce('tickmode');
  coerce('tickvals');
  coerce('ticktext');
  coerce('tick0');
  coerce('dtick');
  if (containerOut.tickmode === 'array') {
    coerce('arraytick0');
    coerce('arraydtick');
  }
  coerce('labelpadding');
  containerOut._hovertitle = letter;
  if (axType === 'date') {
    var handleCalendarDefaults = Registry.getComponentMethod('calendars', 'handleDefaults');
    handleCalendarDefaults(containerIn, containerOut, 'calendar', options.calendar);
  }

  // we need some of the other functions setConvert attaches, but for
  // path finding, override pixel scaling to simple passthrough (identity)
  setConvert(containerOut, options.fullLayout);
  containerOut.c2p = Lib.identity;
  var dfltColor = coerce('color', options.dfltColor);
  // if axis.color was provided, use it for fonts too; otherwise,
  // inherit from global font color in case that was provided.
  var dfltFontColor = dfltColor === containerIn.color ? dfltColor : font.color;
  var title = coerce('title.text');
  if (title) {
    Lib.coerceFont(coerce, 'title.font', font, {
      overrideDflt: {
        size: Lib.bigFont(font.size),
        color: dfltFontColor
      }
    });
    coerce('title.offset');
  }
  coerce('tickangle');
  var autoRange = coerce('autorange', !containerOut.isValidRange(containerIn.range));
  if (autoRange) coerce('rangemode');
  coerce('range');
  containerOut.cleanRange();
  coerce('fixedrange');
  handleTickValueDefaults(containerIn, containerOut, coerce, axType);
  handlePrefixSuffixDefaults(containerIn, containerOut, coerce, axType, options);
  handleTickLabelDefaults(containerIn, containerOut, coerce, axType, options);
  handleCategoryOrderDefaults(containerIn, containerOut, coerce, {
    data: options.data,
    dataAttr: letter
  });
  var gridColor = coerce2('gridcolor', addOpacity(dfltColor, 0.3));
  var gridWidth = coerce2('gridwidth');
  var gridDash = coerce2('griddash');
  var showGrid = coerce('showgrid');
  if (!showGrid) {
    delete containerOut.gridcolor;
    delete containerOut.gridwidth;
    delete containerOut.griddash;
  }
  var startLineColor = coerce2('startlinecolor', dfltColor);
  var startLineWidth = coerce2('startlinewidth', gridWidth);
  var showStartLine = coerce('startline', containerOut.showgrid || !!startLineColor || !!startLineWidth);
  if (!showStartLine) {
    delete containerOut.startlinecolor;
    delete containerOut.startlinewidth;
  }
  var endLineColor = coerce2('endlinecolor', dfltColor);
  var endLineWidth = coerce2('endlinewidth', gridWidth);
  var showEndLine = coerce('endline', containerOut.showgrid || !!endLineColor || !!endLineWidth);
  if (!showEndLine) {
    delete containerOut.endlinecolor;
    delete containerOut.endlinewidth;
  }
  if (!showGrid) {
    delete containerOut.gridcolor;
    delete containerOut.gridwidth;
    delete containerOut.griddash;
  } else {
    coerce('minorgridcount');
    coerce('minorgridwidth', gridWidth);
    coerce('minorgriddash', gridDash);
    coerce('minorgridcolor', addOpacity(gridColor, 0.06));
    if (!containerOut.minorgridcount) {
      delete containerOut.minorgridwidth;
      delete containerOut.minorgriddash;
      delete containerOut.minorgridcolor;
    }
  }
  if (containerOut.showticklabels === 'none') {
    delete containerOut.tickfont;
    delete containerOut.tickangle;
    delete containerOut.showexponent;
    delete containerOut.exponentformat;
    delete containerOut.minexponent;
    delete containerOut.tickformat;
    delete containerOut.showticksuffix;
    delete containerOut.showtickprefix;
  }
  if (!containerOut.showticksuffix) {
    delete containerOut.ticksuffix;
  }
  if (!containerOut.showtickprefix) {
    delete containerOut.tickprefix;
  }

  // It needs to be coerced, then something above overrides this deep in the axis code,
  // but no, we *actually* want to coerce this.
  coerce('tickmode');
  return containerOut;
};
function setAutoType(ax, data) {
  // new logic: let people specify any type they want,
  // only autotype if type is '-'
  if (ax.type !== '-') return;
  var id = ax._id;
  var axLetter = id.charAt(0);
  var calAttr = axLetter + 'calendar';
  var calendar = ax[calAttr];
  ax.type = autoType(data, calendar, {
    autotypenumbers: ax.autotypenumbers
  });
}

/***/ }),

/***/ 67525:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Axes = __webpack_require__(29714);
var isArray1D = (__webpack_require__(34809).isArray1D);
var cheaterBasis = __webpack_require__(89992);
var arrayMinmax = __webpack_require__(97052);
var calcGridlines = __webpack_require__(4753);
var calcLabels = __webpack_require__(93923);
var calcClipPath = __webpack_require__(39373);
var clean2dArray = __webpack_require__(93877);
var smoothFill2dArray = __webpack_require__(13007);
var convertColumnData = __webpack_require__(87869);
var setConvert = __webpack_require__(76842);
module.exports = function calc(gd, trace) {
  var xa = Axes.getFromId(gd, trace.xaxis);
  var ya = Axes.getFromId(gd, trace.yaxis);
  var aax = trace.aaxis;
  var bax = trace.baxis;
  var x = trace.x;
  var y = trace.y;
  var cols = [];
  if (x && isArray1D(x)) cols.push('x');
  if (y && isArray1D(y)) cols.push('y');
  if (cols.length) {
    convertColumnData(trace, aax, bax, 'a', 'b', cols);
  }
  var a = trace._a = trace._a || trace.a;
  var b = trace._b = trace._b || trace.b;
  x = trace._x || trace.x;
  y = trace._y || trace.y;
  var t = {};
  if (trace._cheater) {
    var avals = aax.cheatertype === 'index' ? a.length : a;
    var bvals = bax.cheatertype === 'index' ? b.length : b;
    x = cheaterBasis(avals, bvals, trace.cheaterslope);
  }
  trace._x = x = clean2dArray(x);
  trace._y = y = clean2dArray(y);

  // Fill in any undefined values with elliptic smoothing. This doesn't take
  // into account the spacing of the values. That is, the derivatives should
  // be modified to use a and b values. It's not that hard, but this is already
  // moderate overkill for just filling in missing values.
  smoothFill2dArray(x, a, b);
  smoothFill2dArray(y, a, b);
  setConvert(trace);

  // create conversion functions that depend on the data
  trace.setScale();

  // This is a rather expensive scan. Nothing guarantees monotonicity,
  // so we need to scan through all data to get proper ranges:
  var xrange = arrayMinmax(x);
  var yrange = arrayMinmax(y);
  var dx = 0.5 * (xrange[1] - xrange[0]);
  var xc = 0.5 * (xrange[1] + xrange[0]);
  var dy = 0.5 * (yrange[1] - yrange[0]);
  var yc = 0.5 * (yrange[1] + yrange[0]);

  // Expand the axes to fit the plot, except just grow it by a factor of 1.3
  // because the labels should be taken into account except that's difficult
  // hence 1.3.
  var grow = 1.3;
  xrange = [xc - dx * grow, xc + dx * grow];
  yrange = [yc - dy * grow, yc + dy * grow];
  trace._extremes[xa._id] = Axes.findExtremes(xa, xrange, {
    padded: true
  });
  trace._extremes[ya._id] = Axes.findExtremes(ya, yrange, {
    padded: true
  });

  // Enumerate the gridlines, both major and minor, and store them on the trace
  // object:
  calcGridlines(trace, 'a', 'b');
  calcGridlines(trace, 'b', 'a');

  // Calculate the text labels for each major gridline and store them on the
  // trace object:
  calcLabels(trace, aax);
  calcLabels(trace, bax);

  // Tabulate points for the four segments that bound the axes so that we can
  // map to pixel coordinates in the plot function and create a clip rect:
  t.clipsegments = calcClipPath(trace._xctrl, trace._yctrl, aax, bax);
  t.x = x;
  t.y = y;
  t.a = a;
  t.b = b;
  return [t];
};

/***/ }),

/***/ 39373:
/***/ (function(module) {

"use strict";


module.exports = function makeClipPath(xctrl, yctrl, aax, bax) {
  var i, x, y;
  var segments = [];
  var asmoothing = !!aax.smoothing;
  var bsmoothing = !!bax.smoothing;
  var nea1 = xctrl[0].length - 1;
  var neb1 = xctrl.length - 1;

  // Along the lower a axis:
  for (i = 0, x = [], y = []; i <= nea1; i++) {
    x[i] = xctrl[0][i];
    y[i] = yctrl[0][i];
  }
  segments.push({
    x: x,
    y: y,
    bicubic: asmoothing
  });

  // Along the upper b axis:
  for (i = 0, x = [], y = []; i <= neb1; i++) {
    x[i] = xctrl[i][nea1];
    y[i] = yctrl[i][nea1];
  }
  segments.push({
    x: x,
    y: y,
    bicubic: bsmoothing
  });

  // Backwards along the upper a axis:
  for (i = nea1, x = [], y = []; i >= 0; i--) {
    x[nea1 - i] = xctrl[neb1][i];
    y[nea1 - i] = yctrl[neb1][i];
  }
  segments.push({
    x: x,
    y: y,
    bicubic: asmoothing
  });

  // Backwards along the lower b axis:
  for (i = neb1, x = [], y = []; i >= 0; i--) {
    x[neb1 - i] = xctrl[i][0];
    y[neb1 - i] = yctrl[i][0];
  }
  segments.push({
    x: x,
    y: y,
    bicubic: bsmoothing
  });
  return segments;
};

/***/ }),

/***/ 4753:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Axes = __webpack_require__(29714);
var extendFlat = (__webpack_require__(93049).extendFlat);
module.exports = function calcGridlines(trace, axisLetter, crossAxisLetter) {
  var i, j, j0;
  var eps, bounds, n1, n2, n, value, v;
  var j1, v0, v1, d;
  var data = trace['_' + axisLetter];
  var axis = trace[axisLetter + 'axis'];
  var gridlines = axis._gridlines = [];
  var minorgridlines = axis._minorgridlines = [];
  var boundarylines = axis._boundarylines = [];
  var crossData = trace['_' + crossAxisLetter];
  var crossAxis = trace[crossAxisLetter + 'axis'];
  if (axis.tickmode === 'array') {
    axis.tickvals = data.slice();
  }
  var xcp = trace._xctrl;
  var ycp = trace._yctrl;
  var nea = xcp[0].length;
  var neb = xcp.length;
  var na = trace._a.length;
  var nb = trace._b.length;
  Axes.prepTicks(axis);

  // don't leave tickvals in axis looking like an attribute
  if (axis.tickmode === 'array') delete axis.tickvals;

  // The default is an empty array that will cause the join to remove the gridline if
  // it's just disappeared:
  // axis._startline = axis._endline = [];

  // If the cross axis uses bicubic interpolation, then the grid
  // lines fall once every three expanded grid row/cols:
  var stride = axis.smoothing ? 3 : 1;
  function constructValueGridline(value) {
    var i, j, j0, tj, pxy, i0, ti, xy, dxydi0, dxydi1, dxydj0, dxydj1;
    var xpoints = [];
    var ypoints = [];
    var ret = {};
    // Search for the fractional grid index giving this line:
    if (axisLetter === 'b') {
      // For the position we use just the i-j coordinates:
      j = trace.b2j(value);

      // The derivatives for catmull-rom splines are discontinuous across cell
      // boundaries though, so we need to provide both the cell and the position
      // within the cell separately:
      j0 = Math.floor(Math.max(0, Math.min(nb - 2, j)));
      tj = j - j0;
      ret.length = nb;
      ret.crossLength = na;
      ret.xy = function (i) {
        return trace.evalxy([], i, j);
      };
      ret.dxy = function (i0, ti) {
        return trace.dxydi([], i0, j0, ti, tj);
      };
      for (i = 0; i < na; i++) {
        i0 = Math.min(na - 2, i);
        ti = i - i0;
        xy = trace.evalxy([], i, j);
        if (crossAxis.smoothing && i > 0) {
          // First control point:
          dxydi0 = trace.dxydi([], i - 1, j0, 0, tj);
          xpoints.push(pxy[0] + dxydi0[0] / 3);
          ypoints.push(pxy[1] + dxydi0[1] / 3);

          // Second control point:
          dxydi1 = trace.dxydi([], i - 1, j0, 1, tj);
          xpoints.push(xy[0] - dxydi1[0] / 3);
          ypoints.push(xy[1] - dxydi1[1] / 3);
        }
        xpoints.push(xy[0]);
        ypoints.push(xy[1]);
        pxy = xy;
      }
    } else {
      i = trace.a2i(value);
      i0 = Math.floor(Math.max(0, Math.min(na - 2, i)));
      ti = i - i0;
      ret.length = na;
      ret.crossLength = nb;
      ret.xy = function (j) {
        return trace.evalxy([], i, j);
      };
      ret.dxy = function (j0, tj) {
        return trace.dxydj([], i0, j0, ti, tj);
      };
      for (j = 0; j < nb; j++) {
        j0 = Math.min(nb - 2, j);
        tj = j - j0;
        xy = trace.evalxy([], i, j);
        if (crossAxis.smoothing && j > 0) {
          // First control point:
          dxydj0 = trace.dxydj([], i0, j - 1, ti, 0);
          xpoints.push(pxy[0] + dxydj0[0] / 3);
          ypoints.push(pxy[1] + dxydj0[1] / 3);

          // Second control point:
          dxydj1 = trace.dxydj([], i0, j - 1, ti, 1);
          xpoints.push(xy[0] - dxydj1[0] / 3);
          ypoints.push(xy[1] - dxydj1[1] / 3);
        }
        xpoints.push(xy[0]);
        ypoints.push(xy[1]);
        pxy = xy;
      }
    }
    ret.axisLetter = axisLetter;
    ret.axis = axis;
    ret.crossAxis = crossAxis;
    ret.value = value;
    ret.constvar = crossAxisLetter;
    ret.index = n;
    ret.x = xpoints;
    ret.y = ypoints;
    ret.smoothing = crossAxis.smoothing;
    return ret;
  }
  function constructArrayGridline(idx) {
    var j, i0, j0, ti, tj;
    var xpoints = [];
    var ypoints = [];
    var ret = {};
    ret.length = data.length;
    ret.crossLength = crossData.length;
    if (axisLetter === 'b') {
      j0 = Math.max(0, Math.min(nb - 2, idx));
      tj = Math.min(1, Math.max(0, idx - j0));
      ret.xy = function (i) {
        return trace.evalxy([], i, idx);
      };
      ret.dxy = function (i0, ti) {
        return trace.dxydi([], i0, j0, ti, tj);
      };

      // In the tickmode: array case, this operation is a simple
      // transfer of data:
      for (j = 0; j < nea; j++) {
        xpoints[j] = xcp[idx * stride][j];
        ypoints[j] = ycp[idx * stride][j];
      }
    } else {
      i0 = Math.max(0, Math.min(na - 2, idx));
      ti = Math.min(1, Math.max(0, idx - i0));
      ret.xy = function (j) {
        return trace.evalxy([], idx, j);
      };
      ret.dxy = function (j0, tj) {
        return trace.dxydj([], i0, j0, ti, tj);
      };

      // In the tickmode: array case, this operation is a simple
      // transfer of data:
      for (j = 0; j < neb; j++) {
        xpoints[j] = xcp[j][idx * stride];
        ypoints[j] = ycp[j][idx * stride];
      }
    }
    ret.axisLetter = axisLetter;
    ret.axis = axis;
    ret.crossAxis = crossAxis;
    ret.value = data[idx];
    ret.constvar = crossAxisLetter;
    ret.index = idx;
    ret.x = xpoints;
    ret.y = ypoints;
    ret.smoothing = crossAxis.smoothing;
    return ret;
  }
  if (axis.tickmode === 'array') {
    // var j0 = axis.startline ? 1 : 0;
    // var j1 = data.length - (axis.endline ? 1 : 0);

    eps = 5e-15;
    bounds = [Math.floor((data.length - 1 - axis.arraytick0) / axis.arraydtick * (1 + eps)), Math.ceil(-axis.arraytick0 / axis.arraydtick / (1 + eps))].sort(function (a, b) {
      return a - b;
    });

    // Unpack sorted values so we can be sure to avoid infinite loops if something
    // is backwards:
    n1 = bounds[0] - 1;
    n2 = bounds[1] + 1;

    // If the axes fall along array lines, then this is a much simpler process since
    // we already have all the control points we need
    for (n = n1; n < n2; n++) {
      j = axis.arraytick0 + axis.arraydtick * n;
      if (j < 0 || j > data.length - 1) continue;
      gridlines.push(extendFlat(constructArrayGridline(j), {
        color: axis.gridcolor,
        width: axis.gridwidth,
        dash: axis.griddash
      }));
    }
    for (n = n1; n < n2; n++) {
      j0 = axis.arraytick0 + axis.arraydtick * n;
      j1 = Math.min(j0 + axis.arraydtick, data.length - 1);

      // TODO: fix the bounds computation so we don't have to do a large range and then throw
      // out unneeded numbers
      if (j0 < 0 || j0 > data.length - 1) continue;
      if (j1 < 0 || j1 > data.length - 1) continue;
      v0 = data[j0];
      v1 = data[j1];
      for (i = 0; i < axis.minorgridcount; i++) {
        d = j1 - j0;

        // TODO: fix the bounds computation so we don't have to do a large range and then throw
        // out unneeded numbers
        if (d <= 0) continue;

        // XXX: This calculation isn't quite right. Off by one somewhere?
        v = v0 + (v1 - v0) * (i + 1) / (axis.minorgridcount + 1) * (axis.arraydtick / d);

        // TODO: fix the bounds computation so we don't have to do a large range and then throw
        // out unneeded numbers
        if (v < data[0] || v > data[data.length - 1]) continue;
        minorgridlines.push(extendFlat(constructValueGridline(v), {
          color: axis.minorgridcolor,
          width: axis.minorgridwidth,
          dash: axis.minorgriddash
        }));
      }
    }
    if (axis.startline) {
      boundarylines.push(extendFlat(constructArrayGridline(0), {
        color: axis.startlinecolor,
        width: axis.startlinewidth
      }));
    }
    if (axis.endline) {
      boundarylines.push(extendFlat(constructArrayGridline(data.length - 1), {
        color: axis.endlinecolor,
        width: axis.endlinewidth
      }));
    }
  } else {
    // If the lines do not fall along the axes, then we have to interpolate
    // the contro points and so some math to figure out where the lines are
    // in the first place.

    // Compute the integer boudns of tick0 + n * dtick that fall within the range
    // (roughly speaking):
    // Give this a nice generous epsilon. We use at as * (1 + eps) in order to make
    // inequalities a little tolerant in a more or less correct manner:
    eps = 5e-15;
    bounds = [Math.floor((data[data.length - 1] - axis.tick0) / axis.dtick * (1 + eps)), Math.ceil((data[0] - axis.tick0) / axis.dtick / (1 + eps))].sort(function (a, b) {
      return a - b;
    });

    // Unpack sorted values so we can be sure to avoid infinite loops if something
    // is backwards:
    n1 = bounds[0];
    n2 = bounds[1];
    for (n = n1; n <= n2; n++) {
      value = axis.tick0 + axis.dtick * n;
      gridlines.push(extendFlat(constructValueGridline(value), {
        color: axis.gridcolor,
        width: axis.gridwidth,
        dash: axis.griddash
      }));
    }
    for (n = n1 - 1; n < n2 + 1; n++) {
      value = axis.tick0 + axis.dtick * n;
      for (i = 0; i < axis.minorgridcount; i++) {
        v = value + axis.dtick * (i + 1) / (axis.minorgridcount + 1);
        if (v < data[0] || v > data[data.length - 1]) continue;
        minorgridlines.push(extendFlat(constructValueGridline(v), {
          color: axis.minorgridcolor,
          width: axis.minorgridwidth,
          dash: axis.minorgriddash
        }));
      }
    }
    if (axis.startline) {
      boundarylines.push(extendFlat(constructValueGridline(data[0]), {
        color: axis.startlinecolor,
        width: axis.startlinewidth
      }));
    }
    if (axis.endline) {
      boundarylines.push(extendFlat(constructValueGridline(data[data.length - 1]), {
        color: axis.endlinecolor,
        width: axis.endlinewidth
      }));
    }
  }
};

/***/ }),

/***/ 93923:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Axes = __webpack_require__(29714);
var extendFlat = (__webpack_require__(93049).extendFlat);
module.exports = function calcLabels(trace, axis) {
  var i, tobj, prefix, suffix, gridline;
  var labels = axis._labels = [];
  var gridlines = axis._gridlines;
  for (i = 0; i < gridlines.length; i++) {
    gridline = gridlines[i];
    if (['start', 'both'].indexOf(axis.showticklabels) !== -1) {
      tobj = Axes.tickText(axis, gridline.value);
      extendFlat(tobj, {
        prefix: prefix,
        suffix: suffix,
        endAnchor: true,
        xy: gridline.xy(0),
        dxy: gridline.dxy(0, 0),
        axis: gridline.axis,
        length: gridline.crossAxis.length,
        font: gridline.axis.tickfont,
        isFirst: i === 0,
        isLast: i === gridlines.length - 1
      });
      labels.push(tobj);
    }
    if (['end', 'both'].indexOf(axis.showticklabels) !== -1) {
      tobj = Axes.tickText(axis, gridline.value);
      extendFlat(tobj, {
        endAnchor: false,
        xy: gridline.xy(gridline.crossLength - 1),
        dxy: gridline.dxy(gridline.crossLength - 2, 1),
        axis: gridline.axis,
        length: gridline.crossAxis.length,
        font: gridline.axis.tickfont,
        isFirst: i === 0,
        isLast: i === gridlines.length - 1
      });
      labels.push(tobj);
    }
  }
};

/***/ }),

/***/ 49109:
/***/ (function(module) {

"use strict";


/*
 * Compute the tangent vector according to catmull-rom cubic splines (centripetal,
 * I think). That differs from the control point in two ways:
 *   1. It is a vector, not a position relative to the point
 *   2. the vector is longer than the position relative to p1 by a factor of 3
 *
 * Close to the boundaries, we'll use these as *quadratic control points, so that
 * to make a nice grid, we'll need to divide the tangent by 2 instead of 3. (The
 * math works out this way if you work through the bezier derivatives)
 */
var CatmullRomExp = 0.5;
module.exports = function makeControlPoints(p0, p1, p2, smoothness) {
  var d1x = p0[0] - p1[0];
  var d1y = p0[1] - p1[1];
  var d2x = p2[0] - p1[0];
  var d2y = p2[1] - p1[1];
  var d1a = Math.pow(d1x * d1x + d1y * d1y, CatmullRomExp / 2);
  var d2a = Math.pow(d2x * d2x + d2y * d2y, CatmullRomExp / 2);
  var numx = (d2a * d2a * d1x - d1a * d1a * d2x) * smoothness;
  var numy = (d2a * d2a * d1y - d1a * d1a * d2y) * smoothness;
  var denom1 = d2a * (d1a + d2a) * 3;
  var denom2 = d1a * (d1a + d2a) * 3;
  return [[p1[0] + (denom1 && numx / denom1), p1[1] + (denom1 && numy / denom1)], [p1[0] - (denom2 && numx / denom2), p1[1] - (denom2 && numy / denom2)]];
};

/***/ }),

/***/ 89992:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isArrayOrTypedArray = (__webpack_require__(34809).isArrayOrTypedArray);

/*
 * Construct a 2D array of cheater values given a, b, and a slope.
 * If
 */
module.exports = function (a, b, cheaterslope) {
  var i, j, ascal, bscal, aval, bval;
  var data = [];
  var na = isArrayOrTypedArray(a) ? a.length : a;
  var nb = isArrayOrTypedArray(b) ? b.length : b;
  var adata = isArrayOrTypedArray(a) ? a : null;
  var bdata = isArrayOrTypedArray(b) ? b : null;

  // If we're using data, scale it so that for data that's just barely
  // not evenly spaced, the switch to value-based indexing is continuous.
  // This means evenly spaced data should look the same whether value
  // or index cheatertype.
  if (adata) {
    ascal = (adata.length - 1) / (adata[adata.length - 1] - adata[0]) / (na - 1);
  }
  if (bdata) {
    bscal = (bdata.length - 1) / (bdata[bdata.length - 1] - bdata[0]) / (nb - 1);
  }
  var xval;
  var xmin = Infinity;
  var xmax = -Infinity;
  for (j = 0; j < nb; j++) {
    data[j] = [];
    bval = bdata ? (bdata[j] - bdata[0]) * bscal : j / (nb - 1);
    for (i = 0; i < na; i++) {
      aval = adata ? (adata[i] - adata[0]) * ascal : i / (na - 1);
      xval = aval - bval * cheaterslope;
      xmin = Math.min(xval, xmin);
      xmax = Math.max(xval, xmax);
      data[j][i] = xval;
    }
  }

  // Normalize cheater values to the 0-1 range. This comes into play when you have
  // multiple cheater plots. After careful consideration, it seems better if cheater
  // values are normalized to a consistent range. Otherwise one cheater affects the
  // layout of other cheaters on the same axis.
  var slope = 1.0 / (xmax - xmin);
  var offset = -xmin * slope;
  for (j = 0; j < nb; j++) {
    for (i = 0; i < na; i++) {
      data[j][i] = slope * data[j][i] + offset;
    }
  }
  return data;
};

/***/ }),

/***/ 57075:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var makeControlPoints = __webpack_require__(49109);
var ensureArray = (__webpack_require__(34809).ensureArray);

/*
 * Turns a coarse grid into a fine grid with control points.
 *
 * Here's an ASCII representation:
 *
 *       o ----- o ----- o ----- o
 *       |       |       |       |
 *       |       |       |       |
 *       |       |       |       |
 *       o ----- o ----- o ----- o
 *       |       |       |       |
 *       |       |       |       |
 *    ^  |       |       |       |
 *    |  o ----- o ----- o ----- o
 *  b |  |       |       |       |
 *    |  |       |       |       |
 *    |  |       |       |       |
 *       o ----- o ----- o ----- o
 *         ------>
 *           a
 *
 * First of all, note that we want to do this in *cartesian* space. This means
 * we might run into problems when there are extreme differences in x/y scaling,
 * but the alternative is that the topology of the contours might actually be
 * view-dependent, which seems worse. As a fallback, the only parameter that
 * actually affects the result is the *aspect ratio*, so that we can at least
 * improve the situation a bit without going all the way to screen coordinates.
 *
 * This function flattens the points + tangents  into a slightly denser grid of
 * *control points*. The resulting grid looks like this:
 *
 *       9 +--o-o--+ -o-o--+--o-o--+
 *       8 o  o o  o  o o  o  o o  o
 *         |       |       |       |
 *       7 o  o o  o  o o  o  o o  o
 *       6 +--o-o--+ -o-o--+--o-o--+
 *       5 o  o o  o  o o  o  o o  o
 *         |       |       |       |
 *    ^  4 o  o o  o  o o  o  o o  o
 *    |  3 +--o-o--+ -o-o--+--o-o--+
 *  b |  2 o  o o  o  o o  o  o o  o
 *    |    |       |       |       |
 *    |  1 o  o o  o  o o  o  o o  o
 *       0 +--o-o--+ -o-o--+--o-o--+
 *         0  1 2  3  4 5  6  7 8  9
 *         ------>
 *           a
 *
 * where `o`s represent newly-computed control points. the resulting dimension is
 *
 *     (m - 1) * 3 + 1
 *   = 3 * m - 2
 *
 * We could simply store the tangents separately, but that's a nightmare to organize
 * in two dimensions since we'll be slicing grid lines in both directions and since
 * that basically requires very nearly just as much storage as just storing the dense
 * grid.
 *
 * Wow!
 */

/*
 * Catmull-rom is biased at the boundaries toward the interior and we actually
 * can't use catmull-rom to compute the control point closest to (but inside)
 * the boundary.
 *
 * A note on plotly's spline interpolation. It uses the catmull rom control point
 * closest to the boundary *as* a quadratic control point. This seems incorrect,
 * so I've elected not to follow that. Given control points 0 and 1, regular plotly
 * splines give *equivalent* cubic control points:
 *
 * Input:
 *
 *   boundary
 *     |                    |
 *     p0           p2      p3    --> interior
 *     0.0          0.667   1.0
 *     |                    |
 *
 * Cubic-equivalent of what plotly splines draw::
 *
 *   boundary
 *     |                    |
 *     p0   p1      p2      p3    --> interior
 *     0.0  0.4444  0.8888  1.0
 *     |                    |
 *
 * What this function fills in:
 *
 *   boundary
 *     |                    |
 *     p0    p1     p2      p3    --> interior
 *     0.0   0.333  0.667   1.0
 *     |                    |
 *
 * Parameters:
 *   p0: boundary point
 *   p2: catmull rom point based on computation at p3
 *   p3: first grid point
 *
 * Of course it works whichever way it's oriented; you just need to interpret the
 * input/output accordingly.
 */
function inferCubicControlPoint(p0, p2, p3) {
  // Extend p1 away from p0 by 50%. This is the equivalent quadratic point that
  // would give the same slope as catmull rom at p0.
  var p2e0 = -0.5 * p3[0] + 1.5 * p2[0];
  var p2e1 = -0.5 * p3[1] + 1.5 * p2[1];
  return [(2 * p2e0 + p0[0]) / 3, (2 * p2e1 + p0[1]) / 3];
}
module.exports = function computeControlPoints(xe, ye, x, y, asmoothing, bsmoothing) {
  var i, j, ie, je, xej, yej, xj, yj, cp, p1;
  // At this point, we know these dimensions are correct and representative of
  // the whole 2D arrays:
  var na = x[0].length;
  var nb = x.length;

  // (n)umber of (e)xpanded points:
  var nea = asmoothing ? 3 * na - 2 : na;
  var neb = bsmoothing ? 3 * nb - 2 : nb;
  xe = ensureArray(xe, neb);
  ye = ensureArray(ye, neb);
  for (ie = 0; ie < neb; ie++) {
    xe[ie] = ensureArray(xe[ie], nea);
    ye[ie] = ensureArray(ye[ie], nea);
  }

  // This loop fills in the X'd points:
  //
  //    .       .       .       .
  //    .       .       .       .
  //    |       |       |       |
  //    |       |       |       |
  //    X ----- X ----- X ----- X
  //    |       |       |       |
  //    |       |       |       |
  //    |       |       |       |
  //    X ----- X ----- X ----- X
  //
  //
  // ie = (i) (e)xpanded:
  for (j = 0, je = 0; j < nb; j++, je += bsmoothing ? 3 : 1) {
    xej = xe[je];
    yej = ye[je];
    xj = x[j];
    yj = y[j];

    // je = (j) (e)xpanded:
    for (i = 0, ie = 0; i < na; i++, ie += asmoothing ? 3 : 1) {
      xej[ie] = xj[i];
      yej[ie] = yj[i];
    }
  }
  if (asmoothing) {
    // If there's a-smoothing, this loop fills in the X'd points with catmull-rom
    // control points computed along the a-axis:
    //     .       .       .       .
    //     .       .       .       .
    //     |       |       |       |
    //     |       |       |       |
    //     o -Y-X- o -X-X- o -X-Y- o
    //     |       |       |       |
    //     |       |       |       |
    //     |       |       |       |
    //     o -Y-X- o -X-X- o -X-Y- o
    //
    // i:  0       1       2       3
    // ie: 0  1 3  3  4 5  6  7 8  9
    //
    //           ------>
    //             a
    //
    for (j = 0, je = 0; j < nb; j++, je += bsmoothing ? 3 : 1) {
      // Fill in the points marked X for this a-row:
      for (i = 1, ie = 3; i < na - 1; i++, ie += 3) {
        cp = makeControlPoints([x[j][i - 1], y[j][i - 1]], [x[j][i], y[j][i]], [x[j][i + 1], y[j][i + 1]], asmoothing);
        xe[je][ie - 1] = cp[0][0];
        ye[je][ie - 1] = cp[0][1];
        xe[je][ie + 1] = cp[1][0];
        ye[je][ie + 1] = cp[1][1];
      }

      // The very first cubic interpolation point (to the left for i = 1 above) is
      // used as a *quadratic* interpolation point by the spline drawing function
      // which isn't really correct. But for the sake of consistency, we'll use it
      // as such. Since we're using cubic splines, that means we need to shorten the
      // tangent by 1/3 and also construct a new cubic spline control point 1/3 from
      // the original to the i = 0 point.
      p1 = inferCubicControlPoint([xe[je][0], ye[je][0]], [xe[je][2], ye[je][2]], [xe[je][3], ye[je][3]]);
      xe[je][1] = p1[0];
      ye[je][1] = p1[1];

      // Ditto last points, sans explanation:
      p1 = inferCubicControlPoint([xe[je][nea - 1], ye[je][nea - 1]], [xe[je][nea - 3], ye[je][nea - 3]], [xe[je][nea - 4], ye[je][nea - 4]]);
      xe[je][nea - 2] = p1[0];
      ye[je][nea - 2] = p1[1];
    }
  }
  if (bsmoothing) {
    // If there's a-smoothing, this loop fills in the X'd points with catmull-rom
    // control points computed along the b-axis:
    //     .       .       .       .
    //     X  X X  X  X X  X  X X  X
    //     |       |       |       |
    //     X  X X  X  X X  X  X X  X
    //     o -o-o- o -o-o- o -o-o- o
    //     X  X X  X  X X  X  X X  X
    //     |       |       |       |
    //     Y  Y Y  Y  Y Y  Y  Y Y  Y
    //     o -o-o- o -o-o- o -o-o- o
    //
    // i:  0       1       2       3
    // ie: 0  1 3  3  4 5  6  7 8  9
    //
    //           ------>
    //             a
    //
    for (ie = 0; ie < nea; ie++) {
      for (je = 3; je < neb - 3; je += 3) {
        cp = makeControlPoints([xe[je - 3][ie], ye[je - 3][ie]], [xe[je][ie], ye[je][ie]], [xe[je + 3][ie], ye[je + 3][ie]], bsmoothing);
        xe[je - 1][ie] = cp[0][0];
        ye[je - 1][ie] = cp[0][1];
        xe[je + 1][ie] = cp[1][0];
        ye[je + 1][ie] = cp[1][1];
      }
      // Do the same boundary condition magic for these control points marked Y above:
      p1 = inferCubicControlPoint([xe[0][ie], ye[0][ie]], [xe[2][ie], ye[2][ie]], [xe[3][ie], ye[3][ie]]);
      xe[1][ie] = p1[0];
      ye[1][ie] = p1[1];
      p1 = inferCubicControlPoint([xe[neb - 1][ie], ye[neb - 1][ie]], [xe[neb - 3][ie], ye[neb - 3][ie]], [xe[neb - 4][ie], ye[neb - 4][ie]]);
      xe[neb - 2][ie] = p1[0];
      ye[neb - 2][ie] = p1[1];
    }
  }
  if (asmoothing && bsmoothing) {
    // Do one more pass, this time recomputing exactly what we just computed.
    // It's overdetermined since we're peforming catmull-rom in two directions,
    // so we'll just average the overdetermined. These points don't lie along the
    // grid lines, so note that only grid lines will follow normal plotly spline
    // interpolation.
    //
    // Unless of course there was no b smoothing. Then these intermediate points
    // don't actually exist and this section is bypassed.
    //     .       .       .       .
    //     o  X X  o  X X  o  X X  o
    //     |       |       |       |
    //     o  X X  o  X X  o  X X  o
    //     o -o-o- o -o-o- o -o-o- o
    //     o  X X  o  X X  o  X X  o
    //     |       |       |       |
    //     o  Y Y  o  Y Y  o  Y Y  o
    //     o -o-o- o -o-o- o -o-o- o
    //
    // i:  0       1       2       3
    // ie: 0  1 3  3  4 5  6  7 8  9
    //
    //           ------>
    //             a
    //
    for (je = 1; je < neb; je += (je + 1) % 3 === 0 ? 2 : 1) {
      // Fill in the points marked X for this a-row:
      for (ie = 3; ie < nea - 3; ie += 3) {
        cp = makeControlPoints([xe[je][ie - 3], ye[je][ie - 3]], [xe[je][ie], ye[je][ie]], [xe[je][ie + 3], ye[je][ie + 3]], asmoothing);
        xe[je][ie - 1] = 0.5 * (xe[je][ie - 1] + cp[0][0]);
        ye[je][ie - 1] = 0.5 * (ye[je][ie - 1] + cp[0][1]);
        xe[je][ie + 1] = 0.5 * (xe[je][ie + 1] + cp[1][0]);
        ye[je][ie + 1] = 0.5 * (ye[je][ie + 1] + cp[1][1]);
      }

      // This case is just slightly different. The computation is the same,
      // but having computed this, we'll average with the existing result.
      p1 = inferCubicControlPoint([xe[je][0], ye[je][0]], [xe[je][2], ye[je][2]], [xe[je][3], ye[je][3]]);
      xe[je][1] = 0.5 * (xe[je][1] + p1[0]);
      ye[je][1] = 0.5 * (ye[je][1] + p1[1]);
      p1 = inferCubicControlPoint([xe[je][nea - 1], ye[je][nea - 1]], [xe[je][nea - 3], ye[je][nea - 3]], [xe[je][nea - 4], ye[je][nea - 4]]);
      xe[je][nea - 2] = 0.5 * (xe[je][nea - 2] + p1[0]);
      ye[je][nea - 2] = 0.5 * (ye[je][nea - 2] + p1[1]);
    }
  }
  return [xe, ye];
};

/***/ }),

/***/ 45923:
/***/ (function(module) {

"use strict";


module.exports = {
  RELATIVE_CULL_TOLERANCE: 1e-6
};

/***/ }),

/***/ 39848:
/***/ (function(module) {

"use strict";


/*
 * Evaluates the derivative of a list of control point arrays. That is, it expects an array or arrays
 * that are expanded relative to the raw data to include the bicubic control points, if applicable. If
 * only linear interpolation is desired, then the data points correspond 1-1 along that axis to the
 * data itself. Since it's catmull-rom splines in either direction note in particular that the
 * derivatives are discontinuous across cell boundaries. That's the reason you need both the *cell*
 * and the *point within the cell*.
 *
 * Also note that the discontinuity of the derivative is in magnitude only. The direction *is*
 * continuous across cell boundaries.
 *
 * For example, to compute the derivative of the xcoordinate halfway between the 7 and 8th i-gridpoints
 * and the 10th and 11th j-gridpoints given bicubic smoothing in both dimensions, you'd write:
 *
 *     var deriv = createIDerivativeEvaluator([x], 1, 1);
 *
 *     var dxdi = deriv([], 7, 10, 0.5, 0.5);
 *     // => [0.12345]
 *
 * Since there'd be a bunch of duplicate computation to compute multiple derivatives, you can double
 * this up by providing more arrays:
 *
 *     var deriv = createIDerivativeEvaluator([x, y], 1, 1);
 *
 *     var dxdi = deriv([], 7, 10, 0.5, 0.5);
 *     // => [0.12345, 0.78910]
 *
 * NB: It's presumed that at this point all data has been sanitized and is valid numerical data arrays
 * of the correct dimension.
 */
module.exports = function (arrays, asmoothing, bsmoothing) {
  if (asmoothing && bsmoothing) {
    return function (out, i0, j0, u, v) {
      if (!out) out = [];
      var f0, f1, f2, f3, ak, k;

      // Since it's a grid of control points, the actual indices are * 3:
      i0 *= 3;
      j0 *= 3;

      // Precompute some numbers:
      var u2 = u * u;
      var ou = 1 - u;
      var ou2 = ou * ou;
      var ouu2 = ou * u * 2;
      var a = -3 * ou2;
      var b = 3 * (ou2 - ouu2);
      var c = 3 * (ouu2 - u2);
      var d = 3 * u2;
      var v2 = v * v;
      var v3 = v2 * v;
      var ov = 1 - v;
      var ov2 = ov * ov;
      var ov3 = ov2 * ov;
      for (k = 0; k < arrays.length; k++) {
        ak = arrays[k];
        // Compute the derivatives in the u-direction:
        f0 = a * ak[j0][i0] + b * ak[j0][i0 + 1] + c * ak[j0][i0 + 2] + d * ak[j0][i0 + 3];
        f1 = a * ak[j0 + 1][i0] + b * ak[j0 + 1][i0 + 1] + c * ak[j0 + 1][i0 + 2] + d * ak[j0 + 1][i0 + 3];
        f2 = a * ak[j0 + 2][i0] + b * ak[j0 + 2][i0 + 1] + c * ak[j0 + 2][i0 + 2] + d * ak[j0 + 2][i0 + 3];
        f3 = a * ak[j0 + 3][i0] + b * ak[j0 + 3][i0 + 1] + c * ak[j0 + 3][i0 + 2] + d * ak[j0 + 3][i0 + 3];

        // Now just interpolate in the v-direction since it's all separable:
        out[k] = ov3 * f0 + 3 * (ov2 * v * f1 + ov * v2 * f2) + v3 * f3;
      }
      return out;
    };
  } else if (asmoothing) {
    // Handle smooth in the a-direction but linear in the b-direction by performing four
    // linear interpolations followed by one cubic interpolation of the result
    return function (out, i0, j0, u, v) {
      if (!out) out = [];
      var f0, f1, k, ak;
      i0 *= 3;
      var u2 = u * u;
      var ou = 1 - u;
      var ou2 = ou * ou;
      var ouu2 = ou * u * 2;
      var a = -3 * ou2;
      var b = 3 * (ou2 - ouu2);
      var c = 3 * (ouu2 - u2);
      var d = 3 * u2;
      var ov = 1 - v;
      for (k = 0; k < arrays.length; k++) {
        ak = arrays[k];
        f0 = a * ak[j0][i0] + b * ak[j0][i0 + 1] + c * ak[j0][i0 + 2] + d * ak[j0][i0 + 3];
        f1 = a * ak[j0 + 1][i0] + b * ak[j0 + 1][i0 + 1] + c * ak[j0 + 1][i0 + 2] + d * ak[j0 + 1][i0 + 3];
        out[k] = ov * f0 + v * f1;
      }
      return out;
    };
  } else if (bsmoothing) {
    // Same as the above case, except reversed. I've disabled the no-unused vars rule
    // so that this function is fully interpolation-agnostic. Otherwise it would need
    // to be called differently in different cases. Which wouldn't be the worst, but
    /* eslint-disable no-unused-vars */
    return function (out, i0, j0, u, v) {
      /* eslint-enable no-unused-vars */
      if (!out) out = [];
      var f0, f1, f2, f3, k, ak;
      j0 *= 3;
      var v2 = v * v;
      var v3 = v2 * v;
      var ov = 1 - v;
      var ov2 = ov * ov;
      var ov3 = ov2 * ov;
      for (k = 0; k < arrays.length; k++) {
        ak = arrays[k];
        f0 = ak[j0][i0 + 1] - ak[j0][i0];
        f1 = ak[j0 + 1][i0 + 1] - ak[j0 + 1][i0];
        f2 = ak[j0 + 2][i0 + 1] - ak[j0 + 2][i0];
        f3 = ak[j0 + 3][i0 + 1] - ak[j0 + 3][i0];
        out[k] = ov3 * f0 + 3 * (ov2 * v * f1 + ov * v2 * f2) + v3 * f3;
      }
      return out;
    };
  } else {
    // Finally, both directions are linear:
    /* eslint-disable no-unused-vars */
    return function (out, i0, j0, u, v) {
      /* eslint-enable no-unused-vars */
      if (!out) out = [];
      var f0, f1, k, ak;
      var ov = 1 - v;
      for (k = 0; k < arrays.length; k++) {
        ak = arrays[k];
        f0 = ak[j0][i0 + 1] - ak[j0][i0];
        f1 = ak[j0 + 1][i0 + 1] - ak[j0 + 1][i0];
        out[k] = ov * f0 + v * f1;
      }
      return out;
    };
  }
};

/***/ }),

/***/ 41839:
/***/ (function(module) {

"use strict";


module.exports = function (arrays, asmoothing, bsmoothing) {
  if (asmoothing && bsmoothing) {
    return function (out, i0, j0, u, v) {
      if (!out) out = [];
      var f0, f1, f2, f3, ak, k;

      // Since it's a grid of control points, the actual indices are * 3:
      i0 *= 3;
      j0 *= 3;

      // Precompute some numbers:
      var u2 = u * u;
      var u3 = u2 * u;
      var ou = 1 - u;
      var ou2 = ou * ou;
      var ou3 = ou2 * ou;
      var v2 = v * v;
      var ov = 1 - v;
      var ov2 = ov * ov;
      var ovv2 = ov * v * 2;
      var a = -3 * ov2;
      var b = 3 * (ov2 - ovv2);
      var c = 3 * (ovv2 - v2);
      var d = 3 * v2;
      for (k = 0; k < arrays.length; k++) {
        ak = arrays[k];

        // Compute the derivatives in the v-direction:
        f0 = a * ak[j0][i0] + b * ak[j0 + 1][i0] + c * ak[j0 + 2][i0] + d * ak[j0 + 3][i0];
        f1 = a * ak[j0][i0 + 1] + b * ak[j0 + 1][i0 + 1] + c * ak[j0 + 2][i0 + 1] + d * ak[j0 + 3][i0 + 1];
        f2 = a * ak[j0][i0 + 2] + b * ak[j0 + 1][i0 + 2] + c * ak[j0 + 2][i0 + 2] + d * ak[j0 + 3][i0 + 2];
        f3 = a * ak[j0][i0 + 3] + b * ak[j0 + 1][i0 + 3] + c * ak[j0 + 2][i0 + 3] + d * ak[j0 + 3][i0 + 3];

        // Now just interpolate in the v-direction since it's all separable:
        out[k] = ou3 * f0 + 3 * (ou2 * u * f1 + ou * u2 * f2) + u3 * f3;
      }
      return out;
    };
  } else if (asmoothing) {
    // Handle smooth in the a-direction but linear in the b-direction by performing four
    // linear interpolations followed by one cubic interpolation of the result
    return function (out, i0, j0, v, u) {
      if (!out) out = [];
      var f0, f1, f2, f3, k, ak;
      i0 *= 3;
      var u2 = u * u;
      var u3 = u2 * u;
      var ou = 1 - u;
      var ou2 = ou * ou;
      var ou3 = ou2 * ou;
      for (k = 0; k < arrays.length; k++) {
        ak = arrays[k];
        f0 = ak[j0 + 1][i0] - ak[j0][i0];
        f1 = ak[j0 + 1][i0 + 1] - ak[j0][i0 + 1];
        f2 = ak[j0 + 1][i0 + 2] - ak[j0][i0 + 2];
        f3 = ak[j0 + 1][i0 + 3] - ak[j0][i0 + 3];
        out[k] = ou3 * f0 + 3 * (ou2 * u * f1 + ou * u2 * f2) + u3 * f3;

        // mathematically equivalent:
        // f0 = ou3 * ak[j0    ][i0] + 3 * (ou2 * u * ak[j0    ][i0 + 1] + ou * u2 * ak[j0    ][i0 + 2]) + u3 * ak[j0    ][i0 + 3];
        // f1 = ou3 * ak[j0 + 1][i0] + 3 * (ou2 * u * ak[j0 + 1][i0 + 1] + ou * u2 * ak[j0 + 1][i0 + 2]) + u3 * ak[j0 + 1][i0 + 3];
        // out[k] = f1 - f0;
      }
      return out;
    };
  } else if (bsmoothing) {
    // Same as the above case, except reversed:
    /* eslint-disable no-unused-vars */
    return function (out, i0, j0, u, v) {
      /* eslint-enable no-unused-vars */
      if (!out) out = [];
      var f0, f1, k, ak;
      j0 *= 3;
      var ou = 1 - u;
      var v2 = v * v;
      var ov = 1 - v;
      var ov2 = ov * ov;
      var ovv2 = ov * v * 2;
      var a = -3 * ov2;
      var b = 3 * (ov2 - ovv2);
      var c = 3 * (ovv2 - v2);
      var d = 3 * v2;
      for (k = 0; k < arrays.length; k++) {
        ak = arrays[k];
        f0 = a * ak[j0][i0] + b * ak[j0 + 1][i0] + c * ak[j0 + 2][i0] + d * ak[j0 + 3][i0];
        f1 = a * ak[j0][i0 + 1] + b * ak[j0 + 1][i0 + 1] + c * ak[j0 + 2][i0 + 1] + d * ak[j0 + 3][i0 + 1];
        out[k] = ou * f0 + u * f1;
      }
      return out;
    };
  } else {
    // Finally, both directions are linear:
    /* eslint-disable no-unused-vars */
    return function (out, i0, j0, v, u) {
      /* eslint-enable no-unused-vars */
      if (!out) out = [];
      var f0, f1, k, ak;
      var ov = 1 - v;
      for (k = 0; k < arrays.length; k++) {
        ak = arrays[k];
        f0 = ak[j0 + 1][i0] - ak[j0][i0];
        f1 = ak[j0 + 1][i0 + 1] - ak[j0][i0 + 1];
        out[k] = ov * f0 + v * f1;
      }
      return out;
    };
  }
};

/***/ }),

/***/ 13828:
/***/ (function(module) {

"use strict";


/*
 * Return a function that evaluates a set of linear or bicubic control points.
 * This will get evaluated a lot, so we'll at least do a bit of extra work to
 * flatten some of the choices. In particular, we'll unroll the linear/bicubic
 * combinations and we'll allow computing results in parallel to cut down
 * on repeated arithmetic.
 *
 * Take note that we don't search for the correct range in this function. The
 * reason is for consistency due to the corrresponding derivative function. In
 * particular, the derivatives aren't continuous across cells, so it's important
 * to be able control whether the derivative at a cell boundary is approached
 * from one side or the other.
 */
module.exports = function (arrays, na, nb, asmoothing, bsmoothing) {
  var imax = na - 2;
  var jmax = nb - 2;
  if (asmoothing && bsmoothing) {
    return function (out, i, j) {
      if (!out) out = [];
      var f0, f1, f2, f3, ak, k;
      var i0 = Math.max(0, Math.min(Math.floor(i), imax));
      var j0 = Math.max(0, Math.min(Math.floor(j), jmax));
      var u = Math.max(0, Math.min(1, i - i0));
      var v = Math.max(0, Math.min(1, j - j0));

      // Since it's a grid of control points, the actual indices are * 3:
      i0 *= 3;
      j0 *= 3;

      // Precompute some numbers:
      var u2 = u * u;
      var u3 = u2 * u;
      var ou = 1 - u;
      var ou2 = ou * ou;
      var ou3 = ou2 * ou;
      var v2 = v * v;
      var v3 = v2 * v;
      var ov = 1 - v;
      var ov2 = ov * ov;
      var ov3 = ov2 * ov;
      for (k = 0; k < arrays.length; k++) {
        ak = arrays[k];
        f0 = ou3 * ak[j0][i0] + 3 * (ou2 * u * ak[j0][i0 + 1] + ou * u2 * ak[j0][i0 + 2]) + u3 * ak[j0][i0 + 3];
        f1 = ou3 * ak[j0 + 1][i0] + 3 * (ou2 * u * ak[j0 + 1][i0 + 1] + ou * u2 * ak[j0 + 1][i0 + 2]) + u3 * ak[j0 + 1][i0 + 3];
        f2 = ou3 * ak[j0 + 2][i0] + 3 * (ou2 * u * ak[j0 + 2][i0 + 1] + ou * u2 * ak[j0 + 2][i0 + 2]) + u3 * ak[j0 + 2][i0 + 3];
        f3 = ou3 * ak[j0 + 3][i0] + 3 * (ou2 * u * ak[j0 + 3][i0 + 1] + ou * u2 * ak[j0 + 3][i0 + 2]) + u3 * ak[j0 + 3][i0 + 3];
        out[k] = ov3 * f0 + 3 * (ov2 * v * f1 + ov * v2 * f2) + v3 * f3;
      }
      return out;
    };
  } else if (asmoothing) {
    // Handle smooth in the a-direction but linear in the b-direction by performing four
    // linear interpolations followed by one cubic interpolation of the result
    return function (out, i, j) {
      if (!out) out = [];
      var i0 = Math.max(0, Math.min(Math.floor(i), imax));
      var j0 = Math.max(0, Math.min(Math.floor(j), jmax));
      var u = Math.max(0, Math.min(1, i - i0));
      var v = Math.max(0, Math.min(1, j - j0));
      var f0, f1, f2, f3, k, ak;
      i0 *= 3;
      var u2 = u * u;
      var u3 = u2 * u;
      var ou = 1 - u;
      var ou2 = ou * ou;
      var ou3 = ou2 * ou;
      var ov = 1 - v;
      for (k = 0; k < arrays.length; k++) {
        ak = arrays[k];
        f0 = ov * ak[j0][i0] + v * ak[j0 + 1][i0];
        f1 = ov * ak[j0][i0 + 1] + v * ak[j0 + 1][i0 + 1];
        f2 = ov * ak[j0][i0 + 2] + v * ak[j0 + 1][i0 + 1];
        f3 = ov * ak[j0][i0 + 3] + v * ak[j0 + 1][i0 + 1];
        out[k] = ou3 * f0 + 3 * (ou2 * u * f1 + ou * u2 * f2) + u3 * f3;
      }
      return out;
    };
  } else if (bsmoothing) {
    // Same as the above case, except reversed:
    return function (out, i, j) {
      if (!out) out = [];
      var i0 = Math.max(0, Math.min(Math.floor(i), imax));
      var j0 = Math.max(0, Math.min(Math.floor(j), jmax));
      var u = Math.max(0, Math.min(1, i - i0));
      var v = Math.max(0, Math.min(1, j - j0));
      var f0, f1, f2, f3, k, ak;
      j0 *= 3;
      var v2 = v * v;
      var v3 = v2 * v;
      var ov = 1 - v;
      var ov2 = ov * ov;
      var ov3 = ov2 * ov;
      var ou = 1 - u;
      for (k = 0; k < arrays.length; k++) {
        ak = arrays[k];
        f0 = ou * ak[j0][i0] + u * ak[j0][i0 + 1];
        f1 = ou * ak[j0 + 1][i0] + u * ak[j0 + 1][i0 + 1];
        f2 = ou * ak[j0 + 2][i0] + u * ak[j0 + 2][i0 + 1];
        f3 = ou * ak[j0 + 3][i0] + u * ak[j0 + 3][i0 + 1];
        out[k] = ov3 * f0 + 3 * (ov2 * v * f1 + ov * v2 * f2) + v3 * f3;
      }
      return out;
    };
  } else {
    // Finally, both directions are linear:
    return function (out, i, j) {
      if (!out) out = [];
      var i0 = Math.max(0, Math.min(Math.floor(i), imax));
      var j0 = Math.max(0, Math.min(Math.floor(j), jmax));
      var u = Math.max(0, Math.min(1, i - i0));
      var v = Math.max(0, Math.min(1, j - j0));
      var f0, f1, k, ak;
      var ov = 1 - v;
      var ou = 1 - u;
      for (k = 0; k < arrays.length; k++) {
        ak = arrays[k];
        f0 = ou * ak[j0][i0] + u * ak[j0][i0 + 1];
        f1 = ou * ak[j0 + 1][i0] + u * ak[j0 + 1][i0 + 1];
        out[k] = ov * f0 + v * f1;
      }
      return out;
    };
  }
};

/***/ }),

/***/ 13254:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var handleXYDefaults = __webpack_require__(10820);
var handleABDefaults = __webpack_require__(8432);
var attributes = __webpack_require__(43745);
var colorAttrs = __webpack_require__(10229);
module.exports = function supplyDefaults(traceIn, traceOut, dfltColor, fullLayout) {
  function coerce(attr, dflt) {
    return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
  }
  traceOut._clipPathId = 'clip' + traceOut.uid + 'carpet';
  var defaultColor = coerce('color', colorAttrs.defaultLine);
  Lib.coerceFont(coerce, 'font', fullLayout.font);
  coerce('carpet');
  handleABDefaults(traceIn, traceOut, fullLayout, coerce, defaultColor);
  if (!traceOut.a || !traceOut.b) {
    traceOut.visible = false;
    return;
  }
  if (traceOut.a.length < 3) {
    traceOut.aaxis.smoothing = 0;
  }
  if (traceOut.b.length < 3) {
    traceOut.baxis.smoothing = 0;
  }

  // NB: the input is x/y arrays. You should know that the *first* dimension of x and y
  // corresponds to b and the second to a. This sounds backwards but ends up making sense
  // the important part to know is that when you write y[j][i], j goes from 0 to b.length - 1
  // and i goes from 0 to a.length - 1.
  var validData = handleXYDefaults(traceIn, traceOut, coerce);
  if (!validData) {
    traceOut.visible = false;
  }
  if (traceOut._cheater) {
    coerce('cheaterslope');
  }
  coerce('zorder');
};

/***/ }),

/***/ 48050:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = {
  attributes: __webpack_require__(43745),
  supplyDefaults: __webpack_require__(13254),
  plot: __webpack_require__(87947),
  calc: __webpack_require__(67525),
  animatable: true,
  isContainer: true,
  // so carpet traces get `calc` before other traces

  moduleType: 'trace',
  name: 'carpet',
  basePlotModule: __webpack_require__(37703),
  categories: ['cartesian', 'svg', 'carpet', 'carpetAxis', 'notLegendIsolatable', 'noMultiCategory', 'noHover', 'noSortingByValue'],
  meta: {}
};

/***/ }),

/***/ 26571:
/***/ (function(module) {

"use strict";


/*
 * Given a trace, look up the carpet axis by carpet.
 */
module.exports = function (gd, trace) {
  var n = gd._fullData.length;
  var firstAxis;
  for (var i = 0; i < n; i++) {
    var maybeCarpet = gd._fullData[i];
    if (maybeCarpet.index === trace.index) continue;
    if (maybeCarpet.type === 'carpet') {
      if (!firstAxis) {
        firstAxis = maybeCarpet;
      }
      if (maybeCarpet.carpet === trace.carpet) {
        return maybeCarpet;
      }
    }
  }
  return firstAxis;
};

/***/ }),

/***/ 3685:
/***/ (function(module) {

"use strict";


module.exports = function makePath(xp, yp, isBicubic) {
  // Prevent d3 errors that would result otherwise:
  if (xp.length === 0) return '';
  var i;
  var path = [];
  var stride = isBicubic ? 3 : 1;
  for (i = 0; i < xp.length; i += stride) {
    path.push(xp[i] + ',' + yp[i]);
    if (isBicubic && i < xp.length - stride) {
      path.push('C');
      path.push([xp[i + 1] + ',' + yp[i + 1], xp[i + 2] + ',' + yp[i + 2] + ' '].join(' '));
    }
  }
  return path.join(isBicubic ? '' : 'L');
};

/***/ }),

/***/ 6720:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isArrayOrTypedArray = (__webpack_require__(34809).isArrayOrTypedArray);

/*
 * Map an array of x or y coordinates (c) to screen-space pixel coordinates (p).
 * The output array is optional, but if provided, it will be reused without
 * reallocation to the extent possible.
 */
module.exports = function mapArray(out, data, func) {
  var i;
  if (!isArrayOrTypedArray(out)) {
    // If not an array, make it an array:
    out = [];
  } else if (out.length > data.length) {
    // If too long, truncate. (If too short, it will grow
    // automatically so we don't care about that case)
    out = out.slice(0, data.length);
  }
  for (i = 0; i < data.length; i++) {
    out[i] = func(data[i]);
  }
  return out;
};

/***/ }),

/***/ 33163:
/***/ (function(module) {

"use strict";


module.exports = function orientText(trace, xaxis, yaxis, xy, dxy, refDxy) {
  var dx = dxy[0] * trace.dpdx(xaxis);
  var dy = dxy[1] * trace.dpdy(yaxis);
  var flip = 1;
  var offsetMultiplier = 1.0;
  if (refDxy) {
    var l1 = Math.sqrt(dxy[0] * dxy[0] + dxy[1] * dxy[1]);
    var l2 = Math.sqrt(refDxy[0] * refDxy[0] + refDxy[1] * refDxy[1]);
    var dot = (dxy[0] * refDxy[0] + dxy[1] * refDxy[1]) / l1 / l2;
    offsetMultiplier = Math.max(0.0, dot);
  }
  var angle = Math.atan2(dy, dx) * 180 / Math.PI;
  if (angle < -90) {
    angle += 180;
    flip = -flip;
  } else if (angle > 90) {
    angle -= 180;
    flip = -flip;
  }
  return {
    angle: angle,
    flip: flip,
    p: trace.c2p(xy, xaxis, yaxis),
    offsetMultplier: offsetMultiplier
  };
};

/***/ }),

/***/ 87947:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var Drawing = __webpack_require__(62203);
var map1dArray = __webpack_require__(6720);
var makepath = __webpack_require__(3685);
var orientText = __webpack_require__(33163);
var svgTextUtils = __webpack_require__(30635);
var Lib = __webpack_require__(34809);
var strRotate = Lib.strRotate;
var strTranslate = Lib.strTranslate;
var alignmentConstants = __webpack_require__(4530);
module.exports = function plot(gd, plotinfo, cdcarpet, carpetLayer) {
  var isStatic = gd._context.staticPlot;
  var xa = plotinfo.xaxis;
  var ya = plotinfo.yaxis;
  var fullLayout = gd._fullLayout;
  var clipLayer = fullLayout._clips;
  Lib.makeTraceGroups(carpetLayer, cdcarpet, 'trace').each(function (cd) {
    var axisLayer = d3.select(this);
    var cd0 = cd[0];
    var trace = cd0.trace;
    var aax = trace.aaxis;
    var bax = trace.baxis;
    var minorLayer = Lib.ensureSingle(axisLayer, 'g', 'minorlayer');
    var majorLayer = Lib.ensureSingle(axisLayer, 'g', 'majorlayer');
    var boundaryLayer = Lib.ensureSingle(axisLayer, 'g', 'boundarylayer');
    var labelLayer = Lib.ensureSingle(axisLayer, 'g', 'labellayer');
    axisLayer.style('opacity', trace.opacity);
    drawGridLines(xa, ya, majorLayer, aax, 'a', aax._gridlines, true, isStatic);
    drawGridLines(xa, ya, majorLayer, bax, 'b', bax._gridlines, true, isStatic);
    drawGridLines(xa, ya, minorLayer, aax, 'a', aax._minorgridlines, true, isStatic);
    drawGridLines(xa, ya, minorLayer, bax, 'b', bax._minorgridlines, true, isStatic);

    // NB: These are not omitted if the lines are not active. The joins must be executed
    // in order for them to get cleaned up without a full redraw
    drawGridLines(xa, ya, boundaryLayer, aax, 'a-boundary', aax._boundarylines, isStatic);
    drawGridLines(xa, ya, boundaryLayer, bax, 'b-boundary', bax._boundarylines, isStatic);
    var labelOrientationA = drawAxisLabels(gd, xa, ya, trace, cd0, labelLayer, aax._labels, 'a-label');
    var labelOrientationB = drawAxisLabels(gd, xa, ya, trace, cd0, labelLayer, bax._labels, 'b-label');
    drawAxisTitles(gd, labelLayer, trace, cd0, xa, ya, labelOrientationA, labelOrientationB);
    drawClipPath(trace, cd0, clipLayer, xa, ya);
  });
};
function drawClipPath(trace, t, layer, xaxis, yaxis) {
  var seg, xp, yp, i;
  var clip = layer.select('#' + trace._clipPathId);
  if (!clip.size()) {
    clip = layer.append('clipPath').classed('carpetclip', true);
  }
  var path = Lib.ensureSingle(clip, 'path', 'carpetboundary');
  var segments = t.clipsegments;
  var segs = [];
  for (i = 0; i < segments.length; i++) {
    seg = segments[i];
    xp = map1dArray([], seg.x, xaxis.c2p);
    yp = map1dArray([], seg.y, yaxis.c2p);
    segs.push(makepath(xp, yp, seg.bicubic));
  }

  // This could be optimized ever so slightly to avoid no-op L segments
  // at the corners, but it's so negligible that I don't think it's worth
  // the extra complexity
  var clipPathData = 'M' + segs.join('L') + 'Z';
  clip.attr('id', trace._clipPathId);
  path.attr('d', clipPathData);
}
function drawGridLines(xaxis, yaxis, layer, axis, axisLetter, gridlines, isStatic) {
  var lineClass = 'const-' + axisLetter + '-lines';
  var gridJoin = layer.selectAll('.' + lineClass).data(gridlines);
  gridJoin.enter().append('path').classed(lineClass, true).style('vector-effect', isStatic ? 'none' : 'non-scaling-stroke');
  gridJoin.each(function (d) {
    var gridline = d;
    var x = gridline.x;
    var y = gridline.y;
    var xp = map1dArray([], x, xaxis.c2p);
    var yp = map1dArray([], y, yaxis.c2p);
    var path = 'M' + makepath(xp, yp, gridline.smoothing);
    var el = d3.select(this);
    el.attr('d', path).style('stroke-width', gridline.width).style('stroke', gridline.color).style('stroke-dasharray', Drawing.dashStyle(gridline.dash, gridline.width)).style('fill', 'none');
  });
  gridJoin.exit().remove();
}
function drawAxisLabels(gd, xaxis, yaxis, trace, t, layer, labels, labelClass) {
  var labelJoin = layer.selectAll('text.' + labelClass).data(labels);
  labelJoin.enter().append('text').classed(labelClass, true);
  var maxExtent = 0;
  var labelOrientation = {};
  labelJoin.each(function (label, i) {
    // Most of the positioning is done in calc_labels. Only the parts that depend upon
    // the screen space representation of the x and y axes are here:
    var orientation;
    if (label.axis.tickangle === 'auto') {
      orientation = orientText(trace, xaxis, yaxis, label.xy, label.dxy);
    } else {
      var angle = (label.axis.tickangle + 180.0) * Math.PI / 180.0;
      orientation = orientText(trace, xaxis, yaxis, label.xy, [Math.cos(angle), Math.sin(angle)]);
    }
    if (!i) {
      // TODO: offsetMultiplier? Not currently used anywhere...
      labelOrientation = {
        angle: orientation.angle,
        flip: orientation.flip
      };
    }
    var direction = (label.endAnchor ? -1 : 1) * orientation.flip;
    var labelEl = d3.select(this).attr({
      'text-anchor': direction > 0 ? 'start' : 'end',
      'data-notex': 1
    }).call(Drawing.font, label.font).text(label.text).call(svgTextUtils.convertToTspans, gd);
    var bbox = Drawing.bBox(this);
    labelEl.attr('transform',
    // Translate to the correct point:
    strTranslate(orientation.p[0], orientation.p[1]) +
    // Rotate to line up with grid line tangent:
    strRotate(orientation.angle) +
    // Adjust the baseline and indentation:
    strTranslate(label.axis.labelpadding * direction, bbox.height * 0.3));
    maxExtent = Math.max(maxExtent, bbox.width + label.axis.labelpadding);
  });
  labelJoin.exit().remove();
  labelOrientation.maxExtent = maxExtent;
  return labelOrientation;
}
function drawAxisTitles(gd, layer, trace, t, xa, ya, labelOrientationA, labelOrientationB) {
  var a, b, xy, dxy;
  var aMin = Lib.aggNums(Math.min, null, trace.a);
  var aMax = Lib.aggNums(Math.max, null, trace.a);
  var bMin = Lib.aggNums(Math.min, null, trace.b);
  var bMax = Lib.aggNums(Math.max, null, trace.b);
  a = 0.5 * (aMin + aMax);
  b = bMin;
  xy = trace.ab2xy(a, b, true);
  dxy = trace.dxyda_rough(a, b);
  if (labelOrientationA.angle === undefined) {
    Lib.extendFlat(labelOrientationA, orientText(trace, xa, ya, xy, trace.dxydb_rough(a, b)));
  }
  drawAxisTitle(gd, layer, trace, t, xy, dxy, trace.aaxis, xa, ya, labelOrientationA, 'a-title');
  a = aMin;
  b = 0.5 * (bMin + bMax);
  xy = trace.ab2xy(a, b, true);
  dxy = trace.dxydb_rough(a, b);
  if (labelOrientationB.angle === undefined) {
    Lib.extendFlat(labelOrientationB, orientText(trace, xa, ya, xy, trace.dxyda_rough(a, b)));
  }
  drawAxisTitle(gd, layer, trace, t, xy, dxy, trace.baxis, xa, ya, labelOrientationB, 'b-title');
}
var lineSpacing = alignmentConstants.LINE_SPACING;
var midShift = (1 - alignmentConstants.MID_SHIFT) / lineSpacing + 1;
function drawAxisTitle(gd, layer, trace, t, xy, dxy, axis, xa, ya, labelOrientation, labelClass) {
  var data = [];
  if (axis.title.text) data.push(axis.title.text);
  var titleJoin = layer.selectAll('text.' + labelClass).data(data);
  var offset = labelOrientation.maxExtent;
  titleJoin.enter().append('text').classed(labelClass, true);

  // There's only one, but we'll do it as a join so it's updated nicely:
  titleJoin.each(function () {
    var orientation = orientText(trace, xa, ya, xy, dxy);
    if (['start', 'both'].indexOf(axis.showticklabels) === -1) {
      offset = 0;
    }

    // In addition to the size of the labels, add on some extra padding:
    var titleSize = axis.title.font.size;
    offset += titleSize + axis.title.offset;
    var labelNorm = labelOrientation.angle + (labelOrientation.flip < 0 ? 180 : 0);
    var angleDiff = (labelNorm - orientation.angle + 450) % 360;
    var reverseTitle = angleDiff > 90 && angleDiff < 270;
    var el = d3.select(this);
    el.text(axis.title.text).call(svgTextUtils.convertToTspans, gd);
    if (reverseTitle) {
      offset = (-svgTextUtils.lineCount(el) + midShift) * lineSpacing * titleSize - offset;
    }
    el.attr('transform', strTranslate(orientation.p[0], orientation.p[1]) + strRotate(orientation.angle) + strTranslate(0, offset)).attr('text-anchor', 'middle').call(Drawing.font, axis.title.font);
  });
  titleJoin.exit().remove();
}

/***/ }),

/***/ 76842:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var constants = __webpack_require__(45923);
var search = (__webpack_require__(98813).findBin);
var computeControlPoints = __webpack_require__(57075);
var createSplineEvaluator = __webpack_require__(13828);
var createIDerivativeEvaluator = __webpack_require__(39848);
var createJDerivativeEvaluator = __webpack_require__(41839);

/*
 * Create conversion functions to go from one basis to another. In particular the letter
 * abbreviations are:
 *
 *   i: i/j coordinates along the grid. Integer values correspond to data points
 *   a: real-valued coordinates along the a/b axes
 *   c: cartesian x-y coordinates
 *   p: screen-space pixel coordinates
 */
module.exports = function setConvert(trace) {
  var a = trace._a;
  var b = trace._b;
  var na = a.length;
  var nb = b.length;
  var aax = trace.aaxis;
  var bax = trace.baxis;

  // Grab the limits once rather than recomputing the bounds for every point
  // independently:
  var amin = a[0];
  var amax = a[na - 1];
  var bmin = b[0];
  var bmax = b[nb - 1];
  var arange = a[a.length - 1] - a[0];
  var brange = b[b.length - 1] - b[0];

  // Compute the tolerance so that points are visible slightly outside the
  // defined carpet axis:
  var atol = arange * constants.RELATIVE_CULL_TOLERANCE;
  var btol = brange * constants.RELATIVE_CULL_TOLERANCE;

  // Expand the limits to include the relative tolerance:
  amin -= atol;
  amax += atol;
  bmin -= btol;
  bmax += btol;
  trace.isVisible = function (a, b) {
    return a > amin && a < amax && b > bmin && b < bmax;
  };
  trace.isOccluded = function (a, b) {
    return a < amin || a > amax || b < bmin || b > bmax;
  };
  trace.setScale = function () {
    var x = trace._x;
    var y = trace._y;

    // This is potentially a very expensive step! It does the bulk of the work of constructing
    // an expanded basis of control points. Note in particular that it overwrites the existing
    // basis without creating a new array since that would potentially thrash the garbage
    // collector.
    var result = computeControlPoints(trace._xctrl, trace._yctrl, x, y, aax.smoothing, bax.smoothing);
    trace._xctrl = result[0];
    trace._yctrl = result[1];

    // This step is the second step in the process, but it's somewhat simpler. It just unrolls
    // some logic since it would be unnecessarily expensive to compute both interpolations
    // nearly identically but separately and to include a bunch of linear vs. bicubic logic in
    // every single call.
    trace.evalxy = createSplineEvaluator([trace._xctrl, trace._yctrl], na, nb, aax.smoothing, bax.smoothing);
    trace.dxydi = createIDerivativeEvaluator([trace._xctrl, trace._yctrl], aax.smoothing, bax.smoothing);
    trace.dxydj = createJDerivativeEvaluator([trace._xctrl, trace._yctrl], aax.smoothing, bax.smoothing);
  };

  /*
   * Convert from i/j data grid coordinates to a/b values. Note in particular that this
   * is *linear* interpolation, even if the data is interpolated bicubically.
   */
  trace.i2a = function (i) {
    var i0 = Math.max(0, Math.floor(i[0]), na - 2);
    var ti = i[0] - i0;
    return (1 - ti) * a[i0] + ti * a[i0 + 1];
  };
  trace.j2b = function (j) {
    var j0 = Math.max(0, Math.floor(j[1]), na - 2);
    var tj = j[1] - j0;
    return (1 - tj) * b[j0] + tj * b[j0 + 1];
  };
  trace.ij2ab = function (ij) {
    return [trace.i2a(ij[0]), trace.j2b(ij[1])];
  };

  /*
   * Convert from a/b coordinates to i/j grid-numbered coordinates. This requires searching
   * through the a/b data arrays and assumes they are monotonic, which is presumed to have
   * been enforced already.
   */
  trace.a2i = function (aval) {
    var i0 = Math.max(0, Math.min(search(aval, a), na - 2));
    var a0 = a[i0];
    var a1 = a[i0 + 1];
    return Math.max(0, Math.min(na - 1, i0 + (aval - a0) / (a1 - a0)));
  };
  trace.b2j = function (bval) {
    var j0 = Math.max(0, Math.min(search(bval, b), nb - 2));
    var b0 = b[j0];
    var b1 = b[j0 + 1];
    return Math.max(0, Math.min(nb - 1, j0 + (bval - b0) / (b1 - b0)));
  };
  trace.ab2ij = function (ab) {
    return [trace.a2i(ab[0]), trace.b2j(ab[1])];
  };

  /*
   * Convert from i/j coordinates to x/y caretesian coordinates. This means either bilinear
   * or bicubic spline evaluation, but the hard part is already done at this point.
   */
  trace.i2c = function (i, j) {
    return trace.evalxy([], i, j);
  };
  trace.ab2xy = function (aval, bval, extrapolate) {
    if (!extrapolate && (aval < a[0] || aval > a[na - 1] | bval < b[0] || bval > b[nb - 1])) {
      return [false, false];
    }
    var i = trace.a2i(aval);
    var j = trace.b2j(bval);
    var pt = trace.evalxy([], i, j);
    if (extrapolate) {
      // This section uses the boundary derivatives to extrapolate linearly outside
      // the defined range. Consider a scatter line with one point inside the carpet
      // axis and one point outside. If we don't extrapolate, we can't draw the line
      // at all.
      var iex = 0;
      var jex = 0;
      var der = [];
      var i0, ti, j0, tj;
      if (aval < a[0]) {
        i0 = 0;
        ti = 0;
        iex = (aval - a[0]) / (a[1] - a[0]);
      } else if (aval > a[na - 1]) {
        i0 = na - 2;
        ti = 1;
        iex = (aval - a[na - 1]) / (a[na - 1] - a[na - 2]);
      } else {
        i0 = Math.max(0, Math.min(na - 2, Math.floor(i)));
        ti = i - i0;
      }
      if (bval < b[0]) {
        j0 = 0;
        tj = 0;
        jex = (bval - b[0]) / (b[1] - b[0]);
      } else if (bval > b[nb - 1]) {
        j0 = nb - 2;
        tj = 1;
        jex = (bval - b[nb - 1]) / (b[nb - 1] - b[nb - 2]);
      } else {
        j0 = Math.max(0, Math.min(nb - 2, Math.floor(j)));
        tj = j - j0;
      }
      if (iex) {
        trace.dxydi(der, i0, j0, ti, tj);
        pt[0] += der[0] * iex;
        pt[1] += der[1] * iex;
      }
      if (jex) {
        trace.dxydj(der, i0, j0, ti, tj);
        pt[0] += der[0] * jex;
        pt[1] += der[1] * jex;
      }
    }
    return pt;
  };
  trace.c2p = function (xy, xa, ya) {
    return [xa.c2p(xy[0]), ya.c2p(xy[1])];
  };
  trace.p2x = function (p, xa, ya) {
    return [xa.p2c(p[0]), ya.p2c(p[1])];
  };
  trace.dadi = function (i /* , u*/) {
    // Right now only a piecewise linear a or b basis is permitted since smoother interpolation
    // would cause monotonicity problems. As a retult, u is entirely disregarded in this
    // computation, though we'll specify it as a parameter for the sake of completeness and
    // future-proofing. It would be possible to use monotonic cubic interpolation, for example.
    //
    // See: https://en.wikipedia.org/wiki/Monotone_cubic_interpolation

    // u = u || 0;

    var i0 = Math.max(0, Math.min(a.length - 2, i));

    // The step (denominator) is implicitly 1 since that's the grid spacing.
    return a[i0 + 1] - a[i0];
  };
  trace.dbdj = function (j /* , v*/) {
    // See above caveats for dadi which also apply here
    var j0 = Math.max(0, Math.min(b.length - 2, j));

    // The step (denominator) is implicitly 1 since that's the grid spacing.
    return b[j0 + 1] - b[j0];
  };

  // Takes: grid cell coordinate (i, j) and fractional grid cell coordinates (u, v)
  // Returns: (dx/da, dy/db)
  //
  // NB: separate grid cell + fractional grid cell coordinate format is due to the discontinuous
  // derivative, as described better in create_i_derivative_evaluator.js
  trace.dxyda = function (i0, j0, u, v) {
    var dxydi = trace.dxydi(null, i0, j0, u, v);
    var dadi = trace.dadi(i0, u);
    return [dxydi[0] / dadi, dxydi[1] / dadi];
  };
  trace.dxydb = function (i0, j0, u, v) {
    var dxydj = trace.dxydj(null, i0, j0, u, v);
    var dbdj = trace.dbdj(j0, v);
    return [dxydj[0] / dbdj, dxydj[1] / dbdj];
  };

  // Sometimes we don't care about precision and all we really want is decent rough
  // directions (as is the case with labels). In that case, we can do a very rough finite
  // difference and spare having to worry about precise grid coordinates:
  trace.dxyda_rough = function (a, b, reldiff) {
    var h = arange * (reldiff || 0.1);
    var plus = trace.ab2xy(a + h, b, true);
    var minus = trace.ab2xy(a - h, b, true);
    return [(plus[0] - minus[0]) * 0.5 / h, (plus[1] - minus[1]) * 0.5 / h];
  };
  trace.dxydb_rough = function (a, b, reldiff) {
    var h = brange * (reldiff || 0.1);
    var plus = trace.ab2xy(a, b + h, true);
    var minus = trace.ab2xy(a, b - h, true);
    return [(plus[0] - minus[0]) * 0.5 / h, (plus[1] - minus[1]) * 0.5 / h];
  };
  trace.dpdx = function (xa) {
    return xa._m;
  };
  trace.dpdy = function (ya) {
    return ya._m;
  };
};

/***/ }),

/***/ 13007:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);

/*
 * Given a 2D array as well as a basis in either direction, this function fills in the
 * 2D array using a combination of smoothing and extrapolation. This is rather important
 * for carpet plots since it's used for layout so that we can't simply omit or blank out
 * points. We need a reasonable guess so that the interpolation puts points somewhere
 * even if we were to somehow represent that the data was missing later on.
 *
 * input:
 *  - data: 2D array of arrays
 *  - a: array such that a.length === data[0].length
 *  - b: array such that b.length === data.length
 */
module.exports = function smoothFill2dArray(data, a, b) {
  var i, j, k;
  var ip = [];
  var jp = [];
  // var neighborCnts = [];

  var ni = data[0].length;
  var nj = data.length;
  function avgSurrounding(i, j) {
    // As a low-quality start, we can simply average surrounding points (in a not
    // non-uniform grid aware manner):
    var sum = 0.0;
    var val;
    var cnt = 0;
    if (i > 0 && (val = data[j][i - 1]) !== undefined) {
      cnt++;
      sum += val;
    }
    if (i < ni - 1 && (val = data[j][i + 1]) !== undefined) {
      cnt++;
      sum += val;
    }
    if (j > 0 && (val = data[j - 1][i]) !== undefined) {
      cnt++;
      sum += val;
    }
    if (j < nj - 1 && (val = data[j + 1][i]) !== undefined) {
      cnt++;
      sum += val;
    }
    return sum / Math.max(1, cnt);
  }

  // This loop iterates over all cells. Any cells that are null will be noted and those
  // are the only points we will loop over and update via laplace's equation. Points with
  // any neighbors will receive the average. If there are no neighboring points, then they
  // will be set to zero. Also as we go, track the maximum magnitude so that we can scale
  // our tolerance accordingly.
  var dmax = 0.0;
  for (i = 0; i < ni; i++) {
    for (j = 0; j < nj; j++) {
      if (data[j][i] === undefined) {
        ip.push(i);
        jp.push(j);
        data[j][i] = avgSurrounding(i, j);
        // neighborCnts.push(result.neighbors);
      }
      dmax = Math.max(dmax, Math.abs(data[j][i]));
    }
  }
  if (!ip.length) return data;

  // The tolerance doesn't need to be excessive. It's just for display positioning
  var dxp, dxm, dap, dam, dbp, dbm, c, d, diff, reldiff, overrelaxation;
  var tol = 1e-5;
  var resid = 0;
  var itermax = 100;
  var iter = 0;
  var n = ip.length;
  do {
    resid = 0;
    // Normally we'd loop in two dimensions, but not all points are blank and need
    // an update, so we instead loop only over the points that were tabulated above
    for (k = 0; k < n; k++) {
      i = ip[k];
      j = jp[k];
      // neighborCnt = neighborCnts[k];

      // Track a counter for how many contributions there are. We'll use this counter
      // to average at the end, which reduces to laplace's equation with neumann boundary
      // conditions on the first derivative (second derivative is zero so that we get
      // a nice linear extrapolation at the boundaries).
      var boundaryCnt = 0;
      var newVal = 0;
      var d0, d1, x0, x1, i0, j0;
      if (i === 0) {
        // If this lies along the i = 0 boundary, extrapolate from the two points
        // to the right of this point. Note that the finite differences take into
        // account non-uniform grid spacing:
        i0 = Math.min(ni - 1, 2);
        x0 = a[i0];
        x1 = a[1];
        d0 = data[j][i0];
        d1 = data[j][1];
        newVal += d1 + (d1 - d0) * (a[0] - x1) / (x1 - x0);
        boundaryCnt++;
      } else if (i === ni - 1) {
        // If along the high i boundary, extrapolate from the two points to the
        // left of this point
        i0 = Math.max(0, ni - 3);
        x0 = a[i0];
        x1 = a[ni - 2];
        d0 = data[j][i0];
        d1 = data[j][ni - 2];
        newVal += d1 + (d1 - d0) * (a[ni - 1] - x1) / (x1 - x0);
        boundaryCnt++;
      }
      if ((i === 0 || i === ni - 1) && j > 0 && j < nj - 1) {
        // If along the min(i) or max(i) boundaries, also smooth vertically as long
        // as we're not in a corner. Note that the finite differences used here
        // are also aware of nonuniform grid spacing:
        dxp = b[j + 1] - b[j];
        dxm = b[j] - b[j - 1];
        newVal += (dxm * data[j + 1][i] + dxp * data[j - 1][i]) / (dxm + dxp);
        boundaryCnt++;
      }
      if (j === 0) {
        // If along the j = 0 boundary, extrpolate this point from the two points
        // above it
        j0 = Math.min(nj - 1, 2);
        x0 = b[j0];
        x1 = b[1];
        d0 = data[j0][i];
        d1 = data[1][i];
        newVal += d1 + (d1 - d0) * (b[0] - x1) / (x1 - x0);
        boundaryCnt++;
      } else if (j === nj - 1) {
        // Same for the max j boundary from the cells below it:
        j0 = Math.max(0, nj - 3);
        x0 = b[j0];
        x1 = b[nj - 2];
        d0 = data[j0][i];
        d1 = data[nj - 2][i];
        newVal += d1 + (d1 - d0) * (b[nj - 1] - x1) / (x1 - x0);
        boundaryCnt++;
      }
      if ((j === 0 || j === nj - 1) && i > 0 && i < ni - 1) {
        // Now average points to the left/right as long as not in a corner:
        dxp = a[i + 1] - a[i];
        dxm = a[i] - a[i - 1];
        newVal += (dxm * data[j][i + 1] + dxp * data[j][i - 1]) / (dxm + dxp);
        boundaryCnt++;
      }
      if (!boundaryCnt) {
        // If none of the above conditions were triggered, then this is an interior
        // point and we can just do a laplace equation update. As above, these differences
        // are aware of nonuniform grid spacing:
        dap = a[i + 1] - a[i];
        dam = a[i] - a[i - 1];
        dbp = b[j + 1] - b[j];
        dbm = b[j] - b[j - 1];

        // These are just some useful constants for the iteration, which is perfectly
        // straightforward but a little long to derive from f_xx + f_yy = 0.
        c = dap * dam * (dap + dam);
        d = dbp * dbm * (dbp + dbm);
        newVal = (c * (dbm * data[j + 1][i] + dbp * data[j - 1][i]) + d * (dam * data[j][i + 1] + dap * data[j][i - 1])) / (d * (dam + dap) + c * (dbm + dbp));
      } else {
        // If we did have contributions from the boundary conditions, then average
        // the result from the various contributions:
        newVal /= boundaryCnt;
      }

      // Jacobi updates are ridiculously slow to converge, so this approach uses a
      // Gauss-seidel iteration which is dramatically faster.
      diff = newVal - data[j][i];
      reldiff = diff / dmax;
      resid += reldiff * reldiff;

      // Gauss-Seidel-ish iteration, omega chosen based on heuristics and some
      // quick tests.
      //
      // NB: Don't overrelax the boundarie. Otherwise set an overrelaxation factor
      // which is a little low but safely optimal-ish:
      overrelaxation = boundaryCnt ? 0 : 0.85;

      // If there are four non-null neighbors, then we want a simple average without
      // overrelaxation. If all the surrounding points are null, then we want the full
      // overrelaxation
      //
      // Based on experiments, this actually seems to slow down convergence just a bit.
      // I'll leave it here for reference in case this needs to be revisited, but
      // it seems to work just fine without this.
      // if (overrelaxation) overrelaxation *= (4 - neighborCnt) / 4;

      data[j][i] += diff * (1 + overrelaxation);
    }
    resid = Math.sqrt(resid);
  } while (iter++ < itermax && resid > tol);
  Lib.log('Smoother converged to', resid, 'after', iter, 'iterations');
  return data;
};

/***/ }),

/***/ 10820:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isArray1D = (__webpack_require__(34809).isArray1D);
module.exports = function handleXYDefaults(traceIn, traceOut, coerce) {
  var x = coerce('x');
  var hasX = x && x.length;
  var y = coerce('y');
  var hasY = y && y.length;
  if (!hasX && !hasY) return false;
  traceOut._cheater = !x;
  if ((!hasX || isArray1D(x)) && (!hasY || isArray1D(y))) {
    var len = hasX ? x.length : Infinity;
    if (hasY) len = Math.min(len, y.length);
    if (traceOut.a && traceOut.a.length) len = Math.min(len, traceOut.a.length);
    if (traceOut.b && traceOut.b.length) len = Math.min(len, traceOut.b.length);
    traceOut._length = len;
  } else traceOut._length = null;
  return true;
};

/***/ }),

/***/ 92802:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var hovertemplateAttrs = (__webpack_require__(3208)/* .hovertemplateAttrs */ .rb);
var scatterGeoAttrs = __webpack_require__(6893);
var colorScaleAttrs = __webpack_require__(87163);
var baseAttrs = __webpack_require__(9829);
var defaultLine = (__webpack_require__(10229).defaultLine);
var extendFlat = (__webpack_require__(93049).extendFlat);
var scatterGeoMarkerLineAttrs = scatterGeoAttrs.marker.line;
module.exports = extendFlat({
  locations: {
    valType: 'data_array',
    editType: 'calc'
  },
  locationmode: scatterGeoAttrs.locationmode,
  z: {
    valType: 'data_array',
    editType: 'calc'
  },
  geojson: extendFlat({}, scatterGeoAttrs.geojson, {}),
  featureidkey: scatterGeoAttrs.featureidkey,
  text: extendFlat({}, scatterGeoAttrs.text, {}),
  hovertext: extendFlat({}, scatterGeoAttrs.hovertext, {}),
  marker: {
    line: {
      color: extendFlat({}, scatterGeoMarkerLineAttrs.color, {
        dflt: defaultLine
      }),
      width: extendFlat({}, scatterGeoMarkerLineAttrs.width, {
        dflt: 1
      }),
      editType: 'calc'
    },
    opacity: {
      valType: 'number',
      arrayOk: true,
      min: 0,
      max: 1,
      dflt: 1,
      editType: 'style'
    },
    editType: 'calc'
  },
  selected: {
    marker: {
      opacity: scatterGeoAttrs.selected.marker.opacity,
      editType: 'plot'
    },
    editType: 'plot'
  },
  unselected: {
    marker: {
      opacity: scatterGeoAttrs.unselected.marker.opacity,
      editType: 'plot'
    },
    editType: 'plot'
  },
  hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
    editType: 'calc',
    flags: ['location', 'z', 'text', 'name']
  }),
  hovertemplate: hovertemplateAttrs(),
  showlegend: extendFlat({}, baseAttrs.showlegend, {
    dflt: false
  })
}, colorScaleAttrs('', {
  cLetter: 'z',
  editTypeOverride: 'calc'
}));

/***/ }),

/***/ 12702:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isNumeric = __webpack_require__(10721);
var BADNUM = (__webpack_require__(63821).BADNUM);
var colorscaleCalc = __webpack_require__(28379);
var arraysToCalcdata = __webpack_require__(99203);
var calcSelection = __webpack_require__(48861);
function isNonBlankString(v) {
  return v && typeof v === 'string';
}
module.exports = function calc(gd, trace) {
  var len = trace._length;
  var calcTrace = new Array(len);
  var isValidLoc;
  if (trace.geojson) {
    isValidLoc = function (v) {
      return isNonBlankString(v) || isNumeric(v);
    };
  } else {
    isValidLoc = isNonBlankString;
  }
  for (var i = 0; i < len; i++) {
    var calcPt = calcTrace[i] = {};
    var loc = trace.locations[i];
    var z = trace.z[i];
    if (isValidLoc(loc) && isNumeric(z)) {
      calcPt.loc = loc;
      calcPt.z = z;
    } else {
      calcPt.loc = null;
      calcPt.z = BADNUM;
    }
    calcPt.index = i;
  }
  arraysToCalcdata(calcTrace, trace);
  colorscaleCalc(gd, trace, {
    vals: trace.z,
    containerStr: '',
    cLetter: 'z'
  });
  calcSelection(calcTrace, trace);
  return calcTrace;
};

/***/ }),

/***/ 51893:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var colorscaleDefaults = __webpack_require__(39356);
var attributes = __webpack_require__(92802);
module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
  function coerce(attr, dflt) {
    return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
  }
  var locations = coerce('locations');
  var z = coerce('z');
  if (!(locations && locations.length && Lib.isArrayOrTypedArray(z) && z.length)) {
    traceOut.visible = false;
    return;
  }
  traceOut._length = Math.min(locations.length, z.length);
  var geojson = coerce('geojson');
  var locationmodeDflt;
  if (typeof geojson === 'string' && geojson !== '' || Lib.isPlainObject(geojson)) {
    locationmodeDflt = 'geojson-id';
  }
  var locationMode = coerce('locationmode', locationmodeDflt);
  if (locationMode === 'geojson-id') {
    coerce('featureidkey');
  }
  coerce('text');
  coerce('hovertext');
  coerce('hovertemplate');
  var mlw = coerce('marker.line.width');
  if (mlw) coerce('marker.line.color');
  coerce('marker.opacity');
  colorscaleDefaults(traceIn, traceOut, layout, coerce, {
    prefix: '',
    cLetter: 'z'
  });
  Lib.coerceSelectionMarkerOpacity(traceOut, coerce);
};

/***/ }),

/***/ 38414:
/***/ (function(module) {

"use strict";


module.exports = function eventData(out, pt, trace, cd, pointNumber) {
  out.location = pt.location;
  out.z = pt.z;

  // include feature properties from input geojson
  var cdi = cd[pointNumber];
  if (cdi.fIn && cdi.fIn.properties) {
    out.properties = cdi.fIn.properties;
  }
  out.ct = cdi.ct;
  return out;
};

/***/ }),

/***/ 94125:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Axes = __webpack_require__(29714);
var attributes = __webpack_require__(92802);
var fillText = (__webpack_require__(34809).fillText);
module.exports = function hoverPoints(pointData, xval, yval) {
  var cd = pointData.cd;
  var trace = cd[0].trace;
  var geo = pointData.subplot;
  var pt, i, j, isInside;
  var xy = [xval, yval];
  var altXy = [xval + 360, yval];
  for (i = 0; i < cd.length; i++) {
    pt = cd[i];
    isInside = false;
    if (pt._polygons) {
      for (j = 0; j < pt._polygons.length; j++) {
        if (pt._polygons[j].contains(xy)) {
          isInside = !isInside;
        }
        // for polygons that cross antimeridian as xval is in [-180, 180]
        if (pt._polygons[j].contains(altXy)) {
          isInside = !isInside;
        }
      }
      if (isInside) break;
    }
  }
  if (!isInside || !pt) return;
  pointData.x0 = pointData.x1 = pointData.xa.c2p(pt.ct);
  pointData.y0 = pointData.y1 = pointData.ya.c2p(pt.ct);
  pointData.index = pt.index;
  pointData.location = pt.loc;
  pointData.z = pt.z;
  pointData.zLabel = Axes.tickText(geo.mockAxis, geo.mockAxis.c2l(pt.z), 'hover').text;
  pointData.hovertemplate = pt.hovertemplate;
  makeHoverInfo(pointData, trace, pt);
  return [pointData];
};
function makeHoverInfo(pointData, trace, pt) {
  if (trace.hovertemplate) return;
  var hoverinfo = pt.hi || trace.hoverinfo;
  var loc = String(pt.loc);
  var parts = hoverinfo === 'all' ? attributes.hoverinfo.flags : hoverinfo.split('+');
  var hasName = parts.indexOf('name') !== -1;
  var hasLocation = parts.indexOf('location') !== -1;
  var hasZ = parts.indexOf('z') !== -1;
  var hasText = parts.indexOf('text') !== -1;
  var hasIdAsNameLabel = !hasName && hasLocation;
  var text = [];
  if (hasIdAsNameLabel) {
    pointData.nameOverride = loc;
  } else {
    if (hasName) pointData.nameOverride = trace.name;
    if (hasLocation) text.push(loc);
  }
  if (hasZ) {
    text.push(pointData.zLabel);
  }
  if (hasText) {
    fillText(pt, trace, text);
  }
  pointData.extraText = text.join('<br>');
}

/***/ }),

/***/ 58075:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = {
  attributes: __webpack_require__(92802),
  supplyDefaults: __webpack_require__(51893),
  colorbar: __webpack_require__(12431),
  calc: __webpack_require__(12702),
  calcGeoJSON: (__webpack_require__(4700).calcGeoJSON),
  plot: (__webpack_require__(4700).plot),
  style: (__webpack_require__(59342).style),
  styleOnSelect: (__webpack_require__(59342).styleOnSelect),
  hoverPoints: __webpack_require__(94125),
  eventData: __webpack_require__(38414),
  selectPoints: __webpack_require__(43727),
  moduleType: 'trace',
  name: 'choropleth',
  basePlotModule: __webpack_require__(47544),
  categories: ['geo', 'noOpacity', 'showLegend'],
  meta: {}
};

/***/ }),

/***/ 4700:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var Lib = __webpack_require__(34809);
var geoUtils = __webpack_require__(3994);
var getTopojsonFeatures = (__webpack_require__(11577).getTopojsonFeatures);
var findExtremes = (__webpack_require__(32919).findExtremes);
var style = (__webpack_require__(59342).style);
function plot(gd, geo, calcData) {
  var choroplethLayer = geo.layers.backplot.select('.choroplethlayer');
  Lib.makeTraceGroups(choroplethLayer, calcData, 'trace choropleth').each(function (calcTrace) {
    var sel = d3.select(this);
    var paths = sel.selectAll('path.choroplethlocation').data(Lib.identity);
    paths.enter().append('path').classed('choroplethlocation', true);
    paths.exit().remove();

    // call style here within topojson request callback
    style(gd, calcTrace);
  });
}
function calcGeoJSON(calcTrace, fullLayout) {
  var trace = calcTrace[0].trace;
  var geoLayout = fullLayout[trace.geo];
  var geo = geoLayout._subplot;
  var locationmode = trace.locationmode;
  var len = trace._length;
  var features = locationmode === 'geojson-id' ? geoUtils.extractTraceFeature(calcTrace) : getTopojsonFeatures(trace, geo.topojson);
  var lonArray = [];
  var latArray = [];
  for (var i = 0; i < len; i++) {
    var calcPt = calcTrace[i];
    var feature = locationmode === 'geojson-id' ? calcPt.fOut : geoUtils.locationToFeature(locationmode, calcPt.loc, features);
    if (feature) {
      calcPt.geojson = feature;
      calcPt.ct = feature.properties.ct;
      calcPt._polygons = geoUtils.feature2polygons(feature);
      var bboxFeature = geoUtils.computeBbox(feature);
      lonArray.push(bboxFeature[0], bboxFeature[2]);
      latArray.push(bboxFeature[1], bboxFeature[3]);
    } else {
      calcPt.geojson = null;
    }
  }
  if (geoLayout.fitbounds === 'geojson' && locationmode === 'geojson-id') {
    var bboxGeojson = geoUtils.computeBbox(geoUtils.getTraceGeojson(trace));
    lonArray = [bboxGeojson[0], bboxGeojson[2]];
    latArray = [bboxGeojson[1], bboxGeojson[3]];
  }
  var opts = {
    padded: true
  };
  trace._extremes.lon = findExtremes(geoLayout.lonaxis._ax, lonArray, opts);
  trace._extremes.lat = findExtremes(geoLayout.lataxis._ax, latArray, opts);
}
module.exports = {
  calcGeoJSON: calcGeoJSON,
  plot: plot
};

/***/ }),

/***/ 43727:
/***/ (function(module) {

"use strict";


module.exports = function selectPoints(searchInfo, selectionTester) {
  var cd = searchInfo.cd;
  var xa = searchInfo.xaxis;
  var ya = searchInfo.yaxis;
  var selection = [];
  var i, di, ct, x, y;
  if (selectionTester === false) {
    for (i = 0; i < cd.length; i++) {
      cd[i].selected = 0;
    }
  } else {
    for (i = 0; i < cd.length; i++) {
      di = cd[i];
      ct = di.ct;
      if (!ct) continue;
      x = xa.c2p(ct);
      y = ya.c2p(ct);
      if (selectionTester.contains([x, y], null, i, searchInfo)) {
        selection.push({
          pointNumber: i,
          lon: ct[0],
          lat: ct[1]
        });
        di.selected = 1;
      } else {
        di.selected = 0;
      }
    }
  }
  return selection;
};

/***/ }),

/***/ 59342:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var Color = __webpack_require__(78766);
var Drawing = __webpack_require__(62203);
var Colorscale = __webpack_require__(88856);
function style(gd, calcTrace) {
  if (calcTrace) styleTrace(gd, calcTrace);
}
function styleTrace(gd, calcTrace) {
  var trace = calcTrace[0].trace;
  var s = calcTrace[0].node3;
  var locs = s.selectAll('.choroplethlocation');
  var marker = trace.marker || {};
  var markerLine = marker.line || {};
  var sclFunc = Colorscale.makeColorScaleFuncFromTrace(trace);
  locs.each(function (d) {
    d3.select(this).attr('fill', sclFunc(d.z)).call(Color.stroke, d.mlc || markerLine.color).call(Drawing.dashLine, '', d.mlw || markerLine.width || 0).style('opacity', marker.opacity);
  });
  Drawing.selectedPointStyle(locs, trace);
}
function styleOnSelect(gd, calcTrace) {
  var s = calcTrace[0].node3;
  var trace = calcTrace[0].trace;
  if (trace.selectedpoints) {
    Drawing.selectedPointStyle(s.selectAll('.choroplethlocation'), trace);
  } else {
    styleTrace(gd, calcTrace);
  }
}
module.exports = {
  style: style,
  styleOnSelect: styleOnSelect
};

/***/ }),

/***/ 34770:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var choroplethAttrs = __webpack_require__(92802);
var colorScaleAttrs = __webpack_require__(87163);
var hovertemplateAttrs = (__webpack_require__(3208)/* .hovertemplateAttrs */ .rb);
var baseAttrs = __webpack_require__(9829);
var extendFlat = (__webpack_require__(93049).extendFlat);
module.exports = extendFlat({
  locations: {
    valType: 'data_array',
    editType: 'calc'
  },
  // TODO
  // Maybe start with only one value (that we could name e.g. 'geojson-id'),
  // but eventually:
  // - we could also support for our own dist/topojson/*
  //   .. and locationmode: choroplethAttrs.locationmode,

  z: {
    valType: 'data_array',
    editType: 'calc'
  },
  // TODO maybe we could also set a "key" to dig out values out of the
  // GeoJSON feature `properties` fields?

  geojson: {
    valType: 'any',
    editType: 'calc'
  },
  featureidkey: extendFlat({}, choroplethAttrs.featureidkey, {}),
  // TODO agree on name / behaviour
  //
  // 'below' is used currently for layout.map.layers,
  // even though it's not very plotly-esque.
  //
  // Note also, that the map-gl style don't all have the same layers,
  // see https://codepen.io/etpinard/pen/ydVMwM for full list
  below: {
    valType: 'string',
    editType: 'plot'
  },
  text: choroplethAttrs.text,
  hovertext: choroplethAttrs.hovertext,
  marker: {
    line: {
      color: extendFlat({}, choroplethAttrs.marker.line.color, {
        editType: 'plot'
      }),
      width: extendFlat({}, choroplethAttrs.marker.line.width, {
        editType: 'plot'
      }),
      editType: 'calc'
    },
    // TODO maybe having a dflt less than 1, together with `below:''` would be better?
    opacity: extendFlat({}, choroplethAttrs.marker.opacity, {
      editType: 'plot'
    }),
    editType: 'calc'
  },
  selected: {
    marker: {
      opacity: extendFlat({}, choroplethAttrs.selected.marker.opacity, {
        editType: 'plot'
      }),
      editType: 'plot'
    },
    editType: 'plot'
  },
  unselected: {
    marker: {
      opacity: extendFlat({}, choroplethAttrs.unselected.marker.opacity, {
        editType: 'plot'
      }),
      editType: 'plot'
    },
    editType: 'plot'
  },
  hoverinfo: choroplethAttrs.hoverinfo,
  hovertemplate: hovertemplateAttrs({}, {
    keys: ['properties']
  }),
  showlegend: extendFlat({}, baseAttrs.showlegend, {
    dflt: false
  })
}, colorScaleAttrs('', {
  cLetter: 'z',
  editTypeOverride: 'calc'
}));

/***/ }),

/***/ 40980:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isNumeric = __webpack_require__(10721);
var Lib = __webpack_require__(34809);
var Colorscale = __webpack_require__(88856);
var Drawing = __webpack_require__(62203);
var makeBlank = (__webpack_require__(39532).makeBlank);
var geoUtils = __webpack_require__(3994);

/* N.B.
 *
 * We fetch the GeoJSON files "ourselves" (during
 * map.prototype.fetchMapData) where they are stored in a global object
 * named `PlotlyGeoAssets` (same as for topojson files in `geo` subplots).
 *
 * Map does allow using URLs as geojson sources, but does NOT allow filtering
 * features by feature `id` that are not numbers (more info in:
 * https://github.com/mapbox/mapbox-gl-js/issues/8088).
 */

function convert(calcTrace) {
  var trace = calcTrace[0].trace;
  var isVisible = trace.visible === true && trace._length !== 0;
  var fill = {
    layout: {
      visibility: 'none'
    },
    paint: {}
  };
  var line = {
    layout: {
      visibility: 'none'
    },
    paint: {}
  };
  var opts = trace._opts = {
    fill: fill,
    line: line,
    geojson: makeBlank()
  };
  if (!isVisible) return opts;
  var features = geoUtils.extractTraceFeature(calcTrace);
  if (!features) return opts;
  var sclFunc = Colorscale.makeColorScaleFuncFromTrace(trace);
  var marker = trace.marker;
  var markerLine = marker.line || {};
  var opacityFn;
  if (Lib.isArrayOrTypedArray(marker.opacity)) {
    opacityFn = function (d) {
      var mo = d.mo;
      return isNumeric(mo) ? +Lib.constrain(mo, 0, 1) : 0;
    };
  }
  var lineColorFn;
  if (Lib.isArrayOrTypedArray(markerLine.color)) {
    lineColorFn = function (d) {
      return d.mlc;
    };
  }
  var lineWidthFn;
  if (Lib.isArrayOrTypedArray(markerLine.width)) {
    lineWidthFn = function (d) {
      return d.mlw;
    };
  }
  for (var i = 0; i < calcTrace.length; i++) {
    var cdi = calcTrace[i];
    var fOut = cdi.fOut;
    if (fOut) {
      var props = fOut.properties;
      props.fc = sclFunc(cdi.z);
      if (opacityFn) props.mo = opacityFn(cdi);
      if (lineColorFn) props.mlc = lineColorFn(cdi);
      if (lineWidthFn) props.mlw = lineWidthFn(cdi);
      cdi.ct = props.ct;
      cdi._polygons = geoUtils.feature2polygons(fOut);
    }
  }
  var opacitySetting = opacityFn ? {
    type: 'identity',
    property: 'mo'
  } : marker.opacity;
  Lib.extendFlat(fill.paint, {
    'fill-color': {
      type: 'identity',
      property: 'fc'
    },
    'fill-opacity': opacitySetting
  });
  Lib.extendFlat(line.paint, {
    'line-color': lineColorFn ? {
      type: 'identity',
      property: 'mlc'
    } : markerLine.color,
    'line-width': lineWidthFn ? {
      type: 'identity',
      property: 'mlw'
    } : markerLine.width,
    'line-opacity': opacitySetting
  });
  fill.layout.visibility = 'visible';
  line.layout.visibility = 'visible';
  opts.geojson = {
    type: 'FeatureCollection',
    features: features
  };
  convertOnSelect(calcTrace);
  return opts;
}
function convertOnSelect(calcTrace) {
  var trace = calcTrace[0].trace;
  var opts = trace._opts;
  var opacitySetting;
  if (trace.selectedpoints) {
    var fns = Drawing.makeSelectedPointStyleFns(trace);
    for (var i = 0; i < calcTrace.length; i++) {
      var cdi = calcTrace[i];
      if (cdi.fOut) {
        cdi.fOut.properties.mo2 = fns.selectedOpacityFn(cdi);
      }
    }
    opacitySetting = {
      type: 'identity',
      property: 'mo2'
    };
  } else {
    opacitySetting = Lib.isArrayOrTypedArray(trace.marker.opacity) ? {
      type: 'identity',
      property: 'mo'
    } : trace.marker.opacity;
  }
  Lib.extendFlat(opts.fill.paint, {
    'fill-opacity': opacitySetting
  });
  Lib.extendFlat(opts.line.paint, {
    'line-opacity': opacitySetting
  });
  return opts;
}
module.exports = {
  convert: convert,
  convertOnSelect: convertOnSelect
};

/***/ }),

/***/ 94149:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var colorscaleDefaults = __webpack_require__(39356);
var attributes = __webpack_require__(34770);
module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
  function coerce(attr, dflt) {
    return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
  }
  var locations = coerce('locations');
  var z = coerce('z');
  var geojson = coerce('geojson');
  if (!Lib.isArrayOrTypedArray(locations) || !locations.length || !Lib.isArrayOrTypedArray(z) || !z.length || !(typeof geojson === 'string' && geojson !== '' || Lib.isPlainObject(geojson))) {
    traceOut.visible = false;
    return;
  }
  coerce('featureidkey');
  traceOut._length = Math.min(locations.length, z.length);
  coerce('below');
  coerce('text');
  coerce('hovertext');
  coerce('hovertemplate');
  var mlw = coerce('marker.line.width');
  if (mlw) coerce('marker.line.color');
  coerce('marker.opacity');
  colorscaleDefaults(traceIn, traceOut, layout, coerce, {
    prefix: '',
    cLetter: 'z'
  });
  Lib.coerceSelectionMarkerOpacity(traceOut, coerce);
};

/***/ }),

/***/ 9419:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = {
  attributes: __webpack_require__(34770),
  supplyDefaults: __webpack_require__(94149),
  colorbar: __webpack_require__(12431),
  calc: __webpack_require__(12702),
  plot: __webpack_require__(30316),
  hoverPoints: __webpack_require__(94125),
  eventData: __webpack_require__(38414),
  selectPoints: __webpack_require__(43727),
  styleOnSelect: function (_, cd) {
    if (cd) {
      var trace = cd[0].trace;
      trace._glTrace.updateOnSelect(cd);
    }
  },
  getBelow: function (trace, subplot) {
    var mapLayers = subplot.getMapLayers();

    // find layer just above top-most "water" layer
    // that is not a plotly layer
    for (var i = mapLayers.length - 2; i >= 0; i--) {
      var layerId = mapLayers[i].id;
      if (typeof layerId === 'string' && layerId.indexOf('water') === 0) {
        for (var j = i + 1; j < mapLayers.length; j++) {
          layerId = mapLayers[j].id;
          if (typeof layerId === 'string' && layerId.indexOf('plotly-') === -1) {
            return layerId;
          }
        }
      }
    }
  },
  moduleType: 'trace',
  name: 'choroplethmap',
  basePlotModule: __webpack_require__(34091),
  categories: ['map', 'gl', 'noOpacity', 'showLegend'],
  meta: {
    hr_name: 'choropleth_map'
  }
};

/***/ }),

/***/ 30316:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var convert = (__webpack_require__(40980).convert);
var convertOnSelect = (__webpack_require__(40980).convertOnSelect);
var LAYER_PREFIX = (__webpack_require__(8814).traceLayerPrefix);
function ChoroplethMap(subplot, uid) {
  this.type = 'choroplethmap';
  this.subplot = subplot;
  this.uid = uid;

  // N.B. fill and line layers share same source
  this.sourceId = 'source-' + uid;
  this.layerList = [['fill', LAYER_PREFIX + uid + '-fill'], ['line', LAYER_PREFIX + uid + '-line']];

  // previous 'below' value,
  // need this to update it properly
  this.below = null;
}
var proto = ChoroplethMap.prototype;
proto.update = function (calcTrace) {
  this._update(convert(calcTrace));

  // link ref for quick update during selections
  calcTrace[0].trace._glTrace = this;
};
proto.updateOnSelect = function (calcTrace) {
  this._update(convertOnSelect(calcTrace));
};
proto._update = function (optsAll) {
  var subplot = this.subplot;
  var layerList = this.layerList;
  var below = subplot.belowLookup['trace-' + this.uid];
  subplot.map.getSource(this.sourceId).setData(optsAll.geojson);
  if (below !== this.below) {
    this._removeLayers();
    this._addLayers(optsAll, below);
    this.below = below;
  }
  for (var i = 0; i < layerList.length; i++) {
    var item = layerList[i];
    var k = item[0];
    var id = item[1];
    var opts = optsAll[k];
    subplot.setOptions(id, 'setLayoutProperty', opts.layout);
    if (opts.layout.visibility === 'visible') {
      subplot.setOptions(id, 'setPaintProperty', opts.paint);
    }
  }
};
proto._addLayers = function (optsAll, below) {
  var subplot = this.subplot;
  var layerList = this.layerList;
  var sourceId = this.sourceId;
  for (var i = 0; i < layerList.length; i++) {
    var item = layerList[i];
    var k = item[0];
    var opts = optsAll[k];
    subplot.addLayer({
      type: k,
      id: item[1],
      source: sourceId,
      layout: opts.layout,
      paint: opts.paint
    }, below);
  }
};
proto._removeLayers = function () {
  var map = this.subplot.map;
  var layerList = this.layerList;
  for (var i = layerList.length - 1; i >= 0; i--) {
    map.removeLayer(layerList[i][1]);
  }
};
proto.dispose = function () {
  var map = this.subplot.map;
  this._removeLayers();
  map.removeSource(this.sourceId);
};
module.exports = function createChoroplethMap(subplot, calcTrace) {
  var trace = calcTrace[0].trace;
  var choroplethMap = new ChoroplethMap(subplot, trace.uid);
  var sourceId = choroplethMap.sourceId;
  var optsAll = convert(calcTrace);
  var below = choroplethMap.below = subplot.belowLookup['trace-' + trace.uid];
  subplot.map.addSource(sourceId, {
    type: 'geojson',
    data: optsAll.geojson
  });
  choroplethMap._addLayers(optsAll, below);

  // link ref for quick update during selections
  calcTrace[0].trace._glTrace = choroplethMap;
  return choroplethMap;
};

/***/ }),

/***/ 86227:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var choroplethAttrs = __webpack_require__(92802);
var colorScaleAttrs = __webpack_require__(87163);
var hovertemplateAttrs = (__webpack_require__(3208)/* .hovertemplateAttrs */ .rb);
var baseAttrs = __webpack_require__(9829);
var extendFlat = (__webpack_require__(93049).extendFlat);
module.exports = extendFlat({
  locations: {
    valType: 'data_array',
    editType: 'calc'
  },
  // TODO
  // Maybe start with only one value (that we could name e.g. 'geojson-id'),
  // but eventually:
  // - we could also support for our own dist/topojson/*
  //   .. and locationmode: choroplethAttrs.locationmode,

  z: {
    valType: 'data_array',
    editType: 'calc'
  },
  // TODO maybe we could also set a "key" to dig out values out of the
  // GeoJSON feature `properties` fields?

  geojson: {
    valType: 'any',
    editType: 'calc'
  },
  featureidkey: extendFlat({}, choroplethAttrs.featureidkey, {}),
  // TODO agree on name / behaviour
  //
  // 'below' is used currently for layout.mapbox.layers,
  // even though it's not very plotly-esque.
  //
  // Note also, that the mapbox-gl style don't all have the same layers,
  // see https://codepen.io/etpinard/pen/ydVMwM for full list
  below: {
    valType: 'string',
    editType: 'plot'
  },
  text: choroplethAttrs.text,
  hovertext: choroplethAttrs.hovertext,
  marker: {
    line: {
      color: extendFlat({}, choroplethAttrs.marker.line.color, {
        editType: 'plot'
      }),
      width: extendFlat({}, choroplethAttrs.marker.line.width, {
        editType: 'plot'
      }),
      editType: 'calc'
    },
    // TODO maybe having a dflt less than 1, together with `below:''` would be better?
    opacity: extendFlat({}, choroplethAttrs.marker.opacity, {
      editType: 'plot'
    }),
    editType: 'calc'
  },
  selected: {
    marker: {
      opacity: extendFlat({}, choroplethAttrs.selected.marker.opacity, {
        editType: 'plot'
      }),
      editType: 'plot'
    },
    editType: 'plot'
  },
  unselected: {
    marker: {
      opacity: extendFlat({}, choroplethAttrs.unselected.marker.opacity, {
        editType: 'plot'
      }),
      editType: 'plot'
    },
    editType: 'plot'
  },
  hoverinfo: choroplethAttrs.hoverinfo,
  hovertemplate: hovertemplateAttrs({}, {
    keys: ['properties']
  }),
  showlegend: extendFlat({}, baseAttrs.showlegend, {
    dflt: false
  })
}, colorScaleAttrs('', {
  cLetter: 'z',
  editTypeOverride: 'calc'
}));

/***/ }),

/***/ 51335:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isNumeric = __webpack_require__(10721);
var Lib = __webpack_require__(34809);
var Colorscale = __webpack_require__(88856);
var Drawing = __webpack_require__(62203);
var makeBlank = (__webpack_require__(39532).makeBlank);
var geoUtils = __webpack_require__(3994);

/* N.B.
 *
 * We fetch the GeoJSON files "ourselves" (during
 * mapbox.prototype.fetchMapData) where they are stored in a global object
 * named `PlotlyGeoAssets` (same as for topojson files in `geo` subplots).
 *
 * Mapbox does allow using URLs as geojson sources, but does NOT allow filtering
 * features by feature `id` that are not numbers (more info in:
 * https://github.com/mapbox/mapbox-gl-js/issues/8088).
 */

function convert(calcTrace) {
  var trace = calcTrace[0].trace;
  var isVisible = trace.visible === true && trace._length !== 0;
  var fill = {
    layout: {
      visibility: 'none'
    },
    paint: {}
  };
  var line = {
    layout: {
      visibility: 'none'
    },
    paint: {}
  };
  var opts = trace._opts = {
    fill: fill,
    line: line,
    geojson: makeBlank()
  };
  if (!isVisible) return opts;
  var features = geoUtils.extractTraceFeature(calcTrace);
  if (!features) return opts;
  var sclFunc = Colorscale.makeColorScaleFuncFromTrace(trace);
  var marker = trace.marker;
  var markerLine = marker.line || {};
  var opacityFn;
  if (Lib.isArrayOrTypedArray(marker.opacity)) {
    opacityFn = function (d) {
      var mo = d.mo;
      return isNumeric(mo) ? +Lib.constrain(mo, 0, 1) : 0;
    };
  }
  var lineColorFn;
  if (Lib.isArrayOrTypedArray(markerLine.color)) {
    lineColorFn = function (d) {
      return d.mlc;
    };
  }
  var lineWidthFn;
  if (Lib.isArrayOrTypedArray(markerLine.width)) {
    lineWidthFn = function (d) {
      return d.mlw;
    };
  }
  for (var i = 0; i < calcTrace.length; i++) {
    var cdi = calcTrace[i];
    var fOut = cdi.fOut;
    if (fOut) {
      var props = fOut.properties;
      props.fc = sclFunc(cdi.z);
      if (opacityFn) props.mo = opacityFn(cdi);
      if (lineColorFn) props.mlc = lineColorFn(cdi);
      if (lineWidthFn) props.mlw = lineWidthFn(cdi);
      cdi.ct = props.ct;
      cdi._polygons = geoUtils.feature2polygons(fOut);
    }
  }
  var opacitySetting = opacityFn ? {
    type: 'identity',
    property: 'mo'
  } : marker.opacity;
  Lib.extendFlat(fill.paint, {
    'fill-color': {
      type: 'identity',
      property: 'fc'
    },
    'fill-opacity': opacitySetting
  });
  Lib.extendFlat(line.paint, {
    'line-color': lineColorFn ? {
      type: 'identity',
      property: 'mlc'
    } : markerLine.color,
    'line-width': lineWidthFn ? {
      type: 'identity',
      property: 'mlw'
    } : markerLine.width,
    'line-opacity': opacitySetting
  });
  fill.layout.visibility = 'visible';
  line.layout.visibility = 'visible';
  opts.geojson = {
    type: 'FeatureCollection',
    features: features
  };
  convertOnSelect(calcTrace);
  return opts;
}
function convertOnSelect(calcTrace) {
  var trace = calcTrace[0].trace;
  var opts = trace._opts;
  var opacitySetting;
  if (trace.selectedpoints) {
    var fns = Drawing.makeSelectedPointStyleFns(trace);
    for (var i = 0; i < calcTrace.length; i++) {
      var cdi = calcTrace[i];
      if (cdi.fOut) {
        cdi.fOut.properties.mo2 = fns.selectedOpacityFn(cdi);
      }
    }
    opacitySetting = {
      type: 'identity',
      property: 'mo2'
    };
  } else {
    opacitySetting = Lib.isArrayOrTypedArray(trace.marker.opacity) ? {
      type: 'identity',
      property: 'mo'
    } : trace.marker.opacity;
  }
  Lib.extendFlat(opts.fill.paint, {
    'fill-opacity': opacitySetting
  });
  Lib.extendFlat(opts.line.paint, {
    'line-opacity': opacitySetting
  });
  return opts;
}
module.exports = {
  convert: convert,
  convertOnSelect: convertOnSelect
};

/***/ }),

/***/ 8244:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var colorscaleDefaults = __webpack_require__(39356);
var attributes = __webpack_require__(86227);
module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
  function coerce(attr, dflt) {
    return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
  }
  var locations = coerce('locations');
  var z = coerce('z');
  var geojson = coerce('geojson');
  if (!Lib.isArrayOrTypedArray(locations) || !locations.length || !Lib.isArrayOrTypedArray(z) || !z.length || !(typeof geojson === 'string' && geojson !== '' || Lib.isPlainObject(geojson))) {
    traceOut.visible = false;
    return;
  }
  coerce('featureidkey');
  traceOut._length = Math.min(locations.length, z.length);
  coerce('below');
  coerce('text');
  coerce('hovertext');
  coerce('hovertemplate');
  var mlw = coerce('marker.line.width');
  if (mlw) coerce('marker.line.color');
  coerce('marker.opacity');
  colorscaleDefaults(traceIn, traceOut, layout, coerce, {
    prefix: '',
    cLetter: 'z'
  });
  Lib.coerceSelectionMarkerOpacity(traceOut, coerce);
};

/***/ }),

/***/ 28128:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var deprecationWarning = ['*choroplethmapbox* trace is deprecated!', 'Please consider switching to the *choroplethmap* trace type and `map` subplots.', 'Learn more at: https://plotly.com/javascript/maplibre-migration/'].join(' ');
module.exports = {
  attributes: __webpack_require__(86227),
  supplyDefaults: __webpack_require__(8244),
  colorbar: __webpack_require__(12431),
  calc: __webpack_require__(12702),
  plot: __webpack_require__(33501),
  hoverPoints: __webpack_require__(94125),
  eventData: __webpack_require__(38414),
  selectPoints: __webpack_require__(43727),
  styleOnSelect: function (_, cd) {
    if (cd) {
      var trace = cd[0].trace;
      trace._glTrace.updateOnSelect(cd);
    }
  },
  getBelow: function (trace, subplot) {
    var mapLayers = subplot.getMapLayers();

    // find layer just above top-most "water" layer
    // that is not a plotly layer
    for (var i = mapLayers.length - 2; i >= 0; i--) {
      var layerId = mapLayers[i].id;
      if (typeof layerId === 'string' && layerId.indexOf('water') === 0) {
        for (var j = i + 1; j < mapLayers.length; j++) {
          layerId = mapLayers[j].id;
          if (typeof layerId === 'string' && layerId.indexOf('plotly-') === -1) {
            return layerId;
          }
        }
      }
    }
  },
  moduleType: 'trace',
  name: 'choroplethmapbox',
  basePlotModule: __webpack_require__(68192),
  categories: ['mapbox', 'gl', 'noOpacity', 'showLegend'],
  meta: {
    hr_name: 'choropleth_mapbox'
  }
};

/***/ }),

/***/ 33501:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var convert = (__webpack_require__(51335).convert);
var convertOnSelect = (__webpack_require__(51335).convertOnSelect);
var LAYER_PREFIX = (__webpack_require__(44245).traceLayerPrefix);
function ChoroplethMapbox(subplot, uid) {
  this.type = 'choroplethmapbox';
  this.subplot = subplot;
  this.uid = uid;

  // N.B. fill and line layers share same source
  this.sourceId = 'source-' + uid;
  this.layerList = [['fill', LAYER_PREFIX + uid + '-fill'], ['line', LAYER_PREFIX + uid + '-line']];

  // previous 'below' value,
  // need this to update it properly
  this.below = null;
}
var proto = ChoroplethMapbox.prototype;
proto.update = function (calcTrace) {
  this._update(convert(calcTrace));

  // link ref for quick update during selections
  calcTrace[0].trace._glTrace = this;
};
proto.updateOnSelect = function (calcTrace) {
  this._update(convertOnSelect(calcTrace));
};
proto._update = function (optsAll) {
  var subplot = this.subplot;
  var layerList = this.layerList;
  var below = subplot.belowLookup['trace-' + this.uid];
  subplot.map.getSource(this.sourceId).setData(optsAll.geojson);
  if (below !== this.below) {
    this._removeLayers();
    this._addLayers(optsAll, below);
    this.below = below;
  }
  for (var i = 0; i < layerList.length; i++) {
    var item = layerList[i];
    var k = item[0];
    var id = item[1];
    var opts = optsAll[k];
    subplot.setOptions(id, 'setLayoutProperty', opts.layout);
    if (opts.layout.visibility === 'visible') {
      subplot.setOptions(id, 'setPaintProperty', opts.paint);
    }
  }
};
proto._addLayers = function (optsAll, below) {
  var subplot = this.subplot;
  var layerList = this.layerList;
  var sourceId = this.sourceId;
  for (var i = 0; i < layerList.length; i++) {
    var item = layerList[i];
    var k = item[0];
    var opts = optsAll[k];
    subplot.addLayer({
      type: k,
      id: item[1],
      source: sourceId,
      layout: opts.layout,
      paint: opts.paint
    }, below);
  }
};
proto._removeLayers = function () {
  var map = this.subplot.map;
  var layerList = this.layerList;
  for (var i = layerList.length - 1; i >= 0; i--) {
    map.removeLayer(layerList[i][1]);
  }
};
proto.dispose = function () {
  var map = this.subplot.map;
  this._removeLayers();
  map.removeSource(this.sourceId);
};
module.exports = function createChoroplethMapbox(subplot, calcTrace) {
  var trace = calcTrace[0].trace;
  var choroplethMapbox = new ChoroplethMapbox(subplot, trace.uid);
  var sourceId = choroplethMapbox.sourceId;
  var optsAll = convert(calcTrace);
  var below = choroplethMapbox.below = subplot.belowLookup['trace-' + trace.uid];
  subplot.map.addSource(sourceId, {
    type: 'geojson',
    data: optsAll.geojson
  });
  choroplethMapbox._addLayers(optsAll, below);

  // link ref for quick update during selections
  calcTrace[0].trace._glTrace = choroplethMapbox;
  return choroplethMapbox;
};

/***/ }),

/***/ 49865:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var colorScaleAttrs = __webpack_require__(87163);
var axisHoverFormat = (__webpack_require__(80712).axisHoverFormat);
var hovertemplateAttrs = (__webpack_require__(3208)/* .hovertemplateAttrs */ .rb);
var mesh3dAttrs = __webpack_require__(42450);
var baseAttrs = __webpack_require__(9829);
var extendFlat = (__webpack_require__(93049).extendFlat);
var attrs = {
  x: {
    valType: 'data_array',
    editType: 'calc+clearAxisTypes'
  },
  y: {
    valType: 'data_array',
    editType: 'calc+clearAxisTypes'
  },
  z: {
    valType: 'data_array',
    editType: 'calc+clearAxisTypes'
  },
  u: {
    valType: 'data_array',
    editType: 'calc'
  },
  v: {
    valType: 'data_array',
    editType: 'calc'
  },
  w: {
    valType: 'data_array',
    editType: 'calc'
  },
  // TODO add way to specify cone positions independently of the vector field
  // provided, similar to MATLAB's coneplot Cx/Cy/Cz meshgrids,
  // see https://www.mathworks.com/help/matlab/ref/coneplot.html
  //
  // Alternatively, if our goal is only to 'fill in gaps' in the vector data,
  // we could try to extend the heatmap 'connectgaps' algorithm to 3D.
  // From AJ: this particular algorithm which amounts to a Poisson equation,
  // both for interpolation and extrapolation - is the right one to use for
  // cones too.  It makes a field with zero divergence, which is a good
  // baseline assumption for vector fields.
  //
  // cones: {
  //     // potential attributes to add:
  //     //
  //     // - meshmode: 'cartesian-product', 'pts', 'grid'
  //     //
  //     // under `meshmode: 'grid'`
  //     // - (x|y|z)grid.start
  //     // - (x|y|z)grid.end
  //     // - (x|y|z)grid.size
  //
  //     x: {
  //         valType: 'data_array',
  //         editType: 'calc',
  //
  //     },
  //     y: {
  //         valType: 'data_array',
  //         editType: 'calc',
  //
  //     },
  //     z: {
  //         valType: 'data_array',
  //         editType: 'calc',
  //
  //     },
  //
  //     editType: 'calc',
  //
  // },

  sizemode: {
    valType: 'enumerated',
    values: ['scaled', 'absolute', 'raw'],
    editType: 'calc',
    dflt: 'scaled'
  },
  sizeref: {
    valType: 'number',
    editType: 'calc',
    min: 0
  },
  anchor: {
    valType: 'enumerated',
    editType: 'calc',
    values: ['tip', 'tail', 'cm', 'center'],
    dflt: 'cm'
  },
  text: {
    valType: 'string',
    dflt: '',
    arrayOk: true,
    editType: 'calc'
  },
  hovertext: {
    valType: 'string',
    dflt: '',
    arrayOk: true,
    editType: 'calc'
  },
  hovertemplate: hovertemplateAttrs({
    editType: 'calc'
  }, {
    keys: ['norm']
  }),
  uhoverformat: axisHoverFormat('u', 1),
  vhoverformat: axisHoverFormat('v', 1),
  whoverformat: axisHoverFormat('w', 1),
  xhoverformat: axisHoverFormat('x'),
  yhoverformat: axisHoverFormat('y'),
  zhoverformat: axisHoverFormat('z'),
  showlegend: extendFlat({}, baseAttrs.showlegend, {
    dflt: false
  })
};
extendFlat(attrs, colorScaleAttrs('', {
  colorAttr: 'u/v/w norm',
  showScaleDflt: true,
  editTypeOverride: 'calc'
}));
var fromMesh3d = ['opacity', 'lightposition', 'lighting'];
fromMesh3d.forEach(function (k) {
  attrs[k] = mesh3dAttrs[k];
});
attrs.hoverinfo = extendFlat({}, baseAttrs.hoverinfo, {
  editType: 'calc',
  flags: ['x', 'y', 'z', 'u', 'v', 'w', 'norm', 'text', 'name'],
  dflt: 'x+y+z+norm+text+name'
});
attrs.transforms = undefined;
module.exports = attrs;

/***/ }),

/***/ 93805:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var colorscaleCalc = __webpack_require__(28379);
module.exports = function calc(gd, trace) {
  var u = trace.u;
  var v = trace.v;
  var w = trace.w;
  var len = Math.min(trace.x.length, trace.y.length, trace.z.length, u.length, v.length, w.length);
  var normMax = -Infinity;
  var normMin = Infinity;
  for (var i = 0; i < len; i++) {
    var uu = u[i];
    var vv = v[i];
    var ww = w[i];
    var norm = Math.sqrt(uu * uu + vv * vv + ww * ww);
    normMax = Math.max(normMax, norm);
    normMin = Math.min(normMin, norm);
  }
  trace._len = len;
  trace._normMax = normMax;
  colorscaleCalc(gd, trace, {
    vals: [normMin, normMax],
    containerStr: '',
    cLetter: 'c'
  });
};

/***/ }),

/***/ 49393:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var conePlot = (__webpack_require__(99098).gl_cone3d);
var createConeMesh = (__webpack_require__(99098).gl_cone3d).createConeMesh;
var simpleMap = (__webpack_require__(34809).simpleMap);
var parseColorScale = (__webpack_require__(46998).parseColorScale);
var extractOpts = (__webpack_require__(88856).extractOpts);
var isArrayOrTypedArray = (__webpack_require__(34809).isArrayOrTypedArray);
var zip3 = __webpack_require__(88239);
function Cone(scene, uid) {
  this.scene = scene;
  this.uid = uid;
  this.mesh = null;
  this.data = null;
}
var proto = Cone.prototype;
proto.handlePick = function (selection) {
  if (selection.object === this.mesh) {
    var selectIndex = selection.index = selection.data.index;
    var xx = this.data.x[selectIndex];
    var yy = this.data.y[selectIndex];
    var zz = this.data.z[selectIndex];
    var uu = this.data.u[selectIndex];
    var vv = this.data.v[selectIndex];
    var ww = this.data.w[selectIndex];
    selection.traceCoordinate = [xx, yy, zz, uu, vv, ww, Math.sqrt(uu * uu + vv * vv + ww * ww)];
    var text = this.data.hovertext || this.data.text;
    if (isArrayOrTypedArray(text) && text[selectIndex] !== undefined) {
      selection.textLabel = text[selectIndex];
    } else if (text) {
      selection.textLabel = text;
    }
    return true;
  }
};
var axisName2scaleIndex = {
  xaxis: 0,
  yaxis: 1,
  zaxis: 2
};
var anchor2coneOffset = {
  tip: 1,
  tail: 0,
  cm: 0.25,
  center: 0.5
};
var anchor2coneSpan = {
  tip: 1,
  tail: 1,
  cm: 0.75,
  center: 0.5
};
function convert(scene, trace) {
  var sceneLayout = scene.fullSceneLayout;
  var dataScale = scene.dataScale;
  var coneOpts = {};
  function toDataCoords(arr, axisName) {
    var ax = sceneLayout[axisName];
    var scale = dataScale[axisName2scaleIndex[axisName]];
    return simpleMap(arr, function (v) {
      return ax.d2l(v) * scale;
    });
  }
  coneOpts.vectors = zip3(toDataCoords(trace.u, 'xaxis'), toDataCoords(trace.v, 'yaxis'), toDataCoords(trace.w, 'zaxis'), trace._len);
  coneOpts.positions = zip3(toDataCoords(trace.x, 'xaxis'), toDataCoords(trace.y, 'yaxis'), toDataCoords(trace.z, 'zaxis'), trace._len);
  var cOpts = extractOpts(trace);
  coneOpts.colormap = parseColorScale(trace);
  coneOpts.vertexIntensityBounds = [cOpts.min / trace._normMax, cOpts.max / trace._normMax];
  coneOpts.coneOffset = anchor2coneOffset[trace.anchor];
  var sizemode = trace.sizemode;
  if (sizemode === 'scaled') {
    // unitless sizeref
    coneOpts.coneSize = trace.sizeref || 0.5;
  } else if (sizemode === 'absolute') {
    // sizeref here has unit of velocity
    coneOpts.coneSize = trace.sizeref && trace._normMax ? trace.sizeref / trace._normMax : 0.5;
  } else if (sizemode === 'raw') {
    coneOpts.coneSize = trace.sizeref;
  }
  coneOpts.coneSizemode = sizemode;
  var meshData = conePlot(coneOpts);

  // pass gl-mesh3d lighting attributes
  var lp = trace.lightposition;
  meshData.lightPosition = [lp.x, lp.y, lp.z];
  meshData.ambient = trace.lighting.ambient;
  meshData.diffuse = trace.lighting.diffuse;
  meshData.specular = trace.lighting.specular;
  meshData.roughness = trace.lighting.roughness;
  meshData.fresnel = trace.lighting.fresnel;
  meshData.opacity = trace.opacity;

  // stash autorange pad value
  trace._pad = anchor2coneSpan[trace.anchor] * meshData.vectorScale * meshData.coneScale * trace._normMax;
  return meshData;
}
proto.update = function (data) {
  this.data = data;
  var meshData = convert(this.scene, data);
  this.mesh.update(meshData);
};
proto.dispose = function () {
  this.scene.glplot.remove(this.mesh);
  this.mesh.dispose();
};
function createConeTrace(scene, data) {
  var gl = scene.glplot.gl;
  var meshData = convert(scene, data);
  var mesh = createConeMesh(gl, meshData);
  var cone = new Cone(scene, data.uid);
  cone.mesh = mesh;
  cone.data = data;
  mesh._trace = cone;
  scene.glplot.add(mesh);
  return cone;
}
module.exports = createConeTrace;

/***/ }),

/***/ 17326:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var colorscaleDefaults = __webpack_require__(39356);
var attributes = __webpack_require__(49865);
module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
  function coerce(attr, dflt) {
    return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
  }
  var u = coerce('u');
  var v = coerce('v');
  var w = coerce('w');
  var x = coerce('x');
  var y = coerce('y');
  var z = coerce('z');
  if (!u || !u.length || !v || !v.length || !w || !w.length || !x || !x.length || !y || !y.length || !z || !z.length) {
    traceOut.visible = false;
    return;
  }
  var sizemode = coerce('sizemode');
  coerce('sizeref', sizemode === 'raw' ? 1 : 0.5);
  coerce('anchor');
  coerce('lighting.ambient');
  coerce('lighting.diffuse');
  coerce('lighting.specular');
  coerce('lighting.roughness');
  coerce('lighting.fresnel');
  coerce('lightposition.x');
  coerce('lightposition.y');
  coerce('lightposition.z');
  colorscaleDefaults(traceIn, traceOut, layout, coerce, {
    prefix: '',
    cLetter: 'c'
  });
  coerce('text');
  coerce('hovertext');
  coerce('hovertemplate');
  coerce('uhoverformat');
  coerce('vhoverformat');
  coerce('whoverformat');
  coerce('xhoverformat');
  coerce('yhoverformat');
  coerce('zhoverformat');

  // disable 1D transforms (for now)
  traceOut._length = null;
};

/***/ }),

/***/ 47050:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = {
  moduleType: 'trace',
  name: 'cone',
  basePlotModule: __webpack_require__(2487),
  categories: ['gl3d', 'showLegend'],
  attributes: __webpack_require__(49865),
  supplyDefaults: __webpack_require__(17326),
  colorbar: {
    min: 'cmin',
    max: 'cmax'
  },
  calc: __webpack_require__(93805),
  plot: __webpack_require__(49393),
  eventData: function (out, pt) {
    out.norm = pt.traceCoordinate[6];
    return out;
  },
  meta: {}
};

/***/ }),

/***/ 52240:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var heatmapAttrs = __webpack_require__(81658);
var scatterAttrs = __webpack_require__(36640);
var axisFormat = __webpack_require__(80712);
var axisHoverFormat = axisFormat.axisHoverFormat;
var descriptionOnlyNumbers = axisFormat.descriptionOnlyNumbers;
var colorScaleAttrs = __webpack_require__(87163);
var dash = (__webpack_require__(94850)/* .dash */ .T);
var fontAttrs = __webpack_require__(80337);
var extendFlat = (__webpack_require__(93049).extendFlat);
var filterOps = __webpack_require__(20726);
var COMPARISON_OPS2 = filterOps.COMPARISON_OPS2;
var INTERVAL_OPS = filterOps.INTERVAL_OPS;
var scatterLineAttrs = scatterAttrs.line;
module.exports = extendFlat({
  z: heatmapAttrs.z,
  x: heatmapAttrs.x,
  x0: heatmapAttrs.x0,
  dx: heatmapAttrs.dx,
  y: heatmapAttrs.y,
  y0: heatmapAttrs.y0,
  dy: heatmapAttrs.dy,
  xperiod: heatmapAttrs.xperiod,
  yperiod: heatmapAttrs.yperiod,
  xperiod0: scatterAttrs.xperiod0,
  yperiod0: scatterAttrs.yperiod0,
  xperiodalignment: heatmapAttrs.xperiodalignment,
  yperiodalignment: heatmapAttrs.yperiodalignment,
  text: heatmapAttrs.text,
  hovertext: heatmapAttrs.hovertext,
  transpose: heatmapAttrs.transpose,
  xtype: heatmapAttrs.xtype,
  ytype: heatmapAttrs.ytype,
  xhoverformat: axisHoverFormat('x'),
  yhoverformat: axisHoverFormat('y'),
  zhoverformat: axisHoverFormat('z', 1),
  hovertemplate: heatmapAttrs.hovertemplate,
  texttemplate: extendFlat({}, heatmapAttrs.texttemplate, {}),
  textfont: extendFlat({}, heatmapAttrs.textfont, {}),
  hoverongaps: heatmapAttrs.hoverongaps,
  connectgaps: extendFlat({}, heatmapAttrs.connectgaps, {}),
  fillcolor: {
    valType: 'color',
    editType: 'calc'
  },
  autocontour: {
    valType: 'boolean',
    dflt: true,
    editType: 'calc',
    impliedEdits: {
      'contours.start': undefined,
      'contours.end': undefined,
      'contours.size': undefined
    }
  },
  ncontours: {
    valType: 'integer',
    dflt: 15,
    min: 1,
    editType: 'calc'
  },
  contours: {
    type: {
      valType: 'enumerated',
      values: ['levels', 'constraint'],
      dflt: 'levels',
      editType: 'calc'
    },
    start: {
      valType: 'number',
      dflt: null,
      editType: 'plot',
      impliedEdits: {
        '^autocontour': false
      }
    },
    end: {
      valType: 'number',
      dflt: null,
      editType: 'plot',
      impliedEdits: {
        '^autocontour': false
      }
    },
    size: {
      valType: 'number',
      dflt: null,
      min: 0,
      editType: 'plot',
      impliedEdits: {
        '^autocontour': false
      }
    },
    coloring: {
      valType: 'enumerated',
      values: ['fill', 'heatmap', 'lines', 'none'],
      dflt: 'fill',
      editType: 'calc'
    },
    showlines: {
      valType: 'boolean',
      dflt: true,
      editType: 'plot'
    },
    showlabels: {
      valType: 'boolean',
      dflt: false,
      editType: 'plot'
    },
    labelfont: fontAttrs({
      editType: 'plot',
      colorEditType: 'style'
    }),
    labelformat: {
      valType: 'string',
      dflt: '',
      editType: 'plot',
      description: descriptionOnlyNumbers('contour label')
    },
    operation: {
      valType: 'enumerated',
      values: [].concat(COMPARISON_OPS2).concat(INTERVAL_OPS),
      dflt: '=',
      editType: 'calc'
    },
    value: {
      valType: 'any',
      dflt: 0,
      editType: 'calc'
    },
    editType: 'calc',
    impliedEdits: {
      autocontour: false
    }
  },
  line: {
    color: extendFlat({}, scatterLineAttrs.color, {
      editType: 'style+colorbars'
    }),
    width: {
      valType: 'number',
      min: 0,
      editType: 'style+colorbars'
    },
    dash: dash,
    smoothing: extendFlat({}, scatterLineAttrs.smoothing, {}),
    editType: 'plot'
  },
  zorder: scatterAttrs.zorder
}, colorScaleAttrs('', {
  cLetter: 'z',
  autoColorDflt: false,
  editTypeOverride: 'calc'
}));

/***/ }),

/***/ 40352:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Colorscale = __webpack_require__(88856);
var heatmapCalc = __webpack_require__(51670);
var setContours = __webpack_require__(62475);
var endPlus = __webpack_require__(48715);

// most is the same as heatmap calc, then adjust it
// though a few things inside heatmap calc still look for
// contour maps, because the makeBoundArray calls are too entangled
module.exports = function calc(gd, trace) {
  var cd = heatmapCalc(gd, trace);
  var zOut = cd[0].z;
  setContours(trace, zOut);
  var contours = trace.contours;
  var cOpts = Colorscale.extractOpts(trace);
  var cVals;
  if (contours.coloring === 'heatmap' && cOpts.auto && trace.autocontour === false) {
    var start = contours.start;
    var end = endPlus(contours);
    var cs = contours.size || 1;
    var nc = Math.floor((end - start) / cs) + 1;
    if (!isFinite(cs)) {
      cs = 1;
      nc = 1;
    }
    var min0 = start - cs / 2;
    var max0 = min0 + nc * cs;
    cVals = [min0, max0];
  } else {
    cVals = zOut;
  }
  Colorscale.calc(gd, trace, {
    vals: cVals,
    cLetter: 'z'
  });
  return cd;
};

/***/ }),

/***/ 49886:
/***/ (function(module) {

"use strict";


module.exports = function (pathinfo, contours) {
  var pi0 = pathinfo[0];
  var z = pi0.z;
  var i;
  switch (contours.type) {
    case 'levels':
      // Why (just) use z[0][0] and z[0][1]?
      //
      // N.B. using boundaryMin instead of edgeVal2 here makes the
      //      `contour_scatter` mock fail
      var edgeVal2 = Math.min(z[0][0], z[0][1]);
      for (i = 0; i < pathinfo.length; i++) {
        var pi = pathinfo[i];
        pi.prefixBoundary = !pi.edgepaths.length && (edgeVal2 > pi.level || pi.starts.length && edgeVal2 === pi.level);
      }
      break;
    case 'constraint':
      // after convertToConstraints, pathinfo has length=0
      pi0.prefixBoundary = false;

      // joinAllPaths does enough already when edgepaths are present
      if (pi0.edgepaths.length) return;
      var na = pi0.x.length;
      var nb = pi0.y.length;
      var boundaryMax = -Infinity;
      var boundaryMin = Infinity;
      for (i = 0; i < nb; i++) {
        boundaryMin = Math.min(boundaryMin, z[i][0]);
        boundaryMin = Math.min(boundaryMin, z[i][na - 1]);
        boundaryMax = Math.max(boundaryMax, z[i][0]);
        boundaryMax = Math.max(boundaryMax, z[i][na - 1]);
      }
      for (i = 1; i < na - 1; i++) {
        boundaryMin = Math.min(boundaryMin, z[0][i]);
        boundaryMin = Math.min(boundaryMin, z[nb - 1][i]);
        boundaryMax = Math.max(boundaryMax, z[0][i]);
        boundaryMax = Math.max(boundaryMax, z[nb - 1][i]);
      }
      var contoursValue = contours.value;
      var v1, v2;
      switch (contours._operation) {
        case '>':
          if (contoursValue > boundaryMax) {
            pi0.prefixBoundary = true;
          }
          break;
        case '<':
          if (contoursValue < boundaryMin || pi0.starts.length && contoursValue === boundaryMin) {
            pi0.prefixBoundary = true;
          }
          break;
        case '[]':
          v1 = Math.min(contoursValue[0], contoursValue[1]);
          v2 = Math.max(contoursValue[0], contoursValue[1]);
          if (v2 < boundaryMin || v1 > boundaryMax || pi0.starts.length && v2 === boundaryMin) {
            pi0.prefixBoundary = true;
          }
          break;
        case '][':
          v1 = Math.min(contoursValue[0], contoursValue[1]);
          v2 = Math.max(contoursValue[0], contoursValue[1]);
          if (v1 < boundaryMin && v2 > boundaryMax) {
            pi0.prefixBoundary = true;
          }
          break;
      }
      break;
  }
};

/***/ }),

/***/ 92697:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Colorscale = __webpack_require__(88856);
var makeColorMap = __webpack_require__(16438);
var endPlus = __webpack_require__(48715);
function calc(gd, trace, opts) {
  var contours = trace.contours;
  var line = trace.line;
  var cs = contours.size || 1;
  var coloring = contours.coloring;
  var colorMap = makeColorMap(trace, {
    isColorbar: true
  });
  if (coloring === 'heatmap') {
    var cOpts = Colorscale.extractOpts(trace);
    opts._fillgradient = cOpts.reversescale ? Colorscale.flipScale(cOpts.colorscale) : cOpts.colorscale;
    opts._zrange = [cOpts.min, cOpts.max];
  } else if (coloring === 'fill') {
    opts._fillcolor = colorMap;
  }
  opts._line = {
    color: coloring === 'lines' ? colorMap : line.color,
    width: contours.showlines !== false ? line.width : 0,
    dash: line.dash
  };
  opts._levels = {
    start: contours.start,
    end: endPlus(contours),
    size: cs
  };
}
module.exports = {
  min: 'zmin',
  max: 'zmax',
  calc: calc
};

/***/ }),

/***/ 53156:
/***/ (function(module) {

"use strict";


module.exports = {
  // some constants to help with marching squares algorithm
  // where does the path start for each index?
  BOTTOMSTART: [1, 9, 13, 104, 713],
  TOPSTART: [4, 6, 7, 104, 713],
  LEFTSTART: [8, 12, 14, 208, 1114],
  RIGHTSTART: [2, 3, 11, 208, 1114],
  // which way [dx,dy] do we leave a given index?
  // saddles are already disambiguated
  NEWDELTA: [null, [-1, 0], [0, -1], [-1, 0], [1, 0], null, [0, -1], [-1, 0], [0, 1], [0, 1], null, [0, 1], [1, 0], [1, 0], [0, -1]],
  // for each saddle, the first index here is used
  // for dx||dy<0, the second for dx||dy>0
  CHOOSESADDLE: {
    104: [4, 1],
    208: [2, 8],
    713: [7, 13],
    1114: [11, 14]
  },
  // after one index has been used for a saddle, which do we
  // substitute to be used up later?
  SADDLEREMAINDER: {
    1: 4,
    2: 8,
    4: 1,
    7: 13,
    8: 2,
    11: 14,
    13: 7,
    14: 11
  },
  // length of a contour, as a multiple of the plot area diagonal, per label
  LABELDISTANCE: 2,
  // number of contour levels after which we start increasing the number of
  // labels we draw. Many contours means they will generally be close
  // together, so it will be harder to follow a long way to find a label
  LABELINCREASE: 10,
  // minimum length of a contour line, as a multiple of the label length,
  // at which we draw *any* labels
  LABELMIN: 3,
  // max number of labels to draw on a single contour path, no matter how long
  LABELMAX: 10,
  // constants for the label position cost function
  LABELOPTIMIZER: {
    // weight given to edge proximity
    EDGECOST: 1,
    // weight given to the angle off horizontal
    ANGLECOST: 1,
    // weight given to distance from already-placed labels
    NEIGHBORCOST: 5,
    // cost multiplier for labels on the same level
    SAMELEVELFACTOR: 10,
    // minimum distance (as a multiple of the label length)
    // for labels on the same level
    SAMELEVELDISTANCE: 5,
    // maximum cost before we won't even place the label
    MAXCOST: 100,
    // number of evenly spaced points to look at in the first
    // iteration of the search
    INITIALSEARCHPOINTS: 10,
    // number of binary search iterations after the initial wide search
    ITERATIONS: 5
  }
};

/***/ }),

/***/ 29503:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isNumeric = __webpack_require__(10721);
var handleLabelDefaults = __webpack_require__(20576);
var Color = __webpack_require__(78766);
var addOpacity = Color.addOpacity;
var opacity = Color.opacity;
var filterOps = __webpack_require__(20726);
var isArrayOrTypedArray = (__webpack_require__(34809).isArrayOrTypedArray);
var CONSTRAINT_REDUCTION = filterOps.CONSTRAINT_REDUCTION;
var COMPARISON_OPS2 = filterOps.COMPARISON_OPS2;
module.exports = function handleConstraintDefaults(traceIn, traceOut, coerce, layout, defaultColor, opts) {
  var contours = traceOut.contours;
  var showLines, lineColor, fillColor;
  var operation = coerce('contours.operation');
  contours._operation = CONSTRAINT_REDUCTION[operation];
  handleConstraintValueDefaults(coerce, contours);
  if (operation === '=') {
    showLines = contours.showlines = true;
  } else {
    showLines = coerce('contours.showlines');
    fillColor = coerce('fillcolor', addOpacity((traceIn.line || {}).color || defaultColor, 0.5));
  }
  if (showLines) {
    var lineDfltColor = fillColor && opacity(fillColor) ? addOpacity(traceOut.fillcolor, 1) : defaultColor;
    lineColor = coerce('line.color', lineDfltColor);
    coerce('line.width', 2);
    coerce('line.dash');
  }
  coerce('line.smoothing');
  handleLabelDefaults(coerce, layout, lineColor, opts);
};
function handleConstraintValueDefaults(coerce, contours) {
  var zvalue;
  if (COMPARISON_OPS2.indexOf(contours.operation) === -1) {
    // Requires an array of two numbers:
    coerce('contours.value', [0, 1]);
    if (!isArrayOrTypedArray(contours.value)) {
      if (isNumeric(contours.value)) {
        zvalue = parseFloat(contours.value);
        contours.value = [zvalue, zvalue + 1];
      }
    } else if (contours.value.length > 2) {
      contours.value = contours.value.slice(2);
    } else if (contours.length === 0) {
      contours.value = [0, 1];
    } else if (contours.length < 2) {
      zvalue = parseFloat(contours.value[0]);
      contours.value = [zvalue, zvalue + 1];
    } else {
      contours.value = [parseFloat(contours.value[0]), parseFloat(contours.value[1])];
    }
  } else {
    // Requires a single scalar:
    coerce('contours.value', 0);
    if (!isNumeric(contours.value)) {
      if (isArrayOrTypedArray(contours.value)) {
        contours.value = parseFloat(contours.value[0]);
      } else {
        contours.value = 0;
      }
    }
  }
}

/***/ }),

/***/ 22783:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var filterOps = __webpack_require__(20726);
var isNumeric = __webpack_require__(10721);

// This syntax conforms to the existing filter transform syntax, but we don't care
// about open vs. closed intervals for simply drawing contours constraints:
module.exports = {
  '[]': makeRangeSettings('[]'),
  '][': makeRangeSettings(']['),
  '>': makeInequalitySettings('>'),
  '<': makeInequalitySettings('<'),
  '=': makeInequalitySettings('=')
};

// This does not in any way shape or form support calendars. It's adapted from
// transforms/filter.js.
function coerceValue(operation, value) {
  var hasArrayValue = Array.isArray(value);
  var coercedValue;
  function coerce(value) {
    return isNumeric(value) ? +value : null;
  }
  if (filterOps.COMPARISON_OPS2.indexOf(operation) !== -1) {
    coercedValue = hasArrayValue ? coerce(value[0]) : coerce(value);
  } else if (filterOps.INTERVAL_OPS.indexOf(operation) !== -1) {
    coercedValue = hasArrayValue ? [coerce(value[0]), coerce(value[1])] : [coerce(value), coerce(value)];
  } else if (filterOps.SET_OPS.indexOf(operation) !== -1) {
    coercedValue = hasArrayValue ? value.map(coerce) : [coerce(value)];
  }
  return coercedValue;
}

// Returns a parabola scaled so that the min/max is either +/- 1 and zero at the two values
// provided. The data is mapped by this function when constructing intervals so that it's
// very easy to construct contours as normal.
function makeRangeSettings(operation) {
  return function (value) {
    value = coerceValue(operation, value);

    // Ensure proper ordering:
    var min = Math.min(value[0], value[1]);
    var max = Math.max(value[0], value[1]);
    return {
      start: min,
      end: max,
      size: max - min
    };
  };
}
function makeInequalitySettings(operation) {
  return function (value) {
    value = coerceValue(operation, value);
    return {
      start: value,
      end: Infinity,
      size: Infinity
    };
  };
}

/***/ }),

/***/ 47495:
/***/ (function(module) {

"use strict";


module.exports = function handleContourDefaults(traceIn, traceOut, coerce, coerce2) {
  var contourStart = coerce2('contours.start');
  var contourEnd = coerce2('contours.end');
  var missingEnd = contourStart === false || contourEnd === false;

  // normally we only need size if autocontour is off. But contour.calc
  // pushes its calculated contour size back to the input trace, so for
  // things like restyle that can call supplyDefaults without calc
  // after the initial draw, we can just reuse the previous calculation
  var contourSize = coerce('contours.size');
  var autoContour;
  if (missingEnd) autoContour = traceOut.autocontour = true;else autoContour = coerce('autocontour', false);
  if (autoContour || !contourSize) coerce('ncontours');
};

/***/ }),

/***/ 1999:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);

// The contour extraction is great, except it totally fails for constraints because we
// need weird range loops and flipped contours instead of the usual format. This function
// does some weird manipulation of the extracted pathinfo data such that it magically
// draws contours correctly *as* constraints.
//
// ** I do not know which "weird range loops" the comment above is referring to.
module.exports = function (pathinfo, operation) {
  var i, pi0, pi1;
  var op0 = function (arr) {
    return arr.reverse();
  };
  var op1 = function (arr) {
    return arr;
  };
  switch (operation) {
    case '=':
    case '<':
      return pathinfo;
    case '>':
      if (pathinfo.length !== 1) {
        Lib.warn('Contour data invalid for the specified inequality operation.');
      }

      // In this case there should be exactly one contour levels in pathinfo.
      // We flip all of the data. This will draw the contour as closed.
      pi0 = pathinfo[0];
      for (i = 0; i < pi0.edgepaths.length; i++) {
        pi0.edgepaths[i] = op0(pi0.edgepaths[i]);
      }
      for (i = 0; i < pi0.paths.length; i++) {
        pi0.paths[i] = op0(pi0.paths[i]);
      }
      for (i = 0; i < pi0.starts.length; i++) {
        pi0.starts[i] = op0(pi0.starts[i]);
      }
      return pathinfo;
    case '][':
      var tmp = op0;
      op0 = op1;
      op1 = tmp;
    // It's a nice rule, except this definitely *is* what's intended here.
    /* eslint-disable: no-fallthrough */
    case '[]':
      /* eslint-enable: no-fallthrough */
      if (pathinfo.length !== 2) {
        Lib.warn('Contour data invalid for the specified inequality range operation.');
      }

      // In this case there should be exactly two contour levels in pathinfo.
      // - We concatenate the info into one pathinfo.
      // - We must also flip all of the data in the `[]` case.
      // This will draw the contours as closed.
      pi0 = copyPathinfo(pathinfo[0]);
      pi1 = copyPathinfo(pathinfo[1]);
      for (i = 0; i < pi0.edgepaths.length; i++) {
        pi0.edgepaths[i] = op0(pi0.edgepaths[i]);
      }
      for (i = 0; i < pi0.paths.length; i++) {
        pi0.paths[i] = op0(pi0.paths[i]);
      }
      for (i = 0; i < pi0.starts.length; i++) {
        pi0.starts[i] = op0(pi0.starts[i]);
      }
      while (pi1.edgepaths.length) {
        pi0.edgepaths.push(op1(pi1.edgepaths.shift()));
      }
      while (pi1.paths.length) {
        pi0.paths.push(op1(pi1.paths.shift()));
      }
      while (pi1.starts.length) {
        pi0.starts.push(op1(pi1.starts.shift()));
      }
      return [pi0];
  }
};
function copyPathinfo(pi) {
  return Lib.extendFlat({}, pi, {
    edgepaths: Lib.extendDeep([], pi.edgepaths),
    paths: Lib.extendDeep([], pi.paths),
    starts: Lib.extendDeep([], pi.starts)
  });
}

/***/ }),

/***/ 57543:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var handleXYZDefaults = __webpack_require__(86073);
var handlePeriodDefaults = __webpack_require__(99669);
var handleConstraintDefaults = __webpack_require__(29503);
var handleContoursDefaults = __webpack_require__(47495);
var handleStyleDefaults = __webpack_require__(39889);
var handleHeatmapLabelDefaults = __webpack_require__(63814);
var attributes = __webpack_require__(52240);
module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
  function coerce(attr, dflt) {
    return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
  }
  function coerce2(attr) {
    return Lib.coerce2(traceIn, traceOut, attributes, attr);
  }
  var len = handleXYZDefaults(traceIn, traceOut, coerce, layout);
  if (!len) {
    traceOut.visible = false;
    return;
  }
  handlePeriodDefaults(traceIn, traceOut, layout, coerce);
  coerce('xhoverformat');
  coerce('yhoverformat');
  coerce('text');
  coerce('hovertext');
  coerce('hoverongaps');
  coerce('hovertemplate');
  var isConstraint = coerce('contours.type') === 'constraint';
  coerce('connectgaps', Lib.isArray1D(traceOut.z));
  if (isConstraint) {
    handleConstraintDefaults(traceIn, traceOut, coerce, layout, defaultColor);
  } else {
    handleContoursDefaults(traceIn, traceOut, coerce, coerce2);
    handleStyleDefaults(traceIn, traceOut, coerce, layout);
  }
  if (traceOut.contours && traceOut.contours.coloring === 'heatmap') {
    handleHeatmapLabelDefaults(coerce, layout);
  }
  coerce('zorder');
};

/***/ }),

/***/ 86828:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var constraintMapping = __webpack_require__(22783);
var endPlus = __webpack_require__(48715);
module.exports = function emptyPathinfo(contours, plotinfo, cd0) {
  var contoursFinal = contours.type === 'constraint' ? constraintMapping[contours._operation](contours.value) : contours;
  var cs = contoursFinal.size;
  var pathinfo = [];
  var end = endPlus(contoursFinal);
  var carpet = cd0.trace._carpetTrace;
  var basePathinfo = carpet ? {
    // store axes so we can convert to px
    xaxis: carpet.aaxis,
    yaxis: carpet.baxis,
    // full data arrays to use for interpolation
    x: cd0.a,
    y: cd0.b
  } : {
    xaxis: plotinfo.xaxis,
    yaxis: plotinfo.yaxis,
    x: cd0.x,
    y: cd0.y
  };
  for (var ci = contoursFinal.start; ci < end; ci += cs) {
    pathinfo.push(Lib.extendFlat({
      level: ci,
      // all the cells with nontrivial marching index
      crossings: {},
      // starting points on the edges of the lattice for each contour
      starts: [],
      // all unclosed paths (may have less items than starts,
      // if a path is closed by rounding)
      edgepaths: [],
      // all closed paths
      paths: [],
      z: cd0.z,
      smoothing: cd0.trace.line.smoothing
    }, basePathinfo));
    if (pathinfo.length > 1000) {
      Lib.warn('Too many contours, clipping at 1000', contours);
      break;
    }
  }
  return pathinfo;
};

/***/ }),

/***/ 48715:
/***/ (function(module) {

"use strict";


/*
 * tiny helper to move the end of the contours a little to prevent
 * losing the last contour to rounding errors
 */
module.exports = function endPlus(contours) {
  return contours.end + contours.size / 1e6;
};

/***/ }),

/***/ 27657:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var constants = __webpack_require__(53156);
module.exports = function findAllPaths(pathinfo, xtol, ytol) {
  var cnt, startLoc, i, pi, j;

  // Default just passes these values through as they were before:
  xtol = xtol || 0.01;
  ytol = ytol || 0.01;
  for (i = 0; i < pathinfo.length; i++) {
    pi = pathinfo[i];
    for (j = 0; j < pi.starts.length; j++) {
      startLoc = pi.starts[j];
      makePath(pi, startLoc, 'edge', xtol, ytol);
    }
    cnt = 0;
    while (Object.keys(pi.crossings).length && cnt < 10000) {
      cnt++;
      startLoc = Object.keys(pi.crossings)[0].split(',').map(Number);
      makePath(pi, startLoc, undefined, xtol, ytol);
    }
    if (cnt === 10000) Lib.log('Infinite loop in contour?');
  }
};
function equalPts(pt1, pt2, xtol, ytol) {
  return Math.abs(pt1[0] - pt2[0]) < xtol && Math.abs(pt1[1] - pt2[1]) < ytol;
}

// distance in index units - uses the 3rd and 4th items in points
function ptDist(pt1, pt2) {
  var dx = pt1[2] - pt2[2];
  var dy = pt1[3] - pt2[3];
  return Math.sqrt(dx * dx + dy * dy);
}
function makePath(pi, loc, edgeflag, xtol, ytol) {
  var locStr = loc.join(',');
  var mi = pi.crossings[locStr];
  var marchStep = getStartStep(mi, edgeflag, loc);
  // start by going backward a half step and finding the crossing point
  var pts = [getInterpPx(pi, loc, [-marchStep[0], -marchStep[1]])];
  var m = pi.z.length;
  var n = pi.z[0].length;
  var startLoc = loc.slice();
  var startStep = marchStep.slice();
  var cnt;

  // now follow the path
  for (cnt = 0; cnt < 10000; cnt++) {
    // just to avoid infinite loops
    if (mi > 20) {
      mi = constants.CHOOSESADDLE[mi][(marchStep[0] || marchStep[1]) < 0 ? 0 : 1];
      pi.crossings[locStr] = constants.SADDLEREMAINDER[mi];
    } else {
      delete pi.crossings[locStr];
    }
    marchStep = constants.NEWDELTA[mi];
    if (!marchStep) {
      Lib.log('Found bad marching index:', mi, loc, pi.level);
      break;
    }

    // find the crossing a half step forward, and then take the full step
    pts.push(getInterpPx(pi, loc, marchStep));
    loc[0] += marchStep[0];
    loc[1] += marchStep[1];
    locStr = loc.join(',');

    // don't include the same point multiple times
    if (equalPts(pts[pts.length - 1], pts[pts.length - 2], xtol, ytol)) pts.pop();
    var atEdge = marchStep[0] && (loc[0] < 0 || loc[0] > n - 2) || marchStep[1] && (loc[1] < 0 || loc[1] > m - 2);
    var closedLoop = loc[0] === startLoc[0] && loc[1] === startLoc[1] && marchStep[0] === startStep[0] && marchStep[1] === startStep[1];

    // have we completed a loop, or reached an edge?
    if (closedLoop || edgeflag && atEdge) break;
    mi = pi.crossings[locStr];
  }
  if (cnt === 10000) {
    Lib.log('Infinite loop in contour?');
  }
  var closedpath = equalPts(pts[0], pts[pts.length - 1], xtol, ytol);
  var totaldist = 0;
  var distThresholdFactor = 0.2 * pi.smoothing;
  var alldists = [];
  var cropstart = 0;
  var distgroup, cnt2, cnt3, newpt, ptcnt, ptavg, thisdist, i, j, edgepathi, edgepathj;

  /*
   * Check for points that are too close together (<1/5 the average dist
   * *in grid index units* (important for log axes and nonuniform grids),
   * less if less smoothed) and just take the center (or avg of center 2).
   * This cuts down on funny behavior when a point is very close to a
   * contour level.
   */
  for (cnt = 1; cnt < pts.length; cnt++) {
    thisdist = ptDist(pts[cnt], pts[cnt - 1]);
    totaldist += thisdist;
    alldists.push(thisdist);
  }
  var distThreshold = totaldist / alldists.length * distThresholdFactor;
  function getpt(i) {
    return pts[i % pts.length];
  }
  for (cnt = pts.length - 2; cnt >= cropstart; cnt--) {
    distgroup = alldists[cnt];
    if (distgroup < distThreshold) {
      cnt3 = 0;
      for (cnt2 = cnt - 1; cnt2 >= cropstart; cnt2--) {
        if (distgroup + alldists[cnt2] < distThreshold) {
          distgroup += alldists[cnt2];
        } else break;
      }

      // closed path with close points wrapping around the boundary?
      if (closedpath && cnt === pts.length - 2) {
        for (cnt3 = 0; cnt3 < cnt2; cnt3++) {
          if (distgroup + alldists[cnt3] < distThreshold) {
            distgroup += alldists[cnt3];
          } else break;
        }
      }
      ptcnt = cnt - cnt2 + cnt3 + 1;
      ptavg = Math.floor((cnt + cnt2 + cnt3 + 2) / 2);

      // either endpoint included: keep the endpoint
      if (!closedpath && cnt === pts.length - 2) newpt = pts[pts.length - 1];else if (!closedpath && cnt2 === -1) newpt = pts[0];

      // odd # of points - just take the central one
      else if (ptcnt % 2) newpt = getpt(ptavg);

      // even # of pts - average central two
      else {
        newpt = [(getpt(ptavg)[0] + getpt(ptavg + 1)[0]) / 2, (getpt(ptavg)[1] + getpt(ptavg + 1)[1]) / 2];
      }
      pts.splice(cnt2 + 1, cnt - cnt2 + 1, newpt);
      cnt = cnt2 + 1;
      if (cnt3) cropstart = cnt3;
      if (closedpath) {
        if (cnt === pts.length - 2) pts[cnt3] = pts[pts.length - 1];else if (cnt === 0) pts[pts.length - 1] = pts[0];
      }
    }
  }
  pts.splice(0, cropstart);

  // done with the index parts - remove them so path generation works right
  // because it depends on only having [xpx, ypx]
  for (cnt = 0; cnt < pts.length; cnt++) pts[cnt].length = 2;

  // don't return single-point paths (ie all points were the same
  // so they got deleted?)
  if (pts.length < 2) return;else if (closedpath) {
    pts.pop();
    pi.paths.push(pts);
  } else {
    if (!edgeflag) {
      Lib.log('Unclosed interior contour?', pi.level, startLoc.join(','), pts.join('L'));
    }

    // edge path - does it start where an existing edge path ends, or vice versa?
    var merged = false;
    for (i = 0; i < pi.edgepaths.length; i++) {
      edgepathi = pi.edgepaths[i];
      if (!merged && equalPts(edgepathi[0], pts[pts.length - 1], xtol, ytol)) {
        pts.pop();
        merged = true;

        // now does it ALSO meet the end of another (or the same) path?
        var doublemerged = false;
        for (j = 0; j < pi.edgepaths.length; j++) {
          edgepathj = pi.edgepaths[j];
          if (equalPts(edgepathj[edgepathj.length - 1], pts[0], xtol, ytol)) {
            doublemerged = true;
            pts.shift();
            pi.edgepaths.splice(i, 1);
            if (j === i) {
              // the path is now closed
              pi.paths.push(pts.concat(edgepathj));
            } else {
              if (j > i) j--;
              pi.edgepaths[j] = edgepathj.concat(pts, edgepathi);
            }
            break;
          }
        }
        if (!doublemerged) {
          pi.edgepaths[i] = pts.concat(edgepathi);
        }
      }
    }
    for (i = 0; i < pi.edgepaths.length; i++) {
      if (merged) break;
      edgepathi = pi.edgepaths[i];
      if (equalPts(edgepathi[edgepathi.length - 1], pts[0], xtol, ytol)) {
        pts.shift();
        pi.edgepaths[i] = edgepathi.concat(pts);
        merged = true;
      }
    }
    if (!merged) pi.edgepaths.push(pts);
  }
}

// special function to get the marching step of the
// first point in the path (leading to loc)
function getStartStep(mi, edgeflag, loc) {
  var dx = 0;
  var dy = 0;
  if (mi > 20 && edgeflag) {
    // these saddles start at +/- x
    if (mi === 208 || mi === 1114) {
      // if we're starting at the left side, we must be going right
      dx = loc[0] === 0 ? 1 : -1;
    } else {
      // if we're starting at the bottom, we must be going up
      dy = loc[1] === 0 ? 1 : -1;
    }
  } else if (constants.BOTTOMSTART.indexOf(mi) !== -1) dy = 1;else if (constants.LEFTSTART.indexOf(mi) !== -1) dx = 1;else if (constants.TOPSTART.indexOf(mi) !== -1) dy = -1;else dx = -1;
  return [dx, dy];
}

/*
 * Find the pixel coordinates of a particular crossing
 *
 * @param {object} pi: the pathinfo object at this level
 * @param {array} loc: the grid index [x, y] of the crossing
 * @param {array} step: the direction [dx, dy] we're moving on the grid
 *
 * @return {array} [xpx, ypx, xi, yi]: the first two are the pixel location,
 *   the next two are the interpolated grid indices, which we use for
 *   distance calculations to delete points that are too close together.
 *   This is important when the grid is nonuniform (and most dramatically when
 *   we're on log axes and include invalid (0 or negative) values.
 *   It's crucial to delete these extra two before turning an array of these
 *   points into a path, because those routines require length-2 points.
 */
function getInterpPx(pi, loc, step) {
  var locx = loc[0] + Math.max(step[0], 0);
  var locy = loc[1] + Math.max(step[1], 0);
  var zxy = pi.z[locy][locx];
  var xa = pi.xaxis;
  var ya = pi.yaxis;

  // Interpolate in linear space, then convert to pixel
  if (step[1]) {
    var dx = (pi.level - zxy) / (pi.z[locy][locx + 1] - zxy);
    // Interpolate, but protect against NaN linear values for log axis (dx will equal 1 or 0)
    var dxl = (dx !== 1 ? (1 - dx) * xa.c2l(pi.x[locx]) : 0) + (dx !== 0 ? dx * xa.c2l(pi.x[locx + 1]) : 0);
    return [xa.c2p(xa.l2c(dxl), true), ya.c2p(pi.y[locy], true), locx + dx, locy];
  } else {
    var dy = (pi.level - zxy) / (pi.z[locy + 1][locx] - zxy);
    var dyl = (dy !== 1 ? (1 - dy) * ya.c2l(pi.y[locy]) : 0) + (dy !== 0 ? dy * ya.c2l(pi.y[locy + 1]) : 0);
    return [xa.c2p(pi.x[locx], true), ya.c2p(ya.l2c(dyl), true), locx, locy + dy];
  }
}

/***/ }),

/***/ 29815:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Color = __webpack_require__(78766);
var heatmapHoverPoints = __webpack_require__(93125);
module.exports = function hoverPoints(pointData, xval, yval, hovermode, opts) {
  if (!opts) opts = {};
  opts.isContour = true;
  var hoverData = heatmapHoverPoints(pointData, xval, yval, hovermode, opts);
  if (hoverData) {
    hoverData.forEach(function (hoverPt) {
      var trace = hoverPt.trace;
      if (trace.contours.type === 'constraint') {
        if (trace.fillcolor && Color.opacity(trace.fillcolor)) {
          hoverPt.color = Color.addOpacity(trace.fillcolor, 1);
        } else if (trace.contours.showlines && Color.opacity(trace.line.color)) {
          hoverPt.color = Color.addOpacity(trace.line.color, 1);
        }
      }
    });
  }
  return hoverData;
};

/***/ }),

/***/ 91405:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = {
  attributes: __webpack_require__(52240),
  supplyDefaults: __webpack_require__(57543),
  calc: __webpack_require__(40352),
  plot: (__webpack_require__(8850).plot),
  style: __webpack_require__(1328),
  colorbar: __webpack_require__(92697),
  hoverPoints: __webpack_require__(29815),
  moduleType: 'trace',
  name: 'contour',
  basePlotModule: __webpack_require__(37703),
  categories: ['cartesian', 'svg', '2dMap', 'contour', 'showLegend'],
  meta: {}
};

/***/ }),

/***/ 20576:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
module.exports = function handleLabelDefaults(coerce, layout, lineColor, opts) {
  if (!opts) opts = {};
  var showLabels = coerce('contours.showlabels');
  if (showLabels) {
    var globalFont = layout.font;
    Lib.coerceFont(coerce, 'contours.labelfont', globalFont, {
      overrideDflt: {
        color: lineColor
      }
    });
    coerce('contours.labelformat');
  }
  if (opts.hasHover !== false) coerce('zhoverformat');
};

/***/ }),

/***/ 16438:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var Colorscale = __webpack_require__(88856);
var endPlus = __webpack_require__(48715);
module.exports = function makeColorMap(trace) {
  var contours = trace.contours;
  var start = contours.start;
  var end = endPlus(contours);
  var cs = contours.size || 1;
  var nc = Math.floor((end - start) / cs) + 1;
  var extra = contours.coloring === 'lines' ? 0 : 1;
  var cOpts = Colorscale.extractOpts(trace);
  if (!isFinite(cs)) {
    cs = 1;
    nc = 1;
  }
  var scl = cOpts.reversescale ? Colorscale.flipScale(cOpts.colorscale) : cOpts.colorscale;
  var len = scl.length;
  var domain = new Array(len);
  var range = new Array(len);
  var si, i;
  var zmin0 = cOpts.min;
  var zmax0 = cOpts.max;
  if (contours.coloring === 'heatmap') {
    for (i = 0; i < len; i++) {
      si = scl[i];
      domain[i] = si[0] * (zmax0 - zmin0) + zmin0;
      range[i] = si[1];
    }

    // do the contours extend beyond the colorscale?
    // if so, extend the colorscale with constants
    var zRange = d3.extent([zmin0, zmax0, contours.start, contours.start + cs * (nc - 1)]);
    var zmin = zRange[zmin0 < zmax0 ? 0 : 1];
    var zmax = zRange[zmin0 < zmax0 ? 1 : 0];
    if (zmin !== zmin0) {
      domain.splice(0, 0, zmin);
      range.splice(0, 0, range[0]);
    }
    if (zmax !== zmax0) {
      domain.push(zmax);
      range.push(range[range.length - 1]);
    }
  } else {
    var zRangeInput = trace._input && typeof trace._input.zmin === 'number' && typeof trace._input.zmax === 'number';

    // If zmin/zmax are explicitly set, consider case where user specifies a
    // narrower z range than that of the contours start/end.
    if (zRangeInput && (start <= zmin0 || end >= zmax0)) {
      if (start <= zmin0) start = zmin0;
      if (end >= zmax0) end = zmax0;
      nc = Math.floor((end - start) / cs) + 1;
      extra = 0;
    }
    for (i = 0; i < len; i++) {
      si = scl[i];
      domain[i] = (si[0] * (nc + extra - 1) - extra / 2) * cs + start;
      range[i] = si[1];
    }

    // Make the colorscale fit the z range except if contours are explicitly
    // set BUT NOT zmin/zmax.
    if (zRangeInput || trace.autocontour) {
      if (domain[0] > zmin0) {
        domain.unshift(zmin0);
        range.unshift(range[0]);
      }
      if (domain[domain.length - 1] < zmax0) {
        domain.push(zmax0);
        range.push(range[range.length - 1]);
      }
    }
  }
  return Colorscale.makeColorScaleFunc({
    domain: domain,
    range: range
  }, {
    noNumericCheck: true
  });
};

/***/ }),

/***/ 83545:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var constants = __webpack_require__(53156);

// Calculate all the marching indices, for ALL levels at once.
// since we want to be exhaustive we'll check for contour crossings
// at every intersection, rather than just following a path
// TODO: shorten the inner loop to only the relevant levels
module.exports = function makeCrossings(pathinfo) {
  var z = pathinfo[0].z;
  var m = z.length;
  var n = z[0].length; // we already made sure z isn't ragged in interp2d
  var twoWide = m === 2 || n === 2;
  var xi;
  var yi;
  var startIndices;
  var ystartIndices;
  var label;
  var corners;
  var mi;
  var pi;
  var i;
  for (yi = 0; yi < m - 1; yi++) {
    ystartIndices = [];
    if (yi === 0) ystartIndices = ystartIndices.concat(constants.BOTTOMSTART);
    if (yi === m - 2) ystartIndices = ystartIndices.concat(constants.TOPSTART);
    for (xi = 0; xi < n - 1; xi++) {
      startIndices = ystartIndices.slice();
      if (xi === 0) startIndices = startIndices.concat(constants.LEFTSTART);
      if (xi === n - 2) startIndices = startIndices.concat(constants.RIGHTSTART);
      label = xi + ',' + yi;
      corners = [[z[yi][xi], z[yi][xi + 1]], [z[yi + 1][xi], z[yi + 1][xi + 1]]];
      for (i = 0; i < pathinfo.length; i++) {
        pi = pathinfo[i];
        mi = getMarchingIndex(pi.level, corners);
        if (!mi) continue;
        pi.crossings[label] = mi;
        if (startIndices.indexOf(mi) !== -1) {
          pi.starts.push([xi, yi]);
          if (twoWide && startIndices.indexOf(mi, startIndices.indexOf(mi) + 1) !== -1) {
            // the same square has starts from opposite sides
            // it's not possible to have starts on opposite edges
            // of a corner, only a start and an end...
            // but if the array is only two points wide (either way)
            // you can have starts on opposite sides.
            pi.starts.push([xi, yi]);
          }
        }
      }
    }
  }
};

// modified marching squares algorithm,
// so we disambiguate the saddle points from the start
// and we ignore the cases with no crossings
// the index I'm using is based on:
// http://en.wikipedia.org/wiki/Marching_squares
// except that the saddles bifurcate and I represent them
// as the decimal combination of the two appropriate
// non-saddle indices
function getMarchingIndex(val, corners) {
  var mi = (corners[0][0] > val ? 0 : 1) + (corners[0][1] > val ? 0 : 2) + (corners[1][1] > val ? 0 : 4) + (corners[1][0] > val ? 0 : 8);
  if (mi === 5 || mi === 10) {
    var avg = (corners[0][0] + corners[0][1] + corners[1][0] + corners[1][1]) / 4;
    // two peaks with a big valley
    if (val > avg) return mi === 5 ? 713 : 1114;
    // two valleys with a big ridge
    return mi === 5 ? 104 : 208;
  }
  return mi === 15 ? 0 : mi;
}

/***/ }),

/***/ 8850:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var Lib = __webpack_require__(34809);
var Drawing = __webpack_require__(62203);
var Colorscale = __webpack_require__(88856);
var svgTextUtils = __webpack_require__(30635);
var Axes = __webpack_require__(29714);
var setConvert = __webpack_require__(19091);
var heatmapPlot = __webpack_require__(19236);
var makeCrossings = __webpack_require__(83545);
var findAllPaths = __webpack_require__(27657);
var emptyPathinfo = __webpack_require__(86828);
var convertToConstraints = __webpack_require__(1999);
var closeBoundaries = __webpack_require__(49886);
var constants = __webpack_require__(53156);
var costConstants = constants.LABELOPTIMIZER;
exports.plot = function plot(gd, plotinfo, cdcontours, contourLayer) {
  var xa = plotinfo.xaxis;
  var ya = plotinfo.yaxis;
  Lib.makeTraceGroups(contourLayer, cdcontours, 'contour').each(function (cd) {
    var plotGroup = d3.select(this);
    var cd0 = cd[0];
    var trace = cd0.trace;
    var x = cd0.x;
    var y = cd0.y;
    var contours = trace.contours;
    var pathinfo = emptyPathinfo(contours, plotinfo, cd0);

    // use a heatmap to fill - draw it behind the lines
    var heatmapColoringLayer = Lib.ensureSingle(plotGroup, 'g', 'heatmapcoloring');
    var cdheatmaps = [];
    if (contours.coloring === 'heatmap') {
      cdheatmaps = [cd];
    }
    heatmapPlot(gd, plotinfo, cdheatmaps, heatmapColoringLayer);
    makeCrossings(pathinfo);
    findAllPaths(pathinfo);
    var leftedge = xa.c2p(x[0], true);
    var rightedge = xa.c2p(x[x.length - 1], true);
    var bottomedge = ya.c2p(y[0], true);
    var topedge = ya.c2p(y[y.length - 1], true);
    var perimeter = [[leftedge, topedge], [rightedge, topedge], [rightedge, bottomedge], [leftedge, bottomedge]];
    var fillPathinfo = pathinfo;
    if (contours.type === 'constraint') {
      // N.B. this also mutates pathinfo
      fillPathinfo = convertToConstraints(pathinfo, contours._operation);
    }

    // draw everything
    makeBackground(plotGroup, perimeter, contours);
    makeFills(plotGroup, fillPathinfo, perimeter, contours);
    makeLinesAndLabels(plotGroup, pathinfo, gd, cd0, contours);
    clipGaps(plotGroup, plotinfo, gd, cd0, perimeter);
  });
};
function makeBackground(plotgroup, perimeter, contours) {
  var bggroup = Lib.ensureSingle(plotgroup, 'g', 'contourbg');
  var bgfill = bggroup.selectAll('path').data(contours.coloring === 'fill' ? [0] : []);
  bgfill.enter().append('path');
  bgfill.exit().remove();
  bgfill.attr('d', 'M' + perimeter.join('L') + 'Z').style('stroke', 'none');
}
function makeFills(plotgroup, pathinfo, perimeter, contours) {
  var hasFills = contours.coloring === 'fill' || contours.type === 'constraint' && contours._operation !== '=';
  var boundaryPath = 'M' + perimeter.join('L') + 'Z';

  // fills prefixBoundary in pathinfo items
  if (hasFills) {
    closeBoundaries(pathinfo, contours);
  }
  var fillgroup = Lib.ensureSingle(plotgroup, 'g', 'contourfill');
  var fillitems = fillgroup.selectAll('path').data(hasFills ? pathinfo : []);
  fillitems.enter().append('path');
  fillitems.exit().remove();
  fillitems.each(function (pi) {
    // join all paths for this level together into a single path
    // first follow clockwise around the perimeter to close any open paths
    // if the whole perimeter is above this level, start with a path
    // enclosing the whole thing. With all that, the parity should mean
    // that we always fill everything above the contour, nothing below
    var fullpath = (pi.prefixBoundary ? boundaryPath : '') + joinAllPaths(pi, perimeter);
    if (!fullpath) {
      d3.select(this).remove();
    } else {
      d3.select(this).attr('d', fullpath).style('stroke', 'none');
    }
  });
}
function joinAllPaths(pi, perimeter) {
  var fullpath = '';
  var i = 0;
  var startsleft = pi.edgepaths.map(function (v, i) {
    return i;
  });
  var newloop = true;
  var endpt;
  var newendpt;
  var cnt;
  var nexti;
  var possiblei;
  var addpath;
  function istop(pt) {
    return Math.abs(pt[1] - perimeter[0][1]) < 0.01;
  }
  function isbottom(pt) {
    return Math.abs(pt[1] - perimeter[2][1]) < 0.01;
  }
  function isleft(pt) {
    return Math.abs(pt[0] - perimeter[0][0]) < 0.01;
  }
  function isright(pt) {
    return Math.abs(pt[0] - perimeter[2][0]) < 0.01;
  }
  while (startsleft.length) {
    addpath = Drawing.smoothopen(pi.edgepaths[i], pi.smoothing);
    fullpath += newloop ? addpath : addpath.replace(/^M/, 'L');
    startsleft.splice(startsleft.indexOf(i), 1);
    endpt = pi.edgepaths[i][pi.edgepaths[i].length - 1];
    nexti = -1;

    // now loop through sides, moving our endpoint until we find a new start
    for (cnt = 0; cnt < 4; cnt++) {
      // just to prevent infinite loops
      if (!endpt) {
        Lib.log('Missing end?', i, pi);
        break;
      }
      if (istop(endpt) && !isright(endpt)) newendpt = perimeter[1]; // right top
      else if (isleft(endpt)) newendpt = perimeter[0]; // left top
      else if (isbottom(endpt)) newendpt = perimeter[3]; // right bottom
      else if (isright(endpt)) newendpt = perimeter[2]; // left bottom

      for (possiblei = 0; possiblei < pi.edgepaths.length; possiblei++) {
        var ptNew = pi.edgepaths[possiblei][0];
        // is ptNew on the (horz. or vert.) segment from endpt to newendpt?
        if (Math.abs(endpt[0] - newendpt[0]) < 0.01) {
          if (Math.abs(endpt[0] - ptNew[0]) < 0.01 && (ptNew[1] - endpt[1]) * (newendpt[1] - ptNew[1]) >= 0) {
            newendpt = ptNew;
            nexti = possiblei;
          }
        } else if (Math.abs(endpt[1] - newendpt[1]) < 0.01) {
          if (Math.abs(endpt[1] - ptNew[1]) < 0.01 && (ptNew[0] - endpt[0]) * (newendpt[0] - ptNew[0]) >= 0) {
            newendpt = ptNew;
            nexti = possiblei;
          }
        } else {
          Lib.log('endpt to newendpt is not vert. or horz.', endpt, newendpt, ptNew);
        }
      }
      endpt = newendpt;
      if (nexti >= 0) break;
      fullpath += 'L' + newendpt;
    }
    if (nexti === pi.edgepaths.length) {
      Lib.log('unclosed perimeter path');
      break;
    }
    i = nexti;

    // if we closed back on a loop we already included,
    // close it and start a new loop
    newloop = startsleft.indexOf(i) === -1;
    if (newloop) {
      i = startsleft[0];
      fullpath += 'Z';
    }
  }

  // finally add the interior paths
  for (i = 0; i < pi.paths.length; i++) {
    fullpath += Drawing.smoothclosed(pi.paths[i], pi.smoothing);
  }
  return fullpath;
}
function makeLinesAndLabels(plotgroup, pathinfo, gd, cd0, contours) {
  var isStatic = gd._context.staticPlot;
  var lineContainer = Lib.ensureSingle(plotgroup, 'g', 'contourlines');
  var showLines = contours.showlines !== false;
  var showLabels = contours.showlabels;
  var clipLinesForLabels = showLines && showLabels;

  // Even if we're not going to show lines, we need to create them
  // if we're showing labels, because the fill paths include the perimeter
  // so can't be used to position the labels correctly.
  // In this case we'll remove the lines after making the labels.
  var linegroup = exports.createLines(lineContainer, showLines || showLabels, pathinfo, isStatic);
  var lineClip = exports.createLineClip(lineContainer, clipLinesForLabels, gd, cd0.trace.uid);
  var labelGroup = plotgroup.selectAll('g.contourlabels').data(showLabels ? [0] : []);
  labelGroup.exit().remove();
  labelGroup.enter().append('g').classed('contourlabels', true);
  if (showLabels) {
    var labelClipPathData = [];
    var labelData = [];

    // invalidate the getTextLocation cache in case paths changed
    Lib.clearLocationCache();
    var contourFormat = exports.labelFormatter(gd, cd0);
    var dummyText = Drawing.tester.append('text').attr('data-notex', 1).call(Drawing.font, contours.labelfont);
    var xa = pathinfo[0].xaxis;
    var ya = pathinfo[0].yaxis;
    var xLen = xa._length;
    var yLen = ya._length;
    var xRng = xa.range;
    var yRng = ya.range;
    var xMin = Lib.aggNums(Math.min, null, cd0.x);
    var xMax = Lib.aggNums(Math.max, null, cd0.x);
    var yMin = Lib.aggNums(Math.min, null, cd0.y);
    var yMax = Lib.aggNums(Math.max, null, cd0.y);
    var x0 = Math.max(xa.c2p(xMin, true), 0);
    var x1 = Math.min(xa.c2p(xMax, true), xLen);
    var y0 = Math.max(ya.c2p(yMax, true), 0);
    var y1 = Math.min(ya.c2p(yMin, true), yLen);

    // visible bounds of the contour trace (and the midpoints, to
    // help with cost calculations)
    var bounds = {};
    if (xRng[0] < xRng[1]) {
      bounds.left = x0;
      bounds.right = x1;
    } else {
      bounds.left = x1;
      bounds.right = x0;
    }
    if (yRng[0] < yRng[1]) {
      bounds.top = y0;
      bounds.bottom = y1;
    } else {
      bounds.top = y1;
      bounds.bottom = y0;
    }
    bounds.middle = (bounds.top + bounds.bottom) / 2;
    bounds.center = (bounds.left + bounds.right) / 2;
    labelClipPathData.push([[bounds.left, bounds.top], [bounds.right, bounds.top], [bounds.right, bounds.bottom], [bounds.left, bounds.bottom]]);
    var plotDiagonal = Math.sqrt(xLen * xLen + yLen * yLen);

    // the path length to use to scale the number of labels to draw:
    var normLength = constants.LABELDISTANCE * plotDiagonal / Math.max(1, pathinfo.length / constants.LABELINCREASE);
    linegroup.each(function (d) {
      var textOpts = exports.calcTextOpts(d.level, contourFormat, dummyText, gd);
      d3.select(this).selectAll('path').each(function () {
        var path = this;
        var pathBounds = Lib.getVisibleSegment(path, bounds, textOpts.height / 2);
        if (!pathBounds) return;
        if (pathBounds.len < (textOpts.width + textOpts.height) * constants.LABELMIN) return;
        var maxLabels = Math.min(Math.ceil(pathBounds.len / normLength), constants.LABELMAX);
        for (var i = 0; i < maxLabels; i++) {
          var loc = exports.findBestTextLocation(path, pathBounds, textOpts, labelData, bounds);
          if (!loc) break;
          exports.addLabelData(loc, textOpts, labelData, labelClipPathData);
        }
      });
    });
    dummyText.remove();
    exports.drawLabels(labelGroup, labelData, gd, lineClip, clipLinesForLabels ? labelClipPathData : null);
  }
  if (showLabels && !showLines) linegroup.remove();
}
exports.createLines = function (lineContainer, makeLines, pathinfo, isStatic) {
  var smoothing = pathinfo[0].smoothing;
  var linegroup = lineContainer.selectAll('g.contourlevel').data(makeLines ? pathinfo : []);
  linegroup.exit().remove();
  linegroup.enter().append('g').classed('contourlevel', true);
  if (makeLines) {
    // pedgepaths / ppaths are used by contourcarpet, for the paths transformed from a/b to x/y
    // edgepaths / paths are used by contour since it's in x/y from the start
    var opencontourlines = linegroup.selectAll('path.openline').data(function (d) {
      return d.pedgepaths || d.edgepaths;
    });
    opencontourlines.exit().remove();
    opencontourlines.enter().append('path').classed('openline', true);
    opencontourlines.attr('d', function (d) {
      return Drawing.smoothopen(d, smoothing);
    }).style('stroke-miterlimit', 1).style('vector-effect', isStatic ? 'none' : 'non-scaling-stroke');
    var closedcontourlines = linegroup.selectAll('path.closedline').data(function (d) {
      return d.ppaths || d.paths;
    });
    closedcontourlines.exit().remove();
    closedcontourlines.enter().append('path').classed('closedline', true);
    closedcontourlines.attr('d', function (d) {
      return Drawing.smoothclosed(d, smoothing);
    }).style('stroke-miterlimit', 1).style('vector-effect', isStatic ? 'none' : 'non-scaling-stroke');
  }
  return linegroup;
};
exports.createLineClip = function (lineContainer, clipLinesForLabels, gd, uid) {
  var clips = gd._fullLayout._clips;
  var clipId = clipLinesForLabels ? 'clipline' + uid : null;
  var lineClip = clips.selectAll('#' + clipId).data(clipLinesForLabels ? [0] : []);
  lineClip.exit().remove();
  lineClip.enter().append('clipPath').classed('contourlineclip', true).attr('id', clipId);
  Drawing.setClipUrl(lineContainer, clipId, gd);
  return lineClip;
};
exports.labelFormatter = function (gd, cd0) {
  var fullLayout = gd._fullLayout;
  var trace = cd0.trace;
  var contours = trace.contours;
  var formatAxis = {
    type: 'linear',
    _id: 'ycontour',
    showexponent: 'all',
    exponentformat: 'B'
  };
  if (contours.labelformat) {
    formatAxis.tickformat = contours.labelformat;
    setConvert(formatAxis, fullLayout);
  } else {
    var cOpts = Colorscale.extractOpts(trace);
    if (cOpts && cOpts.colorbar && cOpts.colorbar._axis) {
      formatAxis = cOpts.colorbar._axis;
    } else {
      if (contours.type === 'constraint') {
        var value = contours.value;
        if (Lib.isArrayOrTypedArray(value)) {
          formatAxis.range = [value[0], value[value.length - 1]];
        } else formatAxis.range = [value, value];
      } else {
        formatAxis.range = [contours.start, contours.end];
        formatAxis.nticks = (contours.end - contours.start) / contours.size;
      }
      if (formatAxis.range[0] === formatAxis.range[1]) {
        formatAxis.range[1] += formatAxis.range[0] || 1;
      }
      if (!formatAxis.nticks) formatAxis.nticks = 1000;
      setConvert(formatAxis, fullLayout);
      Axes.prepTicks(formatAxis);
      formatAxis._tmin = null;
      formatAxis._tmax = null;
    }
  }
  return function (v) {
    return Axes.tickText(formatAxis, v).text;
  };
};
exports.calcTextOpts = function (level, contourFormat, dummyText, gd) {
  var text = contourFormat(level);
  dummyText.text(text).call(svgTextUtils.convertToTspans, gd);
  var el = dummyText.node();
  var bBox = Drawing.bBox(el, true);
  return {
    text: text,
    width: bBox.width,
    height: bBox.height,
    fontSize: +el.style['font-size'].replace('px', ''),
    level: level,
    dy: (bBox.top + bBox.bottom) / 2
  };
};
exports.findBestTextLocation = function (path, pathBounds, textOpts, labelData, plotBounds) {
  var textWidth = textOpts.width;
  var p0, dp, pMax, pMin, loc;
  if (pathBounds.isClosed) {
    dp = pathBounds.len / costConstants.INITIALSEARCHPOINTS;
    p0 = pathBounds.min + dp / 2;
    pMax = pathBounds.max;
  } else {
    dp = (pathBounds.len - textWidth) / (costConstants.INITIALSEARCHPOINTS + 1);
    p0 = pathBounds.min + dp + textWidth / 2;
    pMax = pathBounds.max - (dp + textWidth) / 2;
  }
  var cost = Infinity;
  for (var j = 0; j < costConstants.ITERATIONS; j++) {
    for (var p = p0; p < pMax; p += dp) {
      var newLocation = Lib.getTextLocation(path, pathBounds.total, p, textWidth);
      var newCost = locationCost(newLocation, textOpts, labelData, plotBounds);
      if (newCost < cost) {
        cost = newCost;
        loc = newLocation;
        pMin = p;
      }
    }
    if (cost > costConstants.MAXCOST * 2) break;

    // subsequent iterations just look half steps away from the
    // best we found in the previous iteration
    if (j) dp /= 2;
    p0 = pMin - dp / 2;
    pMax = p0 + dp * 1.5;
  }
  if (cost <= costConstants.MAXCOST) return loc;
};

/*
 * locationCost: a cost function for label locations
 * composed of three kinds of penalty:
 * - for open paths, being close to the end of the path
 * - the angle away from horizontal
 * - being too close to already placed neighbors
 */
function locationCost(loc, textOpts, labelData, bounds) {
  var halfWidth = textOpts.width / 2;
  var halfHeight = textOpts.height / 2;
  var x = loc.x;
  var y = loc.y;
  var theta = loc.theta;
  var dx = Math.cos(theta) * halfWidth;
  var dy = Math.sin(theta) * halfWidth;

  // cost for being near an edge
  var normX = (x > bounds.center ? bounds.right - x : x - bounds.left) / (dx + Math.abs(Math.sin(theta) * halfHeight));
  var normY = (y > bounds.middle ? bounds.bottom - y : y - bounds.top) / (Math.abs(dy) + Math.cos(theta) * halfHeight);
  if (normX < 1 || normY < 1) return Infinity;
  var cost = costConstants.EDGECOST * (1 / (normX - 1) + 1 / (normY - 1));

  // cost for not being horizontal
  cost += costConstants.ANGLECOST * theta * theta;

  // cost for being close to other labels
  var x1 = x - dx;
  var y1 = y - dy;
  var x2 = x + dx;
  var y2 = y + dy;
  for (var i = 0; i < labelData.length; i++) {
    var labeli = labelData[i];
    var dxd = Math.cos(labeli.theta) * labeli.width / 2;
    var dyd = Math.sin(labeli.theta) * labeli.width / 2;
    var dist = Lib.segmentDistance(x1, y1, x2, y2, labeli.x - dxd, labeli.y - dyd, labeli.x + dxd, labeli.y + dyd) * 2 / (textOpts.height + labeli.height);
    var sameLevel = labeli.level === textOpts.level;
    var distOffset = sameLevel ? costConstants.SAMELEVELDISTANCE : 1;
    if (dist <= distOffset) return Infinity;
    var distFactor = costConstants.NEIGHBORCOST * (sameLevel ? costConstants.SAMELEVELFACTOR : 1);
    cost += distFactor / (dist - distOffset);
  }
  return cost;
}
exports.addLabelData = function (loc, textOpts, labelData, labelClipPathData) {
  var fontSize = textOpts.fontSize;
  var w = textOpts.width + fontSize / 3;
  var h = Math.max(0, textOpts.height - fontSize / 3);
  var x = loc.x;
  var y = loc.y;
  var theta = loc.theta;
  var sin = Math.sin(theta);
  var cos = Math.cos(theta);
  var rotateXY = function (dx, dy) {
    return [x + dx * cos - dy * sin, y + dx * sin + dy * cos];
  };
  var bBoxPts = [rotateXY(-w / 2, -h / 2), rotateXY(-w / 2, h / 2), rotateXY(w / 2, h / 2), rotateXY(w / 2, -h / 2)];
  labelData.push({
    text: textOpts.text,
    x: x,
    y: y,
    dy: textOpts.dy,
    theta: theta,
    level: textOpts.level,
    width: w,
    height: h
  });
  labelClipPathData.push(bBoxPts);
};
exports.drawLabels = function (labelGroup, labelData, gd, lineClip, labelClipPathData) {
  var labels = labelGroup.selectAll('text').data(labelData, function (d) {
    return d.text + ',' + d.x + ',' + d.y + ',' + d.theta;
  });
  labels.exit().remove();
  labels.enter().append('text').attr({
    'data-notex': 1,
    'text-anchor': 'middle'
  }).each(function (d) {
    var x = d.x + Math.sin(d.theta) * d.dy;
    var y = d.y - Math.cos(d.theta) * d.dy;
    d3.select(this).text(d.text).attr({
      x: x,
      y: y,
      transform: 'rotate(' + 180 * d.theta / Math.PI + ' ' + x + ' ' + y + ')'
    }).call(svgTextUtils.convertToTspans, gd);
  });
  if (labelClipPathData) {
    var clipPath = '';
    for (var i = 0; i < labelClipPathData.length; i++) {
      clipPath += 'M' + labelClipPathData[i].join('L') + 'Z';
    }
    var lineClipPath = Lib.ensureSingle(lineClip, 'path', '');
    lineClipPath.attr('d', clipPath);
  }
};
function clipGaps(plotGroup, plotinfo, gd, cd0, perimeter) {
  var trace = cd0.trace;
  var clips = gd._fullLayout._clips;
  var clipId = 'clip' + trace.uid;
  var clipPath = clips.selectAll('#' + clipId).data(trace.connectgaps ? [] : [0]);
  clipPath.enter().append('clipPath').classed('contourclip', true).attr('id', clipId);
  clipPath.exit().remove();
  if (trace.connectgaps === false) {
    var clipPathInfo = {
      // fraction of the way from missing to present point
      // to draw the boundary.
      // if you make this 1 (or 1-epsilon) then a point in
      // a sea of missing data will disappear entirely.
      level: 0.9,
      crossings: {},
      starts: [],
      edgepaths: [],
      paths: [],
      xaxis: plotinfo.xaxis,
      yaxis: plotinfo.yaxis,
      x: cd0.x,
      y: cd0.y,
      // 0 = no data, 1 = data
      z: makeClipMask(cd0),
      smoothing: 0
    };
    makeCrossings([clipPathInfo]);
    findAllPaths([clipPathInfo]);
    closeBoundaries([clipPathInfo], {
      type: 'levels'
    });
    var path = Lib.ensureSingle(clipPath, 'path', '');
    path.attr('d', (clipPathInfo.prefixBoundary ? 'M' + perimeter.join('L') + 'Z' : '') + joinAllPaths(clipPathInfo, perimeter));
  } else clipId = null;
  Drawing.setClipUrl(plotGroup, clipId, gd);
}
function makeClipMask(cd0) {
  var empties = cd0.trace._emptypoints;
  var z = [];
  var m = cd0.z.length;
  var n = cd0.z[0].length;
  var i;
  var row = [];
  var emptyPoint;
  for (i = 0; i < n; i++) row.push(1);
  for (i = 0; i < m; i++) z.push(row.slice());
  for (i = 0; i < empties.length; i++) {
    emptyPoint = empties[i];
    z[emptyPoint[0]][emptyPoint[1]] = 0;
  }
  // save this mask to determine whether to show this data in hover
  cd0.zmask = z;
  return z;
}

/***/ }),

/***/ 62475:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Axes = __webpack_require__(29714);
var Lib = __webpack_require__(34809);
module.exports = function setContours(trace, vals) {
  var contours = trace.contours;

  // check if we need to auto-choose contour levels
  if (trace.autocontour) {
    // N.B. do not try to use coloraxis cmin/cmax,
    // these values here are meant to remain "per-trace" for now
    var zmin = trace.zmin;
    var zmax = trace.zmax;
    if (trace.zauto || zmin === undefined) {
      zmin = Lib.aggNums(Math.min, null, vals);
    }
    if (trace.zauto || zmax === undefined) {
      zmax = Lib.aggNums(Math.max, null, vals);
    }
    var dummyAx = autoContours(zmin, zmax, trace.ncontours);
    contours.size = dummyAx.dtick;
    contours.start = Axes.tickFirst(dummyAx);
    dummyAx.range.reverse();
    contours.end = Axes.tickFirst(dummyAx);
    if (contours.start === zmin) contours.start += contours.size;
    if (contours.end === zmax) contours.end -= contours.size;

    // if you set a small ncontours, *and* the ends are exactly on zmin/zmax
    // there's an edge case where start > end now. Make sure there's at least
    // one meaningful contour, put it midway between the crossed values
    if (contours.start > contours.end) {
      contours.start = contours.end = (contours.start + contours.end) / 2;
    }

    // copy auto-contour info back to the source data.
    // previously we copied the whole contours object back, but that had
    // other info (coloring, showlines) that should be left to supplyDefaults
    if (!trace._input.contours) trace._input.contours = {};
    Lib.extendFlat(trace._input.contours, {
      start: contours.start,
      end: contours.end,
      size: contours.size
    });
    trace._input.autocontour = true;
  } else if (contours.type !== 'constraint') {
    // sanity checks on manually-supplied start/end/size
    var start = contours.start;
    var end = contours.end;
    var inputContours = trace._input.contours;
    if (start > end) {
      contours.start = inputContours.start = end;
      end = contours.end = inputContours.end = start;
      start = contours.start;
    }
    if (!(contours.size > 0)) {
      var sizeOut;
      if (start === end) sizeOut = 1;else sizeOut = autoContours(start, end, trace.ncontours).dtick;
      inputContours.size = contours.size = sizeOut;
    }
  }
};

/*
 * autoContours: make a dummy axis object with dtick we can use
 * as contours.size, and if needed we can use Axes.tickFirst
 * with this axis object to calculate the start and end too
 *
 * start: the value to start the contours at
 * end: the value to end at (must be > start)
 * ncontours: max number of contours to make, like roughDTick
 *
 * returns: an axis object
 */
function autoContours(start, end, ncontours) {
  var dummyAx = {
    type: 'linear',
    range: [start, end]
  };
  Axes.autoTicks(dummyAx, (end - start) / (ncontours || 15));
  return dummyAx;
}

/***/ }),

/***/ 1328:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var Drawing = __webpack_require__(62203);
var heatmapStyle = __webpack_require__(12774);
var makeColorMap = __webpack_require__(16438);
module.exports = function style(gd) {
  var contours = d3.select(gd).selectAll('g.contour');
  contours.style('opacity', function (d) {
    return d[0].trace.opacity;
  });
  contours.each(function (d) {
    var c = d3.select(this);
    var trace = d[0].trace;
    var contours = trace.contours;
    var line = trace.line;
    var cs = contours.size || 1;
    var start = contours.start;

    // for contourcarpet only - is this a constraint-type contour trace?
    var isConstraintType = contours.type === 'constraint';
    var colorLines = !isConstraintType && contours.coloring === 'lines';
    var colorFills = !isConstraintType && contours.coloring === 'fill';
    var colorMap = colorLines || colorFills ? makeColorMap(trace) : null;
    c.selectAll('g.contourlevel').each(function (d) {
      d3.select(this).selectAll('path').call(Drawing.lineGroupStyle, line.width, colorLines ? colorMap(d.level) : line.color, line.dash);
    });
    var labelFont = contours.labelfont;
    c.selectAll('g.contourlabels text').each(function (d) {
      Drawing.font(d3.select(this), {
        weight: labelFont.weight,
        style: labelFont.style,
        variant: labelFont.variant,
        textcase: labelFont.textcase,
        lineposition: labelFont.lineposition,
        shadow: labelFont.shadow,
        family: labelFont.family,
        size: labelFont.size,
        color: labelFont.color || (colorLines ? colorMap(d.level) : line.color)
      });
    });
    if (isConstraintType) {
      c.selectAll('g.contourfill path').style('fill', trace.fillcolor);
    } else if (colorFills) {
      var firstFill;
      c.selectAll('g.contourfill path').style('fill', function (d) {
        if (firstFill === undefined) firstFill = d.level;
        return colorMap(d.level + 0.5 * cs);
      });
      if (firstFill === undefined) firstFill = start;
      c.selectAll('g.contourbg path').style('fill', colorMap(firstFill - 0.5 * cs));
    }
  });
  heatmapStyle(gd);
};

/***/ }),

/***/ 39889:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var colorscaleDefaults = __webpack_require__(39356);
var handleLabelDefaults = __webpack_require__(20576);
module.exports = function handleStyleDefaults(traceIn, traceOut, coerce, layout, opts) {
  var coloring = coerce('contours.coloring');
  var showLines;
  var lineColor = '';
  if (coloring === 'fill') showLines = coerce('contours.showlines');
  if (showLines !== false) {
    if (coloring !== 'lines') lineColor = coerce('line.color', '#000');
    coerce('line.width', 0.5);
    coerce('line.dash');
  }
  if (coloring !== 'none') {
    // plots/plots always coerces showlegend to true, but in this case
    // we default to false and (by default) show a colorbar instead
    if (traceIn.showlegend !== true) traceOut.showlegend = false;
    traceOut._dfltShowLegend = false;
    colorscaleDefaults(traceIn, traceOut, layout, coerce, {
      prefix: '',
      cLetter: 'z'
    });
  }
  coerce('line.smoothing');
  handleLabelDefaults(coerce, layout, lineColor, opts);
};

/***/ }),

/***/ 66365:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var heatmapAttrs = __webpack_require__(81658);
var contourAttrs = __webpack_require__(52240);
var colorScaleAttrs = __webpack_require__(87163);
var extendFlat = (__webpack_require__(93049).extendFlat);
var contourContourAttrs = contourAttrs.contours;
module.exports = extendFlat({
  carpet: {
    valType: 'string',
    editType: 'calc'
  },
  z: heatmapAttrs.z,
  a: heatmapAttrs.x,
  a0: heatmapAttrs.x0,
  da: heatmapAttrs.dx,
  b: heatmapAttrs.y,
  b0: heatmapAttrs.y0,
  db: heatmapAttrs.dy,
  text: heatmapAttrs.text,
  hovertext: heatmapAttrs.hovertext,
  transpose: heatmapAttrs.transpose,
  atype: heatmapAttrs.xtype,
  btype: heatmapAttrs.ytype,
  fillcolor: contourAttrs.fillcolor,
  autocontour: contourAttrs.autocontour,
  ncontours: contourAttrs.ncontours,
  contours: {
    type: contourContourAttrs.type,
    start: contourContourAttrs.start,
    end: contourContourAttrs.end,
    size: contourContourAttrs.size,
    coloring: {
      // from contourAttrs.contours.coloring but no 'heatmap' option
      valType: 'enumerated',
      values: ['fill', 'lines', 'none'],
      dflt: 'fill',
      editType: 'calc'
    },
    showlines: contourContourAttrs.showlines,
    showlabels: contourContourAttrs.showlabels,
    labelfont: contourContourAttrs.labelfont,
    labelformat: contourContourAttrs.labelformat,
    operation: contourContourAttrs.operation,
    value: contourContourAttrs.value,
    editType: 'calc',
    impliedEdits: {
      autocontour: false
    }
  },
  line: {
    color: contourAttrs.line.color,
    width: contourAttrs.line.width,
    dash: contourAttrs.line.dash,
    smoothing: contourAttrs.line.smoothing,
    editType: 'plot'
  },
  zorder: contourAttrs.zorder,
  transforms: undefined
}, colorScaleAttrs('', {
  cLetter: 'z',
  autoColorDflt: false
}));

/***/ }),

/***/ 80849:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var colorscaleCalc = __webpack_require__(28379);
var Lib = __webpack_require__(34809);
var convertColumnData = __webpack_require__(87869);
var clean2dArray = __webpack_require__(93877);
var interp2d = __webpack_require__(69295);
var findEmpties = __webpack_require__(78106);
var makeBoundArray = __webpack_require__(80924);
var supplyDefaults = __webpack_require__(50538);
var lookupCarpet = __webpack_require__(26571);
var setContours = __webpack_require__(62475);

// most is the same as heatmap calc, then adjust it
// though a few things inside heatmap calc still look for
// contour maps, because the makeBoundArray calls are too entangled
module.exports = function calc(gd, trace) {
  var carpet = trace._carpetTrace = lookupCarpet(gd, trace);
  if (!carpet || !carpet.visible || carpet.visible === 'legendonly') return;
  if (!trace.a || !trace.b) {
    // Look up the original incoming carpet data:
    var carpetdata = gd.data[carpet.index];

    // Look up the incoming trace data, *except* perform a shallow
    // copy so that we're not actually modifying it when we use it
    // to supply defaults:
    var tracedata = gd.data[trace.index];
    // var tracedata = extendFlat({}, gd.data[trace.index]);

    // If the data is not specified
    if (!tracedata.a) tracedata.a = carpetdata.a;
    if (!tracedata.b) tracedata.b = carpetdata.b;
    supplyDefaults(tracedata, trace, trace._defaultColor, gd._fullLayout);
  }
  var cd = heatmappishCalc(gd, trace);
  setContours(trace, trace._z);
  return cd;
};
function heatmappishCalc(gd, trace) {
  // prepare the raw data
  // run makeCalcdata on x and y even for heatmaps, in case of category mappings
  var carpet = trace._carpetTrace;
  var aax = carpet.aaxis;
  var bax = carpet.baxis;
  var a, a0, da, b, b0, db, z;

  // cancel minimum tick spacings (only applies to bars and boxes)
  aax._minDtick = 0;
  bax._minDtick = 0;
  if (Lib.isArray1D(trace.z)) convertColumnData(trace, aax, bax, 'a', 'b', ['z']);
  a = trace._a = trace._a || trace.a;
  b = trace._b = trace._b || trace.b;
  a = a ? aax.makeCalcdata(trace, '_a') : [];
  b = b ? bax.makeCalcdata(trace, '_b') : [];
  a0 = trace.a0 || 0;
  da = trace.da || 1;
  b0 = trace.b0 || 0;
  db = trace.db || 1;
  z = trace._z = clean2dArray(trace._z || trace.z, trace.transpose);
  trace._emptypoints = findEmpties(z);
  interp2d(z, trace._emptypoints);

  // create arrays of brick boundaries, to be used by autorange and heatmap.plot
  var xlen = Lib.maxRowLength(z);
  var xIn = trace.xtype === 'scaled' ? '' : a;
  var xArray = makeBoundArray(trace, xIn, a0, da, xlen, aax);
  var yIn = trace.ytype === 'scaled' ? '' : b;
  var yArray = makeBoundArray(trace, yIn, b0, db, z.length, bax);
  var cd0 = {
    a: xArray,
    b: yArray,
    z: z
  };
  if (trace.contours.type === 'levels' && trace.contours.coloring !== 'none') {
    // auto-z and autocolorscale if applicable
    colorscaleCalc(gd, trace, {
      vals: z,
      containerStr: '',
      cLetter: 'z'
    });
  }
  return [cd0];
}

/***/ }),

/***/ 50538:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var handleXYZDefaults = __webpack_require__(86073);
var attributes = __webpack_require__(66365);
var handleConstraintDefaults = __webpack_require__(29503);
var handleContoursDefaults = __webpack_require__(47495);
var handleStyleDefaults = __webpack_require__(39889);
module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
  function coerce(attr, dflt) {
    return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
  }
  function coerce2(attr) {
    return Lib.coerce2(traceIn, traceOut, attributes, attr);
  }
  coerce('carpet');

  // If either a or b is not present, then it's not a valid trace *unless* the carpet
  // axis has the a or b values we're looking for. So if these are not found, just defer
  // that decision until the calc step.
  //
  // NB: the calc step will modify the original data input by assigning whichever of
  // a or b are missing. This is necessary because panning goes right from supplyDefaults
  // to plot (skipping calc). That means on subsequent updates, this *will* need to be
  // able to find a and b.
  //
  // The long-term proper fix is that this should perhaps use underscored attributes to
  // at least modify the user input to a slightly lesser extent. Fully removing the
  // input mutation is challenging. The underscore approach is not currently taken since
  // it requires modification to all of the functions below that expect the coerced
  // attribute name to match the property name -- except '_a' !== 'a' so that is not
  // straightforward.
  if (traceIn.a && traceIn.b) {
    var len = handleXYZDefaults(traceIn, traceOut, coerce, layout, 'a', 'b');
    if (!len) {
      traceOut.visible = false;
      return;
    }
    coerce('text');
    var isConstraint = coerce('contours.type') === 'constraint';
    if (isConstraint) {
      handleConstraintDefaults(traceIn, traceOut, coerce, layout, defaultColor, {
        hasHover: false
      });
    } else {
      handleContoursDefaults(traceIn, traceOut, coerce, coerce2);
      handleStyleDefaults(traceIn, traceOut, coerce, layout, {
        hasHover: false
      });
    }
  } else {
    traceOut._defaultColor = defaultColor;
    traceOut._length = null;
  }
  coerce('zorder');
};

/***/ }),

/***/ 34406:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = {
  attributes: __webpack_require__(66365),
  supplyDefaults: __webpack_require__(50538),
  colorbar: __webpack_require__(92697),
  calc: __webpack_require__(80849),
  plot: __webpack_require__(71815),
  style: __webpack_require__(1328),
  moduleType: 'trace',
  name: 'contourcarpet',
  basePlotModule: __webpack_require__(37703),
  categories: ['cartesian', 'svg', 'carpet', 'contour', 'symbols', 'showLegend', 'hasLines', 'carpetDependent', 'noHover', 'noSortingByValue'],
  meta: {}
};

/***/ }),

/***/ 71815:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var map1dArray = __webpack_require__(6720);
var makepath = __webpack_require__(3685);
var Drawing = __webpack_require__(62203);
var Lib = __webpack_require__(34809);
var makeCrossings = __webpack_require__(83545);
var findAllPaths = __webpack_require__(27657);
var contourPlot = __webpack_require__(8850);
var constants = __webpack_require__(53156);
var convertToConstraints = __webpack_require__(1999);
var emptyPathinfo = __webpack_require__(86828);
var closeBoundaries = __webpack_require__(49886);
var lookupCarpet = __webpack_require__(26571);
var axisAlignedLine = __webpack_require__(94903);
module.exports = function plot(gd, plotinfo, cdcontours, contourcarpetLayer) {
  var xa = plotinfo.xaxis;
  var ya = plotinfo.yaxis;
  Lib.makeTraceGroups(contourcarpetLayer, cdcontours, 'contour').each(function (cd) {
    var plotGroup = d3.select(this);
    var cd0 = cd[0];
    var trace = cd0.trace;
    var carpet = trace._carpetTrace = lookupCarpet(gd, trace);
    var carpetcd = gd.calcdata[carpet.index][0];
    if (!carpet.visible || carpet.visible === 'legendonly') return;
    var a = cd0.a;
    var b = cd0.b;
    var contours = trace.contours;
    var pathinfo = emptyPathinfo(contours, plotinfo, cd0);
    var isConstraint = contours.type === 'constraint';
    var operation = contours._operation;
    var coloring = isConstraint ? operation === '=' ? 'lines' : 'fill' : contours.coloring;

    // Map [a, b] (data) --> [i, j] (pixels)
    function ab2p(ab) {
      var pt = carpet.ab2xy(ab[0], ab[1], true);
      return [xa.c2p(pt[0]), ya.c2p(pt[1])];
    }

    // Define the perimeter in a/b coordinates:
    var perimeter = [[a[0], b[b.length - 1]], [a[a.length - 1], b[b.length - 1]], [a[a.length - 1], b[0]], [a[0], b[0]]];

    // Extract the contour levels:
    makeCrossings(pathinfo);
    var atol = (a[a.length - 1] - a[0]) * 1e-8;
    var btol = (b[b.length - 1] - b[0]) * 1e-8;
    findAllPaths(pathinfo, atol, btol);

    // Constraints might need to be draw inverted, which is not something contours
    // handle by default since they're assumed fully opaque so that they can be
    // drawn overlapping. This function flips the paths as necessary so that they're
    // drawn correctly.
    //
    // TODO: Perhaps this should be generalized and *all* paths should be drawn as
    // closed regions so that translucent contour levels would be valid.
    // See: https://github.com/plotly/plotly.js/issues/1356
    var fillPathinfo = pathinfo;
    if (contours.type === 'constraint') {
      fillPathinfo = convertToConstraints(pathinfo, operation);
    }

    // Map the paths in a/b coordinates to pixel coordinates:
    mapPathinfo(pathinfo, ab2p);

    // draw everything

    // Compute the boundary path
    var seg, xp, yp, i;
    var segs = [];
    for (i = carpetcd.clipsegments.length - 1; i >= 0; i--) {
      seg = carpetcd.clipsegments[i];
      xp = map1dArray([], seg.x, xa.c2p);
      yp = map1dArray([], seg.y, ya.c2p);
      xp.reverse();
      yp.reverse();
      segs.push(makepath(xp, yp, seg.bicubic));
    }
    var boundaryPath = 'M' + segs.join('L') + 'Z';

    // Draw the baseline background fill that fills in the space behind any other
    // contour levels:
    makeBackground(plotGroup, carpetcd.clipsegments, xa, ya, isConstraint, coloring);

    // Draw the specific contour fills. As a simplification, they're assumed to be
    // fully opaque so that it's easy to draw them simply overlapping. The alternative
    // would be to flip adjacent paths and draw closed paths for each level instead.
    makeFills(trace, plotGroup, xa, ya, fillPathinfo, perimeter, ab2p, carpet, carpetcd, coloring, boundaryPath);

    // Draw contour lines:
    makeLinesAndLabels(plotGroup, pathinfo, gd, cd0, contours, plotinfo, carpet);

    // Clip the boundary of the plot
    Drawing.setClipUrl(plotGroup, carpet._clipPathId, gd);
  });
};
function mapPathinfo(pathinfo, map) {
  var i, j, k, pi, pedgepaths, ppaths, pedgepath, ppath, path;
  for (i = 0; i < pathinfo.length; i++) {
    pi = pathinfo[i];
    pedgepaths = pi.pedgepaths = [];
    ppaths = pi.ppaths = [];
    for (j = 0; j < pi.edgepaths.length; j++) {
      path = pi.edgepaths[j];
      pedgepath = [];
      for (k = 0; k < path.length; k++) {
        pedgepath[k] = map(path[k]);
      }
      pedgepaths.push(pedgepath);
    }
    for (j = 0; j < pi.paths.length; j++) {
      path = pi.paths[j];
      ppath = [];
      for (k = 0; k < path.length; k++) {
        ppath[k] = map(path[k]);
      }
      ppaths.push(ppath);
    }
  }
}
function makeLinesAndLabels(plotgroup, pathinfo, gd, cd0, contours, plotinfo, carpet) {
  var isStatic = gd._context.staticPlot;
  var lineContainer = Lib.ensureSingle(plotgroup, 'g', 'contourlines');
  var showLines = contours.showlines !== false;
  var showLabels = contours.showlabels;
  var clipLinesForLabels = showLines && showLabels;

  // Even if we're not going to show lines, we need to create them
  // if we're showing labels, because the fill paths include the perimeter
  // so can't be used to position the labels correctly.
  // In this case we'll remove the lines after making the labels.
  var linegroup = contourPlot.createLines(lineContainer, showLines || showLabels, pathinfo, isStatic);
  var lineClip = contourPlot.createLineClip(lineContainer, clipLinesForLabels, gd, cd0.trace.uid);
  var labelGroup = plotgroup.selectAll('g.contourlabels').data(showLabels ? [0] : []);
  labelGroup.exit().remove();
  labelGroup.enter().append('g').classed('contourlabels', true);
  if (showLabels) {
    var xa = plotinfo.xaxis;
    var ya = plotinfo.yaxis;
    var xLen = xa._length;
    var yLen = ya._length;
    // for simplicity use the xy box for label clipping outline.
    var labelClipPathData = [[[0, 0], [xLen, 0], [xLen, yLen], [0, yLen]]];
    var labelData = [];

    // invalidate the getTextLocation cache in case paths changed
    Lib.clearLocationCache();
    var contourFormat = contourPlot.labelFormatter(gd, cd0);
    var dummyText = Drawing.tester.append('text').attr('data-notex', 1).call(Drawing.font, contours.labelfont);

    // use `bounds` only to keep labels away from the x/y boundaries
    // `constrainToCarpet` below ensures labels don't go off the
    // carpet edges
    var bounds = {
      left: 0,
      right: xLen,
      center: xLen / 2,
      top: 0,
      bottom: yLen,
      middle: yLen / 2
    };
    var plotDiagonal = Math.sqrt(xLen * xLen + yLen * yLen);

    // the path length to use to scale the number of labels to draw:
    var normLength = constants.LABELDISTANCE * plotDiagonal / Math.max(1, pathinfo.length / constants.LABELINCREASE);
    linegroup.each(function (d) {
      var textOpts = contourPlot.calcTextOpts(d.level, contourFormat, dummyText, gd);
      d3.select(this).selectAll('path').each(function (pathData) {
        var path = this;
        var pathBounds = Lib.getVisibleSegment(path, bounds, textOpts.height / 2);
        if (!pathBounds) return;
        constrainToCarpet(path, pathData, d, pathBounds, carpet, textOpts.height);
        if (pathBounds.len < (textOpts.width + textOpts.height) * constants.LABELMIN) return;
        var maxLabels = Math.min(Math.ceil(pathBounds.len / normLength), constants.LABELMAX);
        for (var i = 0; i < maxLabels; i++) {
          var loc = contourPlot.findBestTextLocation(path, pathBounds, textOpts, labelData, bounds);
          if (!loc) break;
          contourPlot.addLabelData(loc, textOpts, labelData, labelClipPathData);
        }
      });
    });
    dummyText.remove();
    contourPlot.drawLabels(labelGroup, labelData, gd, lineClip, clipLinesForLabels ? labelClipPathData : null);
  }
  if (showLabels && !showLines) linegroup.remove();
}

// figure out if this path goes off the edge of the carpet
// and shorten the part we call visible to keep labels away from the edge
function constrainToCarpet(path, pathData, levelData, pathBounds, carpet, textHeight) {
  var pathABData;
  for (var i = 0; i < levelData.pedgepaths.length; i++) {
    if (pathData === levelData.pedgepaths[i]) {
      pathABData = levelData.edgepaths[i];
    }
  }
  if (!pathABData) return;
  var aMin = carpet.a[0];
  var aMax = carpet.a[carpet.a.length - 1];
  var bMin = carpet.b[0];
  var bMax = carpet.b[carpet.b.length - 1];
  function getOffset(abPt, pathVector) {
    var offset = 0;
    var edgeVector;
    var dAB = 0.1;
    if (Math.abs(abPt[0] - aMin) < dAB || Math.abs(abPt[0] - aMax) < dAB) {
      edgeVector = normalizeVector(carpet.dxydb_rough(abPt[0], abPt[1], dAB));
      offset = Math.max(offset, textHeight * vectorTan(pathVector, edgeVector) / 2);
    }
    if (Math.abs(abPt[1] - bMin) < dAB || Math.abs(abPt[1] - bMax) < dAB) {
      edgeVector = normalizeVector(carpet.dxyda_rough(abPt[0], abPt[1], dAB));
      offset = Math.max(offset, textHeight * vectorTan(pathVector, edgeVector) / 2);
    }
    return offset;
  }
  var startVector = getUnitVector(path, 0, 1);
  var endVector = getUnitVector(path, pathBounds.total, pathBounds.total - 1);
  var minStart = getOffset(pathABData[0], startVector);
  var maxEnd = pathBounds.total - getOffset(pathABData[pathABData.length - 1], endVector);
  if (pathBounds.min < minStart) pathBounds.min = minStart;
  if (pathBounds.max > maxEnd) pathBounds.max = maxEnd;
  pathBounds.len = pathBounds.max - pathBounds.min;
}
function getUnitVector(path, p0, p1) {
  var pt0 = path.getPointAtLength(p0);
  var pt1 = path.getPointAtLength(p1);
  var dx = pt1.x - pt0.x;
  var dy = pt1.y - pt0.y;
  var len = Math.sqrt(dx * dx + dy * dy);
  return [dx / len, dy / len];
}
function normalizeVector(v) {
  var len = Math.sqrt(v[0] * v[0] + v[1] * v[1]);
  return [v[0] / len, v[1] / len];
}
function vectorTan(v0, v1) {
  var cos = Math.abs(v0[0] * v1[0] + v0[1] * v1[1]);
  var sin = Math.sqrt(1 - cos * cos);
  return sin / cos;
}
function makeBackground(plotgroup, clipsegments, xaxis, yaxis, isConstraint, coloring) {
  var seg, xp, yp, i;
  var bggroup = Lib.ensureSingle(plotgroup, 'g', 'contourbg');
  var bgfill = bggroup.selectAll('path').data(coloring === 'fill' && !isConstraint ? [0] : []);
  bgfill.enter().append('path');
  bgfill.exit().remove();
  var segs = [];
  for (i = 0; i < clipsegments.length; i++) {
    seg = clipsegments[i];
    xp = map1dArray([], seg.x, xaxis.c2p);
    yp = map1dArray([], seg.y, yaxis.c2p);
    segs.push(makepath(xp, yp, seg.bicubic));
  }
  bgfill.attr('d', 'M' + segs.join('L') + 'Z').style('stroke', 'none');
}
function makeFills(trace, plotgroup, xa, ya, pathinfo, perimeter, ab2p, carpet, carpetcd, coloring, boundaryPath) {
  var hasFills = coloring === 'fill';

  // fills prefixBoundary in pathinfo items
  if (hasFills) {
    closeBoundaries(pathinfo, trace.contours);
  }
  var fillgroup = Lib.ensureSingle(plotgroup, 'g', 'contourfill');
  var fillitems = fillgroup.selectAll('path').data(hasFills ? pathinfo : []);
  fillitems.enter().append('path');
  fillitems.exit().remove();
  fillitems.each(function (pi) {
    // join all paths for this level together into a single path
    // first follow clockwise around the perimeter to close any open paths
    // if the whole perimeter is above this level, start with a path
    // enclosing the whole thing. With all that, the parity should mean
    // that we always fill everything above the contour, nothing below
    var fullpath = (pi.prefixBoundary ? boundaryPath : '') + joinAllPaths(trace, pi, perimeter, ab2p, carpet, carpetcd, xa, ya);
    if (!fullpath) {
      d3.select(this).remove();
    } else {
      d3.select(this).attr('d', fullpath).style('stroke', 'none');
    }
  });
}
function joinAllPaths(trace, pi, perimeter, ab2p, carpet, carpetcd, xa, ya) {
  var i;
  var fullpath = '';
  var startsleft = pi.edgepaths.map(function (v, i) {
    return i;
  });
  var newloop = true;
  var endpt, newendpt, cnt, nexti, possiblei, addpath;
  var atol = Math.abs(perimeter[0][0] - perimeter[2][0]) * 1e-4;
  var btol = Math.abs(perimeter[0][1] - perimeter[2][1]) * 1e-4;
  function istop(pt) {
    return Math.abs(pt[1] - perimeter[0][1]) < btol;
  }
  function isbottom(pt) {
    return Math.abs(pt[1] - perimeter[2][1]) < btol;
  }
  function isleft(pt) {
    return Math.abs(pt[0] - perimeter[0][0]) < atol;
  }
  function isright(pt) {
    return Math.abs(pt[0] - perimeter[2][0]) < atol;
  }
  function pathto(pt0, pt1) {
    var i, j, segments, axis;
    var path = '';
    if (istop(pt0) && !isright(pt0) || isbottom(pt0) && !isleft(pt0)) {
      axis = carpet.aaxis;
      segments = axisAlignedLine(carpet, carpetcd, [pt0[0], pt1[0]], 0.5 * (pt0[1] + pt1[1]));
    } else {
      axis = carpet.baxis;
      segments = axisAlignedLine(carpet, carpetcd, 0.5 * (pt0[0] + pt1[0]), [pt0[1], pt1[1]]);
    }
    for (i = 1; i < segments.length; i++) {
      path += axis.smoothing ? 'C' : 'L';
      for (j = 0; j < segments[i].length; j++) {
        var pt = segments[i][j];
        path += [xa.c2p(pt[0]), ya.c2p(pt[1])] + ' ';
      }
    }
    return path;
  }
  i = 0;
  endpt = null;
  while (startsleft.length) {
    var startpt = pi.edgepaths[i][0];
    if (endpt) {
      fullpath += pathto(endpt, startpt);
    }
    addpath = Drawing.smoothopen(pi.edgepaths[i].map(ab2p), pi.smoothing);
    fullpath += newloop ? addpath : addpath.replace(/^M/, 'L');
    startsleft.splice(startsleft.indexOf(i), 1);
    endpt = pi.edgepaths[i][pi.edgepaths[i].length - 1];
    nexti = -1;

    // now loop through sides, moving our endpoint until we find a new start
    for (cnt = 0; cnt < 4; cnt++) {
      // just to prevent infinite loops
      if (!endpt) {
        Lib.log('Missing end?', i, pi);
        break;
      }
      if (istop(endpt) && !isright(endpt)) {
        newendpt = perimeter[1]; // left top ---> right top
      } else if (isleft(endpt)) {
        newendpt = perimeter[0]; // left bottom ---> left top
      } else if (isbottom(endpt)) {
        newendpt = perimeter[3]; // right bottom
      } else if (isright(endpt)) {
        newendpt = perimeter[2]; // left bottom
      }
      for (possiblei = 0; possiblei < pi.edgepaths.length; possiblei++) {
        var ptNew = pi.edgepaths[possiblei][0];
        // is ptNew on the (horz. or vert.) segment from endpt to newendpt?
        if (Math.abs(endpt[0] - newendpt[0]) < atol) {
          if (Math.abs(endpt[0] - ptNew[0]) < atol && (ptNew[1] - endpt[1]) * (newendpt[1] - ptNew[1]) >= 0) {
            newendpt = ptNew;
            nexti = possiblei;
          }
        } else if (Math.abs(endpt[1] - newendpt[1]) < btol) {
          if (Math.abs(endpt[1] - ptNew[1]) < btol && (ptNew[0] - endpt[0]) * (newendpt[0] - ptNew[0]) >= 0) {
            newendpt = ptNew;
            nexti = possiblei;
          }
        } else {
          Lib.log('endpt to newendpt is not vert. or horz.', endpt, newendpt, ptNew);
        }
      }
      if (nexti >= 0) break;
      fullpath += pathto(endpt, newendpt);
      endpt = newendpt;
    }
    if (nexti === pi.edgepaths.length) {
      Lib.log('unclosed perimeter path');
      break;
    }
    i = nexti;

    // if we closed back on a loop we already included,
    // close it and start a new loop
    newloop = startsleft.indexOf(i) === -1;
    if (newloop) {
      i = startsleft[0];
      fullpath += pathto(endpt, newendpt) + 'Z';
      endpt = null;
    }
  }

  // finally add the interior paths
  for (i = 0; i < pi.paths.length; i++) {
    fullpath += Drawing.smoothclosed(pi.paths[i].map(ab2p), pi.smoothing);
  }
  return fullpath;
}

/***/ }),

/***/ 70690:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var colorScaleAttrs = __webpack_require__(87163);
var hovertemplateAttrs = (__webpack_require__(3208)/* .hovertemplateAttrs */ .rb);
var baseAttrs = __webpack_require__(9829);
var scatterMapAttrs = __webpack_require__(71388);
var extendFlat = (__webpack_require__(93049).extendFlat);

/*
 * - https://docs.map.com/help/tutorials/make-a-heatmap-with-mapbox-gl-js/
 * - https://docs.mapbox.com/mapbox-gl-js/example/heatmap-layer/
 * - https://docs.mapbox.com/mapbox-gl-js/style-spec/#layers-heatmap
 * - https://blog.map.com/introducing-heatmaps-in-mapbox-gl-js-71355ada9e6c
 *
 * Gotchas:
 * - https://github.com/mapbox/mapbox-gl-js/issues/6463
 * - https://github.com/mapbox/mapbox-gl-js/issues/6112
 */

/*
 *
 * In mathematical terms, Map GL heatmaps are a bivariate (2D) kernel density
 * estimation with a Gaussian kernel. It means that each data point has an area
 * of “influence” around it (called a kernel) where the numerical value of
 * influence (which we call density) decreases as you go further from the point.
 * If we sum density values of all points in every pixel of the screen, we get a
 * combined density value which we then map to a heatmap color.
 *
 */

module.exports = extendFlat({
  lon: scatterMapAttrs.lon,
  lat: scatterMapAttrs.lat,
  z: {
    valType: 'data_array',
    editType: 'calc'
  },
  radius: {
    valType: 'number',
    editType: 'plot',
    arrayOk: true,
    min: 1,
    dflt: 30
  },
  below: {
    valType: 'string',
    editType: 'plot'
  },
  text: scatterMapAttrs.text,
  hovertext: scatterMapAttrs.hovertext,
  hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
    flags: ['lon', 'lat', 'z', 'text', 'name']
  }),
  hovertemplate: hovertemplateAttrs(),
  showlegend: extendFlat({}, baseAttrs.showlegend, {
    dflt: false
  })
}, colorScaleAttrs('', {
  cLetter: 'z',
  editTypeOverride: 'calc'
}));

/***/ }),

/***/ 91582:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isNumeric = __webpack_require__(10721);
var isArrayOrTypedArray = (__webpack_require__(34809).isArrayOrTypedArray);
var BADNUM = (__webpack_require__(63821).BADNUM);
var colorscaleCalc = __webpack_require__(28379);
var _ = (__webpack_require__(34809)._);
module.exports = function calc(gd, trace) {
  var len = trace._length;
  var calcTrace = new Array(len);
  var z = trace.z;
  var hasZ = isArrayOrTypedArray(z) && z.length;
  for (var i = 0; i < len; i++) {
    var cdi = calcTrace[i] = {};
    var lon = trace.lon[i];
    var lat = trace.lat[i];
    cdi.lonlat = isNumeric(lon) && isNumeric(lat) ? [+lon, +lat] : [BADNUM, BADNUM];
    if (hasZ) {
      var zi = z[i];
      cdi.z = isNumeric(zi) ? zi : BADNUM;
    }
  }
  colorscaleCalc(gd, trace, {
    vals: hasZ ? z : [0, 1],
    containerStr: '',
    cLetter: 'z'
  });
  if (len) {
    calcTrace[0].t = {
      labels: {
        lat: _(gd, 'lat:') + ' ',
        lon: _(gd, 'lon:') + ' '
      }
    };
  }
  return calcTrace;
};

/***/ }),

/***/ 95012:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isNumeric = __webpack_require__(10721);
var Lib = __webpack_require__(34809);
var Color = __webpack_require__(78766);
var Colorscale = __webpack_require__(88856);
var BADNUM = (__webpack_require__(63821).BADNUM);
var makeBlank = (__webpack_require__(39532).makeBlank);
module.exports = function convert(calcTrace) {
  var trace = calcTrace[0].trace;
  var isVisible = trace.visible === true && trace._length !== 0;
  var heatmap = {
    layout: {
      visibility: 'none'
    },
    paint: {}
  };
  var opts = trace._opts = {
    heatmap: heatmap,
    geojson: makeBlank()
  };

  // early return if not visible or placeholder
  if (!isVisible) return opts;
  var features = [];
  var i;
  var z = trace.z;
  var radius = trace.radius;
  var hasZ = Lib.isArrayOrTypedArray(z) && z.length;
  var hasArrayRadius = Lib.isArrayOrTypedArray(radius);
  for (i = 0; i < calcTrace.length; i++) {
    var cdi = calcTrace[i];
    var lonlat = cdi.lonlat;
    if (lonlat[0] !== BADNUM) {
      var props = {};
      if (hasZ) {
        var zi = cdi.z;
        props.z = zi !== BADNUM ? zi : 0;
      }
      if (hasArrayRadius) {
        props.r = isNumeric(radius[i]) && radius[i] > 0 ? +radius[i] : 0;
      }
      features.push({
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: lonlat
        },
        properties: props
      });
    }
  }
  var cOpts = Colorscale.extractOpts(trace);
  var scl = cOpts.reversescale ? Colorscale.flipScale(cOpts.colorscale) : cOpts.colorscale;

  // Add alpha channel to first colorscale step.
  // If not, we would essentially color the entire map.
  // See https://maplibre.org/maplibre-gl-js/docs/examples/heatmap-layer/
  var scl01 = scl[0][1];
  var color0 = Color.opacity(scl01) < 1 ? scl01 : Color.addOpacity(scl01, 0);
  var heatmapColor = ['interpolate', ['linear'], ['heatmap-density'], 0, color0];
  for (i = 1; i < scl.length; i++) {
    heatmapColor.push(scl[i][0], scl[i][1]);
  }

  // Those "weights" have to be in [0, 1], we can do this either:
  // - as here using a map-gl expression
  // - or, scale the 'z' property in the feature loop
  var zExp = ['interpolate', ['linear'], ['get', 'z'], cOpts.min, 0, cOpts.max, 1];
  Lib.extendFlat(opts.heatmap.paint, {
    'heatmap-weight': hasZ ? zExp : 1 / (cOpts.max - cOpts.min),
    'heatmap-color': heatmapColor,
    'heatmap-radius': hasArrayRadius ? {
      type: 'identity',
      property: 'r'
    } : trace.radius,
    'heatmap-opacity': trace.opacity
  });
  opts.geojson = {
    type: 'FeatureCollection',
    features: features
  };
  opts.heatmap.layout.visibility = 'visible';
  return opts;
};

/***/ }),

/***/ 9653:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var colorscaleDefaults = __webpack_require__(39356);
var attributes = __webpack_require__(70690);
module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
  function coerce(attr, dflt) {
    return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
  }
  var lon = coerce('lon') || [];
  var lat = coerce('lat') || [];
  var len = Math.min(lon.length, lat.length);
  if (!len) {
    traceOut.visible = false;
    return;
  }
  traceOut._length = len;
  coerce('z');
  coerce('radius');
  coerce('below');
  coerce('text');
  coerce('hovertext');
  coerce('hovertemplate');
  colorscaleDefaults(traceIn, traceOut, layout, coerce, {
    prefix: '',
    cLetter: 'z'
  });
};

/***/ }),

/***/ 16302:
/***/ (function(module) {

"use strict";


module.exports = function eventData(out, pt) {
  out.lon = pt.lon;
  out.lat = pt.lat;
  out.z = pt.z;
  return out;
};

/***/ }),

/***/ 28045:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Axes = __webpack_require__(29714);
var scatterMapHoverPoints = (__webpack_require__(67275).hoverPoints);
var getExtraText = (__webpack_require__(67275).getExtraText);
module.exports = function hoverPoints(pointData, xval, yval) {
  var pts = scatterMapHoverPoints(pointData, xval, yval);
  if (!pts) return;
  var newPointData = pts[0];
  var cd = newPointData.cd;
  var trace = cd[0].trace;
  var di = cd[newPointData.index];

  // let Fx.hover pick the color
  delete newPointData.color;
  if ('z' in di) {
    var ax = newPointData.subplot.mockAxis;
    newPointData.z = di.z;
    newPointData.zLabel = Axes.tickText(ax, ax.c2l(di.z), 'hover').text;
  }
  newPointData.extraText = getExtraText(trace, di, cd[0].t.labels);
  return [newPointData];
};

/***/ }),

/***/ 91995:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = {
  attributes: __webpack_require__(70690),
  supplyDefaults: __webpack_require__(9653),
  colorbar: __webpack_require__(12431),
  formatLabels: __webpack_require__(66762),
  calc: __webpack_require__(91582),
  plot: __webpack_require__(99932),
  hoverPoints: __webpack_require__(28045),
  eventData: __webpack_require__(16302),
  getBelow: function (trace, subplot) {
    var mapLayers = subplot.getMapLayers();

    // find first layer with `type: 'symbol'`,
    // that is not a plotly layer
    for (var i = 0; i < mapLayers.length; i++) {
      var layer = mapLayers[i];
      var layerId = layer.id;
      if (layer.type === 'symbol' && typeof layerId === 'string' && layerId.indexOf('plotly-') === -1) {
        return layerId;
      }
    }
  },
  moduleType: 'trace',
  name: 'densitymap',
  basePlotModule: __webpack_require__(34091),
  categories: ['map', 'gl', 'showLegend'],
  meta: {
    hr_name: 'density_map'
  }
};

/***/ }),

/***/ 99932:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var convert = __webpack_require__(95012);
var LAYER_PREFIX = (__webpack_require__(8814).traceLayerPrefix);
function DensityMap(subplot, uid) {
  this.type = 'densitymap';
  this.subplot = subplot;
  this.uid = uid;
  this.sourceId = 'source-' + uid;
  this.layerList = [['heatmap', LAYER_PREFIX + uid + '-heatmap']];

  // previous 'below' value,
  // need this to update it properly
  this.below = null;
}
var proto = DensityMap.prototype;
proto.update = function (calcTrace) {
  var subplot = this.subplot;
  var layerList = this.layerList;
  var optsAll = convert(calcTrace);
  var below = subplot.belowLookup['trace-' + this.uid];
  subplot.map.getSource(this.sourceId).setData(optsAll.geojson);
  if (below !== this.below) {
    this._removeLayers();
    this._addLayers(optsAll, below);
    this.below = below;
  }
  for (var i = 0; i < layerList.length; i++) {
    var item = layerList[i];
    var k = item[0];
    var id = item[1];
    var opts = optsAll[k];
    subplot.setOptions(id, 'setLayoutProperty', opts.layout);
    if (opts.layout.visibility === 'visible') {
      subplot.setOptions(id, 'setPaintProperty', opts.paint);
    }
  }
};
proto._addLayers = function (optsAll, below) {
  var subplot = this.subplot;
  var layerList = this.layerList;
  var sourceId = this.sourceId;
  for (var i = 0; i < layerList.length; i++) {
    var item = layerList[i];
    var k = item[0];
    var opts = optsAll[k];
    subplot.addLayer({
      type: k,
      id: item[1],
      source: sourceId,
      layout: opts.layout,
      paint: opts.paint
    }, below);
  }
};
proto._removeLayers = function () {
  var map = this.subplot.map;
  var layerList = this.layerList;
  for (var i = layerList.length - 1; i >= 0; i--) {
    map.removeLayer(layerList[i][1]);
  }
};
proto.dispose = function () {
  var map = this.subplot.map;
  this._removeLayers();
  map.removeSource(this.sourceId);
};
module.exports = function createDensityMap(subplot, calcTrace) {
  var trace = calcTrace[0].trace;
  var densityMap = new DensityMap(subplot, trace.uid);
  var sourceId = densityMap.sourceId;
  var optsAll = convert(calcTrace);
  var below = densityMap.below = subplot.belowLookup['trace-' + trace.uid];
  subplot.map.addSource(sourceId, {
    type: 'geojson',
    data: optsAll.geojson
  });
  densityMap._addLayers(optsAll, below);
  return densityMap;
};

/***/ }),

/***/ 17347:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var colorScaleAttrs = __webpack_require__(87163);
var hovertemplateAttrs = (__webpack_require__(3208)/* .hovertemplateAttrs */ .rb);
var baseAttrs = __webpack_require__(9829);
var scatterMapboxAttrs = __webpack_require__(95833);
var extendFlat = (__webpack_require__(93049).extendFlat);

/*
 * - https://docs.mapbox.com/help/tutorials/make-a-heatmap-with-mapbox-gl-js/
 * - https://docs.mapbox.com/mapbox-gl-js/example/heatmap-layer/
 * - https://docs.mapbox.com/mapbox-gl-js/style-spec/#layers-heatmap
 * - https://blog.mapbox.com/introducing-heatmaps-in-mapbox-gl-js-71355ada9e6c
 *
 * Gotchas:
 * - https://github.com/mapbox/mapbox-gl-js/issues/6463
 * - https://github.com/mapbox/mapbox-gl-js/issues/6112
 */

/*
 *
 * In mathematical terms, Mapbox GL heatmaps are a bivariate (2D) kernel density
 * estimation with a Gaussian kernel. It means that each data point has an area
 * of “influence” around it (called a kernel) where the numerical value of
 * influence (which we call density) decreases as you go further from the point.
 * If we sum density values of all points in every pixel of the screen, we get a
 * combined density value which we then map to a heatmap color.
 *
 */

module.exports = extendFlat({
  lon: scatterMapboxAttrs.lon,
  lat: scatterMapboxAttrs.lat,
  z: {
    valType: 'data_array',
    editType: 'calc'
  },
  radius: {
    valType: 'number',
    editType: 'plot',
    arrayOk: true,
    min: 1,
    dflt: 30
  },
  below: {
    valType: 'string',
    editType: 'plot'
  },
  text: scatterMapboxAttrs.text,
  hovertext: scatterMapboxAttrs.hovertext,
  hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
    flags: ['lon', 'lat', 'z', 'text', 'name']
  }),
  hovertemplate: hovertemplateAttrs(),
  showlegend: extendFlat({}, baseAttrs.showlegend, {
    dflt: false
  })
}, colorScaleAttrs('', {
  cLetter: 'z',
  editTypeOverride: 'calc'
}));

/***/ }),

/***/ 60675:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isNumeric = __webpack_require__(10721);
var isArrayOrTypedArray = (__webpack_require__(34809).isArrayOrTypedArray);
var BADNUM = (__webpack_require__(63821).BADNUM);
var colorscaleCalc = __webpack_require__(28379);
var _ = (__webpack_require__(34809)._);
module.exports = function calc(gd, trace) {
  var len = trace._length;
  var calcTrace = new Array(len);
  var z = trace.z;
  var hasZ = isArrayOrTypedArray(z) && z.length;
  for (var i = 0; i < len; i++) {
    var cdi = calcTrace[i] = {};
    var lon = trace.lon[i];
    var lat = trace.lat[i];
    cdi.lonlat = isNumeric(lon) && isNumeric(lat) ? [+lon, +lat] : [BADNUM, BADNUM];
    if (hasZ) {
      var zi = z[i];
      cdi.z = isNumeric(zi) ? zi : BADNUM;
    }
  }
  colorscaleCalc(gd, trace, {
    vals: hasZ ? z : [0, 1],
    containerStr: '',
    cLetter: 'z'
  });
  if (len) {
    calcTrace[0].t = {
      labels: {
        lat: _(gd, 'lat:') + ' ',
        lon: _(gd, 'lon:') + ' '
      }
    };
  }
  return calcTrace;
};

/***/ }),

/***/ 78391:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isNumeric = __webpack_require__(10721);
var Lib = __webpack_require__(34809);
var Color = __webpack_require__(78766);
var Colorscale = __webpack_require__(88856);
var BADNUM = (__webpack_require__(63821).BADNUM);
var makeBlank = (__webpack_require__(39532).makeBlank);
module.exports = function convert(calcTrace) {
  var trace = calcTrace[0].trace;
  var isVisible = trace.visible === true && trace._length !== 0;
  var heatmap = {
    layout: {
      visibility: 'none'
    },
    paint: {}
  };
  var opts = trace._opts = {
    heatmap: heatmap,
    geojson: makeBlank()
  };

  // early return if not visible or placeholder
  if (!isVisible) return opts;
  var features = [];
  var i;
  var z = trace.z;
  var radius = trace.radius;
  var hasZ = Lib.isArrayOrTypedArray(z) && z.length;
  var hasArrayRadius = Lib.isArrayOrTypedArray(radius);
  for (i = 0; i < calcTrace.length; i++) {
    var cdi = calcTrace[i];
    var lonlat = cdi.lonlat;
    if (lonlat[0] !== BADNUM) {
      var props = {};
      if (hasZ) {
        var zi = cdi.z;
        props.z = zi !== BADNUM ? zi : 0;
      }
      if (hasArrayRadius) {
        props.r = isNumeric(radius[i]) && radius[i] > 0 ? +radius[i] : 0;
      }
      features.push({
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: lonlat
        },
        properties: props
      });
    }
  }
  var cOpts = Colorscale.extractOpts(trace);
  var scl = cOpts.reversescale ? Colorscale.flipScale(cOpts.colorscale) : cOpts.colorscale;

  // Add alpha channel to first colorscale step.
  // If not, we would essentially color the entire map.
  // See https://docs.mapbox.com/mapbox-gl-js/example/heatmap-layer/
  var scl01 = scl[0][1];
  var color0 = Color.opacity(scl01) < 1 ? scl01 : Color.addOpacity(scl01, 0);
  var heatmapColor = ['interpolate', ['linear'], ['heatmap-density'], 0, color0];
  for (i = 1; i < scl.length; i++) {
    heatmapColor.push(scl[i][0], scl[i][1]);
  }

  // Those "weights" have to be in [0, 1], we can do this either:
  // - as here using a mapbox-gl expression
  // - or, scale the 'z' property in the feature loop
  var zExp = ['interpolate', ['linear'], ['get', 'z'], cOpts.min, 0, cOpts.max, 1];
  Lib.extendFlat(opts.heatmap.paint, {
    'heatmap-weight': hasZ ? zExp : 1 / (cOpts.max - cOpts.min),
    'heatmap-color': heatmapColor,
    'heatmap-radius': hasArrayRadius ? {
      type: 'identity',
      property: 'r'
    } : trace.radius,
    'heatmap-opacity': trace.opacity
  });
  opts.geojson = {
    type: 'FeatureCollection',
    features: features
  };
  opts.heatmap.layout.visibility = 'visible';
  return opts;
};

/***/ }),

/***/ 1892:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var colorscaleDefaults = __webpack_require__(39356);
var attributes = __webpack_require__(17347);
module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
  function coerce(attr, dflt) {
    return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
  }
  var lon = coerce('lon') || [];
  var lat = coerce('lat') || [];
  var len = Math.min(lon.length, lat.length);
  if (!len) {
    traceOut.visible = false;
    return;
  }
  traceOut._length = len;
  coerce('z');
  coerce('radius');
  coerce('below');
  coerce('text');
  coerce('hovertext');
  coerce('hovertemplate');
  colorscaleDefaults(traceIn, traceOut, layout, coerce, {
    prefix: '',
    cLetter: 'z'
  });
};

/***/ }),

/***/ 8919:
/***/ (function(module) {

"use strict";


module.exports = function eventData(out, pt) {
  out.lon = pt.lon;
  out.lat = pt.lat;
  out.z = pt.z;
  return out;
};

/***/ }),

/***/ 54478:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Axes = __webpack_require__(29714);
var scatterMapboxHoverPoints = (__webpack_require__(18016).hoverPoints);
var getExtraText = (__webpack_require__(18016).getExtraText);
module.exports = function hoverPoints(pointData, xval, yval) {
  var pts = scatterMapboxHoverPoints(pointData, xval, yval);
  if (!pts) return;
  var newPointData = pts[0];
  var cd = newPointData.cd;
  var trace = cd[0].trace;
  var di = cd[newPointData.index];

  // let Fx.hover pick the color
  delete newPointData.color;
  if ('z' in di) {
    var ax = newPointData.subplot.mockAxis;
    newPointData.z = di.z;
    newPointData.zLabel = Axes.tickText(ax, ax.c2l(di.z), 'hover').text;
  }
  newPointData.extraText = getExtraText(trace, di, cd[0].t.labels);
  return [newPointData];
};

/***/ }),

/***/ 81264:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var deprecationWarning = ['*densitymapbox* trace is deprecated!', 'Please consider switching to the *densitymap* trace type and `map` subplots.', 'Learn more at: https://plotly.com/javascript/maplibre-migration/'].join(' ');
module.exports = {
  attributes: __webpack_require__(17347),
  supplyDefaults: __webpack_require__(1892),
  colorbar: __webpack_require__(12431),
  formatLabels: __webpack_require__(69009),
  calc: __webpack_require__(60675),
  plot: __webpack_require__(5165),
  hoverPoints: __webpack_require__(54478),
  eventData: __webpack_require__(8919),
  getBelow: function (trace, subplot) {
    var mapLayers = subplot.getMapLayers();

    // find first layer with `type: 'symbol'`,
    // that is not a plotly layer
    for (var i = 0; i < mapLayers.length; i++) {
      var layer = mapLayers[i];
      var layerId = layer.id;
      if (layer.type === 'symbol' && typeof layerId === 'string' && layerId.indexOf('plotly-') === -1) {
        return layerId;
      }
    }
  },
  moduleType: 'trace',
  name: 'densitymapbox',
  basePlotModule: __webpack_require__(68192),
  categories: ['mapbox', 'gl', 'showLegend'],
  meta: {
    hr_name: 'density_mapbox'
  }
};

/***/ }),

/***/ 5165:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var convert = __webpack_require__(78391);
var LAYER_PREFIX = (__webpack_require__(44245).traceLayerPrefix);
function DensityMapbox(subplot, uid) {
  this.type = 'densitymapbox';
  this.subplot = subplot;
  this.uid = uid;
  this.sourceId = 'source-' + uid;
  this.layerList = [['heatmap', LAYER_PREFIX + uid + '-heatmap']];

  // previous 'below' value,
  // need this to update it properly
  this.below = null;
}
var proto = DensityMapbox.prototype;
proto.update = function (calcTrace) {
  var subplot = this.subplot;
  var layerList = this.layerList;
  var optsAll = convert(calcTrace);
  var below = subplot.belowLookup['trace-' + this.uid];
  subplot.map.getSource(this.sourceId).setData(optsAll.geojson);
  if (below !== this.below) {
    this._removeLayers();
    this._addLayers(optsAll, below);
    this.below = below;
  }
  for (var i = 0; i < layerList.length; i++) {
    var item = layerList[i];
    var k = item[0];
    var id = item[1];
    var opts = optsAll[k];
    subplot.setOptions(id, 'setLayoutProperty', opts.layout);
    if (opts.layout.visibility === 'visible') {
      subplot.setOptions(id, 'setPaintProperty', opts.paint);
    }
  }
};
proto._addLayers = function (optsAll, below) {
  var subplot = this.subplot;
  var layerList = this.layerList;
  var sourceId = this.sourceId;
  for (var i = 0; i < layerList.length; i++) {
    var item = layerList[i];
    var k = item[0];
    var opts = optsAll[k];
    subplot.addLayer({
      type: k,
      id: item[1],
      source: sourceId,
      layout: opts.layout,
      paint: opts.paint
    }, below);
  }
};
proto._removeLayers = function () {
  var map = this.subplot.map;
  var layerList = this.layerList;
  for (var i = layerList.length - 1; i >= 0; i--) {
    map.removeLayer(layerList[i][1]);
  }
};
proto.dispose = function () {
  var map = this.subplot.map;
  this._removeLayers();
  map.removeSource(this.sourceId);
};
module.exports = function createDensityMapbox(subplot, calcTrace) {
  var trace = calcTrace[0].trace;
  var densityMapbox = new DensityMapbox(subplot, trace.uid);
  var sourceId = densityMapbox.sourceId;
  var optsAll = convert(calcTrace);
  var below = densityMapbox.below = subplot.belowLookup['trace-' + trace.uid];
  subplot.map.addSource(sourceId, {
    type: 'geojson',
    data: optsAll.geojson
  });
  densityMapbox._addLayers(optsAll, below);
  return densityMapbox;
};

/***/ }),

/***/ 43179:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);

// arrayOk attributes, merge them into calcdata array
module.exports = function arraysToCalcdata(cd, trace) {
  for (var i = 0; i < cd.length; i++) cd[i].i = i;
  Lib.mergeArray(trace.text, cd, 'tx');
  Lib.mergeArray(trace.hovertext, cd, 'htx');
  var marker = trace.marker;
  if (marker) {
    Lib.mergeArray(marker.opacity, cd, 'mo');
    Lib.mergeArray(marker.color, cd, 'mc');
    var markerLine = marker.line;
    if (markerLine) {
      Lib.mergeArray(markerLine.color, cd, 'mlc');
      Lib.mergeArrayCastPositive(markerLine.width, cd, 'mlw');
    }
  }
};

/***/ }),

/***/ 62824:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var barAttrs = __webpack_require__(81481);
var lineAttrs = (__webpack_require__(36640).line);
var baseAttrs = __webpack_require__(9829);
var axisHoverFormat = (__webpack_require__(80712).axisHoverFormat);
var hovertemplateAttrs = (__webpack_require__(3208)/* .hovertemplateAttrs */ .rb);
var texttemplateAttrs = (__webpack_require__(3208)/* .texttemplateAttrs */ .ay);
var constants = __webpack_require__(87948);
var extendFlat = (__webpack_require__(93049).extendFlat);
var Color = __webpack_require__(78766);
module.exports = {
  x: barAttrs.x,
  x0: barAttrs.x0,
  dx: barAttrs.dx,
  y: barAttrs.y,
  y0: barAttrs.y0,
  dy: barAttrs.dy,
  xperiod: barAttrs.xperiod,
  yperiod: barAttrs.yperiod,
  xperiod0: barAttrs.xperiod0,
  yperiod0: barAttrs.yperiod0,
  xperiodalignment: barAttrs.xperiodalignment,
  yperiodalignment: barAttrs.yperiodalignment,
  xhoverformat: axisHoverFormat('x'),
  yhoverformat: axisHoverFormat('y'),
  hovertext: barAttrs.hovertext,
  hovertemplate: hovertemplateAttrs({}, {
    keys: constants.eventDataKeys
  }),
  hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
    flags: ['name', 'x', 'y', 'text', 'percent initial', 'percent previous', 'percent total']
  }),
  textinfo: {
    valType: 'flaglist',
    flags: ['label', 'text', 'percent initial', 'percent previous', 'percent total', 'value'],
    extras: ['none'],
    editType: 'plot',
    arrayOk: false
  },
  // TODO: incorporate `label` and `value` in the eventData
  texttemplate: texttemplateAttrs({
    editType: 'plot'
  }, {
    keys: constants.eventDataKeys.concat(['label', 'value'])
  }),
  text: barAttrs.text,
  textposition: barAttrs.textposition,
  insidetextanchor: extendFlat({}, barAttrs.insidetextanchor, {
    dflt: 'middle'
  }),
  textangle: extendFlat({}, barAttrs.textangle, {
    dflt: 0
  }),
  textfont: barAttrs.textfont,
  insidetextfont: barAttrs.insidetextfont,
  outsidetextfont: barAttrs.outsidetextfont,
  constraintext: barAttrs.constraintext,
  cliponaxis: barAttrs.cliponaxis,
  orientation: extendFlat({}, barAttrs.orientation, {}),
  offset: extendFlat({}, barAttrs.offset, {
    arrayOk: false
  }),
  width: extendFlat({}, barAttrs.width, {
    arrayOk: false
  }),
  marker: funnelMarker(),
  connector: {
    fillcolor: {
      valType: 'color',
      editType: 'style'
    },
    line: {
      color: extendFlat({}, lineAttrs.color, {
        dflt: Color.defaultLine
      }),
      width: extendFlat({}, lineAttrs.width, {
        dflt: 0,
        editType: 'plot'
      }),
      dash: lineAttrs.dash,
      editType: 'style'
    },
    visible: {
      valType: 'boolean',
      dflt: true,
      editType: 'plot'
    },
    editType: 'plot'
  },
  offsetgroup: barAttrs.offsetgroup,
  alignmentgroup: barAttrs.alignmentgroup,
  zorder: barAttrs.zorder
};
function funnelMarker() {
  var marker = extendFlat({}, barAttrs.marker);
  delete marker.pattern;
  delete marker.cornerradius;
  return marker;
}

/***/ }),

/***/ 28152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Axes = __webpack_require__(29714);
var alignPeriod = __webpack_require__(40528);
var arraysToCalcdata = __webpack_require__(43179);
var calcSelection = __webpack_require__(48861);
var BADNUM = (__webpack_require__(63821).BADNUM);
module.exports = function calc(gd, trace) {
  var xa = Axes.getFromId(gd, trace.xaxis || 'x');
  var ya = Axes.getFromId(gd, trace.yaxis || 'y');
  var size, pos, origPos, pObj, hasPeriod, pLetter, i, cdi;
  if (trace.orientation === 'h') {
    size = xa.makeCalcdata(trace, 'x');
    origPos = ya.makeCalcdata(trace, 'y');
    pObj = alignPeriod(trace, ya, 'y', origPos);
    hasPeriod = !!trace.yperiodalignment;
    pLetter = 'y';
  } else {
    size = ya.makeCalcdata(trace, 'y');
    origPos = xa.makeCalcdata(trace, 'x');
    pObj = alignPeriod(trace, xa, 'x', origPos);
    hasPeriod = !!trace.xperiodalignment;
    pLetter = 'x';
  }
  pos = pObj.vals;

  // create the "calculated data" to plot
  var serieslen = Math.min(pos.length, size.length);
  var cd = new Array(serieslen);

  // Unlike other bar-like traces funnels do not support base attribute.
  // bases for funnels are computed internally in a way that
  // the mid-point of each bar are located on the axis line.
  trace._base = [];

  // set position and size
  for (i = 0; i < serieslen; i++) {
    // treat negative values as bad numbers
    if (size[i] < 0) size[i] = BADNUM;
    var connectToNext = false;
    if (size[i] !== BADNUM) {
      if (i + 1 < serieslen && size[i + 1] !== BADNUM) {
        connectToNext = true;
      }
    }
    cdi = cd[i] = {
      p: pos[i],
      s: size[i],
      cNext: connectToNext
    };
    trace._base[i] = -0.5 * cdi.s;
    if (hasPeriod) {
      cd[i].orig_p = origPos[i]; // used by hover
      cd[i][pLetter + 'End'] = pObj.ends[i];
      cd[i][pLetter + 'Start'] = pObj.starts[i];
    }
    if (trace.ids) {
      cdi.id = String(trace.ids[i]);
    }

    // calculate total values
    if (i === 0) cd[0].vTotal = 0;
    cd[0].vTotal += fixNum(cdi.s);

    // ratio from initial value
    cdi.begR = fixNum(cdi.s) / fixNum(cd[0].s);
  }
  var prevGoodNum;
  for (i = 0; i < serieslen; i++) {
    cdi = cd[i];
    if (cdi.s === BADNUM) continue;

    // ratio of total value
    cdi.sumR = cdi.s / cd[0].vTotal;

    // ratio of previous (good) value
    cdi.difR = prevGoodNum !== undefined ? cdi.s / prevGoodNum : 1;
    prevGoodNum = cdi.s;
  }
  arraysToCalcdata(cd, trace);
  calcSelection(cd, trace);
  return cd;
};
function fixNum(a) {
  return a === BADNUM ? 0 : a;
}

/***/ }),

/***/ 87948:
/***/ (function(module) {

"use strict";


module.exports = {
  eventDataKeys: ['percentInitial', 'percentPrevious', 'percentTotal']
};

/***/ }),

/***/ 82539:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var setGroupPositions = (__webpack_require__(24782).setGroupPositions);
module.exports = function crossTraceCalc(gd, plotinfo) {
  var fullLayout = gd._fullLayout;
  var fullData = gd._fullData;
  var calcdata = gd.calcdata;
  var xa = plotinfo.xaxis;
  var ya = plotinfo.yaxis;
  var funnels = [];
  var funnelsVert = [];
  var funnelsHorz = [];
  var cd, i;
  for (i = 0; i < fullData.length; i++) {
    var fullTrace = fullData[i];
    var isHorizontal = fullTrace.orientation === 'h';
    if (fullTrace.visible === true && fullTrace.xaxis === xa._id && fullTrace.yaxis === ya._id && fullTrace.type === 'funnel') {
      cd = calcdata[i];
      if (isHorizontal) {
        funnelsHorz.push(cd);
      } else {
        funnelsVert.push(cd);
      }
      funnels.push(cd);
    }
  }
  var opts = {
    mode: fullLayout.funnelmode,
    norm: fullLayout.funnelnorm,
    gap: fullLayout.funnelgap,
    groupgap: fullLayout.funnelgroupgap
  };
  setGroupPositions(gd, xa, ya, funnelsVert, opts);
  setGroupPositions(gd, ya, xa, funnelsHorz, opts);
  for (i = 0; i < funnels.length; i++) {
    cd = funnels[i];
    for (var j = 0; j < cd.length; j++) {
      if (j + 1 < cd.length) {
        cd[j].nextP0 = cd[j + 1].p0;
        cd[j].nextS0 = cd[j + 1].s0;
        cd[j].nextP1 = cd[j + 1].p1;
        cd[j].nextS1 = cd[j + 1].s1;
      }
    }
  }
};

/***/ }),

/***/ 30495:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var handleGroupingDefaults = __webpack_require__(36301);
var handleText = (__webpack_require__(17550).handleText);
var handleXYDefaults = __webpack_require__(99867);
var handlePeriodDefaults = __webpack_require__(99669);
var attributes = __webpack_require__(62824);
var Color = __webpack_require__(78766);
function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
  function coerce(attr, dflt) {
    return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
  }
  var len = handleXYDefaults(traceIn, traceOut, layout, coerce);
  if (!len) {
    traceOut.visible = false;
    return;
  }
  handlePeriodDefaults(traceIn, traceOut, layout, coerce);
  coerce('xhoverformat');
  coerce('yhoverformat');
  coerce('orientation', traceOut.y && !traceOut.x ? 'v' : 'h');
  coerce('offset');
  coerce('width');
  var text = coerce('text');
  coerce('hovertext');
  coerce('hovertemplate');
  var textposition = coerce('textposition');
  handleText(traceIn, traceOut, layout, coerce, textposition, {
    moduleHasSelected: false,
    moduleHasUnselected: false,
    moduleHasConstrain: true,
    moduleHasCliponaxis: true,
    moduleHasTextangle: true,
    moduleHasInsideanchor: true
  });
  if (traceOut.textposition !== 'none' && !traceOut.texttemplate) {
    coerce('textinfo', Lib.isArrayOrTypedArray(text) ? 'text+value' : 'value');
  }
  var markerColor = coerce('marker.color', defaultColor);
  coerce('marker.line.color', Color.defaultLine);
  coerce('marker.line.width');
  var connectorVisible = coerce('connector.visible');
  if (connectorVisible) {
    coerce('connector.fillcolor', defaultFillColor(markerColor));
    var connectorLineWidth = coerce('connector.line.width');
    if (connectorLineWidth) {
      coerce('connector.line.color');
      coerce('connector.line.dash');
    }
  }
  coerce('zorder');
}
function defaultFillColor(markerColor) {
  var cBase = Lib.isArrayOrTypedArray(markerColor) ? '#000' : markerColor;
  return Color.addOpacity(cBase, 0.5 * Color.opacity(cBase));
}
function crossTraceDefaults(fullData, fullLayout) {
  var traceIn, traceOut;
  function coerce(attr) {
    return Lib.coerce(traceOut._input, traceOut, attributes, attr);
  }
  if (fullLayout.funnelmode === 'group') {
    for (var i = 0; i < fullData.length; i++) {
      traceOut = fullData[i];
      traceIn = traceOut._input;
      handleGroupingDefaults(traceIn, traceOut, fullLayout, coerce);
    }
  }
}
module.exports = {
  supplyDefaults: supplyDefaults,
  crossTraceDefaults: crossTraceDefaults
};

/***/ }),

/***/ 29412:
/***/ (function(module) {

"use strict";


module.exports = function eventData(out, pt /* , trace, cd, pointNumber */) {
  // standard cartesian event data
  out.x = 'xVal' in pt ? pt.xVal : pt.x;
  out.y = 'yVal' in pt ? pt.yVal : pt.y;

  // for funnel
  if ('percentInitial' in pt) out.percentInitial = pt.percentInitial;
  if ('percentPrevious' in pt) out.percentPrevious = pt.percentPrevious;
  if ('percentTotal' in pt) out.percentTotal = pt.percentTotal;
  if (pt.xa) out.xaxis = pt.xa;
  if (pt.ya) out.yaxis = pt.ya;
  return out;
};

/***/ }),

/***/ 27759:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var opacity = (__webpack_require__(78766).opacity);
var hoverOnBars = (__webpack_require__(91664).hoverOnBars);
var formatPercent = (__webpack_require__(34809).formatPercent);
module.exports = function hoverPoints(pointData, xval, yval, hovermode, opts) {
  var point = hoverOnBars(pointData, xval, yval, hovermode, opts);
  if (!point) return;
  var cd = point.cd;
  var trace = cd[0].trace;
  var isHorizontal = trace.orientation === 'h';

  // the closest data point
  var index = point.index;
  var di = cd[index];
  var sizeLetter = isHorizontal ? 'x' : 'y';
  point[sizeLetter + 'LabelVal'] = di.s;
  point.percentInitial = di.begR;
  point.percentInitialLabel = formatPercent(di.begR, 1);
  point.percentPrevious = di.difR;
  point.percentPreviousLabel = formatPercent(di.difR, 1);
  point.percentTotal = di.sumR;
  point.percentTotalLabel = formatPercent(di.sumR, 1);
  var hoverinfo = di.hi || trace.hoverinfo;
  var text = [];
  if (hoverinfo && hoverinfo !== 'none' && hoverinfo !== 'skip') {
    var isAll = hoverinfo === 'all';
    var parts = hoverinfo.split('+');
    var hasFlag = function (flag) {
      return isAll || parts.indexOf(flag) !== -1;
    };
    if (hasFlag('percent initial')) {
      text.push(point.percentInitialLabel + ' of initial');
    }
    if (hasFlag('percent previous')) {
      text.push(point.percentPreviousLabel + ' of previous');
    }
    if (hasFlag('percent total')) {
      text.push(point.percentTotalLabel + ' of total');
    }
  }
  point.extraText = text.join('<br>');
  point.color = getTraceColor(trace, di);
  return [point];
};
function getTraceColor(trace, di) {
  var cont = trace.marker;
  var mc = di.mc || cont.color;
  var mlc = di.mlc || cont.line.color;
  var mlw = di.mlw || cont.line.width;
  if (opacity(mc)) return mc;else if (opacity(mlc) && mlw) return mlc;
}

/***/ }),

/***/ 52213:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = {
  attributes: __webpack_require__(62824),
  layoutAttributes: __webpack_require__(93795),
  supplyDefaults: (__webpack_require__(30495).supplyDefaults),
  crossTraceDefaults: (__webpack_require__(30495).crossTraceDefaults),
  supplyLayoutDefaults: __webpack_require__(34980),
  calc: __webpack_require__(28152),
  crossTraceCalc: __webpack_require__(82539),
  plot: __webpack_require__(83482),
  style: (__webpack_require__(7240).style),
  hoverPoints: __webpack_require__(27759),
  eventData: __webpack_require__(29412),
  selectPoints: __webpack_require__(88384),
  moduleType: 'trace',
  name: 'funnel',
  basePlotModule: __webpack_require__(37703),
  categories: ['bar-like', 'cartesian', 'svg', 'oriented', 'showLegend', 'zoomScale'],
  meta: {}
};

/***/ }),

/***/ 93795:
/***/ (function(module) {

"use strict";


module.exports = {
  funnelmode: {
    valType: 'enumerated',
    values: ['stack', 'group', 'overlay'],
    dflt: 'stack',
    editType: 'calc'
  },
  funnelgap: {
    valType: 'number',
    min: 0,
    max: 1,
    editType: 'calc'
  },
  funnelgroupgap: {
    valType: 'number',
    min: 0,
    max: 1,
    dflt: 0,
    editType: 'calc'
  }
};

/***/ }),

/***/ 34980:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var layoutAttributes = __webpack_require__(93795);
module.exports = function (layoutIn, layoutOut, fullData) {
  var hasTraceType = false;
  function coerce(attr, dflt) {
    return Lib.coerce(layoutIn, layoutOut, layoutAttributes, attr, dflt);
  }
  for (var i = 0; i < fullData.length; i++) {
    var trace = fullData[i];
    if (trace.visible && trace.type === 'funnel') {
      hasTraceType = true;
      break;
    }
  }
  if (hasTraceType) {
    coerce('funnelmode');
    coerce('funnelgap', 0.2);
    coerce('funnelgroupgap');
  }
};

/***/ }),

/***/ 83482:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var Lib = __webpack_require__(34809);
var Drawing = __webpack_require__(62203);
var BADNUM = (__webpack_require__(63821).BADNUM);
var barPlot = __webpack_require__(32995);
var clearMinTextSize = (__webpack_require__(84102).clearMinTextSize);
module.exports = function plot(gd, plotinfo, cdModule, traceLayer) {
  var fullLayout = gd._fullLayout;
  clearMinTextSize('funnel', fullLayout);
  plotConnectorRegions(gd, plotinfo, cdModule, traceLayer);
  plotConnectorLines(gd, plotinfo, cdModule, traceLayer);
  barPlot.plot(gd, plotinfo, cdModule, traceLayer, {
    mode: fullLayout.funnelmode,
    norm: fullLayout.funnelmode,
    gap: fullLayout.funnelgap,
    groupgap: fullLayout.funnelgroupgap
  });
};
function plotConnectorRegions(gd, plotinfo, cdModule, traceLayer) {
  var xa = plotinfo.xaxis;
  var ya = plotinfo.yaxis;
  Lib.makeTraceGroups(traceLayer, cdModule, 'trace bars').each(function (cd) {
    var plotGroup = d3.select(this);
    var trace = cd[0].trace;
    var group = Lib.ensureSingle(plotGroup, 'g', 'regions');
    if (!trace.connector || !trace.connector.visible) {
      group.remove();
      return;
    }
    var isHorizontal = trace.orientation === 'h';
    var connectors = group.selectAll('g.region').data(Lib.identity);
    connectors.enter().append('g').classed('region', true);
    connectors.exit().remove();
    var len = connectors.size();
    connectors.each(function (di, i) {
      // don't draw lines between nulls
      if (i !== len - 1 && !di.cNext) return;
      var xy = getXY(di, xa, ya, isHorizontal);
      var x = xy[0];
      var y = xy[1];
      var shape = '';
      if (x[0] !== BADNUM && y[0] !== BADNUM && x[1] !== BADNUM && y[1] !== BADNUM && x[2] !== BADNUM && y[2] !== BADNUM && x[3] !== BADNUM && y[3] !== BADNUM) {
        if (isHorizontal) {
          shape += 'M' + x[0] + ',' + y[1] + 'L' + x[2] + ',' + y[2] + 'H' + x[3] + 'L' + x[1] + ',' + y[1] + 'Z';
        } else {
          shape += 'M' + x[1] + ',' + y[1] + 'L' + x[2] + ',' + y[3] + 'V' + y[2] + 'L' + x[1] + ',' + y[0] + 'Z';
        }
      }
      if (shape === '') shape = 'M0,0Z';
      Lib.ensureSingle(d3.select(this), 'path').attr('d', shape).call(Drawing.setClipUrl, plotinfo.layerClipId, gd);
    });
  });
}
function plotConnectorLines(gd, plotinfo, cdModule, traceLayer) {
  var xa = plotinfo.xaxis;
  var ya = plotinfo.yaxis;
  Lib.makeTraceGroups(traceLayer, cdModule, 'trace bars').each(function (cd) {
    var plotGroup = d3.select(this);
    var trace = cd[0].trace;
    var group = Lib.ensureSingle(plotGroup, 'g', 'lines');
    if (!trace.connector || !trace.connector.visible || !trace.connector.line.width) {
      group.remove();
      return;
    }
    var isHorizontal = trace.orientation === 'h';
    var connectors = group.selectAll('g.line').data(Lib.identity);
    connectors.enter().append('g').classed('line', true);
    connectors.exit().remove();
    var len = connectors.size();
    connectors.each(function (di, i) {
      // don't draw lines between nulls
      if (i !== len - 1 && !di.cNext) return;
      var xy = getXY(di, xa, ya, isHorizontal);
      var x = xy[0];
      var y = xy[1];
      var shape = '';
      if (x[3] !== undefined && y[3] !== undefined) {
        if (isHorizontal) {
          shape += 'M' + x[0] + ',' + y[1] + 'L' + x[2] + ',' + y[2];
          shape += 'M' + x[1] + ',' + y[1] + 'L' + x[3] + ',' + y[2];
        } else {
          shape += 'M' + x[1] + ',' + y[1] + 'L' + x[2] + ',' + y[3];
          shape += 'M' + x[1] + ',' + y[0] + 'L' + x[2] + ',' + y[2];
        }
      }
      if (shape === '') shape = 'M0,0Z';
      Lib.ensureSingle(d3.select(this), 'path').attr('d', shape).call(Drawing.setClipUrl, plotinfo.layerClipId, gd);
    });
  });
}
function getXY(di, xa, ya, isHorizontal) {
  var s = [];
  var p = [];
  var sAxis = isHorizontal ? xa : ya;
  var pAxis = isHorizontal ? ya : xa;
  s[0] = sAxis.c2p(di.s0, true);
  p[0] = pAxis.c2p(di.p0, true);
  s[1] = sAxis.c2p(di.s1, true);
  p[1] = pAxis.c2p(di.p1, true);
  s[2] = sAxis.c2p(di.nextS0, true);
  p[2] = pAxis.c2p(di.nextP0, true);
  s[3] = sAxis.c2p(di.nextS1, true);
  p[3] = pAxis.c2p(di.nextP1, true);
  return isHorizontal ? [s, p] : [p, s];
}

/***/ }),

/***/ 7240:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var Drawing = __webpack_require__(62203);
var Color = __webpack_require__(78766);
var DESELECTDIM = (__webpack_require__(20438).DESELECTDIM);
var barStyle = __webpack_require__(6851);
var resizeText = (__webpack_require__(84102).resizeText);
var styleTextPoints = barStyle.styleTextPoints;
function style(gd, cd, sel) {
  var s = sel ? sel : d3.select(gd).selectAll('g[class^="funnellayer"]').selectAll('g.trace');
  resizeText(gd, s, 'funnel');
  s.style('opacity', function (d) {
    return d[0].trace.opacity;
  });
  s.each(function (d) {
    var gTrace = d3.select(this);
    var trace = d[0].trace;
    gTrace.selectAll('.point > path').each(function (di) {
      if (!di.isBlank) {
        var cont = trace.marker;
        d3.select(this).call(Color.fill, di.mc || cont.color).call(Color.stroke, di.mlc || cont.line.color).call(Drawing.dashLine, cont.line.dash, di.mlw || cont.line.width).style('opacity', trace.selectedpoints && !di.selected ? DESELECTDIM : 1);
      }
    });
    styleTextPoints(gTrace, trace, gd);
    gTrace.selectAll('.regions').each(function () {
      d3.select(this).selectAll('path').style('stroke-width', 0).call(Color.fill, trace.connector.fillcolor);
    });
    gTrace.selectAll('.lines').each(function () {
      var cont = trace.connector.line;
      Drawing.lineGroupStyle(d3.select(this).selectAll('path'), cont.width, cont.color, cont.dash);
    });
  });
}
module.exports = {
  style: style
};

/***/ }),

/***/ 63447:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var pieAttrs = __webpack_require__(55412);
var baseAttrs = __webpack_require__(9829);
var domainAttrs = (__webpack_require__(13792)/* .attributes */ .u);
var hovertemplateAttrs = (__webpack_require__(3208)/* .hovertemplateAttrs */ .rb);
var texttemplateAttrs = (__webpack_require__(3208)/* .texttemplateAttrs */ .ay);
var extendFlat = (__webpack_require__(93049).extendFlat);
module.exports = {
  labels: pieAttrs.labels,
  // equivalent of x0 and dx, if label is missing
  label0: pieAttrs.label0,
  dlabel: pieAttrs.dlabel,
  values: pieAttrs.values,
  marker: {
    colors: pieAttrs.marker.colors,
    line: {
      color: extendFlat({}, pieAttrs.marker.line.color, {
        dflt: null
      }),
      width: extendFlat({}, pieAttrs.marker.line.width, {
        dflt: 1
      }),
      editType: 'calc'
    },
    pattern: pieAttrs.marker.pattern,
    editType: 'calc'
  },
  text: pieAttrs.text,
  hovertext: pieAttrs.hovertext,
  scalegroup: extendFlat({}, pieAttrs.scalegroup, {}),
  textinfo: extendFlat({}, pieAttrs.textinfo, {
    flags: ['label', 'text', 'value', 'percent']
  }),
  texttemplate: texttemplateAttrs({
    editType: 'plot'
  }, {
    keys: ['label', 'color', 'value', 'text', 'percent']
  }),
  hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
    flags: ['label', 'text', 'value', 'percent', 'name']
  }),
  hovertemplate: hovertemplateAttrs({}, {
    keys: ['label', 'color', 'value', 'text', 'percent']
  }),
  textposition: extendFlat({}, pieAttrs.textposition, {
    values: ['inside', 'none'],
    dflt: 'inside'
  }),
  textfont: pieAttrs.textfont,
  insidetextfont: pieAttrs.insidetextfont,
  title: {
    text: pieAttrs.title.text,
    font: pieAttrs.title.font,
    position: extendFlat({}, pieAttrs.title.position, {
      values: ['top left', 'top center', 'top right'],
      dflt: 'top center'
    }),
    editType: 'plot'
  },
  domain: domainAttrs({
    name: 'funnelarea',
    trace: true,
    editType: 'calc'
  }),
  aspectratio: {
    valType: 'number',
    min: 0,
    dflt: 1,
    editType: 'plot'
  },
  baseratio: {
    valType: 'number',
    min: 0,
    max: 1,
    dflt: 0.333,
    editType: 'plot'
  }
};

/***/ }),

/***/ 86817:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var plots = __webpack_require__(44122);
exports.name = 'funnelarea';
exports.plot = function (gd, traces, transitionOpts, makeOnCompleteCallback) {
  plots.plotBasePlot(exports.name, gd, traces, transitionOpts, makeOnCompleteCallback);
};
exports.clean = function (newFullData, newFullLayout, oldFullData, oldFullLayout) {
  plots.cleanBasePlot(exports.name, newFullData, newFullLayout, oldFullData, oldFullLayout);
};

/***/ }),

/***/ 2807:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var pieCalc = __webpack_require__(44148);
function calc(gd, trace) {
  return pieCalc.calc(gd, trace);
}
function crossTraceCalc(gd) {
  pieCalc.crossTraceCalc(gd, {
    type: 'funnelarea'
  });
}
module.exports = {
  calc: calc,
  crossTraceCalc: crossTraceCalc
};

/***/ }),

/***/ 79824:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var attributes = __webpack_require__(63447);
var handleDomainDefaults = (__webpack_require__(13792)/* .defaults */ .N);
var handleText = (__webpack_require__(17550).handleText);
var handleLabelsAndValues = (__webpack_require__(46979).handleLabelsAndValues);
var handleMarkerDefaults = (__webpack_require__(46979).handleMarkerDefaults);
module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
  function coerce(attr, dflt) {
    return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
  }
  var labels = coerce('labels');
  var values = coerce('values');
  var res = handleLabelsAndValues(labels, values);
  var len = res.len;
  traceOut._hasLabels = res.hasLabels;
  traceOut._hasValues = res.hasValues;
  if (!traceOut._hasLabels && traceOut._hasValues) {
    coerce('label0');
    coerce('dlabel');
  }
  if (!len) {
    traceOut.visible = false;
    return;
  }
  traceOut._length = len;
  handleMarkerDefaults(traceIn, traceOut, layout, coerce);
  coerce('scalegroup');
  var textData = coerce('text');
  var textTemplate = coerce('texttemplate');
  var textInfo;
  if (!textTemplate) textInfo = coerce('textinfo', Array.isArray(textData) ? 'text+percent' : 'percent');
  coerce('hovertext');
  coerce('hovertemplate');
  if (textTemplate || textInfo && textInfo !== 'none') {
    var textposition = coerce('textposition');
    handleText(traceIn, traceOut, layout, coerce, textposition, {
      moduleHasSelected: false,
      moduleHasUnselected: false,
      moduleHasConstrain: false,
      moduleHasCliponaxis: false,
      moduleHasTextangle: false,
      moduleHasInsideanchor: false
    });
  } else if (textInfo === 'none') {
    coerce('textposition', 'none');
  }
  handleDomainDefaults(traceOut, layout, coerce);
  var title = coerce('title.text');
  if (title) {
    coerce('title.position');
    Lib.coerceFont(coerce, 'title.font', layout.font);
  }
  coerce('aspectratio');
  coerce('baseratio');
};

/***/ }),

/***/ 91132:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = {
  moduleType: 'trace',
  name: 'funnelarea',
  basePlotModule: __webpack_require__(86817),
  categories: ['pie-like', 'funnelarea', 'showLegend'],
  attributes: __webpack_require__(63447),
  layoutAttributes: __webpack_require__(10270),
  supplyDefaults: __webpack_require__(79824),
  supplyLayoutDefaults: __webpack_require__(69161),
  calc: (__webpack_require__(2807).calc),
  crossTraceCalc: (__webpack_require__(2807).crossTraceCalc),
  plot: __webpack_require__(96673),
  style: __webpack_require__(13757),
  styleOne: __webpack_require__(32891),
  meta: {}
};

/***/ }),

/***/ 10270:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var hiddenlabels = (__webpack_require__(4031).hiddenlabels);
module.exports = {
  hiddenlabels: hiddenlabels,
  funnelareacolorway: {
    valType: 'colorlist',
    editType: 'calc'
  },
  extendfunnelareacolors: {
    valType: 'boolean',
    dflt: true,
    editType: 'calc'
  }
};

/***/ }),

/***/ 69161:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var layoutAttributes = __webpack_require__(10270);
module.exports = function supplyLayoutDefaults(layoutIn, layoutOut) {
  function coerce(attr, dflt) {
    return Lib.coerce(layoutIn, layoutOut, layoutAttributes, attr, dflt);
  }
  coerce('hiddenlabels');
  coerce('funnelareacolorway', layoutOut.colorway);
  coerce('extendfunnelareacolors');
};

/***/ }),

/***/ 96673:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var Drawing = __webpack_require__(62203);
var Lib = __webpack_require__(34809);
var strScale = Lib.strScale;
var strTranslate = Lib.strTranslate;
var svgTextUtils = __webpack_require__(30635);
var barPlot = __webpack_require__(32995);
var toMoveInsideBar = barPlot.toMoveInsideBar;
var uniformText = __webpack_require__(84102);
var recordMinTextSize = uniformText.recordMinTextSize;
var clearMinTextSize = uniformText.clearMinTextSize;
var pieHelpers = __webpack_require__(37252);
var piePlot = __webpack_require__(35734);
var attachFxHandlers = piePlot.attachFxHandlers;
var determineInsideTextFont = piePlot.determineInsideTextFont;
var layoutAreas = piePlot.layoutAreas;
var prerenderTitles = piePlot.prerenderTitles;
var positionTitleOutside = piePlot.positionTitleOutside;
var formatSliceLabel = piePlot.formatSliceLabel;
module.exports = function plot(gd, cdModule) {
  var isStatic = gd._context.staticPlot;
  var fullLayout = gd._fullLayout;
  clearMinTextSize('funnelarea', fullLayout);
  prerenderTitles(cdModule, gd);
  layoutAreas(cdModule, fullLayout._size);
  Lib.makeTraceGroups(fullLayout._funnelarealayer, cdModule, 'trace').each(function (cd) {
    var plotGroup = d3.select(this);
    var cd0 = cd[0];
    var trace = cd0.trace;
    setCoords(cd);
    plotGroup.each(function () {
      var slices = d3.select(this).selectAll('g.slice').data(cd);
      slices.enter().append('g').classed('slice', true);
      slices.exit().remove();
      slices.each(function (pt, i) {
        if (pt.hidden) {
          d3.select(this).selectAll('path,g').remove();
          return;
        }

        // to have consistent event data compared to other traces
        pt.pointNumber = pt.i;
        pt.curveNumber = trace.index;
        var cx = cd0.cx;
        var cy = cd0.cy;
        var sliceTop = d3.select(this);
        var slicePath = sliceTop.selectAll('path.surface').data([pt]);
        slicePath.enter().append('path').classed('surface', true).style({
          'pointer-events': isStatic ? 'none' : 'all'
        });
        sliceTop.call(attachFxHandlers, gd, cd);
        var shape = 'M' + (cx + pt.TR[0]) + ',' + (cy + pt.TR[1]) + line(pt.TR, pt.BR) + line(pt.BR, pt.BL) + line(pt.BL, pt.TL) + 'Z';
        slicePath.attr('d', shape);

        // add text
        formatSliceLabel(gd, pt, cd0);
        var textPosition = pieHelpers.castOption(trace.textposition, pt.pts);
        var sliceTextGroup = sliceTop.selectAll('g.slicetext').data(pt.text && textPosition !== 'none' ? [0] : []);
        sliceTextGroup.enter().append('g').classed('slicetext', true);
        sliceTextGroup.exit().remove();
        sliceTextGroup.each(function () {
          var sliceText = Lib.ensureSingle(d3.select(this), 'text', '', function (s) {
            // prohibit tex interpretation until we can handle
            // tex and regular text together
            s.attr('data-notex', 1);
          });
          var font = Lib.ensureUniformFontSize(gd, determineInsideTextFont(trace, pt, fullLayout.font));
          sliceText.text(pt.text).attr({
            class: 'slicetext',
            transform: '',
            'text-anchor': 'middle'
          }).call(Drawing.font, font).call(svgTextUtils.convertToTspans, gd);

          // position the text relative to the slice
          var textBB = Drawing.bBox(sliceText.node());
          var transform;
          var x0, x1;
          var y0 = Math.min(pt.BL[1], pt.BR[1]) + cy;
          var y1 = Math.max(pt.TL[1], pt.TR[1]) + cy;
          x0 = Math.max(pt.TL[0], pt.BL[0]) + cx;
          x1 = Math.min(pt.TR[0], pt.BR[0]) + cx;
          transform = toMoveInsideBar(x0, x1, y0, y1, textBB, {
            isHorizontal: true,
            constrained: true,
            angle: 0,
            anchor: 'middle'
          });
          transform.fontSize = font.size;
          recordMinTextSize(trace.type, transform, fullLayout);
          cd[i].transform = transform;
          Lib.setTransormAndDisplay(sliceText, transform);
        });
      });

      // add the title
      var titleTextGroup = d3.select(this).selectAll('g.titletext').data(trace.title.text ? [0] : []);
      titleTextGroup.enter().append('g').classed('titletext', true);
      titleTextGroup.exit().remove();
      titleTextGroup.each(function () {
        var titleText = Lib.ensureSingle(d3.select(this), 'text', '', function (s) {
          // prohibit tex interpretation as above
          s.attr('data-notex', 1);
        });
        var txt = trace.title.text;
        if (trace._meta) {
          txt = Lib.templateString(txt, trace._meta);
        }
        titleText.text(txt).attr({
          class: 'titletext',
          transform: '',
          'text-anchor': 'middle'
        }).call(Drawing.font, trace.title.font).call(svgTextUtils.convertToTspans, gd);
        var transform = positionTitleOutside(cd0, fullLayout._size);
        titleText.attr('transform', strTranslate(transform.x, transform.y) + strScale(Math.min(1, transform.scale)) + strTranslate(transform.tx, transform.ty));
      });
    });
  });
};
function line(a, b) {
  var dx = b[0] - a[0];
  var dy = b[1] - a[1];
  return 'l' + dx + ',' + dy;
}
function getBetween(a, b) {
  return [0.5 * (a[0] + b[0]), 0.5 * (a[1] + b[1])];
}
function setCoords(cd) {
  if (!cd.length) return;
  var cd0 = cd[0];
  var trace = cd0.trace;
  var aspectratio = trace.aspectratio;
  var h = trace.baseratio;
  if (h > 0.999) h = 0.999; // TODO: may handle this case separately
  var h2 = Math.pow(h, 2);
  var v1 = cd0.vTotal;
  var v0 = v1 * h2 / (1 - h2);
  var totalValues = v1;
  var sumSteps = v0 / v1;
  function calcPos() {
    var q = Math.sqrt(sumSteps);
    return {
      x: q,
      y: -q
    };
  }
  function getPoint() {
    var pos = calcPos();
    return [pos.x, pos.y];
  }
  var p;
  var allPoints = [];
  allPoints.push(getPoint());
  var i, cdi;
  for (i = cd.length - 1; i > -1; i--) {
    cdi = cd[i];
    if (cdi.hidden) continue;
    var step = cdi.v / totalValues;
    sumSteps += step;
    allPoints.push(getPoint());
  }
  var minY = Infinity;
  var maxY = -Infinity;
  for (i = 0; i < allPoints.length; i++) {
    p = allPoints[i];
    minY = Math.min(minY, p[1]);
    maxY = Math.max(maxY, p[1]);
  }

  // center the shape
  for (i = 0; i < allPoints.length; i++) {
    allPoints[i][1] -= (maxY + minY) / 2;
  }
  var lastX = allPoints[allPoints.length - 1][0];

  // get pie r
  var r = cd0.r;
  var rY = (maxY - minY) / 2;
  var scaleX = r / lastX;
  var scaleY = r / rY * aspectratio;

  // set funnelarea r
  cd0.r = scaleY * rY;

  // scale the shape
  for (i = 0; i < allPoints.length; i++) {
    allPoints[i][0] *= scaleX;
    allPoints[i][1] *= scaleY;
  }

  // record first position
  p = allPoints[0];
  var prevLeft = [-p[0], p[1]];
  var prevRight = [p[0], p[1]];
  var n = 0; // note we skip the very first point.
  for (i = cd.length - 1; i > -1; i--) {
    cdi = cd[i];
    if (cdi.hidden) continue;
    n += 1;
    var x = allPoints[n][0];
    var y = allPoints[n][1];
    cdi.TL = [-x, y];
    cdi.TR = [x, y];
    cdi.BL = prevLeft;
    cdi.BR = prevRight;
    cdi.pxmid = getBetween(cdi.TR, cdi.BR);
    prevLeft = cdi.TL;
    prevRight = cdi.TR;
  }
}

/***/ }),

/***/ 13757:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var styleOne = __webpack_require__(32891);
var resizeText = (__webpack_require__(84102).resizeText);
module.exports = function style(gd) {
  var s = gd._fullLayout._funnelarealayer.selectAll('.trace');
  resizeText(gd, s, 'funnelarea');
  s.each(function (cd) {
    var cd0 = cd[0];
    var trace = cd0.trace;
    var traceSelection = d3.select(this);
    traceSelection.style({
      opacity: trace.opacity
    });
    traceSelection.selectAll('path.surface').each(function (pt) {
      d3.select(this).call(styleOne, pt, trace, gd);
    });
  });
};

/***/ }),

/***/ 81658:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var scatterAttrs = __webpack_require__(36640);
var baseAttrs = __webpack_require__(9829);
var fontAttrs = __webpack_require__(80337);
var axisHoverFormat = (__webpack_require__(80712).axisHoverFormat);
var hovertemplateAttrs = (__webpack_require__(3208)/* .hovertemplateAttrs */ .rb);
var texttemplateAttrs = (__webpack_require__(3208)/* .texttemplateAttrs */ .ay);
var colorScaleAttrs = __webpack_require__(87163);
var extendFlat = (__webpack_require__(93049).extendFlat);
module.exports = extendFlat({
  z: {
    valType: 'data_array',
    editType: 'calc'
  },
  x: extendFlat({}, scatterAttrs.x, {
    impliedEdits: {
      xtype: 'array'
    }
  }),
  x0: extendFlat({}, scatterAttrs.x0, {
    impliedEdits: {
      xtype: 'scaled'
    }
  }),
  dx: extendFlat({}, scatterAttrs.dx, {
    impliedEdits: {
      xtype: 'scaled'
    }
  }),
  y: extendFlat({}, scatterAttrs.y, {
    impliedEdits: {
      ytype: 'array'
    }
  }),
  y0: extendFlat({}, scatterAttrs.y0, {
    impliedEdits: {
      ytype: 'scaled'
    }
  }),
  dy: extendFlat({}, scatterAttrs.dy, {
    impliedEdits: {
      ytype: 'scaled'
    }
  }),
  xperiod: extendFlat({}, scatterAttrs.xperiod, {
    impliedEdits: {
      xtype: 'scaled'
    }
  }),
  yperiod: extendFlat({}, scatterAttrs.yperiod, {
    impliedEdits: {
      ytype: 'scaled'
    }
  }),
  xperiod0: extendFlat({}, scatterAttrs.xperiod0, {
    impliedEdits: {
      xtype: 'scaled'
    }
  }),
  yperiod0: extendFlat({}, scatterAttrs.yperiod0, {
    impliedEdits: {
      ytype: 'scaled'
    }
  }),
  xperiodalignment: extendFlat({}, scatterAttrs.xperiodalignment, {
    impliedEdits: {
      xtype: 'scaled'
    }
  }),
  yperiodalignment: extendFlat({}, scatterAttrs.yperiodalignment, {
    impliedEdits: {
      ytype: 'scaled'
    }
  }),
  text: {
    valType: 'data_array',
    editType: 'calc'
  },
  hovertext: {
    valType: 'data_array',
    editType: 'calc'
  },
  transpose: {
    valType: 'boolean',
    dflt: false,
    editType: 'calc'
  },
  xtype: {
    valType: 'enumerated',
    values: ['array', 'scaled'],
    editType: 'calc+clearAxisTypes'
  },
  ytype: {
    valType: 'enumerated',
    values: ['array', 'scaled'],
    editType: 'calc+clearAxisTypes'
  },
  zsmooth: {
    valType: 'enumerated',
    values: ['fast', 'best', false],
    dflt: false,
    editType: 'calc'
  },
  hoverongaps: {
    valType: 'boolean',
    dflt: true,
    editType: 'none'
  },
  connectgaps: {
    valType: 'boolean',
    editType: 'calc'
  },
  xgap: {
    valType: 'number',
    dflt: 0,
    min: 0,
    editType: 'plot'
  },
  ygap: {
    valType: 'number',
    dflt: 0,
    min: 0,
    editType: 'plot'
  },
  xhoverformat: axisHoverFormat('x'),
  yhoverformat: axisHoverFormat('y'),
  zhoverformat: axisHoverFormat('z', 1),
  hovertemplate: hovertemplateAttrs(),
  texttemplate: texttemplateAttrs({
    arrayOk: false,
    editType: 'plot'
  }, {
    keys: ['x', 'y', 'z', 'text']
  }),
  textfont: fontAttrs({
    editType: 'plot',
    autoSize: true,
    autoColor: true,
    colorEditType: 'style'
  }),
  showlegend: extendFlat({}, baseAttrs.showlegend, {
    dflt: false
  }),
  zorder: scatterAttrs.zorder
}, {
  transforms: undefined
}, colorScaleAttrs('', {
  cLetter: 'z',
  autoColorDflt: false
}));

/***/ }),

/***/ 51670:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Registry = __webpack_require__(33626);
var Lib = __webpack_require__(34809);
var Axes = __webpack_require__(29714);
var alignPeriod = __webpack_require__(40528);
var histogram2dCalc = __webpack_require__(19226);
var colorscaleCalc = __webpack_require__(28379);
var convertColumnData = __webpack_require__(87869);
var clean2dArray = __webpack_require__(93877);
var interp2d = __webpack_require__(69295);
var findEmpties = __webpack_require__(78106);
var makeBoundArray = __webpack_require__(80924);
var BADNUM = (__webpack_require__(63821).BADNUM);
module.exports = function calc(gd, trace) {
  // prepare the raw data
  // run makeCalcdata on x and y even for heatmaps, in case of category mappings
  var xa = Axes.getFromId(gd, trace.xaxis || 'x');
  var ya = Axes.getFromId(gd, trace.yaxis || 'y');
  var isContour = Registry.traceIs(trace, 'contour');
  var isHist = Registry.traceIs(trace, 'histogram');
  var isGL2D = Registry.traceIs(trace, 'gl2d');
  var zsmooth = isContour ? 'best' : trace.zsmooth;
  var x, x0, dx, origX;
  var y, y0, dy, origY;
  var z, i, binned;

  // cancel minimum tick spacings (only applies to bars and boxes)
  xa._minDtick = 0;
  ya._minDtick = 0;
  if (isHist) {
    binned = histogram2dCalc(gd, trace);
    origX = binned.orig_x;
    x = binned.x;
    x0 = binned.x0;
    dx = binned.dx;
    origY = binned.orig_y;
    y = binned.y;
    y0 = binned.y0;
    dy = binned.dy;
    z = binned.z;
  } else {
    var zIn = trace.z;
    if (Lib.isArray1D(zIn)) {
      convertColumnData(trace, xa, ya, 'x', 'y', ['z']);
      x = trace._x;
      y = trace._y;
      zIn = trace._z;
    } else {
      origX = trace.x ? xa.makeCalcdata(trace, 'x') : [];
      origY = trace.y ? ya.makeCalcdata(trace, 'y') : [];
      x = alignPeriod(trace, xa, 'x', origX).vals;
      y = alignPeriod(trace, ya, 'y', origY).vals;
      trace._x = x;
      trace._y = y;
    }
    x0 = trace.x0;
    dx = trace.dx;
    y0 = trace.y0;
    dy = trace.dy;
    z = clean2dArray(zIn, trace, xa, ya);
  }
  if (xa.rangebreaks || ya.rangebreaks) {
    z = dropZonBreaks(x, y, z);
    if (!isHist) {
      x = skipBreaks(x);
      y = skipBreaks(y);
      trace._x = x;
      trace._y = y;
    }
  }
  if (!isHist && (isContour || trace.connectgaps)) {
    trace._emptypoints = findEmpties(z);
    interp2d(z, trace._emptypoints);
  }
  function noZsmooth(msg) {
    zsmooth = trace._input.zsmooth = trace.zsmooth = false;
    Lib.warn('cannot use zsmooth: "fast": ' + msg);
  }
  function scaleIsLinear(s) {
    if (s.length > 1) {
      var avgdx = (s[s.length - 1] - s[0]) / (s.length - 1);
      var maxErrX = Math.abs(avgdx / 100);
      for (i = 0; i < s.length - 1; i++) {
        if (Math.abs(s[i + 1] - s[i] - avgdx) > maxErrX) {
          return false;
        }
      }
    }
    return true;
  }

  // Check whether all brick are uniform
  trace._islinear = false;
  if (xa.type === 'log' || ya.type === 'log') {
    if (zsmooth === 'fast') {
      noZsmooth('log axis found');
    }
  } else if (!scaleIsLinear(x)) {
    if (zsmooth === 'fast') noZsmooth('x scale is not linear');
  } else if (!scaleIsLinear(y)) {
    if (zsmooth === 'fast') noZsmooth('y scale is not linear');
  } else {
    trace._islinear = true;
  }

  // create arrays of brick boundaries, to be used by autorange and heatmap.plot
  var xlen = Lib.maxRowLength(z);
  var xIn = trace.xtype === 'scaled' ? '' : x;
  var xArray = makeBoundArray(trace, xIn, x0, dx, xlen, xa);
  var yIn = trace.ytype === 'scaled' ? '' : y;
  var yArray = makeBoundArray(trace, yIn, y0, dy, z.length, ya);

  // handled in gl2d convert step
  if (!isGL2D) {
    trace._extremes[xa._id] = Axes.findExtremes(xa, xArray);
    trace._extremes[ya._id] = Axes.findExtremes(ya, yArray);
  }
  var cd0 = {
    x: xArray,
    y: yArray,
    z: z,
    text: trace._text || trace.text,
    hovertext: trace._hovertext || trace.hovertext
  };
  if (trace.xperiodalignment && origX) {
    cd0.orig_x = origX;
  }
  if (trace.yperiodalignment && origY) {
    cd0.orig_y = origY;
  }
  if (xIn && xIn.length === xArray.length - 1) cd0.xCenter = xIn;
  if (yIn && yIn.length === yArray.length - 1) cd0.yCenter = yIn;
  if (isHist) {
    cd0.xRanges = binned.xRanges;
    cd0.yRanges = binned.yRanges;
    cd0.pts = binned.pts;
  }
  if (!isContour) {
    colorscaleCalc(gd, trace, {
      vals: z,
      cLetter: 'z'
    });
  }
  if (isContour && trace.contours && trace.contours.coloring === 'heatmap') {
    var dummyTrace = {
      type: trace.type === 'contour' ? 'heatmap' : 'histogram2d',
      xcalendar: trace.xcalendar,
      ycalendar: trace.ycalendar
    };
    cd0.xfill = makeBoundArray(dummyTrace, xIn, x0, dx, xlen, xa);
    cd0.yfill = makeBoundArray(dummyTrace, yIn, y0, dy, z.length, ya);
  }
  return [cd0];
};
function skipBreaks(a) {
  var b = [];
  var len = a.length;
  for (var i = 0; i < len; i++) {
    var v = a[i];
    if (v !== BADNUM) b.push(v);
  }
  return b;
}
function dropZonBreaks(x, y, z) {
  var newZ = [];
  var k = -1;
  for (var i = 0; i < z.length; i++) {
    if (y[i] === BADNUM) continue;
    k++;
    newZ[k] = [];
    for (var j = 0; j < z[i].length; j++) {
      if (x[j] === BADNUM) continue;
      newZ[k].push(z[i][j]);
    }
  }
  return newZ;
}

/***/ }),

/***/ 93877:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isNumeric = __webpack_require__(10721);
var Lib = __webpack_require__(34809);
var BADNUM = (__webpack_require__(63821).BADNUM);
module.exports = function clean2dArray(zOld, trace, xa, ya) {
  var rowlen, collen, getCollen, old2new, i, j;
  function cleanZvalue(v) {
    if (!isNumeric(v)) return undefined;
    return +v;
  }
  if (trace && trace.transpose) {
    rowlen = 0;
    for (i = 0; i < zOld.length; i++) rowlen = Math.max(rowlen, zOld[i].length);
    if (rowlen === 0) return false;
    getCollen = function (zOld) {
      return zOld.length;
    };
    old2new = function (zOld, i, j) {
      return (zOld[j] || [])[i];
    };
  } else {
    rowlen = zOld.length;
    getCollen = function (zOld, i) {
      return zOld[i].length;
    };
    old2new = function (zOld, i, j) {
      return (zOld[i] || [])[j];
    };
  }
  var padOld2new = function (zOld, i, j) {
    if (i === BADNUM || j === BADNUM) return BADNUM;
    return old2new(zOld, i, j);
  };
  function axisMapping(ax) {
    if (trace && trace.type !== 'carpet' && trace.type !== 'contourcarpet' && ax && ax.type === 'category' && trace['_' + ax._id.charAt(0)].length) {
      var axLetter = ax._id.charAt(0);
      var axMapping = {};
      var traceCategories = trace['_' + axLetter + 'CategoryMap'] || trace[axLetter];
      for (i = 0; i < traceCategories.length; i++) {
        axMapping[traceCategories[i]] = i;
      }
      return function (i) {
        var ind = axMapping[ax._categories[i]];
        return ind + 1 ? ind : BADNUM;
      };
    } else {
      return Lib.identity;
    }
  }
  var xMap = axisMapping(xa);
  var yMap = axisMapping(ya);
  if (ya && ya.type === 'category') rowlen = ya._categories.length;
  var zNew = new Array(rowlen);
  for (i = 0; i < rowlen; i++) {
    if (xa && xa.type === 'category') {
      collen = xa._categories.length;
    } else {
      collen = getCollen(zOld, i);
    }
    zNew[i] = new Array(collen);
    for (j = 0; j < collen; j++) zNew[i][j] = cleanZvalue(padOld2new(zOld, yMap(i), xMap(j)));
  }
  return zNew;
};

/***/ }),

/***/ 12431:
/***/ (function(module) {

"use strict";


module.exports = {
  min: 'zmin',
  max: 'zmax'
};

/***/ }),

/***/ 87869:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var BADNUM = (__webpack_require__(63821).BADNUM);
var alignPeriod = __webpack_require__(40528);
module.exports = function convertColumnData(trace, ax1, ax2, var1Name, var2Name, arrayVarNames) {
  var colLen = trace._length;
  var col1 = ax1.makeCalcdata(trace, var1Name);
  var col2 = ax2.makeCalcdata(trace, var2Name);
  col1 = alignPeriod(trace, ax1, var1Name, col1).vals;
  col2 = alignPeriod(trace, ax2, var2Name, col2).vals;
  var textCol = trace.text;
  var hasColumnText = textCol !== undefined && Lib.isArray1D(textCol);
  var hoverTextCol = trace.hovertext;
  var hasColumnHoverText = hoverTextCol !== undefined && Lib.isArray1D(hoverTextCol);
  var i, j;
  var col1dv = Lib.distinctVals(col1);
  var col1vals = col1dv.vals;
  var col2dv = Lib.distinctVals(col2);
  var col2vals = col2dv.vals;
  var newArrays = [];
  var text;
  var hovertext;
  var nI = col2vals.length;
  var nJ = col1vals.length;
  for (i = 0; i < arrayVarNames.length; i++) {
    newArrays[i] = Lib.init2dArray(nI, nJ);
  }
  if (hasColumnText) {
    text = Lib.init2dArray(nI, nJ);
  }
  if (hasColumnHoverText) {
    hovertext = Lib.init2dArray(nI, nJ);
  }
  var after2before = Lib.init2dArray(nI, nJ);
  for (i = 0; i < colLen; i++) {
    if (col1[i] !== BADNUM && col2[i] !== BADNUM) {
      var i1 = Lib.findBin(col1[i] + col1dv.minDiff / 2, col1vals);
      var i2 = Lib.findBin(col2[i] + col2dv.minDiff / 2, col2vals);
      for (j = 0; j < arrayVarNames.length; j++) {
        var arrayVarName = arrayVarNames[j];
        var arrayVar = trace[arrayVarName];
        var newArray = newArrays[j];
        newArray[i2][i1] = arrayVar[i];
        after2before[i2][i1] = i;
      }
      if (hasColumnText) text[i2][i1] = textCol[i];
      if (hasColumnHoverText) hovertext[i2][i1] = hoverTextCol[i];
    }
  }
  trace['_' + var1Name] = col1vals;
  trace['_' + var2Name] = col2vals;
  for (j = 0; j < arrayVarNames.length; j++) {
    trace['_' + arrayVarNames[j]] = newArrays[j];
  }
  if (hasColumnText) trace._text = text;
  if (hasColumnHoverText) trace._hovertext = hovertext;
  if (ax1 && ax1.type === 'category') {
    trace['_' + var1Name + 'CategoryMap'] = col1vals.map(function (v) {
      return ax1._categories[v];
    });
  }
  if (ax2 && ax2.type === 'category') {
    trace['_' + var2Name + 'CategoryMap'] = col2vals.map(function (v) {
      return ax2._categories[v];
    });
  }
  trace._after2before = after2before;
};

/***/ }),

/***/ 52813:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var handleXYZDefaults = __webpack_require__(86073);
var handleHeatmapLabelDefaults = __webpack_require__(63814);
var handlePeriodDefaults = __webpack_require__(99669);
var handleStyleDefaults = __webpack_require__(44143);
var colorscaleDefaults = __webpack_require__(39356);
var attributes = __webpack_require__(81658);
module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
  function coerce(attr, dflt) {
    return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
  }
  var validData = handleXYZDefaults(traceIn, traceOut, coerce, layout);
  if (!validData) {
    traceOut.visible = false;
    return;
  }
  handlePeriodDefaults(traceIn, traceOut, layout, coerce);
  coerce('xhoverformat');
  coerce('yhoverformat');
  coerce('text');
  coerce('hovertext');
  coerce('hovertemplate');
  handleHeatmapLabelDefaults(coerce, layout);
  handleStyleDefaults(traceIn, traceOut, coerce, layout);
  coerce('hoverongaps');
  coerce('connectgaps', Lib.isArray1D(traceOut.z) && traceOut.zsmooth !== false);
  colorscaleDefaults(traceIn, traceOut, layout, coerce, {
    prefix: '',
    cLetter: 'z'
  });
  coerce('zorder');
};

/***/ }),

/***/ 78106:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var maxRowLength = (__webpack_require__(34809).maxRowLength);

/* Return a list of empty points in 2D array z
 * each empty point z[i][j] gives an array [i, j, neighborCount]
 * neighborCount is the count of 4 nearest neighbors that DO exist
 * this is to give us an order of points to evaluate for interpolation.
 * if no neighbors exist, we iteratively look for neighbors that HAVE
 * neighbors, and add a fractional neighborCount
 */
module.exports = function findEmpties(z) {
  var empties = [];
  var neighborHash = {};
  var noNeighborList = [];
  var nextRow = z[0];
  var row = [];
  var blank = [0, 0, 0];
  var rowLength = maxRowLength(z);
  var prevRow;
  var i;
  var j;
  var thisPt;
  var p;
  var neighborCount;
  var newNeighborHash;
  var foundNewNeighbors;
  for (i = 0; i < z.length; i++) {
    prevRow = row;
    row = nextRow;
    nextRow = z[i + 1] || [];
    for (j = 0; j < rowLength; j++) {
      if (row[j] === undefined) {
        neighborCount = (row[j - 1] !== undefined ? 1 : 0) + (row[j + 1] !== undefined ? 1 : 0) + (prevRow[j] !== undefined ? 1 : 0) + (nextRow[j] !== undefined ? 1 : 0);
        if (neighborCount) {
          // for this purpose, don't count off-the-edge points
          // as undefined neighbors
          if (i === 0) neighborCount++;
          if (j === 0) neighborCount++;
          if (i === z.length - 1) neighborCount++;
          if (j === row.length - 1) neighborCount++;

          // if all neighbors that could exist do, we don't
          // need this for finding farther neighbors
          if (neighborCount < 4) {
            neighborHash[[i, j]] = [i, j, neighborCount];
          }
          empties.push([i, j, neighborCount]);
        } else noNeighborList.push([i, j]);
      }
    }
  }
  while (noNeighborList.length) {
    newNeighborHash = {};
    foundNewNeighbors = false;

    // look for cells that now have neighbors but didn't before
    for (p = noNeighborList.length - 1; p >= 0; p--) {
      thisPt = noNeighborList[p];
      i = thisPt[0];
      j = thisPt[1];
      neighborCount = ((neighborHash[[i - 1, j]] || blank)[2] + (neighborHash[[i + 1, j]] || blank)[2] + (neighborHash[[i, j - 1]] || blank)[2] + (neighborHash[[i, j + 1]] || blank)[2]) / 20;
      if (neighborCount) {
        newNeighborHash[thisPt] = [i, j, neighborCount];
        noNeighborList.splice(p, 1);
        foundNewNeighbors = true;
      }
    }
    if (!foundNewNeighbors) {
      throw 'findEmpties iterated with no new neighbors';
    }

    // put these new cells into the main neighbor list
    for (thisPt in newNeighborHash) {
      neighborHash[thisPt] = newNeighborHash[thisPt];
      empties.push(newNeighborHash[thisPt]);
    }
  }

  // sort the full list in descending order of neighbor count
  return empties.sort(function (a, b) {
    return b[2] - a[2];
  });
};

/***/ }),

/***/ 93125:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Fx = __webpack_require__(32141);
var Lib = __webpack_require__(34809);
var isArrayOrTypedArray = Lib.isArrayOrTypedArray;
var Axes = __webpack_require__(29714);
var extractOpts = (__webpack_require__(88856).extractOpts);
module.exports = function hoverPoints(pointData, xval, yval, hovermode, opts) {
  if (!opts) opts = {};
  var isContour = opts.isContour;
  var cd0 = pointData.cd[0];
  var trace = cd0.trace;
  var xa = pointData.xa;
  var ya = pointData.ya;
  var x = cd0.x;
  var y = cd0.y;
  var z = cd0.z;
  var xc = cd0.xCenter;
  var yc = cd0.yCenter;
  var zmask = cd0.zmask;
  var zhoverformat = trace.zhoverformat;
  var x2 = x;
  var y2 = y;
  var xl, yl, nx, ny;
  if (pointData.index !== false) {
    try {
      nx = Math.round(pointData.index[1]);
      ny = Math.round(pointData.index[0]);
    } catch (e) {
      Lib.error('Error hovering on heatmap, ' + 'pointNumber must be [row,col], found:', pointData.index);
      return;
    }
    if (nx < 0 || nx >= z[0].length || ny < 0 || ny > z.length) {
      return;
    }
  } else if (Fx.inbox(xval - x[0], xval - x[x.length - 1], 0) > 0 || Fx.inbox(yval - y[0], yval - y[y.length - 1], 0) > 0) {
    return;
  } else {
    if (isContour) {
      var i2;
      x2 = [2 * x[0] - x[1]];
      for (i2 = 1; i2 < x.length; i2++) {
        x2.push((x[i2] + x[i2 - 1]) / 2);
      }
      x2.push([2 * x[x.length - 1] - x[x.length - 2]]);
      y2 = [2 * y[0] - y[1]];
      for (i2 = 1; i2 < y.length; i2++) {
        y2.push((y[i2] + y[i2 - 1]) / 2);
      }
      y2.push([2 * y[y.length - 1] - y[y.length - 2]]);
    }
    nx = Math.max(0, Math.min(x2.length - 2, Lib.findBin(xval, x2)));
    ny = Math.max(0, Math.min(y2.length - 2, Lib.findBin(yval, y2)));
  }
  var x0 = xa.c2p(x[nx]);
  var x1 = xa.c2p(x[nx + 1]);
  var y0 = ya.c2p(y[ny]);
  var y1 = ya.c2p(y[ny + 1]);
  var _x, _y;
  if (isContour) {
    _x = cd0.orig_x || x;
    _y = cd0.orig_y || y;
    x1 = x0;
    xl = _x[nx];
    y1 = y0;
    yl = _y[ny];
  } else {
    _x = cd0.orig_x || xc || x;
    _y = cd0.orig_y || yc || y;
    xl = xc ? _x[nx] : (_x[nx] + _x[nx + 1]) / 2;
    yl = yc ? _y[ny] : (_y[ny] + _y[ny + 1]) / 2;
    if (xa && xa.type === 'category') xl = x[nx];
    if (ya && ya.type === 'category') yl = y[ny];
    if (trace.zsmooth) {
      x0 = x1 = xa.c2p(xl);
      y0 = y1 = ya.c2p(yl);
    }
  }
  var zVal = z[ny][nx];
  if (zmask && !zmask[ny][nx]) zVal = undefined;
  if (zVal === undefined && !trace.hoverongaps) return;
  var text;
  if (isArrayOrTypedArray(cd0.hovertext) && isArrayOrTypedArray(cd0.hovertext[ny])) {
    text = cd0.hovertext[ny][nx];
  } else if (isArrayOrTypedArray(cd0.text) && isArrayOrTypedArray(cd0.text[ny])) {
    text = cd0.text[ny][nx];
  }

  // dummy axis for formatting the z value
  var cOpts = extractOpts(trace);
  var dummyAx = {
    type: 'linear',
    range: [cOpts.min, cOpts.max],
    hoverformat: zhoverformat,
    _separators: xa._separators,
    _numFormat: xa._numFormat
  };
  var zLabel = Axes.tickText(dummyAx, zVal, 'hover').text;
  return [Lib.extendFlat(pointData, {
    index: trace._after2before ? trace._after2before[ny][nx] : [ny, nx],
    // never let a 2D override 1D type as closest point
    distance: pointData.maxHoverDistance,
    spikeDistance: pointData.maxSpikeDistance,
    x0: x0,
    x1: x1,
    y0: y0,
    y1: y1,
    xLabelVal: xl,
    yLabelVal: yl,
    zLabelVal: zVal,
    zLabel: zLabel,
    text: text
  })];
};

/***/ }),

/***/ 29251:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = {
  attributes: __webpack_require__(81658),
  supplyDefaults: __webpack_require__(52813),
  calc: __webpack_require__(51670),
  plot: __webpack_require__(19236),
  colorbar: __webpack_require__(12431),
  style: __webpack_require__(12774),
  hoverPoints: __webpack_require__(93125),
  moduleType: 'trace',
  name: 'heatmap',
  basePlotModule: __webpack_require__(37703),
  categories: ['cartesian', 'svg', '2dMap', 'showLegend'],
  meta: {}
};

/***/ }),

/***/ 69295:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var INTERPTHRESHOLD = 1e-2;
var NEIGHBORSHIFTS = [[-1, 0], [1, 0], [0, -1], [0, 1]];
function correctionOvershoot(maxFractionalChange) {
  // start with less overshoot, until we know it's converging,
  // then ramp up the overshoot for faster convergence
  return 0.5 - 0.25 * Math.min(1, maxFractionalChange * 0.5);
}

/*
 * interp2d: Fill in missing data from a 2D array using an iterative
 *   poisson equation solver with zero-derivative BC at edges.
 *   Amazingly, this just amounts to repeatedly averaging all the existing
 *   nearest neighbors, at least if we don't take x/y scaling into account,
 *   which is the right approach here where x and y may not even have the
 *   same units.
 *
 * @param {array of arrays} z
 *      The 2D array to fill in. Will be mutated here. Assumed to already be
 *      cleaned, so all entries are numbers except gaps, which are `undefined`.
 * @param {array of arrays} emptyPoints
 *      Each entry [i, j, neighborCount] for empty points z[i][j] and the number
 *      of neighbors that are *not* missing. Assumed to be sorted from most to
 *      least neighbors, as produced by heatmap/find_empties.
 */
module.exports = function interp2d(z, emptyPoints) {
  var maxFractionalChange = 1;
  var i;

  // one pass to fill in a starting value for all the empties
  iterateInterp2d(z, emptyPoints);

  // we're don't need to iterate lone empties - remove them
  for (i = 0; i < emptyPoints.length; i++) {
    if (emptyPoints[i][2] < 4) break;
  }
  // but don't remove these points from the original array,
  // we'll use them for masking, so make a copy.
  emptyPoints = emptyPoints.slice(i);
  for (i = 0; i < 100 && maxFractionalChange > INTERPTHRESHOLD; i++) {
    maxFractionalChange = iterateInterp2d(z, emptyPoints, correctionOvershoot(maxFractionalChange));
  }
  if (maxFractionalChange > INTERPTHRESHOLD) {
    Lib.log('interp2d didn\'t converge quickly', maxFractionalChange);
  }
  return z;
};
function iterateInterp2d(z, emptyPoints, overshoot) {
  var maxFractionalChange = 0;
  var thisPt;
  var i;
  var j;
  var p;
  var q;
  var neighborShift;
  var neighborRow;
  var neighborVal;
  var neighborCount;
  var neighborSum;
  var initialVal;
  var minNeighbor;
  var maxNeighbor;
  for (p = 0; p < emptyPoints.length; p++) {
    thisPt = emptyPoints[p];
    i = thisPt[0];
    j = thisPt[1];
    initialVal = z[i][j];
    neighborSum = 0;
    neighborCount = 0;
    for (q = 0; q < 4; q++) {
      neighborShift = NEIGHBORSHIFTS[q];
      neighborRow = z[i + neighborShift[0]];
      if (!neighborRow) continue;
      neighborVal = neighborRow[j + neighborShift[1]];
      if (neighborVal !== undefined) {
        if (neighborSum === 0) {
          minNeighbor = maxNeighbor = neighborVal;
        } else {
          minNeighbor = Math.min(minNeighbor, neighborVal);
          maxNeighbor = Math.max(maxNeighbor, neighborVal);
        }
        neighborCount++;
        neighborSum += neighborVal;
      }
    }
    if (neighborCount === 0) {
      throw 'iterateInterp2d order is wrong: no defined neighbors';
    }

    // this is the laplace equation interpolation:
    // each point is just the average of its neighbors
    // note that this ignores differential x/y scaling
    // which I think is the right approach, since we
    // don't know what that scaling means
    z[i][j] = neighborSum / neighborCount;
    if (initialVal === undefined) {
      if (neighborCount < 4) maxFractionalChange = 1;
    } else {
      // we can make large empty regions converge faster
      // if we overshoot the change vs the previous value
      z[i][j] = (1 + overshoot) * z[i][j] - overshoot * initialVal;
      if (maxNeighbor > minNeighbor) {
        maxFractionalChange = Math.max(maxFractionalChange, Math.abs(z[i][j] - initialVal) / (maxNeighbor - minNeighbor));
      }
    }
  }
  return maxFractionalChange;
}

/***/ }),

/***/ 63814:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
module.exports = function handleHeatmapLabelDefaults(coerce, layout) {
  coerce('texttemplate');
  var fontDflt = Lib.extendFlat({}, layout.font, {
    color: 'auto',
    size: 'auto'
  });
  Lib.coerceFont(coerce, 'textfont', fontDflt);
};

/***/ }),

/***/ 80924:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Registry = __webpack_require__(33626);
var isArrayOrTypedArray = (__webpack_require__(34809).isArrayOrTypedArray);
module.exports = function makeBoundArray(trace, arrayIn, v0In, dvIn, numbricks, ax) {
  var arrayOut = [];
  var isContour = Registry.traceIs(trace, 'contour');
  var isHist = Registry.traceIs(trace, 'histogram');
  var isGL2D = Registry.traceIs(trace, 'gl2d');
  var v0;
  var dv;
  var i;
  var isArrayOfTwoItemsOrMore = isArrayOrTypedArray(arrayIn) && arrayIn.length > 1;
  if (isArrayOfTwoItemsOrMore && !isHist && ax.type !== 'category') {
    var len = arrayIn.length;

    // given vals are brick centers
    // hopefully length === numbricks, but use this method even if too few are supplied
    // and extend it linearly based on the last two points
    if (len <= numbricks) {
      // contour plots only want the centers
      if (isContour || isGL2D) arrayOut = Array.from(arrayIn).slice(0, numbricks);else if (numbricks === 1) {
        if (ax.type === 'log') {
          arrayOut = [0.5 * arrayIn[0], 2 * arrayIn[0]];
        } else {
          arrayOut = [arrayIn[0] - 0.5, arrayIn[0] + 0.5];
        }
      } else if (ax.type === 'log') {
        arrayOut = [Math.pow(arrayIn[0], 1.5) / Math.pow(arrayIn[1], 0.5)];
        for (i = 1; i < len; i++) {
          // Geomean
          arrayOut.push(Math.sqrt(arrayIn[i - 1] * arrayIn[i]));
        }
        arrayOut.push(Math.pow(arrayIn[len - 1], 1.5) / Math.pow(arrayIn[len - 2], 0.5));
      } else {
        arrayOut = [1.5 * arrayIn[0] - 0.5 * arrayIn[1]];
        for (i = 1; i < len; i++) {
          // Arithmetic mean
          arrayOut.push((arrayIn[i - 1] + arrayIn[i]) * 0.5);
        }
        arrayOut.push(1.5 * arrayIn[len - 1] - 0.5 * arrayIn[len - 2]);
      }
      if (len < numbricks) {
        var lastPt = arrayOut[arrayOut.length - 1];
        var delta; // either multiplicative delta (log axis type) or arithmetic delta (all other axis types)
        if (ax.type === 'log') {
          delta = lastPt / arrayOut[arrayOut.length - 2];
          for (i = len; i < numbricks; i++) {
            lastPt *= delta;
            arrayOut.push(lastPt);
          }
        } else {
          delta = lastPt - arrayOut[arrayOut.length - 2];
          for (i = len; i < numbricks; i++) {
            lastPt += delta;
            arrayOut.push(lastPt);
          }
        }
      }
    } else {
      // hopefully length === numbricks+1, but do something regardless:
      // given vals are brick boundaries
      return isContour ? arrayIn.slice(0, numbricks) :
      // we must be strict for contours
      arrayIn.slice(0, numbricks + 1);
    }
  } else {
    var calendar = trace[ax._id.charAt(0) + 'calendar'];
    if (isHist) {
      v0 = ax.r2c(v0In, 0, calendar);
    } else {
      if (isArrayOrTypedArray(arrayIn) && arrayIn.length === 1) {
        v0 = arrayIn[0];
      } else if (v0In === undefined) {
        v0 = 0;
      } else {
        var fn = ax.type === 'log' ? ax.d2c : ax.r2c;
        v0 = fn(v0In, 0, calendar);
      }
    }
    dv = dvIn || 1;
    for (i = isContour || isGL2D ? 0 : -0.5; i < numbricks; i++) {
      arrayOut.push(v0 + dv * i);
    }
  }
  return arrayOut;
};

/***/ }),

/***/ 19236:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var tinycolor = __webpack_require__(65657);
var Registry = __webpack_require__(33626);
var Drawing = __webpack_require__(62203);
var Axes = __webpack_require__(29714);
var Lib = __webpack_require__(34809);
var svgTextUtils = __webpack_require__(30635);
var formatLabels = __webpack_require__(15294);
var Color = __webpack_require__(78766);
var extractOpts = (__webpack_require__(88856).extractOpts);
var makeColorScaleFuncFromTrace = (__webpack_require__(88856).makeColorScaleFuncFromTrace);
var xmlnsNamespaces = __webpack_require__(62972);
var alignmentConstants = __webpack_require__(4530);
var LINE_SPACING = alignmentConstants.LINE_SPACING;
var supportsPixelatedImage = __webpack_require__(95544);
var PIXELATED_IMAGE_STYLE = (__webpack_require__(1837).STYLE);
var labelClass = 'heatmap-label';
function selectLabels(plotGroup) {
  return plotGroup.selectAll('g.' + labelClass);
}
function removeLabels(plotGroup) {
  selectLabels(plotGroup).remove();
}
module.exports = function (gd, plotinfo, cdheatmaps, heatmapLayer) {
  var xa = plotinfo.xaxis;
  var ya = plotinfo.yaxis;
  Lib.makeTraceGroups(heatmapLayer, cdheatmaps, 'hm').each(function (cd) {
    var plotGroup = d3.select(this);
    var cd0 = cd[0];
    var trace = cd0.trace;
    var xGap = trace.xgap || 0;
    var yGap = trace.ygap || 0;
    var z = cd0.z;
    var x = cd0.x;
    var y = cd0.y;
    var xc = cd0.xCenter;
    var yc = cd0.yCenter;
    var isContour = Registry.traceIs(trace, 'contour');
    var zsmooth = isContour ? 'best' : trace.zsmooth;

    // get z dims
    var m = z.length;
    var n = Lib.maxRowLength(z);
    var xrev = false;
    var yrev = false;
    var left, right, temp, top, bottom, i, j, k;

    // TODO: if there are multiple overlapping categorical heatmaps,
    // or if we allow category sorting, then the categories may not be
    // sequential... may need to reorder and/or expand z

    // Get edges of png in pixels (xa.c2p() maps axes coordinates to pixel coordinates)
    // figure out if either axis is reversed (y is usually reversed, in pixel coords)
    // also clip the image to maximum 50% outside the visible plot area
    // bigger image lets you pan more naturally, but slows performance.
    // TODO: use low-resolution images outside the visible plot for panning
    // these while loops find the first and last brick bounds that are defined
    // (in case of log of a negative)
    i = 0;
    while (left === undefined && i < x.length - 1) {
      left = xa.c2p(x[i]);
      i++;
    }
    i = x.length - 1;
    while (right === undefined && i > 0) {
      right = xa.c2p(x[i]);
      i--;
    }
    if (right < left) {
      temp = right;
      right = left;
      left = temp;
      xrev = true;
    }
    i = 0;
    while (top === undefined && i < y.length - 1) {
      top = ya.c2p(y[i]);
      i++;
    }
    i = y.length - 1;
    while (bottom === undefined && i > 0) {
      bottom = ya.c2p(y[i]);
      i--;
    }
    if (bottom < top) {
      temp = top;
      top = bottom;
      bottom = temp;
      yrev = true;
    }

    // for contours with heatmap fill, we generate the boundaries based on
    // brick centers but then use the brick edges for drawing the bricks
    if (isContour) {
      xc = x;
      yc = y;
      x = cd0.xfill;
      y = cd0.yfill;
    }
    var drawingMethod = 'default';
    if (zsmooth) {
      drawingMethod = zsmooth === 'best' ? 'smooth' : 'fast';
    } else if (trace._islinear && xGap === 0 && yGap === 0 && supportsPixelatedImage()) {
      drawingMethod = 'fast';
    }

    // make an image that goes at most half a screen off either side, to keep
    // time reasonable when you zoom in. if drawingMethod is fast, don't worry
    // about this, because zooming doesn't increase number of pixels
    // if zsmooth is best, don't include anything off screen because it takes too long
    if (drawingMethod !== 'fast') {
      var extra = zsmooth === 'best' ? 0 : 0.5;
      left = Math.max(-extra * xa._length, left);
      right = Math.min((1 + extra) * xa._length, right);
      top = Math.max(-extra * ya._length, top);
      bottom = Math.min((1 + extra) * ya._length, bottom);
    }
    var imageWidth = Math.round(right - left);
    var imageHeight = Math.round(bottom - top);

    // setup image nodes

    // if image is entirely off-screen, don't even draw it
    var isOffScreen = left >= xa._length || right <= 0 || top >= ya._length || bottom <= 0;
    if (isOffScreen) {
      var noImage = plotGroup.selectAll('image').data([]);
      noImage.exit().remove();
      removeLabels(plotGroup);
      return;
    }

    // generate image data

    var canvasW, canvasH;
    if (drawingMethod === 'fast') {
      canvasW = n;
      canvasH = m;
    } else {
      canvasW = imageWidth;
      canvasH = imageHeight;
    }
    var canvas = document.createElement('canvas');
    canvas.width = canvasW;
    canvas.height = canvasH;
    var context = canvas.getContext('2d', {
      willReadFrequently: true
    });
    var sclFunc = makeColorScaleFuncFromTrace(trace, {
      noNumericCheck: true,
      returnArray: true
    });

    // map brick boundaries to image pixels
    var xpx, ypx;
    if (drawingMethod === 'fast') {
      xpx = xrev ? function (index) {
        return n - 1 - index;
      } : Lib.identity;
      ypx = yrev ? function (index) {
        return m - 1 - index;
      } : Lib.identity;
    } else {
      xpx = function (index) {
        return Lib.constrain(Math.round(xa.c2p(x[index]) - left), 0, imageWidth);
      };
      ypx = function (index) {
        return Lib.constrain(Math.round(ya.c2p(y[index]) - top), 0, imageHeight);
      };
    }

    // build the pixel map brick-by-brick
    // cruise through z-matrix row-by-row
    // build a brick at each z-matrix value
    var yi = ypx(0);
    var yb = [yi, yi];
    var xbi = xrev ? 0 : 1;
    var ybi = yrev ? 0 : 1;
    // for collecting an average luminosity of the heatmap
    var pixcount = 0;
    var rcount = 0;
    var gcount = 0;
    var bcount = 0;
    var xb, xi, v, row, c;
    function setColor(v, pixsize) {
      if (v !== undefined) {
        var c = sclFunc(v);
        c[0] = Math.round(c[0]);
        c[1] = Math.round(c[1]);
        c[2] = Math.round(c[2]);
        pixcount += pixsize;
        rcount += c[0] * pixsize;
        gcount += c[1] * pixsize;
        bcount += c[2] * pixsize;
        return c;
      }
      return [0, 0, 0, 0];
    }
    function interpColor(r0, r1, xinterp, yinterp) {
      var z00 = r0[xinterp.bin0];
      if (z00 === undefined) return setColor(undefined, 1);
      var z01 = r0[xinterp.bin1];
      var z10 = r1[xinterp.bin0];
      var z11 = r1[xinterp.bin1];
      var dx = z01 - z00 || 0;
      var dy = z10 - z00 || 0;
      var dxy;

      // the bilinear interpolation term needs different calculations
      // for all the different permutations of missing data
      // among the neighbors of the main point, to ensure
      // continuity across brick boundaries.
      if (z01 === undefined) {
        if (z11 === undefined) dxy = 0;else if (z10 === undefined) dxy = 2 * (z11 - z00);else dxy = (2 * z11 - z10 - z00) * 2 / 3;
      } else if (z11 === undefined) {
        if (z10 === undefined) dxy = 0;else dxy = (2 * z00 - z01 - z10) * 2 / 3;
      } else if (z10 === undefined) dxy = (2 * z11 - z01 - z00) * 2 / 3;else dxy = z11 + z00 - z01 - z10;
      return setColor(z00 + xinterp.frac * dx + yinterp.frac * (dy + xinterp.frac * dxy));
    }
    if (drawingMethod !== 'default') {
      // works fastest with imageData
      var pxIndex = 0;
      var pixels;
      try {
        pixels = new Uint8Array(canvasW * canvasH * 4);
      } catch (e) {
        pixels = new Array(canvasW * canvasH * 4);
      }
      if (drawingMethod === 'smooth') {
        // zsmooth="best"
        var xForPx = xc || x;
        var yForPx = yc || y;
        var xPixArray = new Array(xForPx.length);
        var yPixArray = new Array(yForPx.length);
        var xinterpArray = new Array(imageWidth);
        var findInterpX = xc ? findInterpFromCenters : findInterp;
        var findInterpY = yc ? findInterpFromCenters : findInterp;
        var yinterp, r0, r1;

        // first make arrays of x and y pixel locations of brick boundaries
        for (i = 0; i < xForPx.length; i++) xPixArray[i] = Math.round(xa.c2p(xForPx[i]) - left);
        for (i = 0; i < yForPx.length; i++) yPixArray[i] = Math.round(ya.c2p(yForPx[i]) - top);

        // then make arrays of interpolations
        // (bin0=closest, bin1=next, frac=fractional dist.)
        for (i = 0; i < imageWidth; i++) xinterpArray[i] = findInterpX(i, xPixArray);

        // now do the interpolations and fill the png
        for (j = 0; j < imageHeight; j++) {
          yinterp = findInterpY(j, yPixArray);
          r0 = z[yinterp.bin0];
          r1 = z[yinterp.bin1];
          for (i = 0; i < imageWidth; i++, pxIndex += 4) {
            c = interpColor(r0, r1, xinterpArray[i], yinterp);
            putColor(pixels, pxIndex, c);
          }
        }
      } else {
        // drawingMethod = "fast" (zsmooth = "fast"|false)
        for (j = 0; j < m; j++) {
          row = z[j];
          yb = ypx(j);
          for (i = 0; i < n; i++) {
            c = setColor(row[i], 1);
            pxIndex = (yb * n + xpx(i)) * 4;
            putColor(pixels, pxIndex, c);
          }
        }
      }
      var imageData = context.createImageData(canvasW, canvasH);
      try {
        imageData.data.set(pixels);
      } catch (e) {
        var pxArray = imageData.data;
        var dlen = pxArray.length;
        for (j = 0; j < dlen; j++) {
          pxArray[j] = pixels[j];
        }
      }
      context.putImageData(imageData, 0, 0);
    } else {
      // rawingMethod = "default" (zsmooth = false)
      // filling potentially large bricks works fastest with fillRect
      // gaps do not need to be exact integers, but if they *are* we will get
      // cleaner edges by rounding at least one edge
      var xGapLeft = Math.floor(xGap / 2);
      var yGapTop = Math.floor(yGap / 2);
      for (j = 0; j < m; j++) {
        row = z[j];
        yb.reverse();
        yb[ybi] = ypx(j + 1);
        if (yb[0] === yb[1] || yb[0] === undefined || yb[1] === undefined) {
          continue;
        }
        xi = xpx(0);
        xb = [xi, xi];
        for (i = 0; i < n; i++) {
          // build one color brick!
          xb.reverse();
          xb[xbi] = xpx(i + 1);
          if (xb[0] === xb[1] || xb[0] === undefined || xb[1] === undefined) {
            continue;
          }
          v = row[i];
          c = setColor(v, (xb[1] - xb[0]) * (yb[1] - yb[0]));
          context.fillStyle = 'rgba(' + c.join(',') + ')';
          context.fillRect(xb[0] + xGapLeft, yb[0] + yGapTop, xb[1] - xb[0] - xGap, yb[1] - yb[0] - yGap);
        }
      }
    }
    rcount = Math.round(rcount / pixcount);
    gcount = Math.round(gcount / pixcount);
    bcount = Math.round(bcount / pixcount);
    var avgColor = tinycolor('rgb(' + rcount + ',' + gcount + ',' + bcount + ')');
    gd._hmpixcount = (gd._hmpixcount || 0) + pixcount;
    gd._hmlumcount = (gd._hmlumcount || 0) + pixcount * avgColor.getLuminance();
    var image3 = plotGroup.selectAll('image').data(cd);
    image3.enter().append('svg:image').attr({
      xmlns: xmlnsNamespaces.svg,
      preserveAspectRatio: 'none'
    });
    image3.attr({
      height: imageHeight,
      width: imageWidth,
      x: left,
      y: top,
      'xlink:href': canvas.toDataURL('image/png')
    });
    if (drawingMethod === 'fast' && !zsmooth) {
      image3.attr('style', PIXELATED_IMAGE_STYLE);
    }
    removeLabels(plotGroup);
    var texttemplate = trace.texttemplate;
    if (texttemplate) {
      // dummy axis for formatting the z value
      var cOpts = extractOpts(trace);
      var dummyAx = {
        type: 'linear',
        range: [cOpts.min, cOpts.max],
        _separators: xa._separators,
        _numFormat: xa._numFormat
      };
      var aHistogram2dContour = trace.type === 'histogram2dcontour';
      var aContour = trace.type === 'contour';
      var iStart = aContour ? 1 : 0;
      var iStop = aContour ? m - 1 : m;
      var jStart = aContour ? 1 : 0;
      var jStop = aContour ? n - 1 : n;
      var textData = [];
      for (i = iStart; i < iStop; i++) {
        var yVal;
        if (aContour) {
          yVal = cd0.y[i];
        } else if (aHistogram2dContour) {
          if (i === 0 || i === m - 1) continue;
          yVal = cd0.y[i];
        } else if (cd0.yCenter) {
          yVal = cd0.yCenter[i];
        } else {
          if (i + 1 === m && cd0.y[i + 1] === undefined) continue;
          yVal = (cd0.y[i] + cd0.y[i + 1]) / 2;
        }
        var _y = Math.round(ya.c2p(yVal));
        if (0 > _y || _y > ya._length) continue;
        for (j = jStart; j < jStop; j++) {
          var xVal;
          if (aContour) {
            xVal = cd0.x[j];
          } else if (aHistogram2dContour) {
            if (j === 0 || j === n - 1) continue;
            xVal = cd0.x[j];
          } else if (cd0.xCenter) {
            xVal = cd0.xCenter[j];
          } else {
            if (j + 1 === n && cd0.x[j + 1] === undefined) continue;
            xVal = (cd0.x[j] + cd0.x[j + 1]) / 2;
          }
          var _x = Math.round(xa.c2p(xVal));
          if (0 > _x || _x > xa._length) continue;
          var obj = formatLabels({
            x: xVal,
            y: yVal
          }, trace, gd._fullLayout);
          obj.x = xVal;
          obj.y = yVal;
          var zVal = cd0.z[i][j];
          if (zVal === undefined) {
            obj.z = '';
            obj.zLabel = '';
          } else {
            obj.z = zVal;
            obj.zLabel = Axes.tickText(dummyAx, zVal, 'hover').text;
          }
          var theText = cd0.text && cd0.text[i] && cd0.text[i][j];
          if (theText === undefined || theText === false) theText = '';
          obj.text = theText;
          var _t = Lib.texttemplateString(texttemplate, obj, gd._fullLayout._d3locale, obj, trace._meta || {});
          if (!_t) continue;
          var lines = _t.split('<br>');
          var nL = lines.length;
          var nC = 0;
          for (k = 0; k < nL; k++) {
            nC = Math.max(nC, lines[k].length);
          }
          textData.push({
            l: nL,
            // number of lines
            c: nC,
            // maximum number of chars in a line
            t: _t,
            // text
            x: _x,
            y: _y,
            z: zVal
          });
        }
      }
      var font = trace.textfont;
      var fontSize = font.size;
      var globalFontSize = gd._fullLayout.font.size;
      if (!fontSize || fontSize === 'auto') {
        var minW = Infinity;
        var minH = Infinity;
        var maxL = 0;
        var maxC = 0;
        for (k = 0; k < textData.length; k++) {
          var d = textData[k];
          maxL = Math.max(maxL, d.l);
          maxC = Math.max(maxC, d.c);
          if (k < textData.length - 1) {
            var nextD = textData[k + 1];
            var dx = Math.abs(nextD.x - d.x);
            var dy = Math.abs(nextD.y - d.y);
            if (dx) minW = Math.min(minW, dx);
            if (dy) minH = Math.min(minH, dy);
          }
        }
        if (!isFinite(minW) || !isFinite(minH)) {
          fontSize = globalFontSize;
        } else {
          minW -= xGap;
          minH -= yGap;
          minW /= maxC;
          minH /= maxL;
          minW /= LINE_SPACING / 2;
          minH /= LINE_SPACING;
          fontSize = Math.min(Math.floor(minW), Math.floor(minH), globalFontSize);
        }
      }
      if (fontSize <= 0 || !isFinite(fontSize)) return;
      var xFn = function (d) {
        return d.x;
      };
      var yFn = function (d) {
        return d.y - fontSize * (d.l * LINE_SPACING / 2 - 1);
      };
      var labels = selectLabels(plotGroup).data(textData);
      labels.enter().append('g').classed(labelClass, 1).append('text').attr('text-anchor', 'middle').each(function (d) {
        var thisLabel = d3.select(this);
        var fontColor = font.color;
        if (!fontColor || fontColor === 'auto') {
          fontColor = Color.contrast(d.z === undefined ? gd._fullLayout.plot_bgcolor : 'rgba(' + sclFunc(d.z).join() + ')');
        }
        thisLabel.attr('data-notex', 1).call(svgTextUtils.positionText, xFn(d), yFn(d)).call(Drawing.font, {
          family: font.family,
          size: fontSize,
          color: fontColor,
          weight: font.weight,
          style: font.style,
          variant: font.variant,
          textcase: font.textcase,
          lineposition: font.lineposition,
          shadow: font.shadow
        }).text(d.t).call(svgTextUtils.convertToTspans, gd);
      });
    }
  });
};

// get interpolated bin value. Returns {bin0:closest bin, frac:fractional dist to next, bin1:next bin}
function findInterp(pixel, pixArray) {
  var maxBin = pixArray.length - 2;
  var bin = Lib.constrain(Lib.findBin(pixel, pixArray), 0, maxBin);
  var pix0 = pixArray[bin];
  var pix1 = pixArray[bin + 1];
  var interp = Lib.constrain(bin + (pixel - pix0) / (pix1 - pix0) - 0.5, 0, maxBin);
  var bin0 = Math.round(interp);
  var frac = Math.abs(interp - bin0);
  if (!interp || interp === maxBin || !frac) {
    return {
      bin0: bin0,
      bin1: bin0,
      frac: 0
    };
  }
  return {
    bin0: bin0,
    frac: frac,
    bin1: Math.round(bin0 + frac / (interp - bin0))
  };
}
function findInterpFromCenters(pixel, centerPixArray) {
  var maxBin = centerPixArray.length - 1;
  var bin = Lib.constrain(Lib.findBin(pixel, centerPixArray), 0, maxBin);
  var pix0 = centerPixArray[bin];
  var pix1 = centerPixArray[bin + 1];
  var frac = (pixel - pix0) / (pix1 - pix0) || 0;
  if (frac <= 0) {
    return {
      bin0: bin,
      bin1: bin,
      frac: 0
    };
  }
  if (frac < 0.5) {
    return {
      bin0: bin,
      bin1: bin + 1,
      frac: frac
    };
  }
  return {
    bin0: bin + 1,
    bin1: bin,
    frac: 1 - frac
  };
}
function putColor(pixels, pxIndex, c) {
  pixels[pxIndex] = c[0];
  pixels[pxIndex + 1] = c[1];
  pixels[pxIndex + 2] = c[2];
  pixels[pxIndex + 3] = Math.round(c[3] * 255);
}

/***/ }),

/***/ 12774:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
module.exports = function style(gd) {
  d3.select(gd).selectAll('.hm image').style('opacity', function (d) {
    return d.trace.opacity;
  });
};

/***/ }),

/***/ 44143:
/***/ (function(module) {

"use strict";


module.exports = function handleStyleDefaults(traceIn, traceOut, coerce) {
  var zsmooth = coerce('zsmooth');
  if (zsmooth === false) {
    // ensure that xgap and ygap are coerced only when zsmooth allows them to have an effect.
    coerce('xgap');
    coerce('ygap');
  }
  coerce('zhoverformat');
};

/***/ }),

/***/ 86073:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isNumeric = __webpack_require__(10721);
var Lib = __webpack_require__(34809);
var Registry = __webpack_require__(33626);
module.exports = function handleXYZDefaults(traceIn, traceOut, coerce, layout, xName, yName) {
  var z = coerce('z');
  xName = xName || 'x';
  yName = yName || 'y';
  var x, y;
  if (z === undefined || !z.length) return 0;
  if (Lib.isArray1D(z)) {
    x = coerce(xName);
    y = coerce(yName);
    var xlen = Lib.minRowLength(x);
    var ylen = Lib.minRowLength(y);

    // column z must be accompanied by xName and yName arrays
    if (xlen === 0 || ylen === 0) return 0;
    traceOut._length = Math.min(xlen, ylen, z.length);
  } else {
    x = coordDefaults(xName, coerce);
    y = coordDefaults(yName, coerce);

    // TODO put z validation elsewhere
    if (!isValidZ(z)) return 0;
    coerce('transpose');
    traceOut._length = null;
  }
  if (traceIn.type === 'heatmapgl') return true; // skip calendars until we handle them in those traces

  var handleCalendarDefaults = Registry.getComponentMethod('calendars', 'handleTraceDefaults');
  handleCalendarDefaults(traceIn, traceOut, [xName, yName], layout);
  return true;
};
function coordDefaults(coordStr, coerce) {
  var coord = coerce(coordStr);
  var coordType = coord ? coerce(coordStr + 'type', 'array') : 'scaled';
  if (coordType === 'scaled') {
    coerce(coordStr + '0');
    coerce('d' + coordStr);
  }
  return coord;
}
function isValidZ(z) {
  var allRowsAreArrays = true;
  var oneRowIsFilled = false;
  var hasOneNumber = false;
  var zi;

  /*
   * Without this step:
   *
   * hasOneNumber = false breaks contour but not heatmap
   * allRowsAreArrays = false breaks contour but not heatmap
   * oneRowIsFilled = false breaks both
   */

  for (var i = 0; i < z.length; i++) {
    zi = z[i];
    if (!Lib.isArrayOrTypedArray(zi)) {
      allRowsAreArrays = false;
      break;
    }
    if (zi.length > 0) oneRowIsFilled = true;
    for (var j = 0; j < zi.length; j++) {
      if (isNumeric(zi[j])) {
        hasOneNumber = true;
        break;
      }
    }
  }
  return allRowsAreArrays && oneRowIsFilled && hasOneNumber;
}

/***/ }),

/***/ 29751:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var heatmapAttrs = __webpack_require__(81658);
var colorScaleAttrs = __webpack_require__(87163);
var extendFlat = (__webpack_require__(93049).extendFlat);
var overrideAll = (__webpack_require__(13582).overrideAll);
var commonList = ['z', 'x', 'x0', 'dx', 'y', 'y0', 'dy', 'text', 'transpose', 'xtype', 'ytype'];
var attrs = {};
for (var i = 0; i < commonList.length; i++) {
  var k = commonList[i];
  attrs[k] = heatmapAttrs[k];
}
attrs.zsmooth = {
  valType: 'enumerated',
  values: ['fast', false],
  dflt: 'fast',
  editType: 'calc'
};
extendFlat(attrs, colorScaleAttrs('', {
  cLetter: 'z',
  autoColorDflt: false
}));
module.exports = overrideAll(attrs, 'calc', 'nested');

/***/ }),

/***/ 89987:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var createHeatmap2D = (__webpack_require__(99098).gl_heatmap2d);
var Axes = __webpack_require__(29714);
var str2RGBArray = __webpack_require__(55010);
function Heatmap(scene, uid) {
  this.scene = scene;
  this.uid = uid;
  this.type = 'heatmapgl';
  this.name = '';
  this.hoverinfo = 'all';
  this.xData = [];
  this.yData = [];
  this.zData = [];
  this.textLabels = [];
  this.idToIndex = [];
  this.bounds = [0, 0, 0, 0];
  this.options = {
    zsmooth: 'fast',
    z: [],
    x: [],
    y: [],
    shape: [0, 0],
    colorLevels: [0],
    colorValues: [0, 0, 0, 1]
  };
  this.heatmap = createHeatmap2D(scene.glplot, this.options);
  this.heatmap._trace = this;
}
var proto = Heatmap.prototype;
proto.handlePick = function (pickResult) {
  var options = this.options;
  var shape = options.shape;
  var index = pickResult.pointId;
  var xIndex = index % shape[0];
  var yIndex = Math.floor(index / shape[0]);
  var zIndex = index;
  return {
    trace: this,
    dataCoord: pickResult.dataCoord,
    traceCoord: [options.x[xIndex], options.y[yIndex], options.z[zIndex]],
    textLabel: this.textLabels[index],
    name: this.name,
    pointIndex: [yIndex, xIndex],
    hoverinfo: this.hoverinfo
  };
};
proto.update = function (fullTrace, calcTrace) {
  var calcPt = calcTrace[0];
  this.index = fullTrace.index;
  this.name = fullTrace.name;
  this.hoverinfo = fullTrace.hoverinfo;

  // convert z from 2D -> 1D
  var z = calcPt.z;
  this.options.z = [].concat.apply([], z);
  var rowLen = z[0].length;
  var colLen = z.length;
  this.options.shape = [rowLen, colLen];
  this.options.x = calcPt.x;
  this.options.y = calcPt.y;
  this.options.zsmooth = fullTrace.zsmooth;
  var colorOptions = convertColorscale(fullTrace);
  this.options.colorLevels = colorOptions.colorLevels;
  this.options.colorValues = colorOptions.colorValues;

  // convert text from 2D -> 1D
  this.textLabels = [].concat.apply([], fullTrace.text);
  this.heatmap.update(this.options);
  var xa = this.scene.xaxis;
  var ya = this.scene.yaxis;
  var xOpts, yOpts;
  if (fullTrace.zsmooth === false) {
    // increase padding for discretised heatmap as suggested by Louise Ord
    xOpts = {
      ppad: calcPt.x[1] - calcPt.x[0]
    };
    yOpts = {
      ppad: calcPt.y[1] - calcPt.y[0]
    };
  }
  fullTrace._extremes[xa._id] = Axes.findExtremes(xa, calcPt.x, xOpts);
  fullTrace._extremes[ya._id] = Axes.findExtremes(ya, calcPt.y, yOpts);
};
proto.dispose = function () {
  this.heatmap.dispose();
};
function convertColorscale(fullTrace) {
  var scl = fullTrace.colorscale;
  var zmin = fullTrace.zmin;
  var zmax = fullTrace.zmax;
  var N = scl.length;
  var domain = new Array(N);
  var range = new Array(4 * N);
  for (var i = 0; i < N; i++) {
    var si = scl[i];
    var color = str2RGBArray(si[1]);
    domain[i] = zmin + si[0] * (zmax - zmin);
    for (var j = 0; j < 4; j++) {
      range[4 * i + j] = color[j];
    }
  }
  return {
    colorLevels: domain,
    colorValues: range
  };
}
function createHeatmap(scene, fullTrace, calcTrace) {
  var plot = new Heatmap(scene, fullTrace.uid);
  plot.update(fullTrace, calcTrace);
  return plot;
}
module.exports = createHeatmap;

/***/ }),

/***/ 51312:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var handleXYZDefaults = __webpack_require__(86073);
var colorscaleDefaults = __webpack_require__(39356);
var attributes = __webpack_require__(29751);
module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
  function coerce(attr, dflt) {
    return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
  }
  var validData = handleXYZDefaults(traceIn, traceOut, coerce, layout);
  if (!validData) {
    traceOut.visible = false;
    return;
  }
  coerce('text');
  coerce('zsmooth');
  colorscaleDefaults(traceIn, traceOut, layout, coerce, {
    prefix: '',
    cLetter: 'z'
  });
};

/***/ }),

/***/ 72892:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var deprecationWarning = ['*heatmapgl* trace is deprecated!', 'Please consider switching to the *heatmap* or *image* trace types.', 'Alternatively you could contribute/sponsor rewriting this trace type', 'based on cartesian features and using regl framework.'].join(' ');
module.exports = {
  attributes: __webpack_require__(29751),
  supplyDefaults: __webpack_require__(51312),
  colorbar: __webpack_require__(12431),
  calc: __webpack_require__(51670),
  plot: __webpack_require__(89987),
  moduleType: 'trace',
  name: 'heatmapgl',
  basePlotModule: __webpack_require__(24585),
  categories: ['gl', 'gl2d', '2dMap'],
  meta: {}
};

/***/ }),

/***/ 16160:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var barAttrs = __webpack_require__(81481);
var axisHoverFormat = (__webpack_require__(80712).axisHoverFormat);
var hovertemplateAttrs = (__webpack_require__(3208)/* .hovertemplateAttrs */ .rb);
var texttemplateAttrs = (__webpack_require__(3208)/* .texttemplateAttrs */ .ay);
var fontAttrs = __webpack_require__(80337);
var makeBinAttrs = __webpack_require__(64766);
var constants = __webpack_require__(39732);
var extendFlat = (__webpack_require__(93049).extendFlat);
module.exports = {
  x: {
    valType: 'data_array',
    editType: 'calc+clearAxisTypes'
  },
  y: {
    valType: 'data_array',
    editType: 'calc+clearAxisTypes'
  },
  xhoverformat: axisHoverFormat('x'),
  yhoverformat: axisHoverFormat('y'),
  text: extendFlat({}, barAttrs.text, {}),
  hovertext: extendFlat({}, barAttrs.hovertext, {}),
  orientation: barAttrs.orientation,
  histfunc: {
    valType: 'enumerated',
    values: ['count', 'sum', 'avg', 'min', 'max'],
    dflt: 'count',
    editType: 'calc'
  },
  histnorm: {
    valType: 'enumerated',
    values: ['', 'percent', 'probability', 'density', 'probability density'],
    dflt: '',
    editType: 'calc'
  },
  cumulative: {
    enabled: {
      valType: 'boolean',
      dflt: false,
      editType: 'calc'
    },
    direction: {
      valType: 'enumerated',
      values: ['increasing', 'decreasing'],
      dflt: 'increasing',
      editType: 'calc'
    },
    currentbin: {
      valType: 'enumerated',
      values: ['include', 'exclude', 'half'],
      dflt: 'include',
      editType: 'calc'
    },
    editType: 'calc'
  },
  nbinsx: {
    valType: 'integer',
    min: 0,
    dflt: 0,
    editType: 'calc'
  },
  xbins: makeBinAttrs('x', true),
  nbinsy: {
    valType: 'integer',
    min: 0,
    dflt: 0,
    editType: 'calc'
  },
  ybins: makeBinAttrs('y', true),
  autobinx: {
    valType: 'boolean',
    dflt: null,
    editType: 'calc'
  },
  autobiny: {
    valType: 'boolean',
    dflt: null,
    editType: 'calc'
  },
  bingroup: {
    valType: 'string',
    dflt: '',
    editType: 'calc'
  },
  hovertemplate: hovertemplateAttrs({}, {
    keys: constants.eventDataKeys
  }),
  texttemplate: texttemplateAttrs({
    arrayOk: false,
    editType: 'plot'
  }, {
    keys: ['label', 'value']
  }),
  textposition: extendFlat({}, barAttrs.textposition, {
    arrayOk: false
  }),
  textfont: fontAttrs({
    arrayOk: false,
    editType: 'plot',
    colorEditType: 'style'
  }),
  outsidetextfont: fontAttrs({
    arrayOk: false,
    editType: 'plot',
    colorEditType: 'style'
  }),
  insidetextfont: fontAttrs({
    arrayOk: false,
    editType: 'plot',
    colorEditType: 'style'
  }),
  insidetextanchor: barAttrs.insidetextanchor,
  textangle: barAttrs.textangle,
  cliponaxis: barAttrs.cliponaxis,
  constraintext: barAttrs.constraintext,
  marker: barAttrs.marker,
  offsetgroup: barAttrs.offsetgroup,
  alignmentgroup: barAttrs.alignmentgroup,
  selected: barAttrs.selected,
  unselected: barAttrs.unselected,
  _deprecated: {
    bardir: barAttrs._deprecated.bardir
  },
  zorder: barAttrs.zorder
};

/***/ }),

/***/ 48198:
/***/ (function(module) {

"use strict";


module.exports = function doAvg(size, counts) {
  var nMax = size.length;
  var total = 0;
  for (var i = 0; i < nMax; i++) {
    if (counts[i]) {
      size[i] /= counts[i];
      total += size[i];
    } else size[i] = null;
  }
  return total;
};

/***/ }),

/***/ 64766:
/***/ (function(module) {

"use strict";


module.exports = function makeBinAttrs(axLetter, match) {
  return {
    start: {
      valType: 'any',
      // for date axes
      editType: 'calc'
    },
    end: {
      valType: 'any',
      // for date axes
      editType: 'calc'
    },
    size: {
      valType: 'any',
      // for date axes
      editType: 'calc'
    },
    editType: 'calc'
  };
};

/***/ }),

/***/ 34870:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isNumeric = __webpack_require__(10721);
module.exports = {
  count: function (n, i, size) {
    size[n]++;
    return 1;
  },
  sum: function (n, i, size, counterData) {
    var v = counterData[i];
    if (isNumeric(v)) {
      v = Number(v);
      size[n] += v;
      return v;
    }
    return 0;
  },
  avg: function (n, i, size, counterData, counts) {
    var v = counterData[i];
    if (isNumeric(v)) {
      v = Number(v);
      size[n] += v;
      counts[n]++;
    }
    return 0;
  },
  min: function (n, i, size, counterData) {
    var v = counterData[i];
    if (isNumeric(v)) {
      v = Number(v);
      if (!isNumeric(size[n])) {
        size[n] = v;
        return v;
      } else if (size[n] > v) {
        var delta = v - size[n];
        size[n] = v;
        return delta;
      }
    }
    return 0;
  },
  max: function (n, i, size, counterData) {
    var v = counterData[i];
    if (isNumeric(v)) {
      v = Number(v);
      if (!isNumeric(size[n])) {
        size[n] = v;
        return v;
      } else if (size[n] < v) {
        var delta = v - size[n];
        size[n] = v;
        return delta;
      }
    }
    return 0;
  }
};

/***/ }),

/***/ 64852:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var numConstants = __webpack_require__(63821);
var oneYear = numConstants.ONEAVGYEAR;
var oneMonth = numConstants.ONEAVGMONTH;
var oneDay = numConstants.ONEDAY;
var oneHour = numConstants.ONEHOUR;
var oneMin = numConstants.ONEMIN;
var oneSec = numConstants.ONESEC;
var tickIncrement = (__webpack_require__(29714).tickIncrement);

/*
 * make a function that will find rounded bin edges
 * @param {number} leftGap: how far from the left edge of any bin is the closest data value?
 * @param {number} rightGap: how far from the right edge of any bin is the closest data value?
 * @param {Array[number]} binEdges: the actual edge values used in binning
 * @param {object} pa: the position axis
 * @param {string} calendar: the data calendar
 *
 * @return {function(v, isRightEdge)}:
 *   find the start (isRightEdge is falsy) or end (truthy) label value for a bin edge `v`
 */
module.exports = function getBinSpanLabelRound(leftGap, rightGap, binEdges, pa, calendar) {
  // the rounding digit is the largest digit that changes in *all* of 4 regions:
  // - inside the rightGap before binEdges[0] (shifted 10% to the left)
  // - inside the leftGap after binEdges[0] (expanded by 10% of rightGap on each end)
  // - same for binEdges[1]
  var dv0 = -1.1 * rightGap;
  var dv1 = -0.1 * rightGap;
  var dv2 = leftGap - dv1;
  var edge0 = binEdges[0];
  var edge1 = binEdges[1];
  var leftDigit = Math.min(biggestDigitChanged(edge0 + dv1, edge0 + dv2, pa, calendar), biggestDigitChanged(edge1 + dv1, edge1 + dv2, pa, calendar));
  var rightDigit = Math.min(biggestDigitChanged(edge0 + dv0, edge0 + dv1, pa, calendar), biggestDigitChanged(edge1 + dv0, edge1 + dv1, pa, calendar));

  // normally we try to make the label for the right edge different from
  // the left edge label, so it's unambiguous which bin gets data on the edge.
  // but if this results in more than 3 extra digits (or for dates, more than
  // 2 fields ie hr&min or min&sec, which is 3600x), it'll be more clutter than
  // useful so keep the label cleaner instead
  var digit, disambiguateEdges;
  if (leftDigit > rightDigit && rightDigit < Math.abs(edge1 - edge0) / 4000) {
    digit = leftDigit;
    disambiguateEdges = false;
  } else {
    digit = Math.min(leftDigit, rightDigit);
    disambiguateEdges = true;
  }
  if (pa.type === 'date' && digit > oneDay) {
    var dashExclude = digit === oneYear ? 1 : 6;
    var increment = digit === oneYear ? 'M12' : 'M1';
    return function (v, isRightEdge) {
      var dateStr = pa.c2d(v, oneYear, calendar);
      var dashPos = dateStr.indexOf('-', dashExclude);
      if (dashPos > 0) dateStr = dateStr.substr(0, dashPos);
      var roundedV = pa.d2c(dateStr, 0, calendar);
      if (roundedV < v) {
        var nextV = tickIncrement(roundedV, increment, false, calendar);
        if ((roundedV + nextV) / 2 < v + leftGap) roundedV = nextV;
      }
      if (isRightEdge && disambiguateEdges) {
        return tickIncrement(roundedV, increment, true, calendar);
      }
      return roundedV;
    };
  }
  return function (v, isRightEdge) {
    var roundedV = digit * Math.round(v / digit);
    // if we rounded down and we could round up and still be < leftGap
    // (or what leftGap values round to), do that
    if (roundedV + digit / 10 < v && roundedV + digit * 0.9 < v + leftGap) {
      roundedV += digit;
    }
    // finally for the right edge back off one digit - but only if we can do that
    // and not clip off any data that's potentially in the bin
    if (isRightEdge && disambiguateEdges) {
      roundedV -= digit;
    }
    return roundedV;
  };
};

/*
 * Find the largest digit that changes within a (calcdata) region [v1, v2]
 * if dates, "digit" means date/time part when it's bigger than a second
 * returns the unit value to round to this digit, eg 0.01 to round to hundredths, or
 * 100 to round to hundreds. returns oneMonth or oneYear for month or year rounding,
 * so that Math.min will work, rather than 'M1' and 'M12'
 */
function biggestDigitChanged(v1, v2, pa, calendar) {
  // are we crossing zero? can't say anything.
  // in principle this doesn't apply to dates but turns out this doesn't matter.
  if (v1 * v2 <= 0) return Infinity;
  var dv = Math.abs(v2 - v1);
  var isDate = pa.type === 'date';
  var digit = biggestGuaranteedDigitChanged(dv, isDate);
  // see if a larger digit also changed
  for (var i = 0; i < 10; i++) {
    // numbers: next digit needs to be >10x but <100x then gets rounded down.
    // dates: next digit can be as much as 60x (then rounded down)
    var nextDigit = biggestGuaranteedDigitChanged(digit * 80, isDate);
    // if we get to years, the chain stops
    if (digit === nextDigit) break;
    if (didDigitChange(nextDigit, v1, v2, isDate, pa, calendar)) digit = nextDigit;else break;
  }
  return digit;
}

/*
 * Find the largest digit that *definitely* changes in a region [v, v + dv] for any v
 * for nonuniform date regions (months/years) pick the largest
 */
function biggestGuaranteedDigitChanged(dv, isDate) {
  if (isDate && dv > oneSec) {
    // this is supposed to be the biggest *guaranteed* change
    // so compare to the longest month and year across any calendar,
    // and we'll iterate back up later
    // note: does not support rounding larger than one year. We could add
    // that if anyone wants it, but seems unusual and not strictly necessary.
    if (dv > oneDay) {
      if (dv > oneYear * 1.1) return oneYear;
      if (dv > oneMonth * 1.1) return oneMonth;
      return oneDay;
    }
    if (dv > oneHour) return oneHour;
    if (dv > oneMin) return oneMin;
    return oneSec;
  }
  return Math.pow(10, Math.floor(Math.log(dv) / Math.LN10));
}
function didDigitChange(digit, v1, v2, isDate, pa, calendar) {
  if (isDate && digit > oneDay) {
    var dateParts1 = dateParts(v1, pa, calendar);
    var dateParts2 = dateParts(v2, pa, calendar);
    var parti = digit === oneYear ? 0 : 1;
    return dateParts1[parti] !== dateParts2[parti];
  }
  return Math.floor(v2 / digit) - Math.floor(v1 / digit) > 0.1;
}
function dateParts(v, pa, calendar) {
  var parts = pa.c2d(v, oneYear, calendar).split('-');
  if (parts[0] === '') {
    parts.unshift();
    parts[0] = '-' + parts[0];
  }
  return parts;
}

/***/ }),

/***/ 53616:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isNumeric = __webpack_require__(10721);
var Lib = __webpack_require__(34809);
var Registry = __webpack_require__(33626);
var Axes = __webpack_require__(29714);
var arraysToCalcdata = __webpack_require__(35374);
var binFunctions = __webpack_require__(34870);
var normFunctions = __webpack_require__(58665);
var doAvg = __webpack_require__(48198);
var getBinSpanLabelRound = __webpack_require__(64852);
function calc(gd, trace) {
  var pos = [];
  var size = [];
  var isHorizontal = trace.orientation === 'h';
  var pa = Axes.getFromId(gd, isHorizontal ? trace.yaxis : trace.xaxis);
  var mainData = isHorizontal ? 'y' : 'x';
  var counterData = {
    x: 'y',
    y: 'x'
  }[mainData];
  var calendar = trace[mainData + 'calendar'];
  var cumulativeSpec = trace.cumulative;
  var i;
  var binsAndPos = calcAllAutoBins(gd, trace, pa, mainData);
  var binSpec = binsAndPos[0];
  var pos0 = binsAndPos[1];
  var nonuniformBins = typeof binSpec.size === 'string';
  var binEdges = [];
  var bins = nonuniformBins ? binEdges : binSpec;
  // make the empty bin array
  var inc = [];
  var counts = [];
  var inputPoints = [];
  var total = 0;
  var norm = trace.histnorm;
  var func = trace.histfunc;
  var densityNorm = norm.indexOf('density') !== -1;
  var i2, binEnd, n;
  if (cumulativeSpec.enabled && densityNorm) {
    // we treat "cumulative" like it means "integral" if you use a density norm,
    // which in the end means it's the same as without "density"
    norm = norm.replace(/ ?density$/, '');
    densityNorm = false;
  }
  var extremeFunc = func === 'max' || func === 'min';
  var sizeInit = extremeFunc ? null : 0;
  var binFunc = binFunctions.count;
  var normFunc = normFunctions[norm];
  var isAvg = false;
  var pr2c = function (v) {
    return pa.r2c(v, 0, calendar);
  };
  var rawCounterData;
  if (Lib.isArrayOrTypedArray(trace[counterData]) && func !== 'count') {
    rawCounterData = trace[counterData];
    isAvg = func === 'avg';
    binFunc = binFunctions[func];
  }

  // create the bins (and any extra arrays needed)
  // assume more than 1e6 bins is an error, so we don't crash the browser
  i = pr2c(binSpec.start);

  // decrease end a little in case of rounding errors
  binEnd = pr2c(binSpec.end) + (i - Axes.tickIncrement(i, binSpec.size, false, calendar)) / 1e6;
  while (i < binEnd && pos.length < 1e6) {
    i2 = Axes.tickIncrement(i, binSpec.size, false, calendar);
    pos.push((i + i2) / 2);
    size.push(sizeInit);
    inputPoints.push([]);
    // nonuniform bins (like months) we need to search,
    // rather than straight calculate the bin we're in
    binEdges.push(i);
    // nonuniform bins also need nonuniform normalization factors
    if (densityNorm) inc.push(1 / (i2 - i));
    if (isAvg) counts.push(0);
    // break to avoid infinite loops
    if (i2 <= i) break;
    i = i2;
  }
  binEdges.push(i);

  // for date axes we need bin bounds to be calcdata. For nonuniform bins
  // we already have this, but uniform with start/end/size they're still strings.
  if (!nonuniformBins && pa.type === 'date') {
    bins = {
      start: pr2c(bins.start),
      end: pr2c(bins.end),
      size: bins.size
    };
  }

  // stash left and right gaps by group
  if (!gd._fullLayout._roundFnOpts) gd._fullLayout._roundFnOpts = {};
  var groupName = trace['_' + mainData + 'bingroup'];
  var roundFnOpts = {
    leftGap: Infinity,
    rightGap: Infinity
  };
  if (groupName) {
    if (!gd._fullLayout._roundFnOpts[groupName]) gd._fullLayout._roundFnOpts[groupName] = roundFnOpts;
    roundFnOpts = gd._fullLayout._roundFnOpts[groupName];
  }

  // bin the data
  // and make histogram-specific pt-number-to-cd-index map object
  var nMax = size.length;
  var uniqueValsPerBin = true;
  var leftGap = roundFnOpts.leftGap;
  var rightGap = roundFnOpts.rightGap;
  var ptNumber2cdIndex = {};
  for (i = 0; i < pos0.length; i++) {
    var posi = pos0[i];
    n = Lib.findBin(posi, bins);
    if (n >= 0 && n < nMax) {
      total += binFunc(n, i, size, rawCounterData, counts);
      if (uniqueValsPerBin && inputPoints[n].length && posi !== pos0[inputPoints[n][0]]) {
        uniqueValsPerBin = false;
      }
      inputPoints[n].push(i);
      ptNumber2cdIndex[i] = n;
      leftGap = Math.min(leftGap, posi - binEdges[n]);
      rightGap = Math.min(rightGap, binEdges[n + 1] - posi);
    }
  }
  roundFnOpts.leftGap = leftGap;
  roundFnOpts.rightGap = rightGap;
  var roundFn;
  if (!uniqueValsPerBin) {
    roundFn = function (v, isRightEdge) {
      return function () {
        var roundFnOpts = gd._fullLayout._roundFnOpts[groupName];
        return getBinSpanLabelRound(roundFnOpts.leftGap, roundFnOpts.rightGap, binEdges, pa, calendar)(v, isRightEdge);
      };
    };
  }

  // average and/or normalize the data, if needed
  if (isAvg) total = doAvg(size, counts);
  if (normFunc) normFunc(size, total, inc);

  // after all normalization etc, now we can accumulate if desired
  if (cumulativeSpec.enabled) cdf(size, cumulativeSpec.direction, cumulativeSpec.currentbin);
  var seriesLen = Math.min(pos.length, size.length);
  var cd = [];
  var firstNonzero = 0;
  var lastNonzero = seriesLen - 1;

  // look for empty bins at the ends to remove, so autoscale omits them
  for (i = 0; i < seriesLen; i++) {
    if (size[i]) {
      firstNonzero = i;
      break;
    }
  }
  for (i = seriesLen - 1; i >= firstNonzero; i--) {
    if (size[i]) {
      lastNonzero = i;
      break;
    }
  }

  // create the "calculated data" to plot
  for (i = firstNonzero; i <= lastNonzero; i++) {
    if (isNumeric(pos[i]) && isNumeric(size[i])) {
      var cdi = {
        p: pos[i],
        s: size[i],
        b: 0
      };

      // setup hover and event data fields,
      // N.B. pts and "hover" positions ph0/ph1 don't seem to make much sense
      // for cumulative distributions
      if (!cumulativeSpec.enabled) {
        cdi.pts = inputPoints[i];
        if (uniqueValsPerBin) {
          cdi.ph0 = cdi.ph1 = inputPoints[i].length ? pos0[inputPoints[i][0]] : pos[i];
        } else {
          // Defer evaluation of ph(0|1) in crossTraceCalc
          trace._computePh = true;
          cdi.ph0 = roundFn(binEdges[i]);
          cdi.ph1 = roundFn(binEdges[i + 1], true);
        }
      }
      cd.push(cdi);
    }
  }
  if (cd.length === 1) {
    // when we collapse to a single bin, calcdata no longer describes bin size
    // so we need to explicitly specify it
    cd[0].width1 = Axes.tickIncrement(cd[0].p, binSpec.size, false, calendar) - cd[0].p;
  }
  arraysToCalcdata(cd, trace);
  if (Lib.isArrayOrTypedArray(trace.selectedpoints)) {
    Lib.tagSelected(cd, trace, ptNumber2cdIndex);
  }
  return cd;
}

/*
 * calcAllAutoBins: we want all histograms inside the same bingroup
 * (see logic in Histogram.crossTraceDefaults) to share bin specs
 *
 * If the user has explicitly specified differing
 * bin specs, there's nothing we can do, but if possible we will try to use the
 * smallest bins of any of the auto values for all histograms inside the same
 * bingroup.
 */
function calcAllAutoBins(gd, trace, pa, mainData, _overlayEdgeCase) {
  var binAttr = mainData + 'bins';
  var fullLayout = gd._fullLayout;
  var groupName = trace['_' + mainData + 'bingroup'];
  var binOpts = fullLayout._histogramBinOpts[groupName];
  var isOverlay = fullLayout.barmode === 'overlay';
  var i, traces, tracei, calendar, pos0, autoVals, cumulativeSpec;
  var r2c = function (v) {
    return pa.r2c(v, 0, calendar);
  };
  var c2r = function (v) {
    return pa.c2r(v, 0, calendar);
  };
  var cleanBound = pa.type === 'date' ? function (v) {
    return v || v === 0 ? Lib.cleanDate(v, null, calendar) : null;
  } : function (v) {
    return isNumeric(v) ? Number(v) : null;
  };
  function setBound(attr, bins, newBins) {
    if (bins[attr + 'Found']) {
      bins[attr] = cleanBound(bins[attr]);
      if (bins[attr] === null) bins[attr] = newBins[attr];
    } else {
      autoVals[attr] = bins[attr] = newBins[attr];
      Lib.nestedProperty(traces[0], binAttr + '.' + attr).set(newBins[attr]);
    }
  }

  // all but the first trace in this group has already been marked finished
  // clear this flag, so next time we run calc we will run autobin again
  if (trace['_' + mainData + 'autoBinFinished']) {
    delete trace['_' + mainData + 'autoBinFinished'];
  } else {
    traces = binOpts.traces;
    var allPos = [];

    // Note: we're including `legendonly` traces here for autobin purposes,
    // so that showing & hiding from the legend won't affect bins.
    // But this complicates things a bit since those traces don't `calc`,
    // hence `isFirstVisible`.
    var isFirstVisible = true;
    var has2dMap = false;
    var hasHist2dContour = false;
    for (i = 0; i < traces.length; i++) {
      tracei = traces[i];
      if (tracei.visible) {
        var mainDatai = binOpts.dirs[i];
        pos0 = tracei['_' + mainDatai + 'pos0'] = pa.makeCalcdata(tracei, mainDatai);
        allPos = Lib.concat(allPos, pos0);
        delete tracei['_' + mainData + 'autoBinFinished'];
        if (trace.visible === true) {
          if (isFirstVisible) {
            isFirstVisible = false;
          } else {
            delete tracei._autoBin;
            tracei['_' + mainData + 'autoBinFinished'] = 1;
          }
          if (Registry.traceIs(tracei, '2dMap')) {
            has2dMap = true;
          }
          if (tracei.type === 'histogram2dcontour') {
            hasHist2dContour = true;
          }
        }
      }
    }
    calendar = traces[0][mainData + 'calendar'];
    var newBinSpec = Axes.autoBin(allPos, pa, binOpts.nbins, has2dMap, calendar, binOpts.sizeFound && binOpts.size);
    var autoBin = traces[0]._autoBin = {};
    autoVals = autoBin[binOpts.dirs[0]] = {};
    if (hasHist2dContour) {
      // the "true" 2nd argument reverses the tick direction (which we can't
      // just do with a minus sign because of month bins)
      if (!binOpts.size) {
        newBinSpec.start = c2r(Axes.tickIncrement(r2c(newBinSpec.start), newBinSpec.size, true, calendar));
      }
      if (binOpts.end === undefined) {
        newBinSpec.end = c2r(Axes.tickIncrement(r2c(newBinSpec.end), newBinSpec.size, false, calendar));
      }
    }

    // Edge case: single-valued histogram overlaying others
    // Use them all together to calculate the bin size for the single-valued one
    // Don't re-calculate bin width if user manually specified it (checing in bingroup=='' or xbins is defined)
    if (isOverlay && !Registry.traceIs(trace, '2dMap') && newBinSpec._dataSpan === 0 && pa.type !== 'category' && pa.type !== 'multicategory' && trace.bingroup === '' && typeof trace.xbins === 'undefined') {
      // Several single-valued histograms! Stop infinite recursion,
      // just return an extra flag that tells handleSingleValueOverlays
      // to sort out this trace too
      if (_overlayEdgeCase) return [newBinSpec, pos0, true];
      newBinSpec = handleSingleValueOverlays(gd, trace, pa, mainData, binAttr);
    }

    // adjust for CDF edge cases
    cumulativeSpec = tracei.cumulative || {};
    if (cumulativeSpec.enabled && cumulativeSpec.currentbin !== 'include') {
      if (cumulativeSpec.direction === 'decreasing') {
        newBinSpec.start = c2r(Axes.tickIncrement(r2c(newBinSpec.start), newBinSpec.size, true, calendar));
      } else {
        newBinSpec.end = c2r(Axes.tickIncrement(r2c(newBinSpec.end), newBinSpec.size, false, calendar));
      }
    }
    binOpts.size = newBinSpec.size;
    if (!binOpts.sizeFound) {
      autoVals.size = newBinSpec.size;
      Lib.nestedProperty(traces[0], binAttr + '.size').set(newBinSpec.size);
    }
    setBound('start', binOpts, newBinSpec);
    setBound('end', binOpts, newBinSpec);
  }
  pos0 = trace['_' + mainData + 'pos0'];
  delete trace['_' + mainData + 'pos0'];

  // Each trace can specify its own start/end, or if omitted
  // we ensure they're beyond the bounds of this trace's data,
  // and we need to make sure start is aligned with the main start
  var traceInputBins = trace._input[binAttr] || {};
  var traceBinOptsCalc = Lib.extendFlat({}, binOpts);
  var mainStart = binOpts.start;
  var startIn = pa.r2l(traceInputBins.start);
  var hasStart = startIn !== undefined;
  if ((binOpts.startFound || hasStart) && startIn !== pa.r2l(mainStart)) {
    // We have an explicit start to reconcile across traces
    // if this trace has an explicit start, shift it down to a bin edge
    // if another trace had an explicit start, shift it down to a
    // bin edge past our data
    var traceStart = hasStart ? startIn : Lib.aggNums(Math.min, null, pos0);
    var dummyAx = {
      type: pa.type === 'category' || pa.type === 'multicategory' ? 'linear' : pa.type,
      r2l: pa.r2l,
      dtick: binOpts.size,
      tick0: mainStart,
      calendar: calendar,
      range: [traceStart, Axes.tickIncrement(traceStart, binOpts.size, false, calendar)].map(pa.l2r)
    };
    var newStart = Axes.tickFirst(dummyAx);
    if (newStart > pa.r2l(traceStart)) {
      newStart = Axes.tickIncrement(newStart, binOpts.size, true, calendar);
    }
    traceBinOptsCalc.start = pa.l2r(newStart);
    if (!hasStart) Lib.nestedProperty(trace, binAttr + '.start').set(traceBinOptsCalc.start);
  }
  var mainEnd = binOpts.end;
  var endIn = pa.r2l(traceInputBins.end);
  var hasEnd = endIn !== undefined;
  if ((binOpts.endFound || hasEnd) && endIn !== pa.r2l(mainEnd)) {
    // Reconciling an explicit end is easier, as it doesn't need to
    // match bin edges
    var traceEnd = hasEnd ? endIn : Lib.aggNums(Math.max, null, pos0);
    traceBinOptsCalc.end = pa.l2r(traceEnd);
    if (!hasEnd) Lib.nestedProperty(trace, binAttr + '.start').set(traceBinOptsCalc.end);
  }

  // Backward compatibility for one-time autobinning.
  // autobin: true is handled in cleanData, but autobin: false
  // needs to be here where we have determined the values.
  var autoBinAttr = 'autobin' + mainData;
  if (trace._input[autoBinAttr] === false) {
    trace._input[binAttr] = Lib.extendFlat({}, trace[binAttr] || {});
    delete trace._input[autoBinAttr];
    delete trace[autoBinAttr];
  }
  return [traceBinOptsCalc, pos0];
}

/*
 * Adjust single-value histograms in overlay mode to make as good a
 * guess as we can at autobin values the user would like.
 *
 * Returns the binSpec for the trace that sparked all this
 */
function handleSingleValueOverlays(gd, trace, pa, mainData, binAttr) {
  var fullLayout = gd._fullLayout;
  var overlaidTraceGroup = getConnectedHistograms(gd, trace);
  var pastThisTrace = false;
  var minSize = Infinity;
  var singleValuedTraces = [trace];
  var i, tracei, binOpts;

  // first collect all the:
  // - min bin size from all multi-valued traces
  // - single-valued traces
  for (i = 0; i < overlaidTraceGroup.length; i++) {
    tracei = overlaidTraceGroup[i];
    if (tracei === trace) {
      pastThisTrace = true;
    } else if (!pastThisTrace) {
      // This trace has already had its autobins calculated, so either:
      // - it is part of a bingroup
      // - it is NOT a single-valued trace
      binOpts = fullLayout._histogramBinOpts[tracei['_' + mainData + 'bingroup']];
      minSize = Math.min(minSize, binOpts.size || tracei[binAttr].size);
    } else {
      var resulti = calcAllAutoBins(gd, tracei, pa, mainData, true);
      var binSpeci = resulti[0];
      var isSingleValued = resulti[2];

      // so we can use this result when we get to tracei in the normal
      // course of events, mark it as done and put _pos0 back
      tracei['_' + mainData + 'autoBinFinished'] = 1;
      tracei['_' + mainData + 'pos0'] = resulti[1];
      if (isSingleValued) {
        singleValuedTraces.push(tracei);
      } else {
        minSize = Math.min(minSize, binSpeci.size);
      }
    }
  }

  // find the real data values for each single-valued trace
  // hunt through pos0 for the first valid value
  var dataVals = new Array(singleValuedTraces.length);
  for (i = 0; i < singleValuedTraces.length; i++) {
    var pos0 = singleValuedTraces[i]['_' + mainData + 'pos0'];
    for (var j = 0; j < pos0.length; j++) {
      if (pos0[j] !== undefined) {
        dataVals[i] = pos0[j];
        break;
      }
    }
  }

  // are ALL traces are single-valued? use the min difference between
  // all of their values (which defaults to 1 if there's still only one)
  if (!isFinite(minSize)) {
    minSize = Lib.distinctVals(dataVals).minDiff;
  }

  // now apply the min size we found to all single-valued traces
  for (i = 0; i < singleValuedTraces.length; i++) {
    tracei = singleValuedTraces[i];
    var calendar = tracei[mainData + 'calendar'];
    var newBins = {
      start: pa.c2r(dataVals[i] - minSize / 2, 0, calendar),
      end: pa.c2r(dataVals[i] + minSize / 2, 0, calendar),
      size: minSize
    };
    tracei._input[binAttr] = tracei[binAttr] = newBins;
    binOpts = fullLayout._histogramBinOpts[tracei['_' + mainData + 'bingroup']];
    if (binOpts) Lib.extendFlat(binOpts, newBins);
  }
  return trace[binAttr];
}

/*
 * Return an array of histograms that share axes and orientation.
 *
 * Only considers histograms. In principle we could include bars in a
 * similar way to how we do manually binned histograms, though this
 * would have tons of edge cases and value judgments to make.
 */
function getConnectedHistograms(gd, trace) {
  var xid = trace.xaxis;
  var yid = trace.yaxis;
  var orientation = trace.orientation;
  var out = [];
  var fullData = gd._fullData;
  for (var i = 0; i < fullData.length; i++) {
    var tracei = fullData[i];
    if (tracei.type === 'histogram' && tracei.visible === true && tracei.orientation === orientation && tracei.xaxis === xid && tracei.yaxis === yid) {
      out.push(tracei);
    }
  }
  return out;
}
function cdf(size, direction, currentBin) {
  var i, vi, prevSum;
  function firstHalfPoint(i) {
    prevSum = size[i];
    size[i] /= 2;
  }
  function nextHalfPoint(i) {
    vi = size[i];
    size[i] = prevSum + vi / 2;
    prevSum += vi;
  }
  if (currentBin === 'half') {
    if (direction === 'increasing') {
      firstHalfPoint(0);
      for (i = 1; i < size.length; i++) {
        nextHalfPoint(i);
      }
    } else {
      firstHalfPoint(size.length - 1);
      for (i = size.length - 2; i >= 0; i--) {
        nextHalfPoint(i);
      }
    }
  } else if (direction === 'increasing') {
    for (i = 1; i < size.length; i++) {
      size[i] += size[i - 1];
    }

    // 'exclude' is identical to 'include' just shifted one bin over
    if (currentBin === 'exclude') {
      size.unshift(0);
      size.pop();
    }
  } else {
    for (i = size.length - 2; i >= 0; i--) {
      size[i] += size[i + 1];
    }
    if (currentBin === 'exclude') {
      size.push(0);
      size.shift();
    }
  }
}
module.exports = {
  calc: calc,
  calcAllAutoBins: calcAllAutoBins
};

/***/ }),

/***/ 39732:
/***/ (function(module) {

"use strict";


module.exports = {
  eventDataKeys: ['binNumber']
};

/***/ }),

/***/ 83380:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var axisIds = __webpack_require__(5975);
var traceIs = (__webpack_require__(33626).traceIs);
var handleGroupingDefaults = __webpack_require__(36301);
var validateCornerradius = (__webpack_require__(17550).validateCornerradius);
var nestedProperty = Lib.nestedProperty;
var getAxisGroup = (__webpack_require__(84391).getAxisGroup);
var BINATTRS = [{
  aStr: {
    x: 'xbins.start',
    y: 'ybins.start'
  },
  name: 'start'
}, {
  aStr: {
    x: 'xbins.end',
    y: 'ybins.end'
  },
  name: 'end'
}, {
  aStr: {
    x: 'xbins.size',
    y: 'ybins.size'
  },
  name: 'size'
}, {
  aStr: {
    x: 'nbinsx',
    y: 'nbinsy'
  },
  name: 'nbins'
}];
var BINDIRECTIONS = ['x', 'y'];

// handle bin attrs and relink auto-determined values so fullData is complete
module.exports = function crossTraceDefaults(fullData, fullLayout) {
  var allBinOpts = fullLayout._histogramBinOpts = {};
  var histTraces = [];
  var mustMatchTracesLookup = {};
  var otherTracesList = [];
  var traceOut, traces, groupName, binDir;
  var i, j, k;
  function coerce(attr, dflt) {
    return Lib.coerce(traceOut._input, traceOut, traceOut._module.attributes, attr, dflt);
  }
  function orientation2binDir(traceOut) {
    return traceOut.orientation === 'v' ? 'x' : 'y';
  }
  function getAxisType(traceOut, binDir) {
    var ax = axisIds.getFromTrace({
      _fullLayout: fullLayout
    }, traceOut, binDir);
    return ax.type;
  }
  function fillBinOpts(traceOut, groupName, binDir) {
    // N.B. group traces that don't have a bingroup with themselves
    var fallbackGroupName = traceOut.uid + '__' + binDir;
    if (!groupName) groupName = fallbackGroupName;
    var axType = getAxisType(traceOut, binDir);
    var calendar = traceOut[binDir + 'calendar'] || '';
    var binOpts = allBinOpts[groupName];
    var needsNewItem = true;
    if (binOpts) {
      if (axType === binOpts.axType && calendar === binOpts.calendar) {
        needsNewItem = false;
        binOpts.traces.push(traceOut);
        binOpts.dirs.push(binDir);
      } else {
        groupName = fallbackGroupName;
        if (axType !== binOpts.axType) {
          Lib.warn(['Attempted to group the bins of trace', traceOut.index, 'set on a', 'type:' + axType, 'axis', 'with bins on', 'type:' + binOpts.axType, 'axis.'].join(' '));
        }
        if (calendar !== binOpts.calendar) {
          // prohibit bingroup for traces using different calendar,
          // there's probably a way to make this work, but skip for now
          Lib.warn(['Attempted to group the bins of trace', traceOut.index, 'set with a', calendar, 'calendar', 'with bins', binOpts.calendar ? 'on a ' + binOpts.calendar + ' calendar' : 'w/o a set calendar'].join(' '));
        }
      }
    }
    if (needsNewItem) {
      allBinOpts[groupName] = {
        traces: [traceOut],
        dirs: [binDir],
        axType: axType,
        calendar: traceOut[binDir + 'calendar'] || ''
      };
    }
    traceOut['_' + binDir + 'bingroup'] = groupName;
  }
  for (i = 0; i < fullData.length; i++) {
    traceOut = fullData[i];
    if (traceIs(traceOut, 'histogram')) {
      histTraces.push(traceOut);

      // TODO: this shouldn't be relinked as it's only used within calc
      // https://github.com/plotly/plotly.js/issues/749
      delete traceOut._xautoBinFinished;
      delete traceOut._yautoBinFinished;
      if (traceOut.type === 'histogram') {
        var r = coerce('marker.cornerradius', fullLayout.barcornerradius);
        if (traceOut.marker) {
          traceOut.marker.cornerradius = validateCornerradius(r);
        }
      }

      // N.B. need to coerce *alignmentgroup* before *bingroup*, as traces
      // in same alignmentgroup "have to match"
      if (!traceIs(traceOut, '2dMap')) {
        handleGroupingDefaults(traceOut._input, traceOut, fullLayout, coerce);
      }
    }
  }
  var alignmentOpts = fullLayout._alignmentOpts || {};

  // Look for traces that "have to match", that is:
  // - 1d histogram traces on the same subplot with same orientation under barmode:stack,
  // - 1d histogram traces on the same subplot with same orientation under barmode:group
  // - 1d histogram traces on the same position axis with the same orientation
  //   and the same *alignmentgroup* (coerced under barmode:group)
  // - Once `stackgroup` gets implemented (see https://github.com/plotly/plotly.js/issues/3614),
  //   traces within the same stackgroup will also "have to match"
  for (i = 0; i < histTraces.length; i++) {
    traceOut = histTraces[i];
    groupName = '';
    if (!traceIs(traceOut, '2dMap')) {
      binDir = orientation2binDir(traceOut);
      if (fullLayout.barmode === 'group' && traceOut.alignmentgroup) {
        var pa = traceOut[binDir + 'axis'];
        var aGroupId = getAxisGroup(fullLayout, pa) + traceOut.orientation;
        if ((alignmentOpts[aGroupId] || {})[traceOut.alignmentgroup]) {
          groupName = aGroupId;
        }
      }
      if (!groupName && fullLayout.barmode !== 'overlay') {
        groupName = getAxisGroup(fullLayout, traceOut.xaxis) + getAxisGroup(fullLayout, traceOut.yaxis) + orientation2binDir(traceOut);
      }
    }
    if (groupName) {
      if (!mustMatchTracesLookup[groupName]) {
        mustMatchTracesLookup[groupName] = [];
      }
      mustMatchTracesLookup[groupName].push(traceOut);
    } else {
      otherTracesList.push(traceOut);
    }
  }

  // Setup binOpts for traces that have to match,
  // if the traces have a valid bingroup, use that
  // if not use axis+binDir groupName
  for (groupName in mustMatchTracesLookup) {
    traces = mustMatchTracesLookup[groupName];

    // no need to 'force' anything when a single
    // trace is detected as "must match"
    if (traces.length === 1) {
      otherTracesList.push(traces[0]);
      continue;
    }
    var binGroupFound = false;
    if (traces.length) {
      traceOut = traces[0];
      binGroupFound = coerce('bingroup');
    }
    groupName = binGroupFound || groupName;
    for (i = 0; i < traces.length; i++) {
      traceOut = traces[i];
      var bingroupIn = traceOut._input.bingroup;
      if (bingroupIn && bingroupIn !== groupName) {
        Lib.warn(['Trace', traceOut.index, 'must match', 'within bingroup', groupName + '.', 'Ignoring its bingroup:', bingroupIn, 'setting.'].join(' '));
      }
      traceOut.bingroup = groupName;

      // N.B. no need to worry about 2dMap case
      // (where both bin direction are set in each trace)
      // as 2dMap trace never "have to match"
      fillBinOpts(traceOut, groupName, orientation2binDir(traceOut));
    }
  }

  // setup binOpts for traces that can but don't have to match,
  // notice that these traces can be matched with traces that have to match
  for (i = 0; i < otherTracesList.length; i++) {
    traceOut = otherTracesList[i];
    var binGroup = coerce('bingroup');
    if (traceIs(traceOut, '2dMap')) {
      for (k = 0; k < 2; k++) {
        binDir = BINDIRECTIONS[k];
        var binGroupInDir = coerce(binDir + 'bingroup', binGroup ? binGroup + '__' + binDir : null);
        fillBinOpts(traceOut, binGroupInDir, binDir);
      }
    } else {
      fillBinOpts(traceOut, binGroup, orientation2binDir(traceOut));
    }
  }

  // coerce bin attrs!
  for (groupName in allBinOpts) {
    var binOpts = allBinOpts[groupName];
    traces = binOpts.traces;
    for (j = 0; j < BINATTRS.length; j++) {
      var attrSpec = BINATTRS[j];
      var attr = attrSpec.name;
      var aStr;
      var autoVals;

      // nbins(x|y) is moot if we have a size. This depends on
      // nbins coming after size in binAttrs.
      if (attr === 'nbins' && binOpts.sizeFound) continue;
      for (i = 0; i < traces.length; i++) {
        traceOut = traces[i];
        binDir = binOpts.dirs[i];
        aStr = attrSpec.aStr[binDir];
        if (nestedProperty(traceOut._input, aStr).get() !== undefined) {
          binOpts[attr] = coerce(aStr);
          binOpts[attr + 'Found'] = true;
          break;
        }
        autoVals = (traceOut._autoBin || {})[binDir] || {};
        if (autoVals[attr]) {
          // if this is the *first* autoval
          nestedProperty(traceOut, aStr).set(autoVals[attr]);
        }
      }

      // start and end we need to coerce anyway, after having collected the
      // first of each into binOpts, in case a trace wants to restrict its
      // data to a certain range
      if (attr === 'start' || attr === 'end') {
        for (; i < traces.length; i++) {
          traceOut = traces[i];
          if (traceOut['_' + binDir + 'bingroup']) {
            autoVals = (traceOut._autoBin || {})[binDir] || {};
            coerce(aStr, autoVals[attr]);
          }
        }
      }
      if (attr === 'nbins' && !binOpts.sizeFound && !binOpts.nbinsFound) {
        traceOut = traces[0];
        binOpts[attr] = coerce(aStr);
      }
    }
  }
};

/***/ }),

/***/ 85079:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Registry = __webpack_require__(33626);
var Lib = __webpack_require__(34809);
var Color = __webpack_require__(78766);
var handleText = (__webpack_require__(17550).handleText);
var handleStyleDefaults = __webpack_require__(59760);
var attributes = __webpack_require__(16160);
module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
  function coerce(attr, dflt) {
    return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
  }
  var x = coerce('x');
  var y = coerce('y');
  var cumulative = coerce('cumulative.enabled');
  if (cumulative) {
    coerce('cumulative.direction');
    coerce('cumulative.currentbin');
  }
  coerce('text');
  var textposition = coerce('textposition');
  handleText(traceIn, traceOut, layout, coerce, textposition, {
    moduleHasSelected: true,
    moduleHasUnselected: true,
    moduleHasConstrain: true,
    moduleHasCliponaxis: true,
    moduleHasTextangle: true,
    moduleHasInsideanchor: true
  });
  coerce('hovertext');
  coerce('hovertemplate');
  coerce('xhoverformat');
  coerce('yhoverformat');
  var orientation = coerce('orientation', y && !x ? 'h' : 'v');
  var sampleLetter = orientation === 'v' ? 'x' : 'y';
  var aggLetter = orientation === 'v' ? 'y' : 'x';
  var len = x && y ? Math.min(Lib.minRowLength(x) && Lib.minRowLength(y)) : Lib.minRowLength(traceOut[sampleLetter] || []);
  if (!len) {
    traceOut.visible = false;
    return;
  }
  traceOut._length = len;
  var handleCalendarDefaults = Registry.getComponentMethod('calendars', 'handleTraceDefaults');
  handleCalendarDefaults(traceIn, traceOut, ['x', 'y'], layout);
  var hasAggregationData = traceOut[aggLetter];
  if (hasAggregationData) coerce('histfunc');
  coerce('histnorm');

  // Note: bin defaults are now handled in Histogram.crossTraceDefaults
  // autobin(x|y) are only included here to appease Plotly.validate
  coerce('autobin' + sampleLetter);
  handleStyleDefaults(traceIn, traceOut, coerce, defaultColor, layout);
  Lib.coerceSelectionMarkerOpacity(traceOut, coerce);
  var lineColor = (traceOut.marker.line || {}).color;

  // override defaultColor for error bars with defaultLine
  var errorBarsSupplyDefaults = Registry.getComponentMethod('errorbars', 'supplyDefaults');
  errorBarsSupplyDefaults(traceIn, traceOut, lineColor || Color.defaultLine, {
    axis: 'y'
  });
  errorBarsSupplyDefaults(traceIn, traceOut, lineColor || Color.defaultLine, {
    axis: 'x',
    inherit: 'y'
  });
  coerce('zorder');
};

/***/ }),

/***/ 82604:
/***/ (function(module) {

"use strict";


module.exports = function eventData(out, pt, trace, cd, pointNumber) {
  // standard cartesian event data
  out.x = 'xVal' in pt ? pt.xVal : pt.x;
  out.y = 'yVal' in pt ? pt.yVal : pt.y;

  // for 2d histograms
  if ('zLabelVal' in pt) out.z = pt.zLabelVal;
  if (pt.xa) out.xaxis = pt.xa;
  if (pt.ya) out.yaxis = pt.ya;

  // specific to histogram - CDFs do not have pts (yet?)
  if (!(trace.cumulative || {}).enabled) {
    var pts = Array.isArray(pointNumber) ? cd[0].pts[pointNumber[0]][pointNumber[1]] : cd[pointNumber].pts;
    out.pointNumbers = pts;
    out.binNumber = out.pointNumber;
    delete out.pointNumber;
    delete out.pointIndex;
    var pointIndices;
    if (trace._indexToPoints) {
      pointIndices = [];
      for (var i = 0; i < pts.length; i++) {
        pointIndices = pointIndices.concat(trace._indexToPoints[pts[i]]);
      }
    } else {
      pointIndices = pts;
    }
    out.pointIndices = pointIndices;
  }
  return out;
};

/***/ }),

/***/ 20487:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var barHover = (__webpack_require__(91664).hoverPoints);
var hoverLabelText = (__webpack_require__(29714).hoverLabelText);
module.exports = function hoverPoints(pointData, xval, yval, hovermode, opts) {
  var pts = barHover(pointData, xval, yval, hovermode, opts);
  if (!pts) return;
  pointData = pts[0];
  var di = pointData.cd[pointData.index];
  var trace = pointData.cd[0].trace;
  if (!trace.cumulative.enabled) {
    var posLetter = trace.orientation === 'h' ? 'y' : 'x';
    pointData[posLetter + 'Label'] = hoverLabelText(pointData[posLetter + 'a'], [di.ph0, di.ph1], trace[posLetter + 'hoverformat']);
  }
  return pts;
};

/***/ }),

/***/ 74461:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


/**
 * Histogram has its own attribute, defaults and calc steps,
 * but uses bar's plot to display
 * and bar's crossTraceCalc (formerly known as setPositions) for stacking and grouping
 */

/**
 * histogram errorBarsOK is debatable, but it's put in for backward compat.
 * there are use cases for it - sqrt for a simple histogram works right now,
 * constant and % work but they're not so meaningful. I guess it could be cool
 * to allow quadrature combination of errors in summed histograms...
 */
module.exports = {
  attributes: __webpack_require__(16160),
  layoutAttributes: __webpack_require__(25412),
  supplyDefaults: __webpack_require__(85079),
  crossTraceDefaults: __webpack_require__(83380),
  supplyLayoutDefaults: __webpack_require__(78931),
  calc: (__webpack_require__(53616).calc),
  crossTraceCalc: (__webpack_require__(24782).crossTraceCalc),
  plot: (__webpack_require__(32995).plot),
  layerName: 'barlayer',
  style: (__webpack_require__(6851).style),
  styleOnSelect: (__webpack_require__(6851).styleOnSelect),
  colorbar: __webpack_require__(21146),
  hoverPoints: __webpack_require__(20487),
  selectPoints: __webpack_require__(88384),
  eventData: __webpack_require__(82604),
  moduleType: 'trace',
  name: 'histogram',
  basePlotModule: __webpack_require__(37703),
  categories: ['bar-like', 'cartesian', 'svg', 'bar', 'histogram', 'oriented', 'errorBarsOK', 'showLegend'],
  meta: {}
};

/***/ }),

/***/ 58665:
/***/ (function(module) {

"use strict";


module.exports = {
  percent: function (size, total) {
    var nMax = size.length;
    var norm = 100 / total;
    for (var n = 0; n < nMax; n++) size[n] *= norm;
  },
  probability: function (size, total) {
    var nMax = size.length;
    for (var n = 0; n < nMax; n++) size[n] /= total;
  },
  density: function (size, total, inc, yinc) {
    var nMax = size.length;
    yinc = yinc || 1;
    for (var n = 0; n < nMax; n++) size[n] *= inc[n] * yinc;
  },
  'probability density': function (size, total, inc, yinc) {
    var nMax = size.length;
    if (yinc) total /= yinc;
    for (var n = 0; n < nMax; n++) size[n] *= inc[n] / total;
  }
};

/***/ }),

/***/ 9310:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var histogramAttrs = __webpack_require__(16160);
var makeBinAttrs = __webpack_require__(64766);
var heatmapAttrs = __webpack_require__(81658);
var baseAttrs = __webpack_require__(9829);
var axisHoverFormat = (__webpack_require__(80712).axisHoverFormat);
var hovertemplateAttrs = (__webpack_require__(3208)/* .hovertemplateAttrs */ .rb);
var texttemplateAttrs = (__webpack_require__(3208)/* .texttemplateAttrs */ .ay);
var colorScaleAttrs = __webpack_require__(87163);
var extendFlat = (__webpack_require__(93049).extendFlat);
module.exports = extendFlat({
  x: histogramAttrs.x,
  y: histogramAttrs.y,
  z: {
    valType: 'data_array',
    editType: 'calc'
  },
  marker: {
    color: {
      valType: 'data_array',
      editType: 'calc'
    },
    editType: 'calc'
  },
  histnorm: histogramAttrs.histnorm,
  histfunc: histogramAttrs.histfunc,
  nbinsx: histogramAttrs.nbinsx,
  xbins: makeBinAttrs('x'),
  nbinsy: histogramAttrs.nbinsy,
  ybins: makeBinAttrs('y'),
  autobinx: histogramAttrs.autobinx,
  autobiny: histogramAttrs.autobiny,
  bingroup: extendFlat({}, histogramAttrs.bingroup, {}),
  xbingroup: extendFlat({}, histogramAttrs.bingroup, {}),
  ybingroup: extendFlat({}, histogramAttrs.bingroup, {}),
  xgap: heatmapAttrs.xgap,
  ygap: heatmapAttrs.ygap,
  zsmooth: heatmapAttrs.zsmooth,
  xhoverformat: axisHoverFormat('x'),
  yhoverformat: axisHoverFormat('y'),
  zhoverformat: axisHoverFormat('z', 1),
  hovertemplate: hovertemplateAttrs({}, {
    keys: 'z'
  }),
  texttemplate: texttemplateAttrs({
    arrayOk: false,
    editType: 'plot'
  }, {
    keys: 'z'
  }),
  textfont: heatmapAttrs.textfont,
  showlegend: extendFlat({}, baseAttrs.showlegend, {
    dflt: false
  })
}, colorScaleAttrs('', {
  cLetter: 'z',
  autoColorDflt: false
}));

/***/ }),

/***/ 19226:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var Axes = __webpack_require__(29714);
var binFunctions = __webpack_require__(34870);
var normFunctions = __webpack_require__(58665);
var doAvg = __webpack_require__(48198);
var getBinSpanLabelRound = __webpack_require__(64852);
var calcAllAutoBins = (__webpack_require__(53616).calcAllAutoBins);
module.exports = function calc(gd, trace) {
  var xa = Axes.getFromId(gd, trace.xaxis);
  var ya = Axes.getFromId(gd, trace.yaxis);
  var xcalendar = trace.xcalendar;
  var ycalendar = trace.ycalendar;
  var xr2c = function (v) {
    return xa.r2c(v, 0, xcalendar);
  };
  var yr2c = function (v) {
    return ya.r2c(v, 0, ycalendar);
  };
  var xc2r = function (v) {
    return xa.c2r(v, 0, xcalendar);
  };
  var yc2r = function (v) {
    return ya.c2r(v, 0, ycalendar);
  };
  var i, j, n, m;

  // calculate the bins
  var xBinsAndPos = calcAllAutoBins(gd, trace, xa, 'x');
  var xBinSpec = xBinsAndPos[0];
  var xPos0 = xBinsAndPos[1];
  var yBinsAndPos = calcAllAutoBins(gd, trace, ya, 'y');
  var yBinSpec = yBinsAndPos[0];
  var yPos0 = yBinsAndPos[1];
  var serieslen = trace._length;
  if (xPos0.length > serieslen) xPos0.splice(serieslen, xPos0.length - serieslen);
  if (yPos0.length > serieslen) yPos0.splice(serieslen, yPos0.length - serieslen);

  // make the empty bin array & scale the map
  var z = [];
  var onecol = [];
  var zerocol = [];
  var nonuniformBinsX = typeof xBinSpec.size === 'string';
  var nonuniformBinsY = typeof yBinSpec.size === 'string';
  var xEdges = [];
  var yEdges = [];
  var xbins = nonuniformBinsX ? xEdges : xBinSpec;
  var ybins = nonuniformBinsY ? yEdges : yBinSpec;
  var total = 0;
  var counts = [];
  var inputPoints = [];
  var norm = trace.histnorm;
  var func = trace.histfunc;
  var densitynorm = norm.indexOf('density') !== -1;
  var extremefunc = func === 'max' || func === 'min';
  var sizeinit = extremefunc ? null : 0;
  var binfunc = binFunctions.count;
  var normfunc = normFunctions[norm];
  var doavg = false;
  var xinc = [];
  var yinc = [];

  // set a binning function other than count?
  // for binning functions: check first for 'z',
  // then 'mc' in case we had a colored scatter plot
  // and want to transfer these colors to the 2D histo
  // TODO: axe this, make it the responsibility of the app changing type? or an impliedEdit?
  var rawCounterData = 'z' in trace ? trace.z : 'marker' in trace && Array.isArray(trace.marker.color) ? trace.marker.color : '';
  if (rawCounterData && func !== 'count') {
    doavg = func === 'avg';
    binfunc = binFunctions[func];
  }

  // decrease end a little in case of rounding errors
  var xBinSize = xBinSpec.size;
  var xBinStart = xr2c(xBinSpec.start);
  var xBinEnd = xr2c(xBinSpec.end) + (xBinStart - Axes.tickIncrement(xBinStart, xBinSize, false, xcalendar)) / 1e6;
  for (i = xBinStart; i < xBinEnd; i = Axes.tickIncrement(i, xBinSize, false, xcalendar)) {
    onecol.push(sizeinit);
    xEdges.push(i);
    if (doavg) zerocol.push(0);
  }
  xEdges.push(i);
  var nx = onecol.length;
  var dx = (i - xBinStart) / nx;
  var x0 = xc2r(xBinStart + dx / 2);
  var yBinSize = yBinSpec.size;
  var yBinStart = yr2c(yBinSpec.start);
  var yBinEnd = yr2c(yBinSpec.end) + (yBinStart - Axes.tickIncrement(yBinStart, yBinSize, false, ycalendar)) / 1e6;
  for (i = yBinStart; i < yBinEnd; i = Axes.tickIncrement(i, yBinSize, false, ycalendar)) {
    z.push(onecol.slice());
    yEdges.push(i);
    var ipCol = new Array(nx);
    for (j = 0; j < nx; j++) ipCol[j] = [];
    inputPoints.push(ipCol);
    if (doavg) counts.push(zerocol.slice());
  }
  yEdges.push(i);
  var ny = z.length;
  var dy = (i - yBinStart) / ny;
  var y0 = yc2r(yBinStart + dy / 2);
  if (densitynorm) {
    xinc = makeIncrements(onecol.length, xbins, dx, nonuniformBinsX);
    yinc = makeIncrements(z.length, ybins, dy, nonuniformBinsY);
  }

  // for date axes we need bin bounds to be calcdata. For nonuniform bins
  // we already have this, but uniform with start/end/size they're still strings.
  if (!nonuniformBinsX && xa.type === 'date') xbins = binsToCalc(xr2c, xbins);
  if (!nonuniformBinsY && ya.type === 'date') ybins = binsToCalc(yr2c, ybins);

  // put data into bins
  var uniqueValsPerX = true;
  var uniqueValsPerY = true;
  var xVals = new Array(nx);
  var yVals = new Array(ny);
  var xGapLow = Infinity;
  var xGapHigh = Infinity;
  var yGapLow = Infinity;
  var yGapHigh = Infinity;
  for (i = 0; i < serieslen; i++) {
    var xi = xPos0[i];
    var yi = yPos0[i];
    n = Lib.findBin(xi, xbins);
    m = Lib.findBin(yi, ybins);
    if (n >= 0 && n < nx && m >= 0 && m < ny) {
      total += binfunc(n, i, z[m], rawCounterData, counts[m]);
      inputPoints[m][n].push(i);
      if (uniqueValsPerX) {
        if (xVals[n] === undefined) xVals[n] = xi;else if (xVals[n] !== xi) uniqueValsPerX = false;
      }
      if (uniqueValsPerY) {
        if (yVals[m] === undefined) yVals[m] = yi;else if (yVals[m] !== yi) uniqueValsPerY = false;
      }
      xGapLow = Math.min(xGapLow, xi - xEdges[n]);
      xGapHigh = Math.min(xGapHigh, xEdges[n + 1] - xi);
      yGapLow = Math.min(yGapLow, yi - yEdges[m]);
      yGapHigh = Math.min(yGapHigh, yEdges[m + 1] - yi);
    }
  }
  // normalize, if needed
  if (doavg) {
    for (m = 0; m < ny; m++) total += doAvg(z[m], counts[m]);
  }
  if (normfunc) {
    for (m = 0; m < ny; m++) normfunc(z[m], total, xinc, yinc[m]);
  }
  return {
    x: xPos0,
    xRanges: getRanges(xEdges, uniqueValsPerX && xVals, xGapLow, xGapHigh, xa, xcalendar),
    x0: x0,
    dx: dx,
    y: yPos0,
    yRanges: getRanges(yEdges, uniqueValsPerY && yVals, yGapLow, yGapHigh, ya, ycalendar),
    y0: y0,
    dy: dy,
    z: z,
    pts: inputPoints
  };
};
function makeIncrements(len, bins, dv, nonuniform) {
  var out = new Array(len);
  var i;
  if (nonuniform) {
    for (i = 0; i < len; i++) out[i] = 1 / (bins[i + 1] - bins[i]);
  } else {
    var inc = 1 / dv;
    for (i = 0; i < len; i++) out[i] = inc;
  }
  return out;
}
function binsToCalc(r2c, bins) {
  return {
    start: r2c(bins.start),
    end: r2c(bins.end),
    size: bins.size
  };
}
function getRanges(edges, uniqueVals, gapLow, gapHigh, ax, calendar) {
  var i;
  var len = edges.length - 1;
  var out = new Array(len);
  var roundFn = getBinSpanLabelRound(gapLow, gapHigh, edges, ax, calendar);
  for (i = 0; i < len; i++) {
    var v = (uniqueVals || [])[i];
    out[i] = v === undefined ? [roundFn(edges[i]), roundFn(edges[i + 1], true)] : [v, v];
  }
  return out;
}

/***/ }),

/***/ 29097:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var handleSampleDefaults = __webpack_require__(77134);
var handleStyleDefaults = __webpack_require__(44143);
var colorscaleDefaults = __webpack_require__(39356);
var handleHeatmapLabelDefaults = __webpack_require__(63814);
var attributes = __webpack_require__(9310);
module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
  function coerce(attr, dflt) {
    return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
  }
  handleSampleDefaults(traceIn, traceOut, coerce, layout);
  if (traceOut.visible === false) return;
  handleStyleDefaults(traceIn, traceOut, coerce, layout);
  colorscaleDefaults(traceIn, traceOut, layout, coerce, {
    prefix: '',
    cLetter: 'z'
  });
  coerce('hovertemplate');
  handleHeatmapLabelDefaults(coerce, layout);
  coerce('xhoverformat');
  coerce('yhoverformat');
};

/***/ }),

/***/ 1873:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var heatmapHover = __webpack_require__(93125);
var hoverLabelText = (__webpack_require__(29714).hoverLabelText);
module.exports = function hoverPoints(pointData, xval, yval, hovermode, opts) {
  var pts = heatmapHover(pointData, xval, yval, hovermode, opts);
  if (!pts) return;
  pointData = pts[0];
  var indices = pointData.index;
  var ny = indices[0];
  var nx = indices[1];
  var cd0 = pointData.cd[0];
  var trace = cd0.trace;
  var xRange = cd0.xRanges[nx];
  var yRange = cd0.yRanges[ny];
  pointData.xLabel = hoverLabelText(pointData.xa, [xRange[0], xRange[1]], trace.xhoverformat);
  pointData.yLabel = hoverLabelText(pointData.ya, [yRange[0], yRange[1]], trace.yhoverformat);
  return pts;
};

/***/ }),

/***/ 66143:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = {
  attributes: __webpack_require__(9310),
  supplyDefaults: __webpack_require__(29097),
  crossTraceDefaults: __webpack_require__(83380),
  calc: __webpack_require__(51670),
  plot: __webpack_require__(19236),
  layerName: 'heatmaplayer',
  colorbar: __webpack_require__(12431),
  style: __webpack_require__(12774),
  hoverPoints: __webpack_require__(1873),
  eventData: __webpack_require__(82604),
  moduleType: 'trace',
  name: 'histogram2d',
  basePlotModule: __webpack_require__(37703),
  categories: ['cartesian', 'svg', '2dMap', 'histogram', 'showLegend'],
  meta: {}
};

/***/ }),

/***/ 77134:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Registry = __webpack_require__(33626);
var Lib = __webpack_require__(34809);
module.exports = function handleSampleDefaults(traceIn, traceOut, coerce, layout) {
  var x = coerce('x');
  var y = coerce('y');
  var xlen = Lib.minRowLength(x);
  var ylen = Lib.minRowLength(y);

  // we could try to accept x0 and dx, etc...
  // but that's a pretty weird use case.
  // for now require both x and y explicitly specified.
  if (!xlen || !ylen) {
    traceOut.visible = false;
    return;
  }
  traceOut._length = Math.min(xlen, ylen);
  var handleCalendarDefaults = Registry.getComponentMethod('calendars', 'handleTraceDefaults');
  handleCalendarDefaults(traceIn, traceOut, ['x', 'y'], layout);

  // if marker.color is an array, we can use it in aggregation instead of z
  var hasAggregationData = coerce('z') || coerce('marker.color');
  if (hasAggregationData) coerce('histfunc');
  coerce('histnorm');

  // Note: bin defaults are now handled in Histogram2D.crossTraceDefaults
  // autobin(x|y) are only included here to appease Plotly.validate
  coerce('autobinx');
  coerce('autobiny');
};

/***/ }),

/***/ 85018:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var histogram2dAttrs = __webpack_require__(9310);
var contourAttrs = __webpack_require__(52240);
var colorScaleAttrs = __webpack_require__(87163);
var axisHoverFormat = (__webpack_require__(80712).axisHoverFormat);
var extendFlat = (__webpack_require__(93049).extendFlat);
module.exports = extendFlat({
  x: histogram2dAttrs.x,
  y: histogram2dAttrs.y,
  z: histogram2dAttrs.z,
  marker: histogram2dAttrs.marker,
  histnorm: histogram2dAttrs.histnorm,
  histfunc: histogram2dAttrs.histfunc,
  nbinsx: histogram2dAttrs.nbinsx,
  xbins: histogram2dAttrs.xbins,
  nbinsy: histogram2dAttrs.nbinsy,
  ybins: histogram2dAttrs.ybins,
  autobinx: histogram2dAttrs.autobinx,
  autobiny: histogram2dAttrs.autobiny,
  bingroup: histogram2dAttrs.bingroup,
  xbingroup: histogram2dAttrs.xbingroup,
  ybingroup: histogram2dAttrs.ybingroup,
  autocontour: contourAttrs.autocontour,
  ncontours: contourAttrs.ncontours,
  contours: contourAttrs.contours,
  line: {
    color: contourAttrs.line.color,
    width: extendFlat({}, contourAttrs.line.width, {
      dflt: 0.5
    }),
    dash: contourAttrs.line.dash,
    smoothing: contourAttrs.line.smoothing,
    editType: 'plot'
  },
  xhoverformat: axisHoverFormat('x'),
  yhoverformat: axisHoverFormat('y'),
  zhoverformat: axisHoverFormat('z', 1),
  hovertemplate: histogram2dAttrs.hovertemplate,
  texttemplate: contourAttrs.texttemplate,
  textfont: contourAttrs.textfont
}, colorScaleAttrs('', {
  cLetter: 'z',
  editTypeOverride: 'calc'
}));

/***/ }),

/***/ 49389:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var handleSampleDefaults = __webpack_require__(77134);
var handleContoursDefaults = __webpack_require__(47495);
var handleStyleDefaults = __webpack_require__(39889);
var handleHeatmapLabelDefaults = __webpack_require__(63814);
var attributes = __webpack_require__(85018);
module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
  function coerce(attr, dflt) {
    return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
  }
  function coerce2(attr) {
    return Lib.coerce2(traceIn, traceOut, attributes, attr);
  }
  handleSampleDefaults(traceIn, traceOut, coerce, layout);
  if (traceOut.visible === false) return;
  handleContoursDefaults(traceIn, traceOut, coerce, coerce2);
  handleStyleDefaults(traceIn, traceOut, coerce, layout);
  coerce('xhoverformat');
  coerce('yhoverformat');
  coerce('hovertemplate');
  if (traceOut.contours && traceOut.contours.coloring === 'heatmap') {
    handleHeatmapLabelDefaults(coerce, layout);
  }
};

/***/ }),

/***/ 81955:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = {
  attributes: __webpack_require__(85018),
  supplyDefaults: __webpack_require__(49389),
  crossTraceDefaults: __webpack_require__(83380),
  calc: __webpack_require__(40352),
  plot: (__webpack_require__(8850).plot),
  layerName: 'contourlayer',
  style: __webpack_require__(1328),
  colorbar: __webpack_require__(92697),
  hoverPoints: __webpack_require__(29815),
  moduleType: 'trace',
  name: 'histogram2dcontour',
  basePlotModule: __webpack_require__(37703),
  categories: ['cartesian', 'svg', '2dMap', 'contour', 'histogram', 'showLegend'],
  meta: {}
};

/***/ }),

/***/ 12505:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var hovertemplateAttrs = (__webpack_require__(3208)/* .hovertemplateAttrs */ .rb);
var texttemplateAttrs = (__webpack_require__(3208)/* .texttemplateAttrs */ .ay);
var colorScaleAttrs = __webpack_require__(87163);
var domainAttrs = (__webpack_require__(13792)/* .attributes */ .u);
var pieAttrs = __webpack_require__(55412);
var sunburstAttrs = __webpack_require__(56708);
var treemapAttrs = __webpack_require__(71856);
var constants = __webpack_require__(43236);
var extendFlat = (__webpack_require__(93049).extendFlat);
var pattern = (__webpack_require__(94850)/* .pattern */ .k);
module.exports = {
  labels: sunburstAttrs.labels,
  parents: sunburstAttrs.parents,
  values: sunburstAttrs.values,
  branchvalues: sunburstAttrs.branchvalues,
  count: sunburstAttrs.count,
  level: sunburstAttrs.level,
  maxdepth: sunburstAttrs.maxdepth,
  tiling: {
    orientation: {
      valType: 'enumerated',
      values: ['v', 'h'],
      dflt: 'h',
      editType: 'plot'
    },
    flip: treemapAttrs.tiling.flip,
    pad: {
      valType: 'number',
      min: 0,
      dflt: 0,
      editType: 'plot'
    },
    editType: 'calc'
  },
  marker: extendFlat({
    colors: sunburstAttrs.marker.colors,
    line: sunburstAttrs.marker.line,
    pattern: pattern,
    editType: 'calc'
  }, colorScaleAttrs('marker', {
    colorAttr: 'colors',
    anim: false // TODO: set to anim: true?
  })),
  leaf: sunburstAttrs.leaf,
  pathbar: treemapAttrs.pathbar,
  text: pieAttrs.text,
  textinfo: sunburstAttrs.textinfo,
  // TODO: incorporate `label` and `value` in the eventData
  texttemplate: texttemplateAttrs({
    editType: 'plot'
  }, {
    keys: constants.eventDataKeys.concat(['label', 'value'])
  }),
  hovertext: pieAttrs.hovertext,
  hoverinfo: sunburstAttrs.hoverinfo,
  hovertemplate: hovertemplateAttrs({}, {
    keys: constants.eventDataKeys
  }),
  textfont: pieAttrs.textfont,
  insidetextfont: pieAttrs.insidetextfont,
  outsidetextfont: treemapAttrs.outsidetextfont,
  textposition: treemapAttrs.textposition,
  sort: pieAttrs.sort,
  root: sunburstAttrs.root,
  domain: domainAttrs({
    name: 'icicle',
    trace: true,
    editType: 'calc'
  })
};

/***/ }),

/***/ 63387:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var plots = __webpack_require__(44122);
exports.name = 'icicle';
exports.plot = function (gd, traces, transitionOpts, makeOnCompleteCallback) {
  plots.plotBasePlot(exports.name, gd, traces, transitionOpts, makeOnCompleteCallback);
};
exports.clean = function (newFullData, newFullLayout, oldFullData, oldFullLayout) {
  plots.cleanBasePlot(exports.name, newFullData, newFullLayout, oldFullData, oldFullLayout);
};

/***/ }),

/***/ 36349:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var calc = __webpack_require__(14852);
exports._ = function (gd, trace) {
  return calc.calc(gd, trace);
};
exports.t = function (gd) {
  return calc._runCrossTraceCalc('icicle', gd);
};

/***/ }),

/***/ 17918:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var attributes = __webpack_require__(12505);
var Color = __webpack_require__(78766);
var handleDomainDefaults = (__webpack_require__(13792)/* .defaults */ .N);
var handleText = (__webpack_require__(17550).handleText);
var TEXTPAD = (__webpack_require__(56155).TEXTPAD);
var handleMarkerDefaults = (__webpack_require__(46979).handleMarkerDefaults);
var Colorscale = __webpack_require__(88856);
var hasColorscale = Colorscale.hasColorscale;
var colorscaleDefaults = Colorscale.handleDefaults;
module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
  function coerce(attr, dflt) {
    return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
  }
  var labels = coerce('labels');
  var parents = coerce('parents');
  if (!labels || !labels.length || !parents || !parents.length) {
    traceOut.visible = false;
    return;
  }
  var vals = coerce('values');
  if (vals && vals.length) {
    coerce('branchvalues');
  } else {
    coerce('count');
  }
  coerce('level');
  coerce('maxdepth');
  coerce('tiling.orientation');
  coerce('tiling.flip');
  coerce('tiling.pad');
  var text = coerce('text');
  coerce('texttemplate');
  if (!traceOut.texttemplate) coerce('textinfo', Lib.isArrayOrTypedArray(text) ? 'text+label' : 'label');
  coerce('hovertext');
  coerce('hovertemplate');
  var hasPathbar = coerce('pathbar.visible');
  var textposition = 'auto';
  handleText(traceIn, traceOut, layout, coerce, textposition, {
    hasPathbar: hasPathbar,
    moduleHasSelected: false,
    moduleHasUnselected: false,
    moduleHasConstrain: false,
    moduleHasCliponaxis: false,
    moduleHasTextangle: false,
    moduleHasInsideanchor: false
  });
  coerce('textposition');
  handleMarkerDefaults(traceIn, traceOut, layout, coerce);
  var withColorscale = traceOut._hasColorscale = hasColorscale(traceIn, 'marker', 'colors') || (traceIn.marker || {}).coloraxis // N.B. special logic to consider "values" colorscales
  ;
  if (withColorscale) {
    colorscaleDefaults(traceIn, traceOut, layout, coerce, {
      prefix: 'marker.',
      cLetter: 'c'
    });
  }
  coerce('leaf.opacity', withColorscale ? 1 : 0.7);
  traceOut._hovered = {
    marker: {
      line: {
        width: 2,
        color: Color.contrast(layout.paper_bgcolor)
      }
    }
  };
  if (hasPathbar) {
    // This works even for multi-line labels as icicle pathbar trim out line breaks
    coerce('pathbar.thickness', traceOut.pathbar.textfont.size + 2 * TEXTPAD);
    coerce('pathbar.side');
    coerce('pathbar.edgeshape');
  }
  coerce('sort');
  coerce('root.color');
  handleDomainDefaults(traceOut, layout, coerce);

  // do not support transforms for now
  traceOut._length = null;
};

/***/ }),

/***/ 23593:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var Lib = __webpack_require__(34809);
var Drawing = __webpack_require__(62203);
var svgTextUtils = __webpack_require__(30635);
var partition = __webpack_require__(29316);
var styleOne = (__webpack_require__(50579).styleOne);
var constants = __webpack_require__(43236);
var helpers = __webpack_require__(33108);
var attachFxHandlers = __webpack_require__(44691);
var formatSliceLabel = (__webpack_require__(19718).formatSliceLabel);
var onPathbar = false; // for Descendants

module.exports = function drawDescendants(gd, cd, entry, slices, opts) {
  var width = opts.width;
  var height = opts.height;
  var viewX = opts.viewX;
  var viewY = opts.viewY;
  var pathSlice = opts.pathSlice;
  var toMoveInsideSlice = opts.toMoveInsideSlice;
  var strTransform = opts.strTransform;
  var hasTransition = opts.hasTransition;
  var handleSlicesExit = opts.handleSlicesExit;
  var makeUpdateSliceInterpolator = opts.makeUpdateSliceInterpolator;
  var makeUpdateTextInterpolator = opts.makeUpdateTextInterpolator;
  var prevEntry = opts.prevEntry;
  var refRect = {};
  var isStatic = gd._context.staticPlot;
  var fullLayout = gd._fullLayout;
  var cd0 = cd[0];
  var trace = cd0.trace;
  var hasLeft = trace.textposition.indexOf('left') !== -1;
  var hasRight = trace.textposition.indexOf('right') !== -1;
  var hasBottom = trace.textposition.indexOf('bottom') !== -1;

  // N.B. slice data isn't the calcdata,
  // grab corresponding calcdata item in sliceData[i].data.data
  var allData = partition(entry, [width, height], {
    flipX: trace.tiling.flip.indexOf('x') > -1,
    flipY: trace.tiling.flip.indexOf('y') > -1,
    orientation: trace.tiling.orientation,
    pad: {
      inner: trace.tiling.pad
    },
    maxDepth: trace._maxDepth
  });
  var sliceData = allData.descendants();
  var minVisibleDepth = Infinity;
  var maxVisibleDepth = -Infinity;
  sliceData.forEach(function (pt) {
    var depth = pt.depth;
    if (depth >= trace._maxDepth) {
      // hide slices that won't show up on graph
      pt.x0 = pt.x1 = (pt.x0 + pt.x1) / 2;
      pt.y0 = pt.y1 = (pt.y0 + pt.y1) / 2;
    } else {
      minVisibleDepth = Math.min(minVisibleDepth, depth);
      maxVisibleDepth = Math.max(maxVisibleDepth, depth);
    }
  });
  slices = slices.data(sliceData, helpers.getPtId);
  trace._maxVisibleLayers = isFinite(maxVisibleDepth) ? maxVisibleDepth - minVisibleDepth + 1 : 0;
  slices.enter().append('g').classed('slice', true);
  handleSlicesExit(slices, onPathbar, refRect, [width, height], pathSlice);
  slices.order();

  // next coords of previous entry
  var nextOfPrevEntry = null;
  if (hasTransition && prevEntry) {
    var prevEntryId = helpers.getPtId(prevEntry);
    slices.each(function (pt) {
      if (nextOfPrevEntry === null && helpers.getPtId(pt) === prevEntryId) {
        nextOfPrevEntry = {
          x0: pt.x0,
          x1: pt.x1,
          y0: pt.y0,
          y1: pt.y1
        };
      }
    });
  }
  var getRefRect = function () {
    return nextOfPrevEntry || {
      x0: 0,
      x1: width,
      y0: 0,
      y1: height
    };
  };
  var updateSlices = slices;
  if (hasTransition) {
    updateSlices = updateSlices.transition().each('end', function () {
      // N.B. gd._transitioning is (still) *true* by the time
      // transition updates get here
      var sliceTop = d3.select(this);
      helpers.setSliceCursor(sliceTop, gd, {
        hideOnRoot: true,
        hideOnLeaves: false,
        isTransitioning: false
      });
    });
  }
  updateSlices.each(function (pt) {
    // for bbox
    pt._x0 = viewX(pt.x0);
    pt._x1 = viewX(pt.x1);
    pt._y0 = viewY(pt.y0);
    pt._y1 = viewY(pt.y1);
    pt._hoverX = viewX(pt.x1 - trace.tiling.pad), pt._hoverY = hasBottom ? viewY(pt.y1 - trace.tiling.pad / 2) : viewY(pt.y0 + trace.tiling.pad / 2);
    var sliceTop = d3.select(this);
    var slicePath = Lib.ensureSingle(sliceTop, 'path', 'surface', function (s) {
      s.style('pointer-events', isStatic ? 'none' : 'all');
    });
    if (hasTransition) {
      slicePath.transition().attrTween('d', function (pt2) {
        var interp = makeUpdateSliceInterpolator(pt2, onPathbar, getRefRect(), [width, height], {
          orientation: trace.tiling.orientation,
          flipX: trace.tiling.flip.indexOf('x') > -1,
          flipY: trace.tiling.flip.indexOf('y') > -1
        });
        return function (t) {
          return pathSlice(interp(t));
        };
      });
    } else {
      slicePath.attr('d', pathSlice);
    }
    sliceTop.call(attachFxHandlers, entry, gd, cd, {
      styleOne: styleOne,
      eventDataKeys: constants.eventDataKeys,
      transitionTime: constants.CLICK_TRANSITION_TIME,
      transitionEasing: constants.CLICK_TRANSITION_EASING
    }).call(helpers.setSliceCursor, gd, {
      isTransitioning: gd._transitioning
    });
    slicePath.call(styleOne, pt, trace, gd, {
      hovered: false
    });
    if (pt.x0 === pt.x1 || pt.y0 === pt.y1) {
      pt._text = '';
    } else {
      pt._text = formatSliceLabel(pt, entry, trace, cd, fullLayout) || '';
    }
    var sliceTextGroup = Lib.ensureSingle(sliceTop, 'g', 'slicetext');
    var sliceText = Lib.ensureSingle(sliceTextGroup, 'text', '', function (s) {
      // prohibit tex interpretation until we can handle
      // tex and regular text together
      s.attr('data-notex', 1);
    });
    var font = Lib.ensureUniformFontSize(gd, helpers.determineTextFont(trace, pt, fullLayout.font));
    sliceText.text(pt._text || ' ') // use one space character instead of a blank string to avoid jumps during transition
    .classed('slicetext', true).attr('text-anchor', hasRight ? 'end' : hasLeft ? 'start' : 'middle').call(Drawing.font, font).call(svgTextUtils.convertToTspans, gd);
    pt.textBB = Drawing.bBox(sliceText.node());
    pt.transform = toMoveInsideSlice(pt, {
      fontSize: font.size
    });
    pt.transform.fontSize = font.size;
    if (hasTransition) {
      sliceText.transition().attrTween('transform', function (pt2) {
        var interp = makeUpdateTextInterpolator(pt2, onPathbar, getRefRect(), [width, height]);
        return function (t) {
          return strTransform(interp(t));
        };
      });
    } else {
      sliceText.attr('transform', strTransform(pt));
    }
  });
  return nextOfPrevEntry;
};

/***/ }),

/***/ 36858:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = {
  moduleType: 'trace',
  name: 'icicle',
  basePlotModule: __webpack_require__(63387),
  categories: [],
  animatable: true,
  attributes: __webpack_require__(12505),
  layoutAttributes: __webpack_require__(60052),
  supplyDefaults: __webpack_require__(17918),
  supplyLayoutDefaults: __webpack_require__(11747),
  calc: (__webpack_require__(36349)/* .calc */ ._),
  crossTraceCalc: (__webpack_require__(36349)/* .crossTraceCalc */ .t),
  plot: __webpack_require__(1395),
  style: (__webpack_require__(50579).style),
  colorbar: __webpack_require__(21146),
  meta: {}
};

/***/ }),

/***/ 60052:
/***/ (function(module) {

"use strict";


module.exports = {
  iciclecolorway: {
    valType: 'colorlist',
    editType: 'calc'
  },
  extendiciclecolors: {
    valType: 'boolean',
    dflt: true,
    editType: 'calc'
  }
};

/***/ }),

/***/ 11747:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var layoutAttributes = __webpack_require__(60052);
module.exports = function supplyLayoutDefaults(layoutIn, layoutOut) {
  function coerce(attr, dflt) {
    return Lib.coerce(layoutIn, layoutOut, layoutAttributes, attr, dflt);
  }
  coerce('iciclecolorway', layoutOut.colorway);
  coerce('extendiciclecolors');
};

/***/ }),

/***/ 29316:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3Hierarchy = __webpack_require__(92264);
var flipTree = __webpack_require__(36141);
module.exports = function partition(entry, size, opts) {
  var flipX = opts.flipX;
  var flipY = opts.flipY;
  var swapXY = opts.orientation === 'h';
  var maxDepth = opts.maxDepth;
  var newWidth = size[0];
  var newHeight = size[1];
  if (maxDepth) {
    newWidth = (entry.height + 1) * size[0] / Math.min(entry.height + 1, maxDepth);
    newHeight = (entry.height + 1) * size[1] / Math.min(entry.height + 1, maxDepth);
  }
  var result = d3Hierarchy.partition().padding(opts.pad.inner).size(swapXY ? [size[1], newWidth] : [size[0], newHeight])(entry);
  if (swapXY || flipX || flipY) {
    flipTree(result, size, {
      swapXY: swapXY,
      flipX: flipX,
      flipY: flipY
    });
  }
  return result;
};

/***/ }),

/***/ 1395:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var draw = __webpack_require__(41567);
var drawDescendants = __webpack_require__(23593);
module.exports = function _plot(gd, cdmodule, transitionOpts, makeOnCompleteCallback) {
  return draw(gd, cdmodule, transitionOpts, makeOnCompleteCallback, {
    type: 'icicle',
    drawDescendants: drawDescendants
  });
};

/***/ }),

/***/ 50579:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var Color = __webpack_require__(78766);
var Lib = __webpack_require__(34809);
var resizeText = (__webpack_require__(84102).resizeText);
var fillOne = __webpack_require__(72043);
function style(gd) {
  var s = gd._fullLayout._iciclelayer.selectAll('.trace');
  resizeText(gd, s, 'icicle');
  s.each(function (cd) {
    var gTrace = d3.select(this);
    var cd0 = cd[0];
    var trace = cd0.trace;
    gTrace.style('opacity', trace.opacity);
    gTrace.selectAll('path.surface').each(function (pt) {
      d3.select(this).call(styleOne, pt, trace, gd);
    });
  });
}
function styleOne(s, pt, trace, gd) {
  var cdi = pt.data.data;
  var isLeaf = !pt.children;
  var ptNumber = cdi.i;
  var lineColor = Lib.castOption(trace, ptNumber, 'marker.line.color') || Color.defaultLine;
  var lineWidth = Lib.castOption(trace, ptNumber, 'marker.line.width') || 0;
  s.call(fillOne, pt, trace, gd).style('stroke-width', lineWidth).call(Color.stroke, lineColor).style('opacity', isLeaf ? trace.leaf.opacity : null);
}
module.exports = {
  style: style,
  styleOne: styleOne
};

/***/ }),

/***/ 22153:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var baseAttrs = __webpack_require__(9829);
var zorder = (__webpack_require__(36640).zorder);
var hovertemplateAttrs = (__webpack_require__(3208)/* .hovertemplateAttrs */ .rb);
var extendFlat = (__webpack_require__(93049).extendFlat);
var colormodel = (__webpack_require__(42939).colormodel);
var cm = ['rgb', 'rgba', 'rgba256', 'hsl', 'hsla'];
var zminDesc = [];
var zmaxDesc = [];
for (var i = 0; i < cm.length; i++) {
  var cr = colormodel[cm[i]];
  zminDesc.push('For the `' + cm[i] + '` colormodel, it is [' + (cr.zminDflt || cr.min).join(', ') + '].');
  zmaxDesc.push('For the `' + cm[i] + '` colormodel, it is [' + (cr.zmaxDflt || cr.max).join(', ') + '].');
}
module.exports = extendFlat({
  source: {
    valType: 'string',
    editType: 'calc'
  },
  z: {
    valType: 'data_array',
    editType: 'calc'
  },
  colormodel: {
    valType: 'enumerated',
    values: cm,
    editType: 'calc'
  },
  zsmooth: {
    valType: 'enumerated',
    values: ['fast', false],
    dflt: false,
    editType: 'plot'
  },
  zmin: {
    valType: 'info_array',
    items: [{
      valType: 'number',
      editType: 'calc'
    }, {
      valType: 'number',
      editType: 'calc'
    }, {
      valType: 'number',
      editType: 'calc'
    }, {
      valType: 'number',
      editType: 'calc'
    }],
    editType: 'calc'
  },
  zmax: {
    valType: 'info_array',
    items: [{
      valType: 'number',
      editType: 'calc'
    }, {
      valType: 'number',
      editType: 'calc'
    }, {
      valType: 'number',
      editType: 'calc'
    }, {
      valType: 'number',
      editType: 'calc'
    }],
    editType: 'calc'
  },
  x0: {
    valType: 'any',
    dflt: 0,
    editType: 'calc+clearAxisTypes'
  },
  y0: {
    valType: 'any',
    dflt: 0,
    editType: 'calc+clearAxisTypes'
  },
  dx: {
    valType: 'number',
    dflt: 1,
    editType: 'calc'
  },
  dy: {
    valType: 'number',
    dflt: 1,
    editType: 'calc'
  },
  text: {
    valType: 'data_array',
    editType: 'plot'
  },
  hovertext: {
    valType: 'data_array',
    editType: 'plot'
  },
  hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
    flags: ['x', 'y', 'z', 'color', 'name', 'text'],
    dflt: 'x+y+z+text+name'
  }),
  hovertemplate: hovertemplateAttrs({}, {
    keys: ['z', 'color', 'colormodel']
  }),
  zorder: zorder,
  transforms: undefined
});

/***/ }),

/***/ 31181:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var constants = __webpack_require__(42939);
var isNumeric = __webpack_require__(10721);
var Axes = __webpack_require__(29714);
var maxRowLength = (__webpack_require__(34809).maxRowLength);
var getImageSize = (__webpack_require__(96315)/* .getImageSize */ .p);
module.exports = function calc(gd, trace) {
  var h;
  var w;
  if (trace._hasZ) {
    h = trace.z.length;
    w = maxRowLength(trace.z);
  } else if (trace._hasSource) {
    var size = getImageSize(trace.source);
    h = size.height;
    w = size.width;
  }
  var xa = Axes.getFromId(gd, trace.xaxis || 'x');
  var ya = Axes.getFromId(gd, trace.yaxis || 'y');
  var x0 = xa.d2c(trace.x0) - trace.dx / 2;
  var y0 = ya.d2c(trace.y0) - trace.dy / 2;

  // Set axis range
  var i;
  var xrange = [x0, x0 + w * trace.dx];
  var yrange = [y0, y0 + h * trace.dy];
  if (xa && xa.type === 'log') for (i = 0; i < w; i++) xrange.push(x0 + i * trace.dx);
  if (ya && ya.type === 'log') for (i = 0; i < h; i++) yrange.push(y0 + i * trace.dy);
  trace._extremes[xa._id] = Axes.findExtremes(xa, xrange);
  trace._extremes[ya._id] = Axes.findExtremes(ya, yrange);
  trace._scaler = makeScaler(trace);
  var cd0 = {
    x0: x0,
    y0: y0,
    z: trace.z,
    w: w,
    h: h
  };
  return [cd0];
};
function scale(zero, ratio, min, max) {
  return function (c) {
    return Lib.constrain((c - zero) * ratio, min, max);
  };
}
function constrain(min, max) {
  return function (c) {
    return Lib.constrain(c, min, max);
  };
}

// Generate a function to scale color components according to zmin/zmax and the colormodel
function makeScaler(trace) {
  var cr = constants.colormodel[trace.colormodel];
  var colormodel = cr.colormodel || trace.colormodel;
  var n = colormodel.length;
  trace._sArray = [];
  // Loop over all color components
  for (var k = 0; k < n; k++) {
    if (cr.min[k] !== trace.zmin[k] || cr.max[k] !== trace.zmax[k]) {
      trace._sArray.push(scale(trace.zmin[k], (cr.max[k] - cr.min[k]) / (trace.zmax[k] - trace.zmin[k]), cr.min[k], cr.max[k]));
    } else {
      trace._sArray.push(constrain(cr.min[k], cr.max[k]));
    }
  }
  return function (pixel) {
    var c = pixel.slice(0, n);
    for (var k = 0; k < n; k++) {
      var ck = c[k];
      if (!isNumeric(ck)) return false;
      c[k] = trace._sArray[k](ck);
    }
    return c;
  };
}

/***/ }),

/***/ 42939:
/***/ (function(module) {

"use strict";


module.exports = {
  colormodel: {
    // min and max define the numerical range accepted in CSS
    // If z(min|max)Dflt are not defined, z(min|max) will default to min/max
    rgb: {
      min: [0, 0, 0],
      max: [255, 255, 255],
      fmt: function (c) {
        return c.slice(0, 3);
      },
      suffix: ['', '', '']
    },
    rgba: {
      min: [0, 0, 0, 0],
      max: [255, 255, 255, 1],
      fmt: function (c) {
        return c.slice(0, 4);
      },
      suffix: ['', '', '', '']
    },
    rgba256: {
      colormodel: 'rgba',
      // because rgba256 is not an accept colormodel in CSS
      zminDflt: [0, 0, 0, 0],
      zmaxDflt: [255, 255, 255, 255],
      min: [0, 0, 0, 0],
      max: [255, 255, 255, 1],
      fmt: function (c) {
        return c.slice(0, 4);
      },
      suffix: ['', '', '', '']
    },
    hsl: {
      min: [0, 0, 0],
      max: [360, 100, 100],
      fmt: function (c) {
        var p = c.slice(0, 3);
        p[1] = p[1] + '%';
        p[2] = p[2] + '%';
        return p;
      },
      suffix: ['°', '%', '%']
    },
    hsla: {
      min: [0, 0, 0, 0],
      max: [360, 100, 100, 1],
      fmt: function (c) {
        var p = c.slice(0, 4);
        p[1] = p[1] + '%';
        p[2] = p[2] + '%';
        return p;
      },
      suffix: ['°', '%', '%', '']
    }
  }
};

/***/ }),

/***/ 82766:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var attributes = __webpack_require__(22153);
var constants = __webpack_require__(42939);
var dataUri = (__webpack_require__(84619).IMAGE_URL_PREFIX);
module.exports = function supplyDefaults(traceIn, traceOut) {
  function coerce(attr, dflt) {
    return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
  }
  coerce('source');
  // sanitize source to only allow for data URI representing images
  if (traceOut.source && !traceOut.source.match(dataUri)) delete traceOut.source;
  traceOut._hasSource = !!traceOut.source;
  var z = coerce('z');
  traceOut._hasZ = !(z === undefined || !z.length || !z[0] || !z[0].length);
  if (!traceOut._hasZ && !traceOut._hasSource) {
    traceOut.visible = false;
    return;
  }
  coerce('x0');
  coerce('y0');
  coerce('dx');
  coerce('dy');
  var cm;
  if (traceOut._hasZ) {
    coerce('colormodel', 'rgb');
    cm = constants.colormodel[traceOut.colormodel];
    coerce('zmin', cm.zminDflt || cm.min);
    coerce('zmax', cm.zmaxDflt || cm.max);
  } else if (traceOut._hasSource) {
    traceOut.colormodel = 'rgba256';
    cm = constants.colormodel[traceOut.colormodel];
    traceOut.zmin = cm.zminDflt;
    traceOut.zmax = cm.zmaxDflt;
  }
  coerce('zsmooth');
  coerce('text');
  coerce('hovertext');
  coerce('hovertemplate');
  traceOut._length = null;
  coerce('zorder');
};

/***/ }),

/***/ 45461:
/***/ (function(module) {

"use strict";


module.exports = function eventData(out, pt) {
  if ('xVal' in pt) out.x = pt.xVal;
  if ('yVal' in pt) out.y = pt.yVal;
  if (pt.xa) out.xaxis = pt.xa;
  if (pt.ya) out.yaxis = pt.ya;
  out.color = pt.color;
  out.colormodel = pt.trace.colormodel;
  if (!out.z) out.z = pt.color;
  return out;
};

/***/ }),

/***/ 96315:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var probeSync = __webpack_require__(19490);
var dataUri = (__webpack_require__(84619).IMAGE_URL_PREFIX);
var Buffer = (__webpack_require__(45708).Buffer); // note: the trailing slash is important!

exports.p = function (src) {
  var data = src.replace(dataUri, '');
  var buff = new Buffer(data, 'base64');
  return probeSync(buff);
};

/***/ }),

/***/ 57328:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Fx = __webpack_require__(32141);
var Lib = __webpack_require__(34809);
var isArrayOrTypedArray = Lib.isArrayOrTypedArray;
var constants = __webpack_require__(42939);
module.exports = function hoverPoints(pointData, xval, yval) {
  var cd0 = pointData.cd[0];
  var trace = cd0.trace;
  var xa = pointData.xa;
  var ya = pointData.ya;

  // Return early if not on image
  if (Fx.inbox(xval - cd0.x0, xval - (cd0.x0 + cd0.w * trace.dx), 0) > 0 || Fx.inbox(yval - cd0.y0, yval - (cd0.y0 + cd0.h * trace.dy), 0) > 0) {
    return;
  }

  // Find nearest pixel's index
  var nx = Math.floor((xval - cd0.x0) / trace.dx);
  var ny = Math.floor(Math.abs(yval - cd0.y0) / trace.dy);
  var pixel;
  if (trace._hasZ) {
    pixel = cd0.z[ny][nx];
  } else if (trace._hasSource) {
    pixel = trace._canvas.el.getContext('2d', {
      willReadFrequently: true
    }).getImageData(nx, ny, 1, 1).data;
  }

  // return early if pixel is undefined
  if (!pixel) return;
  var hoverinfo = cd0.hi || trace.hoverinfo;
  var fmtColor;
  if (hoverinfo) {
    var parts = hoverinfo.split('+');
    if (parts.indexOf('all') !== -1) parts = ['color'];
    if (parts.indexOf('color') !== -1) fmtColor = true;
  }
  var cr = constants.colormodel[trace.colormodel];
  var colormodel = cr.colormodel || trace.colormodel;
  var dims = colormodel.length;
  var c = trace._scaler(pixel);
  var s = cr.suffix;
  var colorstring = [];
  if (trace.hovertemplate || fmtColor) {
    colorstring.push('[' + [c[0] + s[0], c[1] + s[1], c[2] + s[2]].join(', '));
    if (dims === 4) colorstring.push(', ' + c[3] + s[3]);
    colorstring.push(']');
    colorstring = colorstring.join('');
    pointData.extraText = colormodel.toUpperCase() + ': ' + colorstring;
  }
  var text;
  if (isArrayOrTypedArray(trace.hovertext) && isArrayOrTypedArray(trace.hovertext[ny])) {
    text = trace.hovertext[ny][nx];
  } else if (isArrayOrTypedArray(trace.text) && isArrayOrTypedArray(trace.text[ny])) {
    text = trace.text[ny][nx];
  }

  // TODO: for color model with 3 dims, display something useful for hovertemplate `%{color[3]}`
  var py = ya.c2p(cd0.y0 + (ny + 0.5) * trace.dy);
  var xVal = cd0.x0 + (nx + 0.5) * trace.dx;
  var yVal = cd0.y0 + (ny + 0.5) * trace.dy;
  var zLabel = '[' + pixel.slice(0, trace.colormodel.length).join(', ') + ']';
  return [Lib.extendFlat(pointData, {
    index: [ny, nx],
    x0: xa.c2p(cd0.x0 + nx * trace.dx),
    x1: xa.c2p(cd0.x0 + (nx + 1) * trace.dx),
    y0: py,
    y1: py,
    color: c,
    xVal: xVal,
    xLabelVal: xVal,
    yVal: yVal,
    yLabelVal: yVal,
    zLabelVal: zLabel,
    text: text,
    hovertemplateLabels: {
      zLabel: zLabel,
      colorLabel: colorstring,
      'color[0]Label': c[0] + s[0],
      'color[1]Label': c[1] + s[1],
      'color[2]Label': c[2] + s[2],
      'color[3]Label': c[3] + s[3]
    }
  })];
};

/***/ }),

/***/ 92106:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = {
  attributes: __webpack_require__(22153),
  supplyDefaults: __webpack_require__(82766),
  calc: __webpack_require__(31181),
  plot: __webpack_require__(36899),
  style: __webpack_require__(67555),
  hoverPoints: __webpack_require__(57328),
  eventData: __webpack_require__(45461),
  moduleType: 'trace',
  name: 'image',
  basePlotModule: __webpack_require__(37703),
  categories: ['cartesian', 'svg', '2dMap', 'noSortingByValue'],
  animatable: false,
  meta: {}
};

/***/ }),

/***/ 36899:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var Lib = __webpack_require__(34809);
var strTranslate = Lib.strTranslate;
var xmlnsNamespaces = __webpack_require__(62972);
var constants = __webpack_require__(42939);
var supportsPixelatedImage = __webpack_require__(95544);
var PIXELATED_IMAGE_STYLE = (__webpack_require__(1837).STYLE);
module.exports = function plot(gd, plotinfo, cdimage, imageLayer) {
  var xa = plotinfo.xaxis;
  var ya = plotinfo.yaxis;
  var supportsPixelated = !gd._context._exportedPlot && supportsPixelatedImage();
  Lib.makeTraceGroups(imageLayer, cdimage, 'im').each(function (cd) {
    var plotGroup = d3.select(this);
    var cd0 = cd[0];
    var trace = cd0.trace;
    var realImage = (trace.zsmooth === 'fast' || trace.zsmooth === false && supportsPixelated) && !trace._hasZ && trace._hasSource && xa.type === 'linear' && ya.type === 'linear';
    trace._realImage = realImage;
    var z = cd0.z;
    var x0 = cd0.x0;
    var y0 = cd0.y0;
    var w = cd0.w;
    var h = cd0.h;
    var dx = trace.dx;
    var dy = trace.dy;
    var left, right, temp, top, bottom, i;
    // in case of log of a negative
    i = 0;
    while (left === undefined && i < w) {
      left = xa.c2p(x0 + i * dx);
      i++;
    }
    i = w;
    while (right === undefined && i > 0) {
      right = xa.c2p(x0 + i * dx);
      i--;
    }
    i = 0;
    while (top === undefined && i < h) {
      top = ya.c2p(y0 + i * dy);
      i++;
    }
    i = h;
    while (bottom === undefined && i > 0) {
      bottom = ya.c2p(y0 + i * dy);
      i--;
    }
    if (right < left) {
      temp = right;
      right = left;
      left = temp;
    }
    if (bottom < top) {
      temp = top;
      top = bottom;
      bottom = temp;
    }

    // Reduce image size when zoomed in to save memory
    if (!realImage) {
      var extra = 0.5; // half the axis size
      left = Math.max(-extra * xa._length, left);
      right = Math.min((1 + extra) * xa._length, right);
      top = Math.max(-extra * ya._length, top);
      bottom = Math.min((1 + extra) * ya._length, bottom);
    }
    var imageWidth = Math.round(right - left);
    var imageHeight = Math.round(bottom - top);

    // if image is entirely off-screen, don't even draw it
    var isOffScreen = imageWidth <= 0 || imageHeight <= 0;
    if (isOffScreen) {
      var noImage = plotGroup.selectAll('image').data([]);
      noImage.exit().remove();
      return;
    }

    // Create a new canvas and draw magnified pixels on it
    function drawMagnifiedPixelsOnCanvas(readPixel) {
      var canvas = document.createElement('canvas');
      canvas.width = imageWidth;
      canvas.height = imageHeight;
      var context = canvas.getContext('2d', {
        willReadFrequently: true
      });
      var ipx = function (i) {
        return Lib.constrain(Math.round(xa.c2p(x0 + i * dx) - left), 0, imageWidth);
      };
      var jpx = function (j) {
        return Lib.constrain(Math.round(ya.c2p(y0 + j * dy) - top), 0, imageHeight);
      };
      var cr = constants.colormodel[trace.colormodel];
      var colormodel = cr.colormodel || trace.colormodel;
      var fmt = cr.fmt;
      var c;
      for (i = 0; i < cd0.w; i++) {
        var ipx0 = ipx(i);
        var ipx1 = ipx(i + 1);
        if (ipx1 === ipx0 || isNaN(ipx1) || isNaN(ipx0)) continue;
        for (var j = 0; j < cd0.h; j++) {
          var jpx0 = jpx(j);
          var jpx1 = jpx(j + 1);
          if (jpx1 === jpx0 || isNaN(jpx1) || isNaN(jpx0) || !readPixel(i, j)) continue;
          c = trace._scaler(readPixel(i, j));
          if (c) {
            context.fillStyle = colormodel + '(' + fmt(c).join(',') + ')';
          } else {
            // Return a transparent pixel
            context.fillStyle = 'rgba(0,0,0,0)';
          }
          context.fillRect(ipx0, jpx0, ipx1 - ipx0, jpx1 - jpx0);
        }
      }
      return canvas;
    }
    var image3 = plotGroup.selectAll('image').data([cd]);
    image3.enter().append('svg:image').attr({
      xmlns: xmlnsNamespaces.svg,
      preserveAspectRatio: 'none'
    });
    image3.exit().remove();
    var style = trace.zsmooth === false ? PIXELATED_IMAGE_STYLE : '';
    if (realImage) {
      var xRange = Lib.simpleMap(xa.range, xa.r2l);
      var yRange = Lib.simpleMap(ya.range, ya.r2l);
      var flipX = xRange[1] < xRange[0];
      var flipY = yRange[1] > yRange[0];
      if (flipX || flipY) {
        var tx = left + imageWidth / 2;
        var ty = top + imageHeight / 2;
        style += 'transform:' + strTranslate(tx + 'px', ty + 'px') + 'scale(' + (flipX ? -1 : 1) + ',' + (flipY ? -1 : 1) + ')' + strTranslate(-tx + 'px', -ty + 'px') + ';';
      }
    }
    image3.attr('style', style);
    var p = new Promise(function (resolve) {
      if (trace._hasZ) {
        resolve();
      } else if (trace._hasSource) {
        // Check if canvas already exists and has the right data
        if (trace._canvas && trace._canvas.el.width === w && trace._canvas.el.height === h && trace._canvas.source === trace.source) {
          resolve();
        } else {
          // Create a canvas and transfer image onto it to access pixel information
          var canvas = document.createElement('canvas');
          canvas.width = w;
          canvas.height = h;
          var context = canvas.getContext('2d', {
            willReadFrequently: true
          });
          trace._image = trace._image || new Image();
          var image = trace._image;
          image.onload = function () {
            context.drawImage(image, 0, 0);
            trace._canvas = {
              el: canvas,
              source: trace.source
            };
            resolve();
          };
          image.setAttribute('src', trace.source);
        }
      }
    }).then(function () {
      var href, canvas;
      if (trace._hasZ) {
        canvas = drawMagnifiedPixelsOnCanvas(function (i, j) {
          var _z = z[j][i];
          if (Lib.isTypedArray(_z)) _z = Array.from(_z);
          return _z;
        });
        href = canvas.toDataURL('image/png');
      } else if (trace._hasSource) {
        if (realImage) {
          href = trace.source;
        } else {
          var context = trace._canvas.el.getContext('2d', {
            willReadFrequently: true
          });
          var data = context.getImageData(0, 0, w, h).data;
          canvas = drawMagnifiedPixelsOnCanvas(function (i, j) {
            var index = 4 * (j * w + i);
            return [data[index], data[index + 1], data[index + 2], data[index + 3]];
          });
          href = canvas.toDataURL('image/png');
        }
      }
      image3.attr({
        'xlink:href': href,
        height: imageHeight,
        width: imageWidth,
        x: left,
        y: top
      });
    });
    gd._promises.push(p);
  });
};

/***/ }),

/***/ 67555:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
module.exports = function style(gd) {
  d3.select(gd).selectAll('.im image').style('opacity', function (d) {
    return d[0].trace.opacity;
  });
};

/***/ }),

/***/ 95485:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var extendFlat = (__webpack_require__(93049).extendFlat);
var extendDeep = (__webpack_require__(93049).extendDeep);
var overrideAll = (__webpack_require__(13582).overrideAll);
var fontAttrs = __webpack_require__(80337);
var colorAttrs = __webpack_require__(10229);
var domainAttrs = (__webpack_require__(13792)/* .attributes */ .u);
var axesAttrs = __webpack_require__(25829);
var templatedArray = (__webpack_require__(78032).templatedArray);
var delta = __webpack_require__(20909);
var descriptionOnlyNumbers = (__webpack_require__(80712).descriptionOnlyNumbers);
var textFontAttrs = fontAttrs({
  editType: 'plot',
  colorEditType: 'plot'
});
var gaugeBarAttrs = {
  color: {
    valType: 'color',
    editType: 'plot'
  },
  line: {
    color: {
      valType: 'color',
      dflt: colorAttrs.defaultLine,
      editType: 'plot'
    },
    width: {
      valType: 'number',
      min: 0,
      dflt: 0,
      editType: 'plot'
    },
    editType: 'calc'
  },
  thickness: {
    valType: 'number',
    min: 0,
    max: 1,
    dflt: 1,
    editType: 'plot'
  },
  editType: 'calc'
};
var rangeAttr = {
  valType: 'info_array',
  items: [{
    valType: 'number',
    editType: 'plot'
  }, {
    valType: 'number',
    editType: 'plot'
  }],
  editType: 'plot'
};
var stepsAttrs = templatedArray('step', extendDeep({}, gaugeBarAttrs, {
  range: rangeAttr
}));
module.exports = {
  mode: {
    valType: 'flaglist',
    editType: 'calc',
    flags: ['number', 'delta', 'gauge'],
    dflt: 'number'
  },
  value: {
    valType: 'number',
    editType: 'calc',
    anim: true
  },
  align: {
    valType: 'enumerated',
    values: ['left', 'center', 'right'],
    editType: 'plot'
  },
  // position
  domain: domainAttrs({
    name: 'indicator',
    trace: true,
    editType: 'calc'
  }),
  title: {
    text: {
      valType: 'string',
      editType: 'plot'
    },
    align: {
      valType: 'enumerated',
      values: ['left', 'center', 'right'],
      editType: 'plot'
    },
    font: extendFlat({}, textFontAttrs, {}),
    editType: 'plot'
  },
  number: {
    valueformat: {
      valType: 'string',
      dflt: '',
      editType: 'plot',
      description: descriptionOnlyNumbers('value')
    },
    font: extendFlat({}, textFontAttrs, {}),
    prefix: {
      valType: 'string',
      dflt: '',
      editType: 'plot'
    },
    suffix: {
      valType: 'string',
      dflt: '',
      editType: 'plot'
    },
    editType: 'plot'
  },
  delta: {
    reference: {
      valType: 'number',
      editType: 'calc'
    },
    position: {
      valType: 'enumerated',
      values: ['top', 'bottom', 'left', 'right'],
      dflt: 'bottom',
      editType: 'plot'
    },
    relative: {
      valType: 'boolean',
      editType: 'plot',
      dflt: false
    },
    valueformat: {
      valType: 'string',
      editType: 'plot',
      description: descriptionOnlyNumbers('value')
    },
    increasing: {
      symbol: {
        valType: 'string',
        dflt: delta.INCREASING.SYMBOL,
        editType: 'plot'
      },
      color: {
        valType: 'color',
        dflt: delta.INCREASING.COLOR,
        editType: 'plot'
      },
      // TODO: add attribute to show sign
      editType: 'plot'
    },
    decreasing: {
      symbol: {
        valType: 'string',
        dflt: delta.DECREASING.SYMBOL,
        editType: 'plot'
      },
      color: {
        valType: 'color',
        dflt: delta.DECREASING.COLOR,
        editType: 'plot'
      },
      // TODO: add attribute to hide sign
      editType: 'plot'
    },
    font: extendFlat({}, textFontAttrs, {}),
    prefix: {
      valType: 'string',
      dflt: '',
      editType: 'plot'
    },
    suffix: {
      valType: 'string',
      dflt: '',
      editType: 'plot'
    },
    editType: 'calc'
  },
  gauge: {
    shape: {
      valType: 'enumerated',
      editType: 'plot',
      dflt: 'angular',
      values: ['angular', 'bullet']
    },
    bar: extendDeep({}, gaugeBarAttrs, {
      color: {
        dflt: 'green'
      }
    }),
    // Background of the gauge
    bgcolor: {
      valType: 'color',
      editType: 'plot'
    },
    bordercolor: {
      valType: 'color',
      dflt: colorAttrs.defaultLine,
      editType: 'plot'
    },
    borderwidth: {
      valType: 'number',
      min: 0,
      dflt: 1,
      editType: 'plot'
    },
    axis: overrideAll({
      range: rangeAttr,
      visible: extendFlat({}, axesAttrs.visible, {
        dflt: true
      }),
      // tick and title properties named and function exactly as in axes
      tickmode: axesAttrs.minor.tickmode,
      nticks: axesAttrs.nticks,
      tick0: axesAttrs.tick0,
      dtick: axesAttrs.dtick,
      tickvals: axesAttrs.tickvals,
      ticktext: axesAttrs.ticktext,
      ticks: extendFlat({}, axesAttrs.ticks, {
        dflt: 'outside'
      }),
      ticklen: axesAttrs.ticklen,
      tickwidth: axesAttrs.tickwidth,
      tickcolor: axesAttrs.tickcolor,
      ticklabelstep: axesAttrs.ticklabelstep,
      showticklabels: axesAttrs.showticklabels,
      labelalias: axesAttrs.labelalias,
      tickfont: fontAttrs({}),
      tickangle: axesAttrs.tickangle,
      tickformat: axesAttrs.tickformat,
      tickformatstops: axesAttrs.tickformatstops,
      tickprefix: axesAttrs.tickprefix,
      showtickprefix: axesAttrs.showtickprefix,
      ticksuffix: axesAttrs.ticksuffix,
      showticksuffix: axesAttrs.showticksuffix,
      separatethousands: axesAttrs.separatethousands,
      exponentformat: axesAttrs.exponentformat,
      minexponent: axesAttrs.minexponent,
      showexponent: axesAttrs.showexponent,
      editType: 'plot'
    }, 'plot'),
    // Steps (or ranges) and thresholds
    steps: stepsAttrs,
    threshold: {
      line: {
        color: extendFlat({}, gaugeBarAttrs.line.color, {}),
        width: extendFlat({}, gaugeBarAttrs.line.width, {
          dflt: 1
        }),
        editType: 'plot'
      },
      thickness: extendFlat({}, gaugeBarAttrs.thickness, {
        dflt: 0.85
      }),
      value: {
        valType: 'number',
        editType: 'calc',
        dflt: false
      },
      editType: 'plot'
    },
    editType: 'plot'
    // TODO: in future version, add marker: (bar|needle)
  }
};

/***/ }),

/***/ 47751:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var plots = __webpack_require__(44122);
exports.name = 'indicator';
exports.plot = function (gd, traces, transitionOpts, makeOnCompleteCallback) {
  plots.plotBasePlot(exports.name, gd, traces, transitionOpts, makeOnCompleteCallback);
};
exports.clean = function (newFullData, newFullLayout, oldFullData, oldFullLayout) {
  plots.cleanBasePlot(exports.name, newFullData, newFullLayout, oldFullData, oldFullLayout);
};

/***/ }),

/***/ 98385:
/***/ (function(module) {

"use strict";


// var Lib = require('../../lib');
function calc(gd, trace) {
  var cd = [];
  var lastReading = trace.value;
  if (!(typeof trace._lastValue === 'number')) trace._lastValue = trace.value;
  var secondLastReading = trace._lastValue;
  var deltaRef = secondLastReading;
  if (trace._hasDelta && typeof trace.delta.reference === 'number') {
    deltaRef = trace.delta.reference;
  }
  cd[0] = {
    y: lastReading,
    lastY: secondLastReading,
    delta: lastReading - deltaRef,
    relativeDelta: (lastReading - deltaRef) / deltaRef
  };
  return cd;
}
module.exports = {
  calc: calc
};

/***/ }),

/***/ 74807:
/***/ (function(module) {

"use strict";


module.exports = {
  // Defaults for delta
  defaultNumberFontSize: 80,
  bulletNumberDomainSize: 0.25,
  bulletPadding: 0.025,
  innerRadius: 0.75,
  valueThickness: 0.5,
  // thickness of value bars relative to full thickness,
  titlePadding: 5,
  horizontalPadding: 10
};

/***/ }),

/***/ 79306:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var attributes = __webpack_require__(95485);
var handleDomainDefaults = (__webpack_require__(13792)/* .defaults */ .N);
var Template = __webpack_require__(78032);
var handleArrayContainerDefaults = __webpack_require__(59008);
var cn = __webpack_require__(74807);
var handleTickValueDefaults = __webpack_require__(22777);
var handleTickMarkDefaults = __webpack_require__(87433);
var handleTickLabelDefaults = __webpack_require__(12036);
var handlePrefixSuffixDefaults = __webpack_require__(54616);
function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
  function coerce(attr, dflt) {
    return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
  }
  handleDomainDefaults(traceOut, layout, coerce);

  // Mode
  coerce('mode');
  traceOut._hasNumber = traceOut.mode.indexOf('number') !== -1;
  traceOut._hasDelta = traceOut.mode.indexOf('delta') !== -1;
  traceOut._hasGauge = traceOut.mode.indexOf('gauge') !== -1;
  var value = coerce('value');
  traceOut._range = [0, typeof value === 'number' ? 1.5 * value : 1];

  // Number attributes
  var auto = new Array(2);
  var bignumberFontSize;
  if (traceOut._hasNumber) {
    coerce('number.valueformat');
    var numberFontDflt = Lib.extendFlat({}, layout.font);
    numberFontDflt.size = undefined;
    Lib.coerceFont(coerce, 'number.font', numberFontDflt);
    if (traceOut.number.font.size === undefined) {
      traceOut.number.font.size = cn.defaultNumberFontSize;
      auto[0] = true;
    }
    coerce('number.prefix');
    coerce('number.suffix');
    bignumberFontSize = traceOut.number.font.size;
  }

  // delta attributes
  var deltaFontSize;
  if (traceOut._hasDelta) {
    var deltaFontDflt = Lib.extendFlat({}, layout.font);
    deltaFontDflt.size = undefined;
    Lib.coerceFont(coerce, 'delta.font', deltaFontDflt);
    if (traceOut.delta.font.size === undefined) {
      traceOut.delta.font.size = (traceOut._hasNumber ? 0.5 : 1) * (bignumberFontSize || cn.defaultNumberFontSize);
      auto[1] = true;
    }
    coerce('delta.reference', traceOut.value);
    coerce('delta.relative');
    coerce('delta.valueformat', traceOut.delta.relative ? '2%' : '');
    coerce('delta.increasing.symbol');
    coerce('delta.increasing.color');
    coerce('delta.decreasing.symbol');
    coerce('delta.decreasing.color');
    coerce('delta.position');
    coerce('delta.prefix');
    coerce('delta.suffix');
    deltaFontSize = traceOut.delta.font.size;
  }
  traceOut._scaleNumbers = (!traceOut._hasNumber || auto[0]) && (!traceOut._hasDelta || auto[1]) || false;

  // Title attributes
  var titleFontDflt = Lib.extendFlat({}, layout.font);
  titleFontDflt.size = 0.25 * (bignumberFontSize || deltaFontSize || cn.defaultNumberFontSize);
  Lib.coerceFont(coerce, 'title.font', titleFontDflt);
  coerce('title.text');

  // Gauge attributes
  var gaugeIn, gaugeOut, axisIn, axisOut;
  function coerceGauge(attr, dflt) {
    return Lib.coerce(gaugeIn, gaugeOut, attributes.gauge, attr, dflt);
  }
  function coerceGaugeAxis(attr, dflt) {
    return Lib.coerce(axisIn, axisOut, attributes.gauge.axis, attr, dflt);
  }
  if (traceOut._hasGauge) {
    gaugeIn = traceIn.gauge;
    if (!gaugeIn) gaugeIn = {};
    gaugeOut = Template.newContainer(traceOut, 'gauge');
    coerceGauge('shape');
    var isBullet = traceOut._isBullet = traceOut.gauge.shape === 'bullet';
    if (!isBullet) {
      coerce('title.align', 'center');
    }
    var isAngular = traceOut._isAngular = traceOut.gauge.shape === 'angular';
    if (!isAngular) {
      coerce('align', 'center');
    }

    // gauge background
    coerceGauge('bgcolor', layout.paper_bgcolor);
    coerceGauge('borderwidth');
    coerceGauge('bordercolor');

    // gauge bar indicator
    coerceGauge('bar.color');
    coerceGauge('bar.line.color');
    coerceGauge('bar.line.width');
    var defaultBarThickness = cn.valueThickness * (traceOut.gauge.shape === 'bullet' ? 0.5 : 1);
    coerceGauge('bar.thickness', defaultBarThickness);

    // Gauge steps
    handleArrayContainerDefaults(gaugeIn, gaugeOut, {
      name: 'steps',
      handleItemDefaults: stepDefaults
    });

    // Gauge threshold
    coerceGauge('threshold.value');
    coerceGauge('threshold.thickness');
    coerceGauge('threshold.line.width');
    coerceGauge('threshold.line.color');

    // Gauge axis
    axisIn = {};
    if (gaugeIn) axisIn = gaugeIn.axis || {};
    axisOut = Template.newContainer(gaugeOut, 'axis');
    coerceGaugeAxis('visible');
    traceOut._range = coerceGaugeAxis('range', traceOut._range);
    var opts = {
      font: layout.font,
      noAutotickangles: true,
      outerTicks: true,
      noTicklabelshift: true,
      noTicklabelstandoff: true
    };
    handleTickValueDefaults(axisIn, axisOut, coerceGaugeAxis, 'linear');
    handlePrefixSuffixDefaults(axisIn, axisOut, coerceGaugeAxis, 'linear', opts);
    handleTickLabelDefaults(axisIn, axisOut, coerceGaugeAxis, 'linear', opts);
    handleTickMarkDefaults(axisIn, axisOut, coerceGaugeAxis, opts);
  } else {
    coerce('title.align', 'center');
    coerce('align', 'center');
    traceOut._isAngular = traceOut._isBullet = false;
  }

  // disable 1D transforms
  traceOut._length = null;
}
function stepDefaults(stepIn, stepOut) {
  function coerce(attr, dflt) {
    return Lib.coerce(stepIn, stepOut, attributes.gauge.steps, attr, dflt);
  }
  coerce('color');
  coerce('line.color');
  coerce('line.width');
  coerce('range');
  coerce('thickness');
}
module.exports = {
  supplyDefaults: supplyDefaults
};

/***/ }),

/***/ 25638:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = {
  moduleType: 'trace',
  name: 'indicator',
  basePlotModule: __webpack_require__(47751),
  categories: ['svg', 'noOpacity', 'noHover'],
  animatable: true,
  attributes: __webpack_require__(95485),
  supplyDefaults: (__webpack_require__(79306).supplyDefaults),
  calc: (__webpack_require__(98385).calc),
  plot: __webpack_require__(37095),
  meta: {}
};

/***/ }),

/***/ 37095:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var interpolate = (__webpack_require__(88640)/* .interpolate */ .GW);
var interpolateNumber = (__webpack_require__(88640)/* .interpolateNumber */ .Dj);
var Lib = __webpack_require__(34809);
var strScale = Lib.strScale;
var strTranslate = Lib.strTranslate;
var rad2deg = Lib.rad2deg;
var MID_SHIFT = (__webpack_require__(4530).MID_SHIFT);
var Drawing = __webpack_require__(62203);
var cn = __webpack_require__(74807);
var svgTextUtils = __webpack_require__(30635);
var Axes = __webpack_require__(29714);
var handleAxisDefaults = __webpack_require__(97655);
var handleAxisPositionDefaults = __webpack_require__(40957);
var axisLayoutAttrs = __webpack_require__(25829);
var Color = __webpack_require__(78766);
var anchor = {
  left: 'start',
  center: 'middle',
  right: 'end'
};
var position = {
  left: 0,
  center: 0.5,
  right: 1
};
var SI_PREFIX = /[yzafpnµmkMGTPEZY]/;
function hasTransition(transitionOpts) {
  // If transition config is provided, then it is only a partial replot and traces not
  // updated are removed.
  return transitionOpts && transitionOpts.duration > 0;
}
module.exports = function plot(gd, cdModule, transitionOpts, makeOnCompleteCallback) {
  var fullLayout = gd._fullLayout;
  var onComplete;
  if (hasTransition(transitionOpts)) {
    if (makeOnCompleteCallback) {
      // If it was passed a callback to register completion, make a callback. If
      // this is created, then it must be executed on completion, otherwise the
      // pos-transition redraw will not execute:
      onComplete = makeOnCompleteCallback();
    }
  }
  Lib.makeTraceGroups(fullLayout._indicatorlayer, cdModule, 'trace').each(function (cd) {
    var cd0 = cd[0];
    var trace = cd0.trace;
    var plotGroup = d3.select(this);

    // Elements in trace
    var hasGauge = trace._hasGauge;
    var isAngular = trace._isAngular;
    var isBullet = trace._isBullet;

    // Domain size
    var domain = trace.domain;
    var size = {
      w: fullLayout._size.w * (domain.x[1] - domain.x[0]),
      h: fullLayout._size.h * (domain.y[1] - domain.y[0]),
      l: fullLayout._size.l + fullLayout._size.w * domain.x[0],
      r: fullLayout._size.r + fullLayout._size.w * (1 - domain.x[1]),
      t: fullLayout._size.t + fullLayout._size.h * (1 - domain.y[1]),
      b: fullLayout._size.b + fullLayout._size.h * domain.y[0]
    };
    var centerX = size.l + size.w / 2;
    var centerY = size.t + size.h / 2;

    // Angular gauge size
    var radius = Math.min(size.w / 2, size.h); // fill domain
    var innerRadius = cn.innerRadius * radius;

    // Position numbers based on mode and set the scaling logic
    var numbersX, numbersY, numbersScaler;
    var numbersAlign = trace.align || 'center';
    numbersY = centerY;
    if (!hasGauge) {
      numbersX = size.l + position[numbersAlign] * size.w;
      numbersScaler = function (el) {
        return fitTextInsideBox(el, size.w, size.h);
      };
    } else {
      if (isAngular) {
        numbersX = centerX;
        numbersY = centerY + radius / 2;
        numbersScaler = function (el) {
          return fitTextInsideCircle(el, 0.9 * innerRadius);
        };
      }
      if (isBullet) {
        var padding = cn.bulletPadding;
        var p = 1 - cn.bulletNumberDomainSize + padding;
        numbersX = size.l + (p + (1 - p) * position[numbersAlign]) * size.w;
        numbersScaler = function (el) {
          return fitTextInsideBox(el, (cn.bulletNumberDomainSize - padding) * size.w, size.h);
        };
      }
    }

    // Draw numbers
    drawNumbers(gd, plotGroup, cd, {
      numbersX: numbersX,
      numbersY: numbersY,
      numbersScaler: numbersScaler,
      transitionOpts: transitionOpts,
      onComplete: onComplete
    });

    // Reexpress our gauge background attributes for drawing
    var gaugeBg, gaugeOutline;
    if (hasGauge) {
      gaugeBg = {
        range: trace.gauge.axis.range,
        color: trace.gauge.bgcolor,
        line: {
          color: trace.gauge.bordercolor,
          width: 0
        },
        thickness: 1
      };
      gaugeOutline = {
        range: trace.gauge.axis.range,
        color: 'rgba(0, 0, 0, 0)',
        line: {
          color: trace.gauge.bordercolor,
          width: trace.gauge.borderwidth
        },
        thickness: 1
      };
    }

    // Prepare angular gauge layers
    var angularGauge = plotGroup.selectAll('g.angular').data(isAngular ? cd : []);
    angularGauge.exit().remove();
    var angularaxisLayer = plotGroup.selectAll('g.angularaxis').data(isAngular ? cd : []);
    angularaxisLayer.exit().remove();
    if (isAngular) {
      drawAngularGauge(gd, plotGroup, cd, {
        radius: radius,
        innerRadius: innerRadius,
        gauge: angularGauge,
        layer: angularaxisLayer,
        size: size,
        gaugeBg: gaugeBg,
        gaugeOutline: gaugeOutline,
        transitionOpts: transitionOpts,
        onComplete: onComplete
      });
    }

    // Prepare bullet layers
    var bulletGauge = plotGroup.selectAll('g.bullet').data(isBullet ? cd : []);
    bulletGauge.exit().remove();
    var bulletaxisLayer = plotGroup.selectAll('g.bulletaxis').data(isBullet ? cd : []);
    bulletaxisLayer.exit().remove();
    if (isBullet) {
      drawBulletGauge(gd, plotGroup, cd, {
        gauge: bulletGauge,
        layer: bulletaxisLayer,
        size: size,
        gaugeBg: gaugeBg,
        gaugeOutline: gaugeOutline,
        transitionOpts: transitionOpts,
        onComplete: onComplete
      });
    }

    // title
    var title = plotGroup.selectAll('text.title').data(cd);
    title.exit().remove();
    title.enter().append('text').classed('title', true);
    title.attr('text-anchor', function () {
      return isBullet ? anchor.right : anchor[trace.title.align];
    }).text(trace.title.text).call(Drawing.font, trace.title.font).call(svgTextUtils.convertToTspans, gd);

    // Position title
    title.attr('transform', function () {
      var titleX = size.l + size.w * position[trace.title.align];
      var titleY;
      var titlePadding = cn.titlePadding;
      var titlebBox = Drawing.bBox(title.node());
      if (hasGauge) {
        if (isAngular) {
          // position above axis ticks/labels
          if (trace.gauge.axis.visible) {
            var bBox = Drawing.bBox(angularaxisLayer.node());
            titleY = bBox.top - titlePadding - titlebBox.bottom;
          } else {
            titleY = size.t + size.h / 2 - radius / 2 - titlebBox.bottom - titlePadding;
          }
        }
        if (isBullet) {
          // position outside domain
          titleY = numbersY - (titlebBox.top + titlebBox.bottom) / 2;
          titleX = size.l - cn.bulletPadding * size.w; // Outside domain, on the left
        }
      } else {
        // position above numbers
        titleY = trace._numbersTop - titlePadding - titlebBox.bottom;
      }
      return strTranslate(titleX, titleY);
    });
  });
};
function drawBulletGauge(gd, plotGroup, cd, opts) {
  var trace = cd[0].trace;
  var bullet = opts.gauge;
  var axisLayer = opts.layer;
  var gaugeBg = opts.gaugeBg;
  var gaugeOutline = opts.gaugeOutline;
  var size = opts.size;
  var domain = trace.domain;
  var transitionOpts = opts.transitionOpts;
  var onComplete = opts.onComplete;

  // preparing axis
  var ax, vals, transFn, tickSign, shift;

  // Enter bullet, axis
  bullet.enter().append('g').classed('bullet', true);
  bullet.attr('transform', strTranslate(size.l, size.t));
  axisLayer.enter().append('g').classed('bulletaxis', true).classed('crisp', true);
  axisLayer.selectAll('g.' + 'xbulletaxis' + 'tick,path,text').remove();

  // Draw bullet
  var bulletHeight = size.h; // use all vertical domain
  var innerBulletHeight = trace.gauge.bar.thickness * bulletHeight;
  var bulletLeft = domain.x[0];
  var bulletRight = domain.x[0] + (domain.x[1] - domain.x[0]) * (trace._hasNumber || trace._hasDelta ? 1 - cn.bulletNumberDomainSize : 1);
  ax = mockAxis(gd, trace.gauge.axis);
  ax._id = 'xbulletaxis';
  ax.domain = [bulletLeft, bulletRight];
  ax.setScale();
  vals = Axes.calcTicks(ax);
  transFn = Axes.makeTransTickFn(ax);
  tickSign = Axes.getTickSigns(ax)[2];
  shift = size.t + size.h;
  if (ax.visible) {
    Axes.drawTicks(gd, ax, {
      vals: ax.ticks === 'inside' ? Axes.clipEnds(ax, vals) : vals,
      layer: axisLayer,
      path: Axes.makeTickPath(ax, shift, tickSign),
      transFn: transFn
    });
    Axes.drawLabels(gd, ax, {
      vals: vals,
      layer: axisLayer,
      transFn: transFn,
      labelFns: Axes.makeLabelFns(ax, shift)
    });
  }
  function drawRect(s) {
    s.attr('width', function (d) {
      return Math.max(0, ax.c2p(d.range[1]) - ax.c2p(d.range[0]));
    }).attr('x', function (d) {
      return ax.c2p(d.range[0]);
    }).attr('y', function (d) {
      return 0.5 * (1 - d.thickness) * bulletHeight;
    }).attr('height', function (d) {
      return d.thickness * bulletHeight;
    });
  }

  // Draw bullet background, steps
  var boxes = [gaugeBg].concat(trace.gauge.steps);
  var bgBullet = bullet.selectAll('g.bg-bullet').data(boxes);
  bgBullet.enter().append('g').classed('bg-bullet', true).append('rect');
  bgBullet.select('rect').call(drawRect).call(styleShape);
  bgBullet.exit().remove();

  // Draw value bar with transitions
  var fgBullet = bullet.selectAll('g.value-bullet').data([trace.gauge.bar]);
  fgBullet.enter().append('g').classed('value-bullet', true).append('rect');
  fgBullet.select('rect').attr('height', innerBulletHeight).attr('y', (bulletHeight - innerBulletHeight) / 2).call(styleShape);
  if (hasTransition(transitionOpts)) {
    fgBullet.select('rect').transition().duration(transitionOpts.duration).ease(transitionOpts.easing).each('end', function () {
      onComplete && onComplete();
    }).each('interrupt', function () {
      onComplete && onComplete();
    }).attr('width', Math.max(0, ax.c2p(Math.min(trace.gauge.axis.range[1], cd[0].y))));
  } else {
    fgBullet.select('rect').attr('width', typeof cd[0].y === 'number' ? Math.max(0, ax.c2p(Math.min(trace.gauge.axis.range[1], cd[0].y))) : 0);
  }
  fgBullet.exit().remove();
  var data = cd.filter(function () {
    return trace.gauge.threshold.value || trace.gauge.threshold.value === 0;
  });
  var threshold = bullet.selectAll('g.threshold-bullet').data(data);
  threshold.enter().append('g').classed('threshold-bullet', true).append('line');
  threshold.select('line').attr('x1', ax.c2p(trace.gauge.threshold.value)).attr('x2', ax.c2p(trace.gauge.threshold.value)).attr('y1', (1 - trace.gauge.threshold.thickness) / 2 * bulletHeight).attr('y2', (1 - (1 - trace.gauge.threshold.thickness) / 2) * bulletHeight).call(Color.stroke, trace.gauge.threshold.line.color).style('stroke-width', trace.gauge.threshold.line.width);
  threshold.exit().remove();
  var bulletOutline = bullet.selectAll('g.gauge-outline').data([gaugeOutline]);
  bulletOutline.enter().append('g').classed('gauge-outline', true).append('rect');
  bulletOutline.select('rect').call(drawRect).call(styleShape);
  bulletOutline.exit().remove();
}
function drawAngularGauge(gd, plotGroup, cd, opts) {
  var trace = cd[0].trace;
  var size = opts.size;
  var radius = opts.radius;
  var innerRadius = opts.innerRadius;
  var gaugeBg = opts.gaugeBg;
  var gaugeOutline = opts.gaugeOutline;
  var gaugePosition = [size.l + size.w / 2, size.t + size.h / 2 + radius / 2];
  var gauge = opts.gauge;
  var axisLayer = opts.layer;
  var transitionOpts = opts.transitionOpts;
  var onComplete = opts.onComplete;

  // circular gauge
  var theta = Math.PI / 2;
  function valueToAngle(v) {
    var min = trace.gauge.axis.range[0];
    var max = trace.gauge.axis.range[1];
    var angle = (v - min) / (max - min) * Math.PI - theta;
    if (angle < -theta) return -theta;
    if (angle > theta) return theta;
    return angle;
  }
  function arcPathGenerator(size) {
    return d3.svg.arc().innerRadius((innerRadius + radius) / 2 - size / 2 * (radius - innerRadius)).outerRadius((innerRadius + radius) / 2 + size / 2 * (radius - innerRadius)).startAngle(-theta);
  }
  function drawArc(p) {
    p.attr('d', function (d) {
      return arcPathGenerator(d.thickness).startAngle(valueToAngle(d.range[0])).endAngle(valueToAngle(d.range[1]))();
    });
  }

  // preparing axis
  var ax, vals, transFn, tickSign;

  // Enter gauge and axis
  gauge.enter().append('g').classed('angular', true);
  gauge.attr('transform', strTranslate(gaugePosition[0], gaugePosition[1]));
  axisLayer.enter().append('g').classed('angularaxis', true).classed('crisp', true);
  axisLayer.selectAll('g.' + 'xangularaxis' + 'tick,path,text').remove();
  ax = mockAxis(gd, trace.gauge.axis);
  ax.type = 'linear';
  ax.range = trace.gauge.axis.range;
  ax._id = 'xangularaxis'; // or 'y', but I don't think this makes a difference here
  ax.ticklabeloverflow = 'allow';
  ax.setScale();

  // 't'ick to 'g'eometric radians is used all over the place here
  var t2g = function (d) {
    return (ax.range[0] - d.x) / (ax.range[1] - ax.range[0]) * Math.PI + Math.PI;
  };
  var labelFns = {};
  var out = Axes.makeLabelFns(ax, 0);
  var labelStandoff = out.labelStandoff;
  labelFns.xFn = function (d) {
    var rad = t2g(d);
    return Math.cos(rad) * labelStandoff;
  };
  labelFns.yFn = function (d) {
    var rad = t2g(d);
    var ff = Math.sin(rad) > 0 ? 0.2 : 1;
    return -Math.sin(rad) * (labelStandoff + d.fontSize * ff) + Math.abs(Math.cos(rad)) * (d.fontSize * MID_SHIFT);
  };
  labelFns.anchorFn = function (d) {
    var rad = t2g(d);
    var cos = Math.cos(rad);
    return Math.abs(cos) < 0.1 ? 'middle' : cos > 0 ? 'start' : 'end';
  };
  labelFns.heightFn = function (d, a, h) {
    var rad = t2g(d);
    return -0.5 * (1 + Math.sin(rad)) * h;
  };
  var _transFn = function (rad) {
    return strTranslate(gaugePosition[0] + radius * Math.cos(rad), gaugePosition[1] - radius * Math.sin(rad));
  };
  transFn = function (d) {
    return _transFn(t2g(d));
  };
  var transFn2 = function (d) {
    var rad = t2g(d);
    return _transFn(rad) + 'rotate(' + -rad2deg(rad) + ')';
  };
  vals = Axes.calcTicks(ax);
  tickSign = Axes.getTickSigns(ax)[2];
  if (ax.visible) {
    tickSign = ax.ticks === 'inside' ? -1 : 1;
    var pad = (ax.linewidth || 1) / 2;
    Axes.drawTicks(gd, ax, {
      vals: vals,
      layer: axisLayer,
      path: 'M' + tickSign * pad + ',0h' + tickSign * ax.ticklen,
      transFn: transFn2
    });
    Axes.drawLabels(gd, ax, {
      vals: vals,
      layer: axisLayer,
      transFn: transFn,
      labelFns: labelFns
    });
  }

  // Draw background + steps
  var arcs = [gaugeBg].concat(trace.gauge.steps);
  var bgArc = gauge.selectAll('g.bg-arc').data(arcs);
  bgArc.enter().append('g').classed('bg-arc', true).append('path');
  bgArc.select('path').call(drawArc).call(styleShape);
  bgArc.exit().remove();

  // Draw foreground with transition
  var valueArcPathGenerator = arcPathGenerator(trace.gauge.bar.thickness);
  var valueArc = gauge.selectAll('g.value-arc').data([trace.gauge.bar]);
  valueArc.enter().append('g').classed('value-arc', true).append('path');
  var valueArcPath = valueArc.select('path');
  if (hasTransition(transitionOpts)) {
    valueArcPath.transition().duration(transitionOpts.duration).ease(transitionOpts.easing).each('end', function () {
      onComplete && onComplete();
    }).each('interrupt', function () {
      onComplete && onComplete();
    }).attrTween('d', arcTween(valueArcPathGenerator, valueToAngle(cd[0].lastY), valueToAngle(cd[0].y)));
    trace._lastValue = cd[0].y;
  } else {
    valueArcPath.attr('d', typeof cd[0].y === 'number' ? valueArcPathGenerator.endAngle(valueToAngle(cd[0].y)) : 'M0,0Z');
  }
  valueArcPath.call(styleShape);
  valueArc.exit().remove();

  // Draw threshold
  arcs = [];
  var v = trace.gauge.threshold.value;
  if (v || v === 0) {
    arcs.push({
      range: [v, v],
      color: trace.gauge.threshold.color,
      line: {
        color: trace.gauge.threshold.line.color,
        width: trace.gauge.threshold.line.width
      },
      thickness: trace.gauge.threshold.thickness
    });
  }
  var thresholdArc = gauge.selectAll('g.threshold-arc').data(arcs);
  thresholdArc.enter().append('g').classed('threshold-arc', true).append('path');
  thresholdArc.select('path').call(drawArc).call(styleShape);
  thresholdArc.exit().remove();

  // Draw border last
  var gaugeBorder = gauge.selectAll('g.gauge-outline').data([gaugeOutline]);
  gaugeBorder.enter().append('g').classed('gauge-outline', true).append('path');
  gaugeBorder.select('path').call(drawArc).call(styleShape);
  gaugeBorder.exit().remove();
}
function drawNumbers(gd, plotGroup, cd, opts) {
  var trace = cd[0].trace;
  var numbersX = opts.numbersX;
  var numbersY = opts.numbersY;
  var numbersAlign = trace.align || 'center';
  var numbersAnchor = anchor[numbersAlign];
  var transitionOpts = opts.transitionOpts;
  var onComplete = opts.onComplete;
  var numbers = Lib.ensureSingle(plotGroup, 'g', 'numbers');
  var bignumberbBox, deltabBox;
  var numbersbBox;
  var data = [];
  if (trace._hasNumber) data.push('number');
  if (trace._hasDelta) {
    data.push('delta');
    if (trace.delta.position === 'left') data.reverse();
  }
  var sel = numbers.selectAll('text').data(data);
  sel.enter().append('text');
  sel.attr('text-anchor', function () {
    return numbersAnchor;
  }).attr('class', function (d) {
    return d;
  }).attr('x', null).attr('y', null).attr('dx', null).attr('dy', null);
  sel.exit().remove();

  // Function to override the number formatting used during transitions
  function transitionFormat(valueformat, fmt, from, to) {
    // For now, do not display SI prefix if start and end value do not have any
    if (valueformat.match('s') &&
    // If using SI prefix
    from >= 0 !== to >= 0 &&
    // If sign change
    !fmt(from).slice(-1).match(SI_PREFIX) && !fmt(to).slice(-1).match(SI_PREFIX) // Has no SI prefix
    ) {
      var transitionValueFormat = valueformat.slice().replace('s', 'f').replace(/\d+/, function (m) {
        return parseInt(m) - 1;
      });
      var transitionAx = mockAxis(gd, {
        tickformat: transitionValueFormat
      });
      return function (v) {
        // Switch to fixed precision if number is smaller than one
        if (Math.abs(v) < 1) return Axes.tickText(transitionAx, v).text;
        return fmt(v);
      };
    } else {
      return fmt;
    }
  }
  function drawBignumber() {
    var bignumberAx = mockAxis(gd, {
      tickformat: trace.number.valueformat
    }, trace._range);
    bignumberAx.setScale();
    Axes.prepTicks(bignumberAx);
    var bignumberFmt = function (v) {
      return Axes.tickText(bignumberAx, v).text;
    };
    var bignumberSuffix = trace.number.suffix;
    var bignumberPrefix = trace.number.prefix;
    var number = numbers.select('text.number');
    function writeNumber() {
      var txt = typeof cd[0].y === 'number' ? bignumberPrefix + bignumberFmt(cd[0].y) + bignumberSuffix : '-';
      number.text(txt).call(Drawing.font, trace.number.font).call(svgTextUtils.convertToTspans, gd);
    }
    if (hasTransition(transitionOpts)) {
      number.transition().duration(transitionOpts.duration).ease(transitionOpts.easing).each('end', function () {
        writeNumber();
        onComplete && onComplete();
      }).each('interrupt', function () {
        writeNumber();
        onComplete && onComplete();
      }).attrTween('text', function () {
        var that = d3.select(this);
        var interpolator = interpolateNumber(cd[0].lastY, cd[0].y);
        trace._lastValue = cd[0].y;
        var transitionFmt = transitionFormat(trace.number.valueformat, bignumberFmt, cd[0].lastY, cd[0].y);
        return function (t) {
          that.text(bignumberPrefix + transitionFmt(interpolator(t)) + bignumberSuffix);
        };
      });
    } else {
      writeNumber();
    }
    bignumberbBox = measureText(bignumberPrefix + bignumberFmt(cd[0].y) + bignumberSuffix, trace.number.font, numbersAnchor, gd);
    return number;
  }
  function drawDelta() {
    var deltaAx = mockAxis(gd, {
      tickformat: trace.delta.valueformat
    }, trace._range);
    deltaAx.setScale();
    Axes.prepTicks(deltaAx);
    var deltaFmt = function (v) {
      return Axes.tickText(deltaAx, v).text;
    };
    var deltaSuffix = trace.delta.suffix;
    var deltaPrefix = trace.delta.prefix;
    var deltaValue = function (d) {
      var value = trace.delta.relative ? d.relativeDelta : d.delta;
      return value;
    };
    var deltaFormatText = function (value, numberFmt) {
      if (value === 0 || typeof value !== 'number' || isNaN(value)) return '-';
      return (value > 0 ? trace.delta.increasing.symbol : trace.delta.decreasing.symbol) + deltaPrefix + numberFmt(value) + deltaSuffix;
    };
    var deltaFill = function (d) {
      return d.delta >= 0 ? trace.delta.increasing.color : trace.delta.decreasing.color;
    };
    if (trace._deltaLastValue === undefined) {
      trace._deltaLastValue = deltaValue(cd[0]);
    }
    var delta = numbers.select('text.delta');
    delta.call(Drawing.font, trace.delta.font).call(Color.fill, deltaFill({
      delta: trace._deltaLastValue
    }));
    function writeDelta() {
      delta.text(deltaFormatText(deltaValue(cd[0]), deltaFmt)).call(Color.fill, deltaFill(cd[0])).call(svgTextUtils.convertToTspans, gd);
    }
    if (hasTransition(transitionOpts)) {
      delta.transition().duration(transitionOpts.duration).ease(transitionOpts.easing).tween('text', function () {
        var that = d3.select(this);
        var to = deltaValue(cd[0]);
        var from = trace._deltaLastValue;
        var transitionFmt = transitionFormat(trace.delta.valueformat, deltaFmt, from, to);
        var interpolator = interpolateNumber(from, to);
        trace._deltaLastValue = to;
        return function (t) {
          that.text(deltaFormatText(interpolator(t), transitionFmt));
          that.call(Color.fill, deltaFill({
            delta: interpolator(t)
          }));
        };
      }).each('end', function () {
        writeDelta();
        onComplete && onComplete();
      }).each('interrupt', function () {
        writeDelta();
        onComplete && onComplete();
      });
    } else {
      writeDelta();
    }
    deltabBox = measureText(deltaFormatText(deltaValue(cd[0]), deltaFmt), trace.delta.font, numbersAnchor, gd);
    return delta;
  }
  var key = trace.mode + trace.align;
  var delta;
  if (trace._hasDelta) {
    delta = drawDelta();
    key += trace.delta.position + trace.delta.font.size + trace.delta.font.family + trace.delta.valueformat;
    key += trace.delta.increasing.symbol + trace.delta.decreasing.symbol;
    numbersbBox = deltabBox;
  }
  if (trace._hasNumber) {
    drawBignumber();
    key += trace.number.font.size + trace.number.font.family + trace.number.valueformat + trace.number.suffix + trace.number.prefix;
    numbersbBox = bignumberbBox;
  }

  // Position delta relative to bignumber
  if (trace._hasDelta && trace._hasNumber) {
    var bignumberCenter = [(bignumberbBox.left + bignumberbBox.right) / 2, (bignumberbBox.top + bignumberbBox.bottom) / 2];
    var deltaCenter = [(deltabBox.left + deltabBox.right) / 2, (deltabBox.top + deltabBox.bottom) / 2];
    var dx, dy;
    var padding = 0.75 * trace.delta.font.size;
    if (trace.delta.position === 'left') {
      dx = cache(trace, 'deltaPos', 0, -1 * (bignumberbBox.width * position[trace.align] + deltabBox.width * (1 - position[trace.align]) + padding), key, Math.min);
      dy = bignumberCenter[1] - deltaCenter[1];
      numbersbBox = {
        width: bignumberbBox.width + deltabBox.width + padding,
        height: Math.max(bignumberbBox.height, deltabBox.height),
        left: deltabBox.left + dx,
        right: bignumberbBox.right,
        top: Math.min(bignumberbBox.top, deltabBox.top + dy),
        bottom: Math.max(bignumberbBox.bottom, deltabBox.bottom + dy)
      };
    }
    if (trace.delta.position === 'right') {
      dx = cache(trace, 'deltaPos', 0, bignumberbBox.width * (1 - position[trace.align]) + deltabBox.width * position[trace.align] + padding, key, Math.max);
      dy = bignumberCenter[1] - deltaCenter[1];
      numbersbBox = {
        width: bignumberbBox.width + deltabBox.width + padding,
        height: Math.max(bignumberbBox.height, deltabBox.height),
        left: bignumberbBox.left,
        right: deltabBox.right + dx,
        top: Math.min(bignumberbBox.top, deltabBox.top + dy),
        bottom: Math.max(bignumberbBox.bottom, deltabBox.bottom + dy)
      };
    }
    if (trace.delta.position === 'bottom') {
      dx = null;
      dy = deltabBox.height;
      numbersbBox = {
        width: Math.max(bignumberbBox.width, deltabBox.width),
        height: bignumberbBox.height + deltabBox.height,
        left: Math.min(bignumberbBox.left, deltabBox.left),
        right: Math.max(bignumberbBox.right, deltabBox.right),
        top: bignumberbBox.bottom - bignumberbBox.height,
        bottom: bignumberbBox.bottom + deltabBox.height
      };
    }
    if (trace.delta.position === 'top') {
      dx = null;
      dy = bignumberbBox.top;
      numbersbBox = {
        width: Math.max(bignumberbBox.width, deltabBox.width),
        height: bignumberbBox.height + deltabBox.height,
        left: Math.min(bignumberbBox.left, deltabBox.left),
        right: Math.max(bignumberbBox.right, deltabBox.right),
        top: bignumberbBox.bottom - bignumberbBox.height - deltabBox.height,
        bottom: bignumberbBox.bottom
      };
    }
    delta.attr({
      dx: dx,
      dy: dy
    });
  }

  // Resize numbers to fit within space and position
  if (trace._hasNumber || trace._hasDelta) {
    numbers.attr('transform', function () {
      var m = opts.numbersScaler(numbersbBox);
      key += m[2];
      var scaleRatio = cache(trace, 'numbersScale', 1, m[0], key, Math.min);
      var translateY;
      if (!trace._scaleNumbers) scaleRatio = 1;
      if (trace._isAngular) {
        // align vertically to bottom
        translateY = numbersY - scaleRatio * numbersbBox.bottom;
      } else {
        // align vertically to center
        translateY = numbersY - scaleRatio * (numbersbBox.top + numbersbBox.bottom) / 2;
      }

      // Stash the top position of numbersbBox for title positioning
      trace._numbersTop = scaleRatio * numbersbBox.top + translateY;
      var ref = numbersbBox[numbersAlign];
      if (numbersAlign === 'center') ref = (numbersbBox.left + numbersbBox.right) / 2;
      var translateX = numbersX - scaleRatio * ref;

      // Stash translateX
      translateX = cache(trace, 'numbersTranslate', 0, translateX, key, Math.max);
      return strTranslate(translateX, translateY) + strScale(scaleRatio);
    });
  }
}

// Apply fill, stroke, stroke-width to SVG shape
function styleShape(p) {
  p.each(function (d) {
    Color.stroke(d3.select(this), d.line.color);
  }).each(function (d) {
    Color.fill(d3.select(this), d.color);
  }).style('stroke-width', function (d) {
    return d.line.width;
  });
}

// Returns a tween for a transition’s "d" attribute, transitioning any selected
// arcs from their current angle to the specified new angle.
function arcTween(arc, endAngle, newAngle) {
  return function () {
    var interp = interpolate(endAngle, newAngle);
    return function (t) {
      return arc.endAngle(interp(t))();
    };
  };
}

// mocks our axis
function mockAxis(gd, opts, zrange) {
  var fullLayout = gd._fullLayout;
  var axisIn = Lib.extendFlat({
    type: 'linear',
    ticks: 'outside',
    range: zrange,
    showline: true
  }, opts);
  var axisOut = {
    type: 'linear',
    _id: 'x' + opts._id
  };
  var axisOptions = {
    letter: 'x',
    font: fullLayout.font,
    noAutotickangles: true,
    noHover: true,
    noTickson: true
  };
  function coerce(attr, dflt) {
    return Lib.coerce(axisIn, axisOut, axisLayoutAttrs, attr, dflt);
  }
  handleAxisDefaults(axisIn, axisOut, coerce, axisOptions, fullLayout);
  handleAxisPositionDefaults(axisIn, axisOut, coerce, axisOptions);
  return axisOut;
}
function fitTextInsideBox(textBB, width, height) {
  // compute scaling ratio to have text fit within specified width and height
  var ratio = Math.min(width / textBB.width, height / textBB.height);
  return [ratio, textBB, width + 'x' + height];
}
function fitTextInsideCircle(textBB, radius) {
  // compute scaling ratio to have text fit within specified radius
  var elRadius = Math.sqrt(textBB.width / 2 * (textBB.width / 2) + textBB.height * textBB.height);
  var ratio = radius / elRadius;
  return [ratio, textBB, radius];
}
function measureText(txt, font, textAnchor, gd) {
  var element = document.createElementNS('http://www.w3.org/2000/svg', 'text');
  var sel = d3.select(element);
  sel.text(txt).attr('x', 0).attr('y', 0).attr('text-anchor', textAnchor).attr('data-unformatted', txt).call(svgTextUtils.convertToTspans, gd).call(Drawing.font, font);
  return Drawing.bBox(sel.node());
}
function cache(trace, name, initialValue, value, key, fn) {
  var objName = '_cache' + name;
  if (!(trace[objName] && trace[objName].key === key)) {
    trace[objName] = {
      key: key,
      value: initialValue
    };
  }
  var v = Lib.aggNums(fn, null, [trace[objName].value, value], 2);
  trace[objName].value = v;
  return v;
}

/***/ }),

/***/ 70252:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var colorScaleAttrs = __webpack_require__(87163);
var axisHoverFormat = (__webpack_require__(80712).axisHoverFormat);
var hovertemplateAttrs = (__webpack_require__(3208)/* .hovertemplateAttrs */ .rb);
var meshAttrs = __webpack_require__(42450);
var baseAttrs = __webpack_require__(9829);
var extendFlat = (__webpack_require__(93049).extendFlat);
var overrideAll = (__webpack_require__(13582).overrideAll);
function makeSliceAttr(axLetter) {
  return {
    show: {
      valType: 'boolean',
      dflt: false
    },
    locations: {
      valType: 'data_array',
      dflt: []
    },
    fill: {
      valType: 'number',
      min: 0,
      max: 1,
      dflt: 1
    }
  };
}
function makeCapAttr(axLetter) {
  return {
    show: {
      valType: 'boolean',
      dflt: true
    },
    fill: {
      valType: 'number',
      min: 0,
      max: 1,
      dflt: 1
    }
  };
}
var attrs = module.exports = overrideAll(extendFlat({
  x: {
    valType: 'data_array'
  },
  y: {
    valType: 'data_array'
  },
  z: {
    valType: 'data_array'
  },
  value: {
    valType: 'data_array'
  },
  isomin: {
    valType: 'number'
  },
  isomax: {
    valType: 'number'
  },
  surface: {
    show: {
      valType: 'boolean',
      dflt: true
    },
    count: {
      valType: 'integer',
      dflt: 2,
      min: 1
    },
    fill: {
      valType: 'number',
      min: 0,
      max: 1,
      dflt: 1
    },
    pattern: {
      valType: 'flaglist',
      flags: ['A', 'B', 'C', 'D', 'E'],
      extras: ['all', 'odd', 'even'],
      dflt: 'all'
    }
  },
  spaceframe: {
    show: {
      valType: 'boolean',
      dflt: false
    },
    fill: {
      valType: 'number',
      min: 0,
      max: 1,
      dflt: 0.15
    }
  },
  slices: {
    x: makeSliceAttr('x'),
    y: makeSliceAttr('y'),
    z: makeSliceAttr('z')
  },
  caps: {
    x: makeCapAttr('x'),
    y: makeCapAttr('y'),
    z: makeCapAttr('z')
  },
  text: {
    valType: 'string',
    dflt: '',
    arrayOk: true
  },
  hovertext: {
    valType: 'string',
    dflt: '',
    arrayOk: true
  },
  hovertemplate: hovertemplateAttrs(),
  xhoverformat: axisHoverFormat('x'),
  yhoverformat: axisHoverFormat('y'),
  zhoverformat: axisHoverFormat('z'),
  valuehoverformat: axisHoverFormat('value', 1),
  showlegend: extendFlat({}, baseAttrs.showlegend, {
    dflt: false
  })
}, colorScaleAttrs('', {
  colorAttr: '`value`',
  showScaleDflt: true,
  editTypeOverride: 'calc'
}), {
  opacity: meshAttrs.opacity,
  lightposition: meshAttrs.lightposition,
  lighting: meshAttrs.lighting,
  flatshading: meshAttrs.flatshading,
  contour: meshAttrs.contour,
  hoverinfo: extendFlat({}, baseAttrs.hoverinfo)
}), 'calc', 'nested');

// required defaults to speed up surface normal calculations
attrs.flatshading.dflt = true;
attrs.lighting.facenormalsepsilon.dflt = 0;
attrs.x.editType = attrs.y.editType = attrs.z.editType = attrs.value.editType = 'calc+clearAxisTypes';
attrs.transforms = undefined;

/***/ }),

/***/ 58988:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var colorscaleCalc = __webpack_require__(28379);
var processGrid = (__webpack_require__(36402).processGrid);
var filter = (__webpack_require__(36402).filter);
module.exports = function calc(gd, trace) {
  trace._len = Math.min(trace.x.length, trace.y.length, trace.z.length, trace.value.length);
  trace._x = filter(trace.x, trace._len);
  trace._y = filter(trace.y, trace._len);
  trace._z = filter(trace.z, trace._len);
  trace._value = filter(trace.value, trace._len);
  var grid = processGrid(trace);
  trace._gridFill = grid.fill;
  trace._Xs = grid.Xs;
  trace._Ys = grid.Ys;
  trace._Zs = grid.Zs;
  trace._len = grid.len;
  var min = Infinity;
  var max = -Infinity;
  for (var i = 0; i < trace._len; i++) {
    var v = trace._value[i];
    min = Math.min(min, v);
    max = Math.max(max, v);
  }
  trace._minValues = min;
  trace._maxValues = max;
  trace._vMin = trace.isomin === undefined || trace.isomin === null ? min : trace.isomin;
  trace._vMax = trace.isomax === undefined || trace.isomax === null ? max : trace.isomax;
  colorscaleCalc(gd, trace, {
    vals: [trace._vMin, trace._vMax],
    containerStr: '',
    cLetter: 'c'
  });
};

/***/ }),

/***/ 91370:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var createMesh = (__webpack_require__(99098).gl_mesh3d);
var parseColorScale = (__webpack_require__(46998).parseColorScale);
var isArrayOrTypedArray = (__webpack_require__(34809).isArrayOrTypedArray);
var str2RgbaArray = __webpack_require__(55010);
var extractOpts = (__webpack_require__(88856).extractOpts);
var zip3 = __webpack_require__(88239);
var findNearestOnAxis = function (w, arr) {
  for (var q = arr.length - 1; q > 0; q--) {
    var min = Math.min(arr[q], arr[q - 1]);
    var max = Math.max(arr[q], arr[q - 1]);
    if (max > min && min < w && w <= max) {
      return {
        id: q,
        distRatio: (max - w) / (max - min)
      };
    }
  }
  return {
    id: 0,
    distRatio: 0
  };
};
function IsosurfaceTrace(scene, mesh, uid) {
  this.scene = scene;
  this.uid = uid;
  this.mesh = mesh;
  this.name = '';
  this.data = null;
  this.showContour = false;
}
var proto = IsosurfaceTrace.prototype;
proto.handlePick = function (selection) {
  if (selection.object === this.mesh) {
    var rawId = selection.data.index;
    var x = this.data._meshX[rawId];
    var y = this.data._meshY[rawId];
    var z = this.data._meshZ[rawId];
    var height = this.data._Ys.length;
    var depth = this.data._Zs.length;
    var i = findNearestOnAxis(x, this.data._Xs).id;
    var j = findNearestOnAxis(y, this.data._Ys).id;
    var k = findNearestOnAxis(z, this.data._Zs).id;
    var selectIndex = selection.index = k + depth * j + depth * height * i;
    selection.traceCoordinate = [this.data._meshX[selectIndex], this.data._meshY[selectIndex], this.data._meshZ[selectIndex], this.data._value[selectIndex]];
    var text = this.data.hovertext || this.data.text;
    if (isArrayOrTypedArray(text) && text[selectIndex] !== undefined) {
      selection.textLabel = text[selectIndex];
    } else if (text) {
      selection.textLabel = text;
    }
    return true;
  }
};
proto.update = function (data) {
  var scene = this.scene;
  var layout = scene.fullSceneLayout;
  this.data = generateIsoMeshes(data);

  // Unpack position data
  function toDataCoords(axis, coord, scale, calendar) {
    return coord.map(function (x) {
      return axis.d2l(x, 0, calendar) * scale;
    });
  }
  var positions = zip3(toDataCoords(layout.xaxis, data._meshX, scene.dataScale[0], data.xcalendar), toDataCoords(layout.yaxis, data._meshY, scene.dataScale[1], data.ycalendar), toDataCoords(layout.zaxis, data._meshZ, scene.dataScale[2], data.zcalendar));
  var cells = zip3(data._meshI, data._meshJ, data._meshK);
  var config = {
    positions: positions,
    cells: cells,
    lightPosition: [data.lightposition.x, data.lightposition.y, data.lightposition.z],
    ambient: data.lighting.ambient,
    diffuse: data.lighting.diffuse,
    specular: data.lighting.specular,
    roughness: data.lighting.roughness,
    fresnel: data.lighting.fresnel,
    vertexNormalsEpsilon: data.lighting.vertexnormalsepsilon,
    faceNormalsEpsilon: data.lighting.facenormalsepsilon,
    opacity: data.opacity,
    contourEnable: data.contour.show,
    contourColor: str2RgbaArray(data.contour.color).slice(0, 3),
    contourWidth: data.contour.width,
    useFacetNormals: data.flatshading
  };
  var cOpts = extractOpts(data);
  config.vertexIntensity = data._meshIntensity;
  config.vertexIntensityBounds = [cOpts.min, cOpts.max];
  config.colormap = parseColorScale(data);

  // Update mesh
  this.mesh.update(config);
};
proto.dispose = function () {
  this.scene.glplot.remove(this.mesh);
  this.mesh.dispose();
};
var GRID_TYPES = ['xyz', 'xzy', 'yxz', 'yzx', 'zxy', 'zyx'];
function generateIsoMeshes(data) {
  data._meshI = [];
  data._meshJ = [];
  data._meshK = [];
  var showSurface = data.surface.show;
  var showSpaceframe = data.spaceframe.show;
  var surfaceFill = data.surface.fill;
  var spaceframeFill = data.spaceframe.fill;
  var drawingSurface = false;
  var drawingSpaceframe = false;
  var numFaces = 0;
  var numVertices;
  var beginVertextLength;
  var Xs = data._Xs;
  var Ys = data._Ys;
  var Zs = data._Zs;
  var width = Xs.length;
  var height = Ys.length;
  var depth = Zs.length;
  var filled = GRID_TYPES.indexOf(data._gridFill.replace(/-/g, '').replace(/\+/g, ''));
  var getIndex = function (i, j, k) {
    switch (filled) {
      case 5:
        // 'zyx'
        return k + depth * j + depth * height * i;
      case 4:
        // 'zxy'
        return k + depth * i + depth * width * j;
      case 3:
        // 'yzx'
        return j + height * k + height * depth * i;
      case 2:
        // 'yxz'
        return j + height * i + height * width * k;
      case 1:
        // 'xzy'
        return i + width * k + width * depth * j;
      default:
        // case 0: // 'xyz'
        return i + width * j + width * height * k;
    }
  };
  var minValues = data._minValues;
  var maxValues = data._maxValues;
  var vMin = data._vMin;
  var vMax = data._vMax;
  var allXs;
  var allYs;
  var allZs;
  var allVs;
  function findVertexId(x, y, z) {
    // could be used to find the vertex id of previously generated vertex within the group

    var len = allVs.length;
    for (var f = beginVertextLength; f < len; f++) {
      if (x === allXs[f] && y === allYs[f] && z === allZs[f]) {
        return f;
      }
    }
    return -1;
  }
  function beginGroup() {
    beginVertextLength = numVertices;
  }
  function emptyVertices() {
    allXs = [];
    allYs = [];
    allZs = [];
    allVs = [];
    numVertices = 0;
    beginGroup();
  }
  function addVertex(x, y, z, v) {
    allXs.push(x);
    allYs.push(y);
    allZs.push(z);
    allVs.push(v);
    numVertices++;
    return numVertices - 1;
  }
  function addFace(a, b, c) {
    data._meshI.push(a);
    data._meshJ.push(b);
    data._meshK.push(c);
    numFaces++;
    return numFaces - 1;
  }
  function getCenter(A, B, C) {
    var M = [];
    for (var i = 0; i < A.length; i++) {
      M[i] = (A[i] + B[i] + C[i]) / 3.0;
    }
    return M;
  }
  function getBetween(A, B, r) {
    var M = [];
    for (var i = 0; i < A.length; i++) {
      M[i] = A[i] * (1 - r) + r * B[i];
    }
    return M;
  }
  var activeFill;
  function setFill(fill) {
    activeFill = fill;
  }
  function createOpenTri(xyzv, abc) {
    var A = xyzv[0];
    var B = xyzv[1];
    var C = xyzv[2];
    var G = getCenter(A, B, C);
    var r = Math.sqrt(1 - activeFill);
    var p1 = getBetween(G, A, r);
    var p2 = getBetween(G, B, r);
    var p3 = getBetween(G, C, r);
    var a = abc[0];
    var b = abc[1];
    var c = abc[2];
    return {
      xyzv: [[A, B, p2], [p2, p1, A], [B, C, p3], [p3, p2, B], [C, A, p1], [p1, p3, C]],
      abc: [[a, b, -1], [-1, -1, a], [b, c, -1], [-1, -1, b], [c, a, -1], [-1, -1, c]]
    };
  }
  function styleIncludes(style, char) {
    if (style === 'all' || style === null) return true;
    return style.indexOf(char) > -1;
  }
  function mapValue(style, value) {
    if (style === null) return value;
    return style;
  }
  function drawTri(style, xyzv, abc) {
    beginGroup();
    var allXYZVs = [xyzv];
    var allABCs = [abc];
    if (activeFill >= 1) {
      allXYZVs = [xyzv];
      allABCs = [abc];
    } else if (activeFill > 0) {
      var openTri = createOpenTri(xyzv, abc);
      allXYZVs = openTri.xyzv;
      allABCs = openTri.abc;
    }
    for (var f = 0; f < allXYZVs.length; f++) {
      xyzv = allXYZVs[f];
      abc = allABCs[f];
      var pnts = [];
      for (var i = 0; i < 3; i++) {
        var x = xyzv[i][0];
        var y = xyzv[i][1];
        var z = xyzv[i][2];
        var v = xyzv[i][3];
        var id = abc[i] > -1 ? abc[i] : findVertexId(x, y, z);
        if (id > -1) {
          pnts[i] = id;
        } else {
          pnts[i] = addVertex(x, y, z, mapValue(style, v));
        }
      }
      addFace(pnts[0], pnts[1], pnts[2]);
    }
  }
  function drawQuad(style, xyzv, abcd) {
    var makeTri = function (i, j, k) {
      drawTri(style, [xyzv[i], xyzv[j], xyzv[k]], [abcd[i], abcd[j], abcd[k]]);
    };
    makeTri(0, 1, 2);
    makeTri(2, 3, 0);
  }
  function drawTetra(style, xyzv, abcd) {
    var makeTri = function (i, j, k) {
      drawTri(style, [xyzv[i], xyzv[j], xyzv[k]], [abcd[i], abcd[j], abcd[k]]);
    };
    makeTri(0, 1, 2);
    makeTri(3, 0, 1);
    makeTri(2, 3, 0);
    makeTri(1, 2, 3);
  }
  function calcIntersection(pointOut, pointIn, min, max) {
    var value = pointOut[3];
    if (value < min) value = min;
    if (value > max) value = max;
    var ratio = (pointOut[3] - value) / (pointOut[3] - pointIn[3] + 0.000000001); // we had to add this error to force solve the tiny caps

    var result = [];
    for (var s = 0; s < 4; s++) {
      result[s] = (1 - ratio) * pointOut[s] + ratio * pointIn[s];
    }
    return result;
  }
  function inRange(value, min, max) {
    return value >= min && value <= max;
  }
  function almostInFinalRange(value) {
    var vErr = 0.001 * (vMax - vMin);
    return value >= vMin - vErr && value <= vMax + vErr;
  }
  function getXYZV(indecies) {
    var xyzv = [];
    for (var q = 0; q < 4; q++) {
      var index = indecies[q];
      xyzv.push([data._x[index], data._y[index], data._z[index], data._value[index]]);
    }
    return xyzv;
  }
  var MAX_PASS = 3;
  function tryCreateTri(style, xyzv, abc, min, max, nPass) {
    if (!nPass) nPass = 1;
    abc = [-1, -1, -1]; // Note: for the moment we override indices
    // to run faster! But it is possible to comment this line
    // to reduce the number of vertices.

    var result = false;
    var ok = [inRange(xyzv[0][3], min, max), inRange(xyzv[1][3], min, max), inRange(xyzv[2][3], min, max)];
    if (!ok[0] && !ok[1] && !ok[2]) {
      return false;
    }
    var tryDrawTri = function (style, xyzv, abc) {
      if (
      // we check here if the points are in `real` iso-min/max range
      almostInFinalRange(xyzv[0][3]) && almostInFinalRange(xyzv[1][3]) && almostInFinalRange(xyzv[2][3])) {
        drawTri(style, xyzv, abc);
        return true;
      } else if (nPass < MAX_PASS) {
        return tryCreateTri(style, xyzv, abc, vMin, vMax, ++nPass); // i.e. second pass using actual vMin vMax bounds
      }
      return false;
    };
    if (ok[0] && ok[1] && ok[2]) {
      return tryDrawTri(style, xyzv, abc) || result;
    }
    var interpolated = false;
    [[0, 1, 2], [2, 0, 1], [1, 2, 0]].forEach(function (e) {
      if (ok[e[0]] && ok[e[1]] && !ok[e[2]]) {
        var A = xyzv[e[0]];
        var B = xyzv[e[1]];
        var C = xyzv[e[2]];
        var p1 = calcIntersection(C, A, min, max);
        var p2 = calcIntersection(C, B, min, max);
        result = tryDrawTri(style, [p2, p1, A], [-1, -1, abc[e[0]]]) || result;
        result = tryDrawTri(style, [A, B, p2], [abc[e[0]], abc[e[1]], -1]) || result;
        interpolated = true;
      }
    });
    if (interpolated) return result;
    [[0, 1, 2], [1, 2, 0], [2, 0, 1]].forEach(function (e) {
      if (ok[e[0]] && !ok[e[1]] && !ok[e[2]]) {
        var A = xyzv[e[0]];
        var B = xyzv[e[1]];
        var C = xyzv[e[2]];
        var p1 = calcIntersection(B, A, min, max);
        var p2 = calcIntersection(C, A, min, max);
        result = tryDrawTri(style, [p2, p1, A], [-1, -1, abc[e[0]]]) || result;
        interpolated = true;
      }
    });
    return result;
  }
  function tryCreateTetra(style, abcd, min, max) {
    var result = false;
    var xyzv = getXYZV(abcd);
    var ok = [inRange(xyzv[0][3], min, max), inRange(xyzv[1][3], min, max), inRange(xyzv[2][3], min, max), inRange(xyzv[3][3], min, max)];
    if (!ok[0] && !ok[1] && !ok[2] && !ok[3]) {
      return result;
    }
    if (ok[0] && ok[1] && ok[2] && ok[3]) {
      if (drawingSpaceframe) {
        result = drawTetra(style, xyzv, abcd) || result;
      }
      return result;
    }
    var interpolated = false;
    [[0, 1, 2, 3], [3, 0, 1, 2], [2, 3, 0, 1], [1, 2, 3, 0]].forEach(function (e) {
      if (ok[e[0]] && ok[e[1]] && ok[e[2]] && !ok[e[3]]) {
        var A = xyzv[e[0]];
        var B = xyzv[e[1]];
        var C = xyzv[e[2]];
        var D = xyzv[e[3]];
        if (drawingSpaceframe) {
          result = drawTri(style, [A, B, C], [abcd[e[0]], abcd[e[1]], abcd[e[2]]]) || result;
        } else {
          var p1 = calcIntersection(D, A, min, max);
          var p2 = calcIntersection(D, B, min, max);
          var p3 = calcIntersection(D, C, min, max);
          result = drawTri(null, [p1, p2, p3], [-1, -1, -1]) || result;
        }
        interpolated = true;
      }
    });
    if (interpolated) return result;
    [[0, 1, 2, 3], [1, 2, 3, 0], [2, 3, 0, 1], [3, 0, 1, 2], [0, 2, 3, 1], [1, 3, 2, 0]].forEach(function (e) {
      if (ok[e[0]] && ok[e[1]] && !ok[e[2]] && !ok[e[3]]) {
        var A = xyzv[e[0]];
        var B = xyzv[e[1]];
        var C = xyzv[e[2]];
        var D = xyzv[e[3]];
        var p1 = calcIntersection(C, A, min, max);
        var p2 = calcIntersection(C, B, min, max);
        var p3 = calcIntersection(D, B, min, max);
        var p4 = calcIntersection(D, A, min, max);
        if (drawingSpaceframe) {
          result = drawTri(style, [A, p4, p1], [abcd[e[0]], -1, -1]) || result;
          result = drawTri(style, [B, p2, p3], [abcd[e[1]], -1, -1]) || result;
        } else {
          result = drawQuad(null, [p1, p2, p3, p4], [-1, -1, -1, -1]) || result;
        }
        interpolated = true;
      }
    });
    if (interpolated) return result;
    [[0, 1, 2, 3], [1, 2, 3, 0], [2, 3, 0, 1], [3, 0, 1, 2]].forEach(function (e) {
      if (ok[e[0]] && !ok[e[1]] && !ok[e[2]] && !ok[e[3]]) {
        var A = xyzv[e[0]];
        var B = xyzv[e[1]];
        var C = xyzv[e[2]];
        var D = xyzv[e[3]];
        var p1 = calcIntersection(B, A, min, max);
        var p2 = calcIntersection(C, A, min, max);
        var p3 = calcIntersection(D, A, min, max);
        if (drawingSpaceframe) {
          result = drawTri(style, [A, p1, p2], [abcd[e[0]], -1, -1]) || result;
          result = drawTri(style, [A, p2, p3], [abcd[e[0]], -1, -1]) || result;
          result = drawTri(style, [A, p3, p1], [abcd[e[0]], -1, -1]) || result;
        } else {
          result = drawTri(null, [p1, p2, p3], [-1, -1, -1]) || result;
        }
        interpolated = true;
      }
    });
    return result;
  }
  function addCube(style, p000, p001, p010, p011, p100, p101, p110, p111, min, max) {
    var result = false;
    if (drawingSurface) {
      if (styleIncludes(style, 'A')) {
        result = tryCreateTetra(null, [p000, p001, p010, p100], min, max) || result;
      }
      if (styleIncludes(style, 'B')) {
        result = tryCreateTetra(null, [p001, p010, p011, p111], min, max) || result;
      }
      if (styleIncludes(style, 'C')) {
        result = tryCreateTetra(null, [p001, p100, p101, p111], min, max) || result;
      }
      if (styleIncludes(style, 'D')) {
        result = tryCreateTetra(null, [p010, p100, p110, p111], min, max) || result;
      }
      if (styleIncludes(style, 'E')) {
        result = tryCreateTetra(null, [p001, p010, p100, p111], min, max) || result;
      }
    }
    if (drawingSpaceframe) {
      result = tryCreateTetra(style, [p001, p010, p100, p111], min, max) || result;
    }
    return result;
  }
  function addRect(style, a, b, c, d, min, max, previousResult) {
    return [previousResult[0] === true ? true : tryCreateTri(style, getXYZV([a, b, c]), [a, b, c], min, max), previousResult[1] === true ? true : tryCreateTri(style, getXYZV([c, d, a]), [c, d, a], min, max)];
  }
  function begin2dCell(style, p00, p01, p10, p11, min, max, isEven, previousResult) {
    // used to create caps and/or slices on exact axis points
    if (isEven) {
      return addRect(style, p00, p01, p11, p10, min, max, previousResult);
    } else {
      return addRect(style, p01, p11, p10, p00, min, max, previousResult);
    }
  }
  function beginSection(style, i, j, k, min, max, distRatios) {
    // used to create slices between axis points

    var result = false;
    var A, B, C, D;
    var makeSection = function () {
      result = tryCreateTri(style, [A, B, C], [-1, -1, -1], min, max) || result;
      result = tryCreateTri(style, [C, D, A], [-1, -1, -1], min, max) || result;
    };
    var rX = distRatios[0];
    var rY = distRatios[1];
    var rZ = distRatios[2];
    if (rX) {
      A = getBetween(getXYZV([getIndex(i, j - 0, k - 0)])[0], getXYZV([getIndex(i - 1, j - 0, k - 0)])[0], rX);
      B = getBetween(getXYZV([getIndex(i, j - 0, k - 1)])[0], getXYZV([getIndex(i - 1, j - 0, k - 1)])[0], rX);
      C = getBetween(getXYZV([getIndex(i, j - 1, k - 1)])[0], getXYZV([getIndex(i - 1, j - 1, k - 1)])[0], rX);
      D = getBetween(getXYZV([getIndex(i, j - 1, k - 0)])[0], getXYZV([getIndex(i - 1, j - 1, k - 0)])[0], rX);
      makeSection();
    }
    if (rY) {
      A = getBetween(getXYZV([getIndex(i - 0, j, k - 0)])[0], getXYZV([getIndex(i - 0, j - 1, k - 0)])[0], rY);
      B = getBetween(getXYZV([getIndex(i - 0, j, k - 1)])[0], getXYZV([getIndex(i - 0, j - 1, k - 1)])[0], rY);
      C = getBetween(getXYZV([getIndex(i - 1, j, k - 1)])[0], getXYZV([getIndex(i - 1, j - 1, k - 1)])[0], rY);
      D = getBetween(getXYZV([getIndex(i - 1, j, k - 0)])[0], getXYZV([getIndex(i - 1, j - 1, k - 0)])[0], rY);
      makeSection();
    }
    if (rZ) {
      A = getBetween(getXYZV([getIndex(i - 0, j - 0, k)])[0], getXYZV([getIndex(i - 0, j - 0, k - 1)])[0], rZ);
      B = getBetween(getXYZV([getIndex(i - 0, j - 1, k)])[0], getXYZV([getIndex(i - 0, j - 1, k - 1)])[0], rZ);
      C = getBetween(getXYZV([getIndex(i - 1, j - 1, k)])[0], getXYZV([getIndex(i - 1, j - 1, k - 1)])[0], rZ);
      D = getBetween(getXYZV([getIndex(i - 1, j - 0, k)])[0], getXYZV([getIndex(i - 1, j - 0, k - 1)])[0], rZ);
      makeSection();
    }
    return result;
  }
  function begin3dCell(style, p000, p001, p010, p011, p100, p101, p110, p111, min, max, isEven) {
    // used to create spaceframe and/or iso-surfaces

    var cellStyle = style;
    if (isEven) {
      if (drawingSurface && style === 'even') cellStyle = null;
      return addCube(cellStyle, p000, p001, p010, p011, p100, p101, p110, p111, min, max);
    } else {
      if (drawingSurface && style === 'odd') cellStyle = null;
      return addCube(cellStyle, p111, p110, p101, p100, p011, p010, p001, p000, min, max);
    }
  }
  function draw2dX(style, items, min, max, previousResult) {
    var result = [];
    var n = 0;
    for (var q = 0; q < items.length; q++) {
      var i = items[q];
      for (var k = 1; k < depth; k++) {
        for (var j = 1; j < height; j++) {
          result.push(begin2dCell(style, getIndex(i, j - 1, k - 1), getIndex(i, j - 1, k), getIndex(i, j, k - 1), getIndex(i, j, k), min, max, (i + j + k) % 2, previousResult && previousResult[n] ? previousResult[n] : []));
          n++;
        }
      }
    }
    return result;
  }
  function draw2dY(style, items, min, max, previousResult) {
    var result = [];
    var n = 0;
    for (var q = 0; q < items.length; q++) {
      var j = items[q];
      for (var i = 1; i < width; i++) {
        for (var k = 1; k < depth; k++) {
          result.push(begin2dCell(style, getIndex(i - 1, j, k - 1), getIndex(i, j, k - 1), getIndex(i - 1, j, k), getIndex(i, j, k), min, max, (i + j + k) % 2, previousResult && previousResult[n] ? previousResult[n] : []));
          n++;
        }
      }
    }
    return result;
  }
  function draw2dZ(style, items, min, max, previousResult) {
    var result = [];
    var n = 0;
    for (var q = 0; q < items.length; q++) {
      var k = items[q];
      for (var j = 1; j < height; j++) {
        for (var i = 1; i < width; i++) {
          result.push(begin2dCell(style, getIndex(i - 1, j - 1, k), getIndex(i - 1, j, k), getIndex(i, j - 1, k), getIndex(i, j, k), min, max, (i + j + k) % 2, previousResult && previousResult[n] ? previousResult[n] : []));
          n++;
        }
      }
    }
    return result;
  }
  function draw3d(style, min, max) {
    for (var k = 1; k < depth; k++) {
      for (var j = 1; j < height; j++) {
        for (var i = 1; i < width; i++) {
          begin3dCell(style, getIndex(i - 1, j - 1, k - 1), getIndex(i - 1, j - 1, k), getIndex(i - 1, j, k - 1), getIndex(i - 1, j, k), getIndex(i, j - 1, k - 1), getIndex(i, j - 1, k), getIndex(i, j, k - 1), getIndex(i, j, k), min, max, (i + j + k) % 2);
        }
      }
    }
  }
  function drawSpaceframe(style, min, max) {
    drawingSpaceframe = true;
    draw3d(style, min, max);
    drawingSpaceframe = false;
  }
  function drawSurface(style, min, max) {
    drawingSurface = true;
    draw3d(style, min, max);
    drawingSurface = false;
  }
  function drawSectionX(style, items, min, max, distRatios, previousResult) {
    var result = [];
    var n = 0;
    for (var q = 0; q < items.length; q++) {
      var i = items[q];
      for (var k = 1; k < depth; k++) {
        for (var j = 1; j < height; j++) {
          result.push(beginSection(style, i, j, k, min, max, distRatios[q], previousResult && previousResult[n] ? previousResult[n] : []));
          n++;
        }
      }
    }
    return result;
  }
  function drawSectionY(style, items, min, max, distRatios, previousResult) {
    var result = [];
    var n = 0;
    for (var q = 0; q < items.length; q++) {
      var j = items[q];
      for (var i = 1; i < width; i++) {
        for (var k = 1; k < depth; k++) {
          result.push(beginSection(style, i, j, k, min, max, distRatios[q], previousResult && previousResult[n] ? previousResult[n] : []));
          n++;
        }
      }
    }
    return result;
  }
  function drawSectionZ(style, items, min, max, distRatios, previousResult) {
    var result = [];
    var n = 0;
    for (var q = 0; q < items.length; q++) {
      var k = items[q];
      for (var j = 1; j < height; j++) {
        for (var i = 1; i < width; i++) {
          result.push(beginSection(style, i, j, k, min, max, distRatios[q], previousResult && previousResult[n] ? previousResult[n] : []));
          n++;
        }
      }
    }
    return result;
  }
  function createRange(a, b) {
    var range = [];
    for (var q = a; q < b; q++) {
      range.push(q);
    }
    return range;
  }
  function insertGridPoints() {
    for (var i = 0; i < width; i++) {
      for (var j = 0; j < height; j++) {
        for (var k = 0; k < depth; k++) {
          var index = getIndex(i, j, k);
          addVertex(data._x[index], data._y[index], data._z[index], data._value[index]);
        }
      }
    }
  }
  function drawAll() {
    emptyVertices();

    // insert grid points
    insertGridPoints();
    var activeStyle = null;

    // draw spaceframes
    if (showSpaceframe && spaceframeFill) {
      setFill(spaceframeFill);
      drawSpaceframe(activeStyle, vMin, vMax);
    }

    // draw iso-surfaces
    if (showSurface && surfaceFill) {
      setFill(surfaceFill);
      var surfacePattern = data.surface.pattern;
      var surfaceCount = data.surface.count;
      for (var q = 0; q < surfaceCount; q++) {
        var ratio = surfaceCount === 1 ? 0.5 : q / (surfaceCount - 1);
        var level = (1 - ratio) * vMin + ratio * vMax;
        var d1 = Math.abs(level - minValues);
        var d2 = Math.abs(level - maxValues);
        var ranges = d1 > d2 ? [minValues, level] : [level, maxValues];
        drawSurface(surfacePattern, ranges[0], ranges[1]);
      }
    }
    var setupMinMax = [[Math.min(vMin, maxValues), Math.max(vMin, maxValues)], [Math.min(minValues, vMax), Math.max(minValues, vMax)]];
    ['x', 'y', 'z'].forEach(function (e) {
      var preRes = [];
      for (var s = 0; s < setupMinMax.length; s++) {
        var count = 0;
        var activeMin = setupMinMax[s][0];
        var activeMax = setupMinMax[s][1];

        // draw slices
        var slice = data.slices[e];
        if (slice.show && slice.fill) {
          setFill(slice.fill);
          var exactIndices = [];
          var ceilIndices = [];
          var distRatios = [];
          if (slice.locations.length) {
            for (var q = 0; q < slice.locations.length; q++) {
              var near = findNearestOnAxis(slice.locations[q], e === 'x' ? Xs : e === 'y' ? Ys : Zs);
              if (near.distRatio === 0) {
                exactIndices.push(near.id);
              } else if (near.id > 0) {
                ceilIndices.push(near.id);
                if (e === 'x') {
                  distRatios.push([near.distRatio, 0, 0]);
                } else if (e === 'y') {
                  distRatios.push([0, near.distRatio, 0]);
                } else {
                  distRatios.push([0, 0, near.distRatio]);
                }
              }
            }
          } else {
            if (e === 'x') {
              exactIndices = createRange(1, width - 1);
            } else if (e === 'y') {
              exactIndices = createRange(1, height - 1);
            } else {
              exactIndices = createRange(1, depth - 1);
            }
          }
          if (ceilIndices.length > 0) {
            if (e === 'x') {
              preRes[count] = drawSectionX(activeStyle, ceilIndices, activeMin, activeMax, distRatios, preRes[count]);
            } else if (e === 'y') {
              preRes[count] = drawSectionY(activeStyle, ceilIndices, activeMin, activeMax, distRatios, preRes[count]);
            } else {
              preRes[count] = drawSectionZ(activeStyle, ceilIndices, activeMin, activeMax, distRatios, preRes[count]);
            }
            count++;
          }
          if (exactIndices.length > 0) {
            if (e === 'x') {
              preRes[count] = draw2dX(activeStyle, exactIndices, activeMin, activeMax, preRes[count]);
            } else if (e === 'y') {
              preRes[count] = draw2dY(activeStyle, exactIndices, activeMin, activeMax, preRes[count]);
            } else {
              preRes[count] = draw2dZ(activeStyle, exactIndices, activeMin, activeMax, preRes[count]);
            }
            count++;
          }
        }

        // draw caps
        var cap = data.caps[e];
        if (cap.show && cap.fill) {
          setFill(cap.fill);
          if (e === 'x') {
            preRes[count] = draw2dX(activeStyle, [0, width - 1], activeMin, activeMax, preRes[count]);
          } else if (e === 'y') {
            preRes[count] = draw2dY(activeStyle, [0, height - 1], activeMin, activeMax, preRes[count]);
          } else {
            preRes[count] = draw2dZ(activeStyle, [0, depth - 1], activeMin, activeMax, preRes[count]);
          }
          count++;
        }
      }
    });

    // remove vertices arrays (i.e. grid points) in case no face was created.
    if (numFaces === 0) {
      emptyVertices();
    }
    data._meshX = allXs;
    data._meshY = allYs;
    data._meshZ = allZs;
    data._meshIntensity = allVs;
    data._Xs = Xs;
    data._Ys = Ys;
    data._Zs = Zs;
  }
  drawAll();
  return data;
}
function createIsosurfaceTrace(scene, data) {
  var gl = scene.glplot.gl;
  var mesh = createMesh({
    gl: gl
  });
  var result = new IsosurfaceTrace(scene, mesh, data.uid);
  mesh._trace = result;
  result.update(data);
  scene.glplot.add(mesh);
  return result;
}
module.exports = {
  findNearestOnAxis: findNearestOnAxis,
  generateIsoMeshes: generateIsoMeshes,
  createIsosurfaceTrace: createIsosurfaceTrace
};

/***/ }),

/***/ 44731:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var Registry = __webpack_require__(33626);
var attributes = __webpack_require__(70252);
var colorscaleDefaults = __webpack_require__(39356);
function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
  function coerce(attr, dflt) {
    return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
  }
  supplyIsoDefaults(traceIn, traceOut, defaultColor, layout, coerce);
}
function supplyIsoDefaults(traceIn, traceOut, defaultColor, layout, coerce) {
  var isomin = coerce('isomin');
  var isomax = coerce('isomax');
  if (isomax !== undefined && isomax !== null && isomin !== undefined && isomin !== null && isomin > isomax) {
    // applying default values in this case:
    traceOut.isomin = null;
    traceOut.isomax = null;
  }
  var x = coerce('x');
  var y = coerce('y');
  var z = coerce('z');
  var value = coerce('value');
  if (!x || !x.length || !y || !y.length || !z || !z.length || !value || !value.length) {
    traceOut.visible = false;
    return;
  }
  var handleCalendarDefaults = Registry.getComponentMethod('calendars', 'handleTraceDefaults');
  handleCalendarDefaults(traceIn, traceOut, ['x', 'y', 'z'], layout);
  coerce('valuehoverformat');
  ['x', 'y', 'z'].forEach(function (dim) {
    coerce(dim + 'hoverformat');
    var capDim = 'caps.' + dim;
    var showCap = coerce(capDim + '.show');
    if (showCap) {
      coerce(capDim + '.fill');
    }
    var sliceDim = 'slices.' + dim;
    var showSlice = coerce(sliceDim + '.show');
    if (showSlice) {
      coerce(sliceDim + '.fill');
      coerce(sliceDim + '.locations');
    }
  });
  var showSpaceframe = coerce('spaceframe.show');
  if (showSpaceframe) {
    coerce('spaceframe.fill');
  }
  var showSurface = coerce('surface.show');
  if (showSurface) {
    coerce('surface.count');
    coerce('surface.fill');
    coerce('surface.pattern');
  }
  var showContour = coerce('contour.show');
  if (showContour) {
    coerce('contour.color');
    coerce('contour.width');
  }

  // Coerce remaining properties
  ['text', 'hovertext', 'hovertemplate', 'lighting.ambient', 'lighting.diffuse', 'lighting.specular', 'lighting.roughness', 'lighting.fresnel', 'lighting.vertexnormalsepsilon', 'lighting.facenormalsepsilon', 'lightposition.x', 'lightposition.y', 'lightposition.z', 'flatshading', 'opacity'].forEach(function (x) {
    coerce(x);
  });
  colorscaleDefaults(traceIn, traceOut, layout, coerce, {
    prefix: '',
    cLetter: 'c'
  });

  // disable 1D transforms (for now)
  traceOut._length = null;
}
module.exports = {
  supplyDefaults: supplyDefaults,
  supplyIsoDefaults: supplyIsoDefaults
};

/***/ }),

/***/ 75297:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = {
  attributes: __webpack_require__(70252),
  supplyDefaults: (__webpack_require__(44731).supplyDefaults),
  calc: __webpack_require__(58988),
  colorbar: {
    min: 'cmin',
    max: 'cmax'
  },
  plot: (__webpack_require__(91370).createIsosurfaceTrace),
  moduleType: 'trace',
  name: 'isosurface',
  basePlotModule: __webpack_require__(2487),
  categories: ['gl3d', 'showLegend'],
  meta: {}
};

/***/ }),

/***/ 42450:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var colorScaleAttrs = __webpack_require__(87163);
var axisHoverFormat = (__webpack_require__(80712).axisHoverFormat);
var hovertemplateAttrs = (__webpack_require__(3208)/* .hovertemplateAttrs */ .rb);
var surfaceAttrs = __webpack_require__(16131);
var baseAttrs = __webpack_require__(9829);
var extendFlat = (__webpack_require__(93049).extendFlat);
module.exports = extendFlat({
  x: {
    valType: 'data_array',
    editType: 'calc+clearAxisTypes'
  },
  y: {
    valType: 'data_array',
    editType: 'calc+clearAxisTypes'
  },
  z: {
    valType: 'data_array',
    editType: 'calc+clearAxisTypes'
  },
  i: {
    valType: 'data_array',
    editType: 'calc'
  },
  j: {
    valType: 'data_array',
    editType: 'calc'
  },
  k: {
    valType: 'data_array',
    editType: 'calc'
  },
  text: {
    valType: 'string',
    dflt: '',
    arrayOk: true,
    editType: 'calc'
  },
  hovertext: {
    valType: 'string',
    dflt: '',
    arrayOk: true,
    editType: 'calc'
  },
  hovertemplate: hovertemplateAttrs({
    editType: 'calc'
  }),
  xhoverformat: axisHoverFormat('x'),
  yhoverformat: axisHoverFormat('y'),
  zhoverformat: axisHoverFormat('z'),
  delaunayaxis: {
    valType: 'enumerated',
    values: ['x', 'y', 'z'],
    dflt: 'z',
    editType: 'calc'
  },
  alphahull: {
    valType: 'number',
    dflt: -1,
    editType: 'calc'
  },
  intensity: {
    valType: 'data_array',
    editType: 'calc'
  },
  intensitymode: {
    valType: 'enumerated',
    values: ['vertex', 'cell'],
    dflt: 'vertex',
    editType: 'calc'
  },
  // Color field
  color: {
    valType: 'color',
    editType: 'calc'
  },
  vertexcolor: {
    valType: 'data_array',
    editType: 'calc'
  },
  facecolor: {
    valType: 'data_array',
    editType: 'calc'
  },
  transforms: undefined
}, colorScaleAttrs('', {
  colorAttr: '`intensity`',
  showScaleDflt: true,
  editTypeOverride: 'calc'
}), {
  opacity: surfaceAttrs.opacity,
  // Flat shaded mode
  flatshading: {
    valType: 'boolean',
    dflt: false,
    editType: 'calc'
  },
  contour: {
    show: extendFlat({}, surfaceAttrs.contours.x.show, {}),
    color: surfaceAttrs.contours.x.color,
    width: surfaceAttrs.contours.x.width,
    editType: 'calc'
  },
  lightposition: {
    x: extendFlat({}, surfaceAttrs.lightposition.x, {
      dflt: 1e5
    }),
    y: extendFlat({}, surfaceAttrs.lightposition.y, {
      dflt: 1e5
    }),
    z: extendFlat({}, surfaceAttrs.lightposition.z, {
      dflt: 0
    }),
    editType: 'calc'
  },
  lighting: extendFlat({
    vertexnormalsepsilon: {
      valType: 'number',
      min: 0.00,
      max: 1,
      dflt: 1e-12,
      // otherwise finely tessellated things eg. the brain will have no specular light reflection
      editType: 'calc'
    },
    facenormalsepsilon: {
      valType: 'number',
      min: 0.00,
      max: 1,
      dflt: 1e-6,
      // even the brain model doesn't appear to need finer than this
      editType: 'calc'
    },
    editType: 'calc'
  }, surfaceAttrs.lighting),
  hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
    editType: 'calc'
  }),
  showlegend: extendFlat({}, baseAttrs.showlegend, {
    dflt: false
  })
});

/***/ }),

/***/ 44878:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var colorscaleCalc = __webpack_require__(28379);
module.exports = function calc(gd, trace) {
  if (trace.intensity) {
    colorscaleCalc(gd, trace, {
      vals: trace.intensity,
      containerStr: '',
      cLetter: 'c'
    });
  }
};

/***/ }),

/***/ 82836:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var createMesh = (__webpack_require__(99098).gl_mesh3d);
var triangulate = (__webpack_require__(99098).delaunay_triangulate);
var alphaShape = (__webpack_require__(99098).alpha_shape);
var convexHull = (__webpack_require__(99098).convex_hull);
var parseColorScale = (__webpack_require__(46998).parseColorScale);
var isArrayOrTypedArray = (__webpack_require__(34809).isArrayOrTypedArray);
var str2RgbaArray = __webpack_require__(55010);
var extractOpts = (__webpack_require__(88856).extractOpts);
var zip3 = __webpack_require__(88239);
function Mesh3DTrace(scene, mesh, uid) {
  this.scene = scene;
  this.uid = uid;
  this.mesh = mesh;
  this.name = '';
  this.color = '#fff';
  this.data = null;
  this.showContour = false;
}
var proto = Mesh3DTrace.prototype;
proto.handlePick = function (selection) {
  if (selection.object === this.mesh) {
    var selectIndex = selection.index = selection.data.index;
    if (selection.data._cellCenter) {
      selection.traceCoordinate = selection.data.dataCoordinate;
    } else {
      selection.traceCoordinate = [this.data.x[selectIndex], this.data.y[selectIndex], this.data.z[selectIndex]];
    }
    var text = this.data.hovertext || this.data.text;
    if (isArrayOrTypedArray(text) && text[selectIndex] !== undefined) {
      selection.textLabel = text[selectIndex];
    } else if (text) {
      selection.textLabel = text;
    }
    return true;
  }
};
function parseColorArray(colors) {
  var b = [];
  var len = colors.length;
  for (var i = 0; i < len; i++) {
    b[i] = str2RgbaArray(colors[i]);
  }
  return b;
}

// Unpack position data
function toDataCoords(axis, coord, scale, calendar) {
  var b = [];
  var len = coord.length;
  for (var i = 0; i < len; i++) {
    b[i] = axis.d2l(coord[i], 0, calendar) * scale;
  }
  return b;
}

// Round indices if passed as floats
function toRoundIndex(a) {
  var b = [];
  var len = a.length;
  for (var i = 0; i < len; i++) {
    b[i] = Math.round(a[i]);
  }
  return b;
}
function delaunayCells(delaunayaxis, positions) {
  var d = ['x', 'y', 'z'].indexOf(delaunayaxis);
  var b = [];
  var len = positions.length;
  for (var i = 0; i < len; i++) {
    b[i] = [positions[i][(d + 1) % 3], positions[i][(d + 2) % 3]];
  }
  return triangulate(b);
}

// Validate indices
function hasValidIndices(list, numVertices) {
  var len = list.length;
  for (var i = 0; i < len; i++) {
    if (list[i] <= -0.5 || list[i] >= numVertices - 0.5) {
      // Note: the indices would be rounded -0.49 is valid.
      return false;
    }
  }
  return true;
}
proto.update = function (data) {
  var scene = this.scene;
  var layout = scene.fullSceneLayout;
  this.data = data;
  var numVertices = data.x.length;
  var positions = zip3(toDataCoords(layout.xaxis, data.x, scene.dataScale[0], data.xcalendar), toDataCoords(layout.yaxis, data.y, scene.dataScale[1], data.ycalendar), toDataCoords(layout.zaxis, data.z, scene.dataScale[2], data.zcalendar));
  var cells;
  if (data.i && data.j && data.k) {
    if (data.i.length !== data.j.length || data.j.length !== data.k.length || !hasValidIndices(data.i, numVertices) || !hasValidIndices(data.j, numVertices) || !hasValidIndices(data.k, numVertices)) {
      return;
    }
    cells = zip3(toRoundIndex(data.i), toRoundIndex(data.j), toRoundIndex(data.k));
  } else if (data.alphahull === 0) {
    cells = convexHull(positions);
  } else if (data.alphahull > 0) {
    cells = alphaShape(data.alphahull, positions);
  } else {
    cells = delaunayCells(data.delaunayaxis, positions);
  }
  var config = {
    positions: positions,
    cells: cells,
    lightPosition: [data.lightposition.x, data.lightposition.y, data.lightposition.z],
    ambient: data.lighting.ambient,
    diffuse: data.lighting.diffuse,
    specular: data.lighting.specular,
    roughness: data.lighting.roughness,
    fresnel: data.lighting.fresnel,
    vertexNormalsEpsilon: data.lighting.vertexnormalsepsilon,
    faceNormalsEpsilon: data.lighting.facenormalsepsilon,
    opacity: data.opacity,
    contourEnable: data.contour.show,
    contourColor: str2RgbaArray(data.contour.color).slice(0, 3),
    contourWidth: data.contour.width,
    useFacetNormals: data.flatshading
  };
  if (data.intensity) {
    var cOpts = extractOpts(data);
    this.color = '#fff';
    var mode = data.intensitymode;
    config[mode + 'Intensity'] = data.intensity;
    config[mode + 'IntensityBounds'] = [cOpts.min, cOpts.max];
    config.colormap = parseColorScale(data);
  } else if (data.vertexcolor) {
    this.color = data.vertexcolor[0];
    config.vertexColors = parseColorArray(data.vertexcolor);
  } else if (data.facecolor) {
    this.color = data.facecolor[0];
    config.cellColors = parseColorArray(data.facecolor);
  } else {
    this.color = data.color;
    config.meshColor = str2RgbaArray(data.color);
  }

  // Update mesh
  this.mesh.update(config);
};
proto.dispose = function () {
  this.scene.glplot.remove(this.mesh);
  this.mesh.dispose();
};
function createMesh3DTrace(scene, data) {
  var gl = scene.glplot.gl;
  var mesh = createMesh({
    gl: gl
  });
  var result = new Mesh3DTrace(scene, mesh, data.uid);
  mesh._trace = result;
  result.update(data);
  scene.glplot.add(mesh);
  return result;
}
module.exports = createMesh3DTrace;

/***/ }),

/***/ 13573:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Registry = __webpack_require__(33626);
var Lib = __webpack_require__(34809);
var colorscaleDefaults = __webpack_require__(39356);
var attributes = __webpack_require__(42450);
module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
  function coerce(attr, dflt) {
    return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
  }

  // read in face/vertex properties
  function readComponents(array) {
    var ret = array.map(function (attr) {
      var result = coerce(attr);
      if (result && Lib.isArrayOrTypedArray(result)) return result;
      return null;
    });
    return ret.every(function (x) {
      return x && x.length === ret[0].length;
    }) && ret;
  }
  var coords = readComponents(['x', 'y', 'z']);
  if (!coords) {
    traceOut.visible = false;
    return;
  }
  readComponents(['i', 'j', 'k']);
  // three indices should be all provided or not
  if (traceOut.i && (!traceOut.j || !traceOut.k) || traceOut.j && (!traceOut.k || !traceOut.i) || traceOut.k && (!traceOut.i || !traceOut.j)) {
    traceOut.visible = false;
    return;
  }
  var handleCalendarDefaults = Registry.getComponentMethod('calendars', 'handleTraceDefaults');
  handleCalendarDefaults(traceIn, traceOut, ['x', 'y', 'z'], layout);

  // Coerce remaining properties
  ['lighting.ambient', 'lighting.diffuse', 'lighting.specular', 'lighting.roughness', 'lighting.fresnel', 'lighting.vertexnormalsepsilon', 'lighting.facenormalsepsilon', 'lightposition.x', 'lightposition.y', 'lightposition.z', 'flatshading', 'alphahull', 'delaunayaxis', 'opacity'].forEach(function (x) {
    coerce(x);
  });
  var showContour = coerce('contour.show');
  if (showContour) {
    coerce('contour.color');
    coerce('contour.width');
  }
  if ('intensity' in traceIn) {
    coerce('intensity');
    coerce('intensitymode');
    colorscaleDefaults(traceIn, traceOut, layout, coerce, {
      prefix: '',
      cLetter: 'c'
    });
  } else {
    traceOut.showscale = false;
    if ('facecolor' in traceIn) coerce('facecolor');else if ('vertexcolor' in traceIn) coerce('vertexcolor');else coerce('color', defaultColor);
  }
  coerce('text');
  coerce('hovertext');
  coerce('hovertemplate');
  coerce('xhoverformat');
  coerce('yhoverformat');
  coerce('zhoverformat');

  // disable 1D transforms
  // x/y/z should match lengths, and i/j/k should match as well, but
  // the two sets have different lengths so transforms wouldn't work.
  traceOut._length = null;
};

/***/ }),

/***/ 58859:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = {
  attributes: __webpack_require__(42450),
  supplyDefaults: __webpack_require__(13573),
  calc: __webpack_require__(44878),
  colorbar: {
    min: 'cmin',
    max: 'cmax'
  },
  plot: __webpack_require__(82836),
  moduleType: 'trace',
  name: 'mesh3d',
  basePlotModule: __webpack_require__(2487),
  categories: ['gl3d', 'showLegend'],
  meta: {}
};

/***/ }),

/***/ 86706:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var extendFlat = (__webpack_require__(34809).extendFlat);
var scatterAttrs = __webpack_require__(36640);
var axisHoverFormat = (__webpack_require__(80712).axisHoverFormat);
var dash = (__webpack_require__(94850)/* .dash */ .T);
var fxAttrs = __webpack_require__(70192);
var delta = __webpack_require__(20909);
var INCREASING_COLOR = delta.INCREASING.COLOR;
var DECREASING_COLOR = delta.DECREASING.COLOR;
var lineAttrs = scatterAttrs.line;
function directionAttrs(lineColorDefault) {
  return {
    line: {
      color: extendFlat({}, lineAttrs.color, {
        dflt: lineColorDefault
      }),
      width: lineAttrs.width,
      dash: dash,
      editType: 'style'
    },
    editType: 'style'
  };
}
module.exports = {
  xperiod: scatterAttrs.xperiod,
  xperiod0: scatterAttrs.xperiod0,
  xperiodalignment: scatterAttrs.xperiodalignment,
  xhoverformat: axisHoverFormat('x'),
  yhoverformat: axisHoverFormat('y'),
  x: {
    valType: 'data_array',
    editType: 'calc+clearAxisTypes'
  },
  open: {
    valType: 'data_array',
    editType: 'calc'
  },
  high: {
    valType: 'data_array',
    editType: 'calc'
  },
  low: {
    valType: 'data_array',
    editType: 'calc'
  },
  close: {
    valType: 'data_array',
    editType: 'calc'
  },
  line: {
    width: extendFlat({}, lineAttrs.width, {}),
    dash: extendFlat({}, dash, {}),
    editType: 'style'
  },
  increasing: directionAttrs(INCREASING_COLOR),
  decreasing: directionAttrs(DECREASING_COLOR),
  text: {
    valType: 'string',
    dflt: '',
    arrayOk: true,
    editType: 'calc'
  },
  hovertext: {
    valType: 'string',
    dflt: '',
    arrayOk: true,
    editType: 'calc'
  },
  tickwidth: {
    valType: 'number',
    min: 0,
    max: 0.5,
    dflt: 0.3,
    editType: 'calc'
  },
  hoverlabel: extendFlat({}, fxAttrs.hoverlabel, {
    split: {
      valType: 'boolean',
      dflt: false,
      editType: 'style'
    }
  }),
  zorder: scatterAttrs.zorder
};

/***/ }),

/***/ 95694:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var _ = Lib._;
var Axes = __webpack_require__(29714);
var alignPeriod = __webpack_require__(40528);
var BADNUM = (__webpack_require__(63821).BADNUM);
function calc(gd, trace) {
  var xa = Axes.getFromId(gd, trace.xaxis);
  var ya = Axes.getFromId(gd, trace.yaxis);
  var tickLen = convertTickWidth(gd, xa, trace);
  var minDiff = trace._minDiff;
  trace._minDiff = null;
  var origX = trace._origX;
  trace._origX = null;
  var x = trace._xcalc;
  trace._xcalc = null;
  var cd = calcCommon(gd, trace, origX, x, ya, ptFunc);
  trace._extremes[xa._id] = Axes.findExtremes(xa, x, {
    vpad: minDiff / 2
  });
  if (cd.length) {
    Lib.extendFlat(cd[0].t, {
      wHover: minDiff / 2,
      tickLen: tickLen
    });
    return cd;
  } else {
    return [{
      t: {
        empty: true
      }
    }];
  }
}
function ptFunc(o, h, l, c) {
  return {
    o: o,
    h: h,
    l: l,
    c: c
  };
}

// shared between OHLC and candlestick
// ptFunc makes a calcdata point specific to each trace type, from oi, hi, li, ci
function calcCommon(gd, trace, origX, x, ya, ptFunc) {
  var o = ya.makeCalcdata(trace, 'open');
  var h = ya.makeCalcdata(trace, 'high');
  var l = ya.makeCalcdata(trace, 'low');
  var c = ya.makeCalcdata(trace, 'close');
  var hasTextArray = Lib.isArrayOrTypedArray(trace.text);
  var hasHovertextArray = Lib.isArrayOrTypedArray(trace.hovertext);

  // we're optimists - before we have any changing data, assume increasing
  var increasing = true;
  var cPrev = null;
  var hasPeriod = !!trace.xperiodalignment;
  var cd = [];
  for (var i = 0; i < x.length; i++) {
    var xi = x[i];
    var oi = o[i];
    var hi = h[i];
    var li = l[i];
    var ci = c[i];
    if (xi !== BADNUM && oi !== BADNUM && hi !== BADNUM && li !== BADNUM && ci !== BADNUM) {
      if (ci === oi) {
        // if open == close, look for a change from the previous close
        if (cPrev !== null && ci !== cPrev) increasing = ci > cPrev;
        // else (c === cPrev or cPrev is null) no change
      } else increasing = ci > oi;
      cPrev = ci;
      var pt = ptFunc(oi, hi, li, ci);
      pt.pos = xi;
      pt.yc = (oi + ci) / 2;
      pt.i = i;
      pt.dir = increasing ? 'increasing' : 'decreasing';

      // For categoryorder, store low and high
      pt.x = pt.pos;
      pt.y = [li, hi];
      if (hasPeriod) pt.orig_p = origX[i]; // used by hover
      if (hasTextArray) pt.tx = trace.text[i];
      if (hasHovertextArray) pt.htx = trace.hovertext[i];
      cd.push(pt);
    } else {
      cd.push({
        pos: xi,
        empty: true
      });
    }
  }
  trace._extremes[ya._id] = Axes.findExtremes(ya, Lib.concat(l, h), {
    padded: true
  });
  if (cd.length) {
    cd[0].t = {
      labels: {
        open: _(gd, 'open:') + ' ',
        high: _(gd, 'high:') + ' ',
        low: _(gd, 'low:') + ' ',
        close: _(gd, 'close:') + ' '
      }
    };
  }
  return cd;
}

/*
 * find min x-coordinates difference of all traces
 * attached to this x-axis and stash the result in _minDiff
 * in all traces; when a trace uses this in its
 * calc step it deletes _minDiff, so that next calc this is
 * done again in case the data changed.
 * also since we need it here, stash _xcalc (and _origX) on the trace
 */
function convertTickWidth(gd, xa, trace) {
  var minDiff = trace._minDiff;
  if (!minDiff) {
    var fullData = gd._fullData;
    var ohlcTracesOnThisXaxis = [];
    minDiff = Infinity;
    var i;
    for (i = 0; i < fullData.length; i++) {
      var tracei = fullData[i];
      if (tracei.type === 'ohlc' && tracei.visible === true && tracei.xaxis === xa._id) {
        ohlcTracesOnThisXaxis.push(tracei);
        var origX = xa.makeCalcdata(tracei, 'x');
        tracei._origX = origX;
        var xcalc = alignPeriod(trace, xa, 'x', origX).vals;
        tracei._xcalc = xcalc;
        var _minDiff = Lib.distinctVals(xcalc).minDiff;
        if (_minDiff && isFinite(_minDiff)) {
          minDiff = Math.min(minDiff, _minDiff);
        }
      }
    }

    // if minDiff is still Infinity here, set it to 1
    if (minDiff === Infinity) minDiff = 1;
    for (i = 0; i < ohlcTracesOnThisXaxis.length; i++) {
      ohlcTracesOnThisXaxis[i]._minDiff = minDiff;
    }
  }
  return minDiff * trace.tickwidth;
}
module.exports = {
  calc: calc,
  calcCommon: calcCommon
};

/***/ }),

/***/ 22629:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var handleOHLC = __webpack_require__(28270);
var handlePeriodDefaults = __webpack_require__(99669);
var attributes = __webpack_require__(86706);
module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
  function coerce(attr, dflt) {
    return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
  }
  var len = handleOHLC(traceIn, traceOut, coerce, layout);
  if (!len) {
    traceOut.visible = false;
    return;
  }
  handlePeriodDefaults(traceIn, traceOut, layout, coerce, {
    x: true
  });
  coerce('xhoverformat');
  coerce('yhoverformat');
  coerce('line.width');
  coerce('line.dash');
  handleDirection(traceIn, traceOut, coerce, 'increasing');
  handleDirection(traceIn, traceOut, coerce, 'decreasing');
  coerce('text');
  coerce('hovertext');
  coerce('tickwidth');
  layout._requestRangeslider[traceOut.xaxis] = true;
  coerce('zorder');
};
function handleDirection(traceIn, traceOut, coerce, direction) {
  coerce(direction + '.line.color');
  coerce(direction + '.line.width', traceOut.line.width);
  coerce(direction + '.line.dash', traceOut.line.dash);
}

/***/ }),

/***/ 93245:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Axes = __webpack_require__(29714);
var Lib = __webpack_require__(34809);
var Fx = __webpack_require__(32141);
var Color = __webpack_require__(78766);
var fillText = (__webpack_require__(34809).fillText);
var delta = __webpack_require__(20909);
var DIRSYMBOL = {
  increasing: delta.INCREASING.SYMBOL,
  decreasing: delta.DECREASING.SYMBOL
};
function hoverPoints(pointData, xval, yval, hovermode) {
  var cd = pointData.cd;
  var trace = cd[0].trace;
  if (trace.hoverlabel.split) {
    return hoverSplit(pointData, xval, yval, hovermode);
  }
  return hoverOnPoints(pointData, xval, yval, hovermode);
}
function _getClosestPoint(pointData, xval, yval, hovermode) {
  var cd = pointData.cd;
  var xa = pointData.xa;
  var trace = cd[0].trace;
  var t = cd[0].t;
  var type = trace.type;
  var minAttr = type === 'ohlc' ? 'l' : 'min';
  var maxAttr = type === 'ohlc' ? 'h' : 'max';
  var hoverPseudoDistance, spikePseudoDistance;

  // potentially shift xval for grouped candlesticks
  var centerShift = t.bPos || 0;
  var shiftPos = function (di) {
    return di.pos + centerShift - xval;
  };

  // ohlc and candlestick call displayHalfWidth different things...
  var displayHalfWidth = t.bdPos || t.tickLen;
  var hoverHalfWidth = t.wHover;

  // if two figures are overlaying, let the narrowest one win
  var pseudoDistance = Math.min(1, displayHalfWidth / Math.abs(xa.r2c(xa.range[1]) - xa.r2c(xa.range[0])));
  hoverPseudoDistance = pointData.maxHoverDistance - pseudoDistance;
  spikePseudoDistance = pointData.maxSpikeDistance - pseudoDistance;
  function dx(di) {
    var pos = shiftPos(di);
    return Fx.inbox(pos - hoverHalfWidth, pos + hoverHalfWidth, hoverPseudoDistance);
  }
  function dy(di) {
    var min = di[minAttr];
    var max = di[maxAttr];
    return min === max || Fx.inbox(min - yval, max - yval, hoverPseudoDistance);
  }
  function dxy(di) {
    return (dx(di) + dy(di)) / 2;
  }
  var distfn = Fx.getDistanceFunction(hovermode, dx, dy, dxy);
  Fx.getClosest(cd, distfn, pointData);
  if (pointData.index === false) return null;
  var di = cd[pointData.index];
  if (di.empty) return null;
  var dir = di.dir;
  var container = trace[dir];
  var lc = container.line.color;
  if (Color.opacity(lc) && container.line.width) pointData.color = lc;else pointData.color = container.fillcolor;
  pointData.x0 = xa.c2p(di.pos + centerShift - displayHalfWidth, true);
  pointData.x1 = xa.c2p(di.pos + centerShift + displayHalfWidth, true);
  pointData.xLabelVal = di.orig_p !== undefined ? di.orig_p : di.pos;
  pointData.spikeDistance = dxy(di) * spikePseudoDistance / hoverPseudoDistance;
  pointData.xSpike = xa.c2p(di.pos, true);
  return pointData;
}
function hoverSplit(pointData, xval, yval, hovermode) {
  var cd = pointData.cd;
  var ya = pointData.ya;
  var trace = cd[0].trace;
  var t = cd[0].t;
  var closeBoxData = [];
  var closestPoint = _getClosestPoint(pointData, xval, yval, hovermode);
  // skip the rest (for this trace) if we didn't find a close point
  if (!closestPoint) return [];
  var cdIndex = closestPoint.index;
  var di = cd[cdIndex];
  var hoverinfo = di.hi || trace.hoverinfo;
  var hoverParts = hoverinfo.split('+');
  var isAll = hoverinfo === 'all';
  var hasY = isAll || hoverParts.indexOf('y') !== -1;

  // similar to hoverOnPoints, we return nothing
  // if all or y is not present.
  if (!hasY) return [];
  var attrs = ['high', 'open', 'close', 'low'];

  // several attributes can have the same y-coordinate. We will
  // bunch them together in a single text block. For this, we keep
  // a dictionary mapping y-coord -> point data.
  var usedVals = {};
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    var val = trace[attr][closestPoint.index];
    var valPx = ya.c2p(val, true);
    var pointData2;
    if (val in usedVals) {
      pointData2 = usedVals[val];
      pointData2.yLabel += '<br>' + t.labels[attr] + Axes.hoverLabelText(ya, val, trace.yhoverformat);
    } else {
      // copy out to a new object for each new y-value to label
      pointData2 = Lib.extendFlat({}, closestPoint);
      pointData2.y0 = pointData2.y1 = valPx;
      pointData2.yLabelVal = val;
      pointData2.yLabel = t.labels[attr] + Axes.hoverLabelText(ya, val, trace.yhoverformat);
      pointData2.name = '';
      closeBoxData.push(pointData2);
      usedVals[val] = pointData2;
    }
  }
  return closeBoxData;
}
function hoverOnPoints(pointData, xval, yval, hovermode) {
  var cd = pointData.cd;
  var ya = pointData.ya;
  var trace = cd[0].trace;
  var t = cd[0].t;
  var closestPoint = _getClosestPoint(pointData, xval, yval, hovermode);
  // skip the rest (for this trace) if we didn't find a close point
  if (!closestPoint) return [];

  // we don't make a calcdata point if we're missing any piece (x/o/h/l/c)
  // so we need to fix the index here to point to the data arrays
  var cdIndex = closestPoint.index;
  var di = cd[cdIndex];
  var i = closestPoint.index = di.i;
  var dir = di.dir;
  function getLabelLine(attr) {
    return t.labels[attr] + Axes.hoverLabelText(ya, trace[attr][i], trace.yhoverformat);
  }
  var hoverinfo = di.hi || trace.hoverinfo;
  var hoverParts = hoverinfo.split('+');
  var isAll = hoverinfo === 'all';
  var hasY = isAll || hoverParts.indexOf('y') !== -1;
  var hasText = isAll || hoverParts.indexOf('text') !== -1;
  var textParts = hasY ? [getLabelLine('open'), getLabelLine('high'), getLabelLine('low'), getLabelLine('close') + '  ' + DIRSYMBOL[dir]] : [];
  if (hasText) fillText(di, trace, textParts);

  // don't make .yLabelVal or .text, since we're managing hoverinfo
  // put it all in .extraText
  closestPoint.extraText = textParts.join('<br>');

  // this puts the label *and the spike* at the midpoint of the box, ie
  // halfway between open and close, not between high and low.
  closestPoint.y0 = closestPoint.y1 = ya.c2p(di.yc, true);
  return [closestPoint];
}
module.exports = {
  hoverPoints: hoverPoints,
  hoverSplit: hoverSplit,
  hoverOnPoints: hoverOnPoints
};

/***/ }),

/***/ 12683:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = {
  moduleType: 'trace',
  name: 'ohlc',
  basePlotModule: __webpack_require__(37703),
  categories: ['cartesian', 'svg', 'showLegend'],
  meta: {},
  attributes: __webpack_require__(86706),
  supplyDefaults: __webpack_require__(22629),
  calc: (__webpack_require__(95694).calc),
  plot: __webpack_require__(38956),
  style: __webpack_require__(57406),
  hoverPoints: (__webpack_require__(93245).hoverPoints),
  selectPoints: __webpack_require__(49343)
};

/***/ }),

/***/ 28270:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Registry = __webpack_require__(33626);
var Lib = __webpack_require__(34809);
module.exports = function handleOHLC(traceIn, traceOut, coerce, layout) {
  var x = coerce('x');
  var open = coerce('open');
  var high = coerce('high');
  var low = coerce('low');
  var close = coerce('close');
  coerce('hoverlabel.split');
  var handleCalendarDefaults = Registry.getComponentMethod('calendars', 'handleTraceDefaults');
  handleCalendarDefaults(traceIn, traceOut, ['x'], layout);
  if (!(open && high && low && close)) return;
  var len = Math.min(open.length, high.length, low.length, close.length);
  if (x) len = Math.min(len, Lib.minRowLength(x));
  traceOut._length = len;
  return len;
};

/***/ }),

/***/ 38956:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var Lib = __webpack_require__(34809);
module.exports = function plot(gd, plotinfo, cdOHLC, ohlcLayer) {
  var ya = plotinfo.yaxis;
  var xa = plotinfo.xaxis;
  var posHasRangeBreaks = !!xa.rangebreaks;
  Lib.makeTraceGroups(ohlcLayer, cdOHLC, 'trace ohlc').each(function (cd) {
    var plotGroup = d3.select(this);
    var cd0 = cd[0];
    var t = cd0.t;
    var trace = cd0.trace;
    if (trace.visible !== true || t.empty) {
      plotGroup.remove();
      return;
    }
    var tickLen = t.tickLen;
    var paths = plotGroup.selectAll('path').data(Lib.identity);
    paths.enter().append('path');
    paths.exit().remove();
    paths.attr('d', function (d) {
      if (d.empty) return 'M0,0Z';
      var xo = xa.c2p(d.pos - tickLen, true);
      var xc = xa.c2p(d.pos + tickLen, true);
      var x = posHasRangeBreaks ? (xo + xc) / 2 : xa.c2p(d.pos, true);
      var yo = ya.c2p(d.o, true);
      var yh = ya.c2p(d.h, true);
      var yl = ya.c2p(d.l, true);
      var yc = ya.c2p(d.c, true);
      return 'M' + xo + ',' + yo + 'H' + x + 'M' + x + ',' + yh + 'V' + yl + 'M' + xc + ',' + yc + 'H' + x;
    });
  });
};

/***/ }),

/***/ 49343:
/***/ (function(module) {

"use strict";


module.exports = function selectPoints(searchInfo, selectionTester) {
  var cd = searchInfo.cd;
  var xa = searchInfo.xaxis;
  var ya = searchInfo.yaxis;
  var selection = [];
  var i;
  // for (potentially grouped) candlesticks
  var posOffset = cd[0].t.bPos || 0;
  if (selectionTester === false) {
    // clear selection
    for (i = 0; i < cd.length; i++) {
      cd[i].selected = 0;
    }
  } else {
    for (i = 0; i < cd.length; i++) {
      var di = cd[i];
      if (selectionTester.contains([xa.c2p(di.pos + posOffset), ya.c2p(di.yc)], null, di.i, searchInfo)) {
        selection.push({
          pointNumber: di.i,
          x: xa.c2d(di.pos),
          y: ya.c2d(di.yc)
        });
        di.selected = 1;
      } else {
        di.selected = 0;
      }
    }
  }
  return selection;
};

/***/ }),

/***/ 57406:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var Drawing = __webpack_require__(62203);
var Color = __webpack_require__(78766);
module.exports = function style(gd, cd, sel) {
  var s = sel ? sel : d3.select(gd).selectAll('g.ohlclayer').selectAll('g.trace');
  s.style('opacity', function (d) {
    return d[0].trace.opacity;
  });
  s.each(function (d) {
    var trace = d[0].trace;
    d3.select(this).selectAll('path').each(function (di) {
      if (di.empty) return;
      var dirLine = trace[di.dir].line;
      d3.select(this).style('fill', 'none').call(Color.stroke, dirLine.color).call(Drawing.dashLine, dirLine.dash, dirLine.width)
      // TODO: custom selection style for OHLC
      .style('opacity', trace.selectedpoints && !di.selected ? 0.3 : 1);
    });
  });
};

/***/ }),

/***/ 11660:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var extendFlat = (__webpack_require__(93049).extendFlat);
var baseAttrs = __webpack_require__(9829);
var fontAttrs = __webpack_require__(80337);
var colorScaleAttrs = __webpack_require__(87163);
var hovertemplateAttrs = (__webpack_require__(3208)/* .hovertemplateAttrs */ .rb);
var domainAttrs = (__webpack_require__(13792)/* .attributes */ .u);
var line = extendFlat({
  editType: 'calc'
}, colorScaleAttrs('line', {
  editTypeOverride: 'calc'
}), {
  shape: {
    valType: 'enumerated',
    values: ['linear', 'hspline'],
    dflt: 'linear',
    editType: 'plot'
  },
  hovertemplate: hovertemplateAttrs({
    editType: 'plot',
    arrayOk: false
  }, {
    keys: ['count', 'probability']
  })
});
module.exports = {
  domain: domainAttrs({
    name: 'parcats',
    trace: true,
    editType: 'calc'
  }),
  hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
    flags: ['count', 'probability'],
    editType: 'plot',
    arrayOk: false
  }),
  hoveron: {
    valType: 'enumerated',
    values: ['category', 'color', 'dimension'],
    dflt: 'category',
    editType: 'plot'
  },
  hovertemplate: hovertemplateAttrs({
    editType: 'plot',
    arrayOk: false
  }, {
    keys: ['count', 'probability', 'category', 'categorycount', 'colorcount', 'bandcolorcount']
  }),
  arrangement: {
    valType: 'enumerated',
    values: ['perpendicular', 'freeform', 'fixed'],
    dflt: 'perpendicular',
    editType: 'plot'
  },
  bundlecolors: {
    valType: 'boolean',
    dflt: true,
    editType: 'plot'
  },
  sortpaths: {
    valType: 'enumerated',
    values: ['forward', 'backward'],
    dflt: 'forward',
    editType: 'plot'
  },
  labelfont: fontAttrs({
    editType: 'calc'
  }),
  tickfont: fontAttrs({
    autoShadowDflt: true,
    editType: 'calc'
  }),
  dimensions: {
    _isLinkedToArray: 'dimension',
    label: {
      valType: 'string',
      editType: 'calc'
    },
    categoryorder: {
      valType: 'enumerated',
      values: ['trace', 'category ascending', 'category descending', 'array'],
      dflt: 'trace',
      editType: 'calc'
    },
    categoryarray: {
      valType: 'data_array',
      editType: 'calc'
    },
    ticktext: {
      valType: 'data_array',
      editType: 'calc'
    },
    values: {
      valType: 'data_array',
      dflt: [],
      editType: 'calc'
    },
    displayindex: {
      valType: 'integer',
      editType: 'calc'
    },
    editType: 'calc',
    visible: {
      valType: 'boolean',
      dflt: true,
      editType: 'calc'
    }
  },
  line: line,
  counts: {
    valType: 'number',
    min: 0,
    dflt: 1,
    arrayOk: true,
    editType: 'calc'
  },
  // Hide unsupported top-level properties from plot-schema
  customdata: undefined,
  hoverlabel: undefined,
  ids: undefined,
  legend: undefined,
  legendgroup: undefined,
  legendrank: undefined,
  opacity: undefined,
  selectedpoints: undefined,
  showlegend: undefined
};

/***/ }),

/***/ 83260:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var getModuleCalcData = (__webpack_require__(4173)/* .getModuleCalcData */ .eV);
var parcatsPlot = __webpack_require__(37822);
var PARCATS = 'parcats';
exports.name = PARCATS;
exports.plot = function (gd, traces, transitionOpts, makeOnCompleteCallback) {
  var cdModuleAndOthers = getModuleCalcData(gd.calcdata, PARCATS);
  if (cdModuleAndOthers.length) {
    var calcData = cdModuleAndOthers[0];
    parcatsPlot(gd, calcData, transitionOpts, makeOnCompleteCallback);
  }
};
exports.clean = function (newFullData, newFullLayout, oldFullData, oldFullLayout) {
  var hadTable = oldFullLayout._has && oldFullLayout._has('parcats');
  var hasTable = newFullLayout._has && newFullLayout._has('parcats');
  if (hadTable && !hasTable) {
    oldFullLayout._paperdiv.selectAll('.parcats').remove();
  }
};

/***/ }),

/***/ 95564:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


// Requirements
// ============
var wrap = (__webpack_require__(71293).wrap);
var hasColorscale = (__webpack_require__(65477).hasColorscale);
var colorscaleCalc = __webpack_require__(28379);
var filterUnique = __webpack_require__(48965);
var Drawing = __webpack_require__(62203);
var Lib = __webpack_require__(34809);
var isNumeric = __webpack_require__(10721);

/**
 * Create a wrapped ParcatsModel object from trace
 *
 * Note: trace defaults have already been applied
 * @param {Object} gd
 * @param {Object} trace
 * @return {Array.<ParcatsModel>}
 */
module.exports = function calc(gd, trace) {
  var visibleDims = Lib.filterVisible(trace.dimensions);
  if (visibleDims.length === 0) return [];
  var uniqueInfoDims = visibleDims.map(function (dim) {
    var categoryValues;
    if (dim.categoryorder === 'trace') {
      // Use order of first occurrence in trace
      categoryValues = null;
    } else if (dim.categoryorder === 'array') {
      // Use categories specified in `categoryarray` first,
      // then add extra to the end in trace order
      categoryValues = dim.categoryarray;
    } else {
      // Get all categories up front
      categoryValues = filterUnique(dim.values);

      // order them
      var allNumeric = true;
      for (var i = 0; i < categoryValues.length; i++) {
        if (!isNumeric(categoryValues[i])) {
          allNumeric = false;
          break;
        }
      }
      categoryValues.sort(allNumeric ? Lib.sorterAsc : undefined);
      if (dim.categoryorder === 'category descending') {
        categoryValues = categoryValues.reverse();
      }
    }
    return getUniqueInfo(dim.values, categoryValues);
  });
  var counts, count, totalCount;
  if (Lib.isArrayOrTypedArray(trace.counts)) {
    counts = trace.counts;
  } else {
    counts = [trace.counts];
  }
  validateDimensionDisplayInds(visibleDims);
  visibleDims.forEach(function (dim, dimInd) {
    validateCategoryProperties(dim, uniqueInfoDims[dimInd]);
  });

  // Handle path colors
  // ------------------
  var line = trace.line;
  var markerColorscale;

  // Process colorscale
  if (line) {
    if (hasColorscale(trace, 'line')) {
      colorscaleCalc(gd, trace, {
        vals: trace.line.color,
        containerStr: 'line',
        cLetter: 'c'
      });
    }
    markerColorscale = Drawing.tryColorscale(line);
  } else {
    markerColorscale = Lib.identity;
  }

  // Build color generation function
  function getMarkerColorInfo(index) {
    var value, rawColor;
    if (Lib.isArrayOrTypedArray(line.color)) {
      value = line.color[index % line.color.length];
      rawColor = value;
    } else {
      value = line.color;
    }
    return {
      color: markerColorscale(value),
      rawColor: rawColor
    };
  }

  // Number of values and counts
  // ---------------------------
  var numValues = visibleDims[0].values.length;

  // Build path info
  // ---------------
  // Mapping from category inds to PathModel objects
  var pathModels = {};

  // Category inds array for each dimension
  var categoryIndsDims = uniqueInfoDims.map(function (di) {
    return di.inds;
  });

  // Initialize total count
  totalCount = 0;
  var valueInd;
  var d;
  for (valueInd = 0; valueInd < numValues; valueInd++) {
    // Category inds for this input value across dimensions
    var categoryIndsPath = [];
    for (d = 0; d < categoryIndsDims.length; d++) {
      categoryIndsPath.push(categoryIndsDims[d][valueInd]);
    }

    // Count
    count = counts[valueInd % counts.length];

    // Update total count
    totalCount += count;

    // Path color
    var pathColorInfo = getMarkerColorInfo(valueInd);

    // path key
    var pathKey = categoryIndsPath + '-' + pathColorInfo.rawColor;

    // Create / Update PathModel
    if (pathModels[pathKey] === undefined) {
      pathModels[pathKey] = createPathModel(categoryIndsPath, pathColorInfo.color, pathColorInfo.rawColor);
    }
    updatePathModel(pathModels[pathKey], valueInd, count);
  }
  var dimensionModels = visibleDims.map(function (di, i) {
    return createDimensionModel(i, di._index, di._displayindex, di.label, totalCount);
  });
  for (valueInd = 0; valueInd < numValues; valueInd++) {
    count = counts[valueInd % counts.length];
    for (d = 0; d < dimensionModels.length; d++) {
      var containerInd = dimensionModels[d].containerInd;
      var catInd = uniqueInfoDims[d].inds[valueInd];
      var cats = dimensionModels[d].categories;
      if (cats[catInd] === undefined) {
        var catValue = trace.dimensions[containerInd]._categoryarray[catInd];
        var catLabel = trace.dimensions[containerInd]._ticktext[catInd];
        cats[catInd] = createCategoryModel(d, catInd, catValue, catLabel);
      }
      updateCategoryModel(cats[catInd], valueInd, count);
    }
  }

  // Compute unique
  return wrap(createParcatsModel(dimensionModels, pathModels, totalCount));
};

// Models
// ======

// Parcats Model
// -------------
/**
 * @typedef {Object} ParcatsModel
 *  Object containing calculated information about a parcats trace
 *
 * @property {Array.<DimensionModel>} dimensions
 *  Array of dimension models
 * @property {Object.<string,PathModel>} paths
 *  Dictionary from category inds string (e.g. "1,2,1,1") to path model
 * @property {Number} maxCats
 *  The maximum number of categories of any dimension in the diagram
 * @property {Number} count
 *  Total number of input values
 * @property {Object} trace
 */

/**
 * Create and new ParcatsModel object
 * @param {Array.<DimensionModel>} dimensions
 * @param {Object.<string,PathModel>} paths
 * @param {Number} count
 * @return {ParcatsModel}
 */
function createParcatsModel(dimensions, paths, count) {
  var maxCats = dimensions.map(function (d) {
    return d.categories.length;
  }).reduce(function (v1, v2) {
    return Math.max(v1, v2);
  });
  return {
    dimensions: dimensions,
    paths: paths,
    trace: undefined,
    maxCats: maxCats,
    count: count
  };
}

// Dimension Model
// ---------------
/**
 * @typedef {Object} DimensionModel
 *  Object containing calculated information about a single dimension
 *
 * @property {Number} dimensionInd
 *  The index of this dimension among the *visible* dimensions
 * @property {Number} containerInd
 *  The index of this dimension in the original dimensions container,
 *  irrespective of dimension visibility
 * @property {Number} displayInd
 *  The display index of this dimension (where 0 is the left most dimension)
 * @property {String} dimensionLabel
 *  The label of this dimension
 * @property {Number} count
 *  Total number of input values
 * @property {Array.<CategoryModel>} categories
 * @property {Number|null} dragX
 *  The x position of dimension that is currently being dragged. null if not being dragged
 */

/**
 * Create and new DimensionModel object with an empty categories array
 * @param {Number} dimensionInd
 * @param {Number} containerInd
 * @param {Number} displayInd
 * @param {String} dimensionLabel
 * @param {Number} count
 *  Total number of input values
 * @return {DimensionModel}
 */
function createDimensionModel(dimensionInd, containerInd, displayInd, dimensionLabel, count) {
  return {
    dimensionInd: dimensionInd,
    containerInd: containerInd,
    displayInd: displayInd,
    dimensionLabel: dimensionLabel,
    count: count,
    categories: [],
    dragX: null
  };
}

// Category Model
// --------------
/**
 * @typedef {Object} CategoryModel
 *  Object containing calculated information about a single category.
 *
 * @property {Number} dimensionInd
 *  The index of this categories dimension
 * @property {Number} categoryInd
 *  The index of this category
 * @property {Number} displayInd
 *  The display index of this category (where 0 is the topmost category)
 * @property {String} categoryLabel
 *  The name of this category
 * @property categoryValue: Raw value of the category
 * @property {Array} valueInds
 *  Array of indices (into the original value array) of all samples in this category
 * @property {Number} count
 *  The number of elements from the original array in this path
 * @property {Number|null} dragY
 *  The y position of category that is currently being dragged. null if not being dragged
 */

/**
 * Create and return a new CategoryModel object
 * @param {Number} dimensionInd
 * @param {Number} categoryInd
 *  The display index of this category (where 0 is the topmost category)
 * @param {String} categoryValue
 * @param {String} categoryLabel
 * @return {CategoryModel}
 */
function createCategoryModel(dimensionInd, categoryInd, categoryValue, categoryLabel) {
  return {
    dimensionInd: dimensionInd,
    categoryInd: categoryInd,
    categoryValue: categoryValue,
    displayInd: categoryInd,
    categoryLabel: categoryLabel,
    valueInds: [],
    count: 0,
    dragY: null
  };
}

/**
 * Update a CategoryModel object with a new value index
 * Note: The calling parameter is modified in place.
 *
 * @param {CategoryModel} categoryModel
 * @param {Number} valueInd
 * @param {Number} count
 */
function updateCategoryModel(categoryModel, valueInd, count) {
  categoryModel.valueInds.push(valueInd);
  categoryModel.count += count;
}

// Path Model
// ----------
/**
 * @typedef {Object} PathModel
 *  Object containing calculated information about the samples in a path.
 *
 * @property {Array} categoryInds
 *  Array of category indices for each dimension (length `numDimensions`)
 * @param {String} pathColor
 *  Color of this path. (Note: Any colorscaling has already taken place)
 * @property {Array} valueInds
 *  Array of indices (into the original value array) of all samples in this path
 * @property {Number} count
 *  The number of elements from the original array in this path
 * @property {String} color
 *  The path's color (ass CSS color string)
 * @property rawColor
 *  The raw color value specified by the user. May be a CSS color string or a Number
 */

/**
 * Create and return a new PathModel object
 * @param {Array} categoryInds
 * @param color
 * @param rawColor
 * @return {PathModel}
 */
function createPathModel(categoryInds, color, rawColor) {
  return {
    categoryInds: categoryInds,
    color: color,
    rawColor: rawColor,
    valueInds: [],
    count: 0
  };
}

/**
 * Update a PathModel object with a new value index
 * Note: The calling parameter is modified in place.
 *
 * @param {PathModel} pathModel
 * @param {Number} valueInd
 * @param {Number} count
 */
function updatePathModel(pathModel, valueInd, count) {
  pathModel.valueInds.push(valueInd);
  pathModel.count += count;
}

// Unique calculations
// ===================
/**
 * @typedef {Object} UniqueInfo
 *  Object containing information about the unique values of an input array
 *
 * @property {Array} uniqueValues
 *  The unique values in the input array
 * @property {Array} uniqueCounts
 *  The number of times each entry in uniqueValues occurs in input array.
 *  This has the same length as `uniqueValues`
 * @property {Array} inds
 *  Indices into uniqueValues that would reproduce original input array
 */

/**
 * Compute unique value information for an array
 *
 * IMPORTANT: Note that values are considered unique
 * if their string representations are unique.
 *
 * @param {Array} values
 * @param {Array|undefined} uniqueValues
 *  Array of expected unique values. The uniqueValues property of the resulting UniqueInfo object will begin with
 *  these entries. Entries are included even if there are zero occurrences in the values array. Entries found in
 *  the values array that are not present in uniqueValues will be included at the end of the array in the
 *  UniqueInfo object.
 * @return {UniqueInfo}
 */
function getUniqueInfo(values, uniqueValues) {
  // Initialize uniqueValues if not specified
  if (uniqueValues === undefined || uniqueValues === null) {
    uniqueValues = [];
  } else {
    // Shallow copy so append below doesn't alter input array
    uniqueValues = uniqueValues.map(function (e) {
      return e;
    });
  }

  // Initialize Variables
  var uniqueValueCounts = {};
  var uniqueValueInds = {};
  var inds = [];

  // Initialize uniqueValueCounts and
  uniqueValues.forEach(function (uniqueVal, valInd) {
    uniqueValueCounts[uniqueVal] = 0;
    uniqueValueInds[uniqueVal] = valInd;
  });

  // Compute the necessary unique info in a single pass
  for (var i = 0; i < values.length; i++) {
    var item = values[i];
    var itemInd;
    if (uniqueValueCounts[item] === undefined) {
      // This item has a previously unseen value
      uniqueValueCounts[item] = 1;
      itemInd = uniqueValues.push(item) - 1;
      uniqueValueInds[item] = itemInd;
    } else {
      // Increment count for this item
      uniqueValueCounts[item]++;
      itemInd = uniqueValueInds[item];
    }
    inds.push(itemInd);
  }

  // Build UniqueInfo
  var uniqueCounts = uniqueValues.map(function (v) {
    return uniqueValueCounts[v];
  });
  return {
    uniqueValues: uniqueValues,
    uniqueCounts: uniqueCounts,
    inds: inds
  };
}

/**
 * Validate the requested display order for the dimensions.
 * If the display order is a permutation of 0 through dimensions.length - 1, link to _displayindex
 * Otherwise, replace the display order with the dimension order
 * @param {Object} trace
 */
function validateDimensionDisplayInds(visibleDims) {
  var displayInds = visibleDims.map(function (d) {
    return d.displayindex;
  });
  var i;
  if (isRangePermutation(displayInds)) {
    for (i = 0; i < visibleDims.length; i++) {
      visibleDims[i]._displayindex = visibleDims[i].displayindex;
    }
  } else {
    for (i = 0; i < visibleDims.length; i++) {
      visibleDims[i]._displayindex = i;
    }
  }
}

/**
 * Update category properties based on the unique values found for this dimension
 * @param {Object} dim
 * @param {UniqueInfo} uniqueInfoDim
 */
function validateCategoryProperties(dim, uniqueInfoDim) {
  // Update categoryarray
  dim._categoryarray = uniqueInfoDim.uniqueValues;

  // Handle ticktext
  if (dim.ticktext === null || dim.ticktext === undefined) {
    dim._ticktext = [];
  } else {
    // Shallow copy to avoid modifying input array
    dim._ticktext = dim.ticktext.slice();
  }

  // Extend ticktext with elements from uniqueInfoDim.uniqueValues
  for (var i = dim._ticktext.length; i < uniqueInfoDim.uniqueValues.length; i++) {
    dim._ticktext.push(uniqueInfoDim.uniqueValues[i]);
  }
}

/**
 * Determine whether an array contains a permutation of the integers from 0 to the array's length - 1
 * @param {Array} inds
 * @return {boolean}
 */
function isRangePermutation(inds) {
  var indsSpecified = new Array(inds.length);
  for (var i = 0; i < inds.length; i++) {
    // Check for out of bounds
    if (inds[i] < 0 || inds[i] >= inds.length) {
      return false;
    }

    // Check for collisions with already specified index
    if (indsSpecified[inds[i]] !== undefined) {
      return false;
    }
    indsSpecified[inds[i]] = true;
  }

  // Nothing out of bounds and no collisions. We have a permutation
  return true;
}

/***/ }),

/***/ 62651:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var hasColorscale = (__webpack_require__(65477).hasColorscale);
var colorscaleDefaults = __webpack_require__(39356);
var handleDomainDefaults = (__webpack_require__(13792)/* .defaults */ .N);
var handleArrayContainerDefaults = __webpack_require__(59008);
var attributes = __webpack_require__(11660);
var mergeLength = __webpack_require__(63197);
var isTypedArraySpec = (__webpack_require__(87800).isTypedArraySpec);
function handleLineDefaults(traceIn, traceOut, defaultColor, layout, coerce) {
  coerce('line.shape');
  coerce('line.hovertemplate');
  var lineColor = coerce('line.color', layout.colorway[0]);
  if (hasColorscale(traceIn, 'line') && Lib.isArrayOrTypedArray(lineColor)) {
    if (lineColor.length) {
      coerce('line.colorscale');
      colorscaleDefaults(traceIn, traceOut, layout, coerce, {
        prefix: 'line.',
        cLetter: 'c'
      });
      return lineColor.length;
    } else {
      traceOut.line.color = defaultColor;
    }
  }
  return Infinity;
}
function dimensionDefaults(dimensionIn, dimensionOut) {
  function coerce(attr, dflt) {
    return Lib.coerce(dimensionIn, dimensionOut, attributes.dimensions, attr, dflt);
  }
  var values = coerce('values');
  var visible = coerce('visible');
  if (!(values && values.length)) {
    visible = dimensionOut.visible = false;
  }
  if (visible) {
    // Dimension level
    coerce('label');
    coerce('displayindex', dimensionOut._index);

    // Category level
    var arrayIn = dimensionIn.categoryarray;
    var isValidArray = Lib.isArrayOrTypedArray(arrayIn) && arrayIn.length > 0 || isTypedArraySpec(arrayIn);
    var orderDefault;
    if (isValidArray) orderDefault = 'array';
    var order = coerce('categoryorder', orderDefault);

    // coerce 'categoryarray' only in array order case
    if (order === 'array') {
      coerce('categoryarray');
      coerce('ticktext');
    } else {
      delete dimensionIn.categoryarray;
      delete dimensionIn.ticktext;
    }

    // cannot set 'categoryorder' to 'array' with an invalid 'categoryarray'
    if (!isValidArray && order === 'array') {
      dimensionOut.categoryorder = 'trace';
    }
  }
}
module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
  function coerce(attr, dflt) {
    return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
  }
  var dimensions = handleArrayContainerDefaults(traceIn, traceOut, {
    name: 'dimensions',
    handleItemDefaults: dimensionDefaults
  });
  var len = handleLineDefaults(traceIn, traceOut, defaultColor, layout, coerce);
  handleDomainDefaults(traceOut, layout, coerce);
  if (!Array.isArray(dimensions) || !dimensions.length) {
    traceOut.visible = false;
  }
  mergeLength(traceOut, dimensions, 'values', len);
  coerce('hoveron');
  coerce('hovertemplate');
  coerce('arrangement');
  coerce('bundlecolors');
  coerce('sortpaths');
  coerce('counts');
  var layoutFont = layout.font;
  Lib.coerceFont(coerce, 'labelfont', layoutFont, {
    overrideDflt: {
      size: Math.round(layoutFont.size)
    }
  });
  Lib.coerceFont(coerce, 'tickfont', layoutFont, {
    autoShadowDflt: true,
    overrideDflt: {
      size: Math.round(layoutFont.size / 1.2)
    }
  });
};

/***/ }),

/***/ 6305:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = {
  attributes: __webpack_require__(11660),
  supplyDefaults: __webpack_require__(62651),
  calc: __webpack_require__(95564),
  plot: __webpack_require__(37822),
  colorbar: {
    container: 'line',
    min: 'cmin',
    max: 'cmax'
  },
  moduleType: 'trace',
  name: 'parcats',
  basePlotModule: __webpack_require__(83260),
  categories: ['noOpacity'],
  meta: {}
};

/***/ }),

/***/ 27219:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var interpolateNumber = (__webpack_require__(88640)/* .interpolateNumber */ .Dj);
var Plotly = __webpack_require__(31420);
var Fx = __webpack_require__(32141);
var Lib = __webpack_require__(34809);
var strTranslate = Lib.strTranslate;
var Drawing = __webpack_require__(62203);
var tinycolor = __webpack_require__(65657);
var svgTextUtils = __webpack_require__(30635);
function performPlot(parcatsModels, graphDiv, layout, svg) {
  var isStatic = graphDiv._context.staticPlot;
  var viewModels = parcatsModels.map(createParcatsViewModel.bind(0, graphDiv, layout));

  // Get (potentially empty) parcatslayer selection with bound data to single element array
  var layerSelection = svg.selectAll('g.parcatslayer').data([null]);

  // Initialize single parcatslayer group if it doesn't exist
  layerSelection.enter().append('g').attr('class', 'parcatslayer').style('pointer-events', isStatic ? 'none' : 'all');

  // Bind data to children of layerSelection and get reference to traceSelection
  var traceSelection = layerSelection.selectAll('g.trace.parcats').data(viewModels, key);

  // Initialize group for each trace/dimensions
  var traceEnter = traceSelection.enter().append('g').attr('class', 'trace parcats');

  // Update properties for each trace
  traceSelection.attr('transform', function (d) {
    return strTranslate(d.x, d.y);
  });

  // Initialize paths group
  traceEnter.append('g').attr('class', 'paths');

  // Update paths transform
  var pathsSelection = traceSelection.select('g.paths');

  // Get paths selection
  var pathSelection = pathsSelection.selectAll('path.path').data(function (d) {
    return d.paths;
  }, key);

  // Update existing path colors
  pathSelection.attr('fill', function (d) {
    return d.model.color;
  });

  // Create paths
  var pathSelectionEnter = pathSelection.enter().append('path').attr('class', 'path').attr('stroke-opacity', 0).attr('fill', function (d) {
    return d.model.color;
  }).attr('fill-opacity', 0);
  stylePathsNoHover(pathSelectionEnter);

  // Set path geometry
  pathSelection.attr('d', function (d) {
    return d.svgD;
  });

  // sort paths
  if (!pathSelectionEnter.empty()) {
    // Only sort paths if there has been a change.
    // Otherwise paths are already sorted or a hover operation may be in progress
    pathSelection.sort(compareRawColor);
  }

  // Remove any old paths
  pathSelection.exit().remove();

  // Path hover
  pathSelection.on('mouseover', mouseoverPath).on('mouseout', mouseoutPath).on('click', clickPath);

  // Initialize dimensions group
  traceEnter.append('g').attr('class', 'dimensions');

  // Update dimensions transform
  var dimensionsSelection = traceSelection.select('g.dimensions');

  // Get dimension selection
  var dimensionSelection = dimensionsSelection.selectAll('g.dimension').data(function (d) {
    return d.dimensions;
  }, key);

  // Create dimension groups
  dimensionSelection.enter().append('g').attr('class', 'dimension');

  // Update dimension group transforms
  dimensionSelection.attr('transform', function (d) {
    return strTranslate(d.x, 0);
  });

  // Remove any old dimensions
  dimensionSelection.exit().remove();

  // Get category selection
  var categorySelection = dimensionSelection.selectAll('g.category').data(function (d) {
    return d.categories;
  }, key);

  // Initialize category groups
  var categoryGroupEnterSelection = categorySelection.enter().append('g').attr('class', 'category');

  // Update category transforms
  categorySelection.attr('transform', function (d) {
    return strTranslate(0, d.y);
  });

  // Initialize rectangle
  categoryGroupEnterSelection.append('rect').attr('class', 'catrect').attr('pointer-events', 'none');

  // Update rectangle
  categorySelection.select('rect.catrect').attr('fill', 'none').attr('width', function (d) {
    return d.width;
  }).attr('height', function (d) {
    return d.height;
  });
  styleCategoriesNoHover(categoryGroupEnterSelection);

  // Initialize color band rects
  var bandSelection = categorySelection.selectAll('rect.bandrect').data( /** @param {CategoryViewModel} catViewModel*/
  function (catViewModel) {
    return catViewModel.bands;
  }, key);

  // Raise all update bands to the top so that fading enter/exit bands will be behind
  bandSelection.each(function () {
    Lib.raiseToTop(this);
  });

  // Update band color
  bandSelection.attr('fill', function (d) {
    return d.color;
  });
  var bandsSelectionEnter = bandSelection.enter().append('rect').attr('class', 'bandrect').attr('stroke-opacity', 0).attr('fill', function (d) {
    return d.color;
  }).attr('fill-opacity', 0);
  bandSelection.attr('fill', function (d) {
    return d.color;
  }).attr('width', function (d) {
    return d.width;
  }).attr('height', function (d) {
    return d.height;
  }).attr('y', function (d) {
    return d.y;
  }).attr('cursor', /** @param {CategoryBandViewModel} bandModel*/
  function (bandModel) {
    if (bandModel.parcatsViewModel.arrangement === 'fixed') {
      return 'default';
    } else if (bandModel.parcatsViewModel.arrangement === 'perpendicular') {
      return 'ns-resize';
    } else {
      return 'move';
    }
  });
  styleBandsNoHover(bandsSelectionEnter);
  bandSelection.exit().remove();

  // Initialize category label
  categoryGroupEnterSelection.append('text').attr('class', 'catlabel').attr('pointer-events', 'none');

  // Update category label
  categorySelection.select('text.catlabel').attr('text-anchor', function (d) {
    if (catInRightDim(d)) {
      // Place label to the right of category
      return 'start';
    } else {
      // Place label to the left of category
      return 'end';
    }
  }).attr('alignment-baseline', 'middle').style('fill', 'rgb(0, 0, 0)').attr('x', function (d) {
    if (catInRightDim(d)) {
      // Place label to the right of category
      return d.width + 5;
    } else {
      // Place label to the left of category
      return -5;
    }
  }).attr('y', function (d) {
    return d.height / 2;
  }).text(function (d) {
    return d.model.categoryLabel;
  }).each( /** @param {CategoryViewModel} catModel*/
  function (catModel) {
    Drawing.font(d3.select(this), catModel.parcatsViewModel.categorylabelfont);
    svgTextUtils.convertToTspans(d3.select(this), graphDiv);
  });

  // Initialize dimension label
  categoryGroupEnterSelection.append('text').attr('class', 'dimlabel');

  // Update dimension label
  categorySelection.select('text.dimlabel').attr('text-anchor', 'middle').attr('alignment-baseline', 'baseline').attr('cursor', /** @param {CategoryViewModel} catModel*/
  function (catModel) {
    if (catModel.parcatsViewModel.arrangement === 'fixed') {
      return 'default';
    } else {
      return 'ew-resize';
    }
  }).attr('x', function (d) {
    return d.width / 2;
  }).attr('y', -5).text(function (d, i) {
    if (i === 0) {
      // Add dimension label above topmost category
      return d.parcatsViewModel.model.dimensions[d.model.dimensionInd].dimensionLabel;
    } else {
      return null;
    }
  }).each( /** @param {CategoryViewModel} catModel*/
  function (catModel) {
    Drawing.font(d3.select(this), catModel.parcatsViewModel.labelfont);
  });

  // Category hover
  // categorySelection.select('rect.catrect')
  categorySelection.selectAll('rect.bandrect').on('mouseover', mouseoverCategoryBand).on('mouseout', mouseoutCategory);

  // Remove unused categories
  categorySelection.exit().remove();

  // Setup drag
  dimensionSelection.call(d3.behavior.drag().origin(function (d) {
    return {
      x: d.x,
      y: 0
    };
  }).on('dragstart', dragDimensionStart).on('drag', dragDimension).on('dragend', dragDimensionEnd));

  // Save off selections to view models
  traceSelection.each(function (d) {
    d.traceSelection = d3.select(this);
    d.pathSelection = d3.select(this).selectAll('g.paths').selectAll('path.path');
    d.dimensionSelection = d3.select(this).selectAll('g.dimensions').selectAll('g.dimension');
  });

  // Remove any orphan traces
  traceSelection.exit().remove();
}

/**
 * Create / update parcat traces
 *
 * @param {Object} graphDiv
 * @param {Object} svg
 * @param {Array.<ParcatsModel>} parcatsModels
 * @param {Layout} layout
 */
module.exports = function (graphDiv, svg, parcatsModels, layout) {
  performPlot(parcatsModels, graphDiv, layout, svg);
};

/**
 * Function the returns the key property of an object for use with as D3 join function
 * @param d
 */
function key(d) {
  return d.key;
}

/** True if a category view model is in the right-most display dimension
 * @param {CategoryViewModel} d */
function catInRightDim(d) {
  var numDims = d.parcatsViewModel.dimensions.length;
  var leftDimInd = d.parcatsViewModel.dimensions[numDims - 1].model.dimensionInd;
  return d.model.dimensionInd === leftDimInd;
}

/**
 * @param {PathViewModel} a
 * @param {PathViewModel} b
 */
function compareRawColor(a, b) {
  if (a.model.rawColor > b.model.rawColor) {
    return 1;
  } else if (a.model.rawColor < b.model.rawColor) {
    return -1;
  } else {
    return 0;
  }
}

/**
 * Handle path mouseover
 * @param {PathViewModel} d
 */
function mouseoverPath(d) {
  if (!d.parcatsViewModel.dragDimension) {
    // We're not currently dragging

    if (d.parcatsViewModel.hoverinfoItems.indexOf('skip') === -1) {
      // hoverinfo is not skip, so we at least style the paths and emit interaction events

      // Raise path to top
      Lib.raiseToTop(this);
      stylePathsHover(d3.select(this));

      // Emit hover event
      var points = buildPointsArrayForPath(d);
      var constraints = buildConstraintsForPath(d);
      d.parcatsViewModel.graphDiv.emit('plotly_hover', {
        points: points,
        event: d3.event,
        constraints: constraints
      });

      // Handle hover label
      if (d.parcatsViewModel.hoverinfoItems.indexOf('none') === -1) {
        // hoverinfo is a combination of 'count' and 'probability'

        // Mouse
        var hoverX = d3.mouse(this)[0];

        // Label
        var gd = d.parcatsViewModel.graphDiv;
        var trace = d.parcatsViewModel.trace;
        var fullLayout = gd._fullLayout;
        var rootBBox = fullLayout._paperdiv.node().getBoundingClientRect();
        var graphDivBBox = d.parcatsViewModel.graphDiv.getBoundingClientRect();

        // Find path center in path coordinates
        var pathCenterX, pathCenterY, dimInd;
        for (dimInd = 0; dimInd < d.leftXs.length - 1; dimInd++) {
          if (d.leftXs[dimInd] + d.dimWidths[dimInd] - 2 <= hoverX && hoverX <= d.leftXs[dimInd + 1] + 2) {
            var leftDim = d.parcatsViewModel.dimensions[dimInd];
            var rightDim = d.parcatsViewModel.dimensions[dimInd + 1];
            pathCenterX = (leftDim.x + leftDim.width + rightDim.x) / 2;
            pathCenterY = (d.topYs[dimInd] + d.topYs[dimInd + 1] + d.height) / 2;
            break;
          }
        }

        // Find path center in root coordinates
        var hoverCenterX = d.parcatsViewModel.x + pathCenterX;
        var hoverCenterY = d.parcatsViewModel.y + pathCenterY;
        var textColor = tinycolor.mostReadable(d.model.color, ['black', 'white']);
        var count = d.model.count;
        var prob = count / d.parcatsViewModel.model.count;
        var labels = {
          countLabel: count,
          probabilityLabel: prob.toFixed(3)
        };

        // Build hover text
        var hovertextParts = [];
        if (d.parcatsViewModel.hoverinfoItems.indexOf('count') !== -1) {
          hovertextParts.push(['Count:', labels.countLabel].join(' '));
        }
        if (d.parcatsViewModel.hoverinfoItems.indexOf('probability') !== -1) {
          hovertextParts.push(['P:', labels.probabilityLabel].join(' '));
        }
        var hovertext = hovertextParts.join('<br>');
        var mouseX = d3.mouse(gd)[0];
        Fx.loneHover({
          trace: trace,
          x: hoverCenterX - rootBBox.left + graphDivBBox.left,
          y: hoverCenterY - rootBBox.top + graphDivBBox.top,
          text: hovertext,
          color: d.model.color,
          borderColor: 'black',
          fontFamily: 'Monaco, "Courier New", monospace',
          fontSize: 10,
          fontColor: textColor,
          idealAlign: mouseX < hoverCenterX ? 'right' : 'left',
          hovertemplate: (trace.line || {}).hovertemplate,
          hovertemplateLabels: labels,
          eventData: [{
            data: trace._input,
            fullData: trace,
            count: count,
            probability: prob
          }]
        }, {
          container: fullLayout._hoverlayer.node(),
          outerContainer: fullLayout._paper.node(),
          gd: gd
        });
      }
    }
  }
}

/**
 * Handle path mouseout
 * @param {PathViewModel} d
 */
function mouseoutPath(d) {
  if (!d.parcatsViewModel.dragDimension) {
    // We're not currently dragging
    stylePathsNoHover(d3.select(this));

    // Remove and hover label
    Fx.loneUnhover(d.parcatsViewModel.graphDiv._fullLayout._hoverlayer.node());

    // Restore path order
    d.parcatsViewModel.pathSelection.sort(compareRawColor);

    // Emit unhover event
    if (d.parcatsViewModel.hoverinfoItems.indexOf('skip') === -1) {
      var points = buildPointsArrayForPath(d);
      var constraints = buildConstraintsForPath(d);
      d.parcatsViewModel.graphDiv.emit('plotly_unhover', {
        points: points,
        event: d3.event,
        constraints: constraints
      });
    }
  }
}

/**
 * Build array of point objects for a path
 *
 * For use in click/hover events
 * @param {PathViewModel} d
 */
function buildPointsArrayForPath(d) {
  var points = [];
  var curveNumber = getTraceIndex(d.parcatsViewModel);
  for (var i = 0; i < d.model.valueInds.length; i++) {
    var pointNumber = d.model.valueInds[i];
    points.push({
      curveNumber: curveNumber,
      pointNumber: pointNumber
    });
  }
  return points;
}

/**
 * Build constraints object for a path
 *
 * For use in click/hover events
 * @param {PathViewModel} d
 */
function buildConstraintsForPath(d) {
  var constraints = {};
  var dimensions = d.parcatsViewModel.model.dimensions;

  // dimensions
  for (var i = 0; i < dimensions.length; i++) {
    var dimension = dimensions[i];
    var category = dimension.categories[d.model.categoryInds[i]];
    constraints[dimension.containerInd] = category.categoryValue;
  }

  // color
  if (d.model.rawColor !== undefined) {
    constraints.color = d.model.rawColor;
  }
  return constraints;
}

/**
 * Handle path click
 * @param {PathViewModel} d
 */
function clickPath(d) {
  if (d.parcatsViewModel.hoverinfoItems.indexOf('skip') === -1) {
    // hoverinfo it's skip, so interaction events aren't disabled
    var points = buildPointsArrayForPath(d);
    var constraints = buildConstraintsForPath(d);
    d.parcatsViewModel.graphDiv.emit('plotly_click', {
      points: points,
      event: d3.event,
      constraints: constraints
    });
  }
}
function stylePathsNoHover(pathSelection) {
  pathSelection.attr('fill', function (d) {
    return d.model.color;
  }).attr('fill-opacity', 0.6).attr('stroke', 'lightgray').attr('stroke-width', 0.2).attr('stroke-opacity', 1.0);
}
function stylePathsHover(pathSelection) {
  pathSelection.attr('fill-opacity', 0.8).attr('stroke', function (d) {
    return tinycolor.mostReadable(d.model.color, ['black', 'white']);
  }).attr('stroke-width', 0.3);
}
function styleCategoryHover(categorySelection) {
  categorySelection.select('rect.catrect').attr('stroke', 'black').attr('stroke-width', 2.5);
}
function styleCategoriesNoHover(categorySelection) {
  categorySelection.select('rect.catrect').attr('stroke', 'black').attr('stroke-width', 1).attr('stroke-opacity', 1);
}
function styleBandsHover(bandsSelection) {
  bandsSelection.attr('stroke', 'black').attr('stroke-width', 1.5);
}
function styleBandsNoHover(bandsSelection) {
  bandsSelection.attr('stroke', 'black').attr('stroke-width', 0.2).attr('stroke-opacity', 1.0).attr('fill-opacity', 1.0);
}

/**
 * Return selection of all paths that pass through the specified category
 * @param {CategoryBandViewModel} catBandViewModel
 */
function selectPathsThroughCategoryBandColor(catBandViewModel) {
  var allPaths = catBandViewModel.parcatsViewModel.pathSelection;
  var dimInd = catBandViewModel.categoryViewModel.model.dimensionInd;
  var catInd = catBandViewModel.categoryViewModel.model.categoryInd;
  return allPaths.filter( /** @param {PathViewModel} pathViewModel */
  function (pathViewModel) {
    return pathViewModel.model.categoryInds[dimInd] === catInd && pathViewModel.model.color === catBandViewModel.color;
  });
}

/**
 * Perform hover styling for all paths that pass though the specified band element's category
 *
 * @param {HTMLElement} bandElement
 *  HTML element for band
 *
 */
function styleForCategoryHovermode(bandElement) {
  // Get all bands in the current category
  var bandSel = d3.select(bandElement.parentNode).selectAll('rect.bandrect');

  // Raise and style paths
  bandSel.each(function (bvm) {
    var paths = selectPathsThroughCategoryBandColor(bvm);
    stylePathsHover(paths);
    paths.each(function () {
      // Raise path to top
      Lib.raiseToTop(this);
    });
  });

  // Style category
  styleCategoryHover(d3.select(bandElement.parentNode));
}

/**
 * Perform hover styling for all paths that pass though the category of the specified band element and share the
 * same color
 *
 * @param {HTMLElement} bandElement
 *  HTML element for band
 *
 */
function styleForColorHovermode(bandElement) {
  var bandViewModel = d3.select(bandElement).datum();
  var catPaths = selectPathsThroughCategoryBandColor(bandViewModel);
  stylePathsHover(catPaths);
  catPaths.each(function () {
    // Raise path to top
    Lib.raiseToTop(this);
  });

  // Style category for drag
  d3.select(bandElement.parentNode).selectAll('rect.bandrect').filter(function (b) {
    return b.color === bandViewModel.color;
  }).each(function () {
    Lib.raiseToTop(this);
    styleBandsHover(d3.select(this));
  });
}

/**
 * @param {HTMLElement} bandElement
 *  HTML element for band
 * @param eventName
 *  Event name (plotly_hover or plotly_click)
 * @param event
 *  Mouse Event
 */
function emitPointsEventCategoryHovermode(bandElement, eventName, event) {
  // Get all bands in the current category
  var bandViewModel = d3.select(bandElement).datum();
  var categoryModel = bandViewModel.categoryViewModel.model;
  var gd = bandViewModel.parcatsViewModel.graphDiv;
  var bandSel = d3.select(bandElement.parentNode).selectAll('rect.bandrect');
  var points = [];
  bandSel.each(function (bvm) {
    var paths = selectPathsThroughCategoryBandColor(bvm);
    paths.each(function (pathViewModel) {
      // Extend points array
      Array.prototype.push.apply(points, buildPointsArrayForPath(pathViewModel));
    });
  });
  var constraints = {};
  constraints[categoryModel.dimensionInd] = categoryModel.categoryValue;
  gd.emit(eventName, {
    points: points,
    event: event,
    constraints: constraints
  });
}

/**
 * @param {HTMLElement} bandElement
 *  HTML element for band
 * @param eventName
 *  Event name (plotly_hover or plotly_click)
 * @param event
 *  Mouse Event
 */
function emitPointsEventColorHovermode(bandElement, eventName, event) {
  var bandViewModel = d3.select(bandElement).datum();
  var categoryModel = bandViewModel.categoryViewModel.model;
  var gd = bandViewModel.parcatsViewModel.graphDiv;
  var paths = selectPathsThroughCategoryBandColor(bandViewModel);
  var points = [];
  paths.each(function (pathViewModel) {
    // Extend points array
    Array.prototype.push.apply(points, buildPointsArrayForPath(pathViewModel));
  });
  var constraints = {};
  constraints[categoryModel.dimensionInd] = categoryModel.categoryValue;
  // color
  if (bandViewModel.rawColor !== undefined) {
    constraints.color = bandViewModel.rawColor;
  }
  gd.emit(eventName, {
    points: points,
    event: event,
    constraints: constraints
  });
}

/**
 * Create hover label for a band element's category (for use when hoveron === 'category')
 *
 * @param {ClientRect} rootBBox
 *  Client bounding box for root of figure
 * @param {HTMLElement} bandElement
 *  HTML element for band
 *
 */
function createHoverLabelForCategoryHovermode(gd, rootBBox, bandElement) {
  gd._fullLayout._calcInverseTransform(gd);
  var scaleX = gd._fullLayout._invScaleX;
  var scaleY = gd._fullLayout._invScaleY;

  // Selections
  var rectSelection = d3.select(bandElement.parentNode).select('rect.catrect');
  var rectBoundingBox = rectSelection.node().getBoundingClientRect();

  // Models
  /** @type {CategoryViewModel} */
  var catViewModel = rectSelection.datum();
  var parcatsViewModel = catViewModel.parcatsViewModel;
  var dimensionModel = parcatsViewModel.model.dimensions[catViewModel.model.dimensionInd];
  var trace = parcatsViewModel.trace;

  // Positions
  var hoverCenterY = rectBoundingBox.top + rectBoundingBox.height / 2;
  var hoverCenterX, hoverLabelIdealAlign;
  if (parcatsViewModel.dimensions.length > 1 && dimensionModel.displayInd === parcatsViewModel.dimensions.length - 1) {
    // right most dimension
    hoverCenterX = rectBoundingBox.left;
    hoverLabelIdealAlign = 'left';
  } else {
    hoverCenterX = rectBoundingBox.left + rectBoundingBox.width;
    hoverLabelIdealAlign = 'right';
  }
  var count = catViewModel.model.count;
  var catLabel = catViewModel.model.categoryLabel;
  var prob = count / catViewModel.parcatsViewModel.model.count;
  var labels = {
    countLabel: count,
    categoryLabel: catLabel,
    probabilityLabel: prob.toFixed(3)
  };

  // Hover label text
  var hoverinfoParts = [];
  if (catViewModel.parcatsViewModel.hoverinfoItems.indexOf('count') !== -1) {
    hoverinfoParts.push(['Count:', labels.countLabel].join(' '));
  }
  if (catViewModel.parcatsViewModel.hoverinfoItems.indexOf('probability') !== -1) {
    hoverinfoParts.push(['P(' + labels.categoryLabel + '):', labels.probabilityLabel].join(' '));
  }
  var hovertext = hoverinfoParts.join('<br>');
  return {
    trace: trace,
    x: scaleX * (hoverCenterX - rootBBox.left),
    y: scaleY * (hoverCenterY - rootBBox.top),
    text: hovertext,
    color: 'lightgray',
    borderColor: 'black',
    fontFamily: 'Monaco, "Courier New", monospace',
    fontSize: 12,
    fontColor: 'black',
    idealAlign: hoverLabelIdealAlign,
    hovertemplate: trace.hovertemplate,
    hovertemplateLabels: labels,
    eventData: [{
      data: trace._input,
      fullData: trace,
      count: count,
      category: catLabel,
      probability: prob
    }]
  };
}

/**
 * Create hover label for a band element's category (for use when hoveron === 'category')
 *
 * @param {ClientRect} rootBBox
 *  Client bounding box for root of figure
 * @param {HTMLElement} bandElement
 *  HTML element for band
 *
 */
function createHoverLabelForDimensionHovermode(gd, rootBBox, bandElement) {
  var allHoverlabels = [];
  d3.select(bandElement.parentNode.parentNode).selectAll('g.category').select('rect.catrect').each(function () {
    var bandNode = this;
    allHoverlabels.push(createHoverLabelForCategoryHovermode(gd, rootBBox, bandNode));
  });
  return allHoverlabels;
}

/**
 * Create hover labels for a band element's category (for use when hoveron === 'dimension')
 *
 * @param {ClientRect} rootBBox
 *  Client bounding box for root of figure
 * @param {HTMLElement} bandElement
 *  HTML element for band
 *
 */
function createHoverLabelForColorHovermode(gd, rootBBox, bandElement) {
  gd._fullLayout._calcInverseTransform(gd);
  var scaleX = gd._fullLayout._invScaleX;
  var scaleY = gd._fullLayout._invScaleY;
  var bandBoundingBox = bandElement.getBoundingClientRect();

  // Models
  /** @type {CategoryBandViewModel} */
  var bandViewModel = d3.select(bandElement).datum();
  var catViewModel = bandViewModel.categoryViewModel;
  var parcatsViewModel = catViewModel.parcatsViewModel;
  var dimensionModel = parcatsViewModel.model.dimensions[catViewModel.model.dimensionInd];
  var trace = parcatsViewModel.trace;

  // positions
  var hoverCenterY = bandBoundingBox.y + bandBoundingBox.height / 2;
  var hoverCenterX, hoverLabelIdealAlign;
  if (parcatsViewModel.dimensions.length > 1 && dimensionModel.displayInd === parcatsViewModel.dimensions.length - 1) {
    // right most dimension
    hoverCenterX = bandBoundingBox.left;
    hoverLabelIdealAlign = 'left';
  } else {
    hoverCenterX = bandBoundingBox.left + bandBoundingBox.width;
    hoverLabelIdealAlign = 'right';
  }

  // Labels
  var catLabel = catViewModel.model.categoryLabel;

  // Counts
  var totalCount = bandViewModel.parcatsViewModel.model.count;
  var bandColorCount = 0;
  bandViewModel.categoryViewModel.bands.forEach(function (b) {
    if (b.color === bandViewModel.color) {
      bandColorCount += b.count;
    }
  });
  var catCount = catViewModel.model.count;
  var colorCount = 0;
  parcatsViewModel.pathSelection.each( /** @param {PathViewModel} pathViewModel */
  function (pathViewModel) {
    if (pathViewModel.model.color === bandViewModel.color) {
      colorCount += pathViewModel.model.count;
    }
  });
  var pColorAndCat = bandColorCount / totalCount;
  var pCatGivenColor = bandColorCount / colorCount;
  var pColorGivenCat = bandColorCount / catCount;
  var labels = {
    countLabel: bandColorCount,
    categoryLabel: catLabel,
    probabilityLabel: pColorAndCat.toFixed(3)
  };

  // Hover label text
  var hoverinfoParts = [];
  if (catViewModel.parcatsViewModel.hoverinfoItems.indexOf('count') !== -1) {
    hoverinfoParts.push(['Count:', labels.countLabel].join(' '));
  }
  if (catViewModel.parcatsViewModel.hoverinfoItems.indexOf('probability') !== -1) {
    hoverinfoParts.push('P(color ∩ ' + catLabel + '): ' + labels.probabilityLabel);
    hoverinfoParts.push('P(' + catLabel + ' | color): ' + pCatGivenColor.toFixed(3));
    hoverinfoParts.push('P(color | ' + catLabel + '): ' + pColorGivenCat.toFixed(3));
  }
  var hovertext = hoverinfoParts.join('<br>');

  // Compute text color
  var textColor = tinycolor.mostReadable(bandViewModel.color, ['black', 'white']);
  return {
    trace: trace,
    x: scaleX * (hoverCenterX - rootBBox.left),
    y: scaleY * (hoverCenterY - rootBBox.top),
    // name: 'NAME',
    text: hovertext,
    color: bandViewModel.color,
    borderColor: 'black',
    fontFamily: 'Monaco, "Courier New", monospace',
    fontColor: textColor,
    fontSize: 10,
    idealAlign: hoverLabelIdealAlign,
    hovertemplate: trace.hovertemplate,
    hovertemplateLabels: labels,
    eventData: [{
      data: trace._input,
      fullData: trace,
      category: catLabel,
      count: totalCount,
      probability: pColorAndCat,
      categorycount: catCount,
      colorcount: colorCount,
      bandcolorcount: bandColorCount
    }]
  };
}

/**
 * Handle dimension mouseover
 * @param {CategoryBandViewModel} bandViewModel
 */
function mouseoverCategoryBand(bandViewModel) {
  if (!bandViewModel.parcatsViewModel.dragDimension) {
    // We're not currently dragging

    if (bandViewModel.parcatsViewModel.hoverinfoItems.indexOf('skip') === -1) {
      // hoverinfo is not skip, so we at least style the bands and emit interaction events

      // Mouse
      var mouseY = d3.mouse(this)[1];
      if (mouseY < -1) {
        // Hover is above above the category rectangle (probably the dimension title text)
        return;
      }
      var gd = bandViewModel.parcatsViewModel.graphDiv;
      var fullLayout = gd._fullLayout;
      var rootBBox = fullLayout._paperdiv.node().getBoundingClientRect();
      var hoveron = bandViewModel.parcatsViewModel.hoveron;

      /** @type {HTMLElement} */
      var bandElement = this;

      // Handle style and events
      if (hoveron === 'color') {
        styleForColorHovermode(bandElement);
        emitPointsEventColorHovermode(bandElement, 'plotly_hover', d3.event);
      } else {
        styleForCategoryHovermode(bandElement);
        emitPointsEventCategoryHovermode(bandElement, 'plotly_hover', d3.event);
      }

      // Handle hover label
      if (bandViewModel.parcatsViewModel.hoverinfoItems.indexOf('none') === -1) {
        var hoverItems;
        if (hoveron === 'category') {
          hoverItems = createHoverLabelForCategoryHovermode(gd, rootBBox, bandElement);
        } else if (hoveron === 'color') {
          hoverItems = createHoverLabelForColorHovermode(gd, rootBBox, bandElement);
        } else if (hoveron === 'dimension') {
          hoverItems = createHoverLabelForDimensionHovermode(gd, rootBBox, bandElement);
        }
        if (hoverItems) {
          Fx.loneHover(hoverItems, {
            container: fullLayout._hoverlayer.node(),
            outerContainer: fullLayout._paper.node(),
            gd: gd
          });
        }
      }
    }
  }
}

/**
 * Handle dimension mouseover
 * @param {CategoryBandViewModel} bandViewModel
 */
function mouseoutCategory(bandViewModel) {
  var parcatsViewModel = bandViewModel.parcatsViewModel;
  if (!parcatsViewModel.dragDimension) {
    // We're not dragging anything

    // Reset unhovered styles
    stylePathsNoHover(parcatsViewModel.pathSelection);
    styleCategoriesNoHover(parcatsViewModel.dimensionSelection.selectAll('g.category'));
    styleBandsNoHover(parcatsViewModel.dimensionSelection.selectAll('g.category').selectAll('rect.bandrect'));

    // Remove hover label
    Fx.loneUnhover(parcatsViewModel.graphDiv._fullLayout._hoverlayer.node());

    // Restore path order
    parcatsViewModel.pathSelection.sort(compareRawColor);

    // Emit unhover event
    if (parcatsViewModel.hoverinfoItems.indexOf('skip') === -1) {
      var hoveron = bandViewModel.parcatsViewModel.hoveron;
      var bandElement = this;

      // Handle style and events
      if (hoveron === 'color') {
        emitPointsEventColorHovermode(bandElement, 'plotly_unhover', d3.event);
      } else {
        emitPointsEventCategoryHovermode(bandElement, 'plotly_unhover', d3.event);
      }
    }
  }
}

/**
 * Handle dimension drag start
 * @param {DimensionViewModel} d
 */
function dragDimensionStart(d) {
  // Check if dragging is supported
  if (d.parcatsViewModel.arrangement === 'fixed') {
    return;
  }

  // Save off initial drag indexes for dimension
  d.dragDimensionDisplayInd = d.model.displayInd;
  d.initialDragDimensionDisplayInds = d.parcatsViewModel.model.dimensions.map(function (d) {
    return d.displayInd;
  });
  d.dragHasMoved = false;

  // Check for category hit
  d.dragCategoryDisplayInd = null;
  d3.select(this).selectAll('g.category').select('rect.catrect').each( /** @param {CategoryViewModel} catViewModel */
  function (catViewModel) {
    var catMouseX = d3.mouse(this)[0];
    var catMouseY = d3.mouse(this)[1];
    if (-2 <= catMouseX && catMouseX <= catViewModel.width + 2 && -2 <= catMouseY && catMouseY <= catViewModel.height + 2) {
      // Save off initial drag indexes for categories
      d.dragCategoryDisplayInd = catViewModel.model.displayInd;
      d.initialDragCategoryDisplayInds = d.model.categories.map(function (c) {
        return c.displayInd;
      });

      // Initialize categories dragY to be the current y position
      catViewModel.model.dragY = catViewModel.y;

      // Raise category
      Lib.raiseToTop(this.parentNode);

      // Get band element
      d3.select(this.parentNode).selectAll('rect.bandrect')
      /** @param {CategoryBandViewModel} bandViewModel */.each(function (bandViewModel) {
        if (bandViewModel.y < catMouseY && catMouseY <= bandViewModel.y + bandViewModel.height) {
          d.potentialClickBand = this;
        }
      });
    }
  });

  // Update toplevel drag dimension
  d.parcatsViewModel.dragDimension = d;

  // Remove hover label if any
  Fx.loneUnhover(d.parcatsViewModel.graphDiv._fullLayout._hoverlayer.node());
}

/**
 * Handle dimension drag
 * @param {DimensionViewModel} d
 */
function dragDimension(d) {
  // Check if dragging is supported
  if (d.parcatsViewModel.arrangement === 'fixed') {
    return;
  }
  d.dragHasMoved = true;
  if (d.dragDimensionDisplayInd === null) {
    return;
  }
  var dragDimInd = d.dragDimensionDisplayInd;
  var prevDimInd = dragDimInd - 1;
  var nextDimInd = dragDimInd + 1;
  var dragDimension = d.parcatsViewModel.dimensions[dragDimInd];

  // Update category
  if (d.dragCategoryDisplayInd !== null) {
    var dragCategory = dragDimension.categories[d.dragCategoryDisplayInd];

    // Update dragY by dy
    dragCategory.model.dragY += d3.event.dy;
    var categoryY = dragCategory.model.dragY;

    // Check for category drag swaps
    var catDisplayInd = dragCategory.model.displayInd;
    var dimCategoryViews = dragDimension.categories;
    var catAbove = dimCategoryViews[catDisplayInd - 1];
    var catBelow = dimCategoryViews[catDisplayInd + 1];

    // Check for overlap above
    if (catAbove !== undefined) {
      if (categoryY < catAbove.y + catAbove.height / 2.0) {
        // Swap display inds
        dragCategory.model.displayInd = catAbove.model.displayInd;
        catAbove.model.displayInd = catDisplayInd;
      }
    }
    if (catBelow !== undefined) {
      if (categoryY + dragCategory.height > catBelow.y + catBelow.height / 2.0) {
        // Swap display inds
        dragCategory.model.displayInd = catBelow.model.displayInd;
        catBelow.model.displayInd = catDisplayInd;
      }
    }

    // Update category drag display index
    d.dragCategoryDisplayInd = dragCategory.model.displayInd;
  }

  // Update dimension position
  if (d.dragCategoryDisplayInd === null || d.parcatsViewModel.arrangement === 'freeform') {
    dragDimension.model.dragX = d3.event.x;

    // Check for dimension swaps
    var prevDimension = d.parcatsViewModel.dimensions[prevDimInd];
    var nextDimension = d.parcatsViewModel.dimensions[nextDimInd];
    if (prevDimension !== undefined) {
      if (dragDimension.model.dragX < prevDimension.x + prevDimension.width) {
        // Swap display inds
        dragDimension.model.displayInd = prevDimension.model.displayInd;
        prevDimension.model.displayInd = dragDimInd;
      }
    }
    if (nextDimension !== undefined) {
      if (dragDimension.model.dragX + dragDimension.width > nextDimension.x) {
        // Swap display inds
        dragDimension.model.displayInd = nextDimension.model.displayInd;
        nextDimension.model.displayInd = d.dragDimensionDisplayInd;
      }
    }

    // Update drag display index
    d.dragDimensionDisplayInd = dragDimension.model.displayInd;
  }

  // Update view models
  updateDimensionViewModels(d.parcatsViewModel);
  updatePathViewModels(d.parcatsViewModel);

  // Update svg geometry
  updateSvgCategories(d.parcatsViewModel);
  updateSvgPaths(d.parcatsViewModel);
}

/**
 * Handle dimension drag end
 * @param {DimensionViewModel} d
 */
function dragDimensionEnd(d) {
  // Check if dragging is supported
  if (d.parcatsViewModel.arrangement === 'fixed') {
    return;
  }
  if (d.dragDimensionDisplayInd === null) {
    return;
  }
  d3.select(this).selectAll('text').attr('font-weight', 'normal');

  // Compute restyle command
  // -----------------------
  var restyleData = {};
  var traceInd = getTraceIndex(d.parcatsViewModel);

  // ### Handle dimension reordering ###
  var finalDragDimensionDisplayInds = d.parcatsViewModel.model.dimensions.map(function (d) {
    return d.displayInd;
  });
  var anyDimsReordered = d.initialDragDimensionDisplayInds.some(function (initDimDisplay, dimInd) {
    return initDimDisplay !== finalDragDimensionDisplayInds[dimInd];
  });
  if (anyDimsReordered) {
    finalDragDimensionDisplayInds.forEach(function (finalDimDisplay, dimInd) {
      var containerInd = d.parcatsViewModel.model.dimensions[dimInd].containerInd;
      restyleData['dimensions[' + containerInd + '].displayindex'] = finalDimDisplay;
    });
  }

  // ### Handle category reordering ###
  var anyCatsReordered = false;
  if (d.dragCategoryDisplayInd !== null) {
    var finalDragCategoryDisplayInds = d.model.categories.map(function (c) {
      return c.displayInd;
    });
    anyCatsReordered = d.initialDragCategoryDisplayInds.some(function (initCatDisplay, catInd) {
      return initCatDisplay !== finalDragCategoryDisplayInds[catInd];
    });
    if (anyCatsReordered) {
      // Sort a shallow copy of the category models by display index
      var sortedCategoryModels = d.model.categories.slice().sort(function (a, b) {
        return a.displayInd - b.displayInd;
      });

      // Get new categoryarray and ticktext values
      var newCategoryArray = sortedCategoryModels.map(function (v) {
        return v.categoryValue;
      });
      var newCategoryLabels = sortedCategoryModels.map(function (v) {
        return v.categoryLabel;
      });
      restyleData['dimensions[' + d.model.containerInd + '].categoryarray'] = [newCategoryArray];
      restyleData['dimensions[' + d.model.containerInd + '].ticktext'] = [newCategoryLabels];
      restyleData['dimensions[' + d.model.containerInd + '].categoryorder'] = 'array';
    }
  }

  // Handle potential click event
  // ----------------------------
  if (d.parcatsViewModel.hoverinfoItems.indexOf('skip') === -1) {
    if (!d.dragHasMoved && d.potentialClickBand) {
      if (d.parcatsViewModel.hoveron === 'color') {
        emitPointsEventColorHovermode(d.potentialClickBand, 'plotly_click', d3.event.sourceEvent);
      } else {
        emitPointsEventCategoryHovermode(d.potentialClickBand, 'plotly_click', d3.event.sourceEvent);
      }
    }
  }

  // Nullify drag states
  // -------------------
  d.model.dragX = null;
  if (d.dragCategoryDisplayInd !== null) {
    var dragCategory = d.parcatsViewModel.dimensions[d.dragDimensionDisplayInd].categories[d.dragCategoryDisplayInd];
    dragCategory.model.dragY = null;
    d.dragCategoryDisplayInd = null;
  }
  d.dragDimensionDisplayInd = null;
  d.parcatsViewModel.dragDimension = null;
  d.dragHasMoved = null;
  d.potentialClickBand = null;

  // Update view models
  // ------------------
  updateDimensionViewModels(d.parcatsViewModel);
  updatePathViewModels(d.parcatsViewModel);

  // Perform transition
  // ------------------
  var transition = d3.transition().duration(300).ease('cubic-in-out');
  transition.each(function () {
    updateSvgCategories(d.parcatsViewModel, true);
    updateSvgPaths(d.parcatsViewModel, true);
  }).each('end', function () {
    if (anyDimsReordered || anyCatsReordered) {
      // Perform restyle if the order of categories or dimensions changed
      Plotly.restyle(d.parcatsViewModel.graphDiv, restyleData, [traceInd]);
    }
  });
}

/**
 *
 * @param {ParcatsViewModel} parcatsViewModel
 */
function getTraceIndex(parcatsViewModel) {
  var traceInd;
  var allTraces = parcatsViewModel.graphDiv._fullData;
  for (var i = 0; i < allTraces.length; i++) {
    if (parcatsViewModel.key === allTraces[i].uid) {
      traceInd = i;
      break;
    }
  }
  return traceInd;
}

/** Update the svg paths for view model
 * @param {ParcatsViewModel} parcatsViewModel
 * @param {boolean} hasTransition Whether to update element with transition
 */
function updateSvgPaths(parcatsViewModel, hasTransition) {
  if (hasTransition === undefined) {
    hasTransition = false;
  }
  function transition(selection) {
    return hasTransition ? selection.transition() : selection;
  }

  // Update binding
  parcatsViewModel.pathSelection.data(function (d) {
    return d.paths;
  }, key);

  // Update paths
  transition(parcatsViewModel.pathSelection).attr('d', function (d) {
    return d.svgD;
  });
}

/** Update the svg paths for view model
 * @param {ParcatsViewModel} parcatsViewModel
 * @param {boolean} hasTransition Whether to update element with transition
 */
function updateSvgCategories(parcatsViewModel, hasTransition) {
  if (hasTransition === undefined) {
    hasTransition = false;
  }
  function transition(selection) {
    return hasTransition ? selection.transition() : selection;
  }

  // Update binding
  parcatsViewModel.dimensionSelection.data(function (d) {
    return d.dimensions;
  }, key);
  var categorySelection = parcatsViewModel.dimensionSelection.selectAll('g.category').data(function (d) {
    return d.categories;
  }, key);

  // Update dimension position
  transition(parcatsViewModel.dimensionSelection).attr('transform', function (d) {
    return strTranslate(d.x, 0);
  });

  // Update category position
  transition(categorySelection).attr('transform', function (d) {
    return strTranslate(0, d.y);
  });
  var dimLabelSelection = categorySelection.select('.dimlabel');

  // ### Update dimension label
  // Only the top-most display category should have the dimension label
  dimLabelSelection.text(function (d, i) {
    if (i === 0) {
      // Add dimension label above topmost category
      return d.parcatsViewModel.model.dimensions[d.model.dimensionInd].dimensionLabel;
    } else {
      return null;
    }
  });

  // Update category label
  // Categories in the right-most display dimension have their labels on
  // the right, all others on the left
  var catLabelSelection = categorySelection.select('.catlabel');
  catLabelSelection.attr('text-anchor', function (d) {
    if (catInRightDim(d)) {
      // Place label to the right of category
      return 'start';
    } else {
      // Place label to the left of category
      return 'end';
    }
  }).attr('x', function (d) {
    if (catInRightDim(d)) {
      // Place label to the right of category
      return d.width + 5;
    } else {
      // Place label to the left of category
      return -5;
    }
  }).each(function (d) {
    // Update attriubutes of <tspan> elements
    var newX;
    var newAnchor;
    if (catInRightDim(d)) {
      // Place label to the right of category
      newX = d.width + 5;
      newAnchor = 'start';
    } else {
      // Place label to the left of category
      newX = -5;
      newAnchor = 'end';
    }
    d3.select(this).selectAll('tspan').attr('x', newX).attr('text-anchor', newAnchor);
  });

  // Update bands
  // Initialize color band rects
  var bandSelection = categorySelection.selectAll('rect.bandrect').data( /** @param {CategoryViewModel} catViewModel*/
  function (catViewModel) {
    return catViewModel.bands;
  }, key);
  var bandsSelectionEnter = bandSelection.enter().append('rect').attr('class', 'bandrect').attr('cursor', 'move').attr('stroke-opacity', 0).attr('fill', function (d) {
    return d.color;
  }).attr('fill-opacity', 0);
  bandSelection.attr('fill', function (d) {
    return d.color;
  }).attr('width', function (d) {
    return d.width;
  }).attr('height', function (d) {
    return d.height;
  }).attr('y', function (d) {
    return d.y;
  });
  styleBandsNoHover(bandsSelectionEnter);

  // Raise bands to the top
  bandSelection.each(function () {
    Lib.raiseToTop(this);
  });

  // Remove unused bands
  bandSelection.exit().remove();
}

/**
 * Create a ParcatsViewModel traces
 * @param {Object} graphDiv
 *  Top-level graph div element
 * @param {Layout} layout
 *  SVG layout object
 * @param {Array.<ParcatsModel>} wrappedParcatsModel
 *  Wrapped ParcatsModel for this trace
 * @return {ParcatsViewModel}
 */
function createParcatsViewModel(graphDiv, layout, wrappedParcatsModel) {
  // Unwrap model
  var parcatsModel = wrappedParcatsModel[0];

  // Compute margin
  var margin = layout.margin || {
    l: 80,
    r: 80,
    t: 100,
    b: 80
  };

  // Compute pixel position/extents
  var trace = parcatsModel.trace;
  var domain = trace.domain;
  var figureWidth = layout.width;
  var figureHeight = layout.height;
  var traceWidth = Math.floor(figureWidth * (domain.x[1] - domain.x[0]));
  var traceHeight = Math.floor(figureHeight * (domain.y[1] - domain.y[0]));
  var traceX = domain.x[0] * figureWidth + margin.l;
  var traceY = layout.height - domain.y[1] * layout.height + margin.t;

  // Handle path shape
  // -----------------
  var pathShape = trace.line.shape;

  // Handle hover info
  // -----------------
  var hoverinfoItems;
  if (trace.hoverinfo === 'all') {
    hoverinfoItems = ['count', 'probability'];
  } else {
    hoverinfoItems = (trace.hoverinfo || '').split('+');
  }

  // Construct parcatsViewModel
  // --------------------------
  var parcatsViewModel = {
    trace: trace,
    key: trace.uid,
    model: parcatsModel,
    x: traceX,
    y: traceY,
    width: traceWidth,
    height: traceHeight,
    hoveron: trace.hoveron,
    hoverinfoItems: hoverinfoItems,
    arrangement: trace.arrangement,
    bundlecolors: trace.bundlecolors,
    sortpaths: trace.sortpaths,
    labelfont: trace.labelfont,
    categorylabelfont: trace.tickfont,
    pathShape: pathShape,
    dragDimension: null,
    margin: margin,
    paths: [],
    dimensions: [],
    graphDiv: graphDiv,
    traceSelection: null,
    pathSelection: null,
    dimensionSelection: null
  };

  // Update dimension view models if we have at least 1 dimension
  if (parcatsModel.dimensions) {
    updateDimensionViewModels(parcatsViewModel);

    // Update path view models if we have at least 2 dimensions
    updatePathViewModels(parcatsViewModel);
  }
  // Inside a categories view model
  return parcatsViewModel;
}

/**
 * Build the SVG string to represents a parallel categories path
 * @param {Array.<Number>} leftXPositions
 *  Array of the x positions of the left edge of each dimension (in display order)
 * @param {Array.<Number>} pathYs
 *  Array of the y positions of the top of the path at each dimension (in display order)
 * @param {Array.<Number>} dimWidths
 *  Array of the widths of each dimension in display order
 * @param {Number} pathHeight
 *  The height of the path in pixels
 * @param {Number} curvature
 *  The curvature factor for the path. 0 results in a straight line and values greater than zero result in curved paths
 * @return {string}
 */
function buildSvgPath(leftXPositions, pathYs, dimWidths, pathHeight, curvature) {
  // Compute the x midpoint of each path segment
  var xRefPoints1 = [];
  var xRefPoints2 = [];
  var refInterpolator;
  var d;
  for (d = 0; d < dimWidths.length - 1; d++) {
    refInterpolator = interpolateNumber(dimWidths[d] + leftXPositions[d], leftXPositions[d + 1]);
    xRefPoints1.push(refInterpolator(curvature));
    xRefPoints2.push(refInterpolator(1 - curvature));
  }

  // Move to top of path on left edge of left-most category
  var svgD = 'M ' + leftXPositions[0] + ',' + pathYs[0];

  // Horizontal line to right edge
  svgD += 'l' + dimWidths[0] + ',0 ';

  // Horizontal line to right edge
  for (d = 1; d < dimWidths.length; d++) {
    // Curve to left edge of category
    svgD += 'C' + xRefPoints1[d - 1] + ',' + pathYs[d - 1] + ' ' + xRefPoints2[d - 1] + ',' + pathYs[d] + ' ' + leftXPositions[d] + ',' + pathYs[d];

    // svgD += 'L' + leftXPositions[d] + ',' + pathYs[d];

    // Horizontal line to right edge
    svgD += 'l' + dimWidths[d] + ',0 ';
  }

  // Line down
  svgD += 'l' + '0,' + pathHeight + ' ';

  // Line to left edge of right-most category
  svgD += 'l -' + dimWidths[dimWidths.length - 1] + ',0 ';
  for (d = dimWidths.length - 2; d >= 0; d--) {
    // Curve to right edge of category
    svgD += 'C' + xRefPoints2[d] + ',' + (pathYs[d + 1] + pathHeight) + ' ' + xRefPoints1[d] + ',' + (pathYs[d] + pathHeight) + ' ' + (leftXPositions[d] + dimWidths[d]) + ',' + (pathYs[d] + pathHeight);

    // svgD += 'L' + (leftXPositions[d] + dimWidths[d]) + ',' + (pathYs[d] + pathHeight);

    // Horizontal line to right edge
    svgD += 'l-' + dimWidths[d] + ',0 ';
  }

  // Close path
  svgD += 'Z';
  return svgD;
}

/**
 * Update the path view models based on the dimension view models in a ParcatsViewModel
 *
 * @param {ParcatsViewModel} parcatsViewModel
 *  View model for trace
 */
function updatePathViewModels(parcatsViewModel) {
  // Initialize an array of the y position of the top of the next path to be added to each category.
  //
  // nextYPositions[d][c] is the y position of the next path through category with index c of dimension with index d
  var dimensionViewModels = parcatsViewModel.dimensions;
  var parcatsModel = parcatsViewModel.model;
  var nextYPositions = dimensionViewModels.map(function (d) {
    return d.categories.map(function (c) {
      return c.y;
    });
  });

  // Array from category index to category display index for each true dimension index
  var catToDisplayIndPerDim = parcatsViewModel.model.dimensions.map(function (d) {
    return d.categories.map(function (c) {
      return c.displayInd;
    });
  });

  // Array from true dimension index to dimension display index
  var dimToDisplayInd = parcatsViewModel.model.dimensions.map(function (d) {
    return d.displayInd;
  });
  var displayToDimInd = parcatsViewModel.dimensions.map(function (d) {
    return d.model.dimensionInd;
  });

  // Array of the x position of the left edge of the rectangles for each dimension
  var leftXPositions = dimensionViewModels.map(function (d) {
    return d.x;
  });

  // Compute dimension widths
  var dimWidths = dimensionViewModels.map(function (d) {
    return d.width;
  });

  // Build sorted Array of PathModel objects
  var pathModels = [];
  for (var p in parcatsModel.paths) {
    if (parcatsModel.paths.hasOwnProperty(p)) {
      pathModels.push(parcatsModel.paths[p]);
    }
  }

  // Compute category display inds to use for sorting paths
  function pathDisplayCategoryInds(pathModel) {
    var dimensionInds = pathModel.categoryInds.map(function (catInd, dimInd) {
      return catToDisplayIndPerDim[dimInd][catInd];
    });
    var displayInds = displayToDimInd.map(function (dimInd) {
      return dimensionInds[dimInd];
    });
    return displayInds;
  }

  // Sort in ascending order by display index array
  pathModels.sort(function (v1, v2) {
    // Build display inds for each path
    var sortArray1 = pathDisplayCategoryInds(v1);
    var sortArray2 = pathDisplayCategoryInds(v2);

    // Handle path sort order
    if (parcatsViewModel.sortpaths === 'backward') {
      sortArray1.reverse();
      sortArray2.reverse();
    }

    // Append the first value index of the path to break ties
    sortArray1.push(v1.valueInds[0]);
    sortArray2.push(v2.valueInds[0]);

    // Handle color bundling
    if (parcatsViewModel.bundlecolors) {
      // Prepend sort array with the raw color value
      sortArray1.unshift(v1.rawColor);
      sortArray2.unshift(v2.rawColor);
    }

    // colors equal, sort by display categories
    if (sortArray1 < sortArray2) {
      return -1;
    }
    if (sortArray1 > sortArray2) {
      return 1;
    }
    return 0;
  });

  // Create path models
  var pathViewModels = new Array(pathModels.length);
  var totalCount = dimensionViewModels[0].model.count;
  var totalHeight = dimensionViewModels[0].categories.map(function (c) {
    return c.height;
  }).reduce(function (v1, v2) {
    return v1 + v2;
  });
  for (var pathNumber = 0; pathNumber < pathModels.length; pathNumber++) {
    var pathModel = pathModels[pathNumber];
    var pathHeight;
    if (totalCount > 0) {
      pathHeight = totalHeight * (pathModel.count / totalCount);
    } else {
      pathHeight = 0;
    }

    // Build path y coords
    var pathYs = new Array(nextYPositions.length);
    for (var d = 0; d < pathModel.categoryInds.length; d++) {
      var catInd = pathModel.categoryInds[d];
      var catDisplayInd = catToDisplayIndPerDim[d][catInd];
      var dimDisplayInd = dimToDisplayInd[d];

      // Update next y position
      pathYs[dimDisplayInd] = nextYPositions[dimDisplayInd][catDisplayInd];
      nextYPositions[dimDisplayInd][catDisplayInd] += pathHeight;

      // Update category color information
      var catViewModle = parcatsViewModel.dimensions[dimDisplayInd].categories[catDisplayInd];
      var numBands = catViewModle.bands.length;
      var lastCatBand = catViewModle.bands[numBands - 1];
      if (lastCatBand === undefined || pathModel.rawColor !== lastCatBand.rawColor) {
        // Create a new band
        var bandY = lastCatBand === undefined ? 0 : lastCatBand.y + lastCatBand.height;
        catViewModle.bands.push({
          key: bandY,
          color: pathModel.color,
          rawColor: pathModel.rawColor,
          height: pathHeight,
          width: catViewModle.width,
          count: pathModel.count,
          y: bandY,
          categoryViewModel: catViewModle,
          parcatsViewModel: parcatsViewModel
        });
      } else {
        // Extend current band
        var currentBand = catViewModle.bands[numBands - 1];
        currentBand.height += pathHeight;
        currentBand.count += pathModel.count;
      }
    }

    // build svg path
    var svgD;
    if (parcatsViewModel.pathShape === 'hspline') {
      svgD = buildSvgPath(leftXPositions, pathYs, dimWidths, pathHeight, 0.5);
    } else {
      svgD = buildSvgPath(leftXPositions, pathYs, dimWidths, pathHeight, 0);
    }
    pathViewModels[pathNumber] = {
      key: pathModel.valueInds[0],
      model: pathModel,
      height: pathHeight,
      leftXs: leftXPositions,
      topYs: pathYs,
      dimWidths: dimWidths,
      svgD: svgD,
      parcatsViewModel: parcatsViewModel
    };
  }
  parcatsViewModel.paths = pathViewModels;

  // * @property key
  // *  Unique key for this model
  // * @property {PathModel} model
  // *  Source path model
  // * @property {Number} height
  // *  Height of this path (pixels)
  // * @property {String} svgD
  // *  SVG path "d" attribute string
}

/**
 * Update the dimension view models based on the dimension models in a ParcatsViewModel
 *
 * @param {ParcatsViewModel} parcatsViewModel
 *  View model for trace
 */
function updateDimensionViewModels(parcatsViewModel) {
  // Compute dimension ordering
  var dimensionsIndInfo = parcatsViewModel.model.dimensions.map(function (d) {
    return {
      displayInd: d.displayInd,
      dimensionInd: d.dimensionInd
    };
  });
  dimensionsIndInfo.sort(function (a, b) {
    return a.displayInd - b.displayInd;
  });
  var dimensions = [];
  for (var displayInd in dimensionsIndInfo) {
    var dimensionInd = dimensionsIndInfo[displayInd].dimensionInd;
    var dimModel = parcatsViewModel.model.dimensions[dimensionInd];
    dimensions.push(createDimensionViewModel(parcatsViewModel, dimModel));
  }
  parcatsViewModel.dimensions = dimensions;
}

/**
 * Create a parcats DimensionViewModel
 *
 * @param {ParcatsViewModel} parcatsViewModel
 *  View model for trace
 * @param {DimensionModel} dimensionModel
 * @return {DimensionViewModel}
 */
function createDimensionViewModel(parcatsViewModel, dimensionModel) {
  // Compute dimension x position
  var categoryLabelPad = 40;
  var dimWidth = 16;
  var numDimensions = parcatsViewModel.model.dimensions.length;
  var displayInd = dimensionModel.displayInd;

  // Compute x coordinate values
  var dimDx;
  var dimX0;
  var dimX;
  if (numDimensions > 1) {
    dimDx = (parcatsViewModel.width - 2 * categoryLabelPad - dimWidth) / (numDimensions - 1);
  } else {
    dimDx = 0;
  }
  dimX0 = categoryLabelPad;
  dimX = dimX0 + dimDx * displayInd;

  // Compute categories
  var categories = [];
  var maxCats = parcatsViewModel.model.maxCats;
  var numCats = dimensionModel.categories.length;
  var catSpacing = 8;
  var totalCount = dimensionModel.count;
  var totalHeight = parcatsViewModel.height - catSpacing * (maxCats - 1);
  var nextCatHeight;
  var nextCatModel;
  var nextCat;
  var catInd;
  var catDisplayInd;

  // Compute starting Y offset
  var nextCatY = (maxCats - numCats) * catSpacing / 2.0;

  // Compute category ordering
  var categoryIndInfo = dimensionModel.categories.map(function (c) {
    return {
      displayInd: c.displayInd,
      categoryInd: c.categoryInd
    };
  });
  categoryIndInfo.sort(function (a, b) {
    return a.displayInd - b.displayInd;
  });
  for (catDisplayInd = 0; catDisplayInd < numCats; catDisplayInd++) {
    catInd = categoryIndInfo[catDisplayInd].categoryInd;
    nextCatModel = dimensionModel.categories[catInd];
    if (totalCount > 0) {
      nextCatHeight = nextCatModel.count / totalCount * totalHeight;
    } else {
      nextCatHeight = 0;
    }
    nextCat = {
      key: nextCatModel.valueInds[0],
      model: nextCatModel,
      width: dimWidth,
      height: nextCatHeight,
      y: nextCatModel.dragY !== null ? nextCatModel.dragY : nextCatY,
      bands: [],
      parcatsViewModel: parcatsViewModel
    };
    nextCatY = nextCatY + nextCatHeight + catSpacing;
    categories.push(nextCat);
  }
  return {
    key: dimensionModel.dimensionInd,
    x: dimensionModel.dragX !== null ? dimensionModel.dragX : dimX,
    y: 0,
    width: dimWidth,
    model: dimensionModel,
    categories: categories,
    parcatsViewModel: parcatsViewModel,
    dragCategoryDisplayInd: null,
    dragDimensionDisplayInd: null,
    initialDragDimensionDisplayInds: null,
    initialDragCategoryDisplayInds: null,
    dragHasMoved: null,
    potentialClickBand: null
  };
}

// JSDoc typedefs
// ==============
/**
 * @typedef {Object} Layout
 *  Object containing svg layout information
 *
 * @property {Number} width (pixels)
 *  Usable width for Figure (after margins are removed)
 * @property {Number} height (pixels)
 *  Usable height for Figure (after margins are removed)
 * @property {Margin} margin
 *  Margin around the Figure (pixels)
 */

/**
 * @typedef {Object} Margin
 *  Object containing padding information in pixels
 *
 * @property {Number} t
 *  Top margin
 * @property {Number} r
 *  Right margin
 * @property {Number} b
 *  Bottom margin
 * @property {Number} l
 *  Left margin
 */

/**
 * @typedef {Object} Font
 *  Object containing font information
 *
 * @property {Number} size: Font size
 * @property {String} color: Font color
 * @property {String} family: Font family
 */

/**
 * @typedef {Object} ParcatsViewModel
 *  Object containing calculated parcats view information
 *
 *  These are quantities that require Layout information to calculate
 * @property key
 *  Unique key for this model
 * @property {ParcatsModel} model
 *  Source parcats model
 * @property {Array.<DimensionViewModel>} dimensions
 *  Array of dimension view models
 * @property {Number} width
 *  Width for this trace (pixels)
 * @property {Number} height
 *  Height for this trace (pixels)
 * @property {Number} x
 *  X position of this trace with respect to the Figure (pixels)
 * @property {Number} y
 *  Y position of this trace with respect to the Figure (pixels)
 * @property {String} hoveron
 *  Hover interaction mode. One of: 'category', 'color', or 'dimension'
 * @property {Array.<String>} hoverinfoItems
 *  Info to display on hover. Array with a combination of 'counts' and/or 'probabilities', or 'none', or 'skip'
 * @property {String} arrangement
 *  Category arrangement. One of: 'perpendicular', 'freeform', or 'fixed'
 * @property {Boolean} bundlecolors
 *  Whether paths should be sorted so that like colors are bundled together as they pass through categories
 * @property {String} sortpaths
 *  If 'forward' then sort paths based on dimensions from left to right. If 'backward' sort based on dimensions
 *  from right to left
 * @property {Font} labelfont
 *  Font for the dimension labels
 * @property {Font} categorylabelfont
 *  Font for the category labels
 * @property {String} pathShape
 *  The shape of the paths. Either 'linear' or 'hspline'.
 * @property {DimensionViewModel|null} dragDimension
 *  Dimension currently being dragged. Null if no drag in progress
 * @property {Margin} margin
 *  Margin around the Figure
 * @property {Object} graphDiv
 *  Top-level graph div element
 * @property {Object} traceSelection
 *  D3 selection of this view models trace group element
 * @property {Object} pathSelection
 *  D3 selection of this view models path elements
 * @property {Object} dimensionSelection
 *  D3 selection of this view models dimension group element
 */

/**
 * @typedef {Object} DimensionViewModel
 *  Object containing calculated parcats dimension view information
 *
 *  These are quantities that require Layout information to calculate
 * @property key
 *  Unique key for this model
 * @property {DimensionModel} model
 *  Source dimension model
 * @property {Number} x
 *  X position of the center of this dimension with respect to the Figure (pixels)
 * @property {Number} y
 *  Y position of the top of this dimension with respect to the Figure (pixels)
 * @property {Number} width
 *  Width of categories in this dimension (pixels)
 * @property {ParcatsViewModel} parcatsViewModel
 *  The parent trace's view model
 * @property {Array.<CategoryViewModel>} categories
 *  Dimensions category view models
 * @property {Number|null} dragCategoryDisplayInd
 *  Display index of category currently being dragged. null if no category is being dragged
 * @property {Number|null} dragDimensionDisplayInd
 *  Display index of the dimension being dragged. null if no dimension is being dragged
 * @property {Array.<Number>|null} initialDragDimensionDisplayInds
 *  Dimensions display indexes at the beginning of the current drag. null if no dimension is being dragged
 * @property {Array.<Number>|null} initialDragCategoryDisplayInds
 *  Category display indexes for the at the beginning of the current drag. null if no category is being dragged
 * @property {HTMLElement} potentialClickBand
 *  Band under mouse when current drag began. If no drag movement takes place then a click will be emitted for this
 *  band. Null if not drag in progress.
 * @property {Boolean} dragHasMoved
 *  True if there is an active drag and the drag has moved. If drag doesn't move before being ended then
 *  this may be interpreted as a click. Null if no drag in progress
 */

/**
 * @typedef {Object} CategoryViewModel
 *  Object containing calculated parcats category view information
 *
 *  These are quantities that require Layout information to calculate
 * @property key
 *  Unique key for this model
 * @property {CategoryModel} model
 *  Source category model
 * @property {Number} width
 *  Width for this category (pixels)
 * @property {Number} height
 *  Height for this category (pixels)
 * @property {Number} y
 *  Y position of this cateogry with respect to the Figure (pixels)
 * @property {Array.<CategoryBandViewModel>} bands
 *  Array of color bands inside the category
 * @property {ParcatsViewModel} parcatsViewModel
 *  The parent trace's view model
 */

/**
 * @typedef {Object} CategoryBandViewModel
 *  Object containing calculated category band information. A category band is a region inside a category covering
 *  paths of a single color
 *
 * @property key
 *  Unique key for this model
 * @property color
 *  Band color
 * @property rawColor
 *  Raw color value for band
 * @property {Number} width
 *  Band width
 * @property {Number} height
 *  Band height
 * @property {Number} y
 *  Y position of top of the band with respect to the category
 * @property {Number} count
 *  The number of samples represented by the band
 * @property {CategoryViewModel} categoryViewModel
 *  The parent categorie's view model
 * @property {ParcatsViewModel} parcatsViewModel
 *  The parent trace's view model
 */

/**
 * @typedef {Object} PathViewModel
 *  Object containing calculated parcats path view information
 *
 *  These are quantities that require Layout information to calculate
 * @property key
 *  Unique key for this model
 * @property {PathModel} model
 *  Source path model
 * @property {Number} height
 *  Height of this path (pixels)
 * @property {Array.<Number>} leftXs
 *  The x position of the left edge of each display dimension
 * @property {Array.<Number>} topYs
 *  The y position of the top of the path for each display dimension
 * @property {Array.<Number>} dimWidths
 *  The width of each display dimension
 * @property {String} svgD
 *  SVG path "d" attribute string
 * @property {ParcatsViewModel} parcatsViewModel
 *  The parent trace's view model
 */

/***/ }),

/***/ 37822:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var parcats = __webpack_require__(27219);

/**
 * Create / update parcat traces
 *
 * @param {Object} graphDiv
 * @param {Array.<ParcatsModel>} parcatsModels
 */
module.exports = function plot(graphDiv, parcatsModels, transitionOpts, makeOnCompleteCallback) {
  var fullLayout = graphDiv._fullLayout;
  var svg = fullLayout._paper;
  var size = fullLayout._size;
  parcats(graphDiv, svg, parcatsModels, {
    width: size.w,
    height: size.h,
    margin: {
      t: size.t,
      r: size.r,
      b: size.b,
      l: size.l
    }
  }, transitionOpts, makeOnCompleteCallback);
};

/***/ }),

/***/ 59549:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var colorScaleAttrs = __webpack_require__(87163);
var axesAttrs = __webpack_require__(25829);
var fontAttrs = __webpack_require__(80337);
var domainAttrs = (__webpack_require__(13792)/* .attributes */ .u);
var extendFlat = (__webpack_require__(93049).extendFlat);
var templatedArray = (__webpack_require__(78032).templatedArray);
module.exports = {
  domain: domainAttrs({
    name: 'parcoords',
    trace: true,
    editType: 'plot'
  }),
  labelangle: {
    valType: 'angle',
    dflt: 0,
    editType: 'plot'
  },
  labelside: {
    valType: 'enumerated',
    values: ['top', 'bottom'],
    dflt: 'top',
    editType: 'plot'
  },
  labelfont: fontAttrs({
    editType: 'plot'
  }),
  tickfont: fontAttrs({
    autoShadowDflt: true,
    editType: 'plot'
  }),
  rangefont: fontAttrs({
    editType: 'plot'
  }),
  dimensions: templatedArray('dimension', {
    label: {
      valType: 'string',
      editType: 'plot'
    },
    // TODO: better way to determine ordinal vs continuous axes,
    // so users can use tickvals/ticktext with a continuous axis.
    tickvals: extendFlat({}, axesAttrs.tickvals, {
      editType: 'plot'
    }),
    ticktext: extendFlat({}, axesAttrs.ticktext, {
      editType: 'plot'
    }),
    tickformat: extendFlat({}, axesAttrs.tickformat, {
      editType: 'plot'
    }),
    visible: {
      valType: 'boolean',
      dflt: true,
      editType: 'plot'
    },
    range: {
      valType: 'info_array',
      items: [{
        valType: 'number',
        editType: 'plot'
      }, {
        valType: 'number',
        editType: 'plot'
      }],
      editType: 'plot'
    },
    constraintrange: {
      valType: 'info_array',
      freeLength: true,
      dimensions: '1-2',
      items: [{
        valType: 'any',
        editType: 'plot'
      }, {
        valType: 'any',
        editType: 'plot'
      }],
      editType: 'plot'
    },
    multiselect: {
      valType: 'boolean',
      dflt: true,
      editType: 'plot'
    },
    values: {
      valType: 'data_array',
      editType: 'calc'
    },
    editType: 'calc'
  }),
  line: extendFlat({
    editType: 'calc'
  }, colorScaleAttrs('line', {
    // the default autocolorscale isn't quite usable for parcoords due to context ambiguity around 0 (grey, off-white)
    // autocolorscale therefore defaults to false too, to avoid being overridden by the blue-white-red autocolor palette
    colorscaleDflt: 'Viridis',
    autoColorDflt: false,
    editTypeOverride: 'calc'
  })),
  unselected: {
    line: {
      color: {
        valType: 'color',
        dflt: '#7f7f7f',
        editType: 'plot'
      },
      opacity: {
        valType: 'number',
        min: 0,
        max: 1,
        dflt: 'auto',
        editType: 'plot'
      },
      editType: 'plot'
    },
    editType: 'plot'
  }
};

/***/ }),

/***/ 23245:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var c = __webpack_require__(77911);
var d3 = __webpack_require__(45568);
var keyFun = (__webpack_require__(71293).keyFun);
var repeat = (__webpack_require__(71293).repeat);
var sortAsc = (__webpack_require__(34809).sorterAsc);
var strTranslate = (__webpack_require__(34809).strTranslate);
var snapRatio = c.bar.snapRatio;
function snapOvershoot(v, vAdjacent) {
  return v * (1 - snapRatio) + vAdjacent * snapRatio;
}
var snapClose = c.bar.snapClose;
function closeToCovering(v, vAdjacent) {
  return v * (1 - snapClose) + vAdjacent * snapClose;
}

// snap for the low end of a range on an ordinal scale
// on an ordinal scale, always show some overshoot from the exact value,
// so it's clear we're covering it
// find the interval we're in, and snap to 1/4 the distance to the next
// these two could be unified at a slight loss of readability / perf
function ordinalScaleSnap(isHigh, a, v, existingRanges) {
  if (overlappingExisting(v, existingRanges)) return v;
  var dir = isHigh ? -1 : 1;
  var first = 0;
  var last = a.length - 1;
  if (dir < 0) {
    var tmp = first;
    first = last;
    last = tmp;
  }
  var aHere = a[first];
  var aPrev = aHere;
  for (var i = first; dir * i < dir * last; i += dir) {
    var nextI = i + dir;
    var aNext = a[nextI];

    // very close to the previous - snap down to it
    if (dir * v < dir * closeToCovering(aHere, aNext)) return snapOvershoot(aHere, aPrev);
    if (dir * v < dir * aNext || nextI === last) return snapOvershoot(aNext, aHere);
    aPrev = aHere;
    aHere = aNext;
  }
}
function overlappingExisting(v, existingRanges) {
  for (var i = 0; i < existingRanges.length; i++) {
    if (v >= existingRanges[i][0] && v <= existingRanges[i][1]) return true;
  }
  return false;
}
function barHorizontalSetup(selection) {
  selection.attr('x', -c.bar.captureWidth / 2).attr('width', c.bar.captureWidth);
}
function backgroundBarHorizontalSetup(selection) {
  selection.attr('visibility', 'visible').style('visibility', 'visible').attr('fill', 'yellow').attr('opacity', 0);
}
function setHighlight(d) {
  if (!d.brush.filterSpecified) {
    return '0,' + d.height;
  }
  var pixelRanges = unitToPx(d.brush.filter.getConsolidated(), d.height);
  var dashArray = [0]; // we start with a 0 length selection as filter ranges are inclusive, not exclusive
  var p, sectionHeight, iNext;
  var currentGap = pixelRanges.length ? pixelRanges[0][0] : null;
  for (var i = 0; i < pixelRanges.length; i++) {
    p = pixelRanges[i];
    sectionHeight = p[1] - p[0];
    dashArray.push(currentGap);
    dashArray.push(sectionHeight);
    iNext = i + 1;
    if (iNext < pixelRanges.length) {
      currentGap = pixelRanges[iNext][0] - p[1];
    }
  }
  dashArray.push(d.height);
  // d.height is added at the end to ensure that (1) we have an even number of dasharray points, MDN page says
  // "If an odd number of values is provided, then the list of values is repeated to yield an even number of values."
  // and (2) it's _at least_ as long as the full height (even if range is minuscule and at the bottom) though this
  // may not be necessary, maybe duplicating the last point would do too. But no harm in a longer dasharray than line.
  return dashArray;
}
function unitToPx(unitRanges, height) {
  return unitRanges.map(function (pr) {
    return pr.map(function (v) {
      return Math.max(0, v * height);
    }).sort(sortAsc);
  });
}

// is the cursor over the north, middle, or south of a bar?
// the end handles extend over the last 10% of the bar
function getRegion(fPix, y) {
  var pad = c.bar.handleHeight;
  if (y > fPix[1] + pad || y < fPix[0] - pad) return;
  if (y >= 0.9 * fPix[1] + 0.1 * fPix[0]) return 'n';
  if (y <= 0.9 * fPix[0] + 0.1 * fPix[1]) return 's';
  return 'ns';
}
function clearCursor() {
  d3.select(document.body).style('cursor', null);
}
function styleHighlight(selection) {
  // stroke-dasharray is used to minimize the number of created DOM nodes, because the requirement calls for up to
  // 1000 individual selections on an axis, and there can be 60 axes per parcoords, and multiple parcoords per
  // dashboard. The technique is similar to https://codepen.io/monfera/pen/rLYqWR and using a `polyline` with
  // multiple sections, or a `path` element via its `d` attribute would also be DOM-sparing alternatives.
  selection.attr('stroke-dasharray', setHighlight);
}
function renderHighlight(root, tweenCallback) {
  var bar = d3.select(root).selectAll('.highlight, .highlight-shadow');
  var barToStyle = tweenCallback ? bar.transition().duration(c.bar.snapDuration).each('end', tweenCallback) : bar;
  styleHighlight(barToStyle);
}
function getInterval(d, y) {
  var b = d.brush;
  var active = b.filterSpecified;
  var closestInterval = NaN;
  var out = {};
  var i;
  if (active) {
    var height = d.height;
    var intervals = b.filter.getConsolidated();
    var pixIntervals = unitToPx(intervals, height);
    var hoveredInterval = NaN;
    var previousInterval = NaN;
    var nextInterval = NaN;
    for (i = 0; i <= pixIntervals.length; i++) {
      var p = pixIntervals[i];
      if (p && p[0] <= y && y <= p[1]) {
        // over a bar
        hoveredInterval = i;
        break;
      } else {
        // between bars, or before/after the first/last bar
        previousInterval = i ? i - 1 : NaN;
        if (p && p[0] > y) {
          nextInterval = i;
          break; // no point continuing as intervals are non-overlapping and sorted; could use log search
        }
      }
    }
    closestInterval = hoveredInterval;
    if (isNaN(closestInterval)) {
      if (isNaN(previousInterval) || isNaN(nextInterval)) {
        closestInterval = isNaN(previousInterval) ? nextInterval : previousInterval;
      } else {
        closestInterval = y - pixIntervals[previousInterval][1] < pixIntervals[nextInterval][0] - y ? previousInterval : nextInterval;
      }
    }
    if (!isNaN(closestInterval)) {
      var fPix = pixIntervals[closestInterval];
      var region = getRegion(fPix, y);
      if (region) {
        out.interval = intervals[closestInterval];
        out.intervalPix = fPix;
        out.region = region;
      }
    }
  }
  if (d.ordinal && !out.region) {
    var a = d.unitTickvals;
    var unitLocation = d.unitToPaddedPx.invert(y);
    for (i = 0; i < a.length; i++) {
      var rangei = [a[Math.max(i - 1, 0)] * 0.25 + a[i] * 0.75, a[Math.min(i + 1, a.length - 1)] * 0.25 + a[i] * 0.75];
      if (unitLocation >= rangei[0] && unitLocation <= rangei[1]) {
        out.clickableOrdinalRange = rangei;
        break;
      }
    }
  }
  return out;
}
function dragstart(lThis, d) {
  d3.event.sourceEvent.stopPropagation();
  var y = d.height - d3.mouse(lThis)[1] - 2 * c.verticalPadding;
  var unitLocation = d.unitToPaddedPx.invert(y);
  var b = d.brush;
  var interval = getInterval(d, y);
  var unitRange = interval.interval;
  var s = b.svgBrush;
  s.wasDragged = false; // we start assuming there won't be a drag - useful for reset
  s.grabbingBar = interval.region === 'ns';
  if (s.grabbingBar) {
    var pixelRange = unitRange.map(d.unitToPaddedPx);
    s.grabPoint = y - pixelRange[0] - c.verticalPadding;
    s.barLength = pixelRange[1] - pixelRange[0];
  }
  s.clickableOrdinalRange = interval.clickableOrdinalRange;
  s.stayingIntervals = d.multiselect && b.filterSpecified ? b.filter.getConsolidated() : [];
  if (unitRange) {
    s.stayingIntervals = s.stayingIntervals.filter(function (int2) {
      return int2[0] !== unitRange[0] && int2[1] !== unitRange[1];
    });
  }
  s.startExtent = interval.region ? unitRange[interval.region === 's' ? 1 : 0] : unitLocation;
  d.parent.inBrushDrag = true;
  s.brushStartCallback();
}
function drag(lThis, d) {
  d3.event.sourceEvent.stopPropagation();
  var y = d.height - d3.mouse(lThis)[1] - 2 * c.verticalPadding;
  var s = d.brush.svgBrush;
  s.wasDragged = true;
  s._dragging = true;
  if (s.grabbingBar) {
    // moving the bar
    s.newExtent = [y - s.grabPoint, y + s.barLength - s.grabPoint].map(d.unitToPaddedPx.invert);
  } else {
    // south/north drag or new bar creation
    s.newExtent = [s.startExtent, d.unitToPaddedPx.invert(y)].sort(sortAsc);
  }
  d.brush.filterSpecified = true;
  s.extent = s.stayingIntervals.concat([s.newExtent]);
  s.brushCallback(d);
  renderHighlight(lThis.parentNode);
}
function dragend(lThis, d) {
  var brush = d.brush;
  var filter = brush.filter;
  var s = brush.svgBrush;
  if (!s._dragging) {
    // i.e. click
    // mock zero drag
    mousemove(lThis, d);
    drag(lThis, d);
    // remember it is a click not a drag
    d.brush.svgBrush.wasDragged = false;
  }
  s._dragging = false;
  var e = d3.event;
  e.sourceEvent.stopPropagation();
  var grabbingBar = s.grabbingBar;
  s.grabbingBar = false;
  s.grabLocation = undefined;
  d.parent.inBrushDrag = false;
  clearCursor(); // instead of clearing, a nicer thing would be to set it according to current location
  if (!s.wasDragged) {
    // a click+release on the same spot (ie. w/o dragging) means a bar or full reset
    s.wasDragged = undefined; // logic-wise unneeded, just shows `wasDragged` has no longer a meaning
    if (s.clickableOrdinalRange) {
      if (brush.filterSpecified && d.multiselect) {
        s.extent.push(s.clickableOrdinalRange);
      } else {
        s.extent = [s.clickableOrdinalRange];
        brush.filterSpecified = true;
      }
    } else if (grabbingBar) {
      s.extent = s.stayingIntervals;
      if (s.extent.length === 0) {
        brushClear(brush);
      }
    } else {
      brushClear(brush);
    }
    s.brushCallback(d);
    renderHighlight(lThis.parentNode);
    s.brushEndCallback(brush.filterSpecified ? filter.getConsolidated() : []);
    return; // no need to fuse intervals or snap to ordinals, so we can bail early
  }
  var mergeIntervals = function () {
    // Key piece of logic: once the button is released, possibly overlapping intervals will be fused:
    // Here it's done immediately on click release while on ordinal snap transition it's done at the end
    filter.set(filter.getConsolidated());
  };
  if (d.ordinal) {
    var a = d.unitTickvals;
    if (a[a.length - 1] < a[0]) a.reverse();
    s.newExtent = [ordinalScaleSnap(0, a, s.newExtent[0], s.stayingIntervals), ordinalScaleSnap(1, a, s.newExtent[1], s.stayingIntervals)];
    var hasNewExtent = s.newExtent[1] > s.newExtent[0];
    s.extent = s.stayingIntervals.concat(hasNewExtent ? [s.newExtent] : []);
    if (!s.extent.length) {
      brushClear(brush);
    }
    s.brushCallback(d);
    if (hasNewExtent) {
      // merging intervals post the snap tween
      renderHighlight(lThis.parentNode, mergeIntervals);
    } else {
      // if no new interval, don't animate, just redraw the highlight immediately
      mergeIntervals();
      renderHighlight(lThis.parentNode);
    }
  } else {
    mergeIntervals(); // merging intervals immediately
  }
  s.brushEndCallback(brush.filterSpecified ? filter.getConsolidated() : []);
}
function mousemove(lThis, d) {
  var y = d.height - d3.mouse(lThis)[1] - 2 * c.verticalPadding;
  var interval = getInterval(d, y);
  var cursor = 'crosshair';
  if (interval.clickableOrdinalRange) cursor = 'pointer';else if (interval.region) cursor = interval.region + '-resize';
  d3.select(document.body).style('cursor', cursor);
}
function attachDragBehavior(selection) {
  // There's some fiddling with pointer cursor styling so that the cursor preserves its shape while dragging a brush
  // even if the cursor strays from the interacting bar, which is bound to happen as bars are thin and the user
  // will inevitably leave the hotspot strip. In this regard, it does something similar to what the D3 brush would do.
  selection.on('mousemove', function (d) {
    d3.event.preventDefault();
    if (!d.parent.inBrushDrag) mousemove(this, d);
  }).on('mouseleave', function (d) {
    if (!d.parent.inBrushDrag) clearCursor();
  }).call(d3.behavior.drag().on('dragstart', function (d) {
    dragstart(this, d);
  }).on('drag', function (d) {
    drag(this, d);
  }).on('dragend', function (d) {
    dragend(this, d);
  }));
}
function startAsc(a, b) {
  return a[0] - b[0];
}
function renderAxisBrush(axisBrush, paperColor, gd) {
  var isStatic = gd._context.staticPlot;
  var background = axisBrush.selectAll('.background').data(repeat);
  background.enter().append('rect').classed('background', true).call(barHorizontalSetup).call(backgroundBarHorizontalSetup).style('pointer-events', isStatic ? 'none' : 'auto') // parent pointer events are disabled; we must have it to register events
  .attr('transform', strTranslate(0, c.verticalPadding));
  background.call(attachDragBehavior).attr('height', function (d) {
    return d.height - c.verticalPadding;
  });
  var highlightShadow = axisBrush.selectAll('.highlight-shadow').data(repeat); // we have a set here, can't call it `extent`

  highlightShadow.enter().append('line').classed('highlight-shadow', true).attr('x', -c.bar.width / 2).attr('stroke-width', c.bar.width + c.bar.strokeWidth).attr('stroke', paperColor).attr('opacity', c.bar.strokeOpacity).attr('stroke-linecap', 'butt');
  highlightShadow.attr('y1', function (d) {
    return d.height;
  }).call(styleHighlight);
  var highlight = axisBrush.selectAll('.highlight').data(repeat); // we have a set here, can't call it `extent`

  highlight.enter().append('line').classed('highlight', true).attr('x', -c.bar.width / 2).attr('stroke-width', c.bar.width - c.bar.strokeWidth).attr('stroke', c.bar.fillColor).attr('opacity', c.bar.fillOpacity).attr('stroke-linecap', 'butt');
  highlight.attr('y1', function (d) {
    return d.height;
  }).call(styleHighlight);
}
function ensureAxisBrush(axisOverlays, paperColor, gd) {
  var axisBrush = axisOverlays.selectAll('.' + c.cn.axisBrush).data(repeat, keyFun);
  axisBrush.enter().append('g').classed(c.cn.axisBrush, true);
  renderAxisBrush(axisBrush, paperColor, gd);
}
function getBrushExtent(brush) {
  return brush.svgBrush.extent.map(function (e) {
    return e.slice();
  });
}
function brushClear(brush) {
  brush.filterSpecified = false;
  brush.svgBrush.extent = [[-Infinity, Infinity]];
}
function axisBrushMoved(callback) {
  return function axisBrushMoved(dimension) {
    var brush = dimension.brush;
    var extent = getBrushExtent(brush);
    var newExtent = extent.slice();
    brush.filter.set(newExtent);
    callback();
  };
}
function dedupeRealRanges(intervals) {
  // Fuses elements of intervals if they overlap, yielding discontiguous intervals, results.length <= intervals.length
  // Currently uses closed intervals, ie. dedupeRealRanges([[400, 800], [300, 400]]) -> [300, 800]
  var queue = intervals.slice();
  var result = [];
  var currentInterval;
  var current = queue.shift();
  while (current) {
    // [].shift === undefined, so we don't descend into an empty array
    currentInterval = current.slice();
    while ((current = queue.shift()) && current[0] <= /* right-open interval would need `<` */currentInterval[1]) {
      currentInterval[1] = Math.max(currentInterval[1], current[1]);
    }
    result.push(currentInterval);
  }
  if (result.length === 1 && result[0][0] > result[0][1]) {
    // discard result
    result = [];
  }
  return result;
}
function makeFilter() {
  var filter = [];
  var consolidated;
  var bounds;
  return {
    set: function (a) {
      filter = a.map(function (d) {
        return d.slice().sort(sortAsc);
      }).sort(startAsc);

      // handle unselected case
      if (filter.length === 1 && filter[0][0] === -Infinity && filter[0][1] === Infinity) {
        filter = [[0, -1]];
      }
      consolidated = dedupeRealRanges(filter);
      bounds = filter.reduce(function (p, n) {
        return [Math.min(p[0], n[0]), Math.max(p[1], n[1])];
      }, [Infinity, -Infinity]);
    },
    get: function () {
      return filter.slice();
    },
    getConsolidated: function () {
      return consolidated;
    },
    getBounds: function () {
      return bounds;
    }
  };
}
function makeBrush(state, rangeSpecified, initialRange, brushStartCallback, brushCallback, brushEndCallback) {
  var filter = makeFilter();
  filter.set(initialRange);
  return {
    filter: filter,
    filterSpecified: rangeSpecified,
    // there's a difference between not filtering and filtering a non-proper subset
    svgBrush: {
      extent: [],
      // this is where the svgBrush writes contents into
      brushStartCallback: brushStartCallback,
      brushCallback: axisBrushMoved(brushCallback),
      brushEndCallback: brushEndCallback
    }
  };
}

// for use by supplyDefaults, but it needed tons of pieces from here so
// seemed to make more sense just to put the whole routine here
function cleanRanges(ranges, dimension) {
  if (Array.isArray(ranges[0])) {
    ranges = ranges.map(function (ri) {
      return ri.sort(sortAsc);
    });
    if (!dimension.multiselect) ranges = [ranges[0]];else ranges = dedupeRealRanges(ranges.sort(startAsc));
  } else ranges = [ranges.sort(sortAsc)];

  // ordinal snapping
  if (dimension.tickvals) {
    var sortedTickVals = dimension.tickvals.slice().sort(sortAsc);
    ranges = ranges.map(function (ri) {
      var rSnapped = [ordinalScaleSnap(0, sortedTickVals, ri[0], []), ordinalScaleSnap(1, sortedTickVals, ri[1], [])];
      if (rSnapped[1] > rSnapped[0]) return rSnapped;
    }).filter(function (ri) {
      return ri;
    });
    if (!ranges.length) return;
  }
  return ranges.length > 1 ? ranges : ranges[0];
}
module.exports = {
  makeBrush: makeBrush,
  ensureAxisBrush: ensureAxisBrush,
  cleanRanges: cleanRanges
};

/***/ }),

/***/ 79846:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = {
  attributes: __webpack_require__(59549),
  supplyDefaults: __webpack_require__(12842),
  calc: __webpack_require__(20113),
  colorbar: {
    container: 'line',
    min: 'cmin',
    max: 'cmax'
  },
  moduleType: 'trace',
  name: 'parcoords',
  basePlotModule: __webpack_require__(67207),
  categories: ['gl', 'regl', 'noOpacity', 'noHover'],
  meta: {}
};

/***/ }),

/***/ 67207:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var getModuleCalcData = (__webpack_require__(4173)/* .getModuleCalcData */ .eV);
var parcoordsPlot = __webpack_require__(58823);
var xmlnsNamespaces = __webpack_require__(62972);
exports.name = 'parcoords';
exports.plot = function (gd) {
  var calcData = getModuleCalcData(gd.calcdata, 'parcoords')[0];
  if (calcData.length) parcoordsPlot(gd, calcData);
};
exports.clean = function (newFullData, newFullLayout, oldFullData, oldFullLayout) {
  var hadParcoords = oldFullLayout._has && oldFullLayout._has('parcoords');
  var hasParcoords = newFullLayout._has && newFullLayout._has('parcoords');
  if (hadParcoords && !hasParcoords) {
    oldFullLayout._paperdiv.selectAll('.parcoords').remove();
    oldFullLayout._glimages.selectAll('*').remove();
  }
};
exports.toSVG = function (gd) {
  var imageRoot = gd._fullLayout._glimages;
  var root = d3.select(gd).selectAll('.svg-container');
  var canvases = root.filter(function (d, i) {
    return i === root.size() - 1;
  }).selectAll('.gl-canvas-context, .gl-canvas-focus');
  function canvasToImage() {
    var canvas = this;
    var imageData = canvas.toDataURL('image/png');
    var image = imageRoot.append('svg:image');
    image.attr({
      xmlns: xmlnsNamespaces.svg,
      'xlink:href': imageData,
      preserveAspectRatio: 'none',
      x: 0,
      y: 0,
      width: canvas.style.width,
      height: canvas.style.height
    });
  }
  canvases.each(canvasToImage);

  // Chrome / Safari bug workaround - browser apparently loses connection to the defined pattern
  // Without the workaround, these browsers 'lose' the filter brush styling (color etc.) after a snapshot
  // on a subsequent interaction.
  // Firefox works fine without this workaround
  window.setTimeout(function () {
    d3.selectAll('#filterBarPattern').attr('id', 'filterBarPattern');
  }, 60);
};

/***/ }),

/***/ 20113:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isArrayOrTypedArray = (__webpack_require__(34809).isArrayOrTypedArray);
var Colorscale = __webpack_require__(88856);
var wrap = (__webpack_require__(71293).wrap);
module.exports = function calc(gd, trace) {
  var lineColor;
  var cscale;
  if (Colorscale.hasColorscale(trace, 'line') && isArrayOrTypedArray(trace.line.color)) {
    lineColor = trace.line.color;
    cscale = Colorscale.extractOpts(trace.line).colorscale;
    Colorscale.calc(gd, trace, {
      vals: lineColor,
      containerStr: 'line',
      cLetter: 'c'
    });
  } else {
    lineColor = constHalf(trace._length);
    cscale = [[0, trace.line.color], [1, trace.line.color]];
  }
  return wrap({
    lineColor: lineColor,
    cscale: cscale
  });
};
function constHalf(len) {
  var out = new Array(len);
  for (var i = 0; i < len; i++) {
    out[i] = 0.5;
  }
  return out;
}

/***/ }),

/***/ 77911:
/***/ (function(module) {

"use strict";


module.exports = {
  maxDimensionCount: 60,
  // this cannot be increased without WebGL code refactoring
  overdrag: 45,
  verticalPadding: 2,
  // otherwise, horizontal lines on top or bottom are of lower width
  tickDistance: 50,
  canvasPixelRatio: 1,
  blockLineCount: 5000,
  layers: ['contextLineLayer', 'focusLineLayer', 'pickLineLayer'],
  axisTitleOffset: 28,
  axisExtentOffset: 10,
  bar: {
    width: 4,
    // Visible width of the filter bar
    captureWidth: 10,
    // Mouse-sensitive width for interaction (Fitts law)
    fillColor: 'magenta',
    // Color of the filter bar fill
    fillOpacity: 1,
    // Filter bar fill opacity
    snapDuration: 150,
    // tween duration in ms for brush snap for ordinal axes
    snapRatio: 0.25,
    // ratio of bar extension relative to the distance between two adjacent ordinal values
    snapClose: 0.01,
    // fraction of inter-value distance to snap to the closer one, even if you're not over it
    strokeOpacity: 1,
    // Filter bar side stroke opacity
    strokeWidth: 1,
    // Filter bar side stroke width in pixels
    handleHeight: 8,
    // Height of the filter bar vertical resize areas on top and bottom
    handleOpacity: 1,
    // Opacity of the filter bar vertical resize areas on top and bottom
    handleOverlap: 0 // A larger than 0 value causes overlaps with the filter bar, represented as pixels
  },
  cn: {
    axisExtentText: 'axis-extent-text',
    parcoordsLineLayers: 'parcoords-line-layers',
    parcoordsLineLayer: 'parcoords-lines',
    parcoords: 'parcoords',
    parcoordsControlView: 'parcoords-control-view',
    yAxis: 'y-axis',
    axisOverlays: 'axis-overlays',
    axis: 'axis',
    axisHeading: 'axis-heading',
    axisTitle: 'axis-title',
    axisExtent: 'axis-extent',
    axisExtentTop: 'axis-extent-top',
    axisExtentTopText: 'axis-extent-top-text',
    axisExtentBottom: 'axis-extent-bottom',
    axisExtentBottomText: 'axis-extent-bottom-text',
    axisBrush: 'axis-brush'
  },
  id: {
    filterBarPattern: 'filter-bar-pattern'
  }
};

/***/ }),

/***/ 12842:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var hasColorscale = (__webpack_require__(65477).hasColorscale);
var colorscaleDefaults = __webpack_require__(39356);
var handleDomainDefaults = (__webpack_require__(13792)/* .defaults */ .N);
var handleArrayContainerDefaults = __webpack_require__(59008);
var Axes = __webpack_require__(29714);
var attributes = __webpack_require__(59549);
var axisBrush = __webpack_require__(23245);
var maxDimensionCount = (__webpack_require__(77911).maxDimensionCount);
var mergeLength = __webpack_require__(63197);
function handleLineDefaults(traceIn, traceOut, defaultColor, layout, coerce) {
  var lineColor = coerce('line.color', defaultColor);
  if (hasColorscale(traceIn, 'line') && Lib.isArrayOrTypedArray(lineColor)) {
    if (lineColor.length) {
      coerce('line.colorscale');
      colorscaleDefaults(traceIn, traceOut, layout, coerce, {
        prefix: 'line.',
        cLetter: 'c'
      });
      // TODO: I think it would be better to keep showing lines beyond the last line color
      // but I'm not sure what color to give these lines - probably black or white
      // depending on the background color?
      return lineColor.length;
    } else {
      traceOut.line.color = defaultColor;
    }
  }
  return Infinity;
}
function dimensionDefaults(dimensionIn, dimensionOut, parentOut, opts) {
  function coerce(attr, dflt) {
    return Lib.coerce(dimensionIn, dimensionOut, attributes.dimensions, attr, dflt);
  }
  var values = coerce('values');
  var visible = coerce('visible');
  if (!(values && values.length)) {
    visible = dimensionOut.visible = false;
  }
  if (visible) {
    coerce('label');
    coerce('tickvals');
    coerce('ticktext');
    coerce('tickformat');
    var range = coerce('range');
    dimensionOut._ax = {
      _id: 'y',
      type: 'linear',
      showexponent: 'all',
      exponentformat: 'B',
      range: range
    };
    Axes.setConvert(dimensionOut._ax, opts.layout);
    coerce('multiselect');
    var constraintRange = coerce('constraintrange');
    if (constraintRange) {
      dimensionOut.constraintrange = axisBrush.cleanRanges(constraintRange, dimensionOut);
    }
  }
}
module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
  function coerce(attr, dflt) {
    return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
  }
  var dimensionsIn = traceIn.dimensions;
  if (Array.isArray(dimensionsIn) && dimensionsIn.length > maxDimensionCount) {
    Lib.log('parcoords traces support up to ' + maxDimensionCount + ' dimensions at the moment');
    dimensionsIn.splice(maxDimensionCount);
  }
  var dimensions = handleArrayContainerDefaults(traceIn, traceOut, {
    name: 'dimensions',
    layout: layout,
    handleItemDefaults: dimensionDefaults
  });
  var len = handleLineDefaults(traceIn, traceOut, defaultColor, layout, coerce);
  handleDomainDefaults(traceOut, layout, coerce);
  if (!Array.isArray(dimensions) || !dimensions.length) {
    traceOut.visible = false;
  }
  mergeLength(traceOut, dimensions, 'values', len);

  // make default font size 10px (default is 12),
  // scale linearly with global font size
  var fontDflt = Lib.extendFlat({}, layout.font, {
    size: Math.round(layout.font.size / 1.2)
  });
  Lib.coerceFont(coerce, 'labelfont', fontDflt);
  Lib.coerceFont(coerce, 'tickfont', fontDflt, {
    autoShadowDflt: true
  });
  Lib.coerceFont(coerce, 'rangefont', fontDflt);
  coerce('labelangle');
  coerce('labelside');
  coerce('unselected.line.color');
  coerce('unselected.line.opacity');
};

/***/ }),

/***/ 62935:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var isTypedArray = (__webpack_require__(34809).isTypedArray);
exports.convertTypedArray = function (a) {
  return isTypedArray(a) ? Array.prototype.slice.call(a) : a;
};
exports.isOrdinal = function (dimension) {
  return !!dimension.tickvals;
};
exports.isVisible = function (dimension) {
  return dimension.visible || !('visible' in dimension);
};

/***/ }),

/***/ 83910:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var index = __webpack_require__(79846);
index.plot = __webpack_require__(58823);
module.exports = index;

/***/ }),

/***/ 1293:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var vertexShaderSource = ['precision highp float;', '', 'varying vec4 fragColor;', '', 'attribute vec4 p01_04, p05_08, p09_12, p13_16,', '               p17_20, p21_24, p25_28, p29_32,', '               p33_36, p37_40, p41_44, p45_48,', '               p49_52, p53_56, p57_60, colors;', '', 'uniform mat4 dim0A, dim1A, dim0B, dim1B, dim0C, dim1C, dim0D, dim1D,', '             loA, hiA, loB, hiB, loC, hiC, loD, hiD;', '', 'uniform vec2 resolution, viewBoxPos, viewBoxSize;', 'uniform float maskHeight;', 'uniform float drwLayer; // 0: context, 1: focus, 2: pick', 'uniform vec4 contextColor;', 'uniform sampler2D maskTexture, palette;', '', 'bool isPick    = (drwLayer > 1.5);', 'bool isContext = (drwLayer < 0.5);', '', 'const vec4 ZEROS = vec4(0.0, 0.0, 0.0, 0.0);', 'const vec4 UNITS = vec4(1.0, 1.0, 1.0, 1.0);', '', 'float val(mat4 p, mat4 v) {', '    return dot(matrixCompMult(p, v) * UNITS, UNITS);', '}', '', 'float axisY(float ratio, mat4 A, mat4 B, mat4 C, mat4 D) {', '    float y1 = val(A, dim0A) + val(B, dim0B) + val(C, dim0C) + val(D, dim0D);', '    float y2 = val(A, dim1A) + val(B, dim1B) + val(C, dim1C) + val(D, dim1D);', '    return y1 * (1.0 - ratio) + y2 * ratio;', '}', '', 'int iMod(int a, int b) {', '    return a - b * (a / b);', '}', '', 'bool fOutside(float p, float lo, float hi) {', '    return (lo < hi) && (lo > p || p > hi);', '}', '', 'bool vOutside(vec4 p, vec4 lo, vec4 hi) {', '    return (', '        fOutside(p[0], lo[0], hi[0]) ||', '        fOutside(p[1], lo[1], hi[1]) ||', '        fOutside(p[2], lo[2], hi[2]) ||', '        fOutside(p[3], lo[3], hi[3])', '    );', '}', '', 'bool mOutside(mat4 p, mat4 lo, mat4 hi) {', '    return (', '        vOutside(p[0], lo[0], hi[0]) ||', '        vOutside(p[1], lo[1], hi[1]) ||', '        vOutside(p[2], lo[2], hi[2]) ||', '        vOutside(p[3], lo[3], hi[3])', '    );', '}', '', 'bool outsideBoundingBox(mat4 A, mat4 B, mat4 C, mat4 D) {', '    return mOutside(A, loA, hiA) ||', '           mOutside(B, loB, hiB) ||', '           mOutside(C, loC, hiC) ||', '           mOutside(D, loD, hiD);', '}', '', 'bool outsideRasterMask(mat4 A, mat4 B, mat4 C, mat4 D) {', '    mat4 pnts[4];', '    pnts[0] = A;', '    pnts[1] = B;', '    pnts[2] = C;', '    pnts[3] = D;', '', '    for(int i = 0; i < 4; ++i) {', '        for(int j = 0; j < 4; ++j) {', '            for(int k = 0; k < 4; ++k) {', '                if(0 == iMod(', '                    int(255.0 * texture2D(maskTexture,', '                        vec2(', '                            (float(i * 2 + j / 2) + 0.5) / 8.0,', '                            (pnts[i][j][k] * (maskHeight - 1.0) + 1.0) / maskHeight', '                        ))[3]', '                    ) / int(pow(2.0, float(iMod(j * 4 + k, 8)))),', '                    2', '                )) return true;', '            }', '        }', '    }', '    return false;', '}', '', 'vec4 position(bool isContext, float v, mat4 A, mat4 B, mat4 C, mat4 D) {', '    float x = 0.5 * sign(v) + 0.5;', '    float y = axisY(x, A, B, C, D);', '    float z = 1.0 - abs(v);', '', '    z += isContext ? 0.0 : 2.0 * float(', '        outsideBoundingBox(A, B, C, D) ||', '        outsideRasterMask(A, B, C, D)', '    );', '', '    return vec4(', '        2.0 * (vec2(x, y) * viewBoxSize + viewBoxPos) / resolution - 1.0,', '        z,', '        1.0', '    );', '}', '', 'void main() {', '    mat4 A = mat4(p01_04, p05_08, p09_12, p13_16);', '    mat4 B = mat4(p17_20, p21_24, p25_28, p29_32);', '    mat4 C = mat4(p33_36, p37_40, p41_44, p45_48);', '    mat4 D = mat4(p49_52, p53_56, p57_60, ZEROS);', '', '    float v = colors[3];', '', '    gl_Position = position(isContext, v, A, B, C, D);', '', '    fragColor =', '        isContext ? vec4(contextColor) :', '        isPick ? vec4(colors.rgb, 1.0) : texture2D(palette, vec2(abs(v), 0.5));', '}'].join('\n');
var fragmentShaderSource = ['precision highp float;', '', 'varying vec4 fragColor;', '', 'void main() {', '    gl_FragColor = fragColor;', '}'].join('\n');
var maxDim = (__webpack_require__(77911).maxDimensionCount);
var Lib = __webpack_require__(34809);

// don't change; otherwise near/far plane lines are lost
var depthLimitEpsilon = 1e-6;

// precision of multiselect is the full range divided into this many parts
var maskHeight = 2048;
var dummyPixel = new Uint8Array(4);
var dataPixel = new Uint8Array(4);
var paletteTextureConfig = {
  shape: [256, 1],
  format: 'rgba',
  type: 'uint8',
  mag: 'nearest',
  min: 'nearest'
};
function ensureDraw(regl) {
  regl.read({
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    data: dummyPixel
  });
}
function clear(regl, x, y, width, height) {
  var gl = regl._gl;
  gl.enable(gl.SCISSOR_TEST);
  gl.scissor(x, y, width, height);
  regl.clear({
    color: [0, 0, 0, 0],
    depth: 1
  }); // clearing is done in scissored panel only
}
function renderBlock(regl, glAes, renderState, blockLineCount, sampleCount, item) {
  var rafKey = item.key;
  function render(blockNumber) {
    var count = Math.min(blockLineCount, sampleCount - blockNumber * blockLineCount);
    if (blockNumber === 0) {
      // stop drawing possibly stale glyphs before clearing
      window.cancelAnimationFrame(renderState.currentRafs[rafKey]);
      delete renderState.currentRafs[rafKey];
      clear(regl, item.scissorX, item.scissorY, item.scissorWidth, item.viewBoxSize[1]);
    }
    if (renderState.clearOnly) {
      return;
    }
    item.count = 2 * count;
    item.offset = 2 * blockNumber * blockLineCount;
    glAes(item);
    if (blockNumber * blockLineCount + count < sampleCount) {
      renderState.currentRafs[rafKey] = window.requestAnimationFrame(function () {
        render(blockNumber + 1);
      });
    }
    renderState.drawCompleted = false;
  }
  if (!renderState.drawCompleted) {
    ensureDraw(regl);
    renderState.drawCompleted = true;
  }

  // start with rendering item 0; recursion handles the rest
  render(0);
}
function adjustDepth(d) {
  // WebGL matrix operations use floats with limited precision, potentially causing a number near a border of [0, 1]
  // to end up slightly outside the border. With an epsilon, we reduce the chance that a line gets clipped by the
  // near or the far plane.
  return Math.max(depthLimitEpsilon, Math.min(1 - depthLimitEpsilon, d));
}
function palette(unitToColor, opacity) {
  var result = new Array(256);
  for (var i = 0; i < 256; i++) {
    result[i] = unitToColor(i / 255).concat(opacity);
  }
  return result;
}

// Maps the sample index [0...sampleCount - 1] to a range of [0, 1] as the shader expects colors in the [0, 1] range.
// but first it shifts the sample index by 0, 8 or 16 bits depending on rgbIndex [0..2]
// with the end result that each line will be of a unique color, making it possible for the pick handler
// to uniquely identify which line is hovered over (bijective mapping).
// The inverse, i.e. readPixel is invoked from 'parcoords.js'
function calcPickColor(i, rgbIndex) {
  return (i >>> 8 * rgbIndex) % 256 / 255;
}
function makePoints(sampleCount, dims, color) {
  var points = new Array(sampleCount * (maxDim + 4));
  var n = 0;
  for (var i = 0; i < sampleCount; i++) {
    for (var k = 0; k < maxDim; k++) {
      points[n++] = k < dims.length ? dims[k].paddedUnitValues[i] : 0.5;
    }
    points[n++] = calcPickColor(i, 2);
    points[n++] = calcPickColor(i, 1);
    points[n++] = calcPickColor(i, 0);
    points[n++] = adjustDepth(color[i]);
  }
  return points;
}
function makeVecAttr(vecIndex, sampleCount, points) {
  var pointPairs = new Array(sampleCount * 8);
  var n = 0;
  for (var i = 0; i < sampleCount; i++) {
    for (var j = 0; j < 2; j++) {
      for (var k = 0; k < 4; k++) {
        var q = vecIndex * 4 + k;
        var v = points[i * 64 + q];
        if (q === 63 && j === 0) {
          v *= -1;
        }
        pointPairs[n++] = v;
      }
    }
  }
  return pointPairs;
}
function pad2(num) {
  var s = '0' + num;
  return s.substr(s.length - 2);
}
function getAttrName(i) {
  return i < maxDim ? 'p' + pad2(i + 1) + '_' + pad2(i + 4) : 'colors';
}
function setAttributes(attributes, sampleCount, points) {
  for (var i = 0; i <= maxDim; i += 4) {
    attributes[getAttrName(i)](makeVecAttr(i / 4, sampleCount, points));
  }
}
function emptyAttributes(regl) {
  var attributes = {};
  for (var i = 0; i <= maxDim; i += 4) {
    attributes[getAttrName(i)] = regl.buffer({
      usage: 'dynamic',
      type: 'float',
      data: new Uint8Array(0)
    });
  }
  return attributes;
}
function makeItem(model, leftmost, rightmost, itemNumber, i0, i1, x, y, panelSizeX, panelSizeY, crossfilterDimensionIndex, drwLayer, constraints, plotGlPixelRatio) {
  var dims = [[], []];
  for (var k = 0; k < 64; k++) {
    dims[0][k] = k === i0 ? 1 : 0;
    dims[1][k] = k === i1 ? 1 : 0;
  }
  x *= plotGlPixelRatio;
  y *= plotGlPixelRatio;
  panelSizeX *= plotGlPixelRatio;
  panelSizeY *= plotGlPixelRatio;
  var overdrag = model.lines.canvasOverdrag * plotGlPixelRatio;
  var domain = model.domain;
  var canvasWidth = model.canvasWidth * plotGlPixelRatio;
  var canvasHeight = model.canvasHeight * plotGlPixelRatio;
  var padL = model.pad.l * plotGlPixelRatio;
  var padB = model.pad.b * plotGlPixelRatio;
  var layoutHeight = model.layoutHeight * plotGlPixelRatio;
  var layoutWidth = model.layoutWidth * plotGlPixelRatio;
  var deselectedLinesColor = model.deselectedLines.color;
  var deselectedLinesOpacity = model.deselectedLines.opacity;
  var itemModel = Lib.extendFlat({
    key: crossfilterDimensionIndex,
    resolution: [canvasWidth, canvasHeight],
    viewBoxPos: [x + overdrag, y],
    viewBoxSize: [panelSizeX, panelSizeY],
    i0: i0,
    i1: i1,
    dim0A: dims[0].slice(0, 16),
    dim0B: dims[0].slice(16, 32),
    dim0C: dims[0].slice(32, 48),
    dim0D: dims[0].slice(48, 64),
    dim1A: dims[1].slice(0, 16),
    dim1B: dims[1].slice(16, 32),
    dim1C: dims[1].slice(32, 48),
    dim1D: dims[1].slice(48, 64),
    drwLayer: drwLayer,
    contextColor: [deselectedLinesColor[0] / 255, deselectedLinesColor[1] / 255, deselectedLinesColor[2] / 255, deselectedLinesOpacity !== 'auto' ? deselectedLinesColor[3] * deselectedLinesOpacity : Math.max(1 / 255, Math.pow(1 / model.lines.color.length, 1 / 3))],
    scissorX: (itemNumber === leftmost ? 0 : x + overdrag) + (padL - overdrag) + layoutWidth * domain.x[0],
    scissorWidth: (itemNumber === rightmost ? canvasWidth - x + overdrag : panelSizeX + 0.5) + (itemNumber === leftmost ? x + overdrag : 0),
    scissorY: y + padB + layoutHeight * domain.y[0],
    scissorHeight: panelSizeY,
    viewportX: padL - overdrag + layoutWidth * domain.x[0],
    viewportY: padB + layoutHeight * domain.y[0],
    viewportWidth: canvasWidth,
    viewportHeight: canvasHeight
  }, constraints);
  return itemModel;
}
function expandedPixelRange(bounds) {
  var dh = maskHeight - 1;
  var a = Math.max(0, Math.floor(bounds[0] * dh), 0);
  var b = Math.min(dh, Math.ceil(bounds[1] * dh), dh);
  return [Math.min(a, b), Math.max(a, b)];
}
module.exports = function (canvasGL, d) {
  // context & pick describe which canvas we're talking about - won't change with new data
  var isContext = d.context;
  var isPick = d.pick;
  var regl = d.regl;
  var gl = regl._gl;
  var supportedLineWidth = gl.getParameter(gl.ALIASED_LINE_WIDTH_RANGE);
  // ensure here that plotGlPixelRatio is within supported range; otherwise regl throws error
  var plotGlPixelRatio = Math.max(supportedLineWidth[0], Math.min(supportedLineWidth[1], d.viewModel.plotGlPixelRatio));
  var renderState = {
    currentRafs: {},
    drawCompleted: true,
    clearOnly: false
  };

  // state to be set by update and used later
  var model;
  var vm;
  var initialDims;
  var sampleCount;
  var attributes = emptyAttributes(regl);
  var maskTexture;
  var paletteTexture = regl.texture(paletteTextureConfig);
  var prevAxisOrder = [];
  update(d);
  var glAes = regl({
    profile: false,
    blend: {
      enable: isContext,
      func: {
        srcRGB: 'src alpha',
        dstRGB: 'one minus src alpha',
        srcAlpha: 1,
        dstAlpha: 1 // 'one minus src alpha'
      },
      equation: {
        rgb: 'add',
        alpha: 'add'
      },
      color: [0, 0, 0, 0]
    },
    depth: {
      enable: !isContext,
      mask: true,
      func: 'less',
      range: [0, 1]
    },
    // for polygons
    cull: {
      enable: true,
      face: 'back'
    },
    scissor: {
      enable: true,
      box: {
        x: regl.prop('scissorX'),
        y: regl.prop('scissorY'),
        width: regl.prop('scissorWidth'),
        height: regl.prop('scissorHeight')
      }
    },
    viewport: {
      x: regl.prop('viewportX'),
      y: regl.prop('viewportY'),
      width: regl.prop('viewportWidth'),
      height: regl.prop('viewportHeight')
    },
    dither: false,
    vert: vertexShaderSource,
    frag: fragmentShaderSource,
    primitive: 'lines',
    lineWidth: plotGlPixelRatio,
    attributes: attributes,
    uniforms: {
      resolution: regl.prop('resolution'),
      viewBoxPos: regl.prop('viewBoxPos'),
      viewBoxSize: regl.prop('viewBoxSize'),
      dim0A: regl.prop('dim0A'),
      dim1A: regl.prop('dim1A'),
      dim0B: regl.prop('dim0B'),
      dim1B: regl.prop('dim1B'),
      dim0C: regl.prop('dim0C'),
      dim1C: regl.prop('dim1C'),
      dim0D: regl.prop('dim0D'),
      dim1D: regl.prop('dim1D'),
      loA: regl.prop('loA'),
      hiA: regl.prop('hiA'),
      loB: regl.prop('loB'),
      hiB: regl.prop('hiB'),
      loC: regl.prop('loC'),
      hiC: regl.prop('hiC'),
      loD: regl.prop('loD'),
      hiD: regl.prop('hiD'),
      palette: paletteTexture,
      contextColor: regl.prop('contextColor'),
      maskTexture: regl.prop('maskTexture'),
      drwLayer: regl.prop('drwLayer'),
      maskHeight: regl.prop('maskHeight')
    },
    offset: regl.prop('offset'),
    count: regl.prop('count')
  });
  function update(dNew) {
    model = dNew.model;
    vm = dNew.viewModel;
    initialDims = vm.dimensions.slice();
    sampleCount = initialDims[0] ? initialDims[0].values.length : 0;
    var lines = model.lines;
    var color = isPick ? lines.color.map(function (_, i) {
      return i / lines.color.length;
    }) : lines.color;
    var points = makePoints(sampleCount, initialDims, color);
    setAttributes(attributes, sampleCount, points);
    if (!isContext && !isPick) {
      paletteTexture = regl.texture(Lib.extendFlat({
        data: palette(model.unitToColor, 255)
      }, paletteTextureConfig));
    }
  }
  function makeConstraints(isContext) {
    var i, j, k;
    var limits = [[], []];
    for (k = 0; k < 64; k++) {
      var p = !isContext && k < initialDims.length ? initialDims[k].brush.filter.getBounds() : [-Infinity, Infinity];
      limits[0][k] = p[0];
      limits[1][k] = p[1];
    }
    var len = maskHeight * 8;
    var mask = new Array(len);
    for (i = 0; i < len; i++) {
      mask[i] = 255;
    }
    if (!isContext) {
      for (i = 0; i < initialDims.length; i++) {
        var u = i % 8;
        var v = (i - u) / 8;
        var bitMask = Math.pow(2, u);
        var dim = initialDims[i];
        var ranges = dim.brush.filter.get();
        if (ranges.length < 2) continue; // bail if the bounding box based filter is sufficient

        var prevEnd = expandedPixelRange(ranges[0])[1];
        for (j = 1; j < ranges.length; j++) {
          var nextRange = expandedPixelRange(ranges[j]);
          for (k = prevEnd + 1; k < nextRange[0]; k++) {
            mask[k * 8 + v] &= ~bitMask;
          }
          prevEnd = Math.max(prevEnd, nextRange[1]);
        }
      }
    }
    var textureData = {
      // 8 units x 8 bits = 64 bits, just sufficient for the almost 64 dimensions we support
      shape: [8, maskHeight],
      format: 'alpha',
      type: 'uint8',
      mag: 'nearest',
      min: 'nearest',
      data: mask
    };
    if (maskTexture) maskTexture(textureData);else maskTexture = regl.texture(textureData);
    return {
      maskTexture: maskTexture,
      maskHeight: maskHeight,
      loA: limits[0].slice(0, 16),
      loB: limits[0].slice(16, 32),
      loC: limits[0].slice(32, 48),
      loD: limits[0].slice(48, 64),
      hiA: limits[1].slice(0, 16),
      hiB: limits[1].slice(16, 32),
      hiC: limits[1].slice(32, 48),
      hiD: limits[1].slice(48, 64)
    };
  }
  function renderGLParcoords(panels, setChanged, clearOnly) {
    var panelCount = panels.length;
    var i;
    var leftmost;
    var rightmost;
    var lowestX = Infinity;
    var highestX = -Infinity;
    for (i = 0; i < panelCount; i++) {
      if (panels[i].dim0.canvasX < lowestX) {
        lowestX = panels[i].dim0.canvasX;
        leftmost = i;
      }
      if (panels[i].dim1.canvasX > highestX) {
        highestX = panels[i].dim1.canvasX;
        rightmost = i;
      }
    }
    if (panelCount === 0) {
      // clear canvas here, as the panel iteration below will not enter the loop body
      clear(regl, 0, 0, model.canvasWidth, model.canvasHeight);
    }
    var constraints = makeConstraints(isContext);
    for (i = 0; i < panelCount; i++) {
      var p = panels[i];
      var i0 = p.dim0.crossfilterDimensionIndex;
      var i1 = p.dim1.crossfilterDimensionIndex;
      var x = p.canvasX;
      var y = p.canvasY;
      var nextX = x + p.panelSizeX;
      var plotGlPixelRatio = p.plotGlPixelRatio;
      if (setChanged || !prevAxisOrder[i0] || prevAxisOrder[i0][0] !== x || prevAxisOrder[i0][1] !== nextX) {
        prevAxisOrder[i0] = [x, nextX];
        var item = makeItem(model, leftmost, rightmost, i, i0, i1, x, y, p.panelSizeX, p.panelSizeY, p.dim0.crossfilterDimensionIndex, isContext ? 0 : isPick ? 2 : 1, constraints, plotGlPixelRatio);
        renderState.clearOnly = clearOnly;
        var blockLineCount = setChanged ? model.lines.blockLineCount : sampleCount;
        renderBlock(regl, glAes, renderState, blockLineCount, sampleCount, item);
      }
    }
  }
  function readPixel(canvasX, canvasY) {
    regl.read({
      x: canvasX,
      y: canvasY,
      width: 1,
      height: 1,
      data: dataPixel
    });
    return dataPixel;
  }
  function readPixels(canvasX, canvasY, width, height) {
    var pixelArray = new Uint8Array(4 * width * height);
    regl.read({
      x: canvasX,
      y: canvasY,
      width: width,
      height: height,
      data: pixelArray
    });
    return pixelArray;
  }
  function destroy() {
    canvasGL.style['pointer-events'] = 'none';
    paletteTexture.destroy();
    if (maskTexture) maskTexture.destroy();
    for (var k in attributes) attributes[k].destroy();
  }
  return {
    render: renderGLParcoords,
    readPixel: readPixel,
    readPixels: readPixels,
    destroy: destroy,
    update: update
  };
};

/***/ }),

/***/ 63197:
/***/ (function(module) {

"use strict";


/**
 * mergeLength: set trace length as the minimum of all dimension data lengths
 *     and propagates this length into each dimension
 *
 * @param {object} traceOut: the fullData trace
 * @param {Array(object)} dimensions: array of dimension objects
 * @param {string} dataAttr: the attribute of each dimension containing the data
 * @param {integer} len: an already-existing length from other attributes
 */
module.exports = function (traceOut, dimensions, dataAttr, len) {
  if (!len) len = Infinity;
  var i, dimi;
  for (i = 0; i < dimensions.length; i++) {
    dimi = dimensions[i];
    if (dimi.visible) len = Math.min(len, dimi[dataAttr].length);
  }
  if (len === Infinity) len = 0;
  traceOut._length = len;
  for (i = 0; i < dimensions.length; i++) {
    dimi = dimensions[i];
    if (dimi.visible) dimi._length = len;
  }
  return len;
};

/***/ }),

/***/ 16019:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var Lib = __webpack_require__(34809);
var isArrayOrTypedArray = Lib.isArrayOrTypedArray;
var numberFormat = Lib.numberFormat;
var rgba = __webpack_require__(16401);
var Axes = __webpack_require__(29714);
var strRotate = Lib.strRotate;
var strTranslate = Lib.strTranslate;
var svgTextUtils = __webpack_require__(30635);
var Drawing = __webpack_require__(62203);
var Colorscale = __webpack_require__(88856);
var gup = __webpack_require__(71293);
var keyFun = gup.keyFun;
var repeat = gup.repeat;
var unwrap = gup.unwrap;
var helpers = __webpack_require__(62935);
var c = __webpack_require__(77911);
var brush = __webpack_require__(23245);
var lineLayerMaker = __webpack_require__(1293);
function findExtreme(fn, values, len) {
  return Lib.aggNums(fn, null, values, len);
}
function findExtremes(values, len) {
  return fixExtremes(findExtreme(Math.min, values, len), findExtreme(Math.max, values, len));
}
function dimensionExtent(dimension) {
  var range = dimension.range;
  return range ? fixExtremes(range[0], range[1]) : findExtremes(dimension.values, dimension._length);
}
function fixExtremes(lo, hi) {
  if (isNaN(lo) || !isFinite(lo)) {
    lo = 0;
  }
  if (isNaN(hi) || !isFinite(hi)) {
    hi = 0;
  }

  // avoid a degenerate (zero-width) domain
  if (lo === hi) {
    if (lo === 0) {
      // no use to multiplying zero, so add/subtract in this case
      lo -= 1;
      hi += 1;
    } else {
      // this keeps the range in the order of magnitude of the data
      lo *= 0.9;
      hi *= 1.1;
    }
  }
  return [lo, hi];
}
function toText(formatter, texts) {
  if (texts) {
    return function (v, i) {
      var text = texts[i];
      if (text === null || text === undefined) return formatter(v);
      return text;
    };
  }
  return formatter;
}
function domainScale(height, padding, dimension, tickvals, ticktext) {
  var extent = dimensionExtent(dimension);
  if (tickvals) {
    return d3.scale.ordinal().domain(tickvals.map(toText(numberFormat(dimension.tickformat), ticktext))).range(tickvals.map(function (d) {
      var unitVal = (d - extent[0]) / (extent[1] - extent[0]);
      return height - padding + unitVal * (2 * padding - height);
    }));
  }
  return d3.scale.linear().domain(extent).range([height - padding, padding]);
}
function unitToPaddedPx(height, padding) {
  return d3.scale.linear().range([padding, height - padding]);
}
function domainToPaddedUnitScale(dimension, padFraction) {
  return d3.scale.linear().domain(dimensionExtent(dimension)).range([padFraction, 1 - padFraction]);
}
function ordinalScale(dimension) {
  if (!dimension.tickvals) return;
  var extent = dimensionExtent(dimension);
  return d3.scale.ordinal().domain(dimension.tickvals).range(dimension.tickvals.map(function (d) {
    return (d - extent[0]) / (extent[1] - extent[0]);
  }));
}
function unitToColorScale(cscale) {
  var colorStops = cscale.map(function (d) {
    return d[0];
  });
  var colorTuples = cscale.map(function (d) {
    var RGBA = rgba(d[1]);
    return d3.rgb('rgb(' + RGBA[0] + ',' + RGBA[1] + ',' + RGBA[2] + ')');
  });
  var prop = function (n) {
    return function (o) {
      return o[n];
    };
  };

  // We can't use d3 color interpolation as we may have non-uniform color palette raster
  // (various color stop distances).
  var polylinearUnitScales = 'rgb'.split('').map(function (key) {
    return d3.scale.linear().clamp(true).domain(colorStops).range(colorTuples.map(prop(key)));
  });
  return function (d) {
    return polylinearUnitScales.map(function (s) {
      return s(d);
    });
  };
}
function someFiltersActive(view) {
  return view.dimensions.some(function (p) {
    return p.brush.filterSpecified;
  });
}
function model(layout, d, i) {
  var cd0 = unwrap(d);
  var trace = cd0.trace;
  var lineColor = helpers.convertTypedArray(cd0.lineColor);
  var line = trace.line;
  var deselectedLines = {
    color: rgba(trace.unselected.line.color),
    opacity: trace.unselected.line.opacity
  };
  var cOpts = Colorscale.extractOpts(line);
  var cscale = cOpts.reversescale ? Colorscale.flipScale(cd0.cscale) : cd0.cscale;
  var domain = trace.domain;
  var dimensions = trace.dimensions;
  var width = layout.width;
  var labelAngle = trace.labelangle;
  var labelSide = trace.labelside;
  var labelFont = trace.labelfont;
  var tickFont = trace.tickfont;
  var rangeFont = trace.rangefont;
  var lines = Lib.extendDeepNoArrays({}, line, {
    color: lineColor.map(d3.scale.linear().domain(dimensionExtent({
      values: lineColor,
      range: [cOpts.min, cOpts.max],
      _length: trace._length
    }))),
    blockLineCount: c.blockLineCount,
    canvasOverdrag: c.overdrag * c.canvasPixelRatio
  });
  var groupWidth = Math.floor(width * (domain.x[1] - domain.x[0]));
  var groupHeight = Math.floor(layout.height * (domain.y[1] - domain.y[0]));
  var pad = layout.margin || {
    l: 80,
    r: 80,
    t: 100,
    b: 80
  };
  var rowContentWidth = groupWidth;
  var rowHeight = groupHeight;
  return {
    key: i,
    colCount: dimensions.filter(helpers.isVisible).length,
    dimensions: dimensions,
    tickDistance: c.tickDistance,
    unitToColor: unitToColorScale(cscale),
    lines: lines,
    deselectedLines: deselectedLines,
    labelAngle: labelAngle,
    labelSide: labelSide,
    labelFont: labelFont,
    tickFont: tickFont,
    rangeFont: rangeFont,
    layoutWidth: width,
    layoutHeight: layout.height,
    domain: domain,
    translateX: domain.x[0] * width,
    translateY: layout.height - domain.y[1] * layout.height,
    pad: pad,
    canvasWidth: rowContentWidth * c.canvasPixelRatio + 2 * lines.canvasOverdrag,
    canvasHeight: rowHeight * c.canvasPixelRatio,
    width: rowContentWidth,
    height: rowHeight,
    canvasPixelRatio: c.canvasPixelRatio
  };
}
function viewModel(state, callbacks, model) {
  var width = model.width;
  var height = model.height;
  var dimensions = model.dimensions;
  var canvasPixelRatio = model.canvasPixelRatio;
  var xScale = function (d) {
    return width * d / Math.max(1, model.colCount - 1);
  };
  var unitPad = c.verticalPadding / height;
  var _unitToPaddedPx = unitToPaddedPx(height, c.verticalPadding);
  var vm = {
    key: model.key,
    xScale: xScale,
    model: model,
    inBrushDrag: false // consider factoring it out and putting it in a centralized global-ish gesture state object
  };
  var uniqueKeys = {};
  vm.dimensions = dimensions.filter(helpers.isVisible).map(function (dimension, i) {
    var domainToPaddedUnit = domainToPaddedUnitScale(dimension, unitPad);
    var foundKey = uniqueKeys[dimension.label];
    uniqueKeys[dimension.label] = (foundKey || 0) + 1;
    var key = dimension.label + (foundKey ? '__' + foundKey : '');
    var specifiedConstraint = dimension.constraintrange;
    var filterRangeSpecified = specifiedConstraint && specifiedConstraint.length;
    if (filterRangeSpecified && !isArrayOrTypedArray(specifiedConstraint[0])) {
      specifiedConstraint = [specifiedConstraint];
    }
    var filterRange = filterRangeSpecified ? specifiedConstraint.map(function (d) {
      return d.map(domainToPaddedUnit);
    }) : [[-Infinity, Infinity]];
    var brushMove = function () {
      var p = vm;
      p.focusLayer && p.focusLayer.render(p.panels, true);
      var filtersActive = someFiltersActive(p);
      if (!state.contextShown() && filtersActive) {
        p.contextLayer && p.contextLayer.render(p.panels, true);
        state.contextShown(true);
      } else if (state.contextShown() && !filtersActive) {
        p.contextLayer && p.contextLayer.render(p.panels, true, true);
        state.contextShown(false);
      }
    };
    var truncatedValues = dimension.values;
    if (truncatedValues.length > dimension._length) {
      truncatedValues = truncatedValues.slice(0, dimension._length);
    }
    var tickvals = dimension.tickvals;
    var ticktext;
    function makeTickItem(v, i) {
      return {
        val: v,
        text: ticktext[i]
      };
    }
    function sortTickItem(a, b) {
      return a.val - b.val;
    }
    if (isArrayOrTypedArray(tickvals) && tickvals.length) {
      if (Lib.isTypedArray(tickvals)) tickvals = Array.from(tickvals);
      ticktext = dimension.ticktext;

      // ensure ticktext and tickvals have same length
      if (!isArrayOrTypedArray(ticktext) || !ticktext.length) {
        ticktext = tickvals.map(numberFormat(dimension.tickformat));
      } else if (ticktext.length > tickvals.length) {
        ticktext = ticktext.slice(0, tickvals.length);
      } else if (tickvals.length > ticktext.length) {
        tickvals = tickvals.slice(0, ticktext.length);
      }

      // check if we need to sort tickvals/ticktext
      for (var j = 1; j < tickvals.length; j++) {
        if (tickvals[j] < tickvals[j - 1]) {
          var tickItems = tickvals.map(makeTickItem).sort(sortTickItem);
          for (var k = 0; k < tickvals.length; k++) {
            tickvals[k] = tickItems[k].val;
            ticktext[k] = tickItems[k].text;
          }
          break;
        }
      }
    } else tickvals = undefined;
    truncatedValues = helpers.convertTypedArray(truncatedValues);
    return {
      key: key,
      label: dimension.label,
      tickFormat: dimension.tickformat,
      tickvals: tickvals,
      ticktext: ticktext,
      ordinal: helpers.isOrdinal(dimension),
      multiselect: dimension.multiselect,
      xIndex: i,
      crossfilterDimensionIndex: i,
      visibleIndex: dimension._index,
      height: height,
      values: truncatedValues,
      paddedUnitValues: truncatedValues.map(domainToPaddedUnit),
      unitTickvals: tickvals && tickvals.map(domainToPaddedUnit),
      xScale: xScale,
      x: xScale(i),
      canvasX: xScale(i) * canvasPixelRatio,
      unitToPaddedPx: _unitToPaddedPx,
      domainScale: domainScale(height, c.verticalPadding, dimension, tickvals, ticktext),
      ordinalScale: ordinalScale(dimension),
      parent: vm,
      model: model,
      brush: brush.makeBrush(state, filterRangeSpecified, filterRange, function () {
        state.linePickActive(false);
      }, brushMove, function (f) {
        vm.focusLayer.render(vm.panels, true);
        vm.pickLayer && vm.pickLayer.render(vm.panels, true);
        state.linePickActive(true);
        if (callbacks && callbacks.filterChanged) {
          var invScale = domainToPaddedUnit.invert;

          // update gd.data as if a Plotly.restyle were fired
          var newRanges = f.map(function (r) {
            return r.map(invScale).sort(Lib.sorterAsc);
          }).sort(function (a, b) {
            return a[0] - b[0];
          });
          callbacks.filterChanged(vm.key, dimension._index, newRanges);
        }
      })
    };
  });
  return vm;
}
function styleExtentTexts(selection) {
  selection.classed(c.cn.axisExtentText, true).attr('text-anchor', 'middle').style('cursor', 'default');
}
function parcoordsInteractionState() {
  var linePickActive = true;
  var contextShown = false;
  return {
    linePickActive: function (val) {
      return arguments.length ? linePickActive = !!val : linePickActive;
    },
    contextShown: function (val) {
      return arguments.length ? contextShown = !!val : contextShown;
    }
  };
}
function calcTilt(angle, position) {
  var dir = position === 'top' ? 1 : -1;
  var radians = angle * Math.PI / 180;
  var dx = Math.sin(radians);
  var dy = Math.cos(radians);
  return {
    dir: dir,
    dx: dx,
    dy: dy,
    degrees: angle
  };
}
function updatePanelLayout(yAxis, vm, plotGlPixelRatio) {
  var panels = vm.panels || (vm.panels = []);
  var data = yAxis.data();
  for (var i = 0; i < data.length - 1; i++) {
    var p = panels[i] || (panels[i] = {});
    var dim0 = data[i];
    var dim1 = data[i + 1];
    p.dim0 = dim0;
    p.dim1 = dim1;
    p.canvasX = dim0.canvasX;
    p.panelSizeX = dim1.canvasX - dim0.canvasX;
    p.panelSizeY = vm.model.canvasHeight;
    p.y = 0;
    p.canvasY = 0;
    p.plotGlPixelRatio = plotGlPixelRatio;
  }
}
function calcAllTicks(cd) {
  for (var i = 0; i < cd.length; i++) {
    for (var j = 0; j < cd[i].length; j++) {
      var trace = cd[i][j].trace;
      var dimensions = trace.dimensions;
      for (var k = 0; k < dimensions.length; k++) {
        var values = dimensions[k].values;
        var dim = dimensions[k]._ax;
        if (dim) {
          if (!dim.range) {
            dim.range = findExtremes(values, trace._length);
          } else {
            dim.range = fixExtremes(dim.range[0], dim.range[1]);
          }
          if (!dim.dtick) {
            dim.dtick = 0.01 * (Math.abs(dim.range[1] - dim.range[0]) || 1);
          }
          dim.tickformat = dimensions[k].tickformat;
          Axes.calcTicks(dim);
          dim.cleanRange();
        }
      }
    }
  }
}
function linearFormat(dim, v) {
  return Axes.tickText(dim._ax, v, false).text;
}
function extremeText(d, isTop) {
  if (d.ordinal) return '';
  var domain = d.domainScale.domain();
  var v = domain[isTop ? domain.length - 1 : 0];
  return linearFormat(d.model.dimensions[d.visibleIndex], v);
}
module.exports = function parcoords(gd, cdModule, layout, callbacks) {
  var isStatic = gd._context.staticPlot;
  var fullLayout = gd._fullLayout;
  var svg = fullLayout._toppaper;
  var glContainer = fullLayout._glcontainer;
  var plotGlPixelRatio = gd._context.plotGlPixelRatio;
  var paperColor = gd._fullLayout.paper_bgcolor;
  calcAllTicks(cdModule);
  var state = parcoordsInteractionState();
  var vm = cdModule.filter(function (d) {
    return unwrap(d).trace.visible;
  }).map(model.bind(0, layout)).map(viewModel.bind(0, state, callbacks));
  glContainer.each(function (d, i) {
    return Lib.extendFlat(d, vm[i]);
  });
  var glLayers = glContainer.selectAll('.gl-canvas').each(function (d) {
    // FIXME: figure out how to handle multiple instances
    d.viewModel = vm[0];
    d.viewModel.plotGlPixelRatio = plotGlPixelRatio;
    d.viewModel.paperColor = paperColor;
    d.model = d.viewModel ? d.viewModel.model : null;
  });
  var lastHovered = null;
  var pickLayer = glLayers.filter(function (d) {
    return d.pick;
  });

  // emit hover / unhover event
  pickLayer.style('pointer-events', isStatic ? 'none' : 'auto').on('mousemove', function (d) {
    if (state.linePickActive() && d.lineLayer && callbacks && callbacks.hover) {
      var event = d3.event;
      var cw = this.width;
      var ch = this.height;
      var pointer = d3.mouse(this);
      var x = pointer[0];
      var y = pointer[1];
      if (x < 0 || y < 0 || x >= cw || y >= ch) {
        return;
      }
      var pixel = d.lineLayer.readPixel(x, ch - 1 - y);
      var found = pixel[3] !== 0;
      // inverse of the calcPickColor in `lines.js`; detailed comment there
      var curveNumber = found ? pixel[2] + 256 * (pixel[1] + 256 * pixel[0]) : null;
      var eventData = {
        x: x,
        y: y,
        clientX: event.clientX,
        clientY: event.clientY,
        dataIndex: d.model.key,
        curveNumber: curveNumber
      };
      if (curveNumber !== lastHovered) {
        // don't unnecessarily repeat the same hit (or miss)
        if (found) {
          callbacks.hover(eventData);
        } else if (callbacks.unhover) {
          callbacks.unhover(eventData);
        }
        lastHovered = curveNumber;
      }
    }
  });
  glLayers.style('opacity', function (d) {
    return d.pick ? 0 : 1;
  });
  svg.style('background', 'rgba(255, 255, 255, 0)');
  var controlOverlay = svg.selectAll('.' + c.cn.parcoords).data(vm, keyFun);
  controlOverlay.exit().remove();
  controlOverlay.enter().append('g').classed(c.cn.parcoords, true).style('shape-rendering', 'crispEdges').style('pointer-events', 'none');
  controlOverlay.attr('transform', function (d) {
    return strTranslate(d.model.translateX, d.model.translateY);
  });
  var parcoordsControlView = controlOverlay.selectAll('.' + c.cn.parcoordsControlView).data(repeat, keyFun);
  parcoordsControlView.enter().append('g').classed(c.cn.parcoordsControlView, true);
  parcoordsControlView.attr('transform', function (d) {
    return strTranslate(d.model.pad.l, d.model.pad.t);
  });
  var yAxis = parcoordsControlView.selectAll('.' + c.cn.yAxis).data(function (p) {
    return p.dimensions;
  }, keyFun);
  yAxis.enter().append('g').classed(c.cn.yAxis, true);
  parcoordsControlView.each(function (p) {
    updatePanelLayout(yAxis, p, plotGlPixelRatio);
  });
  glLayers.each(function (d) {
    if (d.viewModel) {
      if (!d.lineLayer || callbacks) {
        // recreate in case of having callbacks e.g. restyle. Should we test for callback to be a restyle?
        d.lineLayer = lineLayerMaker(this, d);
      } else d.lineLayer.update(d);
      if (d.key || d.key === 0) d.viewModel[d.key] = d.lineLayer;
      var setChanged = !d.context ||
      // don't update background
      callbacks; // unless there is a callback on the context layer. Should we test the callback?

      d.lineLayer.render(d.viewModel.panels, setChanged);
    }
  });
  yAxis.attr('transform', function (d) {
    return strTranslate(d.xScale(d.xIndex), 0);
  });

  // drag column for reordering columns
  yAxis.call(d3.behavior.drag().origin(function (d) {
    return d;
  }).on('drag', function (d) {
    var p = d.parent;
    state.linePickActive(false);
    d.x = Math.max(-c.overdrag, Math.min(d.model.width + c.overdrag, d3.event.x));
    d.canvasX = d.x * d.model.canvasPixelRatio;
    yAxis.sort(function (a, b) {
      return a.x - b.x;
    }).each(function (e, i) {
      e.xIndex = i;
      e.x = d === e ? e.x : e.xScale(e.xIndex);
      e.canvasX = e.x * e.model.canvasPixelRatio;
    });
    updatePanelLayout(yAxis, p, plotGlPixelRatio);
    yAxis.filter(function (e) {
      return Math.abs(d.xIndex - e.xIndex) !== 0;
    }).attr('transform', function (d) {
      return strTranslate(d.xScale(d.xIndex), 0);
    });
    d3.select(this).attr('transform', strTranslate(d.x, 0));
    yAxis.each(function (e, i0, i1) {
      if (i1 === d.parent.key) p.dimensions[i0] = e;
    });
    p.contextLayer && p.contextLayer.render(p.panels, false, !someFiltersActive(p));
    p.focusLayer.render && p.focusLayer.render(p.panels);
  }).on('dragend', function (d) {
    var p = d.parent;
    d.x = d.xScale(d.xIndex);
    d.canvasX = d.x * d.model.canvasPixelRatio;
    updatePanelLayout(yAxis, p, plotGlPixelRatio);
    d3.select(this).attr('transform', function (d) {
      return strTranslate(d.x, 0);
    });
    p.contextLayer && p.contextLayer.render(p.panels, false, !someFiltersActive(p));
    p.focusLayer && p.focusLayer.render(p.panels);
    p.pickLayer && p.pickLayer.render(p.panels, true);
    state.linePickActive(true);
    if (callbacks && callbacks.axesMoved) {
      callbacks.axesMoved(p.key, p.dimensions.map(function (e) {
        return e.crossfilterDimensionIndex;
      }));
    }
  }));
  yAxis.exit().remove();
  var axisOverlays = yAxis.selectAll('.' + c.cn.axisOverlays).data(repeat, keyFun);
  axisOverlays.enter().append('g').classed(c.cn.axisOverlays, true);
  axisOverlays.selectAll('.' + c.cn.axis).remove();
  var axis = axisOverlays.selectAll('.' + c.cn.axis).data(repeat, keyFun);
  axis.enter().append('g').classed(c.cn.axis, true);
  axis.each(function (d) {
    var wantedTickCount = d.model.height / d.model.tickDistance;
    var scale = d.domainScale;
    var sdom = scale.domain();
    d3.select(this).call(d3.svg.axis().orient('left').tickSize(4).outerTickSize(2).ticks(wantedTickCount, d.tickFormat) // works for continuous scales only...
    .tickValues(d.ordinal ?
    // and this works for ordinal scales
    sdom : null).tickFormat(function (v) {
      return helpers.isOrdinal(d) ? v : linearFormat(d.model.dimensions[d.visibleIndex], v);
    }).scale(scale));
    Drawing.font(axis.selectAll('text'), d.model.tickFont);
  });
  axis.selectAll('.domain, .tick>line').attr('fill', 'none').attr('stroke', 'black').attr('stroke-opacity', 0.25).attr('stroke-width', '1px');
  axis.selectAll('text').style('cursor', 'default');
  var axisHeading = axisOverlays.selectAll('.' + c.cn.axisHeading).data(repeat, keyFun);
  axisHeading.enter().append('g').classed(c.cn.axisHeading, true);
  var axisTitle = axisHeading.selectAll('.' + c.cn.axisTitle).data(repeat, keyFun);
  axisTitle.enter().append('text').classed(c.cn.axisTitle, true).attr('text-anchor', 'middle').style('cursor', 'ew-resize').style('pointer-events', isStatic ? 'none' : 'auto');
  axisTitle.text(function (d) {
    return d.label;
  }).each(function (d) {
    var e = d3.select(this);
    Drawing.font(e, d.model.labelFont);
    svgTextUtils.convertToTspans(e, gd);
  }).attr('transform', function (d) {
    var tilt = calcTilt(d.model.labelAngle, d.model.labelSide);
    var r = c.axisTitleOffset;
    return (tilt.dir > 0 ? '' : strTranslate(0, 2 * r + d.model.height)) + strRotate(tilt.degrees) + strTranslate(-r * tilt.dx, -r * tilt.dy);
  }).attr('text-anchor', function (d) {
    var tilt = calcTilt(d.model.labelAngle, d.model.labelSide);
    var adx = Math.abs(tilt.dx);
    var ady = Math.abs(tilt.dy);
    if (2 * adx > ady) {
      return tilt.dir * tilt.dx < 0 ? 'start' : 'end';
    } else {
      return 'middle';
    }
  });
  var axisExtent = axisOverlays.selectAll('.' + c.cn.axisExtent).data(repeat, keyFun);
  axisExtent.enter().append('g').classed(c.cn.axisExtent, true);
  var axisExtentTop = axisExtent.selectAll('.' + c.cn.axisExtentTop).data(repeat, keyFun);
  axisExtentTop.enter().append('g').classed(c.cn.axisExtentTop, true);
  axisExtentTop.attr('transform', strTranslate(0, -c.axisExtentOffset));
  var axisExtentTopText = axisExtentTop.selectAll('.' + c.cn.axisExtentTopText).data(repeat, keyFun);
  axisExtentTopText.enter().append('text').classed(c.cn.axisExtentTopText, true).call(styleExtentTexts);
  axisExtentTopText.text(function (d) {
    return extremeText(d, true);
  }).each(function (d) {
    Drawing.font(d3.select(this), d.model.rangeFont);
  });
  var axisExtentBottom = axisExtent.selectAll('.' + c.cn.axisExtentBottom).data(repeat, keyFun);
  axisExtentBottom.enter().append('g').classed(c.cn.axisExtentBottom, true);
  axisExtentBottom.attr('transform', function (d) {
    return strTranslate(0, d.model.height + c.axisExtentOffset);
  });
  var axisExtentBottomText = axisExtentBottom.selectAll('.' + c.cn.axisExtentBottomText).data(repeat, keyFun);
  axisExtentBottomText.enter().append('text').classed(c.cn.axisExtentBottomText, true).attr('dy', '0.75em').call(styleExtentTexts);
  axisExtentBottomText.text(function (d) {
    return extremeText(d, false);
  }).each(function (d) {
    Drawing.font(d3.select(this), d.model.rangeFont);
  });
  brush.ensureAxisBrush(axisOverlays, paperColor, gd);
};

/***/ }),

/***/ 58823:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var parcoords = __webpack_require__(16019);
var prepareRegl = __webpack_require__(22459);
var isVisible = (__webpack_require__(62935).isVisible);
var reglPrecompiled = {};
function newIndex(visibleIndices, orig, dim) {
  var origIndex = orig.indexOf(dim);
  var currentIndex = visibleIndices.indexOf(origIndex);
  if (currentIndex === -1) {
    // invisible dimensions initially go to the end
    currentIndex += orig.length;
  }
  return currentIndex;
}
function sorter(visibleIndices, orig) {
  return function sorter(d1, d2) {
    return newIndex(visibleIndices, orig, d1) - newIndex(visibleIndices, orig, d2);
  };
}
var exports = module.exports = function plot(gd, cdModule) {
  var fullLayout = gd._fullLayout;
  var success = prepareRegl(gd, [], reglPrecompiled);
  if (!success) return;
  var currentDims = {};
  var initialDims = {};
  var fullIndices = {};
  var inputIndices = {};
  var size = fullLayout._size;
  cdModule.forEach(function (d, i) {
    var trace = d[0].trace;
    fullIndices[i] = trace.index;
    var iIn = inputIndices[i] = trace._fullInput.index;
    currentDims[i] = gd.data[iIn].dimensions;
    initialDims[i] = gd.data[iIn].dimensions.slice();
  });
  var filterChanged = function (i, initialDimIndex, newRanges) {
    // Have updated `constraintrange` data on `gd.data` and raise `Plotly.restyle` event
    // without having to incur heavy UI blocking due to an actual `Plotly.restyle` call

    var dim = initialDims[i][initialDimIndex];
    var newConstraints = newRanges.map(function (r) {
      return r.slice();
    });

    // Store constraint range in preGUI
    // This one doesn't work if it's stored in pieces in _storeDirectGUIEdit
    // because it's an array of variable dimensionality. So store the whole
    // thing at once manually.
    var aStr = 'dimensions[' + initialDimIndex + '].constraintrange';
    var preGUI = fullLayout._tracePreGUI[gd._fullData[fullIndices[i]]._fullInput.uid];
    if (preGUI[aStr] === undefined) {
      var initialVal = dim.constraintrange;
      preGUI[aStr] = initialVal || null;
    }
    var fullDimension = gd._fullData[fullIndices[i]].dimensions[initialDimIndex];
    if (!newConstraints.length) {
      delete dim.constraintrange;
      delete fullDimension.constraintrange;
      newConstraints = null;
    } else {
      if (newConstraints.length === 1) newConstraints = newConstraints[0];
      dim.constraintrange = newConstraints;
      fullDimension.constraintrange = newConstraints.slice();
      // wrap in another array for restyle event data
      newConstraints = [newConstraints];
    }
    var restyleData = {};
    restyleData[aStr] = newConstraints;
    gd.emit('plotly_restyle', [restyleData, [inputIndices[i]]]);
  };
  var hover = function (eventData) {
    gd.emit('plotly_hover', eventData);
  };
  var unhover = function (eventData) {
    gd.emit('plotly_unhover', eventData);
  };
  var axesMoved = function (i, visibleIndices) {
    // Have updated order data on `gd.data` and raise `Plotly.restyle` event
    // without having to incur heavy UI blocking due to an actual `Plotly.restyle` call

    // drag&drop sorting of the visible dimensions
    var orig = sorter(visibleIndices, initialDims[i].filter(isVisible));
    currentDims[i].sort(orig);

    // invisible dimensions are not interpreted in the context of drag&drop sorting as an invisible dimension
    // cannot be dragged; they're interspersed into their original positions by this subsequent merging step
    initialDims[i].filter(function (d) {
      return !isVisible(d);
    }).sort(function (d) {
      // subsequent splicing to be done left to right, otherwise indices may be incorrect
      return initialDims[i].indexOf(d);
    }).forEach(function (d) {
      currentDims[i].splice(currentDims[i].indexOf(d), 1); // remove from the end
      currentDims[i].splice(initialDims[i].indexOf(d), 0, d); // insert at original index
    });

    // TODO: we can't really store this part of the interaction state
    // directly as below, since it incudes data arrays. If we want to
    // persist column order we may have to do something special for this
    // case to just store the order itself.
    // Registry.call('_storeDirectGUIEdit',
    //     gd.data[inputIndices[i]],
    //     fullLayout._tracePreGUI[gd._fullData[fullIndices[i]]._fullInput.uid],
    //     {dimensions: currentDims[i]}
    // );

    gd.emit('plotly_restyle', [{
      dimensions: [currentDims[i]]
    }, [inputIndices[i]]]);
  };
  parcoords(gd, cdModule, {
    // layout
    width: size.w,
    height: size.h,
    margin: {
      t: size.t,
      r: size.r,
      b: size.b,
      l: size.l
    }
  }, {
    // callbacks
    filterChanged: filterChanged,
    hover: hover,
    unhover: unhover,
    axesMoved: axesMoved
  });
};
exports.reglPrecompiled = reglPrecompiled;

/***/ }),

/***/ 55412:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var baseAttrs = __webpack_require__(9829);
var domainAttrs = (__webpack_require__(13792)/* .attributes */ .u);
var fontAttrs = __webpack_require__(80337);
var colorAttrs = __webpack_require__(10229);
var hovertemplateAttrs = (__webpack_require__(3208)/* .hovertemplateAttrs */ .rb);
var texttemplateAttrs = (__webpack_require__(3208)/* .texttemplateAttrs */ .ay);
var extendFlat = (__webpack_require__(93049).extendFlat);
var pattern = (__webpack_require__(94850)/* .pattern */ .k);
var textFontAttrs = fontAttrs({
  editType: 'plot',
  arrayOk: true,
  colorEditType: 'plot'
});
module.exports = {
  labels: {
    valType: 'data_array',
    editType: 'calc'
  },
  // equivalent of x0 and dx, if label is missing
  label0: {
    valType: 'number',
    dflt: 0,
    editType: 'calc'
  },
  dlabel: {
    valType: 'number',
    dflt: 1,
    editType: 'calc'
  },
  values: {
    valType: 'data_array',
    editType: 'calc'
  },
  marker: {
    colors: {
      valType: 'data_array',
      // TODO 'color_array' ?
      editType: 'calc'
    },
    line: {
      color: {
        valType: 'color',
        dflt: colorAttrs.defaultLine,
        arrayOk: true,
        editType: 'style'
      },
      width: {
        valType: 'number',
        min: 0,
        dflt: 0,
        arrayOk: true,
        editType: 'style'
      },
      editType: 'calc'
    },
    pattern: pattern,
    editType: 'calc'
  },
  text: {
    valType: 'data_array',
    editType: 'plot'
  },
  hovertext: {
    valType: 'string',
    dflt: '',
    arrayOk: true,
    editType: 'style'
  },
  // 'see eg:'
  // 'https://www.e-education.psu.edu/natureofgeoinfo/sites/www.e-education.psu.edu.natureofgeoinfo/files/image/hisp_pies.gif',
  // '(this example involves a map too - may someday be a whole trace type',
  // 'of its own. but the point is the size of the whole pie is important.)'
  scalegroup: {
    valType: 'string',
    dflt: '',
    editType: 'calc'
  },
  // labels (legend is handled by plots.attributes.showlegend and layout.hiddenlabels)
  textinfo: {
    valType: 'flaglist',
    flags: ['label', 'text', 'value', 'percent'],
    extras: ['none'],
    editType: 'calc'
  },
  hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
    flags: ['label', 'text', 'value', 'percent', 'name']
  }),
  hovertemplate: hovertemplateAttrs({}, {
    keys: ['label', 'color', 'value', 'percent', 'text']
  }),
  texttemplate: texttemplateAttrs({
    editType: 'plot'
  }, {
    keys: ['label', 'color', 'value', 'percent', 'text']
  }),
  textposition: {
    valType: 'enumerated',
    values: ['inside', 'outside', 'auto', 'none'],
    dflt: 'auto',
    arrayOk: true,
    editType: 'plot'
  },
  textfont: extendFlat({}, textFontAttrs, {}),
  insidetextorientation: {
    valType: 'enumerated',
    values: ['horizontal', 'radial', 'tangential', 'auto'],
    dflt: 'auto',
    editType: 'plot'
  },
  insidetextfont: extendFlat({}, textFontAttrs, {}),
  outsidetextfont: extendFlat({}, textFontAttrs, {}),
  automargin: {
    valType: 'boolean',
    dflt: false,
    editType: 'plot'
  },
  title: {
    text: {
      valType: 'string',
      dflt: '',
      editType: 'plot'
    },
    font: extendFlat({}, textFontAttrs, {}),
    position: {
      valType: 'enumerated',
      values: ['top left', 'top center', 'top right', 'middle center', 'bottom left', 'bottom center', 'bottom right'],
      editType: 'plot'
    },
    editType: 'plot'
  },
  // position and shape
  domain: domainAttrs({
    name: 'pie',
    trace: true,
    editType: 'calc'
  }),
  hole: {
    valType: 'number',
    min: 0,
    max: 1,
    dflt: 0,
    editType: 'calc'
  },
  // ordering and direction
  sort: {
    valType: 'boolean',
    dflt: true,
    editType: 'calc'
  },
  direction: {
    /**
     * there are two common conventions, both of which place the first
     * (largest, if sorted) slice with its left edge at 12 o'clock but
     * succeeding slices follow either cw or ccw from there.
     *
     * see http://visage.co/data-visualization-101-pie-charts/
     */
    valType: 'enumerated',
    values: ['clockwise', 'counterclockwise'],
    dflt: 'counterclockwise',
    editType: 'calc'
  },
  rotation: {
    valType: 'angle',
    dflt: 0,
    editType: 'calc'
  },
  pull: {
    valType: 'number',
    min: 0,
    max: 1,
    dflt: 0,
    arrayOk: true,
    editType: 'calc'
  },
  _deprecated: {
    title: {
      valType: 'string',
      dflt: '',
      editType: 'calc'
    },
    titlefont: extendFlat({}, textFontAttrs, {}),
    titleposition: {
      valType: 'enumerated',
      values: ['top left', 'top center', 'top right', 'middle center', 'bottom left', 'bottom center', 'bottom right'],
      editType: 'calc'
    }
  }
};

/***/ }),

/***/ 96052:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var plots = __webpack_require__(44122);
exports.name = 'pie';
exports.plot = function (gd, traces, transitionOpts, makeOnCompleteCallback) {
  plots.plotBasePlot(exports.name, gd, traces, transitionOpts, makeOnCompleteCallback);
};
exports.clean = function (newFullData, newFullLayout, oldFullData, oldFullLayout) {
  plots.cleanBasePlot(exports.name, newFullData, newFullLayout, oldFullData, oldFullLayout);
};

/***/ }),

/***/ 44148:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isNumeric = __webpack_require__(10721);
var tinycolor = __webpack_require__(65657);
var Color = __webpack_require__(78766);
var extendedColorWayList = {};
function calc(gd, trace) {
  var cd = [];
  var fullLayout = gd._fullLayout;
  var hiddenLabels = fullLayout.hiddenlabels || [];
  var labels = trace.labels;
  var colors = trace.marker.colors || [];
  var vals = trace.values;
  var len = trace._length;
  var hasValues = trace._hasValues && len;
  var i, pt;
  if (trace.dlabel) {
    labels = new Array(len);
    for (i = 0; i < len; i++) {
      labels[i] = String(trace.label0 + i * trace.dlabel);
    }
  }
  var allThisTraceLabels = {};
  var pullColor = makePullColorFn(fullLayout['_' + trace.type + 'colormap']);
  var vTotal = 0;
  var isAggregated = false;
  for (i = 0; i < len; i++) {
    var v, label, hidden;
    if (hasValues) {
      v = vals[i];
      if (!isNumeric(v)) continue;
      v = +v;
    } else v = 1;
    label = labels[i];
    if (label === undefined || label === '') label = i;
    label = String(label);
    var thisLabelIndex = allThisTraceLabels[label];
    if (thisLabelIndex === undefined) {
      allThisTraceLabels[label] = cd.length;
      hidden = hiddenLabels.indexOf(label) !== -1;
      if (!hidden) vTotal += v;
      cd.push({
        v: v,
        label: label,
        color: pullColor(colors[i], label),
        i: i,
        pts: [i],
        hidden: hidden
      });
    } else {
      isAggregated = true;
      pt = cd[thisLabelIndex];
      pt.v += v;
      pt.pts.push(i);
      if (!pt.hidden) vTotal += v;
      if (pt.color === false && colors[i]) {
        pt.color = pullColor(colors[i], label);
      }
    }
  }

  // Drop aggregate sums of value 0 or less
  cd = cd.filter(function (elem) {
    return elem.v >= 0;
  });
  var shouldSort = trace.type === 'funnelarea' ? isAggregated : trace.sort;
  if (shouldSort) cd.sort(function (a, b) {
    return b.v - a.v;
  });

  // include the sum of all values in the first point
  if (cd[0]) cd[0].vTotal = vTotal;
  return cd;
}
function makePullColorFn(colorMap) {
  return function pullColor(color, id) {
    if (!color) return false;
    color = tinycolor(color);
    if (!color.isValid()) return false;
    color = Color.addOpacity(color, color.getAlpha());
    if (!colorMap[id]) colorMap[id] = color;
    return color;
  };
}

/*
 * `calc` filled in (and collated) explicit colors.
 * Now we need to propagate these explicit colors to other traces,
 * and fill in default colors.
 * This is done after sorting, so we pick defaults
 * in the order slices will be displayed
 */
function crossTraceCalc(gd, plotinfo) {
  // TODO: should we name the second argument opts?
  var desiredType = (plotinfo || {}).type;
  if (!desiredType) desiredType = 'pie';
  var fullLayout = gd._fullLayout;
  var calcdata = gd.calcdata;
  var colorWay = fullLayout[desiredType + 'colorway'];
  var colorMap = fullLayout['_' + desiredType + 'colormap'];
  if (fullLayout['extend' + desiredType + 'colors']) {
    colorWay = generateExtendedColors(colorWay, extendedColorWayList);
  }
  var dfltColorCount = 0;
  for (var i = 0; i < calcdata.length; i++) {
    var cd = calcdata[i];
    var traceType = cd[0].trace.type;
    if (traceType !== desiredType) continue;
    for (var j = 0; j < cd.length; j++) {
      var pt = cd[j];
      if (pt.color === false) {
        // have we seen this label and assigned a color to it in a previous trace?
        if (colorMap[pt.label]) {
          pt.color = colorMap[pt.label];
        } else {
          colorMap[pt.label] = pt.color = colorWay[dfltColorCount % colorWay.length];
          dfltColorCount++;
        }
      }
    }
  }
}

/**
 * pick a default color from the main default set, augmented by
 * itself lighter then darker before repeating
 */
function generateExtendedColors(colorList, extendedColorWays) {
  var i;
  var colorString = JSON.stringify(colorList);
  var colors = extendedColorWays[colorString];
  if (!colors) {
    colors = colorList.slice();
    for (i = 0; i < colorList.length; i++) {
      colors.push(tinycolor(colorList[i]).lighten(20).toHexString());
    }
    for (i = 0; i < colorList.length; i++) {
      colors.push(tinycolor(colorList[i]).darken(20).toHexString());
    }
    extendedColorWays[colorString] = colors;
  }
  return colors;
}
module.exports = {
  calc: calc,
  crossTraceCalc: crossTraceCalc,
  makePullColorFn: makePullColorFn,
  generateExtendedColors: generateExtendedColors
};

/***/ }),

/***/ 46979:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isNumeric = __webpack_require__(10721);
var Lib = __webpack_require__(34809);
var attributes = __webpack_require__(55412);
var handleDomainDefaults = (__webpack_require__(13792)/* .defaults */ .N);
var handleText = (__webpack_require__(17550).handleText);
var coercePattern = (__webpack_require__(34809).coercePattern);
function handleLabelsAndValues(labels, values) {
  var hasLabels = Lib.isArrayOrTypedArray(labels);
  var hasValues = Lib.isArrayOrTypedArray(values);
  var len = Math.min(hasLabels ? labels.length : Infinity, hasValues ? values.length : Infinity);
  if (!isFinite(len)) len = 0;
  if (len && hasValues) {
    var hasPositive;
    for (var i = 0; i < len; i++) {
      var v = values[i];
      if (isNumeric(v) && v > 0) {
        hasPositive = true;
        break;
      }
    }
    if (!hasPositive) len = 0;
  }
  return {
    hasLabels: hasLabels,
    hasValues: hasValues,
    len: len
  };
}
function handleMarkerDefaults(traceIn, traceOut, layout, coerce, isPie) {
  var lineWidth = coerce('marker.line.width');
  if (lineWidth) {
    coerce('marker.line.color', isPie ? undefined : layout.paper_bgcolor // case of funnelarea, sunburst, icicle, treemap
    );
  }
  var markerColors = coerce('marker.colors');
  coercePattern(coerce, 'marker.pattern', markerColors);
  // push the marker colors (with s) to the foreground colors, to work around logic in the drawing pattern code on marker.color (without s, which is okay for a bar trace)
  if (traceIn.marker && !traceOut.marker.pattern.fgcolor) traceOut.marker.pattern.fgcolor = traceIn.marker.colors;
  if (!traceOut.marker.pattern.bgcolor) traceOut.marker.pattern.bgcolor = layout.paper_bgcolor;
}
function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
  function coerce(attr, dflt) {
    return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
  }
  var labels = coerce('labels');
  var values = coerce('values');
  var res = handleLabelsAndValues(labels, values);
  var len = res.len;
  traceOut._hasLabels = res.hasLabels;
  traceOut._hasValues = res.hasValues;
  if (!traceOut._hasLabels && traceOut._hasValues) {
    coerce('label0');
    coerce('dlabel');
  }
  if (!len) {
    traceOut.visible = false;
    return;
  }
  traceOut._length = len;
  handleMarkerDefaults(traceIn, traceOut, layout, coerce, true);
  coerce('scalegroup');
  // TODO: hole needs to be coerced to the same value within a scaleegroup

  var textData = coerce('text');
  var textTemplate = coerce('texttemplate');
  var textInfo;
  if (!textTemplate) textInfo = coerce('textinfo', Lib.isArrayOrTypedArray(textData) ? 'text+percent' : 'percent');
  coerce('hovertext');
  coerce('hovertemplate');
  if (textTemplate || textInfo && textInfo !== 'none') {
    var textposition = coerce('textposition');
    handleText(traceIn, traceOut, layout, coerce, textposition, {
      moduleHasSelected: false,
      moduleHasUnselected: false,
      moduleHasConstrain: false,
      moduleHasCliponaxis: false,
      moduleHasTextangle: false,
      moduleHasInsideanchor: false
    });
    var hasBoth = Array.isArray(textposition) || textposition === 'auto';
    var hasOutside = hasBoth || textposition === 'outside';
    if (hasOutside) {
      coerce('automargin');
    }
    if (textposition === 'inside' || textposition === 'auto' || Array.isArray(textposition)) {
      coerce('insidetextorientation');
    }
  } else if (textInfo === 'none') {
    coerce('textposition', 'none');
  }
  handleDomainDefaults(traceOut, layout, coerce);
  var hole = coerce('hole');
  var title = coerce('title.text');
  if (title) {
    var titlePosition = coerce('title.position', hole ? 'middle center' : 'top center');
    if (!hole && titlePosition === 'middle center') traceOut.title.position = 'top center';
    Lib.coerceFont(coerce, 'title.font', layout.font);
  }
  coerce('sort');
  coerce('direction');
  coerce('rotation');
  coerce('pull');
}
module.exports = {
  handleLabelsAndValues: handleLabelsAndValues,
  handleMarkerDefaults: handleMarkerDefaults,
  supplyDefaults: supplyDefaults
};

/***/ }),

/***/ 50568:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var appendArrayMultiPointValues = (__webpack_require__(36040).appendArrayMultiPointValues);

// Note: like other eventData routines, this creates the data for hover/unhover/click events
// but it has a different API and goes through a totally different pathway.
// So to ensure it doesn't get misused, it's not attached to the Pie module.
module.exports = function eventData(pt, trace) {
  var out = {
    curveNumber: trace.index,
    pointNumbers: pt.pts,
    data: trace._input,
    fullData: trace,
    label: pt.label,
    color: pt.color,
    value: pt.v,
    percent: pt.percent,
    text: pt.text,
    bbox: pt.bbox,
    // pt.v (and pt.i below) for backward compatibility
    v: pt.v
  };

  // Only include pointNumber if it's unambiguous
  if (pt.pts.length === 1) out.pointNumber = out.i = pt.pts[0];

  // Add extra data arrays to the output
  // notice that this is the multi-point version ('s' on the end!)
  // so added data will be arrays matching the pointNumbers array.
  appendArrayMultiPointValues(out, trace, pt.pts);

  // don't include obsolete fields in new funnelarea traces
  if (trace.type === 'funnelarea') {
    delete out.v;
    delete out.i;
  }
  return out;
};

/***/ }),

/***/ 75067:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Drawing = __webpack_require__(62203);
var Color = __webpack_require__(78766);
module.exports = function fillOne(s, pt, trace, gd) {
  var pattern = trace.marker.pattern;
  if (pattern && pattern.shape) {
    Drawing.pointStyle(s, trace, gd, pt);
  } else {
    Color.fill(s, pt.color);
  }
};

/***/ }),

/***/ 37252:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
function format(vRounded) {
  return vRounded.indexOf('e') !== -1 ? vRounded.replace(/[.]?0+e/, 'e') : vRounded.indexOf('.') !== -1 ? vRounded.replace(/[.]?0+$/, '') : vRounded;
}
exports.formatPiePercent = function formatPiePercent(v, separators) {
  var vRounded = format((v * 100).toPrecision(3));
  return Lib.numSeparate(vRounded, separators) + '%';
};
exports.formatPieValue = function formatPieValue(v, separators) {
  var vRounded = format(v.toPrecision(10));
  return Lib.numSeparate(vRounded, separators);
};
exports.getFirstFilled = function getFirstFilled(array, indices) {
  if (!Lib.isArrayOrTypedArray(array)) return;
  for (var i = 0; i < indices.length; i++) {
    var v = array[indices[i]];
    if (v || v === 0 || v === '') return v;
  }
};
exports.castOption = function castOption(item, indices) {
  if (Lib.isArrayOrTypedArray(item)) return exports.getFirstFilled(item, indices);else if (item) return item;
};
exports.getRotationAngle = function (rotation) {
  return (rotation === 'auto' ? 0 : rotation) * Math.PI / 180;
};

/***/ }),

/***/ 49913:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = {
  attributes: __webpack_require__(55412),
  supplyDefaults: (__webpack_require__(46979).supplyDefaults),
  supplyLayoutDefaults: __webpack_require__(13464),
  layoutAttributes: __webpack_require__(4031),
  calc: (__webpack_require__(44148).calc),
  crossTraceCalc: (__webpack_require__(44148).crossTraceCalc),
  plot: (__webpack_require__(35734).plot),
  style: __webpack_require__(140),
  styleOne: __webpack_require__(32891),
  moduleType: 'trace',
  name: 'pie',
  basePlotModule: __webpack_require__(96052),
  categories: ['pie-like', 'pie', 'showLegend'],
  meta: {}
};

/***/ }),

/***/ 4031:
/***/ (function(module) {

"use strict";


module.exports = {
  hiddenlabels: {
    valType: 'data_array',
    editType: 'calc'
  },
  piecolorway: {
    valType: 'colorlist',
    editType: 'calc'
  },
  extendpiecolors: {
    valType: 'boolean',
    dflt: true,
    editType: 'calc'
  }
};

/***/ }),

/***/ 13464:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var layoutAttributes = __webpack_require__(4031);
module.exports = function supplyLayoutDefaults(layoutIn, layoutOut) {
  function coerce(attr, dflt) {
    return Lib.coerce(layoutIn, layoutOut, layoutAttributes, attr, dflt);
  }
  coerce('hiddenlabels');
  coerce('piecolorway', layoutOut.colorway);
  coerce('extendpiecolors');
};

/***/ }),

/***/ 35734:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var Plots = __webpack_require__(44122);
var Fx = __webpack_require__(32141);
var Color = __webpack_require__(78766);
var Drawing = __webpack_require__(62203);
var Lib = __webpack_require__(34809);
var strScale = Lib.strScale;
var strTranslate = Lib.strTranslate;
var svgTextUtils = __webpack_require__(30635);
var uniformText = __webpack_require__(84102);
var recordMinTextSize = uniformText.recordMinTextSize;
var clearMinTextSize = uniformText.clearMinTextSize;
var TEXTPAD = (__webpack_require__(56155).TEXTPAD);
var helpers = __webpack_require__(37252);
var eventData = __webpack_require__(50568);
var isValidTextValue = (__webpack_require__(34809).isValidTextValue);
function plot(gd, cdModule) {
  var isStatic = gd._context.staticPlot;
  var fullLayout = gd._fullLayout;
  var gs = fullLayout._size;
  clearMinTextSize('pie', fullLayout);
  prerenderTitles(cdModule, gd);
  layoutAreas(cdModule, gs);
  var plotGroups = Lib.makeTraceGroups(fullLayout._pielayer, cdModule, 'trace').each(function (cd) {
    var plotGroup = d3.select(this);
    var cd0 = cd[0];
    var trace = cd0.trace;
    setCoords(cd);

    // TODO: miter might look better but can sometimes cause problems
    // maybe miter with a small-ish stroke-miterlimit?
    plotGroup.attr('stroke-linejoin', 'round');
    plotGroup.each(function () {
      var slices = d3.select(this).selectAll('g.slice').data(cd);
      slices.enter().append('g').classed('slice', true);
      slices.exit().remove();
      var quadrants = [[[], []],
      // y<0: x<0, x>=0
      [[], []] // y>=0: x<0, x>=0
      ];
      var hasOutsideText = false;
      slices.each(function (pt, i) {
        if (pt.hidden) {
          d3.select(this).selectAll('path,g').remove();
          return;
        }

        // to have consistent event data compared to other traces
        pt.pointNumber = pt.i;
        pt.curveNumber = trace.index;
        quadrants[pt.pxmid[1] < 0 ? 0 : 1][pt.pxmid[0] < 0 ? 0 : 1].push(pt);
        var cx = cd0.cx;
        var cy = cd0.cy;
        var sliceTop = d3.select(this);
        var slicePath = sliceTop.selectAll('path.surface').data([pt]);
        slicePath.enter().append('path').classed('surface', true).style({
          'pointer-events': isStatic ? 'none' : 'all'
        });
        sliceTop.call(attachFxHandlers, gd, cd);
        if (trace.pull) {
          var pull = +helpers.castOption(trace.pull, pt.pts) || 0;
          if (pull > 0) {
            cx += pull * pt.pxmid[0];
            cy += pull * pt.pxmid[1];
          }
        }
        pt.cxFinal = cx;
        pt.cyFinal = cy;
        function arc(start, finish, cw, scale) {
          var dx = scale * (finish[0] - start[0]);
          var dy = scale * (finish[1] - start[1]);
          return 'a' + scale * cd0.r + ',' + scale * cd0.r + ' 0 ' + pt.largeArc + (cw ? ' 1 ' : ' 0 ') + dx + ',' + dy;
        }
        var hole = trace.hole;
        if (pt.v === cd0.vTotal) {
          // 100% fails bcs arc start and end are identical
          var outerCircle = 'M' + (cx + pt.px0[0]) + ',' + (cy + pt.px0[1]) + arc(pt.px0, pt.pxmid, true, 1) + arc(pt.pxmid, pt.px0, true, 1) + 'Z';
          if (hole) {
            slicePath.attr('d', 'M' + (cx + hole * pt.px0[0]) + ',' + (cy + hole * pt.px0[1]) + arc(pt.px0, pt.pxmid, false, hole) + arc(pt.pxmid, pt.px0, false, hole) + 'Z' + outerCircle);
          } else slicePath.attr('d', outerCircle);
        } else {
          var outerArc = arc(pt.px0, pt.px1, true, 1);
          if (hole) {
            var rim = 1 - hole;
            slicePath.attr('d', 'M' + (cx + hole * pt.px1[0]) + ',' + (cy + hole * pt.px1[1]) + arc(pt.px1, pt.px0, false, hole) + 'l' + rim * pt.px0[0] + ',' + rim * pt.px0[1] + outerArc + 'Z');
          } else {
            slicePath.attr('d', 'M' + cx + ',' + cy + 'l' + pt.px0[0] + ',' + pt.px0[1] + outerArc + 'Z');
          }
        }

        // add text
        formatSliceLabel(gd, pt, cd0);
        var textPosition = helpers.castOption(trace.textposition, pt.pts);
        var sliceTextGroup = sliceTop.selectAll('g.slicetext').data(pt.text && textPosition !== 'none' ? [0] : []);
        sliceTextGroup.enter().append('g').classed('slicetext', true);
        sliceTextGroup.exit().remove();
        sliceTextGroup.each(function () {
          var sliceText = Lib.ensureSingle(d3.select(this), 'text', '', function (s) {
            // prohibit tex interpretation until we can handle
            // tex and regular text together
            s.attr('data-notex', 1);
          });
          var font = Lib.ensureUniformFontSize(gd, textPosition === 'outside' ? determineOutsideTextFont(trace, pt, fullLayout.font) : determineInsideTextFont(trace, pt, fullLayout.font));
          sliceText.text(pt.text).attr({
            class: 'slicetext',
            transform: '',
            'text-anchor': 'middle'
          }).call(Drawing.font, font).call(svgTextUtils.convertToTspans, gd);

          // position the text relative to the slice
          var textBB = Drawing.bBox(sliceText.node());
          var transform;
          if (textPosition === 'outside') {
            transform = transformOutsideText(textBB, pt);
          } else {
            transform = transformInsideText(textBB, pt, cd0);
            if (textPosition === 'auto' && transform.scale < 1) {
              var newFont = Lib.ensureUniformFontSize(gd, trace.outsidetextfont);
              sliceText.call(Drawing.font, newFont);
              textBB = Drawing.bBox(sliceText.node());
              transform = transformOutsideText(textBB, pt);
            }
          }
          var textPosAngle = transform.textPosAngle;
          var textXY = textPosAngle === undefined ? pt.pxmid : getCoords(cd0.r, textPosAngle);
          transform.targetX = cx + textXY[0] * transform.rCenter + (transform.x || 0);
          transform.targetY = cy + textXY[1] * transform.rCenter + (transform.y || 0);
          computeTransform(transform, textBB);

          // save some stuff to use later ensure no labels overlap
          if (transform.outside) {
            var targetY = transform.targetY;
            pt.yLabelMin = targetY - textBB.height / 2;
            pt.yLabelMid = targetY;
            pt.yLabelMax = targetY + textBB.height / 2;
            pt.labelExtraX = 0;
            pt.labelExtraY = 0;
            hasOutsideText = true;
          }
          transform.fontSize = font.size;
          recordMinTextSize(trace.type, transform, fullLayout);
          cd[i].transform = transform;
          Lib.setTransormAndDisplay(sliceText, transform);
        });
      });

      // add the title
      var titleTextGroup = d3.select(this).selectAll('g.titletext').data(trace.title.text ? [0] : []);
      titleTextGroup.enter().append('g').classed('titletext', true);
      titleTextGroup.exit().remove();
      titleTextGroup.each(function () {
        var titleText = Lib.ensureSingle(d3.select(this), 'text', '', function (s) {
          // prohibit tex interpretation as above
          s.attr('data-notex', 1);
        });
        var txt = trace.title.text;
        if (trace._meta) {
          txt = Lib.templateString(txt, trace._meta);
        }
        titleText.text(txt).attr({
          class: 'titletext',
          transform: '',
          'text-anchor': 'middle'
        }).call(Drawing.font, trace.title.font).call(svgTextUtils.convertToTspans, gd);
        var transform;
        if (trace.title.position === 'middle center') {
          transform = positionTitleInside(cd0);
        } else {
          transform = positionTitleOutside(cd0, gs);
        }
        titleText.attr('transform', strTranslate(transform.x, transform.y) + strScale(Math.min(1, transform.scale)) + strTranslate(transform.tx, transform.ty));
      });

      // now make sure no labels overlap (at least within one pie)
      if (hasOutsideText) scootLabels(quadrants, trace);
      plotTextLines(slices, trace);
      if (hasOutsideText && trace.automargin) {
        // TODO if we ever want to improve perf,
        // we could reuse the textBB computed above together
        // with the sliceText transform info
        var traceBbox = Drawing.bBox(plotGroup.node());
        var domain = trace.domain;
        var vpw = gs.w * (domain.x[1] - domain.x[0]);
        var vph = gs.h * (domain.y[1] - domain.y[0]);
        var xgap = (0.5 * vpw - cd0.r) / gs.w;
        var ygap = (0.5 * vph - cd0.r) / gs.h;
        Plots.autoMargin(gd, 'pie.' + trace.uid + '.automargin', {
          xl: domain.x[0] - xgap,
          xr: domain.x[1] + xgap,
          yb: domain.y[0] - ygap,
          yt: domain.y[1] + ygap,
          l: Math.max(cd0.cx - cd0.r - traceBbox.left, 0),
          r: Math.max(traceBbox.right - (cd0.cx + cd0.r), 0),
          b: Math.max(traceBbox.bottom - (cd0.cy + cd0.r), 0),
          t: Math.max(cd0.cy - cd0.r - traceBbox.top, 0),
          pad: 5
        });
      }
    });
  });

  // This is for a bug in Chrome (as of 2015-07-22, and does not affect FF)
  // if insidetextfont and outsidetextfont are different sizes, sometimes the size
  // of an "em" gets taken from the wrong element at first so lines are
  // spaced wrong. You just have to tell it to try again later and it gets fixed.
  // I have no idea why we haven't seen this in other contexts. Also, sometimes
  // it gets the initial draw correct but on redraw it gets confused.
  setTimeout(function () {
    plotGroups.selectAll('tspan').each(function () {
      var s = d3.select(this);
      if (s.attr('dy')) s.attr('dy', s.attr('dy'));
    });
  }, 0);
}

// TODO add support for transition
function plotTextLines(slices, trace) {
  slices.each(function (pt) {
    var sliceTop = d3.select(this);
    if (!pt.labelExtraX && !pt.labelExtraY) {
      sliceTop.select('path.textline').remove();
      return;
    }

    // first move the text to its new location
    var sliceText = sliceTop.select('g.slicetext text');
    pt.transform.targetX += pt.labelExtraX;
    pt.transform.targetY += pt.labelExtraY;
    Lib.setTransormAndDisplay(sliceText, pt.transform);

    // then add a line to the new location
    var lineStartX = pt.cxFinal + pt.pxmid[0];
    var lineStartY = pt.cyFinal + pt.pxmid[1];
    var textLinePath = 'M' + lineStartX + ',' + lineStartY;
    var finalX = (pt.yLabelMax - pt.yLabelMin) * (pt.pxmid[0] < 0 ? -1 : 1) / 4;
    if (pt.labelExtraX) {
      var yFromX = pt.labelExtraX * pt.pxmid[1] / pt.pxmid[0];
      var yNet = pt.yLabelMid + pt.labelExtraY - (pt.cyFinal + pt.pxmid[1]);
      if (Math.abs(yFromX) > Math.abs(yNet)) {
        textLinePath += 'l' + yNet * pt.pxmid[0] / pt.pxmid[1] + ',' + yNet + 'H' + (lineStartX + pt.labelExtraX + finalX);
      } else {
        textLinePath += 'l' + pt.labelExtraX + ',' + yFromX + 'v' + (yNet - yFromX) + 'h' + finalX;
      }
    } else {
      textLinePath += 'V' + (pt.yLabelMid + pt.labelExtraY) + 'h' + finalX;
    }
    Lib.ensureSingle(sliceTop, 'path', 'textline').call(Color.stroke, trace.outsidetextfont.color).attr({
      'stroke-width': Math.min(2, trace.outsidetextfont.size / 8),
      d: textLinePath,
      fill: 'none'
    });
  });
}
function attachFxHandlers(sliceTop, gd, cd) {
  var cd0 = cd[0];
  var cx = cd0.cx;
  var cy = cd0.cy;
  var trace = cd0.trace;
  var isFunnelArea = trace.type === 'funnelarea';

  // hover state vars
  // have we drawn a hover label, so it should be cleared later
  if (!('_hasHoverLabel' in trace)) trace._hasHoverLabel = false;
  // have we emitted a hover event, so later an unhover event should be emitted
  // note that click events do not depend on this - you can still get them
  // with hovermode: false or if you were earlier dragging, then clicked
  // in the same slice that you moused up in
  if (!('_hasHoverEvent' in trace)) trace._hasHoverEvent = false;
  sliceTop.on('mouseover', function (pt) {
    // in case fullLayout or fullData has changed without a replot
    var fullLayout2 = gd._fullLayout;
    var trace2 = gd._fullData[trace.index];
    if (gd._dragging || fullLayout2.hovermode === false) return;
    var hoverinfo = trace2.hoverinfo;
    if (Array.isArray(hoverinfo)) {
      // super hacky: we need to pull out the *first* hoverinfo from
      // pt.pts, then put it back into an array in a dummy trace
      // and call castHoverinfo on that.
      // TODO: do we want to have Fx.castHoverinfo somehow handle this?
      // it already takes an array for index, for 2D, so this seems tricky.
      hoverinfo = Fx.castHoverinfo({
        hoverinfo: [helpers.castOption(hoverinfo, pt.pts)],
        _module: trace._module
      }, fullLayout2, 0);
    }
    if (hoverinfo === 'all') hoverinfo = 'label+text+value+percent+name';

    // in case we dragged over the pie from another subplot,
    // or if hover is turned off
    if (trace2.hovertemplate || hoverinfo !== 'none' && hoverinfo !== 'skip' && hoverinfo) {
      var rInscribed = pt.rInscribed || 0;
      var hoverCenterX = cx + pt.pxmid[0] * (1 - rInscribed);
      var hoverCenterY = cy + pt.pxmid[1] * (1 - rInscribed);
      var separators = fullLayout2.separators;
      var text = [];
      if (hoverinfo && hoverinfo.indexOf('label') !== -1) text.push(pt.label);
      pt.text = helpers.castOption(trace2.hovertext || trace2.text, pt.pts);
      if (hoverinfo && hoverinfo.indexOf('text') !== -1) {
        var tx = pt.text;
        if (Lib.isValidTextValue(tx)) text.push(tx);
      }
      pt.value = pt.v;
      pt.valueLabel = helpers.formatPieValue(pt.v, separators);
      if (hoverinfo && hoverinfo.indexOf('value') !== -1) text.push(pt.valueLabel);
      pt.percent = pt.v / cd0.vTotal;
      pt.percentLabel = helpers.formatPiePercent(pt.percent, separators);
      if (hoverinfo && hoverinfo.indexOf('percent') !== -1) text.push(pt.percentLabel);
      var hoverLabel = trace2.hoverlabel;
      var hoverFont = hoverLabel.font;
      var bbox = [];
      Fx.loneHover({
        trace: trace,
        x0: hoverCenterX - rInscribed * cd0.r,
        x1: hoverCenterX + rInscribed * cd0.r,
        y: hoverCenterY,
        _x0: isFunnelArea ? cx + pt.TL[0] : hoverCenterX - rInscribed * cd0.r,
        _x1: isFunnelArea ? cx + pt.TR[0] : hoverCenterX + rInscribed * cd0.r,
        _y0: isFunnelArea ? cy + pt.TL[1] : hoverCenterY - rInscribed * cd0.r,
        _y1: isFunnelArea ? cy + pt.BL[1] : hoverCenterY + rInscribed * cd0.r,
        text: text.join('<br>'),
        name: trace2.hovertemplate || hoverinfo.indexOf('name') !== -1 ? trace2.name : undefined,
        idealAlign: pt.pxmid[0] < 0 ? 'left' : 'right',
        color: helpers.castOption(hoverLabel.bgcolor, pt.pts) || pt.color,
        borderColor: helpers.castOption(hoverLabel.bordercolor, pt.pts),
        fontFamily: helpers.castOption(hoverFont.family, pt.pts),
        fontSize: helpers.castOption(hoverFont.size, pt.pts),
        fontColor: helpers.castOption(hoverFont.color, pt.pts),
        nameLength: helpers.castOption(hoverLabel.namelength, pt.pts),
        textAlign: helpers.castOption(hoverLabel.align, pt.pts),
        hovertemplate: helpers.castOption(trace2.hovertemplate, pt.pts),
        hovertemplateLabels: pt,
        eventData: [eventData(pt, trace2)]
      }, {
        container: fullLayout2._hoverlayer.node(),
        outerContainer: fullLayout2._paper.node(),
        gd: gd,
        inOut_bbox: bbox
      });
      pt.bbox = bbox[0];
      trace._hasHoverLabel = true;
    }
    trace._hasHoverEvent = true;
    gd.emit('plotly_hover', {
      points: [eventData(pt, trace2)],
      event: d3.event
    });
  });
  sliceTop.on('mouseout', function (evt) {
    var fullLayout2 = gd._fullLayout;
    var trace2 = gd._fullData[trace.index];
    var pt = d3.select(this).datum();
    if (trace._hasHoverEvent) {
      evt.originalEvent = d3.event;
      gd.emit('plotly_unhover', {
        points: [eventData(pt, trace2)],
        event: d3.event
      });
      trace._hasHoverEvent = false;
    }
    if (trace._hasHoverLabel) {
      Fx.loneUnhover(fullLayout2._hoverlayer.node());
      trace._hasHoverLabel = false;
    }
  });
  sliceTop.on('click', function (pt) {
    // TODO: this does not support right-click. If we want to support it, we
    // would likely need to change pie to use dragElement instead of straight
    // map subplot event binding. Or perhaps better, make a simple wrapper with the
    // right mousedown, mousemove, and mouseup handlers just for a left/right click
    // map subplots would use this too.
    var fullLayout2 = gd._fullLayout;
    var trace2 = gd._fullData[trace.index];
    if (gd._dragging || fullLayout2.hovermode === false) return;
    gd._hoverdata = [eventData(pt, trace2)];
    Fx.click(gd, d3.event);
  });
}
function determineOutsideTextFont(trace, pt, layoutFont) {
  var color = helpers.castOption(trace.outsidetextfont.color, pt.pts) || helpers.castOption(trace.textfont.color, pt.pts) || layoutFont.color;
  var family = helpers.castOption(trace.outsidetextfont.family, pt.pts) || helpers.castOption(trace.textfont.family, pt.pts) || layoutFont.family;
  var size = helpers.castOption(trace.outsidetextfont.size, pt.pts) || helpers.castOption(trace.textfont.size, pt.pts) || layoutFont.size;
  var weight = helpers.castOption(trace.outsidetextfont.weight, pt.pts) || helpers.castOption(trace.textfont.weight, pt.pts) || layoutFont.weight;
  var style = helpers.castOption(trace.outsidetextfont.style, pt.pts) || helpers.castOption(trace.textfont.style, pt.pts) || layoutFont.style;
  var variant = helpers.castOption(trace.outsidetextfont.variant, pt.pts) || helpers.castOption(trace.textfont.variant, pt.pts) || layoutFont.variant;
  var textcase = helpers.castOption(trace.outsidetextfont.textcase, pt.pts) || helpers.castOption(trace.textfont.textcase, pt.pts) || layoutFont.textcase;
  var lineposition = helpers.castOption(trace.outsidetextfont.lineposition, pt.pts) || helpers.castOption(trace.textfont.lineposition, pt.pts) || layoutFont.lineposition;
  var shadow = helpers.castOption(trace.outsidetextfont.shadow, pt.pts) || helpers.castOption(trace.textfont.shadow, pt.pts) || layoutFont.shadow;
  return {
    color: color,
    family: family,
    size: size,
    weight: weight,
    style: style,
    variant: variant,
    textcase: textcase,
    lineposition: lineposition,
    shadow: shadow
  };
}
function determineInsideTextFont(trace, pt, layoutFont) {
  var customColor = helpers.castOption(trace.insidetextfont.color, pt.pts);
  if (!customColor && trace._input.textfont) {
    // Why not simply using trace.textfont? Because if not set, it
    // defaults to layout.font which has a default color. But if
    // textfont.color and insidetextfont.color don't supply a value,
    // a contrasting color shall be used.
    customColor = helpers.castOption(trace._input.textfont.color, pt.pts);
  }
  var family = helpers.castOption(trace.insidetextfont.family, pt.pts) || helpers.castOption(trace.textfont.family, pt.pts) || layoutFont.family;
  var size = helpers.castOption(trace.insidetextfont.size, pt.pts) || helpers.castOption(trace.textfont.size, pt.pts) || layoutFont.size;
  var weight = helpers.castOption(trace.insidetextfont.weight, pt.pts) || helpers.castOption(trace.textfont.weight, pt.pts) || layoutFont.weight;
  var style = helpers.castOption(trace.insidetextfont.style, pt.pts) || helpers.castOption(trace.textfont.style, pt.pts) || layoutFont.style;
  var variant = helpers.castOption(trace.insidetextfont.variant, pt.pts) || helpers.castOption(trace.textfont.variant, pt.pts) || layoutFont.variant;
  var textcase = helpers.castOption(trace.insidetextfont.textcase, pt.pts) || helpers.castOption(trace.textfont.textcase, pt.pts) || layoutFont.textcase;
  var lineposition = helpers.castOption(trace.insidetextfont.lineposition, pt.pts) || helpers.castOption(trace.textfont.lineposition, pt.pts) || layoutFont.lineposition;
  var shadow = helpers.castOption(trace.insidetextfont.shadow, pt.pts) || helpers.castOption(trace.textfont.shadow, pt.pts) || layoutFont.shadow;
  return {
    color: customColor || Color.contrast(pt.color),
    family: family,
    size: size,
    weight: weight,
    style: style,
    variant: variant,
    textcase: textcase,
    lineposition: lineposition,
    shadow: shadow
  };
}
function prerenderTitles(cdModule, gd) {
  var cd0, trace;

  // Determine the width and height of the title for each pie.
  for (var i = 0; i < cdModule.length; i++) {
    cd0 = cdModule[i][0];
    trace = cd0.trace;
    if (trace.title.text) {
      var txt = trace.title.text;
      if (trace._meta) {
        txt = Lib.templateString(txt, trace._meta);
      }
      var dummyTitle = Drawing.tester.append('text').attr('data-notex', 1).text(txt).call(Drawing.font, trace.title.font).call(svgTextUtils.convertToTspans, gd);
      var bBox = Drawing.bBox(dummyTitle.node(), true);
      cd0.titleBox = {
        width: bBox.width,
        height: bBox.height
      };
      dummyTitle.remove();
    }
  }
}
function transformInsideText(textBB, pt, cd0) {
  var r = cd0.r || pt.rpx1;
  var rInscribed = pt.rInscribed;
  var isEmpty = pt.startangle === pt.stopangle;
  if (isEmpty) {
    return {
      rCenter: 1 - rInscribed,
      scale: 0,
      rotate: 0,
      textPosAngle: 0
    };
  }
  var ring = pt.ring;
  var isCircle = ring === 1 && Math.abs(pt.startangle - pt.stopangle) === Math.PI * 2;
  var halfAngle = pt.halfangle;
  var midAngle = pt.midangle;
  var orientation = cd0.trace.insidetextorientation;
  var isHorizontal = orientation === 'horizontal';
  var isTangential = orientation === 'tangential';
  var isRadial = orientation === 'radial';
  var isAuto = orientation === 'auto';
  var allTransforms = [];
  var newT;
  if (!isAuto) {
    // max size if text is placed (horizontally) at the top or bottom of the arc

    var considerCrossing = function (angle, key) {
      if (isCrossing(pt, angle)) {
        var dStart = Math.abs(angle - pt.startangle);
        var dStop = Math.abs(angle - pt.stopangle);
        var closestEdge = dStart < dStop ? dStart : dStop;
        if (key === 'tan') {
          newT = calcTanTransform(textBB, r, ring, closestEdge, 0);
        } else {
          // case of 'rad'
          newT = calcRadTransform(textBB, r, ring, closestEdge, Math.PI / 2);
        }
        newT.textPosAngle = angle;
        allTransforms.push(newT);
      }
    };

    // to cover all cases with trace.rotation added
    var i;
    if (isHorizontal || isTangential) {
      // top
      for (i = 4; i >= -4; i -= 2) considerCrossing(Math.PI * i, 'tan');
      // bottom
      for (i = 4; i >= -4; i -= 2) considerCrossing(Math.PI * (i + 1), 'tan');
    }
    if (isHorizontal || isRadial) {
      // left
      for (i = 4; i >= -4; i -= 2) considerCrossing(Math.PI * (i + 1.5), 'rad');
      // right
      for (i = 4; i >= -4; i -= 2) considerCrossing(Math.PI * (i + 0.5), 'rad');
    }
  }
  if (isCircle || isAuto || isHorizontal) {
    // max size text can be inserted inside without rotating it
    // this inscribes the text rectangle in a circle, which is then inscribed
    // in the slice, so it will be an underestimate, which some day we may want
    // to improve so this case can get more use
    var textDiameter = Math.sqrt(textBB.width * textBB.width + textBB.height * textBB.height);
    newT = {
      scale: rInscribed * r * 2 / textDiameter,
      // and the center position and rotation in this case
      rCenter: 1 - rInscribed,
      rotate: 0
    };
    newT.textPosAngle = (pt.startangle + pt.stopangle) / 2;
    if (newT.scale >= 1) return newT;
    allTransforms.push(newT);
  }
  if (isAuto || isRadial) {
    newT = calcRadTransform(textBB, r, ring, halfAngle, midAngle);
    newT.textPosAngle = (pt.startangle + pt.stopangle) / 2;
    allTransforms.push(newT);
  }
  if (isAuto || isTangential) {
    newT = calcTanTransform(textBB, r, ring, halfAngle, midAngle);
    newT.textPosAngle = (pt.startangle + pt.stopangle) / 2;
    allTransforms.push(newT);
  }
  var id = 0;
  var maxScale = 0;
  for (var k = 0; k < allTransforms.length; k++) {
    var s = allTransforms[k].scale;
    if (maxScale < s) {
      maxScale = s;
      id = k;
    }
    if (!isAuto && maxScale >= 1) {
      // respect test order for non-auto options
      break;
    }
  }
  return allTransforms[id];
}
function isCrossing(pt, angle) {
  var start = pt.startangle;
  var stop = pt.stopangle;
  return start > angle && angle > stop || start < angle && angle < stop;
}
function calcRadTransform(textBB, r, ring, halfAngle, midAngle) {
  r = Math.max(0, r - 2 * TEXTPAD);

  // max size if text is rotated radially
  var a = textBB.width / textBB.height;
  var s = calcMaxHalfSize(a, halfAngle, r, ring);
  return {
    scale: s * 2 / textBB.height,
    rCenter: calcRCenter(a, s / r),
    rotate: calcRotate(midAngle)
  };
}
function calcTanTransform(textBB, r, ring, halfAngle, midAngle) {
  r = Math.max(0, r - 2 * TEXTPAD);

  // max size if text is rotated tangentially
  var a = textBB.height / textBB.width;
  var s = calcMaxHalfSize(a, halfAngle, r, ring);
  return {
    scale: s * 2 / textBB.width,
    rCenter: calcRCenter(a, s / r),
    rotate: calcRotate(midAngle + Math.PI / 2)
  };
}
function calcRCenter(a, b) {
  return Math.cos(b) - a * b;
}
function calcRotate(t) {
  return (180 / Math.PI * t + 720) % 180 - 90;
}
function calcMaxHalfSize(a, halfAngle, r, ring) {
  var q = a + 1 / (2 * Math.tan(halfAngle));
  return r * Math.min(1 / (Math.sqrt(q * q + 0.5) + q), ring / (Math.sqrt(a * a + ring / 2) + a));
}
function getInscribedRadiusFraction(pt, cd0) {
  if (pt.v === cd0.vTotal && !cd0.trace.hole) return 1; // special case of 100% with no hole

  return Math.min(1 / (1 + 1 / Math.sin(pt.halfangle)), pt.ring / 2);
}
function transformOutsideText(textBB, pt) {
  var x = pt.pxmid[0];
  var y = pt.pxmid[1];
  var dx = textBB.width / 2;
  var dy = textBB.height / 2;
  if (x < 0) dx *= -1;
  if (y < 0) dy *= -1;
  return {
    scale: 1,
    rCenter: 1,
    rotate: 0,
    x: dx + Math.abs(dy) * (dx > 0 ? 1 : -1) / 2,
    y: dy / (1 + x * x / (y * y)),
    outside: true
  };
}
function positionTitleInside(cd0) {
  var textDiameter = Math.sqrt(cd0.titleBox.width * cd0.titleBox.width + cd0.titleBox.height * cd0.titleBox.height);
  return {
    x: cd0.cx,
    y: cd0.cy,
    scale: cd0.trace.hole * cd0.r * 2 / textDiameter,
    tx: 0,
    ty: -cd0.titleBox.height / 2 + cd0.trace.title.font.size
  };
}
function positionTitleOutside(cd0, plotSize) {
  var scaleX = 1;
  var scaleY = 1;
  var maxPull;
  var trace = cd0.trace;
  // position of the baseline point of the text box in the plot, before scaling.
  // we anchored the text in the middle, so the baseline is on the bottom middle
  // of the first line of text.
  var topMiddle = {
    x: cd0.cx,
    y: cd0.cy
  };
  // relative translation of the text box after scaling
  var translate = {
    tx: 0,
    ty: 0
  };

  // we reason below as if the baseline is the top middle point of the text box.
  // so we must add the font size to approximate the y-coord. of the top.
  // note that this correction must happen after scaling.
  translate.ty += trace.title.font.size;
  maxPull = getMaxPull(trace);
  if (trace.title.position.indexOf('top') !== -1) {
    topMiddle.y -= (1 + maxPull) * cd0.r;
    translate.ty -= cd0.titleBox.height;
  } else if (trace.title.position.indexOf('bottom') !== -1) {
    topMiddle.y += (1 + maxPull) * cd0.r;
  }
  var rx = applyAspectRatio(cd0.r, cd0.trace.aspectratio);
  var maxWidth = plotSize.w * (trace.domain.x[1] - trace.domain.x[0]) / 2;
  if (trace.title.position.indexOf('left') !== -1) {
    // we start the text at the left edge of the pie
    maxWidth = maxWidth + rx;
    topMiddle.x -= (1 + maxPull) * rx;
    translate.tx += cd0.titleBox.width / 2;
  } else if (trace.title.position.indexOf('center') !== -1) {
    maxWidth *= 2;
  } else if (trace.title.position.indexOf('right') !== -1) {
    maxWidth = maxWidth + rx;
    topMiddle.x += (1 + maxPull) * rx;
    translate.tx -= cd0.titleBox.width / 2;
  }
  scaleX = maxWidth / cd0.titleBox.width;
  scaleY = getTitleSpace(cd0, plotSize) / cd0.titleBox.height;
  return {
    x: topMiddle.x,
    y: topMiddle.y,
    scale: Math.min(scaleX, scaleY),
    tx: translate.tx,
    ty: translate.ty
  };
}
function applyAspectRatio(x, aspectratio) {
  return x / (aspectratio === undefined ? 1 : aspectratio);
}
function getTitleSpace(cd0, plotSize) {
  var trace = cd0.trace;
  var pieBoxHeight = plotSize.h * (trace.domain.y[1] - trace.domain.y[0]);
  // use at most half of the plot for the title
  return Math.min(cd0.titleBox.height, pieBoxHeight / 2);
}
function getMaxPull(trace) {
  var maxPull = trace.pull;
  if (!maxPull) return 0;
  var j;
  if (Lib.isArrayOrTypedArray(maxPull)) {
    maxPull = 0;
    for (j = 0; j < trace.pull.length; j++) {
      if (trace.pull[j] > maxPull) maxPull = trace.pull[j];
    }
  }
  return maxPull;
}
function scootLabels(quadrants, trace) {
  var xHalf, yHalf, equatorFirst, farthestX, farthestY, xDiffSign, yDiffSign, thisQuad, oppositeQuad, wholeSide, i, thisQuadOutside, firstOppositeOutsidePt;
  function topFirst(a, b) {
    return a.pxmid[1] - b.pxmid[1];
  }
  function bottomFirst(a, b) {
    return b.pxmid[1] - a.pxmid[1];
  }
  function scootOneLabel(thisPt, prevPt) {
    if (!prevPt) prevPt = {};
    var prevOuterY = prevPt.labelExtraY + (yHalf ? prevPt.yLabelMax : prevPt.yLabelMin);
    var thisInnerY = yHalf ? thisPt.yLabelMin : thisPt.yLabelMax;
    var thisOuterY = yHalf ? thisPt.yLabelMax : thisPt.yLabelMin;
    var thisSliceOuterY = thisPt.cyFinal + farthestY(thisPt.px0[1], thisPt.px1[1]);
    var newExtraY = prevOuterY - thisInnerY;
    var xBuffer, i, otherPt, otherOuterY, otherOuterX, newExtraX;

    // make sure this label doesn't overlap other labels
    // this *only* has us move these labels vertically
    if (newExtraY * yDiffSign > 0) thisPt.labelExtraY = newExtraY;

    // make sure this label doesn't overlap any slices
    if (!Lib.isArrayOrTypedArray(trace.pull)) return; // this can only happen with array pulls

    for (i = 0; i < wholeSide.length; i++) {
      otherPt = wholeSide[i];

      // overlap can only happen if the other point is pulled more than this one
      if (otherPt === thisPt || (helpers.castOption(trace.pull, thisPt.pts) || 0) >= (helpers.castOption(trace.pull, otherPt.pts) || 0)) {
        continue;
      }
      if ((thisPt.pxmid[1] - otherPt.pxmid[1]) * yDiffSign > 0) {
        // closer to the equator - by construction all of these happen first
        // move the text vertically to get away from these slices
        otherOuterY = otherPt.cyFinal + farthestY(otherPt.px0[1], otherPt.px1[1]);
        newExtraY = otherOuterY - thisInnerY - thisPt.labelExtraY;
        if (newExtraY * yDiffSign > 0) thisPt.labelExtraY += newExtraY;
      } else if ((thisOuterY + thisPt.labelExtraY - thisSliceOuterY) * yDiffSign > 0) {
        // farther from the equator - happens after we've done all the
        // vertical moving we're going to do
        // move horizontally to get away from these more polar slices

        // if we're moving horz. based on a slice that's several slices away from this one
        // then we need some extra space for the lines to labels between them
        xBuffer = 3 * xDiffSign * Math.abs(i - wholeSide.indexOf(thisPt));
        otherOuterX = otherPt.cxFinal + farthestX(otherPt.px0[0], otherPt.px1[0]);
        newExtraX = otherOuterX + xBuffer - (thisPt.cxFinal + thisPt.pxmid[0]) - thisPt.labelExtraX;
        if (newExtraX * xDiffSign > 0) thisPt.labelExtraX += newExtraX;
      }
    }
  }
  for (yHalf = 0; yHalf < 2; yHalf++) {
    equatorFirst = yHalf ? topFirst : bottomFirst;
    farthestY = yHalf ? Math.max : Math.min;
    yDiffSign = yHalf ? 1 : -1;
    for (xHalf = 0; xHalf < 2; xHalf++) {
      farthestX = xHalf ? Math.max : Math.min;
      xDiffSign = xHalf ? 1 : -1;

      // first sort the array
      // note this is a copy of cd, so cd itself doesn't get sorted
      // but we can still modify points in place.
      thisQuad = quadrants[yHalf][xHalf];
      thisQuad.sort(equatorFirst);
      oppositeQuad = quadrants[1 - yHalf][xHalf];
      wholeSide = oppositeQuad.concat(thisQuad);
      thisQuadOutside = [];
      for (i = 0; i < thisQuad.length; i++) {
        if (thisQuad[i].yLabelMid !== undefined) thisQuadOutside.push(thisQuad[i]);
      }
      firstOppositeOutsidePt = false;
      for (i = 0; yHalf && i < oppositeQuad.length; i++) {
        if (oppositeQuad[i].yLabelMid !== undefined) {
          firstOppositeOutsidePt = oppositeQuad[i];
          break;
        }
      }

      // each needs to avoid the previous
      for (i = 0; i < thisQuadOutside.length; i++) {
        var prevPt = i && thisQuadOutside[i - 1];
        // bottom half needs to avoid the first label of the top half
        // top half we still need to call scootOneLabel on the first slice
        // so we can avoid other slices, but we don't pass a prevPt
        if (firstOppositeOutsidePt && !i) prevPt = firstOppositeOutsidePt;
        scootOneLabel(thisQuadOutside[i], prevPt);
      }
    }
  }
}
function layoutAreas(cdModule, plotSize) {
  var scaleGroups = [];

  // figure out the center and maximum radius
  for (var i = 0; i < cdModule.length; i++) {
    var cd0 = cdModule[i][0];
    var trace = cd0.trace;
    var domain = trace.domain;
    var width = plotSize.w * (domain.x[1] - domain.x[0]);
    var height = plotSize.h * (domain.y[1] - domain.y[0]);
    // leave some space for the title, if it will be displayed outside
    if (trace.title.text && trace.title.position !== 'middle center') {
      height -= getTitleSpace(cd0, plotSize);
    }
    var rx = width / 2;
    var ry = height / 2;
    if (trace.type === 'funnelarea' && !trace.scalegroup) {
      ry /= trace.aspectratio;
    }
    cd0.r = Math.min(rx, ry) / (1 + getMaxPull(trace));
    cd0.cx = plotSize.l + plotSize.w * (trace.domain.x[1] + trace.domain.x[0]) / 2;
    cd0.cy = plotSize.t + plotSize.h * (1 - trace.domain.y[0]) - height / 2;
    if (trace.title.text && trace.title.position.indexOf('bottom') !== -1) {
      cd0.cy -= getTitleSpace(cd0, plotSize);
    }
    if (trace.scalegroup && scaleGroups.indexOf(trace.scalegroup) === -1) {
      scaleGroups.push(trace.scalegroup);
    }
  }
  groupScale(cdModule, scaleGroups);
}
function groupScale(cdModule, scaleGroups) {
  var cd0, i, trace;

  // scale those that are grouped
  for (var k = 0; k < scaleGroups.length; k++) {
    var min = Infinity;
    var g = scaleGroups[k];
    for (i = 0; i < cdModule.length; i++) {
      cd0 = cdModule[i][0];
      trace = cd0.trace;
      if (trace.scalegroup === g) {
        var area;
        if (trace.type === 'pie') {
          area = cd0.r * cd0.r;
        } else if (trace.type === 'funnelarea') {
          var rx, ry;
          if (trace.aspectratio > 1) {
            rx = cd0.r;
            ry = rx / trace.aspectratio;
          } else {
            ry = cd0.r;
            rx = ry * trace.aspectratio;
          }
          rx *= (1 + trace.baseratio) / 2;
          area = rx * ry;
        }
        min = Math.min(min, area / cd0.vTotal);
      }
    }
    for (i = 0; i < cdModule.length; i++) {
      cd0 = cdModule[i][0];
      trace = cd0.trace;
      if (trace.scalegroup === g) {
        var v = min * cd0.vTotal;
        if (trace.type === 'funnelarea') {
          v /= (1 + trace.baseratio) / 2;
          v /= trace.aspectratio;
        }
        cd0.r = Math.sqrt(v);
      }
    }
  }
}
function setCoords(cd) {
  var cd0 = cd[0];
  var r = cd0.r;
  var trace = cd0.trace;
  var currentAngle = helpers.getRotationAngle(trace.rotation);
  var angleFactor = 2 * Math.PI / cd0.vTotal;
  var firstPt = 'px0';
  var lastPt = 'px1';
  var i, cdi, currentCoords;
  if (trace.direction === 'counterclockwise') {
    for (i = 0; i < cd.length; i++) {
      if (!cd[i].hidden) break; // find the first non-hidden slice
    }
    if (i === cd.length) return; // all slices hidden

    currentAngle += angleFactor * cd[i].v;
    angleFactor *= -1;
    firstPt = 'px1';
    lastPt = 'px0';
  }
  currentCoords = getCoords(r, currentAngle);
  for (i = 0; i < cd.length; i++) {
    cdi = cd[i];
    if (cdi.hidden) continue;
    cdi[firstPt] = currentCoords;
    cdi.startangle = currentAngle;
    currentAngle += angleFactor * cdi.v / 2;
    cdi.pxmid = getCoords(r, currentAngle);
    cdi.midangle = currentAngle;
    currentAngle += angleFactor * cdi.v / 2;
    currentCoords = getCoords(r, currentAngle);
    cdi.stopangle = currentAngle;
    cdi[lastPt] = currentCoords;
    cdi.largeArc = cdi.v > cd0.vTotal / 2 ? 1 : 0;
    cdi.halfangle = Math.PI * Math.min(cdi.v / cd0.vTotal, 0.5);
    cdi.ring = 1 - trace.hole;
    cdi.rInscribed = getInscribedRadiusFraction(cdi, cd0);
  }
}
function getCoords(r, angle) {
  return [r * Math.sin(angle), -r * Math.cos(angle)];
}
function formatSliceLabel(gd, pt, cd0) {
  var fullLayout = gd._fullLayout;
  var trace = cd0.trace;
  // look for textemplate
  var texttemplate = trace.texttemplate;

  // now insert text
  var textinfo = trace.textinfo;
  if (!texttemplate && textinfo && textinfo !== 'none') {
    var parts = textinfo.split('+');
    var hasFlag = function (flag) {
      return parts.indexOf(flag) !== -1;
    };
    var hasLabel = hasFlag('label');
    var hasText = hasFlag('text');
    var hasValue = hasFlag('value');
    var hasPercent = hasFlag('percent');
    var separators = fullLayout.separators;
    var text;
    text = hasLabel ? [pt.label] : [];
    if (hasText) {
      var tx = helpers.getFirstFilled(trace.text, pt.pts);
      if (isValidTextValue(tx)) text.push(tx);
    }
    if (hasValue) text.push(helpers.formatPieValue(pt.v, separators));
    if (hasPercent) text.push(helpers.formatPiePercent(pt.v / cd0.vTotal, separators));
    pt.text = text.join('<br>');
  }
  function makeTemplateVariables(pt) {
    return {
      label: pt.label,
      value: pt.v,
      valueLabel: helpers.formatPieValue(pt.v, fullLayout.separators),
      percent: pt.v / cd0.vTotal,
      percentLabel: helpers.formatPiePercent(pt.v / cd0.vTotal, fullLayout.separators),
      color: pt.color,
      text: pt.text,
      customdata: Lib.castOption(trace, pt.i, 'customdata')
    };
  }
  if (texttemplate) {
    var txt = Lib.castOption(trace, pt.i, 'texttemplate');
    if (!txt) {
      pt.text = '';
    } else {
      var obj = makeTemplateVariables(pt);
      var ptTx = helpers.getFirstFilled(trace.text, pt.pts);
      if (isValidTextValue(ptTx) || ptTx === '') obj.text = ptTx;
      pt.text = Lib.texttemplateString(txt, obj, gd._fullLayout._d3locale, obj, trace._meta || {});
    }
  }
}
function computeTransform(transform,
// inout
textBB // in
) {
  var a = transform.rotate * Math.PI / 180;
  var cosA = Math.cos(a);
  var sinA = Math.sin(a);
  var midX = (textBB.left + textBB.right) / 2;
  var midY = (textBB.top + textBB.bottom) / 2;
  transform.textX = midX * cosA - midY * sinA;
  transform.textY = midX * sinA + midY * cosA;
  transform.noCenter = true;
}
module.exports = {
  plot: plot,
  formatSliceLabel: formatSliceLabel,
  transformInsideText: transformInsideText,
  determineInsideTextFont: determineInsideTextFont,
  positionTitleOutside: positionTitleOutside,
  prerenderTitles: prerenderTitles,
  layoutAreas: layoutAreas,
  attachFxHandlers: attachFxHandlers,
  computeTransform: computeTransform
};

/***/ }),

/***/ 140:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var styleOne = __webpack_require__(32891);
var resizeText = (__webpack_require__(84102).resizeText);
module.exports = function style(gd) {
  var s = gd._fullLayout._pielayer.selectAll('.trace');
  resizeText(gd, s, 'pie');
  s.each(function (cd) {
    var cd0 = cd[0];
    var trace = cd0.trace;
    var traceSelection = d3.select(this);
    traceSelection.style({
      opacity: trace.opacity
    });
    traceSelection.selectAll('path.surface').each(function (pt) {
      d3.select(this).call(styleOne, pt, trace, gd);
    });
  });
};

/***/ }),

/***/ 32891:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Color = __webpack_require__(78766);
var castOption = (__webpack_require__(37252).castOption);
var fillOne = __webpack_require__(75067);
module.exports = function styleOne(s, pt, trace, gd) {
  var line = trace.marker.line;
  var lineColor = castOption(line.color, pt.pts) || Color.defaultLine;
  var lineWidth = castOption(line.width, pt.pts) || 0;
  s.call(fillOne, pt, trace, gd).style('stroke-width', lineWidth).call(Color.stroke, lineColor);
};

/***/ }),

/***/ 36961:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var scatterglAttrs = __webpack_require__(36640);
module.exports = {
  x: scatterglAttrs.x,
  y: scatterglAttrs.y,
  xy: {
    valType: 'data_array',
    editType: 'calc'
  },
  indices: {
    valType: 'data_array',
    editType: 'calc'
  },
  xbounds: {
    valType: 'data_array',
    editType: 'calc'
  },
  ybounds: {
    valType: 'data_array',
    editType: 'calc'
  },
  text: scatterglAttrs.text,
  marker: {
    color: {
      valType: 'color',
      arrayOk: false,
      editType: 'calc'
    },
    opacity: {
      valType: 'number',
      min: 0,
      max: 1,
      dflt: 1,
      arrayOk: false,
      editType: 'calc'
    },
    blend: {
      valType: 'boolean',
      dflt: null,
      editType: 'calc'
    },
    sizemin: {
      valType: 'number',
      min: 0.1,
      max: 2,
      dflt: 0.5,
      editType: 'calc'
    },
    sizemax: {
      valType: 'number',
      min: 0.1,
      dflt: 20,
      editType: 'calc'
    },
    border: {
      color: {
        valType: 'color',
        arrayOk: false,
        editType: 'calc'
      },
      arearatio: {
        valType: 'number',
        min: 0,
        max: 1,
        dflt: 0,
        editType: 'calc'
      },
      editType: 'calc'
    },
    editType: 'calc'
  },
  transforms: undefined
};

/***/ }),

/***/ 71593:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var createPointCloudRenderer = (__webpack_require__(99098).gl_pointcloud2d);
var isArrayOrTypedArray = (__webpack_require__(34809).isArrayOrTypedArray);
var str2RGBArray = __webpack_require__(55010);
var findExtremes = (__webpack_require__(32919).findExtremes);
var getTraceColor = __webpack_require__(11539);
function Pointcloud(scene, uid) {
  this.scene = scene;
  this.uid = uid;
  this.type = 'pointcloud';
  this.pickXData = [];
  this.pickYData = [];
  this.xData = [];
  this.yData = [];
  this.textLabels = [];
  this.color = 'rgb(0, 0, 0)';
  this.name = '';
  this.hoverinfo = 'all';
  this.idToIndex = new Int32Array(0);
  this.bounds = [0, 0, 0, 0];
  this.pointcloudOptions = {
    positions: new Float32Array(0),
    idToIndex: this.idToIndex,
    sizemin: 0.5,
    sizemax: 12,
    color: [0, 0, 0, 1],
    areaRatio: 1,
    borderColor: [0, 0, 0, 1]
  };
  this.pointcloud = createPointCloudRenderer(scene.glplot, this.pointcloudOptions);
  this.pointcloud._trace = this; // scene2d requires this prop
}
var proto = Pointcloud.prototype;
proto.handlePick = function (pickResult) {
  var index = this.idToIndex[pickResult.pointId];

  // prefer the readout from XY, if present
  return {
    trace: this,
    dataCoord: pickResult.dataCoord,
    traceCoord: this.pickXYData ? [this.pickXYData[index * 2], this.pickXYData[index * 2 + 1]] : [this.pickXData[index], this.pickYData[index]],
    textLabel: isArrayOrTypedArray(this.textLabels) ? this.textLabels[index] : this.textLabels,
    color: this.color,
    name: this.name,
    pointIndex: index,
    hoverinfo: this.hoverinfo
  };
};
proto.update = function (options) {
  this.index = options.index;
  this.textLabels = options.text;
  this.name = options.name;
  this.hoverinfo = options.hoverinfo;
  this.bounds = [Infinity, Infinity, -Infinity, -Infinity];
  this.updateFast(options);
  this.color = getTraceColor(options, {});
};
proto.updateFast = function (options) {
  var x = this.xData = this.pickXData = options.x;
  var y = this.yData = this.pickYData = options.y;
  var xy = this.pickXYData = options.xy;
  var userBounds = options.xbounds && options.ybounds;
  var index = options.indices;
  var len;
  var idToIndex;
  var positions;
  var bounds = this.bounds;
  var xx, yy, i;
  if (xy) {
    positions = xy;

    // dividing xy.length by 2 and truncating to integer if xy.length was not even
    len = xy.length >>> 1;
    if (userBounds) {
      bounds[0] = options.xbounds[0];
      bounds[2] = options.xbounds[1];
      bounds[1] = options.ybounds[0];
      bounds[3] = options.ybounds[1];
    } else {
      for (i = 0; i < len; i++) {
        xx = positions[i * 2];
        yy = positions[i * 2 + 1];
        if (xx < bounds[0]) bounds[0] = xx;
        if (xx > bounds[2]) bounds[2] = xx;
        if (yy < bounds[1]) bounds[1] = yy;
        if (yy > bounds[3]) bounds[3] = yy;
      }
    }
    if (index) {
      idToIndex = index;
    } else {
      idToIndex = new Int32Array(len);
      for (i = 0; i < len; i++) {
        idToIndex[i] = i;
      }
    }
  } else {
    len = x.length;
    positions = new Float32Array(2 * len);
    idToIndex = new Int32Array(len);
    for (i = 0; i < len; i++) {
      xx = x[i];
      yy = y[i];
      idToIndex[i] = i;
      positions[i * 2] = xx;
      positions[i * 2 + 1] = yy;
      if (xx < bounds[0]) bounds[0] = xx;
      if (xx > bounds[2]) bounds[2] = xx;
      if (yy < bounds[1]) bounds[1] = yy;
      if (yy > bounds[3]) bounds[3] = yy;
    }
  }
  this.idToIndex = idToIndex;
  this.pointcloudOptions.idToIndex = idToIndex;
  this.pointcloudOptions.positions = positions;
  var markerColor = str2RGBArray(options.marker.color);
  var borderColor = str2RGBArray(options.marker.border.color);
  var opacity = options.opacity * options.marker.opacity;
  markerColor[3] *= opacity;
  this.pointcloudOptions.color = markerColor;

  // detect blending from the number of points, if undefined
  // because large data with blending hits performance
  var blend = options.marker.blend;
  if (blend === null) {
    var maxPoints = 100;
    blend = x.length < maxPoints || y.length < maxPoints;
  }
  this.pointcloudOptions.blend = blend;
  borderColor[3] *= opacity;
  this.pointcloudOptions.borderColor = borderColor;
  var markerSizeMin = options.marker.sizemin;
  var markerSizeMax = Math.max(options.marker.sizemax, options.marker.sizemin);
  this.pointcloudOptions.sizeMin = markerSizeMin;
  this.pointcloudOptions.sizeMax = markerSizeMax;
  this.pointcloudOptions.areaRatio = options.marker.border.arearatio;
  this.pointcloud.update(this.pointcloudOptions);

  // add item for autorange routine
  var xa = this.scene.xaxis;
  var ya = this.scene.yaxis;
  var pad = markerSizeMax / 2 || 0.5;
  options._extremes[xa._id] = findExtremes(xa, [bounds[0], bounds[2]], {
    ppad: pad
  });
  options._extremes[ya._id] = findExtremes(ya, [bounds[1], bounds[3]], {
    ppad: pad
  });
};
proto.dispose = function () {
  this.pointcloud.dispose();
};
function createPointcloud(scene, data) {
  var plot = new Pointcloud(scene, data.uid);
  plot.update(data);
  return plot;
}
module.exports = createPointcloud;

/***/ }),

/***/ 75526:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var attributes = __webpack_require__(36961);
module.exports = function supplyDefaults(traceIn, traceOut, defaultColor) {
  function coerce(attr, dflt) {
    return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
  }
  coerce('x');
  coerce('y');
  coerce('xbounds');
  coerce('ybounds');
  if (traceIn.xy && traceIn.xy instanceof Float32Array) {
    traceOut.xy = traceIn.xy;
  }
  if (traceIn.indices && traceIn.indices instanceof Int32Array) {
    traceOut.indices = traceIn.indices;
  }
  coerce('text');
  coerce('marker.color', defaultColor);
  coerce('marker.opacity');
  coerce('marker.blend');
  coerce('marker.sizemin');
  coerce('marker.sizemax');
  coerce('marker.border.color', defaultColor);
  coerce('marker.border.arearatio');

  // disable 1D transforms - that would defeat the purpose of this trace type, performance!
  traceOut._length = null;
};

/***/ }),

/***/ 15186:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var deprecationWarning = ['*pointcloud* trace is deprecated!', 'Please consider switching to the *scattergl* trace type.'].join(' ');
module.exports = {
  attributes: __webpack_require__(36961),
  supplyDefaults: __webpack_require__(75526),
  // reuse the Scatter3D 'dummy' calc step so that legends know what to do
  calc: __webpack_require__(37593),
  plot: __webpack_require__(71593),
  moduleType: 'trace',
  name: 'pointcloud',
  basePlotModule: __webpack_require__(24585),
  categories: ['gl', 'gl2d', 'showLegend'],
  meta: {}
};

/***/ }),

/***/ 33795:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var fontAttrs = __webpack_require__(80337);
var baseAttrs = __webpack_require__(9829);
var colorAttrs = __webpack_require__(10229);
var fxAttrs = __webpack_require__(70192);
var domainAttrs = (__webpack_require__(13792)/* .attributes */ .u);
var hovertemplateAttrs = (__webpack_require__(3208)/* .hovertemplateAttrs */ .rb);
var colorAttributes = __webpack_require__(87163);
var templatedArray = (__webpack_require__(78032).templatedArray);
var descriptionOnlyNumbers = (__webpack_require__(80712).descriptionOnlyNumbers);
var extendFlat = (__webpack_require__(93049).extendFlat);
var overrideAll = (__webpack_require__(13582).overrideAll);
var attrs = module.exports = overrideAll({
  hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
    flags: [],
    arrayOk: false
  }),
  hoverlabel: fxAttrs.hoverlabel,
  domain: domainAttrs({
    name: 'sankey',
    trace: true
  }),
  orientation: {
    valType: 'enumerated',
    values: ['v', 'h'],
    dflt: 'h'
  },
  valueformat: {
    valType: 'string',
    dflt: '.3s',
    description: descriptionOnlyNumbers('value')
  },
  valuesuffix: {
    valType: 'string',
    dflt: ''
  },
  arrangement: {
    valType: 'enumerated',
    values: ['snap', 'perpendicular', 'freeform', 'fixed'],
    dflt: 'snap'
  },
  textfont: fontAttrs({
    autoShadowDflt: true
  }),
  // Remove top-level customdata
  customdata: undefined,
  node: {
    label: {
      valType: 'data_array',
      dflt: []
    },
    groups: {
      valType: 'info_array',
      impliedEdits: {
        x: [],
        y: []
      },
      dimensions: 2,
      freeLength: true,
      dflt: [],
      items: {
        valType: 'number',
        editType: 'calc'
      }
    },
    x: {
      valType: 'data_array',
      dflt: []
    },
    y: {
      valType: 'data_array',
      dflt: []
    },
    color: {
      valType: 'color',
      arrayOk: true
    },
    customdata: {
      valType: 'data_array',
      editType: 'calc'
    },
    line: {
      color: {
        valType: 'color',
        dflt: colorAttrs.defaultLine,
        arrayOk: true
      },
      width: {
        valType: 'number',
        min: 0,
        dflt: 0.5,
        arrayOk: true
      }
    },
    pad: {
      valType: 'number',
      arrayOk: false,
      min: 0,
      dflt: 20
    },
    thickness: {
      valType: 'number',
      arrayOk: false,
      min: 1,
      dflt: 20
    },
    hoverinfo: {
      valType: 'enumerated',
      values: ['all', 'none', 'skip'],
      dflt: 'all'
    },
    hoverlabel: fxAttrs.hoverlabel,
    // needs editType override,
    hovertemplate: hovertemplateAttrs({}, {
      keys: ['value', 'label']
    }),
    align: {
      valType: 'enumerated',
      values: ['justify', 'left', 'right', 'center'],
      dflt: 'justify'
    }
  },
  link: {
    arrowlen: {
      valType: 'number',
      min: 0,
      dflt: 0
    },
    label: {
      valType: 'data_array',
      dflt: []
    },
    color: {
      valType: 'color',
      arrayOk: true
    },
    hovercolor: {
      valType: 'color',
      arrayOk: true
    },
    customdata: {
      valType: 'data_array',
      editType: 'calc'
    },
    line: {
      color: {
        valType: 'color',
        dflt: colorAttrs.defaultLine,
        arrayOk: true
      },
      width: {
        valType: 'number',
        min: 0,
        dflt: 0,
        arrayOk: true
      }
    },
    source: {
      valType: 'data_array',
      dflt: []
    },
    target: {
      valType: 'data_array',
      dflt: []
    },
    value: {
      valType: 'data_array',
      dflt: []
    },
    hoverinfo: {
      valType: 'enumerated',
      values: ['all', 'none', 'skip'],
      dflt: 'all'
    },
    hoverlabel: fxAttrs.hoverlabel,
    // needs editType override,
    hovertemplate: hovertemplateAttrs({}, {
      keys: ['value', 'label']
    }),
    colorscales: templatedArray('concentrationscales', {
      editType: 'calc',
      label: {
        valType: 'string',
        editType: 'calc',
        dflt: ''
      },
      cmax: {
        valType: 'number',
        editType: 'calc',
        dflt: 1
      },
      cmin: {
        valType: 'number',
        editType: 'calc',
        dflt: 0
      },
      colorscale: extendFlat(colorAttributes().colorscale, {
        dflt: [[0, 'white'], [1, 'black']]
      })
    })
  }
}, 'calc', 'nested');
attrs.transforms = undefined;

/***/ }),

/***/ 42229:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var overrideAll = (__webpack_require__(13582).overrideAll);
var getModuleCalcData = (__webpack_require__(4173)/* .getModuleCalcData */ .eV);
var plot = __webpack_require__(16506);
var fxAttrs = __webpack_require__(6811);
var setCursor = __webpack_require__(27983);
var dragElement = __webpack_require__(14751);
var prepSelect = (__webpack_require__(44844).prepSelect);
var Lib = __webpack_require__(34809);
var Registry = __webpack_require__(33626);
var SANKEY = 'sankey';
exports.name = SANKEY;
exports.baseLayoutAttrOverrides = overrideAll({
  hoverlabel: fxAttrs.hoverlabel
}, 'plot', 'nested');
exports.plot = function (gd) {
  var calcData = getModuleCalcData(gd.calcdata, SANKEY)[0];
  plot(gd, calcData);
  exports.updateFx(gd);
};
exports.clean = function (newFullData, newFullLayout, oldFullData, oldFullLayout) {
  var hadPlot = oldFullLayout._has && oldFullLayout._has(SANKEY);
  var hasPlot = newFullLayout._has && newFullLayout._has(SANKEY);
  if (hadPlot && !hasPlot) {
    oldFullLayout._paperdiv.selectAll('.sankey').remove();
    oldFullLayout._paperdiv.selectAll('.bgsankey').remove();
  }
};
exports.updateFx = function (gd) {
  for (var i = 0; i < gd._fullData.length; i++) {
    subplotUpdateFx(gd, i);
  }
};
function subplotUpdateFx(gd, index) {
  var trace = gd._fullData[index];
  var fullLayout = gd._fullLayout;
  var dragMode = fullLayout.dragmode;
  var cursor = fullLayout.dragmode === 'pan' ? 'move' : 'crosshair';
  var bgRect = trace._bgRect;
  if (!bgRect) return;
  if (dragMode === 'pan' || dragMode === 'zoom') return;
  setCursor(bgRect, cursor);
  var xaxis = {
    _id: 'x',
    c2p: Lib.identity,
    _offset: trace._sankey.translateX,
    _length: trace._sankey.width
  };
  var yaxis = {
    _id: 'y',
    c2p: Lib.identity,
    _offset: trace._sankey.translateY,
    _length: trace._sankey.height
  };

  // Note: dragOptions is needed to be declared for all dragmodes because
  // it's the object that holds persistent selection state.
  var dragOptions = {
    gd: gd,
    element: bgRect.node(),
    plotinfo: {
      id: index,
      xaxis: xaxis,
      yaxis: yaxis,
      fillRangeItems: Lib.noop
    },
    subplot: index,
    // create mock x/y axes for hover routine
    xaxes: [xaxis],
    yaxes: [yaxis],
    doneFnCompleted: function (selection) {
      var traceNow = gd._fullData[index];
      var newGroups;
      var oldGroups = traceNow.node.groups.slice();
      var newGroup = [];
      function findNode(pt) {
        var nodes = traceNow._sankey.graph.nodes;
        for (var i = 0; i < nodes.length; i++) {
          if (nodes[i].pointNumber === pt) return nodes[i];
        }
      }
      for (var j = 0; j < selection.length; j++) {
        var node = findNode(selection[j].pointNumber);
        if (!node) continue;

        // If the node represents a group
        if (node.group) {
          // Add all its children to the current selection
          for (var k = 0; k < node.childrenNodes.length; k++) {
            newGroup.push(node.childrenNodes[k].pointNumber);
          }
          // Flag group for removal from existing list of groups
          oldGroups[node.pointNumber - traceNow.node._count] = false;
        } else {
          newGroup.push(node.pointNumber);
        }
      }
      newGroups = oldGroups.filter(Boolean).concat([newGroup]);
      Registry.call('_guiRestyle', gd, {
        'node.groups': [newGroups]
      }, index);
    }
  };
  dragOptions.prepFn = function (e, startX, startY) {
    prepSelect(e, startX, startY, dragOptions, dragMode);
  };
  dragElement.init(dragOptions);
}

/***/ }),

/***/ 22915:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var tarjan = __webpack_require__(26381);
var Lib = __webpack_require__(34809);
var wrap = (__webpack_require__(71293).wrap);
var isArrayOrTypedArray = Lib.isArrayOrTypedArray;
var isIndex = Lib.isIndex;
var Colorscale = __webpack_require__(88856);
function convertToD3Sankey(trace) {
  var nodeSpec = trace.node;
  var linkSpec = trace.link;
  var links = [];
  var hasLinkColorArray = isArrayOrTypedArray(linkSpec.color);
  var hasLinkHoverColorArray = isArrayOrTypedArray(linkSpec.hovercolor);
  var hasLinkCustomdataArray = isArrayOrTypedArray(linkSpec.customdata);
  var linkedNodes = {};
  var components = {};
  var componentCount = linkSpec.colorscales.length;
  var i;
  for (i = 0; i < componentCount; i++) {
    var cscale = linkSpec.colorscales[i];
    var specs = Colorscale.extractScale(cscale, {
      cLetter: 'c'
    });
    var scale = Colorscale.makeColorScaleFunc(specs);
    components[cscale.label] = scale;
  }
  var maxNodeId = 0;
  for (i = 0; i < linkSpec.value.length; i++) {
    if (linkSpec.source[i] > maxNodeId) maxNodeId = linkSpec.source[i];
    if (linkSpec.target[i] > maxNodeId) maxNodeId = linkSpec.target[i];
  }
  var nodeCount = maxNodeId + 1;
  trace.node._count = nodeCount;

  // Group nodes
  var j;
  var groups = trace.node.groups;
  var groupLookup = {};
  for (i = 0; i < groups.length; i++) {
    var group = groups[i];
    // Build a lookup table to quickly find in which group a node is
    for (j = 0; j < group.length; j++) {
      var nodeIndex = group[j];
      var groupIndex = nodeCount + i;
      if (groupLookup.hasOwnProperty(nodeIndex)) {
        Lib.warn('Node ' + nodeIndex + ' is already part of a group.');
      } else {
        groupLookup[nodeIndex] = groupIndex;
      }
    }
  }

  // Process links
  var groupedLinks = {
    source: [],
    target: []
  };
  for (i = 0; i < linkSpec.value.length; i++) {
    var val = linkSpec.value[i];
    // remove negative values, but keep zeros with special treatment
    var source = linkSpec.source[i];
    var target = linkSpec.target[i];
    if (!(val > 0 && isIndex(source, nodeCount) && isIndex(target, nodeCount))) {
      continue;
    }

    // Remove links that are within the same group
    if (groupLookup.hasOwnProperty(source) && groupLookup.hasOwnProperty(target) && groupLookup[source] === groupLookup[target]) {
      continue;
    }

    // if link targets a node in the group, relink target to that group
    if (groupLookup.hasOwnProperty(target)) {
      target = groupLookup[target];
    }

    // if link originates from a node in a group, relink source to that group
    if (groupLookup.hasOwnProperty(source)) {
      source = groupLookup[source];
    }
    source = +source;
    target = +target;
    linkedNodes[source] = linkedNodes[target] = true;
    var label = '';
    if (linkSpec.label && linkSpec.label[i]) label = linkSpec.label[i];
    var concentrationscale = null;
    if (label && components.hasOwnProperty(label)) concentrationscale = components[label];
    links.push({
      pointNumber: i,
      label: label,
      color: hasLinkColorArray ? linkSpec.color[i] : linkSpec.color,
      hovercolor: hasLinkHoverColorArray ? linkSpec.hovercolor[i] : linkSpec.hovercolor,
      customdata: hasLinkCustomdataArray ? linkSpec.customdata[i] : linkSpec.customdata,
      concentrationscale: concentrationscale,
      source: source,
      target: target,
      value: +val
    });
    groupedLinks.source.push(source);
    groupedLinks.target.push(target);
  }

  // Process nodes
  var totalCount = nodeCount + groups.length;
  var hasNodeColorArray = isArrayOrTypedArray(nodeSpec.color);
  var hasNodeCustomdataArray = isArrayOrTypedArray(nodeSpec.customdata);
  var nodes = [];
  for (i = 0; i < totalCount; i++) {
    if (!linkedNodes[i]) continue;
    var l = nodeSpec.label[i];
    nodes.push({
      group: i > nodeCount - 1,
      childrenNodes: [],
      pointNumber: i,
      label: l,
      color: hasNodeColorArray ? nodeSpec.color[i] : nodeSpec.color,
      customdata: hasNodeCustomdataArray ? nodeSpec.customdata[i] : nodeSpec.customdata
    });
  }

  // Check if we have circularity on the resulting graph
  var circular = false;
  if (circularityPresent(totalCount, groupedLinks.source, groupedLinks.target)) {
    circular = true;
  }
  return {
    circular: circular,
    links: links,
    nodes: nodes,
    // Data structure for groups
    groups: groups,
    groupLookup: groupLookup
  };
}
function circularityPresent(nodeLen, sources, targets) {
  var nodes = Lib.init2dArray(nodeLen, 0);
  for (var i = 0; i < Math.min(sources.length, targets.length); i++) {
    if (Lib.isIndex(sources[i], nodeLen) && Lib.isIndex(targets[i], nodeLen)) {
      if (sources[i] === targets[i]) {
        return true; // self-link which is also a scc of one
      }
      nodes[sources[i]].push(targets[i]);
    }
  }
  var scc = tarjan(nodes);

  // Tarján's strongly connected components algorithm coded by Mikola Lysenko
  // returns at least one non-singular component if there's circularity in the graph
  return scc.components.some(function (c) {
    return c.length > 1;
  });
}
module.exports = function calc(gd, trace) {
  var result = convertToD3Sankey(trace);
  return wrap({
    circular: result.circular,
    _nodes: result.nodes,
    _links: result.links,
    // Data structure for grouping
    _groups: result.groups,
    _groupLookup: result.groupLookup
  });
};

/***/ }),

/***/ 21541:
/***/ (function(module) {

"use strict";


module.exports = {
  nodeTextOffsetHorizontal: 4,
  nodeTextOffsetVertical: 3,
  nodePadAcross: 10,
  sankeyIterations: 50,
  forceIterations: 5,
  forceTicksPerFrame: 10,
  duration: 500,
  ease: 'linear',
  cn: {
    sankey: 'sankey',
    sankeyLinks: 'sankey-links',
    sankeyLink: 'sankey-link',
    sankeyNodeSet: 'sankey-node-set',
    sankeyNode: 'sankey-node',
    nodeRect: 'node-rect',
    nodeLabel: 'node-label'
  }
};

/***/ }),

/***/ 67940:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var attributes = __webpack_require__(33795);
var Color = __webpack_require__(78766);
var tinycolor = __webpack_require__(65657);
var handleDomainDefaults = (__webpack_require__(13792)/* .defaults */ .N);
var handleHoverLabelDefaults = __webpack_require__(26430);
var Template = __webpack_require__(78032);
var handleArrayContainerDefaults = __webpack_require__(59008);
module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
  function coerce(attr, dflt) {
    return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
  }
  var hoverlabelDefault = Lib.extendDeep(layout.hoverlabel, traceIn.hoverlabel);

  // node attributes
  var nodeIn = traceIn.node;
  var nodeOut = Template.newContainer(traceOut, 'node');
  function coerceNode(attr, dflt) {
    return Lib.coerce(nodeIn, nodeOut, attributes.node, attr, dflt);
  }
  coerceNode('label');
  coerceNode('groups');
  coerceNode('x');
  coerceNode('y');
  coerceNode('pad');
  coerceNode('thickness');
  coerceNode('line.color');
  coerceNode('line.width');
  coerceNode('hoverinfo', traceIn.hoverinfo);
  handleHoverLabelDefaults(nodeIn, nodeOut, coerceNode, hoverlabelDefault);
  coerceNode('hovertemplate');
  coerceNode('align');
  var colors = layout.colorway;
  var defaultNodePalette = function (i) {
    return colors[i % colors.length];
  };
  coerceNode('color', nodeOut.label.map(function (d, i) {
    return Color.addOpacity(defaultNodePalette(i), 0.8);
  }));
  coerceNode('customdata');

  // link attributes
  var linkIn = traceIn.link || {};
  var linkOut = Template.newContainer(traceOut, 'link');
  function coerceLink(attr, dflt) {
    return Lib.coerce(linkIn, linkOut, attributes.link, attr, dflt);
  }
  coerceLink('label');
  coerceLink('arrowlen');
  coerceLink('source');
  coerceLink('target');
  coerceLink('value');
  coerceLink('line.color');
  coerceLink('line.width');
  coerceLink('hoverinfo', traceIn.hoverinfo);
  handleHoverLabelDefaults(linkIn, linkOut, coerceLink, hoverlabelDefault);
  coerceLink('hovertemplate');
  var darkBG = tinycolor(layout.paper_bgcolor).getLuminance() < 0.333;
  var defaultLinkColor = darkBG ? 'rgba(255, 255, 255, 0.6)' : 'rgba(0, 0, 0, 0.2)';
  var linkColor = coerceLink('color', defaultLinkColor);
  function makeDefaultHoverColor(_linkColor) {
    var tc = tinycolor(_linkColor);
    if (!tc.isValid()) {
      // hopefully the user-specified color is valid, but if not that can be caught elsewhere
      return _linkColor;
    }
    var alpha = tc.getAlpha();
    if (alpha <= 0.8) {
      tc.setAlpha(alpha + 0.2);
    } else {
      tc = darkBG ? tc.brighten() : tc.darken();
    }
    return tc.toRgbString();
  }
  coerceLink('hovercolor', Array.isArray(linkColor) ? linkColor.map(makeDefaultHoverColor) : makeDefaultHoverColor(linkColor));
  coerceLink('customdata');
  handleArrayContainerDefaults(linkIn, linkOut, {
    name: 'colorscales',
    handleItemDefaults: concentrationscalesDefaults
  });
  handleDomainDefaults(traceOut, layout, coerce);
  coerce('orientation');
  coerce('valueformat');
  coerce('valuesuffix');
  var dfltArrangement;
  if (nodeOut.x.length && nodeOut.y.length) {
    dfltArrangement = 'freeform';
  }
  coerce('arrangement', dfltArrangement);
  Lib.coerceFont(coerce, 'textfont', layout.font, {
    autoShadowDflt: true
  });

  // disable 1D transforms - arrays here are 1D but their lengths/meanings
  // don't match, between nodes and links
  traceOut._length = null;
};
function concentrationscalesDefaults(In, Out) {
  function coerce(attr, dflt) {
    return Lib.coerce(In, Out, attributes.link.colorscales, attr, dflt);
  }
  coerce('label');
  coerce('cmin');
  coerce('cmax');
  coerce('colorscale');
}

/***/ }),

/***/ 71760:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = {
  attributes: __webpack_require__(33795),
  supplyDefaults: __webpack_require__(67940),
  calc: __webpack_require__(22915),
  plot: __webpack_require__(16506),
  moduleType: 'trace',
  name: 'sankey',
  basePlotModule: __webpack_require__(42229),
  selectPoints: __webpack_require__(74670),
  categories: ['noOpacity'],
  meta: {}
};

/***/ }),

/***/ 16506:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var Lib = __webpack_require__(34809);
var numberFormat = Lib.numberFormat;
var render = __webpack_require__(90958);
var Fx = __webpack_require__(32141);
var Color = __webpack_require__(78766);
var cn = (__webpack_require__(21541).cn);
var _ = Lib._;
function renderableValuePresent(d) {
  return d !== '';
}
function ownTrace(selection, d) {
  return selection.filter(function (s) {
    return s.key === d.traceId;
  });
}
function makeTranslucent(element, alpha) {
  d3.select(element).select('path').style('fill-opacity', alpha);
  d3.select(element).select('rect').style('fill-opacity', alpha);
}
function makeTextContrasty(element) {
  d3.select(element).select('text.name').style('fill', 'black');
}
function relatedLinks(d) {
  return function (l) {
    return d.node.sourceLinks.indexOf(l.link) !== -1 || d.node.targetLinks.indexOf(l.link) !== -1;
  };
}
function relatedNodes(l) {
  return function (d) {
    return d.node.sourceLinks.indexOf(l.link) !== -1 || d.node.targetLinks.indexOf(l.link) !== -1;
  };
}
function nodeHoveredStyle(sankeyNode, d, sankey) {
  if (d && sankey) {
    ownTrace(sankey, d).selectAll('.' + cn.sankeyLink).filter(relatedLinks(d)).call(linkHoveredStyle.bind(0, d, sankey, false));
  }
}
function nodeNonHoveredStyle(sankeyNode, d, sankey) {
  if (d && sankey) {
    ownTrace(sankey, d).selectAll('.' + cn.sankeyLink).filter(relatedLinks(d)).call(linkNonHoveredStyle.bind(0, d, sankey, false));
  }
}
function linkHoveredStyle(d, sankey, visitNodes, sankeyLink) {
  sankeyLink.style('fill', function (l) {
    if (!l.link.concentrationscale) {
      return l.tinyColorHoverHue;
    }
  }).style('fill-opacity', function (l) {
    if (!l.link.concentrationscale) {
      return l.tinyColorHoverAlpha;
    }
  });
  sankeyLink.each(function (curLink) {
    var label = curLink.link.label;
    if (label !== '') {
      ownTrace(sankey, d).selectAll('.' + cn.sankeyLink).filter(function (l) {
        return l.link.label === label;
      }).style('fill', function (l) {
        if (!l.link.concentrationscale) {
          return l.tinyColorHoverHue;
        }
      }).style('fill-opacity', function (l) {
        if (!l.link.concentrationscale) {
          return l.tinyColorHoverAlpha;
        }
      });
    }
  });
  if (visitNodes) {
    ownTrace(sankey, d).selectAll('.' + cn.sankeyNode).filter(relatedNodes(d)).call(nodeHoveredStyle);
  }
}
function linkNonHoveredStyle(d, sankey, visitNodes, sankeyLink) {
  sankeyLink.style('fill', function (l) {
    return l.tinyColorHue;
  }).style('fill-opacity', function (l) {
    return l.tinyColorAlpha;
  });
  sankeyLink.each(function (curLink) {
    var label = curLink.link.label;
    if (label !== '') {
      ownTrace(sankey, d).selectAll('.' + cn.sankeyLink).filter(function (l) {
        return l.link.label === label;
      }).style('fill', function (l) {
        return l.tinyColorHue;
      }).style('fill-opacity', function (l) {
        return l.tinyColorAlpha;
      });
    }
  });
  if (visitNodes) {
    ownTrace(sankey, d).selectAll(cn.sankeyNode).filter(relatedNodes(d)).call(nodeNonHoveredStyle);
  }
}

// does not support array values for now
function castHoverOption(trace, attr) {
  var labelOpts = trace.hoverlabel || {};
  var val = Lib.nestedProperty(labelOpts, attr).get();
  return Array.isArray(val) ? false : val;
}
module.exports = function plot(gd, calcData) {
  var fullLayout = gd._fullLayout;
  var svg = fullLayout._paper;
  var size = fullLayout._size;

  // stash initial view
  for (var i = 0; i < gd._fullData.length; i++) {
    if (!gd._fullData[i].visible) continue;
    if (gd._fullData[i].type !== cn.sankey) continue;
    if (!gd._fullData[i]._viewInitial) {
      var node = gd._fullData[i].node;
      gd._fullData[i]._viewInitial = {
        node: {
          groups: node.groups.slice(),
          x: node.x.slice(),
          y: node.y.slice()
        }
      };
    }
  }
  var linkSelect = function (element, d) {
    var evt = d.link;
    evt.originalEvent = d3.event;
    gd._hoverdata = [evt];
    Fx.click(gd, {
      target: true
    });
  };
  var linkHover = function (element, d, sankey) {
    if (gd._fullLayout.hovermode === false) return;
    d3.select(element).call(linkHoveredStyle.bind(0, d, sankey, true));
    if (d.link.trace.link.hoverinfo !== 'skip') {
      d.link.fullData = d.link.trace;
      gd.emit('plotly_hover', {
        event: d3.event,
        points: [d.link]
      });
    }
  };
  var sourceLabel = _(gd, 'source:') + ' ';
  var targetLabel = _(gd, 'target:') + ' ';
  var concentrationLabel = _(gd, 'concentration:') + ' ';
  var incomingLabel = _(gd, 'incoming flow count:') + ' ';
  var outgoingLabel = _(gd, 'outgoing flow count:') + ' ';
  var linkHoverFollow = function (element, d) {
    if (gd._fullLayout.hovermode === false) return;
    var obj = d.link.trace.link;
    if (obj.hoverinfo === 'none' || obj.hoverinfo === 'skip') return;
    var hoverItems = [];
    function hoverCenterPosition(link) {
      var hoverCenterX, hoverCenterY;
      if (link.circular) {
        hoverCenterX = (link.circularPathData.leftInnerExtent + link.circularPathData.rightInnerExtent) / 2;
        hoverCenterY = link.circularPathData.verticalFullExtent;
      } else {
        hoverCenterX = (link.source.x1 + link.target.x0) / 2;
        hoverCenterY = (link.y0 + link.y1) / 2;
      }
      var center = [hoverCenterX, hoverCenterY];
      if (link.trace.orientation === 'v') center.reverse();
      center[0] += d.parent.translateX;
      center[1] += d.parent.translateY;
      return center;
    }

    // For each related links, create a hoverItem
    var anchorIndex = 0;
    for (var i = 0; i < d.flow.links.length; i++) {
      var link = d.flow.links[i];
      if (gd._fullLayout.hovermode === 'closest' && d.link.pointNumber !== link.pointNumber) continue;
      if (d.link.pointNumber === link.pointNumber) anchorIndex = i;
      link.fullData = link.trace;
      obj = d.link.trace.link;
      var hoverCenter = hoverCenterPosition(link);
      var hovertemplateLabels = {
        valueLabel: numberFormat(d.valueFormat)(link.value) + d.valueSuffix
      };
      hoverItems.push({
        x: hoverCenter[0],
        y: hoverCenter[1],
        name: hovertemplateLabels.valueLabel,
        text: [link.label || '', sourceLabel + link.source.label, targetLabel + link.target.label, link.concentrationscale ? concentrationLabel + numberFormat('%0.2f')(link.flow.labelConcentration) : ''].filter(renderableValuePresent).join('<br>'),
        color: castHoverOption(obj, 'bgcolor') || Color.addOpacity(link.color, 1),
        borderColor: castHoverOption(obj, 'bordercolor'),
        fontFamily: castHoverOption(obj, 'font.family'),
        fontSize: castHoverOption(obj, 'font.size'),
        fontColor: castHoverOption(obj, 'font.color'),
        fontWeight: castHoverOption(obj, 'font.weight'),
        fontStyle: castHoverOption(obj, 'font.style'),
        fontVariant: castHoverOption(obj, 'font.variant'),
        fontTextcase: castHoverOption(obj, 'font.textcase'),
        fontLineposition: castHoverOption(obj, 'font.lineposition'),
        fontShadow: castHoverOption(obj, 'font.shadow'),
        nameLength: castHoverOption(obj, 'namelength'),
        textAlign: castHoverOption(obj, 'align'),
        idealAlign: d3.event.x < hoverCenter[0] ? 'right' : 'left',
        hovertemplate: obj.hovertemplate,
        hovertemplateLabels: hovertemplateLabels,
        eventData: [link]
      });
    }
    var tooltips = Fx.loneHover(hoverItems, {
      container: fullLayout._hoverlayer.node(),
      outerContainer: fullLayout._paper.node(),
      gd: gd,
      anchorIndex: anchorIndex
    });
    tooltips.each(function () {
      var tooltip = this;
      if (!d.link.concentrationscale) {
        makeTranslucent(tooltip, 0.65);
      }
      makeTextContrasty(tooltip);
    });
  };
  var linkUnhover = function (element, d, sankey) {
    if (gd._fullLayout.hovermode === false) return;
    d3.select(element).call(linkNonHoveredStyle.bind(0, d, sankey, true));
    if (d.link.trace.link.hoverinfo !== 'skip') {
      d.link.fullData = d.link.trace;
      gd.emit('plotly_unhover', {
        event: d3.event,
        points: [d.link]
      });
    }
    Fx.loneUnhover(fullLayout._hoverlayer.node());
  };
  var nodeSelect = function (element, d, sankey) {
    var evt = d.node;
    evt.originalEvent = d3.event;
    gd._hoverdata = [evt];
    d3.select(element).call(nodeNonHoveredStyle, d, sankey);
    Fx.click(gd, {
      target: true
    });
  };
  var nodeHover = function (element, d, sankey) {
    if (gd._fullLayout.hovermode === false) return;
    d3.select(element).call(nodeHoveredStyle, d, sankey);
    if (d.node.trace.node.hoverinfo !== 'skip') {
      d.node.fullData = d.node.trace;
      gd.emit('plotly_hover', {
        event: d3.event,
        points: [d.node]
      });
    }
  };
  var nodeHoverFollow = function (element, d) {
    if (gd._fullLayout.hovermode === false) return;
    var obj = d.node.trace.node;
    if (obj.hoverinfo === 'none' || obj.hoverinfo === 'skip') return;
    var nodeRect = d3.select(element).select('.' + cn.nodeRect);
    var rootBBox = gd._fullLayout._paperdiv.node().getBoundingClientRect();
    var boundingBox = nodeRect.node().getBoundingClientRect();
    var hoverCenterX0 = boundingBox.left - 2 - rootBBox.left;
    var hoverCenterX1 = boundingBox.right + 2 - rootBBox.left;
    var hoverCenterY = boundingBox.top + boundingBox.height / 4 - rootBBox.top;
    var hovertemplateLabels = {
      valueLabel: numberFormat(d.valueFormat)(d.node.value) + d.valueSuffix
    };
    d.node.fullData = d.node.trace;
    gd._fullLayout._calcInverseTransform(gd);
    var scaleX = gd._fullLayout._invScaleX;
    var scaleY = gd._fullLayout._invScaleY;
    var tooltip = Fx.loneHover({
      x0: scaleX * hoverCenterX0,
      x1: scaleX * hoverCenterX1,
      y: scaleY * hoverCenterY,
      name: numberFormat(d.valueFormat)(d.node.value) + d.valueSuffix,
      text: [d.node.label, incomingLabel + d.node.targetLinks.length, outgoingLabel + d.node.sourceLinks.length].filter(renderableValuePresent).join('<br>'),
      color: castHoverOption(obj, 'bgcolor') || d.tinyColorHue,
      borderColor: castHoverOption(obj, 'bordercolor'),
      fontFamily: castHoverOption(obj, 'font.family'),
      fontSize: castHoverOption(obj, 'font.size'),
      fontColor: castHoverOption(obj, 'font.color'),
      fontWeight: castHoverOption(obj, 'font.weight'),
      fontStyle: castHoverOption(obj, 'font.style'),
      fontVariant: castHoverOption(obj, 'font.variant'),
      fontTextcase: castHoverOption(obj, 'font.textcase'),
      fontLineposition: castHoverOption(obj, 'font.lineposition'),
      fontShadow: castHoverOption(obj, 'font.shadow'),
      nameLength: castHoverOption(obj, 'namelength'),
      textAlign: castHoverOption(obj, 'align'),
      idealAlign: 'left',
      hovertemplate: obj.hovertemplate,
      hovertemplateLabels: hovertemplateLabels,
      eventData: [d.node]
    }, {
      container: fullLayout._hoverlayer.node(),
      outerContainer: fullLayout._paper.node(),
      gd: gd
    });
    makeTranslucent(tooltip, 0.85);
    makeTextContrasty(tooltip);
  };
  var nodeUnhover = function (element, d, sankey) {
    if (gd._fullLayout.hovermode === false) return;
    d3.select(element).call(nodeNonHoveredStyle, d, sankey);
    if (d.node.trace.node.hoverinfo !== 'skip') {
      d.node.fullData = d.node.trace;
      gd.emit('plotly_unhover', {
        event: d3.event,
        points: [d.node]
      });
    }
    Fx.loneUnhover(fullLayout._hoverlayer.node());
  };
  render(gd, svg, calcData, {
    width: size.w,
    height: size.h,
    margin: {
      t: size.t,
      r: size.r,
      b: size.b,
      l: size.l
    }
  }, {
    linkEvents: {
      hover: linkHover,
      follow: linkHoverFollow,
      unhover: linkUnhover,
      select: linkSelect
    },
    nodeEvents: {
      hover: nodeHover,
      follow: nodeHoverFollow,
      unhover: nodeUnhover,
      select: nodeSelect
    }
  });
};

/***/ }),

/***/ 90958:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3Force = __webpack_require__(32702);
var interpolateNumber = (__webpack_require__(88640)/* .interpolateNumber */ .Dj);
var d3 = __webpack_require__(45568);
var d3Sankey = __webpack_require__(62369);
var d3SankeyCircular = __webpack_require__(68735);
var c = __webpack_require__(21541);
var tinycolor = __webpack_require__(65657);
var Color = __webpack_require__(78766);
var Drawing = __webpack_require__(62203);
var Lib = __webpack_require__(34809);
var strTranslate = Lib.strTranslate;
var strRotate = Lib.strRotate;
var gup = __webpack_require__(71293);
var keyFun = gup.keyFun;
var repeat = gup.repeat;
var unwrap = gup.unwrap;
var svgTextUtils = __webpack_require__(30635);
var Registry = __webpack_require__(33626);
var alignmentConstants = __webpack_require__(4530);
var CAP_SHIFT = alignmentConstants.CAP_SHIFT;
var LINE_SPACING = alignmentConstants.LINE_SPACING;
var TEXTPAD = 3;

// view models

function sankeyModel(layout, d, traceIndex) {
  var calcData = unwrap(d);
  var trace = calcData.trace;
  var domain = trace.domain;
  var horizontal = trace.orientation === 'h';
  var nodePad = trace.node.pad;
  var nodeThickness = trace.node.thickness;
  var nodeAlign = {
    justify: d3Sankey.sankeyJustify,
    left: d3Sankey.sankeyLeft,
    right: d3Sankey.sankeyRight,
    center: d3Sankey.sankeyCenter
  }[trace.node.align];
  var width = layout.width * (domain.x[1] - domain.x[0]);
  var height = layout.height * (domain.y[1] - domain.y[0]);
  var nodes = calcData._nodes;
  var links = calcData._links;
  var circular = calcData.circular;

  // Select Sankey generator
  var sankey;
  if (circular) {
    sankey = d3SankeyCircular.sankeyCircular().circularLinkGap(0);
  } else {
    sankey = d3Sankey.sankey();
  }
  sankey.iterations(c.sankeyIterations).size(horizontal ? [width, height] : [height, width]).nodeWidth(nodeThickness).nodePadding(nodePad).nodeId(function (d) {
    return d.pointNumber;
  }).nodeAlign(nodeAlign).nodes(nodes).links(links);
  var graph = sankey();
  if (sankey.nodePadding() < nodePad) {
    Lib.warn('node.pad was reduced to ', sankey.nodePadding(), ' to fit within the figure.');
  }

  // Counters for nested loops
  var i, j, k;

  // Create transient nodes for animations
  for (var nodePointNumber in calcData._groupLookup) {
    var groupIndex = parseInt(calcData._groupLookup[nodePointNumber]);

    // Find node representing groupIndex
    var groupingNode;
    for (i = 0; i < graph.nodes.length; i++) {
      if (graph.nodes[i].pointNumber === groupIndex) {
        groupingNode = graph.nodes[i];
        break;
      }
    }
    // If groupinNode is undefined, no links are targeting this group
    if (!groupingNode) continue;
    var child = {
      pointNumber: parseInt(nodePointNumber),
      x0: groupingNode.x0,
      x1: groupingNode.x1,
      y0: groupingNode.y0,
      y1: groupingNode.y1,
      partOfGroup: true,
      sourceLinks: [],
      targetLinks: []
    };
    graph.nodes.unshift(child);
    groupingNode.childrenNodes.unshift(child);
  }
  function computeLinkConcentrations() {
    for (i = 0; i < graph.nodes.length; i++) {
      var node = graph.nodes[i];
      // Links connecting the same two nodes are part of a flow
      var flows = {};
      var flowKey;
      var link;
      for (j = 0; j < node.targetLinks.length; j++) {
        link = node.targetLinks[j];
        flowKey = link.source.pointNumber + ':' + link.target.pointNumber;
        if (!flows.hasOwnProperty(flowKey)) flows[flowKey] = [];
        flows[flowKey].push(link);
      }

      // Compute statistics for each flow
      var keys = Object.keys(flows);
      for (j = 0; j < keys.length; j++) {
        flowKey = keys[j];
        var flowLinks = flows[flowKey];

        // Find the total size of the flow and total size per label
        var total = 0;
        var totalPerLabel = {};
        for (k = 0; k < flowLinks.length; k++) {
          link = flowLinks[k];
          if (!totalPerLabel[link.label]) totalPerLabel[link.label] = 0;
          totalPerLabel[link.label] += link.value;
          total += link.value;
        }

        // Find the ratio of the link's value and the size of the flow
        for (k = 0; k < flowLinks.length; k++) {
          link = flowLinks[k];
          link.flow = {
            value: total,
            labelConcentration: totalPerLabel[link.label] / total,
            concentration: link.value / total,
            links: flowLinks
          };
          if (link.concentrationscale) {
            link.color = tinycolor(link.concentrationscale(link.flow.labelConcentration));
          }
        }
      }

      // Gather statistics of all links at current node
      var totalOutflow = 0;
      for (j = 0; j < node.sourceLinks.length; j++) {
        totalOutflow += node.sourceLinks[j].value;
      }
      for (j = 0; j < node.sourceLinks.length; j++) {
        link = node.sourceLinks[j];
        link.concentrationOut = link.value / totalOutflow;
      }
      var totalInflow = 0;
      for (j = 0; j < node.targetLinks.length; j++) {
        totalInflow += node.targetLinks[j].value;
      }
      for (j = 0; j < node.targetLinks.length; j++) {
        link = node.targetLinks[j];
        link.concenrationIn = link.value / totalInflow;
      }
    }
  }
  computeLinkConcentrations();

  // Push any overlapping nodes down.
  function resolveCollisionsTopToBottom(columns) {
    columns.forEach(function (nodes) {
      var node;
      var dy;
      var y = 0;
      var n = nodes.length;
      var i;
      nodes.sort(function (a, b) {
        return a.y0 - b.y0;
      });
      for (i = 0; i < n; ++i) {
        node = nodes[i];
        if (node.y0 >= y) {
          // No overlap
        } else {
          dy = y - node.y0;
          if (dy > 1e-6) node.y0 += dy, node.y1 += dy;
        }
        y = node.y1 + nodePad;
      }
    });
  }

  // Group nodes into columns based on their x position
  function snapToColumns(nodes) {
    // Sort nodes by x position
    var orderedNodes = nodes.map(function (n, i) {
      return {
        x0: n.x0,
        index: i
      };
    }).sort(function (a, b) {
      return a.x0 - b.x0;
    });
    var columns = [];
    var colNumber = -1;
    var colX; // Position of column
    var lastX = -Infinity; // Position of last node
    var dx;
    for (i = 0; i < orderedNodes.length; i++) {
      var node = nodes[orderedNodes[i].index];
      // If the node does not overlap with the last one
      if (node.x0 > lastX + nodeThickness) {
        // Start a new column
        colNumber += 1;
        colX = node.x0;
      }
      lastX = node.x0;

      // Add node to its associated column
      if (!columns[colNumber]) columns[colNumber] = [];
      columns[colNumber].push(node);

      // Change node's x position to align it with its column
      dx = colX - node.x0;
      node.x0 += dx, node.x1 += dx;
    }
    return columns;
  }

  // Force node position
  if (trace.node.x.length && trace.node.y.length) {
    for (i = 0; i < Math.min(trace.node.x.length, trace.node.y.length, graph.nodes.length); i++) {
      if (trace.node.x[i] && trace.node.y[i]) {
        var pos = [trace.node.x[i] * width, trace.node.y[i] * height];
        graph.nodes[i].x0 = pos[0] - nodeThickness / 2;
        graph.nodes[i].x1 = pos[0] + nodeThickness / 2;
        var nodeHeight = graph.nodes[i].y1 - graph.nodes[i].y0;
        graph.nodes[i].y0 = pos[1] - nodeHeight / 2;
        graph.nodes[i].y1 = pos[1] + nodeHeight / 2;
      }
    }
    if (trace.arrangement === 'snap') {
      nodes = graph.nodes;
      var columns = snapToColumns(nodes);
      resolveCollisionsTopToBottom(columns);
    }
    // Update links
    sankey.update(graph);
  }
  return {
    circular: circular,
    key: traceIndex,
    trace: trace,
    guid: Lib.randstr(),
    horizontal: horizontal,
    width: width,
    height: height,
    nodePad: trace.node.pad,
    nodeLineColor: trace.node.line.color,
    nodeLineWidth: trace.node.line.width,
    linkLineColor: trace.link.line.color,
    linkLineWidth: trace.link.line.width,
    linkArrowLength: trace.link.arrowlen,
    valueFormat: trace.valueformat,
    valueSuffix: trace.valuesuffix,
    textFont: trace.textfont,
    translateX: domain.x[0] * layout.width + layout.margin.l,
    translateY: layout.height - domain.y[1] * layout.height + layout.margin.t,
    dragParallel: horizontal ? height : width,
    dragPerpendicular: horizontal ? width : height,
    arrangement: trace.arrangement,
    sankey: sankey,
    graph: graph,
    forceLayouts: {},
    interactionState: {
      dragInProgress: false,
      hovered: false
    }
  };
}
function linkModel(d, l, i) {
  var tc = tinycolor(l.color);
  var htc = tinycolor(l.hovercolor);
  var basicKey = l.source.label + '|' + l.target.label;
  var key = basicKey + '__' + i;

  // for event data
  l.trace = d.trace;
  l.curveNumber = d.trace.index;
  return {
    circular: d.circular,
    key: key,
    traceId: d.key,
    pointNumber: l.pointNumber,
    link: l,
    tinyColorHue: Color.tinyRGB(tc),
    tinyColorAlpha: tc.getAlpha(),
    tinyColorHoverHue: Color.tinyRGB(htc),
    tinyColorHoverAlpha: htc.getAlpha(),
    linkPath: linkPath,
    linkLineColor: d.linkLineColor,
    linkLineWidth: d.linkLineWidth,
    linkArrowLength: d.linkArrowLength,
    valueFormat: d.valueFormat,
    valueSuffix: d.valueSuffix,
    sankey: d.sankey,
    parent: d,
    interactionState: d.interactionState,
    flow: l.flow
  };
}
function createCircularClosedPathString(link, arrowLen) {
  // Using coordinates computed by d3-sankey-circular
  var pathString = '';
  var offset = link.width / 2;
  var coords = link.circularPathData;
  if (link.circularLinkType === 'top') {
    // Top path
    pathString =
    // start at the left of the target node
    'M ' + (coords.targetX - arrowLen) + ' ' + (coords.targetY + offset) + ' ' + 'L' + (coords.rightInnerExtent - arrowLen) + ' ' + (coords.targetY + offset) + 'A' + (coords.rightLargeArcRadius + offset) + ' ' + (coords.rightSmallArcRadius + offset) + ' 0 0 1 ' + (coords.rightFullExtent - offset - arrowLen) + ' ' + (coords.targetY - coords.rightSmallArcRadius) + 'L' + (coords.rightFullExtent - offset - arrowLen) + ' ' + coords.verticalRightInnerExtent + 'A' + (coords.rightLargeArcRadius + offset) + ' ' + (coords.rightLargeArcRadius + offset) + ' 0 0 1 ' + (coords.rightInnerExtent - arrowLen) + ' ' + (coords.verticalFullExtent - offset) + 'L' + coords.leftInnerExtent + ' ' + (coords.verticalFullExtent - offset) + 'A' + (coords.leftLargeArcRadius + offset) + ' ' + (coords.leftLargeArcRadius + offset) + ' 0 0 1 ' + (coords.leftFullExtent + offset) + ' ' + coords.verticalLeftInnerExtent + 'L' + (coords.leftFullExtent + offset) + ' ' + (coords.sourceY - coords.leftSmallArcRadius) + 'A' + (coords.leftLargeArcRadius + offset) + ' ' + (coords.leftSmallArcRadius + offset) + ' 0 0 1 ' + coords.leftInnerExtent + ' ' + (coords.sourceY + offset) + 'L' + coords.sourceX + ' ' + (coords.sourceY + offset) +
    // Walking back
    'L' + coords.sourceX + ' ' + (coords.sourceY - offset) + 'L' + coords.leftInnerExtent + ' ' + (coords.sourceY - offset) + 'A' + (coords.leftLargeArcRadius - offset) + ' ' + (coords.leftSmallArcRadius - offset) + ' 0 0 0 ' + (coords.leftFullExtent - offset) + ' ' + (coords.sourceY - coords.leftSmallArcRadius) + 'L' + (coords.leftFullExtent - offset) + ' ' + coords.verticalLeftInnerExtent + 'A' + (coords.leftLargeArcRadius - offset) + ' ' + (coords.leftLargeArcRadius - offset) + ' 0 0 0 ' + coords.leftInnerExtent + ' ' + (coords.verticalFullExtent + offset) + 'L' + (coords.rightInnerExtent - arrowLen) + ' ' + (coords.verticalFullExtent + offset) + 'A' + (coords.rightLargeArcRadius - offset) + ' ' + (coords.rightLargeArcRadius - offset) + ' 0 0 0 ' + (coords.rightFullExtent + offset - arrowLen) + ' ' + coords.verticalRightInnerExtent + 'L' + (coords.rightFullExtent + offset - arrowLen) + ' ' + (coords.targetY - coords.rightSmallArcRadius) + 'A' + (coords.rightLargeArcRadius - offset) + ' ' + (coords.rightSmallArcRadius - offset) + ' 0 0 0 ' + (coords.rightInnerExtent - arrowLen) + ' ' + (coords.targetY - offset) + 'L' + (coords.targetX - arrowLen) + ' ' + (coords.targetY - offset) + (arrowLen > 0 ? 'L' + coords.targetX + ' ' + coords.targetY : '') + 'Z';
  } else {
    // Bottom path
    pathString =
    // start at the left of the target node
    'M ' + (coords.targetX - arrowLen) + ' ' + (coords.targetY - offset) + ' ' + 'L' + (coords.rightInnerExtent - arrowLen) + ' ' + (coords.targetY - offset) + 'A' + (coords.rightLargeArcRadius + offset) + ' ' + (coords.rightSmallArcRadius + offset) + ' 0 0 0 ' + (coords.rightFullExtent - offset - arrowLen) + ' ' + (coords.targetY + coords.rightSmallArcRadius) + 'L' + (coords.rightFullExtent - offset - arrowLen) + ' ' + coords.verticalRightInnerExtent + 'A' + (coords.rightLargeArcRadius + offset) + ' ' + (coords.rightLargeArcRadius + offset) + ' 0 0 0 ' + (coords.rightInnerExtent - arrowLen) + ' ' + (coords.verticalFullExtent + offset) + 'L' + coords.leftInnerExtent + ' ' + (coords.verticalFullExtent + offset) + 'A' + (coords.leftLargeArcRadius + offset) + ' ' + (coords.leftLargeArcRadius + offset) + ' 0 0 0 ' + (coords.leftFullExtent + offset) + ' ' + coords.verticalLeftInnerExtent + 'L' + (coords.leftFullExtent + offset) + ' ' + (coords.sourceY + coords.leftSmallArcRadius) + 'A' + (coords.leftLargeArcRadius + offset) + ' ' + (coords.leftSmallArcRadius + offset) + ' 0 0 0 ' + coords.leftInnerExtent + ' ' + (coords.sourceY - offset) + 'L' + coords.sourceX + ' ' + (coords.sourceY - offset) +
    // Walking back
    'L' + coords.sourceX + ' ' + (coords.sourceY + offset) + 'L' + coords.leftInnerExtent + ' ' + (coords.sourceY + offset) + 'A' + (coords.leftLargeArcRadius - offset) + ' ' + (coords.leftSmallArcRadius - offset) + ' 0 0 1 ' + (coords.leftFullExtent - offset) + ' ' + (coords.sourceY + coords.leftSmallArcRadius) + 'L' + (coords.leftFullExtent - offset) + ' ' + coords.verticalLeftInnerExtent + 'A' + (coords.leftLargeArcRadius - offset) + ' ' + (coords.leftLargeArcRadius - offset) + ' 0 0 1 ' + coords.leftInnerExtent + ' ' + (coords.verticalFullExtent - offset) + 'L' + (coords.rightInnerExtent - arrowLen) + ' ' + (coords.verticalFullExtent - offset) + 'A' + (coords.rightLargeArcRadius - offset) + ' ' + (coords.rightLargeArcRadius - offset) + ' 0 0 1 ' + (coords.rightFullExtent + offset - arrowLen) + ' ' + coords.verticalRightInnerExtent + 'L' + (coords.rightFullExtent + offset - arrowLen) + ' ' + (coords.targetY + coords.rightSmallArcRadius) + 'A' + (coords.rightLargeArcRadius - offset) + ' ' + (coords.rightSmallArcRadius - offset) + ' 0 0 1 ' + (coords.rightInnerExtent - arrowLen) + ' ' + (coords.targetY + offset) + 'L' + (coords.targetX - arrowLen) + ' ' + (coords.targetY + offset) + (arrowLen > 0 ? 'L' + coords.targetX + ' ' + coords.targetY : '') + 'Z';
  }
  return pathString;
}
function linkPath() {
  var curvature = 0.5;
  function path(d) {
    var arrowLen = d.linkArrowLength;
    if (d.link.circular) {
      return createCircularClosedPathString(d.link, arrowLen);
    } else {
      var maxArrowLength = Math.abs((d.link.target.x0 - d.link.source.x1) / 2);
      if (arrowLen > maxArrowLength) {
        arrowLen = maxArrowLength;
      }
      var x0 = d.link.source.x1;
      var x1 = d.link.target.x0 - arrowLen;
      var xi = interpolateNumber(x0, x1);
      var x2 = xi(curvature);
      var x3 = xi(1 - curvature);
      var y0a = d.link.y0 - d.link.width / 2;
      var y0b = d.link.y0 + d.link.width / 2;
      var y1a = d.link.y1 - d.link.width / 2;
      var y1b = d.link.y1 + d.link.width / 2;
      var start = 'M' + x0 + ',' + y0a;
      var upperCurve = 'C' + x2 + ',' + y0a + ' ' + x3 + ',' + y1a + ' ' + x1 + ',' + y1a;
      var lowerCurve = 'C' + x3 + ',' + y1b + ' ' + x2 + ',' + y0b + ' ' + x0 + ',' + y0b;
      var rightEnd = arrowLen > 0 ? 'L' + (x1 + arrowLen) + ',' + (y1a + d.link.width / 2) : '';
      rightEnd += 'L' + x1 + ',' + y1b;
      return start + upperCurve + rightEnd + lowerCurve + 'Z';
    }
  }
  return path;
}
function nodeModel(d, n) {
  var tc = tinycolor(n.color);
  var zoneThicknessPad = c.nodePadAcross;
  var zoneLengthPad = d.nodePad / 2;
  n.dx = n.x1 - n.x0;
  n.dy = n.y1 - n.y0;
  var visibleThickness = n.dx;
  var visibleLength = Math.max(0.5, n.dy);
  var key = 'node_' + n.pointNumber;
  // If it's a group, it's mutable and should be unique
  if (n.group) {
    key = Lib.randstr();
  }

  // for event data
  n.trace = d.trace;
  n.curveNumber = d.trace.index;
  return {
    index: n.pointNumber,
    key: key,
    partOfGroup: n.partOfGroup || false,
    group: n.group,
    traceId: d.key,
    trace: d.trace,
    node: n,
    nodePad: d.nodePad,
    nodeLineColor: d.nodeLineColor,
    nodeLineWidth: d.nodeLineWidth,
    textFont: d.textFont,
    size: d.horizontal ? d.height : d.width,
    visibleWidth: Math.ceil(visibleThickness),
    visibleHeight: visibleLength,
    zoneX: -zoneThicknessPad,
    zoneY: -zoneLengthPad,
    zoneWidth: visibleThickness + 2 * zoneThicknessPad,
    zoneHeight: visibleLength + 2 * zoneLengthPad,
    labelY: d.horizontal ? n.dy / 2 + 1 : n.dx / 2 + 1,
    left: n.originalLayer === 1,
    sizeAcross: d.width,
    forceLayouts: d.forceLayouts,
    horizontal: d.horizontal,
    darkBackground: tc.getBrightness() <= 128,
    tinyColorHue: Color.tinyRGB(tc),
    tinyColorAlpha: tc.getAlpha(),
    valueFormat: d.valueFormat,
    valueSuffix: d.valueSuffix,
    sankey: d.sankey,
    graph: d.graph,
    arrangement: d.arrangement,
    uniqueNodeLabelPathId: [d.guid, d.key, key].join('_'),
    interactionState: d.interactionState,
    figure: d
  };
}

// rendering snippets

function updateNodePositions(sankeyNode) {
  sankeyNode.attr('transform', function (d) {
    return strTranslate(d.node.x0.toFixed(3), d.node.y0.toFixed(3));
  });
}
function updateNodeShapes(sankeyNode) {
  sankeyNode.call(updateNodePositions);
}
function updateShapes(sankeyNode, sankeyLink) {
  sankeyNode.call(updateNodeShapes);
  sankeyLink.attr('d', linkPath());
}
function sizeNode(rect) {
  rect.attr('width', function (d) {
    return d.node.x1 - d.node.x0;
  }).attr('height', function (d) {
    return d.visibleHeight;
  });
}
function salientEnough(d) {
  return d.link.width > 1 || d.linkLineWidth > 0;
}
function sankeyTransform(d) {
  var offset = strTranslate(d.translateX, d.translateY);
  return offset + (d.horizontal ? 'matrix(1 0 0 1 0 0)' : 'matrix(0 1 1 0 0 0)');
}

// event handling

function attachPointerEvents(selection, sankey, eventSet) {
  selection.on('.basic', null) // remove any preexisting handlers
  .on('mouseover.basic', function (d) {
    if (!d.interactionState.dragInProgress && !d.partOfGroup) {
      eventSet.hover(this, d, sankey);
      d.interactionState.hovered = [this, d];
    }
  }).on('mousemove.basic', function (d) {
    if (!d.interactionState.dragInProgress && !d.partOfGroup) {
      eventSet.follow(this, d);
      d.interactionState.hovered = [this, d];
    }
  }).on('mouseout.basic', function (d) {
    if (!d.interactionState.dragInProgress && !d.partOfGroup) {
      eventSet.unhover(this, d, sankey);
      d.interactionState.hovered = false;
    }
  }).on('click.basic', function (d) {
    if (d.interactionState.hovered) {
      eventSet.unhover(this, d, sankey);
      d.interactionState.hovered = false;
    }
    if (!d.interactionState.dragInProgress && !d.partOfGroup) {
      eventSet.select(this, d, sankey);
    }
  });
}
function attachDragHandler(sankeyNode, sankeyLink, callbacks, gd) {
  var dragBehavior = d3.behavior.drag().origin(function (d) {
    return {
      x: d.node.x0 + d.visibleWidth / 2,
      y: d.node.y0 + d.visibleHeight / 2
    };
  }).on('dragstart', function (d) {
    if (d.arrangement === 'fixed') return;
    Lib.ensureSingle(gd._fullLayout._infolayer, 'g', 'dragcover', function (s) {
      gd._fullLayout._dragCover = s;
    });
    Lib.raiseToTop(this);
    d.interactionState.dragInProgress = d.node;
    saveCurrentDragPosition(d.node);
    if (d.interactionState.hovered) {
      callbacks.nodeEvents.unhover.apply(0, d.interactionState.hovered);
      d.interactionState.hovered = false;
    }
    if (d.arrangement === 'snap') {
      var forceKey = d.traceId + '|' + d.key;
      if (d.forceLayouts[forceKey]) {
        d.forceLayouts[forceKey].alpha(1);
      } else {
        // make a forceLayout if needed
        attachForce(sankeyNode, forceKey, d, gd);
      }
      startForce(sankeyNode, sankeyLink, d, forceKey, gd);
    }
  }).on('drag', function (d) {
    if (d.arrangement === 'fixed') return;
    var x = d3.event.x;
    var y = d3.event.y;
    if (d.arrangement === 'snap') {
      d.node.x0 = x - d.visibleWidth / 2;
      d.node.x1 = x + d.visibleWidth / 2;
      d.node.y0 = y - d.visibleHeight / 2;
      d.node.y1 = y + d.visibleHeight / 2;
    } else {
      if (d.arrangement === 'freeform') {
        d.node.x0 = x - d.visibleWidth / 2;
        d.node.x1 = x + d.visibleWidth / 2;
      }
      y = Math.max(0, Math.min(d.size - d.visibleHeight / 2, y));
      d.node.y0 = y - d.visibleHeight / 2;
      d.node.y1 = y + d.visibleHeight / 2;
    }
    saveCurrentDragPosition(d.node);
    if (d.arrangement !== 'snap') {
      d.sankey.update(d.graph);
      updateShapes(sankeyNode.filter(sameLayer(d)), sankeyLink);
    }
  }).on('dragend', function (d) {
    if (d.arrangement === 'fixed') return;
    d.interactionState.dragInProgress = false;
    for (var i = 0; i < d.node.childrenNodes.length; i++) {
      d.node.childrenNodes[i].x = d.node.x;
      d.node.childrenNodes[i].y = d.node.y;
    }
    if (d.arrangement !== 'snap') persistFinalNodePositions(d, gd);
  });
  sankeyNode.on('.drag', null) // remove possible previous handlers
  .call(dragBehavior);
}
function attachForce(sankeyNode, forceKey, d, gd) {
  // Attach force to nodes in the same column (same x coordinate)
  switchToForceFormat(d.graph.nodes);
  var nodes = d.graph.nodes.filter(function (n) {
    return n.originalX === d.node.originalX;
  })
  // Filter out children
  .filter(function (n) {
    return !n.partOfGroup;
  });
  d.forceLayouts[forceKey] = d3Force.forceSimulation(nodes).alphaDecay(0).force('collide', d3Force.forceCollide().radius(function (n) {
    return n.dy / 2 + d.nodePad / 2;
  }).strength(1).iterations(c.forceIterations)).force('constrain', snappingForce(sankeyNode, forceKey, nodes, d, gd)).stop();
}
function startForce(sankeyNode, sankeyLink, d, forceKey, gd) {
  window.requestAnimationFrame(function faster() {
    var i;
    for (i = 0; i < c.forceTicksPerFrame; i++) {
      d.forceLayouts[forceKey].tick();
    }
    var nodes = d.graph.nodes;
    switchToSankeyFormat(nodes);
    d.sankey.update(d.graph);
    updateShapes(sankeyNode.filter(sameLayer(d)), sankeyLink);
    if (d.forceLayouts[forceKey].alpha() > 0) {
      window.requestAnimationFrame(faster);
    } else {
      // Make sure the final x position is equal to its original value
      // because the force simulation will have numerical error
      var x = d.node.originalX;
      d.node.x0 = x - d.visibleWidth / 2;
      d.node.x1 = x + d.visibleWidth / 2;
      persistFinalNodePositions(d, gd);
    }
  });
}
function snappingForce(sankeyNode, forceKey, nodes, d) {
  return function _snappingForce() {
    var maxVelocity = 0;
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (n === d.interactionState.dragInProgress) {
        // constrain node position to the dragging pointer
        n.x = n.lastDraggedX;
        n.y = n.lastDraggedY;
      } else {
        n.vx = (n.originalX - n.x) / c.forceTicksPerFrame; // snap to layer
        n.y = Math.min(d.size - n.dy / 2, Math.max(n.dy / 2, n.y)); // constrain to extent
      }
      maxVelocity = Math.max(maxVelocity, Math.abs(n.vx), Math.abs(n.vy));
    }
    if (!d.interactionState.dragInProgress && maxVelocity < 0.1 && d.forceLayouts[forceKey].alpha() > 0) {
      d.forceLayouts[forceKey].alpha(0); // This will stop the animation loop
    }
  };
}

// basic data utilities

function persistFinalNodePositions(d, gd) {
  var x = [];
  var y = [];
  for (var i = 0; i < d.graph.nodes.length; i++) {
    var nodeX = (d.graph.nodes[i].x0 + d.graph.nodes[i].x1) / 2;
    var nodeY = (d.graph.nodes[i].y0 + d.graph.nodes[i].y1) / 2;
    x.push(nodeX / d.figure.width);
    y.push(nodeY / d.figure.height);
  }
  Registry.call('_guiRestyle', gd, {
    'node.x': [x],
    'node.y': [y]
  }, d.trace.index).then(function () {
    if (gd._fullLayout._dragCover) gd._fullLayout._dragCover.remove();
  });
}
function persistOriginalPlace(nodes) {
  var distinctLayerPositions = [];
  var i;
  for (i = 0; i < nodes.length; i++) {
    nodes[i].originalX = (nodes[i].x0 + nodes[i].x1) / 2;
    nodes[i].originalY = (nodes[i].y0 + nodes[i].y1) / 2;
    if (distinctLayerPositions.indexOf(nodes[i].originalX) === -1) {
      distinctLayerPositions.push(nodes[i].originalX);
    }
  }
  distinctLayerPositions.sort(function (a, b) {
    return a - b;
  });
  for (i = 0; i < nodes.length; i++) {
    nodes[i].originalLayerIndex = distinctLayerPositions.indexOf(nodes[i].originalX);
    nodes[i].originalLayer = nodes[i].originalLayerIndex / (distinctLayerPositions.length - 1);
  }
}
function saveCurrentDragPosition(d) {
  d.lastDraggedX = d.x0 + d.dx / 2;
  d.lastDraggedY = d.y0 + d.dy / 2;
}
function sameLayer(d) {
  return function (n) {
    return n.node.originalX === d.node.originalX;
  };
}
function switchToForceFormat(nodes) {
  // force uses x, y as centers
  for (var i = 0; i < nodes.length; i++) {
    nodes[i].y = (nodes[i].y0 + nodes[i].y1) / 2;
    nodes[i].x = (nodes[i].x0 + nodes[i].x1) / 2;
  }
}
function switchToSankeyFormat(nodes) {
  // sankey uses x0, x1, y0, y1
  for (var i = 0; i < nodes.length; i++) {
    nodes[i].y0 = nodes[i].y - nodes[i].dy / 2;
    nodes[i].y1 = nodes[i].y0 + nodes[i].dy;
    nodes[i].x0 = nodes[i].x - nodes[i].dx / 2;
    nodes[i].x1 = nodes[i].x0 + nodes[i].dx;
  }
}

// scene graph
module.exports = function (gd, svg, calcData, layout, callbacks) {
  var isStatic = gd._context.staticPlot;

  // To prevent animation on first render
  var firstRender = false;
  Lib.ensureSingle(gd._fullLayout._infolayer, 'g', 'first-render', function () {
    firstRender = true;
  });

  // To prevent animation on dragging
  var dragcover = gd._fullLayout._dragCover;
  var styledData = calcData.filter(function (d) {
    return unwrap(d).trace.visible;
  }).map(sankeyModel.bind(null, layout));
  var sankey = svg.selectAll('.' + c.cn.sankey).data(styledData, keyFun);
  sankey.exit().remove();
  sankey.enter().append('g').classed(c.cn.sankey, true).style('box-sizing', 'content-box').style('position', 'absolute').style('left', 0).style('shape-rendering', 'geometricPrecision').style('pointer-events', isStatic ? 'none' : 'auto').attr('transform', sankeyTransform);
  sankey.each(function (d, i) {
    gd._fullData[i]._sankey = d;
    // Create dragbox if missing
    var dragboxClassName = 'bgsankey-' + d.trace.uid + '-' + i;
    Lib.ensureSingle(gd._fullLayout._draggers, 'rect', dragboxClassName);
    gd._fullData[i]._bgRect = d3.select('.' + dragboxClassName);

    // Style dragbox
    gd._fullData[i]._bgRect.style('pointer-events', isStatic ? 'none' : 'all').attr('width', d.width).attr('height', d.height).attr('x', d.translateX).attr('y', d.translateY).classed('bgsankey', true).style({
      fill: 'transparent',
      'stroke-width': 0
    });
  });
  sankey.transition().ease(c.ease).duration(c.duration).attr('transform', sankeyTransform);
  var sankeyLinks = sankey.selectAll('.' + c.cn.sankeyLinks).data(repeat, keyFun);
  sankeyLinks.enter().append('g').classed(c.cn.sankeyLinks, true).style('fill', 'none');
  var sankeyLink = sankeyLinks.selectAll('.' + c.cn.sankeyLink).data(function (d) {
    var links = d.graph.links;
    return links.filter(function (l) {
      return l.value;
    }).map(linkModel.bind(null, d));
  }, keyFun);
  sankeyLink.enter().append('path').classed(c.cn.sankeyLink, true).call(attachPointerEvents, sankey, callbacks.linkEvents);
  sankeyLink.style('stroke', function (d) {
    return salientEnough(d) ? Color.tinyRGB(tinycolor(d.linkLineColor)) : d.tinyColorHue;
  }).style('stroke-opacity', function (d) {
    return salientEnough(d) ? Color.opacity(d.linkLineColor) : d.tinyColorAlpha;
  }).style('fill', function (d) {
    return d.tinyColorHue;
  }).style('fill-opacity', function (d) {
    return d.tinyColorAlpha;
  }).style('stroke-width', function (d) {
    return salientEnough(d) ? d.linkLineWidth : 1;
  }).attr('d', linkPath());
  sankeyLink.style('opacity', function () {
    return gd._context.staticPlot || firstRender || dragcover ? 1 : 0;
  }).transition().ease(c.ease).duration(c.duration).style('opacity', 1);
  sankeyLink.exit().transition().ease(c.ease).duration(c.duration).style('opacity', 0).remove();
  var sankeyNodeSet = sankey.selectAll('.' + c.cn.sankeyNodeSet).data(repeat, keyFun);
  sankeyNodeSet.enter().append('g').classed(c.cn.sankeyNodeSet, true);
  sankeyNodeSet.style('cursor', function (d) {
    switch (d.arrangement) {
      case 'fixed':
        return 'default';
      case 'perpendicular':
        return 'ns-resize';
      default:
        return 'move';
    }
  });
  var sankeyNode = sankeyNodeSet.selectAll('.' + c.cn.sankeyNode).data(function (d) {
    var nodes = d.graph.nodes;
    persistOriginalPlace(nodes);
    return nodes.map(nodeModel.bind(null, d));
  }, keyFun);
  sankeyNode.enter().append('g').classed(c.cn.sankeyNode, true).call(updateNodePositions).style('opacity', function (n) {
    return (gd._context.staticPlot || firstRender) && !n.partOfGroup ? 1 : 0;
  });
  sankeyNode.call(attachPointerEvents, sankey, callbacks.nodeEvents).call(attachDragHandler, sankeyLink, callbacks, gd); // has to be here as it binds sankeyLink

  sankeyNode.transition().ease(c.ease).duration(c.duration).call(updateNodePositions).style('opacity', function (n) {
    return n.partOfGroup ? 0 : 1;
  });
  sankeyNode.exit().transition().ease(c.ease).duration(c.duration).style('opacity', 0).remove();
  var nodeRect = sankeyNode.selectAll('.' + c.cn.nodeRect).data(repeat);
  nodeRect.enter().append('rect').classed(c.cn.nodeRect, true).call(sizeNode);
  nodeRect.style('stroke-width', function (d) {
    return d.nodeLineWidth;
  }).style('stroke', function (d) {
    return Color.tinyRGB(tinycolor(d.nodeLineColor));
  }).style('stroke-opacity', function (d) {
    return Color.opacity(d.nodeLineColor);
  }).style('fill', function (d) {
    return d.tinyColorHue;
  }).style('fill-opacity', function (d) {
    return d.tinyColorAlpha;
  });
  nodeRect.transition().ease(c.ease).duration(c.duration).call(sizeNode);
  var nodeLabel = sankeyNode.selectAll('.' + c.cn.nodeLabel).data(repeat);
  nodeLabel.enter().append('text').classed(c.cn.nodeLabel, true).style('cursor', 'default');
  nodeLabel.attr('data-notex', 1) // prohibit tex interpretation until we can handle tex and regular text together
  .text(function (d) {
    return d.node.label;
  }).each(function (d) {
    var e = d3.select(this);
    Drawing.font(e, d.textFont);
    svgTextUtils.convertToTspans(e, gd);
  }).attr('text-anchor', function (d) {
    return d.horizontal && d.left ? 'end' : 'start';
  }).attr('transform', function (d) {
    var e = d3.select(this);
    // how much to shift a multi-line label to center it vertically.
    var nLines = svgTextUtils.lineCount(e);
    var blockHeight = d.textFont.size * ((nLines - 1) * LINE_SPACING - CAP_SHIFT);
    var posX = d.nodeLineWidth / 2 + TEXTPAD;
    var posY = ((d.horizontal ? d.visibleHeight : d.visibleWidth) - blockHeight) / 2;
    if (d.horizontal) {
      if (d.left) {
        posX = -posX;
      } else {
        posX += d.visibleWidth;
      }
    }
    var flipText = d.horizontal ? '' : 'scale(-1,1)' + strRotate(90);
    return strTranslate(d.horizontal ? posX : posY, d.horizontal ? posY : posX) + flipText;
  });
  nodeLabel.transition().ease(c.ease).duration(c.duration);
};

/***/ }),

/***/ 74670:
/***/ (function(module) {

"use strict";


module.exports = function selectPoints(searchInfo, selectionTester) {
  var cd = searchInfo.cd;
  var selection = [];
  var fullData = cd[0].trace;
  var nodes = fullData._sankey.graph.nodes;
  for (var i = 0; i < nodes.length; i++) {
    var node = nodes[i];
    if (node.partOfGroup) continue; // Those are invisible

    // Position of node's centroid
    var pos = [(node.x0 + node.x1) / 2, (node.y0 + node.y1) / 2];

    // Swap x and y if trace is vertical
    if (fullData.orientation === 'v') pos.reverse();
    if (selectionTester && selectionTester.contains(pos, false, i, searchInfo)) {
      selection.push({
        pointNumber: node.pointNumber
        // TODO: add eventData
      });
    }
  }
  return selection;
};

/***/ }),

/***/ 99203:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);

// arrayOk attributes, merge them into calcdata array
module.exports = function arraysToCalcdata(cd, trace) {
  // so each point knows which index it originally came from
  for (var i = 0; i < cd.length; i++) cd[i].i = i;
  Lib.mergeArray(trace.text, cd, 'tx');
  Lib.mergeArray(trace.texttemplate, cd, 'txt');
  Lib.mergeArray(trace.hovertext, cd, 'htx');
  Lib.mergeArray(trace.customdata, cd, 'data');
  Lib.mergeArray(trace.textposition, cd, 'tp');
  if (trace.textfont) {
    Lib.mergeArrayCastPositive(trace.textfont.size, cd, 'ts');
    Lib.mergeArray(trace.textfont.color, cd, 'tc');
    Lib.mergeArray(trace.textfont.family, cd, 'tf');
    Lib.mergeArray(trace.textfont.weight, cd, 'tw');
    Lib.mergeArray(trace.textfont.style, cd, 'ty');
    Lib.mergeArray(trace.textfont.variant, cd, 'tv');
    Lib.mergeArray(trace.textfont.textcase, cd, 'tC');
    Lib.mergeArray(trace.textfont.lineposition, cd, 'tE');
    Lib.mergeArray(trace.textfont.shadow, cd, 'tS');
  }
  var marker = trace.marker;
  if (marker) {
    Lib.mergeArrayCastPositive(marker.size, cd, 'ms');
    Lib.mergeArrayCastPositive(marker.opacity, cd, 'mo');
    Lib.mergeArray(marker.symbol, cd, 'mx');
    Lib.mergeArray(marker.angle, cd, 'ma');
    Lib.mergeArray(marker.standoff, cd, 'mf');
    Lib.mergeArray(marker.color, cd, 'mc');
    var markerLine = marker.line;
    if (marker.line) {
      Lib.mergeArray(markerLine.color, cd, 'mlc');
      Lib.mergeArrayCastPositive(markerLine.width, cd, 'mlw');
    }
    var markerGradient = marker.gradient;
    if (markerGradient && markerGradient.type !== 'none') {
      Lib.mergeArray(markerGradient.type, cd, 'mgt');
      Lib.mergeArray(markerGradient.color, cd, 'mgc');
    }
  }
};

/***/ }),

/***/ 36640:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var axisHoverFormat = (__webpack_require__(80712).axisHoverFormat);
var texttemplateAttrs = (__webpack_require__(3208)/* .texttemplateAttrs */ .ay);
var hovertemplateAttrs = (__webpack_require__(3208)/* .hovertemplateAttrs */ .rb);
var colorScaleAttrs = __webpack_require__(87163);
var fontAttrs = __webpack_require__(80337);
var dash = (__webpack_require__(94850)/* .dash */ .T);
var pattern = (__webpack_require__(94850)/* .pattern */ .k);
var Drawing = __webpack_require__(62203);
var constants = __webpack_require__(32660);
var extendFlat = (__webpack_require__(93049).extendFlat);
var makeFillcolorAttr = __webpack_require__(19326);
function axisPeriod(axis) {
  return {
    valType: 'any',
    dflt: 0,
    editType: 'calc'
  };
}
function axisPeriod0(axis) {
  return {
    valType: 'any',
    editType: 'calc'
  };
}
function axisPeriodAlignment(axis) {
  return {
    valType: 'enumerated',
    values: ['start', 'middle', 'end'],
    dflt: 'middle',
    editType: 'calc'
  };
}
module.exports = {
  x: {
    valType: 'data_array',
    editType: 'calc+clearAxisTypes',
    anim: true
  },
  x0: {
    valType: 'any',
    dflt: 0,
    editType: 'calc+clearAxisTypes',
    anim: true
  },
  dx: {
    valType: 'number',
    dflt: 1,
    editType: 'calc',
    anim: true
  },
  y: {
    valType: 'data_array',
    editType: 'calc+clearAxisTypes',
    anim: true
  },
  y0: {
    valType: 'any',
    dflt: 0,
    editType: 'calc+clearAxisTypes',
    anim: true
  },
  dy: {
    valType: 'number',
    dflt: 1,
    editType: 'calc',
    anim: true
  },
  xperiod: axisPeriod('x'),
  yperiod: axisPeriod('y'),
  xperiod0: axisPeriod0('x0'),
  yperiod0: axisPeriod0('y0'),
  xperiodalignment: axisPeriodAlignment('x'),
  yperiodalignment: axisPeriodAlignment('y'),
  xhoverformat: axisHoverFormat('x'),
  yhoverformat: axisHoverFormat('y'),
  offsetgroup: {
    valType: 'string',
    dflt: '',
    editType: 'calc'
  },
  alignmentgroup: {
    valType: 'string',
    dflt: '',
    editType: 'calc'
  },
  stackgroup: {
    valType: 'string',
    dflt: '',
    editType: 'calc'
  },
  orientation: {
    valType: 'enumerated',
    values: ['v', 'h'],
    editType: 'calc'
  },
  groupnorm: {
    valType: 'enumerated',
    values: ['', 'fraction', 'percent'],
    dflt: '',
    editType: 'calc'
  },
  stackgaps: {
    valType: 'enumerated',
    values: ['infer zero', 'interpolate'],
    dflt: 'infer zero',
    editType: 'calc'
  },
  text: {
    valType: 'string',
    dflt: '',
    arrayOk: true,
    editType: 'calc'
  },
  texttemplate: texttemplateAttrs({}, {}),
  hovertext: {
    valType: 'string',
    dflt: '',
    arrayOk: true,
    editType: 'style'
  },
  mode: {
    valType: 'flaglist',
    flags: ['lines', 'markers', 'text'],
    extras: ['none'],
    editType: 'calc'
  },
  hoveron: {
    valType: 'flaglist',
    flags: ['points', 'fills'],
    editType: 'style'
  },
  hovertemplate: hovertemplateAttrs({}, {
    keys: constants.eventDataKeys
  }),
  line: {
    color: {
      valType: 'color',
      editType: 'style',
      anim: true
    },
    width: {
      valType: 'number',
      min: 0,
      dflt: 2,
      editType: 'style',
      anim: true
    },
    shape: {
      valType: 'enumerated',
      values: ['linear', 'spline', 'hv', 'vh', 'hvh', 'vhv'],
      dflt: 'linear',
      editType: 'plot'
    },
    smoothing: {
      valType: 'number',
      min: 0,
      max: 1.3,
      dflt: 1,
      editType: 'plot'
    },
    dash: extendFlat({}, dash, {
      editType: 'style'
    }),
    backoff: {
      // we want to have a similar option for the start of the line
      valType: 'number',
      min: 0,
      dflt: 'auto',
      arrayOk: true,
      editType: 'plot'
    },
    simplify: {
      valType: 'boolean',
      dflt: true,
      editType: 'plot'
    },
    editType: 'plot'
  },
  connectgaps: {
    valType: 'boolean',
    dflt: false,
    editType: 'calc'
  },
  cliponaxis: {
    valType: 'boolean',
    dflt: true,
    editType: 'plot'
  },
  fill: {
    valType: 'enumerated',
    values: ['none', 'tozeroy', 'tozerox', 'tonexty', 'tonextx', 'toself', 'tonext'],
    editType: 'calc'
  },
  fillcolor: makeFillcolorAttr(true),
  fillgradient: extendFlat({
    type: {
      valType: 'enumerated',
      values: ['radial', 'horizontal', 'vertical', 'none'],
      dflt: 'none',
      editType: 'calc'
    },
    start: {
      valType: 'number',
      editType: 'calc'
    },
    stop: {
      valType: 'number',
      editType: 'calc'
    },
    colorscale: {
      valType: 'colorscale',
      editType: 'style'
    },
    editType: 'calc'
  }),
  fillpattern: pattern,
  marker: extendFlat({
    symbol: {
      valType: 'enumerated',
      values: Drawing.symbolList,
      dflt: 'circle',
      arrayOk: true,
      editType: 'style'
    },
    opacity: {
      valType: 'number',
      min: 0,
      max: 1,
      arrayOk: true,
      editType: 'style',
      anim: true
    },
    angle: {
      valType: 'angle',
      dflt: 0,
      arrayOk: true,
      editType: 'plot',
      anim: false // TODO: possibly set to true in future
    },
    angleref: {
      valType: 'enumerated',
      values: ['previous', 'up'],
      dflt: 'up',
      editType: 'plot',
      anim: false
    },
    standoff: {
      valType: 'number',
      min: 0,
      dflt: 0,
      arrayOk: true,
      editType: 'plot',
      anim: true
    },
    size: {
      valType: 'number',
      min: 0,
      dflt: 6,
      arrayOk: true,
      editType: 'calc',
      anim: true
    },
    maxdisplayed: {
      valType: 'number',
      min: 0,
      dflt: 0,
      editType: 'plot'
    },
    sizeref: {
      valType: 'number',
      dflt: 1,
      editType: 'calc'
    },
    sizemin: {
      valType: 'number',
      min: 0,
      dflt: 0,
      editType: 'calc'
    },
    sizemode: {
      valType: 'enumerated',
      values: ['diameter', 'area'],
      dflt: 'diameter',
      editType: 'calc'
    },
    line: extendFlat({
      width: {
        valType: 'number',
        min: 0,
        arrayOk: true,
        editType: 'style',
        anim: true
      },
      editType: 'calc'
    }, colorScaleAttrs('marker.line', {
      anim: true
    })),
    gradient: {
      type: {
        valType: 'enumerated',
        values: ['radial', 'horizontal', 'vertical', 'none'],
        arrayOk: true,
        dflt: 'none',
        editType: 'calc'
      },
      color: {
        valType: 'color',
        arrayOk: true,
        editType: 'calc'
      },
      editType: 'calc'
    },
    editType: 'calc'
  }, colorScaleAttrs('marker', {
    anim: true
  })),
  selected: {
    marker: {
      opacity: {
        valType: 'number',
        min: 0,
        max: 1,
        editType: 'style'
      },
      color: {
        valType: 'color',
        editType: 'style'
      },
      size: {
        valType: 'number',
        min: 0,
        editType: 'style'
      },
      editType: 'style'
    },
    textfont: {
      color: {
        valType: 'color',
        editType: 'style'
      },
      editType: 'style'
    },
    editType: 'style'
  },
  unselected: {
    marker: {
      opacity: {
        valType: 'number',
        min: 0,
        max: 1,
        editType: 'style'
      },
      color: {
        valType: 'color',
        editType: 'style'
      },
      size: {
        valType: 'number',
        min: 0,
        editType: 'style'
      },
      editType: 'style'
    },
    textfont: {
      color: {
        valType: 'color',
        editType: 'style'
      },
      editType: 'style'
    },
    editType: 'style'
  },
  textposition: {
    valType: 'enumerated',
    values: ['top left', 'top center', 'top right', 'middle left', 'middle center', 'middle right', 'bottom left', 'bottom center', 'bottom right'],
    dflt: 'middle center',
    arrayOk: true,
    editType: 'calc'
  },
  textfont: fontAttrs({
    editType: 'calc',
    colorEditType: 'style',
    arrayOk: true
  }),
  zorder: {
    valType: 'integer',
    dflt: 0,
    editType: 'plot'
  }
};

/***/ }),

/***/ 26544:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isNumeric = __webpack_require__(10721);
var Lib = __webpack_require__(34809);
var Axes = __webpack_require__(29714);
var alignPeriod = __webpack_require__(40528);
var BADNUM = (__webpack_require__(63821).BADNUM);
var subTypes = __webpack_require__(64726);
var calcColorscale = __webpack_require__(77272);
var arraysToCalcdata = __webpack_require__(99203);
var calcSelection = __webpack_require__(48861);
function calc(gd, trace) {
  var fullLayout = gd._fullLayout;
  var xa = trace._xA = Axes.getFromId(gd, trace.xaxis || 'x', 'x');
  var ya = trace._yA = Axes.getFromId(gd, trace.yaxis || 'y', 'y');
  var origX = xa.makeCalcdata(trace, 'x');
  var origY = ya.makeCalcdata(trace, 'y');
  var xObj = alignPeriod(trace, xa, 'x', origX);
  var yObj = alignPeriod(trace, ya, 'y', origY);
  var x = xObj.vals;
  var y = yObj.vals;
  var serieslen = trace._length;
  var cd = new Array(serieslen);
  var ids = trace.ids;
  var stackGroupOpts = getStackOpts(trace, fullLayout, xa, ya);
  var interpolateGaps = false;
  var isV, i, j, k, interpolate, vali;
  setFirstScatter(fullLayout, trace);
  var xAttr = 'x';
  var yAttr = 'y';
  var posAttr;
  if (stackGroupOpts) {
    Lib.pushUnique(stackGroupOpts.traceIndices, trace._expandedIndex);
    isV = stackGroupOpts.orientation === 'v';

    // size, like we use for bar
    if (isV) {
      yAttr = 's';
      posAttr = 'x';
    } else {
      xAttr = 's';
      posAttr = 'y';
    }
    interpolate = stackGroupOpts.stackgaps === 'interpolate';
  } else {
    var ppad = calcMarkerSize(trace, serieslen);
    calcAxisExpansion(gd, trace, xa, ya, x, y, ppad);
  }
  var hasPeriodX = !!trace.xperiodalignment;
  var hasPeriodY = !!trace.yperiodalignment;
  for (i = 0; i < serieslen; i++) {
    var cdi = cd[i] = {};
    var xValid = isNumeric(x[i]);
    var yValid = isNumeric(y[i]);
    if (xValid && yValid) {
      cdi[xAttr] = x[i];
      cdi[yAttr] = y[i];
      if (hasPeriodX) {
        cdi.orig_x = origX[i]; // used by hover
        cdi.xEnd = xObj.ends[i];
        cdi.xStart = xObj.starts[i];
      }
      if (hasPeriodY) {
        cdi.orig_y = origY[i]; // used by hover
        cdi.yEnd = yObj.ends[i];
        cdi.yStart = yObj.starts[i];
      }
    } else if (stackGroupOpts && (isV ? xValid : yValid)) {
      // if we're stacking we need to hold on to all valid positions
      // even with invalid sizes

      cdi[posAttr] = isV ? x[i] : y[i];
      cdi.gap = true;
      if (interpolate) {
        cdi.s = BADNUM;
        interpolateGaps = true;
      } else {
        cdi.s = 0;
      }
    } else {
      cdi[xAttr] = cdi[yAttr] = BADNUM;
    }
    if (ids) {
      cdi.id = String(ids[i]);
    }
  }
  arraysToCalcdata(cd, trace);
  calcColorscale(gd, trace);
  calcSelection(cd, trace);
  if (stackGroupOpts) {
    // remove bad positions and sort
    // note that original indices get added to cd in arraysToCalcdata
    i = 0;
    while (i < cd.length) {
      if (cd[i][posAttr] === BADNUM) {
        cd.splice(i, 1);
      } else i++;
    }
    Lib.sort(cd, function (a, b) {
      return a[posAttr] - b[posAttr] || a.i - b.i;
    });
    if (interpolateGaps) {
      // first fill the beginning with constant from the first point
      i = 0;
      while (i < cd.length - 1 && cd[i].gap) {
        i++;
      }
      vali = cd[i].s;
      if (!vali) vali = cd[i].s = 0; // in case of no data AT ALL in this trace - use 0
      for (j = 0; j < i; j++) {
        cd[j].s = vali;
      }
      // then fill the end with constant from the last point
      k = cd.length - 1;
      while (k > i && cd[k].gap) {
        k--;
      }
      vali = cd[k].s;
      for (j = cd.length - 1; j > k; j--) {
        cd[j].s = vali;
      }
      // now interpolate internal gaps linearly
      while (i < k) {
        i++;
        if (cd[i].gap) {
          j = i + 1;
          while (cd[j].gap) {
            j++;
          }
          var pos0 = cd[i - 1][posAttr];
          var size0 = cd[i - 1].s;
          var m = (cd[j].s - size0) / (cd[j][posAttr] - pos0);
          while (i < j) {
            cd[i].s = size0 + (cd[i][posAttr] - pos0) * m;
            i++;
          }
        }
      }
    }
  }
  return cd;
}
function calcAxisExpansion(gd, trace, xa, ya, x, y, ppad) {
  var serieslen = trace._length;
  var fullLayout = gd._fullLayout;
  var xId = xa._id;
  var yId = ya._id;
  var firstScatter = fullLayout._firstScatter[firstScatterGroup(trace)] === trace.uid;
  var stackOrientation = (getStackOpts(trace, fullLayout, xa, ya) || {}).orientation;
  var fill = trace.fill;

  // cancel minimum tick spacings (only applies to bars and boxes)
  xa._minDtick = 0;
  ya._minDtick = 0;

  // check whether bounds should be tight, padded, extended to zero...
  // most cases both should be padded on both ends, so start with that.
  var xOptions = {
    padded: true
  };
  var yOptions = {
    padded: true
  };
  if (ppad) {
    xOptions.ppad = yOptions.ppad = ppad;
  }

  // TODO: text size

  var openEnded = serieslen < 2 || x[0] !== x[serieslen - 1] || y[0] !== y[serieslen - 1];
  if (openEnded && (fill === 'tozerox' || fill === 'tonextx' && (firstScatter || stackOrientation === 'h'))) {
    // include zero (tight) and extremes (padded) if fill to zero
    // (unless the shape is closed, then it's just filling the shape regardless)

    xOptions.tozero = true;
  } else if (!(trace.error_y || {}).visible && (
  // if no error bars, markers or text, or fill to y=0 remove x padding

  fill === 'tonexty' || fill === 'tozeroy' || !subTypes.hasMarkers(trace) && !subTypes.hasText(trace))) {
    xOptions.padded = false;
    xOptions.ppad = 0;
  }
  if (openEnded && (fill === 'tozeroy' || fill === 'tonexty' && (firstScatter || stackOrientation === 'v'))) {
    // now check for y - rather different logic, though still mostly padded both ends
    // include zero (tight) and extremes (padded) if fill to zero
    // (unless the shape is closed, then it's just filling the shape regardless)

    yOptions.tozero = true;
  } else if (fill === 'tonextx' || fill === 'tozerox') {
    // tight y: any x fill

    yOptions.padded = false;
  }

  // N.B. asymmetric splom traces call this with blank {} xa or ya
  if (xId) trace._extremes[xId] = Axes.findExtremes(xa, x, xOptions);
  if (yId) trace._extremes[yId] = Axes.findExtremes(ya, y, yOptions);
}
function calcMarkerSize(trace, serieslen) {
  if (!subTypes.hasMarkers(trace)) return;

  // Treat size like x or y arrays --- Run d2c
  // this needs to go before ppad computation
  var marker = trace.marker;
  var sizeref = 1.6 * (trace.marker.sizeref || 1);
  var markerTrans;
  if (trace.marker.sizemode === 'area') {
    markerTrans = function (v) {
      return Math.max(Math.sqrt((v || 0) / sizeref), 3);
    };
  } else {
    markerTrans = function (v) {
      return Math.max((v || 0) / sizeref, 3);
    };
  }
  if (Lib.isArrayOrTypedArray(marker.size)) {
    // I tried auto-type but category and dates dont make much sense.
    var ax = {
      type: 'linear'
    };
    Axes.setConvert(ax);
    var s = ax.makeCalcdata(trace.marker, 'size');
    var sizeOut = new Array(serieslen);
    for (var i = 0; i < serieslen; i++) {
      sizeOut[i] = markerTrans(s[i]);
    }
    return sizeOut;
  } else {
    return markerTrans(marker.size);
  }
}

/**
 * mark the first scatter trace for each subplot
 * note that scatter and scattergl each get their own first trace
 * note also that I'm doing this during calc rather than supplyDefaults
 * so I don't need to worry about transforms, but if we ever do
 * per-trace calc this will get confused.
 */
function setFirstScatter(fullLayout, trace) {
  var group = firstScatterGroup(trace);
  var firstScatter = fullLayout._firstScatter;
  if (!firstScatter[group]) firstScatter[group] = trace.uid;
}
function firstScatterGroup(trace) {
  var stackGroup = trace.stackgroup;
  return trace.xaxis + trace.yaxis + trace.type + (stackGroup ? '-' + stackGroup : '');
}
function getStackOpts(trace, fullLayout, xa, ya) {
  var stackGroup = trace.stackgroup;
  if (!stackGroup) return;
  var stackOpts = fullLayout._scatterStackOpts[xa._id + ya._id][stackGroup];
  var stackAx = stackOpts.orientation === 'v' ? ya : xa;
  // Allow stacking only on numeric axes
  // calc is a little late to be figuring this out, but during supplyDefaults
  // we don't know the axis type yet
  if (stackAx.type === 'linear' || stackAx.type === 'log') return stackOpts;
}
module.exports = {
  calc: calc,
  calcMarkerSize: calcMarkerSize,
  calcAxisExpansion: calcAxisExpansion,
  setFirstScatter: setFirstScatter,
  getStackOpts: getStackOpts
};

/***/ }),

/***/ 48861:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
module.exports = function calcSelection(cd, trace) {
  if (Lib.isArrayOrTypedArray(trace.selectedpoints)) {
    Lib.tagSelected(cd, trace);
  }
};

/***/ }),

/***/ 77272:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var hasColorscale = (__webpack_require__(65477).hasColorscale);
var calcColorscale = __webpack_require__(28379);
var subTypes = __webpack_require__(64726);
module.exports = function calcMarkerColorscale(gd, trace) {
  if (subTypes.hasLines(trace) && hasColorscale(trace, 'line')) {
    calcColorscale(gd, trace, {
      vals: trace.line.color,
      containerStr: 'line',
      cLetter: 'c'
    });
  }
  if (subTypes.hasMarkers(trace)) {
    if (hasColorscale(trace, 'marker')) {
      calcColorscale(gd, trace, {
        vals: trace.marker.color,
        containerStr: 'marker',
        cLetter: 'c'
      });
    }
    if (hasColorscale(trace, 'marker.line')) {
      calcColorscale(gd, trace, {
        vals: trace.marker.line.color,
        containerStr: 'marker.line',
        cLetter: 'c'
      });
    }
  }
};

/***/ }),

/***/ 32660:
/***/ (function(module) {

"use strict";


module.exports = {
  PTS_LINESONLY: 20,
  // fixed parameters of clustering and clipping algorithms

  // fraction of clustering tolerance "so close we don't even consider it a new point"
  minTolerance: 0.2,
  // how fast does clustering tolerance increase as you get away from the visible region
  toleranceGrowth: 10,
  // number of viewport sizes away from the visible region
  // at which we clip all lines to the perimeter
  maxScreensAway: 20,
  eventDataKeys: []
};

/***/ }),

/***/ 75603:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var calc = __webpack_require__(26544);
var setGroupPositions = (__webpack_require__(24782).setGroupPositions);
function groupCrossTraceCalc(gd, plotinfo) {
  var xa = plotinfo.xaxis;
  var ya = plotinfo.yaxis;
  var fullLayout = gd._fullLayout;
  var fullTraces = gd._fullData;
  var calcTraces = gd.calcdata;
  var calcTracesHorz = [];
  var calcTracesVert = [];
  for (var i = 0; i < fullTraces.length; i++) {
    var fullTrace = fullTraces[i];
    if (fullTrace.visible === true && fullTrace.type === 'scatter' && fullTrace.xaxis === xa._id && fullTrace.yaxis === ya._id) {
      if (fullTrace.orientation === 'h') {
        calcTracesHorz.push(calcTraces[i]);
      } else if (fullTrace.orientation === 'v') {
        // check for v since certain scatter traces may not have an orientation
        calcTracesVert.push(calcTraces[i]);
      }
    }
  }
  var opts = {
    mode: fullLayout.scattermode,
    gap: fullLayout.scattergap
  };
  setGroupPositions(gd, xa, ya, calcTracesVert, opts);
  setGroupPositions(gd, ya, xa, calcTracesHorz, opts);
}

/*
 * Scatter stacking & normalization calculations
 * runs per subplot, and can handle multiple stacking groups
 */

module.exports = function crossTraceCalc(gd, plotinfo) {
  if (gd._fullLayout.scattermode === 'group') {
    groupCrossTraceCalc(gd, plotinfo);
  }
  var xa = plotinfo.xaxis;
  var ya = plotinfo.yaxis;
  var subplot = xa._id + ya._id;
  var subplotStackOpts = gd._fullLayout._scatterStackOpts[subplot];
  if (!subplotStackOpts) return;
  var calcTraces = gd.calcdata;
  var i, j, k, i2, cd, cd0, posj, sumj, norm;
  var groupOpts, interpolate, groupnorm, posAttr, valAttr;
  var hasAnyBlanks;
  for (var stackGroup in subplotStackOpts) {
    groupOpts = subplotStackOpts[stackGroup];
    var indices = groupOpts.traceIndices;

    // can get here with no indices if the stack axis is non-numeric
    if (!indices.length) continue;
    interpolate = groupOpts.stackgaps === 'interpolate';
    groupnorm = groupOpts.groupnorm;
    if (groupOpts.orientation === 'v') {
      posAttr = 'x';
      valAttr = 'y';
    } else {
      posAttr = 'y';
      valAttr = 'x';
    }
    hasAnyBlanks = new Array(indices.length);
    for (i = 0; i < hasAnyBlanks.length; i++) {
      hasAnyBlanks[i] = false;
    }

    // Collect the complete set of all positions across ALL traces.
    // Start with the first trace, then interleave items from later traces
    // as needed.
    // Fill in mising items as we go.
    cd0 = calcTraces[indices[0]];
    var allPositions = new Array(cd0.length);
    for (i = 0; i < cd0.length; i++) {
      allPositions[i] = cd0[i][posAttr];
    }
    for (i = 1; i < indices.length; i++) {
      cd = calcTraces[indices[i]];
      for (j = k = 0; j < cd.length; j++) {
        posj = cd[j][posAttr];
        for (; posj > allPositions[k] && k < allPositions.length; k++) {
          // the current trace is missing a position from some previous trace(s)
          insertBlank(cd, j, allPositions[k], i, hasAnyBlanks, interpolate, posAttr);
          j++;
        }
        if (posj !== allPositions[k]) {
          // previous trace(s) are missing a position from the current trace
          for (i2 = 0; i2 < i; i2++) {
            insertBlank(calcTraces[indices[i2]], k, posj, i2, hasAnyBlanks, interpolate, posAttr);
          }
          allPositions.splice(k, 0, posj);
        }
        k++;
      }
      for (; k < allPositions.length; k++) {
        insertBlank(cd, j, allPositions[k], i, hasAnyBlanks, interpolate, posAttr);
        j++;
      }
    }
    var serieslen = allPositions.length;

    // stack (and normalize)!
    for (j = 0; j < cd0.length; j++) {
      sumj = cd0[j][valAttr] = cd0[j].s;
      for (i = 1; i < indices.length; i++) {
        cd = calcTraces[indices[i]];
        cd[0].trace._rawLength = cd[0].trace._length;
        cd[0].trace._length = serieslen;
        sumj += cd[j].s;
        cd[j][valAttr] = sumj;
      }
      if (groupnorm) {
        norm = (groupnorm === 'fraction' ? sumj : sumj / 100) || 1;
        for (i = 0; i < indices.length; i++) {
          var cdj = calcTraces[indices[i]][j];
          cdj[valAttr] /= norm;
          cdj.sNorm = cdj.s / norm;
        }
      }
    }

    // autorange
    for (i = 0; i < indices.length; i++) {
      cd = calcTraces[indices[i]];
      var trace = cd[0].trace;
      var ppad = calc.calcMarkerSize(trace, trace._rawLength);
      var arrayPad = Array.isArray(ppad);
      if (ppad && hasAnyBlanks[i] || arrayPad) {
        var ppadRaw = ppad;
        ppad = new Array(serieslen);
        for (j = 0; j < serieslen; j++) {
          ppad[j] = cd[j].gap ? 0 : arrayPad ? ppadRaw[cd[j].i] : ppadRaw;
        }
      }
      var x = new Array(serieslen);
      var y = new Array(serieslen);
      for (j = 0; j < serieslen; j++) {
        x[j] = cd[j].x;
        y[j] = cd[j].y;
      }
      calc.calcAxisExpansion(gd, trace, xa, ya, x, y, ppad);

      // while we're here (in a loop over all traces in the stack)
      // record the orientation, so hover can find it easily
      cd[0].t.orientation = groupOpts.orientation;
    }
  }
};
function insertBlank(calcTrace, index, position, traceIndex, hasAnyBlanks, interpolate, posAttr) {
  hasAnyBlanks[traceIndex] = true;
  var newEntry = {
    i: null,
    gap: true,
    s: 0
  };
  newEntry[posAttr] = position;
  calcTrace.splice(index, 0, newEntry);
  // Even if we're not interpolating, if one trace has multiple
  // values at the same position and this trace only has one value there,
  // we just duplicate that one value rather than insert a zero.
  // We also make it look like a real point - because it's ambiguous which
  // one really is the real one!
  if (index && position === calcTrace[index - 1][posAttr]) {
    var prevEntry = calcTrace[index - 1];
    newEntry.s = prevEntry.s;
    // TODO is it going to cause any problems to have multiple
    // calcdata points with the same index?
    newEntry.i = prevEntry.i;
    newEntry.gap = prevEntry.gap;
  } else if (interpolate) {
    newEntry.s = getInterp(calcTrace, index, position, posAttr);
  }
  if (!index) {
    // t and trace need to stay on the first cd entry
    calcTrace[0].t = calcTrace[1].t;
    calcTrace[0].trace = calcTrace[1].trace;
    delete calcTrace[1].t;
    delete calcTrace[1].trace;
  }
}
function getInterp(calcTrace, index, position, posAttr) {
  var pt0 = calcTrace[index - 1];
  var pt1 = calcTrace[index + 1];
  if (!pt1) return pt0.s;
  if (!pt0) return pt1.s;
  return pt0.s + (pt1.s - pt0.s) * (position - pt0[posAttr]) / (pt1[posAttr] - pt0[posAttr]);
}

/***/ }),

/***/ 53044:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var handleGroupingDefaults = __webpack_require__(36301);
var attributes = __webpack_require__(36640);

// remove opacity for any trace that has a fill or is filled to
module.exports = function crossTraceDefaults(fullData, fullLayout) {
  var traceIn, traceOut, i;
  function coerce(attr) {
    return Lib.coerce(traceOut._input, traceOut, attributes, attr);
  }
  if (fullLayout.scattermode === 'group') {
    for (i = 0; i < fullData.length; i++) {
      traceOut = fullData[i];
      if (traceOut.type === 'scatter') {
        traceIn = traceOut._input;
        handleGroupingDefaults(traceIn, traceOut, fullLayout, coerce);
      }
    }
  }
  for (i = 0; i < fullData.length; i++) {
    var tracei = fullData[i];
    if (tracei.type !== 'scatter') continue;
    var filli = tracei.fill;
    if (filli === 'none' || filli === 'toself') continue;
    tracei.opacity = undefined;
    if (filli === 'tonexty' || filli === 'tonextx') {
      for (var j = i - 1; j >= 0; j--) {
        var tracej = fullData[j];
        if (tracej.type === 'scatter' && tracej.xaxis === tracei.xaxis && tracej.yaxis === tracei.yaxis) {
          tracej.opacity = undefined;
          break;
        }
      }
    }
  }
};

/***/ }),

/***/ 40247:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var Registry = __webpack_require__(33626);
var attributes = __webpack_require__(36640);
var constants = __webpack_require__(32660);
var subTypes = __webpack_require__(64726);
var handleXYDefaults = __webpack_require__(99867);
var handlePeriodDefaults = __webpack_require__(99669);
var handleStackDefaults = __webpack_require__(382);
var handleMarkerDefaults = __webpack_require__(24272);
var handleLineDefaults = __webpack_require__(98168);
var handleLineShapeDefaults = __webpack_require__(91602);
var handleTextDefaults = __webpack_require__(663);
var handleFillColorDefaults = __webpack_require__(54114);
var coercePattern = (__webpack_require__(34809).coercePattern);
module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
  function coerce(attr, dflt) {
    return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
  }
  var len = handleXYDefaults(traceIn, traceOut, layout, coerce);
  if (!len) traceOut.visible = false;
  if (!traceOut.visible) return;
  handlePeriodDefaults(traceIn, traceOut, layout, coerce);
  coerce('xhoverformat');
  coerce('yhoverformat');
  coerce('zorder');
  var stackGroupOpts = handleStackDefaults(traceIn, traceOut, layout, coerce);
  if (layout.scattermode === 'group' && traceOut.orientation === undefined) {
    coerce('orientation', 'v');
  }
  var defaultMode = !stackGroupOpts && len < constants.PTS_LINESONLY ? 'lines+markers' : 'lines';
  coerce('text');
  coerce('hovertext');
  coerce('mode', defaultMode);
  if (subTypes.hasMarkers(traceOut)) {
    handleMarkerDefaults(traceIn, traceOut, defaultColor, layout, coerce, {
      gradient: true
    });
  }
  if (subTypes.hasLines(traceOut)) {
    handleLineDefaults(traceIn, traceOut, defaultColor, layout, coerce, {
      backoff: true
    });
    handleLineShapeDefaults(traceIn, traceOut, coerce);
    coerce('connectgaps');
    coerce('line.simplify');
  }
  if (subTypes.hasText(traceOut)) {
    coerce('texttemplate');
    handleTextDefaults(traceIn, traceOut, layout, coerce);
  }
  var dfltHoverOn = [];
  if (subTypes.hasMarkers(traceOut) || subTypes.hasText(traceOut)) {
    coerce('cliponaxis');
    coerce('marker.maxdisplayed');
    dfltHoverOn.push('points');
  }

  // It's possible for this default to be changed by a later trace.
  // We handle that case in some hacky code inside handleStackDefaults.
  coerce('fill', stackGroupOpts ? stackGroupOpts.fillDflt : 'none');
  if (traceOut.fill !== 'none') {
    handleFillColorDefaults(traceIn, traceOut, defaultColor, coerce, {
      moduleHasFillgradient: true
    });
    if (!subTypes.hasLines(traceOut)) handleLineShapeDefaults(traceIn, traceOut, coerce);
    coercePattern(coerce, 'fillpattern', traceOut.fillcolor, false);
  }
  var lineColor = (traceOut.line || {}).color;
  var markerColor = (traceOut.marker || {}).color;
  if (traceOut.fill === 'tonext' || traceOut.fill === 'toself') {
    dfltHoverOn.push('fills');
  }
  coerce('hoveron', dfltHoverOn.join('+') || 'points');
  if (traceOut.hoveron !== 'fills') coerce('hovertemplate');
  var errorBarsSupplyDefaults = Registry.getComponentMethod('errorbars', 'supplyDefaults');
  errorBarsSupplyDefaults(traceIn, traceOut, lineColor || markerColor || defaultColor, {
    axis: 'y'
  });
  errorBarsSupplyDefaults(traceIn, traceOut, lineColor || markerColor || defaultColor, {
    axis: 'x',
    inherit: 'y'
  });
  Lib.coerceSelectionMarkerOpacity(traceOut, coerce);
};

/***/ }),

/***/ 19326:
/***/ (function(module) {

"use strict";


module.exports = function makeFillcolorAttr(hasFillgradient) {
  return {
    valType: 'color',
    editType: 'style',
    anim: true
  };
};

/***/ }),

/***/ 54114:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Color = __webpack_require__(78766);
var isArrayOrTypedArray = (__webpack_require__(34809).isArrayOrTypedArray);
function averageColors(colorscale) {
  var color = Color.interpolate(colorscale[0][1], colorscale[1][1], 0.5);
  for (var i = 2; i < colorscale.length; i++) {
    var averageColorI = Color.interpolate(colorscale[i - 1][1], colorscale[i][1], 0.5);
    color = Color.interpolate(color, averageColorI, colorscale[i - 1][0] / colorscale[i][0]);
  }
  return color;
}
module.exports = function fillColorDefaults(traceIn, traceOut, defaultColor, coerce, opts) {
  if (!opts) opts = {};
  var inheritColorFromMarker = false;
  if (traceOut.marker) {
    // don't try to inherit a color array
    var markerColor = traceOut.marker.color;
    var markerLineColor = (traceOut.marker.line || {}).color;
    if (markerColor && !isArrayOrTypedArray(markerColor)) {
      inheritColorFromMarker = markerColor;
    } else if (markerLineColor && !isArrayOrTypedArray(markerLineColor)) {
      inheritColorFromMarker = markerLineColor;
    }
  }
  var averageGradientColor;
  if (opts.moduleHasFillgradient) {
    var gradientOrientation = coerce('fillgradient.type');
    if (gradientOrientation !== 'none') {
      coerce('fillgradient.start');
      coerce('fillgradient.stop');
      var gradientColorscale = coerce('fillgradient.colorscale');

      // if a fillgradient is specified, we use the average gradient color
      // to specify fillcolor after all other more specific candidates
      // are considered, but before the global default color.
      // fillcolor affects the background color of the hoverlabel in this case.
      if (gradientColorscale) {
        averageGradientColor = averageColors(gradientColorscale);
      }
    }
  }
  coerce('fillcolor', Color.addOpacity((traceOut.line || {}).color || inheritColorFromMarker || averageGradientColor || defaultColor, 0.5));
};

/***/ }),

/***/ 15294:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Axes = __webpack_require__(29714);
module.exports = function formatLabels(cdi, trace, fullLayout) {
  var labels = {};
  var mockGd = {
    _fullLayout: fullLayout
  };
  var xa = Axes.getFromTrace(mockGd, trace, 'x');
  var ya = Axes.getFromTrace(mockGd, trace, 'y');
  var x = cdi.orig_x;
  if (x === undefined) x = cdi.x;
  var y = cdi.orig_y;
  if (y === undefined) y = cdi.y;
  labels.xLabel = Axes.tickText(xa, xa.c2l(x), true).text;
  labels.yLabel = Axes.tickText(ya, ya.c2l(y), true).text;
  return labels;
};

/***/ }),

/***/ 11539:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Color = __webpack_require__(78766);
var subtypes = __webpack_require__(64726);
module.exports = function getTraceColor(trace, di) {
  var lc, tc;

  // TODO: text modes

  if (trace.mode === 'lines') {
    lc = trace.line.color;
    return lc && Color.opacity(lc) ? lc : trace.fillcolor;
  } else if (trace.mode === 'none') {
    return trace.fill ? trace.fillcolor : '';
  } else {
    var mc = di.mcc || (trace.marker || {}).color;
    var mlc = di.mlcc || ((trace.marker || {}).line || {}).color;
    tc = mc && Color.opacity(mc) ? mc : mlc && Color.opacity(mlc) && (di.mlw || ((trace.marker || {}).line || {}).width) ? mlc : '';
    if (tc) {
      // make sure the points aren't TOO transparent
      if (Color.opacity(tc) < 0.3) {
        return Color.addOpacity(tc, 0.3);
      } else return tc;
    } else {
      lc = (trace.line || {}).color;
      return lc && Color.opacity(lc) && subtypes.hasLines(trace) && trace.line.width ? lc : trace.fillcolor;
    }
  }
};

/***/ }),

/***/ 36301:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var getAxisGroup = (__webpack_require__(84391).getAxisGroup);
module.exports = function handleGroupingDefaults(traceIn, traceOut, fullLayout, coerce) {
  var orientation = traceOut.orientation;
  // N.B. grouping is done across all trace types that support it
  var posAxId = traceOut[{
    v: 'x',
    h: 'y'
  }[orientation] + 'axis'];
  var groupId = getAxisGroup(fullLayout, posAxId) + orientation;
  var alignmentOpts = fullLayout._alignmentOpts || {};
  var alignmentgroup = coerce('alignmentgroup');
  var alignmentGroups = alignmentOpts[groupId];
  if (!alignmentGroups) alignmentGroups = alignmentOpts[groupId] = {};
  var alignmentGroupOpts = alignmentGroups[alignmentgroup];
  if (alignmentGroupOpts) {
    alignmentGroupOpts.traces.push(traceOut);
  } else {
    alignmentGroupOpts = alignmentGroups[alignmentgroup] = {
      traces: [traceOut],
      alignmentIndex: Object.keys(alignmentGroups).length,
      offsetGroups: {}
    };
  }
  var offsetgroup = coerce('offsetgroup');
  var offsetGroups = alignmentGroupOpts.offsetGroups;
  var offsetGroupOpts = offsetGroups[offsetgroup];
  if (offsetgroup) {
    if (!offsetGroupOpts) {
      offsetGroupOpts = offsetGroups[offsetgroup] = {
        offsetIndex: Object.keys(offsetGroups).length
      };
    }
    traceOut._offsetIndex = offsetGroupOpts.offsetIndex;
  }
};

/***/ }),

/***/ 37255:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var Fx = __webpack_require__(32141);
var Registry = __webpack_require__(33626);
var getTraceColor = __webpack_require__(11539);
var Color = __webpack_require__(78766);
var fillText = Lib.fillText;
module.exports = function hoverPoints(pointData, xval, yval, hovermode) {
  var cd = pointData.cd;
  var trace = cd[0].trace;
  var xa = pointData.xa;
  var ya = pointData.ya;
  var xpx = xa.c2p(xval);
  var ypx = ya.c2p(yval);
  var pt = [xpx, ypx];
  var hoveron = trace.hoveron || '';
  var minRad = trace.mode.indexOf('markers') !== -1 ? 3 : 0.5;
  var xPeriod = !!trace.xperiodalignment;
  var yPeriod = !!trace.yperiodalignment;

  // look for points to hover on first, then take fills only if we
  // didn't find a point

  if (hoveron.indexOf('points') !== -1) {
    // dx and dy are used in compare modes - here we want to always
    // prioritize the closest data point, at least as long as markers are
    // the same size or nonexistent, but still try to prioritize small markers too.
    var dx = function (di) {
      if (xPeriod) {
        var x0 = xa.c2p(di.xStart);
        var x1 = xa.c2p(di.xEnd);
        return xpx >= Math.min(x0, x1) && xpx <= Math.max(x0, x1) ? 0 : Infinity;
      }
      var rad = Math.max(3, di.mrc || 0);
      var kink = 1 - 1 / rad;
      var dxRaw = Math.abs(xa.c2p(di.x) - xpx);
      return dxRaw < rad ? kink * dxRaw / rad : dxRaw - rad + kink;
    };
    var dy = function (di) {
      if (yPeriod) {
        var y0 = ya.c2p(di.yStart);
        var y1 = ya.c2p(di.yEnd);
        return ypx >= Math.min(y0, y1) && ypx <= Math.max(y0, y1) ? 0 : Infinity;
      }
      var rad = Math.max(3, di.mrc || 0);
      var kink = 1 - 1 / rad;
      var dyRaw = Math.abs(ya.c2p(di.y) - ypx);
      return dyRaw < rad ? kink * dyRaw / rad : dyRaw - rad + kink;
    };

    // scatter points: d.mrc is the calculated marker radius
    // adjust the distance so if you're inside the marker it
    // always will show up regardless of point size, but
    // prioritize smaller points
    var dxy = function (di) {
      var rad = Math.max(minRad, di.mrc || 0);
      var dx = xa.c2p(di.x) - xpx;
      var dy = ya.c2p(di.y) - ypx;
      return Math.max(Math.sqrt(dx * dx + dy * dy) - rad, 1 - minRad / rad);
    };
    var distfn = Fx.getDistanceFunction(hovermode, dx, dy, dxy);
    Fx.getClosest(cd, distfn, pointData);

    // skip the rest (for this trace) if we didn't find a close point
    if (pointData.index !== false) {
      // the closest data point
      var di = cd[pointData.index];
      var xc = xa.c2p(di.x, true);
      var yc = ya.c2p(di.y, true);
      var rad = di.mrc || 1;

      // now we're done using the whole `calcdata` array, replace the
      // index with the original index (in case of inserted point from
      // stacked area)
      pointData.index = di.i;
      var orientation = cd[0].t.orientation;
      // TODO: for scatter and bar, option to show (sub)totals and
      // raw data? Currently stacked and/or normalized bars just show
      // the normalized individual sizes, so that's what I'm doing here
      // for now.
      var sizeVal = orientation && (di.sNorm || di.s);
      var xLabelVal = orientation === 'h' ? sizeVal : di.orig_x !== undefined ? di.orig_x : di.x;
      var yLabelVal = orientation === 'v' ? sizeVal : di.orig_y !== undefined ? di.orig_y : di.y;
      Lib.extendFlat(pointData, {
        color: getTraceColor(trace, di),
        x0: xc - rad,
        x1: xc + rad,
        xLabelVal: xLabelVal,
        y0: yc - rad,
        y1: yc + rad,
        yLabelVal: yLabelVal,
        spikeDistance: dxy(di),
        hovertemplate: trace.hovertemplate
      });
      fillText(di, trace, pointData);
      Registry.getComponentMethod('errorbars', 'hoverInfo')(di, trace, pointData);
      return [pointData];
    }
  }
  function isHoverPointInFillElement(el) {
    // Uses SVGElement.isPointInFill to accurately determine wether
    // the hover point / cursor is contained in the fill, taking
    // curved or jagged edges into account, which the Polygon-based
    // approach does not.
    if (!el) {
      return false;
    }
    var svgElement = el.node();
    try {
      var domPoint = new DOMPoint(pt[0], pt[1]);
      return svgElement.isPointInFill(domPoint);
    } catch (TypeError) {
      var svgPoint = svgElement.ownerSVGElement.createSVGPoint();
      svgPoint.x = pt[0];
      svgPoint.y = pt[1];
      return svgElement.isPointInFill(svgPoint);
    }
  }
  function getHoverLabelPosition(polygons) {
    // Uses Polygon s to determine the left- and right-most x-coordinates
    // of the subshape of the fill that contains the hover point / cursor.
    // Doing this with the SVGElement directly is quite tricky, so this falls
    // back to the existing relatively simple code, accepting some small inaccuracies
    // of label positioning for curved/jagged edges.
    var i;
    var polygonsIn = [];
    var xmin = Infinity;
    var xmax = -Infinity;
    var ymin = Infinity;
    var ymax = -Infinity;
    var yPos;
    for (i = 0; i < polygons.length; i++) {
      var polygon = polygons[i];
      // This is not going to work right for curved or jagged edges, it will
      // act as though they're straight.
      if (polygon.contains(pt)) {
        polygonsIn.push(polygon);
        ymin = Math.min(ymin, polygon.ymin);
        ymax = Math.max(ymax, polygon.ymax);
      }
    }

    // The above found no polygon that contains the cursor, but we know that
    // the cursor must be inside the fill as determined by the SVGElement
    // (so we are probably close to a curved/jagged edge...).
    if (polygonsIn.length === 0) {
      return null;
    }

    // constrain ymin/max to the visible plot, so the label goes
    // at the middle of the piece you can see
    ymin = Math.max(ymin, 0);
    ymax = Math.min(ymax, ya._length);
    yPos = (ymin + ymax) / 2;

    // find the overall left-most and right-most points of the
    // polygon(s) we're inside at their combined vertical midpoint.
    // This is where we will draw the hover label.
    // Note that this might not be the vertical midpoint of the
    // whole trace, if it's disjoint.
    var j, pts, xAtYPos, x0, x1, y0, y1;
    for (i = 0; i < polygonsIn.length; i++) {
      pts = polygonsIn[i].pts;
      for (j = 1; j < pts.length; j++) {
        y0 = pts[j - 1][1];
        y1 = pts[j][1];
        if (y0 > yPos !== y1 >= yPos) {
          x0 = pts[j - 1][0];
          x1 = pts[j][0];
          if (y1 - y0) {
            xAtYPos = x0 + (x1 - x0) * (yPos - y0) / (y1 - y0);
            xmin = Math.min(xmin, xAtYPos);
            xmax = Math.max(xmax, xAtYPos);
          }
        }
      }
    }

    // constrain xmin/max to the visible plot now too
    xmin = Math.max(xmin, 0);
    xmax = Math.min(xmax, xa._length);
    return {
      x0: xmin,
      x1: xmax,
      y0: yPos,
      y1: yPos
    };
  }

  // even if hoveron is 'fills', only use it if we have a fill element too
  if (hoveron.indexOf('fills') !== -1 && trace._fillElement) {
    var inside = isHoverPointInFillElement(trace._fillElement) && !isHoverPointInFillElement(trace._fillExclusionElement);
    if (inside) {
      var hoverLabelCoords = getHoverLabelPosition(trace._polygons);

      // getHoverLabelPosition may return null if the cursor / hover point is not contained
      // in any of the trace's polygons, which can happen close to curved edges. in that
      // case we fall back to displaying the hover label at the cursor position.
      if (hoverLabelCoords === null) {
        hoverLabelCoords = {
          x0: pt[0],
          x1: pt[0],
          y0: pt[1],
          y1: pt[1]
        };
      }

      // get only fill or line color for the hover color
      var color = Color.defaultLine;
      if (Color.opacity(trace.fillcolor)) color = trace.fillcolor;else if (Color.opacity((trace.line || {}).color)) {
        color = trace.line.color;
      }
      Lib.extendFlat(pointData, {
        // never let a 2D override 1D type as closest point
        // also: no spikeDistance, it's not allowed for fills
        distance: pointData.maxHoverDistance,
        x0: hoverLabelCoords.x0,
        x1: hoverLabelCoords.x1,
        y0: hoverLabelCoords.y0,
        y1: hoverLabelCoords.y1,
        color: color,
        hovertemplate: false
      });
      delete pointData.index;
      if (trace.text && !Lib.isArrayOrTypedArray(trace.text)) {
        pointData.text = String(trace.text);
      } else pointData.text = trace.name;
      return [pointData];
    }
  }
};

/***/ }),

/***/ 69693:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var subtypes = __webpack_require__(64726);
module.exports = {
  hasLines: subtypes.hasLines,
  hasMarkers: subtypes.hasMarkers,
  hasText: subtypes.hasText,
  isBubble: subtypes.isBubble,
  attributes: __webpack_require__(36640),
  layoutAttributes: __webpack_require__(26667),
  supplyDefaults: __webpack_require__(40247),
  crossTraceDefaults: __webpack_require__(53044),
  supplyLayoutDefaults: __webpack_require__(12332),
  calc: (__webpack_require__(26544).calc),
  crossTraceCalc: __webpack_require__(75603),
  arraysToCalcdata: __webpack_require__(99203),
  plot: __webpack_require__(36098),
  colorbar: __webpack_require__(21146),
  formatLabels: __webpack_require__(15294),
  style: (__webpack_require__(9408).style),
  styleOnSelect: (__webpack_require__(9408).styleOnSelect),
  hoverPoints: __webpack_require__(37255),
  selectPoints: __webpack_require__(32665),
  animatable: true,
  moduleType: 'trace',
  name: 'scatter',
  basePlotModule: __webpack_require__(37703),
  categories: ['cartesian', 'svg', 'symbols', 'errorBarsOK', 'showLegend', 'scatter-like', 'zoomScale'],
  meta: {}
};

/***/ }),

/***/ 26667:
/***/ (function(module) {

"use strict";


module.exports = {
  scattermode: {
    valType: 'enumerated',
    values: ['group', 'overlay'],
    dflt: 'overlay',
    editType: 'calc'
  },
  scattergap: {
    valType: 'number',
    min: 0,
    max: 1,
    editType: 'calc'
  }
};

/***/ }),

/***/ 12332:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var layoutAttributes = __webpack_require__(26667);
module.exports = function (layoutIn, layoutOut) {
  function coerce(attr, dflt) {
    return Lib.coerce(layoutIn, layoutOut, layoutAttributes, attr, dflt);
  }
  var groupBarmode = layoutOut.barmode === 'group';
  if (layoutOut.scattermode === 'group') {
    coerce('scattergap', groupBarmode ? layoutOut.bargap : 0.2);
  }
};

/***/ }),

/***/ 98168:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isArrayOrTypedArray = (__webpack_require__(34809).isArrayOrTypedArray);
var hasColorscale = (__webpack_require__(65477).hasColorscale);
var colorscaleDefaults = __webpack_require__(39356);
module.exports = function lineDefaults(traceIn, traceOut, defaultColor, layout, coerce, opts) {
  if (!opts) opts = {};
  var markerColor = (traceIn.marker || {}).color;
  if (markerColor && markerColor._inputArray) markerColor = markerColor._inputArray;
  coerce('line.color', defaultColor);
  if (hasColorscale(traceIn, 'line')) {
    colorscaleDefaults(traceIn, traceOut, layout, coerce, {
      prefix: 'line.',
      cLetter: 'c'
    });
  } else {
    var lineColorDflt = (isArrayOrTypedArray(markerColor) ? false : markerColor) || defaultColor;
    coerce('line.color', lineColorDflt);
  }
  coerce('line.width');
  if (!opts.noDash) coerce('line.dash');
  if (opts.backoff) coerce('line.backoff');
};

/***/ }),

/***/ 5525:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Drawing = __webpack_require__(62203);
var numConstants = __webpack_require__(63821);
var BADNUM = numConstants.BADNUM;
var LOG_CLIP = numConstants.LOG_CLIP;
var LOG_CLIP_PLUS = LOG_CLIP + 0.5;
var LOG_CLIP_MINUS = LOG_CLIP - 0.5;
var Lib = __webpack_require__(34809);
var segmentsIntersect = Lib.segmentsIntersect;
var constrain = Lib.constrain;
var constants = __webpack_require__(32660);
module.exports = function linePoints(d, opts) {
  var trace = opts.trace || {};
  var xa = opts.xaxis;
  var ya = opts.yaxis;
  var xLog = xa.type === 'log';
  var yLog = ya.type === 'log';
  var xLen = xa._length;
  var yLen = ya._length;
  var backoff = opts.backoff;
  var marker = trace.marker;
  var connectGaps = opts.connectGaps;
  var baseTolerance = opts.baseTolerance;
  var shape = opts.shape;
  var linear = shape === 'linear';
  var fill = trace.fill && trace.fill !== 'none';
  var segments = [];
  var minTolerance = constants.minTolerance;
  var len = d.length;
  var pts = new Array(len);
  var pti = 0;
  var i;

  // pt variables are pixel coordinates [x,y] of one point
  // these four are the outputs of clustering on a line
  var clusterStartPt, clusterEndPt, clusterHighPt, clusterLowPt;

  // "this" is the next point we're considering adding to the cluster
  var thisPt;

  // did we encounter the high point first, then a low point, or vice versa?
  var clusterHighFirst;

  // the first two points in the cluster determine its unit vector
  // so the second is always in the "High" direction
  var clusterUnitVector;

  // the pixel delta from clusterStartPt
  var thisVector;

  // val variables are (signed) pixel distances along the cluster vector
  var clusterRefDist, clusterHighVal, clusterLowVal, thisVal;

  // deviation variables are (signed) pixel distances normal to the cluster vector
  var clusterMinDeviation, clusterMaxDeviation, thisDeviation;

  // turn one calcdata point into pixel coordinates
  function getPt(index) {
    var di = d[index];
    if (!di) return false;
    var x = opts.linearized ? xa.l2p(di.x) : xa.c2p(di.x);
    var y = opts.linearized ? ya.l2p(di.y) : ya.c2p(di.y);

    // if non-positive log values, set them VERY far off-screen
    // so the line looks essentially straight from the previous point.
    if (x === BADNUM) {
      if (xLog) x = xa.c2p(di.x, true);
      if (x === BADNUM) return false;
      // If BOTH were bad log values, make the line follow a constant
      // exponent rather than a constant slope
      if (yLog && y === BADNUM) {
        x *= Math.abs(xa._m * yLen * (xa._m > 0 ? LOG_CLIP_PLUS : LOG_CLIP_MINUS) / (ya._m * xLen * (ya._m > 0 ? LOG_CLIP_PLUS : LOG_CLIP_MINUS)));
      }
      x *= 1000;
    }
    if (y === BADNUM) {
      if (yLog) y = ya.c2p(di.y, true);
      if (y === BADNUM) return false;
      y *= 1000;
    }
    return [x, y];
  }
  function crossesViewport(xFrac0, yFrac0, xFrac1, yFrac1) {
    var dx = xFrac1 - xFrac0;
    var dy = yFrac1 - yFrac0;
    var dx0 = 0.5 - xFrac0;
    var dy0 = 0.5 - yFrac0;
    var norm2 = dx * dx + dy * dy;
    var dot = dx * dx0 + dy * dy0;
    if (dot > 0 && dot < norm2) {
      var cross = dx0 * dy - dy0 * dx;
      if (cross * cross < norm2) return true;
    }
  }
  var latestXFrac, latestYFrac;
  // if we're off-screen, increase tolerance over baseTolerance
  function getTolerance(pt, nextPt) {
    var xFrac = pt[0] / xLen;
    var yFrac = pt[1] / yLen;
    var offScreenFraction = Math.max(0, -xFrac, xFrac - 1, -yFrac, yFrac - 1);
    if (offScreenFraction && latestXFrac !== undefined && crossesViewport(xFrac, yFrac, latestXFrac, latestYFrac)) {
      offScreenFraction = 0;
    }
    if (offScreenFraction && nextPt && crossesViewport(xFrac, yFrac, nextPt[0] / xLen, nextPt[1] / yLen)) {
      offScreenFraction = 0;
    }
    return (1 + constants.toleranceGrowth * offScreenFraction) * baseTolerance;
  }
  function ptDist(pt1, pt2) {
    var dx = pt1[0] - pt2[0];
    var dy = pt1[1] - pt2[1];
    return Math.sqrt(dx * dx + dy * dy);
  }

  // last bit of filtering: clip paths that are VERY far off-screen
  // so we don't get near the browser's hard limit (+/- 2^29 px in Chrome and FF)

  var maxScreensAway = constants.maxScreensAway;

  // find the intersections between the segment from pt1 to pt2
  // and the large rectangle maxScreensAway around the viewport
  // if one of pt1 and pt2 is inside and the other outside, there
  // will be only one intersection.
  // if both are outside there will be 0 or 2 intersections
  // (or 1 if it's right at a corner - we'll treat that like 0)
  // returns an array of intersection pts
  var xEdge0 = -xLen * maxScreensAway;
  var xEdge1 = xLen * (1 + maxScreensAway);
  var yEdge0 = -yLen * maxScreensAway;
  var yEdge1 = yLen * (1 + maxScreensAway);
  var edges = [[xEdge0, yEdge0, xEdge1, yEdge0], [xEdge1, yEdge0, xEdge1, yEdge1], [xEdge1, yEdge1, xEdge0, yEdge1], [xEdge0, yEdge1, xEdge0, yEdge0]];
  var xEdge, yEdge, lastXEdge, lastYEdge, lastFarPt, edgePt;

  // for linear line shape, edge intersections should be linearly interpolated
  // spline uses this too, which isn't precisely correct but is actually pretty
  // good, because Catmull-Rom weights far-away points less in creating the curvature
  function getLinearEdgeIntersections(pt1, pt2) {
    var out = [];
    var ptCount = 0;
    for (var i = 0; i < 4; i++) {
      var edge = edges[i];
      var ptInt = segmentsIntersect(pt1[0], pt1[1], pt2[0], pt2[1], edge[0], edge[1], edge[2], edge[3]);
      if (ptInt && (!ptCount || Math.abs(ptInt.x - out[0][0]) > 1 || Math.abs(ptInt.y - out[0][1]) > 1)) {
        ptInt = [ptInt.x, ptInt.y];
        // if we have 2 intersections, make sure the closest one to pt1 comes first
        if (ptCount && ptDist(ptInt, pt1) < ptDist(out[0], pt1)) out.unshift(ptInt);else out.push(ptInt);
        ptCount++;
      }
    }
    return out;
  }
  function onlyConstrainedPoint(pt) {
    if (pt[0] < xEdge0 || pt[0] > xEdge1 || pt[1] < yEdge0 || pt[1] > yEdge1) {
      return [constrain(pt[0], xEdge0, xEdge1), constrain(pt[1], yEdge0, yEdge1)];
    }
  }
  function sameEdge(pt1, pt2) {
    if (pt1[0] === pt2[0] && (pt1[0] === xEdge0 || pt1[0] === xEdge1)) return true;
    if (pt1[1] === pt2[1] && (pt1[1] === yEdge0 || pt1[1] === yEdge1)) return true;
  }

  // for line shapes hv and vh, movement in the two dimensions is decoupled,
  // so all we need to do is constrain each dimension independently
  function getHVEdgeIntersections(pt1, pt2) {
    var out = [];
    var ptInt1 = onlyConstrainedPoint(pt1);
    var ptInt2 = onlyConstrainedPoint(pt2);
    if (ptInt1 && ptInt2 && sameEdge(ptInt1, ptInt2)) return out;
    if (ptInt1) out.push(ptInt1);
    if (ptInt2) out.push(ptInt2);
    return out;
  }

  // hvh and vhv we sometimes have to move one of the intersection points
  // out BEYOND the clipping rect, by a maximum of a factor of 2, so that
  // the midpoint line is drawn in the right place
  function getABAEdgeIntersections(dim, limit0, limit1) {
    return function (pt1, pt2) {
      var ptInt1 = onlyConstrainedPoint(pt1);
      var ptInt2 = onlyConstrainedPoint(pt2);
      var out = [];
      if (ptInt1 && ptInt2 && sameEdge(ptInt1, ptInt2)) return out;
      if (ptInt1) out.push(ptInt1);
      if (ptInt2) out.push(ptInt2);
      var midShift = 2 * Lib.constrain((pt1[dim] + pt2[dim]) / 2, limit0, limit1) - ((ptInt1 || pt1)[dim] + (ptInt2 || pt2)[dim]);
      if (midShift) {
        var ptToAlter;
        if (ptInt1 && ptInt2) {
          ptToAlter = midShift > 0 === ptInt1[dim] > ptInt2[dim] ? ptInt1 : ptInt2;
        } else ptToAlter = ptInt1 || ptInt2;
        ptToAlter[dim] += midShift;
      }
      return out;
    };
  }
  var getEdgeIntersections;
  if (shape === 'linear' || shape === 'spline') {
    getEdgeIntersections = getLinearEdgeIntersections;
  } else if (shape === 'hv' || shape === 'vh') {
    getEdgeIntersections = getHVEdgeIntersections;
  } else if (shape === 'hvh') getEdgeIntersections = getABAEdgeIntersections(0, xEdge0, xEdge1);else if (shape === 'vhv') getEdgeIntersections = getABAEdgeIntersections(1, yEdge0, yEdge1);

  // a segment pt1->pt2 entirely outside the nearby region:
  // find the corner it gets closest to touching
  function getClosestCorner(pt1, pt2) {
    var dx = pt2[0] - pt1[0];
    var m = (pt2[1] - pt1[1]) / dx;
    var b = (pt1[1] * pt2[0] - pt2[1] * pt1[0]) / dx;
    if (b > 0) return [m > 0 ? xEdge0 : xEdge1, yEdge1];else return [m > 0 ? xEdge1 : xEdge0, yEdge0];
  }
  function updateEdge(pt) {
    var x = pt[0];
    var y = pt[1];
    var xSame = x === pts[pti - 1][0];
    var ySame = y === pts[pti - 1][1];
    // duplicate point?
    if (xSame && ySame) return;
    if (pti > 1) {
      // backtracking along an edge?
      var xSame2 = x === pts[pti - 2][0];
      var ySame2 = y === pts[pti - 2][1];
      if (xSame && (x === xEdge0 || x === xEdge1) && xSame2) {
        if (ySame2) pti--; // backtracking exactly - drop prev pt and don't add
        else pts[pti - 1] = pt; // not exact: replace the prev pt
      } else if (ySame && (y === yEdge0 || y === yEdge1) && ySame2) {
        if (xSame2) pti--;else pts[pti - 1] = pt;
      } else pts[pti++] = pt;
    } else pts[pti++] = pt;
  }
  function updateEdgesForReentry(pt) {
    // if we're outside the nearby region and going back in,
    // we may need to loop around a corner point
    if (pts[pti - 1][0] !== pt[0] && pts[pti - 1][1] !== pt[1]) {
      updateEdge([lastXEdge, lastYEdge]);
    }
    updateEdge(pt);
    lastFarPt = null;
    lastXEdge = lastYEdge = 0;
  }
  var arrayMarker = Lib.isArrayOrTypedArray(marker);
  function addPt(pt) {
    if (pt && backoff) {
      pt.i = i;
      pt.d = d;
      pt.trace = trace;
      pt.marker = arrayMarker ? marker[pt.i] : marker;
      pt.backoff = backoff;
    }
    latestXFrac = pt[0] / xLen;
    latestYFrac = pt[1] / yLen;
    // Are we more than maxScreensAway off-screen any direction?
    // if so, clip to this box, but in such a way that on-screen
    // drawing is unchanged
    xEdge = pt[0] < xEdge0 ? xEdge0 : pt[0] > xEdge1 ? xEdge1 : 0;
    yEdge = pt[1] < yEdge0 ? yEdge0 : pt[1] > yEdge1 ? yEdge1 : 0;
    if (xEdge || yEdge) {
      if (!pti) {
        // to get fills right - if first point is far, push it toward the
        // screen in whichever direction(s) are far

        pts[pti++] = [xEdge || pt[0], yEdge || pt[1]];
      } else if (lastFarPt) {
        // both this point and the last are outside the nearby region
        // check if we're crossing the nearby region
        var intersections = getEdgeIntersections(lastFarPt, pt);
        if (intersections.length > 1) {
          updateEdgesForReentry(intersections[0]);
          pts[pti++] = intersections[1];
        }
      } else {
        // we're leaving the nearby region - add the point where we left it

        edgePt = getEdgeIntersections(pts[pti - 1], pt)[0];
        pts[pti++] = edgePt;
      }
      var lastPt = pts[pti - 1];
      if (xEdge && yEdge && (lastPt[0] !== xEdge || lastPt[1] !== yEdge)) {
        // we've gone out beyond a new corner: add the corner too
        // so that the next point will take the right winding
        if (lastFarPt) {
          if (lastXEdge !== xEdge && lastYEdge !== yEdge) {
            if (lastXEdge && lastYEdge) {
              // we've gone around to an opposite corner - we
              // need to add the correct extra corner
              // in order to get the right winding
              updateEdge(getClosestCorner(lastFarPt, pt));
            } else {
              // we're coming from a far edge - the extra corner
              // we need is determined uniquely by the sectors
              updateEdge([lastXEdge || xEdge, lastYEdge || yEdge]);
            }
          } else if (lastXEdge && lastYEdge) {
            updateEdge([lastXEdge, lastYEdge]);
          }
        }
        updateEdge([xEdge, yEdge]);
      } else if (lastXEdge - xEdge && lastYEdge - yEdge) {
        // we're coming from an edge or far corner to an edge - again the
        // extra corner we need is uniquely determined by the sectors
        updateEdge([xEdge || lastXEdge, yEdge || lastYEdge]);
      }
      lastFarPt = pt;
      lastXEdge = xEdge;
      lastYEdge = yEdge;
    } else {
      if (lastFarPt) {
        // this point is in range but the previous wasn't: add its entry pt first
        updateEdgesForReentry(getEdgeIntersections(lastFarPt, pt)[0]);
      }
      pts[pti++] = pt;
    }
  }

  // loop over ALL points in this trace
  for (i = 0; i < len; i++) {
    clusterStartPt = getPt(i);
    if (!clusterStartPt) continue;
    pti = 0;
    lastFarPt = null;
    addPt(clusterStartPt);

    // loop over one segment of the trace
    for (i++; i < len; i++) {
      clusterHighPt = getPt(i);
      if (!clusterHighPt) {
        if (connectGaps) continue;else break;
      }

      // can't decimate if nonlinear line shape
      // TODO: we *could* decimate [hv]{2,3} shapes if we restricted clusters to horz or vert again
      // but spline would be verrry awkward to decimate
      if (!linear || !opts.simplify) {
        addPt(clusterHighPt);
        continue;
      }
      var nextPt = getPt(i + 1);
      clusterRefDist = ptDist(clusterHighPt, clusterStartPt);

      // #3147 - always include the very first and last points for fills
      if (!(fill && (pti === 0 || pti === len - 1)) && clusterRefDist < getTolerance(clusterHighPt, nextPt) * minTolerance) continue;
      clusterUnitVector = [(clusterHighPt[0] - clusterStartPt[0]) / clusterRefDist, (clusterHighPt[1] - clusterStartPt[1]) / clusterRefDist];
      clusterLowPt = clusterStartPt;
      clusterHighVal = clusterRefDist;
      clusterLowVal = clusterMinDeviation = clusterMaxDeviation = 0;
      clusterHighFirst = false;
      clusterEndPt = clusterHighPt;

      // loop over one cluster of points that collapse onto one line
      for (i++; i < d.length; i++) {
        thisPt = nextPt;
        nextPt = getPt(i + 1);
        if (!thisPt) {
          if (connectGaps) continue;else break;
        }
        thisVector = [thisPt[0] - clusterStartPt[0], thisPt[1] - clusterStartPt[1]];
        // cross product (or dot with normal to the cluster vector)
        thisDeviation = thisVector[0] * clusterUnitVector[1] - thisVector[1] * clusterUnitVector[0];
        clusterMinDeviation = Math.min(clusterMinDeviation, thisDeviation);
        clusterMaxDeviation = Math.max(clusterMaxDeviation, thisDeviation);
        if (clusterMaxDeviation - clusterMinDeviation > getTolerance(thisPt, nextPt)) break;
        clusterEndPt = thisPt;
        thisVal = thisVector[0] * clusterUnitVector[0] + thisVector[1] * clusterUnitVector[1];
        if (thisVal > clusterHighVal) {
          clusterHighVal = thisVal;
          clusterHighPt = thisPt;
          clusterHighFirst = false;
        } else if (thisVal < clusterLowVal) {
          clusterLowVal = thisVal;
          clusterLowPt = thisPt;
          clusterHighFirst = true;
        }
      }

      // insert this cluster into pts
      // we've already inserted the start pt, now check if we have high and low pts
      if (clusterHighFirst) {
        addPt(clusterHighPt);
        if (clusterEndPt !== clusterLowPt) addPt(clusterLowPt);
      } else {
        if (clusterLowPt !== clusterStartPt) addPt(clusterLowPt);
        if (clusterEndPt !== clusterHighPt) addPt(clusterHighPt);
      }
      // and finally insert the end pt
      addPt(clusterEndPt);

      // have we reached the end of this segment?
      if (i >= d.length || !thisPt) break;

      // otherwise we have an out-of-cluster point to insert as next clusterStartPt
      addPt(thisPt);
      clusterStartPt = thisPt;
    }

    // to get fills right - repeat what we did at the start
    if (lastFarPt) updateEdge([lastXEdge || lastFarPt[0], lastYEdge || lastFarPt[1]]);
    segments.push(pts.slice(0, pti));
  }
  var lastShapeChar = shape.slice(shape.length - 1);
  if (backoff && lastShapeChar !== 'h' && lastShapeChar !== 'v') {
    var trimmed = false;
    var n = -1;
    var newSegments = [];
    for (var j = 0; j < segments.length; j++) {
      for (var k = 0; k < segments[j].length - 1; k++) {
        var start = segments[j][k];
        var end = segments[j][k + 1];
        var xy = Drawing.applyBackoff(end, start);
        if (xy[0] !== end[0] || xy[1] !== end[1]) {
          trimmed = true;
        }
        if (!newSegments[n + 1]) {
          n++;
          newSegments[n] = [start, [xy[0], xy[1]]];
        }
      }
    }
    return trimmed ? newSegments : segments;
  }
  return segments;
};

/***/ }),

/***/ 91602:
/***/ (function(module) {

"use strict";


// common to 'scatter' and 'scatterternary'
module.exports = function handleLineShapeDefaults(traceIn, traceOut, coerce) {
  var shape = coerce('line.shape');
  if (shape === 'spline') coerce('line.smoothing');
};

/***/ }),

/***/ 17210:
/***/ (function(module) {

"use strict";


var LINKEDFILLS = {
  tonextx: 1,
  tonexty: 1,
  tonext: 1
};
module.exports = function linkTraces(gd, plotinfo, cdscatter) {
  var trace, i, group, prevtrace, groupIndex;

  // first sort traces to keep stacks & filled-together groups together
  var groupIndices = {};
  var needsSort = false;
  var prevGroupIndex = -1;
  var nextGroupIndex = 0;
  var prevUnstackedGroupIndex = -1;
  for (i = 0; i < cdscatter.length; i++) {
    trace = cdscatter[i][0].trace;
    group = trace.stackgroup || '';
    if (group) {
      if (group in groupIndices) {
        groupIndex = groupIndices[group];
      } else {
        groupIndex = groupIndices[group] = nextGroupIndex;
        nextGroupIndex++;
      }
    } else if (trace.fill in LINKEDFILLS && prevUnstackedGroupIndex >= 0) {
      groupIndex = prevUnstackedGroupIndex;
    } else {
      groupIndex = prevUnstackedGroupIndex = nextGroupIndex;
      nextGroupIndex++;
    }
    if (groupIndex < prevGroupIndex) needsSort = true;
    trace._groupIndex = prevGroupIndex = groupIndex;
  }
  var cdscatterSorted = cdscatter.slice();
  if (needsSort) {
    cdscatterSorted.sort(function (a, b) {
      var traceA = a[0].trace;
      var traceB = b[0].trace;
      return traceA._groupIndex - traceB._groupIndex || traceA.index - traceB.index;
    });
  }

  // now link traces to each other
  var prevtraces = {};
  for (i = 0; i < cdscatterSorted.length; i++) {
    trace = cdscatterSorted[i][0].trace;
    group = trace.stackgroup || '';

    // Note: The check which ensures all cdscatter here are for the same axis and
    // are either cartesian or scatterternary has been removed. This code assumes
    // the passed scattertraces have been filtered to the proper plot types and
    // the proper subplots.
    if (trace.visible === true) {
      trace._nexttrace = null;
      if (trace.fill in LINKEDFILLS) {
        prevtrace = prevtraces[group];
        trace._prevtrace = prevtrace || null;
        if (prevtrace) {
          prevtrace._nexttrace = trace;
        }
      }
      trace._ownfill = trace.fill && (trace.fill.substr(0, 6) === 'tozero' || trace.fill === 'toself' || trace.fill.substr(0, 2) === 'to' && !trace._prevtrace);
      prevtraces[group] = trace;
    } else {
      trace._prevtrace = trace._nexttrace = trace._ownfill = null;
    }
  }
  return cdscatterSorted;
};

/***/ }),

/***/ 92527:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isNumeric = __webpack_require__(10721);

// used in the drawing step for 'scatter' and 'scattegeo' and
// in the convert step for 'scatter3d'
module.exports = function makeBubbleSizeFn(trace, factor) {
  if (!factor) {
    factor = 2;
  }
  var marker = trace.marker;
  var sizeRef = marker.sizeref || 1;
  var sizeMin = marker.sizemin || 0;

  // for bubble charts, allow scaling the provided value linearly
  // and by area or diameter.
  // Note this only applies to the array-value sizes

  var baseFn = marker.sizemode === 'area' ? function (v) {
    return Math.sqrt(v / sizeRef);
  } : function (v) {
    return v / sizeRef;
  };

  // TODO add support for position/negative bubbles?
  // TODO add 'sizeoffset' attribute?
  return function (v) {
    var baseSize = baseFn(v / factor);

    // don't show non-numeric and negative sizes
    return isNumeric(baseSize) && baseSize > 0 ? Math.max(baseSize, sizeMin) : 0;
  };
};

/***/ }),

/***/ 21146:
/***/ (function(module) {

"use strict";


module.exports = {
  container: 'marker',
  min: 'cmin',
  max: 'cmax'
};

/***/ }),

/***/ 24272:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Color = __webpack_require__(78766);
var hasColorscale = (__webpack_require__(65477).hasColorscale);
var colorscaleDefaults = __webpack_require__(39356);
var subTypes = __webpack_require__(64726);

/*
 * opts: object of flags to control features not all marker users support
 *   noLine: caller does not support marker lines
 *   gradient: caller supports gradients
 *   noSelect: caller does not support selected/unselected attribute containers
 */
module.exports = function markerDefaults(traceIn, traceOut, defaultColor, layout, coerce, opts) {
  var isBubble = subTypes.isBubble(traceIn);
  var lineColor = (traceIn.line || {}).color;
  var defaultMLC;
  opts = opts || {};

  // marker.color inherit from line.color (even if line.color is an array)
  if (lineColor) defaultColor = lineColor;
  coerce('marker.symbol');
  coerce('marker.opacity', isBubble ? 0.7 : 1);
  coerce('marker.size');
  if (!opts.noAngle) {
    coerce('marker.angle');
    if (!opts.noAngleRef) {
      coerce('marker.angleref');
    }
    if (!opts.noStandOff) {
      coerce('marker.standoff');
    }
  }
  coerce('marker.color', defaultColor);
  if (hasColorscale(traceIn, 'marker')) {
    colorscaleDefaults(traceIn, traceOut, layout, coerce, {
      prefix: 'marker.',
      cLetter: 'c'
    });
  }
  if (!opts.noSelect) {
    coerce('selected.marker.color');
    coerce('unselected.marker.color');
    coerce('selected.marker.size');
    coerce('unselected.marker.size');
  }
  if (!opts.noLine) {
    // if there's a line with a different color than the marker, use
    // that line color as the default marker line color
    // (except when it's an array)
    // mostly this is for transparent markers to behave nicely
    if (lineColor && !Array.isArray(lineColor) && traceOut.marker.color !== lineColor) {
      defaultMLC = lineColor;
    } else if (isBubble) defaultMLC = Color.background;else defaultMLC = Color.defaultLine;
    coerce('marker.line.color', defaultMLC);
    if (hasColorscale(traceIn, 'marker.line')) {
      colorscaleDefaults(traceIn, traceOut, layout, coerce, {
        prefix: 'marker.line.',
        cLetter: 'c'
      });
    }
    coerce('marker.line.width', isBubble ? 1 : 0);
  }
  if (isBubble) {
    coerce('marker.sizeref');
    coerce('marker.sizemin');
    coerce('marker.sizemode');
  }
  if (opts.gradient) {
    var gradientType = coerce('marker.gradient.type');
    if (gradientType !== 'none') {
      coerce('marker.gradient.color');
    }
  }
};

/***/ }),

/***/ 99669:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var dateTick0 = (__webpack_require__(34809).dateTick0);
var numConstants = __webpack_require__(63821);
var ONEWEEK = numConstants.ONEWEEK;
function getPeriod0Dflt(period, calendar) {
  if (period % ONEWEEK === 0) {
    return dateTick0(calendar, 1); // Sunday
  }
  return dateTick0(calendar, 0);
}
module.exports = function handlePeriodDefaults(traceIn, traceOut, layout, coerce, opts) {
  if (!opts) {
    opts = {
      x: true,
      y: true
    };
  }
  if (opts.x) {
    var xperiod = coerce('xperiod');
    if (xperiod) {
      coerce('xperiod0', getPeriod0Dflt(xperiod, traceOut.xcalendar));
      coerce('xperiodalignment');
    }
  }
  if (opts.y) {
    var yperiod = coerce('yperiod');
    if (yperiod) {
      coerce('yperiod0', getPeriod0Dflt(yperiod, traceOut.ycalendar));
      coerce('yperiodalignment');
    }
  }
};

/***/ }),

/***/ 36098:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var Registry = __webpack_require__(33626);
var Lib = __webpack_require__(34809);
var ensureSingle = Lib.ensureSingle;
var identity = Lib.identity;
var Drawing = __webpack_require__(62203);
var subTypes = __webpack_require__(64726);
var linePoints = __webpack_require__(5525);
var linkTraces = __webpack_require__(17210);
var polygonTester = (__webpack_require__(80899).tester);
module.exports = function plot(gd, plotinfo, cdscatter, scatterLayer, transitionOpts, makeOnCompleteCallback) {
  var join, onComplete;

  // If transition config is provided, then it is only a partial replot and traces not
  // updated are removed.
  var isFullReplot = !transitionOpts;
  var hasTransition = !!transitionOpts && transitionOpts.duration > 0;

  // Link traces so the z-order of fill layers is correct
  var cdscatterSorted = linkTraces(gd, plotinfo, cdscatter);
  join = scatterLayer.selectAll('g.trace').data(cdscatterSorted, function (d) {
    return d[0].trace.uid;
  });

  // Append new traces:
  join.enter().append('g').attr('class', function (d) {
    return 'trace scatter trace' + d[0].trace.uid;
  }).style('stroke-miterlimit', 2);
  join.order();
  createFills(gd, join, plotinfo);
  if (hasTransition) {
    if (makeOnCompleteCallback) {
      // If it was passed a callback to register completion, make a callback. If
      // this is created, then it must be executed on completion, otherwise the
      // pos-transition redraw will not execute:
      onComplete = makeOnCompleteCallback();
    }
    var transition = d3.transition().duration(transitionOpts.duration).ease(transitionOpts.easing).each('end', function () {
      onComplete && onComplete();
    }).each('interrupt', function () {
      onComplete && onComplete();
    });
    transition.each(function () {
      // Must run the selection again since otherwise enters/updates get grouped together
      // and these get executed out of order. Except we need them in order!
      scatterLayer.selectAll('g.trace').each(function (d, i) {
        plotOne(gd, i, plotinfo, d, cdscatterSorted, this, transitionOpts);
      });
    });
  } else {
    join.each(function (d, i) {
      plotOne(gd, i, plotinfo, d, cdscatterSorted, this, transitionOpts);
    });
  }
  if (isFullReplot) {
    join.exit().remove();
  }

  // remove paths that didn't get used
  scatterLayer.selectAll('path:not([d])').remove();
};
function createFills(gd, traceJoin, plotinfo) {
  traceJoin.each(function (d) {
    var fills = ensureSingle(d3.select(this), 'g', 'fills');
    Drawing.setClipUrl(fills, plotinfo.layerClipId, gd);
    var trace = d[0].trace;
    var fillData = [];
    if (trace._ownfill) fillData.push('_ownFill');
    if (trace._nexttrace) fillData.push('_nextFill');
    var fillJoin = fills.selectAll('g').data(fillData, identity);
    fillJoin.enter().append('g');
    fillJoin.exit().each(function (d) {
      trace[d] = null;
    }).remove();
    fillJoin.order().each(function (d) {
      // make a path element inside the fill group, just so
      // we can give it its own data later on and the group can
      // keep its simple '_*Fill' data
      trace[d] = ensureSingle(d3.select(this), 'path', 'js-fill');
    });
  });
}
function plotOne(gd, idx, plotinfo, cdscatter, cdscatterAll, element, transitionOpts) {
  var isStatic = gd._context.staticPlot;
  var i;

  // Since this has been reorganized and we're executing this on individual traces,
  // we need to pass it the full list of cdscatter as well as this trace's index (idx)
  // since it does an internal n^2 loop over comparisons with other traces:
  selectMarkers(gd, idx, plotinfo, cdscatter, cdscatterAll);
  var hasTransition = !!transitionOpts && transitionOpts.duration > 0;
  function transition(selection) {
    return hasTransition ? selection.transition() : selection;
  }
  var xa = plotinfo.xaxis;
  var ya = plotinfo.yaxis;
  var trace = cdscatter[0].trace;
  var line = trace.line;
  var tr = d3.select(element);
  var errorBarGroup = ensureSingle(tr, 'g', 'errorbars');
  var lines = ensureSingle(tr, 'g', 'lines');
  var points = ensureSingle(tr, 'g', 'points');
  var text = ensureSingle(tr, 'g', 'text');

  // error bars are at the bottom
  Registry.getComponentMethod('errorbars', 'plot')(gd, errorBarGroup, plotinfo, transitionOpts);
  if (trace.visible !== true) return;
  transition(tr).style('opacity', trace.opacity);

  // BUILD LINES AND FILLS
  var ownFillEl3, tonext;
  var ownFillDir = trace.fill.charAt(trace.fill.length - 1);
  if (ownFillDir !== 'x' && ownFillDir !== 'y') ownFillDir = '';
  var fillAxisIndex, fillAxisZero;
  if (ownFillDir === 'y') {
    fillAxisIndex = 1;
    fillAxisZero = ya.c2p(0, true);
  } else if (ownFillDir === 'x') {
    fillAxisIndex = 0;
    fillAxisZero = xa.c2p(0, true);
  }

  // store node for tweaking by selectPoints
  cdscatter[0][plotinfo.isRangePlot ? 'nodeRangePlot3' : 'node3'] = tr;
  var prevRevpath = '';
  var prevPolygons = [];
  var prevtrace = trace._prevtrace;
  var prevFillsegments = null;
  var prevFillElement = null;
  if (prevtrace) {
    prevRevpath = prevtrace._prevRevpath || '';
    tonext = prevtrace._nextFill;
    prevPolygons = prevtrace._ownPolygons;
    prevFillsegments = prevtrace._fillsegments;
    prevFillElement = prevtrace._fillElement;
  }
  var thispath;
  var thisrevpath;
  // fullpath is all paths for this curve, joined together straight
  // across gaps, for filling
  var fullpath = '';
  // revpath is fullpath reversed, for fill-to-next
  var revpath = '';
  // functions for converting a point array to a path
  var pathfn, revpathbase, revpathfn;
  // variables used before and after the data join
  var pt0, lastSegment, pt1;

  // thisPolygons always contains only the polygons of this trace only
  // whereas trace._polygons may be extended to include those of the previous
  // trace as well for exclusion during hover detection
  var thisPolygons = [];
  trace._polygons = [];
  var fillsegments = [];

  // initialize line join data / method
  var segments = [];
  var makeUpdate = Lib.noop;
  ownFillEl3 = trace._ownFill;
  if (subTypes.hasLines(trace) || trace.fill !== 'none') {
    if (tonext) {
      // This tells .style which trace to use for fill information:
      tonext.datum(cdscatter);
    }
    if (['hv', 'vh', 'hvh', 'vhv'].indexOf(line.shape) !== -1) {
      pathfn = Drawing.steps(line.shape);
      revpathbase = Drawing.steps(line.shape.split('').reverse().join(''));
    } else if (line.shape === 'spline') {
      pathfn = revpathbase = function (pts) {
        var pLast = pts[pts.length - 1];
        if (pts.length > 1 && pts[0][0] === pLast[0] && pts[0][1] === pLast[1]) {
          // identical start and end points: treat it as a
          // closed curve so we don't get a kink
          return Drawing.smoothclosed(pts.slice(1), line.smoothing);
        } else {
          return Drawing.smoothopen(pts, line.smoothing);
        }
      };
    } else {
      pathfn = revpathbase = function (pts) {
        return 'M' + pts.join('L');
      };
    }
    revpathfn = function (pts) {
      // note: this is destructive (reverses pts in place) so can't use pts after this
      return revpathbase(pts.reverse());
    };
    segments = linePoints(cdscatter, {
      xaxis: xa,
      yaxis: ya,
      trace: trace,
      connectGaps: trace.connectgaps,
      baseTolerance: Math.max(line.width || 1, 3) / 4,
      shape: line.shape,
      backoff: line.backoff,
      simplify: line.simplify,
      fill: trace.fill
    });

    // since we already have the pixel segments here, use them to make
    // polygons for hover on fill; we first merge segments where the fill
    // is connected into "fillsegments"; the actual polygon construction
    // is deferred to later to distinguish between self and tonext/tozero fills.
    // TODO: can we skip this if hoveron!=fills? That would mean we
    // need to redraw when you change hoveron...
    fillsegments = new Array(segments.length);
    var fillsegmentCount = 0;
    for (i = 0; i < segments.length; i++) {
      var curpoints;
      var pts = segments[i];
      if (!curpoints || !ownFillDir) {
        curpoints = pts.slice();
        fillsegments[fillsegmentCount] = curpoints;
        fillsegmentCount++;
      } else {
        curpoints.push.apply(curpoints, pts);
      }
    }
    trace._fillElement = null;
    trace._fillExclusionElement = prevFillElement;
    trace._fillsegments = fillsegments.slice(0, fillsegmentCount);
    fillsegments = trace._fillsegments;
    if (segments.length) {
      pt0 = segments[0][0].slice();
      lastSegment = segments[segments.length - 1];
      pt1 = lastSegment[lastSegment.length - 1].slice();
    }
    makeUpdate = function (isEnter) {
      return function (pts) {
        thispath = pathfn(pts);
        thisrevpath = revpathfn(pts); // side-effect: reverses input
        // calculate SVG path over all segments for fills
        if (!fullpath) {
          fullpath = thispath;
          revpath = thisrevpath;
        } else if (ownFillDir) {
          // for fills with fill direction: ignore gaps
          fullpath += 'L' + thispath.substr(1);
          revpath = thisrevpath + ('L' + revpath.substr(1));
        } else {
          fullpath += 'Z' + thispath;
          revpath = thisrevpath + 'Z' + revpath;
        }

        // actual lines get drawn here, with gaps between segments if requested
        if (subTypes.hasLines(trace)) {
          var el = d3.select(this);

          // This makes the coloring work correctly:
          el.datum(cdscatter);
          if (isEnter) {
            transition(el.style('opacity', 0).attr('d', thispath).call(Drawing.lineGroupStyle)).style('opacity', 1);
          } else {
            var sel = transition(el);
            sel.attr('d', thispath);
            Drawing.singleLineStyle(cdscatter, sel);
          }
        }
      };
    };
  }
  var lineJoin = lines.selectAll('.js-line').data(segments);
  transition(lineJoin.exit()).style('opacity', 0).remove();
  lineJoin.each(makeUpdate(false));
  lineJoin.enter().append('path').classed('js-line', true).style('vector-effect', isStatic ? 'none' : 'non-scaling-stroke').call(Drawing.lineGroupStyle).each(makeUpdate(true));
  Drawing.setClipUrl(lineJoin, plotinfo.layerClipId, gd);
  function clearFill(selection) {
    transition(selection).attr('d', 'M0,0Z');
  }

  // helper functions to create polygons for hoveron fill detection
  var makeSelfPolygons = function () {
    var polygons = new Array(fillsegments.length);
    for (i = 0; i < fillsegments.length; i++) {
      polygons[i] = polygonTester(fillsegments[i]);
    }
    return polygons;
  };
  var makePolygonsToPrevious = function (prevFillsegments) {
    var polygons, i;
    if (!prevFillsegments || prevFillsegments.length === 0) {
      // if there are no fill segments of a previous trace, stretch the
      // polygon to the relevant axis
      polygons = new Array(fillsegments.length);
      for (i = 0; i < fillsegments.length; i++) {
        var pt0 = fillsegments[i][0].slice();
        var pt1 = fillsegments[i][fillsegments[i].length - 1].slice();
        pt0[fillAxisIndex] = pt1[fillAxisIndex] = fillAxisZero;
        var zeropoints = [pt1, pt0];
        var polypoints = zeropoints.concat(fillsegments[i]);
        polygons[i] = polygonTester(polypoints);
      }
    } else {
      // if there are more than one previous fill segment, the
      // way that fills work is to "self" fill all but the last segments
      // of the previous and then fill from the new trace to the last
      // segment of the previous.
      polygons = new Array(prevFillsegments.length - 1 + fillsegments.length);
      for (i = 0; i < prevFillsegments.length - 1; i++) {
        polygons[i] = polygonTester(prevFillsegments[i]);
      }
      var reversedPrevFillsegment = prevFillsegments[prevFillsegments.length - 1].slice();
      reversedPrevFillsegment.reverse();
      for (i = 0; i < fillsegments.length; i++) {
        polygons[prevFillsegments.length - 1 + i] = polygonTester(fillsegments[i].concat(reversedPrevFillsegment));
      }
    }
    return polygons;
  };

  // draw fills and create hover detection polygons
  if (segments.length) {
    if (ownFillEl3) {
      ownFillEl3.datum(cdscatter);
      if (pt0 && pt1) {
        // TODO(2023-12-10): this is always true if segments is not empty (?)
        if (ownFillDir) {
          pt0[fillAxisIndex] = pt1[fillAxisIndex] = fillAxisZero;

          // fill to zero: full trace path, plus extension of
          // the endpoints to the appropriate axis
          // For the sake of animations, wrap the points around so that
          // the points on the axes are the first two points. Otherwise
          // animations get a little crazy if the number of points changes.
          transition(ownFillEl3).attr('d', 'M' + pt1 + 'L' + pt0 + 'L' + fullpath.substr(1)).call(Drawing.singleFillStyle, gd);

          // create hover polygons that extend to the axis as well.
          thisPolygons = makePolygonsToPrevious(null); // polygon to axis
        } else {
          // fill to self: just join the path to itself
          transition(ownFillEl3).attr('d', fullpath + 'Z').call(Drawing.singleFillStyle, gd);

          // and simply emit hover polygons for each segment
          thisPolygons = makeSelfPolygons();
        }
      }
      trace._polygons = thisPolygons;
      trace._fillElement = ownFillEl3;
    } else if (tonext) {
      if (trace.fill.substr(0, 6) === 'tonext' && fullpath && prevRevpath) {
        // fill to next: full trace path, plus the previous path reversed
        if (trace.fill === 'tonext') {
          // tonext: for use by concentric shapes, like manually constructed
          // contours, we just add the two paths closed on themselves.
          // This makes strange results if one path is *not* entirely
          // inside the other, but then that is a strange usage.
          transition(tonext).attr('d', fullpath + 'Z' + prevRevpath + 'Z').call(Drawing.singleFillStyle, gd);

          // and simply emit hover polygons for each segment
          thisPolygons = makeSelfPolygons();

          // we add the polygons of the previous trace which causes hover
          // detection to ignore points contained in them.
          trace._polygons = thisPolygons.concat(prevPolygons); // this does not modify thisPolygons, on purpose
        } else {
          // tonextx/y: for now just connect endpoints with lines. This is
          // the correct behavior if the endpoints are at the same value of
          // y/x, but if they *aren't*, we should ideally do more complicated
          // things depending on whether the new endpoint projects onto the
          // existing curve or off the end of it
          transition(tonext).attr('d', fullpath + 'L' + prevRevpath.substr(1) + 'Z').call(Drawing.singleFillStyle, gd);

          // create hover polygons that extend to the previous trace.
          thisPolygons = makePolygonsToPrevious(prevFillsegments);

          // in this case our polygons do not cover that of previous traces,
          // so must not include previous trace polygons for hover detection.
          trace._polygons = thisPolygons;
        }
        trace._fillElement = tonext;
      } else {
        clearFill(tonext);
      }
    }
    trace._prevRevpath = revpath;
  } else {
    if (ownFillEl3) clearFill(ownFillEl3);else if (tonext) clearFill(tonext);
    trace._prevRevpath = null;
  }
  trace._ownPolygons = thisPolygons;
  function visFilter(d) {
    return d.filter(function (v) {
      return !v.gap && v.vis;
    });
  }
  function visFilterWithGaps(d) {
    return d.filter(function (v) {
      return v.vis;
    });
  }
  function gapFilter(d) {
    return d.filter(function (v) {
      return !v.gap;
    });
  }
  function keyFunc(d) {
    return d.id;
  }

  // Returns a function if the trace is keyed, otherwise returns undefined
  function getKeyFunc(trace) {
    if (trace.ids) {
      return keyFunc;
    }
  }
  function hideFilter() {
    return false;
  }
  function makePoints(points, text, cdscatter) {
    var join, selection, hasNode;
    var trace = cdscatter[0].trace;
    var showMarkers = subTypes.hasMarkers(trace);
    var showText = subTypes.hasText(trace);
    var keyFunc = getKeyFunc(trace);
    var markerFilter = hideFilter;
    var textFilter = hideFilter;
    if (showMarkers || showText) {
      var showFilter = identity;
      // if we're stacking, "infer zero" gap mode gets markers in the
      // gap points - because we've inferred a zero there - but other
      // modes (currently "interpolate", later "interrupt" hopefully)
      // we don't draw generated markers
      var stackGroup = trace.stackgroup;
      var isInferZero = stackGroup && gd._fullLayout._scatterStackOpts[xa._id + ya._id][stackGroup].stackgaps === 'infer zero';
      if (trace.marker.maxdisplayed || trace._needsCull) {
        showFilter = isInferZero ? visFilterWithGaps : visFilter;
      } else if (stackGroup && !isInferZero) {
        showFilter = gapFilter;
      }
      if (showMarkers) markerFilter = showFilter;
      if (showText) textFilter = showFilter;
    }

    // marker points

    selection = points.selectAll('path.point');
    join = selection.data(markerFilter, keyFunc);
    var enter = join.enter().append('path').classed('point', true);
    if (hasTransition) {
      enter.call(Drawing.pointStyle, trace, gd).call(Drawing.translatePoints, xa, ya).style('opacity', 0).transition().style('opacity', 1);
    }
    join.order();
    var styleFns;
    if (showMarkers) {
      styleFns = Drawing.makePointStyleFns(trace);
    }
    join.each(function (d) {
      var el = d3.select(this);
      var sel = transition(el);
      hasNode = Drawing.translatePoint(d, sel, xa, ya);
      if (hasNode) {
        Drawing.singlePointStyle(d, sel, trace, styleFns, gd);
        if (plotinfo.layerClipId) {
          Drawing.hideOutsideRangePoint(d, sel, xa, ya, trace.xcalendar, trace.ycalendar);
        }
        if (trace.customdata) {
          el.classed('plotly-customdata', d.data !== null && d.data !== undefined);
        }
      } else {
        sel.remove();
      }
    });
    if (hasTransition) {
      join.exit().transition().style('opacity', 0).remove();
    } else {
      join.exit().remove();
    }

    // text points
    selection = text.selectAll('g');
    join = selection.data(textFilter, keyFunc);

    // each text needs to go in its own 'g' in case
    // it gets converted to mathjax
    join.enter().append('g').classed('textpoint', true).append('text');
    join.order();
    join.each(function (d) {
      var g = d3.select(this);
      var sel = transition(g.select('text'));
      hasNode = Drawing.translatePoint(d, sel, xa, ya);
      if (hasNode) {
        if (plotinfo.layerClipId) {
          Drawing.hideOutsideRangePoint(d, g, xa, ya, trace.xcalendar, trace.ycalendar);
        }
      } else {
        g.remove();
      }
    });
    join.selectAll('text').call(Drawing.textPointStyle, trace, gd).each(function (d) {
      // This just *has* to be totally custom because of SVG text positioning :(
      // It's obviously copied from translatePoint; we just can't use that
      var x = xa.c2p(d.x);
      var y = ya.c2p(d.y);
      d3.select(this).selectAll('tspan.line').each(function () {
        transition(d3.select(this)).attr({
          x: x,
          y: y
        });
      });
    });
    join.exit().remove();
  }
  points.datum(cdscatter);
  text.datum(cdscatter);
  makePoints(points, text, cdscatter);

  // lastly, clip points groups of `cliponaxis !== false` traces
  // on `plotinfo._hasClipOnAxisFalse === true` subplots
  var hasClipOnAxisFalse = trace.cliponaxis === false;
  var clipUrl = hasClipOnAxisFalse ? null : plotinfo.layerClipId;
  Drawing.setClipUrl(points, clipUrl, gd);
  Drawing.setClipUrl(text, clipUrl, gd);
}
function selectMarkers(gd, idx, plotinfo, cdscatter, cdscatterAll) {
  var xa = plotinfo.xaxis;
  var ya = plotinfo.yaxis;
  var xr = d3.extent(Lib.simpleMap(xa.range, xa.r2c));
  var yr = d3.extent(Lib.simpleMap(ya.range, ya.r2c));
  var trace = cdscatter[0].trace;
  if (!subTypes.hasMarkers(trace)) return;
  // if marker.maxdisplayed is used, select a maximum of
  // mnum markers to show, from the set that are in the viewport
  var mnum = trace.marker.maxdisplayed;

  // TODO: remove some as we get away from the viewport?
  if (mnum === 0) return;
  var cd = cdscatter.filter(function (v) {
    return v.x >= xr[0] && v.x <= xr[1] && v.y >= yr[0] && v.y <= yr[1];
  });
  var inc = Math.ceil(cd.length / mnum);
  var tnum = 0;
  cdscatterAll.forEach(function (cdj, j) {
    var tracei = cdj[0].trace;
    if (subTypes.hasMarkers(tracei) && tracei.marker.maxdisplayed > 0 && j < idx) {
      tnum++;
    }
  });

  // if multiple traces use maxdisplayed, stagger which markers we
  // display this formula offsets successive traces by 1/3 of the
  // increment, adding an extra small amount after each triplet so
  // it's not quite periodic
  var i0 = Math.round(tnum * inc / 3 + Math.floor(tnum / 3) * inc / 7.1);

  // for error bars: save in cd which markers to show
  // so we don't have to repeat this
  cdscatter.forEach(function (v) {
    delete v.vis;
  });
  cd.forEach(function (v, i) {
    if (Math.round((i + i0) % inc) === 0) v.vis = true;
  });
}

/***/ }),

/***/ 32665:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var subtypes = __webpack_require__(64726);
module.exports = function selectPoints(searchInfo, selectionTester) {
  var cd = searchInfo.cd;
  var xa = searchInfo.xaxis;
  var ya = searchInfo.yaxis;
  var selection = [];
  var trace = cd[0].trace;
  var i;
  var di;
  var x;
  var y;
  var hasOnlyLines = !subtypes.hasMarkers(trace) && !subtypes.hasText(trace);
  if (hasOnlyLines) return [];
  if (selectionTester === false) {
    // clear selection
    for (i = 0; i < cd.length; i++) {
      cd[i].selected = 0;
    }
  } else {
    for (i = 0; i < cd.length; i++) {
      di = cd[i];
      x = xa.c2p(di.x);
      y = ya.c2p(di.y);
      if (di.i !== null && selectionTester.contains([x, y], false, i, searchInfo)) {
        selection.push({
          pointNumber: di.i,
          x: xa.c2d(di.x),
          y: ya.c2d(di.y)
        });
        di.selected = 1;
      } else {
        di.selected = 0;
      }
    }
  }
  return selection;
};

/***/ }),

/***/ 382:
/***/ (function(module) {

"use strict";


var perStackAttrs = ['orientation', 'groupnorm', 'stackgaps'];
module.exports = function handleStackDefaults(traceIn, traceOut, layout, coerce) {
  var stackOpts = layout._scatterStackOpts;
  var stackGroup = coerce('stackgroup');
  if (stackGroup) {
    // use independent stacking options per subplot
    var subplot = traceOut.xaxis + traceOut.yaxis;
    var subplotStackOpts = stackOpts[subplot];
    if (!subplotStackOpts) subplotStackOpts = stackOpts[subplot] = {};
    var groupOpts = subplotStackOpts[stackGroup];
    var firstTrace = false;
    if (groupOpts) {
      groupOpts.traces.push(traceOut);
    } else {
      groupOpts = subplotStackOpts[stackGroup] = {
        // keep track of trace indices for use during stacking calculations
        // this will be filled in during `calc` and used during `crossTraceCalc`
        // so it's OK if we don't recreate it during a non-calc edit
        traceIndices: [],
        // Hold on to the whole set of prior traces
        // First one is most important, so we can clear defaults
        // there if we find explicit values only in later traces.
        // We're only going to *use* the values stored in groupOpts,
        // but for the editor and validate we want things self-consistent
        // The full set of traces is used only to fix `fill` default if
        // we find `orientation: 'h'` beyond the first trace
        traces: [traceOut]
      };
      firstTrace = true;
    }
    // TODO: how is this going to work with groupby transforms?
    // in principle it should be OK I guess, as long as explicit group styles
    // don't override explicit base-trace styles?

    var dflts = {
      orientation: traceOut.x && !traceOut.y ? 'h' : 'v'
    };
    for (var i = 0; i < perStackAttrs.length; i++) {
      var attr = perStackAttrs[i];
      var attrFound = attr + 'Found';
      if (!groupOpts[attrFound]) {
        var traceHasAttr = traceIn[attr] !== undefined;
        var isOrientation = attr === 'orientation';
        if (traceHasAttr || firstTrace) {
          groupOpts[attr] = coerce(attr, dflts[attr]);
          if (isOrientation) {
            groupOpts.fillDflt = groupOpts[attr] === 'h' ? 'tonextx' : 'tonexty';
          }
          if (traceHasAttr) {
            // Note: this will show a value here even if it's invalid
            // in which case it will revert to default.
            groupOpts[attrFound] = true;

            // Note: only one trace in the stack will get a _fullData
            // entry for a given stack-wide attribute. If no traces
            // (or the first trace) specify that attribute, the
            // first trace will get it. If the first trace does NOT
            // specify it but some later trace does, then it gets
            // removed from the first trace and only included in the
            // one that specified it. This is mostly important for
            // editors (that want to see the full values to know
            // what settings are available) and Plotly.react diffing.
            // Editors may want to use fullLayout._scatterStackOpts
            // directly and make these settings available from all
            // traces in the stack... then set the new value into
            // the first trace, and clear all later traces.
            if (!firstTrace) {
              delete groupOpts.traces[0][attr];

              // orientation can affect default fill of previous traces
              if (isOrientation) {
                for (var j = 0; j < groupOpts.traces.length - 1; j++) {
                  var trace2 = groupOpts.traces[j];
                  if (trace2._input.fill !== trace2.fill) {
                    trace2.fill = groupOpts.fillDflt;
                  }
                }
              }
            }
          }
        }
      }
    }
    return groupOpts;
  }
};

/***/ }),

/***/ 9408:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var Drawing = __webpack_require__(62203);
var Registry = __webpack_require__(33626);
function style(gd) {
  var s = d3.select(gd).selectAll('g.trace.scatter');
  s.style('opacity', function (d) {
    return d[0].trace.opacity;
  });
  s.selectAll('g.points').each(function (d) {
    var sel = d3.select(this);
    var trace = d.trace || d[0].trace;
    stylePoints(sel, trace, gd);
  });
  s.selectAll('g.text').each(function (d) {
    var sel = d3.select(this);
    var trace = d.trace || d[0].trace;
    styleText(sel, trace, gd);
  });
  s.selectAll('g.trace path.js-line').call(Drawing.lineGroupStyle);
  s.selectAll('g.trace path.js-fill').call(Drawing.fillGroupStyle, gd, false);
  Registry.getComponentMethod('errorbars', 'style')(s);
}
function stylePoints(sel, trace, gd) {
  Drawing.pointStyle(sel.selectAll('path.point'), trace, gd);
}
function styleText(sel, trace, gd) {
  Drawing.textPointStyle(sel.selectAll('text'), trace, gd);
}
function styleOnSelect(gd, cd, sel) {
  var trace = cd[0].trace;
  if (trace.selectedpoints) {
    Drawing.selectedPointStyle(sel.selectAll('path.point'), trace);
    Drawing.selectedTextStyle(sel.selectAll('text'), trace);
  } else {
    stylePoints(sel, trace, gd);
    styleText(sel, trace, gd);
  }
}
module.exports = {
  style: style,
  stylePoints: stylePoints,
  styleText: styleText,
  styleOnSelect: styleOnSelect
};

/***/ }),

/***/ 64726:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var isTypedArraySpec = (__webpack_require__(87800).isTypedArraySpec);
module.exports = {
  hasLines: function (trace) {
    return trace.visible && trace.mode && trace.mode.indexOf('lines') !== -1;
  },
  hasMarkers: function (trace) {
    return trace.visible && (trace.mode && trace.mode.indexOf('markers') !== -1 ||
    // until splom implements 'mode'
    trace.type === 'splom');
  },
  hasText: function (trace) {
    return trace.visible && trace.mode && trace.mode.indexOf('text') !== -1;
  },
  isBubble: function (trace) {
    var marker = trace.marker;
    return Lib.isPlainObject(marker) && (Lib.isArrayOrTypedArray(marker.size) || isTypedArraySpec(marker.size));
  }
};

/***/ }),

/***/ 663:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);

/*
 * opts: object of flags to control features not all text users support
 *   noSelect: caller does not support selected/unselected attribute containers
 */
module.exports = function (traceIn, traceOut, layout, coerce, opts) {
  opts = opts || {};
  coerce('textposition');
  Lib.coerceFont(coerce, 'textfont', opts.font || layout.font, opts);
  if (!opts.noSelect) {
    coerce('selected.textfont.color');
    coerce('unselected.textfont.color');
  }
};

/***/ }),

/***/ 99867:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var Registry = __webpack_require__(33626);
module.exports = function handleXYDefaults(traceIn, traceOut, layout, coerce) {
  var x = coerce('x');
  var y = coerce('y');
  var len;
  var handleCalendarDefaults = Registry.getComponentMethod('calendars', 'handleTraceDefaults');
  handleCalendarDefaults(traceIn, traceOut, ['x', 'y'], layout);
  if (x) {
    var xlen = Lib.minRowLength(x);
    if (y) {
      len = Math.min(xlen, Lib.minRowLength(y));
    } else {
      len = xlen;
      coerce('y0');
      coerce('dy');
    }
  } else {
    if (!y) return 0;
    len = Lib.minRowLength(y);
    coerce('x0');
    coerce('dx');
  }
  traceOut._length = len;
  return len;
};

/***/ }),

/***/ 14117:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var scatterAttrs = __webpack_require__(36640);
var fontAttrs = __webpack_require__(80337);
var colorAttributes = __webpack_require__(87163);
var axisHoverFormat = (__webpack_require__(80712).axisHoverFormat);
var hovertemplateAttrs = (__webpack_require__(3208)/* .hovertemplateAttrs */ .rb);
var texttemplateAttrs = (__webpack_require__(3208)/* .texttemplateAttrs */ .ay);
var baseAttrs = __webpack_require__(9829);
var DASHES = __webpack_require__(84770);
var MARKER_SYMBOLS = __webpack_require__(49467);
var extendFlat = (__webpack_require__(93049).extendFlat);
var overrideAll = (__webpack_require__(13582).overrideAll);
var sortObjectKeys = __webpack_require__(62994);
var scatterLineAttrs = scatterAttrs.line;
var scatterMarkerAttrs = scatterAttrs.marker;
var scatterMarkerLineAttrs = scatterMarkerAttrs.line;
var lineAttrs = extendFlat({
  width: scatterLineAttrs.width,
  dash: {
    valType: 'enumerated',
    values: sortObjectKeys(DASHES),
    dflt: 'solid'
  }
}, colorAttributes('line'));
function makeProjectionAttr(axLetter) {
  return {
    show: {
      valType: 'boolean',
      dflt: false
    },
    opacity: {
      valType: 'number',
      min: 0,
      max: 1,
      dflt: 1
    },
    scale: {
      valType: 'number',
      min: 0,
      max: 10,
      dflt: 2 / 3
    }
  };
}
var attrs = module.exports = overrideAll({
  x: scatterAttrs.x,
  y: scatterAttrs.y,
  z: {
    valType: 'data_array'
  },
  text: extendFlat({}, scatterAttrs.text, {}),
  texttemplate: texttemplateAttrs({}, {}),
  hovertext: extendFlat({}, scatterAttrs.hovertext, {}),
  hovertemplate: hovertemplateAttrs(),
  xhoverformat: axisHoverFormat('x'),
  yhoverformat: axisHoverFormat('y'),
  zhoverformat: axisHoverFormat('z'),
  mode: extendFlat({}, scatterAttrs.mode,
  // shouldn't this be on-par with 2D?
  {
    dflt: 'lines+markers'
  }),
  surfaceaxis: {
    valType: 'enumerated',
    values: [-1, 0, 1, 2],
    dflt: -1
  },
  surfacecolor: {
    valType: 'color'
  },
  projection: {
    x: makeProjectionAttr('x'),
    y: makeProjectionAttr('y'),
    z: makeProjectionAttr('z')
  },
  connectgaps: scatterAttrs.connectgaps,
  line: lineAttrs,
  marker: extendFlat({
    // Parity with scatter.js?
    symbol: {
      valType: 'enumerated',
      values: sortObjectKeys(MARKER_SYMBOLS),
      dflt: 'circle',
      arrayOk: true
    },
    size: extendFlat({}, scatterMarkerAttrs.size, {
      dflt: 8
    }),
    sizeref: scatterMarkerAttrs.sizeref,
    sizemin: scatterMarkerAttrs.sizemin,
    sizemode: scatterMarkerAttrs.sizemode,
    opacity: extendFlat({}, scatterMarkerAttrs.opacity, {
      arrayOk: false
    }),
    colorbar: scatterMarkerAttrs.colorbar,
    line: extendFlat({
      width: extendFlat({}, scatterMarkerLineAttrs.width, {
        arrayOk: false
      })
    }, colorAttributes('marker.line'))
  }, colorAttributes('marker')),
  textposition: extendFlat({}, scatterAttrs.textposition, {
    dflt: 'top center'
  }),
  textfont: fontAttrs({
    noFontShadow: true,
    noFontLineposition: true,
    noFontTextcase: true,
    editType: 'calc',
    colorEditType: 'style',
    arrayOk: true,
    variantValues: ['normal', 'small-caps']
  }),
  opacity: baseAttrs.opacity,
  hoverinfo: extendFlat({}, baseAttrs.hoverinfo)
}, 'calc', 'nested');
attrs.x.editType = attrs.y.editType = attrs.z.editType = 'calc+clearAxisTypes';

/***/ }),

/***/ 37593:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var arraysToCalcdata = __webpack_require__(99203);
var calcColorscale = __webpack_require__(77272);

/**
 * This is a kludge to put the array attributes into
 * calcdata the way Scatter.plot does, so that legends and
 * popovers know what to do with them.
 */
module.exports = function calc(gd, trace) {
  var cd = [{
    x: false,
    y: false,
    trace: trace,
    t: {}
  }];
  arraysToCalcdata(cd, trace);
  calcColorscale(gd, trace);
  return cd;
};

/***/ }),

/***/ 95447:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Registry = __webpack_require__(33626);
function calculateAxisErrors(data, params, scaleFactor, axis) {
  if (!params || !params.visible) return null;
  var computeError = Registry.getComponentMethod('errorbars', 'makeComputeError')(params);
  var result = new Array(data.length);
  for (var i = 0; i < data.length; i++) {
    var errors = computeError(+data[i], i);
    if (axis.type === 'log') {
      var point = axis.c2l(data[i]);
      var min = data[i] - errors[0];
      var max = data[i] + errors[1];
      result[i] = [(axis.c2l(min, true) - point) * scaleFactor, (axis.c2l(max, true) - point) * scaleFactor];

      // Keep track of the lower error bound which isn't negative!
      if (min > 0) {
        var lower = axis.c2l(min);
        if (!axis._lowerLogErrorBound) axis._lowerLogErrorBound = lower;
        axis._lowerErrorBound = Math.min(axis._lowerLogErrorBound, lower);
      }
    } else {
      result[i] = [-errors[0] * scaleFactor, errors[1] * scaleFactor];
    }
  }
  return result;
}
function dataLength(array) {
  for (var i = 0; i < array.length; i++) {
    if (array[i]) return array[i].length;
  }
  return 0;
}
function calculateErrors(data, scaleFactor, sceneLayout) {
  var errors = [calculateAxisErrors(data.x, data.error_x, scaleFactor[0], sceneLayout.xaxis), calculateAxisErrors(data.y, data.error_y, scaleFactor[1], sceneLayout.yaxis), calculateAxisErrors(data.z, data.error_z, scaleFactor[2], sceneLayout.zaxis)];
  var n = dataLength(errors);
  if (n === 0) return null;
  var errorBounds = new Array(n);
  for (var i = 0; i < n; i++) {
    var bound = [[0, 0, 0], [0, 0, 0]];
    for (var j = 0; j < 3; j++) {
      if (errors[j]) {
        for (var k = 0; k < 2; k++) {
          bound[k][j] = errors[j][i][k];
        }
      }
    }
    errorBounds[i] = bound;
  }
  return errorBounds;
}
module.exports = calculateErrors;

/***/ }),

/***/ 16533:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var createLinePlot = (__webpack_require__(99098).gl_line3d);
var createScatterPlot = (__webpack_require__(99098).gl_scatter3d);
var createErrorBars = (__webpack_require__(99098).gl_error3d);
var createMesh = (__webpack_require__(99098).gl_mesh3d);
var triangulate = (__webpack_require__(99098).delaunay_triangulate);
var Lib = __webpack_require__(34809);
var str2RgbaArray = __webpack_require__(55010);
var formatColor = (__webpack_require__(46998).formatColor);
var makeBubbleSizeFn = __webpack_require__(92527);
var DASH_PATTERNS = __webpack_require__(84770);
var MARKER_SYMBOLS = __webpack_require__(49467);
var Axes = __webpack_require__(29714);
var appendArrayPointValue = (__webpack_require__(36040).appendArrayPointValue);
var calculateError = __webpack_require__(95447);
function LineWithMarkers(scene, uid) {
  this.scene = scene;
  this.uid = uid;
  this.linePlot = null;
  this.scatterPlot = null;
  this.errorBars = null;
  this.textMarkers = null;
  this.delaunayMesh = null;
  this.color = null;
  this.mode = '';
  this.dataPoints = [];
  this.axesBounds = [[-Infinity, -Infinity, -Infinity], [Infinity, Infinity, Infinity]];
  this.textLabels = null;
  this.data = null;
}
var proto = LineWithMarkers.prototype;
proto.handlePick = function (selection) {
  if (selection.object && (selection.object === this.linePlot || selection.object === this.delaunayMesh || selection.object === this.textMarkers || selection.object === this.scatterPlot)) {
    var ind = selection.index = selection.data.index;
    if (selection.object.highlight) {
      selection.object.highlight(null);
    }
    if (this.scatterPlot) {
      selection.object = this.scatterPlot;
      this.scatterPlot.highlight(selection.data);
    }
    selection.textLabel = '';
    if (this.textLabels) {
      if (Lib.isArrayOrTypedArray(this.textLabels)) {
        if (this.textLabels[ind] || this.textLabels[ind] === 0) {
          selection.textLabel = this.textLabels[ind];
        }
      } else {
        selection.textLabel = this.textLabels;
      }
    }
    selection.traceCoordinate = [this.data.x[ind], this.data.y[ind], this.data.z[ind]];
    return true;
  }
};
function constructDelaunay(points, color, axis) {
  var u = (axis + 1) % 3;
  var v = (axis + 2) % 3;
  var filteredPoints = [];
  var filteredIds = [];
  var i;
  for (i = 0; i < points.length; ++i) {
    var p = points[i];
    if (isNaN(p[u]) || !isFinite(p[u]) || isNaN(p[v]) || !isFinite(p[v])) {
      continue;
    }
    filteredPoints.push([p[u], p[v]]);
    filteredIds.push(i);
  }
  var cells = triangulate(filteredPoints);
  for (i = 0; i < cells.length; ++i) {
    var c = cells[i];
    for (var j = 0; j < c.length; ++j) {
      c[j] = filteredIds[c[j]];
    }
  }
  return {
    positions: points,
    cells: cells,
    meshColor: color
  };
}
function calculateErrorParams(errors) {
  var capSize = [0.0, 0.0, 0.0];
  var color = [[0, 0, 0], [0, 0, 0], [0, 0, 0]];
  var lineWidth = [1.0, 1.0, 1.0];
  for (var i = 0; i < 3; i++) {
    var e = errors[i];
    if (e && e.copy_zstyle !== false && errors[2].visible !== false) e = errors[2];
    if (!e || !e.visible) continue;
    capSize[i] = e.width / 2; // ballpark rescaling
    color[i] = str2RgbaArray(e.color);
    lineWidth[i] = e.thickness;
  }
  return {
    capSize: capSize,
    color: color,
    lineWidth: lineWidth
  };
}
function parseAlignmentX(a) {
  if (a === null || a === undefined) return 0;
  return a.indexOf('left') > -1 ? -1 : a.indexOf('right') > -1 ? 1 : 0;
}
function parseAlignmentY(a) {
  if (a === null || a === undefined) return 0;
  return a.indexOf('top') > -1 ? -1 : a.indexOf('bottom') > -1 ? 1 : 0;
}
function calculateTextOffset(tp) {
  // Read out text properties

  var defaultAlignmentX = 0;
  var defaultAlignmentY = 0;
  var textOffset = [defaultAlignmentX, defaultAlignmentY];
  if (Array.isArray(tp)) {
    for (var i = 0; i < tp.length; i++) {
      textOffset[i] = [defaultAlignmentX, defaultAlignmentY];
      if (tp[i]) {
        textOffset[i][0] = parseAlignmentX(tp[i]);
        textOffset[i][1] = parseAlignmentY(tp[i]);
      }
    }
  } else {
    textOffset[0] = parseAlignmentX(tp);
    textOffset[1] = parseAlignmentY(tp);
  }
  return textOffset;
}
function calculateSize(sizeIn, sizeFn) {
  // rough parity with Plotly 2D markers
  return sizeFn(sizeIn * 4);
}
function calculateSymbol(symbolIn) {
  return MARKER_SYMBOLS[symbolIn];
}
function formatParam(paramIn, len, calculate, dflt, extraFn) {
  var paramOut = null;
  if (Lib.isArrayOrTypedArray(paramIn)) {
    paramOut = [];
    for (var i = 0; i < len; i++) {
      if (paramIn[i] === undefined) paramOut[i] = dflt;else paramOut[i] = calculate(paramIn[i], extraFn);
    }
  } else paramOut = calculate(paramIn, Lib.identity);
  return paramOut;
}
function convertPlotlyOptions(scene, data) {
  var points = [];
  var sceneLayout = scene.fullSceneLayout;
  var scaleFactor = scene.dataScale;
  var xaxis = sceneLayout.xaxis;
  var yaxis = sceneLayout.yaxis;
  var zaxis = sceneLayout.zaxis;
  var marker = data.marker;
  var line = data.line;
  var x = data.x || [];
  var y = data.y || [];
  var z = data.z || [];
  var len = x.length;
  var xcalendar = data.xcalendar;
  var ycalendar = data.ycalendar;
  var zcalendar = data.zcalendar;
  var xc, yc, zc;
  var params, i;
  var text;

  // Convert points
  for (i = 0; i < len; i++) {
    // sanitize numbers and apply transforms based on axes.type
    xc = xaxis.d2l(x[i], 0, xcalendar) * scaleFactor[0];
    yc = yaxis.d2l(y[i], 0, ycalendar) * scaleFactor[1];
    zc = zaxis.d2l(z[i], 0, zcalendar) * scaleFactor[2];
    points[i] = [xc, yc, zc];
  }

  // convert text
  if (Array.isArray(data.text)) {
    text = data.text;
  } else if (Lib.isTypedArray(data.text)) {
    text = Array.from(data.text);
  } else if (data.text !== undefined) {
    text = new Array(len);
    for (i = 0; i < len; i++) text[i] = data.text;
  }
  function formatter(axName, val) {
    var ax = sceneLayout[axName];
    return Axes.tickText(ax, ax.d2l(val), true).text;
  }

  // check texttemplate
  var texttemplate = data.texttemplate;
  if (texttemplate) {
    var fullLayout = scene.fullLayout;
    var d3locale = fullLayout._d3locale;
    var isArray = Array.isArray(texttemplate);
    var N = isArray ? Math.min(texttemplate.length, len) : len;
    var txt = isArray ? function (i) {
      return texttemplate[i];
    } : function () {
      return texttemplate;
    };
    text = new Array(N);
    for (i = 0; i < N; i++) {
      var d = {
        x: x[i],
        y: y[i],
        z: z[i]
      };
      var labels = {
        xLabel: formatter('xaxis', x[i]),
        yLabel: formatter('yaxis', y[i]),
        zLabel: formatter('zaxis', z[i])
      };
      var pointValues = {};
      appendArrayPointValue(pointValues, data, i);
      var meta = data._meta || {};
      text[i] = Lib.texttemplateString(txt(i), labels, d3locale, pointValues, d, meta);
    }
  }

  // Build object parameters
  params = {
    position: points,
    mode: data.mode,
    text: text
  };
  if ('line' in data) {
    params.lineColor = formatColor(line, 1, len);
    params.lineWidth = line.width;
    params.lineDashes = line.dash;
  }
  if ('marker' in data) {
    var sizeFn = makeBubbleSizeFn(data);
    params.scatterColor = formatColor(marker, 1, len);
    params.scatterSize = formatParam(marker.size, len, calculateSize, 20, sizeFn);
    params.scatterMarker = formatParam(marker.symbol, len, calculateSymbol, '●');
    params.scatterLineWidth = marker.line.width; // arrayOk === false
    params.scatterLineColor = formatColor(marker.line, 1, len);
    params.scatterAngle = 0;
  }
  if ('textposition' in data) {
    params.textOffset = calculateTextOffset(data.textposition);
    params.textColor = formatColor(data.textfont, 1, len);
    params.textSize = formatParam(data.textfont.size, len, Lib.identity, 12);
    params.textFontFamily = data.textfont.family;
    params.textFontWeight = data.textfont.weight;
    params.textFontStyle = data.textfont.style;
    params.textFontVariant = data.textfont.variant;
    params.textAngle = 0;
  }
  var dims = ['x', 'y', 'z'];
  params.project = [false, false, false];
  params.projectScale = [1, 1, 1];
  params.projectOpacity = [1, 1, 1];
  for (i = 0; i < 3; ++i) {
    var projection = data.projection[dims[i]];
    if (params.project[i] = projection.show) {
      params.projectOpacity[i] = projection.opacity;
      params.projectScale[i] = projection.scale;
    }
  }
  params.errorBounds = calculateError(data, scaleFactor, sceneLayout);
  var errorParams = calculateErrorParams([data.error_x, data.error_y, data.error_z]);
  params.errorColor = errorParams.color;
  params.errorLineWidth = errorParams.lineWidth;
  params.errorCapSize = errorParams.capSize;
  params.delaunayAxis = data.surfaceaxis;
  params.delaunayColor = str2RgbaArray(data.surfacecolor);
  return params;
}
function _arrayToColor(color) {
  if (Lib.isArrayOrTypedArray(color)) {
    var c = color[0];
    if (Lib.isArrayOrTypedArray(c)) color = c;
    return 'rgb(' + color.slice(0, 3).map(function (x) {
      return Math.round(x * 255);
    }) + ')';
  }
  return null;
}
function arrayToColor(colors) {
  if (!Lib.isArrayOrTypedArray(colors)) {
    return null;
  }
  if (colors.length === 4 && typeof colors[0] === 'number') {
    return _arrayToColor(colors);
  }
  return colors.map(_arrayToColor);
}
proto.update = function (data) {
  var gl = this.scene.glplot.gl;
  var lineOptions;
  var scatterOptions;
  var errorOptions;
  var textOptions;
  var dashPattern = DASH_PATTERNS.solid;

  // Save data
  this.data = data;

  // Run data conversion
  var options = convertPlotlyOptions(this.scene, data);
  if ('mode' in options) {
    this.mode = options.mode;
  }
  if ('lineDashes' in options) {
    if (options.lineDashes in DASH_PATTERNS) {
      dashPattern = DASH_PATTERNS[options.lineDashes];
    }
  }
  this.color = arrayToColor(options.scatterColor) || arrayToColor(options.lineColor);

  // Save data points
  this.dataPoints = options.position;
  lineOptions = {
    gl: this.scene.glplot.gl,
    position: options.position,
    color: options.lineColor,
    lineWidth: options.lineWidth || 1,
    dashes: dashPattern[0],
    dashScale: dashPattern[1],
    opacity: data.opacity,
    connectGaps: data.connectgaps
  };
  if (this.mode.indexOf('lines') !== -1) {
    if (this.linePlot) this.linePlot.update(lineOptions);else {
      this.linePlot = createLinePlot(lineOptions);
      this.linePlot._trace = this;
      this.scene.glplot.add(this.linePlot);
    }
  } else if (this.linePlot) {
    this.scene.glplot.remove(this.linePlot);
    this.linePlot.dispose();
    this.linePlot = null;
  }

  // N.B. marker.opacity must be a scalar for performance
  var scatterOpacity = data.opacity;
  if (data.marker && data.marker.opacity !== undefined) scatterOpacity *= data.marker.opacity;
  scatterOptions = {
    gl: this.scene.glplot.gl,
    position: options.position,
    color: options.scatterColor,
    size: options.scatterSize,
    glyph: options.scatterMarker,
    opacity: scatterOpacity,
    orthographic: true,
    lineWidth: options.scatterLineWidth,
    lineColor: options.scatterLineColor,
    project: options.project,
    projectScale: options.projectScale,
    projectOpacity: options.projectOpacity
  };
  if (this.mode.indexOf('markers') !== -1) {
    if (this.scatterPlot) this.scatterPlot.update(scatterOptions);else {
      this.scatterPlot = createScatterPlot(scatterOptions);
      this.scatterPlot._trace = this;
      this.scatterPlot.highlightScale = 1;
      this.scene.glplot.add(this.scatterPlot);
    }
  } else if (this.scatterPlot) {
    this.scene.glplot.remove(this.scatterPlot);
    this.scatterPlot.dispose();
    this.scatterPlot = null;
  }
  textOptions = {
    gl: this.scene.glplot.gl,
    position: options.position,
    glyph: options.text,
    color: options.textColor,
    size: options.textSize,
    angle: options.textAngle,
    alignment: options.textOffset,
    font: options.textFontFamily,
    fontWeight: options.textFontWeight,
    fontStyle: options.textFontStyle,
    fontVariant: options.textFontVariant,
    orthographic: true,
    lineWidth: 0,
    project: false,
    opacity: data.opacity
  };
  this.textLabels = data.hovertext || data.text;
  if (this.mode.indexOf('text') !== -1) {
    if (this.textMarkers) this.textMarkers.update(textOptions);else {
      this.textMarkers = createScatterPlot(textOptions);
      this.textMarkers._trace = this;
      this.textMarkers.highlightScale = 1;
      this.scene.glplot.add(this.textMarkers);
    }
  } else if (this.textMarkers) {
    this.scene.glplot.remove(this.textMarkers);
    this.textMarkers.dispose();
    this.textMarkers = null;
  }
  errorOptions = {
    gl: this.scene.glplot.gl,
    position: options.position,
    color: options.errorColor,
    error: options.errorBounds,
    lineWidth: options.errorLineWidth,
    capSize: options.errorCapSize,
    opacity: data.opacity
  };
  if (this.errorBars) {
    if (options.errorBounds) {
      this.errorBars.update(errorOptions);
    } else {
      this.scene.glplot.remove(this.errorBars);
      this.errorBars.dispose();
      this.errorBars = null;
    }
  } else if (options.errorBounds) {
    this.errorBars = createErrorBars(errorOptions);
    this.errorBars._trace = this;
    this.scene.glplot.add(this.errorBars);
  }
  if (options.delaunayAxis >= 0) {
    var delaunayOptions = constructDelaunay(options.position, options.delaunayColor, options.delaunayAxis);
    delaunayOptions.opacity = data.opacity;
    if (this.delaunayMesh) {
      this.delaunayMesh.update(delaunayOptions);
    } else {
      delaunayOptions.gl = gl;
      this.delaunayMesh = createMesh(delaunayOptions);
      this.delaunayMesh._trace = this;
      this.scene.glplot.add(this.delaunayMesh);
    }
  } else if (this.delaunayMesh) {
    this.scene.glplot.remove(this.delaunayMesh);
    this.delaunayMesh.dispose();
    this.delaunayMesh = null;
  }
};
proto.dispose = function () {
  if (this.linePlot) {
    this.scene.glplot.remove(this.linePlot);
    this.linePlot.dispose();
  }
  if (this.scatterPlot) {
    this.scene.glplot.remove(this.scatterPlot);
    this.scatterPlot.dispose();
  }
  if (this.errorBars) {
    this.scene.glplot.remove(this.errorBars);
    this.errorBars.dispose();
  }
  if (this.textMarkers) {
    this.scene.glplot.remove(this.textMarkers);
    this.textMarkers.dispose();
  }
  if (this.delaunayMesh) {
    this.scene.glplot.remove(this.delaunayMesh);
    this.delaunayMesh.dispose();
  }
};
function createLineWithMarkers(scene, data) {
  var plot = new LineWithMarkers(scene, data.uid);
  plot.update(data);
  return plot;
}
module.exports = createLineWithMarkers;

/***/ }),

/***/ 82418:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Registry = __webpack_require__(33626);
var Lib = __webpack_require__(34809);
var subTypes = __webpack_require__(64726);
var handleMarkerDefaults = __webpack_require__(24272);
var handleLineDefaults = __webpack_require__(98168);
var handleTextDefaults = __webpack_require__(663);
var attributes = __webpack_require__(14117);
module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
  function coerce(attr, dflt) {
    return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
  }
  var len = handleXYZDefaults(traceIn, traceOut, coerce, layout);
  if (!len) {
    traceOut.visible = false;
    return;
  }
  coerce('text');
  coerce('hovertext');
  coerce('hovertemplate');
  coerce('xhoverformat');
  coerce('yhoverformat');
  coerce('zhoverformat');
  coerce('mode');
  if (subTypes.hasMarkers(traceOut)) {
    handleMarkerDefaults(traceIn, traceOut, defaultColor, layout, coerce, {
      noSelect: true,
      noAngle: true
    });
  }
  if (subTypes.hasLines(traceOut)) {
    coerce('connectgaps');
    handleLineDefaults(traceIn, traceOut, defaultColor, layout, coerce);
  }
  if (subTypes.hasText(traceOut)) {
    coerce('texttemplate');
    handleTextDefaults(traceIn, traceOut, layout, coerce, {
      noSelect: true,
      noFontShadow: true,
      noFontLineposition: true,
      noFontTextcase: true
    });
  }
  var lineColor = (traceOut.line || {}).color;
  var markerColor = (traceOut.marker || {}).color;
  if (coerce('surfaceaxis') >= 0) coerce('surfacecolor', lineColor || markerColor);
  var dims = ['x', 'y', 'z'];
  for (var i = 0; i < 3; ++i) {
    var projection = 'projection.' + dims[i];
    if (coerce(projection + '.show')) {
      coerce(projection + '.opacity');
      coerce(projection + '.scale');
    }
  }
  var errorBarsSupplyDefaults = Registry.getComponentMethod('errorbars', 'supplyDefaults');
  errorBarsSupplyDefaults(traceIn, traceOut, lineColor || markerColor || defaultColor, {
    axis: 'z'
  });
  errorBarsSupplyDefaults(traceIn, traceOut, lineColor || markerColor || defaultColor, {
    axis: 'y',
    inherit: 'z'
  });
  errorBarsSupplyDefaults(traceIn, traceOut, lineColor || markerColor || defaultColor, {
    axis: 'x',
    inherit: 'z'
  });
};
function handleXYZDefaults(traceIn, traceOut, coerce, layout) {
  var len = 0;
  var x = coerce('x');
  var y = coerce('y');
  var z = coerce('z');
  var handleCalendarDefaults = Registry.getComponentMethod('calendars', 'handleTraceDefaults');
  handleCalendarDefaults(traceIn, traceOut, ['x', 'y', 'z'], layout);
  if (x && y && z) {
    // TODO: what happens if one is missing?
    len = Math.min(x.length, y.length, z.length);
    traceOut._length = traceOut._xlength = traceOut._ylength = traceOut._zlength = len;
  }
  return len;
}

/***/ }),

/***/ 17822:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = {
  plot: __webpack_require__(16533),
  attributes: __webpack_require__(14117),
  markerSymbols: __webpack_require__(49467),
  supplyDefaults: __webpack_require__(82418),
  colorbar: [{
    container: 'marker',
    min: 'cmin',
    max: 'cmax'
  }, {
    container: 'line',
    min: 'cmin',
    max: 'cmax'
  }],
  calc: __webpack_require__(37593),
  moduleType: 'trace',
  name: 'scatter3d',
  basePlotModule: __webpack_require__(2487),
  categories: ['gl3d', 'symbols', 'showLegend', 'scatter-like'],
  meta: {}
};

/***/ }),

/***/ 54637:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var makeFillcolorAttr = __webpack_require__(19326);
var scatterAttrs = __webpack_require__(36640);
var baseAttrs = __webpack_require__(9829);
var hovertemplateAttrs = (__webpack_require__(3208)/* .hovertemplateAttrs */ .rb);
var texttemplateAttrs = (__webpack_require__(3208)/* .texttemplateAttrs */ .ay);
var colorScaleAttrs = __webpack_require__(87163);
var extendFlat = (__webpack_require__(93049).extendFlat);
var scatterMarkerAttrs = scatterAttrs.marker;
var scatterLineAttrs = scatterAttrs.line;
var scatterMarkerLineAttrs = scatterMarkerAttrs.line;
module.exports = {
  carpet: {
    valType: 'string',
    editType: 'calc'
  },
  a: {
    valType: 'data_array',
    editType: 'calc'
  },
  b: {
    valType: 'data_array',
    editType: 'calc'
  },
  mode: extendFlat({}, scatterAttrs.mode, {
    dflt: 'markers'
  }),
  text: extendFlat({}, scatterAttrs.text, {}),
  texttemplate: texttemplateAttrs({
    editType: 'plot'
  }, {
    keys: ['a', 'b', 'text']
  }),
  hovertext: extendFlat({}, scatterAttrs.hovertext, {}),
  line: {
    color: scatterLineAttrs.color,
    width: scatterLineAttrs.width,
    dash: scatterLineAttrs.dash,
    backoff: scatterLineAttrs.backoff,
    shape: extendFlat({}, scatterLineAttrs.shape, {
      values: ['linear', 'spline']
    }),
    smoothing: scatterLineAttrs.smoothing,
    editType: 'calc'
  },
  connectgaps: scatterAttrs.connectgaps,
  fill: extendFlat({}, scatterAttrs.fill, {
    values: ['none', 'toself', 'tonext'],
    dflt: 'none'
  }),
  fillcolor: makeFillcolorAttr(),
  marker: extendFlat({
    symbol: scatterMarkerAttrs.symbol,
    opacity: scatterMarkerAttrs.opacity,
    maxdisplayed: scatterMarkerAttrs.maxdisplayed,
    angle: scatterMarkerAttrs.angle,
    angleref: scatterMarkerAttrs.angleref,
    standoff: scatterMarkerAttrs.standoff,
    size: scatterMarkerAttrs.size,
    sizeref: scatterMarkerAttrs.sizeref,
    sizemin: scatterMarkerAttrs.sizemin,
    sizemode: scatterMarkerAttrs.sizemode,
    line: extendFlat({
      width: scatterMarkerLineAttrs.width,
      editType: 'calc'
    }, colorScaleAttrs('marker.line')),
    gradient: scatterMarkerAttrs.gradient,
    editType: 'calc'
  }, colorScaleAttrs('marker')),
  textfont: scatterAttrs.textfont,
  textposition: scatterAttrs.textposition,
  selected: scatterAttrs.selected,
  unselected: scatterAttrs.unselected,
  hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
    flags: ['a', 'b', 'text', 'name']
  }),
  hoveron: scatterAttrs.hoveron,
  hovertemplate: hovertemplateAttrs(),
  zorder: scatterAttrs.zorder
};

/***/ }),

/***/ 68001:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isNumeric = __webpack_require__(10721);
var calcColorscale = __webpack_require__(77272);
var arraysToCalcdata = __webpack_require__(99203);
var calcSelection = __webpack_require__(48861);
var calcMarkerSize = (__webpack_require__(26544).calcMarkerSize);
var lookupCarpet = __webpack_require__(26571);
module.exports = function calc(gd, trace) {
  var carpet = trace._carpetTrace = lookupCarpet(gd, trace);
  if (!carpet || !carpet.visible || carpet.visible === 'legendonly') return;
  var i;

  // Transfer this over from carpet before plotting since this is a necessary
  // condition in order for cartesian to actually plot this trace:
  trace.xaxis = carpet.xaxis;
  trace.yaxis = carpet.yaxis;

  // make the calcdata array
  var serieslen = trace._length;
  var cd = new Array(serieslen);
  var a, b;
  var needsCull = false;
  for (i = 0; i < serieslen; i++) {
    a = trace.a[i];
    b = trace.b[i];
    if (isNumeric(a) && isNumeric(b)) {
      var xy = carpet.ab2xy(+a, +b, true);
      var visible = carpet.isVisible(+a, +b);
      if (!visible) needsCull = true;
      cd[i] = {
        x: xy[0],
        y: xy[1],
        a: a,
        b: b,
        vis: visible
      };
    } else cd[i] = {
      x: false,
      y: false
    };
  }
  trace._needsCull = needsCull;
  cd[0].carpet = carpet;
  cd[0].trace = trace;
  calcMarkerSize(trace, serieslen);
  calcColorscale(gd, trace);
  arraysToCalcdata(cd, trace);
  calcSelection(cd, trace);
  return cd;
};

/***/ }),

/***/ 16986:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var constants = __webpack_require__(32660);
var subTypes = __webpack_require__(64726);
var handleMarkerDefaults = __webpack_require__(24272);
var handleLineDefaults = __webpack_require__(98168);
var handleLineShapeDefaults = __webpack_require__(91602);
var handleTextDefaults = __webpack_require__(663);
var handleFillColorDefaults = __webpack_require__(54114);
var attributes = __webpack_require__(54637);
module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
  function coerce(attr, dflt) {
    return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
  }
  coerce('carpet');

  // XXX: Don't hard code this
  traceOut.xaxis = 'x';
  traceOut.yaxis = 'y';
  var a = coerce('a');
  var b = coerce('b');
  var len = Math.min(a.length, b.length);
  if (!len) {
    traceOut.visible = false;
    return;
  }
  traceOut._length = len;
  coerce('text');
  coerce('texttemplate');
  coerce('hovertext');
  var defaultMode = len < constants.PTS_LINESONLY ? 'lines+markers' : 'lines';
  coerce('mode', defaultMode);
  if (subTypes.hasMarkers(traceOut)) {
    handleMarkerDefaults(traceIn, traceOut, defaultColor, layout, coerce, {
      gradient: true
    });
  }
  if (subTypes.hasLines(traceOut)) {
    handleLineDefaults(traceIn, traceOut, defaultColor, layout, coerce, {
      backoff: true
    });
    handleLineShapeDefaults(traceIn, traceOut, coerce);
    coerce('connectgaps');
  }
  if (subTypes.hasText(traceOut)) {
    handleTextDefaults(traceIn, traceOut, layout, coerce);
  }
  var dfltHoverOn = [];
  if (subTypes.hasMarkers(traceOut) || subTypes.hasText(traceOut)) {
    coerce('marker.maxdisplayed');
    dfltHoverOn.push('points');
  }
  coerce('fill');
  if (traceOut.fill !== 'none') {
    handleFillColorDefaults(traceIn, traceOut, defaultColor, coerce);
    if (!subTypes.hasLines(traceOut)) handleLineShapeDefaults(traceIn, traceOut, coerce);
  }
  if (traceOut.fill === 'tonext' || traceOut.fill === 'toself') {
    dfltHoverOn.push('fills');
  }
  var hoverOn = coerce('hoveron', dfltHoverOn.join('+') || 'points');
  if (hoverOn !== 'fills') coerce('hovertemplate');
  coerce('zorder');
  Lib.coerceSelectionMarkerOpacity(traceOut, coerce);
};

/***/ }),

/***/ 68289:
/***/ (function(module) {

"use strict";


module.exports = function eventData(out, pt, trace, cd, pointNumber) {
  var cdi = cd[pointNumber];
  out.a = cdi.a;
  out.b = cdi.b;
  out.y = cdi.y;
  return out;
};

/***/ }),

/***/ 32709:
/***/ (function(module) {

"use strict";


module.exports = function formatLabels(cdi, trace) {
  var labels = {};
  var carpet = trace._carpet;
  var ij = carpet.ab2ij([cdi.a, cdi.b]);
  var i0 = Math.floor(ij[0]);
  var ti = ij[0] - i0;
  var j0 = Math.floor(ij[1]);
  var tj = ij[1] - j0;
  var xy = carpet.evalxy([], i0, j0, ti, tj);
  labels.yLabel = xy[1].toFixed(3);
  return labels;
};

/***/ }),

/***/ 59420:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var scatterHover = __webpack_require__(37255);
var fillText = (__webpack_require__(34809).fillText);
module.exports = function hoverPoints(pointData, xval, yval, hovermode) {
  var scatterPointData = scatterHover(pointData, xval, yval, hovermode);
  if (!scatterPointData || scatterPointData[0].index === false) return;
  var newPointData = scatterPointData[0];

  // if hovering on a fill, we don't show any point data so the label is
  // unchanged from what scatter gives us - except that it needs to
  // be constrained to the trianglular plot area, not just the rectangular
  // area defined by the synthetic x and y axes
  // TODO: in some cases the vertical middle of the shape is not within
  // the triangular viewport at all, so the label can become disconnected
  // from the shape entirely. But calculating what portion of the shape
  // is actually visible, as constrained by the diagonal axis lines, is not
  // so easy and anyway we lost the information we would have needed to do
  // this inside scatterHover.
  if (newPointData.index === undefined) {
    var yFracUp = 1 - newPointData.y0 / pointData.ya._length;
    var xLen = pointData.xa._length;
    var xMin = xLen * yFracUp / 2;
    var xMax = xLen - xMin;
    newPointData.x0 = Math.max(Math.min(newPointData.x0, xMax), xMin);
    newPointData.x1 = Math.max(Math.min(newPointData.x1, xMax), xMin);
    return scatterPointData;
  }
  var cdi = newPointData.cd[newPointData.index];
  newPointData.a = cdi.a;
  newPointData.b = cdi.b;
  newPointData.xLabelVal = undefined;
  newPointData.yLabelVal = undefined;
  // TODO: nice formatting, and label by axis title, for a, b, and c?

  var trace = newPointData.trace;
  var carpet = trace._carpet;
  var labels = trace._module.formatLabels(cdi, trace);
  newPointData.yLabel = labels.yLabel;
  delete newPointData.text;
  var text = [];
  function textPart(ax, val) {
    var prefix;
    if (ax.labelprefix && ax.labelprefix.length > 0) {
      prefix = ax.labelprefix.replace(/ = $/, '');
    } else {
      prefix = ax._hovertitle;
    }
    text.push(prefix + ': ' + val.toFixed(3) + ax.labelsuffix);
  }
  if (!trace.hovertemplate) {
    var hoverinfo = cdi.hi || trace.hoverinfo;
    var parts = hoverinfo.split('+');
    if (parts.indexOf('all') !== -1) parts = ['a', 'b', 'text'];
    if (parts.indexOf('a') !== -1) textPart(carpet.aaxis, cdi.a);
    if (parts.indexOf('b') !== -1) textPart(carpet.baxis, cdi.b);
    text.push('y: ' + newPointData.yLabel);
    if (parts.indexOf('text') !== -1) {
      fillText(cdi, trace, text);
    }
    newPointData.extraText = text.join('<br>');
  }
  return scatterPointData;
};

/***/ }),

/***/ 56534:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = {
  attributes: __webpack_require__(54637),
  supplyDefaults: __webpack_require__(16986),
  colorbar: __webpack_require__(21146),
  formatLabels: __webpack_require__(32709),
  calc: __webpack_require__(68001),
  plot: __webpack_require__(64535),
  style: (__webpack_require__(9408).style),
  styleOnSelect: (__webpack_require__(9408).styleOnSelect),
  hoverPoints: __webpack_require__(59420),
  selectPoints: __webpack_require__(32665),
  eventData: __webpack_require__(68289),
  moduleType: 'trace',
  name: 'scattercarpet',
  basePlotModule: __webpack_require__(37703),
  categories: ['svg', 'carpet', 'symbols', 'showLegend', 'carpetDependent', 'zoomScale'],
  meta: {}
};

/***/ }),

/***/ 64535:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var scatterPlot = __webpack_require__(36098);
var Axes = __webpack_require__(29714);
var Drawing = __webpack_require__(62203);
module.exports = function plot(gd, plotinfoproxy, data, layer) {
  var i, trace, node;
  var carpet = data[0][0].carpet;
  var xaxis = Axes.getFromId(gd, carpet.xaxis || 'x');
  var yaxis = Axes.getFromId(gd, carpet.yaxis || 'y');

  // mimic cartesian plotinfo
  var plotinfo = {
    xaxis: xaxis,
    yaxis: yaxis,
    plot: plotinfoproxy.plot
  };
  for (i = 0; i < data.length; i++) {
    trace = data[i][0].trace;
    trace._xA = xaxis;
    trace._yA = yaxis;
  }
  scatterPlot(gd, plotinfo, data, layer);
  for (i = 0; i < data.length; i++) {
    trace = data[i][0].trace;

    // Note: .select is adequate but seems to mutate the node data,
    // which is at least a bit surprising and causes problems elsewhere
    node = layer.selectAll('g.trace' + trace.uid + ' .js-line');

    // Note: it would be more efficient if this didn't need to be applied
    // separately to all scattercarpet traces, but that would require
    // lots of reorganization of scatter traces that is otherwise not
    // necessary. That makes this a potential optimization.
    Drawing.setClipUrl(node, data[i][0].carpet._clipPathId, gd);
  }
};

/***/ }),

/***/ 6893:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var hovertemplateAttrs = (__webpack_require__(3208)/* .hovertemplateAttrs */ .rb);
var texttemplateAttrs = (__webpack_require__(3208)/* .texttemplateAttrs */ .ay);
var makeFillcolorAttr = __webpack_require__(19326);
var scatterAttrs = __webpack_require__(36640);
var baseAttrs = __webpack_require__(9829);
var colorAttributes = __webpack_require__(87163);
var dash = (__webpack_require__(94850)/* .dash */ .T);
var extendFlat = (__webpack_require__(93049).extendFlat);
var overrideAll = (__webpack_require__(13582).overrideAll);
var scatterMarkerAttrs = scatterAttrs.marker;
var scatterLineAttrs = scatterAttrs.line;
var scatterMarkerLineAttrs = scatterMarkerAttrs.line;
module.exports = overrideAll({
  lon: {
    valType: 'data_array'
  },
  lat: {
    valType: 'data_array'
  },
  locations: {
    valType: 'data_array'
  },
  locationmode: {
    valType: 'enumerated',
    values: ['ISO-3', 'USA-states', 'country names', 'geojson-id'],
    dflt: 'ISO-3'
  },
  geojson: {
    valType: 'any',
    editType: 'calc'
  },
  featureidkey: {
    valType: 'string',
    editType: 'calc',
    dflt: 'id'
  },
  mode: extendFlat({}, scatterAttrs.mode, {
    dflt: 'markers'
  }),
  text: extendFlat({}, scatterAttrs.text, {}),
  texttemplate: texttemplateAttrs({
    editType: 'plot'
  }, {
    keys: ['lat', 'lon', 'location', 'text']
  }),
  hovertext: extendFlat({}, scatterAttrs.hovertext, {}),
  textfont: scatterAttrs.textfont,
  textposition: scatterAttrs.textposition,
  line: {
    color: scatterLineAttrs.color,
    width: scatterLineAttrs.width,
    dash: dash
  },
  connectgaps: scatterAttrs.connectgaps,
  marker: extendFlat({
    symbol: scatterMarkerAttrs.symbol,
    opacity: scatterMarkerAttrs.opacity,
    angle: scatterMarkerAttrs.angle,
    angleref: extendFlat({}, scatterMarkerAttrs.angleref, {
      values: ['previous', 'up', 'north']
    }),
    standoff: scatterMarkerAttrs.standoff,
    size: scatterMarkerAttrs.size,
    sizeref: scatterMarkerAttrs.sizeref,
    sizemin: scatterMarkerAttrs.sizemin,
    sizemode: scatterMarkerAttrs.sizemode,
    colorbar: scatterMarkerAttrs.colorbar,
    line: extendFlat({
      width: scatterMarkerLineAttrs.width
    }, colorAttributes('marker.line')),
    gradient: scatterMarkerAttrs.gradient
  }, colorAttributes('marker')),
  fill: {
    valType: 'enumerated',
    values: ['none', 'toself'],
    dflt: 'none'
  },
  fillcolor: makeFillcolorAttr(),
  selected: scatterAttrs.selected,
  unselected: scatterAttrs.unselected,
  hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
    flags: ['lon', 'lat', 'location', 'text', 'name']
  }),
  hovertemplate: hovertemplateAttrs()
}, 'calc', 'nested');

/***/ }),

/***/ 75649:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isNumeric = __webpack_require__(10721);
var BADNUM = (__webpack_require__(63821).BADNUM);
var calcMarkerColorscale = __webpack_require__(77272);
var arraysToCalcdata = __webpack_require__(99203);
var calcSelection = __webpack_require__(48861);
var isArrayOrTypedArray = (__webpack_require__(34809).isArrayOrTypedArray);
var _ = (__webpack_require__(34809)._);
function isNonBlankString(v) {
  return v && typeof v === 'string';
}
module.exports = function calc(gd, trace) {
  var hasLocationData = isArrayOrTypedArray(trace.locations);
  var len = hasLocationData ? trace.locations.length : trace._length;
  var calcTrace = new Array(len);
  var isValidLoc;
  if (trace.geojson) {
    isValidLoc = function (v) {
      return isNonBlankString(v) || isNumeric(v);
    };
  } else {
    isValidLoc = isNonBlankString;
  }
  for (var i = 0; i < len; i++) {
    var calcPt = calcTrace[i] = {};
    if (hasLocationData) {
      var loc = trace.locations[i];
      calcPt.loc = isValidLoc(loc) ? loc : null;
    } else {
      var lon = trace.lon[i];
      var lat = trace.lat[i];
      if (isNumeric(lon) && isNumeric(lat)) calcPt.lonlat = [+lon, +lat];else calcPt.lonlat = [BADNUM, BADNUM];
    }
  }
  arraysToCalcdata(calcTrace, trace);
  calcMarkerColorscale(gd, trace);
  calcSelection(calcTrace, trace);
  if (len) {
    calcTrace[0].t = {
      labels: {
        lat: _(gd, 'lat:') + ' ',
        lon: _(gd, 'lon:') + ' '
      }
    };
  }
  return calcTrace;
};

/***/ }),

/***/ 27386:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var subTypes = __webpack_require__(64726);
var handleMarkerDefaults = __webpack_require__(24272);
var handleLineDefaults = __webpack_require__(98168);
var handleTextDefaults = __webpack_require__(663);
var handleFillColorDefaults = __webpack_require__(54114);
var attributes = __webpack_require__(6893);
module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
  function coerce(attr, dflt) {
    return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
  }
  var locations = coerce('locations');
  var len;
  if (locations && locations.length) {
    var geojson = coerce('geojson');
    var locationmodeDflt;
    if (typeof geojson === 'string' && geojson !== '' || Lib.isPlainObject(geojson)) {
      locationmodeDflt = 'geojson-id';
    }
    var locationMode = coerce('locationmode', locationmodeDflt);
    if (locationMode === 'geojson-id') {
      coerce('featureidkey');
    }
    len = locations.length;
  } else {
    var lon = coerce('lon') || [];
    var lat = coerce('lat') || [];
    len = Math.min(lon.length, lat.length);
  }
  if (!len) {
    traceOut.visible = false;
    return;
  }
  traceOut._length = len;
  coerce('text');
  coerce('hovertext');
  coerce('hovertemplate');
  coerce('mode');
  if (subTypes.hasMarkers(traceOut)) {
    handleMarkerDefaults(traceIn, traceOut, defaultColor, layout, coerce, {
      gradient: true
    });
  }
  if (subTypes.hasLines(traceOut)) {
    handleLineDefaults(traceIn, traceOut, defaultColor, layout, coerce);
    coerce('connectgaps');
  }
  if (subTypes.hasText(traceOut)) {
    coerce('texttemplate');
    handleTextDefaults(traceIn, traceOut, layout, coerce);
  }
  coerce('fill');
  if (traceOut.fill !== 'none') {
    handleFillColorDefaults(traceIn, traceOut, defaultColor, coerce);
  }
  Lib.coerceSelectionMarkerOpacity(traceOut, coerce);
};

/***/ }),

/***/ 71873:
/***/ (function(module) {

"use strict";


module.exports = function eventData(out, pt, trace, cd, pointNumber) {
  out.lon = pt.lon;
  out.lat = pt.lat;
  out.location = pt.loc ? pt.loc : null;

  // include feature properties from input geojson
  var cdi = cd[pointNumber];
  if (cdi.fIn && cdi.fIn.properties) {
    out.properties = cdi.fIn.properties;
  }
  return out;
};

/***/ }),

/***/ 57413:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Axes = __webpack_require__(29714);
module.exports = function formatLabels(cdi, trace, fullLayout) {
  var labels = {};
  var geo = fullLayout[trace.geo]._subplot;
  var ax = geo.mockAxis;
  var lonlat = cdi.lonlat;
  labels.lonLabel = Axes.tickText(ax, ax.c2l(lonlat[0]), true).text;
  labels.latLabel = Axes.tickText(ax, ax.c2l(lonlat[1]), true).text;
  return labels;
};

/***/ }),

/***/ 40636:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Fx = __webpack_require__(32141);
var BADNUM = (__webpack_require__(63821).BADNUM);
var getTraceColor = __webpack_require__(11539);
var fillText = (__webpack_require__(34809).fillText);
var attributes = __webpack_require__(6893);
module.exports = function hoverPoints(pointData, xval, yval) {
  var cd = pointData.cd;
  var trace = cd[0].trace;
  var xa = pointData.xa;
  var ya = pointData.ya;
  var geo = pointData.subplot;
  var isLonLatOverEdges = geo.projection.isLonLatOverEdges;
  var project = geo.project;
  function distFn(d) {
    var lonlat = d.lonlat;
    if (lonlat[0] === BADNUM) return Infinity;
    if (isLonLatOverEdges(lonlat)) return Infinity;
    var pt = project(lonlat);
    var px = project([xval, yval]);
    var dx = Math.abs(pt[0] - px[0]);
    var dy = Math.abs(pt[1] - px[1]);
    var rad = Math.max(3, d.mrc || 0);

    // N.B. d.mrc is the calculated marker radius
    // which is only set for trace with 'markers' mode.

    return Math.max(Math.sqrt(dx * dx + dy * dy) - rad, 1 - 3 / rad);
  }
  Fx.getClosest(cd, distFn, pointData);

  // skip the rest (for this trace) if we didn't find a close point
  if (pointData.index === false) return;
  var di = cd[pointData.index];
  var lonlat = di.lonlat;
  var pos = [xa.c2p(lonlat), ya.c2p(lonlat)];
  var rad = di.mrc || 1;
  pointData.x0 = pos[0] - rad;
  pointData.x1 = pos[0] + rad;
  pointData.y0 = pos[1] - rad;
  pointData.y1 = pos[1] + rad;
  pointData.loc = di.loc;
  pointData.lon = lonlat[0];
  pointData.lat = lonlat[1];
  var fullLayout = {};
  fullLayout[trace.geo] = {
    _subplot: geo
  };
  var labels = trace._module.formatLabels(di, trace, fullLayout);
  pointData.lonLabel = labels.lonLabel;
  pointData.latLabel = labels.latLabel;
  pointData.color = getTraceColor(trace, di);
  pointData.extraText = getExtraText(trace, di, pointData, cd[0].t.labels);
  pointData.hovertemplate = trace.hovertemplate;
  return [pointData];
};
function getExtraText(trace, pt, pointData, labels) {
  if (trace.hovertemplate) return;
  var hoverinfo = pt.hi || trace.hoverinfo;
  var parts = hoverinfo === 'all' ? attributes.hoverinfo.flags : hoverinfo.split('+');
  var hasLocation = parts.indexOf('location') !== -1 && Array.isArray(trace.locations);
  var hasLon = parts.indexOf('lon') !== -1;
  var hasLat = parts.indexOf('lat') !== -1;
  var hasText = parts.indexOf('text') !== -1;
  var text = [];
  function format(val) {
    return val + '\u00B0';
  }
  if (hasLocation) {
    text.push(pt.loc);
  } else if (hasLon && hasLat) {
    text.push('(' + format(pointData.latLabel) + ', ' + format(pointData.lonLabel) + ')');
  } else if (hasLon) {
    text.push(labels.lon + format(pointData.lonLabel));
  } else if (hasLat) {
    text.push(labels.lat + format(pointData.latLabel));
  }
  if (hasText) {
    fillText(pt, trace, text);
  }
  return text.join('<br>');
}

/***/ }),

/***/ 18070:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = {
  attributes: __webpack_require__(6893),
  supplyDefaults: __webpack_require__(27386),
  colorbar: __webpack_require__(21146),
  formatLabels: __webpack_require__(57413),
  calc: __webpack_require__(75649),
  calcGeoJSON: (__webpack_require__(48887).calcGeoJSON),
  plot: (__webpack_require__(48887).plot),
  style: __webpack_require__(60367),
  styleOnSelect: (__webpack_require__(9408).styleOnSelect),
  hoverPoints: __webpack_require__(40636),
  eventData: __webpack_require__(71873),
  selectPoints: __webpack_require__(45852),
  moduleType: 'trace',
  name: 'scattergeo',
  basePlotModule: __webpack_require__(47544),
  categories: ['geo', 'symbols', 'showLegend', 'scatter-like'],
  meta: {}
};

/***/ }),

/***/ 48887:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var Lib = __webpack_require__(34809);
var getTopojsonFeatures = (__webpack_require__(11577).getTopojsonFeatures);
var geoJsonUtils = __webpack_require__(39532);
var geoUtils = __webpack_require__(3994);
var findExtremes = (__webpack_require__(32919).findExtremes);
var BADNUM = (__webpack_require__(63821).BADNUM);
var calcMarkerSize = (__webpack_require__(26544).calcMarkerSize);
var subTypes = __webpack_require__(64726);
var style = __webpack_require__(60367);
function plot(gd, geo, calcData) {
  var scatterLayer = geo.layers.frontplot.select('.scatterlayer');
  var gTraces = Lib.makeTraceGroups(scatterLayer, calcData, 'trace scattergeo');
  function removeBADNUM(d, node) {
    if (d.lonlat[0] === BADNUM) {
      d3.select(node).remove();
    }
  }

  // TODO find a way to order the inner nodes on update
  gTraces.selectAll('*').remove();
  gTraces.each(function (calcTrace) {
    var s = d3.select(this);
    var trace = calcTrace[0].trace;
    if (subTypes.hasLines(trace) || trace.fill !== 'none') {
      var lineCoords = geoJsonUtils.calcTraceToLineCoords(calcTrace);
      var lineData = trace.fill !== 'none' ? geoJsonUtils.makePolygon(lineCoords) : geoJsonUtils.makeLine(lineCoords);
      s.selectAll('path.js-line').data([{
        geojson: lineData,
        trace: trace
      }]).enter().append('path').classed('js-line', true).style('stroke-miterlimit', 2);
    }
    if (subTypes.hasMarkers(trace)) {
      s.selectAll('path.point').data(Lib.identity).enter().append('path').classed('point', true).each(function (calcPt) {
        removeBADNUM(calcPt, this);
      });
    }
    if (subTypes.hasText(trace)) {
      s.selectAll('g').data(Lib.identity).enter().append('g').append('text').each(function (calcPt) {
        removeBADNUM(calcPt, this);
      });
    }

    // call style here within topojson request callback
    style(gd, calcTrace);
  });
}
function calcGeoJSON(calcTrace, fullLayout) {
  var trace = calcTrace[0].trace;
  var geoLayout = fullLayout[trace.geo];
  var geo = geoLayout._subplot;
  var len = trace._length;
  var i, calcPt;
  if (Lib.isArrayOrTypedArray(trace.locations)) {
    var locationmode = trace.locationmode;
    var features = locationmode === 'geojson-id' ? geoUtils.extractTraceFeature(calcTrace) : getTopojsonFeatures(trace, geo.topojson);
    for (i = 0; i < len; i++) {
      calcPt = calcTrace[i];
      var feature = locationmode === 'geojson-id' ? calcPt.fOut : geoUtils.locationToFeature(locationmode, calcPt.loc, features);
      calcPt.lonlat = feature ? feature.properties.ct : [BADNUM, BADNUM];
    }
  }
  var opts = {
    padded: true
  };
  var lonArray;
  var latArray;
  if (geoLayout.fitbounds === 'geojson' && trace.locationmode === 'geojson-id') {
    var bboxGeojson = geoUtils.computeBbox(geoUtils.getTraceGeojson(trace));
    lonArray = [bboxGeojson[0], bboxGeojson[2]];
    latArray = [bboxGeojson[1], bboxGeojson[3]];
  } else {
    lonArray = new Array(len);
    latArray = new Array(len);
    for (i = 0; i < len; i++) {
      calcPt = calcTrace[i];
      lonArray[i] = calcPt.lonlat[0];
      latArray[i] = calcPt.lonlat[1];
    }
    opts.ppad = calcMarkerSize(trace, len);
  }
  trace._extremes.lon = findExtremes(geoLayout.lonaxis._ax, lonArray, opts);
  trace._extremes.lat = findExtremes(geoLayout.lataxis._ax, latArray, opts);
}
module.exports = {
  calcGeoJSON: calcGeoJSON,
  plot: plot
};

/***/ }),

/***/ 45852:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var subtypes = __webpack_require__(64726);
var BADNUM = (__webpack_require__(63821).BADNUM);
module.exports = function selectPoints(searchInfo, selectionTester) {
  var cd = searchInfo.cd;
  var xa = searchInfo.xaxis;
  var ya = searchInfo.yaxis;
  var selection = [];
  var trace = cd[0].trace;
  var di, lonlat, x, y, i;
  var hasOnlyLines = !subtypes.hasMarkers(trace) && !subtypes.hasText(trace);
  if (hasOnlyLines) return [];
  if (selectionTester === false) {
    for (i = 0; i < cd.length; i++) {
      cd[i].selected = 0;
    }
  } else {
    for (i = 0; i < cd.length; i++) {
      di = cd[i];
      lonlat = di.lonlat;

      // some projection types can't handle BADNUMs
      if (lonlat[0] === BADNUM) continue;
      x = xa.c2p(lonlat);
      y = ya.c2p(lonlat);
      if (selectionTester.contains([x, y], null, i, searchInfo)) {
        selection.push({
          pointNumber: i,
          lon: lonlat[0],
          lat: lonlat[1]
        });
        di.selected = 1;
      } else {
        di.selected = 0;
      }
    }
  }
  return selection;
};

/***/ }),

/***/ 60367:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var Drawing = __webpack_require__(62203);
var Color = __webpack_require__(78766);
var scatterStyle = __webpack_require__(9408);
var stylePoints = scatterStyle.stylePoints;
var styleText = scatterStyle.styleText;
module.exports = function style(gd, calcTrace) {
  if (calcTrace) styleTrace(gd, calcTrace);
};
function styleTrace(gd, calcTrace) {
  var trace = calcTrace[0].trace;
  var s = calcTrace[0].node3;
  s.style('opacity', calcTrace[0].trace.opacity);
  stylePoints(s, trace, gd);
  styleText(s, trace, gd);

  // this part is incompatible with Drawing.lineGroupStyle
  s.selectAll('path.js-line').style('fill', 'none').each(function (d) {
    var path = d3.select(this);
    var trace = d.trace;
    var line = trace.line || {};
    path.call(Color.stroke, line.color).call(Drawing.dashLine, line.dash || '', line.width || 0);
    if (trace.fill !== 'none') {
      path.call(Color.fill, trace.fillcolor);
    }
  });
}

/***/ }),

/***/ 92089:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var baseAttrs = __webpack_require__(9829);
var fontAttrs = __webpack_require__(80337);
var makeFillcolorAttr = __webpack_require__(19326);
var scatterAttrs = __webpack_require__(36640);
var axisHoverFormat = (__webpack_require__(80712).axisHoverFormat);
var colorScaleAttrs = __webpack_require__(87163);
var sortObjectKeys = __webpack_require__(62994);
var extendFlat = (__webpack_require__(93049).extendFlat);
var overrideAll = (__webpack_require__(13582).overrideAll);
var DASHES = (__webpack_require__(29483).DASHES);
var scatterLineAttrs = scatterAttrs.line;
var scatterMarkerAttrs = scatterAttrs.marker;
var scatterMarkerLineAttrs = scatterMarkerAttrs.line;
var attrs = module.exports = overrideAll({
  x: scatterAttrs.x,
  x0: scatterAttrs.x0,
  dx: scatterAttrs.dx,
  y: scatterAttrs.y,
  y0: scatterAttrs.y0,
  dy: scatterAttrs.dy,
  xperiod: scatterAttrs.xperiod,
  yperiod: scatterAttrs.yperiod,
  xperiod0: scatterAttrs.xperiod0,
  yperiod0: scatterAttrs.yperiod0,
  xperiodalignment: scatterAttrs.xperiodalignment,
  yperiodalignment: scatterAttrs.yperiodalignment,
  xhoverformat: axisHoverFormat('x'),
  yhoverformat: axisHoverFormat('y'),
  text: scatterAttrs.text,
  hovertext: scatterAttrs.hovertext,
  textposition: scatterAttrs.textposition,
  textfont: fontAttrs({
    noFontShadow: true,
    noFontLineposition: true,
    noFontTextcase: true,
    editType: 'calc',
    colorEditType: 'style',
    arrayOk: true,
    noNumericWeightValues: true,
    variantValues: ['normal', 'small-caps']
  }),
  mode: {
    valType: 'flaglist',
    flags: ['lines', 'markers', 'text'],
    extras: ['none']
  },
  line: {
    color: scatterLineAttrs.color,
    width: scatterLineAttrs.width,
    shape: {
      valType: 'enumerated',
      values: ['linear', 'hv', 'vh', 'hvh', 'vhv'],
      dflt: 'linear',
      editType: 'plot'
    },
    dash: {
      valType: 'enumerated',
      values: sortObjectKeys(DASHES),
      dflt: 'solid'
    }
  },
  marker: extendFlat({}, colorScaleAttrs('marker'), {
    symbol: scatterMarkerAttrs.symbol,
    angle: scatterMarkerAttrs.angle,
    size: scatterMarkerAttrs.size,
    sizeref: scatterMarkerAttrs.sizeref,
    sizemin: scatterMarkerAttrs.sizemin,
    sizemode: scatterMarkerAttrs.sizemode,
    opacity: scatterMarkerAttrs.opacity,
    colorbar: scatterMarkerAttrs.colorbar,
    line: extendFlat({}, colorScaleAttrs('marker.line'), {
      width: scatterMarkerLineAttrs.width
    })
  }),
  connectgaps: scatterAttrs.connectgaps,
  fill: extendFlat({}, scatterAttrs.fill, {
    dflt: 'none'
  }),
  fillcolor: makeFillcolorAttr(),
  // no hoveron

  selected: {
    marker: scatterAttrs.selected.marker,
    textfont: scatterAttrs.selected.textfont
  },
  unselected: {
    marker: scatterAttrs.unselected.marker,
    textfont: scatterAttrs.unselected.textfont
  },
  opacity: baseAttrs.opacity
}, 'calc', 'nested');
attrs.x.editType = attrs.y.editType = attrs.x0.editType = attrs.y0.editType = 'calc+clearAxisTypes';
attrs.hovertemplate = scatterAttrs.hovertemplate;
attrs.texttemplate = scatterAttrs.texttemplate;

/***/ }),

/***/ 68258:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var hover = __webpack_require__(36544);
module.exports = {
  moduleType: 'trace',
  name: 'scattergl',
  basePlotModule: __webpack_require__(37703),
  categories: ['gl', 'regl', 'cartesian', 'symbols', 'errorBarsOK', 'showLegend', 'scatter-like'],
  attributes: __webpack_require__(92089),
  supplyDefaults: __webpack_require__(86590),
  crossTraceDefaults: __webpack_require__(53044),
  colorbar: __webpack_require__(21146),
  formatLabels: __webpack_require__(99185),
  calc: __webpack_require__(15293),
  hoverPoints: hover.hoverPoints,
  selectPoints: __webpack_require__(17168),
  meta: {}
};

/***/ }),

/***/ 15293:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var cluster = __webpack_require__(27549);
var Lib = __webpack_require__(34809);
var AxisIDs = __webpack_require__(5975);
var findExtremes = (__webpack_require__(32919).findExtremes);
var alignPeriod = __webpack_require__(40528);
var scatterCalc = __webpack_require__(26544);
var calcMarkerSize = scatterCalc.calcMarkerSize;
var calcAxisExpansion = scatterCalc.calcAxisExpansion;
var setFirstScatter = scatterCalc.setFirstScatter;
var calcColorscale = __webpack_require__(77272);
var convert = __webpack_require__(19937);
var sceneUpdate = __webpack_require__(62336);
var BADNUM = (__webpack_require__(63821).BADNUM);
var TOO_MANY_POINTS = (__webpack_require__(29483).TOO_MANY_POINTS);
module.exports = function calc(gd, trace) {
  var fullLayout = gd._fullLayout;
  var xa = trace._xA = AxisIDs.getFromId(gd, trace.xaxis, 'x');
  var ya = trace._yA = AxisIDs.getFromId(gd, trace.yaxis, 'y');
  var subplot = fullLayout._plots[trace.xaxis + trace.yaxis];
  var len = trace._length;
  var hasTooManyPoints = len >= TOO_MANY_POINTS;
  var len2 = len * 2;
  var stash = {};
  var i;
  var origX = xa.makeCalcdata(trace, 'x');
  var origY = ya.makeCalcdata(trace, 'y');
  var xObj = alignPeriod(trace, xa, 'x', origX);
  var yObj = alignPeriod(trace, ya, 'y', origY);
  var x = xObj.vals;
  var y = yObj.vals;
  trace._x = x;
  trace._y = y;
  if (trace.xperiodalignment) {
    trace._origX = origX;
    trace._xStarts = xObj.starts;
    trace._xEnds = xObj.ends;
  }
  if (trace.yperiodalignment) {
    trace._origY = origY;
    trace._yStarts = yObj.starts;
    trace._yEnds = yObj.ends;
  }

  // we need hi-precision for scatter2d,
  // regl-scatter2d uses NaNs for bad/missing values
  var positions = new Array(len2);
  var _ids = new Array(len);
  for (i = 0; i < len; i++) {
    positions[i * 2] = x[i] === BADNUM ? NaN : x[i];
    positions[i * 2 + 1] = y[i] === BADNUM ? NaN : y[i];
    // Pre-compute ids.
    _ids[i] = i;
  }
  if (xa.type === 'log') {
    for (i = 0; i < len2; i += 2) {
      positions[i] = xa.c2l(positions[i]);
    }
  }
  if (ya.type === 'log') {
    for (i = 1; i < len2; i += 2) {
      positions[i] = ya.c2l(positions[i]);
    }
  }

  // we don't build a tree for log axes since it takes long to convert log2px
  // and it is also
  if (hasTooManyPoints && xa.type !== 'log' && ya.type !== 'log') {
    // FIXME: delegate this to webworker
    stash.tree = cluster(positions);
  } else {
    stash.ids = _ids;
  }

  // create scene options and scene
  calcColorscale(gd, trace);
  var opts = sceneOptions(gd, subplot, trace, positions, x, y);
  var scene = sceneUpdate(gd, subplot);

  // Reuse SVG scatter axis expansion routine.
  // For graphs with very large number of points and array marker.size,
  // use average marker size instead to speed things up.
  setFirstScatter(fullLayout, trace);
  var ppad;
  if (!hasTooManyPoints) {
    ppad = calcMarkerSize(trace, len);
  } else if (opts.marker) {
    ppad = opts.marker.sizeAvg || Math.max(opts.marker.size, 3);
  }
  calcAxisExpansion(gd, trace, xa, ya, x, y, ppad);
  if (opts.errorX) expandForErrorBars(trace, xa, opts.errorX);
  if (opts.errorY) expandForErrorBars(trace, ya, opts.errorY);

  // set flags to create scene renderers
  if (opts.fill && !scene.fill2d) scene.fill2d = true;
  if (opts.marker && !scene.scatter2d) scene.scatter2d = true;
  if (opts.line && !scene.line2d) scene.line2d = true;
  if ((opts.errorX || opts.errorY) && !scene.error2d) scene.error2d = true;
  if (opts.text && !scene.glText) scene.glText = true;
  if (opts.marker) opts.marker.snap = len;
  scene.lineOptions.push(opts.line);
  scene.errorXOptions.push(opts.errorX);
  scene.errorYOptions.push(opts.errorY);
  scene.fillOptions.push(opts.fill);
  scene.markerOptions.push(opts.marker);
  scene.markerSelectedOptions.push(opts.markerSel);
  scene.markerUnselectedOptions.push(opts.markerUnsel);
  scene.textOptions.push(opts.text);
  scene.textSelectedOptions.push(opts.textSel);
  scene.textUnselectedOptions.push(opts.textUnsel);
  scene.selectBatch.push([]);
  scene.unselectBatch.push([]);
  stash._scene = scene;
  stash.index = scene.count;
  stash.x = x;
  stash.y = y;
  stash.positions = positions;
  scene.count++;
  return [{
    x: false,
    y: false,
    t: stash,
    trace: trace
  }];
};
function expandForErrorBars(trace, ax, opts) {
  var extremes = trace._extremes[ax._id];
  var errExt = findExtremes(ax, opts._bnds, {
    padded: true
  });
  extremes.min = extremes.min.concat(errExt.min);
  extremes.max = extremes.max.concat(errExt.max);
}
function sceneOptions(gd, subplot, trace, positions, x, y) {
  var opts = convert.style(gd, trace);
  if (opts.marker) {
    opts.marker.positions = positions;
  }
  if (opts.line && positions.length > 1) {
    Lib.extendFlat(opts.line, convert.linePositions(gd, trace, positions));
  }
  if (opts.errorX || opts.errorY) {
    var errors = convert.errorBarPositions(gd, trace, positions, x, y);
    if (opts.errorX) {
      Lib.extendFlat(opts.errorX, errors.x);
    }
    if (opts.errorY) {
      Lib.extendFlat(opts.errorY, errors.y);
    }
  }
  if (opts.text) {
    Lib.extendFlat(opts.text, {
      positions: positions
    }, convert.textPosition(gd, trace, opts.text, opts.marker));
    Lib.extendFlat(opts.textSel, {
      positions: positions
    }, convert.textPosition(gd, trace, opts.text, opts.markerSel));
    Lib.extendFlat(opts.textUnsel, {
      positions: positions
    }, convert.textPosition(gd, trace, opts.text, opts.markerUnsel));
  }
  return opts;
}

/***/ }),

/***/ 29483:
/***/ (function(module) {

"use strict";


var SYMBOL_SIZE = 20;
module.exports = {
  TOO_MANY_POINTS: 1e5,
  SYMBOL_SDF_SIZE: 200,
  SYMBOL_SIZE: SYMBOL_SIZE,
  SYMBOL_STROKE: SYMBOL_SIZE / 20,
  DOT_RE: /-dot/,
  OPEN_RE: /-open/,
  DASHES: {
    solid: [1],
    dot: [1, 1],
    dash: [4, 1],
    longdash: [8, 1],
    dashdot: [4, 1, 1, 1],
    longdashdot: [8, 1, 1, 1]
  }
};

/***/ }),

/***/ 19937:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isNumeric = __webpack_require__(10721);
var svgSdf = __webpack_require__(96021);
var rgba = __webpack_require__(162);
var Registry = __webpack_require__(33626);
var Lib = __webpack_require__(34809);
var isArrayOrTypedArray = Lib.isArrayOrTypedArray;
var Drawing = __webpack_require__(62203);
var AxisIDs = __webpack_require__(5975);
var formatColor = (__webpack_require__(46998).formatColor);
var subTypes = __webpack_require__(64726);
var makeBubbleSizeFn = __webpack_require__(92527);
var helpers = __webpack_require__(4075);
var constants = __webpack_require__(29483);
var DESELECTDIM = (__webpack_require__(20438).DESELECTDIM);
var TEXTOFFSETSIGN = {
  start: 1,
  left: 1,
  end: -1,
  right: -1,
  middle: 0,
  center: 0,
  bottom: 1,
  top: -1
};
var appendArrayPointValue = (__webpack_require__(36040).appendArrayPointValue);
function convertStyle(gd, trace) {
  var i;
  var opts = {
    marker: undefined,
    markerSel: undefined,
    markerUnsel: undefined,
    line: undefined,
    fill: undefined,
    errorX: undefined,
    errorY: undefined,
    text: undefined,
    textSel: undefined,
    textUnsel: undefined
  };
  var plotGlPixelRatio = gd._context.plotGlPixelRatio;
  if (trace.visible !== true) return opts;
  if (subTypes.hasText(trace)) {
    opts.text = convertTextStyle(gd, trace);
    opts.textSel = convertTextSelection(gd, trace, trace.selected);
    opts.textUnsel = convertTextSelection(gd, trace, trace.unselected);
  }
  if (subTypes.hasMarkers(trace)) {
    opts.marker = convertMarkerStyle(gd, trace);
    opts.markerSel = convertMarkerSelection(gd, trace, trace.selected);
    opts.markerUnsel = convertMarkerSelection(gd, trace, trace.unselected);
    if (!trace.unselected && isArrayOrTypedArray(trace.marker.opacity)) {
      var mo = trace.marker.opacity;
      opts.markerUnsel.opacity = new Array(mo.length);
      for (i = 0; i < mo.length; i++) {
        opts.markerUnsel.opacity[i] = DESELECTDIM * mo[i];
      }
    }
  }
  if (subTypes.hasLines(trace)) {
    opts.line = {
      overlay: true,
      thickness: trace.line.width * plotGlPixelRatio,
      color: trace.line.color,
      opacity: trace.opacity
    };
    var dashes = (constants.DASHES[trace.line.dash] || [1]).slice();
    for (i = 0; i < dashes.length; ++i) {
      dashes[i] *= trace.line.width * plotGlPixelRatio;
    }
    opts.line.dashes = dashes;
  }
  if (trace.error_x && trace.error_x.visible) {
    opts.errorX = convertErrorBarStyle(trace, trace.error_x, plotGlPixelRatio);
  }
  if (trace.error_y && trace.error_y.visible) {
    opts.errorY = convertErrorBarStyle(trace, trace.error_y, plotGlPixelRatio);
  }
  if (!!trace.fill && trace.fill !== 'none') {
    opts.fill = {
      closed: true,
      fill: trace.fillcolor,
      thickness: 0
    };
  }
  return opts;
}
function convertTextStyle(gd, trace) {
  var fullLayout = gd._fullLayout;
  var count = trace._length;
  var textfontIn = trace.textfont;
  var textpositionIn = trace.textposition;
  var textPos = isArrayOrTypedArray(textpositionIn) ? textpositionIn : [textpositionIn];
  var tfc = textfontIn.color;
  var tfs = textfontIn.size;
  var tff = textfontIn.family;
  var tfw = textfontIn.weight;
  var tfy = textfontIn.style;
  var tfv = textfontIn.variant;
  var optsOut = {};
  var i;
  var plotGlPixelRatio = gd._context.plotGlPixelRatio;
  var texttemplate = trace.texttemplate;
  if (texttemplate) {
    optsOut.text = [];
    var d3locale = fullLayout._d3locale;
    var isArray = Array.isArray(texttemplate);
    var N = isArray ? Math.min(texttemplate.length, count) : count;
    var txt = isArray ? function (i) {
      return texttemplate[i];
    } : function () {
      return texttemplate;
    };
    for (i = 0; i < N; i++) {
      var d = {
        i: i
      };
      var labels = trace._module.formatLabels(d, trace, fullLayout);
      var pointValues = {};
      appendArrayPointValue(pointValues, trace, i);
      var meta = trace._meta || {};
      optsOut.text.push(Lib.texttemplateString(txt(i), labels, d3locale, pointValues, d, meta));
    }
  } else {
    if (isArrayOrTypedArray(trace.text) && trace.text.length < count) {
      // if text array is shorter, we'll need to append to it, so let's slice to prevent mutating
      optsOut.text = trace.text.slice();
    } else {
      optsOut.text = trace.text;
    }
  }
  // pad text array with empty strings
  if (isArrayOrTypedArray(optsOut.text)) {
    for (i = optsOut.text.length; i < count; i++) {
      optsOut.text[i] = '';
    }
  }
  optsOut.opacity = trace.opacity;
  optsOut.font = {};
  optsOut.align = [];
  optsOut.baseline = [];
  for (i = 0; i < textPos.length; i++) {
    var tp = textPos[i].split(/\s+/);
    switch (tp[1]) {
      case 'left':
        optsOut.align.push('right');
        break;
      case 'right':
        optsOut.align.push('left');
        break;
      default:
        optsOut.align.push(tp[1]);
    }
    switch (tp[0]) {
      case 'top':
        optsOut.baseline.push('bottom');
        break;
      case 'bottom':
        optsOut.baseline.push('top');
        break;
      default:
        optsOut.baseline.push(tp[0]);
    }
  }
  if (isArrayOrTypedArray(tfc)) {
    optsOut.color = new Array(count);
    for (i = 0; i < count; i++) {
      optsOut.color[i] = tfc[i];
    }
  } else {
    optsOut.color = tfc;
  }
  if (isArrayOrTypedArray(tfs) || Array.isArray(tff) || isArrayOrTypedArray(tfw) || Array.isArray(tfy) || Array.isArray(tfv)) {
    // if any textfont param is array - make render a batch
    optsOut.font = new Array(count);
    for (i = 0; i < count; i++) {
      var fonti = optsOut.font[i] = {};
      fonti.size = (Lib.isTypedArray(tfs) ? tfs[i] : isArrayOrTypedArray(tfs) ? isNumeric(tfs[i]) ? tfs[i] : 0 : tfs) * plotGlPixelRatio;
      fonti.family = Array.isArray(tff) ? tff[i] : tff;
      fonti.weight = weightFallBack(isArrayOrTypedArray(tfw) ? tfw[i] : tfw);
      fonti.style = Array.isArray(tfy) ? tfy[i] : tfy;
      fonti.variant = Array.isArray(tfv) ? tfv[i] : tfv;
    }
  } else {
    // if both are single values, make render fast single-value
    optsOut.font = {
      size: tfs * plotGlPixelRatio,
      family: tff,
      weight: weightFallBack(tfw),
      style: tfy,
      variant: tfv
    };
  }
  return optsOut;
}

// scattergl rendering pipeline has limited support of numeric weight values
// Here we map the numbers to be either bold or normal.
function weightFallBack(w) {
  if (w <= 1000) {
    return w > 500 ? 'bold' : 'normal';
  }
  return w;
}
function convertMarkerStyle(gd, trace) {
  var count = trace._length;
  var optsIn = trace.marker;
  var optsOut = {};
  var i;
  var multiSymbol = isArrayOrTypedArray(optsIn.symbol);
  var multiAngle = isArrayOrTypedArray(optsIn.angle);
  var multiColor = isArrayOrTypedArray(optsIn.color);
  var multiLineColor = isArrayOrTypedArray(optsIn.line.color);
  var multiOpacity = isArrayOrTypedArray(optsIn.opacity);
  var multiSize = isArrayOrTypedArray(optsIn.size);
  var multiLineWidth = isArrayOrTypedArray(optsIn.line.width);
  var isOpen;
  if (!multiSymbol) isOpen = helpers.isOpenSymbol(optsIn.symbol);

  // prepare colors
  if (multiSymbol || multiColor || multiLineColor || multiOpacity || multiAngle) {
    optsOut.symbols = new Array(count);
    optsOut.angles = new Array(count);
    optsOut.colors = new Array(count);
    optsOut.borderColors = new Array(count);
    var symbols = optsIn.symbol;
    var angles = optsIn.angle;
    var colors = formatColor(optsIn, optsIn.opacity, count);
    var borderColors = formatColor(optsIn.line, optsIn.opacity, count);
    if (!isArrayOrTypedArray(borderColors[0])) {
      var borderColor = borderColors;
      borderColors = Array(count);
      for (i = 0; i < count; i++) {
        borderColors[i] = borderColor;
      }
    }
    if (!isArrayOrTypedArray(colors[0])) {
      var color = colors;
      colors = Array(count);
      for (i = 0; i < count; i++) {
        colors[i] = color;
      }
    }
    if (!isArrayOrTypedArray(symbols)) {
      var symbol = symbols;
      symbols = Array(count);
      for (i = 0; i < count; i++) {
        symbols[i] = symbol;
      }
    }
    if (!isArrayOrTypedArray(angles)) {
      var angle = angles;
      angles = Array(count);
      for (i = 0; i < count; i++) {
        angles[i] = angle;
      }
    }
    optsOut.symbols = symbols;
    optsOut.angles = angles;
    optsOut.colors = colors;
    optsOut.borderColors = borderColors;
    for (i = 0; i < count; i++) {
      if (multiSymbol) {
        isOpen = helpers.isOpenSymbol(optsIn.symbol[i]);
      }
      if (isOpen) {
        borderColors[i] = colors[i].slice();
        colors[i] = colors[i].slice();
        colors[i][3] = 0;
      }
    }
    optsOut.opacity = trace.opacity;
    optsOut.markers = new Array(count);
    for (i = 0; i < count; i++) {
      optsOut.markers[i] = getSymbolSdf({
        mx: optsOut.symbols[i],
        ma: optsOut.angles[i]
      }, trace);
    }
  } else {
    if (isOpen) {
      optsOut.color = rgba(optsIn.color, 'uint8');
      optsOut.color[3] = 0;
      optsOut.borderColor = rgba(optsIn.color, 'uint8');
    } else {
      optsOut.color = rgba(optsIn.color, 'uint8');
      optsOut.borderColor = rgba(optsIn.line.color, 'uint8');
    }
    optsOut.opacity = trace.opacity * optsIn.opacity;
    optsOut.marker = getSymbolSdf({
      mx: optsIn.symbol,
      ma: optsIn.angle
    }, trace);
  }

  // prepare sizes
  var sizeFactor = 1;
  var markerSizeFunc = makeBubbleSizeFn(trace, sizeFactor);
  var s;
  if (multiSize || multiLineWidth) {
    var sizes = optsOut.sizes = new Array(count);
    var borderSizes = optsOut.borderSizes = new Array(count);
    var sizeTotal = 0;
    var sizeAvg;
    if (multiSize) {
      for (i = 0; i < count; i++) {
        sizes[i] = markerSizeFunc(optsIn.size[i]);
        sizeTotal += sizes[i];
      }
      sizeAvg = sizeTotal / count;
    } else {
      s = markerSizeFunc(optsIn.size);
      for (i = 0; i < count; i++) {
        sizes[i] = s;
      }
    }

    // See  https://github.com/plotly/plotly.js/pull/1781#discussion_r121820798
    if (multiLineWidth) {
      for (i = 0; i < count; i++) {
        borderSizes[i] = optsIn.line.width[i];
      }
    } else {
      s = optsIn.line.width;
      for (i = 0; i < count; i++) {
        borderSizes[i] = s;
      }
    }
    optsOut.sizeAvg = sizeAvg;
  } else {
    optsOut.size = markerSizeFunc(optsIn && optsIn.size || 10);
    optsOut.borderSizes = markerSizeFunc(optsIn.line.width);
  }
  return optsOut;
}
function convertMarkerSelection(gd, trace, target) {
  var optsIn = trace.marker;
  var optsOut = {};
  if (!target) return optsOut;
  if (target.marker && target.marker.symbol) {
    optsOut = convertMarkerStyle(gd, Lib.extendFlat({}, optsIn, target.marker));
  } else if (target.marker) {
    if (target.marker.size) optsOut.size = target.marker.size;
    if (target.marker.color) optsOut.colors = target.marker.color;
    if (target.marker.opacity !== undefined) optsOut.opacity = target.marker.opacity;
  }
  return optsOut;
}
function convertTextSelection(gd, trace, target) {
  var optsOut = {};
  if (!target) return optsOut;
  if (target.textfont) {
    var optsIn = {
      opacity: 1,
      text: trace.text,
      texttemplate: trace.texttemplate,
      textposition: trace.textposition,
      textfont: Lib.extendFlat({}, trace.textfont)
    };
    if (target.textfont) {
      Lib.extendFlat(optsIn.textfont, target.textfont);
    }
    optsOut = convertTextStyle(gd, optsIn);
  }
  return optsOut;
}
function convertErrorBarStyle(trace, target, plotGlPixelRatio) {
  var optsOut = {
    capSize: target.width * 2 * plotGlPixelRatio,
    lineWidth: target.thickness * plotGlPixelRatio,
    color: target.color
  };
  if (target.copy_ystyle) {
    optsOut = trace.error_y;
  }
  return optsOut;
}
var SYMBOL_SDF_SIZE = constants.SYMBOL_SDF_SIZE;
var SYMBOL_SIZE = constants.SYMBOL_SIZE;
var SYMBOL_STROKE = constants.SYMBOL_STROKE;
var SYMBOL_SDF = {};
var SYMBOL_SVG_CIRCLE = Drawing.symbolFuncs[0](SYMBOL_SIZE * 0.05);
function getSymbolSdf(d, trace) {
  var symbol = d.mx;
  if (symbol === 'circle') return null;
  var symbolPath, symbolSdf;
  var symbolNumber = Drawing.symbolNumber(symbol);
  var symbolFunc = Drawing.symbolFuncs[symbolNumber % 100];
  var symbolNoDot = !!Drawing.symbolNoDot[symbolNumber % 100];
  var symbolNoFill = !!Drawing.symbolNoFill[symbolNumber % 100];
  var isDot = helpers.isDotSymbol(symbol);

  // until we may handle angles in shader?
  if (d.ma) symbol += '_' + d.ma;

  // get symbol sdf from cache or generate it
  if (SYMBOL_SDF[symbol]) return SYMBOL_SDF[symbol];
  var angle = Drawing.getMarkerAngle(d, trace);
  if (isDot && !symbolNoDot) {
    symbolPath = symbolFunc(SYMBOL_SIZE * 1.1, angle) + SYMBOL_SVG_CIRCLE;
  } else {
    symbolPath = symbolFunc(SYMBOL_SIZE, angle);
  }
  symbolSdf = svgSdf(symbolPath, {
    w: SYMBOL_SDF_SIZE,
    h: SYMBOL_SDF_SIZE,
    viewBox: [-SYMBOL_SIZE, -SYMBOL_SIZE, SYMBOL_SIZE, SYMBOL_SIZE],
    stroke: symbolNoFill ? SYMBOL_STROKE : -SYMBOL_STROKE
  });
  SYMBOL_SDF[symbol] = symbolSdf;
  return symbolSdf || null;
}
function convertLinePositions(gd, trace, positions) {
  var len = positions.length;
  var count = len / 2;
  var linePositions;
  var i;
  if (subTypes.hasLines(trace) && count) {
    if (trace.line.shape === 'hv') {
      linePositions = [];
      for (i = 0; i < count - 1; i++) {
        if (isNaN(positions[i * 2]) || isNaN(positions[i * 2 + 1])) {
          linePositions.push(NaN, NaN, NaN, NaN);
        } else {
          linePositions.push(positions[i * 2], positions[i * 2 + 1]);
          if (!isNaN(positions[i * 2 + 2]) && !isNaN(positions[i * 2 + 3])) {
            linePositions.push(positions[i * 2 + 2], positions[i * 2 + 1]);
          } else {
            linePositions.push(NaN, NaN);
          }
        }
      }
      linePositions.push(positions[len - 2], positions[len - 1]);
    } else if (trace.line.shape === 'hvh') {
      linePositions = [];
      for (i = 0; i < count - 1; i++) {
        if (isNaN(positions[i * 2]) || isNaN(positions[i * 2 + 1]) || isNaN(positions[i * 2 + 2]) || isNaN(positions[i * 2 + 3])) {
          if (!isNaN(positions[i * 2]) && !isNaN(positions[i * 2 + 1])) {
            linePositions.push(positions[i * 2], positions[i * 2 + 1]);
          } else {
            linePositions.push(NaN, NaN);
          }
          linePositions.push(NaN, NaN);
        } else {
          var midPtX = (positions[i * 2] + positions[i * 2 + 2]) / 2;
          linePositions.push(positions[i * 2], positions[i * 2 + 1], midPtX, positions[i * 2 + 1], midPtX, positions[i * 2 + 3]);
        }
      }
      linePositions.push(positions[len - 2], positions[len - 1]);
    } else if (trace.line.shape === 'vhv') {
      linePositions = [];
      for (i = 0; i < count - 1; i++) {
        if (isNaN(positions[i * 2]) || isNaN(positions[i * 2 + 1]) || isNaN(positions[i * 2 + 2]) || isNaN(positions[i * 2 + 3])) {
          if (!isNaN(positions[i * 2]) && !isNaN(positions[i * 2 + 1])) {
            linePositions.push(positions[i * 2], positions[i * 2 + 1]);
          } else {
            linePositions.push(NaN, NaN);
          }
          linePositions.push(NaN, NaN);
        } else {
          var midPtY = (positions[i * 2 + 1] + positions[i * 2 + 3]) / 2;
          linePositions.push(positions[i * 2], positions[i * 2 + 1], positions[i * 2], midPtY, positions[i * 2 + 2], midPtY);
        }
      }
      linePositions.push(positions[len - 2], positions[len - 1]);
    } else if (trace.line.shape === 'vh') {
      linePositions = [];
      for (i = 0; i < count - 1; i++) {
        if (isNaN(positions[i * 2]) || isNaN(positions[i * 2 + 1])) {
          linePositions.push(NaN, NaN, NaN, NaN);
        } else {
          linePositions.push(positions[i * 2], positions[i * 2 + 1]);
          if (!isNaN(positions[i * 2 + 2]) && !isNaN(positions[i * 2 + 3])) {
            linePositions.push(positions[i * 2], positions[i * 2 + 3]);
          } else {
            linePositions.push(NaN, NaN);
          }
        }
      }
      linePositions.push(positions[len - 2], positions[len - 1]);
    } else {
      linePositions = positions;
    }
  }

  // If we have data with gaps, we ought to use rect joins
  // FIXME: get rid of this
  var hasNaN = false;
  for (i = 0; i < linePositions.length; i++) {
    if (isNaN(linePositions[i])) {
      hasNaN = true;
      break;
    }
  }
  var join = hasNaN || linePositions.length > constants.TOO_MANY_POINTS ? 'rect' : subTypes.hasMarkers(trace) ? 'rect' : 'round';

  // fill gaps
  if (hasNaN && trace.connectgaps) {
    var lastX = linePositions[0];
    var lastY = linePositions[1];
    for (i = 0; i < linePositions.length; i += 2) {
      if (isNaN(linePositions[i]) || isNaN(linePositions[i + 1])) {
        linePositions[i] = lastX;
        linePositions[i + 1] = lastY;
      } else {
        lastX = linePositions[i];
        lastY = linePositions[i + 1];
      }
    }
  }
  return {
    join: join,
    positions: linePositions
  };
}
function convertErrorBarPositions(gd, trace, positions, x, y) {
  var makeComputeError = Registry.getComponentMethod('errorbars', 'makeComputeError');
  var xa = AxisIDs.getFromId(gd, trace.xaxis, 'x');
  var ya = AxisIDs.getFromId(gd, trace.yaxis, 'y');
  var count = positions.length / 2;
  var out = {};
  function convertOneAxis(coords, ax) {
    var axLetter = ax._id.charAt(0);
    var opts = trace['error_' + axLetter];
    if (opts && opts.visible && (ax.type === 'linear' || ax.type === 'log')) {
      var computeError = makeComputeError(opts);
      var pOffset = {
        x: 0,
        y: 1
      }[axLetter];
      var eOffset = {
        x: [0, 1, 2, 3],
        y: [2, 3, 0, 1]
      }[axLetter];
      var errors = new Float64Array(4 * count);
      var minShoe = Infinity;
      var maxHat = -Infinity;
      for (var i = 0, j = 0; i < count; i++, j += 4) {
        var dc = coords[i];
        if (isNumeric(dc)) {
          var dl = positions[i * 2 + pOffset];
          var vals = computeError(dc, i);
          var lv = vals[0];
          var hv = vals[1];
          if (isNumeric(lv) && isNumeric(hv)) {
            var shoe = dc - lv;
            var hat = dc + hv;
            errors[j + eOffset[0]] = dl - ax.c2l(shoe);
            errors[j + eOffset[1]] = ax.c2l(hat) - dl;
            errors[j + eOffset[2]] = 0;
            errors[j + eOffset[3]] = 0;
            minShoe = Math.min(minShoe, dc - lv);
            maxHat = Math.max(maxHat, dc + hv);
          }
        }
      }
      out[axLetter] = {
        positions: positions,
        errors: errors,
        _bnds: [minShoe, maxHat]
      };
    }
  }
  convertOneAxis(x, xa);
  convertOneAxis(y, ya);
  return out;
}
function convertTextPosition(gd, trace, textOpts, markerOpts) {
  var count = trace._length;
  var out = {};
  var i;

  // corresponds to textPointPosition from component.drawing
  if (subTypes.hasMarkers(trace)) {
    var fontOpts = textOpts.font;
    var align = textOpts.align;
    var baseline = textOpts.baseline;
    out.offset = new Array(count);
    for (i = 0; i < count; i++) {
      var ms = markerOpts.sizes ? markerOpts.sizes[i] : markerOpts.size;
      var fs = isArrayOrTypedArray(fontOpts) ? fontOpts[i].size : fontOpts.size;
      var a = isArrayOrTypedArray(align) ? align.length > 1 ? align[i] : align[0] : align;
      var b = isArrayOrTypedArray(baseline) ? baseline.length > 1 ? baseline[i] : baseline[0] : baseline;
      var hSign = TEXTOFFSETSIGN[a];
      var vSign = TEXTOFFSETSIGN[b];
      var xPad = ms ? ms / 0.8 + 1 : 0;
      var yPad = -vSign * xPad - vSign * 0.5;
      out.offset[i] = [hSign * xPad / fs, yPad / fs];
    }
  }
  return out;
}
module.exports = {
  style: convertStyle,
  markerStyle: convertMarkerStyle,
  markerSelection: convertMarkerSelection,
  linePositions: convertLinePositions,
  errorBarPositions: convertErrorBarPositions,
  textPosition: convertTextPosition
};

/***/ }),

/***/ 86590:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var Registry = __webpack_require__(33626);
var helpers = __webpack_require__(4075);
var attributes = __webpack_require__(92089);
var constants = __webpack_require__(32660);
var subTypes = __webpack_require__(64726);
var handleXYDefaults = __webpack_require__(99867);
var handlePeriodDefaults = __webpack_require__(99669);
var handleMarkerDefaults = __webpack_require__(24272);
var handleLineDefaults = __webpack_require__(98168);
var handleFillColorDefaults = __webpack_require__(54114);
var handleTextDefaults = __webpack_require__(663);
module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
  function coerce(attr, dflt) {
    return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
  }
  var isOpen = traceIn.marker ? helpers.isOpenSymbol(traceIn.marker.symbol) : false;
  var isBubble = subTypes.isBubble(traceIn);
  var len = handleXYDefaults(traceIn, traceOut, layout, coerce);
  if (!len) {
    traceOut.visible = false;
    return;
  }
  handlePeriodDefaults(traceIn, traceOut, layout, coerce);
  coerce('xhoverformat');
  coerce('yhoverformat');
  var defaultMode = len < constants.PTS_LINESONLY ? 'lines+markers' : 'lines';
  coerce('text');
  coerce('hovertext');
  coerce('hovertemplate');
  coerce('mode', defaultMode);
  if (subTypes.hasMarkers(traceOut)) {
    handleMarkerDefaults(traceIn, traceOut, defaultColor, layout, coerce, {
      noAngleRef: true,
      noStandOff: true
    });
    coerce('marker.line.width', isOpen || isBubble ? 1 : 0);
  }
  if (subTypes.hasLines(traceOut)) {
    coerce('connectgaps');
    handleLineDefaults(traceIn, traceOut, defaultColor, layout, coerce);
    coerce('line.shape');
  }
  if (subTypes.hasText(traceOut)) {
    coerce('texttemplate');
    handleTextDefaults(traceIn, traceOut, layout, coerce, {
      noFontShadow: true,
      noFontLineposition: true,
      noFontTextcase: true
    });
  }
  var lineColor = (traceOut.line || {}).color;
  var markerColor = (traceOut.marker || {}).color;
  coerce('fill');
  if (traceOut.fill !== 'none') {
    handleFillColorDefaults(traceIn, traceOut, defaultColor, coerce);
  }
  var errorBarsSupplyDefaults = Registry.getComponentMethod('errorbars', 'supplyDefaults');
  errorBarsSupplyDefaults(traceIn, traceOut, lineColor || markerColor || defaultColor, {
    axis: 'y'
  });
  errorBarsSupplyDefaults(traceIn, traceOut, lineColor || markerColor || defaultColor, {
    axis: 'x',
    inherit: 'y'
  });
  Lib.coerceSelectionMarkerOpacity(traceOut, coerce);
};

/***/ }),

/***/ 85686:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var Color = __webpack_require__(78766);
var DESELECTDIM = (__webpack_require__(20438).DESELECTDIM);
function styleTextSelection(cd) {
  var cd0 = cd[0];
  var trace = cd0.trace;
  var stash = cd0.t;
  var scene = stash._scene;
  var index = stash.index;
  var els = scene.selectBatch[index];
  var unels = scene.unselectBatch[index];
  var baseOpts = scene.textOptions[index];
  var selOpts = scene.textSelectedOptions[index] || {};
  var unselOpts = scene.textUnselectedOptions[index] || {};
  var opts = Lib.extendFlat({}, baseOpts);
  var i, j;
  if (els.length || unels.length) {
    var stc = selOpts.color;
    var utc = unselOpts.color;
    var base = baseOpts.color;
    var hasArrayBase = Lib.isArrayOrTypedArray(base);
    opts.color = new Array(trace._length);
    for (i = 0; i < els.length; i++) {
      j = els[i];
      opts.color[j] = stc || (hasArrayBase ? base[j] : base);
    }
    for (i = 0; i < unels.length; i++) {
      j = unels[i];
      var basej = hasArrayBase ? base[j] : base;
      opts.color[j] = utc ? utc : stc ? basej : Color.addOpacity(basej, DESELECTDIM);
    }
  }
  scene.glText[index].update(opts);
}
module.exports = {
  styleTextSelection: styleTextSelection
};

/***/ }),

/***/ 99185:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var scatterFormatLabels = __webpack_require__(15294);
module.exports = function formatLabels(cdi, trace, fullLayout) {
  var i = cdi.i;
  if (!('x' in cdi)) cdi.x = trace._x[i];
  if (!('y' in cdi)) cdi.y = trace._y[i];
  return scatterFormatLabels(cdi, trace, fullLayout);
};

/***/ }),

/***/ 4075:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var constants = __webpack_require__(29483);
exports.isOpenSymbol = function (symbol) {
  return typeof symbol === 'string' ? constants.OPEN_RE.test(symbol) : symbol % 200 > 100;
};
exports.isDotSymbol = function (symbol) {
  return typeof symbol === 'string' ? constants.DOT_RE.test(symbol) : symbol > 200;
};

/***/ }),

/***/ 36544:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Registry = __webpack_require__(33626);
var Lib = __webpack_require__(34809);
var getTraceColor = __webpack_require__(11539);
function hoverPoints(pointData, xval, yval, hovermode) {
  var cd = pointData.cd;
  var stash = cd[0].t;
  var trace = cd[0].trace;
  var xa = pointData.xa;
  var ya = pointData.ya;
  var x = stash.x;
  var y = stash.y;
  var xpx = xa.c2p(xval);
  var ypx = ya.c2p(yval);
  var maxDistance = pointData.distance;
  var ids;

  // FIXME: make sure this is a proper way to calc search radius
  if (stash.tree) {
    var xl = xa.p2c(xpx - maxDistance);
    var xr = xa.p2c(xpx + maxDistance);
    var yl = ya.p2c(ypx - maxDistance);
    var yr = ya.p2c(ypx + maxDistance);
    if (hovermode === 'x') {
      ids = stash.tree.range(Math.min(xl, xr), Math.min(ya._rl[0], ya._rl[1]), Math.max(xl, xr), Math.max(ya._rl[0], ya._rl[1]));
    } else {
      ids = stash.tree.range(Math.min(xl, xr), Math.min(yl, yr), Math.max(xl, xr), Math.max(yl, yr));
    }
  } else {
    ids = stash.ids;
  }

  // pick the id closest to the point
  // note that point possibly may not be found
  var k, closestId, ptx, pty, i, dx, dy, dist, dxy;
  var minDist = maxDistance;
  if (hovermode === 'x') {
    var xPeriod = !!trace.xperiodalignment;
    var yPeriod = !!trace.yperiodalignment;
    for (i = 0; i < ids.length; i++) {
      k = ids[i];
      ptx = x[k];
      dx = Math.abs(xa.c2p(ptx) - xpx);
      if (xPeriod) {
        var x0 = xa.c2p(trace._xStarts[k]);
        var x1 = xa.c2p(trace._xEnds[k]);
        dx = xpx >= Math.min(x0, x1) && xpx <= Math.max(x0, x1) ? 0 : Infinity;
      }
      if (dx < minDist) {
        minDist = dx;
        pty = y[k];
        dy = ya.c2p(pty) - ypx;
        if (yPeriod) {
          var y0 = ya.c2p(trace._yStarts[k]);
          var y1 = ya.c2p(trace._yEnds[k]);
          dy = ypx >= Math.min(y0, y1) && ypx <= Math.max(y0, y1) ? 0 : Infinity;
        }
        dxy = Math.sqrt(dx * dx + dy * dy);
        closestId = ids[i];
      }
    }
  } else {
    for (i = ids.length - 1; i > -1; i--) {
      k = ids[i];
      ptx = x[k];
      pty = y[k];
      dx = xa.c2p(ptx) - xpx;
      dy = ya.c2p(pty) - ypx;
      dist = Math.sqrt(dx * dx + dy * dy);
      if (dist < minDist) {
        minDist = dxy = dist;
        closestId = k;
      }
    }
  }
  pointData.index = closestId;
  pointData.distance = minDist;
  pointData.dxy = dxy;
  if (closestId === undefined) return [pointData];
  return [calcHover(pointData, x, y, trace)];
}
function calcHover(pointData, x, y, trace) {
  var xa = pointData.xa;
  var ya = pointData.ya;
  var minDist = pointData.distance;
  var dxy = pointData.dxy;
  var id = pointData.index;

  // the closest data point
  var di = {
    pointNumber: id,
    x: x[id],
    y: y[id]
  };

  // that is single-item arrays_to_calcdata excerpt, since we are doing it for a single point and we don't have to do it beforehead for 1e6 points
  di.tx = Lib.isArrayOrTypedArray(trace.text) ? trace.text[id] : trace.text;
  di.htx = Array.isArray(trace.hovertext) ? trace.hovertext[id] : trace.hovertext;
  di.data = Array.isArray(trace.customdata) ? trace.customdata[id] : trace.customdata;
  di.tp = Array.isArray(trace.textposition) ? trace.textposition[id] : trace.textposition;
  var font = trace.textfont;
  if (font) {
    di.ts = Lib.isArrayOrTypedArray(font.size) ? font.size[id] : font.size;
    di.tc = Lib.isArrayOrTypedArray(font.color) ? font.color[id] : font.color;
    di.tf = Array.isArray(font.family) ? font.family[id] : font.family;
    di.tw = Array.isArray(font.weight) ? font.weight[id] : font.weight;
    di.ty = Array.isArray(font.style) ? font.style[id] : font.style;
    di.tv = Array.isArray(font.variant) ? font.variant[id] : font.variant;
  }
  var marker = trace.marker;
  if (marker) {
    di.ms = Lib.isArrayOrTypedArray(marker.size) ? marker.size[id] : marker.size;
    di.mo = Lib.isArrayOrTypedArray(marker.opacity) ? marker.opacity[id] : marker.opacity;
    di.mx = Lib.isArrayOrTypedArray(marker.symbol) ? marker.symbol[id] : marker.symbol;
    di.ma = Lib.isArrayOrTypedArray(marker.angle) ? marker.angle[id] : marker.angle;
    di.mc = Lib.isArrayOrTypedArray(marker.color) ? marker.color[id] : marker.color;
  }
  var line = marker && marker.line;
  if (line) {
    di.mlc = Array.isArray(line.color) ? line.color[id] : line.color;
    di.mlw = Lib.isArrayOrTypedArray(line.width) ? line.width[id] : line.width;
  }
  var grad = marker && marker.gradient;
  if (grad && grad.type !== 'none') {
    di.mgt = Array.isArray(grad.type) ? grad.type[id] : grad.type;
    di.mgc = Array.isArray(grad.color) ? grad.color[id] : grad.color;
  }
  var xp = xa.c2p(di.x, true);
  var yp = ya.c2p(di.y, true);
  var rad = di.mrc || 1;
  var hoverlabel = trace.hoverlabel;
  if (hoverlabel) {
    di.hbg = Array.isArray(hoverlabel.bgcolor) ? hoverlabel.bgcolor[id] : hoverlabel.bgcolor;
    di.hbc = Array.isArray(hoverlabel.bordercolor) ? hoverlabel.bordercolor[id] : hoverlabel.bordercolor;
    di.hts = Lib.isArrayOrTypedArray(hoverlabel.font.size) ? hoverlabel.font.size[id] : hoverlabel.font.size;
    di.htc = Array.isArray(hoverlabel.font.color) ? hoverlabel.font.color[id] : hoverlabel.font.color;
    di.htf = Array.isArray(hoverlabel.font.family) ? hoverlabel.font.family[id] : hoverlabel.font.family;
    di.hnl = Lib.isArrayOrTypedArray(hoverlabel.namelength) ? hoverlabel.namelength[id] : hoverlabel.namelength;
  }
  var hoverinfo = trace.hoverinfo;
  if (hoverinfo) {
    di.hi = Array.isArray(hoverinfo) ? hoverinfo[id] : hoverinfo;
  }
  var hovertemplate = trace.hovertemplate;
  if (hovertemplate) {
    di.ht = Array.isArray(hovertemplate) ? hovertemplate[id] : hovertemplate;
  }
  var fakeCd = {};
  fakeCd[pointData.index] = di;
  var origX = trace._origX;
  var origY = trace._origY;
  var pointData2 = Lib.extendFlat({}, pointData, {
    color: getTraceColor(trace, di),
    x0: xp - rad,
    x1: xp + rad,
    xLabelVal: origX ? origX[id] : di.x,
    y0: yp - rad,
    y1: yp + rad,
    yLabelVal: origY ? origY[id] : di.y,
    cd: fakeCd,
    distance: minDist,
    spikeDistance: dxy,
    hovertemplate: di.ht
  });
  if (di.htx) pointData2.text = di.htx;else if (di.tx) pointData2.text = di.tx;else if (trace.text) pointData2.text = trace.text;
  Lib.fillText(di, trace, pointData2);
  Registry.getComponentMethod('errorbars', 'hoverInfo')(di, trace, pointData2);
  return pointData2;
}
module.exports = {
  hoverPoints: hoverPoints,
  calcHover: calcHover
};

/***/ }),

/***/ 52378:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var index = __webpack_require__(68258);
index.plot = __webpack_require__(47731);
module.exports = index;

/***/ }),

/***/ 47731:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var createScatter = __webpack_require__(62172);
var createLine = __webpack_require__(49478);
var createError = __webpack_require__(29978);
var Text = __webpack_require__(74024);
var Lib = __webpack_require__(34809);
var selectMode = (__webpack_require__(70414).selectMode);
var prepareRegl = __webpack_require__(22459);
var subTypes = __webpack_require__(64726);
var linkTraces = __webpack_require__(17210);
var styleTextSelection = (__webpack_require__(85686).styleTextSelection);
var reglPrecompiled = {};
function getViewport(fullLayout, xaxis, yaxis, plotGlPixelRatio) {
  var gs = fullLayout._size;
  var width = fullLayout.width * plotGlPixelRatio;
  var height = fullLayout.height * plotGlPixelRatio;
  var l = gs.l * plotGlPixelRatio;
  var b = gs.b * plotGlPixelRatio;
  var r = gs.r * plotGlPixelRatio;
  var t = gs.t * plotGlPixelRatio;
  var w = gs.w * plotGlPixelRatio;
  var h = gs.h * plotGlPixelRatio;
  return [l + xaxis.domain[0] * w, b + yaxis.domain[0] * h, width - r - (1 - xaxis.domain[1]) * w, height - t - (1 - yaxis.domain[1]) * h];
}
var exports = module.exports = function plot(gd, subplot, cdata) {
  if (!cdata.length) return;
  var fullLayout = gd._fullLayout;
  var scene = subplot._scene;
  var xaxis = subplot.xaxis;
  var yaxis = subplot.yaxis;
  var i, j;

  // we may have more subplots than initialized data due to Axes.getSubplots method
  if (!scene) return;
  var success = prepareRegl(gd, ['ANGLE_instanced_arrays', 'OES_element_index_uint'], reglPrecompiled);
  if (!success) {
    scene.init();
    return;
  }
  var count = scene.count;
  var regl = fullLayout._glcanvas.data()[0].regl;

  // that is needed for fills
  linkTraces(gd, subplot, cdata);
  if (scene.dirty) {
    if ((scene.line2d || scene.error2d) && !(scene.scatter2d || scene.fill2d || scene.glText)) {
      // Fixes shared WebGL context drawing lines only case
      regl.clear({});
    }

    // make sure scenes are created
    if (scene.error2d === true) {
      scene.error2d = createError(regl);
    }
    if (scene.line2d === true) {
      scene.line2d = createLine(regl);
    }
    if (scene.scatter2d === true) {
      scene.scatter2d = createScatter(regl);
    }
    if (scene.fill2d === true) {
      scene.fill2d = createLine(regl);
    }
    if (scene.glText === true) {
      scene.glText = new Array(count);
      for (i = 0; i < count; i++) {
        scene.glText[i] = new Text(regl);
      }
    }

    // update main marker options
    if (scene.glText) {
      if (count > scene.glText.length) {
        // add gl text marker
        var textsToAdd = count - scene.glText.length;
        for (i = 0; i < textsToAdd; i++) {
          scene.glText.push(new Text(regl));
        }
      } else if (count < scene.glText.length) {
        // remove gl text marker
        var textsToRemove = scene.glText.length - count;
        var removedTexts = scene.glText.splice(count, textsToRemove);
        removedTexts.forEach(function (text) {
          text.destroy();
        });
      }
      for (i = 0; i < count; i++) {
        scene.glText[i].update(scene.textOptions[i]);
      }
    }
    if (scene.line2d) {
      scene.line2d.update(scene.lineOptions);
      scene.lineOptions = scene.lineOptions.map(function (lineOptions) {
        if (lineOptions && lineOptions.positions) {
          var srcPos = lineOptions.positions;
          var firstptdef = 0;
          while (firstptdef < srcPos.length && (isNaN(srcPos[firstptdef]) || isNaN(srcPos[firstptdef + 1]))) {
            firstptdef += 2;
          }
          var lastptdef = srcPos.length - 2;
          while (lastptdef > firstptdef && (isNaN(srcPos[lastptdef]) || isNaN(srcPos[lastptdef + 1]))) {
            lastptdef -= 2;
          }
          lineOptions.positions = srcPos.slice(firstptdef, lastptdef + 2);
        }
        return lineOptions;
      });
      scene.line2d.update(scene.lineOptions);
    }
    if (scene.error2d) {
      var errorBatch = (scene.errorXOptions || []).concat(scene.errorYOptions || []);
      scene.error2d.update(errorBatch);
    }
    if (scene.scatter2d) {
      scene.scatter2d.update(scene.markerOptions);
    }

    // fill requires linked traces, so we generate it's positions here
    scene.fillOrder = Lib.repeat(null, count);
    if (scene.fill2d) {
      scene.fillOptions = scene.fillOptions.map(function (fillOptions, i) {
        var cdscatter = cdata[i];
        if (!fillOptions || !cdscatter || !cdscatter[0] || !cdscatter[0].trace) return;
        var cd = cdscatter[0];
        var trace = cd.trace;
        var stash = cd.t;
        var lineOptions = scene.lineOptions[i];
        var last, j;
        var fillData = [];
        if (trace._ownfill) fillData.push(i);
        if (trace._nexttrace) fillData.push(i + 1);
        if (fillData.length) scene.fillOrder[i] = fillData;
        var pos = [];
        var srcPos = lineOptions && lineOptions.positions || stash.positions;
        var firstptdef, lastptdef;
        if (trace.fill === 'tozeroy') {
          firstptdef = 0;
          while (firstptdef < srcPos.length && isNaN(srcPos[firstptdef + 1])) {
            firstptdef += 2;
          }
          lastptdef = srcPos.length - 2;
          while (lastptdef > firstptdef && isNaN(srcPos[lastptdef + 1])) {
            lastptdef -= 2;
          }
          if (srcPos[firstptdef + 1] !== 0) {
            pos = [srcPos[firstptdef], 0];
          }
          pos = pos.concat(srcPos.slice(firstptdef, lastptdef + 2));
          if (srcPos[lastptdef + 1] !== 0) {
            pos = pos.concat([srcPos[lastptdef], 0]);
          }
        } else if (trace.fill === 'tozerox') {
          firstptdef = 0;
          while (firstptdef < srcPos.length && isNaN(srcPos[firstptdef])) {
            firstptdef += 2;
          }
          lastptdef = srcPos.length - 2;
          while (lastptdef > firstptdef && isNaN(srcPos[lastptdef])) {
            lastptdef -= 2;
          }
          if (srcPos[firstptdef] !== 0) {
            pos = [0, srcPos[firstptdef + 1]];
          }
          pos = pos.concat(srcPos.slice(firstptdef, lastptdef + 2));
          if (srcPos[lastptdef] !== 0) {
            pos = pos.concat([0, srcPos[lastptdef + 1]]);
          }
        } else if (trace.fill === 'toself' || trace.fill === 'tonext') {
          pos = [];
          last = 0;
          fillOptions.splitNull = true;
          for (j = 0; j < srcPos.length; j += 2) {
            if (isNaN(srcPos[j]) || isNaN(srcPos[j + 1])) {
              pos = pos.concat(srcPos.slice(last, j));
              pos.push(srcPos[last], srcPos[last + 1]);
              pos.push(null, null); // keep null to mark end of polygon
              last = j + 2;
            }
          }
          pos = pos.concat(srcPos.slice(last));
          if (last) {
            pos.push(srcPos[last], srcPos[last + 1]);
          }
        } else {
          var nextTrace = trace._nexttrace;
          if (nextTrace) {
            var nextOptions = scene.lineOptions[i + 1];
            if (nextOptions) {
              var nextPos = nextOptions.positions;
              if (trace.fill === 'tonexty') {
                pos = srcPos.slice();
                for (i = Math.floor(nextPos.length / 2); i--;) {
                  var xx = nextPos[i * 2];
                  var yy = nextPos[i * 2 + 1];
                  if (isNaN(xx) || isNaN(yy)) continue;
                  pos.push(xx, yy);
                }
                fillOptions.fill = nextTrace.fillcolor;
              }
            }
          }
        }

        // detect prev trace positions to exclude from current fill
        if (trace._prevtrace && trace._prevtrace.fill === 'tonext') {
          var prevLinePos = scene.lineOptions[i - 1].positions;

          // FIXME: likely this logic should be tested better
          var offset = pos.length / 2;
          last = offset;
          var hole = [last];
          for (j = 0; j < prevLinePos.length; j += 2) {
            if (isNaN(prevLinePos[j]) || isNaN(prevLinePos[j + 1])) {
              hole.push(j / 2 + offset + 1);
              last = j + 2;
            }
          }
          pos = pos.concat(prevLinePos);
          fillOptions.hole = hole;
        }
        fillOptions.fillmode = trace.fill;
        fillOptions.opacity = trace.opacity;
        fillOptions.positions = pos;
        return fillOptions;
      });
      scene.fill2d.update(scene.fillOptions);
    }
  }

  // form batch arrays, and check for selected points
  var dragmode = fullLayout.dragmode;
  var isSelectMode = selectMode(dragmode);
  var clickSelectEnabled = fullLayout.clickmode.indexOf('select') > -1;
  for (i = 0; i < count; i++) {
    var cd0 = cdata[i][0];
    var trace = cd0.trace;
    var stash = cd0.t;
    var index = stash.index;
    var len = trace._length;
    var x = stash.x;
    var y = stash.y;
    if (trace.selectedpoints || isSelectMode || clickSelectEnabled) {
      if (!isSelectMode) isSelectMode = true;

      // regenerate scene batch, if traces number changed during selection
      if (trace.selectedpoints) {
        var selPts = scene.selectBatch[index] = Lib.selIndices2selPoints(trace);
        var selDict = {};
        for (j = 0; j < selPts.length; j++) {
          selDict[selPts[j]] = 1;
        }
        var unselPts = [];
        for (j = 0; j < len; j++) {
          if (!selDict[j]) unselPts.push(j);
        }
        scene.unselectBatch[index] = unselPts;
      }

      // precalculate px coords since we are not going to pan during select
      // TODO, could do better here e.g.
      // - spin that in a webworker
      // - compute selection from polygons in data coordinates
      //   (maybe just for linear axes)
      var xpx = stash.xpx = new Array(len);
      var ypx = stash.ypx = new Array(len);
      for (j = 0; j < len; j++) {
        xpx[j] = xaxis.c2p(x[j]);
        ypx[j] = yaxis.c2p(y[j]);
      }
    } else {
      stash.xpx = stash.ypx = null;
    }
  }
  if (isSelectMode) {
    // create scatter instance by cloning scatter2d
    if (!scene.select2d) {
      scene.select2d = createScatter(fullLayout._glcanvas.data()[1].regl);
    }

    // use unselected styles on 'context' canvas
    if (scene.scatter2d) {
      var unselOpts = new Array(count);
      for (i = 0; i < count; i++) {
        unselOpts[i] = scene.selectBatch[i].length || scene.unselectBatch[i].length ? scene.markerUnselectedOptions[i] : {};
      }
      scene.scatter2d.update(unselOpts);
    }

    // use selected style on 'focus' canvas
    if (scene.select2d) {
      scene.select2d.update(scene.markerOptions);
      scene.select2d.update(scene.markerSelectedOptions);
    }
    if (scene.glText) {
      cdata.forEach(function (cdscatter) {
        var trace = ((cdscatter || [])[0] || {}).trace || {};
        if (subTypes.hasText(trace)) {
          styleTextSelection(cdscatter);
        }
      });
    }
  } else {
    // reset 'context' scatter2d opts to base opts,
    // thus unsetting markerUnselectedOptions from selection
    if (scene.scatter2d) {
      scene.scatter2d.update(scene.markerOptions);
    }
  }

  // provide viewport and range
  var vpRange0 = {
    viewport: getViewport(fullLayout, xaxis, yaxis, gd._context.plotGlPixelRatio),
    // TODO do we need those fallbacks?
    range: [(xaxis._rl || xaxis.range)[0], (yaxis._rl || yaxis.range)[0], (xaxis._rl || xaxis.range)[1], (yaxis._rl || yaxis.range)[1]]
  };
  var vpRange = Lib.repeat(vpRange0, scene.count);

  // upload viewport/range data to GPU
  if (scene.fill2d) {
    scene.fill2d.update(vpRange);
  }
  if (scene.line2d) {
    scene.line2d.update(vpRange);
  }
  if (scene.error2d) {
    scene.error2d.update(vpRange.concat(vpRange));
  }
  if (scene.scatter2d) {
    scene.scatter2d.update(vpRange);
  }
  if (scene.select2d) {
    scene.select2d.update(vpRange);
  }
  if (scene.glText) {
    scene.glText.forEach(function (text) {
      text.update(vpRange0);
    });
  }
};
exports.reglPrecompiled = reglPrecompiled;

/***/ }),

/***/ 62336:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);

// make sure scene exists on subplot, return it
module.exports = function sceneUpdate(gd, subplot) {
  var scene = subplot._scene;
  var resetOpts = {
    // number of traces in subplot, since scene:subplot -> 1:1
    count: 0,
    // whether scene requires init hook in plot call (dirty plot call)
    dirty: true,
    // last used options
    lineOptions: [],
    fillOptions: [],
    markerOptions: [],
    markerSelectedOptions: [],
    markerUnselectedOptions: [],
    errorXOptions: [],
    errorYOptions: [],
    textOptions: [],
    textSelectedOptions: [],
    textUnselectedOptions: [],
    // selection batches
    selectBatch: [],
    unselectBatch: []
  };

  // regl- component stubs, initialized in dirty plot call
  var initOpts = {
    fill2d: false,
    scatter2d: false,
    error2d: false,
    line2d: false,
    glText: false,
    select2d: false
  };
  if (!subplot._scene) {
    scene = subplot._scene = {};
    scene.init = function init() {
      Lib.extendFlat(scene, initOpts, resetOpts);
    };
    scene.init();

    // apply new option to all regl components (used on drag)
    scene.update = function update(opt) {
      var opts = Lib.repeat(opt, scene.count);
      if (scene.fill2d) scene.fill2d.update(opts);
      if (scene.scatter2d) scene.scatter2d.update(opts);
      if (scene.line2d) scene.line2d.update(opts);
      if (scene.error2d) scene.error2d.update(opts.concat(opts));
      if (scene.select2d) scene.select2d.update(opts);
      if (scene.glText) {
        for (var i = 0; i < scene.count; i++) {
          scene.glText[i].update(opt);
        }
      }
    };

    // draw traces in proper order
    scene.draw = function draw() {
      var count = scene.count;
      var fill2d = scene.fill2d;
      var error2d = scene.error2d;
      var line2d = scene.line2d;
      var scatter2d = scene.scatter2d;
      var glText = scene.glText;
      var select2d = scene.select2d;
      var selectBatch = scene.selectBatch;
      var unselectBatch = scene.unselectBatch;
      for (var i = 0; i < count; i++) {
        if (fill2d && scene.fillOrder[i]) {
          fill2d.draw(scene.fillOrder[i]);
        }
        if (line2d && scene.lineOptions[i]) {
          line2d.draw(i);
        }
        if (error2d) {
          if (scene.errorXOptions[i]) error2d.draw(i);
          if (scene.errorYOptions[i]) error2d.draw(i + count);
        }
        if (scatter2d && scene.markerOptions[i]) {
          if (unselectBatch[i].length) {
            var arg = Lib.repeat([], scene.count);
            arg[i] = unselectBatch[i];
            scatter2d.draw(arg);
          } else if (!selectBatch[i].length) {
            scatter2d.draw(i);
          }
        }
        if (glText[i] && scene.textOptions[i]) {
          glText[i].render();
        }
      }
      if (select2d) {
        select2d.draw(selectBatch);
      }
      scene.dirty = false;
    };

    // remove scene resources
    scene.destroy = function destroy() {
      if (scene.fill2d && scene.fill2d.destroy) scene.fill2d.destroy();
      if (scene.scatter2d && scene.scatter2d.destroy) scene.scatter2d.destroy();
      if (scene.error2d && scene.error2d.destroy) scene.error2d.destroy();
      if (scene.line2d && scene.line2d.destroy) scene.line2d.destroy();
      if (scene.select2d && scene.select2d.destroy) scene.select2d.destroy();
      if (scene.glText) {
        scene.glText.forEach(function (text) {
          if (text.destroy) text.destroy();
        });
      }
      scene.lineOptions = null;
      scene.fillOptions = null;
      scene.markerOptions = null;
      scene.markerSelectedOptions = null;
      scene.markerUnselectedOptions = null;
      scene.errorXOptions = null;
      scene.errorYOptions = null;
      scene.textOptions = null;
      scene.textSelectedOptions = null;
      scene.textUnselectedOptions = null;
      scene.selectBatch = null;
      scene.unselectBatch = null;

      // we can't just delete _scene, because `destroy` is called in the
      // middle of supplyDefaults, before relinkPrivateKeys which will put it back.
      subplot._scene = null;
    };
  }

  // in case if we have scene from the last calc - reset data
  if (!scene.dirty) {
    Lib.extendFlat(scene, resetOpts);
  }
  return scene;
};

/***/ }),

/***/ 17168:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var subTypes = __webpack_require__(64726);
var styleTextSelection = (__webpack_require__(85686).styleTextSelection);
module.exports = function select(searchInfo, selectionTester) {
  var cd = searchInfo.cd;
  var xa = searchInfo.xaxis;
  var ya = searchInfo.yaxis;
  var selection = [];
  var trace = cd[0].trace;
  var stash = cd[0].t;
  var len = trace._length;
  var x = stash.x;
  var y = stash.y;
  var scene = stash._scene;
  var index = stash.index;
  if (!scene) return selection;
  var hasText = subTypes.hasText(trace);
  var hasMarkers = subTypes.hasMarkers(trace);
  var hasOnlyLines = !hasMarkers && !hasText;
  if (trace.visible !== true || hasOnlyLines) return selection;
  var els = [];
  var unels = [];

  // degenerate polygon does not enable selection
  // filter out points by visible scatter ones
  if (selectionTester !== false && !selectionTester.degenerate) {
    for (var i = 0; i < len; i++) {
      if (selectionTester.contains([stash.xpx[i], stash.ypx[i]], false, i, searchInfo)) {
        els.push(i);
        selection.push({
          pointNumber: i,
          x: xa.c2d(x[i]),
          y: ya.c2d(y[i])
        });
      } else {
        unels.push(i);
      }
    }
  }
  if (hasMarkers) {
    var scatter2d = scene.scatter2d;
    if (!els.length && !unels.length) {
      // reset to base styles when clearing
      var baseOpts = new Array(scene.count);
      baseOpts[index] = scene.markerOptions[index];
      scatter2d.update.apply(scatter2d, baseOpts);
    } else if (!scene.selectBatch[index].length && !scene.unselectBatch[index].length) {
      // set unselected styles on 'context' canvas (if not done already)
      var unselOpts = new Array(scene.count);
      unselOpts[index] = scene.markerUnselectedOptions[index];
      scatter2d.update.apply(scatter2d, unselOpts);
    }
  }
  scene.selectBatch[index] = els;
  scene.unselectBatch[index] = unels;
  if (hasText) {
    styleTextSelection(cd);
  }
  return selection;
};

/***/ }),

/***/ 71388:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var hovertemplateAttrs = (__webpack_require__(3208)/* .hovertemplateAttrs */ .rb);
var texttemplateAttrs = (__webpack_require__(3208)/* .texttemplateAttrs */ .ay);
var makeFillcolorAttr = __webpack_require__(19326);
var scatterGeoAttrs = __webpack_require__(6893);
var scatterAttrs = __webpack_require__(36640);
var mapAttrs = __webpack_require__(8257);
var baseAttrs = __webpack_require__(9829);
var colorScaleAttrs = __webpack_require__(87163);
var extendFlat = (__webpack_require__(93049).extendFlat);
var overrideAll = (__webpack_require__(13582).overrideAll);
var mapLayoutAtributes = __webpack_require__(8257);
var lineAttrs = scatterGeoAttrs.line;
var markerAttrs = scatterGeoAttrs.marker;
module.exports = overrideAll({
  lon: scatterGeoAttrs.lon,
  lat: scatterGeoAttrs.lat,
  cluster: {
    enabled: {
      valType: 'boolean'
    },
    maxzoom: extendFlat({}, mapLayoutAtributes.layers.maxzoom, {}),
    step: {
      valType: 'number',
      arrayOk: true,
      dflt: -1,
      min: -1
    },
    size: {
      valType: 'number',
      arrayOk: true,
      dflt: 20,
      min: 0
    },
    color: {
      valType: 'color',
      arrayOk: true
    },
    opacity: extendFlat({}, markerAttrs.opacity, {
      dflt: 1
    })
  },
  // locations
  // locationmode

  mode: extendFlat({}, scatterAttrs.mode, {
    dflt: 'markers'
  }),
  text: extendFlat({}, scatterAttrs.text, {}),
  texttemplate: texttemplateAttrs({
    editType: 'plot'
  }, {
    keys: ['lat', 'lon', 'text']
  }),
  hovertext: extendFlat({}, scatterAttrs.hovertext, {}),
  line: {
    color: lineAttrs.color,
    width: lineAttrs.width

    // TODO
    // dash: dash
  },
  connectgaps: scatterAttrs.connectgaps,
  marker: extendFlat({
    symbol: {
      valType: 'string',
      dflt: 'circle',
      arrayOk: true
    },
    angle: {
      valType: 'number',
      dflt: 'auto',
      arrayOk: true
    },
    allowoverlap: {
      valType: 'boolean',
      dflt: false
    },
    opacity: markerAttrs.opacity,
    size: markerAttrs.size,
    sizeref: markerAttrs.sizeref,
    sizemin: markerAttrs.sizemin,
    sizemode: markerAttrs.sizemode
  }, colorScaleAttrs('marker')
  // line
  ),
  fill: scatterGeoAttrs.fill,
  fillcolor: makeFillcolorAttr(),
  textfont: mapAttrs.layers.symbol.textfont,
  textposition: mapAttrs.layers.symbol.textposition,
  below: {
    valType: 'string'
  },
  selected: {
    marker: scatterAttrs.selected.marker
  },
  unselected: {
    marker: scatterAttrs.unselected.marker
  },
  hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
    flags: ['lon', 'lat', 'text', 'name']
  }),
  hovertemplate: hovertemplateAttrs()
}, 'calc', 'nested');

/***/ }),

/***/ 13624:
/***/ (function(module) {

"use strict";


// Must use one of the following fonts as the family, else default to 'Open Sans Regular'
// See https://github.com/openmaptiles/fonts/blob/gh-pages/fontstacks.json
var supportedFonts = ['Metropolis Black Italic', 'Metropolis Black', 'Metropolis Bold Italic', 'Metropolis Bold', 'Metropolis Extra Bold Italic', 'Metropolis Extra Bold', 'Metropolis Extra Light Italic', 'Metropolis Extra Light', 'Metropolis Light Italic', 'Metropolis Light', 'Metropolis Medium Italic', 'Metropolis Medium', 'Metropolis Regular Italic', 'Metropolis Regular', 'Metropolis Semi Bold Italic', 'Metropolis Semi Bold', 'Metropolis Thin Italic', 'Metropolis Thin', 'Open Sans Bold Italic', 'Open Sans Bold', 'Open Sans Extrabold Italic', 'Open Sans Extrabold', 'Open Sans Italic', 'Open Sans Light Italic', 'Open Sans Light', 'Open Sans Regular', 'Open Sans Semibold Italic', 'Open Sans Semibold', 'Klokantech Noto Sans Bold', 'Klokantech Noto Sans CJK Bold', 'Klokantech Noto Sans CJK Regular', 'Klokantech Noto Sans Italic', 'Klokantech Noto Sans Regular'];
module.exports = {
  isSupportedFont: function (a) {
    return supportedFonts.indexOf(a) !== -1;
  }
};

/***/ }),

/***/ 76717:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isNumeric = __webpack_require__(10721);
var Lib = __webpack_require__(34809);
var BADNUM = (__webpack_require__(63821).BADNUM);
var geoJsonUtils = __webpack_require__(39532);
var Colorscale = __webpack_require__(88856);
var Drawing = __webpack_require__(62203);
var makeBubbleSizeFn = __webpack_require__(92527);
var subTypes = __webpack_require__(64726);
var isSupportedFont = (__webpack_require__(13624).isSupportedFont);
var convertTextOpts = __webpack_require__(4657);
var appendArrayPointValue = (__webpack_require__(36040).appendArrayPointValue);
var NEWLINES = (__webpack_require__(30635).NEWLINES);
var BR_TAG_ALL = (__webpack_require__(30635).BR_TAG_ALL);
module.exports = function convert(gd, calcTrace) {
  var trace = calcTrace[0].trace;
  var isVisible = trace.visible === true && trace._length !== 0;
  var hasFill = trace.fill !== 'none';
  var hasLines = subTypes.hasLines(trace);
  var hasMarkers = subTypes.hasMarkers(trace);
  var hasText = subTypes.hasText(trace);
  var hasCircles = hasMarkers && trace.marker.symbol === 'circle';
  var hasSymbols = hasMarkers && trace.marker.symbol !== 'circle';
  var hasCluster = trace.cluster && trace.cluster.enabled;
  var fill = initContainer('fill');
  var line = initContainer('line');
  var circle = initContainer('circle');
  var symbol = initContainer('symbol');
  var opts = {
    fill: fill,
    line: line,
    circle: circle,
    symbol: symbol
  };

  // early return if not visible or placeholder
  if (!isVisible) return opts;

  // fill layer and line layer use the same coords
  var lineCoords;
  if (hasFill || hasLines) {
    lineCoords = geoJsonUtils.calcTraceToLineCoords(calcTrace);
  }
  if (hasFill) {
    fill.geojson = geoJsonUtils.makePolygon(lineCoords);
    fill.layout.visibility = 'visible';
    Lib.extendFlat(fill.paint, {
      'fill-color': trace.fillcolor
    });
  }
  if (hasLines) {
    line.geojson = geoJsonUtils.makeLine(lineCoords);
    line.layout.visibility = 'visible';
    Lib.extendFlat(line.paint, {
      'line-width': trace.line.width,
      'line-color': trace.line.color,
      'line-opacity': trace.opacity
    });

    // TODO convert line.dash into line-dasharray
  }
  if (hasCircles) {
    var circleOpts = makeCircleOpts(calcTrace);
    circle.geojson = circleOpts.geojson;
    circle.layout.visibility = 'visible';
    if (hasCluster) {
      circle.filter = ['!', ['has', 'point_count']];
      opts.cluster = {
        type: 'circle',
        filter: ['has', 'point_count'],
        layout: {
          visibility: 'visible'
        },
        paint: {
          'circle-color': arrayifyAttribute(trace.cluster.color, trace.cluster.step),
          'circle-radius': arrayifyAttribute(trace.cluster.size, trace.cluster.step),
          'circle-opacity': arrayifyAttribute(trace.cluster.opacity, trace.cluster.step)
        }
      };
      opts.clusterCount = {
        type: 'symbol',
        filter: ['has', 'point_count'],
        paint: {},
        layout: {
          'text-field': '{point_count_abbreviated}',
          'text-font': getTextFont(trace),
          'text-size': 12
        }
      };
    }
    Lib.extendFlat(circle.paint, {
      'circle-color': circleOpts.mcc,
      'circle-radius': circleOpts.mrc,
      'circle-opacity': circleOpts.mo
    });
  }
  if (hasCircles && hasCluster) {
    circle.filter = ['!', ['has', 'point_count']];
  }
  if (hasSymbols || hasText) {
    symbol.geojson = makeSymbolGeoJSON(calcTrace, gd);
    Lib.extendFlat(symbol.layout, {
      visibility: 'visible',
      'icon-image': '{symbol}-15',
      'text-field': '{text}'
    });
    if (hasSymbols) {
      Lib.extendFlat(symbol.layout, {
        'icon-size': trace.marker.size / 10
      });
      if ('angle' in trace.marker && trace.marker.angle !== 'auto') {
        Lib.extendFlat(symbol.layout, {
          // unfortunately cant use {angle} do to this issue:
          // https://github.com/mapbox/mapbox-gl-js/issues/873
          'icon-rotate': {
            type: 'identity',
            property: 'angle'
          },
          'icon-rotation-alignment': 'map'
        });
      }
      symbol.layout['icon-allow-overlap'] = trace.marker.allowoverlap;
      Lib.extendFlat(symbol.paint, {
        'icon-opacity': trace.opacity * trace.marker.opacity,
        // TODO does not work ??
        'icon-color': trace.marker.color
      });
    }
    if (hasText) {
      var iconSize = (trace.marker || {}).size;
      var textOpts = convertTextOpts(trace.textposition, iconSize);

      // all data-driven below !!

      Lib.extendFlat(symbol.layout, {
        'text-size': trace.textfont.size,
        'text-anchor': textOpts.anchor,
        'text-offset': textOpts.offset,
        'text-font': getTextFont(trace)
      });
      Lib.extendFlat(symbol.paint, {
        'text-color': trace.textfont.color,
        'text-opacity': trace.opacity
      });
    }
  }
  return opts;
};
function initContainer(type) {
  return {
    type: type,
    geojson: geoJsonUtils.makeBlank(),
    layout: {
      visibility: 'none'
    },
    filter: null,
    paint: {}
  };
}
function makeCircleOpts(calcTrace) {
  var trace = calcTrace[0].trace;
  var marker = trace.marker;
  var selectedpoints = trace.selectedpoints;
  var arrayColor = Lib.isArrayOrTypedArray(marker.color);
  var arraySize = Lib.isArrayOrTypedArray(marker.size);
  var arrayOpacity = Lib.isArrayOrTypedArray(marker.opacity);
  var i;
  function addTraceOpacity(o) {
    return trace.opacity * o;
  }
  function size2radius(s) {
    return s / 2;
  }
  var colorFn;
  if (arrayColor) {
    if (Colorscale.hasColorscale(trace, 'marker')) {
      colorFn = Colorscale.makeColorScaleFuncFromTrace(marker);
    } else {
      colorFn = Lib.identity;
    }
  }
  var sizeFn;
  if (arraySize) {
    sizeFn = makeBubbleSizeFn(trace);
  }
  var opacityFn;
  if (arrayOpacity) {
    opacityFn = function (mo) {
      var mo2 = isNumeric(mo) ? +Lib.constrain(mo, 0, 1) : 0;
      return addTraceOpacity(mo2);
    };
  }
  var features = [];
  for (i = 0; i < calcTrace.length; i++) {
    var calcPt = calcTrace[i];
    var lonlat = calcPt.lonlat;
    if (isBADNUM(lonlat)) continue;
    var props = {};
    if (colorFn) props.mcc = calcPt.mcc = colorFn(calcPt.mc);
    if (sizeFn) props.mrc = calcPt.mrc = sizeFn(calcPt.ms);
    if (opacityFn) props.mo = opacityFn(calcPt.mo);
    if (selectedpoints) props.selected = calcPt.selected || 0;
    features.push({
      type: 'Feature',
      id: i + 1,
      geometry: {
        type: 'Point',
        coordinates: lonlat
      },
      properties: props
    });
  }
  var fns;
  if (selectedpoints) {
    fns = Drawing.makeSelectedPointStyleFns(trace);
    for (i = 0; i < features.length; i++) {
      var d = features[i].properties;
      if (fns.selectedOpacityFn) {
        d.mo = addTraceOpacity(fns.selectedOpacityFn(d));
      }
      if (fns.selectedColorFn) {
        d.mcc = fns.selectedColorFn(d);
      }
      if (fns.selectedSizeFn) {
        d.mrc = fns.selectedSizeFn(d);
      }
    }
  }
  return {
    geojson: {
      type: 'FeatureCollection',
      features: features
    },
    mcc: arrayColor || fns && fns.selectedColorFn ? {
      type: 'identity',
      property: 'mcc'
    } : marker.color,
    mrc: arraySize || fns && fns.selectedSizeFn ? {
      type: 'identity',
      property: 'mrc'
    } : size2radius(marker.size),
    mo: arrayOpacity || fns && fns.selectedOpacityFn ? {
      type: 'identity',
      property: 'mo'
    } : addTraceOpacity(marker.opacity)
  };
}
function makeSymbolGeoJSON(calcTrace, gd) {
  var fullLayout = gd._fullLayout;
  var trace = calcTrace[0].trace;
  var marker = trace.marker || {};
  var symbol = marker.symbol;
  var angle = marker.angle;
  var fillSymbol = symbol !== 'circle' ? getFillFunc(symbol) : blankFillFunc;
  var fillAngle = angle !== 'auto' ? getFillFunc(angle, true) : blankFillFunc;
  var fillText = subTypes.hasText(trace) ? getFillFunc(trace.text) : blankFillFunc;
  var features = [];
  for (var i = 0; i < calcTrace.length; i++) {
    var calcPt = calcTrace[i];
    if (isBADNUM(calcPt.lonlat)) continue;
    var texttemplate = trace.texttemplate;
    var text;
    if (texttemplate) {
      var tt = Array.isArray(texttemplate) ? texttemplate[i] || '' : texttemplate;
      var labels = trace._module.formatLabels(calcPt, trace, fullLayout);
      var pointValues = {};
      appendArrayPointValue(pointValues, trace, calcPt.i);
      var meta = trace._meta || {};
      text = Lib.texttemplateString(tt, labels, fullLayout._d3locale, pointValues, calcPt, meta);
    } else {
      text = fillText(i);
    }
    if (text) {
      text = text.replace(NEWLINES, '').replace(BR_TAG_ALL, '\n');
    }
    features.push({
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: calcPt.lonlat
      },
      properties: {
        symbol: fillSymbol(i),
        angle: fillAngle(i),
        text: text
      }
    });
  }
  return {
    type: 'FeatureCollection',
    features: features
  };
}
function getFillFunc(attr, numeric) {
  if (Lib.isArrayOrTypedArray(attr)) {
    if (numeric) {
      return function (i) {
        return isNumeric(attr[i]) ? +attr[i] : 0;
      };
    }
    return function (i) {
      return attr[i];
    };
  } else if (attr) {
    return function () {
      return attr;
    };
  } else {
    return blankFillFunc;
  }
}
function blankFillFunc() {
  return '';
}

// only need to check lon (OR lat)
function isBADNUM(lonlat) {
  return lonlat[0] === BADNUM;
}
function arrayifyAttribute(values, step) {
  var newAttribute;
  if (Lib.isArrayOrTypedArray(values) && Lib.isArrayOrTypedArray(step)) {
    newAttribute = ['step', ['get', 'point_count'], values[0]];
    for (var idx = 1; idx < values.length; idx++) {
      newAttribute.push(step[idx - 1], values[idx]);
    }
  } else {
    newAttribute = values;
  }
  return newAttribute;
}
function getTextFont(trace) {
  var font = trace.textfont;
  var family = font.family;
  var style = font.style;
  var weight = font.weight;
  var parts = family.split(' ');
  var isItalic = parts[parts.length - 1] === 'Italic';
  if (isItalic) parts.pop();
  isItalic = isItalic || style === 'italic';
  var str = parts.join(' ');
  if (weight === 'bold' && parts.indexOf('Bold') === -1) {
    str += ' Bold';
  } else if (weight <= 1000) {
    // numeric font-weight
    // See supportedFonts

    if (parts[0] === 'Metropolis') {
      str = 'Metropolis';
      if (weight > 850) str += ' Black';else if (weight > 750) str += ' Extra Bold';else if (weight > 650) str += ' Bold';else if (weight > 550) str += ' Semi Bold';else if (weight > 450) str += ' Medium';else if (weight > 350) str += ' Regular';else if (weight > 250) str += ' Light';else if (weight > 150) str += ' Extra Light';else str += ' Thin';
    } else if (parts.slice(0, 2).join(' ') === 'Open Sans') {
      str = 'Open Sans';
      if (weight > 750) str += ' Extrabold';else if (weight > 650) str += ' Bold';else if (weight > 550) str += ' Semibold';else if (weight > 350) str += ' Regular';else str += ' Light';
    } else if (parts.slice(0, 3).join(' ') === 'Klokantech Noto Sans') {
      str = 'Klokantech Noto Sans';
      if (parts[3] === 'CJK') str += ' CJK';
      str += weight > 500 ? ' Bold' : ' Regular';
    }
  }
  if (isItalic) str += ' Italic';
  if (str === 'Open Sans Regular Italic') str = 'Open Sans Italic';else if (str === 'Open Sans Regular Bold') str = 'Open Sans Bold';else if (str === 'Open Sans Regular Bold Italic') str = 'Open Sans Bold Italic';else if (str === 'Klokantech Noto Sans Regular Italic') str = 'Klokantech Noto Sans Italic';

  // Ensure the result is a supported font
  if (!isSupportedFont(str)) {
    str = family;
  }
  var textFont = str.split(', ');
  return textFont;
}

/***/ }),

/***/ 57387:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var subTypes = __webpack_require__(64726);
var handleMarkerDefaults = __webpack_require__(24272);
var handleLineDefaults = __webpack_require__(98168);
var handleTextDefaults = __webpack_require__(663);
var handleFillColorDefaults = __webpack_require__(54114);
var attributes = __webpack_require__(71388);
var isSupportedFont = (__webpack_require__(13624).isSupportedFont);
module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
  function coerce(attr, dflt) {
    return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
  }
  function coerce2(attr, dflt) {
    return Lib.coerce2(traceIn, traceOut, attributes, attr, dflt);
  }
  var len = handleLonLatDefaults(traceIn, traceOut, coerce);
  if (!len) {
    traceOut.visible = false;
    return;
  }
  coerce('text');
  coerce('texttemplate');
  coerce('hovertext');
  coerce('hovertemplate');
  coerce('mode');
  coerce('below');
  if (subTypes.hasMarkers(traceOut)) {
    handleMarkerDefaults(traceIn, traceOut, defaultColor, layout, coerce, {
      noLine: true,
      noAngle: true
    });
    coerce('marker.allowoverlap');
    coerce('marker.angle');

    // array marker.size and marker.color are only supported with circles
    var marker = traceOut.marker;
    if (marker.symbol !== 'circle') {
      if (Lib.isArrayOrTypedArray(marker.size)) marker.size = marker.size[0];
      if (Lib.isArrayOrTypedArray(marker.color)) marker.color = marker.color[0];
    }
  }
  if (subTypes.hasLines(traceOut)) {
    handleLineDefaults(traceIn, traceOut, defaultColor, layout, coerce, {
      noDash: true
    });
    coerce('connectgaps');
  }
  var clusterMaxzoom = coerce2('cluster.maxzoom');
  var clusterStep = coerce2('cluster.step');
  var clusterColor = coerce2('cluster.color', traceOut.marker && traceOut.marker.color || defaultColor);
  var clusterSize = coerce2('cluster.size');
  var clusterOpacity = coerce2('cluster.opacity');
  var clusterEnabledDflt = clusterMaxzoom !== false || clusterStep !== false || clusterColor !== false || clusterSize !== false || clusterOpacity !== false;
  var clusterEnabled = coerce('cluster.enabled', clusterEnabledDflt);
  if (clusterEnabled || subTypes.hasText(traceOut)) {
    var layoutFontFamily = layout.font.family;
    handleTextDefaults(traceIn, traceOut, layout, coerce, {
      noSelect: true,
      noFontVariant: true,
      noFontShadow: true,
      noFontLineposition: true,
      noFontTextcase: true,
      font: {
        family: isSupportedFont(layoutFontFamily) ? layoutFontFamily : 'Open Sans Regular',
        weight: layout.font.weight,
        style: layout.font.style,
        size: layout.font.size,
        color: layout.font.color
      }
    });
  }
  coerce('fill');
  if (traceOut.fill !== 'none') {
    handleFillColorDefaults(traceIn, traceOut, defaultColor, coerce);
  }
  Lib.coerceSelectionMarkerOpacity(traceOut, coerce);
};
function handleLonLatDefaults(traceIn, traceOut, coerce) {
  var lon = coerce('lon') || [];
  var lat = coerce('lat') || [];
  var len = Math.min(lon.length, lat.length);
  traceOut._length = len;
  return len;
}

/***/ }),

/***/ 58240:
/***/ (function(module) {

"use strict";


module.exports = function eventData(out, pt) {
  out.lon = pt.lon;
  out.lat = pt.lat;
  return out;
};

/***/ }),

/***/ 66762:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Axes = __webpack_require__(29714);
module.exports = function formatLabels(cdi, trace, fullLayout) {
  var labels = {};
  var subplot = fullLayout[trace.subplot]._subplot;
  var ax = subplot.mockAxis;
  var lonlat = cdi.lonlat;
  labels.lonLabel = Axes.tickText(ax, ax.c2l(lonlat[0]), true).text;
  labels.latLabel = Axes.tickText(ax, ax.c2l(lonlat[1]), true).text;
  return labels;
};

/***/ }),

/***/ 67275:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Fx = __webpack_require__(32141);
var Lib = __webpack_require__(34809);
var getTraceColor = __webpack_require__(11539);
var fillText = Lib.fillText;
var BADNUM = (__webpack_require__(63821).BADNUM);
var LAYER_PREFIX = (__webpack_require__(8814).traceLayerPrefix);
function hoverPoints(pointData, xval, yval) {
  var cd = pointData.cd;
  var trace = cd[0].trace;
  var xa = pointData.xa;
  var ya = pointData.ya;
  var subplot = pointData.subplot;
  var clusteredPointsIds = [];
  var layer = LAYER_PREFIX + trace.uid + '-circle';
  var hasCluster = trace.cluster && trace.cluster.enabled;
  if (hasCluster) {
    var elems = subplot.map.queryRenderedFeatures(null, {
      layers: [layer]
    });
    clusteredPointsIds = elems.map(function (elem) {
      return elem.id;
    });
  }

  // compute winding number about [-180, 180] globe
  var winding = xval >= 0 ? Math.floor((xval + 180) / 360) : Math.ceil((xval - 180) / 360);

  // shift longitude to [-180, 180] to determine closest point
  var lonShift = winding * 360;
  var xval2 = xval - lonShift;
  function distFn(d) {
    var lonlat = d.lonlat;
    if (lonlat[0] === BADNUM) return Infinity;
    if (hasCluster && clusteredPointsIds.indexOf(d.i + 1) === -1) return Infinity;
    var lon = Lib.modHalf(lonlat[0], 360);
    var lat = lonlat[1];
    var pt = subplot.project([lon, lat]);
    var dx = pt.x - xa.c2p([xval2, lat]);
    var dy = pt.y - ya.c2p([lon, yval]);
    var rad = Math.max(3, d.mrc || 0);
    return Math.max(Math.sqrt(dx * dx + dy * dy) - rad, 1 - 3 / rad);
  }
  Fx.getClosest(cd, distFn, pointData);

  // skip the rest (for this trace) if we didn't find a close point
  if (pointData.index === false) return;
  var di = cd[pointData.index];
  var lonlat = di.lonlat;
  var lonlatShifted = [Lib.modHalf(lonlat[0], 360) + lonShift, lonlat[1]];

  // shift labels back to original winded globe
  var xc = xa.c2p(lonlatShifted);
  var yc = ya.c2p(lonlatShifted);
  var rad = di.mrc || 1;
  pointData.x0 = xc - rad;
  pointData.x1 = xc + rad;
  pointData.y0 = yc - rad;
  pointData.y1 = yc + rad;
  var fullLayout = {};
  fullLayout[trace.subplot] = {
    _subplot: subplot
  };
  var labels = trace._module.formatLabels(di, trace, fullLayout);
  pointData.lonLabel = labels.lonLabel;
  pointData.latLabel = labels.latLabel;
  pointData.color = getTraceColor(trace, di);
  pointData.extraText = getExtraText(trace, di, cd[0].t.labels);
  pointData.hovertemplate = trace.hovertemplate;
  return [pointData];
}
function getExtraText(trace, di, labels) {
  if (trace.hovertemplate) return;
  var hoverinfo = di.hi || trace.hoverinfo;
  var parts = hoverinfo.split('+');
  var isAll = parts.indexOf('all') !== -1;
  var hasLon = parts.indexOf('lon') !== -1;
  var hasLat = parts.indexOf('lat') !== -1;
  var lonlat = di.lonlat;
  var text = [];

  // TODO should we use a mock axis to format hover?
  // If so, we'll need to make precision be zoom-level dependent
  function format(v) {
    return v + '\u00B0';
  }
  if (isAll || hasLon && hasLat) {
    text.push('(' + format(lonlat[1]) + ', ' + format(lonlat[0]) + ')');
  } else if (hasLon) {
    text.push(labels.lon + format(lonlat[0]));
  } else if (hasLat) {
    text.push(labels.lat + format(lonlat[1]));
  }
  if (isAll || parts.indexOf('text') !== -1) {
    fillText(di, trace, text);
  }
  return text.join('<br>');
}
module.exports = {
  hoverPoints: hoverPoints,
  getExtraText: getExtraText
};

/***/ }),

/***/ 30929:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = {
  attributes: __webpack_require__(71388),
  supplyDefaults: __webpack_require__(57387),
  colorbar: __webpack_require__(21146),
  formatLabels: __webpack_require__(66762),
  calc: __webpack_require__(75649),
  plot: __webpack_require__(26126),
  hoverPoints: (__webpack_require__(67275).hoverPoints),
  eventData: __webpack_require__(58240),
  selectPoints: __webpack_require__(21501),
  styleOnSelect: function (_, cd) {
    if (cd) {
      var trace = cd[0].trace;
      trace._glTrace.update(cd);
    }
  },
  moduleType: 'trace',
  name: 'scattermap',
  basePlotModule: __webpack_require__(34091),
  categories: ['map', 'gl', 'symbols', 'showLegend', 'scatter-like'],
  meta: {}
};

/***/ }),

/***/ 26126:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var convert = __webpack_require__(76717);
var LAYER_PREFIX = (__webpack_require__(8814).traceLayerPrefix);
var ORDER = {
  cluster: ['cluster', 'clusterCount', 'circle'],
  nonCluster: ['fill', 'line', 'circle', 'symbol']
};
function ScatterMap(subplot, uid, clusterEnabled, isHidden) {
  this.type = 'scattermap';
  this.subplot = subplot;
  this.uid = uid;
  this.clusterEnabled = clusterEnabled;
  this.isHidden = isHidden;
  this.sourceIds = {
    fill: 'source-' + uid + '-fill',
    line: 'source-' + uid + '-line',
    circle: 'source-' + uid + '-circle',
    symbol: 'source-' + uid + '-symbol',
    cluster: 'source-' + uid + '-circle',
    clusterCount: 'source-' + uid + '-circle'
  };
  this.layerIds = {
    fill: LAYER_PREFIX + uid + '-fill',
    line: LAYER_PREFIX + uid + '-line',
    circle: LAYER_PREFIX + uid + '-circle',
    symbol: LAYER_PREFIX + uid + '-symbol',
    cluster: LAYER_PREFIX + uid + '-cluster',
    clusterCount: LAYER_PREFIX + uid + '-cluster-count'
  };

  // We could merge the 'fill' source with the 'line' source and
  // the 'circle' source with the 'symbol' source if ever having
  // for up-to 4 sources per 'scattermap' traces becomes a problem.

  // previous 'below' value,
  // need this to update it properly
  this.below = null;
}
var proto = ScatterMap.prototype;
proto.addSource = function (k, opts, cluster) {
  var sourceOpts = {
    type: 'geojson',
    data: opts.geojson
  };
  if (cluster && cluster.enabled) {
    Lib.extendFlat(sourceOpts, {
      cluster: true,
      clusterMaxZoom: cluster.maxzoom
    });
  }
  var isSourceExists = this.subplot.map.getSource(this.sourceIds[k]);
  if (isSourceExists) {
    isSourceExists.setData(opts.geojson);
  } else {
    this.subplot.map.addSource(this.sourceIds[k], sourceOpts);
  }
};
proto.setSourceData = function (k, opts) {
  this.subplot.map.getSource(this.sourceIds[k]).setData(opts.geojson);
};
proto.addLayer = function (k, opts, below) {
  var source = {
    type: opts.type,
    id: this.layerIds[k],
    source: this.sourceIds[k],
    layout: opts.layout,
    paint: opts.paint
  };
  if (opts.filter) {
    source.filter = opts.filter;
  }
  var currentLayerId = this.layerIds[k];
  var layerExist;
  var layers = this.subplot.getMapLayers();
  for (var i = 0; i < layers.length; i++) {
    if (layers[i].id === currentLayerId) {
      layerExist = true;
      break;
    }
  }
  if (layerExist) {
    this.subplot.setOptions(currentLayerId, 'setLayoutProperty', source.layout);
    if (source.layout.visibility === 'visible') {
      this.subplot.setOptions(currentLayerId, 'setPaintProperty', source.paint);
    }
  } else {
    this.subplot.addLayer(source, below);
  }
};
proto.update = function update(calcTrace) {
  var trace = calcTrace[0].trace;
  var subplot = this.subplot;
  var map = subplot.map;
  var optsAll = convert(subplot.gd, calcTrace);
  var below = subplot.belowLookup['trace-' + this.uid];
  var hasCluster = !!(trace.cluster && trace.cluster.enabled);
  var hadCluster = !!this.clusterEnabled;
  var lThis = this;
  function addCluster(noSource) {
    if (!noSource) lThis.addSource('circle', optsAll.circle, trace.cluster);
    var order = ORDER.cluster;
    for (var i = 0; i < order.length; i++) {
      var k = order[i];
      var opts = optsAll[k];
      lThis.addLayer(k, opts, below);
    }
  }
  function removeCluster(noSource) {
    var order = ORDER.cluster;
    for (var i = order.length - 1; i >= 0; i--) {
      var k = order[i];
      map.removeLayer(lThis.layerIds[k]);
    }
    if (!noSource) map.removeSource(lThis.sourceIds.circle);
  }
  function addNonCluster(noSource) {
    var order = ORDER.nonCluster;
    for (var i = 0; i < order.length; i++) {
      var k = order[i];
      var opts = optsAll[k];
      if (!noSource) lThis.addSource(k, opts);
      lThis.addLayer(k, opts, below);
    }
  }
  function removeNonCluster(noSource) {
    var order = ORDER.nonCluster;
    for (var i = order.length - 1; i >= 0; i--) {
      var k = order[i];
      map.removeLayer(lThis.layerIds[k]);
      if (!noSource) map.removeSource(lThis.sourceIds[k]);
    }
  }
  function remove(noSource) {
    if (hadCluster) removeCluster(noSource);else removeNonCluster(noSource);
  }
  function add(noSource) {
    if (hasCluster) addCluster(noSource);else addNonCluster(noSource);
  }
  function repaint() {
    var order = hasCluster ? ORDER.cluster : ORDER.nonCluster;
    for (var i = 0; i < order.length; i++) {
      var k = order[i];
      var opts = optsAll[k];
      if (!opts) continue;
      subplot.setOptions(lThis.layerIds[k], 'setLayoutProperty', opts.layout);
      if (opts.layout.visibility === 'visible') {
        if (k !== 'cluster') {
          lThis.setSourceData(k, opts);
        }
        subplot.setOptions(lThis.layerIds[k], 'setPaintProperty', opts.paint);
      }
    }
  }
  var wasHidden = this.isHidden;
  var isHidden = trace.visible !== true;
  if (isHidden) {
    if (!wasHidden) remove();
  } else if (wasHidden) {
    if (!isHidden) add();
  } else if (hadCluster !== hasCluster) {
    remove();
    add();
  } else if (this.below !== below) {
    remove(true);
    add(true);
    repaint();
  } else {
    repaint();
  }
  this.clusterEnabled = hasCluster;
  this.isHidden = isHidden;
  this.below = below;

  // link ref for quick update during selections
  calcTrace[0].trace._glTrace = this;
};
proto.dispose = function dispose() {
  var map = this.subplot.map;
  var order = this.clusterEnabled ? ORDER.cluster : ORDER.nonCluster;
  for (var i = order.length - 1; i >= 0; i--) {
    var k = order[i];
    map.removeLayer(this.layerIds[k]);
    map.removeSource(this.sourceIds[k]);
  }
};
module.exports = function createScatterMap(subplot, calcTrace) {
  var trace = calcTrace[0].trace;
  var hasCluster = trace.cluster && trace.cluster.enabled;
  var isHidden = trace.visible !== true;
  var scatterMap = new ScatterMap(subplot, trace.uid, hasCluster, isHidden);
  var optsAll = convert(subplot.gd, calcTrace);
  var below = scatterMap.below = subplot.belowLookup['trace-' + trace.uid];
  var i, k, opts;
  if (hasCluster) {
    scatterMap.addSource('circle', optsAll.circle, trace.cluster);
    for (i = 0; i < ORDER.cluster.length; i++) {
      k = ORDER.cluster[i];
      opts = optsAll[k];
      scatterMap.addLayer(k, opts, below);
    }
  } else {
    for (i = 0; i < ORDER.nonCluster.length; i++) {
      k = ORDER.nonCluster[i];
      opts = optsAll[k];
      scatterMap.addSource(k, opts, trace.cluster);
      scatterMap.addLayer(k, opts, below);
    }
  }

  // link ref for quick update during selections
  calcTrace[0].trace._glTrace = scatterMap;
  return scatterMap;
};

/***/ }),

/***/ 21501:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var subtypes = __webpack_require__(64726);
var BADNUM = (__webpack_require__(63821).BADNUM);
module.exports = function selectPoints(searchInfo, selectionTester) {
  var cd = searchInfo.cd;
  var xa = searchInfo.xaxis;
  var ya = searchInfo.yaxis;
  var selection = [];
  var trace = cd[0].trace;
  var i;
  if (!subtypes.hasMarkers(trace)) return [];
  if (selectionTester === false) {
    for (i = 0; i < cd.length; i++) {
      cd[i].selected = 0;
    }
  } else {
    for (i = 0; i < cd.length; i++) {
      var di = cd[i];
      var lonlat = di.lonlat;
      if (lonlat[0] !== BADNUM) {
        var lonlat2 = [Lib.modHalf(lonlat[0], 360), lonlat[1]];
        var xy = [xa.c2p(lonlat2), ya.c2p(lonlat2)];
        if (selectionTester.contains(xy, null, i, searchInfo)) {
          selection.push({
            pointNumber: i,
            lon: lonlat[0],
            lat: lonlat[1]
          });
          di.selected = 1;
        } else {
          di.selected = 0;
        }
      }
    }
  }
  return selection;
};

/***/ }),

/***/ 95833:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var hovertemplateAttrs = (__webpack_require__(3208)/* .hovertemplateAttrs */ .rb);
var texttemplateAttrs = (__webpack_require__(3208)/* .texttemplateAttrs */ .ay);
var makeFillcolorAttr = __webpack_require__(19326);
var scatterGeoAttrs = __webpack_require__(6893);
var scatterAttrs = __webpack_require__(36640);
var mapboxAttrs = __webpack_require__(67514);
var baseAttrs = __webpack_require__(9829);
var colorScaleAttrs = __webpack_require__(87163);
var extendFlat = (__webpack_require__(93049).extendFlat);
var overrideAll = (__webpack_require__(13582).overrideAll);
var mapboxLayoutAtributes = __webpack_require__(67514);
var lineAttrs = scatterGeoAttrs.line;
var markerAttrs = scatterGeoAttrs.marker;
module.exports = overrideAll({
  lon: scatterGeoAttrs.lon,
  lat: scatterGeoAttrs.lat,
  cluster: {
    enabled: {
      valType: 'boolean'
    },
    maxzoom: extendFlat({}, mapboxLayoutAtributes.layers.maxzoom, {}),
    step: {
      valType: 'number',
      arrayOk: true,
      dflt: -1,
      min: -1
    },
    size: {
      valType: 'number',
      arrayOk: true,
      dflt: 20,
      min: 0
    },
    color: {
      valType: 'color',
      arrayOk: true
    },
    opacity: extendFlat({}, markerAttrs.opacity, {
      dflt: 1
    })
  },
  // locations
  // locationmode

  mode: extendFlat({}, scatterAttrs.mode, {
    dflt: 'markers'
  }),
  text: extendFlat({}, scatterAttrs.text, {}),
  texttemplate: texttemplateAttrs({
    editType: 'plot'
  }, {
    keys: ['lat', 'lon', 'text']
  }),
  hovertext: extendFlat({}, scatterAttrs.hovertext, {}),
  line: {
    color: lineAttrs.color,
    width: lineAttrs.width

    // TODO
    // dash: dash
  },
  connectgaps: scatterAttrs.connectgaps,
  marker: extendFlat({
    symbol: {
      valType: 'string',
      dflt: 'circle',
      arrayOk: true
    },
    angle: {
      valType: 'number',
      dflt: 'auto',
      arrayOk: true
    },
    allowoverlap: {
      valType: 'boolean',
      dflt: false
    },
    opacity: markerAttrs.opacity,
    size: markerAttrs.size,
    sizeref: markerAttrs.sizeref,
    sizemin: markerAttrs.sizemin,
    sizemode: markerAttrs.sizemode
  }, colorScaleAttrs('marker')
  // line
  ),
  fill: scatterGeoAttrs.fill,
  fillcolor: makeFillcolorAttr(),
  textfont: mapboxAttrs.layers.symbol.textfont,
  textposition: mapboxAttrs.layers.symbol.textposition,
  below: {
    valType: 'string'
  },
  selected: {
    marker: scatterAttrs.selected.marker
  },
  unselected: {
    marker: scatterAttrs.unselected.marker
  },
  hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
    flags: ['lon', 'lat', 'text', 'name']
  }),
  hovertemplate: hovertemplateAttrs()
}, 'calc', 'nested');

/***/ }),

/***/ 2795:
/***/ (function(module) {

"use strict";


// Must use one of the following fonts as the family, else default to 'Open Sans Regular'
// See https://github.com/openmaptiles/fonts/blob/gh-pages/fontstacks.json
var supportedFonts = ['Metropolis Black Italic', 'Metropolis Black', 'Metropolis Bold Italic', 'Metropolis Bold', 'Metropolis Extra Bold Italic', 'Metropolis Extra Bold', 'Metropolis Extra Light Italic', 'Metropolis Extra Light', 'Metropolis Light Italic', 'Metropolis Light', 'Metropolis Medium Italic', 'Metropolis Medium', 'Metropolis Regular Italic', 'Metropolis Regular', 'Metropolis Semi Bold Italic', 'Metropolis Semi Bold', 'Metropolis Thin Italic', 'Metropolis Thin', 'Open Sans Bold Italic', 'Open Sans Bold', 'Open Sans Extrabold Italic', 'Open Sans Extrabold', 'Open Sans Italic', 'Open Sans Light Italic', 'Open Sans Light', 'Open Sans Regular', 'Open Sans Semibold Italic', 'Open Sans Semibold', 'Klokantech Noto Sans Bold', 'Klokantech Noto Sans CJK Bold', 'Klokantech Noto Sans CJK Regular', 'Klokantech Noto Sans Italic', 'Klokantech Noto Sans Regular'];
module.exports = {
  isSupportedFont: function (a) {
    return supportedFonts.indexOf(a) !== -1;
  }
};

/***/ }),

/***/ 27009:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isNumeric = __webpack_require__(10721);
var Lib = __webpack_require__(34809);
var BADNUM = (__webpack_require__(63821).BADNUM);
var geoJsonUtils = __webpack_require__(39532);
var Colorscale = __webpack_require__(88856);
var Drawing = __webpack_require__(62203);
var makeBubbleSizeFn = __webpack_require__(92527);
var subTypes = __webpack_require__(64726);
var isSupportedFont = (__webpack_require__(2795).isSupportedFont);
var convertTextOpts = __webpack_require__(2178);
var appendArrayPointValue = (__webpack_require__(36040).appendArrayPointValue);
var NEWLINES = (__webpack_require__(30635).NEWLINES);
var BR_TAG_ALL = (__webpack_require__(30635).BR_TAG_ALL);
module.exports = function convert(gd, calcTrace) {
  var trace = calcTrace[0].trace;
  var isVisible = trace.visible === true && trace._length !== 0;
  var hasFill = trace.fill !== 'none';
  var hasLines = subTypes.hasLines(trace);
  var hasMarkers = subTypes.hasMarkers(trace);
  var hasText = subTypes.hasText(trace);
  var hasCircles = hasMarkers && trace.marker.symbol === 'circle';
  var hasSymbols = hasMarkers && trace.marker.symbol !== 'circle';
  var hasCluster = trace.cluster && trace.cluster.enabled;
  var fill = initContainer('fill');
  var line = initContainer('line');
  var circle = initContainer('circle');
  var symbol = initContainer('symbol');
  var opts = {
    fill: fill,
    line: line,
    circle: circle,
    symbol: symbol
  };

  // early return if not visible or placeholder
  if (!isVisible) return opts;

  // fill layer and line layer use the same coords
  var lineCoords;
  if (hasFill || hasLines) {
    lineCoords = geoJsonUtils.calcTraceToLineCoords(calcTrace);
  }
  if (hasFill) {
    fill.geojson = geoJsonUtils.makePolygon(lineCoords);
    fill.layout.visibility = 'visible';
    Lib.extendFlat(fill.paint, {
      'fill-color': trace.fillcolor
    });
  }
  if (hasLines) {
    line.geojson = geoJsonUtils.makeLine(lineCoords);
    line.layout.visibility = 'visible';
    Lib.extendFlat(line.paint, {
      'line-width': trace.line.width,
      'line-color': trace.line.color,
      'line-opacity': trace.opacity
    });

    // TODO convert line.dash into line-dasharray
  }
  if (hasCircles) {
    var circleOpts = makeCircleOpts(calcTrace);
    circle.geojson = circleOpts.geojson;
    circle.layout.visibility = 'visible';
    if (hasCluster) {
      circle.filter = ['!', ['has', 'point_count']];
      opts.cluster = {
        type: 'circle',
        filter: ['has', 'point_count'],
        layout: {
          visibility: 'visible'
        },
        paint: {
          'circle-color': arrayifyAttribute(trace.cluster.color, trace.cluster.step),
          'circle-radius': arrayifyAttribute(trace.cluster.size, trace.cluster.step),
          'circle-opacity': arrayifyAttribute(trace.cluster.opacity, trace.cluster.step)
        }
      };
      opts.clusterCount = {
        type: 'symbol',
        filter: ['has', 'point_count'],
        paint: {},
        layout: {
          'text-field': '{point_count_abbreviated}',
          'text-font': getTextFont(trace),
          'text-size': 12
        }
      };
    }
    Lib.extendFlat(circle.paint, {
      'circle-color': circleOpts.mcc,
      'circle-radius': circleOpts.mrc,
      'circle-opacity': circleOpts.mo
    });
  }
  if (hasCircles && hasCluster) {
    circle.filter = ['!', ['has', 'point_count']];
  }
  if (hasSymbols || hasText) {
    symbol.geojson = makeSymbolGeoJSON(calcTrace, gd);
    Lib.extendFlat(symbol.layout, {
      visibility: 'visible',
      'icon-image': '{symbol}-15',
      'text-field': '{text}'
    });
    if (hasSymbols) {
      Lib.extendFlat(symbol.layout, {
        'icon-size': trace.marker.size / 10
      });
      if ('angle' in trace.marker && trace.marker.angle !== 'auto') {
        Lib.extendFlat(symbol.layout, {
          // unfortunately cant use {angle} do to this issue:
          // https://github.com/mapbox/mapbox-gl-js/issues/873
          'icon-rotate': {
            type: 'identity',
            property: 'angle'
          },
          'icon-rotation-alignment': 'map'
        });
      }
      symbol.layout['icon-allow-overlap'] = trace.marker.allowoverlap;
      Lib.extendFlat(symbol.paint, {
        'icon-opacity': trace.opacity * trace.marker.opacity,
        // TODO does not work ??
        'icon-color': trace.marker.color
      });
    }
    if (hasText) {
      var iconSize = (trace.marker || {}).size;
      var textOpts = convertTextOpts(trace.textposition, iconSize);

      // all data-driven below !!

      Lib.extendFlat(symbol.layout, {
        'text-size': trace.textfont.size,
        'text-anchor': textOpts.anchor,
        'text-offset': textOpts.offset,
        'text-font': getTextFont(trace)
      });
      Lib.extendFlat(symbol.paint, {
        'text-color': trace.textfont.color,
        'text-opacity': trace.opacity
      });
    }
  }
  return opts;
};
function initContainer(type) {
  return {
    type: type,
    geojson: geoJsonUtils.makeBlank(),
    layout: {
      visibility: 'none'
    },
    filter: null,
    paint: {}
  };
}
function makeCircleOpts(calcTrace) {
  var trace = calcTrace[0].trace;
  var marker = trace.marker;
  var selectedpoints = trace.selectedpoints;
  var arrayColor = Lib.isArrayOrTypedArray(marker.color);
  var arraySize = Lib.isArrayOrTypedArray(marker.size);
  var arrayOpacity = Lib.isArrayOrTypedArray(marker.opacity);
  var i;
  function addTraceOpacity(o) {
    return trace.opacity * o;
  }
  function size2radius(s) {
    return s / 2;
  }
  var colorFn;
  if (arrayColor) {
    if (Colorscale.hasColorscale(trace, 'marker')) {
      colorFn = Colorscale.makeColorScaleFuncFromTrace(marker);
    } else {
      colorFn = Lib.identity;
    }
  }
  var sizeFn;
  if (arraySize) {
    sizeFn = makeBubbleSizeFn(trace);
  }
  var opacityFn;
  if (arrayOpacity) {
    opacityFn = function (mo) {
      var mo2 = isNumeric(mo) ? +Lib.constrain(mo, 0, 1) : 0;
      return addTraceOpacity(mo2);
    };
  }
  var features = [];
  for (i = 0; i < calcTrace.length; i++) {
    var calcPt = calcTrace[i];
    var lonlat = calcPt.lonlat;
    if (isBADNUM(lonlat)) continue;
    var props = {};
    if (colorFn) props.mcc = calcPt.mcc = colorFn(calcPt.mc);
    if (sizeFn) props.mrc = calcPt.mrc = sizeFn(calcPt.ms);
    if (opacityFn) props.mo = opacityFn(calcPt.mo);
    if (selectedpoints) props.selected = calcPt.selected || 0;
    features.push({
      type: 'Feature',
      id: i + 1,
      geometry: {
        type: 'Point',
        coordinates: lonlat
      },
      properties: props
    });
  }
  var fns;
  if (selectedpoints) {
    fns = Drawing.makeSelectedPointStyleFns(trace);
    for (i = 0; i < features.length; i++) {
      var d = features[i].properties;
      if (fns.selectedOpacityFn) {
        d.mo = addTraceOpacity(fns.selectedOpacityFn(d));
      }
      if (fns.selectedColorFn) {
        d.mcc = fns.selectedColorFn(d);
      }
      if (fns.selectedSizeFn) {
        d.mrc = fns.selectedSizeFn(d);
      }
    }
  }
  return {
    geojson: {
      type: 'FeatureCollection',
      features: features
    },
    mcc: arrayColor || fns && fns.selectedColorFn ? {
      type: 'identity',
      property: 'mcc'
    } : marker.color,
    mrc: arraySize || fns && fns.selectedSizeFn ? {
      type: 'identity',
      property: 'mrc'
    } : size2radius(marker.size),
    mo: arrayOpacity || fns && fns.selectedOpacityFn ? {
      type: 'identity',
      property: 'mo'
    } : addTraceOpacity(marker.opacity)
  };
}
function makeSymbolGeoJSON(calcTrace, gd) {
  var fullLayout = gd._fullLayout;
  var trace = calcTrace[0].trace;
  var marker = trace.marker || {};
  var symbol = marker.symbol;
  var angle = marker.angle;
  var fillSymbol = symbol !== 'circle' ? getFillFunc(symbol) : blankFillFunc;
  var fillAngle = angle !== 'auto' ? getFillFunc(angle, true) : blankFillFunc;
  var fillText = subTypes.hasText(trace) ? getFillFunc(trace.text) : blankFillFunc;
  var features = [];
  for (var i = 0; i < calcTrace.length; i++) {
    var calcPt = calcTrace[i];
    if (isBADNUM(calcPt.lonlat)) continue;
    var texttemplate = trace.texttemplate;
    var text;
    if (texttemplate) {
      var tt = Array.isArray(texttemplate) ? texttemplate[i] || '' : texttemplate;
      var labels = trace._module.formatLabels(calcPt, trace, fullLayout);
      var pointValues = {};
      appendArrayPointValue(pointValues, trace, calcPt.i);
      var meta = trace._meta || {};
      text = Lib.texttemplateString(tt, labels, fullLayout._d3locale, pointValues, calcPt, meta);
    } else {
      text = fillText(i);
    }
    if (text) {
      text = text.replace(NEWLINES, '').replace(BR_TAG_ALL, '\n');
    }
    features.push({
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: calcPt.lonlat
      },
      properties: {
        symbol: fillSymbol(i),
        angle: fillAngle(i),
        text: text
      }
    });
  }
  return {
    type: 'FeatureCollection',
    features: features
  };
}
function getFillFunc(attr, numeric) {
  if (Lib.isArrayOrTypedArray(attr)) {
    if (numeric) {
      return function (i) {
        return isNumeric(attr[i]) ? +attr[i] : 0;
      };
    }
    return function (i) {
      return attr[i];
    };
  } else if (attr) {
    return function () {
      return attr;
    };
  } else {
    return blankFillFunc;
  }
}
function blankFillFunc() {
  return '';
}

// only need to check lon (OR lat)
function isBADNUM(lonlat) {
  return lonlat[0] === BADNUM;
}
function arrayifyAttribute(values, step) {
  var newAttribute;
  if (Lib.isArrayOrTypedArray(values) && Lib.isArrayOrTypedArray(step)) {
    newAttribute = ['step', ['get', 'point_count'], values[0]];
    for (var idx = 1; idx < values.length; idx++) {
      newAttribute.push(step[idx - 1], values[idx]);
    }
  } else {
    newAttribute = values;
  }
  return newAttribute;
}
function getTextFont(trace) {
  var font = trace.textfont;
  var family = font.family;
  var style = font.style;
  var weight = font.weight;
  var parts = family.split(' ');
  var isItalic = parts[parts.length - 1] === 'Italic';
  if (isItalic) parts.pop();
  isItalic = isItalic || style === 'italic';
  var str = parts.join(' ');
  if (weight === 'bold' && parts.indexOf('Bold') === -1) {
    str += ' Bold';
  } else if (weight <= 1000) {
    // numeric font-weight
    // See supportedFonts

    if (parts[0] === 'Metropolis') {
      str = 'Metropolis';
      if (weight > 850) str += ' Black';else if (weight > 750) str += ' Extra Bold';else if (weight > 650) str += ' Bold';else if (weight > 550) str += ' Semi Bold';else if (weight > 450) str += ' Medium';else if (weight > 350) str += ' Regular';else if (weight > 250) str += ' Light';else if (weight > 150) str += ' Extra Light';else str += ' Thin';
    } else if (parts.slice(0, 2).join(' ') === 'Open Sans') {
      str = 'Open Sans';
      if (weight > 750) str += ' Extrabold';else if (weight > 650) str += ' Bold';else if (weight > 550) str += ' Semibold';else if (weight > 350) str += ' Regular';else str += ' Light';
    } else if (parts.slice(0, 3).join(' ') === 'Klokantech Noto Sans') {
      str = 'Klokantech Noto Sans';
      if (parts[3] === 'CJK') str += ' CJK';
      str += weight > 500 ? ' Bold' : ' Regular';
    }
  }
  if (isItalic) str += ' Italic';
  if (str === 'Open Sans Regular Italic') str = 'Open Sans Italic';else if (str === 'Open Sans Regular Bold') str = 'Open Sans Bold';else if (str === 'Open Sans Regular Bold Italic') str = 'Open Sans Bold Italic';else if (str === 'Klokantech Noto Sans Regular Italic') str = 'Klokantech Noto Sans Italic';

  // Ensure the result is a supported font
  if (!isSupportedFont(str)) {
    str = family;
  }
  var textFont = str.split(', ');
  return textFont;
}

/***/ }),

/***/ 38302:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var subTypes = __webpack_require__(64726);
var handleMarkerDefaults = __webpack_require__(24272);
var handleLineDefaults = __webpack_require__(98168);
var handleTextDefaults = __webpack_require__(663);
var handleFillColorDefaults = __webpack_require__(54114);
var attributes = __webpack_require__(95833);
var isSupportedFont = (__webpack_require__(2795).isSupportedFont);
module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
  function coerce(attr, dflt) {
    return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
  }
  function coerce2(attr, dflt) {
    return Lib.coerce2(traceIn, traceOut, attributes, attr, dflt);
  }
  var len = handleLonLatDefaults(traceIn, traceOut, coerce);
  if (!len) {
    traceOut.visible = false;
    return;
  }
  coerce('text');
  coerce('texttemplate');
  coerce('hovertext');
  coerce('hovertemplate');
  coerce('mode');
  coerce('below');
  if (subTypes.hasMarkers(traceOut)) {
    handleMarkerDefaults(traceIn, traceOut, defaultColor, layout, coerce, {
      noLine: true,
      noAngle: true
    });
    coerce('marker.allowoverlap');
    coerce('marker.angle');

    // array marker.size and marker.color are only supported with circles
    var marker = traceOut.marker;
    if (marker.symbol !== 'circle') {
      if (Lib.isArrayOrTypedArray(marker.size)) marker.size = marker.size[0];
      if (Lib.isArrayOrTypedArray(marker.color)) marker.color = marker.color[0];
    }
  }
  if (subTypes.hasLines(traceOut)) {
    handleLineDefaults(traceIn, traceOut, defaultColor, layout, coerce, {
      noDash: true
    });
    coerce('connectgaps');
  }
  var clusterMaxzoom = coerce2('cluster.maxzoom');
  var clusterStep = coerce2('cluster.step');
  var clusterColor = coerce2('cluster.color', traceOut.marker && traceOut.marker.color || defaultColor);
  var clusterSize = coerce2('cluster.size');
  var clusterOpacity = coerce2('cluster.opacity');
  var clusterEnabledDflt = clusterMaxzoom !== false || clusterStep !== false || clusterColor !== false || clusterSize !== false || clusterOpacity !== false;
  var clusterEnabled = coerce('cluster.enabled', clusterEnabledDflt);
  if (clusterEnabled || subTypes.hasText(traceOut)) {
    var layoutFontFamily = layout.font.family;
    handleTextDefaults(traceIn, traceOut, layout, coerce, {
      noSelect: true,
      noFontVariant: true,
      noFontShadow: true,
      noFontLineposition: true,
      noFontTextcase: true,
      font: {
        family: isSupportedFont(layoutFontFamily) ? layoutFontFamily : 'Open Sans Regular',
        weight: layout.font.weight,
        style: layout.font.style,
        size: layout.font.size,
        color: layout.font.color
      }
    });
  }
  coerce('fill');
  if (traceOut.fill !== 'none') {
    handleFillColorDefaults(traceIn, traceOut, defaultColor, coerce);
  }
  Lib.coerceSelectionMarkerOpacity(traceOut, coerce);
};
function handleLonLatDefaults(traceIn, traceOut, coerce) {
  var lon = coerce('lon') || [];
  var lat = coerce('lat') || [];
  var len = Math.min(lon.length, lat.length);
  traceOut._length = len;
  return len;
}

/***/ }),

/***/ 68197:
/***/ (function(module) {

"use strict";


module.exports = function eventData(out, pt) {
  out.lon = pt.lon;
  out.lat = pt.lat;
  return out;
};

/***/ }),

/***/ 69009:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Axes = __webpack_require__(29714);
module.exports = function formatLabels(cdi, trace, fullLayout) {
  var labels = {};
  var subplot = fullLayout[trace.subplot]._subplot;
  var ax = subplot.mockAxis;
  var lonlat = cdi.lonlat;
  labels.lonLabel = Axes.tickText(ax, ax.c2l(lonlat[0]), true).text;
  labels.latLabel = Axes.tickText(ax, ax.c2l(lonlat[1]), true).text;
  return labels;
};

/***/ }),

/***/ 18016:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Fx = __webpack_require__(32141);
var Lib = __webpack_require__(34809);
var getTraceColor = __webpack_require__(11539);
var fillText = Lib.fillText;
var BADNUM = (__webpack_require__(63821).BADNUM);
var LAYER_PREFIX = (__webpack_require__(44245).traceLayerPrefix);
function hoverPoints(pointData, xval, yval) {
  var cd = pointData.cd;
  var trace = cd[0].trace;
  var xa = pointData.xa;
  var ya = pointData.ya;
  var subplot = pointData.subplot;
  var clusteredPointsIds = [];
  var layer = LAYER_PREFIX + trace.uid + '-circle';
  var hasCluster = trace.cluster && trace.cluster.enabled;
  if (hasCluster) {
    var elems = subplot.map.queryRenderedFeatures(null, {
      layers: [layer]
    });
    clusteredPointsIds = elems.map(function (elem) {
      return elem.id;
    });
  }

  // compute winding number about [-180, 180] globe
  var winding = xval >= 0 ? Math.floor((xval + 180) / 360) : Math.ceil((xval - 180) / 360);

  // shift longitude to [-180, 180] to determine closest point
  var lonShift = winding * 360;
  var xval2 = xval - lonShift;
  function distFn(d) {
    var lonlat = d.lonlat;
    if (lonlat[0] === BADNUM) return Infinity;
    if (hasCluster && clusteredPointsIds.indexOf(d.i + 1) === -1) return Infinity;
    var lon = Lib.modHalf(lonlat[0], 360);
    var lat = lonlat[1];
    var pt = subplot.project([lon, lat]);
    var dx = pt.x - xa.c2p([xval2, lat]);
    var dy = pt.y - ya.c2p([lon, yval]);
    var rad = Math.max(3, d.mrc || 0);
    return Math.max(Math.sqrt(dx * dx + dy * dy) - rad, 1 - 3 / rad);
  }
  Fx.getClosest(cd, distFn, pointData);

  // skip the rest (for this trace) if we didn't find a close point
  if (pointData.index === false) return;
  var di = cd[pointData.index];
  var lonlat = di.lonlat;
  var lonlatShifted = [Lib.modHalf(lonlat[0], 360) + lonShift, lonlat[1]];

  // shift labels back to original winded globe
  var xc = xa.c2p(lonlatShifted);
  var yc = ya.c2p(lonlatShifted);
  var rad = di.mrc || 1;
  pointData.x0 = xc - rad;
  pointData.x1 = xc + rad;
  pointData.y0 = yc - rad;
  pointData.y1 = yc + rad;
  var fullLayout = {};
  fullLayout[trace.subplot] = {
    _subplot: subplot
  };
  var labels = trace._module.formatLabels(di, trace, fullLayout);
  pointData.lonLabel = labels.lonLabel;
  pointData.latLabel = labels.latLabel;
  pointData.color = getTraceColor(trace, di);
  pointData.extraText = getExtraText(trace, di, cd[0].t.labels);
  pointData.hovertemplate = trace.hovertemplate;
  return [pointData];
}
function getExtraText(trace, di, labels) {
  if (trace.hovertemplate) return;
  var hoverinfo = di.hi || trace.hoverinfo;
  var parts = hoverinfo.split('+');
  var isAll = parts.indexOf('all') !== -1;
  var hasLon = parts.indexOf('lon') !== -1;
  var hasLat = parts.indexOf('lat') !== -1;
  var lonlat = di.lonlat;
  var text = [];

  // TODO should we use a mock axis to format hover?
  // If so, we'll need to make precision be zoom-level dependent
  function format(v) {
    return v + '\u00B0';
  }
  if (isAll || hasLon && hasLat) {
    text.push('(' + format(lonlat[1]) + ', ' + format(lonlat[0]) + ')');
  } else if (hasLon) {
    text.push(labels.lon + format(lonlat[0]));
  } else if (hasLat) {
    text.push(labels.lat + format(lonlat[1]));
  }
  if (isAll || parts.indexOf('text') !== -1) {
    fillText(di, trace, text);
  }
  return text.join('<br>');
}
module.exports = {
  hoverPoints: hoverPoints,
  getExtraText: getExtraText
};

/***/ }),

/***/ 83866:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var deprecationWarning = ['*scattermapbox* trace is deprecated!', 'Please consider switching to the *scattermap* trace type and `map` subplots.', 'Learn more at: https://plotly.com/javascript/maplibre-migration/'].join(' ');
module.exports = {
  attributes: __webpack_require__(95833),
  supplyDefaults: __webpack_require__(38302),
  colorbar: __webpack_require__(21146),
  formatLabels: __webpack_require__(69009),
  calc: __webpack_require__(75649),
  plot: __webpack_require__(20691),
  hoverPoints: (__webpack_require__(18016).hoverPoints),
  eventData: __webpack_require__(68197),
  selectPoints: __webpack_require__(60784),
  styleOnSelect: function (_, cd) {
    if (cd) {
      var trace = cd[0].trace;
      trace._glTrace.update(cd);
    }
  },
  moduleType: 'trace',
  name: 'scattermapbox',
  basePlotModule: __webpack_require__(68192),
  categories: ['mapbox', 'gl', 'symbols', 'showLegend', 'scatter-like'],
  meta: {}
};

/***/ }),

/***/ 20691:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var convert = __webpack_require__(27009);
var LAYER_PREFIX = (__webpack_require__(44245).traceLayerPrefix);
var ORDER = {
  cluster: ['cluster', 'clusterCount', 'circle'],
  nonCluster: ['fill', 'line', 'circle', 'symbol']
};
function ScatterMapbox(subplot, uid, clusterEnabled, isHidden) {
  this.type = 'scattermapbox';
  this.subplot = subplot;
  this.uid = uid;
  this.clusterEnabled = clusterEnabled;
  this.isHidden = isHidden;
  this.sourceIds = {
    fill: 'source-' + uid + '-fill',
    line: 'source-' + uid + '-line',
    circle: 'source-' + uid + '-circle',
    symbol: 'source-' + uid + '-symbol',
    cluster: 'source-' + uid + '-circle',
    clusterCount: 'source-' + uid + '-circle'
  };
  this.layerIds = {
    fill: LAYER_PREFIX + uid + '-fill',
    line: LAYER_PREFIX + uid + '-line',
    circle: LAYER_PREFIX + uid + '-circle',
    symbol: LAYER_PREFIX + uid + '-symbol',
    cluster: LAYER_PREFIX + uid + '-cluster',
    clusterCount: LAYER_PREFIX + uid + '-cluster-count'
  };

  // We could merge the 'fill' source with the 'line' source and
  // the 'circle' source with the 'symbol' source if ever having
  // for up-to 4 sources per 'scattermapbox' traces becomes a problem.

  // previous 'below' value,
  // need this to update it properly
  this.below = null;
}
var proto = ScatterMapbox.prototype;
proto.addSource = function (k, opts, cluster) {
  var sourceOpts = {
    type: 'geojson',
    data: opts.geojson
  };
  if (cluster && cluster.enabled) {
    Lib.extendFlat(sourceOpts, {
      cluster: true,
      clusterMaxZoom: cluster.maxzoom
    });
  }
  var isSourceExists = this.subplot.map.getSource(this.sourceIds[k]);
  if (isSourceExists) {
    isSourceExists.setData(opts.geojson);
  } else {
    this.subplot.map.addSource(this.sourceIds[k], sourceOpts);
  }
};
proto.setSourceData = function (k, opts) {
  this.subplot.map.getSource(this.sourceIds[k]).setData(opts.geojson);
};
proto.addLayer = function (k, opts, below) {
  var source = {
    type: opts.type,
    id: this.layerIds[k],
    source: this.sourceIds[k],
    layout: opts.layout,
    paint: opts.paint
  };
  if (opts.filter) {
    source.filter = opts.filter;
  }
  var currentLayerId = this.layerIds[k];
  var layerExist;
  var layers = this.subplot.getMapLayers();
  for (var i = 0; i < layers.length; i++) {
    if (layers[i].id === currentLayerId) {
      layerExist = true;
      break;
    }
  }
  if (layerExist) {
    this.subplot.setOptions(currentLayerId, 'setLayoutProperty', source.layout);
    if (source.layout.visibility === 'visible') {
      this.subplot.setOptions(currentLayerId, 'setPaintProperty', source.paint);
    }
  } else {
    this.subplot.addLayer(source, below);
  }
};
proto.update = function update(calcTrace) {
  var trace = calcTrace[0].trace;
  var subplot = this.subplot;
  var map = subplot.map;
  var optsAll = convert(subplot.gd, calcTrace);
  var below = subplot.belowLookup['trace-' + this.uid];
  var hasCluster = !!(trace.cluster && trace.cluster.enabled);
  var hadCluster = !!this.clusterEnabled;
  var lThis = this;
  function addCluster(noSource) {
    if (!noSource) lThis.addSource('circle', optsAll.circle, trace.cluster);
    var order = ORDER.cluster;
    for (var i = 0; i < order.length; i++) {
      var k = order[i];
      var opts = optsAll[k];
      lThis.addLayer(k, opts, below);
    }
  }
  function removeCluster(noSource) {
    var order = ORDER.cluster;
    for (var i = order.length - 1; i >= 0; i--) {
      var k = order[i];
      map.removeLayer(lThis.layerIds[k]);
    }
    if (!noSource) map.removeSource(lThis.sourceIds.circle);
  }
  function addNonCluster(noSource) {
    var order = ORDER.nonCluster;
    for (var i = 0; i < order.length; i++) {
      var k = order[i];
      var opts = optsAll[k];
      if (!noSource) lThis.addSource(k, opts);
      lThis.addLayer(k, opts, below);
    }
  }
  function removeNonCluster(noSource) {
    var order = ORDER.nonCluster;
    for (var i = order.length - 1; i >= 0; i--) {
      var k = order[i];
      map.removeLayer(lThis.layerIds[k]);
      if (!noSource) map.removeSource(lThis.sourceIds[k]);
    }
  }
  function remove(noSource) {
    if (hadCluster) removeCluster(noSource);else removeNonCluster(noSource);
  }
  function add(noSource) {
    if (hasCluster) addCluster(noSource);else addNonCluster(noSource);
  }
  function repaint() {
    var order = hasCluster ? ORDER.cluster : ORDER.nonCluster;
    for (var i = 0; i < order.length; i++) {
      var k = order[i];
      var opts = optsAll[k];
      if (!opts) continue;
      subplot.setOptions(lThis.layerIds[k], 'setLayoutProperty', opts.layout);
      if (opts.layout.visibility === 'visible') {
        if (k !== 'cluster') {
          lThis.setSourceData(k, opts);
        }
        subplot.setOptions(lThis.layerIds[k], 'setPaintProperty', opts.paint);
      }
    }
  }
  var wasHidden = this.isHidden;
  var isHidden = trace.visible !== true;
  if (isHidden) {
    if (!wasHidden) remove();
  } else if (wasHidden) {
    if (!isHidden) add();
  } else if (hadCluster !== hasCluster) {
    remove();
    add();
  } else if (this.below !== below) {
    remove(true);
    add(true);
    repaint();
  } else {
    repaint();
  }
  this.clusterEnabled = hasCluster;
  this.isHidden = isHidden;
  this.below = below;

  // link ref for quick update during selections
  calcTrace[0].trace._glTrace = this;
};
proto.dispose = function dispose() {
  var map = this.subplot.map;
  var order = this.clusterEnabled ? ORDER.cluster : ORDER.nonCluster;
  for (var i = order.length - 1; i >= 0; i--) {
    var k = order[i];
    map.removeLayer(this.layerIds[k]);
    map.removeSource(this.sourceIds[k]);
  }
};
module.exports = function createScatterMapbox(subplot, calcTrace) {
  var trace = calcTrace[0].trace;
  var hasCluster = trace.cluster && trace.cluster.enabled;
  var isHidden = trace.visible !== true;
  var scatterMapbox = new ScatterMapbox(subplot, trace.uid, hasCluster, isHidden);
  var optsAll = convert(subplot.gd, calcTrace);
  var below = scatterMapbox.below = subplot.belowLookup['trace-' + trace.uid];
  var i, k, opts;
  if (hasCluster) {
    scatterMapbox.addSource('circle', optsAll.circle, trace.cluster);
    for (i = 0; i < ORDER.cluster.length; i++) {
      k = ORDER.cluster[i];
      opts = optsAll[k];
      scatterMapbox.addLayer(k, opts, below);
    }
  } else {
    for (i = 0; i < ORDER.nonCluster.length; i++) {
      k = ORDER.nonCluster[i];
      opts = optsAll[k];
      scatterMapbox.addSource(k, opts, trace.cluster);
      scatterMapbox.addLayer(k, opts, below);
    }
  }

  // link ref for quick update during selections
  calcTrace[0].trace._glTrace = scatterMapbox;
  return scatterMapbox;
};

/***/ }),

/***/ 60784:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var subtypes = __webpack_require__(64726);
var BADNUM = (__webpack_require__(63821).BADNUM);
module.exports = function selectPoints(searchInfo, selectionTester) {
  var cd = searchInfo.cd;
  var xa = searchInfo.xaxis;
  var ya = searchInfo.yaxis;
  var selection = [];
  var trace = cd[0].trace;
  var i;
  if (!subtypes.hasMarkers(trace)) return [];
  if (selectionTester === false) {
    for (i = 0; i < cd.length; i++) {
      cd[i].selected = 0;
    }
  } else {
    for (i = 0; i < cd.length; i++) {
      var di = cd[i];
      var lonlat = di.lonlat;
      if (lonlat[0] !== BADNUM) {
        var lonlat2 = [Lib.modHalf(lonlat[0], 360), lonlat[1]];
        var xy = [xa.c2p(lonlat2), ya.c2p(lonlat2)];
        if (selectionTester.contains(xy, null, i, searchInfo)) {
          selection.push({
            pointNumber: i,
            lon: lonlat[0],
            lat: lonlat[1]
          });
          di.selected = 1;
        } else {
          di.selected = 0;
        }
      }
    }
  }
  return selection;
};

/***/ }),

/***/ 8738:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var hovertemplateAttrs = (__webpack_require__(3208)/* .hovertemplateAttrs */ .rb);
var texttemplateAttrs = (__webpack_require__(3208)/* .texttemplateAttrs */ .ay);
var extendFlat = (__webpack_require__(93049).extendFlat);
var makeFillcolorAttr = __webpack_require__(19326);
var scatterAttrs = __webpack_require__(36640);
var baseAttrs = __webpack_require__(9829);
var lineAttrs = scatterAttrs.line;
module.exports = {
  mode: scatterAttrs.mode,
  r: {
    valType: 'data_array',
    editType: 'calc+clearAxisTypes'
  },
  theta: {
    valType: 'data_array',
    editType: 'calc+clearAxisTypes'
  },
  r0: {
    valType: 'any',
    dflt: 0,
    editType: 'calc+clearAxisTypes'
  },
  dr: {
    valType: 'number',
    dflt: 1,
    editType: 'calc'
  },
  theta0: {
    valType: 'any',
    dflt: 0,
    editType: 'calc+clearAxisTypes'
  },
  dtheta: {
    valType: 'number',
    editType: 'calc'
  },
  thetaunit: {
    valType: 'enumerated',
    values: ['radians', 'degrees', 'gradians'],
    dflt: 'degrees',
    editType: 'calc+clearAxisTypes'
  },
  text: scatterAttrs.text,
  texttemplate: texttemplateAttrs({
    editType: 'plot'
  }, {
    keys: ['r', 'theta', 'text']
  }),
  hovertext: scatterAttrs.hovertext,
  line: {
    color: lineAttrs.color,
    width: lineAttrs.width,
    dash: lineAttrs.dash,
    backoff: lineAttrs.backoff,
    shape: extendFlat({}, lineAttrs.shape, {
      values: ['linear', 'spline']
    }),
    smoothing: lineAttrs.smoothing,
    editType: 'calc'
  },
  connectgaps: scatterAttrs.connectgaps,
  marker: scatterAttrs.marker,
  cliponaxis: extendFlat({}, scatterAttrs.cliponaxis, {
    dflt: false
  }),
  textposition: scatterAttrs.textposition,
  textfont: scatterAttrs.textfont,
  fill: extendFlat({}, scatterAttrs.fill, {
    values: ['none', 'toself', 'tonext'],
    dflt: 'none'
  }),
  fillcolor: makeFillcolorAttr(),
  // TODO error bars
  // https://stackoverflow.com/a/26597487/4068492
  // error_x (error_r, error_theta)
  // error_y

  hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
    flags: ['r', 'theta', 'text', 'name']
  }),
  hoveron: scatterAttrs.hoveron,
  hovertemplate: hovertemplateAttrs(),
  selected: scatterAttrs.selected,
  unselected: scatterAttrs.unselected
};

/***/ }),

/***/ 13246:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isNumeric = __webpack_require__(10721);
var BADNUM = (__webpack_require__(63821).BADNUM);
var Axes = __webpack_require__(29714);
var calcColorscale = __webpack_require__(77272);
var arraysToCalcdata = __webpack_require__(99203);
var calcSelection = __webpack_require__(48861);
var calcMarkerSize = (__webpack_require__(26544).calcMarkerSize);
module.exports = function calc(gd, trace) {
  var fullLayout = gd._fullLayout;
  var subplotId = trace.subplot;
  var radialAxis = fullLayout[subplotId].radialaxis;
  var angularAxis = fullLayout[subplotId].angularaxis;
  var rArray = radialAxis.makeCalcdata(trace, 'r');
  var thetaArray = angularAxis.makeCalcdata(trace, 'theta');
  var len = trace._length;
  var cd = new Array(len);
  for (var i = 0; i < len; i++) {
    var r = rArray[i];
    var theta = thetaArray[i];
    var cdi = cd[i] = {};
    if (isNumeric(r) && isNumeric(theta)) {
      cdi.r = r;
      cdi.theta = theta;
    } else {
      cdi.r = BADNUM;
    }
  }
  var ppad = calcMarkerSize(trace, len);
  trace._extremes.x = Axes.findExtremes(radialAxis, rArray, {
    ppad: ppad
  });
  calcColorscale(gd, trace);
  arraysToCalcdata(cd, trace);
  calcSelection(cd, trace);
  return cd;
};

/***/ }),

/***/ 73749:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var subTypes = __webpack_require__(64726);
var handleMarkerDefaults = __webpack_require__(24272);
var handleLineDefaults = __webpack_require__(98168);
var handleLineShapeDefaults = __webpack_require__(91602);
var handleTextDefaults = __webpack_require__(663);
var handleFillColorDefaults = __webpack_require__(54114);
var PTS_LINESONLY = (__webpack_require__(32660).PTS_LINESONLY);
var attributes = __webpack_require__(8738);
function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
  function coerce(attr, dflt) {
    return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
  }
  var len = handleRThetaDefaults(traceIn, traceOut, layout, coerce);
  if (!len) {
    traceOut.visible = false;
    return;
  }
  coerce('thetaunit');
  coerce('mode', len < PTS_LINESONLY ? 'lines+markers' : 'lines');
  coerce('text');
  coerce('hovertext');
  if (traceOut.hoveron !== 'fills') coerce('hovertemplate');
  if (subTypes.hasMarkers(traceOut)) {
    handleMarkerDefaults(traceIn, traceOut, defaultColor, layout, coerce, {
      gradient: true
    });
  }
  if (subTypes.hasLines(traceOut)) {
    handleLineDefaults(traceIn, traceOut, defaultColor, layout, coerce, {
      backoff: true
    });
    handleLineShapeDefaults(traceIn, traceOut, coerce);
    coerce('connectgaps');
  }
  if (subTypes.hasText(traceOut)) {
    coerce('texttemplate');
    handleTextDefaults(traceIn, traceOut, layout, coerce);
  }
  var dfltHoverOn = [];
  if (subTypes.hasMarkers(traceOut) || subTypes.hasText(traceOut)) {
    coerce('cliponaxis');
    coerce('marker.maxdisplayed');
    dfltHoverOn.push('points');
  }
  coerce('fill');
  if (traceOut.fill !== 'none') {
    handleFillColorDefaults(traceIn, traceOut, defaultColor, coerce);
    if (!subTypes.hasLines(traceOut)) handleLineShapeDefaults(traceIn, traceOut, coerce);
  }
  if (traceOut.fill === 'tonext' || traceOut.fill === 'toself') {
    dfltHoverOn.push('fills');
  }
  coerce('hoveron', dfltHoverOn.join('+') || 'points');
  Lib.coerceSelectionMarkerOpacity(traceOut, coerce);
}
function handleRThetaDefaults(traceIn, traceOut, layout, coerce) {
  var r = coerce('r');
  var theta = coerce('theta');

  // TODO: handle this case outside supply defaults step
  if (Lib.isTypedArray(r)) {
    traceOut.r = r = Array.from(r);
  }
  if (Lib.isTypedArray(theta)) {
    traceOut.theta = theta = Array.from(theta);
  }
  var len;
  if (r) {
    if (theta) {
      len = Math.min(r.length, theta.length);
    } else {
      len = r.length;
      coerce('theta0');
      coerce('dtheta');
    }
  } else {
    if (!theta) return 0;
    len = traceOut.theta.length;
    coerce('r0');
    coerce('dr');
  }
  traceOut._length = len;
  return len;
}
module.exports = {
  handleRThetaDefaults: handleRThetaDefaults,
  supplyDefaults: supplyDefaults
};

/***/ }),

/***/ 33368:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var Axes = __webpack_require__(29714);
module.exports = function formatLabels(cdi, trace, fullLayout) {
  var labels = {};
  var subplot = fullLayout[trace.subplot]._subplot;
  var radialAxis;
  var angularAxis;

  // for scatterpolargl texttemplate, _subplot is NOT defined, this takes part during the convert step
  // TODO we should consider moving the texttemplate formatting logic to the plot step
  if (!subplot) {
    subplot = fullLayout[trace.subplot];
    radialAxis = subplot.radialaxis;
    angularAxis = subplot.angularaxis;
  } else {
    radialAxis = subplot.radialAxis;
    angularAxis = subplot.angularAxis;
  }
  var rVal = radialAxis.c2l(cdi.r);
  labels.rLabel = Axes.tickText(radialAxis, rVal, true).text;

  // N.B here the ° sign is part of the formatted value for thetaunit:'degrees'
  var thetaVal = angularAxis.thetaunit === 'degrees' ? Lib.rad2deg(cdi.theta) : cdi.theta;
  labels.thetaLabel = Axes.tickText(angularAxis, thetaVal, true).text;
  return labels;
};

/***/ }),

/***/ 29709:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var scatterHover = __webpack_require__(37255);
function hoverPoints(pointData, xval, yval, hovermode) {
  var scatterPointData = scatterHover(pointData, xval, yval, hovermode);
  if (!scatterPointData || scatterPointData[0].index === false) return;
  var newPointData = scatterPointData[0];

  // hovering on fill case
  if (newPointData.index === undefined) {
    return scatterPointData;
  }
  var subplot = pointData.subplot;
  var cdi = newPointData.cd[newPointData.index];
  var trace = newPointData.trace;
  if (!subplot.isPtInside(cdi)) return;
  newPointData.xLabelVal = undefined;
  newPointData.yLabelVal = undefined;
  makeHoverPointText(cdi, trace, subplot, newPointData);
  newPointData.hovertemplate = trace.hovertemplate;
  return scatterPointData;
}
function makeHoverPointText(cdi, trace, subplot, pointData) {
  var radialAxis = subplot.radialAxis;
  var angularAxis = subplot.angularAxis;
  radialAxis._hovertitle = 'r';
  angularAxis._hovertitle = 'θ';
  var fullLayout = {};
  fullLayout[trace.subplot] = {
    _subplot: subplot
  };
  var labels = trace._module.formatLabels(cdi, trace, fullLayout);
  pointData.rLabel = labels.rLabel;
  pointData.thetaLabel = labels.thetaLabel;
  var hoverinfo = cdi.hi || trace.hoverinfo;
  var text = [];
  function textPart(ax, val) {
    text.push(ax._hovertitle + ': ' + val);
  }
  if (!trace.hovertemplate) {
    var parts = hoverinfo.split('+');
    if (parts.indexOf('all') !== -1) parts = ['r', 'theta', 'text'];
    if (parts.indexOf('r') !== -1) textPart(radialAxis, pointData.rLabel);
    if (parts.indexOf('theta') !== -1) textPart(angularAxis, pointData.thetaLabel);
    if (parts.indexOf('text') !== -1 && pointData.text) {
      text.push(pointData.text);
      delete pointData.text;
    }
    pointData.extraText = text.join('<br>');
  }
}
module.exports = {
  hoverPoints: hoverPoints,
  makeHoverPointText: makeHoverPointText
};

/***/ }),

/***/ 66939:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = {
  moduleType: 'trace',
  name: 'scatterpolar',
  basePlotModule: __webpack_require__(31645),
  categories: ['polar', 'symbols', 'showLegend', 'scatter-like'],
  attributes: __webpack_require__(8738),
  supplyDefaults: (__webpack_require__(73749).supplyDefaults),
  colorbar: __webpack_require__(21146),
  formatLabels: __webpack_require__(33368),
  calc: __webpack_require__(13246),
  plot: __webpack_require__(43836),
  style: (__webpack_require__(9408).style),
  styleOnSelect: (__webpack_require__(9408).styleOnSelect),
  hoverPoints: (__webpack_require__(29709).hoverPoints),
  selectPoints: __webpack_require__(32665),
  meta: {}
};

/***/ }),

/***/ 43836:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var scatterPlot = __webpack_require__(36098);
var BADNUM = (__webpack_require__(63821).BADNUM);
module.exports = function plot(gd, subplot, moduleCalcData) {
  var mlayer = subplot.layers.frontplot.select('g.scatterlayer');
  var xa = subplot.xaxis;
  var ya = subplot.yaxis;
  var plotinfo = {
    xaxis: xa,
    yaxis: ya,
    plot: subplot.framework,
    layerClipId: subplot._hasClipOnAxisFalse ? subplot.clipIds.forTraces : null
  };
  var radialAxis = subplot.radialAxis;
  var angularAxis = subplot.angularAxis;

  // convert:
  // 'c' (r,theta) -> 'geometric' (r,theta) -> (x,y)
  for (var i = 0; i < moduleCalcData.length; i++) {
    var cdi = moduleCalcData[i];
    for (var j = 0; j < cdi.length; j++) {
      if (j === 0) {
        cdi[0].trace._xA = xa;
        cdi[0].trace._yA = ya;
      }
      var cd = cdi[j];
      var r = cd.r;
      if (r === BADNUM) {
        cd.x = cd.y = BADNUM;
      } else {
        var rg = radialAxis.c2g(r);
        var thetag = angularAxis.c2g(cd.theta);
        cd.x = rg * Math.cos(thetag);
        cd.y = rg * Math.sin(thetag);
      }
    }
  }
  scatterPlot(gd, plotinfo, moduleCalcData, mlayer);
};

/***/ }),

/***/ 58319:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var scatterPolarAttrs = __webpack_require__(8738);
var scatterGlAttrs = __webpack_require__(92089);
var texttemplateAttrs = (__webpack_require__(3208)/* .texttemplateAttrs */ .ay);
module.exports = {
  mode: scatterPolarAttrs.mode,
  r: scatterPolarAttrs.r,
  theta: scatterPolarAttrs.theta,
  r0: scatterPolarAttrs.r0,
  dr: scatterPolarAttrs.dr,
  theta0: scatterPolarAttrs.theta0,
  dtheta: scatterPolarAttrs.dtheta,
  thetaunit: scatterPolarAttrs.thetaunit,
  text: scatterPolarAttrs.text,
  texttemplate: texttemplateAttrs({
    editType: 'plot'
  }, {
    keys: ['r', 'theta', 'text']
  }),
  hovertext: scatterPolarAttrs.hovertext,
  hovertemplate: scatterPolarAttrs.hovertemplate,
  line: {
    color: scatterGlAttrs.line.color,
    width: scatterGlAttrs.line.width,
    dash: scatterGlAttrs.line.dash,
    editType: 'calc'
  },
  connectgaps: scatterGlAttrs.connectgaps,
  marker: scatterGlAttrs.marker,
  // no cliponaxis

  fill: scatterGlAttrs.fill,
  fillcolor: scatterGlAttrs.fillcolor,
  textposition: scatterGlAttrs.textposition,
  textfont: scatterGlAttrs.textfont,
  hoverinfo: scatterPolarAttrs.hoverinfo,
  // no hoveron

  selected: scatterPolarAttrs.selected,
  unselected: scatterPolarAttrs.unselected
};

/***/ }),

/***/ 25796:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = {
  moduleType: 'trace',
  name: 'scatterpolargl',
  basePlotModule: __webpack_require__(31645),
  categories: ['gl', 'regl', 'polar', 'symbols', 'showLegend', 'scatter-like'],
  attributes: __webpack_require__(58319),
  supplyDefaults: __webpack_require__(14952),
  colorbar: __webpack_require__(21146),
  formatLabels: __webpack_require__(94015),
  calc: __webpack_require__(71535),
  hoverPoints: (__webpack_require__(47522).hoverPoints),
  selectPoints: __webpack_require__(17168),
  meta: {}
};

/***/ }),

/***/ 71535:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var calcColorscale = __webpack_require__(77272);
var calcMarkerSize = (__webpack_require__(26544).calcMarkerSize);
var convert = __webpack_require__(19937);
var Axes = __webpack_require__(29714);
var TOO_MANY_POINTS = (__webpack_require__(29483).TOO_MANY_POINTS);
module.exports = function calc(gd, trace) {
  var fullLayout = gd._fullLayout;
  var subplotId = trace.subplot;
  var radialAxis = fullLayout[subplotId].radialaxis;
  var angularAxis = fullLayout[subplotId].angularaxis;
  var rArray = trace._r = radialAxis.makeCalcdata(trace, 'r');
  var thetaArray = trace._theta = angularAxis.makeCalcdata(trace, 'theta');
  var len = trace._length;
  var stash = {};
  if (len < rArray.length) rArray = rArray.slice(0, len);
  if (len < thetaArray.length) thetaArray = thetaArray.slice(0, len);
  stash.r = rArray;
  stash.theta = thetaArray;
  calcColorscale(gd, trace);

  // only compute 'style' options in calc, as position options
  // depend on the radial range and must be set in plot
  var opts = stash.opts = convert.style(gd, trace);

  // For graphs with very large number of points and array marker.size,
  // use average marker size instead to speed things up.
  var ppad;
  if (len < TOO_MANY_POINTS) {
    ppad = calcMarkerSize(trace, len);
  } else if (opts.marker) {
    ppad = 2 * (opts.marker.sizeAvg || Math.max(opts.marker.size, 3));
  }
  trace._extremes.x = Axes.findExtremes(radialAxis, rArray, {
    ppad: ppad
  });
  return [{
    x: false,
    y: false,
    t: stash,
    trace: trace
  }];
};

/***/ }),

/***/ 14952:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var subTypes = __webpack_require__(64726);
var handleRThetaDefaults = (__webpack_require__(73749).handleRThetaDefaults);
var handleMarkerDefaults = __webpack_require__(24272);
var handleLineDefaults = __webpack_require__(98168);
var handleTextDefaults = __webpack_require__(663);
var handleFillColorDefaults = __webpack_require__(54114);
var PTS_LINESONLY = (__webpack_require__(32660).PTS_LINESONLY);
var attributes = __webpack_require__(58319);
module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
  function coerce(attr, dflt) {
    return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
  }
  var len = handleRThetaDefaults(traceIn, traceOut, layout, coerce);
  if (!len) {
    traceOut.visible = false;
    return;
  }
  coerce('thetaunit');
  coerce('mode', len < PTS_LINESONLY ? 'lines+markers' : 'lines');
  coerce('text');
  coerce('hovertext');
  if (traceOut.hoveron !== 'fills') coerce('hovertemplate');
  if (subTypes.hasMarkers(traceOut)) {
    handleMarkerDefaults(traceIn, traceOut, defaultColor, layout, coerce, {
      noAngleRef: true,
      noStandOff: true
    });
  }
  if (subTypes.hasLines(traceOut)) {
    handleLineDefaults(traceIn, traceOut, defaultColor, layout, coerce);
    coerce('connectgaps');
  }
  if (subTypes.hasText(traceOut)) {
    coerce('texttemplate');
    handleTextDefaults(traceIn, traceOut, layout, coerce, {
      noFontShadow: true,
      noFontLineposition: true,
      noFontTextcase: true
    });
  }
  coerce('fill');
  if (traceOut.fill !== 'none') {
    handleFillColorDefaults(traceIn, traceOut, defaultColor, coerce);
  }
  Lib.coerceSelectionMarkerOpacity(traceOut, coerce);
};

/***/ }),

/***/ 94015:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var scatterPolarFormatLabels = __webpack_require__(33368);
module.exports = function formatLabels(cdi, trace, fullLayout) {
  var i = cdi.i;
  if (!('r' in cdi)) cdi.r = trace._r[i];
  if (!('theta' in cdi)) cdi.theta = trace._theta[i];
  return scatterPolarFormatLabels(cdi, trace, fullLayout);
};

/***/ }),

/***/ 47522:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var hover = __webpack_require__(36544);
var makeHoverPointText = (__webpack_require__(29709).makeHoverPointText);
function hoverPoints(pointData, xval, yval, hovermode) {
  var cd = pointData.cd;
  var stash = cd[0].t;
  var rArray = stash.r;
  var thetaArray = stash.theta;
  var scatterPointData = hover.hoverPoints(pointData, xval, yval, hovermode);
  if (!scatterPointData || scatterPointData[0].index === false) return;
  var newPointData = scatterPointData[0];
  if (newPointData.index === undefined) {
    return scatterPointData;
  }
  var subplot = pointData.subplot;
  var cdi = newPointData.cd[newPointData.index];
  var trace = newPointData.trace;

  // augment pointData with r/theta param
  cdi.r = rArray[newPointData.index];
  cdi.theta = thetaArray[newPointData.index];
  if (!subplot.isPtInside(cdi)) return;
  newPointData.xLabelVal = undefined;
  newPointData.yLabelVal = undefined;
  makeHoverPointText(cdi, trace, subplot, newPointData);
  return scatterPointData;
}
module.exports = {
  hoverPoints: hoverPoints
};

/***/ }),

/***/ 23748:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var index = __webpack_require__(25796);
index.plot = __webpack_require__(54121);
module.exports = index;

/***/ }),

/***/ 54121:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var cluster = __webpack_require__(27549);
var isNumeric = __webpack_require__(10721);
var scatterglPlot = __webpack_require__(47731);
var sceneUpdate = __webpack_require__(62336);
var convert = __webpack_require__(19937);
var Lib = __webpack_require__(34809);
var TOO_MANY_POINTS = (__webpack_require__(29483).TOO_MANY_POINTS);
var reglPrecompiled = {};
module.exports = function plot(gd, subplot, cdata) {
  if (!cdata.length) return;
  var radialAxis = subplot.radialAxis;
  var angularAxis = subplot.angularAxis;
  var scene = sceneUpdate(gd, subplot);
  cdata.forEach(function (cdscatter) {
    if (!cdscatter || !cdscatter[0] || !cdscatter[0].trace) return;
    var cd = cdscatter[0];
    var trace = cd.trace;
    var stash = cd.t;
    var len = trace._length;
    var rArray = stash.r;
    var thetaArray = stash.theta;
    var opts = stash.opts;
    var i;
    var subRArray = rArray.slice();
    var subThetaArray = thetaArray.slice();

    // filter out by range
    for (i = 0; i < rArray.length; i++) {
      if (!subplot.isPtInside({
        r: rArray[i],
        theta: thetaArray[i]
      })) {
        subRArray[i] = NaN;
        subThetaArray[i] = NaN;
      }
    }
    var positions = new Array(len * 2);
    var x = Array(len);
    var y = Array(len);
    for (i = 0; i < len; i++) {
      var r = subRArray[i];
      var xx, yy;
      if (isNumeric(r)) {
        var rg = radialAxis.c2g(r);
        var thetag = angularAxis.c2g(subThetaArray[i], trace.thetaunit);
        xx = rg * Math.cos(thetag);
        yy = rg * Math.sin(thetag);
      } else {
        xx = yy = NaN;
      }
      x[i] = positions[i * 2] = xx;
      y[i] = positions[i * 2 + 1] = yy;
    }
    stash.tree = cluster(positions);

    // FIXME: see scattergl.js#109
    if (opts.marker && len >= TOO_MANY_POINTS) {
      opts.marker.cluster = stash.tree;
    }
    if (opts.marker) {
      opts.markerSel.positions = opts.markerUnsel.positions = opts.marker.positions = positions;
    }
    if (opts.line && positions.length > 1) {
      Lib.extendFlat(opts.line, convert.linePositions(gd, trace, positions));
    }
    if (opts.text) {
      Lib.extendFlat(opts.text, {
        positions: positions
      }, convert.textPosition(gd, trace, opts.text, opts.marker));
      Lib.extendFlat(opts.textSel, {
        positions: positions
      }, convert.textPosition(gd, trace, opts.text, opts.markerSel));
      Lib.extendFlat(opts.textUnsel, {
        positions: positions
      }, convert.textPosition(gd, trace, opts.text, opts.markerUnsel));
    }
    if (opts.fill && !scene.fill2d) scene.fill2d = true;
    if (opts.marker && !scene.scatter2d) scene.scatter2d = true;
    if (opts.line && !scene.line2d) scene.line2d = true;
    if (opts.text && !scene.glText) scene.glText = true;
    scene.lineOptions.push(opts.line);
    scene.fillOptions.push(opts.fill);
    scene.markerOptions.push(opts.marker);
    scene.markerSelectedOptions.push(opts.markerSel);
    scene.markerUnselectedOptions.push(opts.markerUnsel);
    scene.textOptions.push(opts.text);
    scene.textSelectedOptions.push(opts.textSel);
    scene.textUnselectedOptions.push(opts.textUnsel);
    scene.selectBatch.push([]);
    scene.unselectBatch.push([]);
    stash.x = x;
    stash.y = y;
    stash.rawx = x;
    stash.rawy = y;
    stash.r = rArray;
    stash.theta = thetaArray;
    stash.positions = positions;
    stash._scene = scene;
    stash.index = scene.count;
    scene.count++;
  });
  return scatterglPlot(gd, subplot, cdata);
};
module.exports.reglPrecompiled = reglPrecompiled;

/***/ }),

/***/ 69595:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var hovertemplateAttrs = (__webpack_require__(3208)/* .hovertemplateAttrs */ .rb);
var texttemplateAttrs = (__webpack_require__(3208)/* .texttemplateAttrs */ .ay);
var extendFlat = (__webpack_require__(93049).extendFlat);
var makeFillcolorAttr = __webpack_require__(19326);
var scatterAttrs = __webpack_require__(36640);
var baseAttrs = __webpack_require__(9829);
var lineAttrs = scatterAttrs.line;
module.exports = {
  mode: scatterAttrs.mode,
  real: {
    valType: 'data_array',
    editType: 'calc+clearAxisTypes'
  },
  imag: {
    valType: 'data_array',
    editType: 'calc+clearAxisTypes'
  },
  text: scatterAttrs.text,
  texttemplate: texttemplateAttrs({
    editType: 'plot'
  }, {
    keys: ['real', 'imag', 'text']
  }),
  hovertext: scatterAttrs.hovertext,
  line: {
    color: lineAttrs.color,
    width: lineAttrs.width,
    dash: lineAttrs.dash,
    backoff: lineAttrs.backoff,
    shape: extendFlat({}, lineAttrs.shape, {
      values: ['linear', 'spline']
    }),
    smoothing: lineAttrs.smoothing,
    editType: 'calc'
  },
  connectgaps: scatterAttrs.connectgaps,
  marker: scatterAttrs.marker,
  cliponaxis: extendFlat({}, scatterAttrs.cliponaxis, {
    dflt: false
  }),
  textposition: scatterAttrs.textposition,
  textfont: scatterAttrs.textfont,
  fill: extendFlat({}, scatterAttrs.fill, {
    values: ['none', 'toself', 'tonext'],
    dflt: 'none'
  }),
  fillcolor: makeFillcolorAttr(),
  hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
    flags: ['real', 'imag', 'text', 'name']
  }),
  hoveron: scatterAttrs.hoveron,
  hovertemplate: hovertemplateAttrs(),
  selected: scatterAttrs.selected,
  unselected: scatterAttrs.unselected
};

/***/ }),

/***/ 44315:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isNumeric = __webpack_require__(10721);
var BADNUM = (__webpack_require__(63821).BADNUM);
var calcColorscale = __webpack_require__(77272);
var arraysToCalcdata = __webpack_require__(99203);
var calcSelection = __webpack_require__(48861);
var calcMarkerSize = (__webpack_require__(26544).calcMarkerSize);
module.exports = function calc(gd, trace) {
  var fullLayout = gd._fullLayout;
  var subplotId = trace.subplot;
  var realAxis = fullLayout[subplotId].realaxis;
  var imaginaryAxis = fullLayout[subplotId].imaginaryaxis;
  var realArray = realAxis.makeCalcdata(trace, 'real');
  var imagArray = imaginaryAxis.makeCalcdata(trace, 'imag');
  var len = trace._length;
  var cd = new Array(len);
  for (var i = 0; i < len; i++) {
    var real = realArray[i];
    var imag = imagArray[i];
    var cdi = cd[i] = {};
    if (isNumeric(real) && isNumeric(imag)) {
      cdi.real = real;
      cdi.imag = imag;
    } else {
      cdi.real = BADNUM;
    }
  }
  calcMarkerSize(trace, len);
  calcColorscale(gd, trace);
  arraysToCalcdata(cd, trace);
  calcSelection(cd, trace);
  return cd;
};

/***/ }),

/***/ 93788:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var subTypes = __webpack_require__(64726);
var handleMarkerDefaults = __webpack_require__(24272);
var handleLineDefaults = __webpack_require__(98168);
var handleLineShapeDefaults = __webpack_require__(91602);
var handleTextDefaults = __webpack_require__(663);
var handleFillColorDefaults = __webpack_require__(54114);
var PTS_LINESONLY = (__webpack_require__(32660).PTS_LINESONLY);
var attributes = __webpack_require__(69595);
module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
  function coerce(attr, dflt) {
    return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
  }
  var len = handleRealImagDefaults(traceIn, traceOut, layout, coerce);
  if (!len) {
    traceOut.visible = false;
    return;
  }
  coerce('mode', len < PTS_LINESONLY ? 'lines+markers' : 'lines');
  coerce('text');
  coerce('hovertext');
  if (traceOut.hoveron !== 'fills') coerce('hovertemplate');
  if (subTypes.hasMarkers(traceOut)) {
    handleMarkerDefaults(traceIn, traceOut, defaultColor, layout, coerce, {
      gradient: true
    });
  }
  if (subTypes.hasLines(traceOut)) {
    handleLineDefaults(traceIn, traceOut, defaultColor, layout, coerce, {
      backoff: true
    });
    handleLineShapeDefaults(traceIn, traceOut, coerce);
    coerce('connectgaps');
  }
  if (subTypes.hasText(traceOut)) {
    coerce('texttemplate');
    handleTextDefaults(traceIn, traceOut, layout, coerce);
  }
  var dfltHoverOn = [];
  if (subTypes.hasMarkers(traceOut) || subTypes.hasText(traceOut)) {
    coerce('cliponaxis');
    coerce('marker.maxdisplayed');
    dfltHoverOn.push('points');
  }
  coerce('fill');
  if (traceOut.fill !== 'none') {
    handleFillColorDefaults(traceIn, traceOut, defaultColor, coerce);
    if (!subTypes.hasLines(traceOut)) handleLineShapeDefaults(traceIn, traceOut, coerce);
  }
  if (traceOut.fill === 'tonext' || traceOut.fill === 'toself') {
    dfltHoverOn.push('fills');
  }
  coerce('hoveron', dfltHoverOn.join('+') || 'points');
  Lib.coerceSelectionMarkerOpacity(traceOut, coerce);
};
function handleRealImagDefaults(traceIn, traceOut, layout, coerce) {
  var real = coerce('real');
  var imag = coerce('imag');
  var len;
  if (real && imag) {
    len = Math.min(real.length, imag.length);
  }

  // TODO: handle this case outside supply defaults step
  if (Lib.isTypedArray(real)) {
    traceOut.real = real = Array.from(real);
  }
  if (Lib.isTypedArray(imag)) {
    traceOut.imag = imag = Array.from(imag);
  }
  traceOut._length = len;
  return len;
}

/***/ }),

/***/ 89419:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Axes = __webpack_require__(29714);
module.exports = function formatLabels(cdi, trace, fullLayout) {
  var labels = {};
  var subplot = fullLayout[trace.subplot]._subplot;
  labels.realLabel = Axes.tickText(subplot.radialAxis, cdi.real, true).text;
  labels.imagLabel = Axes.tickText(subplot.angularAxis, cdi.imag, true).text;
  return labels;
};

/***/ }),

/***/ 64422:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var scatterHover = __webpack_require__(37255);
function hoverPoints(pointData, xval, yval, hovermode) {
  var scatterPointData = scatterHover(pointData, xval, yval, hovermode);
  if (!scatterPointData || scatterPointData[0].index === false) return;
  var newPointData = scatterPointData[0];

  // hovering on fill case
  if (newPointData.index === undefined) {
    return scatterPointData;
  }
  var subplot = pointData.subplot;
  var cdi = newPointData.cd[newPointData.index];
  var trace = newPointData.trace;
  if (!subplot.isPtInside(cdi)) return;
  newPointData.xLabelVal = undefined;
  newPointData.yLabelVal = undefined;
  makeHoverPointText(cdi, trace, subplot, newPointData);
  newPointData.hovertemplate = trace.hovertemplate;
  return scatterPointData;
}
function makeHoverPointText(cdi, trace, subplot, pointData) {
  var realAxis = subplot.radialAxis;
  var imaginaryAxis = subplot.angularAxis;
  realAxis._hovertitle = 'real';
  imaginaryAxis._hovertitle = 'imag';
  var fullLayout = {};
  fullLayout[trace.subplot] = {
    _subplot: subplot
  };
  var labels = trace._module.formatLabels(cdi, trace, fullLayout);
  pointData.realLabel = labels.realLabel;
  pointData.imagLabel = labels.imagLabel;
  var hoverinfo = cdi.hi || trace.hoverinfo;
  var text = [];
  function textPart(ax, val) {
    text.push(ax._hovertitle + ': ' + val);
  }
  if (!trace.hovertemplate) {
    var parts = hoverinfo.split('+');
    if (parts.indexOf('all') !== -1) parts = ['real', 'imag', 'text'];
    if (parts.indexOf('real') !== -1) textPart(realAxis, pointData.realLabel);
    if (parts.indexOf('imag') !== -1) textPart(imaginaryAxis, pointData.imagLabel);
    if (parts.indexOf('text') !== -1 && pointData.text) {
      text.push(pointData.text);
      delete pointData.text;
    }
    pointData.extraText = text.join('<br>');
  }
}
module.exports = {
  hoverPoints: hoverPoints,
  makeHoverPointText: makeHoverPointText
};

/***/ }),

/***/ 73304:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = {
  moduleType: 'trace',
  name: 'scattersmith',
  basePlotModule: __webpack_require__(50358),
  categories: ['smith', 'symbols', 'showLegend', 'scatter-like'],
  attributes: __webpack_require__(69595),
  supplyDefaults: __webpack_require__(93788),
  colorbar: __webpack_require__(21146),
  formatLabels: __webpack_require__(89419),
  calc: __webpack_require__(44315),
  plot: __webpack_require__(6229),
  style: (__webpack_require__(9408).style),
  styleOnSelect: (__webpack_require__(9408).styleOnSelect),
  hoverPoints: (__webpack_require__(64422).hoverPoints),
  selectPoints: __webpack_require__(32665),
  meta: {}
};

/***/ }),

/***/ 6229:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var scatterPlot = __webpack_require__(36098);
var BADNUM = (__webpack_require__(63821).BADNUM);
var helpers = __webpack_require__(52007);
var smith = helpers.smith;
module.exports = function plot(gd, subplot, moduleCalcData) {
  var mlayer = subplot.layers.frontplot.select('g.scatterlayer');
  var xa = subplot.xaxis;
  var ya = subplot.yaxis;
  var plotinfo = {
    xaxis: xa,
    yaxis: ya,
    plot: subplot.framework,
    layerClipId: subplot._hasClipOnAxisFalse ? subplot.clipIds.forTraces : null
  };

  // convert:
  // 'c' (real,imag) -> (x,y)
  for (var i = 0; i < moduleCalcData.length; i++) {
    var cdi = moduleCalcData[i];
    for (var j = 0; j < cdi.length; j++) {
      if (j === 0) {
        cdi[0].trace._xA = xa;
        cdi[0].trace._yA = ya;
      }
      var cd = cdi[j];
      var real = cd.real;
      if (real === BADNUM) {
        cd.x = cd.y = BADNUM;
      } else {
        var t = smith([real, cd.imag]);
        cd.x = t[0];
        cd.y = t[1];
      }
    }
  }
  scatterPlot(gd, plotinfo, moduleCalcData, mlayer);
};

/***/ }),

/***/ 18483:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var hovertemplateAttrs = (__webpack_require__(3208)/* .hovertemplateAttrs */ .rb);
var texttemplateAttrs = (__webpack_require__(3208)/* .texttemplateAttrs */ .ay);
var makeFillcolorAttr = __webpack_require__(19326);
var scatterAttrs = __webpack_require__(36640);
var baseAttrs = __webpack_require__(9829);
var colorScaleAttrs = __webpack_require__(87163);
var dash = (__webpack_require__(94850)/* .dash */ .T);
var extendFlat = (__webpack_require__(93049).extendFlat);
var scatterMarkerAttrs = scatterAttrs.marker;
var scatterLineAttrs = scatterAttrs.line;
var scatterMarkerLineAttrs = scatterMarkerAttrs.line;
module.exports = {
  a: {
    valType: 'data_array',
    editType: 'calc'
  },
  b: {
    valType: 'data_array',
    editType: 'calc'
  },
  c: {
    valType: 'data_array',
    editType: 'calc'
  },
  sum: {
    valType: 'number',
    dflt: 0,
    min: 0,
    editType: 'calc'
  },
  mode: extendFlat({}, scatterAttrs.mode, {
    dflt: 'markers'
  }),
  text: extendFlat({}, scatterAttrs.text, {}),
  texttemplate: texttemplateAttrs({
    editType: 'plot'
  }, {
    keys: ['a', 'b', 'c', 'text']
  }),
  hovertext: extendFlat({}, scatterAttrs.hovertext, {}),
  line: {
    color: scatterLineAttrs.color,
    width: scatterLineAttrs.width,
    dash: dash,
    backoff: scatterLineAttrs.backoff,
    shape: extendFlat({}, scatterLineAttrs.shape, {
      values: ['linear', 'spline']
    }),
    smoothing: scatterLineAttrs.smoothing,
    editType: 'calc'
  },
  connectgaps: scatterAttrs.connectgaps,
  cliponaxis: scatterAttrs.cliponaxis,
  fill: extendFlat({}, scatterAttrs.fill, {
    values: ['none', 'toself', 'tonext'],
    dflt: 'none'
  }),
  fillcolor: makeFillcolorAttr(),
  marker: extendFlat({
    symbol: scatterMarkerAttrs.symbol,
    opacity: scatterMarkerAttrs.opacity,
    angle: scatterMarkerAttrs.angle,
    angleref: scatterMarkerAttrs.angleref,
    standoff: scatterMarkerAttrs.standoff,
    maxdisplayed: scatterMarkerAttrs.maxdisplayed,
    size: scatterMarkerAttrs.size,
    sizeref: scatterMarkerAttrs.sizeref,
    sizemin: scatterMarkerAttrs.sizemin,
    sizemode: scatterMarkerAttrs.sizemode,
    line: extendFlat({
      width: scatterMarkerLineAttrs.width,
      editType: 'calc'
    }, colorScaleAttrs('marker.line')),
    gradient: scatterMarkerAttrs.gradient,
    editType: 'calc'
  }, colorScaleAttrs('marker')),
  textfont: scatterAttrs.textfont,
  textposition: scatterAttrs.textposition,
  selected: scatterAttrs.selected,
  unselected: scatterAttrs.unselected,
  hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
    flags: ['a', 'b', 'c', 'text', 'name']
  }),
  hoveron: scatterAttrs.hoveron,
  hovertemplate: hovertemplateAttrs()
};

/***/ }),

/***/ 67091:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isNumeric = __webpack_require__(10721);
var calcColorscale = __webpack_require__(77272);
var arraysToCalcdata = __webpack_require__(99203);
var calcSelection = __webpack_require__(48861);
var calcMarkerSize = (__webpack_require__(26544).calcMarkerSize);
var dataArrays = ['a', 'b', 'c'];
var arraysToFill = {
  a: ['b', 'c'],
  b: ['a', 'c'],
  c: ['a', 'b']
};
module.exports = function calc(gd, trace) {
  var ternary = gd._fullLayout[trace.subplot];
  var displaySum = ternary.sum;
  var normSum = trace.sum || displaySum;
  var arrays = {
    a: trace.a,
    b: trace.b,
    c: trace.c
  };
  var i, j, dataArray, newArray, fillArray1, fillArray2;

  // fill in one missing component
  for (i = 0; i < dataArrays.length; i++) {
    dataArray = dataArrays[i];
    if (arrays[dataArray]) continue;
    fillArray1 = arrays[arraysToFill[dataArray][0]];
    fillArray2 = arrays[arraysToFill[dataArray][1]];
    newArray = new Array(fillArray1.length);
    for (j = 0; j < fillArray1.length; j++) {
      newArray[j] = normSum - fillArray1[j] - fillArray2[j];
    }
    arrays[dataArray] = newArray;
  }

  // make the calcdata array
  var serieslen = trace._length;
  var cd = new Array(serieslen);
  var a, b, c, norm, x, y;
  for (i = 0; i < serieslen; i++) {
    a = arrays.a[i];
    b = arrays.b[i];
    c = arrays.c[i];
    if (isNumeric(a) && isNumeric(b) && isNumeric(c)) {
      a = +a;
      b = +b;
      c = +c;
      norm = displaySum / (a + b + c);
      if (norm !== 1) {
        a *= norm;
        b *= norm;
        c *= norm;
      }
      // map a, b, c onto x and y where the full scale of y
      // is [0, sum], and x is [-sum, sum]
      // TODO: this makes `a` always the top, `b` the bottom left,
      // and `c` the bottom right. Do we want options to rearrange
      // these?
      y = a;
      x = c - b;
      cd[i] = {
        x: x,
        y: y,
        a: a,
        b: b,
        c: c
      };
    } else cd[i] = {
      x: false,
      y: false
    };
  }
  calcMarkerSize(trace, serieslen);
  calcColorscale(gd, trace);
  arraysToCalcdata(cd, trace);
  calcSelection(cd, trace);
  return cd;
};

/***/ }),

/***/ 79028:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var constants = __webpack_require__(32660);
var subTypes = __webpack_require__(64726);
var handleMarkerDefaults = __webpack_require__(24272);
var handleLineDefaults = __webpack_require__(98168);
var handleLineShapeDefaults = __webpack_require__(91602);
var handleTextDefaults = __webpack_require__(663);
var handleFillColorDefaults = __webpack_require__(54114);
var attributes = __webpack_require__(18483);
module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
  function coerce(attr, dflt) {
    return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
  }
  var a = coerce('a');
  var b = coerce('b');
  var c = coerce('c');
  var len;

  // allow any one array to be missing, len is the minimum length of those
  // present. Note that after coerce data_array's are either Arrays (which
  // are truthy even if empty) or undefined. As in scatter, an empty array
  // is different from undefined, because it can signify that this data is
  // not known yet but expected in the future
  if (a) {
    len = a.length;
    if (b) {
      len = Math.min(len, b.length);
      if (c) len = Math.min(len, c.length);
    } else if (c) len = Math.min(len, c.length);else len = 0;
  } else if (b && c) {
    len = Math.min(b.length, c.length);
  }
  if (!len) {
    traceOut.visible = false;
    return;
  }
  traceOut._length = len;
  coerce('sum');
  coerce('text');
  coerce('hovertext');
  if (traceOut.hoveron !== 'fills') coerce('hovertemplate');
  var defaultMode = len < constants.PTS_LINESONLY ? 'lines+markers' : 'lines';
  coerce('mode', defaultMode);
  if (subTypes.hasMarkers(traceOut)) {
    handleMarkerDefaults(traceIn, traceOut, defaultColor, layout, coerce, {
      gradient: true
    });
  }
  if (subTypes.hasLines(traceOut)) {
    handleLineDefaults(traceIn, traceOut, defaultColor, layout, coerce, {
      backoff: true
    });
    handleLineShapeDefaults(traceIn, traceOut, coerce);
    coerce('connectgaps');
  }
  if (subTypes.hasText(traceOut)) {
    coerce('texttemplate');
    handleTextDefaults(traceIn, traceOut, layout, coerce);
  }
  var dfltHoverOn = [];
  if (subTypes.hasMarkers(traceOut) || subTypes.hasText(traceOut)) {
    coerce('cliponaxis');
    coerce('marker.maxdisplayed');
    dfltHoverOn.push('points');
  }
  coerce('fill');
  if (traceOut.fill !== 'none') {
    handleFillColorDefaults(traceIn, traceOut, defaultColor, coerce);
    if (!subTypes.hasLines(traceOut)) handleLineShapeDefaults(traceIn, traceOut, coerce);
  }
  if (traceOut.fill === 'tonext' || traceOut.fill === 'toself') {
    dfltHoverOn.push('fills');
  }
  coerce('hoveron', dfltHoverOn.join('+') || 'points');
  Lib.coerceSelectionMarkerOpacity(traceOut, coerce);
};

/***/ }),

/***/ 94343:
/***/ (function(module) {

"use strict";


module.exports = function eventData(out, pt, trace, cd, pointNumber) {
  if (pt.xa) out.xaxis = pt.xa;
  if (pt.ya) out.yaxis = pt.ya;
  if (cd[pointNumber]) {
    var cdi = cd[pointNumber];

    // N.B. These are the normalized coordinates.
    out.a = cdi.a;
    out.b = cdi.b;
    out.c = cdi.c;
  } else {
    // for fill-hover only
    out.a = pt.a;
    out.b = pt.b;
    out.c = pt.c;
  }
  return out;
};

/***/ }),

/***/ 78995:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Axes = __webpack_require__(29714);
module.exports = function formatLabels(cdi, trace, fullLayout) {
  var labels = {};
  var subplot = fullLayout[trace.subplot]._subplot;
  labels.aLabel = Axes.tickText(subplot.aaxis, cdi.a, true).text;
  labels.bLabel = Axes.tickText(subplot.baxis, cdi.b, true).text;
  labels.cLabel = Axes.tickText(subplot.caxis, cdi.c, true).text;
  return labels;
};

/***/ }),

/***/ 26558:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var scatterHover = __webpack_require__(37255);
module.exports = function hoverPoints(pointData, xval, yval, hovermode) {
  var scatterPointData = scatterHover(pointData, xval, yval, hovermode);
  if (!scatterPointData || scatterPointData[0].index === false) return;
  var newPointData = scatterPointData[0];

  // if hovering on a fill, we don't show any point data so the label is
  // unchanged from what scatter gives us - except that it needs to
  // be constrained to the trianglular plot area, not just the rectangular
  // area defined by the synthetic x and y axes
  // TODO: in some cases the vertical middle of the shape is not within
  // the triangular viewport at all, so the label can become disconnected
  // from the shape entirely. But calculating what portion of the shape
  // is actually visible, as constrained by the diagonal axis lines, is not
  // so easy and anyway we lost the information we would have needed to do
  // this inside scatterHover.
  if (newPointData.index === undefined) {
    var yFracUp = 1 - newPointData.y0 / pointData.ya._length;
    var xLen = pointData.xa._length;
    var xMin = xLen * yFracUp / 2;
    var xMax = xLen - xMin;
    newPointData.x0 = Math.max(Math.min(newPointData.x0, xMax), xMin);
    newPointData.x1 = Math.max(Math.min(newPointData.x1, xMax), xMin);
    return scatterPointData;
  }
  var cdi = newPointData.cd[newPointData.index];
  var trace = newPointData.trace;
  var subplot = newPointData.subplot;
  newPointData.a = cdi.a;
  newPointData.b = cdi.b;
  newPointData.c = cdi.c;
  newPointData.xLabelVal = undefined;
  newPointData.yLabelVal = undefined;
  var fullLayout = {};
  fullLayout[trace.subplot] = {
    _subplot: subplot
  };
  var labels = trace._module.formatLabels(cdi, trace, fullLayout);
  newPointData.aLabel = labels.aLabel;
  newPointData.bLabel = labels.bLabel;
  newPointData.cLabel = labels.cLabel;
  var hoverinfo = cdi.hi || trace.hoverinfo;
  var text = [];
  function textPart(ax, val) {
    text.push(ax._hovertitle + ': ' + val);
  }
  if (!trace.hovertemplate) {
    var parts = hoverinfo.split('+');
    if (parts.indexOf('all') !== -1) parts = ['a', 'b', 'c'];
    if (parts.indexOf('a') !== -1) textPart(subplot.aaxis, newPointData.aLabel);
    if (parts.indexOf('b') !== -1) textPart(subplot.baxis, newPointData.bLabel);
    if (parts.indexOf('c') !== -1) textPart(subplot.caxis, newPointData.cLabel);
  }
  newPointData.extraText = text.join('<br>');
  newPointData.hovertemplate = trace.hovertemplate;
  return scatterPointData;
};

/***/ }),

/***/ 12864:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = {
  attributes: __webpack_require__(18483),
  supplyDefaults: __webpack_require__(79028),
  colorbar: __webpack_require__(21146),
  formatLabels: __webpack_require__(78995),
  calc: __webpack_require__(67091),
  plot: __webpack_require__(79005),
  style: (__webpack_require__(9408).style),
  styleOnSelect: (__webpack_require__(9408).styleOnSelect),
  hoverPoints: __webpack_require__(26558),
  selectPoints: __webpack_require__(32665),
  eventData: __webpack_require__(94343),
  moduleType: 'trace',
  name: 'scatterternary',
  basePlotModule: __webpack_require__(7638),
  categories: ['ternary', 'symbols', 'showLegend', 'scatter-like'],
  meta: {}
};

/***/ }),

/***/ 79005:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var scatterPlot = __webpack_require__(36098);
module.exports = function plot(gd, ternary, moduleCalcData) {
  var plotContainer = ternary.plotContainer;

  // remove all nodes inside the scatter layer
  plotContainer.select('.scatterlayer').selectAll('*').remove();

  // mimic cartesian plotinfo
  var xa = ternary.xaxis;
  var ya = ternary.yaxis;
  var plotinfo = {
    xaxis: xa,
    yaxis: ya,
    plot: plotContainer,
    layerClipId: ternary._hasClipOnAxisFalse ? ternary.clipIdRelative : null
  };
  var scatterLayer = ternary.layers.frontplot.select('g.scatterlayer');
  for (var i = 0; i < moduleCalcData.length; i++) {
    var cdi = moduleCalcData[i];
    if (cdi.length) {
      cdi[0].trace._xA = xa;
      cdi[0].trace._yA = ya;
    }
  }
  scatterPlot(gd, plotinfo, moduleCalcData, scatterLayer);
};

/***/ }),

/***/ 68697:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var scatterAttrs = __webpack_require__(36640);
var colorScaleAttrs = __webpack_require__(87163);
var axisHoverFormat = (__webpack_require__(80712).axisHoverFormat);
var hovertemplateAttrs = (__webpack_require__(3208)/* .hovertemplateAttrs */ .rb);
var scatterGlAttrs = __webpack_require__(92089);
var cartesianIdRegex = (__webpack_require__(54826).idRegex);
var templatedArray = (__webpack_require__(78032).templatedArray);
var extendFlat = (__webpack_require__(93049).extendFlat);
var scatterMarkerAttrs = scatterAttrs.marker;
var scatterMarkerLineAttrs = scatterMarkerAttrs.line;
var markerLineAttrs = extendFlat(colorScaleAttrs('marker.line', {
  editTypeOverride: 'calc'
}), {
  width: extendFlat({}, scatterMarkerLineAttrs.width, {
    editType: 'calc'
  }),
  editType: 'calc'
});
var markerAttrs = extendFlat(colorScaleAttrs('marker'), {
  symbol: scatterMarkerAttrs.symbol,
  angle: scatterMarkerAttrs.angle,
  size: extendFlat({}, scatterMarkerAttrs.size, {
    editType: 'markerSize'
  }),
  sizeref: scatterMarkerAttrs.sizeref,
  sizemin: scatterMarkerAttrs.sizemin,
  sizemode: scatterMarkerAttrs.sizemode,
  opacity: scatterMarkerAttrs.opacity,
  colorbar: scatterMarkerAttrs.colorbar,
  line: markerLineAttrs,
  editType: 'calc'
});
markerAttrs.color.editType = markerAttrs.cmin.editType = markerAttrs.cmax.editType = 'style';
function makeAxesValObject(axLetter) {
  return {
    valType: 'info_array',
    freeLength: true,
    editType: 'calc',
    items: {
      valType: 'subplotid',
      regex: cartesianIdRegex[axLetter],
      editType: 'plot'
    }
  };
}
module.exports = {
  dimensions: templatedArray('dimension', {
    visible: {
      valType: 'boolean',
      dflt: true,
      editType: 'calc'
    },
    label: {
      valType: 'string',
      editType: 'calc'
    },
    values: {
      valType: 'data_array',
      editType: 'calc+clearAxisTypes'
    },
    axis: {
      type: {
        valType: 'enumerated',
        values: ['linear', 'log', 'date', 'category'],
        editType: 'calc+clearAxisTypes'
      },
      // TODO make 'true' the default in v3?
      matches: {
        valType: 'boolean',
        dflt: false,
        editType: 'calc'
      },
      editType: 'calc+clearAxisTypes'
    },
    // TODO should add an attribute to pin down x only vars and y only vars
    // like https://seaborn.pydata.org/generated/seaborn.pairplot.html
    // x_vars and y_vars

    // maybe more axis defaulting option e.g. `showgrid: false`

    editType: 'calc+clearAxisTypes'
  }),
  // mode: {}, (only 'markers' for now)

  text: extendFlat({}, scatterGlAttrs.text, {}),
  hovertext: extendFlat({}, scatterGlAttrs.hovertext, {}),
  hovertemplate: hovertemplateAttrs(),
  xhoverformat: axisHoverFormat('x'),
  yhoverformat: axisHoverFormat('y'),
  marker: markerAttrs,
  xaxes: makeAxesValObject('x'),
  yaxes: makeAxesValObject('y'),
  diagonal: {
    visible: {
      valType: 'boolean',
      dflt: true,
      editType: 'calc'
    },
    // type: 'scattergl' | 'histogram' | 'box' | 'violin'
    // ...
    // more options

    editType: 'calc'
  },
  showupperhalf: {
    valType: 'boolean',
    dflt: true,
    editType: 'calc'
  },
  showlowerhalf: {
    valType: 'boolean',
    dflt: true,
    editType: 'calc'
  },
  selected: {
    marker: scatterGlAttrs.selected.marker,
    editType: 'calc'
  },
  unselected: {
    marker: scatterGlAttrs.unselected.marker,
    editType: 'calc'
  },
  opacity: scatterGlAttrs.opacity
};

/***/ }),

/***/ 86690:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Registry = __webpack_require__(33626);
var Grid = __webpack_require__(83595);
module.exports = {
  moduleType: 'trace',
  name: 'splom',
  categories: ['gl', 'regl', 'cartesian', 'symbols', 'showLegend', 'scatter-like'],
  attributes: __webpack_require__(68697),
  supplyDefaults: __webpack_require__(52542),
  colorbar: __webpack_require__(21146),
  calc: __webpack_require__(55325),
  plot: __webpack_require__(83027),
  hoverPoints: (__webpack_require__(25600).hoverPoints),
  selectPoints: __webpack_require__(13392),
  editStyle: __webpack_require__(27926),
  meta: {}
};

// splom traces use the 'grid' component to generate their axes,
// register it here
Registry.register(Grid);

/***/ }),

/***/ 571:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var createLine = __webpack_require__(49478);
var Registry = __webpack_require__(33626);
var prepareRegl = __webpack_require__(22459);
var getModuleCalcData = (__webpack_require__(4173)/* .getModuleCalcData */ .eV);
var Cartesian = __webpack_require__(37703);
var getFromId = (__webpack_require__(5975).getFromId);
var shouldShowZeroLine = (__webpack_require__(29714).shouldShowZeroLine);
var SPLOM = 'splom';
var reglPrecompiled = {};
function plot(gd) {
  var fullLayout = gd._fullLayout;
  var _module = Registry.getModule(SPLOM);
  var splomCalcData = getModuleCalcData(gd.calcdata, _module)[0];
  var success = prepareRegl(gd, ['ANGLE_instanced_arrays', 'OES_element_index_uint'], reglPrecompiled);
  if (!success) return;
  if (fullLayout._hasOnlyLargeSploms) {
    updateGrid(gd);
  }
  _module.plot(gd, {}, splomCalcData);
}
function drag(gd) {
  var cd = gd.calcdata;
  var fullLayout = gd._fullLayout;
  if (fullLayout._hasOnlyLargeSploms) {
    updateGrid(gd);
  }
  for (var i = 0; i < cd.length; i++) {
    var cd0 = cd[i][0];
    var trace = cd0.trace;
    var scene = fullLayout._splomScenes[trace.uid];
    if (trace.type === 'splom' && scene && scene.matrix) {
      dragOne(gd, trace, scene);
    }
  }
}
function dragOne(gd, trace, scene) {
  var visibleLength = scene.matrixOptions.data.length;
  var visibleDims = trace._visibleDims;
  var ranges = scene.viewOpts.ranges = new Array(visibleLength);
  for (var k = 0; k < visibleDims.length; k++) {
    var i = visibleDims[k];
    var rng = ranges[k] = new Array(4);
    var xa = getFromId(gd, trace._diag[i][0]);
    if (xa) {
      rng[0] = xa.r2l(xa.range[0]);
      rng[2] = xa.r2l(xa.range[1]);
    }
    var ya = getFromId(gd, trace._diag[i][1]);
    if (ya) {
      rng[1] = ya.r2l(ya.range[0]);
      rng[3] = ya.r2l(ya.range[1]);
    }
  }
  if (scene.selectBatch.length || scene.unselectBatch.length) {
    scene.matrix.update({
      ranges: ranges
    }, {
      ranges: ranges
    });
  } else {
    scene.matrix.update({
      ranges: ranges
    });
  }
}
function updateGrid(gd) {
  var fullLayout = gd._fullLayout;
  var regl = fullLayout._glcanvas.data()[0].regl;
  var splomGrid = fullLayout._splomGrid;
  if (!splomGrid) {
    splomGrid = fullLayout._splomGrid = createLine(regl);
  }
  splomGrid.update(makeGridData(gd));
}
function makeGridData(gd) {
  var plotGlPixelRatio = gd._context.plotGlPixelRatio;
  var fullLayout = gd._fullLayout;
  var gs = fullLayout._size;
  var fullView = [0, 0, fullLayout.width * plotGlPixelRatio, fullLayout.height * plotGlPixelRatio];
  var lookup = {};
  var k;
  function push(prefix, ax, x0, x1, y0, y1) {
    x0 *= plotGlPixelRatio;
    x1 *= plotGlPixelRatio;
    y0 *= plotGlPixelRatio;
    y1 *= plotGlPixelRatio;
    var lcolor = ax[prefix + 'color'];
    var lwidth = ax[prefix + 'width'];
    var key = String(lcolor + lwidth);
    if (key in lookup) {
      lookup[key].data.push(NaN, NaN, x0, x1, y0, y1);
    } else {
      lookup[key] = {
        data: [x0, x1, y0, y1],
        join: 'rect',
        thickness: lwidth * plotGlPixelRatio,
        color: lcolor,
        viewport: fullView,
        range: fullView,
        overlay: false
      };
    }
  }
  for (k in fullLayout._splomSubplots) {
    var sp = fullLayout._plots[k];
    var xa = sp.xaxis;
    var ya = sp.yaxis;
    var xVals = xa._gridVals;
    var yVals = ya._gridVals;
    var xOffset = xa._offset;
    var xLength = xa._length;
    var yLength = ya._length;

    // ya.l2p assumes top-to-bottom coordinate system (a la SVG),
    // we need to compute bottom-to-top offsets and slopes:
    var yOffset = gs.b + ya.domain[0] * gs.h;
    var ym = -ya._m;
    var yb = -ym * ya.r2l(ya.range[0], ya.calendar);
    var x, y;
    if (xa.showgrid) {
      for (k = 0; k < xVals.length; k++) {
        x = xOffset + xa.l2p(xVals[k].x);
        push('grid', xa, x, yOffset, x, yOffset + yLength);
      }
    }
    if (ya.showgrid) {
      for (k = 0; k < yVals.length; k++) {
        y = yOffset + yb + ym * yVals[k].x;
        push('grid', ya, xOffset, y, xOffset + xLength, y);
      }
    }
    if (shouldShowZeroLine(gd, xa, ya)) {
      x = xOffset + xa.l2p(0);
      push('zeroline', xa, x, yOffset, x, yOffset + yLength);
    }
    if (shouldShowZeroLine(gd, ya, xa)) {
      y = yOffset + yb + 0;
      push('zeroline', ya, xOffset, y, xOffset + xLength, y);
    }
  }
  var gridBatches = [];
  for (k in lookup) {
    gridBatches.push(lookup[k]);
  }
  return gridBatches;
}
function clean(newFullData, newFullLayout, oldFullData, oldFullLayout) {
  var lookup = {};
  var i;
  if (oldFullLayout._splomScenes) {
    for (i = 0; i < newFullData.length; i++) {
      var newTrace = newFullData[i];
      if (newTrace.type === 'splom') {
        lookup[newTrace.uid] = 1;
      }
    }
    for (i = 0; i < oldFullData.length; i++) {
      var oldTrace = oldFullData[i];
      if (!lookup[oldTrace.uid]) {
        var scene = oldFullLayout._splomScenes[oldTrace.uid];
        if (scene && scene.destroy) scene.destroy();
        // must first set scene to null in order to get garbage collected
        oldFullLayout._splomScenes[oldTrace.uid] = null;
        delete oldFullLayout._splomScenes[oldTrace.uid];
      }
    }
  }
  if (Object.keys(oldFullLayout._splomScenes || {}).length === 0) {
    delete oldFullLayout._splomScenes;
  }
  if (oldFullLayout._splomGrid && !newFullLayout._hasOnlyLargeSploms && oldFullLayout._hasOnlyLargeSploms) {
    // must first set scene to null in order to get garbage collected
    oldFullLayout._splomGrid.destroy();
    oldFullLayout._splomGrid = null;
    delete oldFullLayout._splomGrid;
  }
  Cartesian.clean(newFullData, newFullLayout, oldFullData, oldFullLayout);
}
module.exports = {
  name: SPLOM,
  attr: Cartesian.attr,
  attrRegex: Cartesian.attrRegex,
  layoutAttributes: Cartesian.layoutAttributes,
  supplyLayoutDefaults: Cartesian.supplyLayoutDefaults,
  drawFramework: Cartesian.drawFramework,
  plot: plot,
  drag: drag,
  updateGrid: updateGrid,
  clean: clean,
  updateFx: Cartesian.updateFx,
  toSVG: Cartesian.toSVG,
  reglPrecompiled: reglPrecompiled
};

/***/ }),

/***/ 55325:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var AxisIDs = __webpack_require__(5975);
var calcMarkerSize = (__webpack_require__(26544).calcMarkerSize);
var calcAxisExpansion = (__webpack_require__(26544).calcAxisExpansion);
var calcColorscale = __webpack_require__(77272);
var convertMarkerSelection = (__webpack_require__(19937).markerSelection);
var convertMarkerStyle = (__webpack_require__(19937).markerStyle);
var sceneUpdate = __webpack_require__(78880);
var BADNUM = (__webpack_require__(63821).BADNUM);
var TOO_MANY_POINTS = (__webpack_require__(29483).TOO_MANY_POINTS);
module.exports = function calc(gd, trace) {
  var dimensions = trace.dimensions;
  var commonLength = trace._length;
  var opts = {};
  // 'c' for calculated, 'l' for linear,
  // only differ here for log axes, pass ldata to createMatrix as 'data'
  var cdata = opts.cdata = [];
  var ldata = opts.data = [];
  // keep track of visible dimensions
  var visibleDims = trace._visibleDims = [];
  var i, k, dim, xa, ya;
  function makeCalcdata(ax, dim) {
    // call makeCalcdata with fake input
    var ccol = ax.makeCalcdata({
      v: dim.values,
      vcalendar: trace.calendar
    }, 'v');
    for (var j = 0; j < ccol.length; j++) {
      ccol[j] = ccol[j] === BADNUM ? NaN : ccol[j];
    }
    cdata.push(ccol);
    ldata.push(ax.type === 'log' ? Lib.simpleMap(ccol, ax.c2l) : ccol);
  }
  for (i = 0; i < dimensions.length; i++) {
    dim = dimensions[i];
    if (dim.visible) {
      xa = AxisIDs.getFromId(gd, trace._diag[i][0]);
      ya = AxisIDs.getFromId(gd, trace._diag[i][1]);

      // if corresponding x & y axes don't have matching types, skip dim
      if (xa && ya && xa.type !== ya.type) {
        Lib.log('Skipping splom dimension ' + i + ' with conflicting axis types');
        continue;
      }
      if (xa) {
        makeCalcdata(xa, dim);
        if (ya && ya.type === 'category') {
          ya._categories = xa._categories.slice();
        }
      } else {
        // should not make it here, if both xa and ya undefined
        makeCalcdata(ya, dim);
      }
      visibleDims.push(i);
    }
  }
  calcColorscale(gd, trace);
  Lib.extendFlat(opts, convertMarkerStyle(gd, trace));
  var visibleLength = cdata.length;
  var hasTooManyPoints = visibleLength * commonLength > TOO_MANY_POINTS;

  // Reuse SVG scatter axis expansion routine.
  // For graphs with very large number of points and array marker.size,
  // use average marker size instead to speed things up.
  var ppad;
  if (hasTooManyPoints) {
    ppad = opts.sizeAvg || Math.max(opts.size, 3);
  } else {
    ppad = calcMarkerSize(trace, commonLength);
  }
  for (k = 0; k < visibleDims.length; k++) {
    i = visibleDims[k];
    dim = dimensions[i];
    xa = AxisIDs.getFromId(gd, trace._diag[i][0]) || {};
    ya = AxisIDs.getFromId(gd, trace._diag[i][1]) || {};
    calcAxisExpansion(gd, trace, xa, ya, cdata[k], cdata[k], ppad);
  }
  var scene = sceneUpdate(gd, trace);
  if (!scene.matrix) scene.matrix = true;
  scene.matrixOptions = opts;
  scene.selectedOptions = convertMarkerSelection(gd, trace, trace.selected);
  scene.unselectedOptions = convertMarkerSelection(gd, trace, trace.unselected);
  return [{
    x: false,
    y: false,
    t: {},
    trace: trace
  }];
};

/***/ }),

/***/ 52542:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var handleArrayContainerDefaults = __webpack_require__(59008);
var attributes = __webpack_require__(68697);
var subTypes = __webpack_require__(64726);
var handleMarkerDefaults = __webpack_require__(24272);
var mergeLength = __webpack_require__(63197);
var isOpenSymbol = (__webpack_require__(4075).isOpenSymbol);
module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
  function coerce(attr, dflt) {
    return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
  }
  var dimensions = handleArrayContainerDefaults(traceIn, traceOut, {
    name: 'dimensions',
    handleItemDefaults: dimensionDefaults
  });
  var showDiag = coerce('diagonal.visible');
  var showUpper = coerce('showupperhalf');
  var showLower = coerce('showlowerhalf');
  var dimLength = mergeLength(traceOut, dimensions, 'values');
  if (!dimLength || !showDiag && !showUpper && !showLower) {
    traceOut.visible = false;
    return;
  }
  coerce('text');
  coerce('hovertext');
  coerce('hovertemplate');
  coerce('xhoverformat');
  coerce('yhoverformat');
  handleMarkerDefaults(traceIn, traceOut, defaultColor, layout, coerce, {
    noAngleRef: true,
    noStandOff: true
  });
  var isOpen = isOpenSymbol(traceOut.marker.symbol);
  var isBubble = subTypes.isBubble(traceOut);
  coerce('marker.line.width', isOpen || isBubble ? 1 : 0);
  handleAxisDefaults(traceIn, traceOut, layout, coerce);
  Lib.coerceSelectionMarkerOpacity(traceOut, coerce);
};
function dimensionDefaults(dimIn, dimOut) {
  function coerce(attr, dflt) {
    return Lib.coerce(dimIn, dimOut, attributes.dimensions, attr, dflt);
  }
  coerce('label');
  var values = coerce('values');
  if (!(values && values.length)) dimOut.visible = false;else coerce('visible');
  coerce('axis.type');
  coerce('axis.matches');
}
function handleAxisDefaults(traceIn, traceOut, layout, coerce) {
  var dimensions = traceOut.dimensions;
  var dimLength = dimensions.length;
  var showUpper = traceOut.showupperhalf;
  var showLower = traceOut.showlowerhalf;
  var showDiag = traceOut.diagonal.visible;
  var i, j;
  var xAxesDflt = new Array(dimLength);
  var yAxesDflt = new Array(dimLength);
  for (i = 0; i < dimLength; i++) {
    var suffix = i ? i + 1 : '';
    xAxesDflt[i] = 'x' + suffix;
    yAxesDflt[i] = 'y' + suffix;
  }
  var xaxes = coerce('xaxes', xAxesDflt);
  var yaxes = coerce('yaxes', yAxesDflt);

  // build list of [x,y] axis corresponding to each dimensions[i],
  // very useful for passing options to regl-splom
  var diag = traceOut._diag = new Array(dimLength);

  // lookup for 'drawn' x|y axes, to avoid costly indexOf downstream
  traceOut._xaxes = {};
  traceOut._yaxes = {};

  // list of 'drawn' x|y axes, use to generate list of subplots
  var xList = [];
  var yList = [];
  function fillAxisStashes(axId, counterAxId, dim, list) {
    if (!axId) return;
    var axLetter = axId.charAt(0);
    var stash = layout._splomAxes[axLetter];
    traceOut['_' + axLetter + 'axes'][axId] = 1;
    list.push(axId);
    if (!(axId in stash)) {
      var s = stash[axId] = {};
      if (dim) {
        s.label = dim.label || '';
        if (dim.visible && dim.axis) {
          if (dim.axis.type) s.type = dim.axis.type;
          if (dim.axis.matches) s.matches = counterAxId;
        }
      }
    }
  }

  // cases where showDiag and showLower or showUpper are false
  // no special treatment as the 'drawn' x-axes and y-axes no longer match
  // the dimensions items and xaxes|yaxes 1-to-1
  var mustShiftX = !showDiag && !showLower;
  var mustShiftY = !showDiag && !showUpper;
  traceOut._axesDim = {};
  for (i = 0; i < dimLength; i++) {
    var dim = dimensions[i];
    var i0 = i === 0;
    var iN = i === dimLength - 1;
    var xaId = i0 && mustShiftX || iN && mustShiftY ? undefined : xaxes[i];
    var yaId = i0 && mustShiftY || iN && mustShiftX ? undefined : yaxes[i];
    fillAxisStashes(xaId, yaId, dim, xList);
    fillAxisStashes(yaId, xaId, dim, yList);
    diag[i] = [xaId, yaId];
    traceOut._axesDim[xaId] = i;
    traceOut._axesDim[yaId] = i;
  }

  // fill in splom subplot keys
  for (i = 0; i < xList.length; i++) {
    for (j = 0; j < yList.length; j++) {
      var id = xList[i] + yList[j];
      if (i > j && showUpper) {
        layout._splomSubplots[id] = 1;
      } else if (i < j && showLower) {
        layout._splomSubplots[id] = 1;
      } else if (i === j && (showDiag || !showLower || !showUpper)) {
        // need to include diagonal subplots when
        // hiding one half and the diagonal
        layout._splomSubplots[id] = 1;
      }
    }
  }

  // when lower half is omitted, or when just the diagonal is gone,
  // override grid default to make sure axes remain on
  // the left/bottom of the plot area
  if (!showLower || !showDiag && showUpper && showLower) {
    layout._splomGridDflt.xside = 'bottom';
    layout._splomGridDflt.yside = 'left';
  }
}

/***/ }),

/***/ 27926:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var calcColorscale = __webpack_require__(77272);
var convertMarkerStyle = (__webpack_require__(19937).markerStyle);
module.exports = function editStyle(gd, cd0) {
  var trace = cd0.trace;
  var scene = gd._fullLayout._splomScenes[trace.uid];
  if (scene) {
    calcColorscale(gd, trace);
    Lib.extendFlat(scene.matrixOptions, convertMarkerStyle(gd, trace));
    // TODO [un]selected styles?

    var opts = Lib.extendFlat({}, scene.matrixOptions, scene.viewOpts);

    // TODO this is too long for arrayOk attributes!
    scene.matrix.update(opts, null);
  }
};

/***/ }),

/***/ 52875:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


exports.getDimIndex = function getDimIndex(trace, ax) {
  var axId = ax._id;
  var axLetter = axId.charAt(0);
  var ind = {
    x: 0,
    y: 1
  }[axLetter];
  var visibleDims = trace._visibleDims;
  for (var k = 0; k < visibleDims.length; k++) {
    var i = visibleDims[k];
    if (trace._diag[i][ind] === axId) return k;
  }
  return false;
};

/***/ }),

/***/ 25600:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__(52875);
var calcHover = (__webpack_require__(36544).calcHover);
var getFromId = (__webpack_require__(29714).getFromId);
var extendFlat = (__webpack_require__(93049).extendFlat);
function hoverPoints(pointData, xval, yval, hovermode, opts) {
  if (!opts) opts = {};
  var hovermodeHasX = (hovermode || '').charAt(0) === 'x';
  var hovermodeHasY = (hovermode || '').charAt(0) === 'y';
  var points = _hoverPoints(pointData, xval, yval);
  if ((hovermodeHasX || hovermodeHasY) && opts.hoversubplots === 'axis' && points[0]) {
    var subplotsWith = (hovermodeHasX ? pointData.xa : pointData.ya)._subplotsWith;
    var gd = opts.gd;
    var _pointData = extendFlat({}, pointData);
    for (var i = 0; i < subplotsWith.length; i++) {
      var spId = subplotsWith[i];

      // do not reselect on the initial subplot
      if (spId === pointData.xa._id + pointData.ya._id) continue;
      if (hovermodeHasY) {
        _pointData.xa = getFromId(gd, spId, 'x');
      } else {
        // hovermodeHasX
        _pointData.ya = getFromId(gd, spId, 'y');
      }
      var axisHoversubplots = hovermodeHasX || hovermodeHasY;
      var newPoints = _hoverPoints(_pointData, xval, yval, axisHoversubplots);
      points = points.concat(newPoints);
    }
  }
  return points;
}
function _hoverPoints(pointData, xval, yval, axisHoversubplots) {
  var cd = pointData.cd;
  var trace = cd[0].trace;
  var scene = pointData.scene;
  var cdata = scene.matrixOptions.cdata;
  var xa = pointData.xa;
  var ya = pointData.ya;
  var xpx = xa.c2p(xval);
  var ypx = ya.c2p(yval);
  var maxDistance = pointData.distance;
  var xi = helpers.getDimIndex(trace, xa);
  var yi = helpers.getDimIndex(trace, ya);
  if (xi === false || yi === false) return [pointData];
  var x = cdata[xi];
  var y = cdata[yi];
  var id, dxy;
  var minDist = maxDistance;
  for (var i = 0; i < x.length; i++) {
    if (axisHoversubplots && i !== pointData.index) continue;
    var ptx = x[i];
    var pty = y[i];
    var dx = xa.c2p(ptx) - xpx;
    var dy = ya.c2p(pty) - ypx;
    var dist = Math.sqrt(dx * dx + dy * dy);
    if (axisHoversubplots || dist < minDist) {
      minDist = dxy = dist;
      id = i;
    }
  }
  pointData.index = id;
  pointData.distance = minDist;
  pointData.dxy = dxy;
  if (id === undefined) return [pointData];
  return [calcHover(pointData, x, y, trace)];
}
module.exports = {
  hoverPoints: hoverPoints
};

/***/ }),

/***/ 91450:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var index = __webpack_require__(86690);
index.basePlotModule = __webpack_require__(571), module.exports = index;

/***/ }),

/***/ 83027:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var createMatrix = __webpack_require__(31239);
var Lib = __webpack_require__(34809);
var AxisIDs = __webpack_require__(5975);
var selectMode = (__webpack_require__(70414).selectMode);
module.exports = function plot(gd, _, splomCalcData) {
  if (!splomCalcData.length) return;
  for (var i = 0; i < splomCalcData.length; i++) {
    plotOne(gd, splomCalcData[i][0]);
  }
};
function plotOne(gd, cd0) {
  var fullLayout = gd._fullLayout;
  var gs = fullLayout._size;
  var trace = cd0.trace;
  var stash = cd0.t;
  var scene = fullLayout._splomScenes[trace.uid];
  var matrixOpts = scene.matrixOptions;
  var cdata = matrixOpts.cdata;
  var regl = fullLayout._glcanvas.data()[0].regl;
  var dragmode = fullLayout.dragmode;
  var xa, ya;
  var i, j, k;
  if (cdata.length === 0) return;

  // augment options with proper upper/lower halves
  // regl-splom's default grid starts from bottom-left
  matrixOpts.lower = trace.showupperhalf;
  matrixOpts.upper = trace.showlowerhalf;
  matrixOpts.diagonal = trace.diagonal.visible;
  var visibleDims = trace._visibleDims;
  var visibleLength = cdata.length;
  var viewOpts = scene.viewOpts = {};
  viewOpts.ranges = new Array(visibleLength);
  viewOpts.domains = new Array(visibleLength);
  for (k = 0; k < visibleDims.length; k++) {
    i = visibleDims[k];
    var rng = viewOpts.ranges[k] = new Array(4);
    var dmn = viewOpts.domains[k] = new Array(4);
    xa = AxisIDs.getFromId(gd, trace._diag[i][0]);
    if (xa) {
      rng[0] = xa._rl[0];
      rng[2] = xa._rl[1];
      dmn[0] = xa.domain[0];
      dmn[2] = xa.domain[1];
    }
    ya = AxisIDs.getFromId(gd, trace._diag[i][1]);
    if (ya) {
      rng[1] = ya._rl[0];
      rng[3] = ya._rl[1];
      dmn[1] = ya.domain[0];
      dmn[3] = ya.domain[1];
    }
  }
  var plotGlPixelRatio = gd._context.plotGlPixelRatio;
  var l = gs.l * plotGlPixelRatio;
  var b = gs.b * plotGlPixelRatio;
  var w = gs.w * plotGlPixelRatio;
  var h = gs.h * plotGlPixelRatio;
  viewOpts.viewport = [l, b, w + l, h + b];
  if (scene.matrix === true) {
    scene.matrix = createMatrix(regl);
  }
  var clickSelectEnabled = fullLayout.clickmode.indexOf('select') > -1;
  var isSelectMode = selectMode(dragmode) || !!trace.selectedpoints || clickSelectEnabled;
  var needsBaseUpdate = true;
  if (isSelectMode) {
    var commonLength = trace._length;

    // regenerate scene batch, if traces number changed during selection
    if (trace.selectedpoints) {
      scene.selectBatch = trace.selectedpoints;
      var selPts = trace.selectedpoints;
      var selDict = {};
      for (i = 0; i < selPts.length; i++) {
        selDict[selPts[i]] = true;
      }
      var unselPts = [];
      for (i = 0; i < commonLength; i++) {
        if (!selDict[i]) unselPts.push(i);
      }
      scene.unselectBatch = unselPts;
    }

    // precalculate px coords since we are not going to pan during select
    var xpx = stash.xpx = new Array(visibleLength);
    var ypx = stash.ypx = new Array(visibleLength);
    for (k = 0; k < visibleDims.length; k++) {
      i = visibleDims[k];
      xa = AxisIDs.getFromId(gd, trace._diag[i][0]);
      if (xa) {
        xpx[k] = new Array(commonLength);
        for (j = 0; j < commonLength; j++) {
          xpx[k][j] = xa.c2p(cdata[k][j]);
        }
      }
      ya = AxisIDs.getFromId(gd, trace._diag[i][1]);
      if (ya) {
        ypx[k] = new Array(commonLength);
        for (j = 0; j < commonLength; j++) {
          ypx[k][j] = ya.c2p(cdata[k][j]);
        }
      }
    }
    if (scene.selectBatch.length || scene.unselectBatch.length) {
      var unselOpts = Lib.extendFlat({}, matrixOpts, scene.unselectedOptions, viewOpts);
      var selOpts = Lib.extendFlat({}, matrixOpts, scene.selectedOptions, viewOpts);
      scene.matrix.update(unselOpts, selOpts);
      needsBaseUpdate = false;
    }
  } else {
    stash.xpx = stash.ypx = null;
  }
  if (needsBaseUpdate) {
    var opts = Lib.extendFlat({}, matrixOpts, viewOpts);
    scene.matrix.update(opts, null);
  }
}

/***/ }),

/***/ 78880:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
module.exports = function sceneUpdate(gd, trace) {
  var fullLayout = gd._fullLayout;
  var uid = trace.uid;

  // must place ref to 'scene' in fullLayout, so that:
  // - it can be relinked properly on updates
  // - it can be destroyed properly when needed
  var splomScenes = fullLayout._splomScenes;
  if (!splomScenes) splomScenes = fullLayout._splomScenes = {};
  var reset = {
    dirty: true,
    selectBatch: [],
    unselectBatch: []
  };
  var first = {
    matrix: false,
    selectBatch: [],
    unselectBatch: []
  };
  var scene = splomScenes[trace.uid];
  if (!scene) {
    scene = splomScenes[uid] = Lib.extendFlat({}, reset, first);
    scene.draw = function draw() {
      if (scene.matrix && scene.matrix.draw) {
        if (scene.selectBatch.length || scene.unselectBatch.length) {
          scene.matrix.draw(scene.unselectBatch, scene.selectBatch);
        } else {
          scene.matrix.draw();
        }
      }
      scene.dirty = false;
    };

    // remove scene resources
    scene.destroy = function destroy() {
      if (scene.matrix && scene.matrix.destroy) {
        scene.matrix.destroy();
      }
      scene.matrixOptions = null;
      scene.selectBatch = null;
      scene.unselectBatch = null;
      scene = null;
    };
  }

  // In case if we have scene from the last calc - reset data
  if (!scene.dirty) {
    Lib.extendFlat(scene, reset);
  }
  return scene;
};

/***/ }),

/***/ 13392:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var pushUnique = Lib.pushUnique;
var subTypes = __webpack_require__(64726);
var helpers = __webpack_require__(52875);
module.exports = function select(searchInfo, selectionTester) {
  var cd = searchInfo.cd;
  var trace = cd[0].trace;
  var stash = cd[0].t;
  var scene = searchInfo.scene;
  var cdata = scene.matrixOptions.cdata;
  var xa = searchInfo.xaxis;
  var ya = searchInfo.yaxis;
  var selection = [];
  if (!scene) return selection;
  var hasOnlyLines = !subTypes.hasMarkers(trace) && !subTypes.hasText(trace);
  if (trace.visible !== true || hasOnlyLines) return selection;
  var xi = helpers.getDimIndex(trace, xa);
  var yi = helpers.getDimIndex(trace, ya);
  if (xi === false || yi === false) return selection;
  var xpx = stash.xpx[xi];
  var ypx = stash.ypx[yi];
  var x = cdata[xi];
  var y = cdata[yi];
  var els = (searchInfo.scene.selectBatch || []).slice();
  var unels = [];

  // degenerate polygon does not enable selection
  // filter out points by visible scatter ones
  if (selectionTester !== false && !selectionTester.degenerate) {
    for (var i = 0; i < x.length; i++) {
      if (selectionTester.contains([xpx[i], ypx[i]], null, i, searchInfo)) {
        selection.push({
          pointNumber: i,
          x: x[i],
          y: y[i]
        });
        pushUnique(els, i);
      } else if (els.indexOf(i) !== -1) {
        pushUnique(els, i);
      } else {
        unels.push(i);
      }
    }
  }
  var matrixOpts = scene.matrixOptions;
  if (!els.length && !unels.length) {
    scene.matrix.update(matrixOpts, null);
  } else if (!scene.selectBatch.length && !scene.unselectBatch.length) {
    scene.matrix.update(scene.unselectedOptions, Lib.extendFlat({}, matrixOpts, scene.selectedOptions, scene.viewOpts));
  }
  scene.selectBatch = els;
  scene.unselectBatch = unels;
  return selection;
};

/***/ }),

/***/ 14774:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var colorScaleAttrs = __webpack_require__(87163);
var axisHoverFormat = (__webpack_require__(80712).axisHoverFormat);
var hovertemplateAttrs = (__webpack_require__(3208)/* .hovertemplateAttrs */ .rb);
var mesh3dAttrs = __webpack_require__(42450);
var baseAttrs = __webpack_require__(9829);
var extendFlat = (__webpack_require__(93049).extendFlat);
var attrs = {
  x: {
    valType: 'data_array',
    editType: 'calc+clearAxisTypes'
  },
  y: {
    valType: 'data_array',
    editType: 'calc+clearAxisTypes'
  },
  z: {
    valType: 'data_array',
    editType: 'calc+clearAxisTypes'
  },
  u: {
    valType: 'data_array',
    editType: 'calc'
  },
  v: {
    valType: 'data_array',
    editType: 'calc'
  },
  w: {
    valType: 'data_array',
    editType: 'calc'
  },
  starts: {
    x: {
      valType: 'data_array',
      editType: 'calc'
    },
    y: {
      valType: 'data_array',
      editType: 'calc'
    },
    z: {
      valType: 'data_array',
      editType: 'calc'
    },
    editType: 'calc'
  },
  maxdisplayed: {
    valType: 'integer',
    min: 0,
    dflt: 1000,
    editType: 'calc'
  },
  // TODO
  //
  // Should add 'absolute' (like cone traces have), but currently gl-streamtube3d's
  // `absoluteTubeSize` doesn't behave well enough for our needs.
  //
  // 'fixed' would be a nice addition to plot stream 'lines', see
  // https://github.com/plotly/plotly.js/commit/812be20750e21e0a1831975001c248d365850f73#r29129877
  //
  // sizemode: {
  //     valType: 'enumerated',
  //     values: ['scaled', 'absolute', 'fixed'],
  //     dflt: 'scaled',
  //     editType: 'calc',
  //
  // },

  sizeref: {
    valType: 'number',
    editType: 'calc',
    min: 0,
    dflt: 1
  },
  text: {
    valType: 'string',
    dflt: '',
    editType: 'calc'
  },
  hovertext: {
    valType: 'string',
    dflt: '',
    editType: 'calc'
  },
  hovertemplate: hovertemplateAttrs({
    editType: 'calc'
  }, {
    keys: ['tubex', 'tubey', 'tubez', 'tubeu', 'tubev', 'tubew', 'norm', 'divergence']
  }),
  uhoverformat: axisHoverFormat('u', 1),
  vhoverformat: axisHoverFormat('v', 1),
  whoverformat: axisHoverFormat('w', 1),
  xhoverformat: axisHoverFormat('x'),
  yhoverformat: axisHoverFormat('y'),
  zhoverformat: axisHoverFormat('z'),
  showlegend: extendFlat({}, baseAttrs.showlegend, {
    dflt: false
  })
};
extendFlat(attrs, colorScaleAttrs('', {
  colorAttr: 'u/v/w norm',
  showScaleDflt: true,
  editTypeOverride: 'calc'
}));
var fromMesh3d = ['opacity', 'lightposition', 'lighting'];
fromMesh3d.forEach(function (k) {
  attrs[k] = mesh3dAttrs[k];
});
attrs.hoverinfo = extendFlat({}, baseAttrs.hoverinfo, {
  editType: 'calc',
  flags: ['x', 'y', 'z', 'u', 'v', 'w', 'norm', 'divergence', 'text', 'name'],
  dflt: 'x+y+z+norm+text+name'
});
attrs.transforms = undefined;
module.exports = attrs;

/***/ }),

/***/ 36402:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var colorscaleCalc = __webpack_require__(28379);
function calc(gd, trace) {
  trace._len = Math.min(trace.u.length, trace.v.length, trace.w.length, trace.x.length, trace.y.length, trace.z.length);
  trace._u = filter(trace.u, trace._len);
  trace._v = filter(trace.v, trace._len);
  trace._w = filter(trace.w, trace._len);
  trace._x = filter(trace.x, trace._len);
  trace._y = filter(trace.y, trace._len);
  trace._z = filter(trace.z, trace._len);
  var grid = processGrid(trace);
  trace._gridFill = grid.fill;
  trace._Xs = grid.Xs;
  trace._Ys = grid.Ys;
  trace._Zs = grid.Zs;
  trace._len = grid.len;
  var slen = 0;
  var startx, starty, startz;
  if (trace.starts) {
    startx = filter(trace.starts.x || []);
    starty = filter(trace.starts.y || []);
    startz = filter(trace.starts.z || []);
    slen = Math.min(startx.length, starty.length, startz.length);
  }
  trace._startsX = startx || [];
  trace._startsY = starty || [];
  trace._startsZ = startz || [];
  var normMax = 0;
  var normMin = Infinity;
  var i;
  for (i = 0; i < trace._len; i++) {
    var u = trace._u[i];
    var v = trace._v[i];
    var w = trace._w[i];
    var norm = Math.sqrt(u * u + v * v + w * w);
    normMax = Math.max(normMax, norm);
    normMin = Math.min(normMin, norm);
  }
  colorscaleCalc(gd, trace, {
    vals: [normMin, normMax],
    containerStr: '',
    cLetter: 'c'
  });
  for (i = 0; i < slen; i++) {
    var sx = startx[i];
    grid.xMax = Math.max(grid.xMax, sx);
    grid.xMin = Math.min(grid.xMin, sx);
    var sy = starty[i];
    grid.yMax = Math.max(grid.yMax, sy);
    grid.yMin = Math.min(grid.yMin, sy);
    var sz = startz[i];
    grid.zMax = Math.max(grid.zMax, sz);
    grid.zMin = Math.min(grid.zMin, sz);
  }
  trace._slen = slen;
  trace._normMax = normMax;
  trace._xbnds = [grid.xMin, grid.xMax];
  trace._ybnds = [grid.yMin, grid.yMax];
  trace._zbnds = [grid.zMin, grid.zMax];
}
function processGrid(trace) {
  var x = trace._x;
  var y = trace._y;
  var z = trace._z;
  var len = trace._len;
  var i, j, k;
  var xMax = -Infinity;
  var xMin = Infinity;
  var yMax = -Infinity;
  var yMin = Infinity;
  var zMax = -Infinity;
  var zMin = Infinity;
  var gridFill = '';
  var filledX;
  var filledY;
  var filledZ;
  var firstX, lastX;
  var firstY, lastY;
  var firstZ, lastZ;
  if (len) {
    firstX = x[0];
    firstY = y[0];
    firstZ = z[0];
  }
  if (len > 1) {
    lastX = x[len - 1];
    lastY = y[len - 1];
    lastZ = z[len - 1];
  }
  for (i = 0; i < len; i++) {
    xMax = Math.max(xMax, x[i]);
    xMin = Math.min(xMin, x[i]);
    yMax = Math.max(yMax, y[i]);
    yMin = Math.min(yMin, y[i]);
    zMax = Math.max(zMax, z[i]);
    zMin = Math.min(zMin, z[i]);
    if (!filledX && x[i] !== firstX) {
      filledX = true;
      gridFill += 'x';
    }
    if (!filledY && y[i] !== firstY) {
      filledY = true;
      gridFill += 'y';
    }
    if (!filledZ && z[i] !== firstZ) {
      filledZ = true;
      gridFill += 'z';
    }
  }
  // fill if not filled - case of having dimension(s) with one item
  if (!filledX) gridFill += 'x';
  if (!filledY) gridFill += 'y';
  if (!filledZ) gridFill += 'z';
  var Xs = distinctVals(trace._x);
  var Ys = distinctVals(trace._y);
  var Zs = distinctVals(trace._z);
  gridFill = gridFill.replace('x', (firstX > lastX ? '-' : '+') + 'x');
  gridFill = gridFill.replace('y', (firstY > lastY ? '-' : '+') + 'y');
  gridFill = gridFill.replace('z', (firstZ > lastZ ? '-' : '+') + 'z');
  var empty = function () {
    len = 0;
    Xs = [];
    Ys = [];
    Zs = [];
  };

  // Over-specified mesh case, this would error in tube2mesh
  if (!len || len < Xs.length * Ys.length * Zs.length) empty();
  var getArray = function (c) {
    return c === 'x' ? x : c === 'y' ? y : z;
  };
  var getVals = function (c) {
    return c === 'x' ? Xs : c === 'y' ? Ys : Zs;
  };
  var getDir = function (c) {
    return c[len - 1] < c[0] ? -1 : 1;
  };
  var arrK = getArray(gridFill[1]);
  var arrJ = getArray(gridFill[3]);
  var arrI = getArray(gridFill[5]);
  var nk = getVals(gridFill[1]).length;
  var nj = getVals(gridFill[3]).length;
  var ni = getVals(gridFill[5]).length;
  var arbitrary = false;
  var getIndex = function (_i, _j, _k) {
    return nk * (nj * _i + _j) + _k;
  };
  var dirK = getDir(getArray(gridFill[1]));
  var dirJ = getDir(getArray(gridFill[3]));
  var dirI = getDir(getArray(gridFill[5]));
  for (i = 0; i < ni - 1; i++) {
    for (j = 0; j < nj - 1; j++) {
      for (k = 0; k < nk - 1; k++) {
        var q000 = getIndex(i, j, k);
        var q001 = getIndex(i, j, k + 1);
        var q010 = getIndex(i, j + 1, k);
        var q100 = getIndex(i + 1, j, k);
        if (!(arrK[q000] * dirK < arrK[q001] * dirK) || !(arrJ[q000] * dirJ < arrJ[q010] * dirJ) || !(arrI[q000] * dirI < arrI[q100] * dirI)) {
          arbitrary = true;
        }
        if (arbitrary) break;
      }
      if (arbitrary) break;
    }
    if (arbitrary) break;
  }
  if (arbitrary) {
    Lib.warn('Encountered arbitrary coordinates! Unable to input data grid.');
    empty();
  }
  return {
    xMin: xMin,
    yMin: yMin,
    zMin: zMin,
    xMax: xMax,
    yMax: yMax,
    zMax: zMax,
    Xs: Xs,
    Ys: Ys,
    Zs: Zs,
    len: len,
    fill: gridFill
  };
}
function distinctVals(col) {
  return Lib.distinctVals(col).vals;
}
function filter(arr, len) {
  if (len === undefined) len = arr.length;

  // no need for casting typed arrays to numbers
  if (Lib.isTypedArray(arr)) return arr.subarray(0, len);
  var values = [];
  for (var i = 0; i < len; i++) {
    values[i] = +arr[i];
  }
  return values;
}
module.exports = {
  calc: calc,
  filter: filter,
  processGrid: processGrid
};

/***/ }),

/***/ 49280:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var tube2mesh = (__webpack_require__(99098).gl_streamtube3d);
var createTubeMesh = tube2mesh.createTubeMesh;
var Lib = __webpack_require__(34809);
var parseColorScale = (__webpack_require__(46998).parseColorScale);
var extractOpts = (__webpack_require__(88856).extractOpts);
var zip3 = __webpack_require__(88239);
var axisName2scaleIndex = {
  xaxis: 0,
  yaxis: 1,
  zaxis: 2
};
function Streamtube(scene, uid) {
  this.scene = scene;
  this.uid = uid;
  this.mesh = null;
  this.data = null;
}
var proto = Streamtube.prototype;
proto.handlePick = function (selection) {
  var sceneLayout = this.scene.fullSceneLayout;
  var dataScale = this.scene.dataScale;
  function fromDataScale(v, axisName) {
    var ax = sceneLayout[axisName];
    var scale = dataScale[axisName2scaleIndex[axisName]];
    return ax.l2c(v) / scale;
  }
  if (selection.object === this.mesh) {
    var pos = selection.data.position;
    var uvx = selection.data.velocity;
    selection.traceCoordinate = [fromDataScale(pos[0], 'xaxis'), fromDataScale(pos[1], 'yaxis'), fromDataScale(pos[2], 'zaxis'), fromDataScale(uvx[0], 'xaxis'), fromDataScale(uvx[1], 'yaxis'), fromDataScale(uvx[2], 'zaxis'),
    // u/v/w norm
    selection.data.intensity * this.data._normMax,
    // divergence
    selection.data.divergence];
    selection.textLabel = this.data.hovertext || this.data.text;
    return true;
  }
};
function getDfltStartingPositions(vec) {
  var len = vec.length;
  var s;
  if (len > 2) {
    s = vec.slice(1, len - 1);
  } else if (len === 2) {
    s = [(vec[0] + vec[1]) / 2];
  } else {
    s = vec;
  }
  return s;
}
function getBoundPads(vec) {
  var len = vec.length;
  if (len === 1) {
    return [0.5, 0.5];
  } else {
    return [vec[1] - vec[0], vec[len - 1] - vec[len - 2]];
  }
}
function convert(scene, trace) {
  var sceneLayout = scene.fullSceneLayout;
  var dataScale = scene.dataScale;
  var len = trace._len;
  var tubeOpts = {};
  function toDataCoords(arr, axisName) {
    var ax = sceneLayout[axisName];
    var scale = dataScale[axisName2scaleIndex[axisName]];
    return Lib.simpleMap(arr, function (v) {
      return ax.d2l(v) * scale;
    });
  }
  tubeOpts.vectors = zip3(toDataCoords(trace._u, 'xaxis'), toDataCoords(trace._v, 'yaxis'), toDataCoords(trace._w, 'zaxis'), len);

  // Over-specified mesh case, this would error in tube2mesh
  if (!len) {
    return {
      positions: [],
      cells: []
    };
  }
  var meshx = toDataCoords(trace._Xs, 'xaxis');
  var meshy = toDataCoords(trace._Ys, 'yaxis');
  var meshz = toDataCoords(trace._Zs, 'zaxis');
  tubeOpts.meshgrid = [meshx, meshy, meshz];
  tubeOpts.gridFill = trace._gridFill;
  var slen = trace._slen;
  if (slen) {
    tubeOpts.startingPositions = zip3(toDataCoords(trace._startsX, 'xaxis'), toDataCoords(trace._startsY, 'yaxis'), toDataCoords(trace._startsZ, 'zaxis'));
  } else {
    // Default starting positions:
    //
    // if len>2, cut xz plane at min-y,
    // takes all x/y/z pts on that plane except those on the edges
    // to generate "well-defined" tubes,
    //
    // if len=2, take position halfway between two the pts,
    //
    // if len=1, take that pt
    var sy0 = meshy[0];
    var sx = getDfltStartingPositions(meshx);
    var sz = getDfltStartingPositions(meshz);
    var startingPositions = new Array(sx.length * sz.length);
    var m = 0;
    for (var i = 0; i < sx.length; i++) {
      for (var k = 0; k < sz.length; k++) {
        startingPositions[m++] = [sx[i], sy0, sz[k]];
      }
    }
    tubeOpts.startingPositions = startingPositions;
  }
  tubeOpts.colormap = parseColorScale(trace);
  tubeOpts.tubeSize = trace.sizeref;
  tubeOpts.maxLength = trace.maxdisplayed;

  // add some padding around the bounds
  // to e.g. allow tubes starting from a slice of the x/y/z mesh
  // to go beyond bounds a little bit w/o getting clipped
  var xbnds = toDataCoords(trace._xbnds, 'xaxis');
  var ybnds = toDataCoords(trace._ybnds, 'yaxis');
  var zbnds = toDataCoords(trace._zbnds, 'zaxis');
  var xpads = getBoundPads(meshx);
  var ypads = getBoundPads(meshy);
  var zpads = getBoundPads(meshz);
  var bounds = [[xbnds[0] - xpads[0], ybnds[0] - ypads[0], zbnds[0] - zpads[0]], [xbnds[1] + xpads[1], ybnds[1] + ypads[1], zbnds[1] + zpads[1]]];
  var meshData = tube2mesh(tubeOpts, bounds);

  // N.B. cmin/cmax correspond to the min/max vector norm
  // in the u/v/w arrays, which in general is NOT equal to max
  // intensity that colors the tubes.
  var cOpts = extractOpts(trace);
  meshData.vertexIntensityBounds = [cOpts.min / trace._normMax, cOpts.max / trace._normMax];

  // pass gl-mesh3d lighting attributes
  var lp = trace.lightposition;
  meshData.lightPosition = [lp.x, lp.y, lp.z];
  meshData.ambient = trace.lighting.ambient;
  meshData.diffuse = trace.lighting.diffuse;
  meshData.specular = trace.lighting.specular;
  meshData.roughness = trace.lighting.roughness;
  meshData.fresnel = trace.lighting.fresnel;
  meshData.opacity = trace.opacity;

  // stash autorange pad value
  trace._pad = meshData.tubeScale * trace.sizeref * 2;
  return meshData;
}
proto.update = function (data) {
  this.data = data;
  var meshData = convert(this.scene, data);
  this.mesh.update(meshData);
};
proto.dispose = function () {
  this.scene.glplot.remove(this.mesh);
  this.mesh.dispose();
};
function createStreamtubeTrace(scene, data) {
  var gl = scene.glplot.gl;
  var meshData = convert(scene, data);
  var mesh = createTubeMesh(gl, meshData);
  var streamtube = new Streamtube(scene, data.uid);
  streamtube.mesh = mesh;
  streamtube.data = data;
  mesh._trace = streamtube;
  scene.glplot.add(mesh);
  return streamtube;
}
module.exports = createStreamtubeTrace;

/***/ }),

/***/ 52737:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var colorscaleDefaults = __webpack_require__(39356);
var attributes = __webpack_require__(14774);
module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
  function coerce(attr, dflt) {
    return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
  }
  var u = coerce('u');
  var v = coerce('v');
  var w = coerce('w');
  var x = coerce('x');
  var y = coerce('y');
  var z = coerce('z');
  if (!u || !u.length || !v || !v.length || !w || !w.length || !x || !x.length || !y || !y.length || !z || !z.length) {
    traceOut.visible = false;
    return;
  }
  coerce('starts.x');
  coerce('starts.y');
  coerce('starts.z');
  coerce('maxdisplayed');
  coerce('sizeref');
  coerce('lighting.ambient');
  coerce('lighting.diffuse');
  coerce('lighting.specular');
  coerce('lighting.roughness');
  coerce('lighting.fresnel');
  coerce('lightposition.x');
  coerce('lightposition.y');
  coerce('lightposition.z');
  colorscaleDefaults(traceIn, traceOut, layout, coerce, {
    prefix: '',
    cLetter: 'c'
  });
  coerce('text');
  coerce('hovertext');
  coerce('hovertemplate');
  coerce('uhoverformat');
  coerce('vhoverformat');
  coerce('whoverformat');
  coerce('xhoverformat');
  coerce('yhoverformat');
  coerce('zhoverformat');

  // disable 1D transforms (for now)
  // x/y/z and u/v/w have matching lengths,
  // but they don't have to match with starts.(x|y|z)
  traceOut._length = null;
};

/***/ }),

/***/ 51943:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = {
  moduleType: 'trace',
  name: 'streamtube',
  basePlotModule: __webpack_require__(2487),
  categories: ['gl3d', 'showLegend'],
  attributes: __webpack_require__(14774),
  supplyDefaults: __webpack_require__(52737),
  colorbar: {
    min: 'cmin',
    max: 'cmax'
  },
  calc: (__webpack_require__(36402).calc),
  plot: __webpack_require__(49280),
  eventData: function (out, pt) {
    out.tubex = out.x;
    out.tubey = out.y;
    out.tubez = out.z;
    out.tubeu = pt.traceCoordinate[3];
    out.tubev = pt.traceCoordinate[4];
    out.tubew = pt.traceCoordinate[5];
    out.norm = pt.traceCoordinate[6];
    out.divergence = pt.traceCoordinate[7];

    // Does not correspond to input x/y/z, so delete them
    delete out.x;
    delete out.y;
    delete out.z;
    return out;
  },
  meta: {}
};

/***/ }),

/***/ 56708:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var baseAttrs = __webpack_require__(9829);
var hovertemplateAttrs = (__webpack_require__(3208)/* .hovertemplateAttrs */ .rb);
var texttemplateAttrs = (__webpack_require__(3208)/* .texttemplateAttrs */ .ay);
var colorScaleAttrs = __webpack_require__(87163);
var domainAttrs = (__webpack_require__(13792)/* .attributes */ .u);
var pieAttrs = __webpack_require__(55412);
var constants = __webpack_require__(2032);
var extendFlat = (__webpack_require__(93049).extendFlat);
var pattern = (__webpack_require__(94850)/* .pattern */ .k);
module.exports = {
  labels: {
    valType: 'data_array',
    editType: 'calc'
  },
  parents: {
    valType: 'data_array',
    editType: 'calc'
  },
  values: {
    valType: 'data_array',
    editType: 'calc'
  },
  branchvalues: {
    valType: 'enumerated',
    values: ['remainder', 'total'],
    dflt: 'remainder',
    editType: 'calc'
  },
  count: {
    valType: 'flaglist',
    flags: ['branches', 'leaves'],
    dflt: 'leaves',
    editType: 'calc'
  },
  level: {
    valType: 'any',
    editType: 'plot',
    anim: true
  },
  maxdepth: {
    valType: 'integer',
    editType: 'plot',
    dflt: -1
  },
  marker: extendFlat({
    colors: {
      valType: 'data_array',
      editType: 'calc'
    },
    // colorinheritance: {
    //     valType: 'enumerated',
    //     values: ['per-branch', 'per-label', false]
    // },

    line: {
      color: extendFlat({}, pieAttrs.marker.line.color, {
        dflt: null
      }),
      width: extendFlat({}, pieAttrs.marker.line.width, {
        dflt: 1
      }),
      editType: 'calc'
    },
    pattern: pattern,
    editType: 'calc'
  }, colorScaleAttrs('marker', {
    colorAttr: 'colors',
    anim: false // TODO: set to anim: true?
  })),
  leaf: {
    opacity: {
      valType: 'number',
      editType: 'style',
      min: 0,
      max: 1
    },
    editType: 'plot'
  },
  text: pieAttrs.text,
  textinfo: {
    valType: 'flaglist',
    flags: ['label', 'text', 'value', 'current path', 'percent root', 'percent entry', 'percent parent'],
    extras: ['none'],
    editType: 'plot'
  },
  // TODO: incorporate `label` and `value` in the eventData
  texttemplate: texttemplateAttrs({
    editType: 'plot'
  }, {
    keys: constants.eventDataKeys.concat(['label', 'value'])
  }),
  hovertext: pieAttrs.hovertext,
  hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
    flags: ['label', 'text', 'value', 'name', 'current path', 'percent root', 'percent entry', 'percent parent'],
    dflt: 'label+text+value+name'
  }),
  hovertemplate: hovertemplateAttrs({}, {
    keys: constants.eventDataKeys
  }),
  textfont: pieAttrs.textfont,
  insidetextorientation: pieAttrs.insidetextorientation,
  insidetextfont: pieAttrs.insidetextfont,
  outsidetextfont: extendFlat({}, pieAttrs.outsidetextfont, {}),
  rotation: {
    valType: 'angle',
    dflt: 0,
    editType: 'plot'
  },
  sort: pieAttrs.sort,
  root: {
    color: {
      valType: 'color',
      editType: 'calc',
      dflt: 'rgba(0,0,0,0)'
    },
    editType: 'calc'
  },
  domain: domainAttrs({
    name: 'sunburst',
    trace: true,
    editType: 'calc'
  })
};

/***/ }),

/***/ 14724:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var plots = __webpack_require__(44122);
exports.name = 'sunburst';
exports.plot = function (gd, traces, transitionOpts, makeOnCompleteCallback) {
  plots.plotBasePlot(exports.name, gd, traces, transitionOpts, makeOnCompleteCallback);
};
exports.clean = function (newFullData, newFullLayout, oldFullData, oldFullLayout) {
  plots.cleanBasePlot(exports.name, newFullData, newFullLayout, oldFullData, oldFullLayout);
};

/***/ }),

/***/ 14852:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var d3Hierarchy = __webpack_require__(92264);
var isNumeric = __webpack_require__(10721);
var Lib = __webpack_require__(34809);
var makeColorScaleFn = (__webpack_require__(88856).makeColorScaleFuncFromTrace);
var makePullColorFn = (__webpack_require__(44148).makePullColorFn);
var generateExtendedColors = (__webpack_require__(44148).generateExtendedColors);
var colorscaleCalc = (__webpack_require__(88856).calc);
var ALMOST_EQUAL = (__webpack_require__(63821).ALMOST_EQUAL);
var sunburstExtendedColorWays = {};
var treemapExtendedColorWays = {};
var icicleExtendedColorWays = {};
exports.calc = function (gd, trace) {
  var fullLayout = gd._fullLayout;
  var ids = trace.ids;
  var hasIds = Lib.isArrayOrTypedArray(ids);
  var labels = trace.labels;
  var parents = trace.parents;
  var values = trace.values;
  var hasValues = Lib.isArrayOrTypedArray(values);
  var cd = [];
  var parent2children = {};
  var refs = {};
  var addToLookup = function (parent, v) {
    if (parent2children[parent]) parent2children[parent].push(v);else parent2children[parent] = [v];
    refs[v] = 1;
  };

  // treat number `0` as valid
  var isValidKey = function (k) {
    return k || typeof k === 'number';
  };
  var isValidVal = function (i) {
    return !hasValues || isNumeric(values[i]) && values[i] >= 0;
  };
  var len;
  var isValid;
  var getId;
  if (hasIds) {
    len = Math.min(ids.length, parents.length);
    isValid = function (i) {
      return isValidKey(ids[i]) && isValidVal(i);
    };
    getId = function (i) {
      return String(ids[i]);
    };
  } else {
    len = Math.min(labels.length, parents.length);
    isValid = function (i) {
      return isValidKey(labels[i]) && isValidVal(i);
    };
    // TODO We could allow some label / parent duplication
    //
    // From AJ:
    //  It would work OK for one level
    //  (multiple rows with the same name and different parents -
    //  or even the same parent) but if that name is then used as a parent
    //  which one is it?
    getId = function (i) {
      return String(labels[i]);
    };
  }
  if (hasValues) len = Math.min(len, values.length);
  for (var i = 0; i < len; i++) {
    if (isValid(i)) {
      var id = getId(i);
      var pid = isValidKey(parents[i]) ? String(parents[i]) : '';
      var cdi = {
        i: i,
        id: id,
        pid: pid,
        label: isValidKey(labels[i]) ? String(labels[i]) : ''
      };
      if (hasValues) cdi.v = +values[i];
      cd.push(cdi);
      addToLookup(pid, id);
    }
  }
  if (!parent2children['']) {
    var impliedRoots = [];
    var k;
    for (k in parent2children) {
      if (!refs[k]) {
        impliedRoots.push(k);
      }
    }

    // if an `id` has no ref in the `parents` array,
    // take it as being the root node

    if (impliedRoots.length === 1) {
      k = impliedRoots[0];
      cd.unshift({
        hasImpliedRoot: true,
        id: k,
        pid: '',
        label: k
      });
    } else {
      return Lib.warn(['Multiple implied roots, cannot build', trace.type, 'hierarchy of', trace.name + '.', 'These roots include:', impliedRoots.join(', ')].join(' '));
    }
  } else if (parent2children[''].length > 1) {
    var dummyId = Lib.randstr();

    // if multiple rows linked to the root node,
    // add dummy "root of roots" node to make d3 build the hierarchy successfully

    for (var j = 0; j < cd.length; j++) {
      if (cd[j].pid === '') {
        cd[j].pid = dummyId;
      }
    }
    cd.unshift({
      hasMultipleRoots: true,
      id: dummyId,
      pid: '',
      label: ''
    });
  }

  // TODO might be better to replace stratify() with our own algorithm
  var root;
  try {
    root = d3Hierarchy.stratify().id(function (d) {
      return d.id;
    }).parentId(function (d) {
      return d.pid;
    })(cd);
  } catch (e) {
    return Lib.warn(['Failed to build', trace.type, 'hierarchy of', trace.name + '.', 'Error:', e.message].join(' '));
  }
  var hierarchy = d3Hierarchy.hierarchy(root);
  var failed = false;
  if (hasValues) {
    switch (trace.branchvalues) {
      case 'remainder':
        hierarchy.sum(function (d) {
          return d.data.v;
        });
        break;
      case 'total':
        hierarchy.each(function (d) {
          var cdi = d.data.data;
          var v = cdi.v;
          if (d.children) {
            var partialSum = d.children.reduce(function (a, c) {
              return a + c.data.data.v;
            }, 0);

            // N.B. we must fill in `value` for generated sectors
            // with the partialSum to compute the correct partition
            if (cdi.hasImpliedRoot || cdi.hasMultipleRoots) {
              v = partialSum;
            }
            if (v < partialSum * ALMOST_EQUAL) {
              failed = true;
              return Lib.warn(['Total value for node', d.data.data.id, 'of', trace.name, 'is smaller than the sum of its children.', '\nparent value =', v, '\nchildren sum =', partialSum].join(' '));
            }
          }
          d.value = v;
        });
        break;
    }
  } else {
    countDescendants(hierarchy, trace, {
      branches: trace.count.indexOf('branches') !== -1,
      leaves: trace.count.indexOf('leaves') !== -1
    });
  }
  if (failed) return;

  // TODO add way to sort by height also?
  if (trace.sort) {
    hierarchy.sort(function (a, b) {
      return b.value - a.value;
    });
  }
  var pullColor;
  var scaleColor;
  var colors = trace.marker.colors || [];
  var hasColors = !!colors.length;
  if (trace._hasColorscale) {
    if (!hasColors) {
      colors = hasValues ? trace.values : trace._values;
    }
    colorscaleCalc(gd, trace, {
      vals: colors,
      containerStr: 'marker',
      cLetter: 'c'
    });
    scaleColor = makeColorScaleFn(trace.marker);
  } else {
    pullColor = makePullColorFn(fullLayout['_' + trace.type + 'colormap']);
  }

  // TODO keep track of 'root-children' (i.e. branch) for hover info etc.

  hierarchy.each(function (d) {
    var cdi = d.data.data;
    // N.B. this mutates items in `cd`
    cdi.color = trace._hasColorscale ? scaleColor(colors[cdi.i]) : pullColor(colors[cdi.i], cdi.id);
  });
  cd[0].hierarchy = hierarchy;
  return cd;
};

/*
 * `calc` filled in (and collated) explicit colors.
 * Now we need to propagate these explicit colors to other traces,
 * and fill in default colors.
 * This is done after sorting, so we pick defaults
 * in the order slices will be displayed
 */
exports._runCrossTraceCalc = function (desiredType, gd) {
  var fullLayout = gd._fullLayout;
  var calcdata = gd.calcdata;
  var colorWay = fullLayout[desiredType + 'colorway'];
  var colorMap = fullLayout['_' + desiredType + 'colormap'];
  if (fullLayout['extend' + desiredType + 'colors']) {
    colorWay = generateExtendedColors(colorWay, desiredType === 'icicle' ? icicleExtendedColorWays : desiredType === 'treemap' ? treemapExtendedColorWays : sunburstExtendedColorWays);
  }
  var dfltColorCount = 0;
  var rootColor;
  function pickColor(d) {
    var cdi = d.data.data;
    var id = cdi.id;
    if (cdi.color === false) {
      if (colorMap[id]) {
        // have we seen this label and assigned a color to it in a previous trace?
        cdi.color = colorMap[id];
      } else if (d.parent) {
        if (d.parent.parent) {
          // from third-level on, inherit from parent
          cdi.color = d.parent.data.data.color;
        } else {
          // pick new color for second level
          colorMap[id] = cdi.color = colorWay[dfltColorCount % colorWay.length];
          dfltColorCount++;
        }
      } else {
        // set root color. no coloring by default.
        cdi.color = rootColor;
      }
    }
  }
  for (var i = 0; i < calcdata.length; i++) {
    var cd = calcdata[i];
    var cd0 = cd[0];
    if (cd0.trace.type === desiredType && cd0.hierarchy) {
      rootColor = cd0.trace.root.color;
      cd0.hierarchy.each(pickColor);
    }
  }
};
exports.crossTraceCalc = function (gd) {
  return exports._runCrossTraceCalc('sunburst', gd);
};
function countDescendants(node, trace, opts) {
  var nChild = 0;
  var children = node.children;
  if (children) {
    var len = children.length;
    for (var i = 0; i < len; i++) {
      nChild += countDescendants(children[i], trace, opts);
    }
    if (opts.branches) nChild++; // count this branch
  } else {
    if (opts.leaves) nChild++; // count this leaf
  }

  // save to the node
  node.value = node.data.data.value = nChild;

  // save to the trace
  if (!trace._values) trace._values = [];
  trace._values[node.data.data.i] = nChild;
  return nChild;
}

/***/ }),

/***/ 2032:
/***/ (function(module) {

"use strict";


module.exports = {
  CLICK_TRANSITION_TIME: 750,
  CLICK_TRANSITION_EASING: 'linear',
  eventDataKeys: [
  // string
  'currentPath', 'root', 'entry',
  // no need to add 'parent' here

  // percentages i.e. ratios
  'percentRoot', 'percentEntry', 'percentParent']
};

/***/ }),

/***/ 33459:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var attributes = __webpack_require__(56708);
var handleDomainDefaults = (__webpack_require__(13792)/* .defaults */ .N);
var handleText = (__webpack_require__(17550).handleText);
var handleMarkerDefaults = (__webpack_require__(46979).handleMarkerDefaults);
var Colorscale = __webpack_require__(88856);
var hasColorscale = Colorscale.hasColorscale;
var colorscaleDefaults = Colorscale.handleDefaults;
module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
  function coerce(attr, dflt) {
    return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
  }
  var labels = coerce('labels');
  var parents = coerce('parents');
  if (!labels || !labels.length || !parents || !parents.length) {
    traceOut.visible = false;
    return;
  }
  var vals = coerce('values');
  if (vals && vals.length) {
    coerce('branchvalues');
  } else {
    coerce('count');
  }
  coerce('level');
  coerce('maxdepth');
  handleMarkerDefaults(traceIn, traceOut, layout, coerce);
  var withColorscale = traceOut._hasColorscale = hasColorscale(traceIn, 'marker', 'colors') || (traceIn.marker || {}).coloraxis // N.B. special logic to consider "values" colorscales
  ;
  if (withColorscale) {
    colorscaleDefaults(traceIn, traceOut, layout, coerce, {
      prefix: 'marker.',
      cLetter: 'c'
    });
  }
  coerce('leaf.opacity', withColorscale ? 1 : 0.7);
  var text = coerce('text');
  coerce('texttemplate');
  if (!traceOut.texttemplate) coerce('textinfo', Lib.isArrayOrTypedArray(text) ? 'text+label' : 'label');
  coerce('hovertext');
  coerce('hovertemplate');
  var textposition = 'auto';
  handleText(traceIn, traceOut, layout, coerce, textposition, {
    moduleHasSelected: false,
    moduleHasUnselected: false,
    moduleHasConstrain: false,
    moduleHasCliponaxis: false,
    moduleHasTextangle: false,
    moduleHasInsideanchor: false
  });
  coerce('insidetextorientation');
  coerce('sort');
  coerce('rotation');
  coerce('root.color');
  handleDomainDefaults(traceOut, layout, coerce);

  // do not support transforms for now
  traceOut._length = null;
};

/***/ }),

/***/ 72043:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Drawing = __webpack_require__(62203);
var Color = __webpack_require__(78766);
module.exports = function fillOne(s, pt, trace, gd, fadedColor) {
  var cdi = pt.data.data;
  var ptNumber = cdi.i;
  var color = fadedColor || cdi.color;
  if (ptNumber >= 0) {
    pt.i = cdi.i;
    var marker = trace.marker;
    if (marker.pattern) {
      if (!marker.colors || !marker.pattern.shape) {
        marker.color = color;
        pt.color = color;
      }
    } else {
      marker.color = color;
      pt.color = color;
    }
    Drawing.pointStyle(s, trace, gd, pt);
  } else {
    Color.fill(s, color);
  }
};

/***/ }),

/***/ 44691:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var Registry = __webpack_require__(33626);
var appendArrayPointValue = (__webpack_require__(36040).appendArrayPointValue);
var Fx = __webpack_require__(32141);
var Lib = __webpack_require__(34809);
var Events = __webpack_require__(68596);
var helpers = __webpack_require__(33108);
var pieHelpers = __webpack_require__(37252);
var formatValue = pieHelpers.formatPieValue;
module.exports = function attachFxHandlers(sliceTop, entry, gd, cd, opts) {
  var cd0 = cd[0];
  var trace = cd0.trace;
  var hierarchy = cd0.hierarchy;
  var isSunburst = trace.type === 'sunburst';
  var isTreemapOrIcicle = trace.type === 'treemap' || trace.type === 'icicle';

  // hover state vars
  // have we drawn a hover label, so it should be cleared later
  if (!('_hasHoverLabel' in trace)) trace._hasHoverLabel = false;
  // have we emitted a hover event, so later an unhover event should be emitted
  // note that click events do not depend on this - you can still get them
  // with hovermode: false or if you were earlier dragging, then clicked
  // in the same slice that you moused up in
  if (!('_hasHoverEvent' in trace)) trace._hasHoverEvent = false;
  var onMouseOver = function (pt) {
    var fullLayoutNow = gd._fullLayout;
    if (gd._dragging || fullLayoutNow.hovermode === false) return;
    var traceNow = gd._fullData[trace.index];
    var cdi = pt.data.data;
    var ptNumber = cdi.i;
    var isRoot = helpers.isHierarchyRoot(pt);
    var parent = helpers.getParent(hierarchy, pt);
    var val = helpers.getValue(pt);
    var _cast = function (astr) {
      return Lib.castOption(traceNow, ptNumber, astr);
    };
    var hovertemplate = _cast('hovertemplate');
    var hoverinfo = Fx.castHoverinfo(traceNow, fullLayoutNow, ptNumber);
    var separators = fullLayoutNow.separators;
    var eventData;
    if (hovertemplate || hoverinfo && hoverinfo !== 'none' && hoverinfo !== 'skip') {
      var hoverCenterX;
      var hoverCenterY;
      if (isSunburst) {
        hoverCenterX = cd0.cx + pt.pxmid[0] * (1 - pt.rInscribed);
        hoverCenterY = cd0.cy + pt.pxmid[1] * (1 - pt.rInscribed);
      }
      if (isTreemapOrIcicle) {
        hoverCenterX = pt._hoverX;
        hoverCenterY = pt._hoverY;
      }
      var hoverPt = {};
      var parts = [];
      var thisText = [];
      var hasFlag = function (flag) {
        return parts.indexOf(flag) !== -1;
      };
      if (hoverinfo) {
        parts = hoverinfo === 'all' ? traceNow._module.attributes.hoverinfo.flags : hoverinfo.split('+');
      }
      hoverPt.label = cdi.label;
      if (hasFlag('label') && hoverPt.label) thisText.push(hoverPt.label);
      if (cdi.hasOwnProperty('v')) {
        hoverPt.value = cdi.v;
        hoverPt.valueLabel = formatValue(hoverPt.value, separators);
        if (hasFlag('value')) thisText.push(hoverPt.valueLabel);
      }
      hoverPt.currentPath = pt.currentPath = helpers.getPath(pt.data);
      if (hasFlag('current path') && !isRoot) {
        thisText.push(hoverPt.currentPath);
      }
      var tx;
      var allPercents = [];
      var insertPercent = function () {
        if (allPercents.indexOf(tx) === -1) {
          // no need to add redundant info
          thisText.push(tx);
          allPercents.push(tx);
        }
      };
      hoverPt.percentParent = pt.percentParent = val / helpers.getValue(parent);
      hoverPt.parent = pt.parentString = helpers.getPtLabel(parent);
      if (hasFlag('percent parent')) {
        tx = helpers.formatPercent(hoverPt.percentParent, separators) + ' of ' + hoverPt.parent;
        insertPercent();
      }
      hoverPt.percentEntry = pt.percentEntry = val / helpers.getValue(entry);
      hoverPt.entry = pt.entry = helpers.getPtLabel(entry);
      if (hasFlag('percent entry') && !isRoot && !pt.onPathbar) {
        tx = helpers.formatPercent(hoverPt.percentEntry, separators) + ' of ' + hoverPt.entry;
        insertPercent();
      }
      hoverPt.percentRoot = pt.percentRoot = val / helpers.getValue(hierarchy);
      hoverPt.root = pt.root = helpers.getPtLabel(hierarchy);
      if (hasFlag('percent root') && !isRoot) {
        tx = helpers.formatPercent(hoverPt.percentRoot, separators) + ' of ' + hoverPt.root;
        insertPercent();
      }
      hoverPt.text = _cast('hovertext') || _cast('text');
      if (hasFlag('text')) {
        tx = hoverPt.text;
        if (Lib.isValidTextValue(tx)) thisText.push(tx);
      }
      eventData = [makeEventData(pt, traceNow, opts.eventDataKeys)];
      var hoverItems = {
        trace: traceNow,
        y: hoverCenterY,
        _x0: pt._x0,
        _x1: pt._x1,
        _y0: pt._y0,
        _y1: pt._y1,
        text: thisText.join('<br>'),
        name: hovertemplate || hasFlag('name') ? traceNow.name : undefined,
        color: _cast('hoverlabel.bgcolor') || cdi.color,
        borderColor: _cast('hoverlabel.bordercolor'),
        fontFamily: _cast('hoverlabel.font.family'),
        fontSize: _cast('hoverlabel.font.size'),
        fontColor: _cast('hoverlabel.font.color'),
        fontWeight: _cast('hoverlabel.font.weight'),
        fontStyle: _cast('hoverlabel.font.style'),
        fontVariant: _cast('hoverlabel.font.variant'),
        nameLength: _cast('hoverlabel.namelength'),
        textAlign: _cast('hoverlabel.align'),
        hovertemplate: hovertemplate,
        hovertemplateLabels: hoverPt,
        eventData: eventData
      };
      if (isSunburst) {
        hoverItems.x0 = hoverCenterX - pt.rInscribed * pt.rpx1;
        hoverItems.x1 = hoverCenterX + pt.rInscribed * pt.rpx1;
        hoverItems.idealAlign = pt.pxmid[0] < 0 ? 'left' : 'right';
      }
      if (isTreemapOrIcicle) {
        hoverItems.x = hoverCenterX;
        hoverItems.idealAlign = hoverCenterX < 0 ? 'left' : 'right';
      }
      var bbox = [];
      Fx.loneHover(hoverItems, {
        container: fullLayoutNow._hoverlayer.node(),
        outerContainer: fullLayoutNow._paper.node(),
        gd: gd,
        inOut_bbox: bbox
      });
      eventData[0].bbox = bbox[0];
      trace._hasHoverLabel = true;
    }
    if (isTreemapOrIcicle) {
      var slice = sliceTop.select('path.surface');
      opts.styleOne(slice, pt, traceNow, gd, {
        hovered: true
      });
    }
    trace._hasHoverEvent = true;
    gd.emit('plotly_hover', {
      points: eventData || [makeEventData(pt, traceNow, opts.eventDataKeys)],
      event: d3.event
    });
  };
  var onMouseOut = function (evt) {
    var fullLayoutNow = gd._fullLayout;
    var traceNow = gd._fullData[trace.index];
    var pt = d3.select(this).datum();
    if (trace._hasHoverEvent) {
      evt.originalEvent = d3.event;
      gd.emit('plotly_unhover', {
        points: [makeEventData(pt, traceNow, opts.eventDataKeys)],
        event: d3.event
      });
      trace._hasHoverEvent = false;
    }
    if (trace._hasHoverLabel) {
      Fx.loneUnhover(fullLayoutNow._hoverlayer.node());
      trace._hasHoverLabel = false;
    }
    if (isTreemapOrIcicle) {
      var slice = sliceTop.select('path.surface');
      opts.styleOne(slice, pt, traceNow, gd, {
        hovered: false
      });
    }
  };
  var onClick = function (pt) {
    // TODO: this does not support right-click. If we want to support it, we
    // would likely need to change pie to use dragElement instead of straight
    // map subplots event binding. Or perhaps better, make a simple wrapper with the
    // right mousedown, mousemove, and mouseup handlers just for a left/right click
    // map subplots would use this too.
    var fullLayoutNow = gd._fullLayout;
    var traceNow = gd._fullData[trace.index];
    var noTransition = isSunburst && (helpers.isHierarchyRoot(pt) || helpers.isLeaf(pt));
    var id = helpers.getPtId(pt);
    var nextEntry = helpers.isEntry(pt) ? helpers.findEntryWithChild(hierarchy, id) : helpers.findEntryWithLevel(hierarchy, id);
    var nextLevel = helpers.getPtId(nextEntry);
    var typeClickEvtData = {
      points: [makeEventData(pt, traceNow, opts.eventDataKeys)],
      event: d3.event
    };
    if (!noTransition) typeClickEvtData.nextLevel = nextLevel;
    var clickVal = Events.triggerHandler(gd, 'plotly_' + trace.type + 'click', typeClickEvtData);
    if (clickVal !== false && fullLayoutNow.hovermode) {
      gd._hoverdata = [makeEventData(pt, traceNow, opts.eventDataKeys)];
      Fx.click(gd, d3.event);
    }

    // if click does not trigger a transition, we're done!
    if (noTransition) return;

    // if custom handler returns false, we're done!
    if (clickVal === false) return;

    // skip if triggered from dragging a nearby cartesian subplot
    if (gd._dragging) return;

    // skip during transitions, to avoid potential bugs
    // we could remove this check later
    if (gd._transitioning) return;

    // store 'old' level in guiEdit stash, so that subsequent Plotly.react
    // calls with the same uirevision can start from the same entry
    Registry.call('_storeDirectGUIEdit', traceNow, fullLayoutNow._tracePreGUI[traceNow.uid], {
      level: traceNow.level
    });
    var frame = {
      data: [{
        level: nextLevel
      }],
      traces: [trace.index]
    };
    var animOpts = {
      frame: {
        redraw: false,
        duration: opts.transitionTime
      },
      transition: {
        duration: opts.transitionTime,
        easing: opts.transitionEasing
      },
      mode: 'immediate',
      fromcurrent: true
    };
    Fx.loneUnhover(fullLayoutNow._hoverlayer.node());
    Registry.call('animate', gd, frame, animOpts);
  };
  sliceTop.on('mouseover', onMouseOver);
  sliceTop.on('mouseout', onMouseOut);
  sliceTop.on('click', onClick);
};
function makeEventData(pt, trace, keys) {
  var cdi = pt.data.data;
  var out = {
    curveNumber: trace.index,
    pointNumber: cdi.i,
    data: trace._input,
    fullData: trace

    // TODO more things like 'children', 'siblings', 'hierarchy?
  };
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (key in pt) out[key] = pt[key];
  }
  // handle special case of parent
  if ('parentString' in pt && !helpers.isHierarchyRoot(pt)) out.parent = pt.parentString;
  appendArrayPointValue(out, trace, cdi.i);
  return out;
}

/***/ }),

/***/ 33108:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var Color = __webpack_require__(78766);
var setCursor = __webpack_require__(27983);
var pieHelpers = __webpack_require__(37252);
exports.findEntryWithLevel = function (hierarchy, level) {
  var out;
  if (level) {
    hierarchy.eachAfter(function (pt) {
      if (exports.getPtId(pt) === level) {
        return out = pt.copy();
      }
    });
  }
  return out || hierarchy;
};
exports.findEntryWithChild = function (hierarchy, childId) {
  var out;
  hierarchy.eachAfter(function (pt) {
    var children = pt.children || [];
    for (var i = 0; i < children.length; i++) {
      var child = children[i];
      if (exports.getPtId(child) === childId) {
        return out = pt.copy();
      }
    }
  });
  return out || hierarchy;
};
exports.isEntry = function (pt) {
  return !pt.parent;
};
exports.isLeaf = function (pt) {
  return !pt.children;
};
exports.getPtId = function (pt) {
  return pt.data.data.id;
};
exports.getPtLabel = function (pt) {
  return pt.data.data.label;
};
exports.getValue = function (d) {
  return d.value;
};
exports.isHierarchyRoot = function (pt) {
  return getParentId(pt) === '';
};
exports.setSliceCursor = function (sliceTop, gd, opts) {
  var hide = opts.isTransitioning;
  if (!hide) {
    var pt = sliceTop.datum();
    hide = opts.hideOnRoot && exports.isHierarchyRoot(pt) || opts.hideOnLeaves && exports.isLeaf(pt);
  }
  setCursor(sliceTop, hide ? null : 'pointer');
};
function determineOutsideTextFont(trace, pt, layoutFont) {
  return {
    color: exports.getOutsideTextFontKey('color', trace, pt, layoutFont),
    family: exports.getOutsideTextFontKey('family', trace, pt, layoutFont),
    size: exports.getOutsideTextFontKey('size', trace, pt, layoutFont),
    weight: exports.getOutsideTextFontKey('weight', trace, pt, layoutFont),
    style: exports.getOutsideTextFontKey('style', trace, pt, layoutFont),
    variant: exports.getOutsideTextFontKey('variant', trace, pt, layoutFont),
    textcase: exports.getOutsideTextFontKey('textcase', trace, pt, layoutFont),
    lineposition: exports.getOutsideTextFontKey('lineposition', trace, pt, layoutFont),
    shadow: exports.getOutsideTextFontKey('shadow', trace, pt, layoutFont)
  };
}
function determineInsideTextFont(trace, pt, layoutFont, opts) {
  var onPathbar = (opts || {}).onPathbar;
  var cdi = pt.data.data;
  var ptNumber = cdi.i;
  var customColor = Lib.castOption(trace, ptNumber, (onPathbar ? 'pathbar.textfont' : 'insidetextfont') + '.color');
  if (!customColor && trace._input.textfont) {
    // Why not simply using trace.textfont? Because if not set, it
    // defaults to layout.font which has a default color. But if
    // textfont.color and insidetextfont.color don't supply a value,
    // a contrasting color shall be used.
    customColor = Lib.castOption(trace._input, ptNumber, 'textfont.color');
  }
  return {
    color: customColor || Color.contrast(cdi.color),
    family: exports.getInsideTextFontKey('family', trace, pt, layoutFont, opts),
    size: exports.getInsideTextFontKey('size', trace, pt, layoutFont, opts),
    weight: exports.getInsideTextFontKey('weight', trace, pt, layoutFont, opts),
    style: exports.getInsideTextFontKey('style', trace, pt, layoutFont, opts),
    variant: exports.getInsideTextFontKey('variant', trace, pt, layoutFont, opts),
    textcase: exports.getInsideTextFontKey('textcase', trace, pt, layoutFont, opts),
    lineposition: exports.getInsideTextFontKey('lineposition', trace, pt, layoutFont, opts),
    shadow: exports.getInsideTextFontKey('shadow', trace, pt, layoutFont, opts)
  };
}
exports.getInsideTextFontKey = function (keyStr, trace, pt, layoutFont, opts) {
  var onPathbar = (opts || {}).onPathbar;
  var cont = onPathbar ? 'pathbar.textfont' : 'insidetextfont';
  var ptNumber = pt.data.data.i;
  return Lib.castOption(trace, ptNumber, cont + '.' + keyStr) || Lib.castOption(trace, ptNumber, 'textfont.' + keyStr) || layoutFont.size;
};
exports.getOutsideTextFontKey = function (keyStr, trace, pt, layoutFont) {
  var ptNumber = pt.data.data.i;
  return Lib.castOption(trace, ptNumber, 'outsidetextfont.' + keyStr) || Lib.castOption(trace, ptNumber, 'textfont.' + keyStr) || layoutFont.size;
};
exports.isOutsideText = function (trace, pt) {
  return !trace._hasColorscale && exports.isHierarchyRoot(pt);
};
exports.determineTextFont = function (trace, pt, layoutFont, opts) {
  return exports.isOutsideText(trace, pt) ? determineOutsideTextFont(trace, pt, layoutFont) : determineInsideTextFont(trace, pt, layoutFont, opts);
};
exports.hasTransition = function (transitionOpts) {
  // We could optimize hasTransition per trace,
  // as sunburst, treemap & icicle have no cross-trace logic!
  return !!(transitionOpts && transitionOpts.duration > 0);
};
exports.getMaxDepth = function (trace) {
  return trace.maxdepth >= 0 ? trace.maxdepth : Infinity;
};
exports.isHeader = function (pt, trace) {
  // it is only used in treemap.
  return !(exports.isLeaf(pt) || pt.depth === trace._maxDepth - 1);
};
function getParentId(pt) {
  return pt.data.data.pid;
}
exports.getParent = function (hierarchy, pt) {
  return exports.findEntryWithLevel(hierarchy, getParentId(pt));
};
exports.listPath = function (d, keyStr) {
  var parent = d.parent;
  if (!parent) return [];
  var list = keyStr ? [parent.data[keyStr]] : [parent];
  return exports.listPath(parent, keyStr).concat(list);
};
exports.getPath = function (d) {
  return exports.listPath(d, 'label').join('/') + '/';
};
exports.formatValue = pieHelpers.formatPieValue;

// TODO: should combine the two in a separate PR - Also please note Lib.formatPercent should support separators.
exports.formatPercent = function (v, separators) {
  var tx = Lib.formatPercent(v, 0); // use funnel(area) version
  if (tx === '0%') tx = pieHelpers.formatPiePercent(v, separators); // use pie version
  return tx;
};

/***/ }),

/***/ 80809:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = {
  moduleType: 'trace',
  name: 'sunburst',
  basePlotModule: __webpack_require__(14724),
  categories: [],
  animatable: true,
  attributes: __webpack_require__(56708),
  layoutAttributes: __webpack_require__(98959),
  supplyDefaults: __webpack_require__(33459),
  supplyLayoutDefaults: __webpack_require__(75816),
  calc: (__webpack_require__(14852).calc),
  crossTraceCalc: (__webpack_require__(14852).crossTraceCalc),
  plot: (__webpack_require__(19718).plot),
  style: (__webpack_require__(98972).style),
  colorbar: __webpack_require__(21146),
  meta: {}
};

/***/ }),

/***/ 98959:
/***/ (function(module) {

"use strict";


module.exports = {
  sunburstcolorway: {
    valType: 'colorlist',
    editType: 'calc'
  },
  extendsunburstcolors: {
    valType: 'boolean',
    dflt: true,
    editType: 'calc'
  }
};

/***/ }),

/***/ 75816:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var layoutAttributes = __webpack_require__(98959);
module.exports = function supplyLayoutDefaults(layoutIn, layoutOut) {
  function coerce(attr, dflt) {
    return Lib.coerce(layoutIn, layoutOut, layoutAttributes, attr, dflt);
  }
  coerce('sunburstcolorway', layoutOut.colorway);
  coerce('extendsunburstcolors');
};

/***/ }),

/***/ 19718:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var d3Hierarchy = __webpack_require__(92264);
var interpolate = (__webpack_require__(88640)/* .interpolate */ .GW);
var Drawing = __webpack_require__(62203);
var Lib = __webpack_require__(34809);
var svgTextUtils = __webpack_require__(30635);
var uniformText = __webpack_require__(84102);
var recordMinTextSize = uniformText.recordMinTextSize;
var clearMinTextSize = uniformText.clearMinTextSize;
var piePlot = __webpack_require__(35734);
var getRotationAngle = (__webpack_require__(37252).getRotationAngle);
var computeTransform = piePlot.computeTransform;
var transformInsideText = piePlot.transformInsideText;
var styleOne = (__webpack_require__(98972).styleOne);
var resizeText = (__webpack_require__(6851).resizeText);
var attachFxHandlers = __webpack_require__(44691);
var constants = __webpack_require__(2032);
var helpers = __webpack_require__(33108);
exports.plot = function (gd, cdmodule, transitionOpts, makeOnCompleteCallback) {
  var fullLayout = gd._fullLayout;
  var layer = fullLayout._sunburstlayer;
  var join, onComplete;

  // If transition config is provided, then it is only a partial replot and traces not
  // updated are removed.
  var isFullReplot = !transitionOpts;
  var hasTransition = !fullLayout.uniformtext.mode && helpers.hasTransition(transitionOpts);
  clearMinTextSize('sunburst', fullLayout);
  join = layer.selectAll('g.trace.sunburst').data(cdmodule, function (cd) {
    return cd[0].trace.uid;
  });

  // using same 'stroke-linejoin' as pie traces
  join.enter().append('g').classed('trace', true).classed('sunburst', true).attr('stroke-linejoin', 'round');
  join.order();
  if (hasTransition) {
    if (makeOnCompleteCallback) {
      // If it was passed a callback to register completion, make a callback. If
      // this is created, then it must be executed on completion, otherwise the
      // pos-transition redraw will not execute:
      onComplete = makeOnCompleteCallback();
    }
    var transition = d3.transition().duration(transitionOpts.duration).ease(transitionOpts.easing).each('end', function () {
      onComplete && onComplete();
    }).each('interrupt', function () {
      onComplete && onComplete();
    });
    transition.each(function () {
      // Must run the selection again since otherwise enters/updates get grouped together
      // and these get executed out of order. Except we need them in order!
      layer.selectAll('g.trace').each(function (cd) {
        plotOne(gd, cd, this, transitionOpts);
      });
    });
  } else {
    join.each(function (cd) {
      plotOne(gd, cd, this, transitionOpts);
    });
    if (fullLayout.uniformtext.mode) {
      resizeText(gd, fullLayout._sunburstlayer.selectAll('.trace'), 'sunburst');
    }
  }
  if (isFullReplot) {
    join.exit().remove();
  }
};
function plotOne(gd, cd, element, transitionOpts) {
  var isStatic = gd._context.staticPlot;
  var fullLayout = gd._fullLayout;
  var hasTransition = !fullLayout.uniformtext.mode && helpers.hasTransition(transitionOpts);
  var gTrace = d3.select(element);
  var slices = gTrace.selectAll('g.slice');
  var cd0 = cd[0];
  var trace = cd0.trace;
  var hierarchy = cd0.hierarchy;
  var entry = helpers.findEntryWithLevel(hierarchy, trace.level);
  var maxDepth = helpers.getMaxDepth(trace);
  var gs = fullLayout._size;
  var domain = trace.domain;
  var vpw = gs.w * (domain.x[1] - domain.x[0]);
  var vph = gs.h * (domain.y[1] - domain.y[0]);
  var rMax = 0.5 * Math.min(vpw, vph);
  var cx = cd0.cx = gs.l + gs.w * (domain.x[1] + domain.x[0]) / 2;
  var cy = cd0.cy = gs.t + gs.h * (1 - domain.y[0]) - vph / 2;
  if (!entry) {
    return slices.remove();
  }

  // previous root 'pt' (can be empty)
  var prevEntry = null;
  // stash of 'previous' position data used by tweening functions
  var prevLookup = {};
  if (hasTransition) {
    // Important: do this before binding new sliceData!
    slices.each(function (pt) {
      prevLookup[helpers.getPtId(pt)] = {
        rpx0: pt.rpx0,
        rpx1: pt.rpx1,
        x0: pt.x0,
        x1: pt.x1,
        transform: pt.transform
      };
      if (!prevEntry && helpers.isEntry(pt)) {
        prevEntry = pt;
      }
    });
  }

  // N.B. slice data isn't the calcdata,
  // grab corresponding calcdata item in sliceData[i].data.data
  var sliceData = partition(entry).descendants();
  var maxHeight = entry.height + 1;
  var yOffset = 0;
  var cutoff = maxDepth;
  // N.B. handle multiple-root special case
  if (cd0.hasMultipleRoots && helpers.isHierarchyRoot(entry)) {
    sliceData = sliceData.slice(1);
    maxHeight -= 1;
    yOffset = 1;
    cutoff += 1;
  }

  // filter out slices that won't show up on graph
  sliceData = sliceData.filter(function (pt) {
    return pt.y1 <= cutoff;
  });
  var baseX = getRotationAngle(trace.rotation);
  if (baseX) {
    sliceData.forEach(function (pt) {
      pt.x0 += baseX;
      pt.x1 += baseX;
    });
  }

  // partition span ('y') to sector radial px value
  var maxY = Math.min(maxHeight, maxDepth);
  var y2rpx = function (y) {
    return (y - yOffset) / maxY * rMax;
  };
  // (radial px value, partition angle ('x'))  to px [x,y]
  var rx2px = function (r, x) {
    return [r * Math.cos(x), -r * Math.sin(x)];
  };
  // slice path generation fn
  var pathSlice = function (d) {
    return Lib.pathAnnulus(d.rpx0, d.rpx1, d.x0, d.x1, cx, cy);
  };
  // slice text translate x/y

  var getTargetX = function (d) {
    return cx + getTextXY(d)[0] * (d.transform.rCenter || 0) + (d.transform.x || 0);
  };
  var getTargetY = function (d) {
    return cy + getTextXY(d)[1] * (d.transform.rCenter || 0) + (d.transform.y || 0);
  };
  slices = slices.data(sliceData, helpers.getPtId);
  slices.enter().append('g').classed('slice', true);
  if (hasTransition) {
    slices.exit().transition().each(function () {
      var sliceTop = d3.select(this);
      var slicePath = sliceTop.select('path.surface');
      slicePath.transition().attrTween('d', function (pt2) {
        var interp = makeExitSliceInterpolator(pt2);
        return function (t) {
          return pathSlice(interp(t));
        };
      });
      var sliceTextGroup = sliceTop.select('g.slicetext');
      sliceTextGroup.attr('opacity', 0);
    }).remove();
  } else {
    slices.exit().remove();
  }
  slices.order();

  // next x1 (i.e. sector end angle) of previous entry
  var nextX1ofPrevEntry = null;
  if (hasTransition && prevEntry) {
    var prevEntryId = helpers.getPtId(prevEntry);
    slices.each(function (pt) {
      if (nextX1ofPrevEntry === null && helpers.getPtId(pt) === prevEntryId) {
        nextX1ofPrevEntry = pt.x1;
      }
    });
  }
  var updateSlices = slices;
  if (hasTransition) {
    updateSlices = updateSlices.transition().each('end', function () {
      // N.B. gd._transitioning is (still) *true* by the time
      // transition updates get here
      var sliceTop = d3.select(this);
      helpers.setSliceCursor(sliceTop, gd, {
        hideOnRoot: true,
        hideOnLeaves: true,
        isTransitioning: false
      });
    });
  }
  updateSlices.each(function (pt) {
    var sliceTop = d3.select(this);
    var slicePath = Lib.ensureSingle(sliceTop, 'path', 'surface', function (s) {
      s.style('pointer-events', isStatic ? 'none' : 'all');
    });
    pt.rpx0 = y2rpx(pt.y0);
    pt.rpx1 = y2rpx(pt.y1);
    pt.xmid = (pt.x0 + pt.x1) / 2;
    pt.pxmid = rx2px(pt.rpx1, pt.xmid);
    pt.midangle = -(pt.xmid - Math.PI / 2);
    pt.startangle = -(pt.x0 - Math.PI / 2);
    pt.stopangle = -(pt.x1 - Math.PI / 2);
    pt.halfangle = 0.5 * Math.min(Lib.angleDelta(pt.x0, pt.x1) || Math.PI, Math.PI);
    pt.ring = 1 - pt.rpx0 / pt.rpx1;
    pt.rInscribed = getInscribedRadiusFraction(pt, trace);
    if (hasTransition) {
      slicePath.transition().attrTween('d', function (pt2) {
        var interp = makeUpdateSliceInterpolator(pt2);
        return function (t) {
          return pathSlice(interp(t));
        };
      });
    } else {
      slicePath.attr('d', pathSlice);
    }
    sliceTop.call(attachFxHandlers, entry, gd, cd, {
      eventDataKeys: constants.eventDataKeys,
      transitionTime: constants.CLICK_TRANSITION_TIME,
      transitionEasing: constants.CLICK_TRANSITION_EASING
    }).call(helpers.setSliceCursor, gd, {
      hideOnRoot: true,
      hideOnLeaves: true,
      isTransitioning: gd._transitioning
    });
    slicePath.call(styleOne, pt, trace, gd);
    var sliceTextGroup = Lib.ensureSingle(sliceTop, 'g', 'slicetext');
    var sliceText = Lib.ensureSingle(sliceTextGroup, 'text', '', function (s) {
      // prohibit tex interpretation until we can handle
      // tex and regular text together
      s.attr('data-notex', 1);
    });
    var font = Lib.ensureUniformFontSize(gd, helpers.determineTextFont(trace, pt, fullLayout.font));
    sliceText.text(exports.formatSliceLabel(pt, entry, trace, cd, fullLayout)).classed('slicetext', true).attr('text-anchor', 'middle').call(Drawing.font, font).call(svgTextUtils.convertToTspans, gd);

    // position the text relative to the slice
    var textBB = Drawing.bBox(sliceText.node());
    pt.transform = transformInsideText(textBB, pt, cd0);
    pt.transform.targetX = getTargetX(pt);
    pt.transform.targetY = getTargetY(pt);
    var strTransform = function (d, textBB) {
      var transform = d.transform;
      computeTransform(transform, textBB);
      transform.fontSize = font.size;
      recordMinTextSize(trace.type, transform, fullLayout);
      return Lib.getTextTransform(transform);
    };
    if (hasTransition) {
      sliceText.transition().attrTween('transform', function (pt2) {
        var interp = makeUpdateTextInterpolator(pt2);
        return function (t) {
          return strTransform(interp(t), textBB);
        };
      });
    } else {
      sliceText.attr('transform', strTransform(pt, textBB));
    }
  });
  function makeExitSliceInterpolator(pt) {
    var id = helpers.getPtId(pt);
    var prev = prevLookup[id];
    var entryPrev = prevLookup[helpers.getPtId(entry)];
    var next;
    if (entryPrev) {
      var a = (pt.x1 > entryPrev.x1 ? 2 * Math.PI : 0) + baseX;
      // if pt to remove:
      // - if 'below' where the root-node used to be: shrink it radially inward
      // - otherwise, collapse it clockwise or counterclockwise which ever is shortest to theta=0
      next = pt.rpx1 < entryPrev.rpx1 ? {
        x0: pt.x0,
        x1: pt.x1,
        rpx0: 0,
        rpx1: 0
      } : {
        x0: a,
        x1: a,
        rpx0: pt.rpx0,
        rpx1: pt.rpx1
      };
    } else {
      // this happens when maxdepth is set, when leaves must
      // be removed and the rootPt is new (i.e. does not have a 'prev' object)
      var parent;
      var parentId = helpers.getPtId(pt.parent);
      slices.each(function (pt2) {
        if (helpers.getPtId(pt2) === parentId) {
          return parent = pt2;
        }
      });
      var parentChildren = parent.children;
      var ci;
      parentChildren.forEach(function (pt2, i) {
        if (helpers.getPtId(pt2) === id) {
          return ci = i;
        }
      });
      var n = parentChildren.length;
      var interp = interpolate(parent.x0, parent.x1);
      next = {
        rpx0: rMax,
        rpx1: rMax,
        x0: interp(ci / n),
        x1: interp((ci + 1) / n)
      };
    }
    return interpolate(prev, next);
  }
  function makeUpdateSliceInterpolator(pt) {
    var prev0 = prevLookup[helpers.getPtId(pt)];
    var prev;
    var next = {
      x0: pt.x0,
      x1: pt.x1,
      rpx0: pt.rpx0,
      rpx1: pt.rpx1
    };
    if (prev0) {
      // if pt already on graph, this is easy
      prev = prev0;
    } else {
      // for new pts:
      if (prevEntry) {
        // if trace was visible before
        if (pt.parent) {
          if (nextX1ofPrevEntry) {
            // if new branch, twist it in clockwise or
            // counterclockwise which ever is shorter to
            // its final angle
            var a = (pt.x1 > nextX1ofPrevEntry ? 2 * Math.PI : 0) + baseX;
            prev = {
              x0: a,
              x1: a
            };
          } else {
            // if new leaf (when maxdepth is set),
            // grow it radially and angularly from
            // its parent node
            prev = {
              rpx0: rMax,
              rpx1: rMax
            };
            Lib.extendFlat(prev, interpX0X1FromParent(pt));
          }
        } else {
          // if new root-node, grow it radially
          prev = {
            rpx0: 0,
            rpx1: 0
          };
        }
      } else {
        // start sector of new traces from theta=0
        prev = {
          x0: baseX,
          x1: baseX
        };
      }
    }
    return interpolate(prev, next);
  }
  function makeUpdateTextInterpolator(pt) {
    var prev0 = prevLookup[helpers.getPtId(pt)];
    var prev;
    var transform = pt.transform;
    if (prev0) {
      prev = prev0;
    } else {
      prev = {
        rpx1: pt.rpx1,
        transform: {
          textPosAngle: transform.textPosAngle,
          scale: 0,
          rotate: transform.rotate,
          rCenter: transform.rCenter,
          x: transform.x,
          y: transform.y
        }
      };

      // for new pts:
      if (prevEntry) {
        // if trace was visible before
        if (pt.parent) {
          if (nextX1ofPrevEntry) {
            // if new branch, twist it in clockwise or
            // counterclockwise which ever is shorter to
            // its final angle
            var a = pt.x1 > nextX1ofPrevEntry ? 2 * Math.PI : 0;
            prev.x0 = prev.x1 = a;
          } else {
            // if leaf
            Lib.extendFlat(prev, interpX0X1FromParent(pt));
          }
        } else {
          // if new root-node
          prev.x0 = prev.x1 = baseX;
        }
      } else {
        // on new traces
        prev.x0 = prev.x1 = baseX;
      }
    }
    var textPosAngleFn = interpolate(prev.transform.textPosAngle, pt.transform.textPosAngle);
    var rpx1Fn = interpolate(prev.rpx1, pt.rpx1);
    var x0Fn = interpolate(prev.x0, pt.x0);
    var x1Fn = interpolate(prev.x1, pt.x1);
    var scaleFn = interpolate(prev.transform.scale, transform.scale);
    var rotateFn = interpolate(prev.transform.rotate, transform.rotate);

    // smooth out start/end from entry, to try to keep text inside sector
    // while keeping transition smooth
    var pow = transform.rCenter === 0 ? 3 : prev.transform.rCenter === 0 ? 1 / 3 : 1;
    var _rCenterFn = interpolate(prev.transform.rCenter, transform.rCenter);
    var rCenterFn = function (t) {
      return _rCenterFn(Math.pow(t, pow));
    };
    return function (t) {
      var rpx1 = rpx1Fn(t);
      var x0 = x0Fn(t);
      var x1 = x1Fn(t);
      var rCenter = rCenterFn(t);
      var pxmid = rx2px(rpx1, (x0 + x1) / 2);
      var textPosAngle = textPosAngleFn(t);
      var d = {
        pxmid: pxmid,
        rpx1: rpx1,
        transform: {
          textPosAngle: textPosAngle,
          rCenter: rCenter,
          x: transform.x,
          y: transform.y
        }
      };
      recordMinTextSize(trace.type, transform, fullLayout);
      return {
        transform: {
          targetX: getTargetX(d),
          targetY: getTargetY(d),
          scale: scaleFn(t),
          rotate: rotateFn(t),
          rCenter: rCenter
        }
      };
    };
  }
  function interpX0X1FromParent(pt) {
    var parent = pt.parent;
    var parentPrev = prevLookup[helpers.getPtId(parent)];
    var out = {};
    if (parentPrev) {
      // if parent is visible
      var parentChildren = parent.children;
      var ci = parentChildren.indexOf(pt);
      var n = parentChildren.length;
      var interp = interpolate(parentPrev.x0, parentPrev.x1);
      out.x0 = interp(ci / n);
      out.x1 = interp(ci / n);
    } else {
      // w/o visible parent
      // TODO !!! HOW ???
      out.x0 = out.x1 = 0;
    }
    return out;
  }
}

// x[0-1] keys are angles [radians]
// y[0-1] keys are hierarchy heights [integers]
function partition(entry) {
  return d3Hierarchy.partition().size([2 * Math.PI, entry.height + 1])(entry);
}
exports.formatSliceLabel = function (pt, entry, trace, cd, fullLayout) {
  var texttemplate = trace.texttemplate;
  var textinfo = trace.textinfo;
  if (!texttemplate && (!textinfo || textinfo === 'none')) {
    return '';
  }
  var separators = fullLayout.separators;
  var cd0 = cd[0];
  var cdi = pt.data.data;
  var hierarchy = cd0.hierarchy;
  var isRoot = helpers.isHierarchyRoot(pt);
  var parent = helpers.getParent(hierarchy, pt);
  var val = helpers.getValue(pt);
  if (!texttemplate) {
    var parts = textinfo.split('+');
    var hasFlag = function (flag) {
      return parts.indexOf(flag) !== -1;
    };
    var thisText = [];
    var tx;
    if (hasFlag('label') && cdi.label) {
      thisText.push(cdi.label);
    }
    if (cdi.hasOwnProperty('v') && hasFlag('value')) {
      thisText.push(helpers.formatValue(cdi.v, separators));
    }
    if (!isRoot) {
      if (hasFlag('current path')) {
        thisText.push(helpers.getPath(pt.data));
      }
      var nPercent = 0;
      if (hasFlag('percent parent')) nPercent++;
      if (hasFlag('percent entry')) nPercent++;
      if (hasFlag('percent root')) nPercent++;
      var hasMultiplePercents = nPercent > 1;
      if (nPercent) {
        var percent;
        var addPercent = function (key) {
          tx = helpers.formatPercent(percent, separators);
          if (hasMultiplePercents) tx += ' of ' + key;
          thisText.push(tx);
        };
        if (hasFlag('percent parent') && !isRoot) {
          percent = val / helpers.getValue(parent);
          addPercent('parent');
        }
        if (hasFlag('percent entry')) {
          percent = val / helpers.getValue(entry);
          addPercent('entry');
        }
        if (hasFlag('percent root')) {
          percent = val / helpers.getValue(hierarchy);
          addPercent('root');
        }
      }
    }
    if (hasFlag('text')) {
      tx = Lib.castOption(trace, cdi.i, 'text');
      if (Lib.isValidTextValue(tx)) thisText.push(tx);
    }
    return thisText.join('<br>');
  }
  var txt = Lib.castOption(trace, cdi.i, 'texttemplate');
  if (!txt) return '';
  var obj = {};
  if (cdi.label) obj.label = cdi.label;
  if (cdi.hasOwnProperty('v')) {
    obj.value = cdi.v;
    obj.valueLabel = helpers.formatValue(cdi.v, separators);
  }
  obj.currentPath = helpers.getPath(pt.data);
  if (!isRoot) {
    obj.percentParent = val / helpers.getValue(parent);
    obj.percentParentLabel = helpers.formatPercent(obj.percentParent, separators);
    obj.parent = helpers.getPtLabel(parent);
  }
  obj.percentEntry = val / helpers.getValue(entry);
  obj.percentEntryLabel = helpers.formatPercent(obj.percentEntry, separators);
  obj.entry = helpers.getPtLabel(entry);
  obj.percentRoot = val / helpers.getValue(hierarchy);
  obj.percentRootLabel = helpers.formatPercent(obj.percentRoot, separators);
  obj.root = helpers.getPtLabel(hierarchy);
  if (cdi.hasOwnProperty('color')) {
    obj.color = cdi.color;
  }
  var ptTx = Lib.castOption(trace, cdi.i, 'text');
  if (Lib.isValidTextValue(ptTx) || ptTx === '') obj.text = ptTx;
  obj.customdata = Lib.castOption(trace, cdi.i, 'customdata');
  return Lib.texttemplateString(txt, obj, fullLayout._d3locale, obj, trace._meta || {});
};
function getInscribedRadiusFraction(pt) {
  if (pt.rpx0 === 0 && Lib.isFullCircle([pt.x0, pt.x1])) {
    // special case of 100% with no hole
    return 1;
  } else {
    return Math.max(0, Math.min(1 / (1 + 1 / Math.sin(pt.halfangle)), pt.ring / 2));
  }
}
function getTextXY(d) {
  return getCoords(d.rpx1, d.transform.textPosAngle);
}
function getCoords(r, angle) {
  return [r * Math.sin(angle), -r * Math.cos(angle)];
}

/***/ }),

/***/ 98972:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var Color = __webpack_require__(78766);
var Lib = __webpack_require__(34809);
var resizeText = (__webpack_require__(84102).resizeText);
var fillOne = __webpack_require__(72043);
function style(gd) {
  var s = gd._fullLayout._sunburstlayer.selectAll('.trace');
  resizeText(gd, s, 'sunburst');
  s.each(function (cd) {
    var gTrace = d3.select(this);
    var cd0 = cd[0];
    var trace = cd0.trace;
    gTrace.style('opacity', trace.opacity);
    gTrace.selectAll('path.surface').each(function (pt) {
      d3.select(this).call(styleOne, pt, trace, gd);
    });
  });
}
function styleOne(s, pt, trace, gd) {
  var cdi = pt.data.data;
  var isLeaf = !pt.children;
  var ptNumber = cdi.i;
  var lineColor = Lib.castOption(trace, ptNumber, 'marker.line.color') || Color.defaultLine;
  var lineWidth = Lib.castOption(trace, ptNumber, 'marker.line.width') || 0;
  s.call(fillOne, pt, trace, gd).style('stroke-width', lineWidth).call(Color.stroke, lineColor).style('opacity', isLeaf ? trace.leaf.opacity : null);
}
module.exports = {
  style: style,
  styleOne: styleOne
};

/***/ }),

/***/ 16131:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Color = __webpack_require__(78766);
var colorScaleAttrs = __webpack_require__(87163);
var axisHoverFormat = (__webpack_require__(80712).axisHoverFormat);
var hovertemplateAttrs = (__webpack_require__(3208)/* .hovertemplateAttrs */ .rb);
var baseAttrs = __webpack_require__(9829);
var extendFlat = (__webpack_require__(93049).extendFlat);
var overrideAll = (__webpack_require__(13582).overrideAll);
function makeContourProjAttr(axLetter) {
  return {
    valType: 'boolean',
    dflt: false
  };
}
function makeContourAttr(axLetter) {
  return {
    show: {
      valType: 'boolean',
      dflt: false
    },
    start: {
      valType: 'number',
      dflt: null,
      editType: 'plot'
      // impliedEdits: {'^autocontour': false},
    },
    end: {
      valType: 'number',
      dflt: null,
      editType: 'plot'
      // impliedEdits: {'^autocontour': false},
    },
    size: {
      valType: 'number',
      dflt: null,
      min: 0,
      editType: 'plot'
      // impliedEdits: {'^autocontour': false},
    },
    project: {
      x: makeContourProjAttr('x'),
      y: makeContourProjAttr('y'),
      z: makeContourProjAttr('z')
    },
    color: {
      valType: 'color',
      dflt: Color.defaultLine
    },
    usecolormap: {
      valType: 'boolean',
      dflt: false
    },
    width: {
      valType: 'number',
      min: 1,
      max: 16,
      dflt: 2
    },
    highlight: {
      valType: 'boolean',
      dflt: true
    },
    highlightcolor: {
      valType: 'color',
      dflt: Color.defaultLine
    },
    highlightwidth: {
      valType: 'number',
      min: 1,
      max: 16,
      dflt: 2
    }
  };
}
var attrs = module.exports = overrideAll(extendFlat({
  z: {
    valType: 'data_array'
  },
  x: {
    valType: 'data_array'
  },
  y: {
    valType: 'data_array'
  },
  text: {
    valType: 'string',
    dflt: '',
    arrayOk: true
  },
  hovertext: {
    valType: 'string',
    dflt: '',
    arrayOk: true
  },
  hovertemplate: hovertemplateAttrs(),
  xhoverformat: axisHoverFormat('x'),
  yhoverformat: axisHoverFormat('y'),
  zhoverformat: axisHoverFormat('z'),
  connectgaps: {
    valType: 'boolean',
    dflt: false,
    editType: 'calc'
  },
  surfacecolor: {
    valType: 'data_array'
  }
}, colorScaleAttrs('', {
  colorAttr: 'z or surfacecolor',
  showScaleDflt: true,
  autoColorDflt: false,
  editTypeOverride: 'calc'
}), {
  contours: {
    x: makeContourAttr('x'),
    y: makeContourAttr('y'),
    z: makeContourAttr('z')
  },
  hidesurface: {
    valType: 'boolean',
    dflt: false
  },
  lightposition: {
    x: {
      valType: 'number',
      min: -1e5,
      max: 1e5,
      dflt: 10
    },
    y: {
      valType: 'number',
      min: -1e5,
      max: 1e5,
      dflt: 1e4
    },
    z: {
      valType: 'number',
      min: -1e5,
      max: 1e5,
      dflt: 0
    }
  },
  lighting: {
    ambient: {
      valType: 'number',
      min: 0.00,
      max: 1.0,
      dflt: 0.8
    },
    diffuse: {
      valType: 'number',
      min: 0.00,
      max: 1.00,
      dflt: 0.8
    },
    specular: {
      valType: 'number',
      min: 0.00,
      max: 2.00,
      dflt: 0.05
    },
    roughness: {
      valType: 'number',
      min: 0.00,
      max: 1.00,
      dflt: 0.5
    },
    fresnel: {
      valType: 'number',
      min: 0.00,
      max: 5.00,
      dflt: 0.2
    }
  },
  opacity: {
    valType: 'number',
    min: 0,
    max: 1,
    dflt: 1
  },
  opacityscale: {
    valType: 'any',
    editType: 'calc'
  },
  _deprecated: {
    zauto: extendFlat({}, colorScaleAttrs.zauto, {}),
    zmin: extendFlat({}, colorScaleAttrs.zmin, {}),
    zmax: extendFlat({}, colorScaleAttrs.zmax, {})
  },
  hoverinfo: extendFlat({}, baseAttrs.hoverinfo),
  showlegend: extendFlat({}, baseAttrs.showlegend, {
    dflt: false
  })
}), 'calc', 'nested');
attrs.x.editType = attrs.y.editType = attrs.z.editType = 'calc+clearAxisTypes';
attrs.transforms = undefined;

/***/ }),

/***/ 53027:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var colorscaleCalc = __webpack_require__(28379);

// Compute auto-z and autocolorscale if applicable
module.exports = function calc(gd, trace) {
  if (trace.surfacecolor) {
    colorscaleCalc(gd, trace, {
      vals: trace.surfacecolor,
      containerStr: '',
      cLetter: 'c'
    });
  } else {
    colorscaleCalc(gd, trace, {
      vals: trace.z,
      containerStr: '',
      cLetter: 'c'
    });
  }
};

/***/ }),

/***/ 27159:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var createSurface = (__webpack_require__(99098).gl_surface3d);
var ndarray = (__webpack_require__(99098).ndarray);
var ndarrayInterp2d = (__webpack_require__(99098).ndarray_linear_interpolate).d2;
var interp2d = __webpack_require__(69295);
var findEmpties = __webpack_require__(78106);
var isArrayOrTypedArray = (__webpack_require__(34809).isArrayOrTypedArray);
var parseColorScale = (__webpack_require__(46998).parseColorScale);
var str2RgbaArray = __webpack_require__(55010);
var extractOpts = (__webpack_require__(88856).extractOpts);
function SurfaceTrace(scene, surface, uid) {
  this.scene = scene;
  this.uid = uid;
  this.surface = surface;
  this.data = null;
  this.showContour = [false, false, false];
  this.contourStart = [null, null, null];
  this.contourEnd = [null, null, null];
  this.contourSize = [0, 0, 0];
  this.minValues = [Infinity, Infinity, Infinity];
  this.maxValues = [-Infinity, -Infinity, -Infinity];
  this.dataScaleX = 1.0;
  this.dataScaleY = 1.0;
  this.refineData = true;
  this.objectOffset = [0, 0, 0];
}
var proto = SurfaceTrace.prototype;
proto.getXat = function (a, b, calendar, axis) {
  var v = !isArrayOrTypedArray(this.data.x) ? a : isArrayOrTypedArray(this.data.x[0]) ? this.data.x[b][a] : this.data.x[a];
  return calendar === undefined ? v : axis.d2l(v, 0, calendar);
};
proto.getYat = function (a, b, calendar, axis) {
  var v = !isArrayOrTypedArray(this.data.y) ? b : isArrayOrTypedArray(this.data.y[0]) ? this.data.y[b][a] : this.data.y[b];
  return calendar === undefined ? v : axis.d2l(v, 0, calendar);
};
proto.getZat = function (a, b, calendar, axis) {
  var v = this.data.z[b][a];
  if (v === null && this.data.connectgaps && this.data._interpolatedZ) {
    v = this.data._interpolatedZ[b][a];
  }
  return calendar === undefined ? v : axis.d2l(v, 0, calendar);
};
proto.handlePick = function (selection) {
  if (selection.object === this.surface) {
    var xRatio = (selection.data.index[0] - 1) / this.dataScaleX - 1;
    var yRatio = (selection.data.index[1] - 1) / this.dataScaleY - 1;
    var j = Math.max(Math.min(Math.round(xRatio), this.data.z[0].length - 1), 0);
    var k = Math.max(Math.min(Math.round(yRatio), this.data._ylength - 1), 0);
    selection.index = [j, k];
    selection.traceCoordinate = [this.getXat(j, k), this.getYat(j, k), this.getZat(j, k)];
    selection.dataCoordinate = [this.getXat(j, k, this.data.xcalendar, this.scene.fullSceneLayout.xaxis), this.getYat(j, k, this.data.ycalendar, this.scene.fullSceneLayout.yaxis), this.getZat(j, k, this.data.zcalendar, this.scene.fullSceneLayout.zaxis)];
    for (var i = 0; i < 3; i++) {
      var v = selection.dataCoordinate[i];
      if (v !== null && v !== undefined) {
        selection.dataCoordinate[i] *= this.scene.dataScale[i];
      }
    }
    var text = this.data.hovertext || this.data.text;
    if (isArrayOrTypedArray(text) && text[k] && text[k][j] !== undefined) {
      selection.textLabel = text[k][j];
    } else if (text) {
      selection.textLabel = text;
    } else {
      selection.textLabel = '';
    }
    selection.data.dataCoordinate = selection.dataCoordinate.slice();
    this.surface.highlight(selection.data);

    // Snap spikes to data coordinate
    this.scene.glplot.spikes.position = selection.dataCoordinate;
    return true;
  }
};
function isColormapCircular(colormap) {
  var first = colormap[0].rgb;
  var last = colormap[colormap.length - 1].rgb;
  return first[0] === last[0] && first[1] === last[1] && first[2] === last[2] && first[3] === last[3];
}
var shortPrimes = [2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37, 41, 43, 47, 53, 59, 61, 67, 71, 73, 79, 83, 89, 97, 101, 103, 107, 109, 113, 127, 131, 137, 139, 149, 151, 157, 163, 167, 173, 179, 181, 191, 193, 197, 199, 211, 223, 227, 229, 233, 239, 241, 251, 257, 263, 269, 271, 277, 281, 283, 293, 307, 311, 313, 317, 331, 337, 347, 349, 353, 359, 367, 373, 379, 383, 389, 397, 401, 409, 419, 421, 431, 433, 439, 443, 449, 457, 461, 463, 467, 479, 487, 491, 499, 503, 509, 521, 523, 541, 547, 557, 563, 569, 571, 577, 587, 593, 599, 601, 607, 613, 617, 619, 631, 641, 643, 647, 653, 659, 661, 673, 677, 683, 691, 701, 709, 719, 727, 733, 739, 743, 751, 757, 761, 769, 773, 787, 797, 809, 811, 821, 823, 827, 829, 839, 853, 857, 859, 863, 877, 881, 883, 887, 907, 911, 919, 929, 937, 941, 947, 953, 967, 971, 977, 983, 991, 997, 1009, 1013, 1019, 1021, 1031, 1033, 1039, 1049, 1051, 1061, 1063, 1069, 1087, 1091, 1093, 1097, 1103, 1109, 1117, 1123, 1129, 1151, 1153, 1163, 1171, 1181, 1187, 1193, 1201, 1213, 1217, 1223, 1229, 1231, 1237, 1249, 1259, 1277, 1279, 1283, 1289, 1291, 1297, 1301, 1303, 1307, 1319, 1321, 1327, 1361, 1367, 1373, 1381, 1399, 1409, 1423, 1427, 1429, 1433, 1439, 1447, 1451, 1453, 1459, 1471, 1481, 1483, 1487, 1489, 1493, 1499, 1511, 1523, 1531, 1543, 1549, 1553, 1559, 1567, 1571, 1579, 1583, 1597, 1601, 1607, 1609, 1613, 1619, 1621, 1627, 1637, 1657, 1663, 1667, 1669, 1693, 1697, 1699, 1709, 1721, 1723, 1733, 1741, 1747, 1753, 1759, 1777, 1783, 1787, 1789, 1801, 1811, 1823, 1831, 1847, 1861, 1867, 1871, 1873, 1877, 1879, 1889, 1901, 1907, 1913, 1931, 1933, 1949, 1951, 1973, 1979, 1987, 1993, 1997, 1999, 2003, 2011, 2017, 2027, 2029, 2039, 2053, 2063, 2069, 2081, 2083, 2087, 2089, 2099, 2111, 2113, 2129, 2131, 2137, 2141, 2143, 2153, 2161, 2179, 2203, 2207, 2213, 2221, 2237, 2239, 2243, 2251, 2267, 2269, 2273, 2281, 2287, 2293, 2297, 2309, 2311, 2333, 2339, 2341, 2347, 2351, 2357, 2371, 2377, 2381, 2383, 2389, 2393, 2399, 2411, 2417, 2423, 2437, 2441, 2447, 2459, 2467, 2473, 2477, 2503, 2521, 2531, 2539, 2543, 2549, 2551, 2557, 2579, 2591, 2593, 2609, 2617, 2621, 2633, 2647, 2657, 2659, 2663, 2671, 2677, 2683, 2687, 2689, 2693, 2699, 2707, 2711, 2713, 2719, 2729, 2731, 2741, 2749, 2753, 2767, 2777, 2789, 2791, 2797, 2801, 2803, 2819, 2833, 2837, 2843, 2851, 2857, 2861, 2879, 2887, 2897, 2903, 2909, 2917, 2927, 2939, 2953, 2957, 2963, 2969, 2971, 2999];
function getPow(a, b) {
  if (a < b) return 0;
  var n = 0;
  while (Math.floor(a % b) === 0) {
    a /= b;
    n++;
  }
  return n;
}
function getFactors(a) {
  var powers = [];
  for (var i = 0; i < shortPrimes.length; i++) {
    var b = shortPrimes[i];
    powers.push(getPow(a, b));
  }
  return powers;
}
function smallestDivisor(a) {
  var A = getFactors(a);
  var result = a;
  for (var i = 0; i < shortPrimes.length; i++) {
    if (A[i] > 0) {
      result = shortPrimes[i];
      break;
    }
  }
  return result;
}
function leastCommonMultiple(a, b) {
  if (a < 1 || b < 1) return undefined;
  var A = getFactors(a);
  var B = getFactors(b);
  var n = 1;
  for (var i = 0; i < shortPrimes.length; i++) {
    n *= Math.pow(shortPrimes[i], Math.max(A[i], B[i]));
  }
  return n;
}
function arrayLCM(A) {
  if (A.length === 0) return undefined;
  var n = 1;
  for (var i = 0; i < A.length; i++) {
    n = leastCommonMultiple(n, A[i]);
  }
  return n;
}
proto.calcXnums = function (xlen) {
  var i;
  var nums = [];
  for (i = 1; i < xlen; i++) {
    var a = this.getXat(i - 1, 0);
    var b = this.getXat(i, 0);
    if (b !== a && a !== undefined && a !== null && b !== undefined && b !== null) {
      nums[i - 1] = Math.abs(b - a);
    } else {
      nums[i - 1] = 0;
    }
  }
  var totalDist = 0;
  for (i = 1; i < xlen; i++) {
    totalDist += nums[i - 1];
  }
  for (i = 1; i < xlen; i++) {
    if (nums[i - 1] === 0) {
      nums[i - 1] = 1;
    } else {
      nums[i - 1] = Math.round(totalDist / nums[i - 1]);
    }
  }
  return nums;
};
proto.calcYnums = function (ylen) {
  var i;
  var nums = [];
  for (i = 1; i < ylen; i++) {
    var a = this.getYat(0, i - 1);
    var b = this.getYat(0, i);
    if (b !== a && a !== undefined && a !== null && b !== undefined && b !== null) {
      nums[i - 1] = Math.abs(b - a);
    } else {
      nums[i - 1] = 0;
    }
  }
  var totalDist = 0;
  for (i = 1; i < ylen; i++) {
    totalDist += nums[i - 1];
  }
  for (i = 1; i < ylen; i++) {
    if (nums[i - 1] === 0) {
      nums[i - 1] = 1;
    } else {
      nums[i - 1] = Math.round(totalDist / nums[i - 1]);
    }
  }
  return nums;
};
var highlyComposites = [1, 2, 4, 6, 12, 24, 36, 48, 60, 120, 180, 240, 360, 720, 840, 1260];
var MIN_RESOLUTION = highlyComposites[9];
var MAX_RESOLUTION = highlyComposites[13];
proto.estimateScale = function (resSrc, axis) {
  var nums = axis === 0 ? this.calcXnums(resSrc) : this.calcYnums(resSrc);
  var resDst = 1 + arrayLCM(nums);
  while (resDst < MIN_RESOLUTION) {
    resDst *= 2;
  }
  while (resDst > MAX_RESOLUTION) {
    resDst--;
    resDst /= smallestDivisor(resDst);
    resDst++;
    if (resDst < MIN_RESOLUTION) {
      // resDst = MIN_RESOLUTION; // option 1: use min resolution
      resDst = MAX_RESOLUTION; // option 2: use max resolution
    }
  }
  var scale = Math.round(resDst / resSrc);
  return scale > 1 ? scale : 1;
};

// based on Mikola Lysenko's ndarray-homography
// see https://github.com/scijs/ndarray-homography

function fnHomography(out, inp, X) {
  var w = X[8] + X[2] * inp[0] + X[5] * inp[1];
  out[0] = (X[6] + X[0] * inp[0] + X[3] * inp[1]) / w;
  out[1] = (X[7] + X[1] * inp[0] + X[4] * inp[1]) / w;
  return out;
}
function homography(dest, src, X) {
  warp(dest, src, fnHomography, X);
  return dest;
}

// based on Mikola Lysenko's ndarray-warp
// see https://github.com/scijs/ndarray-warp

function warp(dest, src, func, X) {
  var warped = [0, 0];
  var ni = dest.shape[0];
  var nj = dest.shape[1];
  for (var i = 0; i < ni; i++) {
    for (var j = 0; j < nj; j++) {
      func(warped, [i, j], X);
      dest.set(i, j, ndarrayInterp2d(src, warped[0], warped[1]));
    }
  }
  return dest;
}
proto.refineCoords = function (coords) {
  var scaleW = this.dataScaleX;
  var scaleH = this.dataScaleY;
  var width = coords[0].shape[0];
  var height = coords[0].shape[1];
  var newWidth = Math.floor(coords[0].shape[0] * scaleW + 1) | 0;
  var newHeight = Math.floor(coords[0].shape[1] * scaleH + 1) | 0;

  // Pad coords by +1
  var padWidth = 1 + width + 1;
  var padHeight = 1 + height + 1;
  var padImg = ndarray(new Float32Array(padWidth * padHeight), [padWidth, padHeight]);
  var X = [1 / scaleW, 0, 0, 0, 1 / scaleH, 0, 0, 0, 1];
  for (var i = 0; i < coords.length; ++i) {
    this.surface.padField(padImg, coords[i]);
    var scaledImg = ndarray(new Float32Array(newWidth * newHeight), [newWidth, newHeight]);
    homography(scaledImg, padImg, X);
    coords[i] = scaledImg;
  }
};
function insertIfNewLevel(arr, newValue) {
  var found = false;
  for (var k = 0; k < arr.length; k++) {
    if (newValue === arr[k]) {
      found = true;
      break;
    }
  }
  if (found === false) arr.push(newValue);
}
proto.setContourLevels = function () {
  var newLevels = [[], [], []];
  var useNewLevels = [false, false, false];
  var needsUpdate = false;
  var i, j, value;
  for (i = 0; i < 3; ++i) {
    if (this.showContour[i]) {
      needsUpdate = true;
      if (this.contourSize[i] > 0 && this.contourStart[i] !== null && this.contourEnd[i] !== null && this.contourEnd[i] > this.contourStart[i]) {
        useNewLevels[i] = true;
        for (j = this.contourStart[i]; j < this.contourEnd[i]; j += this.contourSize[i]) {
          value = j * this.scene.dataScale[i];
          insertIfNewLevel(newLevels[i], value);
        }
      }
    }
  }
  if (needsUpdate) {
    var allLevels = [[], [], []];
    for (i = 0; i < 3; ++i) {
      if (this.showContour[i]) {
        allLevels[i] = useNewLevels[i] ? newLevels[i] : this.scene.contourLevels[i];
      }
    }
    this.surface.update({
      levels: allLevels
    });
  }
};
proto.update = function (data) {
  var scene = this.scene;
  var sceneLayout = scene.fullSceneLayout;
  var surface = this.surface;
  var colormap = parseColorScale(data);
  var scaleFactor = scene.dataScale;
  var xlen = data.z[0].length;
  var ylen = data._ylength;
  var contourLevels = scene.contourLevels;

  // Save data
  this.data = data;

  /*
   * Fill and transpose zdata.
   * Consistent with 'heatmap' and 'contour', plotly 'surface'
   * 'z' are such that sub-arrays correspond to y-coords
   * and that the sub-array entries correspond to a x-coords,
   * which is the transpose of 'gl-surface-plot'.
   */

  var i, j, k, v;
  var rawCoords = [];
  for (i = 0; i < 3; i++) {
    rawCoords[i] = [];
    for (j = 0; j < xlen; j++) {
      rawCoords[i][j] = [];
      /*
      for(k = 0; k < ylen; k++) {
          rawCoords[i][j][k] = undefined;
      }
      */
    }
  }

  // coords x, y & z
  for (j = 0; j < xlen; j++) {
    for (k = 0; k < ylen; k++) {
      rawCoords[0][j][k] = this.getXat(j, k, data.xcalendar, sceneLayout.xaxis);
      rawCoords[1][j][k] = this.getYat(j, k, data.ycalendar, sceneLayout.yaxis);
      rawCoords[2][j][k] = this.getZat(j, k, data.zcalendar, sceneLayout.zaxis);
    }
  }
  if (data.connectgaps) {
    data._emptypoints = findEmpties(rawCoords[2]);
    interp2d(rawCoords[2], data._emptypoints);
    data._interpolatedZ = [];
    for (j = 0; j < xlen; j++) {
      data._interpolatedZ[j] = [];
      for (k = 0; k < ylen; k++) {
        data._interpolatedZ[j][k] = rawCoords[2][j][k];
      }
    }
  }

  // Note: log axes are not defined in surfaces yet.
  // but they could be defined here...

  for (i = 0; i < 3; i++) {
    for (j = 0; j < xlen; j++) {
      for (k = 0; k < ylen; k++) {
        v = rawCoords[i][j][k];
        if (v === null || v === undefined) {
          rawCoords[i][j][k] = NaN;
        } else {
          v = rawCoords[i][j][k] *= scaleFactor[i];
        }
      }
    }
  }
  for (i = 0; i < 3; i++) {
    for (j = 0; j < xlen; j++) {
      for (k = 0; k < ylen; k++) {
        v = rawCoords[i][j][k];
        if (v !== null && v !== undefined) {
          if (this.minValues[i] > v) {
            this.minValues[i] = v;
          }
          if (this.maxValues[i] < v) {
            this.maxValues[i] = v;
          }
        }
      }
    }
  }
  for (i = 0; i < 3; i++) {
    this.objectOffset[i] = 0.5 * (this.minValues[i] + this.maxValues[i]);
  }
  for (i = 0; i < 3; i++) {
    for (j = 0; j < xlen; j++) {
      for (k = 0; k < ylen; k++) {
        v = rawCoords[i][j][k];
        if (v !== null && v !== undefined) {
          rawCoords[i][j][k] -= this.objectOffset[i];
        }
      }
    }
  }

  // convert processed raw data to Float32 matrices
  var coords = [ndarray(new Float32Array(xlen * ylen), [xlen, ylen]), ndarray(new Float32Array(xlen * ylen), [xlen, ylen]), ndarray(new Float32Array(xlen * ylen), [xlen, ylen])];
  for (i = 0; i < 3; i++) {
    for (j = 0; j < xlen; j++) {
      for (k = 0; k < ylen; k++) {
        coords[i].set(j, k, rawCoords[i][j][k]);
      }
    }
  }
  rawCoords = []; // free memory

  var params = {
    colormap: colormap,
    levels: [[], [], []],
    showContour: [true, true, true],
    showSurface: !data.hidesurface,
    contourProject: [[false, false, false], [false, false, false], [false, false, false]],
    contourWidth: [1, 1, 1],
    contourColor: [[1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1]],
    contourTint: [1, 1, 1],
    dynamicColor: [[1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1]],
    dynamicWidth: [1, 1, 1],
    dynamicTint: [1, 1, 1],
    opacityscale: data.opacityscale,
    opacity: data.opacity
  };
  var cOpts = extractOpts(data);
  params.intensityBounds = [cOpts.min, cOpts.max];

  // Refine surface color if necessary
  if (data.surfacecolor) {
    var intensity = ndarray(new Float32Array(xlen * ylen), [xlen, ylen]);
    for (j = 0; j < xlen; j++) {
      for (k = 0; k < ylen; k++) {
        intensity.set(j, k, data.surfacecolor[k][j]);
      }
    }
    coords.push(intensity);
  } else {
    // when 'z' is used as 'intensity',
    // we must scale its value
    params.intensityBounds[0] *= scaleFactor[2];
    params.intensityBounds[1] *= scaleFactor[2];
  }
  if (MAX_RESOLUTION < coords[0].shape[0] || MAX_RESOLUTION < coords[0].shape[1]) {
    this.refineData = false;
  }
  if (this.refineData === true) {
    this.dataScaleX = this.estimateScale(coords[0].shape[0], 0);
    this.dataScaleY = this.estimateScale(coords[0].shape[1], 1);
    if (this.dataScaleX !== 1 || this.dataScaleY !== 1) {
      this.refineCoords(coords);
    }
  }
  if (data.surfacecolor) {
    params.intensity = coords.pop();
  }
  var highlightEnable = [true, true, true];
  var axis = ['x', 'y', 'z'];
  for (i = 0; i < 3; ++i) {
    var contourParams = data.contours[axis[i]];
    highlightEnable[i] = contourParams.highlight;
    params.showContour[i] = contourParams.show || contourParams.highlight;
    if (!params.showContour[i]) continue;
    params.contourProject[i] = [contourParams.project.x, contourParams.project.y, contourParams.project.z];
    if (contourParams.show) {
      this.showContour[i] = true;
      params.levels[i] = contourLevels[i];
      surface.highlightColor[i] = params.contourColor[i] = str2RgbaArray(contourParams.color);
      if (contourParams.usecolormap) {
        surface.highlightTint[i] = params.contourTint[i] = 0;
      } else {
        surface.highlightTint[i] = params.contourTint[i] = 1;
      }
      params.contourWidth[i] = contourParams.width;
      this.contourStart[i] = contourParams.start;
      this.contourEnd[i] = contourParams.end;
      this.contourSize[i] = contourParams.size;
    } else {
      this.showContour[i] = false;
      this.contourStart[i] = null;
      this.contourEnd[i] = null;
      this.contourSize[i] = 0;
    }
    if (contourParams.highlight) {
      params.dynamicColor[i] = str2RgbaArray(contourParams.highlightcolor);
      params.dynamicWidth[i] = contourParams.highlightwidth;
    }
  }

  // see https://github.com/plotly/plotly.js/issues/940
  if (isColormapCircular(colormap)) {
    params.vertexColor = true;
  }
  params.objectOffset = this.objectOffset;
  params.coords = coords;
  surface.update(params);
  surface.visible = data.visible;
  surface.enableDynamic = highlightEnable;
  surface.enableHighlight = highlightEnable;
  surface.snapToData = true;
  if ('lighting' in data) {
    surface.ambientLight = data.lighting.ambient;
    surface.diffuseLight = data.lighting.diffuse;
    surface.specularLight = data.lighting.specular;
    surface.roughness = data.lighting.roughness;
    surface.fresnel = data.lighting.fresnel;
  }
  if ('lightposition' in data) {
    surface.lightPosition = [data.lightposition.x, data.lightposition.y, data.lightposition.z];
  }
};
proto.dispose = function () {
  this.scene.glplot.remove(this.surface);
  this.surface.dispose();
};
function createSurfaceTrace(scene, data) {
  var gl = scene.glplot.gl;
  var surface = createSurface({
    gl: gl
  });
  var result = new SurfaceTrace(scene, surface, data.uid);
  surface._trace = result;
  result.update(data);
  scene.glplot.add(surface);
  return result;
}
module.exports = createSurfaceTrace;

/***/ }),

/***/ 65444:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Registry = __webpack_require__(33626);
var Lib = __webpack_require__(34809);
var colorscaleDefaults = __webpack_require__(39356);
var attributes = __webpack_require__(16131);
var MIN = 0.1; // Note: often we don't want the data cube to be disappeared

function createWave(n, minOpacity) {
  var arr = [];
  var steps = 32; // Max: 256
  for (var i = 0; i < steps; i++) {
    var u = i / (steps - 1);
    var v = minOpacity + (1 - minOpacity) * (1 - Math.pow(Math.sin(n * u * Math.PI), 2));
    arr.push([u, Math.max(0, Math.min(1, v))]);
  }
  return arr;
}
function isValidScaleArray(scl) {
  var highestVal = 0;
  if (!Array.isArray(scl) || scl.length < 2) return false;
  if (!scl[0] || !scl[scl.length - 1]) return false;
  if (+scl[0][0] !== 0 || +scl[scl.length - 1][0] !== 1) return false;
  for (var i = 0; i < scl.length; i++) {
    var si = scl[i];
    if (si.length !== 2 || +si[0] < highestVal) {
      return false;
    }
    highestVal = +si[0];
  }
  return true;
}
function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
  var i, j;
  function coerce(attr, dflt) {
    return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
  }
  var x = coerce('x');
  var y = coerce('y');
  var z = coerce('z');
  if (!z || !z.length || (x ? x.length < 1 : false) || (y ? y.length < 1 : false)) {
    traceOut.visible = false;
    return;
  }
  traceOut._xlength = Array.isArray(x) && Lib.isArrayOrTypedArray(x[0]) ? z.length : z[0].length;
  traceOut._ylength = z.length;
  var handleCalendarDefaults = Registry.getComponentMethod('calendars', 'handleTraceDefaults');
  handleCalendarDefaults(traceIn, traceOut, ['x', 'y', 'z'], layout);
  coerce('text');
  coerce('hovertext');
  coerce('hovertemplate');
  coerce('xhoverformat');
  coerce('yhoverformat');
  coerce('zhoverformat');

  // Coerce remaining properties
  ['lighting.ambient', 'lighting.diffuse', 'lighting.specular', 'lighting.roughness', 'lighting.fresnel', 'lightposition.x', 'lightposition.y', 'lightposition.z', 'hidesurface', 'connectgaps', 'opacity'].forEach(function (x) {
    coerce(x);
  });
  var surfaceColor = coerce('surfacecolor');
  var dims = ['x', 'y', 'z'];
  for (i = 0; i < 3; ++i) {
    var contourDim = 'contours.' + dims[i];
    var show = coerce(contourDim + '.show');
    var highlight = coerce(contourDim + '.highlight');
    if (show || highlight) {
      for (j = 0; j < 3; ++j) {
        coerce(contourDim + '.project.' + dims[j]);
      }
    }
    if (show) {
      coerce(contourDim + '.color');
      coerce(contourDim + '.width');
      coerce(contourDim + '.usecolormap');
    }
    if (highlight) {
      coerce(contourDim + '.highlightcolor');
      coerce(contourDim + '.highlightwidth');
    }
    coerce(contourDim + '.start');
    coerce(contourDim + '.end');
    coerce(contourDim + '.size');
  }

  // backward compatibility block
  if (!surfaceColor) {
    mapLegacy(traceIn, 'zmin', 'cmin');
    mapLegacy(traceIn, 'zmax', 'cmax');
    mapLegacy(traceIn, 'zauto', 'cauto');
  }

  // TODO if contours.?.usecolormap are false and hidesurface is true
  // the colorbar shouldn't be shown by default

  colorscaleDefaults(traceIn, traceOut, layout, coerce, {
    prefix: '',
    cLetter: 'c'
  });
  opacityscaleDefaults(traceIn, traceOut, layout, coerce);

  // disable 1D transforms - currently surface does NOT support column data like heatmap does
  // you can use mesh3d for this use case, but not surface
  traceOut._length = null;
}
function opacityscaleDefaults(traceIn, traceOut, layout, coerce) {
  var opacityscale = coerce('opacityscale');
  if (opacityscale === 'max') {
    traceOut.opacityscale = [[0, MIN], [1, 1]];
  } else if (opacityscale === 'min') {
    traceOut.opacityscale = [[0, 1], [1, MIN]];
  } else if (opacityscale === 'extremes') {
    traceOut.opacityscale = createWave(1, MIN);
  } else if (!isValidScaleArray(opacityscale)) {
    traceOut.opacityscale = undefined;
  }
}
function mapLegacy(traceIn, oldAttr, newAttr) {
  if (oldAttr in traceIn && !(newAttr in traceIn)) {
    traceIn[newAttr] = traceIn[oldAttr];
  }
}
module.exports = {
  supplyDefaults: supplyDefaults,
  opacityscaleDefaults: opacityscaleDefaults
};

/***/ }),

/***/ 95984:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = {
  attributes: __webpack_require__(16131),
  supplyDefaults: (__webpack_require__(65444).supplyDefaults),
  colorbar: {
    min: 'cmin',
    max: 'cmax'
  },
  calc: __webpack_require__(53027),
  plot: __webpack_require__(27159),
  moduleType: 'trace',
  name: 'surface',
  basePlotModule: __webpack_require__(2487),
  categories: ['gl3d', '2dMap', 'showLegend'],
  meta: {}
};

/***/ }),

/***/ 92294:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var annAttrs = __webpack_require__(50222);
var extendFlat = (__webpack_require__(93049).extendFlat);
var overrideAll = (__webpack_require__(13582).overrideAll);
var fontAttrs = __webpack_require__(80337);
var domainAttrs = (__webpack_require__(13792)/* .attributes */ .u);
var descriptionOnlyNumbers = (__webpack_require__(80712).descriptionOnlyNumbers);
var attrs = module.exports = overrideAll({
  domain: domainAttrs({
    name: 'table',
    trace: true
  }),
  columnwidth: {
    valType: 'number',
    arrayOk: true,
    dflt: null
  },
  columnorder: {
    valType: 'data_array'
  },
  header: {
    values: {
      valType: 'data_array',
      dflt: []
    },
    format: {
      valType: 'data_array',
      dflt: [],
      description: descriptionOnlyNumbers('cell value')
    },
    prefix: {
      valType: 'string',
      arrayOk: true,
      dflt: null
    },
    suffix: {
      valType: 'string',
      arrayOk: true,
      dflt: null
    },
    height: {
      valType: 'number',
      dflt: 28
    },
    align: extendFlat({}, annAttrs.align, {
      arrayOk: true
    }),
    line: {
      width: {
        valType: 'number',
        arrayOk: true,
        dflt: 1
      },
      color: {
        valType: 'color',
        arrayOk: true,
        dflt: 'grey'
      }
    },
    fill: {
      color: {
        valType: 'color',
        arrayOk: true,
        dflt: 'white'
      }
    },
    font: extendFlat({}, fontAttrs({
      arrayOk: true
    }))
  },
  cells: {
    values: {
      valType: 'data_array',
      dflt: []
    },
    format: {
      valType: 'data_array',
      dflt: [],
      description: descriptionOnlyNumbers('cell value')
    },
    prefix: {
      valType: 'string',
      arrayOk: true,
      dflt: null
    },
    suffix: {
      valType: 'string',
      arrayOk: true,
      dflt: null
    },
    height: {
      valType: 'number',
      dflt: 20
    },
    align: extendFlat({}, annAttrs.align, {
      arrayOk: true
    }),
    line: {
      width: {
        valType: 'number',
        arrayOk: true,
        dflt: 1
      },
      color: {
        valType: 'color',
        arrayOk: true,
        dflt: 'grey'
      }
    },
    fill: {
      color: {
        valType: 'color',
        arrayOk: true,
        dflt: 'white'
      }
    },
    font: extendFlat({}, fontAttrs({
      arrayOk: true
    }))
  }
}, 'calc', 'from-root');
attrs.transforms = undefined;

/***/ }),

/***/ 82662:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var getModuleCalcData = (__webpack_require__(4173)/* .getModuleCalcData */ .eV);
var tablePlot = __webpack_require__(84576);
var TABLE = 'table';
exports.name = TABLE;
exports.plot = function (gd) {
  var calcData = getModuleCalcData(gd.calcdata, TABLE)[0];
  if (calcData.length) tablePlot(gd, calcData);
};
exports.clean = function (newFullData, newFullLayout, oldFullData, oldFullLayout) {
  var hadTable = oldFullLayout._has && oldFullLayout._has(TABLE);
  var hasTable = newFullLayout._has && newFullLayout._has(TABLE);
  if (hadTable && !hasTable) {
    oldFullLayout._paperdiv.selectAll('.table').remove();
  }
};

/***/ }),

/***/ 87522:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var wrap = (__webpack_require__(71293).wrap);
module.exports = function calc() {
  // we don't actually need to include the trace here, since that will be added
  // by Plots.doCalcdata, and that's all we actually need later.
  return wrap({});
};

/***/ }),

/***/ 18426:
/***/ (function(module) {

"use strict";


module.exports = {
  cellPad: 8,
  columnExtentOffset: 10,
  columnTitleOffset: 28,
  emptyHeaderHeight: 16,
  latexCheck: /^\$.*\$$/,
  goldenRatio: 1.618,
  lineBreaker: '<br>',
  maxDimensionCount: 60,
  overdrag: 45,
  releaseTransitionDuration: 120,
  releaseTransitionEase: 'cubic-out',
  scrollbarCaptureWidth: 18,
  scrollbarHideDelay: 1000,
  scrollbarHideDuration: 1000,
  scrollbarOffset: 5,
  scrollbarWidth: 8,
  transitionDuration: 100,
  transitionEase: 'cubic-out',
  uplift: 5,
  wrapSpacer: ' ',
  wrapSplitCharacter: ' ',
  cn: {
    // general class names
    table: 'table',
    tableControlView: 'table-control-view',
    scrollBackground: 'scroll-background',
    yColumn: 'y-column',
    columnBlock: 'column-block',
    scrollAreaClip: 'scroll-area-clip',
    scrollAreaClipRect: 'scroll-area-clip-rect',
    columnBoundary: 'column-boundary',
    columnBoundaryClippath: 'column-boundary-clippath',
    columnBoundaryRect: 'column-boundary-rect',
    columnCells: 'column-cells',
    columnCell: 'column-cell',
    cellRect: 'cell-rect',
    cellText: 'cell-text',
    cellTextHolder: 'cell-text-holder',
    // scroll related class names
    scrollbarKit: 'scrollbar-kit',
    scrollbar: 'scrollbar',
    scrollbarSlider: 'scrollbar-slider',
    scrollbarGlyph: 'scrollbar-glyph',
    scrollbarCaptureZone: 'scrollbar-capture-zone'
  }
};

/***/ }),

/***/ 21908:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var c = __webpack_require__(18426);
var extendFlat = (__webpack_require__(93049).extendFlat);
var isNumeric = __webpack_require__(10721);
var isTypedArray = (__webpack_require__(87800).isTypedArray);
var isArrayOrTypedArray = (__webpack_require__(87800).isArrayOrTypedArray);

// pure functions, don't alter but passes on `gd` and parts of `trace` without deep copying
module.exports = function calc(gd, trace) {
  var cellsValues = squareStringMatrix(trace.cells.values);
  var slicer = function (a) {
    return a.slice(trace.header.values.length, a.length);
  };
  var headerValuesIn = squareStringMatrix(trace.header.values);
  if (headerValuesIn.length && !headerValuesIn[0].length) {
    headerValuesIn[0] = [''];
    headerValuesIn = squareStringMatrix(headerValuesIn);
  }
  var headerValues = headerValuesIn.concat(slicer(cellsValues).map(function () {
    return emptyStrings((headerValuesIn[0] || ['']).length);
  }));
  var domain = trace.domain;
  var groupWidth = Math.floor(gd._fullLayout._size.w * (domain.x[1] - domain.x[0]));
  var groupHeight = Math.floor(gd._fullLayout._size.h * (domain.y[1] - domain.y[0]));
  var headerRowHeights = trace.header.values.length ? headerValues[0].map(function () {
    return trace.header.height;
  }) : [c.emptyHeaderHeight];
  var rowHeights = cellsValues.length ? cellsValues[0].map(function () {
    return trace.cells.height;
  }) : [];
  var headerHeight = headerRowHeights.reduce(sum, 0);
  var scrollHeight = groupHeight - headerHeight;
  var minimumFillHeight = scrollHeight + c.uplift;
  var anchorToRowBlock = makeAnchorToRowBlock(rowHeights, minimumFillHeight);
  var anchorToHeaderRowBlock = makeAnchorToRowBlock(headerRowHeights, headerHeight);
  var headerRowBlocks = makeRowBlock(anchorToHeaderRowBlock, []);
  var rowBlocks = makeRowBlock(anchorToRowBlock, headerRowBlocks);
  var uniqueKeys = {};
  var columnOrder = trace._fullInput.columnorder;
  if (isArrayOrTypedArray(columnOrder)) columnOrder = Array.from(columnOrder);
  columnOrder = columnOrder.concat(slicer(cellsValues.map(function (d, i) {
    return i;
  })));
  var columnWidths = headerValues.map(function (d, i) {
    var value = isArrayOrTypedArray(trace.columnwidth) ? trace.columnwidth[Math.min(i, trace.columnwidth.length - 1)] : trace.columnwidth;
    return isNumeric(value) ? Number(value) : 1;
  });
  var totalColumnWidths = columnWidths.reduce(sum, 0);

  // fit columns in the available vertical space as there's no vertical scrolling now
  columnWidths = columnWidths.map(function (d) {
    return d / totalColumnWidths * groupWidth;
  });
  var maxLineWidth = Math.max(arrayMax(trace.header.line.width), arrayMax(trace.cells.line.width));
  var calcdata = {
    // include staticPlot in the key so if it changes we delete and redraw
    key: trace.uid + gd._context.staticPlot,
    translateX: domain.x[0] * gd._fullLayout._size.w,
    translateY: gd._fullLayout._size.h * (1 - domain.y[1]),
    size: gd._fullLayout._size,
    width: groupWidth,
    maxLineWidth: maxLineWidth,
    height: groupHeight,
    columnOrder: columnOrder,
    // will be mutated on column move, todo use in callback
    groupHeight: groupHeight,
    rowBlocks: rowBlocks,
    headerRowBlocks: headerRowBlocks,
    scrollY: 0,
    // will be mutated on scroll
    cells: extendFlat({}, trace.cells, {
      values: cellsValues
    }),
    headerCells: extendFlat({}, trace.header, {
      values: headerValues
    }),
    gdColumns: headerValues.map(function (d) {
      return d[0];
    }),
    gdColumnsOriginalOrder: headerValues.map(function (d) {
      return d[0];
    }),
    prevPages: [0, 0],
    scrollbarState: {
      scrollbarScrollInProgress: false
    },
    columns: headerValues.map(function (label, i) {
      var foundKey = uniqueKeys[label];
      uniqueKeys[label] = (foundKey || 0) + 1;
      var key = label + '__' + uniqueKeys[label];
      return {
        key: key,
        label: label,
        specIndex: i,
        xIndex: columnOrder[i],
        xScale: xScale,
        x: undefined,
        // initialized below
        calcdata: undefined,
        // initialized below
        columnWidth: columnWidths[i]
      };
    })
  };
  calcdata.columns.forEach(function (col) {
    col.calcdata = calcdata;
    col.x = xScale(col);
  });
  return calcdata;
};
function arrayMax(maybeArray) {
  if (isArrayOrTypedArray(maybeArray)) {
    var max = 0;
    for (var i = 0; i < maybeArray.length; i++) {
      max = Math.max(max, arrayMax(maybeArray[i]));
    }
    return max;
  }
  return maybeArray;
}
function sum(a, b) {
  return a + b;
}

// fill matrix in place to equal lengths
// and ensure it's uniformly 2D
function squareStringMatrix(matrixIn) {
  var matrix = matrixIn.slice();
  var minLen = Infinity;
  var maxLen = 0;
  var i;
  for (i = 0; i < matrix.length; i++) {
    if (isTypedArray(matrix[i])) matrix[i] = Array.from(matrix[i]);else if (!isArrayOrTypedArray(matrix[i])) matrix[i] = [matrix[i]];
    minLen = Math.min(minLen, matrix[i].length);
    maxLen = Math.max(maxLen, matrix[i].length);
  }
  if (minLen !== maxLen) {
    for (i = 0; i < matrix.length; i++) {
      var padLen = maxLen - matrix[i].length;
      if (padLen) matrix[i] = matrix[i].concat(emptyStrings(padLen));
    }
  }
  return matrix;
}
function emptyStrings(len) {
  var padArray = new Array(len);
  for (var j = 0; j < len; j++) padArray[j] = '';
  return padArray;
}
function xScale(d) {
  return d.calcdata.columns.reduce(function (prev, next) {
    return next.xIndex < d.xIndex ? prev + next.columnWidth : prev;
  }, 0);
}
function makeRowBlock(anchorToRowBlock, auxiliary) {
  var blockAnchorKeys = Object.keys(anchorToRowBlock);
  return blockAnchorKeys.map(function (k) {
    return extendFlat({}, anchorToRowBlock[k], {
      auxiliaryBlocks: auxiliary
    });
  });
}
function makeAnchorToRowBlock(rowHeights, minimumFillHeight) {
  var anchorToRowBlock = {};
  var currentRowHeight;
  var currentAnchor = 0;
  var currentBlockHeight = 0;
  var currentBlock = makeIdentity();
  var currentFirstRowIndex = 0;
  var blockCounter = 0;
  for (var i = 0; i < rowHeights.length; i++) {
    currentRowHeight = rowHeights[i];
    currentBlock.rows.push({
      rowIndex: i,
      rowHeight: currentRowHeight
    });
    currentBlockHeight += currentRowHeight;
    if (currentBlockHeight >= minimumFillHeight || i === rowHeights.length - 1) {
      anchorToRowBlock[currentAnchor] = currentBlock;
      currentBlock.key = blockCounter++;
      currentBlock.firstRowIndex = currentFirstRowIndex;
      currentBlock.lastRowIndex = i;
      currentBlock = makeIdentity();
      currentAnchor += currentBlockHeight;
      currentFirstRowIndex = i + 1;
      currentBlockHeight = 0;
    }
  }
  return anchorToRowBlock;
}
function makeIdentity() {
  return {
    firstRowIndex: null,
    lastRowIndex: null,
    rows: []
  };
}

/***/ }),

/***/ 49618:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var extendFlat = (__webpack_require__(93049).extendFlat);

// pure functions, don't alter but passes on `gd` and parts of `trace` without deep copying

exports.splitToPanels = function (d) {
  var prevPages = [0, 0];
  var headerPanel = extendFlat({}, d, {
    key: 'header',
    type: 'header',
    page: 0,
    prevPages: prevPages,
    currentRepaint: [null, null],
    dragHandle: true,
    values: d.calcdata.headerCells.values[d.specIndex],
    rowBlocks: d.calcdata.headerRowBlocks,
    calcdata: extendFlat({}, d.calcdata, {
      cells: d.calcdata.headerCells
    })
  });
  var revolverPanel1 = extendFlat({}, d, {
    key: 'cells1',
    type: 'cells',
    page: 0,
    prevPages: prevPages,
    currentRepaint: [null, null],
    dragHandle: false,
    values: d.calcdata.cells.values[d.specIndex],
    rowBlocks: d.calcdata.rowBlocks
  });
  var revolverPanel2 = extendFlat({}, d, {
    key: 'cells2',
    type: 'cells',
    page: 1,
    prevPages: prevPages,
    currentRepaint: [null, null],
    dragHandle: false,
    values: d.calcdata.cells.values[d.specIndex],
    rowBlocks: d.calcdata.rowBlocks
  });
  // order due to SVG using painter's algo:
  return [revolverPanel1, revolverPanel2, headerPanel];
};
exports.splitToCells = function (d) {
  var fromTo = rowFromTo(d);
  return (d.values || []).slice(fromTo[0], fromTo[1]).map(function (v, i) {
    // By keeping identical key, a DOM node removal, creation and addition is spared, important when visible
    // grid has a lot of elements (quadratic with xcol/ycol count).
    // But it has to be busted when `svgUtil.convertToTspans` is used as it reshapes cell subtrees asynchronously,
    // and by that time the user may have scrolled away, resulting in stale overwrites. The real solution will be
    // to turn `svgUtil.convertToTspans` into a cancelable request, in which case no key busting is needed.
    var buster = typeof v === 'string' && v.match(/[<$&> ]/) ? '_keybuster_' + Math.random() : '';
    return {
      // keyWithinBlock: /*fromTo[0] + */i, // optimized future version - no busting
      // keyWithinBlock: fromTo[0] + i, // initial always-unoptimized version - janky scrolling with 5+ columns
      keyWithinBlock: i + buster,
      // current compromise: regular content is very fast; async content is possible
      key: fromTo[0] + i,
      column: d,
      calcdata: d.calcdata,
      page: d.page,
      rowBlocks: d.rowBlocks,
      value: v
    };
  });
};
function rowFromTo(d) {
  var rowBlock = d.rowBlocks[d.page];
  // fixme rowBlock truthiness check is due to ugly hack of placing 2nd panel as d.page = -1
  var rowFrom = rowBlock ? rowBlock.rows[0].rowIndex : 0;
  var rowTo = rowBlock ? rowFrom + rowBlock.rows.length : 0;
  return [rowFrom, rowTo];
}

/***/ }),

/***/ 23281:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var attributes = __webpack_require__(92294);
var handleDomainDefaults = (__webpack_require__(13792)/* .defaults */ .N);
function defaultColumnOrder(traceOut, coerce) {
  var specifiedColumnOrder = traceOut.columnorder || [];
  var commonLength = traceOut.header.values.length;
  var truncated = specifiedColumnOrder.slice(0, commonLength);
  var sorted = truncated.slice().sort(function (a, b) {
    return a - b;
  });
  var oneStepped = truncated.map(function (d) {
    return sorted.indexOf(d);
  });
  for (var i = oneStepped.length; i < commonLength; i++) {
    oneStepped.push(i);
  }
  coerce('columnorder', oneStepped);
}
module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
  function coerce(attr, dflt) {
    return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
  }
  handleDomainDefaults(traceOut, layout, coerce);
  coerce('columnwidth');
  coerce('header.values');
  coerce('header.format');
  coerce('header.align');
  coerce('header.prefix');
  coerce('header.suffix');
  coerce('header.height');
  coerce('header.line.width');
  coerce('header.line.color');
  coerce('header.fill.color');
  Lib.coerceFont(coerce, 'header.font', layout.font);
  defaultColumnOrder(traceOut, coerce);
  coerce('cells.values');
  coerce('cells.format');
  coerce('cells.align');
  coerce('cells.prefix');
  coerce('cells.suffix');
  coerce('cells.height');
  coerce('cells.line.width');
  coerce('cells.line.color');
  coerce('cells.fill.color');
  Lib.coerceFont(coerce, 'cells.font', layout.font);

  // disable 1D transforms
  traceOut._length = null;
};

/***/ }),

/***/ 51671:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = {
  attributes: __webpack_require__(92294),
  supplyDefaults: __webpack_require__(23281),
  calc: __webpack_require__(87522),
  plot: __webpack_require__(84576),
  moduleType: 'trace',
  name: 'table',
  basePlotModule: __webpack_require__(82662),
  categories: ['noOpacity'],
  meta: {}
};

/***/ }),

/***/ 84576:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var c = __webpack_require__(18426);
var d3 = __webpack_require__(45568);
var Lib = __webpack_require__(34809);
var numberFormat = Lib.numberFormat;
var gup = __webpack_require__(71293);
var Drawing = __webpack_require__(62203);
var svgUtil = __webpack_require__(30635);
var raiseToTop = (__webpack_require__(34809).raiseToTop);
var strTranslate = (__webpack_require__(34809).strTranslate);
var cancelEeaseColumn = (__webpack_require__(34809).cancelTransition);
var prepareData = __webpack_require__(21908);
var splitData = __webpack_require__(49618);
var Color = __webpack_require__(78766);
module.exports = function plot(gd, wrappedTraceHolders) {
  var dynamic = !gd._context.staticPlot;
  var table = gd._fullLayout._paper.selectAll('.' + c.cn.table).data(wrappedTraceHolders.map(function (wrappedTraceHolder) {
    var traceHolder = gup.unwrap(wrappedTraceHolder);
    var trace = traceHolder.trace;
    return prepareData(gd, trace);
  }), gup.keyFun);
  table.exit().remove();
  table.enter().append('g').classed(c.cn.table, true).attr('overflow', 'visible').style('box-sizing', 'content-box').style('position', 'absolute').style('left', 0).style('overflow', 'visible').style('shape-rendering', 'crispEdges').style('pointer-events', 'all');
  table.attr('width', function (d) {
    return d.width + d.size.l + d.size.r;
  }).attr('height', function (d) {
    return d.height + d.size.t + d.size.b;
  }).attr('transform', function (d) {
    return strTranslate(d.translateX, d.translateY);
  });
  var tableControlView = table.selectAll('.' + c.cn.tableControlView).data(gup.repeat, gup.keyFun);
  var cvEnter = tableControlView.enter().append('g').classed(c.cn.tableControlView, true).style('box-sizing', 'content-box');
  if (dynamic) {
    var wheelEvent = 'onwheel' in document ? 'wheel' : 'mousewheel';
    cvEnter.on('mousemove', function (d) {
      tableControlView.filter(function (dd) {
        return d === dd;
      }).call(renderScrollbarKit, gd);
    }).on(wheelEvent, function (d) {
      if (d.scrollbarState.wheeling) return;
      d.scrollbarState.wheeling = true;
      var newY = d.scrollY + d3.event.deltaY;
      var noChange = makeDragRow(gd, tableControlView, null, newY)(d);
      if (!noChange) {
        d3.event.stopPropagation();
        d3.event.preventDefault();
      }
      d.scrollbarState.wheeling = false;
    }).call(renderScrollbarKit, gd, true);
  }
  tableControlView.attr('transform', function (d) {
    return strTranslate(d.size.l, d.size.t);
  });

  // scrollBackground merely ensures that mouse events are captured even on crazy fast scrollwheeling
  // otherwise rendering glitches may occur
  var scrollBackground = tableControlView.selectAll('.' + c.cn.scrollBackground).data(gup.repeat, gup.keyFun);
  scrollBackground.enter().append('rect').classed(c.cn.scrollBackground, true).attr('fill', 'none');
  scrollBackground.attr('width', function (d) {
    return d.width;
  }).attr('height', function (d) {
    return d.height;
  });
  tableControlView.each(function (d) {
    Drawing.setClipUrl(d3.select(this), scrollAreaBottomClipKey(gd, d), gd);
  });
  var yColumn = tableControlView.selectAll('.' + c.cn.yColumn).data(function (vm) {
    return vm.columns;
  }, gup.keyFun);
  yColumn.enter().append('g').classed(c.cn.yColumn, true);
  yColumn.exit().remove();
  yColumn.attr('transform', function (d) {
    return strTranslate(d.x, 0);
  });
  if (dynamic) {
    yColumn.call(d3.behavior.drag().origin(function (d) {
      var movedColumn = d3.select(this);
      easeColumn(movedColumn, d, -c.uplift);
      raiseToTop(this);
      d.calcdata.columnDragInProgress = true;
      renderScrollbarKit(tableControlView.filter(function (dd) {
        return d.calcdata.key === dd.key;
      }), gd);
      return d;
    }).on('drag', function (d) {
      var movedColumn = d3.select(this);
      var getter = function (dd) {
        return (d === dd ? d3.event.x : dd.x) + dd.columnWidth / 2;
      };
      d.x = Math.max(-c.overdrag, Math.min(d.calcdata.width + c.overdrag - d.columnWidth, d3.event.x));
      var sortableColumns = flatData(yColumn).filter(function (dd) {
        return dd.calcdata.key === d.calcdata.key;
      });
      var newOrder = sortableColumns.sort(function (a, b) {
        return getter(a) - getter(b);
      });
      newOrder.forEach(function (dd, i) {
        dd.xIndex = i;
        dd.x = d === dd ? dd.x : dd.xScale(dd);
      });
      yColumn.filter(function (dd) {
        return d !== dd;
      }).transition().ease(c.transitionEase).duration(c.transitionDuration).attr('transform', function (d) {
        return strTranslate(d.x, 0);
      });
      movedColumn.call(cancelEeaseColumn).attr('transform', strTranslate(d.x, -c.uplift));
    }).on('dragend', function (d) {
      var movedColumn = d3.select(this);
      var p = d.calcdata;
      d.x = d.xScale(d);
      d.calcdata.columnDragInProgress = false;
      easeColumn(movedColumn, d, 0);
      columnMoved(gd, p, p.columns.map(function (dd) {
        return dd.xIndex;
      }));
    }));
  }
  yColumn.each(function (d) {
    Drawing.setClipUrl(d3.select(this), columnBoundaryClipKey(gd, d), gd);
  });
  var columnBlock = yColumn.selectAll('.' + c.cn.columnBlock).data(splitData.splitToPanels, gup.keyFun);
  columnBlock.enter().append('g').classed(c.cn.columnBlock, true).attr('id', function (d) {
    return d.key;
  });
  columnBlock.style('cursor', function (d) {
    return d.dragHandle ? 'ew-resize' : d.calcdata.scrollbarState.barWiggleRoom ? 'ns-resize' : 'default';
  });
  var headerColumnBlock = columnBlock.filter(headerBlock);
  var cellsColumnBlock = columnBlock.filter(cellsBlock);
  if (dynamic) {
    cellsColumnBlock.call(d3.behavior.drag().origin(function (d) {
      d3.event.stopPropagation();
      return d;
    }).on('drag', makeDragRow(gd, tableControlView, -1)).on('dragend', function () {
      // fixme emit plotly notification
    }));
  }

  // initial rendering: header is rendered first, as it may may have async LaTeX (show header first)
  // but blocks are _entered_ the way they are due to painter's algo (header on top)
  renderColumnCellTree(gd, tableControlView, headerColumnBlock, columnBlock);
  renderColumnCellTree(gd, tableControlView, cellsColumnBlock, columnBlock);
  var scrollAreaClip = tableControlView.selectAll('.' + c.cn.scrollAreaClip).data(gup.repeat, gup.keyFun);
  scrollAreaClip.enter().append('clipPath').classed(c.cn.scrollAreaClip, true).attr('id', function (d) {
    return scrollAreaBottomClipKey(gd, d);
  });
  var scrollAreaClipRect = scrollAreaClip.selectAll('.' + c.cn.scrollAreaClipRect).data(gup.repeat, gup.keyFun);
  scrollAreaClipRect.enter().append('rect').classed(c.cn.scrollAreaClipRect, true).attr('x', -c.overdrag).attr('y', -c.uplift).attr('fill', 'none');
  scrollAreaClipRect.attr('width', function (d) {
    return d.width + 2 * c.overdrag;
  }).attr('height', function (d) {
    return d.height + c.uplift;
  });
  var columnBoundary = yColumn.selectAll('.' + c.cn.columnBoundary).data(gup.repeat, gup.keyFun);
  columnBoundary.enter().append('g').classed(c.cn.columnBoundary, true);
  var columnBoundaryClippath = yColumn.selectAll('.' + c.cn.columnBoundaryClippath).data(gup.repeat, gup.keyFun);

  // SVG spec doesn't mandate wrapping into a <defs> and doesn't seem to cause a speed difference
  columnBoundaryClippath.enter().append('clipPath').classed(c.cn.columnBoundaryClippath, true);
  columnBoundaryClippath.attr('id', function (d) {
    return columnBoundaryClipKey(gd, d);
  });
  var columnBoundaryRect = columnBoundaryClippath.selectAll('.' + c.cn.columnBoundaryRect).data(gup.repeat, gup.keyFun);
  columnBoundaryRect.enter().append('rect').classed(c.cn.columnBoundaryRect, true).attr('fill', 'none');
  columnBoundaryRect.attr('width', function (d) {
    return d.columnWidth + 2 * roundHalfWidth(d);
  }).attr('height', function (d) {
    return d.calcdata.height + 2 * roundHalfWidth(d) + c.uplift;
  }).attr('x', function (d) {
    return -roundHalfWidth(d);
  }).attr('y', function (d) {
    return -roundHalfWidth(d);
  });
  updateBlockYPosition(null, cellsColumnBlock, tableControlView);
};
function roundHalfWidth(d) {
  return Math.ceil(d.calcdata.maxLineWidth / 2);
}
function scrollAreaBottomClipKey(gd, d) {
  return 'clip' + gd._fullLayout._uid + '_scrollAreaBottomClip_' + d.key;
}
function columnBoundaryClipKey(gd, d) {
  return 'clip' + gd._fullLayout._uid + '_columnBoundaryClippath_' + d.calcdata.key + '_' + d.specIndex;
}
function flatData(selection) {
  return [].concat.apply([], selection.map(function (g) {
    return g;
  })).map(function (g) {
    return g.__data__;
  });
}
function renderScrollbarKit(tableControlView, gd, bypassVisibleBar) {
  function calcTotalHeight(d) {
    var blocks = d.rowBlocks;
    return firstRowAnchor(blocks, blocks.length - 1) + (blocks.length ? rowsHeight(blocks[blocks.length - 1], Infinity) : 1);
  }
  var scrollbarKit = tableControlView.selectAll('.' + c.cn.scrollbarKit).data(gup.repeat, gup.keyFun);
  scrollbarKit.enter().append('g').classed(c.cn.scrollbarKit, true).style('shape-rendering', 'geometricPrecision');
  scrollbarKit.each(function (d) {
    var s = d.scrollbarState;
    s.totalHeight = calcTotalHeight(d);
    s.scrollableAreaHeight = d.groupHeight - headerHeight(d);
    s.currentlyVisibleHeight = Math.min(s.totalHeight, s.scrollableAreaHeight);
    s.ratio = s.currentlyVisibleHeight / s.totalHeight;
    s.barLength = Math.max(s.ratio * s.currentlyVisibleHeight, c.goldenRatio * c.scrollbarWidth);
    s.barWiggleRoom = s.currentlyVisibleHeight - s.barLength;
    s.wiggleRoom = Math.max(0, s.totalHeight - s.scrollableAreaHeight);
    s.topY = s.barWiggleRoom === 0 ? 0 : d.scrollY / s.wiggleRoom * s.barWiggleRoom;
    s.bottomY = s.topY + s.barLength;
    s.dragMultiplier = s.wiggleRoom / s.barWiggleRoom;
  }).attr('transform', function (d) {
    var xPosition = d.width + c.scrollbarWidth / 2 + c.scrollbarOffset;
    return strTranslate(xPosition, headerHeight(d));
  });
  var scrollbar = scrollbarKit.selectAll('.' + c.cn.scrollbar).data(gup.repeat, gup.keyFun);
  scrollbar.enter().append('g').classed(c.cn.scrollbar, true);
  var scrollbarSlider = scrollbar.selectAll('.' + c.cn.scrollbarSlider).data(gup.repeat, gup.keyFun);
  scrollbarSlider.enter().append('g').classed(c.cn.scrollbarSlider, true);
  scrollbarSlider.attr('transform', function (d) {
    return strTranslate(0, d.scrollbarState.topY || 0);
  });
  var scrollbarGlyph = scrollbarSlider.selectAll('.' + c.cn.scrollbarGlyph).data(gup.repeat, gup.keyFun);
  scrollbarGlyph.enter().append('line').classed(c.cn.scrollbarGlyph, true).attr('stroke', 'black').attr('stroke-width', c.scrollbarWidth).attr('stroke-linecap', 'round').attr('y1', c.scrollbarWidth / 2);
  scrollbarGlyph.attr('y2', function (d) {
    return d.scrollbarState.barLength - c.scrollbarWidth / 2;
  }).attr('stroke-opacity', function (d) {
    return d.columnDragInProgress || !d.scrollbarState.barWiggleRoom || bypassVisibleBar ? 0 : 0.4;
  });

  // cancel transition: possible pending (also, delayed) transition
  scrollbarGlyph.transition().delay(0).duration(0);
  scrollbarGlyph.transition().delay(c.scrollbarHideDelay).duration(c.scrollbarHideDuration).attr('stroke-opacity', 0);
  var scrollbarCaptureZone = scrollbar.selectAll('.' + c.cn.scrollbarCaptureZone).data(gup.repeat, gup.keyFun);
  scrollbarCaptureZone.enter().append('line').classed(c.cn.scrollbarCaptureZone, true).attr('stroke', 'white').attr('stroke-opacity', 0.01) // some browser might get rid of a 0 opacity element
  .attr('stroke-width', c.scrollbarCaptureWidth).attr('stroke-linecap', 'butt').attr('y1', 0).on('mousedown', function (d) {
    var y = d3.event.y;
    var bbox = this.getBoundingClientRect();
    var s = d.scrollbarState;
    var pixelVal = y - bbox.top;
    var inverseScale = d3.scale.linear().domain([0, s.scrollableAreaHeight]).range([0, s.totalHeight]).clamp(true);
    if (!(s.topY <= pixelVal && pixelVal <= s.bottomY)) {
      makeDragRow(gd, tableControlView, null, inverseScale(pixelVal - s.barLength / 2))(d);
    }
  }).call(d3.behavior.drag().origin(function (d) {
    d3.event.stopPropagation();
    d.scrollbarState.scrollbarScrollInProgress = true;
    return d;
  }).on('drag', makeDragRow(gd, tableControlView)).on('dragend', function () {
    // fixme emit Plotly event
  }));
  scrollbarCaptureZone.attr('y2', function (d) {
    return d.scrollbarState.scrollableAreaHeight;
  });

  // Remove scroll glyph and capture zone on static plots
  // as they don't render properly when converted to PDF
  // in the Chrome PDF viewer
  // https://github.com/plotly/streambed/issues/11618
  if (gd._context.staticPlot) {
    scrollbarGlyph.remove();
    scrollbarCaptureZone.remove();
  }
}
function renderColumnCellTree(gd, tableControlView, columnBlock, allColumnBlock) {
  // fixme this perf hotspot
  // this is performance critical code as scrolling calls it on every revolver switch
  // it appears sufficiently fast but there are plenty of low-hanging fruits for performance optimization

  var columnCells = renderColumnCells(columnBlock);
  var columnCell = renderColumnCell(columnCells);
  supplyStylingValues(columnCell);
  var cellRect = renderCellRect(columnCell);
  sizeAndStyleRect(cellRect);
  var cellTextHolder = renderCellTextHolder(columnCell);
  var cellText = renderCellText(cellTextHolder);
  setFont(cellText);
  populateCellText(cellText, tableControlView, allColumnBlock, gd);

  // doing this at the end when text, and text stlying are set
  setCellHeightAndPositionY(columnCell);
}
function renderColumnCells(columnBlock) {
  var columnCells = columnBlock.selectAll('.' + c.cn.columnCells).data(gup.repeat, gup.keyFun);
  columnCells.enter().append('g').classed(c.cn.columnCells, true);
  columnCells.exit().remove();
  return columnCells;
}
function renderColumnCell(columnCells) {
  var columnCell = columnCells.selectAll('.' + c.cn.columnCell).data(splitData.splitToCells, function (d) {
    return d.keyWithinBlock;
  });
  columnCell.enter().append('g').classed(c.cn.columnCell, true);
  columnCell.exit().remove();
  return columnCell;
}
function renderCellRect(columnCell) {
  var cellRect = columnCell.selectAll('.' + c.cn.cellRect).data(gup.repeat, function (d) {
    return d.keyWithinBlock;
  });
  cellRect.enter().append('rect').classed(c.cn.cellRect, true);
  return cellRect;
}
function renderCellText(cellTextHolder) {
  var cellText = cellTextHolder.selectAll('.' + c.cn.cellText).data(gup.repeat, function (d) {
    return d.keyWithinBlock;
  });
  cellText.enter().append('text').classed(c.cn.cellText, true).style('cursor', function () {
    return 'auto';
  }).on('mousedown', function () {
    d3.event.stopPropagation();
  });
  return cellText;
}
function renderCellTextHolder(columnCell) {
  var cellTextHolder = columnCell.selectAll('.' + c.cn.cellTextHolder).data(gup.repeat, function (d) {
    return d.keyWithinBlock;
  });
  cellTextHolder.enter().append('g').classed(c.cn.cellTextHolder, true).style('shape-rendering', 'geometricPrecision');
  return cellTextHolder;
}
function supplyStylingValues(columnCell) {
  columnCell.each(function (d, i) {
    var spec = d.calcdata.cells.font;
    var col = d.column.specIndex;
    var font = {
      size: gridPick(spec.size, col, i),
      color: gridPick(spec.color, col, i),
      family: gridPick(spec.family, col, i),
      weight: gridPick(spec.weight, col, i),
      style: gridPick(spec.style, col, i),
      variant: gridPick(spec.variant, col, i),
      textcase: gridPick(spec.textcase, col, i),
      lineposition: gridPick(spec.lineposition, col, i),
      shadow: gridPick(spec.shadow, col, i)
    };
    d.rowNumber = d.key;
    d.align = gridPick(d.calcdata.cells.align, col, i);
    d.cellBorderWidth = gridPick(d.calcdata.cells.line.width, col, i);
    d.font = font;
  });
}
function setFont(cellText) {
  cellText.each(function (d) {
    Drawing.font(d3.select(this), d.font);
  });
}
function sizeAndStyleRect(cellRect) {
  cellRect.attr('width', function (d) {
    return d.column.columnWidth;
  }).attr('stroke-width', function (d) {
    return d.cellBorderWidth;
  }).each(function (d) {
    var atomicSelection = d3.select(this);
    Color.stroke(atomicSelection, gridPick(d.calcdata.cells.line.color, d.column.specIndex, d.rowNumber));
    Color.fill(atomicSelection, gridPick(d.calcdata.cells.fill.color, d.column.specIndex, d.rowNumber));
  });
}
function populateCellText(cellText, tableControlView, allColumnBlock, gd) {
  cellText.text(function (d) {
    var col = d.column.specIndex;
    var row = d.rowNumber;
    var userSuppliedContent = d.value;
    var stringSupplied = typeof userSuppliedContent === 'string';
    var hasBreaks = stringSupplied && userSuppliedContent.match(/<br>/i);
    var userBrokenText = !stringSupplied || hasBreaks;
    d.mayHaveMarkup = stringSupplied && userSuppliedContent.match(/[<&>]/);
    var latex = isLatex(userSuppliedContent);
    d.latex = latex;
    var prefix = latex ? '' : gridPick(d.calcdata.cells.prefix, col, row) || '';
    var suffix = latex ? '' : gridPick(d.calcdata.cells.suffix, col, row) || '';
    var format = latex ? null : gridPick(d.calcdata.cells.format, col, row) || null;
    var prefixSuffixedText = prefix + (format ? numberFormat(format)(d.value) : d.value) + suffix;
    var hasWrapSplitCharacter;
    d.wrappingNeeded = !d.wrapped && !userBrokenText && !latex && (hasWrapSplitCharacter = hasWrapCharacter(prefixSuffixedText));
    d.cellHeightMayIncrease = hasBreaks || latex || d.mayHaveMarkup || (hasWrapSplitCharacter === void 0 ? hasWrapCharacter(prefixSuffixedText) : hasWrapSplitCharacter);
    d.needsConvertToTspans = d.mayHaveMarkup || d.wrappingNeeded || d.latex;
    var textToRender;
    if (d.wrappingNeeded) {
      var hrefPreservedText = c.wrapSplitCharacter === ' ' ? prefixSuffixedText.replace(/<a href=/ig, '<a_href=') : prefixSuffixedText;
      var fragments = hrefPreservedText.split(c.wrapSplitCharacter);
      var hrefRestoredFragments = c.wrapSplitCharacter === ' ' ? fragments.map(function (frag) {
        return frag.replace(/<a_href=/ig, '<a href=');
      }) : fragments;
      d.fragments = hrefRestoredFragments.map(function (f) {
        return {
          text: f,
          width: null
        };
      });
      d.fragments.push({
        fragment: c.wrapSpacer,
        width: null
      });
      textToRender = hrefRestoredFragments.join(c.lineBreaker) + c.lineBreaker + c.wrapSpacer;
    } else {
      delete d.fragments;
      textToRender = prefixSuffixedText;
    }
    return textToRender;
  }).attr('dy', function (d) {
    return d.needsConvertToTspans ? 0 : '0.75em';
  }).each(function (d) {
    var element = this;
    var selection = d3.select(element);

    // finalize what's in the DOM

    var renderCallback = d.wrappingNeeded ? wrapTextMaker : updateYPositionMaker;
    if (d.needsConvertToTspans) {
      svgUtil.convertToTspans(selection, gd, renderCallback(allColumnBlock, element, tableControlView, gd, d));
    } else {
      d3.select(element.parentNode)
      // basic cell adjustment - compliance with `cellPad`
      .attr('transform', function (d) {
        return strTranslate(xPosition(d), c.cellPad);
      }).attr('text-anchor', function (d) {
        return {
          left: 'start',
          center: 'middle',
          right: 'end'
        }[d.align];
      });
    }
  });
}
function isLatex(content) {
  return typeof content === 'string' && content.match(c.latexCheck);
}
function hasWrapCharacter(text) {
  return text.indexOf(c.wrapSplitCharacter) !== -1;
}
function columnMoved(gd, calcdata, indices) {
  var o = calcdata.gdColumnsOriginalOrder;
  calcdata.gdColumns.sort(function (a, b) {
    return indices[o.indexOf(a)] - indices[o.indexOf(b)];
  });
  calcdata.columnorder = indices;

  // TODO: there's no data here, but also this reordering is not reflected
  // in gd.data or even gd._fullData.
  // For now I will not attempt to persist this in _preGUI
  gd.emit('plotly_restyle');
}
function gridPick(spec, col, row) {
  if (Lib.isArrayOrTypedArray(spec)) {
    var column = spec[Math.min(col, spec.length - 1)];
    if (Lib.isArrayOrTypedArray(column)) {
      return column[Math.min(row, column.length - 1)];
    } else {
      return column;
    }
  } else {
    return spec;
  }
}
function easeColumn(selection, d, y) {
  selection.transition().ease(c.releaseTransitionEase).duration(c.releaseTransitionDuration).attr('transform', strTranslate(d.x, y));
}
function cellsBlock(d) {
  return d.type === 'cells';
}
function headerBlock(d) {
  return d.type === 'header';
}

/**
 * Revolver panel and cell contents layouting
 */

function headerHeight(d) {
  var headerBlocks = d.rowBlocks.length ? d.rowBlocks[0].auxiliaryBlocks : [];
  return headerBlocks.reduce(function (p, n) {
    return p + rowsHeight(n, Infinity);
  }, 0);
}
function findPagesAndCacheHeights(blocks, scrollY, scrollHeight) {
  var pages = [];
  var pTop = 0;
  for (var blockIndex = 0; blockIndex < blocks.length; blockIndex++) {
    var block = blocks[blockIndex];
    var blockRows = block.rows;
    var rowsHeight = 0;
    for (var i = 0; i < blockRows.length; i++) {
      rowsHeight += blockRows[i].rowHeight;
    }

    // caching allRowsHeight on the block - it's safe as this function is always called from within the code part
    // that handles increases to row heights
    block.allRowsHeight = rowsHeight;
    var pBottom = pTop + rowsHeight;
    var windowTop = scrollY;
    var windowBottom = windowTop + scrollHeight;
    if (windowTop < pBottom && windowBottom > pTop) {
      pages.push(blockIndex);
    }
    pTop += rowsHeight;

    // consider this nice final optimization; put it in `for` condition - caveat, currently the
    // block.allRowsHeight relies on being invalidated, so enabling this opt may not be safe
    // if(pages.length > 1) break;
  }
  return pages;
}
function updateBlockYPosition(gd, cellsColumnBlock, tableControlView) {
  var d = flatData(cellsColumnBlock)[0];
  if (d === undefined) return;
  var blocks = d.rowBlocks;
  var calcdata = d.calcdata;
  var bottom = firstRowAnchor(blocks, blocks.length);
  var scrollHeight = d.calcdata.groupHeight - headerHeight(d);
  var scrollY = calcdata.scrollY = Math.max(0, Math.min(bottom - scrollHeight, calcdata.scrollY));
  var pages = findPagesAndCacheHeights(blocks, scrollY, scrollHeight);
  if (pages.length === 1) {
    if (pages[0] === blocks.length - 1) {
      pages.unshift(pages[0] - 1);
    } else {
      pages.push(pages[0] + 1);
    }
  }

  // make phased out page jump by 2 while leaving stationary page intact
  if (pages[0] % 2) {
    pages.reverse();
  }
  cellsColumnBlock.each(function (d, i) {
    // these values will also be needed when a block is translated again due to growing cell height
    d.page = pages[i];
    d.scrollY = scrollY;
  });
  cellsColumnBlock.attr('transform', function (d) {
    var yTranslate = firstRowAnchor(d.rowBlocks, d.page) - d.scrollY;
    return strTranslate(0, yTranslate);
  });

  // conditionally rerendering panel 0 and 1
  if (gd) {
    conditionalPanelRerender(gd, tableControlView, cellsColumnBlock, pages, d.prevPages, d, 0);
    conditionalPanelRerender(gd, tableControlView, cellsColumnBlock, pages, d.prevPages, d, 1);
    renderScrollbarKit(tableControlView, gd);
  }
}
function makeDragRow(gd, allTableControlView, optionalMultiplier, optionalPosition) {
  return function dragRow(eventD) {
    // may come from whichever DOM event target: drag, wheel, bar... eventD corresponds to event target
    var d = eventD.calcdata ? eventD.calcdata : eventD;
    var tableControlView = allTableControlView.filter(function (dd) {
      return d.key === dd.key;
    });
    var multiplier = optionalMultiplier || d.scrollbarState.dragMultiplier;
    var initialScrollY = d.scrollY;
    d.scrollY = optionalPosition === void 0 ? d.scrollY + multiplier * d3.event.dy : optionalPosition;
    var cellsColumnBlock = tableControlView.selectAll('.' + c.cn.yColumn).selectAll('.' + c.cn.columnBlock).filter(cellsBlock);
    updateBlockYPosition(gd, cellsColumnBlock, tableControlView);

    // return false if we've "used" the scroll, ie it did something,
    // so the event shouldn't bubble (if appropriate)
    return d.scrollY === initialScrollY;
  };
}
function conditionalPanelRerender(gd, tableControlView, cellsColumnBlock, pages, prevPages, d, revolverIndex) {
  var shouldComponentUpdate = pages[revolverIndex] !== prevPages[revolverIndex];
  if (shouldComponentUpdate) {
    clearTimeout(d.currentRepaint[revolverIndex]);
    d.currentRepaint[revolverIndex] = setTimeout(function () {
      // setTimeout might lag rendering but yields a smoother scroll, because fast scrolling makes
      // some repaints invisible ie. wasteful (DOM work blocks the main thread)
      var toRerender = cellsColumnBlock.filter(function (d, i) {
        return i === revolverIndex && pages[i] !== prevPages[i];
      });
      renderColumnCellTree(gd, tableControlView, toRerender, cellsColumnBlock);
      prevPages[revolverIndex] = pages[revolverIndex];
    });
  }
}
function wrapTextMaker(columnBlock, element, tableControlView, gd) {
  return function wrapText() {
    var cellTextHolder = d3.select(element.parentNode);
    cellTextHolder.each(function (d) {
      var fragments = d.fragments;
      cellTextHolder.selectAll('tspan.line').each(function (dd, i) {
        fragments[i].width = this.getComputedTextLength();
      });
      // last element is only for measuring the separator character, so it's ignored:
      var separatorLength = fragments[fragments.length - 1].width;
      var rest = fragments.slice(0, -1);
      var currentRow = [];
      var currentAddition, currentAdditionLength;
      var currentRowLength = 0;
      var rowLengthLimit = d.column.columnWidth - 2 * c.cellPad;
      d.value = '';
      while (rest.length) {
        currentAddition = rest.shift();
        currentAdditionLength = currentAddition.width + separatorLength;
        if (currentRowLength + currentAdditionLength > rowLengthLimit) {
          d.value += currentRow.join(c.wrapSpacer) + c.lineBreaker;
          currentRow = [];
          currentRowLength = 0;
        }
        currentRow.push(currentAddition.text);
        currentRowLength += currentAdditionLength;
      }
      if (currentRowLength) {
        d.value += currentRow.join(c.wrapSpacer);
      }
      d.wrapped = true;
    });

    // the pre-wrapped text was rendered only for the text measurements
    cellTextHolder.selectAll('tspan.line').remove();

    // resupply text, now wrapped
    populateCellText(cellTextHolder.select('.' + c.cn.cellText), tableControlView, columnBlock, gd);
    d3.select(element.parentNode.parentNode).call(setCellHeightAndPositionY);
  };
}
function updateYPositionMaker(columnBlock, element, tableControlView, gd, d) {
  return function updateYPosition() {
    if (d.settledY) return;
    var cellTextHolder = d3.select(element.parentNode);
    var l = getBlock(d);
    var rowIndex = d.key - l.firstRowIndex;
    var declaredRowHeight = l.rows[rowIndex].rowHeight;
    var requiredHeight = d.cellHeightMayIncrease ? element.parentNode.getBoundingClientRect().height + 2 * c.cellPad : declaredRowHeight;
    var finalHeight = Math.max(requiredHeight, declaredRowHeight);
    var increase = finalHeight - l.rows[rowIndex].rowHeight;
    if (increase) {
      // current row height increased
      l.rows[rowIndex].rowHeight = finalHeight;
      columnBlock.selectAll('.' + c.cn.columnCell).call(setCellHeightAndPositionY);
      updateBlockYPosition(null, columnBlock.filter(cellsBlock), 0);

      // if d.column.type === 'header', then the scrollbar has to be pushed downward to the scrollable area
      // if d.column.type === 'cells', it can still be relevant if total scrolling content height is less than the
      //                               scrollable window, as increases to row heights may need scrollbar updates
      renderScrollbarKit(tableControlView, gd, true);
    }
    cellTextHolder.attr('transform', function () {
      // this code block is only invoked for items where d.cellHeightMayIncrease is truthy
      var element = this;
      var columnCellElement = element.parentNode;
      var box = columnCellElement.getBoundingClientRect();
      var rectBox = d3.select(element.parentNode).select('.' + c.cn.cellRect).node().getBoundingClientRect();
      var currentTransform = element.transform.baseVal.consolidate();
      var yPosition = rectBox.top - box.top + (currentTransform ? currentTransform.matrix.f : c.cellPad);
      return strTranslate(xPosition(d, d3.select(element.parentNode).select('.' + c.cn.cellTextHolder).node().getBoundingClientRect().width), yPosition);
    });
    d.settledY = true;
  };
}
function xPosition(d, optionalWidth) {
  switch (d.align) {
    case 'left':
      return c.cellPad;
    case 'right':
      return d.column.columnWidth - (optionalWidth || 0) - c.cellPad;
    case 'center':
      return (d.column.columnWidth - (optionalWidth || 0)) / 2;
    default:
      return c.cellPad;
  }
}
function setCellHeightAndPositionY(columnCell) {
  columnCell.attr('transform', function (d) {
    var headerHeight = d.rowBlocks[0].auxiliaryBlocks.reduce(function (p, n) {
      return p + rowsHeight(n, Infinity);
    }, 0);
    var l = getBlock(d);
    var rowAnchor = rowsHeight(l, d.key);
    var yOffset = rowAnchor + headerHeight;
    return strTranslate(0, yOffset);
  }).selectAll('.' + c.cn.cellRect).attr('height', function (d) {
    return getRow(getBlock(d), d.key).rowHeight;
  });
}
function firstRowAnchor(blocks, page) {
  var total = 0;
  for (var i = page - 1; i >= 0; i--) {
    total += allRowsHeight(blocks[i]);
  }
  return total;
}
function rowsHeight(rowBlock, key) {
  var total = 0;
  for (var i = 0; i < rowBlock.rows.length && rowBlock.rows[i].rowIndex < key; i++) {
    total += rowBlock.rows[i].rowHeight;
  }
  return total;
}
function allRowsHeight(rowBlock) {
  var cached = rowBlock.allRowsHeight;
  if (cached !== void 0) {
    return cached;
  }
  var total = 0;
  for (var i = 0; i < rowBlock.rows.length; i++) {
    total += rowBlock.rows[i].rowHeight;
  }
  rowBlock.allRowsHeight = total;
  return total;
}
function getBlock(d) {
  return d.rowBlocks[d.page];
}
function getRow(l, i) {
  return l.rows[i - l.firstRowIndex];
}

/***/ }),

/***/ 71856:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var hovertemplateAttrs = (__webpack_require__(3208)/* .hovertemplateAttrs */ .rb);
var texttemplateAttrs = (__webpack_require__(3208)/* .texttemplateAttrs */ .ay);
var colorScaleAttrs = __webpack_require__(87163);
var domainAttrs = (__webpack_require__(13792)/* .attributes */ .u);
var pieAttrs = __webpack_require__(55412);
var sunburstAttrs = __webpack_require__(56708);
var constants = __webpack_require__(43236);
var extendFlat = (__webpack_require__(93049).extendFlat);
var pattern = (__webpack_require__(94850)/* .pattern */ .k);
module.exports = {
  labels: sunburstAttrs.labels,
  parents: sunburstAttrs.parents,
  values: sunburstAttrs.values,
  branchvalues: sunburstAttrs.branchvalues,
  count: sunburstAttrs.count,
  level: sunburstAttrs.level,
  maxdepth: sunburstAttrs.maxdepth,
  tiling: {
    packing: {
      valType: 'enumerated',
      values: ['squarify', 'binary', 'dice', 'slice', 'slice-dice', 'dice-slice'],
      dflt: 'squarify',
      editType: 'plot'
    },
    squarifyratio: {
      valType: 'number',
      min: 1,
      dflt: 1,
      editType: 'plot'
    },
    flip: {
      valType: 'flaglist',
      flags: ['x', 'y'],
      dflt: '',
      editType: 'plot'
    },
    pad: {
      valType: 'number',
      min: 0,
      dflt: 3,
      editType: 'plot'
    },
    editType: 'calc'
  },
  marker: extendFlat({
    pad: {
      t: {
        valType: 'number',
        min: 0,
        editType: 'plot'
      },
      l: {
        valType: 'number',
        min: 0,
        editType: 'plot'
      },
      r: {
        valType: 'number',
        min: 0,
        editType: 'plot'
      },
      b: {
        valType: 'number',
        min: 0,
        editType: 'plot'
      },
      editType: 'calc'
    },
    colors: sunburstAttrs.marker.colors,
    pattern: pattern,
    depthfade: {
      valType: 'enumerated',
      values: [true, false, 'reversed'],
      editType: 'style'
    },
    line: sunburstAttrs.marker.line,
    cornerradius: {
      valType: 'number',
      min: 0,
      dflt: 0,
      editType: 'plot'
    },
    editType: 'calc'
  }, colorScaleAttrs('marker', {
    colorAttr: 'colors',
    anim: false // TODO: set to anim: true?
  })),
  pathbar: {
    visible: {
      valType: 'boolean',
      dflt: true,
      editType: 'plot'
    },
    side: {
      valType: 'enumerated',
      values: ['top', 'bottom'],
      dflt: 'top',
      editType: 'plot'
    },
    edgeshape: {
      valType: 'enumerated',
      values: ['>', '<', '|', '/', '\\'],
      dflt: '>',
      editType: 'plot'
    },
    thickness: {
      valType: 'number',
      min: 12,
      editType: 'plot'
    },
    textfont: extendFlat({}, pieAttrs.textfont, {}),
    editType: 'calc'
  },
  text: pieAttrs.text,
  textinfo: sunburstAttrs.textinfo,
  // TODO: incorporate `label` and `value` in the eventData
  texttemplate: texttemplateAttrs({
    editType: 'plot'
  }, {
    keys: constants.eventDataKeys.concat(['label', 'value'])
  }),
  hovertext: pieAttrs.hovertext,
  hoverinfo: sunburstAttrs.hoverinfo,
  hovertemplate: hovertemplateAttrs({}, {
    keys: constants.eventDataKeys
  }),
  textfont: pieAttrs.textfont,
  insidetextfont: pieAttrs.insidetextfont,
  outsidetextfont: extendFlat({}, pieAttrs.outsidetextfont, {}),
  textposition: {
    valType: 'enumerated',
    values: ['top left', 'top center', 'top right', 'middle left', 'middle center', 'middle right', 'bottom left', 'bottom center', 'bottom right'],
    dflt: 'top left',
    editType: 'plot'
  },
  sort: pieAttrs.sort,
  root: sunburstAttrs.root,
  domain: domainAttrs({
    name: 'treemap',
    trace: true,
    editType: 'calc'
  })
};

/***/ }),

/***/ 69784:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var plots = __webpack_require__(44122);
exports.name = 'treemap';
exports.plot = function (gd, traces, transitionOpts, makeOnCompleteCallback) {
  plots.plotBasePlot(exports.name, gd, traces, transitionOpts, makeOnCompleteCallback);
};
exports.clean = function (newFullData, newFullLayout, oldFullData, oldFullLayout) {
  plots.cleanBasePlot(exports.name, newFullData, newFullLayout, oldFullData, oldFullLayout);
};

/***/ }),

/***/ 38848:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var calc = __webpack_require__(14852);
exports._ = function (gd, trace) {
  return calc.calc(gd, trace);
};
exports.t = function (gd) {
  return calc._runCrossTraceCalc('treemap', gd);
};

/***/ }),

/***/ 43236:
/***/ (function(module) {

"use strict";


module.exports = {
  CLICK_TRANSITION_TIME: 750,
  CLICK_TRANSITION_EASING: 'poly',
  eventDataKeys: [
  // string
  'currentPath', 'root', 'entry',
  // no need to add 'parent' here

  // percentages i.e. ratios
  'percentRoot', 'percentEntry', 'percentParent'],
  gapWithPathbar: 1 // i.e. one pixel
};

/***/ }),

/***/ 95719:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var attributes = __webpack_require__(71856);
var Color = __webpack_require__(78766);
var handleDomainDefaults = (__webpack_require__(13792)/* .defaults */ .N);
var handleText = (__webpack_require__(17550).handleText);
var TEXTPAD = (__webpack_require__(56155).TEXTPAD);
var handleMarkerDefaults = (__webpack_require__(46979).handleMarkerDefaults);
var Colorscale = __webpack_require__(88856);
var hasColorscale = Colorscale.hasColorscale;
var colorscaleDefaults = Colorscale.handleDefaults;
module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
  function coerce(attr, dflt) {
    return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
  }
  var labels = coerce('labels');
  var parents = coerce('parents');
  if (!labels || !labels.length || !parents || !parents.length) {
    traceOut.visible = false;
    return;
  }
  var vals = coerce('values');
  if (vals && vals.length) {
    coerce('branchvalues');
  } else {
    coerce('count');
  }
  coerce('level');
  coerce('maxdepth');
  var packing = coerce('tiling.packing');
  if (packing === 'squarify') {
    coerce('tiling.squarifyratio');
  }
  coerce('tiling.flip');
  coerce('tiling.pad');
  var text = coerce('text');
  coerce('texttemplate');
  if (!traceOut.texttemplate) coerce('textinfo', Lib.isArrayOrTypedArray(text) ? 'text+label' : 'label');
  coerce('hovertext');
  coerce('hovertemplate');
  var hasPathbar = coerce('pathbar.visible');
  var textposition = 'auto';
  handleText(traceIn, traceOut, layout, coerce, textposition, {
    hasPathbar: hasPathbar,
    moduleHasSelected: false,
    moduleHasUnselected: false,
    moduleHasConstrain: false,
    moduleHasCliponaxis: false,
    moduleHasTextangle: false,
    moduleHasInsideanchor: false
  });
  coerce('textposition');
  var bottomText = traceOut.textposition.indexOf('bottom') !== -1;
  handleMarkerDefaults(traceIn, traceOut, layout, coerce);
  var withColorscale = traceOut._hasColorscale = hasColorscale(traceIn, 'marker', 'colors') || (traceIn.marker || {}).coloraxis // N.B. special logic to consider "values" colorscales
  ;
  if (withColorscale) {
    colorscaleDefaults(traceIn, traceOut, layout, coerce, {
      prefix: 'marker.',
      cLetter: 'c'
    });
  } else {
    coerce('marker.depthfade', !(traceOut.marker.colors || []).length);
  }
  var headerSize = traceOut.textfont.size * 2;
  coerce('marker.pad.t', bottomText ? headerSize / 4 : headerSize);
  coerce('marker.pad.l', headerSize / 4);
  coerce('marker.pad.r', headerSize / 4);
  coerce('marker.pad.b', bottomText ? headerSize : headerSize / 4);
  coerce('marker.cornerradius');
  traceOut._hovered = {
    marker: {
      line: {
        width: 2,
        color: Color.contrast(layout.paper_bgcolor)
      }
    }
  };
  if (hasPathbar) {
    // This works even for multi-line labels as treemap pathbar trim out line breaks
    coerce('pathbar.thickness', traceOut.pathbar.textfont.size + 2 * TEXTPAD);
    coerce('pathbar.side');
    coerce('pathbar.edgeshape');
  }
  coerce('sort');
  coerce('root.color');
  handleDomainDefaults(traceOut, layout, coerce);

  // do not support transforms for now
  traceOut._length = null;
};

/***/ }),

/***/ 41567:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var helpers = __webpack_require__(33108);
var uniformText = __webpack_require__(84102);
var clearMinTextSize = uniformText.clearMinTextSize;
var resizeText = (__webpack_require__(6851).resizeText);
var plotOne = __webpack_require__(95709);
module.exports = function _plot(gd, cdmodule, transitionOpts, makeOnCompleteCallback, opts) {
  var type = opts.type;
  var drawDescendants = opts.drawDescendants;
  var fullLayout = gd._fullLayout;
  var layer = fullLayout['_' + type + 'layer'];
  var join, onComplete;

  // If transition config is provided, then it is only a partial replot and traces not
  // updated are removed.
  var isFullReplot = !transitionOpts;
  clearMinTextSize(type, fullLayout);
  join = layer.selectAll('g.trace.' + type).data(cdmodule, function (cd) {
    return cd[0].trace.uid;
  });
  join.enter().append('g').classed('trace', true).classed(type, true);
  join.order();
  if (!fullLayout.uniformtext.mode && helpers.hasTransition(transitionOpts)) {
    if (makeOnCompleteCallback) {
      // If it was passed a callback to register completion, make a callback. If
      // this is created, then it must be executed on completion, otherwise the
      // pos-transition redraw will not execute:
      onComplete = makeOnCompleteCallback();
    }
    var transition = d3.transition().duration(transitionOpts.duration).ease(transitionOpts.easing).each('end', function () {
      onComplete && onComplete();
    }).each('interrupt', function () {
      onComplete && onComplete();
    });
    transition.each(function () {
      // Must run the selection again since otherwise enters/updates get grouped together
      // and these get executed out of order. Except we need them in order!
      layer.selectAll('g.trace').each(function (cd) {
        plotOne(gd, cd, this, transitionOpts, drawDescendants);
      });
    });
  } else {
    join.each(function (cd) {
      plotOne(gd, cd, this, transitionOpts, drawDescendants);
    });
    if (fullLayout.uniformtext.mode) {
      resizeText(gd, layer.selectAll('.trace'), type);
    }
  }
  if (isFullReplot) {
    join.exit().remove();
  }
};

/***/ }),

/***/ 17010:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var Lib = __webpack_require__(34809);
var Drawing = __webpack_require__(62203);
var svgTextUtils = __webpack_require__(30635);
var partition = __webpack_require__(11995);
var styleOne = (__webpack_require__(92080).styleOne);
var constants = __webpack_require__(43236);
var helpers = __webpack_require__(33108);
var attachFxHandlers = __webpack_require__(44691);
var onPathbar = true; // for Ancestors

module.exports = function drawAncestors(gd, cd, entry, slices, opts) {
  var barDifY = opts.barDifY;
  var width = opts.width;
  var height = opts.height;
  var viewX = opts.viewX;
  var viewY = opts.viewY;
  var pathSlice = opts.pathSlice;
  var toMoveInsideSlice = opts.toMoveInsideSlice;
  var strTransform = opts.strTransform;
  var hasTransition = opts.hasTransition;
  var handleSlicesExit = opts.handleSlicesExit;
  var makeUpdateSliceInterpolator = opts.makeUpdateSliceInterpolator;
  var makeUpdateTextInterpolator = opts.makeUpdateTextInterpolator;
  var refRect = {};
  var isStatic = gd._context.staticPlot;
  var fullLayout = gd._fullLayout;
  var cd0 = cd[0];
  var trace = cd0.trace;
  var hierarchy = cd0.hierarchy;
  var eachWidth = width / trace._entryDepth;
  var pathIds = helpers.listPath(entry.data, 'id');
  var sliceData = partition(hierarchy.copy(), [width, height], {
    packing: 'dice',
    pad: {
      inner: 0,
      top: 0,
      left: 0,
      right: 0,
      bottom: 0
    }
  }).descendants();

  // edit slices that show up on graph
  sliceData = sliceData.filter(function (pt) {
    var level = pathIds.indexOf(pt.data.id);
    if (level === -1) return false;
    pt.x0 = eachWidth * level;
    pt.x1 = eachWidth * (level + 1);
    pt.y0 = barDifY;
    pt.y1 = barDifY + height;
    pt.onPathbar = true;
    return true;
  });
  sliceData.reverse();
  slices = slices.data(sliceData, helpers.getPtId);
  slices.enter().append('g').classed('pathbar', true);
  handleSlicesExit(slices, onPathbar, refRect, [width, height], pathSlice);
  slices.order();
  var updateSlices = slices;
  if (hasTransition) {
    updateSlices = updateSlices.transition().each('end', function () {
      // N.B. gd._transitioning is (still) *true* by the time
      // transition updates get here
      var sliceTop = d3.select(this);
      helpers.setSliceCursor(sliceTop, gd, {
        hideOnRoot: false,
        hideOnLeaves: false,
        isTransitioning: false
      });
    });
  }
  updateSlices.each(function (pt) {
    // for bbox
    pt._x0 = viewX(pt.x0);
    pt._x1 = viewX(pt.x1);
    pt._y0 = viewY(pt.y0);
    pt._y1 = viewY(pt.y1);
    pt._hoverX = viewX(pt.x1 - Math.min(width, height) / 2);
    pt._hoverY = viewY(pt.y1 - height / 2);
    var sliceTop = d3.select(this);
    var slicePath = Lib.ensureSingle(sliceTop, 'path', 'surface', function (s) {
      s.style('pointer-events', isStatic ? 'none' : 'all');
    });
    if (hasTransition) {
      slicePath.transition().attrTween('d', function (pt2) {
        var interp = makeUpdateSliceInterpolator(pt2, onPathbar, refRect, [width, height]);
        return function (t) {
          return pathSlice(interp(t));
        };
      });
    } else {
      slicePath.attr('d', pathSlice);
    }
    sliceTop.call(attachFxHandlers, entry, gd, cd, {
      styleOne: styleOne,
      eventDataKeys: constants.eventDataKeys,
      transitionTime: constants.CLICK_TRANSITION_TIME,
      transitionEasing: constants.CLICK_TRANSITION_EASING
    }).call(helpers.setSliceCursor, gd, {
      hideOnRoot: false,
      hideOnLeaves: false,
      isTransitioning: gd._transitioning
    });
    slicePath.call(styleOne, pt, trace, gd, {
      hovered: false
    });
    pt._text = (helpers.getPtLabel(pt) || '').split('<br>').join(' ') || '';
    var sliceTextGroup = Lib.ensureSingle(sliceTop, 'g', 'slicetext');
    var sliceText = Lib.ensureSingle(sliceTextGroup, 'text', '', function (s) {
      // prohibit tex interpretation until we can handle
      // tex and regular text together
      s.attr('data-notex', 1);
    });
    var font = Lib.ensureUniformFontSize(gd, helpers.determineTextFont(trace, pt, fullLayout.font, {
      onPathbar: true
    }));
    sliceText.text(pt._text || ' ') // use one space character instead of a blank string to avoid jumps during transition
    .classed('slicetext', true).attr('text-anchor', 'start').call(Drawing.font, font).call(svgTextUtils.convertToTspans, gd);
    pt.textBB = Drawing.bBox(sliceText.node());
    pt.transform = toMoveInsideSlice(pt, {
      fontSize: font.size,
      onPathbar: true
    });
    pt.transform.fontSize = font.size;
    if (hasTransition) {
      sliceText.transition().attrTween('transform', function (pt2) {
        var interp = makeUpdateTextInterpolator(pt2, onPathbar, refRect, [width, height]);
        return function (t) {
          return strTransform(interp(t));
        };
      });
    } else {
      sliceText.attr('transform', strTransform(pt));
    }
  });
};

/***/ }),

/***/ 50916:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var Lib = __webpack_require__(34809);
var Drawing = __webpack_require__(62203);
var svgTextUtils = __webpack_require__(30635);
var partition = __webpack_require__(11995);
var styleOne = (__webpack_require__(92080).styleOne);
var constants = __webpack_require__(43236);
var helpers = __webpack_require__(33108);
var attachFxHandlers = __webpack_require__(44691);
var formatSliceLabel = (__webpack_require__(19718).formatSliceLabel);
var onPathbar = false; // for Descendants

module.exports = function drawDescendants(gd, cd, entry, slices, opts) {
  var width = opts.width;
  var height = opts.height;
  var viewX = opts.viewX;
  var viewY = opts.viewY;
  var pathSlice = opts.pathSlice;
  var toMoveInsideSlice = opts.toMoveInsideSlice;
  var strTransform = opts.strTransform;
  var hasTransition = opts.hasTransition;
  var handleSlicesExit = opts.handleSlicesExit;
  var makeUpdateSliceInterpolator = opts.makeUpdateSliceInterpolator;
  var makeUpdateTextInterpolator = opts.makeUpdateTextInterpolator;
  var prevEntry = opts.prevEntry;
  var refRect = {};
  var isStatic = gd._context.staticPlot;
  var fullLayout = gd._fullLayout;
  var cd0 = cd[0];
  var trace = cd0.trace;
  var hasLeft = trace.textposition.indexOf('left') !== -1;
  var hasRight = trace.textposition.indexOf('right') !== -1;
  var hasBottom = trace.textposition.indexOf('bottom') !== -1;
  var noRoomForHeader = !hasBottom && !trace.marker.pad.t || hasBottom && !trace.marker.pad.b;

  // N.B. slice data isn't the calcdata,
  // grab corresponding calcdata item in sliceData[i].data.data
  var allData = partition(entry, [width, height], {
    packing: trace.tiling.packing,
    squarifyratio: trace.tiling.squarifyratio,
    flipX: trace.tiling.flip.indexOf('x') > -1,
    flipY: trace.tiling.flip.indexOf('y') > -1,
    pad: {
      inner: trace.tiling.pad,
      top: trace.marker.pad.t,
      left: trace.marker.pad.l,
      right: trace.marker.pad.r,
      bottom: trace.marker.pad.b
    }
  });
  var sliceData = allData.descendants();
  var minVisibleDepth = Infinity;
  var maxVisibleDepth = -Infinity;
  sliceData.forEach(function (pt) {
    var depth = pt.depth;
    if (depth >= trace._maxDepth) {
      // hide slices that won't show up on graph
      pt.x0 = pt.x1 = (pt.x0 + pt.x1) / 2;
      pt.y0 = pt.y1 = (pt.y0 + pt.y1) / 2;
    } else {
      minVisibleDepth = Math.min(minVisibleDepth, depth);
      maxVisibleDepth = Math.max(maxVisibleDepth, depth);
    }
  });
  slices = slices.data(sliceData, helpers.getPtId);
  trace._maxVisibleLayers = isFinite(maxVisibleDepth) ? maxVisibleDepth - minVisibleDepth + 1 : 0;
  slices.enter().append('g').classed('slice', true);
  handleSlicesExit(slices, onPathbar, refRect, [width, height], pathSlice);
  slices.order();

  // next coords of previous entry
  var nextOfPrevEntry = null;
  if (hasTransition && prevEntry) {
    var prevEntryId = helpers.getPtId(prevEntry);
    slices.each(function (pt) {
      if (nextOfPrevEntry === null && helpers.getPtId(pt) === prevEntryId) {
        nextOfPrevEntry = {
          x0: pt.x0,
          x1: pt.x1,
          y0: pt.y0,
          y1: pt.y1
        };
      }
    });
  }
  var getRefRect = function () {
    return nextOfPrevEntry || {
      x0: 0,
      x1: width,
      y0: 0,
      y1: height
    };
  };
  var updateSlices = slices;
  if (hasTransition) {
    updateSlices = updateSlices.transition().each('end', function () {
      // N.B. gd._transitioning is (still) *true* by the time
      // transition updates get here
      var sliceTop = d3.select(this);
      helpers.setSliceCursor(sliceTop, gd, {
        hideOnRoot: true,
        hideOnLeaves: false,
        isTransitioning: false
      });
    });
  }
  updateSlices.each(function (pt) {
    var isHeader = helpers.isHeader(pt, trace);

    // for bbox
    pt._x0 = viewX(pt.x0);
    pt._x1 = viewX(pt.x1);
    pt._y0 = viewY(pt.y0);
    pt._y1 = viewY(pt.y1);
    pt._hoverX = viewX(pt.x1 - trace.marker.pad.r), pt._hoverY = hasBottom ? viewY(pt.y1 - trace.marker.pad.b / 2) : viewY(pt.y0 + trace.marker.pad.t / 2);
    var sliceTop = d3.select(this);
    var slicePath = Lib.ensureSingle(sliceTop, 'path', 'surface', function (s) {
      s.style('pointer-events', isStatic ? 'none' : 'all');
    });
    if (hasTransition) {
      slicePath.transition().attrTween('d', function (pt2) {
        var interp = makeUpdateSliceInterpolator(pt2, onPathbar, getRefRect(), [width, height]);
        return function (t) {
          return pathSlice(interp(t));
        };
      });
    } else {
      slicePath.attr('d', pathSlice);
    }
    sliceTop.call(attachFxHandlers, entry, gd, cd, {
      styleOne: styleOne,
      eventDataKeys: constants.eventDataKeys,
      transitionTime: constants.CLICK_TRANSITION_TIME,
      transitionEasing: constants.CLICK_TRANSITION_EASING
    }).call(helpers.setSliceCursor, gd, {
      isTransitioning: gd._transitioning
    });
    slicePath.call(styleOne, pt, trace, gd, {
      hovered: false
    });
    if (pt.x0 === pt.x1 || pt.y0 === pt.y1) {
      pt._text = '';
    } else {
      if (isHeader) {
        pt._text = noRoomForHeader ? '' : helpers.getPtLabel(pt) || '';
      } else {
        pt._text = formatSliceLabel(pt, entry, trace, cd, fullLayout) || '';
      }
    }
    var sliceTextGroup = Lib.ensureSingle(sliceTop, 'g', 'slicetext');
    var sliceText = Lib.ensureSingle(sliceTextGroup, 'text', '', function (s) {
      // prohibit tex interpretation until we can handle
      // tex and regular text together
      s.attr('data-notex', 1);
    });
    var font = Lib.ensureUniformFontSize(gd, helpers.determineTextFont(trace, pt, fullLayout.font));
    var text = pt._text || ' '; // use one space character instead of a blank string to avoid jumps during transition
    var singleLineHeader = isHeader && text.indexOf('<br>') === -1;
    sliceText.text(text).classed('slicetext', true).attr('text-anchor', hasRight ? 'end' : hasLeft || singleLineHeader ? 'start' : 'middle').call(Drawing.font, font).call(svgTextUtils.convertToTspans, gd);
    pt.textBB = Drawing.bBox(sliceText.node());
    pt.transform = toMoveInsideSlice(pt, {
      fontSize: font.size,
      isHeader: isHeader
    });
    pt.transform.fontSize = font.size;
    if (hasTransition) {
      sliceText.transition().attrTween('transform', function (pt2) {
        var interp = makeUpdateTextInterpolator(pt2, onPathbar, getRefRect(), [width, height]);
        return function (t) {
          return strTransform(interp(t));
        };
      });
    } else {
      sliceText.attr('transform', strTransform(pt));
    }
  });
  return nextOfPrevEntry;
};

/***/ }),

/***/ 36141:
/***/ (function(module) {

"use strict";


module.exports = function flipTree(node, size, opts) {
  var tmp;
  if (opts.swapXY) {
    // swap x0 and y0
    tmp = node.x0;
    node.x0 = node.y0;
    node.y0 = tmp;

    // swap x1 and y1
    tmp = node.x1;
    node.x1 = node.y1;
    node.y1 = tmp;
  }
  if (opts.flipX) {
    tmp = node.x0;
    node.x0 = size[0] - node.x1;
    node.x1 = size[0] - tmp;
  }
  if (opts.flipY) {
    tmp = node.y0;
    node.y0 = size[1] - node.y1;
    node.y1 = size[1] - tmp;
  }
  var children = node.children;
  if (children) {
    for (var i = 0; i < children.length; i++) {
      flipTree(children[i], size, opts);
    }
  }
};

/***/ }),

/***/ 47181:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = {
  moduleType: 'trace',
  name: 'treemap',
  basePlotModule: __webpack_require__(69784),
  categories: [],
  animatable: true,
  attributes: __webpack_require__(71856),
  layoutAttributes: __webpack_require__(4219),
  supplyDefaults: __webpack_require__(95719),
  supplyLayoutDefaults: __webpack_require__(49852),
  calc: (__webpack_require__(38848)/* .calc */ ._),
  crossTraceCalc: (__webpack_require__(38848)/* .crossTraceCalc */ .t),
  plot: __webpack_require__(64274),
  style: (__webpack_require__(92080).style),
  colorbar: __webpack_require__(21146),
  meta: {}
};

/***/ }),

/***/ 4219:
/***/ (function(module) {

"use strict";


module.exports = {
  treemapcolorway: {
    valType: 'colorlist',
    editType: 'calc'
  },
  extendtreemapcolors: {
    valType: 'boolean',
    dflt: true,
    editType: 'calc'
  }
};

/***/ }),

/***/ 49852:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var layoutAttributes = __webpack_require__(4219);
module.exports = function supplyLayoutDefaults(layoutIn, layoutOut) {
  function coerce(attr, dflt) {
    return Lib.coerce(layoutIn, layoutOut, layoutAttributes, attr, dflt);
  }
  coerce('treemapcolorway', layoutOut.colorway);
  coerce('extendtreemapcolors');
};

/***/ }),

/***/ 11995:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3Hierarchy = __webpack_require__(92264);
var flipTree = __webpack_require__(36141);
module.exports = function partition(entry, size, opts) {
  var flipX = opts.flipX;
  var flipY = opts.flipY;
  var swapXY = opts.packing === 'dice-slice';
  var top = opts.pad[flipY ? 'bottom' : 'top'];
  var left = opts.pad[flipX ? 'right' : 'left'];
  var right = opts.pad[flipX ? 'left' : 'right'];
  var bottom = opts.pad[flipY ? 'top' : 'bottom'];
  var tmp;
  if (swapXY) {
    tmp = left;
    left = top;
    top = tmp;
    tmp = right;
    right = bottom;
    bottom = tmp;
  }
  var result = d3Hierarchy.treemap().tile(getTilingMethod(opts.packing, opts.squarifyratio)).paddingInner(opts.pad.inner).paddingLeft(left).paddingRight(right).paddingTop(top).paddingBottom(bottom).size(swapXY ? [size[1], size[0]] : size)(entry);
  if (swapXY || flipX || flipY) {
    flipTree(result, size, {
      swapXY: swapXY,
      flipX: flipX,
      flipY: flipY
    });
  }
  return result;
};
function getTilingMethod(key, squarifyratio) {
  switch (key) {
    case 'squarify':
      return d3Hierarchy.treemapSquarify.ratio(squarifyratio);
    case 'binary':
      return d3Hierarchy.treemapBinary;
    case 'dice':
      return d3Hierarchy.treemapDice;
    case 'slice':
      return d3Hierarchy.treemapSlice;
    default:
      // i.e. 'slice-dice' | 'dice-slice'
      return d3Hierarchy.treemapSliceDice;
  }
}

/***/ }),

/***/ 64274:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var draw = __webpack_require__(41567);
var drawDescendants = __webpack_require__(50916);
module.exports = function _plot(gd, cdmodule, transitionOpts, makeOnCompleteCallback) {
  return draw(gd, cdmodule, transitionOpts, makeOnCompleteCallback, {
    type: 'treemap',
    drawDescendants: drawDescendants
  });
};

/***/ }),

/***/ 95709:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var interpolate = (__webpack_require__(88640)/* .interpolate */ .GW);
var helpers = __webpack_require__(33108);
var Lib = __webpack_require__(34809);
var TEXTPAD = (__webpack_require__(56155).TEXTPAD);
var barPlot = __webpack_require__(32995);
var toMoveInsideBar = barPlot.toMoveInsideBar;
var uniformText = __webpack_require__(84102);
var recordMinTextSize = uniformText.recordMinTextSize;
var constants = __webpack_require__(43236);
var drawAncestors = __webpack_require__(17010);
function getKey(pt) {
  return helpers.isHierarchyRoot(pt) ? '' :
  // don't use the dummyId
  helpers.getPtId(pt);
}
module.exports = function plotOne(gd, cd, element, transitionOpts, drawDescendants) {
  var fullLayout = gd._fullLayout;
  var cd0 = cd[0];
  var trace = cd0.trace;
  var type = trace.type;
  var isIcicle = type === 'icicle';
  var hierarchy = cd0.hierarchy;
  var entry = helpers.findEntryWithLevel(hierarchy, trace.level);
  var gTrace = d3.select(element);
  var selAncestors = gTrace.selectAll('g.pathbar');
  var selDescendants = gTrace.selectAll('g.slice');
  if (!entry) {
    selAncestors.remove();
    selDescendants.remove();
    return;
  }
  var isRoot = helpers.isHierarchyRoot(entry);
  var hasTransition = !fullLayout.uniformtext.mode && helpers.hasTransition(transitionOpts);
  var maxDepth = helpers.getMaxDepth(trace);
  var hasVisibleDepth = function (pt) {
    return pt.data.depth - entry.data.depth < maxDepth;
  };
  var gs = fullLayout._size;
  var domain = trace.domain;
  var vpw = gs.w * (domain.x[1] - domain.x[0]);
  var vph = gs.h * (domain.y[1] - domain.y[0]);
  var barW = vpw;
  var barH = trace.pathbar.thickness;
  var barPad = trace.marker.line.width + constants.gapWithPathbar;
  var barDifY = !trace.pathbar.visible ? 0 : trace.pathbar.side.indexOf('bottom') > -1 ? vph + barPad : -(barH + barPad);
  var pathbarOrigin = {
    x0: barW,
    // slide to the right
    x1: barW,
    y0: barDifY,
    y1: barDifY + barH
  };
  var findClosestEdge = function (pt, ref, size) {
    var e = trace.tiling.pad;
    var isLeftOfRect = function (x) {
      return x - e <= ref.x0;
    };
    var isRightOfRect = function (x) {
      return x + e >= ref.x1;
    };
    var isBottomOfRect = function (y) {
      return y - e <= ref.y0;
    };
    var isTopOfRect = function (y) {
      return y + e >= ref.y1;
    };
    if (pt.x0 === ref.x0 && pt.x1 === ref.x1 && pt.y0 === ref.y0 && pt.y1 === ref.y1) {
      return {
        x0: pt.x0,
        x1: pt.x1,
        y0: pt.y0,
        y1: pt.y1
      };
    }
    return {
      x0: isLeftOfRect(pt.x0 - e) ? 0 : isRightOfRect(pt.x0 - e) ? size[0] : pt.x0,
      x1: isLeftOfRect(pt.x1 + e) ? 0 : isRightOfRect(pt.x1 + e) ? size[0] : pt.x1,
      y0: isBottomOfRect(pt.y0 - e) ? 0 : isTopOfRect(pt.y0 - e) ? size[1] : pt.y0,
      y1: isBottomOfRect(pt.y1 + e) ? 0 : isTopOfRect(pt.y1 + e) ? size[1] : pt.y1
    };
  };

  // stash of 'previous' position data used by tweening functions
  var prevEntry = null;
  var prevLookupPathbar = {};
  var prevLookupSlices = {};
  var nextOfPrevEntry = null;
  var getPrev = function (pt, onPathbar) {
    return onPathbar ? prevLookupPathbar[getKey(pt)] : prevLookupSlices[getKey(pt)];
  };
  var getOrigin = function (pt, onPathbar, refRect, size) {
    if (onPathbar) {
      return prevLookupPathbar[getKey(hierarchy)] || pathbarOrigin;
    } else {
      var ref = prevLookupSlices[trace.level] || refRect;
      if (hasVisibleDepth(pt)) {
        // case of an empty object - happens when maxdepth is set
        return findClosestEdge(pt, ref, size);
      }
    }
    return {};
  };

  // N.B. handle multiple-root special case
  if (cd0.hasMultipleRoots && isRoot) {
    maxDepth++;
  }
  trace._maxDepth = maxDepth;
  trace._backgroundColor = fullLayout.paper_bgcolor;
  trace._entryDepth = entry.data.depth;
  trace._atRootLevel = isRoot;
  var cenX = -vpw / 2 + gs.l + gs.w * (domain.x[1] + domain.x[0]) / 2;
  var cenY = -vph / 2 + gs.t + gs.h * (1 - (domain.y[1] + domain.y[0]) / 2);
  var viewMapX = function (x) {
    return cenX + x;
  };
  var viewMapY = function (y) {
    return cenY + y;
  };
  var barY0 = viewMapY(0);
  var barX0 = viewMapX(0);
  var viewBarX = function (x) {
    return barX0 + x;
  };
  var viewBarY = function (y) {
    return barY0 + y;
  };
  function pos(x, y) {
    return x + ',' + y;
  }
  var xStart = viewBarX(0);
  var limitX0 = function (p) {
    p.x = Math.max(xStart, p.x);
  };
  var edgeshape = trace.pathbar.edgeshape;

  // pathbar(directory) path generation fn
  var pathAncestor = function (d) {
    var _x0 = viewBarX(Math.max(Math.min(d.x0, d.x0), 0));
    var _x1 = viewBarX(Math.min(Math.max(d.x1, d.x1), barW));
    var _y0 = viewBarY(d.y0);
    var _y1 = viewBarY(d.y1);
    var halfH = barH / 2;
    var pL = {};
    var pR = {};
    pL.x = _x0;
    pR.x = _x1;
    pL.y = pR.y = (_y0 + _y1) / 2;
    var pA = {
      x: _x0,
      y: _y0
    };
    var pB = {
      x: _x1,
      y: _y0
    };
    var pC = {
      x: _x1,
      y: _y1
    };
    var pD = {
      x: _x0,
      y: _y1
    };
    if (edgeshape === '>') {
      pA.x -= halfH;
      pB.x -= halfH;
      pC.x -= halfH;
      pD.x -= halfH;
    } else if (edgeshape === '/') {
      pC.x -= halfH;
      pD.x -= halfH;
      pL.x -= halfH / 2;
      pR.x -= halfH / 2;
    } else if (edgeshape === '\\') {
      pA.x -= halfH;
      pB.x -= halfH;
      pL.x -= halfH / 2;
      pR.x -= halfH / 2;
    } else if (edgeshape === '<') {
      pL.x -= halfH;
      pR.x -= halfH;
    }
    limitX0(pA);
    limitX0(pD);
    limitX0(pL);
    limitX0(pB);
    limitX0(pC);
    limitX0(pR);
    return 'M' + pos(pA.x, pA.y) + 'L' + pos(pB.x, pB.y) + 'L' + pos(pR.x, pR.y) + 'L' + pos(pC.x, pC.y) + 'L' + pos(pD.x, pD.y) + 'L' + pos(pL.x, pL.y) + 'Z';
  };

  // Note that `pad` is just an integer for `icicle`` traces where
  // `pad` is a hashmap for treemap: pad.t, pad.b, pad.l, and pad.r
  var pad = trace[isIcicle ? 'tiling' : 'marker'].pad;
  var hasFlag = function (f) {
    return trace.textposition.indexOf(f) !== -1;
  };
  var hasTop = hasFlag('top');
  var hasLeft = hasFlag('left');
  var hasRight = hasFlag('right');
  var hasBottom = hasFlag('bottom');

  // slice path generation fn
  var pathDescendant = function (d) {
    var _x0 = viewMapX(d.x0);
    var _x1 = viewMapX(d.x1);
    var _y0 = viewMapY(d.y0);
    var _y1 = viewMapY(d.y1);
    var dx = _x1 - _x0;
    var dy = _y1 - _y0;
    if (!dx || !dy) return '';
    var cornerradius = trace.marker.cornerradius || 0;
    var r = Math.min(cornerradius, dx / 2, dy / 2);
    if (r && d.data && d.data.data && d.data.data.label) {
      if (hasTop) r = Math.min(r, pad.t);
      if (hasLeft) r = Math.min(r, pad.l);
      if (hasRight) r = Math.min(r, pad.r);
      if (hasBottom) r = Math.min(r, pad.b);
    }
    var arc = function (rx, ry) {
      return r ? 'a' + pos(r, r) + ' 0 0 1 ' + pos(rx, ry) : '';
    };
    return 'M' + pos(_x0, _y0 + r) + arc(r, -r) + 'L' + pos(_x1 - r, _y0) + arc(r, r) + 'L' + pos(_x1, _y1 - r) + arc(-r, r) + 'L' + pos(_x0 + r, _y1) + arc(-r, -r) + 'Z';
  };
  var toMoveInsideSlice = function (pt, opts) {
    var x0 = pt.x0;
    var x1 = pt.x1;
    var y0 = pt.y0;
    var y1 = pt.y1;
    var textBB = pt.textBB;
    var _hasTop = hasTop || opts.isHeader && !hasBottom;
    var anchor = _hasTop ? 'start' : hasBottom ? 'end' : 'middle';
    var _hasRight = hasFlag('right');
    var _hasLeft = hasFlag('left') || opts.onPathbar;
    var leftToRight = _hasLeft ? -1 : _hasRight ? 1 : 0;
    if (opts.isHeader) {
      x0 += (isIcicle ? pad : pad.l) - TEXTPAD;
      x1 -= (isIcicle ? pad : pad.r) - TEXTPAD;
      if (x0 >= x1) {
        var mid = (x0 + x1) / 2;
        x0 = mid;
        x1 = mid;
      }

      // limit the drawing area for headers
      var limY;
      if (hasBottom) {
        limY = y1 - (isIcicle ? pad : pad.b);
        if (y0 < limY && limY < y1) y0 = limY;
      } else {
        limY = y0 + (isIcicle ? pad : pad.t);
        if (y0 < limY && limY < y1) y1 = limY;
      }
    }

    // position the text relative to the slice
    var transform = toMoveInsideBar(x0, x1, y0, y1, textBB, {
      isHorizontal: false,
      constrained: true,
      angle: 0,
      anchor: anchor,
      leftToRight: leftToRight
    });
    transform.fontSize = opts.fontSize;
    transform.targetX = viewMapX(transform.targetX);
    transform.targetY = viewMapY(transform.targetY);
    if (isNaN(transform.targetX) || isNaN(transform.targetY)) {
      return {};
    }
    if (x0 !== x1 && y0 !== y1) {
      recordMinTextSize(trace.type, transform, fullLayout);
    }
    return {
      scale: transform.scale,
      rotate: transform.rotate,
      textX: transform.textX,
      textY: transform.textY,
      anchorX: transform.anchorX,
      anchorY: transform.anchorY,
      targetX: transform.targetX,
      targetY: transform.targetY
    };
  };
  var interpFromParent = function (pt, onPathbar) {
    var parentPrev;
    var i = 0;
    var Q = pt;
    while (!parentPrev && i < maxDepth) {
      // loop to find a parent/grandParent on the previous graph
      i++;
      Q = Q.parent;
      if (Q) {
        parentPrev = getPrev(Q, onPathbar);
      } else i = maxDepth;
    }
    return parentPrev || {};
  };
  var makeExitSliceInterpolator = function (pt, onPathbar, refRect, size) {
    var prev = getPrev(pt, onPathbar);
    var next;
    if (onPathbar) {
      next = pathbarOrigin;
    } else {
      var entryPrev = getPrev(entry, onPathbar);
      if (entryPrev) {
        // 'entryPrev' is here has the previous coordinates of the entry
        // node, which corresponds to the last "clicked" node when zooming in
        next = findClosestEdge(pt, entryPrev, size);
      } else {
        // this happens when maxdepth is set, when leaves must
        // be removed and the entry is new (i.e. does not have a 'prev' object)
        next = {};
      }
    }
    return interpolate(prev, next);
  };
  var makeUpdateSliceInterpolator = function (pt, onPathbar, refRect, size, opts) {
    var prev0 = getPrev(pt, onPathbar);
    var prev;
    if (prev0) {
      // if pt already on graph, this is easy
      prev = prev0;
    } else {
      // for new pts:
      if (onPathbar) {
        prev = pathbarOrigin;
      } else {
        if (prevEntry) {
          // if trace was visible before
          if (pt.parent) {
            var ref = nextOfPrevEntry || refRect;
            if (ref && !onPathbar) {
              prev = findClosestEdge(pt, ref, size);
            } else {
              // if new leaf (when maxdepth is set),
              // grow it from its parent node
              prev = {};
              Lib.extendFlat(prev, interpFromParent(pt, onPathbar));
            }
          } else {
            prev = Lib.extendFlat({}, pt);
            if (isIcicle) {
              if (opts.orientation === 'h') {
                if (opts.flipX) prev.x0 = pt.x1;else prev.x1 = 0;
              } else {
                if (opts.flipY) prev.y0 = pt.y1;else prev.y1 = 0;
              }
            }
          }
        } else {
          prev = {};
        }
      }
    }
    return interpolate(prev, {
      x0: pt.x0,
      x1: pt.x1,
      y0: pt.y0,
      y1: pt.y1
    });
  };
  var makeUpdateTextInterpolator = function (pt, onPathbar, refRect, size) {
    var prev0 = getPrev(pt, onPathbar);
    var prev = {};
    var origin = getOrigin(pt, onPathbar, refRect, size);
    Lib.extendFlat(prev, {
      transform: toMoveInsideSlice({
        x0: origin.x0,
        x1: origin.x1,
        y0: origin.y0,
        y1: origin.y1,
        textBB: pt.textBB,
        _text: pt._text
      }, {
        isHeader: helpers.isHeader(pt, trace)
      })
    });
    if (prev0) {
      // if pt already on graph, this is easy
      prev = prev0;
    } else {
      // for new pts:
      if (pt.parent) {
        Lib.extendFlat(prev, interpFromParent(pt, onPathbar));
      }
    }
    var transform = pt.transform;
    if (pt.x0 !== pt.x1 && pt.y0 !== pt.y1) {
      recordMinTextSize(trace.type, transform, fullLayout);
    }
    return interpolate(prev, {
      transform: {
        scale: transform.scale,
        rotate: transform.rotate,
        textX: transform.textX,
        textY: transform.textY,
        anchorX: transform.anchorX,
        anchorY: transform.anchorY,
        targetX: transform.targetX,
        targetY: transform.targetY
      }
    });
  };
  var handleSlicesExit = function (slices, onPathbar, refRect, size, pathSlice) {
    var width = size[0];
    var height = size[1];
    if (hasTransition) {
      slices.exit().transition().each(function () {
        var sliceTop = d3.select(this);
        var slicePath = sliceTop.select('path.surface');
        slicePath.transition().attrTween('d', function (pt2) {
          var interp = makeExitSliceInterpolator(pt2, onPathbar, refRect, [width, height]);
          return function (t) {
            return pathSlice(interp(t));
          };
        });
        var sliceTextGroup = sliceTop.select('g.slicetext');
        sliceTextGroup.attr('opacity', 0);
      }).remove();
    } else {
      slices.exit().remove();
    }
  };
  var strTransform = function (d) {
    var transform = d.transform;
    if (d.x0 !== d.x1 && d.y0 !== d.y1) {
      recordMinTextSize(trace.type, transform, fullLayout);
    }
    return Lib.getTextTransform({
      textX: transform.textX,
      textY: transform.textY,
      anchorX: transform.anchorX,
      anchorY: transform.anchorY,
      targetX: transform.targetX,
      targetY: transform.targetY,
      scale: transform.scale,
      rotate: transform.rotate
    });
  };
  if (hasTransition) {
    // Important: do this before binding new sliceData!

    selAncestors.each(function (pt) {
      prevLookupPathbar[getKey(pt)] = {
        x0: pt.x0,
        x1: pt.x1,
        y0: pt.y0,
        y1: pt.y1
      };
      if (pt.transform) {
        prevLookupPathbar[getKey(pt)].transform = {
          textX: pt.transform.textX,
          textY: pt.transform.textY,
          anchorX: pt.transform.anchorX,
          anchorY: pt.transform.anchorY,
          targetX: pt.transform.targetX,
          targetY: pt.transform.targetY,
          scale: pt.transform.scale,
          rotate: pt.transform.rotate
        };
      }
    });
    selDescendants.each(function (pt) {
      prevLookupSlices[getKey(pt)] = {
        x0: pt.x0,
        x1: pt.x1,
        y0: pt.y0,
        y1: pt.y1
      };
      if (pt.transform) {
        prevLookupSlices[getKey(pt)].transform = {
          textX: pt.transform.textX,
          textY: pt.transform.textY,
          anchorX: pt.transform.anchorX,
          anchorY: pt.transform.anchorY,
          targetX: pt.transform.targetX,
          targetY: pt.transform.targetY,
          scale: pt.transform.scale,
          rotate: pt.transform.rotate
        };
      }
      if (!prevEntry && helpers.isEntry(pt)) {
        prevEntry = pt;
      }
    });
  }
  nextOfPrevEntry = drawDescendants(gd, cd, entry, selDescendants, {
    width: vpw,
    height: vph,
    viewX: viewMapX,
    viewY: viewMapY,
    pathSlice: pathDescendant,
    toMoveInsideSlice: toMoveInsideSlice,
    prevEntry: prevEntry,
    makeUpdateSliceInterpolator: makeUpdateSliceInterpolator,
    makeUpdateTextInterpolator: makeUpdateTextInterpolator,
    handleSlicesExit: handleSlicesExit,
    hasTransition: hasTransition,
    strTransform: strTransform
  });
  if (trace.pathbar.visible) {
    drawAncestors(gd, cd, entry, selAncestors, {
      barDifY: barDifY,
      width: barW,
      height: barH,
      viewX: viewBarX,
      viewY: viewBarY,
      pathSlice: pathAncestor,
      toMoveInsideSlice: toMoveInsideSlice,
      makeUpdateSliceInterpolator: makeUpdateSliceInterpolator,
      makeUpdateTextInterpolator: makeUpdateTextInterpolator,
      handleSlicesExit: handleSlicesExit,
      hasTransition: hasTransition,
      strTransform: strTransform
    });
  } else {
    selAncestors.remove();
  }
};

/***/ }),

/***/ 92080:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var Color = __webpack_require__(78766);
var Lib = __webpack_require__(34809);
var helpers = __webpack_require__(33108);
var resizeText = (__webpack_require__(84102).resizeText);
var fillOne = __webpack_require__(72043);
function style(gd) {
  var s = gd._fullLayout._treemaplayer.selectAll('.trace');
  resizeText(gd, s, 'treemap');
  s.each(function (cd) {
    var gTrace = d3.select(this);
    var cd0 = cd[0];
    var trace = cd0.trace;
    gTrace.style('opacity', trace.opacity);
    gTrace.selectAll('path.surface').each(function (pt) {
      d3.select(this).call(styleOne, pt, trace, gd, {
        hovered: false
      });
    });
  });
}
function styleOne(s, pt, trace, gd, opts) {
  var hovered = (opts || {}).hovered;
  var cdi = pt.data.data;
  var ptNumber = cdi.i;
  var lineColor;
  var lineWidth;
  var fillColor = cdi.color;
  var isRoot = helpers.isHierarchyRoot(pt);
  var opacity = 1;
  if (hovered) {
    lineColor = trace._hovered.marker.line.color;
    lineWidth = trace._hovered.marker.line.width;
  } else {
    if (isRoot && fillColor === trace.root.color) {
      opacity = 100;
      lineColor = 'rgba(0,0,0,0)';
      lineWidth = 0;
    } else {
      lineColor = Lib.castOption(trace, ptNumber, 'marker.line.color') || Color.defaultLine;
      lineWidth = Lib.castOption(trace, ptNumber, 'marker.line.width') || 0;
      if (!trace._hasColorscale && !pt.onPathbar) {
        var depthfade = trace.marker.depthfade;
        if (depthfade) {
          var fadedColor = Color.combine(Color.addOpacity(trace._backgroundColor, 0.75), fillColor);
          var n;
          if (depthfade === true) {
            var maxDepth = helpers.getMaxDepth(trace);
            if (isFinite(maxDepth)) {
              if (helpers.isLeaf(pt)) {
                n = 0;
              } else {
                n = trace._maxVisibleLayers - (pt.data.depth - trace._entryDepth);
              }
            } else {
              n = pt.data.height + 1;
            }
          } else {
            // i.e. case of depthfade === 'reversed'
            n = pt.data.depth - trace._entryDepth;
            if (!trace._atRootLevel) n++;
          }
          if (n > 0) {
            for (var i = 0; i < n; i++) {
              var ratio = 0.5 * i / n;
              fillColor = Color.combine(Color.addOpacity(fadedColor, ratio), fillColor);
            }
          }
        }
      }
    }
  }
  s.call(fillOne, pt, trace, gd, fillColor).style('stroke-width', lineWidth).call(Color.stroke, lineColor).style('opacity', opacity);
}
module.exports = {
  style: style,
  styleOne: styleOne
};

/***/ }),

/***/ 14711:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var boxAttrs = __webpack_require__(64625);
var extendFlat = (__webpack_require__(93049).extendFlat);
var axisHoverFormat = (__webpack_require__(80712).axisHoverFormat);
module.exports = {
  y: boxAttrs.y,
  x: boxAttrs.x,
  x0: boxAttrs.x0,
  y0: boxAttrs.y0,
  xhoverformat: axisHoverFormat('x'),
  yhoverformat: axisHoverFormat('y'),
  name: extendFlat({}, boxAttrs.name, {}),
  orientation: extendFlat({}, boxAttrs.orientation, {}),
  bandwidth: {
    valType: 'number',
    min: 0,
    editType: 'calc'
  },
  scalegroup: {
    valType: 'string',
    dflt: '',
    editType: 'calc'
  },
  scalemode: {
    valType: 'enumerated',
    values: ['width', 'count'],
    dflt: 'width',
    editType: 'calc'
  },
  spanmode: {
    valType: 'enumerated',
    values: ['soft', 'hard', 'manual'],
    dflt: 'soft',
    editType: 'calc'
  },
  span: {
    valType: 'info_array',
    items: [{
      valType: 'any',
      editType: 'calc'
    }, {
      valType: 'any',
      editType: 'calc'
    }],
    editType: 'calc'
  },
  line: {
    color: {
      valType: 'color',
      editType: 'style'
    },
    width: {
      valType: 'number',
      min: 0,
      dflt: 2,
      editType: 'style'
    },
    editType: 'plot'
  },
  fillcolor: boxAttrs.fillcolor,
  points: extendFlat({}, boxAttrs.boxpoints, {}),
  jitter: extendFlat({}, boxAttrs.jitter, {}),
  pointpos: extendFlat({}, boxAttrs.pointpos, {}),
  width: extendFlat({}, boxAttrs.width, {}),
  marker: boxAttrs.marker,
  text: boxAttrs.text,
  hovertext: boxAttrs.hovertext,
  hovertemplate: boxAttrs.hovertemplate,
  quartilemethod: boxAttrs.quartilemethod,
  box: {
    visible: {
      valType: 'boolean',
      dflt: false,
      editType: 'plot'
    },
    width: {
      valType: 'number',
      min: 0,
      max: 1,
      dflt: 0.25,
      editType: 'plot'
    },
    fillcolor: {
      valType: 'color',
      editType: 'style'
    },
    line: {
      color: {
        valType: 'color',
        editType: 'style'
      },
      width: {
        valType: 'number',
        min: 0,
        editType: 'style'
      },
      editType: 'style'
    },
    editType: 'plot'
  },
  meanline: {
    visible: {
      valType: 'boolean',
      dflt: false,
      editType: 'plot'
    },
    color: {
      valType: 'color',
      editType: 'style'
    },
    width: {
      valType: 'number',
      min: 0,
      editType: 'style'
    },
    editType: 'plot'
  },
  side: {
    valType: 'enumerated',
    values: ['both', 'positive', 'negative'],
    dflt: 'both',
    editType: 'calc'
  },
  offsetgroup: boxAttrs.offsetgroup,
  alignmentgroup: boxAttrs.alignmentgroup,
  selected: boxAttrs.selected,
  unselected: boxAttrs.unselected,
  hoveron: {
    valType: 'flaglist',
    flags: ['violins', 'points', 'kde'],
    dflt: 'violins+points+kde',
    extras: ['all'],
    editType: 'style'
  },
  zorder: boxAttrs.zorder
};

/***/ }),

/***/ 88759:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var Axes = __webpack_require__(29714);
var boxCalc = __webpack_require__(89429);
var helpers = __webpack_require__(37881);
var BADNUM = (__webpack_require__(63821).BADNUM);
module.exports = function calc(gd, trace) {
  var cd = boxCalc(gd, trace);
  if (cd[0].t.empty) return cd;
  var fullLayout = gd._fullLayout;
  var valAxis = Axes.getFromId(gd, trace[trace.orientation === 'h' ? 'xaxis' : 'yaxis']);
  var spanMin = Infinity;
  var spanMax = -Infinity;
  var maxKDE = 0;
  var maxCount = 0;
  for (var i = 0; i < cd.length; i++) {
    var cdi = cd[i];
    var vals = cdi.pts.map(helpers.extractVal);
    var bandwidth = cdi.bandwidth = calcBandwidth(trace, cdi, vals);
    var span = cdi.span = calcSpan(trace, cdi, valAxis, bandwidth);
    if (cdi.min === cdi.max && bandwidth === 0) {
      // if span is zero and bandwidth is zero, we want a violin with zero width
      span = cdi.span = [cdi.min, cdi.max];
      cdi.density = [{
        v: 1,
        t: span[0]
      }];
      cdi.bandwidth = bandwidth;
      maxKDE = Math.max(maxKDE, 1);
    } else {
      // step that well covers the bandwidth and is multiple of span distance
      var dist = span[1] - span[0];
      var n = Math.ceil(dist / (bandwidth / 3));
      var step = dist / n;
      if (!isFinite(step) || !isFinite(n)) {
        Lib.error('Something went wrong with computing the violin span');
        cd[0].t.empty = true;
        return cd;
      }
      var kde = helpers.makeKDE(cdi, trace, vals);
      cdi.density = new Array(n);
      for (var k = 0, t = span[0]; t < span[1] + step / 2; k++, t += step) {
        var v = kde(t);
        cdi.density[k] = {
          v: v,
          t: t
        };
        maxKDE = Math.max(maxKDE, v);
      }
    }
    maxCount = Math.max(maxCount, vals.length);
    spanMin = Math.min(spanMin, span[0]);
    spanMax = Math.max(spanMax, span[1]);
  }
  var extremes = Axes.findExtremes(valAxis, [spanMin, spanMax], {
    padded: true
  });
  trace._extremes[valAxis._id] = extremes;
  if (trace.width) {
    cd[0].t.maxKDE = maxKDE;
  } else {
    var violinScaleGroupStats = fullLayout._violinScaleGroupStats;
    var scaleGroup = trace.scalegroup;
    var groupStats = violinScaleGroupStats[scaleGroup];
    if (groupStats) {
      groupStats.maxKDE = Math.max(groupStats.maxKDE, maxKDE);
      groupStats.maxCount = Math.max(groupStats.maxCount, maxCount);
    } else {
      violinScaleGroupStats[scaleGroup] = {
        maxKDE: maxKDE,
        maxCount: maxCount
      };
    }
  }
  cd[0].t.labels.kde = Lib._(gd, 'kde:');
  return cd;
};

// Default to Silveman's rule of thumb
// - https://stats.stackexchange.com/a/6671
// - https://en.wikipedia.org/wiki/Kernel_density_estimation#A_rule-of-thumb_bandwidth_estimator
// - https://github.com/statsmodels/statsmodels/blob/master/statsmodels/nonparametric/bandwidths.py
function silvermanRule(len, ssd, iqr) {
  var a = Math.min(ssd, iqr / 1.349);
  return 1.059 * a * Math.pow(len, -0.2);
}
function calcBandwidth(trace, cdi, vals) {
  var span = cdi.max - cdi.min;

  // If span is zero
  if (!span) {
    if (trace.bandwidth) {
      return trace.bandwidth;
    } else {
      // if span is zero and no bandwidth is specified
      // it returns zero bandwidth which is a special case
      return 0;
    }
  }

  // Limit how small the bandwidth can be.
  //
  // Silverman's rule of thumb can be "very" small
  // when IQR does a poor job at describing the spread
  // of the distribution.
  // We also want to limit custom bandwidths
  // to not blow up kde computations.

  if (trace.bandwidth) {
    return Math.max(trace.bandwidth, span / 1e4);
  } else {
    var len = vals.length;
    var ssd = Lib.stdev(vals, len - 1, cdi.mean);
    return Math.max(silvermanRule(len, ssd, cdi.q3 - cdi.q1), span / 100);
  }
}
function calcSpan(trace, cdi, valAxis, bandwidth) {
  var spanmode = trace.spanmode;
  var spanIn = trace.span || [];
  var spanTight = [cdi.min, cdi.max];
  var spanLoose = [cdi.min - 2 * bandwidth, cdi.max + 2 * bandwidth];
  var spanOut;
  function calcSpanItem(index) {
    var s = spanIn[index];
    var sc = valAxis.type === 'multicategory' ? valAxis.r2c(s) : valAxis.d2c(s, 0, trace[cdi.valLetter + 'calendar']);
    return sc === BADNUM ? spanLoose[index] : sc;
  }
  if (spanmode === 'soft') {
    spanOut = spanLoose;
  } else if (spanmode === 'hard') {
    spanOut = spanTight;
  } else {
    spanOut = [calcSpanItem(0), calcSpanItem(1)];
  }

  // to reuse the equal-range-item block
  var dummyAx = {
    type: 'linear',
    range: spanOut
  };
  Axes.setConvert(dummyAx);
  dummyAx.cleanRange();
  return spanOut;
}

/***/ }),

/***/ 67316:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var setPositionOffset = (__webpack_require__(81606).setPositionOffset);
var orientations = ['v', 'h'];
module.exports = function crossTraceCalc(gd, plotinfo) {
  var calcdata = gd.calcdata;
  var xa = plotinfo.xaxis;
  var ya = plotinfo.yaxis;
  for (var i = 0; i < orientations.length; i++) {
    var orientation = orientations[i];
    var posAxis = orientation === 'h' ? ya : xa;
    var violinList = [];
    for (var j = 0; j < calcdata.length; j++) {
      var cd = calcdata[j];
      var t = cd[0].t;
      var trace = cd[0].trace;
      if (trace.visible === true && trace.type === 'violin' && !t.empty && trace.orientation === orientation && trace.xaxis === xa._id && trace.yaxis === ya._id) {
        violinList.push(j);
      }
    }
    setPositionOffset('violin', gd, violinList, posAxis);
  }
};

/***/ }),

/***/ 10864:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var Color = __webpack_require__(78766);
var boxDefaults = __webpack_require__(62294);
var attributes = __webpack_require__(14711);
module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
  function coerce(attr, dflt) {
    return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
  }
  function coerce2(attr, dflt) {
    return Lib.coerce2(traceIn, traceOut, attributes, attr, dflt);
  }
  boxDefaults.handleSampleDefaults(traceIn, traceOut, coerce, layout);
  if (traceOut.visible === false) return;
  coerce('bandwidth');
  coerce('side');
  var width = coerce('width');
  if (!width) {
    coerce('scalegroup', traceOut.name);
    coerce('scalemode');
  }
  var span = coerce('span');
  var spanmodeDflt;
  if (Array.isArray(span)) spanmodeDflt = 'manual';
  coerce('spanmode', spanmodeDflt);
  var lineColor = coerce('line.color', (traceIn.marker || {}).color || defaultColor);
  var lineWidth = coerce('line.width');
  var fillColor = coerce('fillcolor', Color.addOpacity(traceOut.line.color, 0.5));
  boxDefaults.handlePointsDefaults(traceIn, traceOut, coerce, {
    prefix: ''
  });
  var boxWidth = coerce2('box.width');
  var boxFillColor = coerce2('box.fillcolor', fillColor);
  var boxLineColor = coerce2('box.line.color', lineColor);
  var boxLineWidth = coerce2('box.line.width', lineWidth);
  var boxVisible = coerce('box.visible', Boolean(boxWidth || boxFillColor || boxLineColor || boxLineWidth));
  if (!boxVisible) traceOut.box = {
    visible: false
  };
  var meanLineColor = coerce2('meanline.color', lineColor);
  var meanLineWidth = coerce2('meanline.width', lineWidth);
  var meanLineVisible = coerce('meanline.visible', Boolean(meanLineColor || meanLineWidth));
  if (!meanLineVisible) traceOut.meanline = {
    visible: false
  };
  coerce('quartilemethod');
  coerce('zorder');
};

/***/ }),

/***/ 37881:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);

// Maybe add kernels more down the road,
// but note that the default `spanmode: 'soft'` bounds might have
// to become kernel-dependent
var kernels = {
  gaussian: function (v) {
    return 1 / Math.sqrt(2 * Math.PI) * Math.exp(-0.5 * v * v);
  }
};
exports.makeKDE = function (calcItem, trace, vals) {
  var len = vals.length;
  var kernel = kernels.gaussian;
  var bandwidth = calcItem.bandwidth;
  var factor = 1 / (len * bandwidth);

  // don't use Lib.aggNums to skip isNumeric checks
  return function (x) {
    var sum = 0;
    for (var i = 0; i < len; i++) {
      sum += kernel((x - vals[i]) / bandwidth);
    }
    return factor * sum;
  };
};
exports.getPositionOnKdePath = function (calcItem, trace, valuePx) {
  var posLetter, valLetter;
  if (trace.orientation === 'h') {
    posLetter = 'y';
    valLetter = 'x';
  } else {
    posLetter = 'x';
    valLetter = 'y';
  }
  var pointOnPath = Lib.findPointOnPath(calcItem.path, valuePx, valLetter, {
    pathLength: calcItem.pathLength
  });
  var posCenterPx = calcItem.posCenterPx;
  var posOnPath0 = pointOnPath[posLetter];
  var posOnPath1 = trace.side === 'both' ? 2 * posCenterPx - posOnPath0 : posCenterPx;
  return [posOnPath0, posOnPath1];
};
exports.getKdeValue = function (calcItem, trace, valueDist) {
  var vals = calcItem.pts.map(exports.extractVal);
  var kde = exports.makeKDE(calcItem, trace, vals);
  return kde(valueDist) / calcItem.posDensityScale;
};
exports.extractVal = function (o) {
  return o.v;
};

/***/ }),

/***/ 16842:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Color = __webpack_require__(78766);
var Lib = __webpack_require__(34809);
var Axes = __webpack_require__(29714);
var boxHoverPoints = __webpack_require__(11448);
var helpers = __webpack_require__(37881);
module.exports = function hoverPoints(pointData, xval, yval, hovermode, opts) {
  if (!opts) opts = {};
  var hoverLayer = opts.hoverLayer;
  var cd = pointData.cd;
  var trace = cd[0].trace;
  var hoveron = trace.hoveron;
  var hasHoveronViolins = hoveron.indexOf('violins') !== -1;
  var hasHoveronKDE = hoveron.indexOf('kde') !== -1;
  var closeData = [];
  var closePtData;
  var violinLineAttrs;
  if (hasHoveronViolins || hasHoveronKDE) {
    var closeBoxData = boxHoverPoints.hoverOnBoxes(pointData, xval, yval, hovermode);
    if (hasHoveronKDE && closeBoxData.length > 0) {
      var xa = pointData.xa;
      var ya = pointData.ya;
      var pLetter, vLetter, pAxis, vAxis, vVal;
      if (trace.orientation === 'h') {
        vVal = xval;
        pLetter = 'y';
        pAxis = ya;
        vLetter = 'x';
        vAxis = xa;
      } else {
        vVal = yval;
        pLetter = 'x';
        pAxis = xa;
        vLetter = 'y';
        vAxis = ya;
      }
      var di = cd[pointData.index];
      if (vVal >= di.span[0] && vVal <= di.span[1]) {
        var kdePointData = Lib.extendFlat({}, pointData);
        var vValPx = vAxis.c2p(vVal, true);
        var kdeVal = helpers.getKdeValue(di, trace, vVal);
        var pOnPath = helpers.getPositionOnKdePath(di, trace, vValPx);
        var paOffset = pAxis._offset;
        var paLength = pAxis._length;
        kdePointData[pLetter + '0'] = pOnPath[0];
        kdePointData[pLetter + '1'] = pOnPath[1];
        kdePointData[vLetter + '0'] = kdePointData[vLetter + '1'] = vValPx;
        kdePointData[vLetter + 'Label'] = vLetter + ': ' + Axes.hoverLabelText(vAxis, vVal, trace[vLetter + 'hoverformat']) + ', ' + cd[0].t.labels.kde + ' ' + kdeVal.toFixed(3);

        // move the spike to the KDE point
        var medId = 0;
        for (var k = 0; k < closeBoxData.length; k++) {
          if (closeBoxData[k].attr === 'med') {
            medId = k;
            break;
          }
        }
        kdePointData.spikeDistance = closeBoxData[medId].spikeDistance;
        var spikePosAttr = pLetter + 'Spike';
        kdePointData[spikePosAttr] = closeBoxData[medId][spikePosAttr];
        closeBoxData[medId].spikeDistance = undefined;
        closeBoxData[medId][spikePosAttr] = undefined;

        // no hovertemplate support yet
        kdePointData.hovertemplate = false;
        closeData.push(kdePointData);
        violinLineAttrs = {};
        violinLineAttrs[pLetter + '1'] = Lib.constrain(paOffset + pOnPath[0], paOffset, paOffset + paLength);
        violinLineAttrs[pLetter + '2'] = Lib.constrain(paOffset + pOnPath[1], paOffset, paOffset + paLength);
        violinLineAttrs[vLetter + '1'] = violinLineAttrs[vLetter + '2'] = vAxis._offset + vValPx;
      }
    }
    if (hasHoveronViolins) {
      closeData = closeData.concat(closeBoxData);
    }
  }
  if (hoveron.indexOf('points') !== -1) {
    closePtData = boxHoverPoints.hoverOnPoints(pointData, xval, yval);
  }

  // update violin line (if any)
  var violinLine = hoverLayer.selectAll('.violinline-' + trace.uid).data(violinLineAttrs ? [0] : []);
  violinLine.enter().append('line').classed('violinline-' + trace.uid, true).attr('stroke-width', 1.5);
  violinLine.exit().remove();
  violinLine.attr(violinLineAttrs).call(Color.stroke, pointData.color);

  // same combine logic as box hoverPoints
  if (hovermode === 'closest') {
    if (closePtData) return [closePtData];
    return closeData;
  }
  if (closePtData) {
    closeData.push(closePtData);
    return closeData;
  }
  return closeData;
};

/***/ }),

/***/ 37276:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = {
  attributes: __webpack_require__(14711),
  layoutAttributes: __webpack_require__(84734),
  supplyDefaults: __webpack_require__(10864),
  crossTraceDefaults: (__webpack_require__(62294).crossTraceDefaults),
  supplyLayoutDefaults: __webpack_require__(55145),
  calc: __webpack_require__(88759),
  crossTraceCalc: __webpack_require__(67316),
  plot: __webpack_require__(36769),
  style: __webpack_require__(25117),
  styleOnSelect: (__webpack_require__(9408).styleOnSelect),
  hoverPoints: __webpack_require__(16842),
  selectPoints: __webpack_require__(72488),
  moduleType: 'trace',
  name: 'violin',
  basePlotModule: __webpack_require__(37703),
  categories: ['cartesian', 'svg', 'symbols', 'oriented', 'box-violin', 'showLegend', 'violinLayout', 'zoomScale'],
  meta: {}
};

/***/ }),

/***/ 84734:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var boxLayoutAttrs = __webpack_require__(64636);
var extendFlat = (__webpack_require__(34809).extendFlat);
module.exports = {
  violinmode: extendFlat({}, boxLayoutAttrs.boxmode, {}),
  violingap: extendFlat({}, boxLayoutAttrs.boxgap, {}),
  violingroupgap: extendFlat({}, boxLayoutAttrs.boxgroupgap, {})
};

/***/ }),

/***/ 55145:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var layoutAttributes = __webpack_require__(84734);
var boxLayoutDefaults = __webpack_require__(65067);
module.exports = function supplyLayoutDefaults(layoutIn, layoutOut, fullData) {
  function coerce(attr, dflt) {
    return Lib.coerce(layoutIn, layoutOut, layoutAttributes, attr, dflt);
  }
  boxLayoutDefaults._supply(layoutIn, layoutOut, fullData, coerce, 'violin');
};

/***/ }),

/***/ 36769:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var Lib = __webpack_require__(34809);
var Drawing = __webpack_require__(62203);
var boxPlot = __webpack_require__(95419);
var linePoints = __webpack_require__(5525);
var helpers = __webpack_require__(37881);
module.exports = function plot(gd, plotinfo, cdViolins, violinLayer) {
  var isStatic = gd._context.staticPlot;
  var fullLayout = gd._fullLayout;
  var xa = plotinfo.xaxis;
  var ya = plotinfo.yaxis;
  function makePath(pts, trace) {
    var segments = linePoints(pts, {
      xaxis: xa,
      yaxis: ya,
      trace: trace,
      connectGaps: true,
      baseTolerance: 0.75,
      shape: 'spline',
      simplify: true,
      linearized: true
    });
    return Drawing.smoothopen(segments[0], 1);
  }
  Lib.makeTraceGroups(violinLayer, cdViolins, 'trace violins').each(function (cd) {
    var plotGroup = d3.select(this);
    var cd0 = cd[0];
    var t = cd0.t;
    var trace = cd0.trace;
    if (trace.visible !== true || t.empty) {
      plotGroup.remove();
      return;
    }
    var bPos = t.bPos;
    var bdPos = t.bdPos;
    var valAxis = plotinfo[t.valLetter + 'axis'];
    var posAxis = plotinfo[t.posLetter + 'axis'];
    var hasBothSides = trace.side === 'both';
    var hasPositiveSide = hasBothSides || trace.side === 'positive';
    var hasNegativeSide = hasBothSides || trace.side === 'negative';
    var violins = plotGroup.selectAll('path.violin').data(Lib.identity);
    violins.enter().append('path').style('vector-effect', isStatic ? 'none' : 'non-scaling-stroke').attr('class', 'violin');
    violins.exit().remove();
    violins.each(function (d) {
      var pathSel = d3.select(this);
      var density = d.density;
      var len = density.length;
      var posCenter = posAxis.c2l(d.pos + bPos, true);
      var posCenterPx = posAxis.l2p(posCenter);
      var scale;
      if (trace.width) {
        scale = t.maxKDE / bdPos;
      } else {
        var groupStats = fullLayout._violinScaleGroupStats[trace.scalegroup];
        scale = trace.scalemode === 'count' ? groupStats.maxKDE / bdPos * (groupStats.maxCount / d.pts.length) : groupStats.maxKDE / bdPos;
      }
      var pathPos, pathNeg, path;
      var i, k, pts, pt;
      if (hasPositiveSide) {
        pts = new Array(len);
        for (i = 0; i < len; i++) {
          pt = pts[i] = {};
          pt[t.posLetter] = posCenter + density[i].v / scale;
          pt[t.valLetter] = valAxis.c2l(density[i].t, true);
        }
        pathPos = makePath(pts, trace);
      }
      if (hasNegativeSide) {
        pts = new Array(len);
        for (k = 0, i = len - 1; k < len; k++, i--) {
          pt = pts[k] = {};
          pt[t.posLetter] = posCenter - density[i].v / scale;
          pt[t.valLetter] = valAxis.c2l(density[i].t, true);
        }
        pathNeg = makePath(pts, trace);
      }
      if (hasBothSides) {
        path = pathPos + 'L' + pathNeg.substr(1) + 'Z';
      } else {
        var startPt = [posCenterPx, valAxis.c2p(density[0].t)];
        var endPt = [posCenterPx, valAxis.c2p(density[len - 1].t)];
        if (trace.orientation === 'h') {
          startPt.reverse();
          endPt.reverse();
        }
        if (hasPositiveSide) {
          path = 'M' + startPt + 'L' + pathPos.substr(1) + 'L' + endPt;
        } else {
          path = 'M' + endPt + 'L' + pathNeg.substr(1) + 'L' + startPt;
        }
      }
      pathSel.attr('d', path);

      // save a few things used in getPositionOnKdePath, getKdeValue
      // on hover and for meanline draw block below
      d.posCenterPx = posCenterPx;
      d.posDensityScale = scale * bdPos;
      d.path = pathSel.node();
      d.pathLength = d.path.getTotalLength() / (hasBothSides ? 2 : 1);
    });
    var boxAttrs = trace.box;
    var boxWidth = boxAttrs.width;
    var boxLineWidth = (boxAttrs.line || {}).width;
    var bdPosScaled;
    var bPosPxOffset;
    if (hasBothSides) {
      bdPosScaled = bdPos * boxWidth;
      bPosPxOffset = 0;
    } else if (hasPositiveSide) {
      bdPosScaled = [0, bdPos * boxWidth / 2];
      bPosPxOffset = boxLineWidth * {
        x: 1,
        y: -1
      }[t.posLetter];
    } else {
      bdPosScaled = [bdPos * boxWidth / 2, 0];
      bPosPxOffset = boxLineWidth * {
        x: -1,
        y: 1
      }[t.posLetter];
    }

    // inner box
    boxPlot.plotBoxAndWhiskers(plotGroup, {
      pos: posAxis,
      val: valAxis
    }, trace, {
      bPos: bPos,
      bdPos: bdPosScaled,
      bPosPxOffset: bPosPxOffset
    });

    // meanline insider box
    boxPlot.plotBoxMean(plotGroup, {
      pos: posAxis,
      val: valAxis
    }, trace, {
      bPos: bPos,
      bdPos: bdPosScaled,
      bPosPxOffset: bPosPxOffset
    });
    var fn;
    if (!trace.box.visible && trace.meanline.visible) {
      fn = Lib.identity;
    }

    // N.B. use different class name than boxPlot.plotBoxMean,
    // to avoid selectAll conflict
    var meanPaths = plotGroup.selectAll('path.meanline').data(fn || []);
    meanPaths.enter().append('path').attr('class', 'meanline').style('fill', 'none').style('vector-effect', isStatic ? 'none' : 'non-scaling-stroke');
    meanPaths.exit().remove();
    meanPaths.each(function (d) {
      var v = valAxis.c2p(d.mean, true);
      var p = helpers.getPositionOnKdePath(d, trace, v);
      d3.select(this).attr('d', trace.orientation === 'h' ? 'M' + v + ',' + p[0] + 'V' + p[1] : 'M' + p[0] + ',' + v + 'H' + p[1]);
    });
    boxPlot.plotPoints(plotGroup, {
      x: xa,
      y: ya
    }, trace, t);
  });
};

/***/ }),

/***/ 25117:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var Color = __webpack_require__(78766);
var stylePoints = (__webpack_require__(9408).stylePoints);
module.exports = function style(gd) {
  var s = d3.select(gd).selectAll('g.trace.violins');
  s.style('opacity', function (d) {
    return d[0].trace.opacity;
  });
  s.each(function (d) {
    var trace = d[0].trace;
    var sel = d3.select(this);
    var box = trace.box || {};
    var boxLine = box.line || {};
    var meanline = trace.meanline || {};
    var meanLineWidth = meanline.width;
    sel.selectAll('path.violin').style('stroke-width', trace.line.width + 'px').call(Color.stroke, trace.line.color).call(Color.fill, trace.fillcolor);
    sel.selectAll('path.box').style('stroke-width', boxLine.width + 'px').call(Color.stroke, boxLine.color).call(Color.fill, box.fillcolor);
    var meanLineStyle = {
      'stroke-width': meanLineWidth + 'px',
      'stroke-dasharray': 2 * meanLineWidth + 'px,' + meanLineWidth + 'px'
    };
    sel.selectAll('path.mean').style(meanLineStyle).call(Color.stroke, meanline.color);
    sel.selectAll('path.meanline').style(meanLineStyle).call(Color.stroke, meanline.color);
    stylePoints(sel, trace, gd);
  });
};

/***/ }),

/***/ 51526:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var colorScaleAttrs = __webpack_require__(87163);
var isosurfaceAttrs = __webpack_require__(70252);
var surfaceAttrs = __webpack_require__(16131);
var baseAttrs = __webpack_require__(9829);
var extendFlat = (__webpack_require__(93049).extendFlat);
var overrideAll = (__webpack_require__(13582).overrideAll);
var attrs = module.exports = overrideAll(extendFlat({
  x: isosurfaceAttrs.x,
  y: isosurfaceAttrs.y,
  z: isosurfaceAttrs.z,
  value: isosurfaceAttrs.value,
  isomin: isosurfaceAttrs.isomin,
  isomax: isosurfaceAttrs.isomax,
  surface: isosurfaceAttrs.surface,
  spaceframe: {
    show: {
      valType: 'boolean',
      dflt: false
    },
    fill: {
      valType: 'number',
      min: 0,
      max: 1,
      dflt: 1
    }
  },
  slices: isosurfaceAttrs.slices,
  caps: isosurfaceAttrs.caps,
  text: isosurfaceAttrs.text,
  hovertext: isosurfaceAttrs.hovertext,
  xhoverformat: isosurfaceAttrs.xhoverformat,
  yhoverformat: isosurfaceAttrs.yhoverformat,
  zhoverformat: isosurfaceAttrs.zhoverformat,
  valuehoverformat: isosurfaceAttrs.valuehoverformat,
  hovertemplate: isosurfaceAttrs.hovertemplate
}, colorScaleAttrs('', {
  colorAttr: '`value`',
  showScaleDflt: true,
  editTypeOverride: 'calc'
}), {
  colorbar: isosurfaceAttrs.colorbar,
  opacity: isosurfaceAttrs.opacity,
  opacityscale: surfaceAttrs.opacityscale,
  lightposition: isosurfaceAttrs.lightposition,
  lighting: isosurfaceAttrs.lighting,
  flatshading: isosurfaceAttrs.flatshading,
  contour: isosurfaceAttrs.contour,
  hoverinfo: extendFlat({}, baseAttrs.hoverinfo),
  showlegend: extendFlat({}, baseAttrs.showlegend, {
    dflt: false
  })
}), 'calc', 'nested');
attrs.x.editType = attrs.y.editType = attrs.z.editType = attrs.value.editType = 'calc+clearAxisTypes';
attrs.transforms = undefined;

/***/ }),

/***/ 96496:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var createMesh = (__webpack_require__(99098).gl_mesh3d);
var parseColorScale = (__webpack_require__(46998).parseColorScale);
var isArrayOrTypedArray = (__webpack_require__(34809).isArrayOrTypedArray);
var str2RgbaArray = __webpack_require__(55010);
var extractOpts = (__webpack_require__(88856).extractOpts);
var zip3 = __webpack_require__(88239);
var findNearestOnAxis = (__webpack_require__(91370).findNearestOnAxis);
var generateIsoMeshes = (__webpack_require__(91370).generateIsoMeshes);
function VolumeTrace(scene, mesh, uid) {
  this.scene = scene;
  this.uid = uid;
  this.mesh = mesh;
  this.name = '';
  this.data = null;
  this.showContour = false;
}
var proto = VolumeTrace.prototype;
proto.handlePick = function (selection) {
  if (selection.object === this.mesh) {
    var rawId = selection.data.index;
    var x = this.data._meshX[rawId];
    var y = this.data._meshY[rawId];
    var z = this.data._meshZ[rawId];
    var height = this.data._Ys.length;
    var depth = this.data._Zs.length;
    var i = findNearestOnAxis(x, this.data._Xs).id;
    var j = findNearestOnAxis(y, this.data._Ys).id;
    var k = findNearestOnAxis(z, this.data._Zs).id;
    var selectIndex = selection.index = k + depth * j + depth * height * i;
    selection.traceCoordinate = [this.data._meshX[selectIndex], this.data._meshY[selectIndex], this.data._meshZ[selectIndex], this.data._value[selectIndex]];
    var text = this.data.hovertext || this.data.text;
    if (isArrayOrTypedArray(text) && text[selectIndex] !== undefined) {
      selection.textLabel = text[selectIndex];
    } else if (text) {
      selection.textLabel = text;
    }
    return true;
  }
};
proto.update = function (data) {
  var scene = this.scene;
  var layout = scene.fullSceneLayout;
  this.data = generateIsoMeshes(data);

  // Unpack position data
  function toDataCoords(axis, coord, scale, calendar) {
    return coord.map(function (x) {
      return axis.d2l(x, 0, calendar) * scale;
    });
  }
  var positions = zip3(toDataCoords(layout.xaxis, data._meshX, scene.dataScale[0], data.xcalendar), toDataCoords(layout.yaxis, data._meshY, scene.dataScale[1], data.ycalendar), toDataCoords(layout.zaxis, data._meshZ, scene.dataScale[2], data.zcalendar));
  var cells = zip3(data._meshI, data._meshJ, data._meshK);
  var config = {
    positions: positions,
    cells: cells,
    lightPosition: [data.lightposition.x, data.lightposition.y, data.lightposition.z],
    ambient: data.lighting.ambient,
    diffuse: data.lighting.diffuse,
    specular: data.lighting.specular,
    roughness: data.lighting.roughness,
    fresnel: data.lighting.fresnel,
    vertexNormalsEpsilon: data.lighting.vertexnormalsepsilon,
    faceNormalsEpsilon: data.lighting.facenormalsepsilon,
    opacity: data.opacity,
    opacityscale: data.opacityscale,
    contourEnable: data.contour.show,
    contourColor: str2RgbaArray(data.contour.color).slice(0, 3),
    contourWidth: data.contour.width,
    useFacetNormals: data.flatshading
  };
  var cOpts = extractOpts(data);
  config.vertexIntensity = data._meshIntensity;
  config.vertexIntensityBounds = [cOpts.min, cOpts.max];
  config.colormap = parseColorScale(data);

  // Update mesh
  this.mesh.update(config);
};
proto.dispose = function () {
  this.scene.glplot.remove(this.mesh);
  this.mesh.dispose();
};
function createVolumeTrace(scene, data) {
  var gl = scene.glplot.gl;
  var mesh = createMesh({
    gl: gl
  });
  var result = new VolumeTrace(scene, mesh, data.uid);
  mesh._trace = result;
  result.update(data);
  scene.glplot.add(mesh);
  return result;
}
module.exports = createVolumeTrace;

/***/ }),

/***/ 22385:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var attributes = __webpack_require__(51526);
var supplyIsoDefaults = (__webpack_require__(44731).supplyIsoDefaults);
var opacityscaleDefaults = (__webpack_require__(65444).opacityscaleDefaults);
module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
  function coerce(attr, dflt) {
    return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
  }
  supplyIsoDefaults(traceIn, traceOut, defaultColor, layout, coerce);
  opacityscaleDefaults(traceIn, traceOut, layout, coerce);
};

/***/ }),

/***/ 75703:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = {
  attributes: __webpack_require__(51526),
  supplyDefaults: __webpack_require__(22385),
  calc: __webpack_require__(58988),
  colorbar: {
    min: 'cmin',
    max: 'cmax'
  },
  plot: __webpack_require__(96496),
  moduleType: 'trace',
  name: 'volume',
  basePlotModule: __webpack_require__(2487),
  categories: ['gl3d', 'showLegend'],
  meta: {}
};

/***/ }),

/***/ 37832:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var barAttrs = __webpack_require__(81481);
var lineAttrs = (__webpack_require__(36640).line);
var baseAttrs = __webpack_require__(9829);
var axisHoverFormat = (__webpack_require__(80712).axisHoverFormat);
var hovertemplateAttrs = (__webpack_require__(3208)/* .hovertemplateAttrs */ .rb);
var texttemplateAttrs = (__webpack_require__(3208)/* .texttemplateAttrs */ .ay);
var constants = __webpack_require__(82508);
var extendFlat = (__webpack_require__(93049).extendFlat);
var Color = __webpack_require__(78766);
function directionAttrs(dirTxt) {
  return {
    marker: {
      color: extendFlat({}, barAttrs.marker.color, {
        arrayOk: false,
        editType: 'style'
      }),
      line: {
        color: extendFlat({}, barAttrs.marker.line.color, {
          arrayOk: false,
          editType: 'style'
        }),
        width: extendFlat({}, barAttrs.marker.line.width, {
          arrayOk: false,
          editType: 'style'
        }),
        editType: 'style'
      },
      editType: 'style'
    },
    editType: 'style'
  };
}
module.exports = {
  measure: {
    valType: 'data_array',
    dflt: [],
    editType: 'calc'
  },
  base: {
    valType: 'number',
    dflt: null,
    arrayOk: false,
    editType: 'calc'
  },
  x: barAttrs.x,
  x0: barAttrs.x0,
  dx: barAttrs.dx,
  y: barAttrs.y,
  y0: barAttrs.y0,
  dy: barAttrs.dy,
  xperiod: barAttrs.xperiod,
  yperiod: barAttrs.yperiod,
  xperiod0: barAttrs.xperiod0,
  yperiod0: barAttrs.yperiod0,
  xperiodalignment: barAttrs.xperiodalignment,
  yperiodalignment: barAttrs.yperiodalignment,
  xhoverformat: axisHoverFormat('x'),
  yhoverformat: axisHoverFormat('y'),
  hovertext: barAttrs.hovertext,
  hovertemplate: hovertemplateAttrs({}, {
    keys: constants.eventDataKeys
  }),
  hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
    flags: ['name', 'x', 'y', 'text', 'initial', 'delta', 'final']
  }),
  textinfo: {
    valType: 'flaglist',
    flags: ['label', 'text', 'initial', 'delta', 'final'],
    extras: ['none'],
    editType: 'plot',
    arrayOk: false
  },
  // TODO: incorporate `label` and `value` in the eventData
  texttemplate: texttemplateAttrs({
    editType: 'plot'
  }, {
    keys: constants.eventDataKeys.concat(['label'])
  }),
  text: barAttrs.text,
  textposition: barAttrs.textposition,
  insidetextanchor: barAttrs.insidetextanchor,
  textangle: barAttrs.textangle,
  textfont: barAttrs.textfont,
  insidetextfont: barAttrs.insidetextfont,
  outsidetextfont: barAttrs.outsidetextfont,
  constraintext: barAttrs.constraintext,
  cliponaxis: barAttrs.cliponaxis,
  orientation: barAttrs.orientation,
  offset: barAttrs.offset,
  width: barAttrs.width,
  increasing: directionAttrs('increasing'),
  decreasing: directionAttrs('decreasing'),
  totals: directionAttrs('intermediate sums and total'),
  connector: {
    line: {
      color: extendFlat({}, lineAttrs.color, {
        dflt: Color.defaultLine
      }),
      width: extendFlat({}, lineAttrs.width, {
        editType: 'plot' // i.e. to adjust bars is mode: 'between'. See https://github.com/plotly/plotly.js/issues/3787
      }),
      dash: lineAttrs.dash,
      editType: 'plot'
    },
    mode: {
      valType: 'enumerated',
      values: ['spanning', 'between'],
      dflt: 'between',
      editType: 'plot'
    },
    visible: {
      valType: 'boolean',
      dflt: true,
      editType: 'plot'
    },
    editType: 'plot'
  },
  offsetgroup: barAttrs.offsetgroup,
  alignmentgroup: barAttrs.alignmentgroup,
  zorder: barAttrs.zorder
};

/***/ }),

/***/ 15000:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Axes = __webpack_require__(29714);
var alignPeriod = __webpack_require__(40528);
var mergeArray = (__webpack_require__(34809).mergeArray);
var calcSelection = __webpack_require__(48861);
var BADNUM = (__webpack_require__(63821).BADNUM);
function isAbsolute(a) {
  return a === 'a' || a === 'absolute';
}
function isTotal(a) {
  return a === 't' || a === 'total';
}
module.exports = function calc(gd, trace) {
  var xa = Axes.getFromId(gd, trace.xaxis || 'x');
  var ya = Axes.getFromId(gd, trace.yaxis || 'y');
  var size, pos, origPos, pObj, hasPeriod, pLetter;
  if (trace.orientation === 'h') {
    size = xa.makeCalcdata(trace, 'x');
    origPos = ya.makeCalcdata(trace, 'y');
    pObj = alignPeriod(trace, ya, 'y', origPos);
    hasPeriod = !!trace.yperiodalignment;
    pLetter = 'y';
  } else {
    size = ya.makeCalcdata(trace, 'y');
    origPos = xa.makeCalcdata(trace, 'x');
    pObj = alignPeriod(trace, xa, 'x', origPos);
    hasPeriod = !!trace.xperiodalignment;
    pLetter = 'x';
  }
  pos = pObj.vals;

  // create the "calculated data" to plot
  var serieslen = Math.min(pos.length, size.length);
  var cd = new Array(serieslen);

  // set position and size (as well as for waterfall total size)
  var previousSum = 0;
  var newSize;
  // trace-wide flags
  var hasTotals = false;
  for (var i = 0; i < serieslen; i++) {
    var amount = size[i] || 0;
    var connectToNext = false;
    if (size[i] !== BADNUM || isTotal(trace.measure[i]) || isAbsolute(trace.measure[i])) {
      if (i + 1 < serieslen && (size[i + 1] !== BADNUM || isTotal(trace.measure[i + 1]) || isAbsolute(trace.measure[i + 1]))) {
        connectToNext = true;
      }
    }
    var cdi = cd[i] = {
      i: i,
      p: pos[i],
      s: amount,
      rawS: amount,
      cNext: connectToNext
    };
    if (isAbsolute(trace.measure[i])) {
      previousSum = cdi.s;
      cdi.isSum = true;
      cdi.dir = 'totals';
      cdi.s = previousSum;
    } else if (isTotal(trace.measure[i])) {
      cdi.isSum = true;
      cdi.dir = 'totals';
      cdi.s = previousSum;
    } else {
      // default: relative
      cdi.isSum = false;
      cdi.dir = cdi.rawS < 0 ? 'decreasing' : 'increasing';
      newSize = cdi.s;
      cdi.s = previousSum + newSize;
      previousSum += newSize;
    }
    if (cdi.dir === 'totals') {
      hasTotals = true;
    }
    if (hasPeriod) {
      cd[i].orig_p = origPos[i]; // used by hover
      cd[i][pLetter + 'End'] = pObj.ends[i];
      cd[i][pLetter + 'Start'] = pObj.starts[i];
    }
    if (trace.ids) {
      cdi.id = String(trace.ids[i]);
    }
    cdi.v = (trace.base || 0) + previousSum;
  }
  if (cd.length) cd[0].hasTotals = hasTotals;
  mergeArray(trace.text, cd, 'tx');
  mergeArray(trace.hovertext, cd, 'htx');
  calcSelection(cd, trace);
  return cd;
};

/***/ }),

/***/ 82508:
/***/ (function(module) {

"use strict";


module.exports = {
  eventDataKeys: ['initial', 'delta', 'final']
};

/***/ }),

/***/ 9963:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var setGroupPositions = (__webpack_require__(24782).setGroupPositions);
module.exports = function crossTraceCalc(gd, plotinfo) {
  var fullLayout = gd._fullLayout;
  var fullData = gd._fullData;
  var calcdata = gd.calcdata;
  var xa = plotinfo.xaxis;
  var ya = plotinfo.yaxis;
  var waterfalls = [];
  var waterfallsVert = [];
  var waterfallsHorz = [];
  var cd, i;
  for (i = 0; i < fullData.length; i++) {
    var fullTrace = fullData[i];
    if (fullTrace.visible === true && fullTrace.xaxis === xa._id && fullTrace.yaxis === ya._id && fullTrace.type === 'waterfall') {
      cd = calcdata[i];
      if (fullTrace.orientation === 'h') {
        waterfallsHorz.push(cd);
      } else {
        waterfallsVert.push(cd);
      }
      waterfalls.push(cd);
    }
  }
  var opts = {
    mode: fullLayout.waterfallmode,
    norm: fullLayout.waterfallnorm,
    gap: fullLayout.waterfallgap,
    groupgap: fullLayout.waterfallgroupgap
  };
  setGroupPositions(gd, xa, ya, waterfallsVert, opts);
  setGroupPositions(gd, ya, xa, waterfallsHorz, opts);
  for (i = 0; i < waterfalls.length; i++) {
    cd = waterfalls[i];
    for (var j = 0; j < cd.length; j++) {
      var di = cd[j];
      if (di.isSum === false) {
        di.s0 += j === 0 ? 0 : cd[j - 1].s;
      }
      if (j + 1 < cd.length) {
        cd[j].nextP0 = cd[j + 1].p0;
        cd[j].nextS0 = cd[j + 1].s0;
      }
    }
  }
};

/***/ }),

/***/ 67199:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var handleGroupingDefaults = __webpack_require__(36301);
var handleText = (__webpack_require__(17550).handleText);
var handleXYDefaults = __webpack_require__(99867);
var handlePeriodDefaults = __webpack_require__(99669);
var attributes = __webpack_require__(37832);
var Color = __webpack_require__(78766);
var delta = __webpack_require__(20909);
var INCREASING_COLOR = delta.INCREASING.COLOR;
var DECREASING_COLOR = delta.DECREASING.COLOR;
var TOTALS_COLOR = '#4499FF';
function handleDirection(coerce, direction, defaultColor) {
  coerce(direction + '.marker.color', defaultColor);
  coerce(direction + '.marker.line.color', Color.defaultLine);
  coerce(direction + '.marker.line.width');
}
function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
  function coerce(attr, dflt) {
    return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
  }
  var len = handleXYDefaults(traceIn, traceOut, layout, coerce);
  if (!len) {
    traceOut.visible = false;
    return;
  }
  handlePeriodDefaults(traceIn, traceOut, layout, coerce);
  coerce('xhoverformat');
  coerce('yhoverformat');
  coerce('measure');
  coerce('orientation', traceOut.x && !traceOut.y ? 'h' : 'v');
  coerce('base');
  coerce('offset');
  coerce('width');
  coerce('text');
  coerce('hovertext');
  coerce('hovertemplate');
  var textposition = coerce('textposition');
  handleText(traceIn, traceOut, layout, coerce, textposition, {
    moduleHasSelected: false,
    moduleHasUnselected: false,
    moduleHasConstrain: true,
    moduleHasCliponaxis: true,
    moduleHasTextangle: true,
    moduleHasInsideanchor: true
  });
  if (traceOut.textposition !== 'none') {
    coerce('texttemplate');
    if (!traceOut.texttemplate) coerce('textinfo');
  }
  handleDirection(coerce, 'increasing', INCREASING_COLOR);
  handleDirection(coerce, 'decreasing', DECREASING_COLOR);
  handleDirection(coerce, 'totals', TOTALS_COLOR);
  var connectorVisible = coerce('connector.visible');
  if (connectorVisible) {
    coerce('connector.mode');
    var connectorLineWidth = coerce('connector.line.width');
    if (connectorLineWidth) {
      coerce('connector.line.color');
      coerce('connector.line.dash');
    }
  }
  coerce('zorder');
}
function crossTraceDefaults(fullData, fullLayout) {
  var traceIn, traceOut;
  function coerce(attr) {
    return Lib.coerce(traceOut._input, traceOut, attributes, attr);
  }
  if (fullLayout.waterfallmode === 'group') {
    for (var i = 0; i < fullData.length; i++) {
      traceOut = fullData[i];
      traceIn = traceOut._input;
      handleGroupingDefaults(traceIn, traceOut, fullLayout, coerce);
    }
  }
}
module.exports = {
  supplyDefaults: supplyDefaults,
  crossTraceDefaults: crossTraceDefaults
};

/***/ }),

/***/ 64932:
/***/ (function(module) {

"use strict";


module.exports = function eventData(out, pt /* , trace, cd, pointNumber */) {
  // standard cartesian event data
  out.x = 'xVal' in pt ? pt.xVal : pt.x;
  out.y = 'yVal' in pt ? pt.yVal : pt.y;

  // for funnel
  if ('initial' in pt) out.initial = pt.initial;
  if ('delta' in pt) out.delta = pt.delta;
  if ('final' in pt) out.final = pt.final;
  if (pt.xa) out.xaxis = pt.xa;
  if (pt.ya) out.yaxis = pt.ya;
  return out;
};

/***/ }),

/***/ 40943:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var hoverLabelText = (__webpack_require__(29714).hoverLabelText);
var opacity = (__webpack_require__(78766).opacity);
var hoverOnBars = (__webpack_require__(91664).hoverOnBars);
var delta = __webpack_require__(20909);
var DIRSYMBOL = {
  increasing: delta.INCREASING.SYMBOL,
  decreasing: delta.DECREASING.SYMBOL
};
module.exports = function hoverPoints(pointData, xval, yval, hovermode, opts) {
  var point = hoverOnBars(pointData, xval, yval, hovermode, opts);
  if (!point) return;
  var cd = point.cd;
  var trace = cd[0].trace;
  var isHorizontal = trace.orientation === 'h';
  var vLetter = isHorizontal ? 'x' : 'y';
  var vAxis = isHorizontal ? pointData.xa : pointData.ya;
  function formatNumber(a) {
    return hoverLabelText(vAxis, a, trace[vLetter + 'hoverformat']);
  }

  // the closest data point
  var index = point.index;
  var di = cd[index];
  var size = di.isSum ? di.b + di.s : di.rawS;
  point.initial = di.b + di.s - size;
  point.delta = size;
  point.final = point.initial + point.delta;
  var v = formatNumber(Math.abs(point.delta));
  point.deltaLabel = size < 0 ? '(' + v + ')' : v;
  point.finalLabel = formatNumber(point.final);
  point.initialLabel = formatNumber(point.initial);
  var hoverinfo = di.hi || trace.hoverinfo;
  var text = [];
  if (hoverinfo && hoverinfo !== 'none' && hoverinfo !== 'skip') {
    var isAll = hoverinfo === 'all';
    var parts = hoverinfo.split('+');
    var hasFlag = function (flag) {
      return isAll || parts.indexOf(flag) !== -1;
    };
    if (!di.isSum) {
      if (hasFlag('final') && (isHorizontal ? !hasFlag('x') : !hasFlag('y')) // don't display redundant info.
      ) {
        text.push(point.finalLabel);
      }
      if (hasFlag('delta')) {
        if (size < 0) {
          text.push(point.deltaLabel + ' ' + DIRSYMBOL.decreasing);
        } else {
          text.push(point.deltaLabel + ' ' + DIRSYMBOL.increasing);
        }
      }
      if (hasFlag('initial')) {
        text.push('Initial: ' + point.initialLabel);
      }
    }
  }
  if (text.length) point.extraText = text.join('<br>');
  point.color = getTraceColor(trace, di);
  return [point];
};
function getTraceColor(trace, di) {
  var cont = trace[di.dir].marker;
  var mc = cont.color;
  var mlc = cont.line.color;
  var mlw = cont.line.width;
  if (opacity(mc)) return mc;else if (opacity(mlc) && mlw) return mlc;
}

/***/ }),

/***/ 38261:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = {
  attributes: __webpack_require__(37832),
  layoutAttributes: __webpack_require__(579),
  supplyDefaults: (__webpack_require__(67199).supplyDefaults),
  crossTraceDefaults: (__webpack_require__(67199).crossTraceDefaults),
  supplyLayoutDefaults: __webpack_require__(71492),
  calc: __webpack_require__(15000),
  crossTraceCalc: __webpack_require__(9963),
  plot: __webpack_require__(71130),
  style: (__webpack_require__(57256).style),
  hoverPoints: __webpack_require__(40943),
  eventData: __webpack_require__(64932),
  selectPoints: __webpack_require__(88384),
  moduleType: 'trace',
  name: 'waterfall',
  basePlotModule: __webpack_require__(37703),
  categories: ['bar-like', 'cartesian', 'svg', 'oriented', 'showLegend', 'zoomScale'],
  meta: {}
};

/***/ }),

/***/ 579:
/***/ (function(module) {

"use strict";


module.exports = {
  waterfallmode: {
    valType: 'enumerated',
    values: ['group', 'overlay'],
    dflt: 'group',
    editType: 'calc'
  },
  waterfallgap: {
    valType: 'number',
    min: 0,
    max: 1,
    editType: 'calc'
  },
  waterfallgroupgap: {
    valType: 'number',
    min: 0,
    max: 1,
    dflt: 0,
    editType: 'calc'
  }
};

/***/ }),

/***/ 71492:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var layoutAttributes = __webpack_require__(579);
module.exports = function (layoutIn, layoutOut, fullData) {
  var hasTraceType = false;
  function coerce(attr, dflt) {
    return Lib.coerce(layoutIn, layoutOut, layoutAttributes, attr, dflt);
  }
  for (var i = 0; i < fullData.length; i++) {
    var trace = fullData[i];
    if (trace.visible && trace.type === 'waterfall') {
      hasTraceType = true;
      break;
    }
  }
  if (hasTraceType) {
    coerce('waterfallmode');
    coerce('waterfallgap', 0.2);
    coerce('waterfallgroupgap');
  }
};

/***/ }),

/***/ 71130:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var Lib = __webpack_require__(34809);
var Drawing = __webpack_require__(62203);
var BADNUM = (__webpack_require__(63821).BADNUM);
var barPlot = __webpack_require__(32995);
var clearMinTextSize = (__webpack_require__(84102).clearMinTextSize);
module.exports = function plot(gd, plotinfo, cdModule, traceLayer) {
  var fullLayout = gd._fullLayout;
  clearMinTextSize('waterfall', fullLayout);
  barPlot.plot(gd, plotinfo, cdModule, traceLayer, {
    mode: fullLayout.waterfallmode,
    norm: fullLayout.waterfallmode,
    gap: fullLayout.waterfallgap,
    groupgap: fullLayout.waterfallgroupgap
  });
  plotConnectors(gd, plotinfo, cdModule, traceLayer);
};
function plotConnectors(gd, plotinfo, cdModule, traceLayer) {
  var xa = plotinfo.xaxis;
  var ya = plotinfo.yaxis;
  Lib.makeTraceGroups(traceLayer, cdModule, 'trace bars').each(function (cd) {
    var plotGroup = d3.select(this);
    var trace = cd[0].trace;
    var group = Lib.ensureSingle(plotGroup, 'g', 'lines');
    if (!trace.connector || !trace.connector.visible) {
      group.remove();
      return;
    }
    var isHorizontal = trace.orientation === 'h';
    var mode = trace.connector.mode;
    var connectors = group.selectAll('g.line').data(Lib.identity);
    connectors.enter().append('g').classed('line', true);
    connectors.exit().remove();
    var len = connectors.size();
    connectors.each(function (di, i) {
      // don't draw lines between nulls
      if (i !== len - 1 && !di.cNext) return;
      var xy = getXY(di, xa, ya, isHorizontal);
      var x = xy[0];
      var y = xy[1];
      var shape = '';
      if (x[0] !== BADNUM && y[0] !== BADNUM && x[1] !== BADNUM && y[1] !== BADNUM) {
        if (mode === 'spanning') {
          if (!di.isSum && i > 0) {
            if (isHorizontal) {
              shape += 'M' + x[0] + ',' + y[1] + 'V' + y[0];
            } else {
              shape += 'M' + x[1] + ',' + y[0] + 'H' + x[0];
            }
          }
        }
        if (mode !== 'between') {
          if (di.isSum || i < len - 1) {
            if (isHorizontal) {
              shape += 'M' + x[1] + ',' + y[0] + 'V' + y[1];
            } else {
              shape += 'M' + x[0] + ',' + y[1] + 'H' + x[1];
            }
          }
        }
        if (x[2] !== BADNUM && y[2] !== BADNUM) {
          if (isHorizontal) {
            shape += 'M' + x[1] + ',' + y[1] + 'V' + y[2];
          } else {
            shape += 'M' + x[1] + ',' + y[1] + 'H' + x[2];
          }
        }
      }
      if (shape === '') shape = 'M0,0Z';
      Lib.ensureSingle(d3.select(this), 'path').attr('d', shape).call(Drawing.setClipUrl, plotinfo.layerClipId, gd);
    });
  });
}
function getXY(di, xa, ya, isHorizontal) {
  var s = [];
  var p = [];
  var sAxis = isHorizontal ? xa : ya;
  var pAxis = isHorizontal ? ya : xa;
  s[0] = sAxis.c2p(di.s0, true);
  p[0] = pAxis.c2p(di.p0, true);
  s[1] = sAxis.c2p(di.s1, true);
  p[1] = pAxis.c2p(di.p1, true);
  s[2] = sAxis.c2p(di.nextS0, true);
  p[2] = pAxis.c2p(di.nextP0, true);
  return isHorizontal ? [s, p] : [p, s];
}

/***/ }),

/***/ 57256:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d3 = __webpack_require__(45568);
var Drawing = __webpack_require__(62203);
var Color = __webpack_require__(78766);
var DESELECTDIM = (__webpack_require__(20438).DESELECTDIM);
var barStyle = __webpack_require__(6851);
var resizeText = (__webpack_require__(84102).resizeText);
var styleTextPoints = barStyle.styleTextPoints;
function style(gd, cd, sel) {
  var s = sel ? sel : d3.select(gd).selectAll('g[class^="waterfalllayer"]').selectAll('g.trace');
  resizeText(gd, s, 'waterfall');
  s.style('opacity', function (d) {
    return d[0].trace.opacity;
  });
  s.each(function (d) {
    var gTrace = d3.select(this);
    var trace = d[0].trace;
    gTrace.selectAll('.point > path').each(function (di) {
      if (!di.isBlank) {
        var cont = trace[di.dir].marker;
        d3.select(this).call(Color.fill, cont.color).call(Color.stroke, cont.line.color).call(Drawing.dashLine, cont.line.dash, cont.line.width).style('opacity', trace.selectedpoints && !di.selected ? DESELECTDIM : 1);
      }
    });
    styleTextPoints(gTrace, trace, gd);
    gTrace.selectAll('.lines').each(function () {
      var cont = trace.connector.line;
      Drawing.lineGroupStyle(d3.select(this).selectAll('path'), cont.width, cont.color, cont.dash);
    });
  });
}
module.exports = {
  style: style
};

/***/ }),

/***/ 47908:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var Axes = __webpack_require__(29714);
var Lib = __webpack_require__(34809);
var PlotSchema = __webpack_require__(57297);
var pointsAccessorFunction = (__webpack_require__(5086)/* .pointsAccessorFunction */ .z);
var BADNUM = (__webpack_require__(63821).BADNUM);
exports.moduleType = 'transform';
exports.name = 'aggregate';
var attrs = exports.attributes = {
  enabled: {
    valType: 'boolean',
    dflt: true,
    editType: 'calc'
  },
  groups: {
    // TODO: groupby should support string or array grouping this way too
    // currently groupby only allows a grouping array
    valType: 'string',
    strict: true,
    noBlank: true,
    arrayOk: true,
    dflt: 'x',
    editType: 'calc'
  },
  aggregations: {
    _isLinkedToArray: 'aggregation',
    target: {
      valType: 'string',
      editType: 'calc'
    },
    func: {
      valType: 'enumerated',
      values: ['count', 'sum', 'avg', 'median', 'mode', 'rms', 'stddev', 'min', 'max', 'first', 'last', 'change', 'range'],
      dflt: 'first',
      editType: 'calc'
    },
    funcmode: {
      valType: 'enumerated',
      values: ['sample', 'population'],
      dflt: 'sample',
      editType: 'calc'
    },
    enabled: {
      valType: 'boolean',
      dflt: true,
      editType: 'calc'
    },
    editType: 'calc'
  },
  editType: 'calc'
};
var aggAttrs = attrs.aggregations;

/**
 * Supply transform attributes defaults
 *
 * @param {object} transformIn
 *  object linked to trace.transforms[i] with 'func' set to exports.name
 * @param {object} traceOut
 *  the _fullData trace this transform applies to
 * @param {object} layout
 *  the plot's (not-so-full) layout
 * @param {object} traceIn
 *  the input data trace this transform applies to
 *
 * @return {object} transformOut
 *  copy of transformIn that contains attribute defaults
 */
exports.supplyDefaults = function (transformIn, traceOut) {
  var transformOut = {};
  var i;
  function coerce(attr, dflt) {
    return Lib.coerce(transformIn, transformOut, attrs, attr, dflt);
  }
  var enabled = coerce('enabled');
  if (!enabled) return transformOut;

  /*
   * Normally _arrayAttrs is calculated during doCalc, but that comes later.
   * Anyway this can change due to *count* aggregations (see below) so it's not
   * necessarily the same set.
   *
   * For performance we turn it into an object of truthy values
   * we'll use 1 for arrays we haven't aggregated yet, 0 for finished arrays,
   * as distinct from undefined which means this array isn't present in the input
   * missing arrays can still be aggregate outputs for *count* aggregations.
   */
  var arrayAttrArray = PlotSchema.findArrayAttributes(traceOut);
  var arrayAttrs = {};
  for (i = 0; i < arrayAttrArray.length; i++) arrayAttrs[arrayAttrArray[i]] = 1;
  var groups = coerce('groups');
  if (!Array.isArray(groups)) {
    if (!arrayAttrs[groups]) {
      transformOut.enabled = false;
      return transformOut;
    }
    arrayAttrs[groups] = 0;
  }
  var aggregationsIn = transformIn.aggregations || [];
  var aggregationsOut = transformOut.aggregations = new Array(aggregationsIn.length);
  var aggregationOut;
  function coercei(attr, dflt) {
    return Lib.coerce(aggregationsIn[i], aggregationOut, aggAttrs, attr, dflt);
  }
  for (i = 0; i < aggregationsIn.length; i++) {
    aggregationOut = {
      _index: i
    };
    var target = coercei('target');
    var func = coercei('func');
    var enabledi = coercei('enabled');

    // add this aggregation to the output only if it's the first instance
    // of a valid target attribute - or an unused target attribute with "count"
    if (enabledi && target && (arrayAttrs[target] || func === 'count' && arrayAttrs[target] === undefined)) {
      if (func === 'stddev') coercei('funcmode');
      arrayAttrs[target] = 0;
      aggregationsOut[i] = aggregationOut;
    } else aggregationsOut[i] = {
      enabled: false,
      _index: i
    };
  }

  // any array attributes we haven't yet covered, fill them with the default aggregation
  for (i = 0; i < arrayAttrArray.length; i++) {
    if (arrayAttrs[arrayAttrArray[i]]) {
      aggregationsOut.push({
        target: arrayAttrArray[i],
        func: aggAttrs.func.dflt,
        enabled: true,
        _index: -1
      });
    }
  }
  return transformOut;
};
exports.calcTransform = function (gd, trace, opts) {
  if (!opts.enabled) return;
  var groups = opts.groups;
  var groupArray = Lib.getTargetArray(trace, {
    target: groups
  });
  if (!groupArray) return;
  var i, vi, groupIndex, newGrouping;
  var groupIndices = {};
  var indexToPoints = {};
  var groupings = [];
  var originalPointsAccessor = pointsAccessorFunction(trace.transforms, opts);
  var len = groupArray.length;
  if (trace._length) len = Math.min(len, trace._length);
  for (i = 0; i < len; i++) {
    vi = groupArray[i];
    groupIndex = groupIndices[vi];
    if (groupIndex === undefined) {
      groupIndices[vi] = groupings.length;
      newGrouping = [i];
      groupings.push(newGrouping);
      indexToPoints[groupIndices[vi]] = originalPointsAccessor(i);
    } else {
      groupings[groupIndex].push(i);
      indexToPoints[groupIndices[vi]] = (indexToPoints[groupIndices[vi]] || []).concat(originalPointsAccessor(i));
    }
  }
  opts._indexToPoints = indexToPoints;
  var aggregations = opts.aggregations;
  for (i = 0; i < aggregations.length; i++) {
    aggregateOneArray(gd, trace, groupings, aggregations[i]);
  }
  if (typeof groups === 'string') {
    aggregateOneArray(gd, trace, groupings, {
      target: groups,
      func: 'first',
      enabled: true
    });
  }
  trace._length = groupings.length;
};
function aggregateOneArray(gd, trace, groupings, aggregation) {
  if (!aggregation.enabled) return;
  var attr = aggregation.target;
  var targetNP = Lib.nestedProperty(trace, attr);
  var arrayIn = targetNP.get();
  var conversions = Axes.getDataConversions(gd, trace, attr, arrayIn);
  var func = getAggregateFunction(aggregation, conversions);
  var arrayOut = new Array(groupings.length);
  for (var i = 0; i < groupings.length; i++) {
    arrayOut[i] = func(arrayIn, groupings[i]);
  }
  targetNP.set(arrayOut);
  if (aggregation.func === 'count') {
    // count does not depend on an input array, so it's likely not part of _arrayAttrs yet
    // but after this transform it most definitely *is* an array attribute.
    Lib.pushUnique(trace._arrayAttrs, attr);
  }
}
function getAggregateFunction(opts, conversions) {
  var func = opts.func;
  var d2c = conversions.d2c;
  var c2d = conversions.c2d;
  switch (func) {
    // count, first, and last don't depend on anything about the data
    // point back to pure functions for performance
    case 'count':
      return count;
    case 'first':
      return first;
    case 'last':
      return last;
    case 'sum':
      // This will produce output in all cases even though it's nonsensical
      // for date or category data.
      return function (array, indices) {
        var total = 0;
        for (var i = 0; i < indices.length; i++) {
          var vi = d2c(array[indices[i]]);
          if (vi !== BADNUM) total += vi;
        }
        return c2d(total);
      };
    case 'avg':
      // Generally meaningless for category data but it still does something.
      return function (array, indices) {
        var total = 0;
        var cnt = 0;
        for (var i = 0; i < indices.length; i++) {
          var vi = d2c(array[indices[i]]);
          if (vi !== BADNUM) {
            total += vi;
            cnt++;
          }
        }
        return cnt ? c2d(total / cnt) : BADNUM;
      };
    case 'min':
      return function (array, indices) {
        var out = Infinity;
        for (var i = 0; i < indices.length; i++) {
          var vi = d2c(array[indices[i]]);
          if (vi !== BADNUM) out = Math.min(out, vi);
        }
        return out === Infinity ? BADNUM : c2d(out);
      };
    case 'max':
      return function (array, indices) {
        var out = -Infinity;
        for (var i = 0; i < indices.length; i++) {
          var vi = d2c(array[indices[i]]);
          if (vi !== BADNUM) out = Math.max(out, vi);
        }
        return out === -Infinity ? BADNUM : c2d(out);
      };
    case 'range':
      return function (array, indices) {
        var min = Infinity;
        var max = -Infinity;
        for (var i = 0; i < indices.length; i++) {
          var vi = d2c(array[indices[i]]);
          if (vi !== BADNUM) {
            min = Math.min(min, vi);
            max = Math.max(max, vi);
          }
        }
        return max === -Infinity || min === Infinity ? BADNUM : c2d(max - min);
      };
    case 'change':
      return function (array, indices) {
        var first = d2c(array[indices[0]]);
        var last = d2c(array[indices[indices.length - 1]]);
        return first === BADNUM || last === BADNUM ? BADNUM : c2d(last - first);
      };
    case 'median':
      return function (array, indices) {
        var sortCalc = [];
        for (var i = 0; i < indices.length; i++) {
          var vi = d2c(array[indices[i]]);
          if (vi !== BADNUM) sortCalc.push(vi);
        }
        if (!sortCalc.length) return BADNUM;
        sortCalc.sort(Lib.sorterAsc);
        var mid = (sortCalc.length - 1) / 2;
        return c2d((sortCalc[Math.floor(mid)] + sortCalc[Math.ceil(mid)]) / 2);
      };
    case 'mode':
      return function (array, indices) {
        var counts = {};
        var maxCnt = 0;
        var out = BADNUM;
        for (var i = 0; i < indices.length; i++) {
          var vi = d2c(array[indices[i]]);
          if (vi !== BADNUM) {
            var counti = counts[vi] = (counts[vi] || 0) + 1;
            if (counti > maxCnt) {
              maxCnt = counti;
              out = vi;
            }
          }
        }
        return maxCnt ? c2d(out) : BADNUM;
      };
    case 'rms':
      return function (array, indices) {
        var total = 0;
        var cnt = 0;
        for (var i = 0; i < indices.length; i++) {
          var vi = d2c(array[indices[i]]);
          if (vi !== BADNUM) {
            total += vi * vi;
            cnt++;
          }
        }
        return cnt ? c2d(Math.sqrt(total / cnt)) : BADNUM;
      };
    case 'stddev':
      return function (array, indices) {
        // balance numerical stability with performance:
        // so that we call d2c once per element but don't need to
        // store them, reference all to the first element
        var total = 0;
        var total2 = 0;
        var cnt = 1;
        var v0 = BADNUM;
        var i;
        for (i = 0; i < indices.length && v0 === BADNUM; i++) {
          v0 = d2c(array[indices[i]]);
        }
        if (v0 === BADNUM) return BADNUM;
        for (; i < indices.length; i++) {
          var vi = d2c(array[indices[i]]);
          if (vi !== BADNUM) {
            var dv = vi - v0;
            total += dv;
            total2 += dv * dv;
            cnt++;
          }
        }

        // This is population std dev, if we want sample std dev
        // we would need (...) / (cnt - 1)
        // Also note there's no c2d here - that means for dates the result
        // is a number of milliseconds, and for categories it's a number
        // of category differences, which is not generically meaningful but
        // as in other cases we don't forbid it.
        var norm = opts.funcmode === 'sample' ? cnt - 1 : cnt;
        // this is debatable: should a count of 1 return sample stddev of
        // 0 or undefined?
        if (!norm) return 0;
        return Math.sqrt((total2 - total * total / cnt) / norm);
      };
  }
}
function count(array, indices) {
  return indices.length;
}
function first(array, indices) {
  return array[indices[0]];
}
function last(array, indices) {
  return array[indices[indices.length - 1]];
}

/***/ }),

/***/ 42849:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var Registry = __webpack_require__(33626);
var Axes = __webpack_require__(29714);
var pointsAccessorFunction = (__webpack_require__(5086)/* .pointsAccessorFunction */ .z);
var filterOps = __webpack_require__(20726);
var COMPARISON_OPS = filterOps.COMPARISON_OPS;
var INTERVAL_OPS = filterOps.INTERVAL_OPS;
var SET_OPS = filterOps.SET_OPS;
exports.moduleType = 'transform';
exports.name = 'filter';
exports.attributes = {
  enabled: {
    valType: 'boolean',
    dflt: true,
    editType: 'calc'
  },
  target: {
    valType: 'string',
    strict: true,
    noBlank: true,
    arrayOk: true,
    dflt: 'x',
    editType: 'calc'
  },
  operation: {
    valType: 'enumerated',
    values: [].concat(COMPARISON_OPS).concat(INTERVAL_OPS).concat(SET_OPS),
    dflt: '=',
    editType: 'calc'
  },
  value: {
    valType: 'any',
    dflt: 0,
    editType: 'calc'
  },
  preservegaps: {
    valType: 'boolean',
    dflt: false,
    editType: 'calc'
  },
  editType: 'calc'
};
exports.supplyDefaults = function (transformIn) {
  var transformOut = {};
  function coerce(attr, dflt) {
    return Lib.coerce(transformIn, transformOut, exports.attributes, attr, dflt);
  }
  var enabled = coerce('enabled');
  if (enabled) {
    var target = coerce('target');
    if (Lib.isArrayOrTypedArray(target) && target.length === 0) {
      transformOut.enabled = false;
      return transformOut;
    }
    coerce('preservegaps');
    coerce('operation');
    coerce('value');
    var handleCalendarDefaults = Registry.getComponentMethod('calendars', 'handleDefaults');
    handleCalendarDefaults(transformIn, transformOut, 'valuecalendar', null);
    handleCalendarDefaults(transformIn, transformOut, 'targetcalendar', null);
  }
  return transformOut;
};
exports.calcTransform = function (gd, trace, opts) {
  if (!opts.enabled) return;
  var targetArray = Lib.getTargetArray(trace, opts);
  if (!targetArray) return;
  var target = opts.target;
  var len = targetArray.length;
  if (trace._length) len = Math.min(len, trace._length);
  var targetCalendar = opts.targetcalendar;
  var arrayAttrs = trace._arrayAttrs;
  var preservegaps = opts.preservegaps;

  // even if you provide targetcalendar, if target is a string and there
  // is a calendar attribute matching target it will get used instead.
  if (typeof target === 'string') {
    var attrTargetCalendar = Lib.nestedProperty(trace, target + 'calendar').get();
    if (attrTargetCalendar) targetCalendar = attrTargetCalendar;
  }
  var d2c = Axes.getDataToCoordFunc(gd, trace, target, targetArray);
  var filterFunc = getFilterFunc(opts, d2c, targetCalendar);
  var originalArrays = {};
  var indexToPoints = {};
  var index = 0;
  function forAllAttrs(fn, index) {
    for (var j = 0; j < arrayAttrs.length; j++) {
      var np = Lib.nestedProperty(trace, arrayAttrs[j]);
      fn(np, index);
    }
  }
  var initFn;
  var fillFn;
  if (preservegaps) {
    initFn = function (np) {
      originalArrays[np.astr] = Lib.extendDeep([], np.get());
      np.set(new Array(len));
    };
    fillFn = function (np, index) {
      var val = originalArrays[np.astr][index];
      np.get()[index] = val;
    };
  } else {
    initFn = function (np) {
      originalArrays[np.astr] = Lib.extendDeep([], np.get());
      np.set([]);
    };
    fillFn = function (np, index) {
      var val = originalArrays[np.astr][index];
      np.get().push(val);
    };
  }

  // copy all original array attribute values, and clear arrays in trace
  forAllAttrs(initFn);
  var originalPointsAccessor = pointsAccessorFunction(trace.transforms, opts);

  // loop through filter array, fill trace arrays if passed
  for (var i = 0; i < len; i++) {
    var passed = filterFunc(targetArray[i]);
    if (passed) {
      forAllAttrs(fillFn, i);
      indexToPoints[index++] = originalPointsAccessor(i);
    } else if (preservegaps) index++;
  }
  opts._indexToPoints = indexToPoints;
  trace._length = index;
};
function getFilterFunc(opts, d2c, targetCalendar) {
  var operation = opts.operation;
  var value = opts.value;
  var hasArrayValue = Lib.isArrayOrTypedArray(value);
  function isOperationIn(array) {
    return array.indexOf(operation) !== -1;
  }
  var d2cValue = function (v) {
    return d2c(v, 0, opts.valuecalendar);
  };
  var d2cTarget = function (v) {
    return d2c(v, 0, targetCalendar);
  };
  var coercedValue;
  if (isOperationIn(COMPARISON_OPS)) {
    coercedValue = hasArrayValue ? d2cValue(value[0]) : d2cValue(value);
  } else if (isOperationIn(INTERVAL_OPS)) {
    coercedValue = hasArrayValue ? [d2cValue(value[0]), d2cValue(value[1])] : [d2cValue(value), d2cValue(value)];
  } else if (isOperationIn(SET_OPS)) {
    coercedValue = hasArrayValue ? value.map(d2cValue) : [d2cValue(value)];
  }
  switch (operation) {
    case '=':
      return function (v) {
        return d2cTarget(v) === coercedValue;
      };
    case '!=':
      return function (v) {
        return d2cTarget(v) !== coercedValue;
      };
    case '<':
      return function (v) {
        return d2cTarget(v) < coercedValue;
      };
    case '<=':
      return function (v) {
        return d2cTarget(v) <= coercedValue;
      };
    case '>':
      return function (v) {
        return d2cTarget(v) > coercedValue;
      };
    case '>=':
      return function (v) {
        return d2cTarget(v) >= coercedValue;
      };
    case '[]':
      return function (v) {
        var cv = d2cTarget(v);
        return cv >= coercedValue[0] && cv <= coercedValue[1];
      };
    case '()':
      return function (v) {
        var cv = d2cTarget(v);
        return cv > coercedValue[0] && cv < coercedValue[1];
      };
    case '[)':
      return function (v) {
        var cv = d2cTarget(v);
        return cv >= coercedValue[0] && cv < coercedValue[1];
      };
    case '(]':
      return function (v) {
        var cv = d2cTarget(v);
        return cv > coercedValue[0] && cv <= coercedValue[1];
      };
    case '][':
      return function (v) {
        var cv = d2cTarget(v);
        return cv <= coercedValue[0] || cv >= coercedValue[1];
      };
    case ')(':
      return function (v) {
        var cv = d2cTarget(v);
        return cv < coercedValue[0] || cv > coercedValue[1];
      };
    case '](':
      return function (v) {
        var cv = d2cTarget(v);
        return cv <= coercedValue[0] || cv > coercedValue[1];
      };
    case ')[':
      return function (v) {
        var cv = d2cTarget(v);
        return cv < coercedValue[0] || cv >= coercedValue[1];
      };
    case '{}':
      return function (v) {
        return coercedValue.indexOf(d2cTarget(v)) !== -1;
      };
    case '}{':
      return function (v) {
        return coercedValue.indexOf(d2cTarget(v)) === -1;
      };
  }
}

/***/ }),

/***/ 50453:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var PlotSchema = __webpack_require__(57297);
var Plots = __webpack_require__(44122);
var pointsAccessorFunction = (__webpack_require__(5086)/* .pointsAccessorFunction */ .z);
exports.moduleType = 'transform';
exports.name = 'groupby';
exports.attributes = {
  enabled: {
    valType: 'boolean',
    dflt: true,
    editType: 'calc'
  },
  groups: {
    valType: 'data_array',
    dflt: [],
    editType: 'calc'
  },
  nameformat: {
    valType: 'string',
    editType: 'calc'
  },
  styles: {
    _isLinkedToArray: 'style',
    target: {
      valType: 'string',
      editType: 'calc'
    },
    value: {
      valType: 'any',
      dflt: {},
      editType: 'calc',
      _compareAsJSON: true
    },
    editType: 'calc'
  },
  editType: 'calc'
};

/**
 * Supply transform attributes defaults
 *
 * @param {object} transformIn
 *  object linked to trace.transforms[i] with 'type' set to exports.name
 * @param {object} traceOut
 *  the _fullData trace this transform applies to
 * @param {object} layout
 *  the plot's (not-so-full) layout
 * @param {object} traceIn
 *  the input data trace this transform applies to
 *
 * @return {object} transformOut
 *  copy of transformIn that contains attribute defaults
 */
exports.supplyDefaults = function (transformIn, traceOut, layout) {
  var i;
  var transformOut = {};
  function coerce(attr, dflt) {
    return Lib.coerce(transformIn, transformOut, exports.attributes, attr, dflt);
  }
  var enabled = coerce('enabled');
  if (!enabled) return transformOut;
  coerce('groups');
  coerce('nameformat', layout._dataLength > 1 ? '%{group} (%{trace})' : '%{group}');
  var styleIn = transformIn.styles;
  var styleOut = transformOut.styles = [];
  if (styleIn) {
    for (i = 0; i < styleIn.length; i++) {
      var thisStyle = styleOut[i] = {};
      Lib.coerce(styleIn[i], styleOut[i], exports.attributes.styles, 'target');
      var value = Lib.coerce(styleIn[i], styleOut[i], exports.attributes.styles, 'value');

      // so that you can edit value in place and have Plotly.react notice it, or
      // rebuild it every time and have Plotly.react NOT think it changed:
      // use _compareAsJSON to say we should diff the _JSON_value
      if (Lib.isPlainObject(value)) thisStyle.value = Lib.extendDeep({}, value);else if (value) delete thisStyle.value;
    }
  }
  return transformOut;
};

/**
 * Apply transform !!!
 *
 * @param {array} data
 *  array of transformed traces (is [fullTrace] upon first transform)
 *
 * @param {object} state
 *  state object which includes:
 *      - transform {object} full transform attributes
 *      - fullTrace {object} full trace object which is being transformed
 *      - fullData {array} full pre-transform(s) data array
 *      - layout {object} the plot's (not-so-full) layout
 *
 * @return {object} newData
 *  array of transformed traces
 */
exports.transform = function (data, state) {
  var newTraces, i, j;
  var newData = [];
  for (i = 0; i < data.length; i++) {
    newTraces = transformOne(data[i], state);
    for (j = 0; j < newTraces.length; j++) {
      newData.push(newTraces[j]);
    }
  }
  return newData;
};
function transformOne(trace, state) {
  var i, j, k, attr, srcArray, groupName, newTrace, transforms, arrayLookup;
  var groupNameObj;
  var opts = state.transform;
  var transformIndex = state.transformIndex;
  var groups = trace.transforms[transformIndex].groups;
  var originalPointsAccessor = pointsAccessorFunction(trace.transforms, opts);
  if (!Lib.isArrayOrTypedArray(groups) || groups.length === 0) {
    return [trace];
  }
  var groupNames = Lib.filterUnique(groups);
  var newData = new Array(groupNames.length);
  var len = groups.length;
  var arrayAttrs = PlotSchema.findArrayAttributes(trace);
  var styles = opts.styles || [];
  var styleLookup = {};
  for (i = 0; i < styles.length; i++) {
    styleLookup[styles[i].target] = styles[i].value;
  }
  if (opts.styles) {
    groupNameObj = Lib.keyedContainer(opts, 'styles', 'target', 'value.name');
  }

  // An index to map group name --> expanded trace index
  var indexLookup = {};
  var indexCnts = {};
  for (i = 0; i < groupNames.length; i++) {
    groupName = groupNames[i];
    indexLookup[groupName] = i;
    indexCnts[groupName] = 0;

    // Start with a deep extend that just copies array references.
    newTrace = newData[i] = Lib.extendDeepNoArrays({}, trace);
    newTrace._group = groupName;
    newTrace.transforms[transformIndex]._indexToPoints = {};
    var suppliedName = null;
    if (groupNameObj) {
      suppliedName = groupNameObj.get(groupName);
    }
    if (suppliedName || suppliedName === '') {
      newTrace.name = suppliedName;
    } else {
      newTrace.name = Lib.templateString(opts.nameformat, {
        trace: trace.name,
        group: groupName
      });
    }

    // In order for groups to apply correctly to other transform data (e.g.
    // a filter transform), we have to break the connection and clone the
    // transforms so that each group writes grouped values into a different
    // destination. This function does not break the array reference
    // connection between the split transforms it creates. That's handled in
    // initialize, which creates a new empty array for each arrayAttr.
    transforms = newTrace.transforms;
    newTrace.transforms = [];
    for (j = 0; j < transforms.length; j++) {
      newTrace.transforms[j] = Lib.extendDeepNoArrays({}, transforms[j]);
    }

    // Initialize empty arrays for the arrayAttrs, to be split in the next step
    for (j = 0; j < arrayAttrs.length; j++) {
      Lib.nestedProperty(newTrace, arrayAttrs[j]).set([]);
    }
  }

  // For each array attribute including those nested inside this and other
  // transforms (small note that we technically only need to do this for
  // transforms that have not yet been applied):
  for (k = 0; k < arrayAttrs.length; k++) {
    attr = arrayAttrs[k];

    // Cache all the arrays to which we'll push:
    for (j = 0, arrayLookup = []; j < groupNames.length; j++) {
      arrayLookup[j] = Lib.nestedProperty(newData[j], attr).get();
    }

    // Get the input data:
    srcArray = Lib.nestedProperty(trace, attr).get();

    // Send each data point to the appropriate expanded trace:
    for (j = 0; j < len; j++) {
      // Map group data --> trace index --> array and push data onto it
      arrayLookup[indexLookup[groups[j]]].push(srcArray[j]);
    }
  }
  for (j = 0; j < len; j++) {
    newTrace = newData[indexLookup[groups[j]]];
    var indexToPoints = newTrace.transforms[transformIndex]._indexToPoints;
    indexToPoints[indexCnts[groups[j]]] = originalPointsAccessor(j);
    indexCnts[groups[j]]++;
  }
  for (i = 0; i < groupNames.length; i++) {
    groupName = groupNames[i];
    newTrace = newData[i];
    Plots.clearExpandedTraceDefaultColors(newTrace);

    // there's no need to coerce styleLookup[groupName] here
    // as another round of supplyDefaults is done on the transformed traces
    newTrace = Lib.extendDeepNoArrays(newTrace, styleLookup[groupName] || {});
  }
  return newData;
}

/***/ }),

/***/ 5086:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


exports.z = function (transforms, opts) {
  var tr;
  var prevIndexToPoints;
  for (var i = 0; i < transforms.length; i++) {
    tr = transforms[i];
    if (tr === opts) break;
    if (!tr._indexToPoints || tr.enabled === false) continue;
    prevIndexToPoints = tr._indexToPoints;
  }
  var originalPointsAccessor = prevIndexToPoints ? function (i) {
    return prevIndexToPoints[i];
  } : function (i) {
    return [i];
  };
  return originalPointsAccessor;
};

/***/ }),

/***/ 99855:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var Lib = __webpack_require__(34809);
var Axes = __webpack_require__(29714);
var pointsAccessorFunction = (__webpack_require__(5086)/* .pointsAccessorFunction */ .z);
var BADNUM = (__webpack_require__(63821).BADNUM);
exports.moduleType = 'transform';
exports.name = 'sort';
exports.attributes = {
  enabled: {
    valType: 'boolean',
    dflt: true,
    editType: 'calc'
  },
  target: {
    valType: 'string',
    strict: true,
    noBlank: true,
    arrayOk: true,
    dflt: 'x',
    editType: 'calc'
  },
  order: {
    valType: 'enumerated',
    values: ['ascending', 'descending'],
    dflt: 'ascending',
    editType: 'calc'
  },
  editType: 'calc'
};
exports.supplyDefaults = function (transformIn) {
  var transformOut = {};
  function coerce(attr, dflt) {
    return Lib.coerce(transformIn, transformOut, exports.attributes, attr, dflt);
  }
  var enabled = coerce('enabled');
  if (enabled) {
    coerce('target');
    coerce('order');
  }
  return transformOut;
};
exports.calcTransform = function (gd, trace, opts) {
  if (!opts.enabled) return;
  var targetArray = Lib.getTargetArray(trace, opts);
  if (!targetArray) return;
  var target = opts.target;
  var len = targetArray.length;
  if (trace._length) len = Math.min(len, trace._length);
  var arrayAttrs = trace._arrayAttrs;
  var d2c = Axes.getDataToCoordFunc(gd, trace, target, targetArray);
  var indices = getIndices(opts, targetArray, d2c, len);
  var originalPointsAccessor = pointsAccessorFunction(trace.transforms, opts);
  var indexToPoints = {};
  var i, j;
  for (i = 0; i < arrayAttrs.length; i++) {
    var np = Lib.nestedProperty(trace, arrayAttrs[i]);
    var arrayOld = np.get();
    var arrayNew = new Array(len);
    for (j = 0; j < len; j++) {
      arrayNew[j] = arrayOld[indices[j]];
    }
    np.set(arrayNew);
  }
  for (j = 0; j < len; j++) {
    indexToPoints[j] = originalPointsAccessor(indices[j]);
  }
  opts._indexToPoints = indexToPoints;
  trace._length = len;
};
function getIndices(opts, targetArray, d2c, len) {
  var sortedArray = new Array(len);
  var indices = new Array(len);
  var i;
  for (i = 0; i < len; i++) {
    sortedArray[i] = {
      v: targetArray[i],
      i: i
    };
  }
  sortedArray.sort(getSortFunc(opts, d2c));
  for (i = 0; i < len; i++) {
    indices[i] = sortedArray[i].i;
  }
  return indices;
}
function getSortFunc(opts, d2c) {
  switch (opts.order) {
    case 'ascending':
      return function (a, b) {
        var ac = d2c(a.v);
        var bc = d2c(b.v);
        if (ac === BADNUM) {
          return 1;
        }
        if (bc === BADNUM) {
          return -1;
        }
        return ac - bc;
      };
    case 'descending':
      return function (a, b) {
        var ac = d2c(a.v);
        var bc = d2c(b.v);
        if (ac === BADNUM) {
          return 1;
        }
        if (bc === BADNUM) {
          return -1;
        }
        return bc - ac;
      };
  }
}

/***/ }),

/***/ 29697:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


// package version injected by `npm run preprocess`
exports.version = '2.35.3';

/***/ }),

/***/ 99098:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var Buffer = __webpack_require__(45708)["Buffer"];
/* provided dependency */ var process = __webpack_require__(33282);
/******/(function(){// webpackBootstrap
/******/var __webpack_modules__={/***/1964:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_130__){module.exports={alpha_shape:__nested_webpack_require_130__(3502),convex_hull:__nested_webpack_require_130__(7352),delaunay_triangulate:__nested_webpack_require_130__(7642),gl_cone3d:__nested_webpack_require_130__(6405),gl_error3d:__nested_webpack_require_130__(9165),gl_heatmap2d:__nested_webpack_require_130__(2510),gl_line3d:__nested_webpack_require_130__(5714),gl_mesh3d:__nested_webpack_require_130__(7201),gl_plot2d:__nested_webpack_require_130__(1850),gl_plot3d:__nested_webpack_require_130__(4100),gl_pointcloud2d:__nested_webpack_require_130__(4696),gl_scatter3d:__nested_webpack_require_130__(8418),gl_select_box:__nested_webpack_require_130__(3161),gl_spikes2d:__nested_webpack_require_130__(4098),gl_streamtube3d:__nested_webpack_require_130__(7815),gl_surface3d:__nested_webpack_require_130__(9499),ndarray:__nested_webpack_require_130__(9618),ndarray_linear_interpolate:__nested_webpack_require_130__(4317)};/***/}),/***/4793:(/***/function(__unused_webpack_module,exports,__nested_webpack_require_939__){"use strict";var __webpack_unused_export__;/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */function _classCallCheck(a,n){if(!(a instanceof n))throw new TypeError("Cannot call a class as a function");}function _defineProperties(e,r){for(var t=0;t<r.length;t++){var o=r[t];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,_toPropertyKey(o.key),o);}}function _createClass(e,r,t){return r&&_defineProperties(e.prototype,r),t&&_defineProperties(e,t),Object.defineProperty(e,"prototype",{writable:!1}),e;}function _toPropertyKey(t){var i=_toPrimitive(t,"string");return"symbol"==_typeof(i)?i:i+"";}function _toPrimitive(t,r){if("object"!=_typeof(t)||!t)return t;var e=t[Symbol.toPrimitive];if(void 0!==e){var i=e.call(t,r||"default");if("object"!=_typeof(i))return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return("string"===r?String:Number)(t);}function _callSuper(t,o,e){return o=_getPrototypeOf(o),_possibleConstructorReturn(t,_isNativeReflectConstruct()?Reflect.construct(o,e||[],_getPrototypeOf(t).constructor):o.apply(t,e));}function _possibleConstructorReturn(t,e){if(e&&("object"==_typeof(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined");return _assertThisInitialized(t);}function _assertThisInitialized(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e;}function _isNativeReflectConstruct(){try{var t=!Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));}catch(t){}return(_isNativeReflectConstruct=function _isNativeReflectConstruct(){return!!t;})();}function _getPrototypeOf(t){return _getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t);},_getPrototypeOf(t);}function _inherits(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&_setPrototypeOf(t,e);}function _setPrototypeOf(t,e){return _setPrototypeOf=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t;},_setPrototypeOf(t,e);}function _typeof(o){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(o){return typeof o;}:function(o){return o&&"function"==typeof Symbol&&o.constructor===Symbol&&o!==Symbol.prototype?"symbol":typeof o;},_typeof(o);}var base64=__nested_webpack_require_939__(7507);var ieee754=__nested_webpack_require_939__(3778);var customInspectSymbol=typeof Symbol==='function'&&typeof Symbol['for']==='function'// eslint-disable-line dot-notation
?Symbol['for']('nodejs.util.inspect.custom')// eslint-disable-line dot-notation
:null;exports.hp=Buffer;__webpack_unused_export__=SlowBuffer;exports.IS=50;var K_MAX_LENGTH=0x7fffffff;__webpack_unused_export__=K_MAX_LENGTH;/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */Buffer.TYPED_ARRAY_SUPPORT=typedArraySupport();if(!Buffer.TYPED_ARRAY_SUPPORT&&typeof console!=='undefined'&&typeof console.error==='function'){console.error('This browser lacks typed array (Uint8Array) support which is required by '+'`buffer` v5.x. Use `buffer` v4.x if you require old browser support.');}function typedArraySupport(){// Can typed array instances can be augmented?
try{var arr=new Uint8Array(1);var proto={foo:function foo(){return 42;}};Object.setPrototypeOf(proto,Uint8Array.prototype);Object.setPrototypeOf(arr,proto);return arr.foo()===42;}catch(e){return false;}}Object.defineProperty(Buffer.prototype,'parent',{enumerable:true,get:function get(){if(!Buffer.isBuffer(this))return undefined;return this.buffer;}});Object.defineProperty(Buffer.prototype,'offset',{enumerable:true,get:function get(){if(!Buffer.isBuffer(this))return undefined;return this.byteOffset;}});function createBuffer(length){if(length>K_MAX_LENGTH){throw new RangeError('The value "'+length+'" is invalid for option "size"');}// Return an augmented `Uint8Array` instance
var buf=new Uint8Array(length);Object.setPrototypeOf(buf,Buffer.prototype);return buf;}/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */function Buffer(arg,encodingOrOffset,length){// Common case.
if(typeof arg==='number'){if(typeof encodingOrOffset==='string'){throw new TypeError('The "string" argument must be of type string. Received type number');}return allocUnsafe(arg);}return from(arg,encodingOrOffset,length);}Buffer.poolSize=8192;// not used by this implementation
function from(value,encodingOrOffset,length){if(typeof value==='string'){return fromString(value,encodingOrOffset);}if(ArrayBuffer.isView(value)){return fromArrayView(value);}if(value==null){throw new TypeError('The first argument must be one of type string, Buffer, ArrayBuffer, Array, '+'or Array-like Object. Received type '+_typeof(value));}if(isInstance(value,ArrayBuffer)||value&&isInstance(value.buffer,ArrayBuffer)){return fromArrayBuffer(value,encodingOrOffset,length);}if(typeof SharedArrayBuffer!=='undefined'&&(isInstance(value,SharedArrayBuffer)||value&&isInstance(value.buffer,SharedArrayBuffer))){return fromArrayBuffer(value,encodingOrOffset,length);}if(typeof value==='number'){throw new TypeError('The "value" argument must not be of type number. Received type number');}var valueOf=value.valueOf&&value.valueOf();if(valueOf!=null&&valueOf!==value){return Buffer.from(valueOf,encodingOrOffset,length);}var b=fromObject(value);if(b)return b;if(typeof Symbol!=='undefined'&&Symbol.toPrimitive!=null&&typeof value[Symbol.toPrimitive]==='function'){return Buffer.from(value[Symbol.toPrimitive]('string'),encodingOrOffset,length);}throw new TypeError('The first argument must be one of type string, Buffer, ArrayBuffer, Array, '+'or Array-like Object. Received type '+_typeof(value));}/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/Buffer.from=function(value,encodingOrOffset,length){return from(value,encodingOrOffset,length);};// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype,Uint8Array.prototype);Object.setPrototypeOf(Buffer,Uint8Array);function assertSize(size){if(typeof size!=='number'){throw new TypeError('"size" argument must be of type number');}else if(size<0){throw new RangeError('The value "'+size+'" is invalid for option "size"');}}function alloc(size,fill,encoding){assertSize(size);if(size<=0){return createBuffer(size);}if(fill!==undefined){// Only pay attention to encoding if it's a string. This
// prevents accidentally sending in a number that would
// be interpreted as a start offset.
return typeof encoding==='string'?createBuffer(size).fill(fill,encoding):createBuffer(size).fill(fill);}return createBuffer(size);}/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/Buffer.alloc=function(size,fill,encoding){return alloc(size,fill,encoding);};function allocUnsafe(size){assertSize(size);return createBuffer(size<0?0:checked(size)|0);}/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */Buffer.allocUnsafe=function(size){return allocUnsafe(size);};/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */Buffer.allocUnsafeSlow=function(size){return allocUnsafe(size);};function fromString(string,encoding){if(typeof encoding!=='string'||encoding===''){encoding='utf8';}if(!Buffer.isEncoding(encoding)){throw new TypeError('Unknown encoding: '+encoding);}var length=byteLength(string,encoding)|0;var buf=createBuffer(length);var actual=buf.write(string,encoding);if(actual!==length){// Writing a hex string, for example, that contains invalid characters will
// cause everything after the first invalid character to be ignored. (e.g.
// 'abxxcd' will be treated as 'ab')
buf=buf.slice(0,actual);}return buf;}function fromArrayLike(array){var length=array.length<0?0:checked(array.length)|0;var buf=createBuffer(length);for(var i=0;i<length;i+=1){buf[i]=array[i]&255;}return buf;}function fromArrayView(arrayView){if(isInstance(arrayView,Uint8Array)){var copy=new Uint8Array(arrayView);return fromArrayBuffer(copy.buffer,copy.byteOffset,copy.byteLength);}return fromArrayLike(arrayView);}function fromArrayBuffer(array,byteOffset,length){if(byteOffset<0||array.byteLength<byteOffset){throw new RangeError('"offset" is outside of buffer bounds');}if(array.byteLength<byteOffset+(length||0)){throw new RangeError('"length" is outside of buffer bounds');}var buf;if(byteOffset===undefined&&length===undefined){buf=new Uint8Array(array);}else if(length===undefined){buf=new Uint8Array(array,byteOffset);}else{buf=new Uint8Array(array,byteOffset,length);}// Return an augmented `Uint8Array` instance
Object.setPrototypeOf(buf,Buffer.prototype);return buf;}function fromObject(obj){if(Buffer.isBuffer(obj)){var len=checked(obj.length)|0;var buf=createBuffer(len);if(buf.length===0){return buf;}obj.copy(buf,0,0,len);return buf;}if(obj.length!==undefined){if(typeof obj.length!=='number'||numberIsNaN(obj.length)){return createBuffer(0);}return fromArrayLike(obj);}if(obj.type==='Buffer'&&Array.isArray(obj.data)){return fromArrayLike(obj.data);}}function checked(length){// Note: cannot use `length < K_MAX_LENGTH` here because that fails when
// length is NaN (which is otherwise coerced to zero.)
if(length>=K_MAX_LENGTH){throw new RangeError('Attempt to allocate Buffer larger than maximum '+'size: 0x'+K_MAX_LENGTH.toString(16)+' bytes');}return length|0;}function SlowBuffer(length){if(+length!=length){// eslint-disable-line eqeqeq
length=0;}return Buffer.alloc(+length);}Buffer.isBuffer=function isBuffer(b){return b!=null&&b._isBuffer===true&&b!==Buffer.prototype;// so Buffer.isBuffer(Buffer.prototype) will be false
};Buffer.compare=function compare(a,b){if(isInstance(a,Uint8Array))a=Buffer.from(a,a.offset,a.byteLength);if(isInstance(b,Uint8Array))b=Buffer.from(b,b.offset,b.byteLength);if(!Buffer.isBuffer(a)||!Buffer.isBuffer(b)){throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');}if(a===b)return 0;var x=a.length;var y=b.length;for(var i=0,len=Math.min(x,y);i<len;++i){if(a[i]!==b[i]){x=a[i];y=b[i];break;}}if(x<y)return-1;if(y<x)return 1;return 0;};Buffer.isEncoding=function isEncoding(encoding){switch(String(encoding).toLowerCase()){case'hex':case'utf8':case'utf-8':case'ascii':case'latin1':case'binary':case'base64':case'ucs2':case'ucs-2':case'utf16le':case'utf-16le':return true;default:return false;}};Buffer.concat=function concat(list,length){if(!Array.isArray(list)){throw new TypeError('"list" argument must be an Array of Buffers');}if(list.length===0){return Buffer.alloc(0);}var i;if(length===undefined){length=0;for(i=0;i<list.length;++i){length+=list[i].length;}}var buffer=Buffer.allocUnsafe(length);var pos=0;for(i=0;i<list.length;++i){var buf=list[i];if(isInstance(buf,Uint8Array)){if(pos+buf.length>buffer.length){if(!Buffer.isBuffer(buf))buf=Buffer.from(buf);buf.copy(buffer,pos);}else{Uint8Array.prototype.set.call(buffer,buf,pos);}}else if(!Buffer.isBuffer(buf)){throw new TypeError('"list" argument must be an Array of Buffers');}else{buf.copy(buffer,pos);}pos+=buf.length;}return buffer;};function byteLength(string,encoding){if(Buffer.isBuffer(string)){return string.length;}if(ArrayBuffer.isView(string)||isInstance(string,ArrayBuffer)){return string.byteLength;}if(typeof string!=='string'){throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. '+'Received type '+_typeof(string));}var len=string.length;var mustMatch=arguments.length>2&&arguments[2]===true;if(!mustMatch&&len===0)return 0;// Use a for loop to avoid recursion
var loweredCase=false;for(;;){switch(encoding){case'ascii':case'latin1':case'binary':return len;case'utf8':case'utf-8':return utf8ToBytes(string).length;case'ucs2':case'ucs-2':case'utf16le':case'utf-16le':return len*2;case'hex':return len>>>1;case'base64':return base64ToBytes(string).length;default:if(loweredCase){return mustMatch?-1:utf8ToBytes(string).length;// assume utf8
}encoding=(''+encoding).toLowerCase();loweredCase=true;}}}Buffer.byteLength=byteLength;function slowToString(encoding,start,end){var loweredCase=false;// No need to verify that "this.length <= MAX_UINT32" since it's a read-only
// property of a typed array.
// This behaves neither like String nor Uint8Array in that we set start/end
// to their upper/lower bounds if the value passed is out of range.
// undefined is handled specially as per ECMA-262 6th Edition,
// Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
if(start===undefined||start<0){start=0;}// Return early if start > this.length. Done here to prevent potential uint32
// coercion fail below.
if(start>this.length){return'';}if(end===undefined||end>this.length){end=this.length;}if(end<=0){return'';}// Force coercion to uint32. This will also coerce falsey/NaN values to 0.
end>>>=0;start>>>=0;if(end<=start){return'';}if(!encoding)encoding='utf8';while(true){switch(encoding){case'hex':return hexSlice(this,start,end);case'utf8':case'utf-8':return utf8Slice(this,start,end);case'ascii':return asciiSlice(this,start,end);case'latin1':case'binary':return latin1Slice(this,start,end);case'base64':return base64Slice(this,start,end);case'ucs2':case'ucs-2':case'utf16le':case'utf-16le':return utf16leSlice(this,start,end);default:if(loweredCase)throw new TypeError('Unknown encoding: '+encoding);encoding=(encoding+'').toLowerCase();loweredCase=true;}}}// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer=true;function swap(b,n,m){var i=b[n];b[n]=b[m];b[m]=i;}Buffer.prototype.swap16=function swap16(){var len=this.length;if(len%2!==0){throw new RangeError('Buffer size must be a multiple of 16-bits');}for(var i=0;i<len;i+=2){swap(this,i,i+1);}return this;};Buffer.prototype.swap32=function swap32(){var len=this.length;if(len%4!==0){throw new RangeError('Buffer size must be a multiple of 32-bits');}for(var i=0;i<len;i+=4){swap(this,i,i+3);swap(this,i+1,i+2);}return this;};Buffer.prototype.swap64=function swap64(){var len=this.length;if(len%8!==0){throw new RangeError('Buffer size must be a multiple of 64-bits');}for(var i=0;i<len;i+=8){swap(this,i,i+7);swap(this,i+1,i+6);swap(this,i+2,i+5);swap(this,i+3,i+4);}return this;};Buffer.prototype.toString=function toString(){var length=this.length;if(length===0)return'';if(arguments.length===0)return utf8Slice(this,0,length);return slowToString.apply(this,arguments);};Buffer.prototype.toLocaleString=Buffer.prototype.toString;Buffer.prototype.equals=function equals(b){if(!Buffer.isBuffer(b))throw new TypeError('Argument must be a Buffer');if(this===b)return true;return Buffer.compare(this,b)===0;};Buffer.prototype.inspect=function inspect(){var str='';var max=exports.IS;str=this.toString('hex',0,max).replace(/(.{2})/g,'$1 ').trim();if(this.length>max)str+=' ... ';return'<Buffer '+str+'>';};if(customInspectSymbol){Buffer.prototype[customInspectSymbol]=Buffer.prototype.inspect;}Buffer.prototype.compare=function compare(target,start,end,thisStart,thisEnd){if(isInstance(target,Uint8Array)){target=Buffer.from(target,target.offset,target.byteLength);}if(!Buffer.isBuffer(target)){throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. '+'Received type '+_typeof(target));}if(start===undefined){start=0;}if(end===undefined){end=target?target.length:0;}if(thisStart===undefined){thisStart=0;}if(thisEnd===undefined){thisEnd=this.length;}if(start<0||end>target.length||thisStart<0||thisEnd>this.length){throw new RangeError('out of range index');}if(thisStart>=thisEnd&&start>=end){return 0;}if(thisStart>=thisEnd){return-1;}if(start>=end){return 1;}start>>>=0;end>>>=0;thisStart>>>=0;thisEnd>>>=0;if(this===target)return 0;var x=thisEnd-thisStart;var y=end-start;var len=Math.min(x,y);var thisCopy=this.slice(thisStart,thisEnd);var targetCopy=target.slice(start,end);for(var i=0;i<len;++i){if(thisCopy[i]!==targetCopy[i]){x=thisCopy[i];y=targetCopy[i];break;}}if(x<y)return-1;if(y<x)return 1;return 0;};// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer,val,byteOffset,encoding,dir){// Empty buffer means no match
if(buffer.length===0)return-1;// Normalize byteOffset
if(typeof byteOffset==='string'){encoding=byteOffset;byteOffset=0;}else if(byteOffset>0x7fffffff){byteOffset=0x7fffffff;}else if(byteOffset<-0x80000000){byteOffset=-0x80000000;}byteOffset=+byteOffset;// Coerce to Number.
if(numberIsNaN(byteOffset)){// byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
byteOffset=dir?0:buffer.length-1;}// Normalize byteOffset: negative offsets start from the end of the buffer
if(byteOffset<0)byteOffset=buffer.length+byteOffset;if(byteOffset>=buffer.length){if(dir)return-1;else byteOffset=buffer.length-1;}else if(byteOffset<0){if(dir)byteOffset=0;else return-1;}// Normalize val
if(typeof val==='string'){val=Buffer.from(val,encoding);}// Finally, search either indexOf (if dir is true) or lastIndexOf
if(Buffer.isBuffer(val)){// Special case: looking for empty string/buffer always fails
if(val.length===0){return-1;}return arrayIndexOf(buffer,val,byteOffset,encoding,dir);}else if(typeof val==='number'){val=val&0xFF;// Search for a byte value [0-255]
if(typeof Uint8Array.prototype.indexOf==='function'){if(dir){return Uint8Array.prototype.indexOf.call(buffer,val,byteOffset);}else{return Uint8Array.prototype.lastIndexOf.call(buffer,val,byteOffset);}}return arrayIndexOf(buffer,[val],byteOffset,encoding,dir);}throw new TypeError('val must be string, number or Buffer');}function arrayIndexOf(arr,val,byteOffset,encoding,dir){var indexSize=1;var arrLength=arr.length;var valLength=val.length;if(encoding!==undefined){encoding=String(encoding).toLowerCase();if(encoding==='ucs2'||encoding==='ucs-2'||encoding==='utf16le'||encoding==='utf-16le'){if(arr.length<2||val.length<2){return-1;}indexSize=2;arrLength/=2;valLength/=2;byteOffset/=2;}}function read(buf,i){if(indexSize===1){return buf[i];}else{return buf.readUInt16BE(i*indexSize);}}var i;if(dir){var foundIndex=-1;for(i=byteOffset;i<arrLength;i++){if(read(arr,i)===read(val,foundIndex===-1?0:i-foundIndex)){if(foundIndex===-1)foundIndex=i;if(i-foundIndex+1===valLength)return foundIndex*indexSize;}else{if(foundIndex!==-1)i-=i-foundIndex;foundIndex=-1;}}}else{if(byteOffset+valLength>arrLength)byteOffset=arrLength-valLength;for(i=byteOffset;i>=0;i--){var found=true;for(var j=0;j<valLength;j++){if(read(arr,i+j)!==read(val,j)){found=false;break;}}if(found)return i;}}return-1;}Buffer.prototype.includes=function includes(val,byteOffset,encoding){return this.indexOf(val,byteOffset,encoding)!==-1;};Buffer.prototype.indexOf=function indexOf(val,byteOffset,encoding){return bidirectionalIndexOf(this,val,byteOffset,encoding,true);};Buffer.prototype.lastIndexOf=function lastIndexOf(val,byteOffset,encoding){return bidirectionalIndexOf(this,val,byteOffset,encoding,false);};function hexWrite(buf,string,offset,length){offset=Number(offset)||0;var remaining=buf.length-offset;if(!length){length=remaining;}else{length=Number(length);if(length>remaining){length=remaining;}}var strLen=string.length;if(length>strLen/2){length=strLen/2;}var i;for(i=0;i<length;++i){var parsed=parseInt(string.substr(i*2,2),16);if(numberIsNaN(parsed))return i;buf[offset+i]=parsed;}return i;}function utf8Write(buf,string,offset,length){return blitBuffer(utf8ToBytes(string,buf.length-offset),buf,offset,length);}function asciiWrite(buf,string,offset,length){return blitBuffer(asciiToBytes(string),buf,offset,length);}function base64Write(buf,string,offset,length){return blitBuffer(base64ToBytes(string),buf,offset,length);}function ucs2Write(buf,string,offset,length){return blitBuffer(utf16leToBytes(string,buf.length-offset),buf,offset,length);}Buffer.prototype.write=function write(string,offset,length,encoding){// Buffer#write(string)
if(offset===undefined){encoding='utf8';length=this.length;offset=0;// Buffer#write(string, encoding)
}else if(length===undefined&&typeof offset==='string'){encoding=offset;length=this.length;offset=0;// Buffer#write(string, offset[, length][, encoding])
}else if(isFinite(offset)){offset=offset>>>0;if(isFinite(length)){length=length>>>0;if(encoding===undefined)encoding='utf8';}else{encoding=length;length=undefined;}}else{throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');}var remaining=this.length-offset;if(length===undefined||length>remaining)length=remaining;if(string.length>0&&(length<0||offset<0)||offset>this.length){throw new RangeError('Attempt to write outside buffer bounds');}if(!encoding)encoding='utf8';var loweredCase=false;for(;;){switch(encoding){case'hex':return hexWrite(this,string,offset,length);case'utf8':case'utf-8':return utf8Write(this,string,offset,length);case'ascii':case'latin1':case'binary':return asciiWrite(this,string,offset,length);case'base64':// Warning: maxLength not taken into account in base64Write
return base64Write(this,string,offset,length);case'ucs2':case'ucs-2':case'utf16le':case'utf-16le':return ucs2Write(this,string,offset,length);default:if(loweredCase)throw new TypeError('Unknown encoding: '+encoding);encoding=(''+encoding).toLowerCase();loweredCase=true;}}};Buffer.prototype.toJSON=function toJSON(){return{type:'Buffer',data:Array.prototype.slice.call(this._arr||this,0)};};function base64Slice(buf,start,end){if(start===0&&end===buf.length){return base64.fromByteArray(buf);}else{return base64.fromByteArray(buf.slice(start,end));}}function utf8Slice(buf,start,end){end=Math.min(buf.length,end);var res=[];var i=start;while(i<end){var firstByte=buf[i];var codePoint=null;var bytesPerSequence=firstByte>0xEF?4:firstByte>0xDF?3:firstByte>0xBF?2:1;if(i+bytesPerSequence<=end){var secondByte=void 0,thirdByte=void 0,fourthByte=void 0,tempCodePoint=void 0;switch(bytesPerSequence){case 1:if(firstByte<0x80){codePoint=firstByte;}break;case 2:secondByte=buf[i+1];if((secondByte&0xC0)===0x80){tempCodePoint=(firstByte&0x1F)<<0x6|secondByte&0x3F;if(tempCodePoint>0x7F){codePoint=tempCodePoint;}}break;case 3:secondByte=buf[i+1];thirdByte=buf[i+2];if((secondByte&0xC0)===0x80&&(thirdByte&0xC0)===0x80){tempCodePoint=(firstByte&0xF)<<0xC|(secondByte&0x3F)<<0x6|thirdByte&0x3F;if(tempCodePoint>0x7FF&&(tempCodePoint<0xD800||tempCodePoint>0xDFFF)){codePoint=tempCodePoint;}}break;case 4:secondByte=buf[i+1];thirdByte=buf[i+2];fourthByte=buf[i+3];if((secondByte&0xC0)===0x80&&(thirdByte&0xC0)===0x80&&(fourthByte&0xC0)===0x80){tempCodePoint=(firstByte&0xF)<<0x12|(secondByte&0x3F)<<0xC|(thirdByte&0x3F)<<0x6|fourthByte&0x3F;if(tempCodePoint>0xFFFF&&tempCodePoint<0x110000){codePoint=tempCodePoint;}}}}if(codePoint===null){// we did not generate a valid codePoint so insert a
// replacement char (U+FFFD) and advance only 1 byte
codePoint=0xFFFD;bytesPerSequence=1;}else if(codePoint>0xFFFF){// encode to utf16 (surrogate pair dance)
codePoint-=0x10000;res.push(codePoint>>>10&0x3FF|0xD800);codePoint=0xDC00|codePoint&0x3FF;}res.push(codePoint);i+=bytesPerSequence;}return decodeCodePointsArray(res);}// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH=0x1000;function decodeCodePointsArray(codePoints){var len=codePoints.length;if(len<=MAX_ARGUMENTS_LENGTH){return String.fromCharCode.apply(String,codePoints);// avoid extra slice()
}// Decode in chunks to avoid "call stack size exceeded".
var res='';var i=0;while(i<len){res+=String.fromCharCode.apply(String,codePoints.slice(i,i+=MAX_ARGUMENTS_LENGTH));}return res;}function asciiSlice(buf,start,end){var ret='';end=Math.min(buf.length,end);for(var i=start;i<end;++i){ret+=String.fromCharCode(buf[i]&0x7F);}return ret;}function latin1Slice(buf,start,end){var ret='';end=Math.min(buf.length,end);for(var i=start;i<end;++i){ret+=String.fromCharCode(buf[i]);}return ret;}function hexSlice(buf,start,end){var len=buf.length;if(!start||start<0)start=0;if(!end||end<0||end>len)end=len;var out='';for(var i=start;i<end;++i){out+=hexSliceLookupTable[buf[i]];}return out;}function utf16leSlice(buf,start,end){var bytes=buf.slice(start,end);var res='';// If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
for(var i=0;i<bytes.length-1;i+=2){res+=String.fromCharCode(bytes[i]+bytes[i+1]*256);}return res;}Buffer.prototype.slice=function slice(start,end){var len=this.length;start=~~start;end=end===undefined?len:~~end;if(start<0){start+=len;if(start<0)start=0;}else if(start>len){start=len;}if(end<0){end+=len;if(end<0)end=0;}else if(end>len){end=len;}if(end<start)end=start;var newBuf=this.subarray(start,end);// Return an augmented `Uint8Array` instance
Object.setPrototypeOf(newBuf,Buffer.prototype);return newBuf;};/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */function checkOffset(offset,ext,length){if(offset%1!==0||offset<0)throw new RangeError('offset is not uint');if(offset+ext>length)throw new RangeError('Trying to access beyond buffer length');}Buffer.prototype.readUintLE=Buffer.prototype.readUIntLE=function readUIntLE(offset,byteLength,noAssert){offset=offset>>>0;byteLength=byteLength>>>0;if(!noAssert)checkOffset(offset,byteLength,this.length);var val=this[offset];var mul=1;var i=0;while(++i<byteLength&&(mul*=0x100)){val+=this[offset+i]*mul;}return val;};Buffer.prototype.readUintBE=Buffer.prototype.readUIntBE=function readUIntBE(offset,byteLength,noAssert){offset=offset>>>0;byteLength=byteLength>>>0;if(!noAssert){checkOffset(offset,byteLength,this.length);}var val=this[offset+--byteLength];var mul=1;while(byteLength>0&&(mul*=0x100)){val+=this[offset+--byteLength]*mul;}return val;};Buffer.prototype.readUint8=Buffer.prototype.readUInt8=function readUInt8(offset,noAssert){offset=offset>>>0;if(!noAssert)checkOffset(offset,1,this.length);return this[offset];};Buffer.prototype.readUint16LE=Buffer.prototype.readUInt16LE=function readUInt16LE(offset,noAssert){offset=offset>>>0;if(!noAssert)checkOffset(offset,2,this.length);return this[offset]|this[offset+1]<<8;};Buffer.prototype.readUint16BE=Buffer.prototype.readUInt16BE=function readUInt16BE(offset,noAssert){offset=offset>>>0;if(!noAssert)checkOffset(offset,2,this.length);return this[offset]<<8|this[offset+1];};Buffer.prototype.readUint32LE=Buffer.prototype.readUInt32LE=function readUInt32LE(offset,noAssert){offset=offset>>>0;if(!noAssert)checkOffset(offset,4,this.length);return(this[offset]|this[offset+1]<<8|this[offset+2]<<16)+this[offset+3]*0x1000000;};Buffer.prototype.readUint32BE=Buffer.prototype.readUInt32BE=function readUInt32BE(offset,noAssert){offset=offset>>>0;if(!noAssert)checkOffset(offset,4,this.length);return this[offset]*0x1000000+(this[offset+1]<<16|this[offset+2]<<8|this[offset+3]);};Buffer.prototype.readBigUInt64LE=defineBigIntMethod(function readBigUInt64LE(offset){offset=offset>>>0;validateNumber(offset,'offset');var first=this[offset];var last=this[offset+7];if(first===undefined||last===undefined){boundsError(offset,this.length-8);}var lo=first+this[++offset]*Math.pow(2,8)+this[++offset]*Math.pow(2,16)+this[++offset]*Math.pow(2,24);var hi=this[++offset]+this[++offset]*Math.pow(2,8)+this[++offset]*Math.pow(2,16)+last*Math.pow(2,24);return BigInt(lo)+(BigInt(hi)<<BigInt(32));});Buffer.prototype.readBigUInt64BE=defineBigIntMethod(function readBigUInt64BE(offset){offset=offset>>>0;validateNumber(offset,'offset');var first=this[offset];var last=this[offset+7];if(first===undefined||last===undefined){boundsError(offset,this.length-8);}var hi=first*Math.pow(2,24)+this[++offset]*Math.pow(2,16)+this[++offset]*Math.pow(2,8)+this[++offset];var lo=this[++offset]*Math.pow(2,24)+this[++offset]*Math.pow(2,16)+this[++offset]*Math.pow(2,8)+last;return(BigInt(hi)<<BigInt(32))+BigInt(lo);});Buffer.prototype.readIntLE=function readIntLE(offset,byteLength,noAssert){offset=offset>>>0;byteLength=byteLength>>>0;if(!noAssert)checkOffset(offset,byteLength,this.length);var val=this[offset];var mul=1;var i=0;while(++i<byteLength&&(mul*=0x100)){val+=this[offset+i]*mul;}mul*=0x80;if(val>=mul)val-=Math.pow(2,8*byteLength);return val;};Buffer.prototype.readIntBE=function readIntBE(offset,byteLength,noAssert){offset=offset>>>0;byteLength=byteLength>>>0;if(!noAssert)checkOffset(offset,byteLength,this.length);var i=byteLength;var mul=1;var val=this[offset+--i];while(i>0&&(mul*=0x100)){val+=this[offset+--i]*mul;}mul*=0x80;if(val>=mul)val-=Math.pow(2,8*byteLength);return val;};Buffer.prototype.readInt8=function readInt8(offset,noAssert){offset=offset>>>0;if(!noAssert)checkOffset(offset,1,this.length);if(!(this[offset]&0x80))return this[offset];return(0xff-this[offset]+1)*-1;};Buffer.prototype.readInt16LE=function readInt16LE(offset,noAssert){offset=offset>>>0;if(!noAssert)checkOffset(offset,2,this.length);var val=this[offset]|this[offset+1]<<8;return val&0x8000?val|0xFFFF0000:val;};Buffer.prototype.readInt16BE=function readInt16BE(offset,noAssert){offset=offset>>>0;if(!noAssert)checkOffset(offset,2,this.length);var val=this[offset+1]|this[offset]<<8;return val&0x8000?val|0xFFFF0000:val;};Buffer.prototype.readInt32LE=function readInt32LE(offset,noAssert){offset=offset>>>0;if(!noAssert)checkOffset(offset,4,this.length);return this[offset]|this[offset+1]<<8|this[offset+2]<<16|this[offset+3]<<24;};Buffer.prototype.readInt32BE=function readInt32BE(offset,noAssert){offset=offset>>>0;if(!noAssert)checkOffset(offset,4,this.length);return this[offset]<<24|this[offset+1]<<16|this[offset+2]<<8|this[offset+3];};Buffer.prototype.readBigInt64LE=defineBigIntMethod(function readBigInt64LE(offset){offset=offset>>>0;validateNumber(offset,'offset');var first=this[offset];var last=this[offset+7];if(first===undefined||last===undefined){boundsError(offset,this.length-8);}var val=this[offset+4]+this[offset+5]*Math.pow(2,8)+this[offset+6]*Math.pow(2,16)+(last<<24);// Overflow
return(BigInt(val)<<BigInt(32))+BigInt(first+this[++offset]*Math.pow(2,8)+this[++offset]*Math.pow(2,16)+this[++offset]*Math.pow(2,24));});Buffer.prototype.readBigInt64BE=defineBigIntMethod(function readBigInt64BE(offset){offset=offset>>>0;validateNumber(offset,'offset');var first=this[offset];var last=this[offset+7];if(first===undefined||last===undefined){boundsError(offset,this.length-8);}var val=(first<<24)+// Overflow
this[++offset]*Math.pow(2,16)+this[++offset]*Math.pow(2,8)+this[++offset];return(BigInt(val)<<BigInt(32))+BigInt(this[++offset]*Math.pow(2,24)+this[++offset]*Math.pow(2,16)+this[++offset]*Math.pow(2,8)+last);});Buffer.prototype.readFloatLE=function readFloatLE(offset,noAssert){offset=offset>>>0;if(!noAssert)checkOffset(offset,4,this.length);return ieee754.read(this,offset,true,23,4);};Buffer.prototype.readFloatBE=function readFloatBE(offset,noAssert){offset=offset>>>0;if(!noAssert)checkOffset(offset,4,this.length);return ieee754.read(this,offset,false,23,4);};Buffer.prototype.readDoubleLE=function readDoubleLE(offset,noAssert){offset=offset>>>0;if(!noAssert)checkOffset(offset,8,this.length);return ieee754.read(this,offset,true,52,8);};Buffer.prototype.readDoubleBE=function readDoubleBE(offset,noAssert){offset=offset>>>0;if(!noAssert)checkOffset(offset,8,this.length);return ieee754.read(this,offset,false,52,8);};function checkInt(buf,value,offset,ext,max,min){if(!Buffer.isBuffer(buf))throw new TypeError('"buffer" argument must be a Buffer instance');if(value>max||value<min)throw new RangeError('"value" argument is out of bounds');if(offset+ext>buf.length)throw new RangeError('Index out of range');}Buffer.prototype.writeUintLE=Buffer.prototype.writeUIntLE=function writeUIntLE(value,offset,byteLength,noAssert){value=+value;offset=offset>>>0;byteLength=byteLength>>>0;if(!noAssert){var maxBytes=Math.pow(2,8*byteLength)-1;checkInt(this,value,offset,byteLength,maxBytes,0);}var mul=1;var i=0;this[offset]=value&0xFF;while(++i<byteLength&&(mul*=0x100)){this[offset+i]=value/mul&0xFF;}return offset+byteLength;};Buffer.prototype.writeUintBE=Buffer.prototype.writeUIntBE=function writeUIntBE(value,offset,byteLength,noAssert){value=+value;offset=offset>>>0;byteLength=byteLength>>>0;if(!noAssert){var maxBytes=Math.pow(2,8*byteLength)-1;checkInt(this,value,offset,byteLength,maxBytes,0);}var i=byteLength-1;var mul=1;this[offset+i]=value&0xFF;while(--i>=0&&(mul*=0x100)){this[offset+i]=value/mul&0xFF;}return offset+byteLength;};Buffer.prototype.writeUint8=Buffer.prototype.writeUInt8=function writeUInt8(value,offset,noAssert){value=+value;offset=offset>>>0;if(!noAssert)checkInt(this,value,offset,1,0xff,0);this[offset]=value&0xff;return offset+1;};Buffer.prototype.writeUint16LE=Buffer.prototype.writeUInt16LE=function writeUInt16LE(value,offset,noAssert){value=+value;offset=offset>>>0;if(!noAssert)checkInt(this,value,offset,2,0xffff,0);this[offset]=value&0xff;this[offset+1]=value>>>8;return offset+2;};Buffer.prototype.writeUint16BE=Buffer.prototype.writeUInt16BE=function writeUInt16BE(value,offset,noAssert){value=+value;offset=offset>>>0;if(!noAssert)checkInt(this,value,offset,2,0xffff,0);this[offset]=value>>>8;this[offset+1]=value&0xff;return offset+2;};Buffer.prototype.writeUint32LE=Buffer.prototype.writeUInt32LE=function writeUInt32LE(value,offset,noAssert){value=+value;offset=offset>>>0;if(!noAssert)checkInt(this,value,offset,4,0xffffffff,0);this[offset+3]=value>>>24;this[offset+2]=value>>>16;this[offset+1]=value>>>8;this[offset]=value&0xff;return offset+4;};Buffer.prototype.writeUint32BE=Buffer.prototype.writeUInt32BE=function writeUInt32BE(value,offset,noAssert){value=+value;offset=offset>>>0;if(!noAssert)checkInt(this,value,offset,4,0xffffffff,0);this[offset]=value>>>24;this[offset+1]=value>>>16;this[offset+2]=value>>>8;this[offset+3]=value&0xff;return offset+4;};function wrtBigUInt64LE(buf,value,offset,min,max){checkIntBI(value,min,max,buf,offset,7);var lo=Number(value&BigInt(0xffffffff));buf[offset++]=lo;lo=lo>>8;buf[offset++]=lo;lo=lo>>8;buf[offset++]=lo;lo=lo>>8;buf[offset++]=lo;var hi=Number(value>>BigInt(32)&BigInt(0xffffffff));buf[offset++]=hi;hi=hi>>8;buf[offset++]=hi;hi=hi>>8;buf[offset++]=hi;hi=hi>>8;buf[offset++]=hi;return offset;}function wrtBigUInt64BE(buf,value,offset,min,max){checkIntBI(value,min,max,buf,offset,7);var lo=Number(value&BigInt(0xffffffff));buf[offset+7]=lo;lo=lo>>8;buf[offset+6]=lo;lo=lo>>8;buf[offset+5]=lo;lo=lo>>8;buf[offset+4]=lo;var hi=Number(value>>BigInt(32)&BigInt(0xffffffff));buf[offset+3]=hi;hi=hi>>8;buf[offset+2]=hi;hi=hi>>8;buf[offset+1]=hi;hi=hi>>8;buf[offset]=hi;return offset+8;}Buffer.prototype.writeBigUInt64LE=defineBigIntMethod(function writeBigUInt64LE(value){var offset=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;return wrtBigUInt64LE(this,value,offset,BigInt(0),BigInt('0xffffffffffffffff'));});Buffer.prototype.writeBigUInt64BE=defineBigIntMethod(function writeBigUInt64BE(value){var offset=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;return wrtBigUInt64BE(this,value,offset,BigInt(0),BigInt('0xffffffffffffffff'));});Buffer.prototype.writeIntLE=function writeIntLE(value,offset,byteLength,noAssert){value=+value;offset=offset>>>0;if(!noAssert){var limit=Math.pow(2,8*byteLength-1);checkInt(this,value,offset,byteLength,limit-1,-limit);}var i=0;var mul=1;var sub=0;this[offset]=value&0xFF;while(++i<byteLength&&(mul*=0x100)){if(value<0&&sub===0&&this[offset+i-1]!==0){sub=1;}this[offset+i]=(value/mul>>0)-sub&0xFF;}return offset+byteLength;};Buffer.prototype.writeIntBE=function writeIntBE(value,offset,byteLength,noAssert){value=+value;offset=offset>>>0;if(!noAssert){var limit=Math.pow(2,8*byteLength-1);checkInt(this,value,offset,byteLength,limit-1,-limit);}var i=byteLength-1;var mul=1;var sub=0;this[offset+i]=value&0xFF;while(--i>=0&&(mul*=0x100)){if(value<0&&sub===0&&this[offset+i+1]!==0){sub=1;}this[offset+i]=(value/mul>>0)-sub&0xFF;}return offset+byteLength;};Buffer.prototype.writeInt8=function writeInt8(value,offset,noAssert){value=+value;offset=offset>>>0;if(!noAssert)checkInt(this,value,offset,1,0x7f,-0x80);if(value<0)value=0xff+value+1;this[offset]=value&0xff;return offset+1;};Buffer.prototype.writeInt16LE=function writeInt16LE(value,offset,noAssert){value=+value;offset=offset>>>0;if(!noAssert)checkInt(this,value,offset,2,0x7fff,-0x8000);this[offset]=value&0xff;this[offset+1]=value>>>8;return offset+2;};Buffer.prototype.writeInt16BE=function writeInt16BE(value,offset,noAssert){value=+value;offset=offset>>>0;if(!noAssert)checkInt(this,value,offset,2,0x7fff,-0x8000);this[offset]=value>>>8;this[offset+1]=value&0xff;return offset+2;};Buffer.prototype.writeInt32LE=function writeInt32LE(value,offset,noAssert){value=+value;offset=offset>>>0;if(!noAssert)checkInt(this,value,offset,4,0x7fffffff,-0x80000000);this[offset]=value&0xff;this[offset+1]=value>>>8;this[offset+2]=value>>>16;this[offset+3]=value>>>24;return offset+4;};Buffer.prototype.writeInt32BE=function writeInt32BE(value,offset,noAssert){value=+value;offset=offset>>>0;if(!noAssert)checkInt(this,value,offset,4,0x7fffffff,-0x80000000);if(value<0)value=0xffffffff+value+1;this[offset]=value>>>24;this[offset+1]=value>>>16;this[offset+2]=value>>>8;this[offset+3]=value&0xff;return offset+4;};Buffer.prototype.writeBigInt64LE=defineBigIntMethod(function writeBigInt64LE(value){var offset=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;return wrtBigUInt64LE(this,value,offset,-BigInt('0x8000000000000000'),BigInt('0x7fffffffffffffff'));});Buffer.prototype.writeBigInt64BE=defineBigIntMethod(function writeBigInt64BE(value){var offset=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;return wrtBigUInt64BE(this,value,offset,-BigInt('0x8000000000000000'),BigInt('0x7fffffffffffffff'));});function checkIEEE754(buf,value,offset,ext,max,min){if(offset+ext>buf.length)throw new RangeError('Index out of range');if(offset<0)throw new RangeError('Index out of range');}function writeFloat(buf,value,offset,littleEndian,noAssert){value=+value;offset=offset>>>0;if(!noAssert){checkIEEE754(buf,value,offset,4,3.4028234663852886e+38,-3.4028234663852886e+38);}ieee754.write(buf,value,offset,littleEndian,23,4);return offset+4;}Buffer.prototype.writeFloatLE=function writeFloatLE(value,offset,noAssert){return writeFloat(this,value,offset,true,noAssert);};Buffer.prototype.writeFloatBE=function writeFloatBE(value,offset,noAssert){return writeFloat(this,value,offset,false,noAssert);};function writeDouble(buf,value,offset,littleEndian,noAssert){value=+value;offset=offset>>>0;if(!noAssert){checkIEEE754(buf,value,offset,8,1.7976931348623157E+308,-1.7976931348623157E+308);}ieee754.write(buf,value,offset,littleEndian,52,8);return offset+8;}Buffer.prototype.writeDoubleLE=function writeDoubleLE(value,offset,noAssert){return writeDouble(this,value,offset,true,noAssert);};Buffer.prototype.writeDoubleBE=function writeDoubleBE(value,offset,noAssert){return writeDouble(this,value,offset,false,noAssert);};// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy=function copy(target,targetStart,start,end){if(!Buffer.isBuffer(target))throw new TypeError('argument should be a Buffer');if(!start)start=0;if(!end&&end!==0)end=this.length;if(targetStart>=target.length)targetStart=target.length;if(!targetStart)targetStart=0;if(end>0&&end<start)end=start;// Copy 0 bytes; we're done
if(end===start)return 0;if(target.length===0||this.length===0)return 0;// Fatal error conditions
if(targetStart<0){throw new RangeError('targetStart out of bounds');}if(start<0||start>=this.length)throw new RangeError('Index out of range');if(end<0)throw new RangeError('sourceEnd out of bounds');// Are we oob?
if(end>this.length)end=this.length;if(target.length-targetStart<end-start){end=target.length-targetStart+start;}var len=end-start;if(this===target&&typeof Uint8Array.prototype.copyWithin==='function'){// Use built-in when available, missing from IE11
this.copyWithin(targetStart,start,end);}else{Uint8Array.prototype.set.call(target,this.subarray(start,end),targetStart);}return len;};// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill=function fill(val,start,end,encoding){// Handle string cases:
if(typeof val==='string'){if(typeof start==='string'){encoding=start;start=0;end=this.length;}else if(typeof end==='string'){encoding=end;end=this.length;}if(encoding!==undefined&&typeof encoding!=='string'){throw new TypeError('encoding must be a string');}if(typeof encoding==='string'&&!Buffer.isEncoding(encoding)){throw new TypeError('Unknown encoding: '+encoding);}if(val.length===1){var code=val.charCodeAt(0);if(encoding==='utf8'&&code<128||encoding==='latin1'){// Fast path: If `val` fits into a single byte, use that numeric value.
val=code;}}}else if(typeof val==='number'){val=val&255;}else if(typeof val==='boolean'){val=Number(val);}// Invalid ranges are not set to a default, so can range check early.
if(start<0||this.length<start||this.length<end){throw new RangeError('Out of range index');}if(end<=start){return this;}start=start>>>0;end=end===undefined?this.length:end>>>0;if(!val)val=0;var i;if(typeof val==='number'){for(i=start;i<end;++i){this[i]=val;}}else{var bytes=Buffer.isBuffer(val)?val:Buffer.from(val,encoding);var len=bytes.length;if(len===0){throw new TypeError('The value "'+val+'" is invalid for argument "value"');}for(i=0;i<end-start;++i){this[i+start]=bytes[i%len];}}return this;};// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
var errors={};function E(sym,getMessage,Base){errors[sym]=/*#__PURE__*/function(_Base){function NodeError(){var _this;_classCallCheck(this,NodeError);_this=_callSuper(this,NodeError);Object.defineProperty(_this,'message',{value:getMessage.apply(_this,arguments),writable:true,configurable:true});// Add the error code to the name to include it in the stack trace.
_this.name="".concat(_this.name," [").concat(sym,"]");// Access the stack to generate the error message including the error code
// from the name.
_this.stack;// eslint-disable-line no-unused-expressions
// Reset the name to the actual name.
delete _this.name;return _this;}_inherits(NodeError,_Base);return _createClass(NodeError,[{key:"code",get:function get(){return sym;},set:function set(value){Object.defineProperty(this,'code',{configurable:true,enumerable:true,value:value,writable:true});}},{key:"toString",value:function toString(){return"".concat(this.name," [").concat(sym,"]: ").concat(this.message);}}]);}(Base);}E('ERR_BUFFER_OUT_OF_BOUNDS',function(name){if(name){return"".concat(name," is outside of buffer bounds");}return'Attempt to access memory outside buffer bounds';},RangeError);E('ERR_INVALID_ARG_TYPE',function(name,actual){return"The \"".concat(name,"\" argument must be of type number. Received type ").concat(_typeof(actual));},TypeError);E('ERR_OUT_OF_RANGE',function(str,range,input){var msg="The value of \"".concat(str,"\" is out of range.");var received=input;if(Number.isInteger(input)&&Math.abs(input)>Math.pow(2,32)){received=addNumericalSeparator(String(input));}else if(typeof input==='bigint'){received=String(input);if(input>Math.pow(BigInt(2),BigInt(32))||input<-Math.pow(BigInt(2),BigInt(32))){received=addNumericalSeparator(received);}received+='n';}msg+=" It must be ".concat(range,". Received ").concat(received);return msg;},RangeError);function addNumericalSeparator(val){var res='';var i=val.length;var start=val[0]==='-'?1:0;for(;i>=start+4;i-=3){res="_".concat(val.slice(i-3,i)).concat(res);}return"".concat(val.slice(0,i)).concat(res);}// CHECK FUNCTIONS
// ===============
function checkBounds(buf,offset,byteLength){validateNumber(offset,'offset');if(buf[offset]===undefined||buf[offset+byteLength]===undefined){boundsError(offset,buf.length-(byteLength+1));}}function checkIntBI(value,min,max,buf,offset,byteLength){if(value>max||value<min){var n=typeof min==='bigint'?'n':'';var range;if(byteLength>3){if(min===0||min===BigInt(0)){range=">= 0".concat(n," and < 2").concat(n," ** ").concat((byteLength+1)*8).concat(n);}else{range=">= -(2".concat(n," ** ").concat((byteLength+1)*8-1).concat(n,") and < 2 ** ")+"".concat((byteLength+1)*8-1).concat(n);}}else{range=">= ".concat(min).concat(n," and <= ").concat(max).concat(n);}throw new errors.ERR_OUT_OF_RANGE('value',range,value);}checkBounds(buf,offset,byteLength);}function validateNumber(value,name){if(typeof value!=='number'){throw new errors.ERR_INVALID_ARG_TYPE(name,'number',value);}}function boundsError(value,length,type){if(Math.floor(value)!==value){validateNumber(value,type);throw new errors.ERR_OUT_OF_RANGE(type||'offset','an integer',value);}if(length<0){throw new errors.ERR_BUFFER_OUT_OF_BOUNDS();}throw new errors.ERR_OUT_OF_RANGE(type||'offset',">= ".concat(type?1:0," and <= ").concat(length),value);}// HELPER FUNCTIONS
// ================
var INVALID_BASE64_RE=/[^+/0-9A-Za-z-_]/g;function base64clean(str){// Node takes equal signs as end of the Base64 encoding
str=str.split('=')[0];// Node strips out invalid characters like \n and \t from the string, base64-js does not
str=str.trim().replace(INVALID_BASE64_RE,'');// Node converts strings with length < 2 to ''
if(str.length<2)return'';// Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
while(str.length%4!==0){str=str+'=';}return str;}function utf8ToBytes(string,units){units=units||Infinity;var codePoint;var length=string.length;var leadSurrogate=null;var bytes=[];for(var i=0;i<length;++i){codePoint=string.charCodeAt(i);// is surrogate component
if(codePoint>0xD7FF&&codePoint<0xE000){// last char was a lead
if(!leadSurrogate){// no lead yet
if(codePoint>0xDBFF){// unexpected trail
if((units-=3)>-1)bytes.push(0xEF,0xBF,0xBD);continue;}else if(i+1===length){// unpaired lead
if((units-=3)>-1)bytes.push(0xEF,0xBF,0xBD);continue;}// valid lead
leadSurrogate=codePoint;continue;}// 2 leads in a row
if(codePoint<0xDC00){if((units-=3)>-1)bytes.push(0xEF,0xBF,0xBD);leadSurrogate=codePoint;continue;}// valid surrogate pair
codePoint=(leadSurrogate-0xD800<<10|codePoint-0xDC00)+0x10000;}else if(leadSurrogate){// valid bmp char, but last char was a lead
if((units-=3)>-1)bytes.push(0xEF,0xBF,0xBD);}leadSurrogate=null;// encode utf8
if(codePoint<0x80){if((units-=1)<0)break;bytes.push(codePoint);}else if(codePoint<0x800){if((units-=2)<0)break;bytes.push(codePoint>>0x6|0xC0,codePoint&0x3F|0x80);}else if(codePoint<0x10000){if((units-=3)<0)break;bytes.push(codePoint>>0xC|0xE0,codePoint>>0x6&0x3F|0x80,codePoint&0x3F|0x80);}else if(codePoint<0x110000){if((units-=4)<0)break;bytes.push(codePoint>>0x12|0xF0,codePoint>>0xC&0x3F|0x80,codePoint>>0x6&0x3F|0x80,codePoint&0x3F|0x80);}else{throw new Error('Invalid code point');}}return bytes;}function asciiToBytes(str){var byteArray=[];for(var i=0;i<str.length;++i){// Node's code seems to be doing this and not & 0x7F..
byteArray.push(str.charCodeAt(i)&0xFF);}return byteArray;}function utf16leToBytes(str,units){var c,hi,lo;var byteArray=[];for(var i=0;i<str.length;++i){if((units-=2)<0)break;c=str.charCodeAt(i);hi=c>>8;lo=c%256;byteArray.push(lo);byteArray.push(hi);}return byteArray;}function base64ToBytes(str){return base64.toByteArray(base64clean(str));}function blitBuffer(src,dst,offset,length){var i;for(i=0;i<length;++i){if(i+offset>=dst.length||i>=src.length)break;dst[i+offset]=src[i];}return i;}// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance(obj,type){return obj instanceof type||obj!=null&&obj.constructor!=null&&obj.constructor.name!=null&&obj.constructor.name===type.name;}function numberIsNaN(obj){// For IE11 support
return obj!==obj;// eslint-disable-line no-self-compare
}// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var hexSliceLookupTable=function(){var alphabet='0123456789abcdef';var table=new Array(256);for(var i=0;i<16;++i){var i16=i*16;for(var j=0;j<16;++j){table[i16+j]=alphabet[i]+alphabet[j];}}return table;}();// Return not function with Error if BigInt not supported
function defineBigIntMethod(fn){return typeof BigInt==='undefined'?BufferBigIntNotDefined:fn;}function BufferBigIntNotDefined(){throw new Error('BigInt not supported');}/***/}),/***/9216:(/***/function(module){"use strict";module.exports=isMobile;module.exports.isMobile=isMobile;module.exports["default"]=isMobile;var mobileRE=/(android|bb\d+|meego).+mobile|armv7l|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|samsungbrowser.*mobile|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i;var notMobileRE=/CrOS/;var tabletRE=/android|ipad|playbook|silk/i;function isMobile(opts){if(!opts)opts={};var ua=opts.ua;if(!ua&&typeof navigator!=='undefined')ua=navigator.userAgent;if(ua&&ua.headers&&typeof ua.headers['user-agent']==='string'){ua=ua.headers['user-agent'];}if(typeof ua!=='string')return false;var result=mobileRE.test(ua)&&!notMobileRE.test(ua)||!!opts.tablet&&tabletRE.test(ua);if(!result&&opts.tablet&&opts.featureDetect&&navigator&&navigator.maxTouchPoints>1&&ua.indexOf('Macintosh')!==-1&&ua.indexOf('Safari')!==-1){result=true;}return result;}/***/}),/***/6296:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_52703__){"use strict";module.exports=createViewController;var createTurntable=__nested_webpack_require_52703__(7261);var createOrbit=__nested_webpack_require_52703__(9977);var createMatrix=__nested_webpack_require_52703__(4192);function ViewController(controllers,mode){this._controllerNames=Object.keys(controllers);this._controllerList=this._controllerNames.map(function(n){return controllers[n];});this._mode=mode;this._active=controllers[mode];if(!this._active){this._mode='turntable';this._active=controllers.turntable;}this.modes=this._controllerNames;this.computedMatrix=this._active.computedMatrix;this.computedEye=this._active.computedEye;this.computedUp=this._active.computedUp;this.computedCenter=this._active.computedCenter;this.computedRadius=this._active.computedRadius;}var proto=ViewController.prototype;proto.flush=function(a0){var cc=this._controllerList;for(var i=0;i<cc.length;++i){cc[i].flush(a0);}};proto.idle=function(a0){var cc=this._controllerList;for(var i=0;i<cc.length;++i){cc[i].idle(a0);}};proto.lookAt=function(a0,a1,a2,a3){var cc=this._controllerList;for(var i=0;i<cc.length;++i){cc[i].lookAt(a0,a1,a2,a3);}};proto.rotate=function(a0,a1,a2,a3){var cc=this._controllerList;for(var i=0;i<cc.length;++i){cc[i].rotate(a0,a1,a2,a3);}};proto.pan=function(a0,a1,a2,a3){var cc=this._controllerList;for(var i=0;i<cc.length;++i){cc[i].pan(a0,a1,a2,a3);}};proto.translate=function(a0,a1,a2,a3){var cc=this._controllerList;for(var i=0;i<cc.length;++i){cc[i].translate(a0,a1,a2,a3);}};proto.setMatrix=function(a0,a1){var cc=this._controllerList;for(var i=0;i<cc.length;++i){cc[i].setMatrix(a0,a1);}};proto.setDistanceLimits=function(a0,a1){var cc=this._controllerList;for(var i=0;i<cc.length;++i){cc[i].setDistanceLimits(a0,a1);}};proto.setDistance=function(a0,a1){var cc=this._controllerList;for(var i=0;i<cc.length;++i){cc[i].setDistance(a0,a1);}};proto.recalcMatrix=function(t){this._active.recalcMatrix(t);};proto.getDistance=function(t){return this._active.getDistance(t);};proto.getDistanceLimits=function(out){return this._active.getDistanceLimits(out);};proto.lastT=function(){return this._active.lastT();};proto.setMode=function(mode){if(mode===this._mode){return;}var idx=this._controllerNames.indexOf(mode);if(idx<0){return;}var prev=this._active;var next=this._controllerList[idx];var lastT=Math.max(prev.lastT(),next.lastT());prev.recalcMatrix(lastT);next.setMatrix(lastT,prev.computedMatrix);this._active=next;this._mode=mode;//Update matrix properties
this.computedMatrix=this._active.computedMatrix;this.computedEye=this._active.computedEye;this.computedUp=this._active.computedUp;this.computedCenter=this._active.computedCenter;this.computedRadius=this._active.computedRadius;};proto.getMode=function(){return this._mode;};function createViewController(options){options=options||{};var eye=options.eye||[0,0,1];var center=options.center||[0,0,0];var up=options.up||[0,1,0];var limits=options.distanceLimits||[0,Infinity];var mode=options.mode||'turntable';var turntable=createTurntable();var orbit=createOrbit();var matrix=createMatrix();turntable.setDistanceLimits(limits[0],limits[1]);turntable.lookAt(0,eye,center,up);orbit.setDistanceLimits(limits[0],limits[1]);orbit.lookAt(0,eye,center,up);matrix.setDistanceLimits(limits[0],limits[1]);matrix.lookAt(0,eye,center,up);return new ViewController({turntable:turntable,orbit:orbit,matrix:matrix},mode);}/***/}),/***/7169:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_56131__){"use strict";var weakMap=typeof WeakMap==='undefined'?__nested_webpack_require_56131__(1538):WeakMap;var createBuffer=__nested_webpack_require_56131__(2762);var createVAO=__nested_webpack_require_56131__(8116);var TriangleCache=new weakMap();function createABigTriangle(gl){var triangleVAO=TriangleCache.get(gl);var handle=triangleVAO&&(triangleVAO._triangleBuffer.handle||triangleVAO._triangleBuffer.buffer);if(!handle||!gl.isBuffer(handle)){var buf=createBuffer(gl,new Float32Array([-1,-1,-1,4,4,-1]));triangleVAO=createVAO(gl,[{buffer:buf,type:gl.FLOAT,size:2}]);triangleVAO._triangleBuffer=buf;TriangleCache.set(gl,triangleVAO);}triangleVAO.bind();gl.drawArrays(gl.TRIANGLES,0,3);triangleVAO.unbind();}module.exports=createABigTriangle;/***/}),/***/1085:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_56918__){var padLeft=__nested_webpack_require_56918__(1371);module.exports=addLineNumbers;function addLineNumbers(string,start,delim){start=typeof start==='number'?start:1;delim=delim||': ';var lines=string.split(/\r?\n/);var totalDigits=String(lines.length+start-1).length;return lines.map(function(line,i){var c=i+start;var digits=String(c).length;var prefix=padLeft(c,totalDigits-digits);return prefix+delim+line;}).join('\n');}/***/}),/***/3952:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_57413__){"use strict";module.exports=affineHull;var orient=__nested_webpack_require_57413__(3250);function linearlyIndependent(points,d){var nhull=new Array(d+1);for(var i=0;i<points.length;++i){nhull[i]=points[i];}for(var i=0;i<=points.length;++i){for(var j=points.length;j<=d;++j){var x=new Array(d);for(var k=0;k<d;++k){x[k]=Math.pow(j+1-i,k);}nhull[j]=x;}var o=orient.apply(void 0,nhull);if(o){return true;}}return false;}function affineHull(points){var n=points.length;if(n===0){return[];}if(n===1){return[0];}var d=points[0].length;var frame=[points[0]];var index=[0];for(var i=1;i<n;++i){frame.push(points[i]);if(!linearlyIndependent(frame,d)){frame.pop();continue;}index.push(i);if(index.length===d+1){return index;}}return index;}/***/}),/***/5995:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_58216__){"use strict";module.exports=alphaComplex;var delaunay=__nested_webpack_require_58216__(7642);var circumradius=__nested_webpack_require_58216__(6037);function alphaComplex(alpha,points){return delaunay(points).filter(function(cell){var simplex=new Array(cell.length);for(var i=0;i<cell.length;++i){simplex[i]=points[cell[i]];}return circumradius(simplex)*alpha<1;});}/***/}),/***/3502:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_58642__){module.exports=alphaShape;var ac=__nested_webpack_require_58642__(5995);var bnd=__nested_webpack_require_58642__(9127);function alphaShape(alpha,points){return bnd(ac(alpha,points));}/***/}),/***/6468:(/***/function(module){module.exports=function _atob(str){return atob(str);};/***/}),/***/2642:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_58980__){"use strict";module.exports=barycentric;var solve=__nested_webpack_require_58980__(727);function reduce(x){var r=0;for(var i=0;i<x.length;++i){r+=x[i];}return r;}function barycentric(simplex,point){var d=point.length;var A=new Array(d+1);for(var i=0;i<d;++i){var row=new Array(d+1);for(var j=0;j<=d;++j){row[j]=simplex[j][i];}A[i]=row;}A[d]=new Array(d+1);for(var i=0;i<=d;++i){A[d][i]=1;}var b=new Array(d+1);for(var i=0;i<d;++i){b[i]=point[i];}b[d]=1.0;var x=solve(A,b);var w=reduce(x[d+1]);if(w===0){w=1.0;}var y=new Array(d+1);for(var i=0;i<=d;++i){y[i]=reduce(x[i])/w;}return y;}/***/}),/***/7507:(/***/function(__unused_webpack_module,exports){"use strict";exports.byteLength=byteLength;exports.toByteArray=toByteArray;exports.fromByteArray=fromByteArray;var lookup=[];var revLookup=[];var Arr=typeof Uint8Array!=='undefined'?Uint8Array:Array;var code='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';for(var i=0,len=code.length;i<len;++i){lookup[i]=code[i];revLookup[code.charCodeAt(i)]=i;}// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)]=62;revLookup['_'.charCodeAt(0)]=63;function getLens(b64){var len=b64.length;if(len%4>0){throw new Error('Invalid string. Length must be a multiple of 4');}// Trim off extra bytes after placeholder bytes are found
// See: https://github.com/beatgammit/base64-js/issues/42
var validLen=b64.indexOf('=');if(validLen===-1)validLen=len;var placeHoldersLen=validLen===len?0:4-validLen%4;return[validLen,placeHoldersLen];}// base64 is 4/3 + up to two characters of the original data
function byteLength(b64){var lens=getLens(b64);var validLen=lens[0];var placeHoldersLen=lens[1];return(validLen+placeHoldersLen)*3/4-placeHoldersLen;}function _byteLength(b64,validLen,placeHoldersLen){return(validLen+placeHoldersLen)*3/4-placeHoldersLen;}function toByteArray(b64){var tmp;var lens=getLens(b64);var validLen=lens[0];var placeHoldersLen=lens[1];var arr=new Arr(_byteLength(b64,validLen,placeHoldersLen));var curByte=0;// if there are placeholders, only get up to the last complete 4 chars
var len=placeHoldersLen>0?validLen-4:validLen;var i;for(i=0;i<len;i+=4){tmp=revLookup[b64.charCodeAt(i)]<<18|revLookup[b64.charCodeAt(i+1)]<<12|revLookup[b64.charCodeAt(i+2)]<<6|revLookup[b64.charCodeAt(i+3)];arr[curByte++]=tmp>>16&0xFF;arr[curByte++]=tmp>>8&0xFF;arr[curByte++]=tmp&0xFF;}if(placeHoldersLen===2){tmp=revLookup[b64.charCodeAt(i)]<<2|revLookup[b64.charCodeAt(i+1)]>>4;arr[curByte++]=tmp&0xFF;}if(placeHoldersLen===1){tmp=revLookup[b64.charCodeAt(i)]<<10|revLookup[b64.charCodeAt(i+1)]<<4|revLookup[b64.charCodeAt(i+2)]>>2;arr[curByte++]=tmp>>8&0xFF;arr[curByte++]=tmp&0xFF;}return arr;}function tripletToBase64(num){return lookup[num>>18&0x3F]+lookup[num>>12&0x3F]+lookup[num>>6&0x3F]+lookup[num&0x3F];}function encodeChunk(uint8,start,end){var tmp;var output=[];for(var i=start;i<end;i+=3){tmp=(uint8[i]<<16&0xFF0000)+(uint8[i+1]<<8&0xFF00)+(uint8[i+2]&0xFF);output.push(tripletToBase64(tmp));}return output.join('');}function fromByteArray(uint8){var tmp;var len=uint8.length;var extraBytes=len%3;// if we have 1 byte left, pad 2 bytes
var parts=[];var maxChunkLength=16383;// must be multiple of 3
// go through the array every three bytes, we'll deal with trailing stuff later
for(var i=0,len2=len-extraBytes;i<len2;i+=maxChunkLength){parts.push(encodeChunk(uint8,i,i+maxChunkLength>len2?len2:i+maxChunkLength));}// pad the end with zeros, but make sure to not forget the extra bytes
if(extraBytes===1){tmp=uint8[len-1];parts.push(lookup[tmp>>2]+lookup[tmp<<4&0x3F]+'==');}else if(extraBytes===2){tmp=(uint8[len-2]<<8)+uint8[len-1];parts.push(lookup[tmp>>10]+lookup[tmp>>4&0x3F]+lookup[tmp<<2&0x3F]+'=');}return parts.join('');}/***/}),/***/3865:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_62848__){"use strict";var rationalize=__nested_webpack_require_62848__(869);module.exports=add;function add(a,b){return rationalize(a[0].mul(b[1]).add(b[0].mul(a[1])),a[1].mul(b[1]));}/***/}),/***/1318:(/***/function(module){"use strict";module.exports=cmp;function cmp(a,b){return a[0].mul(b[1]).cmp(b[0].mul(a[1]));}/***/}),/***/8697:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_63230__){"use strict";var rationalize=__nested_webpack_require_63230__(869);module.exports=div;function div(a,b){return rationalize(a[0].mul(b[1]),a[1].mul(b[0]));}/***/}),/***/7842:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_63458__){"use strict";var isRat=__nested_webpack_require_63458__(6330);var isBN=__nested_webpack_require_63458__(1533);var num2bn=__nested_webpack_require_63458__(2651);var str2bn=__nested_webpack_require_63458__(4387);var rationalize=__nested_webpack_require_63458__(869);var div=__nested_webpack_require_63458__(8697);module.exports=makeRational;function makeRational(numer,denom){if(isRat(numer)){if(denom){return div(numer,makeRational(denom));}return[numer[0].clone(),numer[1].clone()];}var shift=0;var a,b;if(isBN(numer)){a=numer.clone();}else if(typeof numer==='string'){a=str2bn(numer);}else if(numer===0){return[num2bn(0),num2bn(1)];}else if(numer===Math.floor(numer)){a=num2bn(numer);}else{while(numer!==Math.floor(numer)){numer=numer*Math.pow(2,256);shift-=256;}a=num2bn(numer);}if(isRat(denom)){a.mul(denom[1]);b=denom[0].clone();}else if(isBN(denom)){b=denom.clone();}else if(typeof denom==='string'){b=str2bn(denom);}else if(!denom){b=num2bn(1);}else if(denom===Math.floor(denom)){b=num2bn(denom);}else{while(denom!==Math.floor(denom)){denom=denom*Math.pow(2,256);shift+=256;}b=num2bn(denom);}if(shift>0){a=a.ushln(shift);}else if(shift<0){b=b.ushln(-shift);}return rationalize(a,b);}/***/}),/***/6330:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_64655__){"use strict";var isBN=__nested_webpack_require_64655__(1533);module.exports=isRat;function isRat(x){return Array.isArray(x)&&x.length===2&&isBN(x[0])&&isBN(x[1]);}/***/}),/***/5716:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_64891__){"use strict";var BN=__nested_webpack_require_64891__(6859);module.exports=sign;function sign(x){return x.cmp(new BN(0));}/***/}),/***/1369:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_65085__){"use strict";var sign=__nested_webpack_require_65085__(5716);module.exports=bn2num;//TODO: Make this better
function bn2num(b){var l=b.length;var words=b.words;var out=0;if(l===1){out=words[0];}else if(l===2){out=words[0]+words[1]*0x4000000;}else{for(var i=0;i<l;i++){var w=words[i];out+=w*Math.pow(0x4000000,i);}}return sign(b)*out;}/***/}),/***/4025:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_65492__){"use strict";var db=__nested_webpack_require_65492__(2361);var ctz=__nested_webpack_require_65492__(8828).countTrailingZeros;module.exports=ctzNumber;//Counts the number of trailing zeros
function ctzNumber(x){var l=ctz(db.lo(x));if(l<32){return l;}var h=ctz(db.hi(x));if(h>20){return 52;}return h+32;}/***/}),/***/1533:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_65854__){"use strict";var BN=__nested_webpack_require_65854__(6859);module.exports=isBN;//Test if x is a bignumber
//FIXME: obviously this is the wrong way to do it
function isBN(x){return x&&typeof x==='object'&&Boolean(x.words);}/***/}),/***/2651:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_66149__){"use strict";var BN=__nested_webpack_require_66149__(6859);var db=__nested_webpack_require_66149__(2361);module.exports=num2bn;function num2bn(x){var e=db.exponent(x);if(e<52){return new BN(x);}else{return new BN(x*Math.pow(2,52-e)).ushln(e-52);}}/***/}),/***/869:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_66455__){"use strict";var num2bn=__nested_webpack_require_66455__(2651);var sign=__nested_webpack_require_66455__(5716);module.exports=rationalize;function rationalize(numer,denom){var snumer=sign(numer);var sdenom=sign(denom);if(snumer===0){return[num2bn(0),num2bn(1)];}if(sdenom===0){return[num2bn(0),num2bn(0)];}if(sdenom<0){numer=numer.neg();denom=denom.neg();}var d=numer.gcd(denom);if(d.cmpn(1)){return[numer.div(d),denom.div(d)];}return[numer,denom];}/***/}),/***/4387:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_66964__){"use strict";var BN=__nested_webpack_require_66964__(6859);module.exports=str2BN;function str2BN(x){return new BN(x);}/***/}),/***/6504:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_67155__){"use strict";var rationalize=__nested_webpack_require_67155__(869);module.exports=mul;function mul(a,b){return rationalize(a[0].mul(b[0]),a[1].mul(b[1]));}/***/}),/***/7721:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_67383__){"use strict";var bnsign=__nested_webpack_require_67383__(5716);module.exports=sign;function sign(x){return bnsign(x[0])*bnsign(x[1]);}/***/}),/***/5572:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_67590__){"use strict";var rationalize=__nested_webpack_require_67590__(869);module.exports=sub;function sub(a,b){return rationalize(a[0].mul(b[1]).sub(a[1].mul(b[0])),a[1].mul(b[1]));}/***/}),/***/946:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_67837__){"use strict";var bn2num=__nested_webpack_require_67837__(1369);var ctz=__nested_webpack_require_67837__(4025);module.exports=roundRat;// Round a rational to the closest float
function roundRat(f){var a=f[0];var b=f[1];if(a.cmpn(0)===0){return 0;}var h=a.abs().divmod(b.abs());var iv=h.div;var x=bn2num(iv);var ir=h.mod;var sgn=a.negative!==b.negative?-1:1;if(ir.cmpn(0)===0){return sgn*x;}if(x){var s=ctz(x)+4;var y=bn2num(ir.ushln(s).divRound(b));return sgn*(x+y*Math.pow(2,-s));}else{var ybits=b.bitLength()-ir.bitLength()+53;var y=bn2num(ir.ushln(ybits).divRound(b));if(ybits<1023){return sgn*y*Math.pow(2,-ybits);}y*=Math.pow(2,-1023);return sgn*y*Math.pow(2,1023-ybits);}}/***/}),/***/2478:(/***/function(module){"use strict";// (a, y, c, l, h) = (array, y[, cmp, lo, hi])
function ge(a,y,c,l,h){var i=h+1;while(l<=h){var m=l+h>>>1,x=a[m];var p=c!==undefined?c(x,y):x-y;if(p>=0){i=m;h=m-1;}else{l=m+1;}}return i;};function gt(a,y,c,l,h){var i=h+1;while(l<=h){var m=l+h>>>1,x=a[m];var p=c!==undefined?c(x,y):x-y;if(p>0){i=m;h=m-1;}else{l=m+1;}}return i;};function lt(a,y,c,l,h){var i=l-1;while(l<=h){var m=l+h>>>1,x=a[m];var p=c!==undefined?c(x,y):x-y;if(p<0){i=m;l=m+1;}else{h=m-1;}}return i;};function le(a,y,c,l,h){var i=l-1;while(l<=h){var m=l+h>>>1,x=a[m];var p=c!==undefined?c(x,y):x-y;if(p<=0){i=m;l=m+1;}else{h=m-1;}}return i;};function eq(a,y,c,l,h){while(l<=h){var m=l+h>>>1,x=a[m];var p=c!==undefined?c(x,y):x-y;if(p===0){return m;}if(p<=0){l=m+1;}else{h=m-1;}}return-1;};function norm(a,y,c,l,h,f){if(typeof c==='function'){return f(a,y,c,l===undefined?0:l|0,h===undefined?a.length-1:h|0);}return f(a,y,undefined,c===undefined?0:c|0,l===undefined?a.length-1:l|0);}module.exports={ge:function(a,y,c,l,h){return norm(a,y,c,l,h,ge);},gt:function(a,y,c,l,h){return norm(a,y,c,l,h,gt);},lt:function(a,y,c,l,h){return norm(a,y,c,l,h,lt);},le:function(a,y,c,l,h){return norm(a,y,c,l,h,le);},eq:function(a,y,c,l,h){return norm(a,y,c,l,h,eq);}};/***/}),/***/8828:(/***/function(__unused_webpack_module,exports){"use strict";/**
 * Bit twiddling hacks for JavaScript.
 *
 * Author: Mikola Lysenko
 *
 * Ported from Stanford bit twiddling hack library:
 *    http://graphics.stanford.edu/~seander/bithacks.html
 */"use restrict";//Number of bits in an integer
var INT_BITS=32;//Constants
exports.INT_BITS=INT_BITS;exports.INT_MAX=0x7fffffff;exports.INT_MIN=-1<<INT_BITS-1;//Returns -1, 0, +1 depending on sign of x
exports.sign=function(v){return(v>0)-(v<0);};//Computes absolute value of integer
exports.abs=function(v){var mask=v>>INT_BITS-1;return(v^mask)-mask;};//Computes minimum of integers x and y
exports.min=function(x,y){return y^(x^y)&-(x<y);};//Computes maximum of integers x and y
exports.max=function(x,y){return x^(x^y)&-(x<y);};//Checks if a number is a power of two
exports.isPow2=function(v){return!(v&v-1)&&!!v;};//Computes log base 2 of v
exports.log2=function(v){var r,shift;r=(v>0xFFFF)<<4;v>>>=r;shift=(v>0xFF)<<3;v>>>=shift;r|=shift;shift=(v>0xF)<<2;v>>>=shift;r|=shift;shift=(v>0x3)<<1;v>>>=shift;r|=shift;return r|v>>1;};//Computes log base 10 of v
exports.log10=function(v){return v>=1000000000?9:v>=100000000?8:v>=10000000?7:v>=1000000?6:v>=100000?5:v>=10000?4:v>=1000?3:v>=100?2:v>=10?1:0;};//Counts number of bits
exports.popCount=function(v){v=v-(v>>>1&0x55555555);v=(v&0x33333333)+(v>>>2&0x33333333);return(v+(v>>>4)&0xF0F0F0F)*0x1010101>>>24;};//Counts number of trailing zeros
function countTrailingZeros(v){var c=32;v&=-v;if(v)c--;if(v&0x0000FFFF)c-=16;if(v&0x00FF00FF)c-=8;if(v&0x0F0F0F0F)c-=4;if(v&0x33333333)c-=2;if(v&0x55555555)c-=1;return c;}exports.countTrailingZeros=countTrailingZeros;//Rounds to next power of 2
exports.nextPow2=function(v){v+=v===0;--v;v|=v>>>1;v|=v>>>2;v|=v>>>4;v|=v>>>8;v|=v>>>16;return v+1;};//Rounds down to previous power of 2
exports.prevPow2=function(v){v|=v>>>1;v|=v>>>2;v|=v>>>4;v|=v>>>8;v|=v>>>16;return v-(v>>>1);};//Computes parity of word
exports.parity=function(v){v^=v>>>16;v^=v>>>8;v^=v>>>4;v&=0xf;return 0x6996>>>v&1;};var REVERSE_TABLE=new Array(256);(function(tab){for(var i=0;i<256;++i){var v=i,r=i,s=7;for(v>>>=1;v;v>>>=1){r<<=1;r|=v&1;--s;}tab[i]=r<<s&0xff;}})(REVERSE_TABLE);//Reverse bits in a 32 bit word
exports.reverse=function(v){return REVERSE_TABLE[v&0xff]<<24|REVERSE_TABLE[v>>>8&0xff]<<16|REVERSE_TABLE[v>>>16&0xff]<<8|REVERSE_TABLE[v>>>24&0xff];};//Interleave bits of 2 coordinates with 16 bits.  Useful for fast quadtree codes
exports.interleave2=function(x,y){x&=0xFFFF;x=(x|x<<8)&0x00FF00FF;x=(x|x<<4)&0x0F0F0F0F;x=(x|x<<2)&0x33333333;x=(x|x<<1)&0x55555555;y&=0xFFFF;y=(y|y<<8)&0x00FF00FF;y=(y|y<<4)&0x0F0F0F0F;y=(y|y<<2)&0x33333333;y=(y|y<<1)&0x55555555;return x|y<<1;};//Extracts the nth interleaved component
exports.deinterleave2=function(v,n){v=v>>>n&0x55555555;v=(v|v>>>1)&0x33333333;v=(v|v>>>2)&0x0F0F0F0F;v=(v|v>>>4)&0x00FF00FF;v=(v|v>>>16)&0x000FFFF;return v<<16>>16;};//Interleave bits of 3 coordinates, each with 10 bits.  Useful for fast octree codes
exports.interleave3=function(x,y,z){x&=0x3FF;x=(x|x<<16)&4278190335;x=(x|x<<8)&251719695;x=(x|x<<4)&3272356035;x=(x|x<<2)&1227133513;y&=0x3FF;y=(y|y<<16)&4278190335;y=(y|y<<8)&251719695;y=(y|y<<4)&3272356035;y=(y|y<<2)&1227133513;x|=y<<1;z&=0x3FF;z=(z|z<<16)&4278190335;z=(z|z<<8)&251719695;z=(z|z<<4)&3272356035;z=(z|z<<2)&1227133513;return x|z<<2;};//Extracts nth interleaved component of a 3-tuple
exports.deinterleave3=function(v,n){v=v>>>n&1227133513;v=(v|v>>>2)&3272356035;v=(v|v>>>4)&251719695;v=(v|v>>>8)&4278190335;v=(v|v>>>16)&0x3FF;return v<<22>>22;};//Computes next combination in colexicographic order (this is mistakenly called nextPermutation on the bit twiddling hacks page)
exports.nextCombination=function(v){var t=v|v-1;return t+1|(~t&-~t)-1>>>countTrailingZeros(v)+1;};/***/}),/***/6859:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_73652__){/* module decorator */module=__nested_webpack_require_73652__.nmd(module);(function(module,exports){'use strict';// Utils
function assert(val,msg){if(!val)throw new Error(msg||'Assertion failed');}// Could use `inherits` module, but don't want to move from single file
// architecture yet.
function inherits(ctor,superCtor){ctor.super_=superCtor;var TempCtor=function(){};TempCtor.prototype=superCtor.prototype;ctor.prototype=new TempCtor();ctor.prototype.constructor=ctor;}// BN
function BN(number,base,endian){if(BN.isBN(number)){return number;}this.negative=0;this.words=null;this.length=0;// Reduction context
this.red=null;if(number!==null){if(base==='le'||base==='be'){endian=base;base=10;}this._init(number||0,base||10,endian||'be');}}if(typeof module==='object'){module.exports=BN;}else{exports.BN=BN;}BN.BN=BN;BN.wordSize=26;var Buffer;try{if(typeof window!=='undefined'&&typeof window.Buffer!=='undefined'){Buffer=window.Buffer;}else{Buffer=__nested_webpack_require_73652__(7790).Buffer;}}catch(e){}BN.isBN=function isBN(num){if(num instanceof BN){return true;}return num!==null&&typeof num==='object'&&num.constructor.wordSize===BN.wordSize&&Array.isArray(num.words);};BN.max=function max(left,right){if(left.cmp(right)>0)return left;return right;};BN.min=function min(left,right){if(left.cmp(right)<0)return left;return right;};BN.prototype._init=function init(number,base,endian){if(typeof number==='number'){return this._initNumber(number,base,endian);}if(typeof number==='object'){return this._initArray(number,base,endian);}if(base==='hex'){base=16;}assert(base===(base|0)&&base>=2&&base<=36);number=number.toString().replace(/\s+/g,'');var start=0;if(number[0]==='-'){start++;this.negative=1;}if(start<number.length){if(base===16){this._parseHex(number,start,endian);}else{this._parseBase(number,base,start);if(endian==='le'){this._initArray(this.toArray(),base,endian);}}}};BN.prototype._initNumber=function _initNumber(number,base,endian){if(number<0){this.negative=1;number=-number;}if(number<0x4000000){this.words=[number&0x3ffffff];this.length=1;}else if(number<0x10000000000000){this.words=[number&0x3ffffff,number/0x4000000&0x3ffffff];this.length=2;}else{assert(number<0x20000000000000);// 2 ^ 53 (unsafe)
this.words=[number&0x3ffffff,number/0x4000000&0x3ffffff,1];this.length=3;}if(endian!=='le')return;// Reverse the bytes
this._initArray(this.toArray(),base,endian);};BN.prototype._initArray=function _initArray(number,base,endian){// Perhaps a Uint8Array
assert(typeof number.length==='number');if(number.length<=0){this.words=[0];this.length=1;return this;}this.length=Math.ceil(number.length/3);this.words=new Array(this.length);for(var i=0;i<this.length;i++){this.words[i]=0;}var j,w;var off=0;if(endian==='be'){for(i=number.length-1,j=0;i>=0;i-=3){w=number[i]|number[i-1]<<8|number[i-2]<<16;this.words[j]|=w<<off&0x3ffffff;this.words[j+1]=w>>>26-off&0x3ffffff;off+=24;if(off>=26){off-=26;j++;}}}else if(endian==='le'){for(i=0,j=0;i<number.length;i+=3){w=number[i]|number[i+1]<<8|number[i+2]<<16;this.words[j]|=w<<off&0x3ffffff;this.words[j+1]=w>>>26-off&0x3ffffff;off+=24;if(off>=26){off-=26;j++;}}}return this.strip();};function parseHex4Bits(string,index){var c=string.charCodeAt(index);// 'A' - 'F'
if(c>=65&&c<=70){return c-55;// 'a' - 'f'
}else if(c>=97&&c<=102){return c-87;// '0' - '9'
}else{return c-48&0xf;}}function parseHexByte(string,lowerBound,index){var r=parseHex4Bits(string,index);if(index-1>=lowerBound){r|=parseHex4Bits(string,index-1)<<4;}return r;}BN.prototype._parseHex=function _parseHex(number,start,endian){// Create possibly bigger array to ensure that it fits the number
this.length=Math.ceil((number.length-start)/6);this.words=new Array(this.length);for(var i=0;i<this.length;i++){this.words[i]=0;}// 24-bits chunks
var off=0;var j=0;var w;if(endian==='be'){for(i=number.length-1;i>=start;i-=2){w=parseHexByte(number,start,i)<<off;this.words[j]|=w&0x3ffffff;if(off>=18){off-=18;j+=1;this.words[j]|=w>>>26;}else{off+=8;}}}else{var parseLength=number.length-start;for(i=parseLength%2===0?start+1:start;i<number.length;i+=2){w=parseHexByte(number,start,i)<<off;this.words[j]|=w&0x3ffffff;if(off>=18){off-=18;j+=1;this.words[j]|=w>>>26;}else{off+=8;}}}this.strip();};function parseBase(str,start,end,mul){var r=0;var len=Math.min(str.length,end);for(var i=start;i<len;i++){var c=str.charCodeAt(i)-48;r*=mul;// 'a'
if(c>=49){r+=c-49+0xa;// 'A'
}else if(c>=17){r+=c-17+0xa;// '0' - '9'
}else{r+=c;}}return r;}BN.prototype._parseBase=function _parseBase(number,base,start){// Initialize as zero
this.words=[0];this.length=1;// Find length of limb in base
for(var limbLen=0,limbPow=1;limbPow<=0x3ffffff;limbPow*=base){limbLen++;}limbLen--;limbPow=limbPow/base|0;var total=number.length-start;var mod=total%limbLen;var end=Math.min(total,total-mod)+start;var word=0;for(var i=start;i<end;i+=limbLen){word=parseBase(number,i,i+limbLen,base);this.imuln(limbPow);if(this.words[0]+word<0x4000000){this.words[0]+=word;}else{this._iaddn(word);}}if(mod!==0){var pow=1;word=parseBase(number,i,number.length,base);for(i=0;i<mod;i++){pow*=base;}this.imuln(pow);if(this.words[0]+word<0x4000000){this.words[0]+=word;}else{this._iaddn(word);}}this.strip();};BN.prototype.copy=function copy(dest){dest.words=new Array(this.length);for(var i=0;i<this.length;i++){dest.words[i]=this.words[i];}dest.length=this.length;dest.negative=this.negative;dest.red=this.red;};BN.prototype.clone=function clone(){var r=new BN(null);this.copy(r);return r;};BN.prototype._expand=function _expand(size){while(this.length<size){this.words[this.length++]=0;}return this;};// Remove leading `0` from `this`
BN.prototype.strip=function strip(){while(this.length>1&&this.words[this.length-1]===0){this.length--;}return this._normSign();};BN.prototype._normSign=function _normSign(){// -0 = 0
if(this.length===1&&this.words[0]===0){this.negative=0;}return this;};BN.prototype.inspect=function inspect(){return(this.red?'<BN-R: ':'<BN: ')+this.toString(16)+'>';};/*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */var zeros=['','0','00','000','0000','00000','000000','0000000','00000000','000000000','0000000000','00000000000','000000000000','0000000000000','00000000000000','000000000000000','0000000000000000','00000000000000000','000000000000000000','0000000000000000000','00000000000000000000','000000000000000000000','0000000000000000000000','00000000000000000000000','000000000000000000000000','0000000000000000000000000'];var groupSizes=[0,0,25,16,12,11,10,9,8,8,7,7,7,7,6,6,6,6,6,6,6,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5];var groupBases=[0,0,33554432,43046721,16777216,48828125,60466176,40353607,16777216,43046721,10000000,19487171,35831808,62748517,7529536,11390625,16777216,24137569,34012224,47045881,64000000,4084101,5153632,6436343,7962624,9765625,11881376,14348907,17210368,20511149,24300000,28629151,33554432,39135393,45435424,52521875,60466176];BN.prototype.toString=function toString(base,padding){base=base||10;padding=padding|0||1;var out;if(base===16||base==='hex'){out='';var off=0;var carry=0;for(var i=0;i<this.length;i++){var w=this.words[i];var word=((w<<off|carry)&0xffffff).toString(16);carry=w>>>24-off&0xffffff;if(carry!==0||i!==this.length-1){out=zeros[6-word.length]+word+out;}else{out=word+out;}off+=2;if(off>=26){off-=26;i--;}}if(carry!==0){out=carry.toString(16)+out;}while(out.length%padding!==0){out='0'+out;}if(this.negative!==0){out='-'+out;}return out;}if(base===(base|0)&&base>=2&&base<=36){// var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
var groupSize=groupSizes[base];// var groupBase = Math.pow(base, groupSize);
var groupBase=groupBases[base];out='';var c=this.clone();c.negative=0;while(!c.isZero()){var r=c.modn(groupBase).toString(base);c=c.idivn(groupBase);if(!c.isZero()){out=zeros[groupSize-r.length]+r+out;}else{out=r+out;}}if(this.isZero()){out='0'+out;}while(out.length%padding!==0){out='0'+out;}if(this.negative!==0){out='-'+out;}return out;}assert(false,'Base should be between 2 and 36');};BN.prototype.toNumber=function toNumber(){var ret=this.words[0];if(this.length===2){ret+=this.words[1]*0x4000000;}else if(this.length===3&&this.words[2]===0x01){// NOTE: at this stage it is known that the top bit is set
ret+=0x10000000000000+this.words[1]*0x4000000;}else if(this.length>2){assert(false,'Number can only safely store up to 53 bits');}return this.negative!==0?-ret:ret;};BN.prototype.toJSON=function toJSON(){return this.toString(16);};BN.prototype.toBuffer=function toBuffer(endian,length){assert(typeof Buffer!=='undefined');return this.toArrayLike(Buffer,endian,length);};BN.prototype.toArray=function toArray(endian,length){return this.toArrayLike(Array,endian,length);};BN.prototype.toArrayLike=function toArrayLike(ArrayType,endian,length){var byteLength=this.byteLength();var reqLength=length||Math.max(1,byteLength);assert(byteLength<=reqLength,'byte array longer than desired length');assert(reqLength>0,'Requested array length <= 0');this.strip();var littleEndian=endian==='le';var res=new ArrayType(reqLength);var b,i;var q=this.clone();if(!littleEndian){// Assume big-endian
for(i=0;i<reqLength-byteLength;i++){res[i]=0;}for(i=0;!q.isZero();i++){b=q.andln(0xff);q.iushrn(8);res[reqLength-i-1]=b;}}else{for(i=0;!q.isZero();i++){b=q.andln(0xff);q.iushrn(8);res[i]=b;}for(;i<reqLength;i++){res[i]=0;}}return res;};if(Math.clz32){BN.prototype._countBits=function _countBits(w){return 32-Math.clz32(w);};}else{BN.prototype._countBits=function _countBits(w){var t=w;var r=0;if(t>=0x1000){r+=13;t>>>=13;}if(t>=0x40){r+=7;t>>>=7;}if(t>=0x8){r+=4;t>>>=4;}if(t>=0x02){r+=2;t>>>=2;}return r+t;};}BN.prototype._zeroBits=function _zeroBits(w){// Short-cut
if(w===0)return 26;var t=w;var r=0;if((t&0x1fff)===0){r+=13;t>>>=13;}if((t&0x7f)===0){r+=7;t>>>=7;}if((t&0xf)===0){r+=4;t>>>=4;}if((t&0x3)===0){r+=2;t>>>=2;}if((t&0x1)===0){r++;}return r;};// Return number of used bits in a BN
BN.prototype.bitLength=function bitLength(){var w=this.words[this.length-1];var hi=this._countBits(w);return(this.length-1)*26+hi;};function toBitArray(num){var w=new Array(num.bitLength());for(var bit=0;bit<w.length;bit++){var off=bit/26|0;var wbit=bit%26;w[bit]=(num.words[off]&1<<wbit)>>>wbit;}return w;}// Number of trailing zero bits
BN.prototype.zeroBits=function zeroBits(){if(this.isZero())return 0;var r=0;for(var i=0;i<this.length;i++){var b=this._zeroBits(this.words[i]);r+=b;if(b!==26)break;}return r;};BN.prototype.byteLength=function byteLength(){return Math.ceil(this.bitLength()/8);};BN.prototype.toTwos=function toTwos(width){if(this.negative!==0){return this.abs().inotn(width).iaddn(1);}return this.clone();};BN.prototype.fromTwos=function fromTwos(width){if(this.testn(width-1)){return this.notn(width).iaddn(1).ineg();}return this.clone();};BN.prototype.isNeg=function isNeg(){return this.negative!==0;};// Return negative clone of `this`
BN.prototype.neg=function neg(){return this.clone().ineg();};BN.prototype.ineg=function ineg(){if(!this.isZero()){this.negative^=1;}return this;};// Or `num` with `this` in-place
BN.prototype.iuor=function iuor(num){while(this.length<num.length){this.words[this.length++]=0;}for(var i=0;i<num.length;i++){this.words[i]=this.words[i]|num.words[i];}return this.strip();};BN.prototype.ior=function ior(num){assert((this.negative|num.negative)===0);return this.iuor(num);};// Or `num` with `this`
BN.prototype.or=function or(num){if(this.length>num.length)return this.clone().ior(num);return num.clone().ior(this);};BN.prototype.uor=function uor(num){if(this.length>num.length)return this.clone().iuor(num);return num.clone().iuor(this);};// And `num` with `this` in-place
BN.prototype.iuand=function iuand(num){// b = min-length(num, this)
var b;if(this.length>num.length){b=num;}else{b=this;}for(var i=0;i<b.length;i++){this.words[i]=this.words[i]&num.words[i];}this.length=b.length;return this.strip();};BN.prototype.iand=function iand(num){assert((this.negative|num.negative)===0);return this.iuand(num);};// And `num` with `this`
BN.prototype.and=function and(num){if(this.length>num.length)return this.clone().iand(num);return num.clone().iand(this);};BN.prototype.uand=function uand(num){if(this.length>num.length)return this.clone().iuand(num);return num.clone().iuand(this);};// Xor `num` with `this` in-place
BN.prototype.iuxor=function iuxor(num){// a.length > b.length
var a;var b;if(this.length>num.length){a=this;b=num;}else{a=num;b=this;}for(var i=0;i<b.length;i++){this.words[i]=a.words[i]^b.words[i];}if(this!==a){for(;i<a.length;i++){this.words[i]=a.words[i];}}this.length=a.length;return this.strip();};BN.prototype.ixor=function ixor(num){assert((this.negative|num.negative)===0);return this.iuxor(num);};// Xor `num` with `this`
BN.prototype.xor=function xor(num){if(this.length>num.length)return this.clone().ixor(num);return num.clone().ixor(this);};BN.prototype.uxor=function uxor(num){if(this.length>num.length)return this.clone().iuxor(num);return num.clone().iuxor(this);};// Not ``this`` with ``width`` bitwidth
BN.prototype.inotn=function inotn(width){assert(typeof width==='number'&&width>=0);var bytesNeeded=Math.ceil(width/26)|0;var bitsLeft=width%26;// Extend the buffer with leading zeroes
this._expand(bytesNeeded);if(bitsLeft>0){bytesNeeded--;}// Handle complete words
for(var i=0;i<bytesNeeded;i++){this.words[i]=~this.words[i]&0x3ffffff;}// Handle the residue
if(bitsLeft>0){this.words[i]=~this.words[i]&0x3ffffff>>26-bitsLeft;}// And remove leading zeroes
return this.strip();};BN.prototype.notn=function notn(width){return this.clone().inotn(width);};// Set `bit` of `this`
BN.prototype.setn=function setn(bit,val){assert(typeof bit==='number'&&bit>=0);var off=bit/26|0;var wbit=bit%26;this._expand(off+1);if(val){this.words[off]=this.words[off]|1<<wbit;}else{this.words[off]=this.words[off]&~(1<<wbit);}return this.strip();};// Add `num` to `this` in-place
BN.prototype.iadd=function iadd(num){var r;// negative + positive
if(this.negative!==0&&num.negative===0){this.negative=0;r=this.isub(num);this.negative^=1;return this._normSign();// positive + negative
}else if(this.negative===0&&num.negative!==0){num.negative=0;r=this.isub(num);num.negative=1;return r._normSign();}// a.length > b.length
var a,b;if(this.length>num.length){a=this;b=num;}else{a=num;b=this;}var carry=0;for(var i=0;i<b.length;i++){r=(a.words[i]|0)+(b.words[i]|0)+carry;this.words[i]=r&0x3ffffff;carry=r>>>26;}for(;carry!==0&&i<a.length;i++){r=(a.words[i]|0)+carry;this.words[i]=r&0x3ffffff;carry=r>>>26;}this.length=a.length;if(carry!==0){this.words[this.length]=carry;this.length++;// Copy the rest of the words
}else if(a!==this){for(;i<a.length;i++){this.words[i]=a.words[i];}}return this;};// Add `num` to `this`
BN.prototype.add=function add(num){var res;if(num.negative!==0&&this.negative===0){num.negative=0;res=this.sub(num);num.negative^=1;return res;}else if(num.negative===0&&this.negative!==0){this.negative=0;res=num.sub(this);this.negative=1;return res;}if(this.length>num.length)return this.clone().iadd(num);return num.clone().iadd(this);};// Subtract `num` from `this` in-place
BN.prototype.isub=function isub(num){// this - (-num) = this + num
if(num.negative!==0){num.negative=0;var r=this.iadd(num);num.negative=1;return r._normSign();// -this - num = -(this + num)
}else if(this.negative!==0){this.negative=0;this.iadd(num);this.negative=1;return this._normSign();}// At this point both numbers are positive
var cmp=this.cmp(num);// Optimization - zeroify
if(cmp===0){this.negative=0;this.length=1;this.words[0]=0;return this;}// a > b
var a,b;if(cmp>0){a=this;b=num;}else{a=num;b=this;}var carry=0;for(var i=0;i<b.length;i++){r=(a.words[i]|0)-(b.words[i]|0)+carry;carry=r>>26;this.words[i]=r&0x3ffffff;}for(;carry!==0&&i<a.length;i++){r=(a.words[i]|0)+carry;carry=r>>26;this.words[i]=r&0x3ffffff;}// Copy rest of the words
if(carry===0&&i<a.length&&a!==this){for(;i<a.length;i++){this.words[i]=a.words[i];}}this.length=Math.max(this.length,i);if(a!==this){this.negative=1;}return this.strip();};// Subtract `num` from `this`
BN.prototype.sub=function sub(num){return this.clone().isub(num);};function smallMulTo(self,num,out){out.negative=num.negative^self.negative;var len=self.length+num.length|0;out.length=len;len=len-1|0;// Peel one iteration (compiler can't do it, because of code complexity)
var a=self.words[0]|0;var b=num.words[0]|0;var r=a*b;var lo=r&0x3ffffff;var carry=r/0x4000000|0;out.words[0]=lo;for(var k=1;k<len;k++){// Sum all words with the same `i + j = k` and accumulate `ncarry`,
// note that ncarry could be >= 0x3ffffff
var ncarry=carry>>>26;var rword=carry&0x3ffffff;var maxJ=Math.min(k,num.length-1);for(var j=Math.max(0,k-self.length+1);j<=maxJ;j++){var i=k-j|0;a=self.words[i]|0;b=num.words[j]|0;r=a*b+rword;ncarry+=r/0x4000000|0;rword=r&0x3ffffff;}out.words[k]=rword|0;carry=ncarry|0;}if(carry!==0){out.words[k]=carry|0;}else{out.length--;}return out.strip();}// TODO(indutny): it may be reasonable to omit it for users who don't need
// to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
// multiplication (like elliptic secp256k1).
var comb10MulTo=function comb10MulTo(self,num,out){var a=self.words;var b=num.words;var o=out.words;var c=0;var lo;var mid;var hi;var a0=a[0]|0;var al0=a0&0x1fff;var ah0=a0>>>13;var a1=a[1]|0;var al1=a1&0x1fff;var ah1=a1>>>13;var a2=a[2]|0;var al2=a2&0x1fff;var ah2=a2>>>13;var a3=a[3]|0;var al3=a3&0x1fff;var ah3=a3>>>13;var a4=a[4]|0;var al4=a4&0x1fff;var ah4=a4>>>13;var a5=a[5]|0;var al5=a5&0x1fff;var ah5=a5>>>13;var a6=a[6]|0;var al6=a6&0x1fff;var ah6=a6>>>13;var a7=a[7]|0;var al7=a7&0x1fff;var ah7=a7>>>13;var a8=a[8]|0;var al8=a8&0x1fff;var ah8=a8>>>13;var a9=a[9]|0;var al9=a9&0x1fff;var ah9=a9>>>13;var b0=b[0]|0;var bl0=b0&0x1fff;var bh0=b0>>>13;var b1=b[1]|0;var bl1=b1&0x1fff;var bh1=b1>>>13;var b2=b[2]|0;var bl2=b2&0x1fff;var bh2=b2>>>13;var b3=b[3]|0;var bl3=b3&0x1fff;var bh3=b3>>>13;var b4=b[4]|0;var bl4=b4&0x1fff;var bh4=b4>>>13;var b5=b[5]|0;var bl5=b5&0x1fff;var bh5=b5>>>13;var b6=b[6]|0;var bl6=b6&0x1fff;var bh6=b6>>>13;var b7=b[7]|0;var bl7=b7&0x1fff;var bh7=b7>>>13;var b8=b[8]|0;var bl8=b8&0x1fff;var bh8=b8>>>13;var b9=b[9]|0;var bl9=b9&0x1fff;var bh9=b9>>>13;out.negative=self.negative^num.negative;out.length=19;/* k = 0 */lo=Math.imul(al0,bl0);mid=Math.imul(al0,bh0);mid=mid+Math.imul(ah0,bl0)|0;hi=Math.imul(ah0,bh0);var w0=(c+lo|0)+((mid&0x1fff)<<13)|0;c=(hi+(mid>>>13)|0)+(w0>>>26)|0;w0&=0x3ffffff;/* k = 1 */lo=Math.imul(al1,bl0);mid=Math.imul(al1,bh0);mid=mid+Math.imul(ah1,bl0)|0;hi=Math.imul(ah1,bh0);lo=lo+Math.imul(al0,bl1)|0;mid=mid+Math.imul(al0,bh1)|0;mid=mid+Math.imul(ah0,bl1)|0;hi=hi+Math.imul(ah0,bh1)|0;var w1=(c+lo|0)+((mid&0x1fff)<<13)|0;c=(hi+(mid>>>13)|0)+(w1>>>26)|0;w1&=0x3ffffff;/* k = 2 */lo=Math.imul(al2,bl0);mid=Math.imul(al2,bh0);mid=mid+Math.imul(ah2,bl0)|0;hi=Math.imul(ah2,bh0);lo=lo+Math.imul(al1,bl1)|0;mid=mid+Math.imul(al1,bh1)|0;mid=mid+Math.imul(ah1,bl1)|0;hi=hi+Math.imul(ah1,bh1)|0;lo=lo+Math.imul(al0,bl2)|0;mid=mid+Math.imul(al0,bh2)|0;mid=mid+Math.imul(ah0,bl2)|0;hi=hi+Math.imul(ah0,bh2)|0;var w2=(c+lo|0)+((mid&0x1fff)<<13)|0;c=(hi+(mid>>>13)|0)+(w2>>>26)|0;w2&=0x3ffffff;/* k = 3 */lo=Math.imul(al3,bl0);mid=Math.imul(al3,bh0);mid=mid+Math.imul(ah3,bl0)|0;hi=Math.imul(ah3,bh0);lo=lo+Math.imul(al2,bl1)|0;mid=mid+Math.imul(al2,bh1)|0;mid=mid+Math.imul(ah2,bl1)|0;hi=hi+Math.imul(ah2,bh1)|0;lo=lo+Math.imul(al1,bl2)|0;mid=mid+Math.imul(al1,bh2)|0;mid=mid+Math.imul(ah1,bl2)|0;hi=hi+Math.imul(ah1,bh2)|0;lo=lo+Math.imul(al0,bl3)|0;mid=mid+Math.imul(al0,bh3)|0;mid=mid+Math.imul(ah0,bl3)|0;hi=hi+Math.imul(ah0,bh3)|0;var w3=(c+lo|0)+((mid&0x1fff)<<13)|0;c=(hi+(mid>>>13)|0)+(w3>>>26)|0;w3&=0x3ffffff;/* k = 4 */lo=Math.imul(al4,bl0);mid=Math.imul(al4,bh0);mid=mid+Math.imul(ah4,bl0)|0;hi=Math.imul(ah4,bh0);lo=lo+Math.imul(al3,bl1)|0;mid=mid+Math.imul(al3,bh1)|0;mid=mid+Math.imul(ah3,bl1)|0;hi=hi+Math.imul(ah3,bh1)|0;lo=lo+Math.imul(al2,bl2)|0;mid=mid+Math.imul(al2,bh2)|0;mid=mid+Math.imul(ah2,bl2)|0;hi=hi+Math.imul(ah2,bh2)|0;lo=lo+Math.imul(al1,bl3)|0;mid=mid+Math.imul(al1,bh3)|0;mid=mid+Math.imul(ah1,bl3)|0;hi=hi+Math.imul(ah1,bh3)|0;lo=lo+Math.imul(al0,bl4)|0;mid=mid+Math.imul(al0,bh4)|0;mid=mid+Math.imul(ah0,bl4)|0;hi=hi+Math.imul(ah0,bh4)|0;var w4=(c+lo|0)+((mid&0x1fff)<<13)|0;c=(hi+(mid>>>13)|0)+(w4>>>26)|0;w4&=0x3ffffff;/* k = 5 */lo=Math.imul(al5,bl0);mid=Math.imul(al5,bh0);mid=mid+Math.imul(ah5,bl0)|0;hi=Math.imul(ah5,bh0);lo=lo+Math.imul(al4,bl1)|0;mid=mid+Math.imul(al4,bh1)|0;mid=mid+Math.imul(ah4,bl1)|0;hi=hi+Math.imul(ah4,bh1)|0;lo=lo+Math.imul(al3,bl2)|0;mid=mid+Math.imul(al3,bh2)|0;mid=mid+Math.imul(ah3,bl2)|0;hi=hi+Math.imul(ah3,bh2)|0;lo=lo+Math.imul(al2,bl3)|0;mid=mid+Math.imul(al2,bh3)|0;mid=mid+Math.imul(ah2,bl3)|0;hi=hi+Math.imul(ah2,bh3)|0;lo=lo+Math.imul(al1,bl4)|0;mid=mid+Math.imul(al1,bh4)|0;mid=mid+Math.imul(ah1,bl4)|0;hi=hi+Math.imul(ah1,bh4)|0;lo=lo+Math.imul(al0,bl5)|0;mid=mid+Math.imul(al0,bh5)|0;mid=mid+Math.imul(ah0,bl5)|0;hi=hi+Math.imul(ah0,bh5)|0;var w5=(c+lo|0)+((mid&0x1fff)<<13)|0;c=(hi+(mid>>>13)|0)+(w5>>>26)|0;w5&=0x3ffffff;/* k = 6 */lo=Math.imul(al6,bl0);mid=Math.imul(al6,bh0);mid=mid+Math.imul(ah6,bl0)|0;hi=Math.imul(ah6,bh0);lo=lo+Math.imul(al5,bl1)|0;mid=mid+Math.imul(al5,bh1)|0;mid=mid+Math.imul(ah5,bl1)|0;hi=hi+Math.imul(ah5,bh1)|0;lo=lo+Math.imul(al4,bl2)|0;mid=mid+Math.imul(al4,bh2)|0;mid=mid+Math.imul(ah4,bl2)|0;hi=hi+Math.imul(ah4,bh2)|0;lo=lo+Math.imul(al3,bl3)|0;mid=mid+Math.imul(al3,bh3)|0;mid=mid+Math.imul(ah3,bl3)|0;hi=hi+Math.imul(ah3,bh3)|0;lo=lo+Math.imul(al2,bl4)|0;mid=mid+Math.imul(al2,bh4)|0;mid=mid+Math.imul(ah2,bl4)|0;hi=hi+Math.imul(ah2,bh4)|0;lo=lo+Math.imul(al1,bl5)|0;mid=mid+Math.imul(al1,bh5)|0;mid=mid+Math.imul(ah1,bl5)|0;hi=hi+Math.imul(ah1,bh5)|0;lo=lo+Math.imul(al0,bl6)|0;mid=mid+Math.imul(al0,bh6)|0;mid=mid+Math.imul(ah0,bl6)|0;hi=hi+Math.imul(ah0,bh6)|0;var w6=(c+lo|0)+((mid&0x1fff)<<13)|0;c=(hi+(mid>>>13)|0)+(w6>>>26)|0;w6&=0x3ffffff;/* k = 7 */lo=Math.imul(al7,bl0);mid=Math.imul(al7,bh0);mid=mid+Math.imul(ah7,bl0)|0;hi=Math.imul(ah7,bh0);lo=lo+Math.imul(al6,bl1)|0;mid=mid+Math.imul(al6,bh1)|0;mid=mid+Math.imul(ah6,bl1)|0;hi=hi+Math.imul(ah6,bh1)|0;lo=lo+Math.imul(al5,bl2)|0;mid=mid+Math.imul(al5,bh2)|0;mid=mid+Math.imul(ah5,bl2)|0;hi=hi+Math.imul(ah5,bh2)|0;lo=lo+Math.imul(al4,bl3)|0;mid=mid+Math.imul(al4,bh3)|0;mid=mid+Math.imul(ah4,bl3)|0;hi=hi+Math.imul(ah4,bh3)|0;lo=lo+Math.imul(al3,bl4)|0;mid=mid+Math.imul(al3,bh4)|0;mid=mid+Math.imul(ah3,bl4)|0;hi=hi+Math.imul(ah3,bh4)|0;lo=lo+Math.imul(al2,bl5)|0;mid=mid+Math.imul(al2,bh5)|0;mid=mid+Math.imul(ah2,bl5)|0;hi=hi+Math.imul(ah2,bh5)|0;lo=lo+Math.imul(al1,bl6)|0;mid=mid+Math.imul(al1,bh6)|0;mid=mid+Math.imul(ah1,bl6)|0;hi=hi+Math.imul(ah1,bh6)|0;lo=lo+Math.imul(al0,bl7)|0;mid=mid+Math.imul(al0,bh7)|0;mid=mid+Math.imul(ah0,bl7)|0;hi=hi+Math.imul(ah0,bh7)|0;var w7=(c+lo|0)+((mid&0x1fff)<<13)|0;c=(hi+(mid>>>13)|0)+(w7>>>26)|0;w7&=0x3ffffff;/* k = 8 */lo=Math.imul(al8,bl0);mid=Math.imul(al8,bh0);mid=mid+Math.imul(ah8,bl0)|0;hi=Math.imul(ah8,bh0);lo=lo+Math.imul(al7,bl1)|0;mid=mid+Math.imul(al7,bh1)|0;mid=mid+Math.imul(ah7,bl1)|0;hi=hi+Math.imul(ah7,bh1)|0;lo=lo+Math.imul(al6,bl2)|0;mid=mid+Math.imul(al6,bh2)|0;mid=mid+Math.imul(ah6,bl2)|0;hi=hi+Math.imul(ah6,bh2)|0;lo=lo+Math.imul(al5,bl3)|0;mid=mid+Math.imul(al5,bh3)|0;mid=mid+Math.imul(ah5,bl3)|0;hi=hi+Math.imul(ah5,bh3)|0;lo=lo+Math.imul(al4,bl4)|0;mid=mid+Math.imul(al4,bh4)|0;mid=mid+Math.imul(ah4,bl4)|0;hi=hi+Math.imul(ah4,bh4)|0;lo=lo+Math.imul(al3,bl5)|0;mid=mid+Math.imul(al3,bh5)|0;mid=mid+Math.imul(ah3,bl5)|0;hi=hi+Math.imul(ah3,bh5)|0;lo=lo+Math.imul(al2,bl6)|0;mid=mid+Math.imul(al2,bh6)|0;mid=mid+Math.imul(ah2,bl6)|0;hi=hi+Math.imul(ah2,bh6)|0;lo=lo+Math.imul(al1,bl7)|0;mid=mid+Math.imul(al1,bh7)|0;mid=mid+Math.imul(ah1,bl7)|0;hi=hi+Math.imul(ah1,bh7)|0;lo=lo+Math.imul(al0,bl8)|0;mid=mid+Math.imul(al0,bh8)|0;mid=mid+Math.imul(ah0,bl8)|0;hi=hi+Math.imul(ah0,bh8)|0;var w8=(c+lo|0)+((mid&0x1fff)<<13)|0;c=(hi+(mid>>>13)|0)+(w8>>>26)|0;w8&=0x3ffffff;/* k = 9 */lo=Math.imul(al9,bl0);mid=Math.imul(al9,bh0);mid=mid+Math.imul(ah9,bl0)|0;hi=Math.imul(ah9,bh0);lo=lo+Math.imul(al8,bl1)|0;mid=mid+Math.imul(al8,bh1)|0;mid=mid+Math.imul(ah8,bl1)|0;hi=hi+Math.imul(ah8,bh1)|0;lo=lo+Math.imul(al7,bl2)|0;mid=mid+Math.imul(al7,bh2)|0;mid=mid+Math.imul(ah7,bl2)|0;hi=hi+Math.imul(ah7,bh2)|0;lo=lo+Math.imul(al6,bl3)|0;mid=mid+Math.imul(al6,bh3)|0;mid=mid+Math.imul(ah6,bl3)|0;hi=hi+Math.imul(ah6,bh3)|0;lo=lo+Math.imul(al5,bl4)|0;mid=mid+Math.imul(al5,bh4)|0;mid=mid+Math.imul(ah5,bl4)|0;hi=hi+Math.imul(ah5,bh4)|0;lo=lo+Math.imul(al4,bl5)|0;mid=mid+Math.imul(al4,bh5)|0;mid=mid+Math.imul(ah4,bl5)|0;hi=hi+Math.imul(ah4,bh5)|0;lo=lo+Math.imul(al3,bl6)|0;mid=mid+Math.imul(al3,bh6)|0;mid=mid+Math.imul(ah3,bl6)|0;hi=hi+Math.imul(ah3,bh6)|0;lo=lo+Math.imul(al2,bl7)|0;mid=mid+Math.imul(al2,bh7)|0;mid=mid+Math.imul(ah2,bl7)|0;hi=hi+Math.imul(ah2,bh7)|0;lo=lo+Math.imul(al1,bl8)|0;mid=mid+Math.imul(al1,bh8)|0;mid=mid+Math.imul(ah1,bl8)|0;hi=hi+Math.imul(ah1,bh8)|0;lo=lo+Math.imul(al0,bl9)|0;mid=mid+Math.imul(al0,bh9)|0;mid=mid+Math.imul(ah0,bl9)|0;hi=hi+Math.imul(ah0,bh9)|0;var w9=(c+lo|0)+((mid&0x1fff)<<13)|0;c=(hi+(mid>>>13)|0)+(w9>>>26)|0;w9&=0x3ffffff;/* k = 10 */lo=Math.imul(al9,bl1);mid=Math.imul(al9,bh1);mid=mid+Math.imul(ah9,bl1)|0;hi=Math.imul(ah9,bh1);lo=lo+Math.imul(al8,bl2)|0;mid=mid+Math.imul(al8,bh2)|0;mid=mid+Math.imul(ah8,bl2)|0;hi=hi+Math.imul(ah8,bh2)|0;lo=lo+Math.imul(al7,bl3)|0;mid=mid+Math.imul(al7,bh3)|0;mid=mid+Math.imul(ah7,bl3)|0;hi=hi+Math.imul(ah7,bh3)|0;lo=lo+Math.imul(al6,bl4)|0;mid=mid+Math.imul(al6,bh4)|0;mid=mid+Math.imul(ah6,bl4)|0;hi=hi+Math.imul(ah6,bh4)|0;lo=lo+Math.imul(al5,bl5)|0;mid=mid+Math.imul(al5,bh5)|0;mid=mid+Math.imul(ah5,bl5)|0;hi=hi+Math.imul(ah5,bh5)|0;lo=lo+Math.imul(al4,bl6)|0;mid=mid+Math.imul(al4,bh6)|0;mid=mid+Math.imul(ah4,bl6)|0;hi=hi+Math.imul(ah4,bh6)|0;lo=lo+Math.imul(al3,bl7)|0;mid=mid+Math.imul(al3,bh7)|0;mid=mid+Math.imul(ah3,bl7)|0;hi=hi+Math.imul(ah3,bh7)|0;lo=lo+Math.imul(al2,bl8)|0;mid=mid+Math.imul(al2,bh8)|0;mid=mid+Math.imul(ah2,bl8)|0;hi=hi+Math.imul(ah2,bh8)|0;lo=lo+Math.imul(al1,bl9)|0;mid=mid+Math.imul(al1,bh9)|0;mid=mid+Math.imul(ah1,bl9)|0;hi=hi+Math.imul(ah1,bh9)|0;var w10=(c+lo|0)+((mid&0x1fff)<<13)|0;c=(hi+(mid>>>13)|0)+(w10>>>26)|0;w10&=0x3ffffff;/* k = 11 */lo=Math.imul(al9,bl2);mid=Math.imul(al9,bh2);mid=mid+Math.imul(ah9,bl2)|0;hi=Math.imul(ah9,bh2);lo=lo+Math.imul(al8,bl3)|0;mid=mid+Math.imul(al8,bh3)|0;mid=mid+Math.imul(ah8,bl3)|0;hi=hi+Math.imul(ah8,bh3)|0;lo=lo+Math.imul(al7,bl4)|0;mid=mid+Math.imul(al7,bh4)|0;mid=mid+Math.imul(ah7,bl4)|0;hi=hi+Math.imul(ah7,bh4)|0;lo=lo+Math.imul(al6,bl5)|0;mid=mid+Math.imul(al6,bh5)|0;mid=mid+Math.imul(ah6,bl5)|0;hi=hi+Math.imul(ah6,bh5)|0;lo=lo+Math.imul(al5,bl6)|0;mid=mid+Math.imul(al5,bh6)|0;mid=mid+Math.imul(ah5,bl6)|0;hi=hi+Math.imul(ah5,bh6)|0;lo=lo+Math.imul(al4,bl7)|0;mid=mid+Math.imul(al4,bh7)|0;mid=mid+Math.imul(ah4,bl7)|0;hi=hi+Math.imul(ah4,bh7)|0;lo=lo+Math.imul(al3,bl8)|0;mid=mid+Math.imul(al3,bh8)|0;mid=mid+Math.imul(ah3,bl8)|0;hi=hi+Math.imul(ah3,bh8)|0;lo=lo+Math.imul(al2,bl9)|0;mid=mid+Math.imul(al2,bh9)|0;mid=mid+Math.imul(ah2,bl9)|0;hi=hi+Math.imul(ah2,bh9)|0;var w11=(c+lo|0)+((mid&0x1fff)<<13)|0;c=(hi+(mid>>>13)|0)+(w11>>>26)|0;w11&=0x3ffffff;/* k = 12 */lo=Math.imul(al9,bl3);mid=Math.imul(al9,bh3);mid=mid+Math.imul(ah9,bl3)|0;hi=Math.imul(ah9,bh3);lo=lo+Math.imul(al8,bl4)|0;mid=mid+Math.imul(al8,bh4)|0;mid=mid+Math.imul(ah8,bl4)|0;hi=hi+Math.imul(ah8,bh4)|0;lo=lo+Math.imul(al7,bl5)|0;mid=mid+Math.imul(al7,bh5)|0;mid=mid+Math.imul(ah7,bl5)|0;hi=hi+Math.imul(ah7,bh5)|0;lo=lo+Math.imul(al6,bl6)|0;mid=mid+Math.imul(al6,bh6)|0;mid=mid+Math.imul(ah6,bl6)|0;hi=hi+Math.imul(ah6,bh6)|0;lo=lo+Math.imul(al5,bl7)|0;mid=mid+Math.imul(al5,bh7)|0;mid=mid+Math.imul(ah5,bl7)|0;hi=hi+Math.imul(ah5,bh7)|0;lo=lo+Math.imul(al4,bl8)|0;mid=mid+Math.imul(al4,bh8)|0;mid=mid+Math.imul(ah4,bl8)|0;hi=hi+Math.imul(ah4,bh8)|0;lo=lo+Math.imul(al3,bl9)|0;mid=mid+Math.imul(al3,bh9)|0;mid=mid+Math.imul(ah3,bl9)|0;hi=hi+Math.imul(ah3,bh9)|0;var w12=(c+lo|0)+((mid&0x1fff)<<13)|0;c=(hi+(mid>>>13)|0)+(w12>>>26)|0;w12&=0x3ffffff;/* k = 13 */lo=Math.imul(al9,bl4);mid=Math.imul(al9,bh4);mid=mid+Math.imul(ah9,bl4)|0;hi=Math.imul(ah9,bh4);lo=lo+Math.imul(al8,bl5)|0;mid=mid+Math.imul(al8,bh5)|0;mid=mid+Math.imul(ah8,bl5)|0;hi=hi+Math.imul(ah8,bh5)|0;lo=lo+Math.imul(al7,bl6)|0;mid=mid+Math.imul(al7,bh6)|0;mid=mid+Math.imul(ah7,bl6)|0;hi=hi+Math.imul(ah7,bh6)|0;lo=lo+Math.imul(al6,bl7)|0;mid=mid+Math.imul(al6,bh7)|0;mid=mid+Math.imul(ah6,bl7)|0;hi=hi+Math.imul(ah6,bh7)|0;lo=lo+Math.imul(al5,bl8)|0;mid=mid+Math.imul(al5,bh8)|0;mid=mid+Math.imul(ah5,bl8)|0;hi=hi+Math.imul(ah5,bh8)|0;lo=lo+Math.imul(al4,bl9)|0;mid=mid+Math.imul(al4,bh9)|0;mid=mid+Math.imul(ah4,bl9)|0;hi=hi+Math.imul(ah4,bh9)|0;var w13=(c+lo|0)+((mid&0x1fff)<<13)|0;c=(hi+(mid>>>13)|0)+(w13>>>26)|0;w13&=0x3ffffff;/* k = 14 */lo=Math.imul(al9,bl5);mid=Math.imul(al9,bh5);mid=mid+Math.imul(ah9,bl5)|0;hi=Math.imul(ah9,bh5);lo=lo+Math.imul(al8,bl6)|0;mid=mid+Math.imul(al8,bh6)|0;mid=mid+Math.imul(ah8,bl6)|0;hi=hi+Math.imul(ah8,bh6)|0;lo=lo+Math.imul(al7,bl7)|0;mid=mid+Math.imul(al7,bh7)|0;mid=mid+Math.imul(ah7,bl7)|0;hi=hi+Math.imul(ah7,bh7)|0;lo=lo+Math.imul(al6,bl8)|0;mid=mid+Math.imul(al6,bh8)|0;mid=mid+Math.imul(ah6,bl8)|0;hi=hi+Math.imul(ah6,bh8)|0;lo=lo+Math.imul(al5,bl9)|0;mid=mid+Math.imul(al5,bh9)|0;mid=mid+Math.imul(ah5,bl9)|0;hi=hi+Math.imul(ah5,bh9)|0;var w14=(c+lo|0)+((mid&0x1fff)<<13)|0;c=(hi+(mid>>>13)|0)+(w14>>>26)|0;w14&=0x3ffffff;/* k = 15 */lo=Math.imul(al9,bl6);mid=Math.imul(al9,bh6);mid=mid+Math.imul(ah9,bl6)|0;hi=Math.imul(ah9,bh6);lo=lo+Math.imul(al8,bl7)|0;mid=mid+Math.imul(al8,bh7)|0;mid=mid+Math.imul(ah8,bl7)|0;hi=hi+Math.imul(ah8,bh7)|0;lo=lo+Math.imul(al7,bl8)|0;mid=mid+Math.imul(al7,bh8)|0;mid=mid+Math.imul(ah7,bl8)|0;hi=hi+Math.imul(ah7,bh8)|0;lo=lo+Math.imul(al6,bl9)|0;mid=mid+Math.imul(al6,bh9)|0;mid=mid+Math.imul(ah6,bl9)|0;hi=hi+Math.imul(ah6,bh9)|0;var w15=(c+lo|0)+((mid&0x1fff)<<13)|0;c=(hi+(mid>>>13)|0)+(w15>>>26)|0;w15&=0x3ffffff;/* k = 16 */lo=Math.imul(al9,bl7);mid=Math.imul(al9,bh7);mid=mid+Math.imul(ah9,bl7)|0;hi=Math.imul(ah9,bh7);lo=lo+Math.imul(al8,bl8)|0;mid=mid+Math.imul(al8,bh8)|0;mid=mid+Math.imul(ah8,bl8)|0;hi=hi+Math.imul(ah8,bh8)|0;lo=lo+Math.imul(al7,bl9)|0;mid=mid+Math.imul(al7,bh9)|0;mid=mid+Math.imul(ah7,bl9)|0;hi=hi+Math.imul(ah7,bh9)|0;var w16=(c+lo|0)+((mid&0x1fff)<<13)|0;c=(hi+(mid>>>13)|0)+(w16>>>26)|0;w16&=0x3ffffff;/* k = 17 */lo=Math.imul(al9,bl8);mid=Math.imul(al9,bh8);mid=mid+Math.imul(ah9,bl8)|0;hi=Math.imul(ah9,bh8);lo=lo+Math.imul(al8,bl9)|0;mid=mid+Math.imul(al8,bh9)|0;mid=mid+Math.imul(ah8,bl9)|0;hi=hi+Math.imul(ah8,bh9)|0;var w17=(c+lo|0)+((mid&0x1fff)<<13)|0;c=(hi+(mid>>>13)|0)+(w17>>>26)|0;w17&=0x3ffffff;/* k = 18 */lo=Math.imul(al9,bl9);mid=Math.imul(al9,bh9);mid=mid+Math.imul(ah9,bl9)|0;hi=Math.imul(ah9,bh9);var w18=(c+lo|0)+((mid&0x1fff)<<13)|0;c=(hi+(mid>>>13)|0)+(w18>>>26)|0;w18&=0x3ffffff;o[0]=w0;o[1]=w1;o[2]=w2;o[3]=w3;o[4]=w4;o[5]=w5;o[6]=w6;o[7]=w7;o[8]=w8;o[9]=w9;o[10]=w10;o[11]=w11;o[12]=w12;o[13]=w13;o[14]=w14;o[15]=w15;o[16]=w16;o[17]=w17;o[18]=w18;if(c!==0){o[19]=c;out.length++;}return out;};// Polyfill comb
if(!Math.imul){comb10MulTo=smallMulTo;}function bigMulTo(self,num,out){out.negative=num.negative^self.negative;out.length=self.length+num.length;var carry=0;var hncarry=0;for(var k=0;k<out.length-1;k++){// Sum all words with the same `i + j = k` and accumulate `ncarry`,
// note that ncarry could be >= 0x3ffffff
var ncarry=hncarry;hncarry=0;var rword=carry&0x3ffffff;var maxJ=Math.min(k,num.length-1);for(var j=Math.max(0,k-self.length+1);j<=maxJ;j++){var i=k-j;var a=self.words[i]|0;var b=num.words[j]|0;var r=a*b;var lo=r&0x3ffffff;ncarry=ncarry+(r/0x4000000|0)|0;lo=lo+rword|0;rword=lo&0x3ffffff;ncarry=ncarry+(lo>>>26)|0;hncarry+=ncarry>>>26;ncarry&=0x3ffffff;}out.words[k]=rword;carry=ncarry;ncarry=hncarry;}if(carry!==0){out.words[k]=carry;}else{out.length--;}return out.strip();}function jumboMulTo(self,num,out){var fftm=new FFTM();return fftm.mulp(self,num,out);}BN.prototype.mulTo=function mulTo(num,out){var res;var len=this.length+num.length;if(this.length===10&&num.length===10){res=comb10MulTo(this,num,out);}else if(len<63){res=smallMulTo(this,num,out);}else if(len<1024){res=bigMulTo(this,num,out);}else{res=jumboMulTo(this,num,out);}return res;};// Cooley-Tukey algorithm for FFT
// slightly revisited to rely on looping instead of recursion
function FFTM(x,y){this.x=x;this.y=y;}FFTM.prototype.makeRBT=function makeRBT(N){var t=new Array(N);var l=BN.prototype._countBits(N)-1;for(var i=0;i<N;i++){t[i]=this.revBin(i,l,N);}return t;};// Returns binary-reversed representation of `x`
FFTM.prototype.revBin=function revBin(x,l,N){if(x===0||x===N-1)return x;var rb=0;for(var i=0;i<l;i++){rb|=(x&1)<<l-i-1;x>>=1;}return rb;};// Performs "tweedling" phase, therefore 'emulating'
// behaviour of the recursive algorithm
FFTM.prototype.permute=function permute(rbt,rws,iws,rtws,itws,N){for(var i=0;i<N;i++){rtws[i]=rws[rbt[i]];itws[i]=iws[rbt[i]];}};FFTM.prototype.transform=function transform(rws,iws,rtws,itws,N,rbt){this.permute(rbt,rws,iws,rtws,itws,N);for(var s=1;s<N;s<<=1){var l=s<<1;var rtwdf=Math.cos(2*Math.PI/l);var itwdf=Math.sin(2*Math.PI/l);for(var p=0;p<N;p+=l){var rtwdf_=rtwdf;var itwdf_=itwdf;for(var j=0;j<s;j++){var re=rtws[p+j];var ie=itws[p+j];var ro=rtws[p+j+s];var io=itws[p+j+s];var rx=rtwdf_*ro-itwdf_*io;io=rtwdf_*io+itwdf_*ro;ro=rx;rtws[p+j]=re+ro;itws[p+j]=ie+io;rtws[p+j+s]=re-ro;itws[p+j+s]=ie-io;/* jshint maxdepth : false */if(j!==l){rx=rtwdf*rtwdf_-itwdf*itwdf_;itwdf_=rtwdf*itwdf_+itwdf*rtwdf_;rtwdf_=rx;}}}}};FFTM.prototype.guessLen13b=function guessLen13b(n,m){var N=Math.max(m,n)|1;var odd=N&1;var i=0;for(N=N/2|0;N;N=N>>>1){i++;}return 1<<i+1+odd;};FFTM.prototype.conjugate=function conjugate(rws,iws,N){if(N<=1)return;for(var i=0;i<N/2;i++){var t=rws[i];rws[i]=rws[N-i-1];rws[N-i-1]=t;t=iws[i];iws[i]=-iws[N-i-1];iws[N-i-1]=-t;}};FFTM.prototype.normalize13b=function normalize13b(ws,N){var carry=0;for(var i=0;i<N/2;i++){var w=Math.round(ws[2*i+1]/N)*0x2000+Math.round(ws[2*i]/N)+carry;ws[i]=w&0x3ffffff;if(w<0x4000000){carry=0;}else{carry=w/0x4000000|0;}}return ws;};FFTM.prototype.convert13b=function convert13b(ws,len,rws,N){var carry=0;for(var i=0;i<len;i++){carry=carry+(ws[i]|0);rws[2*i]=carry&0x1fff;carry=carry>>>13;rws[2*i+1]=carry&0x1fff;carry=carry>>>13;}// Pad with zeroes
for(i=2*len;i<N;++i){rws[i]=0;}assert(carry===0);assert((carry&~0x1fff)===0);};FFTM.prototype.stub=function stub(N){var ph=new Array(N);for(var i=0;i<N;i++){ph[i]=0;}return ph;};FFTM.prototype.mulp=function mulp(x,y,out){var N=2*this.guessLen13b(x.length,y.length);var rbt=this.makeRBT(N);var _=this.stub(N);var rws=new Array(N);var rwst=new Array(N);var iwst=new Array(N);var nrws=new Array(N);var nrwst=new Array(N);var niwst=new Array(N);var rmws=out.words;rmws.length=N;this.convert13b(x.words,x.length,rws,N);this.convert13b(y.words,y.length,nrws,N);this.transform(rws,_,rwst,iwst,N,rbt);this.transform(nrws,_,nrwst,niwst,N,rbt);for(var i=0;i<N;i++){var rx=rwst[i]*nrwst[i]-iwst[i]*niwst[i];iwst[i]=rwst[i]*niwst[i]+iwst[i]*nrwst[i];rwst[i]=rx;}this.conjugate(rwst,iwst,N);this.transform(rwst,iwst,rmws,_,N,rbt);this.conjugate(rmws,_,N);this.normalize13b(rmws,N);out.negative=x.negative^y.negative;out.length=x.length+y.length;return out.strip();};// Multiply `this` by `num`
BN.prototype.mul=function mul(num){var out=new BN(null);out.words=new Array(this.length+num.length);return this.mulTo(num,out);};// Multiply employing FFT
BN.prototype.mulf=function mulf(num){var out=new BN(null);out.words=new Array(this.length+num.length);return jumboMulTo(this,num,out);};// In-place Multiplication
BN.prototype.imul=function imul(num){return this.clone().mulTo(num,this);};BN.prototype.imuln=function imuln(num){assert(typeof num==='number');assert(num<0x4000000);// Carry
var carry=0;for(var i=0;i<this.length;i++){var w=(this.words[i]|0)*num;var lo=(w&0x3ffffff)+(carry&0x3ffffff);carry>>=26;carry+=w/0x4000000|0;// NOTE: lo is 27bit maximum
carry+=lo>>>26;this.words[i]=lo&0x3ffffff;}if(carry!==0){this.words[i]=carry;this.length++;}return this;};BN.prototype.muln=function muln(num){return this.clone().imuln(num);};// `this` * `this`
BN.prototype.sqr=function sqr(){return this.mul(this);};// `this` * `this` in-place
BN.prototype.isqr=function isqr(){return this.imul(this.clone());};// Math.pow(`this`, `num`)
BN.prototype.pow=function pow(num){var w=toBitArray(num);if(w.length===0)return new BN(1);// Skip leading zeroes
var res=this;for(var i=0;i<w.length;i++,res=res.sqr()){if(w[i]!==0)break;}if(++i<w.length){for(var q=res.sqr();i<w.length;i++,q=q.sqr()){if(w[i]===0)continue;res=res.mul(q);}}return res;};// Shift-left in-place
BN.prototype.iushln=function iushln(bits){assert(typeof bits==='number'&&bits>=0);var r=bits%26;var s=(bits-r)/26;var carryMask=0x3ffffff>>>26-r<<26-r;var i;if(r!==0){var carry=0;for(i=0;i<this.length;i++){var newCarry=this.words[i]&carryMask;var c=(this.words[i]|0)-newCarry<<r;this.words[i]=c|carry;carry=newCarry>>>26-r;}if(carry){this.words[i]=carry;this.length++;}}if(s!==0){for(i=this.length-1;i>=0;i--){this.words[i+s]=this.words[i];}for(i=0;i<s;i++){this.words[i]=0;}this.length+=s;}return this.strip();};BN.prototype.ishln=function ishln(bits){// TODO(indutny): implement me
assert(this.negative===0);return this.iushln(bits);};// Shift-right in-place
// NOTE: `hint` is a lowest bit before trailing zeroes
// NOTE: if `extended` is present - it will be filled with destroyed bits
BN.prototype.iushrn=function iushrn(bits,hint,extended){assert(typeof bits==='number'&&bits>=0);var h;if(hint){h=(hint-hint%26)/26;}else{h=0;}var r=bits%26;var s=Math.min((bits-r)/26,this.length);var mask=0x3ffffff^0x3ffffff>>>r<<r;var maskedWords=extended;h-=s;h=Math.max(0,h);// Extended mode, copy masked part
if(maskedWords){for(var i=0;i<s;i++){maskedWords.words[i]=this.words[i];}maskedWords.length=s;}if(s===0){// No-op, we should not move anything at all
}else if(this.length>s){this.length-=s;for(i=0;i<this.length;i++){this.words[i]=this.words[i+s];}}else{this.words[0]=0;this.length=1;}var carry=0;for(i=this.length-1;i>=0&&(carry!==0||i>=h);i--){var word=this.words[i]|0;this.words[i]=carry<<26-r|word>>>r;carry=word&mask;}// Push carried bits as a mask
if(maskedWords&&carry!==0){maskedWords.words[maskedWords.length++]=carry;}if(this.length===0){this.words[0]=0;this.length=1;}return this.strip();};BN.prototype.ishrn=function ishrn(bits,hint,extended){// TODO(indutny): implement me
assert(this.negative===0);return this.iushrn(bits,hint,extended);};// Shift-left
BN.prototype.shln=function shln(bits){return this.clone().ishln(bits);};BN.prototype.ushln=function ushln(bits){return this.clone().iushln(bits);};// Shift-right
BN.prototype.shrn=function shrn(bits){return this.clone().ishrn(bits);};BN.prototype.ushrn=function ushrn(bits){return this.clone().iushrn(bits);};// Test if n bit is set
BN.prototype.testn=function testn(bit){assert(typeof bit==='number'&&bit>=0);var r=bit%26;var s=(bit-r)/26;var q=1<<r;// Fast case: bit is much higher than all existing words
if(this.length<=s)return false;// Check bit and return
var w=this.words[s];return!!(w&q);};// Return only lowers bits of number (in-place)
BN.prototype.imaskn=function imaskn(bits){assert(typeof bits==='number'&&bits>=0);var r=bits%26;var s=(bits-r)/26;assert(this.negative===0,'imaskn works only with positive numbers');if(this.length<=s){return this;}if(r!==0){s++;}this.length=Math.min(s,this.length);if(r!==0){var mask=0x3ffffff^0x3ffffff>>>r<<r;this.words[this.length-1]&=mask;}return this.strip();};// Return only lowers bits of number
BN.prototype.maskn=function maskn(bits){return this.clone().imaskn(bits);};// Add plain number `num` to `this`
BN.prototype.iaddn=function iaddn(num){assert(typeof num==='number');assert(num<0x4000000);if(num<0)return this.isubn(-num);// Possible sign change
if(this.negative!==0){if(this.length===1&&(this.words[0]|0)<num){this.words[0]=num-(this.words[0]|0);this.negative=0;return this;}this.negative=0;this.isubn(num);this.negative=1;return this;}// Add without checks
return this._iaddn(num);};BN.prototype._iaddn=function _iaddn(num){this.words[0]+=num;// Carry
for(var i=0;i<this.length&&this.words[i]>=0x4000000;i++){this.words[i]-=0x4000000;if(i===this.length-1){this.words[i+1]=1;}else{this.words[i+1]++;}}this.length=Math.max(this.length,i+1);return this;};// Subtract plain number `num` from `this`
BN.prototype.isubn=function isubn(num){assert(typeof num==='number');assert(num<0x4000000);if(num<0)return this.iaddn(-num);if(this.negative!==0){this.negative=0;this.iaddn(num);this.negative=1;return this;}this.words[0]-=num;if(this.length===1&&this.words[0]<0){this.words[0]=-this.words[0];this.negative=1;}else{// Carry
for(var i=0;i<this.length&&this.words[i]<0;i++){this.words[i]+=0x4000000;this.words[i+1]-=1;}}return this.strip();};BN.prototype.addn=function addn(num){return this.clone().iaddn(num);};BN.prototype.subn=function subn(num){return this.clone().isubn(num);};BN.prototype.iabs=function iabs(){this.negative=0;return this;};BN.prototype.abs=function abs(){return this.clone().iabs();};BN.prototype._ishlnsubmul=function _ishlnsubmul(num,mul,shift){var len=num.length+shift;var i;this._expand(len);var w;var carry=0;for(i=0;i<num.length;i++){w=(this.words[i+shift]|0)+carry;var right=(num.words[i]|0)*mul;w-=right&0x3ffffff;carry=(w>>26)-(right/0x4000000|0);this.words[i+shift]=w&0x3ffffff;}for(;i<this.length-shift;i++){w=(this.words[i+shift]|0)+carry;carry=w>>26;this.words[i+shift]=w&0x3ffffff;}if(carry===0)return this.strip();// Subtraction overflow
assert(carry===-1);carry=0;for(i=0;i<this.length;i++){w=-(this.words[i]|0)+carry;carry=w>>26;this.words[i]=w&0x3ffffff;}this.negative=1;return this.strip();};BN.prototype._wordDiv=function _wordDiv(num,mode){var shift=this.length-num.length;var a=this.clone();var b=num;// Normalize
var bhi=b.words[b.length-1]|0;var bhiBits=this._countBits(bhi);shift=26-bhiBits;if(shift!==0){b=b.ushln(shift);a.iushln(shift);bhi=b.words[b.length-1]|0;}// Initialize quotient
var m=a.length-b.length;var q;if(mode!=='mod'){q=new BN(null);q.length=m+1;q.words=new Array(q.length);for(var i=0;i<q.length;i++){q.words[i]=0;}}var diff=a.clone()._ishlnsubmul(b,1,m);if(diff.negative===0){a=diff;if(q){q.words[m]=1;}}for(var j=m-1;j>=0;j--){var qj=(a.words[b.length+j]|0)*0x4000000+(a.words[b.length+j-1]|0);// NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
// (0x7ffffff)
qj=Math.min(qj/bhi|0,0x3ffffff);a._ishlnsubmul(b,qj,j);while(a.negative!==0){qj--;a.negative=0;a._ishlnsubmul(b,1,j);if(!a.isZero()){a.negative^=1;}}if(q){q.words[j]=qj;}}if(q){q.strip();}a.strip();// Denormalize
if(mode!=='div'&&shift!==0){a.iushrn(shift);}return{div:q||null,mod:a};};// NOTE: 1) `mode` can be set to `mod` to request mod only,
//       to `div` to request div only, or be absent to
//       request both div & mod
//       2) `positive` is true if unsigned mod is requested
BN.prototype.divmod=function divmod(num,mode,positive){assert(!num.isZero());if(this.isZero()){return{div:new BN(0),mod:new BN(0)};}var div,mod,res;if(this.negative!==0&&num.negative===0){res=this.neg().divmod(num,mode);if(mode!=='mod'){div=res.div.neg();}if(mode!=='div'){mod=res.mod.neg();if(positive&&mod.negative!==0){mod.iadd(num);}}return{div:div,mod:mod};}if(this.negative===0&&num.negative!==0){res=this.divmod(num.neg(),mode);if(mode!=='mod'){div=res.div.neg();}return{div:div,mod:res.mod};}if((this.negative&num.negative)!==0){res=this.neg().divmod(num.neg(),mode);if(mode!=='div'){mod=res.mod.neg();if(positive&&mod.negative!==0){mod.isub(num);}}return{div:res.div,mod:mod};}// Both numbers are positive at this point
// Strip both numbers to approximate shift value
if(num.length>this.length||this.cmp(num)<0){return{div:new BN(0),mod:this};}// Very short reduction
if(num.length===1){if(mode==='div'){return{div:this.divn(num.words[0]),mod:null};}if(mode==='mod'){return{div:null,mod:new BN(this.modn(num.words[0]))};}return{div:this.divn(num.words[0]),mod:new BN(this.modn(num.words[0]))};}return this._wordDiv(num,mode);};// Find `this` / `num`
BN.prototype.div=function div(num){return this.divmod(num,'div',false).div;};// Find `this` % `num`
BN.prototype.mod=function mod(num){return this.divmod(num,'mod',false).mod;};BN.prototype.umod=function umod(num){return this.divmod(num,'mod',true).mod;};// Find Round(`this` / `num`)
BN.prototype.divRound=function divRound(num){var dm=this.divmod(num);// Fast case - exact division
if(dm.mod.isZero())return dm.div;var mod=dm.div.negative!==0?dm.mod.isub(num):dm.mod;var half=num.ushrn(1);var r2=num.andln(1);var cmp=mod.cmp(half);// Round down
if(cmp<0||r2===1&&cmp===0)return dm.div;// Round up
return dm.div.negative!==0?dm.div.isubn(1):dm.div.iaddn(1);};BN.prototype.modn=function modn(num){assert(num<=0x3ffffff);var p=(1<<26)%num;var acc=0;for(var i=this.length-1;i>=0;i--){acc=(p*acc+(this.words[i]|0))%num;}return acc;};// In-place division by number
BN.prototype.idivn=function idivn(num){assert(num<=0x3ffffff);var carry=0;for(var i=this.length-1;i>=0;i--){var w=(this.words[i]|0)+carry*0x4000000;this.words[i]=w/num|0;carry=w%num;}return this.strip();};BN.prototype.divn=function divn(num){return this.clone().idivn(num);};BN.prototype.egcd=function egcd(p){assert(p.negative===0);assert(!p.isZero());var x=this;var y=p.clone();if(x.negative!==0){x=x.umod(p);}else{x=x.clone();}// A * x + B * y = x
var A=new BN(1);var B=new BN(0);// C * x + D * y = y
var C=new BN(0);var D=new BN(1);var g=0;while(x.isEven()&&y.isEven()){x.iushrn(1);y.iushrn(1);++g;}var yp=y.clone();var xp=x.clone();while(!x.isZero()){for(var i=0,im=1;(x.words[0]&im)===0&&i<26;++i,im<<=1);if(i>0){x.iushrn(i);while(i-->0){if(A.isOdd()||B.isOdd()){A.iadd(yp);B.isub(xp);}A.iushrn(1);B.iushrn(1);}}for(var j=0,jm=1;(y.words[0]&jm)===0&&j<26;++j,jm<<=1);if(j>0){y.iushrn(j);while(j-->0){if(C.isOdd()||D.isOdd()){C.iadd(yp);D.isub(xp);}C.iushrn(1);D.iushrn(1);}}if(x.cmp(y)>=0){x.isub(y);A.isub(C);B.isub(D);}else{y.isub(x);C.isub(A);D.isub(B);}}return{a:C,b:D,gcd:y.iushln(g)};};// This is reduced incarnation of the binary EEA
// above, designated to invert members of the
// _prime_ fields F(p) at a maximal speed
BN.prototype._invmp=function _invmp(p){assert(p.negative===0);assert(!p.isZero());var a=this;var b=p.clone();if(a.negative!==0){a=a.umod(p);}else{a=a.clone();}var x1=new BN(1);var x2=new BN(0);var delta=b.clone();while(a.cmpn(1)>0&&b.cmpn(1)>0){for(var i=0,im=1;(a.words[0]&im)===0&&i<26;++i,im<<=1);if(i>0){a.iushrn(i);while(i-->0){if(x1.isOdd()){x1.iadd(delta);}x1.iushrn(1);}}for(var j=0,jm=1;(b.words[0]&jm)===0&&j<26;++j,jm<<=1);if(j>0){b.iushrn(j);while(j-->0){if(x2.isOdd()){x2.iadd(delta);}x2.iushrn(1);}}if(a.cmp(b)>=0){a.isub(b);x1.isub(x2);}else{b.isub(a);x2.isub(x1);}}var res;if(a.cmpn(1)===0){res=x1;}else{res=x2;}if(res.cmpn(0)<0){res.iadd(p);}return res;};BN.prototype.gcd=function gcd(num){if(this.isZero())return num.abs();if(num.isZero())return this.abs();var a=this.clone();var b=num.clone();a.negative=0;b.negative=0;// Remove common factor of two
for(var shift=0;a.isEven()&&b.isEven();shift++){a.iushrn(1);b.iushrn(1);}do{while(a.isEven()){a.iushrn(1);}while(b.isEven()){b.iushrn(1);}var r=a.cmp(b);if(r<0){// Swap `a` and `b` to make `a` always bigger than `b`
var t=a;a=b;b=t;}else if(r===0||b.cmpn(1)===0){break;}a.isub(b);}while(true);return b.iushln(shift);};// Invert number in the field F(num)
BN.prototype.invm=function invm(num){return this.egcd(num).a.umod(num);};BN.prototype.isEven=function isEven(){return(this.words[0]&1)===0;};BN.prototype.isOdd=function isOdd(){return(this.words[0]&1)===1;};// And first word and num
BN.prototype.andln=function andln(num){return this.words[0]&num;};// Increment at the bit position in-line
BN.prototype.bincn=function bincn(bit){assert(typeof bit==='number');var r=bit%26;var s=(bit-r)/26;var q=1<<r;// Fast case: bit is much higher than all existing words
if(this.length<=s){this._expand(s+1);this.words[s]|=q;return this;}// Add bit and propagate, if needed
var carry=q;for(var i=s;carry!==0&&i<this.length;i++){var w=this.words[i]|0;w+=carry;carry=w>>>26;w&=0x3ffffff;this.words[i]=w;}if(carry!==0){this.words[i]=carry;this.length++;}return this;};BN.prototype.isZero=function isZero(){return this.length===1&&this.words[0]===0;};BN.prototype.cmpn=function cmpn(num){var negative=num<0;if(this.negative!==0&&!negative)return-1;if(this.negative===0&&negative)return 1;this.strip();var res;if(this.length>1){res=1;}else{if(negative){num=-num;}assert(num<=0x3ffffff,'Number is too big');var w=this.words[0]|0;res=w===num?0:w<num?-1:1;}if(this.negative!==0)return-res|0;return res;};// Compare two numbers and return:
// 1 - if `this` > `num`
// 0 - if `this` == `num`
// -1 - if `this` < `num`
BN.prototype.cmp=function cmp(num){if(this.negative!==0&&num.negative===0)return-1;if(this.negative===0&&num.negative!==0)return 1;var res=this.ucmp(num);if(this.negative!==0)return-res|0;return res;};// Unsigned comparison
BN.prototype.ucmp=function ucmp(num){// At this point both numbers have the same sign
if(this.length>num.length)return 1;if(this.length<num.length)return-1;var res=0;for(var i=this.length-1;i>=0;i--){var a=this.words[i]|0;var b=num.words[i]|0;if(a===b)continue;if(a<b){res=-1;}else if(a>b){res=1;}break;}return res;};BN.prototype.gtn=function gtn(num){return this.cmpn(num)===1;};BN.prototype.gt=function gt(num){return this.cmp(num)===1;};BN.prototype.gten=function gten(num){return this.cmpn(num)>=0;};BN.prototype.gte=function gte(num){return this.cmp(num)>=0;};BN.prototype.ltn=function ltn(num){return this.cmpn(num)===-1;};BN.prototype.lt=function lt(num){return this.cmp(num)===-1;};BN.prototype.lten=function lten(num){return this.cmpn(num)<=0;};BN.prototype.lte=function lte(num){return this.cmp(num)<=0;};BN.prototype.eqn=function eqn(num){return this.cmpn(num)===0;};BN.prototype.eq=function eq(num){return this.cmp(num)===0;};//
// A reduce context, could be using montgomery or something better, depending
// on the `m` itself.
//
BN.red=function red(num){return new Red(num);};BN.prototype.toRed=function toRed(ctx){assert(!this.red,'Already a number in reduction context');assert(this.negative===0,'red works only with positives');return ctx.convertTo(this)._forceRed(ctx);};BN.prototype.fromRed=function fromRed(){assert(this.red,'fromRed works only with numbers in reduction context');return this.red.convertFrom(this);};BN.prototype._forceRed=function _forceRed(ctx){this.red=ctx;return this;};BN.prototype.forceRed=function forceRed(ctx){assert(!this.red,'Already a number in reduction context');return this._forceRed(ctx);};BN.prototype.redAdd=function redAdd(num){assert(this.red,'redAdd works only with red numbers');return this.red.add(this,num);};BN.prototype.redIAdd=function redIAdd(num){assert(this.red,'redIAdd works only with red numbers');return this.red.iadd(this,num);};BN.prototype.redSub=function redSub(num){assert(this.red,'redSub works only with red numbers');return this.red.sub(this,num);};BN.prototype.redISub=function redISub(num){assert(this.red,'redISub works only with red numbers');return this.red.isub(this,num);};BN.prototype.redShl=function redShl(num){assert(this.red,'redShl works only with red numbers');return this.red.shl(this,num);};BN.prototype.redMul=function redMul(num){assert(this.red,'redMul works only with red numbers');this.red._verify2(this,num);return this.red.mul(this,num);};BN.prototype.redIMul=function redIMul(num){assert(this.red,'redMul works only with red numbers');this.red._verify2(this,num);return this.red.imul(this,num);};BN.prototype.redSqr=function redSqr(){assert(this.red,'redSqr works only with red numbers');this.red._verify1(this);return this.red.sqr(this);};BN.prototype.redISqr=function redISqr(){assert(this.red,'redISqr works only with red numbers');this.red._verify1(this);return this.red.isqr(this);};// Square root over p
BN.prototype.redSqrt=function redSqrt(){assert(this.red,'redSqrt works only with red numbers');this.red._verify1(this);return this.red.sqrt(this);};BN.prototype.redInvm=function redInvm(){assert(this.red,'redInvm works only with red numbers');this.red._verify1(this);return this.red.invm(this);};// Return negative clone of `this` % `red modulo`
BN.prototype.redNeg=function redNeg(){assert(this.red,'redNeg works only with red numbers');this.red._verify1(this);return this.red.neg(this);};BN.prototype.redPow=function redPow(num){assert(this.red&&!num.red,'redPow(normalNum)');this.red._verify1(this);return this.red.pow(this,num);};// Prime numbers with efficient reduction
var primes={k256:null,p224:null,p192:null,p25519:null};// Pseudo-Mersenne prime
function MPrime(name,p){// P = 2 ^ N - K
this.name=name;this.p=new BN(p,16);this.n=this.p.bitLength();this.k=new BN(1).iushln(this.n).isub(this.p);this.tmp=this._tmp();}MPrime.prototype._tmp=function _tmp(){var tmp=new BN(null);tmp.words=new Array(Math.ceil(this.n/13));return tmp;};MPrime.prototype.ireduce=function ireduce(num){// Assumes that `num` is less than `P^2`
// num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
var r=num;var rlen;do{this.split(r,this.tmp);r=this.imulK(r);r=r.iadd(this.tmp);rlen=r.bitLength();}while(rlen>this.n);var cmp=rlen<this.n?-1:r.ucmp(this.p);if(cmp===0){r.words[0]=0;r.length=1;}else if(cmp>0){r.isub(this.p);}else{if(r.strip!==undefined){// r is BN v4 instance
r.strip();}else{// r is BN v5 instance
r._strip();}}return r;};MPrime.prototype.split=function split(input,out){input.iushrn(this.n,0,out);};MPrime.prototype.imulK=function imulK(num){return num.imul(this.k);};function K256(){MPrime.call(this,'k256','ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');}inherits(K256,MPrime);K256.prototype.split=function split(input,output){// 256 = 9 * 26 + 22
var mask=0x3fffff;var outLen=Math.min(input.length,9);for(var i=0;i<outLen;i++){output.words[i]=input.words[i];}output.length=outLen;if(input.length<=9){input.words[0]=0;input.length=1;return;}// Shift by 9 limbs
var prev=input.words[9];output.words[output.length++]=prev&mask;for(i=10;i<input.length;i++){var next=input.words[i]|0;input.words[i-10]=(next&mask)<<4|prev>>>22;prev=next;}prev>>>=22;input.words[i-10]=prev;if(prev===0&&input.length>10){input.length-=10;}else{input.length-=9;}};K256.prototype.imulK=function imulK(num){// K = 0x1000003d1 = [ 0x40, 0x3d1 ]
num.words[num.length]=0;num.words[num.length+1]=0;num.length+=2;// bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
var lo=0;for(var i=0;i<num.length;i++){var w=num.words[i]|0;lo+=w*0x3d1;num.words[i]=lo&0x3ffffff;lo=w*0x40+(lo/0x4000000|0);}// Fast length reduction
if(num.words[num.length-1]===0){num.length--;if(num.words[num.length-1]===0){num.length--;}}return num;};function P224(){MPrime.call(this,'p224','ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');}inherits(P224,MPrime);function P192(){MPrime.call(this,'p192','ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');}inherits(P192,MPrime);function P25519(){// 2 ^ 255 - 19
MPrime.call(this,'25519','7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');}inherits(P25519,MPrime);P25519.prototype.imulK=function imulK(num){// K = 0x13
var carry=0;for(var i=0;i<num.length;i++){var hi=(num.words[i]|0)*0x13+carry;var lo=hi&0x3ffffff;hi>>>=26;num.words[i]=lo;carry=hi;}if(carry!==0){num.words[num.length++]=carry;}return num;};// Exported mostly for testing purposes, use plain name instead
BN._prime=function prime(name){// Cached version of prime
if(primes[name])return primes[name];var prime;if(name==='k256'){prime=new K256();}else if(name==='p224'){prime=new P224();}else if(name==='p192'){prime=new P192();}else if(name==='p25519'){prime=new P25519();}else{throw new Error('Unknown prime '+name);}primes[name]=prime;return prime;};//
// Base reduction engine
//
function Red(m){if(typeof m==='string'){var prime=BN._prime(m);this.m=prime.p;this.prime=prime;}else{assert(m.gtn(1),'modulus must be greater than 1');this.m=m;this.prime=null;}}Red.prototype._verify1=function _verify1(a){assert(a.negative===0,'red works only with positives');assert(a.red,'red works only with red numbers');};Red.prototype._verify2=function _verify2(a,b){assert((a.negative|b.negative)===0,'red works only with positives');assert(a.red&&a.red===b.red,'red works only with red numbers');};Red.prototype.imod=function imod(a){if(this.prime)return this.prime.ireduce(a)._forceRed(this);return a.umod(this.m)._forceRed(this);};Red.prototype.neg=function neg(a){if(a.isZero()){return a.clone();}return this.m.sub(a)._forceRed(this);};Red.prototype.add=function add(a,b){this._verify2(a,b);var res=a.add(b);if(res.cmp(this.m)>=0){res.isub(this.m);}return res._forceRed(this);};Red.prototype.iadd=function iadd(a,b){this._verify2(a,b);var res=a.iadd(b);if(res.cmp(this.m)>=0){res.isub(this.m);}return res;};Red.prototype.sub=function sub(a,b){this._verify2(a,b);var res=a.sub(b);if(res.cmpn(0)<0){res.iadd(this.m);}return res._forceRed(this);};Red.prototype.isub=function isub(a,b){this._verify2(a,b);var res=a.isub(b);if(res.cmpn(0)<0){res.iadd(this.m);}return res;};Red.prototype.shl=function shl(a,num){this._verify1(a);return this.imod(a.ushln(num));};Red.prototype.imul=function imul(a,b){this._verify2(a,b);return this.imod(a.imul(b));};Red.prototype.mul=function mul(a,b){this._verify2(a,b);return this.imod(a.mul(b));};Red.prototype.isqr=function isqr(a){return this.imul(a,a.clone());};Red.prototype.sqr=function sqr(a){return this.mul(a,a);};Red.prototype.sqrt=function sqrt(a){if(a.isZero())return a.clone();var mod3=this.m.andln(3);assert(mod3%2===1);// Fast case
if(mod3===3){var pow=this.m.add(new BN(1)).iushrn(2);return this.pow(a,pow);}// Tonelli-Shanks algorithm (Totally unoptimized and slow)
//
// Find Q and S, that Q * 2 ^ S = (P - 1)
var q=this.m.subn(1);var s=0;while(!q.isZero()&&q.andln(1)===0){s++;q.iushrn(1);}assert(!q.isZero());var one=new BN(1).toRed(this);var nOne=one.redNeg();// Find quadratic non-residue
// NOTE: Max is such because of generalized Riemann hypothesis.
var lpow=this.m.subn(1).iushrn(1);var z=this.m.bitLength();z=new BN(2*z*z).toRed(this);while(this.pow(z,lpow).cmp(nOne)!==0){z.redIAdd(nOne);}var c=this.pow(z,q);var r=this.pow(a,q.addn(1).iushrn(1));var t=this.pow(a,q);var m=s;while(t.cmp(one)!==0){var tmp=t;for(var i=0;tmp.cmp(one)!==0;i++){tmp=tmp.redSqr();}assert(i<m);var b=this.pow(c,new BN(1).iushln(m-i-1));r=r.redMul(b);c=b.redSqr();t=t.redMul(c);m=i;}return r;};Red.prototype.invm=function invm(a){var inv=a._invmp(this.m);if(inv.negative!==0){inv.negative=0;return this.imod(inv).redNeg();}else{return this.imod(inv);}};Red.prototype.pow=function pow(a,num){if(num.isZero())return new BN(1).toRed(this);if(num.cmpn(1)===0)return a.clone();var windowSize=4;var wnd=new Array(1<<windowSize);wnd[0]=new BN(1).toRed(this);wnd[1]=a;for(var i=2;i<wnd.length;i++){wnd[i]=this.mul(wnd[i-1],a);}var res=wnd[0];var current=0;var currentLen=0;var start=num.bitLength()%26;if(start===0){start=26;}for(i=num.length-1;i>=0;i--){var word=num.words[i];for(var j=start-1;j>=0;j--){var bit=word>>j&1;if(res!==wnd[0]){res=this.sqr(res);}if(bit===0&&current===0){currentLen=0;continue;}current<<=1;current|=bit;currentLen++;if(currentLen!==windowSize&&(i!==0||j!==0))continue;res=this.mul(res,wnd[current]);currentLen=0;current=0;}start=26;}return res;};Red.prototype.convertTo=function convertTo(num){var r=num.umod(this.m);return r===num?r.clone():r;};Red.prototype.convertFrom=function convertFrom(num){var res=num.clone();res.red=null;return res;};//
// Montgomery method engine
//
BN.mont=function mont(num){return new Mont(num);};function Mont(m){Red.call(this,m);this.shift=this.m.bitLength();if(this.shift%26!==0){this.shift+=26-this.shift%26;}this.r=new BN(1).iushln(this.shift);this.r2=this.imod(this.r.sqr());this.rinv=this.r._invmp(this.m);this.minv=this.rinv.mul(this.r).isubn(1).div(this.m);this.minv=this.minv.umod(this.r);this.minv=this.r.sub(this.minv);}inherits(Mont,Red);Mont.prototype.convertTo=function convertTo(num){return this.imod(num.ushln(this.shift));};Mont.prototype.convertFrom=function convertFrom(num){var r=this.imod(num.mul(this.rinv));r.red=null;return r;};Mont.prototype.imul=function imul(a,b){if(a.isZero()||b.isZero()){a.words[0]=0;a.length=1;return a;}var t=a.imul(b);var c=t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);var u=t.isub(c).iushrn(this.shift);var res=u;if(u.cmp(this.m)>=0){res=u.isub(this.m);}else if(u.cmpn(0)<0){res=u.iadd(this.m);}return res._forceRed(this);};Mont.prototype.mul=function mul(a,b){if(a.isZero()||b.isZero())return new BN(0)._forceRed(this);var t=a.mul(b);var c=t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);var u=t.isub(c).iushrn(this.shift);var res=u;if(u.cmp(this.m)>=0){res=u.isub(this.m);}else if(u.cmpn(0)<0){res=u.iadd(this.m);}return res._forceRed(this);};Mont.prototype.invm=function invm(a){// (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
var res=this.imod(a._invmp(this.m).mul(this.r2));return res._forceRed(this);};})( false||module,this);/***/}),/***/6204:(/***/function(module){"use strict";module.exports=boundary;function boundary(cells){var i,j,k;var n=cells.length;var sz=0;for(i=0;i<n;++i){sz+=cells[i].length;}var result=new Array(sz);var ptr=0;for(i=0;i<n;++i){var c=cells[i];var d=c.length;for(j=0;j<d;++j){var b=result[ptr++]=new Array(d-1);var p=0;for(k=0;k<d;++k){if(k===j){continue;}b[p++]=c[k];}if(j&1){var tmp=b[1];b[1]=b[0];b[0]=tmp;}}}return result;}/***/}),/***/6867:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_135715__){"use strict";module.exports=boxIntersectWrapper;var pool=__nested_webpack_require_135715__(1888);var sweep=__nested_webpack_require_135715__(855);var boxIntersectIter=__nested_webpack_require_135715__(7150);function boxEmpty(d,box){for(var j=0;j<d;++j){if(!(box[j]<=box[j+d])){return true;}}return false;}//Unpack boxes into a flat typed array, remove empty boxes
function convertBoxes(boxes,d,data,ids){var ptr=0;var count=0;for(var i=0,n=boxes.length;i<n;++i){var b=boxes[i];if(boxEmpty(d,b)){continue;}for(var j=0;j<2*d;++j){data[ptr++]=b[j];}ids[count++]=i;}return count;}//Perform type conversions, check bounds
function boxIntersect(red,blue,visit,full){var n=red.length;var m=blue.length;//If either array is empty, then we can skip this whole thing
if(n<=0||m<=0){return;}//Compute dimension, if it is 0 then we skip
var d=red[0].length>>>1;if(d<=0){return;}var retval;//Convert red boxes
var redList=pool.mallocDouble(2*d*n);var redIds=pool.mallocInt32(n);n=convertBoxes(red,d,redList,redIds);if(n>0){if(d===1&&full){//Special case: 1d complete
sweep.init(n);retval=sweep.sweepComplete(d,visit,0,n,redList,redIds,0,n,redList,redIds);}else{//Convert blue boxes
var blueList=pool.mallocDouble(2*d*m);var blueIds=pool.mallocInt32(m);m=convertBoxes(blue,d,blueList,blueIds);if(m>0){sweep.init(n+m);if(d===1){//Special case: 1d bipartite
retval=sweep.sweepBipartite(d,visit,0,n,redList,redIds,0,m,blueList,blueIds);}else{//General case:  d>1
retval=boxIntersectIter(d,visit,full,n,redList,redIds,m,blueList,blueIds);}pool.free(blueList);pool.free(blueIds);}}pool.free(redList);pool.free(redIds);}return retval;}var RESULT;function appendItem(i,j){RESULT.push([i,j]);}function intersectFullArray(x){RESULT=[];boxIntersect(x,x,appendItem,true);return RESULT;}function intersectBipartiteArray(x,y){RESULT=[];boxIntersect(x,y,appendItem,false);return RESULT;}//User-friendly wrapper, handle full input and no-visitor cases
function boxIntersectWrapper(arg0,arg1,arg2){switch(arguments.length){case 1:return intersectFullArray(arg0);case 2:if(typeof arg1==='function'){return boxIntersect(arg0,arg0,arg1,true);}else{return intersectBipartiteArray(arg0,arg1);}case 3:return boxIntersect(arg0,arg1,arg2,false);default:throw new Error('box-intersect: Invalid arguments');}}/***/}),/***/2455:(/***/function(__unused_webpack_module,exports){"use strict";function full(){function bruteForceRedFull(d,ax,vv,rs,re,rb,ri,bs,be,bb,bi){var es=2*d;for(var i=rs,rp=es*rs;i<re;++i,rp+=es){var x0=rb[ax+rp],x1=rb[ax+rp+d],xi=ri[i];Q:for(var j=bs,bp=es*bs;j<be;++j,bp+=es){var y0=bb[ax+bp],y1=bb[ax+bp+d],yi=bi[j];if(y1<x0||x1<y0)continue;for(var k=ax+1;k<d;++k){var r0=rb[k+rp],r1=rb[k+d+rp],b0=bb[k+bp],b1=bb[k+d+bp];if(r1<b0||b1<r0)continue Q;}var rv=vv(xi,yi);if(rv!==void 0)return rv;}}}function bruteForceBlueFull(d,ax,vv,rs,re,rb,ri,bs,be,bb,bi){var es=2*d;for(var j=bs,bp=es*bs;j<be;++j,bp+=es){var y0=bb[ax+bp],y1=bb[ax+bp+d],yi=bi[j];Q:for(var i=rs,rp=es*rs;i<re;++i,rp+=es){var x0=rb[ax+rp],x1=rb[ax+rp+d],xi=ri[i];if(y1<x0||x1<y0)continue;for(var k=ax+1;k<d;++k){var r0=rb[k+rp],r1=rb[k+d+rp],b0=bb[k+bp],b1=bb[k+d+bp];if(r1<b0||b1<r0)continue Q;}var rv=vv(xi,yi);if(rv!==void 0)return rv;}}}function bruteForceFull(d,ax,vv,rs,re,rb,ri,bs,be,bb,bi){if(re-rs>be-bs){return bruteForceRedFull(d,ax,vv,rs,re,rb,ri,bs,be,bb,bi);}else{return bruteForceBlueFull(d,ax,vv,rs,re,rb,ri,bs,be,bb,bi);}}return bruteForceFull;}function partial(){function bruteForceRedFlip(d,ax,vv,rs,re,rb,ri,bs,be,bb,bi){var es=2*d;for(var i=rs,rp=es*rs;i<re;++i,rp+=es){var x0=rb[ax+rp],x1=rb[ax+rp+d],xi=ri[i];Q:for(var j=bs,bp=es*bs;j<be;++j,bp+=es){var y0=bb[ax+bp],yi=bi[j];if(y0<=x0||x1<y0)continue;for(var k=ax+1;k<d;++k){var r0=rb[k+rp],r1=rb[k+d+rp],b0=bb[k+bp],b1=bb[k+d+bp];if(r1<b0||b1<r0)continue Q;}var rv=vv(yi,xi);if(rv!==void 0)return rv;}}}function bruteForceRed(d,ax,vv,rs,re,rb,ri,bs,be,bb,bi){var es=2*d;for(var i=rs,rp=es*rs;i<re;++i,rp+=es){var x0=rb[ax+rp],x1=rb[ax+rp+d],xi=ri[i];Q:for(var j=bs,bp=es*bs;j<be;++j,bp+=es){var y0=bb[ax+bp],yi=bi[j];if(y0<x0||x1<y0)continue;for(var k=ax+1;k<d;++k){var r0=rb[k+rp],r1=rb[k+d+rp],b0=bb[k+bp],b1=bb[k+d+bp];if(r1<b0||b1<r0)continue Q;}var rv=vv(xi,yi);if(rv!==void 0)return rv;}}}function bruteForceBlueFlip(d,ax,vv,rs,re,rb,ri,bs,be,bb,bi){var es=2*d;for(var j=bs,bp=es*bs;j<be;++j,bp+=es){var y0=bb[ax+bp],yi=bi[j];Q:for(var i=rs,rp=es*rs;i<re;++i,rp+=es){var x0=rb[ax+rp],x1=rb[ax+rp+d],xi=ri[i];if(y0<=x0||x1<y0)continue;for(var k=ax+1;k<d;++k){var r0=rb[k+rp],r1=rb[k+d+rp],b0=bb[k+bp],b1=bb[k+d+bp];if(r1<b0||b1<r0)continue Q;}var rv=vv(yi,xi);if(rv!==void 0)return rv;}}}function bruteForceBlue(d,ax,vv,rs,re,rb,ri,bs,be,bb,bi){var es=2*d;for(var j=bs,bp=es*bs;j<be;++j,bp+=es){var y0=bb[ax+bp],yi=bi[j];Q:for(var i=rs,rp=es*rs;i<re;++i,rp+=es){var x0=rb[ax+rp],x1=rb[ax+rp+d],xi=ri[i];if(y0<x0||x1<y0)continue;for(var k=ax+1;k<d;++k){var r0=rb[k+rp],r1=rb[k+d+rp],b0=bb[k+bp],b1=bb[k+d+bp];if(r1<b0||b1<r0)continue Q;}var rv=vv(xi,yi);if(rv!==void 0)return rv;}}}function bruteForcePartial(d,ax,vv,fp,rs,re,rb,ri,bs,be,bb,bi){if(re-rs>be-bs){if(fp){return bruteForceRedFlip(d,ax,vv,rs,re,rb,ri,bs,be,bb,bi);}else{return bruteForceRed(d,ax,vv,rs,re,rb,ri,bs,be,bb,bi);}}else{if(fp){return bruteForceBlueFlip(d,ax,vv,rs,re,rb,ri,bs,be,bb,bi);}else{return bruteForceBlue(d,ax,vv,rs,re,rb,ri,bs,be,bb,bi);}}}return bruteForcePartial;}function bruteForcePlanner(isFull){return isFull?full():partial();}exports.partial=bruteForcePlanner(false);exports.full=bruteForcePlanner(true);/***/}),/***/7150:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_141278__){"use strict";module.exports=boxIntersectIter;var pool=__nested_webpack_require_141278__(1888);var bits=__nested_webpack_require_141278__(8828);var bruteForce=__nested_webpack_require_141278__(2455);var bruteForcePartial=bruteForce.partial;var bruteForceFull=bruteForce.full;var sweep=__nested_webpack_require_141278__(855);var findMedian=__nested_webpack_require_141278__(3545);var genPartition=__nested_webpack_require_141278__(8105);//Twiddle parameters
var BRUTE_FORCE_CUTOFF=128;//Cut off for brute force search
var SCAN_CUTOFF=1<<22;//Cut off for two way scan
var SCAN_COMPLETE_CUTOFF=1<<22;//Partition functions
var partitionInteriorContainsInterval=genPartition('!(lo>=p0)&&!(p1>=hi)');var partitionStartEqual=genPartition('lo===p0');var partitionStartLessThan=genPartition('lo<p0');var partitionEndLessThanEqual=genPartition('hi<=p0');var partitionContainsPoint=genPartition('lo<=p0&&p0<=hi');var partitionContainsPointProper=genPartition('lo<p0&&p0<=hi');//Frame size for iterative loop
var IFRAME_SIZE=6;var DFRAME_SIZE=2;//Data for box statck
var INIT_CAPACITY=1024;var BOX_ISTACK=pool.mallocInt32(INIT_CAPACITY);var BOX_DSTACK=pool.mallocDouble(INIT_CAPACITY);//Initialize iterative loop queue
function iterInit(d,count){var levels=8*bits.log2(count+1)*(d+1)|0;var maxInts=bits.nextPow2(IFRAME_SIZE*levels);if(BOX_ISTACK.length<maxInts){pool.free(BOX_ISTACK);BOX_ISTACK=pool.mallocInt32(maxInts);}var maxDoubles=bits.nextPow2(DFRAME_SIZE*levels);if(BOX_DSTACK.length<maxDoubles){pool.free(BOX_DSTACK);BOX_DSTACK=pool.mallocDouble(maxDoubles);}}//Append item to queue
function iterPush(ptr,axis,redStart,redEnd,blueStart,blueEnd,state,lo,hi){var iptr=IFRAME_SIZE*ptr;BOX_ISTACK[iptr]=axis;BOX_ISTACK[iptr+1]=redStart;BOX_ISTACK[iptr+2]=redEnd;BOX_ISTACK[iptr+3]=blueStart;BOX_ISTACK[iptr+4]=blueEnd;BOX_ISTACK[iptr+5]=state;var dptr=DFRAME_SIZE*ptr;BOX_DSTACK[dptr]=lo;BOX_DSTACK[dptr+1]=hi;}//Special case:  Intersect single point with list of intervals
function onePointPartial(d,axis,visit,flip,redStart,redEnd,red,redIndex,blueOffset,blue,blueId){var elemSize=2*d;var bluePtr=blueOffset*elemSize;var blueX=blue[bluePtr+axis];red_loop:for(var i=redStart,redPtr=redStart*elemSize;i<redEnd;++i,redPtr+=elemSize){var r0=red[redPtr+axis];var r1=red[redPtr+axis+d];if(blueX<r0||r1<blueX){continue;}if(flip&&blueX===r0){continue;}var redId=redIndex[i];for(var j=axis+1;j<d;++j){var r0=red[redPtr+j];var r1=red[redPtr+j+d];var b0=blue[bluePtr+j];var b1=blue[bluePtr+j+d];if(r1<b0||b1<r0){continue red_loop;}}var retval;if(flip){retval=visit(blueId,redId);}else{retval=visit(redId,blueId);}if(retval!==void 0){return retval;}}}//Special case:  Intersect one point with list of intervals
function onePointFull(d,axis,visit,redStart,redEnd,red,redIndex,blueOffset,blue,blueId){var elemSize=2*d;var bluePtr=blueOffset*elemSize;var blueX=blue[bluePtr+axis];red_loop:for(var i=redStart,redPtr=redStart*elemSize;i<redEnd;++i,redPtr+=elemSize){var redId=redIndex[i];if(redId===blueId){continue;}var r0=red[redPtr+axis];var r1=red[redPtr+axis+d];if(blueX<r0||r1<blueX){continue;}for(var j=axis+1;j<d;++j){var r0=red[redPtr+j];var r1=red[redPtr+j+d];var b0=blue[bluePtr+j];var b1=blue[bluePtr+j+d];if(r1<b0||b1<r0){continue red_loop;}}var retval=visit(redId,blueId);if(retval!==void 0){return retval;}}}//The main box intersection routine
function boxIntersectIter(d,visit,initFull,xSize,xBoxes,xIndex,ySize,yBoxes,yIndex){//Reserve memory for stack
iterInit(d,xSize+ySize);var top=0;var elemSize=2*d;var retval;iterPush(top++,0,0,xSize,0,ySize,initFull?16:0,-Infinity,Infinity);if(!initFull){iterPush(top++,0,0,ySize,0,xSize,1,-Infinity,Infinity);}while(top>0){top-=1;var iptr=top*IFRAME_SIZE;var axis=BOX_ISTACK[iptr];var redStart=BOX_ISTACK[iptr+1];var redEnd=BOX_ISTACK[iptr+2];var blueStart=BOX_ISTACK[iptr+3];var blueEnd=BOX_ISTACK[iptr+4];var state=BOX_ISTACK[iptr+5];var dptr=top*DFRAME_SIZE;var lo=BOX_DSTACK[dptr];var hi=BOX_DSTACK[dptr+1];//Unpack state info
var flip=state&1;var full=!!(state&16);//Unpack indices
var red=xBoxes;var redIndex=xIndex;var blue=yBoxes;var blueIndex=yIndex;if(flip){red=yBoxes;redIndex=yIndex;blue=xBoxes;blueIndex=xIndex;}if(state&2){redEnd=partitionStartLessThan(d,axis,redStart,redEnd,red,redIndex,hi);if(redStart>=redEnd){continue;}}if(state&4){redStart=partitionEndLessThanEqual(d,axis,redStart,redEnd,red,redIndex,lo);if(redStart>=redEnd){continue;}}var redCount=redEnd-redStart;var blueCount=blueEnd-blueStart;if(full){if(d*redCount*(redCount+blueCount)<SCAN_COMPLETE_CUTOFF){retval=sweep.scanComplete(d,axis,visit,redStart,redEnd,red,redIndex,blueStart,blueEnd,blue,blueIndex);if(retval!==void 0){return retval;}continue;}}else{if(d*Math.min(redCount,blueCount)<BRUTE_FORCE_CUTOFF){//If input small, then use brute force
retval=bruteForcePartial(d,axis,visit,flip,redStart,redEnd,red,redIndex,blueStart,blueEnd,blue,blueIndex);if(retval!==void 0){return retval;}continue;}else if(d*redCount*blueCount<SCAN_CUTOFF){//If input medium sized, then use sweep and prune
retval=sweep.scanBipartite(d,axis,visit,flip,redStart,redEnd,red,redIndex,blueStart,blueEnd,blue,blueIndex);if(retval!==void 0){return retval;}continue;}}//First, find all red intervals whose interior contains (lo,hi)
var red0=partitionInteriorContainsInterval(d,axis,redStart,redEnd,red,redIndex,lo,hi);//Lower dimensional case
if(redStart<red0){if(d*(red0-redStart)<BRUTE_FORCE_CUTOFF){//Special case for small inputs: use brute force
retval=bruteForceFull(d,axis+1,visit,redStart,red0,red,redIndex,blueStart,blueEnd,blue,blueIndex);if(retval!==void 0){return retval;}}else if(axis===d-2){if(flip){retval=sweep.sweepBipartite(d,visit,blueStart,blueEnd,blue,blueIndex,redStart,red0,red,redIndex);}else{retval=sweep.sweepBipartite(d,visit,redStart,red0,red,redIndex,blueStart,blueEnd,blue,blueIndex);}if(retval!==void 0){return retval;}}else{iterPush(top++,axis+1,redStart,red0,blueStart,blueEnd,flip,-Infinity,Infinity);iterPush(top++,axis+1,blueStart,blueEnd,redStart,red0,flip^1,-Infinity,Infinity);}}//Divide and conquer phase
if(red0<redEnd){//Cut blue into 3 parts:
//
//  Points < mid point
//  Points = mid point
//  Points > mid point
//
var blue0=findMedian(d,axis,blueStart,blueEnd,blue,blueIndex);var mid=blue[elemSize*blue0+axis];var blue1=partitionStartEqual(d,axis,blue0,blueEnd,blue,blueIndex,mid);//Right case
if(blue1<blueEnd){iterPush(top++,axis,red0,redEnd,blue1,blueEnd,(flip|4)+(full?16:0),mid,hi);}//Left case
if(blueStart<blue0){iterPush(top++,axis,red0,redEnd,blueStart,blue0,(flip|2)+(full?16:0),lo,mid);}//Center case (the hard part)
if(blue0+1===blue1){//Optimization: Range with exactly 1 point, use a brute force scan
if(full){retval=onePointFull(d,axis,visit,red0,redEnd,red,redIndex,blue0,blue,blueIndex[blue0]);}else{retval=onePointPartial(d,axis,visit,flip,red0,redEnd,red,redIndex,blue0,blue,blueIndex[blue0]);}if(retval!==void 0){return retval;}}else if(blue0<blue1){var red1;if(full){//If full intersection, need to handle special case
red1=partitionContainsPoint(d,axis,red0,redEnd,red,redIndex,mid);if(red0<red1){var redX=partitionStartEqual(d,axis,red0,red1,red,redIndex,mid);if(axis===d-2){//Degenerate sweep intersection:
//  [red0, redX] with [blue0, blue1]
if(red0<redX){retval=sweep.sweepComplete(d,visit,red0,redX,red,redIndex,blue0,blue1,blue,blueIndex);if(retval!==void 0){return retval;}}//Normal sweep intersection:
//  [redX, red1] with [blue0, blue1]
if(redX<red1){retval=sweep.sweepBipartite(d,visit,redX,red1,red,redIndex,blue0,blue1,blue,blueIndex);if(retval!==void 0){return retval;}}}else{if(red0<redX){iterPush(top++,axis+1,red0,redX,blue0,blue1,16,-Infinity,Infinity);}if(redX<red1){iterPush(top++,axis+1,redX,red1,blue0,blue1,0,-Infinity,Infinity);iterPush(top++,axis+1,blue0,blue1,redX,red1,1,-Infinity,Infinity);}}}}else{if(flip){red1=partitionContainsPointProper(d,axis,red0,redEnd,red,redIndex,mid);}else{red1=partitionContainsPoint(d,axis,red0,redEnd,red,redIndex,mid);}if(red0<red1){if(axis===d-2){if(flip){retval=sweep.sweepBipartite(d,visit,blue0,blue1,blue,blueIndex,red0,red1,red,redIndex);}else{retval=sweep.sweepBipartite(d,visit,red0,red1,red,redIndex,blue0,blue1,blue,blueIndex);}}else{iterPush(top++,axis+1,red0,red1,blue0,blue1,flip,-Infinity,Infinity);iterPush(top++,axis+1,blue0,blue1,red0,red1,flip^1,-Infinity,Infinity);}}}}}}}/***/}),/***/3545:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_149597__){"use strict";module.exports=findMedian;var genPartition=__nested_webpack_require_149597__(8105);var partitionStartLessThan=genPartition('lo<p0');var PARTITION_THRESHOLD=8;//Cut off for using insertion sort in findMedian
//Base case for median finding:  Use insertion sort
function insertionSort(d,axis,start,end,boxes,ids){var elemSize=2*d;var boxPtr=elemSize*(start+1)+axis;for(var i=start+1;i<end;++i,boxPtr+=elemSize){var x=boxes[boxPtr];for(var j=i,ptr=elemSize*(i-1);j>start&&boxes[ptr+axis]>x;--j,ptr-=elemSize){//Swap
var aPtr=ptr;var bPtr=ptr+elemSize;for(var k=0;k<elemSize;++k,++aPtr,++bPtr){var y=boxes[aPtr];boxes[aPtr]=boxes[bPtr];boxes[bPtr]=y;}var tmp=ids[j];ids[j]=ids[j-1];ids[j-1]=tmp;}}}//Find median using quick select algorithm
//  takes O(n) time with high probability
function findMedian(d,axis,start,end,boxes,ids){if(end<=start+1){return start;}var lo=start;var hi=end;var mid=end+start>>>1;var elemSize=2*d;var pivot=mid;var value=boxes[elemSize*mid+axis];while(lo<hi){if(hi-lo<PARTITION_THRESHOLD){insertionSort(d,axis,lo,hi,boxes,ids);value=boxes[elemSize*mid+axis];break;}//Select pivot using median-of-3
var count=hi-lo;var pivot0=Math.random()*count+lo|0;var value0=boxes[elemSize*pivot0+axis];var pivot1=Math.random()*count+lo|0;var value1=boxes[elemSize*pivot1+axis];var pivot2=Math.random()*count+lo|0;var value2=boxes[elemSize*pivot2+axis];if(value0<=value1){if(value2>=value1){pivot=pivot1;value=value1;}else if(value0>=value2){pivot=pivot0;value=value0;}else{pivot=pivot2;value=value2;}}else{if(value1>=value2){pivot=pivot1;value=value1;}else if(value2>=value0){pivot=pivot0;value=value0;}else{pivot=pivot2;value=value2;}}//Swap pivot to end of array
var aPtr=elemSize*(hi-1);var bPtr=elemSize*pivot;for(var i=0;i<elemSize;++i,++aPtr,++bPtr){var x=boxes[aPtr];boxes[aPtr]=boxes[bPtr];boxes[bPtr]=x;}var y=ids[hi-1];ids[hi-1]=ids[pivot];ids[pivot]=y;//Partition using pivot
pivot=partitionStartLessThan(d,axis,lo,hi-1,boxes,ids,value);//Swap pivot back
var aPtr=elemSize*(hi-1);var bPtr=elemSize*pivot;for(var i=0;i<elemSize;++i,++aPtr,++bPtr){var x=boxes[aPtr];boxes[aPtr]=boxes[bPtr];boxes[bPtr]=x;}var y=ids[hi-1];ids[hi-1]=ids[pivot];ids[pivot]=y;//Swap pivot to last pivot
if(mid<pivot){hi=pivot-1;while(lo<hi&&boxes[elemSize*(hi-1)+axis]===value){hi-=1;}hi+=1;}else if(pivot<mid){lo=pivot+1;while(lo<hi&&boxes[elemSize*lo+axis]===value){lo+=1;}}else{break;}}//Make sure pivot is at start
return partitionStartLessThan(d,axis,start,mid,boxes,ids,boxes[elemSize*mid+axis]);}/***/}),/***/8105:(/***/function(module){"use strict";module.exports=genPartition;var P2F={'lo===p0':lo_equal_p0,'lo<p0':lo_lessThan_p0,'lo<=p0':lo_lessOrEqual_p0,'hi<=p0':hi_lessOrEqual_p0,'lo<p0&&p0<=hi':lo_lessThan_p0_and_p0_lessOrEqual_hi,'lo<=p0&&p0<=hi':lo_lassOrEqual_p0_and_p0_lessOrEqual_hi,'!(lo>=p0)&&!(p1>=hi)':lo_lessThan_p0_and_p1_lessThan_hi};function genPartition(predicate){return P2F[predicate];}// lo===p0
function lo_equal_p0(a,b,c,d,e,f,p0){for(var j=2*a,k=j*c,l=k,m=c,n=b,o=a+b,p=c;d>p;++p,k+=j){var lo=e[k+n];if(lo===p0)if(m===p)m+=1,l+=j;else{for(var s=0;j>s;++s){var t=e[k+s];e[k+s]=e[l],e[l++]=t;}var u=f[p];f[p]=f[m],f[m++]=u;}}return m;}// lo<p0
function lo_lessThan_p0(a,b,c,d,e,f,p0){for(var j=2*a,k=j*c,l=k,m=c,n=b,o=a+b,p=c;d>p;++p,k+=j){var lo=e[k+n];if(lo<p0)if(m===p)m+=1,l+=j;else{for(var s=0;j>s;++s){var t=e[k+s];e[k+s]=e[l],e[l++]=t;}var u=f[p];f[p]=f[m],f[m++]=u;}}return m;}// lo<=p0
function lo_lessOrEqual_p0(a,b,c,d,e,f,p0){for(var j=2*a,k=j*c,l=k,m=c,n=b,o=a+b,p=c;d>p;++p,k+=j){var hi=e[k+o];if(hi<=p0)if(m===p)m+=1,l+=j;else{for(var s=0;j>s;++s){var t=e[k+s];e[k+s]=e[l],e[l++]=t;}var u=f[p];f[p]=f[m],f[m++]=u;}}return m;}// hi<=p0
function hi_lessOrEqual_p0(a,b,c,d,e,f,p0){for(var j=2*a,k=j*c,l=k,m=c,n=b,o=a+b,p=c;d>p;++p,k+=j){var hi=e[k+o];if(hi<=p0)if(m===p)m+=1,l+=j;else{for(var s=0;j>s;++s){var t=e[k+s];e[k+s]=e[l],e[l++]=t;}var u=f[p];f[p]=f[m],f[m++]=u;}}return m;}// lo<=p0&&p0<=hi
function lo_lassOrEqual_p0_and_p0_lessOrEqual_hi(a,b,c,d,e,f,p0){for(var j=2*a,k=j*c,l=k,m=c,n=b,o=a+b,p=c;d>p;++p,k+=j){var lo=e[k+n],hi=e[k+o];if(lo<=p0&&p0<=hi)if(m===p)m+=1,l+=j;else{for(var s=0;j>s;++s){var t=e[k+s];e[k+s]=e[l],e[l++]=t;}var u=f[p];f[p]=f[m],f[m++]=u;}}return m;}// lo<p0&&p0<=hi
function lo_lessThan_p0_and_p0_lessOrEqual_hi(a,b,c,d,e,f,p0){for(var j=2*a,k=j*c,l=k,m=c,n=b,o=a+b,p=c;d>p;++p,k+=j){var lo=e[k+n],hi=e[k+o];if(lo<p0&&p0<=hi)if(m===p)m+=1,l+=j;else{for(var s=0;j>s;++s){var t=e[k+s];e[k+s]=e[l],e[l++]=t;}var u=f[p];f[p]=f[m],f[m++]=u;}}return m;}// !(lo>=p0)&&!(p1>=hi)
function lo_lessThan_p0_and_p1_lessThan_hi(a,b,c,d,e,f,p0,p1){for(var j=2*a,k=j*c,l=k,m=c,n=b,o=a+b,p=c;d>p;++p,k+=j){var lo=e[k+n],hi=e[k+o];if(!(lo>=p0)&&!(p1>=hi))if(m===p)m+=1,l+=j;else{for(var s=0;j>s;++s){var t=e[k+s];e[k+s]=e[l],e[l++]=t;}var u=f[p];f[p]=f[m],f[m++]=u;}}return m;}/***/}),/***/1811:(/***/function(module){"use strict";//This code is extracted from ndarray-sort
//It is inlined here as a temporary workaround
module.exports=wrapper;var INSERT_SORT_CUTOFF=32;function wrapper(data,n0){if(n0<=4*INSERT_SORT_CUTOFF){insertionSort(0,n0-1,data);}else{quickSort(0,n0-1,data);}}function insertionSort(left,right,data){var ptr=2*(left+1);for(var i=left+1;i<=right;++i){var a=data[ptr++];var b=data[ptr++];var j=i;var jptr=ptr-2;while(j-->left){var x=data[jptr-2];var y=data[jptr-1];if(x<a){break;}else if(x===a&&y<b){break;}data[jptr]=x;data[jptr+1]=y;jptr-=2;}data[jptr]=a;data[jptr+1]=b;}}function swap(i,j,data){i*=2;j*=2;var x=data[i];var y=data[i+1];data[i]=data[j];data[i+1]=data[j+1];data[j]=x;data[j+1]=y;}function move(i,j,data){i*=2;j*=2;data[i]=data[j];data[i+1]=data[j+1];}function rotate(i,j,k,data){i*=2;j*=2;k*=2;var x=data[i];var y=data[i+1];data[i]=data[j];data[i+1]=data[j+1];data[j]=data[k];data[j+1]=data[k+1];data[k]=x;data[k+1]=y;}function shufflePivot(i,j,px,py,data){i*=2;j*=2;data[i]=data[j];data[j]=px;data[i+1]=data[j+1];data[j+1]=py;}function compare(i,j,data){i*=2;j*=2;var x=data[i],y=data[j];if(x<y){return false;}else if(x===y){return data[i+1]>data[j+1];}return true;}function comparePivot(i,y,b,data){i*=2;var x=data[i];if(x<y){return true;}else if(x===y){return data[i+1]<b;}return false;}function quickSort(left,right,data){var sixth=(right-left+1)/6|0,index1=left+sixth,index5=right-sixth,index3=left+right>>1,index2=index3-sixth,index4=index3+sixth,el1=index1,el2=index2,el3=index3,el4=index4,el5=index5,less=left+1,great=right-1,tmp=0;if(compare(el1,el2,data)){tmp=el1;el1=el2;el2=tmp;}if(compare(el4,el5,data)){tmp=el4;el4=el5;el5=tmp;}if(compare(el1,el3,data)){tmp=el1;el1=el3;el3=tmp;}if(compare(el2,el3,data)){tmp=el2;el2=el3;el3=tmp;}if(compare(el1,el4,data)){tmp=el1;el1=el4;el4=tmp;}if(compare(el3,el4,data)){tmp=el3;el3=el4;el4=tmp;}if(compare(el2,el5,data)){tmp=el2;el2=el5;el5=tmp;}if(compare(el2,el3,data)){tmp=el2;el2=el3;el3=tmp;}if(compare(el4,el5,data)){tmp=el4;el4=el5;el5=tmp;}var pivot1X=data[2*el2];var pivot1Y=data[2*el2+1];var pivot2X=data[2*el4];var pivot2Y=data[2*el4+1];var ptr0=2*el1;var ptr2=2*el3;var ptr4=2*el5;var ptr5=2*index1;var ptr6=2*index3;var ptr7=2*index5;for(var i1=0;i1<2;++i1){var x=data[ptr0+i1];var y=data[ptr2+i1];var z=data[ptr4+i1];data[ptr5+i1]=x;data[ptr6+i1]=y;data[ptr7+i1]=z;}move(index2,left,data);move(index4,right,data);for(var k=less;k<=great;++k){if(comparePivot(k,pivot1X,pivot1Y,data)){if(k!==less){swap(k,less,data);}++less;}else{if(!comparePivot(k,pivot2X,pivot2Y,data)){while(true){if(!comparePivot(great,pivot2X,pivot2Y,data)){if(--great<k){break;}continue;}else{if(comparePivot(great,pivot1X,pivot1Y,data)){rotate(k,less,great,data);++less;--great;}else{swap(k,great,data);--great;}break;}}}}}shufflePivot(left,less-1,pivot1X,pivot1Y,data);shufflePivot(right,great+1,pivot2X,pivot2Y,data);if(less-2-left<=INSERT_SORT_CUTOFF){insertionSort(left,less-2,data);}else{quickSort(left,less-2,data);}if(right-(great+2)<=INSERT_SORT_CUTOFF){insertionSort(great+2,right,data);}else{quickSort(great+2,right,data);}if(great-less<=INSERT_SORT_CUTOFF){insertionSort(less,great,data);}else{quickSort(less,great,data);}}/***/}),/***/855:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_157752__){"use strict";module.exports={init:sqInit,sweepBipartite:sweepBipartite,sweepComplete:sweepComplete,scanBipartite:scanBipartite,scanComplete:scanComplete};var pool=__nested_webpack_require_157752__(1888);var bits=__nested_webpack_require_157752__(8828);var isort=__nested_webpack_require_157752__(1811);//Flag for blue
var BLUE_FLAG=1<<28;//1D sweep event queue stuff (use pool to save space)
var INIT_CAPACITY=1024;var RED_SWEEP_QUEUE=pool.mallocInt32(INIT_CAPACITY);var RED_SWEEP_INDEX=pool.mallocInt32(INIT_CAPACITY);var BLUE_SWEEP_QUEUE=pool.mallocInt32(INIT_CAPACITY);var BLUE_SWEEP_INDEX=pool.mallocInt32(INIT_CAPACITY);var COMMON_SWEEP_QUEUE=pool.mallocInt32(INIT_CAPACITY);var COMMON_SWEEP_INDEX=pool.mallocInt32(INIT_CAPACITY);var SWEEP_EVENTS=pool.mallocDouble(INIT_CAPACITY*8);//Reserves memory for the 1D sweep data structures
function sqInit(count){var rcount=bits.nextPow2(count);if(RED_SWEEP_QUEUE.length<rcount){pool.free(RED_SWEEP_QUEUE);RED_SWEEP_QUEUE=pool.mallocInt32(rcount);}if(RED_SWEEP_INDEX.length<rcount){pool.free(RED_SWEEP_INDEX);RED_SWEEP_INDEX=pool.mallocInt32(rcount);}if(BLUE_SWEEP_QUEUE.length<rcount){pool.free(BLUE_SWEEP_QUEUE);BLUE_SWEEP_QUEUE=pool.mallocInt32(rcount);}if(BLUE_SWEEP_INDEX.length<rcount){pool.free(BLUE_SWEEP_INDEX);BLUE_SWEEP_INDEX=pool.mallocInt32(rcount);}if(COMMON_SWEEP_QUEUE.length<rcount){pool.free(COMMON_SWEEP_QUEUE);COMMON_SWEEP_QUEUE=pool.mallocInt32(rcount);}if(COMMON_SWEEP_INDEX.length<rcount){pool.free(COMMON_SWEEP_INDEX);COMMON_SWEEP_INDEX=pool.mallocInt32(rcount);}var eventLength=8*rcount;if(SWEEP_EVENTS.length<eventLength){pool.free(SWEEP_EVENTS);SWEEP_EVENTS=pool.mallocDouble(eventLength);}}//Remove an item from the active queue in O(1)
function sqPop(queue,index,count,item){var idx=index[item];var top=queue[count-1];queue[idx]=top;index[top]=idx;}//Insert an item into the active queue in O(1)
function sqPush(queue,index,count,item){queue[count]=item;index[item]=count;}//Recursion base case: use 1D sweep algorithm
function sweepBipartite(d,visit,redStart,redEnd,red,redIndex,blueStart,blueEnd,blue,blueIndex){//store events as pairs [coordinate, idx]
//
//  red create:  -(idx+1)
//  red destroy: idx
//  blue create: -(idx+BLUE_FLAG)
//  blue destroy: idx+BLUE_FLAG
//
var ptr=0;var elemSize=2*d;var istart=d-1;var iend=elemSize-1;for(var i=redStart;i<redEnd;++i){var idx=redIndex[i];var redOffset=elemSize*i;SWEEP_EVENTS[ptr++]=red[redOffset+istart];SWEEP_EVENTS[ptr++]=-(idx+1);SWEEP_EVENTS[ptr++]=red[redOffset+iend];SWEEP_EVENTS[ptr++]=idx;}for(var i=blueStart;i<blueEnd;++i){var idx=blueIndex[i]+BLUE_FLAG;var blueOffset=elemSize*i;SWEEP_EVENTS[ptr++]=blue[blueOffset+istart];SWEEP_EVENTS[ptr++]=-idx;SWEEP_EVENTS[ptr++]=blue[blueOffset+iend];SWEEP_EVENTS[ptr++]=idx;}//process events from left->right
var n=ptr>>>1;isort(SWEEP_EVENTS,n);var redActive=0;var blueActive=0;for(var i=0;i<n;++i){var e=SWEEP_EVENTS[2*i+1]|0;if(e>=BLUE_FLAG){//blue destroy event
e=e-BLUE_FLAG|0;sqPop(BLUE_SWEEP_QUEUE,BLUE_SWEEP_INDEX,blueActive--,e);}else if(e>=0){//red destroy event
sqPop(RED_SWEEP_QUEUE,RED_SWEEP_INDEX,redActive--,e);}else if(e<=-BLUE_FLAG){//blue create event
e=-e-BLUE_FLAG|0;for(var j=0;j<redActive;++j){var retval=visit(RED_SWEEP_QUEUE[j],e);if(retval!==void 0){return retval;}}sqPush(BLUE_SWEEP_QUEUE,BLUE_SWEEP_INDEX,blueActive++,e);}else{//red create event
e=-e-1|0;for(var j=0;j<blueActive;++j){var retval=visit(e,BLUE_SWEEP_QUEUE[j]);if(retval!==void 0){return retval;}}sqPush(RED_SWEEP_QUEUE,RED_SWEEP_INDEX,redActive++,e);}}}//Complete sweep
function sweepComplete(d,visit,redStart,redEnd,red,redIndex,blueStart,blueEnd,blue,blueIndex){var ptr=0;var elemSize=2*d;var istart=d-1;var iend=elemSize-1;for(var i=redStart;i<redEnd;++i){var idx=redIndex[i]+1<<1;var redOffset=elemSize*i;SWEEP_EVENTS[ptr++]=red[redOffset+istart];SWEEP_EVENTS[ptr++]=-idx;SWEEP_EVENTS[ptr++]=red[redOffset+iend];SWEEP_EVENTS[ptr++]=idx;}for(var i=blueStart;i<blueEnd;++i){var idx=blueIndex[i]+1<<1;var blueOffset=elemSize*i;SWEEP_EVENTS[ptr++]=blue[blueOffset+istart];SWEEP_EVENTS[ptr++]=-idx|1;SWEEP_EVENTS[ptr++]=blue[blueOffset+iend];SWEEP_EVENTS[ptr++]=idx|1;}//process events from left->right
var n=ptr>>>1;isort(SWEEP_EVENTS,n);var redActive=0;var blueActive=0;var commonActive=0;for(var i=0;i<n;++i){var e=SWEEP_EVENTS[2*i+1]|0;var color=e&1;if(i<n-1&&e>>1===SWEEP_EVENTS[2*i+3]>>1){color=2;i+=1;}if(e<0){//Create event
var id=-(e>>1)-1;//Intersect with common
for(var j=0;j<commonActive;++j){var retval=visit(COMMON_SWEEP_QUEUE[j],id);if(retval!==void 0){return retval;}}if(color!==0){//Intersect with red
for(var j=0;j<redActive;++j){var retval=visit(RED_SWEEP_QUEUE[j],id);if(retval!==void 0){return retval;}}}if(color!==1){//Intersect with blue
for(var j=0;j<blueActive;++j){var retval=visit(BLUE_SWEEP_QUEUE[j],id);if(retval!==void 0){return retval;}}}if(color===0){//Red
sqPush(RED_SWEEP_QUEUE,RED_SWEEP_INDEX,redActive++,id);}else if(color===1){//Blue
sqPush(BLUE_SWEEP_QUEUE,BLUE_SWEEP_INDEX,blueActive++,id);}else if(color===2){//Both
sqPush(COMMON_SWEEP_QUEUE,COMMON_SWEEP_INDEX,commonActive++,id);}}else{//Destroy event
var id=(e>>1)-1;if(color===0){//Red
sqPop(RED_SWEEP_QUEUE,RED_SWEEP_INDEX,redActive--,id);}else if(color===1){//Blue
sqPop(BLUE_SWEEP_QUEUE,BLUE_SWEEP_INDEX,blueActive--,id);}else if(color===2){//Both
sqPop(COMMON_SWEEP_QUEUE,COMMON_SWEEP_INDEX,commonActive--,id);}}}}//Sweep and prune/scanline algorithm:
//  Scan along axis, detect intersections
//  Brute force all boxes along axis
function scanBipartite(d,axis,visit,flip,redStart,redEnd,red,redIndex,blueStart,blueEnd,blue,blueIndex){var ptr=0;var elemSize=2*d;var istart=axis;var iend=axis+d;var redShift=1;var blueShift=1;if(flip){blueShift=BLUE_FLAG;}else{redShift=BLUE_FLAG;}for(var i=redStart;i<redEnd;++i){var idx=i+redShift;var redOffset=elemSize*i;SWEEP_EVENTS[ptr++]=red[redOffset+istart];SWEEP_EVENTS[ptr++]=-idx;SWEEP_EVENTS[ptr++]=red[redOffset+iend];SWEEP_EVENTS[ptr++]=idx;}for(var i=blueStart;i<blueEnd;++i){var idx=i+blueShift;var blueOffset=elemSize*i;SWEEP_EVENTS[ptr++]=blue[blueOffset+istart];SWEEP_EVENTS[ptr++]=-idx;}//process events from left->right
var n=ptr>>>1;isort(SWEEP_EVENTS,n);var redActive=0;for(var i=0;i<n;++i){var e=SWEEP_EVENTS[2*i+1]|0;if(e<0){var idx=-e;var isRed=false;if(idx>=BLUE_FLAG){isRed=!flip;idx-=BLUE_FLAG;}else{isRed=!!flip;idx-=1;}if(isRed){sqPush(RED_SWEEP_QUEUE,RED_SWEEP_INDEX,redActive++,idx);}else{var blueId=blueIndex[idx];var bluePtr=elemSize*idx;var b0=blue[bluePtr+axis+1];var b1=blue[bluePtr+axis+1+d];red_loop:for(var j=0;j<redActive;++j){var oidx=RED_SWEEP_QUEUE[j];var redPtr=elemSize*oidx;if(b1<red[redPtr+axis+1]||red[redPtr+axis+1+d]<b0){continue;}for(var k=axis+2;k<d;++k){if(blue[bluePtr+k+d]<red[redPtr+k]||red[redPtr+k+d]<blue[bluePtr+k]){continue red_loop;}}var redId=redIndex[oidx];var retval;if(flip){retval=visit(blueId,redId);}else{retval=visit(redId,blueId);}if(retval!==void 0){return retval;}}}}else{sqPop(RED_SWEEP_QUEUE,RED_SWEEP_INDEX,redActive--,e-redShift);}}}function scanComplete(d,axis,visit,redStart,redEnd,red,redIndex,blueStart,blueEnd,blue,blueIndex){var ptr=0;var elemSize=2*d;var istart=axis;var iend=axis+d;for(var i=redStart;i<redEnd;++i){var idx=i+BLUE_FLAG;var redOffset=elemSize*i;SWEEP_EVENTS[ptr++]=red[redOffset+istart];SWEEP_EVENTS[ptr++]=-idx;SWEEP_EVENTS[ptr++]=red[redOffset+iend];SWEEP_EVENTS[ptr++]=idx;}for(var i=blueStart;i<blueEnd;++i){var idx=i+1;var blueOffset=elemSize*i;SWEEP_EVENTS[ptr++]=blue[blueOffset+istart];SWEEP_EVENTS[ptr++]=-idx;}//process events from left->right
var n=ptr>>>1;isort(SWEEP_EVENTS,n);var redActive=0;for(var i=0;i<n;++i){var e=SWEEP_EVENTS[2*i+1]|0;if(e<0){var idx=-e;if(idx>=BLUE_FLAG){RED_SWEEP_QUEUE[redActive++]=idx-BLUE_FLAG;}else{idx-=1;var blueId=blueIndex[idx];var bluePtr=elemSize*idx;var b0=blue[bluePtr+axis+1];var b1=blue[bluePtr+axis+1+d];red_loop:for(var j=0;j<redActive;++j){var oidx=RED_SWEEP_QUEUE[j];var redId=redIndex[oidx];if(redId===blueId){break;}var redPtr=elemSize*oidx;if(b1<red[redPtr+axis+1]||red[redPtr+axis+1+d]<b0){continue;}for(var k=axis+2;k<d;++k){if(blue[bluePtr+k+d]<red[redPtr+k]||red[redPtr+k+d]<blue[bluePtr+k]){continue red_loop;}}var retval=visit(redId,blueId);if(retval!==void 0){return retval;}}}}else{var idx=e-BLUE_FLAG;for(var j=redActive-1;j>=0;--j){if(RED_SWEEP_QUEUE[j]===idx){for(var k=j+1;k<redActive;++k){RED_SWEEP_QUEUE[k-1]=RED_SWEEP_QUEUE[k];}break;}}--redActive;}}}/***/}),/***/2538:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_166225__){"use strict";var monotoneTriangulate=__nested_webpack_require_166225__(8902);var makeIndex=__nested_webpack_require_166225__(5542);var delaunayFlip=__nested_webpack_require_166225__(2272);var filterTriangulation=__nested_webpack_require_166225__(5023);module.exports=cdt2d;function canonicalizeEdge(e){return[Math.min(e[0],e[1]),Math.max(e[0],e[1])];}function compareEdge(a,b){return a[0]-b[0]||a[1]-b[1];}function canonicalizeEdges(edges){return edges.map(canonicalizeEdge).sort(compareEdge);}function getDefault(options,property,dflt){if(property in options){return options[property];}return dflt;}function cdt2d(points,edges,options){if(!Array.isArray(edges)){options=edges||{};edges=[];}else{options=options||{};edges=edges||[];}//Parse out options
var delaunay=!!getDefault(options,'delaunay',true);var interior=!!getDefault(options,'interior',true);var exterior=!!getDefault(options,'exterior',true);var infinity=!!getDefault(options,'infinity',false);//Handle trivial case
if(!interior&&!exterior||points.length===0){return[];}//Construct initial triangulation
var cells=monotoneTriangulate(points,edges);//If delaunay refinement needed, then improve quality by edge flipping
if(delaunay||interior!==exterior||infinity){//Index all of the cells to support fast neighborhood queries
var triangulation=makeIndex(points.length,canonicalizeEdges(edges));for(var i=0;i<cells.length;++i){var f=cells[i];triangulation.addTriangle(f[0],f[1],f[2]);}//Run edge flipping
if(delaunay){delaunayFlip(points,triangulation);}//Filter points
if(!exterior){return filterTriangulation(triangulation,-1);}else if(!interior){return filterTriangulation(triangulation,1,infinity);}else if(infinity){return filterTriangulation(triangulation,0,infinity);}else{return triangulation.cells();}}else{return cells;}}/***/}),/***/2272:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_168048__){"use strict";var inCircle=__nested_webpack_require_168048__(2646)[4];var bsearch=__nested_webpack_require_168048__(2478);module.exports=delaunayRefine;function testFlip(points,triangulation,stack,a,b,x){var y=triangulation.opposite(a,b);//Test boundary edge
if(y<0){return;}//Swap edge if order flipped
if(b<a){var tmp=a;a=b;b=tmp;tmp=x;x=y;y=tmp;}//Test if edge is constrained
if(triangulation.isConstraint(a,b)){return;}//Test if edge is delaunay
if(inCircle(points[a],points[b],points[x],points[y])<0){stack.push(a,b);}}//Assume edges are sorted lexicographically
function delaunayRefine(points,triangulation){var stack=[];var numPoints=points.length;var stars=triangulation.stars;for(var a=0;a<numPoints;++a){var star=stars[a];for(var j=1;j<star.length;j+=2){var b=star[j];//If order is not consistent, then skip edge
if(b<a){continue;}//Check if edge is constrained
if(triangulation.isConstraint(a,b)){continue;}//Find opposite edge
var x=star[j-1],y=-1;for(var k=1;k<star.length;k+=2){if(star[k-1]===b){y=star[k];break;}}//If this is a boundary edge, don't flip it
if(y<0){continue;}//If edge is in circle, flip it
if(inCircle(points[a],points[b],points[x],points[y])<0){stack.push(a,b);}}}while(stack.length>0){var b=stack.pop();var a=stack.pop();//Find opposite pairs
var x=-1,y=-1;var star=stars[a];for(var i=1;i<star.length;i+=2){var s=star[i-1];var t=star[i];if(s===b){y=t;}else if(t===b){x=s;}}//If x/y are both valid then skip edge
if(x<0||y<0){continue;}//If edge is now delaunay, then don't flip it
if(inCircle(points[a],points[b],points[x],points[y])>=0){continue;}//Flip the edge
triangulation.flip(a,b);//Test flipping neighboring edges
testFlip(points,triangulation,stack,x,a,y);testFlip(points,triangulation,stack,a,y,x);testFlip(points,triangulation,stack,y,b,x);testFlip(points,triangulation,stack,b,x,y);}}/***/}),/***/5023:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_169935__){"use strict";var bsearch=__nested_webpack_require_169935__(2478);module.exports=classifyFaces;function FaceIndex(cells,neighbor,constraint,flags,active,next,boundary){this.cells=cells;this.neighbor=neighbor;this.flags=flags;this.constraint=constraint;this.active=active;this.next=next;this.boundary=boundary;}var proto=FaceIndex.prototype;function compareCell(a,b){return a[0]-b[0]||a[1]-b[1]||a[2]-b[2];}proto.locate=function(){var key=[0,0,0];return function(a,b,c){var x=a,y=b,z=c;if(b<c){if(b<a){x=b;y=c;z=a;}}else if(c<a){x=c;y=a;z=b;}if(x<0){return-1;}key[0]=x;key[1]=y;key[2]=z;return bsearch.eq(this.cells,key,compareCell);};}();function indexCells(triangulation,infinity){//First get cells and canonicalize
var cells=triangulation.cells();var nc=cells.length;for(var i=0;i<nc;++i){var c=cells[i];var x=c[0],y=c[1],z=c[2];if(y<z){if(y<x){c[0]=y;c[1]=z;c[2]=x;}}else if(z<x){c[0]=z;c[1]=x;c[2]=y;}}cells.sort(compareCell);//Initialize flag array
var flags=new Array(nc);for(var i=0;i<flags.length;++i){flags[i]=0;}//Build neighbor index, initialize queues
var active=[];var next=[];var neighbor=new Array(3*nc);var constraint=new Array(3*nc);var boundary=null;if(infinity){boundary=[];}var index=new FaceIndex(cells,neighbor,constraint,flags,active,next,boundary);for(var i=0;i<nc;++i){var c=cells[i];for(var j=0;j<3;++j){var x=c[j],y=c[(j+1)%3];var a=neighbor[3*i+j]=index.locate(y,x,triangulation.opposite(y,x));var b=constraint[3*i+j]=triangulation.isConstraint(x,y);if(a<0){if(b){next.push(i);}else{active.push(i);flags[i]=1;}if(infinity){boundary.push([y,x,-1]);}}}}return index;}function filterCells(cells,flags,target){var ptr=0;for(var i=0;i<cells.length;++i){if(flags[i]===target){cells[ptr++]=cells[i];}}cells.length=ptr;return cells;}function classifyFaces(triangulation,target,infinity){var index=indexCells(triangulation,infinity);if(target===0){if(infinity){return index.cells.concat(index.boundary);}else{return index.cells;}}var side=1;var active=index.active;var next=index.next;var flags=index.flags;var cells=index.cells;var constraint=index.constraint;var neighbor=index.neighbor;while(active.length>0||next.length>0){while(active.length>0){var t=active.pop();if(flags[t]===-side){continue;}flags[t]=side;var c=cells[t];for(var j=0;j<3;++j){var f=neighbor[3*t+j];if(f>=0&&flags[f]===0){if(constraint[3*t+j]){next.push(f);}else{active.push(f);flags[f]=side;}}}}//Swap arrays and loop
var tmp=next;next=active;active=tmp;next.length=0;side=-side;}var result=filterCells(cells,flags,target);if(infinity){return result.concat(index.boundary);}return result;}/***/}),/***/8902:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_172588__){"use strict";var bsearch=__nested_webpack_require_172588__(2478);var orient=__nested_webpack_require_172588__(3250)[3];var EVENT_POINT=0;var EVENT_END=1;var EVENT_START=2;module.exports=monotoneTriangulate;//A partial convex hull fragment, made of two unimonotone polygons
function PartialHull(a,b,idx,lowerIds,upperIds){this.a=a;this.b=b;this.idx=idx;this.lowerIds=lowerIds;this.upperIds=upperIds;}//An event in the sweep line procedure
function Event(a,b,type,idx){this.a=a;this.b=b;this.type=type;this.idx=idx;}//This is used to compare events for the sweep line procedure
// Points are:
//  1. sorted lexicographically
//  2. sorted by type  (point < end < start)
//  3. segments sorted by winding order
//  4. sorted by index
function compareEvent(a,b){var d=a.a[0]-b.a[0]||a.a[1]-b.a[1]||a.type-b.type;if(d){return d;}if(a.type!==EVENT_POINT){d=orient(a.a,a.b,b.b);if(d){return d;}}return a.idx-b.idx;}function testPoint(hull,p){return orient(hull.a,hull.b,p);}function addPoint(cells,hulls,points,p,idx){var lo=bsearch.lt(hulls,p,testPoint);var hi=bsearch.gt(hulls,p,testPoint);for(var i=lo;i<hi;++i){var hull=hulls[i];//Insert p into lower hull
var lowerIds=hull.lowerIds;var m=lowerIds.length;while(m>1&&orient(points[lowerIds[m-2]],points[lowerIds[m-1]],p)>0){cells.push([lowerIds[m-1],lowerIds[m-2],idx]);m-=1;}lowerIds.length=m;lowerIds.push(idx);//Insert p into upper hull
var upperIds=hull.upperIds;var m=upperIds.length;while(m>1&&orient(points[upperIds[m-2]],points[upperIds[m-1]],p)<0){cells.push([upperIds[m-2],upperIds[m-1],idx]);m-=1;}upperIds.length=m;upperIds.push(idx);}}function findSplit(hull,edge){var d;if(hull.a[0]<edge.a[0]){d=orient(hull.a,hull.b,edge.a);}else{d=orient(edge.b,edge.a,hull.a);}if(d){return d;}if(edge.b[0]<hull.b[0]){d=orient(hull.a,hull.b,edge.b);}else{d=orient(edge.b,edge.a,hull.b);}return d||hull.idx-edge.idx;}function splitHulls(hulls,points,event){var splitIdx=bsearch.le(hulls,event,findSplit);var hull=hulls[splitIdx];var upperIds=hull.upperIds;var x=upperIds[upperIds.length-1];hull.upperIds=[x];hulls.splice(splitIdx+1,0,new PartialHull(event.a,event.b,event.idx,[x],upperIds));}function mergeHulls(hulls,points,event){//Swap pointers for merge search
var tmp=event.a;event.a=event.b;event.b=tmp;var mergeIdx=bsearch.eq(hulls,event,findSplit);var upper=hulls[mergeIdx];var lower=hulls[mergeIdx-1];lower.upperIds=upper.upperIds;hulls.splice(mergeIdx,1);}function monotoneTriangulate(points,edges){var numPoints=points.length;var numEdges=edges.length;var events=[];//Create point events
for(var i=0;i<numPoints;++i){events.push(new Event(points[i],null,EVENT_POINT,i));}//Create edge events
for(var i=0;i<numEdges;++i){var e=edges[i];var a=points[e[0]];var b=points[e[1]];if(a[0]<b[0]){events.push(new Event(a,b,EVENT_START,i),new Event(b,a,EVENT_END,i));}else if(a[0]>b[0]){events.push(new Event(b,a,EVENT_START,i),new Event(a,b,EVENT_END,i));}}//Sort events
events.sort(compareEvent);//Initialize hull
var minX=events[0].a[0]-(1+Math.abs(events[0].a[0]))*Math.pow(2,-52);var hull=[new PartialHull([minX,1],[minX,0],-1,[],[],[],[])];//Process events in order
var cells=[];for(var i=0,numEvents=events.length;i<numEvents;++i){var event=events[i];var type=event.type;if(type===EVENT_POINT){addPoint(cells,hull,points,event.a,event.idx);}else if(type===EVENT_START){splitHulls(hull,points,event);}else{mergeHulls(hull,points,event);}}//Return triangulation
return cells;}/***/}),/***/5542:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_176071__){"use strict";var bsearch=__nested_webpack_require_176071__(2478);module.exports=createTriangulation;function Triangulation(stars,edges){this.stars=stars;this.edges=edges;}var proto=Triangulation.prototype;function removePair(list,j,k){for(var i=1,n=list.length;i<n;i+=2){if(list[i-1]===j&&list[i]===k){list[i-1]=list[n-2];list[i]=list[n-1];list.length=n-2;return;}}}proto.isConstraint=function(){var e=[0,0];function compareLex(a,b){return a[0]-b[0]||a[1]-b[1];}return function(i,j){e[0]=Math.min(i,j);e[1]=Math.max(i,j);return bsearch.eq(this.edges,e,compareLex)>=0;};}();proto.removeTriangle=function(i,j,k){var stars=this.stars;removePair(stars[i],j,k);removePair(stars[j],k,i);removePair(stars[k],i,j);};proto.addTriangle=function(i,j,k){var stars=this.stars;stars[i].push(j,k);stars[j].push(k,i);stars[k].push(i,j);};proto.opposite=function(j,i){var list=this.stars[i];for(var k=1,n=list.length;k<n;k+=2){if(list[k]===j){return list[k-1];}}return-1;};proto.flip=function(i,j){var a=this.opposite(i,j);var b=this.opposite(j,i);this.removeTriangle(i,j,a);this.removeTriangle(j,i,b);this.addTriangle(i,b,a);this.addTriangle(j,a,b);};proto.edges=function(){var stars=this.stars;var result=[];for(var i=0,n=stars.length;i<n;++i){var list=stars[i];for(var j=0,m=list.length;j<m;j+=2){result.push([list[j],list[j+1]]);}}return result;};proto.cells=function(){var stars=this.stars;var result=[];for(var i=0,n=stars.length;i<n;++i){var list=stars[i];for(var j=0,m=list.length;j<m;j+=2){var s=list[j];var t=list[j+1];if(i<Math.min(s,t)){result.push([i,s,t]);}}}return result;};function createTriangulation(numVerts,edges){var stars=new Array(numVerts);for(var i=0;i<numVerts;++i){stars[i]=[];}return new Triangulation(stars,edges);}/***/}),/***/2419:(/***/function(module){"use strict";module.exports=orientation;function orientation(s){var p=1;for(var i=1;i<s.length;++i){for(var j=0;j<i;++j){if(s[i]<s[j]){p=-p;}else if(s[j]===s[i]){return 0;}}}return p;}/***/}),/***/3628:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_178095__){"use strict";var dup=__nested_webpack_require_178095__(1338);var solve=__nested_webpack_require_178095__(727);function dot(a,b){var s=0.0;var d=a.length;for(var i=0;i<d;++i){s+=a[i]*b[i];}return s;}function barycentricCircumcenter(points){var N=points.length;if(N===0){return[];}var D=points[0].length;var A=dup([points.length+1,points.length+1],1.0);var b=dup([points.length+1],1.0);A[N][N]=0.0;for(var i=0;i<N;++i){for(var j=0;j<=i;++j){A[j][i]=A[i][j]=2.0*dot(points[i],points[j]);}b[i]=dot(points[i],points[i]);}var x=solve(A,b);var denom=0.0;var h=x[N+1];for(var i=0;i<h.length;++i){denom+=h[i];}var y=new Array(N);for(var i=0;i<N;++i){var h=x[i];var numer=0.0;for(var j=0;j<h.length;++j){numer+=h[j];}y[i]=numer/denom;}return y;}function circumcenter(points){if(points.length===0){return[];}var D=points[0].length;var result=dup([D]);var weights=barycentricCircumcenter(points);for(var i=0;i<points.length;++i){for(var j=0;j<D;++j){result[j]+=points[i][j]*weights[i];}}return result;}circumcenter.barycenetric=barycentricCircumcenter;module.exports=circumcenter;/***/}),/***/6037:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_179221__){module.exports=circumradius;var circumcenter=__nested_webpack_require_179221__(3628);function circumradius(points){var center=circumcenter(points);var avgDist=0.0;for(var i=0;i<points.length;++i){var p=points[i];for(var j=0;j<center.length;++j){avgDist+=Math.pow(p[j]-center[j],2);}}return Math.sqrt(avgDist/points.length);}/***/}),/***/332:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_179616__){"use strict";module.exports=cleanPSLG;var UnionFind=__nested_webpack_require_179616__(1755);var boxIntersect=__nested_webpack_require_179616__(6867);var segseg=__nested_webpack_require_179616__(1125);var rat=__nested_webpack_require_179616__(7842);var ratCmp=__nested_webpack_require_179616__(1318);var ratToFloat=__nested_webpack_require_179616__(946);var ratVec=__nested_webpack_require_179616__(5838);var nextafter=__nested_webpack_require_179616__(1278);var solveIntersection=__nested_webpack_require_179616__(3637);// Bounds on a rational number when rounded to a float
function boundRat(r){var f=ratToFloat(r);return[nextafter(f,-Infinity),nextafter(f,Infinity)];}// Convert a list of edges in a pslg to bounding boxes
function boundEdges(points,edges){var bounds=new Array(edges.length);for(var i=0;i<edges.length;++i){var e=edges[i];var a=points[e[0]];var b=points[e[1]];bounds[i]=[nextafter(Math.min(a[0],b[0]),-Infinity),nextafter(Math.min(a[1],b[1]),-Infinity),nextafter(Math.max(a[0],b[0]),Infinity),nextafter(Math.max(a[1],b[1]),Infinity)];}return bounds;}// Convert a list of points into bounding boxes by duplicating coords
function boundPoints(points){var bounds=new Array(points.length);for(var i=0;i<points.length;++i){var p=points[i];bounds[i]=[nextafter(p[0],-Infinity),nextafter(p[1],-Infinity),nextafter(p[0],Infinity),nextafter(p[1],Infinity)];}return bounds;}// Find all pairs of crossing edges in a pslg (given edge bounds)
function getCrossings(points,edges,edgeBounds){var result=[];boxIntersect(edgeBounds,function(i,j){var e=edges[i];var f=edges[j];if(e[0]===f[0]||e[0]===f[1]||e[1]===f[0]||e[1]===f[1]){return;}var a=points[e[0]];var b=points[e[1]];var c=points[f[0]];var d=points[f[1]];if(segseg(a,b,c,d)){result.push([i,j]);}});return result;}// Find all pairs of crossing vertices in a pslg (given edge/vert bounds)
function getTJunctions(points,edges,edgeBounds,vertBounds){var result=[];boxIntersect(edgeBounds,vertBounds,function(i,v){var e=edges[i];if(e[0]===v||e[1]===v){return;}var p=points[v];var a=points[e[0]];var b=points[e[1]];if(segseg(a,b,p,p)){result.push([i,v]);}});return result;}// Cut edges along crossings/tjunctions
function cutEdges(floatPoints,edges,crossings,junctions,useColor){var i,e;// Convert crossings into tjunctions by constructing rational points
var ratPoints=floatPoints.map(function(p){return[rat(p[0]),rat(p[1])];});for(i=0;i<crossings.length;++i){var crossing=crossings[i];e=crossing[0];var f=crossing[1];var ee=edges[e];var ef=edges[f];var x=solveIntersection(ratVec(floatPoints[ee[0]]),ratVec(floatPoints[ee[1]]),ratVec(floatPoints[ef[0]]),ratVec(floatPoints[ef[1]]));if(!x){// Segments are parallel, should already be handled by t-junctions
continue;}var idx=floatPoints.length;floatPoints.push([ratToFloat(x[0]),ratToFloat(x[1])]);ratPoints.push(x);junctions.push([e,idx],[f,idx]);}// Sort tjunctions
junctions.sort(function(a,b){if(a[0]!==b[0]){return a[0]-b[0];}var u=ratPoints[a[1]];var v=ratPoints[b[1]];return ratCmp(u[0],v[0])||ratCmp(u[1],v[1]);});// Split edges along junctions
for(i=junctions.length-1;i>=0;--i){var junction=junctions[i];e=junction[0];var edge=edges[e];var s=edge[0];var t=edge[1];// Check if edge is not lexicographically sorted
var a=floatPoints[s];var b=floatPoints[t];if((a[0]-b[0]||a[1]-b[1])<0){var tmp=s;s=t;t=tmp;}// Split leading edge
edge[0]=s;var last=edge[1]=junction[1];// If we are grouping edges by color, remember to track data
var color;if(useColor){color=edge[2];}// Split other edges
while(i>0&&junctions[i-1][0]===e){var junction=junctions[--i];var next=junction[1];if(useColor){edges.push([last,next,color]);}else{edges.push([last,next]);}last=next;}// Add final edge
if(useColor){edges.push([last,t,color]);}else{edges.push([last,t]);}}// Return constructed rational points
return ratPoints;}// Merge overlapping points
function dedupPoints(floatPoints,ratPoints,floatBounds){var numPoints=ratPoints.length;var uf=new UnionFind(numPoints);// Compute rational bounds
var bounds=[];for(var i=0;i<ratPoints.length;++i){var p=ratPoints[i];var xb=boundRat(p[0]);var yb=boundRat(p[1]);bounds.push([nextafter(xb[0],-Infinity),nextafter(yb[0],-Infinity),nextafter(xb[1],Infinity),nextafter(yb[1],Infinity)]);}// Link all points with over lapping boxes
boxIntersect(bounds,function(i,j){uf.link(i,j);});// Do 1 pass over points to combine points in label sets
var noDupes=true;var labels=new Array(numPoints);for(var i=0;i<numPoints;++i){var j=uf.find(i);if(j!==i){// Clear no-dupes flag, zero out label
noDupes=false;// Make each point the top-left point from its cell
floatPoints[j]=[Math.min(floatPoints[i][0],floatPoints[j][0]),Math.min(floatPoints[i][1],floatPoints[j][1])];}}// If no duplicates, return null to signal termination
if(noDupes){return null;}var ptr=0;for(var i=0;i<numPoints;++i){var j=uf.find(i);if(j===i){labels[i]=ptr;floatPoints[ptr++]=floatPoints[i];}else{labels[i]=-1;}}floatPoints.length=ptr;// Do a second pass to fix up missing labels
for(var i=0;i<numPoints;++i){if(labels[i]<0){labels[i]=labels[uf.find(i)];}}// Return resulting union-find data structure
return labels;}function compareLex2(a,b){return a[0]-b[0]||a[1]-b[1];}function compareLex3(a,b){var d=a[0]-b[0]||a[1]-b[1];if(d){return d;}if(a[2]<b[2]){return-1;}else if(a[2]>b[2]){return 1;}return 0;}// Remove duplicate edge labels
function dedupEdges(edges,labels,useColor){if(edges.length===0){return;}if(labels){for(var i=0;i<edges.length;++i){var e=edges[i];var a=labels[e[0]];var b=labels[e[1]];e[0]=Math.min(a,b);e[1]=Math.max(a,b);}}else{for(var i=0;i<edges.length;++i){var e=edges[i];var a=e[0];var b=e[1];e[0]=Math.min(a,b);e[1]=Math.max(a,b);}}if(useColor){edges.sort(compareLex3);}else{edges.sort(compareLex2);}var ptr=1;for(var i=1;i<edges.length;++i){var prev=edges[i-1];var next=edges[i];if(next[0]===prev[0]&&next[1]===prev[1]&&(!useColor||next[2]===prev[2])){continue;}edges[ptr++]=next;}edges.length=ptr;}function preRound(points,edges,useColor){var labels=dedupPoints(points,[],boundPoints(points));dedupEdges(edges,labels,useColor);return!!labels;}// Repeat until convergence
function snapRound(points,edges,useColor){// 1. find edge crossings
var edgeBounds=boundEdges(points,edges);var crossings=getCrossings(points,edges,edgeBounds);// 2. find t-junctions
var vertBounds=boundPoints(points);var tjunctions=getTJunctions(points,edges,edgeBounds,vertBounds);// 3. cut edges, construct rational points
var ratPoints=cutEdges(points,edges,crossings,tjunctions,useColor);// 4. dedupe verts
var labels=dedupPoints(points,ratPoints,vertBounds);// 5. dedupe edges
dedupEdges(edges,labels,useColor);// 6. check termination
if(!labels){return crossings.length>0||tjunctions.length>0;}// More iterations necessary
return true;}// Main loop, runs PSLG clean up until completion
function cleanPSLG(points,edges,colors){// If using colors, augment edges with color data
var prevEdges;if(colors){prevEdges=edges;var augEdges=new Array(edges.length);for(var i=0;i<edges.length;++i){var e=edges[i];augEdges[i]=[e[0],e[1],colors[i]];}edges=augEdges;}// First round: remove duplicate edges and points
var modified=preRound(points,edges,!!colors);// Run snap rounding until convergence
while(snapRound(points,edges,!!colors)){modified=true;}// Strip color tags
if(!!colors&&modified){prevEdges.length=0;colors.length=0;for(var i=0;i<edges.length;++i){var e=edges[i];prevEdges.push([e[0],e[1]]);colors.push(e[2]);}}return modified;}/***/}),/***/3637:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_187010__){"use strict";module.exports=solveIntersection;var ratMul=__nested_webpack_require_187010__(6504);var ratDiv=__nested_webpack_require_187010__(8697);var ratSub=__nested_webpack_require_187010__(5572);var ratSign=__nested_webpack_require_187010__(7721);var rvSub=__nested_webpack_require_187010__(544);var rvAdd=__nested_webpack_require_187010__(2653);var rvMuls=__nested_webpack_require_187010__(8987);function ratPerp(a,b){return ratSub(ratMul(a[0],b[1]),ratMul(a[1],b[0]));}// Solve for intersection
//  x = a + t (b-a)
//  (x - c) ^ (d-c) = 0
//  (t * (b-a) + (a-c) ) ^ (d-c) = 0
//  t * (b-a)^(d-c) = (d-c)^(a-c)
//  t = (d-c)^(a-c) / (b-a)^(d-c)
function solveIntersection(a,b,c,d){var ba=rvSub(b,a);var dc=rvSub(d,c);var baXdc=ratPerp(ba,dc);if(ratSign(baXdc)===0){return null;}var ac=rvSub(a,c);var dcXac=ratPerp(dc,ac);var t=ratDiv(dcXac,baXdc);var s=rvMuls(ba,t);var r=rvAdd(a,s);return r;}/***/}),/***/3642:(/***/function(module){module.exports={"jet":[{"index":0,"rgb":[0,0,131]},{"index":0.125,"rgb":[0,60,170]},{"index":0.375,"rgb":[5,255,255]},{"index":0.625,"rgb":[255,255,0]},{"index":0.875,"rgb":[250,0,0]},{"index":1,"rgb":[128,0,0]}],"hsv":[{"index":0,"rgb":[255,0,0]},{"index":0.169,"rgb":[253,255,2]},{"index":0.173,"rgb":[247,255,2]},{"index":0.337,"rgb":[0,252,4]},{"index":0.341,"rgb":[0,252,10]},{"index":0.506,"rgb":[1,249,255]},{"index":0.671,"rgb":[2,0,253]},{"index":0.675,"rgb":[8,0,253]},{"index":0.839,"rgb":[255,0,251]},{"index":0.843,"rgb":[255,0,245]},{"index":1,"rgb":[255,0,6]}],"hot":[{"index":0,"rgb":[0,0,0]},{"index":0.3,"rgb":[230,0,0]},{"index":0.6,"rgb":[255,210,0]},{"index":1,"rgb":[255,255,255]}],"spring":[{"index":0,"rgb":[255,0,255]},{"index":1,"rgb":[255,255,0]}],"summer":[{"index":0,"rgb":[0,128,102]},{"index":1,"rgb":[255,255,102]}],"autumn":[{"index":0,"rgb":[255,0,0]},{"index":1,"rgb":[255,255,0]}],"winter":[{"index":0,"rgb":[0,0,255]},{"index":1,"rgb":[0,255,128]}],"bone":[{"index":0,"rgb":[0,0,0]},{"index":0.376,"rgb":[84,84,116]},{"index":0.753,"rgb":[169,200,200]},{"index":1,"rgb":[255,255,255]}],"copper":[{"index":0,"rgb":[0,0,0]},{"index":0.804,"rgb":[255,160,102]},{"index":1,"rgb":[255,199,127]}],"greys":[{"index":0,"rgb":[0,0,0]},{"index":1,"rgb":[255,255,255]}],"yignbu":[{"index":0,"rgb":[8,29,88]},{"index":0.125,"rgb":[37,52,148]},{"index":0.25,"rgb":[34,94,168]},{"index":0.375,"rgb":[29,145,192]},{"index":0.5,"rgb":[65,182,196]},{"index":0.625,"rgb":[127,205,187]},{"index":0.75,"rgb":[199,233,180]},{"index":0.875,"rgb":[237,248,217]},{"index":1,"rgb":[255,255,217]}],"greens":[{"index":0,"rgb":[0,68,27]},{"index":0.125,"rgb":[0,109,44]},{"index":0.25,"rgb":[35,139,69]},{"index":0.375,"rgb":[65,171,93]},{"index":0.5,"rgb":[116,196,118]},{"index":0.625,"rgb":[161,217,155]},{"index":0.75,"rgb":[199,233,192]},{"index":0.875,"rgb":[229,245,224]},{"index":1,"rgb":[247,252,245]}],"yiorrd":[{"index":0,"rgb":[128,0,38]},{"index":0.125,"rgb":[189,0,38]},{"index":0.25,"rgb":[227,26,28]},{"index":0.375,"rgb":[252,78,42]},{"index":0.5,"rgb":[253,141,60]},{"index":0.625,"rgb":[254,178,76]},{"index":0.75,"rgb":[254,217,118]},{"index":0.875,"rgb":[255,237,160]},{"index":1,"rgb":[255,255,204]}],"bluered":[{"index":0,"rgb":[0,0,255]},{"index":1,"rgb":[255,0,0]}],"rdbu":[{"index":0,"rgb":[5,10,172]},{"index":0.35,"rgb":[106,137,247]},{"index":0.5,"rgb":[190,190,190]},{"index":0.6,"rgb":[220,170,132]},{"index":0.7,"rgb":[230,145,90]},{"index":1,"rgb":[178,10,28]}],"picnic":[{"index":0,"rgb":[0,0,255]},{"index":0.1,"rgb":[51,153,255]},{"index":0.2,"rgb":[102,204,255]},{"index":0.3,"rgb":[153,204,255]},{"index":0.4,"rgb":[204,204,255]},{"index":0.5,"rgb":[255,255,255]},{"index":0.6,"rgb":[255,204,255]},{"index":0.7,"rgb":[255,153,255]},{"index":0.8,"rgb":[255,102,204]},{"index":0.9,"rgb":[255,102,102]},{"index":1,"rgb":[255,0,0]}],"rainbow":[{"index":0,"rgb":[150,0,90]},{"index":0.125,"rgb":[0,0,200]},{"index":0.25,"rgb":[0,25,255]},{"index":0.375,"rgb":[0,152,255]},{"index":0.5,"rgb":[44,255,150]},{"index":0.625,"rgb":[151,255,0]},{"index":0.75,"rgb":[255,234,0]},{"index":0.875,"rgb":[255,111,0]},{"index":1,"rgb":[255,0,0]}],"portland":[{"index":0,"rgb":[12,51,131]},{"index":0.25,"rgb":[10,136,186]},{"index":0.5,"rgb":[242,211,56]},{"index":0.75,"rgb":[242,143,56]},{"index":1,"rgb":[217,30,30]}],"blackbody":[{"index":0,"rgb":[0,0,0]},{"index":0.2,"rgb":[230,0,0]},{"index":0.4,"rgb":[230,210,0]},{"index":0.7,"rgb":[255,255,255]},{"index":1,"rgb":[160,200,255]}],"earth":[{"index":0,"rgb":[0,0,130]},{"index":0.1,"rgb":[0,180,180]},{"index":0.2,"rgb":[40,210,40]},{"index":0.4,"rgb":[230,230,50]},{"index":0.6,"rgb":[120,70,20]},{"index":1,"rgb":[255,255,255]}],"electric":[{"index":0,"rgb":[0,0,0]},{"index":0.15,"rgb":[30,0,100]},{"index":0.4,"rgb":[120,0,100]},{"index":0.6,"rgb":[160,90,0]},{"index":0.8,"rgb":[230,200,0]},{"index":1,"rgb":[255,250,220]}],"alpha":[{"index":0,"rgb":[255,255,255,0]},{"index":1,"rgb":[255,255,255,1]}],"viridis":[{"index":0,"rgb":[68,1,84]},{"index":0.13,"rgb":[71,44,122]},{"index":0.25,"rgb":[59,81,139]},{"index":0.38,"rgb":[44,113,142]},{"index":0.5,"rgb":[33,144,141]},{"index":0.63,"rgb":[39,173,129]},{"index":0.75,"rgb":[92,200,99]},{"index":0.88,"rgb":[170,220,50]},{"index":1,"rgb":[253,231,37]}],"inferno":[{"index":0,"rgb":[0,0,4]},{"index":0.13,"rgb":[31,12,72]},{"index":0.25,"rgb":[85,15,109]},{"index":0.38,"rgb":[136,34,106]},{"index":0.5,"rgb":[186,54,85]},{"index":0.63,"rgb":[227,89,51]},{"index":0.75,"rgb":[249,140,10]},{"index":0.88,"rgb":[249,201,50]},{"index":1,"rgb":[252,255,164]}],"magma":[{"index":0,"rgb":[0,0,4]},{"index":0.13,"rgb":[28,16,68]},{"index":0.25,"rgb":[79,18,123]},{"index":0.38,"rgb":[129,37,129]},{"index":0.5,"rgb":[181,54,122]},{"index":0.63,"rgb":[229,80,100]},{"index":0.75,"rgb":[251,135,97]},{"index":0.88,"rgb":[254,194,135]},{"index":1,"rgb":[252,253,191]}],"plasma":[{"index":0,"rgb":[13,8,135]},{"index":0.13,"rgb":[75,3,161]},{"index":0.25,"rgb":[125,3,168]},{"index":0.38,"rgb":[168,34,150]},{"index":0.5,"rgb":[203,70,121]},{"index":0.63,"rgb":[229,107,93]},{"index":0.75,"rgb":[248,148,65]},{"index":0.88,"rgb":[253,195,40]},{"index":1,"rgb":[240,249,33]}],"warm":[{"index":0,"rgb":[125,0,179]},{"index":0.13,"rgb":[172,0,187]},{"index":0.25,"rgb":[219,0,170]},{"index":0.38,"rgb":[255,0,130]},{"index":0.5,"rgb":[255,63,74]},{"index":0.63,"rgb":[255,123,0]},{"index":0.75,"rgb":[234,176,0]},{"index":0.88,"rgb":[190,228,0]},{"index":1,"rgb":[147,255,0]}],"cool":[{"index":0,"rgb":[125,0,179]},{"index":0.13,"rgb":[116,0,218]},{"index":0.25,"rgb":[98,74,237]},{"index":0.38,"rgb":[68,146,231]},{"index":0.5,"rgb":[0,204,197]},{"index":0.63,"rgb":[0,247,146]},{"index":0.75,"rgb":[0,255,88]},{"index":0.88,"rgb":[40,255,8]},{"index":1,"rgb":[147,255,0]}],"rainbow-soft":[{"index":0,"rgb":[125,0,179]},{"index":0.1,"rgb":[199,0,180]},{"index":0.2,"rgb":[255,0,121]},{"index":0.3,"rgb":[255,108,0]},{"index":0.4,"rgb":[222,194,0]},{"index":0.5,"rgb":[150,255,0]},{"index":0.6,"rgb":[0,255,55]},{"index":0.7,"rgb":[0,246,150]},{"index":0.8,"rgb":[50,167,222]},{"index":0.9,"rgb":[103,51,235]},{"index":1,"rgb":[124,0,186]}],"bathymetry":[{"index":0,"rgb":[40,26,44]},{"index":0.13,"rgb":[59,49,90]},{"index":0.25,"rgb":[64,76,139]},{"index":0.38,"rgb":[63,110,151]},{"index":0.5,"rgb":[72,142,158]},{"index":0.63,"rgb":[85,174,163]},{"index":0.75,"rgb":[120,206,163]},{"index":0.88,"rgb":[187,230,172]},{"index":1,"rgb":[253,254,204]}],"cdom":[{"index":0,"rgb":[47,15,62]},{"index":0.13,"rgb":[87,23,86]},{"index":0.25,"rgb":[130,28,99]},{"index":0.38,"rgb":[171,41,96]},{"index":0.5,"rgb":[206,67,86]},{"index":0.63,"rgb":[230,106,84]},{"index":0.75,"rgb":[242,149,103]},{"index":0.88,"rgb":[249,193,135]},{"index":1,"rgb":[254,237,176]}],"chlorophyll":[{"index":0,"rgb":[18,36,20]},{"index":0.13,"rgb":[25,63,41]},{"index":0.25,"rgb":[24,91,59]},{"index":0.38,"rgb":[13,119,72]},{"index":0.5,"rgb":[18,148,80]},{"index":0.63,"rgb":[80,173,89]},{"index":0.75,"rgb":[132,196,122]},{"index":0.88,"rgb":[175,221,162]},{"index":1,"rgb":[215,249,208]}],"density":[{"index":0,"rgb":[54,14,36]},{"index":0.13,"rgb":[89,23,80]},{"index":0.25,"rgb":[110,45,132]},{"index":0.38,"rgb":[120,77,178]},{"index":0.5,"rgb":[120,113,213]},{"index":0.63,"rgb":[115,151,228]},{"index":0.75,"rgb":[134,185,227]},{"index":0.88,"rgb":[177,214,227]},{"index":1,"rgb":[230,241,241]}],"freesurface-blue":[{"index":0,"rgb":[30,4,110]},{"index":0.13,"rgb":[47,14,176]},{"index":0.25,"rgb":[41,45,236]},{"index":0.38,"rgb":[25,99,212]},{"index":0.5,"rgb":[68,131,200]},{"index":0.63,"rgb":[114,156,197]},{"index":0.75,"rgb":[157,181,203]},{"index":0.88,"rgb":[200,208,216]},{"index":1,"rgb":[241,237,236]}],"freesurface-red":[{"index":0,"rgb":[60,9,18]},{"index":0.13,"rgb":[100,17,27]},{"index":0.25,"rgb":[142,20,29]},{"index":0.38,"rgb":[177,43,27]},{"index":0.5,"rgb":[192,87,63]},{"index":0.63,"rgb":[205,125,105]},{"index":0.75,"rgb":[216,162,148]},{"index":0.88,"rgb":[227,199,193]},{"index":1,"rgb":[241,237,236]}],"oxygen":[{"index":0,"rgb":[64,5,5]},{"index":0.13,"rgb":[106,6,15]},{"index":0.25,"rgb":[144,26,7]},{"index":0.38,"rgb":[168,64,3]},{"index":0.5,"rgb":[188,100,4]},{"index":0.63,"rgb":[206,136,11]},{"index":0.75,"rgb":[220,174,25]},{"index":0.88,"rgb":[231,215,44]},{"index":1,"rgb":[248,254,105]}],"par":[{"index":0,"rgb":[51,20,24]},{"index":0.13,"rgb":[90,32,35]},{"index":0.25,"rgb":[129,44,34]},{"index":0.38,"rgb":[159,68,25]},{"index":0.5,"rgb":[182,99,19]},{"index":0.63,"rgb":[199,134,22]},{"index":0.75,"rgb":[212,171,35]},{"index":0.88,"rgb":[221,210,54]},{"index":1,"rgb":[225,253,75]}],"phase":[{"index":0,"rgb":[145,105,18]},{"index":0.13,"rgb":[184,71,38]},{"index":0.25,"rgb":[186,58,115]},{"index":0.38,"rgb":[160,71,185]},{"index":0.5,"rgb":[110,97,218]},{"index":0.63,"rgb":[50,123,164]},{"index":0.75,"rgb":[31,131,110]},{"index":0.88,"rgb":[77,129,34]},{"index":1,"rgb":[145,105,18]}],"salinity":[{"index":0,"rgb":[42,24,108]},{"index":0.13,"rgb":[33,50,162]},{"index":0.25,"rgb":[15,90,145]},{"index":0.38,"rgb":[40,118,137]},{"index":0.5,"rgb":[59,146,135]},{"index":0.63,"rgb":[79,175,126]},{"index":0.75,"rgb":[120,203,104]},{"index":0.88,"rgb":[193,221,100]},{"index":1,"rgb":[253,239,154]}],"temperature":[{"index":0,"rgb":[4,35,51]},{"index":0.13,"rgb":[23,51,122]},{"index":0.25,"rgb":[85,59,157]},{"index":0.38,"rgb":[129,79,143]},{"index":0.5,"rgb":[175,95,130]},{"index":0.63,"rgb":[222,112,101]},{"index":0.75,"rgb":[249,146,66]},{"index":0.88,"rgb":[249,196,65]},{"index":1,"rgb":[232,250,91]}],"turbidity":[{"index":0,"rgb":[34,31,27]},{"index":0.13,"rgb":[65,50,41]},{"index":0.25,"rgb":[98,69,52]},{"index":0.38,"rgb":[131,89,57]},{"index":0.5,"rgb":[161,112,59]},{"index":0.63,"rgb":[185,140,66]},{"index":0.75,"rgb":[202,174,88]},{"index":0.88,"rgb":[216,209,126]},{"index":1,"rgb":[233,246,171]}],"velocity-blue":[{"index":0,"rgb":[17,32,64]},{"index":0.13,"rgb":[35,52,116]},{"index":0.25,"rgb":[29,81,156]},{"index":0.38,"rgb":[31,113,162]},{"index":0.5,"rgb":[50,144,169]},{"index":0.63,"rgb":[87,173,176]},{"index":0.75,"rgb":[149,196,189]},{"index":0.88,"rgb":[203,221,211]},{"index":1,"rgb":[254,251,230]}],"velocity-green":[{"index":0,"rgb":[23,35,19]},{"index":0.13,"rgb":[24,64,38]},{"index":0.25,"rgb":[11,95,45]},{"index":0.38,"rgb":[39,123,35]},{"index":0.5,"rgb":[95,146,12]},{"index":0.63,"rgb":[152,165,18]},{"index":0.75,"rgb":[201,186,69]},{"index":0.88,"rgb":[233,216,137]},{"index":1,"rgb":[255,253,205]}],"cubehelix":[{"index":0,"rgb":[0,0,0]},{"index":0.07,"rgb":[22,5,59]},{"index":0.13,"rgb":[60,4,105]},{"index":0.2,"rgb":[109,1,135]},{"index":0.27,"rgb":[161,0,147]},{"index":0.33,"rgb":[210,2,142]},{"index":0.4,"rgb":[251,11,123]},{"index":0.47,"rgb":[255,29,97]},{"index":0.53,"rgb":[255,54,69]},{"index":0.6,"rgb":[255,85,46]},{"index":0.67,"rgb":[255,120,34]},{"index":0.73,"rgb":[255,157,37]},{"index":0.8,"rgb":[241,191,57]},{"index":0.87,"rgb":[224,220,93]},{"index":0.93,"rgb":[218,241,142]},{"index":1,"rgb":[227,253,198]}]};/***/}),/***/6729:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_198982__){"use strict";/*
 * Ben Postlethwaite
 * January 2013
 * License MIT
 */var colorScale=__nested_webpack_require_198982__(3642);var lerp=__nested_webpack_require_198982__(395);module.exports=createColormap;function createColormap(spec){/*
     * Default Options
     */var indicies,fromrgba,torgba,nsteps,cmap,colormap,format,nshades,colors,alpha,i;if(!spec)spec={};nshades=(spec.nshades||72)-1;format=spec.format||'hex';colormap=spec.colormap;if(!colormap)colormap='jet';if(typeof colormap==='string'){colormap=colormap.toLowerCase();if(!colorScale[colormap]){throw Error(colormap+' not a supported colorscale');}cmap=colorScale[colormap];}else if(Array.isArray(colormap)){cmap=colormap.slice();}else{throw Error('unsupported colormap option',colormap);}if(cmap.length>nshades+1){throw new Error(colormap+' map requires nshades to be at least size '+cmap.length);}if(!Array.isArray(spec.alpha)){if(typeof spec.alpha==='number'){alpha=[spec.alpha,spec.alpha];}else{alpha=[1,1];}}else if(spec.alpha.length!==2){alpha=[1,1];}else{alpha=spec.alpha.slice();}// map index points from 0..1 to 0..n-1
indicies=cmap.map(function(c){return Math.round(c.index*nshades);});// Add alpha channel to the map
alpha[0]=Math.min(Math.max(alpha[0],0),1);alpha[1]=Math.min(Math.max(alpha[1],0),1);var steps=cmap.map(function(c,i){var index=cmap[i].index;var rgba=cmap[i].rgb.slice();// if user supplies their own map use it
if(rgba.length===4&&rgba[3]>=0&&rgba[3]<=1){return rgba;}rgba[3]=alpha[0]+(alpha[1]-alpha[0])*index;return rgba;});/*
     * map increasing linear values between indicies to
     * linear steps in colorvalues
     */var colors=[];for(i=0;i<indicies.length-1;++i){nsteps=indicies[i+1]-indicies[i];fromrgba=steps[i];torgba=steps[i+1];for(var j=0;j<nsteps;j++){var amt=j/nsteps;colors.push([Math.round(lerp(fromrgba[0],torgba[0],amt)),Math.round(lerp(fromrgba[1],torgba[1],amt)),Math.round(lerp(fromrgba[2],torgba[2],amt)),lerp(fromrgba[3],torgba[3],amt)]);}}//add 1 step as last value
colors.push(cmap[cmap.length-1].rgb.concat(alpha[1]));if(format==='hex')colors=colors.map(rgb2hex);else if(format==='rgbaString')colors=colors.map(rgbaStr);else if(format==='float')colors=colors.map(rgb2float);return colors;};function rgb2float(rgba){return[rgba[0]/255,rgba[1]/255,rgba[2]/255,rgba[3]];}function rgb2hex(rgba){var dig,hex='#';for(var i=0;i<3;++i){dig=rgba[i];dig=dig.toString(16);hex+=('00'+dig).substr(dig.length);}return hex;}function rgbaStr(rgba){return'rgba('+rgba.join(',')+')';}/***/}),/***/3140:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_201528__){"use strict";module.exports=compareAngle;var orient=__nested_webpack_require_201528__(3250);var sgn=__nested_webpack_require_201528__(8572);var twoSum=__nested_webpack_require_201528__(9362);var robustProduct=__nested_webpack_require_201528__(5382);var robustSum=__nested_webpack_require_201528__(8210);function testInterior(a,b,c){var x0=twoSum(a[0],-b[0]);var y0=twoSum(a[1],-b[1]);var x1=twoSum(c[0],-b[0]);var y1=twoSum(c[1],-b[1]);var d=robustSum(robustProduct(x0,x1),robustProduct(y0,y1));return d[d.length-1]>=0;}function compareAngle(a,b,c,d){var bcd=orient(b,c,d);if(bcd===0){//Handle degenerate cases
var sabc=sgn(orient(a,b,c));var sabd=sgn(orient(a,b,d));if(sabc===sabd){if(sabc===0){var ic=testInterior(a,b,c);var id=testInterior(a,b,d);if(ic===id){return 0;}else if(ic){return 1;}else{return-1;}}return 0;}else if(sabd===0){if(sabc>0){return-1;}else if(testInterior(a,b,d)){return-1;}else{return 1;}}else if(sabc===0){if(sabd>0){return 1;}else if(testInterior(a,b,c)){return 1;}else{return-1;}}return sgn(sabd-sabc);}var abc=orient(a,b,c);if(abc>0){if(bcd>0&&orient(a,b,d)>0){return 1;}return-1;}else if(abc<0){if(bcd>0||orient(a,b,d)>0){return 1;}return-1;}else{var abd=orient(a,b,d);if(abd>0){return 1;}else{if(testInterior(a,b,c)){return 1;}else{return-1;}}}}/***/}),/***/8572:(/***/function(module){"use strict";module.exports=function signum(x){if(x<0){return-1;}if(x>0){return 1;}return 0.0;};/***/}),/***/8507:(/***/function(module){module.exports=compareCells;var min=Math.min;function compareInt(a,b){return a-b;}function compareCells(a,b){var n=a.length,t=a.length-b.length;if(t){return t;}switch(n){case 0:return 0;case 1:return a[0]-b[0];case 2:return a[0]+a[1]-b[0]-b[1]||min(a[0],a[1])-min(b[0],b[1]);case 3:var l1=a[0]+a[1],m1=b[0]+b[1];t=l1+a[2]-(m1+b[2]);if(t){return t;}var l0=min(a[0],a[1]),m0=min(b[0],b[1]);return min(l0,a[2])-min(m0,b[2])||min(l0+a[2],l1)-min(m0+b[2],m1);case 4:var aw=a[0],ax=a[1],ay=a[2],az=a[3],bw=b[0],bx=b[1],by=b[2],bz=b[3];return aw+ax+ay+az-(bw+bx+by+bz)||min(aw,ax,ay,az)-min(bw,bx,by,bz,bw)||min(aw+ax,aw+ay,aw+az,ax+ay,ax+az,ay+az)-min(bw+bx,bw+by,bw+bz,bx+by,bx+bz,by+bz)||min(aw+ax+ay,aw+ax+az,aw+ay+az,ax+ay+az)-min(bw+bx+by,bw+bx+bz,bw+by+bz,bx+by+bz);default:var as=a.slice().sort(compareInt);var bs=b.slice().sort(compareInt);for(var i=0;i<n;++i){t=as[i]-bs[i];if(t){return t;}}return 0;}}/***/}),/***/3788:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_203903__){"use strict";var compareCells=__nested_webpack_require_203903__(8507);var parity=__nested_webpack_require_203903__(2419);module.exports=compareOrientedCells;function compareOrientedCells(a,b){return compareCells(a,b)||parity(a)-parity(b);}/***/}),/***/7352:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_204200__){"use strict";var convexHull1d=__nested_webpack_require_204200__(5721);var convexHull2d=__nested_webpack_require_204200__(4750);var convexHullnd=__nested_webpack_require_204200__(2690);module.exports=convexHull;function convexHull(points){var n=points.length;if(n===0){return[];}else if(n===1){return[[0]];}var d=points[0].length;if(d===0){return[];}else if(d===1){return convexHull1d(points);}else if(d===2){return convexHull2d(points);}return convexHullnd(points,d);}/***/}),/***/5721:(/***/function(module){"use strict";module.exports=convexHull1d;function convexHull1d(points){var lo=0;var hi=0;for(var i=1;i<points.length;++i){if(points[i][0]<points[lo][0]){lo=i;}if(points[i][0]>points[hi][0]){hi=i;}}if(lo<hi){return[[lo],[hi]];}else if(lo>hi){return[[hi],[lo]];}else{return[[lo]];}}/***/}),/***/4750:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_205033__){"use strict";module.exports=convexHull2D;var monotoneHull=__nested_webpack_require_205033__(3090);function convexHull2D(points){var hull=monotoneHull(points);var h=hull.length;if(h<=2){return[];}var edges=new Array(h);var a=hull[h-1];for(var i=0;i<h;++i){var b=hull[i];edges[i]=[a,b];a=b;}return edges;}/***/}),/***/2690:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_205408__){"use strict";module.exports=convexHullnD;var ich=__nested_webpack_require_205408__(8954);var aff=__nested_webpack_require_205408__(3952);function permute(points,front){var n=points.length;var npoints=new Array(n);for(var i=0;i<front.length;++i){npoints[i]=points[front[i]];}var ptr=front.length;for(var i=0;i<n;++i){if(front.indexOf(i)<0){npoints[ptr++]=points[i];}}return npoints;}function invPermute(cells,front){var nc=cells.length;var nf=front.length;for(var i=0;i<nc;++i){var c=cells[i];for(var j=0;j<c.length;++j){var x=c[j];if(x<nf){c[j]=front[x];}else{x=x-nf;for(var k=0;k<nf;++k){if(x>=front[k]){x+=1;}}c[j]=x;}}}return cells;}function convexHullnD(points,d){try{return ich(points,true);}catch(e){//If point set is degenerate, try to find a basis and rerun it
var ah=aff(points);if(ah.length<=d){//No basis, no try
return[];}var npoints=permute(points,ah);var nhull=ich(npoints,true);return invPermute(nhull,ah);}}/***/}),/***/4769:(/***/function(module){"use strict";function dcubicHermite(p0,v0,p1,v1,t,f){var dh00=6*t*t-6*t,dh10=3*t*t-4*t+1,dh01=-6*t*t+6*t,dh11=3*t*t-2*t;if(p0.length){if(!f){f=new Array(p0.length);}for(var i=p0.length-1;i>=0;--i){f[i]=dh00*p0[i]+dh10*v0[i]+dh01*p1[i]+dh11*v1[i];}return f;}return dh00*p0+dh10*v0+dh01*p1[i]+dh11*v1;}function cubicHermite(p0,v0,p1,v1,t,f){var ti=t-1,t2=t*t,ti2=ti*ti,h00=(1+2*t)*ti2,h10=t*ti2,h01=t2*(3-2*t),h11=t2*ti;if(p0.length){if(!f){f=new Array(p0.length);}for(var i=p0.length-1;i>=0;--i){f[i]=h00*p0[i]+h10*v0[i]+h01*p1[i]+h11*v1[i];}return f;}return h00*p0+h10*v0+h01*p1+h11*v1;}module.exports=cubicHermite;module.exports.derivative=dcubicHermite;/***/}),/***/7642:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_207085__){"use strict";var ch=__nested_webpack_require_207085__(8954);var uniq=__nested_webpack_require_207085__(1682);module.exports=triangulate;function LiftedPoint(p,i){this.point=p;this.index=i;}function compareLifted(a,b){var ap=a.point;var bp=b.point;var d=ap.length;for(var i=0;i<d;++i){var s=bp[i]-ap[i];if(s){return s;}}return 0;}function triangulate1D(n,points,includePointAtInfinity){if(n===1){if(includePointAtInfinity){return[[-1,0]];}else{return[];}}var lifted=points.map(function(p,i){return[p[0],i];});lifted.sort(function(a,b){return a[0]-b[0];});var cells=new Array(n-1);for(var i=1;i<n;++i){var a=lifted[i-1];var b=lifted[i];cells[i-1]=[a[1],b[1]];}if(includePointAtInfinity){cells.push([-1,cells[0][1]],[cells[n-1][1],-1]);}return cells;}function triangulate(points,includePointAtInfinity){var n=points.length;if(n===0){return[];}var d=points[0].length;if(d<1){return[];}//Special case:  For 1D we can just sort the points
if(d===1){return triangulate1D(n,points,includePointAtInfinity);}//Lift points, sort
var lifted=new Array(n);var upper=1.0;for(var i=0;i<n;++i){var p=points[i];var x=new Array(d+1);var l=0.0;for(var j=0;j<d;++j){var v=p[j];x[j]=v;l+=v*v;}x[d]=l;lifted[i]=new LiftedPoint(x,i);upper=Math.max(l,upper);}uniq(lifted,compareLifted);//Double points
n=lifted.length;//Create new list of points
var dpoints=new Array(n+d+1);var dindex=new Array(n+d+1);//Add steiner points at top
var u=(d+1)*(d+1)*upper;var y=new Array(d+1);for(var i=0;i<=d;++i){y[i]=0.0;}y[d]=u;dpoints[0]=y.slice();dindex[0]=-1;for(var i=0;i<=d;++i){var x=y.slice();x[i]=1;dpoints[i+1]=x;dindex[i+1]=-1;}//Copy rest of the points over
for(var i=0;i<n;++i){var h=lifted[i];dpoints[i+d+1]=h.point;dindex[i+d+1]=h.index;}//Construct convex hull
var hull=ch(dpoints,false);if(includePointAtInfinity){hull=hull.filter(function(cell){var count=0;for(var j=0;j<=d;++j){var v=dindex[cell[j]];if(v<0){if(++count>=2){return false;}}cell[j]=v;}return true;});}else{hull=hull.filter(function(cell){for(var i=0;i<=d;++i){var v=dindex[cell[i]];if(v<0){return false;}cell[i]=v;}return true;});}if(d&1){for(var i=0;i<hull.length;++i){var h=hull[i];var x=h[0];h[0]=h[1];h[1]=x;}}return hull;}/***/}),/***/2361:(/***/function(module){var hasTypedArrays=false;if(typeof Float64Array!=="undefined"){var DOUBLE_VIEW=new Float64Array(1),UINT_VIEW=new Uint32Array(DOUBLE_VIEW.buffer);DOUBLE_VIEW[0]=1.0;hasTypedArrays=true;if(UINT_VIEW[1]===0x3ff00000){//Use little endian
module.exports=function doubleBitsLE(n){DOUBLE_VIEW[0]=n;return[UINT_VIEW[0],UINT_VIEW[1]];};function toDoubleLE(lo,hi){UINT_VIEW[0]=lo;UINT_VIEW[1]=hi;return DOUBLE_VIEW[0];}module.exports.pack=toDoubleLE;function lowUintLE(n){DOUBLE_VIEW[0]=n;return UINT_VIEW[0];}module.exports.lo=lowUintLE;function highUintLE(n){DOUBLE_VIEW[0]=n;return UINT_VIEW[1];}module.exports.hi=highUintLE;}else if(UINT_VIEW[0]===0x3ff00000){//Use big endian
module.exports=function doubleBitsBE(n){DOUBLE_VIEW[0]=n;return[UINT_VIEW[1],UINT_VIEW[0]];};function toDoubleBE(lo,hi){UINT_VIEW[1]=lo;UINT_VIEW[0]=hi;return DOUBLE_VIEW[0];}module.exports.pack=toDoubleBE;function lowUintBE(n){DOUBLE_VIEW[0]=n;return UINT_VIEW[1];}module.exports.lo=lowUintBE;function highUintBE(n){DOUBLE_VIEW[0]=n;return UINT_VIEW[0];}module.exports.hi=highUintBE;}else{hasTypedArrays=false;}}if(!hasTypedArrays){var buffer=new Buffer(8);module.exports=function doubleBits(n){buffer.writeDoubleLE(n,0,true);return[buffer.readUInt32LE(0,true),buffer.readUInt32LE(4,true)];};function toDouble(lo,hi){buffer.writeUInt32LE(lo,0,true);buffer.writeUInt32LE(hi,4,true);return buffer.readDoubleLE(0,true);}module.exports.pack=toDouble;function lowUint(n){buffer.writeDoubleLE(n,0,true);return buffer.readUInt32LE(0,true);}module.exports.lo=lowUint;function highUint(n){buffer.writeDoubleLE(n,0,true);return buffer.readUInt32LE(4,true);}module.exports.hi=highUint;}module.exports.sign=function(n){return module.exports.hi(n)>>>31;};module.exports.exponent=function(n){var b=module.exports.hi(n);return(b<<1>>>21)-1023;};module.exports.fraction=function(n){var lo=module.exports.lo(n);var hi=module.exports.hi(n);var b=hi&(1<<20)-1;if(hi&0x7ff00000){b+=1<<20;}return[lo,b];};module.exports.denormalized=function(n){var hi=module.exports.hi(n);return!(hi&0x7ff00000);};/***/}),/***/1338:(/***/function(module){"use strict";function dupe_array(count,value,i){var c=count[i]|0;if(c<=0){return[];}var result=new Array(c),j;if(i===count.length-1){for(j=0;j<c;++j){result[j]=value;}}else{for(j=0;j<c;++j){result[j]=dupe_array(count,value,i+1);}}return result;}function dupe_number(count,value){var result,i;result=new Array(count);for(i=0;i<count;++i){result[i]=value;}return result;}function dupe(count,value){if(typeof value==="undefined"){value=0;}switch(typeof count){case"number":if(count>0){return dupe_number(count|0,value);}break;case"object":if(typeof count.length==="number"){return dupe_array(count,value,0);}break;}return[];}module.exports=dupe;/***/}),/***/3134:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_212087__){"use strict";module.exports=edgeToAdjacency;var uniq=__nested_webpack_require_212087__(1682);function edgeToAdjacency(edges,numVertices){var numEdges=edges.length;if(typeof numVertices!=="number"){numVertices=0;for(var i=0;i<numEdges;++i){var e=edges[i];numVertices=Math.max(numVertices,e[0],e[1]);}numVertices=(numVertices|0)+1;}numVertices=numVertices|0;var adj=new Array(numVertices);for(var i=0;i<numVertices;++i){adj[i]=[];}for(var i=0;i<numEdges;++i){var e=edges[i];adj[e[0]].push(e[1]);adj[e[1]].push(e[0]);}for(var j=0;j<numVertices;++j){uniq(adj[j],function(a,b){return a-b;});}return adj;}/***/}),/***/5033:(/***/function(module){"use strict";module.exports=extractPlanes;function extractPlanes(M,zNear,zFar){var z=zNear||0.0;var zf=zFar||1.0;return[[M[12]+M[0],M[13]+M[1],M[14]+M[2],M[15]+M[3]],[M[12]-M[0],M[13]-M[1],M[14]-M[2],M[15]-M[3]],[M[12]+M[4],M[13]+M[5],M[14]+M[6],M[15]+M[7]],[M[12]-M[4],M[13]-M[5],M[14]-M[6],M[15]-M[7]],[z*M[12]+M[8],z*M[13]+M[9],z*M[14]+M[10],z*M[15]+M[11]],[zf*M[12]-M[8],zf*M[13]-M[9],zf*M[14]-M[10],zf*M[15]-M[11]]];}/***/}),/***/9215:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_213221__){"use strict";module.exports=createFilteredVector;var cubicHermite=__nested_webpack_require_213221__(4769);var bsearch=__nested_webpack_require_213221__(2478);function clamp(lo,hi,x){return Math.min(hi,Math.max(lo,x));}function FilteredVector(state0,velocity0,t0){this.dimension=state0.length;this.bounds=[new Array(this.dimension),new Array(this.dimension)];for(var i=0;i<this.dimension;++i){this.bounds[0][i]=-Infinity;this.bounds[1][i]=Infinity;}this._state=state0.slice().reverse();this._velocity=velocity0.slice().reverse();this._time=[t0];this._scratch=[state0.slice(),state0.slice(),state0.slice(),state0.slice(),state0.slice()];}var proto=FilteredVector.prototype;proto.flush=function(t){var idx=bsearch.gt(this._time,t)-1;if(idx<=0){return;}this._time.splice(0,idx);this._state.splice(0,idx*this.dimension);this._velocity.splice(0,idx*this.dimension);};proto.curve=function(t){var time=this._time;var n=time.length;var idx=bsearch.le(time,t);var result=this._scratch[0];var state=this._state;var velocity=this._velocity;var d=this.dimension;var bounds=this.bounds;if(idx<0){var ptr=d-1;for(var i=0;i<d;++i,--ptr){result[i]=state[ptr];}}else if(idx>=n-1){var ptr=state.length-1;var tf=t-time[n-1];for(var i=0;i<d;++i,--ptr){result[i]=state[ptr]+tf*velocity[ptr];}}else{var ptr=d*(idx+1)-1;var t0=time[idx];var t1=time[idx+1];var dt=t1-t0||1.0;var x0=this._scratch[1];var x1=this._scratch[2];var v0=this._scratch[3];var v1=this._scratch[4];var steady=true;for(var i=0;i<d;++i,--ptr){x0[i]=state[ptr];v0[i]=velocity[ptr]*dt;x1[i]=state[ptr+d];v1[i]=velocity[ptr+d]*dt;steady=steady&&x0[i]===x1[i]&&v0[i]===v1[i]&&v0[i]===0.0;}if(steady){for(var i=0;i<d;++i){result[i]=x0[i];}}else{cubicHermite(x0,v0,x1,v1,(t-t0)/dt,result);}}var lo=bounds[0];var hi=bounds[1];for(var i=0;i<d;++i){result[i]=clamp(lo[i],hi[i],result[i]);}return result;};proto.dcurve=function(t){var time=this._time;var n=time.length;var idx=bsearch.le(time,t);var result=this._scratch[0];var state=this._state;var velocity=this._velocity;var d=this.dimension;if(idx>=n-1){var ptr=state.length-1;var tf=t-time[n-1];for(var i=0;i<d;++i,--ptr){result[i]=velocity[ptr];}}else{var ptr=d*(idx+1)-1;var t0=time[idx];var t1=time[idx+1];var dt=t1-t0||1.0;var x0=this._scratch[1];var x1=this._scratch[2];var v0=this._scratch[3];var v1=this._scratch[4];var steady=true;for(var i=0;i<d;++i,--ptr){x0[i]=state[ptr];v0[i]=velocity[ptr]*dt;x1[i]=state[ptr+d];v1[i]=velocity[ptr+d]*dt;steady=steady&&x0[i]===x1[i]&&v0[i]===v1[i]&&v0[i]===0.0;}if(steady){for(var i=0;i<d;++i){result[i]=0.0;}}else{cubicHermite.derivative(x0,v0,x1,v1,(t-t0)/dt,result);for(var i=0;i<d;++i){result[i]/=dt;}}}return result;};proto.lastT=function(){var time=this._time;return time[time.length-1];};proto.stable=function(){var velocity=this._velocity;var ptr=velocity.length;for(var i=this.dimension-1;i>=0;--i){if(velocity[--ptr]){return false;}}return true;};proto.jump=function(t){var t0=this.lastT();var d=this.dimension;if(t<t0||arguments.length!==d+1){return;}var state=this._state;var velocity=this._velocity;var ptr=state.length-this.dimension;var bounds=this.bounds;var lo=bounds[0];var hi=bounds[1];this._time.push(t0,t);for(var j=0;j<2;++j){for(var i=0;i<d;++i){state.push(state[ptr++]);velocity.push(0);}}this._time.push(t);for(var i=d;i>0;--i){state.push(clamp(lo[i-1],hi[i-1],arguments[i]));velocity.push(0);}};proto.push=function(t){var t0=this.lastT();var d=this.dimension;if(t<t0||arguments.length!==d+1){return;}var state=this._state;var velocity=this._velocity;var ptr=state.length-this.dimension;var dt=t-t0;var bounds=this.bounds;var lo=bounds[0];var hi=bounds[1];var sf=dt>1e-6?1/dt:0;this._time.push(t);for(var i=d;i>0;--i){var xc=clamp(lo[i-1],hi[i-1],arguments[i]);state.push(xc);velocity.push((xc-state[ptr++])*sf);}};proto.set=function(t){var d=this.dimension;if(t<this.lastT()||arguments.length!==d+1){return;}var state=this._state;var velocity=this._velocity;var bounds=this.bounds;var lo=bounds[0];var hi=bounds[1];this._time.push(t);for(var i=d;i>0;--i){state.push(clamp(lo[i-1],hi[i-1],arguments[i]));velocity.push(0);}};proto.move=function(t){var t0=this.lastT();var d=this.dimension;if(t<=t0||arguments.length!==d+1){return;}var state=this._state;var velocity=this._velocity;var statePtr=state.length-this.dimension;var bounds=this.bounds;var lo=bounds[0];var hi=bounds[1];var dt=t-t0;var sf=dt>1e-6?1/dt:0.0;this._time.push(t);for(var i=d;i>0;--i){var dx=arguments[i];state.push(clamp(lo[i-1],hi[i-1],state[statePtr++]+dx));velocity.push(dx*sf);}};proto.idle=function(t){var t0=this.lastT();if(t<t0){return;}var d=this.dimension;var state=this._state;var velocity=this._velocity;var statePtr=state.length-d;var bounds=this.bounds;var lo=bounds[0];var hi=bounds[1];var dt=t-t0;this._time.push(t);for(var i=d-1;i>=0;--i){state.push(clamp(lo[i],hi[i],state[statePtr]+dt*velocity[statePtr]));velocity.push(0);statePtr+=1;}};function getZero(d){var result=new Array(d);for(var i=0;i<d;++i){result[i]=0.0;}return result;}function createFilteredVector(initState,initVelocity,initTime){switch(arguments.length){case 0:return new FilteredVector([0],[0],0);case 1:if(typeof initState==='number'){var zero=getZero(initState);return new FilteredVector(zero,zero,0);}else{return new FilteredVector(initState,getZero(initState.length),0);}case 2:if(typeof initVelocity==='number'){var zero=getZero(initState.length);return new FilteredVector(initState,zero,+initVelocity);}else{initTime=0;}case 3:if(initState.length!==initVelocity.length){throw new Error('state and velocity lengths must match');}return new FilteredVector(initState,initVelocity,initTime);}}/***/}),/***/3840:(/***/function(module){"use strict";module.exports=createRBTree;var RED=0;var BLACK=1;function RBNode(color,key,value,left,right,count){this._color=color;this.key=key;this.value=value;this.left=left;this.right=right;this._count=count;}function cloneNode(node){return new RBNode(node._color,node.key,node.value,node.left,node.right,node._count);}function repaint(color,node){return new RBNode(color,node.key,node.value,node.left,node.right,node._count);}function recount(node){node._count=1+(node.left?node.left._count:0)+(node.right?node.right._count:0);}function RedBlackTree(compare,root){this._compare=compare;this.root=root;}var proto=RedBlackTree.prototype;Object.defineProperty(proto,"keys",{get:function(){var result=[];this.forEach(function(k,v){result.push(k);});return result;}});Object.defineProperty(proto,"values",{get:function(){var result=[];this.forEach(function(k,v){result.push(v);});return result;}});//Returns the number of nodes in the tree
Object.defineProperty(proto,"length",{get:function(){if(this.root){return this.root._count;}return 0;}});//Insert a new item into the tree
proto.insert=function(key,value){var cmp=this._compare;//Find point to insert new node at
var n=this.root;var n_stack=[];var d_stack=[];while(n){var d=cmp(key,n.key);n_stack.push(n);d_stack.push(d);if(d<=0){n=n.left;}else{n=n.right;}}//Rebuild path to leaf node
n_stack.push(new RBNode(RED,key,value,null,null,1));for(var s=n_stack.length-2;s>=0;--s){var n=n_stack[s];if(d_stack[s]<=0){n_stack[s]=new RBNode(n._color,n.key,n.value,n_stack[s+1],n.right,n._count+1);}else{n_stack[s]=new RBNode(n._color,n.key,n.value,n.left,n_stack[s+1],n._count+1);}}//Rebalance tree using rotations
//console.log("start insert", key, d_stack)
for(var s=n_stack.length-1;s>1;--s){var p=n_stack[s-1];var n=n_stack[s];if(p._color===BLACK||n._color===BLACK){break;}var pp=n_stack[s-2];if(pp.left===p){if(p.left===n){var y=pp.right;if(y&&y._color===RED){//console.log("LLr")
p._color=BLACK;pp.right=repaint(BLACK,y);pp._color=RED;s-=1;}else{//console.log("LLb")
pp._color=RED;pp.left=p.right;p._color=BLACK;p.right=pp;n_stack[s-2]=p;n_stack[s-1]=n;recount(pp);recount(p);if(s>=3){var ppp=n_stack[s-3];if(ppp.left===pp){ppp.left=p;}else{ppp.right=p;}}break;}}else{var y=pp.right;if(y&&y._color===RED){//console.log("LRr")
p._color=BLACK;pp.right=repaint(BLACK,y);pp._color=RED;s-=1;}else{//console.log("LRb")
p.right=n.left;pp._color=RED;pp.left=n.right;n._color=BLACK;n.left=p;n.right=pp;n_stack[s-2]=n;n_stack[s-1]=p;recount(pp);recount(p);recount(n);if(s>=3){var ppp=n_stack[s-3];if(ppp.left===pp){ppp.left=n;}else{ppp.right=n;}}break;}}}else{if(p.right===n){var y=pp.left;if(y&&y._color===RED){//console.log("RRr", y.key)
p._color=BLACK;pp.left=repaint(BLACK,y);pp._color=RED;s-=1;}else{//console.log("RRb")
pp._color=RED;pp.right=p.left;p._color=BLACK;p.left=pp;n_stack[s-2]=p;n_stack[s-1]=n;recount(pp);recount(p);if(s>=3){var ppp=n_stack[s-3];if(ppp.right===pp){ppp.right=p;}else{ppp.left=p;}}break;}}else{var y=pp.left;if(y&&y._color===RED){//console.log("RLr")
p._color=BLACK;pp.left=repaint(BLACK,y);pp._color=RED;s-=1;}else{//console.log("RLb")
p.left=n.right;pp._color=RED;pp.right=n.left;n._color=BLACK;n.right=p;n.left=pp;n_stack[s-2]=n;n_stack[s-1]=p;recount(pp);recount(p);recount(n);if(s>=3){var ppp=n_stack[s-3];if(ppp.right===pp){ppp.right=n;}else{ppp.left=n;}}break;}}}}//Return new tree
n_stack[0]._color=BLACK;return new RedBlackTree(cmp,n_stack[0]);};//Visit all nodes inorder
function doVisitFull(visit,node){if(node.left){var v=doVisitFull(visit,node.left);if(v){return v;}}var v=visit(node.key,node.value);if(v){return v;}if(node.right){return doVisitFull(visit,node.right);}}//Visit half nodes in order
function doVisitHalf(lo,compare,visit,node){var l=compare(lo,node.key);if(l<=0){if(node.left){var v=doVisitHalf(lo,compare,visit,node.left);if(v){return v;}}var v=visit(node.key,node.value);if(v){return v;}}if(node.right){return doVisitHalf(lo,compare,visit,node.right);}}//Visit all nodes within a range
function doVisit(lo,hi,compare,visit,node){var l=compare(lo,node.key);var h=compare(hi,node.key);var v;if(l<=0){if(node.left){v=doVisit(lo,hi,compare,visit,node.left);if(v){return v;}}if(h>0){v=visit(node.key,node.value);if(v){return v;}}}if(h>0&&node.right){return doVisit(lo,hi,compare,visit,node.right);}}proto.forEach=function rbTreeForEach(visit,lo,hi){if(!this.root){return;}switch(arguments.length){case 1:return doVisitFull(visit,this.root);break;case 2:return doVisitHalf(lo,this._compare,visit,this.root);break;case 3:if(this._compare(lo,hi)>=0){return;}return doVisit(lo,hi,this._compare,visit,this.root);break;}};//First item in list
Object.defineProperty(proto,"begin",{get:function(){var stack=[];var n=this.root;while(n){stack.push(n);n=n.left;}return new RedBlackTreeIterator(this,stack);}});//Last item in list
Object.defineProperty(proto,"end",{get:function(){var stack=[];var n=this.root;while(n){stack.push(n);n=n.right;}return new RedBlackTreeIterator(this,stack);}});//Find the ith item in the tree
proto.at=function(idx){if(idx<0){return new RedBlackTreeIterator(this,[]);}var n=this.root;var stack=[];while(true){stack.push(n);if(n.left){if(idx<n.left._count){n=n.left;continue;}idx-=n.left._count;}if(!idx){return new RedBlackTreeIterator(this,stack);}idx-=1;if(n.right){if(idx>=n.right._count){break;}n=n.right;}else{break;}}return new RedBlackTreeIterator(this,[]);};proto.ge=function(key){var cmp=this._compare;var n=this.root;var stack=[];var last_ptr=0;while(n){var d=cmp(key,n.key);stack.push(n);if(d<=0){last_ptr=stack.length;}if(d<=0){n=n.left;}else{n=n.right;}}stack.length=last_ptr;return new RedBlackTreeIterator(this,stack);};proto.gt=function(key){var cmp=this._compare;var n=this.root;var stack=[];var last_ptr=0;while(n){var d=cmp(key,n.key);stack.push(n);if(d<0){last_ptr=stack.length;}if(d<0){n=n.left;}else{n=n.right;}}stack.length=last_ptr;return new RedBlackTreeIterator(this,stack);};proto.lt=function(key){var cmp=this._compare;var n=this.root;var stack=[];var last_ptr=0;while(n){var d=cmp(key,n.key);stack.push(n);if(d>0){last_ptr=stack.length;}if(d<=0){n=n.left;}else{n=n.right;}}stack.length=last_ptr;return new RedBlackTreeIterator(this,stack);};proto.le=function(key){var cmp=this._compare;var n=this.root;var stack=[];var last_ptr=0;while(n){var d=cmp(key,n.key);stack.push(n);if(d>=0){last_ptr=stack.length;}if(d<0){n=n.left;}else{n=n.right;}}stack.length=last_ptr;return new RedBlackTreeIterator(this,stack);};//Finds the item with key if it exists
proto.find=function(key){var cmp=this._compare;var n=this.root;var stack=[];while(n){var d=cmp(key,n.key);stack.push(n);if(d===0){return new RedBlackTreeIterator(this,stack);}if(d<=0){n=n.left;}else{n=n.right;}}return new RedBlackTreeIterator(this,[]);};//Removes item with key from tree
proto.remove=function(key){var iter=this.find(key);if(iter){return iter.remove();}return this;};//Returns the item at `key`
proto.get=function(key){var cmp=this._compare;var n=this.root;while(n){var d=cmp(key,n.key);if(d===0){return n.value;}if(d<=0){n=n.left;}else{n=n.right;}}return;};//Iterator for red black tree
function RedBlackTreeIterator(tree,stack){this.tree=tree;this._stack=stack;}var iproto=RedBlackTreeIterator.prototype;//Test if iterator is valid
Object.defineProperty(iproto,"valid",{get:function(){return this._stack.length>0;}});//Node of the iterator
Object.defineProperty(iproto,"node",{get:function(){if(this._stack.length>0){return this._stack[this._stack.length-1];}return null;},enumerable:true});//Makes a copy of an iterator
iproto.clone=function(){return new RedBlackTreeIterator(this.tree,this._stack.slice());};//Swaps two nodes
function swapNode(n,v){n.key=v.key;n.value=v.value;n.left=v.left;n.right=v.right;n._color=v._color;n._count=v._count;}//Fix up a double black node in a tree
function fixDoubleBlack(stack){var n,p,s,z;for(var i=stack.length-1;i>=0;--i){n=stack[i];if(i===0){n._color=BLACK;return;}//console.log("visit node:", n.key, i, stack[i].key, stack[i-1].key)
p=stack[i-1];if(p.left===n){//console.log("left child")
s=p.right;if(s.right&&s.right._color===RED){//console.log("case 1: right sibling child red")
s=p.right=cloneNode(s);z=s.right=cloneNode(s.right);p.right=s.left;s.left=p;s.right=z;s._color=p._color;n._color=BLACK;p._color=BLACK;z._color=BLACK;recount(p);recount(s);if(i>1){var pp=stack[i-2];if(pp.left===p){pp.left=s;}else{pp.right=s;}}stack[i-1]=s;return;}else if(s.left&&s.left._color===RED){//console.log("case 1: left sibling child red")
s=p.right=cloneNode(s);z=s.left=cloneNode(s.left);p.right=z.left;s.left=z.right;z.left=p;z.right=s;z._color=p._color;p._color=BLACK;s._color=BLACK;n._color=BLACK;recount(p);recount(s);recount(z);if(i>1){var pp=stack[i-2];if(pp.left===p){pp.left=z;}else{pp.right=z;}}stack[i-1]=z;return;}if(s._color===BLACK){if(p._color===RED){//console.log("case 2: black sibling, red parent", p.right.value)
p._color=BLACK;p.right=repaint(RED,s);return;}else{//console.log("case 2: black sibling, black parent", p.right.value)
p.right=repaint(RED,s);continue;}}else{//console.log("case 3: red sibling")
s=cloneNode(s);p.right=s.left;s.left=p;s._color=p._color;p._color=RED;recount(p);recount(s);if(i>1){var pp=stack[i-2];if(pp.left===p){pp.left=s;}else{pp.right=s;}}stack[i-1]=s;stack[i]=p;if(i+1<stack.length){stack[i+1]=n;}else{stack.push(n);}i=i+2;}}else{//console.log("right child")
s=p.left;if(s.left&&s.left._color===RED){//console.log("case 1: left sibling child red", p.value, p._color)
s=p.left=cloneNode(s);z=s.left=cloneNode(s.left);p.left=s.right;s.right=p;s.left=z;s._color=p._color;n._color=BLACK;p._color=BLACK;z._color=BLACK;recount(p);recount(s);if(i>1){var pp=stack[i-2];if(pp.right===p){pp.right=s;}else{pp.left=s;}}stack[i-1]=s;return;}else if(s.right&&s.right._color===RED){//console.log("case 1: right sibling child red")
s=p.left=cloneNode(s);z=s.right=cloneNode(s.right);p.left=z.right;s.right=z.left;z.right=p;z.left=s;z._color=p._color;p._color=BLACK;s._color=BLACK;n._color=BLACK;recount(p);recount(s);recount(z);if(i>1){var pp=stack[i-2];if(pp.right===p){pp.right=z;}else{pp.left=z;}}stack[i-1]=z;return;}if(s._color===BLACK){if(p._color===RED){//console.log("case 2: black sibling, red parent")
p._color=BLACK;p.left=repaint(RED,s);return;}else{//console.log("case 2: black sibling, black parent")
p.left=repaint(RED,s);continue;}}else{//console.log("case 3: red sibling")
s=cloneNode(s);p.left=s.right;s.right=p;s._color=p._color;p._color=RED;recount(p);recount(s);if(i>1){var pp=stack[i-2];if(pp.right===p){pp.right=s;}else{pp.left=s;}}stack[i-1]=s;stack[i]=p;if(i+1<stack.length){stack[i+1]=n;}else{stack.push(n);}i=i+2;}}}}//Removes item at iterator from tree
iproto.remove=function(){var stack=this._stack;if(stack.length===0){return this.tree;}//First copy path to node
var cstack=new Array(stack.length);var n=stack[stack.length-1];cstack[cstack.length-1]=new RBNode(n._color,n.key,n.value,n.left,n.right,n._count);for(var i=stack.length-2;i>=0;--i){var n=stack[i];if(n.left===stack[i+1]){cstack[i]=new RBNode(n._color,n.key,n.value,cstack[i+1],n.right,n._count);}else{cstack[i]=new RBNode(n._color,n.key,n.value,n.left,cstack[i+1],n._count);}}//Get node
n=cstack[cstack.length-1];//console.log("start remove: ", n.value)
//If not leaf, then swap with previous node
if(n.left&&n.right){//console.log("moving to leaf")
//First walk to previous leaf
var split=cstack.length;n=n.left;while(n.right){cstack.push(n);n=n.right;}//Copy path to leaf
var v=cstack[split-1];cstack.push(new RBNode(n._color,v.key,v.value,n.left,n.right,n._count));cstack[split-1].key=n.key;cstack[split-1].value=n.value;//Fix up stack
for(var i=cstack.length-2;i>=split;--i){n=cstack[i];cstack[i]=new RBNode(n._color,n.key,n.value,n.left,cstack[i+1],n._count);}cstack[split-1].left=cstack[split];}//console.log("stack=", cstack.map(function(v) { return v.value }))
//Remove leaf node
n=cstack[cstack.length-1];if(n._color===RED){//Easy case: removing red leaf
//console.log("RED leaf")
var p=cstack[cstack.length-2];if(p.left===n){p.left=null;}else if(p.right===n){p.right=null;}cstack.pop();for(var i=0;i<cstack.length;++i){cstack[i]._count--;}return new RedBlackTree(this.tree._compare,cstack[0]);}else{if(n.left||n.right){//Second easy case:  Single child black parent
//console.log("BLACK single child")
if(n.left){swapNode(n,n.left);}else if(n.right){swapNode(n,n.right);}//Child must be red, so repaint it black to balance color
n._color=BLACK;for(var i=0;i<cstack.length-1;++i){cstack[i]._count--;}return new RedBlackTree(this.tree._compare,cstack[0]);}else if(cstack.length===1){//Third easy case: root
//console.log("ROOT")
return new RedBlackTree(this.tree._compare,null);}else{//Hard case: Repaint n, and then do some nasty stuff
//console.log("BLACK leaf no children")
for(var i=0;i<cstack.length;++i){cstack[i]._count--;}var parent=cstack[cstack.length-2];fixDoubleBlack(cstack);//Fix up links
if(parent.left===n){parent.left=null;}else{parent.right=null;}}}return new RedBlackTree(this.tree._compare,cstack[0]);};//Returns key
Object.defineProperty(iproto,"key",{get:function(){if(this._stack.length>0){return this._stack[this._stack.length-1].key;}return;},enumerable:true});//Returns value
Object.defineProperty(iproto,"value",{get:function(){if(this._stack.length>0){return this._stack[this._stack.length-1].value;}return;},enumerable:true});//Returns the position of this iterator in the sorted list
Object.defineProperty(iproto,"index",{get:function(){var idx=0;var stack=this._stack;if(stack.length===0){var r=this.tree.root;if(r){return r._count;}return 0;}else if(stack[stack.length-1].left){idx=stack[stack.length-1].left._count;}for(var s=stack.length-2;s>=0;--s){if(stack[s+1]===stack[s].right){++idx;if(stack[s].left){idx+=stack[s].left._count;}}}return idx;},enumerable:true});//Advances iterator to next element in list
iproto.next=function(){var stack=this._stack;if(stack.length===0){return;}var n=stack[stack.length-1];if(n.right){n=n.right;while(n){stack.push(n);n=n.left;}}else{stack.pop();while(stack.length>0&&stack[stack.length-1].right===n){n=stack[stack.length-1];stack.pop();}}};//Checks if iterator is at end of tree
Object.defineProperty(iproto,"hasNext",{get:function(){var stack=this._stack;if(stack.length===0){return false;}if(stack[stack.length-1].right){return true;}for(var s=stack.length-1;s>0;--s){if(stack[s-1].left===stack[s]){return true;}}return false;}});//Update value
iproto.update=function(value){var stack=this._stack;if(stack.length===0){throw new Error("Can't update empty node!");}var cstack=new Array(stack.length);var n=stack[stack.length-1];cstack[cstack.length-1]=new RBNode(n._color,n.key,value,n.left,n.right,n._count);for(var i=stack.length-2;i>=0;--i){n=stack[i];if(n.left===stack[i+1]){cstack[i]=new RBNode(n._color,n.key,n.value,cstack[i+1],n.right,n._count);}else{cstack[i]=new RBNode(n._color,n.key,n.value,n.left,cstack[i+1],n._count);}}return new RedBlackTree(this.tree._compare,cstack[0]);};//Moves iterator backward one element
iproto.prev=function(){var stack=this._stack;if(stack.length===0){return;}var n=stack[stack.length-1];if(n.left){n=n.left;while(n){stack.push(n);n=n.right;}}else{stack.pop();while(stack.length>0&&stack[stack.length-1].left===n){n=stack[stack.length-1];stack.pop();}}};//Checks if iterator is at start of tree
Object.defineProperty(iproto,"hasPrev",{get:function(){var stack=this._stack;if(stack.length===0){return false;}if(stack[stack.length-1].left){return true;}for(var s=stack.length-1;s>0;--s){if(stack[s-1].right===stack[s]){return true;}}return false;}});//Default comparison function
function defaultCompare(a,b){if(a<b){return-1;}if(a>b){return 1;}return 0;}//Build a tree
function createRBTree(compare){return new RedBlackTree(compare||defaultCompare,null);}/***/}),/***/3837:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_234687__){"use strict";module.exports=createAxes;var createText=__nested_webpack_require_234687__(4935);var createLines=__nested_webpack_require_234687__(501);var createBackground=__nested_webpack_require_234687__(5304);var getCubeProperties=__nested_webpack_require_234687__(6429);var Ticks=__nested_webpack_require_234687__(6444);var identity=new Float32Array([1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1]);var ab=ArrayBuffer;var dv=DataView;function isTypedArray(a){return ab.isView(a)&&!(a instanceof dv);}function isArrayOrTypedArray(a){return Array.isArray(a)||isTypedArray(a);}function copyVec3(a,b){a[0]=b[0];a[1]=b[1];a[2]=b[2];return a;}function Axes(gl){this.gl=gl;this.pixelRatio=1;this.bounds=[[-10,-10,-10],[10,10,10]];this.ticks=[[],[],[]];this.autoTicks=true;this.tickSpacing=[1,1,1];this.tickEnable=[true,true,true];this.tickFont=['sans-serif','sans-serif','sans-serif'];this.tickFontStyle=['normal','normal','normal'];this.tickFontWeight=['normal','normal','normal'];this.tickFontVariant=['normal','normal','normal'];this.tickSize=[12,12,12];this.tickAngle=[0,0,0];this.tickAlign=['auto','auto','auto'];this.tickColor=[[0,0,0,1],[0,0,0,1],[0,0,0,1]];this.tickPad=[10,10,10];this.lastCubeProps={cubeEdges:[0,0,0],axis:[0,0,0]};this.labels=['x','y','z'];this.labelEnable=[true,true,true];this.labelFont=['sans-serif','sans-serif','sans-serif'];this.labelFontStyle=['normal','normal','normal'];this.labelFontWeight=['normal','normal','normal'];this.labelFontVariant=['normal','normal','normal'];this.labelSize=[20,20,20];this.labelAngle=[0,0,0];this.labelAlign=['auto','auto','auto'];this.labelColor=[[0,0,0,1],[0,0,0,1],[0,0,0,1]];this.labelPad=[10,10,10];this.lineEnable=[true,true,true];this.lineMirror=[false,false,false];this.lineWidth=[1,1,1];this.lineColor=[[0,0,0,1],[0,0,0,1],[0,0,0,1]];this.lineTickEnable=[true,true,true];this.lineTickMirror=[false,false,false];this.lineTickLength=[0,0,0];this.lineTickWidth=[1,1,1];this.lineTickColor=[[0,0,0,1],[0,0,0,1],[0,0,0,1]];this.gridEnable=[true,true,true];this.gridWidth=[1,1,1];this.gridColor=[[0,0,0,1],[0,0,0,1],[0,0,0,1]];this.zeroEnable=[true,true,true];this.zeroLineColor=[[0,0,0,1],[0,0,0,1],[0,0,0,1]];this.zeroLineWidth=[2,2,2];this.backgroundEnable=[false,false,false];this.backgroundColor=[[0.8,0.8,0.8,0.5],[0.8,0.8,0.8,0.5],[0.8,0.8,0.8,0.5]];this._firstInit=true;this._text=null;this._lines=null;this._background=createBackground(gl);}var proto=Axes.prototype;proto.update=function(options){options=options||{};//Option parsing helper functions
function parseOption(nest,cons,name){if(name in options){var opt=options[name];var prev=this[name];var next;if(nest?isArrayOrTypedArray(opt)&&isArrayOrTypedArray(opt[0]):isArrayOrTypedArray(opt)){this[name]=next=[cons(opt[0]),cons(opt[1]),cons(opt[2])];}else{this[name]=next=[cons(opt),cons(opt),cons(opt)];}for(var i=0;i<3;++i){if(next[i]!==prev[i]){return true;}}}return false;}var NUMBER=parseOption.bind(this,false,Number);var BOOLEAN=parseOption.bind(this,false,Boolean);var STRING=parseOption.bind(this,false,String);var COLOR=parseOption.bind(this,true,function(v){if(isArrayOrTypedArray(v)){if(v.length===3){return[+v[0],+v[1],+v[2],1.0];}else if(v.length===4){return[+v[0],+v[1],+v[2],+v[3]];}}return[0,0,0,1];});//Tick marks and bounds
var nextTicks;var ticksUpdate=false;var boundsChanged=false;if('bounds'in options){var bounds=options.bounds;i_loop:for(var i=0;i<2;++i){for(var j=0;j<3;++j){if(bounds[i][j]!==this.bounds[i][j]){boundsChanged=true;}this.bounds[i][j]=bounds[i][j];}}}if('ticks'in options){nextTicks=options.ticks;ticksUpdate=true;this.autoTicks=false;for(var i=0;i<3;++i){this.tickSpacing[i]=0.0;}}else if(NUMBER('tickSpacing')){this.autoTicks=true;boundsChanged=true;}if(this._firstInit){if(!('ticks'in options||'tickSpacing'in options)){this.autoTicks=true;}//Force tick recomputation on first update
boundsChanged=true;ticksUpdate=true;this._firstInit=false;}if(boundsChanged&&this.autoTicks){nextTicks=Ticks.create(this.bounds,this.tickSpacing);ticksUpdate=true;}//Compare next ticks to previous ticks, only update if needed
if(ticksUpdate){for(var i=0;i<3;++i){nextTicks[i].sort(function(a,b){return a.x-b.x;});}if(Ticks.equal(nextTicks,this.ticks)){ticksUpdate=false;}else{this.ticks=nextTicks;}}//Parse tick properties
BOOLEAN('tickEnable');//If font changes, must rebuild vbo
if(STRING('tickFont'))ticksUpdate=true;if(STRING('tickFontStyle'))ticksUpdate=true;if(STRING('tickFontWeight'))ticksUpdate=true;if(STRING('tickFontVariant'))ticksUpdate=true;NUMBER('tickSize');NUMBER('tickAngle');NUMBER('tickPad');COLOR('tickColor');//Axis labels
var labelUpdate=STRING('labels');if(STRING('labelFont'))labelUpdate=true;if(STRING('labelFontStyle'))labelUpdate=true;if(STRING('labelFontWeight'))labelUpdate=true;if(STRING('labelFontVariant'))labelUpdate=true;BOOLEAN('labelEnable');NUMBER('labelSize');NUMBER('labelPad');COLOR('labelColor');//Axis lines
BOOLEAN('lineEnable');BOOLEAN('lineMirror');NUMBER('lineWidth');COLOR('lineColor');//Axis line ticks
BOOLEAN('lineTickEnable');BOOLEAN('lineTickMirror');NUMBER('lineTickLength');NUMBER('lineTickWidth');COLOR('lineTickColor');//Grid lines
BOOLEAN('gridEnable');NUMBER('gridWidth');COLOR('gridColor');//Zero line
BOOLEAN('zeroEnable');COLOR('zeroLineColor');NUMBER('zeroLineWidth');//Background
BOOLEAN('backgroundEnable');COLOR('backgroundColor');var labelFontOpts=[{family:this.labelFont[0],style:this.labelFontStyle[0],weight:this.labelFontWeight[0],variant:this.labelFontVariant[0]},{family:this.labelFont[1],style:this.labelFontStyle[1],weight:this.labelFontWeight[1],variant:this.labelFontVariant[1]},{family:this.labelFont[2],style:this.labelFontStyle[2],weight:this.labelFontWeight[2],variant:this.labelFontVariant[2]}];var tickFontOpts=[{family:this.tickFont[0],style:this.tickFontStyle[0],weight:this.tickFontWeight[0],variant:this.tickFontVariant[0]},{family:this.tickFont[1],style:this.tickFontStyle[1],weight:this.tickFontWeight[1],variant:this.tickFontVariant[1]},{family:this.tickFont[2],style:this.tickFontStyle[2],weight:this.tickFontWeight[2],variant:this.tickFontVariant[2]}];//Update text if necessary
if(!this._text){this._text=createText(this.gl,this.bounds,this.labels,labelFontOpts,this.ticks,tickFontOpts);}else if(this._text&&(labelUpdate||ticksUpdate)){this._text.update(this.bounds,this.labels,labelFontOpts,this.ticks,tickFontOpts);}//Update lines if necessary
if(this._lines&&ticksUpdate){this._lines.dispose();this._lines=null;}if(!this._lines){this._lines=createLines(this.gl,this.bounds,this.ticks);}};function OffsetInfo(){this.primalOffset=[0,0,0];this.primalMinor=[0,0,0];this.mirrorOffset=[0,0,0];this.mirrorMinor=[0,0,0];}var LINE_OFFSET=[new OffsetInfo(),new OffsetInfo(),new OffsetInfo()];function computeLineOffset(result,i,bounds,cubeEdges,cubeAxis){var primalOffset=result.primalOffset;var primalMinor=result.primalMinor;var dualOffset=result.mirrorOffset;var dualMinor=result.mirrorMinor;var e=cubeEdges[i];//Calculate offsets
for(var j=0;j<3;++j){if(i===j){continue;}var a=primalOffset,b=dualOffset,c=primalMinor,d=dualMinor;if(e&1<<j){a=dualOffset;b=primalOffset;c=dualMinor;d=primalMinor;}a[j]=bounds[0][j];b[j]=bounds[1][j];if(cubeAxis[j]>0){c[j]=-1;d[j]=0;}else{c[j]=0;d[j]=+1;}}}var CUBE_ENABLE=[0,0,0];var DEFAULT_PARAMS={model:identity,view:identity,projection:identity,_ortho:false};proto.isOpaque=function(){return true;};proto.isTransparent=function(){return false;};proto.drawTransparent=function(params){};var ALIGN_OPTION_AUTO=0;// i.e. as defined in the shader the text would rotate to stay upwards range: [-90,90]
var PRIMAL_MINOR=[0,0,0];var MIRROR_MINOR=[0,0,0];var PRIMAL_OFFSET=[0,0,0];proto.draw=function(params){params=params||DEFAULT_PARAMS;var gl=this.gl;//Geometry for camera and axes
var model=params.model||identity;var view=params.view||identity;var projection=params.projection||identity;var bounds=this.bounds;var isOrtho=params._ortho||false;//Unpack axis info
var cubeParams=getCubeProperties(model,view,projection,bounds,isOrtho);var cubeEdges=cubeParams.cubeEdges;var cubeAxis=cubeParams.axis;var cx=view[12];var cy=view[13];var cz=view[14];var cw=view[15];var orthoFix=isOrtho?2:1;// double up padding for orthographic ticks & labels
var pixelScaleF=orthoFix*this.pixelRatio*(projection[3]*cx+projection[7]*cy+projection[11]*cz+projection[15]*cw)/gl.drawingBufferHeight;for(var i=0;i<3;++i){this.lastCubeProps.cubeEdges[i]=cubeEdges[i];this.lastCubeProps.axis[i]=cubeAxis[i];}//Compute axis info
var lineOffset=LINE_OFFSET;for(var i=0;i<3;++i){computeLineOffset(LINE_OFFSET[i],i,this.bounds,cubeEdges,cubeAxis);}//Set up state parameters
var gl=this.gl;//Draw background first
var cubeEnable=CUBE_ENABLE;for(var i=0;i<3;++i){if(this.backgroundEnable[i]){cubeEnable[i]=cubeAxis[i];}else{cubeEnable[i]=0;}}this._background.draw(model,view,projection,bounds,cubeEnable,this.backgroundColor);//Draw lines
this._lines.bind(model,view,projection,this);//First draw grid lines and zero lines
for(var i=0;i<3;++i){var x=[0,0,0];if(cubeAxis[i]>0){x[i]=bounds[1][i];}else{x[i]=bounds[0][i];}//Draw grid lines
for(var j=0;j<2;++j){var u=(i+1+j)%3;var v=(i+1+(j^1))%3;if(this.gridEnable[u]){this._lines.drawGrid(u,v,this.bounds,x,this.gridColor[u],this.gridWidth[u]*this.pixelRatio);}}//Draw zero lines (need to do this AFTER all grid lines are drawn)
for(var j=0;j<2;++j){var u=(i+1+j)%3;var v=(i+1+(j^1))%3;if(this.zeroEnable[v]){//Check if zero line in bounds
if(Math.min(bounds[0][v],bounds[1][v])<=0&&Math.max(bounds[0][v],bounds[1][v])>=0){this._lines.drawZero(u,v,this.bounds,x,this.zeroLineColor[v],this.zeroLineWidth[v]*this.pixelRatio);}}}}//Then draw axis lines and tick marks
for(var i=0;i<3;++i){//Draw axis lines
if(this.lineEnable[i]){this._lines.drawAxisLine(i,this.bounds,lineOffset[i].primalOffset,this.lineColor[i],this.lineWidth[i]*this.pixelRatio);}if(this.lineMirror[i]){this._lines.drawAxisLine(i,this.bounds,lineOffset[i].mirrorOffset,this.lineColor[i],this.lineWidth[i]*this.pixelRatio);}//Compute minor axes
var primalMinor=copyVec3(PRIMAL_MINOR,lineOffset[i].primalMinor);var mirrorMinor=copyVec3(MIRROR_MINOR,lineOffset[i].mirrorMinor);var tickLength=this.lineTickLength;for(var j=0;j<3;++j){var scaleFactor=pixelScaleF/model[5*j];primalMinor[j]*=tickLength[j]*scaleFactor;mirrorMinor[j]*=tickLength[j]*scaleFactor;}//Draw axis line ticks
if(this.lineTickEnable[i]){this._lines.drawAxisTicks(i,lineOffset[i].primalOffset,primalMinor,this.lineTickColor[i],this.lineTickWidth[i]*this.pixelRatio);}if(this.lineTickMirror[i]){this._lines.drawAxisTicks(i,lineOffset[i].mirrorOffset,mirrorMinor,this.lineTickColor[i],this.lineTickWidth[i]*this.pixelRatio);}}this._lines.unbind();//Draw text sprites
this._text.bind(model,view,projection,this.pixelRatio);var alignOpt;// options in shader are from this list {-1, 0, 1, 2, 3, ..., n}
// -1: backward compatible
//  0: raw data
//  1: auto align, free angles
//  2: auto align, horizontal or vertical
//3-n: auto align, round to n directions e.g. 12 -> round to angles with 30-degree steps
var hv_ratio=0.5;// can have an effect on the ratio between horizontals and verticals when using option 2
var enableAlign;var alignDir;function alignTo(i){alignDir=[0,0,0];alignDir[i]=1;}function solveTickAlignments(i,minor,major){var i1=(i+1)%3;var i2=(i+2)%3;var A=minor[i1];var B=minor[i2];var C=major[i1];var D=major[i2];if(A>0&&D>0){alignTo(i1);return;}else if(A>0&&D<0){alignTo(i1);return;}else if(A<0&&D>0){alignTo(i1);return;}else if(A<0&&D<0){alignTo(i1);return;}else if(B>0&&C>0){alignTo(i2);return;}else if(B>0&&C<0){alignTo(i2);return;}else if(B<0&&C>0){alignTo(i2);return;}else if(B<0&&C<0){alignTo(i2);return;}}for(var i=0;i<3;++i){var minor=lineOffset[i].primalMinor;var major=lineOffset[i].mirrorMinor;var offset=copyVec3(PRIMAL_OFFSET,lineOffset[i].primalOffset);for(var j=0;j<3;++j){if(this.lineTickEnable[i]){offset[j]+=pixelScaleF*minor[j]*Math.max(this.lineTickLength[j],0)/model[5*j];}}var axis=[0,0,0];axis[i]=1;//Draw tick text
if(this.tickEnable[i]){if(this.tickAngle[i]===-3600){this.tickAngle[i]=0;this.tickAlign[i]='auto';}else{this.tickAlign[i]=-1;}enableAlign=1;alignOpt=[this.tickAlign[i],hv_ratio,enableAlign];if(alignOpt[0]==='auto')alignOpt[0]=ALIGN_OPTION_AUTO;else alignOpt[0]=parseInt(''+alignOpt[0]);alignDir=[0,0,0];solveTickAlignments(i,minor,major);//Add tick padding
for(var j=0;j<3;++j){offset[j]+=pixelScaleF*minor[j]*this.tickPad[j]/model[5*j];}//Draw axis
this._text.drawTicks(i,this.tickSize[i],this.tickAngle[i],offset,this.tickColor[i],axis,alignDir,alignOpt);}//Draw labels
if(this.labelEnable[i]){enableAlign=0;alignDir=[0,0,0];if(this.labels[i].length>4){// for large label axis enable alignDir to axis
alignTo(i);enableAlign=1;}alignOpt=[this.labelAlign[i],hv_ratio,enableAlign];if(alignOpt[0]==='auto')alignOpt[0]=ALIGN_OPTION_AUTO;else alignOpt[0]=parseInt(''+alignOpt[0]);//Add label padding
for(var j=0;j<3;++j){offset[j]+=pixelScaleF*minor[j]*this.labelPad[j]/model[5*j];}offset[i]+=0.5*(bounds[0][i]+bounds[1][i]);//Draw axis
this._text.drawLabel(i,this.labelSize[i],this.labelAngle[i],offset,this.labelColor[i],[0,0,0],alignDir,alignOpt);}}this._text.unbind();};proto.dispose=function(){this._text.dispose();this._lines.dispose();this._background.dispose();this._lines=null;this._text=null;this._background=null;this.gl=null;};function createAxes(gl,options){var axes=new Axes(gl);axes.update(options);return axes;}/***/}),/***/5304:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_248092__){"use strict";module.exports=createBackgroundCube;var createBuffer=__nested_webpack_require_248092__(2762);var createVAO=__nested_webpack_require_248092__(8116);var createShader=__nested_webpack_require_248092__(1879).bg;function BackgroundCube(gl,buffer,vao,shader){this.gl=gl;this.buffer=buffer;this.vao=vao;this.shader=shader;}var proto=BackgroundCube.prototype;proto.draw=function(model,view,projection,bounds,enable,colors){var needsBG=false;for(var i=0;i<3;++i){needsBG=needsBG||enable[i];}if(!needsBG){return;}var gl=this.gl;gl.enable(gl.POLYGON_OFFSET_FILL);gl.polygonOffset(1,2);this.shader.bind();this.shader.uniforms={model:model,view:view,projection:projection,bounds:bounds,enable:enable,colors:colors};this.vao.bind();this.vao.draw(this.gl.TRIANGLES,36);this.vao.unbind();gl.disable(gl.POLYGON_OFFSET_FILL);};proto.dispose=function(){this.vao.dispose();this.buffer.dispose();this.shader.dispose();};function createBackgroundCube(gl){//Create cube vertices
var vertices=[];var indices=[];var ptr=0;for(var d=0;d<3;++d){var u=(d+1)%3;var v=(d+2)%3;var x=[0,0,0];var c=[0,0,0];for(var s=-1;s<=1;s+=2){indices.push(ptr,ptr+2,ptr+1,ptr+1,ptr+2,ptr+3);x[d]=s;c[d]=s;for(var i=-1;i<=1;i+=2){x[u]=i;for(var j=-1;j<=1;j+=2){x[v]=j;vertices.push(x[0],x[1],x[2],c[0],c[1],c[2]);ptr+=1;}}//Swap u and v
var tt=u;u=v;v=tt;}}//Allocate buffer and vertex array
var buffer=createBuffer(gl,new Float32Array(vertices));var elements=createBuffer(gl,new Uint16Array(indices),gl.ELEMENT_ARRAY_BUFFER);var vao=createVAO(gl,[{buffer:buffer,type:gl.FLOAT,size:3,offset:0,stride:24},{buffer:buffer,type:gl.FLOAT,size:3,offset:12,stride:24}],elements);//Create shader object
var shader=createShader(gl);shader.attributes.position.location=0;shader.attributes.normal.location=1;return new BackgroundCube(gl,buffer,vao,shader);}/***/}),/***/6429:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_249949__){"use strict";module.exports=getCubeEdges;var bits=__nested_webpack_require_249949__(8828);var multiply=__nested_webpack_require_249949__(6760);var splitPoly=__nested_webpack_require_249949__(5202);var orient=__nested_webpack_require_249949__(3250);var mvp=new Array(16);var pCubeVerts=new Array(8);var cubeVerts=new Array(8);var x=new Array(3);var zero3=[0,0,0];(function(){for(var i=0;i<8;++i){pCubeVerts[i]=[1,1,1,1];cubeVerts[i]=[1,1,1];}})();function transformHg(result,x,mat){for(var i=0;i<4;++i){result[i]=mat[12+i];for(var j=0;j<3;++j){result[i]+=x[j]*mat[4*j+i];}}}var FRUSTUM_PLANES=[[0,0,1,0,0],[0,0,-1,1,0],[0,-1,0,1,0],[0,1,0,1,0],[-1,0,0,1,0],[1,0,0,1,0]];function polygonArea(p){for(var i=0;i<FRUSTUM_PLANES.length;++i){p=splitPoly.positive(p,FRUSTUM_PLANES[i]);if(p.length<3){return 0;}}var base=p[0];var ax=base[0]/base[3];var ay=base[1]/base[3];var area=0.0;for(var i=1;i+1<p.length;++i){var b=p[i];var c=p[i+1];var bx=b[0]/b[3];var by=b[1]/b[3];var cx=c[0]/c[3];var cy=c[1]/c[3];var ux=bx-ax;var uy=by-ay;var vx=cx-ax;var vy=cy-ay;area+=Math.abs(ux*vy-uy*vx);}return area;}var CUBE_EDGES=[1,1,1];var CUBE_AXIS=[0,0,0];var CUBE_RESULT={cubeEdges:CUBE_EDGES,axis:CUBE_AXIS};function getCubeEdges(model,view,projection,bounds,ortho){//Concatenate matrices
multiply(mvp,view,model);multiply(mvp,projection,mvp);//First project cube vertices
var ptr=0;for(var i=0;i<2;++i){x[2]=bounds[i][2];for(var j=0;j<2;++j){x[1]=bounds[j][1];for(var k=0;k<2;++k){x[0]=bounds[k][0];transformHg(pCubeVerts[ptr],x,mvp);ptr+=1;}}}//Classify camera against cube faces
var closest=-1;for(var i=0;i<8;++i){var w=pCubeVerts[i][3];for(var l=0;l<3;++l){cubeVerts[i][l]=pCubeVerts[i][l]/w;}if(ortho)cubeVerts[i][2]*=-1;if(w<0){if(closest<0){closest=i;}else if(cubeVerts[i][2]<cubeVerts[closest][2]){closest=i;}}}if(closest<0){closest=0;for(var d=0;d<3;++d){var u=(d+2)%3;var v=(d+1)%3;var o0=-1;var o1=-1;for(var s=0;s<2;++s){var f0=s<<d;var f1=f0+(s<<u)+(1-s<<v);var f2=f0+(1-s<<u)+(s<<v);if(orient(cubeVerts[f0],cubeVerts[f1],cubeVerts[f2],zero3)<0){continue;}if(s){o0=1;}else{o1=1;}}if(o0<0||o1<0){if(o1>o0){closest|=1<<d;}continue;}for(var s=0;s<2;++s){var f0=s<<d;var f1=f0+(s<<u)+(1-s<<v);var f2=f0+(1-s<<u)+(s<<v);var o=polygonArea([pCubeVerts[f0],pCubeVerts[f1],pCubeVerts[f2],pCubeVerts[f0+(1<<u)+(1<<v)]]);if(s){o0=o;}else{o1=o;}}if(o1>o0){closest|=1<<d;continue;}}}var farthest=7^closest;//Find lowest vertex which is not closest closest
var bottom=-1;for(var i=0;i<8;++i){if(i===closest||i===farthest){continue;}if(bottom<0){bottom=i;}else if(cubeVerts[bottom][1]>cubeVerts[i][1]){bottom=i;}}//Find left/right neighbors of bottom vertex
var left=-1;for(var i=0;i<3;++i){var idx=bottom^1<<i;if(idx===closest||idx===farthest){continue;}if(left<0){left=idx;}var v=cubeVerts[idx];if(v[0]<cubeVerts[left][0]){left=idx;}}var right=-1;for(var i=0;i<3;++i){var idx=bottom^1<<i;if(idx===closest||idx===farthest||idx===left){continue;}if(right<0){right=idx;}var v=cubeVerts[idx];if(v[0]>cubeVerts[right][0]){right=idx;}}//Determine edge axis coordinates
var cubeEdges=CUBE_EDGES;cubeEdges[0]=cubeEdges[1]=cubeEdges[2]=0;cubeEdges[bits.log2(left^bottom)]=bottom&left;cubeEdges[bits.log2(bottom^right)]=bottom&right;var top=right^7;if(top===closest||top===farthest){top=left^7;cubeEdges[bits.log2(right^top)]=top&right;}else{cubeEdges[bits.log2(left^top)]=top&left;}//Determine visible faces
var axis=CUBE_AXIS;var cutCorner=closest;for(var d=0;d<3;++d){if(cutCorner&1<<d){axis[d]=-1;}else{axis[d]=1;}}//Return result
return CUBE_RESULT;}/***/}),/***/501:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_253506__){"use strict";module.exports=createLines;var createBuffer=__nested_webpack_require_253506__(2762);var createVAO=__nested_webpack_require_253506__(8116);var createShader=__nested_webpack_require_253506__(1879)/* .line */.n;var MAJOR_AXIS=[0,0,0];var MINOR_AXIS=[0,0,0];var SCREEN_AXIS=[0,0,0];var OFFSET_VEC=[0,0,0];var SHAPE=[1,1];function zeroVec(a){a[0]=a[1]=a[2]=0;return a;}function copyVec(a,b){a[0]=b[0];a[1]=b[1];a[2]=b[2];return a;}function Lines(gl,vertBuffer,vao,shader,tickCount,tickOffset,gridCount,gridOffset){this.gl=gl;this.vertBuffer=vertBuffer;this.vao=vao;this.shader=shader;this.tickCount=tickCount;this.tickOffset=tickOffset;this.gridCount=gridCount;this.gridOffset=gridOffset;}var proto=Lines.prototype;proto.bind=function(model,view,projection){this.shader.bind();this.shader.uniforms.model=model;this.shader.uniforms.view=view;this.shader.uniforms.projection=projection;SHAPE[0]=this.gl.drawingBufferWidth;SHAPE[1]=this.gl.drawingBufferHeight;this.shader.uniforms.screenShape=SHAPE;this.vao.bind();};proto.unbind=function(){this.vao.unbind();};proto.drawAxisLine=function(j,bounds,offset,color,lineWidth){var minorAxis=zeroVec(MINOR_AXIS);this.shader.uniforms.majorAxis=MINOR_AXIS;minorAxis[j]=bounds[1][j]-bounds[0][j];this.shader.uniforms.minorAxis=minorAxis;var noffset=copyVec(OFFSET_VEC,offset);noffset[j]+=bounds[0][j];this.shader.uniforms.offset=noffset;this.shader.uniforms.lineWidth=lineWidth;this.shader.uniforms.color=color;var screenAxis=zeroVec(SCREEN_AXIS);screenAxis[(j+2)%3]=1;this.shader.uniforms.screenAxis=screenAxis;this.vao.draw(this.gl.TRIANGLES,6);var screenAxis=zeroVec(SCREEN_AXIS);screenAxis[(j+1)%3]=1;this.shader.uniforms.screenAxis=screenAxis;this.vao.draw(this.gl.TRIANGLES,6);};proto.drawAxisTicks=function(j,offset,minorAxis,color,lineWidth){if(!this.tickCount[j]){return;}var majorAxis=zeroVec(MAJOR_AXIS);majorAxis[j]=1;this.shader.uniforms.majorAxis=majorAxis;this.shader.uniforms.offset=offset;this.shader.uniforms.minorAxis=minorAxis;this.shader.uniforms.color=color;this.shader.uniforms.lineWidth=lineWidth;var screenAxis=zeroVec(SCREEN_AXIS);screenAxis[j]=1;this.shader.uniforms.screenAxis=screenAxis;this.vao.draw(this.gl.TRIANGLES,this.tickCount[j],this.tickOffset[j]);};proto.drawGrid=function(i,j,bounds,offset,color,lineWidth){if(!this.gridCount[i]){return;}var minorAxis=zeroVec(MINOR_AXIS);minorAxis[j]=bounds[1][j]-bounds[0][j];this.shader.uniforms.minorAxis=minorAxis;var noffset=copyVec(OFFSET_VEC,offset);noffset[j]+=bounds[0][j];this.shader.uniforms.offset=noffset;var majorAxis=zeroVec(MAJOR_AXIS);majorAxis[i]=1;this.shader.uniforms.majorAxis=majorAxis;var screenAxis=zeroVec(SCREEN_AXIS);screenAxis[i]=1;this.shader.uniforms.screenAxis=screenAxis;this.shader.uniforms.lineWidth=lineWidth;this.shader.uniforms.color=color;this.vao.draw(this.gl.TRIANGLES,this.gridCount[i],this.gridOffset[i]);};proto.drawZero=function(j,i,bounds,offset,color,lineWidth){var minorAxis=zeroVec(MINOR_AXIS);this.shader.uniforms.majorAxis=minorAxis;minorAxis[j]=bounds[1][j]-bounds[0][j];this.shader.uniforms.minorAxis=minorAxis;var noffset=copyVec(OFFSET_VEC,offset);noffset[j]+=bounds[0][j];this.shader.uniforms.offset=noffset;var screenAxis=zeroVec(SCREEN_AXIS);screenAxis[i]=1;this.shader.uniforms.screenAxis=screenAxis;this.shader.uniforms.lineWidth=lineWidth;this.shader.uniforms.color=color;this.vao.draw(this.gl.TRIANGLES,6);};proto.dispose=function(){this.vao.dispose();this.vertBuffer.dispose();this.shader.dispose();};function createLines(gl,bounds,ticks){var vertices=[];var tickOffset=[0,0,0];var tickCount=[0,0,0];//Create grid lines for each axis/direction
var gridOffset=[0,0,0];var gridCount=[0,0,0];//Add zero line
vertices.push(0,0,1,0,1,1,0,0,-1,0,0,-1,0,1,1,0,1,-1);for(var i=0;i<3;++i){//Axis tick marks
var start=vertices.length/3|0;for(var j=0;j<ticks[i].length;++j){var x=+ticks[i][j].x;vertices.push(x,0,1,x,1,1,x,0,-1,x,0,-1,x,1,1,x,1,-1);}var end=vertices.length/3|0;tickOffset[i]=start;tickCount[i]=end-start;//Grid lines
var start=vertices.length/3|0;for(var k=0;k<ticks[i].length;++k){var x=+ticks[i][k].x;vertices.push(x,0,1,x,1,1,x,0,-1,x,0,-1,x,1,1,x,1,-1);}var end=vertices.length/3|0;gridOffset[i]=start;gridCount[i]=end-start;}//Create cube VAO
var vertBuf=createBuffer(gl,new Float32Array(vertices));var vao=createVAO(gl,[{"buffer":vertBuf,"type":gl.FLOAT,"size":3,"stride":0,"offset":0}]);var shader=createShader(gl);shader.attributes.position.location=0;return new Lines(gl,vertBuf,vao,shader,tickCount,tickOffset,gridCount,gridOffset);}/***/}),/***/1879:(/***/function(__unused_webpack_module,exports,__nested_webpack_require_258081__){"use strict";var glslify=__nested_webpack_require_258081__(3236);var createShader=__nested_webpack_require_258081__(9405);var lineVert=glslify(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position;\n\nuniform mat4 model, view, projection;\nuniform vec3 offset, majorAxis, minorAxis, screenAxis;\nuniform float lineWidth;\nuniform vec2 screenShape;\n\nvec3 project(vec3 p) {\n  vec4 pp = projection * (view * (model * vec4(p, 1.0)));\n  return pp.xyz / max(pp.w, 0.0001);\n}\n\nvoid main() {\n  vec3 major = position.x * majorAxis;\n  vec3 minor = position.y * minorAxis;\n\n  vec3 vPosition = major + minor + offset;\n  vec3 pPosition = project(vPosition);\n  vec3 offset = project(vPosition + screenAxis * position.z);\n\n  vec2 screen = normalize((offset - pPosition).xy * screenShape) / screenShape;\n\n  gl_Position = vec4(pPosition + vec3(0.5 * screen * lineWidth, 0), 1.0);\n}\n"]);var lineFrag=glslify(["precision highp float;\n#define GLSLIFY 1\n\nuniform vec4 color;\nvoid main() {\n  gl_FragColor = color;\n}"]);exports.n=function(gl){return createShader(gl,lineVert,lineFrag,null,[{name:'position',type:'vec3'}]);};var textVert=glslify(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position;\n\nuniform mat4 model, view, projection;\nuniform vec3 offset, axis, alignDir, alignOpt;\nuniform float scale, angle, pixelScale;\nuniform vec2 resolution;\n\nvec3 project(vec3 p) {\n  vec4 pp = projection * (view * (model * vec4(p, 1.0)));\n  return pp.xyz / max(pp.w, 0.0001);\n}\n\nfloat computeViewAngle(vec3 a, vec3 b) {\n  vec3 A = project(a);\n  vec3 B = project(b);\n\n  return atan(\n    (B.y - A.y) * resolution.y,\n    (B.x - A.x) * resolution.x\n  );\n}\n\nconst float PI = 3.141592;\nconst float TWO_PI = 2.0 * PI;\nconst float HALF_PI = 0.5 * PI;\nconst float ONE_AND_HALF_PI = 1.5 * PI;\n\nint option = int(floor(alignOpt.x + 0.001));\nfloat hv_ratio =       alignOpt.y;\nbool enableAlign =    (alignOpt.z != 0.0);\n\nfloat mod_angle(float a) {\n  return mod(a, PI);\n}\n\nfloat positive_angle(float a) {\n  return mod_angle((a < 0.0) ?\n    a + TWO_PI :\n    a\n  );\n}\n\nfloat look_upwards(float a) {\n  float b = positive_angle(a);\n  return ((b > HALF_PI) && (b <= ONE_AND_HALF_PI)) ?\n    b - PI :\n    b;\n}\n\nfloat look_horizontal_or_vertical(float a, float ratio) {\n  // ratio controls the ratio between being horizontal to (vertical + horizontal)\n  // if ratio is set to 0.5 then it is 50%, 50%.\n  // when using a higher ratio e.g. 0.75 the result would\n  // likely be more horizontal than vertical.\n\n  float b = positive_angle(a);\n\n  return\n    (b < (      ratio) * HALF_PI) ? 0.0 :\n    (b < (2.0 - ratio) * HALF_PI) ? -HALF_PI :\n    (b < (2.0 + ratio) * HALF_PI) ? 0.0 :\n    (b < (4.0 - ratio) * HALF_PI) ? HALF_PI :\n                                    0.0;\n}\n\nfloat roundTo(float a, float b) {\n  return float(b * floor((a + 0.5 * b) / b));\n}\n\nfloat look_round_n_directions(float a, int n) {\n  float b = positive_angle(a);\n  float div = TWO_PI / float(n);\n  float c = roundTo(b, div);\n  return look_upwards(c);\n}\n\nfloat applyAlignOption(float rawAngle, float delta) {\n  return\n    (option >  2) ? look_round_n_directions(rawAngle + delta, option) :       // option 3-n: round to n directions\n    (option == 2) ? look_horizontal_or_vertical(rawAngle + delta, hv_ratio) : // horizontal or vertical\n    (option == 1) ? rawAngle + delta :       // use free angle, and flip to align with one direction of the axis\n    (option == 0) ? look_upwards(rawAngle) : // use free angle, and stay upwards\n    (option ==-1) ? 0.0 :                    // useful for backward compatibility, all texts remains horizontal\n                    rawAngle;                // otherwise return back raw input angle\n}\n\nbool isAxisTitle = (axis.x == 0.0) &&\n                   (axis.y == 0.0) &&\n                   (axis.z == 0.0);\n\nvoid main() {\n  //Compute world offset\n  float axisDistance = position.z;\n  vec3 dataPosition = axisDistance * axis + offset;\n\n  float beta = angle; // i.e. user defined attributes for each tick\n\n  float axisAngle;\n  float clipAngle;\n  float flip;\n\n  if (enableAlign) {\n    axisAngle = (isAxisTitle) ? HALF_PI :\n                      computeViewAngle(dataPosition, dataPosition + axis);\n    clipAngle = computeViewAngle(dataPosition, dataPosition + alignDir);\n\n    axisAngle += (sin(axisAngle) < 0.0) ? PI : 0.0;\n    clipAngle += (sin(clipAngle) < 0.0) ? PI : 0.0;\n\n    flip = (dot(vec2(cos(axisAngle), sin(axisAngle)),\n                vec2(sin(clipAngle),-cos(clipAngle))) > 0.0) ? 1.0 : 0.0;\n\n    beta += applyAlignOption(clipAngle, flip * PI);\n  }\n\n  //Compute plane offset\n  vec2 planeCoord = position.xy * pixelScale;\n\n  mat2 planeXform = scale * mat2(\n     cos(beta), sin(beta),\n    -sin(beta), cos(beta)\n  );\n\n  vec2 viewOffset = 2.0 * planeXform * planeCoord / resolution;\n\n  //Compute clip position\n  vec3 clipPosition = project(dataPosition);\n\n  //Apply text offset in clip coordinates\n  clipPosition += vec3(viewOffset, 0.0);\n\n  //Done\n  gl_Position = vec4(clipPosition, 1.0);\n}\n"]);var textFrag=glslify(["precision highp float;\n#define GLSLIFY 1\n\nuniform vec4 color;\nvoid main() {\n  gl_FragColor = color;\n}"]);exports.Q=function(gl){return createShader(gl,textVert,textFrag,null,[{name:'position',type:'vec3'}]);};var bgVert=glslify(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position;\nattribute vec3 normal;\n\nuniform mat4 model, view, projection;\nuniform vec3 enable;\nuniform vec3 bounds[2];\n\nvarying vec3 colorChannel;\n\nvoid main() {\n\n  vec3 signAxis = sign(bounds[1] - bounds[0]);\n\n  vec3 realNormal = signAxis * normal;\n\n  if(dot(realNormal, enable) > 0.0) {\n    vec3 minRange = min(bounds[0], bounds[1]);\n    vec3 maxRange = max(bounds[0], bounds[1]);\n    vec3 nPosition = mix(minRange, maxRange, 0.5 * (position + 1.0));\n    gl_Position = projection * (view * (model * vec4(nPosition, 1.0)));\n  } else {\n    gl_Position = vec4(0,0,0,0);\n  }\n\n  colorChannel = abs(realNormal);\n}\n"]);var bgFrag=glslify(["precision highp float;\n#define GLSLIFY 1\n\nuniform vec4 colors[3];\n\nvarying vec3 colorChannel;\n\nvoid main() {\n  gl_FragColor = colorChannel.x * colors[0] +\n                 colorChannel.y * colors[1] +\n                 colorChannel.z * colors[2];\n}"]);exports.bg=function(gl){return createShader(gl,bgVert,bgFrag,null,[{name:'position',type:'vec3'},{name:'normal',type:'vec3'}]);};/***/}),/***/4935:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_264655__){"use strict";module.exports=createTextSprites;var createBuffer=__nested_webpack_require_264655__(2762);var createVAO=__nested_webpack_require_264655__(8116);var vectorizeText=__nested_webpack_require_264655__(4359);var createShader=__nested_webpack_require_264655__(1879)/* .text */.Q;var globals=window||process.global||{};var __TEXT_CACHE=globals.__TEXT_CACHE||{};globals.__TEXT_CACHE={};//Vertex buffer format for text is:
//
/// [x,y,z] = Spatial coordinate
//
var VERTEX_SIZE=3;function TextSprites(gl,shader,buffer,vao){this.gl=gl;this.shader=shader;this.buffer=buffer;this.vao=vao;this.tickOffset=this.tickCount=this.labelOffset=this.labelCount=null;}var proto=TextSprites.prototype;//Bind textures for rendering
var SHAPE=[0,0];proto.bind=function(model,view,projection,pixelScale){this.vao.bind();this.shader.bind();var uniforms=this.shader.uniforms;uniforms.model=model;uniforms.view=view;uniforms.projection=projection;uniforms.pixelScale=pixelScale;SHAPE[0]=this.gl.drawingBufferWidth;SHAPE[1]=this.gl.drawingBufferHeight;this.shader.uniforms.resolution=SHAPE;};proto.unbind=function(){this.vao.unbind();};proto.update=function(bounds,labels,labelFont,ticks,tickFont){var data=[];function addItem(t,text,font,size,lineSpacing,styletags){var fontKey=[font.style,font.weight,font.variant,font.family].join('_');var fontcache=__TEXT_CACHE[fontKey];if(!fontcache){fontcache=__TEXT_CACHE[fontKey]={};}var mesh=fontcache[text];if(!mesh){mesh=fontcache[text]=tryVectorizeText(text,{triangles:true,font:font.family,fontStyle:font.style,fontWeight:font.weight,fontVariant:font.variant,textAlign:'center',textBaseline:'middle',lineSpacing:lineSpacing,styletags:styletags});}var scale=(size||12)/12;var positions=mesh.positions;var cells=mesh.cells;for(var i=0,nc=cells.length;i<nc;++i){var c=cells[i];for(var j=2;j>=0;--j){var p=positions[c[j]];data.push(scale*p[0],-scale*p[1],t);}}}//Generate sprites for all 3 axes, store data in texture atlases
var tickOffset=[0,0,0];var tickCount=[0,0,0];var labelOffset=[0,0,0];var labelCount=[0,0,0];var lineSpacing=1.25;var styletags={breaklines:true,bolds:true,italics:true,subscripts:true,superscripts:true};for(var d=0;d<3;++d){//Generate label
labelOffset[d]=data.length/VERTEX_SIZE|0;addItem(0.5*(bounds[0][d]+bounds[1][d]),labels[d],labelFont[d],12,// labelFontSize
lineSpacing,styletags);labelCount[d]=(data.length/VERTEX_SIZE|0)-labelOffset[d];//Generate sprites for tick marks
tickOffset[d]=data.length/VERTEX_SIZE|0;for(var i=0;i<ticks[d].length;++i){if(!ticks[d][i].text){continue;}var font={family:ticks[d][i].font||tickFont[d].family,style:tickFont[d].fontStyle||tickFont[d].style,weight:tickFont[d].fontWeight||tickFont[d].weight,variant:tickFont[d].fontVariant||tickFont[d].variant};addItem(ticks[d][i].x,ticks[d][i].text,font,ticks[d][i].fontSize||12,lineSpacing,styletags);}tickCount[d]=(data.length/VERTEX_SIZE|0)-tickOffset[d];}this.buffer.update(data);this.tickOffset=tickOffset;this.tickCount=tickCount;this.labelOffset=labelOffset;this.labelCount=labelCount;};//Draws the tick marks for an axis
proto.drawTicks=function(d,scale,angle,offset,color,axis,alignDir,alignOpt){if(!this.tickCount[d]){return;}this.shader.uniforms.axis=axis;this.shader.uniforms.color=color;this.shader.uniforms.angle=angle;this.shader.uniforms.scale=scale;this.shader.uniforms.offset=offset;this.shader.uniforms.alignDir=alignDir;this.shader.uniforms.alignOpt=alignOpt;this.vao.draw(this.gl.TRIANGLES,this.tickCount[d],this.tickOffset[d]);};//Draws the text label for an axis
proto.drawLabel=function(d,scale,angle,offset,color,axis,alignDir,alignOpt){if(!this.labelCount[d]){return;}this.shader.uniforms.axis=axis;this.shader.uniforms.color=color;this.shader.uniforms.angle=angle;this.shader.uniforms.scale=scale;this.shader.uniforms.offset=offset;this.shader.uniforms.alignDir=alignDir;this.shader.uniforms.alignOpt=alignOpt;this.vao.draw(this.gl.TRIANGLES,this.labelCount[d],this.labelOffset[d]);};//Releases all resources attached to this object
proto.dispose=function(){this.shader.dispose();this.vao.dispose();this.buffer.dispose();};function tryVectorizeText(text,options){try{return vectorizeText(text,options);}catch(e){console.warn('error vectorizing text:"'+text+'" error:',e);return{cells:[],positions:[]};}}function createTextSprites(gl,bounds,labels,labelFont,ticks,tickFont){var buffer=createBuffer(gl);var vao=createVAO(gl,[{"buffer":buffer,"size":3}]);var shader=createShader(gl);shader.attributes.position.location=0;var result=new TextSprites(gl,shader,buffer,vao);result.update(bounds,labels,labelFont,ticks,tickFont);return result;}/***/}),/***/6444:(/***/function(__unused_webpack_module,exports){"use strict";exports.create=defaultTicks;exports.equal=ticksEqual;function prettyPrint(spacing,i){var stepStr=spacing+"";var u=stepStr.indexOf(".");var sigFigs=0;if(u>=0){sigFigs=stepStr.length-u-1;}var shift=Math.pow(10,sigFigs);var x=Math.round(spacing*i*shift);var xstr=x+"";if(xstr.indexOf("e")>=0){return xstr;}var xi=x/shift,xf=x%shift;if(x<0){xi=-Math.ceil(xi)|0;xf=-xf|0;}else{xi=Math.floor(xi)|0;xf=xf|0;}var xis=""+xi;if(x<0){xis="-"+xis;}if(sigFigs){var xs=""+xf;while(xs.length<sigFigs){xs="0"+xs;}return xis+"."+xs;}else{return xis;}}function defaultTicks(bounds,tickSpacing){var array=[];for(var d=0;d<3;++d){var ticks=[];var m=0.5*(bounds[0][d]+bounds[1][d]);for(var t=0;t*tickSpacing[d]<=bounds[1][d];++t){ticks.push({x:t*tickSpacing[d],text:prettyPrint(tickSpacing[d],t)});}for(var t=-1;t*tickSpacing[d]>=bounds[0][d];--t){ticks.push({x:t*tickSpacing[d],text:prettyPrint(tickSpacing[d],t)});}array.push(ticks);}return array;}function ticksEqual(ticksA,ticksB){for(var i=0;i<3;++i){if(ticksA[i].length!==ticksB[i].length){return false;}for(var j=0;j<ticksA[i].length;++j){var a=ticksA[i][j];var b=ticksB[i][j];if(a.x!==b.x||a.text!==b.text||a.font!==b.font||a.fontColor!==b.fontColor||a.fontSize!==b.fontSize||a.dx!==b.dx||a.dy!==b.dy){return false;}}}return true;}/***/}),/***/5445:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_270627__){"use strict";module.exports=axesProperties;var getPlanes=__nested_webpack_require_270627__(5033);var splitPoly=__nested_webpack_require_270627__(5202);var cubeParams=__nested_webpack_require_270627__(6429);var m4mul=__nested_webpack_require_270627__(6760);var m4transpose=__nested_webpack_require_270627__(5665);var v4transformMat4=__nested_webpack_require_270627__(5352);var identity=new Float32Array([1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1]);var mvp=new Float32Array(16);function AxesRange3D(lo,hi,pixelsPerDataUnit){this.lo=lo;this.hi=hi;this.pixelsPerDataUnit=pixelsPerDataUnit;}var SCRATCH_P=[0,0,0,1];var SCRATCH_Q=[0,0,0,1];function gradient(result,M,v,width,height){for(var i=0;i<3;++i){var p=SCRATCH_P;var q=SCRATCH_Q;for(var j=0;j<3;++j){q[j]=p[j]=v[j];}q[3]=p[3]=1;q[i]+=1;v4transformMat4(q,q,M);if(q[3]<0){result[i]=Infinity;}p[i]-=1;v4transformMat4(p,p,M);if(p[3]<0){result[i]=Infinity;}var dx=(p[0]/p[3]-q[0]/q[3])*width;var dy=(p[1]/p[3]-q[1]/q[3])*height;result[i]=0.25*Math.sqrt(dx*dx+dy*dy);}return result;}var RANGES=[new AxesRange3D(Infinity,-Infinity,Infinity),new AxesRange3D(Infinity,-Infinity,Infinity),new AxesRange3D(Infinity,-Infinity,Infinity)];var SCRATCH_X=[0,0,0];function axesProperties(axes,camera,width,height,params){var model=camera.model||identity;var view=camera.view||identity;var projection=camera.projection||identity;var isOrtho=camera._ortho||false;var bounds=axes.bounds;var params=params||cubeParams(model,view,projection,bounds,isOrtho);var axis=params.axis;m4mul(mvp,view,model);m4mul(mvp,projection,mvp);//Calculate the following properties for each axis:
//
// * lo - start of visible range for each axis in tick coordinates
// * hi - end of visible range for each axis in tick coordinates
// * ticksPerPixel - pixel density of tick marks for the axis
//
var ranges=RANGES;for(var i=0;i<3;++i){ranges[i].lo=Infinity;ranges[i].hi=-Infinity;ranges[i].pixelsPerDataUnit=Infinity;}//Compute frustum planes, intersect with box
var frustum=getPlanes(m4transpose(mvp,mvp));m4transpose(mvp,mvp);//Loop over vertices of viewable box
for(var d=0;d<3;++d){var u=(d+1)%3;var v=(d+2)%3;var x=SCRATCH_X;i_loop:for(var i=0;i<2;++i){var poly=[];if(axis[d]<0===!!i){continue;}x[d]=bounds[i][d];for(var j=0;j<2;++j){x[u]=bounds[j^i][u];for(var k=0;k<2;++k){x[v]=bounds[k^j^i][v];poly.push(x.slice());}}var Q=isOrtho?5:4;for(var j=Q;j===Q;++j){// Note: using only near plane here (& for orthographic projection we use the far).
if(poly.length===0){continue i_loop;}poly=splitPoly.positive(poly,frustum[j]);}//Loop over vertices of polygon to find extremal points
for(var j=0;j<poly.length;++j){var v=poly[j];var grad=gradient(SCRATCH_X,mvp,v,width,height);for(var k=0;k<3;++k){ranges[k].lo=Math.min(ranges[k].lo,v[k]);ranges[k].hi=Math.max(ranges[k].hi,v[k]);if(k!==d){ranges[k].pixelsPerDataUnit=Math.min(ranges[k].pixelsPerDataUnit,Math.abs(grad[k]));}}}}}return ranges;}/***/}),/***/2762:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_273525__){"use strict";var pool=__nested_webpack_require_273525__(1888);var ops=__nested_webpack_require_273525__(5298);var ndarray=__nested_webpack_require_273525__(9618);var SUPPORTED_TYPES=["uint8","uint8_clamped","uint16","uint32","int8","int16","int32","float32"];function GLBuffer(gl,type,handle,length,usage){this.gl=gl;this.type=type;this.handle=handle;this.length=length;this.usage=usage;}var proto=GLBuffer.prototype;proto.bind=function(){this.gl.bindBuffer(this.type,this.handle);};proto.unbind=function(){this.gl.bindBuffer(this.type,null);};proto.dispose=function(){this.gl.deleteBuffer(this.handle);};function updateTypeArray(gl,type,len,usage,data,offset){var dataLen=data.length*data.BYTES_PER_ELEMENT;if(offset<0){gl.bufferData(type,data,usage);return dataLen;}if(dataLen+offset>len){throw new Error("gl-buffer: If resizing buffer, must not specify offset");}gl.bufferSubData(type,offset,data);return len;}function makeScratchTypeArray(array,dtype){var res=pool.malloc(array.length,dtype);var n=array.length;for(var i=0;i<n;++i){res[i]=array[i];}return res;}function isPacked(shape,stride){var n=1;for(var i=stride.length-1;i>=0;--i){if(stride[i]!==n){return false;}n*=shape[i];}return true;}proto.update=function(array,offset){if(typeof offset!=="number"){offset=-1;}this.bind();if(typeof array==="object"&&typeof array.shape!=="undefined"){//ndarray
var dtype=array.dtype;if(SUPPORTED_TYPES.indexOf(dtype)<0){dtype="float32";}if(this.type===this.gl.ELEMENT_ARRAY_BUFFER){var ext=gl.getExtension('OES_element_index_uint');if(ext&&dtype!=="uint16"){dtype="uint32";}else{dtype="uint16";}}if(dtype===array.dtype&&isPacked(array.shape,array.stride)){if(array.offset===0&&array.data.length===array.shape[0]){this.length=updateTypeArray(this.gl,this.type,this.length,this.usage,array.data,offset);}else{this.length=updateTypeArray(this.gl,this.type,this.length,this.usage,array.data.subarray(array.offset,array.shape[0]),offset);}}else{var tmp=pool.malloc(array.size,dtype);var ndt=ndarray(tmp,array.shape);ops.assign(ndt,array);if(offset<0){this.length=updateTypeArray(this.gl,this.type,this.length,this.usage,tmp,offset);}else{this.length=updateTypeArray(this.gl,this.type,this.length,this.usage,tmp.subarray(0,array.size),offset);}pool.free(tmp);}}else if(Array.isArray(array)){//Vanilla array
var t;if(this.type===this.gl.ELEMENT_ARRAY_BUFFER){t=makeScratchTypeArray(array,"uint16");}else{t=makeScratchTypeArray(array,"float32");}if(offset<0){this.length=updateTypeArray(this.gl,this.type,this.length,this.usage,t,offset);}else{this.length=updateTypeArray(this.gl,this.type,this.length,this.usage,t.subarray(0,array.length),offset);}pool.free(t);}else if(typeof array==="object"&&typeof array.length==="number"){//Typed array
this.length=updateTypeArray(this.gl,this.type,this.length,this.usage,array,offset);}else if(typeof array==="number"||array===undefined){//Number/default
if(offset>=0){throw new Error("gl-buffer: Cannot specify offset when resizing buffer");}array=array|0;if(array<=0){array=1;}this.gl.bufferData(this.type,array|0,this.usage);this.length=array;}else{//Error, case should not happen
throw new Error("gl-buffer: Invalid data type");}};function createBuffer(gl,data,type,usage){type=type||gl.ARRAY_BUFFER;usage=usage||gl.DYNAMIC_DRAW;if(type!==gl.ARRAY_BUFFER&&type!==gl.ELEMENT_ARRAY_BUFFER){throw new Error("gl-buffer: Invalid type for webgl buffer, must be either gl.ARRAY_BUFFER or gl.ELEMENT_ARRAY_BUFFER");}if(usage!==gl.DYNAMIC_DRAW&&usage!==gl.STATIC_DRAW&&usage!==gl.STREAM_DRAW){throw new Error("gl-buffer: Invalid usage for buffer, must be either gl.DYNAMIC_DRAW, gl.STATIC_DRAW or gl.STREAM_DRAW");}var handle=gl.createBuffer();var result=new GLBuffer(gl,type,handle,0,usage);result.update(data);return result;}module.exports=createBuffer;/***/}),/***/6405:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_277349__){"use strict";var vec3=__nested_webpack_require_277349__(2931);module.exports=function(vectorfield,bounds){var positions=vectorfield.positions;var vectors=vectorfield.vectors;var geo={positions:[],vertexIntensity:[],vertexIntensityBounds:vectorfield.vertexIntensityBounds,vectors:[],cells:[],coneOffset:vectorfield.coneOffset,colormap:vectorfield.colormap};if(vectorfield.positions.length===0){if(bounds){bounds[0]=[0,0,0];bounds[1]=[0,0,0];}return geo;}// Compute bounding box for the dataset.
// Compute maximum velocity for the dataset to use for scaling the cones.
var maxNorm=0;var minX=Infinity,maxX=-Infinity;var minY=Infinity,maxY=-Infinity;var minZ=Infinity,maxZ=-Infinity;var p2=null;var u2=null;var positionVectors=[];var vectorScale=Infinity;var skipIt=false;var rawSizemodemode=vectorfield.coneSizemode==='raw';for(var i=0;i<positions.length;i++){var p=positions[i];minX=Math.min(p[0],minX);maxX=Math.max(p[0],maxX);minY=Math.min(p[1],minY);maxY=Math.max(p[1],maxY);minZ=Math.min(p[2],minZ);maxZ=Math.max(p[2],maxZ);var u=vectors[i];if(vec3.length(u)>maxNorm){maxNorm=vec3.length(u);}if(i&&!rawSizemodemode){// Find vector scale [w/ units of time] using "successive" positions
// (not "adjacent" with would be O(n^2)),
//
// The vector scale corresponds to the minimum "time" to travel across two
// two adjacent positions at the average velocity of those two adjacent positions
var q=2*vec3.distance(p2,p)/(vec3.length(u2)+vec3.length(u));if(q){vectorScale=Math.min(vectorScale,q);skipIt=false;}else{skipIt=true;}}if(!skipIt){p2=p;u2=u;}positionVectors.push(u);}var minV=[minX,minY,minZ];var maxV=[maxX,maxY,maxZ];if(bounds){bounds[0]=minV;bounds[1]=maxV;}if(maxNorm===0){maxNorm=1;}// Inverted max norm would map vector with norm maxNorm to 1 coord space units in length
var invertedMaxNorm=1/maxNorm;if(!isFinite(vectorScale)){vectorScale=1.0;}geo.vectorScale=vectorScale;var coneScale=vectorfield.coneSize||(rawSizemodemode?1:0.5);if(vectorfield.absoluteConeSize){coneScale=vectorfield.absoluteConeSize*invertedMaxNorm;}geo.coneScale=coneScale;// Build the cone model.
for(var i=0,j=0;i<positions.length;i++){var p=positions[i];var x=p[0],y=p[1],z=p[2];var d=positionVectors[i];var intensity=vec3.length(d)*invertedMaxNorm;for(var k=0,l=8;k<l;k++){geo.positions.push([x,y,z,j++]);geo.positions.push([x,y,z,j++]);geo.positions.push([x,y,z,j++]);geo.positions.push([x,y,z,j++]);geo.positions.push([x,y,z,j++]);geo.positions.push([x,y,z,j++]);geo.vectors.push(d);geo.vectors.push(d);geo.vectors.push(d);geo.vectors.push(d);geo.vectors.push(d);geo.vectors.push(d);geo.vertexIntensity.push(intensity,intensity,intensity);geo.vertexIntensity.push(intensity,intensity,intensity);var m=geo.positions.length;geo.cells.push([m-6,m-5,m-4],[m-3,m-2,m-1]);}}return geo;};var shaders=__nested_webpack_require_277349__(614);module.exports.createMesh=__nested_webpack_require_277349__(9060);module.exports.createConeMesh=function(gl,params){return module.exports.createMesh(gl,params,{shaders:shaders,traceType:'cone'});};/***/}),/***/9060:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_280415__){"use strict";var createShader=__nested_webpack_require_280415__(9405);var createBuffer=__nested_webpack_require_280415__(2762);var createVAO=__nested_webpack_require_280415__(8116);var createTexture=__nested_webpack_require_280415__(7766);var multiply=__nested_webpack_require_280415__(6760);var invert=__nested_webpack_require_280415__(7608);var ndarray=__nested_webpack_require_280415__(9618);var colormap=__nested_webpack_require_280415__(6729);var IDENTITY=[1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1];function VectorMesh(gl,texture,triShader,pickShader,trianglePositions,triangleVectors,triangleIds,triangleColors,triangleUVs,triangleVAO,traceType){this.gl=gl;this.pixelRatio=1;this.cells=[];this.positions=[];this.intensity=[];this.texture=texture;this.dirty=true;this.triShader=triShader;this.pickShader=pickShader;this.trianglePositions=trianglePositions;this.triangleVectors=triangleVectors;this.triangleColors=triangleColors;this.triangleUVs=triangleUVs;this.triangleIds=triangleIds;this.triangleVAO=triangleVAO;this.triangleCount=0;this.pickId=1;this.bounds=[[Infinity,Infinity,Infinity],[-Infinity,-Infinity,-Infinity]];this.clipBounds=[[-Infinity,-Infinity,-Infinity],[Infinity,Infinity,Infinity]];this.lightPosition=[1e5,1e5,0];this.ambientLight=0.8;this.diffuseLight=0.8;this.specularLight=2.0;this.roughness=0.5;this.fresnel=1.5;this.opacity=1;this.traceType=traceType;this.tubeScale=1;// used in streamtube
this.coneScale=2;// used in cone
this.vectorScale=1;// used in cone
this.coneOffset=0.25;// used in cone
this._model=IDENTITY;this._view=IDENTITY;this._projection=IDENTITY;this._resolution=[1,1];}var proto=VectorMesh.prototype;proto.isOpaque=function(){return this.opacity>=1;};proto.isTransparent=function(){return this.opacity<1;};proto.pickSlots=1;proto.setPickBase=function(id){this.pickId=id;};function genColormap(param){var colors=colormap({colormap:param,nshades:256,format:'rgba'});var result=new Uint8Array(256*4);for(var i=0;i<256;++i){var c=colors[i];for(var j=0;j<3;++j){result[4*i+j]=c[j];}result[4*i+3]=c[3]*255;}return ndarray(result,[256,256,4],[4,0,1]);}function takeZComponent(array){var n=array.length;var result=new Array(n);for(var i=0;i<n;++i){result[i]=array[i][2];}return result;}proto.update=function(params){params=params||{};var gl=this.gl;this.dirty=true;if('lightPosition'in params){this.lightPosition=params.lightPosition;}if('opacity'in params){this.opacity=params.opacity;}if('ambient'in params){this.ambientLight=params.ambient;}if('diffuse'in params){this.diffuseLight=params.diffuse;}if('specular'in params){this.specularLight=params.specular;}if('roughness'in params){this.roughness=params.roughness;}if('fresnel'in params){this.fresnel=params.fresnel;}// use in streamtube
if(params.tubeScale!==undefined){this.tubeScale=params.tubeScale;}// used in cone
if(params.vectorScale!==undefined){this.vectorScale=params.vectorScale;}if(params.coneScale!==undefined){this.coneScale=params.coneScale;}if(params.coneOffset!==undefined){this.coneOffset=params.coneOffset;}if(params.colormap){this.texture.shape=[256,256];this.texture.minFilter=gl.LINEAR_MIPMAP_LINEAR;this.texture.magFilter=gl.LINEAR;this.texture.setPixels(genColormap(params.colormap));this.texture.generateMipmap();}var cells=params.cells;var positions=params.positions;var vectors=params.vectors;if(!positions||!cells||!vectors){return;}var tPos=[];var tVec=[];var tCol=[];var tUVs=[];var tIds=[];//Save geometry data for picking calculations
this.cells=cells;this.positions=positions;this.vectors=vectors;//Compute colors
var meshColor=params.meshColor||[1,1,1,1];//UVs
var vertexIntensity=params.vertexIntensity;var intensityLo=Infinity;var intensityHi=-Infinity;if(vertexIntensity){if(params.vertexIntensityBounds){intensityLo=+params.vertexIntensityBounds[0];intensityHi=+params.vertexIntensityBounds[1];}else{for(var i=0;i<vertexIntensity.length;++i){var f=vertexIntensity[i];intensityLo=Math.min(intensityLo,f);intensityHi=Math.max(intensityHi,f);}}}else{for(var i=0;i<positions.length;++i){var f=positions[i][2];intensityLo=Math.min(intensityLo,f);intensityHi=Math.max(intensityHi,f);}}if(vertexIntensity){this.intensity=vertexIntensity;}else{this.intensity=takeZComponent(positions);}//Update bounds
this.bounds=[[Infinity,Infinity,Infinity],[-Infinity,-Infinity,-Infinity]];for(var i=0;i<positions.length;++i){var p=positions[i];for(var j=0;j<3;++j){if(isNaN(p[j])||!isFinite(p[j])){continue;}this.bounds[0][j]=Math.min(this.bounds[0][j],p[j]);this.bounds[1][j]=Math.max(this.bounds[1][j],p[j]);}}//Pack cells into buffers
var triangleCount=0;fill_loop:for(var i=0;i<cells.length;++i){var cell=cells[i];switch(cell.length){case 3://Check NaNs
for(var j=0;j<3;++j){var v=cell[j];var p=positions[v];for(var k=0;k<3;++k){if(isNaN(p[k])||!isFinite(p[k])){continue fill_loop;}}}for(var j=0;j<3;++j){var v=cell[2-j];var p=positions[v];tPos.push(p[0],p[1],p[2],p[3]);var w=vectors[v];tVec.push(w[0],w[1],w[2],w[3]||0);var c=meshColor;if(c.length===3){tCol.push(c[0],c[1],c[2],1);}else{tCol.push(c[0],c[1],c[2],c[3]);}var uv;if(vertexIntensity){uv=[(vertexIntensity[v]-intensityLo)/(intensityHi-intensityLo),0];}else{uv=[(p[2]-intensityLo)/(intensityHi-intensityLo),0];}tUVs.push(uv[0],uv[1]);tIds.push(i);}triangleCount+=1;break;default:break;}}this.triangleCount=triangleCount;this.trianglePositions.update(tPos);this.triangleVectors.update(tVec);this.triangleColors.update(tCol);this.triangleUVs.update(tUVs);this.triangleIds.update(new Uint32Array(tIds));};proto.drawTransparent=proto.draw=function(params){params=params||{};var gl=this.gl;var model=params.model||IDENTITY;var view=params.view||IDENTITY;var projection=params.projection||IDENTITY;var clipBounds=[[-1e6,-1e6,-1e6],[1e6,1e6,1e6]];for(var i=0;i<3;++i){clipBounds[0][i]=Math.max(clipBounds[0][i],this.clipBounds[0][i]);clipBounds[1][i]=Math.min(clipBounds[1][i],this.clipBounds[1][i]);}var uniforms={model:model,view:view,projection:projection,inverseModel:IDENTITY.slice(),clipBounds:clipBounds,kambient:this.ambientLight,kdiffuse:this.diffuseLight,kspecular:this.specularLight,roughness:this.roughness,fresnel:this.fresnel,eyePosition:[0,0,0],lightPosition:[0,0,0],opacity:this.opacity,tubeScale:this.tubeScale,vectorScale:this.vectorScale,coneScale:this.coneScale,coneOffset:this.coneOffset,texture:0};uniforms.inverseModel=invert(uniforms.inverseModel,uniforms.model);gl.disable(gl.CULL_FACE);this.texture.bind(0);var invCameraMatrix=new Array(16);multiply(invCameraMatrix,uniforms.view,uniforms.model);multiply(invCameraMatrix,uniforms.projection,invCameraMatrix);invert(invCameraMatrix,invCameraMatrix);for(var i=0;i<3;++i){uniforms.eyePosition[i]=invCameraMatrix[12+i]/invCameraMatrix[15];}var w=invCameraMatrix[15];for(var i=0;i<3;++i){w+=this.lightPosition[i]*invCameraMatrix[4*i+3];}for(var i=0;i<3;++i){var s=invCameraMatrix[12+i];for(var j=0;j<3;++j){s+=invCameraMatrix[4*j+i]*this.lightPosition[j];}uniforms.lightPosition[i]=s/w;}if(this.triangleCount>0){var shader=this.triShader;shader.bind();shader.uniforms=uniforms;this.triangleVAO.bind();gl.drawArrays(gl.TRIANGLES,0,this.triangleCount*3);this.triangleVAO.unbind();}};proto.drawPick=function(params){params=params||{};var gl=this.gl;var model=params.model||IDENTITY;var view=params.view||IDENTITY;var projection=params.projection||IDENTITY;var clipBounds=[[-1e6,-1e6,-1e6],[1e6,1e6,1e6]];for(var i=0;i<3;++i){clipBounds[0][i]=Math.max(clipBounds[0][i],this.clipBounds[0][i]);clipBounds[1][i]=Math.min(clipBounds[1][i],this.clipBounds[1][i]);}//Save camera parameters
this._model=[].slice.call(model);this._view=[].slice.call(view);this._projection=[].slice.call(projection);this._resolution=[gl.drawingBufferWidth,gl.drawingBufferHeight];var uniforms={model:model,view:view,projection:projection,clipBounds:clipBounds,tubeScale:this.tubeScale,vectorScale:this.vectorScale,coneScale:this.coneScale,coneOffset:this.coneOffset,pickId:this.pickId/255.0};var shader=this.pickShader;shader.bind();shader.uniforms=uniforms;if(this.triangleCount>0){this.triangleVAO.bind();gl.drawArrays(gl.TRIANGLES,0,this.triangleCount*3);this.triangleVAO.unbind();}};proto.pick=function(pickData){if(!pickData){return null;}if(pickData.id!==this.pickId){return null;}var cellId=pickData.value[0]+256*pickData.value[1]+65536*pickData.value[2];var cell=this.cells[cellId];var pos=this.positions[cell[1]].slice(0,3);var result={position:pos,dataCoordinate:pos,index:Math.floor(cell[1]/48)};if(this.traceType==='cone'){result.index=Math.floor(cell[1]/48);}else if(this.traceType==='streamtube'){result.intensity=this.intensity[cell[1]];result.velocity=this.vectors[cell[1]].slice(0,3);result.divergence=this.vectors[cell[1]][3];result.index=cellId;}return result;};proto.dispose=function(){this.texture.dispose();this.triShader.dispose();this.pickShader.dispose();this.triangleVAO.dispose();this.trianglePositions.dispose();this.triangleVectors.dispose();this.triangleColors.dispose();this.triangleUVs.dispose();this.triangleIds.dispose();};function createMeshShader(gl,shaders){var shader=createShader(gl,shaders.meshShader.vertex,shaders.meshShader.fragment,null,shaders.meshShader.attributes);shader.attributes.position.location=0;shader.attributes.color.location=2;shader.attributes.uv.location=3;shader.attributes.vector.location=4;return shader;}function createPickShader(gl,shaders){var shader=createShader(gl,shaders.pickShader.vertex,shaders.pickShader.fragment,null,shaders.pickShader.attributes);shader.attributes.position.location=0;shader.attributes.id.location=1;shader.attributes.vector.location=4;return shader;}function createVectorMesh(gl,params,opts){var shaders=opts.shaders;if(arguments.length===1){params=gl;gl=params.gl;}var triShader=createMeshShader(gl,shaders);var pickShader=createPickShader(gl,shaders);var meshTexture=createTexture(gl,ndarray(new Uint8Array([255,255,255,255]),[1,1,4]));meshTexture.generateMipmap();meshTexture.minFilter=gl.LINEAR_MIPMAP_LINEAR;meshTexture.magFilter=gl.LINEAR;var trianglePositions=createBuffer(gl);var triangleVectors=createBuffer(gl);var triangleColors=createBuffer(gl);var triangleUVs=createBuffer(gl);var triangleIds=createBuffer(gl);var triangleVAO=createVAO(gl,[{buffer:trianglePositions,type:gl.FLOAT,size:4},{buffer:triangleIds,type:gl.UNSIGNED_BYTE,size:4,normalized:true},{buffer:triangleColors,type:gl.FLOAT,size:4},{buffer:triangleUVs,type:gl.FLOAT,size:2},{buffer:triangleVectors,type:gl.FLOAT,size:4}]);var mesh=new VectorMesh(gl,meshTexture,triShader,pickShader,trianglePositions,triangleVectors,triangleIds,triangleColors,triangleUVs,triangleVAO,opts.traceType||'cone');mesh.update(params);return mesh;}module.exports=createVectorMesh;/***/}),/***/614:(/***/function(__unused_webpack_module,exports,__nested_webpack_require_291024__){var glslify=__nested_webpack_require_291024__(3236);var triVertSrc=glslify(["precision highp float;\n\nprecision highp float;\n#define GLSLIFY 1\n\nvec3 getOrthogonalVector(vec3 v) {\n  // Return up-vector for only-z vector.\n  // Return ax + by + cz = 0, a point that lies on the plane that has v as a normal and that isn't (0,0,0).\n  // From the above if-statement we have ||a|| > 0  U  ||b|| > 0.\n  // Assign z = 0, x = -b, y = a:\n  // a*-b + b*a + c*0 = -ba + ba + 0 = 0\n  if (v.x*v.x > v.z*v.z || v.y*v.y > v.z*v.z) {\n    return normalize(vec3(-v.y, v.x, 0.0));\n  } else {\n    return normalize(vec3(0.0, v.z, -v.y));\n  }\n}\n\n// Calculate the cone vertex and normal at the given index.\n//\n// The returned vertex is for a cone with its top at origin and height of 1.0,\n// pointing in the direction of the vector attribute.\n//\n// Each cone is made up of a top vertex, a center base vertex and base perimeter vertices.\n// These vertices are used to make up the triangles of the cone by the following:\n//   segment + 0 top vertex\n//   segment + 1 perimeter vertex a+1\n//   segment + 2 perimeter vertex a\n//   segment + 3 center base vertex\n//   segment + 4 perimeter vertex a\n//   segment + 5 perimeter vertex a+1\n// Where segment is the number of the radial segment * 6 and a is the angle at that radial segment.\n// To go from index to segment, floor(index / 6)\n// To go from segment to angle, 2*pi * (segment/segmentCount)\n// To go from index to segment index, index - (segment*6)\n//\nvec3 getConePosition(vec3 d, float rawIndex, float coneOffset, out vec3 normal) {\n\n  const float segmentCount = 8.0;\n\n  float index = rawIndex - floor(rawIndex /\n    (segmentCount * 6.0)) *\n    (segmentCount * 6.0);\n\n  float segment = floor(0.001 + index/6.0);\n  float segmentIndex = index - (segment*6.0);\n\n  normal = -normalize(d);\n\n  if (segmentIndex > 2.99 && segmentIndex < 3.01) {\n    return mix(vec3(0.0), -d, coneOffset);\n  }\n\n  float nextAngle = (\n    (segmentIndex > 0.99 &&  segmentIndex < 1.01) ||\n    (segmentIndex > 4.99 &&  segmentIndex < 5.01)\n  ) ? 1.0 : 0.0;\n  float angle = 2.0 * 3.14159 * ((segment + nextAngle) / segmentCount);\n\n  vec3 v1 = mix(d, vec3(0.0), coneOffset);\n  vec3 v2 = v1 - d;\n\n  vec3 u = getOrthogonalVector(d);\n  vec3 v = normalize(cross(u, d));\n\n  vec3 x = u * cos(angle) * length(d)*0.25;\n  vec3 y = v * sin(angle) * length(d)*0.25;\n  vec3 v3 = v2 + x + y;\n  if (segmentIndex < 3.0) {\n    vec3 tx = u * sin(angle);\n    vec3 ty = v * -cos(angle);\n    vec3 tangent = tx + ty;\n    normal = normalize(cross(v3 - v1, tangent));\n  }\n\n  if (segmentIndex == 0.0) {\n    return mix(d, vec3(0.0), coneOffset);\n  }\n  return v3;\n}\n\nattribute vec3 vector;\nattribute vec4 color, position;\nattribute vec2 uv;\n\nuniform float vectorScale, coneScale, coneOffset;\nuniform mat4 model, view, projection, inverseModel;\nuniform vec3 eyePosition, lightPosition;\n\nvarying vec3 f_normal, f_lightDirection, f_eyeDirection, f_data, f_position;\nvarying vec4 f_color;\nvarying vec2 f_uv;\n\nvoid main() {\n  // Scale the vector magnitude to stay constant with\n  // model & view changes.\n  vec3 normal;\n  vec3 XYZ = getConePosition(mat3(model) * ((vectorScale * coneScale) * vector), position.w, coneOffset, normal);\n  vec4 conePosition = model * vec4(position.xyz, 1.0) + vec4(XYZ, 0.0);\n\n  //Lighting geometry parameters\n  vec4 cameraCoordinate = view * conePosition;\n  cameraCoordinate.xyz /= cameraCoordinate.w;\n  f_lightDirection = lightPosition - cameraCoordinate.xyz;\n  f_eyeDirection   = eyePosition - cameraCoordinate.xyz;\n  f_normal = normalize((vec4(normal, 0.0) * inverseModel).xyz);\n\n  // vec4 m_position  = model * vec4(conePosition, 1.0);\n  vec4 t_position  = view * conePosition;\n  gl_Position      = projection * t_position;\n\n  f_color          = color;\n  f_data           = conePosition.xyz;\n  f_position       = position.xyz;\n  f_uv             = uv;\n}\n"]);var triFragSrc=glslify(["#extension GL_OES_standard_derivatives : enable\n\nprecision highp float;\n#define GLSLIFY 1\n\nfloat beckmannDistribution(float x, float roughness) {\n  float NdotH = max(x, 0.0001);\n  float cos2Alpha = NdotH * NdotH;\n  float tan2Alpha = (cos2Alpha - 1.0) / cos2Alpha;\n  float roughness2 = roughness * roughness;\n  float denom = 3.141592653589793 * roughness2 * cos2Alpha * cos2Alpha;\n  return exp(tan2Alpha / roughness2) / denom;\n}\n\nfloat cookTorranceSpecular(\n  vec3 lightDirection,\n  vec3 viewDirection,\n  vec3 surfaceNormal,\n  float roughness,\n  float fresnel) {\n\n  float VdotN = max(dot(viewDirection, surfaceNormal), 0.0);\n  float LdotN = max(dot(lightDirection, surfaceNormal), 0.0);\n\n  //Half angle vector\n  vec3 H = normalize(lightDirection + viewDirection);\n\n  //Geometric term\n  float NdotH = max(dot(surfaceNormal, H), 0.0);\n  float VdotH = max(dot(viewDirection, H), 0.000001);\n  float LdotH = max(dot(lightDirection, H), 0.000001);\n  float G1 = (2.0 * NdotH * VdotN) / VdotH;\n  float G2 = (2.0 * NdotH * LdotN) / LdotH;\n  float G = min(1.0, min(G1, G2));\n  \n  //Distribution term\n  float D = beckmannDistribution(NdotH, roughness);\n\n  //Fresnel term\n  float F = pow(1.0 - VdotN, fresnel);\n\n  //Multiply terms and done\n  return  G * F * D / max(3.14159265 * VdotN, 0.000001);\n}\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3 clipBounds[2];\nuniform float roughness, fresnel, kambient, kdiffuse, kspecular, opacity;\nuniform sampler2D texture;\n\nvarying vec3 f_normal, f_lightDirection, f_eyeDirection, f_data, f_position;\nvarying vec4 f_color;\nvarying vec2 f_uv;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], f_position)) discard;\n  vec3 N = normalize(f_normal);\n  vec3 L = normalize(f_lightDirection);\n  vec3 V = normalize(f_eyeDirection);\n\n  if(gl_FrontFacing) {\n    N = -N;\n  }\n\n  float specular = min(1.0, max(0.0, cookTorranceSpecular(L, V, N, roughness, fresnel)));\n  float diffuse  = min(kambient + kdiffuse * max(dot(N, L), 0.0), 1.0);\n\n  vec4 surfaceColor = f_color * texture2D(texture, f_uv);\n  vec4 litColor = surfaceColor.a * vec4(diffuse * surfaceColor.rgb + kspecular * vec3(1,1,1) * specular,  1.0);\n\n  gl_FragColor = litColor * opacity;\n}\n"]);var pickVertSrc=glslify(["precision highp float;\n\nprecision highp float;\n#define GLSLIFY 1\n\nvec3 getOrthogonalVector(vec3 v) {\n  // Return up-vector for only-z vector.\n  // Return ax + by + cz = 0, a point that lies on the plane that has v as a normal and that isn't (0,0,0).\n  // From the above if-statement we have ||a|| > 0  U  ||b|| > 0.\n  // Assign z = 0, x = -b, y = a:\n  // a*-b + b*a + c*0 = -ba + ba + 0 = 0\n  if (v.x*v.x > v.z*v.z || v.y*v.y > v.z*v.z) {\n    return normalize(vec3(-v.y, v.x, 0.0));\n  } else {\n    return normalize(vec3(0.0, v.z, -v.y));\n  }\n}\n\n// Calculate the cone vertex and normal at the given index.\n//\n// The returned vertex is for a cone with its top at origin and height of 1.0,\n// pointing in the direction of the vector attribute.\n//\n// Each cone is made up of a top vertex, a center base vertex and base perimeter vertices.\n// These vertices are used to make up the triangles of the cone by the following:\n//   segment + 0 top vertex\n//   segment + 1 perimeter vertex a+1\n//   segment + 2 perimeter vertex a\n//   segment + 3 center base vertex\n//   segment + 4 perimeter vertex a\n//   segment + 5 perimeter vertex a+1\n// Where segment is the number of the radial segment * 6 and a is the angle at that radial segment.\n// To go from index to segment, floor(index / 6)\n// To go from segment to angle, 2*pi * (segment/segmentCount)\n// To go from index to segment index, index - (segment*6)\n//\nvec3 getConePosition(vec3 d, float rawIndex, float coneOffset, out vec3 normal) {\n\n  const float segmentCount = 8.0;\n\n  float index = rawIndex - floor(rawIndex /\n    (segmentCount * 6.0)) *\n    (segmentCount * 6.0);\n\n  float segment = floor(0.001 + index/6.0);\n  float segmentIndex = index - (segment*6.0);\n\n  normal = -normalize(d);\n\n  if (segmentIndex > 2.99 && segmentIndex < 3.01) {\n    return mix(vec3(0.0), -d, coneOffset);\n  }\n\n  float nextAngle = (\n    (segmentIndex > 0.99 &&  segmentIndex < 1.01) ||\n    (segmentIndex > 4.99 &&  segmentIndex < 5.01)\n  ) ? 1.0 : 0.0;\n  float angle = 2.0 * 3.14159 * ((segment + nextAngle) / segmentCount);\n\n  vec3 v1 = mix(d, vec3(0.0), coneOffset);\n  vec3 v2 = v1 - d;\n\n  vec3 u = getOrthogonalVector(d);\n  vec3 v = normalize(cross(u, d));\n\n  vec3 x = u * cos(angle) * length(d)*0.25;\n  vec3 y = v * sin(angle) * length(d)*0.25;\n  vec3 v3 = v2 + x + y;\n  if (segmentIndex < 3.0) {\n    vec3 tx = u * sin(angle);\n    vec3 ty = v * -cos(angle);\n    vec3 tangent = tx + ty;\n    normal = normalize(cross(v3 - v1, tangent));\n  }\n\n  if (segmentIndex == 0.0) {\n    return mix(d, vec3(0.0), coneOffset);\n  }\n  return v3;\n}\n\nattribute vec4 vector;\nattribute vec4 position;\nattribute vec4 id;\n\nuniform mat4 model, view, projection;\nuniform float vectorScale, coneScale, coneOffset;\n\nvarying vec3 f_position;\nvarying vec4 f_id;\n\nvoid main() {\n  vec3 normal;\n  vec3 XYZ = getConePosition(mat3(model) * ((vectorScale * coneScale) * vector.xyz), position.w, coneOffset, normal);\n  vec4 conePosition = model * vec4(position.xyz, 1.0) + vec4(XYZ, 0.0);\n  gl_Position = projection * (view * conePosition);\n  f_id        = id;\n  f_position  = position.xyz;\n}\n"]);var pickFragSrc=glslify(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3  clipBounds[2];\nuniform float pickId;\n\nvarying vec3 f_position;\nvarying vec4 f_id;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], f_position)) discard;\n\n  gl_FragColor = vec4(pickId, f_id.xyz);\n}"]);exports.meshShader={vertex:triVertSrc,fragment:triFragSrc,attributes:[{name:'position',type:'vec4'},{name:'color',type:'vec4'},{name:'uv',type:'vec2'},{name:'vector',type:'vec3'}]};exports.pickShader={vertex:pickVertSrc,fragment:pickFragSrc,attributes:[{name:'position',type:'vec4'},{name:'id',type:'vec4'},{name:'vector',type:'vec3'}]};/***/}),/***/737:(/***/function(module){module.exports={0:'NONE',1:'ONE',2:'LINE_LOOP',3:'LINE_STRIP',4:'TRIANGLES',5:'TRIANGLE_STRIP',6:'TRIANGLE_FAN',256:'DEPTH_BUFFER_BIT',512:'NEVER',513:'LESS',514:'EQUAL',515:'LEQUAL',516:'GREATER',517:'NOTEQUAL',518:'GEQUAL',519:'ALWAYS',768:'SRC_COLOR',769:'ONE_MINUS_SRC_COLOR',770:'SRC_ALPHA',771:'ONE_MINUS_SRC_ALPHA',772:'DST_ALPHA',773:'ONE_MINUS_DST_ALPHA',774:'DST_COLOR',775:'ONE_MINUS_DST_COLOR',776:'SRC_ALPHA_SATURATE',1024:'STENCIL_BUFFER_BIT',1028:'FRONT',1029:'BACK',1032:'FRONT_AND_BACK',1280:'INVALID_ENUM',1281:'INVALID_VALUE',1282:'INVALID_OPERATION',1285:'OUT_OF_MEMORY',1286:'INVALID_FRAMEBUFFER_OPERATION',2304:'CW',2305:'CCW',2849:'LINE_WIDTH',2884:'CULL_FACE',2885:'CULL_FACE_MODE',2886:'FRONT_FACE',2928:'DEPTH_RANGE',2929:'DEPTH_TEST',2930:'DEPTH_WRITEMASK',2931:'DEPTH_CLEAR_VALUE',2932:'DEPTH_FUNC',2960:'STENCIL_TEST',2961:'STENCIL_CLEAR_VALUE',2962:'STENCIL_FUNC',2963:'STENCIL_VALUE_MASK',2964:'STENCIL_FAIL',2965:'STENCIL_PASS_DEPTH_FAIL',2966:'STENCIL_PASS_DEPTH_PASS',2967:'STENCIL_REF',2968:'STENCIL_WRITEMASK',2978:'VIEWPORT',3024:'DITHER',3042:'BLEND',3088:'SCISSOR_BOX',3089:'SCISSOR_TEST',3106:'COLOR_CLEAR_VALUE',3107:'COLOR_WRITEMASK',3317:'UNPACK_ALIGNMENT',3333:'PACK_ALIGNMENT',3379:'MAX_TEXTURE_SIZE',3386:'MAX_VIEWPORT_DIMS',3408:'SUBPIXEL_BITS',3410:'RED_BITS',3411:'GREEN_BITS',3412:'BLUE_BITS',3413:'ALPHA_BITS',3414:'DEPTH_BITS',3415:'STENCIL_BITS',3553:'TEXTURE_2D',4352:'DONT_CARE',4353:'FASTEST',4354:'NICEST',5120:'BYTE',5121:'UNSIGNED_BYTE',5122:'SHORT',5123:'UNSIGNED_SHORT',5124:'INT',5125:'UNSIGNED_INT',5126:'FLOAT',5386:'INVERT',5890:'TEXTURE',6401:'STENCIL_INDEX',6402:'DEPTH_COMPONENT',6406:'ALPHA',6407:'RGB',6408:'RGBA',6409:'LUMINANCE',6410:'LUMINANCE_ALPHA',7680:'KEEP',7681:'REPLACE',7682:'INCR',7683:'DECR',7936:'VENDOR',7937:'RENDERER',7938:'VERSION',9728:'NEAREST',9729:'LINEAR',9984:'NEAREST_MIPMAP_NEAREST',9985:'LINEAR_MIPMAP_NEAREST',9986:'NEAREST_MIPMAP_LINEAR',9987:'LINEAR_MIPMAP_LINEAR',10240:'TEXTURE_MAG_FILTER',10241:'TEXTURE_MIN_FILTER',10242:'TEXTURE_WRAP_S',10243:'TEXTURE_WRAP_T',10497:'REPEAT',10752:'POLYGON_OFFSET_UNITS',16384:'COLOR_BUFFER_BIT',32769:'CONSTANT_COLOR',32770:'ONE_MINUS_CONSTANT_COLOR',32771:'CONSTANT_ALPHA',32772:'ONE_MINUS_CONSTANT_ALPHA',32773:'BLEND_COLOR',32774:'FUNC_ADD',32777:'BLEND_EQUATION_RGB',32778:'FUNC_SUBTRACT',32779:'FUNC_REVERSE_SUBTRACT',32819:'UNSIGNED_SHORT_4_4_4_4',32820:'UNSIGNED_SHORT_5_5_5_1',32823:'POLYGON_OFFSET_FILL',32824:'POLYGON_OFFSET_FACTOR',32854:'RGBA4',32855:'RGB5_A1',32873:'TEXTURE_BINDING_2D',32926:'SAMPLE_ALPHA_TO_COVERAGE',32928:'SAMPLE_COVERAGE',32936:'SAMPLE_BUFFERS',32937:'SAMPLES',32938:'SAMPLE_COVERAGE_VALUE',32939:'SAMPLE_COVERAGE_INVERT',32968:'BLEND_DST_RGB',32969:'BLEND_SRC_RGB',32970:'BLEND_DST_ALPHA',32971:'BLEND_SRC_ALPHA',33071:'CLAMP_TO_EDGE',33170:'GENERATE_MIPMAP_HINT',33189:'DEPTH_COMPONENT16',33306:'DEPTH_STENCIL_ATTACHMENT',33635:'UNSIGNED_SHORT_5_6_5',33648:'MIRRORED_REPEAT',33901:'ALIASED_POINT_SIZE_RANGE',33902:'ALIASED_LINE_WIDTH_RANGE',33984:'TEXTURE0',33985:'TEXTURE1',33986:'TEXTURE2',33987:'TEXTURE3',33988:'TEXTURE4',33989:'TEXTURE5',33990:'TEXTURE6',33991:'TEXTURE7',33992:'TEXTURE8',33993:'TEXTURE9',33994:'TEXTURE10',33995:'TEXTURE11',33996:'TEXTURE12',33997:'TEXTURE13',33998:'TEXTURE14',33999:'TEXTURE15',34000:'TEXTURE16',34001:'TEXTURE17',34002:'TEXTURE18',34003:'TEXTURE19',34004:'TEXTURE20',34005:'TEXTURE21',34006:'TEXTURE22',34007:'TEXTURE23',34008:'TEXTURE24',34009:'TEXTURE25',34010:'TEXTURE26',34011:'TEXTURE27',34012:'TEXTURE28',34013:'TEXTURE29',34014:'TEXTURE30',34015:'TEXTURE31',34016:'ACTIVE_TEXTURE',34024:'MAX_RENDERBUFFER_SIZE',34041:'DEPTH_STENCIL',34055:'INCR_WRAP',34056:'DECR_WRAP',34067:'TEXTURE_CUBE_MAP',34068:'TEXTURE_BINDING_CUBE_MAP',34069:'TEXTURE_CUBE_MAP_POSITIVE_X',34070:'TEXTURE_CUBE_MAP_NEGATIVE_X',34071:'TEXTURE_CUBE_MAP_POSITIVE_Y',34072:'TEXTURE_CUBE_MAP_NEGATIVE_Y',34073:'TEXTURE_CUBE_MAP_POSITIVE_Z',34074:'TEXTURE_CUBE_MAP_NEGATIVE_Z',34076:'MAX_CUBE_MAP_TEXTURE_SIZE',34338:'VERTEX_ATTRIB_ARRAY_ENABLED',34339:'VERTEX_ATTRIB_ARRAY_SIZE',34340:'VERTEX_ATTRIB_ARRAY_STRIDE',34341:'VERTEX_ATTRIB_ARRAY_TYPE',34342:'CURRENT_VERTEX_ATTRIB',34373:'VERTEX_ATTRIB_ARRAY_POINTER',34466:'NUM_COMPRESSED_TEXTURE_FORMATS',34467:'COMPRESSED_TEXTURE_FORMATS',34660:'BUFFER_SIZE',34661:'BUFFER_USAGE',34816:'STENCIL_BACK_FUNC',34817:'STENCIL_BACK_FAIL',34818:'STENCIL_BACK_PASS_DEPTH_FAIL',34819:'STENCIL_BACK_PASS_DEPTH_PASS',34877:'BLEND_EQUATION_ALPHA',34921:'MAX_VERTEX_ATTRIBS',34922:'VERTEX_ATTRIB_ARRAY_NORMALIZED',34930:'MAX_TEXTURE_IMAGE_UNITS',34962:'ARRAY_BUFFER',34963:'ELEMENT_ARRAY_BUFFER',34964:'ARRAY_BUFFER_BINDING',34965:'ELEMENT_ARRAY_BUFFER_BINDING',34975:'VERTEX_ATTRIB_ARRAY_BUFFER_BINDING',35040:'STREAM_DRAW',35044:'STATIC_DRAW',35048:'DYNAMIC_DRAW',35632:'FRAGMENT_SHADER',35633:'VERTEX_SHADER',35660:'MAX_VERTEX_TEXTURE_IMAGE_UNITS',35661:'MAX_COMBINED_TEXTURE_IMAGE_UNITS',35663:'SHADER_TYPE',35664:'FLOAT_VEC2',35665:'FLOAT_VEC3',35666:'FLOAT_VEC4',35667:'INT_VEC2',35668:'INT_VEC3',35669:'INT_VEC4',35670:'BOOL',35671:'BOOL_VEC2',35672:'BOOL_VEC3',35673:'BOOL_VEC4',35674:'FLOAT_MAT2',35675:'FLOAT_MAT3',35676:'FLOAT_MAT4',35678:'SAMPLER_2D',35680:'SAMPLER_CUBE',35712:'DELETE_STATUS',35713:'COMPILE_STATUS',35714:'LINK_STATUS',35715:'VALIDATE_STATUS',35716:'INFO_LOG_LENGTH',35717:'ATTACHED_SHADERS',35718:'ACTIVE_UNIFORMS',35719:'ACTIVE_UNIFORM_MAX_LENGTH',35720:'SHADER_SOURCE_LENGTH',35721:'ACTIVE_ATTRIBUTES',35722:'ACTIVE_ATTRIBUTE_MAX_LENGTH',35724:'SHADING_LANGUAGE_VERSION',35725:'CURRENT_PROGRAM',36003:'STENCIL_BACK_REF',36004:'STENCIL_BACK_VALUE_MASK',36005:'STENCIL_BACK_WRITEMASK',36006:'FRAMEBUFFER_BINDING',36007:'RENDERBUFFER_BINDING',36048:'FRAMEBUFFER_ATTACHMENT_OBJECT_TYPE',36049:'FRAMEBUFFER_ATTACHMENT_OBJECT_NAME',36050:'FRAMEBUFFER_ATTACHMENT_TEXTURE_LEVEL',36051:'FRAMEBUFFER_ATTACHMENT_TEXTURE_CUBE_MAP_FACE',36053:'FRAMEBUFFER_COMPLETE',36054:'FRAMEBUFFER_INCOMPLETE_ATTACHMENT',36055:'FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT',36057:'FRAMEBUFFER_INCOMPLETE_DIMENSIONS',36061:'FRAMEBUFFER_UNSUPPORTED',36064:'COLOR_ATTACHMENT0',36096:'DEPTH_ATTACHMENT',36128:'STENCIL_ATTACHMENT',36160:'FRAMEBUFFER',36161:'RENDERBUFFER',36162:'RENDERBUFFER_WIDTH',36163:'RENDERBUFFER_HEIGHT',36164:'RENDERBUFFER_INTERNAL_FORMAT',36168:'STENCIL_INDEX8',36176:'RENDERBUFFER_RED_SIZE',36177:'RENDERBUFFER_GREEN_SIZE',36178:'RENDERBUFFER_BLUE_SIZE',36179:'RENDERBUFFER_ALPHA_SIZE',36180:'RENDERBUFFER_DEPTH_SIZE',36181:'RENDERBUFFER_STENCIL_SIZE',36194:'RGB565',36336:'LOW_FLOAT',36337:'MEDIUM_FLOAT',36338:'HIGH_FLOAT',36339:'LOW_INT',36340:'MEDIUM_INT',36341:'HIGH_INT',36346:'SHADER_COMPILER',36347:'MAX_VERTEX_UNIFORM_VECTORS',36348:'MAX_VARYING_VECTORS',36349:'MAX_FRAGMENT_UNIFORM_VECTORS',37440:'UNPACK_FLIP_Y_WEBGL',37441:'UNPACK_PREMULTIPLY_ALPHA_WEBGL',37442:'CONTEXT_LOST_WEBGL',37443:'UNPACK_COLORSPACE_CONVERSION_WEBGL',37444:'BROWSER_DEFAULT_WEBGL'};/***/}),/***/5171:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_309125__){var gl10=__nested_webpack_require_309125__(737);module.exports=function lookupConstant(number){return gl10[number];};/***/}),/***/9165:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_309314__){"use strict";module.exports=createErrorBars;var createBuffer=__nested_webpack_require_309314__(2762);var createVAO=__nested_webpack_require_309314__(8116);var createShader=__nested_webpack_require_309314__(3436);var IDENTITY=[1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1];function ErrorBars(gl,buffer,vao,shader){this.gl=gl;this.shader=shader;this.buffer=buffer;this.vao=vao;this.pixelRatio=1;this.bounds=[[Infinity,Infinity,Infinity],[-Infinity,-Infinity,-Infinity]];this.clipBounds=[[-Infinity,-Infinity,-Infinity],[Infinity,Infinity,Infinity]];this.lineWidth=[1,1,1];this.capSize=[10,10,10];this.lineCount=[0,0,0];this.lineOffset=[0,0,0];this.opacity=1;this.hasAlpha=false;}var proto=ErrorBars.prototype;proto.isOpaque=function(){return!this.hasAlpha;};proto.isTransparent=function(){return this.hasAlpha;};proto.drawTransparent=proto.draw=function(cameraParams){var gl=this.gl;var uniforms=this.shader.uniforms;this.shader.bind();var view=uniforms.view=cameraParams.view||IDENTITY;var projection=uniforms.projection=cameraParams.projection||IDENTITY;uniforms.model=cameraParams.model||IDENTITY;uniforms.clipBounds=this.clipBounds;uniforms.opacity=this.opacity;var cx=view[12];var cy=view[13];var cz=view[14];var cw=view[15];var isOrtho=cameraParams._ortho||false;var orthoFix=isOrtho?2:1;// double up padding for orthographic ticks & labels
var pixelScaleF=orthoFix*this.pixelRatio*(projection[3]*cx+projection[7]*cy+projection[11]*cz+projection[15]*cw)/gl.drawingBufferHeight;this.vao.bind();for(var i=0;i<3;++i){gl.lineWidth(this.lineWidth[i]*this.pixelRatio);uniforms.capSize=this.capSize[i]*pixelScaleF;if(this.lineCount[i]){gl.drawArrays(gl.LINES,this.lineOffset[i],this.lineCount[i]);}}this.vao.unbind();};function updateBounds(bounds,point){for(var i=0;i<3;++i){bounds[0][i]=Math.min(bounds[0][i],point[i]);bounds[1][i]=Math.max(bounds[1][i],point[i]);}}var FACE_TABLE=function(){var table=new Array(3);for(var d=0;d<3;++d){var row=[];for(var j=1;j<=2;++j){for(var s=-1;s<=1;s+=2){var u=(j+d)%3;var y=[0,0,0];y[u]=s;row.push(y);}}table[d]=row;}return table;}();function emitFace(verts,x,c,d){var offsets=FACE_TABLE[d];for(var i=0;i<offsets.length;++i){var o=offsets[i];verts.push(x[0],x[1],x[2],c[0],c[1],c[2],c[3],o[0],o[1],o[2]);}return offsets.length;}proto.update=function(options){options=options||{};if('lineWidth'in options){this.lineWidth=options.lineWidth;if(!Array.isArray(this.lineWidth)){this.lineWidth=[this.lineWidth,this.lineWidth,this.lineWidth];}}if('capSize'in options){this.capSize=options.capSize;if(!Array.isArray(this.capSize)){this.capSize=[this.capSize,this.capSize,this.capSize];}}this.hasAlpha=false;// default to no transparent draw
if('opacity'in options){this.opacity=+options.opacity;if(this.opacity<1){this.hasAlpha=true;}}var color=options.color||[[0,0,0],[0,0,0],[0,0,0]];var position=options.position;var error=options.error;if(!Array.isArray(color[0])){color=[color,color,color];}if(position&&error){var verts=[];var n=position.length;var vertexCount=0;this.bounds=[[Infinity,Infinity,Infinity],[-Infinity,-Infinity,-Infinity]];this.lineCount=[0,0,0];//Build geometry for lines
for(var j=0;j<3;++j){this.lineOffset[j]=vertexCount;i_loop:for(var i=0;i<n;++i){var p=position[i];for(var k=0;k<3;++k){if(isNaN(p[k])||!isFinite(p[k])){continue i_loop;}}var e=error[i];var c=color[j];if(Array.isArray(c[0])){c=color[i];}if(c.length===3){c=[c[0],c[1],c[2],1];}else if(c.length===4){c=[c[0],c[1],c[2],c[3]];if(!this.hasAlpha&&c[3]<1)this.hasAlpha=true;}if(isNaN(e[0][j])||isNaN(e[1][j])){continue;}if(e[0][j]<0){var x=p.slice();x[j]+=e[0][j];verts.push(p[0],p[1],p[2],c[0],c[1],c[2],c[3],0,0,0,x[0],x[1],x[2],c[0],c[1],c[2],c[3],0,0,0);updateBounds(this.bounds,x);vertexCount+=2+emitFace(verts,x,c,j);}if(e[1][j]>0){var x=p.slice();x[j]+=e[1][j];verts.push(p[0],p[1],p[2],c[0],c[1],c[2],c[3],0,0,0,x[0],x[1],x[2],c[0],c[1],c[2],c[3],0,0,0);updateBounds(this.bounds,x);vertexCount+=2+emitFace(verts,x,c,j);}}this.lineCount[j]=vertexCount-this.lineOffset[j];}this.buffer.update(verts);}};proto.dispose=function(){this.shader.dispose();this.buffer.dispose();this.vao.dispose();};function createErrorBars(options){var gl=options.gl;var buffer=createBuffer(gl);var vao=createVAO(gl,[{buffer:buffer,type:gl.FLOAT,size:3,offset:0,stride:40},{buffer:buffer,type:gl.FLOAT,size:4,offset:12,stride:40},{buffer:buffer,type:gl.FLOAT,size:3,offset:28,stride:40}]);var shader=createShader(gl);shader.attributes.position.location=0;shader.attributes.color.location=1;shader.attributes.offset.location=2;var result=new ErrorBars(gl,buffer,vao,shader);result.update(options);return result;}/***/}),/***/3436:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_313955__){"use strict";var glslify=__nested_webpack_require_313955__(3236);var createShader=__nested_webpack_require_313955__(9405);var vertSrc=glslify(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position, offset;\nattribute vec4 color;\nuniform mat4 model, view, projection;\nuniform float capSize;\nvarying vec4 fragColor;\nvarying vec3 fragPosition;\n\nvoid main() {\n  vec4 worldPosition  = model * vec4(position, 1.0);\n  worldPosition       = (worldPosition / worldPosition.w) + vec4(capSize * offset, 0.0);\n  gl_Position         = projection * (view * worldPosition);\n  fragColor           = color;\n  fragPosition        = position;\n}"]);var fragSrc=glslify(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3 clipBounds[2];\nuniform float opacity;\nvarying vec3 fragPosition;\nvarying vec4 fragColor;\n\nvoid main() {\n  if (\n    outOfRange(clipBounds[0], clipBounds[1], fragPosition) ||\n    fragColor.a * opacity == 0.\n  ) discard;\n\n  gl_FragColor = opacity * fragColor;\n}"]);module.exports=function(gl){return createShader(gl,vertSrc,fragSrc,null,[{name:'position',type:'vec3'},{name:'color',type:'vec4'},{name:'offset',type:'vec3'}]);};/***/}),/***/2260:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_315682__){"use strict";var createTexture=__nested_webpack_require_315682__(7766);module.exports=createFBO;var colorAttachmentArrays=null;var FRAMEBUFFER_UNSUPPORTED;var FRAMEBUFFER_INCOMPLETE_ATTACHMENT;var FRAMEBUFFER_INCOMPLETE_DIMENSIONS;var FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT;function saveFBOState(gl){var fbo=gl.getParameter(gl.FRAMEBUFFER_BINDING);var rbo=gl.getParameter(gl.RENDERBUFFER_BINDING);var tex=gl.getParameter(gl.TEXTURE_BINDING_2D);return[fbo,rbo,tex];}function restoreFBOState(gl,data){gl.bindFramebuffer(gl.FRAMEBUFFER,data[0]);gl.bindRenderbuffer(gl.RENDERBUFFER,data[1]);gl.bindTexture(gl.TEXTURE_2D,data[2]);}function lazyInitColorAttachments(gl,ext){var maxColorAttachments=gl.getParameter(ext.MAX_COLOR_ATTACHMENTS_WEBGL);colorAttachmentArrays=new Array(maxColorAttachments+1);for(var i=0;i<=maxColorAttachments;++i){var x=new Array(maxColorAttachments);for(var j=0;j<i;++j){x[j]=gl.COLOR_ATTACHMENT0+j;}for(var j=i;j<maxColorAttachments;++j){x[j]=gl.NONE;}colorAttachmentArrays[i]=x;}}//Throw an appropriate error
function throwFBOError(status){switch(status){case FRAMEBUFFER_UNSUPPORTED:throw new Error('gl-fbo: Framebuffer unsupported');case FRAMEBUFFER_INCOMPLETE_ATTACHMENT:throw new Error('gl-fbo: Framebuffer incomplete attachment');case FRAMEBUFFER_INCOMPLETE_DIMENSIONS:throw new Error('gl-fbo: Framebuffer incomplete dimensions');case FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT:throw new Error('gl-fbo: Framebuffer incomplete missing attachment');default:throw new Error('gl-fbo: Framebuffer failed for unspecified reason');}}//Initialize a texture object
function initTexture(gl,width,height,type,format,attachment){if(!type){return null;}var result=createTexture(gl,width,height,format,type);result.magFilter=gl.NEAREST;result.minFilter=gl.NEAREST;result.mipSamples=1;result.bind();gl.framebufferTexture2D(gl.FRAMEBUFFER,attachment,gl.TEXTURE_2D,result.handle,0);return result;}//Initialize a render buffer object
function initRenderBuffer(gl,width,height,component,attachment){var result=gl.createRenderbuffer();gl.bindRenderbuffer(gl.RENDERBUFFER,result);gl.renderbufferStorage(gl.RENDERBUFFER,component,width,height);gl.framebufferRenderbuffer(gl.FRAMEBUFFER,attachment,gl.RENDERBUFFER,result);return result;}//Rebuild the frame buffer
function rebuildFBO(fbo){//Save FBO state
var state=saveFBOState(fbo.gl);var gl=fbo.gl;var handle=fbo.handle=gl.createFramebuffer();var width=fbo._shape[0];var height=fbo._shape[1];var numColors=fbo.color.length;var ext=fbo._ext;var useStencil=fbo._useStencil;var useDepth=fbo._useDepth;var colorType=fbo._colorType;//Bind the fbo
gl.bindFramebuffer(gl.FRAMEBUFFER,handle);//Allocate color buffers
for(var i=0;i<numColors;++i){fbo.color[i]=initTexture(gl,width,height,colorType,gl.RGBA,gl.COLOR_ATTACHMENT0+i);}if(numColors===0){fbo._color_rb=initRenderBuffer(gl,width,height,gl.RGBA4,gl.COLOR_ATTACHMENT0);if(ext){ext.drawBuffersWEBGL(colorAttachmentArrays[0]);}}else if(numColors>1){ext.drawBuffersWEBGL(colorAttachmentArrays[numColors]);}//Allocate depth/stencil buffers
var WEBGL_depth_texture=gl.getExtension('WEBGL_depth_texture');if(WEBGL_depth_texture){if(useStencil){fbo.depth=initTexture(gl,width,height,WEBGL_depth_texture.UNSIGNED_INT_24_8_WEBGL,gl.DEPTH_STENCIL,gl.DEPTH_STENCIL_ATTACHMENT);}else if(useDepth){fbo.depth=initTexture(gl,width,height,gl.UNSIGNED_SHORT,gl.DEPTH_COMPONENT,gl.DEPTH_ATTACHMENT);}}else{if(useDepth&&useStencil){fbo._depth_rb=initRenderBuffer(gl,width,height,gl.DEPTH_STENCIL,gl.DEPTH_STENCIL_ATTACHMENT);}else if(useDepth){fbo._depth_rb=initRenderBuffer(gl,width,height,gl.DEPTH_COMPONENT16,gl.DEPTH_ATTACHMENT);}else if(useStencil){fbo._depth_rb=initRenderBuffer(gl,width,height,gl.STENCIL_INDEX,gl.STENCIL_ATTACHMENT);}}//Check frame buffer state
var status=gl.checkFramebufferStatus(gl.FRAMEBUFFER);if(status!==gl.FRAMEBUFFER_COMPLETE){//Release all partially allocated resources
fbo._destroyed=true;//Release all resources
gl.bindFramebuffer(gl.FRAMEBUFFER,null);gl.deleteFramebuffer(fbo.handle);fbo.handle=null;if(fbo.depth){fbo.depth.dispose();fbo.depth=null;}if(fbo._depth_rb){gl.deleteRenderbuffer(fbo._depth_rb);fbo._depth_rb=null;}for(var i=0;i<fbo.color.length;++i){fbo.color[i].dispose();fbo.color[i]=null;}if(fbo._color_rb){gl.deleteRenderbuffer(fbo._color_rb);fbo._color_rb=null;}restoreFBOState(gl,state);//Throw the frame buffer error
throwFBOError(status);}//Everything ok, let's get on with life
restoreFBOState(gl,state);}function Framebuffer(gl,width,height,colorType,numColors,useDepth,useStencil,ext){//Handle and set properties
this.gl=gl;this._shape=[width|0,height|0];this._destroyed=false;this._ext=ext;//Allocate buffers
this.color=new Array(numColors);for(var i=0;i<numColors;++i){this.color[i]=null;}this._color_rb=null;this.depth=null;this._depth_rb=null;//Save depth and stencil flags
this._colorType=colorType;this._useDepth=useDepth;this._useStencil=useStencil;//Shape vector for resizing
var parent=this;var shapeVector=[width|0,height|0];Object.defineProperties(shapeVector,{0:{get:function(){return parent._shape[0];},set:function(w){return parent.width=w;}},1:{get:function(){return parent._shape[1];},set:function(h){return parent.height=h;}}});this._shapeVector=shapeVector;//Initialize all attachments
rebuildFBO(this);}var proto=Framebuffer.prototype;function reshapeFBO(fbo,w,h){//If fbo is invalid, just skip this
if(fbo._destroyed){throw new Error('gl-fbo: Can\'t resize destroyed FBO');}//Don't resize if no change in shape
if(fbo._shape[0]===w&&fbo._shape[1]===h){return;}var gl=fbo.gl;//Check parameter ranges
var maxFBOSize=gl.getParameter(gl.MAX_RENDERBUFFER_SIZE);if(w<0||w>maxFBOSize||h<0||h>maxFBOSize){throw new Error('gl-fbo: Can\'t resize FBO, invalid dimensions');}//Update shape
fbo._shape[0]=w;fbo._shape[1]=h;//Save framebuffer state
var state=saveFBOState(gl);//Resize framebuffer attachments
for(var i=0;i<fbo.color.length;++i){fbo.color[i].shape=fbo._shape;}if(fbo._color_rb){gl.bindRenderbuffer(gl.RENDERBUFFER,fbo._color_rb);gl.renderbufferStorage(gl.RENDERBUFFER,gl.RGBA4,fbo._shape[0],fbo._shape[1]);}if(fbo.depth){fbo.depth.shape=fbo._shape;}if(fbo._depth_rb){gl.bindRenderbuffer(gl.RENDERBUFFER,fbo._depth_rb);if(fbo._useDepth&&fbo._useStencil){gl.renderbufferStorage(gl.RENDERBUFFER,gl.DEPTH_STENCIL,fbo._shape[0],fbo._shape[1]);}else if(fbo._useDepth){gl.renderbufferStorage(gl.RENDERBUFFER,gl.DEPTH_COMPONENT16,fbo._shape[0],fbo._shape[1]);}else if(fbo._useStencil){gl.renderbufferStorage(gl.RENDERBUFFER,gl.STENCIL_INDEX,fbo._shape[0],fbo._shape[1]);}}//Check FBO status after resize, if something broke then die in a fire
gl.bindFramebuffer(gl.FRAMEBUFFER,fbo.handle);var status=gl.checkFramebufferStatus(gl.FRAMEBUFFER);if(status!==gl.FRAMEBUFFER_COMPLETE){fbo.dispose();restoreFBOState(gl,state);throwFBOError(status);}//Restore framebuffer state
restoreFBOState(gl,state);}Object.defineProperties(proto,{'shape':{get:function(){if(this._destroyed){return[0,0];}return this._shapeVector;},set:function(x){if(!Array.isArray(x)){x=[x|0,x|0];}if(x.length!==2){throw new Error('gl-fbo: Shape vector must be length 2');}var w=x[0]|0;var h=x[1]|0;reshapeFBO(this,w,h);return[w,h];},enumerable:false},'width':{get:function(){if(this._destroyed){return 0;}return this._shape[0];},set:function(w){w=w|0;reshapeFBO(this,w,this._shape[1]);return w;},enumerable:false},'height':{get:function(){if(this._destroyed){return 0;}return this._shape[1];},set:function(h){h=h|0;reshapeFBO(this,this._shape[0],h);return h;},enumerable:false}});proto.bind=function(){if(this._destroyed){return;}var gl=this.gl;gl.bindFramebuffer(gl.FRAMEBUFFER,this.handle);gl.viewport(0,0,this._shape[0],this._shape[1]);};proto.dispose=function(){if(this._destroyed){return;}this._destroyed=true;var gl=this.gl;gl.deleteFramebuffer(this.handle);this.handle=null;if(this.depth){this.depth.dispose();this.depth=null;}if(this._depth_rb){gl.deleteRenderbuffer(this._depth_rb);this._depth_rb=null;}for(var i=0;i<this.color.length;++i){this.color[i].dispose();this.color[i]=null;}if(this._color_rb){gl.deleteRenderbuffer(this._color_rb);this._color_rb=null;}};function createFBO(gl,width,height,options){//Update frame buffer error code values
if(!FRAMEBUFFER_UNSUPPORTED){FRAMEBUFFER_UNSUPPORTED=gl.FRAMEBUFFER_UNSUPPORTED;FRAMEBUFFER_INCOMPLETE_ATTACHMENT=gl.FRAMEBUFFER_INCOMPLETE_ATTACHMENT;FRAMEBUFFER_INCOMPLETE_DIMENSIONS=gl.FRAMEBUFFER_INCOMPLETE_DIMENSIONS;FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT=gl.FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT;}//Lazily initialize color attachment arrays
var WEBGL_draw_buffers=gl.getExtension('WEBGL_draw_buffers');if(!colorAttachmentArrays&&WEBGL_draw_buffers){lazyInitColorAttachments(gl,WEBGL_draw_buffers);}//Special case: Can accept an array as argument
if(Array.isArray(width)){options=height;height=width[1]|0;width=width[0]|0;}if(typeof width!=='number'){throw new Error('gl-fbo: Missing shape parameter');}//Validate width/height properties
var maxFBOSize=gl.getParameter(gl.MAX_RENDERBUFFER_SIZE);if(width<0||width>maxFBOSize||height<0||height>maxFBOSize){throw new Error('gl-fbo: Parameters are too large for FBO');}//Handle each option type
options=options||{};//Figure out number of color buffers to use
var numColors=1;if('color'in options){numColors=Math.max(options.color|0,0);if(numColors<0){throw new Error('gl-fbo: Must specify a nonnegative number of colors');}if(numColors>1){//Check if multiple render targets supported
if(!WEBGL_draw_buffers){throw new Error('gl-fbo: Multiple draw buffer extension not supported');}else if(numColors>gl.getParameter(WEBGL_draw_buffers.MAX_COLOR_ATTACHMENTS_WEBGL)){throw new Error('gl-fbo: Context does not support '+numColors+' draw buffers');}}}//Determine whether to use floating point textures
var colorType=gl.UNSIGNED_BYTE;var OES_texture_float=gl.getExtension('OES_texture_float');if(options.float&&numColors>0){if(!OES_texture_float){throw new Error('gl-fbo: Context does not support floating point textures');}colorType=gl.FLOAT;}else if(options.preferFloat&&numColors>0){if(OES_texture_float){colorType=gl.FLOAT;}}//Check if we should use depth buffer
var useDepth=true;if('depth'in options){useDepth=!!options.depth;}//Check if we should use a stencil buffer
var useStencil=false;if('stencil'in options){useStencil=!!options.stencil;}return new Framebuffer(gl,width,height,colorType,numColors,useDepth,useStencil,WEBGL_draw_buffers);}/***/}),/***/2992:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_326144__){var sprintf=__nested_webpack_require_326144__(3387).sprintf;var glConstants=__nested_webpack_require_326144__(5171);var shaderName=__nested_webpack_require_326144__(1848);var addLineNumbers=__nested_webpack_require_326144__(1085);module.exports=formatCompilerError;function formatCompilerError(errLog,src,type){"use strict";var name=shaderName(src)||'of unknown name (see npm glsl-shader-name)';var typeName='unknown type';if(type!==undefined){typeName=type===glConstants.FRAGMENT_SHADER?'fragment':'vertex';}var longForm=sprintf('Error compiling %s shader %s:\n',typeName,name);var shortForm=sprintf("%s%s",longForm,errLog);var errorStrings=errLog.split('\n');var errors={};for(var i=0;i<errorStrings.length;i++){var errorString=errorStrings[i];if(errorString===''||errorString==="\0")continue;var lineNo=parseInt(errorString.split(':')[2]);if(isNaN(lineNo)){throw new Error(sprintf('Could not parse error: %s',errorString));}errors[lineNo]=errorString;}var lines=addLineNumbers(src).split('\n');for(var i=0;i<lines.length;i++){if(!errors[i+3]&&!errors[i+2]&&!errors[i+1])continue;var line=lines[i];longForm+=line+'\n';if(errors[i+1]){var e=errors[i+1];e=e.substr(e.split(':',3).join(':').length+1).trim();longForm+=sprintf('^^^ %s\n\n',e);}}return{long:longForm.trim(),short:shortForm.trim()};}/***/}),/***/2510:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_327470__){"use strict";module.exports=createHeatmap2D;var bsearch=__nested_webpack_require_327470__(2478);var iota=__nested_webpack_require_327470__(7762);var pool=__nested_webpack_require_327470__(1888);var createShader=__nested_webpack_require_327470__(9405);var createBuffer=__nested_webpack_require_327470__(2762);var shaders=__nested_webpack_require_327470__(6768);function GLHeatmap2D(plot,shader,pickShader,positionBuffer,weightBuffer,colorBuffer,idBuffer){this.plot=plot;this.shader=shader;this.pickShader=pickShader;this.positionBuffer=positionBuffer;this.weightBuffer=weightBuffer;this.colorBuffer=colorBuffer;this.idBuffer=idBuffer;this.xData=[];this.yData=[];this.shape=[0,0];this.bounds=[Infinity,Infinity,-Infinity,-Infinity];this.pickOffset=0;}var proto=GLHeatmap2D.prototype;var WEIGHTS=[0,0,1,0,0,1,1,0,1,1,0,1];proto.draw=function(){var MATRIX=[1,0,0,0,1,0,0,0,1];return function(){var plot=this.plot;var shader=this.shader;var bounds=this.bounds;var numVertices=this.numVertices;if(numVertices<=0){return;}var gl=plot.gl;var dataBox=plot.dataBox;var boundX=bounds[2]-bounds[0];var boundY=bounds[3]-bounds[1];var dataX=dataBox[2]-dataBox[0];var dataY=dataBox[3]-dataBox[1];MATRIX[0]=2.0*boundX/dataX;MATRIX[4]=2.0*boundY/dataY;MATRIX[6]=2.0*(bounds[0]-dataBox[0])/dataX-1.0;MATRIX[7]=2.0*(bounds[1]-dataBox[1])/dataY-1.0;shader.bind();var uniforms=shader.uniforms;uniforms.viewTransform=MATRIX;uniforms.shape=this.shape;var attributes=shader.attributes;this.positionBuffer.bind();attributes.position.pointer();this.weightBuffer.bind();attributes.weight.pointer(gl.UNSIGNED_BYTE,false);this.colorBuffer.bind();attributes.color.pointer(gl.UNSIGNED_BYTE,true);gl.drawArrays(gl.TRIANGLES,0,numVertices);};}();proto.drawPick=function(){var MATRIX=[1,0,0,0,1,0,0,0,1];var PICK_VECTOR=[0,0,0,0];return function(pickOffset){var plot=this.plot;var shader=this.pickShader;var bounds=this.bounds;var numVertices=this.numVertices;if(numVertices<=0){return;}var gl=plot.gl;var dataBox=plot.dataBox;var boundX=bounds[2]-bounds[0];var boundY=bounds[3]-bounds[1];var dataX=dataBox[2]-dataBox[0];var dataY=dataBox[3]-dataBox[1];MATRIX[0]=2.0*boundX/dataX;MATRIX[4]=2.0*boundY/dataY;MATRIX[6]=2.0*(bounds[0]-dataBox[0])/dataX-1.0;MATRIX[7]=2.0*(bounds[1]-dataBox[1])/dataY-1.0;for(var i=0;i<4;++i){PICK_VECTOR[i]=pickOffset>>i*8&0xff;}this.pickOffset=pickOffset;shader.bind();var uniforms=shader.uniforms;uniforms.viewTransform=MATRIX;uniforms.pickOffset=PICK_VECTOR;uniforms.shape=this.shape;var attributes=shader.attributes;this.positionBuffer.bind();attributes.position.pointer();this.weightBuffer.bind();attributes.weight.pointer(gl.UNSIGNED_BYTE,false);this.idBuffer.bind();attributes.pickId.pointer(gl.UNSIGNED_BYTE,false);gl.drawArrays(gl.TRIANGLES,0,numVertices);return pickOffset+this.shape[0]*this.shape[1];};}();proto.pick=function(x,y,value){var pickOffset=this.pickOffset;var pointCount=this.shape[0]*this.shape[1];if(value<pickOffset||value>=pickOffset+pointCount){return null;}var pointId=value-pickOffset;var xData=this.xData;var yData=this.yData;return{object:this,pointId:pointId,dataCoord:[xData[pointId%this.shape[0]],yData[pointId/this.shape[0]|0]]};};proto.update=function(options){options=options||{};var shape=options.shape||[0,0];var x=options.x||iota(shape[0]);var y=options.y||iota(shape[1]);var z=options.z||new Float32Array(shape[0]*shape[1]);var isSmooth=options.zsmooth!==false;this.xData=x;this.yData=y;var colorLevels=options.colorLevels||[0];var colorValues=options.colorValues||[0,0,0,1];var colorCount=colorLevels.length;var bounds=this.bounds;var lox,loy,hix,hiy;if(isSmooth){lox=bounds[0]=x[0];loy=bounds[1]=y[0];hix=bounds[2]=x[x.length-1];hiy=bounds[3]=y[y.length-1];}else{// To get squares to centre on data values
lox=bounds[0]=x[0]+(x[1]-x[0])/2;// starting x value
loy=bounds[1]=y[0]+(y[1]-y[0])/2;// starting y value
// Bounds needs to add half a square on each end
hix=bounds[2]=x[x.length-1]+(x[x.length-1]-x[x.length-2])/2;hiy=bounds[3]=y[y.length-1]+(y[y.length-1]-y[y.length-2])/2;// N.B. Resolution = 1 / range
}var xs=1.0/(hix-lox);var ys=1.0/(hiy-loy);var numX=shape[0];var numY=shape[1];this.shape=[numX,numY];var numVerts=(isSmooth?(numX-1)*(numY-1):numX*numY)*(WEIGHTS.length>>>1);this.numVertices=numVerts;var colors=pool.mallocUint8(numVerts*4);var positions=pool.mallocFloat32(numVerts*2);var weights=pool.mallocUint8(numVerts*2);var ids=pool.mallocUint32(numVerts);var ptr=0;var ni=isSmooth?numX-1:numX;var nj=isSmooth?numY-1:numY;for(var j=0;j<nj;++j){var yc0,yc1;if(isSmooth){yc0=ys*(y[j]-loy);yc1=ys*(y[j+1]-loy);}else{yc0=j<numY-1?ys*(y[j]-(y[j+1]-y[j])/2-loy):ys*(y[j]-(y[j]-y[j-1])/2-loy);yc1=j<numY-1?ys*(y[j]+(y[j+1]-y[j])/2-loy):ys*(y[j]+(y[j]-y[j-1])/2-loy);}for(var i=0;i<ni;++i){var xc0,xc1;if(isSmooth){xc0=xs*(x[i]-lox);xc1=xs*(x[i+1]-lox);}else{xc0=i<numX-1?xs*(x[i]-(x[i+1]-x[i])/2-lox):xs*(x[i]-(x[i]-x[i-1])/2-lox);xc1=i<numX-1?xs*(x[i]+(x[i+1]-x[i])/2-lox):xs*(x[i]+(x[i]-x[i-1])/2-lox);}for(var dd=0;dd<WEIGHTS.length;dd+=2){var dx=WEIGHTS[dd];var dy=WEIGHTS[dd+1];var offset=isSmooth?(j+dy)*numX+(i+dx):j*numX+i;var zc=z[offset];var colorIdx=bsearch.le(colorLevels,zc);var r,g,b,a;if(colorIdx<0){r=colorValues[0];g=colorValues[1];b=colorValues[2];a=colorValues[3];}else if(colorIdx===colorCount-1){r=colorValues[4*colorCount-4];g=colorValues[4*colorCount-3];b=colorValues[4*colorCount-2];a=colorValues[4*colorCount-1];}else{var t=(zc-colorLevels[colorIdx])/(colorLevels[colorIdx+1]-colorLevels[colorIdx]);var ti=1.0-t;var i0=4*colorIdx;var i1=4*(colorIdx+1);r=ti*colorValues[i0]+t*colorValues[i1];g=ti*colorValues[i0+1]+t*colorValues[i1+1];b=ti*colorValues[i0+2]+t*colorValues[i1+2];a=ti*colorValues[i0+3]+t*colorValues[i1+3];}colors[4*ptr]=255*r;colors[4*ptr+1]=255*g;colors[4*ptr+2]=255*b;colors[4*ptr+3]=255*a;positions[2*ptr]=xc0*.5+xc1*.5;positions[2*ptr+1]=yc0*.5+yc1*.5;weights[2*ptr]=dx;weights[2*ptr+1]=dy;ids[ptr]=j*numX+i;ptr+=1;}}}this.positionBuffer.update(positions);this.weightBuffer.update(weights);this.colorBuffer.update(colors);this.idBuffer.update(ids);pool.free(positions);pool.free(colors);pool.free(weights);pool.free(ids);};proto.dispose=function(){this.shader.dispose();this.pickShader.dispose();this.positionBuffer.dispose();this.weightBuffer.dispose();this.colorBuffer.dispose();this.idBuffer.dispose();this.plot.removeObject(this);};function createHeatmap2D(plot,options){var gl=plot.gl;var shader=createShader(gl,shaders.vertex,shaders.fragment);var pickShader=createShader(gl,shaders.pickVertex,shaders.pickFragment);var positionBuffer=createBuffer(gl);var weightBuffer=createBuffer(gl);var colorBuffer=createBuffer(gl);var idBuffer=createBuffer(gl);var heatmap=new GLHeatmap2D(plot,shader,pickShader,positionBuffer,weightBuffer,colorBuffer,idBuffer);heatmap.update(options);plot.addObject(heatmap);return heatmap;}/***/}),/***/6768:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_334288__){"use strict";var glslify=__nested_webpack_require_334288__(3236);module.exports={fragment:glslify(["precision lowp float;\n#define GLSLIFY 1\nvarying vec4 fragColor;\nvoid main() {\n  gl_FragColor = vec4(fragColor.rgb * fragColor.a, fragColor.a);\n}\n"]),vertex:glslify(["precision mediump float;\n#define GLSLIFY 1\n\nattribute vec2 position;\nattribute vec4 color;\nattribute vec2 weight;\n\nuniform vec2 shape;\nuniform mat3 viewTransform;\n\nvarying vec4 fragColor;\n\nvoid main() {\n  vec3 vPosition = viewTransform * vec3( position + (weight-.5)/(shape-1.) , 1.0);\n  fragColor = color;\n  gl_Position = vec4(vPosition.xy, 0, vPosition.z);\n}\n"]),pickFragment:glslify(["precision mediump float;\n#define GLSLIFY 1\n\nvarying vec4 fragId;\nvarying vec2 vWeight;\n\nuniform vec2 shape;\nuniform vec4 pickOffset;\n\nvoid main() {\n  vec2 d = step(.5, vWeight);\n  vec4 id = fragId + pickOffset;\n  id.x += d.x + d.y*shape.x;\n\n  id.y += floor(id.x / 256.0);\n  id.x -= floor(id.x / 256.0) * 256.0;\n\n  id.z += floor(id.y / 256.0);\n  id.y -= floor(id.y / 256.0) * 256.0;\n\n  id.w += floor(id.z / 256.0);\n  id.z -= floor(id.z / 256.0) * 256.0;\n\n  gl_FragColor = id/255.;\n}\n"]),pickVertex:glslify(["precision mediump float;\n#define GLSLIFY 1\n\nattribute vec2 position;\nattribute vec4 pickId;\nattribute vec2 weight;\n\nuniform vec2 shape;\nuniform mat3 viewTransform;\n\nvarying vec4 fragId;\nvarying vec2 vWeight;\n\nvoid main() {\n  vWeight = weight;\n\n  fragId = pickId;\n\n  vec3 vPosition = viewTransform * vec3( position + (weight-.5)/(shape-1.) , 1.0);\n  gl_Position = vec4(vPosition.xy, 0, vPosition.z);\n}\n"])};/***/}),/***/7319:(/***/function(__unused_webpack_module,exports,__nested_webpack_require_335996__){var glslify=__nested_webpack_require_335996__(3236);var createShader=__nested_webpack_require_335996__(9405);var vertSrc=glslify(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position, nextPosition;\nattribute float arcLength, lineWidth;\nattribute vec4 color;\n\nuniform vec2 screenShape;\nuniform float pixelRatio;\nuniform mat4 model, view, projection;\n\nvarying vec4 fragColor;\nvarying vec3 worldPosition;\nvarying float pixelArcLength;\n\nvec4 project(vec3 p) {\n  return projection * (view * (model * vec4(p, 1.0)));\n}\n\nvoid main() {\n  vec4 startPoint = project(position);\n  vec4 endPoint   = project(nextPosition);\n\n  vec2 A = startPoint.xy / startPoint.w;\n  vec2 B =   endPoint.xy /   endPoint.w;\n\n  float clipAngle = atan(\n    (B.y - A.y) * screenShape.y,\n    (B.x - A.x) * screenShape.x\n  );\n\n  vec2 offset = 0.5 * pixelRatio * lineWidth * vec2(\n    sin(clipAngle),\n    -cos(clipAngle)\n  ) / screenShape;\n\n  gl_Position = vec4(startPoint.xy + startPoint.w * offset, startPoint.zw);\n\n  worldPosition = position;\n  pixelArcLength = arcLength;\n  fragColor = color;\n}\n"]);var forwardFrag=glslify(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3      clipBounds[2];\nuniform sampler2D dashTexture;\nuniform float     dashScale;\nuniform float     opacity;\n\nvarying vec3    worldPosition;\nvarying float   pixelArcLength;\nvarying vec4    fragColor;\n\nvoid main() {\n  if (\n    outOfRange(clipBounds[0], clipBounds[1], worldPosition) ||\n    fragColor.a * opacity == 0.\n  ) discard;\n\n  float dashWeight = texture2D(dashTexture, vec2(dashScale * pixelArcLength, 0)).r;\n  if(dashWeight < 0.5) {\n    discard;\n  }\n  gl_FragColor = fragColor * opacity;\n}\n"]);var pickFrag=glslify(["precision highp float;\n#define GLSLIFY 1\n\n#define FLOAT_MAX  1.70141184e38\n#define FLOAT_MIN  1.17549435e-38\n\n// https://github.com/mikolalysenko/glsl-read-float/blob/master/index.glsl\nvec4 packFloat(float v) {\n  float av = abs(v);\n\n  //Handle special cases\n  if(av < FLOAT_MIN) {\n    return vec4(0.0, 0.0, 0.0, 0.0);\n  } else if(v > FLOAT_MAX) {\n    return vec4(127.0, 128.0, 0.0, 0.0) / 255.0;\n  } else if(v < -FLOAT_MAX) {\n    return vec4(255.0, 128.0, 0.0, 0.0) / 255.0;\n  }\n\n  vec4 c = vec4(0,0,0,0);\n\n  //Compute exponent and mantissa\n  float e = floor(log2(av));\n  float m = av * pow(2.0, -e) - 1.0;\n\n  //Unpack mantissa\n  c[1] = floor(128.0 * m);\n  m -= c[1] / 128.0;\n  c[2] = floor(32768.0 * m);\n  m -= c[2] / 32768.0;\n  c[3] = floor(8388608.0 * m);\n\n  //Unpack exponent\n  float ebias = e + 127.0;\n  c[0] = floor(ebias / 2.0);\n  ebias -= c[0] * 2.0;\n  c[1] += floor(ebias) * 128.0;\n\n  //Unpack sign bit\n  c[0] += 128.0 * step(0.0, -v);\n\n  //Scale back to range\n  return c / 255.0;\n}\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform float pickId;\nuniform vec3 clipBounds[2];\n\nvarying vec3 worldPosition;\nvarying float pixelArcLength;\nvarying vec4 fragColor;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], worldPosition)) discard;\n\n  gl_FragColor = vec4(pickId/255.0, packFloat(pixelArcLength).xyz);\n}"]);var ATTRIBUTES=[{name:'position',type:'vec3'},{name:'nextPosition',type:'vec3'},{name:'arcLength',type:'float'},{name:'lineWidth',type:'float'},{name:'color',type:'vec4'}];exports.createShader=function(gl){return createShader(gl,vertSrc,forwardFrag,null,ATTRIBUTES);};exports.createPickShader=function(gl){return createShader(gl,vertSrc,pickFrag,null,ATTRIBUTES);};/***/}),/***/5714:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_340503__){"use strict";module.exports=createLinePlot;var createBuffer=__nested_webpack_require_340503__(2762);var createVAO=__nested_webpack_require_340503__(8116);var createTexture=__nested_webpack_require_340503__(7766);var UINT8_VIEW=new Uint8Array(4);var FLOAT_VIEW=new Float32Array(UINT8_VIEW.buffer);// https://github.com/mikolalysenko/glsl-read-float/blob/master/index.js
function unpackFloat(x,y,z,w){UINT8_VIEW[0]=w;UINT8_VIEW[1]=z;UINT8_VIEW[2]=y;UINT8_VIEW[3]=x;return FLOAT_VIEW[0];}var bsearch=__nested_webpack_require_340503__(2478);var ndarray=__nested_webpack_require_340503__(9618);var shaders=__nested_webpack_require_340503__(7319);var createShader=shaders.createShader;var createPickShader=shaders.createPickShader;var identity=[1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1];function distance(a,b){var s=0.0;for(var i=0;i<3;++i){var d=a[i]-b[i];s+=d*d;}return Math.sqrt(s);}function filterClipBounds(bounds){var result=[[-1e6,-1e6,-1e6],[1e6,1e6,1e6]];for(var i=0;i<3;++i){result[0][i]=Math.max(bounds[0][i],result[0][i]);result[1][i]=Math.min(bounds[1][i],result[1][i]);}return result;}function PickResult(tau,position,index,dataCoordinate){this.arcLength=tau;this.position=position;this.index=index;this.dataCoordinate=dataCoordinate;}function LinePlot(gl,shader,pickShader,buffer,vao,texture){this.gl=gl;this.shader=shader;this.pickShader=pickShader;this.buffer=buffer;this.vao=vao;this.clipBounds=[[-Infinity,-Infinity,-Infinity],[Infinity,Infinity,Infinity]];this.points=[];this.arcLength=[];this.vertexCount=0;this.bounds=[[0,0,0],[0,0,0]];this.pickId=0;this.lineWidth=1;this.texture=texture;this.dashScale=1;this.opacity=1;this.hasAlpha=false;this.dirty=true;this.pixelRatio=1;}var proto=LinePlot.prototype;proto.isTransparent=function(){return this.hasAlpha;};proto.isOpaque=function(){return!this.hasAlpha;};proto.pickSlots=1;proto.setPickBase=function(id){this.pickId=id;};proto.drawTransparent=proto.draw=function(camera){if(!this.vertexCount)return;var gl=this.gl;var shader=this.shader;var vao=this.vao;shader.bind();shader.uniforms={model:camera.model||identity,view:camera.view||identity,projection:camera.projection||identity,clipBounds:filterClipBounds(this.clipBounds),dashTexture:this.texture.bind(),dashScale:this.dashScale/this.arcLength[this.arcLength.length-1],opacity:this.opacity,screenShape:[gl.drawingBufferWidth,gl.drawingBufferHeight],pixelRatio:this.pixelRatio};vao.bind();vao.draw(gl.TRIANGLE_STRIP,this.vertexCount);vao.unbind();};proto.drawPick=function(camera){if(!this.vertexCount)return;var gl=this.gl;var shader=this.pickShader;var vao=this.vao;shader.bind();shader.uniforms={model:camera.model||identity,view:camera.view||identity,projection:camera.projection||identity,pickId:this.pickId,clipBounds:filterClipBounds(this.clipBounds),screenShape:[gl.drawingBufferWidth,gl.drawingBufferHeight],pixelRatio:this.pixelRatio};vao.bind();vao.draw(gl.TRIANGLE_STRIP,this.vertexCount);vao.unbind();};proto.update=function(options){var i,j;this.dirty=true;var connectGaps=!!options.connectGaps;if('dashScale'in options){this.dashScale=options.dashScale;}this.hasAlpha=false;// default to no transparent draw
if('opacity'in options){this.opacity=+options.opacity;if(this.opacity<1){this.hasAlpha=true;}}// Recalculate buffer data
var buffer=[];var arcLengthArray=[];var pointArray=[];var arcLength=0.0;var vertexCount=0;var bounds=[[Infinity,Infinity,Infinity],[-Infinity,-Infinity,-Infinity]];var positions=options.position||options.positions;if(positions){// Default color
var colors=options.color||options.colors||[0,0,0,1];var lineWidth=options.lineWidth||1;var hadGap=false;fill_loop:for(i=1;i<positions.length;++i){var a=positions[i-1];var b=positions[i];arcLengthArray.push(arcLength);pointArray.push(a.slice());for(j=0;j<3;++j){if(isNaN(a[j])||isNaN(b[j])||!isFinite(a[j])||!isFinite(b[j])){if(!connectGaps&&buffer.length>0){for(var k=0;k<24;++k){buffer.push(buffer[buffer.length-12]);}vertexCount+=2;hadGap=true;}continue fill_loop;}bounds[0][j]=Math.min(bounds[0][j],a[j],b[j]);bounds[1][j]=Math.max(bounds[1][j],a[j],b[j]);}var acolor,bcolor;if(Array.isArray(colors[0])){acolor=colors.length>i-1?colors[i-1]:// using index value
colors.length>0?colors[colors.length-1]:// using last item
[0,0,0,1];// using black
bcolor=colors.length>i?colors[i]:// using index value
colors.length>0?colors[colors.length-1]:// using last item
[0,0,0,1];// using black
}else{acolor=bcolor=colors;}if(acolor.length===3){acolor=[acolor[0],acolor[1],acolor[2],1];}if(bcolor.length===3){bcolor=[bcolor[0],bcolor[1],bcolor[2],1];}if(!this.hasAlpha&&acolor[3]<1)this.hasAlpha=true;var w0;if(Array.isArray(lineWidth)){w0=lineWidth.length>i-1?lineWidth[i-1]:// using index value
lineWidth.length>0?lineWidth[lineWidth.length-1]:// using last item
[0,0,0,1];// using black
}else{w0=lineWidth;}var t0=arcLength;arcLength+=distance(a,b);if(hadGap){for(j=0;j<2;++j){buffer.push(a[0],a[1],a[2],b[0],b[1],b[2],t0,w0,acolor[0],acolor[1],acolor[2],acolor[3]);}vertexCount+=2;hadGap=false;}buffer.push(a[0],a[1],a[2],b[0],b[1],b[2],t0,w0,acolor[0],acolor[1],acolor[2],acolor[3],a[0],a[1],a[2],b[0],b[1],b[2],t0,-w0,acolor[0],acolor[1],acolor[2],acolor[3],b[0],b[1],b[2],a[0],a[1],a[2],arcLength,-w0,bcolor[0],bcolor[1],bcolor[2],bcolor[3],b[0],b[1],b[2],a[0],a[1],a[2],arcLength,w0,bcolor[0],bcolor[1],bcolor[2],bcolor[3]);vertexCount+=4;}}this.buffer.update(buffer);arcLengthArray.push(arcLength);pointArray.push(positions[positions.length-1].slice());this.bounds=bounds;this.vertexCount=vertexCount;this.points=pointArray;this.arcLength=arcLengthArray;if('dashes'in options){var dashArray=options.dashes;// Calculate prefix sum
var prefixSum=dashArray.slice();prefixSum.unshift(0);for(i=1;i<prefixSum.length;++i){prefixSum[i]=prefixSum[i-1]+prefixSum[i];}var dashTexture=ndarray(new Array(256*4),[256,1,4]);for(i=0;i<256;++i){for(j=0;j<4;++j){dashTexture.set(i,0,j,0);}if(bsearch.le(prefixSum,prefixSum[prefixSum.length-1]*i/255.0)&1){dashTexture.set(i,0,0,0);}else{dashTexture.set(i,0,0,255);}}this.texture.setPixels(dashTexture);}};proto.dispose=function(){this.shader.dispose();this.vao.dispose();this.buffer.dispose();};proto.pick=function(selection){if(!selection){return null;}if(selection.id!==this.pickId){return null;}var tau=unpackFloat(selection.value[0],selection.value[1],selection.value[2],0);var index=bsearch.le(this.arcLength,tau);if(index<0){return null;}if(index===this.arcLength.length-1){return new PickResult(this.arcLength[this.arcLength.length-1],this.points[this.points.length-1].slice(),index);}var a=this.points[index];var b=this.points[Math.min(index+1,this.points.length-1)];var t=(tau-this.arcLength[index])/(this.arcLength[index+1]-this.arcLength[index]);var ti=1.0-t;var x=[0,0,0];for(var i=0;i<3;++i){x[i]=ti*a[i]+t*b[i];}var dataIndex=Math.min(t<0.5?index:index+1,this.points.length-1);return new PickResult(tau,x,dataIndex,this.points[dataIndex]);};function createLinePlot(options){var gl=options.gl||options.scene&&options.scene.gl;var shader=createShader(gl);shader.attributes.position.location=0;shader.attributes.nextPosition.location=1;shader.attributes.arcLength.location=2;shader.attributes.lineWidth.location=3;shader.attributes.color.location=4;var pickShader=createPickShader(gl);pickShader.attributes.position.location=0;pickShader.attributes.nextPosition.location=1;pickShader.attributes.arcLength.location=2;pickShader.attributes.lineWidth.location=3;pickShader.attributes.color.location=4;var buffer=createBuffer(gl);var vao=createVAO(gl,[{'buffer':buffer,'size':3,'offset':0,'stride':48},{'buffer':buffer,'size':3,'offset':12,'stride':48},{'buffer':buffer,'size':1,'offset':24,'stride':48},{'buffer':buffer,'size':1,'offset':28,'stride':48},{'buffer':buffer,'size':4,'offset':32,'stride':48}]);// Create texture for dash pattern
var defaultTexture=ndarray(new Array(256*4),[256,1,4]);for(var i=0;i<256*4;++i){defaultTexture.data[i]=255;}var texture=createTexture(gl,defaultTexture);texture.wrap=gl.REPEAT;var linePlot=new LinePlot(gl,shader,pickShader,buffer,vao,texture);linePlot.update(options);return linePlot;}/***/}),/***/1903:(/***/function(module){module.exports=clone;/**
 * Creates a new mat4 initialized with values from an existing matrix
 *
 * @param {mat4} a matrix to clone
 * @returns {mat4} a new 4x4 matrix
 */function clone(a){var out=new Float32Array(16);out[0]=a[0];out[1]=a[1];out[2]=a[2];out[3]=a[3];out[4]=a[4];out[5]=a[5];out[6]=a[6];out[7]=a[7];out[8]=a[8];out[9]=a[9];out[10]=a[10];out[11]=a[11];out[12]=a[12];out[13]=a[13];out[14]=a[14];out[15]=a[15];return out;};/***/}),/***/6864:(/***/function(module){module.exports=create;/**
 * Creates a new identity mat4
 *
 * @returns {mat4} a new 4x4 matrix
 */function create(){var out=new Float32Array(16);out[0]=1;out[1]=0;out[2]=0;out[3]=0;out[4]=0;out[5]=1;out[6]=0;out[7]=0;out[8]=0;out[9]=0;out[10]=1;out[11]=0;out[12]=0;out[13]=0;out[14]=0;out[15]=1;return out;};/***/}),/***/9921:(/***/function(module){module.exports=determinant;/**
 * Calculates the determinant of a mat4
 *
 * @param {mat4} a the source matrix
 * @returns {Number} determinant of a
 */function determinant(a){var a00=a[0],a01=a[1],a02=a[2],a03=a[3],a10=a[4],a11=a[5],a12=a[6],a13=a[7],a20=a[8],a21=a[9],a22=a[10],a23=a[11],a30=a[12],a31=a[13],a32=a[14],a33=a[15],b00=a00*a11-a01*a10,b01=a00*a12-a02*a10,b02=a00*a13-a03*a10,b03=a01*a12-a02*a11,b04=a01*a13-a03*a11,b05=a02*a13-a03*a12,b06=a20*a31-a21*a30,b07=a20*a32-a22*a30,b08=a20*a33-a23*a30,b09=a21*a32-a22*a31,b10=a21*a33-a23*a31,b11=a22*a33-a23*a32;// Calculate the determinant
return b00*b11-b01*b10+b02*b09+b03*b08-b04*b07+b05*b06;};/***/}),/***/7399:(/***/function(module){module.exports=fromQuat;/**
 * Creates a matrix from a quaternion rotation.
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {quat4} q Rotation quaternion
 * @returns {mat4} out
 */function fromQuat(out,q){var x=q[0],y=q[1],z=q[2],w=q[3],x2=x+x,y2=y+y,z2=z+z,xx=x*x2,yx=y*x2,yy=y*y2,zx=z*x2,zy=z*y2,zz=z*z2,wx=w*x2,wy=w*y2,wz=w*z2;out[0]=1-yy-zz;out[1]=yx+wz;out[2]=zx-wy;out[3]=0;out[4]=yx-wz;out[5]=1-xx-zz;out[6]=zy+wx;out[7]=0;out[8]=zx+wy;out[9]=zy-wx;out[10]=1-xx-yy;out[11]=0;out[12]=0;out[13]=0;out[14]=0;out[15]=1;return out;};/***/}),/***/6743:(/***/function(module){module.exports=fromRotationTranslation;/**
 * Creates a matrix from a quaternion rotation and vector translation
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.translate(dest, vec);
 *     var quatMat = mat4.create();
 *     quat4.toMat4(quat, quatMat);
 *     mat4.multiply(dest, quatMat);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {quat4} q Rotation quaternion
 * @param {vec3} v Translation vector
 * @returns {mat4} out
 */function fromRotationTranslation(out,q,v){// Quaternion math
var x=q[0],y=q[1],z=q[2],w=q[3],x2=x+x,y2=y+y,z2=z+z,xx=x*x2,xy=x*y2,xz=x*z2,yy=y*y2,yz=y*z2,zz=z*z2,wx=w*x2,wy=w*y2,wz=w*z2;out[0]=1-(yy+zz);out[1]=xy+wz;out[2]=xz-wy;out[3]=0;out[4]=xy-wz;out[5]=1-(xx+zz);out[6]=yz+wx;out[7]=0;out[8]=xz+wy;out[9]=yz-wx;out[10]=1-(xx+yy);out[11]=0;out[12]=v[0];out[13]=v[1];out[14]=v[2];out[15]=1;return out;};/***/}),/***/7894:(/***/function(module){module.exports=identity;/**
 * Set a mat4 to the identity matrix
 *
 * @param {mat4} out the receiving matrix
 * @returns {mat4} out
 */function identity(out){out[0]=1;out[1]=0;out[2]=0;out[3]=0;out[4]=0;out[5]=1;out[6]=0;out[7]=0;out[8]=0;out[9]=0;out[10]=1;out[11]=0;out[12]=0;out[13]=0;out[14]=0;out[15]=1;return out;};/***/}),/***/7608:(/***/function(module){module.exports=invert;/**
 * Inverts a mat4
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the source matrix
 * @returns {mat4} out
 */function invert(out,a){var a00=a[0],a01=a[1],a02=a[2],a03=a[3],a10=a[4],a11=a[5],a12=a[6],a13=a[7],a20=a[8],a21=a[9],a22=a[10],a23=a[11],a30=a[12],a31=a[13],a32=a[14],a33=a[15],b00=a00*a11-a01*a10,b01=a00*a12-a02*a10,b02=a00*a13-a03*a10,b03=a01*a12-a02*a11,b04=a01*a13-a03*a11,b05=a02*a13-a03*a12,b06=a20*a31-a21*a30,b07=a20*a32-a22*a30,b08=a20*a33-a23*a30,b09=a21*a32-a22*a31,b10=a21*a33-a23*a31,b11=a22*a33-a23*a32,// Calculate the determinant
det=b00*b11-b01*b10+b02*b09+b03*b08-b04*b07+b05*b06;if(!det){return null;}det=1.0/det;out[0]=(a11*b11-a12*b10+a13*b09)*det;out[1]=(a02*b10-a01*b11-a03*b09)*det;out[2]=(a31*b05-a32*b04+a33*b03)*det;out[3]=(a22*b04-a21*b05-a23*b03)*det;out[4]=(a12*b08-a10*b11-a13*b07)*det;out[5]=(a00*b11-a02*b08+a03*b07)*det;out[6]=(a32*b02-a30*b05-a33*b01)*det;out[7]=(a20*b05-a22*b02+a23*b01)*det;out[8]=(a10*b10-a11*b08+a13*b06)*det;out[9]=(a01*b08-a00*b10-a03*b06)*det;out[10]=(a30*b04-a31*b02+a33*b00)*det;out[11]=(a21*b02-a20*b04-a23*b00)*det;out[12]=(a11*b07-a10*b09-a12*b06)*det;out[13]=(a00*b09-a01*b07+a02*b06)*det;out[14]=(a31*b01-a30*b03-a32*b00)*det;out[15]=(a20*b03-a21*b01+a22*b00)*det;return out;};/***/}),/***/6582:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_353332__){var identity=__nested_webpack_require_353332__(7894);module.exports=lookAt;/**
 * Generates a look-at matrix with the given eye position, focal point, and up axis
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {vec3} eye Position of the viewer
 * @param {vec3} center Point the viewer is looking at
 * @param {vec3} up vec3 pointing up
 * @returns {mat4} out
 */function lookAt(out,eye,center,up){var x0,x1,x2,y0,y1,y2,z0,z1,z2,len,eyex=eye[0],eyey=eye[1],eyez=eye[2],upx=up[0],upy=up[1],upz=up[2],centerx=center[0],centery=center[1],centerz=center[2];if(Math.abs(eyex-centerx)<0.000001&&Math.abs(eyey-centery)<0.000001&&Math.abs(eyez-centerz)<0.000001){return identity(out);}z0=eyex-centerx;z1=eyey-centery;z2=eyez-centerz;len=1/Math.sqrt(z0*z0+z1*z1+z2*z2);z0*=len;z1*=len;z2*=len;x0=upy*z2-upz*z1;x1=upz*z0-upx*z2;x2=upx*z1-upy*z0;len=Math.sqrt(x0*x0+x1*x1+x2*x2);if(!len){x0=0;x1=0;x2=0;}else{len=1/len;x0*=len;x1*=len;x2*=len;}y0=z1*x2-z2*x1;y1=z2*x0-z0*x2;y2=z0*x1-z1*x0;len=Math.sqrt(y0*y0+y1*y1+y2*y2);if(!len){y0=0;y1=0;y2=0;}else{len=1/len;y0*=len;y1*=len;y2*=len;}out[0]=x0;out[1]=y0;out[2]=z0;out[3]=0;out[4]=x1;out[5]=y1;out[6]=z1;out[7]=0;out[8]=x2;out[9]=y2;out[10]=z2;out[11]=0;out[12]=-(x0*eyex+x1*eyey+x2*eyez);out[13]=-(y0*eyex+y1*eyey+y2*eyez);out[14]=-(z0*eyex+z1*eyey+z2*eyez);out[15]=1;return out;};/***/}),/***/6760:(/***/function(module){module.exports=multiply;/**
 * Multiplies two mat4's
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the first operand
 * @param {mat4} b the second operand
 * @returns {mat4} out
 */function multiply(out,a,b){var a00=a[0],a01=a[1],a02=a[2],a03=a[3],a10=a[4],a11=a[5],a12=a[6],a13=a[7],a20=a[8],a21=a[9],a22=a[10],a23=a[11],a30=a[12],a31=a[13],a32=a[14],a33=a[15];// Cache only the current line of the second matrix
var b0=b[0],b1=b[1],b2=b[2],b3=b[3];out[0]=b0*a00+b1*a10+b2*a20+b3*a30;out[1]=b0*a01+b1*a11+b2*a21+b3*a31;out[2]=b0*a02+b1*a12+b2*a22+b3*a32;out[3]=b0*a03+b1*a13+b2*a23+b3*a33;b0=b[4];b1=b[5];b2=b[6];b3=b[7];out[4]=b0*a00+b1*a10+b2*a20+b3*a30;out[5]=b0*a01+b1*a11+b2*a21+b3*a31;out[6]=b0*a02+b1*a12+b2*a22+b3*a32;out[7]=b0*a03+b1*a13+b2*a23+b3*a33;b0=b[8];b1=b[9];b2=b[10];b3=b[11];out[8]=b0*a00+b1*a10+b2*a20+b3*a30;out[9]=b0*a01+b1*a11+b2*a21+b3*a31;out[10]=b0*a02+b1*a12+b2*a22+b3*a32;out[11]=b0*a03+b1*a13+b2*a23+b3*a33;b0=b[12];b1=b[13];b2=b[14];b3=b[15];out[12]=b0*a00+b1*a10+b2*a20+b3*a30;out[13]=b0*a01+b1*a11+b2*a21+b3*a31;out[14]=b0*a02+b1*a12+b2*a22+b3*a32;out[15]=b0*a03+b1*a13+b2*a23+b3*a33;return out;};/***/}),/***/4040:(/***/function(module){module.exports=ortho;/**
 * Generates a orthogonal projection matrix with the given bounds
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {number} left Left bound of the frustum
 * @param {number} right Right bound of the frustum
 * @param {number} bottom Bottom bound of the frustum
 * @param {number} top Top bound of the frustum
 * @param {number} near Near bound of the frustum
 * @param {number} far Far bound of the frustum
 * @returns {mat4} out
 */function ortho(out,left,right,bottom,top,near,far){var lr=1/(left-right),bt=1/(bottom-top),nf=1/(near-far);out[0]=-2*lr;out[1]=0;out[2]=0;out[3]=0;out[4]=0;out[5]=-2*bt;out[6]=0;out[7]=0;out[8]=0;out[9]=0;out[10]=2*nf;out[11]=0;out[12]=(left+right)*lr;out[13]=(top+bottom)*bt;out[14]=(far+near)*nf;out[15]=1;return out;};/***/}),/***/4772:(/***/function(module){module.exports=perspective;/**
 * Generates a perspective projection matrix with the given bounds
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {number} fovy Vertical field of view in radians
 * @param {number} aspect Aspect ratio. typically viewport width/height
 * @param {number} near Near bound of the frustum
 * @param {number} far Far bound of the frustum
 * @returns {mat4} out
 */function perspective(out,fovy,aspect,near,far){var f=1.0/Math.tan(fovy/2),nf=1/(near-far);out[0]=f/aspect;out[1]=0;out[2]=0;out[3]=0;out[4]=0;out[5]=f;out[6]=0;out[7]=0;out[8]=0;out[9]=0;out[10]=(far+near)*nf;out[11]=-1;out[12]=0;out[13]=0;out[14]=2*far*near*nf;out[15]=0;return out;};/***/}),/***/6079:(/***/function(module){module.exports=rotate;/**
 * Rotates a mat4 by the given angle
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @param {vec3} axis the axis to rotate around
 * @returns {mat4} out
 */function rotate(out,a,rad,axis){var x=axis[0],y=axis[1],z=axis[2],len=Math.sqrt(x*x+y*y+z*z),s,c,t,a00,a01,a02,a03,a10,a11,a12,a13,a20,a21,a22,a23,b00,b01,b02,b10,b11,b12,b20,b21,b22;if(Math.abs(len)<0.000001){return null;}len=1/len;x*=len;y*=len;z*=len;s=Math.sin(rad);c=Math.cos(rad);t=1-c;a00=a[0];a01=a[1];a02=a[2];a03=a[3];a10=a[4];a11=a[5];a12=a[6];a13=a[7];a20=a[8];a21=a[9];a22=a[10];a23=a[11];// Construct the elements of the rotation matrix
b00=x*x*t+c;b01=y*x*t+z*s;b02=z*x*t-y*s;b10=x*y*t-z*s;b11=y*y*t+c;b12=z*y*t+x*s;b20=x*z*t+y*s;b21=y*z*t-x*s;b22=z*z*t+c;// Perform rotation-specific matrix multiplication
out[0]=a00*b00+a10*b01+a20*b02;out[1]=a01*b00+a11*b01+a21*b02;out[2]=a02*b00+a12*b01+a22*b02;out[3]=a03*b00+a13*b01+a23*b02;out[4]=a00*b10+a10*b11+a20*b12;out[5]=a01*b10+a11*b11+a21*b12;out[6]=a02*b10+a12*b11+a22*b12;out[7]=a03*b10+a13*b11+a23*b12;out[8]=a00*b20+a10*b21+a20*b22;out[9]=a01*b20+a11*b21+a21*b22;out[10]=a02*b20+a12*b21+a22*b22;out[11]=a03*b20+a13*b21+a23*b22;if(a!==out){// If the source and destination differ, copy the unchanged last row
out[12]=a[12];out[13]=a[13];out[14]=a[14];out[15]=a[15];}return out;};/***/}),/***/5567:(/***/function(module){module.exports=rotateX;/**
 * Rotates a matrix by the given angle around the X axis
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */function rotateX(out,a,rad){var s=Math.sin(rad),c=Math.cos(rad),a10=a[4],a11=a[5],a12=a[6],a13=a[7],a20=a[8],a21=a[9],a22=a[10],a23=a[11];if(a!==out){// If the source and destination differ, copy the unchanged rows
out[0]=a[0];out[1]=a[1];out[2]=a[2];out[3]=a[3];out[12]=a[12];out[13]=a[13];out[14]=a[14];out[15]=a[15];}// Perform axis-specific matrix multiplication
out[4]=a10*c+a20*s;out[5]=a11*c+a21*s;out[6]=a12*c+a22*s;out[7]=a13*c+a23*s;out[8]=a20*c-a10*s;out[9]=a21*c-a11*s;out[10]=a22*c-a12*s;out[11]=a23*c-a13*s;return out;};/***/}),/***/2408:(/***/function(module){module.exports=rotateY;/**
 * Rotates a matrix by the given angle around the Y axis
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */function rotateY(out,a,rad){var s=Math.sin(rad),c=Math.cos(rad),a00=a[0],a01=a[1],a02=a[2],a03=a[3],a20=a[8],a21=a[9],a22=a[10],a23=a[11];if(a!==out){// If the source and destination differ, copy the unchanged rows
out[4]=a[4];out[5]=a[5];out[6]=a[6];out[7]=a[7];out[12]=a[12];out[13]=a[13];out[14]=a[14];out[15]=a[15];}// Perform axis-specific matrix multiplication
out[0]=a00*c-a20*s;out[1]=a01*c-a21*s;out[2]=a02*c-a22*s;out[3]=a03*c-a23*s;out[8]=a00*s+a20*c;out[9]=a01*s+a21*c;out[10]=a02*s+a22*c;out[11]=a03*s+a23*c;return out;};/***/}),/***/7089:(/***/function(module){module.exports=rotateZ;/**
 * Rotates a matrix by the given angle around the Z axis
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */function rotateZ(out,a,rad){var s=Math.sin(rad),c=Math.cos(rad),a00=a[0],a01=a[1],a02=a[2],a03=a[3],a10=a[4],a11=a[5],a12=a[6],a13=a[7];if(a!==out){// If the source and destination differ, copy the unchanged last row
out[8]=a[8];out[9]=a[9];out[10]=a[10];out[11]=a[11];out[12]=a[12];out[13]=a[13];out[14]=a[14];out[15]=a[15];}// Perform axis-specific matrix multiplication
out[0]=a00*c+a10*s;out[1]=a01*c+a11*s;out[2]=a02*c+a12*s;out[3]=a03*c+a13*s;out[4]=a10*c-a00*s;out[5]=a11*c-a01*s;out[6]=a12*c-a02*s;out[7]=a13*c-a03*s;return out;};/***/}),/***/2504:(/***/function(module){module.exports=scale;/**
 * Scales the mat4 by the dimensions in the given vec3
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the matrix to scale
 * @param {vec3} v the vec3 to scale the matrix by
 * @returns {mat4} out
 **/function scale(out,a,v){var x=v[0],y=v[1],z=v[2];out[0]=a[0]*x;out[1]=a[1]*x;out[2]=a[2]*x;out[3]=a[3]*x;out[4]=a[4]*y;out[5]=a[5]*y;out[6]=a[6]*y;out[7]=a[7]*y;out[8]=a[8]*z;out[9]=a[9]*z;out[10]=a[10]*z;out[11]=a[11]*z;out[12]=a[12];out[13]=a[13];out[14]=a[14];out[15]=a[15];return out;};/***/}),/***/7656:(/***/function(module){module.exports=translate;/**
 * Translate a mat4 by the given vector
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the matrix to translate
 * @param {vec3} v vector to translate by
 * @returns {mat4} out
 */function translate(out,a,v){var x=v[0],y=v[1],z=v[2],a00,a01,a02,a03,a10,a11,a12,a13,a20,a21,a22,a23;if(a===out){out[12]=a[0]*x+a[4]*y+a[8]*z+a[12];out[13]=a[1]*x+a[5]*y+a[9]*z+a[13];out[14]=a[2]*x+a[6]*y+a[10]*z+a[14];out[15]=a[3]*x+a[7]*y+a[11]*z+a[15];}else{a00=a[0];a01=a[1];a02=a[2];a03=a[3];a10=a[4];a11=a[5];a12=a[6];a13=a[7];a20=a[8];a21=a[9];a22=a[10];a23=a[11];out[0]=a00;out[1]=a01;out[2]=a02;out[3]=a03;out[4]=a10;out[5]=a11;out[6]=a12;out[7]=a13;out[8]=a20;out[9]=a21;out[10]=a22;out[11]=a23;out[12]=a00*x+a10*y+a20*z+a[12];out[13]=a01*x+a11*y+a21*z+a[13];out[14]=a02*x+a12*y+a22*z+a[14];out[15]=a03*x+a13*y+a23*z+a[15];}return out;};/***/}),/***/5665:(/***/function(module){module.exports=transpose;/**
 * Transpose the values of a mat4
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the source matrix
 * @returns {mat4} out
 */function transpose(out,a){// If we are transposing ourselves we can skip a few steps but have to cache some values
if(out===a){var a01=a[1],a02=a[2],a03=a[3],a12=a[6],a13=a[7],a23=a[11];out[1]=a[4];out[2]=a[8];out[3]=a[12];out[4]=a01;out[6]=a[9];out[7]=a[13];out[8]=a02;out[9]=a12;out[11]=a[14];out[12]=a03;out[13]=a13;out[14]=a23;}else{out[0]=a[0];out[1]=a[4];out[2]=a[8];out[3]=a[12];out[4]=a[1];out[5]=a[5];out[6]=a[9];out[7]=a[13];out[8]=a[2];out[9]=a[6];out[10]=a[10];out[11]=a[14];out[12]=a[3];out[13]=a[7];out[14]=a[11];out[15]=a[15];}return out;};/***/}),/***/7626:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_363738__){"use strict";var barycentric=__nested_webpack_require_363738__(2642);var closestPointToTriangle=__nested_webpack_require_363738__(9346);module.exports=closestPointToPickLocation;function xformMatrix(m,v){var out=[0,0,0,0];for(var i=0;i<4;++i){for(var j=0;j<4;++j){out[j]+=m[4*i+j]*v[i];}}return out;}function projectVertex(v,model,view,projection,resolution){var p=xformMatrix(projection,xformMatrix(view,xformMatrix(model,[v[0],v[1],v[2],1])));for(var i=0;i<3;++i){p[i]/=p[3];}return[0.5*resolution[0]*(1.0+p[0]),0.5*resolution[1]*(1.0-p[1])];}function barycentricCoord(simplex,point){if(simplex.length===2){var d0=0.0;var d1=0.0;for(var i=0;i<2;++i){d0+=Math.pow(point[i]-simplex[0][i],2);d1+=Math.pow(point[i]-simplex[1][i],2);}d0=Math.sqrt(d0);d1=Math.sqrt(d1);if(d0+d1<1e-6){return[1,0];}return[d1/(d0+d1),d0/(d1+d0)];}else if(simplex.length===3){var closestPoint=[0,0];closestPointToTriangle(simplex[0],simplex[1],simplex[2],point,closestPoint);return barycentric(simplex,closestPoint);}return[];}function interpolate(simplex,weights){var result=[0,0,0];for(var i=0;i<simplex.length;++i){var p=simplex[i];var w=weights[i];for(var j=0;j<3;++j){result[j]+=w*p[j];}}return result;}function closestPointToPickLocation(simplex,pixelCoord,model,view,projection,resolution){if(simplex.length===1){return[0,simplex[0].slice()];}var simplex2D=new Array(simplex.length);for(var i=0;i<simplex.length;++i){simplex2D[i]=projectVertex(simplex[i],model,view,projection,resolution);}var closestIndex=0;var closestDist=Infinity;for(var i=0;i<simplex2D.length;++i){var d2=0.0;for(var j=0;j<2;++j){d2+=Math.pow(simplex2D[i][j]-pixelCoord[j],2);}if(d2<closestDist){closestDist=d2;closestIndex=i;}}var weights=barycentricCoord(simplex2D,pixelCoord);var s=0.0;for(var i=0;i<3;++i){if(weights[i]<-0.001||weights[i]>1.0001){return null;}s+=weights[i];}if(Math.abs(s-1.0)>0.001){return null;}return[closestIndex,interpolate(simplex,weights),weights];}/***/}),/***/840:(/***/function(__unused_webpack_module,exports,__nested_webpack_require_365727__){var glslify=__nested_webpack_require_365727__(3236);var triVertSrc=glslify(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position, normal;\nattribute vec4 color;\nattribute vec2 uv;\n\nuniform mat4 model\n           , view\n           , projection\n           , inverseModel;\nuniform vec3 eyePosition\n           , lightPosition;\n\nvarying vec3 f_normal\n           , f_lightDirection\n           , f_eyeDirection\n           , f_data;\nvarying vec4 f_color;\nvarying vec2 f_uv;\n\nvec4 project(vec3 p) {\n  return projection * (view * (model * vec4(p, 1.0)));\n}\n\nvoid main() {\n  gl_Position      = project(position);\n\n  //Lighting geometry parameters\n  vec4 cameraCoordinate = view * vec4(position , 1.0);\n  cameraCoordinate.xyz /= cameraCoordinate.w;\n  f_lightDirection = lightPosition - cameraCoordinate.xyz;\n  f_eyeDirection   = eyePosition - cameraCoordinate.xyz;\n  f_normal  = normalize((vec4(normal, 0.0) * inverseModel).xyz);\n\n  f_color          = color;\n  f_data           = position;\n  f_uv             = uv;\n}\n"]);var triFragSrc=glslify(["#extension GL_OES_standard_derivatives : enable\n\nprecision highp float;\n#define GLSLIFY 1\n\nfloat beckmannDistribution(float x, float roughness) {\n  float NdotH = max(x, 0.0001);\n  float cos2Alpha = NdotH * NdotH;\n  float tan2Alpha = (cos2Alpha - 1.0) / cos2Alpha;\n  float roughness2 = roughness * roughness;\n  float denom = 3.141592653589793 * roughness2 * cos2Alpha * cos2Alpha;\n  return exp(tan2Alpha / roughness2) / denom;\n}\n\nfloat cookTorranceSpecular(\n  vec3 lightDirection,\n  vec3 viewDirection,\n  vec3 surfaceNormal,\n  float roughness,\n  float fresnel) {\n\n  float VdotN = max(dot(viewDirection, surfaceNormal), 0.0);\n  float LdotN = max(dot(lightDirection, surfaceNormal), 0.0);\n\n  //Half angle vector\n  vec3 H = normalize(lightDirection + viewDirection);\n\n  //Geometric term\n  float NdotH = max(dot(surfaceNormal, H), 0.0);\n  float VdotH = max(dot(viewDirection, H), 0.000001);\n  float LdotH = max(dot(lightDirection, H), 0.000001);\n  float G1 = (2.0 * NdotH * VdotN) / VdotH;\n  float G2 = (2.0 * NdotH * LdotN) / LdotH;\n  float G = min(1.0, min(G1, G2));\n  \n  //Distribution term\n  float D = beckmannDistribution(NdotH, roughness);\n\n  //Fresnel term\n  float F = pow(1.0 - VdotN, fresnel);\n\n  //Multiply terms and done\n  return  G * F * D / max(3.14159265 * VdotN, 0.000001);\n}\n\n//#pragma glslify: beckmann = require(glsl-specular-beckmann) // used in gl-surface3d\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3 clipBounds[2];\nuniform float roughness\n            , fresnel\n            , kambient\n            , kdiffuse\n            , kspecular;\nuniform sampler2D texture;\n\nvarying vec3 f_normal\n           , f_lightDirection\n           , f_eyeDirection\n           , f_data;\nvarying vec4 f_color;\nvarying vec2 f_uv;\n\nvoid main() {\n  if (f_color.a == 0.0 ||\n    outOfRange(clipBounds[0], clipBounds[1], f_data)\n  ) discard;\n\n  vec3 N = normalize(f_normal);\n  vec3 L = normalize(f_lightDirection);\n  vec3 V = normalize(f_eyeDirection);\n\n  if(gl_FrontFacing) {\n    N = -N;\n  }\n\n  float specular = min(1.0, max(0.0, cookTorranceSpecular(L, V, N, roughness, fresnel)));\n  //float specular = max(0.0, beckmann(L, V, N, roughness)); // used in gl-surface3d\n\n  float diffuse  = min(kambient + kdiffuse * max(dot(N, L), 0.0), 1.0);\n\n  vec4 surfaceColor = vec4(f_color.rgb, 1.0) * texture2D(texture, f_uv);\n  vec4 litColor = surfaceColor.a * vec4(diffuse * surfaceColor.rgb + kspecular * vec3(1,1,1) * specular,  1.0);\n\n  gl_FragColor = litColor * f_color.a;\n}\n"]);var edgeVertSrc=glslify(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position;\nattribute vec4 color;\nattribute vec2 uv;\n\nuniform mat4 model, view, projection;\n\nvarying vec4 f_color;\nvarying vec3 f_data;\nvarying vec2 f_uv;\n\nvoid main() {\n  gl_Position = projection * (view * (model * vec4(position, 1.0)));\n  f_color = color;\n  f_data  = position;\n  f_uv    = uv;\n}"]);var edgeFragSrc=glslify(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3 clipBounds[2];\nuniform sampler2D texture;\nuniform float opacity;\n\nvarying vec4 f_color;\nvarying vec3 f_data;\nvarying vec2 f_uv;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], f_data)) discard;\n\n  gl_FragColor = f_color * texture2D(texture, f_uv) * opacity;\n}"]);var pointVertSrc=glslify(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nattribute vec3 position;\nattribute vec4 color;\nattribute vec2 uv;\nattribute float pointSize;\n\nuniform mat4 model, view, projection;\nuniform vec3 clipBounds[2];\n\nvarying vec4 f_color;\nvarying vec2 f_uv;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], position)) {\n\n    gl_Position = vec4(0.0, 0.0 ,0.0 ,0.0);\n  } else {\n    gl_Position = projection * (view * (model * vec4(position, 1.0)));\n  }\n  gl_PointSize = pointSize;\n  f_color = color;\n  f_uv = uv;\n}"]);var pointFragSrc=glslify(["precision highp float;\n#define GLSLIFY 1\n\nuniform sampler2D texture;\nuniform float opacity;\n\nvarying vec4 f_color;\nvarying vec2 f_uv;\n\nvoid main() {\n  vec2 pointR = gl_PointCoord.xy - vec2(0.5, 0.5);\n  if(dot(pointR, pointR) > 0.25) {\n    discard;\n  }\n  gl_FragColor = f_color * texture2D(texture, f_uv) * opacity;\n}"]);var pickVertSrc=glslify(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position;\nattribute vec4 id;\n\nuniform mat4 model, view, projection;\n\nvarying vec3 f_position;\nvarying vec4 f_id;\n\nvoid main() {\n  gl_Position = projection * (view * (model * vec4(position, 1.0)));\n  f_id        = id;\n  f_position  = position;\n}"]);var pickFragSrc=glslify(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3  clipBounds[2];\nuniform float pickId;\n\nvarying vec3 f_position;\nvarying vec4 f_id;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], f_position)) discard;\n\n  gl_FragColor = vec4(pickId, f_id.xyz);\n}"]);var pickPointVertSrc=glslify(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nattribute vec3  position;\nattribute float pointSize;\nattribute vec4  id;\n\nuniform mat4 model, view, projection;\nuniform vec3 clipBounds[2];\n\nvarying vec3 f_position;\nvarying vec4 f_id;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], position)) {\n\n    gl_Position = vec4(0.0, 0.0, 0.0, 0.0);\n  } else {\n    gl_Position  = projection * (view * (model * vec4(position, 1.0)));\n    gl_PointSize = pointSize;\n  }\n  f_id         = id;\n  f_position   = position;\n}"]);var contourVertSrc=glslify(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position;\n\nuniform mat4 model, view, projection;\n\nvoid main() {\n  gl_Position = projection * (view * (model * vec4(position, 1.0)));\n}"]);var contourFragSrc=glslify(["precision highp float;\n#define GLSLIFY 1\n\nuniform vec3 contourColor;\n\nvoid main() {\n  gl_FragColor = vec4(contourColor, 1.0);\n}\n"]);exports.meshShader={vertex:triVertSrc,fragment:triFragSrc,attributes:[{name:'position',type:'vec3'},{name:'normal',type:'vec3'},{name:'color',type:'vec4'},{name:'uv',type:'vec2'}]};exports.wireShader={vertex:edgeVertSrc,fragment:edgeFragSrc,attributes:[{name:'position',type:'vec3'},{name:'color',type:'vec4'},{name:'uv',type:'vec2'}]};exports.pointShader={vertex:pointVertSrc,fragment:pointFragSrc,attributes:[{name:'position',type:'vec3'},{name:'color',type:'vec4'},{name:'uv',type:'vec2'},{name:'pointSize',type:'float'}]};exports.pickShader={vertex:pickVertSrc,fragment:pickFragSrc,attributes:[{name:'position',type:'vec3'},{name:'id',type:'vec4'}]};exports.pointPickShader={vertex:pickPointVertSrc,fragment:pickFragSrc,attributes:[{name:'position',type:'vec3'},{name:'pointSize',type:'float'},{name:'id',type:'vec4'}]};exports.contourShader={vertex:contourVertSrc,fragment:contourFragSrc,attributes:[{name:'position',type:'vec3'}]};/***/}),/***/7201:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_376142__){"use strict";var DEFAULT_VERTEX_NORMALS_EPSILON=1e-6;// may be too large if triangles are very small
var DEFAULT_FACE_NORMALS_EPSILON=1e-6;var createShader=__nested_webpack_require_376142__(9405);var createBuffer=__nested_webpack_require_376142__(2762);var createVAO=__nested_webpack_require_376142__(8116);var createTexture=__nested_webpack_require_376142__(7766);var normals=__nested_webpack_require_376142__(8406);var multiply=__nested_webpack_require_376142__(6760);var invert=__nested_webpack_require_376142__(7608);var ndarray=__nested_webpack_require_376142__(9618);var colormap=__nested_webpack_require_376142__(6729);var getContour=__nested_webpack_require_376142__(7765);var pool=__nested_webpack_require_376142__(1888);var shaders=__nested_webpack_require_376142__(840);var closestPoint=__nested_webpack_require_376142__(7626);var meshShader=shaders.meshShader;var wireShader=shaders.wireShader;var pointShader=shaders.pointShader;var pickShader=shaders.pickShader;var pointPickShader=shaders.pointPickShader;var contourShader=shaders.contourShader;var IDENTITY=[1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1];function SimplicialMesh(gl,texture,triShader,lineShader,pointShader,pickShader,pointPickShader,contourShader,trianglePositions,triangleIds,triangleColors,triangleUVs,triangleNormals,triangleVAO,edgePositions,edgeIds,edgeColors,edgeUVs,edgeVAO,pointPositions,pointIds,pointColors,pointUVs,pointSizes,pointVAO,contourPositions,contourVAO){this.gl=gl;this.pixelRatio=1;this.cells=[];this.positions=[];this.intensity=[];this.texture=texture;this.dirty=true;this.triShader=triShader;this.lineShader=lineShader;this.pointShader=pointShader;this.pickShader=pickShader;this.pointPickShader=pointPickShader;this.contourShader=contourShader;this.trianglePositions=trianglePositions;this.triangleColors=triangleColors;this.triangleNormals=triangleNormals;this.triangleUVs=triangleUVs;this.triangleIds=triangleIds;this.triangleVAO=triangleVAO;this.triangleCount=0;this.lineWidth=1;this.edgePositions=edgePositions;this.edgeColors=edgeColors;this.edgeUVs=edgeUVs;this.edgeIds=edgeIds;this.edgeVAO=edgeVAO;this.edgeCount=0;this.pointPositions=pointPositions;this.pointColors=pointColors;this.pointUVs=pointUVs;this.pointSizes=pointSizes;this.pointIds=pointIds;this.pointVAO=pointVAO;this.pointCount=0;this.contourLineWidth=1;this.contourPositions=contourPositions;this.contourVAO=contourVAO;this.contourCount=0;this.contourColor=[0,0,0];this.contourEnable=true;this.pickVertex=true;this.pickId=1;this.bounds=[[Infinity,Infinity,Infinity],[-Infinity,-Infinity,-Infinity]];this.clipBounds=[[-Infinity,-Infinity,-Infinity],[Infinity,Infinity,Infinity]];this.lightPosition=[1e5,1e5,0];this.ambientLight=0.8;this.diffuseLight=0.8;this.specularLight=2.0;this.roughness=0.5;this.fresnel=1.5;this.opacity=1.0;this.hasAlpha=false;this.opacityscale=false;this._model=IDENTITY;this._view=IDENTITY;this._projection=IDENTITY;this._resolution=[1,1];}var proto=SimplicialMesh.prototype;proto.isOpaque=function(){return!this.hasAlpha;};proto.isTransparent=function(){return this.hasAlpha;};proto.pickSlots=1;proto.setPickBase=function(id){this.pickId=id;};function getOpacityFromScale(ratio,opacityscale){if(!opacityscale)return 1;if(!opacityscale.length)return 1;for(var i=0;i<opacityscale.length;++i){if(opacityscale.length<2)return 1;if(opacityscale[i][0]===ratio)return opacityscale[i][1];if(opacityscale[i][0]>ratio&&i>0){var d=(opacityscale[i][0]-ratio)/(opacityscale[i][0]-opacityscale[i-1][0]);return opacityscale[i][1]*(1-d)+d*opacityscale[i-1][1];}}return 1;}function genColormap(param,opacityscale){var colors=colormap({colormap:param,nshades:256,format:'rgba'});var result=new Uint8Array(256*4);for(var i=0;i<256;++i){var c=colors[i];for(var j=0;j<3;++j){result[4*i+j]=c[j];}if(!opacityscale){result[4*i+3]=255*c[3];}else{result[4*i+3]=255*getOpacityFromScale(i/255.0,opacityscale);}}return ndarray(result,[256,256,4],[4,0,1]);}function takeZComponent(array){var n=array.length;var result=new Array(n);for(var i=0;i<n;++i){result[i]=array[i][2];}return result;}proto.highlight=function(selection){if(!selection||!this.contourEnable){this.contourCount=0;return;}var level=getContour(this.cells,this.intensity,selection.intensity);var cells=level.cells;var vertexIds=level.vertexIds;var vertexWeights=level.vertexWeights;var numCells=cells.length;var result=pool.mallocFloat32(2*3*numCells);var ptr=0;for(var i=0;i<numCells;++i){var c=cells[i];for(var j=0;j<2;++j){var v=c[0];if(c.length===2){v=c[j];}var a=vertexIds[v][0];var b=vertexIds[v][1];var w=vertexWeights[v];var wi=1.0-w;var pa=this.positions[a];var pb=this.positions[b];for(var k=0;k<3;++k){result[ptr++]=w*pa[k]+wi*pb[k];}}}this.contourCount=ptr/3|0;this.contourPositions.update(result.subarray(0,ptr));pool.free(result);};proto.update=function(params){params=params||{};var gl=this.gl;this.dirty=true;if('contourEnable'in params){this.contourEnable=params.contourEnable;}if('contourColor'in params){this.contourColor=params.contourColor;}if('lineWidth'in params){this.lineWidth=params.lineWidth;}if('lightPosition'in params){this.lightPosition=params.lightPosition;}this.hasAlpha=false;// default to no transparent draw
if('opacity'in params){this.opacity=params.opacity;if(this.opacity<1){this.hasAlpha=true;}}if('opacityscale'in params){this.opacityscale=params.opacityscale;this.hasAlpha=true;}if('ambient'in params){this.ambientLight=params.ambient;}if('diffuse'in params){this.diffuseLight=params.diffuse;}if('specular'in params){this.specularLight=params.specular;}if('roughness'in params){this.roughness=params.roughness;}if('fresnel'in params){this.fresnel=params.fresnel;}if(params.texture){this.texture.dispose();this.texture=createTexture(gl,params.texture);}else if(params.colormap){this.texture.shape=[256,256];this.texture.minFilter=gl.LINEAR_MIPMAP_LINEAR;this.texture.magFilter=gl.LINEAR;this.texture.setPixels(genColormap(params.colormap,this.opacityscale));this.texture.generateMipmap();}var cells=params.cells;var positions=params.positions;if(!positions||!cells){return;}var tPos=[];var tCol=[];var tNor=[];var tUVs=[];var tIds=[];var ePos=[];var eCol=[];var eUVs=[];var eIds=[];var pPos=[];var pCol=[];var pUVs=[];var pSiz=[];var pIds=[];//Save geometry data for picking calculations
this.cells=cells;this.positions=positions;//Compute normals
var vertexNormals=params.vertexNormals;var cellNormals=params.cellNormals;var vertexNormalsEpsilon=params.vertexNormalsEpsilon===void 0?DEFAULT_VERTEX_NORMALS_EPSILON:params.vertexNormalsEpsilon;var faceNormalsEpsilon=params.faceNormalsEpsilon===void 0?DEFAULT_FACE_NORMALS_EPSILON:params.faceNormalsEpsilon;if(params.useFacetNormals&&!cellNormals){cellNormals=normals.faceNormals(cells,positions,faceNormalsEpsilon);}if(!cellNormals&&!vertexNormals){vertexNormals=normals.vertexNormals(cells,positions,vertexNormalsEpsilon);}//Compute colors
var vertexColors=params.vertexColors;var cellColors=params.cellColors;var meshColor=params.meshColor||[1,1,1,1];//UVs
var vertexUVs=params.vertexUVs;var vertexIntensity=params.vertexIntensity;var cellUVs=params.cellUVs;var cellIntensity=params.cellIntensity;var intensityLo=Infinity;var intensityHi=-Infinity;if(!vertexUVs&&!cellUVs){if(vertexIntensity){if(params.vertexIntensityBounds){intensityLo=+params.vertexIntensityBounds[0];intensityHi=+params.vertexIntensityBounds[1];}else{for(var i=0;i<vertexIntensity.length;++i){var f=vertexIntensity[i];intensityLo=Math.min(intensityLo,f);intensityHi=Math.max(intensityHi,f);}}}else if(cellIntensity){if(params.cellIntensityBounds){intensityLo=+params.cellIntensityBounds[0];intensityHi=+params.cellIntensityBounds[1];}else{for(var i=0;i<cellIntensity.length;++i){var f=cellIntensity[i];intensityLo=Math.min(intensityLo,f);intensityHi=Math.max(intensityHi,f);}}}else{for(var i=0;i<positions.length;++i){var f=positions[i][2];intensityLo=Math.min(intensityLo,f);intensityHi=Math.max(intensityHi,f);}}}if(vertexIntensity){this.intensity=vertexIntensity;}else if(cellIntensity){this.intensity=cellIntensity;}else{this.intensity=takeZComponent(positions);}this.pickVertex=!(cellIntensity||cellColors);//Point size
var pointSizes=params.pointSizes;var meshPointSize=params.pointSize||1.0;//Update bounds
this.bounds=[[Infinity,Infinity,Infinity],[-Infinity,-Infinity,-Infinity]];for(var i=0;i<positions.length;++i){var p=positions[i];for(var j=0;j<3;++j){if(isNaN(p[j])||!isFinite(p[j])){continue;}this.bounds[0][j]=Math.min(this.bounds[0][j],p[j]);this.bounds[1][j]=Math.max(this.bounds[1][j],p[j]);}}//Pack cells into buffers
var triangleCount=0;var edgeCount=0;var pointCount=0;fill_loop:for(var i=0;i<cells.length;++i){var cell=cells[i];switch(cell.length){case 1:var v=cell[0];var p=positions[v];//Check NaNs
for(var j=0;j<3;++j){if(isNaN(p[j])||!isFinite(p[j])){continue fill_loop;}}pPos.push(p[0],p[1],p[2]);var c;if(vertexColors){c=vertexColors[v];}else if(cellColors){c=cellColors[i];}else{c=meshColor;}if(this.opacityscale&&vertexIntensity){tCol.push(c[0],c[1],c[2],this.opacity*getOpacityFromScale((vertexIntensity[v]-intensityLo)/(intensityHi-intensityLo),this.opacityscale));}else if(c.length===3){pCol.push(c[0],c[1],c[2],this.opacity);}else{pCol.push(c[0],c[1],c[2],c[3]*this.opacity);if(c[3]<1)this.hasAlpha=true;}var uv;if(vertexUVs){uv=vertexUVs[v];}else if(vertexIntensity){uv=[(vertexIntensity[v]-intensityLo)/(intensityHi-intensityLo),0];}else if(cellUVs){uv=cellUVs[i];}else if(cellIntensity){uv=[(cellIntensity[i]-intensityLo)/(intensityHi-intensityLo),0];}else{uv=[(p[2]-intensityLo)/(intensityHi-intensityLo),0];}pUVs.push(uv[0],uv[1]);if(pointSizes){pSiz.push(pointSizes[v]);}else{pSiz.push(meshPointSize);}pIds.push(i);pointCount+=1;break;case 2://Check NaNs
for(var j=0;j<2;++j){var v=cell[j];var p=positions[v];for(var k=0;k<3;++k){if(isNaN(p[k])||!isFinite(p[k])){continue fill_loop;}}}for(var j=0;j<2;++j){var v=cell[j];var p=positions[v];ePos.push(p[0],p[1],p[2]);var c;if(vertexColors){c=vertexColors[v];}else if(cellColors){c=cellColors[i];}else{c=meshColor;}if(this.opacityscale&&vertexIntensity){tCol.push(c[0],c[1],c[2],this.opacity*getOpacityFromScale((vertexIntensity[v]-intensityLo)/(intensityHi-intensityLo),this.opacityscale));}else if(c.length===3){eCol.push(c[0],c[1],c[2],this.opacity);}else{eCol.push(c[0],c[1],c[2],c[3]*this.opacity);if(c[3]<1)this.hasAlpha=true;}var uv;if(vertexUVs){uv=vertexUVs[v];}else if(vertexIntensity){uv=[(vertexIntensity[v]-intensityLo)/(intensityHi-intensityLo),0];}else if(cellUVs){uv=cellUVs[i];}else if(cellIntensity){uv=[(cellIntensity[i]-intensityLo)/(intensityHi-intensityLo),0];}else{uv=[(p[2]-intensityLo)/(intensityHi-intensityLo),0];}eUVs.push(uv[0],uv[1]);eIds.push(i);}edgeCount+=1;break;case 3://Check NaNs
for(var j=0;j<3;++j){var v=cell[j];var p=positions[v];for(var k=0;k<3;++k){if(isNaN(p[k])||!isFinite(p[k])){continue fill_loop;}}}for(var j=0;j<3;++j){var v=cell[2-j];var p=positions[v];tPos.push(p[0],p[1],p[2]);var c;if(vertexColors){c=vertexColors[v];}else if(cellColors){c=cellColors[i];}else{c=meshColor;}if(!c){tCol.push(0.5,0.5,0.5,1);}else if(this.opacityscale&&vertexIntensity){tCol.push(c[0],c[1],c[2],this.opacity*getOpacityFromScale((vertexIntensity[v]-intensityLo)/(intensityHi-intensityLo),this.opacityscale));}else if(c.length===3){tCol.push(c[0],c[1],c[2],this.opacity);}else{tCol.push(c[0],c[1],c[2],c[3]*this.opacity);if(c[3]<1)this.hasAlpha=true;}var uv;if(vertexUVs){uv=vertexUVs[v];}else if(vertexIntensity){uv=[(vertexIntensity[v]-intensityLo)/(intensityHi-intensityLo),0];}else if(cellUVs){uv=cellUVs[i];}else if(cellIntensity){uv=[(cellIntensity[i]-intensityLo)/(intensityHi-intensityLo),0];}else{uv=[(p[2]-intensityLo)/(intensityHi-intensityLo),0];}tUVs.push(uv[0],uv[1]);var q;if(vertexNormals){q=vertexNormals[v];}else{q=cellNormals[i];}tNor.push(q[0],q[1],q[2]);tIds.push(i);}triangleCount+=1;break;default:break;}}this.pointCount=pointCount;this.edgeCount=edgeCount;this.triangleCount=triangleCount;this.pointPositions.update(pPos);this.pointColors.update(pCol);this.pointUVs.update(pUVs);this.pointSizes.update(pSiz);this.pointIds.update(new Uint32Array(pIds));this.edgePositions.update(ePos);this.edgeColors.update(eCol);this.edgeUVs.update(eUVs);this.edgeIds.update(new Uint32Array(eIds));this.trianglePositions.update(tPos);this.triangleColors.update(tCol);this.triangleUVs.update(tUVs);this.triangleNormals.update(tNor);this.triangleIds.update(new Uint32Array(tIds));};proto.drawTransparent=proto.draw=function(params){params=params||{};var gl=this.gl;var model=params.model||IDENTITY;var view=params.view||IDENTITY;var projection=params.projection||IDENTITY;var clipBounds=[[-1e6,-1e6,-1e6],[1e6,1e6,1e6]];for(var i=0;i<3;++i){clipBounds[0][i]=Math.max(clipBounds[0][i],this.clipBounds[0][i]);clipBounds[1][i]=Math.min(clipBounds[1][i],this.clipBounds[1][i]);}var uniforms={model:model,view:view,projection:projection,inverseModel:IDENTITY.slice(),clipBounds:clipBounds,kambient:this.ambientLight,kdiffuse:this.diffuseLight,kspecular:this.specularLight,roughness:this.roughness,fresnel:this.fresnel,eyePosition:[0,0,0],lightPosition:[0,0,0],contourColor:this.contourColor,texture:0};uniforms.inverseModel=invert(uniforms.inverseModel,uniforms.model);gl.disable(gl.CULL_FACE);this.texture.bind(0);var invCameraMatrix=new Array(16);multiply(invCameraMatrix,uniforms.view,uniforms.model);multiply(invCameraMatrix,uniforms.projection,invCameraMatrix);invert(invCameraMatrix,invCameraMatrix);for(var i=0;i<3;++i){uniforms.eyePosition[i]=invCameraMatrix[12+i]/invCameraMatrix[15];}var w=invCameraMatrix[15];for(var i=0;i<3;++i){w+=this.lightPosition[i]*invCameraMatrix[4*i+3];}for(var i=0;i<3;++i){var s=invCameraMatrix[12+i];for(var j=0;j<3;++j){s+=invCameraMatrix[4*j+i]*this.lightPosition[j];}uniforms.lightPosition[i]=s/w;}if(this.triangleCount>0){var shader=this.triShader;shader.bind();shader.uniforms=uniforms;this.triangleVAO.bind();gl.drawArrays(gl.TRIANGLES,0,this.triangleCount*3);this.triangleVAO.unbind();}if(this.edgeCount>0&&this.lineWidth>0){var shader=this.lineShader;shader.bind();shader.uniforms=uniforms;this.edgeVAO.bind();gl.lineWidth(this.lineWidth*this.pixelRatio);gl.drawArrays(gl.LINES,0,this.edgeCount*2);this.edgeVAO.unbind();}if(this.pointCount>0){var shader=this.pointShader;shader.bind();shader.uniforms=uniforms;this.pointVAO.bind();gl.drawArrays(gl.POINTS,0,this.pointCount);this.pointVAO.unbind();}if(this.contourEnable&&this.contourCount>0&&this.contourLineWidth>0){var shader=this.contourShader;shader.bind();shader.uniforms=uniforms;this.contourVAO.bind();gl.drawArrays(gl.LINES,0,this.contourCount);this.contourVAO.unbind();}};proto.drawPick=function(params){params=params||{};var gl=this.gl;var model=params.model||IDENTITY;var view=params.view||IDENTITY;var projection=params.projection||IDENTITY;var clipBounds=[[-1e6,-1e6,-1e6],[1e6,1e6,1e6]];for(var i=0;i<3;++i){clipBounds[0][i]=Math.max(clipBounds[0][i],this.clipBounds[0][i]);clipBounds[1][i]=Math.min(clipBounds[1][i],this.clipBounds[1][i]);}//Save camera parameters
this._model=[].slice.call(model);this._view=[].slice.call(view);this._projection=[].slice.call(projection);this._resolution=[gl.drawingBufferWidth,gl.drawingBufferHeight];var uniforms={model:model,view:view,projection:projection,clipBounds:clipBounds,pickId:this.pickId/255.0};var shader=this.pickShader;shader.bind();shader.uniforms=uniforms;if(this.triangleCount>0){this.triangleVAO.bind();gl.drawArrays(gl.TRIANGLES,0,this.triangleCount*3);this.triangleVAO.unbind();}if(this.edgeCount>0){this.edgeVAO.bind();gl.lineWidth(this.lineWidth*this.pixelRatio);gl.drawArrays(gl.LINES,0,this.edgeCount*2);this.edgeVAO.unbind();}if(this.pointCount>0){var shader=this.pointPickShader;shader.bind();shader.uniforms=uniforms;this.pointVAO.bind();gl.drawArrays(gl.POINTS,0,this.pointCount);this.pointVAO.unbind();}};proto.pick=function(pickData){if(!pickData){return null;}if(pickData.id!==this.pickId){return null;}var cellId=pickData.value[0]+256*pickData.value[1]+65536*pickData.value[2];var cell=this.cells[cellId];var positions=this.positions;var simplex=new Array(cell.length);for(var i=0;i<cell.length;++i){simplex[i]=positions[cell[i]];}var x=pickData.coord[0];var y=pickData.coord[1];if(!this.pickVertex){var A=this.positions[cell[0]];var B=this.positions[cell[1]];var C=this.positions[cell[2]];var dataCoordinate=[(A[0]+B[0]+C[0])/3,(A[1]+B[1]+C[1])/3,(A[2]+B[2]+C[2])/3];return{_cellCenter:true,position:[x,y],index:cellId,cell:cell,cellId:cellId,intensity:this.intensity[cellId],dataCoordinate:dataCoordinate};}var data=closestPoint(simplex,[x*this.pixelRatio,this._resolution[1]-y*this.pixelRatio],this._model,this._view,this._projection,this._resolution);if(!data){return null;}var weights=data[2];var interpIntensity=0.0;for(var i=0;i<cell.length;++i){interpIntensity+=weights[i]*this.intensity[cell[i]];}return{position:data[1],index:cell[data[0]],cell:cell,cellId:cellId,intensity:interpIntensity,dataCoordinate:this.positions[cell[data[0]]]};};proto.dispose=function(){this.texture.dispose();this.triShader.dispose();this.lineShader.dispose();this.pointShader.dispose();this.pickShader.dispose();this.pointPickShader.dispose();this.triangleVAO.dispose();this.trianglePositions.dispose();this.triangleColors.dispose();this.triangleUVs.dispose();this.triangleNormals.dispose();this.triangleIds.dispose();this.edgeVAO.dispose();this.edgePositions.dispose();this.edgeColors.dispose();this.edgeUVs.dispose();this.edgeIds.dispose();this.pointVAO.dispose();this.pointPositions.dispose();this.pointColors.dispose();this.pointUVs.dispose();this.pointSizes.dispose();this.pointIds.dispose();this.contourVAO.dispose();this.contourPositions.dispose();this.contourShader.dispose();};function createMeshShader(gl){var shader=createShader(gl,meshShader.vertex,meshShader.fragment);shader.attributes.position.location=0;shader.attributes.color.location=2;shader.attributes.uv.location=3;shader.attributes.normal.location=4;return shader;}function createWireShader(gl){var shader=createShader(gl,wireShader.vertex,wireShader.fragment);shader.attributes.position.location=0;shader.attributes.color.location=2;shader.attributes.uv.location=3;return shader;}function createPointShader(gl){var shader=createShader(gl,pointShader.vertex,pointShader.fragment);shader.attributes.position.location=0;shader.attributes.color.location=2;shader.attributes.uv.location=3;shader.attributes.pointSize.location=4;return shader;}function createPickShader(gl){var shader=createShader(gl,pickShader.vertex,pickShader.fragment);shader.attributes.position.location=0;shader.attributes.id.location=1;return shader;}function createPointPickShader(gl){var shader=createShader(gl,pointPickShader.vertex,pointPickShader.fragment);shader.attributes.position.location=0;shader.attributes.id.location=1;shader.attributes.pointSize.location=4;return shader;}function createContourShader(gl){var shader=createShader(gl,contourShader.vertex,contourShader.fragment);shader.attributes.position.location=0;return shader;}function createSimplicialMesh(gl,params){if(arguments.length===1){params=gl;gl=params.gl;}//enable derivatives for face normals
var ext=gl.getExtension('OES_standard_derivatives')||gl.getExtension('MOZ_OES_standard_derivatives')||gl.getExtension('WEBKIT_OES_standard_derivatives');if(!ext)throw new Error('derivatives not supported');var triShader=createMeshShader(gl);var lineShader=createWireShader(gl);var pointShader=createPointShader(gl);var pickShader=createPickShader(gl);var pointPickShader=createPointPickShader(gl);var contourShader=createContourShader(gl);var meshTexture=createTexture(gl,ndarray(new Uint8Array([255,255,255,255]),[1,1,4]));meshTexture.generateMipmap();meshTexture.minFilter=gl.LINEAR_MIPMAP_LINEAR;meshTexture.magFilter=gl.LINEAR;var trianglePositions=createBuffer(gl);var triangleColors=createBuffer(gl);var triangleUVs=createBuffer(gl);var triangleNormals=createBuffer(gl);var triangleIds=createBuffer(gl);var triangleVAO=createVAO(gl,[{buffer:trianglePositions,type:gl.FLOAT,size:3},{buffer:triangleIds,type:gl.UNSIGNED_BYTE,size:4,normalized:true},{buffer:triangleColors,type:gl.FLOAT,size:4},{buffer:triangleUVs,type:gl.FLOAT,size:2},{buffer:triangleNormals,type:gl.FLOAT,size:3}]);var edgePositions=createBuffer(gl);var edgeColors=createBuffer(gl);var edgeUVs=createBuffer(gl);var edgeIds=createBuffer(gl);var edgeVAO=createVAO(gl,[{buffer:edgePositions,type:gl.FLOAT,size:3},{buffer:edgeIds,type:gl.UNSIGNED_BYTE,size:4,normalized:true},{buffer:edgeColors,type:gl.FLOAT,size:4},{buffer:edgeUVs,type:gl.FLOAT,size:2}]);var pointPositions=createBuffer(gl);var pointColors=createBuffer(gl);var pointUVs=createBuffer(gl);var pointSizes=createBuffer(gl);var pointIds=createBuffer(gl);var pointVAO=createVAO(gl,[{buffer:pointPositions,type:gl.FLOAT,size:3},{buffer:pointIds,type:gl.UNSIGNED_BYTE,size:4,normalized:true},{buffer:pointColors,type:gl.FLOAT,size:4},{buffer:pointUVs,type:gl.FLOAT,size:2},{buffer:pointSizes,type:gl.FLOAT,size:1}]);var contourPositions=createBuffer(gl);var contourVAO=createVAO(gl,[{buffer:contourPositions,type:gl.FLOAT,size:3}]);var mesh=new SimplicialMesh(gl,meshTexture,triShader,lineShader,pointShader,pickShader,pointPickShader,contourShader,trianglePositions,triangleIds,triangleColors,triangleUVs,triangleNormals,triangleVAO,edgePositions,edgeIds,edgeColors,edgeUVs,edgeVAO,pointPositions,pointIds,pointColors,pointUVs,pointSizes,pointVAO,contourPositions,contourVAO);mesh.update(params);return mesh;}module.exports=createSimplicialMesh;/***/}),/***/8120:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_397514__){"use strict";module.exports=createBoxes;var createBuffer=__nested_webpack_require_397514__(2762);var createShader=__nested_webpack_require_397514__(9405);var shaders=__nested_webpack_require_397514__(3603);function Boxes(plot,vbo,shader){this.plot=plot;this.vbo=vbo;this.shader=shader;}var proto=Boxes.prototype;proto.bind=function(){var shader=this.shader;this.vbo.bind();this.shader.bind();shader.attributes.coord.pointer();shader.uniforms.screenBox=this.plot.screenBox;};proto.drawBox=function(){var lo=[0,0];var hi=[0,0];return function(loX,loY,hiX,hiY,color){var plot=this.plot;var shader=this.shader;var gl=plot.gl;lo[0]=loX;lo[1]=loY;hi[0]=hiX;hi[1]=hiY;shader.uniforms.lo=lo;shader.uniforms.hi=hi;shader.uniforms.color=color;gl.drawArrays(gl.TRIANGLE_STRIP,0,4);};}();proto.dispose=function(){this.vbo.dispose();this.shader.dispose();};function createBoxes(plot){var gl=plot.gl;var vbo=createBuffer(gl,[0,0,0,1,1,0,1,1]);var shader=createShader(gl,shaders.boxVert,shaders.lineFrag);return new Boxes(plot,vbo,shader);}/***/}),/***/1913:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_398583__){"use strict";module.exports=createGrid;var createBuffer=__nested_webpack_require_398583__(2762);var createShader=__nested_webpack_require_398583__(9405);var bsearch=__nested_webpack_require_398583__(2478);var shaders=__nested_webpack_require_398583__(3603);function Grid(plot,vbo,shader,tickShader){this.plot=plot;this.vbo=vbo;this.shader=shader;this.tickShader=tickShader;this.ticks=[[],[]];}function compareTickNum(a,b){return a-b;}var proto=Grid.prototype;proto.draw=function(){var DATA_SHIFT=[0,0];var DATA_SCALE=[0,0];var DATA_AXIS=[0,0];return function(){var plot=this.plot;var vbo=this.vbo;var shader=this.shader;var ticks=this.ticks;var gl=plot.gl;var bounds=plot._tickBounds;var dataBox=plot.dataBox;var viewPixels=plot.viewBox;var lineWidth=plot.gridLineWidth;var gridColor=plot.gridLineColor;var gridEnable=plot.gridLineEnable;var pixelRatio=plot.pixelRatio;for(var i=0;i<2;++i){var lo=bounds[i];var hi=bounds[i+2];var boundScale=hi-lo;var dataCenter=0.5*(dataBox[i+2]+dataBox[i]);var dataWidth=dataBox[i+2]-dataBox[i];DATA_SCALE[i]=2.0*boundScale/dataWidth;DATA_SHIFT[i]=2.0*(lo-dataCenter)/dataWidth;}shader.bind();vbo.bind();shader.attributes.dataCoord.pointer();shader.uniforms.dataShift=DATA_SHIFT;shader.uniforms.dataScale=DATA_SCALE;var offset=0;for(var i=0;i<2;++i){DATA_AXIS[0]=DATA_AXIS[1]=0;DATA_AXIS[i]=1;shader.uniforms.dataAxis=DATA_AXIS;shader.uniforms.lineWidth=lineWidth[i]/(viewPixels[i+2]-viewPixels[i])*pixelRatio;shader.uniforms.color=gridColor[i];var size=ticks[i].length*6;if(gridEnable[i]&&size){gl.drawArrays(gl.TRIANGLES,offset,size);}offset+=size;}};}();proto.drawTickMarks=function(){var DATA_SHIFT=[0,0];var DATA_SCALE=[0,0];var X_AXIS=[1,0];var Y_AXIS=[0,1];var SCR_OFFSET=[0,0];var TICK_SCALE=[0,0];return function(){var plot=this.plot;var vbo=this.vbo;var shader=this.tickShader;var ticks=this.ticks;var gl=plot.gl;var bounds=plot._tickBounds;var dataBox=plot.dataBox;var viewBox=plot.viewBox;var pixelRatio=plot.pixelRatio;var screenBox=plot.screenBox;var screenWidth=screenBox[2]-screenBox[0];var screenHeight=screenBox[3]-screenBox[1];var viewWidth=viewBox[2]-viewBox[0];var viewHeight=viewBox[3]-viewBox[1];for(var i=0;i<2;++i){var lo=bounds[i];var hi=bounds[i+2];var boundScale=hi-lo;var dataCenter=0.5*(dataBox[i+2]+dataBox[i]);var dataWidth=dataBox[i+2]-dataBox[i];DATA_SCALE[i]=2.0*boundScale/dataWidth;DATA_SHIFT[i]=2.0*(lo-dataCenter)/dataWidth;}DATA_SCALE[0]*=viewWidth/screenWidth;DATA_SHIFT[0]*=viewWidth/screenWidth;DATA_SCALE[1]*=viewHeight/screenHeight;DATA_SHIFT[1]*=viewHeight/screenHeight;shader.bind();vbo.bind();shader.attributes.dataCoord.pointer();var uniforms=shader.uniforms;uniforms.dataShift=DATA_SHIFT;uniforms.dataScale=DATA_SCALE;var tickMarkLength=plot.tickMarkLength;var tickMarkWidth=plot.tickMarkWidth;var tickMarkColor=plot.tickMarkColor;var xTicksOffset=0;var yTicksOffset=ticks[0].length*6;var xStart=Math.min(bsearch.ge(ticks[0],(dataBox[0]-bounds[0])/(bounds[2]-bounds[0]),compareTickNum),ticks[0].length);var xEnd=Math.min(bsearch.gt(ticks[0],(dataBox[2]-bounds[0])/(bounds[2]-bounds[0]),compareTickNum),ticks[0].length);var xOffset=xTicksOffset+6*xStart;var xCount=6*Math.max(0,xEnd-xStart);var yStart=Math.min(bsearch.ge(ticks[1],(dataBox[1]-bounds[1])/(bounds[3]-bounds[1]),compareTickNum),ticks[1].length);var yEnd=Math.min(bsearch.gt(ticks[1],(dataBox[3]-bounds[1])/(bounds[3]-bounds[1]),compareTickNum),ticks[1].length);var yOffset=yTicksOffset+6*yStart;var yCount=6*Math.max(0,yEnd-yStart);SCR_OFFSET[0]=2.0*(viewBox[0]-tickMarkLength[1])/screenWidth-1.0;SCR_OFFSET[1]=(viewBox[3]+viewBox[1])/screenHeight-1.0;TICK_SCALE[0]=tickMarkLength[1]*pixelRatio/screenWidth;TICK_SCALE[1]=tickMarkWidth[1]*pixelRatio/screenHeight;if(yCount){uniforms.color=tickMarkColor[1];uniforms.tickScale=TICK_SCALE;uniforms.dataAxis=Y_AXIS;uniforms.screenOffset=SCR_OFFSET;gl.drawArrays(gl.TRIANGLES,yOffset,yCount);}SCR_OFFSET[0]=(viewBox[2]+viewBox[0])/screenWidth-1.0;SCR_OFFSET[1]=2.0*(viewBox[1]-tickMarkLength[0])/screenHeight-1.0;TICK_SCALE[0]=tickMarkWidth[0]*pixelRatio/screenWidth;TICK_SCALE[1]=tickMarkLength[0]*pixelRatio/screenHeight;if(xCount){uniforms.color=tickMarkColor[0];uniforms.tickScale=TICK_SCALE;uniforms.dataAxis=X_AXIS;uniforms.screenOffset=SCR_OFFSET;gl.drawArrays(gl.TRIANGLES,xOffset,xCount);}SCR_OFFSET[0]=2.0*(viewBox[2]+tickMarkLength[3])/screenWidth-1.0;SCR_OFFSET[1]=(viewBox[3]+viewBox[1])/screenHeight-1.0;TICK_SCALE[0]=tickMarkLength[3]*pixelRatio/screenWidth;TICK_SCALE[1]=tickMarkWidth[3]*pixelRatio/screenHeight;if(yCount){uniforms.color=tickMarkColor[3];uniforms.tickScale=TICK_SCALE;uniforms.dataAxis=Y_AXIS;uniforms.screenOffset=SCR_OFFSET;gl.drawArrays(gl.TRIANGLES,yOffset,yCount);}SCR_OFFSET[0]=(viewBox[2]+viewBox[0])/screenWidth-1.0;SCR_OFFSET[1]=2.0*(viewBox[3]+tickMarkLength[2])/screenHeight-1.0;TICK_SCALE[0]=tickMarkWidth[2]*pixelRatio/screenWidth;TICK_SCALE[1]=tickMarkLength[2]*pixelRatio/screenHeight;if(xCount){uniforms.color=tickMarkColor[2];uniforms.tickScale=TICK_SCALE;uniforms.dataAxis=X_AXIS;uniforms.screenOffset=SCR_OFFSET;gl.drawArrays(gl.TRIANGLES,xOffset,xCount);}};}();proto.update=function(){var OFFSET_X=[1,1,-1,-1,1,-1];var OFFSET_Y=[1,-1,1,1,-1,-1];return function(options){var ticks=options.ticks;var bounds=options.bounds;var data=new Float32Array(6*3*(ticks[0].length+ticks[1].length));var zeroLineEnable=this.plot.zeroLineEnable;var ptr=0;var gridTicks=[[],[]];for(var dim=0;dim<2;++dim){var localTicks=gridTicks[dim];var axisTicks=ticks[dim];var lo=bounds[dim];var hi=bounds[dim+2];for(var i=0;i<axisTicks.length;++i){var x=(axisTicks[i].x-lo)/(hi-lo);localTicks.push(x);for(var j=0;j<6;++j){data[ptr++]=x;data[ptr++]=OFFSET_X[j];data[ptr++]=OFFSET_Y[j];}}}this.ticks=gridTicks;this.vbo.update(data);};}();proto.dispose=function(){this.vbo.dispose();this.shader.dispose();this.tickShader.dispose();};function createGrid(plot){var gl=plot.gl;var vbo=createBuffer(gl);var shader=createShader(gl,shaders.gridVert,shaders.gridFrag);var tickShader=createShader(gl,shaders.tickVert,shaders.gridFrag);var grid=new Grid(plot,vbo,shader,tickShader);return grid;}/***/}),/***/4747:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_404712__){"use strict";module.exports=createLines;var createBuffer=__nested_webpack_require_404712__(2762);var createShader=__nested_webpack_require_404712__(9405);var shaders=__nested_webpack_require_404712__(3603);function Lines(plot,vbo,shader){this.plot=plot;this.vbo=vbo;this.shader=shader;}var proto=Lines.prototype;proto.bind=function(){var shader=this.shader;this.vbo.bind();this.shader.bind();shader.attributes.coord.pointer();shader.uniforms.screenBox=this.plot.screenBox;};proto.drawLine=function(){var start=[0,0];var end=[0,0];return function(startX,startY,endX,endY,width,color){var plot=this.plot;var shader=this.shader;var gl=plot.gl;start[0]=startX;start[1]=startY;end[0]=endX;end[1]=endY;shader.uniforms.start=start;shader.uniforms.end=end;shader.uniforms.width=width*plot.pixelRatio;shader.uniforms.color=color;gl.drawArrays(gl.TRIANGLE_STRIP,0,4);};}();proto.dispose=function(){this.vbo.dispose();this.shader.dispose();};function createLines(plot){var gl=plot.gl;var vbo=createBuffer(gl,[-1,-1,-1,1,1,-1,1,1]);var shader=createShader(gl,shaders.lineVert,shaders.lineFrag);var lines=new Lines(plot,vbo,shader);return lines;}/***/}),/***/3603:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_405889__){"use strict";var glslify=__nested_webpack_require_405889__(3236);var FRAGMENT=glslify(["precision lowp float;\n#define GLSLIFY 1\nuniform vec4 color;\nvoid main() {\n  gl_FragColor = vec4(color.xyz * color.w, color.w);\n}\n"]);module.exports={lineVert:glslify(["precision mediump float;\n#define GLSLIFY 1\n\nattribute vec2 coord;\n\nuniform vec4 screenBox;\nuniform vec2 start, end;\nuniform float width;\n\nvec2 perp(vec2 v) {\n  return vec2(v.y, -v.x);\n}\n\nvec2 screen(vec2 v) {\n  return 2.0 * (v - screenBox.xy) / (screenBox.zw - screenBox.xy) - 1.0;\n}\n\nvoid main() {\n  vec2 delta = normalize(perp(start - end));\n  vec2 offset = mix(start, end, 0.5 * (coord.y+1.0));\n  gl_Position = vec4(screen(offset + 0.5 * width * delta * coord.x), 0, 1);\n}\n"]),lineFrag:FRAGMENT,textVert:glslify(["#define GLSLIFY 1\nattribute vec3 textCoordinate;\n\nuniform vec2 dataScale, dataShift, dataAxis, screenOffset, textScale;\nuniform float angle;\n\nvoid main() {\n  float dataOffset  = textCoordinate.z;\n  vec2 glyphOffset  = textCoordinate.xy;\n  mat2 glyphMatrix = mat2(cos(angle), sin(angle), -sin(angle), cos(angle));\n  vec2 screenCoordinate = dataAxis * (dataScale * dataOffset + dataShift) +\n    glyphMatrix * glyphOffset * textScale + screenOffset;\n  gl_Position = vec4(screenCoordinate, 0, 1);\n}\n"]),textFrag:FRAGMENT,gridVert:glslify(["precision mediump float;\n#define GLSLIFY 1\n\nattribute vec3 dataCoord;\n\nuniform vec2 dataAxis, dataShift, dataScale;\nuniform float lineWidth;\n\nvoid main() {\n  vec2 pos = dataAxis * (dataScale * dataCoord.x + dataShift);\n  pos += 10.0 * dataCoord.y * vec2(dataAxis.y, -dataAxis.x) + dataCoord.z * lineWidth;\n  gl_Position = vec4(pos, 0, 1);\n}\n"]),gridFrag:FRAGMENT,boxVert:glslify(["precision mediump float;\n#define GLSLIFY 1\n\nattribute vec2 coord;\n\nuniform vec4 screenBox;\nuniform vec2 lo, hi;\n\nvec2 screen(vec2 v) {\n  return 2.0 * (v - screenBox.xy) / (screenBox.zw - screenBox.xy) - 1.0;\n}\n\nvoid main() {\n  gl_Position = vec4(screen(mix(lo, hi, coord)), 0, 1);\n}\n"]),tickVert:glslify(["precision mediump float;\n#define GLSLIFY 1\n\nattribute vec3 dataCoord;\n\nuniform vec2 dataAxis, dataShift, dataScale, screenOffset, tickScale;\n\nvoid main() {\n  vec2 pos = dataAxis * (dataScale * dataCoord.x + dataShift);\n  gl_Position = vec4(pos + tickScale*dataCoord.yz + screenOffset, 0, 1);\n}\n"])};/***/}),/***/2142:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_408337__){"use strict";module.exports=createTextElements;var createBuffer=__nested_webpack_require_408337__(2762);var createShader=__nested_webpack_require_408337__(9405);var getText=__nested_webpack_require_408337__(529);var bsearch=__nested_webpack_require_408337__(2478);var shaders=__nested_webpack_require_408337__(3603);function TextElements(plot,vbo,shader){this.plot=plot;this.vbo=vbo;this.shader=shader;this.tickOffset=[[],[]];this.tickX=[[],[]];this.labelOffset=[0,0];this.labelCount=[0,0];}var proto=TextElements.prototype;proto.drawTicks=function(){var DATA_AXIS=[0,0];var SCREEN_OFFSET=[0,0];var ZERO_2=[0,0];return function(axis){var plot=this.plot;var shader=this.shader;var tickX=this.tickX[axis];var tickOffset=this.tickOffset[axis];var gl=plot.gl;var viewBox=plot.viewBox;var dataBox=plot.dataBox;var screenBox=plot.screenBox;var pixelRatio=plot.pixelRatio;var tickEnable=plot.tickEnable;var tickPad=plot.tickPad;var textColor=plot.tickColor;var textAngle=plot.tickAngle;// todo check if this should be used (now unused)
// var tickLength  = plot.tickMarkLength
var labelEnable=plot.labelEnable;var labelPad=plot.labelPad;var labelColor=plot.labelColor;var labelAngle=plot.labelAngle;var labelOffset=this.labelOffset[axis];var labelCount=this.labelCount[axis];var start=bsearch.lt(tickX,dataBox[axis]);var end=bsearch.le(tickX,dataBox[axis+2]);DATA_AXIS[0]=DATA_AXIS[1]=0;DATA_AXIS[axis]=1;SCREEN_OFFSET[axis]=(viewBox[2+axis]+viewBox[axis])/(screenBox[2+axis]-screenBox[axis])-1.0;var screenScale=2.0/screenBox[2+(axis^1)]-screenBox[axis^1];SCREEN_OFFSET[axis^1]=screenScale*viewBox[axis^1]-1.0;if(tickEnable[axis]){SCREEN_OFFSET[axis^1]-=screenScale*pixelRatio*tickPad[axis];if(start<end&&tickOffset[end]>tickOffset[start]){shader.uniforms.dataAxis=DATA_AXIS;shader.uniforms.screenOffset=SCREEN_OFFSET;shader.uniforms.color=textColor[axis];shader.uniforms.angle=textAngle[axis];gl.drawArrays(gl.TRIANGLES,tickOffset[start],tickOffset[end]-tickOffset[start]);}}if(labelEnable[axis]&&labelCount){SCREEN_OFFSET[axis^1]-=screenScale*pixelRatio*labelPad[axis];shader.uniforms.dataAxis=ZERO_2;shader.uniforms.screenOffset=SCREEN_OFFSET;shader.uniforms.color=labelColor[axis];shader.uniforms.angle=labelAngle[axis];gl.drawArrays(gl.TRIANGLES,labelOffset,labelCount);}SCREEN_OFFSET[axis^1]=screenScale*viewBox[2+(axis^1)]-1.0;if(tickEnable[axis+2]){SCREEN_OFFSET[axis^1]+=screenScale*pixelRatio*tickPad[axis+2];if(start<end&&tickOffset[end]>tickOffset[start]){shader.uniforms.dataAxis=DATA_AXIS;shader.uniforms.screenOffset=SCREEN_OFFSET;shader.uniforms.color=textColor[axis+2];shader.uniforms.angle=textAngle[axis+2];gl.drawArrays(gl.TRIANGLES,tickOffset[start],tickOffset[end]-tickOffset[start]);}}if(labelEnable[axis+2]&&labelCount){SCREEN_OFFSET[axis^1]+=screenScale*pixelRatio*labelPad[axis+2];shader.uniforms.dataAxis=ZERO_2;shader.uniforms.screenOffset=SCREEN_OFFSET;shader.uniforms.color=labelColor[axis+2];shader.uniforms.angle=labelAngle[axis+2];gl.drawArrays(gl.TRIANGLES,labelOffset,labelCount);}};}();proto.drawTitle=function(){var DATA_AXIS=[0,0];var SCREEN_OFFSET=[0,0];return function(){var plot=this.plot;var shader=this.shader;var gl=plot.gl;var screenBox=plot.screenBox;var titleCenter=plot.titleCenter;var titleAngle=plot.titleAngle;var titleColor=plot.titleColor;var pixelRatio=plot.pixelRatio;if(!this.titleCount){return;}for(var i=0;i<2;++i){SCREEN_OFFSET[i]=2.0*(titleCenter[i]*pixelRatio-screenBox[i])/(screenBox[2+i]-screenBox[i])-1;}shader.bind();shader.uniforms.dataAxis=DATA_AXIS;shader.uniforms.screenOffset=SCREEN_OFFSET;shader.uniforms.angle=titleAngle;shader.uniforms.color=titleColor;gl.drawArrays(gl.TRIANGLES,this.titleOffset,this.titleCount);};}();proto.bind=function(){var DATA_SHIFT=[0,0];var DATA_SCALE=[0,0];var TEXT_SCALE=[0,0];return function(){var plot=this.plot;var shader=this.shader;var bounds=plot._tickBounds;var dataBox=plot.dataBox;var screenBox=plot.screenBox;var viewBox=plot.viewBox;shader.bind();//Set up coordinate scaling uniforms
for(var i=0;i<2;++i){var lo=bounds[i];var hi=bounds[i+2];var boundScale=hi-lo;var dataCenter=0.5*(dataBox[i+2]+dataBox[i]);var dataWidth=dataBox[i+2]-dataBox[i];var viewLo=viewBox[i];var viewHi=viewBox[i+2];var viewScale=viewHi-viewLo;var screenLo=screenBox[i];var screenHi=screenBox[i+2];var screenScale=screenHi-screenLo;DATA_SCALE[i]=2.0*boundScale/dataWidth*viewScale/screenScale;DATA_SHIFT[i]=2.0*(lo-dataCenter)/dataWidth*viewScale/screenScale;}TEXT_SCALE[1]=2.0*plot.pixelRatio/(screenBox[3]-screenBox[1]);TEXT_SCALE[0]=TEXT_SCALE[1]*(screenBox[3]-screenBox[1])/(screenBox[2]-screenBox[0]);shader.uniforms.dataScale=DATA_SCALE;shader.uniforms.dataShift=DATA_SHIFT;shader.uniforms.textScale=TEXT_SCALE;//Set attributes
this.vbo.bind();shader.attributes.textCoordinate.pointer();};}();proto.update=function(options){var vertices=[];var axesTicks=options.ticks;var bounds=options.bounds;var i,j,k,data,scale,dimension;for(dimension=0;dimension<2;++dimension){var offsets=[Math.floor(vertices.length/3)],tickX=[-Infinity];//Copy vertices over to buffer
var ticks=axesTicks[dimension];for(i=0;i<ticks.length;++i){var tick=ticks[i];var x=tick.x;var text=tick.text;var font=tick.font||'sans-serif';var fontStyle=tick.fontStyle||'normal';var fontWeight=tick.fontWeight||'normal';var fontVariant=tick.fontVariant||'normal';scale=tick.fontSize||12;var coordScale=1.0/(bounds[dimension+2]-bounds[dimension]);var coordShift=bounds[dimension];var rows=text.split('\n');for(var r=0;r<rows.length;r++){data=getText(font,rows[r],{fontStyle:fontStyle,fontWeight:fontWeight,fontVariant:fontVariant}).data;for(j=0;j<data.length;j+=2){vertices.push(data[j]*scale,-data[j+1]*scale-r*scale*1.2,(x-coordShift)*coordScale);}}offsets.push(Math.floor(vertices.length/3));tickX.push(x);}this.tickOffset[dimension]=offsets;this.tickX[dimension]=tickX;}//Add labels
for(dimension=0;dimension<2;++dimension){this.labelOffset[dimension]=Math.floor(vertices.length/3);data=getText(options.labelFont[dimension],options.labels[dimension],{fontStyle:options.labelFontStyle[dimension],fontWeight:options.labelFontWeight[dimension],fontVariant:options.labelFontVariant[dimension],textAlign:'center'}).data;scale=options.labelSize[dimension];for(i=0;i<data.length;i+=2){vertices.push(data[i]*scale,-data[i+1]*scale,0);}this.labelCount[dimension]=Math.floor(vertices.length/3)-this.labelOffset[dimension];}//Add title
this.titleOffset=Math.floor(vertices.length/3);data=getText(options.titleFont,options.title,{fontStyle:options.titleFontStyle,fontWeight:options.titleFontWeight,fontVariant:options.titleFontVariant}).data;scale=options.titleSize;for(i=0;i<data.length;i+=2){vertices.push(data[i]*scale,-data[i+1]*scale,0);}this.titleCount=Math.floor(vertices.length/3)-this.titleOffset;//Upload new vertices
this.vbo.update(vertices);};proto.dispose=function(){this.vbo.dispose();this.shader.dispose();};function createTextElements(plot){var gl=plot.gl;var vbo=createBuffer(gl);var shader=createShader(gl,shaders.textVert,shaders.textFrag);var text=new TextElements(plot,vbo,shader);return text;}/***/}),/***/1850:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_415408__){"use strict";module.exports=createGLPlot2D;var createPick=__nested_webpack_require_415408__(3589);var createGrid=__nested_webpack_require_415408__(1913);var createText=__nested_webpack_require_415408__(2142);var createLine=__nested_webpack_require_415408__(4747);var createBox=__nested_webpack_require_415408__(8120);function GLPlot2D(gl,pickBuffer){this.gl=gl;this.pickBuffer=pickBuffer;this.screenBox=[0,0,gl.drawingBufferWidth,gl.drawingBufferHeight];this.viewBox=[0,0,0,0];this.dataBox=[-10,-10,10,10];this.gridLineEnable=[true,true];this.gridLineWidth=[1,1];this.gridLineColor=[[0,0,0,1],[0,0,0,1]];this.pixelRatio=1;this.tickMarkLength=[0,0,0,0];this.tickMarkWidth=[0,0,0,0];this.tickMarkColor=[[0,0,0,1],[0,0,0,1],[0,0,0,1],[0,0,0,1]];this.tickPad=[15,15,15,15];this.tickAngle=[0,0,0,0];this.tickEnable=[true,true,true,true];this.tickColor=[[0,0,0,1],[0,0,0,1],[0,0,0,1],[0,0,0,1]];this.labelPad=[15,15,15,15];this.labelAngle=[0,Math.PI/2,0,3.0*Math.PI/2];this.labelEnable=[true,true,true,true];this.labelColor=[[0,0,0,1],[0,0,0,1],[0,0,0,1],[0,0,0,1]];this.titleCenter=[0,0];this.titleEnable=true;this.titleAngle=0;this.titleColor=[0,0,0,1];this.borderColor=[0,0,0,0];this.backgroundColor=[0,0,0,0];this.zeroLineEnable=[true,true];this.zeroLineWidth=[4,4];this.zeroLineColor=[[0,0,0,1],[0,0,0,1]];this.borderLineEnable=[true,true,true,true];this.borderLineWidth=[2,2,2,2];this.borderLineColor=[[0,0,0,1],[0,0,0,1],[0,0,0,1],[0,0,0,1]];//Drawing parameters
this.grid=null;this.text=null;this.line=null;this.box=null;this.objects=[];this.overlays=[];this._tickBounds=[Infinity,Infinity,-Infinity,-Infinity];this.static=false;this.dirty=false;this.pickDirty=false;this.pickDelay=120;this.pickRadius=10;this._pickTimeout=null;this._drawPick=this.drawPick.bind(this);this._depthCounter=0;}var proto=GLPlot2D.prototype;proto.setDirty=function(){this.dirty=this.pickDirty=true;};proto.setOverlayDirty=function(){this.dirty=true;};proto.nextDepthValue=function(){return this._depthCounter++/65536.0;};function lerp(a,b,t){var s=0.5*(t+1.0);return Math.floor((1.0-s)*a+s*b)|0;}proto.draw=function(){var TICK_MARK_BOX=[0,0,0,0];return function(){var gl=this.gl;var screenBox=this.screenBox;var viewPixels=this.viewBox;var dataBox=this.dataBox;var pixelRatio=this.pixelRatio;var grid=this.grid;var line=this.line;var text=this.text;var objects=this.objects;this._depthCounter=0;if(this.pickDirty){if(this._pickTimeout){clearTimeout(this._pickTimeout);}this.pickDirty=false;this._pickTimeout=setTimeout(this._drawPick,this.pickDelay);}if(!this.dirty){return;}this.dirty=false;gl.bindFramebuffer(gl.FRAMEBUFFER,null);//Turn on scissor
gl.enable(gl.SCISSOR_TEST);//Turn off depth buffer
gl.disable(gl.DEPTH_TEST);gl.depthFunc(gl.LESS);gl.depthMask(false);//Configure premultiplied alpha blending
gl.enable(gl.BLEND);gl.blendEquation(gl.FUNC_ADD,gl.FUNC_ADD);gl.blendFunc(gl.ONE,gl.ONE_MINUS_SRC_ALPHA);//Draw border
if(this.borderColor){gl.scissor(screenBox[0],screenBox[1],screenBox[2]-screenBox[0],screenBox[3]-screenBox[1]);var borderColor=this.borderColor;gl.clearColor(borderColor[0]*borderColor[3],borderColor[1]*borderColor[3],borderColor[2]*borderColor[3],borderColor[3]);gl.clear(gl.COLOR_BUFFER_BIT|gl.DEPTH_BUFFER_BIT);}//Draw center pane
gl.scissor(viewPixels[0],viewPixels[1],viewPixels[2]-viewPixels[0],viewPixels[3]-viewPixels[1]);gl.viewport(viewPixels[0],viewPixels[1],viewPixels[2]-viewPixels[0],viewPixels[3]-viewPixels[1]);var backgroundColor=this.backgroundColor;gl.clearColor(backgroundColor[0]*backgroundColor[3],backgroundColor[1]*backgroundColor[3],backgroundColor[2]*backgroundColor[3],backgroundColor[3]);gl.clear(gl.COLOR_BUFFER_BIT);//Draw grid
grid.draw();//Draw zero lines separately
var zeroLineEnable=this.zeroLineEnable;var zeroLineColor=this.zeroLineColor;var zeroLineWidth=this.zeroLineWidth;if(zeroLineEnable[0]||zeroLineEnable[1]){line.bind();for(var i=0;i<2;++i){if(!zeroLineEnable[i]||!(dataBox[i]<=0&&dataBox[i+2]>=0)){continue;}var zeroIntercept=screenBox[i]-dataBox[i]*(screenBox[i+2]-screenBox[i])/(dataBox[i+2]-dataBox[i]);if(i===0){line.drawLine(zeroIntercept,screenBox[1],zeroIntercept,screenBox[3],zeroLineWidth[i],zeroLineColor[i]);}else{line.drawLine(screenBox[0],zeroIntercept,screenBox[2],zeroIntercept,zeroLineWidth[i],zeroLineColor[i]);}}}//Draw traces
for(var i=0;i<objects.length;++i){objects[i].draw();}//Return viewport to default
gl.viewport(screenBox[0],screenBox[1],screenBox[2]-screenBox[0],screenBox[3]-screenBox[1]);gl.scissor(screenBox[0],screenBox[1],screenBox[2]-screenBox[0],screenBox[3]-screenBox[1]);//Draw tick marks
this.grid.drawTickMarks();//Draw line elements
line.bind();//Draw border lines
var borderLineEnable=this.borderLineEnable;var borderLineWidth=this.borderLineWidth;var borderLineColor=this.borderLineColor;if(borderLineEnable[1]){line.drawLine(viewPixels[0],viewPixels[1]-0.5*borderLineWidth[1]*pixelRatio,viewPixels[0],viewPixels[3]+0.5*borderLineWidth[3]*pixelRatio,borderLineWidth[1],borderLineColor[1]);}if(borderLineEnable[0]){line.drawLine(viewPixels[0]-0.5*borderLineWidth[0]*pixelRatio,viewPixels[1],viewPixels[2]+0.5*borderLineWidth[2]*pixelRatio,viewPixels[1],borderLineWidth[0],borderLineColor[0]);}if(borderLineEnable[3]){line.drawLine(viewPixels[2],viewPixels[1]-0.5*borderLineWidth[1]*pixelRatio,viewPixels[2],viewPixels[3]+0.5*borderLineWidth[3]*pixelRatio,borderLineWidth[3],borderLineColor[3]);}if(borderLineEnable[2]){line.drawLine(viewPixels[0]-0.5*borderLineWidth[0]*pixelRatio,viewPixels[3],viewPixels[2]+0.5*borderLineWidth[2]*pixelRatio,viewPixels[3],borderLineWidth[2],borderLineColor[2]);}//Draw text elements
text.bind();for(var i=0;i<2;++i){text.drawTicks(i);}if(this.titleEnable){text.drawTitle();}//Draw other overlay elements (select boxes, etc.)
var overlays=this.overlays;for(var i=0;i<overlays.length;++i){overlays[i].draw();}//Turn off scissor test
gl.disable(gl.SCISSOR_TEST);gl.disable(gl.BLEND);gl.depthMask(true);};}();proto.drawPick=function(){return function(){if(this.static)return;var pickBuffer=this.pickBuffer;var gl=this.gl;this._pickTimeout=null;pickBuffer.begin();var pickOffset=1;var objects=this.objects;for(var i=0;i<objects.length;++i){pickOffset=objects[i].drawPick(pickOffset);}pickBuffer.end();};}();proto.pick=function(){return function(x,y){if(this.static)return;var pixelRatio=this.pixelRatio;var pickPixelRatio=this.pickPixelRatio;var viewBox=this.viewBox;var scrX=Math.round((x-viewBox[0]/pixelRatio)*pickPixelRatio)|0;var scrY=Math.round((y-viewBox[1]/pixelRatio)*pickPixelRatio)|0;var pickResult=this.pickBuffer.query(scrX,scrY,this.pickRadius);if(!pickResult){return null;}var pickValue=pickResult.id+(pickResult.value[0]<<8)+(pickResult.value[1]<<16)+(pickResult.value[2]<<24);var objects=this.objects;for(var i=0;i<objects.length;++i){var result=objects[i].pick(scrX,scrY,pickValue);if(result){return result;}}return null;};}();function deepClone(array){var result=array.slice();for(var i=0;i<result.length;++i){result[i]=result[i].slice();}return result;}function compareTicks(a,b){return a.x-b.x;}proto.setScreenBox=function(nbox){var screenBox=this.screenBox;var pixelRatio=this.pixelRatio;screenBox[0]=Math.round(nbox[0]*pixelRatio)|0;screenBox[1]=Math.round(nbox[1]*pixelRatio)|0;screenBox[2]=Math.round(nbox[2]*pixelRatio)|0;screenBox[3]=Math.round(nbox[3]*pixelRatio)|0;this.setDirty();};proto.setDataBox=function(nbox){var dataBox=this.dataBox;var different=dataBox[0]!==nbox[0]||dataBox[1]!==nbox[1]||dataBox[2]!==nbox[2]||dataBox[3]!==nbox[3];if(different){dataBox[0]=nbox[0];dataBox[1]=nbox[1];dataBox[2]=nbox[2];dataBox[3]=nbox[3];this.setDirty();}};proto.setViewBox=function(nbox){var pixelRatio=this.pixelRatio;var viewBox=this.viewBox;viewBox[0]=Math.round(nbox[0]*pixelRatio)|0;viewBox[1]=Math.round(nbox[1]*pixelRatio)|0;viewBox[2]=Math.round(nbox[2]*pixelRatio)|0;viewBox[3]=Math.round(nbox[3]*pixelRatio)|0;var pickPixelRatio=this.pickPixelRatio;this.pickBuffer.shape=[Math.round((nbox[2]-nbox[0])*pickPixelRatio)|0,Math.round((nbox[3]-nbox[1])*pickPixelRatio)|0];this.setDirty();};proto.update=function(options){options=options||{};var gl=this.gl;this.pixelRatio=options.pixelRatio||1;var pixelRatio=this.pixelRatio;this.pickPixelRatio=Math.max(pixelRatio,1);this.setScreenBox(options.screenBox||[0,0,gl.drawingBufferWidth/pixelRatio,gl.drawingBufferHeight/pixelRatio]);var screenBox=this.screenBox;this.setViewBox(options.viewBox||[0.125*(this.screenBox[2]-this.screenBox[0])/pixelRatio,0.125*(this.screenBox[3]-this.screenBox[1])/pixelRatio,0.875*(this.screenBox[2]-this.screenBox[0])/pixelRatio,0.875*(this.screenBox[3]-this.screenBox[1])/pixelRatio]);var viewBox=this.viewBox;var aspectRatio=(viewBox[2]-viewBox[0])/(viewBox[3]-viewBox[1]);this.setDataBox(options.dataBox||[-10,-10/aspectRatio,10,10/aspectRatio]);this.borderColor=options.borderColor!==false?(options.borderColor||[0,0,0,0]).slice():false;this.backgroundColor=(options.backgroundColor||[0,0,0,0]).slice();this.gridLineEnable=(options.gridLineEnable||[true,true]).slice();this.gridLineWidth=(options.gridLineWidth||[1,1]).slice();this.gridLineColor=deepClone(options.gridLineColor||[[0.5,0.5,0.5,1],[0.5,0.5,0.5,1]]);this.zeroLineEnable=(options.zeroLineEnable||[true,true]).slice();this.zeroLineWidth=(options.zeroLineWidth||[4,4]).slice();this.zeroLineColor=deepClone(options.zeroLineColor||[[0,0,0,1],[0,0,0,1]]);this.tickMarkLength=(options.tickMarkLength||[0,0,0,0]).slice();this.tickMarkWidth=(options.tickMarkWidth||[0,0,0,0]).slice();this.tickMarkColor=deepClone(options.tickMarkColor||[[0,0,0,1],[0,0,0,1],[0,0,0,1],[0,0,0,1]]);this.titleCenter=(options.titleCenter||[0.5*(viewBox[0]+viewBox[2])/pixelRatio,(viewBox[3]+120)/pixelRatio]).slice();this.titleEnable=!('titleEnable'in options)||!!options.titleEnable;this.titleAngle=options.titleAngle||0;this.titleColor=(options.titleColor||[0,0,0,1]).slice();this.labelPad=(options.labelPad||[15,15,15,15]).slice();this.labelAngle=(options.labelAngle||[0,Math.PI/2,0,3.0*Math.PI/2]).slice();this.labelEnable=(options.labelEnable||[true,true,true,true]).slice();this.labelColor=deepClone(options.labelColor||[[0,0,0,1],[0,0,0,1],[0,0,0,1],[0,0,0,1]]);this.tickPad=(options.tickPad||[15,15,15,15]).slice();this.tickAngle=(options.tickAngle||[0,0,0,0]).slice();this.tickEnable=(options.tickEnable||[true,true,true,true]).slice();this.tickColor=deepClone(options.tickColor||[[0,0,0,1],[0,0,0,1],[0,0,0,1],[0,0,0,1]]);this.borderLineEnable=(options.borderLineEnable||[true,true,true,true]).slice();this.borderLineWidth=(options.borderLineWidth||[2,2,2,2]).slice();this.borderLineColor=deepClone(options.borderLineColor||[[0,0,0,1],[0,0,0,1],[0,0,0,1],[0,0,0,1]]);var ticks=options.ticks||[[],[]];//Compute bounds on ticks
var bounds=this._tickBounds;bounds[0]=bounds[1]=Infinity;bounds[2]=bounds[3]=-Infinity;for(var i=0;i<2;++i){var axisTicks=ticks[i].slice(0);if(axisTicks.length===0){continue;}axisTicks.sort(compareTicks);bounds[i]=Math.min(bounds[i],axisTicks[0].x);bounds[i+2]=Math.max(bounds[i+2],axisTicks[axisTicks.length-1].x);}//Update grid
this.grid.update({bounds:bounds,ticks:ticks});//Update text
this.text.update({bounds:bounds,ticks:ticks,labels:options.labels||['x','y'],labelSize:options.labelSize||[12,12],labelFont:options.labelFont||['sans-serif','sans-serif'],labelFontStyle:options.labelFontStyle||['normal','normal'],labelFontWeight:options.labelFontWeight||['normal','normal'],labelFontVariant:options.labelFontVariant||['normal','normal'],title:options.title||'',titleSize:options.titleSize||18,titleFont:options.titleFont||'sans-serif',titleFontStyle:options.titleFontStyle||'normal',titleFontWeight:options.titleFontWeight||'normal',titleFontVariant:options.titleFontVariant||'normal'});this.static=!!options.static;this.setDirty();};proto.dispose=function(){this.box.dispose();this.grid.dispose();this.text.dispose();this.line.dispose();for(var i=this.objects.length-1;i>=0;--i){this.objects[i].dispose();}this.objects.length=0;for(var i=this.overlays.length-1;i>=0;--i){this.overlays[i].dispose();}this.overlays.length=0;this.gl=null;};proto.addObject=function(object){if(this.objects.indexOf(object)<0){this.objects.push(object);this.setDirty();}};proto.removeObject=function(object){var objects=this.objects;for(var i=0;i<objects.length;++i){if(objects[i]===object){objects.splice(i,1);this.setDirty();break;}}};proto.addOverlay=function(object){if(this.overlays.indexOf(object)<0){this.overlays.push(object);this.setOverlayDirty();}};proto.removeOverlay=function(object){var objects=this.overlays;for(var i=0;i<objects.length;++i){if(objects[i]===object){objects.splice(i,1);this.setOverlayDirty();break;}}};function createGLPlot2D(options){var gl=options.gl;var pickBuffer=createPick(gl,[gl.drawingBufferWidth,gl.drawingBufferHeight]);var plot=new GLPlot2D(gl,pickBuffer);plot.grid=createGrid(plot);plot.text=createText(plot);plot.line=createLine(plot);plot.box=createBox(plot);plot.update(options);return plot;}/***/}),/***/4437:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_428356__){"use strict";module.exports=createCamera;var now=__nested_webpack_require_428356__(3025);var createView=__nested_webpack_require_428356__(6296);var mouseChange=__nested_webpack_require_428356__(351);var mouseWheel=__nested_webpack_require_428356__(8512);var mouseOffset=__nested_webpack_require_428356__(24);var hasPassive=__nested_webpack_require_428356__(7520);function createCamera(element,options){element=element||document.body;options=options||{};var limits=[0.01,Infinity];if('distanceLimits'in options){limits[0]=options.distanceLimits[0];limits[1]=options.distanceLimits[1];}if('zoomMin'in options){limits[0]=options.zoomMin;}if('zoomMax'in options){limits[1]=options.zoomMax;}var view=createView({center:options.center||[0,0,0],up:options.up||[0,1,0],eye:options.eye||[0,0,10],mode:options.mode||'orbit',distanceLimits:limits});var pmatrix=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];var distance=0.0;var width=element.clientWidth;var height=element.clientHeight;var camera={keyBindingMode:'rotate',enableWheel:true,view:view,element:element,delay:options.delay||16,rotateSpeed:options.rotateSpeed||1,zoomSpeed:options.zoomSpeed||1,translateSpeed:options.translateSpeed||1,flipX:!!options.flipX,flipY:!!options.flipY,modes:view.modes,_ortho:options._ortho||options.projection&&options.projection.type==='orthographic'||false,tick:function(){var t=now();var delay=this.delay;var ctime=t-2*delay;view.idle(t-delay);view.recalcMatrix(ctime);view.flush(t-(100+delay*2));var allEqual=true;var matrix=view.computedMatrix;for(var i=0;i<16;++i){allEqual=allEqual&&pmatrix[i]===matrix[i];pmatrix[i]=matrix[i];}var sizeChanged=element.clientWidth===width&&element.clientHeight===height;width=element.clientWidth;height=element.clientHeight;if(allEqual){return!sizeChanged;}distance=Math.exp(view.computedRadius[0]);return true;},lookAt:function(eye,center,up){view.lookAt(view.lastT(),eye,center,up);},rotate:function(pitch,yaw,roll){view.rotate(view.lastT(),pitch,yaw,roll);},pan:function(dx,dy,dz){view.pan(view.lastT(),dx,dy,dz);},translate:function(dx,dy,dz){view.translate(view.lastT(),dx,dy,dz);}};Object.defineProperties(camera,{matrix:{get:function(){return view.computedMatrix;},set:function(mat){view.setMatrix(view.lastT(),mat);return view.computedMatrix;},enumerable:true},mode:{get:function(){return view.getMode();},set:function(mode){var curUp=view.computedUp.slice();var curEye=view.computedEye.slice();var curCenter=view.computedCenter.slice();view.setMode(mode);if(mode==='turntable'){// Hacky time warping stuff to generate smooth animation
var t0=now();view._active.lookAt(t0,curEye,curCenter,curUp);view._active.lookAt(t0+500,curEye,curCenter,[0,0,1]);view._active.flush(t0);}return view.getMode();},enumerable:true},center:{get:function(){return view.computedCenter;},set:function(ncenter){view.lookAt(view.lastT(),null,ncenter);return view.computedCenter;},enumerable:true},eye:{get:function(){return view.computedEye;},set:function(neye){view.lookAt(view.lastT(),neye);return view.computedEye;},enumerable:true},up:{get:function(){return view.computedUp;},set:function(nup){view.lookAt(view.lastT(),null,null,nup);return view.computedUp;},enumerable:true},distance:{get:function(){return distance;},set:function(d){view.setDistance(view.lastT(),d);return d;},enumerable:true},distanceLimits:{get:function(){return view.getDistanceLimits(limits);},set:function(v){view.setDistanceLimits(v);return v;},enumerable:true}});element.addEventListener('contextmenu',function(ev){ev.preventDefault();return false;});camera._lastX=-1;camera._lastY=-1;camera._lastMods={shift:false,control:false,alt:false,meta:false};camera.enableMouseListeners=function(){camera.mouseListener=mouseChange(element,handleInteraction);//enable simple touch interactions
element.addEventListener('touchstart',function(ev){var xy=mouseOffset(ev.changedTouches[0],element);handleInteraction(0,xy[0],xy[1],camera._lastMods);handleInteraction(1,xy[0],xy[1],camera._lastMods);},hasPassive?{passive:true}:false);element.addEventListener('touchmove',function(ev){var xy=mouseOffset(ev.changedTouches[0],element);handleInteraction(1,xy[0],xy[1],camera._lastMods);ev.preventDefault();},hasPassive?{passive:false}:false);element.addEventListener('touchend',function(ev){handleInteraction(0,camera._lastX,camera._lastY,camera._lastMods);},hasPassive?{passive:true}:false);function handleInteraction(buttons,x,y,mods){var keyBindingMode=camera.keyBindingMode;if(keyBindingMode===false)return;var rotate=keyBindingMode==='rotate';var pan=keyBindingMode==='pan';var zoom=keyBindingMode==='zoom';var ctrl=!!mods.control;var alt=!!mods.alt;var shift=!!mods.shift;var left=!!(buttons&1);var right=!!(buttons&2);var middle=!!(buttons&4);var scale=1.0/element.clientHeight;var dx=scale*(x-camera._lastX);var dy=scale*(y-camera._lastY);var flipX=camera.flipX?1:-1;var flipY=camera.flipY?1:-1;var drot=Math.PI*camera.rotateSpeed;var t=now();if(camera._lastX!==-1&&camera._lastY!==-1){if(rotate&&left&&!ctrl&&!alt&&!shift||left&&!ctrl&&!alt&&shift){// Rotate
view.rotate(t,flipX*drot*dx,-flipY*drot*dy,0);}if(pan&&left&&!ctrl&&!alt&&!shift||right||left&&ctrl&&!alt&&!shift){// Pan
view.pan(t,-camera.translateSpeed*dx*distance,camera.translateSpeed*dy*distance,0);}if(zoom&&left&&!ctrl&&!alt&&!shift||middle||left&&!ctrl&&alt&&!shift){// Zoom
var kzoom=-camera.zoomSpeed*dy/window.innerHeight*(t-view.lastT())*100;view.pan(t,0,0,distance*(Math.exp(kzoom)-1));}}camera._lastX=x;camera._lastY=y;camera._lastMods=mods;return true;}camera.wheelListener=mouseWheel(element,function(dx,dy){// TODO remove now that we can disable scroll via scrollZoom?
if(camera.keyBindingMode===false)return;if(!camera.enableWheel)return;var flipX=camera.flipX?1:-1;var flipY=camera.flipY?1:-1;var t=now();if(Math.abs(dx)>Math.abs(dy)){view.rotate(t,0,0,-dx*flipX*Math.PI*camera.rotateSpeed/window.innerWidth);}else{if(!camera._ortho){var kzoom=-camera.zoomSpeed*flipY*dy/window.innerHeight*(t-view.lastT())/20.0;view.pan(t,0,0,distance*(Math.exp(kzoom)-1));}}},true);};camera.enableMouseListeners();return camera;}/***/}),/***/799:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_434412__){var glslify=__nested_webpack_require_434412__(3236);var createShader=__nested_webpack_require_434412__(9405);var vertSrc=glslify(["precision mediump float;\n#define GLSLIFY 1\nattribute vec2 position;\nvarying vec2 uv;\nvoid main() {\n  uv = position;\n  gl_Position = vec4(position, 0, 1);\n}"]);var fragSrc=glslify(["precision mediump float;\n#define GLSLIFY 1\n\nuniform sampler2D accumBuffer;\nvarying vec2 uv;\n\nvoid main() {\n  vec4 accum = texture2D(accumBuffer, 0.5 * (uv + 1.0));\n  gl_FragColor = min(vec4(1,1,1,1), accum);\n}"]);module.exports=function(gl){return createShader(gl,vertSrc,fragSrc,null,[{name:'position',type:'vec2'}]);};/***/}),/***/4100:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_435118__){"use strict";var createCamera=__nested_webpack_require_435118__(4437);var createAxes=__nested_webpack_require_435118__(3837);var axesRanges=__nested_webpack_require_435118__(5445);var createSpikes=__nested_webpack_require_435118__(4449);var createSelect=__nested_webpack_require_435118__(3589);var createFBO=__nested_webpack_require_435118__(2260);var drawTriangle=__nested_webpack_require_435118__(7169);var mouseChange=__nested_webpack_require_435118__(351);var perspective=__nested_webpack_require_435118__(4772);var ortho=__nested_webpack_require_435118__(4040);var createShader=__nested_webpack_require_435118__(799);var isMobile=__nested_webpack_require_435118__(9216)({tablet:true,featureDetect:true});module.exports={createScene:createScene,createCamera:createCamera};function MouseSelect(){this.mouse=[-1,-1];this.screen=null;this.distance=Infinity;this.index=null;this.dataCoordinate=null;this.dataPosition=null;this.object=null;this.data=null;}function getContext(canvas,options){var gl=null;try{gl=canvas.getContext('webgl',options);if(!gl){gl=canvas.getContext('experimental-webgl',options);}}catch(e){return null;}return gl;}function roundUpPow10(x){var y=Math.round(Math.log(Math.abs(x))/Math.log(10));if(y<0){var base=Math.round(Math.pow(10,-y));return Math.ceil(x*base)/base;}else if(y>0){var base=Math.round(Math.pow(10,y));return Math.ceil(x/base)*base;}return Math.ceil(x);}function defaultBool(x){if(typeof x==='boolean'){return x;}return true;}function createScene(options){options=options||{};options.camera=options.camera||{};var canvas=options.canvas;if(!canvas){canvas=document.createElement('canvas');if(options.container){var container=options.container;container.appendChild(canvas);}else{document.body.appendChild(canvas);}}var gl=options.gl;if(!gl){if(options.glOptions){isMobile=!!options.glOptions.preserveDrawingBuffer;}gl=getContext(canvas,options.glOptions||{premultipliedAlpha:true,antialias:true,preserveDrawingBuffer:isMobile});}if(!gl){throw new Error('webgl not supported');}//Initial bounds
var bounds=options.bounds||[[-10,-10,-10],[10,10,10]];//Create selection
var selection=new MouseSelect();//Accumulation buffer
var accumBuffer=createFBO(gl,gl.drawingBufferWidth,gl.drawingBufferHeight,{preferFloat:!isMobile});var accumShader=createShader(gl);var isOrtho=options.cameraObject&&options.cameraObject._ortho===true||options.camera.projection&&options.camera.projection.type==='orthographic'||false;//Create a camera
var cameraOptions={eye:options.camera.eye||[2,0,0],center:options.camera.center||[0,0,0],up:options.camera.up||[0,1,0],zoomMin:options.camera.zoomMax||0.1,zoomMax:options.camera.zoomMin||100,mode:options.camera.mode||'turntable',_ortho:isOrtho};//Create axes
var axesOptions=options.axes||{};var axes=createAxes(gl,axesOptions);axes.enable=!axesOptions.disable;//Create spikes
var spikeOptions=options.spikes||{};var spikes=createSpikes(gl,spikeOptions);//Object list is empty initially
var objects=[];var pickBufferIds=[];var pickBufferCount=[];var pickBuffers=[];//Dirty flag, skip redraw if scene static
var dirty=true;var pickDirty=true;var projection=new Array(16);var model=new Array(16);var cameraParams={view:null,projection:projection,model:model,_ortho:false};var pickDirty=true;var viewShape=[gl.drawingBufferWidth,gl.drawingBufferHeight];var camera=options.cameraObject||createCamera(canvas,cameraOptions);//Create scene object
var scene={gl:gl,contextLost:false,pixelRatio:options.pixelRatio||1,canvas:canvas,selection:selection,camera:camera,axes:axes,axesPixels:null,spikes:spikes,bounds:bounds,objects:objects,shape:viewShape,aspect:options.aspectRatio||[1,1,1],pickRadius:options.pickRadius||10,zNear:options.zNear||0.01,zFar:options.zFar||1000,fovy:options.fovy||Math.PI/4,clearColor:options.clearColor||[0,0,0,0],autoResize:defaultBool(options.autoResize),autoBounds:defaultBool(options.autoBounds),autoScale:!!options.autoScale,autoCenter:defaultBool(options.autoCenter),clipToBounds:defaultBool(options.clipToBounds),snapToData:!!options.snapToData,onselect:options.onselect||null,onrender:options.onrender||null,onclick:options.onclick||null,cameraParams:cameraParams,oncontextloss:null,mouseListener:null,_stopped:false,getAspectratio:function(){return{x:this.aspect[0],y:this.aspect[1],z:this.aspect[2]};},setAspectratio:function(aspectratio){this.aspect[0]=aspectratio.x;this.aspect[1]=aspectratio.y;this.aspect[2]=aspectratio.z;pickDirty=true;},setBounds:function(axisIndex,range){this.bounds[0][axisIndex]=range.min;this.bounds[1][axisIndex]=range.max;},setClearColor:function(clearColor){this.clearColor=clearColor;},clearRGBA:function(){this.gl.clearColor(this.clearColor[0],this.clearColor[1],this.clearColor[2],this.clearColor[3]);this.gl.clear(this.gl.COLOR_BUFFER_BIT|this.gl.DEPTH_BUFFER_BIT);}};var pickShape=[gl.drawingBufferWidth/scene.pixelRatio|0,gl.drawingBufferHeight/scene.pixelRatio|0];function resizeListener(){if(scene._stopped){return;}if(!scene.autoResize){return;}var parent=canvas.parentNode;var width=1;var height=1;if(parent&&parent!==document.body){width=parent.clientWidth;height=parent.clientHeight;}else{width=window.innerWidth;height=window.innerHeight;}var nextWidth=Math.ceil(width*scene.pixelRatio)|0;var nextHeight=Math.ceil(height*scene.pixelRatio)|0;if(nextWidth!==canvas.width||nextHeight!==canvas.height){canvas.width=nextWidth;canvas.height=nextHeight;var style=canvas.style;style.position=style.position||'absolute';style.left='0px';style.top='0px';style.width=width+'px';style.height=height+'px';dirty=true;}}if(scene.autoResize){resizeListener();}window.addEventListener('resize',resizeListener);function reallocPickIds(){var numObjs=objects.length;var numPick=pickBuffers.length;for(var i=0;i<numPick;++i){pickBufferCount[i]=0;}obj_loop:for(var i=0;i<numObjs;++i){var obj=objects[i];var pickCount=obj.pickSlots;if(!pickCount){pickBufferIds[i]=-1;continue;}for(var j=0;j<numPick;++j){if(pickBufferCount[j]+pickCount<255){pickBufferIds[i]=j;obj.setPickBase(pickBufferCount[j]+1);pickBufferCount[j]+=pickCount;continue obj_loop;}}//Create new pick buffer
var nbuffer=createSelect(gl,viewShape);pickBufferIds[i]=numPick;pickBuffers.push(nbuffer);pickBufferCount.push(pickCount);obj.setPickBase(1);numPick+=1;}while(numPick>0&&pickBufferCount[numPick-1]===0){pickBufferCount.pop();pickBuffers.pop().dispose();}}scene.update=function(options){if(scene._stopped){return;}options=options||{};dirty=true;pickDirty=true;};scene.add=function(obj){if(scene._stopped){return;}obj.axes=axes;objects.push(obj);pickBufferIds.push(-1);dirty=true;pickDirty=true;reallocPickIds();};scene.remove=function(obj){if(scene._stopped){return;}var idx=objects.indexOf(obj);if(idx<0){return;}objects.splice(idx,1);pickBufferIds.pop();dirty=true;pickDirty=true;reallocPickIds();};scene.dispose=function(){if(scene._stopped){return;}scene._stopped=true;window.removeEventListener('resize',resizeListener);canvas.removeEventListener('webglcontextlost',checkContextLoss);scene.mouseListener.enabled=false;if(scene.contextLost){return;}//Destroy objects
axes.dispose();spikes.dispose();for(var i=0;i<objects.length;++i){objects[i].dispose();}//Clean up buffers
accumBuffer.dispose();for(var i=0;i<pickBuffers.length;++i){pickBuffers[i].dispose();}//Clean up shaders
accumShader.dispose();//Release all references
gl=null;axes=null;spikes=null;objects=[];};//Update mouse position
scene._mouseRotating=false;scene._prevButtons=0;scene.enableMouseListeners=function(){scene.mouseListener=mouseChange(canvas,function(buttons,x,y){if(scene._stopped){return;}var numPick=pickBuffers.length;var numObjs=objects.length;var prevObj=selection.object;selection.distance=Infinity;selection.mouse[0]=x;selection.mouse[1]=y;selection.object=null;selection.screen=null;selection.dataCoordinate=selection.dataPosition=null;var change=false;if(buttons&&scene._prevButtons){scene._mouseRotating=true;}else{if(scene._mouseRotating){pickDirty=true;}scene._mouseRotating=false;for(var i=0;i<numPick;++i){var result=pickBuffers[i].query(x,pickShape[1]-y-1,scene.pickRadius);if(result){if(result.distance>selection.distance){continue;}for(var j=0;j<numObjs;++j){var obj=objects[j];if(pickBufferIds[j]!==i){continue;}var objPick=obj.pick(result);if(objPick){selection.buttons=buttons;selection.screen=result.coord;selection.distance=result.distance;selection.object=obj;selection.index=objPick.distance;selection.dataPosition=objPick.position;selection.dataCoordinate=objPick.dataCoordinate;selection.data=objPick;change=true;}}}}}if(prevObj&&prevObj!==selection.object){if(prevObj.highlight){prevObj.highlight(null);}dirty=true;}if(selection.object){if(selection.object.highlight){selection.object.highlight(selection.data);}dirty=true;}change=change||selection.object!==prevObj;if(change&&scene.onselect){scene.onselect(selection);}if(buttons&1&&!(scene._prevButtons&1)&&scene.onclick){scene.onclick(selection);}scene._prevButtons=buttons;});};function checkContextLoss(){if(scene.contextLost){return true;}if(gl.isContextLost()){scene.contextLost=true;scene.mouseListener.enabled=false;scene.selection.object=null;if(scene.oncontextloss){scene.oncontextloss();}}}canvas.addEventListener('webglcontextlost',checkContextLoss);//Render the scene for mouse picking
function renderPick(){if(checkContextLoss()){return;}gl.colorMask(true,true,true,true);gl.depthMask(true);gl.disable(gl.BLEND);gl.enable(gl.DEPTH_TEST);gl.depthFunc(gl.LEQUAL);var numObjs=objects.length;var numPick=pickBuffers.length;for(var j=0;j<numPick;++j){var buf=pickBuffers[j];buf.shape=pickShape;buf.begin();for(var i=0;i<numObjs;++i){if(pickBufferIds[i]!==j){continue;}var obj=objects[i];if(obj.drawPick){obj.pixelRatio=1;obj.drawPick(cameraParams);}}buf.end();}}var nBounds=[[Infinity,Infinity,Infinity],[-Infinity,-Infinity,-Infinity]];var prevBounds=[nBounds[0].slice(),nBounds[1].slice()];function redraw(){if(checkContextLoss()){return;}resizeListener();//Tick camera
var cameraMoved=scene.camera.tick();cameraParams.view=scene.camera.matrix;dirty=dirty||cameraMoved;pickDirty=pickDirty||cameraMoved;//Set pixel ratio
axes.pixelRatio=scene.pixelRatio;spikes.pixelRatio=scene.pixelRatio;//Check if any objects changed, recalculate bounds
var numObjs=objects.length;var lo=nBounds[0];var hi=nBounds[1];lo[0]=lo[1]=lo[2]=Infinity;hi[0]=hi[1]=hi[2]=-Infinity;for(var i=0;i<numObjs;++i){var obj=objects[i];//Set the axes properties for each object
obj.pixelRatio=scene.pixelRatio;obj.axes=scene.axes;dirty=dirty||!!obj.dirty;pickDirty=pickDirty||!!obj.dirty;var obb=obj.bounds;if(obb){var olo=obb[0];var ohi=obb[1];for(var j=0;j<3;++j){lo[j]=Math.min(lo[j],olo[j]);hi[j]=Math.max(hi[j],ohi[j]);}}}//Recalculate bounds
var bounds=scene.bounds;if(scene.autoBounds){for(var j=0;j<3;++j){if(hi[j]<lo[j]){lo[j]=-1;hi[j]=1;}else{if(lo[j]===hi[j]){lo[j]-=1;hi[j]+=1;}var padding=0.05*(hi[j]-lo[j]);lo[j]=lo[j]-padding;hi[j]=hi[j]+padding;}bounds[0][j]=lo[j];bounds[1][j]=hi[j];}}var boundsChanged=false;for(var j=0;j<3;++j){boundsChanged=boundsChanged||prevBounds[0][j]!==bounds[0][j]||prevBounds[1][j]!==bounds[1][j];prevBounds[0][j]=bounds[0][j];prevBounds[1][j]=bounds[1][j];}//Recalculate bounds
pickDirty=pickDirty||boundsChanged;dirty=dirty||boundsChanged;if(!dirty){return;}if(boundsChanged){var tickSpacing=[0,0,0];for(var i=0;i<3;++i){tickSpacing[i]=roundUpPow10((bounds[1][i]-bounds[0][i])/10.0);}if(axes.autoTicks){axes.update({bounds:bounds,tickSpacing:tickSpacing});}else{axes.update({bounds:bounds});}}//Get scene
var width=gl.drawingBufferWidth;var height=gl.drawingBufferHeight;viewShape[0]=width;viewShape[1]=height;pickShape[0]=Math.max(width/scene.pixelRatio,1)|0;pickShape[1]=Math.max(height/scene.pixelRatio,1)|0;//Compute camera parameters
calcCameraParams(scene,isOrtho);//Apply axes/clip bounds
for(var i=0;i<numObjs;++i){var obj=objects[i];//Set axes bounds
obj.axesBounds=bounds;//Set clip bounds
if(scene.clipToBounds){obj.clipBounds=bounds;}}//Set spike parameters
if(selection.object){if(scene.snapToData){spikes.position=selection.dataCoordinate;}else{spikes.position=selection.dataPosition;}spikes.bounds=bounds;}//If state changed, then redraw pick buffers
if(pickDirty){pickDirty=false;renderPick();}//Recalculate pixel data
scene.axesPixels=axesRanges(scene.axes,cameraParams,width,height);//Call render callback
if(scene.onrender){scene.onrender();}//Read value
gl.bindFramebuffer(gl.FRAMEBUFFER,null);gl.viewport(0,0,width,height);//General strategy: 3 steps
//  1. render non-transparent objects
//  2. accumulate transparent objects into separate fbo
//  3. composite final scene
//Clear FBO
scene.clearRGBA();gl.depthMask(true);gl.colorMask(true,true,true,true);gl.enable(gl.DEPTH_TEST);gl.depthFunc(gl.LEQUAL);gl.disable(gl.BLEND);gl.disable(gl.CULL_FACE);//most visualization surfaces are 2 sided
//Render opaque pass
var hasTransparent=false;if(axes.enable){hasTransparent=hasTransparent||axes.isTransparent();axes.draw(cameraParams);}spikes.axes=axes;if(selection.object){spikes.draw(cameraParams);}gl.disable(gl.CULL_FACE);//most visualization surfaces are 2 sided
for(var i=0;i<numObjs;++i){var obj=objects[i];obj.axes=axes;obj.pixelRatio=scene.pixelRatio;if(obj.isOpaque&&obj.isOpaque()){obj.draw(cameraParams);}if(obj.isTransparent&&obj.isTransparent()){hasTransparent=true;}}if(hasTransparent){//Render transparent pass
accumBuffer.shape=viewShape;accumBuffer.bind();gl.clear(gl.DEPTH_BUFFER_BIT);gl.colorMask(false,false,false,false);gl.depthMask(true);gl.depthFunc(gl.LESS);//Render forward facing objects
if(axes.enable&&axes.isTransparent()){axes.drawTransparent(cameraParams);}for(var i=0;i<numObjs;++i){var obj=objects[i];if(obj.isOpaque&&obj.isOpaque()){obj.draw(cameraParams);}}//Render transparent pass
gl.enable(gl.BLEND);gl.blendEquation(gl.FUNC_ADD);gl.blendFunc(gl.ONE,gl.ONE_MINUS_SRC_ALPHA);gl.colorMask(true,true,true,true);gl.depthMask(false);gl.clearColor(0,0,0,0);gl.clear(gl.COLOR_BUFFER_BIT);if(axes.isTransparent()){axes.drawTransparent(cameraParams);}for(var i=0;i<numObjs;++i){var obj=objects[i];if(obj.isTransparent&&obj.isTransparent()){obj.drawTransparent(cameraParams);}}//Unbind framebuffer
gl.bindFramebuffer(gl.FRAMEBUFFER,null);//Draw composite pass
gl.blendFunc(gl.ONE,gl.ONE_MINUS_SRC_ALPHA);gl.disable(gl.DEPTH_TEST);accumShader.bind();accumBuffer.color[0].bind(0);accumShader.uniforms.accumBuffer=0;drawTriangle(gl);//Turn off blending
gl.disable(gl.BLEND);}//Clear dirty flags
dirty=false;for(var i=0;i<numObjs;++i){objects[i].dirty=false;}}//Draw the whole scene
function render(){if(scene._stopped||scene.contextLost){return;}// this order is important: ios safari sometimes has sync raf
redraw();requestAnimationFrame(render);}scene.enableMouseListeners();render();//Force redraw of whole scene
scene.redraw=function(){if(scene._stopped){return;}dirty=true;redraw();};return scene;}function calcCameraParams(scene,isOrtho){var bounds=scene.bounds;var cameraParams=scene.cameraParams;var projection=cameraParams.projection;var model=cameraParams.model;var width=scene.gl.drawingBufferWidth;var height=scene.gl.drawingBufferHeight;var zNear=scene.zNear;var zFar=scene.zFar;var fovy=scene.fovy;var r=width/height;if(isOrtho){ortho(projection,-r,r,-1,1,zNear,zFar);cameraParams._ortho=true;}else{perspective(projection,fovy,r,zNear,zFar);cameraParams._ortho=false;}//Compute model matrix
for(var i=0;i<16;++i){model[i]=0;}model[15]=1;var maxS=0;for(var i=0;i<3;++i){maxS=Math.max(maxS,bounds[1][i]-bounds[0][i]);}for(var i=0;i<3;++i){if(scene.autoScale){model[5*i]=scene.aspect[i]/(bounds[1][i]-bounds[0][i]);}else{model[5*i]=1/maxS;}if(scene.autoCenter){model[12+i]=-model[5*i]*0.5*(bounds[0][i]+bounds[1][i]);}}}/***/}),/***/6640:(/***/function(__unused_webpack_module,exports,__nested_webpack_require_450675__){var glslify=__nested_webpack_require_450675__(3236);exports.pointVertex=glslify(["precision mediump float;\n#define GLSLIFY 1\n\nattribute vec2 position;\n\nuniform mat3 matrix;\nuniform float pointSize;\nuniform float pointCloud;\n\nhighp float rand(vec2 co) {\n  highp float a = 12.9898;\n  highp float b = 78.233;\n  highp float c = 43758.5453;\n  highp float d = dot(co.xy, vec2(a, b));\n  highp float e = mod(d, 3.14);\n  return fract(sin(e) * c);\n}\n\nvoid main() {\n  vec3 hgPosition = matrix * vec3(position, 1);\n  gl_Position  = vec4(hgPosition.xy, 0, hgPosition.z);\n    // if we don't jitter the point size a bit, overall point cloud\n    // saturation 'jumps' on zooming, which is disturbing and confusing\n  gl_PointSize = pointSize * ((19.5 + rand(position)) / 20.0);\n  if(pointCloud != 0.0) { // pointCloud is truthy\n    // get the same square surface as circle would be\n    gl_PointSize *= 0.886;\n  }\n}"]);exports.pointFragment=glslify(["precision mediump float;\n#define GLSLIFY 1\n\nuniform vec4 color, borderColor;\nuniform float centerFraction;\nuniform float pointCloud;\n\nvoid main() {\n  float radius;\n  vec4 baseColor;\n  if(pointCloud != 0.0) { // pointCloud is truthy\n    if(centerFraction == 1.0) {\n      gl_FragColor = color;\n    } else {\n      gl_FragColor = mix(borderColor, color, centerFraction);\n    }\n  } else {\n    radius = length(2.0 * gl_PointCoord.xy - 1.0);\n    if(radius > 1.0) {\n      discard;\n    }\n    baseColor = mix(borderColor, color, step(radius, centerFraction));\n    gl_FragColor = vec4(baseColor.rgb * baseColor.a, baseColor.a);\n  }\n}\n"]);exports.pickVertex=glslify(["precision mediump float;\n#define GLSLIFY 1\n\nattribute vec2 position;\nattribute vec4 pickId;\n\nuniform mat3 matrix;\nuniform float pointSize;\nuniform vec4 pickOffset;\n\nvarying vec4 fragId;\n\nvoid main() {\n  vec3 hgPosition = matrix * vec3(position, 1);\n  gl_Position  = vec4(hgPosition.xy, 0, hgPosition.z);\n  gl_PointSize = pointSize;\n\n  vec4 id = pickId + pickOffset;\n  id.y += floor(id.x / 256.0);\n  id.x -= floor(id.x / 256.0) * 256.0;\n\n  id.z += floor(id.y / 256.0);\n  id.y -= floor(id.y / 256.0) * 256.0;\n\n  id.w += floor(id.z / 256.0);\n  id.z -= floor(id.z / 256.0) * 256.0;\n\n  fragId = id;\n}\n"]);exports.pickFragment=glslify(["precision mediump float;\n#define GLSLIFY 1\n\nvarying vec4 fragId;\n\nvoid main() {\n  float radius = length(2.0 * gl_PointCoord.xy - 1.0);\n  if(radius > 1.0) {\n    discard;\n  }\n  gl_FragColor = fragId / 255.0;\n}\n"]);/***/}),/***/4696:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_453273__){"use strict";var createShader=__nested_webpack_require_453273__(9405);var createBuffer=__nested_webpack_require_453273__(2762);var pool=__nested_webpack_require_453273__(1888);var SHADERS=__nested_webpack_require_453273__(6640);module.exports=createPointcloud2D;function Pointcloud2D(plot,offsetBuffer,pickBuffer,shader,pickShader){this.plot=plot;this.offsetBuffer=offsetBuffer;this.pickBuffer=pickBuffer;this.shader=shader;this.pickShader=pickShader;this.sizeMin=0.5;this.sizeMinCap=2;this.sizeMax=20;this.areaRatio=1.0;this.pointCount=0;this.color=[1,0,0,1];this.borderColor=[0,0,0,1];this.blend=false;this.pickOffset=0;this.points=null;}var proto=Pointcloud2D.prototype;proto.dispose=function(){this.shader.dispose();this.pickShader.dispose();this.offsetBuffer.dispose();this.pickBuffer.dispose();this.plot.removeObject(this);};proto.update=function(options){var i;options=options||{};function dflt(opt,value){if(opt in options){return options[opt];}return value;}this.sizeMin=dflt('sizeMin',0.5);// this.sizeMinCap      = dflt('sizeMinCap', 2)
this.sizeMax=dflt('sizeMax',20);this.color=dflt('color',[1,0,0,1]).slice();this.areaRatio=dflt('areaRatio',1);this.borderColor=dflt('borderColor',[0,0,0,1]).slice();this.blend=dflt('blend',false);//Update point data
// Attempt straight-through processing (STP) to avoid allocation and copy
// TODO eventually abstract out STP logic, maybe into `pool` or a layer above
var pointCount=options.positions.length>>>1;var dataStraightThrough=options.positions instanceof Float32Array;var idStraightThrough=options.idToIndex instanceof Int32Array&&options.idToIndex.length>=pointCount;// permit larger to help reuse
var data=options.positions;var packed=dataStraightThrough?data:pool.mallocFloat32(data.length);var packedId=idStraightThrough?options.idToIndex:pool.mallocInt32(pointCount);if(!dataStraightThrough){packed.set(data);}if(!idStraightThrough){packed.set(data);for(i=0;i<pointCount;i++){packedId[i]=i;}}this.points=data;this.offsetBuffer.update(packed);this.pickBuffer.update(packedId);if(!dataStraightThrough){pool.free(packed);}if(!idStraightThrough){pool.free(packedId);}this.pointCount=pointCount;this.pickOffset=0;};function count(points,dataBox){var visiblePointCountEstimate=0;var length=points.length>>>1;var i;for(i=0;i<length;i++){var x=points[i*2];var y=points[i*2+1];if(x>=dataBox[0]&&x<=dataBox[2]&&y>=dataBox[1]&&y<=dataBox[3])visiblePointCountEstimate++;}return visiblePointCountEstimate;}proto.unifiedDraw=function(){var MATRIX=[1,0,0,0,1,0,0,0,1];var PICK_VEC4=[0,0,0,0];return function(pickOffset){var pick=pickOffset!==void 0;var shader=pick?this.pickShader:this.shader;var gl=this.plot.gl;var dataBox=this.plot.dataBox;if(this.pointCount===0){return pickOffset;}var dataX=dataBox[2]-dataBox[0];var dataY=dataBox[3]-dataBox[1];var visiblePointCountEstimate=count(this.points,dataBox);var basicPointSize=this.plot.pickPixelRatio*Math.max(Math.min(this.sizeMinCap,this.sizeMin),Math.min(this.sizeMax,this.sizeMax/Math.pow(visiblePointCountEstimate,0.33333)));MATRIX[0]=2.0/dataX;MATRIX[4]=2.0/dataY;MATRIX[6]=-2.0*dataBox[0]/dataX-1.0;MATRIX[7]=-2.0*dataBox[1]/dataY-1.0;this.offsetBuffer.bind();shader.bind();shader.attributes.position.pointer();shader.uniforms.matrix=MATRIX;shader.uniforms.color=this.color;shader.uniforms.borderColor=this.borderColor;shader.uniforms.pointCloud=basicPointSize<5;shader.uniforms.pointSize=basicPointSize;shader.uniforms.centerFraction=Math.min(1,Math.max(0,Math.sqrt(1-this.areaRatio)));if(pick){PICK_VEC4[0]=pickOffset&0xff;PICK_VEC4[1]=pickOffset>>8&0xff;PICK_VEC4[2]=pickOffset>>16&0xff;PICK_VEC4[3]=pickOffset>>24&0xff;this.pickBuffer.bind();shader.attributes.pickId.pointer(gl.UNSIGNED_BYTE);shader.uniforms.pickOffset=PICK_VEC4;this.pickOffset=pickOffset;}// Worth switching these off, but we can't make assumptions about other
// renderers, so let's restore it after each draw
var blend=gl.getParameter(gl.BLEND);var dither=gl.getParameter(gl.DITHER);if(blend&&!this.blend)gl.disable(gl.BLEND);if(dither)gl.disable(gl.DITHER);gl.drawArrays(gl.POINTS,0,this.pointCount);if(blend&&!this.blend)gl.enable(gl.BLEND);if(dither)gl.enable(gl.DITHER);return pickOffset+this.pointCount;};}();proto.draw=proto.unifiedDraw;proto.drawPick=proto.unifiedDraw;proto.pick=function(x,y,value){var pickOffset=this.pickOffset;var pointCount=this.pointCount;if(value<pickOffset||value>=pickOffset+pointCount){return null;}var pointId=value-pickOffset;var points=this.points;return{object:this,pointId:pointId,dataCoord:[points[2*pointId],points[2*pointId+1]]};};function createPointcloud2D(plot,options){var gl=plot.gl;var buffer=createBuffer(gl);var pickBuffer=createBuffer(gl);var shader=createShader(gl,SHADERS.pointVertex,SHADERS.pointFragment);var pickShader=createShader(gl,SHADERS.pickVertex,SHADERS.pickFragment);var result=new Pointcloud2D(plot,buffer,pickBuffer,shader,pickShader);result.update(options);//Register with plot
plot.addObject(result);return result;}/***/}),/***/783:(/***/function(module){module.exports=slerp;/**
 * Performs a spherical linear interpolation between two quat
 *
 * @param {quat} out the receiving quaternion
 * @param {quat} a the first operand
 * @param {quat} b the second operand
 * @param {Number} t interpolation amount between the two inputs
 * @returns {quat} out
 */function slerp(out,a,b,t){// benchmarks:
//    http://jsperf.com/quaternion-slerp-implementations
var ax=a[0],ay=a[1],az=a[2],aw=a[3],bx=b[0],by=b[1],bz=b[2],bw=b[3];var omega,cosom,sinom,scale0,scale1;// calc cosine
cosom=ax*bx+ay*by+az*bz+aw*bw;// adjust signs (if necessary)
if(cosom<0.0){cosom=-cosom;bx=-bx;by=-by;bz=-bz;bw=-bw;}// calculate coefficients
if(1.0-cosom>0.000001){// standard case (slerp)
omega=Math.acos(cosom);sinom=Math.sin(omega);scale0=Math.sin((1.0-t)*omega)/sinom;scale1=Math.sin(t*omega)/sinom;}else{// "from" and "to" quaternions are very close
//  ... so we can do a linear interpolation
scale0=1.0-t;scale1=t;}// calculate final values
out[0]=scale0*ax+scale1*bx;out[1]=scale0*ay+scale1*by;out[2]=scale0*az+scale1*bz;out[3]=scale0*aw+scale1*bw;return out;}/***/}),/***/5964:(/***/function(module){"use strict";module.exports=function(a){return!a&&a!==0?'':a.toString();};/***/}),/***/9366:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_459510__){"use strict";var vectorizeText=__nested_webpack_require_459510__(4359);module.exports=getGlyph;var GLYPH_CACHE={};function getGlyph(symbol,font,pixelRatio){var fontKey=[font.style,font.weight,font.variant,font.family].join('_');var fontCache=GLYPH_CACHE[fontKey];if(!fontCache){fontCache=GLYPH_CACHE[fontKey]={};}if(symbol in fontCache){return fontCache[symbol];}var config={textAlign:"center",textBaseline:"middle",lineHeight:1.0,font:font.family,fontStyle:font.style,fontWeight:font.weight,fontVariant:font.variant,lineSpacing:1.25,styletags:{breaklines:true,bolds:true,italics:true,subscripts:true,superscripts:true}};//Get line and triangle meshes for glyph
config.triangles=true;var triSymbol=vectorizeText(symbol,config);config.triangles=false;var lineSymbol=vectorizeText(symbol,config);var i,j;if(pixelRatio&&pixelRatio!==1){for(i=0;i<triSymbol.positions.length;++i){for(j=0;j<triSymbol.positions[i].length;++j){triSymbol.positions[i][j]/=pixelRatio;}}for(i=0;i<lineSymbol.positions.length;++i){for(j=0;j<lineSymbol.positions[i].length;++j){lineSymbol.positions[i][j]/=pixelRatio;}}}//Calculate bounding box
var bounds=[[Infinity,Infinity],[-Infinity,-Infinity]];var n=lineSymbol.positions.length;for(i=0;i<n;++i){var p=lineSymbol.positions[i];for(j=0;j<2;++j){bounds[0][j]=Math.min(bounds[0][j],p[j]);bounds[1][j]=Math.max(bounds[1][j],p[j]);}}//Save cached symbol
return fontCache[symbol]=[triSymbol,lineSymbol,bounds];}/***/}),/***/1283:(/***/function(__unused_webpack_module,exports,__nested_webpack_require_461012__){var createShaderWrapper=__nested_webpack_require_461012__(9405);var glslify=__nested_webpack_require_461012__(3236);var perspectiveVertSrc=glslify(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nattribute vec3 position;\nattribute vec4 color;\nattribute vec2 glyph;\nattribute vec4 id;\n\nuniform vec4 highlightId;\nuniform float highlightScale;\nuniform mat4 model, view, projection;\nuniform vec3 clipBounds[2];\n\nvarying vec4 interpColor;\nvarying vec4 pickId;\nvarying vec3 dataCoordinate;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], position)) {\n\n    gl_Position = vec4(0,0,0,0);\n  } else {\n    float scale = 1.0;\n    if(distance(highlightId, id) < 0.0001) {\n      scale = highlightScale;\n    }\n\n    vec4 worldPosition = model * vec4(position, 1);\n    vec4 viewPosition = view * worldPosition;\n    viewPosition = viewPosition / viewPosition.w;\n    vec4 clipPosition = projection * (viewPosition + scale * vec4(glyph.x, -glyph.y, 0, 0));\n\n    gl_Position = clipPosition;\n    interpColor = color;\n    pickId = id;\n    dataCoordinate = position;\n  }\n}"]);var orthographicVertSrc=glslify(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nattribute vec3 position;\nattribute vec4 color;\nattribute vec2 glyph;\nattribute vec4 id;\n\nuniform mat4 model, view, projection;\nuniform vec2 screenSize;\nuniform vec3 clipBounds[2];\nuniform float highlightScale, pixelRatio;\nuniform vec4 highlightId;\n\nvarying vec4 interpColor;\nvarying vec4 pickId;\nvarying vec3 dataCoordinate;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], position)) {\n\n    gl_Position = vec4(0,0,0,0);\n  } else {\n    float scale = pixelRatio;\n    if(distance(highlightId.bgr, id.bgr) < 0.001) {\n      scale *= highlightScale;\n    }\n\n    vec4 worldPosition = model * vec4(position, 1.0);\n    vec4 viewPosition = view * worldPosition;\n    vec4 clipPosition = projection * viewPosition;\n    clipPosition /= clipPosition.w;\n\n    gl_Position = clipPosition + vec4(screenSize * scale * vec2(glyph.x, -glyph.y), 0.0, 0.0);\n    interpColor = color;\n    pickId = id;\n    dataCoordinate = position;\n  }\n}"]);var projectionVertSrc=glslify(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nattribute vec3 position;\nattribute vec4 color;\nattribute vec2 glyph;\nattribute vec4 id;\n\nuniform float highlightScale;\nuniform vec4 highlightId;\nuniform vec3 axes[2];\nuniform mat4 model, view, projection;\nuniform vec2 screenSize;\nuniform vec3 clipBounds[2];\nuniform float scale, pixelRatio;\n\nvarying vec4 interpColor;\nvarying vec4 pickId;\nvarying vec3 dataCoordinate;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], position)) {\n\n    gl_Position = vec4(0,0,0,0);\n  } else {\n    float lscale = pixelRatio * scale;\n    if(distance(highlightId, id) < 0.0001) {\n      lscale *= highlightScale;\n    }\n\n    vec4 clipCenter   = projection * (view * (model * vec4(position, 1)));\n    vec3 dataPosition = position + 0.5*lscale*(axes[0] * glyph.x + axes[1] * glyph.y) * clipCenter.w * screenSize.y;\n    vec4 clipPosition = projection * (view * (model * vec4(dataPosition, 1)));\n\n    gl_Position = clipPosition;\n    interpColor = color;\n    pickId = id;\n    dataCoordinate = dataPosition;\n  }\n}\n"]);var drawFragSrc=glslify(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3 fragClipBounds[2];\nuniform float opacity;\n\nvarying vec4 interpColor;\nvarying vec3 dataCoordinate;\n\nvoid main() {\n  if (\n    outOfRange(fragClipBounds[0], fragClipBounds[1], dataCoordinate) ||\n    interpColor.a * opacity == 0.\n  ) discard;\n  gl_FragColor = interpColor * opacity;\n}\n"]);var pickFragSrc=glslify(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3 fragClipBounds[2];\nuniform float pickGroup;\n\nvarying vec4 pickId;\nvarying vec3 dataCoordinate;\n\nvoid main() {\n  if (outOfRange(fragClipBounds[0], fragClipBounds[1], dataCoordinate)) discard;\n\n  gl_FragColor = vec4(pickGroup, pickId.bgr);\n}"]);var ATTRIBUTES=[{name:'position',type:'vec3'},{name:'color',type:'vec4'},{name:'glyph',type:'vec2'},{name:'id',type:'vec4'}];var perspective={vertex:perspectiveVertSrc,fragment:drawFragSrc,attributes:ATTRIBUTES},ortho={vertex:orthographicVertSrc,fragment:drawFragSrc,attributes:ATTRIBUTES},project={vertex:projectionVertSrc,fragment:drawFragSrc,attributes:ATTRIBUTES},pickPerspective={vertex:perspectiveVertSrc,fragment:pickFragSrc,attributes:ATTRIBUTES},pickOrtho={vertex:orthographicVertSrc,fragment:pickFragSrc,attributes:ATTRIBUTES},pickProject={vertex:projectionVertSrc,fragment:pickFragSrc,attributes:ATTRIBUTES};function createShader(gl,src){var shader=createShaderWrapper(gl,src);var attr=shader.attributes;attr.position.location=0;attr.color.location=1;attr.glyph.location=2;attr.id.location=3;return shader;}exports.createPerspective=function(gl){return createShader(gl,perspective);};exports.createOrtho=function(gl){return createShader(gl,ortho);};exports.createProject=function(gl){return createShader(gl,project);};exports.createPickPerspective=function(gl){return createShader(gl,pickPerspective);};exports.createPickOrtho=function(gl){return createShader(gl,pickOrtho);};exports.createPickProject=function(gl){return createShader(gl,pickProject);};/***/}),/***/8418:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_468790__){"use strict";var isAllBlank=__nested_webpack_require_468790__(5219);var createBuffer=__nested_webpack_require_468790__(2762);var createVAO=__nested_webpack_require_468790__(8116);var pool=__nested_webpack_require_468790__(1888);var mat4mult=__nested_webpack_require_468790__(6760);var shaders=__nested_webpack_require_468790__(1283);var getGlyph=__nested_webpack_require_468790__(9366);var getSimpleString=__nested_webpack_require_468790__(5964);var IDENTITY=[1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1];var ab=ArrayBuffer;var dv=DataView;function isTypedArray(a){return ab.isView(a)&&!(a instanceof dv);}function isArrayOrTypedArray(a){return Array.isArray(a)||isTypedArray(a);}module.exports=createPointCloud;function transformMat4(x,m){var x0=x[0];var x1=x[1];var x2=x[2];var x3=x[3];x[0]=m[0]*x0+m[4]*x1+m[8]*x2+m[12]*x3;x[1]=m[1]*x0+m[5]*x1+m[9]*x2+m[13]*x3;x[2]=m[2]*x0+m[6]*x1+m[10]*x2+m[14]*x3;x[3]=m[3]*x0+m[7]*x1+m[11]*x2+m[15]*x3;return x;}function project(p,v,m,x){transformMat4(x,x,m);transformMat4(x,x,v);return transformMat4(x,x,p);}function ScatterPlotPickResult(index,position){this.index=index;this.dataCoordinate=this.position=position;}function fixOpacity(a){if(a===true)return 1;if(a>1)return 1;return a;}function PointCloud(gl,shader,orthoShader,projectShader,pointBuffer,colorBuffer,glyphBuffer,idBuffer,vao,pickPerspectiveShader,pickOrthoShader,pickProjectShader){this.gl=gl;this.pixelRatio=1;this.shader=shader;this.orthoShader=orthoShader;this.projectShader=projectShader;this.pointBuffer=pointBuffer;this.colorBuffer=colorBuffer;this.glyphBuffer=glyphBuffer;this.idBuffer=idBuffer;this.vao=vao;this.vertexCount=0;this.lineVertexCount=0;this.opacity=1;this.hasAlpha=false;this.lineWidth=0;this.projectScale=[2.0/3.0,2.0/3.0,2.0/3.0];this.projectOpacity=[1,1,1];this.projectHasAlpha=false;this.pickId=0;this.pickPerspectiveShader=pickPerspectiveShader;this.pickOrthoShader=pickOrthoShader;this.pickProjectShader=pickProjectShader;this.points=[];this._selectResult=new ScatterPlotPickResult(0,[0,0,0]);this.useOrtho=true;this.bounds=[[Infinity,Infinity,Infinity],[-Infinity,-Infinity,-Infinity]];//Axes projections
this.axesProject=[true,true,true];this.axesBounds=[[-Infinity,-Infinity,-Infinity],[Infinity,Infinity,Infinity]];this.highlightId=[1,1,1,1];this.highlightScale=2;this.clipBounds=[[-Infinity,-Infinity,-Infinity],[Infinity,Infinity,Infinity]];this.dirty=true;}var proto=PointCloud.prototype;proto.pickSlots=1;proto.setPickBase=function(pickBase){this.pickId=pickBase;};proto.isTransparent=function(){if(this.hasAlpha){return true;}for(var i=0;i<3;++i){if(this.axesProject[i]&&this.projectHasAlpha){return true;}}return false;};proto.isOpaque=function(){if(!this.hasAlpha){return true;}for(var i=0;i<3;++i){if(this.axesProject[i]&&!this.projectHasAlpha){return true;}}return false;};var VIEW_SHAPE=[0,0];var U_VEC=[0,0,0];var V_VEC=[0,0,0];var MU_VEC=[0,0,0,1];var MV_VEC=[0,0,0,1];var SCRATCH_MATRIX=IDENTITY.slice();var SCRATCH_VEC=[0,0,0];var CLIP_BOUNDS=[[0,0,0],[0,0,0]];function zeroVec(a){a[0]=a[1]=a[2]=0;return a;}function augment(hg,af){hg[0]=af[0];hg[1]=af[1];hg[2]=af[2];hg[3]=1;return hg;}function setComponent(out,v,i,x){out[0]=v[0];out[1]=v[1];out[2]=v[2];out[i]=x;return out;}function getClipBounds(bounds){var result=CLIP_BOUNDS;for(var i=0;i<2;++i){for(var j=0;j<3;++j){result[i][j]=Math.max(Math.min(bounds[i][j],1e8),-1e8);}}return result;}function drawProject(shader,points,camera,pixelRatio){var axesProject=points.axesProject;var gl=points.gl;var uniforms=shader.uniforms;var model=camera.model||IDENTITY;var view=camera.view||IDENTITY;var projection=camera.projection||IDENTITY;var bounds=points.axesBounds;var clipBounds=getClipBounds(points.clipBounds);var cubeAxis;if(points.axes&&points.axes.lastCubeProps){cubeAxis=points.axes.lastCubeProps.axis;}else{cubeAxis=[1,1,1];}VIEW_SHAPE[0]=2.0/gl.drawingBufferWidth;VIEW_SHAPE[1]=2.0/gl.drawingBufferHeight;shader.bind();uniforms.view=view;uniforms.projection=projection;uniforms.screenSize=VIEW_SHAPE;uniforms.highlightId=points.highlightId;uniforms.highlightScale=points.highlightScale;uniforms.clipBounds=clipBounds;uniforms.pickGroup=points.pickId/255.0;uniforms.pixelRatio=pixelRatio;for(var i=0;i<3;++i){if(!axesProject[i]){continue;}uniforms.scale=points.projectScale[i];uniforms.opacity=points.projectOpacity[i];//Project model matrix
var pmodel=SCRATCH_MATRIX;for(var j=0;j<16;++j){pmodel[j]=0;}for(var j=0;j<4;++j){pmodel[5*j]=1;}pmodel[5*i]=0;if(cubeAxis[i]<0){pmodel[12+i]=bounds[0][i];}else{pmodel[12+i]=bounds[1][i];}mat4mult(pmodel,model,pmodel);uniforms.model=pmodel;//Compute initial axes
var u=(i+1)%3;var v=(i+2)%3;var du=zeroVec(U_VEC);var dv=zeroVec(V_VEC);du[u]=1;dv[v]=1;//Align orientation relative to viewer
var mdu=project(projection,view,model,augment(MU_VEC,du));var mdv=project(projection,view,model,augment(MV_VEC,dv));if(Math.abs(mdu[1])>Math.abs(mdv[1])){var tmp=mdu;mdu=mdv;mdv=tmp;tmp=du;du=dv;dv=tmp;var t=u;u=v;v=t;}if(mdu[0]<0){du[u]=-1;}if(mdv[1]>0){dv[v]=-1;}var su=0.0;var sv=0.0;for(var j=0;j<4;++j){su+=Math.pow(model[4*u+j],2);sv+=Math.pow(model[4*v+j],2);}du[u]/=Math.sqrt(su);dv[v]/=Math.sqrt(sv);uniforms.axes[0]=du;uniforms.axes[1]=dv;//Update fragment clip bounds
uniforms.fragClipBounds[0]=setComponent(SCRATCH_VEC,clipBounds[0],i,-1e8);uniforms.fragClipBounds[1]=setComponent(SCRATCH_VEC,clipBounds[1],i,1e8);points.vao.bind();//Draw interior
points.vao.draw(gl.TRIANGLES,points.vertexCount);//Draw edges
if(points.lineWidth>0){gl.lineWidth(points.lineWidth*pixelRatio);points.vao.draw(gl.LINES,points.lineVertexCount,points.vertexCount);}points.vao.unbind();}}var NEG_INFINITY3=[-1e8,-1e8,-1e8];var POS_INFINITY3=[1e8,1e8,1e8];var CLIP_GROUP=[NEG_INFINITY3,POS_INFINITY3];function drawFull(shader,pshader,points,camera,pixelRatio,transparent,forceDraw){var gl=points.gl;if(transparent===points.projectHasAlpha||forceDraw){drawProject(pshader,points,camera,pixelRatio);}if(transparent===points.hasAlpha||forceDraw){shader.bind();var uniforms=shader.uniforms;uniforms.model=camera.model||IDENTITY;uniforms.view=camera.view||IDENTITY;uniforms.projection=camera.projection||IDENTITY;VIEW_SHAPE[0]=2.0/gl.drawingBufferWidth;VIEW_SHAPE[1]=2.0/gl.drawingBufferHeight;uniforms.screenSize=VIEW_SHAPE;uniforms.highlightId=points.highlightId;uniforms.highlightScale=points.highlightScale;uniforms.fragClipBounds=CLIP_GROUP;uniforms.clipBounds=points.axes.bounds;uniforms.opacity=points.opacity;uniforms.pickGroup=points.pickId/255.0;uniforms.pixelRatio=pixelRatio;points.vao.bind();//Draw interior
points.vao.draw(gl.TRIANGLES,points.vertexCount);//Draw edges
if(points.lineWidth>0){gl.lineWidth(points.lineWidth*pixelRatio);points.vao.draw(gl.LINES,points.lineVertexCount,points.vertexCount);}points.vao.unbind();}}proto.draw=function(camera){var shader=this.useOrtho?this.orthoShader:this.shader;drawFull(shader,this.projectShader,this,camera,this.pixelRatio,false,false);};proto.drawTransparent=function(camera){var shader=this.useOrtho?this.orthoShader:this.shader;drawFull(shader,this.projectShader,this,camera,this.pixelRatio,true,false);};proto.drawPick=function(camera){var shader=this.useOrtho?this.pickOrthoShader:this.pickPerspectiveShader;drawFull(shader,this.pickProjectShader,this,camera,1,true,true);};proto.pick=function(selected){if(!selected){return null;}if(selected.id!==this.pickId){return null;}var x=selected.value[2]+(selected.value[1]<<8)+(selected.value[0]<<16);if(x>=this.pointCount||x<0){return null;}//Unpack result
var coord=this.points[x];var result=this._selectResult;result.index=x;for(var i=0;i<3;++i){result.position[i]=result.dataCoordinate[i]=coord[i];}return result;};proto.highlight=function(selection){if(!selection){this.highlightId=[1,1,1,1];}else{var pointId=selection.index;var a0=pointId&0xff;var a1=pointId>>8&0xff;var a2=pointId>>16&0xff;this.highlightId=[a0/255.0,a1/255.0,a2/255.0,0];}};function get_glyphData(glyphs,index,font,pixelRatio){var str;// use the data if presented in an array
if(isArrayOrTypedArray(glyphs)){if(index<glyphs.length){str=glyphs[index];}else{str=undefined;}}else{str=glyphs;}str=getSimpleString(str);// this would handle undefined cases
var visible=true;if(isAllBlank(str)){str='▼';// Note: this special character may have minimum number of surfaces
visible=false;}if(!font)font={};var family=font.family;if(isArrayOrTypedArray(family))family=family[index];if(!family)family="normal";var weight=font.weight;if(isArrayOrTypedArray(weight))weight=weight[index];if(!weight)weight="normal";var style=font.style;if(isArrayOrTypedArray(style))style=style[index];if(!style)style="normal";var variant=font.variant;if(isArrayOrTypedArray(variant))variant=variant[index];if(!variant)variant="normal";var glyph=getGlyph(str,{family:family,weight:weight,style:style,variant:variant},pixelRatio);var glyph=getGlyph(str,font,pixelRatio);return{mesh:glyph[0],lines:glyph[1],bounds:glyph[2],visible:visible};}proto.update=function(options){options=options||{};if('perspective'in options){this.useOrtho=!options.perspective;}if('orthographic'in options){this.useOrtho=!!options.orthographic;}if('lineWidth'in options){this.lineWidth=options.lineWidth;}if('project'in options){if(isArrayOrTypedArray(options.project)){this.axesProject=options.project;}else{var v=!!options.project;this.axesProject=[v,v,v];}}if('projectScale'in options){if(isArrayOrTypedArray(options.projectScale)){this.projectScale=options.projectScale.slice();}else{var s=+options.projectScale;this.projectScale=[s,s,s];}}this.projectHasAlpha=false;// default to no transparent draw
if('projectOpacity'in options){if(isArrayOrTypedArray(options.projectOpacity)){this.projectOpacity=options.projectOpacity.slice();}else{var s=+options.projectOpacity;this.projectOpacity=[s,s,s];}for(var i=0;i<3;++i){this.projectOpacity[i]=fixOpacity(this.projectOpacity[i]);if(this.projectOpacity[i]<1){this.projectHasAlpha=true;}}}this.hasAlpha=false;// default to no transparent draw
if('opacity'in options){this.opacity=fixOpacity(options.opacity);if(this.opacity<1){this.hasAlpha=true;}}//Set dirty flag
this.dirty=true;//Create new buffers
var points=options.position;//Text font
var font={family:options.font||'normal',style:options.fontStyle||'normal',weight:options.fontWeight||'normal',variant:options.fontVariant||'normal'};var alignment=options.alignment||[0,0];var alignmentX;var alignmentY;if(alignment.length===2){alignmentX=alignment[0];alignmentY=alignment[1];}else{alignmentX=[];alignmentY=[];for(var i=0;i<alignment.length;++i){alignmentX[i]=alignment[i][0];alignmentY[i]=alignment[i][1];}}//Bounds
var lowerBound=[Infinity,Infinity,Infinity];var upperBound=[-Infinity,-Infinity,-Infinity];//Unpack options
var glyphs=options.glyph;var colors=options.color;var sizes=options.size;var angles=options.angle;var lineColors=options.lineColor;//Picking geometry
var pickCounter=-1;//First do pass to compute buffer sizes
var triVertexCount=0;var lineVertexCount=0;var numPoints=0;if(points.length){//Count number of points and buffer size
numPoints=points.length;count_loop:for(var i=0;i<numPoints;++i){var x=points[i];for(var j=0;j<3;++j){if(isNaN(x[j])||!isFinite(x[j])){continue count_loop;}}var glyphData=get_glyphData(glyphs,i,font,this.pixelRatio);var glyphMesh=glyphData.mesh;var glyphLines=glyphData.lines;var glyphBounds=glyphData.bounds;triVertexCount+=glyphMesh.cells.length*3;lineVertexCount+=glyphLines.edges.length*2;}}var vertexCount=triVertexCount+lineVertexCount;//Preallocate data
var positionArray=pool.mallocFloat(3*vertexCount);var colorArray=pool.mallocFloat(4*vertexCount);var glyphArray=pool.mallocFloat(2*vertexCount);var idArray=pool.mallocUint32(vertexCount);if(vertexCount>0){var triOffset=0;var lineOffset=triVertexCount;var color=[0,0,0,1];var lineColor=[0,0,0,1];var isColorArray=isArrayOrTypedArray(colors)&&isArrayOrTypedArray(colors[0]);var isLineColorArray=isArrayOrTypedArray(lineColors)&&isArrayOrTypedArray(lineColors[0]);fill_loop:for(var i=0;i<numPoints;++i){//Increment pickCounter
pickCounter+=1;var x=points[i];for(var j=0;j<3;++j){if(isNaN(x[j])||!isFinite(x[j])){continue fill_loop;}upperBound[j]=Math.max(upperBound[j],x[j]);lowerBound[j]=Math.min(lowerBound[j],x[j]);}var glyphData=get_glyphData(glyphs,i,font,this.pixelRatio);var glyphMesh=glyphData.mesh;var glyphLines=glyphData.lines;var glyphBounds=glyphData.bounds;var glyphVisible=glyphData.visible;//Get color
if(!glyphVisible)color=[1,1,1,0];else if(isArrayOrTypedArray(colors)){var c;if(isColorArray){if(i<colors.length){c=colors[i];}else{c=[0,0,0,0];}}else{c=colors;}if(c.length===3){for(var j=0;j<3;++j){color[j]=c[j];}color[3]=1;}else if(c.length===4){for(var j=0;j<4;++j){color[j]=c[j];}if(!this.hasAlpha&&c[3]<1)this.hasAlpha=true;}}else{color[0]=color[1]=color[2]=0;color[3]=1;}//Get lineColor
if(!glyphVisible)lineColor=[1,1,1,0];else if(isArrayOrTypedArray(lineColors)){var c;if(isLineColorArray){if(i<lineColors.length){c=lineColors[i];}else{c=[0,0,0,0];}}else{c=lineColors;}if(c.length===3){for(var j=0;j<3;++j){lineColor[j]=c[j];}lineColor[j]=1;}else if(c.length===4){for(var j=0;j<4;++j){lineColor[j]=c[j];}if(!this.hasAlpha&&c[3]<1)this.hasAlpha=true;}}else{lineColor[0]=lineColor[1]=lineColor[2]=0;lineColor[3]=1;}var size=0.5;if(!glyphVisible)size=0.0;else if(isArrayOrTypedArray(sizes)){if(i<sizes.length){size=+sizes[i];}else{size=12;}}else if(sizes){size=+sizes;}else if(this.useOrtho){size=12;}var angle=0;if(isArrayOrTypedArray(angles)){if(i<angles.length){angle=+angles[i];}else{angle=0;}}else if(angles){angle=+angles;}//Loop through markers and append to buffers
var cos=Math.cos(angle);var sin=Math.sin(angle);var x=points[i];for(var j=0;j<3;++j){upperBound[j]=Math.max(upperBound[j],x[j]);lowerBound[j]=Math.min(lowerBound[j],x[j]);}//Calculate text offset
var textOffsetX=alignmentX;var textOffsetY=alignmentY;var textOffsetX=0;if(isArrayOrTypedArray(alignmentX)){if(i<alignmentX.length){textOffsetX=alignmentX[i];}else{textOffsetX=0;}}else if(alignmentX){textOffsetX=alignmentX;}var textOffsetY=0;if(isArrayOrTypedArray(alignmentY)){if(i<alignmentY.length){textOffsetY=alignmentY[i];}else{textOffsetY=0;}}else if(alignmentY){textOffsetY=alignmentY;}textOffsetX*=textOffsetX>0?1-glyphBounds[0][0]:textOffsetX<0?1+glyphBounds[1][0]:1;textOffsetY*=textOffsetY>0?1-glyphBounds[0][1]:textOffsetY<0?1+glyphBounds[1][1]:1;var textOffset=[textOffsetX,textOffsetY];//Write out inner marker
var cells=glyphMesh.cells||[];var verts=glyphMesh.positions||[];for(var j=0;j<cells.length;++j){var cell=cells[j];for(var k=0;k<3;++k){for(var l=0;l<3;++l){positionArray[3*triOffset+l]=x[l];}for(var l=0;l<4;++l){colorArray[4*triOffset+l]=color[l];}idArray[triOffset]=pickCounter;var p=verts[cell[k]];glyphArray[2*triOffset]=size*(cos*p[0]-sin*p[1]+textOffset[0]);glyphArray[2*triOffset+1]=size*(sin*p[0]+cos*p[1]+textOffset[1]);triOffset+=1;}}var cells=glyphLines.edges;var verts=glyphLines.positions;for(var j=0;j<cells.length;++j){var cell=cells[j];for(var k=0;k<2;++k){for(var l=0;l<3;++l){positionArray[3*lineOffset+l]=x[l];}for(var l=0;l<4;++l){colorArray[4*lineOffset+l]=lineColor[l];}idArray[lineOffset]=pickCounter;var p=verts[cell[k]];glyphArray[2*lineOffset]=size*(cos*p[0]-sin*p[1]+textOffset[0]);glyphArray[2*lineOffset+1]=size*(sin*p[0]+cos*p[1]+textOffset[1]);lineOffset+=1;}}}}//Update bounds
this.bounds=[lowerBound,upperBound];//Save points
this.points=points;//Save number of points
this.pointCount=points.length;//Update vertex counts
this.vertexCount=triVertexCount;this.lineVertexCount=lineVertexCount;this.pointBuffer.update(positionArray);this.colorBuffer.update(colorArray);this.glyphBuffer.update(glyphArray);//this.idBuffer.update(new Uint32Array(idArray))
this.idBuffer.update(idArray);pool.free(positionArray);pool.free(colorArray);pool.free(glyphArray);pool.free(idArray);};proto.dispose=function(){//Shaders
this.shader.dispose();this.orthoShader.dispose();this.pickPerspectiveShader.dispose();this.pickOrthoShader.dispose();//Vertex array
this.vao.dispose();//Buffers
this.pointBuffer.dispose();this.colorBuffer.dispose();this.glyphBuffer.dispose();this.idBuffer.dispose();};function createPointCloud(options){var gl=options.gl;var shader=shaders.createPerspective(gl);var orthoShader=shaders.createOrtho(gl);var projectShader=shaders.createProject(gl);var pickPerspectiveShader=shaders.createPickPerspective(gl);var pickOrthoShader=shaders.createPickOrtho(gl);var pickProjectShader=shaders.createPickProject(gl);var pointBuffer=createBuffer(gl);var colorBuffer=createBuffer(gl);var glyphBuffer=createBuffer(gl);var idBuffer=createBuffer(gl);var vao=createVAO(gl,[{buffer:pointBuffer,size:3,type:gl.FLOAT},{buffer:colorBuffer,size:4,type:gl.FLOAT},{buffer:glyphBuffer,size:2,type:gl.FLOAT},{buffer:idBuffer,size:4,type:gl.UNSIGNED_BYTE,normalized:true}]);var pointCloud=new PointCloud(gl,shader,orthoShader,projectShader,pointBuffer,colorBuffer,glyphBuffer,idBuffer,vao,pickPerspectiveShader,pickOrthoShader,pickProjectShader);pointCloud.update(options);return pointCloud;}/***/}),/***/4298:(/***/function(__unused_webpack_module,exports,__nested_webpack_require_485744__){"use strict";var glslify=__nested_webpack_require_485744__(3236);exports.boxVertex=glslify(["precision mediump float;\n#define GLSLIFY 1\n\nattribute vec2 vertex;\n\nuniform vec2 cornerA, cornerB;\n\nvoid main() {\n  gl_Position = vec4(mix(cornerA, cornerB, vertex), 0, 1);\n}\n"]);exports.boxFragment=glslify(["precision mediump float;\n#define GLSLIFY 1\n\nuniform vec4 color;\n\nvoid main() {\n  gl_FragColor = color;\n}\n"]);/***/}),/***/3161:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_486245__){"use strict";var createShader=__nested_webpack_require_486245__(9405);var createBuffer=__nested_webpack_require_486245__(2762);var SHADERS=__nested_webpack_require_486245__(4298);module.exports=createSelectBox;function SelectBox(plot,boxBuffer,boxShader){this.plot=plot;this.boxBuffer=boxBuffer;this.boxShader=boxShader;this.enabled=true;this.selectBox=[Infinity,Infinity,-Infinity,-Infinity];this.borderColor=[0,0,0,1];this.innerFill=false;this.innerColor=[0,0,0,0.25];this.outerFill=true;this.outerColor=[0,0,0,0.5];this.borderWidth=10;}var proto=SelectBox.prototype;proto.draw=function(){if(!this.enabled){return;}var plot=this.plot;var selectBox=this.selectBox;var lineWidth=this.borderWidth;var innerFill=this.innerFill;var innerColor=this.innerColor;var outerFill=this.outerFill;var outerColor=this.outerColor;var borderColor=this.borderColor;var boxes=plot.box;var screenBox=plot.screenBox;var dataBox=plot.dataBox;var viewBox=plot.viewBox;var pixelRatio=plot.pixelRatio;//Map select box into pixel coordinates
var loX=(selectBox[0]-dataBox[0])*(viewBox[2]-viewBox[0])/(dataBox[2]-dataBox[0])+viewBox[0];var loY=(selectBox[1]-dataBox[1])*(viewBox[3]-viewBox[1])/(dataBox[3]-dataBox[1])+viewBox[1];var hiX=(selectBox[2]-dataBox[0])*(viewBox[2]-viewBox[0])/(dataBox[2]-dataBox[0])+viewBox[0];var hiY=(selectBox[3]-dataBox[1])*(viewBox[3]-viewBox[1])/(dataBox[3]-dataBox[1])+viewBox[1];loX=Math.max(loX,viewBox[0]);loY=Math.max(loY,viewBox[1]);hiX=Math.min(hiX,viewBox[2]);hiY=Math.min(hiY,viewBox[3]);if(hiX<loX||hiY<loY){return;}boxes.bind();//Draw box
var screenWidth=screenBox[2]-screenBox[0];var screenHeight=screenBox[3]-screenBox[1];if(this.outerFill){boxes.drawBox(0,0,screenWidth,loY,outerColor);boxes.drawBox(0,loY,loX,hiY,outerColor);boxes.drawBox(0,hiY,screenWidth,screenHeight,outerColor);boxes.drawBox(hiX,loY,screenWidth,hiY,outerColor);}if(this.innerFill){boxes.drawBox(loX,loY,hiX,hiY,innerColor);}//Draw border
if(lineWidth>0){//Draw border
var w=lineWidth*pixelRatio;boxes.drawBox(loX-w,loY-w,hiX+w,loY+w,borderColor);boxes.drawBox(loX-w,hiY-w,hiX+w,hiY+w,borderColor);boxes.drawBox(loX-w,loY-w,loX+w,hiY+w,borderColor);boxes.drawBox(hiX-w,loY-w,hiX+w,hiY+w,borderColor);}};proto.update=function(options){options=options||{};this.innerFill=!!options.innerFill;this.outerFill=!!options.outerFill;this.innerColor=(options.innerColor||[0,0,0,0.5]).slice();this.outerColor=(options.outerColor||[0,0,0,0.5]).slice();this.borderColor=(options.borderColor||[0,0,0,1]).slice();this.borderWidth=options.borderWidth||0;this.selectBox=(options.selectBox||this.selectBox).slice();};proto.dispose=function(){this.boxBuffer.dispose();this.boxShader.dispose();this.plot.removeOverlay(this);};function createSelectBox(plot,options){var gl=plot.gl;var buffer=createBuffer(gl,[0,0,0,1,1,0,1,1]);var shader=createShader(gl,SHADERS.boxVertex,SHADERS.boxFragment);var selectBox=new SelectBox(plot,buffer,shader);selectBox.update(options);plot.addOverlay(selectBox);return selectBox;}/***/}),/***/3589:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_489274__){"use strict";module.exports=createSelectBuffer;var createFBO=__nested_webpack_require_489274__(2260);var pool=__nested_webpack_require_489274__(1888);var ndarray=__nested_webpack_require_489274__(9618);var nextPow2=__nested_webpack_require_489274__(8828).nextPow2;var selectRange=function(arr,x,y){var closestD2=1e8;var closestX=-1;var closestY=-1;var ni=arr.shape[0];var nj=arr.shape[1];for(var i=0;i<ni;i++){for(var j=0;j<nj;j++){var r=arr.get(i,j,0);var g=arr.get(i,j,1);var b=arr.get(i,j,2);var a=arr.get(i,j,3);if(r<255||g<255||b<255||a<255){var dx=x-i;var dy=y-j;var d2=dx*dx+dy*dy;if(d2<closestD2){closestD2=d2;closestX=i;closestY=j;}}}}return[closestX,closestY,closestD2];};function SelectResult(x,y,id,value,distance){this.coord=[x,y];this.id=id;this.value=value;this.distance=distance;}function SelectBuffer(gl,fbo,buffer){this.gl=gl;this.fbo=fbo;this.buffer=buffer;this._readTimeout=null;var self=this;this._readCallback=function(){if(!self.gl){return;}fbo.bind();gl.readPixels(0,0,fbo.shape[0],fbo.shape[1],gl.RGBA,gl.UNSIGNED_BYTE,self.buffer);self._readTimeout=null;};}var proto=SelectBuffer.prototype;Object.defineProperty(proto,'shape',{get:function(){if(!this.gl){return[0,0];}return this.fbo.shape.slice();},set:function(v){if(!this.gl){return;}this.fbo.shape=v;var c=this.fbo.shape[0];var r=this.fbo.shape[1];if(r*c*4>this.buffer.length){pool.free(this.buffer);var buffer=this.buffer=pool.mallocUint8(nextPow2(r*c*4));for(var i=0;i<r*c*4;++i){buffer[i]=0xff;}}return v;}});proto.begin=function(){var gl=this.gl;var shape=this.shape;if(!gl){return;}this.fbo.bind();gl.clearColor(1,1,1,1);gl.clear(gl.COLOR_BUFFER_BIT|gl.DEPTH_BUFFER_BIT);};proto.end=function(){var gl=this.gl;if(!gl){return;}gl.bindFramebuffer(gl.FRAMEBUFFER,null);if(!this._readTimeout){clearTimeout(this._readTimeout);}this._readTimeout=setTimeout(this._readCallback,1);};proto.query=function(x,y,radius){if(!this.gl){return null;}var shape=this.fbo.shape.slice();x=x|0;y=y|0;if(typeof radius!=='number'){radius=1.0;}var x0=Math.min(Math.max(x-radius,0),shape[0])|0;var x1=Math.min(Math.max(x+radius,0),shape[0])|0;var y0=Math.min(Math.max(y-radius,0),shape[1])|0;var y1=Math.min(Math.max(y+radius,0),shape[1])|0;if(x1<=x0||y1<=y0){return null;}var dims=[x1-x0,y1-y0];var region=ndarray(this.buffer,[dims[0],dims[1],4],[4,shape[0]*4,1],4*(x0+shape[0]*y0));var closest=selectRange(region.hi(dims[0],dims[1],1),radius,radius);var dx=closest[0];var dy=closest[1];if(dx<0||Math.pow(this.radius,2)<closest[2]){return null;}var c0=region.get(dx,dy,0);var c1=region.get(dx,dy,1);var c2=region.get(dx,dy,2);var c3=region.get(dx,dy,3);return new SelectResult(dx+x0|0,dy+y0|0,c0,[c1,c2,c3],Math.sqrt(closest[2]));};proto.dispose=function(){if(!this.gl){return;}this.fbo.dispose();pool.free(this.buffer);this.gl=null;if(this._readTimeout){clearTimeout(this._readTimeout);}};function createSelectBuffer(gl,shape){var width=shape[0];var height=shape[1];var options={};var fbo=createFBO(gl,width,height,options);var buffer=pool.mallocUint8(width*height*4);return new SelectBuffer(gl,fbo,buffer);}/***/}),/***/9405:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_492373__){"use strict";var createUniformWrapper=__nested_webpack_require_492373__(3327);var createAttributeWrapper=__nested_webpack_require_492373__(8731);var makeReflect=__nested_webpack_require_492373__(216);var shaderCache=__nested_webpack_require_492373__(5091);var runtime=__nested_webpack_require_492373__(2145);var GLError=__nested_webpack_require_492373__(8866);//Shader object
function Shader(gl){this.gl=gl;this.gl.lastAttribCount=0;// fixme where else should we store info, safe but not nice on the gl object
//Default initialize these to null
this._vref=this._fref=this._relink=this.vertShader=this.fragShader=this.program=this.attributes=this.uniforms=this.types=null;}var proto=Shader.prototype;proto.bind=function(){if(!this.program){this._relink();}// ensuring that we have the right number of enabled vertex attributes
var i;var newAttribCount=this.gl.getProgramParameter(this.program,this.gl.ACTIVE_ATTRIBUTES);// more robust approach
//var newAttribCount = Object.keys(this.attributes).length // avoids the probably immaterial introspection slowdown
var oldAttribCount=this.gl.lastAttribCount;if(newAttribCount>oldAttribCount){for(i=oldAttribCount;i<newAttribCount;i++){this.gl.enableVertexAttribArray(i);}}else if(oldAttribCount>newAttribCount){for(i=newAttribCount;i<oldAttribCount;i++){this.gl.disableVertexAttribArray(i);}}this.gl.lastAttribCount=newAttribCount;this.gl.useProgram(this.program);};proto.dispose=function(){// disabling vertex attributes so new shader starts with zero
// and it's also useful if all shaders are disposed but the
// gl context is reused for subsequent replotting
var oldAttribCount=this.gl.lastAttribCount;for(var i=0;i<oldAttribCount;i++){this.gl.disableVertexAttribArray(i);}this.gl.lastAttribCount=0;if(this._fref){this._fref.dispose();}if(this._vref){this._vref.dispose();}this.attributes=this.types=this.vertShader=this.fragShader=this.program=this._relink=this._fref=this._vref=null;};function compareAttributes(a,b){if(a.name<b.name){return-1;}return 1;}//Update export hook for glslify-live
proto.update=function(vertSource,fragSource,uniforms,attributes){//If only one object passed, assume glslify style output
if(!fragSource||arguments.length===1){var obj=vertSource;vertSource=obj.vertex;fragSource=obj.fragment;uniforms=obj.uniforms;attributes=obj.attributes;}var wrapper=this;var gl=wrapper.gl;//Compile vertex and fragment shaders
var pvref=wrapper._vref;wrapper._vref=shaderCache.shader(gl,gl.VERTEX_SHADER,vertSource);if(pvref){pvref.dispose();}wrapper.vertShader=wrapper._vref.shader;var pfref=this._fref;wrapper._fref=shaderCache.shader(gl,gl.FRAGMENT_SHADER,fragSource);if(pfref){pfref.dispose();}wrapper.fragShader=wrapper._fref.shader;//If uniforms/attributes is not specified, use RT reflection
if(!uniforms||!attributes){//Create initial test program
var testProgram=gl.createProgram();gl.attachShader(testProgram,wrapper.fragShader);gl.attachShader(testProgram,wrapper.vertShader);gl.linkProgram(testProgram);if(!gl.getProgramParameter(testProgram,gl.LINK_STATUS)){var errLog=gl.getProgramInfoLog(testProgram);throw new GLError(errLog,'Error linking program:'+errLog);}//Load data from runtime
uniforms=uniforms||runtime.uniforms(gl,testProgram);attributes=attributes||runtime.attributes(gl,testProgram);//Release test program
gl.deleteProgram(testProgram);}//Sort attributes lexicographically
// overrides undefined WebGL behavior for attribute locations
attributes=attributes.slice();attributes.sort(compareAttributes);//Convert attribute types, read out locations
var attributeUnpacked=[];var attributeNames=[];var attributeLocations=[];var i;for(i=0;i<attributes.length;++i){var attr=attributes[i];if(attr.type.indexOf('mat')>=0){var size=attr.type.charAt(attr.type.length-1)|0;var locVector=new Array(size);for(var j=0;j<size;++j){locVector[j]=attributeLocations.length;attributeNames.push(attr.name+'['+j+']');if(typeof attr.location==='number'){attributeLocations.push(attr.location+j);}else if(Array.isArray(attr.location)&&attr.location.length===size&&typeof attr.location[j]==='number'){attributeLocations.push(attr.location[j]|0);}else{attributeLocations.push(-1);}}attributeUnpacked.push({name:attr.name,type:attr.type,locations:locVector});}else{attributeUnpacked.push({name:attr.name,type:attr.type,locations:[attributeLocations.length]});attributeNames.push(attr.name);if(typeof attr.location==='number'){attributeLocations.push(attr.location|0);}else{attributeLocations.push(-1);}}}//For all unspecified attributes, assign them lexicographically min attribute
var curLocation=0;for(i=0;i<attributeLocations.length;++i){if(attributeLocations[i]<0){while(attributeLocations.indexOf(curLocation)>=0){curLocation+=1;}attributeLocations[i]=curLocation;}}//Rebuild program and recompute all uniform locations
var uniformLocations=new Array(uniforms.length);function relink(){wrapper.program=shaderCache.program(gl,wrapper._vref,wrapper._fref,attributeNames,attributeLocations);for(var i=0;i<uniforms.length;++i){uniformLocations[i]=gl.getUniformLocation(wrapper.program,uniforms[i].name);}}//Perform initial linking, reuse program used for reflection
relink();//Save relinking procedure, defer until runtime
wrapper._relink=relink;//Generate type info
wrapper.types={uniforms:makeReflect(uniforms),attributes:makeReflect(attributes)};//Generate attribute wrappers
wrapper.attributes=createAttributeWrapper(gl,wrapper,attributeUnpacked,attributeLocations);//Generate uniform wrappers
Object.defineProperty(wrapper,'uniforms',createUniformWrapper(gl,wrapper,uniforms,uniformLocations));};//Compiles and links a shader program with the given attribute and vertex list
function createShader(gl,vertSource,fragSource,uniforms,attributes){var shader=new Shader(gl);shader.update(vertSource,fragSource,uniforms,attributes);return shader;}module.exports=createShader;/***/}),/***/8866:(/***/function(module){function GLError(rawError,shortMessage,longMessage){this.shortMessage=shortMessage||'';this.longMessage=longMessage||'';this.rawError=rawError||'';this.message='gl-shader: '+(shortMessage||rawError||'')+(longMessage?'\n'+longMessage:'');this.stack=new Error().stack;}GLError.prototype=new Error();GLError.prototype.name='GLError';GLError.prototype.constructor=GLError;module.exports=GLError;/***/}),/***/8731:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_498645__){"use strict";module.exports=createAttributeWrapper;var GLError=__nested_webpack_require_498645__(8866);function ShaderAttribute(gl,wrapper,index,locations,dimension,constFunc){this._gl=gl;this._wrapper=wrapper;this._index=index;this._locations=locations;this._dimension=dimension;this._constFunc=constFunc;}var proto=ShaderAttribute.prototype;proto.pointer=function setAttribPointer(type,normalized,stride,offset){var self=this;var gl=self._gl;var location=self._locations[self._index];gl.vertexAttribPointer(location,self._dimension,type||gl.FLOAT,!!normalized,stride||0,offset||0);gl.enableVertexAttribArray(location);};proto.set=function(x0,x1,x2,x3){return this._constFunc(this._locations[this._index],x0,x1,x2,x3);};Object.defineProperty(proto,'location',{get:function(){return this._locations[this._index];},set:function(v){if(v!==this._locations[this._index]){this._locations[this._index]=v|0;this._wrapper.program=null;}return v|0;}});var allFns=[function(gl,v,x0){if(x0.length===undefined){return gl.vertexAttrib1f(v,x0);}else{return gl.vertexAttrib1fv(v,x0);}},function(gl,v,x0,x1){if(x0.length===undefined){return gl.vertexAttrib2f(v,x0,x1);}else{return gl.vertexAttrib2fv(v,x0);}},function(gl,v,x0,x1,x2){if(x0.length===undefined){return gl.vertexAttrib3f(v,x0,x1,x2);}else{return gl.vertexAttrib3fv(v,x0);}},function(gl,v,x0,x1,x2,x3){if(x0.length===undefined){return gl.vertexAttrib4f(v,x0,x1,x2,x3);}else{return gl.vertexAttrib4fv(v,x0);}}];//Adds a vector attribute to obj
function addVectorAttribute(gl,wrapper,index,locations,dimension,obj,name){var constFunc=allFns[dimension];//Create attribute wrapper
var attr=new ShaderAttribute(gl,wrapper,index,locations,dimension,constFunc);//Create accessor
Object.defineProperty(obj,name,{set:function(x){gl.disableVertexAttribArray(locations[index]);constFunc(gl,locations[index],x);return x;},get:function(){return attr;},enumerable:true});}function addMatrixAttribute(gl,wrapper,index,locations,dimension,obj,name){var parts=new Array(dimension);var attrs=new Array(dimension);for(var i=0;i<dimension;++i){addVectorAttribute(gl,wrapper,index[i],locations,dimension,parts,i);attrs[i]=parts[i];}Object.defineProperty(parts,'location',{set:function(v){if(Array.isArray(v)){for(var i=0;i<dimension;++i){attrs[i].location=v[i];}}else{for(var i=0;i<dimension;++i){attrs[i].location=v+i;}}return v;},get:function(){var result=new Array(dimension);for(var i=0;i<dimension;++i){result[i]=locations[index[i]];}return result;},enumerable:true});parts.pointer=function(type,normalized,stride,offset){type=type||gl.FLOAT;normalized=!!normalized;stride=stride||dimension*dimension;offset=offset||0;for(var i=0;i<dimension;++i){var location=locations[index[i]];gl.vertexAttribPointer(location,dimension,type,normalized,stride,offset+i*dimension);gl.enableVertexAttribArray(location);}};var scratch=new Array(dimension);var vertexAttrib=gl['vertexAttrib'+dimension+'fv'];Object.defineProperty(obj,name,{set:function(x){for(var i=0;i<dimension;++i){var loc=locations[index[i]];gl.disableVertexAttribArray(loc);if(Array.isArray(x[0])){vertexAttrib.call(gl,loc,x[i]);}else{for(var j=0;j<dimension;++j){scratch[j]=x[dimension*i+j];}vertexAttrib.call(gl,loc,scratch);}}return x;},get:function(){return parts;},enumerable:true});}//Create shims for attributes
function createAttributeWrapper(gl,wrapper,attributes,locations){var obj={};for(var i=0,n=attributes.length;i<n;++i){var a=attributes[i];var name=a.name;var type=a.type;var locs=a.locations;switch(type){case'bool':case'int':case'float':addVectorAttribute(gl,wrapper,locs[0],locations,1,obj,name);break;default:if(type.indexOf('vec')>=0){var d=type.charCodeAt(type.length-1)-48;if(d<2||d>4){throw new GLError('','Invalid data type for attribute '+name+': '+type);}addVectorAttribute(gl,wrapper,locs[0],locations,d,obj,name);}else if(type.indexOf('mat')>=0){var d=type.charCodeAt(type.length-1)-48;if(d<2||d>4){throw new GLError('','Invalid data type for attribute '+name+': '+type);}addMatrixAttribute(gl,wrapper,locs,locations,d,obj,name);}else{throw new GLError('','Unknown data type for attribute '+name+': '+type);}break;}}return obj;}/***/}),/***/3327:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_502857__){"use strict";var coallesceUniforms=__nested_webpack_require_502857__(216);var GLError=__nested_webpack_require_502857__(8866);module.exports=createUniformWrapper;//Binds a function and returns a value
function identity(x){return function(){return x;};}function makeVector(length,fill){var result=new Array(length);for(var i=0;i<length;++i){result[i]=fill;}return result;}//Create shims for uniforms
function createUniformWrapper(gl,wrapper,uniforms,locations){function makeGetter(idx){return function(gl,wrapper,locations){return gl.getUniform(wrapper.program,locations[idx]);};}function makeSetter(type){return function updateProperty(obj){var indices=enumerateIndices('',type);for(var i=0;i<indices.length;++i){var item=indices[i];var path=item[0];var idx=item[1];if(locations[idx]){var objPath=obj;if(typeof path==='string'&&(path.indexOf('.')===0||path.indexOf('[')===0)){var key=path;if(path.indexOf('.')===0){key=path.slice(1);}if(key.indexOf(']')===key.length-1){var j=key.indexOf('[');var k1=key.slice(0,j);var k2=key.slice(j+1,key.length-1);objPath=k1?obj[k1][k2]:obj[k2];}else{objPath=obj[key];}}var t=uniforms[idx].type;var d;switch(t){case'bool':case'int':case'sampler2D':case'samplerCube':gl.uniform1i(locations[idx],objPath);break;case'float':gl.uniform1f(locations[idx],objPath);break;default:var vidx=t.indexOf('vec');if(0<=vidx&&vidx<=1&&t.length===4+vidx){d=t.charCodeAt(t.length-1)-48;if(d<2||d>4){throw new GLError('','Invalid data type');}switch(t.charAt(0)){case'b':case'i':gl['uniform'+d+'iv'](locations[idx],objPath);break;case'v':gl['uniform'+d+'fv'](locations[idx],objPath);break;default:throw new GLError('','Unrecognized data type for vector '+name+': '+t);}}else if(t.indexOf('mat')===0&&t.length===4){d=t.charCodeAt(t.length-1)-48;if(d<2||d>4){throw new GLError('','Invalid uniform dimension type for matrix '+name+': '+t);}gl['uniformMatrix'+d+'fv'](locations[idx],false,objPath);break;}else{throw new GLError('','Unknown uniform data type for '+name+': '+t);}}}}};}function enumerateIndices(prefix,type){if(typeof type!=='object'){return[[prefix,type]];}var indices=[];for(var id in type){var prop=type[id];var tprefix=prefix;if(parseInt(id)+''===id){tprefix+='['+id+']';}else{tprefix+='.'+id;}if(typeof prop==='object'){indices.push.apply(indices,enumerateIndices(tprefix,prop));}else{indices.push([tprefix,prop]);}}return indices;}function defaultValue(type){switch(type){case'bool':return false;case'int':case'sampler2D':case'samplerCube':return 0;case'float':return 0.0;default:var vidx=type.indexOf('vec');if(0<=vidx&&vidx<=1&&type.length===4+vidx){var d=type.charCodeAt(type.length-1)-48;if(d<2||d>4){throw new GLError('','Invalid data type');}if(type.charAt(0)==='b'){return makeVector(d,false);}return makeVector(d,0);}else if(type.indexOf('mat')===0&&type.length===4){var d=type.charCodeAt(type.length-1)-48;if(d<2||d>4){throw new GLError('','Invalid uniform dimension type for matrix '+name+': '+type);}return makeVector(d*d,0);}else{throw new GLError('','Unknown uniform data type for '+name+': '+type);}}}function storeProperty(obj,prop,type){if(typeof type==='object'){var child=processObject(type);Object.defineProperty(obj,prop,{get:identity(child),set:makeSetter(type),enumerable:true,configurable:false});}else{if(locations[type]){Object.defineProperty(obj,prop,{get:makeGetter(type),set:makeSetter(type),enumerable:true,configurable:false});}else{obj[prop]=defaultValue(uniforms[type].type);}}}function processObject(obj){var result;if(Array.isArray(obj)){result=new Array(obj.length);for(var i=0;i<obj.length;++i){storeProperty(result,i,obj[i]);}}else{result={};for(var id in obj){storeProperty(result,id,obj[id]);}}return result;}//Return data
var coallesced=coallesceUniforms(uniforms,true);return{get:identity(processObject(coallesced)),set:makeSetter(coallesced),enumerable:true,configurable:true};}/***/}),/***/216:(/***/function(module){"use strict";module.exports=makeReflectTypes;//Construct type info for reflection.
//
// This iterates over the flattened list of uniform type values and smashes them into a JSON object.
//
// The leaves of the resulting object are either indices or type strings representing primitive glslify types
function makeReflectTypes(uniforms,useIndex){var obj={};for(var i=0;i<uniforms.length;++i){var n=uniforms[i].name;var parts=n.split(".");var o=obj;for(var j=0;j<parts.length;++j){var x=parts[j].split("[");if(x.length>1){if(!(x[0]in o)){o[x[0]]=[];}o=o[x[0]];for(var k=1;k<x.length;++k){var y=parseInt(x[k]);if(k<x.length-1||j<parts.length-1){if(!(y in o)){if(k<x.length-1){o[y]=[];}else{o[y]={};}}o=o[y];}else{if(useIndex){o[y]=i;}else{o[y]=uniforms[i].type;}}}}else if(j<parts.length-1){if(!(x[0]in o)){o[x[0]]={};}o=o[x[0]];}else{if(useIndex){o[x[0]]=i;}else{o[x[0]]=uniforms[i].type;}}}}return obj;}/***/}),/***/2145:(/***/function(__unused_webpack_module,exports){"use strict";exports.uniforms=runtimeUniforms;exports.attributes=runtimeAttributes;var GL_TO_GLSL_TYPES={'FLOAT':'float','FLOAT_VEC2':'vec2','FLOAT_VEC3':'vec3','FLOAT_VEC4':'vec4','INT':'int','INT_VEC2':'ivec2','INT_VEC3':'ivec3','INT_VEC4':'ivec4','BOOL':'bool','BOOL_VEC2':'bvec2','BOOL_VEC3':'bvec3','BOOL_VEC4':'bvec4','FLOAT_MAT2':'mat2','FLOAT_MAT3':'mat3','FLOAT_MAT4':'mat4','SAMPLER_2D':'sampler2D','SAMPLER_CUBE':'samplerCube'};var GL_TABLE=null;function getType(gl,type){if(!GL_TABLE){var typeNames=Object.keys(GL_TO_GLSL_TYPES);GL_TABLE={};for(var i=0;i<typeNames.length;++i){var tn=typeNames[i];GL_TABLE[gl[tn]]=GL_TO_GLSL_TYPES[tn];}}return GL_TABLE[type];}function runtimeUniforms(gl,program){var numUniforms=gl.getProgramParameter(program,gl.ACTIVE_UNIFORMS);var result=[];for(var i=0;i<numUniforms;++i){var info=gl.getActiveUniform(program,i);if(info){var type=getType(gl,info.type);if(info.size>1){for(var j=0;j<info.size;++j){result.push({name:info.name.replace('[0]','['+j+']'),type:type});}}else{result.push({name:info.name,type:type});}}}return result;}function runtimeAttributes(gl,program){var numAttributes=gl.getProgramParameter(program,gl.ACTIVE_ATTRIBUTES);var result=[];for(var i=0;i<numAttributes;++i){var info=gl.getActiveAttrib(program,i);if(info){result.push({name:info.name,type:getType(gl,info.type)});}}return result;}/***/}),/***/5091:(/***/function(__unused_webpack_module,exports,__nested_webpack_require_509132__){"use strict";exports.shader=getShaderReference;exports.program=createProgram;var GLError=__nested_webpack_require_509132__(8866);var formatCompilerError=__nested_webpack_require_509132__(2992);var weakMap=typeof WeakMap==='undefined'?__nested_webpack_require_509132__(606):WeakMap;var CACHE=new weakMap();var SHADER_COUNTER=0;function ShaderReference(id,src,type,shader,programs,count,cache){this.id=id;this.src=src;this.type=type;this.shader=shader;this.count=count;this.programs=[];this.cache=cache;}ShaderReference.prototype.dispose=function(){if(--this.count===0){var cache=this.cache;var gl=cache.gl;//Remove program references
var programs=this.programs;for(var i=0,n=programs.length;i<n;++i){var p=cache.programs[programs[i]];if(p){delete cache.programs[i];gl.deleteProgram(p);}}//Remove shader reference
gl.deleteShader(this.shader);delete cache.shaders[this.type===gl.FRAGMENT_SHADER|0][this.src];}};function ContextCache(gl){this.gl=gl;this.shaders=[{},{}];this.programs={};}var proto=ContextCache.prototype;function compileShader(gl,type,src){var shader=gl.createShader(type);gl.shaderSource(shader,src);gl.compileShader(shader);if(!gl.getShaderParameter(shader,gl.COMPILE_STATUS)){var errLog=gl.getShaderInfoLog(shader);try{var fmt=formatCompilerError(errLog,src,type);}catch(e){console.warn('Failed to format compiler error: '+e);throw new GLError(errLog,'Error compiling shader:\n'+errLog);}throw new GLError(errLog,fmt.short,fmt.long);}return shader;}proto.getShaderReference=function(type,src){var gl=this.gl;var shaders=this.shaders[type===gl.FRAGMENT_SHADER|0];var shader=shaders[src];if(!shader||!gl.isShader(shader.shader)){var shaderObj=compileShader(gl,type,src);shader=shaders[src]=new ShaderReference(SHADER_COUNTER++,src,type,shaderObj,[],1,this);}else{shader.count+=1;}return shader;};function linkProgram(gl,vshader,fshader,attribs,locations){var program=gl.createProgram();gl.attachShader(program,vshader);gl.attachShader(program,fshader);for(var i=0;i<attribs.length;++i){gl.bindAttribLocation(program,locations[i],attribs[i]);}gl.linkProgram(program);if(!gl.getProgramParameter(program,gl.LINK_STATUS)){var errLog=gl.getProgramInfoLog(program);throw new GLError(errLog,'Error linking program: '+errLog);}return program;}proto.getProgram=function(vref,fref,attribs,locations){var token=[vref.id,fref.id,attribs.join(':'),locations.join(':')].join('@');var prog=this.programs[token];if(!prog||!this.gl.isProgram(prog)){this.programs[token]=prog=linkProgram(this.gl,vref.shader,fref.shader,attribs,locations);vref.programs.push(token);fref.programs.push(token);}return prog;};function getCache(gl){var ctxCache=CACHE.get(gl);if(!ctxCache){ctxCache=new ContextCache(gl);CACHE.set(gl,ctxCache);}return ctxCache;}function getShaderReference(gl,type,src){return getCache(gl).getShaderReference(type,src);}function createProgram(gl,vref,fref,attribs,locations){return getCache(gl).getProgram(vref,fref,attribs,locations);}/***/}),/***/4098:(/***/function(module){"use strict";module.exports=createSpikes2D;function GLSpikes2D(plot){this.plot=plot;this.enable=[true,true,false,false];this.width=[1,1,1,1];this.color=[[0,0,0,1],[0,0,0,1],[0,0,0,1],[0,0,0,1]];this.center=[Infinity,Infinity];}var proto=GLSpikes2D.prototype;proto.update=function(options){options=options||{};this.enable=(options.enable||[true,true,false,false]).slice();this.width=(options.width||[1,1,1,1]).slice();this.color=(options.color||[[0,0,0,1],[0,0,0,1],[0,0,0,1],[0,0,0,1]]).map(function(x){return x.slice();});this.center=(options.center||[Infinity,Infinity]).slice();this.plot.setOverlayDirty();};proto.draw=function(){var spikeEnable=this.enable;var spikeWidth=this.width;var spikeColor=this.color;var spikeCenter=this.center;var plot=this.plot;var line=plot.line;var dataBox=plot.dataBox;var viewPixels=plot.viewBox;line.bind();if(dataBox[0]<=spikeCenter[0]&&spikeCenter[0]<=dataBox[2]&&dataBox[1]<=spikeCenter[1]&&spikeCenter[1]<=dataBox[3]){var centerX=viewPixels[0]+(spikeCenter[0]-dataBox[0])/(dataBox[2]-dataBox[0])*(viewPixels[2]-viewPixels[0]);var centerY=viewPixels[1]+(spikeCenter[1]-dataBox[1])/(dataBox[3]-dataBox[1])*(viewPixels[3]-viewPixels[1]);if(spikeEnable[0]){line.drawLine(centerX,centerY,viewPixels[0],centerY,spikeWidth[0],spikeColor[0]);}if(spikeEnable[1]){line.drawLine(centerX,centerY,centerX,viewPixels[1],spikeWidth[1],spikeColor[1]);}if(spikeEnable[2]){line.drawLine(centerX,centerY,viewPixels[2],centerY,spikeWidth[2],spikeColor[2]);}if(spikeEnable[3]){line.drawLine(centerX,centerY,centerX,viewPixels[3],spikeWidth[3],spikeColor[3]);}}};proto.dispose=function(){this.plot.removeOverlay(this);};function createSpikes2D(plot,options){var spikes=new GLSpikes2D(plot);spikes.update(options);plot.addOverlay(spikes);return spikes;}/***/}),/***/1493:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_513932__){"use strict";var glslify=__nested_webpack_require_513932__(3236);var createShader=__nested_webpack_require_513932__(9405);var vertSrc=glslify(["precision mediump float;\n#define GLSLIFY 1\n\nattribute vec3 position, color;\nattribute float weight;\n\nuniform mat4 model, view, projection;\nuniform vec3 coordinates[3];\nuniform vec4 colors[3];\nuniform vec2 screenShape;\nuniform float lineWidth;\n\nvarying vec4 fragColor;\n\nvoid main() {\n  vec3 vertexPosition = mix(coordinates[0],\n    mix(coordinates[2], coordinates[1], 0.5 * (position + 1.0)), abs(position));\n\n  vec4 clipPos = projection * (view * (model * vec4(vertexPosition, 1.0)));\n  vec2 clipOffset = (projection * (view * (model * vec4(color, 0.0)))).xy;\n  vec2 delta = weight * clipOffset * screenShape;\n  vec2 lineOffset = normalize(vec2(delta.y, -delta.x)) / screenShape;\n\n  gl_Position   = vec4(clipPos.xy + clipPos.w * 0.5 * lineWidth * lineOffset, clipPos.z, clipPos.w);\n  fragColor     = color.x * colors[0] + color.y * colors[1] + color.z * colors[2];\n}\n"]);var fragSrc=glslify(["precision mediump float;\n#define GLSLIFY 1\n\nvarying vec4 fragColor;\n\nvoid main() {\n  gl_FragColor = fragColor;\n}"]);module.exports=function(gl){return createShader(gl,vertSrc,fragSrc,null,[{name:'position',type:'vec3'},{name:'color',type:'vec3'},{name:'weight',type:'float'}]);};/***/}),/***/4449:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_515339__){"use strict";var createBuffer=__nested_webpack_require_515339__(2762);var createVAO=__nested_webpack_require_515339__(8116);var createShader=__nested_webpack_require_515339__(1493);module.exports=createSpikes;var identity=[1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1];function AxisSpikes(gl,buffer,vao,shader){this.gl=gl;this.buffer=buffer;this.vao=vao;this.shader=shader;this.pixelRatio=1;this.bounds=[[-1000,-1000,-1000],[1000,1000,1000]];this.position=[0,0,0];this.lineWidth=[2,2,2];this.colors=[[0,0,0,1],[0,0,0,1],[0,0,0,1]];this.enabled=[true,true,true];this.drawSides=[true,true,true];this.axes=null;}var proto=AxisSpikes.prototype;var OUTER_FACE=[0,0,0];var INNER_FACE=[0,0,0];var SHAPE=[0,0];proto.isTransparent=function(){return false;};proto.drawTransparent=function(camera){};proto.draw=function(camera){var gl=this.gl;var vao=this.vao;var shader=this.shader;vao.bind();shader.bind();var model=camera.model||identity;var view=camera.view||identity;var projection=camera.projection||identity;var axis;if(this.axes){axis=this.axes.lastCubeProps.axis;}var outerFace=OUTER_FACE;var innerFace=INNER_FACE;for(var i=0;i<3;++i){if(axis&&axis[i]<0){outerFace[i]=this.bounds[0][i];innerFace[i]=this.bounds[1][i];}else{outerFace[i]=this.bounds[1][i];innerFace[i]=this.bounds[0][i];}}SHAPE[0]=gl.drawingBufferWidth;SHAPE[1]=gl.drawingBufferHeight;shader.uniforms.model=model;shader.uniforms.view=view;shader.uniforms.projection=projection;shader.uniforms.coordinates=[this.position,outerFace,innerFace];shader.uniforms.colors=this.colors;shader.uniforms.screenShape=SHAPE;for(var i=0;i<3;++i){shader.uniforms.lineWidth=this.lineWidth[i]*this.pixelRatio;if(this.enabled[i]){vao.draw(gl.TRIANGLES,6,6*i);if(this.drawSides[i]){vao.draw(gl.TRIANGLES,12,18+12*i);}}}vao.unbind();};proto.update=function(options){if(!options){return;}if("bounds"in options){this.bounds=options.bounds;}if("position"in options){this.position=options.position;}if("lineWidth"in options){this.lineWidth=options.lineWidth;}if("colors"in options){this.colors=options.colors;}if("enabled"in options){this.enabled=options.enabled;}if("drawSides"in options){this.drawSides=options.drawSides;}};proto.dispose=function(){this.vao.dispose();this.buffer.dispose();this.shader.dispose();};function createSpikes(gl,options){//Create buffers
var data=[];function line(x,y,z,i,l,h){var row=[x,y,z,0,0,0,1];row[i+3]=1;row[i]=l;data.push.apply(data,row);row[6]=-1;data.push.apply(data,row);row[i]=h;data.push.apply(data,row);data.push.apply(data,row);row[6]=1;data.push.apply(data,row);row[i]=l;data.push.apply(data,row);}line(0,0,0,0,0,1);line(0,0,0,1,0,1);line(0,0,0,2,0,1);line(1,0,0,1,-1,1);line(1,0,0,2,-1,1);line(0,1,0,0,-1,1);line(0,1,0,2,-1,1);line(0,0,1,0,-1,1);line(0,0,1,1,-1,1);var buffer=createBuffer(gl,data);var vao=createVAO(gl,[{type:gl.FLOAT,buffer:buffer,size:3,offset:0,stride:28},{type:gl.FLOAT,buffer:buffer,size:3,offset:12,stride:28},{type:gl.FLOAT,buffer:buffer,size:1,offset:24,stride:28}]);//Create shader
var shader=createShader(gl);shader.attributes.position.location=0;shader.attributes.color.location=1;shader.attributes.weight.location=2;//Create spike object
var spikes=new AxisSpikes(gl,buffer,vao,shader);//Set parameters
spikes.update(options);//Return resulting object
return spikes;}/***/}),/***/6740:(/***/function(__unused_webpack_module,exports,__nested_webpack_require_518651__){var glslify=__nested_webpack_require_518651__(3236);var triVertSrc=glslify(["precision highp float;\n\nprecision highp float;\n#define GLSLIFY 1\n\nvec3 getOrthogonalVector(vec3 v) {\n  // Return up-vector for only-z vector.\n  // Return ax + by + cz = 0, a point that lies on the plane that has v as a normal and that isn't (0,0,0).\n  // From the above if-statement we have ||a|| > 0  U  ||b|| > 0.\n  // Assign z = 0, x = -b, y = a:\n  // a*-b + b*a + c*0 = -ba + ba + 0 = 0\n  if (v.x*v.x > v.z*v.z || v.y*v.y > v.z*v.z) {\n    return normalize(vec3(-v.y, v.x, 0.0));\n  } else {\n    return normalize(vec3(0.0, v.z, -v.y));\n  }\n}\n\n// Calculate the tube vertex and normal at the given index.\n//\n// The returned vertex is for a tube ring with its center at origin, radius of length(d), pointing in the direction of d.\n//\n// Each tube segment is made up of a ring of vertices.\n// These vertices are used to make up the triangles of the tube by connecting them together in the vertex array.\n// The indexes of tube segments run from 0 to 8.\n//\nvec3 getTubePosition(vec3 d, float index, out vec3 normal) {\n  float segmentCount = 8.0;\n\n  float angle = 2.0 * 3.14159 * (index / segmentCount);\n\n  vec3 u = getOrthogonalVector(d);\n  vec3 v = normalize(cross(u, d));\n\n  vec3 x = u * cos(angle) * length(d);\n  vec3 y = v * sin(angle) * length(d);\n  vec3 v3 = x + y;\n\n  normal = normalize(v3);\n\n  return v3;\n}\n\nattribute vec4 vector;\nattribute vec4 color, position;\nattribute vec2 uv;\n\nuniform float vectorScale, tubeScale;\nuniform mat4 model, view, projection, inverseModel;\nuniform vec3 eyePosition, lightPosition;\n\nvarying vec3 f_normal, f_lightDirection, f_eyeDirection, f_data, f_position;\nvarying vec4 f_color;\nvarying vec2 f_uv;\n\nvoid main() {\n  // Scale the vector magnitude to stay constant with\n  // model & view changes.\n  vec3 normal;\n  vec3 XYZ = getTubePosition(mat3(model) * (tubeScale * vector.w * normalize(vector.xyz)), position.w, normal);\n  vec4 tubePosition = model * vec4(position.xyz, 1.0) + vec4(XYZ, 0.0);\n\n  //Lighting geometry parameters\n  vec4 cameraCoordinate = view * tubePosition;\n  cameraCoordinate.xyz /= cameraCoordinate.w;\n  f_lightDirection = lightPosition - cameraCoordinate.xyz;\n  f_eyeDirection   = eyePosition - cameraCoordinate.xyz;\n  f_normal = normalize((vec4(normal, 0.0) * inverseModel).xyz);\n\n  // vec4 m_position  = model * vec4(tubePosition, 1.0);\n  vec4 t_position  = view * tubePosition;\n  gl_Position      = projection * t_position;\n\n  f_color          = color;\n  f_data           = tubePosition.xyz;\n  f_position       = position.xyz;\n  f_uv             = uv;\n}\n"]);var triFragSrc=glslify(["#extension GL_OES_standard_derivatives : enable\n\nprecision highp float;\n#define GLSLIFY 1\n\nfloat beckmannDistribution(float x, float roughness) {\n  float NdotH = max(x, 0.0001);\n  float cos2Alpha = NdotH * NdotH;\n  float tan2Alpha = (cos2Alpha - 1.0) / cos2Alpha;\n  float roughness2 = roughness * roughness;\n  float denom = 3.141592653589793 * roughness2 * cos2Alpha * cos2Alpha;\n  return exp(tan2Alpha / roughness2) / denom;\n}\n\nfloat cookTorranceSpecular(\n  vec3 lightDirection,\n  vec3 viewDirection,\n  vec3 surfaceNormal,\n  float roughness,\n  float fresnel) {\n\n  float VdotN = max(dot(viewDirection, surfaceNormal), 0.0);\n  float LdotN = max(dot(lightDirection, surfaceNormal), 0.0);\n\n  //Half angle vector\n  vec3 H = normalize(lightDirection + viewDirection);\n\n  //Geometric term\n  float NdotH = max(dot(surfaceNormal, H), 0.0);\n  float VdotH = max(dot(viewDirection, H), 0.000001);\n  float LdotH = max(dot(lightDirection, H), 0.000001);\n  float G1 = (2.0 * NdotH * VdotN) / VdotH;\n  float G2 = (2.0 * NdotH * LdotN) / LdotH;\n  float G = min(1.0, min(G1, G2));\n  \n  //Distribution term\n  float D = beckmannDistribution(NdotH, roughness);\n\n  //Fresnel term\n  float F = pow(1.0 - VdotN, fresnel);\n\n  //Multiply terms and done\n  return  G * F * D / max(3.14159265 * VdotN, 0.000001);\n}\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3 clipBounds[2];\nuniform float roughness, fresnel, kambient, kdiffuse, kspecular, opacity;\nuniform sampler2D texture;\n\nvarying vec3 f_normal, f_lightDirection, f_eyeDirection, f_data, f_position;\nvarying vec4 f_color;\nvarying vec2 f_uv;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], f_position)) discard;\n  vec3 N = normalize(f_normal);\n  vec3 L = normalize(f_lightDirection);\n  vec3 V = normalize(f_eyeDirection);\n\n  if(gl_FrontFacing) {\n    N = -N;\n  }\n\n  float specular = min(1.0, max(0.0, cookTorranceSpecular(L, V, N, roughness, fresnel)));\n  float diffuse  = min(kambient + kdiffuse * max(dot(N, L), 0.0), 1.0);\n\n  vec4 surfaceColor = f_color * texture2D(texture, f_uv);\n  vec4 litColor = surfaceColor.a * vec4(diffuse * surfaceColor.rgb + kspecular * vec3(1,1,1) * specular,  1.0);\n\n  gl_FragColor = litColor * opacity;\n}\n"]);var pickVertSrc=glslify(["precision highp float;\n\nprecision highp float;\n#define GLSLIFY 1\n\nvec3 getOrthogonalVector(vec3 v) {\n  // Return up-vector for only-z vector.\n  // Return ax + by + cz = 0, a point that lies on the plane that has v as a normal and that isn't (0,0,0).\n  // From the above if-statement we have ||a|| > 0  U  ||b|| > 0.\n  // Assign z = 0, x = -b, y = a:\n  // a*-b + b*a + c*0 = -ba + ba + 0 = 0\n  if (v.x*v.x > v.z*v.z || v.y*v.y > v.z*v.z) {\n    return normalize(vec3(-v.y, v.x, 0.0));\n  } else {\n    return normalize(vec3(0.0, v.z, -v.y));\n  }\n}\n\n// Calculate the tube vertex and normal at the given index.\n//\n// The returned vertex is for a tube ring with its center at origin, radius of length(d), pointing in the direction of d.\n//\n// Each tube segment is made up of a ring of vertices.\n// These vertices are used to make up the triangles of the tube by connecting them together in the vertex array.\n// The indexes of tube segments run from 0 to 8.\n//\nvec3 getTubePosition(vec3 d, float index, out vec3 normal) {\n  float segmentCount = 8.0;\n\n  float angle = 2.0 * 3.14159 * (index / segmentCount);\n\n  vec3 u = getOrthogonalVector(d);\n  vec3 v = normalize(cross(u, d));\n\n  vec3 x = u * cos(angle) * length(d);\n  vec3 y = v * sin(angle) * length(d);\n  vec3 v3 = x + y;\n\n  normal = normalize(v3);\n\n  return v3;\n}\n\nattribute vec4 vector;\nattribute vec4 position;\nattribute vec4 id;\n\nuniform mat4 model, view, projection;\nuniform float tubeScale;\n\nvarying vec3 f_position;\nvarying vec4 f_id;\n\nvoid main() {\n  vec3 normal;\n  vec3 XYZ = getTubePosition(mat3(model) * (tubeScale * vector.w * normalize(vector.xyz)), position.w, normal);\n  vec4 tubePosition = model * vec4(position.xyz, 1.0) + vec4(XYZ, 0.0);\n\n  gl_Position = projection * (view * tubePosition);\n  f_id        = id;\n  f_position  = position.xyz;\n}\n"]);var pickFragSrc=glslify(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3  clipBounds[2];\nuniform float pickId;\n\nvarying vec3 f_position;\nvarying vec4 f_id;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], f_position)) discard;\n\n  gl_FragColor = vec4(pickId, f_id.xyz);\n}"]);exports.meshShader={vertex:triVertSrc,fragment:triFragSrc,attributes:[{name:'position',type:'vec4'},{name:'color',type:'vec4'},{name:'uv',type:'vec2'},{name:'vector',type:'vec4'}]};exports.pickShader={vertex:pickVertSrc,fragment:pickFragSrc,attributes:[{name:'position',type:'vec4'},{name:'id',type:'vec4'},{name:'vector',type:'vec4'}]};/***/}),/***/7815:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_527176__){"use strict";var vec3=__nested_webpack_require_527176__(2931);var vec4=__nested_webpack_require_527176__(9970);var GRID_TYPES=['xyz','xzy','yxz','yzx','zxy','zyx'];var streamToTube=function(stream,maxDivergence,minDistance,maxNorm){var points=stream.points;var velocities=stream.velocities;var divergences=stream.divergences;var verts=[];var faces=[];var vectors=[];var previousVerts=[];var currentVerts=[];var intensities=[];var previousIntensity=0;var currentIntensity=0;var currentVector=vec4.create();var previousVector=vec4.create();var facets=8;for(var i=0;i<points.length;i++){var p=points[i];var fwd=velocities[i];var r=divergences[i];if(maxDivergence===0){r=minDistance*0.05;}currentIntensity=vec3.length(fwd)/maxNorm;currentVector=vec4.create();vec3.copy(currentVector,fwd);currentVector[3]=r;for(var a=0;a<facets;a++){currentVerts[a]=[p[0],p[1],p[2],a];}if(previousVerts.length>0){for(var a=0;a<facets;a++){var a1=(a+1)%facets;verts.push(previousVerts[a],currentVerts[a],currentVerts[a1],currentVerts[a1],previousVerts[a1],previousVerts[a]);vectors.push(previousVector,currentVector,currentVector,currentVector,previousVector,previousVector);intensities.push(previousIntensity,currentIntensity,currentIntensity,currentIntensity,previousIntensity,previousIntensity);var len=verts.length;faces.push([len-6,len-5,len-4],[len-3,len-2,len-1]);}}var tmp1=previousVerts;previousVerts=currentVerts;currentVerts=tmp1;var tmp2=previousVector;previousVector=currentVector;currentVector=tmp2;var tmp3=previousIntensity;previousIntensity=currentIntensity;currentIntensity=tmp3;}return{positions:verts,cells:faces,vectors:vectors,vertexIntensity:intensities};};var createTubes=function(streams,colormap,maxDivergence,minDistance){var maxNorm=0;for(var i=0;i<streams.length;i++){var velocities=streams[i].velocities;for(var j=0;j<velocities.length;j++){maxNorm=Math.max(maxNorm,vec3.length(velocities[j]));}}var tubes=streams.map(function(s){return streamToTube(s,maxDivergence,minDistance,maxNorm);});var positions=[];var cells=[];var vectors=[];var vertexIntensity=[];for(var i=0;i<tubes.length;i++){var tube=tubes[i];var offset=positions.length;positions=positions.concat(tube.positions);vectors=vectors.concat(tube.vectors);vertexIntensity=vertexIntensity.concat(tube.vertexIntensity);for(var j=0;j<tube.cells.length;j++){var cell=tube.cells[j];var newCell=[];cells.push(newCell);for(var k=0;k<cell.length;k++){newCell.push(cell[k]+offset);}}}return{positions:positions,cells:cells,vectors:vectors,vertexIntensity:vertexIntensity,colormap:colormap};};var findLastSmallerIndex=function(points,v){var len=points.length;var i;for(i=0;i<len;i++){var p=points[i];if(p===v)return i;else if(p>v)return i-1;}return i;};var clamp=function(v,min,max){return v<min?min:v>max?max:v;};var sampleMeshgrid=function(point,vectorField,gridInfo){var vectors=vectorField.vectors;var meshgrid=vectorField.meshgrid;var x=point[0];var y=point[1];var z=point[2];var w=meshgrid[0].length;var h=meshgrid[1].length;var d=meshgrid[2].length;// Find the index of the nearest smaller value in the meshgrid for each coordinate of (x,y,z).
// The nearest smaller value index for x is the index x0 such that
// meshgrid[0][x0] < x and for all x1 > x0, meshgrid[0][x1] >= x.
var x0=findLastSmallerIndex(meshgrid[0],x);var y0=findLastSmallerIndex(meshgrid[1],y);var z0=findLastSmallerIndex(meshgrid[2],z);// Get the nearest larger meshgrid value indices.
// From the above "nearest smaller value", we know that
//   meshgrid[0][x0] < x
//   meshgrid[0][x0+1] >= x
var x1=x0+1;var y1=y0+1;var z1=z0+1;x0=clamp(x0,0,w-1);x1=clamp(x1,0,w-1);y0=clamp(y0,0,h-1);y1=clamp(y1,0,h-1);z0=clamp(z0,0,d-1);z1=clamp(z1,0,d-1);// Reject points outside the meshgrid, return a zero vector.
if(x0<0||y0<0||z0<0||x1>w-1||y1>h-1||z1>d-1){return vec3.create();}// Normalize point coordinates to 0..1 scaling factor between x0 and x1.
var mX0=meshgrid[0][x0];var mX1=meshgrid[0][x1];var mY0=meshgrid[1][y0];var mY1=meshgrid[1][y1];var mZ0=meshgrid[2][z0];var mZ1=meshgrid[2][z1];var xf=(x-mX0)/(mX1-mX0);var yf=(y-mY0)/(mY1-mY0);var zf=(z-mZ0)/(mZ1-mZ0);if(!isFinite(xf))xf=0.5;if(!isFinite(yf))yf=0.5;if(!isFinite(zf))zf=0.5;var x0off;var x1off;var y0off;var y1off;var z0off;var z1off;if(gridInfo.reversedX){x0=w-1-x0;x1=w-1-x1;}if(gridInfo.reversedY){y0=h-1-y0;y1=h-1-y1;}if(gridInfo.reversedZ){z0=d-1-z0;z1=d-1-z1;}switch(gridInfo.filled){case 5:// 'zyx'
z0off=z0;z1off=z1;y0off=y0*d;y1off=y1*d;x0off=x0*d*h;x1off=x1*d*h;break;case 4:// 'zxy'
z0off=z0;z1off=z1;x0off=x0*d;x1off=x1*d;y0off=y0*d*w;y1off=y1*d*w;break;case 3:// 'yzx'
y0off=y0;y1off=y1;z0off=z0*h;z1off=z1*h;x0off=x0*h*d;x1off=x1*h*d;break;case 2:// 'yxz'
y0off=y0;y1off=y1;x0off=x0*h;x1off=x1*h;z0off=z0*h*w;z1off=z1*h*w;break;case 1:// 'xzy'
x0off=x0;x1off=x1;z0off=z0*w;z1off=z1*w;y0off=y0*w*d;y1off=y1*w*d;break;default:// case 0: // 'xyz'
x0off=x0;x1off=x1;y0off=y0*w;y1off=y1*w;z0off=z0*w*h;z1off=z1*w*h;break;}// Sample data vectors around the (x,y,z) point.
var v000=vectors[x0off+y0off+z0off];var v001=vectors[x0off+y0off+z1off];var v010=vectors[x0off+y1off+z0off];var v011=vectors[x0off+y1off+z1off];var v100=vectors[x1off+y0off+z0off];var v101=vectors[x1off+y0off+z1off];var v110=vectors[x1off+y1off+z0off];var v111=vectors[x1off+y1off+z1off];var c00=vec3.create();var c01=vec3.create();var c10=vec3.create();var c11=vec3.create();vec3.lerp(c00,v000,v100,xf);vec3.lerp(c01,v001,v101,xf);vec3.lerp(c10,v010,v110,xf);vec3.lerp(c11,v011,v111,xf);var c0=vec3.create();var c1=vec3.create();vec3.lerp(c0,c00,c10,yf);vec3.lerp(c1,c01,c11,yf);var c=vec3.create();vec3.lerp(c,c0,c1,zf);return c;};var vabs=function(dst,v){var x=v[0];var y=v[1];var z=v[2];dst[0]=x<0?-x:x;dst[1]=y<0?-y:y;dst[2]=z<0?-z:z;return dst;};var findMinSeparation=function(xs){var minSeparation=Infinity;xs.sort(function(a,b){return a-b;});var len=xs.length;for(var i=1;i<len;i++){var d=Math.abs(xs[i]-xs[i-1]);if(d<minSeparation){minSeparation=d;}}return minSeparation;};// Finds the minimum per-component distance in positions.
//
var calculateMinPositionDistance=function(positions){var xs=[],ys=[],zs=[];var xi={},yi={},zi={};var len=positions.length;for(var i=0;i<len;i++){var p=positions[i];var x=p[0],y=p[1],z=p[2];// Split the positions array into arrays of unique component values.
//
// Why go through the trouble of using a uniqueness hash table vs
// sort and uniq:
//
// Suppose you've got a million positions in a 100x100x100 grid.
//
// Using a uniqueness hash table, you're doing 1M array reads,
// 3M hash table lookups from 100-element hashes, 300 hash table inserts, then
// sorting three 100-element arrays and iterating over them.
// Roughly, 1M + 3M * ln(100) + 300 * ln(100/2) + 3 * 100 * ln(100) + 3 * 100 =
//          1M + 13.8M + 0.0012M +  0.0014M + 0.0003M
//          =~ 15M
//
// Sort and uniq solution would do 1M array reads, 3M array inserts,
// sort three 1M-element arrays and iterate over them.
// Roughly, 1M + 3M + 3 * 1M * ln(1M) + 3 * 1M =
//          1M + 3M + 41.4M + 3M
//          =~ 48.4M
//
// Guessing that a hard-coded sort & uniq would be faster due to not having
// to run a hashing function on everything. More memory usage though
// (bunch of small hash tables vs. duplicating the input array.)
//
// In JS-land, who knows. Maybe xi[x] casts x to string and destroys perf,
// maybe numeric keys get special-cased, maybe the object lookups run at near O(1)-speeds.
// Maybe the sorting comparison function is expensive to call, maybe it gets inlined or special-cased.
//
// ... You're probably not going to call this with more than 10k positions anyhow, so this is very academic.
//
if(!xi[x]){xs.push(x);xi[x]=true;}if(!yi[y]){ys.push(y);yi[y]=true;}if(!zi[z]){zs.push(z);zi[z]=true;}}var xSep=findMinSeparation(xs);var ySep=findMinSeparation(ys);var zSep=findMinSeparation(zs);var minSeparation=Math.min(xSep,ySep,zSep);return isFinite(minSeparation)?minSeparation:1;};module.exports=function(vectorField,bounds){var positions=vectorField.startingPositions;var maxLength=vectorField.maxLength||1000;var tubeSize=vectorField.tubeSize||1;var absoluteTubeSize=vectorField.absoluteTubeSize;var gridFill=vectorField.gridFill||'+x+y+z';var gridInfo={};if(gridFill.indexOf('-x')!==-1){gridInfo.reversedX=true;}if(gridFill.indexOf('-y')!==-1){gridInfo.reversedY=true;}if(gridFill.indexOf('-z')!==-1){gridInfo.reversedZ=true;}gridInfo.filled=GRID_TYPES.indexOf(gridFill.replace(/-/g,'').replace(/\+/g,''));var getVelocity=vectorField.getVelocity||function(p){return sampleMeshgrid(p,vectorField,gridInfo);};var getDivergence=vectorField.getDivergence||function(p,v0){var dp=vec3.create();var e=0.0001;vec3.add(dp,p,[e,0,0]);var vx=getVelocity(dp);vec3.subtract(vx,vx,v0);vec3.scale(vx,vx,1/e);vec3.add(dp,p,[0,e,0]);var vy=getVelocity(dp);vec3.subtract(vy,vy,v0);vec3.scale(vy,vy,1/e);vec3.add(dp,p,[0,0,e]);var vz=getVelocity(dp);vec3.subtract(vz,vz,v0);vec3.scale(vz,vz,1/e);vec3.add(dp,vx,vy);vec3.add(dp,dp,vz);return dp;};var streams=[];var minX=bounds[0][0],minY=bounds[0][1],minZ=bounds[0][2];var maxX=bounds[1][0],maxY=bounds[1][1],maxZ=bounds[1][2];var inBounds=function(p){var x=p[0];var y=p[1];var z=p[2];return!(x<minX||x>maxX||y<minY||y>maxY||z<minZ||z>maxZ);};var boundsSize=vec3.distance(bounds[0],bounds[1]);var maxStepSize=10*boundsSize/maxLength;var maxStepSizeSq=maxStepSize*maxStepSize;var minDistance=1;var maxDivergence=0;// For component-wise divergence vec3.create();
// In case we need to do component-wise divergence visualization
// var tmp = vec3.create();
var len=positions.length;if(len>1){minDistance=calculateMinPositionDistance(positions);}for(var i=0;i<len;i++){var p=vec3.create();vec3.copy(p,positions[i]);var stream=[p];var velocities=[];var v=getVelocity(p);var op=p;velocities.push(v);var divergences=[];var dv=getDivergence(p,v);var dvLength=vec3.length(dv);if(isFinite(dvLength)&&dvLength>maxDivergence){maxDivergence=dvLength;}// In case we need to do component-wise divergence visualization
// vec3.max(maxDivergence, maxDivergence, vabs(tmp, dv));
divergences.push(dvLength);streams.push({points:stream,velocities:velocities,divergences:divergences});var j=0;while(j<maxLength*100&&stream.length<maxLength&&inBounds(p)){j++;var np=vec3.clone(v);var sqLen=vec3.squaredLength(np);if(sqLen===0){break;}else if(sqLen>maxStepSizeSq){vec3.scale(np,np,maxStepSize/Math.sqrt(sqLen));}vec3.add(np,np,p);v=getVelocity(np);if(vec3.squaredDistance(op,np)-maxStepSizeSq>-0.0001*maxStepSizeSq){stream.push(np);op=np;velocities.push(v);var dv=getDivergence(np,v);var dvLength=vec3.length(dv);if(isFinite(dvLength)&&dvLength>maxDivergence){maxDivergence=dvLength;}// In case we need to do component-wise divergence visualization
//vec3.max(maxDivergence, maxDivergence, vabs(tmp, dv));
divergences.push(dvLength);}p=np;}}var tubes=createTubes(streams,vectorField.colormap,maxDivergence,minDistance);if(absoluteTubeSize){tubes.tubeScale=absoluteTubeSize;}else{// Avoid division by zero.
if(maxDivergence===0){maxDivergence=1;}tubes.tubeScale=tubeSize*0.5*minDistance/maxDivergence;}return tubes;};var shaders=__nested_webpack_require_527176__(6740);var createMesh=__nested_webpack_require_527176__(6405).createMesh;module.exports.createTubeMesh=function(gl,params){return createMesh(gl,params,{shaders:shaders,traceType:'streamtube'});};/***/}),/***/990:(/***/function(__unused_webpack_module,exports,__nested_webpack_require_538502__){var createShader=__nested_webpack_require_538502__(9405);var glslify=__nested_webpack_require_538502__(3236);var vertSrc=glslify(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec4 uv;\nattribute vec3 f;\nattribute vec3 normal;\n\nuniform vec3 objectOffset;\nuniform mat4 model, view, projection, inverseModel;\nuniform vec3 lightPosition, eyePosition;\nuniform sampler2D colormap;\n\nvarying float value, kill;\nvarying vec3 worldCoordinate;\nvarying vec2 planeCoordinate;\nvarying vec3 lightDirection, eyeDirection, surfaceNormal;\nvarying vec4 vColor;\n\nvoid main() {\n  vec3 localCoordinate = vec3(uv.zw, f.x);\n  worldCoordinate = objectOffset + localCoordinate;\n  mat4 objectOffsetTranslation = mat4(1.0) + mat4(vec4(0), vec4(0), vec4(0), vec4(objectOffset, 0));\n  vec4 worldPosition = (model * objectOffsetTranslation) * vec4(localCoordinate, 1.0);\n  vec4 clipPosition = projection * (view * worldPosition);\n  gl_Position = clipPosition;\n  kill = f.y;\n  value = f.z;\n  planeCoordinate = uv.xy;\n\n  vColor = texture2D(colormap, vec2(value, value));\n\n  //Lighting geometry parameters\n  vec4 cameraCoordinate = view * worldPosition;\n  cameraCoordinate.xyz /= cameraCoordinate.w;\n  lightDirection = lightPosition - cameraCoordinate.xyz;\n  eyeDirection   = eyePosition - cameraCoordinate.xyz;\n  surfaceNormal  = normalize((vec4(normal,0) * inverseModel).xyz);\n}\n"]);var fragSrc=glslify(["precision highp float;\n#define GLSLIFY 1\n\nfloat beckmannDistribution(float x, float roughness) {\n  float NdotH = max(x, 0.0001);\n  float cos2Alpha = NdotH * NdotH;\n  float tan2Alpha = (cos2Alpha - 1.0) / cos2Alpha;\n  float roughness2 = roughness * roughness;\n  float denom = 3.141592653589793 * roughness2 * cos2Alpha * cos2Alpha;\n  return exp(tan2Alpha / roughness2) / denom;\n}\n\nfloat beckmannSpecular(\n  vec3 lightDirection,\n  vec3 viewDirection,\n  vec3 surfaceNormal,\n  float roughness) {\n  return beckmannDistribution(dot(surfaceNormal, normalize(lightDirection + viewDirection)), roughness);\n}\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3 lowerBound, upperBound;\nuniform float contourTint;\nuniform vec4 contourColor;\nuniform sampler2D colormap;\nuniform vec3 clipBounds[2];\nuniform float roughness, fresnel, kambient, kdiffuse, kspecular, opacity;\nuniform float vertexColor;\n\nvarying float value, kill;\nvarying vec3 worldCoordinate;\nvarying vec3 lightDirection, eyeDirection, surfaceNormal;\nvarying vec4 vColor;\n\nvoid main() {\n  if (\n    kill > 0.0 ||\n    vColor.a == 0.0 ||\n    outOfRange(clipBounds[0], clipBounds[1], worldCoordinate)\n  ) discard;\n\n  vec3 N = normalize(surfaceNormal);\n  vec3 V = normalize(eyeDirection);\n  vec3 L = normalize(lightDirection);\n\n  if(gl_FrontFacing) {\n    N = -N;\n  }\n\n  float specular = max(beckmannSpecular(L, V, N, roughness), 0.);\n  float diffuse  = min(kambient + kdiffuse * max(dot(N, L), 0.0), 1.0);\n\n  //decide how to interpolate color — in vertex or in fragment\n  vec4 surfaceColor =\n    step(vertexColor, .5) * texture2D(colormap, vec2(value, value)) +\n    step(.5, vertexColor) * vColor;\n\n  vec4 litColor = surfaceColor.a * vec4(diffuse * surfaceColor.rgb + kspecular * vec3(1,1,1) * specular,  1.0);\n\n  gl_FragColor = mix(litColor, contourColor, contourTint) * opacity;\n}\n"]);var contourVertSrc=glslify(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec4 uv;\nattribute float f;\n\nuniform vec3 objectOffset;\nuniform mat3 permutation;\nuniform mat4 model, view, projection;\nuniform float height, zOffset;\nuniform sampler2D colormap;\n\nvarying float value, kill;\nvarying vec3 worldCoordinate;\nvarying vec2 planeCoordinate;\nvarying vec3 lightDirection, eyeDirection, surfaceNormal;\nvarying vec4 vColor;\n\nvoid main() {\n  vec3 dataCoordinate = permutation * vec3(uv.xy, height);\n  worldCoordinate = objectOffset + dataCoordinate;\n  mat4 objectOffsetTranslation = mat4(1.0) + mat4(vec4(0), vec4(0), vec4(0), vec4(objectOffset, 0));\n  vec4 worldPosition = (model * objectOffsetTranslation) * vec4(dataCoordinate, 1.0);\n\n  vec4 clipPosition = projection * (view * worldPosition);\n  clipPosition.z += zOffset;\n\n  gl_Position = clipPosition;\n  value = f + objectOffset.z;\n  kill = -1.0;\n  planeCoordinate = uv.zw;\n\n  vColor = texture2D(colormap, vec2(value, value));\n\n  //Don't do lighting for contours\n  surfaceNormal   = vec3(1,0,0);\n  eyeDirection    = vec3(0,1,0);\n  lightDirection  = vec3(0,0,1);\n}\n"]);var pickSrc=glslify(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec2 shape;\nuniform vec3 clipBounds[2];\nuniform float pickId;\n\nvarying float value, kill;\nvarying vec3 worldCoordinate;\nvarying vec2 planeCoordinate;\nvarying vec3 surfaceNormal;\n\nvec2 splitFloat(float v) {\n  float vh = 255.0 * v;\n  float upper = floor(vh);\n  float lower = fract(vh);\n  return vec2(upper / 255.0, floor(lower * 16.0) / 16.0);\n}\n\nvoid main() {\n  if ((kill > 0.0) ||\n      (outOfRange(clipBounds[0], clipBounds[1], worldCoordinate))) discard;\n\n  vec2 ux = splitFloat(planeCoordinate.x / shape.x);\n  vec2 uy = splitFloat(planeCoordinate.y / shape.y);\n  gl_FragColor = vec4(pickId, ux.x, uy.x, ux.y + (uy.y/16.0));\n}\n"]);exports.createShader=function(gl){var shader=createShader(gl,vertSrc,fragSrc,null,[{name:'uv',type:'vec4'},{name:'f',type:'vec3'},{name:'normal',type:'vec3'}]);shader.attributes.uv.location=0;shader.attributes.f.location=1;shader.attributes.normal.location=2;return shader;};exports.createPickShader=function(gl){var shader=createShader(gl,vertSrc,pickSrc,null,[{name:'uv',type:'vec4'},{name:'f',type:'vec3'},{name:'normal',type:'vec3'}]);shader.attributes.uv.location=0;shader.attributes.f.location=1;shader.attributes.normal.location=2;return shader;};exports.createContourShader=function(gl){var shader=createShader(gl,contourVertSrc,fragSrc,null,[{name:'uv',type:'vec4'},{name:'f',type:'float'}]);shader.attributes.uv.location=0;shader.attributes.f.location=1;return shader;};exports.createPickContourShader=function(gl){var shader=createShader(gl,contourVertSrc,pickSrc,null,[{name:'uv',type:'vec4'},{name:'f',type:'float'}]);shader.attributes.uv.location=0;shader.attributes.f.location=1;return shader;};/***/}),/***/9499:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_545731__){"use strict";module.exports=createSurfacePlot;var bits=__nested_webpack_require_545731__(8828);var createBuffer=__nested_webpack_require_545731__(2762);var createVAO=__nested_webpack_require_545731__(8116);var createTexture=__nested_webpack_require_545731__(7766);var pool=__nested_webpack_require_545731__(1888);var colormap=__nested_webpack_require_545731__(6729);var ops=__nested_webpack_require_545731__(5298);var pack=__nested_webpack_require_545731__(9994);var ndarray=__nested_webpack_require_545731__(9618);var surfaceNets=__nested_webpack_require_545731__(3711);var multiply=__nested_webpack_require_545731__(6760);var invert=__nested_webpack_require_545731__(7608);var bsearch=__nested_webpack_require_545731__(2478);var gradient=__nested_webpack_require_545731__(6199);var shaders=__nested_webpack_require_545731__(990);var createShader=shaders.createShader;var createContourShader=shaders.createContourShader;var createPickShader=shaders.createPickShader;var createPickContourShader=shaders.createPickContourShader;var SURFACE_VERTEX_SIZE=4*(4+3+3);var IDENTITY=[1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1];var QUAD=[[0,0],[0,1],[1,0],[1,1],[1,0],[0,1]];var PERMUTATIONS=[[0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0]];(function(){for(var i=0;i<3;++i){var p=PERMUTATIONS[i];var u=(i+1)%3;var v=(i+2)%3;p[u+0]=1;p[v+3]=1;p[i+6]=1;}})();function SurfacePickResult(position,index,uv,level,dataCoordinate){this.position=position;this.index=index;this.uv=uv;this.level=level;this.dataCoordinate=dataCoordinate;}var N_COLORS=256;function SurfacePlot(gl,shape,bounds,shader,pickShader,coordinates,vao,colorMap,contourShader,contourPickShader,contourBuffer,contourVAO,dynamicBuffer,dynamicVAO,objectOffset){this.gl=gl;this.shape=shape;this.bounds=bounds;this.objectOffset=objectOffset;this.intensityBounds=[];this._shader=shader;this._pickShader=pickShader;this._coordinateBuffer=coordinates;this._vao=vao;this._colorMap=colorMap;this._contourShader=contourShader;this._contourPickShader=contourPickShader;this._contourBuffer=contourBuffer;this._contourVAO=contourVAO;this._contourOffsets=[[],[],[]];this._contourCounts=[[],[],[]];this._vertexCount=0;this._pickResult=new SurfacePickResult([0,0,0],[0,0],[0,0],[0,0,0],[0,0,0]);this._dynamicBuffer=dynamicBuffer;this._dynamicVAO=dynamicVAO;this._dynamicOffsets=[0,0,0];this._dynamicCounts=[0,0,0];this.contourWidth=[1,1,1];this.contourLevels=[[1],[1],[1]];this.contourTint=[0,0,0];this.contourColor=[[0.5,0.5,0.5,1],[0.5,0.5,0.5,1],[0.5,0.5,0.5,1]];this.showContour=true;this.showSurface=true;this.enableHighlight=[true,true,true];this.highlightColor=[[0,0,0,1],[0,0,0,1],[0,0,0,1]];this.highlightTint=[1,1,1];this.highlightLevel=[-1,-1,-1];// Dynamic contour options
this.enableDynamic=[true,true,true];this.dynamicLevel=[NaN,NaN,NaN];this.dynamicColor=[[0,0,0,1],[0,0,0,1],[0,0,0,1]];this.dynamicTint=[1,1,1];this.dynamicWidth=[1,1,1];this.axesBounds=[[Infinity,Infinity,Infinity],[-Infinity,-Infinity,-Infinity]];this.surfaceProject=[false,false,false];this.contourProject=[[false,false,false],[false,false,false],[false,false,false]];this.colorBounds=[false,false];// Store xyz fields, need this for picking
this._field=[ndarray(pool.mallocFloat(1024),[0,0]),ndarray(pool.mallocFloat(1024),[0,0]),ndarray(pool.mallocFloat(1024),[0,0])];this.pickId=1;this.clipBounds=[[-Infinity,-Infinity,-Infinity],[Infinity,Infinity,Infinity]];this.snapToData=false;this.pixelRatio=1;this.opacity=1.0;this.lightPosition=[10,10000,0];this.ambientLight=0.8;this.diffuseLight=0.8;this.specularLight=2.0;this.roughness=0.5;this.fresnel=1.5;this.vertexColor=0;this.dirty=true;}var proto=SurfacePlot.prototype;proto.genColormap=function(name,opacityscale){var hasAlpha=false;var x=pack([colormap({colormap:name,nshades:N_COLORS,format:'rgba'}).map(function(c,i){var a=opacityscale?getOpacityFromScale(i/255.0,opacityscale):c[3];if(a<1)hasAlpha=true;return[c[0],c[1],c[2],255*a];})]);ops.divseq(x,255.0);this.hasAlphaScale=hasAlpha;return x;};proto.isTransparent=function(){return this.opacity<1||this.hasAlphaScale;};proto.isOpaque=function(){return!this.isTransparent();};proto.pickSlots=1;proto.setPickBase=function(id){this.pickId=id;};function getOpacityFromScale(ratio,opacityscale){// copied form gl-mesh3d
if(!opacityscale)return 1;if(!opacityscale.length)return 1;for(var i=0;i<opacityscale.length;++i){if(opacityscale.length<2)return 1;if(opacityscale[i][0]===ratio)return opacityscale[i][1];if(opacityscale[i][0]>ratio&&i>0){var d=(opacityscale[i][0]-ratio)/(opacityscale[i][0]-opacityscale[i-1][0]);return opacityscale[i][1]*(1-d)+d*opacityscale[i-1][1];}}return 1;}var ZERO_VEC=[0,0,0];var PROJECT_DATA={showSurface:false,showContour:false,projections:[IDENTITY.slice(),IDENTITY.slice(),IDENTITY.slice()],clipBounds:[[[0,0,0],[0,0,0]],[[0,0,0],[0,0,0]],[[0,0,0],[0,0,0]]]};function computeProjectionData(camera,obj){var i,j,k;// Compute cube properties
var cubeAxis=obj.axes&&obj.axes.lastCubeProps.axis||ZERO_VEC;var showSurface=obj.showSurface;var showContour=obj.showContour;for(i=0;i<3;++i){showSurface=showSurface||obj.surfaceProject[i];for(j=0;j<3;++j){showContour=showContour||obj.contourProject[i][j];}}for(i=0;i<3;++i){// Construct projection onto axis
var axisSquish=PROJECT_DATA.projections[i];for(j=0;j<16;++j){axisSquish[j]=0;}for(j=0;j<4;++j){axisSquish[5*j]=1;}axisSquish[5*i]=0;axisSquish[12+i]=obj.axesBounds[+(cubeAxis[i]>0)][i];multiply(axisSquish,camera.model,axisSquish);var nclipBounds=PROJECT_DATA.clipBounds[i];for(k=0;k<2;++k){for(j=0;j<3;++j){nclipBounds[k][j]=camera.clipBounds[k][j];}}nclipBounds[0][i]=-1e8;nclipBounds[1][i]=1e8;}PROJECT_DATA.showSurface=showSurface;PROJECT_DATA.showContour=showContour;return PROJECT_DATA;}var UNIFORMS={model:IDENTITY,view:IDENTITY,projection:IDENTITY,inverseModel:IDENTITY.slice(),lowerBound:[0,0,0],upperBound:[0,0,0],colorMap:0,clipBounds:[[0,0,0],[0,0,0]],height:0.0,contourTint:0,contourColor:[0,0,0,1],permutation:[1,0,0,0,1,0,0,0,1],zOffset:-1e-4,objectOffset:[0,0,0],kambient:1,kdiffuse:1,kspecular:1,lightPosition:[1000,1000,1000],eyePosition:[0,0,0],roughness:1,fresnel:1,opacity:1,vertexColor:0};var MATRIX_INVERSE=IDENTITY.slice();var DEFAULT_PERM=[1,0,0,0,1,0,0,0,1];function drawCore(params,transparent){params=params||{};var gl=this.gl;gl.disable(gl.CULL_FACE);this._colorMap.bind(0);var uniforms=UNIFORMS;uniforms.model=params.model||IDENTITY;uniforms.view=params.view||IDENTITY;uniforms.projection=params.projection||IDENTITY;uniforms.lowerBound=[this.bounds[0][0],this.bounds[0][1],this.colorBounds[0]||this.bounds[0][2]];uniforms.upperBound=[this.bounds[1][0],this.bounds[1][1],this.colorBounds[1]||this.bounds[1][2]];uniforms.objectOffset=this.objectOffset;uniforms.contourColor=this.contourColor[0];uniforms.inverseModel=invert(uniforms.inverseModel,uniforms.model);for(var i=0;i<2;++i){var clipClamped=uniforms.clipBounds[i];for(var j=0;j<3;++j){clipClamped[j]=Math.min(Math.max(this.clipBounds[i][j],-1e8),1e8);}}uniforms.kambient=this.ambientLight;uniforms.kdiffuse=this.diffuseLight;uniforms.kspecular=this.specularLight;uniforms.roughness=this.roughness;uniforms.fresnel=this.fresnel;uniforms.opacity=this.opacity;uniforms.height=0.0;uniforms.permutation=DEFAULT_PERM;uniforms.vertexColor=this.vertexColor;// Compute camera matrix inverse
var invCameraMatrix=MATRIX_INVERSE;multiply(invCameraMatrix,uniforms.view,uniforms.model);multiply(invCameraMatrix,uniforms.projection,invCameraMatrix);invert(invCameraMatrix,invCameraMatrix);for(i=0;i<3;++i){uniforms.eyePosition[i]=invCameraMatrix[12+i]/invCameraMatrix[15];}var w=invCameraMatrix[15];for(i=0;i<3;++i){w+=this.lightPosition[i]*invCameraMatrix[4*i+3];}for(i=0;i<3;++i){var s=invCameraMatrix[12+i];for(j=0;j<3;++j){s+=invCameraMatrix[4*j+i]*this.lightPosition[j];}uniforms.lightPosition[i]=s/w;}var projectData=computeProjectionData(uniforms,this);if(projectData.showSurface){// Set up uniforms
this._shader.bind();this._shader.uniforms=uniforms;// Draw it
this._vao.bind();if(this.showSurface&&this._vertexCount){this._vao.draw(gl.TRIANGLES,this._vertexCount);}// Draw projections of surface
for(i=0;i<3;++i){if(!this.surfaceProject[i]||!this.vertexCount){continue;}this._shader.uniforms.model=projectData.projections[i];this._shader.uniforms.clipBounds=projectData.clipBounds[i];this._vao.draw(gl.TRIANGLES,this._vertexCount);}this._vao.unbind();}if(projectData.showContour){var shader=this._contourShader;// Don't apply lighting to contours
uniforms.kambient=1.0;uniforms.kdiffuse=0.0;uniforms.kspecular=0.0;uniforms.opacity=1.0;shader.bind();shader.uniforms=uniforms;// Draw contour lines
var vao=this._contourVAO;vao.bind();// Draw contour levels
for(i=0;i<3;++i){shader.uniforms.permutation=PERMUTATIONS[i];gl.lineWidth(this.contourWidth[i]*this.pixelRatio);for(j=0;j<this.contourLevels[i].length;++j){if(j===this.highlightLevel[i]){shader.uniforms.contourColor=this.highlightColor[i];shader.uniforms.contourTint=this.highlightTint[i];}else if(j===0||j-1===this.highlightLevel[i]){shader.uniforms.contourColor=this.contourColor[i];shader.uniforms.contourTint=this.contourTint[i];}if(!this._contourCounts[i][j]){continue;}shader.uniforms.height=this.contourLevels[i][j];vao.draw(gl.LINES,this._contourCounts[i][j],this._contourOffsets[i][j]);}}// Draw projections of surface
for(i=0;i<3;++i){shader.uniforms.model=projectData.projections[i];shader.uniforms.clipBounds=projectData.clipBounds[i];for(j=0;j<3;++j){if(!this.contourProject[i][j]){continue;}shader.uniforms.permutation=PERMUTATIONS[j];gl.lineWidth(this.contourWidth[j]*this.pixelRatio);for(var k=0;k<this.contourLevels[j].length;++k){if(k===this.highlightLevel[j]){shader.uniforms.contourColor=this.highlightColor[j];shader.uniforms.contourTint=this.highlightTint[j];}else if(k===0||k-1===this.highlightLevel[j]){shader.uniforms.contourColor=this.contourColor[j];shader.uniforms.contourTint=this.contourTint[j];}if(!this._contourCounts[j][k]){continue;}shader.uniforms.height=this.contourLevels[j][k];vao.draw(gl.LINES,this._contourCounts[j][k],this._contourOffsets[j][k]);}}}vao.unbind();// Draw dynamic contours
vao=this._dynamicVAO;vao.bind();// Draw contour levels
for(i=0;i<3;++i){if(this._dynamicCounts[i]===0){continue;}shader.uniforms.model=uniforms.model;shader.uniforms.clipBounds=uniforms.clipBounds;shader.uniforms.permutation=PERMUTATIONS[i];gl.lineWidth(this.dynamicWidth[i]*this.pixelRatio);shader.uniforms.contourColor=this.dynamicColor[i];shader.uniforms.contourTint=this.dynamicTint[i];shader.uniforms.height=this.dynamicLevel[i];vao.draw(gl.LINES,this._dynamicCounts[i],this._dynamicOffsets[i]);for(j=0;j<3;++j){if(!this.contourProject[j][i]){continue;}shader.uniforms.model=projectData.projections[j];shader.uniforms.clipBounds=projectData.clipBounds[j];vao.draw(gl.LINES,this._dynamicCounts[i],this._dynamicOffsets[i]);}}vao.unbind();}}proto.draw=function(params){return drawCore.call(this,params,false);};proto.drawTransparent=function(params){return drawCore.call(this,params,true);};var PICK_UNIFORMS={model:IDENTITY,view:IDENTITY,projection:IDENTITY,inverseModel:IDENTITY,clipBounds:[[0,0,0],[0,0,0]],height:0.0,shape:[0,0],pickId:0,lowerBound:[0,0,0],upperBound:[0,0,0],zOffset:0.0,objectOffset:[0,0,0],permutation:[1,0,0,0,1,0,0,0,1],lightPosition:[0,0,0],eyePosition:[0,0,0]};proto.drawPick=function(params){params=params||{};var gl=this.gl;gl.disable(gl.CULL_FACE);var uniforms=PICK_UNIFORMS;uniforms.model=params.model||IDENTITY;uniforms.view=params.view||IDENTITY;uniforms.projection=params.projection||IDENTITY;uniforms.shape=this._field[2].shape;uniforms.pickId=this.pickId/255.0;uniforms.lowerBound=this.bounds[0];uniforms.upperBound=this.bounds[1];uniforms.objectOffset=this.objectOffset;uniforms.permutation=DEFAULT_PERM;for(var i=0;i<2;++i){var clipClamped=uniforms.clipBounds[i];for(var j=0;j<3;++j){clipClamped[j]=Math.min(Math.max(this.clipBounds[i][j],-1e8),1e8);}}var projectData=computeProjectionData(uniforms,this);if(projectData.showSurface){// Set up uniforms
this._pickShader.bind();this._pickShader.uniforms=uniforms;// Draw it
this._vao.bind();this._vao.draw(gl.TRIANGLES,this._vertexCount);// Draw projections of surface
for(i=0;i<3;++i){if(!this.surfaceProject[i]){continue;}this._pickShader.uniforms.model=projectData.projections[i];this._pickShader.uniforms.clipBounds=projectData.clipBounds[i];this._vao.draw(gl.TRIANGLES,this._vertexCount);}this._vao.unbind();}if(projectData.showContour){var shader=this._contourPickShader;shader.bind();shader.uniforms=uniforms;var vao=this._contourVAO;vao.bind();for(j=0;j<3;++j){gl.lineWidth(this.contourWidth[j]*this.pixelRatio);shader.uniforms.permutation=PERMUTATIONS[j];for(i=0;i<this.contourLevels[j].length;++i){if(this._contourCounts[j][i]){shader.uniforms.height=this.contourLevels[j][i];vao.draw(gl.LINES,this._contourCounts[j][i],this._contourOffsets[j][i]);}}}// Draw projections of surface
for(i=0;i<3;++i){shader.uniforms.model=projectData.projections[i];shader.uniforms.clipBounds=projectData.clipBounds[i];for(j=0;j<3;++j){if(!this.contourProject[i][j]){continue;}shader.uniforms.permutation=PERMUTATIONS[j];gl.lineWidth(this.contourWidth[j]*this.pixelRatio);for(var k=0;k<this.contourLevels[j].length;++k){if(this._contourCounts[j][k]){shader.uniforms.height=this.contourLevels[j][k];vao.draw(gl.LINES,this._contourCounts[j][k],this._contourOffsets[j][k]);}}}}vao.unbind();}};proto.pick=function(selection){if(!selection){return null;}if(selection.id!==this.pickId){return null;}var shape=this._field[2].shape;var result=this._pickResult;// Compute uv coordinate
var x=shape[0]*(selection.value[0]+(selection.value[2]>>4)/16.0)/255.0;var ix=Math.floor(x);var fx=x-ix;var y=shape[1]*(selection.value[1]+(selection.value[2]&15)/16.0)/255.0;var iy=Math.floor(y);var fy=y-iy;ix+=1;iy+=1;// Compute xyz coordinate
var pos=result.position;pos[0]=pos[1]=pos[2]=0;for(var dx=0;dx<2;++dx){var s=dx?fx:1.0-fx;for(var dy=0;dy<2;++dy){var t=dy?fy:1.0-fy;var r=ix+dx;var c=iy+dy;var w=s*t;for(var i=0;i<3;++i){pos[i]+=this._field[i].get(r,c)*w;}}}// Find closest level
var levelIndex=this._pickResult.level;for(var j=0;j<3;++j){levelIndex[j]=bsearch.le(this.contourLevels[j],pos[j]);if(levelIndex[j]<0){if(this.contourLevels[j].length>0){levelIndex[j]=0;}}else if(levelIndex[j]<this.contourLevels[j].length-1){var a=this.contourLevels[j][levelIndex[j]];var b=this.contourLevels[j][levelIndex[j]+1];if(Math.abs(a-pos[j])>Math.abs(b-pos[j])){levelIndex[j]+=1;}}}result.index[0]=fx<0.5?ix:ix+1;result.index[1]=fy<0.5?iy:iy+1;result.uv[0]=x/shape[0];result.uv[1]=y/shape[1];for(i=0;i<3;++i){result.dataCoordinate[i]=this._field[i].get(result.index[0],result.index[1]);}return result;};proto.padField=function(dstField,srcField){var srcShape=srcField.shape.slice();var dstShape=dstField.shape.slice();// Center
ops.assign(dstField.lo(1,1).hi(srcShape[0],srcShape[1]),srcField);// Edges
ops.assign(dstField.lo(1).hi(srcShape[0],1),srcField.hi(srcShape[0],1));ops.assign(dstField.lo(1,dstShape[1]-1).hi(srcShape[0],1),srcField.lo(0,srcShape[1]-1).hi(srcShape[0],1));ops.assign(dstField.lo(0,1).hi(1,srcShape[1]),srcField.hi(1));ops.assign(dstField.lo(dstShape[0]-1,1).hi(1,srcShape[1]),srcField.lo(srcShape[0]-1));// Corners
dstField.set(0,0,srcField.get(0,0));dstField.set(0,dstShape[1]-1,srcField.get(0,srcShape[1]-1));dstField.set(dstShape[0]-1,0,srcField.get(srcShape[0]-1,0));dstField.set(dstShape[0]-1,dstShape[1]-1,srcField.get(srcShape[0]-1,srcShape[1]-1));};function handleArray(param,ctor){if(Array.isArray(param)){return[ctor(param[0]),ctor(param[1]),ctor(param[2])];}return[ctor(param),ctor(param),ctor(param)];}function toColor(x){if(Array.isArray(x)){if(x.length===3){return[x[0],x[1],x[2],1];}return[x[0],x[1],x[2],x[3]];}return[0,0,0,1];}function handleColor(param){if(Array.isArray(param)){if(Array.isArray(param)){return[toColor(param[0]),toColor(param[1]),toColor(param[2])];}else{var c=toColor(param);return[c.slice(),c.slice(),c.slice()];}}}proto.update=function(params){params=params||{};this.objectOffset=params.objectOffset||this.objectOffset;this.dirty=true;if('contourWidth'in params){this.contourWidth=handleArray(params.contourWidth,Number);}if('showContour'in params){this.showContour=handleArray(params.showContour,Boolean);}if('showSurface'in params){this.showSurface=!!params.showSurface;}if('contourTint'in params){this.contourTint=handleArray(params.contourTint,Boolean);}if('contourColor'in params){this.contourColor=handleColor(params.contourColor);}if('contourProject'in params){this.contourProject=handleArray(params.contourProject,function(x){return handleArray(x,Boolean);});}if('surfaceProject'in params){this.surfaceProject=params.surfaceProject;}if('dynamicColor'in params){this.dynamicColor=handleColor(params.dynamicColor);}if('dynamicTint'in params){this.dynamicTint=handleArray(params.dynamicTint,Number);}if('dynamicWidth'in params){this.dynamicWidth=handleArray(params.dynamicWidth,Number);}if('opacity'in params){this.opacity=params.opacity;}if('opacityscale'in params){this.opacityscale=params.opacityscale;}if('colorBounds'in params){this.colorBounds=params.colorBounds;}if('vertexColor'in params){this.vertexColor=params.vertexColor?1:0;}if('colormap'in params){this._colorMap.setPixels(this.genColormap(params.colormap,this.opacityscale));}var field=params.field||params.coords&&params.coords[2]||null;var levelsChanged=false;if(!field){if(this._field[2].shape[0]||this._field[2].shape[2]){field=this._field[2].lo(1,1).hi(this._field[2].shape[0]-2,this._field[2].shape[1]-2);}else{field=this._field[2].hi(0,0);}}// Update field
if('field'in params||'coords'in params){var fsize=(field.shape[0]+2)*(field.shape[1]+2);// Resize if necessary
if(fsize>this._field[2].data.length){pool.freeFloat(this._field[2].data);this._field[2].data=pool.mallocFloat(bits.nextPow2(fsize));}// Pad field
this._field[2]=ndarray(this._field[2].data,[field.shape[0]+2,field.shape[1]+2]);this.padField(this._field[2],field);// Save shape of field
this.shape=field.shape.slice();var shape=this.shape;// Resize coordinate fields if necessary
for(var i=0;i<2;++i){if(this._field[2].size>this._field[i].data.length){pool.freeFloat(this._field[i].data);this._field[i].data=pool.mallocFloat(this._field[2].size);}this._field[i]=ndarray(this._field[i].data,[shape[0]+2,shape[1]+2]);}// Generate x/y coordinates
if(params.coords){var coords=params.coords;if(!Array.isArray(coords)||coords.length!==3){throw new Error('gl-surface: invalid coordinates for x/y');}for(i=0;i<2;++i){var coord=coords[i];for(j=0;j<2;++j){if(coord.shape[j]!==shape[j]){throw new Error('gl-surface: coords have incorrect shape');}}this.padField(this._field[i],coord);}}else if(params.ticks){var ticks=params.ticks;if(!Array.isArray(ticks)||ticks.length!==2){throw new Error('gl-surface: invalid ticks');}for(i=0;i<2;++i){var tick=ticks[i];if(Array.isArray(tick)||tick.length){tick=ndarray(tick);}if(tick.shape[0]!==shape[i]){throw new Error('gl-surface: invalid tick length');}// Make a copy view of the tick array
var tick2=ndarray(tick.data,shape);tick2.stride[i]=tick.stride[0];tick2.stride[i^1]=0;// Fill in field array
this.padField(this._field[i],tick2);}}else{for(i=0;i<2;++i){var offset=[0,0];offset[i]=1;this._field[i]=ndarray(this._field[i].data,[shape[0]+2,shape[1]+2],offset,0);}this._field[0].set(0,0,0);for(var j=0;j<shape[0];++j){this._field[0].set(j+1,0,j);}this._field[0].set(shape[0]+1,0,shape[0]-1);this._field[1].set(0,0,0);for(j=0;j<shape[1];++j){this._field[1].set(0,j+1,j);}this._field[1].set(0,shape[1]+1,shape[1]-1);}// Save shape
var fields=this._field;// Compute surface normals
var dfields=ndarray(pool.mallocFloat(fields[2].size*3*2),[3,shape[0]+2,shape[1]+2,2]);for(i=0;i<3;++i){gradient(dfields.pick(i),fields[i],'mirror');}var normals=ndarray(pool.mallocFloat(fields[2].size*3),[shape[0]+2,shape[1]+2,3]);for(i=0;i<shape[0]+2;++i){for(j=0;j<shape[1]+2;++j){var dxdu=dfields.get(0,i,j,0);var dxdv=dfields.get(0,i,j,1);var dydu=dfields.get(1,i,j,0);var dydv=dfields.get(1,i,j,1);var dzdu=dfields.get(2,i,j,0);var dzdv=dfields.get(2,i,j,1);var nx=dydu*dzdv-dydv*dzdu;var ny=dzdu*dxdv-dzdv*dxdu;var nz=dxdu*dydv-dxdv*dydu;var nl=Math.sqrt(nx*nx+ny*ny+nz*nz);if(nl<1e-8){nl=Math.max(Math.abs(nx),Math.abs(ny),Math.abs(nz));if(nl<1e-8){nz=1.0;ny=nx=0.0;nl=1.0;}else{nl=1.0/nl;}}else{nl=1.0/Math.sqrt(nl);}normals.set(i,j,0,nx*nl);normals.set(i,j,1,ny*nl);normals.set(i,j,2,nz*nl);}}pool.free(dfields.data);// Initialize surface
var lo=[Infinity,Infinity,Infinity];var hi=[-Infinity,-Infinity,-Infinity];var lo_intensity=Infinity;var hi_intensity=-Infinity;var count=(shape[0]-1)*(shape[1]-1)*6;var tverts=pool.mallocFloat(bits.nextPow2(10*count));var tptr=0;var vertexCount=0;for(i=0;i<shape[0]-1;++i){j_loop:for(j=0;j<shape[1]-1;++j){// Test for NaNs
for(var dx=0;dx<2;++dx){for(var dy=0;dy<2;++dy){for(var k=0;k<3;++k){var f=this._field[k].get(1+i+dx,1+j+dy);if(isNaN(f)||!isFinite(f)){continue j_loop;}}}}for(k=0;k<6;++k){var r=i+QUAD[k][0];var c=j+QUAD[k][1];var tx=this._field[0].get(r+1,c+1);var ty=this._field[1].get(r+1,c+1);f=this._field[2].get(r+1,c+1);nx=normals.get(r+1,c+1,0);ny=normals.get(r+1,c+1,1);nz=normals.get(r+1,c+1,2);if(params.intensity){vf=params.intensity.get(r,c);}var vf=params.intensity?params.intensity.get(r,c):f+this.objectOffset[2];tverts[tptr++]=r;tverts[tptr++]=c;tverts[tptr++]=tx;tverts[tptr++]=ty;tverts[tptr++]=f;tverts[tptr++]=0;tverts[tptr++]=vf;tverts[tptr++]=nx;tverts[tptr++]=ny;tverts[tptr++]=nz;lo[0]=Math.min(lo[0],tx+this.objectOffset[0]);lo[1]=Math.min(lo[1],ty+this.objectOffset[1]);lo[2]=Math.min(lo[2],f+this.objectOffset[2]);lo_intensity=Math.min(lo_intensity,vf);hi[0]=Math.max(hi[0],tx+this.objectOffset[0]);hi[1]=Math.max(hi[1],ty+this.objectOffset[1]);hi[2]=Math.max(hi[2],f+this.objectOffset[2]);hi_intensity=Math.max(hi_intensity,vf);vertexCount+=1;}}}if(params.intensityBounds){lo_intensity=+params.intensityBounds[0];hi_intensity=+params.intensityBounds[1];}// Scale all vertex intensities
for(i=6;i<tptr;i+=10){tverts[i]=(tverts[i]-lo_intensity)/(hi_intensity-lo_intensity);}this._vertexCount=vertexCount;this._coordinateBuffer.update(tverts.subarray(0,tptr));pool.freeFloat(tverts);pool.free(normals.data);// Update bounds
this.bounds=[lo,hi];// Save intensity
this.intensity=params.intensity||this._field[2];if(this.intensityBounds[0]!==lo_intensity||this.intensityBounds[1]!==hi_intensity){levelsChanged=true;}// Save intensity bound
this.intensityBounds=[lo_intensity,hi_intensity];}// Update level crossings
if('levels'in params){var levels=params.levels;if(!Array.isArray(levels[0])){levels=[[],[],levels];}else{levels=levels.slice();}for(i=0;i<3;++i){levels[i]=levels[i].slice();levels[i].sort(function(a,b){return a-b;});}for(i=0;i<3;++i){for(j=0;j<levels[i].length;++j){levels[i][j]-=this.objectOffset[i];}}change_test:for(i=0;i<3;++i){if(levels[i].length!==this.contourLevels[i].length){levelsChanged=true;break;}for(j=0;j<levels[i].length;++j){if(levels[i][j]!==this.contourLevels[i][j]){levelsChanged=true;break change_test;}}}this.contourLevels=levels;}if(levelsChanged){fields=this._field;shape=this.shape;// Update contour lines
var contourVerts=[];for(var dim=0;dim<3;++dim){var contourLevel=this.contourLevels[dim];var levelOffsets=[];var levelCounts=[];var parts=[0,0,0];for(i=0;i<contourLevel.length;++i){var graph=surfaceNets(this._field[dim],contourLevel[i]);levelOffsets.push(contourVerts.length/5|0);vertexCount=0;edge_loop:for(j=0;j<graph.cells.length;++j){var e=graph.cells[j];for(k=0;k<2;++k){var p=graph.positions[e[k]];var x=p[0];var ix=Math.floor(x)|0;var fx=x-ix;var y=p[1];var iy=Math.floor(y)|0;var fy=y-iy;var hole=false;axis_loop:for(var axis=0;axis<3;++axis){parts[axis]=0.0;var iu=(dim+axis+1)%3;for(dx=0;dx<2;++dx){var s=dx?fx:1.0-fx;r=Math.min(Math.max(ix+dx,0),shape[0])|0;for(dy=0;dy<2;++dy){var t=dy?fy:1.0-fy;c=Math.min(Math.max(iy+dy,0),shape[1])|0;if(axis<2){f=this._field[iu].get(r,c);}else{f=(this.intensity.get(r,c)-this.intensityBounds[0])/(this.intensityBounds[1]-this.intensityBounds[0]);}if(!isFinite(f)||isNaN(f)){hole=true;break axis_loop;}var w=s*t;parts[axis]+=w*f;}}}if(!hole){contourVerts.push(parts[0],parts[1],p[0],p[1],parts[2]);vertexCount+=1;}else{if(k>0){// If we already added first edge, pop off verts
for(var l=0;l<5;++l){contourVerts.pop();}vertexCount-=1;}continue edge_loop;}}}levelCounts.push(vertexCount);}// Store results
this._contourOffsets[dim]=levelOffsets;this._contourCounts[dim]=levelCounts;}var floatBuffer=pool.mallocFloat(contourVerts.length);for(i=0;i<contourVerts.length;++i){floatBuffer[i]=contourVerts[i];}this._contourBuffer.update(floatBuffer);pool.freeFloat(floatBuffer);}};proto.dispose=function(){this._shader.dispose();this._vao.dispose();this._coordinateBuffer.dispose();this._colorMap.dispose();this._contourBuffer.dispose();this._contourVAO.dispose();this._contourShader.dispose();this._contourPickShader.dispose();this._dynamicBuffer.dispose();this._dynamicVAO.dispose();for(var i=0;i<3;++i){pool.freeFloat(this._field[i].data);}};proto.highlight=function(selection){var i;if(!selection){this._dynamicCounts=[0,0,0];this.dyanamicLevel=[NaN,NaN,NaN];this.highlightLevel=[-1,-1,-1];return;}for(i=0;i<3;++i){if(this.enableHighlight[i]){this.highlightLevel[i]=selection.level[i];}else{this.highlightLevel[i]=-1;}}var levels;if(this.snapToData){levels=selection.dataCoordinate;}else{levels=selection.position;}for(i=0;i<3;++i){levels[i]-=this.objectOffset[i];}if((!this.enableDynamic[0]||levels[0]===this.dynamicLevel[0])&&(!this.enableDynamic[1]||levels[1]===this.dynamicLevel[1])&&(!this.enableDynamic[2]||levels[2]===this.dynamicLevel[2])){return;}var vertexCount=0;var shape=this.shape;var scratchBuffer=pool.mallocFloat(12*shape[0]*shape[1]);for(var d=0;d<3;++d){if(!this.enableDynamic[d]){this.dynamicLevel[d]=NaN;this._dynamicCounts[d]=0;continue;}this.dynamicLevel[d]=levels[d];var u=(d+1)%3;var v=(d+2)%3;var f=this._field[d];var g=this._field[u];var h=this._field[v];var graph=surfaceNets(f,levels[d]);var edges=graph.cells;var positions=graph.positions;this._dynamicOffsets[d]=vertexCount;for(i=0;i<edges.length;++i){var e=edges[i];for(var j=0;j<2;++j){var p=positions[e[j]];var x=+p[0];var ix=x|0;var jx=Math.min(ix+1,shape[0])|0;var fx=x-ix;var hx=1.0-fx;var y=+p[1];var iy=y|0;var jy=Math.min(iy+1,shape[1])|0;var fy=y-iy;var hy=1.0-fy;var w00=hx*hy;var w01=hx*fy;var w10=fx*hy;var w11=fx*fy;var cu=w00*g.get(ix,iy)+w01*g.get(ix,jy)+w10*g.get(jx,iy)+w11*g.get(jx,jy);var cv=w00*h.get(ix,iy)+w01*h.get(ix,jy)+w10*h.get(jx,iy)+w11*h.get(jx,jy);if(isNaN(cu)||isNaN(cv)){if(j){vertexCount-=1;}break;}scratchBuffer[2*vertexCount+0]=cu;scratchBuffer[2*vertexCount+1]=cv;vertexCount+=1;}}this._dynamicCounts[d]=vertexCount-this._dynamicOffsets[d];}this._dynamicBuffer.update(scratchBuffer.subarray(0,2*vertexCount));pool.freeFloat(scratchBuffer);};function createSurfacePlot(params){var gl=params.gl;var shader=createShader(gl);var pickShader=createPickShader(gl);var contourShader=createContourShader(gl);var contourPickShader=createPickContourShader(gl);var coordinateBuffer=createBuffer(gl);var vao=createVAO(gl,[{buffer:coordinateBuffer,size:4,stride:SURFACE_VERTEX_SIZE,offset:0},{buffer:coordinateBuffer,size:3,stride:SURFACE_VERTEX_SIZE,offset:16},{buffer:coordinateBuffer,size:3,stride:SURFACE_VERTEX_SIZE,offset:28}]);var contourBuffer=createBuffer(gl);var contourVAO=createVAO(gl,[{buffer:contourBuffer,size:4,stride:20,offset:0},{buffer:contourBuffer,size:1,stride:20,offset:16}]);var dynamicBuffer=createBuffer(gl);var dynamicVAO=createVAO(gl,[{buffer:dynamicBuffer,size:2,type:gl.FLOAT}]);var cmap=createTexture(gl,1,N_COLORS,gl.RGBA,gl.UNSIGNED_BYTE);cmap.minFilter=gl.LINEAR;cmap.magFilter=gl.LINEAR;var surface=new SurfacePlot(gl,[0,0],// shape
[[0,0,0],[0,0,0]],// bounds
shader,pickShader,coordinateBuffer,vao,cmap,contourShader,contourPickShader,contourBuffer,contourVAO,dynamicBuffer,dynamicVAO,[0,0,0]// objectOffset
);var nparams={levels:[[],[],[]]};for(var id in params){nparams[id]=params[id];}nparams.colormap=nparams.colormap||'jet';surface.update(nparams);return surface;}/***/}),/***/7766:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_573640__){"use strict";var ndarray=__nested_webpack_require_573640__(9618);var ops=__nested_webpack_require_573640__(5298);var pool=__nested_webpack_require_573640__(1888);module.exports=createTexture2D;var linearTypes=null;var filterTypes=null;var wrapTypes=null;function lazyInitLinearTypes(gl){linearTypes=[gl.LINEAR,gl.NEAREST_MIPMAP_LINEAR,gl.LINEAR_MIPMAP_NEAREST,gl.LINEAR_MIPMAP_NEAREST];filterTypes=[gl.NEAREST,gl.LINEAR,gl.NEAREST_MIPMAP_NEAREST,gl.NEAREST_MIPMAP_LINEAR,gl.LINEAR_MIPMAP_NEAREST,gl.LINEAR_MIPMAP_LINEAR];wrapTypes=[gl.REPEAT,gl.CLAMP_TO_EDGE,gl.MIRRORED_REPEAT];}function acceptTextureDOM(obj){return'undefined'!=typeof HTMLCanvasElement&&obj instanceof HTMLCanvasElement||'undefined'!=typeof HTMLImageElement&&obj instanceof HTMLImageElement||'undefined'!=typeof HTMLVideoElement&&obj instanceof HTMLVideoElement||'undefined'!=typeof ImageData&&obj instanceof ImageData;}var convertFloatToUint8=function(out,inp){ops.muls(out,inp,255.0);};function reshapeTexture(tex,w,h){var gl=tex.gl;var maxSize=gl.getParameter(gl.MAX_TEXTURE_SIZE);if(w<0||w>maxSize||h<0||h>maxSize){throw new Error('gl-texture2d: Invalid texture size');}tex._shape=[w,h];tex.bind();gl.texImage2D(gl.TEXTURE_2D,0,tex.format,w,h,0,tex.format,tex.type,null);tex._mipLevels=[0];return tex;}function Texture2D(gl,handle,width,height,format,type){this.gl=gl;this.handle=handle;this.format=format;this.type=type;this._shape=[width,height];this._mipLevels=[0];this._magFilter=gl.NEAREST;this._minFilter=gl.NEAREST;this._wrapS=gl.CLAMP_TO_EDGE;this._wrapT=gl.CLAMP_TO_EDGE;this._anisoSamples=1;var parent=this;var wrapVector=[this._wrapS,this._wrapT];Object.defineProperties(wrapVector,[{get:function(){return parent._wrapS;},set:function(v){return parent.wrapS=v;}},{get:function(){return parent._wrapT;},set:function(v){return parent.wrapT=v;}}]);this._wrapVector=wrapVector;var shapeVector=[this._shape[0],this._shape[1]];Object.defineProperties(shapeVector,[{get:function(){return parent._shape[0];},set:function(v){return parent.width=v;}},{get:function(){return parent._shape[1];},set:function(v){return parent.height=v;}}]);this._shapeVector=shapeVector;}var proto=Texture2D.prototype;Object.defineProperties(proto,{minFilter:{get:function(){return this._minFilter;},set:function(v){this.bind();var gl=this.gl;if(this.type===gl.FLOAT&&linearTypes.indexOf(v)>=0){if(!gl.getExtension('OES_texture_float_linear')){v=gl.NEAREST;}}if(filterTypes.indexOf(v)<0){throw new Error('gl-texture2d: Unknown filter mode '+v);}gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MIN_FILTER,v);return this._minFilter=v;}},magFilter:{get:function(){return this._magFilter;},set:function(v){this.bind();var gl=this.gl;if(this.type===gl.FLOAT&&linearTypes.indexOf(v)>=0){if(!gl.getExtension('OES_texture_float_linear')){v=gl.NEAREST;}}if(filterTypes.indexOf(v)<0){throw new Error('gl-texture2d: Unknown filter mode '+v);}gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MAG_FILTER,v);return this._magFilter=v;}},mipSamples:{get:function(){return this._anisoSamples;},set:function(i){var psamples=this._anisoSamples;this._anisoSamples=Math.max(i,1)|0;if(psamples!==this._anisoSamples){var ext=this.gl.getExtension('EXT_texture_filter_anisotropic');if(ext){this.gl.texParameterf(this.gl.TEXTURE_2D,ext.TEXTURE_MAX_ANISOTROPY_EXT,this._anisoSamples);}}return this._anisoSamples;}},wrapS:{get:function(){return this._wrapS;},set:function(v){this.bind();if(wrapTypes.indexOf(v)<0){throw new Error('gl-texture2d: Unknown wrap mode '+v);}this.gl.texParameteri(this.gl.TEXTURE_2D,this.gl.TEXTURE_WRAP_S,v);return this._wrapS=v;}},wrapT:{get:function(){return this._wrapT;},set:function(v){this.bind();if(wrapTypes.indexOf(v)<0){throw new Error('gl-texture2d: Unknown wrap mode '+v);}this.gl.texParameteri(this.gl.TEXTURE_2D,this.gl.TEXTURE_WRAP_T,v);return this._wrapT=v;}},wrap:{get:function(){return this._wrapVector;},set:function(v){if(!Array.isArray(v)){v=[v,v];}if(v.length!==2){throw new Error('gl-texture2d: Must specify wrap mode for rows and columns');}for(var i=0;i<2;++i){if(wrapTypes.indexOf(v[i])<0){throw new Error('gl-texture2d: Unknown wrap mode '+v);}}this._wrapS=v[0];this._wrapT=v[1];var gl=this.gl;this.bind();gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_S,this._wrapS);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_T,this._wrapT);return v;}},shape:{get:function(){return this._shapeVector;},set:function(x){if(!Array.isArray(x)){x=[x|0,x|0];}else{if(x.length!==2){throw new Error('gl-texture2d: Invalid texture shape');}}reshapeTexture(this,x[0]|0,x[1]|0);return[x[0]|0,x[1]|0];}},width:{get:function(){return this._shape[0];},set:function(w){w=w|0;reshapeTexture(this,w,this._shape[1]);return w;}},height:{get:function(){return this._shape[1];},set:function(h){h=h|0;reshapeTexture(this,this._shape[0],h);return h;}}});proto.bind=function(unit){var gl=this.gl;if(unit!==undefined){gl.activeTexture(gl.TEXTURE0+(unit|0));}gl.bindTexture(gl.TEXTURE_2D,this.handle);if(unit!==undefined){return unit|0;}return gl.getParameter(gl.ACTIVE_TEXTURE)-gl.TEXTURE0;};proto.dispose=function(){this.gl.deleteTexture(this.handle);};proto.generateMipmap=function(){this.bind();this.gl.generateMipmap(this.gl.TEXTURE_2D);//Update mip levels
var l=Math.min(this._shape[0],this._shape[1]);for(var i=0;l>0;++i,l>>>=1){if(this._mipLevels.indexOf(i)<0){this._mipLevels.push(i);}}};proto.setPixels=function(data,x_off,y_off,mip_level){var gl=this.gl;this.bind();if(Array.isArray(x_off)){mip_level=y_off;y_off=x_off[1]|0;x_off=x_off[0]|0;}else{x_off=x_off||0;y_off=y_off||0;}mip_level=mip_level||0;var directData=acceptTextureDOM(data)?data:data.raw;if(directData){var needsMip=this._mipLevels.indexOf(mip_level)<0;if(needsMip){gl.texImage2D(gl.TEXTURE_2D,0,this.format,this.format,this.type,directData);this._mipLevels.push(mip_level);}else{gl.texSubImage2D(gl.TEXTURE_2D,mip_level,x_off,y_off,this.format,this.type,directData);}}else if(data.shape&&data.stride&&data.data){if(data.shape.length<2||x_off+data.shape[1]>this._shape[1]>>>mip_level||y_off+data.shape[0]>this._shape[0]>>>mip_level||x_off<0||y_off<0){throw new Error('gl-texture2d: Texture dimensions are out of bounds');}texSubImageArray(gl,x_off,y_off,mip_level,this.format,this.type,this._mipLevels,data);}else{throw new Error('gl-texture2d: Unsupported data type');}};function isPacked(shape,stride){if(shape.length===3){return stride[2]===1&&stride[1]===shape[0]*shape[2]&&stride[0]===shape[2];}return stride[0]===1&&stride[1]===shape[0];}function texSubImageArray(gl,x_off,y_off,mip_level,cformat,ctype,mipLevels,array){var dtype=array.dtype;var shape=array.shape.slice();if(shape.length<2||shape.length>3){throw new Error('gl-texture2d: Invalid ndarray, must be 2d or 3d');}var type=0,format=0;var packed=isPacked(shape,array.stride.slice());if(dtype==='float32'){type=gl.FLOAT;}else if(dtype==='float64'){type=gl.FLOAT;packed=false;dtype='float32';}else if(dtype==='uint8'){type=gl.UNSIGNED_BYTE;}else{type=gl.UNSIGNED_BYTE;packed=false;dtype='uint8';}var channels=1;if(shape.length===2){format=gl.LUMINANCE;shape=[shape[0],shape[1],1];array=ndarray(array.data,shape,[array.stride[0],array.stride[1],1],array.offset);}else if(shape.length===3){if(shape[2]===1){format=gl.ALPHA;}else if(shape[2]===2){format=gl.LUMINANCE_ALPHA;}else if(shape[2]===3){format=gl.RGB;}else if(shape[2]===4){format=gl.RGBA;}else{throw new Error('gl-texture2d: Invalid shape for pixel coords');}channels=shape[2];}else{throw new Error('gl-texture2d: Invalid shape for texture');}//For 1-channel textures allow conversion between formats
if((format===gl.LUMINANCE||format===gl.ALPHA)&&(cformat===gl.LUMINANCE||cformat===gl.ALPHA)){format=cformat;}if(format!==cformat){throw new Error('gl-texture2d: Incompatible texture format for setPixels');}var size=array.size;var needsMip=mipLevels.indexOf(mip_level)<0;if(needsMip){mipLevels.push(mip_level);}if(type===ctype&&packed){//Array data types are compatible, can directly copy into texture
if(array.offset===0&&array.data.length===size){if(needsMip){gl.texImage2D(gl.TEXTURE_2D,mip_level,cformat,shape[0],shape[1],0,cformat,ctype,array.data);}else{gl.texSubImage2D(gl.TEXTURE_2D,mip_level,x_off,y_off,shape[0],shape[1],cformat,ctype,array.data);}}else{if(needsMip){gl.texImage2D(gl.TEXTURE_2D,mip_level,cformat,shape[0],shape[1],0,cformat,ctype,array.data.subarray(array.offset,array.offset+size));}else{gl.texSubImage2D(gl.TEXTURE_2D,mip_level,x_off,y_off,shape[0],shape[1],cformat,ctype,array.data.subarray(array.offset,array.offset+size));}}}else{//Need to do type conversion to pack data into buffer
var pack_buffer;if(ctype===gl.FLOAT){pack_buffer=pool.mallocFloat32(size);}else{pack_buffer=pool.mallocUint8(size);}var pack_view=ndarray(pack_buffer,shape,[shape[2],shape[2]*shape[0],1]);if(type===gl.FLOAT&&ctype===gl.UNSIGNED_BYTE){convertFloatToUint8(pack_view,array);}else{ops.assign(pack_view,array);}if(needsMip){gl.texImage2D(gl.TEXTURE_2D,mip_level,cformat,shape[0],shape[1],0,cformat,ctype,pack_buffer.subarray(0,size));}else{gl.texSubImage2D(gl.TEXTURE_2D,mip_level,x_off,y_off,shape[0],shape[1],cformat,ctype,pack_buffer.subarray(0,size));}if(ctype===gl.FLOAT){pool.freeFloat32(pack_buffer);}else{pool.freeUint8(pack_buffer);}}}function initTexture(gl){var tex=gl.createTexture();gl.bindTexture(gl.TEXTURE_2D,tex);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MIN_FILTER,gl.NEAREST);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MAG_FILTER,gl.NEAREST);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_S,gl.CLAMP_TO_EDGE);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_T,gl.CLAMP_TO_EDGE);return tex;}function createTextureShape(gl,width,height,format,type){var maxTextureSize=gl.getParameter(gl.MAX_TEXTURE_SIZE);if(width<0||width>maxTextureSize||height<0||height>maxTextureSize){throw new Error('gl-texture2d: Invalid texture shape');}if(type===gl.FLOAT&&!gl.getExtension('OES_texture_float')){throw new Error('gl-texture2d: Floating point textures not supported on this platform');}var tex=initTexture(gl);gl.texImage2D(gl.TEXTURE_2D,0,format,width,height,0,format,type,null);return new Texture2D(gl,tex,width,height,format,type);}function createTextureDOM(gl,directData,width,height,format,type){var tex=initTexture(gl);gl.texImage2D(gl.TEXTURE_2D,0,format,format,type,directData);return new Texture2D(gl,tex,width,height,format,type);}//Creates a texture from an ndarray
function createTextureArray(gl,array){var dtype=array.dtype;var shape=array.shape.slice();var maxSize=gl.getParameter(gl.MAX_TEXTURE_SIZE);if(shape[0]<0||shape[0]>maxSize||shape[1]<0||shape[1]>maxSize){throw new Error('gl-texture2d: Invalid texture size');}var packed=isPacked(shape,array.stride.slice());var type=0;if(dtype==='float32'){type=gl.FLOAT;}else if(dtype==='float64'){type=gl.FLOAT;packed=false;dtype='float32';}else if(dtype==='uint8'){type=gl.UNSIGNED_BYTE;}else{type=gl.UNSIGNED_BYTE;packed=false;dtype='uint8';}var format=0;if(shape.length===2){format=gl.LUMINANCE;shape=[shape[0],shape[1],1];array=ndarray(array.data,shape,[array.stride[0],array.stride[1],1],array.offset);}else if(shape.length===3){if(shape[2]===1){format=gl.ALPHA;}else if(shape[2]===2){format=gl.LUMINANCE_ALPHA;}else if(shape[2]===3){format=gl.RGB;}else if(shape[2]===4){format=gl.RGBA;}else{throw new Error('gl-texture2d: Invalid shape for pixel coords');}}else{throw new Error('gl-texture2d: Invalid shape for texture');}if(type===gl.FLOAT&&!gl.getExtension('OES_texture_float')){type=gl.UNSIGNED_BYTE;packed=false;}var buffer,buf_store;var size=array.size;if(!packed){var stride=[shape[2],shape[2]*shape[0],1];buf_store=pool.malloc(size,dtype);var buf_array=ndarray(buf_store,shape,stride,0);if((dtype==='float32'||dtype==='float64')&&type===gl.UNSIGNED_BYTE){convertFloatToUint8(buf_array,array);}else{ops.assign(buf_array,array);}buffer=buf_store.subarray(0,size);}else if(array.offset===0&&array.data.length===size){buffer=array.data;}else{buffer=array.data.subarray(array.offset,array.offset+size);}var tex=initTexture(gl);gl.texImage2D(gl.TEXTURE_2D,0,format,shape[0],shape[1],0,format,type,buffer);if(!packed){pool.free(buf_store);}return new Texture2D(gl,tex,shape[0],shape[1],format,type);}function createTexture2D(gl){if(arguments.length<=1){throw new Error('gl-texture2d: Missing arguments for texture2d constructor');}if(!linearTypes){lazyInitLinearTypes(gl);}if(typeof arguments[1]==='number'){return createTextureShape(gl,arguments[1],arguments[2],arguments[3]||gl.RGBA,arguments[4]||gl.UNSIGNED_BYTE);}if(Array.isArray(arguments[1])){return createTextureShape(gl,arguments[1][0]|0,arguments[1][1]|0,arguments[2]||gl.RGBA,arguments[3]||gl.UNSIGNED_BYTE);}if(typeof arguments[1]==='object'){var obj=arguments[1];var directData=acceptTextureDOM(obj)?obj:obj.raw;if(directData){return createTextureDOM(gl,directData,obj.width|0,obj.height|0,arguments[2]||gl.RGBA,arguments[3]||gl.UNSIGNED_BYTE);}else if(obj.shape&&obj.data&&obj.stride){return createTextureArray(gl,obj);}}throw new Error('gl-texture2d: Invalid arguments for texture2d constructor');}/***/}),/***/1433:(/***/function(module){"use strict";function doBind(gl,elements,attributes){if(elements){elements.bind();}else{gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER,null);}var nattribs=gl.getParameter(gl.MAX_VERTEX_ATTRIBS)|0;if(attributes){if(attributes.length>nattribs){throw new Error("gl-vao: Too many vertex attributes");}for(var i=0;i<attributes.length;++i){var attrib=attributes[i];if(attrib.buffer){var buffer=attrib.buffer;var size=attrib.size||4;var type=attrib.type||gl.FLOAT;var normalized=!!attrib.normalized;var stride=attrib.stride||0;var offset=attrib.offset||0;buffer.bind();gl.enableVertexAttribArray(i);gl.vertexAttribPointer(i,size,type,normalized,stride,offset);}else{if(typeof attrib==="number"){gl.vertexAttrib1f(i,attrib);}else if(attrib.length===1){gl.vertexAttrib1f(i,attrib[0]);}else if(attrib.length===2){gl.vertexAttrib2f(i,attrib[0],attrib[1]);}else if(attrib.length===3){gl.vertexAttrib3f(i,attrib[0],attrib[1],attrib[2]);}else if(attrib.length===4){gl.vertexAttrib4f(i,attrib[0],attrib[1],attrib[2],attrib[3]);}else{throw new Error("gl-vao: Invalid vertex attribute");}gl.disableVertexAttribArray(i);}}for(;i<nattribs;++i){gl.disableVertexAttribArray(i);}}else{gl.bindBuffer(gl.ARRAY_BUFFER,null);for(var i=0;i<nattribs;++i){gl.disableVertexAttribArray(i);}}}module.exports=doBind;/***/}),/***/870:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_587970__){"use strict";var bindAttribs=__nested_webpack_require_587970__(1433);function VAOEmulated(gl){this.gl=gl;this._elements=null;this._attributes=null;this._elementsType=gl.UNSIGNED_SHORT;}VAOEmulated.prototype.bind=function(){bindAttribs(this.gl,this._elements,this._attributes);};VAOEmulated.prototype.update=function(attributes,elements,elementsType){this._elements=elements;this._attributes=attributes;this._elementsType=elementsType||this.gl.UNSIGNED_SHORT;};VAOEmulated.prototype.dispose=function(){};VAOEmulated.prototype.unbind=function(){};VAOEmulated.prototype.draw=function(mode,count,offset){offset=offset||0;var gl=this.gl;if(this._elements){gl.drawElements(mode,count,this._elementsType,offset);}else{gl.drawArrays(mode,offset,count);}};function createVAOEmulated(gl){return new VAOEmulated(gl);}module.exports=createVAOEmulated;/***/}),/***/7518:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_588881__){"use strict";var bindAttribs=__nested_webpack_require_588881__(1433);function VertexAttribute(location,dimension,a,b,c,d){this.location=location;this.dimension=dimension;this.a=a;this.b=b;this.c=c;this.d=d;}VertexAttribute.prototype.bind=function(gl){switch(this.dimension){case 1:gl.vertexAttrib1f(this.location,this.a);break;case 2:gl.vertexAttrib2f(this.location,this.a,this.b);break;case 3:gl.vertexAttrib3f(this.location,this.a,this.b,this.c);break;case 4:gl.vertexAttrib4f(this.location,this.a,this.b,this.c,this.d);break;}};function VAONative(gl,ext,handle){this.gl=gl;this._ext=ext;this.handle=handle;this._attribs=[];this._useElements=false;this._elementsType=gl.UNSIGNED_SHORT;}VAONative.prototype.bind=function(){this._ext.bindVertexArrayOES(this.handle);for(var i=0;i<this._attribs.length;++i){this._attribs[i].bind(this.gl);}};VAONative.prototype.unbind=function(){this._ext.bindVertexArrayOES(null);};VAONative.prototype.dispose=function(){this._ext.deleteVertexArrayOES(this.handle);};VAONative.prototype.update=function(attributes,elements,elementsType){this.bind();bindAttribs(this.gl,elements,attributes);this.unbind();this._attribs.length=0;if(attributes)for(var i=0;i<attributes.length;++i){var a=attributes[i];if(typeof a==="number"){this._attribs.push(new VertexAttribute(i,1,a));}else if(Array.isArray(a)){this._attribs.push(new VertexAttribute(i,a.length,a[0],a[1],a[2],a[3]));}}this._useElements=!!elements;this._elementsType=elementsType||this.gl.UNSIGNED_SHORT;};VAONative.prototype.draw=function(mode,count,offset){offset=offset||0;var gl=this.gl;if(this._useElements){gl.drawElements(mode,count,this._elementsType,offset);}else{gl.drawArrays(mode,offset,count);}};function createVAONative(gl,ext){return new VAONative(gl,ext,ext.createVertexArrayOES());}module.exports=createVAONative;/***/}),/***/8116:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_590767__){"use strict";var createVAONative=__nested_webpack_require_590767__(7518);var createVAOEmulated=__nested_webpack_require_590767__(870);function ExtensionShim(gl){this.bindVertexArrayOES=gl.bindVertexArray.bind(gl);this.createVertexArrayOES=gl.createVertexArray.bind(gl);this.deleteVertexArrayOES=gl.deleteVertexArray.bind(gl);}function createVAO(gl,attributes,elements,elementsType){var ext=gl.createVertexArray?new ExtensionShim(gl):gl.getExtension('OES_vertex_array_object');var vao;if(ext){vao=createVAONative(gl,ext);}else{vao=createVAOEmulated(gl);}vao.update(attributes,elements,elementsType);return vao;}module.exports=createVAO;/***/}),/***/5632:(/***/function(module){module.exports=add;/**
 * Adds two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @returns {vec3} out
 */function add(out,a,b){out[0]=a[0]+b[0];out[1]=a[1]+b[1];out[2]=a[2]+b[2];return out;}/***/}),/***/8192:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_591774__){module.exports=angle;var fromValues=__nested_webpack_require_591774__(2825);var normalize=__nested_webpack_require_591774__(3536);var dot=__nested_webpack_require_591774__(244);/**
 * Get the angle between two 3D vectors
 * @param {vec3} a The first operand
 * @param {vec3} b The second operand
 * @returns {Number} The angle in radians
 */function angle(a,b){var tempA=fromValues(a[0],a[1],a[2]);var tempB=fromValues(b[0],b[1],b[2]);normalize(tempA,tempA);normalize(tempB,tempB);var cosine=dot(tempA,tempB);if(cosine>1.0){return 0;}else{return Math.acos(cosine);}}/***/}),/***/9226:(/***/function(module){module.exports=ceil;/**
 * Math.ceil the components of a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a vector to ceil
 * @returns {vec3} out
 */function ceil(out,a){out[0]=Math.ceil(a[0]);out[1]=Math.ceil(a[1]);out[2]=Math.ceil(a[2]);return out;}/***/}),/***/3126:(/***/function(module){module.exports=clone;/**
 * Creates a new vec3 initialized with values from an existing vector
 *
 * @param {vec3} a vector to clone
 * @returns {vec3} a new 3D vector
 */function clone(a){var out=new Float32Array(3);out[0]=a[0];out[1]=a[1];out[2]=a[2];return out;}/***/}),/***/3990:(/***/function(module){module.exports=copy;/**
 * Copy the values from one vec3 to another
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the source vector
 * @returns {vec3} out
 */function copy(out,a){out[0]=a[0];out[1]=a[1];out[2]=a[2];return out;}/***/}),/***/1091:(/***/function(module){module.exports=create;/**
 * Creates a new, empty vec3
 *
 * @returns {vec3} a new 3D vector
 */function create(){var out=new Float32Array(3);out[0]=0;out[1]=0;out[2]=0;return out;}/***/}),/***/5911:(/***/function(module){module.exports=cross;/**
 * Computes the cross product of two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @returns {vec3} out
 */function cross(out,a,b){var ax=a[0],ay=a[1],az=a[2],bx=b[0],by=b[1],bz=b[2];out[0]=ay*bz-az*by;out[1]=az*bx-ax*bz;out[2]=ax*by-ay*bx;return out;}/***/}),/***/5455:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_593909__){module.exports=__nested_webpack_require_593909__(7056);/***/}),/***/7056:(/***/function(module){module.exports=distance;/**
 * Calculates the euclidian distance between two vec3's
 *
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @returns {Number} distance between a and b
 */function distance(a,b){var x=b[0]-a[0],y=b[1]-a[1],z=b[2]-a[2];return Math.sqrt(x*x+y*y+z*z);}/***/}),/***/4008:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_594382__){module.exports=__nested_webpack_require_594382__(6690);/***/}),/***/6690:(/***/function(module){module.exports=divide;/**
 * Divides two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @returns {vec3} out
 */function divide(out,a,b){out[0]=a[0]/b[0];out[1]=a[1]/b[1];out[2]=a[2]/b[2];return out;}/***/}),/***/244:(/***/function(module){module.exports=dot;/**
 * Calculates the dot product of two vec3's
 *
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @returns {Number} dot product of a and b
 */function dot(a,b){return a[0]*b[0]+a[1]*b[1]+a[2]*b[2];}/***/}),/***/2613:(/***/function(module){module.exports=0.000001;/***/}),/***/9922:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_595185__){module.exports=equals;var EPSILON=__nested_webpack_require_595185__(2613);/**
 * Returns whether or not the vectors have approximately the same elements in the same position.
 *
 * @param {vec3} a The first vector.
 * @param {vec3} b The second vector.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */function equals(a,b){var a0=a[0];var a1=a[1];var a2=a[2];var b0=b[0];var b1=b[1];var b2=b[2];return Math.abs(a0-b0)<=EPSILON*Math.max(1.0,Math.abs(a0),Math.abs(b0))&&Math.abs(a1-b1)<=EPSILON*Math.max(1.0,Math.abs(a1),Math.abs(b1))&&Math.abs(a2-b2)<=EPSILON*Math.max(1.0,Math.abs(a2),Math.abs(b2));}/***/}),/***/9265:(/***/function(module){module.exports=exactEquals;/**
 * Returns whether or not the vectors exactly have the same elements in the same position (when compared with ===)
 *
 * @param {vec3} a The first vector.
 * @param {vec3} b The second vector.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */function exactEquals(a,b){return a[0]===b[0]&&a[1]===b[1]&&a[2]===b[2];}/***/}),/***/2681:(/***/function(module){module.exports=floor;/**
 * Math.floor the components of a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a vector to floor
 * @returns {vec3} out
 */function floor(out,a){out[0]=Math.floor(a[0]);out[1]=Math.floor(a[1]);out[2]=Math.floor(a[2]);return out;}/***/}),/***/5137:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_596608__){module.exports=forEach;var vec=__nested_webpack_require_596608__(1091)();/**
 * Perform some operation over an array of vec3s.
 *
 * @param {Array} a the array of vectors to iterate over
 * @param {Number} stride Number of elements between the start of each vec3. If 0 assumes tightly packed
 * @param {Number} offset Number of elements to skip at the beginning of the array
 * @param {Number} count Number of vec3s to iterate over. If 0 iterates over entire array
 * @param {Function} fn Function to call for each vector in the array
 * @param {Object} [arg] additional argument to pass to fn
 * @returns {Array} a
 * @function
 */function forEach(a,stride,offset,count,fn,arg){var i,l;if(!stride){stride=3;}if(!offset){offset=0;}if(count){l=Math.min(count*stride+offset,a.length);}else{l=a.length;}for(i=offset;i<l;i+=stride){vec[0]=a[i];vec[1]=a[i+1];vec[2]=a[i+2];fn(vec,vec,arg);a[i]=vec[0];a[i+1]=vec[1];a[i+2]=vec[2];}return a;}/***/}),/***/2825:(/***/function(module){module.exports=fromValues;/**
 * Creates a new vec3 initialized with the given values
 *
 * @param {Number} x X component
 * @param {Number} y Y component
 * @param {Number} z Z component
 * @returns {vec3} a new 3D vector
 */function fromValues(x,y,z){var out=new Float32Array(3);out[0]=x;out[1]=y;out[2]=z;return out;}/***/}),/***/2931:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_597976__){module.exports={EPSILON:__nested_webpack_require_597976__(2613),create:__nested_webpack_require_597976__(1091),clone:__nested_webpack_require_597976__(3126),angle:__nested_webpack_require_597976__(8192),fromValues:__nested_webpack_require_597976__(2825),copy:__nested_webpack_require_597976__(3990),set:__nested_webpack_require_597976__(1463),equals:__nested_webpack_require_597976__(9922),exactEquals:__nested_webpack_require_597976__(9265),add:__nested_webpack_require_597976__(5632),subtract:__nested_webpack_require_597976__(6843),sub:__nested_webpack_require_597976__(2229),multiply:__nested_webpack_require_597976__(5847),mul:__nested_webpack_require_597976__(4505),divide:__nested_webpack_require_597976__(6690),div:__nested_webpack_require_597976__(4008),min:__nested_webpack_require_597976__(8107),max:__nested_webpack_require_597976__(7417),floor:__nested_webpack_require_597976__(2681),ceil:__nested_webpack_require_597976__(9226),round:__nested_webpack_require_597976__(2447),scale:__nested_webpack_require_597976__(6621),scaleAndAdd:__nested_webpack_require_597976__(8489),distance:__nested_webpack_require_597976__(7056),dist:__nested_webpack_require_597976__(5455),squaredDistance:__nested_webpack_require_597976__(2953),sqrDist:__nested_webpack_require_597976__(6141),length:__nested_webpack_require_597976__(1387),len:__nested_webpack_require_597976__(868),squaredLength:__nested_webpack_require_597976__(3066),sqrLen:__nested_webpack_require_597976__(5486),negate:__nested_webpack_require_597976__(5093),inverse:__nested_webpack_require_597976__(811),normalize:__nested_webpack_require_597976__(3536),dot:__nested_webpack_require_597976__(244),cross:__nested_webpack_require_597976__(5911),lerp:__nested_webpack_require_597976__(6658),random:__nested_webpack_require_597976__(7636),transformMat4:__nested_webpack_require_597976__(5673),transformMat3:__nested_webpack_require_597976__(492),transformQuat:__nested_webpack_require_597976__(264),rotateX:__nested_webpack_require_597976__(6894),rotateY:__nested_webpack_require_597976__(109),rotateZ:__nested_webpack_require_597976__(8692),forEach:__nested_webpack_require_597976__(5137)};/***/}),/***/811:(/***/function(module){module.exports=inverse;/**
 * Returns the inverse of the components of a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a vector to invert
 * @returns {vec3} out
 */function inverse(out,a){out[0]=1.0/a[0];out[1]=1.0/a[1];out[2]=1.0/a[2];return out;}/***/}),/***/868:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_599892__){module.exports=__nested_webpack_require_599892__(1387);/***/}),/***/1387:(/***/function(module){module.exports=length;/**
 * Calculates the length of a vec3
 *
 * @param {vec3} a vector to calculate length of
 * @returns {Number} length of a
 */function length(a){var x=a[0],y=a[1],z=a[2];return Math.sqrt(x*x+y*y+z*z);}/***/}),/***/6658:(/***/function(module){module.exports=lerp;/**
 * Performs a linear interpolation between two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @param {Number} t interpolation amount between the two inputs
 * @returns {vec3} out
 */function lerp(out,a,b,t){var ax=a[0],ay=a[1],az=a[2];out[0]=ax+t*(b[0]-ax);out[1]=ay+t*(b[1]-ay);out[2]=az+t*(b[2]-az);return out;}/***/}),/***/7417:(/***/function(module){module.exports=max;/**
 * Returns the maximum of two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @returns {vec3} out
 */function max(out,a,b){out[0]=Math.max(a[0],b[0]);out[1]=Math.max(a[1],b[1]);out[2]=Math.max(a[2],b[2]);return out;}/***/}),/***/8107:(/***/function(module){module.exports=min;/**
 * Returns the minimum of two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @returns {vec3} out
 */function min(out,a,b){out[0]=Math.min(a[0],b[0]);out[1]=Math.min(a[1],b[1]);out[2]=Math.min(a[2],b[2]);return out;}/***/}),/***/4505:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_601469__){module.exports=__nested_webpack_require_601469__(5847);/***/}),/***/5847:(/***/function(module){module.exports=multiply;/**
 * Multiplies two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @returns {vec3} out
 */function multiply(out,a,b){out[0]=a[0]*b[0];out[1]=a[1]*b[1];out[2]=a[2]*b[2];return out;}/***/}),/***/5093:(/***/function(module){module.exports=negate;/**
 * Negates the components of a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a vector to negate
 * @returns {vec3} out
 */function negate(out,a){out[0]=-a[0];out[1]=-a[1];out[2]=-a[2];return out;}/***/}),/***/3536:(/***/function(module){module.exports=normalize;/**
 * Normalize a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a vector to normalize
 * @returns {vec3} out
 */function normalize(out,a){var x=a[0],y=a[1],z=a[2];var len=x*x+y*y+z*z;if(len>0){//TODO: evaluate use of glm_invsqrt here?
len=1/Math.sqrt(len);out[0]=a[0]*len;out[1]=a[1]*len;out[2]=a[2]*len;}return out;}/***/}),/***/7636:(/***/function(module){module.exports=random;/**
 * Generates a random vector with the given scale
 *
 * @param {vec3} out the receiving vector
 * @param {Number} [scale] Length of the resulting vector. If ommitted, a unit vector will be returned
 * @returns {vec3} out
 */function random(out,scale){scale=scale||1.0;var r=Math.random()*2.0*Math.PI;var z=Math.random()*2.0-1.0;var zScale=Math.sqrt(1.0-z*z)*scale;out[0]=Math.cos(r)*zScale;out[1]=Math.sin(r)*zScale;out[2]=z*scale;return out;}/***/}),/***/6894:(/***/function(module){module.exports=rotateX;/**
 * Rotate a 3D vector around the x-axis
 * @param {vec3} out The receiving vec3
 * @param {vec3} a The vec3 point to rotate
 * @param {vec3} b The origin of the rotation
 * @param {Number} c The angle of rotation
 * @returns {vec3} out
 */function rotateX(out,a,b,c){var by=b[1];var bz=b[2];// Translate point to the origin
var py=a[1]-by;var pz=a[2]-bz;var sc=Math.sin(c);var cc=Math.cos(c);// perform rotation and translate to correct position
out[0]=a[0];out[1]=by+py*cc-pz*sc;out[2]=bz+py*sc+pz*cc;return out;}/***/}),/***/109:(/***/function(module){module.exports=rotateY;/**
 * Rotate a 3D vector around the y-axis
 * @param {vec3} out The receiving vec3
 * @param {vec3} a The vec3 point to rotate
 * @param {vec3} b The origin of the rotation
 * @param {Number} c The angle of rotation
 * @returns {vec3} out
 */function rotateY(out,a,b,c){var bx=b[0];var bz=b[2];// translate point to the origin
var px=a[0]-bx;var pz=a[2]-bz;var sc=Math.sin(c);var cc=Math.cos(c);// perform rotation and translate to correct position
out[0]=bx+pz*sc+px*cc;out[1]=a[1];out[2]=bz+pz*cc-px*sc;return out;}/***/}),/***/8692:(/***/function(module){module.exports=rotateZ;/**
 * Rotate a 3D vector around the z-axis
 * @param {vec3} out The receiving vec3
 * @param {vec3} a The vec3 point to rotate
 * @param {vec3} b The origin of the rotation
 * @param {Number} c The angle of rotation
 * @returns {vec3} out
 */function rotateZ(out,a,b,c){var bx=b[0];var by=b[1];//Translate point to the origin
var px=a[0]-bx;var py=a[1]-by;var sc=Math.sin(c);var cc=Math.cos(c);// perform rotation and translate to correct position
out[0]=bx+px*cc-py*sc;out[1]=by+px*sc+py*cc;out[2]=a[2];return out;}/***/}),/***/2447:(/***/function(module){module.exports=round;/**
 * Math.round the components of a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a vector to round
 * @returns {vec3} out
 */function round(out,a){out[0]=Math.round(a[0]);out[1]=Math.round(a[1]);out[2]=Math.round(a[2]);return out;}/***/}),/***/6621:(/***/function(module){module.exports=scale;/**
 * Scales a vec3 by a scalar number
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the vector to scale
 * @param {Number} b amount to scale the vector by
 * @returns {vec3} out
 */function scale(out,a,b){out[0]=a[0]*b;out[1]=a[1]*b;out[2]=a[2]*b;return out;}/***/}),/***/8489:(/***/function(module){module.exports=scaleAndAdd;/**
 * Adds two vec3's after scaling the second operand by a scalar value
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @param {Number} scale the amount to scale b by before adding
 * @returns {vec3} out
 */function scaleAndAdd(out,a,b,scale){out[0]=a[0]+b[0]*scale;out[1]=a[1]+b[1]*scale;out[2]=a[2]+b[2]*scale;return out;}/***/}),/***/1463:(/***/function(module){module.exports=set;/**
 * Set the components of a vec3 to the given values
 *
 * @param {vec3} out the receiving vector
 * @param {Number} x X component
 * @param {Number} y Y component
 * @param {Number} z Z component
 * @returns {vec3} out
 */function set(out,x,y,z){out[0]=x;out[1]=y;out[2]=z;return out;}/***/}),/***/6141:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_606345__){module.exports=__nested_webpack_require_606345__(2953);/***/}),/***/5486:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_606472__){module.exports=__nested_webpack_require_606472__(3066);/***/}),/***/2953:(/***/function(module){module.exports=squaredDistance;/**
 * Calculates the squared euclidian distance between two vec3's
 *
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @returns {Number} squared distance between a and b
 */function squaredDistance(a,b){var x=b[0]-a[0],y=b[1]-a[1],z=b[2]-a[2];return x*x+y*y+z*z;}/***/}),/***/3066:(/***/function(module){module.exports=squaredLength;/**
 * Calculates the squared length of a vec3
 *
 * @param {vec3} a vector to calculate squared length of
 * @returns {Number} squared length of a
 */function squaredLength(a){var x=a[0],y=a[1],z=a[2];return x*x+y*y+z*z;}/***/}),/***/2229:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_607256__){module.exports=__nested_webpack_require_607256__(6843);/***/}),/***/6843:(/***/function(module){module.exports=subtract;/**
 * Subtracts vector b from vector a
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @returns {vec3} out
 */function subtract(out,a,b){out[0]=a[0]-b[0];out[1]=a[1]-b[1];out[2]=a[2]-b[2];return out;}/***/}),/***/492:(/***/function(module){module.exports=transformMat3;/**
 * Transforms the vec3 with a mat3.
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the vector to transform
 * @param {mat4} m the 3x3 matrix to transform with
 * @returns {vec3} out
 */function transformMat3(out,a,m){var x=a[0],y=a[1],z=a[2];out[0]=x*m[0]+y*m[3]+z*m[6];out[1]=x*m[1]+y*m[4]+z*m[7];out[2]=x*m[2]+y*m[5]+z*m[8];return out;}/***/}),/***/5673:(/***/function(module){module.exports=transformMat4;/**
 * Transforms the vec3 with a mat4.
 * 4th vector component is implicitly '1'
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the vector to transform
 * @param {mat4} m matrix to transform with
 * @returns {vec3} out
 */function transformMat4(out,a,m){var x=a[0],y=a[1],z=a[2],w=m[3]*x+m[7]*y+m[11]*z+m[15];w=w||1.0;out[0]=(m[0]*x+m[4]*y+m[8]*z+m[12])/w;out[1]=(m[1]*x+m[5]*y+m[9]*z+m[13])/w;out[2]=(m[2]*x+m[6]*y+m[10]*z+m[14])/w;return out;}/***/}),/***/264:(/***/function(module){module.exports=transformQuat;/**
 * Transforms the vec3 with a quat
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the vector to transform
 * @param {quat} q quaternion to transform with
 * @returns {vec3} out
 */function transformQuat(out,a,q){// benchmarks: http://jsperf.com/quaternion-transform-vec3-implementations
var x=a[0],y=a[1],z=a[2],qx=q[0],qy=q[1],qz=q[2],qw=q[3],// calculate quat * vec
ix=qw*x+qy*z-qz*y,iy=qw*y+qz*x-qx*z,iz=qw*z+qx*y-qy*x,iw=-qx*x-qy*y-qz*z;// calculate result * inverse quat
out[0]=ix*qw+iw*-qx+iy*-qz-iz*-qy;out[1]=iy*qw+iw*-qy+iz*-qx-ix*-qz;out[2]=iz*qw+iw*-qz+ix*-qy-iy*-qx;return out;}/***/}),/***/4361:(/***/function(module){module.exports=add;/**
 * Adds two vec4's
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a the first operand
 * @param {vec4} b the second operand
 * @returns {vec4} out
 */function add(out,a,b){out[0]=a[0]+b[0];out[1]=a[1]+b[1];out[2]=a[2]+b[2];out[3]=a[3]+b[3];return out;}/***/}),/***/2335:(/***/function(module){module.exports=clone;/**
 * Creates a new vec4 initialized with values from an existing vector
 *
 * @param {vec4} a vector to clone
 * @returns {vec4} a new 4D vector
 */function clone(a){var out=new Float32Array(4);out[0]=a[0];out[1]=a[1];out[2]=a[2];out[3]=a[3];return out;}/***/}),/***/2933:(/***/function(module){module.exports=copy;/**
 * Copy the values from one vec4 to another
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a the source vector
 * @returns {vec4} out
 */function copy(out,a){out[0]=a[0];out[1]=a[1];out[2]=a[2];out[3]=a[3];return out;}/***/}),/***/7536:(/***/function(module){module.exports=create;/**
 * Creates a new, empty vec4
 *
 * @returns {vec4} a new 4D vector
 */function create(){var out=new Float32Array(4);out[0]=0;out[1]=0;out[2]=0;out[3]=0;return out;}/***/}),/***/4691:(/***/function(module){module.exports=distance;/**
 * Calculates the euclidian distance between two vec4's
 *
 * @param {vec4} a the first operand
 * @param {vec4} b the second operand
 * @returns {Number} distance between a and b
 */function distance(a,b){var x=b[0]-a[0],y=b[1]-a[1],z=b[2]-a[2],w=b[3]-a[3];return Math.sqrt(x*x+y*y+z*z+w*w);}/***/}),/***/1373:(/***/function(module){module.exports=divide;/**
 * Divides two vec4's
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a the first operand
 * @param {vec4} b the second operand
 * @returns {vec4} out
 */function divide(out,a,b){out[0]=a[0]/b[0];out[1]=a[1]/b[1];out[2]=a[2]/b[2];out[3]=a[3]/b[3];return out;}/***/}),/***/3750:(/***/function(module){module.exports=dot;/**
 * Calculates the dot product of two vec4's
 *
 * @param {vec4} a the first operand
 * @param {vec4} b the second operand
 * @returns {Number} dot product of a and b
 */function dot(a,b){return a[0]*b[0]+a[1]*b[1]+a[2]*b[2]+a[3]*b[3];}/***/}),/***/3390:(/***/function(module){module.exports=fromValues;/**
 * Creates a new vec4 initialized with the given values
 *
 * @param {Number} x X component
 * @param {Number} y Y component
 * @param {Number} z Z component
 * @param {Number} w W component
 * @returns {vec4} a new 4D vector
 */function fromValues(x,y,z,w){var out=new Float32Array(4);out[0]=x;out[1]=y;out[2]=z;out[3]=w;return out;}/***/}),/***/9970:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_611949__){module.exports={create:__nested_webpack_require_611949__(7536),clone:__nested_webpack_require_611949__(2335),fromValues:__nested_webpack_require_611949__(3390),copy:__nested_webpack_require_611949__(2933),set:__nested_webpack_require_611949__(4578),add:__nested_webpack_require_611949__(4361),subtract:__nested_webpack_require_611949__(6860),multiply:__nested_webpack_require_611949__(3576),divide:__nested_webpack_require_611949__(1373),min:__nested_webpack_require_611949__(2334),max:__nested_webpack_require_611949__(160),scale:__nested_webpack_require_611949__(9288),scaleAndAdd:__nested_webpack_require_611949__(4844),distance:__nested_webpack_require_611949__(4691),squaredDistance:__nested_webpack_require_611949__(7960),length:__nested_webpack_require_611949__(6808),squaredLength:__nested_webpack_require_611949__(483),negate:__nested_webpack_require_611949__(1498),inverse:__nested_webpack_require_611949__(4494),normalize:__nested_webpack_require_611949__(5177),dot:__nested_webpack_require_611949__(3750),lerp:__nested_webpack_require_611949__(2573),random:__nested_webpack_require_611949__(9131),transformMat4:__nested_webpack_require_611949__(5352),transformQuat:__nested_webpack_require_611949__(4041)};/***/}),/***/4494:(/***/function(module){module.exports=inverse;/**
 * Returns the inverse of the components of a vec4
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a vector to invert
 * @returns {vec4} out
 */function inverse(out,a){out[0]=1.0/a[0];out[1]=1.0/a[1];out[2]=1.0/a[2];out[3]=1.0/a[3];return out;}/***/}),/***/6808:(/***/function(module){module.exports=length;/**
 * Calculates the length of a vec4
 *
 * @param {vec4} a vector to calculate length of
 * @returns {Number} length of a
 */function length(a){var x=a[0],y=a[1],z=a[2],w=a[3];return Math.sqrt(x*x+y*y+z*z+w*w);}/***/}),/***/2573:(/***/function(module){module.exports=lerp;/**
 * Performs a linear interpolation between two vec4's
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a the first operand
 * @param {vec4} b the second operand
 * @param {Number} t interpolation amount between the two inputs
 * @returns {vec4} out
 */function lerp(out,a,b,t){var ax=a[0],ay=a[1],az=a[2],aw=a[3];out[0]=ax+t*(b[0]-ax);out[1]=ay+t*(b[1]-ay);out[2]=az+t*(b[2]-az);out[3]=aw+t*(b[3]-aw);return out;}/***/}),/***/160:(/***/function(module){module.exports=max;/**
 * Returns the maximum of two vec4's
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a the first operand
 * @param {vec4} b the second operand
 * @returns {vec4} out
 */function max(out,a,b){out[0]=Math.max(a[0],b[0]);out[1]=Math.max(a[1],b[1]);out[2]=Math.max(a[2],b[2]);out[3]=Math.max(a[3],b[3]);return out;}/***/}),/***/2334:(/***/function(module){module.exports=min;/**
 * Returns the minimum of two vec4's
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a the first operand
 * @param {vec4} b the second operand
 * @returns {vec4} out
 */function min(out,a,b){out[0]=Math.min(a[0],b[0]);out[1]=Math.min(a[1],b[1]);out[2]=Math.min(a[2],b[2]);out[3]=Math.min(a[3],b[3]);return out;}/***/}),/***/3576:(/***/function(module){module.exports=multiply;/**
 * Multiplies two vec4's
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a the first operand
 * @param {vec4} b the second operand
 * @returns {vec4} out
 */function multiply(out,a,b){out[0]=a[0]*b[0];out[1]=a[1]*b[1];out[2]=a[2]*b[2];out[3]=a[3]*b[3];return out;}/***/}),/***/1498:(/***/function(module){module.exports=negate;/**
 * Negates the components of a vec4
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a vector to negate
 * @returns {vec4} out
 */function negate(out,a){out[0]=-a[0];out[1]=-a[1];out[2]=-a[2];out[3]=-a[3];return out;}/***/}),/***/5177:(/***/function(module){module.exports=normalize;/**
 * Normalize a vec4
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a vector to normalize
 * @returns {vec4} out
 */function normalize(out,a){var x=a[0],y=a[1],z=a[2],w=a[3];var len=x*x+y*y+z*z+w*w;if(len>0){len=1/Math.sqrt(len);out[0]=x*len;out[1]=y*len;out[2]=z*len;out[3]=w*len;}return out;}/***/}),/***/9131:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_615795__){var vecNormalize=__nested_webpack_require_615795__(5177);var vecScale=__nested_webpack_require_615795__(9288);module.exports=random;/**
 * Generates a random vector with the given scale
 *
 * @param {vec4} out the receiving vector
 * @param {Number} [scale] Length of the resulting vector. If ommitted, a unit vector will be returned
 * @returns {vec4} out
 */function random(out,scale){scale=scale||1.0;// TODO: This is a pretty awful way of doing this. Find something better.
out[0]=Math.random();out[1]=Math.random();out[2]=Math.random();out[3]=Math.random();vecNormalize(out,out);vecScale(out,out,scale);return out;}/***/}),/***/9288:(/***/function(module){module.exports=scale;/**
 * Scales a vec4 by a scalar number
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a the vector to scale
 * @param {Number} b amount to scale the vector by
 * @returns {vec4} out
 */function scale(out,a,b){out[0]=a[0]*b;out[1]=a[1]*b;out[2]=a[2]*b;out[3]=a[3]*b;return out;}/***/}),/***/4844:(/***/function(module){module.exports=scaleAndAdd;/**
 * Adds two vec4's after scaling the second operand by a scalar value
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a the first operand
 * @param {vec4} b the second operand
 * @param {Number} scale the amount to scale b by before adding
 * @returns {vec4} out
 */function scaleAndAdd(out,a,b,scale){out[0]=a[0]+b[0]*scale;out[1]=a[1]+b[1]*scale;out[2]=a[2]+b[2]*scale;out[3]=a[3]+b[3]*scale;return out;}/***/}),/***/4578:(/***/function(module){module.exports=set;/**
 * Set the components of a vec4 to the given values
 *
 * @param {vec4} out the receiving vector
 * @param {Number} x X component
 * @param {Number} y Y component
 * @param {Number} z Z component
 * @param {Number} w W component
 * @returns {vec4} out
 */function set(out,x,y,z,w){out[0]=x;out[1]=y;out[2]=z;out[3]=w;return out;}/***/}),/***/7960:(/***/function(module){module.exports=squaredDistance;/**
 * Calculates the squared euclidian distance between two vec4's
 *
 * @param {vec4} a the first operand
 * @param {vec4} b the second operand
 * @returns {Number} squared distance between a and b
 */function squaredDistance(a,b){var x=b[0]-a[0],y=b[1]-a[1],z=b[2]-a[2],w=b[3]-a[3];return x*x+y*y+z*z+w*w;}/***/}),/***/483:(/***/function(module){module.exports=squaredLength;/**
 * Calculates the squared length of a vec4
 *
 * @param {vec4} a vector to calculate squared length of
 * @returns {Number} squared length of a
 */function squaredLength(a){var x=a[0],y=a[1],z=a[2],w=a[3];return x*x+y*y+z*z+w*w;}/***/}),/***/6860:(/***/function(module){module.exports=subtract;/**
 * Subtracts vector b from vector a
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a the first operand
 * @param {vec4} b the second operand
 * @returns {vec4} out
 */function subtract(out,a,b){out[0]=a[0]-b[0];out[1]=a[1]-b[1];out[2]=a[2]-b[2];out[3]=a[3]-b[3];return out;}/***/}),/***/5352:(/***/function(module){module.exports=transformMat4;/**
 * Transforms the vec4 with a mat4.
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a the vector to transform
 * @param {mat4} m matrix to transform with
 * @returns {vec4} out
 */function transformMat4(out,a,m){var x=a[0],y=a[1],z=a[2],w=a[3];out[0]=m[0]*x+m[4]*y+m[8]*z+m[12]*w;out[1]=m[1]*x+m[5]*y+m[9]*z+m[13]*w;out[2]=m[2]*x+m[6]*y+m[10]*z+m[14]*w;out[3]=m[3]*x+m[7]*y+m[11]*z+m[15]*w;return out;}/***/}),/***/4041:(/***/function(module){module.exports=transformQuat;/**
 * Transforms the vec4 with a quat
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a the vector to transform
 * @param {quat} q quaternion to transform with
 * @returns {vec4} out
 */function transformQuat(out,a,q){var x=a[0],y=a[1],z=a[2],qx=q[0],qy=q[1],qz=q[2],qw=q[3],// calculate quat * vec
ix=qw*x+qy*z-qz*y,iy=qw*y+qz*x-qx*z,iz=qw*z+qx*y-qy*x,iw=-qx*x-qy*y-qz*z;// calculate result * inverse quat
out[0]=ix*qw+iw*-qx+iy*-qz-iz*-qy;out[1]=iy*qw+iw*-qy+iz*-qx-ix*-qz;out[2]=iz*qw+iw*-qz+ix*-qy-iy*-qx;out[3]=a[3];return out;}/***/}),/***/1848:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_619862__){var tokenize=__nested_webpack_require_619862__(4905);var atob=__nested_webpack_require_619862__(6468);module.exports=getName;function getName(src){var tokens=Array.isArray(src)?src:tokenize(src);for(var i=0;i<tokens.length;i++){var token=tokens[i];if(token.type!=='preprocessor')continue;var match=token.data.match(/\#define\s+SHADER_NAME(_B64)?\s+(.+)$/);if(!match)continue;if(!match[2])continue;var b64=match[1];var name=match[2];return(b64?atob(name):name).trim();}}/***/}),/***/5874:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_620389__){module.exports=tokenize;var literals100=__nested_webpack_require_620389__(620),operators=__nested_webpack_require_620389__(7827),builtins100=__nested_webpack_require_620389__(6852),literals300es=__nested_webpack_require_620389__(7932),builtins300es=__nested_webpack_require_620389__(3508);var NORMAL=999// <-- never emitted
,TOKEN=9999// <-- never emitted
,BLOCK_COMMENT=0,LINE_COMMENT=1,PREPROCESSOR=2,OPERATOR=3,INTEGER=4,FLOAT=5,IDENT=6,BUILTIN=7,KEYWORD=8,WHITESPACE=9,EOF=10,HEX=11;var map=['block-comment','line-comment','preprocessor','operator','integer','float','ident','builtin','keyword','whitespace','eof','integer'];function tokenize(opt){var i=0,total=0,mode=NORMAL,c,last,content=[],tokens=[],token_idx=0,token_offs=0,line=1,col=0,start=0,isnum=false,isoperator=false,input='',len;opt=opt||{};var allBuiltins=builtins100;var allLiterals=literals100;if(opt.version==='300 es'){allBuiltins=builtins300es;allLiterals=literals300es;}// cache by name
var builtinsDict={},literalsDict={};for(var i=0;i<allBuiltins.length;i++){builtinsDict[allBuiltins[i]]=true;}for(var i=0;i<allLiterals.length;i++){literalsDict[allLiterals[i]]=true;}return function(data){tokens=[];if(data!==null)return write(data);return end();};function token(data){if(data.length){tokens.push({type:map[mode],data:data,position:start,line:line,column:col});}}function write(chunk){i=0;if(chunk.toString)chunk=chunk.toString();input+=chunk.replace(/\r\n/g,'\n');len=input.length;var last;while(c=input[i],i<len){last=i;switch(mode){case BLOCK_COMMENT:i=block_comment();break;case LINE_COMMENT:i=line_comment();break;case PREPROCESSOR:i=preprocessor();break;case OPERATOR:i=operator();break;case INTEGER:i=integer();break;case HEX:i=hex();break;case FLOAT:i=decimal();break;case TOKEN:i=readtoken();break;case WHITESPACE:i=whitespace();break;case NORMAL:i=normal();break;}if(last!==i){switch(input[last]){case'\n':col=0;++line;break;default:++col;break;}}}total+=i;input=input.slice(i);return tokens;}function end(chunk){if(content.length){token(content.join(''));}mode=EOF;token('(eof)');return tokens;}function normal(){content=content.length?[]:content;if(last==='/'&&c==='*'){start=total+i-1;mode=BLOCK_COMMENT;last=c;return i+1;}if(last==='/'&&c==='/'){start=total+i-1;mode=LINE_COMMENT;last=c;return i+1;}if(c==='#'){mode=PREPROCESSOR;start=total+i;return i;}if(/\s/.test(c)){mode=WHITESPACE;start=total+i;return i;}isnum=/\d/.test(c);isoperator=/[^\w_]/.test(c);start=total+i;mode=isnum?INTEGER:isoperator?OPERATOR:TOKEN;return i;}function whitespace(){if(/[^\s]/g.test(c)){token(content.join(''));mode=NORMAL;return i;}content.push(c);last=c;return i+1;}function preprocessor(){if((c==='\r'||c==='\n')&&last!=='\\'){token(content.join(''));mode=NORMAL;return i;}content.push(c);last=c;return i+1;}function line_comment(){return preprocessor();}function block_comment(){if(c==='/'&&last==='*'){content.push(c);token(content.join(''));mode=NORMAL;return i+1;}content.push(c);last=c;return i+1;}function operator(){if(last==='.'&&/\d/.test(c)){mode=FLOAT;return i;}if(last==='/'&&c==='*'){mode=BLOCK_COMMENT;return i;}if(last==='/'&&c==='/'){mode=LINE_COMMENT;return i;}if(c==='.'&&content.length){while(determine_operator(content));mode=FLOAT;return i;}if(c===';'||c===')'||c==='('){if(content.length)while(determine_operator(content));token(c);mode=NORMAL;return i+1;}var is_composite_operator=content.length===2&&c!=='=';if(/[\w_\d\s]/.test(c)||is_composite_operator){while(determine_operator(content));mode=NORMAL;return i;}content.push(c);last=c;return i+1;}function determine_operator(buf){var j=0,idx,res;do{idx=operators.indexOf(buf.slice(0,buf.length+j).join(''));res=operators[idx];if(idx===-1){if(j--+buf.length>0)continue;res=buf.slice(0,1).join('');}token(res);start+=res.length;content=content.slice(res.length);return content.length;}while(1);}function hex(){if(/[^a-fA-F0-9]/.test(c)){token(content.join(''));mode=NORMAL;return i;}content.push(c);last=c;return i+1;}function integer(){if(c==='.'){content.push(c);mode=FLOAT;last=c;return i+1;}if(/[eE]/.test(c)){content.push(c);mode=FLOAT;last=c;return i+1;}if(c==='x'&&content.length===1&&content[0]==='0'){mode=HEX;content.push(c);last=c;return i+1;}if(/[^\d]/.test(c)){token(content.join(''));mode=NORMAL;return i;}content.push(c);last=c;return i+1;}function decimal(){if(c==='f'){content.push(c);last=c;i+=1;}if(/[eE]/.test(c)){content.push(c);last=c;return i+1;}if((c==='-'||c==='+')&&/[eE]/.test(last)){content.push(c);last=c;return i+1;}if(/[^\d]/.test(c)){token(content.join(''));mode=NORMAL;return i;}content.push(c);last=c;return i+1;}function readtoken(){if(/[^\d\w_]/.test(c)){var contentstr=content.join('');if(literalsDict[contentstr]){mode=KEYWORD;}else if(builtinsDict[contentstr]){mode=BUILTIN;}else{mode=IDENT;}token(content.join(''));mode=NORMAL;return i;}content.push(c);last=c;return i+1;}}/***/}),/***/3508:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_625265__){// 300es builtins/reserved words that were previously valid in v100
var v100=__nested_webpack_require_625265__(6852);// The texture2D|Cube functions have been removed
// And the gl_ features are updated
v100=v100.slice().filter(function(b){return!/^(gl\_|texture)/.test(b);});module.exports=v100.concat([// the updated gl_ constants
'gl_VertexID','gl_InstanceID','gl_Position','gl_PointSize','gl_FragCoord','gl_FrontFacing','gl_FragDepth','gl_PointCoord','gl_MaxVertexAttribs','gl_MaxVertexUniformVectors','gl_MaxVertexOutputVectors','gl_MaxFragmentInputVectors','gl_MaxVertexTextureImageUnits','gl_MaxCombinedTextureImageUnits','gl_MaxTextureImageUnits','gl_MaxFragmentUniformVectors','gl_MaxDrawBuffers','gl_MinProgramTexelOffset','gl_MaxProgramTexelOffset','gl_DepthRangeParameters','gl_DepthRange'// other builtins
,'trunc','round','roundEven','isnan','isinf','floatBitsToInt','floatBitsToUint','intBitsToFloat','uintBitsToFloat','packSnorm2x16','unpackSnorm2x16','packUnorm2x16','unpackUnorm2x16','packHalf2x16','unpackHalf2x16','outerProduct','transpose','determinant','inverse','texture','textureSize','textureProj','textureLod','textureOffset','texelFetch','texelFetchOffset','textureProjOffset','textureLodOffset','textureProjLod','textureProjLodOffset','textureGrad','textureGradOffset','textureProjGrad','textureProjGradOffset']);/***/}),/***/6852:(/***/function(module){module.exports=[// Keep this list sorted
'abs','acos','all','any','asin','atan','ceil','clamp','cos','cross','dFdx','dFdy','degrees','distance','dot','equal','exp','exp2','faceforward','floor','fract','gl_BackColor','gl_BackLightModelProduct','gl_BackLightProduct','gl_BackMaterial','gl_BackSecondaryColor','gl_ClipPlane','gl_ClipVertex','gl_Color','gl_DepthRange','gl_DepthRangeParameters','gl_EyePlaneQ','gl_EyePlaneR','gl_EyePlaneS','gl_EyePlaneT','gl_Fog','gl_FogCoord','gl_FogFragCoord','gl_FogParameters','gl_FragColor','gl_FragCoord','gl_FragData','gl_FragDepth','gl_FragDepthEXT','gl_FrontColor','gl_FrontFacing','gl_FrontLightModelProduct','gl_FrontLightProduct','gl_FrontMaterial','gl_FrontSecondaryColor','gl_LightModel','gl_LightModelParameters','gl_LightModelProducts','gl_LightProducts','gl_LightSource','gl_LightSourceParameters','gl_MaterialParameters','gl_MaxClipPlanes','gl_MaxCombinedTextureImageUnits','gl_MaxDrawBuffers','gl_MaxFragmentUniformComponents','gl_MaxLights','gl_MaxTextureCoords','gl_MaxTextureImageUnits','gl_MaxTextureUnits','gl_MaxVaryingFloats','gl_MaxVertexAttribs','gl_MaxVertexTextureImageUnits','gl_MaxVertexUniformComponents','gl_ModelViewMatrix','gl_ModelViewMatrixInverse','gl_ModelViewMatrixInverseTranspose','gl_ModelViewMatrixTranspose','gl_ModelViewProjectionMatrix','gl_ModelViewProjectionMatrixInverse','gl_ModelViewProjectionMatrixInverseTranspose','gl_ModelViewProjectionMatrixTranspose','gl_MultiTexCoord0','gl_MultiTexCoord1','gl_MultiTexCoord2','gl_MultiTexCoord3','gl_MultiTexCoord4','gl_MultiTexCoord5','gl_MultiTexCoord6','gl_MultiTexCoord7','gl_Normal','gl_NormalMatrix','gl_NormalScale','gl_ObjectPlaneQ','gl_ObjectPlaneR','gl_ObjectPlaneS','gl_ObjectPlaneT','gl_Point','gl_PointCoord','gl_PointParameters','gl_PointSize','gl_Position','gl_ProjectionMatrix','gl_ProjectionMatrixInverse','gl_ProjectionMatrixInverseTranspose','gl_ProjectionMatrixTranspose','gl_SecondaryColor','gl_TexCoord','gl_TextureEnvColor','gl_TextureMatrix','gl_TextureMatrixInverse','gl_TextureMatrixInverseTranspose','gl_TextureMatrixTranspose','gl_Vertex','greaterThan','greaterThanEqual','inversesqrt','length','lessThan','lessThanEqual','log','log2','matrixCompMult','max','min','mix','mod','normalize','not','notEqual','pow','radians','reflect','refract','sign','sin','smoothstep','sqrt','step','tan','texture2D','texture2DLod','texture2DProj','texture2DProjLod','textureCube','textureCubeLod','texture2DLodEXT','texture2DProjLodEXT','textureCubeLodEXT','texture2DGradEXT','texture2DProjGradEXT','textureCubeGradEXT'];/***/}),/***/7932:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_629275__){var v100=__nested_webpack_require_629275__(620);module.exports=v100.slice().concat(['layout','centroid','smooth','case','mat2x2','mat2x3','mat2x4','mat3x2','mat3x3','mat3x4','mat4x2','mat4x3','mat4x4','uvec2','uvec3','uvec4','samplerCubeShadow','sampler2DArray','sampler2DArrayShadow','isampler2D','isampler3D','isamplerCube','isampler2DArray','usampler2D','usampler3D','usamplerCube','usampler2DArray','coherent','restrict','readonly','writeonly','resource','atomic_uint','noperspective','patch','sample','subroutine','common','partition','active','filter','image1D','image2D','image3D','imageCube','iimage1D','iimage2D','iimage3D','iimageCube','uimage1D','uimage2D','uimage3D','uimageCube','image1DArray','image2DArray','iimage1DArray','iimage2DArray','uimage1DArray','uimage2DArray','image1DShadow','image2DShadow','image1DArrayShadow','image2DArrayShadow','imageBuffer','iimageBuffer','uimageBuffer','sampler1DArray','sampler1DArrayShadow','isampler1D','isampler1DArray','usampler1D','usampler1DArray','isampler2DRect','usampler2DRect','samplerBuffer','isamplerBuffer','usamplerBuffer','sampler2DMS','isampler2DMS','usampler2DMS','sampler2DMSArray','isampler2DMSArray','usampler2DMSArray']);/***/}),/***/620:(/***/function(module){module.exports=[// current
'precision','highp','mediump','lowp','attribute','const','uniform','varying','break','continue','do','for','while','if','else','in','out','inout','float','int','uint','void','bool','true','false','discard','return','mat2','mat3','mat4','vec2','vec3','vec4','ivec2','ivec3','ivec4','bvec2','bvec3','bvec4','sampler1D','sampler2D','sampler3D','samplerCube','sampler1DShadow','sampler2DShadow','struct'// future
,'asm','class','union','enum','typedef','template','this','packed','goto','switch','default','inline','noinline','volatile','public','static','extern','external','interface','long','short','double','half','fixed','unsigned','input','output','hvec2','hvec3','hvec4','dvec2','dvec3','dvec4','fvec2','fvec3','fvec4','sampler2DRect','sampler3DRect','sampler2DRectShadow','sizeof','cast','namespace','using'];/***/}),/***/7827:(/***/function(module){module.exports=['<<=','>>=','++','--','<<','>>','<=','>=','==','!=','&&','||','+=','-=','*=','/=','%=','&=','^^','^=','|=','(',')','[',']','.','!','~','*','/','%','+','-','<','>','&','^','|','?',':','=',',',';','{','}'];/***/}),/***/4905:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_631683__){var tokenize=__nested_webpack_require_631683__(5874);module.exports=tokenizeString;function tokenizeString(str,opt){var generator=tokenize(opt);var tokens=[];tokens=tokens.concat(generator(str));tokens=tokens.concat(generator(null));return tokens;}/***/}),/***/3236:(/***/function(module){module.exports=function(strings){if(typeof strings==='string')strings=[strings];var exprs=[].slice.call(arguments,1);var parts=[];for(var i=0;i<strings.length-1;i++){parts.push(strings[i],exprs[i]||'');}parts.push(strings[i]);return parts.join('');};/***/}),/***/7520:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_632294__){"use strict";var isBrowser=__nested_webpack_require_632294__(9507);function detect(){var supported=false;try{var opts=Object.defineProperty({},'passive',{get:function(){supported=true;}});window.addEventListener('test',null,opts);window.removeEventListener('test',null,opts);}catch(e){supported=false;}return supported;}module.exports=isBrowser&&detect();/***/}),/***/3778:(/***/function(__unused_webpack_module,exports){/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */exports.read=function(buffer,offset,isLE,mLen,nBytes){var e,m;var eLen=nBytes*8-mLen-1;var eMax=(1<<eLen)-1;var eBias=eMax>>1;var nBits=-7;var i=isLE?nBytes-1:0;var d=isLE?-1:1;var s=buffer[offset+i];i+=d;e=s&(1<<-nBits)-1;s>>=-nBits;nBits+=eLen;for(;nBits>0;e=e*256+buffer[offset+i],i+=d,nBits-=8){}m=e&(1<<-nBits)-1;e>>=-nBits;nBits+=mLen;for(;nBits>0;m=m*256+buffer[offset+i],i+=d,nBits-=8){}if(e===0){e=1-eBias;}else if(e===eMax){return m?NaN:(s?-1:1)*Infinity;}else{m=m+Math.pow(2,mLen);e=e-eBias;}return(s?-1:1)*m*Math.pow(2,e-mLen);};exports.write=function(buffer,value,offset,isLE,mLen,nBytes){var e,m,c;var eLen=nBytes*8-mLen-1;var eMax=(1<<eLen)-1;var eBias=eMax>>1;var rt=mLen===23?Math.pow(2,-24)-Math.pow(2,-77):0;var i=isLE?0:nBytes-1;var d=isLE?1:-1;var s=value<0||value===0&&1/value<0?1:0;value=Math.abs(value);if(isNaN(value)||value===Infinity){m=isNaN(value)?1:0;e=eMax;}else{e=Math.floor(Math.log(value)/Math.LN2);if(value*(c=Math.pow(2,-e))<1){e--;c*=2;}if(e+eBias>=1){value+=rt/c;}else{value+=rt*Math.pow(2,1-eBias);}if(value*c>=2){e++;c/=2;}if(e+eBias>=eMax){m=0;e=eMax;}else if(e+eBias>=1){m=(value*c-1)*Math.pow(2,mLen);e=e+eBias;}else{m=value*Math.pow(2,eBias-1)*Math.pow(2,mLen);e=0;}}for(;mLen>=8;buffer[offset+i]=m&0xff,i+=d,m/=256,mLen-=8){}e=e<<mLen|m;eLen+=mLen;for(;eLen>0;buffer[offset+i]=e&0xff,i+=d,e/=256,eLen-=8){}buffer[offset+i-d]|=s*128;};/***/}),/***/8954:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_634255__){"use strict";//High level idea:
// 1. Use Clarkson's incremental construction to find convex hull
// 2. Point location in triangulation by jump and walk
module.exports=incrementalConvexHull;var orient=__nested_webpack_require_634255__(3250);var compareCell=__nested_webpack_require_634255__(6803)/* .compareCells */.Fw;function Simplex(vertices,adjacent,boundary){this.vertices=vertices;this.adjacent=adjacent;this.boundary=boundary;this.lastVisited=-1;}Simplex.prototype.flip=function(){var t=this.vertices[0];this.vertices[0]=this.vertices[1];this.vertices[1]=t;var u=this.adjacent[0];this.adjacent[0]=this.adjacent[1];this.adjacent[1]=u;};function GlueFacet(vertices,cell,index){this.vertices=vertices;this.cell=cell;this.index=index;}function compareGlue(a,b){return compareCell(a.vertices,b.vertices);}function wrapper(test){return function(){var tuple=this.tuple;return test.apply(this,tuple);};}function bakeOrient(d){var test=orient[d+1];if(!test){test=orient;}return wrapper(test);}var BAKED=[];function Triangulation(dimension,vertices,simplices){this.dimension=dimension;this.vertices=vertices;this.simplices=simplices;this.interior=simplices.filter(function(c){return!c.boundary;});this.tuple=new Array(dimension+1);for(var i=0;i<=dimension;++i){this.tuple[i]=this.vertices[i];}var o=BAKED[dimension];if(!o){o=BAKED[dimension]=bakeOrient(dimension);}this.orient=o;}var proto=Triangulation.prototype;//Degenerate situation where we are on boundary, but coplanar to face
proto.handleBoundaryDegeneracy=function(cell,point){var d=this.dimension;var n=this.vertices.length-1;var tuple=this.tuple;var verts=this.vertices;//Dumb solution: Just do dfs from boundary cell until we find any peak, or terminate
var toVisit=[cell];cell.lastVisited=-n;while(toVisit.length>0){cell=toVisit.pop();var cellAdj=cell.adjacent;for(var i=0;i<=d;++i){var neighbor=cellAdj[i];if(!neighbor.boundary||neighbor.lastVisited<=-n){continue;}var nv=neighbor.vertices;for(var j=0;j<=d;++j){var vv=nv[j];if(vv<0){tuple[j]=point;}else{tuple[j]=verts[vv];}}var o=this.orient();if(o>0){return neighbor;}neighbor.lastVisited=-n;if(o===0){toVisit.push(neighbor);}}}return null;};proto.walk=function(point,random){//Alias local properties
var n=this.vertices.length-1;var d=this.dimension;var verts=this.vertices;var tuple=this.tuple;//Compute initial jump cell
var initIndex=random?this.interior.length*Math.random()|0:this.interior.length-1;var cell=this.interior[initIndex];//Start walking
outerLoop:while(!cell.boundary){var cellVerts=cell.vertices;var cellAdj=cell.adjacent;for(var i=0;i<=d;++i){tuple[i]=verts[cellVerts[i]];}cell.lastVisited=n;//Find farthest adjacent cell
for(var i=0;i<=d;++i){var neighbor=cellAdj[i];if(neighbor.lastVisited>=n){continue;}var prev=tuple[i];tuple[i]=point;var o=this.orient();tuple[i]=prev;if(o<0){cell=neighbor;continue outerLoop;}else{if(!neighbor.boundary){neighbor.lastVisited=n;}else{neighbor.lastVisited=-n;}}}return;}return cell;};proto.addPeaks=function(point,cell){var n=this.vertices.length-1;var d=this.dimension;var verts=this.vertices;var tuple=this.tuple;var interior=this.interior;var simplices=this.simplices;//Walking finished at boundary, time to add peaks
var tovisit=[cell];//Stretch initial boundary cell into a peak
cell.lastVisited=n;cell.vertices[cell.vertices.indexOf(-1)]=n;cell.boundary=false;interior.push(cell);//Record a list of all new boundaries created by added peaks so we can glue them together when we are all done
var glueFacets=[];//Do a traversal of the boundary walking outward from starting peak
while(tovisit.length>0){//Pop off peak and walk over adjacent cells
var cell=tovisit.pop();var cellVerts=cell.vertices;var cellAdj=cell.adjacent;var indexOfN=cellVerts.indexOf(n);if(indexOfN<0){continue;}for(var i=0;i<=d;++i){if(i===indexOfN){continue;}//For each boundary neighbor of the cell
var neighbor=cellAdj[i];if(!neighbor.boundary||neighbor.lastVisited>=n){continue;}var nv=neighbor.vertices;//Test if neighbor is a peak
if(neighbor.lastVisited!==-n){//Compute orientation of p relative to each boundary peak
var indexOfNeg1=0;for(var j=0;j<=d;++j){if(nv[j]<0){indexOfNeg1=j;tuple[j]=point;}else{tuple[j]=verts[nv[j]];}}var o=this.orient();//Test if neighbor cell is also a peak
if(o>0){nv[indexOfNeg1]=n;neighbor.boundary=false;interior.push(neighbor);tovisit.push(neighbor);neighbor.lastVisited=n;continue;}else{neighbor.lastVisited=-n;}}var na=neighbor.adjacent;//Otherwise, replace neighbor with new face
var vverts=cellVerts.slice();var vadj=cellAdj.slice();var ncell=new Simplex(vverts,vadj,true);simplices.push(ncell);//Connect to neighbor
var opposite=na.indexOf(cell);if(opposite<0){continue;}na[opposite]=ncell;vadj[indexOfN]=neighbor;//Connect to cell
vverts[i]=-1;vadj[i]=cell;cellAdj[i]=ncell;//Flip facet
ncell.flip();//Add to glue list
for(var j=0;j<=d;++j){var uu=vverts[j];if(uu<0||uu===n){continue;}var nface=new Array(d-1);var nptr=0;for(var k=0;k<=d;++k){var vv=vverts[k];if(vv<0||k===j){continue;}nface[nptr++]=vv;}glueFacets.push(new GlueFacet(nface,ncell,j));}}}//Glue boundary facets together
glueFacets.sort(compareGlue);for(var i=0;i+1<glueFacets.length;i+=2){var a=glueFacets[i];var b=glueFacets[i+1];var ai=a.index;var bi=b.index;if(ai<0||bi<0){continue;}a.cell.adjacent[a.index]=b.cell;b.cell.adjacent[b.index]=a.cell;}};proto.insert=function(point,random){//Add point
var verts=this.vertices;verts.push(point);var cell=this.walk(point,random);if(!cell){return;}//Alias local properties
var d=this.dimension;var tuple=this.tuple;//Degenerate case: If point is coplanar to cell, then walk until we find a non-degenerate boundary
for(var i=0;i<=d;++i){var vv=cell.vertices[i];if(vv<0){tuple[i]=point;}else{tuple[i]=verts[vv];}}var o=this.orient(tuple);if(o<0){return;}else if(o===0){cell=this.handleBoundaryDegeneracy(cell,point);if(!cell){return;}}//Add peaks
this.addPeaks(point,cell);};//Extract all boundary cells
proto.boundary=function(){var d=this.dimension;var boundary=[];var cells=this.simplices;var nc=cells.length;for(var i=0;i<nc;++i){var c=cells[i];if(c.boundary){var bcell=new Array(d);var cv=c.vertices;var ptr=0;var parity=0;for(var j=0;j<=d;++j){if(cv[j]>=0){bcell[ptr++]=cv[j];}else{parity=j&1;}}if(parity===(d&1)){var t=bcell[0];bcell[0]=bcell[1];bcell[1]=t;}boundary.push(bcell);}}return boundary;};function incrementalConvexHull(points,randomSearch){var n=points.length;if(n===0){throw new Error("Must have at least d+1 points");}var d=points[0].length;if(n<=d){throw new Error("Must input at least d+1 points");}//FIXME: This could be degenerate, but need to select d+1 non-coplanar points to bootstrap process
var initialSimplex=points.slice(0,d+1);//Make sure initial simplex is positively oriented
var o=orient.apply(void 0,initialSimplex);if(o===0){throw new Error("Input not in general position");}var initialCoords=new Array(d+1);for(var i=0;i<=d;++i){initialCoords[i]=i;}if(o<0){initialCoords[0]=1;initialCoords[1]=0;}//Create initial topological index, glue pointers together (kind of messy)
var initialCell=new Simplex(initialCoords,new Array(d+1),false);var boundary=initialCell.adjacent;var list=new Array(d+2);for(var i=0;i<=d;++i){var verts=initialCoords.slice();for(var j=0;j<=d;++j){if(j===i){verts[j]=-1;}}var t=verts[0];verts[0]=verts[1];verts[1]=t;var cell=new Simplex(verts,new Array(d+1),true);boundary[i]=cell;list[i]=cell;}list[d+1]=initialCell;for(var i=0;i<=d;++i){var verts=boundary[i].vertices;var adj=boundary[i].adjacent;for(var j=0;j<=d;++j){var v=verts[j];if(v<0){adj[j]=initialCell;continue;}for(var k=0;k<=d;++k){if(boundary[k].vertices.indexOf(v)<0){adj[j]=boundary[k];}}}}//Initialize triangles
var triangles=new Triangulation(d,initialSimplex,list);//Insert remaining points
var useRandom=!!randomSearch;for(var i=d+1;i<n;++i){triangles.insert(points[i],useRandom);}//Extract boundary cells
return triangles.boundary();}/***/}),/***/3352:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_642181__){"use strict";var bounds=__nested_webpack_require_642181__(2478);var NOT_FOUND=0;var SUCCESS=1;var EMPTY=2;module.exports=createWrapper;function IntervalTreeNode(mid,left,right,leftPoints,rightPoints){this.mid=mid;this.left=left;this.right=right;this.leftPoints=leftPoints;this.rightPoints=rightPoints;this.count=(left?left.count:0)+(right?right.count:0)+leftPoints.length;}var proto=IntervalTreeNode.prototype;function copy(a,b){a.mid=b.mid;a.left=b.left;a.right=b.right;a.leftPoints=b.leftPoints;a.rightPoints=b.rightPoints;a.count=b.count;}function rebuild(node,intervals){var ntree=createIntervalTree(intervals);node.mid=ntree.mid;node.left=ntree.left;node.right=ntree.right;node.leftPoints=ntree.leftPoints;node.rightPoints=ntree.rightPoints;node.count=ntree.count;}function rebuildWithInterval(node,interval){var intervals=node.intervals([]);intervals.push(interval);rebuild(node,intervals);}function rebuildWithoutInterval(node,interval){var intervals=node.intervals([]);var idx=intervals.indexOf(interval);if(idx<0){return NOT_FOUND;}intervals.splice(idx,1);rebuild(node,intervals);return SUCCESS;}proto.intervals=function(result){result.push.apply(result,this.leftPoints);if(this.left){this.left.intervals(result);}if(this.right){this.right.intervals(result);}return result;};proto.insert=function(interval){var weight=this.count-this.leftPoints.length;this.count+=1;if(interval[1]<this.mid){if(this.left){if(4*(this.left.count+1)>3*(weight+1)){rebuildWithInterval(this,interval);}else{this.left.insert(interval);}}else{this.left=createIntervalTree([interval]);}}else if(interval[0]>this.mid){if(this.right){if(4*(this.right.count+1)>3*(weight+1)){rebuildWithInterval(this,interval);}else{this.right.insert(interval);}}else{this.right=createIntervalTree([interval]);}}else{var l=bounds.ge(this.leftPoints,interval,compareBegin);var r=bounds.ge(this.rightPoints,interval,compareEnd);this.leftPoints.splice(l,0,interval);this.rightPoints.splice(r,0,interval);}};proto.remove=function(interval){var weight=this.count-this.leftPoints;if(interval[1]<this.mid){if(!this.left){return NOT_FOUND;}var rw=this.right?this.right.count:0;if(4*rw>3*(weight-1)){return rebuildWithoutInterval(this,interval);}var r=this.left.remove(interval);if(r===EMPTY){this.left=null;this.count-=1;return SUCCESS;}else if(r===SUCCESS){this.count-=1;}return r;}else if(interval[0]>this.mid){if(!this.right){return NOT_FOUND;}var lw=this.left?this.left.count:0;if(4*lw>3*(weight-1)){return rebuildWithoutInterval(this,interval);}var r=this.right.remove(interval);if(r===EMPTY){this.right=null;this.count-=1;return SUCCESS;}else if(r===SUCCESS){this.count-=1;}return r;}else{if(this.count===1){if(this.leftPoints[0]===interval){return EMPTY;}else{return NOT_FOUND;}}if(this.leftPoints.length===1&&this.leftPoints[0]===interval){if(this.left&&this.right){var p=this;var n=this.left;while(n.right){p=n;n=n.right;}if(p===this){n.right=this.right;}else{var l=this.left;var r=this.right;p.count-=n.count;p.right=n.left;n.left=l;n.right=r;}copy(this,n);this.count=(this.left?this.left.count:0)+(this.right?this.right.count:0)+this.leftPoints.length;}else if(this.left){copy(this,this.left);}else{copy(this,this.right);}return SUCCESS;}for(var l=bounds.ge(this.leftPoints,interval,compareBegin);l<this.leftPoints.length;++l){if(this.leftPoints[l][0]!==interval[0]){break;}if(this.leftPoints[l]===interval){this.count-=1;this.leftPoints.splice(l,1);for(var r=bounds.ge(this.rightPoints,interval,compareEnd);r<this.rightPoints.length;++r){if(this.rightPoints[r][1]!==interval[1]){break;}else if(this.rightPoints[r]===interval){this.rightPoints.splice(r,1);return SUCCESS;}}}}return NOT_FOUND;}};function reportLeftRange(arr,hi,cb){for(var i=0;i<arr.length&&arr[i][0]<=hi;++i){var r=cb(arr[i]);if(r){return r;}}}function reportRightRange(arr,lo,cb){for(var i=arr.length-1;i>=0&&arr[i][1]>=lo;--i){var r=cb(arr[i]);if(r){return r;}}}function reportRange(arr,cb){for(var i=0;i<arr.length;++i){var r=cb(arr[i]);if(r){return r;}}}proto.queryPoint=function(x,cb){if(x<this.mid){if(this.left){var r=this.left.queryPoint(x,cb);if(r){return r;}}return reportLeftRange(this.leftPoints,x,cb);}else if(x>this.mid){if(this.right){var r=this.right.queryPoint(x,cb);if(r){return r;}}return reportRightRange(this.rightPoints,x,cb);}else{return reportRange(this.leftPoints,cb);}};proto.queryInterval=function(lo,hi,cb){if(lo<this.mid&&this.left){var r=this.left.queryInterval(lo,hi,cb);if(r){return r;}}if(hi>this.mid&&this.right){var r=this.right.queryInterval(lo,hi,cb);if(r){return r;}}if(hi<this.mid){return reportLeftRange(this.leftPoints,hi,cb);}else if(lo>this.mid){return reportRightRange(this.rightPoints,lo,cb);}else{return reportRange(this.leftPoints,cb);}};function compareNumbers(a,b){return a-b;}function compareBegin(a,b){var d=a[0]-b[0];if(d){return d;}return a[1]-b[1];}function compareEnd(a,b){var d=a[1]-b[1];if(d){return d;}return a[0]-b[0];}function createIntervalTree(intervals){if(intervals.length===0){return null;}var pts=[];for(var i=0;i<intervals.length;++i){pts.push(intervals[i][0],intervals[i][1]);}pts.sort(compareNumbers);var mid=pts[pts.length>>1];var leftIntervals=[];var rightIntervals=[];var centerIntervals=[];for(var i=0;i<intervals.length;++i){var s=intervals[i];if(s[1]<mid){leftIntervals.push(s);}else if(mid<s[0]){rightIntervals.push(s);}else{centerIntervals.push(s);}}//Split center intervals
var leftPoints=centerIntervals;var rightPoints=centerIntervals.slice();leftPoints.sort(compareBegin);rightPoints.sort(compareEnd);return new IntervalTreeNode(mid,createIntervalTree(leftIntervals),createIntervalTree(rightIntervals),leftPoints,rightPoints);}//User friendly wrapper that makes it possible to support empty trees
function IntervalTree(root){this.root=root;}var tproto=IntervalTree.prototype;tproto.insert=function(interval){if(this.root){this.root.insert(interval);}else{this.root=new IntervalTreeNode(interval[0],null,null,[interval],[interval]);}};tproto.remove=function(interval){if(this.root){var r=this.root.remove(interval);if(r===EMPTY){this.root=null;}return r!==NOT_FOUND;}return false;};tproto.queryPoint=function(p,cb){if(this.root){return this.root.queryPoint(p,cb);}};tproto.queryInterval=function(lo,hi,cb){if(lo<=hi&&this.root){return this.root.queryInterval(lo,hi,cb);}};Object.defineProperty(tproto,"count",{get:function(){if(this.root){return this.root.count;}return 0;}});Object.defineProperty(tproto,"intervals",{get:function(){if(this.root){return this.root.intervals([]);}return[];}});function createWrapper(intervals){if(!intervals||intervals.length===0){return new IntervalTree(null);}return new IntervalTree(createIntervalTree(intervals));}/***/}),/***/7762:(/***/function(module){"use strict";function iota(n){var result=new Array(n);for(var i=0;i<n;++i){result[i]=i;}return result;}module.exports=iota;/***/}),/***/9507:(/***/function(module){module.exports=true;/***/}),/***/7163:(/***/function(module){/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ // The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports=function(obj){return obj!=null&&(isBuffer(obj)||isSlowBuffer(obj)||!!obj._isBuffer);};function isBuffer(obj){return!!obj.constructor&&typeof obj.constructor.isBuffer==='function'&&obj.constructor.isBuffer(obj);}// For Node v0.10 support. Remove this eventually.
function isSlowBuffer(obj){return typeof obj.readFloatLE==='function'&&typeof obj.slice==='function'&&isBuffer(obj.slice(0,0));}/***/}),/***/5219:(/***/function(module){"use strict";/**
 * Is this string all whitespace?
 * This solution kind of makes my brain hurt, but it's significantly faster
 * than !str.trim() or any other solution I could find.
 *
 * whitespace codes from: http://en.wikipedia.org/wiki/Whitespace_character
 * and verified with:
 *
 *  for(var i = 0; i < 65536; i++) {
 *      var s = String.fromCharCode(i);
 *      if(+s===0 && !s.trim()) console.log(i, s);
 *  }
 *
 * which counts a couple of these as *not* whitespace, but finds nothing else
 * that *is* whitespace. Note that charCodeAt stops at 16 bits, but it appears
 * that there are no whitespace characters above this, and code points above
 * this do not map onto white space characters.
 */module.exports=function(str){var l=str.length,a;for(var i=0;i<l;i++){a=str.charCodeAt(i);if((a<9||a>13)&&a!==32&&a!==133&&a!==160&&a!==5760&&a!==6158&&(a<8192||a>8205)&&a!==8232&&a!==8233&&a!==8239&&a!==8287&&a!==8288&&a!==12288&&a!==65279){return false;}}return true;};/***/}),/***/395:(/***/function(module){function lerp(v0,v1,t){return v0*(1-t)+v1*t;}module.exports=lerp;/***/}),/***/2652:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_650977__){/*jshint unused:true*/ /*
Input:  matrix      ; a 4x4 matrix
Output: translation ; a 3 component vector
        scale       ; a 3 component vector
        skew        ; skew factors XY,XZ,YZ represented as a 3 component vector
        perspective ; a 4 component vector
        quaternion  ; a 4 component vector
Returns false if the matrix cannot be decomposed, true if it can


References:
https://github.com/kamicane/matrix3d/blob/master/lib/Matrix3d.js
https://github.com/ChromiumWebApps/chromium/blob/master/ui/gfx/transform_util.cc
http://www.w3.org/TR/css3-transforms/#decomposing-a-3d-matrix
*/var normalize=__nested_webpack_require_650977__(4335);var create=__nested_webpack_require_650977__(6864);var clone=__nested_webpack_require_650977__(1903);var determinant=__nested_webpack_require_650977__(9921);var invert=__nested_webpack_require_650977__(7608);var transpose=__nested_webpack_require_650977__(5665);var vec3={length:__nested_webpack_require_650977__(1387),normalize:__nested_webpack_require_650977__(3536),dot:__nested_webpack_require_650977__(244),cross:__nested_webpack_require_650977__(5911)};var tmp=create();var perspectiveMatrix=create();var tmpVec4=[0,0,0,0];var row=[[0,0,0],[0,0,0],[0,0,0]];var pdum3=[0,0,0];module.exports=function decomposeMat4(matrix,translation,scale,skew,perspective,quaternion){if(!translation)translation=[0,0,0];if(!scale)scale=[0,0,0];if(!skew)skew=[0,0,0];if(!perspective)perspective=[0,0,0,1];if(!quaternion)quaternion=[0,0,0,1];//normalize, if not possible then bail out early
if(!normalize(tmp,matrix))return false;// perspectiveMatrix is used to solve for perspective, but it also provides
// an easy way to test for singularity of the upper 3x3 component.
clone(perspectiveMatrix,tmp);perspectiveMatrix[3]=0;perspectiveMatrix[7]=0;perspectiveMatrix[11]=0;perspectiveMatrix[15]=1;// If the perspectiveMatrix is not invertible, we are also unable to
// decompose, so we'll bail early. Constant taken from SkMatrix44::invert.
if(Math.abs(determinant(perspectiveMatrix)<1e-8))return false;var a03=tmp[3],a13=tmp[7],a23=tmp[11],a30=tmp[12],a31=tmp[13],a32=tmp[14],a33=tmp[15];// First, isolate perspective.
if(a03!==0||a13!==0||a23!==0){tmpVec4[0]=a03;tmpVec4[1]=a13;tmpVec4[2]=a23;tmpVec4[3]=a33;// Solve the equation by inverting perspectiveMatrix and multiplying
// rightHandSide by the inverse.
// resuing the perspectiveMatrix here since it's no longer needed
var ret=invert(perspectiveMatrix,perspectiveMatrix);if(!ret)return false;transpose(perspectiveMatrix,perspectiveMatrix);//multiply by transposed inverse perspective matrix, into perspective vec4
vec4multMat4(perspective,tmpVec4,perspectiveMatrix);}else{//no perspective
perspective[0]=perspective[1]=perspective[2]=0;perspective[3]=1;}// Next take care of translation
translation[0]=a30;translation[1]=a31;translation[2]=a32;// Now get scale and shear. 'row' is a 3 element array of 3 component vectors
mat3from4(row,tmp);// Compute X scale factor and normalize first row.
scale[0]=vec3.length(row[0]);vec3.normalize(row[0],row[0]);// Compute XY shear factor and make 2nd row orthogonal to 1st.
skew[0]=vec3.dot(row[0],row[1]);combine(row[1],row[1],row[0],1.0,-skew[0]);// Now, compute Y scale and normalize 2nd row.
scale[1]=vec3.length(row[1]);vec3.normalize(row[1],row[1]);skew[0]/=scale[1];// Compute XZ and YZ shears, orthogonalize 3rd row
skew[1]=vec3.dot(row[0],row[2]);combine(row[2],row[2],row[0],1.0,-skew[1]);skew[2]=vec3.dot(row[1],row[2]);combine(row[2],row[2],row[1],1.0,-skew[2]);// Next, get Z scale and normalize 3rd row.
scale[2]=vec3.length(row[2]);vec3.normalize(row[2],row[2]);skew[1]/=scale[2];skew[2]/=scale[2];// At this point, the matrix (in rows) is orthonormal.
// Check for a coordinate system flip.  If the determinant
// is -1, then negate the matrix and the scaling factors.
vec3.cross(pdum3,row[1],row[2]);if(vec3.dot(row[0],pdum3)<0){for(var i=0;i<3;i++){scale[i]*=-1;row[i][0]*=-1;row[i][1]*=-1;row[i][2]*=-1;}}// Now, get the rotations out
quaternion[0]=0.5*Math.sqrt(Math.max(1+row[0][0]-row[1][1]-row[2][2],0));quaternion[1]=0.5*Math.sqrt(Math.max(1-row[0][0]+row[1][1]-row[2][2],0));quaternion[2]=0.5*Math.sqrt(Math.max(1-row[0][0]-row[1][1]+row[2][2],0));quaternion[3]=0.5*Math.sqrt(Math.max(1+row[0][0]+row[1][1]+row[2][2],0));if(row[2][1]>row[1][2])quaternion[0]=-quaternion[0];if(row[0][2]>row[2][0])quaternion[1]=-quaternion[1];if(row[1][0]>row[0][1])quaternion[2]=-quaternion[2];return true;};//will be replaced by gl-vec4 eventually
function vec4multMat4(out,a,m){var x=a[0],y=a[1],z=a[2],w=a[3];out[0]=m[0]*x+m[4]*y+m[8]*z+m[12]*w;out[1]=m[1]*x+m[5]*y+m[9]*z+m[13]*w;out[2]=m[2]*x+m[6]*y+m[10]*z+m[14]*w;out[3]=m[3]*x+m[7]*y+m[11]*z+m[15]*w;return out;}//gets upper-left of a 4x4 matrix into a 3x3 of vectors
function mat3from4(out,mat4x4){out[0][0]=mat4x4[0];out[0][1]=mat4x4[1];out[0][2]=mat4x4[2];out[1][0]=mat4x4[4];out[1][1]=mat4x4[5];out[1][2]=mat4x4[6];out[2][0]=mat4x4[8];out[2][1]=mat4x4[9];out[2][2]=mat4x4[10];}function combine(out,a,b,scale1,scale2){out[0]=a[0]*scale1+b[0]*scale2;out[1]=a[1]*scale1+b[1]*scale2;out[2]=a[2]*scale1+b[2]*scale2;}/***/}),/***/4335:(/***/function(module){module.exports=function normalize(out,mat){var m44=mat[15];// Cannot normalize.
if(m44===0)return false;var scale=1/m44;for(var i=0;i<16;i++)out[i]=mat[i]*scale;return true;};/***/}),/***/7442:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_656261__){var lerp=__nested_webpack_require_656261__(6658);var recompose=__nested_webpack_require_656261__(7182);var decompose=__nested_webpack_require_656261__(2652);var determinant=__nested_webpack_require_656261__(9921);var slerp=__nested_webpack_require_656261__(8648);var state0=state();var state1=state();var tmp=state();module.exports=interpolate;function interpolate(out,start,end,alpha){if(determinant(start)===0||determinant(end)===0)return false;//decompose the start and end matrices into individual components
var r0=decompose(start,state0.translate,state0.scale,state0.skew,state0.perspective,state0.quaternion);var r1=decompose(end,state1.translate,state1.scale,state1.skew,state1.perspective,state1.quaternion);if(!r0||!r1)return false;//now lerp/slerp the start and end components into a temporary     lerp(tmptranslate, state0.translate, state1.translate, alpha)
lerp(tmp.translate,state0.translate,state1.translate,alpha);lerp(tmp.skew,state0.skew,state1.skew,alpha);lerp(tmp.scale,state0.scale,state1.scale,alpha);lerp(tmp.perspective,state0.perspective,state1.perspective,alpha);slerp(tmp.quaternion,state0.quaternion,state1.quaternion,alpha);//and recompose into our 'out' matrix
recompose(out,tmp.translate,tmp.scale,tmp.skew,tmp.perspective,tmp.quaternion);return true;}function state(){return{translate:vec3(),scale:vec3(1),skew:vec3(),perspective:vec4(),quaternion:vec4()};}function vec3(n){return[n||0,n||0,n||0];}function vec4(){return[0,0,0,1];}/***/}),/***/7182:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_657741__){/*
Input:  translation ; a 3 component vector
        scale       ; a 3 component vector
        skew        ; skew factors XY,XZ,YZ represented as a 3 component vector
        perspective ; a 4 component vector
        quaternion  ; a 4 component vector
Output: matrix      ; a 4x4 matrix

From: http://www.w3.org/TR/css3-transforms/#recomposing-to-a-3d-matrix
*/var mat4={identity:__nested_webpack_require_657741__(7894),translate:__nested_webpack_require_657741__(7656),multiply:__nested_webpack_require_657741__(6760),create:__nested_webpack_require_657741__(6864),scale:__nested_webpack_require_657741__(2504),fromRotationTranslation:__nested_webpack_require_657741__(6743)};var rotationMatrix=mat4.create();var temp=mat4.create();module.exports=function recomposeMat4(matrix,translation,scale,skew,perspective,quaternion){mat4.identity(matrix);//apply translation & rotation
mat4.fromRotationTranslation(matrix,quaternion,translation);//apply perspective
matrix[3]=perspective[0];matrix[7]=perspective[1];matrix[11]=perspective[2];matrix[15]=perspective[3];// apply skew
// temp is a identity 4x4 matrix initially
mat4.identity(temp);if(skew[2]!==0){temp[9]=skew[2];mat4.multiply(matrix,matrix,temp);}if(skew[1]!==0){temp[9]=0;temp[8]=skew[1];mat4.multiply(matrix,matrix,temp);}if(skew[0]!==0){temp[8]=0;temp[4]=skew[0];mat4.multiply(matrix,matrix,temp);}//apply scale
mat4.scale(matrix,matrix,scale);return matrix;};/***/}),/***/4192:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_659166__){"use strict";var bsearch=__nested_webpack_require_659166__(2478);var m4interp=__nested_webpack_require_659166__(7442);var invert44=__nested_webpack_require_659166__(7608);var rotateX=__nested_webpack_require_659166__(5567);var rotateY=__nested_webpack_require_659166__(2408);var rotateZ=__nested_webpack_require_659166__(7089);var lookAt=__nested_webpack_require_659166__(6582);var translate=__nested_webpack_require_659166__(7656);var scale=__nested_webpack_require_659166__(2504);var normalize=__nested_webpack_require_659166__(3536);var DEFAULT_CENTER=[0,0,0];module.exports=createMatrixCameraController;function MatrixCameraController(initialMatrix){this._components=initialMatrix.slice();this._time=[0];this.prevMatrix=initialMatrix.slice();this.nextMatrix=initialMatrix.slice();this.computedMatrix=initialMatrix.slice();this.computedInverse=initialMatrix.slice();this.computedEye=[0,0,0];this.computedUp=[0,0,0];this.computedCenter=[0,0,0];this.computedRadius=[0];this._limits=[-Infinity,Infinity];}var proto=MatrixCameraController.prototype;proto.recalcMatrix=function(t){var time=this._time;var tidx=bsearch.le(time,t);var mat=this.computedMatrix;if(tidx<0){return;}var comps=this._components;if(tidx===time.length-1){var ptr=16*tidx;for(var i=0;i<16;++i){mat[i]=comps[ptr++];}}else{var dt=time[tidx+1]-time[tidx];var ptr=16*tidx;var prev=this.prevMatrix;var allEqual=true;for(var i=0;i<16;++i){prev[i]=comps[ptr++];}var next=this.nextMatrix;for(var i=0;i<16;++i){next[i]=comps[ptr++];allEqual=allEqual&&prev[i]===next[i];}if(dt<1e-6||allEqual){for(var i=0;i<16;++i){mat[i]=prev[i];}}else{m4interp(mat,prev,next,(t-time[tidx])/dt);}}var up=this.computedUp;up[0]=mat[1];up[1]=mat[5];up[2]=mat[9];normalize(up,up);var imat=this.computedInverse;invert44(imat,mat);var eye=this.computedEye;var w=imat[15];eye[0]=imat[12]/w;eye[1]=imat[13]/w;eye[2]=imat[14]/w;var center=this.computedCenter;var radius=Math.exp(this.computedRadius[0]);for(var i=0;i<3;++i){center[i]=eye[i]-mat[2+4*i]*radius;}};proto.idle=function(t){if(t<this.lastT()){return;}var mc=this._components;var ptr=mc.length-16;for(var i=0;i<16;++i){mc.push(mc[ptr++]);}this._time.push(t);};proto.flush=function(t){var idx=bsearch.gt(this._time,t)-2;if(idx<0){return;}this._time.splice(0,idx);this._components.splice(0,16*idx);};proto.lastT=function(){return this._time[this._time.length-1];};proto.lookAt=function(t,eye,center,up){this.recalcMatrix(t);eye=eye||this.computedEye;center=center||DEFAULT_CENTER;up=up||this.computedUp;this.setMatrix(t,lookAt(this.computedMatrix,eye,center,up));var d2=0.0;for(var i=0;i<3;++i){d2+=Math.pow(center[i]-eye[i],2);}d2=Math.log(Math.sqrt(d2));this.computedRadius[0]=d2;};proto.rotate=function(t,yaw,pitch,roll){this.recalcMatrix(t);var mat=this.computedInverse;if(yaw)rotateY(mat,mat,yaw);if(pitch)rotateX(mat,mat,pitch);if(roll)rotateZ(mat,mat,roll);this.setMatrix(t,invert44(this.computedMatrix,mat));};var tvec=[0,0,0];proto.pan=function(t,dx,dy,dz){tvec[0]=-(dx||0.0);tvec[1]=-(dy||0.0);tvec[2]=-(dz||0.0);this.recalcMatrix(t);var mat=this.computedInverse;translate(mat,mat,tvec);this.setMatrix(t,invert44(mat,mat));};proto.translate=function(t,dx,dy,dz){tvec[0]=dx||0.0;tvec[1]=dy||0.0;tvec[2]=dz||0.0;this.recalcMatrix(t);var mat=this.computedMatrix;translate(mat,mat,tvec);this.setMatrix(t,mat);};proto.setMatrix=function(t,mat){if(t<this.lastT()){return;}this._time.push(t);for(var i=0;i<16;++i){this._components.push(mat[i]);}};proto.setDistance=function(t,d){this.computedRadius[0]=d;};proto.setDistanceLimits=function(a,b){var lim=this._limits;lim[0]=a;lim[1]=b;};proto.getDistanceLimits=function(out){var lim=this._limits;if(out){out[0]=lim[0];out[1]=lim[1];return out;}return lim;};function createMatrixCameraController(options){options=options||{};var matrix=options.matrix||[1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1];return new MatrixCameraController(matrix);}/***/}),/***/3090:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_662984__){"use strict";module.exports=monotoneConvexHull2D;var orient=__nested_webpack_require_662984__(3250)[3];function monotoneConvexHull2D(points){var n=points.length;if(n<3){var result=new Array(n);for(var i=0;i<n;++i){result[i]=i;}if(n===2&&points[0][0]===points[1][0]&&points[0][1]===points[1][1]){return[0];}return result;}//Sort point indices along x-axis
var sorted=new Array(n);for(var i=0;i<n;++i){sorted[i]=i;}sorted.sort(function(a,b){var d=points[a][0]-points[b][0];if(d){return d;}return points[a][1]-points[b][1];});//Construct upper and lower hulls
var lower=[sorted[0],sorted[1]];var upper=[sorted[0],sorted[1]];for(var i=2;i<n;++i){var idx=sorted[i];var p=points[idx];//Insert into lower list
var m=lower.length;while(m>1&&orient(points[lower[m-2]],points[lower[m-1]],p)<=0){m-=1;lower.pop();}lower.push(idx);//Insert into upper list
m=upper.length;while(m>1&&orient(points[upper[m-2]],points[upper[m-1]],p)>=0){m-=1;upper.pop();}upper.push(idx);}//Merge lists together
var result=new Array(upper.length+lower.length-2);var ptr=0;for(var i=0,nl=lower.length;i<nl;++i){result[ptr++]=lower[i];}for(var j=upper.length-2;j>0;--j){result[ptr++]=upper[j];}//Return result
return result;}/***/}),/***/351:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_664246__){"use strict";module.exports=mouseListen;var mouse=__nested_webpack_require_664246__(4687);function mouseListen(element,callback){if(!callback){callback=element;element=window;}var buttonState=0;var x=0;var y=0;var mods={shift:false,alt:false,control:false,meta:false};var attached=false;function updateMods(ev){var changed=false;if('altKey'in ev){changed=changed||ev.altKey!==mods.alt;mods.alt=!!ev.altKey;}if('shiftKey'in ev){changed=changed||ev.shiftKey!==mods.shift;mods.shift=!!ev.shiftKey;}if('ctrlKey'in ev){changed=changed||ev.ctrlKey!==mods.control;mods.control=!!ev.ctrlKey;}if('metaKey'in ev){changed=changed||ev.metaKey!==mods.meta;mods.meta=!!ev.metaKey;}return changed;}function handleEvent(nextButtons,ev){var nextX=mouse.x(ev);var nextY=mouse.y(ev);if('buttons'in ev){nextButtons=ev.buttons|0;}if(nextButtons!==buttonState||nextX!==x||nextY!==y||updateMods(ev)){buttonState=nextButtons|0;x=nextX||0;y=nextY||0;callback&&callback(buttonState,x,y,mods);}}function clearState(ev){handleEvent(0,ev);}function handleBlur(){if(buttonState||x||y||mods.shift||mods.alt||mods.meta||mods.control){x=y=0;buttonState=0;mods.shift=mods.alt=mods.control=mods.meta=false;callback&&callback(0,0,0,mods);}}function handleMods(ev){if(updateMods(ev)){callback&&callback(buttonState,x,y,mods);}}function handleMouseMove(ev){if(mouse.buttons(ev)===0){handleEvent(0,ev);}else{handleEvent(buttonState,ev);}}function handleMouseDown(ev){handleEvent(buttonState|mouse.buttons(ev),ev);}function handleMouseUp(ev){handleEvent(buttonState&~mouse.buttons(ev),ev);}function attachListeners(){if(attached){return;}attached=true;element.addEventListener('mousemove',handleMouseMove);element.addEventListener('mousedown',handleMouseDown);element.addEventListener('mouseup',handleMouseUp);element.addEventListener('mouseleave',clearState);element.addEventListener('mouseenter',clearState);element.addEventListener('mouseout',clearState);element.addEventListener('mouseover',clearState);element.addEventListener('blur',handleBlur);element.addEventListener('keyup',handleMods);element.addEventListener('keydown',handleMods);element.addEventListener('keypress',handleMods);if(element!==window){window.addEventListener('blur',handleBlur);window.addEventListener('keyup',handleMods);window.addEventListener('keydown',handleMods);window.addEventListener('keypress',handleMods);}}function detachListeners(){if(!attached){return;}attached=false;element.removeEventListener('mousemove',handleMouseMove);element.removeEventListener('mousedown',handleMouseDown);element.removeEventListener('mouseup',handleMouseUp);element.removeEventListener('mouseleave',clearState);element.removeEventListener('mouseenter',clearState);element.removeEventListener('mouseout',clearState);element.removeEventListener('mouseover',clearState);element.removeEventListener('blur',handleBlur);element.removeEventListener('keyup',handleMods);element.removeEventListener('keydown',handleMods);element.removeEventListener('keypress',handleMods);if(element!==window){window.removeEventListener('blur',handleBlur);window.removeEventListener('keyup',handleMods);window.removeEventListener('keydown',handleMods);window.removeEventListener('keypress',handleMods);}}// Attach listeners
attachListeners();var result={element:element};Object.defineProperties(result,{enabled:{get:function(){return attached;},set:function(f){if(f){attachListeners();}else{detachListeners();}},enumerable:true},buttons:{get:function(){return buttonState;},enumerable:true},x:{get:function(){return x;},enumerable:true},y:{get:function(){return y;},enumerable:true},mods:{get:function(){return mods;},enumerable:true}});return result;}/***/}),/***/24:(/***/function(module){var rootPosition={left:0,top:0};module.exports=mouseEventOffset;function mouseEventOffset(ev,target,out){target=target||ev.currentTarget||ev.srcElement;if(!Array.isArray(out)){out=[0,0];}var cx=ev.clientX||0;var cy=ev.clientY||0;var rect=getBoundingClientOffset(target);out[0]=cx-rect.left;out[1]=cy-rect.top;return out;}function getBoundingClientOffset(element){if(element===window||element===document||element===document.body){return rootPosition;}else{return element.getBoundingClientRect();}}/***/}),/***/4687:(/***/function(__unused_webpack_module,exports){"use strict";function mouseButtons(ev){if(typeof ev==='object'){if('buttons'in ev){return ev.buttons;}else if('which'in ev){var b=ev.which;if(b===2){return 4;}else if(b===3){return 2;}else if(b>0){return 1<<b-1;}}else if('button'in ev){var b=ev.button;if(b===1){return 4;}else if(b===2){return 2;}else if(b>=0){return 1<<b;}}}return 0;}exports.buttons=mouseButtons;function mouseElement(ev){return ev.target||ev.srcElement||window;}exports.element=mouseElement;function mouseRelativeX(ev){if(typeof ev==='object'){if('offsetX'in ev){return ev.offsetX;}var target=mouseElement(ev);var bounds=target.getBoundingClientRect();return ev.clientX-bounds.left;}return 0;}exports.x=mouseRelativeX;function mouseRelativeY(ev){if(typeof ev==='object'){if('offsetY'in ev){return ev.offsetY;}var target=mouseElement(ev);var bounds=target.getBoundingClientRect();return ev.clientY-bounds.top;}return 0;}exports.y=mouseRelativeY;/***/}),/***/8512:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_669486__){"use strict";var toPX=__nested_webpack_require_669486__(665);module.exports=mouseWheelListen;function mouseWheelListen(element,callback,noScroll){if(typeof element==='function'){noScroll=!!callback;callback=element;element=window;}var lineHeight=toPX('ex',element);var listener=function(ev){if(noScroll){ev.preventDefault();}var dx=ev.deltaX||0;var dy=ev.deltaY||0;var dz=ev.deltaZ||0;var mode=ev.deltaMode;var scale=1;switch(mode){case 1:scale=lineHeight;break;case 2:scale=window.innerHeight;break;}dx*=scale;dy*=scale;dz*=scale;if(dx||dy||dz){return callback(dx,dy,dz,ev);}};element.addEventListener('wheel',listener);return listener;}/***/}),/***/2640:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_670196__){"use strict";var pool=__nested_webpack_require_670196__(1888);module.exports=createSurfaceExtractor;var allFns={"false,0,1":function surfaceProcedure(vertex,face,phase,mallocUint32,freeUint32){return function extractContour0_1(a0,x0,x1,x2){var s0=a0.shape[0]|0,s1=a0.shape[1]|0,d0=a0.data,o0=a0.offset|0,t0_0=a0.stride[0]|0,t0_1=a0.stride[1]|0,p0=o0,c0_0,d0_1=-t0_0|0,c0_1=0,d0_2=-t0_1|0,c0_2=0,d0_3=-t0_0-t0_1|0,c0_3=0,u0_0=t0_0|0,u0_1=t0_1-t0_0*s0|0,i0=0,i1=0,N=0,Q=2*s0|0,P=mallocUint32(Q),V=mallocUint32(Q),X=0,b0=0,e1=-1|0,y1=-1|0,b1=0,e2=-s0|0,y2=s0|0,b2=0,e3=-s0-1|0,y3=s0-1|0,b3=0,v0=0,T=0;for(i0=0;i0<s0;++i0){P[X++]=phase(d0[p0],x0,x1,x2);p0+=u0_0;}p0+=u0_1;if(s1>0){i1=1;P[X++]=phase(d0[p0],x0,x1,x2);p0+=u0_0;if(s0>0){i0=1;c0_0=d0[p0];b0=P[X]=phase(c0_0,x0,x1,x2);b1=P[X+e1];b2=P[X+e2];b3=P[X+e3];if(b0!==b1||b0!==b2||b0!==b3){c0_1=d0[p0+d0_1];c0_2=d0[p0+d0_2];c0_3=d0[p0+d0_3];vertex(i0,i1,c0_0,c0_1,c0_2,c0_3,b0,b1,b2,b3,x0,x1,x2);v0=V[X]=N++;}X+=1;p0+=u0_0;for(i0=2;i0<s0;++i0){c0_0=d0[p0];b0=P[X]=phase(c0_0,x0,x1,x2);b1=P[X+e1];b2=P[X+e2];b3=P[X+e3];if(b0!==b1||b0!==b2||b0!==b3){c0_1=d0[p0+d0_1];c0_2=d0[p0+d0_2];c0_3=d0[p0+d0_3];vertex(i0,i1,c0_0,c0_1,c0_2,c0_3,b0,b1,b2,b3,x0,x1,x2);v0=V[X]=N++;if(b3!==b1){face(V[X+e1],v0,c0_3,c0_1,b3,b1,x0,x1,x2);}}X+=1;p0+=u0_0;}}p0+=u0_1;X=0;T=e1;e1=y1;y1=T;T=e2;e2=y2;y2=T;T=e3;e3=y3;y3=T;for(i1=2;i1<s1;++i1){P[X++]=phase(d0[p0],x0,x1,x2);p0+=u0_0;if(s0>0){i0=1;c0_0=d0[p0];b0=P[X]=phase(c0_0,x0,x1,x2);b1=P[X+e1];b2=P[X+e2];b3=P[X+e3];if(b0!==b1||b0!==b2||b0!==b3){c0_1=d0[p0+d0_1];c0_2=d0[p0+d0_2];c0_3=d0[p0+d0_3];vertex(i0,i1,c0_0,c0_1,c0_2,c0_3,b0,b1,b2,b3,x0,x1,x2);v0=V[X]=N++;if(b3!==b2){face(V[X+e2],v0,c0_2,c0_3,b2,b3,x0,x1,x2);}}X+=1;p0+=u0_0;for(i0=2;i0<s0;++i0){c0_0=d0[p0];b0=P[X]=phase(c0_0,x0,x1,x2);b1=P[X+e1];b2=P[X+e2];b3=P[X+e3];if(b0!==b1||b0!==b2||b0!==b3){c0_1=d0[p0+d0_1];c0_2=d0[p0+d0_2];c0_3=d0[p0+d0_3];vertex(i0,i1,c0_0,c0_1,c0_2,c0_3,b0,b1,b2,b3,x0,x1,x2);v0=V[X]=N++;if(b3!==b2){face(V[X+e2],v0,c0_2,c0_3,b2,b3,x0,x1,x2);}if(b3!==b1){face(V[X+e1],v0,c0_3,c0_1,b3,b1,x0,x1,x2);}}X+=1;p0+=u0_0;}}if(i1&1){X=0;}T=e1;e1=y1;y1=T;T=e2;e2=y2;y2=T;T=e3;e3=y3;y3=T;p0+=u0_1;}}freeUint32(V);freeUint32(P);};},"false,1,0":function anonymous(vertex,face,phase,mallocUint32,freeUint32){return function extractContour1_0(a0,x0,x1,x2){var s0=a0.shape[0]|0,s1=a0.shape[1]|0,d0=a0.data,o0=a0.offset|0,t0_0=a0.stride[0]|0,t0_1=a0.stride[1]|0,p0=o0,c0_0,d0_1=-t0_0|0,c0_1=0,d0_2=-t0_1|0,c0_2=0,d0_3=-t0_0-t0_1|0,c0_3=0,u0_1=t0_1|0,u0_0=t0_0-t0_1*s1|0,i0=0,i1=0,N=0,Q=2*s1|0,P=mallocUint32(Q),V=mallocUint32(Q),X=0,b0=0,e2=-1|0,y2=-1|0,b2=0,e1=-s1|0,y1=s1|0,b1=0,e3=-s1-1|0,y3=s1-1|0,b3=0,v0=0,T=0;for(i1=0;i1<s1;++i1){P[X++]=phase(d0[p0],x0,x1,x2);p0+=u0_1;}p0+=u0_0;if(s0>0){i0=1;P[X++]=phase(d0[p0],x0,x1,x2);p0+=u0_1;if(s1>0){i1=1;c0_0=d0[p0];b0=P[X]=phase(c0_0,x0,x1,x2);b1=P[X+e1];b2=P[X+e2];b3=P[X+e3];if(b0!==b1||b0!==b2||b0!==b3){c0_1=d0[p0+d0_1];c0_2=d0[p0+d0_2];c0_3=d0[p0+d0_3];vertex(i0,i1,c0_0,c0_1,c0_2,c0_3,b0,b1,b2,b3,x0,x1,x2);v0=V[X]=N++;}X+=1;p0+=u0_1;for(i1=2;i1<s1;++i1){c0_0=d0[p0];b0=P[X]=phase(c0_0,x0,x1,x2);b1=P[X+e1];b2=P[X+e2];b3=P[X+e3];if(b0!==b1||b0!==b2||b0!==b3){c0_1=d0[p0+d0_1];c0_2=d0[p0+d0_2];c0_3=d0[p0+d0_3];vertex(i0,i1,c0_0,c0_1,c0_2,c0_3,b0,b1,b2,b3,x0,x1,x2);v0=V[X]=N++;if(b3!==b2){face(V[X+e2],v0,c0_2,c0_3,b2,b3,x0,x1,x2);}}X+=1;p0+=u0_1;}}p0+=u0_0;X=0;T=e1;e1=y1;y1=T;T=e2;e2=y2;y2=T;T=e3;e3=y3;y3=T;for(i0=2;i0<s0;++i0){P[X++]=phase(d0[p0],x0,x1,x2);p0+=u0_1;if(s1>0){i1=1;c0_0=d0[p0];b0=P[X]=phase(c0_0,x0,x1,x2);b1=P[X+e1];b2=P[X+e2];b3=P[X+e3];if(b0!==b1||b0!==b2||b0!==b3){c0_1=d0[p0+d0_1];c0_2=d0[p0+d0_2];c0_3=d0[p0+d0_3];vertex(i0,i1,c0_0,c0_1,c0_2,c0_3,b0,b1,b2,b3,x0,x1,x2);v0=V[X]=N++;if(b3!==b1){face(V[X+e1],v0,c0_3,c0_1,b3,b1,x0,x1,x2);}}X+=1;p0+=u0_1;for(i1=2;i1<s1;++i1){c0_0=d0[p0];b0=P[X]=phase(c0_0,x0,x1,x2);b1=P[X+e1];b2=P[X+e2];b3=P[X+e3];if(b0!==b1||b0!==b2||b0!==b3){c0_1=d0[p0+d0_1];c0_2=d0[p0+d0_2];c0_3=d0[p0+d0_3];vertex(i0,i1,c0_0,c0_1,c0_2,c0_3,b0,b1,b2,b3,x0,x1,x2);v0=V[X]=N++;if(b3!==b2){face(V[X+e2],v0,c0_2,c0_3,b2,b3,x0,x1,x2);}if(b3!==b1){face(V[X+e1],v0,c0_3,c0_1,b3,b1,x0,x1,x2);}}X+=1;p0+=u0_1;}}if(i0&1){X=0;}T=e1;e1=y1;y1=T;T=e2;e2=y2;y2=T;T=e3;e3=y3;y3=T;p0+=u0_0;}}freeUint32(V);freeUint32(P);};}};//Generates the surface procedure
function compileSurfaceProcedure(vertexFunc,faceFunc,phaseFunc,scalarArgs,order,typesig){var key=[typesig,order].join(',');var proc=allFns[key];return proc(vertexFunc,faceFunc,phaseFunc,pool.mallocUint32,pool.freeUint32);}function createSurfaceExtractor(args){function error(msg){throw new Error("ndarray-extract-contour: "+msg);}if(typeof args!=="object"){error("Must specify arguments");}var order=args.order;if(!Array.isArray(order)){error("Must specify order");}var arrays=args.arrayArguments||1;if(arrays<1){error("Must have at least one array argument");}var scalars=args.scalarArguments||0;if(scalars<0){error("Scalar arg count must be > 0");}if(typeof args.vertex!=="function"){error("Must specify vertex creation function");}if(typeof args.cell!=="function"){error("Must specify cell creation function");}if(typeof args.phase!=="function"){error("Must specify phase function");}var getters=args.getters||[];var typesig=new Array(arrays);for(var i=0;i<arrays;++i){if(getters.indexOf(i)>=0){typesig[i]=true;}else{typesig[i]=false;}}return compileSurfaceProcedure(args.vertex,args.cell,args.phase,scalars,order,typesig);}/***/}),/***/6199:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_675689__){"use strict";var dup=__nested_webpack_require_675689__(1338);var CACHED_CWiseOp={zero:function(SS,a0,t0,p0){var s0=SS[0],t0p0=t0[0];p0|=0;var i0=0,d0s0=t0p0;for(i0=0;i0<s0;++i0){a0[p0]=0;p0+=d0s0;}},fdTemplate1:function(SS,a0,t0,p0,a1,t1,p1){var s0=SS[0],t0p0=t0[0],t1p0=t1[0],q0=-1*t0p0,q1=t0p0;p0|=0;p1|=0;var i0=0,d0s0=t0p0,d1s0=t1p0;for(i0=0;i0<s0;++i0){a1[p1]=0.5*(a0[p0+q0]-a0[p0+q1]);p0+=d0s0;p1+=d1s0;}},fdTemplate2:function(SS,a0,t0,p0,a1,t1,p1,a2,t2,p2){var s0=SS[0],s1=SS[1],t0p0=t0[0],t0p1=t0[1],t1p0=t1[0],t1p1=t1[1],t2p0=t2[0],t2p1=t2[1],q0=-1*t0p0,q1=t0p0,q2=-1*t0p1,q3=t0p1;p0|=0;p1|=0;p2|=0;var i0=0,i1=0,d0s0=t0p1,d0s1=t0p0-s1*t0p1,d1s0=t1p1,d1s1=t1p0-s1*t1p1,d2s0=t2p1,d2s1=t2p0-s1*t2p1;for(i1=0;i1<s0;++i1){for(i0=0;i0<s1;++i0){a1[p1]=0.5*(a0[p0+q0]-a0[p0+q1]);a2[p2]=0.5*(a0[p0+q2]-a0[p0+q3]);p0+=d0s0;p1+=d1s0;p2+=d2s0;}p0+=d0s1;p1+=d1s1;p2+=d2s1;}}};var CACHED_thunk={cdiff:function(compile){var CACHED={};return function cdiff_cwise_thunk(array0,array1,array2){var t0=array0.dtype,r0=array0.order,t1=array1.dtype,r1=array1.order,t2=array2.dtype,r2=array2.order,type=[t0,r0.join(),t1,r1.join(),t2,r2.join()].join(),proc=CACHED[type];if(!proc){CACHED[type]=proc=compile([t0,r0,t1,r1,t2,r2]);}return proc(array0.shape.slice(0),array0.data,array0.stride,array0.offset|0,array1.data,array1.stride,array1.offset|0,array2.data,array2.stride,array2.offset|0);};},zero:function(compile){var CACHED={};return function zero_cwise_thunk(array0){var t0=array0.dtype,r0=array0.order,type=[t0,r0.join()].join(),proc=CACHED[type];if(!proc){CACHED[type]=proc=compile([t0,r0]);}return proc(array0.shape.slice(0),array0.data,array0.stride,array0.offset|0);};},fdTemplate1:function(compile){var CACHED={};return function fdTemplate1_cwise_thunk(array0,array1){var t0=array0.dtype,r0=array0.order,t1=array1.dtype,r1=array1.order,type=[t0,r0.join(),t1,r1.join()].join(),proc=CACHED[type];if(!proc){CACHED[type]=proc=compile([t0,r0,t1,r1]);}return proc(array0.shape.slice(0),array0.data,array0.stride,array0.offset|0,array1.data,array1.stride,array1.offset|0);};},fdTemplate2:function(compile){var CACHED={};return function fdTemplate2_cwise_thunk(array0,array1,array4){var t0=array0.dtype,r0=array0.order,t1=array1.dtype,r1=array1.order,t4=array4.dtype,r4=array4.order,type=[t0,r0.join(),t1,r1.join(),t4,r4.join()].join(),proc=CACHED[type];if(!proc){CACHED[type]=proc=compile([t0,r0,t1,r1,t4,r4]);}return proc(array0.shape.slice(0),array0.data,array0.stride,array0.offset|0,array1.data,array1.stride,array1.offset|0,array4.data,array4.stride,array4.offset|0);};}};function createThunk(proc){var thunk=CACHED_thunk[proc.funcName];return thunk(compile.bind(undefined,proc));}function compile(proc){return CACHED_CWiseOp[proc.funcName];}function cwiseCompiler(user_args){return createThunk({funcName:user_args.funcName});}var TEMPLATE_CACHE={};var GRADIENT_CACHE={};var EmptyProc={body:"",args:[],thisVars:[],localVars:[]};var centralDiff=cwiseCompiler({funcName:'cdiff'});var zeroOut=cwiseCompiler({funcName:'zero'});function generateTemplate(d){if(d in TEMPLATE_CACHE){return TEMPLATE_CACHE[d];}return TEMPLATE_CACHE[d]=cwiseCompiler({funcName:'fdTemplate'+d});}function CACHED_link(diff,zero,grad1,grad2){return function(dst,src){var s=src.shape.slice();if( true&&s[0]>2&&s[1]>2){grad2(src.pick(-1,-1).lo(1,1).hi(s[0]-2,s[1]-2),dst.pick(-1,-1,0).lo(1,1).hi(s[0]-2,s[1]-2),dst.pick(-1,-1,1).lo(1,1).hi(s[0]-2,s[1]-2));}if( true&&s[1]>2){grad1(src.pick(0,-1).lo(1).hi(s[1]-2),dst.pick(0,-1,1).lo(1).hi(s[1]-2));zero(dst.pick(0,-1,0).lo(1).hi(s[1]-2));}if( true&&s[1]>2){grad1(src.pick(s[0]-1,-1).lo(1).hi(s[1]-2),dst.pick(s[0]-1,-1,1).lo(1).hi(s[1]-2));zero(dst.pick(s[0]-1,-1,0).lo(1).hi(s[1]-2));}if( true&&s[0]>2){grad1(src.pick(-1,0).lo(1).hi(s[0]-2),dst.pick(-1,0,0).lo(1).hi(s[0]-2));zero(dst.pick(-1,0,1).lo(1).hi(s[0]-2));}if( true&&s[0]>2){grad1(src.pick(-1,s[1]-1).lo(1).hi(s[0]-2),dst.pick(-1,s[1]-1,0).lo(1).hi(s[0]-2));zero(dst.pick(-1,s[1]-1,1).lo(1).hi(s[0]-2));}dst.set(0,0,0,0);dst.set(0,0,1,0);dst.set(s[0]-1,0,0,0);dst.set(s[0]-1,0,1,0);dst.set(0,s[1]-1,0,0);dst.set(0,s[1]-1,1,0);dst.set(s[0]-1,s[1]-1,0,0);dst.set(s[0]-1,s[1]-1,1,0);return dst;};}function generateGradient(boundaryConditions){var token=boundaryConditions.join();var proc=GRADIENT_CACHE[token];if(proc){return proc;}var d=boundaryConditions.length;var linkArgs=[centralDiff,zeroOut];for(var i=1;i<=d;++i){linkArgs.push(generateTemplate(i));}var link=CACHED_link;var proc=link.apply(void 0,linkArgs);GRADIENT_CACHE[token]=proc;return proc;}module.exports=function gradient(out,inp,bc){if(!Array.isArray(bc)){if(typeof bc==='string'){bc=dup(inp.dimension,bc);}else{bc=dup(inp.dimension,'clamp');}}if(inp.size===0){return out;}if(inp.dimension===0){out.set(0);return out;}var cached=generateGradient(bc);return cached(out,inp);};/***/}),/***/4317:(/***/function(module){"use strict";function interp1d(arr,x){var ix=Math.floor(x),fx=x-ix,s0=0<=ix&&ix<arr.shape[0],s1=0<=ix+1&&ix+1<arr.shape[0],w0=s0?+arr.get(ix):0.0,w1=s1?+arr.get(ix+1):0.0;return(1.0-fx)*w0+fx*w1;}function interp2d(arr,x,y){var ix=Math.floor(x),fx=x-ix,s0=0<=ix&&ix<arr.shape[0],s1=0<=ix+1&&ix+1<arr.shape[0],iy=Math.floor(y),fy=y-iy,t0=0<=iy&&iy<arr.shape[1],t1=0<=iy+1&&iy+1<arr.shape[1],w00=s0&&t0?arr.get(ix,iy):0.0,w01=s0&&t1?arr.get(ix,iy+1):0.0,w10=s1&&t0?arr.get(ix+1,iy):0.0,w11=s1&&t1?arr.get(ix+1,iy+1):0.0;return(1.0-fy)*((1.0-fx)*w00+fx*w10)+fy*((1.0-fx)*w01+fx*w11);}function interp3d(arr,x,y,z){var ix=Math.floor(x),fx=x-ix,s0=0<=ix&&ix<arr.shape[0],s1=0<=ix+1&&ix+1<arr.shape[0],iy=Math.floor(y),fy=y-iy,t0=0<=iy&&iy<arr.shape[1],t1=0<=iy+1&&iy+1<arr.shape[1],iz=Math.floor(z),fz=z-iz,u0=0<=iz&&iz<arr.shape[2],u1=0<=iz+1&&iz+1<arr.shape[2],w000=s0&&t0&&u0?arr.get(ix,iy,iz):0.0,w010=s0&&t1&&u0?arr.get(ix,iy+1,iz):0.0,w100=s1&&t0&&u0?arr.get(ix+1,iy,iz):0.0,w110=s1&&t1&&u0?arr.get(ix+1,iy+1,iz):0.0,w001=s0&&t0&&u1?arr.get(ix,iy,iz+1):0.0,w011=s0&&t1&&u1?arr.get(ix,iy+1,iz+1):0.0,w101=s1&&t0&&u1?arr.get(ix+1,iy,iz+1):0.0,w111=s1&&t1&&u1?arr.get(ix+1,iy+1,iz+1):0.0;return(1.0-fz)*((1.0-fy)*((1.0-fx)*w000+fx*w100)+fy*((1.0-fx)*w010+fx*w110))+fz*((1.0-fy)*((1.0-fx)*w001+fx*w101)+fy*((1.0-fx)*w011+fx*w111));}function interpNd(arr){var d=arr.shape.length|0,ix=new Array(d),fx=new Array(d),s0=new Array(d),s1=new Array(d),i,t;for(i=0;i<d;++i){t=+arguments[i+1];ix[i]=Math.floor(t);fx[i]=t-ix[i];s0[i]=0<=ix[i]&&ix[i]<arr.shape[i];s1[i]=0<=ix[i]+1&&ix[i]+1<arr.shape[i];}var r=0.0,j,w,idx;i_loop:for(i=0;i<1<<d;++i){w=1.0;idx=arr.offset;for(j=0;j<d;++j){if(i&1<<j){if(!s1[j]){continue i_loop;}w*=fx[j];idx+=arr.stride[j]*(ix[j]+1);}else{if(!s0[j]){continue i_loop;}w*=1.0-fx[j];idx+=arr.stride[j]*ix[j];}}r+=w*arr.data[idx];}return r;}function interpolate(arr,x,y,z){switch(arr.shape.length){case 0:return 0.0;case 1:return interp1d(arr,x);case 2:return interp2d(arr,x,y);case 3:return interp3d(arr,x,y,z);default:return interpNd.apply(undefined,arguments);}}module.exports=interpolate;module.exports.d1=interp1d;module.exports.d2=interp2d;module.exports.d3=interp3d;/***/}),/***/5298:(/***/function(__unused_webpack_module,exports){"use strict";var CACHED_CWiseOp={'float64,2,1,0':function(){return function divseq_cwise_loop_2s1s0m3f64(SS,a0,t0,p0,Y0){var s0=SS[0],s1=SS[1],s2=SS[2],t0p0=t0[0],t0p1=t0[1],t0p2=t0[2];p0|=0;var i0=0,i1=0,i2=0,d0s0=t0p2,d0s1=t0p1-s2*t0p2,d0s2=t0p0-s1*t0p1;for(i2=0;i2<s0;++i2){for(i1=0;i1<s1;++i1){for(i0=0;i0<s2;++i0){a0[p0]/=Y0;p0+=d0s0;}p0+=d0s1;}p0+=d0s2;}};},'uint8,2,0,1,float64,2,1,0':function(){return function muls_cwise_loop_2s0s1m1u8f64(SS,a0,t0,p0,a1,t1,p1,Y0){var s0=SS[0],s1=SS[1],s2=SS[2],t0p0=t0[0],t0p1=t0[1],t0p2=t0[2],t1p0=t1[0],t1p1=t1[1],t1p2=t1[2];p0|=0;p1|=0;var offset0=p0;var offset1=p1;for(var j1=SS[0]|0;j1>0;){if(j1<64){s0=j1;j1=0;}else{s0=64;j1-=64;}for(var j2=SS[1]|0;j2>0;){if(j2<64){s1=j2;j2=0;}else{s1=64;j2-=64;}p0=offset0+j1*t0p0+j2*t0p1;p1=offset1+j1*t1p0+j2*t1p1;var i0=0,i1=0,i2=0,d0s0=t0p2,d0s1=t0p0-s2*t0p2,d0s2=t0p1-s0*t0p0,d1s0=t1p2,d1s1=t1p0-s2*t1p2,d1s2=t1p1-s0*t1p0;for(i2=0;i2<s1;++i2){for(i1=0;i1<s0;++i1){for(i0=0;i0<s2;++i0){a0[p0]=a1[p1]*Y0;p0+=d0s0;p1+=d1s0;}p0+=d0s1;p1+=d1s1;}p0+=d0s2;p1+=d1s2;}}}};},'float32,1,0,float32,1,0':function(){return function assign_cwise_loop_1s0m2f32(SS,a0,t0,p0,a1,t1,p1){var s0=SS[0],s1=SS[1],t0p0=t0[0],t0p1=t0[1],t1p0=t1[0],t1p1=t1[1];p0|=0;p1|=0;var i0=0,i1=0,d0s0=t0p1,d0s1=t0p0-s1*t0p1,d1s0=t1p1,d1s1=t1p0-s1*t1p1;for(i1=0;i1<s0;++i1){for(i0=0;i0<s1;++i0){a0[p0]=a1[p1];p0+=d0s0;p1+=d1s0;}p0+=d0s1;p1+=d1s1;}};},'float32,1,0,float32,0,1':function(){return function assign_cwise_loop_1s0m0f32(SS,a0,t0,p0,a1,t1,p1){var s0=SS[0],s1=SS[1],t0p0=t0[0],t0p1=t0[1],t1p0=t1[0],t1p1=t1[1];p0|=0;p1|=0;var offset0=p0;var offset1=p1;for(var j0=SS[1]|0;j0>0;){if(j0<64){s1=j0;j0=0;}else{s1=64;j0-=64;}for(var j1=SS[0]|0;j1>0;){if(j1<64){s0=j1;j1=0;}else{s0=64;j1-=64;}p0=offset0+j0*t0p1+j1*t0p0;p1=offset1+j0*t1p1+j1*t1p0;var i0=0,i1=0,d0s0=t0p1,d0s1=t0p0-s1*t0p1,d1s0=t1p1,d1s1=t1p0-s1*t1p1;for(i1=0;i1<s0;++i1){for(i0=0;i0<s1;++i0){a0[p0]=a1[p1];p0+=d0s0;p1+=d1s0;}p0+=d0s1;p1+=d1s1;}}}};},'uint8,2,0,1,uint8,1,2,0':function(){return function assign_cwise_loop_2s0s1m0u8(SS,a0,t0,p0,a1,t1,p1){var s0=SS[0],s1=SS[1],s2=SS[2],t0p0=t0[0],t0p1=t0[1],t0p2=t0[2],t1p0=t1[0],t1p1=t1[1],t1p2=t1[2];p0|=0;p1|=0;var offset0=p0;var offset1=p1;for(var j0=SS[2]|0;j0>0;){if(j0<64){s2=j0;j0=0;}else{s2=64;j0-=64;}for(var j1=SS[0]|0;j1>0;){if(j1<64){s0=j1;j1=0;}else{s0=64;j1-=64;}for(var j2=SS[1]|0;j2>0;){if(j2<64){s1=j2;j2=0;}else{s1=64;j2-=64;}p0=offset0+j0*t0p2+j1*t0p0+j2*t0p1;p1=offset1+j0*t1p2+j1*t1p0+j2*t1p1;var i0=0,i1=0,i2=0,d0s0=t0p2,d0s1=t0p0-s2*t0p2,d0s2=t0p1-s0*t0p0,d1s0=t1p2,d1s1=t1p0-s2*t1p2,d1s2=t1p1-s0*t1p0;for(i2=0;i2<s1;++i2){for(i1=0;i1<s0;++i1){for(i0=0;i0<s2;++i0){a0[p0]=a1[p1];p0+=d0s0;p1+=d1s0;}p0+=d0s1;p1+=d1s1;}p0+=d0s2;p1+=d1s2;}}}}};},'uint8,2,0,1,array,2,0,1':function(){return function assign_cwise_loop_2s0s1m3u8a(SS,a0,t0,p0,a1,t1,p1){var s0=SS[0],s1=SS[1],s2=SS[2],t0p0=t0[0],t0p1=t0[1],t0p2=t0[2],t1p0=t1[0],t1p1=t1[1],t1p2=t1[2];p0|=0;p1|=0;var i0=0,i1=0,i2=0,d0s0=t0p2,d0s1=t0p0-s2*t0p2,d0s2=t0p1-s0*t0p0,d1s0=t1p2,d1s1=t1p0-s2*t1p2,d1s2=t1p1-s0*t1p0;for(i2=0;i2<s1;++i2){for(i1=0;i1<s0;++i1){for(i0=0;i0<s2;++i0){a0[p0]=a1[p1];p0+=d0s0;p1+=d1s0;}p0+=d0s1;p1+=d1s1;}p0+=d0s2;p1+=d1s2;}};}};//Generates a cwise operator
function generateCWiseOp(proc,typesig){var key=typesig.join(',');var f=CACHED_CWiseOp[key];return f();}var compile=generateCWiseOp;var CACHED_thunk={mul:function(compile){var CACHED={};return function mul_cwise_thunk(array0,array1,array2){var t0=array0.dtype,r0=array0.order,t1=array1.dtype,r1=array1.order,t2=array2.dtype,r2=array2.order,type=[t0,r0.join(),t1,r1.join(),t2,r2.join()].join(),proc=CACHED[type];if(!proc){CACHED[type]=proc=compile([t0,r0,t1,r1,t2,r2]);}return proc(array0.shape.slice(0),array0.data,array0.stride,array0.offset|0,array1.data,array1.stride,array1.offset|0,array2.data,array2.stride,array2.offset|0);};},muls:function(compile){var CACHED={};return function muls_cwise_thunk(array0,array1,scalar2){var t0=array0.dtype,r0=array0.order,t1=array1.dtype,r1=array1.order,type=[t0,r0.join(),t1,r1.join()].join(),proc=CACHED[type];if(!proc){CACHED[type]=proc=compile([t0,r0,t1,r1]);}return proc(array0.shape.slice(0),array0.data,array0.stride,array0.offset|0,array1.data,array1.stride,array1.offset|0,scalar2);};},mulseq:function(compile){var CACHED={};return function mulseq_cwise_thunk(array0,scalar1){var t0=array0.dtype,r0=array0.order,type=[t0,r0.join()].join(),proc=CACHED[type];if(!proc){CACHED[type]=proc=compile([t0,r0]);}return proc(array0.shape.slice(0),array0.data,array0.stride,array0.offset|0,scalar1);};},div:function(compile){var CACHED={};return function div_cwise_thunk(array0,array1,array2){var t0=array0.dtype,r0=array0.order,t1=array1.dtype,r1=array1.order,t2=array2.dtype,r2=array2.order,type=[t0,r0.join(),t1,r1.join(),t2,r2.join()].join(),proc=CACHED[type];if(!proc){CACHED[type]=proc=compile([t0,r0,t1,r1,t2,r2]);}return proc(array0.shape.slice(0),array0.data,array0.stride,array0.offset|0,array1.data,array1.stride,array1.offset|0,array2.data,array2.stride,array2.offset|0);};},divs:function(compile){var CACHED={};return function divs_cwise_thunk(array0,array1,scalar2){var t0=array0.dtype,r0=array0.order,t1=array1.dtype,r1=array1.order,type=[t0,r0.join(),t1,r1.join()].join(),proc=CACHED[type];if(!proc){CACHED[type]=proc=compile([t0,r0,t1,r1]);}return proc(array0.shape.slice(0),array0.data,array0.stride,array0.offset|0,array1.data,array1.stride,array1.offset|0,scalar2);};},divseq:function(compile){var CACHED={};return function divseq_cwise_thunk(array0,scalar1){var t0=array0.dtype,r0=array0.order,type=[t0,r0.join()].join(),proc=CACHED[type];if(!proc){CACHED[type]=proc=compile([t0,r0]);}return proc(array0.shape.slice(0),array0.data,array0.stride,array0.offset|0,scalar1);};},assign:function(compile){var CACHED={};return function assign_cwise_thunk(array0,array1){var t0=array0.dtype,r0=array0.order,t1=array1.dtype,r1=array1.order,type=[t0,r0.join(),t1,r1.join()].join(),proc=CACHED[type];if(!proc){CACHED[type]=proc=compile([t0,r0,t1,r1]);}return proc(array0.shape.slice(0),array0.data,array0.stride,array0.offset|0,array1.data,array1.stride,array1.offset|0);};}};function createThunk(proc){var thunk=CACHED_thunk[proc.funcName];return thunk(compile.bind(undefined,proc));}function makeOp(user_args){return createThunk({funcName:user_args.funcName});}var assign_ops={mul:"*",div:"/"};(function(){for(var id in assign_ops){exports[id]=makeOp({funcName:id});exports[id+"s"]=makeOp({funcName:id+"s"});exports[id+"seq"]=makeOp({funcName:id+"seq"});}})();exports.assign=makeOp({funcName:"assign"});/***/}),/***/9994:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_689439__){"use strict";var ndarray=__nested_webpack_require_689439__(9618);var do_convert=__nested_webpack_require_689439__(8277);module.exports=function convert(arr,result){var shape=[],c=arr,sz=1;while(Array.isArray(c)){shape.push(c.length);sz*=c.length;c=c[0];}if(shape.length===0){return ndarray();}if(!result){result=ndarray(new Float64Array(sz),shape);}do_convert(result,arr);return result;};/***/}),/***/8277:(/***/function(module){"use strict";function CwiseOp(){return function(SS,a0,t0,p0,Y0){var s0=SS[0],s1=SS[1],s2=SS[2],t0p0=t0[0],t0p1=t0[1],t0p2=t0[2],index=[0,0,0];p0|=0;var i0=0,i1=0,i2=0,d0s0=t0p2,d0s1=t0p1-s2*t0p2,d0s2=t0p0-s1*t0p1;for(i2=0;i2<s0;++i2){for(i1=0;i1<s1;++i1){for(i0=0;i0<s2;++i0){{var _inline_1_v=Y0,_inline_1_i;for(_inline_1_i=0;_inline_1_i<index.length-1;++_inline_1_i){_inline_1_v=_inline_1_v[index[_inline_1_i]];}a0[p0]=_inline_1_v[index[index.length-1]];}p0+=d0s0;++index[2];}p0+=d0s1;index[2]-=s2;++index[1];}p0+=d0s2;index[1]-=s1;++index[0];}};}//Generates a cwise operator
function generateCWiseOp(){return CwiseOp();}var compile=generateCWiseOp;function thunk(compile){var CACHED={};return function convert_cwise_thunk(array0,scalar1){var t0=array0.dtype,r0=array0.order,type=[t0,r0.join()].join(),proc=CACHED[type];if(!proc){CACHED[type]=proc=compile([t0,r0]);}return proc(array0.shape.slice(0),array0.data,array0.stride,array0.offset|0,scalar1);};}function createThunk(proc){return thunk(compile.bind(undefined,proc));}function compileCwise(user_args){return createThunk({funcName:user_args.funcName});}module.exports=compileCwise({funcName:"convert"});/***/}),/***/7640:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_691086__){"use strict";var pool=__nested_webpack_require_691086__(1888);function getMallocFree(dtype){switch(dtype){case"uint32":return[pool.mallocUint32,pool.freeUint32];default:return null;}}var CACHED_insertionSort={"uint32,1,0":function(malloc,free){return function ndarrayInsertionSort1d0uint32(left,right,data,offset,s0,s1,n0,n1,d1,e1,f1){var i,j,cptr,ptr=left*s0+offset,i1,scratch=malloc(n1),dptr,sptr,a,b;for(i=left+1;i<=right;++i){j=i;ptr+=s0;cptr=ptr;dptr=0;sptr=ptr;for(i1=0;i1<n1;++i1){scratch[dptr++]=data[sptr];sptr+=d1;}__g:while(j-->left){dptr=0;sptr=cptr-s0;__l:for(i1=0;i1<n1;++i1){a=data[sptr];b=scratch[dptr];if(a<b){break __g;}if(a>b){break __l;}sptr+=e1;dptr+=f1;}dptr=cptr;sptr=cptr-s0;for(i1=0;i1<n1;++i1){data[dptr]=data[sptr];dptr+=d1;sptr+=d1;}cptr-=s0;}dptr=cptr;sptr=0;for(i1=0;i1<n1;++i1){data[dptr]=scratch[sptr++];dptr+=d1;}}free(scratch);};}};function createInsertionSort(order,dtype){var allocator=getMallocFree(dtype);var key=[dtype,order].join(',');var result=CACHED_insertionSort[key];if(allocator){return result(allocator[0],allocator[1]);}else{return result();}}var CACHED_quickSort={"uint32,1,0":function(insertionSort,malloc,free){return function ndarrayQuickSort1d0uint32(left,right,data,offset,s0,s1,n0,n1,d1,e1,f1){var sixth=(right-left+1)/6|0,index1=left+sixth,index5=right-sixth,index3=left+right>>1,index2=index3-sixth,index4=index3+sixth,el1=index1,el2=index2,el3=index3,el4=index4,el5=index5,less=left+1,great=right-1,pivots_are_equal=true,tmp,tmp0,x,y,z,k,ptr0,ptr1,ptr2,comp_pivot1=0,comp_pivot2=0,comp=0,i1,b_ptr0,b_ptr1,b_ptr2,b_ptr3,b_ptr4,b_ptr5,b_ptr6,b_ptr7,ptr3,ptr4,ptr5,ptr6,ptr7,pivot_ptr,ptr_shift,elementSize=n1,pivot1=malloc(elementSize),pivot2=malloc(elementSize);b_ptr0=s0*el1;b_ptr1=s0*el2;ptr_shift=offset;__l1:for(i1=0;i1<n1;++i1){ptr0=b_ptr0+ptr_shift;ptr1=b_ptr1+ptr_shift;comp=data[ptr0]-data[ptr1];if(comp>0){tmp0=el1;el1=el2;el2=tmp0;break __l1;}if(comp<0){break __l1;}ptr_shift+=e1;}b_ptr0=s0*el4;b_ptr1=s0*el5;ptr_shift=offset;__l2:for(i1=0;i1<n1;++i1){ptr0=b_ptr0+ptr_shift;ptr1=b_ptr1+ptr_shift;comp=data[ptr0]-data[ptr1];if(comp>0){tmp0=el4;el4=el5;el5=tmp0;break __l2;}if(comp<0){break __l2;}ptr_shift+=e1;}b_ptr0=s0*el1;b_ptr1=s0*el3;ptr_shift=offset;__l3:for(i1=0;i1<n1;++i1){ptr0=b_ptr0+ptr_shift;ptr1=b_ptr1+ptr_shift;comp=data[ptr0]-data[ptr1];if(comp>0){tmp0=el1;el1=el3;el3=tmp0;break __l3;}if(comp<0){break __l3;}ptr_shift+=e1;}b_ptr0=s0*el2;b_ptr1=s0*el3;ptr_shift=offset;__l4:for(i1=0;i1<n1;++i1){ptr0=b_ptr0+ptr_shift;ptr1=b_ptr1+ptr_shift;comp=data[ptr0]-data[ptr1];if(comp>0){tmp0=el2;el2=el3;el3=tmp0;break __l4;}if(comp<0){break __l4;}ptr_shift+=e1;}b_ptr0=s0*el1;b_ptr1=s0*el4;ptr_shift=offset;__l5:for(i1=0;i1<n1;++i1){ptr0=b_ptr0+ptr_shift;ptr1=b_ptr1+ptr_shift;comp=data[ptr0]-data[ptr1];if(comp>0){tmp0=el1;el1=el4;el4=tmp0;break __l5;}if(comp<0){break __l5;}ptr_shift+=e1;}b_ptr0=s0*el3;b_ptr1=s0*el4;ptr_shift=offset;__l6:for(i1=0;i1<n1;++i1){ptr0=b_ptr0+ptr_shift;ptr1=b_ptr1+ptr_shift;comp=data[ptr0]-data[ptr1];if(comp>0){tmp0=el3;el3=el4;el4=tmp0;break __l6;}if(comp<0){break __l6;}ptr_shift+=e1;}b_ptr0=s0*el2;b_ptr1=s0*el5;ptr_shift=offset;__l7:for(i1=0;i1<n1;++i1){ptr0=b_ptr0+ptr_shift;ptr1=b_ptr1+ptr_shift;comp=data[ptr0]-data[ptr1];if(comp>0){tmp0=el2;el2=el5;el5=tmp0;break __l7;}if(comp<0){break __l7;}ptr_shift+=e1;}b_ptr0=s0*el2;b_ptr1=s0*el3;ptr_shift=offset;__l8:for(i1=0;i1<n1;++i1){ptr0=b_ptr0+ptr_shift;ptr1=b_ptr1+ptr_shift;comp=data[ptr0]-data[ptr1];if(comp>0){tmp0=el2;el2=el3;el3=tmp0;break __l8;}if(comp<0){break __l8;}ptr_shift+=e1;}b_ptr0=s0*el4;b_ptr1=s0*el5;ptr_shift=offset;__l9:for(i1=0;i1<n1;++i1){ptr0=b_ptr0+ptr_shift;ptr1=b_ptr1+ptr_shift;comp=data[ptr0]-data[ptr1];if(comp>0){tmp0=el4;el4=el5;el5=tmp0;break __l9;}if(comp<0){break __l9;}ptr_shift+=e1;}b_ptr0=s0*el1;b_ptr1=s0*el2;b_ptr2=s0*el3;b_ptr3=s0*el4;b_ptr4=s0*el5;b_ptr5=s0*index1;b_ptr6=s0*index3;b_ptr7=s0*index5;pivot_ptr=0;ptr_shift=offset;for(i1=0;i1<n1;++i1){ptr0=b_ptr0+ptr_shift;ptr1=b_ptr1+ptr_shift;ptr2=b_ptr2+ptr_shift;ptr3=b_ptr3+ptr_shift;ptr4=b_ptr4+ptr_shift;ptr5=b_ptr5+ptr_shift;ptr6=b_ptr6+ptr_shift;ptr7=b_ptr7+ptr_shift;pivot1[pivot_ptr]=data[ptr1];pivot2[pivot_ptr]=data[ptr3];pivots_are_equal=pivots_are_equal&&pivot1[pivot_ptr]===pivot2[pivot_ptr];x=data[ptr0];y=data[ptr2];z=data[ptr4];data[ptr5]=x;data[ptr6]=y;data[ptr7]=z;++pivot_ptr;ptr_shift+=d1;}b_ptr0=s0*index2;b_ptr1=s0*left;ptr_shift=offset;for(i1=0;i1<n1;++i1){ptr0=b_ptr0+ptr_shift;ptr1=b_ptr1+ptr_shift;data[ptr0]=data[ptr1];ptr_shift+=d1;}b_ptr0=s0*index4;b_ptr1=s0*right;ptr_shift=offset;for(i1=0;i1<n1;++i1){ptr0=b_ptr0+ptr_shift;ptr1=b_ptr1+ptr_shift;data[ptr0]=data[ptr1];ptr_shift+=d1;}if(pivots_are_equal){for(k=less;k<=great;++k){ptr0=offset+k*s0;pivot_ptr=0;__l10:for(i1=0;i1<n1;++i1){comp=data[ptr0]-pivot1[pivot_ptr];if(comp!==0){break __l10;}pivot_ptr+=f1;ptr0+=e1;}if(comp===0){continue;}if(comp<0){if(k!==less){b_ptr0=s0*k;b_ptr1=s0*less;ptr_shift=offset;for(i1=0;i1<n1;++i1){ptr0=b_ptr0+ptr_shift;ptr1=b_ptr1+ptr_shift;tmp=data[ptr0];data[ptr0]=data[ptr1];data[ptr1]=tmp;ptr_shift+=d1;}}++less;}else{while(true){ptr0=offset+great*s0;pivot_ptr=0;__l11:for(i1=0;i1<n1;++i1){comp=data[ptr0]-pivot1[pivot_ptr];if(comp!==0){break __l11;}pivot_ptr+=f1;ptr0+=e1;}if(comp>0){great--;}else if(comp<0){b_ptr0=s0*k;b_ptr1=s0*less;b_ptr2=s0*great;ptr_shift=offset;for(i1=0;i1<n1;++i1){ptr0=b_ptr0+ptr_shift;ptr1=b_ptr1+ptr_shift;ptr2=b_ptr2+ptr_shift;tmp=data[ptr0];data[ptr0]=data[ptr1];data[ptr1]=data[ptr2];data[ptr2]=tmp;ptr_shift+=d1;}++less;--great;break;}else{b_ptr0=s0*k;b_ptr1=s0*great;ptr_shift=offset;for(i1=0;i1<n1;++i1){ptr0=b_ptr0+ptr_shift;ptr1=b_ptr1+ptr_shift;tmp=data[ptr0];data[ptr0]=data[ptr1];data[ptr1]=tmp;ptr_shift+=d1;}--great;break;}}}}}else{for(k=less;k<=great;++k){ptr0=offset+k*s0;pivot_ptr=0;__l12:for(i1=0;i1<n1;++i1){comp_pivot1=data[ptr0]-pivot1[pivot_ptr];if(comp_pivot1!==0){break __l12;}pivot_ptr+=f1;ptr0+=e1;}if(comp_pivot1<0){if(k!==less){b_ptr0=s0*k;b_ptr1=s0*less;ptr_shift=offset;for(i1=0;i1<n1;++i1){ptr0=b_ptr0+ptr_shift;ptr1=b_ptr1+ptr_shift;tmp=data[ptr0];data[ptr0]=data[ptr1];data[ptr1]=tmp;ptr_shift+=d1;}}++less;}else{ptr0=offset+k*s0;pivot_ptr=0;__l13:for(i1=0;i1<n1;++i1){comp_pivot2=data[ptr0]-pivot2[pivot_ptr];if(comp_pivot2!==0){break __l13;}pivot_ptr+=f1;ptr0+=e1;}if(comp_pivot2>0){while(true){ptr0=offset+great*s0;pivot_ptr=0;__l14:for(i1=0;i1<n1;++i1){comp=data[ptr0]-pivot2[pivot_ptr];if(comp!==0){break __l14;}pivot_ptr+=f1;ptr0+=e1;}if(comp>0){if(--great<k){break;}continue;}else{ptr0=offset+great*s0;pivot_ptr=0;__l15:for(i1=0;i1<n1;++i1){comp=data[ptr0]-pivot1[pivot_ptr];if(comp!==0){break __l15;}pivot_ptr+=f1;ptr0+=e1;}if(comp<0){b_ptr0=s0*k;b_ptr1=s0*less;b_ptr2=s0*great;ptr_shift=offset;for(i1=0;i1<n1;++i1){ptr0=b_ptr0+ptr_shift;ptr1=b_ptr1+ptr_shift;ptr2=b_ptr2+ptr_shift;tmp=data[ptr0];data[ptr0]=data[ptr1];data[ptr1]=data[ptr2];data[ptr2]=tmp;ptr_shift+=d1;}++less;--great;}else{b_ptr0=s0*k;b_ptr1=s0*great;ptr_shift=offset;for(i1=0;i1<n1;++i1){ptr0=b_ptr0+ptr_shift;ptr1=b_ptr1+ptr_shift;tmp=data[ptr0];data[ptr0]=data[ptr1];data[ptr1]=tmp;ptr_shift+=d1;}--great;}break;}}}}}}b_ptr0=s0*left;b_ptr1=s0*(less-1);pivot_ptr=0;ptr_shift=offset;for(i1=0;i1<n1;++i1){ptr0=b_ptr0+ptr_shift;ptr1=b_ptr1+ptr_shift;data[ptr0]=data[ptr1];data[ptr1]=pivot1[pivot_ptr];++pivot_ptr;ptr_shift+=d1;}b_ptr0=s0*right;b_ptr1=s0*(great+1);pivot_ptr=0;ptr_shift=offset;for(i1=0;i1<n1;++i1){ptr0=b_ptr0+ptr_shift;ptr1=b_ptr1+ptr_shift;data[ptr0]=data[ptr1];data[ptr1]=pivot2[pivot_ptr];++pivot_ptr;ptr_shift+=d1;}if(less-2-left<=32){insertionSort(left,less-2,data,offset,s0,s1,n0,n1,d1,e1,f1);}else{ndarrayQuickSort1d0uint32(left,less-2,data,offset,s0,s1,n0,n1,d1,e1,f1);}if(right-(great+2)<=32){insertionSort(great+2,right,data,offset,s0,s1,n0,n1,d1,e1,f1);}else{ndarrayQuickSort1d0uint32(great+2,right,data,offset,s0,s1,n0,n1,d1,e1,f1);}if(pivots_are_equal){free(pivot1);free(pivot2);return;}if(less<index1&&great>index5){__l16:while(true){ptr0=offset+less*s0;pivot_ptr=0;ptr_shift=offset;for(i1=0;i1<n1;++i1){if(data[ptr0]!==pivot1[pivot_ptr]){break __l16;}++pivot_ptr;ptr0+=d1;}++less;}__l17:while(true){ptr0=offset+great*s0;pivot_ptr=0;ptr_shift=offset;for(i1=0;i1<n1;++i1){if(data[ptr0]!==pivot2[pivot_ptr]){break __l17;}++pivot_ptr;ptr0+=d1;}--great;}for(k=less;k<=great;++k){ptr0=offset+k*s0;pivot_ptr=0;__l18:for(i1=0;i1<n1;++i1){comp_pivot1=data[ptr0]-pivot1[pivot_ptr];if(comp_pivot1!==0){break __l18;}pivot_ptr+=f1;ptr0+=e1;}if(comp_pivot1===0){if(k!==less){b_ptr0=s0*k;b_ptr1=s0*less;ptr_shift=offset;for(i1=0;i1<n1;++i1){ptr0=b_ptr0+ptr_shift;ptr1=b_ptr1+ptr_shift;tmp=data[ptr0];data[ptr0]=data[ptr1];data[ptr1]=tmp;ptr_shift+=d1;}}++less;}else{ptr0=offset+k*s0;pivot_ptr=0;__l19:for(i1=0;i1<n1;++i1){comp_pivot2=data[ptr0]-pivot2[pivot_ptr];if(comp_pivot2!==0){break __l19;}pivot_ptr+=f1;ptr0+=e1;}if(comp_pivot2===0){while(true){ptr0=offset+great*s0;pivot_ptr=0;__l20:for(i1=0;i1<n1;++i1){comp=data[ptr0]-pivot2[pivot_ptr];if(comp!==0){break __l20;}pivot_ptr+=f1;ptr0+=e1;}if(comp===0){if(--great<k){break;}continue;}else{ptr0=offset+great*s0;pivot_ptr=0;__l21:for(i1=0;i1<n1;++i1){comp=data[ptr0]-pivot1[pivot_ptr];if(comp!==0){break __l21;}pivot_ptr+=f1;ptr0+=e1;}if(comp<0){b_ptr0=s0*k;b_ptr1=s0*less;b_ptr2=s0*great;ptr_shift=offset;for(i1=0;i1<n1;++i1){ptr0=b_ptr0+ptr_shift;ptr1=b_ptr1+ptr_shift;ptr2=b_ptr2+ptr_shift;tmp=data[ptr0];data[ptr0]=data[ptr1];data[ptr1]=data[ptr2];data[ptr2]=tmp;ptr_shift+=d1;}++less;--great;}else{b_ptr0=s0*k;b_ptr1=s0*great;ptr_shift=offset;for(i1=0;i1<n1;++i1){ptr0=b_ptr0+ptr_shift;ptr1=b_ptr1+ptr_shift;tmp=data[ptr0];data[ptr0]=data[ptr1];data[ptr1]=tmp;ptr_shift+=d1;}--great;}break;}}}}}}free(pivot1);free(pivot2);if(great-less<=32){insertionSort(less,great,data,offset,s0,s1,n0,n1,d1,e1,f1);}else{ndarrayQuickSort1d0uint32(less,great,data,offset,s0,s1,n0,n1,d1,e1,f1);}};}};function createQuickSort(order,dtype,insertionSort){var allocator=getMallocFree(dtype);var key=[dtype,order].join(',');var result=CACHED_quickSort[key];if(order.length>1&&allocator){return result(insertionSort,allocator[0],allocator[1]);}else{return result(insertionSort);}}var CACHED_sort={"uint32,1,0":function(insertionSort,quickSort){return function(array){var data=array.data,offset=array.offset|0,shape=array.shape,stride=array.stride,s0=stride[0]|0,n0=shape[0]|0,s1=stride[1]|0,n1=shape[1]|0,d1=s1,e1=s1,f1=1;if(n0<=32){insertionSort(0,n0-1,data,offset,s0,s1,n0,n1,d1,e1,f1);}else{quickSort(0,n0-1,data,offset,s0,s1,n0,n1,d1,e1,f1);}};}};function compileSort(order,dtype){var key=[dtype,order].join(',');var result=CACHED_sort[key];var insertionSort=createInsertionSort(order,dtype);var quickSort=createQuickSort(order,dtype,insertionSort);return result(insertionSort,quickSort);}module.exports=compileSort;/***/}),/***/446:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_701938__){"use strict";var compile=__nested_webpack_require_701938__(7640);var CACHE={};function sort(array){var order=array.order;var dtype=array.dtype;var typeSig=[order,dtype];var typeName=typeSig.join(":");var compiled=CACHE[typeName];if(!compiled){CACHE[typeName]=compiled=compile(order,dtype);}compiled(array);return array;}module.exports=sort;/***/}),/***/9618:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_702350__){var isBuffer=__nested_webpack_require_702350__(7163);var hasTypedArrays=typeof Float64Array!=="undefined";function compare1st(a,b){return a[0]-b[0];}function order(){var stride=this.stride;var terms=new Array(stride.length);var i;for(i=0;i<terms.length;++i){terms[i]=[Math.abs(stride[i]),i];}terms.sort(compare1st);var result=new Array(terms.length);for(i=0;i<result.length;++i){result[i]=terms[i][1];}return result;}var allFns={// Special case for trivial arrays
T:function(dtype){function View(a){this.data=a;}var proto=View.prototype;proto.dtype=dtype;proto.index=function(){return-1;};proto.size=0;proto.dimension=-1;proto.shape=proto.stride=proto.order=[];proto.lo=proto.hi=proto.transpose=proto.step=function(){return new View(this.data);};proto.get=proto.set=function(){};proto.pick=function(){return null;};return function construct(a){return new View(a);};},// Special case for 0d arrays
0:function(dtype,TrivialArray){function View(a,d){this.data=a;this.offset=d;}var proto=View.prototype;proto.dtype=dtype;proto.index=function(){return this.offset;};proto.dimension=0;proto.size=1;proto.shape=proto.stride=proto.order=[];proto.lo=proto.hi=proto.transpose=proto.step=function copy(){return new View(this.data,this.offset);};proto.pick=function pick(){return TrivialArray(this.data);};proto.valueOf=proto.get=function get(){return dtype==="generic"?this.data.get(this.offset):this.data[this.offset];};proto.set=function set(v){return dtype==="generic"?this.data.set(this.offset,v):this.data[this.offset]=v;};return function construct(a,b,c,d){return new View(a,d);};},1:function(dtype,CTOR_LIST,ORDER){function View(a,b0,c0,d){this.data=a;this.shape=[b0];this.stride=[c0];this.offset=d|0;}var proto=View.prototype;proto.dtype=dtype;proto.dimension=1;Object.defineProperty(proto,"size",{get:function size(){return this.shape[0];}});proto.order=[0];proto.set=function set(i0,v){return dtype==="generic"?this.data.set(this.offset+this.stride[0]*i0,v):this.data[this.offset+this.stride[0]*i0]=v;};proto.get=function get(i0){return dtype==="generic"?this.data.get(this.offset+this.stride[0]*i0):this.data[this.offset+this.stride[0]*i0];};proto.index=function index(i0){return this.offset+this.stride[0]*i0;};proto.hi=function hi(i0){return new View(this.data,typeof i0!=="number"||i0<0?this.shape[0]:i0|0,this.stride[0],this.offset);};proto.lo=function lo(i0){var b=this.offset,d=0,a0=this.shape[0],c0=this.stride[0];if(typeof i0==="number"&&i0>=0){d=i0|0;b+=c0*d;a0-=d;}return new View(this.data,a0,c0,b);};proto.step=function step(i0){var a0=this.shape[0],b0=this.stride[0],c=this.offset,d=0,ceil=Math.ceil;if(typeof i0==="number"){d=i0|0;if(d<0){c+=b0*(a0-1);a0=ceil(-a0/d);}else{a0=ceil(a0/d);}b0*=d;}return new View(this.data,a0,b0,c);};proto.transpose=function transpose(i0){i0=i0===undefined?0:i0|0;var a=this.shape,b=this.stride;return new View(this.data,a[i0],b[i0],this.offset);};proto.pick=function pick(i0){var a=[],b=[],c=this.offset;if(typeof i0==="number"&&i0>=0){c=c+this.stride[0]*i0|0;}else{a.push(this.shape[0]);b.push(this.stride[0]);}var ctor=CTOR_LIST[a.length+1];return ctor(this.data,a,b,c);};return function construct(data,shape,stride,offset){return new View(data,shape[0],stride[0],offset);};},2:function(dtype,CTOR_LIST,ORDER){function View(a,b0,b1,c0,c1,d){this.data=a;this.shape=[b0,b1];this.stride=[c0,c1];this.offset=d|0;}var proto=View.prototype;proto.dtype=dtype;proto.dimension=2;Object.defineProperty(proto,"size",{get:function size(){return this.shape[0]*this.shape[1];}});Object.defineProperty(proto,"order",{get:function order(){return Math.abs(this.stride[0])>Math.abs(this.stride[1])?[1,0]:[0,1];}});proto.set=function set(i0,i1,v){return dtype==="generic"?this.data.set(this.offset+this.stride[0]*i0+this.stride[1]*i1,v):this.data[this.offset+this.stride[0]*i0+this.stride[1]*i1]=v;};proto.get=function get(i0,i1){return dtype==="generic"?this.data.get(this.offset+this.stride[0]*i0+this.stride[1]*i1):this.data[this.offset+this.stride[0]*i0+this.stride[1]*i1];};proto.index=function index(i0,i1){return this.offset+this.stride[0]*i0+this.stride[1]*i1;};proto.hi=function hi(i0,i1){return new View(this.data,typeof i0!=="number"||i0<0?this.shape[0]:i0|0,typeof i1!=="number"||i1<0?this.shape[1]:i1|0,this.stride[0],this.stride[1],this.offset);};proto.lo=function lo(i0,i1){var b=this.offset,d=0,a0=this.shape[0],a1=this.shape[1],c0=this.stride[0],c1=this.stride[1];if(typeof i0==="number"&&i0>=0){d=i0|0;b+=c0*d;a0-=d;}if(typeof i1==="number"&&i1>=0){d=i1|0;b+=c1*d;a1-=d;}return new View(this.data,a0,a1,c0,c1,b);};proto.step=function step(i0,i1){var a0=this.shape[0],a1=this.shape[1],b0=this.stride[0],b1=this.stride[1],c=this.offset,d=0,ceil=Math.ceil;if(typeof i0==="number"){d=i0|0;if(d<0){c+=b0*(a0-1);a0=ceil(-a0/d);}else{a0=ceil(a0/d);}b0*=d;}if(typeof i1==="number"){d=i1|0;if(d<0){c+=b1*(a1-1);a1=ceil(-a1/d);}else{a1=ceil(a1/d);}b1*=d;}return new View(this.data,a0,a1,b0,b1,c);};proto.transpose=function transpose(i0,i1){i0=i0===undefined?0:i0|0;i1=i1===undefined?1:i1|0;var a=this.shape,b=this.stride;return new View(this.data,a[i0],a[i1],b[i0],b[i1],this.offset);};proto.pick=function pick(i0,i1){var a=[],b=[],c=this.offset;if(typeof i0==="number"&&i0>=0){c=c+this.stride[0]*i0|0;}else{a.push(this.shape[0]);b.push(this.stride[0]);}if(typeof i1==="number"&&i1>=0){c=c+this.stride[1]*i1|0;}else{a.push(this.shape[1]);b.push(this.stride[1]);}var ctor=CTOR_LIST[a.length+1];return ctor(this.data,a,b,c);};return function construct(data,shape,stride,offset){return new View(data,shape[0],shape[1],stride[0],stride[1],offset);};},3:function(dtype,CTOR_LIST,ORDER){function View(a,b0,b1,b2,c0,c1,c2,d){this.data=a;this.shape=[b0,b1,b2];this.stride=[c0,c1,c2];this.offset=d|0;}var proto=View.prototype;proto.dtype=dtype;proto.dimension=3;Object.defineProperty(proto,"size",{get:function size(){return this.shape[0]*this.shape[1]*this.shape[2];}});Object.defineProperty(proto,"order",{get:function order(){var s0=Math.abs(this.stride[0]),s1=Math.abs(this.stride[1]),s2=Math.abs(this.stride[2]);if(s0>s1){if(s1>s2){return[2,1,0];}else if(s0>s2){return[1,2,0];}else{return[1,0,2];}}else if(s0>s2){return[2,0,1];}else if(s2>s1){return[0,1,2];}else{return[0,2,1];}}});proto.set=function set(i0,i1,i2,v){return dtype==="generic"?this.data.set(this.offset+this.stride[0]*i0+this.stride[1]*i1+this.stride[2]*i2,v):this.data[this.offset+this.stride[0]*i0+this.stride[1]*i1+this.stride[2]*i2]=v;};proto.get=function get(i0,i1,i2){return dtype==="generic"?this.data.get(this.offset+this.stride[0]*i0+this.stride[1]*i1+this.stride[2]*i2):this.data[this.offset+this.stride[0]*i0+this.stride[1]*i1+this.stride[2]*i2];};proto.index=function index(i0,i1,i2){return this.offset+this.stride[0]*i0+this.stride[1]*i1+this.stride[2]*i2;};proto.hi=function hi(i0,i1,i2){return new View(this.data,typeof i0!=="number"||i0<0?this.shape[0]:i0|0,typeof i1!=="number"||i1<0?this.shape[1]:i1|0,typeof i2!=="number"||i2<0?this.shape[2]:i2|0,this.stride[0],this.stride[1],this.stride[2],this.offset);};proto.lo=function lo(i0,i1,i2){var b=this.offset,d=0,a0=this.shape[0],a1=this.shape[1],a2=this.shape[2],c0=this.stride[0],c1=this.stride[1],c2=this.stride[2];if(typeof i0==="number"&&i0>=0){d=i0|0;b+=c0*d;a0-=d;}if(typeof i1==="number"&&i1>=0){d=i1|0;b+=c1*d;a1-=d;}if(typeof i2==="number"&&i2>=0){d=i2|0;b+=c2*d;a2-=d;}return new View(this.data,a0,a1,a2,c0,c1,c2,b);};proto.step=function step(i0,i1,i2){var a0=this.shape[0],a1=this.shape[1],a2=this.shape[2],b0=this.stride[0],b1=this.stride[1],b2=this.stride[2],c=this.offset,d=0,ceil=Math.ceil;if(typeof i0==="number"){d=i0|0;if(d<0){c+=b0*(a0-1);a0=ceil(-a0/d);}else{a0=ceil(a0/d);}b0*=d;}if(typeof i1==="number"){d=i1|0;if(d<0){c+=b1*(a1-1);a1=ceil(-a1/d);}else{a1=ceil(a1/d);}b1*=d;}if(typeof i2==="number"){d=i2|0;if(d<0){c+=b2*(a2-1);a2=ceil(-a2/d);}else{a2=ceil(a2/d);}b2*=d;}return new View(this.data,a0,a1,a2,b0,b1,b2,c);};proto.transpose=function transpose(i0,i1,i2){i0=i0===undefined?0:i0|0;i1=i1===undefined?1:i1|0;i2=i2===undefined?2:i2|0;var a=this.shape,b=this.stride;return new View(this.data,a[i0],a[i1],a[i2],b[i0],b[i1],b[i2],this.offset);};proto.pick=function pick(i0,i1,i2){var a=[],b=[],c=this.offset;if(typeof i0==="number"&&i0>=0){c=c+this.stride[0]*i0|0;}else{a.push(this.shape[0]);b.push(this.stride[0]);}if(typeof i1==="number"&&i1>=0){c=c+this.stride[1]*i1|0;}else{a.push(this.shape[1]);b.push(this.stride[1]);}if(typeof i2==="number"&&i2>=0){c=c+this.stride[2]*i2|0;}else{a.push(this.shape[2]);b.push(this.stride[2]);}var ctor=CTOR_LIST[a.length+1];return ctor(this.data,a,b,c);};return function construct(data,shape,stride,offset){return new View(data,shape[0],shape[1],shape[2],stride[0],stride[1],stride[2],offset);};},4:function(dtype,CTOR_LIST,ORDER){function View(a,b0,b1,b2,b3,c0,c1,c2,c3,d){this.data=a;this.shape=[b0,b1,b2,b3];this.stride=[c0,c1,c2,c3];this.offset=d|0;}var proto=View.prototype;proto.dtype=dtype;proto.dimension=4;Object.defineProperty(proto,"size",{get:function size(){return this.shape[0]*this.shape[1]*this.shape[2]*this.shape[3];}});Object.defineProperty(proto,"order",{get:ORDER});proto.set=function set(i0,i1,i2,i3,v){return dtype==="generic"?this.data.set(this.offset+this.stride[0]*i0+this.stride[1]*i1+this.stride[2]*i2+this.stride[3]*i3,v):this.data[this.offset+this.stride[0]*i0+this.stride[1]*i1+this.stride[2]*i2+this.stride[3]*i3]=v;};proto.get=function get(i0,i1,i2,i3){return dtype==="generic"?this.data.get(this.offset+this.stride[0]*i0+this.stride[1]*i1+this.stride[2]*i2+this.stride[3]*i3):this.data[this.offset+this.stride[0]*i0+this.stride[1]*i1+this.stride[2]*i2+this.stride[3]*i3];};proto.index=function index(i0,i1,i2,i3){return this.offset+this.stride[0]*i0+this.stride[1]*i1+this.stride[2]*i2+this.stride[3]*i3;};proto.hi=function hi(i0,i1,i2,i3){return new View(this.data,typeof i0!=="number"||i0<0?this.shape[0]:i0|0,typeof i1!=="number"||i1<0?this.shape[1]:i1|0,typeof i2!=="number"||i2<0?this.shape[2]:i2|0,typeof i3!=="number"||i3<0?this.shape[3]:i3|0,this.stride[0],this.stride[1],this.stride[2],this.stride[3],this.offset);};proto.lo=function lo(i0,i1,i2,i3){var b=this.offset,d=0,a0=this.shape[0],a1=this.shape[1],a2=this.shape[2],a3=this.shape[3],c0=this.stride[0],c1=this.stride[1],c2=this.stride[2],c3=this.stride[3];if(typeof i0==="number"&&i0>=0){d=i0|0;b+=c0*d;a0-=d;}if(typeof i1==="number"&&i1>=0){d=i1|0;b+=c1*d;a1-=d;}if(typeof i2==="number"&&i2>=0){d=i2|0;b+=c2*d;a2-=d;}if(typeof i3==="number"&&i3>=0){d=i3|0;b+=c3*d;a3-=d;}return new View(this.data,a0,a1,a2,a3,c0,c1,c2,c3,b);};proto.step=function step(i0,i1,i2,i3){var a0=this.shape[0],a1=this.shape[1],a2=this.shape[2],a3=this.shape[3],b0=this.stride[0],b1=this.stride[1],b2=this.stride[2],b3=this.stride[3],c=this.offset,d=0,ceil=Math.ceil;if(typeof i0==="number"){d=i0|0;if(d<0){c+=b0*(a0-1);a0=ceil(-a0/d);}else{a0=ceil(a0/d);}b0*=d;}if(typeof i1==="number"){d=i1|0;if(d<0){c+=b1*(a1-1);a1=ceil(-a1/d);}else{a1=ceil(a1/d);}b1*=d;}if(typeof i2==="number"){d=i2|0;if(d<0){c+=b2*(a2-1);a2=ceil(-a2/d);}else{a2=ceil(a2/d);}b2*=d;}if(typeof i3==="number"){d=i3|0;if(d<0){c+=b3*(a3-1);a3=ceil(-a3/d);}else{a3=ceil(a3/d);}b3*=d;}return new View(this.data,a0,a1,a2,a3,b0,b1,b2,b3,c);};proto.transpose=function transpose(i0,i1,i2,i3){i0=i0===undefined?0:i0|0;i1=i1===undefined?1:i1|0;i2=i2===undefined?2:i2|0;i3=i3===undefined?3:i3|0;var a=this.shape,b=this.stride;return new View(this.data,a[i0],a[i1],a[i2],a[i3],b[i0],b[i1],b[i2],b[i3],this.offset);};proto.pick=function pick(i0,i1,i2,i3){var a=[],b=[],c=this.offset;if(typeof i0==="number"&&i0>=0){c=c+this.stride[0]*i0|0;}else{a.push(this.shape[0]);b.push(this.stride[0]);}if(typeof i1==="number"&&i1>=0){c=c+this.stride[1]*i1|0;}else{a.push(this.shape[1]);b.push(this.stride[1]);}if(typeof i2==="number"&&i2>=0){c=c+this.stride[2]*i2|0;}else{a.push(this.shape[2]);b.push(this.stride[2]);}if(typeof i3==="number"&&i3>=0){c=c+this.stride[3]*i3|0;}else{a.push(this.shape[3]);b.push(this.stride[3]);}var ctor=CTOR_LIST[a.length+1];return ctor(this.data,a,b,c);};return function construct(data,shape,stride,offset){return new View(data,shape[0],shape[1],shape[2],shape[3],stride[0],stride[1],stride[2],stride[3],offset);};},5:function anonymous(dtype,CTOR_LIST,ORDER){function View(a,b0,b1,b2,b3,b4,c0,c1,c2,c3,c4,d){this.data=a;this.shape=[b0,b1,b2,b3,b4];this.stride=[c0,c1,c2,c3,c4];this.offset=d|0;}var proto=View.prototype;proto.dtype=dtype;proto.dimension=5;Object.defineProperty(proto,"size",{get:function size(){return this.shape[0]*this.shape[1]*this.shape[2]*this.shape[3]*this.shape[4];}});Object.defineProperty(proto,"order",{get:ORDER});proto.set=function set(i0,i1,i2,i3,i4,v){return dtype==="generic"?this.data.set(this.offset+this.stride[0]*i0+this.stride[1]*i1+this.stride[2]*i2+this.stride[3]*i3+this.stride[4]*i4,v):this.data[this.offset+this.stride[0]*i0+this.stride[1]*i1+this.stride[2]*i2+this.stride[3]*i3+this.stride[4]*i4]=v;};proto.get=function get(i0,i1,i2,i3,i4){return dtype==="generic"?this.data.get(this.offset+this.stride[0]*i0+this.stride[1]*i1+this.stride[2]*i2+this.stride[3]*i3+this.stride[4]*i4):this.data[this.offset+this.stride[0]*i0+this.stride[1]*i1+this.stride[2]*i2+this.stride[3]*i3+this.stride[4]*i4];};proto.index=function index(i0,i1,i2,i3,i4){return this.offset+this.stride[0]*i0+this.stride[1]*i1+this.stride[2]*i2+this.stride[3]*i3+this.stride[4]*i4;};proto.hi=function hi(i0,i1,i2,i3,i4){return new View(this.data,typeof i0!=="number"||i0<0?this.shape[0]:i0|0,typeof i1!=="number"||i1<0?this.shape[1]:i1|0,typeof i2!=="number"||i2<0?this.shape[2]:i2|0,typeof i3!=="number"||i3<0?this.shape[3]:i3|0,typeof i4!=="number"||i4<0?this.shape[4]:i4|0,this.stride[0],this.stride[1],this.stride[2],this.stride[3],this.stride[4],this.offset);};proto.lo=function lo(i0,i1,i2,i3,i4){var b=this.offset,d=0,a0=this.shape[0],a1=this.shape[1],a2=this.shape[2],a3=this.shape[3],a4=this.shape[4],c0=this.stride[0],c1=this.stride[1],c2=this.stride[2],c3=this.stride[3],c4=this.stride[4];if(typeof i0==="number"&&i0>=0){d=i0|0;b+=c0*d;a0-=d;}if(typeof i1==="number"&&i1>=0){d=i1|0;b+=c1*d;a1-=d;}if(typeof i2==="number"&&i2>=0){d=i2|0;b+=c2*d;a2-=d;}if(typeof i3==="number"&&i3>=0){d=i3|0;b+=c3*d;a3-=d;}if(typeof i4==="number"&&i4>=0){d=i4|0;b+=c4*d;a4-=d;}return new View(this.data,a0,a1,a2,a3,a4,c0,c1,c2,c3,c4,b);};proto.step=function step(i0,i1,i2,i3,i4){var a0=this.shape[0],a1=this.shape[1],a2=this.shape[2],a3=this.shape[3],a4=this.shape[4],b0=this.stride[0],b1=this.stride[1],b2=this.stride[2],b3=this.stride[3],b4=this.stride[4],c=this.offset,d=0,ceil=Math.ceil;if(typeof i0==="number"){d=i0|0;if(d<0){c+=b0*(a0-1);a0=ceil(-a0/d);}else{a0=ceil(a0/d);}b0*=d;}if(typeof i1==="number"){d=i1|0;if(d<0){c+=b1*(a1-1);a1=ceil(-a1/d);}else{a1=ceil(a1/d);}b1*=d;}if(typeof i2==="number"){d=i2|0;if(d<0){c+=b2*(a2-1);a2=ceil(-a2/d);}else{a2=ceil(a2/d);}b2*=d;}if(typeof i3==="number"){d=i3|0;if(d<0){c+=b3*(a3-1);a3=ceil(-a3/d);}else{a3=ceil(a3/d);}b3*=d;}if(typeof i4==="number"){d=i4|0;if(d<0){c+=b4*(a4-1);a4=ceil(-a4/d);}else{a4=ceil(a4/d);}b4*=d;}return new View(this.data,a0,a1,a2,a3,a4,b0,b1,b2,b3,b4,c);};proto.transpose=function transpose(i0,i1,i2,i3,i4){i0=i0===undefined?0:i0|0;i1=i1===undefined?1:i1|0;i2=i2===undefined?2:i2|0;i3=i3===undefined?3:i3|0;i4=i4===undefined?4:i4|0;var a=this.shape,b=this.stride;return new View(this.data,a[i0],a[i1],a[i2],a[i3],a[i4],b[i0],b[i1],b[i2],b[i3],b[i4],this.offset);};proto.pick=function pick(i0,i1,i2,i3,i4){var a=[],b=[],c=this.offset;if(typeof i0==="number"&&i0>=0){c=c+this.stride[0]*i0|0;}else{a.push(this.shape[0]);b.push(this.stride[0]);}if(typeof i1==="number"&&i1>=0){c=c+this.stride[1]*i1|0;}else{a.push(this.shape[1]);b.push(this.stride[1]);}if(typeof i2==="number"&&i2>=0){c=c+this.stride[2]*i2|0;}else{a.push(this.shape[2]);b.push(this.stride[2]);}if(typeof i3==="number"&&i3>=0){c=c+this.stride[3]*i3|0;}else{a.push(this.shape[3]);b.push(this.stride[3]);}if(typeof i4==="number"&&i4>=0){c=c+this.stride[4]*i4|0;}else{a.push(this.shape[4]);b.push(this.stride[4]);}var ctor=CTOR_LIST[a.length+1];return ctor(this.data,a,b,c);};return function construct(data,shape,stride,offset){return new View(data,shape[0],shape[1],shape[2],shape[3],shape[4],stride[0],stride[1],stride[2],stride[3],stride[4],offset);};}};function compileConstructor(inType,inDimension){var dKey=inDimension===-1?'T':String(inDimension);var procedure=allFns[dKey];if(inDimension===-1){return procedure(inType);}else if(inDimension===0){return procedure(inType,CACHED_CONSTRUCTORS[inType][0]);}return procedure(inType,CACHED_CONSTRUCTORS[inType],order);}function arrayDType(data){if(isBuffer(data)){return"buffer";}if(hasTypedArrays){switch(Object.prototype.toString.call(data)){case"[object Float64Array]":return"float64";case"[object Float32Array]":return"float32";case"[object Int8Array]":return"int8";case"[object Int16Array]":return"int16";case"[object Int32Array]":return"int32";case"[object Uint8ClampedArray]":return"uint8_clamped";case"[object Uint8Array]":return"uint8";case"[object Uint16Array]":return"uint16";case"[object Uint32Array]":return"uint32";case"[object BigInt64Array]":return"bigint64";case"[object BigUint64Array]":return"biguint64";}}if(Array.isArray(data)){return"array";}return"generic";}var CACHED_CONSTRUCTORS={"generic":[],"buffer":[],"array":[],// typed arrays
"float32":[],"float64":[],"int8":[],"int16":[],"int32":[],"uint8_clamped":[],"uint8":[],"uint16":[],"uint32":[],"bigint64":[],"biguint64":[]};(function(){for(var id in CACHED_CONSTRUCTORS){CACHED_CONSTRUCTORS[id].push(compileConstructor(id,-1));}});function wrappedNDArrayCtor(data,shape,stride,offset){if(data===undefined){var ctor=CACHED_CONSTRUCTORS.array[0];return ctor([]);}else if(typeof data==="number"){data=[data];}if(shape===undefined){shape=[data.length];}var d=shape.length;if(stride===undefined){stride=new Array(d);for(var i=d-1,sz=1;i>=0;--i){stride[i]=sz;sz*=shape[i];}}if(offset===undefined){offset=0;for(var i=0;i<d;++i){if(stride[i]<0){offset-=(shape[i]-1)*stride[i];}}}var inType=arrayDType(data);var ctor_list=CACHED_CONSTRUCTORS[inType];while(ctor_list.length<=d+1){ctor_list.push(compileConstructor(inType,ctor_list.length-1));}var ctor=ctor_list[d+1];return ctor(data,shape,stride,offset);}module.exports=wrappedNDArrayCtor;/***/}),/***/1278:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_720702__){"use strict";var doubleBits=__nested_webpack_require_720702__(2361);var SMALLEST_DENORM=Math.pow(2,-1074);var UINT_MAX=-1>>>0;module.exports=nextafter;function nextafter(x,y){if(isNaN(x)||isNaN(y)){return NaN;}if(x===y){return x;}if(x===0){if(y<0){return-SMALLEST_DENORM;}else{return SMALLEST_DENORM;}}var hi=doubleBits.hi(x);var lo=doubleBits.lo(x);if(y>x===x>0){if(lo===UINT_MAX){hi+=1;lo=0;}else{lo+=1;}}else{if(lo===0){lo=UINT_MAX;hi-=1;}else{lo-=1;}}return doubleBits.pack(lo,hi);}/***/}),/***/8406:(/***/function(__unused_webpack_module,exports){var DEFAULT_NORMALS_EPSILON=1e-6;var DEFAULT_FACE_EPSILON=1e-6;//Estimate the vertex normals of a mesh
exports.vertexNormals=function(faces,positions,specifiedEpsilon){var N=positions.length;var normals=new Array(N);var epsilon=specifiedEpsilon===void 0?DEFAULT_NORMALS_EPSILON:specifiedEpsilon;//Initialize normal array
for(var i=0;i<N;++i){normals[i]=[0.0,0.0,0.0];}//Walk over all the faces and add per-vertex contribution to normal weights
for(var i=0;i<faces.length;++i){var f=faces[i];var p=0;var c=f[f.length-1];var n=f[0];for(var j=0;j<f.length;++j){//Shift indices back
p=c;c=n;n=f[(j+1)%f.length];var v0=positions[p];var v1=positions[c];var v2=positions[n];//Compute infineteismal arcs
var d01=new Array(3);var m01=0.0;var d21=new Array(3);var m21=0.0;for(var k=0;k<3;++k){d01[k]=v0[k]-v1[k];m01+=d01[k]*d01[k];d21[k]=v2[k]-v1[k];m21+=d21[k]*d21[k];}//Accumulate values in normal
if(m01*m21>epsilon){var norm=normals[c];var w=1.0/Math.sqrt(m01*m21);for(var k=0;k<3;++k){var u=(k+1)%3;var v=(k+2)%3;norm[k]+=w*(d21[u]*d01[v]-d21[v]*d01[u]);}}}}//Scale all normals to unit length
for(var i=0;i<N;++i){var norm=normals[i];var m=0.0;for(var k=0;k<3;++k){m+=norm[k]*norm[k];}if(m>epsilon){var w=1.0/Math.sqrt(m);for(var k=0;k<3;++k){norm[k]*=w;}}else{for(var k=0;k<3;++k){norm[k]=0.0;}}}//Return the resulting set of patches
return normals;};//Compute face normals of a mesh
exports.faceNormals=function(faces,positions,specifiedEpsilon){var N=faces.length;var normals=new Array(N);var epsilon=specifiedEpsilon===void 0?DEFAULT_FACE_EPSILON:specifiedEpsilon;for(var i=0;i<N;++i){var f=faces[i];var pos=new Array(3);for(var j=0;j<3;++j){pos[j]=positions[f[j]];}var d01=new Array(3);var d21=new Array(3);for(var j=0;j<3;++j){d01[j]=pos[1][j]-pos[0][j];d21[j]=pos[2][j]-pos[0][j];}var n=new Array(3);var l=0.0;for(var j=0;j<3;++j){var u=(j+1)%3;var v=(j+2)%3;n[j]=d01[u]*d21[v]-d01[v]*d21[u];l+=n[j]*n[j];}if(l>epsilon){l=1.0/Math.sqrt(l);}else{l=0.0;}for(var j=0;j<3;++j){n[j]*=l;}normals[i]=n;}return normals;};/***/}),/***/4081:(/***/function(module){"use strict";module.exports=quatFromFrame;function quatFromFrame(out,rx,ry,rz,ux,uy,uz,fx,fy,fz){var tr=rx+uy+fz;if(l>0){var l=Math.sqrt(tr+1.0);out[0]=0.5*(uz-fy)/l;out[1]=0.5*(fx-rz)/l;out[2]=0.5*(ry-uy)/l;out[3]=0.5*l;}else{var tf=Math.max(rx,uy,fz);var l=Math.sqrt(2*tf-tr+1.0);if(rx>=tf){//x y z  order
out[0]=0.5*l;out[1]=0.5*(ux+ry)/l;out[2]=0.5*(fx+rz)/l;out[3]=0.5*(uz-fy)/l;}else if(uy>=tf){//y z x  order
out[0]=0.5*(ry+ux)/l;out[1]=0.5*l;out[2]=0.5*(fy+uz)/l;out[3]=0.5*(fx-rz)/l;}else{//z x y  order
out[0]=0.5*(rz+fx)/l;out[1]=0.5*(uz+fy)/l;out[2]=0.5*l;out[3]=0.5*(ry-ux)/l;}}return out;}/***/}),/***/9977:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_723985__){"use strict";module.exports=createOrbitController;var filterVector=__nested_webpack_require_723985__(9215);var lookAt=__nested_webpack_require_723985__(6582);var mat4FromQuat=__nested_webpack_require_723985__(7399);var invert44=__nested_webpack_require_723985__(7608);var quatFromFrame=__nested_webpack_require_723985__(4081);function len3(x,y,z){return Math.sqrt(Math.pow(x,2)+Math.pow(y,2)+Math.pow(z,2));}function len4(w,x,y,z){return Math.sqrt(Math.pow(w,2)+Math.pow(x,2)+Math.pow(y,2)+Math.pow(z,2));}function normalize4(out,a){var ax=a[0];var ay=a[1];var az=a[2];var aw=a[3];var al=len4(ax,ay,az,aw);if(al>1e-6){out[0]=ax/al;out[1]=ay/al;out[2]=az/al;out[3]=aw/al;}else{out[0]=out[1]=out[2]=0.0;out[3]=1.0;}}function OrbitCameraController(initQuat,initCenter,initRadius){this.radius=filterVector([initRadius]);this.center=filterVector(initCenter);this.rotation=filterVector(initQuat);this.computedRadius=this.radius.curve(0);this.computedCenter=this.center.curve(0);this.computedRotation=this.rotation.curve(0);this.computedUp=[0.1,0,0];this.computedEye=[0.1,0,0];this.computedMatrix=[0.1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];this.recalcMatrix(0);}var proto=OrbitCameraController.prototype;proto.lastT=function(){return Math.max(this.radius.lastT(),this.center.lastT(),this.rotation.lastT());};proto.recalcMatrix=function(t){this.radius.curve(t);this.center.curve(t);this.rotation.curve(t);var quat=this.computedRotation;normalize4(quat,quat);var mat=this.computedMatrix;mat4FromQuat(mat,quat);var center=this.computedCenter;var eye=this.computedEye;var up=this.computedUp;var radius=Math.exp(this.computedRadius[0]);eye[0]=center[0]+radius*mat[2];eye[1]=center[1]+radius*mat[6];eye[2]=center[2]+radius*mat[10];up[0]=mat[1];up[1]=mat[5];up[2]=mat[9];for(var i=0;i<3;++i){var rr=0.0;for(var j=0;j<3;++j){rr+=mat[i+4*j]*eye[j];}mat[12+i]=-rr;}};proto.getMatrix=function(t,result){this.recalcMatrix(t);var m=this.computedMatrix;if(result){for(var i=0;i<16;++i){result[i]=m[i];}return result;}return m;};proto.idle=function(t){this.center.idle(t);this.radius.idle(t);this.rotation.idle(t);};proto.flush=function(t){this.center.flush(t);this.radius.flush(t);this.rotation.flush(t);};proto.pan=function(t,dx,dy,dz){dx=dx||0.0;dy=dy||0.0;dz=dz||0.0;this.recalcMatrix(t);var mat=this.computedMatrix;var ux=mat[1];var uy=mat[5];var uz=mat[9];var ul=len3(ux,uy,uz);ux/=ul;uy/=ul;uz/=ul;var rx=mat[0];var ry=mat[4];var rz=mat[8];var ru=rx*ux+ry*uy+rz*uz;rx-=ux*ru;ry-=uy*ru;rz-=uz*ru;var rl=len3(rx,ry,rz);rx/=rl;ry/=rl;rz/=rl;var fx=mat[2];var fy=mat[6];var fz=mat[10];var fu=fx*ux+fy*uy+fz*uz;var fr=fx*rx+fy*ry+fz*rz;fx-=fu*ux+fr*rx;fy-=fu*uy+fr*ry;fz-=fu*uz+fr*rz;var fl=len3(fx,fy,fz);fx/=fl;fy/=fl;fz/=fl;var vx=rx*dx+ux*dy;var vy=ry*dx+uy*dy;var vz=rz*dx+uz*dy;this.center.move(t,vx,vy,vz);//Update z-component of radius
var radius=Math.exp(this.computedRadius[0]);radius=Math.max(1e-4,radius+dz);this.radius.set(t,Math.log(radius));};proto.rotate=function(t,dx,dy,dz){this.recalcMatrix(t);dx=dx||0.0;dy=dy||0.0;var mat=this.computedMatrix;var rx=mat[0];var ry=mat[4];var rz=mat[8];var ux=mat[1];var uy=mat[5];var uz=mat[9];var fx=mat[2];var fy=mat[6];var fz=mat[10];var qx=dx*rx+dy*ux;var qy=dx*ry+dy*uy;var qz=dx*rz+dy*uz;var bx=-(fy*qz-fz*qy);var by=-(fz*qx-fx*qz);var bz=-(fx*qy-fy*qx);var bw=Math.sqrt(Math.max(0.0,1.0-Math.pow(bx,2)-Math.pow(by,2)-Math.pow(bz,2)));var bl=len4(bx,by,bz,bw);if(bl>1e-6){bx/=bl;by/=bl;bz/=bl;bw/=bl;}else{bx=by=bz=0.0;bw=1.0;}var rotation=this.computedRotation;var ax=rotation[0];var ay=rotation[1];var az=rotation[2];var aw=rotation[3];var cx=ax*bw+aw*bx+ay*bz-az*by;var cy=ay*bw+aw*by+az*bx-ax*bz;var cz=az*bw+aw*bz+ax*by-ay*bx;var cw=aw*bw-ax*bx-ay*by-az*bz;//Apply roll
if(dz){bx=fx;by=fy;bz=fz;var s=Math.sin(dz)/len3(bx,by,bz);bx*=s;by*=s;bz*=s;bw=Math.cos(dx);cx=cx*bw+cw*bx+cy*bz-cz*by;cy=cy*bw+cw*by+cz*bx-cx*bz;cz=cz*bw+cw*bz+cx*by-cy*bx;cw=cw*bw-cx*bx-cy*by-cz*bz;}var cl=len4(cx,cy,cz,cw);if(cl>1e-6){cx/=cl;cy/=cl;cz/=cl;cw/=cl;}else{cx=cy=cz=0.0;cw=1.0;}this.rotation.set(t,cx,cy,cz,cw);};proto.lookAt=function(t,eye,center,up){this.recalcMatrix(t);center=center||this.computedCenter;eye=eye||this.computedEye;up=up||this.computedUp;var mat=this.computedMatrix;lookAt(mat,eye,center,up);var rotation=this.computedRotation;quatFromFrame(rotation,mat[0],mat[1],mat[2],mat[4],mat[5],mat[6],mat[8],mat[9],mat[10]);normalize4(rotation,rotation);this.rotation.set(t,rotation[0],rotation[1],rotation[2],rotation[3]);var fl=0.0;for(var i=0;i<3;++i){fl+=Math.pow(center[i]-eye[i],2);}this.radius.set(t,0.5*Math.log(Math.max(fl,1e-6)));this.center.set(t,center[0],center[1],center[2]);};proto.translate=function(t,dx,dy,dz){this.center.move(t,dx||0.0,dy||0.0,dz||0.0);};proto.setMatrix=function(t,matrix){var rotation=this.computedRotation;quatFromFrame(rotation,matrix[0],matrix[1],matrix[2],matrix[4],matrix[5],matrix[6],matrix[8],matrix[9],matrix[10]);normalize4(rotation,rotation);this.rotation.set(t,rotation[0],rotation[1],rotation[2],rotation[3]);var mat=this.computedMatrix;invert44(mat,matrix);var w=mat[15];if(Math.abs(w)>1e-6){var cx=mat[12]/w;var cy=mat[13]/w;var cz=mat[14]/w;this.recalcMatrix(t);var r=Math.exp(this.computedRadius[0]);this.center.set(t,cx-mat[2]*r,cy-mat[6]*r,cz-mat[10]*r);this.radius.idle(t);}else{this.center.idle(t);this.radius.idle(t);}};proto.setDistance=function(t,d){if(d>0){this.radius.set(t,Math.log(d));}};proto.setDistanceLimits=function(lo,hi){if(lo>0){lo=Math.log(lo);}else{lo=-Infinity;}if(hi>0){hi=Math.log(hi);}else{hi=Infinity;}hi=Math.max(hi,lo);this.radius.bounds[0][0]=lo;this.radius.bounds[1][0]=hi;};proto.getDistanceLimits=function(out){var bounds=this.radius.bounds;if(out){out[0]=Math.exp(bounds[0][0]);out[1]=Math.exp(bounds[1][0]);return out;}return[Math.exp(bounds[0][0]),Math.exp(bounds[1][0])];};proto.toJSON=function(){this.recalcMatrix(this.lastT());return{center:this.computedCenter.slice(),rotation:this.computedRotation.slice(),distance:Math.log(this.computedRadius[0]),zoomMin:this.radius.bounds[0][0],zoomMax:this.radius.bounds[1][0]};};proto.fromJSON=function(options){var t=this.lastT();var c=options.center;if(c){this.center.set(t,c[0],c[1],c[2]);}var r=options.rotation;if(r){this.rotation.set(t,r[0],r[1],r[2],r[3]);}var d=options.distance;if(d&&d>0){this.radius.set(t,Math.log(d));}this.setDistanceLimits(options.zoomMin,options.zoomMax);};function createOrbitController(options){options=options||{};var center=options.center||[0,0,0];var rotation=options.rotation||[0,0,0,1];var radius=options.radius||1.0;center=[].slice.call(center,0,3);rotation=[].slice.call(rotation,0,4);normalize4(rotation,rotation);var result=new OrbitCameraController(rotation,center,Math.log(radius));result.setDistanceLimits(options.zoomMin,options.zoomMax);if('eye'in options||'up'in options){result.lookAt(0,options.eye,options.center,options.up);}return result;}/***/}),/***/1371:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_730856__){"use strict";/*!
 * pad-left <https://github.com/jonschlinkert/pad-left>
 *
 * Copyright (c) 2014-2015, Jon Schlinkert.
 * Licensed under the MIT license.
 */var repeat=__nested_webpack_require_730856__(3233);module.exports=function padLeft(str,num,ch){ch=typeof ch!=='undefined'?ch+'':' ';return repeat(ch,num)+str;};/***/}),/***/3202:(/***/function(module){module.exports=function parseUnit(str,out){if(!out)out=[0,''];str=String(str);var num=parseFloat(str,10);out[0]=num;out[1]=str.match(/[\d.\-\+]*\s*(.*)/)[1]||'';return out;};/***/}),/***/3088:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_731461__){"use strict";module.exports=planarDual;var compareAngle=__nested_webpack_require_731461__(3140);function planarDual(cells,positions){var numVertices=positions.length|0;var numEdges=cells.length;var adj=[new Array(numVertices),new Array(numVertices)];for(var i=0;i<numVertices;++i){adj[0][i]=[];adj[1][i]=[];}for(var i=0;i<numEdges;++i){var c=cells[i];adj[0][c[0]].push(c);adj[1][c[1]].push(c);}var cycles=[];//Add isolated vertices as trivial case
for(var i=0;i<numVertices;++i){if(adj[0][i].length+adj[1][i].length===0){cycles.push([i]);}}//Remove a half edge
function cut(c,i){var a=adj[i][c[i]];a.splice(a.indexOf(c),1);}//Find next vertex and cut edge
function next(a,b,noCut){var nextCell,nextVertex,nextDir;for(var i=0;i<2;++i){if(adj[i][b].length>0){nextCell=adj[i][b][0];nextDir=i;break;}}nextVertex=nextCell[nextDir^1];for(var dir=0;dir<2;++dir){var nbhd=adj[dir][b];for(var k=0;k<nbhd.length;++k){var e=nbhd[k];var p=e[dir^1];var cmp=compareAngle(positions[a],positions[b],positions[nextVertex],positions[p]);if(cmp>0){nextCell=e;nextVertex=p;nextDir=dir;}}}if(noCut){return nextVertex;}if(nextCell){cut(nextCell,nextDir);}return nextVertex;}function extractCycle(v,dir){var e0=adj[dir][v][0];var cycle=[v];cut(e0,dir);var u=e0[dir^1];var d0=dir;while(true){while(u!==v){cycle.push(u);u=next(cycle[cycle.length-2],u,false);}if(adj[0][v].length+adj[1][v].length===0){break;}var a=cycle[cycle.length-1];var b=v;var c=cycle[1];var d=next(a,b,true);if(compareAngle(positions[a],positions[b],positions[c],positions[d])<0){break;}cycle.push(v);u=next(a,b);}return cycle;}function shouldGlue(pcycle,ncycle){return ncycle[1]===ncycle[ncycle.length-1];}for(var i=0;i<numVertices;++i){for(var j=0;j<2;++j){var pcycle=[];while(adj[j][i].length>0){var ni=adj[0][i].length;var ncycle=extractCycle(i,j);if(shouldGlue(pcycle,ncycle)){//Glue together trivial cycles
pcycle.push.apply(pcycle,ncycle);}else{if(pcycle.length>0){cycles.push(pcycle);}pcycle=ncycle;}}if(pcycle.length>0){cycles.push(pcycle);}}}//Combine paths and loops together
return cycles;}/***/}),/***/5609:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_733582__){"use strict";module.exports=trimLeaves;var e2a=__nested_webpack_require_733582__(3134);function trimLeaves(edges,positions){var adj=e2a(edges,positions.length);var live=new Array(positions.length);var nbhd=new Array(positions.length);var dead=[];for(var i=0;i<positions.length;++i){var count=adj[i].length;nbhd[i]=count;live[i]=true;if(count<=1){dead.push(i);}}while(dead.length>0){var v=dead.pop();live[v]=false;var n=adj[v];for(var i=0;i<n.length;++i){var u=n[i];if(--nbhd[u]===0){dead.push(u);}}}var newIndex=new Array(positions.length);var npositions=[];for(var i=0;i<positions.length;++i){if(live[i]){var v=npositions.length;newIndex[i]=v;npositions.push(positions[i]);}else{newIndex[i]=-1;}}var nedges=[];for(var i=0;i<edges.length;++i){var e=edges[i];if(live[e[0]]&&live[e[1]]){nedges.push([newIndex[e[0]],newIndex[e[1]]]);}}return[nedges,npositions];}/***/}),/***/2095:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_734513__){"use strict";module.exports=planarGraphToPolyline;var e2a=__nested_webpack_require_734513__(3134);var planarDual=__nested_webpack_require_734513__(3088);var preprocessPolygon=__nested_webpack_require_734513__(5085);var twoProduct=__nested_webpack_require_734513__(5250);var robustSum=__nested_webpack_require_734513__(8210);var uniq=__nested_webpack_require_734513__(1682);var trimLeaves=__nested_webpack_require_734513__(5609);function makeArray(length,fill){var result=new Array(length);for(var i=0;i<length;++i){result[i]=fill;}return result;}function makeArrayOfArrays(length){var result=new Array(length);for(var i=0;i<length;++i){result[i]=[];}return result;}function planarGraphToPolyline(edges,positions){//Trim leaves
var result=trimLeaves(edges,positions);edges=result[0];positions=result[1];var numVertices=positions.length;var numEdges=edges.length;//Calculate adjacency list, check manifold
var adj=e2a(edges,positions.length);for(var i=0;i<numVertices;++i){if(adj[i].length%2===1){throw new Error('planar-graph-to-polyline: graph must be manifold');}}//Get faces
var faces=planarDual(edges,positions);//Check orientation of a polygon using exact arithmetic
function ccw(c){var n=c.length;var area=[0];for(var j=0;j<n;++j){var a=positions[c[j]];var b=positions[c[(j+1)%n]];var t00=twoProduct(-a[0],a[1]);var t01=twoProduct(-a[0],b[1]);var t10=twoProduct(b[0],a[1]);var t11=twoProduct(b[0],b[1]);area=robustSum(area,robustSum(robustSum(t00,t01),robustSum(t10,t11)));}return area[area.length-1]>0;}//Extract all clockwise faces
faces=faces.filter(ccw);//Detect which loops are contained in one another to handle parent-of relation
var numFaces=faces.length;var parent=new Array(numFaces);var containment=new Array(numFaces);for(var i=0;i<numFaces;++i){parent[i]=i;var row=new Array(numFaces);var loopVertices=faces[i].map(function(v){return positions[v];});var pmc=preprocessPolygon([loopVertices]);var count=0;outer:for(var j=0;j<numFaces;++j){row[j]=0;if(i===j){continue;}var c=faces[j];var n=c.length;for(var k=0;k<n;++k){var d=pmc(positions[c[k]]);if(d!==0){if(d<0){row[j]=1;count+=1;}continue outer;}}row[j]=1;count+=1;}containment[i]=[count,i,row];}containment.sort(function(a,b){return b[0]-a[0];});for(var i=0;i<numFaces;++i){var row=containment[i];var idx=row[1];var children=row[2];for(var j=0;j<numFaces;++j){if(children[j]){parent[j]=idx;}}}//Initialize face adjacency list
var fadj=makeArrayOfArrays(numFaces);for(var i=0;i<numFaces;++i){fadj[i].push(parent[i]);fadj[parent[i]].push(i);}//Build adjacency matrix for edges
var edgeAdjacency={};var internalVertices=makeArray(numVertices,false);for(var i=0;i<numFaces;++i){var c=faces[i];var n=c.length;for(var j=0;j<n;++j){var a=c[j];var b=c[(j+1)%n];var key=Math.min(a,b)+":"+Math.max(a,b);if(key in edgeAdjacency){var neighbor=edgeAdjacency[key];fadj[neighbor].push(i);fadj[i].push(neighbor);internalVertices[a]=internalVertices[b]=true;}else{edgeAdjacency[key]=i;}}}function sharedBoundary(c){var n=c.length;for(var i=0;i<n;++i){if(!internalVertices[c[i]]){return false;}}return true;}var toVisit=[];var parity=makeArray(numFaces,-1);for(var i=0;i<numFaces;++i){if(parent[i]===i&&!sharedBoundary(faces[i])){toVisit.push(i);parity[i]=0;}else{parity[i]=-1;}}//Using face adjacency, classify faces as in/out
var result=[];while(toVisit.length>0){var top=toVisit.pop();var nbhd=fadj[top];uniq(nbhd,function(a,b){return a-b;});var nnbhr=nbhd.length;var p=parity[top];var polyline;if(p===0){var c=faces[top];polyline=[c];}for(var i=0;i<nnbhr;++i){var f=nbhd[i];if(parity[f]>=0){continue;}parity[f]=p^1;toVisit.push(f);if(p===0){var c=faces[f];if(!sharedBoundary(c)){c.reverse();polyline.push(c);}}}if(p===0){result.push(polyline);}}return result;}/***/}),/***/5085:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_738218__){module.exports=preprocessPolygon;var orient=__nested_webpack_require_738218__(3250)[3];var makeSlabs=__nested_webpack_require_738218__(4209);var makeIntervalTree=__nested_webpack_require_738218__(3352);var bsearch=__nested_webpack_require_738218__(2478);function visitInterval(){return true;}function intervalSearch(table){return function(x,y){var tree=table[x];if(tree){return!!tree.queryPoint(y,visitInterval);}return false;};}function buildVerticalIndex(segments){var table={};for(var i=0;i<segments.length;++i){var s=segments[i];var x=s[0][0];var y0=s[0][1];var y1=s[1][1];var p=[Math.min(y0,y1),Math.max(y0,y1)];if(x in table){table[x].push(p);}else{table[x]=[p];}}var intervalTable={};var keys=Object.keys(table);for(var i=0;i<keys.length;++i){var segs=table[keys[i]];intervalTable[keys[i]]=makeIntervalTree(segs);}return intervalSearch(intervalTable);}function buildSlabSearch(slabs,coordinates){return function(p){var bucket=bsearch.le(coordinates,p[0]);if(bucket<0){return 1;}var root=slabs[bucket];if(!root){if(bucket>0&&coordinates[bucket]===p[0]){root=slabs[bucket-1];}else{return 1;}}var lastOrientation=1;while(root){var s=root.key;var o=orient(p,s[0],s[1]);if(s[0][0]<s[1][0]){if(o<0){root=root.left;}else if(o>0){lastOrientation=-1;root=root.right;}else{return 0;}}else{if(o>0){root=root.left;}else if(o<0){lastOrientation=1;root=root.right;}else{return 0;}}}return lastOrientation;};}function classifyEmpty(p){return 1;}function createClassifyVertical(testVertical){return function classify(p){if(testVertical(p[0],p[1])){return 0;}return 1;};}function createClassifyPointDegen(testVertical,testNormal){return function classify(p){if(testVertical(p[0],p[1])){return 0;}return testNormal(p);};}function preprocessPolygon(loops){//Compute number of loops
var numLoops=loops.length;//Unpack segments
var segments=[];var vsegments=[];var ptr=0;for(var i=0;i<numLoops;++i){var loop=loops[i];var numVertices=loop.length;for(var s=numVertices-1,t=0;t<numVertices;s=t++){var a=loop[s];var b=loop[t];if(a[0]===b[0]){vsegments.push([a,b]);}else{segments.push([a,b]);}}}//Degenerate case: All loops are empty
if(segments.length===0){if(vsegments.length===0){return classifyEmpty;}else{return createClassifyVertical(buildVerticalIndex(vsegments));}}//Build slab decomposition
var slabs=makeSlabs(segments);var testSlab=buildSlabSearch(slabs.slabs,slabs.coordinates);if(vsegments.length===0){return testSlab;}else{return createClassifyPointDegen(buildVerticalIndex(vsegments),testSlab);}}/***/}),/***/9346:(/***/function(module){"use strict";//Optimized version for triangle closest point
// Based on Eberly's WildMagick codes
// http://www.geometrictools.com/LibMathematics/Distance/Distance.html
var diff=new Float64Array(4);var edge0=new Float64Array(4);var edge1=new Float64Array(4);function closestPoint2d(V0,V1,V2,point,result){//Reallocate buffers if necessary
if(diff.length<point.length){diff=new Float64Array(point.length);edge0=new Float64Array(point.length);edge1=new Float64Array(point.length);}//Compute edges
for(var i=0;i<point.length;++i){diff[i]=V0[i]-point[i];edge0[i]=V1[i]-V0[i];edge1[i]=V2[i]-V0[i];}//Compute coefficients for quadratic func
var a00=0.0,a01=0.0,a11=0.0,b0=0.0,b1=0.0,c=0.0;for(var i=0;i<point.length;++i){var e0=edge0[i],e1=edge1[i],d=diff[i];a00+=e0*e0;a01+=e0*e1;a11+=e1*e1;b0+=d*e0;b1+=d*e1;c+=d*d;}//Compute determinant/coeffs
var det=Math.abs(a00*a11-a01*a01);var s=a01*b1-a11*b0;var t=a01*b0-a00*b1;var sqrDistance;//Hardcoded Voronoi diagram classification
if(s+t<=det){if(s<0){if(t<0){// region 4
if(b0<0){t=0;if(-b0>=a00){s=1.0;sqrDistance=a00+2.0*b0+c;}else{s=-b0/a00;sqrDistance=b0*s+c;}}else{s=0;if(b1>=0){t=0;sqrDistance=c;}else if(-b1>=a11){t=1;sqrDistance=a11+2.0*b1+c;}else{t=-b1/a11;sqrDistance=b1*t+c;}}}else{// region 3
s=0;if(b1>=0){t=0;sqrDistance=c;}else if(-b1>=a11){t=1;sqrDistance=a11+2.0*b1+c;}else{t=-b1/a11;sqrDistance=b1*t+c;}}}else if(t<0){// region 5
t=0;if(b0>=0){s=0;sqrDistance=c;}else if(-b0>=a00){s=1;sqrDistance=a00+2.0*b0+c;}else{s=-b0/a00;sqrDistance=b0*s+c;}}else{// region 0
// minimum at interior point
var invDet=1.0/det;s*=invDet;t*=invDet;sqrDistance=s*(a00*s+a01*t+2.0*b0)+t*(a01*s+a11*t+2.0*b1)+c;}}else{var tmp0,tmp1,numer,denom;if(s<0){// region 2
tmp0=a01+b0;tmp1=a11+b1;if(tmp1>tmp0){numer=tmp1-tmp0;denom=a00-2.0*a01+a11;if(numer>=denom){s=1;t=0;sqrDistance=a00+2.0*b0+c;}else{s=numer/denom;t=1-s;sqrDistance=s*(a00*s+a01*t+2.0*b0)+t*(a01*s+a11*t+2.0*b1)+c;}}else{s=0;if(tmp1<=0){t=1;sqrDistance=a11+2.0*b1+c;}else if(b1>=0){t=0;sqrDistance=c;}else{t=-b1/a11;sqrDistance=b1*t+c;}}}else if(t<0){// region 6
tmp0=a01+b1;tmp1=a00+b0;if(tmp1>tmp0){numer=tmp1-tmp0;denom=a00-2.0*a01+a11;if(numer>=denom){t=1;s=0;sqrDistance=a11+2.0*b1+c;}else{t=numer/denom;s=1-t;sqrDistance=s*(a00*s+a01*t+2.0*b0)+t*(a01*s+a11*t+2.0*b1)+c;}}else{t=0;if(tmp1<=0){s=1;sqrDistance=a00+2.0*b0+c;}else if(b0>=0){s=0;sqrDistance=c;}else{s=-b0/a00;sqrDistance=b0*s+c;}}}else{// region 1
numer=a11+b1-a01-b0;if(numer<=0){s=0;t=1;sqrDistance=a11+2.0*b1+c;}else{denom=a00-2.0*a01+a11;if(numer>=denom){s=1;t=0;sqrDistance=a00+2.0*b0+c;}else{s=numer/denom;t=1-s;sqrDistance=s*(a00*s+a01*t+2.0*b0)+t*(a01*s+a11*t+2.0*b1)+c;}}}}var u=1.0-s-t;for(var i=0;i<point.length;++i){result[i]=u*V0[i]+s*V1[i]+t*V2[i];}if(sqrDistance<0){return 0;}return sqrDistance;}module.exports=closestPoint2d;/***/}),/***/8648:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_743595__){module.exports=__nested_webpack_require_743595__(783);/***/}),/***/2653:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_743721__){"use strict";var bnadd=__nested_webpack_require_743721__(3865);module.exports=add;function add(a,b){var n=a.length;var r=new Array(n);for(var i=0;i<n;++i){r[i]=bnadd(a[i],b[i]);}return r;}/***/}),/***/5838:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_743981__){"use strict";module.exports=float2rat;var rat=__nested_webpack_require_743981__(7842);function float2rat(v){var result=new Array(v.length);for(var i=0;i<v.length;++i){result[i]=rat(v[i]);}return result;}/***/}),/***/8987:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_744256__){"use strict";var rat=__nested_webpack_require_744256__(7842);var mul=__nested_webpack_require_744256__(6504);module.exports=muls;function muls(a,x){var s=rat(x);var n=a.length;var r=new Array(n);for(var i=0;i<n;++i){r[i]=mul(a[i],s);}return r;}/***/}),/***/544:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_744557__){"use strict";var bnsub=__nested_webpack_require_744557__(5572);module.exports=sub;function sub(a,b){var n=a.length;var r=new Array(n);for(var i=0;i<n;++i){r[i]=bnsub(a[i],b[i]);}return r;}/***/}),/***/5771:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_744817__){"use strict";var compareCell=__nested_webpack_require_744817__(8507);var compareOrientedCell=__nested_webpack_require_744817__(3788);var orientation=__nested_webpack_require_744817__(2419);module.exports=reduceCellComplex;function reduceCellComplex(cells){cells.sort(compareOrientedCell);var n=cells.length;var ptr=0;for(var i=0;i<n;++i){var c=cells[i];var o=orientation(c);if(o===0){continue;}if(ptr>0){var f=cells[ptr-1];if(compareCell(c,f)===0&&orientation(f)!==o){ptr-=1;continue;}}cells[ptr++]=c;}cells.length=ptr;return cells;}/***/}),/***/3233:(/***/function(module){"use strict";/*!
 * repeat-string <https://github.com/jonschlinkert/repeat-string>
 *
 * Copyright (c) 2014-2015, Jon Schlinkert.
 * Licensed under the MIT License.
 */ /**
 * Results cache
 */var res='';var cache;/**
 * Expose `repeat`
 */module.exports=repeat;/**
 * Repeat the given `string` the specified `number`
 * of times.
 *
 * **Example:**
 *
 * ```js
 * var repeat = require('repeat-string');
 * repeat('A', 5);
 * //=> AAAAA
 * ```
 *
 * @param {String} `string` The string to repeat
 * @param {Number} `number` The number of times to repeat the string
 * @return {String} Repeated string
 * @api public
 */function repeat(str,num){if(typeof str!=='string'){throw new TypeError('expected a string');}// cover common, quick use cases
if(num===1)return str;if(num===2)return str+str;var max=str.length*num;if(cache!==str||typeof cache==='undefined'){cache=str;res='';}else if(res.length>=max){return res.substr(0,max);}while(max>res.length&&num>1){if(num&1){res+=str;}num>>=1;str+=str;}res+=str;res=res.substr(0,max);return res;}/***/}),/***/3025:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_746474__){module.exports=__nested_webpack_require_746474__.g.performance&&__nested_webpack_require_746474__.g.performance.now?function now(){return performance.now();}:Date.now||function now(){return+new Date();};/***/}),/***/7004:(/***/function(module){"use strict";module.exports=compressExpansion;function compressExpansion(e){var m=e.length;var Q=e[e.length-1];var bottom=m;for(var i=m-2;i>=0;--i){var a=Q;var b=e[i];Q=a+b;var bv=Q-a;var q=b-bv;if(q){e[--bottom]=Q;Q=q;}}var top=0;for(var i=bottom;i<m;++i){var a=e[i];var b=Q;Q=a+b;var bv=Q-a;var q=b-bv;if(q){e[top++]=q;}}e[top++]=Q;e.length=top;return e;}/***/}),/***/2962:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_747133__){"use strict";var twoProduct=__nested_webpack_require_747133__(5250);var robustSum=__nested_webpack_require_747133__(8210);var robustScale=__nested_webpack_require_747133__(3012);var compress=__nested_webpack_require_747133__(7004);var NUM_EXPANDED=6;function determinant_2(sum,scale,prod,compress){return function robustDeterminant2(m){return compress(sum(prod(m[0][0],m[1][1]),prod(-m[0][1],m[1][0])));};}function determinant_3(sum,scale,prod,compress){return function robustDeterminant3(m){return compress(sum(scale(sum(prod(m[1][1],m[2][2]),prod(-m[1][2],m[2][1])),m[0][0]),sum(scale(sum(prod(m[1][0],m[2][2]),prod(-m[1][2],m[2][0])),-m[0][1]),scale(sum(prod(m[1][0],m[2][1]),prod(-m[1][1],m[2][0])),m[0][2]))));};}function determinant_4(sum,scale,prod,compress){return function robustDeterminant4(m){return compress(sum(sum(scale(sum(scale(sum(prod(m[2][2],m[3][3]),prod(-m[2][3],m[3][2])),m[1][1]),sum(scale(sum(prod(m[2][1],m[3][3]),prod(-m[2][3],m[3][1])),-m[1][2]),scale(sum(prod(m[2][1],m[3][2]),prod(-m[2][2],m[3][1])),m[1][3]))),m[0][0]),scale(sum(scale(sum(prod(m[2][2],m[3][3]),prod(-m[2][3],m[3][2])),m[1][0]),sum(scale(sum(prod(m[2][0],m[3][3]),prod(-m[2][3],m[3][0])),-m[1][2]),scale(sum(prod(m[2][0],m[3][2]),prod(-m[2][2],m[3][0])),m[1][3]))),-m[0][1])),sum(scale(sum(scale(sum(prod(m[2][1],m[3][3]),prod(-m[2][3],m[3][1])),m[1][0]),sum(scale(sum(prod(m[2][0],m[3][3]),prod(-m[2][3],m[3][0])),-m[1][1]),scale(sum(prod(m[2][0],m[3][1]),prod(-m[2][1],m[3][0])),m[1][3]))),m[0][2]),scale(sum(scale(sum(prod(m[2][1],m[3][2]),prod(-m[2][2],m[3][1])),m[1][0]),sum(scale(sum(prod(m[2][0],m[3][2]),prod(-m[2][2],m[3][0])),-m[1][1]),scale(sum(prod(m[2][0],m[3][1]),prod(-m[2][1],m[3][0])),m[1][2]))),-m[0][3]))));};}function determinant_5(sum,scale,prod,compress){return function robustDeterminant5(m){return compress(sum(sum(scale(sum(sum(scale(sum(scale(sum(prod(m[3][3],m[4][4]),prod(-m[3][4],m[4][3])),m[2][2]),sum(scale(sum(prod(m[3][2],m[4][4]),prod(-m[3][4],m[4][2])),-m[2][3]),scale(sum(prod(m[3][2],m[4][3]),prod(-m[3][3],m[4][2])),m[2][4]))),m[1][1]),scale(sum(scale(sum(prod(m[3][3],m[4][4]),prod(-m[3][4],m[4][3])),m[2][1]),sum(scale(sum(prod(m[3][1],m[4][4]),prod(-m[3][4],m[4][1])),-m[2][3]),scale(sum(prod(m[3][1],m[4][3]),prod(-m[3][3],m[4][1])),m[2][4]))),-m[1][2])),sum(scale(sum(scale(sum(prod(m[3][2],m[4][4]),prod(-m[3][4],m[4][2])),m[2][1]),sum(scale(sum(prod(m[3][1],m[4][4]),prod(-m[3][4],m[4][1])),-m[2][2]),scale(sum(prod(m[3][1],m[4][2]),prod(-m[3][2],m[4][1])),m[2][4]))),m[1][3]),scale(sum(scale(sum(prod(m[3][2],m[4][3]),prod(-m[3][3],m[4][2])),m[2][1]),sum(scale(sum(prod(m[3][1],m[4][3]),prod(-m[3][3],m[4][1])),-m[2][2]),scale(sum(prod(m[3][1],m[4][2]),prod(-m[3][2],m[4][1])),m[2][3]))),-m[1][4]))),m[0][0]),scale(sum(sum(scale(sum(scale(sum(prod(m[3][3],m[4][4]),prod(-m[3][4],m[4][3])),m[2][2]),sum(scale(sum(prod(m[3][2],m[4][4]),prod(-m[3][4],m[4][2])),-m[2][3]),scale(sum(prod(m[3][2],m[4][3]),prod(-m[3][3],m[4][2])),m[2][4]))),m[1][0]),scale(sum(scale(sum(prod(m[3][3],m[4][4]),prod(-m[3][4],m[4][3])),m[2][0]),sum(scale(sum(prod(m[3][0],m[4][4]),prod(-m[3][4],m[4][0])),-m[2][3]),scale(sum(prod(m[3][0],m[4][3]),prod(-m[3][3],m[4][0])),m[2][4]))),-m[1][2])),sum(scale(sum(scale(sum(prod(m[3][2],m[4][4]),prod(-m[3][4],m[4][2])),m[2][0]),sum(scale(sum(prod(m[3][0],m[4][4]),prod(-m[3][4],m[4][0])),-m[2][2]),scale(sum(prod(m[3][0],m[4][2]),prod(-m[3][2],m[4][0])),m[2][4]))),m[1][3]),scale(sum(scale(sum(prod(m[3][2],m[4][3]),prod(-m[3][3],m[4][2])),m[2][0]),sum(scale(sum(prod(m[3][0],m[4][3]),prod(-m[3][3],m[4][0])),-m[2][2]),scale(sum(prod(m[3][0],m[4][2]),prod(-m[3][2],m[4][0])),m[2][3]))),-m[1][4]))),-m[0][1])),sum(scale(sum(sum(scale(sum(scale(sum(prod(m[3][3],m[4][4]),prod(-m[3][4],m[4][3])),m[2][1]),sum(scale(sum(prod(m[3][1],m[4][4]),prod(-m[3][4],m[4][1])),-m[2][3]),scale(sum(prod(m[3][1],m[4][3]),prod(-m[3][3],m[4][1])),m[2][4]))),m[1][0]),scale(sum(scale(sum(prod(m[3][3],m[4][4]),prod(-m[3][4],m[4][3])),m[2][0]),sum(scale(sum(prod(m[3][0],m[4][4]),prod(-m[3][4],m[4][0])),-m[2][3]),scale(sum(prod(m[3][0],m[4][3]),prod(-m[3][3],m[4][0])),m[2][4]))),-m[1][1])),sum(scale(sum(scale(sum(prod(m[3][1],m[4][4]),prod(-m[3][4],m[4][1])),m[2][0]),sum(scale(sum(prod(m[3][0],m[4][4]),prod(-m[3][4],m[4][0])),-m[2][1]),scale(sum(prod(m[3][0],m[4][1]),prod(-m[3][1],m[4][0])),m[2][4]))),m[1][3]),scale(sum(scale(sum(prod(m[3][1],m[4][3]),prod(-m[3][3],m[4][1])),m[2][0]),sum(scale(sum(prod(m[3][0],m[4][3]),prod(-m[3][3],m[4][0])),-m[2][1]),scale(sum(prod(m[3][0],m[4][1]),prod(-m[3][1],m[4][0])),m[2][3]))),-m[1][4]))),m[0][2]),sum(scale(sum(sum(scale(sum(scale(sum(prod(m[3][2],m[4][4]),prod(-m[3][4],m[4][2])),m[2][1]),sum(scale(sum(prod(m[3][1],m[4][4]),prod(-m[3][4],m[4][1])),-m[2][2]),scale(sum(prod(m[3][1],m[4][2]),prod(-m[3][2],m[4][1])),m[2][4]))),m[1][0]),scale(sum(scale(sum(prod(m[3][2],m[4][4]),prod(-m[3][4],m[4][2])),m[2][0]),sum(scale(sum(prod(m[3][0],m[4][4]),prod(-m[3][4],m[4][0])),-m[2][2]),scale(sum(prod(m[3][0],m[4][2]),prod(-m[3][2],m[4][0])),m[2][4]))),-m[1][1])),sum(scale(sum(scale(sum(prod(m[3][1],m[4][4]),prod(-m[3][4],m[4][1])),m[2][0]),sum(scale(sum(prod(m[3][0],m[4][4]),prod(-m[3][4],m[4][0])),-m[2][1]),scale(sum(prod(m[3][0],m[4][1]),prod(-m[3][1],m[4][0])),m[2][4]))),m[1][2]),scale(sum(scale(sum(prod(m[3][1],m[4][2]),prod(-m[3][2],m[4][1])),m[2][0]),sum(scale(sum(prod(m[3][0],m[4][2]),prod(-m[3][2],m[4][0])),-m[2][1]),scale(sum(prod(m[3][0],m[4][1]),prod(-m[3][1],m[4][0])),m[2][2]))),-m[1][4]))),-m[0][3]),scale(sum(sum(scale(sum(scale(sum(prod(m[3][2],m[4][3]),prod(-m[3][3],m[4][2])),m[2][1]),sum(scale(sum(prod(m[3][1],m[4][3]),prod(-m[3][3],m[4][1])),-m[2][2]),scale(sum(prod(m[3][1],m[4][2]),prod(-m[3][2],m[4][1])),m[2][3]))),m[1][0]),scale(sum(scale(sum(prod(m[3][2],m[4][3]),prod(-m[3][3],m[4][2])),m[2][0]),sum(scale(sum(prod(m[3][0],m[4][3]),prod(-m[3][3],m[4][0])),-m[2][2]),scale(sum(prod(m[3][0],m[4][2]),prod(-m[3][2],m[4][0])),m[2][3]))),-m[1][1])),sum(scale(sum(scale(sum(prod(m[3][1],m[4][3]),prod(-m[3][3],m[4][1])),m[2][0]),sum(scale(sum(prod(m[3][0],m[4][3]),prod(-m[3][3],m[4][0])),-m[2][1]),scale(sum(prod(m[3][0],m[4][1]),prod(-m[3][1],m[4][0])),m[2][3]))),m[1][2]),scale(sum(scale(sum(prod(m[3][1],m[4][2]),prod(-m[3][2],m[4][1])),m[2][0]),sum(scale(sum(prod(m[3][0],m[4][2]),prod(-m[3][2],m[4][0])),-m[2][1]),scale(sum(prod(m[3][0],m[4][1]),prod(-m[3][1],m[4][0])),m[2][2]))),-m[1][3]))),m[0][4])))));};}function compileDeterminant(n){var fn=n===2?determinant_2:n===3?determinant_3:n===4?determinant_4:n===5?determinant_5:undefined;return fn(robustSum,robustScale,twoProduct,compress);}var CACHE=[function robustDeterminant0(){return[0];},function robustDeterminant1(m){return[m[0][0]];}];function proc(det0,det1,det2,det3,det4,det5,CACHE,gen){return function robustDeterminant(m){switch(m.length){case 0:return det0(m);case 1:return det1(m);case 2:return det2(m);case 3:return det3(m);case 4:return det4(m);case 5:return det5(m);}var det=CACHE[m.length];if(!det)det=CACHE[m.length]=gen(m.length);return det(m);};}function generateDispatch(){while(CACHE.length<NUM_EXPANDED){CACHE.push(compileDeterminant(CACHE.length));}module.exports=proc.apply(undefined,CACHE.concat([CACHE,compileDeterminant]));for(var i=0;i<CACHE.length;++i){module.exports[i]=CACHE[i];}}generateDispatch();/***/}),/***/1944:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_754471__){"use strict";var twoProduct=__nested_webpack_require_754471__(5250);var robustSum=__nested_webpack_require_754471__(8210);module.exports=robustDotProduct;function robustDotProduct(a,b){var r=twoProduct(a[0],b[0]);for(var i=1;i<a.length;++i){r=robustSum(r,twoProduct(a[i],b[i]));}return r;}/***/}),/***/2646:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_754818__){"use strict";var twoProduct=__nested_webpack_require_754818__(5250);var robustSum=__nested_webpack_require_754818__(8210);var robustDiff=__nested_webpack_require_754818__(8545);var robustScale=__nested_webpack_require_754818__(3012);var NUM_EXPAND=6;function orientation(n){var fn=n===3?inSphere3:n===4?inSphere4:n===5?inSphere5:inSphere6;return fn(robustSum,robustDiff,twoProduct,robustScale);}function inSphere0(){return 0;}function inSphere1(){return 0;}function inSphere2(){return 0;}function inSphere3(sum,diff,prod,scale){function exactInSphere3(m0,m1,m2){var w0=prod(m0[0],m0[0]);var w0m1=scale(w0,m1[0]);var w0m2=scale(w0,m2[0]);var w1=prod(m1[0],m1[0]);var w1m0=scale(w1,m0[0]);var w1m2=scale(w1,m2[0]);var w2=prod(m2[0],m2[0]);var w2m0=scale(w2,m0[0]);var w2m1=scale(w2,m1[0]);var p=sum(diff(w2m1,w1m2),diff(w1m0,w0m1));var n=diff(w2m0,w0m2);var d=diff(p,n);return d[d.length-1];}return exactInSphere3;}function inSphere4(sum,diff,prod,scale){function exactInSphere4(m0,m1,m2,m3){var w0=sum(prod(m0[0],m0[0]),prod(m0[1],m0[1]));var w0m1=scale(w0,m1[0]);var w0m2=scale(w0,m2[0]);var w0m3=scale(w0,m3[0]);var w1=sum(prod(m1[0],m1[0]),prod(m1[1],m1[1]));var w1m0=scale(w1,m0[0]);var w1m2=scale(w1,m2[0]);var w1m3=scale(w1,m3[0]);var w2=sum(prod(m2[0],m2[0]),prod(m2[1],m2[1]));var w2m0=scale(w2,m0[0]);var w2m1=scale(w2,m1[0]);var w2m3=scale(w2,m3[0]);var w3=sum(prod(m3[0],m3[0]),prod(m3[1],m3[1]));var w3m0=scale(w3,m0[0]);var w3m1=scale(w3,m1[0]);var w3m2=scale(w3,m2[0]);var p=sum(sum(scale(diff(w3m2,w2m3),m1[1]),sum(scale(diff(w3m1,w1m3),-m2[1]),scale(diff(w2m1,w1m2),m3[1]))),sum(scale(diff(w3m1,w1m3),m0[1]),sum(scale(diff(w3m0,w0m3),-m1[1]),scale(diff(w1m0,w0m1),m3[1]))));var n=sum(sum(scale(diff(w3m2,w2m3),m0[1]),sum(scale(diff(w3m0,w0m3),-m2[1]),scale(diff(w2m0,w0m2),m3[1]))),sum(scale(diff(w2m1,w1m2),m0[1]),sum(scale(diff(w2m0,w0m2),-m1[1]),scale(diff(w1m0,w0m1),m2[1]))));var d=diff(p,n);return d[d.length-1];}return exactInSphere4;}function inSphere5(sum,diff,prod,scale){function exactInSphere5(m0,m1,m2,m3,m4){var w0=sum(prod(m0[0],m0[0]),sum(prod(m0[1],m0[1]),prod(m0[2],m0[2])));var w0m1=scale(w0,m1[0]);var w0m2=scale(w0,m2[0]);var w0m3=scale(w0,m3[0]);var w0m4=scale(w0,m4[0]);var w1=sum(prod(m1[0],m1[0]),sum(prod(m1[1],m1[1]),prod(m1[2],m1[2])));var w1m0=scale(w1,m0[0]);var w1m2=scale(w1,m2[0]);var w1m3=scale(w1,m3[0]);var w1m4=scale(w1,m4[0]);var w2=sum(prod(m2[0],m2[0]),sum(prod(m2[1],m2[1]),prod(m2[2],m2[2])));var w2m0=scale(w2,m0[0]);var w2m1=scale(w2,m1[0]);var w2m3=scale(w2,m3[0]);var w2m4=scale(w2,m4[0]);var w3=sum(prod(m3[0],m3[0]),sum(prod(m3[1],m3[1]),prod(m3[2],m3[2])));var w3m0=scale(w3,m0[0]);var w3m1=scale(w3,m1[0]);var w3m2=scale(w3,m2[0]);var w3m4=scale(w3,m4[0]);var w4=sum(prod(m4[0],m4[0]),sum(prod(m4[1],m4[1]),prod(m4[2],m4[2])));var w4m0=scale(w4,m0[0]);var w4m1=scale(w4,m1[0]);var w4m2=scale(w4,m2[0]);var w4m3=scale(w4,m3[0]);var p=sum(sum(sum(scale(sum(scale(diff(w4m3,w3m4),m2[1]),sum(scale(diff(w4m2,w2m4),-m3[1]),scale(diff(w3m2,w2m3),m4[1]))),m1[2]),sum(scale(sum(scale(diff(w4m3,w3m4),m1[1]),sum(scale(diff(w4m1,w1m4),-m3[1]),scale(diff(w3m1,w1m3),m4[1]))),-m2[2]),scale(sum(scale(diff(w4m2,w2m4),m1[1]),sum(scale(diff(w4m1,w1m4),-m2[1]),scale(diff(w2m1,w1m2),m4[1]))),m3[2]))),sum(scale(sum(scale(diff(w3m2,w2m3),m1[1]),sum(scale(diff(w3m1,w1m3),-m2[1]),scale(diff(w2m1,w1m2),m3[1]))),-m4[2]),sum(scale(sum(scale(diff(w4m3,w3m4),m1[1]),sum(scale(diff(w4m1,w1m4),-m3[1]),scale(diff(w3m1,w1m3),m4[1]))),m0[2]),scale(sum(scale(diff(w4m3,w3m4),m0[1]),sum(scale(diff(w4m0,w0m4),-m3[1]),scale(diff(w3m0,w0m3),m4[1]))),-m1[2])))),sum(sum(scale(sum(scale(diff(w4m1,w1m4),m0[1]),sum(scale(diff(w4m0,w0m4),-m1[1]),scale(diff(w1m0,w0m1),m4[1]))),m3[2]),sum(scale(sum(scale(diff(w3m1,w1m3),m0[1]),sum(scale(diff(w3m0,w0m3),-m1[1]),scale(diff(w1m0,w0m1),m3[1]))),-m4[2]),scale(sum(scale(diff(w3m2,w2m3),m1[1]),sum(scale(diff(w3m1,w1m3),-m2[1]),scale(diff(w2m1,w1m2),m3[1]))),m0[2]))),sum(scale(sum(scale(diff(w3m2,w2m3),m0[1]),sum(scale(diff(w3m0,w0m3),-m2[1]),scale(diff(w2m0,w0m2),m3[1]))),-m1[2]),sum(scale(sum(scale(diff(w3m1,w1m3),m0[1]),sum(scale(diff(w3m0,w0m3),-m1[1]),scale(diff(w1m0,w0m1),m3[1]))),m2[2]),scale(sum(scale(diff(w2m1,w1m2),m0[1]),sum(scale(diff(w2m0,w0m2),-m1[1]),scale(diff(w1m0,w0m1),m2[1]))),-m3[2])))));var n=sum(sum(sum(scale(sum(scale(diff(w4m3,w3m4),m2[1]),sum(scale(diff(w4m2,w2m4),-m3[1]),scale(diff(w3m2,w2m3),m4[1]))),m0[2]),scale(sum(scale(diff(w4m3,w3m4),m0[1]),sum(scale(diff(w4m0,w0m4),-m3[1]),scale(diff(w3m0,w0m3),m4[1]))),-m2[2])),sum(scale(sum(scale(diff(w4m2,w2m4),m0[1]),sum(scale(diff(w4m0,w0m4),-m2[1]),scale(diff(w2m0,w0m2),m4[1]))),m3[2]),scale(sum(scale(diff(w3m2,w2m3),m0[1]),sum(scale(diff(w3m0,w0m3),-m2[1]),scale(diff(w2m0,w0m2),m3[1]))),-m4[2]))),sum(sum(scale(sum(scale(diff(w4m2,w2m4),m1[1]),sum(scale(diff(w4m1,w1m4),-m2[1]),scale(diff(w2m1,w1m2),m4[1]))),m0[2]),scale(sum(scale(diff(w4m2,w2m4),m0[1]),sum(scale(diff(w4m0,w0m4),-m2[1]),scale(diff(w2m0,w0m2),m4[1]))),-m1[2])),sum(scale(sum(scale(diff(w4m1,w1m4),m0[1]),sum(scale(diff(w4m0,w0m4),-m1[1]),scale(diff(w1m0,w0m1),m4[1]))),m2[2]),scale(sum(scale(diff(w2m1,w1m2),m0[1]),sum(scale(diff(w2m0,w0m2),-m1[1]),scale(diff(w1m0,w0m1),m2[1]))),-m4[2]))));var d=diff(p,n);return d[d.length-1];}return exactInSphere5;}function inSphere6(sum,diff,prod,scale){function exactInSphere6(m0,m1,m2,m3,m4,m5){var w0=sum(sum(prod(m0[0],m0[0]),prod(m0[1],m0[1])),sum(prod(m0[2],m0[2]),prod(m0[3],m0[3])));var w0m1=scale(w0,m1[0]);var w0m2=scale(w0,m2[0]);var w0m3=scale(w0,m3[0]);var w0m4=scale(w0,m4[0]);var w0m5=scale(w0,m5[0]);var w1=sum(sum(prod(m1[0],m1[0]),prod(m1[1],m1[1])),sum(prod(m1[2],m1[2]),prod(m1[3],m1[3])));var w1m0=scale(w1,m0[0]);var w1m2=scale(w1,m2[0]);var w1m3=scale(w1,m3[0]);var w1m4=scale(w1,m4[0]);var w1m5=scale(w1,m5[0]);var w2=sum(sum(prod(m2[0],m2[0]),prod(m2[1],m2[1])),sum(prod(m2[2],m2[2]),prod(m2[3],m2[3])));var w2m0=scale(w2,m0[0]);var w2m1=scale(w2,m1[0]);var w2m3=scale(w2,m3[0]);var w2m4=scale(w2,m4[0]);var w2m5=scale(w2,m5[0]);var w3=sum(sum(prod(m3[0],m3[0]),prod(m3[1],m3[1])),sum(prod(m3[2],m3[2]),prod(m3[3],m3[3])));var w3m0=scale(w3,m0[0]);var w3m1=scale(w3,m1[0]);var w3m2=scale(w3,m2[0]);var w3m4=scale(w3,m4[0]);var w3m5=scale(w3,m5[0]);var w4=sum(sum(prod(m4[0],m4[0]),prod(m4[1],m4[1])),sum(prod(m4[2],m4[2]),prod(m4[3],m4[3])));var w4m0=scale(w4,m0[0]);var w4m1=scale(w4,m1[0]);var w4m2=scale(w4,m2[0]);var w4m3=scale(w4,m3[0]);var w4m5=scale(w4,m5[0]);var w5=sum(sum(prod(m5[0],m5[0]),prod(m5[1],m5[1])),sum(prod(m5[2],m5[2]),prod(m5[3],m5[3])));var w5m0=scale(w5,m0[0]);var w5m1=scale(w5,m1[0]);var w5m2=scale(w5,m2[0]);var w5m3=scale(w5,m3[0]);var w5m4=scale(w5,m4[0]);var p=sum(sum(sum(scale(sum(sum(scale(sum(scale(diff(w5m4,w4m5),m3[1]),sum(scale(diff(w5m3,w3m5),-m4[1]),scale(diff(w4m3,w3m4),m5[1]))),m2[2]),scale(sum(scale(diff(w5m4,w4m5),m2[1]),sum(scale(diff(w5m2,w2m5),-m4[1]),scale(diff(w4m2,w2m4),m5[1]))),-m3[2])),sum(scale(sum(scale(diff(w5m3,w3m5),m2[1]),sum(scale(diff(w5m2,w2m5),-m3[1]),scale(diff(w3m2,w2m3),m5[1]))),m4[2]),scale(sum(scale(diff(w4m3,w3m4),m2[1]),sum(scale(diff(w4m2,w2m4),-m3[1]),scale(diff(w3m2,w2m3),m4[1]))),-m5[2]))),m1[3]),sum(scale(sum(sum(scale(sum(scale(diff(w5m4,w4m5),m3[1]),sum(scale(diff(w5m3,w3m5),-m4[1]),scale(diff(w4m3,w3m4),m5[1]))),m1[2]),scale(sum(scale(diff(w5m4,w4m5),m1[1]),sum(scale(diff(w5m1,w1m5),-m4[1]),scale(diff(w4m1,w1m4),m5[1]))),-m3[2])),sum(scale(sum(scale(diff(w5m3,w3m5),m1[1]),sum(scale(diff(w5m1,w1m5),-m3[1]),scale(diff(w3m1,w1m3),m5[1]))),m4[2]),scale(sum(scale(diff(w4m3,w3m4),m1[1]),sum(scale(diff(w4m1,w1m4),-m3[1]),scale(diff(w3m1,w1m3),m4[1]))),-m5[2]))),-m2[3]),scale(sum(sum(scale(sum(scale(diff(w5m4,w4m5),m2[1]),sum(scale(diff(w5m2,w2m5),-m4[1]),scale(diff(w4m2,w2m4),m5[1]))),m1[2]),scale(sum(scale(diff(w5m4,w4m5),m1[1]),sum(scale(diff(w5m1,w1m5),-m4[1]),scale(diff(w4m1,w1m4),m5[1]))),-m2[2])),sum(scale(sum(scale(diff(w5m2,w2m5),m1[1]),sum(scale(diff(w5m1,w1m5),-m2[1]),scale(diff(w2m1,w1m2),m5[1]))),m4[2]),scale(sum(scale(diff(w4m2,w2m4),m1[1]),sum(scale(diff(w4m1,w1m4),-m2[1]),scale(diff(w2m1,w1m2),m4[1]))),-m5[2]))),m3[3]))),sum(sum(scale(sum(sum(scale(sum(scale(diff(w5m3,w3m5),m2[1]),sum(scale(diff(w5m2,w2m5),-m3[1]),scale(diff(w3m2,w2m3),m5[1]))),m1[2]),scale(sum(scale(diff(w5m3,w3m5),m1[1]),sum(scale(diff(w5m1,w1m5),-m3[1]),scale(diff(w3m1,w1m3),m5[1]))),-m2[2])),sum(scale(sum(scale(diff(w5m2,w2m5),m1[1]),sum(scale(diff(w5m1,w1m5),-m2[1]),scale(diff(w2m1,w1m2),m5[1]))),m3[2]),scale(sum(scale(diff(w3m2,w2m3),m1[1]),sum(scale(diff(w3m1,w1m3),-m2[1]),scale(diff(w2m1,w1m2),m3[1]))),-m5[2]))),-m4[3]),scale(sum(sum(scale(sum(scale(diff(w4m3,w3m4),m2[1]),sum(scale(diff(w4m2,w2m4),-m3[1]),scale(diff(w3m2,w2m3),m4[1]))),m1[2]),scale(sum(scale(diff(w4m3,w3m4),m1[1]),sum(scale(diff(w4m1,w1m4),-m3[1]),scale(diff(w3m1,w1m3),m4[1]))),-m2[2])),sum(scale(sum(scale(diff(w4m2,w2m4),m1[1]),sum(scale(diff(w4m1,w1m4),-m2[1]),scale(diff(w2m1,w1m2),m4[1]))),m3[2]),scale(sum(scale(diff(w3m2,w2m3),m1[1]),sum(scale(diff(w3m1,w1m3),-m2[1]),scale(diff(w2m1,w1m2),m3[1]))),-m4[2]))),m5[3])),sum(scale(sum(sum(scale(sum(scale(diff(w5m4,w4m5),m3[1]),sum(scale(diff(w5m3,w3m5),-m4[1]),scale(diff(w4m3,w3m4),m5[1]))),m1[2]),scale(sum(scale(diff(w5m4,w4m5),m1[1]),sum(scale(diff(w5m1,w1m5),-m4[1]),scale(diff(w4m1,w1m4),m5[1]))),-m3[2])),sum(scale(sum(scale(diff(w5m3,w3m5),m1[1]),sum(scale(diff(w5m1,w1m5),-m3[1]),scale(diff(w3m1,w1m3),m5[1]))),m4[2]),scale(sum(scale(diff(w4m3,w3m4),m1[1]),sum(scale(diff(w4m1,w1m4),-m3[1]),scale(diff(w3m1,w1m3),m4[1]))),-m5[2]))),m0[3]),scale(sum(sum(scale(sum(scale(diff(w5m4,w4m5),m3[1]),sum(scale(diff(w5m3,w3m5),-m4[1]),scale(diff(w4m3,w3m4),m5[1]))),m0[2]),scale(sum(scale(diff(w5m4,w4m5),m0[1]),sum(scale(diff(w5m0,w0m5),-m4[1]),scale(diff(w4m0,w0m4),m5[1]))),-m3[2])),sum(scale(sum(scale(diff(w5m3,w3m5),m0[1]),sum(scale(diff(w5m0,w0m5),-m3[1]),scale(diff(w3m0,w0m3),m5[1]))),m4[2]),scale(sum(scale(diff(w4m3,w3m4),m0[1]),sum(scale(diff(w4m0,w0m4),-m3[1]),scale(diff(w3m0,w0m3),m4[1]))),-m5[2]))),-m1[3])))),sum(sum(sum(scale(sum(sum(scale(sum(scale(diff(w5m4,w4m5),m1[1]),sum(scale(diff(w5m1,w1m5),-m4[1]),scale(diff(w4m1,w1m4),m5[1]))),m0[2]),scale(sum(scale(diff(w5m4,w4m5),m0[1]),sum(scale(diff(w5m0,w0m5),-m4[1]),scale(diff(w4m0,w0m4),m5[1]))),-m1[2])),sum(scale(sum(scale(diff(w5m1,w1m5),m0[1]),sum(scale(diff(w5m0,w0m5),-m1[1]),scale(diff(w1m0,w0m1),m5[1]))),m4[2]),scale(sum(scale(diff(w4m1,w1m4),m0[1]),sum(scale(diff(w4m0,w0m4),-m1[1]),scale(diff(w1m0,w0m1),m4[1]))),-m5[2]))),m3[3]),scale(sum(sum(scale(sum(scale(diff(w5m3,w3m5),m1[1]),sum(scale(diff(w5m1,w1m5),-m3[1]),scale(diff(w3m1,w1m3),m5[1]))),m0[2]),scale(sum(scale(diff(w5m3,w3m5),m0[1]),sum(scale(diff(w5m0,w0m5),-m3[1]),scale(diff(w3m0,w0m3),m5[1]))),-m1[2])),sum(scale(sum(scale(diff(w5m1,w1m5),m0[1]),sum(scale(diff(w5m0,w0m5),-m1[1]),scale(diff(w1m0,w0m1),m5[1]))),m3[2]),scale(sum(scale(diff(w3m1,w1m3),m0[1]),sum(scale(diff(w3m0,w0m3),-m1[1]),scale(diff(w1m0,w0m1),m3[1]))),-m5[2]))),-m4[3])),sum(scale(sum(sum(scale(sum(scale(diff(w4m3,w3m4),m1[1]),sum(scale(diff(w4m1,w1m4),-m3[1]),scale(diff(w3m1,w1m3),m4[1]))),m0[2]),scale(sum(scale(diff(w4m3,w3m4),m0[1]),sum(scale(diff(w4m0,w0m4),-m3[1]),scale(diff(w3m0,w0m3),m4[1]))),-m1[2])),sum(scale(sum(scale(diff(w4m1,w1m4),m0[1]),sum(scale(diff(w4m0,w0m4),-m1[1]),scale(diff(w1m0,w0m1),m4[1]))),m3[2]),scale(sum(scale(diff(w3m1,w1m3),m0[1]),sum(scale(diff(w3m0,w0m3),-m1[1]),scale(diff(w1m0,w0m1),m3[1]))),-m4[2]))),m5[3]),scale(sum(sum(scale(sum(scale(diff(w5m3,w3m5),m2[1]),sum(scale(diff(w5m2,w2m5),-m3[1]),scale(diff(w3m2,w2m3),m5[1]))),m1[2]),scale(sum(scale(diff(w5m3,w3m5),m1[1]),sum(scale(diff(w5m1,w1m5),-m3[1]),scale(diff(w3m1,w1m3),m5[1]))),-m2[2])),sum(scale(sum(scale(diff(w5m2,w2m5),m1[1]),sum(scale(diff(w5m1,w1m5),-m2[1]),scale(diff(w2m1,w1m2),m5[1]))),m3[2]),scale(sum(scale(diff(w3m2,w2m3),m1[1]),sum(scale(diff(w3m1,w1m3),-m2[1]),scale(diff(w2m1,w1m2),m3[1]))),-m5[2]))),m0[3]))),sum(sum(scale(sum(sum(scale(sum(scale(diff(w5m3,w3m5),m2[1]),sum(scale(diff(w5m2,w2m5),-m3[1]),scale(diff(w3m2,w2m3),m5[1]))),m0[2]),scale(sum(scale(diff(w5m3,w3m5),m0[1]),sum(scale(diff(w5m0,w0m5),-m3[1]),scale(diff(w3m0,w0m3),m5[1]))),-m2[2])),sum(scale(sum(scale(diff(w5m2,w2m5),m0[1]),sum(scale(diff(w5m0,w0m5),-m2[1]),scale(diff(w2m0,w0m2),m5[1]))),m3[2]),scale(sum(scale(diff(w3m2,w2m3),m0[1]),sum(scale(diff(w3m0,w0m3),-m2[1]),scale(diff(w2m0,w0m2),m3[1]))),-m5[2]))),-m1[3]),scale(sum(sum(scale(sum(scale(diff(w5m3,w3m5),m1[1]),sum(scale(diff(w5m1,w1m5),-m3[1]),scale(diff(w3m1,w1m3),m5[1]))),m0[2]),scale(sum(scale(diff(w5m3,w3m5),m0[1]),sum(scale(diff(w5m0,w0m5),-m3[1]),scale(diff(w3m0,w0m3),m5[1]))),-m1[2])),sum(scale(sum(scale(diff(w5m1,w1m5),m0[1]),sum(scale(diff(w5m0,w0m5),-m1[1]),scale(diff(w1m0,w0m1),m5[1]))),m3[2]),scale(sum(scale(diff(w3m1,w1m3),m0[1]),sum(scale(diff(w3m0,w0m3),-m1[1]),scale(diff(w1m0,w0m1),m3[1]))),-m5[2]))),m2[3])),sum(scale(sum(sum(scale(sum(scale(diff(w5m2,w2m5),m1[1]),sum(scale(diff(w5m1,w1m5),-m2[1]),scale(diff(w2m1,w1m2),m5[1]))),m0[2]),scale(sum(scale(diff(w5m2,w2m5),m0[1]),sum(scale(diff(w5m0,w0m5),-m2[1]),scale(diff(w2m0,w0m2),m5[1]))),-m1[2])),sum(scale(sum(scale(diff(w5m1,w1m5),m0[1]),sum(scale(diff(w5m0,w0m5),-m1[1]),scale(diff(w1m0,w0m1),m5[1]))),m2[2]),scale(sum(scale(diff(w2m1,w1m2),m0[1]),sum(scale(diff(w2m0,w0m2),-m1[1]),scale(diff(w1m0,w0m1),m2[1]))),-m5[2]))),-m3[3]),scale(sum(sum(scale(sum(scale(diff(w3m2,w2m3),m1[1]),sum(scale(diff(w3m1,w1m3),-m2[1]),scale(diff(w2m1,w1m2),m3[1]))),m0[2]),scale(sum(scale(diff(w3m2,w2m3),m0[1]),sum(scale(diff(w3m0,w0m3),-m2[1]),scale(diff(w2m0,w0m2),m3[1]))),-m1[2])),sum(scale(sum(scale(diff(w3m1,w1m3),m0[1]),sum(scale(diff(w3m0,w0m3),-m1[1]),scale(diff(w1m0,w0m1),m3[1]))),m2[2]),scale(sum(scale(diff(w2m1,w1m2),m0[1]),sum(scale(diff(w2m0,w0m2),-m1[1]),scale(diff(w1m0,w0m1),m2[1]))),-m3[2]))),m5[3])))));var n=sum(sum(sum(scale(sum(sum(scale(sum(scale(diff(w5m4,w4m5),m3[1]),sum(scale(diff(w5m3,w3m5),-m4[1]),scale(diff(w4m3,w3m4),m5[1]))),m2[2]),scale(sum(scale(diff(w5m4,w4m5),m2[1]),sum(scale(diff(w5m2,w2m5),-m4[1]),scale(diff(w4m2,w2m4),m5[1]))),-m3[2])),sum(scale(sum(scale(diff(w5m3,w3m5),m2[1]),sum(scale(diff(w5m2,w2m5),-m3[1]),scale(diff(w3m2,w2m3),m5[1]))),m4[2]),scale(sum(scale(diff(w4m3,w3m4),m2[1]),sum(scale(diff(w4m2,w2m4),-m3[1]),scale(diff(w3m2,w2m3),m4[1]))),-m5[2]))),m0[3]),sum(scale(sum(sum(scale(sum(scale(diff(w5m4,w4m5),m3[1]),sum(scale(diff(w5m3,w3m5),-m4[1]),scale(diff(w4m3,w3m4),m5[1]))),m0[2]),scale(sum(scale(diff(w5m4,w4m5),m0[1]),sum(scale(diff(w5m0,w0m5),-m4[1]),scale(diff(w4m0,w0m4),m5[1]))),-m3[2])),sum(scale(sum(scale(diff(w5m3,w3m5),m0[1]),sum(scale(diff(w5m0,w0m5),-m3[1]),scale(diff(w3m0,w0m3),m5[1]))),m4[2]),scale(sum(scale(diff(w4m3,w3m4),m0[1]),sum(scale(diff(w4m0,w0m4),-m3[1]),scale(diff(w3m0,w0m3),m4[1]))),-m5[2]))),-m2[3]),scale(sum(sum(scale(sum(scale(diff(w5m4,w4m5),m2[1]),sum(scale(diff(w5m2,w2m5),-m4[1]),scale(diff(w4m2,w2m4),m5[1]))),m0[2]),scale(sum(scale(diff(w5m4,w4m5),m0[1]),sum(scale(diff(w5m0,w0m5),-m4[1]),scale(diff(w4m0,w0m4),m5[1]))),-m2[2])),sum(scale(sum(scale(diff(w5m2,w2m5),m0[1]),sum(scale(diff(w5m0,w0m5),-m2[1]),scale(diff(w2m0,w0m2),m5[1]))),m4[2]),scale(sum(scale(diff(w4m2,w2m4),m0[1]),sum(scale(diff(w4m0,w0m4),-m2[1]),scale(diff(w2m0,w0m2),m4[1]))),-m5[2]))),m3[3]))),sum(sum(scale(sum(sum(scale(sum(scale(diff(w5m3,w3m5),m2[1]),sum(scale(diff(w5m2,w2m5),-m3[1]),scale(diff(w3m2,w2m3),m5[1]))),m0[2]),scale(sum(scale(diff(w5m3,w3m5),m0[1]),sum(scale(diff(w5m0,w0m5),-m3[1]),scale(diff(w3m0,w0m3),m5[1]))),-m2[2])),sum(scale(sum(scale(diff(w5m2,w2m5),m0[1]),sum(scale(diff(w5m0,w0m5),-m2[1]),scale(diff(w2m0,w0m2),m5[1]))),m3[2]),scale(sum(scale(diff(w3m2,w2m3),m0[1]),sum(scale(diff(w3m0,w0m3),-m2[1]),scale(diff(w2m0,w0m2),m3[1]))),-m5[2]))),-m4[3]),scale(sum(sum(scale(sum(scale(diff(w4m3,w3m4),m2[1]),sum(scale(diff(w4m2,w2m4),-m3[1]),scale(diff(w3m2,w2m3),m4[1]))),m0[2]),scale(sum(scale(diff(w4m3,w3m4),m0[1]),sum(scale(diff(w4m0,w0m4),-m3[1]),scale(diff(w3m0,w0m3),m4[1]))),-m2[2])),sum(scale(sum(scale(diff(w4m2,w2m4),m0[1]),sum(scale(diff(w4m0,w0m4),-m2[1]),scale(diff(w2m0,w0m2),m4[1]))),m3[2]),scale(sum(scale(diff(w3m2,w2m3),m0[1]),sum(scale(diff(w3m0,w0m3),-m2[1]),scale(diff(w2m0,w0m2),m3[1]))),-m4[2]))),m5[3])),sum(scale(sum(sum(scale(sum(scale(diff(w5m4,w4m5),m2[1]),sum(scale(diff(w5m2,w2m5),-m4[1]),scale(diff(w4m2,w2m4),m5[1]))),m1[2]),scale(sum(scale(diff(w5m4,w4m5),m1[1]),sum(scale(diff(w5m1,w1m5),-m4[1]),scale(diff(w4m1,w1m4),m5[1]))),-m2[2])),sum(scale(sum(scale(diff(w5m2,w2m5),m1[1]),sum(scale(diff(w5m1,w1m5),-m2[1]),scale(diff(w2m1,w1m2),m5[1]))),m4[2]),scale(sum(scale(diff(w4m2,w2m4),m1[1]),sum(scale(diff(w4m1,w1m4),-m2[1]),scale(diff(w2m1,w1m2),m4[1]))),-m5[2]))),m0[3]),scale(sum(sum(scale(sum(scale(diff(w5m4,w4m5),m2[1]),sum(scale(diff(w5m2,w2m5),-m4[1]),scale(diff(w4m2,w2m4),m5[1]))),m0[2]),scale(sum(scale(diff(w5m4,w4m5),m0[1]),sum(scale(diff(w5m0,w0m5),-m4[1]),scale(diff(w4m0,w0m4),m5[1]))),-m2[2])),sum(scale(sum(scale(diff(w5m2,w2m5),m0[1]),sum(scale(diff(w5m0,w0m5),-m2[1]),scale(diff(w2m0,w0m2),m5[1]))),m4[2]),scale(sum(scale(diff(w4m2,w2m4),m0[1]),sum(scale(diff(w4m0,w0m4),-m2[1]),scale(diff(w2m0,w0m2),m4[1]))),-m5[2]))),-m1[3])))),sum(sum(sum(scale(sum(sum(scale(sum(scale(diff(w5m4,w4m5),m1[1]),sum(scale(diff(w5m1,w1m5),-m4[1]),scale(diff(w4m1,w1m4),m5[1]))),m0[2]),scale(sum(scale(diff(w5m4,w4m5),m0[1]),sum(scale(diff(w5m0,w0m5),-m4[1]),scale(diff(w4m0,w0m4),m5[1]))),-m1[2])),sum(scale(sum(scale(diff(w5m1,w1m5),m0[1]),sum(scale(diff(w5m0,w0m5),-m1[1]),scale(diff(w1m0,w0m1),m5[1]))),m4[2]),scale(sum(scale(diff(w4m1,w1m4),m0[1]),sum(scale(diff(w4m0,w0m4),-m1[1]),scale(diff(w1m0,w0m1),m4[1]))),-m5[2]))),m2[3]),scale(sum(sum(scale(sum(scale(diff(w5m2,w2m5),m1[1]),sum(scale(diff(w5m1,w1m5),-m2[1]),scale(diff(w2m1,w1m2),m5[1]))),m0[2]),scale(sum(scale(diff(w5m2,w2m5),m0[1]),sum(scale(diff(w5m0,w0m5),-m2[1]),scale(diff(w2m0,w0m2),m5[1]))),-m1[2])),sum(scale(sum(scale(diff(w5m1,w1m5),m0[1]),sum(scale(diff(w5m0,w0m5),-m1[1]),scale(diff(w1m0,w0m1),m5[1]))),m2[2]),scale(sum(scale(diff(w2m1,w1m2),m0[1]),sum(scale(diff(w2m0,w0m2),-m1[1]),scale(diff(w1m0,w0m1),m2[1]))),-m5[2]))),-m4[3])),sum(scale(sum(sum(scale(sum(scale(diff(w4m2,w2m4),m1[1]),sum(scale(diff(w4m1,w1m4),-m2[1]),scale(diff(w2m1,w1m2),m4[1]))),m0[2]),scale(sum(scale(diff(w4m2,w2m4),m0[1]),sum(scale(diff(w4m0,w0m4),-m2[1]),scale(diff(w2m0,w0m2),m4[1]))),-m1[2])),sum(scale(sum(scale(diff(w4m1,w1m4),m0[1]),sum(scale(diff(w4m0,w0m4),-m1[1]),scale(diff(w1m0,w0m1),m4[1]))),m2[2]),scale(sum(scale(diff(w2m1,w1m2),m0[1]),sum(scale(diff(w2m0,w0m2),-m1[1]),scale(diff(w1m0,w0m1),m2[1]))),-m4[2]))),m5[3]),scale(sum(sum(scale(sum(scale(diff(w4m3,w3m4),m2[1]),sum(scale(diff(w4m2,w2m4),-m3[1]),scale(diff(w3m2,w2m3),m4[1]))),m1[2]),scale(sum(scale(diff(w4m3,w3m4),m1[1]),sum(scale(diff(w4m1,w1m4),-m3[1]),scale(diff(w3m1,w1m3),m4[1]))),-m2[2])),sum(scale(sum(scale(diff(w4m2,w2m4),m1[1]),sum(scale(diff(w4m1,w1m4),-m2[1]),scale(diff(w2m1,w1m2),m4[1]))),m3[2]),scale(sum(scale(diff(w3m2,w2m3),m1[1]),sum(scale(diff(w3m1,w1m3),-m2[1]),scale(diff(w2m1,w1m2),m3[1]))),-m4[2]))),m0[3]))),sum(sum(scale(sum(sum(scale(sum(scale(diff(w4m3,w3m4),m2[1]),sum(scale(diff(w4m2,w2m4),-m3[1]),scale(diff(w3m2,w2m3),m4[1]))),m0[2]),scale(sum(scale(diff(w4m3,w3m4),m0[1]),sum(scale(diff(w4m0,w0m4),-m3[1]),scale(diff(w3m0,w0m3),m4[1]))),-m2[2])),sum(scale(sum(scale(diff(w4m2,w2m4),m0[1]),sum(scale(diff(w4m0,w0m4),-m2[1]),scale(diff(w2m0,w0m2),m4[1]))),m3[2]),scale(sum(scale(diff(w3m2,w2m3),m0[1]),sum(scale(diff(w3m0,w0m3),-m2[1]),scale(diff(w2m0,w0m2),m3[1]))),-m4[2]))),-m1[3]),scale(sum(sum(scale(sum(scale(diff(w4m3,w3m4),m1[1]),sum(scale(diff(w4m1,w1m4),-m3[1]),scale(diff(w3m1,w1m3),m4[1]))),m0[2]),scale(sum(scale(diff(w4m3,w3m4),m0[1]),sum(scale(diff(w4m0,w0m4),-m3[1]),scale(diff(w3m0,w0m3),m4[1]))),-m1[2])),sum(scale(sum(scale(diff(w4m1,w1m4),m0[1]),sum(scale(diff(w4m0,w0m4),-m1[1]),scale(diff(w1m0,w0m1),m4[1]))),m3[2]),scale(sum(scale(diff(w3m1,w1m3),m0[1]),sum(scale(diff(w3m0,w0m3),-m1[1]),scale(diff(w1m0,w0m1),m3[1]))),-m4[2]))),m2[3])),sum(scale(sum(sum(scale(sum(scale(diff(w4m2,w2m4),m1[1]),sum(scale(diff(w4m1,w1m4),-m2[1]),scale(diff(w2m1,w1m2),m4[1]))),m0[2]),scale(sum(scale(diff(w4m2,w2m4),m0[1]),sum(scale(diff(w4m0,w0m4),-m2[1]),scale(diff(w2m0,w0m2),m4[1]))),-m1[2])),sum(scale(sum(scale(diff(w4m1,w1m4),m0[1]),sum(scale(diff(w4m0,w0m4),-m1[1]),scale(diff(w1m0,w0m1),m4[1]))),m2[2]),scale(sum(scale(diff(w2m1,w1m2),m0[1]),sum(scale(diff(w2m0,w0m2),-m1[1]),scale(diff(w1m0,w0m1),m2[1]))),-m4[2]))),-m3[3]),scale(sum(sum(scale(sum(scale(diff(w3m2,w2m3),m1[1]),sum(scale(diff(w3m1,w1m3),-m2[1]),scale(diff(w2m1,w1m2),m3[1]))),m0[2]),scale(sum(scale(diff(w3m2,w2m3),m0[1]),sum(scale(diff(w3m0,w0m3),-m2[1]),scale(diff(w2m0,w0m2),m3[1]))),-m1[2])),sum(scale(sum(scale(diff(w3m1,w1m3),m0[1]),sum(scale(diff(w3m0,w0m3),-m1[1]),scale(diff(w1m0,w0m1),m3[1]))),m2[2]),scale(sum(scale(diff(w2m1,w1m2),m0[1]),sum(scale(diff(w2m0,w0m2),-m1[1]),scale(diff(w1m0,w0m1),m2[1]))),-m3[2]))),m4[3])))));var d=diff(p,n);return d[d.length-1];}return exactInSphere6;}var CACHED=[inSphere0,inSphere1,inSphere2];function slowInSphere(args){var proc=CACHED[args.length];if(!proc){proc=CACHED[args.length]=orientation(args.length);}return proc.apply(undefined,args);}function proc(slow,o0,o1,o2,o3,o4,o5,o6){function testInSphere(a0,a1,a2,a3,a4,a5){switch(arguments.length){case 0:case 1:return 0;case 2:return o2(a0,a1);case 3:return o3(a0,a1,a2);case 4:return o4(a0,a1,a2,a3);case 5:return o5(a0,a1,a2,a3,a4);case 6:return o6(a0,a1,a2,a3,a4,a5);}var s=new Array(arguments.length);for(var i=0;i<arguments.length;++i){s[i]=arguments[i];}return slow(s);}return testInSphere;}function generateInSphereTest(){while(CACHED.length<=NUM_EXPAND){CACHED.push(orientation(CACHED.length));}module.exports=proc.apply(undefined,[slowInSphere].concat(CACHED));for(var i=0;i<=NUM_EXPAND;++i){module.exports[i]=CACHED[i];}}generateInSphereTest();/***/}),/***/727:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_776834__){"use strict";var determinant=__nested_webpack_require_776834__(2962);var NUM_EXPAND=6;function generateSolver(n){var fn=n===2?solve2d:n===3?solve3d:n===4?solve4d:n===5?solve5d:solve6d;if(n<6){return fn(determinant[n]);}return fn(determinant);}function robustLinearSolve0d(){return[[0]];}function robustLinearSolve1d(A,b){return[[b[0]],[A[0][0]]];}function solve2d(det){return function robustLinearSolve2d(A,b){return[det([[+b[0],+A[0][1]],[+b[1],+A[1][1]]]),det([[+A[0][0],+b[0]],[+A[1][0],+b[1]]]),det(A)];};}function solve3d(det){return function robustLinearSolve3d(A,b){return[det([[+b[0],+A[0][1],+A[0][2]],[+b[1],+A[1][1],+A[1][2]],[+b[2],+A[2][1],+A[2][2]]]),det([[+A[0][0],+b[0],+A[0][2]],[+A[1][0],+b[1],+A[1][2]],[+A[2][0],+b[2],+A[2][2]]]),det([[+A[0][0],+A[0][1],+b[0]],[+A[1][0],+A[1][1],+b[1]],[+A[2][0],+A[2][1],+b[2]]]),det(A)];};}function solve4d(det){return function robustLinearSolve4d(A,b){return[det([[+b[0],+A[0][1],+A[0][2],+A[0][3]],[+b[1],+A[1][1],+A[1][2],+A[1][3]],[+b[2],+A[2][1],+A[2][2],+A[2][3]],[+b[3],+A[3][1],+A[3][2],+A[3][3]]]),det([[+A[0][0],+b[0],+A[0][2],+A[0][3]],[+A[1][0],+b[1],+A[1][2],+A[1][3]],[+A[2][0],+b[2],+A[2][2],+A[2][3]],[+A[3][0],+b[3],+A[3][2],+A[3][3]]]),det([[+A[0][0],+A[0][1],+b[0],+A[0][3]],[+A[1][0],+A[1][1],+b[1],+A[1][3]],[+A[2][0],+A[2][1],+b[2],+A[2][3]],[+A[3][0],+A[3][1],+b[3],+A[3][3]]]),det([[+A[0][0],+A[0][1],+A[0][2],+b[0]],[+A[1][0],+A[1][1],+A[1][2],+b[1]],[+A[2][0],+A[2][1],+A[2][2],+b[2]],[+A[3][0],+A[3][1],+A[3][2],+b[3]]]),det(A)];};}function solve5d(det){return function robustLinearSolve5d(A,b){return[det([[+b[0],+A[0][1],+A[0][2],+A[0][3],+A[0][4]],[+b[1],+A[1][1],+A[1][2],+A[1][3],+A[1][4]],[+b[2],+A[2][1],+A[2][2],+A[2][3],+A[2][4]],[+b[3],+A[3][1],+A[3][2],+A[3][3],+A[3][4]],[+b[4],+A[4][1],+A[4][2],+A[4][3],+A[4][4]]]),det([[+A[0][0],+b[0],+A[0][2],+A[0][3],+A[0][4]],[+A[1][0],+b[1],+A[1][2],+A[1][3],+A[1][4]],[+A[2][0],+b[2],+A[2][2],+A[2][3],+A[2][4]],[+A[3][0],+b[3],+A[3][2],+A[3][3],+A[3][4]],[+A[4][0],+b[4],+A[4][2],+A[4][3],+A[4][4]]]),det([[+A[0][0],+A[0][1],+b[0],+A[0][3],+A[0][4]],[+A[1][0],+A[1][1],+b[1],+A[1][3],+A[1][4]],[+A[2][0],+A[2][1],+b[2],+A[2][3],+A[2][4]],[+A[3][0],+A[3][1],+b[3],+A[3][3],+A[3][4]],[+A[4][0],+A[4][1],+b[4],+A[4][3],+A[4][4]]]),det([[+A[0][0],+A[0][1],+A[0][2],+b[0],+A[0][4]],[+A[1][0],+A[1][1],+A[1][2],+b[1],+A[1][4]],[+A[2][0],+A[2][1],+A[2][2],+b[2],+A[2][4]],[+A[3][0],+A[3][1],+A[3][2],+b[3],+A[3][4]],[+A[4][0],+A[4][1],+A[4][2],+b[4],+A[4][4]]]),det([[+A[0][0],+A[0][1],+A[0][2],+A[0][3],+b[0]],[+A[1][0],+A[1][1],+A[1][2],+A[1][3],+b[1]],[+A[2][0],+A[2][1],+A[2][2],+A[2][3],+b[2]],[+A[3][0],+A[3][1],+A[3][2],+A[3][3],+b[3]],[+A[4][0],+A[4][1],+A[4][2],+A[4][3],+b[4]]]),det(A)];};}function solve6d(det){return function robustLinearSolve6d(A,b){return[det([[+b[0],+A[0][1],+A[0][2],+A[0][3],+A[0][4],+A[0][5]],[+b[1],+A[1][1],+A[1][2],+A[1][3],+A[1][4],+A[1][5]],[+b[2],+A[2][1],+A[2][2],+A[2][3],+A[2][4],+A[2][5]],[+b[3],+A[3][1],+A[3][2],+A[3][3],+A[3][4],+A[3][5]],[+b[4],+A[4][1],+A[4][2],+A[4][3],+A[4][4],+A[4][5]],[+b[5],+A[5][1],+A[5][2],+A[5][3],+A[5][4],+A[5][5]]]),det([[+A[0][0],+b[0],+A[0][2],+A[0][3],+A[0][4],+A[0][5]],[+A[1][0],+b[1],+A[1][2],+A[1][3],+A[1][4],+A[1][5]],[+A[2][0],+b[2],+A[2][2],+A[2][3],+A[2][4],+A[2][5]],[+A[3][0],+b[3],+A[3][2],+A[3][3],+A[3][4],+A[3][5]],[+A[4][0],+b[4],+A[4][2],+A[4][3],+A[4][4],+A[4][5]],[+A[5][0],+b[5],+A[5][2],+A[5][3],+A[5][4],+A[5][5]]]),det([[+A[0][0],+A[0][1],+b[0],+A[0][3],+A[0][4],+A[0][5]],[+A[1][0],+A[1][1],+b[1],+A[1][3],+A[1][4],+A[1][5]],[+A[2][0],+A[2][1],+b[2],+A[2][3],+A[2][4],+A[2][5]],[+A[3][0],+A[3][1],+b[3],+A[3][3],+A[3][4],+A[3][5]],[+A[4][0],+A[4][1],+b[4],+A[4][3],+A[4][4],+A[4][5]],[+A[5][0],+A[5][1],+b[5],+A[5][3],+A[5][4],+A[5][5]]]),det([[+A[0][0],+A[0][1],+A[0][2],+b[0],+A[0][4],+A[0][5]],[+A[1][0],+A[1][1],+A[1][2],+b[1],+A[1][4],+A[1][5]],[+A[2][0],+A[2][1],+A[2][2],+b[2],+A[2][4],+A[2][5]],[+A[3][0],+A[3][1],+A[3][2],+b[3],+A[3][4],+A[3][5]],[+A[4][0],+A[4][1],+A[4][2],+b[4],+A[4][4],+A[4][5]],[+A[5][0],+A[5][1],+A[5][2],+b[5],+A[5][4],+A[5][5]]]),det([[+A[0][0],+A[0][1],+A[0][2],+A[0][3],+b[0],+A[0][5]],[+A[1][0],+A[1][1],+A[1][2],+A[1][3],+b[1],+A[1][5]],[+A[2][0],+A[2][1],+A[2][2],+A[2][3],+b[2],+A[2][5]],[+A[3][0],+A[3][1],+A[3][2],+A[3][3],+b[3],+A[3][5]],[+A[4][0],+A[4][1],+A[4][2],+A[4][3],+b[4],+A[4][5]],[+A[5][0],+A[5][1],+A[5][2],+A[5][3],+b[5],+A[5][5]]]),det([[+A[0][0],+A[0][1],+A[0][2],+A[0][3],+A[0][4],+b[0]],[+A[1][0],+A[1][1],+A[1][2],+A[1][3],+A[1][4],+b[1]],[+A[2][0],+A[2][1],+A[2][2],+A[2][3],+A[2][4],+b[2]],[+A[3][0],+A[3][1],+A[3][2],+A[3][3],+A[3][4],+b[3]],[+A[4][0],+A[4][1],+A[4][2],+A[4][3],+A[4][4],+b[4]],[+A[5][0],+A[5][1],+A[5][2],+A[5][3],+A[5][4],+b[5]]]),det(A)];};}var CACHE=[robustLinearSolve0d,robustLinearSolve1d];function proc(s0,s1,s2,s3,s4,s5,CACHE,g){return function dispatchLinearSolve(A,b){switch(A.length){case 0:return s0(A,b);case 1:return s1(A,b);case 2:return s2(A,b);case 3:return s3(A,b);case 4:return s4(A,b);case 5:return s5(A,b);}var s=CACHE[A.length];if(!s)s=CACHE[A.length]=g(A.length);return s(A,b);};}function generateDispatch(){while(CACHE.length<NUM_EXPAND){CACHE.push(generateSolver(CACHE.length));}module.exports=proc.apply(undefined,CACHE.concat([CACHE,generateSolver]));for(var i=0;i<NUM_EXPAND;++i){module.exports[i]=CACHE[i];}}generateDispatch();/***/}),/***/3250:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_782280__){"use strict";var twoProduct=__nested_webpack_require_782280__(5250);var robustSum=__nested_webpack_require_782280__(8210);var robustScale=__nested_webpack_require_782280__(3012);var robustSubtract=__nested_webpack_require_782280__(8545);var NUM_EXPAND=5;var EPSILON=1.1102230246251565e-16;var ERRBOUND3=(3.0+16.0*EPSILON)*EPSILON;var ERRBOUND4=(7.0+56.0*EPSILON)*EPSILON;function orientation_3(sum,prod,scale,sub){return function orientation3Exact(m0,m1,m2){var p=sum(sum(prod(m1[1],m2[0]),prod(-m2[1],m1[0])),sum(prod(m0[1],m1[0]),prod(-m1[1],m0[0])));var n=sum(prod(m0[1],m2[0]),prod(-m2[1],m0[0]));var d=sub(p,n);return d[d.length-1];};}function orientation_4(sum,prod,scale,sub){return function orientation4Exact(m0,m1,m2,m3){var p=sum(sum(scale(sum(prod(m2[1],m3[0]),prod(-m3[1],m2[0])),m1[2]),sum(scale(sum(prod(m1[1],m3[0]),prod(-m3[1],m1[0])),-m2[2]),scale(sum(prod(m1[1],m2[0]),prod(-m2[1],m1[0])),m3[2]))),sum(scale(sum(prod(m1[1],m3[0]),prod(-m3[1],m1[0])),m0[2]),sum(scale(sum(prod(m0[1],m3[0]),prod(-m3[1],m0[0])),-m1[2]),scale(sum(prod(m0[1],m1[0]),prod(-m1[1],m0[0])),m3[2]))));var n=sum(sum(scale(sum(prod(m2[1],m3[0]),prod(-m3[1],m2[0])),m0[2]),sum(scale(sum(prod(m0[1],m3[0]),prod(-m3[1],m0[0])),-m2[2]),scale(sum(prod(m0[1],m2[0]),prod(-m2[1],m0[0])),m3[2]))),sum(scale(sum(prod(m1[1],m2[0]),prod(-m2[1],m1[0])),m0[2]),sum(scale(sum(prod(m0[1],m2[0]),prod(-m2[1],m0[0])),-m1[2]),scale(sum(prod(m0[1],m1[0]),prod(-m1[1],m0[0])),m2[2]))));var d=sub(p,n);return d[d.length-1];};}function orientation_5(sum,prod,scale,sub){return function orientation5Exact(m0,m1,m2,m3,m4){var p=sum(sum(sum(scale(sum(scale(sum(prod(m3[1],m4[0]),prod(-m4[1],m3[0])),m2[2]),sum(scale(sum(prod(m2[1],m4[0]),prod(-m4[1],m2[0])),-m3[2]),scale(sum(prod(m2[1],m3[0]),prod(-m3[1],m2[0])),m4[2]))),m1[3]),sum(scale(sum(scale(sum(prod(m3[1],m4[0]),prod(-m4[1],m3[0])),m1[2]),sum(scale(sum(prod(m1[1],m4[0]),prod(-m4[1],m1[0])),-m3[2]),scale(sum(prod(m1[1],m3[0]),prod(-m3[1],m1[0])),m4[2]))),-m2[3]),scale(sum(scale(sum(prod(m2[1],m4[0]),prod(-m4[1],m2[0])),m1[2]),sum(scale(sum(prod(m1[1],m4[0]),prod(-m4[1],m1[0])),-m2[2]),scale(sum(prod(m1[1],m2[0]),prod(-m2[1],m1[0])),m4[2]))),m3[3]))),sum(scale(sum(scale(sum(prod(m2[1],m3[0]),prod(-m3[1],m2[0])),m1[2]),sum(scale(sum(prod(m1[1],m3[0]),prod(-m3[1],m1[0])),-m2[2]),scale(sum(prod(m1[1],m2[0]),prod(-m2[1],m1[0])),m3[2]))),-m4[3]),sum(scale(sum(scale(sum(prod(m3[1],m4[0]),prod(-m4[1],m3[0])),m1[2]),sum(scale(sum(prod(m1[1],m4[0]),prod(-m4[1],m1[0])),-m3[2]),scale(sum(prod(m1[1],m3[0]),prod(-m3[1],m1[0])),m4[2]))),m0[3]),scale(sum(scale(sum(prod(m3[1],m4[0]),prod(-m4[1],m3[0])),m0[2]),sum(scale(sum(prod(m0[1],m4[0]),prod(-m4[1],m0[0])),-m3[2]),scale(sum(prod(m0[1],m3[0]),prod(-m3[1],m0[0])),m4[2]))),-m1[3])))),sum(sum(scale(sum(scale(sum(prod(m1[1],m4[0]),prod(-m4[1],m1[0])),m0[2]),sum(scale(sum(prod(m0[1],m4[0]),prod(-m4[1],m0[0])),-m1[2]),scale(sum(prod(m0[1],m1[0]),prod(-m1[1],m0[0])),m4[2]))),m3[3]),sum(scale(sum(scale(sum(prod(m1[1],m3[0]),prod(-m3[1],m1[0])),m0[2]),sum(scale(sum(prod(m0[1],m3[0]),prod(-m3[1],m0[0])),-m1[2]),scale(sum(prod(m0[1],m1[0]),prod(-m1[1],m0[0])),m3[2]))),-m4[3]),scale(sum(scale(sum(prod(m2[1],m3[0]),prod(-m3[1],m2[0])),m1[2]),sum(scale(sum(prod(m1[1],m3[0]),prod(-m3[1],m1[0])),-m2[2]),scale(sum(prod(m1[1],m2[0]),prod(-m2[1],m1[0])),m3[2]))),m0[3]))),sum(scale(sum(scale(sum(prod(m2[1],m3[0]),prod(-m3[1],m2[0])),m0[2]),sum(scale(sum(prod(m0[1],m3[0]),prod(-m3[1],m0[0])),-m2[2]),scale(sum(prod(m0[1],m2[0]),prod(-m2[1],m0[0])),m3[2]))),-m1[3]),sum(scale(sum(scale(sum(prod(m1[1],m3[0]),prod(-m3[1],m1[0])),m0[2]),sum(scale(sum(prod(m0[1],m3[0]),prod(-m3[1],m0[0])),-m1[2]),scale(sum(prod(m0[1],m1[0]),prod(-m1[1],m0[0])),m3[2]))),m2[3]),scale(sum(scale(sum(prod(m1[1],m2[0]),prod(-m2[1],m1[0])),m0[2]),sum(scale(sum(prod(m0[1],m2[0]),prod(-m2[1],m0[0])),-m1[2]),scale(sum(prod(m0[1],m1[0]),prod(-m1[1],m0[0])),m2[2]))),-m3[3])))));var n=sum(sum(sum(scale(sum(scale(sum(prod(m3[1],m4[0]),prod(-m4[1],m3[0])),m2[2]),sum(scale(sum(prod(m2[1],m4[0]),prod(-m4[1],m2[0])),-m3[2]),scale(sum(prod(m2[1],m3[0]),prod(-m3[1],m2[0])),m4[2]))),m0[3]),scale(sum(scale(sum(prod(m3[1],m4[0]),prod(-m4[1],m3[0])),m0[2]),sum(scale(sum(prod(m0[1],m4[0]),prod(-m4[1],m0[0])),-m3[2]),scale(sum(prod(m0[1],m3[0]),prod(-m3[1],m0[0])),m4[2]))),-m2[3])),sum(scale(sum(scale(sum(prod(m2[1],m4[0]),prod(-m4[1],m2[0])),m0[2]),sum(scale(sum(prod(m0[1],m4[0]),prod(-m4[1],m0[0])),-m2[2]),scale(sum(prod(m0[1],m2[0]),prod(-m2[1],m0[0])),m4[2]))),m3[3]),scale(sum(scale(sum(prod(m2[1],m3[0]),prod(-m3[1],m2[0])),m0[2]),sum(scale(sum(prod(m0[1],m3[0]),prod(-m3[1],m0[0])),-m2[2]),scale(sum(prod(m0[1],m2[0]),prod(-m2[1],m0[0])),m3[2]))),-m4[3]))),sum(sum(scale(sum(scale(sum(prod(m2[1],m4[0]),prod(-m4[1],m2[0])),m1[2]),sum(scale(sum(prod(m1[1],m4[0]),prod(-m4[1],m1[0])),-m2[2]),scale(sum(prod(m1[1],m2[0]),prod(-m2[1],m1[0])),m4[2]))),m0[3]),scale(sum(scale(sum(prod(m2[1],m4[0]),prod(-m4[1],m2[0])),m0[2]),sum(scale(sum(prod(m0[1],m4[0]),prod(-m4[1],m0[0])),-m2[2]),scale(sum(prod(m0[1],m2[0]),prod(-m2[1],m0[0])),m4[2]))),-m1[3])),sum(scale(sum(scale(sum(prod(m1[1],m4[0]),prod(-m4[1],m1[0])),m0[2]),sum(scale(sum(prod(m0[1],m4[0]),prod(-m4[1],m0[0])),-m1[2]),scale(sum(prod(m0[1],m1[0]),prod(-m1[1],m0[0])),m4[2]))),m2[3]),scale(sum(scale(sum(prod(m1[1],m2[0]),prod(-m2[1],m1[0])),m0[2]),sum(scale(sum(prod(m0[1],m2[0]),prod(-m2[1],m0[0])),-m1[2]),scale(sum(prod(m0[1],m1[0]),prod(-m1[1],m0[0])),m2[2]))),-m4[3]))));var d=sub(p,n);return d[d.length-1];};}function orientation(n){var fn=n===3?orientation_3:n===4?orientation_4:orientation_5;return fn(robustSum,twoProduct,robustScale,robustSubtract);}var orientation3Exact=orientation(3);var orientation4Exact=orientation(4);var CACHED=[function orientation0(){return 0;},function orientation1(){return 0;},function orientation2(a,b){return b[0]-a[0];},function orientation3(a,b,c){var l=(a[1]-c[1])*(b[0]-c[0]);var r=(a[0]-c[0])*(b[1]-c[1]);var det=l-r;var s;if(l>0){if(r<=0){return det;}else{s=l+r;}}else if(l<0){if(r>=0){return det;}else{s=-(l+r);}}else{return det;}var tol=ERRBOUND3*s;if(det>=tol||det<=-tol){return det;}return orientation3Exact(a,b,c);},function orientation4(a,b,c,d){var adx=a[0]-d[0];var bdx=b[0]-d[0];var cdx=c[0]-d[0];var ady=a[1]-d[1];var bdy=b[1]-d[1];var cdy=c[1]-d[1];var adz=a[2]-d[2];var bdz=b[2]-d[2];var cdz=c[2]-d[2];var bdxcdy=bdx*cdy;var cdxbdy=cdx*bdy;var cdxady=cdx*ady;var adxcdy=adx*cdy;var adxbdy=adx*bdy;var bdxady=bdx*ady;var det=adz*(bdxcdy-cdxbdy)+bdz*(cdxady-adxcdy)+cdz*(adxbdy-bdxady);var permanent=(Math.abs(bdxcdy)+Math.abs(cdxbdy))*Math.abs(adz)+(Math.abs(cdxady)+Math.abs(adxcdy))*Math.abs(bdz)+(Math.abs(adxbdy)+Math.abs(bdxady))*Math.abs(cdz);var tol=ERRBOUND4*permanent;if(det>tol||-det>tol){return det;}return orientation4Exact(a,b,c,d);}];function slowOrient(args){var proc=CACHED[args.length];if(!proc){proc=CACHED[args.length]=orientation(args.length);}return proc.apply(undefined,args);}function proc(slow,o0,o1,o2,o3,o4,o5){return function getOrientation(a0,a1,a2,a3,a4){switch(arguments.length){case 0:case 1:return 0;case 2:return o2(a0,a1);case 3:return o3(a0,a1,a2);case 4:return o4(a0,a1,a2,a3);case 5:return o5(a0,a1,a2,a3,a4);}var s=new Array(arguments.length);for(var i=0;i<arguments.length;++i){s[i]=arguments[i];}return slow(s);};}function generateOrientationProc(){while(CACHED.length<=NUM_EXPAND){CACHED.push(orientation(CACHED.length));}module.exports=proc.apply(undefined,[slowOrient].concat(CACHED));for(var i=0;i<=NUM_EXPAND;++i){module.exports[i]=CACHED[i];}}generateOrientationProc();/***/}),/***/5382:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_789887__){"use strict";var robustSum=__nested_webpack_require_789887__(8210);var robustScale=__nested_webpack_require_789887__(3012);module.exports=robustProduct;function robustProduct(a,b){if(a.length===1){return robustScale(b,a[0]);}if(b.length===1){return robustScale(a,b[0]);}if(a.length===0||b.length===0){return[0];}var r=[0];if(a.length<b.length){for(var i=0;i<a.length;++i){r=robustSum(r,robustScale(b,a[i]));}}else{for(var i=0;i<b.length;++i){r=robustSum(r,robustScale(a,b[i]));}}return r;}/***/}),/***/3012:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_790434__){"use strict";var twoProduct=__nested_webpack_require_790434__(5250);var twoSum=__nested_webpack_require_790434__(9362);module.exports=scaleLinearExpansion;function scaleLinearExpansion(e,scale){var n=e.length;if(n===1){var ts=twoProduct(e[0],scale);if(ts[0]){return ts;}return[ts[1]];}var g=new Array(2*n);var q=[0.1,0.1];var t=[0.1,0.1];var count=0;twoProduct(e[0],scale,q);if(q[0]){g[count++]=q[0];}for(var i=1;i<n;++i){twoProduct(e[i],scale,t);var pq=q[1];twoSum(pq,t[0],q);if(q[0]){g[count++]=q[0];}var a=t[1];var b=q[1];var x=a+b;var bv=x-a;var y=b-bv;q[1]=x;if(y){g[count++]=y;}}if(q[1]){g[count++]=q[1];}if(count===0){g[count++]=0.0;}g.length=count;return g;}/***/}),/***/1125:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_791158__){"use strict";module.exports=segmentsIntersect;var orient=__nested_webpack_require_791158__(3250)[3];function checkCollinear(a0,a1,b0,b1){for(var d=0;d<2;++d){var x0=a0[d];var y0=a1[d];var l0=Math.min(x0,y0);var h0=Math.max(x0,y0);var x1=b0[d];var y1=b1[d];var l1=Math.min(x1,y1);var h1=Math.max(x1,y1);if(h1<l0||h0<l1){return false;}}return true;}function segmentsIntersect(a0,a1,b0,b1){var x0=orient(a0,b0,b1);var y0=orient(a1,b0,b1);if(x0>0&&y0>0||x0<0&&y0<0){return false;}var x1=orient(b0,a0,a1);var y1=orient(b1,a0,a1);if(x1>0&&y1>0||x1<0&&y1<0){return false;}//Check for degenerate collinear case
if(x0===0&&y0===0&&x1===0&&y1===0){return checkCollinear(a0,a1,b0,b1);}return true;}/***/}),/***/8545:(/***/function(module){"use strict";module.exports=robustSubtract;//Easy case: Add two scalars
function scalarScalar(a,b){var x=a+b;var bv=x-a;var av=x-bv;var br=b-bv;var ar=a-av;var y=ar+br;if(y){return[y,x];}return[x];}function robustSubtract(e,f){var ne=e.length|0;var nf=f.length|0;if(ne===1&&nf===1){return scalarScalar(e[0],-f[0]);}var n=ne+nf;var g=new Array(n);var count=0;var eptr=0;var fptr=0;var abs=Math.abs;var ei=e[eptr];var ea=abs(ei);var fi=-f[fptr];var fa=abs(fi);var a,b;if(ea<fa){b=ei;eptr+=1;if(eptr<ne){ei=e[eptr];ea=abs(ei);}}else{b=fi;fptr+=1;if(fptr<nf){fi=-f[fptr];fa=abs(fi);}}if(eptr<ne&&ea<fa||fptr>=nf){a=ei;eptr+=1;if(eptr<ne){ei=e[eptr];ea=abs(ei);}}else{a=fi;fptr+=1;if(fptr<nf){fi=-f[fptr];fa=abs(fi);}}var x=a+b;var bv=x-a;var y=b-bv;var q0=y;var q1=x;var _x,_bv,_av,_br,_ar;while(eptr<ne&&fptr<nf){if(ea<fa){a=ei;eptr+=1;if(eptr<ne){ei=e[eptr];ea=abs(ei);}}else{a=fi;fptr+=1;if(fptr<nf){fi=-f[fptr];fa=abs(fi);}}b=q0;x=a+b;bv=x-a;y=b-bv;if(y){g[count++]=y;}_x=q1+x;_bv=_x-q1;_av=_x-_bv;_br=x-_bv;_ar=q1-_av;q0=_ar+_br;q1=_x;}while(eptr<ne){a=ei;b=q0;x=a+b;bv=x-a;y=b-bv;if(y){g[count++]=y;}_x=q1+x;_bv=_x-q1;_av=_x-_bv;_br=x-_bv;_ar=q1-_av;q0=_ar+_br;q1=_x;eptr+=1;if(eptr<ne){ei=e[eptr];}}while(fptr<nf){a=fi;b=q0;x=a+b;bv=x-a;y=b-bv;if(y){g[count++]=y;}_x=q1+x;_bv=_x-q1;_av=_x-_bv;_br=x-_bv;_ar=q1-_av;q0=_ar+_br;q1=_x;fptr+=1;if(fptr<nf){fi=-f[fptr];}}if(q0){g[count++]=q0;}if(q1){g[count++]=q1;}if(!count){g[count++]=0.0;}g.length=count;return g;}/***/}),/***/8210:(/***/function(module){"use strict";module.exports=linearExpansionSum;//Easy case: Add two scalars
function scalarScalar(a,b){var x=a+b;var bv=x-a;var av=x-bv;var br=b-bv;var ar=a-av;var y=ar+br;if(y){return[y,x];}return[x];}function linearExpansionSum(e,f){var ne=e.length|0;var nf=f.length|0;if(ne===1&&nf===1){return scalarScalar(e[0],f[0]);}var n=ne+nf;var g=new Array(n);var count=0;var eptr=0;var fptr=0;var abs=Math.abs;var ei=e[eptr];var ea=abs(ei);var fi=f[fptr];var fa=abs(fi);var a,b;if(ea<fa){b=ei;eptr+=1;if(eptr<ne){ei=e[eptr];ea=abs(ei);}}else{b=fi;fptr+=1;if(fptr<nf){fi=f[fptr];fa=abs(fi);}}if(eptr<ne&&ea<fa||fptr>=nf){a=ei;eptr+=1;if(eptr<ne){ei=e[eptr];ea=abs(ei);}}else{a=fi;fptr+=1;if(fptr<nf){fi=f[fptr];fa=abs(fi);}}var x=a+b;var bv=x-a;var y=b-bv;var q0=y;var q1=x;var _x,_bv,_av,_br,_ar;while(eptr<ne&&fptr<nf){if(ea<fa){a=ei;eptr+=1;if(eptr<ne){ei=e[eptr];ea=abs(ei);}}else{a=fi;fptr+=1;if(fptr<nf){fi=f[fptr];fa=abs(fi);}}b=q0;x=a+b;bv=x-a;y=b-bv;if(y){g[count++]=y;}_x=q1+x;_bv=_x-q1;_av=_x-_bv;_br=x-_bv;_ar=q1-_av;q0=_ar+_br;q1=_x;}while(eptr<ne){a=ei;b=q0;x=a+b;bv=x-a;y=b-bv;if(y){g[count++]=y;}_x=q1+x;_bv=_x-q1;_av=_x-_bv;_br=x-_bv;_ar=q1-_av;q0=_ar+_br;q1=_x;eptr+=1;if(eptr<ne){ei=e[eptr];}}while(fptr<nf){a=fi;b=q0;x=a+b;bv=x-a;y=b-bv;if(y){g[count++]=y;}_x=q1+x;_bv=_x-q1;_av=_x-_bv;_br=x-_bv;_ar=q1-_av;q0=_ar+_br;q1=_x;fptr+=1;if(fptr<nf){fi=f[fptr];}}if(q0){g[count++]=q0;}if(q1){g[count++]=q1;}if(!count){g[count++]=0.0;}g.length=count;return g;}/***/}),/***/9127:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_794929__){"use strict";module.exports=boundary;var bnd=__nested_webpack_require_794929__(6204);var reduce=__nested_webpack_require_794929__(5771);function boundary(cells){return reduce(bnd(cells));}/***/}),/***/7765:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_795175__){"use strict";module.exports=extractContour;var ndarray=__nested_webpack_require_795175__(9618);var pool=__nested_webpack_require_795175__(1888);var ndsort=__nested_webpack_require_795175__(446);var contourAlgorithm=__nested_webpack_require_795175__(1570);function getDimension(cells){var numCells=cells.length;var d=0;for(var i=0;i<numCells;++i){d=Math.max(d,cells[i].length)|0;}return d-1;}function getSigns(values,level){var numVerts=values.length;var vertexSigns=pool.mallocUint8(numVerts);for(var i=0;i<numVerts;++i){vertexSigns[i]=values[i]<level|0;}return vertexSigns;}function getEdges(cells,d){var numCells=cells.length;var maxEdges=d*(d+1)/2*numCells|0;var edges=pool.mallocUint32(maxEdges*2);var ePtr=0;for(var i=0;i<numCells;++i){var c=cells[i];var d=c.length;for(var j=0;j<d;++j){for(var k=0;k<j;++k){var a=c[k];var b=c[j];edges[ePtr++]=Math.min(a,b)|0;edges[ePtr++]=Math.max(a,b)|0;}}}var nedges=ePtr/2|0;ndsort(ndarray(edges,[nedges,2]));var ptr=2;for(var i=2;i<ePtr;i+=2){if(edges[i-2]===edges[i]&&edges[i-1]===edges[i+1]){continue;}edges[ptr++]=edges[i];edges[ptr++]=edges[i+1];}return ndarray(edges,[ptr/2|0,2]);}function getCrossingWeights(edges,values,signs,level){var edata=edges.data;var numEdges=edges.shape[0];var weights=pool.mallocDouble(numEdges);var ptr=0;for(var i=0;i<numEdges;++i){var a=edata[2*i];var b=edata[2*i+1];if(signs[a]===signs[b]){continue;}var va=values[a];var vb=values[b];edata[2*ptr]=a;edata[2*ptr+1]=b;weights[ptr++]=(vb-level)/(vb-va);}edges.shape[0]=ptr;return ndarray(weights,[ptr]);}function getCascade(edges,numVerts){var result=pool.mallocInt32(numVerts*2);var numEdges=edges.shape[0];var edata=edges.data;result[0]=0;var lastV=0;for(var i=0;i<numEdges;++i){var a=edata[2*i];if(a!==lastV){result[2*lastV+1]=i;while(++lastV<a){result[2*lastV]=i;result[2*lastV+1]=i;}result[2*lastV]=i;}}result[2*lastV+1]=numEdges;while(++lastV<numVerts){result[2*lastV]=result[2*lastV+1]=numEdges;}return result;}function unpackEdges(edges){var ne=edges.shape[0]|0;var edata=edges.data;var result=new Array(ne);for(var i=0;i<ne;++i){result[i]=[edata[2*i],edata[2*i+1]];}return result;}function extractContour(cells,values,level,d){level=level||0.0;//If user didn't specify `d`, use brute force scan
if(typeof d==='undefined'){d=getDimension(cells);}//Count number of cells
var numCells=cells.length;if(numCells===0||d<1){return{cells:[],vertexIds:[],vertexWeights:[]};}//Read in vertex signs
var vertexSigns=getSigns(values,+level);//First get 1-skeleton, find all crossings
var edges=getEdges(cells,d);var weights=getCrossingWeights(edges,values,vertexSigns,+level);//Build vertex cascade to speed up binary search
var vcascade=getCascade(edges,values.length|0);//Then construct cells
var faces=contourAlgorithm(d)(cells,edges.data,vcascade,vertexSigns);//Unpack data into pretty format
var uedges=unpackEdges(edges);var uweights=[].slice.call(weights.data,0,weights.shape[0]);//Release data
pool.free(vertexSigns);pool.free(edges.data);pool.free(weights.data);pool.free(vcascade);return{cells:faces,vertexIds:uedges,vertexWeights:uweights};}/***/}),/***/1570:(/***/function(module){"use strict";module.exports=getPolygonizer;var allFns=[function cellPolygonizer_0(){function B(C,E,i,j){var a=Math.min(i,j)|0,b=Math.max(i,j)|0,l=C[2*a],h=C[2*a+1];while(l<h){var m=l+h>>1,v=E[2*m+1];if(v===b){return m;}if(b<v){h=m;}else{l=m+1;}}return l;}function getContour0d(F,E,C,S){var n=F.length,R=[];for(var i=0;i<n;++i){var c=F[i],l=c.length;}return R;}return getContour0d;},function cellPolygonizer_1(){function B(C,E,i,j){var a=Math.min(i,j)|0,b=Math.max(i,j)|0,l=C[2*a],h=C[2*a+1];while(l<h){var m=l+h>>1,v=E[2*m+1];if(v===b){return m;}if(b<v){h=m;}else{l=m+1;}}return l;}function getContour1d(F,E,C,S){var n=F.length,R=[];for(var i=0;i<n;++i){var c=F[i],l=c.length;if(l===2){var M=(S[c[0]]<<0)+(S[c[1]]<<1);if(M===0||M===3){continue;}switch(M){case 0:break;case 1:R.push([B(C,E,c[0],c[1])]);break;case 2:R.push([B(C,E,c[1],c[0])]);break;case 3:break;}}}return R;}return getContour1d;},function cellPolygonizer_2(){function B(C,E,i,j){var a=Math.min(i,j)|0,b=Math.max(i,j)|0,l=C[2*a],h=C[2*a+1];while(l<h){var m=l+h>>1,v=E[2*m+1];if(v===b){return m;}if(b<v){h=m;}else{l=m+1;}}return l;}function getContour2d(F,E,C,S){var n=F.length,R=[];for(var i=0;i<n;++i){var c=F[i],l=c.length;if(l===3){var M=(S[c[0]]<<0)+(S[c[1]]<<1)+(S[c[2]]<<2);if(M===0||M===7){continue;}switch(M){case 0:break;case 1:R.push([B(C,E,c[0],c[2]),B(C,E,c[0],c[1])]);break;case 2:R.push([B(C,E,c[1],c[0]),B(C,E,c[1],c[2])]);break;case 3:R.push([B(C,E,c[0],c[2]),B(C,E,c[1],c[2])]);break;case 4:R.push([B(C,E,c[2],c[1]),B(C,E,c[2],c[0])]);break;case 5:R.push([B(C,E,c[2],c[1]),B(C,E,c[0],c[1])]);break;case 6:R.push([B(C,E,c[1],c[0]),B(C,E,c[2],c[0])]);break;case 7:break;}}else if(l===2){var M=(S[c[0]]<<0)+(S[c[1]]<<1);if(M===0||M===3){continue;}switch(M){case 0:break;case 1:R.push([B(C,E,c[0],c[1])]);break;case 2:R.push([B(C,E,c[1],c[0])]);break;case 3:break;}}}return R;}return getContour2d;},function cellPolygonizer_3(){function B(C,E,i,j){var a=Math.min(i,j)|0,b=Math.max(i,j)|0,l=C[2*a],h=C[2*a+1];while(l<h){var m=l+h>>1,v=E[2*m+1];if(v===b){return m;}if(b<v){h=m;}else{l=m+1;}}return l;}function getContour3d(F,E,C,S){var n=F.length,R=[];for(var i=0;i<n;++i){var c=F[i],l=c.length;if(l===4){var M=(S[c[0]]<<0)+(S[c[1]]<<1)+(S[c[2]]<<2)+(S[c[3]]<<3);if(M===0||M===15){continue;}switch(M){case 0:break;case 1:R.push([B(C,E,c[0],c[1]),B(C,E,c[0],c[2]),B(C,E,c[0],c[3])]);break;case 2:R.push([B(C,E,c[1],c[2]),B(C,E,c[1],c[0]),B(C,E,c[1],c[3])]);break;case 3:R.push([B(C,E,c[1],c[2]),B(C,E,c[0],c[2]),B(C,E,c[0],c[3])],[B(C,E,c[1],c[3]),B(C,E,c[1],c[2]),B(C,E,c[0],c[3])]);break;case 4:R.push([B(C,E,c[2],c[0]),B(C,E,c[2],c[1]),B(C,E,c[2],c[3])]);break;case 5:R.push([B(C,E,c[0],c[1]),B(C,E,c[2],c[1]),B(C,E,c[0],c[3])],[B(C,E,c[2],c[1]),B(C,E,c[2],c[3]),B(C,E,c[0],c[3])]);break;case 6:R.push([B(C,E,c[2],c[0]),B(C,E,c[1],c[0]),B(C,E,c[1],c[3])],[B(C,E,c[2],c[3]),B(C,E,c[2],c[0]),B(C,E,c[1],c[3])]);break;case 7:R.push([B(C,E,c[0],c[3]),B(C,E,c[1],c[3]),B(C,E,c[2],c[3])]);break;case 8:R.push([B(C,E,c[3],c[1]),B(C,E,c[3],c[0]),B(C,E,c[3],c[2])]);break;case 9:R.push([B(C,E,c[3],c[1]),B(C,E,c[0],c[1]),B(C,E,c[0],c[2])],[B(C,E,c[3],c[2]),B(C,E,c[3],c[1]),B(C,E,c[0],c[2])]);break;case 10:R.push([B(C,E,c[1],c[0]),B(C,E,c[3],c[0]),B(C,E,c[1],c[2])],[B(C,E,c[3],c[0]),B(C,E,c[3],c[2]),B(C,E,c[1],c[2])]);break;case 11:R.push([B(C,E,c[1],c[2]),B(C,E,c[0],c[2]),B(C,E,c[3],c[2])]);break;case 12:R.push([B(C,E,c[3],c[0]),B(C,E,c[2],c[0]),B(C,E,c[2],c[1])],[B(C,E,c[3],c[1]),B(C,E,c[3],c[0]),B(C,E,c[2],c[1])]);break;case 13:R.push([B(C,E,c[0],c[1]),B(C,E,c[2],c[1]),B(C,E,c[3],c[1])]);break;case 14:R.push([B(C,E,c[2],c[0]),B(C,E,c[1],c[0]),B(C,E,c[3],c[0])]);break;case 15:break;}}else if(l===3){var M=(S[c[0]]<<0)+(S[c[1]]<<1)+(S[c[2]]<<2);if(M===0||M===7){continue;}switch(M){case 0:break;case 1:R.push([B(C,E,c[0],c[2]),B(C,E,c[0],c[1])]);break;case 2:R.push([B(C,E,c[1],c[0]),B(C,E,c[1],c[2])]);break;case 3:R.push([B(C,E,c[0],c[2]),B(C,E,c[1],c[2])]);break;case 4:R.push([B(C,E,c[2],c[1]),B(C,E,c[2],c[0])]);break;case 5:R.push([B(C,E,c[2],c[1]),B(C,E,c[0],c[1])]);break;case 6:R.push([B(C,E,c[1],c[0]),B(C,E,c[2],c[0])]);break;case 7:break;}}else if(l===2){var M=(S[c[0]]<<0)+(S[c[1]]<<1);if(M===0||M===3){continue;}switch(M){case 0:break;case 1:R.push([B(C,E,c[0],c[1])]);break;case 2:R.push([B(C,E,c[1],c[0])]);break;case 3:break;}}}return R;}return getContour3d;}];function getPolygonizer(d){return allFns[d]();}/***/}),/***/6803:(/***/function(__unused_webpack_module,exports,__nested_webpack_require_802727__){"use strict";var __webpack_unused_export__;"use restrict";var bits=__nested_webpack_require_802727__(8828),UnionFind=__nested_webpack_require_802727__(1755);//Returns the dimension of a cell complex
function dimension(cells){var d=0,max=Math.max;for(var i=0,il=cells.length;i<il;++i){d=max(d,cells[i].length);}return d-1;}__webpack_unused_export__=dimension;//Counts the number of vertices in faces
function countVertices(cells){var vc=-1,max=Math.max;for(var i=0,il=cells.length;i<il;++i){var c=cells[i];for(var j=0,jl=c.length;j<jl;++j){vc=max(vc,c[j]);}}return vc+1;}__webpack_unused_export__=countVertices;//Returns a deep copy of cells
function cloneCells(cells){var ncells=new Array(cells.length);for(var i=0,il=cells.length;i<il;++i){ncells[i]=cells[i].slice(0);}return ncells;}__webpack_unused_export__=cloneCells;//Ranks a pair of cells up to permutation
function compareCells(a,b){var n=a.length,t=a.length-b.length,min=Math.min;if(t){return t;}switch(n){case 0:return 0;case 1:return a[0]-b[0];case 2:var d=a[0]+a[1]-b[0]-b[1];if(d){return d;}return min(a[0],a[1])-min(b[0],b[1]);case 3:var l1=a[0]+a[1],m1=b[0]+b[1];d=l1+a[2]-(m1+b[2]);if(d){return d;}var l0=min(a[0],a[1]),m0=min(b[0],b[1]),d=min(l0,a[2])-min(m0,b[2]);if(d){return d;}return min(l0+a[2],l1)-min(m0+b[2],m1);//TODO: Maybe optimize n=4 as well?
default:var as=a.slice(0);as.sort();var bs=b.slice(0);bs.sort();for(var i=0;i<n;++i){t=as[i]-bs[i];if(t){return t;}}return 0;}}exports.Fw=compareCells;function compareZipped(a,b){return compareCells(a[0],b[0]);}//Puts a cell complex into normal order for the purposes of findCell queries
function normalize(cells,attr){if(attr){var len=cells.length;var zipped=new Array(len);for(var i=0;i<len;++i){zipped[i]=[cells[i],attr[i]];}zipped.sort(compareZipped);for(var i=0;i<len;++i){cells[i]=zipped[i][0];attr[i]=zipped[i][1];}return cells;}else{cells.sort(compareCells);return cells;}}__webpack_unused_export__=normalize;//Removes all duplicate cells in the complex
function unique(cells){if(cells.length===0){return[];}var ptr=1,len=cells.length;for(var i=1;i<len;++i){var a=cells[i];if(compareCells(a,cells[i-1])){if(i===ptr){ptr++;continue;}cells[ptr++]=a;}}cells.length=ptr;return cells;}__webpack_unused_export__=unique;//Finds a cell in a normalized cell complex
function findCell(cells,c){var lo=0,hi=cells.length-1,r=-1;while(lo<=hi){var mid=lo+hi>>1,s=compareCells(cells[mid],c);if(s<=0){if(s===0){r=mid;}lo=mid+1;}else if(s>0){hi=mid-1;}}return r;}__webpack_unused_export__=findCell;//Builds an index for an n-cell.  This is more general than dual, but less efficient
function incidence(from_cells,to_cells){var index=new Array(from_cells.length);for(var i=0,il=index.length;i<il;++i){index[i]=[];}var b=[];for(var i=0,n=to_cells.length;i<n;++i){var c=to_cells[i];var cl=c.length;for(var k=1,kn=1<<cl;k<kn;++k){b.length=bits.popCount(k);var l=0;for(var j=0;j<cl;++j){if(k&1<<j){b[l++]=c[j];}}var idx=findCell(from_cells,b);if(idx<0){continue;}while(true){index[idx++].push(i);if(idx>=from_cells.length||compareCells(from_cells[idx],b)!==0){break;}}}}return index;}__webpack_unused_export__=incidence;//Computes the dual of the mesh.  This is basically an optimized version of buildIndex for the situation where from_cells is just the list of vertices
function dual(cells,vertex_count){if(!vertex_count){return incidence(unique(skeleton(cells,0)),cells,0);}var res=new Array(vertex_count);for(var i=0;i<vertex_count;++i){res[i]=[];}for(var i=0,len=cells.length;i<len;++i){var c=cells[i];for(var j=0,cl=c.length;j<cl;++j){res[c[j]].push(i);}}return res;}__webpack_unused_export__=dual;//Enumerates all cells in the complex
function explode(cells){var result=[];for(var i=0,il=cells.length;i<il;++i){var c=cells[i],cl=c.length|0;for(var j=1,jl=1<<cl;j<jl;++j){var b=[];for(var k=0;k<cl;++k){if(j>>>k&1){b.push(c[k]);}}result.push(b);}}return normalize(result);}__webpack_unused_export__=explode;//Enumerates all of the n-cells of a cell complex
function skeleton(cells,n){if(n<0){return[];}var result=[],k0=(1<<n+1)-1;for(var i=0;i<cells.length;++i){var c=cells[i];for(var k=k0;k<1<<c.length;k=bits.nextCombination(k)){var b=new Array(n+1),l=0;for(var j=0;j<c.length;++j){if(k&1<<j){b[l++]=c[j];}}result.push(b);}}return normalize(result);}__webpack_unused_export__=skeleton;//Computes the boundary of all cells, does not remove duplicates
function boundary(cells){var res=[];for(var i=0,il=cells.length;i<il;++i){var c=cells[i];for(var j=0,cl=c.length;j<cl;++j){var b=new Array(c.length-1);for(var k=0,l=0;k<cl;++k){if(k!==j){b[l++]=c[k];}}res.push(b);}}return normalize(res);}__webpack_unused_export__=boundary;//Computes connected components for a dense cell complex
function connectedComponents_dense(cells,vertex_count){var labels=new UnionFind(vertex_count);for(var i=0;i<cells.length;++i){var c=cells[i];for(var j=0;j<c.length;++j){for(var k=j+1;k<c.length;++k){labels.link(c[j],c[k]);}}}var components=[],component_labels=labels.ranks;for(var i=0;i<component_labels.length;++i){component_labels[i]=-1;}for(var i=0;i<cells.length;++i){var l=labels.find(cells[i][0]);if(component_labels[l]<0){component_labels[l]=components.length;components.push([cells[i].slice(0)]);}else{components[component_labels[l]].push(cells[i].slice(0));}}return components;}//Computes connected components for a sparse graph
function connectedComponents_sparse(cells){var vertices=unique(normalize(skeleton(cells,0))),labels=new UnionFind(vertices.length);for(var i=0;i<cells.length;++i){var c=cells[i];for(var j=0;j<c.length;++j){var vj=findCell(vertices,[c[j]]);for(var k=j+1;k<c.length;++k){labels.link(vj,findCell(vertices,[c[k]]));}}}var components=[],component_labels=labels.ranks;for(var i=0;i<component_labels.length;++i){component_labels[i]=-1;}for(var i=0;i<cells.length;++i){var l=labels.find(findCell(vertices,[cells[i][0]]));if(component_labels[l]<0){component_labels[l]=components.length;components.push([cells[i].slice(0)]);}else{components[component_labels[l]].push(cells[i].slice(0));}}return components;}//Computes connected components for a cell complex
function connectedComponents(cells,vertex_count){if(vertex_count){return connectedComponents_dense(cells,vertex_count);}return connectedComponents_sparse(cells);}__webpack_unused_export__=connectedComponents;/***/}),/***/3105:(/***/function(__unused_webpack_module,exports){"use strict";/**
 * Bit twiddling hacks for JavaScript.
 *
 * Author: Mikola Lysenko
 *
 * Ported from Stanford bit twiddling hack library:
 *    http://graphics.stanford.edu/~seander/bithacks.html
 */"use restrict";//Number of bits in an integer
var INT_BITS=32;//Constants
exports.INT_BITS=INT_BITS;exports.INT_MAX=0x7fffffff;exports.INT_MIN=-1<<INT_BITS-1;//Returns -1, 0, +1 depending on sign of x
exports.sign=function(v){return(v>0)-(v<0);};//Computes absolute value of integer
exports.abs=function(v){var mask=v>>INT_BITS-1;return(v^mask)-mask;};//Computes minimum of integers x and y
exports.min=function(x,y){return y^(x^y)&-(x<y);};//Computes maximum of integers x and y
exports.max=function(x,y){return x^(x^y)&-(x<y);};//Checks if a number is a power of two
exports.isPow2=function(v){return!(v&v-1)&&!!v;};//Computes log base 2 of v
exports.log2=function(v){var r,shift;r=(v>0xFFFF)<<4;v>>>=r;shift=(v>0xFF)<<3;v>>>=shift;r|=shift;shift=(v>0xF)<<2;v>>>=shift;r|=shift;shift=(v>0x3)<<1;v>>>=shift;r|=shift;return r|v>>1;};//Computes log base 10 of v
exports.log10=function(v){return v>=1000000000?9:v>=100000000?8:v>=10000000?7:v>=1000000?6:v>=100000?5:v>=10000?4:v>=1000?3:v>=100?2:v>=10?1:0;};//Counts number of bits
exports.popCount=function(v){v=v-(v>>>1&0x55555555);v=(v&0x33333333)+(v>>>2&0x33333333);return(v+(v>>>4)&0xF0F0F0F)*0x1010101>>>24;};//Counts number of trailing zeros
function countTrailingZeros(v){var c=32;v&=-v;if(v)c--;if(v&0x0000FFFF)c-=16;if(v&0x00FF00FF)c-=8;if(v&0x0F0F0F0F)c-=4;if(v&0x33333333)c-=2;if(v&0x55555555)c-=1;return c;}exports.countTrailingZeros=countTrailingZeros;//Rounds to next power of 2
exports.nextPow2=function(v){v+=v===0;--v;v|=v>>>1;v|=v>>>2;v|=v>>>4;v|=v>>>8;v|=v>>>16;return v+1;};//Rounds down to previous power of 2
exports.prevPow2=function(v){v|=v>>>1;v|=v>>>2;v|=v>>>4;v|=v>>>8;v|=v>>>16;return v-(v>>>1);};//Computes parity of word
exports.parity=function(v){v^=v>>>16;v^=v>>>8;v^=v>>>4;v&=0xf;return 0x6996>>>v&1;};var REVERSE_TABLE=new Array(256);(function(tab){for(var i=0;i<256;++i){var v=i,r=i,s=7;for(v>>>=1;v;v>>>=1){r<<=1;r|=v&1;--s;}tab[i]=r<<s&0xff;}})(REVERSE_TABLE);//Reverse bits in a 32 bit word
exports.reverse=function(v){return REVERSE_TABLE[v&0xff]<<24|REVERSE_TABLE[v>>>8&0xff]<<16|REVERSE_TABLE[v>>>16&0xff]<<8|REVERSE_TABLE[v>>>24&0xff];};//Interleave bits of 2 coordinates with 16 bits.  Useful for fast quadtree codes
exports.interleave2=function(x,y){x&=0xFFFF;x=(x|x<<8)&0x00FF00FF;x=(x|x<<4)&0x0F0F0F0F;x=(x|x<<2)&0x33333333;x=(x|x<<1)&0x55555555;y&=0xFFFF;y=(y|y<<8)&0x00FF00FF;y=(y|y<<4)&0x0F0F0F0F;y=(y|y<<2)&0x33333333;y=(y|y<<1)&0x55555555;return x|y<<1;};//Extracts the nth interleaved component
exports.deinterleave2=function(v,n){v=v>>>n&0x55555555;v=(v|v>>>1)&0x33333333;v=(v|v>>>2)&0x0F0F0F0F;v=(v|v>>>4)&0x00FF00FF;v=(v|v>>>16)&0x000FFFF;return v<<16>>16;};//Interleave bits of 3 coordinates, each with 10 bits.  Useful for fast octree codes
exports.interleave3=function(x,y,z){x&=0x3FF;x=(x|x<<16)&4278190335;x=(x|x<<8)&251719695;x=(x|x<<4)&3272356035;x=(x|x<<2)&1227133513;y&=0x3FF;y=(y|y<<16)&4278190335;y=(y|y<<8)&251719695;y=(y|y<<4)&3272356035;y=(y|y<<2)&1227133513;x|=y<<1;z&=0x3FF;z=(z|z<<16)&4278190335;z=(z|z<<8)&251719695;z=(z|z<<4)&3272356035;z=(z|z<<2)&1227133513;return x|z<<2;};//Extracts nth interleaved component of a 3-tuple
exports.deinterleave3=function(v,n){v=v>>>n&1227133513;v=(v|v>>>2)&3272356035;v=(v|v>>>4)&251719695;v=(v|v>>>8)&4278190335;v=(v|v>>>16)&0x3FF;return v<<22>>22;};//Computes next combination in colexicographic order (this is mistakenly called nextPermutation on the bit twiddling hacks page)
exports.nextCombination=function(v){var t=v|v-1;return t+1|(~t&-~t)-1>>>countTrailingZeros(v)+1;};/***/}),/***/2014:(/***/function(__unused_webpack_module,exports,__nested_webpack_require_812878__){"use strict";"use restrict";var bits=__nested_webpack_require_812878__(3105),UnionFind=__nested_webpack_require_812878__(4623);//Returns the dimension of a cell complex
function dimension(cells){var d=0,max=Math.max;for(var i=0,il=cells.length;i<il;++i){d=max(d,cells[i].length);}return d-1;}exports.dimension=dimension;//Counts the number of vertices in faces
function countVertices(cells){var vc=-1,max=Math.max;for(var i=0,il=cells.length;i<il;++i){var c=cells[i];for(var j=0,jl=c.length;j<jl;++j){vc=max(vc,c[j]);}}return vc+1;}exports.countVertices=countVertices;//Returns a deep copy of cells
function cloneCells(cells){var ncells=new Array(cells.length);for(var i=0,il=cells.length;i<il;++i){ncells[i]=cells[i].slice(0);}return ncells;}exports.cloneCells=cloneCells;//Ranks a pair of cells up to permutation
function compareCells(a,b){var n=a.length,t=a.length-b.length,min=Math.min;if(t){return t;}switch(n){case 0:return 0;case 1:return a[0]-b[0];case 2:var d=a[0]+a[1]-b[0]-b[1];if(d){return d;}return min(a[0],a[1])-min(b[0],b[1]);case 3:var l1=a[0]+a[1],m1=b[0]+b[1];d=l1+a[2]-(m1+b[2]);if(d){return d;}var l0=min(a[0],a[1]),m0=min(b[0],b[1]),d=min(l0,a[2])-min(m0,b[2]);if(d){return d;}return min(l0+a[2],l1)-min(m0+b[2],m1);//TODO: Maybe optimize n=4 as well?
default:var as=a.slice(0);as.sort();var bs=b.slice(0);bs.sort();for(var i=0;i<n;++i){t=as[i]-bs[i];if(t){return t;}}return 0;}}exports.compareCells=compareCells;function compareZipped(a,b){return compareCells(a[0],b[0]);}//Puts a cell complex into normal order for the purposes of findCell queries
function normalize(cells,attr){if(attr){var len=cells.length;var zipped=new Array(len);for(var i=0;i<len;++i){zipped[i]=[cells[i],attr[i]];}zipped.sort(compareZipped);for(var i=0;i<len;++i){cells[i]=zipped[i][0];attr[i]=zipped[i][1];}return cells;}else{cells.sort(compareCells);return cells;}}exports.normalize=normalize;//Removes all duplicate cells in the complex
function unique(cells){if(cells.length===0){return[];}var ptr=1,len=cells.length;for(var i=1;i<len;++i){var a=cells[i];if(compareCells(a,cells[i-1])){if(i===ptr){ptr++;continue;}cells[ptr++]=a;}}cells.length=ptr;return cells;}exports.unique=unique;//Finds a cell in a normalized cell complex
function findCell(cells,c){var lo=0,hi=cells.length-1,r=-1;while(lo<=hi){var mid=lo+hi>>1,s=compareCells(cells[mid],c);if(s<=0){if(s===0){r=mid;}lo=mid+1;}else if(s>0){hi=mid-1;}}return r;}exports.findCell=findCell;//Builds an index for an n-cell.  This is more general than dual, but less efficient
function incidence(from_cells,to_cells){var index=new Array(from_cells.length);for(var i=0,il=index.length;i<il;++i){index[i]=[];}var b=[];for(var i=0,n=to_cells.length;i<n;++i){var c=to_cells[i];var cl=c.length;for(var k=1,kn=1<<cl;k<kn;++k){b.length=bits.popCount(k);var l=0;for(var j=0;j<cl;++j){if(k&1<<j){b[l++]=c[j];}}var idx=findCell(from_cells,b);if(idx<0){continue;}while(true){index[idx++].push(i);if(idx>=from_cells.length||compareCells(from_cells[idx],b)!==0){break;}}}}return index;}exports.incidence=incidence;//Computes the dual of the mesh.  This is basically an optimized version of buildIndex for the situation where from_cells is just the list of vertices
function dual(cells,vertex_count){if(!vertex_count){return incidence(unique(skeleton(cells,0)),cells,0);}var res=new Array(vertex_count);for(var i=0;i<vertex_count;++i){res[i]=[];}for(var i=0,len=cells.length;i<len;++i){var c=cells[i];for(var j=0,cl=c.length;j<cl;++j){res[c[j]].push(i);}}return res;}exports.dual=dual;//Enumerates all cells in the complex
function explode(cells){var result=[];for(var i=0,il=cells.length;i<il;++i){var c=cells[i],cl=c.length|0;for(var j=1,jl=1<<cl;j<jl;++j){var b=[];for(var k=0;k<cl;++k){if(j>>>k&1){b.push(c[k]);}}result.push(b);}}return normalize(result);}exports.explode=explode;//Enumerates all of the n-cells of a cell complex
function skeleton(cells,n){if(n<0){return[];}var result=[],k0=(1<<n+1)-1;for(var i=0;i<cells.length;++i){var c=cells[i];for(var k=k0;k<1<<c.length;k=bits.nextCombination(k)){var b=new Array(n+1),l=0;for(var j=0;j<c.length;++j){if(k&1<<j){b[l++]=c[j];}}result.push(b);}}return normalize(result);}exports.skeleton=skeleton;//Computes the boundary of all cells, does not remove duplicates
function boundary(cells){var res=[];for(var i=0,il=cells.length;i<il;++i){var c=cells[i];for(var j=0,cl=c.length;j<cl;++j){var b=new Array(c.length-1);for(var k=0,l=0;k<cl;++k){if(k!==j){b[l++]=c[k];}}res.push(b);}}return normalize(res);}exports.boundary=boundary;//Computes connected components for a dense cell complex
function connectedComponents_dense(cells,vertex_count){var labels=new UnionFind(vertex_count);for(var i=0;i<cells.length;++i){var c=cells[i];for(var j=0;j<c.length;++j){for(var k=j+1;k<c.length;++k){labels.link(c[j],c[k]);}}}var components=[],component_labels=labels.ranks;for(var i=0;i<component_labels.length;++i){component_labels[i]=-1;}for(var i=0;i<cells.length;++i){var l=labels.find(cells[i][0]);if(component_labels[l]<0){component_labels[l]=components.length;components.push([cells[i].slice(0)]);}else{components[component_labels[l]].push(cells[i].slice(0));}}return components;}//Computes connected components for a sparse graph
function connectedComponents_sparse(cells){var vertices=unique(normalize(skeleton(cells,0))),labels=new UnionFind(vertices.length);for(var i=0;i<cells.length;++i){var c=cells[i];for(var j=0;j<c.length;++j){var vj=findCell(vertices,[c[j]]);for(var k=j+1;k<c.length;++k){labels.link(vj,findCell(vertices,[c[k]]));}}}var components=[],component_labels=labels.ranks;for(var i=0;i<component_labels.length;++i){component_labels[i]=-1;}for(var i=0;i<cells.length;++i){var l=labels.find(findCell(vertices,[cells[i][0]]));if(component_labels[l]<0){component_labels[l]=components.length;components.push([cells[i].slice(0)]);}else{components[component_labels[l]].push(cells[i].slice(0));}}return components;}//Computes connected components for a cell complex
function connectedComponents(cells,vertex_count){if(vertex_count){return connectedComponents_dense(cells,vertex_count);}return connectedComponents_sparse(cells);}exports.connectedComponents=connectedComponents;/***/}),/***/4623:(/***/function(module){"use strict";"use restrict";module.exports=UnionFind;function UnionFind(count){this.roots=new Array(count);this.ranks=new Array(count);for(var i=0;i<count;++i){this.roots[i]=i;this.ranks[i]=0;}}UnionFind.prototype.length=function(){return this.roots.length;};UnionFind.prototype.makeSet=function(){var n=this.roots.length;this.roots.push(n);this.ranks.push(0);return n;};UnionFind.prototype.find=function(x){var roots=this.roots;while(roots[x]!==x){var y=roots[x];roots[x]=roots[y];x=y;}return x;};UnionFind.prototype.link=function(x,y){var xr=this.find(x),yr=this.find(y);if(xr===yr){return;}var ranks=this.ranks,roots=this.roots,xd=ranks[xr],yd=ranks[yr];if(xd<yd){roots[xr]=yr;}else if(yd<xd){roots[yr]=xr;}else{roots[yr]=xr;++ranks[xr];}};/***/}),/***/5878:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_819896__){"use strict";module.exports=simplifyPolygon;var orient=__nested_webpack_require_819896__(3250);var sc=__nested_webpack_require_819896__(2014);function errorWeight(base,a,b){var area=Math.abs(orient(base,a,b));var perim=Math.sqrt(Math.pow(a[0]-b[0],2)+Math.pow(a[1]-b[1],2));return area/perim;}function simplifyPolygon(cells,positions,minArea){var n=positions.length;var nc=cells.length;var inv=new Array(n);var outv=new Array(n);var weights=new Array(n);var dead=new Array(n);//Initialize tables
for(var i=0;i<n;++i){inv[i]=outv[i]=-1;weights[i]=Infinity;dead[i]=false;}//Compute neighbors
for(var i=0;i<nc;++i){var c=cells[i];if(c.length!==2){throw new Error("Input must be a graph");}var s=c[1];var t=c[0];if(outv[t]!==-1){outv[t]=-2;}else{outv[t]=s;}if(inv[s]!==-1){inv[s]=-2;}else{inv[s]=t;}}//Updates the weight for vertex i
function computeWeight(i){if(dead[i]){return Infinity;}//TODO: Check that the line segment doesn't cross once simplified
var s=inv[i];var t=outv[i];if(s<0||t<0){return Infinity;}else{return errorWeight(positions[i],positions[s],positions[t]);}}//Swaps two nodes on the heap (i,j) are the index of the nodes
function heapSwap(i,j){var a=heap[i];var b=heap[j];heap[i]=b;heap[j]=a;index[a]=j;index[b]=i;}//Returns the weight of node i on the heap
function heapWeight(i){return weights[heap[i]];}function heapParent(i){if(i&1){return i-1>>1;}return(i>>1)-1;}//Bubble element i down the heap
function heapDown(i){var w=heapWeight(i);while(true){var tw=w;var left=2*i+1;var right=2*(i+1);var next=i;if(left<heapCount){var lw=heapWeight(left);if(lw<tw){next=left;tw=lw;}}if(right<heapCount){var rw=heapWeight(right);if(rw<tw){next=right;}}if(next===i){return i;}heapSwap(i,next);i=next;}}//Bubbles element i up the heap
function heapUp(i){var w=heapWeight(i);while(i>0){var parent=heapParent(i);if(parent>=0){var pw=heapWeight(parent);if(w<pw){heapSwap(i,parent);i=parent;continue;}}return i;}}//Pop minimum element
function heapPop(){if(heapCount>0){var head=heap[0];heapSwap(0,heapCount-1);heapCount-=1;heapDown(0);return head;}return-1;}//Update heap item i
function heapUpdate(i,w){var a=heap[i];if(weights[a]===w){return i;}weights[a]=-Infinity;heapUp(i);heapPop();weights[a]=w;heapCount+=1;return heapUp(heapCount-1);}//Kills a vertex (assume vertex already removed from heap)
function kill(i){if(dead[i]){return;}//Kill vertex
dead[i]=true;//Fixup topology
var s=inv[i];var t=outv[i];if(inv[t]>=0){inv[t]=s;}if(outv[s]>=0){outv[s]=t;}//Update weights on s and t
if(index[s]>=0){heapUpdate(index[s],computeWeight(s));}if(index[t]>=0){heapUpdate(index[t],computeWeight(t));}}//Initialize weights and heap
var heap=[];var index=new Array(n);for(var i=0;i<n;++i){var w=weights[i]=computeWeight(i);if(w<Infinity){index[i]=heap.length;heap.push(i);}else{index[i]=-1;}}var heapCount=heap.length;for(var i=heapCount>>1;i>=0;--i){heapDown(i);}//Kill vertices
while(true){var hmin=heapPop();if(hmin<0||weights[hmin]>minArea){break;}kill(hmin);}//Build collapsed vertex table
var npositions=[];for(var i=0;i<n;++i){if(!dead[i]){index[i]=npositions.length;npositions.push(positions[i].slice());}}var nv=npositions.length;function tortoiseHare(seq,start){if(seq[start]<0){return start;}var t=start;var h=start;do{//Walk two steps with h
var nh=seq[h];if(!dead[h]||nh<0||nh===h){break;}h=nh;nh=seq[h];if(!dead[h]||nh<0||nh===h){break;}h=nh;//Walk one step with t
t=seq[t];}while(t!==h);//Compress cycles
for(var v=start;v!==h;v=seq[v]){seq[v]=h;}return h;}var ncells=[];cells.forEach(function(c){var tin=tortoiseHare(inv,c[0]);var tout=tortoiseHare(outv,c[1]);if(tin>=0&&tout>=0&&tin!==tout){var cin=index[tin];var cout=index[tout];if(cin!==cout){ncells.push([cin,cout]);}}});//Normalize result
sc.unique(sc.normalize(ncells));//Return final list of cells
return{positions:npositions,edges:ncells};}/***/}),/***/1303:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_823769__){"use strict";module.exports=orderSegments;var orient=__nested_webpack_require_823769__(3250);function horizontalOrder(a,b){var bl,br;if(b[0][0]<b[1][0]){bl=b[0];br=b[1];}else if(b[0][0]>b[1][0]){bl=b[1];br=b[0];}else{var alo=Math.min(a[0][1],a[1][1]);var ahi=Math.max(a[0][1],a[1][1]);var blo=Math.min(b[0][1],b[1][1]);var bhi=Math.max(b[0][1],b[1][1]);if(ahi<blo){return ahi-blo;}if(alo>bhi){return alo-bhi;}return ahi-bhi;}var al,ar;if(a[0][1]<a[1][1]){al=a[0];ar=a[1];}else{al=a[1];ar=a[0];}var d=orient(br,bl,al);if(d){return d;}d=orient(br,bl,ar);if(d){return d;}return ar-br;}function orderSegments(b,a){var al,ar;if(a[0][0]<a[1][0]){al=a[0];ar=a[1];}else if(a[0][0]>a[1][0]){al=a[1];ar=a[0];}else{return horizontalOrder(a,b);}var bl,br;if(b[0][0]<b[1][0]){bl=b[0];br=b[1];}else if(b[0][0]>b[1][0]){bl=b[1];br=b[0];}else{return-horizontalOrder(b,a);}var d1=orient(al,ar,br);var d2=orient(al,ar,bl);if(d1<0){if(d2<=0){return d1;}}else if(d1>0){if(d2>=0){return d1;}}else if(d2){return d2;}d1=orient(br,bl,ar);d2=orient(br,bl,al);if(d1<0){if(d2<=0){return d1;}}else if(d1>0){if(d2>=0){return d1;}}else if(d2){return d2;}return ar[0]-br[0];}/***/}),/***/4209:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_824985__){"use strict";module.exports=createSlabDecomposition;var bounds=__nested_webpack_require_824985__(2478);var createRBTree=__nested_webpack_require_824985__(3840);var orient=__nested_webpack_require_824985__(3250);var orderSegments=__nested_webpack_require_824985__(1303);function SlabDecomposition(slabs,coordinates,horizontal){this.slabs=slabs;this.coordinates=coordinates;this.horizontal=horizontal;}var proto=SlabDecomposition.prototype;function compareHorizontal(e,y){return e.y-y;}function searchBucket(root,p){var lastNode=null;while(root){var seg=root.key;var l,r;if(seg[0][0]<seg[1][0]){l=seg[0];r=seg[1];}else{l=seg[1];r=seg[0];}var o=orient(l,r,p);if(o<0){root=root.left;}else if(o>0){if(p[0]!==seg[1][0]){lastNode=root;root=root.right;}else{var val=searchBucket(root.right,p);if(val){return val;}root=root.left;}}else{if(p[0]!==seg[1][0]){return root;}else{var val=searchBucket(root.right,p);if(val){return val;}root=root.left;}}}return lastNode;}proto.castUp=function(p){var bucket=bounds.le(this.coordinates,p[0]);if(bucket<0){return-1;}var root=this.slabs[bucket];var hitNode=searchBucket(this.slabs[bucket],p);var lastHit=-1;if(hitNode){lastHit=hitNode.value;}//Edge case: need to handle horizontal segments (sucks)
if(this.coordinates[bucket]===p[0]){var lastSegment=null;if(hitNode){lastSegment=hitNode.key;}if(bucket>0){var otherHitNode=searchBucket(this.slabs[bucket-1],p);if(otherHitNode){if(lastSegment){if(orderSegments(otherHitNode.key,lastSegment)>0){lastSegment=otherHitNode.key;lastHit=otherHitNode.value;}}else{lastHit=otherHitNode.value;lastSegment=otherHitNode.key;}}}var horiz=this.horizontal[bucket];if(horiz.length>0){var hbucket=bounds.ge(horiz,p[1],compareHorizontal);if(hbucket<horiz.length){var e=horiz[hbucket];if(p[1]===e.y){if(e.closed){return e.index;}else{while(hbucket<horiz.length-1&&horiz[hbucket+1].y===p[1]){hbucket=hbucket+1;e=horiz[hbucket];if(e.closed){return e.index;}}if(e.y===p[1]&&!e.start){hbucket=hbucket+1;if(hbucket>=horiz.length){return lastHit;}e=horiz[hbucket];}}}//Check if e is above/below last segment
if(e.start){if(lastSegment){var o=orient(lastSegment[0],lastSegment[1],[p[0],e.y]);if(lastSegment[0][0]>lastSegment[1][0]){o=-o;}if(o>0){lastHit=e.index;}}else{lastHit=e.index;}}else if(e.y!==p[1]){lastHit=e.index;}}}}return lastHit;};function IntervalSegment(y,index,start,closed){this.y=y;this.index=index;this.start=start;this.closed=closed;}function Event(x,segment,create,index){this.x=x;this.segment=segment;this.create=create;this.index=index;}function createSlabDecomposition(segments){var numSegments=segments.length;var numEvents=2*numSegments;var events=new Array(numEvents);for(var i=0;i<numSegments;++i){var s=segments[i];var f=s[0][0]<s[1][0];events[2*i]=new Event(s[0][0],s,f,i);events[2*i+1]=new Event(s[1][0],s,!f,i);}events.sort(function(a,b){var d=a.x-b.x;if(d){return d;}d=a.create-b.create;if(d){return d;}return Math.min(a.segment[0][1],a.segment[1][1])-Math.min(b.segment[0][1],b.segment[1][1]);});var tree=createRBTree(orderSegments);var slabs=[];var lines=[];var horizontal=[];var lastX=-Infinity;for(var i=0;i<numEvents;){var x=events[i].x;var horiz=[];while(i<numEvents){var e=events[i];if(e.x!==x){break;}i+=1;if(e.segment[0][0]===e.x&&e.segment[1][0]===e.x){if(e.create){if(e.segment[0][1]<e.segment[1][1]){horiz.push(new IntervalSegment(e.segment[0][1],e.index,true,true));horiz.push(new IntervalSegment(e.segment[1][1],e.index,false,false));}else{horiz.push(new IntervalSegment(e.segment[1][1],e.index,true,false));horiz.push(new IntervalSegment(e.segment[0][1],e.index,false,true));}}}else{if(e.create){tree=tree.insert(e.segment,e.index);}else{tree=tree.remove(e.segment);}}}slabs.push(tree.root);lines.push(x);horizontal.push(horiz);}return new SlabDecomposition(slabs,lines,horizontal);}/***/}),/***/5202:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_828800__){"use strict";var robustDot=__nested_webpack_require_828800__(1944);var robustSum=__nested_webpack_require_828800__(8210);module.exports=splitPolygon;module.exports.positive=positive;module.exports.negative=negative;function planeT(p,plane){var r=robustSum(robustDot(p,plane),[plane[plane.length-1]]);return r[r.length-1];}//Can't do this exactly and emit a floating point result
function lerpW(a,wa,b,wb){var d=wb-wa;var t=-wa/d;if(t<0.0){t=0.0;}else if(t>1.0){t=1.0;}var ti=1.0-t;var n=a.length;var r=new Array(n);for(var i=0;i<n;++i){r[i]=t*a[i]+ti*b[i];}return r;}function splitPolygon(points,plane){var pos=[];var neg=[];var a=planeT(points[points.length-1],plane);for(var s=points[points.length-1],t=points[0],i=0;i<points.length;++i,s=t){t=points[i];var b=planeT(t,plane);if(a<0&&b>0||a>0&&b<0){var p=lerpW(s,b,t,a);pos.push(p);neg.push(p.slice());}if(b<0){neg.push(t.slice());}else if(b>0){pos.push(t.slice());}else{pos.push(t.slice());neg.push(t.slice());}a=b;}return{positive:pos,negative:neg};}function positive(points,plane){var pos=[];var a=planeT(points[points.length-1],plane);for(var s=points[points.length-1],t=points[0],i=0;i<points.length;++i,s=t){t=points[i];var b=planeT(t,plane);if(a<0&&b>0||a>0&&b<0){pos.push(lerpW(s,b,t,a));}if(b>=0){pos.push(t.slice());}a=b;}return pos;}function negative(points,plane){var neg=[];var a=planeT(points[points.length-1],plane);for(var s=points[points.length-1],t=points[0],i=0;i<points.length;++i,s=t){t=points[i];var b=planeT(t,plane);if(a<0&&b>0||a>0&&b<0){neg.push(lerpW(s,b,t,a));}if(b<=0){neg.push(t.slice());}a=b;}return neg;}/***/}),/***/3387:(/***/function(module,exports,__nested_webpack_require_830429__){var __WEBPACK_AMD_DEFINE_RESULT__;/* global window, exports, define */!function(){'use strict';var re={not_string:/[^s]/,not_bool:/[^t]/,not_type:/[^T]/,not_primitive:/[^v]/,number:/[diefg]/,numeric_arg:/[bcdiefguxX]/,json:/[j]/,not_json:/[^j]/,text:/^[^\x25]+/,modulo:/^\x25{2}/,placeholder:/^\x25(?:([1-9]\d*)\$|\(([^)]+)\))?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-gijostTuvxX])/,key:/^([a-z_][a-z_\d]*)/i,key_access:/^\.([a-z_][a-z_\d]*)/i,index_access:/^\[(\d+)\]/,sign:/^[+-]/};function sprintf(key){// `arguments` is not an array, but should be fine for this call
return sprintf_format(sprintf_parse(key),arguments);}function vsprintf(fmt,argv){return sprintf.apply(null,[fmt].concat(argv||[]));}function sprintf_format(parse_tree,argv){var cursor=1,tree_length=parse_tree.length,arg,output='',i,k,ph,pad,pad_character,pad_length,is_positive,sign;for(i=0;i<tree_length;i++){if(typeof parse_tree[i]==='string'){output+=parse_tree[i];}else if(typeof parse_tree[i]==='object'){ph=parse_tree[i];// convenience purposes only
if(ph.keys){// keyword argument
arg=argv[cursor];for(k=0;k<ph.keys.length;k++){if(arg==undefined){throw new Error(sprintf('[sprintf] Cannot access property "%s" of undefined value "%s"',ph.keys[k],ph.keys[k-1]));}arg=arg[ph.keys[k]];}}else if(ph.param_no){// positional argument (explicit)
arg=argv[ph.param_no];}else{// positional argument (implicit)
arg=argv[cursor++];}if(re.not_type.test(ph.type)&&re.not_primitive.test(ph.type)&&arg instanceof Function){arg=arg();}if(re.numeric_arg.test(ph.type)&&typeof arg!=='number'&&isNaN(arg)){throw new TypeError(sprintf('[sprintf] expecting number but found %T',arg));}if(re.number.test(ph.type)){is_positive=arg>=0;}switch(ph.type){case'b':arg=parseInt(arg,10).toString(2);break;case'c':arg=String.fromCharCode(parseInt(arg,10));break;case'd':case'i':arg=parseInt(arg,10);break;case'j':arg=JSON.stringify(arg,null,ph.width?parseInt(ph.width):0);break;case'e':arg=ph.precision?parseFloat(arg).toExponential(ph.precision):parseFloat(arg).toExponential();break;case'f':arg=ph.precision?parseFloat(arg).toFixed(ph.precision):parseFloat(arg);break;case'g':arg=ph.precision?String(Number(arg.toPrecision(ph.precision))):parseFloat(arg);break;case'o':arg=(parseInt(arg,10)>>>0).toString(8);break;case's':arg=String(arg);arg=ph.precision?arg.substring(0,ph.precision):arg;break;case't':arg=String(!!arg);arg=ph.precision?arg.substring(0,ph.precision):arg;break;case'T':arg=Object.prototype.toString.call(arg).slice(8,-1).toLowerCase();arg=ph.precision?arg.substring(0,ph.precision):arg;break;case'u':arg=parseInt(arg,10)>>>0;break;case'v':arg=arg.valueOf();arg=ph.precision?arg.substring(0,ph.precision):arg;break;case'x':arg=(parseInt(arg,10)>>>0).toString(16);break;case'X':arg=(parseInt(arg,10)>>>0).toString(16).toUpperCase();break;}if(re.json.test(ph.type)){output+=arg;}else{if(re.number.test(ph.type)&&(!is_positive||ph.sign)){sign=is_positive?'+':'-';arg=arg.toString().replace(re.sign,'');}else{sign='';}pad_character=ph.pad_char?ph.pad_char==='0'?'0':ph.pad_char.charAt(1):' ';pad_length=ph.width-(sign+arg).length;pad=ph.width?pad_length>0?pad_character.repeat(pad_length):'':'';output+=ph.align?sign+arg+pad:pad_character==='0'?sign+pad+arg:pad+sign+arg;}}}return output;}var sprintf_cache=Object.create(null);function sprintf_parse(fmt){if(sprintf_cache[fmt]){return sprintf_cache[fmt];}var _fmt=fmt,match,parse_tree=[],arg_names=0;while(_fmt){if((match=re.text.exec(_fmt))!==null){parse_tree.push(match[0]);}else if((match=re.modulo.exec(_fmt))!==null){parse_tree.push('%');}else if((match=re.placeholder.exec(_fmt))!==null){if(match[2]){arg_names|=1;var field_list=[],replacement_field=match[2],field_match=[];if((field_match=re.key.exec(replacement_field))!==null){field_list.push(field_match[1]);while((replacement_field=replacement_field.substring(field_match[0].length))!==''){if((field_match=re.key_access.exec(replacement_field))!==null){field_list.push(field_match[1]);}else if((field_match=re.index_access.exec(replacement_field))!==null){field_list.push(field_match[1]);}else{throw new SyntaxError('[sprintf] failed to parse named argument key');}}}else{throw new SyntaxError('[sprintf] failed to parse named argument key');}match[2]=field_list;}else{arg_names|=2;}if(arg_names===3){throw new Error('[sprintf] mixing positional and named placeholders is not (yet) supported');}parse_tree.push({placeholder:match[0],param_no:match[1],keys:match[2],sign:match[3],pad_char:match[4],align:match[5],width:match[6],precision:match[7],type:match[8]});}else{throw new SyntaxError('[sprintf] unexpected placeholder');}_fmt=_fmt.substring(match[0].length);}return sprintf_cache[fmt]=parse_tree;}/**
     * export to either browser or node.js
     */ /* eslint-disable quote-props */if(true){exports.sprintf=sprintf;exports.vsprintf=vsprintf;}if(typeof window!=='undefined'){window['sprintf']=sprintf;window['vsprintf']=vsprintf;if(true){!(__WEBPACK_AMD_DEFINE_RESULT__=function(){return{'sprintf':sprintf,'vsprintf':vsprintf};}.call(exports,__nested_webpack_require_830429__,exports,module),__WEBPACK_AMD_DEFINE_RESULT__!==undefined&&(module.exports=__WEBPACK_AMD_DEFINE_RESULT__));}}/* eslint-enable quote-props */}();// eslint-disable-line
/***/}),/***/3711:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_835723__){"use strict";module.exports=surfaceNets;var generateContourExtractor=__nested_webpack_require_835723__(2640);var zeroCrossings=__nested_webpack_require_835723__(781);var allFns={"2d":function(genContour,order,dtype){var contour=genContour({order:order,scalarArguments:3,getters:dtype==="generic"?[0]:undefined,phase:function phaseFunc(p,a,b,c){return p>c|0;},vertex:function vertexFunc(d0,d1,v0,v1,v2,v3,p0,p1,p2,p3,a,b,c){var m=(p0<<0)+(p1<<1)+(p2<<2)+(p3<<3)|0;if(m===0||m===15){return;}switch(m){case 0:a.push([d0-0.5,d1-0.5]);break;case 1:a.push([d0-0.25-0.25*(v1+v0-2*c)/(v0-v1),d1-0.25-0.25*(v2+v0-2*c)/(v0-v2)]);break;case 2:a.push([d0-0.75-0.25*(-v1-v0+2*c)/(v1-v0),d1-0.25-0.25*(v3+v1-2*c)/(v1-v3)]);break;case 3:a.push([d0-0.5,d1-0.5-0.5*(v2+v0+v3+v1-4*c)/(v0-v2+v1-v3)]);break;case 4:a.push([d0-0.25-0.25*(v3+v2-2*c)/(v2-v3),d1-0.75-0.25*(-v2-v0+2*c)/(v2-v0)]);break;case 5:a.push([d0-0.5-0.5*(v1+v0+v3+v2-4*c)/(v0-v1+v2-v3),d1-0.5]);break;case 6:a.push([d0-0.5-0.25*(-v1-v0+v3+v2)/(v1-v0+v2-v3),d1-0.5-0.25*(-v2-v0+v3+v1)/(v2-v0+v1-v3)]);break;case 7:a.push([d0-0.75-0.25*(v3+v2-2*c)/(v2-v3),d1-0.75-0.25*(v3+v1-2*c)/(v1-v3)]);break;case 8:a.push([d0-0.75-0.25*(-v3-v2+2*c)/(v3-v2),d1-0.75-0.25*(-v3-v1+2*c)/(v3-v1)]);break;case 9:a.push([d0-0.5-0.25*(v1+v0+-v3-v2)/(v0-v1+v3-v2),d1-0.5-0.25*(v2+v0+-v3-v1)/(v0-v2+v3-v1)]);break;case 10:a.push([d0-0.5-0.5*(-v1-v0+-v3-v2+4*c)/(v1-v0+v3-v2),d1-0.5]);break;case 11:a.push([d0-0.25-0.25*(-v3-v2+2*c)/(v3-v2),d1-0.75-0.25*(v2+v0-2*c)/(v0-v2)]);break;case 12:a.push([d0-0.5,d1-0.5-0.5*(-v2-v0+-v3-v1+4*c)/(v2-v0+v3-v1)]);break;case 13:a.push([d0-0.75-0.25*(v1+v0-2*c)/(v0-v1),d1-0.25-0.25*(-v3-v1+2*c)/(v3-v1)]);break;case 14:a.push([d0-0.25-0.25*(-v1-v0+2*c)/(v1-v0),d1-0.25-0.25*(-v2-v0+2*c)/(v2-v0)]);break;case 15:a.push([d0-0.5,d1-0.5]);break;}},cell:function cellFunc(v0,v1,c0,c1,p0,p1,a,b,c){if(p0){b.push([v0,v1]);}else{b.push([v1,v0]);}}});return function(array,level){var verts=[],cells=[];contour(array,verts,cells,level);return{positions:verts,cells:cells};};}};function buildSurfaceNets(order,dtype){var inKey=order.length+'d';var fn=allFns[inKey];if(fn)return fn(generateContourExtractor,order,dtype);}//1D case: Need to handle specially
function mesh1D(array,level){var zc=zeroCrossings(array,level);var n=zc.length;var npos=new Array(n);var ncel=new Array(n);for(var i=0;i<n;++i){npos[i]=[zc[i]];ncel[i]=[i];}return{positions:npos,cells:ncel};}var CACHE={};function surfaceNets(array,level){if(array.dimension<=0){return{positions:[],cells:[]};}else if(array.dimension===1){return mesh1D(array,level);}var typesig=array.order.join()+"-"+array.dtype;var proc=CACHE[typesig];var level=+level||0.0;if(!proc){proc=CACHE[typesig]=buildSurfaceNets(array.order,array.dtype);}return proc(array,level);}/***/}),/***/529:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_838547__){"use strict";module.exports=textGet;var vectorizeText=__nested_webpack_require_838547__(4359);var globals=window||process.global||{};var __TEXT_CACHE=globals.__TEXT_CACHE||{};globals.__TEXT_CACHE={};function unwrap(mesh){var cells=mesh.cells;var positions=mesh.positions;var data=new Float32Array(cells.length*6);var ptr=0;var shapeX=0;for(var i=0;i<cells.length;++i){var tri=cells[i];for(var j=0;j<3;++j){var point=positions[tri[j]];data[ptr++]=point[0];data[ptr++]=point[1]+1.4;shapeX=Math.max(point[0],shapeX);}}return{data:data,shape:shapeX};}function textGet(font,text,opts){var opts=opts||{};var fontStyle=opts.fontStyle||'normal';var fontWeight=opts.fontWeight||'normal';var fontVariant=opts.fontVariant||'normal';var fontKey=[fontStyle,fontWeight,fontVariant,font].join('_');var fontcache=__TEXT_CACHE[fontKey];if(!fontcache){fontcache=__TEXT_CACHE[fontKey]={' ':{data:new Float32Array(0),shape:0.2}};}var mesh=fontcache[text];if(!mesh){if(text.length<=1||!/\d/.test(text)){mesh=fontcache[text]=unwrap(vectorizeText(text,{triangles:true,font:font,fontStyle:fontStyle,fontWeight:fontWeight,fontVariant:fontVariant,textAlign:opts.textAlign||'left',textBaseline:'alphabetic',styletags:{breaklines:true,bolds:true,italics:true,subscripts:true,superscripts:true}}));}else{var parts=text.split(/(\d|\s)/);var buffer=new Array(parts.length);var bufferSize=0;var shapeX=0;for(var i=0;i<parts.length;++i){buffer[i]=textGet(font,parts[i]);bufferSize+=buffer[i].data.length;shapeX+=buffer[i].shape;if(i>0){shapeX+=0.02;}}var data=new Float32Array(bufferSize);var ptr=0;var xOffset=-0.5*shapeX;for(var i=0;i<buffer.length;++i){var bdata=buffer[i].data;for(var j=0;j<bdata.length;j+=2){data[ptr++]=bdata[j]+xOffset;data[ptr++]=bdata[j+1];}xOffset+=buffer[i].shape+0.02;}mesh=fontcache[text]={data:data,shape:shapeX};}}return mesh;}/***/}),/***/665:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_840444__){"use strict";var parseUnit=__nested_webpack_require_840444__(3202);module.exports=toPX;var PIXELS_PER_INCH=96;function getPropertyInPX(element,prop){var parts=parseUnit(getComputedStyle(element).getPropertyValue(prop));return parts[0]*toPX(parts[1],element);}//This brutal hack is needed
function getSizeBrutal(unit,element){var testDIV=document.createElement('div');testDIV.style['font-size']='128'+unit;element.appendChild(testDIV);var size=getPropertyInPX(testDIV,'font-size')/128;element.removeChild(testDIV);return size;}function toPX(str,element){element=element||document.body;str=(str||'px').trim().toLowerCase();if(element===window||element===document){element=document.body;}switch(str){case'%'://Ambiguous, not sure if we should use width or height
return element.clientHeight/100.0;case'ch':case'ex':return getSizeBrutal(str,element);case'em':return getPropertyInPX(element,'font-size');case'rem':return getPropertyInPX(document.body,'font-size');case'vw':return window.innerWidth/100;case'vh':return window.innerHeight/100;case'vmin':return Math.min(window.innerWidth,window.innerHeight)/100;case'vmax':return Math.max(window.innerWidth,window.innerHeight)/100;case'in':return PIXELS_PER_INCH;case'cm':return PIXELS_PER_INCH/2.54;case'mm':return PIXELS_PER_INCH/25.4;case'pt':return PIXELS_PER_INCH/72;case'pc':return PIXELS_PER_INCH/6;}return 1;}/***/}),/***/7261:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_841876__){"use strict";module.exports=createTurntableController;var filterVector=__nested_webpack_require_841876__(9215);var invert44=__nested_webpack_require_841876__(7608);var rotateM=__nested_webpack_require_841876__(6079);var cross=__nested_webpack_require_841876__(5911);var normalize3=__nested_webpack_require_841876__(3536);var dot3=__nested_webpack_require_841876__(244);function len3(x,y,z){return Math.sqrt(Math.pow(x,2)+Math.pow(y,2)+Math.pow(z,2));}function clamp1(x){return Math.min(1.0,Math.max(-1.0,x));}function findOrthoPair(v){var vx=Math.abs(v[0]);var vy=Math.abs(v[1]);var vz=Math.abs(v[2]);var u=[0,0,0];if(vx>Math.max(vy,vz)){u[2]=1;}else if(vy>Math.max(vx,vz)){u[0]=1;}else{u[1]=1;}var vv=0;var uv=0;for(var i=0;i<3;++i){vv+=v[i]*v[i];uv+=u[i]*v[i];}for(var i=0;i<3;++i){u[i]-=uv/vv*v[i];}normalize3(u,u);return u;}function TurntableController(zoomMin,zoomMax,center,up,right,radius,theta,phi){this.center=filterVector(center);this.up=filterVector(up);this.right=filterVector(right);this.radius=filterVector([radius]);this.angle=filterVector([theta,phi]);this.angle.bounds=[[-Infinity,-Math.PI/2],[Infinity,Math.PI/2]];this.setDistanceLimits(zoomMin,zoomMax);this.computedCenter=this.center.curve(0);this.computedUp=this.up.curve(0);this.computedRight=this.right.curve(0);this.computedRadius=this.radius.curve(0);this.computedAngle=this.angle.curve(0);this.computedToward=[0,0,0];this.computedEye=[0,0,0];this.computedMatrix=new Array(16);for(var i=0;i<16;++i){this.computedMatrix[i]=0.5;}this.recalcMatrix(0);}var proto=TurntableController.prototype;proto.setDistanceLimits=function(minDist,maxDist){if(minDist>0){minDist=Math.log(minDist);}else{minDist=-Infinity;}if(maxDist>0){maxDist=Math.log(maxDist);}else{maxDist=Infinity;}maxDist=Math.max(maxDist,minDist);this.radius.bounds[0][0]=minDist;this.radius.bounds[1][0]=maxDist;};proto.getDistanceLimits=function(out){var bounds=this.radius.bounds[0];if(out){out[0]=Math.exp(bounds[0][0]);out[1]=Math.exp(bounds[1][0]);return out;}return[Math.exp(bounds[0][0]),Math.exp(bounds[1][0])];};proto.recalcMatrix=function(t){//Recompute curves
this.center.curve(t);this.up.curve(t);this.right.curve(t);this.radius.curve(t);this.angle.curve(t);//Compute frame for camera matrix
var up=this.computedUp;var right=this.computedRight;var uu=0.0;var ur=0.0;for(var i=0;i<3;++i){ur+=up[i]*right[i];uu+=up[i]*up[i];}var ul=Math.sqrt(uu);var rr=0.0;for(var i=0;i<3;++i){right[i]-=up[i]*ur/uu;rr+=right[i]*right[i];up[i]/=ul;}var rl=Math.sqrt(rr);for(var i=0;i<3;++i){right[i]/=rl;}//Compute toward vector
var toward=this.computedToward;cross(toward,up,right);normalize3(toward,toward);//Compute angular parameters
var radius=Math.exp(this.computedRadius[0]);var theta=this.computedAngle[0];var phi=this.computedAngle[1];var ctheta=Math.cos(theta);var stheta=Math.sin(theta);var cphi=Math.cos(phi);var sphi=Math.sin(phi);var center=this.computedCenter;var wx=ctheta*cphi;var wy=stheta*cphi;var wz=sphi;var sx=-ctheta*sphi;var sy=-stheta*sphi;var sz=cphi;var eye=this.computedEye;var mat=this.computedMatrix;for(var i=0;i<3;++i){var x=wx*right[i]+wy*toward[i]+wz*up[i];mat[4*i+1]=sx*right[i]+sy*toward[i]+sz*up[i];mat[4*i+2]=x;mat[4*i+3]=0.0;}var ax=mat[1];var ay=mat[5];var az=mat[9];var bx=mat[2];var by=mat[6];var bz=mat[10];var cx=ay*bz-az*by;var cy=az*bx-ax*bz;var cz=ax*by-ay*bx;var cl=len3(cx,cy,cz);cx/=cl;cy/=cl;cz/=cl;mat[0]=cx;mat[4]=cy;mat[8]=cz;for(var i=0;i<3;++i){eye[i]=center[i]+mat[2+4*i]*radius;}for(var i=0;i<3;++i){var rr=0.0;for(var j=0;j<3;++j){rr+=mat[i+4*j]*eye[j];}mat[12+i]=-rr;}mat[15]=1.0;};proto.getMatrix=function(t,result){this.recalcMatrix(t);var mat=this.computedMatrix;if(result){for(var i=0;i<16;++i){result[i]=mat[i];}return result;}return mat;};var zAxis=[0,0,0];proto.rotate=function(t,dtheta,dphi,droll){this.angle.move(t,dtheta,dphi);if(droll){this.recalcMatrix(t);var mat=this.computedMatrix;zAxis[0]=mat[2];zAxis[1]=mat[6];zAxis[2]=mat[10];var up=this.computedUp;var right=this.computedRight;var toward=this.computedToward;for(var i=0;i<3;++i){mat[4*i]=up[i];mat[4*i+1]=right[i];mat[4*i+2]=toward[i];}rotateM(mat,mat,droll,zAxis);for(var i=0;i<3;++i){up[i]=mat[4*i];right[i]=mat[4*i+1];}this.up.set(t,up[0],up[1],up[2]);this.right.set(t,right[0],right[1],right[2]);}};proto.pan=function(t,dx,dy,dz){dx=dx||0.0;dy=dy||0.0;dz=dz||0.0;this.recalcMatrix(t);var mat=this.computedMatrix;var dist=Math.exp(this.computedRadius[0]);var ux=mat[1];var uy=mat[5];var uz=mat[9];var ul=len3(ux,uy,uz);ux/=ul;uy/=ul;uz/=ul;var rx=mat[0];var ry=mat[4];var rz=mat[8];var ru=rx*ux+ry*uy+rz*uz;rx-=ux*ru;ry-=uy*ru;rz-=uz*ru;var rl=len3(rx,ry,rz);rx/=rl;ry/=rl;rz/=rl;var vx=rx*dx+ux*dy;var vy=ry*dx+uy*dy;var vz=rz*dx+uz*dy;this.center.move(t,vx,vy,vz);//Update z-component of radius
var radius=Math.exp(this.computedRadius[0]);radius=Math.max(1e-4,radius+dz);this.radius.set(t,Math.log(radius));};proto.translate=function(t,dx,dy,dz){this.center.move(t,dx||0.0,dy||0.0,dz||0.0);};//Recenters the coordinate axes
proto.setMatrix=function(t,mat,axes,noSnap){//Get the axes for tare
var ushift=1;if(typeof axes==='number'){ushift=axes|0;}if(ushift<0||ushift>3){ushift=1;}var vshift=(ushift+2)%3;var fshift=(ushift+1)%3;//Recompute state for new t value
if(!mat){this.recalcMatrix(t);mat=this.computedMatrix;}//Get right and up vectors
var ux=mat[ushift];var uy=mat[ushift+4];var uz=mat[ushift+8];if(!noSnap){var ul=len3(ux,uy,uz);ux/=ul;uy/=ul;uz/=ul;}else{var ax=Math.abs(ux);var ay=Math.abs(uy);var az=Math.abs(uz);var am=Math.max(ax,ay,az);if(ax===am){ux=ux<0?-1:1;uy=uz=0;}else if(az===am){uz=uz<0?-1:1;ux=uy=0;}else{uy=uy<0?-1:1;ux=uz=0;}}var rx=mat[vshift];var ry=mat[vshift+4];var rz=mat[vshift+8];var ru=rx*ux+ry*uy+rz*uz;rx-=ux*ru;ry-=uy*ru;rz-=uz*ru;var rl=len3(rx,ry,rz);rx/=rl;ry/=rl;rz/=rl;var fx=uy*rz-uz*ry;var fy=uz*rx-ux*rz;var fz=ux*ry-uy*rx;var fl=len3(fx,fy,fz);fx/=fl;fy/=fl;fz/=fl;this.center.jump(t,ex,ey,ez);this.radius.idle(t);this.up.jump(t,ux,uy,uz);this.right.jump(t,rx,ry,rz);var phi,theta;if(ushift===2){var cx=mat[1];var cy=mat[5];var cz=mat[9];var cr=cx*rx+cy*ry+cz*rz;var cf=cx*fx+cy*fy+cz*fz;if(tu<0){phi=-Math.PI/2;}else{phi=Math.PI/2;}theta=Math.atan2(cf,cr);}else{var tx=mat[2];var ty=mat[6];var tz=mat[10];var tu=tx*ux+ty*uy+tz*uz;var tr=tx*rx+ty*ry+tz*rz;var tf=tx*fx+ty*fy+tz*fz;phi=Math.asin(clamp1(tu));theta=Math.atan2(tf,tr);}this.angle.jump(t,theta,phi);this.recalcMatrix(t);var dx=mat[2];var dy=mat[6];var dz=mat[10];var imat=this.computedMatrix;invert44(imat,mat);var w=imat[15];var ex=imat[12]/w;var ey=imat[13]/w;var ez=imat[14]/w;var gs=Math.exp(this.computedRadius[0]);this.center.jump(t,ex-dx*gs,ey-dy*gs,ez-dz*gs);};proto.lastT=function(){return Math.max(this.center.lastT(),this.up.lastT(),this.right.lastT(),this.radius.lastT(),this.angle.lastT());};proto.idle=function(t){this.center.idle(t);this.up.idle(t);this.right.idle(t);this.radius.idle(t);this.angle.idle(t);};proto.flush=function(t){this.center.flush(t);this.up.flush(t);this.right.flush(t);this.radius.flush(t);this.angle.flush(t);};proto.setDistance=function(t,d){if(d>0){this.radius.set(t,Math.log(d));}};proto.lookAt=function(t,eye,center,up){this.recalcMatrix(t);eye=eye||this.computedEye;center=center||this.computedCenter;up=up||this.computedUp;var ux=up[0];var uy=up[1];var uz=up[2];var ul=len3(ux,uy,uz);if(ul<1e-6){return;}ux/=ul;uy/=ul;uz/=ul;var tx=eye[0]-center[0];var ty=eye[1]-center[1];var tz=eye[2]-center[2];var tl=len3(tx,ty,tz);if(tl<1e-6){return;}tx/=tl;ty/=tl;tz/=tl;var right=this.computedRight;var rx=right[0];var ry=right[1];var rz=right[2];var ru=ux*rx+uy*ry+uz*rz;rx-=ru*ux;ry-=ru*uy;rz-=ru*uz;var rl=len3(rx,ry,rz);if(rl<0.01){rx=uy*tz-uz*ty;ry=uz*tx-ux*tz;rz=ux*ty-uy*tx;rl=len3(rx,ry,rz);if(rl<1e-6){return;}}rx/=rl;ry/=rl;rz/=rl;this.up.set(t,ux,uy,uz);this.right.set(t,rx,ry,rz);this.center.set(t,center[0],center[1],center[2]);this.radius.set(t,Math.log(tl));var fx=uy*rz-uz*ry;var fy=uz*rx-ux*rz;var fz=ux*ry-uy*rx;var fl=len3(fx,fy,fz);fx/=fl;fy/=fl;fz/=fl;var tu=ux*tx+uy*ty+uz*tz;var tr=rx*tx+ry*ty+rz*tz;var tf=fx*tx+fy*ty+fz*tz;var phi=Math.asin(clamp1(tu));var theta=Math.atan2(tf,tr);var angleState=this.angle._state;var lastTheta=angleState[angleState.length-1];var lastPhi=angleState[angleState.length-2];lastTheta=lastTheta%(2.0*Math.PI);var dp=Math.abs(lastTheta+2.0*Math.PI-theta);var d0=Math.abs(lastTheta-theta);var dn=Math.abs(lastTheta-2.0*Math.PI-theta);if(dp<d0){lastTheta+=2.0*Math.PI;}if(dn<d0){lastTheta-=2.0*Math.PI;}this.angle.jump(this.angle.lastT(),lastTheta,lastPhi);this.angle.set(t,theta,phi);};function createTurntableController(options){options=options||{};var center=options.center||[0,0,0];var up=options.up||[0,1,0];var right=options.right||findOrthoPair(up);var radius=options.radius||1.0;var theta=options.theta||0.0;var phi=options.phi||0.0;center=[].slice.call(center,0,3);up=[].slice.call(up,0,3);normalize3(up,up);right=[].slice.call(right,0,3);normalize3(right,right);if('eye'in options){var eye=options.eye;var toward=[eye[0]-center[0],eye[1]-center[1],eye[2]-center[2]];cross(right,toward,up);if(len3(right[0],right[1],right[2])<1e-6){right=findOrthoPair(up);}else{normalize3(right,right);}radius=len3(toward[0],toward[1],toward[2]);var ut=dot3(up,toward)/radius;var rt=dot3(right,toward)/radius;phi=Math.acos(ut);theta=Math.acos(rt);}//Use logarithmic coordinates for radius
radius=Math.log(radius);//Return the controller
return new TurntableController(options.zoomMin,options.zoomMax,center,up,right,radius,theta,phi);}/***/}),/***/5250:(/***/function(module){"use strict";module.exports=twoProduct;var SPLITTER=+(Math.pow(2,27)+1.0);function twoProduct(a,b,result){var x=a*b;var c=SPLITTER*a;var abig=c-a;var ahi=c-abig;var alo=a-ahi;var d=SPLITTER*b;var bbig=d-b;var bhi=d-bbig;var blo=b-bhi;var err1=x-ahi*bhi;var err2=err1-alo*bhi;var err3=err2-ahi*blo;var y=alo*blo-err3;if(result){result[0]=y;result[1]=x;return result;}return[y,x];}/***/}),/***/9362:(/***/function(module){"use strict";module.exports=fastTwoSum;function fastTwoSum(a,b,result){var x=a+b;var bv=x-a;var av=x-bv;var br=b-bv;var ar=a-av;if(result){result[0]=ar+br;result[1]=x;return result;}return[ar+br,x];}/***/}),/***/1888:(/***/function(__unused_webpack_module,exports,__nested_webpack_require_852020__){"use strict";var bits=__nested_webpack_require_852020__(8828);var dup=__nested_webpack_require_852020__(1338);var Buffer=__nested_webpack_require_852020__(4793)/* .Buffer */.hp;//Legacy pool support
if(!__nested_webpack_require_852020__.g.__TYPEDARRAY_POOL){__nested_webpack_require_852020__.g.__TYPEDARRAY_POOL={UINT8:dup([32,0]),UINT16:dup([32,0]),UINT32:dup([32,0]),BIGUINT64:dup([32,0]),INT8:dup([32,0]),INT16:dup([32,0]),INT32:dup([32,0]),BIGINT64:dup([32,0]),FLOAT:dup([32,0]),DOUBLE:dup([32,0]),DATA:dup([32,0]),UINT8C:dup([32,0]),BUFFER:dup([32,0])};}var hasUint8C=typeof Uint8ClampedArray!=='undefined';var hasBigUint64=typeof BigUint64Array!=='undefined';var hasBigInt64=typeof BigInt64Array!=='undefined';var POOL=__nested_webpack_require_852020__.g.__TYPEDARRAY_POOL;//Upgrade pool
if(!POOL.UINT8C){POOL.UINT8C=dup([32,0]);}if(!POOL.BIGUINT64){POOL.BIGUINT64=dup([32,0]);}if(!POOL.BIGINT64){POOL.BIGINT64=dup([32,0]);}if(!POOL.BUFFER){POOL.BUFFER=dup([32,0]);}//New technique: Only allocate from ArrayBufferView and Buffer
var DATA=POOL.DATA,BUFFER=POOL.BUFFER;exports.free=function free(array){if(Buffer.isBuffer(array)){BUFFER[bits.log2(array.length)].push(array);}else{if(Object.prototype.toString.call(array)!=='[object ArrayBuffer]'){array=array.buffer;}if(!array){return;}var n=array.length||array.byteLength;var log_n=bits.log2(n)|0;DATA[log_n].push(array);}};function freeArrayBuffer(buffer){if(!buffer){return;}var n=buffer.length||buffer.byteLength;var log_n=bits.log2(n);DATA[log_n].push(buffer);}function freeTypedArray(array){freeArrayBuffer(array.buffer);}exports.freeUint8=exports.freeUint16=exports.freeUint32=exports.freeBigUint64=exports.freeInt8=exports.freeInt16=exports.freeInt32=exports.freeBigInt64=exports.freeFloat32=exports.freeFloat=exports.freeFloat64=exports.freeDouble=exports.freeUint8Clamped=exports.freeDataView=freeTypedArray;exports.freeArrayBuffer=freeArrayBuffer;exports.freeBuffer=function freeBuffer(array){BUFFER[bits.log2(array.length)].push(array);};exports.malloc=function malloc(n,dtype){if(dtype===undefined||dtype==='arraybuffer'){return mallocArrayBuffer(n);}else{switch(dtype){case'uint8':return mallocUint8(n);case'uint16':return mallocUint16(n);case'uint32':return mallocUint32(n);case'int8':return mallocInt8(n);case'int16':return mallocInt16(n);case'int32':return mallocInt32(n);case'float':case'float32':return mallocFloat(n);case'double':case'float64':return mallocDouble(n);case'uint8_clamped':return mallocUint8Clamped(n);case'bigint64':return mallocBigInt64(n);case'biguint64':return mallocBigUint64(n);case'buffer':return mallocBuffer(n);case'data':case'dataview':return mallocDataView(n);default:return null;}}return null;};function mallocArrayBuffer(n){var n=bits.nextPow2(n);var log_n=bits.log2(n);var d=DATA[log_n];if(d.length>0){return d.pop();}return new ArrayBuffer(n);}exports.mallocArrayBuffer=mallocArrayBuffer;function mallocUint8(n){return new Uint8Array(mallocArrayBuffer(n),0,n);}exports.mallocUint8=mallocUint8;function mallocUint16(n){return new Uint16Array(mallocArrayBuffer(2*n),0,n);}exports.mallocUint16=mallocUint16;function mallocUint32(n){return new Uint32Array(mallocArrayBuffer(4*n),0,n);}exports.mallocUint32=mallocUint32;function mallocInt8(n){return new Int8Array(mallocArrayBuffer(n),0,n);}exports.mallocInt8=mallocInt8;function mallocInt16(n){return new Int16Array(mallocArrayBuffer(2*n),0,n);}exports.mallocInt16=mallocInt16;function mallocInt32(n){return new Int32Array(mallocArrayBuffer(4*n),0,n);}exports.mallocInt32=mallocInt32;function mallocFloat(n){return new Float32Array(mallocArrayBuffer(4*n),0,n);}exports.mallocFloat32=exports.mallocFloat=mallocFloat;function mallocDouble(n){return new Float64Array(mallocArrayBuffer(8*n),0,n);}exports.mallocFloat64=exports.mallocDouble=mallocDouble;function mallocUint8Clamped(n){if(hasUint8C){return new Uint8ClampedArray(mallocArrayBuffer(n),0,n);}else{return mallocUint8(n);}}exports.mallocUint8Clamped=mallocUint8Clamped;function mallocBigUint64(n){if(hasBigUint64){return new BigUint64Array(mallocArrayBuffer(8*n),0,n);}else{return null;}}exports.mallocBigUint64=mallocBigUint64;function mallocBigInt64(n){if(hasBigInt64){return new BigInt64Array(mallocArrayBuffer(8*n),0,n);}else{return null;}}exports.mallocBigInt64=mallocBigInt64;function mallocDataView(n){return new DataView(mallocArrayBuffer(n),0,n);}exports.mallocDataView=mallocDataView;function mallocBuffer(n){n=bits.nextPow2(n);var log_n=bits.log2(n);var cache=BUFFER[log_n];if(cache.length>0){return cache.pop();}return new Buffer(n);}exports.mallocBuffer=mallocBuffer;exports.clearCache=function clearCache(){for(var i=0;i<32;++i){POOL.UINT8[i].length=0;POOL.UINT16[i].length=0;POOL.UINT32[i].length=0;POOL.INT8[i].length=0;POOL.INT16[i].length=0;POOL.INT32[i].length=0;POOL.FLOAT[i].length=0;POOL.DOUBLE[i].length=0;POOL.BIGUINT64[i].length=0;POOL.BIGINT64[i].length=0;POOL.UINT8C[i].length=0;DATA[i].length=0;BUFFER[i].length=0;}};/***/}),/***/1755:(/***/function(module){"use strict";"use restrict";module.exports=UnionFind;function UnionFind(count){this.roots=new Array(count);this.ranks=new Array(count);for(var i=0;i<count;++i){this.roots[i]=i;this.ranks[i]=0;}}var proto=UnionFind.prototype;Object.defineProperty(proto,"length",{"get":function(){return this.roots.length;}});proto.makeSet=function(){var n=this.roots.length;this.roots.push(n);this.ranks.push(0);return n;};proto.find=function(x){var x0=x;var roots=this.roots;while(roots[x]!==x){x=roots[x];}while(roots[x0]!==x){var y=roots[x0];roots[x0]=x;x0=y;}return x;};proto.link=function(x,y){var xr=this.find(x),yr=this.find(y);if(xr===yr){return;}var ranks=this.ranks,roots=this.roots,xd=ranks[xr],yd=ranks[yr];if(xd<yd){roots[xr]=yr;}else if(yd<xd){roots[yr]=xr;}else{roots[yr]=xr;++ranks[xr];}};/***/}),/***/1682:(/***/function(module){"use strict";function unique_pred(list,compare){var ptr=1,len=list.length,a=list[0],b=list[0];for(var i=1;i<len;++i){b=a;a=list[i];if(compare(a,b)){if(i===ptr){ptr++;continue;}list[ptr++]=a;}}list.length=ptr;return list;}function unique_eq(list){var ptr=1,len=list.length,a=list[0],b=list[0];for(var i=1;i<len;++i,b=a){b=a;a=list[i];if(a!==b){if(i===ptr){ptr++;continue;}list[ptr++]=a;}}list.length=ptr;return list;}function unique(list,compare,sorted){if(list.length===0){return list;}if(compare){if(!sorted){list.sort(compare);}return unique_pred(list,compare);}if(!sorted){list.sort();}return unique_eq(list);}module.exports=unique;/***/}),/***/4359:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_858477__){"use strict";module.exports=createText;var vectorizeText=__nested_webpack_require_858477__(7718);var defaultCanvas=null;var defaultContext=null;if(typeof document!=='undefined'){defaultCanvas=document.createElement('canvas');defaultCanvas.width=8192;defaultCanvas.height=1024;defaultContext=defaultCanvas.getContext("2d");}function createText(str,options){if(typeof options!=="object"||options===null){options={};}return vectorizeText(str,options.canvas||defaultCanvas,options.context||defaultContext,options);}/***/}),/***/7718:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_859060__){module.exports=vectorizeText;module.exports.processPixels=processPixels;var surfaceNets=__nested_webpack_require_859060__(3711);var ndarray=__nested_webpack_require_859060__(9618);var simplify=__nested_webpack_require_859060__(5878);var cleanPSLG=__nested_webpack_require_859060__(332);var cdt2d=__nested_webpack_require_859060__(2538);var toPolygonCrappy=__nested_webpack_require_859060__(2095);var TAG_bold="b";var CHR_bold='b|';var TAG_italic="i";var CHR_italic='i|';var TAG_super="sup";var CHR_super0='+';var CHR_super='+1';var TAG_sub="sub";var CHR_sub0='-';var CHR_sub='-1';function parseTag(tag,TAG_CHR,str,map){var opnTag="<"+tag+">";var clsTag="</"+tag+">";var nOPN=opnTag.length;var nCLS=clsTag.length;var isRecursive=TAG_CHR[0]===CHR_super0||TAG_CHR[0]===CHR_sub0;var a=0;var b=-nCLS;while(a>-1){a=str.indexOf(opnTag,a);if(a===-1)break;b=str.indexOf(clsTag,a+nOPN);if(b===-1)break;if(b<=a)break;for(var i=a;i<b+nCLS;++i){if(i<a+nOPN||i>=b){map[i]=null;str=str.substr(0,i)+" "+str.substr(i+1);}else{if(map[i]!==null){var pos=map[i].indexOf(TAG_CHR[0]);if(pos===-1){map[i]+=TAG_CHR;}else{// i.e. to handle multiple sub/super-scripts
if(isRecursive){// i.e to increase the sub/sup number
map[i]=map[i].substr(0,pos+1)+(1+parseInt(map[i][pos+1]))+map[i].substr(pos+2);}}}}}var start=a+nOPN;var remainingStr=str.substr(start,b-start);var c=remainingStr.indexOf(opnTag);if(c!==-1)a=c;else a=b+nCLS;}return map;}function transformPositions(positions,options,size){var align=options.textAlign||"start";var baseline=options.textBaseline||"alphabetic";var lo=[1<<30,1<<30];var hi=[0,0];var n=positions.length;for(var i=0;i<n;++i){var p=positions[i];for(var j=0;j<2;++j){lo[j]=Math.min(lo[j],p[j])|0;hi[j]=Math.max(hi[j],p[j])|0;}}var xShift=0;switch(align){case"center":xShift=-0.5*(lo[0]+hi[0]);break;case"right":case"end":xShift=-hi[0];break;case"left":case"start":xShift=-lo[0];break;default:throw new Error("vectorize-text: Unrecognized textAlign: '"+align+"'");}var yShift=0;switch(baseline){case"hanging":case"top":yShift=-lo[1];break;case"middle":yShift=-0.5*(lo[1]+hi[1]);break;case"alphabetic":case"ideographic":yShift=-3*size;break;case"bottom":yShift=-hi[1];break;default:throw new Error("vectorize-text: Unrecoginized textBaseline: '"+baseline+"'");}var scale=1.0/size;if("lineHeight"in options){scale*=+options.lineHeight;}else if("width"in options){scale=options.width/(hi[0]-lo[0]);}else if("height"in options){scale=options.height/(hi[1]-lo[1]);}return positions.map(function(p){return[scale*(p[0]+xShift),scale*(p[1]+yShift)];});}function getPixels(canvas,context,rawString,fontSize,lineSpacing,styletags){rawString=rawString.replace(/\n/g,'');// don't accept \n in the input
if(styletags.breaklines===true){rawString=rawString.replace(/\<br\>/g,'\n');// replace <br> tags with \n in the string
}else{rawString=rawString.replace(/\<br\>/g,' ');// don't accept <br> tags in the input and replace with space in this case
}var activeStyle="";var map=[];for(j=0;j<rawString.length;++j){map[j]=activeStyle;}if(styletags.bolds===true)map=parseTag(TAG_bold,CHR_bold,rawString,map);if(styletags.italics===true)map=parseTag(TAG_italic,CHR_italic,rawString,map);if(styletags.superscripts===true)map=parseTag(TAG_super,CHR_super,rawString,map);if(styletags.subscripts===true)map=parseTag(TAG_sub,CHR_sub,rawString,map);var allStyles=[];var plainText="";for(j=0;j<rawString.length;++j){if(map[j]!==null){plainText+=rawString[j];allStyles.push(map[j]);}}var allTexts=plainText.split('\n');var numberOfLines=allTexts.length;var lineHeight=Math.round(lineSpacing*fontSize);var offsetX=fontSize;var offsetY=fontSize*2;var maxWidth=0;var minHeight=numberOfLines*lineHeight+offsetY;if(canvas.height<minHeight){canvas.height=minHeight;}context.fillStyle="#000";context.fillRect(0,0,canvas.width,canvas.height);context.fillStyle="#fff";var i,j,xPos,yPos,zPos;var nDone=0;var buffer="";function writeBuffer(){if(buffer!==""){var delta=context.measureText(buffer).width;context.fillText(buffer,offsetX+xPos,offsetY+yPos);xPos+=delta;}}function getTextFontSize(){return""+Math.round(zPos)+"px ";}function changeStyle(oldStyle,newStyle){var ctxFont=""+context.font;if(styletags.subscripts===true){var oldIndex_Sub=oldStyle.indexOf(CHR_sub0);var newIndex_Sub=newStyle.indexOf(CHR_sub0);var oldSub=oldIndex_Sub>-1?parseInt(oldStyle[1+oldIndex_Sub]):0;var newSub=newIndex_Sub>-1?parseInt(newStyle[1+newIndex_Sub]):0;if(oldSub!==newSub){ctxFont=ctxFont.replace(getTextFontSize(),"?px ");zPos*=Math.pow(0.75,newSub-oldSub);ctxFont=ctxFont.replace("?px ",getTextFontSize());}yPos+=0.25*lineHeight*(newSub-oldSub);}if(styletags.superscripts===true){var oldIndex_Super=oldStyle.indexOf(CHR_super0);var newIndex_Super=newStyle.indexOf(CHR_super0);var oldSuper=oldIndex_Super>-1?parseInt(oldStyle[1+oldIndex_Super]):0;var newSuper=newIndex_Super>-1?parseInt(newStyle[1+newIndex_Super]):0;if(oldSuper!==newSuper){ctxFont=ctxFont.replace(getTextFontSize(),"?px ");zPos*=Math.pow(0.75,newSuper-oldSuper);ctxFont=ctxFont.replace("?px ",getTextFontSize());}yPos-=0.25*lineHeight*(newSuper-oldSuper);}if(styletags.bolds===true){var wasBold=oldStyle.indexOf(CHR_bold)>-1;var is_Bold=newStyle.indexOf(CHR_bold)>-1;if(!wasBold&&is_Bold){if(wasItalic){ctxFont=ctxFont.replace("italic ","italic bold ");}else{ctxFont="bold "+ctxFont;}}if(wasBold&&!is_Bold){ctxFont=ctxFont.replace("bold ",'');}}if(styletags.italics===true){var wasItalic=oldStyle.indexOf(CHR_italic)>-1;var is_Italic=newStyle.indexOf(CHR_italic)>-1;if(!wasItalic&&is_Italic){ctxFont="italic "+ctxFont;}if(wasItalic&&!is_Italic){ctxFont=ctxFont.replace("italic ",'');}}context.font=ctxFont;}for(i=0;i<numberOfLines;++i){var txt=allTexts[i]+'\n';xPos=0;yPos=i*lineHeight;zPos=fontSize;buffer="";for(j=0;j<txt.length;++j){var style=j+nDone<allStyles.length?allStyles[j+nDone]:allStyles[allStyles.length-1];if(activeStyle===style){buffer+=txt[j];}else{writeBuffer();buffer=txt[j];if(style!==undefined){changeStyle(activeStyle,style);activeStyle=style;}}}writeBuffer();nDone+=txt.length;var width=Math.round(xPos+2*offsetX)|0;if(maxWidth<width)maxWidth=width;}//Cut pixels from image
var xCut=maxWidth;var yCut=offsetY+lineHeight*numberOfLines;var pixels=ndarray(context.getImageData(0,0,xCut,yCut).data,[yCut,xCut,4]);return pixels.pick(-1,-1,0).transpose(1,0);}function getContour(pixels,doSimplify){var contour=surfaceNets(pixels,128);if(doSimplify){return simplify(contour.cells,contour.positions,0.25);}return{edges:contour.cells,positions:contour.positions};}function processPixelsImpl(pixels,options,size,simplify){//Extract contour
var contour=getContour(pixels,simplify);//Apply warp to positions
var positions=transformPositions(contour.positions,options,size);var edges=contour.edges;var flip="ccw"===options.orientation;//Clean up the PSLG, resolve self intersections, etc.
cleanPSLG(positions,edges);//If triangulate flag passed, triangulate the result
if(options.polygons||options.polygon||options.polyline){var result=toPolygonCrappy(edges,positions);var nresult=new Array(result.length);for(var i=0;i<result.length;++i){var loops=result[i];var nloops=new Array(loops.length);for(var j=0;j<loops.length;++j){var loop=loops[j];var nloop=new Array(loop.length);for(var k=0;k<loop.length;++k){nloop[k]=positions[loop[k]].slice();}if(flip){nloop.reverse();}nloops[j]=nloop;}nresult[i]=nloops;}return nresult;}else if(options.triangles||options.triangulate||options.triangle){return{cells:cdt2d(positions,edges,{delaunay:false,exterior:false,interior:true}),positions:positions};}else{return{edges:edges,positions:positions};}}function processPixels(pixels,options,size){try{return processPixelsImpl(pixels,options,size,true);}catch(e){}try{return processPixelsImpl(pixels,options,size,false);}catch(e){}if(options.polygons||options.polyline||options.polygon){return[];}if(options.triangles||options.triangulate||options.triangle){return{cells:[],positions:[]};}return{edges:[],positions:[]};}function vectorizeText(str,canvas,context,options){var size=64;var lineSpacing=1.25;var styletags={breaklines:false,bolds:false,italics:false,subscripts:false,superscripts:false};if(options){if(options.size&&options.size>0)size=options.size;if(options.lineSpacing&&options.lineSpacing>0)lineSpacing=options.lineSpacing;if(options.styletags&&options.styletags.breaklines)styletags.breaklines=options.styletags.breaklines?true:false;if(options.styletags&&options.styletags.bolds)styletags.bolds=options.styletags.bolds?true:false;if(options.styletags&&options.styletags.italics)styletags.italics=options.styletags.italics?true:false;if(options.styletags&&options.styletags.subscripts)styletags.subscripts=options.styletags.subscripts?true:false;if(options.styletags&&options.styletags.superscripts)styletags.superscripts=options.styletags.superscripts?true:false;}context.font=[options.fontStyle,options.fontVariant,options.fontWeight,size+"px",options.font].filter(function(d){return d;}).join(" ");context.textAlign="start";context.textBaseline="alphabetic";context.direction="ltr";var pixels=getPixels(canvas,context,str,size,lineSpacing,styletags);return processPixels(pixels,options,size);}/***/}),/***/1538:(/***/function(module){// Copyright (C) 2011 Google Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * @fileoverview Install a leaky WeakMap emulation on platforms that
 * don't provide a built-in one.
 *
 * <p>Assumes that an ES5 platform where, if {@code WeakMap} is
 * already present, then it conforms to the anticipated ES6
 * specification. To run this file on an ES5 or almost ES5
 * implementation where the {@code WeakMap} specification does not
 * quite conform, run <code>repairES5.js</code> first.
 *
 * <p>Even though WeakMapModule is not global, the linter thinks it
 * is, which is why it is in the overrides list below.
 *
 * <p>NOTE: Before using this WeakMap emulation in a non-SES
 * environment, see the note below about hiddenRecord.
 *
 * @author Mark S. Miller
 * @requires crypto, ArrayBuffer, Uint8Array, navigator, console
 * @overrides WeakMap, ses, Proxy
 * @overrides WeakMapModule
 */ /**
 * This {@code WeakMap} emulation is observably equivalent to the
 * ES-Harmony WeakMap, but with leakier garbage collection properties.
 *
 * <p>As with true WeakMaps, in this emulation, a key does not
 * retain maps indexed by that key and (crucially) a map does not
 * retain the keys it indexes. A map by itself also does not retain
 * the values associated with that map.
 *
 * <p>However, the values associated with a key in some map are
 * retained so long as that key is retained and those associations are
 * not overridden. For example, when used to support membranes, all
 * values exported from a given membrane will live for the lifetime
 * they would have had in the absence of an interposed membrane. Even
 * when the membrane is revoked, all objects that would have been
 * reachable in the absence of revocation will still be reachable, as
 * far as the GC can tell, even though they will no longer be relevant
 * to ongoing computation.
 *
 * <p>The API implemented here is approximately the API as implemented
 * in FF6.0a1 and agreed to by MarkM, Andreas Gal, and Dave Herman,
 * rather than the offially approved proposal page. TODO(erights):
 * upgrade the ecmascript WeakMap proposal page to explain this API
 * change and present to EcmaScript committee for their approval.
 *
 * <p>The first difference between the emulation here and that in
 * FF6.0a1 is the presence of non enumerable {@code get___, has___,
 * set___, and delete___} methods on WeakMap instances to represent
 * what would be the hidden internal properties of a primitive
 * implementation. Whereas the FF6.0a1 WeakMap.prototype methods
 * require their {@code this} to be a genuine WeakMap instance (i.e.,
 * an object of {@code [[Class]]} "WeakMap}), since there is nothing
 * unforgeable about the pseudo-internal method names used here,
 * nothing prevents these emulated prototype methods from being
 * applied to non-WeakMaps with pseudo-internal methods of the same
 * names.
 *
 * <p>Another difference is that our emulated {@code
 * WeakMap.prototype} is not itself a WeakMap. A problem with the
 * current FF6.0a1 API is that WeakMap.prototype is itself a WeakMap
 * providing ambient mutability and an ambient communications
 * channel. Thus, if a WeakMap is already present and has this
 * problem, repairES5.js wraps it in a safe wrappper in order to
 * prevent access to this channel. (See
 * PATCH_MUTABLE_FROZEN_WEAKMAP_PROTO in repairES5.js).
 */ /**
 * If this is a full <a href=
 * "http://code.google.com/p/es-lab/wiki/SecureableES5"
 * >secureable ES5</a> platform and the ES-Harmony {@code WeakMap} is
 * absent, install an approximate emulation.
 *
 * <p>If WeakMap is present but cannot store some objects, use our approximate
 * emulation as a wrapper.
 *
 * <p>If this is almost a secureable ES5 platform, then WeakMap.js
 * should be run after repairES5.js.
 *
 * <p>See {@code WeakMap} for documentation of the garbage collection
 * properties of this WeakMap emulation.
 */(function WeakMapModule(){"use strict";if(typeof ses!=='undefined'&&ses.ok&&!ses.ok()){// already too broken, so give up
return;}/**
   * In some cases (current Firefox), we must make a choice betweeen a
   * WeakMap which is capable of using all varieties of host objects as
   * keys and one which is capable of safely using proxies as keys. See
   * comments below about HostWeakMap and DoubleWeakMap for details.
   *
   * This function (which is a global, not exposed to guests) marks a
   * WeakMap as permitted to do what is necessary to index all host
   * objects, at the cost of making it unsafe for proxies.
   *
   * Do not apply this function to anything which is not a genuine
   * fresh WeakMap.
   */function weakMapPermitHostObjects(map){// identity of function used as a secret -- good enough and cheap
if(map.permitHostObjects___){map.permitHostObjects___(weakMapPermitHostObjects);}}if(typeof ses!=='undefined'){ses.weakMapPermitHostObjects=weakMapPermitHostObjects;}// IE 11 has no Proxy but has a broken WeakMap such that we need to patch
// it using DoubleWeakMap; this flag tells DoubleWeakMap so.
var doubleWeakMapCheckSilentFailure=false;// Check if there is already a good-enough WeakMap implementation, and if so
// exit without replacing it.
if(typeof WeakMap==='function'){var HostWeakMap=WeakMap;// There is a WeakMap -- is it good enough?
if(typeof navigator!=='undefined'&&/Firefox/.test(navigator.userAgent)){// We're now *assuming not*, because as of this writing (2013-05-06)
// Firefox's WeakMaps have a miscellany of objects they won't accept, and
// we don't want to make an exhaustive list, and testing for just one
// will be a problem if that one is fixed alone (as they did for Event).
// If there is a platform that we *can* reliably test on, here's how to
// do it:
//  var problematic = ... ;
//  var testHostMap = new HostWeakMap();
//  try {
//    testHostMap.set(problematic, 1);  // Firefox 20 will throw here
//    if (testHostMap.get(problematic) === 1) {
//      return;
//    }
//  } catch (e) {}
}else{// IE 11 bug: WeakMaps silently fail to store frozen objects.
var testMap=new HostWeakMap();var testObject=Object.freeze({});testMap.set(testObject,1);if(testMap.get(testObject)!==1){doubleWeakMapCheckSilentFailure=true;// Fall through to installing our WeakMap.
}else{module.exports=WeakMap;return;}}}var hop=Object.prototype.hasOwnProperty;var gopn=Object.getOwnPropertyNames;var defProp=Object.defineProperty;var isExtensible=Object.isExtensible;/**
   * Security depends on HIDDEN_NAME being both <i>unguessable</i> and
   * <i>undiscoverable</i> by untrusted code.
   *
   * <p>Given the known weaknesses of Math.random() on existing
   * browsers, it does not generate unguessability we can be confident
   * of.
   *
   * <p>It is the monkey patching logic in this file that is intended
   * to ensure undiscoverability. The basic idea is that there are
   * three fundamental means of discovering properties of an object:
   * The for/in loop, Object.keys(), and Object.getOwnPropertyNames(),
   * as well as some proposed ES6 extensions that appear on our
   * whitelist. The first two only discover enumerable properties, and
   * we only use HIDDEN_NAME to name a non-enumerable property, so the
   * only remaining threat should be getOwnPropertyNames and some
   * proposed ES6 extensions that appear on our whitelist. We monkey
   * patch them to remove HIDDEN_NAME from the list of properties they
   * returns.
   *
   * <p>TODO(erights): On a platform with built-in Proxies, proxies
   * could be used to trap and thereby discover the HIDDEN_NAME, so we
   * need to monkey patch Proxy.create, Proxy.createFunction, etc, in
   * order to wrap the provided handler with the real handler which
   * filters out all traps using HIDDEN_NAME.
   *
   * <p>TODO(erights): Revisit Mike Stay's suggestion that we use an
   * encapsulated function at a not-necessarily-secret name, which
   * uses the Stiegler shared-state rights amplification pattern to
   * reveal the associated value only to the WeakMap in which this key
   * is associated with that value. Since only the key retains the
   * function, the function can also remember the key without causing
   * leakage of the key, so this doesn't violate our general gc
   * goals. In addition, because the name need not be a guarded
   * secret, we could efficiently handle cross-frame frozen keys.
   */var HIDDEN_NAME_PREFIX='weakmap:';var HIDDEN_NAME=HIDDEN_NAME_PREFIX+'ident:'+Math.random()+'___';if(typeof crypto!=='undefined'&&typeof crypto.getRandomValues==='function'&&typeof ArrayBuffer==='function'&&typeof Uint8Array==='function'){var ab=new ArrayBuffer(25);var u8s=new Uint8Array(ab);crypto.getRandomValues(u8s);HIDDEN_NAME=HIDDEN_NAME_PREFIX+'rand:'+Array.prototype.map.call(u8s,function(u8){return(u8%36).toString(36);}).join('')+'___';}function isNotHiddenName(name){return!(name.substr(0,HIDDEN_NAME_PREFIX.length)==HIDDEN_NAME_PREFIX&&name.substr(name.length-3)==='___');}/**
   * Monkey patch getOwnPropertyNames to avoid revealing the
   * HIDDEN_NAME.
   *
   * <p>The ES5.1 spec requires each name to appear only once, but as
   * of this writing, this requirement is controversial for ES6, so we
   * made this code robust against this case. If the resulting extra
   * search turns out to be expensive, we can probably relax this once
   * ES6 is adequately supported on all major browsers, iff no browser
   * versions we support at that time have relaxed this constraint
   * without providing built-in ES6 WeakMaps.
   */defProp(Object,'getOwnPropertyNames',{value:function fakeGetOwnPropertyNames(obj){return gopn(obj).filter(isNotHiddenName);}});/**
   * getPropertyNames is not in ES5 but it is proposed for ES6 and
   * does appear in our whitelist, so we need to clean it too.
   */if('getPropertyNames'in Object){var originalGetPropertyNames=Object.getPropertyNames;defProp(Object,'getPropertyNames',{value:function fakeGetPropertyNames(obj){return originalGetPropertyNames(obj).filter(isNotHiddenName);}});}/**
   * <p>To treat objects as identity-keys with reasonable efficiency
   * on ES5 by itself (i.e., without any object-keyed collections), we
   * need to add a hidden property to such key objects when we
   * can. This raises several issues:
   * <ul>
   * <li>Arranging to add this property to objects before we lose the
   *     chance, and
   * <li>Hiding the existence of this new property from most
   *     JavaScript code.
   * <li>Preventing <i>certification theft</i>, where one object is
   *     created falsely claiming to be the key of an association
   *     actually keyed by another object.
   * <li>Preventing <i>value theft</i>, where untrusted code with
   *     access to a key object but not a weak map nevertheless
   *     obtains access to the value associated with that key in that
   *     weak map.
   * </ul>
   * We do so by
   * <ul>
   * <li>Making the name of the hidden property unguessable, so "[]"
   *     indexing, which we cannot intercept, cannot be used to access
   *     a property without knowing the name.
   * <li>Making the hidden property non-enumerable, so we need not
   *     worry about for-in loops or {@code Object.keys},
   * <li>monkey patching those reflective methods that would
   *     prevent extensions, to add this hidden property first,
   * <li>monkey patching those methods that would reveal this
   *     hidden property.
   * </ul>
   * Unfortunately, because of same-origin iframes, we cannot reliably
   * add this hidden property before an object becomes
   * non-extensible. Instead, if we encounter a non-extensible object
   * without a hidden record that we can detect (whether or not it has
   * a hidden record stored under a name secret to us), then we just
   * use the key object itself to represent its identity in a brute
   * force leaky map stored in the weak map, losing all the advantages
   * of weakness for these.
   */function getHiddenRecord(key){if(key!==Object(key)){throw new TypeError('Not an object: '+key);}var hiddenRecord=key[HIDDEN_NAME];if(hiddenRecord&&hiddenRecord.key===key){return hiddenRecord;}if(!isExtensible(key)){// Weak map must brute force, as explained in doc-comment above.
return void 0;}// The hiddenRecord and the key point directly at each other, via
// the "key" and HIDDEN_NAME properties respectively. The key
// field is for quickly verifying that this hidden record is an
// own property, not a hidden record from up the prototype chain.
//
// NOTE: Because this WeakMap emulation is meant only for systems like
// SES where Object.prototype is frozen without any numeric
// properties, it is ok to use an object literal for the hiddenRecord.
// This has two advantages:
// * It is much faster in a performance critical place
// * It avoids relying on Object.create(null), which had been
//   problematic on Chrome 28.0.1480.0. See
//   https://code.google.com/p/google-caja/issues/detail?id=1687
hiddenRecord={key:key};// When using this WeakMap emulation on platforms where
// Object.prototype might not be frozen and Object.create(null) is
// reliable, use the following two commented out lines instead.
// hiddenRecord = Object.create(null);
// hiddenRecord.key = key;
// Please contact us if you need this to work on platforms where
// Object.prototype might not be frozen and
// Object.create(null) might not be reliable.
try{defProp(key,HIDDEN_NAME,{value:hiddenRecord,writable:false,enumerable:false,configurable:false});return hiddenRecord;}catch(error){// Under some circumstances, isExtensible seems to misreport whether
// the HIDDEN_NAME can be defined.
// The circumstances have not been isolated, but at least affect
// Node.js v0.10.26 on TravisCI / Linux, but not the same version of
// Node.js on OS X.
return void 0;}}/**
   * Monkey patch operations that would make their argument
   * non-extensible.
   *
   * <p>The monkey patched versions throw a TypeError if their
   * argument is not an object, so it should only be done to functions
   * that should throw a TypeError anyway if their argument is not an
   * object.
   */(function(){var oldFreeze=Object.freeze;defProp(Object,'freeze',{value:function identifyingFreeze(obj){getHiddenRecord(obj);return oldFreeze(obj);}});var oldSeal=Object.seal;defProp(Object,'seal',{value:function identifyingSeal(obj){getHiddenRecord(obj);return oldSeal(obj);}});var oldPreventExtensions=Object.preventExtensions;defProp(Object,'preventExtensions',{value:function identifyingPreventExtensions(obj){getHiddenRecord(obj);return oldPreventExtensions(obj);}});})();function constFunc(func){func.prototype=null;return Object.freeze(func);}var calledAsFunctionWarningDone=false;function calledAsFunctionWarning(){// Future ES6 WeakMap is currently (2013-09-10) expected to reject WeakMap()
// but we used to permit it and do it ourselves, so warn only.
if(!calledAsFunctionWarningDone&&typeof console!=='undefined'){calledAsFunctionWarningDone=true;console.warn('WeakMap should be invoked as new WeakMap(), not '+'WeakMap(). This will be an error in the future.');}}var nextId=0;var OurWeakMap=function(){if(!(this instanceof OurWeakMap)){// approximate test for new ...()
calledAsFunctionWarning();}// We are currently (12/25/2012) never encountering any prematurely
// non-extensible keys.
var keys=[];// brute force for prematurely non-extensible keys.
var values=[];// brute force for corresponding values.
var id=nextId++;function get___(key,opt_default){var index;var hiddenRecord=getHiddenRecord(key);if(hiddenRecord){return id in hiddenRecord?hiddenRecord[id]:opt_default;}else{index=keys.indexOf(key);return index>=0?values[index]:opt_default;}}function has___(key){var hiddenRecord=getHiddenRecord(key);if(hiddenRecord){return id in hiddenRecord;}else{return keys.indexOf(key)>=0;}}function set___(key,value){var index;var hiddenRecord=getHiddenRecord(key);if(hiddenRecord){hiddenRecord[id]=value;}else{index=keys.indexOf(key);if(index>=0){values[index]=value;}else{// Since some browsers preemptively terminate slow turns but
// then continue computing with presumably corrupted heap
// state, we here defensively get keys.length first and then
// use it to update both the values and keys arrays, keeping
// them in sync.
index=keys.length;values[index]=value;// If we crash here, values will be one longer than keys.
keys[index]=key;}}return this;}function delete___(key){var hiddenRecord=getHiddenRecord(key);var index,lastIndex;if(hiddenRecord){return id in hiddenRecord&&delete hiddenRecord[id];}else{index=keys.indexOf(key);if(index<0){return false;}// Since some browsers preemptively terminate slow turns but
// then continue computing with potentially corrupted heap
// state, we here defensively get keys.length first and then use
// it to update both the keys and the values array, keeping
// them in sync. We update the two with an order of assignments,
// such that any prefix of these assignments will preserve the
// key/value correspondence, either before or after the delete.
// Note that this needs to work correctly when index === lastIndex.
lastIndex=keys.length-1;keys[index]=void 0;// If we crash here, there's a void 0 in the keys array, but
// no operation will cause a "keys.indexOf(void 0)", since
// getHiddenRecord(void 0) will always throw an error first.
values[index]=values[lastIndex];// If we crash here, values[index] cannot be found here,
// because keys[index] is void 0.
keys[index]=keys[lastIndex];// If index === lastIndex and we crash here, then keys[index]
// is still void 0, since the aliasing killed the previous key.
keys.length=lastIndex;// If we crash here, keys will be one shorter than values.
values.length=lastIndex;return true;}}return Object.create(OurWeakMap.prototype,{get___:{value:constFunc(get___)},has___:{value:constFunc(has___)},set___:{value:constFunc(set___)},delete___:{value:constFunc(delete___)}});};OurWeakMap.prototype=Object.create(Object.prototype,{get:{/**
       * Return the value most recently associated with key, or
       * opt_default if none.
       */value:function get(key,opt_default){return this.get___(key,opt_default);},writable:true,configurable:true},has:{/**
       * Is there a value associated with key in this WeakMap?
       */value:function has(key){return this.has___(key);},writable:true,configurable:true},set:{/**
       * Associate value with key in this WeakMap, overwriting any
       * previous association if present.
       */value:function set(key,value){return this.set___(key,value);},writable:true,configurable:true},'delete':{/**
       * Remove any association for key in this WeakMap, returning
       * whether there was one.
       *
       * <p>Note that the boolean return here does not work like the
       * {@code delete} operator. The {@code delete} operator returns
       * whether the deletion succeeds at bringing about a state in
       * which the deleted property is absent. The {@code delete}
       * operator therefore returns true if the property was already
       * absent, whereas this {@code delete} method returns false if
       * the association was already absent.
       */value:function remove(key){return this.delete___(key);},writable:true,configurable:true}});if(typeof HostWeakMap==='function'){(function(){// If we got here, then the platform has a WeakMap but we are concerned
// that it may refuse to store some key types. Therefore, make a map
// implementation which makes use of both as possible.
// In this mode we are always using double maps, so we are not proxy-safe.
// This combination does not occur in any known browser, but we had best
// be safe.
if(doubleWeakMapCheckSilentFailure&&typeof Proxy!=='undefined'){Proxy=undefined;}function DoubleWeakMap(){if(!(this instanceof OurWeakMap)){// approximate test for new ...()
calledAsFunctionWarning();}// Preferable, truly weak map.
var hmap=new HostWeakMap();// Our hidden-property-based pseudo-weak-map. Lazily initialized in the
// 'set' implementation; thus we can avoid performing extra lookups if
// we know all entries actually stored are entered in 'hmap'.
var omap=undefined;// Hidden-property maps are not compatible with proxies because proxies
// can observe the hidden name and either accidentally expose it or fail
// to allow the hidden property to be set. Therefore, we do not allow
// arbitrary WeakMaps to switch to using hidden properties, but only
// those which need the ability, and unprivileged code is not allowed
// to set the flag.
//
// (Except in doubleWeakMapCheckSilentFailure mode in which case we
// disable proxies.)
var enableSwitching=false;function dget(key,opt_default){if(omap){return hmap.has(key)?hmap.get(key):omap.get___(key,opt_default);}else{return hmap.get(key,opt_default);}}function dhas(key){return hmap.has(key)||(omap?omap.has___(key):false);}var dset;if(doubleWeakMapCheckSilentFailure){dset=function(key,value){hmap.set(key,value);if(!hmap.has(key)){if(!omap){omap=new OurWeakMap();}omap.set(key,value);}return this;};}else{dset=function(key,value){if(enableSwitching){try{hmap.set(key,value);}catch(e){if(!omap){omap=new OurWeakMap();}omap.set___(key,value);}}else{hmap.set(key,value);}return this;};}function ddelete(key){var result=!!hmap['delete'](key);if(omap){return omap.delete___(key)||result;}return result;}return Object.create(OurWeakMap.prototype,{get___:{value:constFunc(dget)},has___:{value:constFunc(dhas)},set___:{value:constFunc(dset)},delete___:{value:constFunc(ddelete)},permitHostObjects___:{value:constFunc(function(token){if(token===weakMapPermitHostObjects){enableSwitching=true;}else{throw new Error('bogus call to permitHostObjects___');}})}});}DoubleWeakMap.prototype=OurWeakMap.prototype;module.exports=DoubleWeakMap;// define .constructor to hide OurWeakMap ctor
Object.defineProperty(WeakMap.prototype,'constructor',{value:WeakMap,enumerable:false,// as default .constructor is
configurable:true,writable:true});})();}else{// There is no host WeakMap, so we must use the emulation.
// Emulated WeakMaps are incompatible with native proxies (because proxies
// can observe the hidden name), so we must disable Proxy usage (in
// ArrayLike and Domado, currently).
if(typeof Proxy!=='undefined'){Proxy=undefined;}module.exports=OurWeakMap;}})();/***/}),/***/236:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_890927__){var hiddenStore=__nested_webpack_require_890927__(8284);module.exports=createStore;function createStore(){var key={};return function(obj){if((typeof obj!=='object'||obj===null)&&typeof obj!=='function'){throw new Error('Weakmap-shim: Key must be object');}var store=obj.valueOf(key);return store&&store.identity===key?store:hiddenStore(obj,key);};}/***/}),/***/8284:(/***/function(module){module.exports=hiddenStore;function hiddenStore(obj,key){var store={identity:key};var valueOf=obj.valueOf;Object.defineProperty(obj,"valueOf",{value:function(value){return value!==key?valueOf.apply(this,arguments):store;},writable:true});return store;}/***/}),/***/606:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_891639__){// Original - @Gozola.
// https://gist.github.com/Gozala/1269991
// This is a reimplemented version (with a few bug fixes).
var createStore=__nested_webpack_require_891639__(236);module.exports=weakMap;function weakMap(){var privates=createStore();return{'get':function(key,fallback){var store=privates(key);return store.hasOwnProperty('value')?store.value:fallback;},'set':function(key,value){privates(key).value=value;return this;},'has':function(key){return'value'in privates(key);},'delete':function(key){return delete privates(key).value;}};}/***/}),/***/3349:(/***/function(module){"use strict";function CWiseOp(){return function(SS,a0,t0,p0,Y0,Y1){var s0=SS[0],t0p0=t0[0],index=[0],q0=t0p0;p0|=0;var i0=0,d0s0=t0p0;for(i0=0;i0<s0;++i0){{var da=a0[p0]-Y1;var db=a0[p0+q0]-Y1;if(da>=0!==db>=0){Y0.push(index[0]+0.5+0.5*(da+db)/(da-db));}}p0+=d0s0;++index[0];}};}//Generates a cwise operator
function generateCWiseOp(){return CWiseOp();}var compile=generateCWiseOp;function thunk(compile){var CACHED={};return function zeroCrossings_cwise_thunk(array0,scalar2,scalar3){var t0=array0.dtype,r0=array0.order,type=[t0,r0.join()].join(),proc=CACHED[type];if(!proc){CACHED[type]=proc=compile([t0,r0]);}return proc(array0.shape.slice(0),array0.data,array0.stride,array0.offset|0,scalar2,scalar3);};}function createThunk(proc){return thunk(compile.bind(undefined,proc));}function compileCwise(user_args){return createThunk({funcName:user_args.funcName});}module.exports=compileCwise({funcName:'zeroCrossings'});/***/}),/***/781:(/***/function(module,__unused_webpack_exports,__nested_webpack_require_893217__){"use strict";module.exports=findZeroCrossings;var core=__nested_webpack_require_893217__(3349);function findZeroCrossings(array,level){var cross=[];level=+level||0.0;core(array.hi(array.shape[0]-1),cross,level);return cross;}/***/}),/***/7790:(/***/function(){/* (ignored) */ /***/})/******/};/************************************************************************/ /******/ // The module cache
/******/var __webpack_module_cache__={};/******/ /******/ // The require function
/******/function __nested_webpack_require_893711__(moduleId){/******/ // Check if module is in cache
/******/var cachedModule=__webpack_module_cache__[moduleId];/******/if(cachedModule!==undefined){/******/return cachedModule.exports;/******/}/******/ // Create a new module (and put it into the cache)
/******/var module=__webpack_module_cache__[moduleId]={/******/id:moduleId,/******/loaded:false,/******/exports:{}/******/};/******/ /******/ // Execute the module function
/******/__webpack_modules__[moduleId].call(module.exports,module,module.exports,__nested_webpack_require_893711__);/******/ /******/ // Flag the module as loaded
/******/module.loaded=true;/******/ /******/ // Return the exports of the module
/******/return module.exports;/******/}/******/ /************************************************************************/ /******/ /* webpack/runtime/global */ /******/!function(){/******/__nested_webpack_require_893711__.g=function(){/******/if(typeof globalThis==='object')return globalThis;/******/try{/******/return this||new Function('return this')();/******/}catch(e){/******/if(typeof window==='object')return window;/******/}/******/}();/******/}();/******/ /******/ /* webpack/runtime/node module decorator */ /******/!function(){/******/__nested_webpack_require_893711__.nmd=function(module){/******/module.paths=[];/******/if(!module.children)module.children=[];/******/return module;/******/};/******/}();/******/ /************************************************************************/ /******/ /******/ // startup
/******/ // Load entry module and return exports
/******/ // This entry module is referenced by other modules so it can't be inlined
/******/var __nested_webpack_exports__=__nested_webpack_require_893711__(1964);/******/module.exports=__nested_webpack_exports__;/******/ /******/})();

/***/ }),

/***/ 45708:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var base64 = __webpack_require__(76226);
var ieee754 = __webpack_require__(27415);
var customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
: null;
exports.Buffer = Buffer;
exports.SlowBuffer = SlowBuffer;
exports.INSPECT_MAX_BYTES = 50;
var K_MAX_LENGTH = 0x7fffffff;
exports.kMaxLength = K_MAX_LENGTH;

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */
Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') {
  console.error('This browser lacks typed array (Uint8Array) support which is required by ' + '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.');
}
function typedArraySupport() {
  // Can typed array instances can be augmented?
  try {
    var arr = new Uint8Array(1);
    var proto = {
      foo: function foo() {
        return 42;
      }
    };
    Object.setPrototypeOf(proto, Uint8Array.prototype);
    Object.setPrototypeOf(arr, proto);
    return arr.foo() === 42;
  } catch (e) {
    return false;
  }
}
Object.defineProperty(Buffer.prototype, 'parent', {
  enumerable: true,
  get: function get() {
    if (!Buffer.isBuffer(this)) return undefined;
    return this.buffer;
  }
});
Object.defineProperty(Buffer.prototype, 'offset', {
  enumerable: true,
  get: function get() {
    if (!Buffer.isBuffer(this)) return undefined;
    return this.byteOffset;
  }
});
function createBuffer(length) {
  if (length > K_MAX_LENGTH) {
    throw new RangeError('The value "' + length + '" is invalid for option "size"');
  }
  // Return an augmented `Uint8Array` instance
  var buf = new Uint8Array(length);
  Object.setPrototypeOf(buf, Buffer.prototype);
  return buf;
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer(arg, encodingOrOffset, length) {
  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new TypeError('The "string" argument must be of type string. Received type number');
    }
    return allocUnsafe(arg);
  }
  return from(arg, encodingOrOffset, length);
}
Buffer.poolSize = 8192; // not used by this implementation

function from(value, encodingOrOffset, length) {
  if (typeof value === 'string') {
    return fromString(value, encodingOrOffset);
  }
  if (ArrayBuffer.isView(value)) {
    return fromArrayView(value);
  }
  if (value == null) {
    throw new TypeError('The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' + 'or Array-like Object. Received type ' + _typeof(value));
  }
  if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) {
    return fromArrayBuffer(value, encodingOrOffset, length);
  }
  if (typeof SharedArrayBuffer !== 'undefined' && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) {
    return fromArrayBuffer(value, encodingOrOffset, length);
  }
  if (typeof value === 'number') {
    throw new TypeError('The "value" argument must not be of type number. Received type number');
  }
  var valueOf = value.valueOf && value.valueOf();
  if (valueOf != null && valueOf !== value) {
    return Buffer.from(valueOf, encodingOrOffset, length);
  }
  var b = fromObject(value);
  if (b) return b;
  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') {
    return Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
  }
  throw new TypeError('The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' + 'or Array-like Object. Received type ' + _typeof(value));
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(value, encodingOrOffset, length);
};

// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf(Buffer, Uint8Array);
function assertSize(size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be of type number');
  } else if (size < 0) {
    throw new RangeError('The value "' + size + '" is invalid for option "size"');
  }
}
function alloc(size, fill, encoding) {
  assertSize(size);
  if (size <= 0) {
    return createBuffer(size);
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
  }
  return createBuffer(size);
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(size, fill, encoding);
};
function allocUnsafe(size) {
  assertSize(size);
  return createBuffer(size < 0 ? 0 : checked(size) | 0);
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(size);
};
function fromString(string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8';
  }
  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('Unknown encoding: ' + encoding);
  }
  var length = byteLength(string, encoding) | 0;
  var buf = createBuffer(length);
  var actual = buf.write(string, encoding);
  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
  }
  return buf;
}
function fromArrayLike(array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0;
  var buf = createBuffer(length);
  for (var i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255;
  }
  return buf;
}
function fromArrayView(arrayView) {
  if (isInstance(arrayView, Uint8Array)) {
    var copy = new Uint8Array(arrayView);
    return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
  }
  return fromArrayLike(arrayView);
}
function fromArrayBuffer(array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('"offset" is outside of buffer bounds');
  }
  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('"length" is outside of buffer bounds');
  }
  var buf;
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array);
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset);
  } else {
    buf = new Uint8Array(array, byteOffset, length);
  }

  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(buf, Buffer.prototype);
  return buf;
}
function fromObject(obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0;
    var buf = createBuffer(len);
    if (buf.length === 0) {
      return buf;
    }
    obj.copy(buf, 0, 0, len);
    return buf;
  }
  if (obj.length !== undefined) {
    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
      return createBuffer(0);
    }
    return fromArrayLike(obj);
  }
  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
    return fromArrayLike(obj.data);
  }
}
function checked(length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' + 'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes');
  }
  return length | 0;
}
function SlowBuffer(length) {
  if (+length != length) {
    // eslint-disable-line eqeqeq
    length = 0;
  }
  return Buffer.alloc(+length);
}
Buffer.isBuffer = function isBuffer(b) {
  return b != null && b._isBuffer === true && b !== Buffer.prototype; // so Buffer.isBuffer(Buffer.prototype) will be false
};
Buffer.compare = function compare(a, b) {
  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
  }
  if (a === b) return 0;
  var x = a.length;
  var y = b.length;
  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i];
      y = b[i];
      break;
    }
  }
  if (x < y) return -1;
  if (y < x) return 1;
  return 0;
};
Buffer.isEncoding = function isEncoding(encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true;
    default:
      return false;
  }
};
Buffer.concat = function concat(list, length) {
  if (!Array.isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers');
  }
  if (list.length === 0) {
    return Buffer.alloc(0);
  }
  var i;
  if (length === undefined) {
    length = 0;
    for (i = 0; i < list.length; ++i) {
      length += list[i].length;
    }
  }
  var buffer = Buffer.allocUnsafe(length);
  var pos = 0;
  for (i = 0; i < list.length; ++i) {
    var buf = list[i];
    if (isInstance(buf, Uint8Array)) {
      if (pos + buf.length > buffer.length) {
        if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf);
        buf.copy(buffer, pos);
      } else {
        Uint8Array.prototype.set.call(buffer, buf, pos);
      }
    } else if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers');
    } else {
      buf.copy(buffer, pos);
    }
    pos += buf.length;
  }
  return buffer;
};
function byteLength(string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length;
  }
  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
    return string.byteLength;
  }
  if (typeof string !== 'string') {
    throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' + 'Received type ' + _typeof(string));
  }
  var len = string.length;
  var mustMatch = arguments.length > 2 && arguments[2] === true;
  if (!mustMatch && len === 0) return 0;

  // Use a for loop to avoid recursion
  var loweredCase = false;
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len;
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length;
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2;
      case 'hex':
        return len >>> 1;
      case 'base64':
        return base64ToBytes(string).length;
      default:
        if (loweredCase) {
          return mustMatch ? -1 : utf8ToBytes(string).length; // assume utf8
        }
        encoding = ('' + encoding).toLowerCase();
        loweredCase = true;
    }
  }
}
Buffer.byteLength = byteLength;
function slowToString(encoding, start, end) {
  var loweredCase = false;

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0;
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return '';
  }
  if (end === undefined || end > this.length) {
    end = this.length;
  }
  if (end <= 0) {
    return '';
  }

  // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0;
  start >>>= 0;
  if (end <= start) {
    return '';
  }
  if (!encoding) encoding = 'utf8';
  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end);
      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end);
      case 'ascii':
        return asciiSlice(this, start, end);
      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end);
      case 'base64':
        return base64Slice(this, start, end);
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end);
      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
        encoding = (encoding + '').toLowerCase();
        loweredCase = true;
    }
  }
}

// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true;
function swap(b, n, m) {
  var i = b[n];
  b[n] = b[m];
  b[m] = i;
}
Buffer.prototype.swap16 = function swap16() {
  var len = this.length;
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits');
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1);
  }
  return this;
};
Buffer.prototype.swap32 = function swap32() {
  var len = this.length;
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits');
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3);
    swap(this, i + 1, i + 2);
  }
  return this;
};
Buffer.prototype.swap64 = function swap64() {
  var len = this.length;
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits');
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7);
    swap(this, i + 1, i + 6);
    swap(this, i + 2, i + 5);
    swap(this, i + 3, i + 4);
  }
  return this;
};
Buffer.prototype.toString = function toString() {
  var length = this.length;
  if (length === 0) return '';
  if (arguments.length === 0) return utf8Slice(this, 0, length);
  return slowToString.apply(this, arguments);
};
Buffer.prototype.toLocaleString = Buffer.prototype.toString;
Buffer.prototype.equals = function equals(b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
  if (this === b) return true;
  return Buffer.compare(this, b) === 0;
};
Buffer.prototype.inspect = function inspect() {
  var str = '';
  var max = exports.INSPECT_MAX_BYTES;
  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
  if (this.length > max) str += ' ... ';
  return '<Buffer ' + str + '>';
};
if (customInspectSymbol) {
  Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect;
}
Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
  if (isInstance(target, Uint8Array)) {
    target = Buffer.from(target, target.offset, target.byteLength);
  }
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. ' + 'Received type ' + _typeof(target));
  }
  if (start === undefined) {
    start = 0;
  }
  if (end === undefined) {
    end = target ? target.length : 0;
  }
  if (thisStart === undefined) {
    thisStart = 0;
  }
  if (thisEnd === undefined) {
    thisEnd = this.length;
  }
  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index');
  }
  if (thisStart >= thisEnd && start >= end) {
    return 0;
  }
  if (thisStart >= thisEnd) {
    return -1;
  }
  if (start >= end) {
    return 1;
  }
  start >>>= 0;
  end >>>= 0;
  thisStart >>>= 0;
  thisEnd >>>= 0;
  if (this === target) return 0;
  var x = thisEnd - thisStart;
  var y = end - start;
  var len = Math.min(x, y);
  var thisCopy = this.slice(thisStart, thisEnd);
  var targetCopy = target.slice(start, end);
  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i];
      y = targetCopy[i];
      break;
    }
  }
  if (x < y) return -1;
  if (y < x) return 1;
  return 0;
};

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1;

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset;
    byteOffset = 0;
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff;
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000;
  }
  byteOffset = +byteOffset; // Coerce to Number.
  if (numberIsNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
  if (byteOffset >= buffer.length) {
    if (dir) return -1;else byteOffset = buffer.length - 1;
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0;else return -1;
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding);
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1;
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
  } else if (typeof val === 'number') {
    val = val & 0xFF; // Search for a byte value [0-255]
    if (typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
      }
    }
    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir);
  }
  throw new TypeError('val must be string, number or Buffer');
}
function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
  var indexSize = 1;
  var arrLength = arr.length;
  var valLength = val.length;
  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase();
    if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1;
      }
      indexSize = 2;
      arrLength /= 2;
      valLength /= 2;
      byteOffset /= 2;
    }
  }
  function read(buf, i) {
    if (indexSize === 1) {
      return buf[i];
    } else {
      return buf.readUInt16BE(i * indexSize);
    }
  }
  var i;
  if (dir) {
    var foundIndex = -1;
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i;
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
      } else {
        if (foundIndex !== -1) i -= i - foundIndex;
        foundIndex = -1;
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
    for (i = byteOffset; i >= 0; i--) {
      var found = true;
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false;
          break;
        }
      }
      if (found) return i;
    }
  }
  return -1;
}
Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function hexWrite(buf, string, offset, length) {
  offset = Number(offset) || 0;
  var remaining = buf.length - offset;
  if (!length) {
    length = remaining;
  } else {
    length = Number(length);
    if (length > remaining) {
      length = remaining;
    }
  }
  var strLen = string.length;
  if (length > strLen / 2) {
    length = strLen / 2;
  }
  var i;
  for (i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16);
    if (numberIsNaN(parsed)) return i;
    buf[offset + i] = parsed;
  }
  return i;
}
function utf8Write(buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function asciiWrite(buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length);
}
function base64Write(buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length);
}
function ucs2Write(buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
Buffer.prototype.write = function write(string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8';
    length = this.length;
    offset = 0;
    // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset;
    length = this.length;
    offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset >>> 0;
    if (isFinite(length)) {
      length = length >>> 0;
      if (encoding === undefined) encoding = 'utf8';
    } else {
      encoding = length;
      length = undefined;
    }
  } else {
    throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
  }
  var remaining = this.length - offset;
  if (length === undefined || length > remaining) length = remaining;
  if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds');
  }
  if (!encoding) encoding = 'utf8';
  var loweredCase = false;
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length);
      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length);
      case 'ascii':
      case 'latin1':
      case 'binary':
        return asciiWrite(this, string, offset, length);
      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length);
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length);
      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
        encoding = ('' + encoding).toLowerCase();
        loweredCase = true;
    }
  }
};
Buffer.prototype.toJSON = function toJSON() {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  };
};
function base64Slice(buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf);
  } else {
    return base64.fromByteArray(buf.slice(start, end));
  }
}
function utf8Slice(buf, start, end) {
  end = Math.min(buf.length, end);
  var res = [];
  var i = start;
  while (i < end) {
    var firstByte = buf[i];
    var codePoint = null;
    var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
    if (i + bytesPerSequence <= end) {
      var secondByte = void 0,
        thirdByte = void 0,
        fourthByte = void 0,
        tempCodePoint = void 0;
      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte;
          }
          break;
        case 2:
          secondByte = buf[i + 1];
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint;
            }
          }
          break;
        case 3:
          secondByte = buf[i + 1];
          thirdByte = buf[i + 2];
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint;
            }
          }
          break;
        case 4:
          secondByte = buf[i + 1];
          thirdByte = buf[i + 2];
          fourthByte = buf[i + 3];
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint;
            }
          }
      }
    }
    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD;
      bytesPerSequence = 1;
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000;
      res.push(codePoint >>> 10 & 0x3FF | 0xD800);
      codePoint = 0xDC00 | codePoint & 0x3FF;
    }
    res.push(codePoint);
    i += bytesPerSequence;
  }
  return decodeCodePointsArray(res);
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000;
function decodeCodePointsArray(codePoints) {
  var len = codePoints.length;
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints); // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = '';
  var i = 0;
  while (i < len) {
    res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
  }
  return res;
}
function asciiSlice(buf, start, end) {
  var ret = '';
  end = Math.min(buf.length, end);
  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F);
  }
  return ret;
}
function latin1Slice(buf, start, end) {
  var ret = '';
  end = Math.min(buf.length, end);
  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i]);
  }
  return ret;
}
function hexSlice(buf, start, end) {
  var len = buf.length;
  if (!start || start < 0) start = 0;
  if (!end || end < 0 || end > len) end = len;
  var out = '';
  for (var i = start; i < end; ++i) {
    out += hexSliceLookupTable[buf[i]];
  }
  return out;
}
function utf16leSlice(buf, start, end) {
  var bytes = buf.slice(start, end);
  var res = '';
  // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
  for (var i = 0; i < bytes.length - 1; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
  }
  return res;
}
Buffer.prototype.slice = function slice(start, end) {
  var len = this.length;
  start = ~~start;
  end = end === undefined ? len : ~~end;
  if (start < 0) {
    start += len;
    if (start < 0) start = 0;
  } else if (start > len) {
    start = len;
  }
  if (end < 0) {
    end += len;
    if (end < 0) end = 0;
  } else if (end > len) {
    end = len;
  }
  if (end < start) end = start;
  var newBuf = this.subarray(start, end);
  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(newBuf, Buffer.prototype);
  return newBuf;
};

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset(offset, ext, length) {
  if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
Buffer.prototype.readUintLE = Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
  offset = offset >>> 0;
  byteLength = byteLength >>> 0;
  if (!noAssert) checkOffset(offset, byteLength, this.length);
  var val = this[offset];
  var mul = 1;
  var i = 0;
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul;
  }
  return val;
};
Buffer.prototype.readUintBE = Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
  offset = offset >>> 0;
  byteLength = byteLength >>> 0;
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length);
  }
  var val = this[offset + --byteLength];
  var mul = 1;
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul;
  }
  return val;
};
Buffer.prototype.readUint8 = Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 1, this.length);
  return this[offset];
};
Buffer.prototype.readUint16LE = Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 2, this.length);
  return this[offset] | this[offset + 1] << 8;
};
Buffer.prototype.readUint16BE = Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 2, this.length);
  return this[offset] << 8 | this[offset + 1];
};
Buffer.prototype.readUint32LE = Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 4, this.length);
  return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
Buffer.prototype.readUint32BE = Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 4, this.length);
  return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
Buffer.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE(offset) {
  offset = offset >>> 0;
  validateNumber(offset, 'offset');
  var first = this[offset];
  var last = this[offset + 7];
  if (first === undefined || last === undefined) {
    boundsError(offset, this.length - 8);
  }
  var lo = first + this[++offset] * Math.pow(2, 8) + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24);
  var hi = this[++offset] + this[++offset] * Math.pow(2, 8) + this[++offset] * Math.pow(2, 16) + last * Math.pow(2, 24);
  return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
Buffer.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE(offset) {
  offset = offset >>> 0;
  validateNumber(offset, 'offset');
  var first = this[offset];
  var last = this[offset + 7];
  if (first === undefined || last === undefined) {
    boundsError(offset, this.length - 8);
  }
  var hi = first * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 8) + this[++offset];
  var lo = this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 8) + last;
  return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
  offset = offset >>> 0;
  byteLength = byteLength >>> 0;
  if (!noAssert) checkOffset(offset, byteLength, this.length);
  var val = this[offset];
  var mul = 1;
  var i = 0;
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul;
  }
  mul *= 0x80;
  if (val >= mul) val -= Math.pow(2, 8 * byteLength);
  return val;
};
Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
  offset = offset >>> 0;
  byteLength = byteLength >>> 0;
  if (!noAssert) checkOffset(offset, byteLength, this.length);
  var i = byteLength;
  var mul = 1;
  var val = this[offset + --i];
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul;
  }
  mul *= 0x80;
  if (val >= mul) val -= Math.pow(2, 8 * byteLength);
  return val;
};
Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 1, this.length);
  if (!(this[offset] & 0x80)) return this[offset];
  return (0xff - this[offset] + 1) * -1;
};
Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 2, this.length);
  var val = this[offset] | this[offset + 1] << 8;
  return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 2, this.length);
  var val = this[offset + 1] | this[offset] << 8;
  return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 4, this.length);
  return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 4, this.length);
  return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
Buffer.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE(offset) {
  offset = offset >>> 0;
  validateNumber(offset, 'offset');
  var first = this[offset];
  var last = this[offset + 7];
  if (first === undefined || last === undefined) {
    boundsError(offset, this.length - 8);
  }
  var val = this[offset + 4] + this[offset + 5] * Math.pow(2, 8) + this[offset + 6] * Math.pow(2, 16) + (last << 24); // Overflow

  return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * Math.pow(2, 8) + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24));
});
Buffer.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE(offset) {
  offset = offset >>> 0;
  validateNumber(offset, 'offset');
  var first = this[offset];
  var last = this[offset + 7];
  if (first === undefined || last === undefined) {
    boundsError(offset, this.length - 8);
  }
  var val = (first << 24) +
  // Overflow
  this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 8) + this[++offset];
  return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 8) + last);
});
Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 4, this.length);
  return ieee754.read(this, offset, true, 23, 4);
};
Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 4, this.length);
  return ieee754.read(this, offset, false, 23, 4);
};
Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 8, this.length);
  return ieee754.read(this, offset, true, 52, 8);
};
Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 8, this.length);
  return ieee754.read(this, offset, false, 52, 8);
};
function checkInt(buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
  if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
Buffer.prototype.writeUintLE = Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset >>> 0;
  byteLength = byteLength >>> 0;
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1;
    checkInt(this, value, offset, byteLength, maxBytes, 0);
  }
  var mul = 1;
  var i = 0;
  this[offset] = value & 0xFF;
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = value / mul & 0xFF;
  }
  return offset + byteLength;
};
Buffer.prototype.writeUintBE = Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset >>> 0;
  byteLength = byteLength >>> 0;
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1;
    checkInt(this, value, offset, byteLength, maxBytes, 0);
  }
  var i = byteLength - 1;
  var mul = 1;
  this[offset + i] = value & 0xFF;
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = value / mul & 0xFF;
  }
  return offset + byteLength;
};
Buffer.prototype.writeUint8 = Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
  this[offset] = value & 0xff;
  return offset + 1;
};
Buffer.prototype.writeUint16LE = Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
  this[offset] = value & 0xff;
  this[offset + 1] = value >>> 8;
  return offset + 2;
};
Buffer.prototype.writeUint16BE = Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
  this[offset] = value >>> 8;
  this[offset + 1] = value & 0xff;
  return offset + 2;
};
Buffer.prototype.writeUint32LE = Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
  this[offset + 3] = value >>> 24;
  this[offset + 2] = value >>> 16;
  this[offset + 1] = value >>> 8;
  this[offset] = value & 0xff;
  return offset + 4;
};
Buffer.prototype.writeUint32BE = Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
  this[offset] = value >>> 24;
  this[offset + 1] = value >>> 16;
  this[offset + 2] = value >>> 8;
  this[offset + 3] = value & 0xff;
  return offset + 4;
};
function wrtBigUInt64LE(buf, value, offset, min, max) {
  checkIntBI(value, min, max, buf, offset, 7);
  var lo = Number(value & BigInt(0xffffffff));
  buf[offset++] = lo;
  lo = lo >> 8;
  buf[offset++] = lo;
  lo = lo >> 8;
  buf[offset++] = lo;
  lo = lo >> 8;
  buf[offset++] = lo;
  var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
  buf[offset++] = hi;
  hi = hi >> 8;
  buf[offset++] = hi;
  hi = hi >> 8;
  buf[offset++] = hi;
  hi = hi >> 8;
  buf[offset++] = hi;
  return offset;
}
function wrtBigUInt64BE(buf, value, offset, min, max) {
  checkIntBI(value, min, max, buf, offset, 7);
  var lo = Number(value & BigInt(0xffffffff));
  buf[offset + 7] = lo;
  lo = lo >> 8;
  buf[offset + 6] = lo;
  lo = lo >> 8;
  buf[offset + 5] = lo;
  lo = lo >> 8;
  buf[offset + 4] = lo;
  var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
  buf[offset + 3] = hi;
  hi = hi >> 8;
  buf[offset + 2] = hi;
  hi = hi >> 8;
  buf[offset + 1] = hi;
  hi = hi >> 8;
  buf[offset] = hi;
  return offset + 8;
}
Buffer.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE(value) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
Buffer.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE(value) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1);
    checkInt(this, value, offset, byteLength, limit - 1, -limit);
  }
  var i = 0;
  var mul = 1;
  var sub = 0;
  this[offset] = value & 0xFF;
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1;
    }
    this[offset + i] = (value / mul >> 0) - sub & 0xFF;
  }
  return offset + byteLength;
};
Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1);
    checkInt(this, value, offset, byteLength, limit - 1, -limit);
  }
  var i = byteLength - 1;
  var mul = 1;
  var sub = 0;
  this[offset + i] = value & 0xFF;
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1;
    }
    this[offset + i] = (value / mul >> 0) - sub & 0xFF;
  }
  return offset + byteLength;
};
Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80);
  if (value < 0) value = 0xff + value + 1;
  this[offset] = value & 0xff;
  return offset + 1;
};
Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
  this[offset] = value & 0xff;
  this[offset + 1] = value >>> 8;
  return offset + 2;
};
Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
  this[offset] = value >>> 8;
  this[offset + 1] = value & 0xff;
  return offset + 2;
};
Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
  this[offset] = value & 0xff;
  this[offset + 1] = value >>> 8;
  this[offset + 2] = value >>> 16;
  this[offset + 3] = value >>> 24;
  return offset + 4;
};
Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
  if (value < 0) value = 0xffffffff + value + 1;
  this[offset] = value >>> 24;
  this[offset + 1] = value >>> 16;
  this[offset + 2] = value >>> 8;
  this[offset + 3] = value & 0xff;
  return offset + 4;
};
Buffer.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE(value) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
Buffer.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE(value) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function checkIEEE754(buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range');
  if (offset < 0) throw new RangeError('Index out of range');
}
function writeFloat(buf, value, offset, littleEndian, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38);
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4);
  return offset + 4;
}
Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert);
};
Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert);
};
function writeDouble(buf, value, offset, littleEndian, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308);
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8);
  return offset + 8;
}
Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert);
};
Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert);
};

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
  if (!start) start = 0;
  if (!end && end !== 0) end = this.length;
  if (targetStart >= target.length) targetStart = target.length;
  if (!targetStart) targetStart = 0;
  if (end > 0 && end < start) end = start;

  // Copy 0 bytes; we're done
  if (end === start) return 0;
  if (target.length === 0 || this.length === 0) return 0;

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds');
  }
  if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
  if (end < 0) throw new RangeError('sourceEnd out of bounds');

  // Are we oob?
  if (end > this.length) end = this.length;
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start;
  }
  var len = end - start;
  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
    // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
  } else {
    Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
  }
  return len;
};

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start;
      start = 0;
      end = this.length;
    } else if (typeof end === 'string') {
      encoding = end;
      end = this.length;
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string');
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding);
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0);
      if (encoding === 'utf8' && code < 128 || encoding === 'latin1') {
        // Fast path: If `val` fits into a single byte, use that numeric value.
        val = code;
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255;
  } else if (typeof val === 'boolean') {
    val = Number(val);
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index');
  }
  if (end <= start) {
    return this;
  }
  start = start >>> 0;
  end = end === undefined ? this.length : end >>> 0;
  if (!val) val = 0;
  var i;
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val;
    }
  } else {
    var bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
    var len = bytes.length;
    if (len === 0) {
      throw new TypeError('The value "' + val + '" is invalid for argument "value"');
    }
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len];
    }
  }
  return this;
};

// CUSTOM ERRORS
// =============

// Simplified versions from Node, changed for Buffer-only usage
var errors = {};
function E(sym, getMessage, Base) {
  errors[sym] = /*#__PURE__*/function (_Base) {
    _inherits(NodeError, _Base);
    function NodeError() {
      var _this;
      _classCallCheck(this, NodeError);
      _this = _callSuper(this, NodeError);
      Object.defineProperty(_assertThisInitialized(_this), 'message', {
        value: getMessage.apply(_assertThisInitialized(_this), arguments),
        writable: true,
        configurable: true
      });

      // Add the error code to the name to include it in the stack trace.
      _this.name = "".concat(_this.name, " [").concat(sym, "]");
      // Access the stack to generate the error message including the error code
      // from the name.
      _this.stack; // eslint-disable-line no-unused-expressions
      // Reset the name to the actual name.
      delete _this.name;
      return _this;
    }
    _createClass(NodeError, [{
      key: "code",
      get: function get() {
        return sym;
      },
      set: function set(value) {
        Object.defineProperty(this, 'code', {
          configurable: true,
          enumerable: true,
          value: value,
          writable: true
        });
      }
    }, {
      key: "toString",
      value: function toString() {
        return "".concat(this.name, " [").concat(sym, "]: ").concat(this.message);
      }
    }]);
    return NodeError;
  }(Base);
}
E('ERR_BUFFER_OUT_OF_BOUNDS', function (name) {
  if (name) {
    return "".concat(name, " is outside of buffer bounds");
  }
  return 'Attempt to access memory outside buffer bounds';
}, RangeError);
E('ERR_INVALID_ARG_TYPE', function (name, actual) {
  return "The \"".concat(name, "\" argument must be of type number. Received type ").concat(_typeof(actual));
}, TypeError);
E('ERR_OUT_OF_RANGE', function (str, range, input) {
  var msg = "The value of \"".concat(str, "\" is out of range.");
  var received = input;
  if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) {
    received = addNumericalSeparator(String(input));
  } else if (typeof input === 'bigint') {
    received = String(input);
    if (input > Math.pow(BigInt(2), BigInt(32)) || input < -Math.pow(BigInt(2), BigInt(32))) {
      received = addNumericalSeparator(received);
    }
    received += 'n';
  }
  msg += " It must be ".concat(range, ". Received ").concat(received);
  return msg;
}, RangeError);
function addNumericalSeparator(val) {
  var res = '';
  var i = val.length;
  var start = val[0] === '-' ? 1 : 0;
  for (; i >= start + 4; i -= 3) {
    res = "_".concat(val.slice(i - 3, i)).concat(res);
  }
  return "".concat(val.slice(0, i)).concat(res);
}

// CHECK FUNCTIONS
// ===============

function checkBounds(buf, offset, byteLength) {
  validateNumber(offset, 'offset');
  if (buf[offset] === undefined || buf[offset + byteLength] === undefined) {
    boundsError(offset, buf.length - (byteLength + 1));
  }
}
function checkIntBI(value, min, max, buf, offset, byteLength) {
  if (value > max || value < min) {
    var n = typeof min === 'bigint' ? 'n' : '';
    var range;
    if (byteLength > 3) {
      if (min === 0 || min === BigInt(0)) {
        range = ">= 0".concat(n, " and < 2").concat(n, " ** ").concat((byteLength + 1) * 8).concat(n);
      } else {
        range = ">= -(2".concat(n, " ** ").concat((byteLength + 1) * 8 - 1).concat(n, ") and < 2 ** ") + "".concat((byteLength + 1) * 8 - 1).concat(n);
      }
    } else {
      range = ">= ".concat(min).concat(n, " and <= ").concat(max).concat(n);
    }
    throw new errors.ERR_OUT_OF_RANGE('value', range, value);
  }
  checkBounds(buf, offset, byteLength);
}
function validateNumber(value, name) {
  if (typeof value !== 'number') {
    throw new errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
  }
}
function boundsError(value, length, type) {
  if (Math.floor(value) !== value) {
    validateNumber(value, type);
    throw new errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
  }
  if (length < 0) {
    throw new errors.ERR_BUFFER_OUT_OF_BOUNDS();
  }
  throw new errors.ERR_OUT_OF_RANGE(type || 'offset', ">= ".concat(type ? 1 : 0, " and <= ").concat(length), value);
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function base64clean(str) {
  // Node takes equal signs as end of the Base64 encoding
  str = str.split('=')[0];
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = str.trim().replace(INVALID_BASE64_RE, '');
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return '';
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '=';
  }
  return str;
}
function utf8ToBytes(string, units) {
  units = units || Infinity;
  var codePoint;
  var length = string.length;
  var leadSurrogate = null;
  var bytes = [];
  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i);

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
          continue;
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
          continue;
        }

        // valid lead
        leadSurrogate = codePoint;
        continue;
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        leadSurrogate = codePoint;
        continue;
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
    }
    leadSurrogate = null;

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break;
      bytes.push(codePoint);
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break;
      bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break;
      bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break;
      bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
    } else {
      throw new Error('Invalid code point');
    }
  }
  return bytes;
}
function asciiToBytes(str) {
  var byteArray = [];
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
  }
  return byteArray;
}
function utf16leToBytes(str, units) {
  var c, hi, lo;
  var byteArray = [];
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break;
    c = str.charCodeAt(i);
    hi = c >> 8;
    lo = c % 256;
    byteArray.push(lo);
    byteArray.push(hi);
  }
  return byteArray;
}
function base64ToBytes(str) {
  return base64.toByteArray(base64clean(str));
}
function blitBuffer(src, dst, offset, length) {
  var i;
  for (i = 0; i < length; ++i) {
    if (i + offset >= dst.length || i >= src.length) break;
    dst[i + offset] = src[i];
  }
  return i;
}

// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance(obj, type) {
  return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function numberIsNaN(obj) {
  // For IE11 support
  return obj !== obj; // eslint-disable-line no-self-compare
}

// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var hexSliceLookupTable = function () {
  var alphabet = '0123456789abcdef';
  var table = new Array(256);
  for (var i = 0; i < 16; ++i) {
    var i16 = i * 16;
    for (var j = 0; j < 16; ++j) {
      table[i16 + j] = alphabet[i] + alphabet[j];
    }
  }
  return table;
}();

// Return not function with Error if BigInt not supported
function defineBigIntMethod(fn) {
  return typeof BigInt === 'undefined' ? BufferBigIntNotDefined : fn;
}
function BufferBigIntNotDefined() {
  throw new Error('BigInt not supported');
}

/***/ }),

/***/ 13087:
/***/ (function(module) {

"use strict";


module.exports = isMobile;
module.exports.isMobile = isMobile;
module.exports["default"] = isMobile;
var mobileRE = /(android|bb\d+|meego).+mobile|armv7l|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|samsungbrowser.*mobile|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i;
var notMobileRE = /CrOS/;
var tabletRE = /android|ipad|playbook|silk/i;
function isMobile(opts) {
  if (!opts) opts = {};
  var ua = opts.ua;
  if (!ua && typeof navigator !== 'undefined') ua = navigator.userAgent;
  if (ua && ua.headers && typeof ua.headers['user-agent'] === 'string') {
    ua = ua.headers['user-agent'];
  }
  if (typeof ua !== 'string') return false;
  var result = mobileRE.test(ua) && !notMobileRE.test(ua) || !!opts.tablet && tabletRE.test(ua);
  if (!result && opts.tablet && opts.featureDetect && navigator && navigator.maxTouchPoints > 1 && ua.indexOf('Macintosh') !== -1 && ua.indexOf('Safari') !== -1) {
    result = true;
  }
  return result;
}

/***/ }),

/***/ 5955:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22413);
/* harmony import */ var _css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51070);
/* harmony import */ var _css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62133);
/* harmony import */ var _css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2__);
// Imports



var ___CSS_LOADER_URL_IMPORT_0___ = new URL(/* asset import */ __webpack_require__(77035), __webpack_require__.b);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL(/* asset import */ __webpack_require__(43470), __webpack_require__.b);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL(/* asset import */ __webpack_require__(68164), __webpack_require__.b);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL(/* asset import */ __webpack_require__(64665), __webpack_require__.b);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL(/* asset import */ __webpack_require__(4890), __webpack_require__.b);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL(/* asset import */ __webpack_require__(13363), __webpack_require__.b);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL(/* asset import */ __webpack_require__(13490), __webpack_require__.b);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL(/* asset import */ __webpack_require__(47603), __webpack_require__.b);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL(/* asset import */ __webpack_require__(13913), __webpack_require__.b);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL(/* asset import */ __webpack_require__(91413), __webpack_require__.b);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL(/* asset import */ __webpack_require__(64643), __webpack_require__.b);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL(/* asset import */ __webpack_require__(80216), __webpack_require__.b);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL(/* asset import */ __webpack_require__(61907), __webpack_require__.b);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL(/* asset import */ __webpack_require__(68605), __webpack_require__.b);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL(/* asset import */ __webpack_require__(25446), __webpack_require__.b);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL(/* asset import */ __webpack_require__(56694), __webpack_require__.b);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL(/* asset import */ __webpack_require__(24420), __webpack_require__.b);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL(/* asset import */ __webpack_require__(75796), __webpack_require__.b);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL(/* asset import */ __webpack_require__(92228), __webpack_require__.b);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL(/* asset import */ __webpack_require__(9819), __webpack_require__.b);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL(/* asset import */ __webpack_require__(47695), __webpack_require__.b);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL(/* asset import */ __webpack_require__(28869), __webpack_require__.b);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL(/* asset import */ __webpack_require__(30557), __webpack_require__.b);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL(/* asset import */ __webpack_require__(48460), __webpack_require__.b);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL(/* asset import */ __webpack_require__(56539), __webpack_require__.b);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL(/* asset import */ __webpack_require__(43737), __webpack_require__.b);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL(/* asset import */ __webpack_require__(47914), __webpack_require__.b);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL(/* asset import */ __webpack_require__(26117), __webpack_require__.b);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL(/* asset import */ __webpack_require__(66311), __webpack_require__.b);
var ___CSS_LOADER_EXPORT___ = _css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
var ___CSS_LOADER_URL_REPLACEMENT_0___ = _css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = _css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = _css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = _css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = _css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = _css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = _css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = _css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = _css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = _css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = _css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = _css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = _css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = _css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = _css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = _css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = _css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = _css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = _css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = _css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = _css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = _css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = _css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = _css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = _css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = _css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = _css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = _css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = _css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()(___CSS_LOADER_URL_IMPORT_28___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".maplibregl-map{font:12px/20px Helvetica Neue,Arial,Helvetica,sans-serif;overflow:hidden;position:relative;-webkit-tap-highlight-color:rgb(0 0 0/0)}.maplibregl-canvas{left:0;position:absolute;top:0}.maplibregl-map:fullscreen{height:100%;width:100%}.maplibregl-ctrl-group button.maplibregl-ctrl-compass{touch-action:none}.maplibregl-canvas-container.maplibregl-interactive,.maplibregl-ctrl-group button.maplibregl-ctrl-compass{cursor:grab;-webkit-user-select:none;-moz-user-select:none;user-select:none}.maplibregl-canvas-container.maplibregl-interactive.maplibregl-track-pointer{cursor:pointer}.maplibregl-canvas-container.maplibregl-interactive:active,.maplibregl-ctrl-group button.maplibregl-ctrl-compass:active{cursor:grabbing}.maplibregl-canvas-container.maplibregl-touch-zoom-rotate,.maplibregl-canvas-container.maplibregl-touch-zoom-rotate .maplibregl-canvas{touch-action:pan-x pan-y}.maplibregl-canvas-container.maplibregl-touch-drag-pan,.maplibregl-canvas-container.maplibregl-touch-drag-pan .maplibregl-canvas{touch-action:pinch-zoom}.maplibregl-canvas-container.maplibregl-touch-zoom-rotate.maplibregl-touch-drag-pan,.maplibregl-canvas-container.maplibregl-touch-zoom-rotate.maplibregl-touch-drag-pan .maplibregl-canvas{touch-action:none}.maplibregl-canvas-container.maplibregl-touch-drag-pan.maplibregl-cooperative-gestures,.maplibregl-canvas-container.maplibregl-touch-drag-pan.maplibregl-cooperative-gestures .maplibregl-canvas{touch-action:pan-x pan-y}.maplibregl-ctrl-bottom-left,.maplibregl-ctrl-bottom-right,.maplibregl-ctrl-top-left,.maplibregl-ctrl-top-right{pointer-events:none;position:absolute;z-index:2}.maplibregl-ctrl-top-left{left:0;top:0}.maplibregl-ctrl-top-right{right:0;top:0}.maplibregl-ctrl-bottom-left{bottom:0;left:0}.maplibregl-ctrl-bottom-right{bottom:0;right:0}.maplibregl-ctrl{clear:both;pointer-events:auto;transform:translate(0)}.maplibregl-ctrl-top-left .maplibregl-ctrl{float:left;margin:10px 0 0 10px}.maplibregl-ctrl-top-right .maplibregl-ctrl{float:right;margin:10px 10px 0 0}.maplibregl-ctrl-bottom-left .maplibregl-ctrl{float:left;margin:0 0 10px 10px}.maplibregl-ctrl-bottom-right .maplibregl-ctrl{float:right;margin:0 10px 10px 0}.maplibregl-ctrl-group{background:#fff;border-radius:4px}.maplibregl-ctrl-group:not(:empty){box-shadow:0 0 0 2px rgba(0,0,0,.1)}@media (forced-colors:active){.maplibregl-ctrl-group:not(:empty){box-shadow:0 0 0 2px ButtonText}}.maplibregl-ctrl-group button{background-color:transparent;border:0;box-sizing:border-box;cursor:pointer;display:block;height:29px;outline:none;padding:0;width:29px}.maplibregl-ctrl-group button+button{border-top:1px solid #ddd}.maplibregl-ctrl button .maplibregl-ctrl-icon{background-position:50%;background-repeat:no-repeat;display:block;height:100%;width:100%}@media (forced-colors:active){.maplibregl-ctrl-icon{background-color:transparent}.maplibregl-ctrl-group button+button{border-top:1px solid ButtonText}}.maplibregl-ctrl button::-moz-focus-inner{border:0;padding:0}.maplibregl-ctrl-attrib-button:focus,.maplibregl-ctrl-group button:focus{box-shadow:0 0 2px 2px #0096ff}.maplibregl-ctrl button:disabled{cursor:not-allowed}.maplibregl-ctrl button:disabled .maplibregl-ctrl-icon{opacity:.25}.maplibregl-ctrl button:not(:disabled):hover{background-color:rgb(0 0 0/5%)}.maplibregl-ctrl-group button:focus:focus-visible{box-shadow:0 0 2px 2px #0096ff}.maplibregl-ctrl-group button:focus:not(:focus-visible){box-shadow:none}.maplibregl-ctrl-group button:focus:first-child{border-radius:4px 4px 0 0}.maplibregl-ctrl-group button:focus:last-child{border-radius:0 0 4px 4px}.maplibregl-ctrl-group button:focus:only-child{border-radius:inherit}.maplibregl-ctrl button.maplibregl-ctrl-zoom-out .maplibregl-ctrl-icon{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ")}.maplibregl-ctrl button.maplibregl-ctrl-zoom-in .maplibregl-ctrl-icon{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_1___ + ")}@media (forced-colors:active){.maplibregl-ctrl button.maplibregl-ctrl-zoom-out .maplibregl-ctrl-icon{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_2___ + ")}.maplibregl-ctrl button.maplibregl-ctrl-zoom-in .maplibregl-ctrl-icon{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_3___ + ")}}@media (forced-colors:active) and (prefers-color-scheme:light){.maplibregl-ctrl button.maplibregl-ctrl-zoom-out .maplibregl-ctrl-icon{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_4___ + ")}.maplibregl-ctrl button.maplibregl-ctrl-zoom-in .maplibregl-ctrl-icon{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_5___ + ")}}.maplibregl-ctrl button.maplibregl-ctrl-fullscreen .maplibregl-ctrl-icon{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_6___ + ")}.maplibregl-ctrl button.maplibregl-ctrl-shrink .maplibregl-ctrl-icon{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_7___ + ")}@media (forced-colors:active){.maplibregl-ctrl button.maplibregl-ctrl-fullscreen .maplibregl-ctrl-icon{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_8___ + ")}.maplibregl-ctrl button.maplibregl-ctrl-shrink .maplibregl-ctrl-icon{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_9___ + ")}}@media (forced-colors:active) and (prefers-color-scheme:light){.maplibregl-ctrl button.maplibregl-ctrl-fullscreen .maplibregl-ctrl-icon{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_10___ + ")}.maplibregl-ctrl button.maplibregl-ctrl-shrink .maplibregl-ctrl-icon{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_7___ + ")}}.maplibregl-ctrl button.maplibregl-ctrl-compass .maplibregl-ctrl-icon{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_11___ + ")}@media (forced-colors:active){.maplibregl-ctrl button.maplibregl-ctrl-compass .maplibregl-ctrl-icon{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_12___ + ")}}@media (forced-colors:active) and (prefers-color-scheme:light){.maplibregl-ctrl button.maplibregl-ctrl-compass .maplibregl-ctrl-icon{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_13___ + ")}}.maplibregl-ctrl button.maplibregl-ctrl-terrain .maplibregl-ctrl-icon{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_14___ + ")}.maplibregl-ctrl button.maplibregl-ctrl-terrain-enabled .maplibregl-ctrl-icon{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_15___ + ")}.maplibregl-ctrl button.maplibregl-ctrl-geolocate .maplibregl-ctrl-icon{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_16___ + ")}.maplibregl-ctrl button.maplibregl-ctrl-geolocate:disabled .maplibregl-ctrl-icon{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_17___ + ")}.maplibregl-ctrl button.maplibregl-ctrl-geolocate.maplibregl-ctrl-geolocate-active .maplibregl-ctrl-icon{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_18___ + ")}.maplibregl-ctrl button.maplibregl-ctrl-geolocate.maplibregl-ctrl-geolocate-active-error .maplibregl-ctrl-icon{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_19___ + ")}.maplibregl-ctrl button.maplibregl-ctrl-geolocate.maplibregl-ctrl-geolocate-background .maplibregl-ctrl-icon{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_20___ + ")}.maplibregl-ctrl button.maplibregl-ctrl-geolocate.maplibregl-ctrl-geolocate-background-error .maplibregl-ctrl-icon{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_21___ + ")}.maplibregl-ctrl button.maplibregl-ctrl-geolocate.maplibregl-ctrl-geolocate-waiting .maplibregl-ctrl-icon{animation:maplibregl-spin 2s linear infinite}@media (forced-colors:active){.maplibregl-ctrl button.maplibregl-ctrl-geolocate .maplibregl-ctrl-icon{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_22___ + ")}.maplibregl-ctrl button.maplibregl-ctrl-geolocate:disabled .maplibregl-ctrl-icon{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_23___ + ")}.maplibregl-ctrl button.maplibregl-ctrl-geolocate.maplibregl-ctrl-geolocate-active .maplibregl-ctrl-icon{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_18___ + ")}.maplibregl-ctrl button.maplibregl-ctrl-geolocate.maplibregl-ctrl-geolocate-active-error .maplibregl-ctrl-icon{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_19___ + ")}.maplibregl-ctrl button.maplibregl-ctrl-geolocate.maplibregl-ctrl-geolocate-background .maplibregl-ctrl-icon{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_20___ + ")}.maplibregl-ctrl button.maplibregl-ctrl-geolocate.maplibregl-ctrl-geolocate-background-error .maplibregl-ctrl-icon{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_21___ + ")}}@media (forced-colors:active) and (prefers-color-scheme:light){.maplibregl-ctrl button.maplibregl-ctrl-geolocate .maplibregl-ctrl-icon{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_24___ + ")}.maplibregl-ctrl button.maplibregl-ctrl-geolocate:disabled .maplibregl-ctrl-icon{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_25___ + ")}}@keyframes maplibregl-spin{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}a.maplibregl-ctrl-logo{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_26___ + ");background-repeat:no-repeat;cursor:pointer;display:block;height:23px;margin:0 0 -4px -4px;overflow:hidden;width:88px}a.maplibregl-ctrl-logo.maplibregl-compact{width:14px}@media (forced-colors:active){a.maplibregl-ctrl-logo{background-color:transparent;background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_26___ + ")}}@media (forced-colors:active) and (prefers-color-scheme:light){a.maplibregl-ctrl-logo{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_26___ + ")}}.maplibregl-ctrl.maplibregl-ctrl-attrib{background-color:hsla(0,0%,100%,.5);margin:0;padding:0 5px}@media screen{.maplibregl-ctrl-attrib.maplibregl-compact{background-color:#fff;border-radius:12px;box-sizing:content-box;color:#000;margin:10px;min-height:20px;padding:2px 24px 2px 0;position:relative}.maplibregl-ctrl-attrib.maplibregl-compact-show{padding:2px 28px 2px 8px;visibility:visible}.maplibregl-ctrl-bottom-left>.maplibregl-ctrl-attrib.maplibregl-compact-show,.maplibregl-ctrl-top-left>.maplibregl-ctrl-attrib.maplibregl-compact-show{border-radius:12px;padding:2px 8px 2px 28px}.maplibregl-ctrl-attrib.maplibregl-compact .maplibregl-ctrl-attrib-inner{display:none}.maplibregl-ctrl-attrib-button{background-color:hsla(0,0%,100%,.5);background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_27___ + ");border:0;border-radius:12px;box-sizing:border-box;cursor:pointer;display:none;height:24px;outline:none;position:absolute;right:0;top:0;width:24px}.maplibregl-ctrl-attrib summary.maplibregl-ctrl-attrib-button{-webkit-appearance:none;-moz-appearance:none;appearance:none;list-style:none}.maplibregl-ctrl-attrib summary.maplibregl-ctrl-attrib-button::-webkit-details-marker{display:none}.maplibregl-ctrl-bottom-left .maplibregl-ctrl-attrib-button,.maplibregl-ctrl-top-left .maplibregl-ctrl-attrib-button{left:0}.maplibregl-ctrl-attrib.maplibregl-compact .maplibregl-ctrl-attrib-button,.maplibregl-ctrl-attrib.maplibregl-compact-show .maplibregl-ctrl-attrib-inner{display:block}.maplibregl-ctrl-attrib.maplibregl-compact-show .maplibregl-ctrl-attrib-button{background-color:rgb(0 0 0/5%)}.maplibregl-ctrl-bottom-right>.maplibregl-ctrl-attrib.maplibregl-compact:after{bottom:0;right:0}.maplibregl-ctrl-top-right>.maplibregl-ctrl-attrib.maplibregl-compact:after{right:0;top:0}.maplibregl-ctrl-top-left>.maplibregl-ctrl-attrib.maplibregl-compact:after{left:0;top:0}.maplibregl-ctrl-bottom-left>.maplibregl-ctrl-attrib.maplibregl-compact:after{bottom:0;left:0}}@media screen and (forced-colors:active){.maplibregl-ctrl-attrib.maplibregl-compact:after{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_28___ + ")}}@media screen and (forced-colors:active) and (prefers-color-scheme:light){.maplibregl-ctrl-attrib.maplibregl-compact:after{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_27___ + ")}}.maplibregl-ctrl-attrib a{color:rgba(0,0,0,.75);text-decoration:none}.maplibregl-ctrl-attrib a:hover{color:inherit;text-decoration:underline}.maplibregl-attrib-empty{display:none}.maplibregl-ctrl-scale{background-color:hsla(0,0%,100%,.75);border:2px solid #333;border-top:#333;box-sizing:border-box;color:#333;font-size:10px;padding:0 5px}.maplibregl-popup{display:flex;left:0;pointer-events:none;position:absolute;top:0;will-change:transform}.maplibregl-popup-anchor-top,.maplibregl-popup-anchor-top-left,.maplibregl-popup-anchor-top-right{flex-direction:column}.maplibregl-popup-anchor-bottom,.maplibregl-popup-anchor-bottom-left,.maplibregl-popup-anchor-bottom-right{flex-direction:column-reverse}.maplibregl-popup-anchor-left{flex-direction:row}.maplibregl-popup-anchor-right{flex-direction:row-reverse}.maplibregl-popup-tip{border:10px solid transparent;height:0;width:0;z-index:1}.maplibregl-popup-anchor-top .maplibregl-popup-tip{align-self:center;border-bottom-color:#fff;border-top:none}.maplibregl-popup-anchor-top-left .maplibregl-popup-tip{align-self:flex-start;border-bottom-color:#fff;border-left:none;border-top:none}.maplibregl-popup-anchor-top-right .maplibregl-popup-tip{align-self:flex-end;border-bottom-color:#fff;border-right:none;border-top:none}.maplibregl-popup-anchor-bottom .maplibregl-popup-tip{align-self:center;border-bottom:none;border-top-color:#fff}.maplibregl-popup-anchor-bottom-left .maplibregl-popup-tip{align-self:flex-start;border-bottom:none;border-left:none;border-top-color:#fff}.maplibregl-popup-anchor-bottom-right .maplibregl-popup-tip{align-self:flex-end;border-bottom:none;border-right:none;border-top-color:#fff}.maplibregl-popup-anchor-left .maplibregl-popup-tip{align-self:center;border-left:none;border-right-color:#fff}.maplibregl-popup-anchor-right .maplibregl-popup-tip{align-self:center;border-left-color:#fff;border-right:none}.maplibregl-popup-close-button{background-color:transparent;border:0;border-radius:0 3px 0 0;cursor:pointer;position:absolute;right:0;top:0}.maplibregl-popup-close-button:hover{background-color:rgb(0 0 0/5%)}.maplibregl-popup-content{background:#fff;border-radius:3px;box-shadow:0 1px 2px rgba(0,0,0,.1);padding:15px 10px;pointer-events:auto;position:relative}.maplibregl-popup-anchor-top-left .maplibregl-popup-content{border-top-left-radius:0}.maplibregl-popup-anchor-top-right .maplibregl-popup-content{border-top-right-radius:0}.maplibregl-popup-anchor-bottom-left .maplibregl-popup-content{border-bottom-left-radius:0}.maplibregl-popup-anchor-bottom-right .maplibregl-popup-content{border-bottom-right-radius:0}.maplibregl-popup-track-pointer{display:none}.maplibregl-popup-track-pointer *{pointer-events:none;-webkit-user-select:none;-moz-user-select:none;user-select:none}.maplibregl-map:hover .maplibregl-popup-track-pointer{display:flex}.maplibregl-map:active .maplibregl-popup-track-pointer{display:none}.maplibregl-marker{left:0;position:absolute;top:0;transition:opacity .2s;will-change:transform}.maplibregl-user-location-dot,.maplibregl-user-location-dot:before{background-color:#1da1f2;border-radius:50%;height:15px;width:15px}.maplibregl-user-location-dot:before{animation:maplibregl-user-location-dot-pulse 2s infinite;content:\"\";position:absolute}.maplibregl-user-location-dot:after{border:2px solid #fff;border-radius:50%;box-shadow:0 0 3px rgba(0,0,0,.35);box-sizing:border-box;content:\"\";height:19px;left:-2px;position:absolute;top:-2px;width:19px}@keyframes maplibregl-user-location-dot-pulse{0%{opacity:1;transform:scale(1)}70%{opacity:0;transform:scale(3)}to{opacity:0;transform:scale(1)}}.maplibregl-user-location-dot-stale{background-color:#aaa}.maplibregl-user-location-dot-stale:after{display:none}.maplibregl-user-location-accuracy-circle{background-color:#1da1f233;border-radius:100%;height:1px;width:1px}.maplibregl-crosshair,.maplibregl-crosshair .maplibregl-interactive,.maplibregl-crosshair .maplibregl-interactive:active{cursor:crosshair}.maplibregl-boxzoom{background:#fff;border:2px dotted #202020;height:0;left:0;opacity:.5;position:absolute;top:0;width:0}.maplibregl-cooperative-gesture-screen{align-items:center;background:rgba(0,0,0,.4);color:#fff;display:flex;font-size:1.4em;inset:0;justify-content:center;line-height:1.2;opacity:0;padding:1rem;pointer-events:none;position:absolute;transition:opacity 1s ease 1s;z-index:99999}.maplibregl-cooperative-gesture-screen.maplibregl-show{opacity:1;transition:opacity .05s}.maplibregl-cooperative-gesture-screen .maplibregl-mobile-message{display:none}@media (hover:none),(width <= 480px){.maplibregl-cooperative-gesture-screen .maplibregl-desktop-message{display:none}.maplibregl-cooperative-gesture-screen .maplibregl-mobile-message{display:block}}.maplibregl-pseudo-fullscreen{height:100%!important;left:0!important;position:fixed!important;top:0!important;width:100%!important;z-index:99999}", ""]);
// Exports
/* harmony default export */ __webpack_exports__.A = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 68735:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   sankeyCenter: function() { return /* binding */ center; },
/* harmony export */   sankeyCircular: function() { return /* binding */ sankeyCircular; },
/* harmony export */   sankeyJustify: function() { return /* binding */ justify; },
/* harmony export */   sankeyLeft: function() { return /* binding */ left; },
/* harmony export */   sankeyRight: function() { return /* binding */ right; }
/* harmony export */ });
/* harmony import */ var d3_array__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29725);
/* harmony import */ var d3_collection__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4575);
/* harmony import */ var d3_shape__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48544);
/* harmony import */ var elementary_circuits_directed_graph__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96143);
/* harmony import */ var elementary_circuits_directed_graph__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(elementary_circuits_directed_graph__WEBPACK_IMPORTED_MODULE_2__);





// For a given link, return the target node's depth
function targetDepth(d) {
  return d.target.depth;
}

// The depth of a node when the nodeAlign (align) is set to 'left'
function left(node) {
  return node.depth;
}

// The depth of a node when the nodeAlign (align) is set to 'right'
function right(node, n) {
  return n - 1 - node.height;
}

// The depth of a node when the nodeAlign (align) is set to 'justify'
function justify(node, n) {
  return node.sourceLinks.length ? node.depth : n - 1;
}

// The depth of a node when the nodeAlign (align) is set to 'center'
function center(node) {
  return node.targetLinks.length ? node.depth : node.sourceLinks.length ? (0,d3_array__WEBPACK_IMPORTED_MODULE_0__/* .min */ .jk)(node.sourceLinks, targetDepth) - 1 : 0;
}

// returns a function, using the parameter given to the sankey setting
function constant(x) {
  return function () {
    return x;
  };
}

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

/// https://github.com/tomshanley/d3-sankeyCircular-circular

// sort links' breadth (ie top to bottom in a column), based on their source nodes' breadths
function ascendingSourceBreadth(a, b) {
  return ascendingBreadth(a.source, b.source) || a.index - b.index;
}

// sort links' breadth (ie top to bottom in a column), based on their target nodes' breadths
function ascendingTargetBreadth(a, b) {
  return ascendingBreadth(a.target, b.target) || a.index - b.index;
}

// sort nodes' breadth (ie top to bottom in a column)
// if both nodes have circular links, or both don't have circular links, then sort by the top (y0) of the node
// else push nodes that have top circular links to the top, and nodes that have bottom circular links to the bottom
function ascendingBreadth(a, b) {
  if (a.partOfCycle === b.partOfCycle) {
    return a.y0 - b.y0;
  } else {
    if (a.circularLinkType === 'top' || b.circularLinkType === 'bottom') {
      return -1;
    } else {
      return 1;
    }
  }
}

// return the value of a node or link
function value(d) {
  return d.value;
}

// return the vertical center of a node
function nodeCenter(node) {
  return (node.y0 + node.y1) / 2;
}

// return the vertical center of a link's source node
function linkSourceCenter(link) {
  return nodeCenter(link.source);
}

// return the vertical center of a link's target node
function linkTargetCenter(link) {
  return nodeCenter(link.target);
}

// Return the default value for ID for node, d.index
function defaultId(d) {
  return d.index;
}

// Return the default object the graph's nodes, graph.nodes
function defaultNodes(graph) {
  return graph.nodes;
}

// Return the default object the graph's nodes, graph.links
function defaultLinks(graph) {
  return graph.links;
}

// Return the node from the collection that matches the provided ID, or throw an error if no match
function find(nodeById, id) {
  var node = nodeById.get(id);
  if (!node) throw new Error('missing: ' + id);
  return node;
}

function getNodeID(node, id) {
  return id(node);
}

// The main sankeyCircular functions

// Some constants for circular link calculations
var verticalMargin = 25;
var baseRadius = 10;
var scale = 0.3; //Possibly let user control this, although anything over 0.5 starts to get too cramped

function sankeyCircular () {
  // Set the default values
  var x0 = 0,
      y0 = 0,
      x1 = 1,
      y1 = 1,
      // extent
  dx = 24,
      // nodeWidth
  py,
      // nodePadding, for vertical postioning
  id = defaultId,
      align = justify,
      nodes = defaultNodes,
      links = defaultLinks,
      iterations = 32,
      circularLinkGap = 2,
      paddingRatio,
      sortNodes = null;

  function sankeyCircular() {
    var graph = {
      nodes: nodes.apply(null, arguments),
      links: links.apply(null, arguments)

      // Process the graph's nodes and links, setting their positions

      // 1.  Associate the nodes with their respective links, and vice versa
    };computeNodeLinks(graph);

    // 2.  Determine which links result in a circular path in the graph
    identifyCircles(graph, id, sortNodes);

    // 4. Calculate the nodes' values, based on the values of the incoming and outgoing links
    computeNodeValues(graph);

    // 5.  Calculate the nodes' depth based on the incoming and outgoing links
    //     Sets the nodes':
    //     - depth:  the depth in the graph
    //     - column: the depth (0, 1, 2, etc), as is relates to visual position from left to right
    //     - x0, x1: the x coordinates, as is relates to visual position from left to right
    computeNodeDepths(graph);

    // 3.  Determine how the circular links will be drawn,
    //     either travelling back above the main chart ("top")
    //     or below the main chart ("bottom")
    selectCircularLinkTypes(graph, id);

    // 6.  Calculate the nodes' and links' vertical position within their respective column
    //     Also readjusts sankeyCircular size if circular links are needed, and node x's
    computeNodeBreadths(graph, iterations, id);
    computeLinkBreadths(graph);

    // 7.  Sort links per node, based on the links' source/target nodes' breadths
    // 8.  Adjust nodes that overlap links that span 2+ columns
    var linkSortingIterations = 4; //Possibly let user control this number, like the iterations over node placement
    for (var iteration = 0; iteration < linkSortingIterations; iteration++) {

      sortSourceLinks(graph, y1, id);
      sortTargetLinks(graph, y1, id);
      resolveNodeLinkOverlaps(graph, y0, y1, id);
      sortSourceLinks(graph, y1, id);
      sortTargetLinks(graph, y1, id);
    }

    // 8.1  Adjust node and link positions back to fill height of chart area if compressed
    fillHeight(graph, y0, y1);

    // 9. Calculate visually appealling path for the circular paths, and create the "d" string
    addCircularPathData(graph, circularLinkGap, y1, id);

    return graph;
  } // end of sankeyCircular function


  // Set the sankeyCircular parameters
  // nodeID, nodeAlign, nodeWidth, nodePadding, nodes, links, size, extent, iterations, nodePaddingRatio, circularLinkGap
  sankeyCircular.nodeId = function (_) {
    return arguments.length ? (id = typeof _ === 'function' ? _ : constant(_), sankeyCircular) : id;
  };

  sankeyCircular.nodeAlign = function (_) {
    return arguments.length ? (align = typeof _ === 'function' ? _ : constant(_), sankeyCircular) : align;
  };

  sankeyCircular.nodeWidth = function (_) {
    return arguments.length ? (dx = +_, sankeyCircular) : dx;
  };

  sankeyCircular.nodePadding = function (_) {
    return arguments.length ? (py = +_, sankeyCircular) : py;
  };

  sankeyCircular.nodes = function (_) {
    return arguments.length ? (nodes = typeof _ === 'function' ? _ : constant(_), sankeyCircular) : nodes;
  };

  sankeyCircular.links = function (_) {
    return arguments.length ? (links = typeof _ === 'function' ? _ : constant(_), sankeyCircular) : links;
  };

  sankeyCircular.size = function (_) {
    return arguments.length ? (x0 = y0 = 0, x1 = +_[0], y1 = +_[1], sankeyCircular) : [x1 - x0, y1 - y0];
  };

  sankeyCircular.extent = function (_) {
    return arguments.length ? (x0 = +_[0][0], x1 = +_[1][0], y0 = +_[0][1], y1 = +_[1][1], sankeyCircular) : [[x0, y0], [x1, y1]];
  };

  sankeyCircular.iterations = function (_) {
    return arguments.length ? (iterations = +_, sankeyCircular) : iterations;
  };

  sankeyCircular.circularLinkGap = function (_) {
    return arguments.length ? (circularLinkGap = +_, sankeyCircular) : circularLinkGap;
  };

  sankeyCircular.nodePaddingRatio = function (_) {
    return arguments.length ? (paddingRatio = +_, sankeyCircular) : paddingRatio;
  };

  sankeyCircular.sortNodes = function (_) {
    return arguments.length ? (sortNodes = _, sankeyCircular) : sortNodes;
  };

  sankeyCircular.update = function (graph) {
    // 5.  Calculate the nodes' depth based on the incoming and outgoing links
    //     Sets the nodes':
    //     - depth:  the depth in the graph
    //     - column: the depth (0, 1, 2, etc), as is relates to visual position from left to right
    //     - x0, x1: the x coordinates, as is relates to visual position from left to right
    // computeNodeDepths(graph)

    // 3.  Determine how the circular links will be drawn,
    //     either travelling back above the main chart ("top")
    //     or below the main chart ("bottom")
    selectCircularLinkTypes(graph, id);

    // 6.  Calculate the nodes' and links' vertical position within their respective column
    //     Also readjusts sankeyCircular size if circular links are needed, and node x's
    // computeNodeBreadths(graph, iterations, id)
    computeLinkBreadths(graph);

    // Force position of circular link type based on position
    graph.links.forEach(function (link) {
      if (link.circular) {
        link.circularLinkType = link.y0 + link.y1 < y1 ? 'top' : 'bottom';

        link.source.circularLinkType = link.circularLinkType;
        link.target.circularLinkType = link.circularLinkType;
      }
    });

    sortSourceLinks(graph, y1, id, false); // Sort links but do not move nodes
    sortTargetLinks(graph, y1, id);

    // 7.  Sort links per node, based on the links' source/target nodes' breadths
    // 8.  Adjust nodes that overlap links that span 2+ columns
    // var linkSortingIterations = 4; //Possibly let user control this number, like the iterations over node placement
    // for (var iteration = 0; iteration < linkSortingIterations; iteration++) {
    //
    //   sortSourceLinks(graph, y1, id)
    //   sortTargetLinks(graph, y1, id)
    //   resolveNodeLinkOverlaps(graph, y0, y1, id)
    //   sortSourceLinks(graph, y1, id)
    //   sortTargetLinks(graph, y1, id)
    //
    // }

    // 8.1  Adjust node and link positions back to fill height of chart area if compressed
    // fillHeight(graph, y0, y1)

    // 9. Calculate visually appealling path for the circular paths, and create the "d" string
    addCircularPathData(graph, circularLinkGap, y1, id);
    return graph;
  };

  // Populate the sourceLinks and targetLinks for each node.
  // Also, if the source and target are not objects, assume they are indices.
  function computeNodeLinks(graph) {
    graph.nodes.forEach(function (node, i) {
      node.index = i;
      node.sourceLinks = [];
      node.targetLinks = [];
    });
    var nodeById = (0,d3_collection__WEBPACK_IMPORTED_MODULE_1__/* .map */ .Tj)(graph.nodes, id);
    graph.links.forEach(function (link, i) {
      link.index = i;
      var source = link.source;
      var target = link.target;
      if ((typeof source === "undefined" ? "undefined" : _typeof(source)) !== 'object') {
        source = link.source = find(nodeById, source);
      }
      if ((typeof target === "undefined" ? "undefined" : _typeof(target)) !== 'object') {
        target = link.target = find(nodeById, target);
      }
      source.sourceLinks.push(link);
      target.targetLinks.push(link);
    });
    return graph;
  }

  // Compute the value (size) and cycleness of each node by summing the associated links.
  function computeNodeValues(graph) {
    graph.nodes.forEach(function (node) {
      node.partOfCycle = false;
      node.value = Math.max((0,d3_array__WEBPACK_IMPORTED_MODULE_0__/* .sum */ .cz)(node.sourceLinks, value), (0,d3_array__WEBPACK_IMPORTED_MODULE_0__/* .sum */ .cz)(node.targetLinks, value));
      node.sourceLinks.forEach(function (link) {
        if (link.circular) {
          node.partOfCycle = true;
          node.circularLinkType = link.circularLinkType;
        }
      });
      node.targetLinks.forEach(function (link) {
        if (link.circular) {
          node.partOfCycle = true;
          node.circularLinkType = link.circularLinkType;
        }
      });
    });
  }

  function getCircleMargins(graph) {
    var totalTopLinksWidth = 0,
        totalBottomLinksWidth = 0,
        totalRightLinksWidth = 0,
        totalLeftLinksWidth = 0;

    var maxColumn = (0,d3_array__WEBPACK_IMPORTED_MODULE_0__/* .max */ .T9)(graph.nodes, function (node) {
      return node.column;
    });

    graph.links.forEach(function (link) {
      if (link.circular) {
        if (link.circularLinkType == 'top') {
          totalTopLinksWidth = totalTopLinksWidth + link.width;
        } else {
          totalBottomLinksWidth = totalBottomLinksWidth + link.width;
        }

        if (link.target.column == 0) {
          totalLeftLinksWidth = totalLeftLinksWidth + link.width;
        }

        if (link.source.column == maxColumn) {
          totalRightLinksWidth = totalRightLinksWidth + link.width;
        }
      }
    });

    //account for radius of curves and padding between links
    totalTopLinksWidth = totalTopLinksWidth > 0 ? totalTopLinksWidth + verticalMargin + baseRadius : totalTopLinksWidth;
    totalBottomLinksWidth = totalBottomLinksWidth > 0 ? totalBottomLinksWidth + verticalMargin + baseRadius : totalBottomLinksWidth;
    totalRightLinksWidth = totalRightLinksWidth > 0 ? totalRightLinksWidth + verticalMargin + baseRadius : totalRightLinksWidth;
    totalLeftLinksWidth = totalLeftLinksWidth > 0 ? totalLeftLinksWidth + verticalMargin + baseRadius : totalLeftLinksWidth;

    return { "top": totalTopLinksWidth, "bottom": totalBottomLinksWidth, "left": totalLeftLinksWidth, "right": totalRightLinksWidth };
  }

  // Update the x0, y0, x1 and y1 for the sankeyCircular, to allow space for any circular links
  function scaleSankeySize(graph, margin) {

    var maxColumn = (0,d3_array__WEBPACK_IMPORTED_MODULE_0__/* .max */ .T9)(graph.nodes, function (node) {
      return node.column;
    });

    var currentWidth = x1 - x0;
    var currentHeight = y1 - y0;

    var newWidth = currentWidth + margin.right + margin.left;
    var newHeight = currentHeight + margin.top + margin.bottom;

    var scaleX = currentWidth / newWidth;
    var scaleY = currentHeight / newHeight;

    x0 = x0 * scaleX + margin.left;
    x1 = margin.right == 0 ? x1 : x1 * scaleX;
    y0 = y0 * scaleY + margin.top;
    y1 = y1 * scaleY;

    graph.nodes.forEach(function (node) {
      node.x0 = x0 + node.column * ((x1 - x0 - dx) / maxColumn);
      node.x1 = node.x0 + dx;
    });

    return scaleY;
  }

  // Iteratively assign the depth for each node.
  // Nodes are assigned the maximum depth of incoming neighbors plus one;
  // nodes with no incoming links are assigned depth zero, while
  // nodes with no outgoing links are assigned the maximum depth.
  function computeNodeDepths(graph) {
    var nodes, next, x;

    for (nodes = graph.nodes, next = [], x = 0; nodes.length; ++x, nodes = next, next = []) {
      nodes.forEach(function (node) {
        node.depth = x;
        node.sourceLinks.forEach(function (link) {
          if (next.indexOf(link.target) < 0 && !link.circular) {
            next.push(link.target);
          }
        });
      });
    }

    for (nodes = graph.nodes, next = [], x = 0; nodes.length; ++x, nodes = next, next = []) {
      nodes.forEach(function (node) {
        node.height = x;
        node.targetLinks.forEach(function (link) {
          if (next.indexOf(link.source) < 0 && !link.circular) {
            next.push(link.source);
          }
        });
      });
    }

    // assign column numbers, and get max value
    graph.nodes.forEach(function (node) {
      node.column = Math.floor(align.call(null, node, x));
    });
  }

  // Assign nodes' breadths, and then shift nodes that overlap (resolveCollisions)
  function computeNodeBreadths(graph, iterations, id) {
    var columns = (0,d3_collection__WEBPACK_IMPORTED_MODULE_1__/* .nest */ .$I)().key(function (d) {
      return d.column;
    }).sortKeys(d3_array__WEBPACK_IMPORTED_MODULE_0__/* .ascending */ .V_).entries(graph.nodes).map(function (d) {
      return d.values;
    });

    initializeNodeBreadth(id);
    resolveCollisions();

    for (var alpha = 1, n = iterations; n > 0; --n) {
      relaxLeftAndRight(alpha *= 0.99, id);
      resolveCollisions();
    }

    function initializeNodeBreadth(id) {

      //override py if nodePadding has been set
      if (paddingRatio) {
        var padding = Infinity;
        columns.forEach(function (nodes) {
          var thisPadding = y1 * paddingRatio / (nodes.length + 1);
          padding = thisPadding < padding ? thisPadding : padding;
        });
        py = padding;
      }

      var ky = (0,d3_array__WEBPACK_IMPORTED_MODULE_0__/* .min */ .jk)(columns, function (nodes) {
        return (y1 - y0 - (nodes.length - 1) * py) / (0,d3_array__WEBPACK_IMPORTED_MODULE_0__/* .sum */ .cz)(nodes, value);
      });

      //calculate the widths of the links
      ky = ky * scale;

      graph.links.forEach(function (link) {
        link.width = link.value * ky;
      });

      //determine how much to scale down the chart, based on circular links
      var margin = getCircleMargins(graph);
      var ratio = scaleSankeySize(graph, margin);

      //re-calculate widths
      ky = ky * ratio;

      graph.links.forEach(function (link) {
        link.width = link.value * ky;
      });

      columns.forEach(function (nodes) {
        var nodesLength = nodes.length;
        nodes.forEach(function (node, i) {
          if (node.depth == columns.length - 1 && nodesLength == 1) {
            node.y0 = y1 / 2 - node.value * ky;
            node.y1 = node.y0 + node.value * ky;
          } else if (node.depth == 0 && nodesLength == 1) {
            node.y0 = y1 / 2 - node.value * ky;
            node.y1 = node.y0 + node.value * ky;
          } else if (node.partOfCycle) {
            if (numberOfNonSelfLinkingCycles(node, id) == 0) {
              node.y0 = y1 / 2 + i;
              node.y1 = node.y0 + node.value * ky;
            } else if (node.circularLinkType == 'top') {
              node.y0 = y0 + i;
              node.y1 = node.y0 + node.value * ky;
            } else {
              node.y0 = y1 - node.value * ky - i;
              node.y1 = node.y0 + node.value * ky;
            }
          } else {
            if (margin.top == 0 || margin.bottom == 0) {
              node.y0 = (y1 - y0) / nodesLength * i;
              node.y1 = node.y0 + node.value * ky;
            } else {
              node.y0 = (y1 - y0) / 2 - nodesLength / 2 + i;
              node.y1 = node.y0 + node.value * ky;
            }
          }
        });
      });
    }

    // For each node in each column, check the node's vertical position in relation to its targets and sources vertical position
    // and shift up/down to be closer to the vertical middle of those targets and sources
    function relaxLeftAndRight(alpha, id) {
      var columnsLength = columns.length;

      columns.forEach(function (nodes) {
        var n = nodes.length;
        var depth = nodes[0].depth;

        nodes.forEach(function (node) {
          // check the node is not an orphan
          var nodeHeight;
          if (node.sourceLinks.length || node.targetLinks.length) {
            if (node.partOfCycle && numberOfNonSelfLinkingCycles(node, id) > 0) ; else if (depth == 0 && n == 1) {
              nodeHeight = node.y1 - node.y0;

              node.y0 = y1 / 2 - nodeHeight / 2;
              node.y1 = y1 / 2 + nodeHeight / 2;
            } else if (depth == columnsLength - 1 && n == 1) {
              nodeHeight = node.y1 - node.y0;

              node.y0 = y1 / 2 - nodeHeight / 2;
              node.y1 = y1 / 2 + nodeHeight / 2;
            } else {
              var avg = 0;

              var avgTargetY = (0,d3_array__WEBPACK_IMPORTED_MODULE_0__/* .mean */ .i2)(node.sourceLinks, linkTargetCenter);
              var avgSourceY = (0,d3_array__WEBPACK_IMPORTED_MODULE_0__/* .mean */ .i2)(node.targetLinks, linkSourceCenter);

              if (avgTargetY && avgSourceY) {
                avg = (avgTargetY + avgSourceY) / 2;
              } else {
                avg = avgTargetY || avgSourceY;
              }

              var dy = (avg - nodeCenter(node)) * alpha;
              // positive if it node needs to move down
              node.y0 += dy;
              node.y1 += dy;
            }
          }
        });
      });
    }

    // For each column, check if nodes are overlapping, and if so, shift up/down
    function resolveCollisions() {
      columns.forEach(function (nodes) {
        var node,
            dy,
            y = y0,
            n = nodes.length,
            i;

        // Push any overlapping nodes down.
        nodes.sort(ascendingBreadth);

        for (i = 0; i < n; ++i) {
          node = nodes[i];
          dy = y - node.y0;

          if (dy > 0) {
            node.y0 += dy;
            node.y1 += dy;
          }
          y = node.y1 + py;
        }

        // If the bottommost node goes outside the bounds, push it back up.
        dy = y - py - y1;
        if (dy > 0) {
          y = node.y0 -= dy, node.y1 -= dy;

          // Push any overlapping nodes back up.
          for (i = n - 2; i >= 0; --i) {
            node = nodes[i];
            dy = node.y1 + py - y;
            if (dy > 0) node.y0 -= dy, node.y1 -= dy;
            y = node.y0;
          }
        }
      });
    }
  }

  // Assign the links y0 and y1 based on source/target nodes position,
  // plus the link's relative position to other links to the same node
  function computeLinkBreadths(graph) {
    graph.nodes.forEach(function (node) {
      node.sourceLinks.sort(ascendingTargetBreadth);
      node.targetLinks.sort(ascendingSourceBreadth);
    });
    graph.nodes.forEach(function (node) {
      var y0 = node.y0;
      var y1 = y0;

      // start from the bottom of the node for cycle links
      var y0cycle = node.y1;
      var y1cycle = y0cycle;

      node.sourceLinks.forEach(function (link) {
        if (link.circular) {
          link.y0 = y0cycle - link.width / 2;
          y0cycle = y0cycle - link.width;
        } else {
          link.y0 = y0 + link.width / 2;
          y0 += link.width;
        }
      });
      node.targetLinks.forEach(function (link) {
        if (link.circular) {
          link.y1 = y1cycle - link.width / 2;
          y1cycle = y1cycle - link.width;
        } else {
          link.y1 = y1 + link.width / 2;
          y1 += link.width;
        }
      });
    });
  }

  return sankeyCircular;
}

/// /////////////////////////////////////////////////////////////////////////////////
// Cycle functions
// portion of code to detect circular links based on Colin Fergus' bl.ock https://gist.github.com/cfergus/3956043

// Identify circles in the link objects
function identifyCircles(graph, id, sortNodes) {
  var circularLinkID = 0;
  if (sortNodes === null) {

    // Building adjacency graph
    var adjList = [];
    for (var i = 0; i < graph.links.length; i++) {
      var link = graph.links[i];
      var source = link.source.index;
      var target = link.target.index;
      if (!adjList[source]) adjList[source] = [];
      if (!adjList[target]) adjList[target] = [];

      // Add links if not already in set
      if (adjList[source].indexOf(target) === -1) adjList[source].push(target);
    }

    // Find all elementary circuits
    var cycles = elementary_circuits_directed_graph__WEBPACK_IMPORTED_MODULE_2___default()(adjList);

    // Sort by circuits length
    cycles.sort(function (a, b) {
      return a.length - b.length;
    });

    var circularLinks = {};
    for (i = 0; i < cycles.length; i++) {
      var cycle = cycles[i];
      var last = cycle.slice(-2);
      if (!circularLinks[last[0]]) circularLinks[last[0]] = {};
      circularLinks[last[0]][last[1]] = true;
    }

    graph.links.forEach(function (link) {
      var target = link.target.index;
      var source = link.source.index;
      // If self-linking or a back-edge
      if (target === source || circularLinks[source] && circularLinks[source][target]) {
        link.circular = true;
        link.circularLinkID = circularLinkID;
        circularLinkID = circularLinkID + 1;
      } else {
        link.circular = false;
      }
    });
  } else {
    graph.links.forEach(function (link) {
      if (link.source[sortNodes] < link.target[sortNodes]) {
        link.circular = false;
      } else {
        link.circular = true;
        link.circularLinkID = circularLinkID;
        circularLinkID = circularLinkID + 1;
      }
    });
  }
}

// Assign a circular link type (top or bottom), based on:
// - if the source/target node already has circular links, then use the same type
// - if not, choose the type with fewer links
function selectCircularLinkTypes(graph, id) {
  var numberOfTops = 0;
  var numberOfBottoms = 0;
  graph.links.forEach(function (link) {
    if (link.circular) {
      // if either souce or target has type already use that
      if (link.source.circularLinkType || link.target.circularLinkType) {
        // default to source type if available
        link.circularLinkType = link.source.circularLinkType ? link.source.circularLinkType : link.target.circularLinkType;
      } else {
        link.circularLinkType = numberOfTops < numberOfBottoms ? 'top' : 'bottom';
      }

      if (link.circularLinkType == 'top') {
        numberOfTops = numberOfTops + 1;
      } else {
        numberOfBottoms = numberOfBottoms + 1;
      }

      graph.nodes.forEach(function (node) {
        if (getNodeID(node, id) == getNodeID(link.source, id) || getNodeID(node, id) == getNodeID(link.target, id)) {
          node.circularLinkType = link.circularLinkType;
        }
      });
    }
  });

  //correct self-linking links to be same direction as node
  graph.links.forEach(function (link) {
    if (link.circular) {
      //if both source and target node are same type, then link should have same type
      if (link.source.circularLinkType == link.target.circularLinkType) {
        link.circularLinkType = link.source.circularLinkType;
      }
      //if link is selflinking, then link should have same type as node
      if (selfLinking(link, id)) {
        link.circularLinkType = link.source.circularLinkType;
      }
    }
  });
}

// Return the angle between a straight line between the source and target of the link, and the vertical plane of the node
function linkAngle(link) {
  var adjacent = Math.abs(link.y1 - link.y0);
  var opposite = Math.abs(link.target.x0 - link.source.x1);

  return Math.atan(opposite / adjacent);
}

// Check if two circular links potentially overlap
function circularLinksCross(link1, link2) {
  if (link1.source.column < link2.target.column) {
    return false;
  } else if (link1.target.column > link2.source.column) {
    return false;
  } else {
    return true;
  }
}

// Return the number of circular links for node, not including self linking links
function numberOfNonSelfLinkingCycles(node, id) {
  var sourceCount = 0;
  node.sourceLinks.forEach(function (l) {
    sourceCount = l.circular && !selfLinking(l, id) ? sourceCount + 1 : sourceCount;
  });

  var targetCount = 0;
  node.targetLinks.forEach(function (l) {
    targetCount = l.circular && !selfLinking(l, id) ? targetCount + 1 : targetCount;
  });

  return sourceCount + targetCount;
}

// Check if a circular link is the only circular link for both its source and target node
function onlyCircularLink(link) {
  var nodeSourceLinks = link.source.sourceLinks;
  var sourceCount = 0;
  nodeSourceLinks.forEach(function (l) {
    sourceCount = l.circular ? sourceCount + 1 : sourceCount;
  });

  var nodeTargetLinks = link.target.targetLinks;
  var targetCount = 0;
  nodeTargetLinks.forEach(function (l) {
    targetCount = l.circular ? targetCount + 1 : targetCount;
  });

  if (sourceCount > 1 || targetCount > 1) {
    return false;
  } else {
    return true;
  }
}

// creates vertical buffer values per set of top/bottom links
function calcVerticalBuffer(links, circularLinkGap, id) {
  links.sort(sortLinkColumnAscending);
  links.forEach(function (link, i) {
    var buffer = 0;

    if (selfLinking(link, id) && onlyCircularLink(link)) {
      link.circularPathData.verticalBuffer = buffer + link.width / 2;
    } else {
      var j = 0;
      for (j; j < i; j++) {
        if (circularLinksCross(links[i], links[j])) {
          var bufferOverThisLink = links[j].circularPathData.verticalBuffer + links[j].width / 2 + circularLinkGap;
          buffer = bufferOverThisLink > buffer ? bufferOverThisLink : buffer;
        }
      }

      link.circularPathData.verticalBuffer = buffer + link.width / 2;
    }
  });

  return links;
}

// calculate the optimum path for a link to reduce overlaps
function addCircularPathData(graph, circularLinkGap, y1, id) {
  //var baseRadius = 10
  var buffer = 5;
  //var verticalMargin = 25

  var minY = (0,d3_array__WEBPACK_IMPORTED_MODULE_0__/* .min */ .jk)(graph.links, function (link) {
    return link.source.y0;
  });

  // create object for circular Path Data
  graph.links.forEach(function (link) {
    if (link.circular) {
      link.circularPathData = {};
    }
  });

  // calc vertical offsets per top/bottom links
  var topLinks = graph.links.filter(function (l) {
    return l.circularLinkType == 'top';
  });
  /* topLinks = */calcVerticalBuffer(topLinks, circularLinkGap, id);

  var bottomLinks = graph.links.filter(function (l) {
    return l.circularLinkType == 'bottom';
  });
  /* bottomLinks = */calcVerticalBuffer(bottomLinks, circularLinkGap, id);

  // add the base data for each link
  graph.links.forEach(function (link) {
    if (link.circular) {
      link.circularPathData.arcRadius = link.width + baseRadius;
      link.circularPathData.leftNodeBuffer = buffer;
      link.circularPathData.rightNodeBuffer = buffer;
      link.circularPathData.sourceWidth = link.source.x1 - link.source.x0;
      link.circularPathData.sourceX = link.source.x0 + link.circularPathData.sourceWidth;
      link.circularPathData.targetX = link.target.x0;
      link.circularPathData.sourceY = link.y0;
      link.circularPathData.targetY = link.y1;

      // for self linking paths, and that the only circular link in/out of that node
      if (selfLinking(link, id) && onlyCircularLink(link)) {
        link.circularPathData.leftSmallArcRadius = baseRadius + link.width / 2;
        link.circularPathData.leftLargeArcRadius = baseRadius + link.width / 2;
        link.circularPathData.rightSmallArcRadius = baseRadius + link.width / 2;
        link.circularPathData.rightLargeArcRadius = baseRadius + link.width / 2;

        if (link.circularLinkType == 'bottom') {
          link.circularPathData.verticalFullExtent = link.source.y1 + verticalMargin + link.circularPathData.verticalBuffer;
          link.circularPathData.verticalLeftInnerExtent = link.circularPathData.verticalFullExtent - link.circularPathData.leftLargeArcRadius;
          link.circularPathData.verticalRightInnerExtent = link.circularPathData.verticalFullExtent - link.circularPathData.rightLargeArcRadius;
        } else {
          // top links
          link.circularPathData.verticalFullExtent = link.source.y0 - verticalMargin - link.circularPathData.verticalBuffer;
          link.circularPathData.verticalLeftInnerExtent = link.circularPathData.verticalFullExtent + link.circularPathData.leftLargeArcRadius;
          link.circularPathData.verticalRightInnerExtent = link.circularPathData.verticalFullExtent + link.circularPathData.rightLargeArcRadius;
        }
      } else {
        // else calculate normally
        // add left extent coordinates, based on links with same source column and circularLink type
        var thisColumn = link.source.column;
        var thisCircularLinkType = link.circularLinkType;
        var sameColumnLinks = graph.links.filter(function (l) {
          return l.source.column == thisColumn && l.circularLinkType == thisCircularLinkType;
        });

        if (link.circularLinkType == 'bottom') {
          sameColumnLinks.sort(sortLinkSourceYDescending);
        } else {
          sameColumnLinks.sort(sortLinkSourceYAscending);
        }

        var radiusOffset = 0;
        sameColumnLinks.forEach(function (l, i) {
          if (l.circularLinkID == link.circularLinkID) {
            link.circularPathData.leftSmallArcRadius = baseRadius + link.width / 2 + radiusOffset;
            link.circularPathData.leftLargeArcRadius = baseRadius + link.width / 2 + i * circularLinkGap + radiusOffset;
          }
          radiusOffset = radiusOffset + l.width;
        });

        // add right extent coordinates, based on links with same target column and circularLink type
        thisColumn = link.target.column;
        sameColumnLinks = graph.links.filter(function (l) {
          return l.target.column == thisColumn && l.circularLinkType == thisCircularLinkType;
        });
        if (link.circularLinkType == 'bottom') {
          sameColumnLinks.sort(sortLinkTargetYDescending);
        } else {
          sameColumnLinks.sort(sortLinkTargetYAscending);
        }

        radiusOffset = 0;
        sameColumnLinks.forEach(function (l, i) {
          if (l.circularLinkID == link.circularLinkID) {
            link.circularPathData.rightSmallArcRadius = baseRadius + link.width / 2 + radiusOffset;
            link.circularPathData.rightLargeArcRadius = baseRadius + link.width / 2 + i * circularLinkGap + radiusOffset;
          }
          radiusOffset = radiusOffset + l.width;
        });

        // bottom links
        if (link.circularLinkType == 'bottom') {
          link.circularPathData.verticalFullExtent = Math.max(y1, link.source.y1, link.target.y1) + verticalMargin + link.circularPathData.verticalBuffer;
          link.circularPathData.verticalLeftInnerExtent = link.circularPathData.verticalFullExtent - link.circularPathData.leftLargeArcRadius;
          link.circularPathData.verticalRightInnerExtent = link.circularPathData.verticalFullExtent - link.circularPathData.rightLargeArcRadius;
        } else {
          // top links
          link.circularPathData.verticalFullExtent = minY - verticalMargin - link.circularPathData.verticalBuffer;
          link.circularPathData.verticalLeftInnerExtent = link.circularPathData.verticalFullExtent + link.circularPathData.leftLargeArcRadius;
          link.circularPathData.verticalRightInnerExtent = link.circularPathData.verticalFullExtent + link.circularPathData.rightLargeArcRadius;
        }
      }

      // all links
      link.circularPathData.leftInnerExtent = link.circularPathData.sourceX + link.circularPathData.leftNodeBuffer;
      link.circularPathData.rightInnerExtent = link.circularPathData.targetX - link.circularPathData.rightNodeBuffer;
      link.circularPathData.leftFullExtent = link.circularPathData.sourceX + link.circularPathData.leftLargeArcRadius + link.circularPathData.leftNodeBuffer;
      link.circularPathData.rightFullExtent = link.circularPathData.targetX - link.circularPathData.rightLargeArcRadius - link.circularPathData.rightNodeBuffer;
    }

    if (link.circular) {
      link.path = createCircularPathString(link);
    } else {
      var normalPath = (0,d3_shape__WEBPACK_IMPORTED_MODULE_3__/* .linkHorizontal */ .pq)().source(function (d) {
        var x = d.source.x0 + (d.source.x1 - d.source.x0);
        var y = d.y0;
        return [x, y];
      }).target(function (d) {
        var x = d.target.x0;
        var y = d.y1;
        return [x, y];
      });
      link.path = normalPath(link);
    }
  });
}

// create a d path using the addCircularPathData
function createCircularPathString(link) {
  var pathString = '';
  // 'pathData' is assigned a value but never used
  // var pathData = {}

  if (link.circularLinkType == 'top') {
    pathString =
    // start at the right of the source node
    'M' + link.circularPathData.sourceX + ' ' + link.circularPathData.sourceY + ' ' +
    // line right to buffer point
    'L' + link.circularPathData.leftInnerExtent + ' ' + link.circularPathData.sourceY + ' ' +
    // Arc around: Centre of arc X and  //Centre of arc Y
    'A' + link.circularPathData.leftLargeArcRadius + ' ' + link.circularPathData.leftSmallArcRadius + ' 0 0 0 ' +
    // End of arc X //End of arc Y
    link.circularPathData.leftFullExtent + ' ' + (link.circularPathData.sourceY - link.circularPathData.leftSmallArcRadius) + ' ' + // End of arc X
    // line up to buffer point
    'L' + link.circularPathData.leftFullExtent + ' ' + link.circularPathData.verticalLeftInnerExtent + ' ' +
    // Arc around: Centre of arc X and  //Centre of arc Y
    'A' + link.circularPathData.leftLargeArcRadius + ' ' + link.circularPathData.leftLargeArcRadius + ' 0 0 0 ' +
    // End of arc X //End of arc Y
    link.circularPathData.leftInnerExtent + ' ' + link.circularPathData.verticalFullExtent + ' ' + // End of arc X
    // line left to buffer point
    'L' + link.circularPathData.rightInnerExtent + ' ' + link.circularPathData.verticalFullExtent + ' ' +
    // Arc around: Centre of arc X and  //Centre of arc Y
    'A' + link.circularPathData.rightLargeArcRadius + ' ' + link.circularPathData.rightLargeArcRadius + ' 0 0 0 ' +
    // End of arc X //End of arc Y
    link.circularPathData.rightFullExtent + ' ' + link.circularPathData.verticalRightInnerExtent + ' ' + // End of arc X
    // line down
    'L' + link.circularPathData.rightFullExtent + ' ' + (link.circularPathData.targetY - link.circularPathData.rightSmallArcRadius) + ' ' +
    // Arc around: Centre of arc X and  //Centre of arc Y
    'A' + link.circularPathData.rightLargeArcRadius + ' ' + link.circularPathData.rightSmallArcRadius + ' 0 0 0 ' +
    // End of arc X //End of arc Y
    link.circularPathData.rightInnerExtent + ' ' + link.circularPathData.targetY + ' ' + // End of arc X
    // line to end
    'L' + link.circularPathData.targetX + ' ' + link.circularPathData.targetY;
  } else {
    // bottom path
    pathString =
    // start at the right of the source node
    'M' + link.circularPathData.sourceX + ' ' + link.circularPathData.sourceY + ' ' +
    // line right to buffer point
    'L' + link.circularPathData.leftInnerExtent + ' ' + link.circularPathData.sourceY + ' ' +
    // Arc around: Centre of arc X and  //Centre of arc Y
    'A' + link.circularPathData.leftLargeArcRadius + ' ' + link.circularPathData.leftSmallArcRadius + ' 0 0 1 ' +
    // End of arc X //End of arc Y
    link.circularPathData.leftFullExtent + ' ' + (link.circularPathData.sourceY + link.circularPathData.leftSmallArcRadius) + ' ' + // End of arc X
    // line down to buffer point
    'L' + link.circularPathData.leftFullExtent + ' ' + link.circularPathData.verticalLeftInnerExtent + ' ' +
    // Arc around: Centre of arc X and  //Centre of arc Y
    'A' + link.circularPathData.leftLargeArcRadius + ' ' + link.circularPathData.leftLargeArcRadius + ' 0 0 1 ' +
    // End of arc X //End of arc Y
    link.circularPathData.leftInnerExtent + ' ' + link.circularPathData.verticalFullExtent + ' ' + // End of arc X
    // line left to buffer point
    'L' + link.circularPathData.rightInnerExtent + ' ' + link.circularPathData.verticalFullExtent + ' ' +
    // Arc around: Centre of arc X and  //Centre of arc Y
    'A' + link.circularPathData.rightLargeArcRadius + ' ' + link.circularPathData.rightLargeArcRadius + ' 0 0 1 ' +
    // End of arc X //End of arc Y
    link.circularPathData.rightFullExtent + ' ' + link.circularPathData.verticalRightInnerExtent + ' ' + // End of arc X
    // line up
    'L' + link.circularPathData.rightFullExtent + ' ' + (link.circularPathData.targetY + link.circularPathData.rightSmallArcRadius) + ' ' +
    // Arc around: Centre of arc X and  //Centre of arc Y
    'A' + link.circularPathData.rightLargeArcRadius + ' ' + link.circularPathData.rightSmallArcRadius + ' 0 0 1 ' +
    // End of arc X //End of arc Y
    link.circularPathData.rightInnerExtent + ' ' + link.circularPathData.targetY + ' ' + // End of arc X
    // line to end
    'L' + link.circularPathData.targetX + ' ' + link.circularPathData.targetY;
  }

  return pathString;
}

// sort links based on the distance between the source and tartget node columns
// if the same, then use Y position of the source node
function sortLinkColumnAscending(link1, link2) {
  if (linkColumnDistance(link1) == linkColumnDistance(link2)) {
    return link1.circularLinkType == 'bottom' ? sortLinkSourceYDescending(link1, link2) : sortLinkSourceYAscending(link1, link2);
  } else {
    return linkColumnDistance(link2) - linkColumnDistance(link1);
  }
}

// sort ascending links by their source vertical position, y0
function sortLinkSourceYAscending(link1, link2) {
  return link1.y0 - link2.y0;
}

// sort descending links by their source vertical position, y0
function sortLinkSourceYDescending(link1, link2) {
  return link2.y0 - link1.y0;
}

// sort ascending links by their target vertical position, y1
function sortLinkTargetYAscending(link1, link2) {
  return link1.y1 - link2.y1;
}

// sort descending links by their target vertical position, y1
function sortLinkTargetYDescending(link1, link2) {
  return link2.y1 - link1.y1;
}

// return the distance between the link's target and source node, in terms of the nodes' column
function linkColumnDistance(link) {
  return link.target.column - link.source.column;
}

// return the distance between the link's target and source node, in terms of the nodes' X coordinate
function linkXLength(link) {
  return link.target.x0 - link.source.x1;
}

// Return the Y coordinate on the longerLink path * which is perpendicular shorterLink's source.
// * approx, based on a straight line from target to source, when in fact the path is a bezier
function linkPerpendicularYToLinkSource(longerLink, shorterLink) {
  // get the angle for the longer link
  var angle = linkAngle(longerLink);

  // get the adjacent length to the other link's x position
  var heightFromY1ToPependicular = linkXLength(shorterLink) / Math.tan(angle);

  // add or subtract from longer link1's original y1, depending on the slope
  var yPerpendicular = incline(longerLink) == 'up' ? longerLink.y1 + heightFromY1ToPependicular : longerLink.y1 - heightFromY1ToPependicular;

  return yPerpendicular;
}

// Return the Y coordinate on the longerLink path * which is perpendicular shorterLink's source.
// * approx, based on a straight line from target to source, when in fact the path is a bezier
function linkPerpendicularYToLinkTarget(longerLink, shorterLink) {
  // get the angle for the longer link
  var angle = linkAngle(longerLink);

  // get the adjacent length to the other link's x position
  var heightFromY1ToPependicular = linkXLength(shorterLink) / Math.tan(angle);

  // add or subtract from longer link's original y1, depending on the slope
  var yPerpendicular = incline(longerLink) == 'up' ? longerLink.y1 - heightFromY1ToPependicular : longerLink.y1 + heightFromY1ToPependicular;

  return yPerpendicular;
}

// Move any nodes that overlap links which span 2+ columns
function resolveNodeLinkOverlaps(graph, y0, y1, id) {

  graph.links.forEach(function (link) {
    if (link.circular) {
      return;
    }

    if (link.target.column - link.source.column > 1) {
      var columnToTest = link.source.column + 1;
      var maxColumnToTest = link.target.column - 1;

      var i = 1;
      var numberOfColumnsToTest = maxColumnToTest - columnToTest + 1;

      for (i = 1; columnToTest <= maxColumnToTest; columnToTest++, i++) {
        graph.nodes.forEach(function (node) {
          if (node.column == columnToTest) {
            var t = i / (numberOfColumnsToTest + 1);

            // Find all the points of a cubic bezier curve in javascript
            // https://stackoverflow.com/questions/15397596/find-all-the-points-of-a-cubic-bezier-curve-in-javascript

            var B0_t = Math.pow(1 - t, 3);
            var B1_t = 3 * t * Math.pow(1 - t, 2);
            var B2_t = 3 * Math.pow(t, 2) * (1 - t);
            var B3_t = Math.pow(t, 3);

            var py_t = B0_t * link.y0 + B1_t * link.y0 + B2_t * link.y1 + B3_t * link.y1;

            var linkY0AtColumn = py_t - link.width / 2;
            var linkY1AtColumn = py_t + link.width / 2;
            var dy;

            // If top of link overlaps node, push node up
            if (linkY0AtColumn > node.y0 && linkY0AtColumn < node.y1) {

              dy = node.y1 - linkY0AtColumn + 10;
              dy = node.circularLinkType == 'bottom' ? dy : -dy;

              node = adjustNodeHeight(node, dy, y0, y1);

              // check if other nodes need to move up too
              graph.nodes.forEach(function (otherNode) {
                // don't need to check itself or nodes at different columns
                if (getNodeID(otherNode, id) == getNodeID(node, id) || otherNode.column != node.column) {
                  return;
                }
                if (nodesOverlap(node, otherNode)) {
                  adjustNodeHeight(otherNode, dy, y0, y1);
                }
              });
            } else if (linkY1AtColumn > node.y0 && linkY1AtColumn < node.y1) {
              // If bottom of link overlaps node, push node down
              dy = linkY1AtColumn - node.y0 + 10;

              node = adjustNodeHeight(node, dy, y0, y1);

              // check if other nodes need to move down too
              graph.nodes.forEach(function (otherNode) {
                // don't need to check itself or nodes at different columns
                if (getNodeID(otherNode, id) == getNodeID(node, id) || otherNode.column != node.column) {
                  return;
                }
                if (otherNode.y0 < node.y1 && otherNode.y1 > node.y1) {
                  adjustNodeHeight(otherNode, dy, y0, y1);
                }
              });
            } else if (linkY0AtColumn < node.y0 && linkY1AtColumn > node.y1) {
              // if link completely overlaps node
              dy = linkY1AtColumn - node.y0 + 10;

              node = adjustNodeHeight(node, dy, y0, y1);

              graph.nodes.forEach(function (otherNode) {
                // don't need to check itself or nodes at different columns
                if (getNodeID(otherNode, id) == getNodeID(node, id) || otherNode.column != node.column) {
                  return;
                }
                if (otherNode.y0 < node.y1 && otherNode.y1 > node.y1) {
                  adjustNodeHeight(otherNode, dy, y0, y1);
                }
              });
            }
          }
        });
      }
    }
  });
}

// check if two nodes overlap
function nodesOverlap(nodeA, nodeB) {
  // test if nodeA top partially overlaps nodeB
  if (nodeA.y0 > nodeB.y0 && nodeA.y0 < nodeB.y1) {
    return true;
  } else if (nodeA.y1 > nodeB.y0 && nodeA.y1 < nodeB.y1) {
    // test if nodeA bottom partially overlaps nodeB
    return true;
  } else if (nodeA.y0 < nodeB.y0 && nodeA.y1 > nodeB.y1) {
    // test if nodeA covers nodeB
    return true;
  } else {
    return false;
  }
}

// update a node, and its associated links, vertical positions (y0, y1)
function adjustNodeHeight(node, dy, sankeyY0, sankeyY1) {
  if (node.y0 + dy >= sankeyY0 && node.y1 + dy <= sankeyY1) {
    node.y0 = node.y0 + dy;
    node.y1 = node.y1 + dy;

    node.targetLinks.forEach(function (l) {
      l.y1 = l.y1 + dy;
    });

    node.sourceLinks.forEach(function (l) {
      l.y0 = l.y0 + dy;
    });
  }
  return node;
}

// sort and set the links' y0 for each node
function sortSourceLinks(graph, y1, id, moveNodes) {
  graph.nodes.forEach(function (node) {
    // move any nodes up which are off the bottom
    if (moveNodes && node.y + (node.y1 - node.y0) > y1) {
      node.y = node.y - (node.y + (node.y1 - node.y0) - y1);
    }

    var nodesSourceLinks = graph.links.filter(function (l) {
      return getNodeID(l.source, id) == getNodeID(node, id);
    });

    var nodeSourceLinksLength = nodesSourceLinks.length;

    // if more than 1 link then sort
    if (nodeSourceLinksLength > 1) {
      nodesSourceLinks.sort(function (link1, link2) {
        // if both are not circular...
        if (!link1.circular && !link2.circular) {
          // if the target nodes are the same column, then sort by the link's target y
          if (link1.target.column == link2.target.column) {
            return link1.y1 - link2.y1;
          } else if (!sameInclines(link1, link2)) {
            // if the links slope in different directions, then sort by the link's target y
            return link1.y1 - link2.y1;

            // if the links slope in same directions, then sort by any overlap
          } else {
            if (link1.target.column > link2.target.column) {
              var link2Adj = linkPerpendicularYToLinkTarget(link2, link1);
              return link1.y1 - link2Adj;
            }
            if (link2.target.column > link1.target.column) {
              var link1Adj = linkPerpendicularYToLinkTarget(link1, link2);
              return link1Adj - link2.y1;
            }
          }
        }

        // if only one is circular, the move top links up, or bottom links down
        if (link1.circular && !link2.circular) {
          return link1.circularLinkType == 'top' ? -1 : 1;
        } else if (link2.circular && !link1.circular) {
          return link2.circularLinkType == 'top' ? 1 : -1;
        }

        // if both links are circular...
        if (link1.circular && link2.circular) {
          // ...and they both loop the same way (both top)
          if (link1.circularLinkType === link2.circularLinkType && link1.circularLinkType == 'top') {
            // ...and they both connect to a target with same column, then sort by the target's y
            if (link1.target.column === link2.target.column) {
              return link1.target.y1 - link2.target.y1;
            } else {
              // ...and they connect to different column targets, then sort by how far back they
              return link2.target.column - link1.target.column;
            }
          } else if (link1.circularLinkType === link2.circularLinkType && link1.circularLinkType == 'bottom') {
            // ...and they both loop the same way (both bottom)
            // ...and they both connect to a target with same column, then sort by the target's y
            if (link1.target.column === link2.target.column) {
              return link2.target.y1 - link1.target.y1;
            } else {
              // ...and they connect to different column targets, then sort by how far back they
              return link1.target.column - link2.target.column;
            }
          } else {
            // ...and they loop around different ways, the move top up and bottom down
            return link1.circularLinkType == 'top' ? -1 : 1;
          }
        }
      });
    }

    // update y0 for links
    var ySourceOffset = node.y0;

    nodesSourceLinks.forEach(function (link) {
      link.y0 = ySourceOffset + link.width / 2;
      ySourceOffset = ySourceOffset + link.width;
    });

    // correct any circular bottom links so they are at the bottom of the node
    nodesSourceLinks.forEach(function (link, i) {
      if (link.circularLinkType == 'bottom') {
        var j = i + 1;
        var offsetFromBottom = 0;
        // sum the widths of any links that are below this link
        for (j; j < nodeSourceLinksLength; j++) {
          offsetFromBottom = offsetFromBottom + nodesSourceLinks[j].width;
        }
        link.y0 = node.y1 - offsetFromBottom - link.width / 2;
      }
    });
  });
}

// sort and set the links' y1 for each node
function sortTargetLinks(graph, y1, id) {
  graph.nodes.forEach(function (node) {
    var nodesTargetLinks = graph.links.filter(function (l) {
      return getNodeID(l.target, id) == getNodeID(node, id);
    });

    var nodesTargetLinksLength = nodesTargetLinks.length;

    if (nodesTargetLinksLength > 1) {
      nodesTargetLinks.sort(function (link1, link2) {
        // if both are not circular, the base on the source y position
        if (!link1.circular && !link2.circular) {
          if (link1.source.column == link2.source.column) {
            return link1.y0 - link2.y0;
          } else if (!sameInclines(link1, link2)) {
            return link1.y0 - link2.y0;
          } else {
            // get the angle of the link to the further source node (ie the smaller column)
            if (link2.source.column < link1.source.column) {
              var link2Adj = linkPerpendicularYToLinkSource(link2, link1);

              return link1.y0 - link2Adj;
            }
            if (link1.source.column < link2.source.column) {
              var link1Adj = linkPerpendicularYToLinkSource(link1, link2);

              return link1Adj - link2.y0;
            }
          }
        }

        // if only one is circular, the move top links up, or bottom links down
        if (link1.circular && !link2.circular) {
          return link1.circularLinkType == 'top' ? -1 : 1;
        } else if (link2.circular && !link1.circular) {
          return link2.circularLinkType == 'top' ? 1 : -1;
        }

        // if both links are circular...
        if (link1.circular && link2.circular) {
          // ...and they both loop the same way (both top)
          if (link1.circularLinkType === link2.circularLinkType && link1.circularLinkType == 'top') {
            // ...and they both connect to a target with same column, then sort by the target's y
            if (link1.source.column === link2.source.column) {
              return link1.source.y1 - link2.source.y1;
            } else {
              // ...and they connect to different column targets, then sort by how far back they
              return link1.source.column - link2.source.column;
            }
          } else if (link1.circularLinkType === link2.circularLinkType && link1.circularLinkType == 'bottom') {
            // ...and they both loop the same way (both bottom)
            // ...and they both connect to a target with same column, then sort by the target's y
            if (link1.source.column === link2.source.column) {
              return link1.source.y1 - link2.source.y1;
            } else {
              // ...and they connect to different column targets, then sort by how far back they
              return link2.source.column - link1.source.column;
            }
          } else {
            // ...and they loop around different ways, the move top up and bottom down
            return link1.circularLinkType == 'top' ? -1 : 1;
          }
        }
      });
    }

    // update y1 for links
    var yTargetOffset = node.y0;

    nodesTargetLinks.forEach(function (link) {
      link.y1 = yTargetOffset + link.width / 2;
      yTargetOffset = yTargetOffset + link.width;
    });

    // correct any circular bottom links so they are at the bottom of the node
    nodesTargetLinks.forEach(function (link, i) {
      if (link.circularLinkType == 'bottom') {
        var j = i + 1;
        var offsetFromBottom = 0;
        // sum the widths of any links that are below this link
        for (j; j < nodesTargetLinksLength; j++) {
          offsetFromBottom = offsetFromBottom + nodesTargetLinks[j].width;
        }
        link.y1 = node.y1 - offsetFromBottom - link.width / 2;
      }
    });
  });
}

// test if links both slope up, or both slope down
function sameInclines(link1, link2) {
  return incline(link1) == incline(link2);
}

// returns the slope of a link, from source to target
// up => slopes up from source to target
// down => slopes down from source to target
function incline(link) {
  return link.y0 - link.y1 > 0 ? 'up' : 'down';
}

// check if link is self linking, ie links a node to the same node
function selfLinking(link, id) {
  return getNodeID(link.source, id) == getNodeID(link.target, id);
}

function fillHeight(graph, y0, y1) {

  var nodes = graph.nodes;
  var links = graph.links;

  var top = false;
  var bottom = false;

  links.forEach(function (link) {
    if (link.circularLinkType == "top") {
      top = true;
    } else if (link.circularLinkType == "bottom") {
      bottom = true;
    }
  });

  if (top == false || bottom == false) {
    var minY0 = (0,d3_array__WEBPACK_IMPORTED_MODULE_0__/* .min */ .jk)(nodes, function (node) {
      return node.y0;
    });
    var maxY1 = (0,d3_array__WEBPACK_IMPORTED_MODULE_0__/* .max */ .T9)(nodes, function (node) {
      return node.y1;
    });
    var currentHeight = maxY1 - minY0;
    var chartHeight = y1 - y0;
    var ratio = chartHeight / currentHeight;

    nodes.forEach(function (node) {
      var nodeHeight = (node.y1 - node.y0) * ratio;
      node.y0 = (node.y0 - minY0) * ratio;
      node.y1 = node.y0 + nodeHeight;
    });

    links.forEach(function (link) {
      link.y0 = (link.y0 - minY0) * ratio;
      link.y1 = (link.y1 - minY0) * ratio;
      link.width = link.width * ratio;
    });
  }
}




/***/ }),

/***/ 62369:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  sankey: function() { return /* reexport */ sankey; },
  sankeyCenter: function() { return /* reexport */ center; },
  sankeyJustify: function() { return /* reexport */ justify; },
  sankeyLeft: function() { return /* reexport */ left; },
  sankeyLinkHorizontal: function() { return /* reexport */ sankeyLinkHorizontal; },
  sankeyRight: function() { return /* reexport */ right; }
});

// EXTERNAL MODULE: ./node_modules/d3-array/src/index.js + 14 modules
var src = __webpack_require__(29725);
// EXTERNAL MODULE: ./node_modules/d3-collection/src/index.js + 3 modules
var d3_collection_src = __webpack_require__(4575);
;// CONCATENATED MODULE: ./node_modules/@plotly/d3-sankey/src/align.js


function targetDepth(d) {
  return d.target.depth;
}

function left(node) {
  return node.depth;
}

function right(node, n) {
  return n - 1 - node.height;
}

function justify(node, n) {
  return node.sourceLinks.length ? node.depth : n - 1;
}

function center(node) {
  return node.targetLinks.length ? node.depth
      : node.sourceLinks.length ? (0,src/* min */.jk)(node.sourceLinks, targetDepth) - 1
      : 0;
}

;// CONCATENATED MODULE: ./node_modules/@plotly/d3-sankey/src/constant.js
function constant(x) {
  return function() {
    return x;
  };
}

;// CONCATENATED MODULE: ./node_modules/@plotly/d3-sankey/src/sankey.js





function ascendingSourceBreadth(a, b) {
  return ascendingBreadth(a.source, b.source) || a.index - b.index;
}

function ascendingTargetBreadth(a, b) {
  return ascendingBreadth(a.target, b.target) || a.index - b.index;
}

function ascendingBreadth(a, b) {
  return a.y0 - b.y0;
}

function value(d) {
  return d.value;
}

function nodeCenter(node) {
  return (node.y0 + node.y1) / 2;
}

function weightedSource(link) {
  return nodeCenter(link.source) * link.value;
}

function weightedTarget(link) {
  return nodeCenter(link.target) * link.value;
}

function defaultId(d) {
  return d.index;
}

function defaultNodes(graph) {
  return graph.nodes;
}

function defaultLinks(graph) {
  return graph.links;
}

function find(nodeById, id) {
  var node = nodeById.get(id);
  if (!node) throw new Error("missing: " + id);
  return node;
}

/* harmony default export */ function sankey() {
  var x0 = 0, y0 = 0, x1 = 1, y1 = 1, // extent
      dx = 24, // nodeWidth
      py = 8, // nodePadding
      id = defaultId,
      align = justify,
      nodes = defaultNodes,
      links = defaultLinks,
      iterations = 32,
      maxPaddedSpace = 2 / 3; // Defined as a fraction of the total available space

  function sankey() {
    var graph = {nodes: nodes.apply(null, arguments), links: links.apply(null, arguments)};
    computeNodeLinks(graph);
    computeNodeValues(graph);
    computeNodeDepths(graph);
    computeNodeBreadths(graph, iterations);
    computeLinkBreadths(graph);
    return graph;
  }

  sankey.update = function(graph) {
    computeLinkBreadths(graph);
    return graph;
  };

  sankey.nodeId = function(_) {
    return arguments.length ? (id = typeof _ === "function" ? _ : constant(_), sankey) : id;
  };

  sankey.nodeAlign = function(_) {
    return arguments.length ? (align = typeof _ === "function" ? _ : constant(_), sankey) : align;
  };

  sankey.nodeWidth = function(_) {
    return arguments.length ? (dx = +_, sankey) : dx;
  };

  sankey.nodePadding = function(_) {
    return arguments.length ? (py = +_, sankey) : py;
  };

  sankey.nodes = function(_) {
    return arguments.length ? (nodes = typeof _ === "function" ? _ : constant(_), sankey) : nodes;
  };

  sankey.links = function(_) {
    return arguments.length ? (links = typeof _ === "function" ? _ : constant(_), sankey) : links;
  };

  sankey.size = function(_) {
    return arguments.length ? (x0 = y0 = 0, x1 = +_[0], y1 = +_[1], sankey) : [x1 - x0, y1 - y0];
  };

  sankey.extent = function(_) {
    return arguments.length ? (x0 = +_[0][0], x1 = +_[1][0], y0 = +_[0][1], y1 = +_[1][1], sankey) : [[x0, y0], [x1, y1]];
  };

  sankey.iterations = function(_) {
    return arguments.length ? (iterations = +_, sankey) : iterations;
  };

  // Populate the sourceLinks and targetLinks for each node.
  // Also, if the source and target are not objects, assume they are indices.
  function computeNodeLinks(graph) {
    graph.nodes.forEach(function(node, i) {
      node.index = i;
      node.sourceLinks = [];
      node.targetLinks = [];
    });

    var nodeById = (0,d3_collection_src/* map */.Tj)(graph.nodes, id);
    graph.links.forEach(function(link, i) {
      link.index = i;
      var source = link.source, target = link.target;
      if (typeof source !== "object") source = link.source = find(nodeById, source);
      if (typeof target !== "object") target = link.target = find(nodeById, target);
      source.sourceLinks.push(link);
      target.targetLinks.push(link);
    });
  }

  // Compute the value (size) of each node by summing the associated links.
  function computeNodeValues(graph) {
    graph.nodes.forEach(function(node) {
      node.value = Math.max(
        (0,src/* sum */.cz)(node.sourceLinks, value),
        (0,src/* sum */.cz)(node.targetLinks, value)
      );
    });
  }

  // Iteratively assign the depth (x-position) for each node.
  // Nodes are assigned the maximum depth of incoming neighbors plus one;
  // nodes with no incoming links are assigned depth zero, while
  // nodes with no outgoing links are assigned the maximum depth.
  function computeNodeDepths(graph) {
    var nodes, next, x;

    for (nodes = graph.nodes, next = [], x = 0; nodes.length; ++x, nodes = next, next = []) {
      nodes.forEach(function(node) {
        node.depth = x;
        node.sourceLinks.forEach(function(link) {
          if (next.indexOf(link.target) < 0) {
            next.push(link.target);
          }
        });
      });
    }

    for (nodes = graph.nodes, next = [], x = 0; nodes.length; ++x, nodes = next, next = []) {
      nodes.forEach(function(node) {
        node.height = x;
        node.targetLinks.forEach(function(link) {
          if (next.indexOf(link.source) < 0) {
            next.push(link.source);
          }
        });
      });
    }

    var kx = (x1 - x0 - dx) / (x - 1);
    graph.nodes.forEach(function(node) {
      node.x1 = (node.x0 = x0 + Math.max(0, Math.min(x - 1, Math.floor(align.call(null, node, x)))) * kx) + dx;
    });
  }

  function computeNodeBreadths(graph) {
    var columns = (0,d3_collection_src/* nest */.$I)()
        .key(function(d) { return d.x0; })
        .sortKeys(src/* ascending */.V_)
        .entries(graph.nodes)
        .map(function(d) { return d.values; });

    //
    initializeNodeBreadth();
    resolveCollisions();
    for (var alpha = 1, n = iterations; n > 0; --n) {
      relaxRightToLeft(alpha *= 0.99);
      resolveCollisions();
      relaxLeftToRight(alpha);
      resolveCollisions();
    }

    function initializeNodeBreadth() {
      var L = (0,src/* max */.T9)(columns, function(nodes) {
        return nodes.length;
      });
      var maxNodePadding = maxPaddedSpace * (y1 - y0) / (L - 1);
      if(py > maxNodePadding) py = maxNodePadding;
      var ky = (0,src/* min */.jk)(columns, function(nodes) {
        return (y1 - y0 - (nodes.length - 1) * py) / (0,src/* sum */.cz)(nodes, value);
      });

      columns.forEach(function(nodes) {
        nodes.forEach(function(node, i) {
          node.y1 = (node.y0 = i) + node.value * ky;
        });
      });

      graph.links.forEach(function(link) {
        link.width = link.value * ky;
      });
    }

    function relaxLeftToRight(alpha) {
      columns.forEach(function(nodes) {
        nodes.forEach(function(node) {
          if (node.targetLinks.length) {
            var dy = ((0,src/* sum */.cz)(node.targetLinks, weightedSource) / (0,src/* sum */.cz)(node.targetLinks, value) - nodeCenter(node)) * alpha;
            node.y0 += dy, node.y1 += dy;
          }
        });
      });
    }

    function relaxRightToLeft(alpha) {
      columns.slice().reverse().forEach(function(nodes) {
        nodes.forEach(function(node) {
          if (node.sourceLinks.length) {
            var dy = ((0,src/* sum */.cz)(node.sourceLinks, weightedTarget) / (0,src/* sum */.cz)(node.sourceLinks, value) - nodeCenter(node)) * alpha;
            node.y0 += dy, node.y1 += dy;
          }
        });
      });
    }

    function resolveCollisions() {
      columns.forEach(function(nodes) {
        var node,
            dy,
            y = y0,
            n = nodes.length,
            i;

        // Push any overlapping nodes down.
        nodes.sort(ascendingBreadth);
        for (i = 0; i < n; ++i) {
          node = nodes[i];
          dy = y - node.y0;
          if (dy > 0) node.y0 += dy, node.y1 += dy;
          y = node.y1 + py;
        }

        // If the bottommost node goes outside the bounds, push it back up.
        dy = y - py - y1;
        if (dy > 0) {
          y = (node.y0 -= dy), node.y1 -= dy;

          // Push any overlapping nodes back up.
          for (i = n - 2; i >= 0; --i) {
            node = nodes[i];
            dy = node.y1 + py - y;
            if (dy > 0) node.y0 -= dy, node.y1 -= dy;
            y = node.y0;
          }
        }
      });
    }
  }

  function computeLinkBreadths(graph) {
    graph.nodes.forEach(function(node) {
      node.sourceLinks.sort(ascendingTargetBreadth);
      node.targetLinks.sort(ascendingSourceBreadth);
    });
    graph.nodes.forEach(function(node) {
      var y0 = node.y0, y1 = y0;
      node.sourceLinks.forEach(function(link) {
        link.y0 = y0 + link.width / 2, y0 += link.width;
      });
      node.targetLinks.forEach(function(link) {
        link.y1 = y1 + link.width / 2, y1 += link.width;
      });
    });
  }

  return sankey;
}

// EXTERNAL MODULE: ./node_modules/d3-shape/src/link/index.js + 4 modules
var src_link = __webpack_require__(48544);
;// CONCATENATED MODULE: ./node_modules/@plotly/d3-sankey/src/sankeyLinkHorizontal.js


function horizontalSource(d) {
  return [d.source.x1, d.y0];
}

function horizontalTarget(d) {
  return [d.target.x0, d.y1];
}

/* harmony default export */ function sankeyLinkHorizontal() {
  return (0,src_link/* linkHorizontal */.pq)()
      .source(horizontalSource)
      .target(horizontalTarget);
}

;// CONCATENATED MODULE: ./node_modules/@plotly/d3-sankey/index.js





/***/ }),

/***/ 45568:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;!function() {
  var d3 = {
    version: "3.8.2"
  };
  var d3_arraySlice = [].slice, d3_array = function(list) {
    return d3_arraySlice.call(list);
  };
  var d3_document = self.document;
  function d3_documentElement(node) {
    return node && (node.ownerDocument || node.document || node).documentElement;
  }
  function d3_window(node) {
    return node && (node.ownerDocument && node.ownerDocument.defaultView || node.document && node || node.defaultView);
  }
  if (d3_document) {
    try {
      d3_array(d3_document.documentElement.childNodes)[0].nodeType;
    } catch (e) {
      d3_array = function(list) {
        var i = list.length, array = new Array(i);
        while (i--) array[i] = list[i];
        return array;
      };
    }
  }
  if (!Date.now) Date.now = function() {
    return +new Date();
  };
  if (d3_document) {
    try {
      d3_document.createElement("DIV").style.setProperty("opacity", 0, "");
    } catch (error) {
      var d3_element_prototype = this.Element.prototype, d3_element_setAttribute = d3_element_prototype.setAttribute, d3_element_setAttributeNS = d3_element_prototype.setAttributeNS, d3_style_prototype = this.CSSStyleDeclaration.prototype, d3_style_setProperty = d3_style_prototype.setProperty;
      d3_element_prototype.setAttribute = function(name, value) {
        d3_element_setAttribute.call(this, name, value + "");
      };
      d3_element_prototype.setAttributeNS = function(space, local, value) {
        d3_element_setAttributeNS.call(this, space, local, value + "");
      };
      d3_style_prototype.setProperty = function(name, value, priority) {
        d3_style_setProperty.call(this, name, value + "", priority);
      };
    }
  }
  d3.ascending = d3_ascending;
  function d3_ascending(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
  }
  d3.descending = function(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
  };
  d3.min = function(array, f) {
    var i = -1, n = array.length, a, b;
    if (arguments.length === 1) {
      while (++i < n) if ((b = array[i]) != null && b >= b) {
        a = b;
        break;
      }
      while (++i < n) if ((b = array[i]) != null && a > b) a = b;
    } else {
      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
        a = b;
        break;
      }
      while (++i < n) if ((b = f.call(array, array[i], i)) != null && a > b) a = b;
    }
    return a;
  };
  d3.max = function(array, f) {
    var i = -1, n = array.length, a, b;
    if (arguments.length === 1) {
      while (++i < n) if ((b = array[i]) != null && b >= b) {
        a = b;
        break;
      }
      while (++i < n) if ((b = array[i]) != null && b > a) a = b;
    } else {
      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
        a = b;
        break;
      }
      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b > a) a = b;
    }
    return a;
  };
  d3.extent = function(array, f) {
    var i = -1, n = array.length, a, b, c;
    if (arguments.length === 1) {
      while (++i < n) if ((b = array[i]) != null && b >= b) {
        a = c = b;
        break;
      }
      while (++i < n) if ((b = array[i]) != null) {
        if (a > b) a = b;
        if (c < b) c = b;
      }
    } else {
      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
        a = c = b;
        break;
      }
      while (++i < n) if ((b = f.call(array, array[i], i)) != null) {
        if (a > b) a = b;
        if (c < b) c = b;
      }
    }
    return [ a, c ];
  };
  function d3_number(x) {
    return x === null ? NaN : +x;
  }
  function d3_numeric(x) {
    return !isNaN(x);
  }
  d3.sum = function(array, f) {
    var s = 0, n = array.length, a, i = -1;
    if (arguments.length === 1) {
      while (++i < n) if (d3_numeric(a = +array[i])) s += a;
    } else {
      while (++i < n) if (d3_numeric(a = +f.call(array, array[i], i))) s += a;
    }
    return s;
  };
  d3.mean = function(array, f) {
    var s = 0, n = array.length, a, i = -1, j = n;
    if (arguments.length === 1) {
      while (++i < n) if (d3_numeric(a = d3_number(array[i]))) s += a; else --j;
    } else {
      while (++i < n) if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) s += a; else --j;
    }
    if (j) return s / j;
  };
  d3.quantile = function(values, p) {
    var H = (values.length - 1) * p + 1, h = Math.floor(H), v = +values[h - 1], e = H - h;
    return e ? v + e * (values[h] - v) : v;
  };
  d3.median = function(array, f) {
    var numbers = [], n = array.length, a, i = -1;
    if (arguments.length === 1) {
      while (++i < n) if (d3_numeric(a = d3_number(array[i]))) numbers.push(a);
    } else {
      while (++i < n) if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) numbers.push(a);
    }
    if (numbers.length) return d3.quantile(numbers.sort(d3_ascending), .5);
  };
  d3.variance = function(array, f) {
    var n = array.length, m = 0, a, d, s = 0, i = -1, j = 0;
    if (arguments.length === 1) {
      while (++i < n) {
        if (d3_numeric(a = d3_number(array[i]))) {
          d = a - m;
          m += d / ++j;
          s += d * (a - m);
        }
      }
    } else {
      while (++i < n) {
        if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) {
          d = a - m;
          m += d / ++j;
          s += d * (a - m);
        }
      }
    }
    if (j > 1) return s / (j - 1);
  };
  d3.deviation = function() {
    var v = d3.variance.apply(this, arguments);
    return v ? Math.sqrt(v) : v;
  };
  function d3_bisector(compare) {
    return {
      left: function(a, x, lo, hi) {
        if (arguments.length < 3) lo = 0;
        if (arguments.length < 4) hi = a.length;
        while (lo < hi) {
          var mid = lo + hi >>> 1;
          if (compare(a[mid], x) < 0) lo = mid + 1; else hi = mid;
        }
        return lo;
      },
      right: function(a, x, lo, hi) {
        if (arguments.length < 3) lo = 0;
        if (arguments.length < 4) hi = a.length;
        while (lo < hi) {
          var mid = lo + hi >>> 1;
          if (compare(a[mid], x) > 0) hi = mid; else lo = mid + 1;
        }
        return lo;
      }
    };
  }
  var d3_bisect = d3_bisector(d3_ascending);
  d3.bisectLeft = d3_bisect.left;
  d3.bisect = d3.bisectRight = d3_bisect.right;
  d3.bisector = function(f) {
    return d3_bisector(f.length === 1 ? function(d, x) {
      return d3_ascending(f(d), x);
    } : f);
  };
  d3.shuffle = function(array, i0, i1) {
    if ((m = arguments.length) < 3) {
      i1 = array.length;
      if (m < 2) i0 = 0;
    }
    var m = i1 - i0, t, i;
    while (m) {
      i = Math.random() * m-- | 0;
      t = array[m + i0], array[m + i0] = array[i + i0], array[i + i0] = t;
    }
    return array;
  };
  d3.permute = function(array, indexes) {
    var i = indexes.length, permutes = new Array(i);
    while (i--) permutes[i] = array[indexes[i]];
    return permutes;
  };
  d3.pairs = function(array) {
    var i = 0, n = array.length - 1, p0, p1 = array[0], pairs = new Array(n < 0 ? 0 : n);
    while (i < n) pairs[i] = [ p0 = p1, p1 = array[++i] ];
    return pairs;
  };
  d3.transpose = function(matrix) {
    if (!(n = matrix.length)) return [];
    for (var i = -1, m = d3.min(matrix, d3_transposeLength), transpose = new Array(m); ++i < m; ) {
      for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n; ) {
        row[j] = matrix[j][i];
      }
    }
    return transpose;
  };
  function d3_transposeLength(d) {
    return d.length;
  }
  d3.zip = function() {
    return d3.transpose(arguments);
  };
  d3.keys = function(map) {
    var keys = [];
    for (var key in map) keys.push(key);
    return keys;
  };
  d3.values = function(map) {
    var values = [];
    for (var key in map) values.push(map[key]);
    return values;
  };
  d3.entries = function(map) {
    var entries = [];
    for (var key in map) entries.push({
      key: key,
      value: map[key]
    });
    return entries;
  };
  d3.merge = function(arrays) {
    var n = arrays.length, m, i = -1, j = 0, merged, array;
    while (++i < n) j += arrays[i].length;
    merged = new Array(j);
    while (--n >= 0) {
      array = arrays[n];
      m = array.length;
      while (--m >= 0) {
        merged[--j] = array[m];
      }
    }
    return merged;
  };
  var abs = Math.abs;
  d3.range = function(start, stop, step) {
    if (arguments.length < 3) {
      step = 1;
      if (arguments.length < 2) {
        stop = start;
        start = 0;
      }
    }
    if ((stop - start) / step === Infinity) throw new Error("infinite range");
    var range = [], k = d3_range_integerScale(abs(step)), i = -1, j;
    start *= k, stop *= k, step *= k;
    if (step < 0) while ((j = start + step * ++i) > stop) range.push(j / k); else while ((j = start + step * ++i) < stop) range.push(j / k);
    return range;
  };
  function d3_range_integerScale(x) {
    var k = 1;
    while (x * k % 1) k *= 10;
    return k;
  }
  function d3_class(ctor, properties) {
    for (var key in properties) {
      Object.defineProperty(ctor.prototype, key, {
        value: properties[key],
        enumerable: false
      });
    }
  }
  d3.map = function(object, f) {
    var map = new d3_Map();
    if (object instanceof d3_Map) {
      object.forEach(function(key, value) {
        map.set(key, value);
      });
    } else if (Array.isArray(object)) {
      var i = -1, n = object.length, o;
      if (arguments.length === 1) while (++i < n) map.set(i, object[i]); else while (++i < n) map.set(f.call(object, o = object[i], i), o);
    } else {
      for (var key in object) map.set(key, object[key]);
    }
    return map;
  };
  function d3_Map() {
    this._ = Object.create(null);
  }
  var d3_map_proto = "__proto__", d3_map_zero = "\x00";
  d3_class(d3_Map, {
    has: d3_map_has,
    get: function(key) {
      return this._[d3_map_escape(key)];
    },
    set: function(key, value) {
      return this._[d3_map_escape(key)] = value;
    },
    remove: d3_map_remove,
    keys: d3_map_keys,
    values: function() {
      var values = [];
      for (var key in this._) values.push(this._[key]);
      return values;
    },
    entries: function() {
      var entries = [];
      for (var key in this._) entries.push({
        key: d3_map_unescape(key),
        value: this._[key]
      });
      return entries;
    },
    size: d3_map_size,
    empty: d3_map_empty,
    forEach: function(f) {
      for (var key in this._) f.call(this, d3_map_unescape(key), this._[key]);
    }
  });
  function d3_map_escape(key) {
    return (key += "") === d3_map_proto || key[0] === d3_map_zero ? d3_map_zero + key : key;
  }
  function d3_map_unescape(key) {
    return (key += "")[0] === d3_map_zero ? key.slice(1) : key;
  }
  function d3_map_has(key) {
    return d3_map_escape(key) in this._;
  }
  function d3_map_remove(key) {
    return (key = d3_map_escape(key)) in this._ && delete this._[key];
  }
  function d3_map_keys() {
    var keys = [];
    for (var key in this._) keys.push(d3_map_unescape(key));
    return keys;
  }
  function d3_map_size() {
    var size = 0;
    for (var key in this._) ++size;
    return size;
  }
  function d3_map_empty() {
    for (var key in this._) return false;
    return true;
  }
  d3.nest = function() {
    var nest = {}, keys = [], sortKeys = [], sortValues, rollup;
    function map(mapType, array, depth) {
      if (depth >= keys.length) return rollup ? rollup.call(nest, array) : sortValues ? array.sort(sortValues) : array;
      var i = -1, n = array.length, key = keys[depth++], keyValue, object, setter, valuesByKey = new d3_Map(), values;
      while (++i < n) {
        if (values = valuesByKey.get(keyValue = key(object = array[i]))) {
          values.push(object);
        } else {
          valuesByKey.set(keyValue, [ object ]);
        }
      }
      if (mapType) {
        object = mapType();
        setter = function(keyValue, values) {
          object.set(keyValue, map(mapType, values, depth));
        };
      } else {
        object = {};
        setter = function(keyValue, values) {
          object[keyValue] = map(mapType, values, depth);
        };
      }
      valuesByKey.forEach(setter);
      return object;
    }
    function entries(map, depth) {
      if (depth >= keys.length) return map;
      var array = [], sortKey = sortKeys[depth++];
      map.forEach(function(key, keyMap) {
        array.push({
          key: key,
          values: entries(keyMap, depth)
        });
      });
      return sortKey ? array.sort(function(a, b) {
        return sortKey(a.key, b.key);
      }) : array;
    }
    nest.map = function(array, mapType) {
      return map(mapType, array, 0);
    };
    nest.entries = function(array) {
      return entries(map(d3.map, array, 0), 0);
    };
    nest.key = function(d) {
      keys.push(d);
      return nest;
    };
    nest.sortKeys = function(order) {
      sortKeys[keys.length - 1] = order;
      return nest;
    };
    nest.sortValues = function(order) {
      sortValues = order;
      return nest;
    };
    nest.rollup = function(f) {
      rollup = f;
      return nest;
    };
    return nest;
  };
  d3.set = function(array) {
    var set = new d3_Set();
    if (array) for (var i = 0, n = array.length; i < n; ++i) set.add(array[i]);
    return set;
  };
  function d3_Set() {
    this._ = Object.create(null);
  }
  d3_class(d3_Set, {
    has: d3_map_has,
    add: function(key) {
      this._[d3_map_escape(key += "")] = true;
      return key;
    },
    remove: d3_map_remove,
    values: d3_map_keys,
    size: d3_map_size,
    empty: d3_map_empty,
    forEach: function(f) {
      for (var key in this._) f.call(this, d3_map_unescape(key));
    }
  });
  d3.behavior = {};
  function d3_identity(d) {
    return d;
  }
  d3.rebind = function(target, source) {
    var i = 1, n = arguments.length, method;
    while (++i < n) target[method = arguments[i]] = d3_rebind(target, source, source[method]);
    return target;
  };
  function d3_rebind(target, source, method) {
    return function() {
      var value = method.apply(source, arguments);
      return value === source ? target : value;
    };
  }
  function d3_vendorSymbol(object, name) {
    if (name in object) return name;
    name = name.charAt(0).toUpperCase() + name.slice(1);
    for (var i = 0, n = d3_vendorPrefixes.length; i < n; ++i) {
      var prefixName = d3_vendorPrefixes[i] + name;
      if (prefixName in object) return prefixName;
    }
  }
  var d3_vendorPrefixes = [ "webkit", "ms", "moz", "Moz", "o", "O" ];
  function d3_noop() {}
  d3.dispatch = function() {
    var dispatch = new d3_dispatch(), i = -1, n = arguments.length;
    while (++i < n) dispatch[arguments[i]] = d3_dispatch_event(dispatch);
    return dispatch;
  };
  function d3_dispatch() {}
  d3_dispatch.prototype.on = function(type, listener) {
    var i = type.indexOf("."), name = "";
    if (i >= 0) {
      name = type.slice(i + 1);
      type = type.slice(0, i);
    }
    if (type) return arguments.length < 2 ? this[type].on(name) : this[type].on(name, listener);
    if (arguments.length === 2) {
      if (listener == null) for (type in this) {
        if (this.hasOwnProperty(type)) this[type].on(name, null);
      }
      return this;
    }
  };
  function d3_dispatch_event(dispatch) {
    var listeners = [], listenerByName = new d3_Map();
    function event() {
      var z = listeners, i = -1, n = z.length, l;
      while (++i < n) if (l = z[i].on) l.apply(this, arguments);
      return dispatch;
    }
    event.on = function(name, listener) {
      var l = listenerByName.get(name), i;
      if (arguments.length < 2) return l && l.on;
      if (l) {
        l.on = null;
        listeners = listeners.slice(0, i = listeners.indexOf(l)).concat(listeners.slice(i + 1));
        listenerByName.remove(name);
      }
      if (listener) listeners.push(listenerByName.set(name, {
        on: listener
      }));
      return dispatch;
    };
    return event;
  }
  d3.event = null;
  function d3_eventPreventDefault() {
    d3.event.preventDefault();
  }
  function d3_eventSource() {
    var e = d3.event, s;
    while (s = e.sourceEvent) e = s;
    return e;
  }
  function d3_eventDispatch(target) {
    var dispatch = new d3_dispatch(), i = 0, n = arguments.length;
    while (++i < n) dispatch[arguments[i]] = d3_dispatch_event(dispatch);
    dispatch.of = function(thiz, argumentz) {
      return function(e1) {
        try {
          var e0 = e1.sourceEvent = d3.event;
          e1.target = target;
          d3.event = e1;
          dispatch[e1.type].apply(thiz, argumentz);
        } finally {
          d3.event = e0;
        }
      };
    };
    return dispatch;
  }
  d3.requote = function(s) {
    return s.replace(d3_requote_re, "\\$&");
  };
  var d3_requote_re = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;
  var d3_subclass = {}.__proto__ ? function(object, prototype) {
    object.__proto__ = prototype;
  } : function(object, prototype) {
    for (var property in prototype) object[property] = prototype[property];
  };
  function d3_selection(groups) {
    d3_subclass(groups, d3_selectionPrototype);
    return groups;
  }
  var d3_select = function(s, n) {
    return n.querySelector(s);
  }, d3_selectAll = function(s, n) {
    return n.querySelectorAll(s);
  }, d3_selectMatches = function(n, s) {
    var d3_selectMatcher = n.matches || n[d3_vendorSymbol(n, "matchesSelector")];
    d3_selectMatches = function(n, s) {
      return d3_selectMatcher.call(n, s);
    };
    return d3_selectMatches(n, s);
  };
  if (typeof Sizzle === "function") {
    d3_select = function(s, n) {
      return Sizzle(s, n)[0] || null;
    };
    d3_selectAll = Sizzle;
    d3_selectMatches = Sizzle.matchesSelector;
  }
  d3.selection = function() {
    return d3.select(d3_document.documentElement);
  };
  var d3_selectionPrototype = d3.selection.prototype = [];
  d3_selectionPrototype.select = function(selector) {
    var subgroups = [], subgroup, subnode, group, node;
    selector = d3_selection_selector(selector);
    for (var j = -1, m = this.length; ++j < m; ) {
      subgroups.push(subgroup = []);
      subgroup.parentNode = (group = this[j]).parentNode;
      for (var i = -1, n = group.length; ++i < n; ) {
        if (node = group[i]) {
          subgroup.push(subnode = selector.call(node, node.__data__, i, j));
          if (subnode && "__data__" in node) subnode.__data__ = node.__data__;
        } else {
          subgroup.push(null);
        }
      }
    }
    return d3_selection(subgroups);
  };
  function d3_selection_selector(selector) {
    return typeof selector === "function" ? selector : function() {
      return d3_select(selector, this);
    };
  }
  d3_selectionPrototype.selectAll = function(selector) {
    var subgroups = [], subgroup, node;
    selector = d3_selection_selectorAll(selector);
    for (var j = -1, m = this.length; ++j < m; ) {
      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
        if (node = group[i]) {
          subgroups.push(subgroup = d3_array(selector.call(node, node.__data__, i, j)));
          subgroup.parentNode = node;
        }
      }
    }
    return d3_selection(subgroups);
  };
  function d3_selection_selectorAll(selector) {
    return typeof selector === "function" ? selector : function() {
      return d3_selectAll(selector, this);
    };
  }
  var d3_nsXhtml = "http://www.w3.org/1999/xhtml";
  var d3_nsPrefix = {
    svg: "http://www.w3.org/2000/svg",
    xhtml: d3_nsXhtml,
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace",
    xmlns: "http://www.w3.org/2000/xmlns/"
  };
  d3.ns = {
    prefix: d3_nsPrefix,
    qualify: function(name) {
      var i = name.indexOf(":"), prefix = name;
      if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
      return d3_nsPrefix.hasOwnProperty(prefix) ? {
        space: d3_nsPrefix[prefix],
        local: name
      } : name;
    }
  };
  d3_selectionPrototype.attr = function(name, value) {
    if (arguments.length < 2) {
      if (typeof name === "string") {
        var node = this.node();
        name = d3.ns.qualify(name);
        return name.local ? node.getAttributeNS(name.space, name.local) : node.getAttribute(name);
      }
      for (value in name) this.each(d3_selection_attr(value, name[value]));
      return this;
    }
    return this.each(d3_selection_attr(name, value));
  };
  function d3_selection_attr(name, value) {
    name = d3.ns.qualify(name);
    function attrNull() {
      this.removeAttribute(name);
    }
    function attrNullNS() {
      this.removeAttributeNS(name.space, name.local);
    }
    function attrConstant() {
      this.setAttribute(name, value);
    }
    function attrConstantNS() {
      this.setAttributeNS(name.space, name.local, value);
    }
    function attrFunction() {
      var x = value.apply(this, arguments);
      if (x == null) this.removeAttribute(name); else this.setAttribute(name, x);
    }
    function attrFunctionNS() {
      var x = value.apply(this, arguments);
      if (x == null) this.removeAttributeNS(name.space, name.local); else this.setAttributeNS(name.space, name.local, x);
    }
    return value == null ? name.local ? attrNullNS : attrNull : typeof value === "function" ? name.local ? attrFunctionNS : attrFunction : name.local ? attrConstantNS : attrConstant;
  }
  function d3_collapse(s) {
    return s.trim().replace(/\s+/g, " ");
  }
  d3_selectionPrototype.classed = function(name, value) {
    if (arguments.length < 2) {
      if (typeof name === "string") {
        var node = this.node(), n = (name = d3_selection_classes(name)).length, i = -1;
        if (value = node.classList) {
          while (++i < n) if (!value.contains(name[i])) return false;
        } else {
          value = node.getAttribute("class");
          while (++i < n) if (!d3_selection_classedRe(name[i]).test(value)) return false;
        }
        return true;
      }
      for (value in name) this.each(d3_selection_classed(value, name[value]));
      return this;
    }
    return this.each(d3_selection_classed(name, value));
  };
  function d3_selection_classedRe(name) {
    return new RegExp("(?:^|\\s+)" + d3.requote(name) + "(?:\\s+|$)", "g");
  }
  function d3_selection_classes(name) {
    return (name + "").trim().split(/^|\s+/);
  }
  function d3_selection_classed(name, value) {
    name = d3_selection_classes(name).map(d3_selection_classedName);
    var n = name.length;
    function classedConstant() {
      var i = -1;
      while (++i < n) name[i](this, value);
    }
    function classedFunction() {
      var i = -1, x = value.apply(this, arguments);
      while (++i < n) name[i](this, x);
    }
    return typeof value === "function" ? classedFunction : classedConstant;
  }
  function d3_selection_classedName(name) {
    var re = d3_selection_classedRe(name);
    return function(node, value) {
      if (c = node.classList) return value ? c.add(name) : c.remove(name);
      var c = node.getAttribute("class") || "";
      if (value) {
        re.lastIndex = 0;
        if (!re.test(c)) node.setAttribute("class", d3_collapse(c + " " + name));
      } else {
        node.setAttribute("class", d3_collapse(c.replace(re, " ")));
      }
    };
  }
  d3_selectionPrototype.style = function(name, value, priority) {
    var n = arguments.length;
    if (n < 3) {
      if (typeof name !== "string") {
        if (n < 2) value = "";
        for (priority in name) this.each(d3_selection_style(priority, name[priority], value));
        return this;
      }
      if (n < 2) {
        var node = this.node();
        return d3_window(node).getComputedStyle(node, null).getPropertyValue(name);
      }
      priority = "";
    }
    return this.each(d3_selection_style(name, value, priority));
  };
  function d3_selection_style(name, value, priority) {
    function styleNull() {
      this.style.removeProperty(name);
    }
    function styleConstant() {
      this.style.setProperty(name, value, priority);
    }
    function styleFunction() {
      var x = value.apply(this, arguments);
      if (x == null) this.style.removeProperty(name); else this.style.setProperty(name, x, priority);
    }
    return value == null ? styleNull : typeof value === "function" ? styleFunction : styleConstant;
  }
  d3_selectionPrototype.property = function(name, value) {
    if (arguments.length < 2) {
      if (typeof name === "string") return this.node()[name];
      for (value in name) this.each(d3_selection_property(value, name[value]));
      return this;
    }
    return this.each(d3_selection_property(name, value));
  };
  function d3_selection_property(name, value) {
    function propertyNull() {
      delete this[name];
    }
    function propertyConstant() {
      this[name] = value;
    }
    function propertyFunction() {
      var x = value.apply(this, arguments);
      if (x == null) delete this[name]; else this[name] = x;
    }
    return value == null ? propertyNull : typeof value === "function" ? propertyFunction : propertyConstant;
  }
  d3_selectionPrototype.text = function(value) {
    return arguments.length ? this.each(typeof value === "function" ? function() {
      var v = value.apply(this, arguments);
      this.textContent = v == null ? "" : v;
    } : value == null ? function() {
      this.textContent = "";
    } : function() {
      this.textContent = value;
    }) : this.node().textContent;
  };
  d3_selectionPrototype.html = function(value) {
    return arguments.length ? this.each(typeof value === "function" ? function() {
      var v = value.apply(this, arguments);
      this.innerHTML = v == null ? "" : v;
    } : value == null ? function() {
      this.innerHTML = "";
    } : function() {
      this.innerHTML = value;
    }) : this.node().innerHTML;
  };
  d3_selectionPrototype.append = function(name) {
    name = d3_selection_creator(name);
    return this.select(function() {
      return this.appendChild(name.apply(this, arguments));
    });
  };
  function d3_selection_creator(name) {
    function create() {
      var document = this.ownerDocument, namespace = this.namespaceURI;
      return namespace === d3_nsXhtml && document.documentElement.namespaceURI === d3_nsXhtml ? document.createElement(name) : document.createElementNS(namespace, name);
    }
    function createNS() {
      return this.ownerDocument.createElementNS(name.space, name.local);
    }
    return typeof name === "function" ? name : (name = d3.ns.qualify(name)).local ? createNS : create;
  }
  d3_selectionPrototype.insert = function(name, before) {
    name = d3_selection_creator(name);
    before = d3_selection_selector(before);
    return this.select(function() {
      return this.insertBefore(name.apply(this, arguments), before.apply(this, arguments) || null);
    });
  };
  d3_selectionPrototype.remove = function() {
    return this.each(d3_selectionRemove);
  };
  function d3_selectionRemove() {
    var parent = this.parentNode;
    if (parent) parent.removeChild(this);
  }
  d3_selectionPrototype.data = function(value, key) {
    var i = -1, n = this.length, group, node;
    if (!arguments.length) {
      value = new Array(n = (group = this[0]).length);
      while (++i < n) {
        if (node = group[i]) {
          value[i] = node.__data__;
        }
      }
      return value;
    }
    function bind(group, groupData) {
      var i, n = group.length, m = groupData.length, n0 = Math.min(n, m), updateNodes = new Array(m), enterNodes = new Array(m), exitNodes = new Array(n), node, nodeData;
      if (key) {
        var nodeByKeyValue = new d3_Map(), keyValues = new Array(n), keyValue;
        for (i = -1; ++i < n; ) {
          if (node = group[i]) {
            if (nodeByKeyValue.has(keyValue = key.call(node, node.__data__, i))) {
              exitNodes[i] = node;
            } else {
              nodeByKeyValue.set(keyValue, node);
            }
            keyValues[i] = keyValue;
          }
        }
        for (i = -1; ++i < m; ) {
          if (!(node = nodeByKeyValue.get(keyValue = key.call(groupData, nodeData = groupData[i], i)))) {
            enterNodes[i] = d3_selection_dataNode(nodeData);
          } else if (node !== true) {
            updateNodes[i] = node;
            node.__data__ = nodeData;
          }
          nodeByKeyValue.set(keyValue, true);
        }
        for (i = -1; ++i < n; ) {
          if (i in keyValues && nodeByKeyValue.get(keyValues[i]) !== true) {
            exitNodes[i] = group[i];
          }
        }
      } else {
        for (i = -1; ++i < n0; ) {
          node = group[i];
          nodeData = groupData[i];
          if (node) {
            node.__data__ = nodeData;
            updateNodes[i] = node;
          } else {
            enterNodes[i] = d3_selection_dataNode(nodeData);
          }
        }
        for (;i < m; ++i) {
          enterNodes[i] = d3_selection_dataNode(groupData[i]);
        }
        for (;i < n; ++i) {
          exitNodes[i] = group[i];
        }
      }
      enterNodes.update = updateNodes;
      enterNodes.parentNode = updateNodes.parentNode = exitNodes.parentNode = group.parentNode;
      enter.push(enterNodes);
      update.push(updateNodes);
      exit.push(exitNodes);
    }
    var enter = d3_selection_enter([]), update = d3_selection([]), exit = d3_selection([]);
    if (typeof value === "function") {
      while (++i < n) {
        bind(group = this[i], value.call(group, group.parentNode.__data__, i));
      }
    } else {
      while (++i < n) {
        bind(group = this[i], value);
      }
    }
    update.enter = function() {
      return enter;
    };
    update.exit = function() {
      return exit;
    };
    return update;
  };
  function d3_selection_dataNode(data) {
    return {
      __data__: data
    };
  }
  d3_selectionPrototype.datum = function(value) {
    return arguments.length ? this.property("__data__", value) : this.property("__data__");
  };
  d3_selectionPrototype.filter = function(filter) {
    var subgroups = [], subgroup, group, node;
    if (typeof filter !== "function") filter = d3_selection_filter(filter);
    for (var j = 0, m = this.length; j < m; j++) {
      subgroups.push(subgroup = []);
      subgroup.parentNode = (group = this[j]).parentNode;
      for (var i = 0, n = group.length; i < n; i++) {
        if ((node = group[i]) && filter.call(node, node.__data__, i, j)) {
          subgroup.push(node);
        }
      }
    }
    return d3_selection(subgroups);
  };
  function d3_selection_filter(selector) {
    return function() {
      return d3_selectMatches(this, selector);
    };
  }
  d3_selectionPrototype.order = function() {
    for (var j = -1, m = this.length; ++j < m; ) {
      for (var group = this[j], i = group.length - 1, next = group[i], node; --i >= 0; ) {
        if (node = group[i]) {
          if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
          next = node;
        }
      }
    }
    return this;
  };
  d3_selectionPrototype.sort = function(comparator) {
    comparator = d3_selection_sortComparator.apply(this, arguments);
    for (var j = -1, m = this.length; ++j < m; ) this[j].sort(comparator);
    return this.order();
  };
  function d3_selection_sortComparator(comparator) {
    if (!arguments.length) comparator = d3_ascending;
    return function(a, b) {
      return a && b ? comparator(a.__data__, b.__data__) : !a - !b;
    };
  }
  d3_selectionPrototype.each = function(callback) {
    return d3_selection_each(this, function(node, i, j) {
      callback.call(node, node.__data__, i, j);
    });
  };
  function d3_selection_each(groups, callback) {
    for (var j = 0, m = groups.length; j < m; j++) {
      for (var group = groups[j], i = 0, n = group.length, node; i < n; i++) {
        if (node = group[i]) callback(node, i, j);
      }
    }
    return groups;
  }
  d3_selectionPrototype.call = function(callback) {
    var args = d3_array(arguments);
    callback.apply(args[0] = this, args);
    return this;
  };
  d3_selectionPrototype.empty = function() {
    return !this.node();
  };
  d3_selectionPrototype.node = function() {
    for (var j = 0, m = this.length; j < m; j++) {
      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
        var node = group[i];
        if (node) return node;
      }
    }
    return null;
  };
  d3_selectionPrototype.size = function() {
    var n = 0;
    d3_selection_each(this, function() {
      ++n;
    });
    return n;
  };
  function d3_selection_enter(selection) {
    d3_subclass(selection, d3_selection_enterPrototype);
    return selection;
  }
  var d3_selection_enterPrototype = [];
  d3.selection.enter = d3_selection_enter;
  d3.selection.enter.prototype = d3_selection_enterPrototype;
  d3_selection_enterPrototype.append = d3_selectionPrototype.append;
  d3_selection_enterPrototype.empty = d3_selectionPrototype.empty;
  d3_selection_enterPrototype.node = d3_selectionPrototype.node;
  d3_selection_enterPrototype.call = d3_selectionPrototype.call;
  d3_selection_enterPrototype.size = d3_selectionPrototype.size;
  d3_selection_enterPrototype.select = function(selector) {
    var subgroups = [], subgroup, subnode, upgroup, group, node;
    for (var j = -1, m = this.length; ++j < m; ) {
      upgroup = (group = this[j]).update;
      subgroups.push(subgroup = []);
      subgroup.parentNode = group.parentNode;
      for (var i = -1, n = group.length; ++i < n; ) {
        if (node = group[i]) {
          subgroup.push(upgroup[i] = subnode = selector.call(group.parentNode, node.__data__, i, j));
          subnode.__data__ = node.__data__;
        } else {
          subgroup.push(null);
        }
      }
    }
    return d3_selection(subgroups);
  };
  d3_selection_enterPrototype.insert = function(name, before) {
    if (arguments.length < 2) before = d3_selection_enterInsertBefore(this);
    return d3_selectionPrototype.insert.call(this, name, before);
  };
  function d3_selection_enterInsertBefore(enter) {
    var i0, j0;
    return function(d, i, j) {
      var group = enter[j].update, n = group.length, node;
      if (j != j0) j0 = j, i0 = 0;
      if (i >= i0) i0 = i + 1;
      while (!(node = group[i0]) && ++i0 < n) ;
      return node;
    };
  }
  d3.select = function(node) {
    var group;
    if (typeof node === "string") {
      group = [ d3_select(node, d3_document) ];
      group.parentNode = d3_document.documentElement;
    } else {
      group = [ node ];
      group.parentNode = d3_documentElement(node);
    }
    return d3_selection([ group ]);
  };
  d3.selectAll = function(nodes) {
    var group;
    if (typeof nodes === "string") {
      group = d3_array(d3_selectAll(nodes, d3_document));
      group.parentNode = d3_document.documentElement;
    } else {
      group = d3_array(nodes);
      group.parentNode = null;
    }
    return d3_selection([ group ]);
  };
  d3_selectionPrototype.on = function(type, listener, capture) {
    var n = arguments.length;
    if (n < 3) {
      if (typeof type !== "string") {
        if (n < 2) listener = false;
        for (capture in type) this.each(d3_selection_on(capture, type[capture], listener));
        return this;
      }
      if (n < 2) return (n = this.node()["__on" + type]) && n._;
      capture = false;
    }
    return this.each(d3_selection_on(type, listener, capture));
  };
  function d3_selection_on(type, listener, capture) {
    var name = "__on" + type, i = type.indexOf("."), wrap = d3_selection_onListener;
    if (i > 0) type = type.slice(0, i);
    var filter = d3_selection_onFilters.get(type);
    if (filter) type = filter, wrap = d3_selection_onFilter;
    function onRemove() {
      var l = this[name];
      if (l) {
        this.removeEventListener(type, l, l.$);
        delete this[name];
      }
    }
    function onAdd() {
      var l = wrap(listener, d3_array(arguments));
      onRemove.call(this);
      this.addEventListener(type, this[name] = l, l.$ = capture);
      l._ = listener;
    }
    function removeAll() {
      var re = new RegExp("^__on([^.]+)" + d3.requote(type) + "$"), match;
      for (var name in this) {
        if (match = name.match(re)) {
          var l = this[name];
          this.removeEventListener(match[1], l, l.$);
          delete this[name];
        }
      }
    }
    return i ? listener ? onAdd : onRemove : listener ? d3_noop : removeAll;
  }
  var d3_selection_onFilters = d3.map({
    mouseenter: "mouseover",
    mouseleave: "mouseout"
  });
  if (d3_document) {
    d3_selection_onFilters.forEach(function(k) {
      if ("on" + k in d3_document) d3_selection_onFilters.remove(k);
    });
  }
  function d3_selection_onListener(listener, argumentz) {
    return function(e) {
      var o = d3.event;
      d3.event = e;
      argumentz[0] = this.__data__;
      try {
        listener.apply(this, argumentz);
      } finally {
        d3.event = o;
      }
    };
  }
  function d3_selection_onFilter(listener, argumentz) {
    var l = d3_selection_onListener(listener, argumentz);
    return function(e) {
      var target = this, related = e.relatedTarget;
      if (!related || related !== target && !(related.compareDocumentPosition(target) & 8)) {
        l.call(target, e);
      }
    };
  }
  var d3_event_dragSelect, d3_event_dragId = 0;
  function d3_event_dragSuppress(node) {
    var name = ".dragsuppress-" + ++d3_event_dragId, click = "click" + name, w = d3.select(d3_window(node)).on("touchmove" + name, d3_eventPreventDefault).on("dragstart" + name, d3_eventPreventDefault).on("selectstart" + name, d3_eventPreventDefault);
    if (d3_event_dragSelect == null) {
      d3_event_dragSelect = "onselectstart" in node ? false : d3_vendorSymbol(node.style, "userSelect");
    }
    if (d3_event_dragSelect) {
      var style = d3_documentElement(node).style, select = style[d3_event_dragSelect];
      style[d3_event_dragSelect] = "none";
    }
    return function(suppressClick) {
      w.on(name, null);
      if (d3_event_dragSelect) style[d3_event_dragSelect] = select;
      if (suppressClick) {
        var off = function() {
          w.on(click, null);
        };
        w.on(click, function() {
          d3_eventPreventDefault();
          off();
        }, true);
        setTimeout(off, 0);
      }
    };
  }
  d3.mouse = function(container) {
    return d3_mousePoint(container, d3_eventSource());
  };
  var d3_mouse_bug44083 = this.navigator && /WebKit/.test(this.navigator.userAgent) ? -1 : 0;
  function d3_mousePoint(container, e) {
    if (e.changedTouches) e = e.changedTouches[0];
    var svg = container.ownerSVGElement || container;
    if (svg.createSVGPoint) {
      var point = svg.createSVGPoint();
      if (d3_mouse_bug44083 < 0) {
        var window = d3_window(container);
        if (window.scrollX || window.scrollY) {
          svg = d3.select("body").append("svg").style({
            position: "absolute",
            top: 0,
            left: 0,
            margin: 0,
            padding: 0,
            border: "none"
          }, "important");
          var ctm = svg[0][0].getScreenCTM();
          d3_mouse_bug44083 = !(ctm.f || ctm.e);
          svg.remove();
        }
      }
      if (d3_mouse_bug44083) point.x = e.pageX, point.y = e.pageY; else point.x = e.clientX, 
      point.y = e.clientY;
      point = point.matrixTransform(container.getScreenCTM().inverse());
      return [ point.x, point.y ];
    }
    var rect = container.getBoundingClientRect();
    return [ e.clientX - rect.left - container.clientLeft, e.clientY - rect.top - container.clientTop ];
  }
  d3.touch = function(container, touches, identifier) {
    if (arguments.length < 3) identifier = touches, touches = d3_eventSource().changedTouches;
    if (touches) for (var i = 0, n = touches.length, touch; i < n; ++i) {
      if ((touch = touches[i]).identifier === identifier) {
        return d3_mousePoint(container, touch);
      }
    }
  };
  d3.behavior.drag = function() {
    var event = d3_eventDispatch(drag, "drag", "dragstart", "dragend"), origin = null, mousedown = dragstart(d3_noop, d3.mouse, d3_window, "mousemove", "mouseup"), touchstart = dragstart(d3_behavior_dragTouchId, d3.touch, d3_identity, "touchmove", "touchend");
    function drag() {
      this.on("mousedown.drag", mousedown).on("touchstart.drag", touchstart);
    }
    function dragstart(id, position, subject, move, end) {
      return function() {
        var that = this, target = d3.event.target.correspondingElement || d3.event.target, parent = that.parentNode, dispatch = event.of(that, arguments), dragged = 0, dragId = id(), dragName = ".drag" + (dragId == null ? "" : "-" + dragId), dragOffset, dragSubject = d3.select(subject(target)).on(move + dragName, moved).on(end + dragName, ended), dragRestore = d3_event_dragSuppress(target), position0 = position(parent, dragId);
        if (origin) {
          dragOffset = origin.apply(that, arguments);
          dragOffset = [ dragOffset.x - position0[0], dragOffset.y - position0[1] ];
        } else {
          dragOffset = [ 0, 0 ];
        }
        dispatch({
          type: "dragstart"
        });
        function moved() {
          var position1 = position(parent, dragId), dx, dy;
          if (!position1) return;
          dx = position1[0] - position0[0];
          dy = position1[1] - position0[1];
          dragged |= dx | dy;
          position0 = position1;
          dispatch({
            type: "drag",
            x: position1[0] + dragOffset[0],
            y: position1[1] + dragOffset[1],
            dx: dx,
            dy: dy
          });
        }
        function ended() {
          if (!position(parent, dragId)) return;
          dragSubject.on(move + dragName, null).on(end + dragName, null);
          dragRestore(dragged);
          dispatch({
            type: "dragend"
          });
        }
      };
    }
    drag.origin = function(x) {
      if (!arguments.length) return origin;
      origin = x;
      return drag;
    };
    return d3.rebind(drag, event, "on");
  };
  function d3_behavior_dragTouchId() {
    return d3.event.changedTouches[0].identifier;
  }
  d3.touches = function(container, touches) {
    if (arguments.length < 2) touches = d3_eventSource().touches;
    return touches ? d3_array(touches).map(function(touch) {
      var point = d3_mousePoint(container, touch);
      point.identifier = touch.identifier;
      return point;
    }) : [];
  };
  var ε = 1e-6, ε2 = ε * ε, π = Math.PI, τ = 2 * π, τε = τ - ε, halfπ = π / 2, d3_radians = π / 180, d3_degrees = 180 / π;
  function d3_sgn(x) {
    return x > 0 ? 1 : x < 0 ? -1 : 0;
  }
  function d3_cross2d(a, b, c) {
    return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
  }
  function d3_acos(x) {
    return x > 1 ? 0 : x < -1 ? π : Math.acos(x);
  }
  function d3_asin(x) {
    return x > 1 ? halfπ : x < -1 ? -halfπ : Math.asin(x);
  }
  function d3_sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
  }
  function d3_cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
  }
  function d3_tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
  }
  function d3_haversin(x) {
    return (x = Math.sin(x / 2)) * x;
  }
  var ρ = Math.SQRT2, ρ2 = 2, ρ4 = 4;
  d3.interpolateZoom = function(p0, p1) {
    var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
    if (d2 < ε2) {
      S = Math.log(w1 / w0) / ρ;
      i = function(t) {
        return [ ux0 + t * dx, uy0 + t * dy, w0 * Math.exp(ρ * t * S) ];
      };
    } else {
      var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + ρ4 * d2) / (2 * w0 * ρ2 * d1), b1 = (w1 * w1 - w0 * w0 - ρ4 * d2) / (2 * w1 * ρ2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
      S = (r1 - r0) / ρ;
      i = function(t) {
        var s = t * S, coshr0 = d3_cosh(r0), u = w0 / (ρ2 * d1) * (coshr0 * d3_tanh(ρ * s + r0) - d3_sinh(r0));
        return [ ux0 + u * dx, uy0 + u * dy, w0 * coshr0 / d3_cosh(ρ * s + r0) ];
      };
    }
    i.duration = S * 1e3;
    return i;
  };
  d3.behavior.zoom = function() {
    var view = {
      x: 0,
      y: 0,
      k: 1
    }, translate0, center0, center, size = [ 960, 500 ], scaleExtent = d3_behavior_zoomInfinity, duration = 250, zooming = 0, mousedown = "mousedown.zoom", mousemove = "mousemove.zoom", mouseup = "mouseup.zoom", mousewheelTimer, touchstart = "touchstart.zoom", touchtime, event = d3_eventDispatch(zoom, "zoomstart", "zoom", "zoomend"), x0, x1, y0, y1;
    if (!d3_behavior_zoomWheel) {
      d3_behavior_zoomWheel = "onwheel" in d3_document ? (d3_behavior_zoomDelta = function() {
        return -d3.event.deltaY * (d3.event.deltaMode ? 120 : 1);
      }, "wheel") : "onmousewheel" in d3_document ? (d3_behavior_zoomDelta = function() {
        return d3.event.wheelDelta;
      }, "mousewheel") : (d3_behavior_zoomDelta = function() {
        return -d3.event.detail;
      }, "MozMousePixelScroll");
    }
    function zoom(g) {
      g.on(mousedown, mousedowned).on(d3_behavior_zoomWheel + ".zoom", mousewheeled).on("dblclick.zoom", dblclicked).on(touchstart, touchstarted);
    }
    zoom.event = function(g) {
      g.each(function() {
        var dispatch = event.of(this, arguments), view1 = view;
        if (d3_transitionInheritId) {
          d3.select(this).transition().each("start.zoom", function() {
            view = this.__chart__ || {
              x: 0,
              y: 0,
              k: 1
            };
            zoomstarted(dispatch);
          }).tween("zoom:zoom", function() {
            var dx = size[0], dy = size[1], cx = center0 ? center0[0] : dx / 2, cy = center0 ? center0[1] : dy / 2, i = d3.interpolateZoom([ (cx - view.x) / view.k, (cy - view.y) / view.k, dx / view.k ], [ (cx - view1.x) / view1.k, (cy - view1.y) / view1.k, dx / view1.k ]);
            return function(t) {
              var l = i(t), k = dx / l[2];
              this.__chart__ = view = {
                x: cx - l[0] * k,
                y: cy - l[1] * k,
                k: k
              };
              zoomed(dispatch);
            };
          }).each("interrupt.zoom", function() {
            zoomended(dispatch);
          }).each("end.zoom", function() {
            zoomended(dispatch);
          });
        } else {
          this.__chart__ = view;
          zoomstarted(dispatch);
          zoomed(dispatch);
          zoomended(dispatch);
        }
      });
    };
    zoom.translate = function(_) {
      if (!arguments.length) return [ view.x, view.y ];
      view = {
        x: +_[0],
        y: +_[1],
        k: view.k
      };
      rescale();
      return zoom;
    };
    zoom.scale = function(_) {
      if (!arguments.length) return view.k;
      view = {
        x: view.x,
        y: view.y,
        k: null
      };
      scaleTo(+_);
      rescale();
      return zoom;
    };
    zoom.scaleExtent = function(_) {
      if (!arguments.length) return scaleExtent;
      scaleExtent = _ == null ? d3_behavior_zoomInfinity : [ +_[0], +_[1] ];
      return zoom;
    };
    zoom.center = function(_) {
      if (!arguments.length) return center;
      center = _ && [ +_[0], +_[1] ];
      return zoom;
    };
    zoom.size = function(_) {
      if (!arguments.length) return size;
      size = _ && [ +_[0], +_[1] ];
      return zoom;
    };
    zoom.duration = function(_) {
      if (!arguments.length) return duration;
      duration = +_;
      return zoom;
    };
    zoom.x = function(z) {
      if (!arguments.length) return x1;
      x1 = z;
      x0 = z.copy();
      view = {
        x: 0,
        y: 0,
        k: 1
      };
      return zoom;
    };
    zoom.y = function(z) {
      if (!arguments.length) return y1;
      y1 = z;
      y0 = z.copy();
      view = {
        x: 0,
        y: 0,
        k: 1
      };
      return zoom;
    };
    function location(p) {
      return [ (p[0] - view.x) / view.k, (p[1] - view.y) / view.k ];
    }
    function point(l) {
      return [ l[0] * view.k + view.x, l[1] * view.k + view.y ];
    }
    function scaleTo(s) {
      view.k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], s));
    }
    function translateTo(p, l) {
      l = point(l);
      view.x += p[0] - l[0];
      view.y += p[1] - l[1];
    }
    function zoomTo(that, p, l, k) {
      that.__chart__ = {
        x: view.x,
        y: view.y,
        k: view.k
      };
      scaleTo(Math.pow(2, k));
      translateTo(center0 = p, l);
      that = d3.select(that);
      if (duration > 0) that = that.transition().duration(duration);
      that.call(zoom.event);
    }
    function rescale() {
      if (x1) x1.domain(x0.range().map(function(x) {
        return (x - view.x) / view.k;
      }).map(x0.invert));
      if (y1) y1.domain(y0.range().map(function(y) {
        return (y - view.y) / view.k;
      }).map(y0.invert));
    }
    function zoomstarted(dispatch) {
      if (!zooming++) dispatch({
        type: "zoomstart"
      });
    }
    function zoomed(dispatch) {
      rescale();
      dispatch({
        type: "zoom",
        scale: view.k,
        translate: [ view.x, view.y ]
      });
    }
    function zoomended(dispatch) {
      if (!--zooming) dispatch({
        type: "zoomend"
      }), center0 = null;
    }
    function mousedowned() {
      var that = this, dispatch = event.of(that, arguments), dragged = 0, subject = d3.select(d3_window(that)).on(mousemove, moved).on(mouseup, ended), location0 = location(d3.mouse(that)), dragRestore = d3_event_dragSuppress(that);
      d3_selection_interrupt.call(that);
      zoomstarted(dispatch);
      function moved() {
        dragged = 1;
        translateTo(d3.mouse(that), location0);
        zoomed(dispatch);
      }
      function ended() {
        subject.on(mousemove, null).on(mouseup, null);
        dragRestore(dragged);
        zoomended(dispatch);
      }
    }
    function touchstarted() {
      var that = this, dispatch = event.of(that, arguments), locations0 = {}, distance0 = 0, scale0, zoomName = ".zoom-" + d3.event.changedTouches[0].identifier, touchmove = "touchmove" + zoomName, touchend = "touchend" + zoomName, targets = [], subject = d3.select(that), dragRestore = d3_event_dragSuppress(that);
      started();
      zoomstarted(dispatch);
      subject.on(mousedown, null).on(touchstart, started);
      function relocate() {
        var touches = d3.touches(that);
        scale0 = view.k;
        touches.forEach(function(t) {
          if (t.identifier in locations0) locations0[t.identifier] = location(t);
        });
        return touches;
      }
      function started() {
        var target = d3.event.target;
        d3.select(target).on(touchmove, moved).on(touchend, ended);
        targets.push(target);
        var changed = d3.event.changedTouches;
        for (var i = 0, n = changed.length; i < n; ++i) {
          locations0[changed[i].identifier] = null;
        }
        var touches = relocate(), now = Date.now();
        if (touches.length === 1) {
          if (now - touchtime < 500) {
            var p = touches[0];
            zoomTo(that, p, locations0[p.identifier], Math.floor(Math.log(view.k) / Math.LN2) + 1);
            d3_eventPreventDefault();
          }
          touchtime = now;
        } else if (touches.length > 1) {
          var p = touches[0], q = touches[1], dx = p[0] - q[0], dy = p[1] - q[1];
          distance0 = dx * dx + dy * dy;
        }
      }
      function moved() {
        var touches = d3.touches(that), p0, l0, p1, l1;
        d3_selection_interrupt.call(that);
        for (var i = 0, n = touches.length; i < n; ++i, l1 = null) {
          p1 = touches[i];
          if (l1 = locations0[p1.identifier]) {
            if (l0) break;
            p0 = p1, l0 = l1;
          }
        }
        if (l1) {
          var distance1 = (distance1 = p1[0] - p0[0]) * distance1 + (distance1 = p1[1] - p0[1]) * distance1, scale1 = distance0 && Math.sqrt(distance1 / distance0);
          p0 = [ (p0[0] + p1[0]) / 2, (p0[1] + p1[1]) / 2 ];
          l0 = [ (l0[0] + l1[0]) / 2, (l0[1] + l1[1]) / 2 ];
          scaleTo(scale1 * scale0);
        }
        touchtime = null;
        translateTo(p0, l0);
        zoomed(dispatch);
      }
      function ended() {
        if (d3.event.touches.length) {
          var changed = d3.event.changedTouches;
          for (var i = 0, n = changed.length; i < n; ++i) {
            delete locations0[changed[i].identifier];
          }
          for (var identifier in locations0) {
            return void relocate();
          }
        }
        d3.selectAll(targets).on(zoomName, null);
        subject.on(mousedown, mousedowned).on(touchstart, touchstarted);
        dragRestore();
        zoomended(dispatch);
      }
    }
    function mousewheeled() {
      var dispatch = event.of(this, arguments);
      if (mousewheelTimer) clearTimeout(mousewheelTimer); else d3_selection_interrupt.call(this), 
      translate0 = location(center0 = center || d3.mouse(this)), zoomstarted(dispatch);
      mousewheelTimer = setTimeout(function() {
        mousewheelTimer = null;
        zoomended(dispatch);
      }, 50);
      d3_eventPreventDefault();
      scaleTo(Math.pow(2, d3_behavior_zoomDelta() * .002) * view.k);
      translateTo(center0, translate0);
      zoomed(dispatch);
    }
    function dblclicked() {
      var p = d3.mouse(this), k = Math.log(view.k) / Math.LN2;
      zoomTo(this, p, location(p), d3.event.shiftKey ? Math.ceil(k) - 1 : Math.floor(k) + 1);
    }
    return d3.rebind(zoom, event, "on");
  };
  var d3_behavior_zoomInfinity = [ 0, Infinity ], d3_behavior_zoomDelta, d3_behavior_zoomWheel;
  d3.color = d3_color;
  function d3_color() {}
  d3_color.prototype.toString = function() {
    return this.rgb() + "";
  };
  d3.hsl = d3_hsl;
  function d3_hsl(h, s, l) {
    return this instanceof d3_hsl ? void (this.h = +h, this.s = +s, this.l = +l) : arguments.length < 2 ? h instanceof d3_hsl ? new d3_hsl(h.h, h.s, h.l) : d3_rgb_parse("" + h, d3_rgb_hsl, d3_hsl) : new d3_hsl(h, s, l);
  }
  var d3_hslPrototype = d3_hsl.prototype = new d3_color();
  d3_hslPrototype.brighter = function(k) {
    k = Math.pow(.7, arguments.length ? k : 1);
    return new d3_hsl(this.h, this.s, this.l / k);
  };
  d3_hslPrototype.darker = function(k) {
    k = Math.pow(.7, arguments.length ? k : 1);
    return new d3_hsl(this.h, this.s, k * this.l);
  };
  d3_hslPrototype.rgb = function() {
    return d3_hsl_rgb(this.h, this.s, this.l);
  };
  function d3_hsl_rgb(h, s, l) {
    var m1, m2;
    h = isNaN(h) ? 0 : (h %= 360) < 0 ? h + 360 : h;
    s = isNaN(s) ? 0 : s < 0 ? 0 : s > 1 ? 1 : s;
    l = l < 0 ? 0 : l > 1 ? 1 : l;
    m2 = l <= .5 ? l * (1 + s) : l + s - l * s;
    m1 = 2 * l - m2;
    function v(h) {
      if (h > 360) h -= 360; else if (h < 0) h += 360;
      if (h < 60) return m1 + (m2 - m1) * h / 60;
      if (h < 180) return m2;
      if (h < 240) return m1 + (m2 - m1) * (240 - h) / 60;
      return m1;
    }
    function vv(h) {
      return Math.round(v(h) * 255);
    }
    return new d3_rgb(vv(h + 120), vv(h), vv(h - 120));
  }
  d3.hcl = d3_hcl;
  function d3_hcl(h, c, l) {
    return this instanceof d3_hcl ? void (this.h = +h, this.c = +c, this.l = +l) : arguments.length < 2 ? h instanceof d3_hcl ? new d3_hcl(h.h, h.c, h.l) : h instanceof d3_lab ? d3_lab_hcl(h.l, h.a, h.b) : d3_lab_hcl((h = d3_rgb_lab((h = d3.rgb(h)).r, h.g, h.b)).l, h.a, h.b) : new d3_hcl(h, c, l);
  }
  var d3_hclPrototype = d3_hcl.prototype = new d3_color();
  d3_hclPrototype.brighter = function(k) {
    return new d3_hcl(this.h, this.c, Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)));
  };
  d3_hclPrototype.darker = function(k) {
    return new d3_hcl(this.h, this.c, Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)));
  };
  d3_hclPrototype.rgb = function() {
    return d3_hcl_lab(this.h, this.c, this.l).rgb();
  };
  function d3_hcl_lab(h, c, l) {
    if (isNaN(h)) h = 0;
    if (isNaN(c)) c = 0;
    return new d3_lab(l, Math.cos(h *= d3_radians) * c, Math.sin(h) * c);
  }
  d3.lab = d3_lab;
  function d3_lab(l, a, b) {
    return this instanceof d3_lab ? void (this.l = +l, this.a = +a, this.b = +b) : arguments.length < 2 ? l instanceof d3_lab ? new d3_lab(l.l, l.a, l.b) : l instanceof d3_hcl ? d3_hcl_lab(l.h, l.c, l.l) : d3_rgb_lab((l = d3_rgb(l)).r, l.g, l.b) : new d3_lab(l, a, b);
  }
  var d3_lab_K = 18;
  var d3_lab_X = .95047, d3_lab_Y = 1, d3_lab_Z = 1.08883;
  var d3_labPrototype = d3_lab.prototype = new d3_color();
  d3_labPrototype.brighter = function(k) {
    return new d3_lab(Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
  };
  d3_labPrototype.darker = function(k) {
    return new d3_lab(Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
  };
  d3_labPrototype.rgb = function() {
    return d3_lab_rgb(this.l, this.a, this.b);
  };
  function d3_lab_rgb(l, a, b) {
    var y = (l + 16) / 116, x = y + a / 500, z = y - b / 200;
    x = d3_lab_xyz(x) * d3_lab_X;
    y = d3_lab_xyz(y) * d3_lab_Y;
    z = d3_lab_xyz(z) * d3_lab_Z;
    return new d3_rgb(d3_xyz_rgb(3.2404542 * x - 1.5371385 * y - .4985314 * z), d3_xyz_rgb(-.969266 * x + 1.8760108 * y + .041556 * z), d3_xyz_rgb(.0556434 * x - .2040259 * y + 1.0572252 * z));
  }
  function d3_lab_hcl(l, a, b) {
    return l > 0 ? new d3_hcl(Math.atan2(b, a) * d3_degrees, Math.sqrt(a * a + b * b), l) : new d3_hcl(NaN, NaN, l);
  }
  function d3_lab_xyz(x) {
    return x > .206893034 ? x * x * x : (x - 4 / 29) / 7.787037;
  }
  function d3_xyz_lab(x) {
    return x > .008856 ? Math.pow(x, 1 / 3) : 7.787037 * x + 4 / 29;
  }
  function d3_xyz_rgb(r) {
    return Math.round(255 * (r <= .00304 ? 12.92 * r : 1.055 * Math.pow(r, 1 / 2.4) - .055));
  }
  d3.rgb = d3_rgb;
  function d3_rgb(r, g, b) {
    return this instanceof d3_rgb ? void (this.r = ~~r, this.g = ~~g, this.b = ~~b) : arguments.length < 2 ? r instanceof d3_rgb ? new d3_rgb(r.r, r.g, r.b) : d3_rgb_parse("" + r, d3_rgb, d3_hsl_rgb) : new d3_rgb(r, g, b);
  }
  function d3_rgbNumber(value) {
    return new d3_rgb(value >> 16, value >> 8 & 255, value & 255);
  }
  function d3_rgbString(value) {
    return d3_rgbNumber(value) + "";
  }
  var d3_rgbPrototype = d3_rgb.prototype = new d3_color();
  d3_rgbPrototype.brighter = function(k) {
    k = Math.pow(.7, arguments.length ? k : 1);
    var r = this.r, g = this.g, b = this.b, i = 30;
    if (!r && !g && !b) return new d3_rgb(i, i, i);
    if (r && r < i) r = i;
    if (g && g < i) g = i;
    if (b && b < i) b = i;
    return new d3_rgb(Math.min(255, r / k), Math.min(255, g / k), Math.min(255, b / k));
  };
  d3_rgbPrototype.darker = function(k) {
    k = Math.pow(.7, arguments.length ? k : 1);
    return new d3_rgb(k * this.r, k * this.g, k * this.b);
  };
  d3_rgbPrototype.hsl = function() {
    return d3_rgb_hsl(this.r, this.g, this.b);
  };
  d3_rgbPrototype.toString = function() {
    return "#" + d3_rgb_hex(this.r) + d3_rgb_hex(this.g) + d3_rgb_hex(this.b);
  };
  function d3_rgb_hex(v) {
    return v < 16 ? "0" + Math.max(0, v).toString(16) : Math.min(255, v).toString(16);
  }
  function d3_rgb_parse(format, rgb, hsl) {
    var r = 0, g = 0, b = 0, m1, m2, color;
    m1 = /([a-z]+)\((.*)\)/.exec(format = format.toLowerCase());
    if (m1) {
      m2 = m1[2].split(",");
      switch (m1[1]) {
       case "hsl":
        {
          return hsl(parseFloat(m2[0]), parseFloat(m2[1]) / 100, parseFloat(m2[2]) / 100);
        }

       case "rgb":
        {
          return rgb(d3_rgb_parseNumber(m2[0]), d3_rgb_parseNumber(m2[1]), d3_rgb_parseNumber(m2[2]));
        }
      }
    }
    if (color = d3_rgb_names.get(format)) {
      return rgb(color.r, color.g, color.b);
    }
    if (format != null && format.charAt(0) === "#" && !isNaN(color = parseInt(format.slice(1), 16))) {
      if (format.length === 4) {
        r = (color & 3840) >> 4;
        r = r >> 4 | r;
        g = color & 240;
        g = g >> 4 | g;
        b = color & 15;
        b = b << 4 | b;
      } else if (format.length === 7) {
        r = (color & 16711680) >> 16;
        g = (color & 65280) >> 8;
        b = color & 255;
      }
    }
    return rgb(r, g, b);
  }
  function d3_rgb_hsl(r, g, b) {
    var min = Math.min(r /= 255, g /= 255, b /= 255), max = Math.max(r, g, b), d = max - min, h, s, l = (max + min) / 2;
    if (d) {
      s = l < .5 ? d / (max + min) : d / (2 - max - min);
      if (r == max) h = (g - b) / d + (g < b ? 6 : 0); else if (g == max) h = (b - r) / d + 2; else h = (r - g) / d + 4;
      h *= 60;
    } else {
      h = NaN;
      s = l > 0 && l < 1 ? 0 : h;
    }
    return new d3_hsl(h, s, l);
  }
  function d3_rgb_lab(r, g, b) {
    r = d3_rgb_xyz(r);
    g = d3_rgb_xyz(g);
    b = d3_rgb_xyz(b);
    var x = d3_xyz_lab((.4124564 * r + .3575761 * g + .1804375 * b) / d3_lab_X), y = d3_xyz_lab((.2126729 * r + .7151522 * g + .072175 * b) / d3_lab_Y), z = d3_xyz_lab((.0193339 * r + .119192 * g + .9503041 * b) / d3_lab_Z);
    return d3_lab(116 * y - 16, 500 * (x - y), 200 * (y - z));
  }
  function d3_rgb_xyz(r) {
    return (r /= 255) <= .04045 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4);
  }
  function d3_rgb_parseNumber(c) {
    var f = parseFloat(c);
    return c.charAt(c.length - 1) === "%" ? Math.round(f * 2.55) : f;
  }
  var d3_rgb_names = d3.map({
    aliceblue: 15792383,
    antiquewhite: 16444375,
    aqua: 65535,
    aquamarine: 8388564,
    azure: 15794175,
    beige: 16119260,
    bisque: 16770244,
    black: 0,
    blanchedalmond: 16772045,
    blue: 255,
    blueviolet: 9055202,
    brown: 10824234,
    burlywood: 14596231,
    cadetblue: 6266528,
    chartreuse: 8388352,
    chocolate: 13789470,
    coral: 16744272,
    cornflowerblue: 6591981,
    cornsilk: 16775388,
    crimson: 14423100,
    cyan: 65535,
    darkblue: 139,
    darkcyan: 35723,
    darkgoldenrod: 12092939,
    darkgray: 11119017,
    darkgreen: 25600,
    darkgrey: 11119017,
    darkkhaki: 12433259,
    darkmagenta: 9109643,
    darkolivegreen: 5597999,
    darkorange: 16747520,
    darkorchid: 10040012,
    darkred: 9109504,
    darksalmon: 15308410,
    darkseagreen: 9419919,
    darkslateblue: 4734347,
    darkslategray: 3100495,
    darkslategrey: 3100495,
    darkturquoise: 52945,
    darkviolet: 9699539,
    deeppink: 16716947,
    deepskyblue: 49151,
    dimgray: 6908265,
    dimgrey: 6908265,
    dodgerblue: 2003199,
    firebrick: 11674146,
    floralwhite: 16775920,
    forestgreen: 2263842,
    fuchsia: 16711935,
    gainsboro: 14474460,
    ghostwhite: 16316671,
    gold: 16766720,
    goldenrod: 14329120,
    gray: 8421504,
    green: 32768,
    greenyellow: 11403055,
    grey: 8421504,
    honeydew: 15794160,
    hotpink: 16738740,
    indianred: 13458524,
    indigo: 4915330,
    ivory: 16777200,
    khaki: 15787660,
    lavender: 15132410,
    lavenderblush: 16773365,
    lawngreen: 8190976,
    lemonchiffon: 16775885,
    lightblue: 11393254,
    lightcoral: 15761536,
    lightcyan: 14745599,
    lightgoldenrodyellow: 16448210,
    lightgray: 13882323,
    lightgreen: 9498256,
    lightgrey: 13882323,
    lightpink: 16758465,
    lightsalmon: 16752762,
    lightseagreen: 2142890,
    lightskyblue: 8900346,
    lightslategray: 7833753,
    lightslategrey: 7833753,
    lightsteelblue: 11584734,
    lightyellow: 16777184,
    lime: 65280,
    limegreen: 3329330,
    linen: 16445670,
    magenta: 16711935,
    maroon: 8388608,
    mediumaquamarine: 6737322,
    mediumblue: 205,
    mediumorchid: 12211667,
    mediumpurple: 9662683,
    mediumseagreen: 3978097,
    mediumslateblue: 8087790,
    mediumspringgreen: 64154,
    mediumturquoise: 4772300,
    mediumvioletred: 13047173,
    midnightblue: 1644912,
    mintcream: 16121850,
    mistyrose: 16770273,
    moccasin: 16770229,
    navajowhite: 16768685,
    navy: 128,
    oldlace: 16643558,
    olive: 8421376,
    olivedrab: 7048739,
    orange: 16753920,
    orangered: 16729344,
    orchid: 14315734,
    palegoldenrod: 15657130,
    palegreen: 10025880,
    paleturquoise: 11529966,
    palevioletred: 14381203,
    papayawhip: 16773077,
    peachpuff: 16767673,
    peru: 13468991,
    pink: 16761035,
    plum: 14524637,
    powderblue: 11591910,
    purple: 8388736,
    rebeccapurple: 6697881,
    red: 16711680,
    rosybrown: 12357519,
    royalblue: 4286945,
    saddlebrown: 9127187,
    salmon: 16416882,
    sandybrown: 16032864,
    seagreen: 3050327,
    seashell: 16774638,
    sienna: 10506797,
    silver: 12632256,
    skyblue: 8900331,
    slateblue: 6970061,
    slategray: 7372944,
    slategrey: 7372944,
    snow: 16775930,
    springgreen: 65407,
    steelblue: 4620980,
    tan: 13808780,
    teal: 32896,
    thistle: 14204888,
    tomato: 16737095,
    turquoise: 4251856,
    violet: 15631086,
    wheat: 16113331,
    white: 16777215,
    whitesmoke: 16119285,
    yellow: 16776960,
    yellowgreen: 10145074
  });
  d3_rgb_names.forEach(function(key, value) {
    d3_rgb_names.set(key, d3_rgbNumber(value));
  });
  function d3_functor(v) {
    return typeof v === "function" ? v : function() {
      return v;
    };
  }
  d3.functor = d3_functor;
  d3.xhr = d3_xhrType(d3_identity);
  function d3_xhrType(response) {
    return function(url, mimeType, callback) {
      if (arguments.length === 2 && typeof mimeType === "function") callback = mimeType, 
      mimeType = null;
      return d3_xhr(url, mimeType, response, callback);
    };
  }
  function d3_xhr(url, mimeType, response, callback) {
    var xhr = {}, dispatch = d3.dispatch("beforesend", "progress", "load", "error"), headers = {}, request = new XMLHttpRequest(), responseType = null;
    if (self.XDomainRequest && !("withCredentials" in request) && /^(http(s)?:)?\/\//.test(url)) request = new XDomainRequest();
    "onload" in request ? request.onload = request.onerror = respond : request.onreadystatechange = function() {
      request.readyState > 3 && respond();
    };
    function respond() {
      var status = request.status, result;
      if (!status && d3_xhrHasResponse(request) || status >= 200 && status < 300 || status === 304) {
        try {
          result = response.call(xhr, request);
        } catch (e) {
          dispatch.error.call(xhr, e);
          return;
        }
        dispatch.load.call(xhr, result);
      } else {
        dispatch.error.call(xhr, request);
      }
    }
    request.onprogress = function(event) {
      var o = d3.event;
      d3.event = event;
      try {
        dispatch.progress.call(xhr, request);
      } finally {
        d3.event = o;
      }
    };
    xhr.header = function(name, value) {
      name = (name + "").toLowerCase();
      if (arguments.length < 2) return headers[name];
      if (value == null) delete headers[name]; else headers[name] = value + "";
      return xhr;
    };
    xhr.mimeType = function(value) {
      if (!arguments.length) return mimeType;
      mimeType = value == null ? null : value + "";
      return xhr;
    };
    xhr.responseType = function(value) {
      if (!arguments.length) return responseType;
      responseType = value;
      return xhr;
    };
    xhr.response = function(value) {
      response = value;
      return xhr;
    };
    [ "get", "post" ].forEach(function(method) {
      xhr[method] = function() {
        return xhr.send.apply(xhr, [ method ].concat(d3_array(arguments)));
      };
    });
    xhr.send = function(method, data, callback) {
      if (arguments.length === 2 && typeof data === "function") callback = data, data = null;
      request.open(method, url, true);
      if (mimeType != null && !("accept" in headers)) headers["accept"] = mimeType + ",*/*";
      if (request.setRequestHeader) for (var name in headers) request.setRequestHeader(name, headers[name]);
      if (mimeType != null && request.overrideMimeType) request.overrideMimeType(mimeType);
      if (responseType != null) request.responseType = responseType;
      if (callback != null) xhr.on("error", callback).on("load", function(request) {
        callback(null, request);
      });
      dispatch.beforesend.call(xhr, request);
      request.send(data == null ? null : data);
      return xhr;
    };
    xhr.abort = function() {
      request.abort();
      return xhr;
    };
    d3.rebind(xhr, dispatch, "on");
    return callback == null ? xhr : xhr.get(d3_xhr_fixCallback(callback));
  }
  function d3_xhr_fixCallback(callback) {
    return callback.length === 1 ? function(error, request) {
      callback(error == null ? request : null);
    } : callback;
  }
  function d3_xhrHasResponse(request) {
    var type = request.responseType;
    return type && type !== "text" ? request.response : request.responseText;
  }
  d3.dsv = function(delimiter, mimeType) {
    var reFormat = new RegExp('["' + delimiter + "\n]"), delimiterCode = delimiter.charCodeAt(0);
    function dsv(url, row, callback) {
      if (arguments.length < 3) callback = row, row = null;
      var xhr = d3_xhr(url, mimeType, row == null ? response : typedResponse(row), callback);
      xhr.row = function(_) {
        return arguments.length ? xhr.response((row = _) == null ? response : typedResponse(_)) : row;
      };
      return xhr;
    }
    function response(request) {
      return dsv.parse(request.responseText);
    }
    function typedResponse(f) {
      return function(request) {
        return dsv.parse(request.responseText, f);
      };
    }
    dsv.parse = function(text, f) {
      var o;
      return dsv.parseRows(text, function(row, i) {
        if (o) return o(row, i - 1);
        var a = function(d) {
          var obj = {};
          var len = row.length;
          for (var k = 0; k < len; ++k) {
            obj[row[k]] = d[k];
          }
          return obj;
        };
        o = f ? function(row, i) {
          return f(a(row), i);
        } : a;
      });
    };
    dsv.parseRows = function(text, f) {
      var EOL = {}, EOF = {}, rows = [], N = text.length, I = 0, n = 0, t, eol;
      function token() {
        if (I >= N) return EOF;
        if (eol) return eol = false, EOL;
        var j = I;
        if (text.charCodeAt(j) === 34) {
          var i = j;
          while (i++ < N) {
            if (text.charCodeAt(i) === 34) {
              if (text.charCodeAt(i + 1) !== 34) break;
              ++i;
            }
          }
          I = i + 2;
          var c = text.charCodeAt(i + 1);
          if (c === 13) {
            eol = true;
            if (text.charCodeAt(i + 2) === 10) ++I;
          } else if (c === 10) {
            eol = true;
          }
          return text.slice(j + 1, i).replace(/""/g, '"');
        }
        while (I < N) {
          var c = text.charCodeAt(I++), k = 1;
          if (c === 10) eol = true; else if (c === 13) {
            eol = true;
            if (text.charCodeAt(I) === 10) ++I, ++k;
          } else if (c !== delimiterCode) continue;
          return text.slice(j, I - k);
        }
        return text.slice(j);
      }
      while ((t = token()) !== EOF) {
        var a = [];
        while (t !== EOL && t !== EOF) {
          a.push(t);
          t = token();
        }
        if (f && (a = f(a, n++)) == null) continue;
        rows.push(a);
      }
      return rows;
    };
    dsv.format = function(rows) {
      if (Array.isArray(rows[0])) return dsv.formatRows(rows);
      var fieldSet = new d3_Set(), fields = [];
      rows.forEach(function(row) {
        for (var field in row) {
          if (!fieldSet.has(field)) {
            fields.push(fieldSet.add(field));
          }
        }
      });
      return [ fields.map(formatValue).join(delimiter) ].concat(rows.map(function(row) {
        return fields.map(function(field) {
          return formatValue(row[field]);
        }).join(delimiter);
      })).join("\n");
    };
    dsv.formatRows = function(rows) {
      return rows.map(formatRow).join("\n");
    };
    function formatRow(row) {
      return row.map(formatValue).join(delimiter);
    }
    function formatValue(text) {
      return reFormat.test(text) ? '"' + text.replace(/\"/g, '""') + '"' : text;
    }
    return dsv;
  };
  d3.csv = d3.dsv(",", "text/csv");
  d3.tsv = d3.dsv("	", "text/tab-separated-values");
  var d3_timer_queueHead, d3_timer_queueTail, d3_timer_interval, d3_timer_timeout, d3_timer_frame = this[d3_vendorSymbol(this, "requestAnimationFrame")] || function(callback) {
    setTimeout(callback, 17);
  };
  d3.timer = function() {
    d3_timer.apply(this, arguments);
  };
  function d3_timer(callback, delay, then) {
    var n = arguments.length;
    if (n < 2) delay = 0;
    if (n < 3) then = Date.now();
    var time = then + delay, timer = {
      c: callback,
      t: time,
      n: null
    };
    if (d3_timer_queueTail) d3_timer_queueTail.n = timer; else d3_timer_queueHead = timer;
    d3_timer_queueTail = timer;
    if (!d3_timer_interval) {
      d3_timer_timeout = clearTimeout(d3_timer_timeout);
      d3_timer_interval = 1;
      d3_timer_frame(d3_timer_step);
    }
    return timer;
  }
  function d3_timer_step() {
    var now = d3_timer_mark(), delay = d3_timer_sweep() - now;
    if (delay > 24) {
      if (isFinite(delay)) {
        clearTimeout(d3_timer_timeout);
        d3_timer_timeout = setTimeout(d3_timer_step, delay);
      }
      d3_timer_interval = 0;
    } else {
      d3_timer_interval = 1;
      d3_timer_frame(d3_timer_step);
    }
  }
  d3.timer.flush = function() {
    d3_timer_mark();
    d3_timer_sweep();
  };
  function d3_timer_mark() {
    var now = Date.now(), timer = d3_timer_queueHead;
    while (timer) {
      if (now >= timer.t && timer.c(now - timer.t)) timer.c = null;
      timer = timer.n;
    }
    return now;
  }
  function d3_timer_sweep() {
    var t0, t1 = d3_timer_queueHead, time = Infinity;
    while (t1) {
      if (t1.c) {
        if (t1.t < time) time = t1.t;
        t1 = (t0 = t1).n;
      } else {
        t1 = t0 ? t0.n = t1.n : d3_timer_queueHead = t1.n;
      }
    }
    d3_timer_queueTail = t0;
    return time;
  }
  d3.round = function(x, n) {
    return n ? Math.round(x * (n = Math.pow(10, n))) / n : Math.round(x);
  };
  d3.geom = {};
  function d3_geom_pointX(d) {
    return d[0];
  }
  function d3_geom_pointY(d) {
    return d[1];
  }
  d3.geom.hull = function(vertices) {
    var x = d3_geom_pointX, y = d3_geom_pointY;
    if (arguments.length) return hull(vertices);
    function hull(data) {
      if (data.length < 3) return [];
      var fx = d3_functor(x), fy = d3_functor(y), i, n = data.length, points = [], flippedPoints = [];
      for (i = 0; i < n; i++) {
        points.push([ +fx.call(this, data[i], i), +fy.call(this, data[i], i), i ]);
      }
      points.sort(d3_geom_hullOrder);
      for (i = 0; i < n; i++) flippedPoints.push([ points[i][0], -points[i][1] ]);
      var upper = d3_geom_hullUpper(points), lower = d3_geom_hullUpper(flippedPoints);
      var skipLeft = lower[0] === upper[0], skipRight = lower[lower.length - 1] === upper[upper.length - 1], polygon = [];
      for (i = upper.length - 1; i >= 0; --i) polygon.push(data[points[upper[i]][2]]);
      for (i = +skipLeft; i < lower.length - skipRight; ++i) polygon.push(data[points[lower[i]][2]]);
      return polygon;
    }
    hull.x = function(_) {
      return arguments.length ? (x = _, hull) : x;
    };
    hull.y = function(_) {
      return arguments.length ? (y = _, hull) : y;
    };
    return hull;
  };
  function d3_geom_hullUpper(points) {
    var n = points.length, hull = [ 0, 1 ], hs = 2;
    for (var i = 2; i < n; i++) {
      while (hs > 1 && d3_cross2d(points[hull[hs - 2]], points[hull[hs - 1]], points[i]) <= 0) --hs;
      hull[hs++] = i;
    }
    return hull.slice(0, hs);
  }
  function d3_geom_hullOrder(a, b) {
    return a[0] - b[0] || a[1] - b[1];
  }
  d3.geom.polygon = function(coordinates) {
    d3_subclass(coordinates, d3_geom_polygonPrototype);
    return coordinates;
  };
  var d3_geom_polygonPrototype = d3.geom.polygon.prototype = [];
  d3_geom_polygonPrototype.area = function() {
    var i = -1, n = this.length, a, b = this[n - 1], area = 0;
    while (++i < n) {
      a = b;
      b = this[i];
      area += a[1] * b[0] - a[0] * b[1];
    }
    return area * .5;
  };
  d3_geom_polygonPrototype.centroid = function(k) {
    var i = -1, n = this.length, x = 0, y = 0, a, b = this[n - 1], c;
    if (!arguments.length) k = -1 / (6 * this.area());
    while (++i < n) {
      a = b;
      b = this[i];
      c = a[0] * b[1] - b[0] * a[1];
      x += (a[0] + b[0]) * c;
      y += (a[1] + b[1]) * c;
    }
    return [ x * k, y * k ];
  };
  d3_geom_polygonPrototype.clip = function(subject) {
    var input, closed = d3_geom_polygonClosed(subject), i = -1, n = this.length - d3_geom_polygonClosed(this), j, m, a = this[n - 1], b, c, d;
    while (++i < n) {
      input = subject.slice();
      subject.length = 0;
      b = this[i];
      c = input[(m = input.length - closed) - 1];
      j = -1;
      while (++j < m) {
        d = input[j];
        if (d3_geom_polygonInside(d, a, b)) {
          if (!d3_geom_polygonInside(c, a, b)) {
            subject.push(d3_geom_polygonIntersect(c, d, a, b));
          }
          subject.push(d);
        } else if (d3_geom_polygonInside(c, a, b)) {
          subject.push(d3_geom_polygonIntersect(c, d, a, b));
        }
        c = d;
      }
      if (closed) subject.push(subject[0]);
      a = b;
    }
    return subject;
  };
  function d3_geom_polygonInside(p, a, b) {
    return (b[0] - a[0]) * (p[1] - a[1]) < (b[1] - a[1]) * (p[0] - a[0]);
  }
  function d3_geom_polygonIntersect(c, d, a, b) {
    var x1 = c[0], x3 = a[0], x21 = d[0] - x1, x43 = b[0] - x3, y1 = c[1], y3 = a[1], y21 = d[1] - y1, y43 = b[1] - y3, ua = (x43 * (y1 - y3) - y43 * (x1 - x3)) / (y43 * x21 - x43 * y21);
    return [ x1 + ua * x21, y1 + ua * y21 ];
  }
  function d3_geom_polygonClosed(coordinates) {
    var a = coordinates[0], b = coordinates[coordinates.length - 1];
    return !(a[0] - b[0] || a[1] - b[1]);
  }
  var d3_geom_voronoiEdges, d3_geom_voronoiCells, d3_geom_voronoiBeaches, d3_geom_voronoiBeachPool = [], d3_geom_voronoiFirstCircle, d3_geom_voronoiCircles, d3_geom_voronoiCirclePool = [];
  function d3_geom_voronoiBeach() {
    d3_geom_voronoiRedBlackNode(this);
    this.edge = this.site = this.circle = null;
  }
  function d3_geom_voronoiCreateBeach(site) {
    var beach = d3_geom_voronoiBeachPool.pop() || new d3_geom_voronoiBeach();
    beach.site = site;
    return beach;
  }
  function d3_geom_voronoiDetachBeach(beach) {
    d3_geom_voronoiDetachCircle(beach);
    d3_geom_voronoiBeaches.remove(beach);
    d3_geom_voronoiBeachPool.push(beach);
    d3_geom_voronoiRedBlackNode(beach);
  }
  function d3_geom_voronoiRemoveBeach(beach) {
    var circle = beach.circle, x = circle.x, y = circle.cy, vertex = {
      x: x,
      y: y
    }, previous = beach.P, next = beach.N, disappearing = [ beach ];
    d3_geom_voronoiDetachBeach(beach);
    var lArc = previous;
    while (lArc.circle && abs(x - lArc.circle.x) < ε && abs(y - lArc.circle.cy) < ε) {
      previous = lArc.P;
      disappearing.unshift(lArc);
      d3_geom_voronoiDetachBeach(lArc);
      lArc = previous;
    }
    disappearing.unshift(lArc);
    d3_geom_voronoiDetachCircle(lArc);
    var rArc = next;
    while (rArc.circle && abs(x - rArc.circle.x) < ε && abs(y - rArc.circle.cy) < ε) {
      next = rArc.N;
      disappearing.push(rArc);
      d3_geom_voronoiDetachBeach(rArc);
      rArc = next;
    }
    disappearing.push(rArc);
    d3_geom_voronoiDetachCircle(rArc);
    var nArcs = disappearing.length, iArc;
    for (iArc = 1; iArc < nArcs; ++iArc) {
      rArc = disappearing[iArc];
      lArc = disappearing[iArc - 1];
      d3_geom_voronoiSetEdgeEnd(rArc.edge, lArc.site, rArc.site, vertex);
    }
    lArc = disappearing[0];
    rArc = disappearing[nArcs - 1];
    rArc.edge = d3_geom_voronoiCreateEdge(lArc.site, rArc.site, null, vertex);
    d3_geom_voronoiAttachCircle(lArc);
    d3_geom_voronoiAttachCircle(rArc);
  }
  function d3_geom_voronoiAddBeach(site) {
    var x = site.x, directrix = site.y, lArc, rArc, dxl, dxr, node = d3_geom_voronoiBeaches._;
    while (node) {
      dxl = d3_geom_voronoiLeftBreakPoint(node, directrix) - x;
      if (dxl > ε) node = node.L; else {
        dxr = x - d3_geom_voronoiRightBreakPoint(node, directrix);
        if (dxr > ε) {
          if (!node.R) {
            lArc = node;
            break;
          }
          node = node.R;
        } else {
          if (dxl > -ε) {
            lArc = node.P;
            rArc = node;
          } else if (dxr > -ε) {
            lArc = node;
            rArc = node.N;
          } else {
            lArc = rArc = node;
          }
          break;
        }
      }
    }
    var newArc = d3_geom_voronoiCreateBeach(site);
    d3_geom_voronoiBeaches.insert(lArc, newArc);
    if (!lArc && !rArc) return;
    if (lArc === rArc) {
      d3_geom_voronoiDetachCircle(lArc);
      rArc = d3_geom_voronoiCreateBeach(lArc.site);
      d3_geom_voronoiBeaches.insert(newArc, rArc);
      newArc.edge = rArc.edge = d3_geom_voronoiCreateEdge(lArc.site, newArc.site);
      d3_geom_voronoiAttachCircle(lArc);
      d3_geom_voronoiAttachCircle(rArc);
      return;
    }
    if (!rArc) {
      newArc.edge = d3_geom_voronoiCreateEdge(lArc.site, newArc.site);
      return;
    }
    d3_geom_voronoiDetachCircle(lArc);
    d3_geom_voronoiDetachCircle(rArc);
    var lSite = lArc.site, ax = lSite.x, ay = lSite.y, bx = site.x - ax, by = site.y - ay, rSite = rArc.site, cx = rSite.x - ax, cy = rSite.y - ay, d = 2 * (bx * cy - by * cx), hb = bx * bx + by * by, hc = cx * cx + cy * cy, vertex = {
      x: (cy * hb - by * hc) / d + ax,
      y: (bx * hc - cx * hb) / d + ay
    };
    d3_geom_voronoiSetEdgeEnd(rArc.edge, lSite, rSite, vertex);
    newArc.edge = d3_geom_voronoiCreateEdge(lSite, site, null, vertex);
    rArc.edge = d3_geom_voronoiCreateEdge(site, rSite, null, vertex);
    d3_geom_voronoiAttachCircle(lArc);
    d3_geom_voronoiAttachCircle(rArc);
  }
  function d3_geom_voronoiLeftBreakPoint(arc, directrix) {
    var site = arc.site, rfocx = site.x, rfocy = site.y, pby2 = rfocy - directrix;
    if (!pby2) return rfocx;
    var lArc = arc.P;
    if (!lArc) return -Infinity;
    site = lArc.site;
    var lfocx = site.x, lfocy = site.y, plby2 = lfocy - directrix;
    if (!plby2) return lfocx;
    var hl = lfocx - rfocx, aby2 = 1 / pby2 - 1 / plby2, b = hl / plby2;
    if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;
    return (rfocx + lfocx) / 2;
  }
  function d3_geom_voronoiRightBreakPoint(arc, directrix) {
    var rArc = arc.N;
    if (rArc) return d3_geom_voronoiLeftBreakPoint(rArc, directrix);
    var site = arc.site;
    return site.y === directrix ? site.x : Infinity;
  }
  function d3_geom_voronoiCell(site) {
    this.site = site;
    this.edges = [];
  }
  d3_geom_voronoiCell.prototype.prepare = function() {
    var halfEdges = this.edges, iHalfEdge = halfEdges.length, edge;
    while (iHalfEdge--) {
      edge = halfEdges[iHalfEdge].edge;
      if (!edge.b || !edge.a) halfEdges.splice(iHalfEdge, 1);
    }
    halfEdges.sort(d3_geom_voronoiHalfEdgeOrder);
    return halfEdges.length;
  };
  function d3_geom_voronoiCloseCells(extent) {
    var x0 = extent[0][0], x1 = extent[1][0], y0 = extent[0][1], y1 = extent[1][1], x2, y2, x3, y3, cells = d3_geom_voronoiCells, iCell = cells.length, cell, iHalfEdge, halfEdges, nHalfEdges, start, end;
    while (iCell--) {
      cell = cells[iCell];
      if (!cell || !cell.prepare()) continue;
      halfEdges = cell.edges;
      nHalfEdges = halfEdges.length;
      iHalfEdge = 0;
      while (iHalfEdge < nHalfEdges) {
        end = halfEdges[iHalfEdge].end(), x3 = end.x, y3 = end.y;
        start = halfEdges[++iHalfEdge % nHalfEdges].start(), x2 = start.x, y2 = start.y;
        if (abs(x3 - x2) > ε || abs(y3 - y2) > ε) {
          halfEdges.splice(iHalfEdge, 0, new d3_geom_voronoiHalfEdge(d3_geom_voronoiCreateBorderEdge(cell.site, end, abs(x3 - x0) < ε && y1 - y3 > ε ? {
            x: x0,
            y: abs(x2 - x0) < ε ? y2 : y1
          } : abs(y3 - y1) < ε && x1 - x3 > ε ? {
            x: abs(y2 - y1) < ε ? x2 : x1,
            y: y1
          } : abs(x3 - x1) < ε && y3 - y0 > ε ? {
            x: x1,
            y: abs(x2 - x1) < ε ? y2 : y0
          } : abs(y3 - y0) < ε && x3 - x0 > ε ? {
            x: abs(y2 - y0) < ε ? x2 : x0,
            y: y0
          } : null), cell.site, null));
          ++nHalfEdges;
        }
      }
    }
  }
  function d3_geom_voronoiHalfEdgeOrder(a, b) {
    return b.angle - a.angle;
  }
  function d3_geom_voronoiCircle() {
    d3_geom_voronoiRedBlackNode(this);
    this.x = this.y = this.arc = this.site = this.cy = null;
  }
  function d3_geom_voronoiAttachCircle(arc) {
    var lArc = arc.P, rArc = arc.N;
    if (!lArc || !rArc) return;
    var lSite = lArc.site, cSite = arc.site, rSite = rArc.site;
    if (lSite === rSite) return;
    var bx = cSite.x, by = cSite.y, ax = lSite.x - bx, ay = lSite.y - by, cx = rSite.x - bx, cy = rSite.y - by;
    var d = 2 * (ax * cy - ay * cx);
    if (d >= -ε2) return;
    var ha = ax * ax + ay * ay, hc = cx * cx + cy * cy, x = (cy * ha - ay * hc) / d, y = (ax * hc - cx * ha) / d, cy = y + by;
    var circle = d3_geom_voronoiCirclePool.pop() || new d3_geom_voronoiCircle();
    circle.arc = arc;
    circle.site = cSite;
    circle.x = x + bx;
    circle.y = cy + Math.sqrt(x * x + y * y);
    circle.cy = cy;
    arc.circle = circle;
    var before = null, node = d3_geom_voronoiCircles._;
    while (node) {
      if (circle.y < node.y || circle.y === node.y && circle.x <= node.x) {
        if (node.L) node = node.L; else {
          before = node.P;
          break;
        }
      } else {
        if (node.R) node = node.R; else {
          before = node;
          break;
        }
      }
    }
    d3_geom_voronoiCircles.insert(before, circle);
    if (!before) d3_geom_voronoiFirstCircle = circle;
  }
  function d3_geom_voronoiDetachCircle(arc) {
    var circle = arc.circle;
    if (circle) {
      if (!circle.P) d3_geom_voronoiFirstCircle = circle.N;
      d3_geom_voronoiCircles.remove(circle);
      d3_geom_voronoiCirclePool.push(circle);
      d3_geom_voronoiRedBlackNode(circle);
      arc.circle = null;
    }
  }
  function d3_geom_clipLine(x0, y0, x1, y1) {
    return function(line) {
      var a = line.a, b = line.b, ax = a.x, ay = a.y, bx = b.x, by = b.y, t0 = 0, t1 = 1, dx = bx - ax, dy = by - ay, r;
      r = x0 - ax;
      if (!dx && r > 0) return;
      r /= dx;
      if (dx < 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
      } else if (dx > 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
      }
      r = x1 - ax;
      if (!dx && r < 0) return;
      r /= dx;
      if (dx < 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
      } else if (dx > 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
      }
      r = y0 - ay;
      if (!dy && r > 0) return;
      r /= dy;
      if (dy < 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
      } else if (dy > 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
      }
      r = y1 - ay;
      if (!dy && r < 0) return;
      r /= dy;
      if (dy < 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
      } else if (dy > 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
      }
      if (t0 > 0) line.a = {
        x: ax + t0 * dx,
        y: ay + t0 * dy
      };
      if (t1 < 1) line.b = {
        x: ax + t1 * dx,
        y: ay + t1 * dy
      };
      return line;
    };
  }
  function d3_geom_voronoiClipEdges(extent) {
    var edges = d3_geom_voronoiEdges, clip = d3_geom_clipLine(extent[0][0], extent[0][1], extent[1][0], extent[1][1]), i = edges.length, e;
    while (i--) {
      e = edges[i];
      if (!d3_geom_voronoiConnectEdge(e, extent) || !clip(e) || abs(e.a.x - e.b.x) < ε && abs(e.a.y - e.b.y) < ε) {
        e.a = e.b = null;
        edges.splice(i, 1);
      }
    }
  }
  function d3_geom_voronoiConnectEdge(edge, extent) {
    var vb = edge.b;
    if (vb) return true;
    var va = edge.a, x0 = extent[0][0], x1 = extent[1][0], y0 = extent[0][1], y1 = extent[1][1], lSite = edge.l, rSite = edge.r, lx = lSite.x, ly = lSite.y, rx = rSite.x, ry = rSite.y, fx = (lx + rx) / 2, fy = (ly + ry) / 2, fm, fb;
    if (ry === ly) {
      if (fx < x0 || fx >= x1) return;
      if (lx > rx) {
        if (!va) va = {
          x: fx,
          y: y0
        }; else if (va.y >= y1) return;
        vb = {
          x: fx,
          y: y1
        };
      } else {
        if (!va) va = {
          x: fx,
          y: y1
        }; else if (va.y < y0) return;
        vb = {
          x: fx,
          y: y0
        };
      }
    } else {
      fm = (lx - rx) / (ry - ly);
      fb = fy - fm * fx;
      if (fm < -1 || fm > 1) {
        if (lx > rx) {
          if (!va) va = {
            x: (y0 - fb) / fm,
            y: y0
          }; else if (va.y >= y1) return;
          vb = {
            x: (y1 - fb) / fm,
            y: y1
          };
        } else {
          if (!va) va = {
            x: (y1 - fb) / fm,
            y: y1
          }; else if (va.y < y0) return;
          vb = {
            x: (y0 - fb) / fm,
            y: y0
          };
        }
      } else {
        if (ly < ry) {
          if (!va) va = {
            x: x0,
            y: fm * x0 + fb
          }; else if (va.x >= x1) return;
          vb = {
            x: x1,
            y: fm * x1 + fb
          };
        } else {
          if (!va) va = {
            x: x1,
            y: fm * x1 + fb
          }; else if (va.x < x0) return;
          vb = {
            x: x0,
            y: fm * x0 + fb
          };
        }
      }
    }
    edge.a = va;
    edge.b = vb;
    return true;
  }
  function d3_geom_voronoiEdge(lSite, rSite) {
    this.l = lSite;
    this.r = rSite;
    this.a = this.b = null;
  }
  function d3_geom_voronoiCreateEdge(lSite, rSite, va, vb) {
    var edge = new d3_geom_voronoiEdge(lSite, rSite);
    d3_geom_voronoiEdges.push(edge);
    if (va) d3_geom_voronoiSetEdgeEnd(edge, lSite, rSite, va);
    if (vb) d3_geom_voronoiSetEdgeEnd(edge, rSite, lSite, vb);
    d3_geom_voronoiCells[lSite.i].edges.push(new d3_geom_voronoiHalfEdge(edge, lSite, rSite));
    d3_geom_voronoiCells[rSite.i].edges.push(new d3_geom_voronoiHalfEdge(edge, rSite, lSite));
    return edge;
  }
  function d3_geom_voronoiCreateBorderEdge(lSite, va, vb) {
    var edge = new d3_geom_voronoiEdge(lSite, null);
    edge.a = va;
    edge.b = vb;
    d3_geom_voronoiEdges.push(edge);
    return edge;
  }
  function d3_geom_voronoiSetEdgeEnd(edge, lSite, rSite, vertex) {
    if (!edge.a && !edge.b) {
      edge.a = vertex;
      edge.l = lSite;
      edge.r = rSite;
    } else if (edge.l === rSite) {
      edge.b = vertex;
    } else {
      edge.a = vertex;
    }
  }
  function d3_geom_voronoiHalfEdge(edge, lSite, rSite) {
    var va = edge.a, vb = edge.b;
    this.edge = edge;
    this.site = lSite;
    this.angle = rSite ? Math.atan2(rSite.y - lSite.y, rSite.x - lSite.x) : edge.l === lSite ? Math.atan2(vb.x - va.x, va.y - vb.y) : Math.atan2(va.x - vb.x, vb.y - va.y);
  }
  d3_geom_voronoiHalfEdge.prototype = {
    start: function() {
      return this.edge.l === this.site ? this.edge.a : this.edge.b;
    },
    end: function() {
      return this.edge.l === this.site ? this.edge.b : this.edge.a;
    }
  };
  function d3_geom_voronoiRedBlackTree() {
    this._ = null;
  }
  function d3_geom_voronoiRedBlackNode(node) {
    node.U = node.C = node.L = node.R = node.P = node.N = null;
  }
  d3_geom_voronoiRedBlackTree.prototype = {
    insert: function(after, node) {
      var parent, grandpa, uncle;
      if (after) {
        node.P = after;
        node.N = after.N;
        if (after.N) after.N.P = node;
        after.N = node;
        if (after.R) {
          after = after.R;
          while (after.L) after = after.L;
          after.L = node;
        } else {
          after.R = node;
        }
        parent = after;
      } else if (this._) {
        after = d3_geom_voronoiRedBlackFirst(this._);
        node.P = null;
        node.N = after;
        after.P = after.L = node;
        parent = after;
      } else {
        node.P = node.N = null;
        this._ = node;
        parent = null;
      }
      node.L = node.R = null;
      node.U = parent;
      node.C = true;
      after = node;
      while (parent && parent.C) {
        grandpa = parent.U;
        if (parent === grandpa.L) {
          uncle = grandpa.R;
          if (uncle && uncle.C) {
            parent.C = uncle.C = false;
            grandpa.C = true;
            after = grandpa;
          } else {
            if (after === parent.R) {
              d3_geom_voronoiRedBlackRotateLeft(this, parent);
              after = parent;
              parent = after.U;
            }
            parent.C = false;
            grandpa.C = true;
            d3_geom_voronoiRedBlackRotateRight(this, grandpa);
          }
        } else {
          uncle = grandpa.L;
          if (uncle && uncle.C) {
            parent.C = uncle.C = false;
            grandpa.C = true;
            after = grandpa;
          } else {
            if (after === parent.L) {
              d3_geom_voronoiRedBlackRotateRight(this, parent);
              after = parent;
              parent = after.U;
            }
            parent.C = false;
            grandpa.C = true;
            d3_geom_voronoiRedBlackRotateLeft(this, grandpa);
          }
        }
        parent = after.U;
      }
      this._.C = false;
    },
    remove: function(node) {
      if (node.N) node.N.P = node.P;
      if (node.P) node.P.N = node.N;
      node.N = node.P = null;
      var parent = node.U, sibling, left = node.L, right = node.R, next, red;
      if (!left) next = right; else if (!right) next = left; else next = d3_geom_voronoiRedBlackFirst(right);
      if (parent) {
        if (parent.L === node) parent.L = next; else parent.R = next;
      } else {
        this._ = next;
      }
      if (left && right) {
        red = next.C;
        next.C = node.C;
        next.L = left;
        left.U = next;
        if (next !== right) {
          parent = next.U;
          next.U = node.U;
          node = next.R;
          parent.L = node;
          next.R = right;
          right.U = next;
        } else {
          next.U = parent;
          parent = next;
          node = next.R;
        }
      } else {
        red = node.C;
        node = next;
      }
      if (node) node.U = parent;
      if (red) return;
      if (node && node.C) {
        node.C = false;
        return;
      }
      do {
        if (node === this._) break;
        if (node === parent.L) {
          sibling = parent.R;
          if (sibling.C) {
            sibling.C = false;
            parent.C = true;
            d3_geom_voronoiRedBlackRotateLeft(this, parent);
            sibling = parent.R;
          }
          if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
            if (!sibling.R || !sibling.R.C) {
              sibling.L.C = false;
              sibling.C = true;
              d3_geom_voronoiRedBlackRotateRight(this, sibling);
              sibling = parent.R;
            }
            sibling.C = parent.C;
            parent.C = sibling.R.C = false;
            d3_geom_voronoiRedBlackRotateLeft(this, parent);
            node = this._;
            break;
          }
        } else {
          sibling = parent.L;
          if (sibling.C) {
            sibling.C = false;
            parent.C = true;
            d3_geom_voronoiRedBlackRotateRight(this, parent);
            sibling = parent.L;
          }
          if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
            if (!sibling.L || !sibling.L.C) {
              sibling.R.C = false;
              sibling.C = true;
              d3_geom_voronoiRedBlackRotateLeft(this, sibling);
              sibling = parent.L;
            }
            sibling.C = parent.C;
            parent.C = sibling.L.C = false;
            d3_geom_voronoiRedBlackRotateRight(this, parent);
            node = this._;
            break;
          }
        }
        sibling.C = true;
        node = parent;
        parent = parent.U;
      } while (!node.C);
      if (node) node.C = false;
    }
  };
  function d3_geom_voronoiRedBlackRotateLeft(tree, node) {
    var p = node, q = node.R, parent = p.U;
    if (parent) {
      if (parent.L === p) parent.L = q; else parent.R = q;
    } else {
      tree._ = q;
    }
    q.U = parent;
    p.U = q;
    p.R = q.L;
    if (p.R) p.R.U = p;
    q.L = p;
  }
  function d3_geom_voronoiRedBlackRotateRight(tree, node) {
    var p = node, q = node.L, parent = p.U;
    if (parent) {
      if (parent.L === p) parent.L = q; else parent.R = q;
    } else {
      tree._ = q;
    }
    q.U = parent;
    p.U = q;
    p.L = q.R;
    if (p.L) p.L.U = p;
    q.R = p;
  }
  function d3_geom_voronoiRedBlackFirst(node) {
    while (node.L) node = node.L;
    return node;
  }
  function d3_geom_voronoi(sites, bbox) {
    var site = sites.sort(d3_geom_voronoiVertexOrder).pop(), x0, y0, circle;
    d3_geom_voronoiEdges = [];
    d3_geom_voronoiCells = new Array(sites.length);
    d3_geom_voronoiBeaches = new d3_geom_voronoiRedBlackTree();
    d3_geom_voronoiCircles = new d3_geom_voronoiRedBlackTree();
    while (true) {
      circle = d3_geom_voronoiFirstCircle;
      if (site && (!circle || site.y < circle.y || site.y === circle.y && site.x < circle.x)) {
        if (site.x !== x0 || site.y !== y0) {
          d3_geom_voronoiCells[site.i] = new d3_geom_voronoiCell(site);
          d3_geom_voronoiAddBeach(site);
          x0 = site.x, y0 = site.y;
        }
        site = sites.pop();
      } else if (circle) {
        d3_geom_voronoiRemoveBeach(circle.arc);
      } else {
        break;
      }
    }
    if (bbox) d3_geom_voronoiClipEdges(bbox), d3_geom_voronoiCloseCells(bbox);
    var diagram = {
      cells: d3_geom_voronoiCells,
      edges: d3_geom_voronoiEdges
    };
    d3_geom_voronoiBeaches = d3_geom_voronoiCircles = d3_geom_voronoiEdges = d3_geom_voronoiCells = null;
    return diagram;
  }
  function d3_geom_voronoiVertexOrder(a, b) {
    return b.y - a.y || b.x - a.x;
  }
  d3.geom.voronoi = function(points) {
    var x = d3_geom_pointX, y = d3_geom_pointY, fx = x, fy = y, clipExtent = d3_geom_voronoiClipExtent;
    if (points) return voronoi(points);
    function voronoi(data) {
      var polygons = new Array(data.length), x0 = clipExtent[0][0], y0 = clipExtent[0][1], x1 = clipExtent[1][0], y1 = clipExtent[1][1];
      d3_geom_voronoi(sites(data), clipExtent).cells.forEach(function(cell, i) {
        var edges = cell.edges, site = cell.site, polygon = polygons[i] = edges.length ? edges.map(function(e) {
          var s = e.start();
          return [ s.x, s.y ];
        }) : site.x >= x0 && site.x <= x1 && site.y >= y0 && site.y <= y1 ? [ [ x0, y1 ], [ x1, y1 ], [ x1, y0 ], [ x0, y0 ] ] : [];
        polygon.point = data[i];
      });
      return polygons;
    }
    function sites(data) {
      return data.map(function(d, i) {
        return {
          x: Math.round(fx(d, i) / ε) * ε,
          y: Math.round(fy(d, i) / ε) * ε,
          i: i
        };
      });
    }
    voronoi.links = function(data) {
      return d3_geom_voronoi(sites(data)).edges.filter(function(edge) {
        return edge.l && edge.r;
      }).map(function(edge) {
        return {
          source: data[edge.l.i],
          target: data[edge.r.i]
        };
      });
    };
    voronoi.triangles = function(data) {
      var triangles = [];
      d3_geom_voronoi(sites(data)).cells.forEach(function(cell, i) {
        var site = cell.site, edges = cell.edges.sort(d3_geom_voronoiHalfEdgeOrder), j = -1, m = edges.length, e0, s0, e1 = edges[m - 1].edge, s1 = e1.l === site ? e1.r : e1.l;
        while (++j < m) {
          e0 = e1;
          s0 = s1;
          e1 = edges[j].edge;
          s1 = e1.l === site ? e1.r : e1.l;
          if (i < s0.i && i < s1.i && d3_geom_voronoiTriangleArea(site, s0, s1) < 0) {
            triangles.push([ data[i], data[s0.i], data[s1.i] ]);
          }
        }
      });
      return triangles;
    };
    voronoi.x = function(_) {
      return arguments.length ? (fx = d3_functor(x = _), voronoi) : x;
    };
    voronoi.y = function(_) {
      return arguments.length ? (fy = d3_functor(y = _), voronoi) : y;
    };
    voronoi.clipExtent = function(_) {
      if (!arguments.length) return clipExtent === d3_geom_voronoiClipExtent ? null : clipExtent;
      clipExtent = _ == null ? d3_geom_voronoiClipExtent : _;
      return voronoi;
    };
    voronoi.size = function(_) {
      if (!arguments.length) return clipExtent === d3_geom_voronoiClipExtent ? null : clipExtent && clipExtent[1];
      return voronoi.clipExtent(_ && [ [ 0, 0 ], _ ]);
    };
    return voronoi;
  };
  var d3_geom_voronoiClipExtent = [ [ -1e6, -1e6 ], [ 1e6, 1e6 ] ];
  function d3_geom_voronoiTriangleArea(a, b, c) {
    return (a.x - c.x) * (b.y - a.y) - (a.x - b.x) * (c.y - a.y);
  }
  d3.geom.delaunay = function(vertices) {
    return d3.geom.voronoi().triangles(vertices);
  };
  d3.geom.quadtree = function(points, x1, y1, x2, y2) {
    var x = d3_geom_pointX, y = d3_geom_pointY, compat;
    if (compat = arguments.length) {
      x = d3_geom_quadtreeCompatX;
      y = d3_geom_quadtreeCompatY;
      if (compat === 3) {
        y2 = y1;
        x2 = x1;
        y1 = x1 = 0;
      }
      return quadtree(points);
    }
    function quadtree(data) {
      var d, fx = d3_functor(x), fy = d3_functor(y), xs, ys, i, n, x1_, y1_, x2_, y2_;
      if (x1 != null) {
        x1_ = x1, y1_ = y1, x2_ = x2, y2_ = y2;
      } else {
        x2_ = y2_ = -(x1_ = y1_ = Infinity);
        xs = [], ys = [];
        n = data.length;
        if (compat) for (i = 0; i < n; ++i) {
          d = data[i];
          if (d.x < x1_) x1_ = d.x;
          if (d.y < y1_) y1_ = d.y;
          if (d.x > x2_) x2_ = d.x;
          if (d.y > y2_) y2_ = d.y;
          xs.push(d.x);
          ys.push(d.y);
        } else for (i = 0; i < n; ++i) {
          var x_ = +fx(d = data[i], i), y_ = +fy(d, i);
          if (x_ < x1_) x1_ = x_;
          if (y_ < y1_) y1_ = y_;
          if (x_ > x2_) x2_ = x_;
          if (y_ > y2_) y2_ = y_;
          xs.push(x_);
          ys.push(y_);
        }
      }
      var dx = x2_ - x1_, dy = y2_ - y1_;
      if (dx > dy) y2_ = y1_ + dx; else x2_ = x1_ + dy;
      function insert(n, d, x, y, x1, y1, x2, y2) {
        if (isNaN(x) || isNaN(y)) return;
        if (n.leaf) {
          var nx = n.x, ny = n.y;
          if (nx != null) {
            if (abs(nx - x) + abs(ny - y) < .01) {
              insertChild(n, d, x, y, x1, y1, x2, y2);
            } else {
              var nPoint = n.point;
              n.x = n.y = n.point = null;
              insertChild(n, nPoint, nx, ny, x1, y1, x2, y2);
              insertChild(n, d, x, y, x1, y1, x2, y2);
            }
          } else {
            n.x = x, n.y = y, n.point = d;
          }
        } else {
          insertChild(n, d, x, y, x1, y1, x2, y2);
        }
      }
      function insertChild(n, d, x, y, x1, y1, x2, y2) {
        var xm = (x1 + x2) * .5, ym = (y1 + y2) * .5, right = x >= xm, below = y >= ym, i = below << 1 | right;
        n.leaf = false;
        n = n.nodes[i] || (n.nodes[i] = d3_geom_quadtreeNode());
        if (right) x1 = xm; else x2 = xm;
        if (below) y1 = ym; else y2 = ym;
        insert(n, d, x, y, x1, y1, x2, y2);
      }
      var root = d3_geom_quadtreeNode();
      root.add = function(d) {
        insert(root, d, +fx(d, ++i), +fy(d, i), x1_, y1_, x2_, y2_);
      };
      root.visit = function(f) {
        d3_geom_quadtreeVisit(f, root, x1_, y1_, x2_, y2_);
      };
      root.find = function(point) {
        return d3_geom_quadtreeFind(root, point[0], point[1], x1_, y1_, x2_, y2_);
      };
      i = -1;
      if (x1 == null) {
        while (++i < n) {
          insert(root, data[i], xs[i], ys[i], x1_, y1_, x2_, y2_);
        }
        --i;
      } else data.forEach(root.add);
      xs = ys = data = d = null;
      return root;
    }
    quadtree.x = function(_) {
      return arguments.length ? (x = _, quadtree) : x;
    };
    quadtree.y = function(_) {
      return arguments.length ? (y = _, quadtree) : y;
    };
    quadtree.extent = function(_) {
      if (!arguments.length) return x1 == null ? null : [ [ x1, y1 ], [ x2, y2 ] ];
      if (_ == null) x1 = y1 = x2 = y2 = null; else x1 = +_[0][0], y1 = +_[0][1], x2 = +_[1][0], 
      y2 = +_[1][1];
      return quadtree;
    };
    quadtree.size = function(_) {
      if (!arguments.length) return x1 == null ? null : [ x2 - x1, y2 - y1 ];
      if (_ == null) x1 = y1 = x2 = y2 = null; else x1 = y1 = 0, x2 = +_[0], y2 = +_[1];
      return quadtree;
    };
    return quadtree;
  };
  function d3_geom_quadtreeCompatX(d) {
    return d.x;
  }
  function d3_geom_quadtreeCompatY(d) {
    return d.y;
  }
  function d3_geom_quadtreeNode() {
    return {
      leaf: true,
      nodes: [],
      point: null,
      x: null,
      y: null
    };
  }
  function d3_geom_quadtreeVisit(f, node, x1, y1, x2, y2) {
    if (!f(node, x1, y1, x2, y2)) {
      var sx = (x1 + x2) * .5, sy = (y1 + y2) * .5, children = node.nodes;
      if (children[0]) d3_geom_quadtreeVisit(f, children[0], x1, y1, sx, sy);
      if (children[1]) d3_geom_quadtreeVisit(f, children[1], sx, y1, x2, sy);
      if (children[2]) d3_geom_quadtreeVisit(f, children[2], x1, sy, sx, y2);
      if (children[3]) d3_geom_quadtreeVisit(f, children[3], sx, sy, x2, y2);
    }
  }
  function d3_geom_quadtreeFind(root, x, y, x0, y0, x3, y3) {
    var minDistance2 = Infinity, closestPoint;
    (function find(node, x1, y1, x2, y2) {
      if (x1 > x3 || y1 > y3 || x2 < x0 || y2 < y0) return;
      if (point = node.point) {
        var point, dx = x - node.x, dy = y - node.y, distance2 = dx * dx + dy * dy;
        if (distance2 < minDistance2) {
          var distance = Math.sqrt(minDistance2 = distance2);
          x0 = x - distance, y0 = y - distance;
          x3 = x + distance, y3 = y + distance;
          closestPoint = point;
        }
      }
      var children = node.nodes, xm = (x1 + x2) * .5, ym = (y1 + y2) * .5, right = x >= xm, below = y >= ym;
      for (var i = below << 1 | right, j = i + 4; i < j; ++i) {
        if (node = children[i & 3]) switch (i & 3) {
         case 0:
          find(node, x1, y1, xm, ym);
          break;

         case 1:
          find(node, xm, y1, x2, ym);
          break;

         case 2:
          find(node, x1, ym, xm, y2);
          break;

         case 3:
          find(node, xm, ym, x2, y2);
          break;
        }
      }
    })(root, x0, y0, x3, y3);
    return closestPoint;
  }
  d3.interpolateRgb = d3_interpolateRgb;
  function d3_interpolateRgb(a, b) {
    a = d3.rgb(a);
    b = d3.rgb(b);
    var ar = a.r, ag = a.g, ab = a.b, br = b.r - ar, bg = b.g - ag, bb = b.b - ab;
    return function(t) {
      return "#" + d3_rgb_hex(Math.round(ar + br * t)) + d3_rgb_hex(Math.round(ag + bg * t)) + d3_rgb_hex(Math.round(ab + bb * t));
    };
  }
  d3.interpolateObject = d3_interpolateObject;
  function d3_interpolateObject(a, b) {
    var i = {}, c = {}, k;
    for (k in a) {
      if (k in b) {
        i[k] = d3_interpolate(a[k], b[k]);
      } else {
        c[k] = a[k];
      }
    }
    for (k in b) {
      if (!(k in a)) {
        c[k] = b[k];
      }
    }
    return function(t) {
      for (k in i) c[k] = i[k](t);
      return c;
    };
  }
  d3.interpolateNumber = d3_interpolateNumber;
  function d3_interpolateNumber(a, b) {
    a = +a, b = +b;
    return function(t) {
      return a * (1 - t) + b * t;
    };
  }
  d3.interpolateString = d3_interpolateString;
  function d3_interpolateString(a, b) {
    var bi = d3_interpolate_numberA.lastIndex = d3_interpolate_numberB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = [];
    a = a + "", b = b + "";
    while ((am = d3_interpolate_numberA.exec(a)) && (bm = d3_interpolate_numberB.exec(b))) {
      if ((bs = bm.index) > bi) {
        bs = b.slice(bi, bs);
        if (s[i]) s[i] += bs; else s[++i] = bs;
      }
      if ((am = am[0]) === (bm = bm[0])) {
        if (s[i]) s[i] += bm; else s[++i] = bm;
      } else {
        s[++i] = null;
        q.push({
          i: i,
          x: d3_interpolateNumber(am, bm)
        });
      }
      bi = d3_interpolate_numberB.lastIndex;
    }
    if (bi < b.length) {
      bs = b.slice(bi);
      if (s[i]) s[i] += bs; else s[++i] = bs;
    }
    return s.length < 2 ? q[0] ? (b = q[0].x, function(t) {
      return b(t) + "";
    }) : function() {
      return b;
    } : (b = q.length, function(t) {
      for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
      return s.join("");
    });
  }
  var d3_interpolate_numberA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, d3_interpolate_numberB = new RegExp(d3_interpolate_numberA.source, "g");
  d3.interpolate = d3_interpolate;
  function d3_interpolate(a, b) {
    var i = d3.interpolators.length, f;
    while (--i >= 0 && !(f = d3.interpolators[i](a, b))) ;
    return f;
  }
  d3.interpolators = [ function(a, b) {
    var t = typeof b;
    return (t === "string" ? d3_rgb_names.has(b.toLowerCase()) || /^(#|rgb\(|hsl\()/i.test(b) ? d3_interpolateRgb : d3_interpolateString : b instanceof d3_color ? d3_interpolateRgb : Array.isArray(b) ? d3_interpolateArray : t === "object" && isNaN(b) ? d3_interpolateObject : d3_interpolateNumber)(a, b);
  } ];
  d3.interpolateArray = d3_interpolateArray;
  function d3_interpolateArray(a, b) {
    var x = [], c = [], na = a.length, nb = b.length, n0 = Math.min(a.length, b.length), i;
    for (i = 0; i < n0; ++i) x.push(d3_interpolate(a[i], b[i]));
    for (;i < na; ++i) c[i] = a[i];
    for (;i < nb; ++i) c[i] = b[i];
    return function(t) {
      for (i = 0; i < n0; ++i) c[i] = x[i](t);
      return c;
    };
  }
  var d3_ease_default = function() {
    return d3_identity;
  };
  var d3_ease = d3.map({
    linear: d3_ease_default,
    poly: d3_ease_poly,
    quad: function() {
      return d3_ease_quad;
    },
    cubic: function() {
      return d3_ease_cubic;
    },
    sin: function() {
      return d3_ease_sin;
    },
    exp: function() {
      return d3_ease_exp;
    },
    circle: function() {
      return d3_ease_circle;
    },
    elastic: d3_ease_elastic,
    back: d3_ease_back,
    bounce: function() {
      return d3_ease_bounce;
    }
  });
  var d3_ease_mode = d3.map({
    "in": d3_identity,
    out: d3_ease_reverse,
    "in-out": d3_ease_reflect,
    "out-in": function(f) {
      return d3_ease_reflect(d3_ease_reverse(f));
    }
  });
  d3.ease = function(name) {
    var i = name.indexOf("-"), t = i >= 0 ? name.slice(0, i) : name, m = i >= 0 ? name.slice(i + 1) : "in";
    t = d3_ease.get(t) || d3_ease_default;
    m = d3_ease_mode.get(m) || d3_identity;
    return d3_ease_clamp(m(t.apply(null, d3_arraySlice.call(arguments, 1))));
  };
  function d3_ease_clamp(f) {
    return function(t) {
      return t <= 0 ? 0 : t >= 1 ? 1 : f(t);
    };
  }
  function d3_ease_reverse(f) {
    return function(t) {
      return 1 - f(1 - t);
    };
  }
  function d3_ease_reflect(f) {
    return function(t) {
      return .5 * (t < .5 ? f(2 * t) : 2 - f(2 - 2 * t));
    };
  }
  function d3_ease_quad(t) {
    return t * t;
  }
  function d3_ease_cubic(t) {
    return t * t * t;
  }
  function d3_ease_cubicInOut(t) {
    if (t <= 0) return 0;
    if (t >= 1) return 1;
    var t2 = t * t, t3 = t2 * t;
    return 4 * (t < .5 ? t3 : 3 * (t - t2) + t3 - .75);
  }
  function d3_ease_poly(e) {
    return function(t) {
      return Math.pow(t, e);
    };
  }
  function d3_ease_sin(t) {
    return 1 - Math.cos(t * halfπ);
  }
  function d3_ease_exp(t) {
    return Math.pow(2, 10 * (t - 1));
  }
  function d3_ease_circle(t) {
    return 1 - Math.sqrt(1 - t * t);
  }
  function d3_ease_elastic(a, p) {
    var s;
    if (arguments.length < 2) p = .45;
    if (arguments.length) s = p / τ * Math.asin(1 / a); else a = 1, s = p / 4;
    return function(t) {
      return 1 + a * Math.pow(2, -10 * t) * Math.sin((t - s) * τ / p);
    };
  }
  function d3_ease_back(s) {
    if (!s) s = 1.70158;
    return function(t) {
      return t * t * ((s + 1) * t - s);
    };
  }
  function d3_ease_bounce(t) {
    return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + .75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + .9375 : 7.5625 * (t -= 2.625 / 2.75) * t + .984375;
  }
  d3.interpolateHcl = d3_interpolateHcl;
  function d3_interpolateHcl(a, b) {
    a = d3.hcl(a);
    b = d3.hcl(b);
    var ah = a.h, ac = a.c, al = a.l, bh = b.h - ah, bc = b.c - ac, bl = b.l - al;
    if (isNaN(bc)) bc = 0, ac = isNaN(ac) ? b.c : ac;
    if (isNaN(bh)) bh = 0, ah = isNaN(ah) ? b.h : ah; else if (bh > 180) bh -= 360; else if (bh < -180) bh += 360;
    return function(t) {
      return d3_hcl_lab(ah + bh * t, ac + bc * t, al + bl * t) + "";
    };
  }
  d3.interpolateHsl = d3_interpolateHsl;
  function d3_interpolateHsl(a, b) {
    a = d3.hsl(a);
    b = d3.hsl(b);
    var ah = a.h, as = a.s, al = a.l, bh = b.h - ah, bs = b.s - as, bl = b.l - al;
    if (isNaN(bs)) bs = 0, as = isNaN(as) ? b.s : as;
    if (isNaN(bh)) bh = 0, ah = isNaN(ah) ? b.h : ah; else if (bh > 180) bh -= 360; else if (bh < -180) bh += 360;
    return function(t) {
      return d3_hsl_rgb(ah + bh * t, as + bs * t, al + bl * t) + "";
    };
  }
  d3.interpolateLab = d3_interpolateLab;
  function d3_interpolateLab(a, b) {
    a = d3.lab(a);
    b = d3.lab(b);
    var al = a.l, aa = a.a, ab = a.b, bl = b.l - al, ba = b.a - aa, bb = b.b - ab;
    return function(t) {
      return d3_lab_rgb(al + bl * t, aa + ba * t, ab + bb * t) + "";
    };
  }
  d3.interpolateRound = d3_interpolateRound;
  function d3_interpolateRound(a, b) {
    b -= a;
    return function(t) {
      return Math.round(a + b * t);
    };
  }
  d3.transform = function(string) {
    var g = d3_document.createElementNS(d3.ns.prefix.svg, "g");
    return (d3.transform = function(string) {
      if (string != null) {
        g.setAttribute("transform", string);
        var t = g.transform.baseVal.consolidate();
      }
      return new d3_transform(t ? t.matrix : d3_transformIdentity);
    })(string);
  };
  function d3_transform(m) {
    var r0 = [ m.a, m.b ], r1 = [ m.c, m.d ], kx = d3_transformNormalize(r0), kz = d3_transformDot(r0, r1), ky = d3_transformNormalize(d3_transformCombine(r1, r0, -kz)) || 0;
    if (r0[0] * r1[1] < r1[0] * r0[1]) {
      r0[0] *= -1;
      r0[1] *= -1;
      kx *= -1;
      kz *= -1;
    }
    this.rotate = (kx ? Math.atan2(r0[1], r0[0]) : Math.atan2(-r1[0], r1[1])) * d3_degrees;
    this.translate = [ m.e, m.f ];
    this.scale = [ kx, ky ];
    this.skew = ky ? Math.atan2(kz, ky) * d3_degrees : 0;
  }
  d3_transform.prototype.toString = function() {
    return "translate(" + this.translate + ")rotate(" + this.rotate + ")skewX(" + this.skew + ")scale(" + this.scale + ")";
  };
  function d3_transformDot(a, b) {
    return a[0] * b[0] + a[1] * b[1];
  }
  function d3_transformNormalize(a) {
    var k = Math.sqrt(d3_transformDot(a, a));
    if (k) {
      a[0] /= k;
      a[1] /= k;
    }
    return k;
  }
  function d3_transformCombine(a, b, k) {
    a[0] += k * b[0];
    a[1] += k * b[1];
    return a;
  }
  var d3_transformIdentity = {
    a: 1,
    b: 0,
    c: 0,
    d: 1,
    e: 0,
    f: 0
  };
  d3.interpolateTransform = d3_interpolateTransform;
  function d3_interpolateTransformPop(s) {
    return s.length ? s.pop() + "," : "";
  }
  function d3_interpolateTranslate(ta, tb, s, q) {
    if (ta[0] !== tb[0] || ta[1] !== tb[1]) {
      var i = s.push("translate(", null, ",", null, ")");
      q.push({
        i: i - 4,
        x: d3_interpolateNumber(ta[0], tb[0])
      }, {
        i: i - 2,
        x: d3_interpolateNumber(ta[1], tb[1])
      });
    } else if (tb[0] || tb[1]) {
      s.push("translate(" + tb + ")");
    }
  }
  function d3_interpolateRotate(ra, rb, s, q) {
    if (ra !== rb) {
      if (ra - rb > 180) rb += 360; else if (rb - ra > 180) ra += 360;
      q.push({
        i: s.push(d3_interpolateTransformPop(s) + "rotate(", null, ")") - 2,
        x: d3_interpolateNumber(ra, rb)
      });
    } else if (rb) {
      s.push(d3_interpolateTransformPop(s) + "rotate(" + rb + ")");
    }
  }
  function d3_interpolateSkew(wa, wb, s, q) {
    if (wa !== wb) {
      q.push({
        i: s.push(d3_interpolateTransformPop(s) + "skewX(", null, ")") - 2,
        x: d3_interpolateNumber(wa, wb)
      });
    } else if (wb) {
      s.push(d3_interpolateTransformPop(s) + "skewX(" + wb + ")");
    }
  }
  function d3_interpolateScale(ka, kb, s, q) {
    if (ka[0] !== kb[0] || ka[1] !== kb[1]) {
      var i = s.push(d3_interpolateTransformPop(s) + "scale(", null, ",", null, ")");
      q.push({
        i: i - 4,
        x: d3_interpolateNumber(ka[0], kb[0])
      }, {
        i: i - 2,
        x: d3_interpolateNumber(ka[1], kb[1])
      });
    } else if (kb[0] !== 1 || kb[1] !== 1) {
      s.push(d3_interpolateTransformPop(s) + "scale(" + kb + ")");
    }
  }
  function d3_interpolateTransform(a, b) {
    var s = [], q = [];
    a = d3.transform(a), b = d3.transform(b);
    d3_interpolateTranslate(a.translate, b.translate, s, q);
    d3_interpolateRotate(a.rotate, b.rotate, s, q);
    d3_interpolateSkew(a.skew, b.skew, s, q);
    d3_interpolateScale(a.scale, b.scale, s, q);
    a = b = null;
    return function(t) {
      var i = -1, n = q.length, o;
      while (++i < n) s[(o = q[i]).i] = o.x(t);
      return s.join("");
    };
  }
  function d3_uninterpolateNumber(a, b) {
    b = (b -= a = +a) || 1 / b;
    return function(x) {
      return (x - a) / b;
    };
  }
  function d3_uninterpolateClamp(a, b) {
    b = (b -= a = +a) || 1 / b;
    return function(x) {
      return Math.max(0, Math.min(1, (x - a) / b));
    };
  }
  d3.layout = {};
  d3.layout.bundle = function() {
    return function(links) {
      var paths = [], i = -1, n = links.length;
      while (++i < n) paths.push(d3_layout_bundlePath(links[i]));
      return paths;
    };
  };
  function d3_layout_bundlePath(link) {
    var start = link.source, end = link.target, lca = d3_layout_bundleLeastCommonAncestor(start, end), points = [ start ];
    while (start !== lca) {
      start = start.parent;
      points.push(start);
    }
    var k = points.length;
    while (end !== lca) {
      points.splice(k, 0, end);
      end = end.parent;
    }
    return points;
  }
  function d3_layout_bundleAncestors(node) {
    var ancestors = [], parent = node.parent;
    while (parent != null) {
      ancestors.push(node);
      node = parent;
      parent = parent.parent;
    }
    ancestors.push(node);
    return ancestors;
  }
  function d3_layout_bundleLeastCommonAncestor(a, b) {
    if (a === b) return a;
    var aNodes = d3_layout_bundleAncestors(a), bNodes = d3_layout_bundleAncestors(b), aNode = aNodes.pop(), bNode = bNodes.pop(), sharedNode = null;
    while (aNode === bNode) {
      sharedNode = aNode;
      aNode = aNodes.pop();
      bNode = bNodes.pop();
    }
    return sharedNode;
  }
  d3.layout.chord = function() {
    var chord = {}, chords, groups, matrix, n, padding = 0, sortGroups, sortSubgroups, sortChords;
    function relayout() {
      var subgroups = {}, groupSums = [], groupIndex = d3.range(n), subgroupIndex = [], k, x, x0, i, j;
      chords = [];
      groups = [];
      k = 0, i = -1;
      while (++i < n) {
        x = 0, j = -1;
        while (++j < n) {
          x += matrix[i][j];
        }
        groupSums.push(x);
        subgroupIndex.push(d3.range(n));
        k += x;
      }
      if (sortGroups) {
        groupIndex.sort(function(a, b) {
          return sortGroups(groupSums[a], groupSums[b]);
        });
      }
      if (sortSubgroups) {
        subgroupIndex.forEach(function(d, i) {
          d.sort(function(a, b) {
            return sortSubgroups(matrix[i][a], matrix[i][b]);
          });
        });
      }
      k = (τ - padding * n) / k;
      x = 0, i = -1;
      while (++i < n) {
        x0 = x, j = -1;
        while (++j < n) {
          var di = groupIndex[i], dj = subgroupIndex[di][j], v = matrix[di][dj], a0 = x, a1 = x += v * k;
          subgroups[di + "-" + dj] = {
            index: di,
            subindex: dj,
            startAngle: a0,
            endAngle: a1,
            value: v
          };
        }
        groups[di] = {
          index: di,
          startAngle: x0,
          endAngle: x,
          value: groupSums[di]
        };
        x += padding;
      }
      i = -1;
      while (++i < n) {
        j = i - 1;
        while (++j < n) {
          var source = subgroups[i + "-" + j], target = subgroups[j + "-" + i];
          if (source.value || target.value) {
            chords.push(source.value < target.value ? {
              source: target,
              target: source
            } : {
              source: source,
              target: target
            });
          }
        }
      }
      if (sortChords) resort();
    }
    function resort() {
      chords.sort(function(a, b) {
        return sortChords((a.source.value + a.target.value) / 2, (b.source.value + b.target.value) / 2);
      });
    }
    chord.matrix = function(x) {
      if (!arguments.length) return matrix;
      n = (matrix = x) && matrix.length;
      chords = groups = null;
      return chord;
    };
    chord.padding = function(x) {
      if (!arguments.length) return padding;
      padding = x;
      chords = groups = null;
      return chord;
    };
    chord.sortGroups = function(x) {
      if (!arguments.length) return sortGroups;
      sortGroups = x;
      chords = groups = null;
      return chord;
    };
    chord.sortSubgroups = function(x) {
      if (!arguments.length) return sortSubgroups;
      sortSubgroups = x;
      chords = null;
      return chord;
    };
    chord.sortChords = function(x) {
      if (!arguments.length) return sortChords;
      sortChords = x;
      if (chords) resort();
      return chord;
    };
    chord.chords = function() {
      if (!chords) relayout();
      return chords;
    };
    chord.groups = function() {
      if (!groups) relayout();
      return groups;
    };
    return chord;
  };
  d3.layout.force = function() {
    var force = {}, event = d3.dispatch("start", "tick", "end"), timer, size = [ 1, 1 ], drag, alpha, friction = .9, linkDistance = d3_layout_forceLinkDistance, linkStrength = d3_layout_forceLinkStrength, charge = -30, chargeDistance2 = d3_layout_forceChargeDistance2, gravity = .1, theta2 = .64, nodes = [], links = [], distances, strengths, charges;
    function repulse(node) {
      return function(quad, x1, _, x2) {
        if (quad.point !== node) {
          var dx = quad.cx - node.x, dy = quad.cy - node.y, dw = x2 - x1, dn = dx * dx + dy * dy;
          if (dw * dw / theta2 < dn) {
            if (dn < chargeDistance2) {
              var k = quad.charge / dn;
              node.px -= dx * k;
              node.py -= dy * k;
            }
            return true;
          }
          if (quad.point && dn && dn < chargeDistance2) {
            var k = quad.pointCharge / dn;
            node.px -= dx * k;
            node.py -= dy * k;
          }
        }
        return !quad.charge;
      };
    }
    force.tick = function() {
      if ((alpha *= .99) < .005) {
        timer = null;
        event.end({
          type: "end",
          alpha: alpha = 0
        });
        return true;
      }
      var n = nodes.length, m = links.length, q, i, o, s, t, l, k, x, y;
      for (i = 0; i < m; ++i) {
        o = links[i];
        s = o.source;
        t = o.target;
        x = t.x - s.x;
        y = t.y - s.y;
        if (l = x * x + y * y) {
          l = alpha * strengths[i] * ((l = Math.sqrt(l)) - distances[i]) / l;
          x *= l;
          y *= l;
          t.x -= x * (k = s.weight + t.weight ? s.weight / (s.weight + t.weight) : .5);
          t.y -= y * k;
          s.x += x * (k = 1 - k);
          s.y += y * k;
        }
      }
      if (k = alpha * gravity) {
        x = size[0] / 2;
        y = size[1] / 2;
        i = -1;
        if (k) while (++i < n) {
          o = nodes[i];
          o.x += (x - o.x) * k;
          o.y += (y - o.y) * k;
        }
      }
      if (charge) {
        d3_layout_forceAccumulate(q = d3.geom.quadtree(nodes), alpha, charges);
        i = -1;
        while (++i < n) {
          if (!(o = nodes[i]).fixed) {
            q.visit(repulse(o));
          }
        }
      }
      i = -1;
      while (++i < n) {
        o = nodes[i];
        if (o.fixed) {
          o.x = o.px;
          o.y = o.py;
        } else {
          o.x -= (o.px - (o.px = o.x)) * friction;
          o.y -= (o.py - (o.py = o.y)) * friction;
        }
      }
      event.tick({
        type: "tick",
        alpha: alpha
      });
    };
    force.nodes = function(x) {
      if (!arguments.length) return nodes;
      nodes = x;
      return force;
    };
    force.links = function(x) {
      if (!arguments.length) return links;
      links = x;
      return force;
    };
    force.size = function(x) {
      if (!arguments.length) return size;
      size = x;
      return force;
    };
    force.linkDistance = function(x) {
      if (!arguments.length) return linkDistance;
      linkDistance = typeof x === "function" ? x : +x;
      return force;
    };
    force.distance = force.linkDistance;
    force.linkStrength = function(x) {
      if (!arguments.length) return linkStrength;
      linkStrength = typeof x === "function" ? x : +x;
      return force;
    };
    force.friction = function(x) {
      if (!arguments.length) return friction;
      friction = +x;
      return force;
    };
    force.charge = function(x) {
      if (!arguments.length) return charge;
      charge = typeof x === "function" ? x : +x;
      return force;
    };
    force.chargeDistance = function(x) {
      if (!arguments.length) return Math.sqrt(chargeDistance2);
      chargeDistance2 = x * x;
      return force;
    };
    force.gravity = function(x) {
      if (!arguments.length) return gravity;
      gravity = +x;
      return force;
    };
    force.theta = function(x) {
      if (!arguments.length) return Math.sqrt(theta2);
      theta2 = x * x;
      return force;
    };
    force.alpha = function(x) {
      if (!arguments.length) return alpha;
      x = +x;
      if (alpha) {
        if (x > 0) {
          alpha = x;
        } else {
          timer.c = null, timer.t = NaN, timer = null;
          event.end({
            type: "end",
            alpha: alpha = 0
          });
        }
      } else if (x > 0) {
        event.start({
          type: "start",
          alpha: alpha = x
        });
        timer = d3_timer(force.tick);
      }
      return force;
    };
    force.start = function() {
      var i, n = nodes.length, m = links.length, w = size[0], h = size[1], neighbors, o;
      for (i = 0; i < n; ++i) {
        (o = nodes[i]).index = i;
        o.weight = 0;
      }
      for (i = 0; i < m; ++i) {
        o = links[i];
        if (typeof o.source == "number") o.source = nodes[o.source];
        if (typeof o.target == "number") o.target = nodes[o.target];
        ++o.source.weight;
        ++o.target.weight;
      }
      for (i = 0; i < n; ++i) {
        o = nodes[i];
        if (isNaN(o.x)) o.x = position("x", w);
        if (isNaN(o.y)) o.y = position("y", h);
        if (isNaN(o.px)) o.px = o.x;
        if (isNaN(o.py)) o.py = o.y;
      }
      distances = [];
      if (typeof linkDistance === "function") for (i = 0; i < m; ++i) distances[i] = +linkDistance.call(this, links[i], i); else for (i = 0; i < m; ++i) distances[i] = linkDistance;
      strengths = [];
      if (typeof linkStrength === "function") for (i = 0; i < m; ++i) strengths[i] = +linkStrength.call(this, links[i], i); else for (i = 0; i < m; ++i) strengths[i] = linkStrength;
      charges = [];
      if (typeof charge === "function") for (i = 0; i < n; ++i) charges[i] = +charge.call(this, nodes[i], i); else for (i = 0; i < n; ++i) charges[i] = charge;
      function position(dimension, size) {
        if (!neighbors) {
          neighbors = new Array(n);
          for (j = 0; j < n; ++j) {
            neighbors[j] = [];
          }
          for (j = 0; j < m; ++j) {
            var o = links[j];
            neighbors[o.source.index].push(o.target);
            neighbors[o.target.index].push(o.source);
          }
        }
        var candidates = neighbors[i], j = -1, l = candidates.length, x;
        while (++j < l) if (!isNaN(x = candidates[j][dimension])) return x;
        return Math.random() * size;
      }
      return force.resume();
    };
    force.resume = function() {
      return force.alpha(.1);
    };
    force.stop = function() {
      return force.alpha(0);
    };
    force.drag = function() {
      if (!drag) drag = d3.behavior.drag().origin(d3_identity).on("dragstart.force", d3_layout_forceDragstart).on("drag.force", dragmove).on("dragend.force", d3_layout_forceDragend);
      if (!arguments.length) return drag;
      this.on("mouseover.force", d3_layout_forceMouseover).on("mouseout.force", d3_layout_forceMouseout).call(drag);
    };
    function dragmove(d) {
      d.px = d3.event.x, d.py = d3.event.y;
      force.resume();
    }
    return d3.rebind(force, event, "on");
  };
  function d3_layout_forceDragstart(d) {
    d.fixed |= 2;
  }
  function d3_layout_forceDragend(d) {
    d.fixed &= ~6;
  }
  function d3_layout_forceMouseover(d) {
    d.fixed |= 4;
    d.px = d.x, d.py = d.y;
  }
  function d3_layout_forceMouseout(d) {
    d.fixed &= ~4;
  }
  function d3_layout_forceAccumulate(quad, alpha, charges) {
    var cx = 0, cy = 0;
    quad.charge = 0;
    if (!quad.leaf) {
      var nodes = quad.nodes, n = nodes.length, i = -1, c;
      while (++i < n) {
        c = nodes[i];
        if (c == null) continue;
        d3_layout_forceAccumulate(c, alpha, charges);
        quad.charge += c.charge;
        cx += c.charge * c.cx;
        cy += c.charge * c.cy;
      }
    }
    if (quad.point) {
      if (!quad.leaf) {
        quad.point.x += Math.random() - .5;
        quad.point.y += Math.random() - .5;
      }
      var k = alpha * charges[quad.point.index];
      quad.charge += quad.pointCharge = k;
      cx += k * quad.point.x;
      cy += k * quad.point.y;
    }
    quad.cx = cx / quad.charge;
    quad.cy = cy / quad.charge;
  }
  var d3_layout_forceLinkDistance = 20, d3_layout_forceLinkStrength = 1, d3_layout_forceChargeDistance2 = Infinity;
  d3.layout.hierarchy = function() {
    var sort = d3_layout_hierarchySort, children = d3_layout_hierarchyChildren, value = d3_layout_hierarchyValue;
    function hierarchy(root) {
      var stack = [ root ], nodes = [], node;
      root.depth = 0;
      while ((node = stack.pop()) != null) {
        nodes.push(node);
        if ((childs = children.call(hierarchy, node, node.depth)) && (n = childs.length)) {
          var n, childs, child;
          while (--n >= 0) {
            stack.push(child = childs[n]);
            child.parent = node;
            child.depth = node.depth + 1;
          }
          if (value) node.value = 0;
          node.children = childs;
        } else {
          if (value) node.value = +value.call(hierarchy, node, node.depth) || 0;
          delete node.children;
        }
      }
      d3_layout_hierarchyVisitAfter(root, function(node) {
        var childs, parent;
        if (sort && (childs = node.children)) childs.sort(sort);
        if (value && (parent = node.parent)) parent.value += node.value;
      });
      return nodes;
    }
    hierarchy.sort = function(x) {
      if (!arguments.length) return sort;
      sort = x;
      return hierarchy;
    };
    hierarchy.children = function(x) {
      if (!arguments.length) return children;
      children = x;
      return hierarchy;
    };
    hierarchy.value = function(x) {
      if (!arguments.length) return value;
      value = x;
      return hierarchy;
    };
    hierarchy.revalue = function(root) {
      if (value) {
        d3_layout_hierarchyVisitBefore(root, function(node) {
          if (node.children) node.value = 0;
        });
        d3_layout_hierarchyVisitAfter(root, function(node) {
          var parent;
          if (!node.children) node.value = +value.call(hierarchy, node, node.depth) || 0;
          if (parent = node.parent) parent.value += node.value;
        });
      }
      return root;
    };
    return hierarchy;
  };
  function d3_layout_hierarchyRebind(object, hierarchy) {
    d3.rebind(object, hierarchy, "sort", "children", "value");
    object.nodes = object;
    object.links = d3_layout_hierarchyLinks;
    return object;
  }
  function d3_layout_hierarchyVisitBefore(node, callback) {
    var nodes = [ node ];
    while ((node = nodes.pop()) != null) {
      callback(node);
      if ((children = node.children) && (n = children.length)) {
        var n, children;
        while (--n >= 0) nodes.push(children[n]);
      }
    }
  }
  function d3_layout_hierarchyVisitAfter(node, callback) {
    var nodes = [ node ], nodes2 = [];
    while ((node = nodes.pop()) != null) {
      nodes2.push(node);
      if ((children = node.children) && (n = children.length)) {
        var i = -1, n, children;
        while (++i < n) nodes.push(children[i]);
      }
    }
    while ((node = nodes2.pop()) != null) {
      callback(node);
    }
  }
  function d3_layout_hierarchyChildren(d) {
    return d.children;
  }
  function d3_layout_hierarchyValue(d) {
    return d.value;
  }
  function d3_layout_hierarchySort(a, b) {
    return b.value - a.value;
  }
  function d3_layout_hierarchyLinks(nodes) {
    return d3.merge(nodes.map(function(parent) {
      return (parent.children || []).map(function(child) {
        return {
          source: parent,
          target: child
        };
      });
    }));
  }
  d3.layout.partition = function() {
    var hierarchy = d3.layout.hierarchy(), size = [ 1, 1 ];
    function position(node, x, dx, dy) {
      var children = node.children;
      node.x = x;
      node.y = node.depth * dy;
      node.dx = dx;
      node.dy = dy;
      if (children && (n = children.length)) {
        var i = -1, n, c, d;
        dx = node.value ? dx / node.value : 0;
        while (++i < n) {
          position(c = children[i], x, d = c.value * dx, dy);
          x += d;
        }
      }
    }
    function depth(node) {
      var children = node.children, d = 0;
      if (children && (n = children.length)) {
        var i = -1, n;
        while (++i < n) d = Math.max(d, depth(children[i]));
      }
      return 1 + d;
    }
    function partition(d, i) {
      var nodes = hierarchy.call(this, d, i);
      position(nodes[0], 0, size[0], size[1] / depth(nodes[0]));
      return nodes;
    }
    partition.size = function(x) {
      if (!arguments.length) return size;
      size = x;
      return partition;
    };
    return d3_layout_hierarchyRebind(partition, hierarchy);
  };
  d3.layout.pie = function() {
    var value = Number, sort = d3_layout_pieSortByValue, startAngle = 0, endAngle = τ, padAngle = 0;
    function pie(data) {
      var n = data.length, values = data.map(function(d, i) {
        return +value.call(pie, d, i);
      }), a = +(typeof startAngle === "function" ? startAngle.apply(this, arguments) : startAngle), da = (typeof endAngle === "function" ? endAngle.apply(this, arguments) : endAngle) - a, p = Math.min(Math.abs(da) / n, +(typeof padAngle === "function" ? padAngle.apply(this, arguments) : padAngle)), pa = p * (da < 0 ? -1 : 1), sum = d3.sum(values), k = sum ? (da - n * pa) / sum : 0, index = d3.range(n), arcs = [], v;
      if (sort != null) index.sort(sort === d3_layout_pieSortByValue ? function(i, j) {
        return values[j] - values[i];
      } : function(i, j) {
        return sort(data[i], data[j]);
      });
      index.forEach(function(i) {
        arcs[i] = {
          data: data[i],
          value: v = values[i],
          startAngle: a,
          endAngle: a += v * k + pa,
          padAngle: p
        };
      });
      return arcs;
    }
    pie.value = function(_) {
      if (!arguments.length) return value;
      value = _;
      return pie;
    };
    pie.sort = function(_) {
      if (!arguments.length) return sort;
      sort = _;
      return pie;
    };
    pie.startAngle = function(_) {
      if (!arguments.length) return startAngle;
      startAngle = _;
      return pie;
    };
    pie.endAngle = function(_) {
      if (!arguments.length) return endAngle;
      endAngle = _;
      return pie;
    };
    pie.padAngle = function(_) {
      if (!arguments.length) return padAngle;
      padAngle = _;
      return pie;
    };
    return pie;
  };
  var d3_layout_pieSortByValue = {};
  d3.layout.stack = function() {
    var values = d3_identity, order = d3_layout_stackOrderDefault, offset = d3_layout_stackOffsetZero, out = d3_layout_stackOut, x = d3_layout_stackX, y = d3_layout_stackY;
    function stack(data, index) {
      if (!(n = data.length)) return data;
      var series = data.map(function(d, i) {
        return values.call(stack, d, i);
      });
      var points = series.map(function(d) {
        return d.map(function(v, i) {
          return [ x.call(stack, v, i), y.call(stack, v, i) ];
        });
      });
      var orders = order.call(stack, points, index);
      series = d3.permute(series, orders);
      points = d3.permute(points, orders);
      var offsets = offset.call(stack, points, index);
      var m = series[0].length, n, i, j, o;
      for (j = 0; j < m; ++j) {
        out.call(stack, series[0][j], o = offsets[j], points[0][j][1]);
        for (i = 1; i < n; ++i) {
          out.call(stack, series[i][j], o += points[i - 1][j][1], points[i][j][1]);
        }
      }
      return data;
    }
    stack.values = function(x) {
      if (!arguments.length) return values;
      values = x;
      return stack;
    };
    stack.order = function(x) {
      if (!arguments.length) return order;
      order = typeof x === "function" ? x : d3_layout_stackOrders.get(x) || d3_layout_stackOrderDefault;
      return stack;
    };
    stack.offset = function(x) {
      if (!arguments.length) return offset;
      offset = typeof x === "function" ? x : d3_layout_stackOffsets.get(x) || d3_layout_stackOffsetZero;
      return stack;
    };
    stack.x = function(z) {
      if (!arguments.length) return x;
      x = z;
      return stack;
    };
    stack.y = function(z) {
      if (!arguments.length) return y;
      y = z;
      return stack;
    };
    stack.out = function(z) {
      if (!arguments.length) return out;
      out = z;
      return stack;
    };
    return stack;
  };
  function d3_layout_stackX(d) {
    return d.x;
  }
  function d3_layout_stackY(d) {
    return d.y;
  }
  function d3_layout_stackOut(d, y0, y) {
    d.y0 = y0;
    d.y = y;
  }
  var d3_layout_stackOrders = d3.map({
    "inside-out": function(data) {
      var n = data.length, i, j, max = data.map(d3_layout_stackMaxIndex), sums = data.map(d3_layout_stackReduceSum), index = d3.range(n).sort(function(a, b) {
        return max[a] - max[b];
      }), top = 0, bottom = 0, tops = [], bottoms = [];
      for (i = 0; i < n; ++i) {
        j = index[i];
        if (top < bottom) {
          top += sums[j];
          tops.push(j);
        } else {
          bottom += sums[j];
          bottoms.push(j);
        }
      }
      return bottoms.reverse().concat(tops);
    },
    reverse: function(data) {
      return d3.range(data.length).reverse();
    },
    "default": d3_layout_stackOrderDefault
  });
  var d3_layout_stackOffsets = d3.map({
    silhouette: function(data) {
      var n = data.length, m = data[0].length, sums = [], max = 0, i, j, o, y0 = [];
      for (j = 0; j < m; ++j) {
        for (i = 0, o = 0; i < n; i++) o += data[i][j][1];
        if (o > max) max = o;
        sums.push(o);
      }
      for (j = 0; j < m; ++j) {
        y0[j] = (max - sums[j]) / 2;
      }
      return y0;
    },
    wiggle: function(data) {
      var n = data.length, x = data[0], m = x.length, i, j, k, s1, s2, s3, dx, o, o0, y0 = [];
      y0[0] = o = o0 = 0;
      for (j = 1; j < m; ++j) {
        for (i = 0, s1 = 0; i < n; ++i) s1 += data[i][j][1];
        for (i = 0, s2 = 0, dx = x[j][0] - x[j - 1][0]; i < n; ++i) {
          for (k = 0, s3 = (data[i][j][1] - data[i][j - 1][1]) / (2 * dx); k < i; ++k) {
            s3 += (data[k][j][1] - data[k][j - 1][1]) / dx;
          }
          s2 += s3 * data[i][j][1];
        }
        y0[j] = o -= s1 ? s2 / s1 * dx : 0;
        if (o < o0) o0 = o;
      }
      for (j = 0; j < m; ++j) y0[j] -= o0;
      return y0;
    },
    expand: function(data) {
      var n = data.length, m = data[0].length, k = 1 / n, i, j, o, y0 = [];
      for (j = 0; j < m; ++j) {
        for (i = 0, o = 0; i < n; i++) o += data[i][j][1];
        if (o) for (i = 0; i < n; i++) data[i][j][1] /= o; else for (i = 0; i < n; i++) data[i][j][1] = k;
      }
      for (j = 0; j < m; ++j) y0[j] = 0;
      return y0;
    },
    zero: d3_layout_stackOffsetZero
  });
  function d3_layout_stackOrderDefault(data) {
    return d3.range(data.length);
  }
  function d3_layout_stackOffsetZero(data) {
    var j = -1, m = data[0].length, y0 = [];
    while (++j < m) y0[j] = 0;
    return y0;
  }
  function d3_layout_stackMaxIndex(array) {
    var i = 1, j = 0, v = array[0][1], k, n = array.length;
    for (;i < n; ++i) {
      if ((k = array[i][1]) > v) {
        j = i;
        v = k;
      }
    }
    return j;
  }
  function d3_layout_stackReduceSum(d) {
    return d.reduce(d3_layout_stackSum, 0);
  }
  function d3_layout_stackSum(p, d) {
    return p + d[1];
  }
  d3.layout.histogram = function() {
    var frequency = true, valuer = Number, ranger = d3_layout_histogramRange, binner = d3_layout_histogramBinSturges;
    function histogram(data, i) {
      var bins = [], values = data.map(valuer, this), range = ranger.call(this, values, i), thresholds = binner.call(this, range, values, i), bin, i = -1, n = values.length, m = thresholds.length - 1, k = frequency ? 1 : 1 / n, x;
      while (++i < m) {
        bin = bins[i] = [];
        bin.dx = thresholds[i + 1] - (bin.x = thresholds[i]);
        bin.y = 0;
      }
      if (m > 0) {
        i = -1;
        while (++i < n) {
          x = values[i];
          if (x >= range[0] && x <= range[1]) {
            bin = bins[d3.bisect(thresholds, x, 1, m) - 1];
            bin.y += k;
            bin.push(data[i]);
          }
        }
      }
      return bins;
    }
    histogram.value = function(x) {
      if (!arguments.length) return valuer;
      valuer = x;
      return histogram;
    };
    histogram.range = function(x) {
      if (!arguments.length) return ranger;
      ranger = d3_functor(x);
      return histogram;
    };
    histogram.bins = function(x) {
      if (!arguments.length) return binner;
      binner = typeof x === "number" ? function(range) {
        return d3_layout_histogramBinFixed(range, x);
      } : d3_functor(x);
      return histogram;
    };
    histogram.frequency = function(x) {
      if (!arguments.length) return frequency;
      frequency = !!x;
      return histogram;
    };
    return histogram;
  };
  function d3_layout_histogramBinSturges(range, values) {
    return d3_layout_histogramBinFixed(range, Math.ceil(Math.log(values.length) / Math.LN2 + 1));
  }
  function d3_layout_histogramBinFixed(range, n) {
    var x = -1, b = +range[0], m = (range[1] - b) / n, f = [];
    while (++x <= n) f[x] = m * x + b;
    return f;
  }
  function d3_layout_histogramRange(values) {
    return [ d3.min(values), d3.max(values) ];
  }
  d3.layout.pack = function() {
    var hierarchy = d3.layout.hierarchy().sort(d3_layout_packSort), padding = 0, size = [ 1, 1 ], radius;
    function pack(d, i) {
      var nodes = hierarchy.call(this, d, i), root = nodes[0], w = size[0], h = size[1], r = radius == null ? Math.sqrt : typeof radius === "function" ? radius : function() {
        return radius;
      };
      root.x = root.y = 0;
      d3_layout_hierarchyVisitAfter(root, function(d) {
        d.r = +r(d.value);
      });
      d3_layout_hierarchyVisitAfter(root, d3_layout_packSiblings);
      if (padding) {
        var dr = padding * (radius ? 1 : Math.max(2 * root.r / w, 2 * root.r / h)) / 2;
        d3_layout_hierarchyVisitAfter(root, function(d) {
          d.r += dr;
        });
        d3_layout_hierarchyVisitAfter(root, d3_layout_packSiblings);
        d3_layout_hierarchyVisitAfter(root, function(d) {
          d.r -= dr;
        });
      }
      d3_layout_packTransform(root, w / 2, h / 2, radius ? 1 : 1 / Math.max(2 * root.r / w, 2 * root.r / h));
      return nodes;
    }
    pack.size = function(_) {
      if (!arguments.length) return size;
      size = _;
      return pack;
    };
    pack.radius = function(_) {
      if (!arguments.length) return radius;
      radius = _ == null || typeof _ === "function" ? _ : +_;
      return pack;
    };
    pack.padding = function(_) {
      if (!arguments.length) return padding;
      padding = +_;
      return pack;
    };
    return d3_layout_hierarchyRebind(pack, hierarchy);
  };
  function d3_layout_packSort(a, b) {
    return a.value - b.value;
  }
  function d3_layout_packInsert(a, b) {
    var c = a._pack_next;
    a._pack_next = b;
    b._pack_prev = a;
    b._pack_next = c;
    c._pack_prev = b;
  }
  function d3_layout_packSplice(a, b) {
    a._pack_next = b;
    b._pack_prev = a;
  }
  function d3_layout_packIntersects(a, b) {
    var dx = b.x - a.x, dy = b.y - a.y, dr = a.r + b.r;
    return .999 * dr * dr > dx * dx + dy * dy;
  }
  function d3_layout_packSiblings(node) {
    if (!(nodes = node.children) || !(n = nodes.length)) return;
    var nodes, xMin = Infinity, xMax = -Infinity, yMin = Infinity, yMax = -Infinity, a, b, c, i, j, k, n;
    function bound(node) {
      xMin = Math.min(node.x - node.r, xMin);
      xMax = Math.max(node.x + node.r, xMax);
      yMin = Math.min(node.y - node.r, yMin);
      yMax = Math.max(node.y + node.r, yMax);
    }
    nodes.forEach(d3_layout_packLink);
    a = nodes[0];
    a.x = -a.r;
    a.y = 0;
    bound(a);
    if (n > 1) {
      b = nodes[1];
      b.x = b.r;
      b.y = 0;
      bound(b);
      if (n > 2) {
        c = nodes[2];
        d3_layout_packPlace(a, b, c);
        bound(c);
        d3_layout_packInsert(a, c);
        a._pack_prev = c;
        d3_layout_packInsert(c, b);
        b = a._pack_next;
        for (i = 3; i < n; i++) {
          d3_layout_packPlace(a, b, c = nodes[i]);
          var isect = 0, s1 = 1, s2 = 1;
          for (j = b._pack_next; j !== b; j = j._pack_next, s1++) {
            if (d3_layout_packIntersects(j, c)) {
              isect = 1;
              break;
            }
          }
          if (isect == 1) {
            for (k = a._pack_prev; k !== j._pack_prev; k = k._pack_prev, s2++) {
              if (d3_layout_packIntersects(k, c)) {
                break;
              }
            }
          }
          if (isect) {
            if (s1 < s2 || s1 == s2 && b.r < a.r) d3_layout_packSplice(a, b = j); else d3_layout_packSplice(a = k, b);
            i--;
          } else {
            d3_layout_packInsert(a, c);
            b = c;
            bound(c);
          }
        }
      }
    }
    var cx = (xMin + xMax) / 2, cy = (yMin + yMax) / 2, cr = 0;
    for (i = 0; i < n; i++) {
      c = nodes[i];
      c.x -= cx;
      c.y -= cy;
      cr = Math.max(cr, c.r + Math.sqrt(c.x * c.x + c.y * c.y));
    }
    node.r = cr;
    nodes.forEach(d3_layout_packUnlink);
  }
  function d3_layout_packLink(node) {
    node._pack_next = node._pack_prev = node;
  }
  function d3_layout_packUnlink(node) {
    delete node._pack_next;
    delete node._pack_prev;
  }
  function d3_layout_packTransform(node, x, y, k) {
    var children = node.children;
    node.x = x += k * node.x;
    node.y = y += k * node.y;
    node.r *= k;
    if (children) {
      var i = -1, n = children.length;
      while (++i < n) d3_layout_packTransform(children[i], x, y, k);
    }
  }
  function d3_layout_packPlace(a, b, c) {
    var db = a.r + c.r, dx = b.x - a.x, dy = b.y - a.y;
    if (db && (dx || dy)) {
      var da = b.r + c.r, dc = dx * dx + dy * dy;
      da *= da;
      db *= db;
      var x = .5 + (db - da) / (2 * dc), y = Math.sqrt(Math.max(0, 2 * da * (db + dc) - (db -= dc) * db - da * da)) / (2 * dc);
      c.x = a.x + x * dx + y * dy;
      c.y = a.y + x * dy - y * dx;
    } else {
      c.x = a.x + db;
      c.y = a.y;
    }
  }
  d3.layout.tree = function() {
    var hierarchy = d3.layout.hierarchy().sort(null).value(null), separation = d3_layout_treeSeparation, size = [ 1, 1 ], nodeSize = null;
    function tree(d, i) {
      var nodes = hierarchy.call(this, d, i), root0 = nodes[0], root1 = wrapTree(root0);
      d3_layout_hierarchyVisitAfter(root1, firstWalk), root1.parent.m = -root1.z;
      d3_layout_hierarchyVisitBefore(root1, secondWalk);
      if (nodeSize) d3_layout_hierarchyVisitBefore(root0, sizeNode); else {
        var left = root0, right = root0, bottom = root0;
        d3_layout_hierarchyVisitBefore(root0, function(node) {
          if (node.x < left.x) left = node;
          if (node.x > right.x) right = node;
          if (node.depth > bottom.depth) bottom = node;
        });
        var tx = separation(left, right) / 2 - left.x, kx = size[0] / (right.x + separation(right, left) / 2 + tx), ky = size[1] / (bottom.depth || 1);
        d3_layout_hierarchyVisitBefore(root0, function(node) {
          node.x = (node.x + tx) * kx;
          node.y = node.depth * ky;
        });
      }
      return nodes;
    }
    function wrapTree(root0) {
      var root1 = {
        A: null,
        children: [ root0 ]
      }, queue = [ root1 ], node1;
      while ((node1 = queue.pop()) != null) {
        for (var children = node1.children, child, i = 0, n = children.length; i < n; ++i) {
          queue.push((children[i] = child = {
            _: children[i],
            parent: node1,
            children: (child = children[i].children) && child.slice() || [],
            A: null,
            a: null,
            z: 0,
            m: 0,
            c: 0,
            s: 0,
            t: null,
            i: i
          }).a = child);
        }
      }
      return root1.children[0];
    }
    function firstWalk(v) {
      var children = v.children, siblings = v.parent.children, w = v.i ? siblings[v.i - 1] : null;
      if (children.length) {
        d3_layout_treeShift(v);
        var midpoint = (children[0].z + children[children.length - 1].z) / 2;
        if (w) {
          v.z = w.z + separation(v._, w._);
          v.m = v.z - midpoint;
        } else {
          v.z = midpoint;
        }
      } else if (w) {
        v.z = w.z + separation(v._, w._);
      }
      v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
    }
    function secondWalk(v) {
      v._.x = v.z + v.parent.m;
      v.m += v.parent.m;
    }
    function apportion(v, w, ancestor) {
      if (w) {
        var vip = v, vop = v, vim = w, vom = vip.parent.children[0], sip = vip.m, sop = vop.m, sim = vim.m, som = vom.m, shift;
        while (vim = d3_layout_treeRight(vim), vip = d3_layout_treeLeft(vip), vim && vip) {
          vom = d3_layout_treeLeft(vom);
          vop = d3_layout_treeRight(vop);
          vop.a = v;
          shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
          if (shift > 0) {
            d3_layout_treeMove(d3_layout_treeAncestor(vim, v, ancestor), v, shift);
            sip += shift;
            sop += shift;
          }
          sim += vim.m;
          sip += vip.m;
          som += vom.m;
          sop += vop.m;
        }
        if (vim && !d3_layout_treeRight(vop)) {
          vop.t = vim;
          vop.m += sim - sop;
        }
        if (vip && !d3_layout_treeLeft(vom)) {
          vom.t = vip;
          vom.m += sip - som;
          ancestor = v;
        }
      }
      return ancestor;
    }
    function sizeNode(node) {
      node.x *= size[0];
      node.y = node.depth * size[1];
    }
    tree.separation = function(x) {
      if (!arguments.length) return separation;
      separation = x;
      return tree;
    };
    tree.size = function(x) {
      if (!arguments.length) return nodeSize ? null : size;
      nodeSize = (size = x) == null ? sizeNode : null;
      return tree;
    };
    tree.nodeSize = function(x) {
      if (!arguments.length) return nodeSize ? size : null;
      nodeSize = (size = x) == null ? null : sizeNode;
      return tree;
    };
    return d3_layout_hierarchyRebind(tree, hierarchy);
  };
  function d3_layout_treeSeparation(a, b) {
    return a.parent == b.parent ? 1 : 2;
  }
  function d3_layout_treeLeft(v) {
    var children = v.children;
    return children.length ? children[0] : v.t;
  }
  function d3_layout_treeRight(v) {
    var children = v.children, n;
    return (n = children.length) ? children[n - 1] : v.t;
  }
  function d3_layout_treeMove(wm, wp, shift) {
    var change = shift / (wp.i - wm.i);
    wp.c -= change;
    wp.s += shift;
    wm.c += change;
    wp.z += shift;
    wp.m += shift;
  }
  function d3_layout_treeShift(v) {
    var shift = 0, change = 0, children = v.children, i = children.length, w;
    while (--i >= 0) {
      w = children[i];
      w.z += shift;
      w.m += shift;
      shift += w.s + (change += w.c);
    }
  }
  function d3_layout_treeAncestor(vim, v, ancestor) {
    return vim.a.parent === v.parent ? vim.a : ancestor;
  }
  d3.layout.cluster = function() {
    var hierarchy = d3.layout.hierarchy().sort(null).value(null), separation = d3_layout_treeSeparation, size = [ 1, 1 ], nodeSize = false;
    function cluster(d, i) {
      var nodes = hierarchy.call(this, d, i), root = nodes[0], previousNode, x = 0;
      d3_layout_hierarchyVisitAfter(root, function(node) {
        var children = node.children;
        if (children && children.length) {
          node.x = d3_layout_clusterX(children);
          node.y = d3_layout_clusterY(children);
        } else {
          node.x = previousNode ? x += separation(node, previousNode) : 0;
          node.y = 0;
          previousNode = node;
        }
      });
      var left = d3_layout_clusterLeft(root), right = d3_layout_clusterRight(root), x0 = left.x - separation(left, right) / 2, x1 = right.x + separation(right, left) / 2;
      d3_layout_hierarchyVisitAfter(root, nodeSize ? function(node) {
        node.x = (node.x - root.x) * size[0];
        node.y = (root.y - node.y) * size[1];
      } : function(node) {
        node.x = (node.x - x0) / (x1 - x0) * size[0];
        node.y = (1 - (root.y ? node.y / root.y : 1)) * size[1];
      });
      return nodes;
    }
    cluster.separation = function(x) {
      if (!arguments.length) return separation;
      separation = x;
      return cluster;
    };
    cluster.size = function(x) {
      if (!arguments.length) return nodeSize ? null : size;
      nodeSize = (size = x) == null;
      return cluster;
    };
    cluster.nodeSize = function(x) {
      if (!arguments.length) return nodeSize ? size : null;
      nodeSize = (size = x) != null;
      return cluster;
    };
    return d3_layout_hierarchyRebind(cluster, hierarchy);
  };
  function d3_layout_clusterY(children) {
    return 1 + d3.max(children, function(child) {
      return child.y;
    });
  }
  function d3_layout_clusterX(children) {
    return children.reduce(function(x, child) {
      return x + child.x;
    }, 0) / children.length;
  }
  function d3_layout_clusterLeft(node) {
    var children = node.children;
    return children && children.length ? d3_layout_clusterLeft(children[0]) : node;
  }
  function d3_layout_clusterRight(node) {
    var children = node.children, n;
    return children && (n = children.length) ? d3_layout_clusterRight(children[n - 1]) : node;
  }
  d3.layout.treemap = function() {
    var hierarchy = d3.layout.hierarchy(), round = Math.round, size = [ 1, 1 ], padding = null, pad = d3_layout_treemapPadNull, sticky = false, stickies, mode = "squarify", ratio = .5 * (1 + Math.sqrt(5));
    function scale(children, k) {
      var i = -1, n = children.length, child, area;
      while (++i < n) {
        area = (child = children[i]).value * (k < 0 ? 0 : k);
        child.area = isNaN(area) || area <= 0 ? 0 : area;
      }
    }
    function squarify(node) {
      var children = node.children;
      if (children && children.length) {
        var rect = pad(node), row = [], remaining = children.slice(), child, best = Infinity, score, u = mode === "slice" ? rect.dx : mode === "dice" ? rect.dy : mode === "slice-dice" ? node.depth & 1 ? rect.dy : rect.dx : Math.min(rect.dx, rect.dy), n;
        scale(remaining, rect.dx * rect.dy / node.value);
        row.area = 0;
        while ((n = remaining.length) > 0) {
          row.push(child = remaining[n - 1]);
          row.area += child.area;
          if (mode !== "squarify" || (score = worst(row, u)) <= best) {
            remaining.pop();
            best = score;
          } else {
            row.area -= row.pop().area;
            position(row, u, rect, false);
            u = Math.min(rect.dx, rect.dy);
            row.length = row.area = 0;
            best = Infinity;
          }
        }
        if (row.length) {
          position(row, u, rect, true);
          row.length = row.area = 0;
        }
        children.forEach(squarify);
      }
    }
    function stickify(node) {
      var children = node.children;
      if (children && children.length) {
        var rect = pad(node), remaining = children.slice(), child, row = [];
        scale(remaining, rect.dx * rect.dy / node.value);
        row.area = 0;
        while (child = remaining.pop()) {
          row.push(child);
          row.area += child.area;
          if (child.z != null) {
            position(row, child.z ? rect.dx : rect.dy, rect, !remaining.length);
            row.length = row.area = 0;
          }
        }
        children.forEach(stickify);
      }
    }
    function worst(row, u) {
      var s = row.area, r, rmax = 0, rmin = Infinity, i = -1, n = row.length;
      while (++i < n) {
        if (!(r = row[i].area)) continue;
        if (r < rmin) rmin = r;
        if (r > rmax) rmax = r;
      }
      s *= s;
      u *= u;
      return s ? Math.max(u * rmax * ratio / s, s / (u * rmin * ratio)) : Infinity;
    }
    function position(row, u, rect, flush) {
      var i = -1, n = row.length, x = rect.x, y = rect.y, v = u ? round(row.area / u) : 0, o;
      if (u == rect.dx) {
        if (flush || v > rect.dy) v = rect.dy;
        while (++i < n) {
          o = row[i];
          o.x = x;
          o.y = y;
          o.dy = v;
          x += o.dx = Math.min(rect.x + rect.dx - x, v ? round(o.area / v) : 0);
        }
        o.z = true;
        o.dx += rect.x + rect.dx - x;
        rect.y += v;
        rect.dy -= v;
      } else {
        if (flush || v > rect.dx) v = rect.dx;
        while (++i < n) {
          o = row[i];
          o.x = x;
          o.y = y;
          o.dx = v;
          y += o.dy = Math.min(rect.y + rect.dy - y, v ? round(o.area / v) : 0);
        }
        o.z = false;
        o.dy += rect.y + rect.dy - y;
        rect.x += v;
        rect.dx -= v;
      }
    }
    function treemap(d) {
      var nodes = stickies || hierarchy(d), root = nodes[0];
      root.x = root.y = 0;
      if (root.value) root.dx = size[0], root.dy = size[1]; else root.dx = root.dy = 0;
      if (stickies) hierarchy.revalue(root);
      scale([ root ], root.dx * root.dy / root.value);
      (stickies ? stickify : squarify)(root);
      if (sticky) stickies = nodes;
      return nodes;
    }
    treemap.size = function(x) {
      if (!arguments.length) return size;
      size = x;
      return treemap;
    };
    treemap.padding = function(x) {
      if (!arguments.length) return padding;
      function padFunction(node) {
        var p = x.call(treemap, node, node.depth);
        return p == null ? d3_layout_treemapPadNull(node) : d3_layout_treemapPad(node, typeof p === "number" ? [ p, p, p, p ] : p);
      }
      function padConstant(node) {
        return d3_layout_treemapPad(node, x);
      }
      var type;
      pad = (padding = x) == null ? d3_layout_treemapPadNull : (type = typeof x) === "function" ? padFunction : type === "number" ? (x = [ x, x, x, x ], 
      padConstant) : padConstant;
      return treemap;
    };
    treemap.round = function(x) {
      if (!arguments.length) return round != Number;
      round = x ? Math.round : Number;
      return treemap;
    };
    treemap.sticky = function(x) {
      if (!arguments.length) return sticky;
      sticky = x;
      stickies = null;
      return treemap;
    };
    treemap.ratio = function(x) {
      if (!arguments.length) return ratio;
      ratio = x;
      return treemap;
    };
    treemap.mode = function(x) {
      if (!arguments.length) return mode;
      mode = x + "";
      return treemap;
    };
    return d3_layout_hierarchyRebind(treemap, hierarchy);
  };
  function d3_layout_treemapPadNull(node) {
    return {
      x: node.x,
      y: node.y,
      dx: node.dx,
      dy: node.dy
    };
  }
  function d3_layout_treemapPad(node, padding) {
    var x = node.x + padding[3], y = node.y + padding[0], dx = node.dx - padding[1] - padding[3], dy = node.dy - padding[0] - padding[2];
    if (dx < 0) {
      x += dx / 2;
      dx = 0;
    }
    if (dy < 0) {
      y += dy / 2;
      dy = 0;
    }
    return {
      x: x,
      y: y,
      dx: dx,
      dy: dy
    };
  }
  d3.random = {
    normal: function(mu, sigma) {
      var n = arguments.length;
      if (n < 2) sigma = 1;
      if (n < 1) mu = 0;
      return function() {
        var x, y, r;
        do {
          x = Math.random() * 2 - 1;
          y = Math.random() * 2 - 1;
          r = x * x + y * y;
        } while (!r || r > 1);
        return mu + sigma * x * Math.sqrt(-2 * Math.log(r) / r);
      };
    },
    logNormal: function() {
      var random = d3.random.normal.apply(d3, arguments);
      return function() {
        return Math.exp(random());
      };
    },
    bates: function(m) {
      var random = d3.random.irwinHall(m);
      return function() {
        return random() / m;
      };
    },
    irwinHall: function(m) {
      return function() {
        for (var s = 0, j = 0; j < m; j++) s += Math.random();
        return s;
      };
    }
  };
  d3.scale = {};
  function d3_scaleExtent(domain) {
    var start = domain[0], stop = domain[domain.length - 1];
    return start < stop ? [ start, stop ] : [ stop, start ];
  }
  function d3_scaleRange(scale) {
    return scale.rangeExtent ? scale.rangeExtent() : d3_scaleExtent(scale.range());
  }
  function d3_scale_bilinear(domain, range, uninterpolate, interpolate) {
    var u = uninterpolate(domain[0], domain[1]), i = interpolate(range[0], range[1]);
    return function(x) {
      return i(u(x));
    };
  }
  function d3_scale_nice(domain, nice) {
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], dx;
    if (x1 < x0) {
      dx = i0, i0 = i1, i1 = dx;
      dx = x0, x0 = x1, x1 = dx;
    }
    domain[i0] = nice.floor(x0);
    domain[i1] = nice.ceil(x1);
    return domain;
  }
  function d3_scale_niceStep(step) {
    return step ? {
      floor: function(x) {
        return Math.floor(x / step) * step;
      },
      ceil: function(x) {
        return Math.ceil(x / step) * step;
      }
    } : d3_scale_niceIdentity;
  }
  var d3_scale_niceIdentity = {
    floor: d3_identity,
    ceil: d3_identity
  };
  function d3_scale_polylinear(domain, range, uninterpolate, interpolate) {
    var u = [], i = [], j = 0, k = Math.min(domain.length, range.length) - 1;
    if (domain[k] < domain[0]) {
      domain = domain.slice().reverse();
      range = range.slice().reverse();
    }
    while (++j <= k) {
      u.push(uninterpolate(domain[j - 1], domain[j]));
      i.push(interpolate(range[j - 1], range[j]));
    }
    return function(x) {
      var j = d3.bisect(domain, x, 1, k) - 1;
      return i[j](u[j](x));
    };
  }
  d3.scale.linear = function() {
    return d3_scale_linear([ 0, 1 ], [ 0, 1 ], d3_interpolate, false);
  };
  function d3_scale_linear(domain, range, interpolate, clamp) {
    var output, input;
    function rescale() {
      var linear = Math.min(domain.length, range.length) > 2 ? d3_scale_polylinear : d3_scale_bilinear, uninterpolate = clamp ? d3_uninterpolateClamp : d3_uninterpolateNumber;
      output = linear(domain, range, uninterpolate, interpolate);
      input = linear(range, domain, uninterpolate, d3_interpolate);
      return scale;
    }
    function scale(x) {
      return output(x);
    }
    scale.invert = function(y) {
      return input(y);
    };
    scale.domain = function(x) {
      if (!arguments.length) return domain;
      domain = x.map(Number);
      return rescale();
    };
    scale.range = function(x) {
      if (!arguments.length) return range;
      range = x;
      return rescale();
    };
    scale.rangeRound = function(x) {
      return scale.range(x).interpolate(d3_interpolateRound);
    };
    scale.clamp = function(x) {
      if (!arguments.length) return clamp;
      clamp = x;
      return rescale();
    };
    scale.interpolate = function(x) {
      if (!arguments.length) return interpolate;
      interpolate = x;
      return rescale();
    };
    scale.ticks = function(m) {
      return d3_scale_linearTicks(domain, m);
    };
    scale.tickFormat = function(m, format) {
      return d3_scale_linearTickFormat(domain, m, format);
    };
    scale.nice = function(m) {
      d3_scale_linearNice(domain, m);
      return rescale();
    };
    scale.copy = function() {
      return d3_scale_linear(domain, range, interpolate, clamp);
    };
    return rescale();
  }
  function d3_scale_linearRebind(scale, linear) {
    return d3.rebind(scale, linear, "range", "rangeRound", "interpolate", "clamp");
  }
  function d3_scale_linearNice(domain, m) {
    d3_scale_nice(domain, d3_scale_niceStep(d3_scale_linearTickRange(domain, m)[2]));
    d3_scale_nice(domain, d3_scale_niceStep(d3_scale_linearTickRange(domain, m)[2]));
    return domain;
  }
  function d3_scale_linearTickRange(domain, m) {
    if (m == null) m = 10;
    var extent = d3_scaleExtent(domain), span = extent[1] - extent[0], step = Math.pow(10, Math.floor(Math.log(span / m) / Math.LN10)), err = m / span * step;
    if (err <= .15) step *= 10; else if (err <= .35) step *= 5; else if (err <= .75) step *= 2;
    extent[0] = Math.ceil(extent[0] / step) * step;
    extent[1] = Math.floor(extent[1] / step) * step + step * .5;
    extent[2] = step;
    return extent;
  }
  function d3_scale_linearTicks(domain, m) {
    return d3.range.apply(d3, d3_scale_linearTickRange(domain, m));
  }
  var d3_scale_linearFormatSignificant = {
    s: 1,
    g: 1,
    p: 1,
    r: 1,
    e: 1
  };
  function d3_scale_linearPrecision(value) {
    return -Math.floor(Math.log(value) / Math.LN10 + .01);
  }
  function d3_scale_linearFormatPrecision(type, range) {
    var p = d3_scale_linearPrecision(range[2]);
    return type in d3_scale_linearFormatSignificant ? Math.abs(p - d3_scale_linearPrecision(Math.max(abs(range[0]), abs(range[1])))) + +(type !== "e") : p - (type === "%") * 2;
  }
  d3.scale.log = function() {
    return d3_scale_log(d3.scale.linear().domain([ 0, 1 ]), 10, true, [ 1, 10 ]);
  };
  function d3_scale_log(linear, base, positive, domain) {
    function log(x) {
      return (positive ? Math.log(x < 0 ? 0 : x) : -Math.log(x > 0 ? 0 : -x)) / Math.log(base);
    }
    function pow(x) {
      return positive ? Math.pow(base, x) : -Math.pow(base, -x);
    }
    function scale(x) {
      return linear(log(x));
    }
    scale.invert = function(x) {
      return pow(linear.invert(x));
    };
    scale.domain = function(x) {
      if (!arguments.length) return domain;
      positive = x[0] >= 0;
      linear.domain((domain = x.map(Number)).map(log));
      return scale;
    };
    scale.base = function(_) {
      if (!arguments.length) return base;
      base = +_;
      linear.domain(domain.map(log));
      return scale;
    };
    scale.nice = function() {
      var niced = d3_scale_nice(domain.map(log), positive ? Math : d3_scale_logNiceNegative);
      linear.domain(niced);
      domain = niced.map(pow);
      return scale;
    };
    scale.ticks = function() {
      var extent = d3_scaleExtent(domain), ticks = [], u = extent[0], v = extent[1], i = Math.floor(log(u)), j = Math.ceil(log(v)), n = base % 1 ? 2 : base;
      if (isFinite(j - i)) {
        if (positive) {
          for (;i < j; i++) for (var k = 1; k < n; k++) ticks.push(pow(i) * k);
          ticks.push(pow(i));
        } else {
          ticks.push(pow(i));
          for (;i++ < j; ) for (var k = n - 1; k > 0; k--) ticks.push(pow(i) * k);
        }
        for (i = 0; ticks[i] < u; i++) {}
        for (j = ticks.length; ticks[j - 1] > v; j--) {}
        ticks = ticks.slice(i, j);
      }
      return ticks;
    };
    scale.copy = function() {
      return d3_scale_log(linear.copy(), base, positive, domain);
    };
    return d3_scale_linearRebind(scale, linear);
  }
  var d3_scale_logNiceNegative = {
    floor: function(x) {
      return -Math.ceil(-x);
    },
    ceil: function(x) {
      return -Math.floor(-x);
    }
  };
  d3.scale.pow = function() {
    return d3_scale_pow(d3.scale.linear(), 1, [ 0, 1 ]);
  };
  function d3_scale_pow(linear, exponent, domain) {
    var powp = d3_scale_powPow(exponent), powb = d3_scale_powPow(1 / exponent);
    function scale(x) {
      return linear(powp(x));
    }
    scale.invert = function(x) {
      return powb(linear.invert(x));
    };
    scale.domain = function(x) {
      if (!arguments.length) return domain;
      linear.domain((domain = x.map(Number)).map(powp));
      return scale;
    };
    scale.ticks = function(m) {
      return d3_scale_linearTicks(domain, m);
    };
    scale.tickFormat = function(m, format) {
      return d3_scale_linearTickFormat(domain, m, format);
    };
    scale.nice = function(m) {
      return scale.domain(d3_scale_linearNice(domain, m));
    };
    scale.exponent = function(x) {
      if (!arguments.length) return exponent;
      powp = d3_scale_powPow(exponent = x);
      powb = d3_scale_powPow(1 / exponent);
      linear.domain(domain.map(powp));
      return scale;
    };
    scale.copy = function() {
      return d3_scale_pow(linear.copy(), exponent, domain);
    };
    return d3_scale_linearRebind(scale, linear);
  }
  function d3_scale_powPow(e) {
    return function(x) {
      return x < 0 ? -Math.pow(-x, e) : Math.pow(x, e);
    };
  }
  d3.scale.sqrt = function() {
    return d3.scale.pow().exponent(.5);
  };
  d3.scale.ordinal = function() {
    return d3_scale_ordinal([], {
      t: "range",
      a: [ [] ]
    });
  };
  function d3_scale_ordinal(domain, ranger) {
    var index, range, rangeBand;
    function scale(x) {
      return range[((index.get(x) || (ranger.t === "range" ? index.set(x, domain.push(x)) : NaN)) - 1) % range.length];
    }
    function steps(start, step) {
      return d3.range(domain.length).map(function(i) {
        return start + step * i;
      });
    }
    scale.domain = function(x) {
      if (!arguments.length) return domain;
      domain = [];
      index = new d3_Map();
      var i = -1, n = x.length, xi;
      while (++i < n) if (!index.has(xi = x[i])) index.set(xi, domain.push(xi));
      return scale[ranger.t].apply(scale, ranger.a);
    };
    scale.range = function(x) {
      if (!arguments.length) return range;
      range = x;
      rangeBand = 0;
      ranger = {
        t: "range",
        a: arguments
      };
      return scale;
    };
    scale.rangePoints = function(x, padding) {
      if (arguments.length < 2) padding = 0;
      var start = x[0], stop = x[1], step = domain.length < 2 ? (start = (start + stop) / 2, 
      0) : (stop - start) / (domain.length - 1 + padding);
      range = steps(start + step * padding / 2, step);
      rangeBand = 0;
      ranger = {
        t: "rangePoints",
        a: arguments
      };
      return scale;
    };
    scale.rangeRoundPoints = function(x, padding) {
      if (arguments.length < 2) padding = 0;
      var start = x[0], stop = x[1], step = domain.length < 2 ? (start = stop = Math.round((start + stop) / 2), 
      0) : (stop - start) / (domain.length - 1 + padding) | 0;
      range = steps(start + Math.round(step * padding / 2 + (stop - start - (domain.length - 1 + padding) * step) / 2), step);
      rangeBand = 0;
      ranger = {
        t: "rangeRoundPoints",
        a: arguments
      };
      return scale;
    };
    scale.rangeBands = function(x, padding, outerPadding) {
      if (arguments.length < 2) padding = 0;
      if (arguments.length < 3) outerPadding = padding;
      var reverse = x[1] < x[0], start = x[reverse - 0], stop = x[1 - reverse], step = (stop - start) / (domain.length - padding + 2 * outerPadding);
      range = steps(start + step * outerPadding, step);
      if (reverse) range.reverse();
      rangeBand = step * (1 - padding);
      ranger = {
        t: "rangeBands",
        a: arguments
      };
      return scale;
    };
    scale.rangeRoundBands = function(x, padding, outerPadding) {
      if (arguments.length < 2) padding = 0;
      if (arguments.length < 3) outerPadding = padding;
      var reverse = x[1] < x[0], start = x[reverse - 0], stop = x[1 - reverse], step = Math.floor((stop - start) / (domain.length - padding + 2 * outerPadding));
      range = steps(start + Math.round((stop - start - (domain.length - padding) * step) / 2), step);
      if (reverse) range.reverse();
      rangeBand = Math.round(step * (1 - padding));
      ranger = {
        t: "rangeRoundBands",
        a: arguments
      };
      return scale;
    };
    scale.rangeBand = function() {
      return rangeBand;
    };
    scale.rangeExtent = function() {
      return d3_scaleExtent(ranger.a[0]);
    };
    scale.copy = function() {
      return d3_scale_ordinal(domain, ranger);
    };
    return scale.domain(domain);
  }
  d3.scale.category10 = function() {
    return d3.scale.ordinal().range(d3_category10);
  };
  d3.scale.category20 = function() {
    return d3.scale.ordinal().range(d3_category20);
  };
  d3.scale.category20b = function() {
    return d3.scale.ordinal().range(d3_category20b);
  };
  d3.scale.category20c = function() {
    return d3.scale.ordinal().range(d3_category20c);
  };
  var d3_category10 = [ 2062260, 16744206, 2924588, 14034728, 9725885, 9197131, 14907330, 8355711, 12369186, 1556175 ].map(d3_rgbString);
  var d3_category20 = [ 2062260, 11454440, 16744206, 16759672, 2924588, 10018698, 14034728, 16750742, 9725885, 12955861, 9197131, 12885140, 14907330, 16234194, 8355711, 13092807, 12369186, 14408589, 1556175, 10410725 ].map(d3_rgbString);
  var d3_category20b = [ 3750777, 5395619, 7040719, 10264286, 6519097, 9216594, 11915115, 13556636, 9202993, 12426809, 15186514, 15190932, 8666169, 11356490, 14049643, 15177372, 8077683, 10834324, 13528509, 14589654 ].map(d3_rgbString);
  var d3_category20c = [ 3244733, 7057110, 10406625, 13032431, 15095053, 16616764, 16625259, 16634018, 3253076, 7652470, 10607003, 13101504, 7695281, 10394312, 12369372, 14342891, 6513507, 9868950, 12434877, 14277081 ].map(d3_rgbString);
  d3.scale.quantile = function() {
    return d3_scale_quantile([], []);
  };
  function d3_scale_quantile(domain, range) {
    var thresholds;
    function rescale() {
      var k = 0, q = range.length;
      thresholds = [];
      while (++k < q) thresholds[k - 1] = d3.quantile(domain, k / q);
      return scale;
    }
    function scale(x) {
      if (!isNaN(x = +x)) return range[d3.bisect(thresholds, x)];
    }
    scale.domain = function(x) {
      if (!arguments.length) return domain;
      domain = x.map(d3_number).filter(d3_numeric).sort(d3_ascending);
      return rescale();
    };
    scale.range = function(x) {
      if (!arguments.length) return range;
      range = x;
      return rescale();
    };
    scale.quantiles = function() {
      return thresholds;
    };
    scale.invertExtent = function(y) {
      y = range.indexOf(y);
      return y < 0 ? [ NaN, NaN ] : [ y > 0 ? thresholds[y - 1] : domain[0], y < thresholds.length ? thresholds[y] : domain[domain.length - 1] ];
    };
    scale.copy = function() {
      return d3_scale_quantile(domain, range);
    };
    return rescale();
  }
  d3.scale.quantize = function() {
    return d3_scale_quantize(0, 1, [ 0, 1 ]);
  };
  function d3_scale_quantize(x0, x1, range) {
    var kx, i;
    function scale(x) {
      return range[Math.max(0, Math.min(i, Math.floor(kx * (x - x0))))];
    }
    function rescale() {
      kx = range.length / (x1 - x0);
      i = range.length - 1;
      return scale;
    }
    scale.domain = function(x) {
      if (!arguments.length) return [ x0, x1 ];
      x0 = +x[0];
      x1 = +x[x.length - 1];
      return rescale();
    };
    scale.range = function(x) {
      if (!arguments.length) return range;
      range = x;
      return rescale();
    };
    scale.invertExtent = function(y) {
      y = range.indexOf(y);
      y = y < 0 ? NaN : y / kx + x0;
      return [ y, y + 1 / kx ];
    };
    scale.copy = function() {
      return d3_scale_quantize(x0, x1, range);
    };
    return rescale();
  }
  d3.scale.threshold = function() {
    return d3_scale_threshold([ .5 ], [ 0, 1 ]);
  };
  function d3_scale_threshold(domain, range) {
    function scale(x) {
      if (x <= x) return range[d3.bisect(domain, x)];
    }
    scale.domain = function(_) {
      if (!arguments.length) return domain;
      domain = _;
      return scale;
    };
    scale.range = function(_) {
      if (!arguments.length) return range;
      range = _;
      return scale;
    };
    scale.invertExtent = function(y) {
      y = range.indexOf(y);
      return [ domain[y - 1], domain[y] ];
    };
    scale.copy = function() {
      return d3_scale_threshold(domain, range);
    };
    return scale;
  }
  d3.scale.identity = function() {
    return d3_scale_identity([ 0, 1 ]);
  };
  function d3_scale_identity(domain) {
    function identity(x) {
      return +x;
    }
    identity.invert = identity;
    identity.domain = identity.range = function(x) {
      if (!arguments.length) return domain;
      domain = x.map(identity);
      return identity;
    };
    identity.ticks = function(m) {
      return d3_scale_linearTicks(domain, m);
    };
    identity.tickFormat = function(m, format) {
      return d3_scale_linearTickFormat(domain, m, format);
    };
    identity.copy = function() {
      return d3_scale_identity(domain);
    };
    return identity;
  }
  d3.svg = {};
  function d3_zero() {
    return 0;
  }
  d3.svg.arc = function() {
    var innerRadius = d3_svg_arcInnerRadius, outerRadius = d3_svg_arcOuterRadius, cornerRadius = d3_zero, padRadius = d3_svg_arcAuto, startAngle = d3_svg_arcStartAngle, endAngle = d3_svg_arcEndAngle, padAngle = d3_svg_arcPadAngle;
    function arc() {
      var r0 = Math.max(0, +innerRadius.apply(this, arguments)), r1 = Math.max(0, +outerRadius.apply(this, arguments)), a0 = startAngle.apply(this, arguments) - halfπ, a1 = endAngle.apply(this, arguments) - halfπ, da = Math.abs(a1 - a0), cw = a0 > a1 ? 0 : 1;
      if (r1 < r0) rc = r1, r1 = r0, r0 = rc;
      if (da >= τε) return circleSegment(r1, cw) + (r0 ? circleSegment(r0, 1 - cw) : "") + "Z";
      var rc, cr, rp, ap, p0 = 0, p1 = 0, x0, y0, x1, y1, x2, y2, x3, y3, path = [];
      if (ap = (+padAngle.apply(this, arguments) || 0) / 2) {
        rp = padRadius === d3_svg_arcAuto ? Math.sqrt(r0 * r0 + r1 * r1) : +padRadius.apply(this, arguments);
        if (!cw) p1 *= -1;
        if (r1) p1 = d3_asin(rp / r1 * Math.sin(ap));
        if (r0) p0 = d3_asin(rp / r0 * Math.sin(ap));
      }
      if (r1) {
        x0 = r1 * Math.cos(a0 + p1);
        y0 = r1 * Math.sin(a0 + p1);
        x1 = r1 * Math.cos(a1 - p1);
        y1 = r1 * Math.sin(a1 - p1);
        var l1 = Math.abs(a1 - a0 - 2 * p1) <= π ? 0 : 1;
        if (p1 && d3_svg_arcSweep(x0, y0, x1, y1) === cw ^ l1) {
          var h1 = (a0 + a1) / 2;
          x0 = r1 * Math.cos(h1);
          y0 = r1 * Math.sin(h1);
          x1 = y1 = null;
        }
      } else {
        x0 = y0 = 0;
      }
      if (r0) {
        x2 = r0 * Math.cos(a1 - p0);
        y2 = r0 * Math.sin(a1 - p0);
        x3 = r0 * Math.cos(a0 + p0);
        y3 = r0 * Math.sin(a0 + p0);
        var l0 = Math.abs(a0 - a1 + 2 * p0) <= π ? 0 : 1;
        if (p0 && d3_svg_arcSweep(x2, y2, x3, y3) === 1 - cw ^ l0) {
          var h0 = (a0 + a1) / 2;
          x2 = r0 * Math.cos(h0);
          y2 = r0 * Math.sin(h0);
          x3 = y3 = null;
        }
      } else {
        x2 = y2 = 0;
      }
      if (da > ε && (rc = Math.min(Math.abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments))) > .001) {
        cr = r0 < r1 ^ cw ? 0 : 1;
        var rc1 = rc, rc0 = rc;
        if (da < π) {
          var oc = x3 == null ? [ x2, y2 ] : x1 == null ? [ x0, y0 ] : d3_geom_polygonIntersect([ x0, y0 ], [ x3, y3 ], [ x1, y1 ], [ x2, y2 ]), ax = x0 - oc[0], ay = y0 - oc[1], bx = x1 - oc[0], by = y1 - oc[1], kc = 1 / Math.sin(Math.acos((ax * bx + ay * by) / (Math.sqrt(ax * ax + ay * ay) * Math.sqrt(bx * bx + by * by))) / 2), lc = Math.sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
          rc0 = Math.min(rc, (r0 - lc) / (kc - 1));
          rc1 = Math.min(rc, (r1 - lc) / (kc + 1));
        }
        if (x1 != null) {
          var t30 = d3_svg_arcCornerTangents(x3 == null ? [ x2, y2 ] : [ x3, y3 ], [ x0, y0 ], r1, rc1, cw), t12 = d3_svg_arcCornerTangents([ x1, y1 ], [ x2, y2 ], r1, rc1, cw);
          if (rc === rc1) {
            path.push("M", t30[0], "A", rc1, ",", rc1, " 0 0,", cr, " ", t30[1], "A", r1, ",", r1, " 0 ", 1 - cw ^ d3_svg_arcSweep(t30[1][0], t30[1][1], t12[1][0], t12[1][1]), ",", cw, " ", t12[1], "A", rc1, ",", rc1, " 0 0,", cr, " ", t12[0]);
          } else {
            path.push("M", t30[0], "A", rc1, ",", rc1, " 0 1,", cr, " ", t12[0]);
          }
        } else {
          path.push("M", x0, ",", y0);
        }
        if (x3 != null) {
          var t03 = d3_svg_arcCornerTangents([ x0, y0 ], [ x3, y3 ], r0, -rc0, cw), t21 = d3_svg_arcCornerTangents([ x2, y2 ], x1 == null ? [ x0, y0 ] : [ x1, y1 ], r0, -rc0, cw);
          if (rc === rc0) {
            path.push("L", t21[0], "A", rc0, ",", rc0, " 0 0,", cr, " ", t21[1], "A", r0, ",", r0, " 0 ", cw ^ d3_svg_arcSweep(t21[1][0], t21[1][1], t03[1][0], t03[1][1]), ",", 1 - cw, " ", t03[1], "A", rc0, ",", rc0, " 0 0,", cr, " ", t03[0]);
          } else {
            path.push("L", t21[0], "A", rc0, ",", rc0, " 0 0,", cr, " ", t03[0]);
          }
        } else {
          path.push("L", x2, ",", y2);
        }
      } else {
        path.push("M", x0, ",", y0);
        if (x1 != null) path.push("A", r1, ",", r1, " 0 ", l1, ",", cw, " ", x1, ",", y1);
        path.push("L", x2, ",", y2);
        if (x3 != null) path.push("A", r0, ",", r0, " 0 ", l0, ",", 1 - cw, " ", x3, ",", y3);
      }
      path.push("Z");
      return path.join("");
    }
    function circleSegment(r1, cw) {
      return "M0," + r1 + "A" + r1 + "," + r1 + " 0 1," + cw + " 0," + -r1 + "A" + r1 + "," + r1 + " 0 1," + cw + " 0," + r1;
    }
    arc.innerRadius = function(v) {
      if (!arguments.length) return innerRadius;
      innerRadius = d3_functor(v);
      return arc;
    };
    arc.outerRadius = function(v) {
      if (!arguments.length) return outerRadius;
      outerRadius = d3_functor(v);
      return arc;
    };
    arc.cornerRadius = function(v) {
      if (!arguments.length) return cornerRadius;
      cornerRadius = d3_functor(v);
      return arc;
    };
    arc.padRadius = function(v) {
      if (!arguments.length) return padRadius;
      padRadius = v == d3_svg_arcAuto ? d3_svg_arcAuto : d3_functor(v);
      return arc;
    };
    arc.startAngle = function(v) {
      if (!arguments.length) return startAngle;
      startAngle = d3_functor(v);
      return arc;
    };
    arc.endAngle = function(v) {
      if (!arguments.length) return endAngle;
      endAngle = d3_functor(v);
      return arc;
    };
    arc.padAngle = function(v) {
      if (!arguments.length) return padAngle;
      padAngle = d3_functor(v);
      return arc;
    };
    arc.centroid = function() {
      var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - halfπ;
      return [ Math.cos(a) * r, Math.sin(a) * r ];
    };
    return arc;
  };
  var d3_svg_arcAuto = "auto";
  function d3_svg_arcInnerRadius(d) {
    return d.innerRadius;
  }
  function d3_svg_arcOuterRadius(d) {
    return d.outerRadius;
  }
  function d3_svg_arcStartAngle(d) {
    return d.startAngle;
  }
  function d3_svg_arcEndAngle(d) {
    return d.endAngle;
  }
  function d3_svg_arcPadAngle(d) {
    return d && d.padAngle;
  }
  function d3_svg_arcSweep(x0, y0, x1, y1) {
    return (x0 - x1) * y0 - (y0 - y1) * x0 > 0 ? 0 : 1;
  }
  function d3_svg_arcCornerTangents(p0, p1, r1, rc, cw) {
    var x01 = p0[0] - p1[0], y01 = p0[1] - p1[1], lo = (cw ? rc : -rc) / Math.sqrt(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x1 = p0[0] + ox, y1 = p0[1] + oy, x2 = p1[0] + ox, y2 = p1[1] + oy, x3 = (x1 + x2) / 2, y3 = (y1 + y2) / 2, dx = x2 - x1, dy = y2 - y1, d2 = dx * dx + dy * dy, r = r1 - rc, D = x1 * y2 - x2 * y1, d = (dy < 0 ? -1 : 1) * Math.sqrt(Math.max(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x3, dy0 = cy0 - y3, dx1 = cx1 - x3, dy1 = cy1 - y3;
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return [ [ cx0 - ox, cy0 - oy ], [ cx0 * r1 / r, cy0 * r1 / r ] ];
  }
  function d3_true() {
    return true;
  }
  function d3_svg_line(projection) {
    var x = d3_geom_pointX, y = d3_geom_pointY, defined = d3_true, interpolate = d3_svg_lineLinear, interpolateKey = interpolate.key, tension = .7;
    function line(data) {
      var segments = [], points = [], i = -1, n = data.length, d, fx = d3_functor(x), fy = d3_functor(y);
      function segment() {
        segments.push("M", interpolate(projection(points), tension));
      }
      while (++i < n) {
        if (defined.call(this, d = data[i], i)) {
          points.push([ +fx.call(this, d, i), +fy.call(this, d, i) ]);
        } else if (points.length) {
          segment();
          points = [];
        }
      }
      if (points.length) segment();
      return segments.length ? segments.join("") : null;
    }
    line.x = function(_) {
      if (!arguments.length) return x;
      x = _;
      return line;
    };
    line.y = function(_) {
      if (!arguments.length) return y;
      y = _;
      return line;
    };
    line.defined = function(_) {
      if (!arguments.length) return defined;
      defined = _;
      return line;
    };
    line.interpolate = function(_) {
      if (!arguments.length) return interpolateKey;
      if (typeof _ === "function") interpolateKey = interpolate = _; else interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
      return line;
    };
    line.tension = function(_) {
      if (!arguments.length) return tension;
      tension = _;
      return line;
    };
    return line;
  }
  d3.svg.line = function() {
    return d3_svg_line(d3_identity);
  };
  var d3_svg_lineInterpolators = d3.map({
    linear: d3_svg_lineLinear,
    "linear-closed": d3_svg_lineLinearClosed,
    step: d3_svg_lineStep,
    "step-before": d3_svg_lineStepBefore,
    "step-after": d3_svg_lineStepAfter,
    basis: d3_svg_lineBasis,
    "basis-open": d3_svg_lineBasisOpen,
    "basis-closed": d3_svg_lineBasisClosed,
    bundle: d3_svg_lineBundle,
    cardinal: d3_svg_lineCardinal,
    "cardinal-open": d3_svg_lineCardinalOpen,
    "cardinal-closed": d3_svg_lineCardinalClosed,
    monotone: d3_svg_lineMonotone
  });
  d3_svg_lineInterpolators.forEach(function(key, value) {
    value.key = key;
    value.closed = /-closed$/.test(key);
  });
  function d3_svg_lineLinear(points) {
    return points.length > 1 ? points.join("L") : points + "Z";
  }
  function d3_svg_lineLinearClosed(points) {
    return points.join("L") + "Z";
  }
  function d3_svg_lineStep(points) {
    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
    while (++i < n) path.push("H", (p[0] + (p = points[i])[0]) / 2, "V", p[1]);
    if (n > 1) path.push("H", p[0]);
    return path.join("");
  }
  function d3_svg_lineStepBefore(points) {
    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
    while (++i < n) path.push("V", (p = points[i])[1], "H", p[0]);
    return path.join("");
  }
  function d3_svg_lineStepAfter(points) {
    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
    while (++i < n) path.push("H", (p = points[i])[0], "V", p[1]);
    return path.join("");
  }
  function d3_svg_lineCardinalOpen(points, tension) {
    return points.length < 4 ? d3_svg_lineLinear(points) : points[1] + d3_svg_lineHermite(points.slice(1, -1), d3_svg_lineCardinalTangents(points, tension));
  }
  function d3_svg_lineCardinalClosed(points, tension) {
    return points.length < 3 ? d3_svg_lineLinearClosed(points) : points[0] + d3_svg_lineHermite((points.push(points[0]), 
    points), d3_svg_lineCardinalTangents([ points[points.length - 2] ].concat(points, [ points[1] ]), tension));
  }
  function d3_svg_lineCardinal(points, tension) {
    return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineCardinalTangents(points, tension));
  }
  function d3_svg_lineHermite(points, tangents) {
    if (tangents.length < 1 || points.length != tangents.length && points.length != tangents.length + 2) {
      return d3_svg_lineLinear(points);
    }
    var quad = points.length != tangents.length, path = "", p0 = points[0], p = points[1], t0 = tangents[0], t = t0, pi = 1;
    if (quad) {
      path += "Q" + (p[0] - t0[0] * 2 / 3) + "," + (p[1] - t0[1] * 2 / 3) + "," + p[0] + "," + p[1];
      p0 = points[1];
      pi = 2;
    }
    if (tangents.length > 1) {
      t = tangents[1];
      p = points[pi];
      pi++;
      path += "C" + (p0[0] + t0[0]) + "," + (p0[1] + t0[1]) + "," + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
      for (var i = 2; i < tangents.length; i++, pi++) {
        p = points[pi];
        t = tangents[i];
        path += "S" + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
      }
    }
    if (quad) {
      var lp = points[pi];
      path += "Q" + (p[0] + t[0] * 2 / 3) + "," + (p[1] + t[1] * 2 / 3) + "," + lp[0] + "," + lp[1];
    }
    return path;
  }
  function d3_svg_lineCardinalTangents(points, tension) {
    var tangents = [], a = (1 - tension) / 2, p0, p1 = points[0], p2 = points[1], i = 1, n = points.length;
    while (++i < n) {
      p0 = p1;
      p1 = p2;
      p2 = points[i];
      tangents.push([ a * (p2[0] - p0[0]), a * (p2[1] - p0[1]) ]);
    }
    return tangents;
  }
  function d3_svg_lineBasis(points) {
    if (points.length < 3) return d3_svg_lineLinear(points);
    var i = 1, n = points.length, pi = points[0], x0 = pi[0], y0 = pi[1], px = [ x0, x0, x0, (pi = points[1])[0] ], py = [ y0, y0, y0, pi[1] ], path = [ x0, ",", y0, "L", d3_svg_lineDot4(d3_svg_lineBasisBezier3, px), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, py) ];
    points.push(points[n - 1]);
    while (++i <= n) {
      pi = points[i];
      px.shift();
      px.push(pi[0]);
      py.shift();
      py.push(pi[1]);
      d3_svg_lineBasisBezier(path, px, py);
    }
    points.pop();
    path.push("L", pi);
    return path.join("");
  }
  function d3_svg_lineBasisOpen(points) {
    if (points.length < 4) return d3_svg_lineLinear(points);
    var path = [], i = -1, n = points.length, pi, px = [ 0 ], py = [ 0 ];
    while (++i < 3) {
      pi = points[i];
      px.push(pi[0]);
      py.push(pi[1]);
    }
    path.push(d3_svg_lineDot4(d3_svg_lineBasisBezier3, px) + "," + d3_svg_lineDot4(d3_svg_lineBasisBezier3, py));
    --i;
    while (++i < n) {
      pi = points[i];
      px.shift();
      px.push(pi[0]);
      py.shift();
      py.push(pi[1]);
      d3_svg_lineBasisBezier(path, px, py);
    }
    return path.join("");
  }
  function d3_svg_lineBasisClosed(points) {
    var path, i = -1, n = points.length, m = n + 4, pi, px = [], py = [];
    while (++i < 4) {
      pi = points[i % n];
      px.push(pi[0]);
      py.push(pi[1]);
    }
    path = [ d3_svg_lineDot4(d3_svg_lineBasisBezier3, px), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, py) ];
    --i;
    while (++i < m) {
      pi = points[i % n];
      px.shift();
      px.push(pi[0]);
      py.shift();
      py.push(pi[1]);
      d3_svg_lineBasisBezier(path, px, py);
    }
    return path.join("");
  }
  function d3_svg_lineBundle(points, tension) {
    var n = points.length - 1;
    if (n) {
      var x0 = points[0][0], y0 = points[0][1], dx = points[n][0] - x0, dy = points[n][1] - y0, i = -1, p, t;
      while (++i <= n) {
        p = points[i];
        t = i / n;
        p[0] = tension * p[0] + (1 - tension) * (x0 + t * dx);
        p[1] = tension * p[1] + (1 - tension) * (y0 + t * dy);
      }
    }
    return d3_svg_lineBasis(points);
  }
  function d3_svg_lineDot4(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3];
  }
  var d3_svg_lineBasisBezier1 = [ 0, 2 / 3, 1 / 3, 0 ], d3_svg_lineBasisBezier2 = [ 0, 1 / 3, 2 / 3, 0 ], d3_svg_lineBasisBezier3 = [ 0, 1 / 6, 2 / 3, 1 / 6 ];
  function d3_svg_lineBasisBezier(path, x, y) {
    path.push("C", d3_svg_lineDot4(d3_svg_lineBasisBezier1, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier1, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, y));
  }
  function d3_svg_lineSlope(p0, p1) {
    return (p1[1] - p0[1]) / (p1[0] - p0[0]);
  }
  function d3_svg_lineFiniteDifferences(points) {
    var i = 0, j = points.length - 1, m = [], p0 = points[0], p1 = points[1], d = m[0] = d3_svg_lineSlope(p0, p1);
    while (++i < j) {
      m[i] = (d + (d = d3_svg_lineSlope(p0 = p1, p1 = points[i + 1]))) / 2;
    }
    m[i] = d;
    return m;
  }
  function d3_svg_lineMonotoneTangents(points) {
    var tangents = [], d, a, b, s, m = d3_svg_lineFiniteDifferences(points), i = -1, j = points.length - 1;
    while (++i < j) {
      d = d3_svg_lineSlope(points[i], points[i + 1]);
      if (abs(d) < ε) {
        m[i] = m[i + 1] = 0;
      } else {
        a = m[i] / d;
        b = m[i + 1] / d;
        s = a * a + b * b;
        if (s > 9) {
          s = d * 3 / Math.sqrt(s);
          m[i] = s * a;
          m[i + 1] = s * b;
        }
      }
    }
    i = -1;
    while (++i <= j) {
      s = (points[Math.min(j, i + 1)][0] - points[Math.max(0, i - 1)][0]) / (6 * (1 + m[i] * m[i]));
      tangents.push([ s || 0, m[i] * s || 0 ]);
    }
    return tangents;
  }
  function d3_svg_lineMonotone(points) {
    return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineMonotoneTangents(points));
  }
  d3.svg.line.radial = function() {
    var line = d3_svg_line(d3_svg_lineRadial);
    line.radius = line.x, delete line.x;
    line.angle = line.y, delete line.y;
    return line;
  };
  function d3_svg_lineRadial(points) {
    var point, i = -1, n = points.length, r, a;
    while (++i < n) {
      point = points[i];
      r = point[0];
      a = point[1] - halfπ;
      point[0] = r * Math.cos(a);
      point[1] = r * Math.sin(a);
    }
    return points;
  }
  function d3_svg_area(projection) {
    var x0 = d3_geom_pointX, x1 = d3_geom_pointX, y0 = 0, y1 = d3_geom_pointY, defined = d3_true, interpolate = d3_svg_lineLinear, interpolateKey = interpolate.key, interpolateReverse = interpolate, L = "L", tension = .7;
    function area(data) {
      var segments = [], points0 = [], points1 = [], i = -1, n = data.length, d, fx0 = d3_functor(x0), fy0 = d3_functor(y0), fx1 = x0 === x1 ? function() {
        return x;
      } : d3_functor(x1), fy1 = y0 === y1 ? function() {
        return y;
      } : d3_functor(y1), x, y;
      function segment() {
        segments.push("M", interpolate(projection(points1), tension), L, interpolateReverse(projection(points0.reverse()), tension), "Z");
      }
      while (++i < n) {
        if (defined.call(this, d = data[i], i)) {
          points0.push([ x = +fx0.call(this, d, i), y = +fy0.call(this, d, i) ]);
          points1.push([ +fx1.call(this, d, i), +fy1.call(this, d, i) ]);
        } else if (points0.length) {
          segment();
          points0 = [];
          points1 = [];
        }
      }
      if (points0.length) segment();
      return segments.length ? segments.join("") : null;
    }
    area.x = function(_) {
      if (!arguments.length) return x1;
      x0 = x1 = _;
      return area;
    };
    area.x0 = function(_) {
      if (!arguments.length) return x0;
      x0 = _;
      return area;
    };
    area.x1 = function(_) {
      if (!arguments.length) return x1;
      x1 = _;
      return area;
    };
    area.y = function(_) {
      if (!arguments.length) return y1;
      y0 = y1 = _;
      return area;
    };
    area.y0 = function(_) {
      if (!arguments.length) return y0;
      y0 = _;
      return area;
    };
    area.y1 = function(_) {
      if (!arguments.length) return y1;
      y1 = _;
      return area;
    };
    area.defined = function(_) {
      if (!arguments.length) return defined;
      defined = _;
      return area;
    };
    area.interpolate = function(_) {
      if (!arguments.length) return interpolateKey;
      if (typeof _ === "function") interpolateKey = interpolate = _; else interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
      interpolateReverse = interpolate.reverse || interpolate;
      L = interpolate.closed ? "M" : "L";
      return area;
    };
    area.tension = function(_) {
      if (!arguments.length) return tension;
      tension = _;
      return area;
    };
    return area;
  }
  d3_svg_lineStepBefore.reverse = d3_svg_lineStepAfter;
  d3_svg_lineStepAfter.reverse = d3_svg_lineStepBefore;
  d3.svg.area = function() {
    return d3_svg_area(d3_identity);
  };
  d3.svg.area.radial = function() {
    var area = d3_svg_area(d3_svg_lineRadial);
    area.radius = area.x, delete area.x;
    area.innerRadius = area.x0, delete area.x0;
    area.outerRadius = area.x1, delete area.x1;
    area.angle = area.y, delete area.y;
    area.startAngle = area.y0, delete area.y0;
    area.endAngle = area.y1, delete area.y1;
    return area;
  };
  function d3_source(d) {
    return d.source;
  }
  function d3_target(d) {
    return d.target;
  }
  d3.svg.chord = function() {
    var source = d3_source, target = d3_target, radius = d3_svg_chordRadius, startAngle = d3_svg_arcStartAngle, endAngle = d3_svg_arcEndAngle;
    function chord(d, i) {
      var s = subgroup(this, source, d, i), t = subgroup(this, target, d, i);
      return "M" + s.p0 + arc(s.r, s.p1, s.a1 - s.a0) + (equals(s, t) ? curve(s.r, s.p1, s.r, s.p0) : curve(s.r, s.p1, t.r, t.p0) + arc(t.r, t.p1, t.a1 - t.a0) + curve(t.r, t.p1, s.r, s.p0)) + "Z";
    }
    function subgroup(self, f, d, i) {
      var subgroup = f.call(self, d, i), r = radius.call(self, subgroup, i), a0 = startAngle.call(self, subgroup, i) - halfπ, a1 = endAngle.call(self, subgroup, i) - halfπ;
      return {
        r: r,
        a0: a0,
        a1: a1,
        p0: [ r * Math.cos(a0), r * Math.sin(a0) ],
        p1: [ r * Math.cos(a1), r * Math.sin(a1) ]
      };
    }
    function equals(a, b) {
      return a.a0 == b.a0 && a.a1 == b.a1;
    }
    function arc(r, p, a) {
      return "A" + r + "," + r + " 0 " + +(a > π) + ",1 " + p;
    }
    function curve(r0, p0, r1, p1) {
      return "Q 0,0 " + p1;
    }
    chord.radius = function(v) {
      if (!arguments.length) return radius;
      radius = d3_functor(v);
      return chord;
    };
    chord.source = function(v) {
      if (!arguments.length) return source;
      source = d3_functor(v);
      return chord;
    };
    chord.target = function(v) {
      if (!arguments.length) return target;
      target = d3_functor(v);
      return chord;
    };
    chord.startAngle = function(v) {
      if (!arguments.length) return startAngle;
      startAngle = d3_functor(v);
      return chord;
    };
    chord.endAngle = function(v) {
      if (!arguments.length) return endAngle;
      endAngle = d3_functor(v);
      return chord;
    };
    return chord;
  };
  function d3_svg_chordRadius(d) {
    return d.radius;
  }
  d3.svg.diagonal = function() {
    var source = d3_source, target = d3_target, projection = d3_svg_diagonalProjection;
    function diagonal(d, i) {
      var p0 = source.call(this, d, i), p3 = target.call(this, d, i), m = (p0.y + p3.y) / 2, p = [ p0, {
        x: p0.x,
        y: m
      }, {
        x: p3.x,
        y: m
      }, p3 ];
      p = p.map(projection);
      return "M" + p[0] + "C" + p[1] + " " + p[2] + " " + p[3];
    }
    diagonal.source = function(x) {
      if (!arguments.length) return source;
      source = d3_functor(x);
      return diagonal;
    };
    diagonal.target = function(x) {
      if (!arguments.length) return target;
      target = d3_functor(x);
      return diagonal;
    };
    diagonal.projection = function(x) {
      if (!arguments.length) return projection;
      projection = x;
      return diagonal;
    };
    return diagonal;
  };
  function d3_svg_diagonalProjection(d) {
    return [ d.x, d.y ];
  }
  d3.svg.diagonal.radial = function() {
    var diagonal = d3.svg.diagonal(), projection = d3_svg_diagonalProjection, projection_ = diagonal.projection;
    diagonal.projection = function(x) {
      return arguments.length ? projection_(d3_svg_diagonalRadialProjection(projection = x)) : projection;
    };
    return diagonal;
  };
  function d3_svg_diagonalRadialProjection(projection) {
    return function() {
      var d = projection.apply(this, arguments), r = d[0], a = d[1] - halfπ;
      return [ r * Math.cos(a), r * Math.sin(a) ];
    };
  }
  d3.svg.symbol = function() {
    var type = d3_svg_symbolType, size = d3_svg_symbolSize;
    function symbol(d, i) {
      return (d3_svg_symbols.get(type.call(this, d, i)) || d3_svg_symbolCircle)(size.call(this, d, i));
    }
    symbol.type = function(x) {
      if (!arguments.length) return type;
      type = d3_functor(x);
      return symbol;
    };
    symbol.size = function(x) {
      if (!arguments.length) return size;
      size = d3_functor(x);
      return symbol;
    };
    return symbol;
  };
  function d3_svg_symbolSize() {
    return 64;
  }
  function d3_svg_symbolType() {
    return "circle";
  }
  function d3_svg_symbolCircle(size) {
    var r = Math.sqrt(size / π);
    return "M0," + r + "A" + r + "," + r + " 0 1,1 0," + -r + "A" + r + "," + r + " 0 1,1 0," + r + "Z";
  }
  var d3_svg_symbols = d3.map({
    circle: d3_svg_symbolCircle,
    cross: function(size) {
      var r = Math.sqrt(size / 5) / 2;
      return "M" + -3 * r + "," + -r + "H" + -r + "V" + -3 * r + "H" + r + "V" + -r + "H" + 3 * r + "V" + r + "H" + r + "V" + 3 * r + "H" + -r + "V" + r + "H" + -3 * r + "Z";
    },
    diamond: function(size) {
      var ry = Math.sqrt(size / (2 * d3_svg_symbolTan30)), rx = ry * d3_svg_symbolTan30;
      return "M0," + -ry + "L" + rx + ",0" + " 0," + ry + " " + -rx + ",0" + "Z";
    },
    square: function(size) {
      var r = Math.sqrt(size) / 2;
      return "M" + -r + "," + -r + "L" + r + "," + -r + " " + r + "," + r + " " + -r + "," + r + "Z";
    },
    "triangle-down": function(size) {
      var rx = Math.sqrt(size / d3_svg_symbolSqrt3), ry = rx * d3_svg_symbolSqrt3 / 2;
      return "M0," + ry + "L" + rx + "," + -ry + " " + -rx + "," + -ry + "Z";
    },
    "triangle-up": function(size) {
      var rx = Math.sqrt(size / d3_svg_symbolSqrt3), ry = rx * d3_svg_symbolSqrt3 / 2;
      return "M0," + -ry + "L" + rx + "," + ry + " " + -rx + "," + ry + "Z";
    }
  });
  d3.svg.symbolTypes = d3_svg_symbols.keys();
  var d3_svg_symbolSqrt3 = Math.sqrt(3), d3_svg_symbolTan30 = Math.tan(30 * d3_radians);
  d3_selectionPrototype.transition = function(name) {
    var id = d3_transitionInheritId || ++d3_transitionId, ns = d3_transitionNamespace(name), subgroups = [], subgroup, node, transition = d3_transitionInherit || {
      time: Date.now(),
      ease: d3_ease_cubicInOut,
      delay: 0,
      duration: 250
    };
    for (var j = -1, m = this.length; ++j < m; ) {
      subgroups.push(subgroup = []);
      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
        if (node = group[i]) d3_transitionNode(node, i, ns, id, transition);
        subgroup.push(node);
      }
    }
    return d3_transition(subgroups, ns, id);
  };
  d3_selectionPrototype.interrupt = function(name) {
    return this.each(name == null ? d3_selection_interrupt : d3_selection_interruptNS(d3_transitionNamespace(name)));
  };
  var d3_selection_interrupt = d3_selection_interruptNS(d3_transitionNamespace());
  function d3_selection_interruptNS(ns) {
    return function() {
      var lock, activeId, active;
      if ((lock = this[ns]) && (active = lock[activeId = lock.active])) {
        active.timer.c = null;
        active.timer.t = NaN;
        if (--lock.count) delete lock[activeId]; else delete this[ns];
        lock.active += .5;
        active.event && active.event.interrupt.call(this, this.__data__, active.index);
      }
    };
  }
  function d3_transition(groups, ns, id) {
    d3_subclass(groups, d3_transitionPrototype);
    groups.namespace = ns;
    groups.id = id;
    return groups;
  }
  var d3_transitionPrototype = [], d3_transitionId = 0, d3_transitionInheritId, d3_transitionInherit;
  d3_transitionPrototype.call = d3_selectionPrototype.call;
  d3_transitionPrototype.empty = d3_selectionPrototype.empty;
  d3_transitionPrototype.node = d3_selectionPrototype.node;
  d3_transitionPrototype.size = d3_selectionPrototype.size;
  d3.transition = function(selection, name) {
    return selection && selection.transition ? d3_transitionInheritId ? selection.transition(name) : selection : d3.selection().transition(selection);
  };
  d3.transition.prototype = d3_transitionPrototype;
  d3_transitionPrototype.select = function(selector) {
    var id = this.id, ns = this.namespace, subgroups = [], subgroup, subnode, node;
    selector = d3_selection_selector(selector);
    for (var j = -1, m = this.length; ++j < m; ) {
      subgroups.push(subgroup = []);
      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
        if ((node = group[i]) && (subnode = selector.call(node, node.__data__, i, j))) {
          if ("__data__" in node) subnode.__data__ = node.__data__;
          d3_transitionNode(subnode, i, ns, id, node[ns][id]);
          subgroup.push(subnode);
        } else {
          subgroup.push(null);
        }
      }
    }
    return d3_transition(subgroups, ns, id);
  };
  d3_transitionPrototype.selectAll = function(selector) {
    var id = this.id, ns = this.namespace, subgroups = [], subgroup, subnodes, node, subnode, transition;
    selector = d3_selection_selectorAll(selector);
    for (var j = -1, m = this.length; ++j < m; ) {
      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
        if (node = group[i]) {
          transition = node[ns][id];
          subnodes = selector.call(node, node.__data__, i, j);
          subgroups.push(subgroup = []);
          for (var k = -1, o = subnodes.length; ++k < o; ) {
            if (subnode = subnodes[k]) d3_transitionNode(subnode, k, ns, id, transition);
            subgroup.push(subnode);
          }
        }
      }
    }
    return d3_transition(subgroups, ns, id);
  };
  d3_transitionPrototype.filter = function(filter) {
    var subgroups = [], subgroup, group, node;
    if (typeof filter !== "function") filter = d3_selection_filter(filter);
    for (var j = 0, m = this.length; j < m; j++) {
      subgroups.push(subgroup = []);
      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
        if ((node = group[i]) && filter.call(node, node.__data__, i, j)) {
          subgroup.push(node);
        }
      }
    }
    return d3_transition(subgroups, this.namespace, this.id);
  };
  d3_transitionPrototype.tween = function(name, tween) {
    var id = this.id, ns = this.namespace;
    if (arguments.length < 2) return this.node()[ns][id].tween.get(name);
    return d3_selection_each(this, tween == null ? function(node) {
      node[ns][id].tween.remove(name);
    } : function(node) {
      node[ns][id].tween.set(name, tween);
    });
  };
  function d3_transition_tween(groups, name, value, tween) {
    var id = groups.id, ns = groups.namespace;
    return d3_selection_each(groups, typeof value === "function" ? function(node, i, j) {
      node[ns][id].tween.set(name, tween(value.call(node, node.__data__, i, j)));
    } : (value = tween(value), function(node) {
      node[ns][id].tween.set(name, value);
    }));
  }
  d3_transitionPrototype.attr = function(nameNS, value) {
    if (arguments.length < 2) {
      for (value in nameNS) this.attr(value, nameNS[value]);
      return this;
    }
    var interpolate = nameNS == "transform" ? d3_interpolateTransform : d3_interpolate, name = d3.ns.qualify(nameNS);
    function attrNull() {
      this.removeAttribute(name);
    }
    function attrNullNS() {
      this.removeAttributeNS(name.space, name.local);
    }
    function attrTween(b) {
      return b == null ? attrNull : (b += "", function() {
        var a = this.getAttribute(name), i;
        return a !== b && (i = interpolate(a, b), function(t) {
          this.setAttribute(name, i(t));
        });
      });
    }
    function attrTweenNS(b) {
      return b == null ? attrNullNS : (b += "", function() {
        var a = this.getAttributeNS(name.space, name.local), i;
        return a !== b && (i = interpolate(a, b), function(t) {
          this.setAttributeNS(name.space, name.local, i(t));
        });
      });
    }
    return d3_transition_tween(this, "attr." + nameNS, value, name.local ? attrTweenNS : attrTween);
  };
  d3_transitionPrototype.attrTween = function(nameNS, tween) {
    var name = d3.ns.qualify(nameNS);
    function attrTween(d, i) {
      var f = tween.call(this, d, i, this.getAttribute(name));
      return f && function(t) {
        this.setAttribute(name, f(t));
      };
    }
    function attrTweenNS(d, i) {
      var f = tween.call(this, d, i, this.getAttributeNS(name.space, name.local));
      return f && function(t) {
        this.setAttributeNS(name.space, name.local, f(t));
      };
    }
    return this.tween("attr." + nameNS, name.local ? attrTweenNS : attrTween);
  };
  d3_transitionPrototype.style = function(name, value, priority) {
    var n = arguments.length;
    if (n < 3) {
      if (typeof name !== "string") {
        if (n < 2) value = "";
        for (priority in name) this.style(priority, name[priority], value);
        return this;
      }
      priority = "";
    }
    function styleNull() {
      this.style.removeProperty(name);
    }
    function styleString(b) {
      return b == null ? styleNull : (b += "", function() {
        var a = d3_window(this).getComputedStyle(this, null).getPropertyValue(name), i;
        return a !== b && (i = d3_interpolate(a, b), function(t) {
          this.style.setProperty(name, i(t), priority);
        });
      });
    }
    return d3_transition_tween(this, "style." + name, value, styleString);
  };
  d3_transitionPrototype.styleTween = function(name, tween, priority) {
    if (arguments.length < 3) priority = "";
    function styleTween(d, i) {
      var f = tween.call(this, d, i, d3_window(this).getComputedStyle(this, null).getPropertyValue(name));
      return f && function(t) {
        this.style.setProperty(name, f(t), priority);
      };
    }
    return this.tween("style." + name, styleTween);
  };
  d3_transitionPrototype.text = function(value) {
    return d3_transition_tween(this, "text", value, d3_transition_text);
  };
  function d3_transition_text(b) {
    if (b == null) b = "";
    return function() {
      this.textContent = b;
    };
  }
  d3_transitionPrototype.remove = function() {
    var ns = this.namespace;
    return this.each("end.transition", function() {
      var p;
      if (this[ns].count < 2 && (p = this.parentNode)) p.removeChild(this);
    });
  };
  d3_transitionPrototype.ease = function(value) {
    var id = this.id, ns = this.namespace;
    if (arguments.length < 1) return this.node()[ns][id].ease;
    if (typeof value !== "function") value = d3.ease.apply(d3, arguments);
    return d3_selection_each(this, function(node) {
      node[ns][id].ease = value;
    });
  };
  d3_transitionPrototype.delay = function(value) {
    var id = this.id, ns = this.namespace;
    if (arguments.length < 1) return this.node()[ns][id].delay;
    return d3_selection_each(this, typeof value === "function" ? function(node, i, j) {
      node[ns][id].delay = +value.call(node, node.__data__, i, j);
    } : (value = +value, function(node) {
      node[ns][id].delay = value;
    }));
  };
  d3_transitionPrototype.duration = function(value) {
    var id = this.id, ns = this.namespace;
    if (arguments.length < 1) return this.node()[ns][id].duration;
    return d3_selection_each(this, typeof value === "function" ? function(node, i, j) {
      node[ns][id].duration = Math.max(1, value.call(node, node.__data__, i, j));
    } : (value = Math.max(1, value), function(node) {
      node[ns][id].duration = value;
    }));
  };
  d3_transitionPrototype.each = function(type, listener) {
    var id = this.id, ns = this.namespace;
    if (arguments.length < 2) {
      var inherit = d3_transitionInherit, inheritId = d3_transitionInheritId;
      try {
        d3_transitionInheritId = id;
        d3_selection_each(this, function(node, i, j) {
          d3_transitionInherit = node[ns][id];
          type.call(node, node.__data__, i, j);
        });
      } finally {
        d3_transitionInherit = inherit;
        d3_transitionInheritId = inheritId;
      }
    } else {
      d3_selection_each(this, function(node) {
        var transition = node[ns][id];
        (transition.event || (transition.event = d3.dispatch("start", "end", "interrupt"))).on(type, listener);
      });
    }
    return this;
  };
  d3_transitionPrototype.transition = function() {
    var id0 = this.id, id1 = ++d3_transitionId, ns = this.namespace, subgroups = [], subgroup, group, node, transition;
    for (var j = 0, m = this.length; j < m; j++) {
      subgroups.push(subgroup = []);
      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
        if (node = group[i]) {
          transition = node[ns][id0];
          d3_transitionNode(node, i, ns, id1, {
            time: transition.time,
            ease: transition.ease,
            delay: transition.delay + transition.duration,
            duration: transition.duration
          });
        }
        subgroup.push(node);
      }
    }
    return d3_transition(subgroups, ns, id1);
  };
  function d3_transitionNamespace(name) {
    return name == null ? "__transition__" : "__transition_" + name + "__";
  }
  function d3_transitionNode(node, i, ns, id, inherit) {
    var lock = node[ns] || (node[ns] = {
      active: 0,
      count: 0
    }), transition = lock[id], time, timer, duration, ease, tweens;
    function schedule(elapsed) {
      var delay = transition.delay;
      timer.t = delay + time;
      if (delay <= elapsed) return start(elapsed - delay);
      timer.c = start;
    }
    function start(elapsed) {
      var activeId = lock.active, active = lock[activeId];
      if (active) {
        active.timer.c = null;
        active.timer.t = NaN;
        --lock.count;
        delete lock[activeId];
        active.event && active.event.interrupt.call(node, node.__data__, active.index);
      }
      for (var cancelId in lock) {
        if (+cancelId < id) {
          var cancel = lock[cancelId];
          cancel.timer.c = null;
          cancel.timer.t = NaN;
          --lock.count;
          delete lock[cancelId];
        }
      }
      timer.c = tick;
      d3_timer(function() {
        if (timer.c && tick(elapsed || 1)) {
          timer.c = null;
          timer.t = NaN;
        }
        return 1;
      }, 0, time);
      lock.active = id;
      transition.event && transition.event.start.call(node, node.__data__, i);
      tweens = [];
      transition.tween.forEach(function(key, value) {
        if (value = value.call(node, node.__data__, i)) {
          tweens.push(value);
        }
      });
      ease = transition.ease;
      duration = transition.duration;
    }
    function tick(elapsed) {
      var t = elapsed / duration, e = ease(t), n = tweens.length;
      while (n > 0) {
        tweens[--n].call(node, e);
      }
      if (t >= 1) {
        transition.event && transition.event.end.call(node, node.__data__, i);
        if (--lock.count) delete lock[id]; else delete node[ns];
        return 1;
      }
    }
    if (!transition) {
      time = inherit.time;
      timer = d3_timer(schedule, 0, time);
      transition = lock[id] = {
        tween: new d3_Map(),
        time: time,
        timer: timer,
        delay: inherit.delay,
        duration: inherit.duration,
        ease: inherit.ease,
        index: i
      };
      inherit = null;
      ++lock.count;
    }
  }
  d3.svg.axis = function() {
    var scale = d3.scale.linear(), orient = d3_svg_axisDefaultOrient, innerTickSize = 6, outerTickSize = 6, tickPadding = 3, tickArguments_ = [ 10 ], tickValues = null, tickFormat_;
    function axis(g) {
      g.each(function() {
        var g = d3.select(this);
        var scale0 = this.__chart__ || scale, scale1 = this.__chart__ = scale.copy();
        var ticks = tickValues == null ? scale1.ticks ? scale1.ticks.apply(scale1, tickArguments_) : scale1.domain() : tickValues, tickFormat = tickFormat_ == null ? scale1.tickFormat ? scale1.tickFormat.apply(scale1, tickArguments_) : d3_identity : tickFormat_, tick = g.selectAll(".tick").data(ticks, scale1), tickEnter = tick.enter().insert("g", ".domain").attr("class", "tick").style("opacity", ε), tickExit = d3.transition(tick.exit()).style("opacity", ε).remove(), tickUpdate = d3.transition(tick.order()).style("opacity", 1), tickSpacing = Math.max(innerTickSize, 0) + tickPadding, tickTransform;
        var range = d3_scaleRange(scale1), path = g.selectAll(".domain").data([ 0 ]), pathUpdate = (path.enter().append("path").attr("class", "domain"), 
        d3.transition(path));
        tickEnter.append("line");
        tickEnter.append("text");
        var lineEnter = tickEnter.select("line"), lineUpdate = tickUpdate.select("line"), text = tick.select("text").text(tickFormat), textEnter = tickEnter.select("text"), textUpdate = tickUpdate.select("text"), sign = orient === "top" || orient === "left" ? -1 : 1, x1, x2, y1, y2;
        if (orient === "bottom" || orient === "top") {
          tickTransform = d3_svg_axisX, x1 = "x", y1 = "y", x2 = "x2", y2 = "y2";
          text.attr("dy", sign < 0 ? "0em" : ".71em").style("text-anchor", "middle");
          pathUpdate.attr("d", "M" + range[0] + "," + sign * outerTickSize + "V0H" + range[1] + "V" + sign * outerTickSize);
        } else {
          tickTransform = d3_svg_axisY, x1 = "y", y1 = "x", x2 = "y2", y2 = "x2";
          text.attr("dy", ".32em").style("text-anchor", sign < 0 ? "end" : "start");
          pathUpdate.attr("d", "M" + sign * outerTickSize + "," + range[0] + "H0V" + range[1] + "H" + sign * outerTickSize);
        }
        lineEnter.attr(y2, sign * innerTickSize);
        textEnter.attr(y1, sign * tickSpacing);
        lineUpdate.attr(x2, 0).attr(y2, sign * innerTickSize);
        textUpdate.attr(x1, 0).attr(y1, sign * tickSpacing);
        if (scale1.rangeBand) {
          var x = scale1, dx = x.rangeBand() / 2;
          scale0 = scale1 = function(d) {
            return x(d) + dx;
          };
        } else if (scale0.rangeBand) {
          scale0 = scale1;
        } else {
          tickExit.call(tickTransform, scale1, scale0);
        }
        tickEnter.call(tickTransform, scale0, scale1);
        tickUpdate.call(tickTransform, scale1, scale1);
      });
    }
    axis.scale = function(x) {
      if (!arguments.length) return scale;
      scale = x;
      return axis;
    };
    axis.orient = function(x) {
      if (!arguments.length) return orient;
      orient = x in d3_svg_axisOrients ? x + "" : d3_svg_axisDefaultOrient;
      return axis;
    };
    axis.ticks = function() {
      if (!arguments.length) return tickArguments_;
      tickArguments_ = d3_array(arguments);
      return axis;
    };
    axis.tickValues = function(x) {
      if (!arguments.length) return tickValues;
      tickValues = x;
      return axis;
    };
    axis.tickFormat = function(x) {
      if (!arguments.length) return tickFormat_;
      tickFormat_ = x;
      return axis;
    };
    axis.tickSize = function(x) {
      var n = arguments.length;
      if (!n) return innerTickSize;
      innerTickSize = +x;
      outerTickSize = +arguments[n - 1];
      return axis;
    };
    axis.innerTickSize = function(x) {
      if (!arguments.length) return innerTickSize;
      innerTickSize = +x;
      return axis;
    };
    axis.outerTickSize = function(x) {
      if (!arguments.length) return outerTickSize;
      outerTickSize = +x;
      return axis;
    };
    axis.tickPadding = function(x) {
      if (!arguments.length) return tickPadding;
      tickPadding = +x;
      return axis;
    };
    axis.tickSubdivide = function() {
      return arguments.length && axis;
    };
    return axis;
  };
  var d3_svg_axisDefaultOrient = "bottom", d3_svg_axisOrients = {
    top: 1,
    right: 1,
    bottom: 1,
    left: 1
  };
  function d3_svg_axisX(selection, x0, x1) {
    selection.attr("transform", function(d) {
      var v0 = x0(d);
      return "translate(" + (isFinite(v0) ? v0 : x1(d)) + ",0)";
    });
  }
  function d3_svg_axisY(selection, y0, y1) {
    selection.attr("transform", function(d) {
      var v0 = y0(d);
      return "translate(0," + (isFinite(v0) ? v0 : y1(d)) + ")";
    });
  }
  d3.svg.brush = function() {
    var event = d3_eventDispatch(brush, "brushstart", "brush", "brushend"), x = null, y = null, xExtent = [ 0, 0 ], yExtent = [ 0, 0 ], xExtentDomain, yExtentDomain, xClamp = true, yClamp = true, resizes = d3_svg_brushResizes[0];
    function brush(g) {
      g.each(function() {
        var g = d3.select(this).style("pointer-events", "all").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)").on("mousedown.brush", brushstart).on("touchstart.brush", brushstart);
        var background = g.selectAll(".background").data([ 0 ]);
        background.enter().append("rect").attr("class", "background").style("visibility", "hidden").style("cursor", "crosshair");
        g.selectAll(".extent").data([ 0 ]).enter().append("rect").attr("class", "extent").style("cursor", "move");
        var resize = g.selectAll(".resize").data(resizes, d3_identity);
        resize.exit().remove();
        resize.enter().append("g").attr("class", function(d) {
          return "resize " + d;
        }).style("cursor", function(d) {
          return d3_svg_brushCursor[d];
        }).append("rect").attr("x", function(d) {
          return /[ew]$/.test(d) ? -3 : null;
        }).attr("y", function(d) {
          return /^[ns]/.test(d) ? -3 : null;
        }).attr("width", 6).attr("height", 6).style("visibility", "hidden");
        resize.style("display", brush.empty() ? "none" : null);
        var gUpdate = d3.transition(g), backgroundUpdate = d3.transition(background), range;
        if (x) {
          range = d3_scaleRange(x);
          backgroundUpdate.attr("x", range[0]).attr("width", range[1] - range[0]);
          redrawX(gUpdate);
        }
        if (y) {
          range = d3_scaleRange(y);
          backgroundUpdate.attr("y", range[0]).attr("height", range[1] - range[0]);
          redrawY(gUpdate);
        }
        redraw(gUpdate);
      });
    }
    brush.event = function(g) {
      g.each(function() {
        var event_ = event.of(this, arguments), extent1 = {
          x: xExtent,
          y: yExtent,
          i: xExtentDomain,
          j: yExtentDomain
        }, extent0 = this.__chart__ || extent1;
        this.__chart__ = extent1;
        if (d3_transitionInheritId) {
          d3.select(this).transition().each("start.brush", function() {
            xExtentDomain = extent0.i;
            yExtentDomain = extent0.j;
            xExtent = extent0.x;
            yExtent = extent0.y;
            event_({
              type: "brushstart"
            });
          }).tween("brush:brush", function() {
            var xi = d3_interpolateArray(xExtent, extent1.x), yi = d3_interpolateArray(yExtent, extent1.y);
            xExtentDomain = yExtentDomain = null;
            return function(t) {
              xExtent = extent1.x = xi(t);
              yExtent = extent1.y = yi(t);
              event_({
                type: "brush",
                mode: "resize"
              });
            };
          }).each("end.brush", function() {
            xExtentDomain = extent1.i;
            yExtentDomain = extent1.j;
            event_({
              type: "brush",
              mode: "resize"
            });
            event_({
              type: "brushend"
            });
          });
        } else {
          event_({
            type: "brushstart"
          });
          event_({
            type: "brush",
            mode: "resize"
          });
          event_({
            type: "brushend"
          });
        }
      });
    };
    function redraw(g) {
      g.selectAll(".resize").attr("transform", function(d) {
        return "translate(" + xExtent[+/e$/.test(d)] + "," + yExtent[+/^s/.test(d)] + ")";
      });
    }
    function redrawX(g) {
      g.select(".extent").attr("x", xExtent[0]);
      g.selectAll(".extent,.n>rect,.s>rect").attr("width", xExtent[1] - xExtent[0]);
    }
    function redrawY(g) {
      g.select(".extent").attr("y", yExtent[0]);
      g.selectAll(".extent,.e>rect,.w>rect").attr("height", yExtent[1] - yExtent[0]);
    }
    function brushstart() {
      var target = this, eventTarget = d3.select(d3.event.target), event_ = event.of(target, arguments), g = d3.select(target), resizing = eventTarget.datum(), resizingX = !/^(n|s)$/.test(resizing) && x, resizingY = !/^(e|w)$/.test(resizing) && y, dragging = eventTarget.classed("extent"), dragRestore = d3_event_dragSuppress(target), center, origin = d3.mouse(target), offset;
      var w = d3.select(d3_window(target)).on("keydown.brush", keydown).on("keyup.brush", keyup);
      if (d3.event.changedTouches) {
        w.on("touchmove.brush", brushmove).on("touchend.brush", brushend);
      } else {
        w.on("mousemove.brush", brushmove).on("mouseup.brush", brushend);
      }
      g.interrupt().selectAll("*").interrupt();
      if (dragging) {
        origin[0] = xExtent[0] - origin[0];
        origin[1] = yExtent[0] - origin[1];
      } else if (resizing) {
        var ex = +/w$/.test(resizing), ey = +/^n/.test(resizing);
        offset = [ xExtent[1 - ex] - origin[0], yExtent[1 - ey] - origin[1] ];
        origin[0] = xExtent[ex];
        origin[1] = yExtent[ey];
      } else if (d3.event.altKey) center = origin.slice();
      g.style("pointer-events", "none").selectAll(".resize").style("display", null);
      d3.select("body").style("cursor", eventTarget.style("cursor"));
      event_({
        type: "brushstart"
      });
      brushmove();
      function keydown() {
        if (d3.event.keyCode == 32) {
          if (!dragging) {
            center = null;
            origin[0] -= xExtent[1];
            origin[1] -= yExtent[1];
            dragging = 2;
          }
          d3_eventPreventDefault();
        }
      }
      function keyup() {
        if (d3.event.keyCode == 32 && dragging == 2) {
          origin[0] += xExtent[1];
          origin[1] += yExtent[1];
          dragging = 0;
          d3_eventPreventDefault();
        }
      }
      function brushmove() {
        var point = d3.mouse(target), moved = false;
        if (offset) {
          point[0] += offset[0];
          point[1] += offset[1];
        }
        if (!dragging) {
          if (d3.event.altKey) {
            if (!center) center = [ (xExtent[0] + xExtent[1]) / 2, (yExtent[0] + yExtent[1]) / 2 ];
            origin[0] = xExtent[+(point[0] < center[0])];
            origin[1] = yExtent[+(point[1] < center[1])];
          } else center = null;
        }
        if (resizingX && move1(point, x, 0)) {
          redrawX(g);
          moved = true;
        }
        if (resizingY && move1(point, y, 1)) {
          redrawY(g);
          moved = true;
        }
        if (moved) {
          redraw(g);
          event_({
            type: "brush",
            mode: dragging ? "move" : "resize"
          });
        }
      }
      function move1(point, scale, i) {
        var range = d3_scaleRange(scale), r0 = range[0], r1 = range[1], position = origin[i], extent = i ? yExtent : xExtent, size = extent[1] - extent[0], min, max;
        if (dragging) {
          r0 -= position;
          r1 -= size + position;
        }
        min = (i ? yClamp : xClamp) ? Math.max(r0, Math.min(r1, point[i])) : point[i];
        if (dragging) {
          max = (min += position) + size;
        } else {
          if (center) position = Math.max(r0, Math.min(r1, 2 * center[i] - min));
          if (position < min) {
            max = min;
            min = position;
          } else {
            max = position;
          }
        }
        if (extent[0] != min || extent[1] != max) {
          if (i) yExtentDomain = null; else xExtentDomain = null;
          extent[0] = min;
          extent[1] = max;
          return true;
        }
      }
      function brushend() {
        brushmove();
        g.style("pointer-events", "all").selectAll(".resize").style("display", brush.empty() ? "none" : null);
        d3.select("body").style("cursor", null);
        w.on("mousemove.brush", null).on("mouseup.brush", null).on("touchmove.brush", null).on("touchend.brush", null).on("keydown.brush", null).on("keyup.brush", null);
        dragRestore();
        event_({
          type: "brushend"
        });
      }
    }
    brush.x = function(z) {
      if (!arguments.length) return x;
      x = z;
      resizes = d3_svg_brushResizes[!x << 1 | !y];
      return brush;
    };
    brush.y = function(z) {
      if (!arguments.length) return y;
      y = z;
      resizes = d3_svg_brushResizes[!x << 1 | !y];
      return brush;
    };
    brush.clamp = function(z) {
      if (!arguments.length) return x && y ? [ xClamp, yClamp ] : x ? xClamp : y ? yClamp : null;
      if (x && y) xClamp = !!z[0], yClamp = !!z[1]; else if (x) xClamp = !!z; else if (y) yClamp = !!z;
      return brush;
    };
    brush.extent = function(z) {
      var x0, x1, y0, y1, t;
      if (!arguments.length) {
        if (x) {
          if (xExtentDomain) {
            x0 = xExtentDomain[0], x1 = xExtentDomain[1];
          } else {
            x0 = xExtent[0], x1 = xExtent[1];
            if (x.invert) x0 = x.invert(x0), x1 = x.invert(x1);
            if (x1 < x0) t = x0, x0 = x1, x1 = t;
          }
        }
        if (y) {
          if (yExtentDomain) {
            y0 = yExtentDomain[0], y1 = yExtentDomain[1];
          } else {
            y0 = yExtent[0], y1 = yExtent[1];
            if (y.invert) y0 = y.invert(y0), y1 = y.invert(y1);
            if (y1 < y0) t = y0, y0 = y1, y1 = t;
          }
        }
        return x && y ? [ [ x0, y0 ], [ x1, y1 ] ] : x ? [ x0, x1 ] : y && [ y0, y1 ];
      }
      if (x) {
        x0 = z[0], x1 = z[1];
        if (y) x0 = x0[0], x1 = x1[0];
        xExtentDomain = [ x0, x1 ];
        if (x.invert) x0 = x(x0), x1 = x(x1);
        if (x1 < x0) t = x0, x0 = x1, x1 = t;
        if (x0 != xExtent[0] || x1 != xExtent[1]) xExtent = [ x0, x1 ];
      }
      if (y) {
        y0 = z[0], y1 = z[1];
        if (x) y0 = y0[1], y1 = y1[1];
        yExtentDomain = [ y0, y1 ];
        if (y.invert) y0 = y(y0), y1 = y(y1);
        if (y1 < y0) t = y0, y0 = y1, y1 = t;
        if (y0 != yExtent[0] || y1 != yExtent[1]) yExtent = [ y0, y1 ];
      }
      return brush;
    };
    brush.clear = function() {
      if (!brush.empty()) {
        xExtent = [ 0, 0 ], yExtent = [ 0, 0 ];
        xExtentDomain = yExtentDomain = null;
      }
      return brush;
    };
    brush.empty = function() {
      return !!x && xExtent[0] == xExtent[1] || !!y && yExtent[0] == yExtent[1];
    };
    return d3.rebind(brush, event, "on");
  };
  var d3_svg_brushCursor = {
    n: "ns-resize",
    e: "ew-resize",
    s: "ns-resize",
    w: "ew-resize",
    nw: "nwse-resize",
    ne: "nesw-resize",
    se: "nwse-resize",
    sw: "nesw-resize"
  };
  var d3_svg_brushResizes = [ [ "n", "e", "s", "w", "nw", "ne", "se", "sw" ], [ "e", "w" ], [ "n", "s" ], [] ];
  d3.text = d3_xhrType(function(request) {
    return request.responseText;
  });
  d3.json = function(url, callback) {
    return d3_xhr(url, "application/json", d3_json, callback);
  };
  function d3_json(request) {
    return JSON.parse(request.responseText);
  }
  d3.html = function(url, callback) {
    return d3_xhr(url, "text/html", d3_html, callback);
  };
  function d3_html(request) {
    var range = d3_document.createRange();
    range.selectNode(d3_document.body);
    return range.createContextualFragment(request.responseText);
  }
  d3.xml = d3_xhrType(function(request) {
    return request.responseXML;
  });
  if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (d3),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
		__WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)); else {}
}.apply(self);

/***/ }),

/***/ 32280:
/***/ (function(module) {

/* Mapbox GL JS is licensed under the 3-Clause BSD License. Full text of license: https://github.com/mapbox/mapbox-gl-js/blob/v1.13.1/LICENSE.txt */
(function (global, factory) {
 true ? module.exports = factory() :
0;
}(this, (function () { 'use strict';

/* eslint-disable */

var shared, worker, mapboxgl;
// define gets called three times: one for each chunk. we rely on the order
// they're imported to know which is which
function define(_, chunk) {
if (!shared) {
    shared = chunk;
} else if (!worker) {
    worker = chunk;
} else {
    var workerBundleString = 'var sharedChunk = {}; (' + shared + ')(sharedChunk); (' + worker + ')(sharedChunk);'

    var sharedChunk = {};
    shared(sharedChunk);
    mapboxgl = chunk(sharedChunk);
    if (typeof window !== 'undefined') {
        mapboxgl.workerUrl = window.URL.createObjectURL(new Blob([workerBundleString], { type: 'text/javascript' }));
    }
}
}


define(['exports'], function (exports) { 'use strict';

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var version = "1.13.4";

var unitbezier = UnitBezier;
function UnitBezier(p1x, p1y, p2x, p2y) {
    this.cx = 3 * p1x;
    this.bx = 3 * (p2x - p1x) - this.cx;
    this.ax = 1 - this.cx - this.bx;
    this.cy = 3 * p1y;
    this.by = 3 * (p2y - p1y) - this.cy;
    this.ay = 1 - this.cy - this.by;
    this.p1x = p1x;
    this.p1y = p2y;
    this.p2x = p2x;
    this.p2y = p2y;
}
UnitBezier.prototype.sampleCurveX = function (t) {
    return ((this.ax * t + this.bx) * t + this.cx) * t;
};
UnitBezier.prototype.sampleCurveY = function (t) {
    return ((this.ay * t + this.by) * t + this.cy) * t;
};
UnitBezier.prototype.sampleCurveDerivativeX = function (t) {
    return (3 * this.ax * t + 2 * this.bx) * t + this.cx;
};
UnitBezier.prototype.solveCurveX = function (x, epsilon) {
    if (typeof epsilon === 'undefined') {
        epsilon = 0.000001;
    }
    var t0, t1, t2, x2, i;
    for (t2 = x, i = 0; i < 8; i++) {
        x2 = this.sampleCurveX(t2) - x;
        if (Math.abs(x2) < epsilon) {
            return t2;
        }
        var d2 = this.sampleCurveDerivativeX(t2);
        if (Math.abs(d2) < 0.000001) {
            break;
        }
        t2 = t2 - x2 / d2;
    }
    t0 = 0;
    t1 = 1;
    t2 = x;
    if (t2 < t0) {
        return t0;
    }
    if (t2 > t1) {
        return t1;
    }
    while (t0 < t1) {
        x2 = this.sampleCurveX(t2);
        if (Math.abs(x2 - x) < epsilon) {
            return t2;
        }
        if (x > x2) {
            t0 = t2;
        } else {
            t1 = t2;
        }
        t2 = (t1 - t0) * 0.5 + t0;
    }
    return t2;
};
UnitBezier.prototype.solve = function (x, epsilon) {
    return this.sampleCurveY(this.solveCurveX(x, epsilon));
};

var pointGeometry = Point;
function Point(x, y) {
    this.x = x;
    this.y = y;
}
Point.prototype = {
    clone: function () {
        return new Point(this.x, this.y);
    },
    add: function (p) {
        return this.clone()._add(p);
    },
    sub: function (p) {
        return this.clone()._sub(p);
    },
    multByPoint: function (p) {
        return this.clone()._multByPoint(p);
    },
    divByPoint: function (p) {
        return this.clone()._divByPoint(p);
    },
    mult: function (k) {
        return this.clone()._mult(k);
    },
    div: function (k) {
        return this.clone()._div(k);
    },
    rotate: function (a) {
        return this.clone()._rotate(a);
    },
    rotateAround: function (a, p) {
        return this.clone()._rotateAround(a, p);
    },
    matMult: function (m) {
        return this.clone()._matMult(m);
    },
    unit: function () {
        return this.clone()._unit();
    },
    perp: function () {
        return this.clone()._perp();
    },
    round: function () {
        return this.clone()._round();
    },
    mag: function () {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    },
    equals: function (other) {
        return this.x === other.x && this.y === other.y;
    },
    dist: function (p) {
        return Math.sqrt(this.distSqr(p));
    },
    distSqr: function (p) {
        var dx = p.x - this.x, dy = p.y - this.y;
        return dx * dx + dy * dy;
    },
    angle: function () {
        return Math.atan2(this.y, this.x);
    },
    angleTo: function (b) {
        return Math.atan2(this.y - b.y, this.x - b.x);
    },
    angleWith: function (b) {
        return this.angleWithSep(b.x, b.y);
    },
    angleWithSep: function (x, y) {
        return Math.atan2(this.x * y - this.y * x, this.x * x + this.y * y);
    },
    _matMult: function (m) {
        var x = m[0] * this.x + m[1] * this.y, y = m[2] * this.x + m[3] * this.y;
        this.x = x;
        this.y = y;
        return this;
    },
    _add: function (p) {
        this.x += p.x;
        this.y += p.y;
        return this;
    },
    _sub: function (p) {
        this.x -= p.x;
        this.y -= p.y;
        return this;
    },
    _mult: function (k) {
        this.x *= k;
        this.y *= k;
        return this;
    },
    _div: function (k) {
        this.x /= k;
        this.y /= k;
        return this;
    },
    _multByPoint: function (p) {
        this.x *= p.x;
        this.y *= p.y;
        return this;
    },
    _divByPoint: function (p) {
        this.x /= p.x;
        this.y /= p.y;
        return this;
    },
    _unit: function () {
        this._div(this.mag());
        return this;
    },
    _perp: function () {
        var y = this.y;
        this.y = this.x;
        this.x = -y;
        return this;
    },
    _rotate: function (angle) {
        var cos = Math.cos(angle), sin = Math.sin(angle), x = cos * this.x - sin * this.y, y = sin * this.x + cos * this.y;
        this.x = x;
        this.y = y;
        return this;
    },
    _rotateAround: function (angle, p) {
        var cos = Math.cos(angle), sin = Math.sin(angle), x = p.x + cos * (this.x - p.x) - sin * (this.y - p.y), y = p.y + sin * (this.x - p.x) + cos * (this.y - p.y);
        this.x = x;
        this.y = y;
        return this;
    },
    _round: function () {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        return this;
    }
};
Point.convert = function (a) {
    if (a instanceof Point) {
        return a;
    }
    if (Array.isArray(a)) {
        return new Point(a[0], a[1]);
    }
    return a;
};

var window$1 = typeof self !== 'undefined' ? self : {};

function deepEqual(a, b) {
    if (Array.isArray(a)) {
        if (!Array.isArray(b) || a.length !== b.length) {
            return false;
        }
        for (var i = 0; i < a.length; i++) {
            if (!deepEqual(a[i], b[i])) {
                return false;
            }
        }
        return true;
    }
    if (typeof a === 'object' && a !== null && b !== null) {
        if (!(typeof b === 'object')) {
            return false;
        }
        var keys = Object.keys(a);
        if (keys.length !== Object.keys(b).length) {
            return false;
        }
        for (var key in a) {
            if (!deepEqual(a[key], b[key])) {
                return false;
            }
        }
        return true;
    }
    return a === b;
}

var MAX_SAFE_INTEGER = Math.pow(2, 53) - 1;
function easeCubicInOut(t) {
    if (t <= 0) {
        return 0;
    }
    if (t >= 1) {
        return 1;
    }
    var t2 = t * t, t3 = t2 * t;
    return 4 * (t < 0.5 ? t3 : 3 * (t - t2) + t3 - 0.75);
}
function bezier(p1x, p1y, p2x, p2y) {
    var bezier = new unitbezier(p1x, p1y, p2x, p2y);
    return function (t) {
        return bezier.solve(t);
    };
}
var ease = bezier(0.25, 0.1, 0.25, 1);
function clamp(n, min, max) {
    return Math.min(max, Math.max(min, n));
}
function wrap(n, min, max) {
    var d = max - min;
    var w = ((n - min) % d + d) % d + min;
    return w === min ? max : w;
}
function asyncAll(array, fn, callback) {
    if (!array.length) {
        return callback(null, []);
    }
    var remaining = array.length;
    var results = new Array(array.length);
    var error = null;
    array.forEach(function (item, i) {
        fn(item, function (err, result) {
            if (err) {
                error = err;
            }
            results[i] = result;
            if (--remaining === 0) {
                callback(error, results);
            }
        });
    });
}
function values(obj) {
    var result = [];
    for (var k in obj) {
        result.push(obj[k]);
    }
    return result;
}
function keysDifference(obj, other) {
    var difference = [];
    for (var i in obj) {
        if (!(i in other)) {
            difference.push(i);
        }
    }
    return difference;
}
function extend(dest) {
    var sources = [], len = arguments.length - 1;
    while (len-- > 0)
        sources[len] = arguments[len + 1];
    for (var i = 0, list = sources; i < list.length; i += 1) {
        var src = list[i];
        for (var k in src) {
            dest[k] = src[k];
        }
    }
    return dest;
}
function pick(src, properties) {
    var result = {};
    for (var i = 0; i < properties.length; i++) {
        var k = properties[i];
        if (k in src) {
            result[k] = src[k];
        }
    }
    return result;
}
var id = 1;
function uniqueId() {
    return id++;
}
function uuid() {
    function b(a) {
        return a ? (a ^ Math.random() * 16 >> a / 4).toString(16) : ([10000000] + -[1000] + -4000 + -8000 + -100000000000).replace(/[018]/g, b);
    }
    return b();
}
function nextPowerOfTwo(value) {
    if (value <= 1) {
        return 1;
    }
    return Math.pow(2, Math.ceil(Math.log(value) / Math.LN2));
}
function validateUuid(str) {
    return str ? /^[0-9a-f]{8}-[0-9a-f]{4}-[4][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(str) : false;
}
function bindAll(fns, context) {
    fns.forEach(function (fn) {
        if (!context[fn]) {
            return;
        }
        context[fn] = context[fn].bind(context);
    });
}
function endsWith(string, suffix) {
    return string.indexOf(suffix, string.length - suffix.length) !== -1;
}
function mapObject(input, iterator, context) {
    var output = {};
    for (var key in input) {
        output[key] = iterator.call(context || this, input[key], key, input);
    }
    return output;
}
function filterObject(input, iterator, context) {
    var output = {};
    for (var key in input) {
        if (iterator.call(context || this, input[key], key, input)) {
            output[key] = input[key];
        }
    }
    return output;
}
function clone(input) {
    if (Array.isArray(input)) {
        return input.map(clone);
    } else if (typeof input === 'object' && input) {
        return mapObject(input, clone);
    } else {
        return input;
    }
}
function arraysIntersect(a, b) {
    for (var l = 0; l < a.length; l++) {
        if (b.indexOf(a[l]) >= 0) {
            return true;
        }
    }
    return false;
}
var warnOnceHistory = {};
function warnOnce(message) {
    if (!warnOnceHistory[message]) {
        if (typeof console !== 'undefined') {
            console.warn(message);
        }
        warnOnceHistory[message] = true;
    }
}
function isCounterClockwise(a, b, c) {
    return (c.y - a.y) * (b.x - a.x) > (b.y - a.y) * (c.x - a.x);
}
function calculateSignedArea(ring) {
    var sum = 0;
    for (var i = 0, len = ring.length, j = len - 1, p1 = void 0, p2 = void 0; i < len; j = i++) {
        p1 = ring[i];
        p2 = ring[j];
        sum += (p2.x - p1.x) * (p1.y + p2.y);
    }
    return sum;
}
function sphericalToCartesian(ref) {
    var r = ref[0];
    var azimuthal = ref[1];
    var polar = ref[2];
    azimuthal += 90;
    azimuthal *= Math.PI / 180;
    polar *= Math.PI / 180;
    return {
        x: r * Math.cos(azimuthal) * Math.sin(polar),
        y: r * Math.sin(azimuthal) * Math.sin(polar),
        z: r * Math.cos(polar)
    };
}
function isWorker() {
    return typeof WorkerGlobalScope !== 'undefined' && typeof self !== 'undefined' && self instanceof WorkerGlobalScope;
}
function parseCacheControl(cacheControl) {
    var re = /(?:^|(?:\s*\,\s*))([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)(?:\=(?:([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)|(?:\"((?:[^"\\]|\\.)*)\")))?/g;
    var header = {};
    cacheControl.replace(re, function ($0, $1, $2, $3) {
        var value = $2 || $3;
        header[$1] = value ? value.toLowerCase() : true;
        return '';
    });
    if (header['max-age']) {
        var maxAge = parseInt(header['max-age'], 10);
        if (isNaN(maxAge)) {
            delete header['max-age'];
        } else {
            header['max-age'] = maxAge;
        }
    }
    return header;
}
var _isSafari = null;
function isSafari(scope) {
    if (_isSafari == null) {
        var userAgent = scope.navigator ? scope.navigator.userAgent : null;
        _isSafari = !!scope.safari || !!(userAgent && (/\b(iPad|iPhone|iPod)\b/.test(userAgent) || !!userAgent.match('Safari') && !userAgent.match('Chrome')));
    }
    return _isSafari;
}
function storageAvailable(type) {
    try {
        var storage = window$1[type];
        storage.setItem('_mapbox_test_', 1);
        storage.removeItem('_mapbox_test_');
        return true;
    } catch (e) {
        return false;
    }
}
function b64EncodeUnicode(str) {
    return window$1.btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
        return String.fromCharCode(Number('0x' + p1));
    }));
}
function b64DecodeUnicode(str) {
    return decodeURIComponent(window$1.atob(str).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
}

var now = window$1.performance && window$1.performance.now ? window$1.performance.now.bind(window$1.performance) : Date.now.bind(Date);
var raf = window$1.requestAnimationFrame || window$1.mozRequestAnimationFrame || window$1.webkitRequestAnimationFrame || window$1.msRequestAnimationFrame;
var cancel = window$1.cancelAnimationFrame || window$1.mozCancelAnimationFrame || window$1.webkitCancelAnimationFrame || window$1.msCancelAnimationFrame;
var linkEl;
var reducedMotionQuery;
var exported = {
    now: now,
    frame: function frame(fn) {
        var frame = raf(fn);
        return {
            cancel: function () {
                return cancel(frame);
            }
        };
    },
    getImageData: function getImageData(img, padding) {
        if (padding === void 0)
            padding = 0;
        var canvas = window$1.document.createElement('canvas');
        var context = canvas.getContext('2d');
        if (!context) {
            throw new Error('failed to create canvas 2d context');
        }
        canvas.width = img.width;
        canvas.height = img.height;
        context.drawImage(img, 0, 0, img.width, img.height);
        return context.getImageData(-padding, -padding, img.width + 2 * padding, img.height + 2 * padding);
    },
    resolveURL: function resolveURL(path) {
        if (!linkEl) {
            linkEl = window$1.document.createElement('a');
        }
        linkEl.href = path;
        return linkEl.href;
    },
    hardwareConcurrency: window$1.navigator && window$1.navigator.hardwareConcurrency || 4,
    get devicePixelRatio() {
        return window$1.devicePixelRatio;
    },
    get prefersReducedMotion() {
        if (!window$1.matchMedia) {
            return false;
        }
        if (reducedMotionQuery == null) {
            reducedMotionQuery = window$1.matchMedia('(prefers-reduced-motion: reduce)');
        }
        return reducedMotionQuery.matches;
    }
};

var config = {
    API_URL: 'https://api.mapbox.com',
    get EVENTS_URL() {
        if (!this.API_URL) {
            return null;
        }
        if (this.API_URL.indexOf('https://api.mapbox.cn') === 0) {
            return 'https://events.mapbox.cn/events/v2';
        } else if (this.API_URL.indexOf('https://api.mapbox.com') === 0) {
            return 'https://events.mapbox.com/events/v2';
        } else {
            return null;
        }
    },
    FEEDBACK_URL: 'https://apps.mapbox.com/feedback',
    REQUIRE_ACCESS_TOKEN: true,
    ACCESS_TOKEN: null,
    MAX_PARALLEL_IMAGE_REQUESTS: 16
};

var exported$1 = {
    supported: false,
    testSupport: testSupport
};
var glForTesting;
var webpCheckComplete = false;
var webpImgTest;
var webpImgTestOnloadComplete = false;
if (window$1.document) {
    webpImgTest = window$1.document.createElement('img');
    webpImgTest.onload = function () {
        if (glForTesting) {
            testWebpTextureUpload(glForTesting);
        }
        glForTesting = null;
        webpImgTestOnloadComplete = true;
    };
    webpImgTest.onerror = function () {
        webpCheckComplete = true;
        glForTesting = null;
    };
    webpImgTest.src = 'data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAQAAAAfQ//73v/+BiOh/AAA=';
}
function testSupport(gl) {
    if (webpCheckComplete || !webpImgTest) {
        return;
    }
    if (webpImgTestOnloadComplete) {
        testWebpTextureUpload(gl);
    } else {
        glForTesting = gl;
    }
}
function testWebpTextureUpload(gl) {
    var texture = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D, texture);
    try {
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, webpImgTest);
        if (gl.isContextLost()) {
            return;
        }
        exported$1.supported = true;
    } catch (e) {
    }
    gl.deleteTexture(texture);
    webpCheckComplete = true;
}

var SKU_ID = '01';
function createSkuToken() {
    var TOKEN_VERSION = '1';
    var base62chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    var sessionRandomizer = '';
    for (var i = 0; i < 10; i++) {
        sessionRandomizer += base62chars[Math.floor(Math.random() * 62)];
    }
    var expiration = 12 * 60 * 60 * 1000;
    var token = [
        TOKEN_VERSION,
        SKU_ID,
        sessionRandomizer
    ].join('');
    var tokenExpiresAt = Date.now() + expiration;
    return {
        token: token,
        tokenExpiresAt: tokenExpiresAt
    };
}

var RequestManager = function RequestManager(transformRequestFn, customAccessToken) {
    this._transformRequestFn = transformRequestFn;
    this._customAccessToken = customAccessToken;
    this._createSkuToken();
};
RequestManager.prototype._createSkuToken = function _createSkuToken() {
    var skuToken = createSkuToken();
    this._skuToken = skuToken.token;
    this._skuTokenExpiresAt = skuToken.tokenExpiresAt;
};
RequestManager.prototype._isSkuTokenExpired = function _isSkuTokenExpired() {
    return Date.now() > this._skuTokenExpiresAt;
};
RequestManager.prototype.transformRequest = function transformRequest(url, type) {
    if (this._transformRequestFn) {
        return this._transformRequestFn(url, type) || { url: url };
    }
    return { url: url };
};
RequestManager.prototype.normalizeStyleURL = function normalizeStyleURL(url, accessToken) {
    if (!isMapboxURL(url)) {
        return url;
    }
    var urlObject = parseUrl(url);
    urlObject.path = '/styles/v1' + urlObject.path;
    return this._makeAPIURL(urlObject, this._customAccessToken || accessToken);
};
RequestManager.prototype.normalizeGlyphsURL = function normalizeGlyphsURL(url, accessToken) {
    if (!isMapboxURL(url)) {
        return url;
    }
    var urlObject = parseUrl(url);
    urlObject.path = '/fonts/v1' + urlObject.path;
    return this._makeAPIURL(urlObject, this._customAccessToken || accessToken);
};
RequestManager.prototype.normalizeSourceURL = function normalizeSourceURL(url, accessToken) {
    if (!isMapboxURL(url)) {
        return url;
    }
    var urlObject = parseUrl(url);
    urlObject.path = '/v4/' + urlObject.authority + '.json';
    urlObject.params.push('secure');
    return this._makeAPIURL(urlObject, this._customAccessToken || accessToken);
};
RequestManager.prototype.normalizeSpriteURL = function normalizeSpriteURL(url, format, extension, accessToken) {
    var urlObject = parseUrl(url);
    if (!isMapboxURL(url)) {
        urlObject.path += '' + format + extension;
        return formatUrl(urlObject);
    }
    urlObject.path = '/styles/v1' + urlObject.path + '/sprite' + format + extension;
    return this._makeAPIURL(urlObject, this._customAccessToken || accessToken);
};
RequestManager.prototype.normalizeTileURL = function normalizeTileURL(tileURL, tileSize) {
    if (this._isSkuTokenExpired()) {
        this._createSkuToken();
    }
    if (tileURL && !isMapboxURL(tileURL)) {
        return tileURL;
    }
    var urlObject = parseUrl(tileURL);
    var imageExtensionRe = /(\.(png|jpg)\d*)(?=$)/;
    var tileURLAPIPrefixRe = /^.+\/v4\//;
    var suffix = exported.devicePixelRatio >= 2 || tileSize === 512 ? '@2x' : '';
    var extension = exported$1.supported ? '.webp' : '$1';
    urlObject.path = urlObject.path.replace(imageExtensionRe, '' + suffix + extension);
    urlObject.path = urlObject.path.replace(tileURLAPIPrefixRe, '/');
    urlObject.path = '/v4' + urlObject.path;
    var accessToken = this._customAccessToken || getAccessToken(urlObject.params) || config.ACCESS_TOKEN;
    if (config.REQUIRE_ACCESS_TOKEN && accessToken && this._skuToken) {
        urlObject.params.push('sku=' + this._skuToken);
    }
    return this._makeAPIURL(urlObject, accessToken);
};
RequestManager.prototype.canonicalizeTileURL = function canonicalizeTileURL(url, removeAccessToken) {
    var version = '/v4/';
    var extensionRe = /\.[\w]+$/;
    var urlObject = parseUrl(url);
    if (!urlObject.path.match(/(^\/v4\/)/) || !urlObject.path.match(extensionRe)) {
        return url;
    }
    var result = 'mapbox://tiles/';
    result += urlObject.path.replace(version, '');
    var params = urlObject.params;
    if (removeAccessToken) {
        params = params.filter(function (p) {
            return !p.match(/^access_token=/);
        });
    }
    if (params.length) {
        result += '?' + params.join('&');
    }
    return result;
};
RequestManager.prototype.canonicalizeTileset = function canonicalizeTileset(tileJSON, sourceURL) {
    var removeAccessToken = sourceURL ? isMapboxURL(sourceURL) : false;
    var canonical = [];
    for (var i = 0, list = tileJSON.tiles || []; i < list.length; i += 1) {
        var url = list[i];
        if (isMapboxHTTPURL(url)) {
            canonical.push(this.canonicalizeTileURL(url, removeAccessToken));
        } else {
            canonical.push(url);
        }
    }
    return canonical;
};
RequestManager.prototype._makeAPIURL = function _makeAPIURL(urlObject, accessToken) {
    var help = 'See https://www.mapbox.com/api-documentation/#access-tokens-and-token-scopes';
    var apiUrlObject = parseUrl(config.API_URL);
    urlObject.protocol = apiUrlObject.protocol;
    urlObject.authority = apiUrlObject.authority;
    if (urlObject.protocol === 'http') {
        var i = urlObject.params.indexOf('secure');
        if (i >= 0) {
            urlObject.params.splice(i, 1);
        }
    }
    if (apiUrlObject.path !== '/') {
        urlObject.path = '' + apiUrlObject.path + urlObject.path;
    }
    if (!config.REQUIRE_ACCESS_TOKEN) {
        return formatUrl(urlObject);
    }
    accessToken = accessToken || config.ACCESS_TOKEN;
    if (!accessToken) {
        throw new Error('An API access token is required to use Mapbox GL. ' + help);
    }
    if (accessToken[0] === 's') {
        throw new Error('Use a public access token (pk.*) with Mapbox GL, not a secret access token (sk.*). ' + help);
    }
    urlObject.params = urlObject.params.filter(function (d) {
        return d.indexOf('access_token') === -1;
    });
    urlObject.params.push('access_token=' + accessToken);
    return formatUrl(urlObject);
};
function isMapboxURL(url) {
    return url.indexOf('mapbox:') === 0;
}
var mapboxHTTPURLRe = /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/|\?|$)/i;
function isMapboxHTTPURL(url) {
    return mapboxHTTPURLRe.test(url);
}
function hasCacheDefeatingSku(url) {
    return url.indexOf('sku=') > 0 && isMapboxHTTPURL(url);
}
function getAccessToken(params) {
    for (var i = 0, list = params; i < list.length; i += 1) {
        var param = list[i];
        var match = param.match(/^access_token=(.*)$/);
        if (match) {
            return match[1];
        }
    }
    return null;
}
var urlRe = /^(\w+):\/\/([^/?]*)(\/[^?]+)?\??(.+)?/;
function parseUrl(url) {
    var parts = url.match(urlRe);
    if (!parts) {
        throw new Error('Unable to parse URL object');
    }
    return {
        protocol: parts[1],
        authority: parts[2],
        path: parts[3] || '/',
        params: parts[4] ? parts[4].split('&') : []
    };
}
function formatUrl(obj) {
    var params = obj.params.length ? '?' + obj.params.join('&') : '';
    return obj.protocol + '://' + obj.authority + obj.path + params;
}
var telemEventKey = 'mapbox.eventData';
function parseAccessToken(accessToken) {
    if (!accessToken) {
        return null;
    }
    var parts = accessToken.split('.');
    if (!parts || parts.length !== 3) {
        return null;
    }
    try {
        var jsonData = JSON.parse(b64DecodeUnicode(parts[1]));
        return jsonData;
    } catch (e) {
        return null;
    }
}
var TelemetryEvent = function TelemetryEvent(type) {
    this.type = type;
    this.anonId = null;
    this.eventData = {};
    this.queue = [];
    this.pendingRequest = null;
};
TelemetryEvent.prototype.getStorageKey = function getStorageKey(domain) {
    var tokenData = parseAccessToken(config.ACCESS_TOKEN);
    var u = '';
    if (tokenData && tokenData['u']) {
        u = b64EncodeUnicode(tokenData['u']);
    } else {
        u = config.ACCESS_TOKEN || '';
    }
    return domain ? telemEventKey + '.' + domain + ':' + u : telemEventKey + ':' + u;
};
TelemetryEvent.prototype.fetchEventData = function fetchEventData() {
    var isLocalStorageAvailable = storageAvailable('localStorage');
    var storageKey = this.getStorageKey();
    var uuidKey = this.getStorageKey('uuid');
    if (isLocalStorageAvailable) {
        try {
            var data = window$1.localStorage.getItem(storageKey);
            if (data) {
                this.eventData = JSON.parse(data);
            }
            var uuid = window$1.localStorage.getItem(uuidKey);
            if (uuid) {
                this.anonId = uuid;
            }
        } catch (e) {
            warnOnce('Unable to read from LocalStorage');
        }
    }
};
TelemetryEvent.prototype.saveEventData = function saveEventData() {
    var isLocalStorageAvailable = storageAvailable('localStorage');
    var storageKey = this.getStorageKey();
    var uuidKey = this.getStorageKey('uuid');
    if (isLocalStorageAvailable) {
        try {
            window$1.localStorage.setItem(uuidKey, this.anonId);
            if (Object.keys(this.eventData).length >= 1) {
                window$1.localStorage.setItem(storageKey, JSON.stringify(this.eventData));
            }
        } catch (e) {
            warnOnce('Unable to write to LocalStorage');
        }
    }
};
TelemetryEvent.prototype.processRequests = function processRequests(_) {
};
TelemetryEvent.prototype.postEvent = function postEvent(timestamp, additionalPayload, callback, customAccessToken) {
    var this$1 = this;
    if (!config.EVENTS_URL) {
        return;
    }
    var eventsUrlObject = parseUrl(config.EVENTS_URL);
    eventsUrlObject.params.push('access_token=' + (customAccessToken || config.ACCESS_TOKEN || ''));
    var payload = {
        event: this.type,
        created: new Date(timestamp).toISOString(),
        sdkIdentifier: 'mapbox-gl-js',
        sdkVersion: version,
        skuId: SKU_ID,
        userId: this.anonId
    };
    var finalPayload = additionalPayload ? extend(payload, additionalPayload) : payload;
    var request = {
        url: formatUrl(eventsUrlObject),
        headers: { 'Content-Type': 'text/plain' },
        body: JSON.stringify([finalPayload])
    };
    this.pendingRequest = postData(request, function (error) {
        this$1.pendingRequest = null;
        callback(error);
        this$1.saveEventData();
        this$1.processRequests(customAccessToken);
    });
};
TelemetryEvent.prototype.queueRequest = function queueRequest(event, customAccessToken) {
    this.queue.push(event);
    this.processRequests(customAccessToken);
};
var MapLoadEvent = function (TelemetryEvent) {
    function MapLoadEvent() {
        TelemetryEvent.call(this, 'map.load');
        this.success = {};
        this.skuToken = '';
    }
    if (TelemetryEvent)
        MapLoadEvent.__proto__ = TelemetryEvent;
    MapLoadEvent.prototype = Object.create(TelemetryEvent && TelemetryEvent.prototype);
    MapLoadEvent.prototype.constructor = MapLoadEvent;
    MapLoadEvent.prototype.postMapLoadEvent = function postMapLoadEvent(tileUrls, mapId, skuToken, customAccessToken) {
        this.skuToken = skuToken;
        if (config.EVENTS_URL && customAccessToken || config.ACCESS_TOKEN && Array.isArray(tileUrls) && tileUrls.some(function (url) {
                return isMapboxURL(url) || isMapboxHTTPURL(url);
            })) {
            this.queueRequest({
                id: mapId,
                timestamp: Date.now()
            }, customAccessToken);
        }
    };
    MapLoadEvent.prototype.processRequests = function processRequests(customAccessToken) {
        var this$1 = this;
        if (this.pendingRequest || this.queue.length === 0) {
            return;
        }
        var ref = this.queue.shift();
        var id = ref.id;
        var timestamp = ref.timestamp;
        if (id && this.success[id]) {
            return;
        }
        if (!this.anonId) {
            this.fetchEventData();
        }
        if (!validateUuid(this.anonId)) {
            this.anonId = uuid();
        }
        this.postEvent(timestamp, { skuToken: this.skuToken }, function (err) {
            if (!err) {
                if (id) {
                    this$1.success[id] = true;
                }
            }
        }, customAccessToken);
    };
    return MapLoadEvent;
}(TelemetryEvent);
var TurnstileEvent = function (TelemetryEvent) {
    function TurnstileEvent(customAccessToken) {
        TelemetryEvent.call(this, 'appUserTurnstile');
        this._customAccessToken = customAccessToken;
    }
    if (TelemetryEvent)
        TurnstileEvent.__proto__ = TelemetryEvent;
    TurnstileEvent.prototype = Object.create(TelemetryEvent && TelemetryEvent.prototype);
    TurnstileEvent.prototype.constructor = TurnstileEvent;
    TurnstileEvent.prototype.postTurnstileEvent = function postTurnstileEvent(tileUrls, customAccessToken) {
        if (config.EVENTS_URL && config.ACCESS_TOKEN && Array.isArray(tileUrls) && tileUrls.some(function (url) {
                return isMapboxURL(url) || isMapboxHTTPURL(url);
            })) {
            this.queueRequest(Date.now(), customAccessToken);
        }
    };
    TurnstileEvent.prototype.processRequests = function processRequests(customAccessToken) {
        var this$1 = this;
        if (this.pendingRequest || this.queue.length === 0) {
            return;
        }
        if (!this.anonId || !this.eventData.lastSuccess || !this.eventData.tokenU) {
            this.fetchEventData();
        }
        var tokenData = parseAccessToken(config.ACCESS_TOKEN);
        var tokenU = tokenData ? tokenData['u'] : config.ACCESS_TOKEN;
        var dueForEvent = tokenU !== this.eventData.tokenU;
        if (!validateUuid(this.anonId)) {
            this.anonId = uuid();
            dueForEvent = true;
        }
        var nextUpdate = this.queue.shift();
        if (this.eventData.lastSuccess) {
            var lastUpdate = new Date(this.eventData.lastSuccess);
            var nextDate = new Date(nextUpdate);
            var daysElapsed = (nextUpdate - this.eventData.lastSuccess) / (24 * 60 * 60 * 1000);
            dueForEvent = dueForEvent || daysElapsed >= 1 || daysElapsed < -1 || lastUpdate.getDate() !== nextDate.getDate();
        } else {
            dueForEvent = true;
        }
        if (!dueForEvent) {
            return this.processRequests();
        }
        this.postEvent(nextUpdate, { 'enabled.telemetry': false }, function (err) {
            if (!err) {
                this$1.eventData.lastSuccess = nextUpdate;
                this$1.eventData.tokenU = tokenU;
            }
        }, customAccessToken);
    };
    return TurnstileEvent;
}(TelemetryEvent);
var turnstileEvent_ = new TurnstileEvent();
var postTurnstileEvent = turnstileEvent_.postTurnstileEvent.bind(turnstileEvent_);
var mapLoadEvent_ = new MapLoadEvent();
var postMapLoadEvent = mapLoadEvent_.postMapLoadEvent.bind(mapLoadEvent_);

var CACHE_NAME = 'mapbox-tiles';
var cacheLimit = 500;
var cacheCheckThreshold = 50;
var MIN_TIME_UNTIL_EXPIRY = 1000 * 60 * 7;
var sharedCache;
function cacheOpen() {
    if (window$1.caches && !sharedCache) {
        sharedCache = window$1.caches.open(CACHE_NAME);
    }
}
var responseConstructorSupportsReadableStream;
function prepareBody(response, callback) {
    if (responseConstructorSupportsReadableStream === undefined) {
        try {
            new Response(new ReadableStream());
            responseConstructorSupportsReadableStream = true;
        } catch (e) {
            responseConstructorSupportsReadableStream = false;
        }
    }
    if (responseConstructorSupportsReadableStream) {
        callback(response.body);
    } else {
        response.blob().then(callback);
    }
}
function cachePut(request, response, requestTime) {
    cacheOpen();
    if (!sharedCache) {
        return;
    }
    var options = {
        status: response.status,
        statusText: response.statusText,
        headers: new window$1.Headers()
    };
    response.headers.forEach(function (v, k) {
        return options.headers.set(k, v);
    });
    var cacheControl = parseCacheControl(response.headers.get('Cache-Control') || '');
    if (cacheControl['no-store']) {
        return;
    }
    if (cacheControl['max-age']) {
        options.headers.set('Expires', new Date(requestTime + cacheControl['max-age'] * 1000).toUTCString());
    }
    var timeUntilExpiry = new Date(options.headers.get('Expires')).getTime() - requestTime;
    if (timeUntilExpiry < MIN_TIME_UNTIL_EXPIRY) {
        return;
    }
    prepareBody(response, function (body) {
        var clonedResponse = new window$1.Response(body, options);
        cacheOpen();
        if (!sharedCache) {
            return;
        }
        sharedCache.then(function (cache) {
            return cache.put(stripQueryParameters(request.url), clonedResponse);
        }).catch(function (e) {
            return warnOnce(e.message);
        });
    });
}
function stripQueryParameters(url) {
    var start = url.indexOf('?');
    return start < 0 ? url : url.slice(0, start);
}
function cacheGet(request, callback) {
    cacheOpen();
    if (!sharedCache) {
        return callback(null);
    }
    var strippedURL = stripQueryParameters(request.url);
    sharedCache.then(function (cache) {
        cache.match(strippedURL).then(function (response) {
            var fresh = isFresh(response);
            cache.delete(strippedURL);
            if (fresh) {
                cache.put(strippedURL, response.clone());
            }
            callback(null, response, fresh);
        }).catch(callback);
    }).catch(callback);
}
function isFresh(response) {
    if (!response) {
        return false;
    }
    var expires = new Date(response.headers.get('Expires') || 0);
    var cacheControl = parseCacheControl(response.headers.get('Cache-Control') || '');
    return expires > Date.now() && !cacheControl['no-cache'];
}
var globalEntryCounter = Infinity;
function cacheEntryPossiblyAdded(dispatcher) {
    globalEntryCounter++;
    if (globalEntryCounter > cacheCheckThreshold) {
        dispatcher.getActor().send('enforceCacheSizeLimit', cacheLimit);
        globalEntryCounter = 0;
    }
}
function enforceCacheSizeLimit(limit) {
    cacheOpen();
    if (!sharedCache) {
        return;
    }
    sharedCache.then(function (cache) {
        cache.keys().then(function (keys) {
            for (var i = 0; i < keys.length - limit; i++) {
                cache.delete(keys[i]);
            }
        });
    });
}
function clearTileCache(callback) {
    var promise = window$1.caches.delete(CACHE_NAME);
    if (callback) {
        promise.catch(callback).then(function () {
            return callback();
        });
    }
}
function setCacheLimits(limit, checkThreshold) {
    cacheLimit = limit;
    cacheCheckThreshold = checkThreshold;
}

var supportsOffscreenCanvas;
function offscreenCanvasSupported() {
    if (supportsOffscreenCanvas == null) {
        supportsOffscreenCanvas = window$1.OffscreenCanvas && new window$1.OffscreenCanvas(1, 1).getContext('2d') && typeof window$1.createImageBitmap === 'function';
    }
    return supportsOffscreenCanvas;
}

var ResourceType = {
    Unknown: 'Unknown',
    Style: 'Style',
    Source: 'Source',
    Tile: 'Tile',
    Glyphs: 'Glyphs',
    SpriteImage: 'SpriteImage',
    SpriteJSON: 'SpriteJSON',
    Image: 'Image'
};
if (typeof Object.freeze == 'function') {
    Object.freeze(ResourceType);
}
var AJAXError = function (Error) {
    function AJAXError(message, status, url) {
        if (status === 401 && isMapboxHTTPURL(url)) {
            message += ': you may have provided an invalid Mapbox access token. See https://www.mapbox.com/api-documentation/#access-tokens-and-token-scopes';
        }
        Error.call(this, message);
        this.status = status;
        this.url = url;
        this.name = this.constructor.name;
        this.message = message;
    }
    if (Error)
        AJAXError.__proto__ = Error;
    AJAXError.prototype = Object.create(Error && Error.prototype);
    AJAXError.prototype.constructor = AJAXError;
    AJAXError.prototype.toString = function toString() {
        return this.name + ': ' + this.message + ' (' + this.status + '): ' + this.url;
    };
    return AJAXError;
}(Error);
var getReferrer = isWorker() ? function () {
    return self.worker && self.worker.referrer;
} : function () {
    return (window$1.location.protocol === 'blob:' ? window$1.parent : window$1).location.href;
};
var isFileURL = function (url) {
    return /^file:/.test(url) || /^file:/.test(getReferrer()) && !/^\w+:/.test(url);
};
function makeFetchRequest(requestParameters, callback) {
    var controller = new window$1.AbortController();
    var request = new window$1.Request(requestParameters.url, {
        method: requestParameters.method || 'GET',
        body: requestParameters.body,
        credentials: requestParameters.credentials,
        headers: requestParameters.headers,
        referrer: getReferrer(),
        signal: controller.signal
    });
    var complete = false;
    var aborted = false;
    var cacheIgnoringSearch = hasCacheDefeatingSku(request.url);
    if (requestParameters.type === 'json') {
        request.headers.set('Accept', 'application/json');
    }
    var validateOrFetch = function (err, cachedResponse, responseIsFresh) {
        if (aborted) {
            return;
        }
        if (err) {
            if (err.message !== 'SecurityError') {
                warnOnce(err);
            }
        }
        if (cachedResponse && responseIsFresh) {
            return finishRequest(cachedResponse);
        }
        var requestTime = Date.now();
        window$1.fetch(request).then(function (response) {
            if (response.ok) {
                var cacheableResponse = cacheIgnoringSearch ? response.clone() : null;
                return finishRequest(response, cacheableResponse, requestTime);
            } else {
                return callback(new AJAXError(response.statusText, response.status, requestParameters.url));
            }
        }).catch(function (error) {
            if (error.code === 20) {
                return;
            }
            callback(new Error(error.message));
        });
    };
    var finishRequest = function (response, cacheableResponse, requestTime) {
        (requestParameters.type === 'arrayBuffer' ? response.arrayBuffer() : requestParameters.type === 'json' ? response.json() : response.text()).then(function (result) {
            if (aborted) {
                return;
            }
            if (cacheableResponse && requestTime) {
                cachePut(request, cacheableResponse, requestTime);
            }
            complete = true;
            callback(null, result, response.headers.get('Cache-Control'), response.headers.get('Expires'));
        }).catch(function (err) {
            if (!aborted) {
                callback(new Error(err.message));
            }
        });
    };
    if (cacheIgnoringSearch) {
        cacheGet(request, validateOrFetch);
    } else {
        validateOrFetch(null, null);
    }
    return {
        cancel: function () {
            aborted = true;
            if (!complete) {
                controller.abort();
            }
        }
    };
}
function makeXMLHttpRequest(requestParameters, callback) {
    var xhr = new window$1.XMLHttpRequest();
    xhr.open(requestParameters.method || 'GET', requestParameters.url, true);
    if (requestParameters.type === 'arrayBuffer') {
        xhr.responseType = 'arraybuffer';
    }
    for (var k in requestParameters.headers) {
        xhr.setRequestHeader(k, requestParameters.headers[k]);
    }
    if (requestParameters.type === 'json') {
        xhr.responseType = 'text';
        xhr.setRequestHeader('Accept', 'application/json');
    }
    xhr.withCredentials = requestParameters.credentials === 'include';
    xhr.onerror = function () {
        callback(new Error(xhr.statusText));
    };
    xhr.onload = function () {
        if ((xhr.status >= 200 && xhr.status < 300 || xhr.status === 0) && xhr.response !== null) {
            var data = xhr.response;
            if (requestParameters.type === 'json') {
                try {
                    data = JSON.parse(xhr.response);
                } catch (err) {
                    return callback(err);
                }
            }
            callback(null, data, xhr.getResponseHeader('Cache-Control'), xhr.getResponseHeader('Expires'));
        } else {
            callback(new AJAXError(xhr.statusText, xhr.status, requestParameters.url));
        }
    };
    xhr.send(requestParameters.body);
    return {
        cancel: function () {
            return xhr.abort();
        }
    };
}
var makeRequest = function (requestParameters, callback) {
    if (!isFileURL(requestParameters.url)) {
        if (window$1.fetch && window$1.Request && window$1.AbortController && window$1.Request.prototype.hasOwnProperty('signal')) {
            return makeFetchRequest(requestParameters, callback);
        }
        if (isWorker() && self.worker && self.worker.actor) {
            var queueOnMainThread = true;
            return self.worker.actor.send('getResource', requestParameters, callback, undefined, queueOnMainThread);
        }
    }
    return makeXMLHttpRequest(requestParameters, callback);
};
var getJSON = function (requestParameters, callback) {
    return makeRequest(extend(requestParameters, { type: 'json' }), callback);
};
var getArrayBuffer = function (requestParameters, callback) {
    return makeRequest(extend(requestParameters, { type: 'arrayBuffer' }), callback);
};
var postData = function (requestParameters, callback) {
    return makeRequest(extend(requestParameters, { method: 'POST' }), callback);
};
function sameOrigin(url) {
    var a = window$1.document.createElement('a');
    a.href = url;
    return a.protocol === window$1.document.location.protocol && a.host === window$1.document.location.host;
}
var transparentPngUrl = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVQYV2NgAAIAAAUAAarVyFEAAAAASUVORK5CYII=';
function arrayBufferToImage(data, callback, cacheControl, expires) {
    var img = new window$1.Image();
    var URL = window$1.URL;
    img.onload = function () {
        callback(null, img);
        URL.revokeObjectURL(img.src);
        img.onload = null;
        window$1.requestAnimationFrame(function () {
            img.src = transparentPngUrl;
        });
    };
    img.onerror = function () {
        return callback(new Error('Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported.'));
    };
    var blob = new window$1.Blob([new Uint8Array(data)], { type: 'image/png' });
    img.cacheControl = cacheControl;
    img.expires = expires;
    img.src = data.byteLength ? URL.createObjectURL(blob) : transparentPngUrl;
}
function arrayBufferToImageBitmap(data, callback) {
    var blob = new window$1.Blob([new Uint8Array(data)], { type: 'image/png' });
    window$1.createImageBitmap(blob).then(function (imgBitmap) {
        callback(null, imgBitmap);
    }).catch(function (e) {
        callback(new Error('Could not load image because of ' + e.message + '. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported.'));
    });
}
var imageQueue, numImageRequests;
var resetImageRequestQueue = function () {
    imageQueue = [];
    numImageRequests = 0;
};
resetImageRequestQueue();
var getImage = function (requestParameters, callback) {
    if (exported$1.supported) {
        if (!requestParameters.headers) {
            requestParameters.headers = {};
        }
        requestParameters.headers.accept = 'image/webp,*/*';
    }
    if (numImageRequests >= config.MAX_PARALLEL_IMAGE_REQUESTS) {
        var queued = {
            requestParameters: requestParameters,
            callback: callback,
            cancelled: false,
            cancel: function cancel() {
                this.cancelled = true;
            }
        };
        imageQueue.push(queued);
        return queued;
    }
    numImageRequests++;
    var advanced = false;
    var advanceImageRequestQueue = function () {
        if (advanced) {
            return;
        }
        advanced = true;
        numImageRequests--;
        while (imageQueue.length && numImageRequests < config.MAX_PARALLEL_IMAGE_REQUESTS) {
            var request = imageQueue.shift();
            var requestParameters = request.requestParameters;
            var callback = request.callback;
            var cancelled = request.cancelled;
            if (!cancelled) {
                request.cancel = getImage(requestParameters, callback).cancel;
            }
        }
    };
    var request = getArrayBuffer(requestParameters, function (err, data, cacheControl, expires) {
        advanceImageRequestQueue();
        if (err) {
            callback(err);
        } else if (data) {
            if (offscreenCanvasSupported()) {
                arrayBufferToImageBitmap(data, callback);
            } else {
                arrayBufferToImage(data, callback, cacheControl, expires);
            }
        }
    });
    return {
        cancel: function () {
            request.cancel();
            advanceImageRequestQueue();
        }
    };
};
var getVideo = function (urls, callback) {
    var video = window$1.document.createElement('video');
    video.muted = true;
    video.onloadstart = function () {
        callback(null, video);
    };
    for (var i = 0; i < urls.length; i++) {
        var s = window$1.document.createElement('source');
        if (!sameOrigin(urls[i])) {
            video.crossOrigin = 'Anonymous';
        }
        s.src = urls[i];
        video.appendChild(s);
    }
    return {
        cancel: function () {
        }
    };
};

function _addEventListener(type, listener, listenerList) {
    var listenerExists = listenerList[type] && listenerList[type].indexOf(listener) !== -1;
    if (!listenerExists) {
        listenerList[type] = listenerList[type] || [];
        listenerList[type].push(listener);
    }
}
function _removeEventListener(type, listener, listenerList) {
    if (listenerList && listenerList[type]) {
        var index = listenerList[type].indexOf(listener);
        if (index !== -1) {
            listenerList[type].splice(index, 1);
        }
    }
}
var Event = function Event(type, data) {
    if (data === void 0)
        data = {};
    extend(this, data);
    this.type = type;
};
var ErrorEvent = function (Event) {
    function ErrorEvent(error, data) {
        if (data === void 0)
            data = {};
        Event.call(this, 'error', extend({ error: error }, data));
    }
    if (Event)
        ErrorEvent.__proto__ = Event;
    ErrorEvent.prototype = Object.create(Event && Event.prototype);
    ErrorEvent.prototype.constructor = ErrorEvent;
    return ErrorEvent;
}(Event);
var Evented = function Evented() {
};
Evented.prototype.on = function on(type, listener) {
    this._listeners = this._listeners || {};
    _addEventListener(type, listener, this._listeners);
    return this;
};
Evented.prototype.off = function off(type, listener) {
    _removeEventListener(type, listener, this._listeners);
    _removeEventListener(type, listener, this._oneTimeListeners);
    return this;
};
Evented.prototype.once = function once(type, listener) {
    this._oneTimeListeners = this._oneTimeListeners || {};
    _addEventListener(type, listener, this._oneTimeListeners);
    return this;
};
Evented.prototype.fire = function fire(event, properties) {
    if (typeof event === 'string') {
        event = new Event(event, properties || {});
    }
    var type = event.type;
    if (this.listens(type)) {
        event.target = this;
        var listeners = this._listeners && this._listeners[type] ? this._listeners[type].slice() : [];
        for (var i = 0, list = listeners; i < list.length; i += 1) {
            var listener = list[i];
            listener.call(this, event);
        }
        var oneTimeListeners = this._oneTimeListeners && this._oneTimeListeners[type] ? this._oneTimeListeners[type].slice() : [];
        for (var i$1 = 0, list$1 = oneTimeListeners; i$1 < list$1.length; i$1 += 1) {
            var listener$1 = list$1[i$1];
            _removeEventListener(type, listener$1, this._oneTimeListeners);
            listener$1.call(this, event);
        }
        var parent = this._eventedParent;
        if (parent) {
            extend(event, typeof this._eventedParentData === 'function' ? this._eventedParentData() : this._eventedParentData);
            parent.fire(event);
        }
    } else if (event instanceof ErrorEvent) {
        console.error(event.error);
    }
    return this;
};
Evented.prototype.listens = function listens(type) {
    return this._listeners && this._listeners[type] && this._listeners[type].length > 0 || this._oneTimeListeners && this._oneTimeListeners[type] && this._oneTimeListeners[type].length > 0 || this._eventedParent && this._eventedParent.listens(type);
};
Evented.prototype.setEventedParent = function setEventedParent(parent, data) {
    this._eventedParent = parent;
    this._eventedParentData = data;
    return this;
};

var $version = 8;
var $root = {
	version: {
		required: true,
		type: "enum",
		values: [
			8
		]
	},
	name: {
		type: "string"
	},
	metadata: {
		type: "*"
	},
	center: {
		type: "array",
		value: "number"
	},
	zoom: {
		type: "number"
	},
	bearing: {
		type: "number",
		"default": 0,
		period: 360,
		units: "degrees"
	},
	pitch: {
		type: "number",
		"default": 0,
		units: "degrees"
	},
	light: {
		type: "light"
	},
	sources: {
		required: true,
		type: "sources"
	},
	sprite: {
		type: "string"
	},
	glyphs: {
		type: "string"
	},
	transition: {
		type: "transition"
	},
	layers: {
		required: true,
		type: "array",
		value: "layer"
	}
};
var sources = {
	"*": {
		type: "source"
	}
};
var source = [
	"source_vector",
	"source_raster",
	"source_raster_dem",
	"source_geojson",
	"source_video",
	"source_image"
];
var source_vector = {
	type: {
		required: true,
		type: "enum",
		values: {
			vector: {
			}
		}
	},
	url: {
		type: "string"
	},
	tiles: {
		type: "array",
		value: "string"
	},
	bounds: {
		type: "array",
		value: "number",
		length: 4,
		"default": [
			-180,
			-85.051129,
			180,
			85.051129
		]
	},
	scheme: {
		type: "enum",
		values: {
			xyz: {
			},
			tms: {
			}
		},
		"default": "xyz"
	},
	minzoom: {
		type: "number",
		"default": 0
	},
	maxzoom: {
		type: "number",
		"default": 22
	},
	attribution: {
		type: "string"
	},
	promoteId: {
		type: "promoteId"
	},
	volatile: {
		type: "boolean",
		"default": false
	},
	"*": {
		type: "*"
	}
};
var source_raster = {
	type: {
		required: true,
		type: "enum",
		values: {
			raster: {
			}
		}
	},
	url: {
		type: "string"
	},
	tiles: {
		type: "array",
		value: "string"
	},
	bounds: {
		type: "array",
		value: "number",
		length: 4,
		"default": [
			-180,
			-85.051129,
			180,
			85.051129
		]
	},
	minzoom: {
		type: "number",
		"default": 0
	},
	maxzoom: {
		type: "number",
		"default": 22
	},
	tileSize: {
		type: "number",
		"default": 512,
		units: "pixels"
	},
	scheme: {
		type: "enum",
		values: {
			xyz: {
			},
			tms: {
			}
		},
		"default": "xyz"
	},
	attribution: {
		type: "string"
	},
	volatile: {
		type: "boolean",
		"default": false
	},
	"*": {
		type: "*"
	}
};
var source_raster_dem = {
	type: {
		required: true,
		type: "enum",
		values: {
			"raster-dem": {
			}
		}
	},
	url: {
		type: "string"
	},
	tiles: {
		type: "array",
		value: "string"
	},
	bounds: {
		type: "array",
		value: "number",
		length: 4,
		"default": [
			-180,
			-85.051129,
			180,
			85.051129
		]
	},
	minzoom: {
		type: "number",
		"default": 0
	},
	maxzoom: {
		type: "number",
		"default": 22
	},
	tileSize: {
		type: "number",
		"default": 512,
		units: "pixels"
	},
	attribution: {
		type: "string"
	},
	encoding: {
		type: "enum",
		values: {
			terrarium: {
			},
			mapbox: {
			}
		},
		"default": "mapbox"
	},
	volatile: {
		type: "boolean",
		"default": false
	},
	"*": {
		type: "*"
	}
};
var source_geojson = {
	type: {
		required: true,
		type: "enum",
		values: {
			geojson: {
			}
		}
	},
	data: {
		type: "*"
	},
	maxzoom: {
		type: "number",
		"default": 18
	},
	attribution: {
		type: "string"
	},
	buffer: {
		type: "number",
		"default": 128,
		maximum: 512,
		minimum: 0
	},
	filter: {
		type: "*"
	},
	tolerance: {
		type: "number",
		"default": 0.375
	},
	cluster: {
		type: "boolean",
		"default": false
	},
	clusterRadius: {
		type: "number",
		"default": 50,
		minimum: 0
	},
	clusterMaxZoom: {
		type: "number"
	},
	clusterMinPoints: {
		type: "number"
	},
	clusterProperties: {
		type: "*"
	},
	lineMetrics: {
		type: "boolean",
		"default": false
	},
	generateId: {
		type: "boolean",
		"default": false
	},
	promoteId: {
		type: "promoteId"
	}
};
var source_video = {
	type: {
		required: true,
		type: "enum",
		values: {
			video: {
			}
		}
	},
	urls: {
		required: true,
		type: "array",
		value: "string"
	},
	coordinates: {
		required: true,
		type: "array",
		length: 4,
		value: {
			type: "array",
			length: 2,
			value: "number"
		}
	}
};
var source_image = {
	type: {
		required: true,
		type: "enum",
		values: {
			image: {
			}
		}
	},
	url: {
		required: true,
		type: "string"
	},
	coordinates: {
		required: true,
		type: "array",
		length: 4,
		value: {
			type: "array",
			length: 2,
			value: "number"
		}
	}
};
var layer = {
	id: {
		type: "string",
		required: true
	},
	type: {
		type: "enum",
		values: {
			fill: {
			},
			line: {
			},
			symbol: {
			},
			circle: {
			},
			heatmap: {
			},
			"fill-extrusion": {
			},
			raster: {
			},
			hillshade: {
			},
			background: {
			}
		},
		required: true
	},
	metadata: {
		type: "*"
	},
	source: {
		type: "string"
	},
	"source-layer": {
		type: "string"
	},
	minzoom: {
		type: "number",
		minimum: 0,
		maximum: 24
	},
	maxzoom: {
		type: "number",
		minimum: 0,
		maximum: 24
	},
	filter: {
		type: "filter"
	},
	layout: {
		type: "layout"
	},
	paint: {
		type: "paint"
	}
};
var layout = [
	"layout_fill",
	"layout_line",
	"layout_circle",
	"layout_heatmap",
	"layout_fill-extrusion",
	"layout_symbol",
	"layout_raster",
	"layout_hillshade",
	"layout_background"
];
var layout_background = {
	visibility: {
		type: "enum",
		values: {
			visible: {
			},
			none: {
			}
		},
		"default": "visible",
		"property-type": "constant"
	}
};
var layout_fill = {
	"fill-sort-key": {
		type: "number",
		expression: {
			interpolated: false,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	visibility: {
		type: "enum",
		values: {
			visible: {
			},
			none: {
			}
		},
		"default": "visible",
		"property-type": "constant"
	}
};
var layout_circle = {
	"circle-sort-key": {
		type: "number",
		expression: {
			interpolated: false,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	visibility: {
		type: "enum",
		values: {
			visible: {
			},
			none: {
			}
		},
		"default": "visible",
		"property-type": "constant"
	}
};
var layout_heatmap = {
	visibility: {
		type: "enum",
		values: {
			visible: {
			},
			none: {
			}
		},
		"default": "visible",
		"property-type": "constant"
	}
};
var layout_line = {
	"line-cap": {
		type: "enum",
		values: {
			butt: {
			},
			round: {
			},
			square: {
			}
		},
		"default": "butt",
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"line-join": {
		type: "enum",
		values: {
			bevel: {
			},
			round: {
			},
			miter: {
			}
		},
		"default": "miter",
		expression: {
			interpolated: false,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	"line-miter-limit": {
		type: "number",
		"default": 2,
		requires: [
			{
				"line-join": "miter"
			}
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"line-round-limit": {
		type: "number",
		"default": 1.05,
		requires: [
			{
				"line-join": "round"
			}
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"line-sort-key": {
		type: "number",
		expression: {
			interpolated: false,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	visibility: {
		type: "enum",
		values: {
			visible: {
			},
			none: {
			}
		},
		"default": "visible",
		"property-type": "constant"
	}
};
var layout_symbol = {
	"symbol-placement": {
		type: "enum",
		values: {
			point: {
			},
			line: {
			},
			"line-center": {
			}
		},
		"default": "point",
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"symbol-spacing": {
		type: "number",
		"default": 250,
		minimum: 1,
		units: "pixels",
		requires: [
			{
				"symbol-placement": "line"
			}
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"symbol-avoid-edges": {
		type: "boolean",
		"default": false,
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"symbol-sort-key": {
		type: "number",
		expression: {
			interpolated: false,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	"symbol-z-order": {
		type: "enum",
		values: {
			auto: {
			},
			"viewport-y": {
			},
			source: {
			}
		},
		"default": "auto",
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"icon-allow-overlap": {
		type: "boolean",
		"default": false,
		requires: [
			"icon-image"
		],
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"icon-ignore-placement": {
		type: "boolean",
		"default": false,
		requires: [
			"icon-image"
		],
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"icon-optional": {
		type: "boolean",
		"default": false,
		requires: [
			"icon-image",
			"text-field"
		],
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"icon-rotation-alignment": {
		type: "enum",
		values: {
			map: {
			},
			viewport: {
			},
			auto: {
			}
		},
		"default": "auto",
		requires: [
			"icon-image"
		],
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"icon-size": {
		type: "number",
		"default": 1,
		minimum: 0,
		units: "factor of the original icon size",
		requires: [
			"icon-image"
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	"icon-text-fit": {
		type: "enum",
		values: {
			none: {
			},
			width: {
			},
			height: {
			},
			both: {
			}
		},
		"default": "none",
		requires: [
			"icon-image",
			"text-field"
		],
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"icon-text-fit-padding": {
		type: "array",
		value: "number",
		length: 4,
		"default": [
			0,
			0,
			0,
			0
		],
		units: "pixels",
		requires: [
			"icon-image",
			"text-field",
			{
				"icon-text-fit": [
					"both",
					"width",
					"height"
				]
			}
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"icon-image": {
		type: "resolvedImage",
		tokens: true,
		expression: {
			interpolated: false,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	"icon-rotate": {
		type: "number",
		"default": 0,
		period: 360,
		units: "degrees",
		requires: [
			"icon-image"
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	"icon-padding": {
		type: "number",
		"default": 2,
		minimum: 0,
		units: "pixels",
		requires: [
			"icon-image"
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"icon-keep-upright": {
		type: "boolean",
		"default": false,
		requires: [
			"icon-image",
			{
				"icon-rotation-alignment": "map"
			},
			{
				"symbol-placement": [
					"line",
					"line-center"
				]
			}
		],
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"icon-offset": {
		type: "array",
		value: "number",
		length: 2,
		"default": [
			0,
			0
		],
		requires: [
			"icon-image"
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	"icon-anchor": {
		type: "enum",
		values: {
			center: {
			},
			left: {
			},
			right: {
			},
			top: {
			},
			bottom: {
			},
			"top-left": {
			},
			"top-right": {
			},
			"bottom-left": {
			},
			"bottom-right": {
			}
		},
		"default": "center",
		requires: [
			"icon-image"
		],
		expression: {
			interpolated: false,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	"icon-pitch-alignment": {
		type: "enum",
		values: {
			map: {
			},
			viewport: {
			},
			auto: {
			}
		},
		"default": "auto",
		requires: [
			"icon-image"
		],
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"text-pitch-alignment": {
		type: "enum",
		values: {
			map: {
			},
			viewport: {
			},
			auto: {
			}
		},
		"default": "auto",
		requires: [
			"text-field"
		],
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"text-rotation-alignment": {
		type: "enum",
		values: {
			map: {
			},
			viewport: {
			},
			auto: {
			}
		},
		"default": "auto",
		requires: [
			"text-field"
		],
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"text-field": {
		type: "formatted",
		"default": "",
		tokens: true,
		expression: {
			interpolated: false,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	"text-font": {
		type: "array",
		value: "string",
		"default": [
			"Open Sans Regular",
			"Arial Unicode MS Regular"
		],
		requires: [
			"text-field"
		],
		expression: {
			interpolated: false,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	"text-size": {
		type: "number",
		"default": 16,
		minimum: 0,
		units: "pixels",
		requires: [
			"text-field"
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	"text-max-width": {
		type: "number",
		"default": 10,
		minimum: 0,
		units: "ems",
		requires: [
			"text-field"
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	"text-line-height": {
		type: "number",
		"default": 1.2,
		units: "ems",
		requires: [
			"text-field"
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"text-letter-spacing": {
		type: "number",
		"default": 0,
		units: "ems",
		requires: [
			"text-field"
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	"text-justify": {
		type: "enum",
		values: {
			auto: {
			},
			left: {
			},
			center: {
			},
			right: {
			}
		},
		"default": "center",
		requires: [
			"text-field"
		],
		expression: {
			interpolated: false,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	"text-radial-offset": {
		type: "number",
		units: "ems",
		"default": 0,
		requires: [
			"text-field"
		],
		"property-type": "data-driven",
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature"
			]
		}
	},
	"text-variable-anchor": {
		type: "array",
		value: "enum",
		values: {
			center: {
			},
			left: {
			},
			right: {
			},
			top: {
			},
			bottom: {
			},
			"top-left": {
			},
			"top-right": {
			},
			"bottom-left": {
			},
			"bottom-right": {
			}
		},
		requires: [
			"text-field",
			{
				"symbol-placement": [
					"point"
				]
			}
		],
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"text-anchor": {
		type: "enum",
		values: {
			center: {
			},
			left: {
			},
			right: {
			},
			top: {
			},
			bottom: {
			},
			"top-left": {
			},
			"top-right": {
			},
			"bottom-left": {
			},
			"bottom-right": {
			}
		},
		"default": "center",
		requires: [
			"text-field",
			{
				"!": "text-variable-anchor"
			}
		],
		expression: {
			interpolated: false,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	"text-max-angle": {
		type: "number",
		"default": 45,
		units: "degrees",
		requires: [
			"text-field",
			{
				"symbol-placement": [
					"line",
					"line-center"
				]
			}
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"text-writing-mode": {
		type: "array",
		value: "enum",
		values: {
			horizontal: {
			},
			vertical: {
			}
		},
		requires: [
			"text-field",
			{
				"symbol-placement": [
					"point"
				]
			}
		],
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"text-rotate": {
		type: "number",
		"default": 0,
		period: 360,
		units: "degrees",
		requires: [
			"text-field"
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	"text-padding": {
		type: "number",
		"default": 2,
		minimum: 0,
		units: "pixels",
		requires: [
			"text-field"
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"text-keep-upright": {
		type: "boolean",
		"default": true,
		requires: [
			"text-field",
			{
				"text-rotation-alignment": "map"
			},
			{
				"symbol-placement": [
					"line",
					"line-center"
				]
			}
		],
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"text-transform": {
		type: "enum",
		values: {
			none: {
			},
			uppercase: {
			},
			lowercase: {
			}
		},
		"default": "none",
		requires: [
			"text-field"
		],
		expression: {
			interpolated: false,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	"text-offset": {
		type: "array",
		value: "number",
		units: "ems",
		length: 2,
		"default": [
			0,
			0
		],
		requires: [
			"text-field",
			{
				"!": "text-radial-offset"
			}
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	"text-allow-overlap": {
		type: "boolean",
		"default": false,
		requires: [
			"text-field"
		],
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"text-ignore-placement": {
		type: "boolean",
		"default": false,
		requires: [
			"text-field"
		],
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"text-optional": {
		type: "boolean",
		"default": false,
		requires: [
			"text-field",
			"icon-image"
		],
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	visibility: {
		type: "enum",
		values: {
			visible: {
			},
			none: {
			}
		},
		"default": "visible",
		"property-type": "constant"
	}
};
var layout_raster = {
	visibility: {
		type: "enum",
		values: {
			visible: {
			},
			none: {
			}
		},
		"default": "visible",
		"property-type": "constant"
	}
};
var layout_hillshade = {
	visibility: {
		type: "enum",
		values: {
			visible: {
			},
			none: {
			}
		},
		"default": "visible",
		"property-type": "constant"
	}
};
var filter = {
	type: "array",
	value: "*"
};
var filter_operator = {
	type: "enum",
	values: {
		"==": {
		},
		"!=": {
		},
		">": {
		},
		">=": {
		},
		"<": {
		},
		"<=": {
		},
		"in": {
		},
		"!in": {
		},
		all: {
		},
		any: {
		},
		none: {
		},
		has: {
		},
		"!has": {
		},
		within: {
		}
	}
};
var geometry_type = {
	type: "enum",
	values: {
		Point: {
		},
		LineString: {
		},
		Polygon: {
		}
	}
};
var function_stop = {
	type: "array",
	minimum: 0,
	maximum: 24,
	value: [
		"number",
		"color"
	],
	length: 2
};
var expression = {
	type: "array",
	value: "*",
	minimum: 1
};
var light = {
	anchor: {
		type: "enum",
		"default": "viewport",
		values: {
			map: {
			},
			viewport: {
			}
		},
		"property-type": "data-constant",
		transition: false,
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		}
	},
	position: {
		type: "array",
		"default": [
			1.15,
			210,
			30
		],
		length: 3,
		value: "number",
		"property-type": "data-constant",
		transition: true,
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		}
	},
	color: {
		type: "color",
		"property-type": "data-constant",
		"default": "#ffffff",
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		transition: true
	},
	intensity: {
		type: "number",
		"property-type": "data-constant",
		"default": 0.5,
		minimum: 0,
		maximum: 1,
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		transition: true
	}
};
var paint = [
	"paint_fill",
	"paint_line",
	"paint_circle",
	"paint_heatmap",
	"paint_fill-extrusion",
	"paint_symbol",
	"paint_raster",
	"paint_hillshade",
	"paint_background"
];
var paint_fill = {
	"fill-antialias": {
		type: "boolean",
		"default": true,
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"fill-opacity": {
		type: "number",
		"default": 1,
		minimum: 0,
		maximum: 1,
		transition: true,
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"fill-color": {
		type: "color",
		"default": "#000000",
		transition: true,
		requires: [
			{
				"!": "fill-pattern"
			}
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"fill-outline-color": {
		type: "color",
		transition: true,
		requires: [
			{
				"!": "fill-pattern"
			},
			{
				"fill-antialias": true
			}
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"fill-translate": {
		type: "array",
		value: "number",
		length: 2,
		"default": [
			0,
			0
		],
		transition: true,
		units: "pixels",
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"fill-translate-anchor": {
		type: "enum",
		values: {
			map: {
			},
			viewport: {
			}
		},
		"default": "map",
		requires: [
			"fill-translate"
		],
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"fill-pattern": {
		type: "resolvedImage",
		transition: true,
		expression: {
			interpolated: false,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "cross-faded-data-driven"
	}
};
var paint_line = {
	"line-opacity": {
		type: "number",
		"default": 1,
		minimum: 0,
		maximum: 1,
		transition: true,
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"line-color": {
		type: "color",
		"default": "#000000",
		transition: true,
		requires: [
			{
				"!": "line-pattern"
			}
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"line-translate": {
		type: "array",
		value: "number",
		length: 2,
		"default": [
			0,
			0
		],
		transition: true,
		units: "pixels",
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"line-translate-anchor": {
		type: "enum",
		values: {
			map: {
			},
			viewport: {
			}
		},
		"default": "map",
		requires: [
			"line-translate"
		],
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"line-width": {
		type: "number",
		"default": 1,
		minimum: 0,
		transition: true,
		units: "pixels",
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"line-gap-width": {
		type: "number",
		"default": 0,
		minimum: 0,
		transition: true,
		units: "pixels",
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"line-offset": {
		type: "number",
		"default": 0,
		transition: true,
		units: "pixels",
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"line-blur": {
		type: "number",
		"default": 0,
		minimum: 0,
		transition: true,
		units: "pixels",
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"line-dasharray": {
		type: "array",
		value: "number",
		minimum: 0,
		transition: true,
		units: "line widths",
		requires: [
			{
				"!": "line-pattern"
			}
		],
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "cross-faded"
	},
	"line-pattern": {
		type: "resolvedImage",
		transition: true,
		expression: {
			interpolated: false,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "cross-faded-data-driven"
	},
	"line-gradient": {
		type: "color",
		transition: false,
		requires: [
			{
				"!": "line-dasharray"
			},
			{
				"!": "line-pattern"
			},
			{
				source: "geojson",
				has: {
					lineMetrics: true
				}
			}
		],
		expression: {
			interpolated: true,
			parameters: [
				"line-progress"
			]
		},
		"property-type": "color-ramp"
	}
};
var paint_circle = {
	"circle-radius": {
		type: "number",
		"default": 5,
		minimum: 0,
		transition: true,
		units: "pixels",
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"circle-color": {
		type: "color",
		"default": "#000000",
		transition: true,
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"circle-blur": {
		type: "number",
		"default": 0,
		transition: true,
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"circle-opacity": {
		type: "number",
		"default": 1,
		minimum: 0,
		maximum: 1,
		transition: true,
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"circle-translate": {
		type: "array",
		value: "number",
		length: 2,
		"default": [
			0,
			0
		],
		transition: true,
		units: "pixels",
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"circle-translate-anchor": {
		type: "enum",
		values: {
			map: {
			},
			viewport: {
			}
		},
		"default": "map",
		requires: [
			"circle-translate"
		],
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"circle-pitch-scale": {
		type: "enum",
		values: {
			map: {
			},
			viewport: {
			}
		},
		"default": "map",
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"circle-pitch-alignment": {
		type: "enum",
		values: {
			map: {
			},
			viewport: {
			}
		},
		"default": "viewport",
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"circle-stroke-width": {
		type: "number",
		"default": 0,
		minimum: 0,
		transition: true,
		units: "pixels",
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"circle-stroke-color": {
		type: "color",
		"default": "#000000",
		transition: true,
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"circle-stroke-opacity": {
		type: "number",
		"default": 1,
		minimum: 0,
		maximum: 1,
		transition: true,
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	}
};
var paint_heatmap = {
	"heatmap-radius": {
		type: "number",
		"default": 30,
		minimum: 1,
		transition: true,
		units: "pixels",
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"heatmap-weight": {
		type: "number",
		"default": 1,
		minimum: 0,
		transition: false,
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"heatmap-intensity": {
		type: "number",
		"default": 1,
		minimum: 0,
		transition: true,
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"heatmap-color": {
		type: "color",
		"default": [
			"interpolate",
			[
				"linear"
			],
			[
				"heatmap-density"
			],
			0,
			"rgba(0, 0, 255, 0)",
			0.1,
			"royalblue",
			0.3,
			"cyan",
			0.5,
			"lime",
			0.7,
			"yellow",
			1,
			"red"
		],
		transition: false,
		expression: {
			interpolated: true,
			parameters: [
				"heatmap-density"
			]
		},
		"property-type": "color-ramp"
	},
	"heatmap-opacity": {
		type: "number",
		"default": 1,
		minimum: 0,
		maximum: 1,
		transition: true,
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	}
};
var paint_symbol = {
	"icon-opacity": {
		type: "number",
		"default": 1,
		minimum: 0,
		maximum: 1,
		transition: true,
		requires: [
			"icon-image"
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"icon-color": {
		type: "color",
		"default": "#000000",
		transition: true,
		requires: [
			"icon-image"
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"icon-halo-color": {
		type: "color",
		"default": "rgba(0, 0, 0, 0)",
		transition: true,
		requires: [
			"icon-image"
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"icon-halo-width": {
		type: "number",
		"default": 0,
		minimum: 0,
		transition: true,
		units: "pixels",
		requires: [
			"icon-image"
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"icon-halo-blur": {
		type: "number",
		"default": 0,
		minimum: 0,
		transition: true,
		units: "pixels",
		requires: [
			"icon-image"
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"icon-translate": {
		type: "array",
		value: "number",
		length: 2,
		"default": [
			0,
			0
		],
		transition: true,
		units: "pixels",
		requires: [
			"icon-image"
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"icon-translate-anchor": {
		type: "enum",
		values: {
			map: {
			},
			viewport: {
			}
		},
		"default": "map",
		requires: [
			"icon-image",
			"icon-translate"
		],
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"text-opacity": {
		type: "number",
		"default": 1,
		minimum: 0,
		maximum: 1,
		transition: true,
		requires: [
			"text-field"
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"text-color": {
		type: "color",
		"default": "#000000",
		transition: true,
		overridable: true,
		requires: [
			"text-field"
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"text-halo-color": {
		type: "color",
		"default": "rgba(0, 0, 0, 0)",
		transition: true,
		requires: [
			"text-field"
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"text-halo-width": {
		type: "number",
		"default": 0,
		minimum: 0,
		transition: true,
		units: "pixels",
		requires: [
			"text-field"
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"text-halo-blur": {
		type: "number",
		"default": 0,
		minimum: 0,
		transition: true,
		units: "pixels",
		requires: [
			"text-field"
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"text-translate": {
		type: "array",
		value: "number",
		length: 2,
		"default": [
			0,
			0
		],
		transition: true,
		units: "pixels",
		requires: [
			"text-field"
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"text-translate-anchor": {
		type: "enum",
		values: {
			map: {
			},
			viewport: {
			}
		},
		"default": "map",
		requires: [
			"text-field",
			"text-translate"
		],
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	}
};
var paint_raster = {
	"raster-opacity": {
		type: "number",
		"default": 1,
		minimum: 0,
		maximum: 1,
		transition: true,
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"raster-hue-rotate": {
		type: "number",
		"default": 0,
		period: 360,
		transition: true,
		units: "degrees",
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"raster-brightness-min": {
		type: "number",
		"default": 0,
		minimum: 0,
		maximum: 1,
		transition: true,
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"raster-brightness-max": {
		type: "number",
		"default": 1,
		minimum: 0,
		maximum: 1,
		transition: true,
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"raster-saturation": {
		type: "number",
		"default": 0,
		minimum: -1,
		maximum: 1,
		transition: true,
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"raster-contrast": {
		type: "number",
		"default": 0,
		minimum: -1,
		maximum: 1,
		transition: true,
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"raster-resampling": {
		type: "enum",
		values: {
			linear: {
			},
			nearest: {
			}
		},
		"default": "linear",
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"raster-fade-duration": {
		type: "number",
		"default": 300,
		minimum: 0,
		transition: false,
		units: "milliseconds",
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	}
};
var paint_hillshade = {
	"hillshade-illumination-direction": {
		type: "number",
		"default": 335,
		minimum: 0,
		maximum: 359,
		transition: false,
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"hillshade-illumination-anchor": {
		type: "enum",
		values: {
			map: {
			},
			viewport: {
			}
		},
		"default": "viewport",
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"hillshade-exaggeration": {
		type: "number",
		"default": 0.5,
		minimum: 0,
		maximum: 1,
		transition: true,
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"hillshade-shadow-color": {
		type: "color",
		"default": "#000000",
		transition: true,
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"hillshade-highlight-color": {
		type: "color",
		"default": "#FFFFFF",
		transition: true,
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"hillshade-accent-color": {
		type: "color",
		"default": "#000000",
		transition: true,
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	}
};
var paint_background = {
	"background-color": {
		type: "color",
		"default": "#000000",
		transition: true,
		requires: [
			{
				"!": "background-pattern"
			}
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"background-pattern": {
		type: "resolvedImage",
		transition: true,
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "cross-faded"
	},
	"background-opacity": {
		type: "number",
		"default": 1,
		minimum: 0,
		maximum: 1,
		transition: true,
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	}
};
var transition = {
	duration: {
		type: "number",
		"default": 300,
		minimum: 0,
		units: "milliseconds"
	},
	delay: {
		type: "number",
		"default": 0,
		minimum: 0,
		units: "milliseconds"
	}
};
var promoteId = {
	"*": {
		type: "string"
	}
};
var spec = {
	$version: $version,
	$root: $root,
	sources: sources,
	source: source,
	source_vector: source_vector,
	source_raster: source_raster,
	source_raster_dem: source_raster_dem,
	source_geojson: source_geojson,
	source_video: source_video,
	source_image: source_image,
	layer: layer,
	layout: layout,
	layout_background: layout_background,
	layout_fill: layout_fill,
	layout_circle: layout_circle,
	layout_heatmap: layout_heatmap,
	"layout_fill-extrusion": {
	visibility: {
		type: "enum",
		values: {
			visible: {
			},
			none: {
			}
		},
		"default": "visible",
		"property-type": "constant"
	}
},
	layout_line: layout_line,
	layout_symbol: layout_symbol,
	layout_raster: layout_raster,
	layout_hillshade: layout_hillshade,
	filter: filter,
	filter_operator: filter_operator,
	geometry_type: geometry_type,
	"function": {
	expression: {
		type: "expression"
	},
	stops: {
		type: "array",
		value: "function_stop"
	},
	base: {
		type: "number",
		"default": 1,
		minimum: 0
	},
	property: {
		type: "string",
		"default": "$zoom"
	},
	type: {
		type: "enum",
		values: {
			identity: {
			},
			exponential: {
			},
			interval: {
			},
			categorical: {
			}
		},
		"default": "exponential"
	},
	colorSpace: {
		type: "enum",
		values: {
			rgb: {
			},
			lab: {
			},
			hcl: {
			}
		},
		"default": "rgb"
	},
	"default": {
		type: "*",
		required: false
	}
},
	function_stop: function_stop,
	expression: expression,
	light: light,
	paint: paint,
	paint_fill: paint_fill,
	"paint_fill-extrusion": {
	"fill-extrusion-opacity": {
		type: "number",
		"default": 1,
		minimum: 0,
		maximum: 1,
		transition: true,
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"fill-extrusion-color": {
		type: "color",
		"default": "#000000",
		transition: true,
		requires: [
			{
				"!": "fill-extrusion-pattern"
			}
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"fill-extrusion-translate": {
		type: "array",
		value: "number",
		length: 2,
		"default": [
			0,
			0
		],
		transition: true,
		units: "pixels",
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"fill-extrusion-translate-anchor": {
		type: "enum",
		values: {
			map: {
			},
			viewport: {
			}
		},
		"default": "map",
		requires: [
			"fill-extrusion-translate"
		],
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"fill-extrusion-pattern": {
		type: "resolvedImage",
		transition: true,
		expression: {
			interpolated: false,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "cross-faded-data-driven"
	},
	"fill-extrusion-height": {
		type: "number",
		"default": 0,
		minimum: 0,
		units: "meters",
		transition: true,
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"fill-extrusion-base": {
		type: "number",
		"default": 0,
		minimum: 0,
		units: "meters",
		transition: true,
		requires: [
			"fill-extrusion-height"
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"fill-extrusion-vertical-gradient": {
		type: "boolean",
		"default": true,
		transition: false,
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	}
},
	paint_line: paint_line,
	paint_circle: paint_circle,
	paint_heatmap: paint_heatmap,
	paint_symbol: paint_symbol,
	paint_raster: paint_raster,
	paint_hillshade: paint_hillshade,
	paint_background: paint_background,
	transition: transition,
	"property-type": {
	"data-driven": {
		type: "property-type"
	},
	"cross-faded": {
		type: "property-type"
	},
	"cross-faded-data-driven": {
		type: "property-type"
	},
	"color-ramp": {
		type: "property-type"
	},
	"data-constant": {
		type: "property-type"
	},
	constant: {
		type: "property-type"
	}
},
	promoteId: promoteId
};

var ValidationError = function ValidationError(key, value, message, identifier) {
    this.message = (key ? key + ': ' : '') + message;
    if (identifier) {
        this.identifier = identifier;
    }
    if (value !== null && value !== undefined && value.__line__) {
        this.line = value.__line__;
    }
};

function validateConstants(options) {
    var key = options.key;
    var constants = options.value;
    if (constants) {
        return [new ValidationError(key, constants, 'constants have been deprecated as of v8')];
    } else {
        return [];
    }
}

function extend$1 (output) {
    var inputs = [], len = arguments.length - 1;
    while (len-- > 0)
        inputs[len] = arguments[len + 1];
    for (var i = 0, list = inputs; i < list.length; i += 1) {
        var input = list[i];
        for (var k in input) {
            output[k] = input[k];
        }
    }
    return output;
}

function unbundle(value) {
    if (value instanceof Number || value instanceof String || value instanceof Boolean) {
        return value.valueOf();
    } else {
        return value;
    }
}
function deepUnbundle(value) {
    if (Array.isArray(value)) {
        return value.map(deepUnbundle);
    } else if (value instanceof Object && !(value instanceof Number || value instanceof String || value instanceof Boolean)) {
        var unbundledValue = {};
        for (var key in value) {
            unbundledValue[key] = deepUnbundle(value[key]);
        }
        return unbundledValue;
    }
    return unbundle(value);
}

var ParsingError = function (Error) {
    function ParsingError(key, message) {
        Error.call(this, message);
        this.message = message;
        this.key = key;
    }
    if (Error)
        ParsingError.__proto__ = Error;
    ParsingError.prototype = Object.create(Error && Error.prototype);
    ParsingError.prototype.constructor = ParsingError;
    return ParsingError;
}(Error);

var Scope = function Scope(parent, bindings) {
    if (bindings === void 0)
        bindings = [];
    this.parent = parent;
    this.bindings = {};
    for (var i = 0, list = bindings; i < list.length; i += 1) {
        var ref = list[i];
        var name = ref[0];
        var expression = ref[1];
        this.bindings[name] = expression;
    }
};
Scope.prototype.concat = function concat(bindings) {
    return new Scope(this, bindings);
};
Scope.prototype.get = function get(name) {
    if (this.bindings[name]) {
        return this.bindings[name];
    }
    if (this.parent) {
        return this.parent.get(name);
    }
    throw new Error(name + ' not found in scope.');
};
Scope.prototype.has = function has(name) {
    if (this.bindings[name]) {
        return true;
    }
    return this.parent ? this.parent.has(name) : false;
};

var NullType = { kind: 'null' };
var NumberType = { kind: 'number' };
var StringType = { kind: 'string' };
var BooleanType = { kind: 'boolean' };
var ColorType = { kind: 'color' };
var ObjectType = { kind: 'object' };
var ValueType = { kind: 'value' };
var ErrorType = { kind: 'error' };
var CollatorType = { kind: 'collator' };
var FormattedType = { kind: 'formatted' };
var ResolvedImageType = { kind: 'resolvedImage' };
function array(itemType, N) {
    return {
        kind: 'array',
        itemType: itemType,
        N: N
    };
}
function toString(type) {
    if (type.kind === 'array') {
        var itemType = toString(type.itemType);
        return typeof type.N === 'number' ? 'array<' + itemType + ', ' + type.N + '>' : type.itemType.kind === 'value' ? 'array' : 'array<' + itemType + '>';
    } else {
        return type.kind;
    }
}
var valueMemberTypes = [
    NullType,
    NumberType,
    StringType,
    BooleanType,
    ColorType,
    FormattedType,
    ObjectType,
    array(ValueType),
    ResolvedImageType
];
function checkSubtype(expected, t) {
    if (t.kind === 'error') {
        return null;
    } else if (expected.kind === 'array') {
        if (t.kind === 'array' && (t.N === 0 && t.itemType.kind === 'value' || !checkSubtype(expected.itemType, t.itemType)) && (typeof expected.N !== 'number' || expected.N === t.N)) {
            return null;
        }
    } else if (expected.kind === t.kind) {
        return null;
    } else if (expected.kind === 'value') {
        for (var i = 0, list = valueMemberTypes; i < list.length; i += 1) {
            var memberType = list[i];
            if (!checkSubtype(memberType, t)) {
                return null;
            }
        }
    }
    return 'Expected ' + toString(expected) + ' but found ' + toString(t) + ' instead.';
}
function isValidType(provided, allowedTypes) {
    return allowedTypes.some(function (t) {
        return t.kind === provided.kind;
    });
}
function isValidNativeType(provided, allowedTypes) {
    return allowedTypes.some(function (t) {
        if (t === 'null') {
            return provided === null;
        } else if (t === 'array') {
            return Array.isArray(provided);
        } else if (t === 'object') {
            return provided && !Array.isArray(provided) && typeof provided === 'object';
        } else {
            return t === typeof provided;
        }
    });
}

var csscolorparser = createCommonjsModule(function (module, exports) {
var kCSSColorTable = {
    'transparent': [
        0,
        0,
        0,
        0
    ],
    'aliceblue': [
        240,
        248,
        255,
        1
    ],
    'antiquewhite': [
        250,
        235,
        215,
        1
    ],
    'aqua': [
        0,
        255,
        255,
        1
    ],
    'aquamarine': [
        127,
        255,
        212,
        1
    ],
    'azure': [
        240,
        255,
        255,
        1
    ],
    'beige': [
        245,
        245,
        220,
        1
    ],
    'bisque': [
        255,
        228,
        196,
        1
    ],
    'black': [
        0,
        0,
        0,
        1
    ],
    'blanchedalmond': [
        255,
        235,
        205,
        1
    ],
    'blue': [
        0,
        0,
        255,
        1
    ],
    'blueviolet': [
        138,
        43,
        226,
        1
    ],
    'brown': [
        165,
        42,
        42,
        1
    ],
    'burlywood': [
        222,
        184,
        135,
        1
    ],
    'cadetblue': [
        95,
        158,
        160,
        1
    ],
    'chartreuse': [
        127,
        255,
        0,
        1
    ],
    'chocolate': [
        210,
        105,
        30,
        1
    ],
    'coral': [
        255,
        127,
        80,
        1
    ],
    'cornflowerblue': [
        100,
        149,
        237,
        1
    ],
    'cornsilk': [
        255,
        248,
        220,
        1
    ],
    'crimson': [
        220,
        20,
        60,
        1
    ],
    'cyan': [
        0,
        255,
        255,
        1
    ],
    'darkblue': [
        0,
        0,
        139,
        1
    ],
    'darkcyan': [
        0,
        139,
        139,
        1
    ],
    'darkgoldenrod': [
        184,
        134,
        11,
        1
    ],
    'darkgray': [
        169,
        169,
        169,
        1
    ],
    'darkgreen': [
        0,
        100,
        0,
        1
    ],
    'darkgrey': [
        169,
        169,
        169,
        1
    ],
    'darkkhaki': [
        189,
        183,
        107,
        1
    ],
    'darkmagenta': [
        139,
        0,
        139,
        1
    ],
    'darkolivegreen': [
        85,
        107,
        47,
        1
    ],
    'darkorange': [
        255,
        140,
        0,
        1
    ],
    'darkorchid': [
        153,
        50,
        204,
        1
    ],
    'darkred': [
        139,
        0,
        0,
        1
    ],
    'darksalmon': [
        233,
        150,
        122,
        1
    ],
    'darkseagreen': [
        143,
        188,
        143,
        1
    ],
    'darkslateblue': [
        72,
        61,
        139,
        1
    ],
    'darkslategray': [
        47,
        79,
        79,
        1
    ],
    'darkslategrey': [
        47,
        79,
        79,
        1
    ],
    'darkturquoise': [
        0,
        206,
        209,
        1
    ],
    'darkviolet': [
        148,
        0,
        211,
        1
    ],
    'deeppink': [
        255,
        20,
        147,
        1
    ],
    'deepskyblue': [
        0,
        191,
        255,
        1
    ],
    'dimgray': [
        105,
        105,
        105,
        1
    ],
    'dimgrey': [
        105,
        105,
        105,
        1
    ],
    'dodgerblue': [
        30,
        144,
        255,
        1
    ],
    'firebrick': [
        178,
        34,
        34,
        1
    ],
    'floralwhite': [
        255,
        250,
        240,
        1
    ],
    'forestgreen': [
        34,
        139,
        34,
        1
    ],
    'fuchsia': [
        255,
        0,
        255,
        1
    ],
    'gainsboro': [
        220,
        220,
        220,
        1
    ],
    'ghostwhite': [
        248,
        248,
        255,
        1
    ],
    'gold': [
        255,
        215,
        0,
        1
    ],
    'goldenrod': [
        218,
        165,
        32,
        1
    ],
    'gray': [
        128,
        128,
        128,
        1
    ],
    'green': [
        0,
        128,
        0,
        1
    ],
    'greenyellow': [
        173,
        255,
        47,
        1
    ],
    'grey': [
        128,
        128,
        128,
        1
    ],
    'honeydew': [
        240,
        255,
        240,
        1
    ],
    'hotpink': [
        255,
        105,
        180,
        1
    ],
    'indianred': [
        205,
        92,
        92,
        1
    ],
    'indigo': [
        75,
        0,
        130,
        1
    ],
    'ivory': [
        255,
        255,
        240,
        1
    ],
    'khaki': [
        240,
        230,
        140,
        1
    ],
    'lavender': [
        230,
        230,
        250,
        1
    ],
    'lavenderblush': [
        255,
        240,
        245,
        1
    ],
    'lawngreen': [
        124,
        252,
        0,
        1
    ],
    'lemonchiffon': [
        255,
        250,
        205,
        1
    ],
    'lightblue': [
        173,
        216,
        230,
        1
    ],
    'lightcoral': [
        240,
        128,
        128,
        1
    ],
    'lightcyan': [
        224,
        255,
        255,
        1
    ],
    'lightgoldenrodyellow': [
        250,
        250,
        210,
        1
    ],
    'lightgray': [
        211,
        211,
        211,
        1
    ],
    'lightgreen': [
        144,
        238,
        144,
        1
    ],
    'lightgrey': [
        211,
        211,
        211,
        1
    ],
    'lightpink': [
        255,
        182,
        193,
        1
    ],
    'lightsalmon': [
        255,
        160,
        122,
        1
    ],
    'lightseagreen': [
        32,
        178,
        170,
        1
    ],
    'lightskyblue': [
        135,
        206,
        250,
        1
    ],
    'lightslategray': [
        119,
        136,
        153,
        1
    ],
    'lightslategrey': [
        119,
        136,
        153,
        1
    ],
    'lightsteelblue': [
        176,
        196,
        222,
        1
    ],
    'lightyellow': [
        255,
        255,
        224,
        1
    ],
    'lime': [
        0,
        255,
        0,
        1
    ],
    'limegreen': [
        50,
        205,
        50,
        1
    ],
    'linen': [
        250,
        240,
        230,
        1
    ],
    'magenta': [
        255,
        0,
        255,
        1
    ],
    'maroon': [
        128,
        0,
        0,
        1
    ],
    'mediumaquamarine': [
        102,
        205,
        170,
        1
    ],
    'mediumblue': [
        0,
        0,
        205,
        1
    ],
    'mediumorchid': [
        186,
        85,
        211,
        1
    ],
    'mediumpurple': [
        147,
        112,
        219,
        1
    ],
    'mediumseagreen': [
        60,
        179,
        113,
        1
    ],
    'mediumslateblue': [
        123,
        104,
        238,
        1
    ],
    'mediumspringgreen': [
        0,
        250,
        154,
        1
    ],
    'mediumturquoise': [
        72,
        209,
        204,
        1
    ],
    'mediumvioletred': [
        199,
        21,
        133,
        1
    ],
    'midnightblue': [
        25,
        25,
        112,
        1
    ],
    'mintcream': [
        245,
        255,
        250,
        1
    ],
    'mistyrose': [
        255,
        228,
        225,
        1
    ],
    'moccasin': [
        255,
        228,
        181,
        1
    ],
    'navajowhite': [
        255,
        222,
        173,
        1
    ],
    'navy': [
        0,
        0,
        128,
        1
    ],
    'oldlace': [
        253,
        245,
        230,
        1
    ],
    'olive': [
        128,
        128,
        0,
        1
    ],
    'olivedrab': [
        107,
        142,
        35,
        1
    ],
    'orange': [
        255,
        165,
        0,
        1
    ],
    'orangered': [
        255,
        69,
        0,
        1
    ],
    'orchid': [
        218,
        112,
        214,
        1
    ],
    'palegoldenrod': [
        238,
        232,
        170,
        1
    ],
    'palegreen': [
        152,
        251,
        152,
        1
    ],
    'paleturquoise': [
        175,
        238,
        238,
        1
    ],
    'palevioletred': [
        219,
        112,
        147,
        1
    ],
    'papayawhip': [
        255,
        239,
        213,
        1
    ],
    'peachpuff': [
        255,
        218,
        185,
        1
    ],
    'peru': [
        205,
        133,
        63,
        1
    ],
    'pink': [
        255,
        192,
        203,
        1
    ],
    'plum': [
        221,
        160,
        221,
        1
    ],
    'powderblue': [
        176,
        224,
        230,
        1
    ],
    'purple': [
        128,
        0,
        128,
        1
    ],
    'rebeccapurple': [
        102,
        51,
        153,
        1
    ],
    'red': [
        255,
        0,
        0,
        1
    ],
    'rosybrown': [
        188,
        143,
        143,
        1
    ],
    'royalblue': [
        65,
        105,
        225,
        1
    ],
    'saddlebrown': [
        139,
        69,
        19,
        1
    ],
    'salmon': [
        250,
        128,
        114,
        1
    ],
    'sandybrown': [
        244,
        164,
        96,
        1
    ],
    'seagreen': [
        46,
        139,
        87,
        1
    ],
    'seashell': [
        255,
        245,
        238,
        1
    ],
    'sienna': [
        160,
        82,
        45,
        1
    ],
    'silver': [
        192,
        192,
        192,
        1
    ],
    'skyblue': [
        135,
        206,
        235,
        1
    ],
    'slateblue': [
        106,
        90,
        205,
        1
    ],
    'slategray': [
        112,
        128,
        144,
        1
    ],
    'slategrey': [
        112,
        128,
        144,
        1
    ],
    'snow': [
        255,
        250,
        250,
        1
    ],
    'springgreen': [
        0,
        255,
        127,
        1
    ],
    'steelblue': [
        70,
        130,
        180,
        1
    ],
    'tan': [
        210,
        180,
        140,
        1
    ],
    'teal': [
        0,
        128,
        128,
        1
    ],
    'thistle': [
        216,
        191,
        216,
        1
    ],
    'tomato': [
        255,
        99,
        71,
        1
    ],
    'turquoise': [
        64,
        224,
        208,
        1
    ],
    'violet': [
        238,
        130,
        238,
        1
    ],
    'wheat': [
        245,
        222,
        179,
        1
    ],
    'white': [
        255,
        255,
        255,
        1
    ],
    'whitesmoke': [
        245,
        245,
        245,
        1
    ],
    'yellow': [
        255,
        255,
        0,
        1
    ],
    'yellowgreen': [
        154,
        205,
        50,
        1
    ]
};
function clamp_css_byte(i) {
    i = Math.round(i);
    return i < 0 ? 0 : i > 255 ? 255 : i;
}
function clamp_css_float(f) {
    return f < 0 ? 0 : f > 1 ? 1 : f;
}
function parse_css_int(str) {
    if (str[str.length - 1] === '%') {
        return clamp_css_byte(parseFloat(str) / 100 * 255);
    }
    return clamp_css_byte(parseInt(str));
}
function parse_css_float(str) {
    if (str[str.length - 1] === '%') {
        return clamp_css_float(parseFloat(str) / 100);
    }
    return clamp_css_float(parseFloat(str));
}
function css_hue_to_rgb(m1, m2, h) {
    if (h < 0) {
        h += 1;
    } else if (h > 1) {
        h -= 1;
    }
    if (h * 6 < 1) {
        return m1 + (m2 - m1) * h * 6;
    }
    if (h * 2 < 1) {
        return m2;
    }
    if (h * 3 < 2) {
        return m1 + (m2 - m1) * (2 / 3 - h) * 6;
    }
    return m1;
}
function parseCSSColor(css_str) {
    var str = css_str.replace(/ /g, '').toLowerCase();
    if (str in kCSSColorTable) {
        return kCSSColorTable[str].slice();
    }
    if (str[0] === '#') {
        if (str.length === 4) {
            var iv = parseInt(str.substr(1), 16);
            if (!(iv >= 0 && iv <= 4095)) {
                return null;
            }
            return [
                (iv & 3840) >> 4 | (iv & 3840) >> 8,
                iv & 240 | (iv & 240) >> 4,
                iv & 15 | (iv & 15) << 4,
                1
            ];
        } else if (str.length === 7) {
            var iv = parseInt(str.substr(1), 16);
            if (!(iv >= 0 && iv <= 16777215)) {
                return null;
            }
            return [
                (iv & 16711680) >> 16,
                (iv & 65280) >> 8,
                iv & 255,
                1
            ];
        }
        return null;
    }
    var op = str.indexOf('('), ep = str.indexOf(')');
    if (op !== -1 && ep + 1 === str.length) {
        var fname = str.substr(0, op);
        var params = str.substr(op + 1, ep - (op + 1)).split(',');
        var alpha = 1;
        switch (fname) {
        case 'rgba':
            if (params.length !== 4) {
                return null;
            }
            alpha = parse_css_float(params.pop());
        case 'rgb':
            if (params.length !== 3) {
                return null;
            }
            return [
                parse_css_int(params[0]),
                parse_css_int(params[1]),
                parse_css_int(params[2]),
                alpha
            ];
        case 'hsla':
            if (params.length !== 4) {
                return null;
            }
            alpha = parse_css_float(params.pop());
        case 'hsl':
            if (params.length !== 3) {
                return null;
            }
            var h = (parseFloat(params[0]) % 360 + 360) % 360 / 360;
            var s = parse_css_float(params[1]);
            var l = parse_css_float(params[2]);
            var m2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
            var m1 = l * 2 - m2;
            return [
                clamp_css_byte(css_hue_to_rgb(m1, m2, h + 1 / 3) * 255),
                clamp_css_byte(css_hue_to_rgb(m1, m2, h) * 255),
                clamp_css_byte(css_hue_to_rgb(m1, m2, h - 1 / 3) * 255),
                alpha
            ];
        default:
            return null;
        }
    }
    return null;
}
try {
    exports.parseCSSColor = parseCSSColor;
} catch (e) {
}
});
var csscolorparser_1 = csscolorparser.parseCSSColor;

var Color = function Color(r, g, b, a) {
    if (a === void 0)
        a = 1;
    this.r = r;
    this.g = g;
    this.b = b;
    this.a = a;
};
Color.parse = function parse(input) {
    if (!input) {
        return undefined;
    }
    if (input instanceof Color) {
        return input;
    }
    if (typeof input !== 'string') {
        return undefined;
    }
    var rgba = csscolorparser_1(input);
    if (!rgba) {
        return undefined;
    }
    return new Color(rgba[0] / 255 * rgba[3], rgba[1] / 255 * rgba[3], rgba[2] / 255 * rgba[3], rgba[3]);
};
Color.prototype.toString = function toString() {
    var ref = this.toArray();
    var r = ref[0];
    var g = ref[1];
    var b = ref[2];
    var a = ref[3];
    return 'rgba(' + Math.round(r) + ',' + Math.round(g) + ',' + Math.round(b) + ',' + a + ')';
};
Color.prototype.toArray = function toArray() {
    var ref = this;
    var r = ref.r;
    var g = ref.g;
    var b = ref.b;
    var a = ref.a;
    return a === 0 ? [
        0,
        0,
        0,
        0
    ] : [
        r * 255 / a,
        g * 255 / a,
        b * 255 / a,
        a
    ];
};
Color.black = new Color(0, 0, 0, 1);
Color.white = new Color(1, 1, 1, 1);
Color.transparent = new Color(0, 0, 0, 0);
Color.red = new Color(1, 0, 0, 1);

var Collator = function Collator(caseSensitive, diacriticSensitive, locale) {
    if (caseSensitive) {
        this.sensitivity = diacriticSensitive ? 'variant' : 'case';
    } else {
        this.sensitivity = diacriticSensitive ? 'accent' : 'base';
    }
    this.locale = locale;
    this.collator = new Intl.Collator(this.locale ? this.locale : [], {
        sensitivity: this.sensitivity,
        usage: 'search'
    });
};
Collator.prototype.compare = function compare(lhs, rhs) {
    return this.collator.compare(lhs, rhs);
};
Collator.prototype.resolvedLocale = function resolvedLocale() {
    return new Intl.Collator(this.locale ? this.locale : []).resolvedOptions().locale;
};

var FormattedSection = function FormattedSection(text, image, scale, fontStack, textColor) {
    this.text = text;
    this.image = image;
    this.scale = scale;
    this.fontStack = fontStack;
    this.textColor = textColor;
};
var Formatted = function Formatted(sections) {
    this.sections = sections;
};
Formatted.fromString = function fromString(unformatted) {
    return new Formatted([new FormattedSection(unformatted, null, null, null, null)]);
};
Formatted.prototype.isEmpty = function isEmpty() {
    if (this.sections.length === 0) {
        return true;
    }
    return !this.sections.some(function (section) {
        return section.text.length !== 0 || section.image && section.image.name.length !== 0;
    });
};
Formatted.factory = function factory(text) {
    if (text instanceof Formatted) {
        return text;
    } else {
        return Formatted.fromString(text);
    }
};
Formatted.prototype.toString = function toString() {
    if (this.sections.length === 0) {
        return '';
    }
    return this.sections.map(function (section) {
        return section.text;
    }).join('');
};
Formatted.prototype.serialize = function serialize() {
    var serialized = ['format'];
    for (var i = 0, list = this.sections; i < list.length; i += 1) {
        var section = list[i];
        if (section.image) {
            serialized.push([
                'image',
                section.image.name
            ]);
            continue;
        }
        serialized.push(section.text);
        var options = {};
        if (section.fontStack) {
            options['text-font'] = [
                'literal',
                section.fontStack.split(',')
            ];
        }
        if (section.scale) {
            options['font-scale'] = section.scale;
        }
        if (section.textColor) {
            options['text-color'] = ['rgba'].concat(section.textColor.toArray());
        }
        serialized.push(options);
    }
    return serialized;
};

var ResolvedImage = function ResolvedImage(options) {
    this.name = options.name;
    this.available = options.available;
};
ResolvedImage.prototype.toString = function toString() {
    return this.name;
};
ResolvedImage.fromString = function fromString(name) {
    if (!name) {
        return null;
    }
    return new ResolvedImage({
        name: name,
        available: false
    });
};
ResolvedImage.prototype.serialize = function serialize() {
    return [
        'image',
        this.name
    ];
};

function validateRGBA(r, g, b, a) {
    if (!(typeof r === 'number' && r >= 0 && r <= 255 && typeof g === 'number' && g >= 0 && g <= 255 && typeof b === 'number' && b >= 0 && b <= 255)) {
        var value = typeof a === 'number' ? [
            r,
            g,
            b,
            a
        ] : [
            r,
            g,
            b
        ];
        return 'Invalid rgba value [' + value.join(', ') + ']: \'r\', \'g\', and \'b\' must be between 0 and 255.';
    }
    if (!(typeof a === 'undefined' || typeof a === 'number' && a >= 0 && a <= 1)) {
        return 'Invalid rgba value [' + [
            r,
            g,
            b,
            a
        ].join(', ') + ']: \'a\' must be between 0 and 1.';
    }
    return null;
}
function isValue(mixed) {
    if (mixed === null) {
        return true;
    } else if (typeof mixed === 'string') {
        return true;
    } else if (typeof mixed === 'boolean') {
        return true;
    } else if (typeof mixed === 'number') {
        return true;
    } else if (mixed instanceof Color) {
        return true;
    } else if (mixed instanceof Collator) {
        return true;
    } else if (mixed instanceof Formatted) {
        return true;
    } else if (mixed instanceof ResolvedImage) {
        return true;
    } else if (Array.isArray(mixed)) {
        for (var i = 0, list = mixed; i < list.length; i += 1) {
            var item = list[i];
            if (!isValue(item)) {
                return false;
            }
        }
        return true;
    } else if (typeof mixed === 'object') {
        for (var key in mixed) {
            if (!isValue(mixed[key])) {
                return false;
            }
        }
        return true;
    } else {
        return false;
    }
}
function typeOf(value) {
    if (value === null) {
        return NullType;
    } else if (typeof value === 'string') {
        return StringType;
    } else if (typeof value === 'boolean') {
        return BooleanType;
    } else if (typeof value === 'number') {
        return NumberType;
    } else if (value instanceof Color) {
        return ColorType;
    } else if (value instanceof Collator) {
        return CollatorType;
    } else if (value instanceof Formatted) {
        return FormattedType;
    } else if (value instanceof ResolvedImage) {
        return ResolvedImageType;
    } else if (Array.isArray(value)) {
        var length = value.length;
        var itemType;
        for (var i = 0, list = value; i < list.length; i += 1) {
            var item = list[i];
            var t = typeOf(item);
            if (!itemType) {
                itemType = t;
            } else if (itemType === t) {
                continue;
            } else {
                itemType = ValueType;
                break;
            }
        }
        return array(itemType || ValueType, length);
    } else {
        return ObjectType;
    }
}
function toString$1(value) {
    var type = typeof value;
    if (value === null) {
        return '';
    } else if (type === 'string' || type === 'number' || type === 'boolean') {
        return String(value);
    } else if (value instanceof Color || value instanceof Formatted || value instanceof ResolvedImage) {
        return value.toString();
    } else {
        return JSON.stringify(value);
    }
}

var Literal = function Literal(type, value) {
    this.type = type;
    this.value = value;
};
Literal.parse = function parse(args, context) {
    if (args.length !== 2) {
        return context.error('\'literal\' expression requires exactly one argument, but found ' + (args.length - 1) + ' instead.');
    }
    if (!isValue(args[1])) {
        return context.error('invalid value');
    }
    var value = args[1];
    var type = typeOf(value);
    var expected = context.expectedType;
    if (type.kind === 'array' && type.N === 0 && expected && expected.kind === 'array' && (typeof expected.N !== 'number' || expected.N === 0)) {
        type = expected;
    }
    return new Literal(type, value);
};
Literal.prototype.evaluate = function evaluate() {
    return this.value;
};
Literal.prototype.eachChild = function eachChild() {
};
Literal.prototype.outputDefined = function outputDefined() {
    return true;
};
Literal.prototype.serialize = function serialize() {
    if (this.type.kind === 'array' || this.type.kind === 'object') {
        return [
            'literal',
            this.value
        ];
    } else if (this.value instanceof Color) {
        return ['rgba'].concat(this.value.toArray());
    } else if (this.value instanceof Formatted) {
        return this.value.serialize();
    } else {
        return this.value;
    }
};

var RuntimeError = function RuntimeError(message) {
    this.name = 'ExpressionEvaluationError';
    this.message = message;
};
RuntimeError.prototype.toJSON = function toJSON() {
    return this.message;
};

var types = {
    string: StringType,
    number: NumberType,
    boolean: BooleanType,
    object: ObjectType
};
var Assertion = function Assertion(type, args) {
    this.type = type;
    this.args = args;
};
Assertion.parse = function parse(args, context) {
    if (args.length < 2) {
        return context.error('Expected at least one argument.');
    }
    var i = 1;
    var type;
    var name = args[0];
    if (name === 'array') {
        var itemType;
        if (args.length > 2) {
            var type$1 = args[1];
            if (typeof type$1 !== 'string' || !(type$1 in types) || type$1 === 'object') {
                return context.error('The item type argument of "array" must be one of string, number, boolean', 1);
            }
            itemType = types[type$1];
            i++;
        } else {
            itemType = ValueType;
        }
        var N;
        if (args.length > 3) {
            if (args[2] !== null && (typeof args[2] !== 'number' || args[2] < 0 || args[2] !== Math.floor(args[2]))) {
                return context.error('The length argument to "array" must be a positive integer literal', 2);
            }
            N = args[2];
            i++;
        }
        type = array(itemType, N);
    } else {
        type = types[name];
    }
    var parsed = [];
    for (; i < args.length; i++) {
        var input = context.parse(args[i], i, ValueType);
        if (!input) {
            return null;
        }
        parsed.push(input);
    }
    return new Assertion(type, parsed);
};
Assertion.prototype.evaluate = function evaluate(ctx) {
    for (var i = 0; i < this.args.length; i++) {
        var value = this.args[i].evaluate(ctx);
        var error = checkSubtype(this.type, typeOf(value));
        if (!error) {
            return value;
        } else if (i === this.args.length - 1) {
            throw new RuntimeError('Expected value to be of type ' + toString(this.type) + ', but found ' + toString(typeOf(value)) + ' instead.');
        }
    }
    return null;
};
Assertion.prototype.eachChild = function eachChild(fn) {
    this.args.forEach(fn);
};
Assertion.prototype.outputDefined = function outputDefined() {
    return this.args.every(function (arg) {
        return arg.outputDefined();
    });
};
Assertion.prototype.serialize = function serialize() {
    var type = this.type;
    var serialized = [type.kind];
    if (type.kind === 'array') {
        var itemType = type.itemType;
        if (itemType.kind === 'string' || itemType.kind === 'number' || itemType.kind === 'boolean') {
            serialized.push(itemType.kind);
            var N = type.N;
            if (typeof N === 'number' || this.args.length > 1) {
                serialized.push(N);
            }
        }
    }
    return serialized.concat(this.args.map(function (arg) {
        return arg.serialize();
    }));
};

var FormatExpression = function FormatExpression(sections) {
    this.type = FormattedType;
    this.sections = sections;
};
FormatExpression.parse = function parse(args, context) {
    if (args.length < 2) {
        return context.error('Expected at least one argument.');
    }
    var firstArg = args[1];
    if (!Array.isArray(firstArg) && typeof firstArg === 'object') {
        return context.error('First argument must be an image or text section.');
    }
    var sections = [];
    var nextTokenMayBeObject = false;
    for (var i = 1; i <= args.length - 1; ++i) {
        var arg = args[i];
        if (nextTokenMayBeObject && typeof arg === 'object' && !Array.isArray(arg)) {
            nextTokenMayBeObject = false;
            var scale = null;
            if (arg['font-scale']) {
                scale = context.parse(arg['font-scale'], 1, NumberType);
                if (!scale) {
                    return null;
                }
            }
            var font = null;
            if (arg['text-font']) {
                font = context.parse(arg['text-font'], 1, array(StringType));
                if (!font) {
                    return null;
                }
            }
            var textColor = null;
            if (arg['text-color']) {
                textColor = context.parse(arg['text-color'], 1, ColorType);
                if (!textColor) {
                    return null;
                }
            }
            var lastExpression = sections[sections.length - 1];
            lastExpression.scale = scale;
            lastExpression.font = font;
            lastExpression.textColor = textColor;
        } else {
            var content = context.parse(args[i], 1, ValueType);
            if (!content) {
                return null;
            }
            var kind = content.type.kind;
            if (kind !== 'string' && kind !== 'value' && kind !== 'null' && kind !== 'resolvedImage') {
                return context.error('Formatted text type must be \'string\', \'value\', \'image\' or \'null\'.');
            }
            nextTokenMayBeObject = true;
            sections.push({
                content: content,
                scale: null,
                font: null,
                textColor: null
            });
        }
    }
    return new FormatExpression(sections);
};
FormatExpression.prototype.evaluate = function evaluate(ctx) {
    var evaluateSection = function (section) {
        var evaluatedContent = section.content.evaluate(ctx);
        if (typeOf(evaluatedContent) === ResolvedImageType) {
            return new FormattedSection('', evaluatedContent, null, null, null);
        }
        return new FormattedSection(toString$1(evaluatedContent), null, section.scale ? section.scale.evaluate(ctx) : null, section.font ? section.font.evaluate(ctx).join(',') : null, section.textColor ? section.textColor.evaluate(ctx) : null);
    };
    return new Formatted(this.sections.map(evaluateSection));
};
FormatExpression.prototype.eachChild = function eachChild(fn) {
    for (var i = 0, list = this.sections; i < list.length; i += 1) {
        var section = list[i];
        fn(section.content);
        if (section.scale) {
            fn(section.scale);
        }
        if (section.font) {
            fn(section.font);
        }
        if (section.textColor) {
            fn(section.textColor);
        }
    }
};
FormatExpression.prototype.outputDefined = function outputDefined() {
    return false;
};
FormatExpression.prototype.serialize = function serialize() {
    var serialized = ['format'];
    for (var i = 0, list = this.sections; i < list.length; i += 1) {
        var section = list[i];
        serialized.push(section.content.serialize());
        var options = {};
        if (section.scale) {
            options['font-scale'] = section.scale.serialize();
        }
        if (section.font) {
            options['text-font'] = section.font.serialize();
        }
        if (section.textColor) {
            options['text-color'] = section.textColor.serialize();
        }
        serialized.push(options);
    }
    return serialized;
};

var ImageExpression = function ImageExpression(input) {
    this.type = ResolvedImageType;
    this.input = input;
};
ImageExpression.parse = function parse(args, context) {
    if (args.length !== 2) {
        return context.error('Expected two arguments.');
    }
    var name = context.parse(args[1], 1, StringType);
    if (!name) {
        return context.error('No image name provided.');
    }
    return new ImageExpression(name);
};
ImageExpression.prototype.evaluate = function evaluate(ctx) {
    var evaluatedImageName = this.input.evaluate(ctx);
    var value = ResolvedImage.fromString(evaluatedImageName);
    if (value && ctx.availableImages) {
        value.available = ctx.availableImages.indexOf(evaluatedImageName) > -1;
    }
    return value;
};
ImageExpression.prototype.eachChild = function eachChild(fn) {
    fn(this.input);
};
ImageExpression.prototype.outputDefined = function outputDefined() {
    return false;
};
ImageExpression.prototype.serialize = function serialize() {
    return [
        'image',
        this.input.serialize()
    ];
};

var types$1 = {
    'to-boolean': BooleanType,
    'to-color': ColorType,
    'to-number': NumberType,
    'to-string': StringType
};
var Coercion = function Coercion(type, args) {
    this.type = type;
    this.args = args;
};
Coercion.parse = function parse(args, context) {
    if (args.length < 2) {
        return context.error('Expected at least one argument.');
    }
    var name = args[0];
    if ((name === 'to-boolean' || name === 'to-string') && args.length !== 2) {
        return context.error('Expected one argument.');
    }
    var type = types$1[name];
    var parsed = [];
    for (var i = 1; i < args.length; i++) {
        var input = context.parse(args[i], i, ValueType);
        if (!input) {
            return null;
        }
        parsed.push(input);
    }
    return new Coercion(type, parsed);
};
Coercion.prototype.evaluate = function evaluate(ctx) {
    if (this.type.kind === 'boolean') {
        return Boolean(this.args[0].evaluate(ctx));
    } else if (this.type.kind === 'color') {
        var input;
        var error;
        for (var i = 0, list = this.args; i < list.length; i += 1) {
            var arg = list[i];
            input = arg.evaluate(ctx);
            error = null;
            if (input instanceof Color) {
                return input;
            } else if (typeof input === 'string') {
                var c = ctx.parseColor(input);
                if (c) {
                    return c;
                }
            } else if (Array.isArray(input)) {
                if (input.length < 3 || input.length > 4) {
                    error = 'Invalid rbga value ' + JSON.stringify(input) + ': expected an array containing either three or four numeric values.';
                } else {
                    error = validateRGBA(input[0], input[1], input[2], input[3]);
                }
                if (!error) {
                    return new Color(input[0] / 255, input[1] / 255, input[2] / 255, input[3]);
                }
            }
        }
        throw new RuntimeError(error || 'Could not parse color from value \'' + (typeof input === 'string' ? input : String(JSON.stringify(input))) + '\'');
    } else if (this.type.kind === 'number') {
        var value = null;
        for (var i$1 = 0, list$1 = this.args; i$1 < list$1.length; i$1 += 1) {
            var arg$1 = list$1[i$1];
            value = arg$1.evaluate(ctx);
            if (value === null) {
                return 0;
            }
            var num = Number(value);
            if (isNaN(num)) {
                continue;
            }
            return num;
        }
        throw new RuntimeError('Could not convert ' + JSON.stringify(value) + ' to number.');
    } else if (this.type.kind === 'formatted') {
        return Formatted.fromString(toString$1(this.args[0].evaluate(ctx)));
    } else if (this.type.kind === 'resolvedImage') {
        return ResolvedImage.fromString(toString$1(this.args[0].evaluate(ctx)));
    } else {
        return toString$1(this.args[0].evaluate(ctx));
    }
};
Coercion.prototype.eachChild = function eachChild(fn) {
    this.args.forEach(fn);
};
Coercion.prototype.outputDefined = function outputDefined() {
    return this.args.every(function (arg) {
        return arg.outputDefined();
    });
};
Coercion.prototype.serialize = function serialize() {
    if (this.type.kind === 'formatted') {
        return new FormatExpression([{
                content: this.args[0],
                scale: null,
                font: null,
                textColor: null
            }]).serialize();
    }
    if (this.type.kind === 'resolvedImage') {
        return new ImageExpression(this.args[0]).serialize();
    }
    var serialized = ['to-' + this.type.kind];
    this.eachChild(function (child) {
        serialized.push(child.serialize());
    });
    return serialized;
};

var geometryTypes = [
    'Unknown',
    'Point',
    'LineString',
    'Polygon'
];
var EvaluationContext = function EvaluationContext() {
    this.globals = null;
    this.feature = null;
    this.featureState = null;
    this.formattedSection = null;
    this._parseColorCache = {};
    this.availableImages = null;
    this.canonical = null;
};
EvaluationContext.prototype.id = function id() {
    return this.feature && 'id' in this.feature ? this.feature.id : null;
};
EvaluationContext.prototype.geometryType = function geometryType() {
    return this.feature ? typeof this.feature.type === 'number' ? geometryTypes[this.feature.type] : this.feature.type : null;
};
EvaluationContext.prototype.geometry = function geometry() {
    return this.feature && 'geometry' in this.feature ? this.feature.geometry : null;
};
EvaluationContext.prototype.canonicalID = function canonicalID() {
    return this.canonical;
};
EvaluationContext.prototype.properties = function properties() {
    return this.feature && this.feature.properties || {};
};
EvaluationContext.prototype.parseColor = function parseColor(input) {
    var cached = this._parseColorCache[input];
    if (!cached) {
        cached = this._parseColorCache[input] = Color.parse(input);
    }
    return cached;
};

var CompoundExpression = function CompoundExpression(name, type, evaluate, args) {
    this.name = name;
    this.type = type;
    this._evaluate = evaluate;
    this.args = args;
};
CompoundExpression.prototype.evaluate = function evaluate(ctx) {
    return this._evaluate(ctx, this.args);
};
CompoundExpression.prototype.eachChild = function eachChild(fn) {
    this.args.forEach(fn);
};
CompoundExpression.prototype.outputDefined = function outputDefined() {
    return false;
};
CompoundExpression.prototype.serialize = function serialize() {
    return [this.name].concat(this.args.map(function (arg) {
        return arg.serialize();
    }));
};
CompoundExpression.parse = function parse(args, context) {
    var ref$1;
    var op = args[0];
    var definition = CompoundExpression.definitions[op];
    if (!definition) {
        return context.error('Unknown expression "' + op + '". If you wanted a literal array, use ["literal", [...]].', 0);
    }
    var type = Array.isArray(definition) ? definition[0] : definition.type;
    var availableOverloads = Array.isArray(definition) ? [[
            definition[1],
            definition[2]
        ]] : definition.overloads;
    var overloads = availableOverloads.filter(function (ref) {
        var signature = ref[0];
        return !Array.isArray(signature) || signature.length === args.length - 1;
    });
    var signatureContext = null;
    for (var i$3 = 0, list = overloads; i$3 < list.length; i$3 += 1) {
        var ref = list[i$3];
        var params = ref[0];
        var evaluate = ref[1];
        signatureContext = new ParsingContext(context.registry, context.path, null, context.scope);
        var parsedArgs = [];
        var argParseFailed = false;
        for (var i = 1; i < args.length; i++) {
            var arg = args[i];
            var expectedType = Array.isArray(params) ? params[i - 1] : params.type;
            var parsed = signatureContext.parse(arg, 1 + parsedArgs.length, expectedType);
            if (!parsed) {
                argParseFailed = true;
                break;
            }
            parsedArgs.push(parsed);
        }
        if (argParseFailed) {
            continue;
        }
        if (Array.isArray(params)) {
            if (params.length !== parsedArgs.length) {
                signatureContext.error('Expected ' + params.length + ' arguments, but found ' + parsedArgs.length + ' instead.');
                continue;
            }
        }
        for (var i$1 = 0; i$1 < parsedArgs.length; i$1++) {
            var expected = Array.isArray(params) ? params[i$1] : params.type;
            var arg$1 = parsedArgs[i$1];
            signatureContext.concat(i$1 + 1).checkSubtype(expected, arg$1.type);
        }
        if (signatureContext.errors.length === 0) {
            return new CompoundExpression(op, type, evaluate, parsedArgs);
        }
    }
    if (overloads.length === 1) {
        (ref$1 = context.errors).push.apply(ref$1, signatureContext.errors);
    } else {
        var expected$1 = overloads.length ? overloads : availableOverloads;
        var signatures = expected$1.map(function (ref) {
            var params = ref[0];
            return stringifySignature(params);
        }).join(' | ');
        var actualTypes = [];
        for (var i$2 = 1; i$2 < args.length; i$2++) {
            var parsed$1 = context.parse(args[i$2], 1 + actualTypes.length);
            if (!parsed$1) {
                return null;
            }
            actualTypes.push(toString(parsed$1.type));
        }
        context.error('Expected arguments of type ' + signatures + ', but found (' + actualTypes.join(', ') + ') instead.');
    }
    return null;
};
CompoundExpression.register = function register(registry, definitions) {
    CompoundExpression.definitions = definitions;
    for (var name in definitions) {
        registry[name] = CompoundExpression;
    }
};
function stringifySignature(signature) {
    if (Array.isArray(signature)) {
        return '(' + signature.map(toString).join(', ') + ')';
    } else {
        return '(' + toString(signature.type) + '...)';
    }
}

var CollatorExpression = function CollatorExpression(caseSensitive, diacriticSensitive, locale) {
    this.type = CollatorType;
    this.locale = locale;
    this.caseSensitive = caseSensitive;
    this.diacriticSensitive = diacriticSensitive;
};
CollatorExpression.parse = function parse(args, context) {
    if (args.length !== 2) {
        return context.error('Expected one argument.');
    }
    var options = args[1];
    if (typeof options !== 'object' || Array.isArray(options)) {
        return context.error('Collator options argument must be an object.');
    }
    var caseSensitive = context.parse(options['case-sensitive'] === undefined ? false : options['case-sensitive'], 1, BooleanType);
    if (!caseSensitive) {
        return null;
    }
    var diacriticSensitive = context.parse(options['diacritic-sensitive'] === undefined ? false : options['diacritic-sensitive'], 1, BooleanType);
    if (!diacriticSensitive) {
        return null;
    }
    var locale = null;
    if (options['locale']) {
        locale = context.parse(options['locale'], 1, StringType);
        if (!locale) {
            return null;
        }
    }
    return new CollatorExpression(caseSensitive, diacriticSensitive, locale);
};
CollatorExpression.prototype.evaluate = function evaluate(ctx) {
    return new Collator(this.caseSensitive.evaluate(ctx), this.diacriticSensitive.evaluate(ctx), this.locale ? this.locale.evaluate(ctx) : null);
};
CollatorExpression.prototype.eachChild = function eachChild(fn) {
    fn(this.caseSensitive);
    fn(this.diacriticSensitive);
    if (this.locale) {
        fn(this.locale);
    }
};
CollatorExpression.prototype.outputDefined = function outputDefined() {
    return false;
};
CollatorExpression.prototype.serialize = function serialize() {
    var options = {};
    options['case-sensitive'] = this.caseSensitive.serialize();
    options['diacritic-sensitive'] = this.diacriticSensitive.serialize();
    if (this.locale) {
        options['locale'] = this.locale.serialize();
    }
    return [
        'collator',
        options
    ];
};

var EXTENT = 8192;
function updateBBox(bbox, coord) {
    bbox[0] = Math.min(bbox[0], coord[0]);
    bbox[1] = Math.min(bbox[1], coord[1]);
    bbox[2] = Math.max(bbox[2], coord[0]);
    bbox[3] = Math.max(bbox[3], coord[1]);
}
function mercatorXfromLng(lng) {
    return (180 + lng) / 360;
}
function mercatorYfromLat(lat) {
    return (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + lat * Math.PI / 360))) / 360;
}
function boxWithinBox(bbox1, bbox2) {
    if (bbox1[0] <= bbox2[0]) {
        return false;
    }
    if (bbox1[2] >= bbox2[2]) {
        return false;
    }
    if (bbox1[1] <= bbox2[1]) {
        return false;
    }
    if (bbox1[3] >= bbox2[3]) {
        return false;
    }
    return true;
}
function getTileCoordinates(p, canonical) {
    var x = mercatorXfromLng(p[0]);
    var y = mercatorYfromLat(p[1]);
    var tilesAtZoom = Math.pow(2, canonical.z);
    return [
        Math.round(x * tilesAtZoom * EXTENT),
        Math.round(y * tilesAtZoom * EXTENT)
    ];
}
function onBoundary(p, p1, p2) {
    var x1 = p[0] - p1[0];
    var y1 = p[1] - p1[1];
    var x2 = p[0] - p2[0];
    var y2 = p[1] - p2[1];
    return x1 * y2 - x2 * y1 === 0 && x1 * x2 <= 0 && y1 * y2 <= 0;
}
function rayIntersect(p, p1, p2) {
    return p1[1] > p[1] !== p2[1] > p[1] && p[0] < (p2[0] - p1[0]) * (p[1] - p1[1]) / (p2[1] - p1[1]) + p1[0];
}
function pointWithinPolygon(point, rings) {
    var inside = false;
    for (var i = 0, len = rings.length; i < len; i++) {
        var ring = rings[i];
        for (var j = 0, len2 = ring.length; j < len2 - 1; j++) {
            if (onBoundary(point, ring[j], ring[j + 1])) {
                return false;
            }
            if (rayIntersect(point, ring[j], ring[j + 1])) {
                inside = !inside;
            }
        }
    }
    return inside;
}
function pointWithinPolygons(point, polygons) {
    for (var i = 0; i < polygons.length; i++) {
        if (pointWithinPolygon(point, polygons[i])) {
            return true;
        }
    }
    return false;
}
function perp(v1, v2) {
    return v1[0] * v2[1] - v1[1] * v2[0];
}
function twoSided(p1, p2, q1, q2) {
    var x1 = p1[0] - q1[0];
    var y1 = p1[1] - q1[1];
    var x2 = p2[0] - q1[0];
    var y2 = p2[1] - q1[1];
    var x3 = q2[0] - q1[0];
    var y3 = q2[1] - q1[1];
    var det1 = x1 * y3 - x3 * y1;
    var det2 = x2 * y3 - x3 * y2;
    if (det1 > 0 && det2 < 0 || det1 < 0 && det2 > 0) {
        return true;
    }
    return false;
}
function lineIntersectLine(a, b, c, d) {
    var vectorP = [
        b[0] - a[0],
        b[1] - a[1]
    ];
    var vectorQ = [
        d[0] - c[0],
        d[1] - c[1]
    ];
    if (perp(vectorQ, vectorP) === 0) {
        return false;
    }
    if (twoSided(a, b, c, d) && twoSided(c, d, a, b)) {
        return true;
    }
    return false;
}
function lineIntersectPolygon(p1, p2, polygon) {
    for (var i = 0, list = polygon; i < list.length; i += 1) {
        var ring = list[i];
        for (var j = 0; j < ring.length - 1; ++j) {
            if (lineIntersectLine(p1, p2, ring[j], ring[j + 1])) {
                return true;
            }
        }
    }
    return false;
}
function lineStringWithinPolygon(line, polygon) {
    for (var i = 0; i < line.length; ++i) {
        if (!pointWithinPolygon(line[i], polygon)) {
            return false;
        }
    }
    for (var i$1 = 0; i$1 < line.length - 1; ++i$1) {
        if (lineIntersectPolygon(line[i$1], line[i$1 + 1], polygon)) {
            return false;
        }
    }
    return true;
}
function lineStringWithinPolygons(line, polygons) {
    for (var i = 0; i < polygons.length; i++) {
        if (lineStringWithinPolygon(line, polygons[i])) {
            return true;
        }
    }
    return false;
}
function getTilePolygon(coordinates, bbox, canonical) {
    var polygon = [];
    for (var i = 0; i < coordinates.length; i++) {
        var ring = [];
        for (var j = 0; j < coordinates[i].length; j++) {
            var coord = getTileCoordinates(coordinates[i][j], canonical);
            updateBBox(bbox, coord);
            ring.push(coord);
        }
        polygon.push(ring);
    }
    return polygon;
}
function getTilePolygons(coordinates, bbox, canonical) {
    var polygons = [];
    for (var i = 0; i < coordinates.length; i++) {
        var polygon = getTilePolygon(coordinates[i], bbox, canonical);
        polygons.push(polygon);
    }
    return polygons;
}
function updatePoint(p, bbox, polyBBox, worldSize) {
    if (p[0] < polyBBox[0] || p[0] > polyBBox[2]) {
        var halfWorldSize = worldSize * 0.5;
        var shift = p[0] - polyBBox[0] > halfWorldSize ? -worldSize : polyBBox[0] - p[0] > halfWorldSize ? worldSize : 0;
        if (shift === 0) {
            shift = p[0] - polyBBox[2] > halfWorldSize ? -worldSize : polyBBox[2] - p[0] > halfWorldSize ? worldSize : 0;
        }
        p[0] += shift;
    }
    updateBBox(bbox, p);
}
function resetBBox(bbox) {
    bbox[0] = bbox[1] = Infinity;
    bbox[2] = bbox[3] = -Infinity;
}
function getTilePoints(geometry, pointBBox, polyBBox, canonical) {
    var worldSize = Math.pow(2, canonical.z) * EXTENT;
    var shifts = [
        canonical.x * EXTENT,
        canonical.y * EXTENT
    ];
    var tilePoints = [];
    for (var i$1 = 0, list$1 = geometry; i$1 < list$1.length; i$1 += 1) {
        var points = list$1[i$1];
        for (var i = 0, list = points; i < list.length; i += 1) {
            var point = list[i];
            var p = [
                point.x + shifts[0],
                point.y + shifts[1]
            ];
            updatePoint(p, pointBBox, polyBBox, worldSize);
            tilePoints.push(p);
        }
    }
    return tilePoints;
}
function getTileLines(geometry, lineBBox, polyBBox, canonical) {
    var worldSize = Math.pow(2, canonical.z) * EXTENT;
    var shifts = [
        canonical.x * EXTENT,
        canonical.y * EXTENT
    ];
    var tileLines = [];
    for (var i$1 = 0, list$1 = geometry; i$1 < list$1.length; i$1 += 1) {
        var line = list$1[i$1];
        var tileLine = [];
        for (var i = 0, list = line; i < list.length; i += 1) {
            var point = list[i];
            var p = [
                point.x + shifts[0],
                point.y + shifts[1]
            ];
            updateBBox(lineBBox, p);
            tileLine.push(p);
        }
        tileLines.push(tileLine);
    }
    if (lineBBox[2] - lineBBox[0] <= worldSize / 2) {
        resetBBox(lineBBox);
        for (var i$3 = 0, list$3 = tileLines; i$3 < list$3.length; i$3 += 1) {
            var line$1 = list$3[i$3];
            for (var i$2 = 0, list$2 = line$1; i$2 < list$2.length; i$2 += 1) {
                var p$1 = list$2[i$2];
                updatePoint(p$1, lineBBox, polyBBox, worldSize);
            }
        }
    }
    return tileLines;
}
function pointsWithinPolygons(ctx, polygonGeometry) {
    var pointBBox = [
        Infinity,
        Infinity,
        -Infinity,
        -Infinity
    ];
    var polyBBox = [
        Infinity,
        Infinity,
        -Infinity,
        -Infinity
    ];
    var canonical = ctx.canonicalID();
    if (polygonGeometry.type === 'Polygon') {
        var tilePolygon = getTilePolygon(polygonGeometry.coordinates, polyBBox, canonical);
        var tilePoints = getTilePoints(ctx.geometry(), pointBBox, polyBBox, canonical);
        if (!boxWithinBox(pointBBox, polyBBox)) {
            return false;
        }
        for (var i = 0, list = tilePoints; i < list.length; i += 1) {
            var point = list[i];
            if (!pointWithinPolygon(point, tilePolygon)) {
                return false;
            }
        }
    }
    if (polygonGeometry.type === 'MultiPolygon') {
        var tilePolygons = getTilePolygons(polygonGeometry.coordinates, polyBBox, canonical);
        var tilePoints$1 = getTilePoints(ctx.geometry(), pointBBox, polyBBox, canonical);
        if (!boxWithinBox(pointBBox, polyBBox)) {
            return false;
        }
        for (var i$1 = 0, list$1 = tilePoints$1; i$1 < list$1.length; i$1 += 1) {
            var point$1 = list$1[i$1];
            if (!pointWithinPolygons(point$1, tilePolygons)) {
                return false;
            }
        }
    }
    return true;
}
function linesWithinPolygons(ctx, polygonGeometry) {
    var lineBBox = [
        Infinity,
        Infinity,
        -Infinity,
        -Infinity
    ];
    var polyBBox = [
        Infinity,
        Infinity,
        -Infinity,
        -Infinity
    ];
    var canonical = ctx.canonicalID();
    if (polygonGeometry.type === 'Polygon') {
        var tilePolygon = getTilePolygon(polygonGeometry.coordinates, polyBBox, canonical);
        var tileLines = getTileLines(ctx.geometry(), lineBBox, polyBBox, canonical);
        if (!boxWithinBox(lineBBox, polyBBox)) {
            return false;
        }
        for (var i = 0, list = tileLines; i < list.length; i += 1) {
            var line = list[i];
            if (!lineStringWithinPolygon(line, tilePolygon)) {
                return false;
            }
        }
    }
    if (polygonGeometry.type === 'MultiPolygon') {
        var tilePolygons = getTilePolygons(polygonGeometry.coordinates, polyBBox, canonical);
        var tileLines$1 = getTileLines(ctx.geometry(), lineBBox, polyBBox, canonical);
        if (!boxWithinBox(lineBBox, polyBBox)) {
            return false;
        }
        for (var i$1 = 0, list$1 = tileLines$1; i$1 < list$1.length; i$1 += 1) {
            var line$1 = list$1[i$1];
            if (!lineStringWithinPolygons(line$1, tilePolygons)) {
                return false;
            }
        }
    }
    return true;
}
var Within = function Within(geojson, geometries) {
    this.type = BooleanType;
    this.geojson = geojson;
    this.geometries = geometries;
};
Within.parse = function parse(args, context) {
    if (args.length !== 2) {
        return context.error('\'within\' expression requires exactly one argument, but found ' + (args.length - 1) + ' instead.');
    }
    if (isValue(args[1])) {
        var geojson = args[1];
        if (geojson.type === 'FeatureCollection') {
            for (var i = 0; i < geojson.features.length; ++i) {
                var type = geojson.features[i].geometry.type;
                if (type === 'Polygon' || type === 'MultiPolygon') {
                    return new Within(geojson, geojson.features[i].geometry);
                }
            }
        } else if (geojson.type === 'Feature') {
            var type$1 = geojson.geometry.type;
            if (type$1 === 'Polygon' || type$1 === 'MultiPolygon') {
                return new Within(geojson, geojson.geometry);
            }
        } else if (geojson.type === 'Polygon' || geojson.type === 'MultiPolygon') {
            return new Within(geojson, geojson);
        }
    }
    return context.error('\'within\' expression requires valid geojson object that contains polygon geometry type.');
};
Within.prototype.evaluate = function evaluate(ctx) {
    if (ctx.geometry() != null && ctx.canonicalID() != null) {
        if (ctx.geometryType() === 'Point') {
            return pointsWithinPolygons(ctx, this.geometries);
        } else if (ctx.geometryType() === 'LineString') {
            return linesWithinPolygons(ctx, this.geometries);
        }
    }
    return false;
};
Within.prototype.eachChild = function eachChild() {
};
Within.prototype.outputDefined = function outputDefined() {
    return true;
};
Within.prototype.serialize = function serialize() {
    return [
        'within',
        this.geojson
    ];
};

function isFeatureConstant(e) {
    if (e instanceof CompoundExpression) {
        if (e.name === 'get' && e.args.length === 1) {
            return false;
        } else if (e.name === 'feature-state') {
            return false;
        } else if (e.name === 'has' && e.args.length === 1) {
            return false;
        } else if (e.name === 'properties' || e.name === 'geometry-type' || e.name === 'id') {
            return false;
        } else if (/^filter-/.test(e.name)) {
            return false;
        }
    }
    if (e instanceof Within) {
        return false;
    }
    var result = true;
    e.eachChild(function (arg) {
        if (result && !isFeatureConstant(arg)) {
            result = false;
        }
    });
    return result;
}
function isStateConstant(e) {
    if (e instanceof CompoundExpression) {
        if (e.name === 'feature-state') {
            return false;
        }
    }
    var result = true;
    e.eachChild(function (arg) {
        if (result && !isStateConstant(arg)) {
            result = false;
        }
    });
    return result;
}
function isGlobalPropertyConstant(e, properties) {
    if (e instanceof CompoundExpression && properties.indexOf(e.name) >= 0) {
        return false;
    }
    var result = true;
    e.eachChild(function (arg) {
        if (result && !isGlobalPropertyConstant(arg, properties)) {
            result = false;
        }
    });
    return result;
}

var Var = function Var(name, boundExpression) {
    this.type = boundExpression.type;
    this.name = name;
    this.boundExpression = boundExpression;
};
Var.parse = function parse(args, context) {
    if (args.length !== 2 || typeof args[1] !== 'string') {
        return context.error('\'var\' expression requires exactly one string literal argument.');
    }
    var name = args[1];
    if (!context.scope.has(name)) {
        return context.error('Unknown variable "' + name + '". Make sure "' + name + '" has been bound in an enclosing "let" expression before using it.', 1);
    }
    return new Var(name, context.scope.get(name));
};
Var.prototype.evaluate = function evaluate(ctx) {
    return this.boundExpression.evaluate(ctx);
};
Var.prototype.eachChild = function eachChild() {
};
Var.prototype.outputDefined = function outputDefined() {
    return false;
};
Var.prototype.serialize = function serialize() {
    return [
        'var',
        this.name
    ];
};

var ParsingContext = function ParsingContext(registry, path, expectedType, scope, errors) {
    if (path === void 0)
        path = [];
    if (scope === void 0)
        scope = new Scope();
    if (errors === void 0)
        errors = [];
    this.registry = registry;
    this.path = path;
    this.key = path.map(function (part) {
        return '[' + part + ']';
    }).join('');
    this.scope = scope;
    this.errors = errors;
    this.expectedType = expectedType;
};
ParsingContext.prototype.parse = function parse(expr, index, expectedType, bindings, options) {
    if (options === void 0)
        options = {};
    if (index) {
        return this.concat(index, expectedType, bindings)._parse(expr, options);
    }
    return this._parse(expr, options);
};
ParsingContext.prototype._parse = function _parse(expr, options) {
    if (expr === null || typeof expr === 'string' || typeof expr === 'boolean' || typeof expr === 'number') {
        expr = [
            'literal',
            expr
        ];
    }
    function annotate(parsed, type, typeAnnotation) {
        if (typeAnnotation === 'assert') {
            return new Assertion(type, [parsed]);
        } else if (typeAnnotation === 'coerce') {
            return new Coercion(type, [parsed]);
        } else {
            return parsed;
        }
    }
    if (Array.isArray(expr)) {
        if (expr.length === 0) {
            return this.error('Expected an array with at least one element. If you wanted a literal array, use ["literal", []].');
        }
        var op = expr[0];
        if (typeof op !== 'string') {
            this.error('Expression name must be a string, but found ' + typeof op + ' instead. If you wanted a literal array, use ["literal", [...]].', 0);
            return null;
        }
        var Expr = this.registry[op];
        if (Expr) {
            var parsed = Expr.parse(expr, this);
            if (!parsed) {
                return null;
            }
            if (this.expectedType) {
                var expected = this.expectedType;
                var actual = parsed.type;
                if ((expected.kind === 'string' || expected.kind === 'number' || expected.kind === 'boolean' || expected.kind === 'object' || expected.kind === 'array') && actual.kind === 'value') {
                    parsed = annotate(parsed, expected, options.typeAnnotation || 'assert');
                } else if ((expected.kind === 'color' || expected.kind === 'formatted' || expected.kind === 'resolvedImage') && (actual.kind === 'value' || actual.kind === 'string')) {
                    parsed = annotate(parsed, expected, options.typeAnnotation || 'coerce');
                } else if (this.checkSubtype(expected, actual)) {
                    return null;
                }
            }
            if (!(parsed instanceof Literal) && parsed.type.kind !== 'resolvedImage' && isConstant(parsed)) {
                var ec = new EvaluationContext();
                try {
                    parsed = new Literal(parsed.type, parsed.evaluate(ec));
                } catch (e) {
                    this.error(e.message);
                    return null;
                }
            }
            return parsed;
        }
        return this.error('Unknown expression "' + op + '". If you wanted a literal array, use ["literal", [...]].', 0);
    } else if (typeof expr === 'undefined') {
        return this.error('\'undefined\' value invalid. Use null instead.');
    } else if (typeof expr === 'object') {
        return this.error('Bare objects invalid. Use ["literal", {...}] instead.');
    } else {
        return this.error('Expected an array, but found ' + typeof expr + ' instead.');
    }
};
ParsingContext.prototype.concat = function concat(index, expectedType, bindings) {
    var path = typeof index === 'number' ? this.path.concat(index) : this.path;
    var scope = bindings ? this.scope.concat(bindings) : this.scope;
    return new ParsingContext(this.registry, path, expectedType || null, scope, this.errors);
};
ParsingContext.prototype.error = function error(error$1) {
    var keys = [], len = arguments.length - 1;
    while (len-- > 0)
        keys[len] = arguments[len + 1];
    var key = '' + this.key + keys.map(function (k) {
        return '[' + k + ']';
    }).join('');
    this.errors.push(new ParsingError(key, error$1));
};
ParsingContext.prototype.checkSubtype = function checkSubtype$1(expected, t) {
    var error = checkSubtype(expected, t);
    if (error) {
        this.error(error);
    }
    return error;
};
function isConstant(expression) {
    if (expression instanceof Var) {
        return isConstant(expression.boundExpression);
    } else if (expression instanceof CompoundExpression && expression.name === 'error') {
        return false;
    } else if (expression instanceof CollatorExpression) {
        return false;
    } else if (expression instanceof Within) {
        return false;
    }
    var isTypeAnnotation = expression instanceof Coercion || expression instanceof Assertion;
    var childrenConstant = true;
    expression.eachChild(function (child) {
        if (isTypeAnnotation) {
            childrenConstant = childrenConstant && isConstant(child);
        } else {
            childrenConstant = childrenConstant && child instanceof Literal;
        }
    });
    if (!childrenConstant) {
        return false;
    }
    return isFeatureConstant(expression) && isGlobalPropertyConstant(expression, [
        'zoom',
        'heatmap-density',
        'line-progress',
        'accumulated',
        'is-supported-script'
    ]);
}

function findStopLessThanOrEqualTo(stops, input) {
    var lastIndex = stops.length - 1;
    var lowerIndex = 0;
    var upperIndex = lastIndex;
    var currentIndex = 0;
    var currentValue, nextValue;
    while (lowerIndex <= upperIndex) {
        currentIndex = Math.floor((lowerIndex + upperIndex) / 2);
        currentValue = stops[currentIndex];
        nextValue = stops[currentIndex + 1];
        if (currentValue <= input) {
            if (currentIndex === lastIndex || input < nextValue) {
                return currentIndex;
            }
            lowerIndex = currentIndex + 1;
        } else if (currentValue > input) {
            upperIndex = currentIndex - 1;
        } else {
            throw new RuntimeError('Input is not a number.');
        }
    }
    return 0;
}

var Step = function Step(type, input, stops) {
    this.type = type;
    this.input = input;
    this.labels = [];
    this.outputs = [];
    for (var i = 0, list = stops; i < list.length; i += 1) {
        var ref = list[i];
        var label = ref[0];
        var expression = ref[1];
        this.labels.push(label);
        this.outputs.push(expression);
    }
};
Step.parse = function parse(args, context) {
    if (args.length - 1 < 4) {
        return context.error('Expected at least 4 arguments, but found only ' + (args.length - 1) + '.');
    }
    if ((args.length - 1) % 2 !== 0) {
        return context.error('Expected an even number of arguments.');
    }
    var input = context.parse(args[1], 1, NumberType);
    if (!input) {
        return null;
    }
    var stops = [];
    var outputType = null;
    if (context.expectedType && context.expectedType.kind !== 'value') {
        outputType = context.expectedType;
    }
    for (var i = 1; i < args.length; i += 2) {
        var label = i === 1 ? -Infinity : args[i];
        var value = args[i + 1];
        var labelKey = i;
        var valueKey = i + 1;
        if (typeof label !== 'number') {
            return context.error('Input/output pairs for "step" expressions must be defined using literal numeric values (not computed expressions) for the input values.', labelKey);
        }
        if (stops.length && stops[stops.length - 1][0] >= label) {
            return context.error('Input/output pairs for "step" expressions must be arranged with input values in strictly ascending order.', labelKey);
        }
        var parsed = context.parse(value, valueKey, outputType);
        if (!parsed) {
            return null;
        }
        outputType = outputType || parsed.type;
        stops.push([
            label,
            parsed
        ]);
    }
    return new Step(outputType, input, stops);
};
Step.prototype.evaluate = function evaluate(ctx) {
    var labels = this.labels;
    var outputs = this.outputs;
    if (labels.length === 1) {
        return outputs[0].evaluate(ctx);
    }
    var value = this.input.evaluate(ctx);
    if (value <= labels[0]) {
        return outputs[0].evaluate(ctx);
    }
    var stopCount = labels.length;
    if (value >= labels[stopCount - 1]) {
        return outputs[stopCount - 1].evaluate(ctx);
    }
    var index = findStopLessThanOrEqualTo(labels, value);
    return outputs[index].evaluate(ctx);
};
Step.prototype.eachChild = function eachChild(fn) {
    fn(this.input);
    for (var i = 0, list = this.outputs; i < list.length; i += 1) {
        var expression = list[i];
        fn(expression);
    }
};
Step.prototype.outputDefined = function outputDefined() {
    return this.outputs.every(function (out) {
        return out.outputDefined();
    });
};
Step.prototype.serialize = function serialize() {
    var serialized = [
        'step',
        this.input.serialize()
    ];
    for (var i = 0; i < this.labels.length; i++) {
        if (i > 0) {
            serialized.push(this.labels[i]);
        }
        serialized.push(this.outputs[i].serialize());
    }
    return serialized;
};

function number(a, b, t) {
    return a * (1 - t) + b * t;
}
function color(from, to, t) {
    return new Color(number(from.r, to.r, t), number(from.g, to.g, t), number(from.b, to.b, t), number(from.a, to.a, t));
}
function array$1(from, to, t) {
    return from.map(function (d, i) {
        return number(d, to[i], t);
    });
}

var interpolate = /*#__PURE__*/Object.freeze({
__proto__: null,
number: number,
color: color,
array: array$1
});

var Xn = 0.95047, Yn = 1, Zn = 1.08883, t0 = 4 / 29, t1 = 6 / 29, t2 = 3 * t1 * t1, t3 = t1 * t1 * t1, deg2rad = Math.PI / 180, rad2deg = 180 / Math.PI;
function xyz2lab(t) {
    return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
}
function lab2xyz(t) {
    return t > t1 ? t * t * t : t2 * (t - t0);
}
function xyz2rgb(x) {
    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}
function rgb2xyz(x) {
    x /= 255;
    return x <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}
function rgbToLab(rgbColor) {
    var b = rgb2xyz(rgbColor.r), a = rgb2xyz(rgbColor.g), l = rgb2xyz(rgbColor.b), x = xyz2lab((0.4124564 * b + 0.3575761 * a + 0.1804375 * l) / Xn), y = xyz2lab((0.2126729 * b + 0.7151522 * a + 0.072175 * l) / Yn), z = xyz2lab((0.0193339 * b + 0.119192 * a + 0.9503041 * l) / Zn);
    return {
        l: 116 * y - 16,
        a: 500 * (x - y),
        b: 200 * (y - z),
        alpha: rgbColor.a
    };
}
function labToRgb(labColor) {
    var y = (labColor.l + 16) / 116, x = isNaN(labColor.a) ? y : y + labColor.a / 500, z = isNaN(labColor.b) ? y : y - labColor.b / 200;
    y = Yn * lab2xyz(y);
    x = Xn * lab2xyz(x);
    z = Zn * lab2xyz(z);
    return new Color(xyz2rgb(3.2404542 * x - 1.5371385 * y - 0.4985314 * z), xyz2rgb(-0.969266 * x + 1.8760108 * y + 0.041556 * z), xyz2rgb(0.0556434 * x - 0.2040259 * y + 1.0572252 * z), labColor.alpha);
}
function interpolateLab(from, to, t) {
    return {
        l: number(from.l, to.l, t),
        a: number(from.a, to.a, t),
        b: number(from.b, to.b, t),
        alpha: number(from.alpha, to.alpha, t)
    };
}
function rgbToHcl(rgbColor) {
    var ref = rgbToLab(rgbColor);
    var l = ref.l;
    var a = ref.a;
    var b = ref.b;
    var h = Math.atan2(b, a) * rad2deg;
    return {
        h: h < 0 ? h + 360 : h,
        c: Math.sqrt(a * a + b * b),
        l: l,
        alpha: rgbColor.a
    };
}
function hclToRgb(hclColor) {
    var h = hclColor.h * deg2rad, c = hclColor.c, l = hclColor.l;
    return labToRgb({
        l: l,
        a: Math.cos(h) * c,
        b: Math.sin(h) * c,
        alpha: hclColor.alpha
    });
}
function interpolateHue(a, b, t) {
    var d = b - a;
    return a + t * (d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d);
}
function interpolateHcl(from, to, t) {
    return {
        h: interpolateHue(from.h, to.h, t),
        c: number(from.c, to.c, t),
        l: number(from.l, to.l, t),
        alpha: number(from.alpha, to.alpha, t)
    };
}
var lab = {
    forward: rgbToLab,
    reverse: labToRgb,
    interpolate: interpolateLab
};
var hcl = {
    forward: rgbToHcl,
    reverse: hclToRgb,
    interpolate: interpolateHcl
};

var colorSpaces = /*#__PURE__*/Object.freeze({
__proto__: null,
lab: lab,
hcl: hcl
});

var Interpolate = function Interpolate(type, operator, interpolation, input, stops) {
    this.type = type;
    this.operator = operator;
    this.interpolation = interpolation;
    this.input = input;
    this.labels = [];
    this.outputs = [];
    for (var i = 0, list = stops; i < list.length; i += 1) {
        var ref = list[i];
        var label = ref[0];
        var expression = ref[1];
        this.labels.push(label);
        this.outputs.push(expression);
    }
};
Interpolate.interpolationFactor = function interpolationFactor(interpolation, input, lower, upper) {
    var t = 0;
    if (interpolation.name === 'exponential') {
        t = exponentialInterpolation(input, interpolation.base, lower, upper);
    } else if (interpolation.name === 'linear') {
        t = exponentialInterpolation(input, 1, lower, upper);
    } else if (interpolation.name === 'cubic-bezier') {
        var c = interpolation.controlPoints;
        var ub = new unitbezier(c[0], c[1], c[2], c[3]);
        t = ub.solve(exponentialInterpolation(input, 1, lower, upper));
    }
    return t;
};
Interpolate.parse = function parse(args, context) {
    var operator = args[0];
    var interpolation = args[1];
    var input = args[2];
    var rest = args.slice(3);
    if (!Array.isArray(interpolation) || interpolation.length === 0) {
        return context.error('Expected an interpolation type expression.', 1);
    }
    if (interpolation[0] === 'linear') {
        interpolation = { name: 'linear' };
    } else if (interpolation[0] === 'exponential') {
        var base = interpolation[1];
        if (typeof base !== 'number') {
            return context.error('Exponential interpolation requires a numeric base.', 1, 1);
        }
        interpolation = {
            name: 'exponential',
            base: base
        };
    } else if (interpolation[0] === 'cubic-bezier') {
        var controlPoints = interpolation.slice(1);
        if (controlPoints.length !== 4 || controlPoints.some(function (t) {
                return typeof t !== 'number' || t < 0 || t > 1;
            })) {
            return context.error('Cubic bezier interpolation requires four numeric arguments with values between 0 and 1.', 1);
        }
        interpolation = {
            name: 'cubic-bezier',
            controlPoints: controlPoints
        };
    } else {
        return context.error('Unknown interpolation type ' + String(interpolation[0]), 1, 0);
    }
    if (args.length - 1 < 4) {
        return context.error('Expected at least 4 arguments, but found only ' + (args.length - 1) + '.');
    }
    if ((args.length - 1) % 2 !== 0) {
        return context.error('Expected an even number of arguments.');
    }
    input = context.parse(input, 2, NumberType);
    if (!input) {
        return null;
    }
    var stops = [];
    var outputType = null;
    if (operator === 'interpolate-hcl' || operator === 'interpolate-lab') {
        outputType = ColorType;
    } else if (context.expectedType && context.expectedType.kind !== 'value') {
        outputType = context.expectedType;
    }
    for (var i = 0; i < rest.length; i += 2) {
        var label = rest[i];
        var value = rest[i + 1];
        var labelKey = i + 3;
        var valueKey = i + 4;
        if (typeof label !== 'number') {
            return context.error('Input/output pairs for "interpolate" expressions must be defined using literal numeric values (not computed expressions) for the input values.', labelKey);
        }
        if (stops.length && stops[stops.length - 1][0] >= label) {
            return context.error('Input/output pairs for "interpolate" expressions must be arranged with input values in strictly ascending order.', labelKey);
        }
        var parsed = context.parse(value, valueKey, outputType);
        if (!parsed) {
            return null;
        }
        outputType = outputType || parsed.type;
        stops.push([
            label,
            parsed
        ]);
    }
    if (outputType.kind !== 'number' && outputType.kind !== 'color' && !(outputType.kind === 'array' && outputType.itemType.kind === 'number' && typeof outputType.N === 'number')) {
        return context.error('Type ' + toString(outputType) + ' is not interpolatable.');
    }
    return new Interpolate(outputType, operator, interpolation, input, stops);
};
Interpolate.prototype.evaluate = function evaluate(ctx) {
    var labels = this.labels;
    var outputs = this.outputs;
    if (labels.length === 1) {
        return outputs[0].evaluate(ctx);
    }
    var value = this.input.evaluate(ctx);
    if (value <= labels[0]) {
        return outputs[0].evaluate(ctx);
    }
    var stopCount = labels.length;
    if (value >= labels[stopCount - 1]) {
        return outputs[stopCount - 1].evaluate(ctx);
    }
    var index = findStopLessThanOrEqualTo(labels, value);
    var lower = labels[index];
    var upper = labels[index + 1];
    var t = Interpolate.interpolationFactor(this.interpolation, value, lower, upper);
    var outputLower = outputs[index].evaluate(ctx);
    var outputUpper = outputs[index + 1].evaluate(ctx);
    if (this.operator === 'interpolate') {
        return interpolate[this.type.kind.toLowerCase()](outputLower, outputUpper, t);
    } else if (this.operator === 'interpolate-hcl') {
        return hcl.reverse(hcl.interpolate(hcl.forward(outputLower), hcl.forward(outputUpper), t));
    } else {
        return lab.reverse(lab.interpolate(lab.forward(outputLower), lab.forward(outputUpper), t));
    }
};
Interpolate.prototype.eachChild = function eachChild(fn) {
    fn(this.input);
    for (var i = 0, list = this.outputs; i < list.length; i += 1) {
        var expression = list[i];
        fn(expression);
    }
};
Interpolate.prototype.outputDefined = function outputDefined() {
    return this.outputs.every(function (out) {
        return out.outputDefined();
    });
};
Interpolate.prototype.serialize = function serialize() {
    var interpolation;
    if (this.interpolation.name === 'linear') {
        interpolation = ['linear'];
    } else if (this.interpolation.name === 'exponential') {
        if (this.interpolation.base === 1) {
            interpolation = ['linear'];
        } else {
            interpolation = [
                'exponential',
                this.interpolation.base
            ];
        }
    } else {
        interpolation = ['cubic-bezier'].concat(this.interpolation.controlPoints);
    }
    var serialized = [
        this.operator,
        interpolation,
        this.input.serialize()
    ];
    for (var i = 0; i < this.labels.length; i++) {
        serialized.push(this.labels[i], this.outputs[i].serialize());
    }
    return serialized;
};
function exponentialInterpolation(input, base, lowerValue, upperValue) {
    var difference = upperValue - lowerValue;
    var progress = input - lowerValue;
    if (difference === 0) {
        return 0;
    } else if (base === 1) {
        return progress / difference;
    } else {
        return (Math.pow(base, progress) - 1) / (Math.pow(base, difference) - 1);
    }
}

var Coalesce = function Coalesce(type, args) {
    this.type = type;
    this.args = args;
};
Coalesce.parse = function parse(args, context) {
    if (args.length < 2) {
        return context.error('Expectected at least one argument.');
    }
    var outputType = null;
    var expectedType = context.expectedType;
    if (expectedType && expectedType.kind !== 'value') {
        outputType = expectedType;
    }
    var parsedArgs = [];
    for (var i = 0, list = args.slice(1); i < list.length; i += 1) {
        var arg = list[i];
        var parsed = context.parse(arg, 1 + parsedArgs.length, outputType, undefined, { typeAnnotation: 'omit' });
        if (!parsed) {
            return null;
        }
        outputType = outputType || parsed.type;
        parsedArgs.push(parsed);
    }
    var needsAnnotation = expectedType && parsedArgs.some(function (arg) {
        return checkSubtype(expectedType, arg.type);
    });
    return needsAnnotation ? new Coalesce(ValueType, parsedArgs) : new Coalesce(outputType, parsedArgs);
};
Coalesce.prototype.evaluate = function evaluate(ctx) {
    var result = null;
    var argCount = 0;
    var requestedImageName;
    for (var i = 0, list = this.args; i < list.length; i += 1) {
        var arg = list[i];
        argCount++;
        result = arg.evaluate(ctx);
        if (result && result instanceof ResolvedImage && !result.available) {
            if (!requestedImageName) {
                requestedImageName = result.name;
            }
            result = null;
            if (argCount === this.args.length) {
                result = requestedImageName;
            }
        }
        if (result !== null) {
            break;
        }
    }
    return result;
};
Coalesce.prototype.eachChild = function eachChild(fn) {
    this.args.forEach(fn);
};
Coalesce.prototype.outputDefined = function outputDefined() {
    return this.args.every(function (arg) {
        return arg.outputDefined();
    });
};
Coalesce.prototype.serialize = function serialize() {
    var serialized = ['coalesce'];
    this.eachChild(function (child) {
        serialized.push(child.serialize());
    });
    return serialized;
};

var Let = function Let(bindings, result) {
    this.type = result.type;
    this.bindings = [].concat(bindings);
    this.result = result;
};
Let.prototype.evaluate = function evaluate(ctx) {
    return this.result.evaluate(ctx);
};
Let.prototype.eachChild = function eachChild(fn) {
    for (var i = 0, list = this.bindings; i < list.length; i += 1) {
        var binding = list[i];
        fn(binding[1]);
    }
    fn(this.result);
};
Let.parse = function parse(args, context) {
    if (args.length < 4) {
        return context.error('Expected at least 3 arguments, but found ' + (args.length - 1) + ' instead.');
    }
    var bindings = [];
    for (var i = 1; i < args.length - 1; i += 2) {
        var name = args[i];
        if (typeof name !== 'string') {
            return context.error('Expected string, but found ' + typeof name + ' instead.', i);
        }
        if (/[^a-zA-Z0-9_]/.test(name)) {
            return context.error('Variable names must contain only alphanumeric characters or \'_\'.', i);
        }
        var value = context.parse(args[i + 1], i + 1);
        if (!value) {
            return null;
        }
        bindings.push([
            name,
            value
        ]);
    }
    var result = context.parse(args[args.length - 1], args.length - 1, context.expectedType, bindings);
    if (!result) {
        return null;
    }
    return new Let(bindings, result);
};
Let.prototype.outputDefined = function outputDefined() {
    return this.result.outputDefined();
};
Let.prototype.serialize = function serialize() {
    var serialized = ['let'];
    for (var i = 0, list = this.bindings; i < list.length; i += 1) {
        var ref = list[i];
        var name = ref[0];
        var expr = ref[1];
        serialized.push(name, expr.serialize());
    }
    serialized.push(this.result.serialize());
    return serialized;
};

var At = function At(type, index, input) {
    this.type = type;
    this.index = index;
    this.input = input;
};
At.parse = function parse(args, context) {
    if (args.length !== 3) {
        return context.error('Expected 2 arguments, but found ' + (args.length - 1) + ' instead.');
    }
    var index = context.parse(args[1], 1, NumberType);
    var input = context.parse(args[2], 2, array(context.expectedType || ValueType));
    if (!index || !input) {
        return null;
    }
    var t = input.type;
    return new At(t.itemType, index, input);
};
At.prototype.evaluate = function evaluate(ctx) {
    var index = this.index.evaluate(ctx);
    var array = this.input.evaluate(ctx);
    if (index < 0) {
        throw new RuntimeError('Array index out of bounds: ' + index + ' < 0.');
    }
    if (index >= array.length) {
        throw new RuntimeError('Array index out of bounds: ' + index + ' > ' + (array.length - 1) + '.');
    }
    if (index !== Math.floor(index)) {
        throw new RuntimeError('Array index must be an integer, but found ' + index + ' instead.');
    }
    return array[index];
};
At.prototype.eachChild = function eachChild(fn) {
    fn(this.index);
    fn(this.input);
};
At.prototype.outputDefined = function outputDefined() {
    return false;
};
At.prototype.serialize = function serialize() {
    return [
        'at',
        this.index.serialize(),
        this.input.serialize()
    ];
};

var In = function In(needle, haystack) {
    this.type = BooleanType;
    this.needle = needle;
    this.haystack = haystack;
};
In.parse = function parse(args, context) {
    if (args.length !== 3) {
        return context.error('Expected 2 arguments, but found ' + (args.length - 1) + ' instead.');
    }
    var needle = context.parse(args[1], 1, ValueType);
    var haystack = context.parse(args[2], 2, ValueType);
    if (!needle || !haystack) {
        return null;
    }
    if (!isValidType(needle.type, [
            BooleanType,
            StringType,
            NumberType,
            NullType,
            ValueType
        ])) {
        return context.error('Expected first argument to be of type boolean, string, number or null, but found ' + toString(needle.type) + ' instead');
    }
    return new In(needle, haystack);
};
In.prototype.evaluate = function evaluate(ctx) {
    var needle = this.needle.evaluate(ctx);
    var haystack = this.haystack.evaluate(ctx);
    if (!haystack) {
        return false;
    }
    if (!isValidNativeType(needle, [
            'boolean',
            'string',
            'number',
            'null'
        ])) {
        throw new RuntimeError('Expected first argument to be of type boolean, string, number or null, but found ' + toString(typeOf(needle)) + ' instead.');
    }
    if (!isValidNativeType(haystack, [
            'string',
            'array'
        ])) {
        throw new RuntimeError('Expected second argument to be of type array or string, but found ' + toString(typeOf(haystack)) + ' instead.');
    }
    return haystack.indexOf(needle) >= 0;
};
In.prototype.eachChild = function eachChild(fn) {
    fn(this.needle);
    fn(this.haystack);
};
In.prototype.outputDefined = function outputDefined() {
    return true;
};
In.prototype.serialize = function serialize() {
    return [
        'in',
        this.needle.serialize(),
        this.haystack.serialize()
    ];
};

var IndexOf = function IndexOf(needle, haystack, fromIndex) {
    this.type = NumberType;
    this.needle = needle;
    this.haystack = haystack;
    this.fromIndex = fromIndex;
};
IndexOf.parse = function parse(args, context) {
    if (args.length <= 2 || args.length >= 5) {
        return context.error('Expected 3 or 4 arguments, but found ' + (args.length - 1) + ' instead.');
    }
    var needle = context.parse(args[1], 1, ValueType);
    var haystack = context.parse(args[2], 2, ValueType);
    if (!needle || !haystack) {
        return null;
    }
    if (!isValidType(needle.type, [
            BooleanType,
            StringType,
            NumberType,
            NullType,
            ValueType
        ])) {
        return context.error('Expected first argument to be of type boolean, string, number or null, but found ' + toString(needle.type) + ' instead');
    }
    if (args.length === 4) {
        var fromIndex = context.parse(args[3], 3, NumberType);
        if (!fromIndex) {
            return null;
        }
        return new IndexOf(needle, haystack, fromIndex);
    } else {
        return new IndexOf(needle, haystack);
    }
};
IndexOf.prototype.evaluate = function evaluate(ctx) {
    var needle = this.needle.evaluate(ctx);
    var haystack = this.haystack.evaluate(ctx);
    if (!isValidNativeType(needle, [
            'boolean',
            'string',
            'number',
            'null'
        ])) {
        throw new RuntimeError('Expected first argument to be of type boolean, string, number or null, but found ' + toString(typeOf(needle)) + ' instead.');
    }
    if (!isValidNativeType(haystack, [
            'string',
            'array'
        ])) {
        throw new RuntimeError('Expected second argument to be of type array or string, but found ' + toString(typeOf(haystack)) + ' instead.');
    }
    if (this.fromIndex) {
        var fromIndex = this.fromIndex.evaluate(ctx);
        return haystack.indexOf(needle, fromIndex);
    }
    return haystack.indexOf(needle);
};
IndexOf.prototype.eachChild = function eachChild(fn) {
    fn(this.needle);
    fn(this.haystack);
    if (this.fromIndex) {
        fn(this.fromIndex);
    }
};
IndexOf.prototype.outputDefined = function outputDefined() {
    return false;
};
IndexOf.prototype.serialize = function serialize() {
    if (this.fromIndex != null && this.fromIndex !== undefined) {
        var fromIndex = this.fromIndex.serialize();
        return [
            'index-of',
            this.needle.serialize(),
            this.haystack.serialize(),
            fromIndex
        ];
    }
    return [
        'index-of',
        this.needle.serialize(),
        this.haystack.serialize()
    ];
};

var Match = function Match(inputType, outputType, input, cases, outputs, otherwise) {
    this.inputType = inputType;
    this.type = outputType;
    this.input = input;
    this.cases = cases;
    this.outputs = outputs;
    this.otherwise = otherwise;
};
Match.parse = function parse(args, context) {
    if (args.length < 5) {
        return context.error('Expected at least 4 arguments, but found only ' + (args.length - 1) + '.');
    }
    if (args.length % 2 !== 1) {
        return context.error('Expected an even number of arguments.');
    }
    var inputType;
    var outputType;
    if (context.expectedType && context.expectedType.kind !== 'value') {
        outputType = context.expectedType;
    }
    var cases = {};
    var outputs = [];
    for (var i = 2; i < args.length - 1; i += 2) {
        var labels = args[i];
        var value = args[i + 1];
        if (!Array.isArray(labels)) {
            labels = [labels];
        }
        var labelContext = context.concat(i);
        if (labels.length === 0) {
            return labelContext.error('Expected at least one branch label.');
        }
        for (var i$1 = 0, list = labels; i$1 < list.length; i$1 += 1) {
            var label = list[i$1];
            if (typeof label !== 'number' && typeof label !== 'string') {
                return labelContext.error('Branch labels must be numbers or strings.');
            } else if (typeof label === 'number' && Math.abs(label) > Number.MAX_SAFE_INTEGER) {
                return labelContext.error('Branch labels must be integers no larger than ' + Number.MAX_SAFE_INTEGER + '.');
            } else if (typeof label === 'number' && Math.floor(label) !== label) {
                return labelContext.error('Numeric branch labels must be integer values.');
            } else if (!inputType) {
                inputType = typeOf(label);
            } else if (labelContext.checkSubtype(inputType, typeOf(label))) {
                return null;
            }
            if (typeof cases[String(label)] !== 'undefined') {
                return labelContext.error('Branch labels must be unique.');
            }
            cases[String(label)] = outputs.length;
        }
        var result = context.parse(value, i, outputType);
        if (!result) {
            return null;
        }
        outputType = outputType || result.type;
        outputs.push(result);
    }
    var input = context.parse(args[1], 1, ValueType);
    if (!input) {
        return null;
    }
    var otherwise = context.parse(args[args.length - 1], args.length - 1, outputType);
    if (!otherwise) {
        return null;
    }
    if (input.type.kind !== 'value' && context.concat(1).checkSubtype(inputType, input.type)) {
        return null;
    }
    return new Match(inputType, outputType, input, cases, outputs, otherwise);
};
Match.prototype.evaluate = function evaluate(ctx) {
    var input = this.input.evaluate(ctx);
    var output = typeOf(input) === this.inputType && this.outputs[this.cases[input]] || this.otherwise;
    return output.evaluate(ctx);
};
Match.prototype.eachChild = function eachChild(fn) {
    fn(this.input);
    this.outputs.forEach(fn);
    fn(this.otherwise);
};
Match.prototype.outputDefined = function outputDefined() {
    return this.outputs.every(function (out) {
        return out.outputDefined();
    }) && this.otherwise.outputDefined();
};
Match.prototype.serialize = function serialize() {
    var this$1 = this;
    var serialized = [
        'match',
        this.input.serialize()
    ];
    var sortedLabels = Object.keys(this.cases).sort();
    var groupedByOutput = [];
    var outputLookup = {};
    for (var i = 0, list = sortedLabels; i < list.length; i += 1) {
        var label = list[i];
        var outputIndex = outputLookup[this.cases[label]];
        if (outputIndex === undefined) {
            outputLookup[this.cases[label]] = groupedByOutput.length;
            groupedByOutput.push([
                this.cases[label],
                [label]
            ]);
        } else {
            groupedByOutput[outputIndex][1].push(label);
        }
    }
    var coerceLabel = function (label) {
        return this$1.inputType.kind === 'number' ? Number(label) : label;
    };
    for (var i$1 = 0, list$1 = groupedByOutput; i$1 < list$1.length; i$1 += 1) {
        var ref = list$1[i$1];
        var outputIndex = ref[0];
        var labels = ref[1];
        if (labels.length === 1) {
            serialized.push(coerceLabel(labels[0]));
        } else {
            serialized.push(labels.map(coerceLabel));
        }
        serialized.push(this.outputs[outputIndex$1].serialize());
    }
    serialized.push(this.otherwise.serialize());
    return serialized;
};

var Case = function Case(type, branches, otherwise) {
    this.type = type;
    this.branches = branches;
    this.otherwise = otherwise;
};
Case.parse = function parse(args, context) {
    if (args.length < 4) {
        return context.error('Expected at least 3 arguments, but found only ' + (args.length - 1) + '.');
    }
    if (args.length % 2 !== 0) {
        return context.error('Expected an odd number of arguments.');
    }
    var outputType;
    if (context.expectedType && context.expectedType.kind !== 'value') {
        outputType = context.expectedType;
    }
    var branches = [];
    for (var i = 1; i < args.length - 1; i += 2) {
        var test = context.parse(args[i], i, BooleanType);
        if (!test) {
            return null;
        }
        var result = context.parse(args[i + 1], i + 1, outputType);
        if (!result) {
            return null;
        }
        branches.push([
            test,
            result
        ]);
        outputType = outputType || result.type;
    }
    var otherwise = context.parse(args[args.length - 1], args.length - 1, outputType);
    if (!otherwise) {
        return null;
    }
    return new Case(outputType, branches, otherwise);
};
Case.prototype.evaluate = function evaluate(ctx) {
    for (var i = 0, list = this.branches; i < list.length; i += 1) {
        var ref = list[i];
        var test = ref[0];
        var expression = ref[1];
        if (test.evaluate(ctx)) {
            return expression.evaluate(ctx);
        }
    }
    return this.otherwise.evaluate(ctx);
};
Case.prototype.eachChild = function eachChild(fn) {
    for (var i = 0, list = this.branches; i < list.length; i += 1) {
        var ref = list[i];
        var test = ref[0];
        var expression = ref[1];
        fn(test);
        fn(expression);
    }
    fn(this.otherwise);
};
Case.prototype.outputDefined = function outputDefined() {
    return this.branches.every(function (ref) {
        var _ = ref[0];
        var out = ref[1];
        return out.outputDefined();
    }) && this.otherwise.outputDefined();
};
Case.prototype.serialize = function serialize() {
    var serialized = ['case'];
    this.eachChild(function (child) {
        serialized.push(child.serialize());
    });
    return serialized;
};

var Slice = function Slice(type, input, beginIndex, endIndex) {
    this.type = type;
    this.input = input;
    this.beginIndex = beginIndex;
    this.endIndex = endIndex;
};
Slice.parse = function parse(args, context) {
    if (args.length <= 2 || args.length >= 5) {
        return context.error('Expected 3 or 4 arguments, but found ' + (args.length - 1) + ' instead.');
    }
    var input = context.parse(args[1], 1, ValueType);
    var beginIndex = context.parse(args[2], 2, NumberType);
    if (!input || !beginIndex) {
        return null;
    }
    if (!isValidType(input.type, [
            array(ValueType),
            StringType,
            ValueType
        ])) {
        return context.error('Expected first argument to be of type array or string, but found ' + toString(input.type) + ' instead');
    }
    if (args.length === 4) {
        var endIndex = context.parse(args[3], 3, NumberType);
        if (!endIndex) {
            return null;
        }
        return new Slice(input.type, input, beginIndex, endIndex);
    } else {
        return new Slice(input.type, input, beginIndex);
    }
};
Slice.prototype.evaluate = function evaluate(ctx) {
    var input = this.input.evaluate(ctx);
    var beginIndex = this.beginIndex.evaluate(ctx);
    if (!isValidNativeType(input, [
            'string',
            'array'
        ])) {
        throw new RuntimeError('Expected first argument to be of type array or string, but found ' + toString(typeOf(input)) + ' instead.');
    }
    if (this.endIndex) {
        var endIndex = this.endIndex.evaluate(ctx);
        return input.slice(beginIndex, endIndex);
    }
    return input.slice(beginIndex);
};
Slice.prototype.eachChild = function eachChild(fn) {
    fn(this.input);
    fn(this.beginIndex);
    if (this.endIndex) {
        fn(this.endIndex);
    }
};
Slice.prototype.outputDefined = function outputDefined() {
    return false;
};
Slice.prototype.serialize = function serialize() {
    if (this.endIndex != null && this.endIndex !== undefined) {
        var endIndex = this.endIndex.serialize();
        return [
            'slice',
            this.input.serialize(),
            this.beginIndex.serialize(),
            endIndex
        ];
    }
    return [
        'slice',
        this.input.serialize(),
        this.beginIndex.serialize()
    ];
};

function isComparableType(op, type) {
    if (op === '==' || op === '!=') {
        return type.kind === 'boolean' || type.kind === 'string' || type.kind === 'number' || type.kind === 'null' || type.kind === 'value';
    } else {
        return type.kind === 'string' || type.kind === 'number' || type.kind === 'value';
    }
}
function eq(ctx, a, b) {
    return a === b;
}
function neq(ctx, a, b) {
    return a !== b;
}
function lt(ctx, a, b) {
    return a < b;
}
function gt(ctx, a, b) {
    return a > b;
}
function lteq(ctx, a, b) {
    return a <= b;
}
function gteq(ctx, a, b) {
    return a >= b;
}
function eqCollate(ctx, a, b, c) {
    return c.compare(a, b) === 0;
}
function neqCollate(ctx, a, b, c) {
    return !eqCollate(ctx, a, b, c);
}
function ltCollate(ctx, a, b, c) {
    return c.compare(a, b) < 0;
}
function gtCollate(ctx, a, b, c) {
    return c.compare(a, b) > 0;
}
function lteqCollate(ctx, a, b, c) {
    return c.compare(a, b) <= 0;
}
function gteqCollate(ctx, a, b, c) {
    return c.compare(a, b) >= 0;
}
function makeComparison(op, compareBasic, compareWithCollator) {
    var isOrderComparison = op !== '==' && op !== '!=';
    return function () {
        function Comparison(lhs, rhs, collator) {
            this.type = BooleanType;
            this.lhs = lhs;
            this.rhs = rhs;
            this.collator = collator;
            this.hasUntypedArgument = lhs.type.kind === 'value' || rhs.type.kind === 'value';
        }
        Comparison.parse = function parse(args, context) {
            if (args.length !== 3 && args.length !== 4) {
                return context.error('Expected two or three arguments.');
            }
            var op = args[0];
            var lhs = context.parse(args[1], 1, ValueType);
            if (!lhs) {
                return null;
            }
            if (!isComparableType(op, lhs.type)) {
                return context.concat(1).error('"' + op + '" comparisons are not supported for type \'' + toString(lhs.type) + '\'.');
            }
            var rhs = context.parse(args[2], 2, ValueType);
            if (!rhs) {
                return null;
            }
            if (!isComparableType(op, rhs.type)) {
                return context.concat(2).error('"' + op + '" comparisons are not supported for type \'' + toString(rhs.type) + '\'.');
            }
            if (lhs.type.kind !== rhs.type.kind && lhs.type.kind !== 'value' && rhs.type.kind !== 'value') {
                return context.error('Cannot compare types \'' + toString(lhs.type) + '\' and \'' + toString(rhs.type) + '\'.');
            }
            if (isOrderComparison) {
                if (lhs.type.kind === 'value' && rhs.type.kind !== 'value') {
                    lhs = new Assertion(rhs.type, [lhs]);
                } else if (lhs.type.kind !== 'value' && rhs.type.kind === 'value') {
                    rhs = new Assertion(lhs.type, [rhs]);
                }
            }
            var collator = null;
            if (args.length === 4) {
                if (lhs.type.kind !== 'string' && rhs.type.kind !== 'string' && lhs.type.kind !== 'value' && rhs.type.kind !== 'value') {
                    return context.error('Cannot use collator to compare non-string types.');
                }
                collator = context.parse(args[3], 3, CollatorType);
                if (!collator) {
                    return null;
                }
            }
            return new Comparison(lhs, rhs, collator);
        };
        Comparison.prototype.evaluate = function evaluate(ctx) {
            var lhs = this.lhs.evaluate(ctx);
            var rhs = this.rhs.evaluate(ctx);
            if (isOrderComparison && this.hasUntypedArgument) {
                var lt = typeOf(lhs);
                var rt = typeOf(rhs);
                if (lt.kind !== rt.kind || !(lt.kind === 'string' || lt.kind === 'number')) {
                    throw new RuntimeError('Expected arguments for "' + op + '" to be (string, string) or (number, number), but found (' + lt.kind + ', ' + rt.kind + ') instead.');
                }
            }
            if (this.collator && !isOrderComparison && this.hasUntypedArgument) {
                var lt$1 = typeOf(lhs);
                var rt$1 = typeOf(rhs);
                if (lt$1.kind !== 'string' || rt$1.kind !== 'string') {
                    return compareBasic(ctx, lhs, rhs);
                }
            }
            return this.collator ? compareWithCollator(ctx, lhs, rhs, this.collator.evaluate(ctx)) : compareBasic(ctx, lhs, rhs);
        };
        Comparison.prototype.eachChild = function eachChild(fn) {
            fn(this.lhs);
            fn(this.rhs);
            if (this.collator) {
                fn(this.collator);
            }
        };
        Comparison.prototype.outputDefined = function outputDefined() {
            return true;
        };
        Comparison.prototype.serialize = function serialize() {
            var serialized = [op];
            this.eachChild(function (child) {
                serialized.push(child.serialize());
            });
            return serialized;
        };
        return Comparison;
    }();
}
var Equals = makeComparison('==', eq, eqCollate);
var NotEquals = makeComparison('!=', neq, neqCollate);
var LessThan = makeComparison('<', lt, ltCollate);
var GreaterThan = makeComparison('>', gt, gtCollate);
var LessThanOrEqual = makeComparison('<=', lteq, lteqCollate);
var GreaterThanOrEqual = makeComparison('>=', gteq, gteqCollate);

var NumberFormat = function NumberFormat(number, locale, currency, minFractionDigits, maxFractionDigits) {
    this.type = StringType;
    this.number = number;
    this.locale = locale;
    this.currency = currency;
    this.minFractionDigits = minFractionDigits;
    this.maxFractionDigits = maxFractionDigits;
};
NumberFormat.parse = function parse(args, context) {
    if (args.length !== 3) {
        return context.error('Expected two arguments.');
    }
    var number = context.parse(args[1], 1, NumberType);
    if (!number) {
        return null;
    }
    var options = args[2];
    if (typeof options !== 'object' || Array.isArray(options)) {
        return context.error('NumberFormat options argument must be an object.');
    }
    var locale = null;
    if (options['locale']) {
        locale = context.parse(options['locale'], 1, StringType);
        if (!locale) {
            return null;
        }
    }
    var currency = null;
    if (options['currency']) {
        currency = context.parse(options['currency'], 1, StringType);
        if (!currency) {
            return null;
        }
    }
    var minFractionDigits = null;
    if (options['min-fraction-digits']) {
        minFractionDigits = context.parse(options['min-fraction-digits'], 1, NumberType);
        if (!minFractionDigits) {
            return null;
        }
    }
    var maxFractionDigits = null;
    if (options['max-fraction-digits']) {
        maxFractionDigits = context.parse(options['max-fraction-digits'], 1, NumberType);
        if (!maxFractionDigits) {
            return null;
        }
    }
    return new NumberFormat(number, locale, currency, minFractionDigits, maxFractionDigits);
};
NumberFormat.prototype.evaluate = function evaluate(ctx) {
    return new Intl.NumberFormat(this.locale ? this.locale.evaluate(ctx) : [], {
        style: this.currency ? 'currency' : 'decimal',
        currency: this.currency ? this.currency.evaluate(ctx) : undefined,
        minimumFractionDigits: this.minFractionDigits ? this.minFractionDigits.evaluate(ctx) : undefined,
        maximumFractionDigits: this.maxFractionDigits ? this.maxFractionDigits.evaluate(ctx) : undefined
    }).format(this.number.evaluate(ctx));
};
NumberFormat.prototype.eachChild = function eachChild(fn) {
    fn(this.number);
    if (this.locale) {
        fn(this.locale);
    }
    if (this.currency) {
        fn(this.currency);
    }
    if (this.minFractionDigits) {
        fn(this.minFractionDigits);
    }
    if (this.maxFractionDigits) {
        fn(this.maxFractionDigits);
    }
};
NumberFormat.prototype.outputDefined = function outputDefined() {
    return false;
};
NumberFormat.prototype.serialize = function serialize() {
    var options = {};
    if (this.locale) {
        options['locale'] = this.locale.serialize();
    }
    if (this.currency) {
        options['currency'] = this.currency.serialize();
    }
    if (this.minFractionDigits) {
        options['min-fraction-digits'] = this.minFractionDigits.serialize();
    }
    if (this.maxFractionDigits) {
        options['max-fraction-digits'] = this.maxFractionDigits.serialize();
    }
    return [
        'number-format',
        this.number.serialize(),
        options
    ];
};

var Length = function Length(input) {
    this.type = NumberType;
    this.input = input;
};
Length.parse = function parse(args, context) {
    if (args.length !== 2) {
        return context.error('Expected 1 argument, but found ' + (args.length - 1) + ' instead.');
    }
    var input = context.parse(args[1], 1);
    if (!input) {
        return null;
    }
    if (input.type.kind !== 'array' && input.type.kind !== 'string' && input.type.kind !== 'value') {
        return context.error('Expected argument of type string or array, but found ' + toString(input.type) + ' instead.');
    }
    return new Length(input);
};
Length.prototype.evaluate = function evaluate(ctx) {
    var input = this.input.evaluate(ctx);
    if (typeof input === 'string') {
        return input.length;
    } else if (Array.isArray(input)) {
        return input.length;
    } else {
        throw new RuntimeError('Expected value to be of type string or array, but found ' + toString(typeOf(input)) + ' instead.');
    }
};
Length.prototype.eachChild = function eachChild(fn) {
    fn(this.input);
};
Length.prototype.outputDefined = function outputDefined() {
    return false;
};
Length.prototype.serialize = function serialize() {
    var serialized = ['length'];
    this.eachChild(function (child) {
        serialized.push(child.serialize());
    });
    return serialized;
};

var expressions = {
    '==': Equals,
    '!=': NotEquals,
    '>': GreaterThan,
    '<': LessThan,
    '>=': GreaterThanOrEqual,
    '<=': LessThanOrEqual,
    'array': Assertion,
    'at': At,
    'boolean': Assertion,
    'case': Case,
    'coalesce': Coalesce,
    'collator': CollatorExpression,
    'format': FormatExpression,
    'image': ImageExpression,
    'in': In,
    'index-of': IndexOf,
    'interpolate': Interpolate,
    'interpolate-hcl': Interpolate,
    'interpolate-lab': Interpolate,
    'length': Length,
    'let': Let,
    'literal': Literal,
    'match': Match,
    'number': Assertion,
    'number-format': NumberFormat,
    'object': Assertion,
    'slice': Slice,
    'step': Step,
    'string': Assertion,
    'to-boolean': Coercion,
    'to-color': Coercion,
    'to-number': Coercion,
    'to-string': Coercion,
    'var': Var,
    'within': Within
};
function rgba(ctx, ref) {
    var r = ref[0];
    var g = ref[1];
    var b = ref[2];
    var a = ref[3];
    r = r.evaluate(ctx);
    g = g.evaluate(ctx);
    b = b.evaluate(ctx);
    var alpha = a ? a.evaluate(ctx) : 1;
    var error = validateRGBA(r, g, b, alpha);
    if (error) {
        throw new RuntimeError(error);
    }
    return new Color(r / 255 * alpha, g / 255 * alpha, b / 255 * alpha, alpha);
}
function has(key, obj) {
    return key in obj;
}
function get(key, obj) {
    var v = obj[key];
    return typeof v === 'undefined' ? null : v;
}
function binarySearch(v, a, i, j) {
    while (i <= j) {
        var m = i + j >> 1;
        if (a[m] === v) {
            return true;
        }
        if (a[m] > v) {
            j = m - 1;
        } else {
            i = m + 1;
        }
    }
    return false;
}
function varargs(type) {
    return { type: type };
}
CompoundExpression.register(expressions, {
    'error': [
        ErrorType,
        [StringType],
        function (ctx, ref) {
            var v = ref[0];
            throw new RuntimeError(v.evaluate(ctx));
        }
    ],
    'typeof': [
        StringType,
        [ValueType],
        function (ctx, ref) {
            var v = ref[0];
            return toString(typeOf(v.evaluate(ctx)));
        }
    ],
    'to-rgba': [
        array(NumberType, 4),
        [ColorType],
        function (ctx, ref) {
            var v = ref[0];
            return v.evaluate(ctx).toArray();
        }
    ],
    'rgb': [
        ColorType,
        [
            NumberType,
            NumberType,
            NumberType
        ],
        rgba
    ],
    'rgba': [
        ColorType,
        [
            NumberType,
            NumberType,
            NumberType,
            NumberType
        ],
        rgba
    ],
    'has': {
        type: BooleanType,
        overloads: [
            [
                [StringType],
                function (ctx, ref) {
                    var key = ref[0];
                    return has(key.evaluate(ctx), ctx.properties());
                }
            ],
            [
                [
                    StringType,
                    ObjectType
                ],
                function (ctx, ref) {
                    var key = ref[0];
                    var obj = ref[1];
                    return has(key.evaluate(ctx), obj.evaluate(ctx));
                }
            ]
        ]
    },
    'get': {
        type: ValueType,
        overloads: [
            [
                [StringType],
                function (ctx, ref) {
                    var key = ref[0];
                    return get(key.evaluate(ctx), ctx.properties());
                }
            ],
            [
                [
                    StringType,
                    ObjectType
                ],
                function (ctx, ref) {
                    var key = ref[0];
                    var obj = ref[1];
                    return get(key.evaluate(ctx), obj.evaluate(ctx));
                }
            ]
        ]
    },
    'feature-state': [
        ValueType,
        [StringType],
        function (ctx, ref) {
            var key = ref[0];
            return get(key.evaluate(ctx), ctx.featureState || {});
        }
    ],
    'properties': [
        ObjectType,
        [],
        function (ctx) {
            return ctx.properties();
        }
    ],
    'geometry-type': [
        StringType,
        [],
        function (ctx) {
            return ctx.geometryType();
        }
    ],
    'id': [
        ValueType,
        [],
        function (ctx) {
            return ctx.id();
        }
    ],
    'zoom': [
        NumberType,
        [],
        function (ctx) {
            return ctx.globals.zoom;
        }
    ],
    'heatmap-density': [
        NumberType,
        [],
        function (ctx) {
            return ctx.globals.heatmapDensity || 0;
        }
    ],
    'line-progress': [
        NumberType,
        [],
        function (ctx) {
            return ctx.globals.lineProgress || 0;
        }
    ],
    'accumulated': [
        ValueType,
        [],
        function (ctx) {
            return ctx.globals.accumulated === undefined ? null : ctx.globals.accumulated;
        }
    ],
    '+': [
        NumberType,
        varargs(NumberType),
        function (ctx, args) {
            var result = 0;
            for (var i = 0, list = args; i < list.length; i += 1) {
                var arg = list[i];
                result += arg.evaluate(ctx);
            }
            return result;
        }
    ],
    '*': [
        NumberType,
        varargs(NumberType),
        function (ctx, args) {
            var result = 1;
            for (var i = 0, list = args; i < list.length; i += 1) {
                var arg = list[i];
                result *= arg.evaluate(ctx);
            }
            return result;
        }
    ],
    '-': {
        type: NumberType,
        overloads: [
            [
                [
                    NumberType,
                    NumberType
                ],
                function (ctx, ref) {
                    var a = ref[0];
                    var b = ref[1];
                    return a.evaluate(ctx) - b.evaluate(ctx);
                }
            ],
            [
                [NumberType],
                function (ctx, ref) {
                    var a = ref[0];
                    return -a.evaluate(ctx);
                }
            ]
        ]
    },
    '/': [
        NumberType,
        [
            NumberType,
            NumberType
        ],
        function (ctx, ref) {
            var a = ref[0];
            var b = ref[1];
            return a.evaluate(ctx) / b.evaluate(ctx);
        }
    ],
    '%': [
        NumberType,
        [
            NumberType,
            NumberType
        ],
        function (ctx, ref) {
            var a = ref[0];
            var b = ref[1];
            return a.evaluate(ctx) % b.evaluate(ctx);
        }
    ],
    'ln2': [
        NumberType,
        [],
        function () {
            return Math.LN2;
        }
    ],
    'pi': [
        NumberType,
        [],
        function () {
            return Math.PI;
        }
    ],
    'e': [
        NumberType,
        [],
        function () {
            return Math.E;
        }
    ],
    '^': [
        NumberType,
        [
            NumberType,
            NumberType
        ],
        function (ctx, ref) {
            var b = ref[0];
            var e = ref[1];
            return Math.pow(b.evaluate(ctx), e.evaluate(ctx));
        }
    ],
    'sqrt': [
        NumberType,
        [NumberType],
        function (ctx, ref) {
            var x = ref[0];
            return Math.sqrt(x.evaluate(ctx));
        }
    ],
    'log10': [
        NumberType,
        [NumberType],
        function (ctx, ref) {
            var n = ref[0];
            return Math.log(n.evaluate(ctx)) / Math.LN10;
        }
    ],
    'ln': [
        NumberType,
        [NumberType],
        function (ctx, ref) {
            var n = ref[0];
            return Math.log(n.evaluate(ctx));
        }
    ],
    'log2': [
        NumberType,
        [NumberType],
        function (ctx, ref) {
            var n = ref[0];
            return Math.log(n.evaluate(ctx)) / Math.LN2;
        }
    ],
    'sin': [
        NumberType,
        [NumberType],
        function (ctx, ref) {
            var n = ref[0];
            return Math.sin(n.evaluate(ctx));
        }
    ],
    'cos': [
        NumberType,
        [NumberType],
        function (ctx, ref) {
            var n = ref[0];
            return Math.cos(n.evaluate(ctx));
        }
    ],
    'tan': [
        NumberType,
        [NumberType],
        function (ctx, ref) {
            var n = ref[0];
            return Math.tan(n.evaluate(ctx));
        }
    ],
    'asin': [
        NumberType,
        [NumberType],
        function (ctx, ref) {
            var n = ref[0];
            return Math.asin(n.evaluate(ctx));
        }
    ],
    'acos': [
        NumberType,
        [NumberType],
        function (ctx, ref) {
            var n = ref[0];
            return Math.acos(n.evaluate(ctx));
        }
    ],
    'atan': [
        NumberType,
        [NumberType],
        function (ctx, ref) {
            var n = ref[0];
            return Math.atan(n.evaluate(ctx));
        }
    ],
    'min': [
        NumberType,
        varargs(NumberType),
        function (ctx, args) {
            return Math.min.apply(Math, args.map(function (arg) {
                return arg.evaluate(ctx);
            }));
        }
    ],
    'max': [
        NumberType,
        varargs(NumberType),
        function (ctx, args) {
            return Math.max.apply(Math, args.map(function (arg) {
                return arg.evaluate(ctx);
            }));
        }
    ],
    'abs': [
        NumberType,
        [NumberType],
        function (ctx, ref) {
            var n = ref[0];
            return Math.abs(n.evaluate(ctx));
        }
    ],
    'round': [
        NumberType,
        [NumberType],
        function (ctx, ref) {
            var n = ref[0];
            var v = n.evaluate(ctx);
            return v < 0 ? -Math.round(-v) : Math.round(v);
        }
    ],
    'floor': [
        NumberType,
        [NumberType],
        function (ctx, ref) {
            var n = ref[0];
            return Math.floor(n.evaluate(ctx));
        }
    ],
    'ceil': [
        NumberType,
        [NumberType],
        function (ctx, ref) {
            var n = ref[0];
            return Math.ceil(n.evaluate(ctx));
        }
    ],
    'filter-==': [
        BooleanType,
        [
            StringType,
            ValueType
        ],
        function (ctx, ref) {
            var k = ref[0];
            var v = ref[1];
            return ctx.properties()[k.value] === v.value;
        }
    ],
    'filter-id-==': [
        BooleanType,
        [ValueType],
        function (ctx, ref) {
            var v = ref[0];
            return ctx.id() === v.value;
        }
    ],
    'filter-type-==': [
        BooleanType,
        [StringType],
        function (ctx, ref) {
            var v = ref[0];
            return ctx.geometryType() === v.value;
        }
    ],
    'filter-<': [
        BooleanType,
        [
            StringType,
            ValueType
        ],
        function (ctx, ref) {
            var k = ref[0];
            var v = ref[1];
            var a = ctx.properties()[k.value];
            var b = v.value;
            return typeof a === typeof b && a < b;
        }
    ],
    'filter-id-<': [
        BooleanType,
        [ValueType],
        function (ctx, ref) {
            var v = ref[0];
            var a = ctx.id();
            var b = v.value;
            return typeof a === typeof b && a < b;
        }
    ],
    'filter->': [
        BooleanType,
        [
            StringType,
            ValueType
        ],
        function (ctx, ref) {
            var k = ref[0];
            var v = ref[1];
            var a = ctx.properties()[k.value];
            var b = v.value;
            return typeof a === typeof b && a > b;
        }
    ],
    'filter-id->': [
        BooleanType,
        [ValueType],
        function (ctx, ref) {
            var v = ref[0];
            var a = ctx.id();
            var b = v.value;
            return typeof a === typeof b && a > b;
        }
    ],
    'filter-<=': [
        BooleanType,
        [
            StringType,
            ValueType
        ],
        function (ctx, ref) {
            var k = ref[0];
            var v = ref[1];
            var a = ctx.properties()[k.value];
            var b = v.value;
            return typeof a === typeof b && a <= b;
        }
    ],
    'filter-id-<=': [
        BooleanType,
        [ValueType],
        function (ctx, ref) {
            var v = ref[0];
            var a = ctx.id();
            var b = v.value;
            return typeof a === typeof b && a <= b;
        }
    ],
    'filter->=': [
        BooleanType,
        [
            StringType,
            ValueType
        ],
        function (ctx, ref) {
            var k = ref[0];
            var v = ref[1];
            var a = ctx.properties()[k.value];
            var b = v.value;
            return typeof a === typeof b && a >= b;
        }
    ],
    'filter-id->=': [
        BooleanType,
        [ValueType],
        function (ctx, ref) {
            var v = ref[0];
            var a = ctx.id();
            var b = v.value;
            return typeof a === typeof b && a >= b;
        }
    ],
    'filter-has': [
        BooleanType,
        [ValueType],
        function (ctx, ref) {
            var k = ref[0];
            return k.value in ctx.properties();
        }
    ],
    'filter-has-id': [
        BooleanType,
        [],
        function (ctx) {
            return ctx.id() !== null && ctx.id() !== undefined;
        }
    ],
    'filter-type-in': [
        BooleanType,
        [array(StringType)],
        function (ctx, ref) {
            var v = ref[0];
            return v.value.indexOf(ctx.geometryType()) >= 0;
        }
    ],
    'filter-id-in': [
        BooleanType,
        [array(ValueType)],
        function (ctx, ref) {
            var v = ref[0];
            return v.value.indexOf(ctx.id()) >= 0;
        }
    ],
    'filter-in-small': [
        BooleanType,
        [
            StringType,
            array(ValueType)
        ],
        function (ctx, ref) {
            var k = ref[0];
            var v = ref[1];
            return v.value.indexOf(ctx.properties()[k.value]) >= 0;
        }
    ],
    'filter-in-large': [
        BooleanType,
        [
            StringType,
            array(ValueType)
        ],
        function (ctx, ref) {
            var k = ref[0];
            var v = ref[1];
            return binarySearch(ctx.properties()[k.value], v.value, 0, v.value.length - 1);
        }
    ],
    'all': {
        type: BooleanType,
        overloads: [
            [
                [
                    BooleanType,
                    BooleanType
                ],
                function (ctx, ref) {
                    var a = ref[0];
                    var b = ref[1];
                    return a.evaluate(ctx) && b.evaluate(ctx);
                }
            ],
            [
                varargs(BooleanType),
                function (ctx, args) {
                    for (var i = 0, list = args; i < list.length; i += 1) {
                        var arg = list[i];
                        if (!arg.evaluate(ctx)) {
                            return false;
                        }
                    }
                    return true;
                }
            ]
        ]
    },
    'any': {
        type: BooleanType,
        overloads: [
            [
                [
                    BooleanType,
                    BooleanType
                ],
                function (ctx, ref) {
                    var a = ref[0];
                    var b = ref[1];
                    return a.evaluate(ctx) || b.evaluate(ctx);
                }
            ],
            [
                varargs(BooleanType),
                function (ctx, args) {
                    for (var i = 0, list = args; i < list.length; i += 1) {
                        var arg = list[i];
                        if (arg.evaluate(ctx)) {
                            return true;
                        }
                    }
                    return false;
                }
            ]
        ]
    },
    '!': [
        BooleanType,
        [BooleanType],
        function (ctx, ref) {
            var b = ref[0];
            return !b.evaluate(ctx);
        }
    ],
    'is-supported-script': [
        BooleanType,
        [StringType],
        function (ctx, ref) {
            var s = ref[0];
            var isSupportedScript = ctx.globals && ctx.globals.isSupportedScript;
            if (isSupportedScript) {
                return isSupportedScript(s.evaluate(ctx));
            }
            return true;
        }
    ],
    'upcase': [
        StringType,
        [StringType],
        function (ctx, ref) {
            var s = ref[0];
            return s.evaluate(ctx).toUpperCase();
        }
    ],
    'downcase': [
        StringType,
        [StringType],
        function (ctx, ref) {
            var s = ref[0];
            return s.evaluate(ctx).toLowerCase();
        }
    ],
    'concat': [
        StringType,
        varargs(ValueType),
        function (ctx, args) {
            return args.map(function (arg) {
                return toString$1(arg.evaluate(ctx));
            }).join('');
        }
    ],
    'resolved-locale': [
        StringType,
        [CollatorType],
        function (ctx, ref) {
            var collator = ref[0];
            return collator.evaluate(ctx).resolvedLocale();
        }
    ]
});

function success(value) {
    return {
        result: 'success',
        value: value
    };
}
function error(value) {
    return {
        result: 'error',
        value: value
    };
}

function supportsPropertyExpression(spec) {
    return spec['property-type'] === 'data-driven' || spec['property-type'] === 'cross-faded-data-driven';
}
function supportsZoomExpression(spec) {
    return !!spec.expression && spec.expression.parameters.indexOf('zoom') > -1;
}
function supportsInterpolation(spec) {
    return !!spec.expression && spec.expression.interpolated;
}

function getType(val) {
    if (val instanceof Number) {
        return 'number';
    } else if (val instanceof String) {
        return 'string';
    } else if (val instanceof Boolean) {
        return 'boolean';
    } else if (Array.isArray(val)) {
        return 'array';
    } else if (val === null) {
        return 'null';
    } else {
        return typeof val;
    }
}

function isFunction(value) {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
}
function identityFunction(x) {
    return x;
}
function createFunction(parameters, propertySpec) {
    var isColor = propertySpec.type === 'color';
    var zoomAndFeatureDependent = parameters.stops && typeof parameters.stops[0][0] === 'object';
    var featureDependent = zoomAndFeatureDependent || parameters.property !== undefined;
    var zoomDependent = zoomAndFeatureDependent || !featureDependent;
    var type = parameters.type || (supportsInterpolation(propertySpec) ? 'exponential' : 'interval');
    if (isColor) {
        parameters = extend$1({}, parameters);
        if (parameters.stops) {
            parameters.stops = parameters.stops.map(function (stop) {
                return [
                    stop[0],
                    Color.parse(stop[1])
                ];
            });
        }
        if (parameters.default) {
            parameters.default = Color.parse(parameters.default);
        } else {
            parameters.default = Color.parse(propertySpec.default);
        }
    }
    if (parameters.colorSpace && parameters.colorSpace !== 'rgb' && !colorSpaces[parameters.colorSpace]) {
        throw new Error('Unknown color space: ' + parameters.colorSpace);
    }
    var innerFun;
    var hashedStops;
    var categoricalKeyType;
    if (type === 'exponential') {
        innerFun = evaluateExponentialFunction;
    } else if (type === 'interval') {
        innerFun = evaluateIntervalFunction;
    } else if (type === 'categorical') {
        innerFun = evaluateCategoricalFunction;
        hashedStops = Object.create(null);
        for (var i = 0, list = parameters.stops; i < list.length; i += 1) {
            var stop = list[i];
            hashedStops[stop[0]] = stop[1];
        }
        categoricalKeyType = typeof parameters.stops[0][0];
    } else if (type === 'identity') {
        innerFun = evaluateIdentityFunction;
    } else {
        throw new Error('Unknown function type "' + type + '"');
    }
    if (zoomAndFeatureDependent) {
        var featureFunctions = {};
        var zoomStops = [];
        for (var s = 0; s < parameters.stops.length; s++) {
            var stop$1 = parameters.stops[s];
            var zoom = stop$1[0].zoom;
            if (featureFunctions[zoom] === undefined) {
                featureFunctions[zoom] = {
                    zoom: zoom,
                    type: parameters.type,
                    property: parameters.property,
                    default: parameters.default,
                    stops: []
                };
                zoomStops.push(zoom);
            }
            featureFunctions[zoom].stops.push([
                stop$1[0].value,
                stop$1[1]
            ]);
        }
        var featureFunctionStops = [];
        for (var i$1 = 0, list$1 = zoomStops; i$1 < list$1.length; i$1 += 1) {
            var z = list$1[i$1];
            featureFunctionStops.push([
                featureFunctions[z].zoom,
                createFunction(featureFunctions[z], propertySpec)
            ]);
        }
        var interpolationType = { name: 'linear' };
        return {
            kind: 'composite',
            interpolationType: interpolationType,
            interpolationFactor: Interpolate.interpolationFactor.bind(undefined, interpolationType),
            zoomStops: featureFunctionStops.map(function (s) {
                return s[0];
            }),
            evaluate: function evaluate(ref, properties) {
                var zoom = ref.zoom;
                return evaluateExponentialFunction({
                    stops: featureFunctionStops,
                    base: parameters.base
                }, propertySpec, zoom).evaluate(zoom, properties);
            }
        };
    } else if (zoomDependent) {
        var interpolationType$1 = type === 'exponential' ? {
            name: 'exponential',
            base: parameters.base !== undefined ? parameters.base : 1
        } : null;
        return {
            kind: 'camera',
            interpolationType: interpolationType$1,
            interpolationFactor: Interpolate.interpolationFactor.bind(undefined, interpolationType$1),
            zoomStops: parameters.stops.map(function (s) {
                return s[0];
            }),
            evaluate: function (ref) {
                var zoom = ref.zoom;
                return innerFun(parameters, propertySpec, zoom, hashedStops, categoricalKeyType);
            }
        };
    } else {
        return {
            kind: 'source',
            evaluate: function evaluate(_, feature) {
                var value = feature && feature.properties ? feature.properties[parameters.property] : undefined;
                if (value === undefined) {
                    return coalesce(parameters.default, propertySpec.default);
                }
                return innerFun(parameters, propertySpec, value, hashedStops, categoricalKeyType);
            }
        };
    }
}
function coalesce(a, b, c) {
    if (a !== undefined) {
        return a;
    }
    if (b !== undefined) {
        return b;
    }
    if (c !== undefined) {
        return c;
    }
}
function evaluateCategoricalFunction(parameters, propertySpec, input, hashedStops, keyType) {
    var evaluated = typeof input === keyType ? hashedStops[input] : undefined;
    return coalesce(evaluated, parameters.default, propertySpec.default);
}
function evaluateIntervalFunction(parameters, propertySpec, input) {
    if (getType(input) !== 'number') {
        return coalesce(parameters.default, propertySpec.default);
    }
    var n = parameters.stops.length;
    if (n === 1) {
        return parameters.stops[0][1];
    }
    if (input <= parameters.stops[0][0]) {
        return parameters.stops[0][1];
    }
    if (input >= parameters.stops[n - 1][0]) {
        return parameters.stops[n - 1][1];
    }
    var index = findStopLessThanOrEqualTo(parameters.stops.map(function (stop) {
        return stop[0];
    }), input);
    return parameters.stops[index][1];
}
function evaluateExponentialFunction(parameters, propertySpec, input) {
    var base = parameters.base !== undefined ? parameters.base : 1;
    if (getType(input) !== 'number') {
        return coalesce(parameters.default, propertySpec.default);
    }
    var n = parameters.stops.length;
    if (n === 1) {
        return parameters.stops[0][1];
    }
    if (input <= parameters.stops[0][0]) {
        return parameters.stops[0][1];
    }
    if (input >= parameters.stops[n - 1][0]) {
        return parameters.stops[n - 1][1];
    }
    var index = findStopLessThanOrEqualTo(parameters.stops.map(function (stop) {
        return stop[0];
    }), input);
    var t = interpolationFactor(input, base, parameters.stops[index][0], parameters.stops[index + 1][0]);
    var outputLower = parameters.stops[index][1];
    var outputUpper = parameters.stops[index + 1][1];
    var interp = interpolate[propertySpec.type] || identityFunction;
    if (parameters.colorSpace && parameters.colorSpace !== 'rgb') {
        var colorspace = colorSpaces[parameters.colorSpace];
        interp = function (a, b) {
            return colorspace.reverse(colorspace.interpolate(colorspace.forward(a), colorspace.forward(b), t));
        };
    }
    if (typeof outputLower.evaluate === 'function') {
        return {
            evaluate: function evaluate() {
                var args = [], len = arguments.length;
                while (len--)
                    args[len] = arguments[len];
                var evaluatedLower = outputLower.evaluate.apply(undefined, args);
                var evaluatedUpper = outputUpper.evaluate.apply(undefined, args);
                if (evaluatedLower === undefined || evaluatedUpper === undefined) {
                    return undefined;
                }
                return interp(evaluatedLower, evaluatedUpper, t);
            }
        };
    }
    return interp(outputLower, outputUpper, t);
}
function evaluateIdentityFunction(parameters, propertySpec, input) {
    if (propertySpec.type === 'color') {
        input = Color.parse(input);
    } else if (propertySpec.type === 'formatted') {
        input = Formatted.fromString(input.toString());
    } else if (propertySpec.type === 'resolvedImage') {
        input = ResolvedImage.fromString(input.toString());
    } else if (getType(input) !== propertySpec.type && (propertySpec.type !== 'enum' || !propertySpec.values[input])) {
        input = undefined;
    }
    return coalesce(input, parameters.default, propertySpec.default);
}
function interpolationFactor(input, base, lowerValue, upperValue) {
    var difference = upperValue - lowerValue;
    var progress = input - lowerValue;
    if (difference === 0) {
        return 0;
    } else if (base === 1) {
        return progress / difference;
    } else {
        return (Math.pow(base, progress) - 1) / (Math.pow(base, difference) - 1);
    }
}

var StyleExpression = function StyleExpression(expression, propertySpec) {
    this.expression = expression;
    this._warningHistory = {};
    this._evaluator = new EvaluationContext();
    this._defaultValue = propertySpec ? getDefaultValue(propertySpec) : null;
    this._enumValues = propertySpec && propertySpec.type === 'enum' ? propertySpec.values : null;
};
StyleExpression.prototype.evaluateWithoutErrorHandling = function evaluateWithoutErrorHandling(globals, feature, featureState, canonical, availableImages, formattedSection) {
    this._evaluator.globals = globals;
    this._evaluator.feature = feature;
    this._evaluator.featureState = featureState;
    this._evaluator.canonical = canonical;
    this._evaluator.availableImages = availableImages || null;
    this._evaluator.formattedSection = formattedSection;
    return this.expression.evaluate(this._evaluator);
};
StyleExpression.prototype.evaluate = function evaluate(globals, feature, featureState, canonical, availableImages, formattedSection) {
    this._evaluator.globals = globals;
    this._evaluator.feature = feature || null;
    this._evaluator.featureState = featureState || null;
    this._evaluator.canonical = canonical;
    this._evaluator.availableImages = availableImages || null;
    this._evaluator.formattedSection = formattedSection || null;
    try {
        var val = this.expression.evaluate(this._evaluator);
        if (val === null || val === undefined || typeof val === 'number' && val !== val) {
            return this._defaultValue;
        }
        if (this._enumValues && !(val in this._enumValues)) {
            throw new RuntimeError('Expected value to be one of ' + Object.keys(this._enumValues).map(function (v) {
                return JSON.stringify(v);
            }).join(', ') + ', but found ' + JSON.stringify(val) + ' instead.');
        }
        return val;
    } catch (e) {
        if (!this._warningHistory[e.message]) {
            this._warningHistory[e.message] = true;
            if (typeof console !== 'undefined') {
                console.warn(e.message);
            }
        }
        return this._defaultValue;
    }
};
function isExpression(expression) {
    return Array.isArray(expression) && expression.length > 0 && typeof expression[0] === 'string' && expression[0] in expressions;
}
function createExpression(expression, propertySpec) {
    var parser = new ParsingContext(expressions, [], propertySpec ? getExpectedType(propertySpec) : undefined);
    var parsed = parser.parse(expression, undefined, undefined, undefined, propertySpec && propertySpec.type === 'string' ? { typeAnnotation: 'coerce' } : undefined);
    if (!parsed) {
        return error(parser.errors);
    }
    return success(new StyleExpression(parsed, propertySpec));
}
var ZoomConstantExpression = function ZoomConstantExpression(kind, expression) {
    this.kind = kind;
    this._styleExpression = expression;
    this.isStateDependent = kind !== 'constant' && !isStateConstant(expression.expression);
};
ZoomConstantExpression.prototype.evaluateWithoutErrorHandling = function evaluateWithoutErrorHandling(globals, feature, featureState, canonical, availableImages, formattedSection) {
    return this._styleExpression.evaluateWithoutErrorHandling(globals, feature, featureState, canonical, availableImages, formattedSection);
};
ZoomConstantExpression.prototype.evaluate = function evaluate(globals, feature, featureState, canonical, availableImages, formattedSection) {
    return this._styleExpression.evaluate(globals, feature, featureState, canonical, availableImages, formattedSection);
};
var ZoomDependentExpression = function ZoomDependentExpression(kind, expression, zoomStops, interpolationType) {
    this.kind = kind;
    this.zoomStops = zoomStops;
    this._styleExpression = expression;
    this.isStateDependent = kind !== 'camera' && !isStateConstant(expression.expression);
    this.interpolationType = interpolationType;
};
ZoomDependentExpression.prototype.evaluateWithoutErrorHandling = function evaluateWithoutErrorHandling(globals, feature, featureState, canonical, availableImages, formattedSection) {
    return this._styleExpression.evaluateWithoutErrorHandling(globals, feature, featureState, canonical, availableImages, formattedSection);
};
ZoomDependentExpression.prototype.evaluate = function evaluate(globals, feature, featureState, canonical, availableImages, formattedSection) {
    return this._styleExpression.evaluate(globals, feature, featureState, canonical, availableImages, formattedSection);
};
ZoomDependentExpression.prototype.interpolationFactor = function interpolationFactor(input, lower, upper) {
    if (this.interpolationType) {
        return Interpolate.interpolationFactor(this.interpolationType, input, lower, upper);
    } else {
        return 0;
    }
};
function createPropertyExpression(expression, propertySpec) {
    expression = createExpression(expression, propertySpec);
    if (expression.result === 'error') {
        return expression;
    }
    var parsed = expression.value.expression;
    var isFeatureConstant$1 = isFeatureConstant(parsed);
    if (!isFeatureConstant$1 && !supportsPropertyExpression(propertySpec)) {
        return error([new ParsingError('', 'data expressions not supported')]);
    }
    var isZoomConstant = isGlobalPropertyConstant(parsed, ['zoom']);
    if (!isZoomConstant && !supportsZoomExpression(propertySpec)) {
        return error([new ParsingError('', 'zoom expressions not supported')]);
    }
    var zoomCurve = findZoomCurve(parsed);
    if (!zoomCurve && !isZoomConstant) {
        return error([new ParsingError('', '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.')]);
    } else if (zoomCurve instanceof ParsingError) {
        return error([zoomCurve]);
    } else if (zoomCurve instanceof Interpolate && !supportsInterpolation(propertySpec)) {
        return error([new ParsingError('', '"interpolate" expressions cannot be used with this property')]);
    }
    if (!zoomCurve) {
        return success(isFeatureConstant$1 ? new ZoomConstantExpression('constant', expression.value) : new ZoomConstantExpression('source', expression.value));
    }
    var interpolationType = zoomCurve instanceof Interpolate ? zoomCurve.interpolation : undefined;
    return success(isFeatureConstant$1 ? new ZoomDependentExpression('camera', expression.value, zoomCurve.labels, interpolationType) : new ZoomDependentExpression('composite', expression.value, zoomCurve.labels, interpolationType));
}
var StylePropertyFunction = function StylePropertyFunction(parameters, specification) {
    this._parameters = parameters;
    this._specification = specification;
    extend$1(this, createFunction(this._parameters, this._specification));
};
StylePropertyFunction.deserialize = function deserialize(serialized) {
    return new StylePropertyFunction(serialized._parameters, serialized._specification);
};
StylePropertyFunction.serialize = function serialize(input) {
    return {
        _parameters: input._parameters,
        _specification: input._specification
    };
};
function normalizePropertyExpression(value, specification) {
    if (isFunction(value)) {
        return new StylePropertyFunction(value, specification);
    } else if (isExpression(value)) {
        var expression = createPropertyExpression(value, specification);
        if (expression.result === 'error') {
            throw new Error(expression.value.map(function (err) {
                return err.key + ': ' + err.message;
            }).join(', '));
        }
        return expression.value;
    } else {
        var constant = value;
        if (typeof value === 'string' && specification.type === 'color') {
            constant = Color.parse(value);
        }
        return {
            kind: 'constant',
            evaluate: function () {
                return constant;
            }
        };
    }
}
function findZoomCurve(expression) {
    var result = null;
    if (expression instanceof Let) {
        result = findZoomCurve(expression.result);
    } else if (expression instanceof Coalesce) {
        for (var i = 0, list = expression.args; i < list.length; i += 1) {
            var arg = list[i];
            result = findZoomCurve(arg);
            if (result) {
                break;
            }
        }
    } else if ((expression instanceof Step || expression instanceof Interpolate) && expression.input instanceof CompoundExpression && expression.input.name === 'zoom') {
        result = expression;
    }
    if (result instanceof ParsingError) {
        return result;
    }
    expression.eachChild(function (child) {
        var childResult = findZoomCurve(child);
        if (childResult instanceof ParsingError) {
            result = childResult;
        } else if (!result && childResult) {
            result = new ParsingError('', '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.');
        } else if (result && childResult && result !== childResult) {
            result = new ParsingError('', 'Only one zoom-based "step" or "interpolate" subexpression may be used in an expression.');
        }
    });
    return result;
}
function getExpectedType(spec) {
    var types = {
        color: ColorType,
        string: StringType,
        number: NumberType,
        enum: StringType,
        boolean: BooleanType,
        formatted: FormattedType,
        resolvedImage: ResolvedImageType
    };
    if (spec.type === 'array') {
        return array(types[spec.value] || ValueType, spec.length);
    }
    return types[spec.type];
}
function getDefaultValue(spec) {
    if (spec.type === 'color' && isFunction(spec.default)) {
        return new Color(0, 0, 0, 0);
    } else if (spec.type === 'color') {
        return Color.parse(spec.default) || null;
    } else if (spec.default === undefined) {
        return null;
    } else {
        return spec.default;
    }
}

function validateObject(options) {
    var key = options.key;
    var object = options.value;
    var elementSpecs = options.valueSpec || {};
    var elementValidators = options.objectElementValidators || {};
    var style = options.style;
    var styleSpec = options.styleSpec;
    var errors = [];
    var type = getType(object);
    if (type !== 'object') {
        return [new ValidationError(key, object, 'object expected, ' + type + ' found')];
    }
    for (var objectKey in object) {
        var elementSpecKey = objectKey.split('.')[0];
        var elementSpec = elementSpecs[elementSpecKey] || elementSpecs['*'];
        var validateElement = void 0;
        if (elementValidators[elementSpecKey]) {
            validateElement = elementValidators[elementSpecKey];
        } else if (elementSpecs[elementSpecKey]) {
            validateElement = validate;
        } else if (elementValidators['*']) {
            validateElement = elementValidators['*'];
        } else if (elementSpecs['*']) {
            validateElement = validate;
        } else {
            errors.push(new ValidationError(key, object[objectKey], 'unknown property "' + objectKey + '"'));
            continue;
        }
        errors = errors.concat(validateElement({
            key: (key ? key + '.' : key) + objectKey,
            value: object[objectKey],
            valueSpec: elementSpec,
            style: style,
            styleSpec: styleSpec,
            object: object,
            objectKey: objectKey
        }, object));
    }
    for (var elementSpecKey$1 in elementSpecs) {
        if (elementValidators[elementSpecKey$1]) {
            continue;
        }
        if (elementSpecs[elementSpecKey$1].required && elementSpecs[elementSpecKey$1]['default'] === undefined && object[elementSpecKey$1] === undefined) {
            errors.push(new ValidationError(key, object, 'missing required property "' + elementSpecKey$1 + '"'));
        }
    }
    return errors;
}

function validateArray(options) {
    var array = options.value;
    var arraySpec = options.valueSpec;
    var style = options.style;
    var styleSpec = options.styleSpec;
    var key = options.key;
    var validateArrayElement = options.arrayElementValidator || validate;
    if (getType(array) !== 'array') {
        return [new ValidationError(key, array, 'array expected, ' + getType(array) + ' found')];
    }
    if (arraySpec.length && array.length !== arraySpec.length) {
        return [new ValidationError(key, array, 'array length ' + arraySpec.length + ' expected, length ' + array.length + ' found')];
    }
    if (arraySpec['min-length'] && array.length < arraySpec['min-length']) {
        return [new ValidationError(key, array, 'array length at least ' + arraySpec['min-length'] + ' expected, length ' + array.length + ' found')];
    }
    var arrayElementSpec = {
        'type': arraySpec.value,
        'values': arraySpec.values
    };
    if (styleSpec.$version < 7) {
        arrayElementSpec.function = arraySpec.function;
    }
    if (getType(arraySpec.value) === 'object') {
        arrayElementSpec = arraySpec.value;
    }
    var errors = [];
    for (var i = 0; i < array.length; i++) {
        errors = errors.concat(validateArrayElement({
            array: array,
            arrayIndex: i,
            value: array[i],
            valueSpec: arrayElementSpec,
            style: style,
            styleSpec: styleSpec,
            key: key + '[' + i + ']'
        }));
    }
    return errors;
}

function validateNumber(options) {
    var key = options.key;
    var value = options.value;
    var valueSpec = options.valueSpec;
    var type = getType(value);
    if (type === 'number' && value !== value) {
        type = 'NaN';
    }
    if (type !== 'number') {
        return [new ValidationError(key, value, 'number expected, ' + type + ' found')];
    }
    if ('minimum' in valueSpec && value < valueSpec.minimum) {
        return [new ValidationError(key, value, value + ' is less than the minimum value ' + valueSpec.minimum)];
    }
    if ('maximum' in valueSpec && value > valueSpec.maximum) {
        return [new ValidationError(key, value, value + ' is greater than the maximum value ' + valueSpec.maximum)];
    }
    return [];
}

function validateFunction(options) {
    var functionValueSpec = options.valueSpec;
    var functionType = unbundle(options.value.type);
    var stopKeyType;
    var stopDomainValues = {};
    var previousStopDomainValue;
    var previousStopDomainZoom;
    var isZoomFunction = functionType !== 'categorical' && options.value.property === undefined;
    var isPropertyFunction = !isZoomFunction;
    var isZoomAndPropertyFunction = getType(options.value.stops) === 'array' && getType(options.value.stops[0]) === 'array' && getType(options.value.stops[0][0]) === 'object';
    var errors = validateObject({
        key: options.key,
        value: options.value,
        valueSpec: options.styleSpec.function,
        style: options.style,
        styleSpec: options.styleSpec,
        objectElementValidators: {
            stops: validateFunctionStops,
            default: validateFunctionDefault
        }
    });
    if (functionType === 'identity' && isZoomFunction) {
        errors.push(new ValidationError(options.key, options.value, 'missing required property "property"'));
    }
    if (functionType !== 'identity' && !options.value.stops) {
        errors.push(new ValidationError(options.key, options.value, 'missing required property "stops"'));
    }
    if (functionType === 'exponential' && options.valueSpec.expression && !supportsInterpolation(options.valueSpec)) {
        errors.push(new ValidationError(options.key, options.value, 'exponential functions not supported'));
    }
    if (options.styleSpec.$version >= 8) {
        if (isPropertyFunction && !supportsPropertyExpression(options.valueSpec)) {
            errors.push(new ValidationError(options.key, options.value, 'property functions not supported'));
        } else if (isZoomFunction && !supportsZoomExpression(options.valueSpec)) {
            errors.push(new ValidationError(options.key, options.value, 'zoom functions not supported'));
        }
    }
    if ((functionType === 'categorical' || isZoomAndPropertyFunction) && options.value.property === undefined) {
        errors.push(new ValidationError(options.key, options.value, '"property" property is required'));
    }
    return errors;
    function validateFunctionStops(options) {
        if (functionType === 'identity') {
            return [new ValidationError(options.key, options.value, 'identity function may not have a "stops" property')];
        }
        var errors = [];
        var value = options.value;
        errors = errors.concat(validateArray({
            key: options.key,
            value: value,
            valueSpec: options.valueSpec,
            style: options.style,
            styleSpec: options.styleSpec,
            arrayElementValidator: validateFunctionStop
        }));
        if (getType(value) === 'array' && value.length === 0) {
            errors.push(new ValidationError(options.key, value, 'array must have at least one stop'));
        }
        return errors;
    }
    function validateFunctionStop(options) {
        var errors = [];
        var value = options.value;
        var key = options.key;
        if (getType(value) !== 'array') {
            return [new ValidationError(key, value, 'array expected, ' + getType(value) + ' found')];
        }
        if (value.length !== 2) {
            return [new ValidationError(key, value, 'array length 2 expected, length ' + value.length + ' found')];
        }
        if (isZoomAndPropertyFunction) {
            if (getType(value[0]) !== 'object') {
                return [new ValidationError(key, value, 'object expected, ' + getType(value[0]) + ' found')];
            }
            if (value[0].zoom === undefined) {
                return [new ValidationError(key, value, 'object stop key must have zoom')];
            }
            if (value[0].value === undefined) {
                return [new ValidationError(key, value, 'object stop key must have value')];
            }
            if (previousStopDomainZoom && previousStopDomainZoom > unbundle(value[0].zoom)) {
                return [new ValidationError(key, value[0].zoom, 'stop zoom values must appear in ascending order')];
            }
            if (unbundle(value[0].zoom) !== previousStopDomainZoom) {
                previousStopDomainZoom = unbundle(value[0].zoom);
                previousStopDomainValue = undefined;
                stopDomainValues = {};
            }
            errors = errors.concat(validateObject({
                key: key + '[0]',
                value: value[0],
                valueSpec: { zoom: {} },
                style: options.style,
                styleSpec: options.styleSpec,
                objectElementValidators: {
                    zoom: validateNumber,
                    value: validateStopDomainValue
                }
            }));
        } else {
            errors = errors.concat(validateStopDomainValue({
                key: key + '[0]',
                value: value[0],
                valueSpec: {},
                style: options.style,
                styleSpec: options.styleSpec
            }, value));
        }
        if (isExpression(deepUnbundle(value[1]))) {
            return errors.concat([new ValidationError(key + '[1]', value[1], 'expressions are not allowed in function stops.')]);
        }
        return errors.concat(validate({
            key: key + '[1]',
            value: value[1],
            valueSpec: functionValueSpec,
            style: options.style,
            styleSpec: options.styleSpec
        }));
    }
    function validateStopDomainValue(options, stop) {
        var type = getType(options.value);
        var value = unbundle(options.value);
        var reportValue = options.value !== null ? options.value : stop;
        if (!stopKeyType) {
            stopKeyType = type;
        } else if (type !== stopKeyType) {
            return [new ValidationError(options.key, reportValue, type + ' stop domain type must match previous stop domain type ' + stopKeyType)];
        }
        if (type !== 'number' && type !== 'string' && type !== 'boolean') {
            return [new ValidationError(options.key, reportValue, 'stop domain value must be a number, string, or boolean')];
        }
        if (type !== 'number' && functionType !== 'categorical') {
            var message = 'number expected, ' + type + ' found';
            if (supportsPropertyExpression(functionValueSpec) && functionType === undefined) {
                message += '\nIf you intended to use a categorical function, specify `"type": "categorical"`.';
            }
            return [new ValidationError(options.key, reportValue, message)];
        }
        if (functionType === 'categorical' && type === 'number' && (!isFinite(value) || Math.floor(value) !== value)) {
            return [new ValidationError(options.key, reportValue, 'integer expected, found ' + value)];
        }
        if (functionType !== 'categorical' && type === 'number' && previousStopDomainValue !== undefined && value < previousStopDomainValue) {
            return [new ValidationError(options.key, reportValue, 'stop domain values must appear in ascending order')];
        } else {
            previousStopDomainValue = value;
        }
        if (functionType === 'categorical' && value in stopDomainValues) {
            return [new ValidationError(options.key, reportValue, 'stop domain values must be unique')];
        } else {
            stopDomainValues[value] = true;
        }
        return [];
    }
    function validateFunctionDefault(options) {
        return validate({
            key: options.key,
            value: options.value,
            valueSpec: functionValueSpec,
            style: options.style,
            styleSpec: options.styleSpec
        });
    }
}

function validateExpression(options) {
    var expression = (options.expressionContext === 'property' ? createPropertyExpression : createExpression)(deepUnbundle(options.value), options.valueSpec);
    if (expression.result === 'error') {
        return expression.value.map(function (error) {
            return new ValidationError('' + options.key + error.key, options.value, error.message);
        });
    }
    var expressionObj = expression.value.expression || expression.value._styleExpression.expression;
    if (options.expressionContext === 'property' && options.propertyKey === 'text-font' && !expressionObj.outputDefined()) {
        return [new ValidationError(options.key, options.value, 'Invalid data expression for "' + options.propertyKey + '". Output values must be contained as literals within the expression.')];
    }
    if (options.expressionContext === 'property' && options.propertyType === 'layout' && !isStateConstant(expressionObj)) {
        return [new ValidationError(options.key, options.value, '"feature-state" data expressions are not supported with layout properties.')];
    }
    if (options.expressionContext === 'filter' && !isStateConstant(expressionObj)) {
        return [new ValidationError(options.key, options.value, '"feature-state" data expressions are not supported with filters.')];
    }
    if (options.expressionContext && options.expressionContext.indexOf('cluster') === 0) {
        if (!isGlobalPropertyConstant(expressionObj, [
                'zoom',
                'feature-state'
            ])) {
            return [new ValidationError(options.key, options.value, '"zoom" and "feature-state" expressions are not supported with cluster properties.')];
        }
        if (options.expressionContext === 'cluster-initial' && !isFeatureConstant(expressionObj)) {
            return [new ValidationError(options.key, options.value, 'Feature data expressions are not supported with initial expression part of cluster properties.')];
        }
    }
    return [];
}

function validateBoolean(options) {
    var value = options.value;
    var key = options.key;
    var type = getType(value);
    if (type !== 'boolean') {
        return [new ValidationError(key, value, 'boolean expected, ' + type + ' found')];
    }
    return [];
}

function validateColor(options) {
    var key = options.key;
    var value = options.value;
    var type = getType(value);
    if (type !== 'string') {
        return [new ValidationError(key, value, 'color expected, ' + type + ' found')];
    }
    if (csscolorparser_1(value) === null) {
        return [new ValidationError(key, value, 'color expected, "' + value + '" found')];
    }
    return [];
}

function validateEnum(options) {
    var key = options.key;
    var value = options.value;
    var valueSpec = options.valueSpec;
    var errors = [];
    if (Array.isArray(valueSpec.values)) {
        if (valueSpec.values.indexOf(unbundle(value)) === -1) {
            errors.push(new ValidationError(key, value, 'expected one of [' + valueSpec.values.join(', ') + '], ' + JSON.stringify(value) + ' found'));
        }
    } else {
        if (Object.keys(valueSpec.values).indexOf(unbundle(value)) === -1) {
            errors.push(new ValidationError(key, value, 'expected one of [' + Object.keys(valueSpec.values).join(', ') + '], ' + JSON.stringify(value) + ' found'));
        }
    }
    return errors;
}

function isExpressionFilter(filter) {
    if (filter === true || filter === false) {
        return true;
    }
    if (!Array.isArray(filter) || filter.length === 0) {
        return false;
    }
    switch (filter[0]) {
    case 'has':
        return filter.length >= 2 && filter[1] !== '$id' && filter[1] !== '$type';
    case 'in':
        return filter.length >= 3 && (typeof filter[1] !== 'string' || Array.isArray(filter[2]));
    case '!in':
    case '!has':
    case 'none':
        return false;
    case '==':
    case '!=':
    case '>':
    case '>=':
    case '<':
    case '<=':
        return filter.length !== 3 || (Array.isArray(filter[1]) || Array.isArray(filter[2]));
    case 'any':
    case 'all':
        for (var i = 0, list = filter.slice(1); i < list.length; i += 1) {
            var f = list[i];
            if (!isExpressionFilter(f) && typeof f !== 'boolean') {
                return false;
            }
        }
        return true;
    default:
        return true;
    }
}
var filterSpec = {
    'type': 'boolean',
    'default': false,
    'transition': false,
    'property-type': 'data-driven',
    'expression': {
        'interpolated': false,
        'parameters': [
            'zoom',
            'feature'
        ]
    }
};
function createFilter(filter) {
    if (filter === null || filter === undefined) {
        return {
            filter: function () {
                return true;
            },
            needGeometry: false
        };
    }
    if (!isExpressionFilter(filter)) {
        filter = convertFilter(filter);
    }
    var compiled = createExpression(filter, filterSpec);
    if (compiled.result === 'error') {
        throw new Error(compiled.value.map(function (err) {
            return err.key + ': ' + err.message;
        }).join(', '));
    } else {
        var needGeometry = geometryNeeded(filter);
        return {
            filter: function (globalProperties, feature, canonical) {
                return compiled.value.evaluate(globalProperties, feature, {}, canonical);
            },
            needGeometry: needGeometry
        };
    }
}
function compare(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
}
function geometryNeeded(filter) {
    if (!Array.isArray(filter)) {
        return false;
    }
    if (filter[0] === 'within') {
        return true;
    }
    for (var index = 1; index < filter.length; index++) {
        if (geometryNeeded(filter[index])) {
            return true;
        }
    }
    return false;
}
function convertFilter(filter) {
    if (!filter) {
        return true;
    }
    var op = filter[0];
    if (filter.length <= 1) {
        return op !== 'any';
    }
    var converted = op === '==' ? convertComparisonOp(filter[1], filter[2], '==') : op === '!=' ? convertNegation(convertComparisonOp(filter[1], filter[2], '==')) : op === '<' || op === '>' || op === '<=' || op === '>=' ? convertComparisonOp(filter[1], filter[2], op) : op === 'any' ? convertDisjunctionOp(filter.slice(1)) : op === 'all' ? ['all'].concat(filter.slice(1).map(convertFilter)) : op === 'none' ? ['all'].concat(filter.slice(1).map(convertFilter).map(convertNegation)) : op === 'in' ? convertInOp(filter[1], filter.slice(2)) : op === '!in' ? convertNegation(convertInOp(filter[1], filter.slice(2))) : op === 'has' ? convertHasOp(filter[1]) : op === '!has' ? convertNegation(convertHasOp(filter[1])) : op === 'within' ? filter : true;
    return converted;
}
function convertComparisonOp(property, value, op) {
    switch (property) {
    case '$type':
        return [
            'filter-type-' + op,
            value
        ];
    case '$id':
        return [
            'filter-id-' + op,
            value
        ];
    default:
        return [
            'filter-' + op,
            property,
            value
        ];
    }
}
function convertDisjunctionOp(filters) {
    return ['any'].concat(filters.map(convertFilter));
}
function convertInOp(property, values) {
    if (values.length === 0) {
        return false;
    }
    switch (property) {
    case '$type':
        return [
            'filter-type-in',
            [
                'literal',
                values
            ]
        ];
    case '$id':
        return [
            'filter-id-in',
            [
                'literal',
                values
            ]
        ];
    default:
        if (values.length > 200 && !values.some(function (v) {
                return typeof v !== typeof values[0];
            })) {
            return [
                'filter-in-large',
                property,
                [
                    'literal',
                    values.sort(compare)
                ]
            ];
        } else {
            return [
                'filter-in-small',
                property,
                [
                    'literal',
                    values
                ]
            ];
        }
    }
}
function convertHasOp(property) {
    switch (property) {
    case '$type':
        return true;
    case '$id':
        return ['filter-has-id'];
    default:
        return [
            'filter-has',
            property
        ];
    }
}
function convertNegation(filter) {
    return [
        '!',
        filter
    ];
}

function validateFilter(options) {
    if (isExpressionFilter(deepUnbundle(options.value))) {
        return validateExpression(extend$1({}, options, {
            expressionContext: 'filter',
            valueSpec: { value: 'boolean' }
        }));
    } else {
        return validateNonExpressionFilter(options);
    }
}
function validateNonExpressionFilter(options) {
    var value = options.value;
    var key = options.key;
    if (getType(value) !== 'array') {
        return [new ValidationError(key, value, 'array expected, ' + getType(value) + ' found')];
    }
    var styleSpec = options.styleSpec;
    var type;
    var errors = [];
    if (value.length < 1) {
        return [new ValidationError(key, value, 'filter array must have at least 1 element')];
    }
    errors = errors.concat(validateEnum({
        key: key + '[0]',
        value: value[0],
        valueSpec: styleSpec.filter_operator,
        style: options.style,
        styleSpec: options.styleSpec
    }));
    switch (unbundle(value[0])) {
    case '<':
    case '<=':
    case '>':
    case '>=':
        if (value.length >= 2 && unbundle(value[1]) === '$type') {
            errors.push(new ValidationError(key, value, '"$type" cannot be use with operator "' + value[0] + '"'));
        }
    case '==':
    case '!=':
        if (value.length !== 3) {
            errors.push(new ValidationError(key, value, 'filter array for operator "' + value[0] + '" must have 3 elements'));
        }
    case 'in':
    case '!in':
        if (value.length >= 2) {
            type = getType(value[1]);
            if (type !== 'string') {
                errors.push(new ValidationError(key + '[1]', value[1], 'string expected, ' + type + ' found'));
            }
        }
        for (var i = 2; i < value.length; i++) {
            type = getType(value[i]);
            if (unbundle(value[1]) === '$type') {
                errors = errors.concat(validateEnum({
                    key: key + '[' + i + ']',
                    value: value[i],
                    valueSpec: styleSpec.geometry_type,
                    style: options.style,
                    styleSpec: options.styleSpec
                }));
            } else if (type !== 'string' && type !== 'number' && type !== 'boolean') {
                errors.push(new ValidationError(key + '[' + i + ']', value[i], 'string, number, or boolean expected, ' + type + ' found'));
            }
        }
        break;
    case 'any':
    case 'all':
    case 'none':
        for (var i$1 = 1; i$1 < value.length; i$1++) {
            errors = errors.concat(validateNonExpressionFilter({
                key: key + '[' + i$1 + ']',
                value: value[i$1],
                style: options.style,
                styleSpec: options.styleSpec
            }));
        }
        break;
    case 'has':
    case '!has':
        type = getType(value[1]);
        if (value.length !== 2) {
            errors.push(new ValidationError(key, value, 'filter array for "' + value[0] + '" operator must have 2 elements'));
        } else if (type !== 'string') {
            errors.push(new ValidationError(key + '[1]', value[1], 'string expected, ' + type + ' found'));
        }
        break;
    case 'within':
        type = getType(value[1]);
        if (value.length !== 2) {
            errors.push(new ValidationError(key, value, 'filter array for "' + value[0] + '" operator must have 2 elements'));
        } else if (type !== 'object') {
            errors.push(new ValidationError(key + '[1]', value[1], 'object expected, ' + type + ' found'));
        }
        break;
    }
    return errors;
}

function validateProperty(options, propertyType) {
    var key = options.key;
    var style = options.style;
    var styleSpec = options.styleSpec;
    var value = options.value;
    var propertyKey = options.objectKey;
    var layerSpec = styleSpec[propertyType + '_' + options.layerType];
    if (!layerSpec) {
        return [];
    }
    var transitionMatch = propertyKey.match(/^(.*)-transition$/);
    if (propertyType === 'paint' && transitionMatch && layerSpec[transitionMatch[1]] && layerSpec[transitionMatch[1]].transition) {
        return validate({
            key: key,
            value: value,
            valueSpec: styleSpec.transition,
            style: style,
            styleSpec: styleSpec
        });
    }
    var valueSpec = options.valueSpec || layerSpec[propertyKey];
    if (!valueSpec) {
        return [new ValidationError(key, value, 'unknown property "' + propertyKey + '"')];
    }
    var tokenMatch;
    if (getType(value) === 'string' && supportsPropertyExpression(valueSpec) && !valueSpec.tokens && (tokenMatch = /^{([^}]+)}$/.exec(value))) {
        return [new ValidationError(key, value, '"' + propertyKey + '" does not support interpolation syntax\n' + 'Use an identity property function instead: `{ "type": "identity", "property": ' + JSON.stringify(tokenMatch[1]) + ' }`.')];
    }
    var errors = [];
    if (options.layerType === 'symbol') {
        if (propertyKey === 'text-field' && style && !style.glyphs) {
            errors.push(new ValidationError(key, value, 'use of "text-field" requires a style "glyphs" property'));
        }
        if (propertyKey === 'text-font' && isFunction(deepUnbundle(value)) && unbundle(value.type) === 'identity') {
            errors.push(new ValidationError(key, value, '"text-font" does not support identity functions'));
        }
    }
    return errors.concat(validate({
        key: options.key,
        value: value,
        valueSpec: valueSpec,
        style: style,
        styleSpec: styleSpec,
        expressionContext: 'property',
        propertyType: propertyType,
        propertyKey: propertyKey
    }));
}

function validatePaintProperty(options) {
    return validateProperty(options, 'paint');
}

function validateLayoutProperty(options) {
    return validateProperty(options, 'layout');
}

function validateLayer(options) {
    var errors = [];
    var layer = options.value;
    var key = options.key;
    var style = options.style;
    var styleSpec = options.styleSpec;
    if (!layer.type && !layer.ref) {
        errors.push(new ValidationError(key, layer, 'either "type" or "ref" is required'));
    }
    var type = unbundle(layer.type);
    var ref = unbundle(layer.ref);
    if (layer.id) {
        var layerId = unbundle(layer.id);
        for (var i = 0; i < options.arrayIndex; i++) {
            var otherLayer = style.layers[i];
            if (unbundle(otherLayer.id) === layerId) {
                errors.push(new ValidationError(key, layer.id, 'duplicate layer id "' + layer.id + '", previously used at line ' + otherLayer.id.__line__));
            }
        }
    }
    if ('ref' in layer) {
        [
            'type',
            'source',
            'source-layer',
            'filter',
            'layout'
        ].forEach(function (p) {
            if (p in layer) {
                errors.push(new ValidationError(key, layer[p], '"' + p + '" is prohibited for ref layers'));
            }
        });
        var parent;
        style.layers.forEach(function (layer) {
            if (unbundle(layer.id) === ref) {
                parent = layer;
            }
        });
        if (!parent) {
            errors.push(new ValidationError(key, layer.ref, 'ref layer "' + ref + '" not found'));
        } else if (parent.ref) {
            errors.push(new ValidationError(key, layer.ref, 'ref cannot reference another ref layer'));
        } else {
            type = unbundle(parent.type);
        }
    } else if (type !== 'background') {
        if (!layer.source) {
            errors.push(new ValidationError(key, layer, 'missing required property "source"'));
        } else {
            var source = style.sources && style.sources[layer.source];
            var sourceType = source && unbundle(source.type);
            if (!source) {
                errors.push(new ValidationError(key, layer.source, 'source "' + layer.source + '" not found'));
            } else if (sourceType === 'vector' && type === 'raster') {
                errors.push(new ValidationError(key, layer.source, 'layer "' + layer.id + '" requires a raster source'));
            } else if (sourceType === 'raster' && type !== 'raster') {
                errors.push(new ValidationError(key, layer.source, 'layer "' + layer.id + '" requires a vector source'));
            } else if (sourceType === 'vector' && !layer['source-layer']) {
                errors.push(new ValidationError(key, layer, 'layer "' + layer.id + '" must specify a "source-layer"'));
            } else if (sourceType === 'raster-dem' && type !== 'hillshade') {
                errors.push(new ValidationError(key, layer.source, 'raster-dem source can only be used with layer type \'hillshade\'.'));
            } else if (type === 'line' && layer.paint && layer.paint['line-gradient'] && (sourceType !== 'geojson' || !source.lineMetrics)) {
                errors.push(new ValidationError(key, layer, 'layer "' + layer.id + '" specifies a line-gradient, which requires a GeoJSON source with `lineMetrics` enabled.'));
            }
        }
    }
    errors = errors.concat(validateObject({
        key: key,
        value: layer,
        valueSpec: styleSpec.layer,
        style: options.style,
        styleSpec: options.styleSpec,
        objectElementValidators: {
            '*': function _() {
                return [];
            },
            type: function type() {
                return validate({
                    key: key + '.type',
                    value: layer.type,
                    valueSpec: styleSpec.layer.type,
                    style: options.style,
                    styleSpec: options.styleSpec,
                    object: layer,
                    objectKey: 'type'
                });
            },
            filter: validateFilter,
            layout: function layout(options) {
                return validateObject({
                    layer: layer,
                    key: options.key,
                    value: options.value,
                    style: options.style,
                    styleSpec: options.styleSpec,
                    objectElementValidators: {
                        '*': function _(options) {
                            return validateLayoutProperty(extend$1({ layerType: type }, options));
                        }
                    }
                });
            },
            paint: function paint(options) {
                return validateObject({
                    layer: layer,
                    key: options.key,
                    value: options.value,
                    style: options.style,
                    styleSpec: options.styleSpec,
                    objectElementValidators: {
                        '*': function _(options) {
                            return validatePaintProperty(extend$1({ layerType: type }, options));
                        }
                    }
                });
            }
        }
    }));
    return errors;
}

function validateString(options) {
    var value = options.value;
    var key = options.key;
    var type = getType(value);
    if (type !== 'string') {
        return [new ValidationError(key, value, 'string expected, ' + type + ' found')];
    }
    return [];
}

var objectElementValidators = { promoteId: validatePromoteId };
function validateSource(options) {
    var value = options.value;
    var key = options.key;
    var styleSpec = options.styleSpec;
    var style = options.style;
    if (!value.type) {
        return [new ValidationError(key, value, '"type" is required')];
    }
    var type = unbundle(value.type);
    var errors;
    switch (type) {
    case 'vector':
    case 'raster':
    case 'raster-dem':
        errors = validateObject({
            key: key,
            value: value,
            valueSpec: styleSpec['source_' + type.replace('-', '_')],
            style: options.style,
            styleSpec: styleSpec,
            objectElementValidators: objectElementValidators
        });
        return errors;
    case 'geojson':
        errors = validateObject({
            key: key,
            value: value,
            valueSpec: styleSpec.source_geojson,
            style: style,
            styleSpec: styleSpec,
            objectElementValidators: objectElementValidators
        });
        if (value.cluster) {
            for (var prop in value.clusterProperties) {
                var ref = value.clusterProperties[prop];
                var operator = ref[0];
                var mapExpr = ref[1];
                var reduceExpr = typeof operator === 'string' ? [
                    operator,
                    ['accumulated'],
                    [
                        'get',
                        prop
                    ]
                ] : operator;
                errors.push.apply(errors, validateExpression({
                    key: key + '.' + prop + '.map',
                    value: mapExpr,
                    expressionContext: 'cluster-map'
                }));
                errors.push.apply(errors, validateExpression({
                    key: key + '.' + prop + '.reduce',
                    value: reduceExpr,
                    expressionContext: 'cluster-reduce'
                }));
            }
        }
        return errors;
    case 'video':
        return validateObject({
            key: key,
            value: value,
            valueSpec: styleSpec.source_video,
            style: style,
            styleSpec: styleSpec
        });
    case 'image':
        return validateObject({
            key: key,
            value: value,
            valueSpec: styleSpec.source_image,
            style: style,
            styleSpec: styleSpec
        });
    case 'canvas':
        return [new ValidationError(key, null, 'Please use runtime APIs to add canvas sources, rather than including them in stylesheets.', 'source.canvas')];
    default:
        return validateEnum({
            key: key + '.type',
            value: value.type,
            valueSpec: {
                values: [
                    'vector',
                    'raster',
                    'raster-dem',
                    'geojson',
                    'video',
                    'image'
                ]
            },
            style: style,
            styleSpec: styleSpec
        });
    }
}
function validatePromoteId(ref) {
    var key = ref.key;
    var value = ref.value;
    if (getType(value) === 'string') {
        return validateString({
            key: key,
            value: value
        });
    } else {
        var errors = [];
        for (var prop in value) {
            errors.push.apply(errors, validateString({
                key: key + '.' + prop,
                value: value[prop]
            }));
        }
        return errors;
    }
}

function validateLight(options) {
    var light = options.value;
    var styleSpec = options.styleSpec;
    var lightSpec = styleSpec.light;
    var style = options.style;
    var errors = [];
    var rootType = getType(light);
    if (light === undefined) {
        return errors;
    } else if (rootType !== 'object') {
        errors = errors.concat([new ValidationError('light', light, 'object expected, ' + rootType + ' found')]);
        return errors;
    }
    for (var key in light) {
        var transitionMatch = key.match(/^(.*)-transition$/);
        if (transitionMatch && lightSpec[transitionMatch[1]] && lightSpec[transitionMatch[1]].transition) {
            errors = errors.concat(validate({
                key: key,
                value: light[key],
                valueSpec: styleSpec.transition,
                style: style,
                styleSpec: styleSpec
            }));
        } else if (lightSpec[key]) {
            errors = errors.concat(validate({
                key: key,
                value: light[key],
                valueSpec: lightSpec[key],
                style: style,
                styleSpec: styleSpec
            }));
        } else {
            errors = errors.concat([new ValidationError(key, light[key], 'unknown property "' + key + '"')]);
        }
    }
    return errors;
}

function validateFormatted(options) {
    if (validateString(options).length === 0) {
        return [];
    }
    return validateExpression(options);
}

function validateImage(options) {
    if (validateString(options).length === 0) {
        return [];
    }
    return validateExpression(options);
}

var VALIDATORS = {
    '*': function _() {
        return [];
    },
    'array': validateArray,
    'boolean': validateBoolean,
    'number': validateNumber,
    'color': validateColor,
    'constants': validateConstants,
    'enum': validateEnum,
    'filter': validateFilter,
    'function': validateFunction,
    'layer': validateLayer,
    'object': validateObject,
    'source': validateSource,
    'light': validateLight,
    'string': validateString,
    'formatted': validateFormatted,
    'resolvedImage': validateImage
};
function validate(options) {
    var value = options.value;
    var valueSpec = options.valueSpec;
    var styleSpec = options.styleSpec;
    if (valueSpec.expression && isFunction(unbundle(value))) {
        return validateFunction(options);
    } else if (valueSpec.expression && isExpression(deepUnbundle(value))) {
        return validateExpression(options);
    } else if (valueSpec.type && VALIDATORS[valueSpec.type]) {
        return VALIDATORS[valueSpec.type](options);
    } else {
        var valid = validateObject(extend$1({}, options, { valueSpec: valueSpec.type ? styleSpec[valueSpec.type] : valueSpec }));
        return valid;
    }
}

function validateGlyphsURL (options) {
    var value = options.value;
    var key = options.key;
    var errors = validateString(options);
    if (errors.length) {
        return errors;
    }
    if (value.indexOf('{fontstack}') === -1) {
        errors.push(new ValidationError(key, value, '"glyphs" url must include a "{fontstack}" token'));
    }
    if (value.indexOf('{range}') === -1) {
        errors.push(new ValidationError(key, value, '"glyphs" url must include a "{range}" token'));
    }
    return errors;
}

function validateStyleMin(style, styleSpec) {
    if (styleSpec === void 0)
        styleSpec = spec;
    var errors = [];
    errors = errors.concat(validate({
        key: '',
        value: style,
        valueSpec: styleSpec.$root,
        styleSpec: styleSpec,
        style: style,
        objectElementValidators: {
            glyphs: validateGlyphsURL,
            '*': function _() {
                return [];
            }
        }
    }));
    if (style.constants) {
        errors = errors.concat(validateConstants({
            key: 'constants',
            value: style.constants,
            style: style,
            styleSpec: styleSpec
        }));
    }
    return sortErrors(errors);
}
validateStyleMin.source = wrapCleanErrors(validateSource);
validateStyleMin.light = wrapCleanErrors(validateLight);
validateStyleMin.layer = wrapCleanErrors(validateLayer);
validateStyleMin.filter = wrapCleanErrors(validateFilter);
validateStyleMin.paintProperty = wrapCleanErrors(validatePaintProperty);
validateStyleMin.layoutProperty = wrapCleanErrors(validateLayoutProperty);
function sortErrors(errors) {
    return [].concat(errors).sort(function (a, b) {
        return a.line - b.line;
    });
}
function wrapCleanErrors(inner) {
    return function () {
        var args = [], len = arguments.length;
        while (len--)
            args[len] = arguments[len];
        return sortErrors(inner.apply(this, args));
    };
}

var validateStyle = validateStyleMin;
var validateLight$1 = validateStyle.light;
var validatePaintProperty$1 = validateStyle.paintProperty;
var validateLayoutProperty$1 = validateStyle.layoutProperty;
function emitValidationErrors(emitter, errors) {
    var hasErrors = false;
    if (errors && errors.length) {
        for (var i = 0, list = errors; i < list.length; i += 1) {
            var error = list[i];
            emitter.fire(new ErrorEvent(new Error(error.message)));
            hasErrors = true;
        }
    }
    return hasErrors;
}

var gridIndex = GridIndex;
var NUM_PARAMS = 3;
function GridIndex(extent, n, padding) {
    var cells = this.cells = [];
    if (extent instanceof ArrayBuffer) {
        this.arrayBuffer = extent;
        var array = new Int32Array(this.arrayBuffer);
        extent = array[0];
        n = array[1];
        padding = array[2];
        this.d = n + 2 * padding;
        for (var k = 0; k < this.d * this.d; k++) {
            var start = array[NUM_PARAMS + k];
            var end = array[NUM_PARAMS + k + 1];
            cells.push(start === end ? null : array.subarray(start, end));
        }
        var keysOffset = array[NUM_PARAMS + cells.length];
        var bboxesOffset = array[NUM_PARAMS + cells.length + 1];
        this.keys = array.subarray(keysOffset, bboxesOffset);
        this.bboxes = array.subarray(bboxesOffset);
        this.insert = this._insertReadonly;
    } else {
        this.d = n + 2 * padding;
        for (var i = 0; i < this.d * this.d; i++) {
            cells.push([]);
        }
        this.keys = [];
        this.bboxes = [];
    }
    this.n = n;
    this.extent = extent;
    this.padding = padding;
    this.scale = n / extent;
    this.uid = 0;
    var p = padding / n * extent;
    this.min = -p;
    this.max = extent + p;
}
GridIndex.prototype.insert = function (key, x1, y1, x2, y2) {
    this._forEachCell(x1, y1, x2, y2, this._insertCell, this.uid++);
    this.keys.push(key);
    this.bboxes.push(x1);
    this.bboxes.push(y1);
    this.bboxes.push(x2);
    this.bboxes.push(y2);
};
GridIndex.prototype._insertReadonly = function () {
    throw 'Cannot insert into a GridIndex created from an ArrayBuffer.';
};
GridIndex.prototype._insertCell = function (x1, y1, x2, y2, cellIndex, uid) {
    this.cells[cellIndex].push(uid);
};
GridIndex.prototype.query = function (x1, y1, x2, y2, intersectionTest) {
    var min = this.min;
    var max = this.max;
    if (x1 <= min && y1 <= min && max <= x2 && max <= y2 && !intersectionTest) {
        return Array.prototype.slice.call(this.keys);
    } else {
        var result = [];
        var seenUids = {};
        this._forEachCell(x1, y1, x2, y2, this._queryCell, result, seenUids, intersectionTest);
        return result;
    }
};
GridIndex.prototype._queryCell = function (x1, y1, x2, y2, cellIndex, result, seenUids, intersectionTest) {
    var cell = this.cells[cellIndex];
    if (cell !== null) {
        var keys = this.keys;
        var bboxes = this.bboxes;
        for (var u = 0; u < cell.length; u++) {
            var uid = cell[u];
            if (seenUids[uid] === undefined) {
                var offset = uid * 4;
                if (intersectionTest ? intersectionTest(bboxes[offset + 0], bboxes[offset + 1], bboxes[offset + 2], bboxes[offset + 3]) : x1 <= bboxes[offset + 2] && y1 <= bboxes[offset + 3] && x2 >= bboxes[offset + 0] && y2 >= bboxes[offset + 1]) {
                    seenUids[uid] = true;
                    result.push(keys[uid]);
                } else {
                    seenUids[uid] = false;
                }
            }
        }
    }
};
GridIndex.prototype._forEachCell = function (x1, y1, x2, y2, fn, arg1, arg2, intersectionTest) {
    var cx1 = this._convertToCellCoord(x1);
    var cy1 = this._convertToCellCoord(y1);
    var cx2 = this._convertToCellCoord(x2);
    var cy2 = this._convertToCellCoord(y2);
    for (var x = cx1; x <= cx2; x++) {
        for (var y = cy1; y <= cy2; y++) {
            var cellIndex = this.d * y + x;
            if (intersectionTest && !intersectionTest(this._convertFromCellCoord(x), this._convertFromCellCoord(y), this._convertFromCellCoord(x + 1), this._convertFromCellCoord(y + 1))) {
                continue;
            }
            if (fn.call(this, x1, y1, x2, y2, cellIndex, arg1, arg2, intersectionTest)) {
                return;
            }
        }
    }
};
GridIndex.prototype._convertFromCellCoord = function (x) {
    return (x - this.padding) / this.scale;
};
GridIndex.prototype._convertToCellCoord = function (x) {
    return Math.max(0, Math.min(this.d - 1, Math.floor(x * this.scale) + this.padding));
};
GridIndex.prototype.toArrayBuffer = function () {
    if (this.arrayBuffer) {
        return this.arrayBuffer;
    }
    var cells = this.cells;
    var metadataLength = NUM_PARAMS + this.cells.length + 1 + 1;
    var totalCellLength = 0;
    for (var i = 0; i < this.cells.length; i++) {
        totalCellLength += this.cells[i].length;
    }
    var array = new Int32Array(metadataLength + totalCellLength + this.keys.length + this.bboxes.length);
    array[0] = this.extent;
    array[1] = this.n;
    array[2] = this.padding;
    var offset = metadataLength;
    for (var k = 0; k < cells.length; k++) {
        var cell = cells[k];
        array[NUM_PARAMS + k] = offset;
        array.set(cell, offset);
        offset += cell.length;
    }
    array[NUM_PARAMS + cells.length] = offset;
    array.set(this.keys, offset);
    offset += this.keys.length;
    array[NUM_PARAMS + cells.length + 1] = offset;
    array.set(this.bboxes, offset);
    offset += this.bboxes.length;
    return array.buffer;
};

var ImageData = window$1.ImageData;
var ImageBitmap = window$1.ImageBitmap;
var registry = {};
function register(name, klass, options) {
    if (options === void 0)
        options = {};
    Object.defineProperty(klass, '_classRegistryKey', {
        value: name,
        writeable: false
    });
    registry[name] = {
        klass: klass,
        omit: options.omit || [],
        shallow: options.shallow || []
    };
}
register('Object', Object);
gridIndex.serialize = function serialize(grid, transferables) {
    var buffer = grid.toArrayBuffer();
    if (transferables) {
        transferables.push(buffer);
    }
    return { buffer: buffer };
};
gridIndex.deserialize = function deserialize(serialized) {
    return new gridIndex(serialized.buffer);
};
register('Grid', gridIndex);
register('Color', Color);
register('Error', Error);
register('ResolvedImage', ResolvedImage);
register('StylePropertyFunction', StylePropertyFunction);
register('StyleExpression', StyleExpression, { omit: ['_evaluator'] });
register('ZoomDependentExpression', ZoomDependentExpression);
register('ZoomConstantExpression', ZoomConstantExpression);
register('CompoundExpression', CompoundExpression, { omit: ['_evaluate'] });
for (var name in expressions) {
    if (expressions[name]._classRegistryKey) {
        continue;
    }
    register('Expression_' + name, expressions[name]);
}
function isArrayBuffer(val) {
    return val && typeof ArrayBuffer !== 'undefined' && (val instanceof ArrayBuffer || val.constructor && val.constructor.name === 'ArrayBuffer');
}
function isImageBitmap(val) {
    return ImageBitmap && val instanceof ImageBitmap;
}
function serialize(input, transferables) {
    if (input === null || input === undefined || typeof input === 'boolean' || typeof input === 'number' || typeof input === 'string' || input instanceof Boolean || input instanceof Number || input instanceof String || input instanceof Date || input instanceof RegExp) {
        return input;
    }
    if (isArrayBuffer(input) || isImageBitmap(input)) {
        if (transferables) {
            transferables.push(input);
        }
        return input;
    }
    if (ArrayBuffer.isView(input)) {
        var view = input;
        if (transferables) {
            transferables.push(view.buffer);
        }
        return view;
    }
    if (input instanceof ImageData) {
        if (transferables) {
            transferables.push(input.data.buffer);
        }
        return input;
    }
    if (Array.isArray(input)) {
        var serialized = [];
        for (var i = 0, list = input; i < list.length; i += 1) {
            var item = list[i];
            serialized.push(serialize(item, transferables));
        }
        return serialized;
    }
    if (typeof input === 'object') {
        var klass = input.constructor;
        var name = klass._classRegistryKey;
        if (!name) {
            throw new Error('can\'t serialize object of unregistered class');
        }
        var properties = klass.serialize ? klass.serialize(input, transferables) : {};
        if (!klass.serialize) {
            for (var key in input) {
                if (!input.hasOwnProperty(key)) {
                    continue;
                }
                if (registry[name].omit.indexOf(key) >= 0) {
                    continue;
                }
                var property = input[key];
                properties[key] = registry[name].shallow.indexOf(key) >= 0 ? property : serialize(property, transferables);
            }
            if (input instanceof Error) {
                properties.message = input.message;
            }
        }
        if (properties.$name) {
            throw new Error('$name property is reserved for worker serialization logic.');
        }
        if (name !== 'Object') {
            properties.$name = name;
        }
        return properties;
    }
    throw new Error('can\'t serialize object of type ' + typeof input);
}
function deserialize(input) {
    if (input === null || input === undefined || typeof input === 'boolean' || typeof input === 'number' || typeof input === 'string' || input instanceof Boolean || input instanceof Number || input instanceof String || input instanceof Date || input instanceof RegExp || isArrayBuffer(input) || isImageBitmap(input) || ArrayBuffer.isView(input) || input instanceof ImageData) {
        return input;
    }
    if (Array.isArray(input)) {
        return input.map(deserialize);
    }
    if (typeof input === 'object') {
        var name = input.$name || 'Object';
        var ref = registry[name];
        var klass = ref.klass;
        if (!klass) {
            throw new Error('can\'t deserialize unregistered class ' + name);
        }
        if (klass.deserialize) {
            return klass.deserialize(input);
        }
        var result = Object.create(klass.prototype);
        for (var i = 0, list = Object.keys(input); i < list.length; i += 1) {
            var key = list[i];
            if (key === '$name') {
                continue;
            }
            var value = input[key];
            result[key] = registry[name].shallow.indexOf(key) >= 0 ? value : deserialize(value);
        }
        return result;
    }
    throw new Error('can\'t deserialize object of type ' + typeof input);
}

var ZoomHistory = function ZoomHistory() {
    this.first = true;
};
ZoomHistory.prototype.update = function update(z, now) {
    var floorZ = Math.floor(z);
    if (this.first) {
        this.first = false;
        this.lastIntegerZoom = floorZ;
        this.lastIntegerZoomTime = 0;
        this.lastZoom = z;
        this.lastFloorZoom = floorZ;
        return true;
    }
    if (this.lastFloorZoom > floorZ) {
        this.lastIntegerZoom = floorZ + 1;
        this.lastIntegerZoomTime = now;
    } else if (this.lastFloorZoom < floorZ) {
        this.lastIntegerZoom = floorZ;
        this.lastIntegerZoomTime = now;
    }
    if (z !== this.lastZoom) {
        this.lastZoom = z;
        this.lastFloorZoom = floorZ;
        return true;
    }
    return false;
};

var unicodeBlockLookup = {
    'Latin-1 Supplement': function (char) {
        return char >= 128 && char <= 255;
    },
    'Arabic': function (char) {
        return char >= 1536 && char <= 1791;
    },
    'Arabic Supplement': function (char) {
        return char >= 1872 && char <= 1919;
    },
    'Arabic Extended-A': function (char) {
        return char >= 2208 && char <= 2303;
    },
    'Hangul Jamo': function (char) {
        return char >= 4352 && char <= 4607;
    },
    'Unified Canadian Aboriginal Syllabics': function (char) {
        return char >= 5120 && char <= 5759;
    },
    'Khmer': function (char) {
        return char >= 6016 && char <= 6143;
    },
    'Unified Canadian Aboriginal Syllabics Extended': function (char) {
        return char >= 6320 && char <= 6399;
    },
    'General Punctuation': function (char) {
        return char >= 8192 && char <= 8303;
    },
    'Letterlike Symbols': function (char) {
        return char >= 8448 && char <= 8527;
    },
    'Number Forms': function (char) {
        return char >= 8528 && char <= 8591;
    },
    'Miscellaneous Technical': function (char) {
        return char >= 8960 && char <= 9215;
    },
    'Control Pictures': function (char) {
        return char >= 9216 && char <= 9279;
    },
    'Optical Character Recognition': function (char) {
        return char >= 9280 && char <= 9311;
    },
    'Enclosed Alphanumerics': function (char) {
        return char >= 9312 && char <= 9471;
    },
    'Geometric Shapes': function (char) {
        return char >= 9632 && char <= 9727;
    },
    'Miscellaneous Symbols': function (char) {
        return char >= 9728 && char <= 9983;
    },
    'Miscellaneous Symbols and Arrows': function (char) {
        return char >= 11008 && char <= 11263;
    },
    'CJK Radicals Supplement': function (char) {
        return char >= 11904 && char <= 12031;
    },
    'Kangxi Radicals': function (char) {
        return char >= 12032 && char <= 12255;
    },
    'Ideographic Description Characters': function (char) {
        return char >= 12272 && char <= 12287;
    },
    'CJK Symbols and Punctuation': function (char) {
        return char >= 12288 && char <= 12351;
    },
    'Hiragana': function (char) {
        return char >= 12352 && char <= 12447;
    },
    'Katakana': function (char) {
        return char >= 12448 && char <= 12543;
    },
    'Bopomofo': function (char) {
        return char >= 12544 && char <= 12591;
    },
    'Hangul Compatibility Jamo': function (char) {
        return char >= 12592 && char <= 12687;
    },
    'Kanbun': function (char) {
        return char >= 12688 && char <= 12703;
    },
    'Bopomofo Extended': function (char) {
        return char >= 12704 && char <= 12735;
    },
    'CJK Strokes': function (char) {
        return char >= 12736 && char <= 12783;
    },
    'Katakana Phonetic Extensions': function (char) {
        return char >= 12784 && char <= 12799;
    },
    'Enclosed CJK Letters and Months': function (char) {
        return char >= 12800 && char <= 13055;
    },
    'CJK Compatibility': function (char) {
        return char >= 13056 && char <= 13311;
    },
    'CJK Unified Ideographs Extension A': function (char) {
        return char >= 13312 && char <= 19903;
    },
    'Yijing Hexagram Symbols': function (char) {
        return char >= 19904 && char <= 19967;
    },
    'CJK Unified Ideographs': function (char) {
        return char >= 19968 && char <= 40959;
    },
    'Yi Syllables': function (char) {
        return char >= 40960 && char <= 42127;
    },
    'Yi Radicals': function (char) {
        return char >= 42128 && char <= 42191;
    },
    'Hangul Jamo Extended-A': function (char) {
        return char >= 43360 && char <= 43391;
    },
    'Hangul Syllables': function (char) {
        return char >= 44032 && char <= 55215;
    },
    'Hangul Jamo Extended-B': function (char) {
        return char >= 55216 && char <= 55295;
    },
    'Private Use Area': function (char) {
        return char >= 57344 && char <= 63743;
    },
    'CJK Compatibility Ideographs': function (char) {
        return char >= 63744 && char <= 64255;
    },
    'Arabic Presentation Forms-A': function (char) {
        return char >= 64336 && char <= 65023;
    },
    'Vertical Forms': function (char) {
        return char >= 65040 && char <= 65055;
    },
    'CJK Compatibility Forms': function (char) {
        return char >= 65072 && char <= 65103;
    },
    'Small Form Variants': function (char) {
        return char >= 65104 && char <= 65135;
    },
    'Arabic Presentation Forms-B': function (char) {
        return char >= 65136 && char <= 65279;
    },
    'Halfwidth and Fullwidth Forms': function (char) {
        return char >= 65280 && char <= 65519;
    }
};

function allowsVerticalWritingMode(chars) {
    for (var i = 0, list = chars; i < list.length; i += 1) {
        var char = list[i];
        if (charHasUprightVerticalOrientation(char.charCodeAt(0))) {
            return true;
        }
    }
    return false;
}
function allowsLetterSpacing(chars) {
    for (var i = 0, list = chars; i < list.length; i += 1) {
        var char = list[i];
        if (!charAllowsLetterSpacing(char.charCodeAt(0))) {
            return false;
        }
    }
    return true;
}
function charAllowsLetterSpacing(char) {
    if (unicodeBlockLookup['Arabic'](char)) {
        return false;
    }
    if (unicodeBlockLookup['Arabic Supplement'](char)) {
        return false;
    }
    if (unicodeBlockLookup['Arabic Extended-A'](char)) {
        return false;
    }
    if (unicodeBlockLookup['Arabic Presentation Forms-A'](char)) {
        return false;
    }
    if (unicodeBlockLookup['Arabic Presentation Forms-B'](char)) {
        return false;
    }
    return true;
}
function charAllowsIdeographicBreaking(char) {
    if (char < 11904) {
        return false;
    }
    if (unicodeBlockLookup['Bopomofo Extended'](char)) {
        return true;
    }
    if (unicodeBlockLookup['Bopomofo'](char)) {
        return true;
    }
    if (unicodeBlockLookup['CJK Compatibility Forms'](char)) {
        return true;
    }
    if (unicodeBlockLookup['CJK Compatibility Ideographs'](char)) {
        return true;
    }
    if (unicodeBlockLookup['CJK Compatibility'](char)) {
        return true;
    }
    if (unicodeBlockLookup['CJK Radicals Supplement'](char)) {
        return true;
    }
    if (unicodeBlockLookup['CJK Strokes'](char)) {
        return true;
    }
    if (unicodeBlockLookup['CJK Symbols and Punctuation'](char)) {
        return true;
    }
    if (unicodeBlockLookup['CJK Unified Ideographs Extension A'](char)) {
        return true;
    }
    if (unicodeBlockLookup['CJK Unified Ideographs'](char)) {
        return true;
    }
    if (unicodeBlockLookup['Enclosed CJK Letters and Months'](char)) {
        return true;
    }
    if (unicodeBlockLookup['Halfwidth and Fullwidth Forms'](char)) {
        return true;
    }
    if (unicodeBlockLookup['Hiragana'](char)) {
        return true;
    }
    if (unicodeBlockLookup['Ideographic Description Characters'](char)) {
        return true;
    }
    if (unicodeBlockLookup['Kangxi Radicals'](char)) {
        return true;
    }
    if (unicodeBlockLookup['Katakana Phonetic Extensions'](char)) {
        return true;
    }
    if (unicodeBlockLookup['Katakana'](char)) {
        return true;
    }
    if (unicodeBlockLookup['Vertical Forms'](char)) {
        return true;
    }
    if (unicodeBlockLookup['Yi Radicals'](char)) {
        return true;
    }
    if (unicodeBlockLookup['Yi Syllables'](char)) {
        return true;
    }
    return false;
}
function charHasUprightVerticalOrientation(char) {
    if (char === 746 || char === 747) {
        return true;
    }
    if (char < 4352) {
        return false;
    }
    if (unicodeBlockLookup['Bopomofo Extended'](char)) {
        return true;
    }
    if (unicodeBlockLookup['Bopomofo'](char)) {
        return true;
    }
    if (unicodeBlockLookup['CJK Compatibility Forms'](char)) {
        if (!(char >= 65097 && char <= 65103)) {
            return true;
        }
    }
    if (unicodeBlockLookup['CJK Compatibility Ideographs'](char)) {
        return true;
    }
    if (unicodeBlockLookup['CJK Compatibility'](char)) {
        return true;
    }
    if (unicodeBlockLookup['CJK Radicals Supplement'](char)) {
        return true;
    }
    if (unicodeBlockLookup['CJK Strokes'](char)) {
        return true;
    }
    if (unicodeBlockLookup['CJK Symbols and Punctuation'](char)) {
        if (!(char >= 12296 && char <= 12305) && !(char >= 12308 && char <= 12319) && char !== 12336) {
            return true;
        }
    }
    if (unicodeBlockLookup['CJK Unified Ideographs Extension A'](char)) {
        return true;
    }
    if (unicodeBlockLookup['CJK Unified Ideographs'](char)) {
        return true;
    }
    if (unicodeBlockLookup['Enclosed CJK Letters and Months'](char)) {
        return true;
    }
    if (unicodeBlockLookup['Hangul Compatibility Jamo'](char)) {
        return true;
    }
    if (unicodeBlockLookup['Hangul Jamo Extended-A'](char)) {
        return true;
    }
    if (unicodeBlockLookup['Hangul Jamo Extended-B'](char)) {
        return true;
    }
    if (unicodeBlockLookup['Hangul Jamo'](char)) {
        return true;
    }
    if (unicodeBlockLookup['Hangul Syllables'](char)) {
        return true;
    }
    if (unicodeBlockLookup['Hiragana'](char)) {
        return true;
    }
    if (unicodeBlockLookup['Ideographic Description Characters'](char)) {
        return true;
    }
    if (unicodeBlockLookup['Kanbun'](char)) {
        return true;
    }
    if (unicodeBlockLookup['Kangxi Radicals'](char)) {
        return true;
    }
    if (unicodeBlockLookup['Katakana Phonetic Extensions'](char)) {
        return true;
    }
    if (unicodeBlockLookup['Katakana'](char)) {
        if (char !== 12540) {
            return true;
        }
    }
    if (unicodeBlockLookup['Halfwidth and Fullwidth Forms'](char)) {
        if (char !== 65288 && char !== 65289 && char !== 65293 && !(char >= 65306 && char <= 65310) && char !== 65339 && char !== 65341 && char !== 65343 && !(char >= 65371 && char <= 65503) && char !== 65507 && !(char >= 65512 && char <= 65519)) {
            return true;
        }
    }
    if (unicodeBlockLookup['Small Form Variants'](char)) {
        if (!(char >= 65112 && char <= 65118) && !(char >= 65123 && char <= 65126)) {
            return true;
        }
    }
    if (unicodeBlockLookup['Unified Canadian Aboriginal Syllabics'](char)) {
        return true;
    }
    if (unicodeBlockLookup['Unified Canadian Aboriginal Syllabics Extended'](char)) {
        return true;
    }
    if (unicodeBlockLookup['Vertical Forms'](char)) {
        return true;
    }
    if (unicodeBlockLookup['Yijing Hexagram Symbols'](char)) {
        return true;
    }
    if (unicodeBlockLookup['Yi Syllables'](char)) {
        return true;
    }
    if (unicodeBlockLookup['Yi Radicals'](char)) {
        return true;
    }
    return false;
}
function charHasNeutralVerticalOrientation(char) {
    if (unicodeBlockLookup['Latin-1 Supplement'](char)) {
        if (char === 167 || char === 169 || char === 174 || char === 177 || char === 188 || char === 189 || char === 190 || char === 215 || char === 247) {
            return true;
        }
    }
    if (unicodeBlockLookup['General Punctuation'](char)) {
        if (char === 8214 || char === 8224 || char === 8225 || char === 8240 || char === 8241 || char === 8251 || char === 8252 || char === 8258 || char === 8263 || char === 8264 || char === 8265 || char === 8273) {
            return true;
        }
    }
    if (unicodeBlockLookup['Letterlike Symbols'](char)) {
        return true;
    }
    if (unicodeBlockLookup['Number Forms'](char)) {
        return true;
    }
    if (unicodeBlockLookup['Miscellaneous Technical'](char)) {
        if (char >= 8960 && char <= 8967 || char >= 8972 && char <= 8991 || char >= 8996 && char <= 9000 || char === 9003 || char >= 9085 && char <= 9114 || char >= 9150 && char <= 9165 || char === 9167 || char >= 9169 && char <= 9179 || char >= 9186 && char <= 9215) {
            return true;
        }
    }
    if (unicodeBlockLookup['Control Pictures'](char) && char !== 9251) {
        return true;
    }
    if (unicodeBlockLookup['Optical Character Recognition'](char)) {
        return true;
    }
    if (unicodeBlockLookup['Enclosed Alphanumerics'](char)) {
        return true;
    }
    if (unicodeBlockLookup['Geometric Shapes'](char)) {
        return true;
    }
    if (unicodeBlockLookup['Miscellaneous Symbols'](char)) {
        if (!(char >= 9754 && char <= 9759)) {
            return true;
        }
    }
    if (unicodeBlockLookup['Miscellaneous Symbols and Arrows'](char)) {
        if (char >= 11026 && char <= 11055 || char >= 11088 && char <= 11097 || char >= 11192 && char <= 11243) {
            return true;
        }
    }
    if (unicodeBlockLookup['CJK Symbols and Punctuation'](char)) {
        return true;
    }
    if (unicodeBlockLookup['Katakana'](char)) {
        return true;
    }
    if (unicodeBlockLookup['Private Use Area'](char)) {
        return true;
    }
    if (unicodeBlockLookup['CJK Compatibility Forms'](char)) {
        return true;
    }
    if (unicodeBlockLookup['Small Form Variants'](char)) {
        return true;
    }
    if (unicodeBlockLookup['Halfwidth and Fullwidth Forms'](char)) {
        return true;
    }
    if (char === 8734 || char === 8756 || char === 8757 || char >= 9984 && char <= 10087 || char >= 10102 && char <= 10131 || char === 65532 || char === 65533) {
        return true;
    }
    return false;
}
function charHasRotatedVerticalOrientation(char) {
    return !(charHasUprightVerticalOrientation(char) || charHasNeutralVerticalOrientation(char));
}
function charInComplexShapingScript(char) {
    return unicodeBlockLookup['Arabic'](char) || unicodeBlockLookup['Arabic Supplement'](char) || unicodeBlockLookup['Arabic Extended-A'](char) || unicodeBlockLookup['Arabic Presentation Forms-A'](char) || unicodeBlockLookup['Arabic Presentation Forms-B'](char);
}
function charInRTLScript(char) {
    return char >= 1424 && char <= 2303 || unicodeBlockLookup['Arabic Presentation Forms-A'](char) || unicodeBlockLookup['Arabic Presentation Forms-B'](char);
}
function charInSupportedScript(char, canRenderRTL) {
    if (!canRenderRTL && charInRTLScript(char)) {
        return false;
    }
    if (char >= 2304 && char <= 3583 || char >= 3840 && char <= 4255 || unicodeBlockLookup['Khmer'](char)) {
        return false;
    }
    return true;
}
function stringContainsRTLText(chars) {
    for (var i = 0, list = chars; i < list.length; i += 1) {
        var char = list[i];
        if (charInRTLScript(char.charCodeAt(0))) {
            return true;
        }
    }
    return false;
}
function isStringInSupportedScript(chars, canRenderRTL) {
    for (var i = 0, list = chars; i < list.length; i += 1) {
        var char = list[i];
        if (!charInSupportedScript(char.charCodeAt(0), canRenderRTL)) {
            return false;
        }
    }
    return true;
}

var status = {
    unavailable: 'unavailable',
    deferred: 'deferred',
    loading: 'loading',
    loaded: 'loaded',
    error: 'error'
};
var _completionCallback = null;
var pluginStatus = status.unavailable;
var pluginURL = null;
var triggerPluginCompletionEvent = function (error) {
    if (error && typeof error === 'string' && error.indexOf('NetworkError') > -1) {
        pluginStatus = status.error;
    }
    if (_completionCallback) {
        _completionCallback(error);
    }
};
function sendPluginStateToWorker() {
    evented.fire(new Event('pluginStateChange', {
        pluginStatus: pluginStatus,
        pluginURL: pluginURL
    }));
}
var evented = new Evented();
var getRTLTextPluginStatus = function () {
    return pluginStatus;
};
var registerForPluginStateChange = function (callback) {
    callback({
        pluginStatus: pluginStatus,
        pluginURL: pluginURL
    });
    evented.on('pluginStateChange', callback);
    return callback;
};
var setRTLTextPlugin = function (url, callback, deferred) {
    if (deferred === void 0)
        deferred = false;
    if (pluginStatus === status.deferred || pluginStatus === status.loading || pluginStatus === status.loaded) {
        throw new Error('setRTLTextPlugin cannot be called multiple times.');
    }
    pluginURL = exported.resolveURL(url);
    pluginStatus = status.deferred;
    _completionCallback = callback;
    sendPluginStateToWorker();
    if (!deferred) {
        downloadRTLTextPlugin();
    }
};
var downloadRTLTextPlugin = function () {
    if (pluginStatus !== status.deferred || !pluginURL) {
        throw new Error('rtl-text-plugin cannot be downloaded unless a pluginURL is specified');
    }
    pluginStatus = status.loading;
    sendPluginStateToWorker();
    if (pluginURL) {
        getArrayBuffer({ url: pluginURL }, function (error) {
            if (error) {
                triggerPluginCompletionEvent(error);
            } else {
                pluginStatus = status.loaded;
                sendPluginStateToWorker();
            }
        });
    }
};
var plugin = {
    applyArabicShaping: null,
    processBidirectionalText: null,
    processStyledBidirectionalText: null,
    isLoaded: function isLoaded() {
        return pluginStatus === status.loaded || plugin.applyArabicShaping != null;
    },
    isLoading: function isLoading() {
        return pluginStatus === status.loading;
    },
    setState: function setState(state) {
        pluginStatus = state.pluginStatus;
        pluginURL = state.pluginURL;
    },
    isParsed: function isParsed() {
        return plugin.applyArabicShaping != null && plugin.processBidirectionalText != null && plugin.processStyledBidirectionalText != null;
    },
    getPluginURL: function getPluginURL() {
        return pluginURL;
    }
};
var lazyLoadRTLTextPlugin = function () {
    if (!plugin.isLoading() && !plugin.isLoaded() && getRTLTextPluginStatus() === 'deferred') {
        downloadRTLTextPlugin();
    }
};

var EvaluationParameters = function EvaluationParameters(zoom, options) {
    this.zoom = zoom;
    if (options) {
        this.now = options.now;
        this.fadeDuration = options.fadeDuration;
        this.zoomHistory = options.zoomHistory;
        this.transition = options.transition;
    } else {
        this.now = 0;
        this.fadeDuration = 0;
        this.zoomHistory = new ZoomHistory();
        this.transition = {};
    }
};
EvaluationParameters.prototype.isSupportedScript = function isSupportedScript(str) {
    return isStringInSupportedScript(str, plugin.isLoaded());
};
EvaluationParameters.prototype.crossFadingFactor = function crossFadingFactor() {
    if (this.fadeDuration === 0) {
        return 1;
    } else {
        return Math.min((this.now - this.zoomHistory.lastIntegerZoomTime) / this.fadeDuration, 1);
    }
};
EvaluationParameters.prototype.getCrossfadeParameters = function getCrossfadeParameters() {
    var z = this.zoom;
    var fraction = z - Math.floor(z);
    var t = this.crossFadingFactor();
    return z > this.zoomHistory.lastIntegerZoom ? {
        fromScale: 2,
        toScale: 1,
        t: fraction + (1 - fraction) * t
    } : {
        fromScale: 0.5,
        toScale: 1,
        t: 1 - (1 - t) * fraction
    };
};

var PropertyValue = function PropertyValue(property, value) {
    this.property = property;
    this.value = value;
    this.expression = normalizePropertyExpression(value === undefined ? property.specification.default : value, property.specification);
};
PropertyValue.prototype.isDataDriven = function isDataDriven() {
    return this.expression.kind === 'source' || this.expression.kind === 'composite';
};
PropertyValue.prototype.possiblyEvaluate = function possiblyEvaluate(parameters, canonical, availableImages) {
    return this.property.possiblyEvaluate(this, parameters, canonical, availableImages);
};
var TransitionablePropertyValue = function TransitionablePropertyValue(property) {
    this.property = property;
    this.value = new PropertyValue(property, undefined);
};
TransitionablePropertyValue.prototype.transitioned = function transitioned(parameters, prior) {
    return new TransitioningPropertyValue(this.property, this.value, prior, extend({}, parameters.transition, this.transition), parameters.now);
};
TransitionablePropertyValue.prototype.untransitioned = function untransitioned() {
    return new TransitioningPropertyValue(this.property, this.value, null, {}, 0);
};
var Transitionable = function Transitionable(properties) {
    this._properties = properties;
    this._values = Object.create(properties.defaultTransitionablePropertyValues);
};
Transitionable.prototype.getValue = function getValue(name) {
    return clone(this._values[name].value.value);
};
Transitionable.prototype.setValue = function setValue(name, value) {
    if (!this._values.hasOwnProperty(name)) {
        this._values[name] = new TransitionablePropertyValue(this._values[name].property);
    }
    this._values[name].value = new PropertyValue(this._values[name].property, value === null ? undefined : clone(value));
};
Transitionable.prototype.getTransition = function getTransition(name) {
    return clone(this._values[name].transition);
};
Transitionable.prototype.setTransition = function setTransition(name, value) {
    if (!this._values.hasOwnProperty(name)) {
        this._values[name] = new TransitionablePropertyValue(this._values[name].property);
    }
    this._values[name].transition = clone(value) || undefined;
};
Transitionable.prototype.serialize = function serialize() {
    var result = {};
    for (var i = 0, list = Object.keys(this._values); i < list.length; i += 1) {
        var property = list[i];
        var value = this.getValue(property);
        if (value !== undefined) {
            result[property] = value;
        }
        var transition = this.getTransition(property);
        if (transition !== undefined) {
            result[property + '-transition'] = transition;
        }
    }
    return result;
};
Transitionable.prototype.transitioned = function transitioned(parameters, prior) {
    var result = new Transitioning(this._properties);
    for (var i = 0, list = Object.keys(this._values); i < list.length; i += 1) {
        var property = list[i];
        result._values[property] = this._values[property].transitioned(parameters, prior._values[property]);
    }
    return result;
};
Transitionable.prototype.untransitioned = function untransitioned() {
    var result = new Transitioning(this._properties);
    for (var i = 0, list = Object.keys(this._values); i < list.length; i += 1) {
        var property = list[i];
        result._values[property] = this._values[property].untransitioned();
    }
    return result;
};
var TransitioningPropertyValue = function TransitioningPropertyValue(property, value, prior, transition, now) {
    this.property = property;
    this.value = value;
    this.begin = now + transition.delay || 0;
    this.end = this.begin + transition.duration || 0;
    if (property.specification.transition && (transition.delay || transition.duration)) {
        this.prior = prior;
    }
};
TransitioningPropertyValue.prototype.possiblyEvaluate = function possiblyEvaluate(parameters, canonical, availableImages) {
    var now = parameters.now || 0;
    var finalValue = this.value.possiblyEvaluate(parameters, canonical, availableImages);
    var prior = this.prior;
    if (!prior) {
        return finalValue;
    } else if (now > this.end) {
        this.prior = null;
        return finalValue;
    } else if (this.value.isDataDriven()) {
        this.prior = null;
        return finalValue;
    } else if (now < this.begin) {
        return prior.possiblyEvaluate(parameters, canonical, availableImages);
    } else {
        var t = (now - this.begin) / (this.end - this.begin);
        return this.property.interpolate(prior.possiblyEvaluate(parameters, canonical, availableImages), finalValue, easeCubicInOut(t));
    }
};
var Transitioning = function Transitioning(properties) {
    this._properties = properties;
    this._values = Object.create(properties.defaultTransitioningPropertyValues);
};
Transitioning.prototype.possiblyEvaluate = function possiblyEvaluate(parameters, canonical, availableImages) {
    var result = new PossiblyEvaluated(this._properties);
    for (var i = 0, list = Object.keys(this._values); i < list.length; i += 1) {
        var property = list[i];
        result._values[property] = this._values[property].possiblyEvaluate(parameters, canonical, availableImages);
    }
    return result;
};
Transitioning.prototype.hasTransition = function hasTransition() {
    for (var i = 0, list = Object.keys(this._values); i < list.length; i += 1) {
        var property = list[i];
        if (this._values[property].prior) {
            return true;
        }
    }
    return false;
};
var Layout = function Layout(properties) {
    this._properties = properties;
    this._values = Object.create(properties.defaultPropertyValues);
};
Layout.prototype.getValue = function getValue(name) {
    return clone(this._values[name].value);
};
Layout.prototype.setValue = function setValue(name, value) {
    this._values[name] = new PropertyValue(this._values[name].property, value === null ? undefined : clone(value));
};
Layout.prototype.serialize = function serialize() {
    var result = {};
    for (var i = 0, list = Object.keys(this._values); i < list.length; i += 1) {
        var property = list[i];
        var value = this.getValue(property);
        if (value !== undefined) {
            result[property] = value;
        }
    }
    return result;
};
Layout.prototype.possiblyEvaluate = function possiblyEvaluate(parameters, canonical, availableImages) {
    var result = new PossiblyEvaluated(this._properties);
    for (var i = 0, list = Object.keys(this._values); i < list.length; i += 1) {
        var property = list[i];
        result._values[property] = this._values[property].possiblyEvaluate(parameters, canonical, availableImages);
    }
    return result;
};
var PossiblyEvaluatedPropertyValue = function PossiblyEvaluatedPropertyValue(property, value, parameters) {
    this.property = property;
    this.value = value;
    this.parameters = parameters;
};
PossiblyEvaluatedPropertyValue.prototype.isConstant = function isConstant() {
    return this.value.kind === 'constant';
};
PossiblyEvaluatedPropertyValue.prototype.constantOr = function constantOr(value) {
    if (this.value.kind === 'constant') {
        return this.value.value;
    } else {
        return value;
    }
};
PossiblyEvaluatedPropertyValue.prototype.evaluate = function evaluate(feature, featureState, canonical, availableImages) {
    return this.property.evaluate(this.value, this.parameters, feature, featureState, canonical, availableImages);
};
var PossiblyEvaluated = function PossiblyEvaluated(properties) {
    this._properties = properties;
    this._values = Object.create(properties.defaultPossiblyEvaluatedValues);
};
PossiblyEvaluated.prototype.get = function get(name) {
    return this._values[name];
};
var DataConstantProperty = function DataConstantProperty(specification) {
    this.specification = specification;
};
DataConstantProperty.prototype.possiblyEvaluate = function possiblyEvaluate(value, parameters) {
    return value.expression.evaluate(parameters);
};
DataConstantProperty.prototype.interpolate = function interpolate$1(a, b, t) {
    var interp = interpolate[this.specification.type];
    if (interp) {
        return interp(a, b, t);
    } else {
        return a;
    }
};
var DataDrivenProperty = function DataDrivenProperty(specification, overrides) {
    this.specification = specification;
    this.overrides = overrides;
};
DataDrivenProperty.prototype.possiblyEvaluate = function possiblyEvaluate(value, parameters, canonical, availableImages) {
    if (value.expression.kind === 'constant' || value.expression.kind === 'camera') {
        return new PossiblyEvaluatedPropertyValue(this, {
            kind: 'constant',
            value: value.expression.evaluate(parameters, null, {}, canonical, availableImages)
        }, parameters);
    } else {
        return new PossiblyEvaluatedPropertyValue(this, value.expression, parameters);
    }
};
DataDrivenProperty.prototype.interpolate = function interpolate$2(a, b, t) {
    if (a.value.kind !== 'constant' || b.value.kind !== 'constant') {
        return a;
    }
    if (a.value.value === undefined || b.value.value === undefined) {
        return new PossiblyEvaluatedPropertyValue(this, {
            kind: 'constant',
            value: undefined
        }, a.parameters);
    }
    var interp = interpolate[this.specification.type];
    if (interp) {
        return new PossiblyEvaluatedPropertyValue(this, {
            kind: 'constant',
            value: interp(a.value.value, b.value.value, t)
        }, a.parameters);
    } else {
        return a;
    }
};
DataDrivenProperty.prototype.evaluate = function evaluate(value, parameters, feature, featureState, canonical, availableImages) {
    if (value.kind === 'constant') {
        return value.value;
    } else {
        return value.evaluate(parameters, feature, featureState, canonical, availableImages);
    }
};
var CrossFadedDataDrivenProperty = function (DataDrivenProperty) {
    function CrossFadedDataDrivenProperty() {
        DataDrivenProperty.apply(this, arguments);
    }
    if (DataDrivenProperty)
        CrossFadedDataDrivenProperty.__proto__ = DataDrivenProperty;
    CrossFadedDataDrivenProperty.prototype = Object.create(DataDrivenProperty && DataDrivenProperty.prototype);
    CrossFadedDataDrivenProperty.prototype.constructor = CrossFadedDataDrivenProperty;
    CrossFadedDataDrivenProperty.prototype.possiblyEvaluate = function possiblyEvaluate(value, parameters, canonical, availableImages) {
        if (value.value === undefined) {
            return new PossiblyEvaluatedPropertyValue(this, {
                kind: 'constant',
                value: undefined
            }, parameters);
        } else if (value.expression.kind === 'constant') {
            var evaluatedValue = value.expression.evaluate(parameters, null, {}, canonical, availableImages);
            var isImageExpression = value.property.specification.type === 'resolvedImage';
            var constantValue = isImageExpression && typeof evaluatedValue !== 'string' ? evaluatedValue.name : evaluatedValue;
            var constant = this._calculate(constantValue, constantValue, constantValue, parameters);
            return new PossiblyEvaluatedPropertyValue(this, {
                kind: 'constant',
                value: constant
            }, parameters);
        } else if (value.expression.kind === 'camera') {
            var cameraVal = this._calculate(value.expression.evaluate({ zoom: parameters.zoom - 1 }), value.expression.evaluate({ zoom: parameters.zoom }), value.expression.evaluate({ zoom: parameters.zoom + 1 }), parameters);
            return new PossiblyEvaluatedPropertyValue(this, {
                kind: 'constant',
                value: cameraVal
            }, parameters);
        } else {
            return new PossiblyEvaluatedPropertyValue(this, value.expression, parameters);
        }
    };
    CrossFadedDataDrivenProperty.prototype.evaluate = function evaluate(value, globals, feature, featureState, canonical, availableImages) {
        if (value.kind === 'source') {
            var constant = value.evaluate(globals, feature, featureState, canonical, availableImages);
            return this._calculate(constant, constant, constant, globals);
        } else if (value.kind === 'composite') {
            return this._calculate(value.evaluate({ zoom: Math.floor(globals.zoom) - 1 }, feature, featureState), value.evaluate({ zoom: Math.floor(globals.zoom) }, feature, featureState), value.evaluate({ zoom: Math.floor(globals.zoom) + 1 }, feature, featureState), globals);
        } else {
            return value.value;
        }
    };
    CrossFadedDataDrivenProperty.prototype._calculate = function _calculate(min, mid, max, parameters) {
        var z = parameters.zoom;
        return z > parameters.zoomHistory.lastIntegerZoom ? {
            from: min,
            to: mid
        } : {
            from: max,
            to: mid
        };
    };
    CrossFadedDataDrivenProperty.prototype.interpolate = function interpolate(a) {
        return a;
    };
    return CrossFadedDataDrivenProperty;
}(DataDrivenProperty);
var CrossFadedProperty = function CrossFadedProperty(specification) {
    this.specification = specification;
};
CrossFadedProperty.prototype.possiblyEvaluate = function possiblyEvaluate(value, parameters, canonical, availableImages) {
    if (value.value === undefined) {
        return undefined;
    } else if (value.expression.kind === 'constant') {
        var constant = value.expression.evaluate(parameters, null, {}, canonical, availableImages);
        return this._calculate(constant, constant, constant, parameters);
    } else {
        return this._calculate(value.expression.evaluate(new EvaluationParameters(Math.floor(parameters.zoom - 1), parameters)), value.expression.evaluate(new EvaluationParameters(Math.floor(parameters.zoom), parameters)), value.expression.evaluate(new EvaluationParameters(Math.floor(parameters.zoom + 1), parameters)), parameters);
    }
};
CrossFadedProperty.prototype._calculate = function _calculate(min, mid, max, parameters) {
    var z = parameters.zoom;
    return z > parameters.zoomHistory.lastIntegerZoom ? {
        from: min,
        to: mid
    } : {
        from: max,
        to: mid
    };
};
CrossFadedProperty.prototype.interpolate = function interpolate(a) {
    return a;
};
var ColorRampProperty = function ColorRampProperty(specification) {
    this.specification = specification;
};
ColorRampProperty.prototype.possiblyEvaluate = function possiblyEvaluate(value, parameters, canonical, availableImages) {
    return !!value.expression.evaluate(parameters, null, {}, canonical, availableImages);
};
ColorRampProperty.prototype.interpolate = function interpolate() {
    return false;
};
var Properties = function Properties(properties) {
    this.properties = properties;
    this.defaultPropertyValues = {};
    this.defaultTransitionablePropertyValues = {};
    this.defaultTransitioningPropertyValues = {};
    this.defaultPossiblyEvaluatedValues = {};
    this.overridableProperties = [];
    for (var property in properties) {
        var prop = properties[property];
        if (prop.specification.overridable) {
            this.overridableProperties.push(property);
        }
        var defaultPropertyValue = this.defaultPropertyValues[property] = new PropertyValue(prop, undefined);
        var defaultTransitionablePropertyValue = this.defaultTransitionablePropertyValues[property] = new TransitionablePropertyValue(prop);
        this.defaultTransitioningPropertyValues[property] = defaultTransitionablePropertyValue.untransitioned();
        this.defaultPossiblyEvaluatedValues[property] = defaultPropertyValue.possiblyEvaluate({});
    }
};
register('DataDrivenProperty', DataDrivenProperty);
register('DataConstantProperty', DataConstantProperty);
register('CrossFadedDataDrivenProperty', CrossFadedDataDrivenProperty);
register('CrossFadedProperty', CrossFadedProperty);
register('ColorRampProperty', ColorRampProperty);

var TRANSITION_SUFFIX = '-transition';
var StyleLayer = function (Evented) {
    function StyleLayer(layer, properties) {
        Evented.call(this);
        this.id = layer.id;
        this.type = layer.type;
        this._featureFilter = {
            filter: function () {
                return true;
            },
            needGeometry: false
        };
        if (layer.type === 'custom') {
            return;
        }
        layer = layer;
        this.metadata = layer.metadata;
        this.minzoom = layer.minzoom;
        this.maxzoom = layer.maxzoom;
        if (layer.type !== 'background') {
            this.source = layer.source;
            this.sourceLayer = layer['source-layer'];
            this.filter = layer.filter;
        }
        if (properties.layout) {
            this._unevaluatedLayout = new Layout(properties.layout);
        }
        if (properties.paint) {
            this._transitionablePaint = new Transitionable(properties.paint);
            for (var property in layer.paint) {
                this.setPaintProperty(property, layer.paint[property], { validate: false });
            }
            for (var property$1 in layer.layout) {
                this.setLayoutProperty(property$1, layer.layout[property$1], { validate: false });
            }
            this._transitioningPaint = this._transitionablePaint.untransitioned();
            this.paint = new PossiblyEvaluated(properties.paint);
        }
    }
    if (Evented)
        StyleLayer.__proto__ = Evented;
    StyleLayer.prototype = Object.create(Evented && Evented.prototype);
    StyleLayer.prototype.constructor = StyleLayer;
    StyleLayer.prototype.getCrossfadeParameters = function getCrossfadeParameters() {
        return this._crossfadeParameters;
    };
    StyleLayer.prototype.getLayoutProperty = function getLayoutProperty(name) {
        if (name === 'visibility') {
            return this.visibility;
        }
        return this._unevaluatedLayout.getValue(name);
    };
    StyleLayer.prototype.setLayoutProperty = function setLayoutProperty(name, value, options) {
        if (options === void 0)
            options = {};
        if (value !== null && value !== undefined) {
            var key = 'layers.' + this.id + '.layout.' + name;
            if (this._validate(validateLayoutProperty$1, key, name, value, options)) {
                return;
            }
        }
        if (name === 'visibility') {
            this.visibility = value;
            return;
        }
        this._unevaluatedLayout.setValue(name, value);
    };
    StyleLayer.prototype.getPaintProperty = function getPaintProperty(name) {
        if (endsWith(name, TRANSITION_SUFFIX)) {
            return this._transitionablePaint.getTransition(name.slice(0, -TRANSITION_SUFFIX.length));
        } else {
            return this._transitionablePaint.getValue(name);
        }
    };
    StyleLayer.prototype.setPaintProperty = function setPaintProperty(name, value, options) {
        if (options === void 0)
            options = {};
        if (value !== null && value !== undefined) {
            var key = 'layers.' + this.id + '.paint.' + name;
            if (this._validate(validatePaintProperty$1, key, name, value, options)) {
                return false;
            }
        }
        if (endsWith(name, TRANSITION_SUFFIX)) {
            this._transitionablePaint.setTransition(name.slice(0, -TRANSITION_SUFFIX.length), value || undefined);
            return false;
        } else {
            var transitionable = this._transitionablePaint._values[name];
            var isCrossFadedProperty = transitionable.property.specification['property-type'] === 'cross-faded-data-driven';
            var wasDataDriven = transitionable.value.isDataDriven();
            var oldValue = transitionable.value;
            this._transitionablePaint.setValue(name, value);
            this._handleSpecialPaintPropertyUpdate(name);
            var newValue = this._transitionablePaint._values[name].value;
            var isDataDriven = newValue.isDataDriven();
            return isDataDriven || wasDataDriven || isCrossFadedProperty || this._handleOverridablePaintPropertyUpdate(name, oldValue, newValue);
        }
    };
    StyleLayer.prototype._handleSpecialPaintPropertyUpdate = function _handleSpecialPaintPropertyUpdate(_) {
    };
    StyleLayer.prototype._handleOverridablePaintPropertyUpdate = function _handleOverridablePaintPropertyUpdate(name, oldValue, newValue) {
        return false;
    };
    StyleLayer.prototype.isHidden = function isHidden(zoom) {
        if (this.minzoom && zoom < this.minzoom) {
            return true;
        }
        if (this.maxzoom && zoom >= this.maxzoom) {
            return true;
        }
        return this.visibility === 'none';
    };
    StyleLayer.prototype.updateTransitions = function updateTransitions(parameters) {
        this._transitioningPaint = this._transitionablePaint.transitioned(parameters, this._transitioningPaint);
    };
    StyleLayer.prototype.hasTransition = function hasTransition() {
        return this._transitioningPaint.hasTransition();
    };
    StyleLayer.prototype.recalculate = function recalculate(parameters, availableImages) {
        if (parameters.getCrossfadeParameters) {
            this._crossfadeParameters = parameters.getCrossfadeParameters();
        }
        if (this._unevaluatedLayout) {
            this.layout = this._unevaluatedLayout.possiblyEvaluate(parameters, undefined, availableImages);
        }
        this.paint = this._transitioningPaint.possiblyEvaluate(parameters, undefined, availableImages);
    };
    StyleLayer.prototype.serialize = function serialize() {
        var output = {
            'id': this.id,
            'type': this.type,
            'source': this.source,
            'source-layer': this.sourceLayer,
            'metadata': this.metadata,
            'minzoom': this.minzoom,
            'maxzoom': this.maxzoom,
            'filter': this.filter,
            'layout': this._unevaluatedLayout && this._unevaluatedLayout.serialize(),
            'paint': this._transitionablePaint && this._transitionablePaint.serialize()
        };
        if (this.visibility) {
            output.layout = output.layout || {};
            output.layout.visibility = this.visibility;
        }
        return filterObject(output, function (value, key) {
            return value !== undefined && !(key === 'layout' && !Object.keys(value).length) && !(key === 'paint' && !Object.keys(value).length);
        });
    };
    StyleLayer.prototype._validate = function _validate(validate, key, name, value, options) {
        if (options === void 0)
            options = {};
        if (options && options.validate === false) {
            return false;
        }
        return emitValidationErrors(this, validate.call(validateStyle, {
            key: key,
            layerType: this.type,
            objectKey: name,
            value: value,
            styleSpec: spec,
            style: {
                glyphs: true,
                sprite: true
            }
        }));
    };
    StyleLayer.prototype.is3D = function is3D() {
        return false;
    };
    StyleLayer.prototype.isTileClipped = function isTileClipped() {
        return false;
    };
    StyleLayer.prototype.hasOffscreenPass = function hasOffscreenPass() {
        return false;
    };
    StyleLayer.prototype.resize = function resize() {
    };
    StyleLayer.prototype.isStateDependent = function isStateDependent() {
        for (var property in this.paint._values) {
            var value = this.paint.get(property);
            if (!(value instanceof PossiblyEvaluatedPropertyValue) || !supportsPropertyExpression(value.property.specification)) {
                continue;
            }
            if ((value.value.kind === 'source' || value.value.kind === 'composite') && value.value.isStateDependent) {
                return true;
            }
        }
        return false;
    };
    return StyleLayer;
}(Evented);

var viewTypes = {
    'Int8': Int8Array,
    'Uint8': Uint8Array,
    'Int16': Int16Array,
    'Uint16': Uint16Array,
    'Int32': Int32Array,
    'Uint32': Uint32Array,
    'Float32': Float32Array
};
var Struct = function Struct(structArray, index) {
    this._structArray = structArray;
    this._pos1 = index * this.size;
    this._pos2 = this._pos1 / 2;
    this._pos4 = this._pos1 / 4;
    this._pos8 = this._pos1 / 8;
};
var DEFAULT_CAPACITY = 128;
var RESIZE_MULTIPLIER = 5;
var StructArray = function StructArray() {
    this.isTransferred = false;
    this.capacity = -1;
    this.resize(0);
};
StructArray.serialize = function serialize(array, transferables) {
    array._trim();
    if (transferables) {
        array.isTransferred = true;
        transferables.push(array.arrayBuffer);
    }
    return {
        length: array.length,
        arrayBuffer: array.arrayBuffer
    };
};
StructArray.deserialize = function deserialize(input) {
    var structArray = Object.create(this.prototype);
    structArray.arrayBuffer = input.arrayBuffer;
    structArray.length = input.length;
    structArray.capacity = input.arrayBuffer.byteLength / structArray.bytesPerElement;
    structArray._refreshViews();
    return structArray;
};
StructArray.prototype._trim = function _trim() {
    if (this.length !== this.capacity) {
        this.capacity = this.length;
        this.arrayBuffer = this.arrayBuffer.slice(0, this.length * this.bytesPerElement);
        this._refreshViews();
    }
};
StructArray.prototype.clear = function clear() {
    this.length = 0;
};
StructArray.prototype.resize = function resize(n) {
    this.reserve(n);
    this.length = n;
};
StructArray.prototype.reserve = function reserve(n) {
    if (n > this.capacity) {
        this.capacity = Math.max(n, Math.floor(this.capacity * RESIZE_MULTIPLIER), DEFAULT_CAPACITY);
        this.arrayBuffer = new ArrayBuffer(this.capacity * this.bytesPerElement);
        var oldUint8Array = this.uint8;
        this._refreshViews();
        if (oldUint8Array) {
            this.uint8.set(oldUint8Array);
        }
    }
};
StructArray.prototype._refreshViews = function _refreshViews() {
    throw new Error('_refreshViews() must be implemented by each concrete StructArray layout');
};
function createLayout(members, alignment) {
    if (alignment === void 0)
        alignment = 1;
    var offset = 0;
    var maxSize = 0;
    var layoutMembers = members.map(function (member) {
        var typeSize = sizeOf(member.type);
        var memberOffset = offset = align(offset, Math.max(alignment, typeSize));
        var components = member.components || 1;
        maxSize = Math.max(maxSize, typeSize);
        offset += typeSize * components;
        return {
            name: member.name,
            type: member.type,
            components: components,
            offset: memberOffset
        };
    });
    var size = align(offset, Math.max(maxSize, alignment));
    return {
        members: layoutMembers,
        size: size,
        alignment: alignment
    };
}
function sizeOf(type) {
    return viewTypes[type].BYTES_PER_ELEMENT;
}
function align(offset, size) {
    return Math.ceil(offset / size) * size;
}

var StructArrayLayout2i4 = function (StructArray) {
    function StructArrayLayout2i4() {
        StructArray.apply(this, arguments);
    }
    if (StructArray)
        StructArrayLayout2i4.__proto__ = StructArray;
    StructArrayLayout2i4.prototype = Object.create(StructArray && StructArray.prototype);
    StructArrayLayout2i4.prototype.constructor = StructArrayLayout2i4;
    StructArrayLayout2i4.prototype._refreshViews = function _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer);
        this.int16 = new Int16Array(this.arrayBuffer);
    };
    StructArrayLayout2i4.prototype.emplaceBack = function emplaceBack(v0, v1) {
        var i = this.length;
        this.resize(i + 1);
        return this.emplace(i, v0, v1);
    };
    StructArrayLayout2i4.prototype.emplace = function emplace(i, v0, v1) {
        var o2 = i * 2;
        this.int16[o2 + 0] = v0;
        this.int16[o2 + 1] = v1;
        return i;
    };
    return StructArrayLayout2i4;
}(StructArray);
StructArrayLayout2i4.prototype.bytesPerElement = 4;
register('StructArrayLayout2i4', StructArrayLayout2i4);
var StructArrayLayout4i8 = function (StructArray) {
    function StructArrayLayout4i8() {
        StructArray.apply(this, arguments);
    }
    if (StructArray)
        StructArrayLayout4i8.__proto__ = StructArray;
    StructArrayLayout4i8.prototype = Object.create(StructArray && StructArray.prototype);
    StructArrayLayout4i8.prototype.constructor = StructArrayLayout4i8;
    StructArrayLayout4i8.prototype._refreshViews = function _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer);
        this.int16 = new Int16Array(this.arrayBuffer);
    };
    StructArrayLayout4i8.prototype.emplaceBack = function emplaceBack(v0, v1, v2, v3) {
        var i = this.length;
        this.resize(i + 1);
        return this.emplace(i, v0, v1, v2, v3);
    };
    StructArrayLayout4i8.prototype.emplace = function emplace(i, v0, v1, v2, v3) {
        var o2 = i * 4;
        this.int16[o2 + 0] = v0;
        this.int16[o2 + 1] = v1;
        this.int16[o2 + 2] = v2;
        this.int16[o2 + 3] = v3;
        return i;
    };
    return StructArrayLayout4i8;
}(StructArray);
StructArrayLayout4i8.prototype.bytesPerElement = 8;
register('StructArrayLayout4i8', StructArrayLayout4i8);
var StructArrayLayout2i4i12 = function (StructArray) {
    function StructArrayLayout2i4i12() {
        StructArray.apply(this, arguments);
    }
    if (StructArray)
        StructArrayLayout2i4i12.__proto__ = StructArray;
    StructArrayLayout2i4i12.prototype = Object.create(StructArray && StructArray.prototype);
    StructArrayLayout2i4i12.prototype.constructor = StructArrayLayout2i4i12;
    StructArrayLayout2i4i12.prototype._refreshViews = function _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer);
        this.int16 = new Int16Array(this.arrayBuffer);
    };
    StructArrayLayout2i4i12.prototype.emplaceBack = function emplaceBack(v0, v1, v2, v3, v4, v5) {
        var i = this.length;
        this.resize(i + 1);
        return this.emplace(i, v0, v1, v2, v3, v4, v5);
    };
    StructArrayLayout2i4i12.prototype.emplace = function emplace(i, v0, v1, v2, v3, v4, v5) {
        var o2 = i * 6;
        this.int16[o2 + 0] = v0;
        this.int16[o2 + 1] = v1;
        this.int16[o2 + 2] = v2;
        this.int16[o2 + 3] = v3;
        this.int16[o2 + 4] = v4;
        this.int16[o2 + 5] = v5;
        return i;
    };
    return StructArrayLayout2i4i12;
}(StructArray);
StructArrayLayout2i4i12.prototype.bytesPerElement = 12;
register('StructArrayLayout2i4i12', StructArrayLayout2i4i12);
var StructArrayLayout2i4ub8 = function (StructArray) {
    function StructArrayLayout2i4ub8() {
        StructArray.apply(this, arguments);
    }
    if (StructArray)
        StructArrayLayout2i4ub8.__proto__ = StructArray;
    StructArrayLayout2i4ub8.prototype = Object.create(StructArray && StructArray.prototype);
    StructArrayLayout2i4ub8.prototype.constructor = StructArrayLayout2i4ub8;
    StructArrayLayout2i4ub8.prototype._refreshViews = function _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer);
        this.int16 = new Int16Array(this.arrayBuffer);
    };
    StructArrayLayout2i4ub8.prototype.emplaceBack = function emplaceBack(v0, v1, v2, v3, v4, v5) {
        var i = this.length;
        this.resize(i + 1);
        return this.emplace(i, v0, v1, v2, v3, v4, v5);
    };
    StructArrayLayout2i4ub8.prototype.emplace = function emplace(i, v0, v1, v2, v3, v4, v5) {
        var o2 = i * 4;
        var o1 = i * 8;
        this.int16[o2 + 0] = v0;
        this.int16[o2 + 1] = v1;
        this.uint8[o1 + 4] = v2;
        this.uint8[o1 + 5] = v3;
        this.uint8[o1 + 6] = v4;
        this.uint8[o1 + 7] = v5;
        return i;
    };
    return StructArrayLayout2i4ub8;
}(StructArray);
StructArrayLayout2i4ub8.prototype.bytesPerElement = 8;
register('StructArrayLayout2i4ub8', StructArrayLayout2i4ub8);
var StructArrayLayout2f8 = function (StructArray) {
    function StructArrayLayout2f8() {
        StructArray.apply(this, arguments);
    }
    if (StructArray)
        StructArrayLayout2f8.__proto__ = StructArray;
    StructArrayLayout2f8.prototype = Object.create(StructArray && StructArray.prototype);
    StructArrayLayout2f8.prototype.constructor = StructArrayLayout2f8;
    StructArrayLayout2f8.prototype._refreshViews = function _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer);
        this.float32 = new Float32Array(this.arrayBuffer);
    };
    StructArrayLayout2f8.prototype.emplaceBack = function emplaceBack(v0, v1) {
        var i = this.length;
        this.resize(i + 1);
        return this.emplace(i, v0, v1);
    };
    StructArrayLayout2f8.prototype.emplace = function emplace(i, v0, v1) {
        var o4 = i * 2;
        this.float32[o4 + 0] = v0;
        this.float32[o4 + 1] = v1;
        return i;
    };
    return StructArrayLayout2f8;
}(StructArray);
StructArrayLayout2f8.prototype.bytesPerElement = 8;
register('StructArrayLayout2f8', StructArrayLayout2f8);
var StructArrayLayout10ui20 = function (StructArray) {
    function StructArrayLayout10ui20() {
        StructArray.apply(this, arguments);
    }
    if (StructArray)
        StructArrayLayout10ui20.__proto__ = StructArray;
    StructArrayLayout10ui20.prototype = Object.create(StructArray && StructArray.prototype);
    StructArrayLayout10ui20.prototype.constructor = StructArrayLayout10ui20;
    StructArrayLayout10ui20.prototype._refreshViews = function _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer);
        this.uint16 = new Uint16Array(this.arrayBuffer);
    };
    StructArrayLayout10ui20.prototype.emplaceBack = function emplaceBack(v0, v1, v2, v3, v4, v5, v6, v7, v8, v9) {
        var i = this.length;
        this.resize(i + 1);
        return this.emplace(i, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9);
    };
    StructArrayLayout10ui20.prototype.emplace = function emplace(i, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9) {
        var o2 = i * 10;
        this.uint16[o2 + 0] = v0;
        this.uint16[o2 + 1] = v1;
        this.uint16[o2 + 2] = v2;
        this.uint16[o2 + 3] = v3;
        this.uint16[o2 + 4] = v4;
        this.uint16[o2 + 5] = v5;
        this.uint16[o2 + 6] = v6;
        this.uint16[o2 + 7] = v7;
        this.uint16[o2 + 8] = v8;
        this.uint16[o2 + 9] = v9;
        return i;
    };
    return StructArrayLayout10ui20;
}(StructArray);
StructArrayLayout10ui20.prototype.bytesPerElement = 20;
register('StructArrayLayout10ui20', StructArrayLayout10ui20);
var StructArrayLayout4i4ui4i24 = function (StructArray) {
    function StructArrayLayout4i4ui4i24() {
        StructArray.apply(this, arguments);
    }
    if (StructArray)
        StructArrayLayout4i4ui4i24.__proto__ = StructArray;
    StructArrayLayout4i4ui4i24.prototype = Object.create(StructArray && StructArray.prototype);
    StructArrayLayout4i4ui4i24.prototype.constructor = StructArrayLayout4i4ui4i24;
    StructArrayLayout4i4ui4i24.prototype._refreshViews = function _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer);
        this.int16 = new Int16Array(this.arrayBuffer);
        this.uint16 = new Uint16Array(this.arrayBuffer);
    };
    StructArrayLayout4i4ui4i24.prototype.emplaceBack = function emplaceBack(v0, v1, v2, v3, v4, v5, v6, v7, v8, v9, v10, v11) {
        var i = this.length;
        this.resize(i + 1);
        return this.emplace(i, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9, v10, v11);
    };
    StructArrayLayout4i4ui4i24.prototype.emplace = function emplace(i, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9, v10, v11) {
        var o2 = i * 12;
        this.int16[o2 + 0] = v0;
        this.int16[o2 + 1] = v1;
        this.int16[o2 + 2] = v2;
        this.int16[o2 + 3] = v3;
        this.uint16[o2 + 4] = v4;
        this.uint16[o2 + 5] = v5;
        this.uint16[o2 + 6] = v6;
        this.uint16[o2 + 7] = v7;
        this.int16[o2 + 8] = v8;
        this.int16[o2 + 9] = v9;
        this.int16[o2 + 10] = v10;
        this.int16[o2 + 11] = v11;
        return i;
    };
    return StructArrayLayout4i4ui4i24;
}(StructArray);
StructArrayLayout4i4ui4i24.prototype.bytesPerElement = 24;
register('StructArrayLayout4i4ui4i24', StructArrayLayout4i4ui4i24);
var StructArrayLayout3f12 = function (StructArray) {
    function StructArrayLayout3f12() {
        StructArray.apply(this, arguments);
    }
    if (StructArray)
        StructArrayLayout3f12.__proto__ = StructArray;
    StructArrayLayout3f12.prototype = Object.create(StructArray && StructArray.prototype);
    StructArrayLayout3f12.prototype.constructor = StructArrayLayout3f12;
    StructArrayLayout3f12.prototype._refreshViews = function _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer);
        this.float32 = new Float32Array(this.arrayBuffer);
    };
    StructArrayLayout3f12.prototype.emplaceBack = function emplaceBack(v0, v1, v2) {
        var i = this.length;
        this.resize(i + 1);
        return this.emplace(i, v0, v1, v2);
    };
    StructArrayLayout3f12.prototype.emplace = function emplace(i, v0, v1, v2) {
        var o4 = i * 3;
        this.float32[o4 + 0] = v0;
        this.float32[o4 + 1] = v1;
        this.float32[o4 + 2] = v2;
        return i;
    };
    return StructArrayLayout3f12;
}(StructArray);
StructArrayLayout3f12.prototype.bytesPerElement = 12;
register('StructArrayLayout3f12', StructArrayLayout3f12);
var StructArrayLayout1ul4 = function (StructArray) {
    function StructArrayLayout1ul4() {
        StructArray.apply(this, arguments);
    }
    if (StructArray)
        StructArrayLayout1ul4.__proto__ = StructArray;
    StructArrayLayout1ul4.prototype = Object.create(StructArray && StructArray.prototype);
    StructArrayLayout1ul4.prototype.constructor = StructArrayLayout1ul4;
    StructArrayLayout1ul4.prototype._refreshViews = function _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer);
        this.uint32 = new Uint32Array(this.arrayBuffer);
    };
    StructArrayLayout1ul4.prototype.emplaceBack = function emplaceBack(v0) {
        var i = this.length;
        this.resize(i + 1);
        return this.emplace(i, v0);
    };
    StructArrayLayout1ul4.prototype.emplace = function emplace(i, v0) {
        var o4 = i * 1;
        this.uint32[o4 + 0] = v0;
        return i;
    };
    return StructArrayLayout1ul4;
}(StructArray);
StructArrayLayout1ul4.prototype.bytesPerElement = 4;
register('StructArrayLayout1ul4', StructArrayLayout1ul4);
var StructArrayLayout6i1ul2ui20 = function (StructArray) {
    function StructArrayLayout6i1ul2ui20() {
        StructArray.apply(this, arguments);
    }
    if (StructArray)
        StructArrayLayout6i1ul2ui20.__proto__ = StructArray;
    StructArrayLayout6i1ul2ui20.prototype = Object.create(StructArray && StructArray.prototype);
    StructArrayLayout6i1ul2ui20.prototype.constructor = StructArrayLayout6i1ul2ui20;
    StructArrayLayout6i1ul2ui20.prototype._refreshViews = function _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer);
        this.int16 = new Int16Array(this.arrayBuffer);
        this.uint32 = new Uint32Array(this.arrayBuffer);
        this.uint16 = new Uint16Array(this.arrayBuffer);
    };
    StructArrayLayout6i1ul2ui20.prototype.emplaceBack = function emplaceBack(v0, v1, v2, v3, v4, v5, v6, v7, v8) {
        var i = this.length;
        this.resize(i + 1);
        return this.emplace(i, v0, v1, v2, v3, v4, v5, v6, v7, v8);
    };
    StructArrayLayout6i1ul2ui20.prototype.emplace = function emplace(i, v0, v1, v2, v3, v4, v5, v6, v7, v8) {
        var o2 = i * 10;
        var o4 = i * 5;
        this.int16[o2 + 0] = v0;
        this.int16[o2 + 1] = v1;
        this.int16[o2 + 2] = v2;
        this.int16[o2 + 3] = v3;
        this.int16[o2 + 4] = v4;
        this.int16[o2 + 5] = v5;
        this.uint32[o4 + 3] = v6;
        this.uint16[o2 + 8] = v7;
        this.uint16[o2 + 9] = v8;
        return i;
    };
    return StructArrayLayout6i1ul2ui20;
}(StructArray);
StructArrayLayout6i1ul2ui20.prototype.bytesPerElement = 20;
register('StructArrayLayout6i1ul2ui20', StructArrayLayout6i1ul2ui20);
var StructArrayLayout2i2i2i12 = function (StructArray) {
    function StructArrayLayout2i2i2i12() {
        StructArray.apply(this, arguments);
    }
    if (StructArray)
        StructArrayLayout2i2i2i12.__proto__ = StructArray;
    StructArrayLayout2i2i2i12.prototype = Object.create(StructArray && StructArray.prototype);
    StructArrayLayout2i2i2i12.prototype.constructor = StructArrayLayout2i2i2i12;
    StructArrayLayout2i2i2i12.prototype._refreshViews = function _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer);
        this.int16 = new Int16Array(this.arrayBuffer);
    };
    StructArrayLayout2i2i2i12.prototype.emplaceBack = function emplaceBack(v0, v1, v2, v3, v4, v5) {
        var i = this.length;
        this.resize(i + 1);
        return this.emplace(i, v0, v1, v2, v3, v4, v5);
    };
    StructArrayLayout2i2i2i12.prototype.emplace = function emplace(i, v0, v1, v2, v3, v4, v5) {
        var o2 = i * 6;
        this.int16[o2 + 0] = v0;
        this.int16[o2 + 1] = v1;
        this.int16[o2 + 2] = v2;
        this.int16[o2 + 3] = v3;
        this.int16[o2 + 4] = v4;
        this.int16[o2 + 5] = v5;
        return i;
    };
    return StructArrayLayout2i2i2i12;
}(StructArray);
StructArrayLayout2i2i2i12.prototype.bytesPerElement = 12;
register('StructArrayLayout2i2i2i12', StructArrayLayout2i2i2i12);
var StructArrayLayout2f1f2i16 = function (StructArray) {
    function StructArrayLayout2f1f2i16() {
        StructArray.apply(this, arguments);
    }
    if (StructArray)
        StructArrayLayout2f1f2i16.__proto__ = StructArray;
    StructArrayLayout2f1f2i16.prototype = Object.create(StructArray && StructArray.prototype);
    StructArrayLayout2f1f2i16.prototype.constructor = StructArrayLayout2f1f2i16;
    StructArrayLayout2f1f2i16.prototype._refreshViews = function _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer);
        this.float32 = new Float32Array(this.arrayBuffer);
        this.int16 = new Int16Array(this.arrayBuffer);
    };
    StructArrayLayout2f1f2i16.prototype.emplaceBack = function emplaceBack(v0, v1, v2, v3, v4) {
        var i = this.length;
        this.resize(i + 1);
        return this.emplace(i, v0, v1, v2, v3, v4);
    };
    StructArrayLayout2f1f2i16.prototype.emplace = function emplace(i, v0, v1, v2, v3, v4) {
        var o4 = i * 4;
        var o2 = i * 8;
        this.float32[o4 + 0] = v0;
        this.float32[o4 + 1] = v1;
        this.float32[o4 + 2] = v2;
        this.int16[o2 + 6] = v3;
        this.int16[o2 + 7] = v4;
        return i;
    };
    return StructArrayLayout2f1f2i16;
}(StructArray);
StructArrayLayout2f1f2i16.prototype.bytesPerElement = 16;
register('StructArrayLayout2f1f2i16', StructArrayLayout2f1f2i16);
var StructArrayLayout2ub2f12 = function (StructArray) {
    function StructArrayLayout2ub2f12() {
        StructArray.apply(this, arguments);
    }
    if (StructArray)
        StructArrayLayout2ub2f12.__proto__ = StructArray;
    StructArrayLayout2ub2f12.prototype = Object.create(StructArray && StructArray.prototype);
    StructArrayLayout2ub2f12.prototype.constructor = StructArrayLayout2ub2f12;
    StructArrayLayout2ub2f12.prototype._refreshViews = function _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer);
        this.float32 = new Float32Array(this.arrayBuffer);
    };
    StructArrayLayout2ub2f12.prototype.emplaceBack = function emplaceBack(v0, v1, v2, v3) {
        var i = this.length;
        this.resize(i + 1);
        return this.emplace(i, v0, v1, v2, v3);
    };
    StructArrayLayout2ub2f12.prototype.emplace = function emplace(i, v0, v1, v2, v3) {
        var o1 = i * 12;
        var o4 = i * 3;
        this.uint8[o1 + 0] = v0;
        this.uint8[o1 + 1] = v1;
        this.float32[o4 + 1] = v2;
        this.float32[o4 + 2] = v3;
        return i;
    };
    return StructArrayLayout2ub2f12;
}(StructArray);
StructArrayLayout2ub2f12.prototype.bytesPerElement = 12;
register('StructArrayLayout2ub2f12', StructArrayLayout2ub2f12);
var StructArrayLayout3ui6 = function (StructArray) {
    function StructArrayLayout3ui6() {
        StructArray.apply(this, arguments);
    }
    if (StructArray)
        StructArrayLayout3ui6.__proto__ = StructArray;
    StructArrayLayout3ui6.prototype = Object.create(StructArray && StructArray.prototype);
    StructArrayLayout3ui6.prototype.constructor = StructArrayLayout3ui6;
    StructArrayLayout3ui6.prototype._refreshViews = function _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer);
        this.uint16 = new Uint16Array(this.arrayBuffer);
    };
    StructArrayLayout3ui6.prototype.emplaceBack = function emplaceBack(v0, v1, v2) {
        var i = this.length;
        this.resize(i + 1);
        return this.emplace(i, v0, v1, v2);
    };
    StructArrayLayout3ui6.prototype.emplace = function emplace(i, v0, v1, v2) {
        var o2 = i * 3;
        this.uint16[o2 + 0] = v0;
        this.uint16[o2 + 1] = v1;
        this.uint16[o2 + 2] = v2;
        return i;
    };
    return StructArrayLayout3ui6;
}(StructArray);
StructArrayLayout3ui6.prototype.bytesPerElement = 6;
register('StructArrayLayout3ui6', StructArrayLayout3ui6);
var StructArrayLayout2i2ui3ul3ui2f3ub1ul1i48 = function (StructArray) {
    function StructArrayLayout2i2ui3ul3ui2f3ub1ul1i48() {
        StructArray.apply(this, arguments);
    }
    if (StructArray)
        StructArrayLayout2i2ui3ul3ui2f3ub1ul1i48.__proto__ = StructArray;
    StructArrayLayout2i2ui3ul3ui2f3ub1ul1i48.prototype = Object.create(StructArray && StructArray.prototype);
    StructArrayLayout2i2ui3ul3ui2f3ub1ul1i48.prototype.constructor = StructArrayLayout2i2ui3ul3ui2f3ub1ul1i48;
    StructArrayLayout2i2ui3ul3ui2f3ub1ul1i48.prototype._refreshViews = function _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer);
        this.int16 = new Int16Array(this.arrayBuffer);
        this.uint16 = new Uint16Array(this.arrayBuffer);
        this.uint32 = new Uint32Array(this.arrayBuffer);
        this.float32 = new Float32Array(this.arrayBuffer);
    };
    StructArrayLayout2i2ui3ul3ui2f3ub1ul1i48.prototype.emplaceBack = function emplaceBack(v0, v1, v2, v3, v4, v5, v6, v7, v8, v9, v10, v11, v12, v13, v14, v15, v16) {
        var i = this.length;
        this.resize(i + 1);
        return this.emplace(i, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9, v10, v11, v12, v13, v14, v15, v16);
    };
    StructArrayLayout2i2ui3ul3ui2f3ub1ul1i48.prototype.emplace = function emplace(i, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9, v10, v11, v12, v13, v14, v15, v16) {
        var o2 = i * 24;
        var o4 = i * 12;
        var o1 = i * 48;
        this.int16[o2 + 0] = v0;
        this.int16[o2 + 1] = v1;
        this.uint16[o2 + 2] = v2;
        this.uint16[o2 + 3] = v3;
        this.uint32[o4 + 2] = v4;
        this.uint32[o4 + 3] = v5;
        this.uint32[o4 + 4] = v6;
        this.uint16[o2 + 10] = v7;
        this.uint16[o2 + 11] = v8;
        this.uint16[o2 + 12] = v9;
        this.float32[o4 + 7] = v10;
        this.float32[o4 + 8] = v11;
        this.uint8[o1 + 36] = v12;
        this.uint8[o1 + 37] = v13;
        this.uint8[o1 + 38] = v14;
        this.uint32[o4 + 10] = v15;
        this.int16[o2 + 22] = v16;
        return i;
    };
    return StructArrayLayout2i2ui3ul3ui2f3ub1ul1i48;
}(StructArray);
StructArrayLayout2i2ui3ul3ui2f3ub1ul1i48.prototype.bytesPerElement = 48;
register('StructArrayLayout2i2ui3ul3ui2f3ub1ul1i48', StructArrayLayout2i2ui3ul3ui2f3ub1ul1i48);
var StructArrayLayout8i15ui1ul4f68 = function (StructArray) {
    function StructArrayLayout8i15ui1ul4f68() {
        StructArray.apply(this, arguments);
    }
    if (StructArray)
        StructArrayLayout8i15ui1ul4f68.__proto__ = StructArray;
    StructArrayLayout8i15ui1ul4f68.prototype = Object.create(StructArray && StructArray.prototype);
    StructArrayLayout8i15ui1ul4f68.prototype.constructor = StructArrayLayout8i15ui1ul4f68;
    StructArrayLayout8i15ui1ul4f68.prototype._refreshViews = function _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer);
        this.int16 = new Int16Array(this.arrayBuffer);
        this.uint16 = new Uint16Array(this.arrayBuffer);
        this.uint32 = new Uint32Array(this.arrayBuffer);
        this.float32 = new Float32Array(this.arrayBuffer);
    };
    StructArrayLayout8i15ui1ul4f68.prototype.emplaceBack = function emplaceBack(v0, v1, v2, v3, v4, v5, v6, v7, v8, v9, v10, v11, v12, v13, v14, v15, v16, v17, v18, v19, v20, v21, v22, v23, v24, v25, v26, v27) {
        var i = this.length;
        this.resize(i + 1);
        return this.emplace(i, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9, v10, v11, v12, v13, v14, v15, v16, v17, v18, v19, v20, v21, v22, v23, v24, v25, v26, v27);
    };
    StructArrayLayout8i15ui1ul4f68.prototype.emplace = function emplace(i, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9, v10, v11, v12, v13, v14, v15, v16, v17, v18, v19, v20, v21, v22, v23, v24, v25, v26, v27) {
        var o2 = i * 34;
        var o4 = i * 17;
        this.int16[o2 + 0] = v0;
        this.int16[o2 + 1] = v1;
        this.int16[o2 + 2] = v2;
        this.int16[o2 + 3] = v3;
        this.int16[o2 + 4] = v4;
        this.int16[o2 + 5] = v5;
        this.int16[o2 + 6] = v6;
        this.int16[o2 + 7] = v7;
        this.uint16[o2 + 8] = v8;
        this.uint16[o2 + 9] = v9;
        this.uint16[o2 + 10] = v10;
        this.uint16[o2 + 11] = v11;
        this.uint16[o2 + 12] = v12;
        this.uint16[o2 + 13] = v13;
        this.uint16[o2 + 14] = v14;
        this.uint16[o2 + 15] = v15;
        this.uint16[o2 + 16] = v16;
        this.uint16[o2 + 17] = v17;
        this.uint16[o2 + 18] = v18;
        this.uint16[o2 + 19] = v19;
        this.uint16[o2 + 20] = v20;
        this.uint16[o2 + 21] = v21;
        this.uint16[o2 + 22] = v22;
        this.uint32[o4 + 12] = v23;
        this.float32[o4 + 13] = v24;
        this.float32[o4 + 14] = v25;
        this.float32[o4 + 15] = v26;
        this.float32[o4 + 16] = v27;
        return i;
    };
    return StructArrayLayout8i15ui1ul4f68;
}(StructArray);
StructArrayLayout8i15ui1ul4f68.prototype.bytesPerElement = 68;
register('StructArrayLayout8i15ui1ul4f68', StructArrayLayout8i15ui1ul4f68);
var StructArrayLayout1f4 = function (StructArray) {
    function StructArrayLayout1f4() {
        StructArray.apply(this, arguments);
    }
    if (StructArray)
        StructArrayLayout1f4.__proto__ = StructArray;
    StructArrayLayout1f4.prototype = Object.create(StructArray && StructArray.prototype);
    StructArrayLayout1f4.prototype.constructor = StructArrayLayout1f4;
    StructArrayLayout1f4.prototype._refreshViews = function _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer);
        this.float32 = new Float32Array(this.arrayBuffer);
    };
    StructArrayLayout1f4.prototype.emplaceBack = function emplaceBack(v0) {
        var i = this.length;
        this.resize(i + 1);
        return this.emplace(i, v0);
    };
    StructArrayLayout1f4.prototype.emplace = function emplace(i, v0) {
        var o4 = i * 1;
        this.float32[o4 + 0] = v0;
        return i;
    };
    return StructArrayLayout1f4;
}(StructArray);
StructArrayLayout1f4.prototype.bytesPerElement = 4;
register('StructArrayLayout1f4', StructArrayLayout1f4);
var StructArrayLayout3i6 = function (StructArray) {
    function StructArrayLayout3i6() {
        StructArray.apply(this, arguments);
    }
    if (StructArray)
        StructArrayLayout3i6.__proto__ = StructArray;
    StructArrayLayout3i6.prototype = Object.create(StructArray && StructArray.prototype);
    StructArrayLayout3i6.prototype.constructor = StructArrayLayout3i6;
    StructArrayLayout3i6.prototype._refreshViews = function _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer);
        this.int16 = new Int16Array(this.arrayBuffer);
    };
    StructArrayLayout3i6.prototype.emplaceBack = function emplaceBack(v0, v1, v2) {
        var i = this.length;
        this.resize(i + 1);
        return this.emplace(i, v0, v1, v2);
    };
    StructArrayLayout3i6.prototype.emplace = function emplace(i, v0, v1, v2) {
        var o2 = i * 3;
        this.int16[o2 + 0] = v0;
        this.int16[o2 + 1] = v1;
        this.int16[o2 + 2] = v2;
        return i;
    };
    return StructArrayLayout3i6;
}(StructArray);
StructArrayLayout3i6.prototype.bytesPerElement = 6;
register('StructArrayLayout3i6', StructArrayLayout3i6);
var StructArrayLayout1ul2ui8 = function (StructArray) {
    function StructArrayLayout1ul2ui8() {
        StructArray.apply(this, arguments);
    }
    if (StructArray)
        StructArrayLayout1ul2ui8.__proto__ = StructArray;
    StructArrayLayout1ul2ui8.prototype = Object.create(StructArray && StructArray.prototype);
    StructArrayLayout1ul2ui8.prototype.constructor = StructArrayLayout1ul2ui8;
    StructArrayLayout1ul2ui8.prototype._refreshViews = function _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer);
        this.uint32 = new Uint32Array(this.arrayBuffer);
        this.uint16 = new Uint16Array(this.arrayBuffer);
    };
    StructArrayLayout1ul2ui8.prototype.emplaceBack = function emplaceBack(v0, v1, v2) {
        var i = this.length;
        this.resize(i + 1);
        return this.emplace(i, v0, v1, v2);
    };
    StructArrayLayout1ul2ui8.prototype.emplace = function emplace(i, v0, v1, v2) {
        var o4 = i * 2;
        var o2 = i * 4;
        this.uint32[o4 + 0] = v0;
        this.uint16[o2 + 2] = v1;
        this.uint16[o2 + 3] = v2;
        return i;
    };
    return StructArrayLayout1ul2ui8;
}(StructArray);
StructArrayLayout1ul2ui8.prototype.bytesPerElement = 8;
register('StructArrayLayout1ul2ui8', StructArrayLayout1ul2ui8);
var StructArrayLayout2ui4 = function (StructArray) {
    function StructArrayLayout2ui4() {
        StructArray.apply(this, arguments);
    }
    if (StructArray)
        StructArrayLayout2ui4.__proto__ = StructArray;
    StructArrayLayout2ui4.prototype = Object.create(StructArray && StructArray.prototype);
    StructArrayLayout2ui4.prototype.constructor = StructArrayLayout2ui4;
    StructArrayLayout2ui4.prototype._refreshViews = function _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer);
        this.uint16 = new Uint16Array(this.arrayBuffer);
    };
    StructArrayLayout2ui4.prototype.emplaceBack = function emplaceBack(v0, v1) {
        var i = this.length;
        this.resize(i + 1);
        return this.emplace(i, v0, v1);
    };
    StructArrayLayout2ui4.prototype.emplace = function emplace(i, v0, v1) {
        var o2 = i * 2;
        this.uint16[o2 + 0] = v0;
        this.uint16[o2 + 1] = v1;
        return i;
    };
    return StructArrayLayout2ui4;
}(StructArray);
StructArrayLayout2ui4.prototype.bytesPerElement = 4;
register('StructArrayLayout2ui4', StructArrayLayout2ui4);
var StructArrayLayout1ui2 = function (StructArray) {
    function StructArrayLayout1ui2() {
        StructArray.apply(this, arguments);
    }
    if (StructArray)
        StructArrayLayout1ui2.__proto__ = StructArray;
    StructArrayLayout1ui2.prototype = Object.create(StructArray && StructArray.prototype);
    StructArrayLayout1ui2.prototype.constructor = StructArrayLayout1ui2;
    StructArrayLayout1ui2.prototype._refreshViews = function _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer);
        this.uint16 = new Uint16Array(this.arrayBuffer);
    };
    StructArrayLayout1ui2.prototype.emplaceBack = function emplaceBack(v0) {
        var i = this.length;
        this.resize(i + 1);
        return this.emplace(i, v0);
    };
    StructArrayLayout1ui2.prototype.emplace = function emplace(i, v0) {
        var o2 = i * 1;
        this.uint16[o2 + 0] = v0;
        return i;
    };
    return StructArrayLayout1ui2;
}(StructArray);
StructArrayLayout1ui2.prototype.bytesPerElement = 2;
register('StructArrayLayout1ui2', StructArrayLayout1ui2);
var StructArrayLayout4f16 = function (StructArray) {
    function StructArrayLayout4f16() {
        StructArray.apply(this, arguments);
    }
    if (StructArray)
        StructArrayLayout4f16.__proto__ = StructArray;
    StructArrayLayout4f16.prototype = Object.create(StructArray && StructArray.prototype);
    StructArrayLayout4f16.prototype.constructor = StructArrayLayout4f16;
    StructArrayLayout4f16.prototype._refreshViews = function _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer);
        this.float32 = new Float32Array(this.arrayBuffer);
    };
    StructArrayLayout4f16.prototype.emplaceBack = function emplaceBack(v0, v1, v2, v3) {
        var i = this.length;
        this.resize(i + 1);
        return this.emplace(i, v0, v1, v2, v3);
    };
    StructArrayLayout4f16.prototype.emplace = function emplace(i, v0, v1, v2, v3) {
        var o4 = i * 4;
        this.float32[o4 + 0] = v0;
        this.float32[o4 + 1] = v1;
        this.float32[o4 + 2] = v2;
        this.float32[o4 + 3] = v3;
        return i;
    };
    return StructArrayLayout4f16;
}(StructArray);
StructArrayLayout4f16.prototype.bytesPerElement = 16;
register('StructArrayLayout4f16', StructArrayLayout4f16);
var CollisionBoxStruct = function (Struct) {
    function CollisionBoxStruct() {
        Struct.apply(this, arguments);
    }
    if (Struct)
        CollisionBoxStruct.__proto__ = Struct;
    CollisionBoxStruct.prototype = Object.create(Struct && Struct.prototype);
    CollisionBoxStruct.prototype.constructor = CollisionBoxStruct;
    var prototypeAccessors = {
        anchorPointX: { configurable: true },
        anchorPointY: { configurable: true },
        x1: { configurable: true },
        y1: { configurable: true },
        x2: { configurable: true },
        y2: { configurable: true },
        featureIndex: { configurable: true },
        sourceLayerIndex: { configurable: true },
        bucketIndex: { configurable: true },
        anchorPoint: { configurable: true }
    };
    prototypeAccessors.anchorPointX.get = function () {
        return this._structArray.int16[this._pos2 + 0];
    };
    prototypeAccessors.anchorPointY.get = function () {
        return this._structArray.int16[this._pos2 + 1];
    };
    prototypeAccessors.x1.get = function () {
        return this._structArray.int16[this._pos2 + 2];
    };
    prototypeAccessors.y1.get = function () {
        return this._structArray.int16[this._pos2 + 3];
    };
    prototypeAccessors.x2.get = function () {
        return this._structArray.int16[this._pos2 + 4];
    };
    prototypeAccessors.y2.get = function () {
        return this._structArray.int16[this._pos2 + 5];
    };
    prototypeAccessors.featureIndex.get = function () {
        return this._structArray.uint32[this._pos4 + 3];
    };
    prototypeAccessors.sourceLayerIndex.get = function () {
        return this._structArray.uint16[this._pos2 + 8];
    };
    prototypeAccessors.bucketIndex.get = function () {
        return this._structArray.uint16[this._pos2 + 9];
    };
    prototypeAccessors.anchorPoint.get = function () {
        return new pointGeometry(this.anchorPointX, this.anchorPointY);
    };
    Object.defineProperties(CollisionBoxStruct.prototype, prototypeAccessors);
    return CollisionBoxStruct;
}(Struct);
CollisionBoxStruct.prototype.size = 20;
var CollisionBoxArray = function (StructArrayLayout6i1ul2ui20) {
    function CollisionBoxArray() {
        StructArrayLayout6i1ul2ui20.apply(this, arguments);
    }
    if (StructArrayLayout6i1ul2ui20)
        CollisionBoxArray.__proto__ = StructArrayLayout6i1ul2ui20;
    CollisionBoxArray.prototype = Object.create(StructArrayLayout6i1ul2ui20 && StructArrayLayout6i1ul2ui20.prototype);
    CollisionBoxArray.prototype.constructor = CollisionBoxArray;
    CollisionBoxArray.prototype.get = function get(index) {
        return new CollisionBoxStruct(this, index);
    };
    return CollisionBoxArray;
}(StructArrayLayout6i1ul2ui20);
register('CollisionBoxArray', CollisionBoxArray);
var PlacedSymbolStruct = function (Struct) {
    function PlacedSymbolStruct() {
        Struct.apply(this, arguments);
    }
    if (Struct)
        PlacedSymbolStruct.__proto__ = Struct;
    PlacedSymbolStruct.prototype = Object.create(Struct && Struct.prototype);
    PlacedSymbolStruct.prototype.constructor = PlacedSymbolStruct;
    var prototypeAccessors$1 = {
        anchorX: { configurable: true },
        anchorY: { configurable: true },
        glyphStartIndex: { configurable: true },
        numGlyphs: { configurable: true },
        vertexStartIndex: { configurable: true },
        lineStartIndex: { configurable: true },
        lineLength: { configurable: true },
        segment: { configurable: true },
        lowerSize: { configurable: true },
        upperSize: { configurable: true },
        lineOffsetX: { configurable: true },
        lineOffsetY: { configurable: true },
        writingMode: { configurable: true },
        placedOrientation: { configurable: true },
        hidden: { configurable: true },
        crossTileID: { configurable: true },
        associatedIconIndex: { configurable: true }
    };
    prototypeAccessors$1.anchorX.get = function () {
        return this._structArray.int16[this._pos2 + 0];
    };
    prototypeAccessors$1.anchorY.get = function () {
        return this._structArray.int16[this._pos2 + 1];
    };
    prototypeAccessors$1.glyphStartIndex.get = function () {
        return this._structArray.uint16[this._pos2 + 2];
    };
    prototypeAccessors$1.numGlyphs.get = function () {
        return this._structArray.uint16[this._pos2 + 3];
    };
    prototypeAccessors$1.vertexStartIndex.get = function () {
        return this._structArray.uint32[this._pos4 + 2];
    };
    prototypeAccessors$1.lineStartIndex.get = function () {
        return this._structArray.uint32[this._pos4 + 3];
    };
    prototypeAccessors$1.lineLength.get = function () {
        return this._structArray.uint32[this._pos4 + 4];
    };
    prototypeAccessors$1.segment.get = function () {
        return this._structArray.uint16[this._pos2 + 10];
    };
    prototypeAccessors$1.lowerSize.get = function () {
        return this._structArray.uint16[this._pos2 + 11];
    };
    prototypeAccessors$1.upperSize.get = function () {
        return this._structArray.uint16[this._pos2 + 12];
    };
    prototypeAccessors$1.lineOffsetX.get = function () {
        return this._structArray.float32[this._pos4 + 7];
    };
    prototypeAccessors$1.lineOffsetY.get = function () {
        return this._structArray.float32[this._pos4 + 8];
    };
    prototypeAccessors$1.writingMode.get = function () {
        return this._structArray.uint8[this._pos1 + 36];
    };
    prototypeAccessors$1.placedOrientation.get = function () {
        return this._structArray.uint8[this._pos1 + 37];
    };
    prototypeAccessors$1.placedOrientation.set = function (x) {
        this._structArray.uint8[this._pos1 + 37] = x;
    };
    prototypeAccessors$1.hidden.get = function () {
        return this._structArray.uint8[this._pos1 + 38];
    };
    prototypeAccessors$1.hidden.set = function (x) {
        this._structArray.uint8[this._pos1 + 38] = x;
    };
    prototypeAccessors$1.crossTileID.get = function () {
        return this._structArray.uint32[this._pos4 + 10];
    };
    prototypeAccessors$1.crossTileID.set = function (x) {
        this._structArray.uint32[this._pos4 + 10] = x;
    };
    prototypeAccessors$1.associatedIconIndex.get = function () {
        return this._structArray.int16[this._pos2 + 22];
    };
    Object.defineProperties(PlacedSymbolStruct.prototype, prototypeAccessors$1);
    return PlacedSymbolStruct;
}(Struct);
PlacedSymbolStruct.prototype.size = 48;
var PlacedSymbolArray = function (StructArrayLayout2i2ui3ul3ui2f3ub1ul1i48) {
    function PlacedSymbolArray() {
        StructArrayLayout2i2ui3ul3ui2f3ub1ul1i48.apply(this, arguments);
    }
    if (StructArrayLayout2i2ui3ul3ui2f3ub1ul1i48)
        PlacedSymbolArray.__proto__ = StructArrayLayout2i2ui3ul3ui2f3ub1ul1i48;
    PlacedSymbolArray.prototype = Object.create(StructArrayLayout2i2ui3ul3ui2f3ub1ul1i48 && StructArrayLayout2i2ui3ul3ui2f3ub1ul1i48.prototype);
    PlacedSymbolArray.prototype.constructor = PlacedSymbolArray;
    PlacedSymbolArray.prototype.get = function get(index) {
        return new PlacedSymbolStruct(this, index);
    };
    return PlacedSymbolArray;
}(StructArrayLayout2i2ui3ul3ui2f3ub1ul1i48);
register('PlacedSymbolArray', PlacedSymbolArray);
var SymbolInstanceStruct = function (Struct) {
    function SymbolInstanceStruct() {
        Struct.apply(this, arguments);
    }
    if (Struct)
        SymbolInstanceStruct.__proto__ = Struct;
    SymbolInstanceStruct.prototype = Object.create(Struct && Struct.prototype);
    SymbolInstanceStruct.prototype.constructor = SymbolInstanceStruct;
    var prototypeAccessors$2 = {
        anchorX: { configurable: true },
        anchorY: { configurable: true },
        rightJustifiedTextSymbolIndex: { configurable: true },
        centerJustifiedTextSymbolIndex: { configurable: true },
        leftJustifiedTextSymbolIndex: { configurable: true },
        verticalPlacedTextSymbolIndex: { configurable: true },
        placedIconSymbolIndex: { configurable: true },
        verticalPlacedIconSymbolIndex: { configurable: true },
        key: { configurable: true },
        textBoxStartIndex: { configurable: true },
        textBoxEndIndex: { configurable: true },
        verticalTextBoxStartIndex: { configurable: true },
        verticalTextBoxEndIndex: { configurable: true },
        iconBoxStartIndex: { configurable: true },
        iconBoxEndIndex: { configurable: true },
        verticalIconBoxStartIndex: { configurable: true },
        verticalIconBoxEndIndex: { configurable: true },
        featureIndex: { configurable: true },
        numHorizontalGlyphVertices: { configurable: true },
        numVerticalGlyphVertices: { configurable: true },
        numIconVertices: { configurable: true },
        numVerticalIconVertices: { configurable: true },
        useRuntimeCollisionCircles: { configurable: true },
        crossTileID: { configurable: true },
        textBoxScale: { configurable: true },
        textOffset0: { configurable: true },
        textOffset1: { configurable: true },
        collisionCircleDiameter: { configurable: true }
    };
    prototypeAccessors$2.anchorX.get = function () {
        return this._structArray.int16[this._pos2 + 0];
    };
    prototypeAccessors$2.anchorY.get = function () {
        return this._structArray.int16[this._pos2 + 1];
    };
    prototypeAccessors$2.rightJustifiedTextSymbolIndex.get = function () {
        return this._structArray.int16[this._pos2 + 2];
    };
    prototypeAccessors$2.centerJustifiedTextSymbolIndex.get = function () {
        return this._structArray.int16[this._pos2 + 3];
    };
    prototypeAccessors$2.leftJustifiedTextSymbolIndex.get = function () {
        return this._structArray.int16[this._pos2 + 4];
    };
    prototypeAccessors$2.verticalPlacedTextSymbolIndex.get = function () {
        return this._structArray.int16[this._pos2 + 5];
    };
    prototypeAccessors$2.placedIconSymbolIndex.get = function () {
        return this._structArray.int16[this._pos2 + 6];
    };
    prototypeAccessors$2.verticalPlacedIconSymbolIndex.get = function () {
        return this._structArray.int16[this._pos2 + 7];
    };
    prototypeAccessors$2.key.get = function () {
        return this._structArray.uint16[this._pos2 + 8];
    };
    prototypeAccessors$2.textBoxStartIndex.get = function () {
        return this._structArray.uint16[this._pos2 + 9];
    };
    prototypeAccessors$2.textBoxEndIndex.get = function () {
        return this._structArray.uint16[this._pos2 + 10];
    };
    prototypeAccessors$2.verticalTextBoxStartIndex.get = function () {
        return this._structArray.uint16[this._pos2 + 11];
    };
    prototypeAccessors$2.verticalTextBoxEndIndex.get = function () {
        return this._structArray.uint16[this._pos2 + 12];
    };
    prototypeAccessors$2.iconBoxStartIndex.get = function () {
        return this._structArray.uint16[this._pos2 + 13];
    };
    prototypeAccessors$2.iconBoxEndIndex.get = function () {
        return this._structArray.uint16[this._pos2 + 14];
    };
    prototypeAccessors$2.verticalIconBoxStartIndex.get = function () {
        return this._structArray.uint16[this._pos2 + 15];
    };
    prototypeAccessors$2.verticalIconBoxEndIndex.get = function () {
        return this._structArray.uint16[this._pos2 + 16];
    };
    prototypeAccessors$2.featureIndex.get = function () {
        return this._structArray.uint16[this._pos2 + 17];
    };
    prototypeAccessors$2.numHorizontalGlyphVertices.get = function () {
        return this._structArray.uint16[this._pos2 + 18];
    };
    prototypeAccessors$2.numVerticalGlyphVertices.get = function () {
        return this._structArray.uint16[this._pos2 + 19];
    };
    prototypeAccessors$2.numIconVertices.get = function () {
        return this._structArray.uint16[this._pos2 + 20];
    };
    prototypeAccessors$2.numVerticalIconVertices.get = function () {
        return this._structArray.uint16[this._pos2 + 21];
    };
    prototypeAccessors$2.useRuntimeCollisionCircles.get = function () {
        return this._structArray.uint16[this._pos2 + 22];
    };
    prototypeAccessors$2.crossTileID.get = function () {
        return this._structArray.uint32[this._pos4 + 12];
    };
    prototypeAccessors$2.crossTileID.set = function (x) {
        this._structArray.uint32[this._pos4 + 12] = x;
    };
    prototypeAccessors$2.textBoxScale.get = function () {
        return this._structArray.float32[this._pos4 + 13];
    };
    prototypeAccessors$2.textOffset0.get = function () {
        return this._structArray.float32[this._pos4 + 14];
    };
    prototypeAccessors$2.textOffset1.get = function () {
        return this._structArray.float32[this._pos4 + 15];
    };
    prototypeAccessors$2.collisionCircleDiameter.get = function () {
        return this._structArray.float32[this._pos4 + 16];
    };
    Object.defineProperties(SymbolInstanceStruct.prototype, prototypeAccessors$2);
    return SymbolInstanceStruct;
}(Struct);
SymbolInstanceStruct.prototype.size = 68;
var SymbolInstanceArray = function (StructArrayLayout8i15ui1ul4f68) {
    function SymbolInstanceArray() {
        StructArrayLayout8i15ui1ul4f68.apply(this, arguments);
    }
    if (StructArrayLayout8i15ui1ul4f68)
        SymbolInstanceArray.__proto__ = StructArrayLayout8i15ui1ul4f68;
    SymbolInstanceArray.prototype = Object.create(StructArrayLayout8i15ui1ul4f68 && StructArrayLayout8i15ui1ul4f68.prototype);
    SymbolInstanceArray.prototype.constructor = SymbolInstanceArray;
    SymbolInstanceArray.prototype.get = function get(index) {
        return new SymbolInstanceStruct(this, index);
    };
    return SymbolInstanceArray;
}(StructArrayLayout8i15ui1ul4f68);
register('SymbolInstanceArray', SymbolInstanceArray);
var GlyphOffsetArray = function (StructArrayLayout1f4) {
    function GlyphOffsetArray() {
        StructArrayLayout1f4.apply(this, arguments);
    }
    if (StructArrayLayout1f4)
        GlyphOffsetArray.__proto__ = StructArrayLayout1f4;
    GlyphOffsetArray.prototype = Object.create(StructArrayLayout1f4 && StructArrayLayout1f4.prototype);
    GlyphOffsetArray.prototype.constructor = GlyphOffsetArray;
    GlyphOffsetArray.prototype.getoffsetX = function getoffsetX(index) {
        return this.float32[index * 1 + 0];
    };
    return GlyphOffsetArray;
}(StructArrayLayout1f4);
register('GlyphOffsetArray', GlyphOffsetArray);
var SymbolLineVertexArray = function (StructArrayLayout3i6) {
    function SymbolLineVertexArray() {
        StructArrayLayout3i6.apply(this, arguments);
    }
    if (StructArrayLayout3i6)
        SymbolLineVertexArray.__proto__ = StructArrayLayout3i6;
    SymbolLineVertexArray.prototype = Object.create(StructArrayLayout3i6 && StructArrayLayout3i6.prototype);
    SymbolLineVertexArray.prototype.constructor = SymbolLineVertexArray;
    SymbolLineVertexArray.prototype.getx = function getx(index) {
        return this.int16[index * 3 + 0];
    };
    SymbolLineVertexArray.prototype.gety = function gety(index) {
        return this.int16[index * 3 + 1];
    };
    SymbolLineVertexArray.prototype.gettileUnitDistanceFromAnchor = function gettileUnitDistanceFromAnchor(index) {
        return this.int16[index * 3 + 2];
    };
    return SymbolLineVertexArray;
}(StructArrayLayout3i6);
register('SymbolLineVertexArray', SymbolLineVertexArray);
var FeatureIndexStruct = function (Struct) {
    function FeatureIndexStruct() {
        Struct.apply(this, arguments);
    }
    if (Struct)
        FeatureIndexStruct.__proto__ = Struct;
    FeatureIndexStruct.prototype = Object.create(Struct && Struct.prototype);
    FeatureIndexStruct.prototype.constructor = FeatureIndexStruct;
    var prototypeAccessors$3 = {
        featureIndex: { configurable: true },
        sourceLayerIndex: { configurable: true },
        bucketIndex: { configurable: true }
    };
    prototypeAccessors$3.featureIndex.get = function () {
        return this._structArray.uint32[this._pos4 + 0];
    };
    prototypeAccessors$3.sourceLayerIndex.get = function () {
        return this._structArray.uint16[this._pos2 + 2];
    };
    prototypeAccessors$3.bucketIndex.get = function () {
        return this._structArray.uint16[this._pos2 + 3];
    };
    Object.defineProperties(FeatureIndexStruct.prototype, prototypeAccessors$3);
    return FeatureIndexStruct;
}(Struct);
FeatureIndexStruct.prototype.size = 8;
var FeatureIndexArray = function (StructArrayLayout1ul2ui8) {
    function FeatureIndexArray() {
        StructArrayLayout1ul2ui8.apply(this, arguments);
    }
    if (StructArrayLayout1ul2ui8)
        FeatureIndexArray.__proto__ = StructArrayLayout1ul2ui8;
    FeatureIndexArray.prototype = Object.create(StructArrayLayout1ul2ui8 && StructArrayLayout1ul2ui8.prototype);
    FeatureIndexArray.prototype.constructor = FeatureIndexArray;
    FeatureIndexArray.prototype.get = function get(index) {
        return new FeatureIndexStruct(this, index);
    };
    return FeatureIndexArray;
}(StructArrayLayout1ul2ui8);
register('FeatureIndexArray', FeatureIndexArray);

var layout$1 = createLayout([{
        name: 'a_pos',
        components: 2,
        type: 'Int16'
    }], 4);
var members = layout$1.members;

var SegmentVector = function SegmentVector(segments) {
    if (segments === void 0)
        segments = [];
    this.segments = segments;
};
SegmentVector.prototype.prepareSegment = function prepareSegment(numVertices, layoutVertexArray, indexArray, sortKey) {
    var segment = this.segments[this.segments.length - 1];
    if (numVertices > SegmentVector.MAX_VERTEX_ARRAY_LENGTH) {
        warnOnce('Max vertices per segment is ' + SegmentVector.MAX_VERTEX_ARRAY_LENGTH + ': bucket requested ' + numVertices);
    }
    if (!segment || segment.vertexLength + numVertices > SegmentVector.MAX_VERTEX_ARRAY_LENGTH || segment.sortKey !== sortKey) {
        segment = {
            vertexOffset: layoutVertexArray.length,
            primitiveOffset: indexArray.length,
            vertexLength: 0,
            primitiveLength: 0
        };
        if (sortKey !== undefined) {
            segment.sortKey = sortKey;
        }
        this.segments.push(segment);
    }
    return segment;
};
SegmentVector.prototype.get = function get() {
    return this.segments;
};
SegmentVector.prototype.destroy = function destroy() {
    for (var i = 0, list = this.segments; i < list.length; i += 1) {
        var segment = list[i];
        for (var k in segment.vaos) {
            segment.vaos[k].destroy();
        }
    }
};
SegmentVector.simpleSegment = function simpleSegment(vertexOffset, primitiveOffset, vertexLength, primitiveLength) {
    return new SegmentVector([{
            vertexOffset: vertexOffset,
            primitiveOffset: primitiveOffset,
            vertexLength: vertexLength,
            primitiveLength: primitiveLength,
            vaos: {},
            sortKey: 0
        }]);
};
SegmentVector.MAX_VERTEX_ARRAY_LENGTH = Math.pow(2, 16) - 1;
register('SegmentVector', SegmentVector);

function packUint8ToFloat(a, b) {
    a = clamp(Math.floor(a), 0, 255);
    b = clamp(Math.floor(b), 0, 255);
    return 256 * a + b;
}

var patternAttributes = createLayout([
    {
        name: 'a_pattern_from',
        components: 4,
        type: 'Uint16'
    },
    {
        name: 'a_pattern_to',
        components: 4,
        type: 'Uint16'
    },
    {
        name: 'a_pixel_ratio_from',
        components: 1,
        type: 'Uint16'
    },
    {
        name: 'a_pixel_ratio_to',
        components: 1,
        type: 'Uint16'
    }
]);

var murmurhash3_gc = createCommonjsModule(function (module) {
function murmurhash3_32_gc(key, seed) {
    var remainder, bytes, h1, h1b, c1, c2, k1, i;
    remainder = key.length & 3;
    bytes = key.length - remainder;
    h1 = seed;
    c1 = 3432918353;
    c2 = 461845907;
    i = 0;
    while (i < bytes) {
        k1 = key.charCodeAt(i) & 255 | (key.charCodeAt(++i) & 255) << 8 | (key.charCodeAt(++i) & 255) << 16 | (key.charCodeAt(++i) & 255) << 24;
        ++i;
        k1 = (k1 & 65535) * c1 + (((k1 >>> 16) * c1 & 65535) << 16) & 4294967295;
        k1 = k1 << 15 | k1 >>> 17;
        k1 = (k1 & 65535) * c2 + (((k1 >>> 16) * c2 & 65535) << 16) & 4294967295;
        h1 ^= k1;
        h1 = h1 << 13 | h1 >>> 19;
        h1b = (h1 & 65535) * 5 + (((h1 >>> 16) * 5 & 65535) << 16) & 4294967295;
        h1 = (h1b & 65535) + 27492 + (((h1b >>> 16) + 58964 & 65535) << 16);
    }
    k1 = 0;
    switch (remainder) {
    case 3:
        k1 ^= (key.charCodeAt(i + 2) & 255) << 16;
    case 2:
        k1 ^= (key.charCodeAt(i + 1) & 255) << 8;
    case 1:
        k1 ^= key.charCodeAt(i) & 255;
        k1 = (k1 & 65535) * c1 + (((k1 >>> 16) * c1 & 65535) << 16) & 4294967295;
        k1 = k1 << 15 | k1 >>> 17;
        k1 = (k1 & 65535) * c2 + (((k1 >>> 16) * c2 & 65535) << 16) & 4294967295;
        h1 ^= k1;
    }
    h1 ^= key.length;
    h1 ^= h1 >>> 16;
    h1 = (h1 & 65535) * 2246822507 + (((h1 >>> 16) * 2246822507 & 65535) << 16) & 4294967295;
    h1 ^= h1 >>> 13;
    h1 = (h1 & 65535) * 3266489909 + (((h1 >>> 16) * 3266489909 & 65535) << 16) & 4294967295;
    h1 ^= h1 >>> 16;
    return h1 >>> 0;
}
{
    module.exports = murmurhash3_32_gc;
}
});

var murmurhash2_gc = createCommonjsModule(function (module) {
function murmurhash2_32_gc(str, seed) {
    var l = str.length, h = seed ^ l, i = 0, k;
    while (l >= 4) {
        k = str.charCodeAt(i) & 255 | (str.charCodeAt(++i) & 255) << 8 | (str.charCodeAt(++i) & 255) << 16 | (str.charCodeAt(++i) & 255) << 24;
        k = (k & 65535) * 1540483477 + (((k >>> 16) * 1540483477 & 65535) << 16);
        k ^= k >>> 24;
        k = (k & 65535) * 1540483477 + (((k >>> 16) * 1540483477 & 65535) << 16);
        h = (h & 65535) * 1540483477 + (((h >>> 16) * 1540483477 & 65535) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch (l) {
    case 3:
        h ^= (str.charCodeAt(i + 2) & 255) << 16;
    case 2:
        h ^= (str.charCodeAt(i + 1) & 255) << 8;
    case 1:
        h ^= str.charCodeAt(i) & 255;
        h = (h & 65535) * 1540483477 + (((h >>> 16) * 1540483477 & 65535) << 16);
    }
    h ^= h >>> 13;
    h = (h & 65535) * 1540483477 + (((h >>> 16) * 1540483477 & 65535) << 16);
    h ^= h >>> 15;
    return h >>> 0;
}
{
    module.exports = murmurhash2_32_gc;
}
});

var murmurhashJs = murmurhash3_gc;
var murmur3_1 = murmurhash3_gc;
var murmur2_1 = murmurhash2_gc;
murmurhashJs.murmur3 = murmur3_1;
murmurhashJs.murmur2 = murmur2_1;

var FeaturePositionMap = function FeaturePositionMap() {
    this.ids = [];
    this.positions = [];
    this.indexed = false;
};
FeaturePositionMap.prototype.add = function add(id, index, start, end) {
    this.ids.push(getNumericId(id));
    this.positions.push(index, start, end);
};
FeaturePositionMap.prototype.getPositions = function getPositions(id) {
    var intId = getNumericId(id);
    var i = 0;
    var j = this.ids.length - 1;
    while (i < j) {
        var m = i + j >> 1;
        if (this.ids[m] >= intId) {
            j = m;
        } else {
            i = m + 1;
        }
    }
    var positions = [];
    while (this.ids[i] === intId) {
        var index = this.positions[3 * i];
        var start = this.positions[3 * i + 1];
        var end = this.positions[3 * i + 2];
        positions.push({
            index: index,
            start: start,
            end: end
        });
        i++;
    }
    return positions;
};
FeaturePositionMap.serialize = function serialize(map, transferables) {
    var ids = new Float64Array(map.ids);
    var positions = new Uint32Array(map.positions);
    sort(ids, positions, 0, ids.length - 1);
    if (transferables) {
        transferables.push(ids.buffer, positions.buffer);
    }
    return {
        ids: ids,
        positions: positions
    };
};
FeaturePositionMap.deserialize = function deserialize(obj) {
    var map = new FeaturePositionMap();
    map.ids = obj.ids;
    map.positions = obj.positions;
    map.indexed = true;
    return map;
};
var MAX_SAFE_INTEGER$1 = Math.pow(2, 53) - 1;
function getNumericId(value) {
    var numValue = +value;
    if (!isNaN(numValue) && numValue <= MAX_SAFE_INTEGER$1) {
        return numValue;
    }
    return murmurhashJs(String(value));
}
function sort(ids, positions, left, right) {
    while (left < right) {
        var pivot = ids[left + right >> 1];
        var i = left - 1;
        var j = right + 1;
        while (true) {
            do {
                i++;
            } while (ids[i] < pivot);
            do {
                j--;
            } while (ids[j] > pivot);
            if (i >= j) {
                break;
            }
            swap(ids, i, j);
            swap(positions, 3 * i, 3 * j);
            swap(positions, 3 * i + 1, 3 * j + 1);
            swap(positions, 3 * i + 2, 3 * j + 2);
        }
        if (j - left < right - j) {
            sort(ids, positions, left, j);
            left = j + 1;
        } else {
            sort(ids, positions, j + 1, right);
            right = j;
        }
    }
}
function swap(arr, i, j) {
    var tmp = arr[i];
    arr[i] = arr[j];
    arr[j] = tmp;
}
register('FeaturePositionMap', FeaturePositionMap);

var Uniform = function Uniform(context, location) {
    this.gl = context.gl;
    this.location = location;
};
var Uniform1i = function (Uniform) {
    function Uniform1i(context, location) {
        Uniform.call(this, context, location);
        this.current = 0;
    }
    if (Uniform)
        Uniform1i.__proto__ = Uniform;
    Uniform1i.prototype = Object.create(Uniform && Uniform.prototype);
    Uniform1i.prototype.constructor = Uniform1i;
    Uniform1i.prototype.set = function set(v) {
        if (this.current !== v) {
            this.current = v;
            this.gl.uniform1i(this.location, v);
        }
    };
    return Uniform1i;
}(Uniform);
var Uniform1f = function (Uniform) {
    function Uniform1f(context, location) {
        Uniform.call(this, context, location);
        this.current = 0;
    }
    if (Uniform)
        Uniform1f.__proto__ = Uniform;
    Uniform1f.prototype = Object.create(Uniform && Uniform.prototype);
    Uniform1f.prototype.constructor = Uniform1f;
    Uniform1f.prototype.set = function set(v) {
        if (this.current !== v) {
            this.current = v;
            this.gl.uniform1f(this.location, v);
        }
    };
    return Uniform1f;
}(Uniform);
var Uniform2f = function (Uniform) {
    function Uniform2f(context, location) {
        Uniform.call(this, context, location);
        this.current = [
            0,
            0
        ];
    }
    if (Uniform)
        Uniform2f.__proto__ = Uniform;
    Uniform2f.prototype = Object.create(Uniform && Uniform.prototype);
    Uniform2f.prototype.constructor = Uniform2f;
    Uniform2f.prototype.set = function set(v) {
        if (v[0] !== this.current[0] || v[1] !== this.current[1]) {
            this.current = v;
            this.gl.uniform2f(this.location, v[0], v[1]);
        }
    };
    return Uniform2f;
}(Uniform);
var Uniform3f = function (Uniform) {
    function Uniform3f(context, location) {
        Uniform.call(this, context, location);
        this.current = [
            0,
            0,
            0
        ];
    }
    if (Uniform)
        Uniform3f.__proto__ = Uniform;
    Uniform3f.prototype = Object.create(Uniform && Uniform.prototype);
    Uniform3f.prototype.constructor = Uniform3f;
    Uniform3f.prototype.set = function set(v) {
        if (v[0] !== this.current[0] || v[1] !== this.current[1] || v[2] !== this.current[2]) {
            this.current = v;
            this.gl.uniform3f(this.location, v[0], v[1], v[2]);
        }
    };
    return Uniform3f;
}(Uniform);
var Uniform4f = function (Uniform) {
    function Uniform4f(context, location) {
        Uniform.call(this, context, location);
        this.current = [
            0,
            0,
            0,
            0
        ];
    }
    if (Uniform)
        Uniform4f.__proto__ = Uniform;
    Uniform4f.prototype = Object.create(Uniform && Uniform.prototype);
    Uniform4f.prototype.constructor = Uniform4f;
    Uniform4f.prototype.set = function set(v) {
        if (v[0] !== this.current[0] || v[1] !== this.current[1] || v[2] !== this.current[2] || v[3] !== this.current[3]) {
            this.current = v;
            this.gl.uniform4f(this.location, v[0], v[1], v[2], v[3]);
        }
    };
    return Uniform4f;
}(Uniform);
var UniformColor = function (Uniform) {
    function UniformColor(context, location) {
        Uniform.call(this, context, location);
        this.current = Color.transparent;
    }
    if (Uniform)
        UniformColor.__proto__ = Uniform;
    UniformColor.prototype = Object.create(Uniform && Uniform.prototype);
    UniformColor.prototype.constructor = UniformColor;
    UniformColor.prototype.set = function set(v) {
        if (v.r !== this.current.r || v.g !== this.current.g || v.b !== this.current.b || v.a !== this.current.a) {
            this.current = v;
            this.gl.uniform4f(this.location, v.r, v.g, v.b, v.a);
        }
    };
    return UniformColor;
}(Uniform);
var emptyMat4 = new Float32Array(16);
var UniformMatrix4f = function (Uniform) {
    function UniformMatrix4f(context, location) {
        Uniform.call(this, context, location);
        this.current = emptyMat4;
    }
    if (Uniform)
        UniformMatrix4f.__proto__ = Uniform;
    UniformMatrix4f.prototype = Object.create(Uniform && Uniform.prototype);
    UniformMatrix4f.prototype.constructor = UniformMatrix4f;
    UniformMatrix4f.prototype.set = function set(v) {
        if (v[12] !== this.current[12] || v[0] !== this.current[0]) {
            this.current = v;
            this.gl.uniformMatrix4fv(this.location, false, v);
            return;
        }
        for (var i = 1; i < 16; i++) {
            if (v[i] !== this.current[i]) {
                this.current = v;
                this.gl.uniformMatrix4fv(this.location, false, v);
                break;
            }
        }
    };
    return UniformMatrix4f;
}(Uniform);

function packColor(color) {
    return [
        packUint8ToFloat(255 * color.r, 255 * color.g),
        packUint8ToFloat(255 * color.b, 255 * color.a)
    ];
}
var ConstantBinder = function ConstantBinder(value, names, type) {
    this.value = value;
    this.uniformNames = names.map(function (name) {
        return 'u_' + name;
    });
    this.type = type;
};
ConstantBinder.prototype.setUniform = function setUniform(uniform, globals, currentValue) {
    uniform.set(currentValue.constantOr(this.value));
};
ConstantBinder.prototype.getBinding = function getBinding(context, location, _) {
    return this.type === 'color' ? new UniformColor(context, location) : new Uniform1f(context, location);
};
var CrossFadedConstantBinder = function CrossFadedConstantBinder(value, names) {
    this.uniformNames = names.map(function (name) {
        return 'u_' + name;
    });
    this.patternFrom = null;
    this.patternTo = null;
    this.pixelRatioFrom = 1;
    this.pixelRatioTo = 1;
};
CrossFadedConstantBinder.prototype.setConstantPatternPositions = function setConstantPatternPositions(posTo, posFrom) {
    this.pixelRatioFrom = posFrom.pixelRatio;
    this.pixelRatioTo = posTo.pixelRatio;
    this.patternFrom = posFrom.tlbr;
    this.patternTo = posTo.tlbr;
};
CrossFadedConstantBinder.prototype.setUniform = function setUniform(uniform, globals, currentValue, uniformName) {
    var pos = uniformName === 'u_pattern_to' ? this.patternTo : uniformName === 'u_pattern_from' ? this.patternFrom : uniformName === 'u_pixel_ratio_to' ? this.pixelRatioTo : uniformName === 'u_pixel_ratio_from' ? this.pixelRatioFrom : null;
    if (pos) {
        uniform.set(pos);
    }
};
CrossFadedConstantBinder.prototype.getBinding = function getBinding(context, location, name) {
    return name.substr(0, 9) === 'u_pattern' ? new Uniform4f(context, location) : new Uniform1f(context, location);
};
var SourceExpressionBinder = function SourceExpressionBinder(expression, names, type, PaintVertexArray) {
    this.expression = expression;
    this.type = type;
    this.maxValue = 0;
    this.paintVertexAttributes = names.map(function (name) {
        return {
            name: 'a_' + name,
            type: 'Float32',
            components: type === 'color' ? 2 : 1,
            offset: 0
        };
    });
    this.paintVertexArray = new PaintVertexArray();
};
SourceExpressionBinder.prototype.populatePaintArray = function populatePaintArray(newLength, feature, imagePositions, canonical, formattedSection) {
    var start = this.paintVertexArray.length;
    var value = this.expression.evaluate(new EvaluationParameters(0), feature, {}, canonical, [], formattedSection);
    this.paintVertexArray.resize(newLength);
    this._setPaintValue(start, newLength, value);
};
SourceExpressionBinder.prototype.updatePaintArray = function updatePaintArray(start, end, feature, featureState) {
    var value = this.expression.evaluate({ zoom: 0 }, feature, featureState);
    this._setPaintValue(start, end, value);
};
SourceExpressionBinder.prototype._setPaintValue = function _setPaintValue(start, end, value) {
    if (this.type === 'color') {
        var color = packColor(value);
        for (var i = start; i < end; i++) {
            this.paintVertexArray.emplace(i, color[0], color[1]);
        }
    } else {
        for (var i$1 = start; i$1 < end; i$1++) {
            this.paintVertexArray.emplace(i$1, value);
        }
        this.maxValue = Math.max(this.maxValue, Math.abs(value));
    }
};
SourceExpressionBinder.prototype.upload = function upload(context) {
    if (this.paintVertexArray && this.paintVertexArray.arrayBuffer) {
        if (this.paintVertexBuffer && this.paintVertexBuffer.buffer) {
            this.paintVertexBuffer.updateData(this.paintVertexArray);
        } else {
            this.paintVertexBuffer = context.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent);
        }
    }
};
SourceExpressionBinder.prototype.destroy = function destroy() {
    if (this.paintVertexBuffer) {
        this.paintVertexBuffer.destroy();
    }
};
var CompositeExpressionBinder = function CompositeExpressionBinder(expression, names, type, useIntegerZoom, zoom, PaintVertexArray) {
    this.expression = expression;
    this.uniformNames = names.map(function (name) {
        return 'u_' + name + '_t';
    });
    this.type = type;
    this.useIntegerZoom = useIntegerZoom;
    this.zoom = zoom;
    this.maxValue = 0;
    this.paintVertexAttributes = names.map(function (name) {
        return {
            name: 'a_' + name,
            type: 'Float32',
            components: type === 'color' ? 4 : 2,
            offset: 0
        };
    });
    this.paintVertexArray = new PaintVertexArray();
};
CompositeExpressionBinder.prototype.populatePaintArray = function populatePaintArray(newLength, feature, imagePositions, canonical, formattedSection) {
    var min = this.expression.evaluate(new EvaluationParameters(this.zoom), feature, {}, canonical, [], formattedSection);
    var max = this.expression.evaluate(new EvaluationParameters(this.zoom + 1), feature, {}, canonical, [], formattedSection);
    var start = this.paintVertexArray.length;
    this.paintVertexArray.resize(newLength);
    this._setPaintValue(start, newLength, min, max);
};
CompositeExpressionBinder.prototype.updatePaintArray = function updatePaintArray(start, end, feature, featureState) {
    var min = this.expression.evaluate({ zoom: this.zoom }, feature, featureState);
    var max = this.expression.evaluate({ zoom: this.zoom + 1 }, feature, featureState);
    this._setPaintValue(start, end, min, max);
};
CompositeExpressionBinder.prototype._setPaintValue = function _setPaintValue(start, end, min, max) {
    if (this.type === 'color') {
        var minColor = packColor(min);
        var maxColor = packColor(max);
        for (var i = start; i < end; i++) {
            this.paintVertexArray.emplace(i, minColor[0], minColor[1], maxColor[0], maxColor[1]);
        }
    } else {
        for (var i$1 = start; i$1 < end; i$1++) {
            this.paintVertexArray.emplace(i$1, min, max);
        }
        this.maxValue = Math.max(this.maxValue, Math.abs(min), Math.abs(max));
    }
};
CompositeExpressionBinder.prototype.upload = function upload(context) {
    if (this.paintVertexArray && this.paintVertexArray.arrayBuffer) {
        if (this.paintVertexBuffer && this.paintVertexBuffer.buffer) {
            this.paintVertexBuffer.updateData(this.paintVertexArray);
        } else {
            this.paintVertexBuffer = context.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent);
        }
    }
};
CompositeExpressionBinder.prototype.destroy = function destroy() {
    if (this.paintVertexBuffer) {
        this.paintVertexBuffer.destroy();
    }
};
CompositeExpressionBinder.prototype.setUniform = function setUniform(uniform, globals) {
    var currentZoom = this.useIntegerZoom ? Math.floor(globals.zoom) : globals.zoom;
    var factor = clamp(this.expression.interpolationFactor(currentZoom, this.zoom, this.zoom + 1), 0, 1);
    uniform.set(factor);
};
CompositeExpressionBinder.prototype.getBinding = function getBinding(context, location, _) {
    return new Uniform1f(context, location);
};
var CrossFadedCompositeBinder = function CrossFadedCompositeBinder(expression, type, useIntegerZoom, zoom, PaintVertexArray, layerId) {
    this.expression = expression;
    this.type = type;
    this.useIntegerZoom = useIntegerZoom;
    this.zoom = zoom;
    this.layerId = layerId;
    this.zoomInPaintVertexArray = new PaintVertexArray();
    this.zoomOutPaintVertexArray = new PaintVertexArray();
};
CrossFadedCompositeBinder.prototype.populatePaintArray = function populatePaintArray(length, feature, imagePositions) {
    var start = this.zoomInPaintVertexArray.length;
    this.zoomInPaintVertexArray.resize(length);
    this.zoomOutPaintVertexArray.resize(length);
    this._setPaintValues(start, length, feature.patterns && feature.patterns[this.layerId], imagePositions);
};
CrossFadedCompositeBinder.prototype.updatePaintArray = function updatePaintArray(start, end, feature, featureState, imagePositions) {
    this._setPaintValues(start, end, feature.patterns && feature.patterns[this.layerId], imagePositions);
};
CrossFadedCompositeBinder.prototype._setPaintValues = function _setPaintValues(start, end, patterns, positions) {
    if (!positions || !patterns) {
        return;
    }
    var min = patterns.min;
    var mid = patterns.mid;
    var max = patterns.max;
    var imageMin = positions[min];
    var imageMid = positions[mid];
    var imageMax = positions[max];
    if (!imageMin || !imageMid || !imageMax) {
        return;
    }
    for (var i = start; i < end; i++) {
        this.zoomInPaintVertexArray.emplace(i, imageMid.tl[0], imageMid.tl[1], imageMid.br[0], imageMid.br[1], imageMin.tl[0], imageMin.tl[1], imageMin.br[0], imageMin.br[1], imageMid.pixelRatio, imageMin.pixelRatio);
        this.zoomOutPaintVertexArray.emplace(i, imageMid.tl[0], imageMid.tl[1], imageMid.br[0], imageMid.br[1], imageMax.tl[0], imageMax.tl[1], imageMax.br[0], imageMax.br[1], imageMid.pixelRatio, imageMax.pixelRatio);
    }
};
CrossFadedCompositeBinder.prototype.upload = function upload(context) {
    if (this.zoomInPaintVertexArray && this.zoomInPaintVertexArray.arrayBuffer && this.zoomOutPaintVertexArray && this.zoomOutPaintVertexArray.arrayBuffer) {
        this.zoomInPaintVertexBuffer = context.createVertexBuffer(this.zoomInPaintVertexArray, patternAttributes.members, this.expression.isStateDependent);
        this.zoomOutPaintVertexBuffer = context.createVertexBuffer(this.zoomOutPaintVertexArray, patternAttributes.members, this.expression.isStateDependent);
    }
};
CrossFadedCompositeBinder.prototype.destroy = function destroy() {
    if (this.zoomOutPaintVertexBuffer) {
        this.zoomOutPaintVertexBuffer.destroy();
    }
    if (this.zoomInPaintVertexBuffer) {
        this.zoomInPaintVertexBuffer.destroy();
    }
};
var ProgramConfiguration = function ProgramConfiguration(layer, zoom, filterProperties) {
    this.binders = {};
    this._buffers = [];
    var keys = [];
    for (var property in layer.paint._values) {
        if (!filterProperties(property)) {
            continue;
        }
        var value = layer.paint.get(property);
        if (!(value instanceof PossiblyEvaluatedPropertyValue) || !supportsPropertyExpression(value.property.specification)) {
            continue;
        }
        var names = paintAttributeNames(property, layer.type);
        var expression = value.value;
        var type = value.property.specification.type;
        var useIntegerZoom = value.property.useIntegerZoom;
        var propType = value.property.specification['property-type'];
        var isCrossFaded = propType === 'cross-faded' || propType === 'cross-faded-data-driven';
        if (expression.kind === 'constant') {
            this.binders[property] = isCrossFaded ? new CrossFadedConstantBinder(expression.value, names) : new ConstantBinder(expression.value, names, type);
            keys.push('/u_' + property);
        } else if (expression.kind === 'source' || isCrossFaded) {
            var StructArrayLayout = layoutType(property, type, 'source');
            this.binders[property] = isCrossFaded ? new CrossFadedCompositeBinder(expression, type, useIntegerZoom, zoom, StructArrayLayout, layer.id) : new SourceExpressionBinder(expression, names, type, StructArrayLayout);
            keys.push('/a_' + property);
        } else {
            var StructArrayLayout$1 = layoutType(property, type, 'composite');
            this.binders[property] = new CompositeExpressionBinder(expression, names, type, useIntegerZoom, zoom, StructArrayLayout$1);
            keys.push('/z_' + property);
        }
    }
    this.cacheKey = keys.sort().join('');
};
ProgramConfiguration.prototype.getMaxValue = function getMaxValue(property) {
    var binder = this.binders[property];
    return binder instanceof SourceExpressionBinder || binder instanceof CompositeExpressionBinder ? binder.maxValue : 0;
};
ProgramConfiguration.prototype.populatePaintArrays = function populatePaintArrays(newLength, feature, imagePositions, canonical, formattedSection) {
    for (var property in this.binders) {
        var binder = this.binders[property];
        if (binder instanceof SourceExpressionBinder || binder instanceof CompositeExpressionBinder || binder instanceof CrossFadedCompositeBinder) {
            binder.populatePaintArray(newLength, feature, imagePositions, canonical, formattedSection);
        }
    }
};
ProgramConfiguration.prototype.setConstantPatternPositions = function setConstantPatternPositions(posTo, posFrom) {
    for (var property in this.binders) {
        var binder = this.binders[property];
        if (binder instanceof CrossFadedConstantBinder) {
            binder.setConstantPatternPositions(posTo, posFrom);
        }
    }
};
ProgramConfiguration.prototype.updatePaintArrays = function updatePaintArrays(featureStates, featureMap, vtLayer, layer, imagePositions) {
    var dirty = false;
    for (var id in featureStates) {
        var positions = featureMap.getPositions(id);
        for (var i = 0, list = positions; i < list.length; i += 1) {
            var pos = list[i];
            var feature = vtLayer.feature(pos.index);
            for (var property in this.binders) {
                var binder = this.binders[property];
                if ((binder instanceof SourceExpressionBinder || binder instanceof CompositeExpressionBinder || binder instanceof CrossFadedCompositeBinder) && binder.expression.isStateDependent === true) {
                    var value = layer.paint.get(property);
                    binder.expression = value.value;
                    binder.updatePaintArray(pos.start, pos.end, feature, featureStates[id], imagePositions);
                    dirty = true;
                }
            }
        }
    }
    return dirty;
};
ProgramConfiguration.prototype.defines = function defines() {
    var result = [];
    for (var property in this.binders) {
        var binder = this.binders[property];
        if (binder instanceof ConstantBinder || binder instanceof CrossFadedConstantBinder) {
            result.push.apply(result, binder.uniformNames.map(function (name) {
                return '#define HAS_UNIFORM_' + name;
            }));
        }
    }
    return result;
};
ProgramConfiguration.prototype.getBinderAttributes = function getBinderAttributes() {
    var result = [];
    for (var property in this.binders) {
        var binder = this.binders[property];
        if (binder instanceof SourceExpressionBinder || binder instanceof CompositeExpressionBinder) {
            for (var i = 0; i < binder.paintVertexAttributes.length; i++) {
                result.push(binder.paintVertexAttributes[i].name);
            }
        } else if (binder instanceof CrossFadedCompositeBinder) {
            for (var i$1 = 0; i$1 < patternAttributes.members.length; i$1++) {
                result.push(patternAttributes.members[i$1].name);
            }
        }
    }
    return result;
};
ProgramConfiguration.prototype.getBinderUniforms = function getBinderUniforms() {
    var uniforms = [];
    for (var property in this.binders) {
        var binder = this.binders[property];
        if (binder instanceof ConstantBinder || binder instanceof CrossFadedConstantBinder || binder instanceof CompositeExpressionBinder) {
            for (var i = 0, list = binder.uniformNames; i < list.length; i += 1) {
                var uniformName = list[i];
                uniforms.push(uniformName);
            }
        }
    }
    return uniforms;
};
ProgramConfiguration.prototype.getPaintVertexBuffers = function getPaintVertexBuffers() {
    return this._buffers;
};
ProgramConfiguration.prototype.getUniforms = function getUniforms(context, locations) {
    var uniforms = [];
    for (var property in this.binders) {
        var binder = this.binders[property];
        if (binder instanceof ConstantBinder || binder instanceof CrossFadedConstantBinder || binder instanceof CompositeExpressionBinder) {
            for (var i = 0, list = binder.uniformNames; i < list.length; i += 1) {
                var name = list[i];
                if (locations[name]) {
                    var binding = binder.getBinding(context, locations[name], name);
                    uniforms.push({
                        name: name,
                        property: property,
                        binding: binding
                    });
                }
            }
        }
    }
    return uniforms;
};
ProgramConfiguration.prototype.setUniforms = function setUniforms(context, binderUniforms, properties, globals) {
    for (var i = 0, list = binderUniforms; i < list.length; i += 1) {
        var ref = list[i];
        var name = ref.name;
        var property = ref.property;
        var binding = ref.binding;
        this.binders[property].setUniform(binding, globals, properties.get(property), name);
    }
};
ProgramConfiguration.prototype.updatePaintBuffers = function updatePaintBuffers(crossfade) {
    this._buffers = [];
    for (var property in this.binders) {
        var binder = this.binders[property];
        if (crossfade && binder instanceof CrossFadedCompositeBinder) {
            var patternVertexBuffer = crossfade.fromScale === 2 ? binder.zoomInPaintVertexBuffer : binder.zoomOutPaintVertexBuffer;
            if (patternVertexBuffer) {
                this._buffers.push(patternVertexBuffer);
            }
        } else if ((binder instanceof SourceExpressionBinder || binder instanceof CompositeExpressionBinder) && binder.paintVertexBuffer) {
            this._buffers.push(binder.paintVertexBuffer);
        }
    }
};
ProgramConfiguration.prototype.upload = function upload(context) {
    for (var property in this.binders) {
        var binder = this.binders[property];
        if (binder instanceof SourceExpressionBinder || binder instanceof CompositeExpressionBinder || binder instanceof CrossFadedCompositeBinder) {
            binder.upload(context);
        }
    }
    this.updatePaintBuffers();
};
ProgramConfiguration.prototype.destroy = function destroy() {
    for (var property in this.binders) {
        var binder = this.binders[property];
        if (binder instanceof SourceExpressionBinder || binder instanceof CompositeExpressionBinder || binder instanceof CrossFadedCompositeBinder) {
            binder.destroy();
        }
    }
};
var ProgramConfigurationSet = function ProgramConfigurationSet(layers, zoom, filterProperties) {
    if (filterProperties === void 0)
        filterProperties = function () {
            return true;
        };
    this.programConfigurations = {};
    for (var i = 0, list = layers; i < list.length; i += 1) {
        var layer = list[i];
        this.programConfigurations[layer.id] = new ProgramConfiguration(layer, zoom, filterProperties);
    }
    this.needsUpload = false;
    this._featureMap = new FeaturePositionMap();
    this._bufferOffset = 0;
};
ProgramConfigurationSet.prototype.populatePaintArrays = function populatePaintArrays(length, feature, index, imagePositions, canonical, formattedSection) {
    for (var key in this.programConfigurations) {
        this.programConfigurations[key].populatePaintArrays(length, feature, imagePositions, canonical, formattedSection);
    }
    if (feature.id !== undefined) {
        this._featureMap.add(feature.id, index, this._bufferOffset, length);
    }
    this._bufferOffset = length;
    this.needsUpload = true;
};
ProgramConfigurationSet.prototype.updatePaintArrays = function updatePaintArrays(featureStates, vtLayer, layers, imagePositions) {
    for (var i = 0, list = layers; i < list.length; i += 1) {
        var layer = list[i];
        this.needsUpload = this.programConfigurations[layer.id].updatePaintArrays(featureStates, this._featureMap, vtLayer, layer, imagePositions) || this.needsUpload;
    }
};
ProgramConfigurationSet.prototype.get = function get(layerId) {
    return this.programConfigurations[layerId];
};
ProgramConfigurationSet.prototype.upload = function upload(context) {
    if (!this.needsUpload) {
        return;
    }
    for (var layerId in this.programConfigurations) {
        this.programConfigurations[layerId].upload(context);
    }
    this.needsUpload = false;
};
ProgramConfigurationSet.prototype.destroy = function destroy() {
    for (var layerId in this.programConfigurations) {
        this.programConfigurations[layerId].destroy();
    }
};
function paintAttributeNames(property, type) {
    var attributeNameExceptions = {
        'text-opacity': ['opacity'],
        'icon-opacity': ['opacity'],
        'text-color': ['fill_color'],
        'icon-color': ['fill_color'],
        'text-halo-color': ['halo_color'],
        'icon-halo-color': ['halo_color'],
        'text-halo-blur': ['halo_blur'],
        'icon-halo-blur': ['halo_blur'],
        'text-halo-width': ['halo_width'],
        'icon-halo-width': ['halo_width'],
        'line-gap-width': ['gapwidth'],
        'line-pattern': [
            'pattern_to',
            'pattern_from',
            'pixel_ratio_to',
            'pixel_ratio_from'
        ],
        'fill-pattern': [
            'pattern_to',
            'pattern_from',
            'pixel_ratio_to',
            'pixel_ratio_from'
        ],
        'fill-extrusion-pattern': [
            'pattern_to',
            'pattern_from',
            'pixel_ratio_to',
            'pixel_ratio_from'
        ]
    };
    return attributeNameExceptions[property] || [property.replace(type + '-', '').replace(/-/g, '_')];
}
function getLayoutException(property) {
    var propertyExceptions = {
        'line-pattern': {
            'source': StructArrayLayout10ui20,
            'composite': StructArrayLayout10ui20
        },
        'fill-pattern': {
            'source': StructArrayLayout10ui20,
            'composite': StructArrayLayout10ui20
        },
        'fill-extrusion-pattern': {
            'source': StructArrayLayout10ui20,
            'composite': StructArrayLayout10ui20
        }
    };
    return propertyExceptions[property];
}
function layoutType(property, type, binderType) {
    var defaultLayouts = {
        'color': {
            'source': StructArrayLayout2f8,
            'composite': StructArrayLayout4f16
        },
        'number': {
            'source': StructArrayLayout1f4,
            'composite': StructArrayLayout2f8
        }
    };
    var layoutException = getLayoutException(property);
    return layoutException && layoutException[binderType] || defaultLayouts[type][binderType];
}
register('ConstantBinder', ConstantBinder);
register('CrossFadedConstantBinder', CrossFadedConstantBinder);
register('SourceExpressionBinder', SourceExpressionBinder);
register('CrossFadedCompositeBinder', CrossFadedCompositeBinder);
register('CompositeExpressionBinder', CompositeExpressionBinder);
register('ProgramConfiguration', ProgramConfiguration, { omit: ['_buffers'] });
register('ProgramConfigurationSet', ProgramConfigurationSet);

var EXTENT$1 = 8192;

var BITS = 15;
var MAX = Math.pow(2, BITS - 1) - 1;
var MIN = -MAX - 1;
function loadGeometry(feature) {
    var scale = EXTENT$1 / feature.extent;
    var geometry = feature.loadGeometry();
    for (var r = 0; r < geometry.length; r++) {
        var ring = geometry[r];
        for (var p = 0; p < ring.length; p++) {
            var point = ring[p];
            var x = Math.round(point.x * scale);
            var y = Math.round(point.y * scale);
            point.x = clamp(x, MIN, MAX);
            point.y = clamp(y, MIN, MAX);
            if (x < point.x || x > point.x + 1 || y < point.y || y > point.y + 1) {
                warnOnce('Geometry exceeds allowed extent, reduce your vector tile buffer size');
            }
        }
    }
    return geometry;
}

function toEvaluationFeature(feature, needGeometry) {
    return {
        type: feature.type,
        id: feature.id,
        properties: feature.properties,
        geometry: needGeometry ? loadGeometry(feature) : []
    };
}

function addCircleVertex(layoutVertexArray, x, y, extrudeX, extrudeY) {
    layoutVertexArray.emplaceBack(x * 2 + (extrudeX + 1) / 2, y * 2 + (extrudeY + 1) / 2);
}
var CircleBucket = function CircleBucket(options) {
    this.zoom = options.zoom;
    this.overscaling = options.overscaling;
    this.layers = options.layers;
    this.layerIds = this.layers.map(function (layer) {
        return layer.id;
    });
    this.index = options.index;
    this.hasPattern = false;
    this.layoutVertexArray = new StructArrayLayout2i4();
    this.indexArray = new StructArrayLayout3ui6();
    this.segments = new SegmentVector();
    this.programConfigurations = new ProgramConfigurationSet(options.layers, options.zoom);
    this.stateDependentLayerIds = this.layers.filter(function (l) {
        return l.isStateDependent();
    }).map(function (l) {
        return l.id;
    });
};
CircleBucket.prototype.populate = function populate(features, options, canonical) {
    var styleLayer = this.layers[0];
    var bucketFeatures = [];
    var circleSortKey = null;
    if (styleLayer.type === 'circle') {
        circleSortKey = styleLayer.layout.get('circle-sort-key');
    }
    for (var i = 0, list = features; i < list.length; i += 1) {
        var ref = list[i];
        var feature = ref.feature;
        var id = ref.id;
        var index = ref.index;
        var sourceLayerIndex = ref.sourceLayerIndex;
        var needGeometry = this.layers[0]._featureFilter.needGeometry;
        var evaluationFeature = toEvaluationFeature(feature, needGeometry);
        if (!this.layers[0]._featureFilter.filter(new EvaluationParameters(this.zoom), evaluationFeature, canonical)) {
            continue;
        }
        var sortKey = circleSortKey ? circleSortKey.evaluate(evaluationFeature, {}, canonical) : undefined;
        var bucketFeature = {
            id: id,
            properties: feature.properties,
            type: feature.type,
            sourceLayerIndex: sourceLayerIndex,
            index: index,
            geometry: needGeometry ? evaluationFeature.geometry : loadGeometry(feature),
            patterns: {},
            sortKey: sortKey
        };
        bucketFeatures.push(bucketFeature);
    }
    if (circleSortKey) {
        bucketFeatures.sort(function (a, b) {
            return a.sortKey - b.sortKey;
        });
    }
    for (var i$1 = 0, list$1 = bucketFeatures; i$1 < list$1.length; i$1 += 1) {
        var bucketFeature$1 = list$1[i$1];
        var ref$1 = bucketFeature$1;
        var geometry = ref$1.geometry;
        var index$1 = ref$1.index;
        var sourceLayerIndex$1 = ref$1.sourceLayerIndex;
        var feature$1 = features[index$1].feature;
        this.addFeature(bucketFeature$1, geometry, index$1, canonical);
        options.featureIndex.insert(feature$1, geometry, index$1, sourceLayerIndex$1, this.index);
    }
};
CircleBucket.prototype.update = function update(states, vtLayer, imagePositions) {
    if (!this.stateDependentLayers.length) {
        return;
    }
    this.programConfigurations.updatePaintArrays(states, vtLayer, this.stateDependentLayers, imagePositions);
};
CircleBucket.prototype.isEmpty = function isEmpty() {
    return this.layoutVertexArray.length === 0;
};
CircleBucket.prototype.uploadPending = function uploadPending() {
    return !this.uploaded || this.programConfigurations.needsUpload;
};
CircleBucket.prototype.upload = function upload(context) {
    if (!this.uploaded) {
        this.layoutVertexBuffer = context.createVertexBuffer(this.layoutVertexArray, members);
        this.indexBuffer = context.createIndexBuffer(this.indexArray);
    }
    this.programConfigurations.upload(context);
    this.uploaded = true;
};
CircleBucket.prototype.destroy = function destroy() {
    if (!this.layoutVertexBuffer) {
        return;
    }
    this.layoutVertexBuffer.destroy();
    this.indexBuffer.destroy();
    this.programConfigurations.destroy();
    this.segments.destroy();
};
CircleBucket.prototype.addFeature = function addFeature(feature, geometry, index, canonical) {
    for (var i$1 = 0, list$1 = geometry; i$1 < list$1.length; i$1 += 1) {
        var ring = list$1[i$1];
        for (var i = 0, list = ring; i < list.length; i += 1) {
            var point = list[i];
            var x = point.x;
            var y = point.y;
            if (x < 0 || x >= EXTENT$1 || y < 0 || y >= EXTENT$1) {
                continue;
            }
            var segment = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray, feature.sortKey);
            var index$1 = segment.vertexLength;
            addCircleVertex(this.layoutVertexArray, x, y, -1, -1);
            addCircleVertex(this.layoutVertexArray, x, y, 1, -1);
            addCircleVertex(this.layoutVertexArray, x, y, 1, 1);
            addCircleVertex(this.layoutVertexArray, x, y, -1, 1);
            this.indexArray.emplaceBack(index$1, index$1 + 1, index$1 + 2);
            this.indexArray.emplaceBack(index$1, index$1 + 3, index$1 + 2);
            segment.vertexLength += 4;
            segment.primitiveLength += 2;
        }
    }
    this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, feature, index, {}, canonical);
};
register('CircleBucket', CircleBucket, { omit: ['layers'] });

function polygonIntersectsPolygon(polygonA, polygonB) {
    for (var i = 0; i < polygonA.length; i++) {
        if (polygonContainsPoint(polygonB, polygonA[i])) {
            return true;
        }
    }
    for (var i$1 = 0; i$1 < polygonB.length; i$1++) {
        if (polygonContainsPoint(polygonA, polygonB[i$1])) {
            return true;
        }
    }
    if (lineIntersectsLine(polygonA, polygonB)) {
        return true;
    }
    return false;
}
function polygonIntersectsBufferedPoint(polygon, point, radius) {
    if (polygonContainsPoint(polygon, point)) {
        return true;
    }
    if (pointIntersectsBufferedLine(point, polygon, radius)) {
        return true;
    }
    return false;
}
function polygonIntersectsMultiPolygon(polygon, multiPolygon) {
    if (polygon.length === 1) {
        return multiPolygonContainsPoint(multiPolygon, polygon[0]);
    }
    for (var m = 0; m < multiPolygon.length; m++) {
        var ring = multiPolygon[m];
        for (var n = 0; n < ring.length; n++) {
            if (polygonContainsPoint(polygon, ring[n])) {
                return true;
            }
        }
    }
    for (var i = 0; i < polygon.length; i++) {
        if (multiPolygonContainsPoint(multiPolygon, polygon[i])) {
            return true;
        }
    }
    for (var k = 0; k < multiPolygon.length; k++) {
        if (lineIntersectsLine(polygon, multiPolygon[k])) {
            return true;
        }
    }
    return false;
}
function polygonIntersectsBufferedMultiLine(polygon, multiLine, radius) {
    for (var i = 0; i < multiLine.length; i++) {
        var line = multiLine[i];
        if (polygon.length >= 3) {
            for (var k = 0; k < line.length; k++) {
                if (polygonContainsPoint(polygon, line[k])) {
                    return true;
                }
            }
        }
        if (lineIntersectsBufferedLine(polygon, line, radius)) {
            return true;
        }
    }
    return false;
}
function lineIntersectsBufferedLine(lineA, lineB, radius) {
    if (lineA.length > 1) {
        if (lineIntersectsLine(lineA, lineB)) {
            return true;
        }
        for (var j = 0; j < lineB.length; j++) {
            if (pointIntersectsBufferedLine(lineB[j], lineA, radius)) {
                return true;
            }
        }
    }
    for (var k = 0; k < lineA.length; k++) {
        if (pointIntersectsBufferedLine(lineA[k], lineB, radius)) {
            return true;
        }
    }
    return false;
}
function lineIntersectsLine(lineA, lineB) {
    if (lineA.length === 0 || lineB.length === 0) {
        return false;
    }
    for (var i = 0; i < lineA.length - 1; i++) {
        var a0 = lineA[i];
        var a1 = lineA[i + 1];
        for (var j = 0; j < lineB.length - 1; j++) {
            var b0 = lineB[j];
            var b1 = lineB[j + 1];
            if (lineSegmentIntersectsLineSegment(a0, a1, b0, b1)) {
                return true;
            }
        }
    }
    return false;
}
function lineSegmentIntersectsLineSegment(a0, a1, b0, b1) {
    return isCounterClockwise(a0, b0, b1) !== isCounterClockwise(a1, b0, b1) && isCounterClockwise(a0, a1, b0) !== isCounterClockwise(a0, a1, b1);
}
function pointIntersectsBufferedLine(p, line, radius) {
    var radiusSquared = radius * radius;
    if (line.length === 1) {
        return p.distSqr(line[0]) < radiusSquared;
    }
    for (var i = 1; i < line.length; i++) {
        var v = line[i - 1], w = line[i];
        if (distToSegmentSquared(p, v, w) < radiusSquared) {
            return true;
        }
    }
    return false;
}
function distToSegmentSquared(p, v, w) {
    var l2 = v.distSqr(w);
    if (l2 === 0) {
        return p.distSqr(v);
    }
    var t = ((p.x - v.x) * (w.x - v.x) + (p.y - v.y) * (w.y - v.y)) / l2;
    if (t < 0) {
        return p.distSqr(v);
    }
    if (t > 1) {
        return p.distSqr(w);
    }
    return p.distSqr(w.sub(v)._mult(t)._add(v));
}
function multiPolygonContainsPoint(rings, p) {
    var c = false, ring, p1, p2;
    for (var k = 0; k < rings.length; k++) {
        ring = rings[k];
        for (var i = 0, j = ring.length - 1; i < ring.length; j = i++) {
            p1 = ring[i];
            p2 = ring[j];
            if (p1.y > p.y !== p2.y > p.y && p.x < (p2.x - p1.x) * (p.y - p1.y) / (p2.y - p1.y) + p1.x) {
                c = !c;
            }
        }
    }
    return c;
}
function polygonContainsPoint(ring, p) {
    var c = false;
    for (var i = 0, j = ring.length - 1; i < ring.length; j = i++) {
        var p1 = ring[i];
        var p2 = ring[j];
        if (p1.y > p.y !== p2.y > p.y && p.x < (p2.x - p1.x) * (p.y - p1.y) / (p2.y - p1.y) + p1.x) {
            c = !c;
        }
    }
    return c;
}
function polygonIntersectsBox(ring, boxX1, boxY1, boxX2, boxY2) {
    for (var i$1 = 0, list = ring; i$1 < list.length; i$1 += 1) {
        var p = list[i$1];
        if (boxX1 <= p.x && boxY1 <= p.y && boxX2 >= p.x && boxY2 >= p.y) {
            return true;
        }
    }
    var corners = [
        new pointGeometry(boxX1, boxY1),
        new pointGeometry(boxX1, boxY2),
        new pointGeometry(boxX2, boxY2),
        new pointGeometry(boxX2, boxY1)
    ];
    if (ring.length > 2) {
        for (var i$2 = 0, list$1 = corners; i$2 < list$1.length; i$2 += 1) {
            var corner = list$1[i$2];
            if (polygonContainsPoint(ring, corner)) {
                return true;
            }
        }
    }
    for (var i = 0; i < ring.length - 1; i++) {
        var p1 = ring[i];
        var p2 = ring[i + 1];
        if (edgeIntersectsBox(p1, p2, corners)) {
            return true;
        }
    }
    return false;
}
function edgeIntersectsBox(e1, e2, corners) {
    var tl = corners[0];
    var br = corners[2];
    if (e1.x < tl.x && e2.x < tl.x || e1.x > br.x && e2.x > br.x || e1.y < tl.y && e2.y < tl.y || e1.y > br.y && e2.y > br.y) {
        return false;
    }
    var dir = isCounterClockwise(e1, e2, corners[0]);
    return dir !== isCounterClockwise(e1, e2, corners[1]) || dir !== isCounterClockwise(e1, e2, corners[2]) || dir !== isCounterClockwise(e1, e2, corners[3]);
}

function getMaximumPaintValue(property, layer, bucket) {
    var value = layer.paint.get(property).value;
    if (value.kind === 'constant') {
        return value.value;
    } else {
        return bucket.programConfigurations.get(layer.id).getMaxValue(property);
    }
}
function translateDistance(translate) {
    return Math.sqrt(translate[0] * translate[0] + translate[1] * translate[1]);
}
function translate(queryGeometry, translate, translateAnchor, bearing, pixelsToTileUnits) {
    if (!translate[0] && !translate[1]) {
        return queryGeometry;
    }
    var pt = pointGeometry.convert(translate)._mult(pixelsToTileUnits);
    if (translateAnchor === 'viewport') {
        pt._rotate(-bearing);
    }
    var translated = [];
    for (var i = 0; i < queryGeometry.length; i++) {
        var point = queryGeometry[i];
        translated.push(point.sub(pt));
    }
    return translated;
}

var layout$2 = new Properties({ 'circle-sort-key': new DataDrivenProperty(spec['layout_circle']['circle-sort-key']) });
var paint$1 = new Properties({
    'circle-radius': new DataDrivenProperty(spec['paint_circle']['circle-radius']),
    'circle-color': new DataDrivenProperty(spec['paint_circle']['circle-color']),
    'circle-blur': new DataDrivenProperty(spec['paint_circle']['circle-blur']),
    'circle-opacity': new DataDrivenProperty(spec['paint_circle']['circle-opacity']),
    'circle-translate': new DataConstantProperty(spec['paint_circle']['circle-translate']),
    'circle-translate-anchor': new DataConstantProperty(spec['paint_circle']['circle-translate-anchor']),
    'circle-pitch-scale': new DataConstantProperty(spec['paint_circle']['circle-pitch-scale']),
    'circle-pitch-alignment': new DataConstantProperty(spec['paint_circle']['circle-pitch-alignment']),
    'circle-stroke-width': new DataDrivenProperty(spec['paint_circle']['circle-stroke-width']),
    'circle-stroke-color': new DataDrivenProperty(spec['paint_circle']['circle-stroke-color']),
    'circle-stroke-opacity': new DataDrivenProperty(spec['paint_circle']['circle-stroke-opacity'])
});
var properties = {
    paint: paint$1,
    layout: layout$2
};

var ARRAY_TYPE = typeof Float32Array !== 'undefined' ? Float32Array : Array;
if (!Math.hypot) {
    Math.hypot = function () {
        var arguments$1 = arguments;
        var y = 0, i = arguments.length;
        while (i--) {
            y += arguments$1[i] * arguments$1[i];
        }
        return Math.sqrt(y);
    };
}

function create() {
    var out = new ARRAY_TYPE(4);
    if (ARRAY_TYPE != Float32Array) {
        out[1] = 0;
        out[2] = 0;
    }
    out[0] = 1;
    out[3] = 1;
    return out;
}
function rotate(out, a, rad) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
    var s = Math.sin(rad);
    var c = Math.cos(rad);
    out[0] = a0 * c + a2 * s;
    out[1] = a1 * c + a3 * s;
    out[2] = a0 * -s + a2 * c;
    out[3] = a1 * -s + a3 * c;
    return out;
}

function create$1() {
    var out = new ARRAY_TYPE(9);
    if (ARRAY_TYPE != Float32Array) {
        out[1] = 0;
        out[2] = 0;
        out[3] = 0;
        out[5] = 0;
        out[6] = 0;
        out[7] = 0;
    }
    out[0] = 1;
    out[4] = 1;
    out[8] = 1;
    return out;
}
function fromRotation(out, rad) {
    var s = Math.sin(rad), c = Math.cos(rad);
    out[0] = c;
    out[1] = s;
    out[2] = 0;
    out[3] = -s;
    out[4] = c;
    out[5] = 0;
    out[6] = 0;
    out[7] = 0;
    out[8] = 1;
    return out;
}

function create$2() {
    var out = new ARRAY_TYPE(16);
    if (ARRAY_TYPE != Float32Array) {
        out[1] = 0;
        out[2] = 0;
        out[3] = 0;
        out[4] = 0;
        out[6] = 0;
        out[7] = 0;
        out[8] = 0;
        out[9] = 0;
        out[11] = 0;
        out[12] = 0;
        out[13] = 0;
        out[14] = 0;
    }
    out[0] = 1;
    out[5] = 1;
    out[10] = 1;
    out[15] = 1;
    return out;
}
function clone$1(a) {
    var out = new ARRAY_TYPE(16);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    out[9] = a[9];
    out[10] = a[10];
    out[11] = a[11];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
}
function identity(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function invert(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    var b00 = a00 * a11 - a01 * a10;
    var b01 = a00 * a12 - a02 * a10;
    var b02 = a00 * a13 - a03 * a10;
    var b03 = a01 * a12 - a02 * a11;
    var b04 = a01 * a13 - a03 * a11;
    var b05 = a02 * a13 - a03 * a12;
    var b06 = a20 * a31 - a21 * a30;
    var b07 = a20 * a32 - a22 * a30;
    var b08 = a20 * a33 - a23 * a30;
    var b09 = a21 * a32 - a22 * a31;
    var b10 = a21 * a33 - a23 * a31;
    var b11 = a22 * a33 - a23 * a32;
    var det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
    if (!det) {
        return null;
    }
    det = 1 / det;
    out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
    out[1] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
    out[2] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
    out[3] = (a22 * b04 - a21 * b05 - a23 * b03) * det;
    out[4] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
    out[5] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
    out[6] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
    out[7] = (a20 * b05 - a22 * b02 + a23 * b01) * det;
    out[8] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
    out[9] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
    out[10] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
    out[11] = (a21 * b02 - a20 * b04 - a23 * b00) * det;
    out[12] = (a11 * b07 - a10 * b09 - a12 * b06) * det;
    out[13] = (a00 * b09 - a01 * b07 + a02 * b06) * det;
    out[14] = (a31 * b01 - a30 * b03 - a32 * b00) * det;
    out[15] = (a20 * b03 - a21 * b01 + a22 * b00) * det;
    return out;
}
function multiply(out, a, b) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
    out[0] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[1] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[2] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[3] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[4];
    b1 = b[5];
    b2 = b[6];
    b3 = b[7];
    out[4] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[5] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[6] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[7] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[8];
    b1 = b[9];
    b2 = b[10];
    b3 = b[11];
    out[8] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[9] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[10] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[11] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[12];
    b1 = b[13];
    b2 = b[14];
    b3 = b[15];
    out[12] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[13] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[14] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[15] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    return out;
}
function translate$1(out, a, v) {
    var x = v[0], y = v[1], z = v[2];
    var a00, a01, a02, a03;
    var a10, a11, a12, a13;
    var a20, a21, a22, a23;
    if (a === out) {
        out[12] = a[0] * x + a[4] * y + a[8] * z + a[12];
        out[13] = a[1] * x + a[5] * y + a[9] * z + a[13];
        out[14] = a[2] * x + a[6] * y + a[10] * z + a[14];
        out[15] = a[3] * x + a[7] * y + a[11] * z + a[15];
    } else {
        a00 = a[0];
        a01 = a[1];
        a02 = a[2];
        a03 = a[3];
        a10 = a[4];
        a11 = a[5];
        a12 = a[6];
        a13 = a[7];
        a20 = a[8];
        a21 = a[9];
        a22 = a[10];
        a23 = a[11];
        out[0] = a00;
        out[1] = a01;
        out[2] = a02;
        out[3] = a03;
        out[4] = a10;
        out[5] = a11;
        out[6] = a12;
        out[7] = a13;
        out[8] = a20;
        out[9] = a21;
        out[10] = a22;
        out[11] = a23;
        out[12] = a00 * x + a10 * y + a20 * z + a[12];
        out[13] = a01 * x + a11 * y + a21 * z + a[13];
        out[14] = a02 * x + a12 * y + a22 * z + a[14];
        out[15] = a03 * x + a13 * y + a23 * z + a[15];
    }
    return out;
}
function scale(out, a, v) {
    var x = v[0], y = v[1], z = v[2];
    out[0] = a[0] * x;
    out[1] = a[1] * x;
    out[2] = a[2] * x;
    out[3] = a[3] * x;
    out[4] = a[4] * y;
    out[5] = a[5] * y;
    out[6] = a[6] * y;
    out[7] = a[7] * y;
    out[8] = a[8] * z;
    out[9] = a[9] * z;
    out[10] = a[10] * z;
    out[11] = a[11] * z;
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
}
function rotateX(out, a, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad);
    var a10 = a[4];
    var a11 = a[5];
    var a12 = a[6];
    var a13 = a[7];
    var a20 = a[8];
    var a21 = a[9];
    var a22 = a[10];
    var a23 = a[11];
    if (a !== out) {
        out[0] = a[0];
        out[1] = a[1];
        out[2] = a[2];
        out[3] = a[3];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    }
    out[4] = a10 * c + a20 * s;
    out[5] = a11 * c + a21 * s;
    out[6] = a12 * c + a22 * s;
    out[7] = a13 * c + a23 * s;
    out[8] = a20 * c - a10 * s;
    out[9] = a21 * c - a11 * s;
    out[10] = a22 * c - a12 * s;
    out[11] = a23 * c - a13 * s;
    return out;
}
function rotateZ(out, a, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad);
    var a00 = a[0];
    var a01 = a[1];
    var a02 = a[2];
    var a03 = a[3];
    var a10 = a[4];
    var a11 = a[5];
    var a12 = a[6];
    var a13 = a[7];
    if (a !== out) {
        out[8] = a[8];
        out[9] = a[9];
        out[10] = a[10];
        out[11] = a[11];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    }
    out[0] = a00 * c + a10 * s;
    out[1] = a01 * c + a11 * s;
    out[2] = a02 * c + a12 * s;
    out[3] = a03 * c + a13 * s;
    out[4] = a10 * c - a00 * s;
    out[5] = a11 * c - a01 * s;
    out[6] = a12 * c - a02 * s;
    out[7] = a13 * c - a03 * s;
    return out;
}
function perspective(out, fovy, aspect, near, far) {
    var f = 1 / Math.tan(fovy / 2), nf;
    out[0] = f / aspect;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = f;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[11] = -1;
    out[12] = 0;
    out[13] = 0;
    out[15] = 0;
    if (far != null && far !== Infinity) {
        nf = 1 / (near - far);
        out[10] = (far + near) * nf;
        out[14] = 2 * far * near * nf;
    } else {
        out[10] = -1;
        out[14] = -2 * near;
    }
    return out;
}
function ortho(out, left, right, bottom, top, near, far) {
    var lr = 1 / (left - right);
    var bt = 1 / (bottom - top);
    var nf = 1 / (near - far);
    out[0] = -2 * lr;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = -2 * bt;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 2 * nf;
    out[11] = 0;
    out[12] = (left + right) * lr;
    out[13] = (top + bottom) * bt;
    out[14] = (far + near) * nf;
    out[15] = 1;
    return out;
}
var mul = multiply;

function create$3() {
    var out = new ARRAY_TYPE(3);
    if (ARRAY_TYPE != Float32Array) {
        out[0] = 0;
        out[1] = 0;
        out[2] = 0;
    }
    return out;
}
function clone$2(a) {
    var out = new ARRAY_TYPE(3);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    return out;
}
function add(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    return out;
}
function subtract(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    return out;
}
function scale$1(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    return out;
}
function normalize(out, a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    var len = x * x + y * y + z * z;
    if (len > 0) {
        len = 1 / Math.sqrt(len);
    }
    out[0] = a[0] * len;
    out[1] = a[1] * len;
    out[2] = a[2] * len;
    return out;
}
function dot(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}
function cross(out, a, b) {
    var ax = a[0], ay = a[1], az = a[2];
    var bx = b[0], by = b[1], bz = b[2];
    out[0] = ay * bz - az * by;
    out[1] = az * bx - ax * bz;
    out[2] = ax * by - ay * bx;
    return out;
}
function transformMat3(out, a, m) {
    var x = a[0], y = a[1], z = a[2];
    out[0] = x * m[0] + y * m[3] + z * m[6];
    out[1] = x * m[1] + y * m[4] + z * m[7];
    out[2] = x * m[2] + y * m[5] + z * m[8];
    return out;
}
var sub = subtract;
var forEach = function () {
    var vec = create$3();
    return function (a, stride, offset, count, fn, arg) {
        var i, l;
        if (!stride) {
            stride = 3;
        }
        if (!offset) {
            offset = 0;
        }
        if (count) {
            l = Math.min(count * stride + offset, a.length);
        } else {
            l = a.length;
        }
        for (i = offset; i < l; i += stride) {
            vec[0] = a[i];
            vec[1] = a[i + 1];
            vec[2] = a[i + 2];
            fn(vec, vec, arg);
            a[i] = vec[0];
            a[i + 1] = vec[1];
            a[i + 2] = vec[2];
        }
        return a;
    };
}();

function create$4() {
    var out = new ARRAY_TYPE(4);
    if (ARRAY_TYPE != Float32Array) {
        out[0] = 0;
        out[1] = 0;
        out[2] = 0;
        out[3] = 0;
    }
    return out;
}
function scale$2(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    out[3] = a[3] * b;
    return out;
}
function dot$1(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3];
}
function transformMat4(out, a, m) {
    var x = a[0], y = a[1], z = a[2], w = a[3];
    out[0] = m[0] * x + m[4] * y + m[8] * z + m[12] * w;
    out[1] = m[1] * x + m[5] * y + m[9] * z + m[13] * w;
    out[2] = m[2] * x + m[6] * y + m[10] * z + m[14] * w;
    out[3] = m[3] * x + m[7] * y + m[11] * z + m[15] * w;
    return out;
}
var forEach$1 = function () {
    var vec = create$4();
    return function (a, stride, offset, count, fn, arg) {
        var i, l;
        if (!stride) {
            stride = 4;
        }
        if (!offset) {
            offset = 0;
        }
        if (count) {
            l = Math.min(count * stride + offset, a.length);
        } else {
            l = a.length;
        }
        for (i = offset; i < l; i += stride) {
            vec[0] = a[i];
            vec[1] = a[i + 1];
            vec[2] = a[i + 2];
            vec[3] = a[i + 3];
            fn(vec, vec, arg);
            a[i] = vec[0];
            a[i + 1] = vec[1];
            a[i + 2] = vec[2];
            a[i + 3] = vec[3];
        }
        return a;
    };
}();

function create$5() {
    var out = new ARRAY_TYPE(2);
    if (ARRAY_TYPE != Float32Array) {
        out[0] = 0;
        out[1] = 0;
    }
    return out;
}
function squaredLength(a) {
    var x = a[0], y = a[1];
    return x * x + y * y;
}
var sqrLen = squaredLength;
var forEach$2 = function () {
    var vec = create$5();
    return function (a, stride, offset, count, fn, arg) {
        var i, l;
        if (!stride) {
            stride = 2;
        }
        if (!offset) {
            offset = 0;
        }
        if (count) {
            l = Math.min(count * stride + offset, a.length);
        } else {
            l = a.length;
        }
        for (i = offset; i < l; i += stride) {
            vec[0] = a[i];
            vec[1] = a[i + 1];
            fn(vec, vec, arg);
            a[i] = vec[0];
            a[i + 1] = vec[1];
        }
        return a;
    };
}();

var CircleStyleLayer = function (StyleLayer) {
    function CircleStyleLayer(layer) {
        StyleLayer.call(this, layer, properties);
    }
    if (StyleLayer)
        CircleStyleLayer.__proto__ = StyleLayer;
    CircleStyleLayer.prototype = Object.create(StyleLayer && StyleLayer.prototype);
    CircleStyleLayer.prototype.constructor = CircleStyleLayer;
    CircleStyleLayer.prototype.createBucket = function createBucket(parameters) {
        return new CircleBucket(parameters);
    };
    CircleStyleLayer.prototype.queryRadius = function queryRadius(bucket) {
        var circleBucket = bucket;
        return getMaximumPaintValue('circle-radius', this, circleBucket) + getMaximumPaintValue('circle-stroke-width', this, circleBucket) + translateDistance(this.paint.get('circle-translate'));
    };
    CircleStyleLayer.prototype.queryIntersectsFeature = function queryIntersectsFeature(queryGeometry, feature, featureState, geometry, zoom, transform, pixelsToTileUnits, pixelPosMatrix) {
        var translatedPolygon = translate(queryGeometry, this.paint.get('circle-translate'), this.paint.get('circle-translate-anchor'), transform.angle, pixelsToTileUnits);
        var radius = this.paint.get('circle-radius').evaluate(feature, featureState);
        var stroke = this.paint.get('circle-stroke-width').evaluate(feature, featureState);
        var size = radius + stroke;
        var alignWithMap = this.paint.get('circle-pitch-alignment') === 'map';
        var transformedPolygon = alignWithMap ? translatedPolygon : projectQueryGeometry(translatedPolygon, pixelPosMatrix);
        var transformedSize = alignWithMap ? size * pixelsToTileUnits : size;
        for (var i$1 = 0, list$1 = geometry; i$1 < list$1.length; i$1 += 1) {
            var ring = list$1[i$1];
            for (var i = 0, list = ring; i < list.length; i += 1) {
                var point = list[i];
                var transformedPoint = alignWithMap ? point : projectPoint(point, pixelPosMatrix);
                var adjustedSize = transformedSize;
                var projectedCenter = transformMat4([], [
                    point.x,
                    point.y,
                    0,
                    1
                ], pixelPosMatrix);
                if (this.paint.get('circle-pitch-scale') === 'viewport' && this.paint.get('circle-pitch-alignment') === 'map') {
                    adjustedSize *= projectedCenter[3] / transform.cameraToCenterDistance;
                } else if (this.paint.get('circle-pitch-scale') === 'map' && this.paint.get('circle-pitch-alignment') === 'viewport') {
                    adjustedSize *= transform.cameraToCenterDistance / projectedCenter[3];
                }
                if (polygonIntersectsBufferedPoint(transformedPolygon, transformedPoint, adjustedSize)) {
                    return true;
                }
            }
        }
        return false;
    };
    return CircleStyleLayer;
}(StyleLayer);
function projectPoint(p, pixelPosMatrix) {
    var point = transformMat4([], [
        p.x,
        p.y,
        0,
        1
    ], pixelPosMatrix);
    return new pointGeometry(point[0] / point[3], point[1] / point[3]);
}
function projectQueryGeometry(queryGeometry, pixelPosMatrix) {
    return queryGeometry.map(function (p) {
        return projectPoint(p, pixelPosMatrix);
    });
}

var HeatmapBucket = function (CircleBucket) {
    function HeatmapBucket() {
        CircleBucket.apply(this, arguments);
    }
    if (CircleBucket)
        HeatmapBucket.__proto__ = CircleBucket;
    HeatmapBucket.prototype = Object.create(CircleBucket && CircleBucket.prototype);
    HeatmapBucket.prototype.constructor = HeatmapBucket;
    return HeatmapBucket;
}(CircleBucket);
register('HeatmapBucket', HeatmapBucket, { omit: ['layers'] });

function createImage(image, ref, channels, data) {
    var width = ref.width;
    var height = ref.height;
    if (!data) {
        data = new Uint8Array(width * height * channels);
    } else if (data instanceof Uint8ClampedArray) {
        data = new Uint8Array(data.buffer);
    } else if (data.length !== width * height * channels) {
        throw new RangeError('mismatched image size');
    }
    image.width = width;
    image.height = height;
    image.data = data;
    return image;
}
function resizeImage(image, ref, channels) {
    var width = ref.width;
    var height = ref.height;
    if (width === image.width && height === image.height) {
        return;
    }
    var newImage = createImage({}, {
        width: width,
        height: height
    }, channels);
    copyImage(image, newImage, {
        x: 0,
        y: 0
    }, {
        x: 0,
        y: 0
    }, {
        width: Math.min(image.width, width),
        height: Math.min(image.height, height)
    }, channels);
    image.width = width;
    image.height = height;
    image.data = newImage.data;
}
function copyImage(srcImg, dstImg, srcPt, dstPt, size, channels) {
    if (size.width === 0 || size.height === 0) {
        return dstImg;
    }
    if (size.width > srcImg.width || size.height > srcImg.height || srcPt.x > srcImg.width - size.width || srcPt.y > srcImg.height - size.height) {
        throw new RangeError('out of range source coordinates for image copy');
    }
    if (size.width > dstImg.width || size.height > dstImg.height || dstPt.x > dstImg.width - size.width || dstPt.y > dstImg.height - size.height) {
        throw new RangeError('out of range destination coordinates for image copy');
    }
    var srcData = srcImg.data;
    var dstData = dstImg.data;
    for (var y = 0; y < size.height; y++) {
        var srcOffset = ((srcPt.y + y) * srcImg.width + srcPt.x) * channels;
        var dstOffset = ((dstPt.y + y) * dstImg.width + dstPt.x) * channels;
        for (var i = 0; i < size.width * channels; i++) {
            dstData[dstOffset + i] = srcData[srcOffset + i];
        }
    }
    return dstImg;
}
var AlphaImage = function AlphaImage(size, data) {
    createImage(this, size, 1, data);
};
AlphaImage.prototype.resize = function resize(size) {
    resizeImage(this, size, 1);
};
AlphaImage.prototype.clone = function clone() {
    return new AlphaImage({
        width: this.width,
        height: this.height
    }, new Uint8Array(this.data));
};
AlphaImage.copy = function copy(srcImg, dstImg, srcPt, dstPt, size) {
    copyImage(srcImg, dstImg, srcPt, dstPt, size, 1);
};
var RGBAImage = function RGBAImage(size, data) {
    createImage(this, size, 4, data);
};
RGBAImage.prototype.resize = function resize(size) {
    resizeImage(this, size, 4);
};
RGBAImage.prototype.replace = function replace(data, copy) {
    if (copy) {
        this.data.set(data);
    } else if (data instanceof Uint8ClampedArray) {
        this.data = new Uint8Array(data.buffer);
    } else {
        this.data = data;
    }
};
RGBAImage.prototype.clone = function clone() {
    return new RGBAImage({
        width: this.width,
        height: this.height
    }, new Uint8Array(this.data));
};
RGBAImage.copy = function copy(srcImg, dstImg, srcPt, dstPt, size) {
    copyImage(srcImg, dstImg, srcPt, dstPt, size, 4);
};
register('AlphaImage', AlphaImage);
register('RGBAImage', RGBAImage);

var paint$2 = new Properties({
    'heatmap-radius': new DataDrivenProperty(spec['paint_heatmap']['heatmap-radius']),
    'heatmap-weight': new DataDrivenProperty(spec['paint_heatmap']['heatmap-weight']),
    'heatmap-intensity': new DataConstantProperty(spec['paint_heatmap']['heatmap-intensity']),
    'heatmap-color': new ColorRampProperty(spec['paint_heatmap']['heatmap-color']),
    'heatmap-opacity': new DataConstantProperty(spec['paint_heatmap']['heatmap-opacity'])
});
var properties$1 = { paint: paint$2 };

function renderColorRamp(params) {
    var evaluationGlobals = {};
    var width = params.resolution || 256;
    var height = params.clips ? params.clips.length : 1;
    var image = params.image || new RGBAImage({
        width: width,
        height: height
    });
    var renderPixel = function (stride, index, progress) {
        evaluationGlobals[params.evaluationKey] = progress;
        var pxColor = params.expression.evaluate(evaluationGlobals);
        image.data[stride + index + 0] = Math.floor(pxColor.r * 255 / pxColor.a);
        image.data[stride + index + 1] = Math.floor(pxColor.g * 255 / pxColor.a);
        image.data[stride + index + 2] = Math.floor(pxColor.b * 255 / pxColor.a);
        image.data[stride + index + 3] = Math.floor(pxColor.a * 255);
    };
    if (!params.clips) {
        for (var i = 0, j = 0; i < width; i++, j += 4) {
            var progress = i / (width - 1);
            renderPixel(0, j, progress);
        }
    } else {
        for (var clip = 0, stride = 0; clip < height; ++clip, stride += width * 4) {
            for (var i$1 = 0, j$1 = 0; i$1 < width; i$1++, j$1 += 4) {
                var progress$1 = i$1 / (width - 1);
                var ref = params.clips[clip];
                var start = ref.start;
                var end = ref.end;
                var evaluationProgress = start * (1 - progress$1) + end * progress$1;
                renderPixel(stride, j$1, evaluationProgress);
            }
        }
    }
    return image;
}

var HeatmapStyleLayer = function (StyleLayer) {
    function HeatmapStyleLayer(layer) {
        StyleLayer.call(this, layer, properties$1);
        this._updateColorRamp();
    }
    if (StyleLayer)
        HeatmapStyleLayer.__proto__ = StyleLayer;
    HeatmapStyleLayer.prototype = Object.create(StyleLayer && StyleLayer.prototype);
    HeatmapStyleLayer.prototype.constructor = HeatmapStyleLayer;
    HeatmapStyleLayer.prototype.createBucket = function createBucket(options) {
        return new HeatmapBucket(options);
    };
    HeatmapStyleLayer.prototype._handleSpecialPaintPropertyUpdate = function _handleSpecialPaintPropertyUpdate(name) {
        if (name === 'heatmap-color') {
            this._updateColorRamp();
        }
    };
    HeatmapStyleLayer.prototype._updateColorRamp = function _updateColorRamp() {
        var expression = this._transitionablePaint._values['heatmap-color'].value.expression;
        this.colorRamp = renderColorRamp({
            expression: expression,
            evaluationKey: 'heatmapDensity',
            image: this.colorRamp
        });
        this.colorRampTexture = null;
    };
    HeatmapStyleLayer.prototype.resize = function resize() {
        if (this.heatmapFbo) {
            this.heatmapFbo.destroy();
            this.heatmapFbo = null;
        }
    };
    HeatmapStyleLayer.prototype.queryRadius = function queryRadius() {
        return 0;
    };
    HeatmapStyleLayer.prototype.queryIntersectsFeature = function queryIntersectsFeature() {
        return false;
    };
    HeatmapStyleLayer.prototype.hasOffscreenPass = function hasOffscreenPass() {
        return this.paint.get('heatmap-opacity') !== 0 && this.visibility !== 'none';
    };
    return HeatmapStyleLayer;
}(StyleLayer);

var paint$3 = new Properties({
    'hillshade-illumination-direction': new DataConstantProperty(spec['paint_hillshade']['hillshade-illumination-direction']),
    'hillshade-illumination-anchor': new DataConstantProperty(spec['paint_hillshade']['hillshade-illumination-anchor']),
    'hillshade-exaggeration': new DataConstantProperty(spec['paint_hillshade']['hillshade-exaggeration']),
    'hillshade-shadow-color': new DataConstantProperty(spec['paint_hillshade']['hillshade-shadow-color']),
    'hillshade-highlight-color': new DataConstantProperty(spec['paint_hillshade']['hillshade-highlight-color']),
    'hillshade-accent-color': new DataConstantProperty(spec['paint_hillshade']['hillshade-accent-color'])
});
var properties$2 = { paint: paint$3 };

var HillshadeStyleLayer = function (StyleLayer) {
    function HillshadeStyleLayer(layer) {
        StyleLayer.call(this, layer, properties$2);
    }
    if (StyleLayer)
        HillshadeStyleLayer.__proto__ = StyleLayer;
    HillshadeStyleLayer.prototype = Object.create(StyleLayer && StyleLayer.prototype);
    HillshadeStyleLayer.prototype.constructor = HillshadeStyleLayer;
    HillshadeStyleLayer.prototype.hasOffscreenPass = function hasOffscreenPass() {
        return this.paint.get('hillshade-exaggeration') !== 0 && this.visibility !== 'none';
    };
    return HillshadeStyleLayer;
}(StyleLayer);

var layout$3 = createLayout([{
        name: 'a_pos',
        components: 2,
        type: 'Int16'
    }], 4);
var members$1 = layout$3.members;

var earcut_1 = earcut;
var default_1 = earcut;
function earcut(data, holeIndices, dim) {
    dim = dim || 2;
    var hasHoles = holeIndices && holeIndices.length, outerLen = hasHoles ? holeIndices[0] * dim : data.length, outerNode = linkedList(data, 0, outerLen, dim, true), triangles = [];
    if (!outerNode || outerNode.next === outerNode.prev) {
        return triangles;
    }
    var minX, minY, maxX, maxY, x, y, invSize;
    if (hasHoles) {
        outerNode = eliminateHoles(data, holeIndices, outerNode, dim);
    }
    if (data.length > 80 * dim) {
        minX = maxX = data[0];
        minY = maxY = data[1];
        for (var i = dim; i < outerLen; i += dim) {
            x = data[i];
            y = data[i + 1];
            if (x < minX) {
                minX = x;
            }
            if (y < minY) {
                minY = y;
            }
            if (x > maxX) {
                maxX = x;
            }
            if (y > maxY) {
                maxY = y;
            }
        }
        invSize = Math.max(maxX - minX, maxY - minY);
        invSize = invSize !== 0 ? 1 / invSize : 0;
    }
    earcutLinked(outerNode, triangles, dim, minX, minY, invSize);
    return triangles;
}
function linkedList(data, start, end, dim, clockwise) {
    var i, last;
    if (clockwise === signedArea(data, start, end, dim) > 0) {
        for (i = start; i < end; i += dim) {
            last = insertNode(i, data[i], data[i + 1], last);
        }
    } else {
        for (i = end - dim; i >= start; i -= dim) {
            last = insertNode(i, data[i], data[i + 1], last);
        }
    }
    if (last && equals(last, last.next)) {
        removeNode(last);
        last = last.next;
    }
    return last;
}
function filterPoints(start, end) {
    if (!start) {
        return start;
    }
    if (!end) {
        end = start;
    }
    var p = start, again;
    do {
        again = false;
        if (!p.steiner && (equals(p, p.next) || area(p.prev, p, p.next) === 0)) {
            removeNode(p);
            p = end = p.prev;
            if (p === p.next) {
                break;
            }
            again = true;
        } else {
            p = p.next;
        }
    } while (again || p !== end);
    return end;
}
function earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
    if (!ear) {
        return;
    }
    if (!pass && invSize) {
        indexCurve(ear, minX, minY, invSize);
    }
    var stop = ear, prev, next;
    while (ear.prev !== ear.next) {
        prev = ear.prev;
        next = ear.next;
        if (invSize ? isEarHashed(ear, minX, minY, invSize) : isEar(ear)) {
            triangles.push(prev.i / dim);
            triangles.push(ear.i / dim);
            triangles.push(next.i / dim);
            removeNode(ear);
            ear = next.next;
            stop = next.next;
            continue;
        }
        ear = next;
        if (ear === stop) {
            if (!pass) {
                earcutLinked(filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
            } else if (pass === 1) {
                ear = cureLocalIntersections(filterPoints(ear), triangles, dim);
                earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
            } else if (pass === 2) {
                splitEarcut(ear, triangles, dim, minX, minY, invSize);
            }
            break;
        }
    }
}
function isEar(ear) {
    var a = ear.prev, b = ear, c = ear.next;
    if (area(a, b, c) >= 0) {
        return false;
    }
    var p = ear.next.next;
    while (p !== ear.prev) {
        if (pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) && area(p.prev, p, p.next) >= 0) {
            return false;
        }
        p = p.next;
    }
    return true;
}
function isEarHashed(ear, minX, minY, invSize) {
    var a = ear.prev, b = ear, c = ear.next;
    if (area(a, b, c) >= 0) {
        return false;
    }
    var minTX = a.x < b.x ? a.x < c.x ? a.x : c.x : b.x < c.x ? b.x : c.x, minTY = a.y < b.y ? a.y < c.y ? a.y : c.y : b.y < c.y ? b.y : c.y, maxTX = a.x > b.x ? a.x > c.x ? a.x : c.x : b.x > c.x ? b.x : c.x, maxTY = a.y > b.y ? a.y > c.y ? a.y : c.y : b.y > c.y ? b.y : c.y;
    var minZ = zOrder(minTX, minTY, minX, minY, invSize), maxZ = zOrder(maxTX, maxTY, minX, minY, invSize);
    var p = ear.prevZ, n = ear.nextZ;
    while (p && p.z >= minZ && n && n.z <= maxZ) {
        if (p !== ear.prev && p !== ear.next && pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) && area(p.prev, p, p.next) >= 0) {
            return false;
        }
        p = p.prevZ;
        if (n !== ear.prev && n !== ear.next && pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, n.x, n.y) && area(n.prev, n, n.next) >= 0) {
            return false;
        }
        n = n.nextZ;
    }
    while (p && p.z >= minZ) {
        if (p !== ear.prev && p !== ear.next && pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) && area(p.prev, p, p.next) >= 0) {
            return false;
        }
        p = p.prevZ;
    }
    while (n && n.z <= maxZ) {
        if (n !== ear.prev && n !== ear.next && pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, n.x, n.y) && area(n.prev, n, n.next) >= 0) {
            return false;
        }
        n = n.nextZ;
    }
    return true;
}
function cureLocalIntersections(start, triangles, dim) {
    var p = start;
    do {
        var a = p.prev, b = p.next.next;
        if (!equals(a, b) && intersects(a, p, p.next, b) && locallyInside(a, b) && locallyInside(b, a)) {
            triangles.push(a.i / dim);
            triangles.push(p.i / dim);
            triangles.push(b.i / dim);
            removeNode(p);
            removeNode(p.next);
            p = start = b;
        }
        p = p.next;
    } while (p !== start);
    return filterPoints(p);
}
function splitEarcut(start, triangles, dim, minX, minY, invSize) {
    var a = start;
    do {
        var b = a.next.next;
        while (b !== a.prev) {
            if (a.i !== b.i && isValidDiagonal(a, b)) {
                var c = splitPolygon(a, b);
                a = filterPoints(a, a.next);
                c = filterPoints(c, c.next);
                earcutLinked(a, triangles, dim, minX, minY, invSize);
                earcutLinked(c, triangles, dim, minX, minY, invSize);
                return;
            }
            b = b.next;
        }
        a = a.next;
    } while (a !== start);
}
function eliminateHoles(data, holeIndices, outerNode, dim) {
    var queue = [], i, len, start, end, list;
    for (i = 0, len = holeIndices.length; i < len; i++) {
        start = holeIndices[i] * dim;
        end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        list = linkedList(data, start, end, dim, false);
        if (list === list.next) {
            list.steiner = true;
        }
        queue.push(getLeftmost(list));
    }
    queue.sort(compareX);
    for (i = 0; i < queue.length; i++) {
        eliminateHole(queue[i], outerNode);
        outerNode = filterPoints(outerNode, outerNode.next);
    }
    return outerNode;
}
function compareX(a, b) {
    return a.x - b.x;
}
function eliminateHole(hole, outerNode) {
    outerNode = findHoleBridge(hole, outerNode);
    if (outerNode) {
        var b = splitPolygon(outerNode, hole);
        filterPoints(outerNode, outerNode.next);
        filterPoints(b, b.next);
    }
}
function findHoleBridge(hole, outerNode) {
    var p = outerNode, hx = hole.x, hy = hole.y, qx = -Infinity, m;
    do {
        if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
            var x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
            if (x <= hx && x > qx) {
                qx = x;
                if (x === hx) {
                    if (hy === p.y) {
                        return p;
                    }
                    if (hy === p.next.y) {
                        return p.next;
                    }
                }
                m = p.x < p.next.x ? p : p.next;
            }
        }
        p = p.next;
    } while (p !== outerNode);
    if (!m) {
        return null;
    }
    if (hx === qx) {
        return m;
    }
    var stop = m, mx = m.x, my = m.y, tanMin = Infinity, tan;
    p = m;
    do {
        if (hx >= p.x && p.x >= mx && hx !== p.x && pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
            tan = Math.abs(hy - p.y) / (hx - p.x);
            if (locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && sectorContainsSector(m, p)))) {
                m = p;
                tanMin = tan;
            }
        }
        p = p.next;
    } while (p !== stop);
    return m;
}
function sectorContainsSector(m, p) {
    return area(m.prev, m, p.prev) < 0 && area(p.next, m, m.next) < 0;
}
function indexCurve(start, minX, minY, invSize) {
    var p = start;
    do {
        if (p.z === null) {
            p.z = zOrder(p.x, p.y, minX, minY, invSize);
        }
        p.prevZ = p.prev;
        p.nextZ = p.next;
        p = p.next;
    } while (p !== start);
    p.prevZ.nextZ = null;
    p.prevZ = null;
    sortLinked(p);
}
function sortLinked(list) {
    var i, p, q, e, tail, numMerges, pSize, qSize, inSize = 1;
    do {
        p = list;
        list = null;
        tail = null;
        numMerges = 0;
        while (p) {
            numMerges++;
            q = p;
            pSize = 0;
            for (i = 0; i < inSize; i++) {
                pSize++;
                q = q.nextZ;
                if (!q) {
                    break;
                }
            }
            qSize = inSize;
            while (pSize > 0 || qSize > 0 && q) {
                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                }
                if (tail) {
                    tail.nextZ = e;
                } else {
                    list = e;
                }
                e.prevZ = tail;
                tail = e;
            }
            p = q;
        }
        tail.nextZ = null;
        inSize *= 2;
    } while (numMerges > 1);
    return list;
}
function zOrder(x, y, minX, minY, invSize) {
    x = 32767 * (x - minX) * invSize;
    y = 32767 * (y - minY) * invSize;
    x = (x | x << 8) & 16711935;
    x = (x | x << 4) & 252645135;
    x = (x | x << 2) & 858993459;
    x = (x | x << 1) & 1431655765;
    y = (y | y << 8) & 16711935;
    y = (y | y << 4) & 252645135;
    y = (y | y << 2) & 858993459;
    y = (y | y << 1) & 1431655765;
    return x | y << 1;
}
function getLeftmost(start) {
    var p = start, leftmost = start;
    do {
        if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y) {
            leftmost = p;
        }
        p = p.next;
    } while (p !== start);
    return leftmost;
}
function pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
    return (cx - px) * (ay - py) - (ax - px) * (cy - py) >= 0 && (ax - px) * (by - py) - (bx - px) * (ay - py) >= 0 && (bx - px) * (cy - py) - (cx - px) * (by - py) >= 0;
}
function isValidDiagonal(a, b) {
    return a.next.i !== b.i && a.prev.i !== b.i && !intersectsPolygon(a, b) && (locallyInside(a, b) && locallyInside(b, a) && middleInside(a, b) && (area(a.prev, a, b.prev) || area(a, b.prev, b)) || equals(a, b) && area(a.prev, a, a.next) > 0 && area(b.prev, b, b.next) > 0);
}
function area(p, q, r) {
    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}
function equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}
function intersects(p1, q1, p2, q2) {
    var o1 = sign(area(p1, q1, p2));
    var o2 = sign(area(p1, q1, q2));
    var o3 = sign(area(p2, q2, p1));
    var o4 = sign(area(p2, q2, q1));
    if (o1 !== o2 && o3 !== o4) {
        return true;
    }
    if (o1 === 0 && onSegment(p1, p2, q1)) {
        return true;
    }
    if (o2 === 0 && onSegment(p1, q2, q1)) {
        return true;
    }
    if (o3 === 0 && onSegment(p2, p1, q2)) {
        return true;
    }
    if (o4 === 0 && onSegment(p2, q1, q2)) {
        return true;
    }
    return false;
}
function onSegment(p, q, r) {
    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}
function sign(num) {
    return num > 0 ? 1 : num < 0 ? -1 : 0;
}
function intersectsPolygon(a, b) {
    var p = a;
    do {
        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && intersects(p, p.next, a, b)) {
            return true;
        }
        p = p.next;
    } while (p !== a);
    return false;
}
function locallyInside(a, b) {
    return area(a.prev, a, a.next) < 0 ? area(a, b, a.next) >= 0 && area(a, a.prev, b) >= 0 : area(a, b, a.prev) < 0 || area(a, a.next, b) < 0;
}
function middleInside(a, b) {
    var p = a, inside = false, px = (a.x + b.x) / 2, py = (a.y + b.y) / 2;
    do {
        if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x) {
            inside = !inside;
        }
        p = p.next;
    } while (p !== a);
    return inside;
}
function splitPolygon(a, b) {
    var a2 = new Node(a.i, a.x, a.y), b2 = new Node(b.i, b.x, b.y), an = a.next, bp = b.prev;
    a.next = b;
    b.prev = a;
    a2.next = an;
    an.prev = a2;
    b2.next = a2;
    a2.prev = b2;
    bp.next = b2;
    b2.prev = bp;
    return b2;
}
function insertNode(i, x, y, last) {
    var p = new Node(i, x, y);
    if (!last) {
        p.prev = p;
        p.next = p;
    } else {
        p.next = last.next;
        p.prev = last;
        last.next.prev = p;
        last.next = p;
    }
    return p;
}
function removeNode(p) {
    p.next.prev = p.prev;
    p.prev.next = p.next;
    if (p.prevZ) {
        p.prevZ.nextZ = p.nextZ;
    }
    if (p.nextZ) {
        p.nextZ.prevZ = p.prevZ;
    }
}
function Node(i, x, y) {
    this.i = i;
    this.x = x;
    this.y = y;
    this.prev = null;
    this.next = null;
    this.z = null;
    this.prevZ = null;
    this.nextZ = null;
    this.steiner = false;
}
earcut.deviation = function (data, holeIndices, dim, triangles) {
    var hasHoles = holeIndices && holeIndices.length;
    var outerLen = hasHoles ? holeIndices[0] * dim : data.length;
    var polygonArea = Math.abs(signedArea(data, 0, outerLen, dim));
    if (hasHoles) {
        for (var i = 0, len = holeIndices.length; i < len; i++) {
            var start = holeIndices[i] * dim;
            var end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
            polygonArea -= Math.abs(signedArea(data, start, end, dim));
        }
    }
    var trianglesArea = 0;
    for (i = 0; i < triangles.length; i += 3) {
        var a = triangles[i] * dim;
        var b = triangles[i + 1] * dim;
        var c = triangles[i + 2] * dim;
        trianglesArea += Math.abs((data[a] - data[c]) * (data[b + 1] - data[a + 1]) - (data[a] - data[b]) * (data[c + 1] - data[a + 1]));
    }
    return polygonArea === 0 && trianglesArea === 0 ? 0 : Math.abs((trianglesArea - polygonArea) / polygonArea);
};
function signedArea(data, start, end, dim) {
    var sum = 0;
    for (var i = start, j = end - dim; i < end; i += dim) {
        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
        j = i;
    }
    return sum;
}
earcut.flatten = function (data) {
    var dim = data[0][0].length, result = {
            vertices: [],
            holes: [],
            dimensions: dim
        }, holeIndex = 0;
    for (var i = 0; i < data.length; i++) {
        for (var j = 0; j < data[i].length; j++) {
            for (var d = 0; d < dim; d++) {
                result.vertices.push(data[i][j][d]);
            }
        }
        if (i > 0) {
            holeIndex += data[i - 1].length;
            result.holes.push(holeIndex);
        }
    }
    return result;
};
earcut_1.default = default_1;

function quickselect(arr, k, left, right, compare) {
    quickselectStep(arr, k, left || 0, right || arr.length - 1, compare || defaultCompare);
}
function quickselectStep(arr, k, left, right, compare) {
    while (right > left) {
        if (right - left > 600) {
            var n = right - left + 1;
            var m = k - left + 1;
            var z = Math.log(n);
            var s = 0.5 * Math.exp(2 * z / 3);
            var sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            var newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            var newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            quickselectStep(arr, k, newLeft, newRight, compare);
        }
        var t = arr[k];
        var i = left;
        var j = right;
        swap$1(arr, left, k);
        if (compare(arr[right], t) > 0) {
            swap$1(arr, left, right);
        }
        while (i < j) {
            swap$1(arr, i, j);
            i++;
            j--;
            while (compare(arr[i], t) < 0) {
                i++;
            }
            while (compare(arr[j], t) > 0) {
                j--;
            }
        }
        if (compare(arr[left], t) === 0) {
            swap$1(arr, left, j);
        } else {
            j++;
            swap$1(arr, j, right);
        }
        if (j <= k) {
            left = j + 1;
        }
        if (k <= j) {
            right = j - 1;
        }
    }
}
function swap$1(arr, i, j) {
    var tmp = arr[i];
    arr[i] = arr[j];
    arr[j] = tmp;
}
function defaultCompare(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
}

function classifyRings(rings, maxRings) {
    var len = rings.length;
    if (len <= 1) {
        return [rings];
    }
    var polygons = [];
    var polygon, ccw;
    for (var i = 0; i < len; i++) {
        var area = calculateSignedArea(rings[i]);
        if (area === 0) {
            continue;
        }
        rings[i].area = Math.abs(area);
        if (ccw === undefined) {
            ccw = area < 0;
        }
        if (ccw === area < 0) {
            if (polygon) {
                polygons.push(polygon);
            }
            polygon = [rings[i]];
        } else {
            polygon.push(rings[i]);
        }
    }
    if (polygon) {
        polygons.push(polygon);
    }
    if (maxRings > 1) {
        for (var j = 0; j < polygons.length; j++) {
            if (polygons[j].length <= maxRings) {
                continue;
            }
            quickselect(polygons[j], maxRings, 1, polygons[j].length - 1, compareAreas);
            polygons[j] = polygons[j].slice(0, maxRings);
        }
    }
    return polygons;
}
function compareAreas(a, b) {
    return b.area - a.area;
}

function hasPattern(type, layers, options) {
    var patterns = options.patternDependencies;
    var hasPattern = false;
    for (var i = 0, list = layers; i < list.length; i += 1) {
        var layer = list[i];
        var patternProperty = layer.paint.get(type + '-pattern');
        if (!patternProperty.isConstant()) {
            hasPattern = true;
        }
        var constantPattern = patternProperty.constantOr(null);
        if (constantPattern) {
            hasPattern = true;
            patterns[constantPattern.to] = true;
            patterns[constantPattern.from] = true;
        }
    }
    return hasPattern;
}
function addPatternDependencies(type, layers, patternFeature, zoom, options) {
    var patterns = options.patternDependencies;
    for (var i = 0, list = layers; i < list.length; i += 1) {
        var layer = list[i];
        var patternProperty = layer.paint.get(type + '-pattern');
        var patternPropertyValue = patternProperty.value;
        if (patternPropertyValue.kind !== 'constant') {
            var min = patternPropertyValue.evaluate({ zoom: zoom - 1 }, patternFeature, {}, options.availableImages);
            var mid = patternPropertyValue.evaluate({ zoom: zoom }, patternFeature, {}, options.availableImages);
            var max = patternPropertyValue.evaluate({ zoom: zoom + 1 }, patternFeature, {}, options.availableImages);
            min = min && min.name ? min.name : min;
            mid = mid && mid.name ? mid.name : mid;
            max = max && max.name ? max.name : max;
            patterns[min] = true;
            patterns[mid] = true;
            patterns[max] = true;
            patternFeature.patterns[layer.id] = {
                min: min,
                mid: mid,
                max: max
            };
        }
    }
    return patternFeature;
}

var EARCUT_MAX_RINGS = 500;
var FillBucket = function FillBucket(options) {
    this.zoom = options.zoom;
    this.overscaling = options.overscaling;
    this.layers = options.layers;
    this.layerIds = this.layers.map(function (layer) {
        return layer.id;
    });
    this.index = options.index;
    this.hasPattern = false;
    this.patternFeatures = [];
    this.layoutVertexArray = new StructArrayLayout2i4();
    this.indexArray = new StructArrayLayout3ui6();
    this.indexArray2 = new StructArrayLayout2ui4();
    this.programConfigurations = new ProgramConfigurationSet(options.layers, options.zoom);
    this.segments = new SegmentVector();
    this.segments2 = new SegmentVector();
    this.stateDependentLayerIds = this.layers.filter(function (l) {
        return l.isStateDependent();
    }).map(function (l) {
        return l.id;
    });
};
FillBucket.prototype.populate = function populate(features, options, canonical) {
    this.hasPattern = hasPattern('fill', this.layers, options);
    var fillSortKey = this.layers[0].layout.get('fill-sort-key');
    var bucketFeatures = [];
    for (var i = 0, list = features; i < list.length; i += 1) {
        var ref = list[i];
        var feature = ref.feature;
        var id = ref.id;
        var index = ref.index;
        var sourceLayerIndex = ref.sourceLayerIndex;
        var needGeometry = this.layers[0]._featureFilter.needGeometry;
        var evaluationFeature = toEvaluationFeature(feature, needGeometry);
        if (!this.layers[0]._featureFilter.filter(new EvaluationParameters(this.zoom), evaluationFeature, canonical)) {
            continue;
        }
        var sortKey = fillSortKey ? fillSortKey.evaluate(evaluationFeature, {}, canonical, options.availableImages) : undefined;
        var bucketFeature = {
            id: id,
            properties: feature.properties,
            type: feature.type,
            sourceLayerIndex: sourceLayerIndex,
            index: index,
            geometry: needGeometry ? evaluationFeature.geometry : loadGeometry(feature),
            patterns: {},
            sortKey: sortKey
        };
        bucketFeatures.push(bucketFeature);
    }
    if (fillSortKey) {
        bucketFeatures.sort(function (a, b) {
            return a.sortKey - b.sortKey;
        });
    }
    for (var i$1 = 0, list$1 = bucketFeatures; i$1 < list$1.length; i$1 += 1) {
        var bucketFeature$1 = list$1[i$1];
        var ref$1 = bucketFeature$1;
        var geometry = ref$1.geometry;
        var index$1 = ref$1.index;
        var sourceLayerIndex$1 = ref$1.sourceLayerIndex;
        if (this.hasPattern) {
            var patternFeature = addPatternDependencies('fill', this.layers, bucketFeature$1, this.zoom, options);
            this.patternFeatures.push(patternFeature);
        } else {
            this.addFeature(bucketFeature$1, geometry, index$1, canonical, {});
        }
        var feature$1 = features[index$1].feature;
        options.featureIndex.insert(feature$1, geometry, index$1, sourceLayerIndex$1, this.index);
    }
};
FillBucket.prototype.update = function update(states, vtLayer, imagePositions) {
    if (!this.stateDependentLayers.length) {
        return;
    }
    this.programConfigurations.updatePaintArrays(states, vtLayer, this.stateDependentLayers, imagePositions);
};
FillBucket.prototype.addFeatures = function addFeatures(options, canonical, imagePositions) {
    for (var i = 0, list = this.patternFeatures; i < list.length; i += 1) {
        var feature = list[i];
        this.addFeature(feature, feature.geometry, feature.index, canonical, imagePositions);
    }
};
FillBucket.prototype.isEmpty = function isEmpty() {
    return this.layoutVertexArray.length === 0;
};
FillBucket.prototype.uploadPending = function uploadPending() {
    return !this.uploaded || this.programConfigurations.needsUpload;
};
FillBucket.prototype.upload = function upload(context) {
    if (!this.uploaded) {
        this.layoutVertexBuffer = context.createVertexBuffer(this.layoutVertexArray, members$1);
        this.indexBuffer = context.createIndexBuffer(this.indexArray);
        this.indexBuffer2 = context.createIndexBuffer(this.indexArray2);
    }
    this.programConfigurations.upload(context);
    this.uploaded = true;
};
FillBucket.prototype.destroy = function destroy() {
    if (!this.layoutVertexBuffer) {
        return;
    }
    this.layoutVertexBuffer.destroy();
    this.indexBuffer.destroy();
    this.indexBuffer2.destroy();
    this.programConfigurations.destroy();
    this.segments.destroy();
    this.segments2.destroy();
};
FillBucket.prototype.addFeature = function addFeature(feature, geometry, index, canonical, imagePositions) {
    for (var i$4 = 0, list$2 = classifyRings(geometry, EARCUT_MAX_RINGS); i$4 < list$2.length; i$4 += 1) {
        var polygon = list$2[i$4];
        var numVertices = 0;
        for (var i$2 = 0, list = polygon; i$2 < list.length; i$2 += 1) {
            var ring = list[i$2];
            numVertices += ring.length;
        }
        var triangleSegment = this.segments.prepareSegment(numVertices, this.layoutVertexArray, this.indexArray);
        var triangleIndex = triangleSegment.vertexLength;
        var flattened = [];
        var holeIndices = [];
        for (var i$3 = 0, list$1 = polygon; i$3 < list$1.length; i$3 += 1) {
            var ring$1 = list$1[i$3];
            if (ring$1.length === 0) {
                continue;
            }
            if (ring$1 !== polygon[0]) {
                holeIndices.push(flattened.length / 2);
            }
            var lineSegment = this.segments2.prepareSegment(ring$1.length, this.layoutVertexArray, this.indexArray2);
            var lineIndex = lineSegment.vertexLength;
            this.layoutVertexArray.emplaceBack(ring$1[0].x, ring$1[0].y);
            this.indexArray2.emplaceBack(lineIndex + ring$1.length - 1, lineIndex);
            flattened.push(ring$1[0].x);
            flattened.push(ring$1[0].y);
            for (var i = 1; i < ring$1.length; i++) {
                this.layoutVertexArray.emplaceBack(ring$1[i].x, ring$1[i].y);
                this.indexArray2.emplaceBack(lineIndex + i - 1, lineIndex + i);
                flattened.push(ring$1[i].x);
                flattened.push(ring$1[i].y);
            }
            lineSegment.vertexLength += ring$1.length;
            lineSegment.primitiveLength += ring$1.length;
        }
        var indices = earcut_1(flattened, holeIndices);
        for (var i$1 = 0; i$1 < indices.length; i$1 += 3) {
            this.indexArray.emplaceBack(triangleIndex + indices[i$1], triangleIndex + indices[i$1 + 1], triangleIndex + indices[i$1 + 2]);
        }
        triangleSegment.vertexLength += numVertices;
        triangleSegment.primitiveLength += indices.length / 3;
    }
    this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, feature, index, imagePositions, canonical);
};
register('FillBucket', FillBucket, {
    omit: [
        'layers',
        'patternFeatures'
    ]
});

var layout$4 = new Properties({ 'fill-sort-key': new DataDrivenProperty(spec['layout_fill']['fill-sort-key']) });
var paint$4 = new Properties({
    'fill-antialias': new DataConstantProperty(spec['paint_fill']['fill-antialias']),
    'fill-opacity': new DataDrivenProperty(spec['paint_fill']['fill-opacity']),
    'fill-color': new DataDrivenProperty(spec['paint_fill']['fill-color']),
    'fill-outline-color': new DataDrivenProperty(spec['paint_fill']['fill-outline-color']),
    'fill-translate': new DataConstantProperty(spec['paint_fill']['fill-translate']),
    'fill-translate-anchor': new DataConstantProperty(spec['paint_fill']['fill-translate-anchor']),
    'fill-pattern': new CrossFadedDataDrivenProperty(spec['paint_fill']['fill-pattern'])
});
var properties$3 = {
    paint: paint$4,
    layout: layout$4
};

var FillStyleLayer = function (StyleLayer) {
    function FillStyleLayer(layer) {
        StyleLayer.call(this, layer, properties$3);
    }
    if (StyleLayer)
        FillStyleLayer.__proto__ = StyleLayer;
    FillStyleLayer.prototype = Object.create(StyleLayer && StyleLayer.prototype);
    FillStyleLayer.prototype.constructor = FillStyleLayer;
    FillStyleLayer.prototype.recalculate = function recalculate(parameters, availableImages) {
        StyleLayer.prototype.recalculate.call(this, parameters, availableImages);
        var outlineColor = this.paint._values['fill-outline-color'];
        if (outlineColor.value.kind === 'constant' && outlineColor.value.value === undefined) {
            this.paint._values['fill-outline-color'] = this.paint._values['fill-color'];
        }
    };
    FillStyleLayer.prototype.createBucket = function createBucket(parameters) {
        return new FillBucket(parameters);
    };
    FillStyleLayer.prototype.queryRadius = function queryRadius() {
        return translateDistance(this.paint.get('fill-translate'));
    };
    FillStyleLayer.prototype.queryIntersectsFeature = function queryIntersectsFeature(queryGeometry, feature, featureState, geometry, zoom, transform, pixelsToTileUnits) {
        var translatedPolygon = translate(queryGeometry, this.paint.get('fill-translate'), this.paint.get('fill-translate-anchor'), transform.angle, pixelsToTileUnits);
        return polygonIntersectsMultiPolygon(translatedPolygon, geometry);
    };
    FillStyleLayer.prototype.isTileClipped = function isTileClipped() {
        return true;
    };
    return FillStyleLayer;
}(StyleLayer);

var layout$5 = createLayout([
    {
        name: 'a_pos',
        components: 2,
        type: 'Int16'
    },
    {
        name: 'a_normal_ed',
        components: 4,
        type: 'Int16'
    }
], 4);
var members$2 = layout$5.members;

var vectortilefeature = VectorTileFeature;
function VectorTileFeature(pbf, end, extent, keys, values) {
    this.properties = {};
    this.extent = extent;
    this.type = 0;
    this._pbf = pbf;
    this._geometry = -1;
    this._keys = keys;
    this._values = values;
    pbf.readFields(readFeature, this, end);
}
function readFeature(tag, feature, pbf) {
    if (tag == 1) {
        feature.id = pbf.readVarint();
    } else if (tag == 2) {
        readTag(pbf, feature);
    } else if (tag == 3) {
        feature.type = pbf.readVarint();
    } else if (tag == 4) {
        feature._geometry = pbf.pos;
    }
}
function readTag(pbf, feature) {
    var end = pbf.readVarint() + pbf.pos;
    while (pbf.pos < end) {
        var key = feature._keys[pbf.readVarint()], value = feature._values[pbf.readVarint()];
        feature.properties[key] = value;
    }
}
VectorTileFeature.types = [
    'Unknown',
    'Point',
    'LineString',
    'Polygon'
];
VectorTileFeature.prototype.loadGeometry = function () {
    var pbf = this._pbf;
    pbf.pos = this._geometry;
    var end = pbf.readVarint() + pbf.pos, cmd = 1, length = 0, x = 0, y = 0, lines = [], line;
    while (pbf.pos < end) {
        if (length <= 0) {
            var cmdLen = pbf.readVarint();
            cmd = cmdLen & 7;
            length = cmdLen >> 3;
        }
        length--;
        if (cmd === 1 || cmd === 2) {
            x += pbf.readSVarint();
            y += pbf.readSVarint();
            if (cmd === 1) {
                if (line) {
                    lines.push(line);
                }
                line = [];
            }
            line.push(new pointGeometry(x, y));
        } else if (cmd === 7) {
            if (line) {
                line.push(line[0].clone());
            }
        } else {
            throw new Error('unknown command ' + cmd);
        }
    }
    if (line) {
        lines.push(line);
    }
    return lines;
};
VectorTileFeature.prototype.bbox = function () {
    var pbf = this._pbf;
    pbf.pos = this._geometry;
    var end = pbf.readVarint() + pbf.pos, cmd = 1, length = 0, x = 0, y = 0, x1 = Infinity, x2 = -Infinity, y1 = Infinity, y2 = -Infinity;
    while (pbf.pos < end) {
        if (length <= 0) {
            var cmdLen = pbf.readVarint();
            cmd = cmdLen & 7;
            length = cmdLen >> 3;
        }
        length--;
        if (cmd === 1 || cmd === 2) {
            x += pbf.readSVarint();
            y += pbf.readSVarint();
            if (x < x1) {
                x1 = x;
            }
            if (x > x2) {
                x2 = x;
            }
            if (y < y1) {
                y1 = y;
            }
            if (y > y2) {
                y2 = y;
            }
        } else if (cmd !== 7) {
            throw new Error('unknown command ' + cmd);
        }
    }
    return [
        x1,
        y1,
        x2,
        y2
    ];
};
VectorTileFeature.prototype.toGeoJSON = function (x, y, z) {
    var size = this.extent * Math.pow(2, z), x0 = this.extent * x, y0 = this.extent * y, coords = this.loadGeometry(), type = VectorTileFeature.types[this.type], i, j;
    function project(line) {
        for (var j = 0; j < line.length; j++) {
            var p = line[j], y2 = 180 - (p.y + y0) * 360 / size;
            line[j] = [
                (p.x + x0) * 360 / size - 180,
                360 / Math.PI * Math.atan(Math.exp(y2 * Math.PI / 180)) - 90
            ];
        }
    }
    switch (this.type) {
    case 1:
        var points = [];
        for (i = 0; i < coords.length; i++) {
            points[i] = coords[i][0];
        }
        coords = points;
        project(coords);
        break;
    case 2:
        for (i = 0; i < coords.length; i++) {
            project(coords[i]);
        }
        break;
    case 3:
        coords = classifyRings$1(coords);
        for (i = 0; i < coords.length; i++) {
            for (j = 0; j < coords[i].length; j++) {
                project(coords[i][j]);
            }
        }
        break;
    }
    if (coords.length === 1) {
        coords = coords[0];
    } else {
        type = 'Multi' + type;
    }
    var result = {
        type: 'Feature',
        geometry: {
            type: type,
            coordinates: coords
        },
        properties: this.properties
    };
    if ('id' in this) {
        result.id = this.id;
    }
    return result;
};
function classifyRings$1(rings) {
    var len = rings.length;
    if (len <= 1) {
        return [rings];
    }
    var polygons = [], polygon, ccw;
    for (var i = 0; i < len; i++) {
        var area = signedArea$1(rings[i]);
        if (area === 0) {
            continue;
        }
        if (ccw === undefined) {
            ccw = area < 0;
        }
        if (ccw === area < 0) {
            if (polygon) {
                polygons.push(polygon);
            }
            polygon = [rings[i]];
        } else {
            polygon.push(rings[i]);
        }
    }
    if (polygon) {
        polygons.push(polygon);
    }
    return polygons;
}
function signedArea$1(ring) {
    var sum = 0;
    for (var i = 0, len = ring.length, j = len - 1, p1, p2; i < len; j = i++) {
        p1 = ring[i];
        p2 = ring[j];
        sum += (p2.x - p1.x) * (p1.y + p2.y);
    }
    return sum;
}

var vectortilelayer = VectorTileLayer;
function VectorTileLayer(pbf, end) {
    this.version = 1;
    this.name = null;
    this.extent = 4096;
    this.length = 0;
    this._pbf = pbf;
    this._keys = [];
    this._values = [];
    this._features = [];
    pbf.readFields(readLayer, this, end);
    this.length = this._features.length;
}
function readLayer(tag, layer, pbf) {
    if (tag === 15) {
        layer.version = pbf.readVarint();
    } else if (tag === 1) {
        layer.name = pbf.readString();
    } else if (tag === 5) {
        layer.extent = pbf.readVarint();
    } else if (tag === 2) {
        layer._features.push(pbf.pos);
    } else if (tag === 3) {
        layer._keys.push(pbf.readString());
    } else if (tag === 4) {
        layer._values.push(readValueMessage(pbf));
    }
}
function readValueMessage(pbf) {
    var value = null, end = pbf.readVarint() + pbf.pos;
    while (pbf.pos < end) {
        var tag = pbf.readVarint() >> 3;
        value = tag === 1 ? pbf.readString() : tag === 2 ? pbf.readFloat() : tag === 3 ? pbf.readDouble() : tag === 4 ? pbf.readVarint64() : tag === 5 ? pbf.readVarint() : tag === 6 ? pbf.readSVarint() : tag === 7 ? pbf.readBoolean() : null;
    }
    return value;
}
VectorTileLayer.prototype.feature = function (i) {
    if (i < 0 || i >= this._features.length) {
        throw new Error('feature index out of bounds');
    }
    this._pbf.pos = this._features[i];
    var end = this._pbf.readVarint() + this._pbf.pos;
    return new vectortilefeature(this._pbf, end, this.extent, this._keys, this._values);
};

var vectortile = VectorTile;
function VectorTile(pbf, end) {
    this.layers = pbf.readFields(readTile, {}, end);
}
function readTile(tag, layers, pbf) {
    if (tag === 3) {
        var layer = new vectortilelayer(pbf, pbf.readVarint() + pbf.pos);
        if (layer.length) {
            layers[layer.name] = layer;
        }
    }
}

var VectorTile$1 = vectortile;
var VectorTileFeature$1 = vectortilefeature;
var VectorTileLayer$1 = vectortilelayer;

var vectorTile = {
	VectorTile: VectorTile$1,
	VectorTileFeature: VectorTileFeature$1,
	VectorTileLayer: VectorTileLayer$1
};

var vectorTileFeatureTypes = vectorTile.VectorTileFeature.types;
var EARCUT_MAX_RINGS$1 = 500;
var FACTOR = Math.pow(2, 13);
function addVertex(vertexArray, x, y, nx, ny, nz, t, e) {
    vertexArray.emplaceBack(x, y, Math.floor(nx * FACTOR) * 2 + t, ny * FACTOR * 2, nz * FACTOR * 2, Math.round(e));
}
var FillExtrusionBucket = function FillExtrusionBucket(options) {
    this.zoom = options.zoom;
    this.overscaling = options.overscaling;
    this.layers = options.layers;
    this.layerIds = this.layers.map(function (layer) {
        return layer.id;
    });
    this.index = options.index;
    this.hasPattern = false;
    this.layoutVertexArray = new StructArrayLayout2i4i12();
    this.indexArray = new StructArrayLayout3ui6();
    this.programConfigurations = new ProgramConfigurationSet(options.layers, options.zoom);
    this.segments = new SegmentVector();
    this.stateDependentLayerIds = this.layers.filter(function (l) {
        return l.isStateDependent();
    }).map(function (l) {
        return l.id;
    });
};
FillExtrusionBucket.prototype.populate = function populate(features, options, canonical) {
    this.features = [];
    this.hasPattern = hasPattern('fill-extrusion', this.layers, options);
    for (var i = 0, list = features; i < list.length; i += 1) {
        var ref = list[i];
        var feature = ref.feature;
        var id = ref.id;
        var index = ref.index;
        var sourceLayerIndex = ref.sourceLayerIndex;
        var needGeometry = this.layers[0]._featureFilter.needGeometry;
        var evaluationFeature = toEvaluationFeature(feature, needGeometry);
        if (!this.layers[0]._featureFilter.filter(new EvaluationParameters(this.zoom), evaluationFeature, canonical)) {
            continue;
        }
        var bucketFeature = {
            id: id,
            sourceLayerIndex: sourceLayerIndex,
            index: index,
            geometry: needGeometry ? evaluationFeature.geometry : loadGeometry(feature),
            properties: feature.properties,
            type: feature.type,
            patterns: {}
        };
        if (this.hasPattern) {
            this.features.push(addPatternDependencies('fill-extrusion', this.layers, bucketFeature, this.zoom, options));
        } else {
            this.addFeature(bucketFeature, bucketFeature.geometry, index, canonical, {});
        }
        options.featureIndex.insert(feature, bucketFeature.geometry, index, sourceLayerIndex, this.index, true);
    }
};
FillExtrusionBucket.prototype.addFeatures = function addFeatures(options, canonical, imagePositions) {
    for (var i = 0, list = this.features; i < list.length; i += 1) {
        var feature = list[i];
        var geometry = feature.geometry;
        this.addFeature(feature, geometry, feature.index, canonical, imagePositions);
    }
};
FillExtrusionBucket.prototype.update = function update(states, vtLayer, imagePositions) {
    if (!this.stateDependentLayers.length) {
        return;
    }
    this.programConfigurations.updatePaintArrays(states, vtLayer, this.stateDependentLayers, imagePositions);
};
FillExtrusionBucket.prototype.isEmpty = function isEmpty() {
    return this.layoutVertexArray.length === 0;
};
FillExtrusionBucket.prototype.uploadPending = function uploadPending() {
    return !this.uploaded || this.programConfigurations.needsUpload;
};
FillExtrusionBucket.prototype.upload = function upload(context) {
    if (!this.uploaded) {
        this.layoutVertexBuffer = context.createVertexBuffer(this.layoutVertexArray, members$2);
        this.indexBuffer = context.createIndexBuffer(this.indexArray);
    }
    this.programConfigurations.upload(context);
    this.uploaded = true;
};
FillExtrusionBucket.prototype.destroy = function destroy() {
    if (!this.layoutVertexBuffer) {
        return;
    }
    this.layoutVertexBuffer.destroy();
    this.indexBuffer.destroy();
    this.programConfigurations.destroy();
    this.segments.destroy();
};
FillExtrusionBucket.prototype.addFeature = function addFeature(feature, geometry, index, canonical, imagePositions) {
    for (var i$4 = 0, list$3 = classifyRings(geometry, EARCUT_MAX_RINGS$1); i$4 < list$3.length; i$4 += 1) {
        var polygon = list$3[i$4];
        var numVertices = 0;
        for (var i$1 = 0, list = polygon; i$1 < list.length; i$1 += 1) {
            var ring = list[i$1];
            numVertices += ring.length;
        }
        var segment = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray);
        for (var i$2 = 0, list$1 = polygon; i$2 < list$1.length; i$2 += 1) {
            var ring$1 = list$1[i$2];
            if (ring$1.length === 0) {
                continue;
            }
            if (isEntirelyOutside(ring$1)) {
                continue;
            }
            var edgeDistance = 0;
            for (var p = 0; p < ring$1.length; p++) {
                var p1 = ring$1[p];
                if (p >= 1) {
                    var p2 = ring$1[p - 1];
                    if (!isBoundaryEdge(p1, p2)) {
                        if (segment.vertexLength + 4 > SegmentVector.MAX_VERTEX_ARRAY_LENGTH) {
                            segment = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray);
                        }
                        var perp = p1.sub(p2)._perp()._unit();
                        var dist = p2.dist(p1);
                        if (edgeDistance + dist > 32768) {
                            edgeDistance = 0;
                        }
                        addVertex(this.layoutVertexArray, p1.x, p1.y, perp.x, perp.y, 0, 0, edgeDistance);
                        addVertex(this.layoutVertexArray, p1.x, p1.y, perp.x, perp.y, 0, 1, edgeDistance);
                        edgeDistance += dist;
                        addVertex(this.layoutVertexArray, p2.x, p2.y, perp.x, perp.y, 0, 0, edgeDistance);
                        addVertex(this.layoutVertexArray, p2.x, p2.y, perp.x, perp.y, 0, 1, edgeDistance);
                        var bottomRight = segment.vertexLength;
                        this.indexArray.emplaceBack(bottomRight, bottomRight + 2, bottomRight + 1);
                        this.indexArray.emplaceBack(bottomRight + 1, bottomRight + 2, bottomRight + 3);
                        segment.vertexLength += 4;
                        segment.primitiveLength += 2;
                    }
                }
            }
        }
        if (segment.vertexLength + numVertices > SegmentVector.MAX_VERTEX_ARRAY_LENGTH) {
            segment = this.segments.prepareSegment(numVertices, this.layoutVertexArray, this.indexArray);
        }
        if (vectorTileFeatureTypes[feature.type] !== 'Polygon') {
            continue;
        }
        var flattened = [];
        var holeIndices = [];
        var triangleIndex = segment.vertexLength;
        for (var i$3 = 0, list$2 = polygon; i$3 < list$2.length; i$3 += 1) {
            var ring$2 = list$2[i$3];
            if (ring$2.length === 0) {
                continue;
            }
            if (ring$2 !== polygon[0]) {
                holeIndices.push(flattened.length / 2);
            }
            for (var i = 0; i < ring$2.length; i++) {
                var p$1 = ring$2[i];
                addVertex(this.layoutVertexArray, p$1.x, p$1.y, 0, 0, 1, 1, 0);
                flattened.push(p$1.x);
                flattened.push(p$1.y);
            }
        }
        var indices = earcut_1(flattened, holeIndices);
        for (var j = 0; j < indices.length; j += 3) {
            this.indexArray.emplaceBack(triangleIndex + indices[j], triangleIndex + indices[j + 2], triangleIndex + indices[j + 1]);
        }
        segment.primitiveLength += indices.length / 3;
        segment.vertexLength += numVertices;
    }
    this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, feature, index, imagePositions, canonical);
};
register('FillExtrusionBucket', FillExtrusionBucket, {
    omit: [
        'layers',
        'features'
    ]
});
function isBoundaryEdge(p1, p2) {
    return p1.x === p2.x && (p1.x < 0 || p1.x > EXTENT$1) || p1.y === p2.y && (p1.y < 0 || p1.y > EXTENT$1);
}
function isEntirelyOutside(ring) {
    return ring.every(function (p) {
        return p.x < 0;
    }) || ring.every(function (p) {
        return p.x > EXTENT$1;
    }) || ring.every(function (p) {
        return p.y < 0;
    }) || ring.every(function (p) {
        return p.y > EXTENT$1;
    });
}

var paint$5 = new Properties({
    'fill-extrusion-opacity': new DataConstantProperty(spec['paint_fill-extrusion']['fill-extrusion-opacity']),
    'fill-extrusion-color': new DataDrivenProperty(spec['paint_fill-extrusion']['fill-extrusion-color']),
    'fill-extrusion-translate': new DataConstantProperty(spec['paint_fill-extrusion']['fill-extrusion-translate']),
    'fill-extrusion-translate-anchor': new DataConstantProperty(spec['paint_fill-extrusion']['fill-extrusion-translate-anchor']),
    'fill-extrusion-pattern': new CrossFadedDataDrivenProperty(spec['paint_fill-extrusion']['fill-extrusion-pattern']),
    'fill-extrusion-height': new DataDrivenProperty(spec['paint_fill-extrusion']['fill-extrusion-height']),
    'fill-extrusion-base': new DataDrivenProperty(spec['paint_fill-extrusion']['fill-extrusion-base']),
    'fill-extrusion-vertical-gradient': new DataConstantProperty(spec['paint_fill-extrusion']['fill-extrusion-vertical-gradient'])
});
var properties$4 = { paint: paint$5 };

var FillExtrusionStyleLayer = function (StyleLayer) {
    function FillExtrusionStyleLayer(layer) {
        StyleLayer.call(this, layer, properties$4);
    }
    if (StyleLayer)
        FillExtrusionStyleLayer.__proto__ = StyleLayer;
    FillExtrusionStyleLayer.prototype = Object.create(StyleLayer && StyleLayer.prototype);
    FillExtrusionStyleLayer.prototype.constructor = FillExtrusionStyleLayer;
    FillExtrusionStyleLayer.prototype.createBucket = function createBucket(parameters) {
        return new FillExtrusionBucket(parameters);
    };
    FillExtrusionStyleLayer.prototype.queryRadius = function queryRadius() {
        return translateDistance(this.paint.get('fill-extrusion-translate'));
    };
    FillExtrusionStyleLayer.prototype.is3D = function is3D() {
        return true;
    };
    FillExtrusionStyleLayer.prototype.queryIntersectsFeature = function queryIntersectsFeature(queryGeometry, feature, featureState, geometry, zoom, transform, pixelsToTileUnits, pixelPosMatrix) {
        var translatedPolygon = translate(queryGeometry, this.paint.get('fill-extrusion-translate'), this.paint.get('fill-extrusion-translate-anchor'), transform.angle, pixelsToTileUnits);
        var height = this.paint.get('fill-extrusion-height').evaluate(feature, featureState);
        var base = this.paint.get('fill-extrusion-base').evaluate(feature, featureState);
        var projectedQueryGeometry = projectQueryGeometry$1(translatedPolygon, pixelPosMatrix, transform, 0);
        var projected = projectExtrusion(geometry, base, height, pixelPosMatrix);
        var projectedBase = projected[0];
        var projectedTop = projected[1];
        return checkIntersection(projectedBase, projectedTop, projectedQueryGeometry);
    };
    return FillExtrusionStyleLayer;
}(StyleLayer);
function dot$2(a, b) {
    return a.x * b.x + a.y * b.y;
}
function getIntersectionDistance(projectedQueryGeometry, projectedFace) {
    if (projectedQueryGeometry.length === 1) {
        var i = 0;
        var a = projectedFace[i++];
        var b;
        while (!b || a.equals(b)) {
            b = projectedFace[i++];
            if (!b) {
                return Infinity;
            }
        }
        for (; i < projectedFace.length; i++) {
            var c = projectedFace[i];
            var p = projectedQueryGeometry[0];
            var ab = b.sub(a);
            var ac = c.sub(a);
            var ap = p.sub(a);
            var dotABAB = dot$2(ab, ab);
            var dotABAC = dot$2(ab, ac);
            var dotACAC = dot$2(ac, ac);
            var dotAPAB = dot$2(ap, ab);
            var dotAPAC = dot$2(ap, ac);
            var denom = dotABAB * dotACAC - dotABAC * dotABAC;
            var v = (dotACAC * dotAPAB - dotABAC * dotAPAC) / denom;
            var w = (dotABAB * dotAPAC - dotABAC * dotAPAB) / denom;
            var u = 1 - v - w;
            var distance = a.z * u + b.z * v + c.z * w;
            if (isFinite(distance)) {
                return distance;
            }
        }
        return Infinity;
    } else {
        var closestDistance = Infinity;
        for (var i$1 = 0, list = projectedFace; i$1 < list.length; i$1 += 1) {
            var p$1 = list[i$1];
            closestDistance = Math.min(closestDistance, p$1.z);
        }
        return closestDistance;
    }
}
function checkIntersection(projectedBase, projectedTop, projectedQueryGeometry) {
    var closestDistance = Infinity;
    if (polygonIntersectsMultiPolygon(projectedQueryGeometry, projectedTop)) {
        closestDistance = getIntersectionDistance(projectedQueryGeometry, projectedTop[0]);
    }
    for (var r = 0; r < projectedTop.length; r++) {
        var ringTop = projectedTop[r];
        var ringBase = projectedBase[r];
        for (var p = 0; p < ringTop.length - 1; p++) {
            var topA = ringTop[p];
            var topB = ringTop[p + 1];
            var baseA = ringBase[p];
            var baseB = ringBase[p + 1];
            var face = [
                topA,
                topB,
                baseB,
                baseA,
                topA
            ];
            if (polygonIntersectsPolygon(projectedQueryGeometry, face)) {
                closestDistance = Math.min(closestDistance, getIntersectionDistance(projectedQueryGeometry, face));
            }
        }
    }
    return closestDistance === Infinity ? false : closestDistance;
}
function projectExtrusion(geometry, zBase, zTop, m) {
    var projectedBase = [];
    var projectedTop = [];
    var baseXZ = m[8] * zBase;
    var baseYZ = m[9] * zBase;
    var baseZZ = m[10] * zBase;
    var baseWZ = m[11] * zBase;
    var topXZ = m[8] * zTop;
    var topYZ = m[9] * zTop;
    var topZZ = m[10] * zTop;
    var topWZ = m[11] * zTop;
    for (var i$1 = 0, list$1 = geometry; i$1 < list$1.length; i$1 += 1) {
        var r = list$1[i$1];
        var ringBase = [];
        var ringTop = [];
        for (var i = 0, list = r; i < list.length; i += 1) {
            var p = list[i];
            var x = p.x;
            var y = p.y;
            var sX = m[0] * x + m[4] * y + m[12];
            var sY = m[1] * x + m[5] * y + m[13];
            var sZ = m[2] * x + m[6] * y + m[14];
            var sW = m[3] * x + m[7] * y + m[15];
            var baseX = sX + baseXZ;
            var baseY = sY + baseYZ;
            var baseZ = sZ + baseZZ;
            var baseW = sW + baseWZ;
            var topX = sX + topXZ;
            var topY = sY + topYZ;
            var topZ = sZ + topZZ;
            var topW = sW + topWZ;
            var b = new pointGeometry(baseX / baseW, baseY / baseW);
            b.z = baseZ / baseW;
            ringBase.push(b);
            var t = new pointGeometry(topX / topW, topY / topW);
            t.z = topZ / topW;
            ringTop.push(t);
        }
        projectedBase.push(ringBase);
        projectedTop.push(ringTop);
    }
    return [
        projectedBase,
        projectedTop
    ];
}
function projectQueryGeometry$1(queryGeometry, pixelPosMatrix, transform, z) {
    var projectedQueryGeometry = [];
    for (var i = 0, list = queryGeometry; i < list.length; i += 1) {
        var p = list[i];
        var v = [
            p.x,
            p.y,
            z,
            1
        ];
        transformMat4(v, v, pixelPosMatrix);
        projectedQueryGeometry.push(new pointGeometry(v[0] / v[3], v[1] / v[3]));
    }
    return projectedQueryGeometry;
}

var lineLayoutAttributes = createLayout([
    {
        name: 'a_pos_normal',
        components: 2,
        type: 'Int16'
    },
    {
        name: 'a_data',
        components: 4,
        type: 'Uint8'
    }
], 4);
var members$3 = lineLayoutAttributes.members;

var lineLayoutAttributesExt = createLayout([
    {
        name: 'a_uv_x',
        components: 1,
        type: 'Float32'
    },
    {
        name: 'a_split_index',
        components: 1,
        type: 'Float32'
    }
]);
var members$4 = lineLayoutAttributesExt.members;

var vectorTileFeatureTypes$1 = vectorTile.VectorTileFeature.types;
var EXTRUDE_SCALE = 63;
var COS_HALF_SHARP_CORNER = Math.cos(75 / 2 * (Math.PI / 180));
var SHARP_CORNER_OFFSET = 15;
var DEG_PER_TRIANGLE = 20;
var LINE_DISTANCE_BUFFER_BITS = 15;
var LINE_DISTANCE_SCALE = 1 / 2;
var MAX_LINE_DISTANCE = Math.pow(2, LINE_DISTANCE_BUFFER_BITS - 1) / LINE_DISTANCE_SCALE;
var LineBucket = function LineBucket(options) {
    var this$1 = this;
    this.zoom = options.zoom;
    this.overscaling = options.overscaling;
    this.layers = options.layers;
    this.layerIds = this.layers.map(function (layer) {
        return layer.id;
    });
    this.index = options.index;
    this.hasPattern = false;
    this.patternFeatures = [];
    this.lineClipsArray = [];
    this.gradients = {};
    this.layers.forEach(function (layer) {
        this$1.gradients[layer.id] = {};
    });
    this.layoutVertexArray = new StructArrayLayout2i4ub8();
    this.layoutVertexArray2 = new StructArrayLayout2f8();
    this.indexArray = new StructArrayLayout3ui6();
    this.programConfigurations = new ProgramConfigurationSet(options.layers, options.zoom);
    this.segments = new SegmentVector();
    this.maxLineLength = 0;
    this.stateDependentLayerIds = this.layers.filter(function (l) {
        return l.isStateDependent();
    }).map(function (l) {
        return l.id;
    });
};
LineBucket.prototype.populate = function populate(features, options, canonical) {
    this.hasPattern = hasPattern('line', this.layers, options);
    var lineSortKey = this.layers[0].layout.get('line-sort-key');
    var bucketFeatures = [];
    for (var i = 0, list = features; i < list.length; i += 1) {
        var ref = list[i];
        var feature = ref.feature;
        var id = ref.id;
        var index = ref.index;
        var sourceLayerIndex = ref.sourceLayerIndex;
        var needGeometry = this.layers[0]._featureFilter.needGeometry;
        var evaluationFeature = toEvaluationFeature(feature, needGeometry);
        if (!this.layers[0]._featureFilter.filter(new EvaluationParameters(this.zoom), evaluationFeature, canonical)) {
            continue;
        }
        var sortKey = lineSortKey ? lineSortKey.evaluate(evaluationFeature, {}, canonical) : undefined;
        var bucketFeature = {
            id: id,
            properties: feature.properties,
            type: feature.type,
            sourceLayerIndex: sourceLayerIndex,
            index: index,
            geometry: needGeometry ? evaluationFeature.geometry : loadGeometry(feature),
            patterns: {},
            sortKey: sortKey
        };
        bucketFeatures.push(bucketFeature);
    }
    if (lineSortKey) {
        bucketFeatures.sort(function (a, b) {
            return a.sortKey - b.sortKey;
        });
    }
    for (var i$1 = 0, list$1 = bucketFeatures; i$1 < list$1.length; i$1 += 1) {
        var bucketFeature$1 = list$1[i$1];
        var ref$1 = bucketFeature$1;
        var geometry = ref$1.geometry;
        var index$1 = ref$1.index;
        var sourceLayerIndex$1 = ref$1.sourceLayerIndex;
        if (this.hasPattern) {
            var patternBucketFeature = addPatternDependencies('line', this.layers, bucketFeature$1, this.zoom, options);
            this.patternFeatures.push(patternBucketFeature);
        } else {
            this.addFeature(bucketFeature$1, geometry, index$1, canonical, {});
        }
        var feature$1 = features[index$1].feature;
        options.featureIndex.insert(feature$1, geometry, index$1, sourceLayerIndex$1, this.index);
    }
};
LineBucket.prototype.update = function update(states, vtLayer, imagePositions) {
    if (!this.stateDependentLayers.length) {
        return;
    }
    this.programConfigurations.updatePaintArrays(states, vtLayer, this.stateDependentLayers, imagePositions);
};
LineBucket.prototype.addFeatures = function addFeatures(options, canonical, imagePositions) {
    for (var i = 0, list = this.patternFeatures; i < list.length; i += 1) {
        var feature = list[i];
        this.addFeature(feature, feature.geometry, feature.index, canonical, imagePositions);
    }
};
LineBucket.prototype.isEmpty = function isEmpty() {
    return this.layoutVertexArray.length === 0;
};
LineBucket.prototype.uploadPending = function uploadPending() {
    return !this.uploaded || this.programConfigurations.needsUpload;
};
LineBucket.prototype.upload = function upload(context) {
    if (!this.uploaded) {
        if (this.layoutVertexArray2.length !== 0) {
            this.layoutVertexBuffer2 = context.createVertexBuffer(this.layoutVertexArray2, members$4);
        }
        this.layoutVertexBuffer = context.createVertexBuffer(this.layoutVertexArray, members$3);
        this.indexBuffer = context.createIndexBuffer(this.indexArray);
    }
    this.programConfigurations.upload(context);
    this.uploaded = true;
};
LineBucket.prototype.destroy = function destroy() {
    if (!this.layoutVertexBuffer) {
        return;
    }
    this.layoutVertexBuffer.destroy();
    this.indexBuffer.destroy();
    this.programConfigurations.destroy();
    this.segments.destroy();
};
LineBucket.prototype.lineFeatureClips = function lineFeatureClips(feature) {
    if (!!feature.properties && feature.properties.hasOwnProperty('mapbox_clip_start') && feature.properties.hasOwnProperty('mapbox_clip_end')) {
        var start = +feature.properties['mapbox_clip_start'];
        var end = +feature.properties['mapbox_clip_end'];
        return {
            start: start,
            end: end
        };
    }
};
LineBucket.prototype.addFeature = function addFeature(feature, geometry, index, canonical, imagePositions) {
    var layout = this.layers[0].layout;
    var join = layout.get('line-join').evaluate(feature, {});
    var cap = layout.get('line-cap');
    var miterLimit = layout.get('line-miter-limit');
    var roundLimit = layout.get('line-round-limit');
    this.lineClips = this.lineFeatureClips(feature);
    for (var i = 0, list = geometry; i < list.length; i += 1) {
        var line = list[i];
        this.addLine(line, feature, join, cap, miterLimit, roundLimit);
    }
    this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, feature, index, imagePositions, canonical);
};
LineBucket.prototype.addLine = function addLine(vertices, feature, join, cap, miterLimit, roundLimit) {
    this.distance = 0;
    this.scaledDistance = 0;
    this.totalDistance = 0;
    if (this.lineClips) {
        this.lineClipsArray.push(this.lineClips);
        for (var i = 0; i < vertices.length - 1; i++) {
            this.totalDistance += vertices[i].dist(vertices[i + 1]);
        }
        this.updateScaledDistance();
        this.maxLineLength = Math.max(this.maxLineLength, this.totalDistance);
    }
    var isPolygon = vectorTileFeatureTypes$1[feature.type] === 'Polygon';
    var len = vertices.length;
    while (len >= 2 && vertices[len - 1].equals(vertices[len - 2])) {
        len--;
    }
    var first = 0;
    while (first < len - 1 && vertices[first].equals(vertices[first + 1])) {
        first++;
    }
    if (len < (isPolygon ? 3 : 2)) {
        return;
    }
    if (join === 'bevel') {
        miterLimit = 1.05;
    }
    var sharpCornerOffset = this.overscaling <= 16 ? SHARP_CORNER_OFFSET * EXTENT$1 / (512 * this.overscaling) : 0;
    var segment = this.segments.prepareSegment(len * 10, this.layoutVertexArray, this.indexArray);
    var currentVertex;
    var prevVertex = undefined;
    var nextVertex = undefined;
    var prevNormal = undefined;
    var nextNormal = undefined;
    this.e1 = this.e2 = -1;
    if (isPolygon) {
        currentVertex = vertices[len - 2];
        nextNormal = vertices[first].sub(currentVertex)._unit()._perp();
    }
    for (var i$1 = first; i$1 < len; i$1++) {
        nextVertex = i$1 === len - 1 ? isPolygon ? vertices[first + 1] : undefined : vertices[i$1 + 1];
        if (nextVertex && vertices[i$1].equals(nextVertex)) {
            continue;
        }
        if (nextNormal) {
            prevNormal = nextNormal;
        }
        if (currentVertex) {
            prevVertex = currentVertex;
        }
        currentVertex = vertices[i$1];
        nextNormal = nextVertex ? nextVertex.sub(currentVertex)._unit()._perp() : prevNormal;
        prevNormal = prevNormal || nextNormal;
        var joinNormal = prevNormal.add(nextNormal);
        if (joinNormal.x !== 0 || joinNormal.y !== 0) {
            joinNormal._unit();
        }
        var cosAngle = prevNormal.x * nextNormal.x + prevNormal.y * nextNormal.y;
        var cosHalfAngle = joinNormal.x * nextNormal.x + joinNormal.y * nextNormal.y;
        var miterLength = cosHalfAngle !== 0 ? 1 / cosHalfAngle : Infinity;
        var approxAngle = 2 * Math.sqrt(2 - 2 * cosHalfAngle);
        var isSharpCorner = cosHalfAngle < COS_HALF_SHARP_CORNER && prevVertex && nextVertex;
        var lineTurnsLeft = prevNormal.x * nextNormal.y - prevNormal.y * nextNormal.x > 0;
        if (isSharpCorner && i$1 > first) {
            var prevSegmentLength = currentVertex.dist(prevVertex);
            if (prevSegmentLength > 2 * sharpCornerOffset) {
                var newPrevVertex = currentVertex.sub(currentVertex.sub(prevVertex)._mult(sharpCornerOffset / prevSegmentLength)._round());
                this.updateDistance(prevVertex, newPrevVertex);
                this.addCurrentVertex(newPrevVertex, prevNormal, 0, 0, segment);
                prevVertex = newPrevVertex;
            }
        }
        var middleVertex = prevVertex && nextVertex;
        var currentJoin = middleVertex ? join : isPolygon ? 'butt' : cap;
        if (middleVertex && currentJoin === 'round') {
            if (miterLength < roundLimit) {
                currentJoin = 'miter';
            } else if (miterLength <= 2) {
                currentJoin = 'fakeround';
            }
        }
        if (currentJoin === 'miter' && miterLength > miterLimit) {
            currentJoin = 'bevel';
        }
        if (currentJoin === 'bevel') {
            if (miterLength > 2) {
                currentJoin = 'flipbevel';
            }
            if (miterLength < miterLimit) {
                currentJoin = 'miter';
            }
        }
        if (prevVertex) {
            this.updateDistance(prevVertex, currentVertex);
        }
        if (currentJoin === 'miter') {
            joinNormal._mult(miterLength);
            this.addCurrentVertex(currentVertex, joinNormal, 0, 0, segment);
        } else if (currentJoin === 'flipbevel') {
            if (miterLength > 100) {
                joinNormal = nextNormal.mult(-1);
            } else {
                var bevelLength = miterLength * prevNormal.add(nextNormal).mag() / prevNormal.sub(nextNormal).mag();
                joinNormal._perp()._mult(bevelLength * (lineTurnsLeft ? -1 : 1));
            }
            this.addCurrentVertex(currentVertex, joinNormal, 0, 0, segment);
            this.addCurrentVertex(currentVertex, joinNormal.mult(-1), 0, 0, segment);
        } else if (currentJoin === 'bevel' || currentJoin === 'fakeround') {
            var offset = -Math.sqrt(miterLength * miterLength - 1);
            var offsetA = lineTurnsLeft ? offset : 0;
            var offsetB = lineTurnsLeft ? 0 : offset;
            if (prevVertex) {
                this.addCurrentVertex(currentVertex, prevNormal, offsetA, offsetB, segment);
            }
            if (currentJoin === 'fakeround') {
                var n = Math.round(approxAngle * 180 / Math.PI / DEG_PER_TRIANGLE);
                for (var m = 1; m < n; m++) {
                    var t = m / n;
                    if (t !== 0.5) {
                        var t2 = t - 0.5;
                        var A = 1.0904 + cosAngle * (-3.2452 + cosAngle * (3.55645 - cosAngle * 1.43519));
                        var B = 0.848013 + cosAngle * (-1.06021 + cosAngle * 0.215638);
                        t = t + t * t2 * (t - 1) * (A * t2 * t2 + B);
                    }
                    var extrude = nextNormal.sub(prevNormal)._mult(t)._add(prevNormal)._unit()._mult(lineTurnsLeft ? -1 : 1);
                    this.addHalfVertex(currentVertex, extrude.x, extrude.y, false, lineTurnsLeft, 0, segment);
                }
            }
            if (nextVertex) {
                this.addCurrentVertex(currentVertex, nextNormal, -offsetA, -offsetB, segment);
            }
        } else if (currentJoin === 'butt') {
            this.addCurrentVertex(currentVertex, joinNormal, 0, 0, segment);
        } else if (currentJoin === 'square') {
            var offset$1 = prevVertex ? 1 : -1;
            this.addCurrentVertex(currentVertex, joinNormal, offset$1, offset$1, segment);
        } else if (currentJoin === 'round') {
            if (prevVertex) {
                this.addCurrentVertex(currentVertex, prevNormal, 0, 0, segment);
                this.addCurrentVertex(currentVertex, prevNormal, 1, 1, segment, true);
            }
            if (nextVertex) {
                this.addCurrentVertex(currentVertex, nextNormal, -1, -1, segment, true);
                this.addCurrentVertex(currentVertex, nextNormal, 0, 0, segment);
            }
        }
        if (isSharpCorner && i$1 < len - 1) {
            var nextSegmentLength = currentVertex.dist(nextVertex);
            if (nextSegmentLength > 2 * sharpCornerOffset) {
                var newCurrentVertex = currentVertex.add(nextVertex.sub(currentVertex)._mult(sharpCornerOffset / nextSegmentLength)._round());
                this.updateDistance(currentVertex, newCurrentVertex);
                this.addCurrentVertex(newCurrentVertex, nextNormal, 0, 0, segment);
                currentVertex = newCurrentVertex;
            }
        }
    }
};
LineBucket.prototype.addCurrentVertex = function addCurrentVertex(p, normal, endLeft, endRight, segment, round) {
    if (round === void 0)
        round = false;
    var leftX = normal.x + normal.y * endLeft;
    var leftY = normal.y - normal.x * endLeft;
    var rightX = -normal.x + normal.y * endRight;
    var rightY = -normal.y - normal.x * endRight;
    this.addHalfVertex(p, leftX, leftY, round, false, endLeft, segment);
    this.addHalfVertex(p, rightX, rightY, round, true, -endRight, segment);
    if (this.distance > MAX_LINE_DISTANCE / 2 && this.totalDistance === 0) {
        this.distance = 0;
        this.addCurrentVertex(p, normal, endLeft, endRight, segment, round);
    }
};
LineBucket.prototype.addHalfVertex = function addHalfVertex(ref, extrudeX, extrudeY, round, up, dir, segment) {
    var x = ref.x;
    var y = ref.y;
    var totalDistance = this.lineClips ? this.scaledDistance * (MAX_LINE_DISTANCE - 1) : this.scaledDistance;
    var linesofarScaled = totalDistance * LINE_DISTANCE_SCALE;
    this.layoutVertexArray.emplaceBack((x << 1) + (round ? 1 : 0), (y << 1) + (up ? 1 : 0), Math.round(EXTRUDE_SCALE * extrudeX) + 128, Math.round(EXTRUDE_SCALE * extrudeY) + 128, (dir === 0 ? 0 : dir < 0 ? -1 : 1) + 1 | (linesofarScaled & 63) << 2, linesofarScaled >> 6);
    if (this.lineClips) {
        var progressRealigned = this.scaledDistance - this.lineClips.start;
        var endClipRealigned = this.lineClips.end - this.lineClips.start;
        var uvX = progressRealigned / endClipRealigned;
        this.layoutVertexArray2.emplaceBack(uvX, this.lineClipsArray.length);
    }
    var e = segment.vertexLength++;
    if (this.e1 >= 0 && this.e2 >= 0) {
        this.indexArray.emplaceBack(this.e1, this.e2, e);
        segment.primitiveLength++;
    }
    if (up) {
        this.e2 = e;
    } else {
        this.e1 = e;
    }
};
LineBucket.prototype.updateScaledDistance = function updateScaledDistance() {
    this.scaledDistance = this.lineClips ? this.lineClips.start + (this.lineClips.end - this.lineClips.start) * this.distance / this.totalDistance : this.distance;
};
LineBucket.prototype.updateDistance = function updateDistance(prev, next) {
    this.distance += prev.dist(next);
    this.updateScaledDistance();
};
register('LineBucket', LineBucket, {
    omit: [
        'layers',
        'patternFeatures'
    ]
});

var layout$6 = new Properties({
    'line-cap': new DataConstantProperty(spec['layout_line']['line-cap']),
    'line-join': new DataDrivenProperty(spec['layout_line']['line-join']),
    'line-miter-limit': new DataConstantProperty(spec['layout_line']['line-miter-limit']),
    'line-round-limit': new DataConstantProperty(spec['layout_line']['line-round-limit']),
    'line-sort-key': new DataDrivenProperty(spec['layout_line']['line-sort-key'])
});
var paint$6 = new Properties({
    'line-opacity': new DataDrivenProperty(spec['paint_line']['line-opacity']),
    'line-color': new DataDrivenProperty(spec['paint_line']['line-color']),
    'line-translate': new DataConstantProperty(spec['paint_line']['line-translate']),
    'line-translate-anchor': new DataConstantProperty(spec['paint_line']['line-translate-anchor']),
    'line-width': new DataDrivenProperty(spec['paint_line']['line-width']),
    'line-gap-width': new DataDrivenProperty(spec['paint_line']['line-gap-width']),
    'line-offset': new DataDrivenProperty(spec['paint_line']['line-offset']),
    'line-blur': new DataDrivenProperty(spec['paint_line']['line-blur']),
    'line-dasharray': new CrossFadedProperty(spec['paint_line']['line-dasharray']),
    'line-pattern': new CrossFadedDataDrivenProperty(spec['paint_line']['line-pattern']),
    'line-gradient': new ColorRampProperty(spec['paint_line']['line-gradient'])
});
var properties$5 = {
    paint: paint$6,
    layout: layout$6
};

var LineFloorwidthProperty = function (DataDrivenProperty) {
    function LineFloorwidthProperty() {
        DataDrivenProperty.apply(this, arguments);
    }
    if (DataDrivenProperty)
        LineFloorwidthProperty.__proto__ = DataDrivenProperty;
    LineFloorwidthProperty.prototype = Object.create(DataDrivenProperty && DataDrivenProperty.prototype);
    LineFloorwidthProperty.prototype.constructor = LineFloorwidthProperty;
    LineFloorwidthProperty.prototype.possiblyEvaluate = function possiblyEvaluate(value, parameters) {
        parameters = new EvaluationParameters(Math.floor(parameters.zoom), {
            now: parameters.now,
            fadeDuration: parameters.fadeDuration,
            zoomHistory: parameters.zoomHistory,
            transition: parameters.transition
        });
        return DataDrivenProperty.prototype.possiblyEvaluate.call(this, value, parameters);
    };
    LineFloorwidthProperty.prototype.evaluate = function evaluate(value, globals, feature, featureState) {
        globals = extend({}, globals, { zoom: Math.floor(globals.zoom) });
        return DataDrivenProperty.prototype.evaluate.call(this, value, globals, feature, featureState);
    };
    return LineFloorwidthProperty;
}(DataDrivenProperty);
var lineFloorwidthProperty = new LineFloorwidthProperty(properties$5.paint.properties['line-width'].specification);
lineFloorwidthProperty.useIntegerZoom = true;
var LineStyleLayer = function (StyleLayer) {
    function LineStyleLayer(layer) {
        StyleLayer.call(this, layer, properties$5);
        this.gradientVersion = 0;
    }
    if (StyleLayer)
        LineStyleLayer.__proto__ = StyleLayer;
    LineStyleLayer.prototype = Object.create(StyleLayer && StyleLayer.prototype);
    LineStyleLayer.prototype.constructor = LineStyleLayer;
    LineStyleLayer.prototype._handleSpecialPaintPropertyUpdate = function _handleSpecialPaintPropertyUpdate(name) {
        if (name === 'line-gradient') {
            var expression = this._transitionablePaint._values['line-gradient'].value.expression;
            this.stepInterpolant = expression._styleExpression.expression instanceof Step;
            this.gradientVersion = (this.gradientVersion + 1) % MAX_SAFE_INTEGER;
        }
    };
    LineStyleLayer.prototype.gradientExpression = function gradientExpression() {
        return this._transitionablePaint._values['line-gradient'].value.expression;
    };
    LineStyleLayer.prototype.recalculate = function recalculate(parameters, availableImages) {
        StyleLayer.prototype.recalculate.call(this, parameters, availableImages);
        this.paint._values['line-floorwidth'] = lineFloorwidthProperty.possiblyEvaluate(this._transitioningPaint._values['line-width'].value, parameters);
    };
    LineStyleLayer.prototype.createBucket = function createBucket(parameters) {
        return new LineBucket(parameters);
    };
    LineStyleLayer.prototype.queryRadius = function queryRadius(bucket) {
        var lineBucket = bucket;
        var width = getLineWidth(getMaximumPaintValue('line-width', this, lineBucket), getMaximumPaintValue('line-gap-width', this, lineBucket));
        var offset = getMaximumPaintValue('line-offset', this, lineBucket);
        return width / 2 + Math.abs(offset) + translateDistance(this.paint.get('line-translate'));
    };
    LineStyleLayer.prototype.queryIntersectsFeature = function queryIntersectsFeature(queryGeometry, feature, featureState, geometry, zoom, transform, pixelsToTileUnits) {
        var translatedPolygon = translate(queryGeometry, this.paint.get('line-translate'), this.paint.get('line-translate-anchor'), transform.angle, pixelsToTileUnits);
        var halfWidth = pixelsToTileUnits / 2 * getLineWidth(this.paint.get('line-width').evaluate(feature, featureState), this.paint.get('line-gap-width').evaluate(feature, featureState));
        var lineOffset = this.paint.get('line-offset').evaluate(feature, featureState);
        if (lineOffset) {
            geometry = offsetLine(geometry, lineOffset * pixelsToTileUnits);
        }
        return polygonIntersectsBufferedMultiLine(translatedPolygon, geometry, halfWidth);
    };
    LineStyleLayer.prototype.isTileClipped = function isTileClipped() {
        return true;
    };
    return LineStyleLayer;
}(StyleLayer);
function getLineWidth(lineWidth, lineGapWidth) {
    if (lineGapWidth > 0) {
        return lineGapWidth + 2 * lineWidth;
    } else {
        return lineWidth;
    }
}
function offsetLine(rings, offset) {
    var newRings = [];
    var zero = new pointGeometry(0, 0);
    for (var k = 0; k < rings.length; k++) {
        var ring = rings[k];
        var newRing = [];
        for (var i = 0; i < ring.length; i++) {
            var a = ring[i - 1];
            var b = ring[i];
            var c = ring[i + 1];
            var aToB = i === 0 ? zero : b.sub(a)._unit()._perp();
            var bToC = i === ring.length - 1 ? zero : c.sub(b)._unit()._perp();
            var extrude = aToB._add(bToC)._unit();
            var cosHalfAngle = extrude.x * bToC.x + extrude.y * bToC.y;
            extrude._mult(1 / cosHalfAngle);
            newRing.push(extrude._mult(offset)._add(b));
        }
        newRings.push(newRing);
    }
    return newRings;
}

var symbolLayoutAttributes = createLayout([
    {
        name: 'a_pos_offset',
        components: 4,
        type: 'Int16'
    },
    {
        name: 'a_data',
        components: 4,
        type: 'Uint16'
    },
    {
        name: 'a_pixeloffset',
        components: 4,
        type: 'Int16'
    }
], 4);
var dynamicLayoutAttributes = createLayout([{
        name: 'a_projected_pos',
        components: 3,
        type: 'Float32'
    }], 4);
var placementOpacityAttributes = createLayout([{
        name: 'a_fade_opacity',
        components: 1,
        type: 'Uint32'
    }], 4);
var collisionVertexAttributes = createLayout([
    {
        name: 'a_placed',
        components: 2,
        type: 'Uint8'
    },
    {
        name: 'a_shift',
        components: 2,
        type: 'Float32'
    }
]);
var collisionBox = createLayout([
    {
        type: 'Int16',
        name: 'anchorPointX'
    },
    {
        type: 'Int16',
        name: 'anchorPointY'
    },
    {
        type: 'Int16',
        name: 'x1'
    },
    {
        type: 'Int16',
        name: 'y1'
    },
    {
        type: 'Int16',
        name: 'x2'
    },
    {
        type: 'Int16',
        name: 'y2'
    },
    {
        type: 'Uint32',
        name: 'featureIndex'
    },
    {
        type: 'Uint16',
        name: 'sourceLayerIndex'
    },
    {
        type: 'Uint16',
        name: 'bucketIndex'
    }
]);
var collisionBoxLayout = createLayout([
    {
        name: 'a_pos',
        components: 2,
        type: 'Int16'
    },
    {
        name: 'a_anchor_pos',
        components: 2,
        type: 'Int16'
    },
    {
        name: 'a_extrude',
        components: 2,
        type: 'Int16'
    }
], 4);
var collisionCircleLayout = createLayout([
    {
        name: 'a_pos',
        components: 2,
        type: 'Float32'
    },
    {
        name: 'a_radius',
        components: 1,
        type: 'Float32'
    },
    {
        name: 'a_flags',
        components: 2,
        type: 'Int16'
    }
], 4);
var quadTriangle = createLayout([{
        name: 'triangle',
        components: 3,
        type: 'Uint16'
    }]);
var placement = createLayout([
    {
        type: 'Int16',
        name: 'anchorX'
    },
    {
        type: 'Int16',
        name: 'anchorY'
    },
    {
        type: 'Uint16',
        name: 'glyphStartIndex'
    },
    {
        type: 'Uint16',
        name: 'numGlyphs'
    },
    {
        type: 'Uint32',
        name: 'vertexStartIndex'
    },
    {
        type: 'Uint32',
        name: 'lineStartIndex'
    },
    {
        type: 'Uint32',
        name: 'lineLength'
    },
    {
        type: 'Uint16',
        name: 'segment'
    },
    {
        type: 'Uint16',
        name: 'lowerSize'
    },
    {
        type: 'Uint16',
        name: 'upperSize'
    },
    {
        type: 'Float32',
        name: 'lineOffsetX'
    },
    {
        type: 'Float32',
        name: 'lineOffsetY'
    },
    {
        type: 'Uint8',
        name: 'writingMode'
    },
    {
        type: 'Uint8',
        name: 'placedOrientation'
    },
    {
        type: 'Uint8',
        name: 'hidden'
    },
    {
        type: 'Uint32',
        name: 'crossTileID'
    },
    {
        type: 'Int16',
        name: 'associatedIconIndex'
    }
]);
var symbolInstance = createLayout([
    {
        type: 'Int16',
        name: 'anchorX'
    },
    {
        type: 'Int16',
        name: 'anchorY'
    },
    {
        type: 'Int16',
        name: 'rightJustifiedTextSymbolIndex'
    },
    {
        type: 'Int16',
        name: 'centerJustifiedTextSymbolIndex'
    },
    {
        type: 'Int16',
        name: 'leftJustifiedTextSymbolIndex'
    },
    {
        type: 'Int16',
        name: 'verticalPlacedTextSymbolIndex'
    },
    {
        type: 'Int16',
        name: 'placedIconSymbolIndex'
    },
    {
        type: 'Int16',
        name: 'verticalPlacedIconSymbolIndex'
    },
    {
        type: 'Uint16',
        name: 'key'
    },
    {
        type: 'Uint16',
        name: 'textBoxStartIndex'
    },
    {
        type: 'Uint16',
        name: 'textBoxEndIndex'
    },
    {
        type: 'Uint16',
        name: 'verticalTextBoxStartIndex'
    },
    {
        type: 'Uint16',
        name: 'verticalTextBoxEndIndex'
    },
    {
        type: 'Uint16',
        name: 'iconBoxStartIndex'
    },
    {
        type: 'Uint16',
        name: 'iconBoxEndIndex'
    },
    {
        type: 'Uint16',
        name: 'verticalIconBoxStartIndex'
    },
    {
        type: 'Uint16',
        name: 'verticalIconBoxEndIndex'
    },
    {
        type: 'Uint16',
        name: 'featureIndex'
    },
    {
        type: 'Uint16',
        name: 'numHorizontalGlyphVertices'
    },
    {
        type: 'Uint16',
        name: 'numVerticalGlyphVertices'
    },
    {
        type: 'Uint16',
        name: 'numIconVertices'
    },
    {
        type: 'Uint16',
        name: 'numVerticalIconVertices'
    },
    {
        type: 'Uint16',
        name: 'useRuntimeCollisionCircles'
    },
    {
        type: 'Uint32',
        name: 'crossTileID'
    },
    {
        type: 'Float32',
        name: 'textBoxScale'
    },
    {
        type: 'Float32',
        components: 2,
        name: 'textOffset'
    },
    {
        type: 'Float32',
        name: 'collisionCircleDiameter'
    }
]);
var glyphOffset = createLayout([{
        type: 'Float32',
        name: 'offsetX'
    }]);
var lineVertex = createLayout([
    {
        type: 'Int16',
        name: 'x'
    },
    {
        type: 'Int16',
        name: 'y'
    },
    {
        type: 'Int16',
        name: 'tileUnitDistanceFromAnchor'
    }
]);

function transformText(text, layer, feature) {
    var transform = layer.layout.get('text-transform').evaluate(feature, {});
    if (transform === 'uppercase') {
        text = text.toLocaleUpperCase();
    } else if (transform === 'lowercase') {
        text = text.toLocaleLowerCase();
    }
    if (plugin.applyArabicShaping) {
        text = plugin.applyArabicShaping(text);
    }
    return text;
}
function transformText$1 (text, layer, feature) {
    text.sections.forEach(function (section) {
        section.text = transformText(section.text, layer, feature);
    });
    return text;
}

function mergeLines (features) {
    var leftIndex = {};
    var rightIndex = {};
    var mergedFeatures = [];
    var mergedIndex = 0;
    function add(k) {
        mergedFeatures.push(features[k]);
        mergedIndex++;
    }
    function mergeFromRight(leftKey, rightKey, geom) {
        var i = rightIndex[leftKey];
        delete rightIndex[leftKey];
        rightIndex[rightKey] = i;
        mergedFeatures[i].geometry[0].pop();
        mergedFeatures[i].geometry[0] = mergedFeatures[i].geometry[0].concat(geom[0]);
        return i;
    }
    function mergeFromLeft(leftKey, rightKey, geom) {
        var i = leftIndex[rightKey];
        delete leftIndex[rightKey];
        leftIndex[leftKey] = i;
        mergedFeatures[i].geometry[0].shift();
        mergedFeatures[i].geometry[0] = geom[0].concat(mergedFeatures[i].geometry[0]);
        return i;
    }
    function getKey(text, geom, onRight) {
        var point = onRight ? geom[0][geom[0].length - 1] : geom[0][0];
        return text + ':' + point.x + ':' + point.y;
    }
    for (var k = 0; k < features.length; k++) {
        var feature = features[k];
        var geom = feature.geometry;
        var text = feature.text ? feature.text.toString() : null;
        if (!text) {
            add(k);
            continue;
        }
        var leftKey = getKey(text, geom), rightKey = getKey(text, geom, true);
        if (leftKey in rightIndex && rightKey in leftIndex && rightIndex[leftKey] !== leftIndex[rightKey]) {
            var j = mergeFromLeft(leftKey, rightKey, geom);
            var i = mergeFromRight(leftKey, rightKey, mergedFeatures[j].geometry);
            delete leftIndex[leftKey];
            delete rightIndex[rightKey];
            rightIndex[getKey(text, mergedFeatures[i].geometry, true)] = i;
            mergedFeatures[j].geometry = null;
        } else if (leftKey in rightIndex) {
            mergeFromRight(leftKey, rightKey, geom);
        } else if (rightKey in leftIndex) {
            mergeFromLeft(leftKey, rightKey, geom);
        } else {
            add(k);
            leftIndex[leftKey] = mergedIndex - 1;
            rightIndex[rightKey] = mergedIndex - 1;
        }
    }
    return mergedFeatures.filter(function (f) {
        return f.geometry;
    });
}

var verticalizedCharacterMap = {
    '!': '\uFE15',
    '#': '\uFF03',
    '$': '\uFF04',
    '%': '\uFF05',
    '&': '\uFF06',
    '(': '\uFE35',
    ')': '\uFE36',
    '*': '\uFF0A',
    '+': '\uFF0B',
    ',': '\uFE10',
    '-': '\uFE32',
    '.': '\u30FB',
    '/': '\uFF0F',
    ':': '\uFE13',
    ';': '\uFE14',
    '<': '\uFE3F',
    '=': '\uFF1D',
    '>': '\uFE40',
    '?': '\uFE16',
    '@': '\uFF20',
    '[': '\uFE47',
    '\\': '\uFF3C',
    ']': '\uFE48',
    '^': '\uFF3E',
    '_': '︳',
    '`': '\uFF40',
    '{': '\uFE37',
    '|': '\u2015',
    '}': '\uFE38',
    '~': '\uFF5E',
    '\xA2': '\uFFE0',
    '\xA3': '\uFFE1',
    '\xA5': '\uFFE5',
    '\xA6': '\uFFE4',
    '\xAC': '\uFFE2',
    '\xAF': '\uFFE3',
    '\u2013': '\uFE32',
    '\u2014': '\uFE31',
    '\u2018': '\uFE43',
    '\u2019': '\uFE44',
    '\u201C': '\uFE41',
    '\u201D': '\uFE42',
    '\u2026': '\uFE19',
    '\u2027': '\u30FB',
    '\u20A9': '\uFFE6',
    '\u3001': '\uFE11',
    '\u3002': '\uFE12',
    '\u3008': '\uFE3F',
    '\u3009': '\uFE40',
    '\u300A': '\uFE3D',
    '\u300B': '\uFE3E',
    '\u300C': '\uFE41',
    '\u300D': '\uFE42',
    '\u300E': '\uFE43',
    '\u300F': '\uFE44',
    '\u3010': '\uFE3B',
    '\u3011': '\uFE3C',
    '\u3014': '\uFE39',
    '\u3015': '\uFE3A',
    '\u3016': '\uFE17',
    '\u3017': '\uFE18',
    '\uFF01': '\uFE15',
    '\uFF08': '\uFE35',
    '\uFF09': '\uFE36',
    '\uFF0C': '\uFE10',
    '\uFF0D': '\uFE32',
    '\uFF0E': '\u30FB',
    '\uFF1A': '\uFE13',
    '\uFF1B': '\uFE14',
    '\uFF1C': '\uFE3F',
    '\uFF1E': '\uFE40',
    '\uFF1F': '\uFE16',
    '\uFF3B': '\uFE47',
    '\uFF3D': '\uFE48',
    '＿': '︳',
    '\uFF5B': '\uFE37',
    '\uFF5C': '\u2015',
    '\uFF5D': '\uFE38',
    '\uFF5F': '\uFE35',
    '\uFF60': '\uFE36',
    '\uFF61': '\uFE12',
    '\uFF62': '\uFE41',
    '\uFF63': '\uFE42'
};
function verticalizePunctuation(input) {
    var output = '';
    for (var i = 0; i < input.length; i++) {
        var nextCharCode = input.charCodeAt(i + 1) || null;
        var prevCharCode = input.charCodeAt(i - 1) || null;
        var canReplacePunctuation = (!nextCharCode || !charHasRotatedVerticalOrientation(nextCharCode) || verticalizedCharacterMap[input[i + 1]]) && (!prevCharCode || !charHasRotatedVerticalOrientation(prevCharCode) || verticalizedCharacterMap[input[i - 1]]);
        if (canReplacePunctuation && verticalizedCharacterMap[input[i]]) {
            output += verticalizedCharacterMap[input[i]];
        } else {
            output += input[i];
        }
    }
    return output;
}

var ONE_EM = 24;

var read = function (buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {
    }
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {
    }
    if (e === 0) {
        e = 1 - eBias;
    } else if (e === eMax) {
        return m ? NaN : (s ? -1 : 1) * Infinity;
    } else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
var write = function (buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) {
            value += rt / c;
        } else {
            value += rt * Math.pow(2, 1 - eBias);
        }
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for (; mLen >= 8; buffer[offset + i] = m & 255, i += d, m /= 256, mLen -= 8) {
    }
    e = e << mLen | m;
    eLen += mLen;
    for (; eLen > 0; buffer[offset + i] = e & 255, i += d, e /= 256, eLen -= 8) {
    }
    buffer[offset + i - d] |= s * 128;
};

var ieee754 = {
	read: read,
	write: write
};

var pbf = Pbf;

function Pbf(buf) {
    this.buf = ArrayBuffer.isView && ArrayBuffer.isView(buf) ? buf : new Uint8Array(buf || 0);
    this.pos = 0;
    this.type = 0;
    this.length = this.buf.length;
}
Pbf.Varint = 0;
Pbf.Fixed64 = 1;
Pbf.Bytes = 2;
Pbf.Fixed32 = 5;
var SHIFT_LEFT_32 = (1 << 16) * (1 << 16), SHIFT_RIGHT_32 = 1 / SHIFT_LEFT_32;
var TEXT_DECODER_MIN_LENGTH = 12;
var utf8TextDecoder = typeof TextDecoder === 'undefined' ? null : new TextDecoder('utf8');
Pbf.prototype = {
    destroy: function () {
        this.buf = null;
    },
    readFields: function (readField, result, end) {
        end = end || this.length;
        while (this.pos < end) {
            var val = this.readVarint(), tag = val >> 3, startPos = this.pos;
            this.type = val & 7;
            readField(tag, result, this);
            if (this.pos === startPos) {
                this.skip(val);
            }
        }
        return result;
    },
    readMessage: function (readField, result) {
        return this.readFields(readField, result, this.readVarint() + this.pos);
    },
    readFixed32: function () {
        var val = readUInt32(this.buf, this.pos);
        this.pos += 4;
        return val;
    },
    readSFixed32: function () {
        var val = readInt32(this.buf, this.pos);
        this.pos += 4;
        return val;
    },
    readFixed64: function () {
        var val = readUInt32(this.buf, this.pos) + readUInt32(this.buf, this.pos + 4) * SHIFT_LEFT_32;
        this.pos += 8;
        return val;
    },
    readSFixed64: function () {
        var val = readUInt32(this.buf, this.pos) + readInt32(this.buf, this.pos + 4) * SHIFT_LEFT_32;
        this.pos += 8;
        return val;
    },
    readFloat: function () {
        var val = ieee754.read(this.buf, this.pos, true, 23, 4);
        this.pos += 4;
        return val;
    },
    readDouble: function () {
        var val = ieee754.read(this.buf, this.pos, true, 52, 8);
        this.pos += 8;
        return val;
    },
    readVarint: function (isSigned) {
        var buf = this.buf, val, b;
        b = buf[this.pos++];
        val = b & 127;
        if (b < 128) {
            return val;
        }
        b = buf[this.pos++];
        val |= (b & 127) << 7;
        if (b < 128) {
            return val;
        }
        b = buf[this.pos++];
        val |= (b & 127) << 14;
        if (b < 128) {
            return val;
        }
        b = buf[this.pos++];
        val |= (b & 127) << 21;
        if (b < 128) {
            return val;
        }
        b = buf[this.pos];
        val |= (b & 15) << 28;
        return readVarintRemainder(val, isSigned, this);
    },
    readVarint64: function () {
        return this.readVarint(true);
    },
    readSVarint: function () {
        var num = this.readVarint();
        return num % 2 === 1 ? (num + 1) / -2 : num / 2;
    },
    readBoolean: function () {
        return Boolean(this.readVarint());
    },
    readString: function () {
        var end = this.readVarint() + this.pos;
        var pos = this.pos;
        this.pos = end;
        if (end - pos >= TEXT_DECODER_MIN_LENGTH && utf8TextDecoder) {
            return readUtf8TextDecoder(this.buf, pos, end);
        }
        return readUtf8(this.buf, pos, end);
    },
    readBytes: function () {
        var end = this.readVarint() + this.pos, buffer = this.buf.subarray(this.pos, end);
        this.pos = end;
        return buffer;
    },
    readPackedVarint: function (arr, isSigned) {
        if (this.type !== Pbf.Bytes) {
            return arr.push(this.readVarint(isSigned));
        }
        var end = readPackedEnd(this);
        arr = arr || [];
        while (this.pos < end) {
            arr.push(this.readVarint(isSigned));
        }
        return arr;
    },
    readPackedSVarint: function (arr) {
        if (this.type !== Pbf.Bytes) {
            return arr.push(this.readSVarint());
        }
        var end = readPackedEnd(this);
        arr = arr || [];
        while (this.pos < end) {
            arr.push(this.readSVarint());
        }
        return arr;
    },
    readPackedBoolean: function (arr) {
        if (this.type !== Pbf.Bytes) {
            return arr.push(this.readBoolean());
        }
        var end = readPackedEnd(this);
        arr = arr || [];
        while (this.pos < end) {
            arr.push(this.readBoolean());
        }
        return arr;
    },
    readPackedFloat: function (arr) {
        if (this.type !== Pbf.Bytes) {
            return arr.push(this.readFloat());
        }
        var end = readPackedEnd(this);
        arr = arr || [];
        while (this.pos < end) {
            arr.push(this.readFloat());
        }
        return arr;
    },
    readPackedDouble: function (arr) {
        if (this.type !== Pbf.Bytes) {
            return arr.push(this.readDouble());
        }
        var end = readPackedEnd(this);
        arr = arr || [];
        while (this.pos < end) {
            arr.push(this.readDouble());
        }
        return arr;
    },
    readPackedFixed32: function (arr) {
        if (this.type !== Pbf.Bytes) {
            return arr.push(this.readFixed32());
        }
        var end = readPackedEnd(this);
        arr = arr || [];
        while (this.pos < end) {
            arr.push(this.readFixed32());
        }
        return arr;
    },
    readPackedSFixed32: function (arr) {
        if (this.type !== Pbf.Bytes) {
            return arr.push(this.readSFixed32());
        }
        var end = readPackedEnd(this);
        arr = arr || [];
        while (this.pos < end) {
            arr.push(this.readSFixed32());
        }
        return arr;
    },
    readPackedFixed64: function (arr) {
        if (this.type !== Pbf.Bytes) {
            return arr.push(this.readFixed64());
        }
        var end = readPackedEnd(this);
        arr = arr || [];
        while (this.pos < end) {
            arr.push(this.readFixed64());
        }
        return arr;
    },
    readPackedSFixed64: function (arr) {
        if (this.type !== Pbf.Bytes) {
            return arr.push(this.readSFixed64());
        }
        var end = readPackedEnd(this);
        arr = arr || [];
        while (this.pos < end) {
            arr.push(this.readSFixed64());
        }
        return arr;
    },
    skip: function (val) {
        var type = val & 7;
        if (type === Pbf.Varint) {
            while (this.buf[this.pos++] > 127) {
            }
        } else if (type === Pbf.Bytes) {
            this.pos = this.readVarint() + this.pos;
        } else if (type === Pbf.Fixed32) {
            this.pos += 4;
        } else if (type === Pbf.Fixed64) {
            this.pos += 8;
        } else {
            throw new Error('Unimplemented type: ' + type);
        }
    },
    writeTag: function (tag, type) {
        this.writeVarint(tag << 3 | type);
    },
    realloc: function (min) {
        var length = this.length || 16;
        while (length < this.pos + min) {
            length *= 2;
        }
        if (length !== this.length) {
            var buf = new Uint8Array(length);
            buf.set(this.buf);
            this.buf = buf;
            this.length = length;
        }
    },
    finish: function () {
        this.length = this.pos;
        this.pos = 0;
        return this.buf.subarray(0, this.length);
    },
    writeFixed32: function (val) {
        this.realloc(4);
        writeInt32(this.buf, val, this.pos);
        this.pos += 4;
    },
    writeSFixed32: function (val) {
        this.realloc(4);
        writeInt32(this.buf, val, this.pos);
        this.pos += 4;
    },
    writeFixed64: function (val) {
        this.realloc(8);
        writeInt32(this.buf, val & -1, this.pos);
        writeInt32(this.buf, Math.floor(val * SHIFT_RIGHT_32), this.pos + 4);
        this.pos += 8;
    },
    writeSFixed64: function (val) {
        this.realloc(8);
        writeInt32(this.buf, val & -1, this.pos);
        writeInt32(this.buf, Math.floor(val * SHIFT_RIGHT_32), this.pos + 4);
        this.pos += 8;
    },
    writeVarint: function (val) {
        val = +val || 0;
        if (val > 268435455 || val < 0) {
            writeBigVarint(val, this);
            return;
        }
        this.realloc(4);
        this.buf[this.pos++] = val & 127 | (val > 127 ? 128 : 0);
        if (val <= 127) {
            return;
        }
        this.buf[this.pos++] = (val >>>= 7) & 127 | (val > 127 ? 128 : 0);
        if (val <= 127) {
            return;
        }
        this.buf[this.pos++] = (val >>>= 7) & 127 | (val > 127 ? 128 : 0);
        if (val <= 127) {
            return;
        }
        this.buf[this.pos++] = val >>> 7 & 127;
    },
    writeSVarint: function (val) {
        this.writeVarint(val < 0 ? -val * 2 - 1 : val * 2);
    },
    writeBoolean: function (val) {
        this.writeVarint(Boolean(val));
    },
    writeString: function (str) {
        str = String(str);
        this.realloc(str.length * 4);
        this.pos++;
        var startPos = this.pos;
        this.pos = writeUtf8(this.buf, str, this.pos);
        var len = this.pos - startPos;
        if (len >= 128) {
            makeRoomForExtraLength(startPos, len, this);
        }
        this.pos = startPos - 1;
        this.writeVarint(len);
        this.pos += len;
    },
    writeFloat: function (val) {
        this.realloc(4);
        ieee754.write(this.buf, val, this.pos, true, 23, 4);
        this.pos += 4;
    },
    writeDouble: function (val) {
        this.realloc(8);
        ieee754.write(this.buf, val, this.pos, true, 52, 8);
        this.pos += 8;
    },
    writeBytes: function (buffer) {
        var len = buffer.length;
        this.writeVarint(len);
        this.realloc(len);
        for (var i = 0; i < len; i++) {
            this.buf[this.pos++] = buffer[i];
        }
    },
    writeRawMessage: function (fn, obj) {
        this.pos++;
        var startPos = this.pos;
        fn(obj, this);
        var len = this.pos - startPos;
        if (len >= 128) {
            makeRoomForExtraLength(startPos, len, this);
        }
        this.pos = startPos - 1;
        this.writeVarint(len);
        this.pos += len;
    },
    writeMessage: function (tag, fn, obj) {
        this.writeTag(tag, Pbf.Bytes);
        this.writeRawMessage(fn, obj);
    },
    writePackedVarint: function (tag, arr) {
        if (arr.length) {
            this.writeMessage(tag, writePackedVarint, arr);
        }
    },
    writePackedSVarint: function (tag, arr) {
        if (arr.length) {
            this.writeMessage(tag, writePackedSVarint, arr);
        }
    },
    writePackedBoolean: function (tag, arr) {
        if (arr.length) {
            this.writeMessage(tag, writePackedBoolean, arr);
        }
    },
    writePackedFloat: function (tag, arr) {
        if (arr.length) {
            this.writeMessage(tag, writePackedFloat, arr);
        }
    },
    writePackedDouble: function (tag, arr) {
        if (arr.length) {
            this.writeMessage(tag, writePackedDouble, arr);
        }
    },
    writePackedFixed32: function (tag, arr) {
        if (arr.length) {
            this.writeMessage(tag, writePackedFixed32, arr);
        }
    },
    writePackedSFixed32: function (tag, arr) {
        if (arr.length) {
            this.writeMessage(tag, writePackedSFixed32, arr);
        }
    },
    writePackedFixed64: function (tag, arr) {
        if (arr.length) {
            this.writeMessage(tag, writePackedFixed64, arr);
        }
    },
    writePackedSFixed64: function (tag, arr) {
        if (arr.length) {
            this.writeMessage(tag, writePackedSFixed64, arr);
        }
    },
    writeBytesField: function (tag, buffer) {
        this.writeTag(tag, Pbf.Bytes);
        this.writeBytes(buffer);
    },
    writeFixed32Field: function (tag, val) {
        this.writeTag(tag, Pbf.Fixed32);
        this.writeFixed32(val);
    },
    writeSFixed32Field: function (tag, val) {
        this.writeTag(tag, Pbf.Fixed32);
        this.writeSFixed32(val);
    },
    writeFixed64Field: function (tag, val) {
        this.writeTag(tag, Pbf.Fixed64);
        this.writeFixed64(val);
    },
    writeSFixed64Field: function (tag, val) {
        this.writeTag(tag, Pbf.Fixed64);
        this.writeSFixed64(val);
    },
    writeVarintField: function (tag, val) {
        this.writeTag(tag, Pbf.Varint);
        this.writeVarint(val);
    },
    writeSVarintField: function (tag, val) {
        this.writeTag(tag, Pbf.Varint);
        this.writeSVarint(val);
    },
    writeStringField: function (tag, str) {
        this.writeTag(tag, Pbf.Bytes);
        this.writeString(str);
    },
    writeFloatField: function (tag, val) {
        this.writeTag(tag, Pbf.Fixed32);
        this.writeFloat(val);
    },
    writeDoubleField: function (tag, val) {
        this.writeTag(tag, Pbf.Fixed64);
        this.writeDouble(val);
    },
    writeBooleanField: function (tag, val) {
        this.writeVarintField(tag, Boolean(val));
    }
};
function readVarintRemainder(l, s, p) {
    var buf = p.buf, h, b;
    b = buf[p.pos++];
    h = (b & 112) >> 4;
    if (b < 128) {
        return toNum(l, h, s);
    }
    b = buf[p.pos++];
    h |= (b & 127) << 3;
    if (b < 128) {
        return toNum(l, h, s);
    }
    b = buf[p.pos++];
    h |= (b & 127) << 10;
    if (b < 128) {
        return toNum(l, h, s);
    }
    b = buf[p.pos++];
    h |= (b & 127) << 17;
    if (b < 128) {
        return toNum(l, h, s);
    }
    b = buf[p.pos++];
    h |= (b & 127) << 24;
    if (b < 128) {
        return toNum(l, h, s);
    }
    b = buf[p.pos++];
    h |= (b & 1) << 31;
    if (b < 128) {
        return toNum(l, h, s);
    }
    throw new Error('Expected varint not more than 10 bytes');
}
function readPackedEnd(pbf) {
    return pbf.type === Pbf.Bytes ? pbf.readVarint() + pbf.pos : pbf.pos + 1;
}
function toNum(low, high, isSigned) {
    if (isSigned) {
        return high * 4294967296 + (low >>> 0);
    }
    return (high >>> 0) * 4294967296 + (low >>> 0);
}
function writeBigVarint(val, pbf) {
    var low, high;
    if (val >= 0) {
        low = val % 4294967296 | 0;
        high = val / 4294967296 | 0;
    } else {
        low = ~(-val % 4294967296);
        high = ~(-val / 4294967296);
        if (low ^ 4294967295) {
            low = low + 1 | 0;
        } else {
            low = 0;
            high = high + 1 | 0;
        }
    }
    if (val >= 18446744073709552000 || val < -18446744073709552000) {
        throw new Error('Given varint doesn\'t fit into 10 bytes');
    }
    pbf.realloc(10);
    writeBigVarintLow(low, high, pbf);
    writeBigVarintHigh(high, pbf);
}
function writeBigVarintLow(low, high, pbf) {
    pbf.buf[pbf.pos++] = low & 127 | 128;
    low >>>= 7;
    pbf.buf[pbf.pos++] = low & 127 | 128;
    low >>>= 7;
    pbf.buf[pbf.pos++] = low & 127 | 128;
    low >>>= 7;
    pbf.buf[pbf.pos++] = low & 127 | 128;
    low >>>= 7;
    pbf.buf[pbf.pos] = low & 127;
}
function writeBigVarintHigh(high, pbf) {
    var lsb = (high & 7) << 4;
    pbf.buf[pbf.pos++] |= lsb | ((high >>>= 3) ? 128 : 0);
    if (!high) {
        return;
    }
    pbf.buf[pbf.pos++] = high & 127 | ((high >>>= 7) ? 128 : 0);
    if (!high) {
        return;
    }
    pbf.buf[pbf.pos++] = high & 127 | ((high >>>= 7) ? 128 : 0);
    if (!high) {
        return;
    }
    pbf.buf[pbf.pos++] = high & 127 | ((high >>>= 7) ? 128 : 0);
    if (!high) {
        return;
    }
    pbf.buf[pbf.pos++] = high & 127 | ((high >>>= 7) ? 128 : 0);
    if (!high) {
        return;
    }
    pbf.buf[pbf.pos++] = high & 127;
}
function makeRoomForExtraLength(startPos, len, pbf) {
    var extraLen = len <= 16383 ? 1 : len <= 2097151 ? 2 : len <= 268435455 ? 3 : Math.floor(Math.log(len) / (Math.LN2 * 7));
    pbf.realloc(extraLen);
    for (var i = pbf.pos - 1; i >= startPos; i--) {
        pbf.buf[i + extraLen] = pbf.buf[i];
    }
}
function writePackedVarint(arr, pbf) {
    for (var i = 0; i < arr.length; i++) {
        pbf.writeVarint(arr[i]);
    }
}
function writePackedSVarint(arr, pbf) {
    for (var i = 0; i < arr.length; i++) {
        pbf.writeSVarint(arr[i]);
    }
}
function writePackedFloat(arr, pbf) {
    for (var i = 0; i < arr.length; i++) {
        pbf.writeFloat(arr[i]);
    }
}
function writePackedDouble(arr, pbf) {
    for (var i = 0; i < arr.length; i++) {
        pbf.writeDouble(arr[i]);
    }
}
function writePackedBoolean(arr, pbf) {
    for (var i = 0; i < arr.length; i++) {
        pbf.writeBoolean(arr[i]);
    }
}
function writePackedFixed32(arr, pbf) {
    for (var i = 0; i < arr.length; i++) {
        pbf.writeFixed32(arr[i]);
    }
}
function writePackedSFixed32(arr, pbf) {
    for (var i = 0; i < arr.length; i++) {
        pbf.writeSFixed32(arr[i]);
    }
}
function writePackedFixed64(arr, pbf) {
    for (var i = 0; i < arr.length; i++) {
        pbf.writeFixed64(arr[i]);
    }
}
function writePackedSFixed64(arr, pbf) {
    for (var i = 0; i < arr.length; i++) {
        pbf.writeSFixed64(arr[i]);
    }
}
function readUInt32(buf, pos) {
    return (buf[pos] | buf[pos + 1] << 8 | buf[pos + 2] << 16) + buf[pos + 3] * 16777216;
}
function writeInt32(buf, val, pos) {
    buf[pos] = val;
    buf[pos + 1] = val >>> 8;
    buf[pos + 2] = val >>> 16;
    buf[pos + 3] = val >>> 24;
}
function readInt32(buf, pos) {
    return (buf[pos] | buf[pos + 1] << 8 | buf[pos + 2] << 16) + (buf[pos + 3] << 24);
}
function readUtf8(buf, pos, end) {
    var str = '';
    var i = pos;
    while (i < end) {
        var b0 = buf[i];
        var c = null;
        var bytesPerSequence = b0 > 239 ? 4 : b0 > 223 ? 3 : b0 > 191 ? 2 : 1;
        if (i + bytesPerSequence > end) {
            break;
        }
        var b1, b2, b3;
        if (bytesPerSequence === 1) {
            if (b0 < 128) {
                c = b0;
            }
        } else if (bytesPerSequence === 2) {
            b1 = buf[i + 1];
            if ((b1 & 192) === 128) {
                c = (b0 & 31) << 6 | b1 & 63;
                if (c <= 127) {
                    c = null;
                }
            }
        } else if (bytesPerSequence === 3) {
            b1 = buf[i + 1];
            b2 = buf[i + 2];
            if ((b1 & 192) === 128 && (b2 & 192) === 128) {
                c = (b0 & 15) << 12 | (b1 & 63) << 6 | b2 & 63;
                if (c <= 2047 || c >= 55296 && c <= 57343) {
                    c = null;
                }
            }
        } else if (bytesPerSequence === 4) {
            b1 = buf[i + 1];
            b2 = buf[i + 2];
            b3 = buf[i + 3];
            if ((b1 & 192) === 128 && (b2 & 192) === 128 && (b3 & 192) === 128) {
                c = (b0 & 15) << 18 | (b1 & 63) << 12 | (b2 & 63) << 6 | b3 & 63;
                if (c <= 65535 || c >= 1114112) {
                    c = null;
                }
            }
        }
        if (c === null) {
            c = 65533;
            bytesPerSequence = 1;
        } else if (c > 65535) {
            c -= 65536;
            str += String.fromCharCode(c >>> 10 & 1023 | 55296);
            c = 56320 | c & 1023;
        }
        str += String.fromCharCode(c);
        i += bytesPerSequence;
    }
    return str;
}
function readUtf8TextDecoder(buf, pos, end) {
    return utf8TextDecoder.decode(buf.subarray(pos, end));
}
function writeUtf8(buf, str, pos) {
    for (var i = 0, c, lead; i < str.length; i++) {
        c = str.charCodeAt(i);
        if (c > 55295 && c < 57344) {
            if (lead) {
                if (c < 56320) {
                    buf[pos++] = 239;
                    buf[pos++] = 191;
                    buf[pos++] = 189;
                    lead = c;
                    continue;
                } else {
                    c = lead - 55296 << 10 | c - 56320 | 65536;
                    lead = null;
                }
            } else {
                if (c > 56319 || i + 1 === str.length) {
                    buf[pos++] = 239;
                    buf[pos++] = 191;
                    buf[pos++] = 189;
                } else {
                    lead = c;
                }
                continue;
            }
        } else if (lead) {
            buf[pos++] = 239;
            buf[pos++] = 191;
            buf[pos++] = 189;
            lead = null;
        }
        if (c < 128) {
            buf[pos++] = c;
        } else {
            if (c < 2048) {
                buf[pos++] = c >> 6 | 192;
            } else {
                if (c < 65536) {
                    buf[pos++] = c >> 12 | 224;
                } else {
                    buf[pos++] = c >> 18 | 240;
                    buf[pos++] = c >> 12 & 63 | 128;
                }
                buf[pos++] = c >> 6 & 63 | 128;
            }
            buf[pos++] = c & 63 | 128;
        }
    }
    return pos;
}

var border = 3;
function readFontstacks(tag, glyphs, pbf) {
    if (tag === 1) {
        pbf.readMessage(readFontstack, glyphs);
    }
}
function readFontstack(tag, glyphs, pbf) {
    if (tag === 3) {
        var ref = pbf.readMessage(readGlyph, {});
        var id = ref.id;
        var bitmap = ref.bitmap;
        var width = ref.width;
        var height = ref.height;
        var left = ref.left;
        var top = ref.top;
        var advance = ref.advance;
        glyphs.push({
            id: id,
            bitmap: new AlphaImage({
                width: width + 2 * border,
                height: height + 2 * border
            }, bitmap),
            metrics: {
                width: width,
                height: height,
                left: left,
                top: top,
                advance: advance
            }
        });
    }
}
function readGlyph(tag, glyph, pbf) {
    if (tag === 1) {
        glyph.id = pbf.readVarint();
    } else if (tag === 2) {
        glyph.bitmap = pbf.readBytes();
    } else if (tag === 3) {
        glyph.width = pbf.readVarint();
    } else if (tag === 4) {
        glyph.height = pbf.readVarint();
    } else if (tag === 5) {
        glyph.left = pbf.readSVarint();
    } else if (tag === 6) {
        glyph.top = pbf.readSVarint();
    } else if (tag === 7) {
        glyph.advance = pbf.readVarint();
    }
}
function parseGlyphPBF (data) {
    return new pbf(data).readFields(readFontstacks, []);
}
var GLYPH_PBF_BORDER = border;

function potpack(boxes) {

    // calculate total box area and maximum box width
    var area = 0;
    var maxWidth = 0;

    for (var i$1 = 0, list = boxes; i$1 < list.length; i$1 += 1) {
        var box = list[i$1];

        area += box.w * box.h;
        maxWidth = Math.max(maxWidth, box.w);
    }

    // sort the boxes for insertion by height, descending
    boxes.sort(function (a, b) { return b.h - a.h; });

    // aim for a squarish resulting container,
    // slightly adjusted for sub-100% space utilization
    var startWidth = Math.max(Math.ceil(Math.sqrt(area / 0.95)), maxWidth);

    // start with a single empty space, unbounded at the bottom
    var spaces = [{x: 0, y: 0, w: startWidth, h: Infinity}];

    var width = 0;
    var height = 0;

    for (var i$2 = 0, list$1 = boxes; i$2 < list$1.length; i$2 += 1) {
        // look through spaces backwards so that we check smaller spaces first
        var box$1 = list$1[i$2];

        for (var i = spaces.length - 1; i >= 0; i--) {
            var space = spaces[i];

            // look for empty spaces that can accommodate the current box
            if (box$1.w > space.w || box$1.h > space.h) { continue; }

            // found the space; add the box to its top-left corner
            // |-------|-------|
            // |  box  |       |
            // |_______|       |
            // |         space |
            // |_______________|
            box$1.x = space.x;
            box$1.y = space.y;

            height = Math.max(height, box$1.y + box$1.h);
            width = Math.max(width, box$1.x + box$1.w);

            if (box$1.w === space.w && box$1.h === space.h) {
                // space matches the box exactly; remove it
                var last = spaces.pop();
                if (i < spaces.length) { spaces[i] = last; }

            } else if (box$1.h === space.h) {
                // space matches the box height; update it accordingly
                // |-------|---------------|
                // |  box  | updated space |
                // |_______|_______________|
                space.x += box$1.w;
                space.w -= box$1.w;

            } else if (box$1.w === space.w) {
                // space matches the box width; update it accordingly
                // |---------------|
                // |      box      |
                // |_______________|
                // | updated space |
                // |_______________|
                space.y += box$1.h;
                space.h -= box$1.h;

            } else {
                // otherwise the box splits the space into two spaces
                // |-------|-----------|
                // |  box  | new space |
                // |_______|___________|
                // | updated space     |
                // |___________________|
                spaces.push({
                    x: space.x + box$1.w,
                    y: space.y,
                    w: space.w - box$1.w,
                    h: box$1.h
                });
                space.y += box$1.h;
                space.h -= box$1.h;
            }
            break;
        }
    }

    return {
        w: width, // container width
        h: height, // container height
        fill: (area / (width * height)) || 0 // space utilization
    };
}

var IMAGE_PADDING = 1;
var ImagePosition = function ImagePosition(paddedRect, ref) {
    var pixelRatio = ref.pixelRatio;
    var version = ref.version;
    var stretchX = ref.stretchX;
    var stretchY = ref.stretchY;
    var content = ref.content;
    this.paddedRect = paddedRect;
    this.pixelRatio = pixelRatio;
    this.stretchX = stretchX;
    this.stretchY = stretchY;
    this.content = content;
    this.version = version;
};
var prototypeAccessors = {
    tl: { configurable: true },
    br: { configurable: true },
    tlbr: { configurable: true },
    displaySize: { configurable: true }
};
prototypeAccessors.tl.get = function () {
    return [
        this.paddedRect.x + IMAGE_PADDING,
        this.paddedRect.y + IMAGE_PADDING
    ];
};
prototypeAccessors.br.get = function () {
    return [
        this.paddedRect.x + this.paddedRect.w - IMAGE_PADDING,
        this.paddedRect.y + this.paddedRect.h - IMAGE_PADDING
    ];
};
prototypeAccessors.tlbr.get = function () {
    return this.tl.concat(this.br);
};
prototypeAccessors.displaySize.get = function () {
    return [
        (this.paddedRect.w - IMAGE_PADDING * 2) / this.pixelRatio,
        (this.paddedRect.h - IMAGE_PADDING * 2) / this.pixelRatio
    ];
};
Object.defineProperties(ImagePosition.prototype, prototypeAccessors);
var ImageAtlas = function ImageAtlas(icons, patterns) {
    var iconPositions = {}, patternPositions = {};
    this.haveRenderCallbacks = [];
    var bins = [];
    this.addImages(icons, iconPositions, bins);
    this.addImages(patterns, patternPositions, bins);
    var ref = potpack(bins);
    var w = ref.w;
    var h = ref.h;
    var image = new RGBAImage({
        width: w || 1,
        height: h || 1
    });
    for (var id in icons) {
        var src = icons[id];
        var bin = iconPositions[id].paddedRect;
        RGBAImage.copy(src.data, image, {
            x: 0,
            y: 0
        }, {
            x: bin.x + IMAGE_PADDING,
            y: bin.y + IMAGE_PADDING
        }, src.data);
    }
    for (var id$1 in patterns) {
        var src$1 = patterns[id$1];
        var bin$1 = patternPositions[id$1].paddedRect;
        var x = bin$1.x + IMAGE_PADDING, y = bin$1.y + IMAGE_PADDING, w$1 = src$1.data.width, h$1 = src$1.data.height;
        RGBAImage.copy(src$1.data, image, {
            x: 0,
            y: 0
        }, {
            x: x,
            y: y
        }, src$1.data);
        RGBAImage.copy(src$1.data, image, {
            x: 0,
            y: h$1 - 1
        }, {
            x: x,
            y: y - 1
        }, {
            width: w$1,
            height: 1
        });
        RGBAImage.copy(src$1.data, image, {
            x: 0,
            y: 0
        }, {
            x: x,
            y: y + h$1
        }, {
            width: w$1,
            height: 1
        });
        RGBAImage.copy(src$1.data, image, {
            x: w$1 - 1,
            y: 0
        }, {
            x: x - 1,
            y: y
        }, {
            width: 1,
            height: h$1
        });
        RGBAImage.copy(src$1.data, image, {
            x: 0,
            y: 0
        }, {
            x: x + w$1,
            y: y
        }, {
            width: 1,
            height: h$1
        });
    }
    this.image = image;
    this.iconPositions = iconPositions;
    this.patternPositions = patternPositions;
};
ImageAtlas.prototype.addImages = function addImages(images, positions, bins) {
    for (var id in images) {
        var src = images[id];
        var bin = {
            x: 0,
            y: 0,
            w: src.data.width + 2 * IMAGE_PADDING,
            h: src.data.height + 2 * IMAGE_PADDING
        };
        bins.push(bin);
        positions[id] = new ImagePosition(bin, src);
        if (src.hasRenderCallback) {
            this.haveRenderCallbacks.push(id);
        }
    }
};
ImageAtlas.prototype.patchUpdatedImages = function patchUpdatedImages(imageManager, texture) {
    imageManager.dispatchRenderCallbacks(this.haveRenderCallbacks);
    for (var name in imageManager.updatedImages) {
        this.patchUpdatedImage(this.iconPositions[name], imageManager.getImage(name), texture);
        this.patchUpdatedImage(this.patternPositions[name], imageManager.getImage(name), texture);
    }
};
ImageAtlas.prototype.patchUpdatedImage = function patchUpdatedImage(position, image, texture) {
    if (!position || !image) {
        return;
    }
    if (position.version === image.version) {
        return;
    }
    position.version = image.version;
    var ref = position.tl;
    var x = ref[0];
    var y = ref[1];
    texture.update(image.data, undefined, {
        x: x,
        y: y
    });
};
register('ImagePosition', ImagePosition);
register('ImageAtlas', ImageAtlas);

var WritingMode = {
    horizontal: 1,
    vertical: 2,
    horizontalOnly: 3
};
var SHAPING_DEFAULT_OFFSET = -17;
function isEmpty(positionedLines) {
    for (var i = 0, list = positionedLines; i < list.length; i += 1) {
        var line = list[i];
        if (line.positionedGlyphs.length !== 0) {
            return false;
        }
    }
    return true;
}
var PUAbegin = 57344;
var PUAend = 63743;
var SectionOptions = function SectionOptions() {
    this.scale = 1;
    this.fontStack = '';
    this.imageName = null;
};
SectionOptions.forText = function forText(scale, fontStack) {
    var textOptions = new SectionOptions();
    textOptions.scale = scale || 1;
    textOptions.fontStack = fontStack;
    return textOptions;
};
SectionOptions.forImage = function forImage(imageName) {
    var imageOptions = new SectionOptions();
    imageOptions.imageName = imageName;
    return imageOptions;
};
var TaggedString = function TaggedString() {
    this.text = '';
    this.sectionIndex = [];
    this.sections = [];
    this.imageSectionID = null;
};
TaggedString.fromFeature = function fromFeature(text, defaultFontStack) {
    var result = new TaggedString();
    for (var i = 0; i < text.sections.length; i++) {
        var section = text.sections[i];
        if (!section.image) {
            result.addTextSection(section, defaultFontStack);
        } else {
            result.addImageSection(section);
        }
    }
    return result;
};
TaggedString.prototype.length = function length() {
    return this.text.length;
};
TaggedString.prototype.getSection = function getSection(index) {
    return this.sections[this.sectionIndex[index]];
};
TaggedString.prototype.getSectionIndex = function getSectionIndex(index) {
    return this.sectionIndex[index];
};
TaggedString.prototype.getCharCode = function getCharCode(index) {
    return this.text.charCodeAt(index);
};
TaggedString.prototype.verticalizePunctuation = function verticalizePunctuation$1() {
    this.text = verticalizePunctuation(this.text);
};
TaggedString.prototype.trim = function trim() {
    var beginningWhitespace = 0;
    for (var i = 0; i < this.text.length && whitespace[this.text.charCodeAt(i)]; i++) {
        beginningWhitespace++;
    }
    var trailingWhitespace = this.text.length;
    for (var i$1 = this.text.length - 1; i$1 >= 0 && i$1 >= beginningWhitespace && whitespace[this.text.charCodeAt(i$1)]; i$1--) {
        trailingWhitespace--;
    }
    this.text = this.text.substring(beginningWhitespace, trailingWhitespace);
    this.sectionIndex = this.sectionIndex.slice(beginningWhitespace, trailingWhitespace);
};
TaggedString.prototype.substring = function substring(start, end) {
    var substring = new TaggedString();
    substring.text = this.text.substring(start, end);
    substring.sectionIndex = this.sectionIndex.slice(start, end);
    substring.sections = this.sections;
    return substring;
};
TaggedString.prototype.toString = function toString() {
    return this.text;
};
TaggedString.prototype.getMaxScale = function getMaxScale() {
    var this$1 = this;
    return this.sectionIndex.reduce(function (max, index) {
        return Math.max(max, this$1.sections[index].scale);
    }, 0);
};
TaggedString.prototype.addTextSection = function addTextSection(section, defaultFontStack) {
    this.text += section.text;
    this.sections.push(SectionOptions.forText(section.scale, section.fontStack || defaultFontStack));
    var index = this.sections.length - 1;
    for (var i = 0; i < section.text.length; ++i) {
        this.sectionIndex.push(index);
    }
};
TaggedString.prototype.addImageSection = function addImageSection(section) {
    var imageName = section.image ? section.image.name : '';
    if (imageName.length === 0) {
        warnOnce('Can\'t add FormattedSection with an empty image.');
        return;
    }
    var nextImageSectionCharCode = this.getNextImageSectionCharCode();
    if (!nextImageSectionCharCode) {
        warnOnce('Reached maximum number of images ' + (PUAend - PUAbegin + 2));
        return;
    }
    this.text += String.fromCharCode(nextImageSectionCharCode);
    this.sections.push(SectionOptions.forImage(imageName));
    this.sectionIndex.push(this.sections.length - 1);
};
TaggedString.prototype.getNextImageSectionCharCode = function getNextImageSectionCharCode() {
    if (!this.imageSectionID) {
        this.imageSectionID = PUAbegin;
        return this.imageSectionID;
    }
    if (this.imageSectionID >= PUAend) {
        return null;
    }
    return ++this.imageSectionID;
};
function breakLines(input, lineBreakPoints) {
    var lines = [];
    var text = input.text;
    var start = 0;
    for (var i = 0, list = lineBreakPoints; i < list.length; i += 1) {
        var lineBreak = list[i];
        lines.push(input.substring(start, lineBreak));
        start = lineBreak;
    }
    if (start < text.length) {
        lines.push(input.substring(start, text.length));
    }
    return lines;
}
function shapeText(text, glyphMap, glyphPositions, imagePositions, defaultFontStack, maxWidth, lineHeight, textAnchor, textJustify, spacing, translate, writingMode, allowVerticalPlacement, symbolPlacement, layoutTextSize, layoutTextSizeThisZoom) {
    var logicalInput = TaggedString.fromFeature(text, defaultFontStack);
    if (writingMode === WritingMode.vertical) {
        logicalInput.verticalizePunctuation();
    }
    var lines;
    var processBidirectionalText = plugin.processBidirectionalText;
    var processStyledBidirectionalText = plugin.processStyledBidirectionalText;
    if (processBidirectionalText && logicalInput.sections.length === 1) {
        lines = [];
        var untaggedLines = processBidirectionalText(logicalInput.toString(), determineLineBreaks(logicalInput, spacing, maxWidth, glyphMap, imagePositions, symbolPlacement, layoutTextSize));
        for (var i$1 = 0, list = untaggedLines; i$1 < list.length; i$1 += 1) {
            var line = list[i$1];
            var taggedLine = new TaggedString();
            taggedLine.text = line;
            taggedLine.sections = logicalInput.sections;
            for (var i = 0; i < line.length; i++) {
                taggedLine.sectionIndex.push(0);
            }
            lines.push(taggedLine);
        }
    } else if (processStyledBidirectionalText) {
        lines = [];
        var processedLines = processStyledBidirectionalText(logicalInput.text, logicalInput.sectionIndex, determineLineBreaks(logicalInput, spacing, maxWidth, glyphMap, imagePositions, symbolPlacement, layoutTextSize));
        for (var i$2 = 0, list$1 = processedLines; i$2 < list$1.length; i$2 += 1) {
            var line$1 = list$1[i$2];
            var taggedLine$1 = new TaggedString();
            taggedLine$1.text = line$1[0];
            taggedLine$1.sectionIndex = line$1[1];
            taggedLine$1.sections = logicalInput.sections;
            lines.push(taggedLine$1);
        }
    } else {
        lines = breakLines(logicalInput, determineLineBreaks(logicalInput, spacing, maxWidth, glyphMap, imagePositions, symbolPlacement, layoutTextSize));
    }
    var positionedLines = [];
    var shaping = {
        positionedLines: positionedLines,
        text: logicalInput.toString(),
        top: translate[1],
        bottom: translate[1],
        left: translate[0],
        right: translate[0],
        writingMode: writingMode,
        iconsInText: false,
        verticalizable: false
    };
    shapeLines(shaping, glyphMap, glyphPositions, imagePositions, lines, lineHeight, textAnchor, textJustify, writingMode, spacing, allowVerticalPlacement, layoutTextSizeThisZoom);
    if (isEmpty(positionedLines)) {
        return false;
    }
    return shaping;
}
var whitespace = {};
whitespace[9] = true;
whitespace[10] = true;
whitespace[11] = true;
whitespace[12] = true;
whitespace[13] = true;
whitespace[32] = true;
var breakable = {};
breakable[10] = true;
breakable[32] = true;
breakable[38] = true;
breakable[40] = true;
breakable[41] = true;
breakable[43] = true;
breakable[45] = true;
breakable[47] = true;
breakable[173] = true;
breakable[183] = true;
breakable[8203] = true;
breakable[8208] = true;
breakable[8211] = true;
breakable[8231] = true;
function getGlyphAdvance(codePoint, section, glyphMap, imagePositions, spacing, layoutTextSize) {
    if (!section.imageName) {
        var positions = glyphMap[section.fontStack];
        var glyph = positions && positions[codePoint];
        if (!glyph) {
            return 0;
        }
        return glyph.metrics.advance * section.scale + spacing;
    } else {
        var imagePosition = imagePositions[section.imageName];
        if (!imagePosition) {
            return 0;
        }
        return imagePosition.displaySize[0] * section.scale * ONE_EM / layoutTextSize + spacing;
    }
}
function determineAverageLineWidth(logicalInput, spacing, maxWidth, glyphMap, imagePositions, layoutTextSize) {
    var totalWidth = 0;
    for (var index = 0; index < logicalInput.length(); index++) {
        var section = logicalInput.getSection(index);
        totalWidth += getGlyphAdvance(logicalInput.getCharCode(index), section, glyphMap, imagePositions, spacing, layoutTextSize);
    }
    var lineCount = Math.max(1, Math.ceil(totalWidth / maxWidth));
    return totalWidth / lineCount;
}
function calculateBadness(lineWidth, targetWidth, penalty, isLastBreak) {
    var raggedness = Math.pow(lineWidth - targetWidth, 2);
    if (isLastBreak) {
        if (lineWidth < targetWidth) {
            return raggedness / 2;
        } else {
            return raggedness * 2;
        }
    }
    return raggedness + Math.abs(penalty) * penalty;
}
function calculatePenalty(codePoint, nextCodePoint, penalizableIdeographicBreak) {
    var penalty = 0;
    if (codePoint === 10) {
        penalty -= 10000;
    }
    if (penalizableIdeographicBreak) {
        penalty += 150;
    }
    if (codePoint === 40 || codePoint === 65288) {
        penalty += 50;
    }
    if (nextCodePoint === 41 || nextCodePoint === 65289) {
        penalty += 50;
    }
    return penalty;
}
function evaluateBreak(breakIndex, breakX, targetWidth, potentialBreaks, penalty, isLastBreak) {
    var bestPriorBreak = null;
    var bestBreakBadness = calculateBadness(breakX, targetWidth, penalty, isLastBreak);
    for (var i = 0, list = potentialBreaks; i < list.length; i += 1) {
        var potentialBreak = list[i];
        var lineWidth = breakX - potentialBreak.x;
        var breakBadness = calculateBadness(lineWidth, targetWidth, penalty, isLastBreak) + potentialBreak.badness;
        if (breakBadness <= bestBreakBadness) {
            bestPriorBreak = potentialBreak;
            bestBreakBadness = breakBadness;
        }
    }
    return {
        index: breakIndex,
        x: breakX,
        priorBreak: bestPriorBreak,
        badness: bestBreakBadness
    };
}
function leastBadBreaks(lastLineBreak) {
    if (!lastLineBreak) {
        return [];
    }
    return leastBadBreaks(lastLineBreak.priorBreak).concat(lastLineBreak.index);
}
function determineLineBreaks(logicalInput, spacing, maxWidth, glyphMap, imagePositions, symbolPlacement, layoutTextSize) {
    if (symbolPlacement !== 'point') {
        return [];
    }
    if (!logicalInput) {
        return [];
    }
    var potentialLineBreaks = [];
    var targetWidth = determineAverageLineWidth(logicalInput, spacing, maxWidth, glyphMap, imagePositions, layoutTextSize);
    var hasServerSuggestedBreakpoints = logicalInput.text.indexOf('\u200B') >= 0;
    var currentX = 0;
    for (var i = 0; i < logicalInput.length(); i++) {
        var section = logicalInput.getSection(i);
        var codePoint = logicalInput.getCharCode(i);
        if (!whitespace[codePoint]) {
            currentX += getGlyphAdvance(codePoint, section, glyphMap, imagePositions, spacing, layoutTextSize);
        }
        if (i < logicalInput.length() - 1) {
            var ideographicBreak = charAllowsIdeographicBreaking(codePoint);
            if (breakable[codePoint] || ideographicBreak || section.imageName) {
                potentialLineBreaks.push(evaluateBreak(i + 1, currentX, targetWidth, potentialLineBreaks, calculatePenalty(codePoint, logicalInput.getCharCode(i + 1), ideographicBreak && hasServerSuggestedBreakpoints), false));
            }
        }
    }
    return leastBadBreaks(evaluateBreak(logicalInput.length(), currentX, targetWidth, potentialLineBreaks, 0, true));
}
function getAnchorAlignment(anchor) {
    var horizontalAlign = 0.5, verticalAlign = 0.5;
    switch (anchor) {
    case 'right':
    case 'top-right':
    case 'bottom-right':
        horizontalAlign = 1;
        break;
    case 'left':
    case 'top-left':
    case 'bottom-left':
        horizontalAlign = 0;
        break;
    }
    switch (anchor) {
    case 'bottom':
    case 'bottom-right':
    case 'bottom-left':
        verticalAlign = 1;
        break;
    case 'top':
    case 'top-right':
    case 'top-left':
        verticalAlign = 0;
        break;
    }
    return {
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign
    };
}
function shapeLines(shaping, glyphMap, glyphPositions, imagePositions, lines, lineHeight, textAnchor, textJustify, writingMode, spacing, allowVerticalPlacement, layoutTextSizeThisZoom) {
    var x = 0;
    var y = SHAPING_DEFAULT_OFFSET;
    var maxLineLength = 0;
    var maxLineHeight = 0;
    var justify = textJustify === 'right' ? 1 : textJustify === 'left' ? 0 : 0.5;
    var lineIndex = 0;
    for (var i$1 = 0, list = lines; i$1 < list.length; i$1 += 1) {
        var line = list[i$1];
        line.trim();
        var lineMaxScale = line.getMaxScale();
        var maxLineOffset = (lineMaxScale - 1) * ONE_EM;
        var positionedLine = {
            positionedGlyphs: [],
            lineOffset: 0
        };
        shaping.positionedLines[lineIndex] = positionedLine;
        var positionedGlyphs = positionedLine.positionedGlyphs;
        var lineOffset = 0;
        if (!line.length()) {
            y += lineHeight;
            ++lineIndex;
            continue;
        }
        for (var i = 0; i < line.length(); i++) {
            var section = line.getSection(i);
            var sectionIndex = line.getSectionIndex(i);
            var codePoint = line.getCharCode(i);
            var baselineOffset = 0;
            var metrics = null;
            var rect = null;
            var imageName = null;
            var verticalAdvance = ONE_EM;
            var vertical = !(writingMode === WritingMode.horizontal || !allowVerticalPlacement && !charHasUprightVerticalOrientation(codePoint) || allowVerticalPlacement && (whitespace[codePoint] || charInComplexShapingScript(codePoint)));
            if (!section.imageName) {
                var positions = glyphPositions[section.fontStack];
                var glyphPosition = positions && positions[codePoint];
                if (glyphPosition && glyphPosition.rect) {
                    rect = glyphPosition.rect;
                    metrics = glyphPosition.metrics;
                } else {
                    var glyphs = glyphMap[section.fontStack];
                    var glyph = glyphs && glyphs[codePoint];
                    if (!glyph) {
                        continue;
                    }
                    metrics = glyph.metrics;
                }
                baselineOffset = (lineMaxScale - section.scale) * ONE_EM;
            } else {
                var imagePosition = imagePositions[section.imageName];
                if (!imagePosition) {
                    continue;
                }
                imageName = section.imageName;
                shaping.iconsInText = shaping.iconsInText || true;
                rect = imagePosition.paddedRect;
                var size = imagePosition.displaySize;
                section.scale = section.scale * ONE_EM / layoutTextSizeThisZoom;
                metrics = {
                    width: size[0],
                    height: size[1],
                    left: IMAGE_PADDING,
                    top: -GLYPH_PBF_BORDER,
                    advance: vertical ? size[1] : size[0]
                };
                var imageOffset = ONE_EM - size[1] * section.scale;
                baselineOffset = maxLineOffset + imageOffset;
                verticalAdvance = metrics.advance;
                var offset = vertical ? size[0] * section.scale - ONE_EM * lineMaxScale : size[1] * section.scale - ONE_EM * lineMaxScale;
                if (offset > 0 && offset > lineOffset) {
                    lineOffset = offset;
                }
            }
            if (!vertical) {
                positionedGlyphs.push({
                    glyph: codePoint,
                    imageName: imageName,
                    x: x,
                    y: y + baselineOffset,
                    vertical: vertical,
                    scale: section.scale,
                    fontStack: section.fontStack,
                    sectionIndex: sectionIndex,
                    metrics: metrics,
                    rect: rect
                });
                x += metrics.advance * section.scale + spacing;
            } else {
                shaping.verticalizable = true;
                positionedGlyphs.push({
                    glyph: codePoint,
                    imageName: imageName,
                    x: x,
                    y: y + baselineOffset,
                    vertical: vertical,
                    scale: section.scale,
                    fontStack: section.fontStack,
                    sectionIndex: sectionIndex,
                    metrics: metrics,
                    rect: rect
                });
                x += verticalAdvance * section.scale + spacing;
            }
        }
        if (positionedGlyphs.length !== 0) {
            var lineLength = x - spacing;
            maxLineLength = Math.max(lineLength, maxLineLength);
            justifyLine(positionedGlyphs, 0, positionedGlyphs.length - 1, justify, lineOffset);
        }
        x = 0;
        var currentLineHeight = lineHeight * lineMaxScale + lineOffset;
        positionedLine.lineOffset = Math.max(lineOffset, maxLineOffset);
        y += currentLineHeight;
        maxLineHeight = Math.max(currentLineHeight, maxLineHeight);
        ++lineIndex;
    }
    var height = y - SHAPING_DEFAULT_OFFSET;
    var ref = getAnchorAlignment(textAnchor);
    var horizontalAlign = ref.horizontalAlign;
    var verticalAlign = ref.verticalAlign;
    align$1(shaping.positionedLines, justify, horizontalAlign, verticalAlign, maxLineLength, maxLineHeight, lineHeight, height, lines.length);
    shaping.top += -verticalAlign * height;
    shaping.bottom = shaping.top + height;
    shaping.left += -horizontalAlign * maxLineLength;
    shaping.right = shaping.left + maxLineLength;
}
function justifyLine(positionedGlyphs, start, end, justify, lineOffset) {
    if (!justify && !lineOffset) {
        return;
    }
    var lastPositionedGlyph = positionedGlyphs[end];
    var lastAdvance = lastPositionedGlyph.metrics.advance * lastPositionedGlyph.scale;
    var lineIndent = (positionedGlyphs[end].x + lastAdvance) * justify;
    for (var j = start; j <= end; j++) {
        positionedGlyphs[j].x -= lineIndent;
        positionedGlyphs[j].y += lineOffset;
    }
}
function align$1(positionedLines, justify, horizontalAlign, verticalAlign, maxLineLength, maxLineHeight, lineHeight, blockHeight, lineCount) {
    var shiftX = (justify - horizontalAlign) * maxLineLength;
    var shiftY = 0;
    if (maxLineHeight !== lineHeight) {
        shiftY = -blockHeight * verticalAlign - SHAPING_DEFAULT_OFFSET;
    } else {
        shiftY = (-verticalAlign * lineCount + 0.5) * lineHeight;
    }
    for (var i$1 = 0, list$1 = positionedLines; i$1 < list$1.length; i$1 += 1) {
        var line = list$1[i$1];
        for (var i = 0, list = line.positionedGlyphs; i < list.length; i += 1) {
            var positionedGlyph = list[i];
            positionedGlyph.x += shiftX;
            positionedGlyph.y += shiftY;
        }
    }
}
function shapeIcon(image, iconOffset, iconAnchor) {
    var ref = getAnchorAlignment(iconAnchor);
    var horizontalAlign = ref.horizontalAlign;
    var verticalAlign = ref.verticalAlign;
    var dx = iconOffset[0];
    var dy = iconOffset[1];
    var x1 = dx - image.displaySize[0] * horizontalAlign;
    var x2 = x1 + image.displaySize[0];
    var y1 = dy - image.displaySize[1] * verticalAlign;
    var y2 = y1 + image.displaySize[1];
    return {
        image: image,
        top: y1,
        bottom: y2,
        left: x1,
        right: x2
    };
}
function fitIconToText(shapedIcon, shapedText, textFit, padding, iconOffset, fontScale) {
    var image = shapedIcon.image;
    var collisionPadding;
    if (image.content) {
        var content = image.content;
        var pixelRatio = image.pixelRatio || 1;
        collisionPadding = [
            content[0] / pixelRatio,
            content[1] / pixelRatio,
            image.displaySize[0] - content[2] / pixelRatio,
            image.displaySize[1] - content[3] / pixelRatio
        ];
    }
    var textLeft = shapedText.left * fontScale;
    var textRight = shapedText.right * fontScale;
    var top, right, bottom, left;
    if (textFit === 'width' || textFit === 'both') {
        left = iconOffset[0] + textLeft - padding[3];
        right = iconOffset[0] + textRight + padding[1];
    } else {
        left = iconOffset[0] + (textLeft + textRight - image.displaySize[0]) / 2;
        right = left + image.displaySize[0];
    }
    var textTop = shapedText.top * fontScale;
    var textBottom = shapedText.bottom * fontScale;
    if (textFit === 'height' || textFit === 'both') {
        top = iconOffset[1] + textTop - padding[0];
        bottom = iconOffset[1] + textBottom + padding[2];
    } else {
        top = iconOffset[1] + (textTop + textBottom - image.displaySize[1]) / 2;
        bottom = top + image.displaySize[1];
    }
    return {
        image: image,
        top: top,
        right: right,
        bottom: bottom,
        left: left,
        collisionPadding: collisionPadding
    };
}

var Anchor = function (Point) {
    function Anchor(x, y, angle, segment) {
        Point.call(this, x, y);
        this.angle = angle;
        if (segment !== undefined) {
            this.segment = segment;
        }
    }
    if (Point)
        Anchor.__proto__ = Point;
    Anchor.prototype = Object.create(Point && Point.prototype);
    Anchor.prototype.constructor = Anchor;
    Anchor.prototype.clone = function clone() {
        return new Anchor(this.x, this.y, this.angle, this.segment);
    };
    return Anchor;
}(pointGeometry);
register('Anchor', Anchor);

var SIZE_PACK_FACTOR = 128;
function getSizeData(tileZoom, value) {
    var expression = value.expression;
    if (expression.kind === 'constant') {
        var layoutSize = expression.evaluate(new EvaluationParameters(tileZoom + 1));
        return {
            kind: 'constant',
            layoutSize: layoutSize
        };
    } else if (expression.kind === 'source') {
        return { kind: 'source' };
    } else {
        var zoomStops = expression.zoomStops;
        var interpolationType = expression.interpolationType;
        var lower = 0;
        while (lower < zoomStops.length && zoomStops[lower] <= tileZoom) {
            lower++;
        }
        lower = Math.max(0, lower - 1);
        var upper = lower;
        while (upper < zoomStops.length && zoomStops[upper] < tileZoom + 1) {
            upper++;
        }
        upper = Math.min(zoomStops.length - 1, upper);
        var minZoom = zoomStops[lower];
        var maxZoom = zoomStops[upper];
        if (expression.kind === 'composite') {
            return {
                kind: 'composite',
                minZoom: minZoom,
                maxZoom: maxZoom,
                interpolationType: interpolationType
            };
        }
        var minSize = expression.evaluate(new EvaluationParameters(minZoom));
        var maxSize = expression.evaluate(new EvaluationParameters(maxZoom));
        return {
            kind: 'camera',
            minZoom: minZoom,
            maxZoom: maxZoom,
            minSize: minSize,
            maxSize: maxSize,
            interpolationType: interpolationType
        };
    }
}
function evaluateSizeForFeature(sizeData, ref, ref$1) {
    var uSize = ref.uSize;
    var uSizeT = ref.uSizeT;
    var lowerSize = ref$1.lowerSize;
    var upperSize = ref$1.upperSize;
    if (sizeData.kind === 'source') {
        return lowerSize / SIZE_PACK_FACTOR;
    } else if (sizeData.kind === 'composite') {
        return number(lowerSize / SIZE_PACK_FACTOR, upperSize / SIZE_PACK_FACTOR, uSizeT);
    }
    return uSize;
}
function evaluateSizeForZoom(sizeData, zoom) {
    var uSizeT = 0;
    var uSize = 0;
    if (sizeData.kind === 'constant') {
        uSize = sizeData.layoutSize;
    } else if (sizeData.kind !== 'source') {
        var interpolationType = sizeData.interpolationType;
        var minZoom = sizeData.minZoom;
        var maxZoom = sizeData.maxZoom;
        var t = !interpolationType ? 0 : clamp(Interpolate.interpolationFactor(interpolationType, zoom, minZoom, maxZoom), 0, 1);
        if (sizeData.kind === 'camera') {
            uSize = number(sizeData.minSize, sizeData.maxSize, t);
        } else {
            uSizeT = t;
        }
    }
    return {
        uSizeT: uSizeT,
        uSize: uSize
    };
}

var symbolSize = /*#__PURE__*/Object.freeze({
__proto__: null,
getSizeData: getSizeData,
evaluateSizeForFeature: evaluateSizeForFeature,
evaluateSizeForZoom: evaluateSizeForZoom,
SIZE_PACK_FACTOR: SIZE_PACK_FACTOR
});

function checkMaxAngle(line, anchor, labelLength, windowSize, maxAngle) {
    if (anchor.segment === undefined) {
        return true;
    }
    var p = anchor;
    var index = anchor.segment + 1;
    var anchorDistance = 0;
    while (anchorDistance > -labelLength / 2) {
        index--;
        if (index < 0) {
            return false;
        }
        anchorDistance -= line[index].dist(p);
        p = line[index];
    }
    anchorDistance += line[index].dist(line[index + 1]);
    index++;
    var recentCorners = [];
    var recentAngleDelta = 0;
    while (anchorDistance < labelLength / 2) {
        var prev = line[index - 1];
        var current = line[index];
        var next = line[index + 1];
        if (!next) {
            return false;
        }
        var angleDelta = prev.angleTo(current) - current.angleTo(next);
        angleDelta = Math.abs((angleDelta + 3 * Math.PI) % (Math.PI * 2) - Math.PI);
        recentCorners.push({
            distance: anchorDistance,
            angleDelta: angleDelta
        });
        recentAngleDelta += angleDelta;
        while (anchorDistance - recentCorners[0].distance > windowSize) {
            recentAngleDelta -= recentCorners.shift().angleDelta;
        }
        if (recentAngleDelta > maxAngle) {
            return false;
        }
        index++;
        anchorDistance += current.dist(next);
    }
    return true;
}

function getLineLength(line) {
    var lineLength = 0;
    for (var k = 0; k < line.length - 1; k++) {
        lineLength += line[k].dist(line[k + 1]);
    }
    return lineLength;
}
function getAngleWindowSize(shapedText, glyphSize, boxScale) {
    return shapedText ? 3 / 5 * glyphSize * boxScale : 0;
}
function getShapedLabelLength(shapedText, shapedIcon) {
    return Math.max(shapedText ? shapedText.right - shapedText.left : 0, shapedIcon ? shapedIcon.right - shapedIcon.left : 0);
}
function getCenterAnchor(line, maxAngle, shapedText, shapedIcon, glyphSize, boxScale) {
    var angleWindowSize = getAngleWindowSize(shapedText, glyphSize, boxScale);
    var labelLength = getShapedLabelLength(shapedText, shapedIcon) * boxScale;
    var prevDistance = 0;
    var centerDistance = getLineLength(line) / 2;
    for (var i = 0; i < line.length - 1; i++) {
        var a = line[i], b = line[i + 1];
        var segmentDistance = a.dist(b);
        if (prevDistance + segmentDistance > centerDistance) {
            var t = (centerDistance - prevDistance) / segmentDistance, x = number(a.x, b.x, t), y = number(a.y, b.y, t);
            var anchor = new Anchor(x, y, b.angleTo(a), i);
            anchor._round();
            if (!angleWindowSize || checkMaxAngle(line, anchor, labelLength, angleWindowSize, maxAngle)) {
                return anchor;
            } else {
                return;
            }
        }
        prevDistance += segmentDistance;
    }
}
function getAnchors(line, spacing, maxAngle, shapedText, shapedIcon, glyphSize, boxScale, overscaling, tileExtent) {
    var angleWindowSize = getAngleWindowSize(shapedText, glyphSize, boxScale);
    var shapedLabelLength = getShapedLabelLength(shapedText, shapedIcon);
    var labelLength = shapedLabelLength * boxScale;
    var isLineContinued = line[0].x === 0 || line[0].x === tileExtent || line[0].y === 0 || line[0].y === tileExtent;
    if (spacing - labelLength < spacing / 4) {
        spacing = labelLength + spacing / 4;
    }
    var fixedExtraOffset = glyphSize * 2;
    var offset = !isLineContinued ? (shapedLabelLength / 2 + fixedExtraOffset) * boxScale * overscaling % spacing : spacing / 2 * overscaling % spacing;
    return resample(line, offset, spacing, angleWindowSize, maxAngle, labelLength, isLineContinued, false, tileExtent);
}
function resample(line, offset, spacing, angleWindowSize, maxAngle, labelLength, isLineContinued, placeAtMiddle, tileExtent) {
    var halfLabelLength = labelLength / 2;
    var lineLength = getLineLength(line);
    var distance = 0, markedDistance = offset - spacing;
    var anchors = [];
    for (var i = 0; i < line.length - 1; i++) {
        var a = line[i], b = line[i + 1];
        var segmentDist = a.dist(b), angle = b.angleTo(a);
        while (markedDistance + spacing < distance + segmentDist) {
            markedDistance += spacing;
            var t = (markedDistance - distance) / segmentDist, x = number(a.x, b.x, t), y = number(a.y, b.y, t);
            if (x >= 0 && x < tileExtent && y >= 0 && y < tileExtent && markedDistance - halfLabelLength >= 0 && markedDistance + halfLabelLength <= lineLength) {
                var anchor = new Anchor(x, y, angle, i);
                anchor._round();
                if (!angleWindowSize || checkMaxAngle(line, anchor, labelLength, angleWindowSize, maxAngle)) {
                    anchors.push(anchor);
                }
            }
        }
        distance += segmentDist;
    }
    if (!placeAtMiddle && !anchors.length && !isLineContinued) {
        anchors = resample(line, distance / 2, spacing, angleWindowSize, maxAngle, labelLength, isLineContinued, true, tileExtent);
    }
    return anchors;
}

function clipLine(lines, x1, y1, x2, y2) {
    var clippedLines = [];
    for (var l = 0; l < lines.length; l++) {
        var line = lines[l];
        var clippedLine = void 0;
        for (var i = 0; i < line.length - 1; i++) {
            var p0 = line[i];
            var p1 = line[i + 1];
            if (p0.x < x1 && p1.x < x1) {
                continue;
            } else if (p0.x < x1) {
                p0 = new pointGeometry(x1, p0.y + (p1.y - p0.y) * ((x1 - p0.x) / (p1.x - p0.x)))._round();
            } else if (p1.x < x1) {
                p1 = new pointGeometry(x1, p0.y + (p1.y - p0.y) * ((x1 - p0.x) / (p1.x - p0.x)))._round();
            }
            if (p0.y < y1 && p1.y < y1) {
                continue;
            } else if (p0.y < y1) {
                p0 = new pointGeometry(p0.x + (p1.x - p0.x) * ((y1 - p0.y) / (p1.y - p0.y)), y1)._round();
            } else if (p1.y < y1) {
                p1 = new pointGeometry(p0.x + (p1.x - p0.x) * ((y1 - p0.y) / (p1.y - p0.y)), y1)._round();
            }
            if (p0.x >= x2 && p1.x >= x2) {
                continue;
            } else if (p0.x >= x2) {
                p0 = new pointGeometry(x2, p0.y + (p1.y - p0.y) * ((x2 - p0.x) / (p1.x - p0.x)))._round();
            } else if (p1.x >= x2) {
                p1 = new pointGeometry(x2, p0.y + (p1.y - p0.y) * ((x2 - p0.x) / (p1.x - p0.x)))._round();
            }
            if (p0.y >= y2 && p1.y >= y2) {
                continue;
            } else if (p0.y >= y2) {
                p0 = new pointGeometry(p0.x + (p1.x - p0.x) * ((y2 - p0.y) / (p1.y - p0.y)), y2)._round();
            } else if (p1.y >= y2) {
                p1 = new pointGeometry(p0.x + (p1.x - p0.x) * ((y2 - p0.y) / (p1.y - p0.y)), y2)._round();
            }
            if (!clippedLine || !p0.equals(clippedLine[clippedLine.length - 1])) {
                clippedLine = [p0];
                clippedLines.push(clippedLine);
            }
            clippedLine.push(p1);
        }
    }
    return clippedLines;
}

var border$1 = IMAGE_PADDING;
function getIconQuads(shapedIcon, iconRotate, isSDFIcon, hasIconTextFit) {
    var quads = [];
    var image = shapedIcon.image;
    var pixelRatio = image.pixelRatio;
    var imageWidth = image.paddedRect.w - 2 * border$1;
    var imageHeight = image.paddedRect.h - 2 * border$1;
    var iconWidth = shapedIcon.right - shapedIcon.left;
    var iconHeight = shapedIcon.bottom - shapedIcon.top;
    var stretchX = image.stretchX || [[
            0,
            imageWidth
        ]];
    var stretchY = image.stretchY || [[
            0,
            imageHeight
        ]];
    var reduceRanges = function (sum, range) {
        return sum + range[1] - range[0];
    };
    var stretchWidth = stretchX.reduce(reduceRanges, 0);
    var stretchHeight = stretchY.reduce(reduceRanges, 0);
    var fixedWidth = imageWidth - stretchWidth;
    var fixedHeight = imageHeight - stretchHeight;
    var stretchOffsetX = 0;
    var stretchContentWidth = stretchWidth;
    var stretchOffsetY = 0;
    var stretchContentHeight = stretchHeight;
    var fixedOffsetX = 0;
    var fixedContentWidth = fixedWidth;
    var fixedOffsetY = 0;
    var fixedContentHeight = fixedHeight;
    if (image.content && hasIconTextFit) {
        var content = image.content;
        stretchOffsetX = sumWithinRange(stretchX, 0, content[0]);
        stretchOffsetY = sumWithinRange(stretchY, 0, content[1]);
        stretchContentWidth = sumWithinRange(stretchX, content[0], content[2]);
        stretchContentHeight = sumWithinRange(stretchY, content[1], content[3]);
        fixedOffsetX = content[0] - stretchOffsetX;
        fixedOffsetY = content[1] - stretchOffsetY;
        fixedContentWidth = content[2] - content[0] - stretchContentWidth;
        fixedContentHeight = content[3] - content[1] - stretchContentHeight;
    }
    var makeBox = function (left, top, right, bottom) {
        var leftEm = getEmOffset(left.stretch - stretchOffsetX, stretchContentWidth, iconWidth, shapedIcon.left);
        var leftPx = getPxOffset(left.fixed - fixedOffsetX, fixedContentWidth, left.stretch, stretchWidth);
        var topEm = getEmOffset(top.stretch - stretchOffsetY, stretchContentHeight, iconHeight, shapedIcon.top);
        var topPx = getPxOffset(top.fixed - fixedOffsetY, fixedContentHeight, top.stretch, stretchHeight);
        var rightEm = getEmOffset(right.stretch - stretchOffsetX, stretchContentWidth, iconWidth, shapedIcon.left);
        var rightPx = getPxOffset(right.fixed - fixedOffsetX, fixedContentWidth, right.stretch, stretchWidth);
        var bottomEm = getEmOffset(bottom.stretch - stretchOffsetY, stretchContentHeight, iconHeight, shapedIcon.top);
        var bottomPx = getPxOffset(bottom.fixed - fixedOffsetY, fixedContentHeight, bottom.stretch, stretchHeight);
        var tl = new pointGeometry(leftEm, topEm);
        var tr = new pointGeometry(rightEm, topEm);
        var br = new pointGeometry(rightEm, bottomEm);
        var bl = new pointGeometry(leftEm, bottomEm);
        var pixelOffsetTL = new pointGeometry(leftPx / pixelRatio, topPx / pixelRatio);
        var pixelOffsetBR = new pointGeometry(rightPx / pixelRatio, bottomPx / pixelRatio);
        var angle = iconRotate * Math.PI / 180;
        if (angle) {
            var sin = Math.sin(angle), cos = Math.cos(angle), matrix = [
                    cos,
                    -sin,
                    sin,
                    cos
                ];
            tl._matMult(matrix);
            tr._matMult(matrix);
            bl._matMult(matrix);
            br._matMult(matrix);
        }
        var x1 = left.stretch + left.fixed;
        var x2 = right.stretch + right.fixed;
        var y1 = top.stretch + top.fixed;
        var y2 = bottom.stretch + bottom.fixed;
        var subRect = {
            x: image.paddedRect.x + border$1 + x1,
            y: image.paddedRect.y + border$1 + y1,
            w: x2 - x1,
            h: y2 - y1
        };
        var minFontScaleX = fixedContentWidth / pixelRatio / iconWidth;
        var minFontScaleY = fixedContentHeight / pixelRatio / iconHeight;
        return {
            tl: tl,
            tr: tr,
            bl: bl,
            br: br,
            tex: subRect,
            writingMode: undefined,
            glyphOffset: [
                0,
                0
            ],
            sectionIndex: 0,
            pixelOffsetTL: pixelOffsetTL,
            pixelOffsetBR: pixelOffsetBR,
            minFontScaleX: minFontScaleX,
            minFontScaleY: minFontScaleY,
            isSDF: isSDFIcon
        };
    };
    if (!hasIconTextFit || !image.stretchX && !image.stretchY) {
        quads.push(makeBox({
            fixed: 0,
            stretch: -1
        }, {
            fixed: 0,
            stretch: -1
        }, {
            fixed: 0,
            stretch: imageWidth + 1
        }, {
            fixed: 0,
            stretch: imageHeight + 1
        }));
    } else {
        var xCuts = stretchZonesToCuts(stretchX, fixedWidth, stretchWidth);
        var yCuts = stretchZonesToCuts(stretchY, fixedHeight, stretchHeight);
        for (var xi = 0; xi < xCuts.length - 1; xi++) {
            var x1 = xCuts[xi];
            var x2 = xCuts[xi + 1];
            for (var yi = 0; yi < yCuts.length - 1; yi++) {
                var y1 = yCuts[yi];
                var y2 = yCuts[yi + 1];
                quads.push(makeBox(x1, y1, x2, y2));
            }
        }
    }
    return quads;
}
function sumWithinRange(ranges, min, max) {
    var sum = 0;
    for (var i = 0, list = ranges; i < list.length; i += 1) {
        var range = list[i];
        sum += Math.max(min, Math.min(max, range[1])) - Math.max(min, Math.min(max, range[0]));
    }
    return sum;
}
function stretchZonesToCuts(stretchZones, fixedSize, stretchSize) {
    var cuts = [{
            fixed: -border$1,
            stretch: 0
        }];
    for (var i = 0, list = stretchZones; i < list.length; i += 1) {
        var ref = list[i];
        var c1 = ref[0];
        var c2 = ref[1];
        var last = cuts[cuts.length - 1];
        cuts.push({
            fixed: c1 - last.stretch,
            stretch: last.stretch
        });
        cuts.push({
            fixed: c1 - last.stretch,
            stretch: last.stretch + (c2 - c1)
        });
    }
    cuts.push({
        fixed: fixedSize + border$1,
        stretch: stretchSize
    });
    return cuts;
}
function getEmOffset(stretchOffset, stretchSize, iconSize, iconOffset) {
    return stretchOffset / stretchSize * iconSize + iconOffset;
}
function getPxOffset(fixedOffset, fixedSize, stretchOffset, stretchSize) {
    return fixedOffset - fixedSize * stretchOffset / stretchSize;
}
function getGlyphQuads(anchor, shaping, textOffset, layer, alongLine, feature, imageMap, allowVerticalPlacement) {
    var textRotate = layer.layout.get('text-rotate').evaluate(feature, {}) * Math.PI / 180;
    var quads = [];
    for (var i$1 = 0, list$1 = shaping.positionedLines; i$1 < list$1.length; i$1 += 1) {
        var line = list$1[i$1];
        for (var i = 0, list = line.positionedGlyphs; i < list.length; i += 1) {
            var positionedGlyph = list[i];
            if (!positionedGlyph.rect) {
                continue;
            }
            var textureRect = positionedGlyph.rect || {};
            var glyphPadding = 1;
            var rectBuffer = GLYPH_PBF_BORDER + glyphPadding;
            var isSDF = true;
            var pixelRatio = 1;
            var lineOffset = 0;
            var rotateVerticalGlyph = (alongLine || allowVerticalPlacement) && positionedGlyph.vertical;
            var halfAdvance = positionedGlyph.metrics.advance * positionedGlyph.scale / 2;
            if (allowVerticalPlacement && shaping.verticalizable) {
                var scaledGlyphOffset = (positionedGlyph.scale - 1) * ONE_EM;
                var imageOffset = (ONE_EM - positionedGlyph.metrics.width * positionedGlyph.scale) / 2;
                lineOffset = line.lineOffset / 2 - (positionedGlyph.imageName ? -imageOffset : scaledGlyphOffset);
            }
            if (positionedGlyph.imageName) {
                var image = imageMap[positionedGlyph.imageName];
                isSDF = image.sdf;
                pixelRatio = image.pixelRatio;
                rectBuffer = IMAGE_PADDING / pixelRatio;
            }
            var glyphOffset = alongLine ? [
                positionedGlyph.x + halfAdvance,
                positionedGlyph.y
            ] : [
                0,
                0
            ];
            var builtInOffset = alongLine ? [
                0,
                0
            ] : [
                positionedGlyph.x + halfAdvance + textOffset[0],
                positionedGlyph.y + textOffset[1] - lineOffset
            ];
            var verticalizedLabelOffset = [
                0,
                0
            ];
            if (rotateVerticalGlyph) {
                verticalizedLabelOffset = builtInOffset;
                builtInOffset = [
                    0,
                    0
                ];
            }
            var x1 = (positionedGlyph.metrics.left - rectBuffer) * positionedGlyph.scale - halfAdvance + builtInOffset[0];
            var y1 = (-positionedGlyph.metrics.top - rectBuffer) * positionedGlyph.scale + builtInOffset[1];
            var x2 = x1 + textureRect.w * positionedGlyph.scale / pixelRatio;
            var y2 = y1 + textureRect.h * positionedGlyph.scale / pixelRatio;
            var tl = new pointGeometry(x1, y1);
            var tr = new pointGeometry(x2, y1);
            var bl = new pointGeometry(x1, y2);
            var br = new pointGeometry(x2, y2);
            if (rotateVerticalGlyph) {
                var center = new pointGeometry(-halfAdvance, halfAdvance - SHAPING_DEFAULT_OFFSET);
                var verticalRotation = -Math.PI / 2;
                var xHalfWidthOffsetCorrection = ONE_EM / 2 - halfAdvance;
                var yImageOffsetCorrection = positionedGlyph.imageName ? xHalfWidthOffsetCorrection : 0;
                var halfWidthOffsetCorrection = new pointGeometry(5 - SHAPING_DEFAULT_OFFSET - xHalfWidthOffsetCorrection, -yImageOffsetCorrection);
                var verticalOffsetCorrection = new (Function.prototype.bind.apply(pointGeometry, [null].concat(verticalizedLabelOffset)))();
                tl._rotateAround(verticalRotation, center)._add(halfWidthOffsetCorrection)._add(verticalOffsetCorrection);
                tr._rotateAround(verticalRotation, center)._add(halfWidthOffsetCorrection)._add(verticalOffsetCorrection);
                bl._rotateAround(verticalRotation, center)._add(halfWidthOffsetCorrection)._add(verticalOffsetCorrection);
                br._rotateAround(verticalRotation, center)._add(halfWidthOffsetCorrection)._add(verticalOffsetCorrection);
            }
            if (textRotate) {
                var sin = Math.sin(textRotate), cos = Math.cos(textRotate), matrix = [
                        cos,
                        -sin,
                        sin,
                        cos
                    ];
                tl._matMult(matrix);
                tr._matMult(matrix);
                bl._matMult(matrix);
                br._matMult(matrix);
            }
            var pixelOffsetTL = new pointGeometry(0, 0);
            var pixelOffsetBR = new pointGeometry(0, 0);
            var minFontScaleX = 0;
            var minFontScaleY = 0;
            quads.push({
                tl: tl,
                tr: tr,
                bl: bl,
                br: br,
                tex: textureRect,
                writingMode: shaping.writingMode,
                glyphOffset: glyphOffset,
                sectionIndex: positionedGlyph.sectionIndex,
                isSDF: isSDF,
                pixelOffsetTL: pixelOffsetTL,
                pixelOffsetBR: pixelOffsetBR,
                minFontScaleX: minFontScaleX,
                minFontScaleY: minFontScaleY
            });
        }
    }
    return quads;
}

var CollisionFeature = function CollisionFeature(collisionBoxArray, anchor, featureIndex, sourceLayerIndex, bucketIndex, shaped, boxScale, padding, alignLine, rotate) {
    this.boxStartIndex = collisionBoxArray.length;
    if (alignLine) {
        var top = shaped.top;
        var bottom = shaped.bottom;
        var collisionPadding = shaped.collisionPadding;
        if (collisionPadding) {
            top -= collisionPadding[1];
            bottom += collisionPadding[3];
        }
        var height = bottom - top;
        if (height > 0) {
            height = Math.max(10, height);
            this.circleDiameter = height;
        }
    } else {
        var y1 = shaped.top * boxScale - padding;
        var y2 = shaped.bottom * boxScale + padding;
        var x1 = shaped.left * boxScale - padding;
        var x2 = shaped.right * boxScale + padding;
        var collisionPadding$1 = shaped.collisionPadding;
        if (collisionPadding$1) {
            x1 -= collisionPadding$1[0] * boxScale;
            y1 -= collisionPadding$1[1] * boxScale;
            x2 += collisionPadding$1[2] * boxScale;
            y2 += collisionPadding$1[3] * boxScale;
        }
        if (rotate) {
            var tl = new pointGeometry(x1, y1);
            var tr = new pointGeometry(x2, y1);
            var bl = new pointGeometry(x1, y2);
            var br = new pointGeometry(x2, y2);
            var rotateRadians = rotate * Math.PI / 180;
            tl._rotate(rotateRadians);
            tr._rotate(rotateRadians);
            bl._rotate(rotateRadians);
            br._rotate(rotateRadians);
            x1 = Math.min(tl.x, tr.x, bl.x, br.x);
            x2 = Math.max(tl.x, tr.x, bl.x, br.x);
            y1 = Math.min(tl.y, tr.y, bl.y, br.y);
            y2 = Math.max(tl.y, tr.y, bl.y, br.y);
        }
        collisionBoxArray.emplaceBack(anchor.x, anchor.y, x1, y1, x2, y2, featureIndex, sourceLayerIndex, bucketIndex);
    }
    this.boxEndIndex = collisionBoxArray.length;
};

var TinyQueue = function TinyQueue(data, compare) {
    if (data === void 0)
        data = [];
    if (compare === void 0)
        compare = defaultCompare$1;
    this.data = data;
    this.length = this.data.length;
    this.compare = compare;
    if (this.length > 0) {
        for (var i = (this.length >> 1) - 1; i >= 0; i--) {
            this._down(i);
        }
    }
};
TinyQueue.prototype.push = function push(item) {
    this.data.push(item);
    this.length++;
    this._up(this.length - 1);
};
TinyQueue.prototype.pop = function pop() {
    if (this.length === 0) {
        return undefined;
    }
    var top = this.data[0];
    var bottom = this.data.pop();
    this.length--;
    if (this.length > 0) {
        this.data[0] = bottom;
        this._down(0);
    }
    return top;
};
TinyQueue.prototype.peek = function peek() {
    return this.data[0];
};
TinyQueue.prototype._up = function _up(pos) {
    var ref = this;
    var data = ref.data;
    var compare = ref.compare;
    var item = data[pos];
    while (pos > 0) {
        var parent = pos - 1 >> 1;
        var current = data[parent];
        if (compare(item, current) >= 0) {
            break;
        }
        data[pos] = current;
        pos = parent;
    }
    data[pos] = item;
};
TinyQueue.prototype._down = function _down(pos) {
    var ref = this;
    var data = ref.data;
    var compare = ref.compare;
    var halfLength = this.length >> 1;
    var item = data[pos];
    while (pos < halfLength) {
        var left = (pos << 1) + 1;
        var best = data[left];
        var right = left + 1;
        if (right < this.length && compare(data[right], best) < 0) {
            left = right;
            best = data[right];
        }
        if (compare(best, item) >= 0) {
            break;
        }
        data[pos] = best;
        pos = left;
    }
    data[pos] = item;
};
function defaultCompare$1(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
}

function findPoleOfInaccessibility (polygonRings, precision, debug) {
    if (precision === void 0)
        precision = 1;
    if (debug === void 0)
        debug = false;
    var minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
    var outerRing = polygonRings[0];
    for (var i = 0; i < outerRing.length; i++) {
        var p = outerRing[i];
        if (!i || p.x < minX) {
            minX = p.x;
        }
        if (!i || p.y < minY) {
            minY = p.y;
        }
        if (!i || p.x > maxX) {
            maxX = p.x;
        }
        if (!i || p.y > maxY) {
            maxY = p.y;
        }
    }
    var width = maxX - minX;
    var height = maxY - minY;
    var cellSize = Math.min(width, height);
    var h = cellSize / 2;
    var cellQueue = new TinyQueue([], compareMax);
    if (cellSize === 0) {
        return new pointGeometry(minX, minY);
    }
    for (var x = minX; x < maxX; x += cellSize) {
        for (var y = minY; y < maxY; y += cellSize) {
            cellQueue.push(new Cell(x + h, y + h, h, polygonRings));
        }
    }
    var bestCell = getCentroidCell(polygonRings);
    var numProbes = cellQueue.length;
    while (cellQueue.length) {
        var cell = cellQueue.pop();
        if (cell.d > bestCell.d || !bestCell.d) {
            bestCell = cell;
            if (debug) {
                console.log('found best %d after %d probes', Math.round(10000 * cell.d) / 10000, numProbes);
            }
        }
        if (cell.max - bestCell.d <= precision) {
            continue;
        }
        h = cell.h / 2;
        cellQueue.push(new Cell(cell.p.x - h, cell.p.y - h, h, polygonRings));
        cellQueue.push(new Cell(cell.p.x + h, cell.p.y - h, h, polygonRings));
        cellQueue.push(new Cell(cell.p.x - h, cell.p.y + h, h, polygonRings));
        cellQueue.push(new Cell(cell.p.x + h, cell.p.y + h, h, polygonRings));
        numProbes += 4;
    }
    if (debug) {
        console.log('num probes: ' + numProbes);
        console.log('best distance: ' + bestCell.d);
    }
    return bestCell.p;
}
function compareMax(a, b) {
    return b.max - a.max;
}
function Cell(x, y, h, polygon) {
    this.p = new pointGeometry(x, y);
    this.h = h;
    this.d = pointToPolygonDist(this.p, polygon);
    this.max = this.d + this.h * Math.SQRT2;
}
function pointToPolygonDist(p, polygon) {
    var inside = false;
    var minDistSq = Infinity;
    for (var k = 0; k < polygon.length; k++) {
        var ring = polygon[k];
        for (var i = 0, len = ring.length, j = len - 1; i < len; j = i++) {
            var a = ring[i];
            var b = ring[j];
            if (a.y > p.y !== b.y > p.y && p.x < (b.x - a.x) * (p.y - a.y) / (b.y - a.y) + a.x) {
                inside = !inside;
            }
            minDistSq = Math.min(minDistSq, distToSegmentSquared(p, a, b));
        }
    }
    return (inside ? 1 : -1) * Math.sqrt(minDistSq);
}
function getCentroidCell(polygon) {
    var area = 0;
    var x = 0;
    var y = 0;
    var points = polygon[0];
    for (var i = 0, len = points.length, j = len - 1; i < len; j = i++) {
        var a = points[i];
        var b = points[j];
        var f = a.x * b.y - b.x * a.y;
        x += (a.x + b.x) * f;
        y += (a.y + b.y) * f;
        area += f * 3;
    }
    return new Cell(x / area, y / area, 0, polygon);
}

var baselineOffset = 7;
var INVALID_TEXT_OFFSET = Number.POSITIVE_INFINITY;
function evaluateVariableOffset(anchor, offset) {
    function fromRadialOffset(anchor, radialOffset) {
        var x = 0, y = 0;
        if (radialOffset < 0) {
            radialOffset = 0;
        }
        var hypotenuse = radialOffset / Math.sqrt(2);
        switch (anchor) {
        case 'top-right':
        case 'top-left':
            y = hypotenuse - baselineOffset;
            break;
        case 'bottom-right':
        case 'bottom-left':
            y = -hypotenuse + baselineOffset;
            break;
        case 'bottom':
            y = -radialOffset + baselineOffset;
            break;
        case 'top':
            y = radialOffset - baselineOffset;
            break;
        }
        switch (anchor) {
        case 'top-right':
        case 'bottom-right':
            x = -hypotenuse;
            break;
        case 'top-left':
        case 'bottom-left':
            x = hypotenuse;
            break;
        case 'left':
            x = radialOffset;
            break;
        case 'right':
            x = -radialOffset;
            break;
        }
        return [
            x,
            y
        ];
    }
    function fromTextOffset(anchor, offsetX, offsetY) {
        var x = 0, y = 0;
        offsetX = Math.abs(offsetX);
        offsetY = Math.abs(offsetY);
        switch (anchor) {
        case 'top-right':
        case 'top-left':
        case 'top':
            y = offsetY - baselineOffset;
            break;
        case 'bottom-right':
        case 'bottom-left':
        case 'bottom':
            y = -offsetY + baselineOffset;
            break;
        }
        switch (anchor) {
        case 'top-right':
        case 'bottom-right':
        case 'right':
            x = -offsetX;
            break;
        case 'top-left':
        case 'bottom-left':
        case 'left':
            x = offsetX;
            break;
        }
        return [
            x,
            y
        ];
    }
    return offset[1] !== INVALID_TEXT_OFFSET ? fromTextOffset(anchor, offset[0], offset[1]) : fromRadialOffset(anchor, offset[0]);
}
function performSymbolLayout(bucket, glyphMap, glyphPositions, imageMap, imagePositions, showCollisionBoxes, canonical) {
    bucket.createArrays();
    var tileSize = 512 * bucket.overscaling;
    bucket.tilePixelRatio = EXTENT$1 / tileSize;
    bucket.compareText = {};
    bucket.iconsNeedLinear = false;
    var layout = bucket.layers[0].layout;
    var unevaluatedLayoutValues = bucket.layers[0]._unevaluatedLayout._values;
    var sizes = {};
    if (bucket.textSizeData.kind === 'composite') {
        var ref = bucket.textSizeData;
        var minZoom = ref.minZoom;
        var maxZoom = ref.maxZoom;
        sizes.compositeTextSizes = [
            unevaluatedLayoutValues['text-size'].possiblyEvaluate(new EvaluationParameters(minZoom), canonical),
            unevaluatedLayoutValues['text-size'].possiblyEvaluate(new EvaluationParameters(maxZoom), canonical)
        ];
    }
    if (bucket.iconSizeData.kind === 'composite') {
        var ref$1 = bucket.iconSizeData;
        var minZoom$1 = ref$1.minZoom;
        var maxZoom$1 = ref$1.maxZoom;
        sizes.compositeIconSizes = [
            unevaluatedLayoutValues['icon-size'].possiblyEvaluate(new EvaluationParameters(minZoom$1), canonical),
            unevaluatedLayoutValues['icon-size'].possiblyEvaluate(new EvaluationParameters(maxZoom$1), canonical)
        ];
    }
    sizes.layoutTextSize = unevaluatedLayoutValues['text-size'].possiblyEvaluate(new EvaluationParameters(bucket.zoom + 1), canonical);
    sizes.layoutIconSize = unevaluatedLayoutValues['icon-size'].possiblyEvaluate(new EvaluationParameters(bucket.zoom + 1), canonical);
    sizes.textMaxSize = unevaluatedLayoutValues['text-size'].possiblyEvaluate(new EvaluationParameters(18));
    var lineHeight = layout.get('text-line-height') * ONE_EM;
    var textAlongLine = layout.get('text-rotation-alignment') === 'map' && layout.get('symbol-placement') !== 'point';
    var keepUpright = layout.get('text-keep-upright');
    var textSize = layout.get('text-size');
    var loop = function () {
        var feature = list[i$1];
        var fontstack = layout.get('text-font').evaluate(feature, {}, canonical).join(',');
        var layoutTextSizeThisZoom = textSize.evaluate(feature, {}, canonical);
        var layoutTextSize = sizes.layoutTextSize.evaluate(feature, {}, canonical);
        var layoutIconSize = sizes.layoutIconSize.evaluate(feature, {}, canonical);
        var shapedTextOrientations = {
            horizontal: {},
            vertical: undefined
        };
        var text = feature.text;
        var textOffset = [
            0,
            0
        ];
        if (text) {
            var unformattedText = text.toString();
            var spacing = layout.get('text-letter-spacing').evaluate(feature, {}, canonical) * ONE_EM;
            var spacingIfAllowed = allowsLetterSpacing(unformattedText) ? spacing : 0;
            var textAnchor = layout.get('text-anchor').evaluate(feature, {}, canonical);
            var variableTextAnchor = layout.get('text-variable-anchor');
            if (!variableTextAnchor) {
                var radialOffset = layout.get('text-radial-offset').evaluate(feature, {}, canonical);
                if (radialOffset) {
                    textOffset = evaluateVariableOffset(textAnchor, [
                        radialOffset * ONE_EM,
                        INVALID_TEXT_OFFSET
                    ]);
                } else {
                    textOffset = layout.get('text-offset').evaluate(feature, {}, canonical).map(function (t) {
                        return t * ONE_EM;
                    });
                }
            }
            var textJustify = textAlongLine ? 'center' : layout.get('text-justify').evaluate(feature, {}, canonical);
            var symbolPlacement = layout.get('symbol-placement');
            var maxWidth = symbolPlacement === 'point' ? layout.get('text-max-width').evaluate(feature, {}, canonical) * ONE_EM : 0;
            var addVerticalShapingForPointLabelIfNeeded = function () {
                if (bucket.allowVerticalPlacement && allowsVerticalWritingMode(unformattedText)) {
                    shapedTextOrientations.vertical = shapeText(text, glyphMap, glyphPositions, imagePositions, fontstack, maxWidth, lineHeight, textAnchor, 'left', spacingIfAllowed, textOffset, WritingMode.vertical, true, symbolPlacement, layoutTextSize, layoutTextSizeThisZoom);
                }
            };
            if (!textAlongLine && variableTextAnchor) {
                var justifications = textJustify === 'auto' ? variableTextAnchor.map(function (a) {
                    return getAnchorJustification(a);
                }) : [textJustify];
                var singleLine = false;
                for (var i = 0; i < justifications.length; i++) {
                    var justification = justifications[i];
                    if (shapedTextOrientations.horizontal[justification]) {
                        continue;
                    }
                    if (singleLine) {
                        shapedTextOrientations.horizontal[justification] = shapedTextOrientations.horizontal[0];
                    } else {
                        var shaping = shapeText(text, glyphMap, glyphPositions, imagePositions, fontstack, maxWidth, lineHeight, 'center', justification, spacingIfAllowed, textOffset, WritingMode.horizontal, false, symbolPlacement, layoutTextSize, layoutTextSizeThisZoom);
                        if (shaping) {
                            shapedTextOrientations.horizontal[justification] = shaping;
                            singleLine = shaping.positionedLines.length === 1;
                        }
                    }
                }
                addVerticalShapingForPointLabelIfNeeded();
            } else {
                if (textJustify === 'auto') {
                    textJustify = getAnchorJustification(textAnchor);
                }
                var shaping$1 = shapeText(text, glyphMap, glyphPositions, imagePositions, fontstack, maxWidth, lineHeight, textAnchor, textJustify, spacingIfAllowed, textOffset, WritingMode.horizontal, false, symbolPlacement, layoutTextSize, layoutTextSizeThisZoom);
                if (shaping$1) {
                    shapedTextOrientations.horizontal[textJustify] = shaping$1;
                }
                addVerticalShapingForPointLabelIfNeeded();
                if (allowsVerticalWritingMode(unformattedText) && textAlongLine && keepUpright) {
                    shapedTextOrientations.vertical = shapeText(text, glyphMap, glyphPositions, imagePositions, fontstack, maxWidth, lineHeight, textAnchor, textJustify, spacingIfAllowed, textOffset, WritingMode.vertical, false, symbolPlacement, layoutTextSize, layoutTextSizeThisZoom);
                }
            }
        }
        var shapedIcon = void 0;
        var isSDFIcon = false;
        if (feature.icon && feature.icon.name) {
            var image = imageMap[feature.icon.name];
            if (image) {
                shapedIcon = shapeIcon(imagePositions[feature.icon.name], layout.get('icon-offset').evaluate(feature, {}, canonical), layout.get('icon-anchor').evaluate(feature, {}, canonical));
                isSDFIcon = image.sdf;
                if (bucket.sdfIcons === undefined) {
                    bucket.sdfIcons = image.sdf;
                } else if (bucket.sdfIcons !== image.sdf) {
                    warnOnce('Style sheet warning: Cannot mix SDF and non-SDF icons in one buffer');
                }
                if (image.pixelRatio !== bucket.pixelRatio) {
                    bucket.iconsNeedLinear = true;
                } else if (layout.get('icon-rotate').constantOr(1) !== 0) {
                    bucket.iconsNeedLinear = true;
                }
            }
        }
        var shapedText = getDefaultHorizontalShaping(shapedTextOrientations.horizontal) || shapedTextOrientations.vertical;
        bucket.iconsInText = shapedText ? shapedText.iconsInText : false;
        if (shapedText || shapedIcon) {
            addFeature(bucket, feature, shapedTextOrientations, shapedIcon, imageMap, sizes, layoutTextSize, layoutIconSize, textOffset, isSDFIcon, canonical);
        }
    };
    for (var i$1 = 0, list = bucket.features; i$1 < list.length; i$1 += 1)
        loop();
    if (showCollisionBoxes) {
        bucket.generateCollisionDebugBuffers();
    }
}
function getAnchorJustification(anchor) {
    switch (anchor) {
    case 'right':
    case 'top-right':
    case 'bottom-right':
        return 'right';
    case 'left':
    case 'top-left':
    case 'bottom-left':
        return 'left';
    }
    return 'center';
}
function addFeature(bucket, feature, shapedTextOrientations, shapedIcon, imageMap, sizes, layoutTextSize, layoutIconSize, textOffset, isSDFIcon, canonical) {
    var textMaxSize = sizes.textMaxSize.evaluate(feature, {});
    if (textMaxSize === undefined) {
        textMaxSize = layoutTextSize;
    }
    var layout = bucket.layers[0].layout;
    var iconOffset = layout.get('icon-offset').evaluate(feature, {}, canonical);
    var defaultHorizontalShaping = getDefaultHorizontalShaping(shapedTextOrientations.horizontal);
    var glyphSize = 24, fontScale = layoutTextSize / glyphSize, textBoxScale = bucket.tilePixelRatio * fontScale, textMaxBoxScale = bucket.tilePixelRatio * textMaxSize / glyphSize, iconBoxScale = bucket.tilePixelRatio * layoutIconSize, symbolMinDistance = bucket.tilePixelRatio * layout.get('symbol-spacing'), textPadding = layout.get('text-padding') * bucket.tilePixelRatio, iconPadding = layout.get('icon-padding') * bucket.tilePixelRatio, textMaxAngle = layout.get('text-max-angle') / 180 * Math.PI, textAlongLine = layout.get('text-rotation-alignment') === 'map' && layout.get('symbol-placement') !== 'point', iconAlongLine = layout.get('icon-rotation-alignment') === 'map' && layout.get('symbol-placement') !== 'point', symbolPlacement = layout.get('symbol-placement'), textRepeatDistance = symbolMinDistance / 2;
    var iconTextFit = layout.get('icon-text-fit');
    var verticallyShapedIcon;
    if (shapedIcon && iconTextFit !== 'none') {
        if (bucket.allowVerticalPlacement && shapedTextOrientations.vertical) {
            verticallyShapedIcon = fitIconToText(shapedIcon, shapedTextOrientations.vertical, iconTextFit, layout.get('icon-text-fit-padding'), iconOffset, fontScale);
        }
        if (defaultHorizontalShaping) {
            shapedIcon = fitIconToText(shapedIcon, defaultHorizontalShaping, iconTextFit, layout.get('icon-text-fit-padding'), iconOffset, fontScale);
        }
    }
    var addSymbolAtAnchor = function (line, anchor) {
        if (anchor.x < 0 || anchor.x >= EXTENT$1 || anchor.y < 0 || anchor.y >= EXTENT$1) {
            return;
        }
        addSymbol(bucket, anchor, line, shapedTextOrientations, shapedIcon, imageMap, verticallyShapedIcon, bucket.layers[0], bucket.collisionBoxArray, feature.index, feature.sourceLayerIndex, bucket.index, textBoxScale, textPadding, textAlongLine, textOffset, iconBoxScale, iconPadding, iconAlongLine, iconOffset, feature, sizes, isSDFIcon, canonical, layoutTextSize);
    };
    if (symbolPlacement === 'line') {
        for (var i$1 = 0, list$1 = clipLine(feature.geometry, 0, 0, EXTENT$1, EXTENT$1); i$1 < list$1.length; i$1 += 1) {
            var line = list$1[i$1];
            var anchors = getAnchors(line, symbolMinDistance, textMaxAngle, shapedTextOrientations.vertical || defaultHorizontalShaping, shapedIcon, glyphSize, textMaxBoxScale, bucket.overscaling, EXTENT$1);
            for (var i = 0, list = anchors; i < list.length; i += 1) {
                var anchor = list[i];
                var shapedText = defaultHorizontalShaping;
                if (!shapedText || !anchorIsTooClose(bucket, shapedText.text, textRepeatDistance, anchor)) {
                    addSymbolAtAnchor(line, anchor);
                }
            }
        }
    } else if (symbolPlacement === 'line-center') {
        for (var i$2 = 0, list$2 = feature.geometry; i$2 < list$2.length; i$2 += 1) {
            var line$1 = list$2[i$2];
            if (line$1.length > 1) {
                var anchor$1 = getCenterAnchor(line$1, textMaxAngle, shapedTextOrientations.vertical || defaultHorizontalShaping, shapedIcon, glyphSize, textMaxBoxScale);
                if (anchor$1) {
                    addSymbolAtAnchor(line$1, anchor$1);
                }
            }
        }
    } else if (feature.type === 'Polygon') {
        for (var i$3 = 0, list$3 = classifyRings(feature.geometry, 0); i$3 < list$3.length; i$3 += 1) {
            var polygon = list$3[i$3];
            var poi = findPoleOfInaccessibility(polygon, 16);
            addSymbolAtAnchor(polygon[0], new Anchor(poi.x, poi.y, 0));
        }
    } else if (feature.type === 'LineString') {
        for (var i$4 = 0, list$4 = feature.geometry; i$4 < list$4.length; i$4 += 1) {
            var line$2 = list$4[i$4];
            addSymbolAtAnchor(line$2, new Anchor(line$2[0].x, line$2[0].y, 0));
        }
    } else if (feature.type === 'Point') {
        for (var i$6 = 0, list$6 = feature.geometry; i$6 < list$6.length; i$6 += 1) {
            var points = list$6[i$6];
            for (var i$5 = 0, list$5 = points; i$5 < list$5.length; i$5 += 1) {
                var point = list$5[i$5];
                addSymbolAtAnchor([point], new Anchor(point.x, point.y, 0));
            }
        }
    }
}
var MAX_GLYPH_ICON_SIZE = 255;
var MAX_PACKED_SIZE = MAX_GLYPH_ICON_SIZE * SIZE_PACK_FACTOR;
function addTextVertices(bucket, anchor, shapedText, imageMap, layer, textAlongLine, feature, textOffset, lineArray, writingMode, placementTypes, placedTextSymbolIndices, placedIconIndex, sizes, canonical) {
    var glyphQuads = getGlyphQuads(anchor, shapedText, textOffset, layer, textAlongLine, feature, imageMap, bucket.allowVerticalPlacement);
    var sizeData = bucket.textSizeData;
    var textSizeData = null;
    if (sizeData.kind === 'source') {
        textSizeData = [SIZE_PACK_FACTOR * layer.layout.get('text-size').evaluate(feature, {})];
        if (textSizeData[0] > MAX_PACKED_SIZE) {
            warnOnce(bucket.layerIds[0] + ': Value for "text-size" is >= ' + MAX_GLYPH_ICON_SIZE + '. Reduce your "text-size".');
        }
    } else if (sizeData.kind === 'composite') {
        textSizeData = [
            SIZE_PACK_FACTOR * sizes.compositeTextSizes[0].evaluate(feature, {}, canonical),
            SIZE_PACK_FACTOR * sizes.compositeTextSizes[1].evaluate(feature, {}, canonical)
        ];
        if (textSizeData[0] > MAX_PACKED_SIZE || textSizeData[1] > MAX_PACKED_SIZE) {
            warnOnce(bucket.layerIds[0] + ': Value for "text-size" is >= ' + MAX_GLYPH_ICON_SIZE + '. Reduce your "text-size".');
        }
    }
    bucket.addSymbols(bucket.text, glyphQuads, textSizeData, textOffset, textAlongLine, feature, writingMode, anchor, lineArray.lineStartIndex, lineArray.lineLength, placedIconIndex, canonical);
    for (var i = 0, list = placementTypes; i < list.length; i += 1) {
        var placementType = list[i];
        placedTextSymbolIndices[placementType] = bucket.text.placedSymbolArray.length - 1;
    }
    return glyphQuads.length * 4;
}
function getDefaultHorizontalShaping(horizontalShaping) {
    for (var justification in horizontalShaping) {
        return horizontalShaping[justification];
    }
    return null;
}
function addSymbol(bucket, anchor, line, shapedTextOrientations, shapedIcon, imageMap, verticallyShapedIcon, layer, collisionBoxArray, featureIndex, sourceLayerIndex, bucketIndex, textBoxScale, textPadding, textAlongLine, textOffset, iconBoxScale, iconPadding, iconAlongLine, iconOffset, feature, sizes, isSDFIcon, canonical, layoutTextSize) {
    var assign;
    var lineArray = bucket.addToLineVertexArray(anchor, line);
    var textCollisionFeature, iconCollisionFeature, verticalTextCollisionFeature, verticalIconCollisionFeature;
    var numIconVertices = 0;
    var numVerticalIconVertices = 0;
    var numHorizontalGlyphVertices = 0;
    var numVerticalGlyphVertices = 0;
    var placedIconSymbolIndex = -1;
    var verticalPlacedIconSymbolIndex = -1;
    var placedTextSymbolIndices = {};
    var key = murmurhashJs('');
    var textOffset0 = 0;
    var textOffset1 = 0;
    if (layer._unevaluatedLayout.getValue('text-radial-offset') === undefined) {
        assign = layer.layout.get('text-offset').evaluate(feature, {}, canonical).map(function (t) {
            return t * ONE_EM;
        }), textOffset0 = assign[0], textOffset1 = assign[1];
    } else {
        textOffset0 = layer.layout.get('text-radial-offset').evaluate(feature, {}, canonical) * ONE_EM;
        textOffset1 = INVALID_TEXT_OFFSET;
    }
    if (bucket.allowVerticalPlacement && shapedTextOrientations.vertical) {
        var textRotation = layer.layout.get('text-rotate').evaluate(feature, {}, canonical);
        var verticalTextRotation = textRotation + 90;
        var verticalShaping = shapedTextOrientations.vertical;
        verticalTextCollisionFeature = new CollisionFeature(collisionBoxArray, anchor, featureIndex, sourceLayerIndex, bucketIndex, verticalShaping, textBoxScale, textPadding, textAlongLine, verticalTextRotation);
        if (verticallyShapedIcon) {
            verticalIconCollisionFeature = new CollisionFeature(collisionBoxArray, anchor, featureIndex, sourceLayerIndex, bucketIndex, verticallyShapedIcon, iconBoxScale, iconPadding, textAlongLine, verticalTextRotation);
        }
    }
    if (shapedIcon) {
        var iconRotate = layer.layout.get('icon-rotate').evaluate(feature, {});
        var hasIconTextFit = layer.layout.get('icon-text-fit') !== 'none';
        var iconQuads = getIconQuads(shapedIcon, iconRotate, isSDFIcon, hasIconTextFit);
        var verticalIconQuads = verticallyShapedIcon ? getIconQuads(verticallyShapedIcon, iconRotate, isSDFIcon, hasIconTextFit) : undefined;
        iconCollisionFeature = new CollisionFeature(collisionBoxArray, anchor, featureIndex, sourceLayerIndex, bucketIndex, shapedIcon, iconBoxScale, iconPadding, false, iconRotate);
        numIconVertices = iconQuads.length * 4;
        var sizeData = bucket.iconSizeData;
        var iconSizeData = null;
        if (sizeData.kind === 'source') {
            iconSizeData = [SIZE_PACK_FACTOR * layer.layout.get('icon-size').evaluate(feature, {})];
            if (iconSizeData[0] > MAX_PACKED_SIZE) {
                warnOnce(bucket.layerIds[0] + ': Value for "icon-size" is >= ' + MAX_GLYPH_ICON_SIZE + '. Reduce your "icon-size".');
            }
        } else if (sizeData.kind === 'composite') {
            iconSizeData = [
                SIZE_PACK_FACTOR * sizes.compositeIconSizes[0].evaluate(feature, {}, canonical),
                SIZE_PACK_FACTOR * sizes.compositeIconSizes[1].evaluate(feature, {}, canonical)
            ];
            if (iconSizeData[0] > MAX_PACKED_SIZE || iconSizeData[1] > MAX_PACKED_SIZE) {
                warnOnce(bucket.layerIds[0] + ': Value for "icon-size" is >= ' + MAX_GLYPH_ICON_SIZE + '. Reduce your "icon-size".');
            }
        }
        bucket.addSymbols(bucket.icon, iconQuads, iconSizeData, iconOffset, iconAlongLine, feature, false, anchor, lineArray.lineStartIndex, lineArray.lineLength, -1, canonical);
        placedIconSymbolIndex = bucket.icon.placedSymbolArray.length - 1;
        if (verticalIconQuads) {
            numVerticalIconVertices = verticalIconQuads.length * 4;
            bucket.addSymbols(bucket.icon, verticalIconQuads, iconSizeData, iconOffset, iconAlongLine, feature, WritingMode.vertical, anchor, lineArray.lineStartIndex, lineArray.lineLength, -1, canonical);
            verticalPlacedIconSymbolIndex = bucket.icon.placedSymbolArray.length - 1;
        }
    }
    for (var justification in shapedTextOrientations.horizontal) {
        var shaping = shapedTextOrientations.horizontal[justification];
        if (!textCollisionFeature) {
            key = murmurhashJs(shaping.text);
            var textRotate = layer.layout.get('text-rotate').evaluate(feature, {}, canonical);
            textCollisionFeature = new CollisionFeature(collisionBoxArray, anchor, featureIndex, sourceLayerIndex, bucketIndex, shaping, textBoxScale, textPadding, textAlongLine, textRotate);
        }
        var singleLine = shaping.positionedLines.length === 1;
        numHorizontalGlyphVertices += addTextVertices(bucket, anchor, shaping, imageMap, layer, textAlongLine, feature, textOffset, lineArray, shapedTextOrientations.vertical ? WritingMode.horizontal : WritingMode.horizontalOnly, singleLine ? Object.keys(shapedTextOrientations.horizontal) : [justification], placedTextSymbolIndices, placedIconSymbolIndex, sizes, canonical);
        if (singleLine) {
            break;
        }
    }
    if (shapedTextOrientations.vertical) {
        numVerticalGlyphVertices += addTextVertices(bucket, anchor, shapedTextOrientations.vertical, imageMap, layer, textAlongLine, feature, textOffset, lineArray, WritingMode.vertical, ['vertical'], placedTextSymbolIndices, verticalPlacedIconSymbolIndex, sizes, canonical);
    }
    var textBoxStartIndex = textCollisionFeature ? textCollisionFeature.boxStartIndex : bucket.collisionBoxArray.length;
    var textBoxEndIndex = textCollisionFeature ? textCollisionFeature.boxEndIndex : bucket.collisionBoxArray.length;
    var verticalTextBoxStartIndex = verticalTextCollisionFeature ? verticalTextCollisionFeature.boxStartIndex : bucket.collisionBoxArray.length;
    var verticalTextBoxEndIndex = verticalTextCollisionFeature ? verticalTextCollisionFeature.boxEndIndex : bucket.collisionBoxArray.length;
    var iconBoxStartIndex = iconCollisionFeature ? iconCollisionFeature.boxStartIndex : bucket.collisionBoxArray.length;
    var iconBoxEndIndex = iconCollisionFeature ? iconCollisionFeature.boxEndIndex : bucket.collisionBoxArray.length;
    var verticalIconBoxStartIndex = verticalIconCollisionFeature ? verticalIconCollisionFeature.boxStartIndex : bucket.collisionBoxArray.length;
    var verticalIconBoxEndIndex = verticalIconCollisionFeature ? verticalIconCollisionFeature.boxEndIndex : bucket.collisionBoxArray.length;
    var collisionCircleDiameter = -1;
    var getCollisionCircleHeight = function (feature, prevHeight) {
        if (feature && feature.circleDiameter) {
            return Math.max(feature.circleDiameter, prevHeight);
        }
        return prevHeight;
    };
    collisionCircleDiameter = getCollisionCircleHeight(textCollisionFeature, collisionCircleDiameter);
    collisionCircleDiameter = getCollisionCircleHeight(verticalTextCollisionFeature, collisionCircleDiameter);
    collisionCircleDiameter = getCollisionCircleHeight(iconCollisionFeature, collisionCircleDiameter);
    collisionCircleDiameter = getCollisionCircleHeight(verticalIconCollisionFeature, collisionCircleDiameter);
    var useRuntimeCollisionCircles = collisionCircleDiameter > -1 ? 1 : 0;
    if (useRuntimeCollisionCircles) {
        collisionCircleDiameter *= layoutTextSize / ONE_EM;
    }
    if (bucket.glyphOffsetArray.length >= SymbolBucket.MAX_GLYPHS) {
        warnOnce('Too many glyphs being rendered in a tile. See https://github.com/mapbox/mapbox-gl-js/issues/2907');
    }
    if (feature.sortKey !== undefined) {
        bucket.addToSortKeyRanges(bucket.symbolInstances.length, feature.sortKey);
    }
    bucket.symbolInstances.emplaceBack(anchor.x, anchor.y, placedTextSymbolIndices.right >= 0 ? placedTextSymbolIndices.right : -1, placedTextSymbolIndices.center >= 0 ? placedTextSymbolIndices.center : -1, placedTextSymbolIndices.left >= 0 ? placedTextSymbolIndices.left : -1, placedTextSymbolIndices.vertical || -1, placedIconSymbolIndex, verticalPlacedIconSymbolIndex, key, textBoxStartIndex, textBoxEndIndex, verticalTextBoxStartIndex, verticalTextBoxEndIndex, iconBoxStartIndex, iconBoxEndIndex, verticalIconBoxStartIndex, verticalIconBoxEndIndex, featureIndex, numHorizontalGlyphVertices, numVerticalGlyphVertices, numIconVertices, numVerticalIconVertices, useRuntimeCollisionCircles, 0, textBoxScale, textOffset0, textOffset1, collisionCircleDiameter);
}
function anchorIsTooClose(bucket, text, repeatDistance, anchor) {
    var compareText = bucket.compareText;
    if (!(text in compareText)) {
        compareText[text] = [];
    } else {
        var otherAnchors = compareText[text];
        for (var k = otherAnchors.length - 1; k >= 0; k--) {
            if (anchor.dist(otherAnchors[k]) < repeatDistance) {
                return true;
            }
        }
    }
    compareText[text].push(anchor);
    return false;
}

var vectorTileFeatureTypes$2 = vectorTile.VectorTileFeature.types;
var shaderOpacityAttributes = [{
        name: 'a_fade_opacity',
        components: 1,
        type: 'Uint8',
        offset: 0
    }];
function addVertex$1(array, anchorX, anchorY, ox, oy, tx, ty, sizeVertex, isSDF, pixelOffsetX, pixelOffsetY, minFontScaleX, minFontScaleY) {
    var aSizeX = sizeVertex ? Math.min(MAX_PACKED_SIZE, Math.round(sizeVertex[0])) : 0;
    var aSizeY = sizeVertex ? Math.min(MAX_PACKED_SIZE, Math.round(sizeVertex[1])) : 0;
    array.emplaceBack(anchorX, anchorY, Math.round(ox * 32), Math.round(oy * 32), tx, ty, (aSizeX << 1) + (isSDF ? 1 : 0), aSizeY, pixelOffsetX * 16, pixelOffsetY * 16, minFontScaleX * 256, minFontScaleY * 256);
}
function addDynamicAttributes(dynamicLayoutVertexArray, p, angle) {
    dynamicLayoutVertexArray.emplaceBack(p.x, p.y, angle);
    dynamicLayoutVertexArray.emplaceBack(p.x, p.y, angle);
    dynamicLayoutVertexArray.emplaceBack(p.x, p.y, angle);
    dynamicLayoutVertexArray.emplaceBack(p.x, p.y, angle);
}
function containsRTLText(formattedText) {
    for (var i = 0, list = formattedText.sections; i < list.length; i += 1) {
        var section = list[i];
        if (stringContainsRTLText(section.text)) {
            return true;
        }
    }
    return false;
}
var SymbolBuffers = function SymbolBuffers(programConfigurations) {
    this.layoutVertexArray = new StructArrayLayout4i4ui4i24();
    this.indexArray = new StructArrayLayout3ui6();
    this.programConfigurations = programConfigurations;
    this.segments = new SegmentVector();
    this.dynamicLayoutVertexArray = new StructArrayLayout3f12();
    this.opacityVertexArray = new StructArrayLayout1ul4();
    this.placedSymbolArray = new PlacedSymbolArray();
};
SymbolBuffers.prototype.isEmpty = function isEmpty() {
    return this.layoutVertexArray.length === 0 && this.indexArray.length === 0 && this.dynamicLayoutVertexArray.length === 0 && this.opacityVertexArray.length === 0;
};
SymbolBuffers.prototype.upload = function upload(context, dynamicIndexBuffer, upload$1, update) {
    if (this.isEmpty()) {
        return;
    }
    if (upload$1) {
        this.layoutVertexBuffer = context.createVertexBuffer(this.layoutVertexArray, symbolLayoutAttributes.members);
        this.indexBuffer = context.createIndexBuffer(this.indexArray, dynamicIndexBuffer);
        this.dynamicLayoutVertexBuffer = context.createVertexBuffer(this.dynamicLayoutVertexArray, dynamicLayoutAttributes.members, true);
        this.opacityVertexBuffer = context.createVertexBuffer(this.opacityVertexArray, shaderOpacityAttributes, true);
        this.opacityVertexBuffer.itemSize = 1;
    }
    if (upload$1 || update) {
        this.programConfigurations.upload(context);
    }
};
SymbolBuffers.prototype.destroy = function destroy() {
    if (!this.layoutVertexBuffer) {
        return;
    }
    this.layoutVertexBuffer.destroy();
    this.indexBuffer.destroy();
    this.programConfigurations.destroy();
    this.segments.destroy();
    this.dynamicLayoutVertexBuffer.destroy();
    this.opacityVertexBuffer.destroy();
};
register('SymbolBuffers', SymbolBuffers);
var CollisionBuffers = function CollisionBuffers(LayoutArray, layoutAttributes, IndexArray) {
    this.layoutVertexArray = new LayoutArray();
    this.layoutAttributes = layoutAttributes;
    this.indexArray = new IndexArray();
    this.segments = new SegmentVector();
    this.collisionVertexArray = new StructArrayLayout2ub2f12();
};
CollisionBuffers.prototype.upload = function upload(context) {
    this.layoutVertexBuffer = context.createVertexBuffer(this.layoutVertexArray, this.layoutAttributes);
    this.indexBuffer = context.createIndexBuffer(this.indexArray);
    this.collisionVertexBuffer = context.createVertexBuffer(this.collisionVertexArray, collisionVertexAttributes.members, true);
};
CollisionBuffers.prototype.destroy = function destroy() {
    if (!this.layoutVertexBuffer) {
        return;
    }
    this.layoutVertexBuffer.destroy();
    this.indexBuffer.destroy();
    this.segments.destroy();
    this.collisionVertexBuffer.destroy();
};
register('CollisionBuffers', CollisionBuffers);
var SymbolBucket = function SymbolBucket(options) {
    this.collisionBoxArray = options.collisionBoxArray;
    this.zoom = options.zoom;
    this.overscaling = options.overscaling;
    this.layers = options.layers;
    this.layerIds = this.layers.map(function (layer) {
        return layer.id;
    });
    this.index = options.index;
    this.pixelRatio = options.pixelRatio;
    this.sourceLayerIndex = options.sourceLayerIndex;
    this.hasPattern = false;
    this.hasRTLText = false;
    this.sortKeyRanges = [];
    this.collisionCircleArray = [];
    this.placementInvProjMatrix = identity([]);
    this.placementViewportMatrix = identity([]);
    var layer = this.layers[0];
    var unevaluatedLayoutValues = layer._unevaluatedLayout._values;
    this.textSizeData = getSizeData(this.zoom, unevaluatedLayoutValues['text-size']);
    this.iconSizeData = getSizeData(this.zoom, unevaluatedLayoutValues['icon-size']);
    var layout = this.layers[0].layout;
    var sortKey = layout.get('symbol-sort-key');
    var zOrder = layout.get('symbol-z-order');
    this.canOverlap = layout.get('text-allow-overlap') || layout.get('icon-allow-overlap') || layout.get('text-ignore-placement') || layout.get('icon-ignore-placement');
    this.sortFeaturesByKey = zOrder !== 'viewport-y' && sortKey.constantOr(1) !== undefined;
    var zOrderByViewportY = zOrder === 'viewport-y' || zOrder === 'auto' && !this.sortFeaturesByKey;
    this.sortFeaturesByY = zOrderByViewportY && this.canOverlap;
    if (layout.get('symbol-placement') === 'point') {
        this.writingModes = layout.get('text-writing-mode').map(function (wm) {
            return WritingMode[wm];
        });
    }
    this.stateDependentLayerIds = this.layers.filter(function (l) {
        return l.isStateDependent();
    }).map(function (l) {
        return l.id;
    });
    this.sourceID = options.sourceID;
};
SymbolBucket.prototype.createArrays = function createArrays() {
    this.text = new SymbolBuffers(new ProgramConfigurationSet(this.layers, this.zoom, function (property) {
        return /^text/.test(property);
    }));
    this.icon = new SymbolBuffers(new ProgramConfigurationSet(this.layers, this.zoom, function (property) {
        return /^icon/.test(property);
    }));
    this.glyphOffsetArray = new GlyphOffsetArray();
    this.lineVertexArray = new SymbolLineVertexArray();
    this.symbolInstances = new SymbolInstanceArray();
};
SymbolBucket.prototype.calculateGlyphDependencies = function calculateGlyphDependencies(text, stack, textAlongLine, allowVerticalPlacement, doesAllowVerticalWritingMode) {
    for (var i = 0; i < text.length; i++) {
        stack[text.charCodeAt(i)] = true;
        if ((textAlongLine || allowVerticalPlacement) && doesAllowVerticalWritingMode) {
            var verticalChar = verticalizedCharacterMap[text.charAt(i)];
            if (verticalChar) {
                stack[verticalChar.charCodeAt(0)] = true;
            }
        }
    }
};
SymbolBucket.prototype.populate = function populate(features, options, canonical) {
    var layer = this.layers[0];
    var layout = layer.layout;
    var textFont = layout.get('text-font');
    var textField = layout.get('text-field');
    var iconImage = layout.get('icon-image');
    var hasText = (textField.value.kind !== 'constant' || textField.value.value instanceof Formatted && !textField.value.value.isEmpty() || textField.value.value.toString().length > 0) && (textFont.value.kind !== 'constant' || textFont.value.value.length > 0);
    var hasIcon = iconImage.value.kind !== 'constant' || !!iconImage.value.value || Object.keys(iconImage.parameters).length > 0;
    var symbolSortKey = layout.get('symbol-sort-key');
    this.features = [];
    if (!hasText && !hasIcon) {
        return;
    }
    var icons = options.iconDependencies;
    var stacks = options.glyphDependencies;
    var availableImages = options.availableImages;
    var globalProperties = new EvaluationParameters(this.zoom);
    for (var i$1 = 0, list$1 = features; i$1 < list$1.length; i$1 += 1) {
        var ref = list$1[i$1];
        var feature = ref.feature;
        var id = ref.id;
        var index = ref.index;
        var sourceLayerIndex = ref.sourceLayerIndex;
        var needGeometry = layer._featureFilter.needGeometry;
        var evaluationFeature = toEvaluationFeature(feature, needGeometry);
        if (!layer._featureFilter.filter(globalProperties, evaluationFeature, canonical)) {
            continue;
        }
        if (!needGeometry) {
            evaluationFeature.geometry = loadGeometry(feature);
        }
        var text = void 0;
        if (hasText) {
            var resolvedTokens = layer.getValueAndResolveTokens('text-field', evaluationFeature, canonical, availableImages);
            var formattedText = Formatted.factory(resolvedTokens);
            if (containsRTLText(formattedText)) {
                this.hasRTLText = true;
            }
            if (!this.hasRTLText || getRTLTextPluginStatus() === 'unavailable' || this.hasRTLText && plugin.isParsed()) {
                text = transformText$1(formattedText, layer, evaluationFeature);
            }
        }
        var icon = void 0;
        if (hasIcon) {
            var resolvedTokens$1 = layer.getValueAndResolveTokens('icon-image', evaluationFeature, canonical, availableImages);
            if (resolvedTokens$1 instanceof ResolvedImage) {
                icon = resolvedTokens$1;
            } else {
                icon = ResolvedImage.fromString(resolvedTokens$1);
            }
        }
        if (!text && !icon) {
            continue;
        }
        var sortKey = this.sortFeaturesByKey ? symbolSortKey.evaluate(evaluationFeature, {}, canonical) : undefined;
        var symbolFeature = {
            id: id,
            text: text,
            icon: icon,
            index: index,
            sourceLayerIndex: sourceLayerIndex,
            geometry: evaluationFeature.geometry,
            properties: feature.properties,
            type: vectorTileFeatureTypes$2[feature.type],
            sortKey: sortKey
        };
        this.features.push(symbolFeature);
        if (icon) {
            icons[icon.name] = true;
        }
        if (text) {
            var fontStack = textFont.evaluate(evaluationFeature, {}, canonical).join(',');
            var textAlongLine = layout.get('text-rotation-alignment') === 'map' && layout.get('symbol-placement') !== 'point';
            this.allowVerticalPlacement = this.writingModes && this.writingModes.indexOf(WritingMode.vertical) >= 0;
            for (var i = 0, list = text.sections; i < list.length; i += 1) {
                var section = list[i];
                if (!section.image) {
                    var doesAllowVerticalWritingMode = allowsVerticalWritingMode(text.toString());
                    var sectionFont = section.fontStack || fontStack;
                    var sectionStack = stacks[sectionFont] = stacks[sectionFont] || {};
                    this.calculateGlyphDependencies(section.text, sectionStack, textAlongLine, this.allowVerticalPlacement, doesAllowVerticalWritingMode);
                } else {
                    icons[section.image.name] = true;
                }
            }
        }
    }
    if (layout.get('symbol-placement') === 'line') {
        this.features = mergeLines(this.features);
    }
    if (this.sortFeaturesByKey) {
        this.features.sort(function (a, b) {
            return a.sortKey - b.sortKey;
        });
    }
};
SymbolBucket.prototype.update = function update(states, vtLayer, imagePositions) {
    if (!this.stateDependentLayers.length) {
        return;
    }
    this.text.programConfigurations.updatePaintArrays(states, vtLayer, this.layers, imagePositions);
    this.icon.programConfigurations.updatePaintArrays(states, vtLayer, this.layers, imagePositions);
};
SymbolBucket.prototype.isEmpty = function isEmpty() {
    return this.symbolInstances.length === 0 && !this.hasRTLText;
};
SymbolBucket.prototype.uploadPending = function uploadPending() {
    return !this.uploaded || this.text.programConfigurations.needsUpload || this.icon.programConfigurations.needsUpload;
};
SymbolBucket.prototype.upload = function upload(context) {
    if (!this.uploaded && this.hasDebugData()) {
        this.textCollisionBox.upload(context);
        this.iconCollisionBox.upload(context);
    }
    this.text.upload(context, this.sortFeaturesByY, !this.uploaded, this.text.programConfigurations.needsUpload);
    this.icon.upload(context, this.sortFeaturesByY, !this.uploaded, this.icon.programConfigurations.needsUpload);
    this.uploaded = true;
};
SymbolBucket.prototype.destroyDebugData = function destroyDebugData() {
    this.textCollisionBox.destroy();
    this.iconCollisionBox.destroy();
};
SymbolBucket.prototype.destroy = function destroy() {
    this.text.destroy();
    this.icon.destroy();
    if (this.hasDebugData()) {
        this.destroyDebugData();
    }
};
SymbolBucket.prototype.addToLineVertexArray = function addToLineVertexArray(anchor, line) {
    var lineStartIndex = this.lineVertexArray.length;
    if (anchor.segment !== undefined) {
        var sumForwardLength = anchor.dist(line[anchor.segment + 1]);
        var sumBackwardLength = anchor.dist(line[anchor.segment]);
        var vertices = {};
        for (var i = anchor.segment + 1; i < line.length; i++) {
            vertices[i] = {
                x: line[i].x,
                y: line[i].y,
                tileUnitDistanceFromAnchor: sumForwardLength
            };
            if (i < line.length - 1) {
                sumForwardLength += line[i + 1].dist(line[i]);
            }
        }
        for (var i$1 = anchor.segment || 0; i$1 >= 0; i$1--) {
            vertices[i$1] = {
                x: line[i$1].x,
                y: line[i$1].y,
                tileUnitDistanceFromAnchor: sumBackwardLength
            };
            if (i$1 > 0) {
                sumBackwardLength += line[i$1 - 1].dist(line[i$1]);
            }
        }
        for (var i$2 = 0; i$2 < line.length; i$2++) {
            var vertex = vertices[i$2];
            this.lineVertexArray.emplaceBack(vertex.x, vertex.y, vertex.tileUnitDistanceFromAnchor);
        }
    }
    return {
        lineStartIndex: lineStartIndex,
        lineLength: this.lineVertexArray.length - lineStartIndex
    };
};
SymbolBucket.prototype.addSymbols = function addSymbols(arrays, quads, sizeVertex, lineOffset, alongLine, feature, writingMode, labelAnchor, lineStartIndex, lineLength, associatedIconIndex, canonical) {
    var indexArray = arrays.indexArray;
    var layoutVertexArray = arrays.layoutVertexArray;
    var segment = arrays.segments.prepareSegment(4 * quads.length, layoutVertexArray, indexArray, this.canOverlap ? feature.sortKey : undefined);
    var glyphOffsetArrayStart = this.glyphOffsetArray.length;
    var vertexStartIndex = segment.vertexLength;
    var angle = this.allowVerticalPlacement && writingMode === WritingMode.vertical ? Math.PI / 2 : 0;
    var sections = feature.text && feature.text.sections;
    for (var i = 0; i < quads.length; i++) {
        var ref = quads[i];
        var tl = ref.tl;
        var tr = ref.tr;
        var bl = ref.bl;
        var br = ref.br;
        var tex = ref.tex;
        var pixelOffsetTL = ref.pixelOffsetTL;
        var pixelOffsetBR = ref.pixelOffsetBR;
        var minFontScaleX = ref.minFontScaleX;
        var minFontScaleY = ref.minFontScaleY;
        var glyphOffset = ref.glyphOffset;
        var isSDF = ref.isSDF;
        var sectionIndex = ref.sectionIndex;
        var index = segment.vertexLength;
        var y = glyphOffset[1];
        addVertex$1(layoutVertexArray, labelAnchor.x, labelAnchor.y, tl.x, y + tl.y, tex.x, tex.y, sizeVertex, isSDF, pixelOffsetTL.x, pixelOffsetTL.y, minFontScaleX, minFontScaleY);
        addVertex$1(layoutVertexArray, labelAnchor.x, labelAnchor.y, tr.x, y + tr.y, tex.x + tex.w, tex.y, sizeVertex, isSDF, pixelOffsetBR.x, pixelOffsetTL.y, minFontScaleX, minFontScaleY);
        addVertex$1(layoutVertexArray, labelAnchor.x, labelAnchor.y, bl.x, y + bl.y, tex.x, tex.y + tex.h, sizeVertex, isSDF, pixelOffsetTL.x, pixelOffsetBR.y, minFontScaleX, minFontScaleY);
        addVertex$1(layoutVertexArray, labelAnchor.x, labelAnchor.y, br.x, y + br.y, tex.x + tex.w, tex.y + tex.h, sizeVertex, isSDF, pixelOffsetBR.x, pixelOffsetBR.y, minFontScaleX, minFontScaleY);
        addDynamicAttributes(arrays.dynamicLayoutVertexArray, labelAnchor, angle);
        indexArray.emplaceBack(index, index + 1, index + 2);
        indexArray.emplaceBack(index + 1, index + 2, index + 3);
        segment.vertexLength += 4;
        segment.primitiveLength += 2;
        this.glyphOffsetArray.emplaceBack(glyphOffset[0]);
        if (i === quads.length - 1 || sectionIndex !== quads[i + 1].sectionIndex) {
            arrays.programConfigurations.populatePaintArrays(layoutVertexArray.length, feature, feature.index, {}, canonical, sections && sections[sectionIndex]);
        }
    }
    arrays.placedSymbolArray.emplaceBack(labelAnchor.x, labelAnchor.y, glyphOffsetArrayStart, this.glyphOffsetArray.length - glyphOffsetArrayStart, vertexStartIndex, lineStartIndex, lineLength, labelAnchor.segment, sizeVertex ? sizeVertex[0] : 0, sizeVertex ? sizeVertex[1] : 0, lineOffset[0], lineOffset[1], writingMode, 0, false, 0, associatedIconIndex);
};
SymbolBucket.prototype._addCollisionDebugVertex = function _addCollisionDebugVertex(layoutVertexArray, collisionVertexArray, point, anchorX, anchorY, extrude) {
    collisionVertexArray.emplaceBack(0, 0);
    return layoutVertexArray.emplaceBack(point.x, point.y, anchorX, anchorY, Math.round(extrude.x), Math.round(extrude.y));
};
SymbolBucket.prototype.addCollisionDebugVertices = function addCollisionDebugVertices(x1, y1, x2, y2, arrays, boxAnchorPoint, symbolInstance) {
    var segment = arrays.segments.prepareSegment(4, arrays.layoutVertexArray, arrays.indexArray);
    var index = segment.vertexLength;
    var layoutVertexArray = arrays.layoutVertexArray;
    var collisionVertexArray = arrays.collisionVertexArray;
    var anchorX = symbolInstance.anchorX;
    var anchorY = symbolInstance.anchorY;
    this._addCollisionDebugVertex(layoutVertexArray, collisionVertexArray, boxAnchorPoint, anchorX, anchorY, new pointGeometry(x1, y1));
    this._addCollisionDebugVertex(layoutVertexArray, collisionVertexArray, boxAnchorPoint, anchorX, anchorY, new pointGeometry(x2, y1));
    this._addCollisionDebugVertex(layoutVertexArray, collisionVertexArray, boxAnchorPoint, anchorX, anchorY, new pointGeometry(x2, y2));
    this._addCollisionDebugVertex(layoutVertexArray, collisionVertexArray, boxAnchorPoint, anchorX, anchorY, new pointGeometry(x1, y2));
    segment.vertexLength += 4;
    var indexArray = arrays.indexArray;
    indexArray.emplaceBack(index, index + 1);
    indexArray.emplaceBack(index + 1, index + 2);
    indexArray.emplaceBack(index + 2, index + 3);
    indexArray.emplaceBack(index + 3, index);
    segment.primitiveLength += 4;
};
SymbolBucket.prototype.addDebugCollisionBoxes = function addDebugCollisionBoxes(startIndex, endIndex, symbolInstance, isText) {
    for (var b = startIndex; b < endIndex; b++) {
        var box = this.collisionBoxArray.get(b);
        var x1 = box.x1;
        var y1 = box.y1;
        var x2 = box.x2;
        var y2 = box.y2;
        this.addCollisionDebugVertices(x1, y1, x2, y2, isText ? this.textCollisionBox : this.iconCollisionBox, box.anchorPoint, symbolInstance);
    }
};
SymbolBucket.prototype.generateCollisionDebugBuffers = function generateCollisionDebugBuffers() {
    if (this.hasDebugData()) {
        this.destroyDebugData();
    }
    this.textCollisionBox = new CollisionBuffers(StructArrayLayout2i2i2i12, collisionBoxLayout.members, StructArrayLayout2ui4);
    this.iconCollisionBox = new CollisionBuffers(StructArrayLayout2i2i2i12, collisionBoxLayout.members, StructArrayLayout2ui4);
    for (var i = 0; i < this.symbolInstances.length; i++) {
        var symbolInstance = this.symbolInstances.get(i);
        this.addDebugCollisionBoxes(symbolInstance.textBoxStartIndex, symbolInstance.textBoxEndIndex, symbolInstance, true);
        this.addDebugCollisionBoxes(symbolInstance.verticalTextBoxStartIndex, symbolInstance.verticalTextBoxEndIndex, symbolInstance, true);
        this.addDebugCollisionBoxes(symbolInstance.iconBoxStartIndex, symbolInstance.iconBoxEndIndex, symbolInstance, false);
        this.addDebugCollisionBoxes(symbolInstance.verticalIconBoxStartIndex, symbolInstance.verticalIconBoxEndIndex, symbolInstance, false);
    }
};
SymbolBucket.prototype._deserializeCollisionBoxesForSymbol = function _deserializeCollisionBoxesForSymbol(collisionBoxArray, textStartIndex, textEndIndex, verticalTextStartIndex, verticalTextEndIndex, iconStartIndex, iconEndIndex, verticalIconStartIndex, verticalIconEndIndex) {
    var collisionArrays = {};
    for (var k = textStartIndex; k < textEndIndex; k++) {
        var box = collisionBoxArray.get(k);
        collisionArrays.textBox = {
            x1: box.x1,
            y1: box.y1,
            x2: box.x2,
            y2: box.y2,
            anchorPointX: box.anchorPointX,
            anchorPointY: box.anchorPointY
        };
        collisionArrays.textFeatureIndex = box.featureIndex;
        break;
    }
    for (var k$1 = verticalTextStartIndex; k$1 < verticalTextEndIndex; k$1++) {
        var box$1 = collisionBoxArray.get(k$1);
        collisionArrays.verticalTextBox = {
            x1: box$1.x1,
            y1: box$1.y1,
            x2: box$1.x2,
            y2: box$1.y2,
            anchorPointX: box$1.anchorPointX,
            anchorPointY: box$1.anchorPointY
        };
        collisionArrays.verticalTextFeatureIndex = box$1.featureIndex;
        break;
    }
    for (var k$2 = iconStartIndex; k$2 < iconEndIndex; k$2++) {
        var box$2 = collisionBoxArray.get(k$2);
        collisionArrays.iconBox = {
            x1: box$2.x1,
            y1: box$2.y1,
            x2: box$2.x2,
            y2: box$2.y2,
            anchorPointX: box$2.anchorPointX,
            anchorPointY: box$2.anchorPointY
        };
        collisionArrays.iconFeatureIndex = box$2.featureIndex;
        break;
    }
    for (var k$3 = verticalIconStartIndex; k$3 < verticalIconEndIndex; k$3++) {
        var box$3 = collisionBoxArray.get(k$3);
        collisionArrays.verticalIconBox = {
            x1: box$3.x1,
            y1: box$3.y1,
            x2: box$3.x2,
            y2: box$3.y2,
            anchorPointX: box$3.anchorPointX,
            anchorPointY: box$3.anchorPointY
        };
        collisionArrays.verticalIconFeatureIndex = box$3.featureIndex;
        break;
    }
    return collisionArrays;
};
SymbolBucket.prototype.deserializeCollisionBoxes = function deserializeCollisionBoxes(collisionBoxArray) {
    this.collisionArrays = [];
    for (var i = 0; i < this.symbolInstances.length; i++) {
        var symbolInstance = this.symbolInstances.get(i);
        this.collisionArrays.push(this._deserializeCollisionBoxesForSymbol(collisionBoxArray, symbolInstance.textBoxStartIndex, symbolInstance.textBoxEndIndex, symbolInstance.verticalTextBoxStartIndex, symbolInstance.verticalTextBoxEndIndex, symbolInstance.iconBoxStartIndex, symbolInstance.iconBoxEndIndex, symbolInstance.verticalIconBoxStartIndex, symbolInstance.verticalIconBoxEndIndex));
    }
};
SymbolBucket.prototype.hasTextData = function hasTextData() {
    return this.text.segments.get().length > 0;
};
SymbolBucket.prototype.hasIconData = function hasIconData() {
    return this.icon.segments.get().length > 0;
};
SymbolBucket.prototype.hasDebugData = function hasDebugData() {
    return this.textCollisionBox && this.iconCollisionBox;
};
SymbolBucket.prototype.hasTextCollisionBoxData = function hasTextCollisionBoxData() {
    return this.hasDebugData() && this.textCollisionBox.segments.get().length > 0;
};
SymbolBucket.prototype.hasIconCollisionBoxData = function hasIconCollisionBoxData() {
    return this.hasDebugData() && this.iconCollisionBox.segments.get().length > 0;
};
SymbolBucket.prototype.addIndicesForPlacedSymbol = function addIndicesForPlacedSymbol(iconOrText, placedSymbolIndex) {
    var placedSymbol = iconOrText.placedSymbolArray.get(placedSymbolIndex);
    var endIndex = placedSymbol.vertexStartIndex + placedSymbol.numGlyphs * 4;
    for (var vertexIndex = placedSymbol.vertexStartIndex; vertexIndex < endIndex; vertexIndex += 4) {
        iconOrText.indexArray.emplaceBack(vertexIndex, vertexIndex + 1, vertexIndex + 2);
        iconOrText.indexArray.emplaceBack(vertexIndex + 1, vertexIndex + 2, vertexIndex + 3);
    }
};
SymbolBucket.prototype.getSortedSymbolIndexes = function getSortedSymbolIndexes(angle) {
    if (this.sortedAngle === angle && this.symbolInstanceIndexes !== undefined) {
        return this.symbolInstanceIndexes;
    }
    var sin = Math.sin(angle);
    var cos = Math.cos(angle);
    var rotatedYs = [];
    var featureIndexes = [];
    var result = [];
    for (var i = 0; i < this.symbolInstances.length; ++i) {
        result.push(i);
        var symbolInstance = this.symbolInstances.get(i);
        rotatedYs.push(Math.round(sin * symbolInstance.anchorX + cos * symbolInstance.anchorY) | 0);
        featureIndexes.push(symbolInstance.featureIndex);
    }
    result.sort(function (aIndex, bIndex) {
        return rotatedYs[aIndex] - rotatedYs[bIndex] || featureIndexes[bIndex] - featureIndexes[aIndex];
    });
    return result;
};
SymbolBucket.prototype.addToSortKeyRanges = function addToSortKeyRanges(symbolInstanceIndex, sortKey) {
    var last = this.sortKeyRanges[this.sortKeyRanges.length - 1];
    if (last && last.sortKey === sortKey) {
        last.symbolInstanceEnd = symbolInstanceIndex + 1;
    } else {
        this.sortKeyRanges.push({
            sortKey: sortKey,
            symbolInstanceStart: symbolInstanceIndex,
            symbolInstanceEnd: symbolInstanceIndex + 1
        });
    }
};
SymbolBucket.prototype.sortFeatures = function sortFeatures(angle) {
    var this$1 = this;
    if (!this.sortFeaturesByY) {
        return;
    }
    if (this.sortedAngle === angle) {
        return;
    }
    if (this.text.segments.get().length > 1 || this.icon.segments.get().length > 1) {
        return;
    }
    this.symbolInstanceIndexes = this.getSortedSymbolIndexes(angle);
    this.sortedAngle = angle;
    this.text.indexArray.clear();
    this.icon.indexArray.clear();
    this.featureSortOrder = [];
    for (var i$1 = 0, list = this.symbolInstanceIndexes; i$1 < list.length; i$1 += 1) {
        var i = list[i$1];
        var symbolInstance = this.symbolInstances.get(i);
        this.featureSortOrder.push(symbolInstance.featureIndex);
        [
            symbolInstance.rightJustifiedTextSymbolIndex,
            symbolInstance.centerJustifiedTextSymbolIndex,
            symbolInstance.leftJustifiedTextSymbolIndex
        ].forEach(function (index, i, array) {
            if (index >= 0 && array.indexOf(index) === i) {
                this$1.addIndicesForPlacedSymbol(this$1.text, index);
            }
        });
        if (symbolInstance.verticalPlacedTextSymbolIndex >= 0) {
            this.addIndicesForPlacedSymbol(this.text, symbolInstance.verticalPlacedTextSymbolIndex);
        }
        if (symbolInstance.placedIconSymbolIndex >= 0) {
            this.addIndicesForPlacedSymbol(this.icon, symbolInstance.placedIconSymbolIndex);
        }
        if (symbolInstance.verticalPlacedIconSymbolIndex >= 0) {
            this.addIndicesForPlacedSymbol(this.icon, symbolInstance.verticalPlacedIconSymbolIndex);
        }
    }
    if (this.text.indexBuffer) {
        this.text.indexBuffer.updateData(this.text.indexArray);
    }
    if (this.icon.indexBuffer) {
        this.icon.indexBuffer.updateData(this.icon.indexArray);
    }
};
register('SymbolBucket', SymbolBucket, {
    omit: [
        'layers',
        'collisionBoxArray',
        'features',
        'compareText'
    ]
});
SymbolBucket.MAX_GLYPHS = 65535;
SymbolBucket.addDynamicAttributes = addDynamicAttributes;

function resolveTokens(properties, text) {
    return text.replace(/{([^{}]+)}/g, function (match, key) {
        return key in properties ? String(properties[key]) : '';
    });
}

var layout$7 = new Properties({
    'symbol-placement': new DataConstantProperty(spec['layout_symbol']['symbol-placement']),
    'symbol-spacing': new DataConstantProperty(spec['layout_symbol']['symbol-spacing']),
    'symbol-avoid-edges': new DataConstantProperty(spec['layout_symbol']['symbol-avoid-edges']),
    'symbol-sort-key': new DataDrivenProperty(spec['layout_symbol']['symbol-sort-key']),
    'symbol-z-order': new DataConstantProperty(spec['layout_symbol']['symbol-z-order']),
    'icon-allow-overlap': new DataConstantProperty(spec['layout_symbol']['icon-allow-overlap']),
    'icon-ignore-placement': new DataConstantProperty(spec['layout_symbol']['icon-ignore-placement']),
    'icon-optional': new DataConstantProperty(spec['layout_symbol']['icon-optional']),
    'icon-rotation-alignment': new DataConstantProperty(spec['layout_symbol']['icon-rotation-alignment']),
    'icon-size': new DataDrivenProperty(spec['layout_symbol']['icon-size']),
    'icon-text-fit': new DataConstantProperty(spec['layout_symbol']['icon-text-fit']),
    'icon-text-fit-padding': new DataConstantProperty(spec['layout_symbol']['icon-text-fit-padding']),
    'icon-image': new DataDrivenProperty(spec['layout_symbol']['icon-image']),
    'icon-rotate': new DataDrivenProperty(spec['layout_symbol']['icon-rotate']),
    'icon-padding': new DataConstantProperty(spec['layout_symbol']['icon-padding']),
    'icon-keep-upright': new DataConstantProperty(spec['layout_symbol']['icon-keep-upright']),
    'icon-offset': new DataDrivenProperty(spec['layout_symbol']['icon-offset']),
    'icon-anchor': new DataDrivenProperty(spec['layout_symbol']['icon-anchor']),
    'icon-pitch-alignment': new DataConstantProperty(spec['layout_symbol']['icon-pitch-alignment']),
    'text-pitch-alignment': new DataConstantProperty(spec['layout_symbol']['text-pitch-alignment']),
    'text-rotation-alignment': new DataConstantProperty(spec['layout_symbol']['text-rotation-alignment']),
    'text-field': new DataDrivenProperty(spec['layout_symbol']['text-field']),
    'text-font': new DataDrivenProperty(spec['layout_symbol']['text-font']),
    'text-size': new DataDrivenProperty(spec['layout_symbol']['text-size']),
    'text-max-width': new DataDrivenProperty(spec['layout_symbol']['text-max-width']),
    'text-line-height': new DataConstantProperty(spec['layout_symbol']['text-line-height']),
    'text-letter-spacing': new DataDrivenProperty(spec['layout_symbol']['text-letter-spacing']),
    'text-justify': new DataDrivenProperty(spec['layout_symbol']['text-justify']),
    'text-radial-offset': new DataDrivenProperty(spec['layout_symbol']['text-radial-offset']),
    'text-variable-anchor': new DataConstantProperty(spec['layout_symbol']['text-variable-anchor']),
    'text-anchor': new DataDrivenProperty(spec['layout_symbol']['text-anchor']),
    'text-max-angle': new DataConstantProperty(spec['layout_symbol']['text-max-angle']),
    'text-writing-mode': new DataConstantProperty(spec['layout_symbol']['text-writing-mode']),
    'text-rotate': new DataDrivenProperty(spec['layout_symbol']['text-rotate']),
    'text-padding': new DataConstantProperty(spec['layout_symbol']['text-padding']),
    'text-keep-upright': new DataConstantProperty(spec['layout_symbol']['text-keep-upright']),
    'text-transform': new DataDrivenProperty(spec['layout_symbol']['text-transform']),
    'text-offset': new DataDrivenProperty(spec['layout_symbol']['text-offset']),
    'text-allow-overlap': new DataConstantProperty(spec['layout_symbol']['text-allow-overlap']),
    'text-ignore-placement': new DataConstantProperty(spec['layout_symbol']['text-ignore-placement']),
    'text-optional': new DataConstantProperty(spec['layout_symbol']['text-optional'])
});
var paint$7 = new Properties({
    'icon-opacity': new DataDrivenProperty(spec['paint_symbol']['icon-opacity']),
    'icon-color': new DataDrivenProperty(spec['paint_symbol']['icon-color']),
    'icon-halo-color': new DataDrivenProperty(spec['paint_symbol']['icon-halo-color']),
    'icon-halo-width': new DataDrivenProperty(spec['paint_symbol']['icon-halo-width']),
    'icon-halo-blur': new DataDrivenProperty(spec['paint_symbol']['icon-halo-blur']),
    'icon-translate': new DataConstantProperty(spec['paint_symbol']['icon-translate']),
    'icon-translate-anchor': new DataConstantProperty(spec['paint_symbol']['icon-translate-anchor']),
    'text-opacity': new DataDrivenProperty(spec['paint_symbol']['text-opacity']),
    'text-color': new DataDrivenProperty(spec['paint_symbol']['text-color'], {
        runtimeType: ColorType,
        getOverride: function (o) {
            return o.textColor;
        },
        hasOverride: function (o) {
            return !!o.textColor;
        }
    }),
    'text-halo-color': new DataDrivenProperty(spec['paint_symbol']['text-halo-color']),
    'text-halo-width': new DataDrivenProperty(spec['paint_symbol']['text-halo-width']),
    'text-halo-blur': new DataDrivenProperty(spec['paint_symbol']['text-halo-blur']),
    'text-translate': new DataConstantProperty(spec['paint_symbol']['text-translate']),
    'text-translate-anchor': new DataConstantProperty(spec['paint_symbol']['text-translate-anchor'])
});
var properties$6 = {
    paint: paint$7,
    layout: layout$7
};

var FormatSectionOverride = function FormatSectionOverride(defaultValue) {
    this.type = defaultValue.property.overrides ? defaultValue.property.overrides.runtimeType : NullType;
    this.defaultValue = defaultValue;
};
FormatSectionOverride.prototype.evaluate = function evaluate(ctx) {
    if (ctx.formattedSection) {
        var overrides = this.defaultValue.property.overrides;
        if (overrides && overrides.hasOverride(ctx.formattedSection)) {
            return overrides.getOverride(ctx.formattedSection);
        }
    }
    if (ctx.feature && ctx.featureState) {
        return this.defaultValue.evaluate(ctx.feature, ctx.featureState);
    }
    return this.defaultValue.property.specification.default;
};
FormatSectionOverride.prototype.eachChild = function eachChild(fn) {
    if (!this.defaultValue.isConstant()) {
        var expr = this.defaultValue.value;
        fn(expr._styleExpression.expression);
    }
};
FormatSectionOverride.prototype.outputDefined = function outputDefined() {
    return false;
};
FormatSectionOverride.prototype.serialize = function serialize() {
    return null;
};
register('FormatSectionOverride', FormatSectionOverride, { omit: ['defaultValue'] });

var SymbolStyleLayer = function (StyleLayer) {
    function SymbolStyleLayer(layer) {
        StyleLayer.call(this, layer, properties$6);
    }
    if (StyleLayer)
        SymbolStyleLayer.__proto__ = StyleLayer;
    SymbolStyleLayer.prototype = Object.create(StyleLayer && StyleLayer.prototype);
    SymbolStyleLayer.prototype.constructor = SymbolStyleLayer;
    SymbolStyleLayer.prototype.recalculate = function recalculate(parameters, availableImages) {
        StyleLayer.prototype.recalculate.call(this, parameters, availableImages);
        if (this.layout.get('icon-rotation-alignment') === 'auto') {
            if (this.layout.get('symbol-placement') !== 'point') {
                this.layout._values['icon-rotation-alignment'] = 'map';
            } else {
                this.layout._values['icon-rotation-alignment'] = 'viewport';
            }
        }
        if (this.layout.get('text-rotation-alignment') === 'auto') {
            if (this.layout.get('symbol-placement') !== 'point') {
                this.layout._values['text-rotation-alignment'] = 'map';
            } else {
                this.layout._values['text-rotation-alignment'] = 'viewport';
            }
        }
        if (this.layout.get('text-pitch-alignment') === 'auto') {
            this.layout._values['text-pitch-alignment'] = this.layout.get('text-rotation-alignment');
        }
        if (this.layout.get('icon-pitch-alignment') === 'auto') {
            this.layout._values['icon-pitch-alignment'] = this.layout.get('icon-rotation-alignment');
        }
        if (this.layout.get('symbol-placement') === 'point') {
            var writingModes = this.layout.get('text-writing-mode');
            if (writingModes) {
                var deduped = [];
                for (var i = 0, list = writingModes; i < list.length; i += 1) {
                    var m = list[i];
                    if (deduped.indexOf(m) < 0) {
                        deduped.push(m);
                    }
                }
                this.layout._values['text-writing-mode'] = deduped;
            } else {
                this.layout._values['text-writing-mode'] = ['horizontal'];
            }
        }
        this._setPaintOverrides();
    };
    SymbolStyleLayer.prototype.getValueAndResolveTokens = function getValueAndResolveTokens(name, feature, canonical, availableImages) {
        var value = this.layout.get(name).evaluate(feature, {}, canonical, availableImages);
        var unevaluated = this._unevaluatedLayout._values[name];
        if (!unevaluated.isDataDriven() && !isExpression(unevaluated.value) && value) {
            return resolveTokens(feature.properties, value);
        }
        return value;
    };
    SymbolStyleLayer.prototype.createBucket = function createBucket(parameters) {
        return new SymbolBucket(parameters);
    };
    SymbolStyleLayer.prototype.queryRadius = function queryRadius() {
        return 0;
    };
    SymbolStyleLayer.prototype.queryIntersectsFeature = function queryIntersectsFeature() {
        return false;
    };
    SymbolStyleLayer.prototype._setPaintOverrides = function _setPaintOverrides() {
        for (var i = 0, list = properties$6.paint.overridableProperties; i < list.length; i += 1) {
            var overridable = list[i];
            if (!SymbolStyleLayer.hasPaintOverride(this.layout, overridable)) {
                continue;
            }
            var overriden = this.paint.get(overridable);
            var override = new FormatSectionOverride(overriden);
            var styleExpression = new StyleExpression(override, overriden.property.specification);
            var expression = null;
            if (overriden.value.kind === 'constant' || overriden.value.kind === 'source') {
                expression = new ZoomConstantExpression('source', styleExpression);
            } else {
                expression = new ZoomDependentExpression('composite', styleExpression, overriden.value.zoomStops, overriden.value._interpolationType);
            }
            this.paint._values[overridable] = new PossiblyEvaluatedPropertyValue(overriden.property, expression, overriden.parameters);
        }
    };
    SymbolStyleLayer.prototype._handleOverridablePaintPropertyUpdate = function _handleOverridablePaintPropertyUpdate(name, oldValue, newValue) {
        if (!this.layout || oldValue.isDataDriven() || newValue.isDataDriven()) {
            return false;
        }
        return SymbolStyleLayer.hasPaintOverride(this.layout, name);
    };
    SymbolStyleLayer.hasPaintOverride = function hasPaintOverride(layout, propertyName) {
        var textField = layout.get('text-field');
        var property = properties$6.paint.properties[propertyName];
        var hasOverrides = false;
        var checkSections = function (sections) {
            for (var i = 0, list = sections; i < list.length; i += 1) {
                var section = list[i];
                if (property.overrides && property.overrides.hasOverride(section)) {
                    hasOverrides = true;
                    return;
                }
            }
        };
        if (textField.value.kind === 'constant' && textField.value.value instanceof Formatted) {
            checkSections(textField.value.value.sections);
        } else if (textField.value.kind === 'source') {
            var checkExpression = function (expression) {
                if (hasOverrides) {
                    return;
                }
                if (expression instanceof Literal && typeOf(expression.value) === FormattedType) {
                    var formatted = expression.value;
                    checkSections(formatted.sections);
                } else if (expression instanceof FormatExpression) {
                    checkSections(expression.sections);
                } else {
                    expression.eachChild(checkExpression);
                }
            };
            var expr = textField.value;
            if (expr._styleExpression) {
                checkExpression(expr._styleExpression.expression);
            }
        }
        return hasOverrides;
    };
    return SymbolStyleLayer;
}(StyleLayer);

var paint$8 = new Properties({
    'background-color': new DataConstantProperty(spec['paint_background']['background-color']),
    'background-pattern': new CrossFadedProperty(spec['paint_background']['background-pattern']),
    'background-opacity': new DataConstantProperty(spec['paint_background']['background-opacity'])
});
var properties$7 = { paint: paint$8 };

var BackgroundStyleLayer = function (StyleLayer) {
    function BackgroundStyleLayer(layer) {
        StyleLayer.call(this, layer, properties$7);
    }
    if (StyleLayer)
        BackgroundStyleLayer.__proto__ = StyleLayer;
    BackgroundStyleLayer.prototype = Object.create(StyleLayer && StyleLayer.prototype);
    BackgroundStyleLayer.prototype.constructor = BackgroundStyleLayer;
    return BackgroundStyleLayer;
}(StyleLayer);

var paint$9 = new Properties({
    'raster-opacity': new DataConstantProperty(spec['paint_raster']['raster-opacity']),
    'raster-hue-rotate': new DataConstantProperty(spec['paint_raster']['raster-hue-rotate']),
    'raster-brightness-min': new DataConstantProperty(spec['paint_raster']['raster-brightness-min']),
    'raster-brightness-max': new DataConstantProperty(spec['paint_raster']['raster-brightness-max']),
    'raster-saturation': new DataConstantProperty(spec['paint_raster']['raster-saturation']),
    'raster-contrast': new DataConstantProperty(spec['paint_raster']['raster-contrast']),
    'raster-resampling': new DataConstantProperty(spec['paint_raster']['raster-resampling']),
    'raster-fade-duration': new DataConstantProperty(spec['paint_raster']['raster-fade-duration'])
});
var properties$8 = { paint: paint$9 };

var RasterStyleLayer = function (StyleLayer) {
    function RasterStyleLayer(layer) {
        StyleLayer.call(this, layer, properties$8);
    }
    if (StyleLayer)
        RasterStyleLayer.__proto__ = StyleLayer;
    RasterStyleLayer.prototype = Object.create(StyleLayer && StyleLayer.prototype);
    RasterStyleLayer.prototype.constructor = RasterStyleLayer;
    return RasterStyleLayer;
}(StyleLayer);

function validateCustomStyleLayer(layerObject) {
    var errors = [];
    var id = layerObject.id;
    if (id === undefined) {
        errors.push({ message: 'layers.' + id + ': missing required property "id"' });
    }
    if (layerObject.render === undefined) {
        errors.push({ message: 'layers.' + id + ': missing required method "render"' });
    }
    if (layerObject.renderingMode && layerObject.renderingMode !== '2d' && layerObject.renderingMode !== '3d') {
        errors.push({ message: 'layers.' + id + ': property "renderingMode" must be either "2d" or "3d"' });
    }
    return errors;
}
var CustomStyleLayer = function (StyleLayer) {
    function CustomStyleLayer(implementation) {
        StyleLayer.call(this, implementation, {});
        this.implementation = implementation;
    }
    if (StyleLayer)
        CustomStyleLayer.__proto__ = StyleLayer;
    CustomStyleLayer.prototype = Object.create(StyleLayer && StyleLayer.prototype);
    CustomStyleLayer.prototype.constructor = CustomStyleLayer;
    CustomStyleLayer.prototype.is3D = function is3D() {
        return this.implementation.renderingMode === '3d';
    };
    CustomStyleLayer.prototype.hasOffscreenPass = function hasOffscreenPass() {
        return this.implementation.prerender !== undefined;
    };
    CustomStyleLayer.prototype.recalculate = function recalculate() {
    };
    CustomStyleLayer.prototype.updateTransitions = function updateTransitions() {
    };
    CustomStyleLayer.prototype.hasTransition = function hasTransition() {
    };
    CustomStyleLayer.prototype.serialize = function serialize() {
    };
    CustomStyleLayer.prototype.onAdd = function onAdd(map) {
        if (this.implementation.onAdd) {
            this.implementation.onAdd(map, map.painter.context.gl);
        }
    };
    CustomStyleLayer.prototype.onRemove = function onRemove(map) {
        if (this.implementation.onRemove) {
            this.implementation.onRemove(map, map.painter.context.gl);
        }
    };
    return CustomStyleLayer;
}(StyleLayer);

var subclasses = {
    circle: CircleStyleLayer,
    heatmap: HeatmapStyleLayer,
    hillshade: HillshadeStyleLayer,
    fill: FillStyleLayer,
    'fill-extrusion': FillExtrusionStyleLayer,
    line: LineStyleLayer,
    symbol: SymbolStyleLayer,
    background: BackgroundStyleLayer,
    raster: RasterStyleLayer
};
function createStyleLayer(layer) {
    if (layer.type === 'custom') {
        return new CustomStyleLayer(layer);
    } else {
        return new subclasses[layer.type](layer);
    }
}

var HTMLImageElement = window$1.HTMLImageElement;
var HTMLCanvasElement = window$1.HTMLCanvasElement;
var HTMLVideoElement = window$1.HTMLVideoElement;
var ImageData$1 = window$1.ImageData;
var ImageBitmap$1 = window$1.ImageBitmap;
var Texture = function Texture(context, image, format, options) {
    this.context = context;
    this.format = format;
    this.texture = context.gl.createTexture();
    this.update(image, options);
};
Texture.prototype.update = function update(image, options, position) {
    var width = image.width;
    var height = image.height;
    var resize = (!this.size || this.size[0] !== width || this.size[1] !== height) && !position;
    var ref = this;
    var context = ref.context;
    var gl = context.gl;
    this.useMipmap = Boolean(options && options.useMipmap);
    gl.bindTexture(gl.TEXTURE_2D, this.texture);
    context.pixelStoreUnpackFlipY.set(false);
    context.pixelStoreUnpack.set(1);
    context.pixelStoreUnpackPremultiplyAlpha.set(this.format === gl.RGBA && (!options || options.premultiply !== false));
    if (resize) {
        this.size = [
            width,
            height
        ];
        if (image instanceof HTMLImageElement || image instanceof HTMLCanvasElement || image instanceof HTMLVideoElement || image instanceof ImageData$1 || ImageBitmap$1 && image instanceof ImageBitmap$1) {
            gl.texImage2D(gl.TEXTURE_2D, 0, this.format, this.format, gl.UNSIGNED_BYTE, image);
        } else {
            gl.texImage2D(gl.TEXTURE_2D, 0, this.format, width, height, 0, this.format, gl.UNSIGNED_BYTE, image.data);
        }
    } else {
        var ref$1 = position || {
            x: 0,
            y: 0
        };
        var x = ref$1.x;
        var y = ref$1.y;
        if (image instanceof HTMLImageElement || image instanceof HTMLCanvasElement || image instanceof HTMLVideoElement || image instanceof ImageData$1 || ImageBitmap$1 && image instanceof ImageBitmap$1) {
            gl.texSubImage2D(gl.TEXTURE_2D, 0, x, y, gl.RGBA, gl.UNSIGNED_BYTE, image);
        } else {
            gl.texSubImage2D(gl.TEXTURE_2D, 0, x, y, width, height, gl.RGBA, gl.UNSIGNED_BYTE, image.data);
        }
    }
    if (this.useMipmap && this.isSizePowerOfTwo()) {
        gl.generateMipmap(gl.TEXTURE_2D);
    }
};
Texture.prototype.bind = function bind(filter, wrap, minFilter) {
    var ref = this;
    var context = ref.context;
    var gl = context.gl;
    gl.bindTexture(gl.TEXTURE_2D, this.texture);
    if (minFilter === gl.LINEAR_MIPMAP_NEAREST && !this.isSizePowerOfTwo()) {
        minFilter = gl.LINEAR;
    }
    if (filter !== this.filter) {
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, filter);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, minFilter || filter);
        this.filter = filter;
    }
    if (wrap !== this.wrap) {
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, wrap);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, wrap);
        this.wrap = wrap;
    }
};
Texture.prototype.isSizePowerOfTwo = function isSizePowerOfTwo() {
    return this.size[0] === this.size[1] && Math.log(this.size[0]) / Math.LN2 % 1 === 0;
};
Texture.prototype.destroy = function destroy() {
    var ref = this.context;
    var gl = ref.gl;
    gl.deleteTexture(this.texture);
    this.texture = null;
};

var ThrottledInvoker = function ThrottledInvoker(callback) {
    var this$1 = this;
    this._callback = callback;
    this._triggered = false;
    if (typeof MessageChannel !== 'undefined') {
        this._channel = new MessageChannel();
        this._channel.port2.onmessage = function () {
            this$1._triggered = false;
            this$1._callback();
        };
    }
};
ThrottledInvoker.prototype.trigger = function trigger() {
    var this$1 = this;
    if (!this._triggered) {
        this._triggered = true;
        if (this._channel) {
            this._channel.port1.postMessage(true);
        } else {
            setTimeout(function () {
                this$1._triggered = false;
                this$1._callback();
            }, 0);
        }
    }
};
ThrottledInvoker.prototype.remove = function remove() {
    delete this._channel;
    this._callback = function () {
    };
};

var Actor = function Actor(target, parent, mapId) {
    this.target = target;
    this.parent = parent;
    this.mapId = mapId;
    this.callbacks = {};
    this.tasks = {};
    this.taskQueue = [];
    this.cancelCallbacks = {};
    bindAll([
        'receive',
        'process'
    ], this);
    this.invoker = new ThrottledInvoker(this.process);
    this.target.addEventListener('message', this.receive, false);
    this.globalScope = isWorker() ? target : window$1;
};
Actor.prototype.send = function send(type, data, callback, targetMapId, mustQueue) {
    var this$1 = this;
    if (mustQueue === void 0)
        mustQueue = false;
    var id = Math.round(Math.random() * 1000000000000000000).toString(36).substring(0, 10);
    if (callback) {
        this.callbacks[id] = callback;
    }
    var buffers = isSafari(this.globalScope) ? undefined : [];
    this.target.postMessage({
        id: id,
        type: type,
        hasCallback: !!callback,
        targetMapId: targetMapId,
        mustQueue: mustQueue,
        sourceMapId: this.mapId,
        data: serialize(data, buffers)
    }, buffers);
    return {
        cancel: function () {
            if (callback) {
                delete this$1.callbacks[id];
            }
            this$1.target.postMessage({
                id: id,
                type: '<cancel>',
                targetMapId: targetMapId,
                sourceMapId: this$1.mapId
            });
        }
    };
};
Actor.prototype.receive = function receive(message) {
    var data = message.data, id = data.id;
    if (!id) {
        return;
    }
    if (data.targetMapId && this.mapId !== data.targetMapId) {
        return;
    }
    if (data.type === '<cancel>') {
        delete this.tasks[id];
        var cancel = this.cancelCallbacks[id];
        delete this.cancelCallbacks[id];
        if (cancel) {
            cancel();
        }
    } else {
        if (isWorker() || data.mustQueue) {
            this.tasks[id] = data;
            this.taskQueue.push(id);
            this.invoker.trigger();
        } else {
            this.processTask(id, data);
        }
    }
};
Actor.prototype.process = function process() {
    if (!this.taskQueue.length) {
        return;
    }
    var id = this.taskQueue.shift();
    var task = this.tasks[id];
    delete this.tasks[id];
    if (this.taskQueue.length) {
        this.invoker.trigger();
    }
    if (!task) {
        return;
    }
    this.processTask(id, task);
};
Actor.prototype.processTask = function processTask(id, task) {
    var this$1 = this;
    if (task.type === '<response>') {
        var callback = this.callbacks[id];
        delete this.callbacks[id];
        if (callback) {
            if (task.error) {
                callback(deserialize(task.error));
            } else {
                callback(null, deserialize(task.data));
            }
        }
    } else {
        var completed = false;
        var buffers = isSafari(this.globalScope) ? undefined : [];
        var done = task.hasCallback ? function (err, data) {
            completed = true;
            delete this$1.cancelCallbacks[id];
            this$1.target.postMessage({
                id: id,
                type: '<response>',
                sourceMapId: this$1.mapId,
                error: err ? serialize(err) : null,
                data: serialize(data, buffers)
            }, buffers);
        } : function (_) {
            completed = true;
        };
        var callback$1 = null;
        var params = deserialize(task.data);
        if (this.parent[task.type]) {
            callback$1 = this.parent[task.type](task.sourceMapId, params, done);
        } else if (this.parent.getWorkerSource) {
            var keys = task.type.split('.');
            var scope = this.parent.getWorkerSource(task.sourceMapId, keys[0], params.source);
            callback$1 = scope[keys[1]](params, done);
        } else {
            done(new Error('Could not find function ' + task.type));
        }
        if (!completed && callback$1 && callback$1.cancel) {
            this.cancelCallbacks[id] = callback$1.cancel;
        }
    }
};
Actor.prototype.remove = function remove() {
    this.invoker.remove();
    this.target.removeEventListener('message', this.receive, false);
};

/**
 * getTileBBox
 *
 * @param    {Number}  x  Tile coordinate x
 * @param    {Number}  y  Tile coordinate y
 * @param    {Number}  z  Tile zoom
 * @returns  {String}  String of the bounding box
 */
function getTileBBox(x, y, z) {
    // for Google/OSM tile scheme we need to alter the y
    y = (Math.pow(2, z) - y - 1);

    var min = getMercCoords(x * 256, y * 256, z),
        max = getMercCoords((x + 1) * 256, (y + 1) * 256, z);

    return min[0] + ',' + min[1] + ',' + max[0] + ',' + max[1];
}


/**
 * getMercCoords
 *
 * @param    {Number}  x  Pixel coordinate x
 * @param    {Number}  y  Pixel coordinate y
 * @param    {Number}  z  Tile zoom
 * @returns  {Array}   [x, y]
 */
function getMercCoords(x, y, z) {
    var resolution = (2 * Math.PI * 6378137 / 256) / Math.pow(2, z),
        merc_x = (x * resolution - 2 * Math.PI  * 6378137 / 2.0),
        merc_y = (y * resolution - 2 * Math.PI  * 6378137 / 2.0);

    return [merc_x, merc_y];
}

var LngLatBounds = function LngLatBounds(sw, ne) {
    if (!sw) ; else if (ne) {
        this.setSouthWest(sw).setNorthEast(ne);
    } else if (sw.length === 4) {
        this.setSouthWest([
            sw[0],
            sw[1]
        ]).setNorthEast([
            sw[2],
            sw[3]
        ]);
    } else {
        this.setSouthWest(sw[0]).setNorthEast(sw[1]);
    }
};
LngLatBounds.prototype.setNorthEast = function setNorthEast(ne) {
    this._ne = ne instanceof LngLat ? new LngLat(ne.lng, ne.lat) : LngLat.convert(ne);
    return this;
};
LngLatBounds.prototype.setSouthWest = function setSouthWest(sw) {
    this._sw = sw instanceof LngLat ? new LngLat(sw.lng, sw.lat) : LngLat.convert(sw);
    return this;
};
LngLatBounds.prototype.extend = function extend(obj) {
    var sw = this._sw, ne = this._ne;
    var sw2, ne2;
    if (obj instanceof LngLat) {
        sw2 = obj;
        ne2 = obj;
    } else if (obj instanceof LngLatBounds) {
        sw2 = obj._sw;
        ne2 = obj._ne;
        if (!sw2 || !ne2) {
            return this;
        }
    } else {
        if (Array.isArray(obj)) {
            if (obj.length === 4 || obj.every(Array.isArray)) {
                var lngLatBoundsObj = obj;
                return this.extend(LngLatBounds.convert(lngLatBoundsObj));
            } else {
                var lngLatObj = obj;
                return this.extend(LngLat.convert(lngLatObj));
            }
        }
        return this;
    }
    if (!sw && !ne) {
        this._sw = new LngLat(sw2.lng, sw2.lat);
        this._ne = new LngLat(ne2.lng, ne2.lat);
    } else {
        sw.lng = Math.min(sw2.lng, sw.lng);
        sw.lat = Math.min(sw2.lat, sw.lat);
        ne.lng = Math.max(ne2.lng, ne.lng);
        ne.lat = Math.max(ne2.lat, ne.lat);
    }
    return this;
};
LngLatBounds.prototype.getCenter = function getCenter() {
    return new LngLat((this._sw.lng + this._ne.lng) / 2, (this._sw.lat + this._ne.lat) / 2);
};
LngLatBounds.prototype.getSouthWest = function getSouthWest() {
    return this._sw;
};
LngLatBounds.prototype.getNorthEast = function getNorthEast() {
    return this._ne;
};
LngLatBounds.prototype.getNorthWest = function getNorthWest() {
    return new LngLat(this.getWest(), this.getNorth());
};
LngLatBounds.prototype.getSouthEast = function getSouthEast() {
    return new LngLat(this.getEast(), this.getSouth());
};
LngLatBounds.prototype.getWest = function getWest() {
    return this._sw.lng;
};
LngLatBounds.prototype.getSouth = function getSouth() {
    return this._sw.lat;
};
LngLatBounds.prototype.getEast = function getEast() {
    return this._ne.lng;
};
LngLatBounds.prototype.getNorth = function getNorth() {
    return this._ne.lat;
};
LngLatBounds.prototype.toArray = function toArray() {
    return [
        this._sw.toArray(),
        this._ne.toArray()
    ];
};
LngLatBounds.prototype.toString = function toString() {
    return 'LngLatBounds(' + this._sw.toString() + ', ' + this._ne.toString() + ')';
};
LngLatBounds.prototype.isEmpty = function isEmpty() {
    return !(this._sw && this._ne);
};
LngLatBounds.prototype.contains = function contains(lnglat) {
    var ref = LngLat.convert(lnglat);
    var lng = ref.lng;
    var lat = ref.lat;
    var containsLatitude = this._sw.lat <= lat && lat <= this._ne.lat;
    var containsLongitude = this._sw.lng <= lng && lng <= this._ne.lng;
    if (this._sw.lng > this._ne.lng) {
        containsLongitude = this._sw.lng >= lng && lng >= this._ne.lng;
    }
    return containsLatitude && containsLongitude;
};
LngLatBounds.convert = function convert(input) {
    if (!input || input instanceof LngLatBounds) {
        return input;
    }
    return new LngLatBounds(input);
};

var earthRadius = 6371008.8;
var LngLat = function LngLat(lng, lat) {
    if (isNaN(lng) || isNaN(lat)) {
        throw new Error('Invalid LngLat object: (' + lng + ', ' + lat + ')');
    }
    this.lng = +lng;
    this.lat = +lat;
    if (this.lat > 90 || this.lat < -90) {
        throw new Error('Invalid LngLat latitude value: must be between -90 and 90');
    }
};
LngLat.prototype.wrap = function wrap$1() {
    return new LngLat(wrap(this.lng, -180, 180), this.lat);
};
LngLat.prototype.toArray = function toArray() {
    return [
        this.lng,
        this.lat
    ];
};
LngLat.prototype.toString = function toString() {
    return 'LngLat(' + this.lng + ', ' + this.lat + ')';
};
LngLat.prototype.distanceTo = function distanceTo(lngLat) {
    var rad = Math.PI / 180;
    var lat1 = this.lat * rad;
    var lat2 = lngLat.lat * rad;
    var a = Math.sin(lat1) * Math.sin(lat2) + Math.cos(lat1) * Math.cos(lat2) * Math.cos((lngLat.lng - this.lng) * rad);
    var maxMeters = earthRadius * Math.acos(Math.min(a, 1));
    return maxMeters;
};
LngLat.prototype.toBounds = function toBounds(radius) {
    if (radius === void 0)
        radius = 0;
    var earthCircumferenceInMetersAtEquator = 40075017;
    var latAccuracy = 360 * radius / earthCircumferenceInMetersAtEquator, lngAccuracy = latAccuracy / Math.cos(Math.PI / 180 * this.lat);
    return new LngLatBounds(new LngLat(this.lng - lngAccuracy, this.lat - latAccuracy), new LngLat(this.lng + lngAccuracy, this.lat + latAccuracy));
};
LngLat.convert = function convert(input) {
    if (input instanceof LngLat) {
        return input;
    }
    if (Array.isArray(input) && (input.length === 2 || input.length === 3)) {
        return new LngLat(Number(input[0]), Number(input[1]));
    }
    if (!Array.isArray(input) && typeof input === 'object' && input !== null) {
        return new LngLat(Number('lng' in input ? input.lng : input.lon), Number(input.lat));
    }
    throw new Error('`LngLatLike` argument must be specified as a LngLat instance, an object {lng: <lng>, lat: <lat>}, an object {lon: <lng>, lat: <lat>}, or an array of [<lng>, <lat>]');
};

var earthCircumfrence = 2 * Math.PI * earthRadius;
function circumferenceAtLatitude(latitude) {
    return earthCircumfrence * Math.cos(latitude * Math.PI / 180);
}
function mercatorXfromLng$1(lng) {
    return (180 + lng) / 360;
}
function mercatorYfromLat$1(lat) {
    return (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + lat * Math.PI / 360))) / 360;
}
function mercatorZfromAltitude(altitude, lat) {
    return altitude / circumferenceAtLatitude(lat);
}
function lngFromMercatorX(x) {
    return x * 360 - 180;
}
function latFromMercatorY(y) {
    var y2 = 180 - y * 360;
    return 360 / Math.PI * Math.atan(Math.exp(y2 * Math.PI / 180)) - 90;
}
function altitudeFromMercatorZ(z, y) {
    return z * circumferenceAtLatitude(latFromMercatorY(y));
}
function mercatorScale(lat) {
    return 1 / Math.cos(lat * Math.PI / 180);
}
var MercatorCoordinate = function MercatorCoordinate(x, y, z) {
    if (z === void 0)
        z = 0;
    this.x = +x;
    this.y = +y;
    this.z = +z;
};
MercatorCoordinate.fromLngLat = function fromLngLat(lngLatLike, altitude) {
    if (altitude === void 0)
        altitude = 0;
    var lngLat = LngLat.convert(lngLatLike);
    return new MercatorCoordinate(mercatorXfromLng$1(lngLat.lng), mercatorYfromLat$1(lngLat.lat), mercatorZfromAltitude(altitude, lngLat.lat));
};
MercatorCoordinate.prototype.toLngLat = function toLngLat() {
    return new LngLat(lngFromMercatorX(this.x), latFromMercatorY(this.y));
};
MercatorCoordinate.prototype.toAltitude = function toAltitude() {
    return altitudeFromMercatorZ(this.z, this.y);
};
MercatorCoordinate.prototype.meterInMercatorCoordinateUnits = function meterInMercatorCoordinateUnits() {
    return 1 / earthCircumfrence * mercatorScale(latFromMercatorY(this.y));
};

var CanonicalTileID = function CanonicalTileID(z, x, y) {
    this.z = z;
    this.x = x;
    this.y = y;
    this.key = calculateKey(0, z, z, x, y);
};
CanonicalTileID.prototype.equals = function equals(id) {
    return this.z === id.z && this.x === id.x && this.y === id.y;
};
CanonicalTileID.prototype.url = function url(urls, scheme) {
    var bbox = getTileBBox(this.x, this.y, this.z);
    var quadkey = getQuadkey(this.z, this.x, this.y);
    return urls[(this.x + this.y) % urls.length].replace('{prefix}', (this.x % 16).toString(16) + (this.y % 16).toString(16)).replace('{z}', String(this.z)).replace('{x}', String(this.x)).replace('{y}', String(scheme === 'tms' ? Math.pow(2, this.z) - this.y - 1 : this.y)).replace('{quadkey}', quadkey).replace('{bbox-epsg-3857}', bbox);
};
CanonicalTileID.prototype.getTilePoint = function getTilePoint(coord) {
    var tilesAtZoom = Math.pow(2, this.z);
    return new pointGeometry((coord.x * tilesAtZoom - this.x) * EXTENT$1, (coord.y * tilesAtZoom - this.y) * EXTENT$1);
};
CanonicalTileID.prototype.toString = function toString() {
    return this.z + '/' + this.x + '/' + this.y;
};
var UnwrappedTileID = function UnwrappedTileID(wrap, canonical) {
    this.wrap = wrap;
    this.canonical = canonical;
    this.key = calculateKey(wrap, canonical.z, canonical.z, canonical.x, canonical.y);
};
var OverscaledTileID = function OverscaledTileID(overscaledZ, wrap, z, x, y) {
    this.overscaledZ = overscaledZ;
    this.wrap = wrap;
    this.canonical = new CanonicalTileID(z, +x, +y);
    this.key = calculateKey(wrap, overscaledZ, z, x, y);
};
OverscaledTileID.prototype.equals = function equals(id) {
    return this.overscaledZ === id.overscaledZ && this.wrap === id.wrap && this.canonical.equals(id.canonical);
};
OverscaledTileID.prototype.scaledTo = function scaledTo(targetZ) {
    var zDifference = this.canonical.z - targetZ;
    if (targetZ > this.canonical.z) {
        return new OverscaledTileID(targetZ, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y);
    } else {
        return new OverscaledTileID(targetZ, this.wrap, targetZ, this.canonical.x >> zDifference, this.canonical.y >> zDifference);
    }
};
OverscaledTileID.prototype.calculateScaledKey = function calculateScaledKey(targetZ, withWrap) {
    var zDifference = this.canonical.z - targetZ;
    if (targetZ > this.canonical.z) {
        return calculateKey(this.wrap * +withWrap, targetZ, this.canonical.z, this.canonical.x, this.canonical.y);
    } else {
        return calculateKey(this.wrap * +withWrap, targetZ, targetZ, this.canonical.x >> zDifference, this.canonical.y >> zDifference);
    }
};
OverscaledTileID.prototype.isChildOf = function isChildOf(parent) {
    if (parent.wrap !== this.wrap) {
        return false;
    }
    var zDifference = this.canonical.z - parent.canonical.z;
    return parent.overscaledZ === 0 || parent.overscaledZ < this.overscaledZ && parent.canonical.x === this.canonical.x >> zDifference && parent.canonical.y === this.canonical.y >> zDifference;
};
OverscaledTileID.prototype.children = function children(sourceMaxZoom) {
    if (this.overscaledZ >= sourceMaxZoom) {
        return [new OverscaledTileID(this.overscaledZ + 1, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y)];
    }
    var z = this.canonical.z + 1;
    var x = this.canonical.x * 2;
    var y = this.canonical.y * 2;
    return [
        new OverscaledTileID(z, this.wrap, z, x, y),
        new OverscaledTileID(z, this.wrap, z, x + 1, y),
        new OverscaledTileID(z, this.wrap, z, x, y + 1),
        new OverscaledTileID(z, this.wrap, z, x + 1, y + 1)
    ];
};
OverscaledTileID.prototype.isLessThan = function isLessThan(rhs) {
    if (this.wrap < rhs.wrap) {
        return true;
    }
    if (this.wrap > rhs.wrap) {
        return false;
    }
    if (this.overscaledZ < rhs.overscaledZ) {
        return true;
    }
    if (this.overscaledZ > rhs.overscaledZ) {
        return false;
    }
    if (this.canonical.x < rhs.canonical.x) {
        return true;
    }
    if (this.canonical.x > rhs.canonical.x) {
        return false;
    }
    if (this.canonical.y < rhs.canonical.y) {
        return true;
    }
    return false;
};
OverscaledTileID.prototype.wrapped = function wrapped() {
    return new OverscaledTileID(this.overscaledZ, 0, this.canonical.z, this.canonical.x, this.canonical.y);
};
OverscaledTileID.prototype.unwrapTo = function unwrapTo(wrap) {
    return new OverscaledTileID(this.overscaledZ, wrap, this.canonical.z, this.canonical.x, this.canonical.y);
};
OverscaledTileID.prototype.overscaleFactor = function overscaleFactor() {
    return Math.pow(2, this.overscaledZ - this.canonical.z);
};
OverscaledTileID.prototype.toUnwrapped = function toUnwrapped() {
    return new UnwrappedTileID(this.wrap, this.canonical);
};
OverscaledTileID.prototype.toString = function toString() {
    return this.overscaledZ + '/' + this.canonical.x + '/' + this.canonical.y;
};
OverscaledTileID.prototype.getTilePoint = function getTilePoint(coord) {
    return this.canonical.getTilePoint(new MercatorCoordinate(coord.x - this.wrap, coord.y));
};
function calculateKey(wrap, overscaledZ, z, x, y) {
    wrap *= 2;
    if (wrap < 0) {
        wrap = wrap * -1 - 1;
    }
    var dim = 1 << z;
    return (dim * dim * wrap + dim * y + x).toString(36) + z.toString(36) + overscaledZ.toString(36);
}
function getQuadkey(z, x, y) {
    var quadkey = '', mask;
    for (var i = z; i > 0; i--) {
        mask = 1 << i - 1;
        quadkey += (x & mask ? 1 : 0) + (y & mask ? 2 : 0);
    }
    return quadkey;
}
register('CanonicalTileID', CanonicalTileID);
register('OverscaledTileID', OverscaledTileID, { omit: ['posMatrix'] });

var DEMData = function DEMData(uid, data, encoding) {
    this.uid = uid;
    if (data.height !== data.width) {
        throw new RangeError('DEM tiles must be square');
    }
    if (encoding && encoding !== 'mapbox' && encoding !== 'terrarium') {
        return warnOnce('"' + encoding + '" is not a valid encoding type. Valid types include "mapbox" and "terrarium".');
    }
    this.stride = data.height;
    var dim = this.dim = data.height - 2;
    this.data = new Uint32Array(data.data.buffer);
    this.encoding = encoding || 'mapbox';
    for (var x = 0; x < dim; x++) {
        this.data[this._idx(-1, x)] = this.data[this._idx(0, x)];
        this.data[this._idx(dim, x)] = this.data[this._idx(dim - 1, x)];
        this.data[this._idx(x, -1)] = this.data[this._idx(x, 0)];
        this.data[this._idx(x, dim)] = this.data[this._idx(x, dim - 1)];
    }
    this.data[this._idx(-1, -1)] = this.data[this._idx(0, 0)];
    this.data[this._idx(dim, -1)] = this.data[this._idx(dim - 1, 0)];
    this.data[this._idx(-1, dim)] = this.data[this._idx(0, dim - 1)];
    this.data[this._idx(dim, dim)] = this.data[this._idx(dim - 1, dim - 1)];
};
DEMData.prototype.get = function get(x, y) {
    var pixels = new Uint8Array(this.data.buffer);
    var index = this._idx(x, y) * 4;
    var unpack = this.encoding === 'terrarium' ? this._unpackTerrarium : this._unpackMapbox;
    return unpack(pixels[index], pixels[index + 1], pixels[index + 2]);
};
DEMData.prototype.getUnpackVector = function getUnpackVector() {
    return this.encoding === 'terrarium' ? [
        256,
        1,
        1 / 256,
        32768
    ] : [
        6553.6,
        25.6,
        0.1,
        10000
    ];
};
DEMData.prototype._idx = function _idx(x, y) {
    if (x < -1 || x >= this.dim + 1 || y < -1 || y >= this.dim + 1) {
        throw new RangeError('out of range source coordinates for DEM data');
    }
    return (y + 1) * this.stride + (x + 1);
};
DEMData.prototype._unpackMapbox = function _unpackMapbox(r, g, b) {
    return (r * 256 * 256 + g * 256 + b) / 10 - 10000;
};
DEMData.prototype._unpackTerrarium = function _unpackTerrarium(r, g, b) {
    return r * 256 + g + b / 256 - 32768;
};
DEMData.prototype.getPixels = function getPixels() {
    return new RGBAImage({
        width: this.stride,
        height: this.stride
    }, new Uint8Array(this.data.buffer));
};
DEMData.prototype.backfillBorder = function backfillBorder(borderTile, dx, dy) {
    if (this.dim !== borderTile.dim) {
        throw new Error('dem dimension mismatch');
    }
    var xMin = dx * this.dim, xMax = dx * this.dim + this.dim, yMin = dy * this.dim, yMax = dy * this.dim + this.dim;
    switch (dx) {
    case -1:
        xMin = xMax - 1;
        break;
    case 1:
        xMax = xMin + 1;
        break;
    }
    switch (dy) {
    case -1:
        yMin = yMax - 1;
        break;
    case 1:
        yMax = yMin + 1;
        break;
    }
    var ox = -dx * this.dim;
    var oy = -dy * this.dim;
    for (var y = yMin; y < yMax; y++) {
        for (var x = xMin; x < xMax; x++) {
            this.data[this._idx(x, y)] = borderTile.data[this._idx(x + ox, y + oy)];
        }
    }
};
register('DEMData', DEMData);

function deserialize$1(input, style) {
    var output = {};
    if (!style) {
        return output;
    }
    var loop = function () {
        var bucket = list$1[i$1];
        var layers = bucket.layerIds.map(function (id) {
            return style.getLayer(id);
        }).filter(Boolean);
        if (layers.length === 0) {
            return;
        }
        bucket.layers = layers;
        if (bucket.stateDependentLayerIds) {
            bucket.stateDependentLayers = bucket.stateDependentLayerIds.map(function (lId) {
                return layers.filter(function (l) {
                    return l.id === lId;
                })[0];
            });
        }
        for (var i = 0, list = layers; i < list.length; i += 1) {
            var layer = list[i];
            output[layer.id] = bucket;
        }
    };
    for (var i$1 = 0, list$1 = input; i$1 < list$1.length; i$1 += 1)
        loop();
    return output;
}

var DictionaryCoder = function DictionaryCoder(strings) {
    this._stringToNumber = {};
    this._numberToString = [];
    for (var i = 0; i < strings.length; i++) {
        var string = strings[i];
        this._stringToNumber[string] = i;
        this._numberToString[i] = string;
    }
};
DictionaryCoder.prototype.encode = function encode(string) {
    return this._stringToNumber[string];
};
DictionaryCoder.prototype.decode = function decode(n) {
    return this._numberToString[n];
};

var Feature = function Feature(vectorTileFeature, z, x, y, id) {
    this.type = 'Feature';
    this._vectorTileFeature = vectorTileFeature;
    vectorTileFeature._z = z;
    vectorTileFeature._x = x;
    vectorTileFeature._y = y;
    this.properties = vectorTileFeature.properties;
    this.id = id;
};
var prototypeAccessors$1 = { geometry: { configurable: true } };
prototypeAccessors$1.geometry.get = function () {
    if (this._geometry === undefined) {
        this._geometry = this._vectorTileFeature.toGeoJSON(this._vectorTileFeature._x, this._vectorTileFeature._y, this._vectorTileFeature._z).geometry;
    }
    return this._geometry;
};
prototypeAccessors$1.geometry.set = function (g) {
    this._geometry = g;
};
Feature.prototype.toJSON = function toJSON() {
    var json = { geometry: this.geometry };
    for (var i in this) {
        if (i === '_geometry' || i === '_vectorTileFeature') {
            continue;
        }
        json[i] = this[i];
    }
    return json;
};
Object.defineProperties(Feature.prototype, prototypeAccessors$1);

var SourceFeatureState = function SourceFeatureState() {
    this.state = {};
    this.stateChanges = {};
    this.deletedStates = {};
};
SourceFeatureState.prototype.updateState = function updateState(sourceLayer, featureId, newState) {
    var feature = String(featureId);
    this.stateChanges[sourceLayer] = this.stateChanges[sourceLayer] || {};
    this.stateChanges[sourceLayer][feature] = this.stateChanges[sourceLayer][feature] || {};
    extend(this.stateChanges[sourceLayer][feature], newState);
    if (this.deletedStates[sourceLayer] === null) {
        this.deletedStates[sourceLayer] = {};
        for (var ft in this.state[sourceLayer]) {
            if (ft !== feature) {
                this.deletedStates[sourceLayer][ft] = null;
            }
        }
    } else {
        var featureDeletionQueued = this.deletedStates[sourceLayer] && this.deletedStates[sourceLayer][feature] === null;
        if (featureDeletionQueued) {
            this.deletedStates[sourceLayer][feature] = {};
            for (var prop in this.state[sourceLayer][feature]) {
                if (!newState[prop]) {
                    this.deletedStates[sourceLayer][feature][prop] = null;
                }
            }
        } else {
            for (var key in newState) {
                var deletionInQueue = this.deletedStates[sourceLayer] && this.deletedStates[sourceLayer][feature] && this.deletedStates[sourceLayer][feature][key] === null;
                if (deletionInQueue) {
                    delete this.deletedStates[sourceLayer][feature][key];
                }
            }
        }
    }
};
SourceFeatureState.prototype.removeFeatureState = function removeFeatureState(sourceLayer, featureId, key) {
    var sourceLayerDeleted = this.deletedStates[sourceLayer] === null;
    if (sourceLayerDeleted) {
        return;
    }
    var feature = String(featureId);
    this.deletedStates[sourceLayer] = this.deletedStates[sourceLayer] || {};
    if (key && featureId !== undefined) {
        if (this.deletedStates[sourceLayer][feature] !== null) {
            this.deletedStates[sourceLayer][feature] = this.deletedStates[sourceLayer][feature] || {};
            this.deletedStates[sourceLayer][feature][key] = null;
        }
    } else if (featureId !== undefined) {
        var updateInQueue = this.stateChanges[sourceLayer] && this.stateChanges[sourceLayer][feature];
        if (updateInQueue) {
            this.deletedStates[sourceLayer][feature] = {};
            for (key in this.stateChanges[sourceLayer][feature]) {
                this.deletedStates[sourceLayer][feature][key] = null;
            }
        } else {
            this.deletedStates[sourceLayer][feature] = null;
        }
    } else {
        this.deletedStates[sourceLayer] = null;
    }
};
SourceFeatureState.prototype.getState = function getState(sourceLayer, featureId) {
    var feature = String(featureId);
    var base = this.state[sourceLayer] || {};
    var changes = this.stateChanges[sourceLayer] || {};
    var reconciledState = extend({}, base[feature], changes[feature]);
    if (this.deletedStates[sourceLayer] === null) {
        return {};
    } else if (this.deletedStates[sourceLayer]) {
        var featureDeletions = this.deletedStates[sourceLayer][featureId];
        if (featureDeletions === null) {
            return {};
        }
        for (var prop in featureDeletions) {
            delete reconciledState[prop];
        }
    }
    return reconciledState;
};
SourceFeatureState.prototype.initializeTileState = function initializeTileState(tile, painter) {
    tile.setFeatureState(this.state, painter);
};
SourceFeatureState.prototype.coalesceChanges = function coalesceChanges(tiles, painter) {
    var featuresChanged = {};
    for (var sourceLayer in this.stateChanges) {
        this.state[sourceLayer] = this.state[sourceLayer] || {};
        var layerStates = {};
        for (var feature in this.stateChanges[sourceLayer]) {
            if (!this.state[sourceLayer][feature]) {
                this.state[sourceLayer][feature] = {};
            }
            extend(this.state[sourceLayer][feature], this.stateChanges[sourceLayer][feature]);
            layerStates[feature] = this.state[sourceLayer][feature];
        }
        featuresChanged[sourceLayer] = layerStates;
    }
    for (var sourceLayer$1 in this.deletedStates) {
        this.state[sourceLayer$1] = this.state[sourceLayer$1] || {};
        var layerStates$1 = {};
        if (this.deletedStates[sourceLayer$1] === null) {
            for (var ft in this.state[sourceLayer$1]) {
                layerStates$1[ft] = {};
                this.state[sourceLayer$1][ft] = {};
            }
        } else {
            for (var feature$1 in this.deletedStates[sourceLayer$1]) {
                var deleteWholeFeatureState = this.deletedStates[sourceLayer$1][feature$1] === null;
                if (deleteWholeFeatureState) {
                    this.state[sourceLayer$1][feature$1] = {};
                } else {
                    for (var i = 0, list = Object.keys(this.deletedStates[sourceLayer$1][feature$1]); i < list.length; i += 1) {
                        var key = list[i];
                        delete this.state[sourceLayer$1][feature$1][key];
                    }
                }
                layerStates$1[feature$1] = this.state[sourceLayer$1][feature$1];
            }
        }
        featuresChanged[sourceLayer$1] = featuresChanged[sourceLayer$1] || {};
        extend(featuresChanged[sourceLayer$1], layerStates$1);
    }
    this.stateChanges = {};
    this.deletedStates = {};
    if (Object.keys(featuresChanged).length === 0) {
        return;
    }
    for (var id in tiles) {
        var tile = tiles[id];
        tile.setFeatureState(featuresChanged, painter);
    }
};

var FeatureIndex = function FeatureIndex(tileID, promoteId) {
    this.tileID = tileID;
    this.x = tileID.canonical.x;
    this.y = tileID.canonical.y;
    this.z = tileID.canonical.z;
    this.grid = new gridIndex(EXTENT$1, 16, 0);
    this.grid3D = new gridIndex(EXTENT$1, 16, 0);
    this.featureIndexArray = new FeatureIndexArray();
    this.promoteId = promoteId;
};
FeatureIndex.prototype.insert = function insert(feature, geometry, featureIndex, sourceLayerIndex, bucketIndex, is3D) {
    var key = this.featureIndexArray.length;
    this.featureIndexArray.emplaceBack(featureIndex, sourceLayerIndex, bucketIndex);
    var grid = is3D ? this.grid3D : this.grid;
    for (var r = 0; r < geometry.length; r++) {
        var ring = geometry[r];
        var bbox = [
            Infinity,
            Infinity,
            -Infinity,
            -Infinity
        ];
        for (var i = 0; i < ring.length; i++) {
            var p = ring[i];
            bbox[0] = Math.min(bbox[0], p.x);
            bbox[1] = Math.min(bbox[1], p.y);
            bbox[2] = Math.max(bbox[2], p.x);
            bbox[3] = Math.max(bbox[3], p.y);
        }
        if (bbox[0] < EXTENT$1 && bbox[1] < EXTENT$1 && bbox[2] >= 0 && bbox[3] >= 0) {
            grid.insert(key, bbox[0], bbox[1], bbox[2], bbox[3]);
        }
    }
};
FeatureIndex.prototype.loadVTLayers = function loadVTLayers() {
    if (!this.vtLayers) {
        this.vtLayers = new vectorTile.VectorTile(new pbf(this.rawTileData)).layers;
        this.sourceLayerCoder = new DictionaryCoder(this.vtLayers ? Object.keys(this.vtLayers).sort() : ['_geojsonTileLayer']);
    }
    return this.vtLayers;
};
FeatureIndex.prototype.query = function query(args, styleLayers, serializedLayers, sourceFeatureState) {
    var this$1 = this;
    this.loadVTLayers();
    var params = args.params || {}, pixelsToTileUnits = EXTENT$1 / args.tileSize / args.scale, filter = createFilter(params.filter);
    var queryGeometry = args.queryGeometry;
    var queryPadding = args.queryPadding * pixelsToTileUnits;
    var bounds = getBounds(queryGeometry);
    var matching = this.grid.query(bounds.minX - queryPadding, bounds.minY - queryPadding, bounds.maxX + queryPadding, bounds.maxY + queryPadding);
    var cameraBounds = getBounds(args.cameraQueryGeometry);
    var matching3D = this.grid3D.query(cameraBounds.minX - queryPadding, cameraBounds.minY - queryPadding, cameraBounds.maxX + queryPadding, cameraBounds.maxY + queryPadding, function (bx1, by1, bx2, by2) {
        return polygonIntersectsBox(args.cameraQueryGeometry, bx1 - queryPadding, by1 - queryPadding, bx2 + queryPadding, by2 + queryPadding);
    });
    for (var i = 0, list = matching3D; i < list.length; i += 1) {
        var key = list[i];
        matching.push(key);
    }
    matching.sort(topDownFeatureComparator);
    var result = {};
    var previousIndex;
    var loop = function (k) {
        var index = matching[k];
        if (index === previousIndex) {
            return;
        }
        previousIndex = index;
        var match = this$1.featureIndexArray.get(index);
        var featureGeometry = null;
        this$1.loadMatchingFeature(result, match.bucketIndex, match.sourceLayerIndex, match.featureIndex, filter, params.layers, params.availableImages, styleLayers, serializedLayers, sourceFeatureState, function (feature, styleLayer, featureState) {
            if (!featureGeometry) {
                featureGeometry = loadGeometry(feature);
            }
            return styleLayer.queryIntersectsFeature(queryGeometry, feature, featureState, featureGeometry, this$1.z, args.transform, pixelsToTileUnits, args.pixelPosMatrix);
        });
    };
    for (var k = 0; k < matching.length; k++)
        loop(k);
    return result;
};
FeatureIndex.prototype.loadMatchingFeature = function loadMatchingFeature(result, bucketIndex, sourceLayerIndex, featureIndex, filter, filterLayerIDs, availableImages, styleLayers, serializedLayers, sourceFeatureState, intersectionTest) {
    var layerIDs = this.bucketLayerIDs[bucketIndex];
    if (filterLayerIDs && !arraysIntersect(filterLayerIDs, layerIDs)) {
        return;
    }
    var sourceLayerName = this.sourceLayerCoder.decode(sourceLayerIndex);
    var sourceLayer = this.vtLayers[sourceLayerName];
    var feature = sourceLayer.feature(featureIndex);
    if (filter.needGeometry) {
        var evaluationFeature = toEvaluationFeature(feature, true);
        if (!filter.filter(new EvaluationParameters(this.tileID.overscaledZ), evaluationFeature, this.tileID.canonical)) {
            return;
        }
    } else if (!filter.filter(new EvaluationParameters(this.tileID.overscaledZ), feature)) {
        return;
    }
    var id = this.getId(feature, sourceLayerName);
    for (var l = 0; l < layerIDs.length; l++) {
        var layerID = layerIDs[l];
        if (filterLayerIDs && filterLayerIDs.indexOf(layerID) < 0) {
            continue;
        }
        var styleLayer = styleLayers[layerID];
        if (!styleLayer) {
            continue;
        }
        var featureState = {};
        if (id !== undefined && sourceFeatureState) {
            featureState = sourceFeatureState.getState(styleLayer.sourceLayer || '_geojsonTileLayer', id);
        }
        var serializedLayer = extend({}, serializedLayers[layerID]);
        serializedLayer.paint = evaluateProperties(serializedLayer.paint, styleLayer.paint, feature, featureState, availableImages);
        serializedLayer.layout = evaluateProperties(serializedLayer.layout, styleLayer.layout, feature, featureState, availableImages);
        var intersectionZ = !intersectionTest || intersectionTest(feature, styleLayer, featureState);
        if (!intersectionZ) {
            continue;
        }
        var geojsonFeature = new Feature(feature, this.z, this.x, this.y, id);
        geojsonFeature.layer = serializedLayer;
        var layerResult = result[layerID];
        if (layerResult === undefined) {
            layerResult = result[layerID] = [];
        }
        layerResult.push({
            featureIndex: featureIndex,
            feature: geojsonFeature,
            intersectionZ: intersectionZ
        });
    }
};
FeatureIndex.prototype.lookupSymbolFeatures = function lookupSymbolFeatures(symbolFeatureIndexes, serializedLayers, bucketIndex, sourceLayerIndex, filterSpec, filterLayerIDs, availableImages, styleLayers) {
    var result = {};
    this.loadVTLayers();
    var filter = createFilter(filterSpec);
    for (var i = 0, list = symbolFeatureIndexes; i < list.length; i += 1) {
        var symbolFeatureIndex = list[i];
        this.loadMatchingFeature(result, bucketIndex, sourceLayerIndex, symbolFeatureIndex, filter, filterLayerIDs, availableImages, styleLayers, serializedLayers);
    }
    return result;
};
FeatureIndex.prototype.hasLayer = function hasLayer(id) {
    for (var i$1 = 0, list$1 = this.bucketLayerIDs; i$1 < list$1.length; i$1 += 1) {
        var layerIDs = list$1[i$1];
        for (var i = 0, list = layerIDs; i < list.length; i += 1) {
            var layerID = list[i];
            if (id === layerID) {
                return true;
            }
        }
    }
    return false;
};
FeatureIndex.prototype.getId = function getId(feature, sourceLayerId) {
    var id = feature.id;
    if (this.promoteId) {
        var propName = typeof this.promoteId === 'string' ? this.promoteId : this.promoteId[sourceLayerId];
        id = feature.properties[propName];
        if (typeof id === 'boolean') {
            id = Number(id);
        }
    }
    return id;
};
register('FeatureIndex', FeatureIndex, {
    omit: [
        'rawTileData',
        'sourceLayerCoder'
    ]
});
function evaluateProperties(serializedProperties, styleLayerProperties, feature, featureState, availableImages) {
    return mapObject(serializedProperties, function (property, key) {
        var prop = styleLayerProperties instanceof PossiblyEvaluated ? styleLayerProperties.get(key) : null;
        return prop && prop.evaluate ? prop.evaluate(feature, featureState, availableImages) : prop;
    });
}
function getBounds(geometry) {
    var minX = Infinity;
    var minY = Infinity;
    var maxX = -Infinity;
    var maxY = -Infinity;
    for (var i = 0, list = geometry; i < list.length; i += 1) {
        var p = list[i];
        minX = Math.min(minX, p.x);
        minY = Math.min(minY, p.y);
        maxX = Math.max(maxX, p.x);
        maxY = Math.max(maxY, p.y);
    }
    return {
        minX: minX,
        minY: minY,
        maxX: maxX,
        maxY: maxY
    };
}
function topDownFeatureComparator(a, b) {
    return b - a;
}

var CLOCK_SKEW_RETRY_TIMEOUT = 30000;
var Tile = function Tile(tileID, size) {
    this.tileID = tileID;
    this.uid = uniqueId();
    this.uses = 0;
    this.tileSize = size;
    this.buckets = {};
    this.expirationTime = null;
    this.queryPadding = 0;
    this.hasSymbolBuckets = false;
    this.hasRTLText = false;
    this.dependencies = {};
    this.expiredRequestCount = 0;
    this.state = 'loading';
};
Tile.prototype.registerFadeDuration = function registerFadeDuration(duration) {
    var fadeEndTime = duration + this.timeAdded;
    if (fadeEndTime < exported.now()) {
        return;
    }
    if (this.fadeEndTime && fadeEndTime < this.fadeEndTime) {
        return;
    }
    this.fadeEndTime = fadeEndTime;
};
Tile.prototype.wasRequested = function wasRequested() {
    return this.state === 'errored' || this.state === 'loaded' || this.state === 'reloading';
};
Tile.prototype.loadVectorData = function loadVectorData(data, painter, justReloaded) {
    if (this.hasData()) {
        this.unloadVectorData();
    }
    this.state = 'loaded';
    if (!data) {
        this.collisionBoxArray = new CollisionBoxArray();
        return;
    }
    if (data.featureIndex) {
        this.latestFeatureIndex = data.featureIndex;
        if (data.rawTileData) {
            this.latestRawTileData = data.rawTileData;
            this.latestFeatureIndex.rawTileData = data.rawTileData;
        } else if (this.latestRawTileData) {
            this.latestFeatureIndex.rawTileData = this.latestRawTileData;
        }
    }
    this.collisionBoxArray = data.collisionBoxArray;
    this.buckets = deserialize$1(data.buckets, painter.style);
    this.hasSymbolBuckets = false;
    for (var id in this.buckets) {
        var bucket = this.buckets[id];
        if (bucket instanceof SymbolBucket) {
            this.hasSymbolBuckets = true;
            if (justReloaded) {
                bucket.justReloaded = true;
            } else {
                break;
            }
        }
    }
    this.hasRTLText = false;
    if (this.hasSymbolBuckets) {
        for (var id$1 in this.buckets) {
            var bucket$1 = this.buckets[id$1];
            if (bucket$1 instanceof SymbolBucket) {
                if (bucket$1.hasRTLText) {
                    this.hasRTLText = true;
                    lazyLoadRTLTextPlugin();
                    break;
                }
            }
        }
    }
    this.queryPadding = 0;
    for (var id$2 in this.buckets) {
        var bucket$2 = this.buckets[id$2];
        this.queryPadding = Math.max(this.queryPadding, painter.style.getLayer(id$2).queryRadius(bucket$2));
    }
    if (data.imageAtlas) {
        this.imageAtlas = data.imageAtlas;
    }
    if (data.glyphAtlasImage) {
        this.glyphAtlasImage = data.glyphAtlasImage;
    }
};
Tile.prototype.unloadVectorData = function unloadVectorData() {
    for (var id in this.buckets) {
        this.buckets[id].destroy();
    }
    this.buckets = {};
    if (this.imageAtlasTexture) {
        this.imageAtlasTexture.destroy();
    }
    if (this.imageAtlas) {
        this.imageAtlas = null;
    }
    if (this.glyphAtlasTexture) {
        this.glyphAtlasTexture.destroy();
    }
    this.latestFeatureIndex = null;
    this.state = 'unloaded';
};
Tile.prototype.getBucket = function getBucket(layer) {
    return this.buckets[layer.id];
};
Tile.prototype.upload = function upload(context) {
    for (var id in this.buckets) {
        var bucket = this.buckets[id];
        if (bucket.uploadPending()) {
            bucket.upload(context);
        }
    }
    var gl = context.gl;
    if (this.imageAtlas && !this.imageAtlas.uploaded) {
        this.imageAtlasTexture = new Texture(context, this.imageAtlas.image, gl.RGBA);
        this.imageAtlas.uploaded = true;
    }
    if (this.glyphAtlasImage) {
        this.glyphAtlasTexture = new Texture(context, this.glyphAtlasImage, gl.ALPHA);
        this.glyphAtlasImage = null;
    }
};
Tile.prototype.prepare = function prepare(imageManager) {
    if (this.imageAtlas) {
        this.imageAtlas.patchUpdatedImages(imageManager, this.imageAtlasTexture);
    }
};
Tile.prototype.queryRenderedFeatures = function queryRenderedFeatures(layers, serializedLayers, sourceFeatureState, queryGeometry, cameraQueryGeometry, scale, params, transform, maxPitchScaleFactor, pixelPosMatrix) {
    if (!this.latestFeatureIndex || !this.latestFeatureIndex.rawTileData) {
        return {};
    }
    return this.latestFeatureIndex.query({
        queryGeometry: queryGeometry,
        cameraQueryGeometry: cameraQueryGeometry,
        scale: scale,
        tileSize: this.tileSize,
        pixelPosMatrix: pixelPosMatrix,
        transform: transform,
        params: params,
        queryPadding: this.queryPadding * maxPitchScaleFactor
    }, layers, serializedLayers, sourceFeatureState);
};
Tile.prototype.querySourceFeatures = function querySourceFeatures(result, params) {
    var featureIndex = this.latestFeatureIndex;
    if (!featureIndex || !featureIndex.rawTileData) {
        return;
    }
    var vtLayers = featureIndex.loadVTLayers();
    var sourceLayer = params ? params.sourceLayer : '';
    var layer = vtLayers._geojsonTileLayer || vtLayers[sourceLayer];
    if (!layer) {
        return;
    }
    var filter = createFilter(params && params.filter);
    var ref = this.tileID.canonical;
    var z = ref.z;
    var x = ref.x;
    var y = ref.y;
    var coord = {
        z: z,
        x: x,
        y: y
    };
    for (var i = 0; i < layer.length; i++) {
        var feature = layer.feature(i);
        if (filter.needGeometry) {
            var evaluationFeature = toEvaluationFeature(feature, true);
            if (!filter.filter(new EvaluationParameters(this.tileID.overscaledZ), evaluationFeature, this.tileID.canonical)) {
                continue;
            }
        } else if (!filter.filter(new EvaluationParameters(this.tileID.overscaledZ), feature)) {
            continue;
        }
        var id = featureIndex.getId(feature, sourceLayer);
        var geojsonFeature = new Feature(feature, z, x, y, id);
        geojsonFeature.tile = coord;
        result.push(geojsonFeature);
    }
};
Tile.prototype.hasData = function hasData() {
    return this.state === 'loaded' || this.state === 'reloading' || this.state === 'expired';
};
Tile.prototype.patternsLoaded = function patternsLoaded() {
    return this.imageAtlas && !!Object.keys(this.imageAtlas.patternPositions).length;
};
Tile.prototype.setExpiryData = function setExpiryData(data) {
    var prior = this.expirationTime;
    if (data.cacheControl) {
        var parsedCC = parseCacheControl(data.cacheControl);
        if (parsedCC['max-age']) {
            this.expirationTime = Date.now() + parsedCC['max-age'] * 1000;
        }
    } else if (data.expires) {
        this.expirationTime = new Date(data.expires).getTime();
    }
    if (this.expirationTime) {
        var now = Date.now();
        var isExpired = false;
        if (this.expirationTime > now) {
            isExpired = false;
        } else if (!prior) {
            isExpired = true;
        } else if (this.expirationTime < prior) {
            isExpired = true;
        } else {
            var delta = this.expirationTime - prior;
            if (!delta) {
                isExpired = true;
            } else {
                this.expirationTime = now + Math.max(delta, CLOCK_SKEW_RETRY_TIMEOUT);
            }
        }
        if (isExpired) {
            this.expiredRequestCount++;
            this.state = 'expired';
        } else {
            this.expiredRequestCount = 0;
        }
    }
};
Tile.prototype.getExpiryTimeout = function getExpiryTimeout() {
    if (this.expirationTime) {
        if (this.expiredRequestCount) {
            return 1000 * (1 << Math.min(this.expiredRequestCount - 1, 31));
        } else {
            return Math.min(this.expirationTime - new Date().getTime(), Math.pow(2, 31) - 1);
        }
    }
};
Tile.prototype.setFeatureState = function setFeatureState(states, painter) {
    if (!this.latestFeatureIndex || !this.latestFeatureIndex.rawTileData || Object.keys(states).length === 0) {
        return;
    }
    var vtLayers = this.latestFeatureIndex.loadVTLayers();
    for (var id in this.buckets) {
        if (!painter.style.hasLayer(id)) {
            continue;
        }
        var bucket = this.buckets[id];
        var sourceLayerId = bucket.layers[0]['sourceLayer'] || '_geojsonTileLayer';
        var sourceLayer = vtLayers[sourceLayerId];
        var sourceLayerStates = states[sourceLayerId];
        if (!sourceLayer || !sourceLayerStates || Object.keys(sourceLayerStates).length === 0) {
            continue;
        }
        bucket.update(sourceLayerStates, sourceLayer, this.imageAtlas && this.imageAtlas.patternPositions || {});
        var layer = painter && painter.style && painter.style.getLayer(id);
        if (layer) {
            this.queryPadding = Math.max(this.queryPadding, layer.queryRadius(bucket));
        }
    }
};
Tile.prototype.holdingForFade = function holdingForFade() {
    return this.symbolFadeHoldUntil !== undefined;
};
Tile.prototype.symbolFadeFinished = function symbolFadeFinished() {
    return !this.symbolFadeHoldUntil || this.symbolFadeHoldUntil < exported.now();
};
Tile.prototype.clearFadeHold = function clearFadeHold() {
    this.symbolFadeHoldUntil = undefined;
};
Tile.prototype.setHoldDuration = function setHoldDuration(duration) {
    this.symbolFadeHoldUntil = exported.now() + duration;
};
Tile.prototype.setDependencies = function setDependencies(namespace, dependencies) {
    var index = {};
    for (var i = 0, list = dependencies; i < list.length; i += 1) {
        var dep = list[i];
        index[dep] = true;
    }
    this.dependencies[namespace] = index;
};
Tile.prototype.hasDependency = function hasDependency(namespaces, keys) {
    for (var i$1 = 0, list$1 = namespaces; i$1 < list$1.length; i$1 += 1) {
        var namespace = list$1[i$1];
        var dependencies = this.dependencies[namespace];
        if (dependencies) {
            for (var i = 0, list = keys; i < list.length; i += 1) {
                var key = list[i];
                if (dependencies[key]) {
                    return true;
                }
            }
        }
    }
    return false;
};

var refProperties = [
    'type',
    'source',
    'source-layer',
    'minzoom',
    'maxzoom',
    'filter',
    'layout'
];

var performance = window$1.performance;
var RequestPerformance = function RequestPerformance(request) {
    this._marks = {
        start: [
            request.url,
            'start'
        ].join('#'),
        end: [
            request.url,
            'end'
        ].join('#'),
        measure: request.url.toString()
    };
    performance.mark(this._marks.start);
};
RequestPerformance.prototype.finish = function finish() {
    performance.mark(this._marks.end);
    var resourceTimingData = performance.getEntriesByName(this._marks.measure);
    if (resourceTimingData.length === 0) {
        performance.measure(this._marks.measure, this._marks.start, this._marks.end);
        resourceTimingData = performance.getEntriesByName(this._marks.measure);
        performance.clearMarks(this._marks.start);
        performance.clearMarks(this._marks.end);
        performance.clearMeasures(this._marks.measure);
    }
    return resourceTimingData;
};

exports.Actor = Actor;
exports.AlphaImage = AlphaImage;
exports.CanonicalTileID = CanonicalTileID;
exports.CollisionBoxArray = CollisionBoxArray;
exports.Color = Color;
exports.DEMData = DEMData;
exports.DataConstantProperty = DataConstantProperty;
exports.DictionaryCoder = DictionaryCoder;
exports.EXTENT = EXTENT$1;
exports.ErrorEvent = ErrorEvent;
exports.EvaluationParameters = EvaluationParameters;
exports.Event = Event;
exports.Evented = Evented;
exports.FeatureIndex = FeatureIndex;
exports.FillBucket = FillBucket;
exports.FillExtrusionBucket = FillExtrusionBucket;
exports.ImageAtlas = ImageAtlas;
exports.ImagePosition = ImagePosition;
exports.LineBucket = LineBucket;
exports.LngLat = LngLat;
exports.LngLatBounds = LngLatBounds;
exports.MercatorCoordinate = MercatorCoordinate;
exports.ONE_EM = ONE_EM;
exports.OverscaledTileID = OverscaledTileID;
exports.Point = pointGeometry;
exports.Point$1 = pointGeometry;
exports.Properties = Properties;
exports.Protobuf = pbf;
exports.RGBAImage = RGBAImage;
exports.RequestManager = RequestManager;
exports.RequestPerformance = RequestPerformance;
exports.ResourceType = ResourceType;
exports.SegmentVector = SegmentVector;
exports.SourceFeatureState = SourceFeatureState;
exports.StructArrayLayout1ui2 = StructArrayLayout1ui2;
exports.StructArrayLayout2f1f2i16 = StructArrayLayout2f1f2i16;
exports.StructArrayLayout2i4 = StructArrayLayout2i4;
exports.StructArrayLayout3ui6 = StructArrayLayout3ui6;
exports.StructArrayLayout4i8 = StructArrayLayout4i8;
exports.SymbolBucket = SymbolBucket;
exports.Texture = Texture;
exports.Tile = Tile;
exports.Transitionable = Transitionable;
exports.Uniform1f = Uniform1f;
exports.Uniform1i = Uniform1i;
exports.Uniform2f = Uniform2f;
exports.Uniform3f = Uniform3f;
exports.Uniform4f = Uniform4f;
exports.UniformColor = UniformColor;
exports.UniformMatrix4f = UniformMatrix4f;
exports.UnwrappedTileID = UnwrappedTileID;
exports.ValidationError = ValidationError;
exports.WritingMode = WritingMode;
exports.ZoomHistory = ZoomHistory;
exports.add = add;
exports.addDynamicAttributes = addDynamicAttributes;
exports.asyncAll = asyncAll;
exports.bezier = bezier;
exports.bindAll = bindAll;
exports.browser = exported;
exports.cacheEntryPossiblyAdded = cacheEntryPossiblyAdded;
exports.clamp = clamp;
exports.clearTileCache = clearTileCache;
exports.clipLine = clipLine;
exports.clone = clone$1;
exports.clone$1 = clone;
exports.clone$2 = clone$2;
exports.collisionCircleLayout = collisionCircleLayout;
exports.config = config;
exports.create = create$2;
exports.create$1 = create$1;
exports.create$2 = create;
exports.createCommonjsModule = createCommonjsModule;
exports.createExpression = createExpression;
exports.createLayout = createLayout;
exports.createStyleLayer = createStyleLayer;
exports.cross = cross;
exports.deepEqual = deepEqual;
exports.dot = dot;
exports.dot$1 = dot$1;
exports.ease = ease;
exports.emitValidationErrors = emitValidationErrors;
exports.endsWith = endsWith;
exports.enforceCacheSizeLimit = enforceCacheSizeLimit;
exports.evaluateSizeForFeature = evaluateSizeForFeature;
exports.evaluateSizeForZoom = evaluateSizeForZoom;
exports.evaluateVariableOffset = evaluateVariableOffset;
exports.evented = evented;
exports.extend = extend;
exports.featureFilter = createFilter;
exports.filterObject = filterObject;
exports.fromRotation = fromRotation;
exports.getAnchorAlignment = getAnchorAlignment;
exports.getAnchorJustification = getAnchorJustification;
exports.getArrayBuffer = getArrayBuffer;
exports.getImage = getImage;
exports.getJSON = getJSON;
exports.getRTLTextPluginStatus = getRTLTextPluginStatus;
exports.getReferrer = getReferrer;
exports.getVideo = getVideo;
exports.identity = identity;
exports.invert = invert;
exports.isChar = unicodeBlockLookup;
exports.isMapboxURL = isMapboxURL;
exports.keysDifference = keysDifference;
exports.makeRequest = makeRequest;
exports.mapObject = mapObject;
exports.mercatorXfromLng = mercatorXfromLng$1;
exports.mercatorYfromLat = mercatorYfromLat$1;
exports.mercatorZfromAltitude = mercatorZfromAltitude;
exports.mul = mul;
exports.multiply = multiply;
exports.mvt = vectorTile;
exports.nextPowerOfTwo = nextPowerOfTwo;
exports.normalize = normalize;
exports.number = number;
exports.offscreenCanvasSupported = offscreenCanvasSupported;
exports.ortho = ortho;
exports.parseGlyphPBF = parseGlyphPBF;
exports.pbf = pbf;
exports.performSymbolLayout = performSymbolLayout;
exports.perspective = perspective;
exports.pick = pick;
exports.plugin = plugin;
exports.polygonIntersectsPolygon = polygonIntersectsPolygon;
exports.postMapLoadEvent = postMapLoadEvent;
exports.postTurnstileEvent = postTurnstileEvent;
exports.potpack = potpack;
exports.refProperties = refProperties;
exports.register = register;
exports.registerForPluginStateChange = registerForPluginStateChange;
exports.renderColorRamp = renderColorRamp;
exports.rotate = rotate;
exports.rotateX = rotateX;
exports.rotateZ = rotateZ;
exports.scale = scale;
exports.scale$1 = scale$2;
exports.scale$2 = scale$1;
exports.setCacheLimits = setCacheLimits;
exports.setRTLTextPlugin = setRTLTextPlugin;
exports.sphericalToCartesian = sphericalToCartesian;
exports.sqrLen = sqrLen;
exports.styleSpec = spec;
exports.sub = sub;
exports.symbolSize = symbolSize;
exports.transformMat3 = transformMat3;
exports.transformMat4 = transformMat4;
exports.translate = translate$1;
exports.triggerPluginCompletionEvent = triggerPluginCompletionEvent;
exports.uniqueId = uniqueId;
exports.validateCustomStyleLayer = validateCustomStyleLayer;
exports.validateLight = validateLight$1;
exports.validateStyle = validateStyle;
exports.values = values;
exports.vectorTile = vectorTile;
exports.version = version;
exports.warnOnce = warnOnce;
exports.webpSupported = exported$1;
exports.window = window$1;
exports.wrap = wrap;

});

define(['./shared'], function (performance) { 'use strict';

function stringify(obj) {
    var type = typeof obj;
    if (type === 'number' || type === 'boolean' || type === 'string' || obj === undefined || obj === null) {
        return JSON.stringify(obj);
    }
    if (Array.isArray(obj)) {
        var str$1 = '[';
        for (var i$1 = 0, list = obj; i$1 < list.length; i$1 += 1) {
            var val = list[i$1];
            str$1 += stringify(val) + ',';
        }
        return str$1 + ']';
    }
    var keys = Object.keys(obj).sort();
    var str = '{';
    for (var i = 0; i < keys.length; i++) {
        str += JSON.stringify(keys[i]) + ':' + stringify(obj[keys[i]]) + ',';
    }
    return str + '}';
}
function getKey(layer) {
    var key = '';
    for (var i = 0, list = performance.refProperties; i < list.length; i += 1) {
        var k = list[i];
        key += '/' + stringify(layer[k]);
    }
    return key;
}
function groupByLayout(layers, cachedKeys) {
    var groups = {};
    for (var i = 0; i < layers.length; i++) {
        var k = cachedKeys && cachedKeys[layers[i].id] || getKey(layers[i]);
        if (cachedKeys) {
            cachedKeys[layers[i].id] = k;
        }
        var group = groups[k];
        if (!group) {
            group = groups[k] = [];
        }
        group.push(layers[i]);
    }
    var result = [];
    for (var k$1 in groups) {
        result.push(groups[k$1]);
    }
    return result;
}

var StyleLayerIndex = function StyleLayerIndex(layerConfigs) {
    this.keyCache = {};
    if (layerConfigs) {
        this.replace(layerConfigs);
    }
};
StyleLayerIndex.prototype.replace = function replace(layerConfigs) {
    this._layerConfigs = {};
    this._layers = {};
    this.update(layerConfigs, []);
};
StyleLayerIndex.prototype.update = function update(layerConfigs, removedIds) {
    var this$1 = this;
    for (var i = 0, list = layerConfigs; i < list.length; i += 1) {
        var layerConfig = list[i];
        this._layerConfigs[layerConfig.id] = layerConfig;
        var layer = this._layers[layerConfig.id] = performance.createStyleLayer(layerConfig);
        layer._featureFilter = performance.featureFilter(layer.filter);
        if (this.keyCache[layerConfig.id]) {
            delete this.keyCache[layerConfig.id];
        }
    }
    for (var i$1 = 0, list$1 = removedIds; i$1 < list$1.length; i$1 += 1) {
        var id = list$1[i$1];
        delete this.keyCache[id];
        delete this._layerConfigs[id];
        delete this._layers[id];
    }
    this.familiesBySource = {};
    var groups = groupByLayout(performance.values(this._layerConfigs), this.keyCache);
    for (var i$2 = 0, list$2 = groups; i$2 < list$2.length; i$2 += 1) {
        var layerConfigs$1 = list$2[i$2];
        var layers = layerConfigs$1.map(function (layerConfig) {
            return this$1._layers[layerConfig.id];
        });
        var layer$1 = layers[0];
        if (layer$1.visibility === 'none') {
            continue;
        }
        var sourceId = layer$1.source || '';
        var sourceGroup = this.familiesBySource[sourceId];
        if (!sourceGroup) {
            sourceGroup = this.familiesBySource[sourceId] = {};
        }
        var sourceLayerId = layer$1.sourceLayer || '_geojsonTileLayer';
        var sourceLayerFamilies = sourceGroup[sourceLayerId];
        if (!sourceLayerFamilies) {
            sourceLayerFamilies = sourceGroup[sourceLayerId] = [];
        }
        sourceLayerFamilies.push(layers);
    }
};

var padding = 1;
var GlyphAtlas = function GlyphAtlas(stacks) {
    var positions = {};
    var bins = [];
    for (var stack in stacks) {
        var glyphs = stacks[stack];
        var stackPositions = positions[stack] = {};
        for (var id in glyphs) {
            var src = glyphs[+id];
            if (!src || src.bitmap.width === 0 || src.bitmap.height === 0) {
                continue;
            }
            var bin = {
                x: 0,
                y: 0,
                w: src.bitmap.width + 2 * padding,
                h: src.bitmap.height + 2 * padding
            };
            bins.push(bin);
            stackPositions[id] = {
                rect: bin,
                metrics: src.metrics
            };
        }
    }
    var ref = performance.potpack(bins);
    var w = ref.w;
    var h = ref.h;
    var image = new performance.AlphaImage({
        width: w || 1,
        height: h || 1
    });
    for (var stack$1 in stacks) {
        var glyphs$1 = stacks[stack$1];
        for (var id$1 in glyphs$1) {
            var src$1 = glyphs$1[+id$1];
            if (!src$1 || src$1.bitmap.width === 0 || src$1.bitmap.height === 0) {
                continue;
            }
            var bin$1 = positions[stack$1][id$1].rect;
            performance.AlphaImage.copy(src$1.bitmap, image, {
                x: 0,
                y: 0
            }, {
                x: bin$1.x + padding,
                y: bin$1.y + padding
            }, src$1.bitmap);
        }
    }
    this.image = image;
    this.positions = positions;
};
performance.register('GlyphAtlas', GlyphAtlas);

var WorkerTile = function WorkerTile(params) {
    this.tileID = new performance.OverscaledTileID(params.tileID.overscaledZ, params.tileID.wrap, params.tileID.canonical.z, params.tileID.canonical.x, params.tileID.canonical.y);
    this.uid = params.uid;
    this.zoom = params.zoom;
    this.pixelRatio = params.pixelRatio;
    this.tileSize = params.tileSize;
    this.source = params.source;
    this.overscaling = this.tileID.overscaleFactor();
    this.showCollisionBoxes = params.showCollisionBoxes;
    this.collectResourceTiming = !!params.collectResourceTiming;
    this.returnDependencies = !!params.returnDependencies;
    this.promoteId = params.promoteId;
};
WorkerTile.prototype.parse = function parse(data, layerIndex, availableImages, actor, callback) {
    var this$1 = this;
    this.status = 'parsing';
    this.data = data;
    this.collisionBoxArray = new performance.CollisionBoxArray();
    var sourceLayerCoder = new performance.DictionaryCoder(Object.keys(data.layers).sort());
    var featureIndex = new performance.FeatureIndex(this.tileID, this.promoteId);
    featureIndex.bucketLayerIDs = [];
    var buckets = {};
    var options = {
        featureIndex: featureIndex,
        iconDependencies: {},
        patternDependencies: {},
        glyphDependencies: {},
        availableImages: availableImages
    };
    var layerFamilies = layerIndex.familiesBySource[this.source];
    for (var sourceLayerId in layerFamilies) {
        var sourceLayer = data.layers[sourceLayerId];
        if (!sourceLayer) {
            continue;
        }
        if (sourceLayer.version === 1) {
            performance.warnOnce('Vector tile source "' + this.source + '" layer "' + sourceLayerId + '" ' + 'does not use vector tile spec v2 and therefore may have some rendering errors.');
        }
        var sourceLayerIndex = sourceLayerCoder.encode(sourceLayerId);
        var features = [];
        for (var index = 0; index < sourceLayer.length; index++) {
            var feature = sourceLayer.feature(index);
            var id = featureIndex.getId(feature, sourceLayerId);
            features.push({
                feature: feature,
                id: id,
                index: index,
                sourceLayerIndex: sourceLayerIndex
            });
        }
        for (var i = 0, list = layerFamilies[sourceLayerId]; i < list.length; i += 1) {
            var family = list[i];
            var layer = family[0];
            if (layer.minzoom && this.zoom < Math.floor(layer.minzoom)) {
                continue;
            }
            if (layer.maxzoom && this.zoom >= layer.maxzoom) {
                continue;
            }
            if (layer.visibility === 'none') {
                continue;
            }
            recalculateLayers(family, this.zoom, availableImages);
            var bucket = buckets[layer.id] = layer.createBucket({
                index: featureIndex.bucketLayerIDs.length,
                layers: family,
                zoom: this.zoom,
                pixelRatio: this.pixelRatio,
                overscaling: this.overscaling,
                collisionBoxArray: this.collisionBoxArray,
                sourceLayerIndex: sourceLayerIndex,
                sourceID: this.source
            });
            bucket.populate(features, options, this.tileID.canonical);
            featureIndex.bucketLayerIDs.push(family.map(function (l) {
                return l.id;
            }));
        }
    }
    var error;
    var glyphMap;
    var iconMap;
    var patternMap;
    var stacks = performance.mapObject(options.glyphDependencies, function (glyphs) {
        return Object.keys(glyphs).map(Number);
    });
    if (Object.keys(stacks).length) {
        actor.send('getGlyphs', {
            uid: this.uid,
            stacks: stacks
        }, function (err, result) {
            if (!error) {
                error = err;
                glyphMap = result;
                maybePrepare.call(this$1);
            }
        });
    } else {
        glyphMap = {};
    }
    var icons = Object.keys(options.iconDependencies);
    if (icons.length) {
        actor.send('getImages', {
            icons: icons,
            source: this.source,
            tileID: this.tileID,
            type: 'icons'
        }, function (err, result) {
            if (!error) {
                error = err;
                iconMap = result;
                maybePrepare.call(this$1);
            }
        });
    } else {
        iconMap = {};
    }
    var patterns = Object.keys(options.patternDependencies);
    if (patterns.length) {
        actor.send('getImages', {
            icons: patterns,
            source: this.source,
            tileID: this.tileID,
            type: 'patterns'
        }, function (err, result) {
            if (!error) {
                error = err;
                patternMap = result;
                maybePrepare.call(this$1);
            }
        });
    } else {
        patternMap = {};
    }
    maybePrepare.call(this);
    function maybePrepare() {
        if (error) {
            return callback(error);
        } else if (glyphMap && iconMap && patternMap) {
            var glyphAtlas = new GlyphAtlas(glyphMap);
            var imageAtlas = new performance.ImageAtlas(iconMap, patternMap);
            for (var key in buckets) {
                var bucket = buckets[key];
                if (bucket instanceof performance.SymbolBucket) {
                    recalculateLayers(bucket.layers, this.zoom, availableImages);
                    performance.performSymbolLayout(bucket, glyphMap, glyphAtlas.positions, iconMap, imageAtlas.iconPositions, this.showCollisionBoxes, this.tileID.canonical);
                } else if (bucket.hasPattern && (bucket instanceof performance.LineBucket || bucket instanceof performance.FillBucket || bucket instanceof performance.FillExtrusionBucket)) {
                    recalculateLayers(bucket.layers, this.zoom, availableImages);
                    bucket.addFeatures(options, this.tileID.canonical, imageAtlas.patternPositions);
                }
            }
            this.status = 'done';
            callback(null, {
                buckets: performance.values(buckets).filter(function (b) {
                    return !b.isEmpty();
                }),
                featureIndex: featureIndex,
                collisionBoxArray: this.collisionBoxArray,
                glyphAtlasImage: glyphAtlas.image,
                imageAtlas: imageAtlas,
                glyphMap: this.returnDependencies ? glyphMap : null,
                iconMap: this.returnDependencies ? iconMap : null,
                glyphPositions: this.returnDependencies ? glyphAtlas.positions : null
            });
        }
    }
};
function recalculateLayers(layers, zoom, availableImages) {
    var parameters = new performance.EvaluationParameters(zoom);
    for (var i = 0, list = layers; i < list.length; i += 1) {
        var layer = list[i];
        layer.recalculate(parameters, availableImages);
    }
}

function loadVectorTile(params, callback) {
    var request = performance.getArrayBuffer(params.request, function (err, data, cacheControl, expires) {
        if (err) {
            callback(err);
        } else if (data) {
            callback(null, {
                vectorTile: new performance.vectorTile.VectorTile(new performance.pbf(data)),
                rawData: data,
                cacheControl: cacheControl,
                expires: expires
            });
        }
    });
    return function () {
        request.cancel();
        callback();
    };
}
var VectorTileWorkerSource = function VectorTileWorkerSource(actor, layerIndex, availableImages, loadVectorData) {
    this.actor = actor;
    this.layerIndex = layerIndex;
    this.availableImages = availableImages;
    this.loadVectorData = loadVectorData || loadVectorTile;
    this.loading = {};
    this.loaded = {};
};
VectorTileWorkerSource.prototype.loadTile = function loadTile(params, callback) {
    var this$1 = this;
    var uid = params.uid;
    if (!this.loading) {
        this.loading = {};
    }
    var perf = params && params.request && params.request.collectResourceTiming ? new performance.RequestPerformance(params.request) : false;
    var workerTile = this.loading[uid] = new WorkerTile(params);
    workerTile.abort = this.loadVectorData(params, function (err, response) {
        delete this$1.loading[uid];
        if (err || !response) {
            workerTile.status = 'done';
            this$1.loaded[uid] = workerTile;
            return callback(err);
        }
        var rawTileData = response.rawData;
        var cacheControl = {};
        if (response.expires) {
            cacheControl.expires = response.expires;
        }
        if (response.cacheControl) {
            cacheControl.cacheControl = response.cacheControl;
        }
        var resourceTiming = {};
        if (perf) {
            var resourceTimingData = perf.finish();
            if (resourceTimingData) {
                resourceTiming.resourceTiming = JSON.parse(JSON.stringify(resourceTimingData));
            }
        }
        workerTile.vectorTile = response.vectorTile;
        workerTile.parse(response.vectorTile, this$1.layerIndex, this$1.availableImages, this$1.actor, function (err, result) {
            if (err || !result) {
                return callback(err);
            }
            callback(null, performance.extend({ rawTileData: rawTileData.slice(0) }, result, cacheControl, resourceTiming));
        });
        this$1.loaded = this$1.loaded || {};
        this$1.loaded[uid] = workerTile;
    });
};
VectorTileWorkerSource.prototype.reloadTile = function reloadTile(params, callback) {
    var this$1 = this;
    var loaded = this.loaded, uid = params.uid, vtSource = this;
    if (loaded && loaded[uid]) {
        var workerTile = loaded[uid];
        workerTile.showCollisionBoxes = params.showCollisionBoxes;
        var done = function (err, data) {
            var reloadCallback = workerTile.reloadCallback;
            if (reloadCallback) {
                delete workerTile.reloadCallback;
                workerTile.parse(workerTile.vectorTile, vtSource.layerIndex, this$1.availableImages, vtSource.actor, reloadCallback);
            }
            callback(err, data);
        };
        if (workerTile.status === 'parsing') {
            workerTile.reloadCallback = done;
        } else if (workerTile.status === 'done') {
            if (workerTile.vectorTile) {
                workerTile.parse(workerTile.vectorTile, this.layerIndex, this.availableImages, this.actor, done);
            } else {
                done();
            }
        }
    }
};
VectorTileWorkerSource.prototype.abortTile = function abortTile(params, callback) {
    var loading = this.loading, uid = params.uid;
    if (loading && loading[uid] && loading[uid].abort) {
        loading[uid].abort();
        delete loading[uid];
    }
    callback();
};
VectorTileWorkerSource.prototype.removeTile = function removeTile(params, callback) {
    var loaded = this.loaded, uid = params.uid;
    if (loaded && loaded[uid]) {
        delete loaded[uid];
    }
    callback();
};

var ImageBitmap = performance.window.ImageBitmap;
var RasterDEMTileWorkerSource = function RasterDEMTileWorkerSource() {
    this.loaded = {};
};
RasterDEMTileWorkerSource.prototype.loadTile = function loadTile(params, callback) {
    var uid = params.uid;
    var encoding = params.encoding;
    var rawImageData = params.rawImageData;
    var imagePixels = ImageBitmap && rawImageData instanceof ImageBitmap ? this.getImageData(rawImageData) : rawImageData;
    var dem = new performance.DEMData(uid, imagePixels, encoding);
    this.loaded = this.loaded || {};
    this.loaded[uid] = dem;
    callback(null, dem);
};
RasterDEMTileWorkerSource.prototype.getImageData = function getImageData(imgBitmap) {
    if (!this.offscreenCanvas || !this.offscreenCanvasContext) {
        this.offscreenCanvas = new OffscreenCanvas(imgBitmap.width, imgBitmap.height);
        this.offscreenCanvasContext = this.offscreenCanvas.getContext('2d');
    }
    this.offscreenCanvas.width = imgBitmap.width;
    this.offscreenCanvas.height = imgBitmap.height;
    this.offscreenCanvasContext.drawImage(imgBitmap, 0, 0, imgBitmap.width, imgBitmap.height);
    var imgData = this.offscreenCanvasContext.getImageData(-1, -1, imgBitmap.width + 2, imgBitmap.height + 2);
    this.offscreenCanvasContext.clearRect(0, 0, this.offscreenCanvas.width, this.offscreenCanvas.height);
    return new performance.RGBAImage({
        width: imgData.width,
        height: imgData.height
    }, imgData.data);
};
RasterDEMTileWorkerSource.prototype.removeTile = function removeTile(params) {
    var loaded = this.loaded, uid = params.uid;
    if (loaded && loaded[uid]) {
        delete loaded[uid];
    }
};

var geojsonRewind = rewind;
function rewind(gj, outer) {
    var type = gj && gj.type, i;
    if (type === 'FeatureCollection') {
        for (i = 0; i < gj.features.length; i++) {
            rewind(gj.features[i], outer);
        }
    } else if (type === 'GeometryCollection') {
        for (i = 0; i < gj.geometries.length; i++) {
            rewind(gj.geometries[i], outer);
        }
    } else if (type === 'Feature') {
        rewind(gj.geometry, outer);
    } else if (type === 'Polygon') {
        rewindRings(gj.coordinates, outer);
    } else if (type === 'MultiPolygon') {
        for (i = 0; i < gj.coordinates.length; i++) {
            rewindRings(gj.coordinates[i], outer);
        }
    }
    return gj;
}
function rewindRings(rings, outer) {
    if (rings.length === 0) {
        return;
    }
    rewindRing(rings[0], outer);
    for (var i = 1; i < rings.length; i++) {
        rewindRing(rings[i], !outer);
    }
}
function rewindRing(ring, dir) {
    var area = 0;
    for (var i = 0, len = ring.length, j = len - 1; i < len; j = i++) {
        area += (ring[i][0] - ring[j][0]) * (ring[j][1] + ring[i][1]);
    }
    if (area >= 0 !== !!dir) {
        ring.reverse();
    }
}

var toGeoJSON = performance.vectorTile.VectorTileFeature.prototype.toGeoJSON;
var FeatureWrapper = function FeatureWrapper(feature) {
    this._feature = feature;
    this.extent = performance.EXTENT;
    this.type = feature.type;
    this.properties = feature.tags;
    if ('id' in feature && !isNaN(feature.id)) {
        this.id = parseInt(feature.id, 10);
    }
};
FeatureWrapper.prototype.loadGeometry = function loadGeometry() {
    if (this._feature.type === 1) {
        var geometry = [];
        for (var i = 0, list = this._feature.geometry; i < list.length; i += 1) {
            var point = list[i];
            geometry.push([new performance.Point$1(point[0], point[1])]);
        }
        return geometry;
    } else {
        var geometry$1 = [];
        for (var i$2 = 0, list$2 = this._feature.geometry; i$2 < list$2.length; i$2 += 1) {
            var ring = list$2[i$2];
            var newRing = [];
            for (var i$1 = 0, list$1 = ring; i$1 < list$1.length; i$1 += 1) {
                var point$1 = list$1[i$1];
                newRing.push(new performance.Point$1(point$1[0], point$1[1]));
            }
            geometry$1.push(newRing);
        }
        return geometry$1;
    }
};
FeatureWrapper.prototype.toGeoJSON = function toGeoJSON$1(x, y, z) {
    return toGeoJSON.call(this, x, y, z);
};
var GeoJSONWrapper = function GeoJSONWrapper(features) {
    this.layers = { '_geojsonTileLayer': this };
    this.name = '_geojsonTileLayer';
    this.extent = performance.EXTENT;
    this.length = features.length;
    this._features = features;
};
GeoJSONWrapper.prototype.feature = function feature(i) {
    return new FeatureWrapper(this._features[i]);
};

var VectorTileFeature = performance.vectorTile.VectorTileFeature;
var geojson_wrapper = GeoJSONWrapper$1;
function GeoJSONWrapper$1(features, options) {
    this.options = options || {};
    this.features = features;
    this.length = features.length;
}
GeoJSONWrapper$1.prototype.feature = function (i) {
    return new FeatureWrapper$1(this.features[i], this.options.extent);
};
function FeatureWrapper$1(feature, extent) {
    this.id = typeof feature.id === 'number' ? feature.id : undefined;
    this.type = feature.type;
    this.rawGeometry = feature.type === 1 ? [feature.geometry] : feature.geometry;
    this.properties = feature.tags;
    this.extent = extent || 4096;
}
FeatureWrapper$1.prototype.loadGeometry = function () {
    var rings = this.rawGeometry;
    this.geometry = [];
    for (var i = 0; i < rings.length; i++) {
        var ring = rings[i];
        var newRing = [];
        for (var j = 0; j < ring.length; j++) {
            newRing.push(new performance.Point$1(ring[j][0], ring[j][1]));
        }
        this.geometry.push(newRing);
    }
    return this.geometry;
};
FeatureWrapper$1.prototype.bbox = function () {
    if (!this.geometry) {
        this.loadGeometry();
    }
    var rings = this.geometry;
    var x1 = Infinity;
    var x2 = -Infinity;
    var y1 = Infinity;
    var y2 = -Infinity;
    for (var i = 0; i < rings.length; i++) {
        var ring = rings[i];
        for (var j = 0; j < ring.length; j++) {
            var coord = ring[j];
            x1 = Math.min(x1, coord.x);
            x2 = Math.max(x2, coord.x);
            y1 = Math.min(y1, coord.y);
            y2 = Math.max(y2, coord.y);
        }
    }
    return [
        x1,
        y1,
        x2,
        y2
    ];
};
FeatureWrapper$1.prototype.toGeoJSON = VectorTileFeature.prototype.toGeoJSON;

var vtPbf = fromVectorTileJs;
var fromVectorTileJs_1 = fromVectorTileJs;
var fromGeojsonVt_1 = fromGeojsonVt;
var GeoJSONWrapper_1 = geojson_wrapper;
function fromVectorTileJs(tile) {
    var out = new performance.pbf();
    writeTile(tile, out);
    return out.finish();
}
function fromGeojsonVt(layers, options) {
    options = options || {};
    var l = {};
    for (var k in layers) {
        l[k] = new geojson_wrapper(layers[k].features, options);
        l[k].name = k;
        l[k].version = options.version;
        l[k].extent = options.extent;
    }
    return fromVectorTileJs({ layers: l });
}
function writeTile(tile, pbf) {
    for (var key in tile.layers) {
        pbf.writeMessage(3, writeLayer, tile.layers[key]);
    }
}
function writeLayer(layer, pbf) {
    pbf.writeVarintField(15, layer.version || 1);
    pbf.writeStringField(1, layer.name || '');
    pbf.writeVarintField(5, layer.extent || 4096);
    var i;
    var context = {
        keys: [],
        values: [],
        keycache: {},
        valuecache: {}
    };
    for (i = 0; i < layer.length; i++) {
        context.feature = layer.feature(i);
        pbf.writeMessage(2, writeFeature, context);
    }
    var keys = context.keys;
    for (i = 0; i < keys.length; i++) {
        pbf.writeStringField(3, keys[i]);
    }
    var values = context.values;
    for (i = 0; i < values.length; i++) {
        pbf.writeMessage(4, writeValue, values[i]);
    }
}
function writeFeature(context, pbf) {
    var feature = context.feature;
    if (feature.id !== undefined) {
        pbf.writeVarintField(1, feature.id);
    }
    pbf.writeMessage(2, writeProperties, context);
    pbf.writeVarintField(3, feature.type);
    pbf.writeMessage(4, writeGeometry, feature);
}
function writeProperties(context, pbf) {
    var feature = context.feature;
    var keys = context.keys;
    var values = context.values;
    var keycache = context.keycache;
    var valuecache = context.valuecache;
    for (var key in feature.properties) {
        var keyIndex = keycache[key];
        if (typeof keyIndex === 'undefined') {
            keys.push(key);
            keyIndex = keys.length - 1;
            keycache[key] = keyIndex;
        }
        pbf.writeVarint(keyIndex);
        var value = feature.properties[key];
        var type = typeof value;
        if (type !== 'string' && type !== 'boolean' && type !== 'number') {
            value = JSON.stringify(value);
        }
        var valueKey = type + ':' + value;
        var valueIndex = valuecache[valueKey];
        if (typeof valueIndex === 'undefined') {
            values.push(value);
            valueIndex = values.length - 1;
            valuecache[valueKey] = valueIndex;
        }
        pbf.writeVarint(valueIndex);
    }
}
function command(cmd, length) {
    return (length << 3) + (cmd & 7);
}
function zigzag(num) {
    return num << 1 ^ num >> 31;
}
function writeGeometry(feature, pbf) {
    var geometry = feature.loadGeometry();
    var type = feature.type;
    var x = 0;
    var y = 0;
    var rings = geometry.length;
    for (var r = 0; r < rings; r++) {
        var ring = geometry[r];
        var count = 1;
        if (type === 1) {
            count = ring.length;
        }
        pbf.writeVarint(command(1, count));
        var lineCount = type === 3 ? ring.length - 1 : ring.length;
        for (var i = 0; i < lineCount; i++) {
            if (i === 1 && type !== 1) {
                pbf.writeVarint(command(2, lineCount - 1));
            }
            var dx = ring[i].x - x;
            var dy = ring[i].y - y;
            pbf.writeVarint(zigzag(dx));
            pbf.writeVarint(zigzag(dy));
            x += dx;
            y += dy;
        }
        if (type === 3) {
            pbf.writeVarint(command(7, 1));
        }
    }
}
function writeValue(value, pbf) {
    var type = typeof value;
    if (type === 'string') {
        pbf.writeStringField(1, value);
    } else if (type === 'boolean') {
        pbf.writeBooleanField(7, value);
    } else if (type === 'number') {
        if (value % 1 !== 0) {
            pbf.writeDoubleField(3, value);
        } else if (value < 0) {
            pbf.writeSVarintField(6, value);
        } else {
            pbf.writeVarintField(5, value);
        }
    }
}
vtPbf.fromVectorTileJs = fromVectorTileJs_1;
vtPbf.fromGeojsonVt = fromGeojsonVt_1;
vtPbf.GeoJSONWrapper = GeoJSONWrapper_1;

function sortKD(ids, coords, nodeSize, left, right, depth) {
    if (right - left <= nodeSize) {
        return;
    }
    var m = left + right >> 1;
    select(ids, coords, m, left, right, depth % 2);
    sortKD(ids, coords, nodeSize, left, m - 1, depth + 1);
    sortKD(ids, coords, nodeSize, m + 1, right, depth + 1);
}
function select(ids, coords, k, left, right, inc) {
    while (right > left) {
        if (right - left > 600) {
            var n = right - left + 1;
            var m = k - left + 1;
            var z = Math.log(n);
            var s = 0.5 * Math.exp(2 * z / 3);
            var sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            var newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            var newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            select(ids, coords, k, newLeft, newRight, inc);
        }
        var t = coords[2 * k + inc];
        var i = left;
        var j = right;
        swapItem(ids, coords, left, k);
        if (coords[2 * right + inc] > t) {
            swapItem(ids, coords, left, right);
        }
        while (i < j) {
            swapItem(ids, coords, i, j);
            i++;
            j--;
            while (coords[2 * i + inc] < t) {
                i++;
            }
            while (coords[2 * j + inc] > t) {
                j--;
            }
        }
        if (coords[2 * left + inc] === t) {
            swapItem(ids, coords, left, j);
        } else {
            j++;
            swapItem(ids, coords, j, right);
        }
        if (j <= k) {
            left = j + 1;
        }
        if (k <= j) {
            right = j - 1;
        }
    }
}
function swapItem(ids, coords, i, j) {
    swap(ids, i, j);
    swap(coords, 2 * i, 2 * j);
    swap(coords, 2 * i + 1, 2 * j + 1);
}
function swap(arr, i, j) {
    var tmp = arr[i];
    arr[i] = arr[j];
    arr[j] = tmp;
}

function range(ids, coords, minX, minY, maxX, maxY, nodeSize) {
    var stack = [
        0,
        ids.length - 1,
        0
    ];
    var result = [];
    var x, y;
    while (stack.length) {
        var axis = stack.pop();
        var right = stack.pop();
        var left = stack.pop();
        if (right - left <= nodeSize) {
            for (var i = left; i <= right; i++) {
                x = coords[2 * i];
                y = coords[2 * i + 1];
                if (x >= minX && x <= maxX && y >= minY && y <= maxY) {
                    result.push(ids[i]);
                }
            }
            continue;
        }
        var m = Math.floor((left + right) / 2);
        x = coords[2 * m];
        y = coords[2 * m + 1];
        if (x >= minX && x <= maxX && y >= minY && y <= maxY) {
            result.push(ids[m]);
        }
        var nextAxis = (axis + 1) % 2;
        if (axis === 0 ? minX <= x : minY <= y) {
            stack.push(left);
            stack.push(m - 1);
            stack.push(nextAxis);
        }
        if (axis === 0 ? maxX >= x : maxY >= y) {
            stack.push(m + 1);
            stack.push(right);
            stack.push(nextAxis);
        }
    }
    return result;
}

function within(ids, coords, qx, qy, r, nodeSize) {
    var stack = [
        0,
        ids.length - 1,
        0
    ];
    var result = [];
    var r2 = r * r;
    while (stack.length) {
        var axis = stack.pop();
        var right = stack.pop();
        var left = stack.pop();
        if (right - left <= nodeSize) {
            for (var i = left; i <= right; i++) {
                if (sqDist(coords[2 * i], coords[2 * i + 1], qx, qy) <= r2) {
                    result.push(ids[i]);
                }
            }
            continue;
        }
        var m = Math.floor((left + right) / 2);
        var x = coords[2 * m];
        var y = coords[2 * m + 1];
        if (sqDist(x, y, qx, qy) <= r2) {
            result.push(ids[m]);
        }
        var nextAxis = (axis + 1) % 2;
        if (axis === 0 ? qx - r <= x : qy - r <= y) {
            stack.push(left);
            stack.push(m - 1);
            stack.push(nextAxis);
        }
        if (axis === 0 ? qx + r >= x : qy + r >= y) {
            stack.push(m + 1);
            stack.push(right);
            stack.push(nextAxis);
        }
    }
    return result;
}
function sqDist(ax, ay, bx, by) {
    var dx = ax - bx;
    var dy = ay - by;
    return dx * dx + dy * dy;
}

var defaultGetX = function (p) {
    return p[0];
};
var defaultGetY = function (p) {
    return p[1];
};
var KDBush = function KDBush(points, getX, getY, nodeSize, ArrayType) {
    if (getX === void 0)
        getX = defaultGetX;
    if (getY === void 0)
        getY = defaultGetY;
    if (nodeSize === void 0)
        nodeSize = 64;
    if (ArrayType === void 0)
        ArrayType = Float64Array;
    this.nodeSize = nodeSize;
    this.points = points;
    var IndexArrayType = points.length < 65536 ? Uint16Array : Uint32Array;
    var ids = this.ids = new IndexArrayType(points.length);
    var coords = this.coords = new ArrayType(points.length * 2);
    for (var i = 0; i < points.length; i++) {
        ids[i] = i;
        coords[2 * i] = getX(points[i]);
        coords[2 * i + 1] = getY(points[i]);
    }
    sortKD(ids, coords, nodeSize, 0, ids.length - 1, 0);
};
KDBush.prototype.range = function range$1(minX, minY, maxX, maxY) {
    return range(this.ids, this.coords, minX, minY, maxX, maxY, this.nodeSize);
};
KDBush.prototype.within = function within$1(x, y, r) {
    return within(this.ids, this.coords, x, y, r, this.nodeSize);
};

var defaultOptions = {
    minZoom: 0,
    maxZoom: 16,
    minPoints: 2,
    radius: 40,
    extent: 512,
    nodeSize: 64,
    log: false,
    generateId: false,
    reduce: null,
    map: function (props) {
        return props;
    }
};
var Supercluster = function Supercluster(options) {
    this.options = extend(Object.create(defaultOptions), options);
    this.trees = new Array(this.options.maxZoom + 1);
};
Supercluster.prototype.load = function load(points) {
    var ref = this.options;
    var log = ref.log;
    var minZoom = ref.minZoom;
    var maxZoom = ref.maxZoom;
    var nodeSize = ref.nodeSize;
    if (log) {
        console.time('total time');
    }
    var timerId = 'prepare ' + points.length + ' points';
    if (log) {
        console.time(timerId);
    }
    this.points = points;
    var clusters = [];
    for (var i = 0; i < points.length; i++) {
        if (!points[i].geometry) {
            continue;
        }
        clusters.push(createPointCluster(points[i], i));
    }
    this.trees[maxZoom + 1] = new KDBush(clusters, getX, getY, nodeSize, Float32Array);
    if (log) {
        console.timeEnd(timerId);
    }
    for (var z = maxZoom; z >= minZoom; z--) {
        var now = +Date.now();
        clusters = this._cluster(clusters, z);
        this.trees[z] = new KDBush(clusters, getX, getY, nodeSize, Float32Array);
        if (log) {
            console.log('z%d: %d clusters in %dms', z, clusters.length, +Date.now() - now);
        }
    }
    if (log) {
        console.timeEnd('total time');
    }
    return this;
};
Supercluster.prototype.getClusters = function getClusters(bbox, zoom) {
    var minLng = ((bbox[0] + 180) % 360 + 360) % 360 - 180;
    var minLat = Math.max(-90, Math.min(90, bbox[1]));
    var maxLng = bbox[2] === 180 ? 180 : ((bbox[2] + 180) % 360 + 360) % 360 - 180;
    var maxLat = Math.max(-90, Math.min(90, bbox[3]));
    if (bbox[2] - bbox[0] >= 360) {
        minLng = -180;
        maxLng = 180;
    } else if (minLng > maxLng) {
        var easternHem = this.getClusters([
            minLng,
            minLat,
            180,
            maxLat
        ], zoom);
        var westernHem = this.getClusters([
            -180,
            minLat,
            maxLng,
            maxLat
        ], zoom);
        return easternHem.concat(westernHem);
    }
    var tree = this.trees[this._limitZoom(zoom)];
    var ids = tree.range(lngX(minLng), latY(maxLat), lngX(maxLng), latY(minLat));
    var clusters = [];
    for (var i = 0, list = ids; i < list.length; i += 1) {
        var id = list[i];
        var c = tree.points[id];
        clusters.push(c.numPoints ? getClusterJSON(c) : this.points[c.index]);
    }
    return clusters;
};
Supercluster.prototype.getChildren = function getChildren(clusterId) {
    var originId = this._getOriginId(clusterId);
    var originZoom = this._getOriginZoom(clusterId);
    var errorMsg = 'No cluster with the specified id.';
    var index = this.trees[originZoom];
    if (!index) {
        throw new Error(errorMsg);
    }
    var origin = index.points[originId];
    if (!origin) {
        throw new Error(errorMsg);
    }
    var r = this.options.radius / (this.options.extent * Math.pow(2, originZoom - 1));
    var ids = index.within(origin.x, origin.y, r);
    var children = [];
    for (var i = 0, list = ids; i < list.length; i += 1) {
        var id = list[i];
        var c = index.points[id];
        if (c.parentId === clusterId) {
            children.push(c.numPoints ? getClusterJSON(c) : this.points[c.index]);
        }
    }
    if (children.length === 0) {
        throw new Error(errorMsg);
    }
    return children;
};
Supercluster.prototype.getLeaves = function getLeaves(clusterId, limit, offset) {
    limit = limit || 10;
    offset = offset || 0;
    var leaves = [];
    this._appendLeaves(leaves, clusterId, limit, offset, 0);
    return leaves;
};
Supercluster.prototype.getTile = function getTile(z, x, y) {
    var tree = this.trees[this._limitZoom(z)];
    var z2 = Math.pow(2, z);
    var ref = this.options;
    var extent = ref.extent;
    var radius = ref.radius;
    var p = radius / extent;
    var top = (y - p) / z2;
    var bottom = (y + 1 + p) / z2;
    var tile = { features: [] };
    this._addTileFeatures(tree.range((x - p) / z2, top, (x + 1 + p) / z2, bottom), tree.points, x, y, z2, tile);
    if (x === 0) {
        this._addTileFeatures(tree.range(1 - p / z2, top, 1, bottom), tree.points, z2, y, z2, tile);
    }
    if (x === z2 - 1) {
        this._addTileFeatures(tree.range(0, top, p / z2, bottom), tree.points, -1, y, z2, tile);
    }
    return tile.features.length ? tile : null;
};
Supercluster.prototype.getClusterExpansionZoom = function getClusterExpansionZoom(clusterId) {
    var expansionZoom = this._getOriginZoom(clusterId) - 1;
    while (expansionZoom <= this.options.maxZoom) {
        var children = this.getChildren(clusterId);
        expansionZoom++;
        if (children.length !== 1) {
            break;
        }
        clusterId = children[0].properties.cluster_id;
    }
    return expansionZoom;
};
Supercluster.prototype._appendLeaves = function _appendLeaves(result, clusterId, limit, offset, skipped) {
    var children = this.getChildren(clusterId);
    for (var i = 0, list = children; i < list.length; i += 1) {
        var child = list[i];
        var props = child.properties;
        if (props && props.cluster) {
            if (skipped + props.point_count <= offset) {
                skipped += props.point_count;
            } else {
                skipped = this._appendLeaves(result, props.cluster_id, limit, offset, skipped);
            }
        } else if (skipped < offset) {
            skipped++;
        } else {
            result.push(child);
        }
        if (result.length === limit) {
            break;
        }
    }
    return skipped;
};
Supercluster.prototype._addTileFeatures = function _addTileFeatures(ids, points, x, y, z2, tile) {
    for (var i$1 = 0, list = ids; i$1 < list.length; i$1 += 1) {
        var i = list[i$1];
        var c = points[i];
        var isCluster = c.numPoints;
        var f = {
            type: 1,
            geometry: [[
                    Math.round(this.options.extent * (c.x * z2 - x)),
                    Math.round(this.options.extent * (c.y * z2 - y))
                ]],
            tags: isCluster ? getClusterProperties(c) : this.points[c.index].properties
        };
        var id = void 0;
        if (isCluster) {
            id = c.id;
        } else if (this.options.generateId) {
            id = c.index;
        } else if (this.points[c.index].id) {
            id = this.points[c.index].id;
        }
        if (id !== undefined) {
            f.id = id;
        }
        tile.features.push(f);
    }
};
Supercluster.prototype._limitZoom = function _limitZoom(z) {
    return Math.max(this.options.minZoom, Math.min(+z, this.options.maxZoom + 1));
};
Supercluster.prototype._cluster = function _cluster(points, zoom) {
    var clusters = [];
    var ref = this.options;
    var radius = ref.radius;
    var extent = ref.extent;
    var reduce = ref.reduce;
    var minPoints = ref.minPoints;
    var r = radius / (extent * Math.pow(2, zoom));
    for (var i = 0; i < points.length; i++) {
        var p = points[i];
        if (p.zoom <= zoom) {
            continue;
        }
        p.zoom = zoom;
        var tree = this.trees[zoom + 1];
        var neighborIds = tree.within(p.x, p.y, r);
        var numPointsOrigin = p.numPoints || 1;
        var numPoints = numPointsOrigin;
        for (var i$1 = 0, list = neighborIds; i$1 < list.length; i$1 += 1) {
            var neighborId = list[i$1];
            var b = tree.points[neighborId];
            if (b.zoom > zoom) {
                numPoints += b.numPoints || 1;
            }
        }
        if (numPoints >= minPoints) {
            var wx = p.x * numPointsOrigin;
            var wy = p.y * numPointsOrigin;
            var clusterProperties = reduce && numPointsOrigin > 1 ? this._map(p, true) : null;
            var id = (i << 5) + (zoom + 1) + this.points.length;
            for (var i$2 = 0, list$1 = neighborIds; i$2 < list$1.length; i$2 += 1) {
                var neighborId$1 = list$1[i$2];
                var b$1 = tree.points[neighborId$1];
                if (b$1.zoom <= zoom) {
                    continue;
                }
                b$1.zoom = zoom;
                var numPoints2 = b$1.numPoints || 1;
                wx += b$1.x * numPoints2;
                wy += b$1.y * numPoints2;
                b$1.parentId = id;
                if (reduce) {
                    if (!clusterProperties) {
                        clusterProperties = this._map(p, true);
                    }
                    reduce(clusterProperties, this._map(b$1));
                }
            }
            p.parentId = id;
            clusters.push(createCluster(wx / numPoints, wy / numPoints, id, numPoints, clusterProperties));
        } else {
            clusters.push(p);
            if (numPoints > 1) {
                for (var i$3 = 0, list$2 = neighborIds; i$3 < list$2.length; i$3 += 1) {
                    var neighborId$2 = list$2[i$3];
                    var b$2 = tree.points[neighborId$2];
                    if (b$2.zoom <= zoom) {
                        continue;
                    }
                    b$2.zoom = zoom;
                    clusters.push(b$2);
                }
            }
        }
    }
    return clusters;
};
Supercluster.prototype._getOriginId = function _getOriginId(clusterId) {
    return clusterId - this.points.length >> 5;
};
Supercluster.prototype._getOriginZoom = function _getOriginZoom(clusterId) {
    return (clusterId - this.points.length) % 32;
};
Supercluster.prototype._map = function _map(point, clone) {
    if (point.numPoints) {
        return clone ? extend({}, point.properties) : point.properties;
    }
    var original = this.points[point.index].properties;
    var result = this.options.map(original);
    return clone && result === original ? extend({}, result) : result;
};
function createCluster(x, y, id, numPoints, properties) {
    return {
        x: x,
        y: y,
        zoom: Infinity,
        id: id,
        parentId: -1,
        numPoints: numPoints,
        properties: properties
    };
}
function createPointCluster(p, id) {
    var ref = p.geometry.coordinates;
    var x = ref[0];
    var y = ref[1];
    return {
        x: lngX(x),
        y: latY(y),
        zoom: Infinity,
        index: id,
        parentId: -1
    };
}
function getClusterJSON(cluster) {
    return {
        type: 'Feature',
        id: cluster.id,
        properties: getClusterProperties(cluster),
        geometry: {
            type: 'Point',
            coordinates: [
                xLng(cluster.x),
                yLat(cluster.y)
            ]
        }
    };
}
function getClusterProperties(cluster) {
    var count = cluster.numPoints;
    var abbrev = count >= 10000 ? Math.round(count / 1000) + 'k' : count >= 1000 ? Math.round(count / 100) / 10 + 'k' : count;
    return extend(extend({}, cluster.properties), {
        cluster: true,
        cluster_id: cluster.id,
        point_count: count,
        point_count_abbreviated: abbrev
    });
}
function lngX(lng) {
    return lng / 360 + 0.5;
}
function latY(lat) {
    var sin = Math.sin(lat * Math.PI / 180);
    var y = 0.5 - 0.25 * Math.log((1 + sin) / (1 - sin)) / Math.PI;
    return y < 0 ? 0 : y > 1 ? 1 : y;
}
function xLng(x) {
    return (x - 0.5) * 360;
}
function yLat(y) {
    var y2 = (180 - y * 360) * Math.PI / 180;
    return 360 * Math.atan(Math.exp(y2)) / Math.PI - 90;
}
function extend(dest, src) {
    for (var id in src) {
        dest[id] = src[id];
    }
    return dest;
}
function getX(p) {
    return p.x;
}
function getY(p) {
    return p.y;
}

function simplify(coords, first, last, sqTolerance) {
    var maxSqDist = sqTolerance;
    var mid = last - first >> 1;
    var minPosToMid = last - first;
    var index;
    var ax = coords[first];
    var ay = coords[first + 1];
    var bx = coords[last];
    var by = coords[last + 1];
    for (var i = first + 3; i < last; i += 3) {
        var d = getSqSegDist(coords[i], coords[i + 1], ax, ay, bx, by);
        if (d > maxSqDist) {
            index = i;
            maxSqDist = d;
        } else if (d === maxSqDist) {
            var posToMid = Math.abs(i - mid);
            if (posToMid < minPosToMid) {
                index = i;
                minPosToMid = posToMid;
            }
        }
    }
    if (maxSqDist > sqTolerance) {
        if (index - first > 3) {
            simplify(coords, first, index, sqTolerance);
        }
        coords[index + 2] = maxSqDist;
        if (last - index > 3) {
            simplify(coords, index, last, sqTolerance);
        }
    }
}
function getSqSegDist(px, py, x, y, bx, by) {
    var dx = bx - x;
    var dy = by - y;
    if (dx !== 0 || dy !== 0) {
        var t = ((px - x) * dx + (py - y) * dy) / (dx * dx + dy * dy);
        if (t > 1) {
            x = bx;
            y = by;
        } else if (t > 0) {
            x += dx * t;
            y += dy * t;
        }
    }
    dx = px - x;
    dy = py - y;
    return dx * dx + dy * dy;
}

function createFeature(id, type, geom, tags) {
    var feature = {
        id: typeof id === 'undefined' ? null : id,
        type: type,
        geometry: geom,
        tags: tags,
        minX: Infinity,
        minY: Infinity,
        maxX: -Infinity,
        maxY: -Infinity
    };
    calcBBox(feature);
    return feature;
}
function calcBBox(feature) {
    var geom = feature.geometry;
    var type = feature.type;
    if (type === 'Point' || type === 'MultiPoint' || type === 'LineString') {
        calcLineBBox(feature, geom);
    } else if (type === 'Polygon' || type === 'MultiLineString') {
        for (var i = 0; i < geom.length; i++) {
            calcLineBBox(feature, geom[i]);
        }
    } else if (type === 'MultiPolygon') {
        for (i = 0; i < geom.length; i++) {
            for (var j = 0; j < geom[i].length; j++) {
                calcLineBBox(feature, geom[i][j]);
            }
        }
    }
}
function calcLineBBox(feature, geom) {
    for (var i = 0; i < geom.length; i += 3) {
        feature.minX = Math.min(feature.minX, geom[i]);
        feature.minY = Math.min(feature.minY, geom[i + 1]);
        feature.maxX = Math.max(feature.maxX, geom[i]);
        feature.maxY = Math.max(feature.maxY, geom[i + 1]);
    }
}

function convert(data, options) {
    var features = [];
    if (data.type === 'FeatureCollection') {
        for (var i = 0; i < data.features.length; i++) {
            convertFeature(features, data.features[i], options, i);
        }
    } else if (data.type === 'Feature') {
        convertFeature(features, data, options);
    } else {
        convertFeature(features, { geometry: data }, options);
    }
    return features;
}
function convertFeature(features, geojson, options, index) {
    if (!geojson.geometry) {
        return;
    }
    var coords = geojson.geometry.coordinates;
    var type = geojson.geometry.type;
    var tolerance = Math.pow(options.tolerance / ((1 << options.maxZoom) * options.extent), 2);
    var geometry = [];
    var id = geojson.id;
    if (options.promoteId) {
        id = geojson.properties[options.promoteId];
    } else if (options.generateId) {
        id = index || 0;
    }
    if (type === 'Point') {
        convertPoint(coords, geometry);
    } else if (type === 'MultiPoint') {
        for (var i = 0; i < coords.length; i++) {
            convertPoint(coords[i], geometry);
        }
    } else if (type === 'LineString') {
        convertLine(coords, geometry, tolerance, false);
    } else if (type === 'MultiLineString') {
        if (options.lineMetrics) {
            for (i = 0; i < coords.length; i++) {
                geometry = [];
                convertLine(coords[i], geometry, tolerance, false);
                features.push(createFeature(id, 'LineString', geometry, geojson.properties));
            }
            return;
        } else {
            convertLines(coords, geometry, tolerance, false);
        }
    } else if (type === 'Polygon') {
        convertLines(coords, geometry, tolerance, true);
    } else if (type === 'MultiPolygon') {
        for (i = 0; i < coords.length; i++) {
            var polygon = [];
            convertLines(coords[i], polygon, tolerance, true);
            geometry.push(polygon);
        }
    } else if (type === 'GeometryCollection') {
        for (i = 0; i < geojson.geometry.geometries.length; i++) {
            convertFeature(features, {
                id: id,
                geometry: geojson.geometry.geometries[i],
                properties: geojson.properties
            }, options, index);
        }
        return;
    } else {
        throw new Error('Input data is not a valid GeoJSON object.');
    }
    features.push(createFeature(id, type, geometry, geojson.properties));
}
function convertPoint(coords, out) {
    out.push(projectX(coords[0]));
    out.push(projectY(coords[1]));
    out.push(0);
}
function convertLine(ring, out, tolerance, isPolygon) {
    var x0, y0;
    var size = 0;
    for (var j = 0; j < ring.length; j++) {
        var x = projectX(ring[j][0]);
        var y = projectY(ring[j][1]);
        out.push(x);
        out.push(y);
        out.push(0);
        if (j > 0) {
            if (isPolygon) {
                size += (x0 * y - x * y0) / 2;
            } else {
                size += Math.sqrt(Math.pow(x - x0, 2) + Math.pow(y - y0, 2));
            }
        }
        x0 = x;
        y0 = y;
    }
    var last = out.length - 3;
    out[2] = 1;
    simplify(out, 0, last, tolerance);
    out[last + 2] = 1;
    out.size = Math.abs(size);
    out.start = 0;
    out.end = out.size;
}
function convertLines(rings, out, tolerance, isPolygon) {
    for (var i = 0; i < rings.length; i++) {
        var geom = [];
        convertLine(rings[i], geom, tolerance, isPolygon);
        out.push(geom);
    }
}
function projectX(x) {
    return x / 360 + 0.5;
}
function projectY(y) {
    var sin = Math.sin(y * Math.PI / 180);
    var y2 = 0.5 - 0.25 * Math.log((1 + sin) / (1 - sin)) / Math.PI;
    return y2 < 0 ? 0 : y2 > 1 ? 1 : y2;
}

function clip(features, scale, k1, k2, axis, minAll, maxAll, options) {
    k1 /= scale;
    k2 /= scale;
    if (minAll >= k1 && maxAll < k2) {
        return features;
    } else if (maxAll < k1 || minAll >= k2) {
        return null;
    }
    var clipped = [];
    for (var i = 0; i < features.length; i++) {
        var feature = features[i];
        var geometry = feature.geometry;
        var type = feature.type;
        var min = axis === 0 ? feature.minX : feature.minY;
        var max = axis === 0 ? feature.maxX : feature.maxY;
        if (min >= k1 && max < k2) {
            clipped.push(feature);
            continue;
        } else if (max < k1 || min >= k2) {
            continue;
        }
        var newGeometry = [];
        if (type === 'Point' || type === 'MultiPoint') {
            clipPoints(geometry, newGeometry, k1, k2, axis);
        } else if (type === 'LineString') {
            clipLine(geometry, newGeometry, k1, k2, axis, false, options.lineMetrics);
        } else if (type === 'MultiLineString') {
            clipLines(geometry, newGeometry, k1, k2, axis, false);
        } else if (type === 'Polygon') {
            clipLines(geometry, newGeometry, k1, k2, axis, true);
        } else if (type === 'MultiPolygon') {
            for (var j = 0; j < geometry.length; j++) {
                var polygon = [];
                clipLines(geometry[j], polygon, k1, k2, axis, true);
                if (polygon.length) {
                    newGeometry.push(polygon);
                }
            }
        }
        if (newGeometry.length) {
            if (options.lineMetrics && type === 'LineString') {
                for (j = 0; j < newGeometry.length; j++) {
                    clipped.push(createFeature(feature.id, type, newGeometry[j], feature.tags));
                }
                continue;
            }
            if (type === 'LineString' || type === 'MultiLineString') {
                if (newGeometry.length === 1) {
                    type = 'LineString';
                    newGeometry = newGeometry[0];
                } else {
                    type = 'MultiLineString';
                }
            }
            if (type === 'Point' || type === 'MultiPoint') {
                type = newGeometry.length === 3 ? 'Point' : 'MultiPoint';
            }
            clipped.push(createFeature(feature.id, type, newGeometry, feature.tags));
        }
    }
    return clipped.length ? clipped : null;
}
function clipPoints(geom, newGeom, k1, k2, axis) {
    for (var i = 0; i < geom.length; i += 3) {
        var a = geom[i + axis];
        if (a >= k1 && a <= k2) {
            newGeom.push(geom[i]);
            newGeom.push(geom[i + 1]);
            newGeom.push(geom[i + 2]);
        }
    }
}
function clipLine(geom, newGeom, k1, k2, axis, isPolygon, trackMetrics) {
    var slice = newSlice(geom);
    var intersect = axis === 0 ? intersectX : intersectY;
    var len = geom.start;
    var segLen, t;
    for (var i = 0; i < geom.length - 3; i += 3) {
        var ax = geom[i];
        var ay = geom[i + 1];
        var az = geom[i + 2];
        var bx = geom[i + 3];
        var by = geom[i + 4];
        var a = axis === 0 ? ax : ay;
        var b = axis === 0 ? bx : by;
        var exited = false;
        if (trackMetrics) {
            segLen = Math.sqrt(Math.pow(ax - bx, 2) + Math.pow(ay - by, 2));
        }
        if (a < k1) {
            if (b > k1) {
                t = intersect(slice, ax, ay, bx, by, k1);
                if (trackMetrics) {
                    slice.start = len + segLen * t;
                }
            }
        } else if (a > k2) {
            if (b < k2) {
                t = intersect(slice, ax, ay, bx, by, k2);
                if (trackMetrics) {
                    slice.start = len + segLen * t;
                }
            }
        } else {
            addPoint(slice, ax, ay, az);
        }
        if (b < k1 && a >= k1) {
            t = intersect(slice, ax, ay, bx, by, k1);
            exited = true;
        }
        if (b > k2 && a <= k2) {
            t = intersect(slice, ax, ay, bx, by, k2);
            exited = true;
        }
        if (!isPolygon && exited) {
            if (trackMetrics) {
                slice.end = len + segLen * t;
            }
            newGeom.push(slice);
            slice = newSlice(geom);
        }
        if (trackMetrics) {
            len += segLen;
        }
    }
    var last = geom.length - 3;
    ax = geom[last];
    ay = geom[last + 1];
    az = geom[last + 2];
    a = axis === 0 ? ax : ay;
    if (a >= k1 && a <= k2) {
        addPoint(slice, ax, ay, az);
    }
    last = slice.length - 3;
    if (isPolygon && last >= 3 && (slice[last] !== slice[0] || slice[last + 1] !== slice[1])) {
        addPoint(slice, slice[0], slice[1], slice[2]);
    }
    if (slice.length) {
        newGeom.push(slice);
    }
}
function newSlice(line) {
    var slice = [];
    slice.size = line.size;
    slice.start = line.start;
    slice.end = line.end;
    return slice;
}
function clipLines(geom, newGeom, k1, k2, axis, isPolygon) {
    for (var i = 0; i < geom.length; i++) {
        clipLine(geom[i], newGeom, k1, k2, axis, isPolygon, false);
    }
}
function addPoint(out, x, y, z) {
    out.push(x);
    out.push(y);
    out.push(z);
}
function intersectX(out, ax, ay, bx, by, x) {
    var t = (x - ax) / (bx - ax);
    out.push(x);
    out.push(ay + (by - ay) * t);
    out.push(1);
    return t;
}
function intersectY(out, ax, ay, bx, by, y) {
    var t = (y - ay) / (by - ay);
    out.push(ax + (bx - ax) * t);
    out.push(y);
    out.push(1);
    return t;
}

function wrap(features, options) {
    var buffer = options.buffer / options.extent;
    var merged = features;
    var left = clip(features, 1, -1 - buffer, buffer, 0, -1, 2, options);
    var right = clip(features, 1, 1 - buffer, 2 + buffer, 0, -1, 2, options);
    if (left || right) {
        merged = clip(features, 1, -buffer, 1 + buffer, 0, -1, 2, options) || [];
        if (left) {
            merged = shiftFeatureCoords(left, 1).concat(merged);
        }
        if (right) {
            merged = merged.concat(shiftFeatureCoords(right, -1));
        }
    }
    return merged;
}
function shiftFeatureCoords(features, offset) {
    var newFeatures = [];
    for (var i = 0; i < features.length; i++) {
        var feature = features[i], type = feature.type;
        var newGeometry;
        if (type === 'Point' || type === 'MultiPoint' || type === 'LineString') {
            newGeometry = shiftCoords(feature.geometry, offset);
        } else if (type === 'MultiLineString' || type === 'Polygon') {
            newGeometry = [];
            for (var j = 0; j < feature.geometry.length; j++) {
                newGeometry.push(shiftCoords(feature.geometry[j], offset));
            }
        } else if (type === 'MultiPolygon') {
            newGeometry = [];
            for (j = 0; j < feature.geometry.length; j++) {
                var newPolygon = [];
                for (var k = 0; k < feature.geometry[j].length; k++) {
                    newPolygon.push(shiftCoords(feature.geometry[j][k], offset));
                }
                newGeometry.push(newPolygon);
            }
        }
        newFeatures.push(createFeature(feature.id, type, newGeometry, feature.tags));
    }
    return newFeatures;
}
function shiftCoords(points, offset) {
    var newPoints = [];
    newPoints.size = points.size;
    if (points.start !== undefined) {
        newPoints.start = points.start;
        newPoints.end = points.end;
    }
    for (var i = 0; i < points.length; i += 3) {
        newPoints.push(points[i] + offset, points[i + 1], points[i + 2]);
    }
    return newPoints;
}

function transformTile(tile, extent) {
    if (tile.transformed) {
        return tile;
    }
    var z2 = 1 << tile.z, tx = tile.x, ty = tile.y, i, j, k;
    for (i = 0; i < tile.features.length; i++) {
        var feature = tile.features[i], geom = feature.geometry, type = feature.type;
        feature.geometry = [];
        if (type === 1) {
            for (j = 0; j < geom.length; j += 2) {
                feature.geometry.push(transformPoint(geom[j], geom[j + 1], extent, z2, tx, ty));
            }
        } else {
            for (j = 0; j < geom.length; j++) {
                var ring = [];
                for (k = 0; k < geom[j].length; k += 2) {
                    ring.push(transformPoint(geom[j][k], geom[j][k + 1], extent, z2, tx, ty));
                }
                feature.geometry.push(ring);
            }
        }
    }
    tile.transformed = true;
    return tile;
}
function transformPoint(x, y, extent, z2, tx, ty) {
    return [
        Math.round(extent * (x * z2 - tx)),
        Math.round(extent * (y * z2 - ty))
    ];
}

function createTile(features, z, tx, ty, options) {
    var tolerance = z === options.maxZoom ? 0 : options.tolerance / ((1 << z) * options.extent);
    var tile = {
        features: [],
        numPoints: 0,
        numSimplified: 0,
        numFeatures: 0,
        source: null,
        x: tx,
        y: ty,
        z: z,
        transformed: false,
        minX: 2,
        minY: 1,
        maxX: -1,
        maxY: 0
    };
    for (var i = 0; i < features.length; i++) {
        tile.numFeatures++;
        addFeature(tile, features[i], tolerance, options);
        var minX = features[i].minX;
        var minY = features[i].minY;
        var maxX = features[i].maxX;
        var maxY = features[i].maxY;
        if (minX < tile.minX) {
            tile.minX = minX;
        }
        if (minY < tile.minY) {
            tile.minY = minY;
        }
        if (maxX > tile.maxX) {
            tile.maxX = maxX;
        }
        if (maxY > tile.maxY) {
            tile.maxY = maxY;
        }
    }
    return tile;
}
function addFeature(tile, feature, tolerance, options) {
    var geom = feature.geometry, type = feature.type, simplified = [];
    if (type === 'Point' || type === 'MultiPoint') {
        for (var i = 0; i < geom.length; i += 3) {
            simplified.push(geom[i]);
            simplified.push(geom[i + 1]);
            tile.numPoints++;
            tile.numSimplified++;
        }
    } else if (type === 'LineString') {
        addLine(simplified, geom, tile, tolerance, false, false);
    } else if (type === 'MultiLineString' || type === 'Polygon') {
        for (i = 0; i < geom.length; i++) {
            addLine(simplified, geom[i], tile, tolerance, type === 'Polygon', i === 0);
        }
    } else if (type === 'MultiPolygon') {
        for (var k = 0; k < geom.length; k++) {
            var polygon = geom[k];
            for (i = 0; i < polygon.length; i++) {
                addLine(simplified, polygon[i], tile, tolerance, true, i === 0);
            }
        }
    }
    if (simplified.length) {
        var tags = feature.tags || null;
        if (type === 'LineString' && options.lineMetrics) {
            tags = {};
            for (var key in feature.tags) {
                tags[key] = feature.tags[key];
            }
            tags['mapbox_clip_start'] = geom.start / geom.size;
            tags['mapbox_clip_end'] = geom.end / geom.size;
        }
        var tileFeature = {
            geometry: simplified,
            type: type === 'Polygon' || type === 'MultiPolygon' ? 3 : type === 'LineString' || type === 'MultiLineString' ? 2 : 1,
            tags: tags
        };
        if (feature.id !== null) {
            tileFeature.id = feature.id;
        }
        tile.features.push(tileFeature);
    }
}
function addLine(result, geom, tile, tolerance, isPolygon, isOuter) {
    var sqTolerance = tolerance * tolerance;
    if (tolerance > 0 && geom.size < (isPolygon ? sqTolerance : tolerance)) {
        tile.numPoints += geom.length / 3;
        return;
    }
    var ring = [];
    for (var i = 0; i < geom.length; i += 3) {
        if (tolerance === 0 || geom[i + 2] > sqTolerance) {
            tile.numSimplified++;
            ring.push(geom[i]);
            ring.push(geom[i + 1]);
        }
        tile.numPoints++;
    }
    if (isPolygon) {
        rewind$1(ring, isOuter);
    }
    result.push(ring);
}
function rewind$1(ring, clockwise) {
    var area = 0;
    for (var i = 0, len = ring.length, j = len - 2; i < len; j = i, i += 2) {
        area += (ring[i] - ring[j]) * (ring[i + 1] + ring[j + 1]);
    }
    if (area > 0 === clockwise) {
        for (i = 0, len = ring.length; i < len / 2; i += 2) {
            var x = ring[i];
            var y = ring[i + 1];
            ring[i] = ring[len - 2 - i];
            ring[i + 1] = ring[len - 1 - i];
            ring[len - 2 - i] = x;
            ring[len - 1 - i] = y;
        }
    }
}

function geojsonvt(data, options) {
    return new GeoJSONVT(data, options);
}
function GeoJSONVT(data, options) {
    options = this.options = extend$1(Object.create(this.options), options);
    var debug = options.debug;
    if (debug) {
        console.time('preprocess data');
    }
    if (options.maxZoom < 0 || options.maxZoom > 24) {
        throw new Error('maxZoom should be in the 0-24 range');
    }
    if (options.promoteId && options.generateId) {
        throw new Error('promoteId and generateId cannot be used together.');
    }
    var features = convert(data, options);
    this.tiles = {};
    this.tileCoords = [];
    if (debug) {
        console.timeEnd('preprocess data');
        console.log('index: maxZoom: %d, maxPoints: %d', options.indexMaxZoom, options.indexMaxPoints);
        console.time('generate tiles');
        this.stats = {};
        this.total = 0;
    }
    features = wrap(features, options);
    if (features.length) {
        this.splitTile(features, 0, 0, 0);
    }
    if (debug) {
        if (features.length) {
            console.log('features: %d, points: %d', this.tiles[0].numFeatures, this.tiles[0].numPoints);
        }
        console.timeEnd('generate tiles');
        console.log('tiles generated:', this.total, JSON.stringify(this.stats));
    }
}
GeoJSONVT.prototype.options = {
    maxZoom: 14,
    indexMaxZoom: 5,
    indexMaxPoints: 100000,
    tolerance: 3,
    extent: 4096,
    buffer: 64,
    lineMetrics: false,
    promoteId: null,
    generateId: false,
    debug: 0
};
GeoJSONVT.prototype.splitTile = function (features, z, x, y, cz, cx, cy) {
    var stack = [
            features,
            z,
            x,
            y
        ], options = this.options, debug = options.debug;
    while (stack.length) {
        y = stack.pop();
        x = stack.pop();
        z = stack.pop();
        features = stack.pop();
        var z2 = 1 << z, id = toID(z, x, y), tile = this.tiles[id];
        if (!tile) {
            if (debug > 1) {
                console.time('creation');
            }
            tile = this.tiles[id] = createTile(features, z, x, y, options);
            this.tileCoords.push({
                z: z,
                x: x,
                y: y
            });
            if (debug) {
                if (debug > 1) {
                    console.log('tile z%d-%d-%d (features: %d, points: %d, simplified: %d)', z, x, y, tile.numFeatures, tile.numPoints, tile.numSimplified);
                    console.timeEnd('creation');
                }
                var key = 'z' + z;
                this.stats[key] = (this.stats[key] || 0) + 1;
                this.total++;
            }
        }
        tile.source = features;
        if (!cz) {
            if (z === options.indexMaxZoom || tile.numPoints <= options.indexMaxPoints) {
                continue;
            }
        } else {
            if (z === options.maxZoom || z === cz) {
                continue;
            }
            var m = 1 << cz - z;
            if (x !== Math.floor(cx / m) || y !== Math.floor(cy / m)) {
                continue;
            }
        }
        tile.source = null;
        if (features.length === 0) {
            continue;
        }
        if (debug > 1) {
            console.time('clipping');
        }
        var k1 = 0.5 * options.buffer / options.extent, k2 = 0.5 - k1, k3 = 0.5 + k1, k4 = 1 + k1, tl, bl, tr, br, left, right;
        tl = bl = tr = br = null;
        left = clip(features, z2, x - k1, x + k3, 0, tile.minX, tile.maxX, options);
        right = clip(features, z2, x + k2, x + k4, 0, tile.minX, tile.maxX, options);
        features = null;
        if (left) {
            tl = clip(left, z2, y - k1, y + k3, 1, tile.minY, tile.maxY, options);
            bl = clip(left, z2, y + k2, y + k4, 1, tile.minY, tile.maxY, options);
            left = null;
        }
        if (right) {
            tr = clip(right, z2, y - k1, y + k3, 1, tile.minY, tile.maxY, options);
            br = clip(right, z2, y + k2, y + k4, 1, tile.minY, tile.maxY, options);
            right = null;
        }
        if (debug > 1) {
            console.timeEnd('clipping');
        }
        stack.push(tl || [], z + 1, x * 2, y * 2);
        stack.push(bl || [], z + 1, x * 2, y * 2 + 1);
        stack.push(tr || [], z + 1, x * 2 + 1, y * 2);
        stack.push(br || [], z + 1, x * 2 + 1, y * 2 + 1);
    }
};
GeoJSONVT.prototype.getTile = function (z, x, y) {
    var options = this.options, extent = options.extent, debug = options.debug;
    if (z < 0 || z > 24) {
        return null;
    }
    var z2 = 1 << z;
    x = (x % z2 + z2) % z2;
    var id = toID(z, x, y);
    if (this.tiles[id]) {
        return transformTile(this.tiles[id], extent);
    }
    if (debug > 1) {
        console.log('drilling down to z%d-%d-%d', z, x, y);
    }
    var z0 = z, x0 = x, y0 = y, parent;
    while (!parent && z0 > 0) {
        z0--;
        x0 = Math.floor(x0 / 2);
        y0 = Math.floor(y0 / 2);
        parent = this.tiles[toID(z0, x0, y0)];
    }
    if (!parent || !parent.source) {
        return null;
    }
    if (debug > 1) {
        console.log('found parent tile z%d-%d-%d', z0, x0, y0);
    }
    if (debug > 1) {
        console.time('drilling down');
    }
    this.splitTile(parent.source, z0, x0, y0, z, x, y);
    if (debug > 1) {
        console.timeEnd('drilling down');
    }
    return this.tiles[id] ? transformTile(this.tiles[id], extent) : null;
};
function toID(z, x, y) {
    return ((1 << z) * y + x) * 32 + z;
}
function extend$1(dest, src) {
    for (var i in src) {
        dest[i] = src[i];
    }
    return dest;
}

function loadGeoJSONTile(params, callback) {
    var canonical = params.tileID.canonical;
    if (!this._geoJSONIndex) {
        return callback(null, null);
    }
    var geoJSONTile = this._geoJSONIndex.getTile(canonical.z, canonical.x, canonical.y);
    if (!geoJSONTile) {
        return callback(null, null);
    }
    var geojsonWrapper = new GeoJSONWrapper(geoJSONTile.features);
    var pbf = vtPbf(geojsonWrapper);
    if (pbf.byteOffset !== 0 || pbf.byteLength !== pbf.buffer.byteLength) {
        pbf = new Uint8Array(pbf);
    }
    callback(null, {
        vectorTile: geojsonWrapper,
        rawData: pbf.buffer
    });
}
var GeoJSONWorkerSource = function (VectorTileWorkerSource) {
    function GeoJSONWorkerSource(actor, layerIndex, availableImages, loadGeoJSON) {
        VectorTileWorkerSource.call(this, actor, layerIndex, availableImages, loadGeoJSONTile);
        if (loadGeoJSON) {
            this.loadGeoJSON = loadGeoJSON;
        }
    }
    if (VectorTileWorkerSource)
        GeoJSONWorkerSource.__proto__ = VectorTileWorkerSource;
    GeoJSONWorkerSource.prototype = Object.create(VectorTileWorkerSource && VectorTileWorkerSource.prototype);
    GeoJSONWorkerSource.prototype.constructor = GeoJSONWorkerSource;
    GeoJSONWorkerSource.prototype.loadData = function loadData(params, callback) {
        if (this._pendingCallback) {
            this._pendingCallback(null, { abandoned: true });
        }
        this._pendingCallback = callback;
        this._pendingLoadDataParams = params;
        if (this._state && this._state !== 'Idle') {
            this._state = 'NeedsLoadData';
        } else {
            this._state = 'Coalescing';
            this._loadData();
        }
    };
    GeoJSONWorkerSource.prototype._loadData = function _loadData() {
        var this$1 = this;
        if (!this._pendingCallback || !this._pendingLoadDataParams) {
            return;
        }
        var callback = this._pendingCallback;
        var params = this._pendingLoadDataParams;
        delete this._pendingCallback;
        delete this._pendingLoadDataParams;
        var perf = params && params.request && params.request.collectResourceTiming ? new performance.RequestPerformance(params.request) : false;
        this.loadGeoJSON(params, function (err, data) {
            if (err || !data) {
                return callback(err);
            } else if (typeof data !== 'object') {
                return callback(new Error('Input data given to \'' + params.source + '\' is not a valid GeoJSON object.'));
            } else {
                geojsonRewind(data, true);
                try {
                    if (params.filter) {
                        var compiled = performance.createExpression(params.filter, {
                            type: 'boolean',
                            'property-type': 'data-driven',
                            overridable: false,
                            transition: false
                        });
                        if (compiled.result === 'error') {
                            throw new Error(compiled.value.map(function (err) {
                                return err.key + ': ' + err.message;
                            }).join(', '));
                        }
                        var features = data.features.filter(function (feature) {
                            return compiled.value.evaluate({ zoom: 0 }, feature);
                        });
                        data = {
                            type: 'FeatureCollection',
                            features: features
                        };
                    }
                    this$1._geoJSONIndex = params.cluster ? new Supercluster(getSuperclusterOptions(params)).load(data.features) : geojsonvt(data, params.geojsonVtOptions);
                } catch (err) {
                    return callback(err);
                }
                this$1.loaded = {};
                var result = {};
                if (perf) {
                    var resourceTimingData = perf.finish();
                    if (resourceTimingData) {
                        result.resourceTiming = {};
                        result.resourceTiming[params.source] = JSON.parse(JSON.stringify(resourceTimingData));
                    }
                }
                callback(null, result);
            }
        });
    };
    GeoJSONWorkerSource.prototype.coalesce = function coalesce() {
        if (this._state === 'Coalescing') {
            this._state = 'Idle';
        } else if (this._state === 'NeedsLoadData') {
            this._state = 'Coalescing';
            this._loadData();
        }
    };
    GeoJSONWorkerSource.prototype.reloadTile = function reloadTile(params, callback) {
        var loaded = this.loaded, uid = params.uid;
        if (loaded && loaded[uid]) {
            return VectorTileWorkerSource.prototype.reloadTile.call(this, params, callback);
        } else {
            return this.loadTile(params, callback);
        }
    };
    GeoJSONWorkerSource.prototype.loadGeoJSON = function loadGeoJSON(params, callback) {
        if (params.request) {
            performance.getJSON(params.request, callback);
        } else if (typeof params.data === 'string') {
            try {
                return callback(null, JSON.parse(params.data));
            } catch (e) {
                return callback(new Error('Input data given to \'' + params.source + '\' is not a valid GeoJSON object.'));
            }
        } else {
            return callback(new Error('Input data given to \'' + params.source + '\' is not a valid GeoJSON object.'));
        }
    };
    GeoJSONWorkerSource.prototype.removeSource = function removeSource(params, callback) {
        if (this._pendingCallback) {
            this._pendingCallback(null, { abandoned: true });
        }
        callback();
    };
    GeoJSONWorkerSource.prototype.getClusterExpansionZoom = function getClusterExpansionZoom(params, callback) {
        try {
            callback(null, this._geoJSONIndex.getClusterExpansionZoom(params.clusterId));
        } catch (e) {
            callback(e);
        }
    };
    GeoJSONWorkerSource.prototype.getClusterChildren = function getClusterChildren(params, callback) {
        try {
            callback(null, this._geoJSONIndex.getChildren(params.clusterId));
        } catch (e) {
            callback(e);
        }
    };
    GeoJSONWorkerSource.prototype.getClusterLeaves = function getClusterLeaves(params, callback) {
        try {
            callback(null, this._geoJSONIndex.getLeaves(params.clusterId, params.limit, params.offset));
        } catch (e) {
            callback(e);
        }
    };
    return GeoJSONWorkerSource;
}(VectorTileWorkerSource);
function getSuperclusterOptions(ref) {
    var superclusterOptions = ref.superclusterOptions;
    var clusterProperties = ref.clusterProperties;
    if (!clusterProperties || !superclusterOptions) {
        return superclusterOptions;
    }
    var mapExpressions = {};
    var reduceExpressions = {};
    var globals = {
        accumulated: null,
        zoom: 0
    };
    var feature = { properties: null };
    var propertyNames = Object.keys(clusterProperties);
    for (var i = 0, list = propertyNames; i < list.length; i += 1) {
        var key = list[i];
        var ref$1 = clusterProperties[key];
        var operator = ref$1[0];
        var mapExpression = ref$1[1];
        var mapExpressionParsed = performance.createExpression(mapExpression);
        var reduceExpressionParsed = performance.createExpression(typeof operator === 'string' ? [
            operator,
            ['accumulated'],
            [
                'get',
                key
            ]
        ] : operator);
        mapExpressions[key] = mapExpressionParsed.value;
        reduceExpressions[key] = reduceExpressionParsed.value;
    }
    superclusterOptions.map = function (pointProperties) {
        feature.properties = pointProperties;
        var properties = {};
        for (var i = 0, list = propertyNames; i < list.length; i += 1) {
            var key = list[i];
            properties[key] = mapExpressions[key].evaluate(globals, feature);
        }
        return properties;
    };
    superclusterOptions.reduce = function (accumulated, clusterProperties) {
        feature.properties = clusterProperties;
        for (var i = 0, list = propertyNames; i < list.length; i += 1) {
            var key = list[i];
            globals.accumulated = accumulated[key];
            accumulated[key] = reduceExpressions[key].evaluate(globals, feature);
        }
    };
    return superclusterOptions;
}

var Worker = function Worker(self) {
    var this$1 = this;
    this.self = self;
    this.actor = new performance.Actor(self, this);
    this.layerIndexes = {};
    this.availableImages = {};
    this.workerSourceTypes = {
        vector: VectorTileWorkerSource,
        geojson: GeoJSONWorkerSource
    };
    this.workerSources = {};
    this.demWorkerSources = {};
    this.self.registerWorkerSource = function (name, WorkerSource) {
        if (this$1.workerSourceTypes[name]) {
            throw new Error('Worker source with name "' + name + '" already registered.');
        }
        this$1.workerSourceTypes[name] = WorkerSource;
    };
    this.self.registerRTLTextPlugin = function (rtlTextPlugin) {
        if (performance.plugin.isParsed()) {
            throw new Error('RTL text plugin already registered.');
        }
        performance.plugin['applyArabicShaping'] = rtlTextPlugin.applyArabicShaping;
        performance.plugin['processBidirectionalText'] = rtlTextPlugin.processBidirectionalText;
        performance.plugin['processStyledBidirectionalText'] = rtlTextPlugin.processStyledBidirectionalText;
    };
};
Worker.prototype.setReferrer = function setReferrer(mapID, referrer) {
    this.referrer = referrer;
};
Worker.prototype.setImages = function setImages(mapId, images, callback) {
    this.availableImages[mapId] = images;
    for (var workerSource in this.workerSources[mapId]) {
        var ws = this.workerSources[mapId][workerSource];
        for (var source in ws) {
            ws[source].availableImages = images;
        }
    }
    callback();
};
Worker.prototype.setLayers = function setLayers(mapId, layers, callback) {
    this.getLayerIndex(mapId).replace(layers);
    callback();
};
Worker.prototype.updateLayers = function updateLayers(mapId, params, callback) {
    this.getLayerIndex(mapId).update(params.layers, params.removedIds);
    callback();
};
Worker.prototype.loadTile = function loadTile(mapId, params, callback) {
    this.getWorkerSource(mapId, params.type, params.source).loadTile(params, callback);
};
Worker.prototype.loadDEMTile = function loadDEMTile(mapId, params, callback) {
    this.getDEMWorkerSource(mapId, params.source).loadTile(params, callback);
};
Worker.prototype.reloadTile = function reloadTile(mapId, params, callback) {
    this.getWorkerSource(mapId, params.type, params.source).reloadTile(params, callback);
};
Worker.prototype.abortTile = function abortTile(mapId, params, callback) {
    this.getWorkerSource(mapId, params.type, params.source).abortTile(params, callback);
};
Worker.prototype.removeTile = function removeTile(mapId, params, callback) {
    this.getWorkerSource(mapId, params.type, params.source).removeTile(params, callback);
};
Worker.prototype.removeDEMTile = function removeDEMTile(mapId, params) {
    this.getDEMWorkerSource(mapId, params.source).removeTile(params);
};
Worker.prototype.removeSource = function removeSource(mapId, params, callback) {
    if (!this.workerSources[mapId] || !this.workerSources[mapId][params.type] || !this.workerSources[mapId][params.type][params.source]) {
        return;
    }
    var worker = this.workerSources[mapId][params.type][params.source];
    delete this.workerSources[mapId][params.type][params.source];
    if (worker.removeSource !== undefined) {
        worker.removeSource(params, callback);
    } else {
        callback();
    }
};
Worker.prototype.loadWorkerSource = function loadWorkerSource(map, params, callback) {
    try {
        this.self.importScripts(params.url);
        callback();
    } catch (e) {
        callback(e.toString());
    }
};
Worker.prototype.syncRTLPluginState = function syncRTLPluginState(map, state, callback) {
    try {
        performance.plugin.setState(state);
        var pluginURL = performance.plugin.getPluginURL();
        if (performance.plugin.isLoaded() && !performance.plugin.isParsed() && pluginURL != null) {
            this.self.importScripts(pluginURL);
            var complete = performance.plugin.isParsed();
            var error = complete ? undefined : new Error('RTL Text Plugin failed to import scripts from ' + pluginURL);
            callback(error, complete);
        }
    } catch (e) {
        callback(e.toString());
    }
};
Worker.prototype.getAvailableImages = function getAvailableImages(mapId) {
    var availableImages = this.availableImages[mapId];
    if (!availableImages) {
        availableImages = [];
    }
    return availableImages;
};
Worker.prototype.getLayerIndex = function getLayerIndex(mapId) {
    var layerIndexes = this.layerIndexes[mapId];
    if (!layerIndexes) {
        layerIndexes = this.layerIndexes[mapId] = new StyleLayerIndex();
    }
    return layerIndexes;
};
Worker.prototype.getWorkerSource = function getWorkerSource(mapId, type, source) {
    var this$1 = this;
    if (!this.workerSources[mapId]) {
        this.workerSources[mapId] = {};
    }
    if (!this.workerSources[mapId][type]) {
        this.workerSources[mapId][type] = {};
    }
    if (!this.workerSources[mapId][type][source]) {
        var actor = {
            send: function (type, data, callback) {
                this$1.actor.send(type, data, callback, mapId);
            }
        };
        this.workerSources[mapId][type][source] = new this.workerSourceTypes[type](actor, this.getLayerIndex(mapId), this.getAvailableImages(mapId));
    }
    return this.workerSources[mapId][type][source];
};
Worker.prototype.getDEMWorkerSource = function getDEMWorkerSource(mapId, source) {
    if (!this.demWorkerSources[mapId]) {
        this.demWorkerSources[mapId] = {};
    }
    if (!this.demWorkerSources[mapId][source]) {
        this.demWorkerSources[mapId][source] = new RasterDEMTileWorkerSource();
    }
    return this.demWorkerSources[mapId][source];
};
Worker.prototype.enforceCacheSizeLimit = function enforceCacheSizeLimit$1(mapId, limit) {
    performance.enforceCacheSizeLimit(limit);
};
if (typeof WorkerGlobalScope !== 'undefined' && typeof self !== 'undefined' && self instanceof WorkerGlobalScope) {
    self.worker = new Worker(self);
}

return Worker;

});

define(['./shared'], function (performance) { 'use strict';

var mapboxGlSupported = performance.createCommonjsModule(function (module) {
if ( module.exports) {
    module.exports = isSupported;
} else if (window) {
    window.mapboxgl = window.mapboxgl || {};
    window.mapboxgl.supported = isSupported;
    window.mapboxgl.notSupportedReason = notSupportedReason;
}
function isSupported(options) {
    return !notSupportedReason(options);
}
function notSupportedReason(options) {
    if (!isBrowser()) {
        return 'not a browser';
    }
    if (!isArraySupported()) {
        return 'insufficent Array support';
    }
    if (!isFunctionSupported()) {
        return 'insufficient Function support';
    }
    if (!isObjectSupported()) {
        return 'insufficient Object support';
    }
    if (!isJSONSupported()) {
        return 'insufficient JSON support';
    }
    if (!isWorkerSupported()) {
        return 'insufficient worker support';
    }
    if (!isUint8ClampedArraySupported()) {
        return 'insufficient Uint8ClampedArray support';
    }
    if (!isArrayBufferSupported()) {
        return 'insufficient ArrayBuffer support';
    }
    if (!isCanvasGetImageDataSupported()) {
        return 'insufficient Canvas/getImageData support';
    }
    if (!isWebGLSupportedCached(options && options.failIfMajorPerformanceCaveat)) {
        return 'insufficient WebGL support';
    }
}
function isBrowser() {
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}
function isArraySupported() {
    return Array.prototype && Array.prototype.every && Array.prototype.filter && Array.prototype.forEach && Array.prototype.indexOf && Array.prototype.lastIndexOf && Array.prototype.map && Array.prototype.some && Array.prototype.reduce && Array.prototype.reduceRight && Array.isArray;
}
function isFunctionSupported() {
    return Function.prototype && Function.prototype.bind;
}
function isObjectSupported() {
    return Object.keys && Object.create && Object.getPrototypeOf && Object.getOwnPropertyNames && Object.isSealed && Object.isFrozen && Object.isExtensible && Object.getOwnPropertyDescriptor && Object.defineProperty && Object.defineProperties && Object.seal && Object.freeze && Object.preventExtensions;
}
function isJSONSupported() {
    return 'JSON' in window && 'parse' in JSON && 'stringify' in JSON;
}
function isWorkerSupported() {
    if (!('Worker' in window && 'Blob' in window && 'URL' in window)) {
        return false;
    }
    var blob = new Blob([''], { type: 'text/javascript' });
    var workerURL = URL.createObjectURL(blob);
    var supported;
    var worker;
    try {
        worker = new Worker(workerURL);
        supported = true;
    } catch (e) {
        supported = false;
    }
    if (worker) {
        worker.terminate();
    }
    URL.revokeObjectURL(workerURL);
    return supported;
}
function isUint8ClampedArraySupported() {
    return 'Uint8ClampedArray' in window;
}
function isArrayBufferSupported() {
    return ArrayBuffer.isView;
}
function isCanvasGetImageDataSupported() {
    var canvas = document.createElement('canvas');
    canvas.width = canvas.height = 1;
    var context = canvas.getContext('2d');
    if (!context) {
        return false;
    }
    var imageData = context.getImageData(0, 0, 1, 1);
    return imageData && imageData.width === canvas.width;
}
var isWebGLSupportedCache = {};
function isWebGLSupportedCached(failIfMajorPerformanceCaveat) {
    if (isWebGLSupportedCache[failIfMajorPerformanceCaveat] === undefined) {
        isWebGLSupportedCache[failIfMajorPerformanceCaveat] = isWebGLSupported(failIfMajorPerformanceCaveat);
    }
    return isWebGLSupportedCache[failIfMajorPerformanceCaveat];
}
isSupported.webGLContextAttributes = {
    antialias: false,
    alpha: true,
    stencil: true,
    depth: true
};
function getWebGLContext(failIfMajorPerformanceCaveat) {
    var canvas = document.createElement('canvas');
    var attributes = Object.create(isSupported.webGLContextAttributes);
    attributes.failIfMajorPerformanceCaveat = failIfMajorPerformanceCaveat;
    if (canvas.probablySupportsContext) {
        return canvas.probablySupportsContext('webgl', attributes) || canvas.probablySupportsContext('experimental-webgl', attributes);
    } else if (canvas.supportsContext) {
        return canvas.supportsContext('webgl', attributes) || canvas.supportsContext('experimental-webgl', attributes);
    } else {
        return canvas.getContext('webgl', attributes) || canvas.getContext('experimental-webgl', attributes);
    }
}
function isWebGLSupported(failIfMajorPerformanceCaveat) {
    var gl = getWebGLContext(failIfMajorPerformanceCaveat);
    if (!gl) {
        return false;
    }
    var shader = gl.createShader(gl.VERTEX_SHADER);
    if (!shader || gl.isContextLost()) {
        return false;
    }
    gl.shaderSource(shader, 'void main() {}');
    gl.compileShader(shader);
    return gl.getShaderParameter(shader, gl.COMPILE_STATUS) === true;
}
});

var DOM = {};
DOM.create = function (tagName, className, container) {
    var el = performance.window.document.createElement(tagName);
    if (className !== undefined) {
        el.className = className;
    }
    if (container) {
        container.appendChild(el);
    }
    return el;
};
DOM.createNS = function (namespaceURI, tagName) {
    var el = performance.window.document.createElementNS(namespaceURI, tagName);
    return el;
};
var docStyle = performance.window.document && performance.window.document.documentElement.style;
function testProp(props) {
    if (!docStyle) {
        return props[0];
    }
    for (var i = 0; i < props.length; i++) {
        if (props[i] in docStyle) {
            return props[i];
        }
    }
    return props[0];
}
var selectProp = testProp([
    'userSelect',
    'MozUserSelect',
    'WebkitUserSelect',
    'msUserSelect'
]);
var userSelect;
DOM.disableDrag = function () {
    if (docStyle && selectProp) {
        userSelect = docStyle[selectProp];
        docStyle[selectProp] = 'none';
    }
};
DOM.enableDrag = function () {
    if (docStyle && selectProp) {
        docStyle[selectProp] = userSelect;
    }
};
var transformProp = testProp([
    'transform',
    'WebkitTransform'
]);
DOM.setTransform = function (el, value) {
    el.style[transformProp] = value;
};
var passiveSupported = false;
try {
    var options$1 = Object.defineProperty({}, 'passive', {
        get: function get() {
            passiveSupported = true;
        }
    });
    performance.window.addEventListener('test', options$1, options$1);
    performance.window.removeEventListener('test', options$1, options$1);
} catch (err) {
    passiveSupported = false;
}
DOM.addEventListener = function (target, type, callback, options) {
    if (options === void 0)
        options = {};
    if ('passive' in options && passiveSupported) {
        target.addEventListener(type, callback, options);
    } else {
        target.addEventListener(type, callback, options.capture);
    }
};
DOM.removeEventListener = function (target, type, callback, options) {
    if (options === void 0)
        options = {};
    if ('passive' in options && passiveSupported) {
        target.removeEventListener(type, callback, options);
    } else {
        target.removeEventListener(type, callback, options.capture);
    }
};
var suppressClick = function (e) {
    e.preventDefault();
    e.stopPropagation();
    performance.window.removeEventListener('click', suppressClick, true);
};
DOM.suppressClick = function () {
    performance.window.addEventListener('click', suppressClick, true);
    performance.window.setTimeout(function () {
        performance.window.removeEventListener('click', suppressClick, true);
    }, 0);
};
DOM.mousePos = function (el, e) {
    var rect = el.getBoundingClientRect();
    return new performance.Point(e.clientX - rect.left - el.clientLeft, e.clientY - rect.top - el.clientTop);
};
DOM.touchPos = function (el, touches) {
    var rect = el.getBoundingClientRect(), points = [];
    for (var i = 0; i < touches.length; i++) {
        points.push(new performance.Point(touches[i].clientX - rect.left - el.clientLeft, touches[i].clientY - rect.top - el.clientTop));
    }
    return points;
};
DOM.mouseButton = function (e) {
    if (typeof performance.window.InstallTrigger !== 'undefined' && e.button === 2 && e.ctrlKey && performance.window.navigator.platform.toUpperCase().indexOf('MAC') >= 0) {
        return 0;
    }
    return e.button;
};
DOM.remove = function (node) {
    if (node.parentNode) {
        node.parentNode.removeChild(node);
    }
};

function loadSprite (baseURL, requestManager, callback) {
    var json, image, error;
    var format = performance.browser.devicePixelRatio > 1 ? '@2x' : '';
    var jsonRequest = performance.getJSON(requestManager.transformRequest(requestManager.normalizeSpriteURL(baseURL, format, '.json'), performance.ResourceType.SpriteJSON), function (err, data) {
        jsonRequest = null;
        if (!error) {
            error = err;
            json = data;
            maybeComplete();
        }
    });
    var imageRequest = performance.getImage(requestManager.transformRequest(requestManager.normalizeSpriteURL(baseURL, format, '.png'), performance.ResourceType.SpriteImage), function (err, img) {
        imageRequest = null;
        if (!error) {
            error = err;
            image = img;
            maybeComplete();
        }
    });
    function maybeComplete() {
        if (error) {
            callback(error);
        } else if (json && image) {
            var imageData = performance.browser.getImageData(image);
            var result = {};
            for (var id in json) {
                var ref = json[id];
                var width = ref.width;
                var height = ref.height;
                var x = ref.x;
                var y = ref.y;
                var sdf = ref.sdf;
                var pixelRatio = ref.pixelRatio;
                var stretchX = ref.stretchX;
                var stretchY = ref.stretchY;
                var content = ref.content;
                var data = new performance.RGBAImage({
                    width: width,
                    height: height
                });
                performance.RGBAImage.copy(imageData, data, {
                    x: x,
                    y: y
                }, {
                    x: 0,
                    y: 0
                }, {
                    width: width,
                    height: height
                });
                result[id] = {
                    data: data,
                    pixelRatio: pixelRatio,
                    sdf: sdf,
                    stretchX: stretchX,
                    stretchY: stretchY,
                    content: content
                };
            }
            callback(null, result);
        }
    }
    return {
        cancel: function cancel() {
            if (jsonRequest) {
                jsonRequest.cancel();
                jsonRequest = null;
            }
            if (imageRequest) {
                imageRequest.cancel();
                imageRequest = null;
            }
        }
    };
}

function renderStyleImage(image) {
    var userImage = image.userImage;
    if (userImage && userImage.render) {
        var updated = userImage.render();
        if (updated) {
            image.data.replace(new Uint8Array(userImage.data.buffer));
            return true;
        }
    }
    return false;
}

var padding = 1;
var ImageManager = function (Evented) {
    function ImageManager() {
        Evented.call(this);
        this.images = {};
        this.updatedImages = {};
        this.callbackDispatchedThisFrame = {};
        this.loaded = false;
        this.requestors = [];
        this.patterns = {};
        this.atlasImage = new performance.RGBAImage({
            width: 1,
            height: 1
        });
        this.dirty = true;
    }
    if (Evented)
        ImageManager.__proto__ = Evented;
    ImageManager.prototype = Object.create(Evented && Evented.prototype);
    ImageManager.prototype.constructor = ImageManager;
    ImageManager.prototype.isLoaded = function isLoaded() {
        return this.loaded;
    };
    ImageManager.prototype.setLoaded = function setLoaded(loaded) {
        if (this.loaded === loaded) {
            return;
        }
        this.loaded = loaded;
        if (loaded) {
            for (var i = 0, list = this.requestors; i < list.length; i += 1) {
                var ref = list[i];
                var ids = ref.ids;
                var callback = ref.callback;
                this._notify(ids, callback);
            }
            this.requestors = [];
        }
    };
    ImageManager.prototype.getImage = function getImage(id) {
        return this.images[id];
    };
    ImageManager.prototype.addImage = function addImage(id, image) {
        if (this._validate(id, image)) {
            this.images[id] = image;
        }
    };
    ImageManager.prototype._validate = function _validate(id, image) {
        var valid = true;
        if (!this._validateStretch(image.stretchX, image.data && image.data.width)) {
            this.fire(new performance.ErrorEvent(new Error('Image "' + id + '" has invalid "stretchX" value')));
            valid = false;
        }
        if (!this._validateStretch(image.stretchY, image.data && image.data.height)) {
            this.fire(new performance.ErrorEvent(new Error('Image "' + id + '" has invalid "stretchY" value')));
            valid = false;
        }
        if (!this._validateContent(image.content, image)) {
            this.fire(new performance.ErrorEvent(new Error('Image "' + id + '" has invalid "content" value')));
            valid = false;
        }
        return valid;
    };
    ImageManager.prototype._validateStretch = function _validateStretch(stretch, size) {
        if (!stretch) {
            return true;
        }
        var last = 0;
        for (var i = 0, list = stretch; i < list.length; i += 1) {
            var part = list[i];
            if (part[0] < last || part[1] < part[0] || size < part[1]) {
                return false;
            }
            last = part[1];
        }
        return true;
    };
    ImageManager.prototype._validateContent = function _validateContent(content, image) {
        if (!content) {
            return true;
        }
        if (content.length !== 4) {
            return false;
        }
        if (content[0] < 0 || image.data.width < content[0]) {
            return false;
        }
        if (content[1] < 0 || image.data.height < content[1]) {
            return false;
        }
        if (content[2] < 0 || image.data.width < content[2]) {
            return false;
        }
        if (content[3] < 0 || image.data.height < content[3]) {
            return false;
        }
        if (content[2] < content[0]) {
            return false;
        }
        if (content[3] < content[1]) {
            return false;
        }
        return true;
    };
    ImageManager.prototype.updateImage = function updateImage(id, image) {
        var oldImage = this.images[id];
        image.version = oldImage.version + 1;
        this.images[id] = image;
        this.updatedImages[id] = true;
    };
    ImageManager.prototype.removeImage = function removeImage(id) {
        var image = this.images[id];
        delete this.images[id];
        delete this.patterns[id];
        if (image.userImage && image.userImage.onRemove) {
            image.userImage.onRemove();
        }
    };
    ImageManager.prototype.listImages = function listImages() {
        return Object.keys(this.images);
    };
    ImageManager.prototype.getImages = function getImages(ids, callback) {
        var hasAllDependencies = true;
        if (!this.isLoaded()) {
            for (var i = 0, list = ids; i < list.length; i += 1) {
                var id = list[i];
                if (!this.images[id]) {
                    hasAllDependencies = false;
                }
            }
        }
        if (this.isLoaded() || hasAllDependencies) {
            this._notify(ids, callback);
        } else {
            this.requestors.push({
                ids: ids,
                callback: callback
            });
        }
    };
    ImageManager.prototype._notify = function _notify(ids, callback) {
        var response = {};
        for (var i = 0, list = ids; i < list.length; i += 1) {
            var id = list[i];
            if (!this.images[id]) {
                this.fire(new performance.Event('styleimagemissing', { id: id }));
            }
            var image = this.images[id];
            if (image) {
                response[id] = {
                    data: image.data.clone(),
                    pixelRatio: image.pixelRatio,
                    sdf: image.sdf,
                    version: image.version,
                    stretchX: image.stretchX,
                    stretchY: image.stretchY,
                    content: image.content,
                    hasRenderCallback: Boolean(image.userImage && image.userImage.render)
                };
            } else {
                performance.warnOnce('Image "' + id + '" could not be loaded. Please make sure you have added the image with map.addImage() or a "sprite" property in your style. You can provide missing images by listening for the "styleimagemissing" map event.');
            }
        }
        callback(null, response);
    };
    ImageManager.prototype.getPixelSize = function getPixelSize() {
        var ref = this.atlasImage;
        var width = ref.width;
        var height = ref.height;
        return {
            width: width,
            height: height
        };
    };
    ImageManager.prototype.getPattern = function getPattern(id) {
        var pattern = this.patterns[id];
        var image = this.getImage(id);
        if (!image) {
            return null;
        }
        if (pattern && pattern.position.version === image.version) {
            return pattern.position;
        }
        if (!pattern) {
            var w = image.data.width + padding * 2;
            var h = image.data.height + padding * 2;
            var bin = {
                w: w,
                h: h,
                x: 0,
                y: 0
            };
            var position = new performance.ImagePosition(bin, image);
            this.patterns[id] = {
                bin: bin,
                position: position
            };
        } else {
            pattern.position.version = image.version;
        }
        this._updatePatternAtlas();
        return this.patterns[id].position;
    };
    ImageManager.prototype.bind = function bind(context) {
        var gl = context.gl;
        if (!this.atlasTexture) {
            this.atlasTexture = new performance.Texture(context, this.atlasImage, gl.RGBA);
        } else if (this.dirty) {
            this.atlasTexture.update(this.atlasImage);
            this.dirty = false;
        }
        this.atlasTexture.bind(gl.LINEAR, gl.CLAMP_TO_EDGE);
    };
    ImageManager.prototype._updatePatternAtlas = function _updatePatternAtlas() {
        var bins = [];
        for (var id in this.patterns) {
            bins.push(this.patterns[id].bin);
        }
        var ref = performance.potpack(bins);
        var w = ref.w;
        var h = ref.h;
        var dst = this.atlasImage;
        dst.resize({
            width: w || 1,
            height: h || 1
        });
        for (var id$1 in this.patterns) {
            var ref$1 = this.patterns[id$1];
            var bin = ref$1.bin;
            var x = bin.x + padding;
            var y = bin.y + padding;
            var src = this.images[id$1].data;
            var w$1 = src.width;
            var h$1 = src.height;
            performance.RGBAImage.copy(src, dst, {
                x: 0,
                y: 0
            }, {
                x: x,
                y: y
            }, {
                width: w$1,
                height: h$1
            });
            performance.RGBAImage.copy(src, dst, {
                x: 0,
                y: h$1 - 1
            }, {
                x: x,
                y: y - 1
            }, {
                width: w$1,
                height: 1
            });
            performance.RGBAImage.copy(src, dst, {
                x: 0,
                y: 0
            }, {
                x: x,
                y: y + h$1
            }, {
                width: w$1,
                height: 1
            });
            performance.RGBAImage.copy(src, dst, {
                x: w$1 - 1,
                y: 0
            }, {
                x: x - 1,
                y: y
            }, {
                width: 1,
                height: h$1
            });
            performance.RGBAImage.copy(src, dst, {
                x: 0,
                y: 0
            }, {
                x: x + w$1,
                y: y
            }, {
                width: 1,
                height: h$1
            });
        }
        this.dirty = true;
    };
    ImageManager.prototype.beginFrame = function beginFrame() {
        this.callbackDispatchedThisFrame = {};
    };
    ImageManager.prototype.dispatchRenderCallbacks = function dispatchRenderCallbacks(ids) {
        for (var i = 0, list = ids; i < list.length; i += 1) {
            var id = list[i];
            if (this.callbackDispatchedThisFrame[id]) {
                continue;
            }
            this.callbackDispatchedThisFrame[id] = true;
            var image = this.images[id];
            var updated = renderStyleImage(image);
            if (updated) {
                this.updateImage(id, image);
            }
        }
    };
    return ImageManager;
}(performance.Evented);

function loadGlyphRange (fontstack, range, urlTemplate, requestManager, callback) {
    var begin = range * 256;
    var end = begin + 255;
    var request = requestManager.transformRequest(requestManager.normalizeGlyphsURL(urlTemplate).replace('{fontstack}', fontstack).replace('{range}', begin + '-' + end), performance.ResourceType.Glyphs);
    performance.getArrayBuffer(request, function (err, data) {
        if (err) {
            callback(err);
        } else if (data) {
            var glyphs = {};
            for (var i = 0, list = performance.parseGlyphPBF(data); i < list.length; i += 1) {
                var glyph = list[i];
                glyphs[glyph.id] = glyph;
            }
            callback(null, glyphs);
        }
    });
}

var tinySdf = TinySDF;
var default_1 = TinySDF;
var INF = 100000000000000000000;
function TinySDF(fontSize, buffer, radius, cutoff, fontFamily, fontWeight) {
    this.fontSize = fontSize || 24;
    this.buffer = buffer === undefined ? 3 : buffer;
    this.cutoff = cutoff || 0.25;
    this.fontFamily = fontFamily || 'sans-serif';
    this.fontWeight = fontWeight || 'normal';
    this.radius = radius || 8;
    var size = this.size = this.fontSize + this.buffer * 2;
    this.canvas = document.createElement('canvas');
    this.canvas.width = this.canvas.height = size;
    this.ctx = this.canvas.getContext('2d');
    this.ctx.font = this.fontWeight + ' ' + this.fontSize + 'px ' + this.fontFamily;
    this.ctx.textBaseline = 'middle';
    this.ctx.fillStyle = 'black';
    this.gridOuter = new Float64Array(size * size);
    this.gridInner = new Float64Array(size * size);
    this.f = new Float64Array(size);
    this.d = new Float64Array(size);
    this.z = new Float64Array(size + 1);
    this.v = new Int16Array(size);
    this.middle = Math.round(size / 2 * (navigator.userAgent.indexOf('Gecko/') >= 0 ? 1.2 : 1));
}
TinySDF.prototype.draw = function (char) {
    this.ctx.clearRect(0, 0, this.size, this.size);
    this.ctx.fillText(char, this.buffer, this.middle);
    var imgData = this.ctx.getImageData(0, 0, this.size, this.size);
    var alphaChannel = new Uint8ClampedArray(this.size * this.size);
    for (var i = 0; i < this.size * this.size; i++) {
        var a = imgData.data[i * 4 + 3] / 255;
        this.gridOuter[i] = a === 1 ? 0 : a === 0 ? INF : Math.pow(Math.max(0, 0.5 - a), 2);
        this.gridInner[i] = a === 1 ? INF : a === 0 ? 0 : Math.pow(Math.max(0, a - 0.5), 2);
    }
    edt(this.gridOuter, this.size, this.size, this.f, this.d, this.v, this.z);
    edt(this.gridInner, this.size, this.size, this.f, this.d, this.v, this.z);
    for (i = 0; i < this.size * this.size; i++) {
        var d = this.gridOuter[i] - this.gridInner[i];
        alphaChannel[i] = Math.max(0, Math.min(255, Math.round(255 - 255 * (d / this.radius + this.cutoff))));
    }
    return alphaChannel;
};
function edt(data, width, height, f, d, v, z) {
    for (var x = 0; x < width; x++) {
        for (var y = 0; y < height; y++) {
            f[y] = data[y * width + x];
        }
        edt1d(f, d, v, z, height);
        for (y = 0; y < height; y++) {
            data[y * width + x] = d[y];
        }
    }
    for (y = 0; y < height; y++) {
        for (x = 0; x < width; x++) {
            f[x] = data[y * width + x];
        }
        edt1d(f, d, v, z, width);
        for (x = 0; x < width; x++) {
            data[y * width + x] = Math.sqrt(d[x]);
        }
    }
}
function edt1d(f, d, v, z, n) {
    v[0] = 0;
    z[0] = -INF;
    z[1] = +INF;
    for (var q = 1, k = 0; q < n; q++) {
        var s = (f[q] + q * q - (f[v[k]] + v[k] * v[k])) / (2 * q - 2 * v[k]);
        while (s <= z[k]) {
            k--;
            s = (f[q] + q * q - (f[v[k]] + v[k] * v[k])) / (2 * q - 2 * v[k]);
        }
        k++;
        v[k] = q;
        z[k] = s;
        z[k + 1] = +INF;
    }
    for (q = 0, k = 0; q < n; q++) {
        while (z[k + 1] < q) {
            k++;
        }
        d[q] = (q - v[k]) * (q - v[k]) + f[v[k]];
    }
}
tinySdf.default = default_1;

var GlyphManager = function GlyphManager(requestManager, localIdeographFontFamily) {
    this.requestManager = requestManager;
    this.localIdeographFontFamily = localIdeographFontFamily;
    this.entries = {};
};
GlyphManager.prototype.setURL = function setURL(url) {
    this.url = url;
};
GlyphManager.prototype.getGlyphs = function getGlyphs(glyphs, callback) {
    var this$1 = this;
    var all = [];
    for (var stack in glyphs) {
        for (var i = 0, list = glyphs[stack]; i < list.length; i += 1) {
            var id = list[i];
            all.push({
                stack: stack,
                id: id
            });
        }
    }
    performance.asyncAll(all, function (ref, callback) {
        var stack = ref.stack;
        var id = ref.id;
        var entry = this$1.entries[stack];
        if (!entry) {
            entry = this$1.entries[stack] = {
                glyphs: {},
                requests: {},
                ranges: {}
            };
        }
        var glyph = entry.glyphs[id];
        if (glyph !== undefined) {
            callback(null, {
                stack: stack,
                id: id,
                glyph: glyph
            });
            return;
        }
        glyph = this$1._tinySDF(entry, stack, id);
        if (glyph) {
            entry.glyphs[id] = glyph;
            callback(null, {
                stack: stack,
                id: id,
                glyph: glyph
            });
            return;
        }
        var range = Math.floor(id / 256);
        if (range * 256 > 65535) {
            callback(new Error('glyphs > 65535 not supported'));
            return;
        }
        if (entry.ranges[range]) {
            callback(null, {
                stack: stack,
                id: id,
                glyph: glyph
            });
            return;
        }
        var requests = entry.requests[range];
        if (!requests) {
            requests = entry.requests[range] = [];
            GlyphManager.loadGlyphRange(stack, range, this$1.url, this$1.requestManager, function (err, response) {
                if (response) {
                    for (var id in response) {
                        if (!this$1._doesCharSupportLocalGlyph(+id)) {
                            entry.glyphs[+id] = response[+id];
                        }
                    }
                    entry.ranges[range] = true;
                }
                for (var i = 0, list = requests; i < list.length; i += 1) {
                    var cb = list[i];
                    cb(err, response);
                }
                delete entry.requests[range];
            });
        }
        requests.push(function (err, result) {
            if (err) {
                callback(err);
            } else if (result) {
                callback(null, {
                    stack: stack,
                    id: id,
                    glyph: result[id] || null
                });
            }
        });
    }, function (err, glyphs) {
        if (err) {
            callback(err);
        } else if (glyphs) {
            var result = {};
            for (var i = 0, list = glyphs; i < list.length; i += 1) {
                var ref = list[i];
                var stack = ref.stack;
                var id = ref.id;
                var glyph = ref.glyph;
                (result[stack] || (result[stack] = {}))[id] = glyph && {
                    id: glyph.id,
                    bitmap: glyph.bitmap.clone(),
                    metrics: glyph.metrics
                };
            }
            callback(null, result);
        }
    });
};
GlyphManager.prototype._doesCharSupportLocalGlyph = function _doesCharSupportLocalGlyph(id) {
    return !!this.localIdeographFontFamily && (performance.isChar['CJK Unified Ideographs'](id) || performance.isChar['Hangul Syllables'](id) || performance.isChar['Hiragana'](id) || performance.isChar['Katakana'](id));
};
GlyphManager.prototype._tinySDF = function _tinySDF(entry, stack, id) {
    var family = this.localIdeographFontFamily;
    if (!family) {
        return;
    }
    if (!this._doesCharSupportLocalGlyph(id)) {
        return;
    }
    var tinySDF = entry.tinySDF;
    if (!tinySDF) {
        var fontWeight = '400';
        if (/bold/i.test(stack)) {
            fontWeight = '900';
        } else if (/medium/i.test(stack)) {
            fontWeight = '500';
        } else if (/light/i.test(stack)) {
            fontWeight = '200';
        }
        tinySDF = entry.tinySDF = new GlyphManager.TinySDF(24, 3, 8, 0.25, family, fontWeight);
    }
    return {
        id: id,
        bitmap: new performance.AlphaImage({
            width: 30,
            height: 30
        }, tinySDF.draw(String.fromCharCode(id))),
        metrics: {
            width: 24,
            height: 24,
            left: 0,
            top: -8,
            advance: 24
        }
    };
};
GlyphManager.loadGlyphRange = loadGlyphRange;
GlyphManager.TinySDF = tinySdf;

var LightPositionProperty = function LightPositionProperty() {
    this.specification = performance.styleSpec.light.position;
};
LightPositionProperty.prototype.possiblyEvaluate = function possiblyEvaluate(value, parameters) {
    return performance.sphericalToCartesian(value.expression.evaluate(parameters));
};
LightPositionProperty.prototype.interpolate = function interpolate$1(a, b, t) {
    return {
        x: performance.number(a.x, b.x, t),
        y: performance.number(a.y, b.y, t),
        z: performance.number(a.z, b.z, t)
    };
};
var properties = new performance.Properties({
    'anchor': new performance.DataConstantProperty(performance.styleSpec.light.anchor),
    'position': new LightPositionProperty(),
    'color': new performance.DataConstantProperty(performance.styleSpec.light.color),
    'intensity': new performance.DataConstantProperty(performance.styleSpec.light.intensity)
});
var TRANSITION_SUFFIX = '-transition';
var Light = function (Evented) {
    function Light(lightOptions) {
        Evented.call(this);
        this._transitionable = new performance.Transitionable(properties);
        this.setLight(lightOptions);
        this._transitioning = this._transitionable.untransitioned();
    }
    if (Evented)
        Light.__proto__ = Evented;
    Light.prototype = Object.create(Evented && Evented.prototype);
    Light.prototype.constructor = Light;
    Light.prototype.getLight = function getLight() {
        return this._transitionable.serialize();
    };
    Light.prototype.setLight = function setLight(light, options) {
        if (options === void 0)
            options = {};
        if (this._validate(performance.validateLight, light, options)) {
            return;
        }
        for (var name in light) {
            var value = light[name];
            if (performance.endsWith(name, TRANSITION_SUFFIX)) {
                this._transitionable.setTransition(name.slice(0, -TRANSITION_SUFFIX.length), value);
            } else {
                this._transitionable.setValue(name, value);
            }
        }
    };
    Light.prototype.updateTransitions = function updateTransitions(parameters) {
        this._transitioning = this._transitionable.transitioned(parameters, this._transitioning);
    };
    Light.prototype.hasTransition = function hasTransition() {
        return this._transitioning.hasTransition();
    };
    Light.prototype.recalculate = function recalculate(parameters) {
        this.properties = this._transitioning.possiblyEvaluate(parameters);
    };
    Light.prototype._validate = function _validate(validate, value, options) {
        if (options && options.validate === false) {
            return false;
        }
        return performance.emitValidationErrors(this, validate.call(performance.validateStyle, performance.extend({
            value: value,
            style: {
                glyphs: true,
                sprite: true
            },
            styleSpec: performance.styleSpec
        })));
    };
    return Light;
}(performance.Evented);

var LineAtlas = function LineAtlas(width, height) {
    this.width = width;
    this.height = height;
    this.nextRow = 0;
    this.data = new Uint8Array(this.width * this.height);
    this.dashEntry = {};
};
LineAtlas.prototype.getDash = function getDash(dasharray, round) {
    var key = dasharray.join(',') + String(round);
    if (!this.dashEntry[key]) {
        this.dashEntry[key] = this.addDash(dasharray, round);
    }
    return this.dashEntry[key];
};
LineAtlas.prototype.getDashRanges = function getDashRanges(dasharray, lineAtlasWidth, stretch) {
    var oddDashArray = dasharray.length % 2 === 1;
    var ranges = [];
    var left = oddDashArray ? -dasharray[dasharray.length - 1] * stretch : 0;
    var right = dasharray[0] * stretch;
    var isDash = true;
    ranges.push({
        left: left,
        right: right,
        isDash: isDash,
        zeroLength: dasharray[0] === 0
    });
    var currentDashLength = dasharray[0];
    for (var i = 1; i < dasharray.length; i++) {
        isDash = !isDash;
        var dashLength = dasharray[i];
        left = currentDashLength * stretch;
        currentDashLength += dashLength;
        right = currentDashLength * stretch;
        ranges.push({
            left: left,
            right: right,
            isDash: isDash,
            zeroLength: dashLength === 0
        });
    }
    return ranges;
};
LineAtlas.prototype.addRoundDash = function addRoundDash(ranges, stretch, n) {
    var halfStretch = stretch / 2;
    for (var y = -n; y <= n; y++) {
        var row = this.nextRow + n + y;
        var index = this.width * row;
        var currIndex = 0;
        var range = ranges[currIndex];
        for (var x = 0; x < this.width; x++) {
            if (x / range.right > 1) {
                range = ranges[++currIndex];
            }
            var distLeft = Math.abs(x - range.left);
            var distRight = Math.abs(x - range.right);
            var minDist = Math.min(distLeft, distRight);
            var signedDistance = void 0;
            var distMiddle = y / n * (halfStretch + 1);
            if (range.isDash) {
                var distEdge = halfStretch - Math.abs(distMiddle);
                signedDistance = Math.sqrt(minDist * minDist + distEdge * distEdge);
            } else {
                signedDistance = halfStretch - Math.sqrt(minDist * minDist + distMiddle * distMiddle);
            }
            this.data[index + x] = Math.max(0, Math.min(255, signedDistance + 128));
        }
    }
};
LineAtlas.prototype.addRegularDash = function addRegularDash(ranges) {
    for (var i = ranges.length - 1; i >= 0; --i) {
        var part = ranges[i];
        var next = ranges[i + 1];
        if (part.zeroLength) {
            ranges.splice(i, 1);
        } else if (next && next.isDash === part.isDash) {
            next.left = part.left;
            ranges.splice(i, 1);
        }
    }
    var first = ranges[0];
    var last = ranges[ranges.length - 1];
    if (first.isDash === last.isDash) {
        first.left = last.left - this.width;
        last.right = first.right + this.width;
    }
    var index = this.width * this.nextRow;
    var currIndex = 0;
    var range = ranges[currIndex];
    for (var x = 0; x < this.width; x++) {
        if (x / range.right > 1) {
            range = ranges[++currIndex];
        }
        var distLeft = Math.abs(x - range.left);
        var distRight = Math.abs(x - range.right);
        var minDist = Math.min(distLeft, distRight);
        var signedDistance = range.isDash ? minDist : -minDist;
        this.data[index + x] = Math.max(0, Math.min(255, signedDistance + 128));
    }
};
LineAtlas.prototype.addDash = function addDash(dasharray, round) {
    var n = round ? 7 : 0;
    var height = 2 * n + 1;
    if (this.nextRow + height > this.height) {
        performance.warnOnce('LineAtlas out of space');
        return null;
    }
    var length = 0;
    for (var i = 0; i < dasharray.length; i++) {
        length += dasharray[i];
    }
    if (length !== 0) {
        var stretch = this.width / length;
        var ranges = this.getDashRanges(dasharray, this.width, stretch);
        if (round) {
            this.addRoundDash(ranges, stretch, n);
        } else {
            this.addRegularDash(ranges);
        }
    }
    var dashEntry = {
        y: (this.nextRow + n + 0.5) / this.height,
        height: 2 * n / this.height,
        width: length
    };
    this.nextRow += height;
    this.dirty = true;
    return dashEntry;
};
LineAtlas.prototype.bind = function bind(context) {
    var gl = context.gl;
    if (!this.texture) {
        this.texture = gl.createTexture();
        gl.bindTexture(gl.TEXTURE_2D, this.texture);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.REPEAT);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.REPEAT);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.ALPHA, this.width, this.height, 0, gl.ALPHA, gl.UNSIGNED_BYTE, this.data);
    } else {
        gl.bindTexture(gl.TEXTURE_2D, this.texture);
        if (this.dirty) {
            this.dirty = false;
            gl.texSubImage2D(gl.TEXTURE_2D, 0, 0, 0, this.width, this.height, gl.ALPHA, gl.UNSIGNED_BYTE, this.data);
        }
    }
};

var Dispatcher = function Dispatcher(workerPool, parent) {
    this.workerPool = workerPool;
    this.actors = [];
    this.currentActor = 0;
    this.id = performance.uniqueId();
    var workers = this.workerPool.acquire(this.id);
    for (var i = 0; i < workers.length; i++) {
        var worker = workers[i];
        var actor = new Dispatcher.Actor(worker, parent, this.id);
        actor.name = 'Worker ' + i;
        this.actors.push(actor);
    }
};
Dispatcher.prototype.broadcast = function broadcast(type, data, cb) {
    cb = cb || function () {
    };
    performance.asyncAll(this.actors, function (actor, done) {
        actor.send(type, data, done);
    }, cb);
};
Dispatcher.prototype.getActor = function getActor() {
    this.currentActor = (this.currentActor + 1) % this.actors.length;
    return this.actors[this.currentActor];
};
Dispatcher.prototype.remove = function remove() {
    this.actors.forEach(function (actor) {
        actor.remove();
    });
    this.actors = [];
    this.workerPool.release(this.id);
};
Dispatcher.Actor = performance.Actor;

function loadTileJSON (options, requestManager, callback) {
    var loaded = function (err, tileJSON) {
        if (err) {
            return callback(err);
        } else if (tileJSON) {
            var result = performance.pick(performance.extend(tileJSON, options), [
                'tiles',
                'minzoom',
                'maxzoom',
                'attribution',
                'mapbox_logo',
                'bounds',
                'scheme',
                'tileSize',
                'encoding'
            ]);
            if (tileJSON.vector_layers) {
                result.vectorLayers = tileJSON.vector_layers;
                result.vectorLayerIds = result.vectorLayers.map(function (layer) {
                    return layer.id;
                });
            }
            result.tiles = requestManager.canonicalizeTileset(result, options.url);
            callback(null, result);
        }
    };
    if (options.url) {
        return performance.getJSON(requestManager.transformRequest(requestManager.normalizeSourceURL(options.url), performance.ResourceType.Source), loaded);
    } else {
        return performance.browser.frame(function () {
            return loaded(null, options);
        });
    }
}

var TileBounds = function TileBounds(bounds, minzoom, maxzoom) {
    this.bounds = performance.LngLatBounds.convert(this.validateBounds(bounds));
    this.minzoom = minzoom || 0;
    this.maxzoom = maxzoom || 24;
};
TileBounds.prototype.validateBounds = function validateBounds(bounds) {
    if (!Array.isArray(bounds) || bounds.length !== 4) {
        return [
            -180,
            -90,
            180,
            90
        ];
    }
    return [
        Math.max(-180, bounds[0]),
        Math.max(-90, bounds[1]),
        Math.min(180, bounds[2]),
        Math.min(90, bounds[3])
    ];
};
TileBounds.prototype.contains = function contains(tileID) {
    var worldSize = Math.pow(2, tileID.z);
    var level = {
        minX: Math.floor(performance.mercatorXfromLng(this.bounds.getWest()) * worldSize),
        minY: Math.floor(performance.mercatorYfromLat(this.bounds.getNorth()) * worldSize),
        maxX: Math.ceil(performance.mercatorXfromLng(this.bounds.getEast()) * worldSize),
        maxY: Math.ceil(performance.mercatorYfromLat(this.bounds.getSouth()) * worldSize)
    };
    var hit = tileID.x >= level.minX && tileID.x < level.maxX && tileID.y >= level.minY && tileID.y < level.maxY;
    return hit;
};

var VectorTileSource = function (Evented) {
    function VectorTileSource(id, options, dispatcher, eventedParent) {
        Evented.call(this);
        this.id = id;
        this.dispatcher = dispatcher;
        this.type = 'vector';
        this.minzoom = 0;
        this.maxzoom = 22;
        this.scheme = 'xyz';
        this.tileSize = 512;
        this.reparseOverscaled = true;
        this.isTileClipped = true;
        this._loaded = false;
        performance.extend(this, performance.pick(options, [
            'url',
            'scheme',
            'tileSize',
            'promoteId'
        ]));
        this._options = performance.extend({ type: 'vector' }, options);
        this._collectResourceTiming = options.collectResourceTiming;
        if (this.tileSize !== 512) {
            throw new Error('vector tile sources must have a tileSize of 512');
        }
        this.setEventedParent(eventedParent);
    }
    if (Evented)
        VectorTileSource.__proto__ = Evented;
    VectorTileSource.prototype = Object.create(Evented && Evented.prototype);
    VectorTileSource.prototype.constructor = VectorTileSource;
    VectorTileSource.prototype.load = function load() {
        var this$1 = this;
        this._loaded = false;
        this.fire(new performance.Event('dataloading', { dataType: 'source' }));
        this._tileJSONRequest = loadTileJSON(this._options, this.map._requestManager, function (err, tileJSON) {
            this$1._tileJSONRequest = null;
            this$1._loaded = true;
            if (err) {
                this$1.fire(new performance.ErrorEvent(err));
            } else if (tileJSON) {
                performance.extend(this$1, tileJSON);
                if (tileJSON.bounds) {
                    this$1.tileBounds = new TileBounds(tileJSON.bounds, this$1.minzoom, this$1.maxzoom);
                }
                performance.postTurnstileEvent(tileJSON.tiles, this$1.map._requestManager._customAccessToken);
                performance.postMapLoadEvent(tileJSON.tiles, this$1.map._getMapId(), this$1.map._requestManager._skuToken, this$1.map._requestManager._customAccessToken);
                this$1.fire(new performance.Event('data', {
                    dataType: 'source',
                    sourceDataType: 'metadata'
                }));
                this$1.fire(new performance.Event('data', {
                    dataType: 'source',
                    sourceDataType: 'content'
                }));
            }
        });
    };
    VectorTileSource.prototype.loaded = function loaded() {
        return this._loaded;
    };
    VectorTileSource.prototype.hasTile = function hasTile(tileID) {
        return !this.tileBounds || this.tileBounds.contains(tileID.canonical);
    };
    VectorTileSource.prototype.onAdd = function onAdd(map) {
        this.map = map;
        this.load();
    };
    VectorTileSource.prototype.setSourceProperty = function setSourceProperty(callback) {
        if (this._tileJSONRequest) {
            this._tileJSONRequest.cancel();
        }
        callback();
        var sourceCache = this.map.style.sourceCaches[this.id];
        sourceCache.clearTiles();
        this.load();
    };
    VectorTileSource.prototype.setTiles = function setTiles(tiles) {
        var this$1 = this;
        this.setSourceProperty(function () {
            this$1._options.tiles = tiles;
        });
        return this;
    };
    VectorTileSource.prototype.setUrl = function setUrl(url) {
        var this$1 = this;
        this.setSourceProperty(function () {
            this$1.url = url;
            this$1._options.url = url;
        });
        return this;
    };
    VectorTileSource.prototype.onRemove = function onRemove() {
        if (this._tileJSONRequest) {
            this._tileJSONRequest.cancel();
            this._tileJSONRequest = null;
        }
    };
    VectorTileSource.prototype.serialize = function serialize() {
        return performance.extend({}, this._options);
    };
    VectorTileSource.prototype.loadTile = function loadTile(tile, callback) {
        var url = this.map._requestManager.normalizeTileURL(tile.tileID.canonical.url(this.tiles, this.scheme));
        var params = {
            request: this.map._requestManager.transformRequest(url, performance.ResourceType.Tile),
            uid: tile.uid,
            tileID: tile.tileID,
            zoom: tile.tileID.overscaledZ,
            tileSize: this.tileSize * tile.tileID.overscaleFactor(),
            type: this.type,
            source: this.id,
            pixelRatio: performance.browser.devicePixelRatio,
            showCollisionBoxes: this.map.showCollisionBoxes,
            promoteId: this.promoteId
        };
        params.request.collectResourceTiming = this._collectResourceTiming;
        if (!tile.actor || tile.state === 'expired') {
            tile.actor = this.dispatcher.getActor();
            tile.request = tile.actor.send('loadTile', params, done.bind(this));
        } else if (tile.state === 'loading') {
            tile.reloadCallback = callback;
        } else {
            tile.request = tile.actor.send('reloadTile', params, done.bind(this));
        }
        function done(err, data) {
            delete tile.request;
            if (tile.aborted) {
                return callback(null);
            }
            if (err && err.status !== 404) {
                return callback(err);
            }
            if (data && data.resourceTiming) {
                tile.resourceTiming = data.resourceTiming;
            }
            if (this.map._refreshExpiredTiles && data) {
                tile.setExpiryData(data);
            }
            tile.loadVectorData(data, this.map.painter);
            performance.cacheEntryPossiblyAdded(this.dispatcher);
            callback(null);
            if (tile.reloadCallback) {
                this.loadTile(tile, tile.reloadCallback);
                tile.reloadCallback = null;
            }
        }
    };
    VectorTileSource.prototype.abortTile = function abortTile(tile) {
        if (tile.request) {
            tile.request.cancel();
            delete tile.request;
        }
        if (tile.actor) {
            tile.actor.send('abortTile', {
                uid: tile.uid,
                type: this.type,
                source: this.id
            }, undefined);
        }
    };
    VectorTileSource.prototype.unloadTile = function unloadTile(tile) {
        tile.unloadVectorData();
        if (tile.actor) {
            tile.actor.send('removeTile', {
                uid: tile.uid,
                type: this.type,
                source: this.id
            }, undefined);
        }
    };
    VectorTileSource.prototype.hasTransition = function hasTransition() {
        return false;
    };
    return VectorTileSource;
}(performance.Evented);

var RasterTileSource = function (Evented) {
    function RasterTileSource(id, options, dispatcher, eventedParent) {
        Evented.call(this);
        this.id = id;
        this.dispatcher = dispatcher;
        this.setEventedParent(eventedParent);
        this.type = 'raster';
        this.minzoom = 0;
        this.maxzoom = 22;
        this.roundZoom = true;
        this.scheme = 'xyz';
        this.tileSize = 512;
        this._loaded = false;
        this._options = performance.extend({ type: 'raster' }, options);
        performance.extend(this, performance.pick(options, [
            'url',
            'scheme',
            'tileSize'
        ]));
    }
    if (Evented)
        RasterTileSource.__proto__ = Evented;
    RasterTileSource.prototype = Object.create(Evented && Evented.prototype);
    RasterTileSource.prototype.constructor = RasterTileSource;
    RasterTileSource.prototype.load = function load() {
        var this$1 = this;
        this._loaded = false;
        this.fire(new performance.Event('dataloading', { dataType: 'source' }));
        this._tileJSONRequest = loadTileJSON(this._options, this.map._requestManager, function (err, tileJSON) {
            this$1._tileJSONRequest = null;
            this$1._loaded = true;
            if (err) {
                this$1.fire(new performance.ErrorEvent(err));
            } else if (tileJSON) {
                performance.extend(this$1, tileJSON);
                if (tileJSON.bounds) {
                    this$1.tileBounds = new TileBounds(tileJSON.bounds, this$1.minzoom, this$1.maxzoom);
                }
                performance.postTurnstileEvent(tileJSON.tiles);
                performance.postMapLoadEvent(tileJSON.tiles, this$1.map._getMapId(), this$1.map._requestManager._skuToken);
                this$1.fire(new performance.Event('data', {
                    dataType: 'source',
                    sourceDataType: 'metadata'
                }));
                this$1.fire(new performance.Event('data', {
                    dataType: 'source',
                    sourceDataType: 'content'
                }));
            }
        });
    };
    RasterTileSource.prototype.loaded = function loaded() {
        return this._loaded;
    };
    RasterTileSource.prototype.onAdd = function onAdd(map) {
        this.map = map;
        this.load();
    };
    RasterTileSource.prototype.onRemove = function onRemove() {
        if (this._tileJSONRequest) {
            this._tileJSONRequest.cancel();
            this._tileJSONRequest = null;
        }
    };
    RasterTileSource.prototype.serialize = function serialize() {
        return performance.extend({}, this._options);
    };
    RasterTileSource.prototype.hasTile = function hasTile(tileID) {
        return !this.tileBounds || this.tileBounds.contains(tileID.canonical);
    };
    RasterTileSource.prototype.loadTile = function loadTile(tile, callback) {
        var this$1 = this;
        var url = this.map._requestManager.normalizeTileURL(tile.tileID.canonical.url(this.tiles, this.scheme), this.tileSize);
        tile.request = performance.getImage(this.map._requestManager.transformRequest(url, performance.ResourceType.Tile), function (err, img) {
            delete tile.request;
            if (tile.aborted) {
                tile.state = 'unloaded';
                callback(null);
            } else if (err) {
                tile.state = 'errored';
                callback(err);
            } else if (img) {
                if (this$1.map._refreshExpiredTiles) {
                    tile.setExpiryData(img);
                }
                delete img.cacheControl;
                delete img.expires;
                var context = this$1.map.painter.context;
                var gl = context.gl;
                tile.texture = this$1.map.painter.getTileTexture(img.width);
                if (tile.texture) {
                    tile.texture.update(img, { useMipmap: true });
                } else {
                    tile.texture = new performance.Texture(context, img, gl.RGBA, { useMipmap: true });
                    tile.texture.bind(gl.LINEAR, gl.CLAMP_TO_EDGE, gl.LINEAR_MIPMAP_NEAREST);
                    if (context.extTextureFilterAnisotropic) {
                        gl.texParameterf(gl.TEXTURE_2D, context.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, context.extTextureFilterAnisotropicMax);
                    }
                }
                tile.state = 'loaded';
                performance.cacheEntryPossiblyAdded(this$1.dispatcher);
                callback(null);
            }
        });
    };
    RasterTileSource.prototype.abortTile = function abortTile(tile, callback) {
        if (tile.request) {
            tile.request.cancel();
            delete tile.request;
        }
        callback();
    };
    RasterTileSource.prototype.unloadTile = function unloadTile(tile, callback) {
        if (tile.texture) {
            this.map.painter.saveTileTexture(tile.texture);
        }
        callback();
    };
    RasterTileSource.prototype.hasTransition = function hasTransition() {
        return false;
    };
    return RasterTileSource;
}(performance.Evented);

var RasterDEMTileSource = function (RasterTileSource) {
    function RasterDEMTileSource(id, options, dispatcher, eventedParent) {
        RasterTileSource.call(this, id, options, dispatcher, eventedParent);
        this.type = 'raster-dem';
        this.maxzoom = 22;
        this._options = performance.extend({ type: 'raster-dem' }, options);
        this.encoding = options.encoding || 'mapbox';
    }
    if (RasterTileSource)
        RasterDEMTileSource.__proto__ = RasterTileSource;
    RasterDEMTileSource.prototype = Object.create(RasterTileSource && RasterTileSource.prototype);
    RasterDEMTileSource.prototype.constructor = RasterDEMTileSource;
    RasterDEMTileSource.prototype.serialize = function serialize() {
        return {
            type: 'raster-dem',
            url: this.url,
            tileSize: this.tileSize,
            tiles: this.tiles,
            bounds: this.bounds,
            encoding: this.encoding
        };
    };
    RasterDEMTileSource.prototype.loadTile = function loadTile(tile, callback) {
        var url = this.map._requestManager.normalizeTileURL(tile.tileID.canonical.url(this.tiles, this.scheme), this.tileSize);
        tile.request = performance.getImage(this.map._requestManager.transformRequest(url, performance.ResourceType.Tile), imageLoaded.bind(this));
        tile.neighboringTiles = this._getNeighboringTiles(tile.tileID);
        function imageLoaded(err, img) {
            delete tile.request;
            if (tile.aborted) {
                tile.state = 'unloaded';
                callback(null);
            } else if (err) {
                tile.state = 'errored';
                callback(err);
            } else if (img) {
                if (this.map._refreshExpiredTiles) {
                    tile.setExpiryData(img);
                }
                delete img.cacheControl;
                delete img.expires;
                var transfer = performance.window.ImageBitmap && img instanceof performance.window.ImageBitmap && performance.offscreenCanvasSupported();
                var rawImageData = transfer ? img : performance.browser.getImageData(img, 1);
                var params = {
                    uid: tile.uid,
                    coord: tile.tileID,
                    source: this.id,
                    rawImageData: rawImageData,
                    encoding: this.encoding
                };
                if (!tile.actor || tile.state === 'expired') {
                    tile.actor = this.dispatcher.getActor();
                    tile.actor.send('loadDEMTile', params, done.bind(this));
                }
            }
        }
        function done(err, dem) {
            if (err) {
                tile.state = 'errored';
                callback(err);
            }
            if (dem) {
                tile.dem = dem;
                tile.needsHillshadePrepare = true;
                tile.state = 'loaded';
                callback(null);
            }
        }
    };
    RasterDEMTileSource.prototype._getNeighboringTiles = function _getNeighboringTiles(tileID) {
        var canonical = tileID.canonical;
        var dim = Math.pow(2, canonical.z);
        var px = (canonical.x - 1 + dim) % dim;
        var pxw = canonical.x === 0 ? tileID.wrap - 1 : tileID.wrap;
        var nx = (canonical.x + 1 + dim) % dim;
        var nxw = canonical.x + 1 === dim ? tileID.wrap + 1 : tileID.wrap;
        var neighboringTiles = {};
        neighboringTiles[new performance.OverscaledTileID(tileID.overscaledZ, pxw, canonical.z, px, canonical.y).key] = { backfilled: false };
        neighboringTiles[new performance.OverscaledTileID(tileID.overscaledZ, nxw, canonical.z, nx, canonical.y).key] = { backfilled: false };
        if (canonical.y > 0) {
            neighboringTiles[new performance.OverscaledTileID(tileID.overscaledZ, pxw, canonical.z, px, canonical.y - 1).key] = { backfilled: false };
            neighboringTiles[new performance.OverscaledTileID(tileID.overscaledZ, tileID.wrap, canonical.z, canonical.x, canonical.y - 1).key] = { backfilled: false };
            neighboringTiles[new performance.OverscaledTileID(tileID.overscaledZ, nxw, canonical.z, nx, canonical.y - 1).key] = { backfilled: false };
        }
        if (canonical.y + 1 < dim) {
            neighboringTiles[new performance.OverscaledTileID(tileID.overscaledZ, pxw, canonical.z, px, canonical.y + 1).key] = { backfilled: false };
            neighboringTiles[new performance.OverscaledTileID(tileID.overscaledZ, tileID.wrap, canonical.z, canonical.x, canonical.y + 1).key] = { backfilled: false };
            neighboringTiles[new performance.OverscaledTileID(tileID.overscaledZ, nxw, canonical.z, nx, canonical.y + 1).key] = { backfilled: false };
        }
        return neighboringTiles;
    };
    RasterDEMTileSource.prototype.unloadTile = function unloadTile(tile) {
        if (tile.demTexture) {
            this.map.painter.saveTileTexture(tile.demTexture);
        }
        if (tile.fbo) {
            tile.fbo.destroy();
            delete tile.fbo;
        }
        if (tile.dem) {
            delete tile.dem;
        }
        delete tile.neighboringTiles;
        tile.state = 'unloaded';
        if (tile.actor) {
            tile.actor.send('removeDEMTile', {
                uid: tile.uid,
                source: this.id
            });
        }
    };
    return RasterDEMTileSource;
}(RasterTileSource);

var GeoJSONSource = function (Evented) {
    function GeoJSONSource(id, options, dispatcher, eventedParent) {
        Evented.call(this);
        this.id = id;
        this.type = 'geojson';
        this.minzoom = 0;
        this.maxzoom = 18;
        this.tileSize = 512;
        this.isTileClipped = true;
        this.reparseOverscaled = true;
        this._removed = false;
        this._loaded = false;
        this.actor = dispatcher.getActor();
        this.setEventedParent(eventedParent);
        this._data = options.data;
        this._options = performance.extend({}, options);
        this._collectResourceTiming = options.collectResourceTiming;
        this._resourceTiming = [];
        if (options.maxzoom !== undefined) {
            this.maxzoom = options.maxzoom;
        }
        if (options.type) {
            this.type = options.type;
        }
        if (options.attribution) {
            this.attribution = options.attribution;
        }
        this.promoteId = options.promoteId;
        var scale = performance.EXTENT / this.tileSize;
        this.workerOptions = performance.extend({
            source: this.id,
            cluster: options.cluster || false,
            geojsonVtOptions: {
                buffer: (options.buffer !== undefined ? options.buffer : 128) * scale,
                tolerance: (options.tolerance !== undefined ? options.tolerance : 0.375) * scale,
                extent: performance.EXTENT,
                maxZoom: this.maxzoom,
                lineMetrics: options.lineMetrics || false,
                generateId: options.generateId || false
            },
            superclusterOptions: {
                maxZoom: options.clusterMaxZoom !== undefined ? Math.min(options.clusterMaxZoom, this.maxzoom - 1) : this.maxzoom - 1,
                minPoints: Math.max(2, options.clusterMinPoints || 2),
                extent: performance.EXTENT,
                radius: (options.clusterRadius || 50) * scale,
                log: false,
                generateId: options.generateId || false
            },
            clusterProperties: options.clusterProperties,
            filter: options.filter
        }, options.workerOptions);
    }
    if (Evented)
        GeoJSONSource.__proto__ = Evented;
    GeoJSONSource.prototype = Object.create(Evented && Evented.prototype);
    GeoJSONSource.prototype.constructor = GeoJSONSource;
    GeoJSONSource.prototype.load = function load() {
        var this$1 = this;
        this.fire(new performance.Event('dataloading', { dataType: 'source' }));
        this._updateWorkerData(function (err) {
            if (err) {
                this$1.fire(new performance.ErrorEvent(err));
                return;
            }
            var data = {
                dataType: 'source',
                sourceDataType: 'metadata'
            };
            if (this$1._collectResourceTiming && this$1._resourceTiming && this$1._resourceTiming.length > 0) {
                data.resourceTiming = this$1._resourceTiming;
                this$1._resourceTiming = [];
            }
            this$1.fire(new performance.Event('data', data));
        });
    };
    GeoJSONSource.prototype.onAdd = function onAdd(map) {
        this.map = map;
        this.load();
    };
    GeoJSONSource.prototype.setData = function setData(data) {
        var this$1 = this;
        this._data = data;
        this.fire(new performance.Event('dataloading', { dataType: 'source' }));
        this._updateWorkerData(function (err) {
            if (err) {
                this$1.fire(new performance.ErrorEvent(err));
                return;
            }
            var data = {
                dataType: 'source',
                sourceDataType: 'content'
            };
            if (this$1._collectResourceTiming && this$1._resourceTiming && this$1._resourceTiming.length > 0) {
                data.resourceTiming = this$1._resourceTiming;
                this$1._resourceTiming = [];
            }
            this$1.fire(new performance.Event('data', data));
        });
        return this;
    };
    GeoJSONSource.prototype.getClusterExpansionZoom = function getClusterExpansionZoom(clusterId, callback) {
        this.actor.send('geojson.getClusterExpansionZoom', {
            clusterId: clusterId,
            source: this.id
        }, callback);
        return this;
    };
    GeoJSONSource.prototype.getClusterChildren = function getClusterChildren(clusterId, callback) {
        this.actor.send('geojson.getClusterChildren', {
            clusterId: clusterId,
            source: this.id
        }, callback);
        return this;
    };
    GeoJSONSource.prototype.getClusterLeaves = function getClusterLeaves(clusterId, limit, offset, callback) {
        this.actor.send('geojson.getClusterLeaves', {
            source: this.id,
            clusterId: clusterId,
            limit: limit,
            offset: offset
        }, callback);
        return this;
    };
    GeoJSONSource.prototype._updateWorkerData = function _updateWorkerData(callback) {
        var this$1 = this;
        this._loaded = false;
        var options = performance.extend({}, this.workerOptions);
        var data = this._data;
        if (typeof data === 'string') {
            options.request = this.map._requestManager.transformRequest(performance.browser.resolveURL(data), performance.ResourceType.Source);
            options.request.collectResourceTiming = this._collectResourceTiming;
        } else {
            options.data = JSON.stringify(data);
        }
        this.actor.send(this.type + '.loadData', options, function (err, result) {
            if (this$1._removed || result && result.abandoned) {
                return;
            }
            this$1._loaded = true;
            if (result && result.resourceTiming && result.resourceTiming[this$1.id]) {
                this$1._resourceTiming = result.resourceTiming[this$1.id].slice(0);
            }
            this$1.actor.send(this$1.type + '.coalesce', { source: options.source }, null);
            callback(err);
        });
    };
    GeoJSONSource.prototype.loaded = function loaded() {
        return this._loaded;
    };
    GeoJSONSource.prototype.loadTile = function loadTile(tile, callback) {
        var this$1 = this;
        var message = !tile.actor ? 'loadTile' : 'reloadTile';
        tile.actor = this.actor;
        var params = {
            type: this.type,
            uid: tile.uid,
            tileID: tile.tileID,
            zoom: tile.tileID.overscaledZ,
            maxZoom: this.maxzoom,
            tileSize: this.tileSize,
            source: this.id,
            pixelRatio: performance.browser.devicePixelRatio,
            showCollisionBoxes: this.map.showCollisionBoxes,
            promoteId: this.promoteId
        };
        tile.request = this.actor.send(message, params, function (err, data) {
            delete tile.request;
            tile.unloadVectorData();
            if (tile.aborted) {
                return callback(null);
            }
            if (err) {
                return callback(err);
            }
            tile.loadVectorData(data, this$1.map.painter, message === 'reloadTile');
            return callback(null);
        });
    };
    GeoJSONSource.prototype.abortTile = function abortTile(tile) {
        if (tile.request) {
            tile.request.cancel();
            delete tile.request;
        }
        tile.aborted = true;
    };
    GeoJSONSource.prototype.unloadTile = function unloadTile(tile) {
        tile.unloadVectorData();
        this.actor.send('removeTile', {
            uid: tile.uid,
            type: this.type,
            source: this.id
        });
    };
    GeoJSONSource.prototype.onRemove = function onRemove() {
        this._removed = true;
        this.actor.send('removeSource', {
            type: this.type,
            source: this.id
        });
    };
    GeoJSONSource.prototype.serialize = function serialize() {
        return performance.extend({}, this._options, {
            type: this.type,
            data: this._data
        });
    };
    GeoJSONSource.prototype.hasTransition = function hasTransition() {
        return false;
    };
    return GeoJSONSource;
}(performance.Evented);

var rasterBoundsAttributes = performance.createLayout([
    {
        name: 'a_pos',
        type: 'Int16',
        components: 2
    },
    {
        name: 'a_texture_pos',
        type: 'Int16',
        components: 2
    }
]);

var ImageSource = function (Evented) {
    function ImageSource(id, options, dispatcher, eventedParent) {
        Evented.call(this);
        this.id = id;
        this.dispatcher = dispatcher;
        this.coordinates = options.coordinates;
        this.type = 'image';
        this.minzoom = 0;
        this.maxzoom = 22;
        this.tileSize = 512;
        this.tiles = {};
        this._loaded = false;
        this.setEventedParent(eventedParent);
        this.options = options;
    }
    if (Evented)
        ImageSource.__proto__ = Evented;
    ImageSource.prototype = Object.create(Evented && Evented.prototype);
    ImageSource.prototype.constructor = ImageSource;
    ImageSource.prototype.load = function load(newCoordinates, successCallback) {
        var this$1 = this;
        this._loaded = false;
        this.fire(new performance.Event('dataloading', { dataType: 'source' }));
        this.url = this.options.url;
        performance.getImage(this.map._requestManager.transformRequest(this.url, performance.ResourceType.Image), function (err, image) {
            this$1._loaded = true;
            if (err) {
                this$1.fire(new performance.ErrorEvent(err));
            } else if (image) {
                this$1.image = image;
                if (newCoordinates) {
                    this$1.coordinates = newCoordinates;
                }
                if (successCallback) {
                    successCallback();
                }
                this$1._finishLoading();
            }
        });
    };
    ImageSource.prototype.loaded = function loaded() {
        return this._loaded;
    };
    ImageSource.prototype.updateImage = function updateImage(options) {
        var this$1 = this;
        if (!this.image || !options.url) {
            return this;
        }
        this.options.url = options.url;
        this.load(options.coordinates, function () {
            this$1.texture = null;
        });
        return this;
    };
    ImageSource.prototype._finishLoading = function _finishLoading() {
        if (this.map) {
            this.setCoordinates(this.coordinates);
            this.fire(new performance.Event('data', {
                dataType: 'source',
                sourceDataType: 'metadata'
            }));
        }
    };
    ImageSource.prototype.onAdd = function onAdd(map) {
        this.map = map;
        this.load();
    };
    ImageSource.prototype.setCoordinates = function setCoordinates(coordinates) {
        var this$1 = this;
        this.coordinates = coordinates;
        var cornerCoords = coordinates.map(performance.MercatorCoordinate.fromLngLat);
        this.tileID = getCoordinatesCenterTileID(cornerCoords);
        this.minzoom = this.maxzoom = this.tileID.z;
        var tileCoords = cornerCoords.map(function (coord) {
            return this$1.tileID.getTilePoint(coord)._round();
        });
        this._boundsArray = new performance.StructArrayLayout4i8();
        this._boundsArray.emplaceBack(tileCoords[0].x, tileCoords[0].y, 0, 0);
        this._boundsArray.emplaceBack(tileCoords[1].x, tileCoords[1].y, performance.EXTENT, 0);
        this._boundsArray.emplaceBack(tileCoords[3].x, tileCoords[3].y, 0, performance.EXTENT);
        this._boundsArray.emplaceBack(tileCoords[2].x, tileCoords[2].y, performance.EXTENT, performance.EXTENT);
        if (this.boundsBuffer) {
            this.boundsBuffer.destroy();
            delete this.boundsBuffer;
        }
        this.fire(new performance.Event('data', {
            dataType: 'source',
            sourceDataType: 'content'
        }));
        return this;
    };
    ImageSource.prototype.prepare = function prepare() {
        if (Object.keys(this.tiles).length === 0 || !this.image) {
            return;
        }
        var context = this.map.painter.context;
        var gl = context.gl;
        if (!this.boundsBuffer) {
            this.boundsBuffer = context.createVertexBuffer(this._boundsArray, rasterBoundsAttributes.members);
        }
        if (!this.boundsSegments) {
            this.boundsSegments = performance.SegmentVector.simpleSegment(0, 0, 4, 2);
        }
        if (!this.texture) {
            this.texture = new performance.Texture(context, this.image, gl.RGBA);
            this.texture.bind(gl.LINEAR, gl.CLAMP_TO_EDGE);
        }
        for (var w in this.tiles) {
            var tile = this.tiles[w];
            if (tile.state !== 'loaded') {
                tile.state = 'loaded';
                tile.texture = this.texture;
            }
        }
    };
    ImageSource.prototype.loadTile = function loadTile(tile, callback) {
        if (this.tileID && this.tileID.equals(tile.tileID.canonical)) {
            this.tiles[String(tile.tileID.wrap)] = tile;
            tile.buckets = {};
            callback(null);
        } else {
            tile.state = 'errored';
            callback(null);
        }
    };
    ImageSource.prototype.serialize = function serialize() {
        return {
            type: 'image',
            url: this.options.url,
            coordinates: this.coordinates
        };
    };
    ImageSource.prototype.hasTransition = function hasTransition() {
        return false;
    };
    return ImageSource;
}(performance.Evented);
function getCoordinatesCenterTileID(coords) {
    var minX = Infinity;
    var minY = Infinity;
    var maxX = -Infinity;
    var maxY = -Infinity;
    for (var i = 0, list = coords; i < list.length; i += 1) {
        var coord = list[i];
        minX = Math.min(minX, coord.x);
        minY = Math.min(minY, coord.y);
        maxX = Math.max(maxX, coord.x);
        maxY = Math.max(maxY, coord.y);
    }
    var dx = maxX - minX;
    var dy = maxY - minY;
    var dMax = Math.max(dx, dy);
    var zoom = Math.max(0, Math.floor(-Math.log(dMax) / Math.LN2));
    var tilesAtZoom = Math.pow(2, zoom);
    return new performance.CanonicalTileID(zoom, Math.floor((minX + maxX) / 2 * tilesAtZoom), Math.floor((minY + maxY) / 2 * tilesAtZoom));
}

var VideoSource = function (ImageSource) {
    function VideoSource(id, options, dispatcher, eventedParent) {
        ImageSource.call(this, id, options, dispatcher, eventedParent);
        this.roundZoom = true;
        this.type = 'video';
        this.options = options;
    }
    if (ImageSource)
        VideoSource.__proto__ = ImageSource;
    VideoSource.prototype = Object.create(ImageSource && ImageSource.prototype);
    VideoSource.prototype.constructor = VideoSource;
    VideoSource.prototype.load = function load() {
        var this$1 = this;
        this._loaded = false;
        var options = this.options;
        this.urls = [];
        for (var i = 0, list = options.urls; i < list.length; i += 1) {
            var url = list[i];
            this.urls.push(this.map._requestManager.transformRequest(url, performance.ResourceType.Source).url);
        }
        performance.getVideo(this.urls, function (err, video) {
            this$1._loaded = true;
            if (err) {
                this$1.fire(new performance.ErrorEvent(err));
            } else if (video) {
                this$1.video = video;
                this$1.video.loop = true;
                this$1.video.addEventListener('playing', function () {
                    this$1.map.triggerRepaint();
                });
                if (this$1.map) {
                    this$1.video.play();
                }
                this$1._finishLoading();
            }
        });
    };
    VideoSource.prototype.pause = function pause() {
        if (this.video) {
            this.video.pause();
        }
    };
    VideoSource.prototype.play = function play() {
        if (this.video) {
            this.video.play();
        }
    };
    VideoSource.prototype.seek = function seek(seconds) {
        if (this.video) {
            var seekableRange = this.video.seekable;
            if (seconds < seekableRange.start(0) || seconds > seekableRange.end(0)) {
                this.fire(new performance.ErrorEvent(new performance.ValidationError('sources.' + this.id, null, 'Playback for this video can be set only between the ' + seekableRange.start(0) + ' and ' + seekableRange.end(0) + '-second mark.')));
            } else {
                this.video.currentTime = seconds;
            }
        }
    };
    VideoSource.prototype.getVideo = function getVideo() {
        return this.video;
    };
    VideoSource.prototype.onAdd = function onAdd(map) {
        if (this.map) {
            return;
        }
        this.map = map;
        this.load();
        if (this.video) {
            this.video.play();
            this.setCoordinates(this.coordinates);
        }
    };
    VideoSource.prototype.prepare = function prepare() {
        if (Object.keys(this.tiles).length === 0 || this.video.readyState < 2) {
            return;
        }
        var context = this.map.painter.context;
        var gl = context.gl;
        if (!this.boundsBuffer) {
            this.boundsBuffer = context.createVertexBuffer(this._boundsArray, rasterBoundsAttributes.members);
        }
        if (!this.boundsSegments) {
            this.boundsSegments = performance.SegmentVector.simpleSegment(0, 0, 4, 2);
        }
        if (!this.texture) {
            this.texture = new performance.Texture(context, this.video, gl.RGBA);
            this.texture.bind(gl.LINEAR, gl.CLAMP_TO_EDGE);
        } else if (!this.video.paused) {
            this.texture.bind(gl.LINEAR, gl.CLAMP_TO_EDGE);
            gl.texSubImage2D(gl.TEXTURE_2D, 0, 0, 0, gl.RGBA, gl.UNSIGNED_BYTE, this.video);
        }
        for (var w in this.tiles) {
            var tile = this.tiles[w];
            if (tile.state !== 'loaded') {
                tile.state = 'loaded';
                tile.texture = this.texture;
            }
        }
    };
    VideoSource.prototype.serialize = function serialize() {
        return {
            type: 'video',
            urls: this.urls,
            coordinates: this.coordinates
        };
    };
    VideoSource.prototype.hasTransition = function hasTransition() {
        return this.video && !this.video.paused;
    };
    return VideoSource;
}(ImageSource);

var CanvasSource = function (ImageSource) {
    function CanvasSource(id, options, dispatcher, eventedParent) {
        ImageSource.call(this, id, options, dispatcher, eventedParent);
        if (!options.coordinates) {
            this.fire(new performance.ErrorEvent(new performance.ValidationError('sources.' + id, null, 'missing required property "coordinates"')));
        } else if (!Array.isArray(options.coordinates) || options.coordinates.length !== 4 || options.coordinates.some(function (c) {
                return !Array.isArray(c) || c.length !== 2 || c.some(function (l) {
                    return typeof l !== 'number';
                });
            })) {
            this.fire(new performance.ErrorEvent(new performance.ValidationError('sources.' + id, null, '"coordinates" property must be an array of 4 longitude/latitude array pairs')));
        }
        if (options.animate && typeof options.animate !== 'boolean') {
            this.fire(new performance.ErrorEvent(new performance.ValidationError('sources.' + id, null, 'optional "animate" property must be a boolean value')));
        }
        if (!options.canvas) {
            this.fire(new performance.ErrorEvent(new performance.ValidationError('sources.' + id, null, 'missing required property "canvas"')));
        } else if (typeof options.canvas !== 'string' && !(options.canvas instanceof performance.window.HTMLCanvasElement)) {
            this.fire(new performance.ErrorEvent(new performance.ValidationError('sources.' + id, null, '"canvas" must be either a string representing the ID of the canvas element from which to read, or an HTMLCanvasElement instance')));
        }
        this.options = options;
        this.animate = options.animate !== undefined ? options.animate : true;
    }
    if (ImageSource)
        CanvasSource.__proto__ = ImageSource;
    CanvasSource.prototype = Object.create(ImageSource && ImageSource.prototype);
    CanvasSource.prototype.constructor = CanvasSource;
    CanvasSource.prototype.load = function load() {
        this._loaded = true;
        if (!this.canvas) {
            this.canvas = this.options.canvas instanceof performance.window.HTMLCanvasElement ? this.options.canvas : performance.window.document.getElementById(this.options.canvas);
        }
        this.width = this.canvas.width;
        this.height = this.canvas.height;
        if (this._hasInvalidDimensions()) {
            this.fire(new performance.ErrorEvent(new Error('Canvas dimensions cannot be less than or equal to zero.')));
            return;
        }
        this.play = function () {
            this._playing = true;
            this.map.triggerRepaint();
        };
        this.pause = function () {
            if (this._playing) {
                this.prepare();
                this._playing = false;
            }
        };
        this._finishLoading();
    };
    CanvasSource.prototype.getCanvas = function getCanvas() {
        return this.canvas;
    };
    CanvasSource.prototype.onAdd = function onAdd(map) {
        this.map = map;
        this.load();
        if (this.canvas) {
            if (this.animate) {
                this.play();
            }
        }
    };
    CanvasSource.prototype.onRemove = function onRemove() {
        this.pause();
    };
    CanvasSource.prototype.prepare = function prepare() {
        var resize = false;
        if (this.canvas.width !== this.width) {
            this.width = this.canvas.width;
            resize = true;
        }
        if (this.canvas.height !== this.height) {
            this.height = this.canvas.height;
            resize = true;
        }
        if (this._hasInvalidDimensions()) {
            return;
        }
        if (Object.keys(this.tiles).length === 0) {
            return;
        }
        var context = this.map.painter.context;
        var gl = context.gl;
        if (!this.boundsBuffer) {
            this.boundsBuffer = context.createVertexBuffer(this._boundsArray, rasterBoundsAttributes.members);
        }
        if (!this.boundsSegments) {
            this.boundsSegments = performance.SegmentVector.simpleSegment(0, 0, 4, 2);
        }
        if (!this.texture) {
            this.texture = new performance.Texture(context, this.canvas, gl.RGBA, { premultiply: true });
        } else if (resize || this._playing) {
            this.texture.update(this.canvas, { premultiply: true });
        }
        for (var w in this.tiles) {
            var tile = this.tiles[w];
            if (tile.state !== 'loaded') {
                tile.state = 'loaded';
                tile.texture = this.texture;
            }
        }
    };
    CanvasSource.prototype.serialize = function serialize() {
        return {
            type: 'canvas',
            coordinates: this.coordinates
        };
    };
    CanvasSource.prototype.hasTransition = function hasTransition() {
        return this._playing;
    };
    CanvasSource.prototype._hasInvalidDimensions = function _hasInvalidDimensions() {
        for (var i = 0, list = [
                    this.canvas.width,
                    this.canvas.height
                ]; i < list.length; i += 1) {
            var x = list[i];
            if (isNaN(x) || x <= 0) {
                return true;
            }
        }
        return false;
    };
    return CanvasSource;
}(ImageSource);

var sourceTypes = {
    vector: VectorTileSource,
    raster: RasterTileSource,
    'raster-dem': RasterDEMTileSource,
    geojson: GeoJSONSource,
    video: VideoSource,
    image: ImageSource,
    canvas: CanvasSource
};
var create = function (id, specification, dispatcher, eventedParent) {
    var source = new sourceTypes[specification.type](id, specification, dispatcher, eventedParent);
    if (source.id !== id) {
        throw new Error('Expected Source id to be ' + id + ' instead of ' + source.id);
    }
    performance.bindAll([
        'load',
        'abort',
        'unload',
        'serialize',
        'prepare'
    ], source);
    return source;
};
var getType = function (name) {
    return sourceTypes[name];
};
var setType = function (name, type) {
    sourceTypes[name] = type;
};

function getPixelPosMatrix(transform, tileID) {
    var t = performance.identity([]);
    performance.translate(t, t, [
        1,
        1,
        0
    ]);
    performance.scale(t, t, [
        transform.width * 0.5,
        transform.height * 0.5,
        1
    ]);
    return performance.multiply(t, t, transform.calculatePosMatrix(tileID.toUnwrapped()));
}
function queryIncludes3DLayer(layers, styleLayers, sourceID) {
    if (layers) {
        for (var i = 0, list = layers; i < list.length; i += 1) {
            var layerID = list[i];
            var layer = styleLayers[layerID];
            if (layer && layer.source === sourceID && layer.type === 'fill-extrusion') {
                return true;
            }
        }
    } else {
        for (var key in styleLayers) {
            var layer$1 = styleLayers[key];
            if (layer$1.source === sourceID && layer$1.type === 'fill-extrusion') {
                return true;
            }
        }
    }
    return false;
}
function queryRenderedFeatures(sourceCache, styleLayers, serializedLayers, queryGeometry, params, transform) {
    var has3DLayer = queryIncludes3DLayer(params && params.layers, styleLayers, sourceCache.id);
    var maxPitchScaleFactor = transform.maxPitchScaleFactor();
    var tilesIn = sourceCache.tilesIn(queryGeometry, maxPitchScaleFactor, has3DLayer);
    tilesIn.sort(sortTilesIn);
    var renderedFeatureLayers = [];
    for (var i = 0, list = tilesIn; i < list.length; i += 1) {
        var tileIn = list[i];
        renderedFeatureLayers.push({
            wrappedTileID: tileIn.tileID.wrapped().key,
            queryResults: tileIn.tile.queryRenderedFeatures(styleLayers, serializedLayers, sourceCache._state, tileIn.queryGeometry, tileIn.cameraQueryGeometry, tileIn.scale, params, transform, maxPitchScaleFactor, getPixelPosMatrix(sourceCache.transform, tileIn.tileID))
        });
    }
    var result = mergeRenderedFeatureLayers(renderedFeatureLayers);
    for (var layerID in result) {
        result[layerID].forEach(function (featureWrapper) {
            var feature = featureWrapper.feature;
            var state = sourceCache.getFeatureState(feature.layer['source-layer'], feature.id);
            feature.source = feature.layer.source;
            if (feature.layer['source-layer']) {
                feature.sourceLayer = feature.layer['source-layer'];
            }
            feature.state = state;
        });
    }
    return result;
}
function queryRenderedSymbols(styleLayers, serializedLayers, sourceCaches, queryGeometry, params, collisionIndex, retainedQueryData) {
    var result = {};
    var renderedSymbols = collisionIndex.queryRenderedSymbols(queryGeometry);
    var bucketQueryData = [];
    for (var i = 0, list = Object.keys(renderedSymbols).map(Number); i < list.length; i += 1) {
        var bucketInstanceId = list[i];
        bucketQueryData.push(retainedQueryData[bucketInstanceId]);
    }
    bucketQueryData.sort(sortTilesIn);
    var loop = function () {
        var queryData = list$2[i$2];
        var bucketSymbols = queryData.featureIndex.lookupSymbolFeatures(renderedSymbols[queryData.bucketInstanceId], serializedLayers, queryData.bucketIndex, queryData.sourceLayerIndex, params.filter, params.layers, params.availableImages, styleLayers);
        for (var layerID in bucketSymbols) {
            var resultFeatures = result[layerID] = result[layerID] || [];
            var layerSymbols = bucketSymbols[layerID];
            layerSymbols.sort(function (a, b) {
                var featureSortOrder = queryData.featureSortOrder;
                if (featureSortOrder) {
                    var sortedA = featureSortOrder.indexOf(a.featureIndex);
                    var sortedB = featureSortOrder.indexOf(b.featureIndex);
                    return sortedB - sortedA;
                } else {
                    return b.featureIndex - a.featureIndex;
                }
            });
            for (var i$1 = 0, list$1 = layerSymbols; i$1 < list$1.length; i$1 += 1) {
                var symbolFeature = list$1[i$1];
                resultFeatures.push(symbolFeature);
            }
        }
    };
    for (var i$2 = 0, list$2 = bucketQueryData; i$2 < list$2.length; i$2 += 1)
        loop();
    var loop$1 = function (layerName) {
        result[layerName].forEach(function (featureWrapper) {
            var feature = featureWrapper.feature;
            var layer = styleLayers[layerName];
            var sourceCache = sourceCaches[layer.source];
            var state = sourceCache.getFeatureState(feature.layer['source-layer'], feature.id);
            feature.source = feature.layer.source;
            if (feature.layer['source-layer']) {
                feature.sourceLayer = feature.layer['source-layer'];
            }
            feature.state = state;
        });
    };
    for (var layerName in result)
        loop$1(layerName);
    return result;
}
function querySourceFeatures(sourceCache, params) {
    var tiles = sourceCache.getRenderableIds().map(function (id) {
        return sourceCache.getTileByID(id);
    });
    var result = [];
    var dataTiles = {};
    for (var i = 0; i < tiles.length; i++) {
        var tile = tiles[i];
        var dataID = tile.tileID.canonical.key;
        if (!dataTiles[dataID]) {
            dataTiles[dataID] = true;
            tile.querySourceFeatures(result, params);
        }
    }
    return result;
}
function sortTilesIn(a, b) {
    var idA = a.tileID;
    var idB = b.tileID;
    return idA.overscaledZ - idB.overscaledZ || idA.canonical.y - idB.canonical.y || idA.wrap - idB.wrap || idA.canonical.x - idB.canonical.x;
}
function mergeRenderedFeatureLayers(tiles) {
    var result = {};
    var wrappedIDLayerMap = {};
    for (var i$1 = 0, list$1 = tiles; i$1 < list$1.length; i$1 += 1) {
        var tile = list$1[i$1];
        var queryResults = tile.queryResults;
        var wrappedID = tile.wrappedTileID;
        var wrappedIDLayers = wrappedIDLayerMap[wrappedID] = wrappedIDLayerMap[wrappedID] || {};
        for (var layerID in queryResults) {
            var tileFeatures = queryResults[layerID];
            var wrappedIDFeatures = wrappedIDLayers[layerID] = wrappedIDLayers[layerID] || {};
            var resultFeatures = result[layerID] = result[layerID] || [];
            for (var i = 0, list = tileFeatures; i < list.length; i += 1) {
                var tileFeature = list[i];
                if (!wrappedIDFeatures[tileFeature.featureIndex]) {
                    wrappedIDFeatures[tileFeature.featureIndex] = true;
                    resultFeatures.push(tileFeature);
                }
            }
        }
    }
    return result;
}

var TileCache = function TileCache(max, onRemove) {
    this.max = max;
    this.onRemove = onRemove;
    this.reset();
};
TileCache.prototype.reset = function reset() {
    for (var key in this.data) {
        for (var i = 0, list = this.data[key]; i < list.length; i += 1) {
            var removedData = list[i];
            if (removedData.timeout) {
                clearTimeout(removedData.timeout);
            }
            this.onRemove(removedData.value);
        }
    }
    this.data = {};
    this.order = [];
    return this;
};
TileCache.prototype.add = function add(tileID, data, expiryTimeout) {
    var this$1 = this;
    var key = tileID.wrapped().key;
    if (this.data[key] === undefined) {
        this.data[key] = [];
    }
    var dataWrapper = {
        value: data,
        timeout: undefined
    };
    if (expiryTimeout !== undefined) {
        dataWrapper.timeout = setTimeout(function () {
            this$1.remove(tileID, dataWrapper);
        }, expiryTimeout);
    }
    this.data[key].push(dataWrapper);
    this.order.push(key);
    if (this.order.length > this.max) {
        var removedData = this._getAndRemoveByKey(this.order[0]);
        if (removedData) {
            this.onRemove(removedData);
        }
    }
    return this;
};
TileCache.prototype.has = function has(tileID) {
    return tileID.wrapped().key in this.data;
};
TileCache.prototype.getAndRemove = function getAndRemove(tileID) {
    if (!this.has(tileID)) {
        return null;
    }
    return this._getAndRemoveByKey(tileID.wrapped().key);
};
TileCache.prototype._getAndRemoveByKey = function _getAndRemoveByKey(key) {
    var data = this.data[key].shift();
    if (data.timeout) {
        clearTimeout(data.timeout);
    }
    if (this.data[key].length === 0) {
        delete this.data[key];
    }
    this.order.splice(this.order.indexOf(key), 1);
    return data.value;
};
TileCache.prototype.getByKey = function getByKey(key) {
    var data = this.data[key];
    return data ? data[0].value : null;
};
TileCache.prototype.get = function get(tileID) {
    if (!this.has(tileID)) {
        return null;
    }
    var data = this.data[tileID.wrapped().key][0];
    return data.value;
};
TileCache.prototype.remove = function remove(tileID, value) {
    if (!this.has(tileID)) {
        return this;
    }
    var key = tileID.wrapped().key;
    var dataIndex = value === undefined ? 0 : this.data[key].indexOf(value);
    var data = this.data[key][dataIndex];
    this.data[key].splice(dataIndex, 1);
    if (data.timeout) {
        clearTimeout(data.timeout);
    }
    if (this.data[key].length === 0) {
        delete this.data[key];
    }
    this.onRemove(data.value);
    this.order.splice(this.order.indexOf(key), 1);
    return this;
};
TileCache.prototype.setMaxSize = function setMaxSize(max) {
    this.max = max;
    while (this.order.length > this.max) {
        var removedData = this._getAndRemoveByKey(this.order[0]);
        if (removedData) {
            this.onRemove(removedData);
        }
    }
    return this;
};
TileCache.prototype.filter = function filter(filterFn) {
    var removed = [];
    for (var key in this.data) {
        for (var i = 0, list = this.data[key]; i < list.length; i += 1) {
            var entry = list[i];
            if (!filterFn(entry.value)) {
                removed.push(entry);
            }
        }
    }
    for (var i$1 = 0, list$1 = removed; i$1 < list$1.length; i$1 += 1) {
        var r = list$1[i$1];
        this.remove(r.value.tileID, r);
    }
};

var IndexBuffer = function IndexBuffer(context, array, dynamicDraw) {
    this.context = context;
    var gl = context.gl;
    this.buffer = gl.createBuffer();
    this.dynamicDraw = Boolean(dynamicDraw);
    this.context.unbindVAO();
    context.bindElementBuffer.set(this.buffer);
    gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, array.arrayBuffer, this.dynamicDraw ? gl.DYNAMIC_DRAW : gl.STATIC_DRAW);
    if (!this.dynamicDraw) {
        delete array.arrayBuffer;
    }
};
IndexBuffer.prototype.bind = function bind() {
    this.context.bindElementBuffer.set(this.buffer);
};
IndexBuffer.prototype.updateData = function updateData(array) {
    var gl = this.context.gl;
    this.context.unbindVAO();
    this.bind();
    gl.bufferSubData(gl.ELEMENT_ARRAY_BUFFER, 0, array.arrayBuffer);
};
IndexBuffer.prototype.destroy = function destroy() {
    var gl = this.context.gl;
    if (this.buffer) {
        gl.deleteBuffer(this.buffer);
        delete this.buffer;
    }
};

var AttributeType = {
    Int8: 'BYTE',
    Uint8: 'UNSIGNED_BYTE',
    Int16: 'SHORT',
    Uint16: 'UNSIGNED_SHORT',
    Int32: 'INT',
    Uint32: 'UNSIGNED_INT',
    Float32: 'FLOAT'
};
var VertexBuffer = function VertexBuffer(context, array, attributes, dynamicDraw) {
    this.length = array.length;
    this.attributes = attributes;
    this.itemSize = array.bytesPerElement;
    this.dynamicDraw = dynamicDraw;
    this.context = context;
    var gl = context.gl;
    this.buffer = gl.createBuffer();
    context.bindVertexBuffer.set(this.buffer);
    gl.bufferData(gl.ARRAY_BUFFER, array.arrayBuffer, this.dynamicDraw ? gl.DYNAMIC_DRAW : gl.STATIC_DRAW);
    if (!this.dynamicDraw) {
        delete array.arrayBuffer;
    }
};
VertexBuffer.prototype.bind = function bind() {
    this.context.bindVertexBuffer.set(this.buffer);
};
VertexBuffer.prototype.updateData = function updateData(array) {
    var gl = this.context.gl;
    this.bind();
    gl.bufferSubData(gl.ARRAY_BUFFER, 0, array.arrayBuffer);
};
VertexBuffer.prototype.enableAttributes = function enableAttributes(gl, program) {
    for (var j = 0; j < this.attributes.length; j++) {
        var member = this.attributes[j];
        var attribIndex = program.attributes[member.name];
        if (attribIndex !== undefined) {
            gl.enableVertexAttribArray(attribIndex);
        }
    }
};
VertexBuffer.prototype.setVertexAttribPointers = function setVertexAttribPointers(gl, program, vertexOffset) {
    for (var j = 0; j < this.attributes.length; j++) {
        var member = this.attributes[j];
        var attribIndex = program.attributes[member.name];
        if (attribIndex !== undefined) {
            gl.vertexAttribPointer(attribIndex, member.components, gl[AttributeType[member.type]], false, this.itemSize, member.offset + this.itemSize * (vertexOffset || 0));
        }
    }
};
VertexBuffer.prototype.destroy = function destroy() {
    var gl = this.context.gl;
    if (this.buffer) {
        gl.deleteBuffer(this.buffer);
        delete this.buffer;
    }
};

var BaseValue = function BaseValue(context) {
    this.gl = context.gl;
    this.default = this.getDefault();
    this.current = this.default;
    this.dirty = false;
};
BaseValue.prototype.get = function get() {
    return this.current;
};
BaseValue.prototype.set = function set(value) {
};
BaseValue.prototype.getDefault = function getDefault() {
    return this.default;
};
BaseValue.prototype.setDefault = function setDefault() {
    this.set(this.default);
};
var ClearColor = function (BaseValue) {
    function ClearColor() {
        BaseValue.apply(this, arguments);
    }
    if (BaseValue)
        ClearColor.__proto__ = BaseValue;
    ClearColor.prototype = Object.create(BaseValue && BaseValue.prototype);
    ClearColor.prototype.constructor = ClearColor;
    ClearColor.prototype.getDefault = function getDefault() {
        return performance.Color.transparent;
    };
    ClearColor.prototype.set = function set(v) {
        var c = this.current;
        if (v.r === c.r && v.g === c.g && v.b === c.b && v.a === c.a && !this.dirty) {
            return;
        }
        this.gl.clearColor(v.r, v.g, v.b, v.a);
        this.current = v;
        this.dirty = false;
    };
    return ClearColor;
}(BaseValue);
var ClearDepth = function (BaseValue) {
    function ClearDepth() {
        BaseValue.apply(this, arguments);
    }
    if (BaseValue)
        ClearDepth.__proto__ = BaseValue;
    ClearDepth.prototype = Object.create(BaseValue && BaseValue.prototype);
    ClearDepth.prototype.constructor = ClearDepth;
    ClearDepth.prototype.getDefault = function getDefault() {
        return 1;
    };
    ClearDepth.prototype.set = function set(v) {
        if (v === this.current && !this.dirty) {
            return;
        }
        this.gl.clearDepth(v);
        this.current = v;
        this.dirty = false;
    };
    return ClearDepth;
}(BaseValue);
var ClearStencil = function (BaseValue) {
    function ClearStencil() {
        BaseValue.apply(this, arguments);
    }
    if (BaseValue)
        ClearStencil.__proto__ = BaseValue;
    ClearStencil.prototype = Object.create(BaseValue && BaseValue.prototype);
    ClearStencil.prototype.constructor = ClearStencil;
    ClearStencil.prototype.getDefault = function getDefault() {
        return 0;
    };
    ClearStencil.prototype.set = function set(v) {
        if (v === this.current && !this.dirty) {
            return;
        }
        this.gl.clearStencil(v);
        this.current = v;
        this.dirty = false;
    };
    return ClearStencil;
}(BaseValue);
var ColorMask = function (BaseValue) {
    function ColorMask() {
        BaseValue.apply(this, arguments);
    }
    if (BaseValue)
        ColorMask.__proto__ = BaseValue;
    ColorMask.prototype = Object.create(BaseValue && BaseValue.prototype);
    ColorMask.prototype.constructor = ColorMask;
    ColorMask.prototype.getDefault = function getDefault() {
        return [
            true,
            true,
            true,
            true
        ];
    };
    ColorMask.prototype.set = function set(v) {
        var c = this.current;
        if (v[0] === c[0] && v[1] === c[1] && v[2] === c[2] && v[3] === c[3] && !this.dirty) {
            return;
        }
        this.gl.colorMask(v[0], v[1], v[2], v[3]);
        this.current = v;
        this.dirty = false;
    };
    return ColorMask;
}(BaseValue);
var DepthMask = function (BaseValue) {
    function DepthMask() {
        BaseValue.apply(this, arguments);
    }
    if (BaseValue)
        DepthMask.__proto__ = BaseValue;
    DepthMask.prototype = Object.create(BaseValue && BaseValue.prototype);
    DepthMask.prototype.constructor = DepthMask;
    DepthMask.prototype.getDefault = function getDefault() {
        return true;
    };
    DepthMask.prototype.set = function set(v) {
        if (v === this.current && !this.dirty) {
            return;
        }
        this.gl.depthMask(v);
        this.current = v;
        this.dirty = false;
    };
    return DepthMask;
}(BaseValue);
var StencilMask = function (BaseValue) {
    function StencilMask() {
        BaseValue.apply(this, arguments);
    }
    if (BaseValue)
        StencilMask.__proto__ = BaseValue;
    StencilMask.prototype = Object.create(BaseValue && BaseValue.prototype);
    StencilMask.prototype.constructor = StencilMask;
    StencilMask.prototype.getDefault = function getDefault() {
        return 255;
    };
    StencilMask.prototype.set = function set(v) {
        if (v === this.current && !this.dirty) {
            return;
        }
        this.gl.stencilMask(v);
        this.current = v;
        this.dirty = false;
    };
    return StencilMask;
}(BaseValue);
var StencilFunc = function (BaseValue) {
    function StencilFunc() {
        BaseValue.apply(this, arguments);
    }
    if (BaseValue)
        StencilFunc.__proto__ = BaseValue;
    StencilFunc.prototype = Object.create(BaseValue && BaseValue.prototype);
    StencilFunc.prototype.constructor = StencilFunc;
    StencilFunc.prototype.getDefault = function getDefault() {
        return {
            func: this.gl.ALWAYS,
            ref: 0,
            mask: 255
        };
    };
    StencilFunc.prototype.set = function set(v) {
        var c = this.current;
        if (v.func === c.func && v.ref === c.ref && v.mask === c.mask && !this.dirty) {
            return;
        }
        this.gl.stencilFunc(v.func, v.ref, v.mask);
        this.current = v;
        this.dirty = false;
    };
    return StencilFunc;
}(BaseValue);
var StencilOp = function (BaseValue) {
    function StencilOp() {
        BaseValue.apply(this, arguments);
    }
    if (BaseValue)
        StencilOp.__proto__ = BaseValue;
    StencilOp.prototype = Object.create(BaseValue && BaseValue.prototype);
    StencilOp.prototype.constructor = StencilOp;
    StencilOp.prototype.getDefault = function getDefault() {
        var gl = this.gl;
        return [
            gl.KEEP,
            gl.KEEP,
            gl.KEEP
        ];
    };
    StencilOp.prototype.set = function set(v) {
        var c = this.current;
        if (v[0] === c[0] && v[1] === c[1] && v[2] === c[2] && !this.dirty) {
            return;
        }
        this.gl.stencilOp(v[0], v[1], v[2]);
        this.current = v;
        this.dirty = false;
    };
    return StencilOp;
}(BaseValue);
var StencilTest = function (BaseValue) {
    function StencilTest() {
        BaseValue.apply(this, arguments);
    }
    if (BaseValue)
        StencilTest.__proto__ = BaseValue;
    StencilTest.prototype = Object.create(BaseValue && BaseValue.prototype);
    StencilTest.prototype.constructor = StencilTest;
    StencilTest.prototype.getDefault = function getDefault() {
        return false;
    };
    StencilTest.prototype.set = function set(v) {
        if (v === this.current && !this.dirty) {
            return;
        }
        var gl = this.gl;
        if (v) {
            gl.enable(gl.STENCIL_TEST);
        } else {
            gl.disable(gl.STENCIL_TEST);
        }
        this.current = v;
        this.dirty = false;
    };
    return StencilTest;
}(BaseValue);
var DepthRange = function (BaseValue) {
    function DepthRange() {
        BaseValue.apply(this, arguments);
    }
    if (BaseValue)
        DepthRange.__proto__ = BaseValue;
    DepthRange.prototype = Object.create(BaseValue && BaseValue.prototype);
    DepthRange.prototype.constructor = DepthRange;
    DepthRange.prototype.getDefault = function getDefault() {
        return [
            0,
            1
        ];
    };
    DepthRange.prototype.set = function set(v) {
        var c = this.current;
        if (v[0] === c[0] && v[1] === c[1] && !this.dirty) {
            return;
        }
        this.gl.depthRange(v[0], v[1]);
        this.current = v;
        this.dirty = false;
    };
    return DepthRange;
}(BaseValue);
var DepthTest = function (BaseValue) {
    function DepthTest() {
        BaseValue.apply(this, arguments);
    }
    if (BaseValue)
        DepthTest.__proto__ = BaseValue;
    DepthTest.prototype = Object.create(BaseValue && BaseValue.prototype);
    DepthTest.prototype.constructor = DepthTest;
    DepthTest.prototype.getDefault = function getDefault() {
        return false;
    };
    DepthTest.prototype.set = function set(v) {
        if (v === this.current && !this.dirty) {
            return;
        }
        var gl = this.gl;
        if (v) {
            gl.enable(gl.DEPTH_TEST);
        } else {
            gl.disable(gl.DEPTH_TEST);
        }
        this.current = v;
        this.dirty = false;
    };
    return DepthTest;
}(BaseValue);
var DepthFunc = function (BaseValue) {
    function DepthFunc() {
        BaseValue.apply(this, arguments);
    }
    if (BaseValue)
        DepthFunc.__proto__ = BaseValue;
    DepthFunc.prototype = Object.create(BaseValue && BaseValue.prototype);
    DepthFunc.prototype.constructor = DepthFunc;
    DepthFunc.prototype.getDefault = function getDefault() {
        return this.gl.LESS;
    };
    DepthFunc.prototype.set = function set(v) {
        if (v === this.current && !this.dirty) {
            return;
        }
        this.gl.depthFunc(v);
        this.current = v;
        this.dirty = false;
    };
    return DepthFunc;
}(BaseValue);
var Blend = function (BaseValue) {
    function Blend() {
        BaseValue.apply(this, arguments);
    }
    if (BaseValue)
        Blend.__proto__ = BaseValue;
    Blend.prototype = Object.create(BaseValue && BaseValue.prototype);
    Blend.prototype.constructor = Blend;
    Blend.prototype.getDefault = function getDefault() {
        return false;
    };
    Blend.prototype.set = function set(v) {
        if (v === this.current && !this.dirty) {
            return;
        }
        var gl = this.gl;
        if (v) {
            gl.enable(gl.BLEND);
        } else {
            gl.disable(gl.BLEND);
        }
        this.current = v;
        this.dirty = false;
    };
    return Blend;
}(BaseValue);
var BlendFunc = function (BaseValue) {
    function BlendFunc() {
        BaseValue.apply(this, arguments);
    }
    if (BaseValue)
        BlendFunc.__proto__ = BaseValue;
    BlendFunc.prototype = Object.create(BaseValue && BaseValue.prototype);
    BlendFunc.prototype.constructor = BlendFunc;
    BlendFunc.prototype.getDefault = function getDefault() {
        var gl = this.gl;
        return [
            gl.ONE,
            gl.ZERO
        ];
    };
    BlendFunc.prototype.set = function set(v) {
        var c = this.current;
        if (v[0] === c[0] && v[1] === c[1] && !this.dirty) {
            return;
        }
        this.gl.blendFunc(v[0], v[1]);
        this.current = v;
        this.dirty = false;
    };
    return BlendFunc;
}(BaseValue);
var BlendColor = function (BaseValue) {
    function BlendColor() {
        BaseValue.apply(this, arguments);
    }
    if (BaseValue)
        BlendColor.__proto__ = BaseValue;
    BlendColor.prototype = Object.create(BaseValue && BaseValue.prototype);
    BlendColor.prototype.constructor = BlendColor;
    BlendColor.prototype.getDefault = function getDefault() {
        return performance.Color.transparent;
    };
    BlendColor.prototype.set = function set(v) {
        var c = this.current;
        if (v.r === c.r && v.g === c.g && v.b === c.b && v.a === c.a && !this.dirty) {
            return;
        }
        this.gl.blendColor(v.r, v.g, v.b, v.a);
        this.current = v;
        this.dirty = false;
    };
    return BlendColor;
}(BaseValue);
var BlendEquation = function (BaseValue) {
    function BlendEquation() {
        BaseValue.apply(this, arguments);
    }
    if (BaseValue)
        BlendEquation.__proto__ = BaseValue;
    BlendEquation.prototype = Object.create(BaseValue && BaseValue.prototype);
    BlendEquation.prototype.constructor = BlendEquation;
    BlendEquation.prototype.getDefault = function getDefault() {
        return this.gl.FUNC_ADD;
    };
    BlendEquation.prototype.set = function set(v) {
        if (v === this.current && !this.dirty) {
            return;
        }
        this.gl.blendEquation(v);
        this.current = v;
        this.dirty = false;
    };
    return BlendEquation;
}(BaseValue);
var CullFace = function (BaseValue) {
    function CullFace() {
        BaseValue.apply(this, arguments);
    }
    if (BaseValue)
        CullFace.__proto__ = BaseValue;
    CullFace.prototype = Object.create(BaseValue && BaseValue.prototype);
    CullFace.prototype.constructor = CullFace;
    CullFace.prototype.getDefault = function getDefault() {
        return false;
    };
    CullFace.prototype.set = function set(v) {
        if (v === this.current && !this.dirty) {
            return;
        }
        var gl = this.gl;
        if (v) {
            gl.enable(gl.CULL_FACE);
        } else {
            gl.disable(gl.CULL_FACE);
        }
        this.current = v;
        this.dirty = false;
    };
    return CullFace;
}(BaseValue);
var CullFaceSide = function (BaseValue) {
    function CullFaceSide() {
        BaseValue.apply(this, arguments);
    }
    if (BaseValue)
        CullFaceSide.__proto__ = BaseValue;
    CullFaceSide.prototype = Object.create(BaseValue && BaseValue.prototype);
    CullFaceSide.prototype.constructor = CullFaceSide;
    CullFaceSide.prototype.getDefault = function getDefault() {
        return this.gl.BACK;
    };
    CullFaceSide.prototype.set = function set(v) {
        if (v === this.current && !this.dirty) {
            return;
        }
        this.gl.cullFace(v);
        this.current = v;
        this.dirty = false;
    };
    return CullFaceSide;
}(BaseValue);
var FrontFace = function (BaseValue) {
    function FrontFace() {
        BaseValue.apply(this, arguments);
    }
    if (BaseValue)
        FrontFace.__proto__ = BaseValue;
    FrontFace.prototype = Object.create(BaseValue && BaseValue.prototype);
    FrontFace.prototype.constructor = FrontFace;
    FrontFace.prototype.getDefault = function getDefault() {
        return this.gl.CCW;
    };
    FrontFace.prototype.set = function set(v) {
        if (v === this.current && !this.dirty) {
            return;
        }
        this.gl.frontFace(v);
        this.current = v;
        this.dirty = false;
    };
    return FrontFace;
}(BaseValue);
var Program = function (BaseValue) {
    function Program() {
        BaseValue.apply(this, arguments);
    }
    if (BaseValue)
        Program.__proto__ = BaseValue;
    Program.prototype = Object.create(BaseValue && BaseValue.prototype);
    Program.prototype.constructor = Program;
    Program.prototype.getDefault = function getDefault() {
        return null;
    };
    Program.prototype.set = function set(v) {
        if (v === this.current && !this.dirty) {
            return;
        }
        this.gl.useProgram(v);
        this.current = v;
        this.dirty = false;
    };
    return Program;
}(BaseValue);
var ActiveTextureUnit = function (BaseValue) {
    function ActiveTextureUnit() {
        BaseValue.apply(this, arguments);
    }
    if (BaseValue)
        ActiveTextureUnit.__proto__ = BaseValue;
    ActiveTextureUnit.prototype = Object.create(BaseValue && BaseValue.prototype);
    ActiveTextureUnit.prototype.constructor = ActiveTextureUnit;
    ActiveTextureUnit.prototype.getDefault = function getDefault() {
        return this.gl.TEXTURE0;
    };
    ActiveTextureUnit.prototype.set = function set(v) {
        if (v === this.current && !this.dirty) {
            return;
        }
        this.gl.activeTexture(v);
        this.current = v;
        this.dirty = false;
    };
    return ActiveTextureUnit;
}(BaseValue);
var Viewport = function (BaseValue) {
    function Viewport() {
        BaseValue.apply(this, arguments);
    }
    if (BaseValue)
        Viewport.__proto__ = BaseValue;
    Viewport.prototype = Object.create(BaseValue && BaseValue.prototype);
    Viewport.prototype.constructor = Viewport;
    Viewport.prototype.getDefault = function getDefault() {
        var gl = this.gl;
        return [
            0,
            0,
            gl.drawingBufferWidth,
            gl.drawingBufferHeight
        ];
    };
    Viewport.prototype.set = function set(v) {
        var c = this.current;
        if (v[0] === c[0] && v[1] === c[1] && v[2] === c[2] && v[3] === c[3] && !this.dirty) {
            return;
        }
        this.gl.viewport(v[0], v[1], v[2], v[3]);
        this.current = v;
        this.dirty = false;
    };
    return Viewport;
}(BaseValue);
var BindFramebuffer = function (BaseValue) {
    function BindFramebuffer() {
        BaseValue.apply(this, arguments);
    }
    if (BaseValue)
        BindFramebuffer.__proto__ = BaseValue;
    BindFramebuffer.prototype = Object.create(BaseValue && BaseValue.prototype);
    BindFramebuffer.prototype.constructor = BindFramebuffer;
    BindFramebuffer.prototype.getDefault = function getDefault() {
        return null;
    };
    BindFramebuffer.prototype.set = function set(v) {
        if (v === this.current && !this.dirty) {
            return;
        }
        var gl = this.gl;
        gl.bindFramebuffer(gl.FRAMEBUFFER, v);
        this.current = v;
        this.dirty = false;
    };
    return BindFramebuffer;
}(BaseValue);
var BindRenderbuffer = function (BaseValue) {
    function BindRenderbuffer() {
        BaseValue.apply(this, arguments);
    }
    if (BaseValue)
        BindRenderbuffer.__proto__ = BaseValue;
    BindRenderbuffer.prototype = Object.create(BaseValue && BaseValue.prototype);
    BindRenderbuffer.prototype.constructor = BindRenderbuffer;
    BindRenderbuffer.prototype.getDefault = function getDefault() {
        return null;
    };
    BindRenderbuffer.prototype.set = function set(v) {
        if (v === this.current && !this.dirty) {
            return;
        }
        var gl = this.gl;
        gl.bindRenderbuffer(gl.RENDERBUFFER, v);
        this.current = v;
        this.dirty = false;
    };
    return BindRenderbuffer;
}(BaseValue);
var BindTexture = function (BaseValue) {
    function BindTexture() {
        BaseValue.apply(this, arguments);
    }
    if (BaseValue)
        BindTexture.__proto__ = BaseValue;
    BindTexture.prototype = Object.create(BaseValue && BaseValue.prototype);
    BindTexture.prototype.constructor = BindTexture;
    BindTexture.prototype.getDefault = function getDefault() {
        return null;
    };
    BindTexture.prototype.set = function set(v) {
        if (v === this.current && !this.dirty) {
            return;
        }
        var gl = this.gl;
        gl.bindTexture(gl.TEXTURE_2D, v);
        this.current = v;
        this.dirty = false;
    };
    return BindTexture;
}(BaseValue);
var BindVertexBuffer = function (BaseValue) {
    function BindVertexBuffer() {
        BaseValue.apply(this, arguments);
    }
    if (BaseValue)
        BindVertexBuffer.__proto__ = BaseValue;
    BindVertexBuffer.prototype = Object.create(BaseValue && BaseValue.prototype);
    BindVertexBuffer.prototype.constructor = BindVertexBuffer;
    BindVertexBuffer.prototype.getDefault = function getDefault() {
        return null;
    };
    BindVertexBuffer.prototype.set = function set(v) {
        if (v === this.current && !this.dirty) {
            return;
        }
        var gl = this.gl;
        gl.bindBuffer(gl.ARRAY_BUFFER, v);
        this.current = v;
        this.dirty = false;
    };
    return BindVertexBuffer;
}(BaseValue);
var BindElementBuffer = function (BaseValue) {
    function BindElementBuffer() {
        BaseValue.apply(this, arguments);
    }
    if (BaseValue)
        BindElementBuffer.__proto__ = BaseValue;
    BindElementBuffer.prototype = Object.create(BaseValue && BaseValue.prototype);
    BindElementBuffer.prototype.constructor = BindElementBuffer;
    BindElementBuffer.prototype.getDefault = function getDefault() {
        return null;
    };
    BindElementBuffer.prototype.set = function set(v) {
        var gl = this.gl;
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, v);
        this.current = v;
        this.dirty = false;
    };
    return BindElementBuffer;
}(BaseValue);
var BindVertexArrayOES = function (BaseValue) {
    function BindVertexArrayOES(context) {
        BaseValue.call(this, context);
        this.vao = context.extVertexArrayObject;
    }
    if (BaseValue)
        BindVertexArrayOES.__proto__ = BaseValue;
    BindVertexArrayOES.prototype = Object.create(BaseValue && BaseValue.prototype);
    BindVertexArrayOES.prototype.constructor = BindVertexArrayOES;
    BindVertexArrayOES.prototype.getDefault = function getDefault() {
        return null;
    };
    BindVertexArrayOES.prototype.set = function set(v) {
        if (!this.vao || v === this.current && !this.dirty) {
            return;
        }
        this.vao.bindVertexArrayOES(v);
        this.current = v;
        this.dirty = false;
    };
    return BindVertexArrayOES;
}(BaseValue);
var PixelStoreUnpack = function (BaseValue) {
    function PixelStoreUnpack() {
        BaseValue.apply(this, arguments);
    }
    if (BaseValue)
        PixelStoreUnpack.__proto__ = BaseValue;
    PixelStoreUnpack.prototype = Object.create(BaseValue && BaseValue.prototype);
    PixelStoreUnpack.prototype.constructor = PixelStoreUnpack;
    PixelStoreUnpack.prototype.getDefault = function getDefault() {
        return 4;
    };
    PixelStoreUnpack.prototype.set = function set(v) {
        if (v === this.current && !this.dirty) {
            return;
        }
        var gl = this.gl;
        gl.pixelStorei(gl.UNPACK_ALIGNMENT, v);
        this.current = v;
        this.dirty = false;
    };
    return PixelStoreUnpack;
}(BaseValue);
var PixelStoreUnpackPremultiplyAlpha = function (BaseValue) {
    function PixelStoreUnpackPremultiplyAlpha() {
        BaseValue.apply(this, arguments);
    }
    if (BaseValue)
        PixelStoreUnpackPremultiplyAlpha.__proto__ = BaseValue;
    PixelStoreUnpackPremultiplyAlpha.prototype = Object.create(BaseValue && BaseValue.prototype);
    PixelStoreUnpackPremultiplyAlpha.prototype.constructor = PixelStoreUnpackPremultiplyAlpha;
    PixelStoreUnpackPremultiplyAlpha.prototype.getDefault = function getDefault() {
        return false;
    };
    PixelStoreUnpackPremultiplyAlpha.prototype.set = function set(v) {
        if (v === this.current && !this.dirty) {
            return;
        }
        var gl = this.gl;
        gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, v);
        this.current = v;
        this.dirty = false;
    };
    return PixelStoreUnpackPremultiplyAlpha;
}(BaseValue);
var PixelStoreUnpackFlipY = function (BaseValue) {
    function PixelStoreUnpackFlipY() {
        BaseValue.apply(this, arguments);
    }
    if (BaseValue)
        PixelStoreUnpackFlipY.__proto__ = BaseValue;
    PixelStoreUnpackFlipY.prototype = Object.create(BaseValue && BaseValue.prototype);
    PixelStoreUnpackFlipY.prototype.constructor = PixelStoreUnpackFlipY;
    PixelStoreUnpackFlipY.prototype.getDefault = function getDefault() {
        return false;
    };
    PixelStoreUnpackFlipY.prototype.set = function set(v) {
        if (v === this.current && !this.dirty) {
            return;
        }
        var gl = this.gl;
        gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, v);
        this.current = v;
        this.dirty = false;
    };
    return PixelStoreUnpackFlipY;
}(BaseValue);
var FramebufferAttachment = function (BaseValue) {
    function FramebufferAttachment(context, parent) {
        BaseValue.call(this, context);
        this.context = context;
        this.parent = parent;
    }
    if (BaseValue)
        FramebufferAttachment.__proto__ = BaseValue;
    FramebufferAttachment.prototype = Object.create(BaseValue && BaseValue.prototype);
    FramebufferAttachment.prototype.constructor = FramebufferAttachment;
    FramebufferAttachment.prototype.getDefault = function getDefault() {
        return null;
    };
    return FramebufferAttachment;
}(BaseValue);
var ColorAttachment = function (FramebufferAttachment) {
    function ColorAttachment() {
        FramebufferAttachment.apply(this, arguments);
    }
    if (FramebufferAttachment)
        ColorAttachment.__proto__ = FramebufferAttachment;
    ColorAttachment.prototype = Object.create(FramebufferAttachment && FramebufferAttachment.prototype);
    ColorAttachment.prototype.constructor = ColorAttachment;
    ColorAttachment.prototype.setDirty = function setDirty() {
        this.dirty = true;
    };
    ColorAttachment.prototype.set = function set(v) {
        if (v === this.current && !this.dirty) {
            return;
        }
        this.context.bindFramebuffer.set(this.parent);
        var gl = this.gl;
        gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, v, 0);
        this.current = v;
        this.dirty = false;
    };
    return ColorAttachment;
}(FramebufferAttachment);
var DepthAttachment = function (FramebufferAttachment) {
    function DepthAttachment() {
        FramebufferAttachment.apply(this, arguments);
    }
    if (FramebufferAttachment)
        DepthAttachment.__proto__ = FramebufferAttachment;
    DepthAttachment.prototype = Object.create(FramebufferAttachment && FramebufferAttachment.prototype);
    DepthAttachment.prototype.constructor = DepthAttachment;
    DepthAttachment.prototype.set = function set(v) {
        if (v === this.current && !this.dirty) {
            return;
        }
        this.context.bindFramebuffer.set(this.parent);
        var gl = this.gl;
        gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.DEPTH_ATTACHMENT, gl.RENDERBUFFER, v);
        this.current = v;
        this.dirty = false;
    };
    return DepthAttachment;
}(FramebufferAttachment);

var Framebuffer = function Framebuffer(context, width, height, hasDepth) {
    this.context = context;
    this.width = width;
    this.height = height;
    var gl = context.gl;
    var fbo = this.framebuffer = gl.createFramebuffer();
    this.colorAttachment = new ColorAttachment(context, fbo);
    if (hasDepth) {
        this.depthAttachment = new DepthAttachment(context, fbo);
    }
};
Framebuffer.prototype.destroy = function destroy() {
    var gl = this.context.gl;
    var texture = this.colorAttachment.get();
    if (texture) {
        gl.deleteTexture(texture);
    }
    if (this.depthAttachment) {
        var renderbuffer = this.depthAttachment.get();
        if (renderbuffer) {
            gl.deleteRenderbuffer(renderbuffer);
        }
    }
    gl.deleteFramebuffer(this.framebuffer);
};

var ALWAYS = 519;
var DepthMode = function DepthMode(depthFunc, depthMask, depthRange) {
    this.func = depthFunc;
    this.mask = depthMask;
    this.range = depthRange;
};
DepthMode.ReadOnly = false;
DepthMode.ReadWrite = true;
DepthMode.disabled = new DepthMode(ALWAYS, DepthMode.ReadOnly, [
    0,
    1
]);

var ALWAYS$1 = 519;
var KEEP = 7680;
var StencilMode = function StencilMode(test, ref, mask, fail, depthFail, pass) {
    this.test = test;
    this.ref = ref;
    this.mask = mask;
    this.fail = fail;
    this.depthFail = depthFail;
    this.pass = pass;
};
StencilMode.disabled = new StencilMode({
    func: ALWAYS$1,
    mask: 0
}, 0, 0, KEEP, KEEP, KEEP);

var ZERO = 0;
var ONE = 1;
var ONE_MINUS_SRC_ALPHA = 771;
var ColorMode = function ColorMode(blendFunction, blendColor, mask) {
    this.blendFunction = blendFunction;
    this.blendColor = blendColor;
    this.mask = mask;
};
ColorMode.Replace = [
    ONE,
    ZERO
];
ColorMode.disabled = new ColorMode(ColorMode.Replace, performance.Color.transparent, [
    false,
    false,
    false,
    false
]);
ColorMode.unblended = new ColorMode(ColorMode.Replace, performance.Color.transparent, [
    true,
    true,
    true,
    true
]);
ColorMode.alphaBlended = new ColorMode([
    ONE,
    ONE_MINUS_SRC_ALPHA
], performance.Color.transparent, [
    true,
    true,
    true,
    true
]);

var BACK = 1029;
var CCW = 2305;
var CullFaceMode = function CullFaceMode(enable, mode, frontFace) {
    this.enable = enable;
    this.mode = mode;
    this.frontFace = frontFace;
};
CullFaceMode.disabled = new CullFaceMode(false, BACK, CCW);
CullFaceMode.backCCW = new CullFaceMode(true, BACK, CCW);

var Context = function Context(gl) {
    this.gl = gl;
    this.extVertexArrayObject = this.gl.getExtension('OES_vertex_array_object');
    this.clearColor = new ClearColor(this);
    this.clearDepth = new ClearDepth(this);
    this.clearStencil = new ClearStencil(this);
    this.colorMask = new ColorMask(this);
    this.depthMask = new DepthMask(this);
    this.stencilMask = new StencilMask(this);
    this.stencilFunc = new StencilFunc(this);
    this.stencilOp = new StencilOp(this);
    this.stencilTest = new StencilTest(this);
    this.depthRange = new DepthRange(this);
    this.depthTest = new DepthTest(this);
    this.depthFunc = new DepthFunc(this);
    this.blend = new Blend(this);
    this.blendFunc = new BlendFunc(this);
    this.blendColor = new BlendColor(this);
    this.blendEquation = new BlendEquation(this);
    this.cullFace = new CullFace(this);
    this.cullFaceSide = new CullFaceSide(this);
    this.frontFace = new FrontFace(this);
    this.program = new Program(this);
    this.activeTexture = new ActiveTextureUnit(this);
    this.viewport = new Viewport(this);
    this.bindFramebuffer = new BindFramebuffer(this);
    this.bindRenderbuffer = new BindRenderbuffer(this);
    this.bindTexture = new BindTexture(this);
    this.bindVertexBuffer = new BindVertexBuffer(this);
    this.bindElementBuffer = new BindElementBuffer(this);
    this.bindVertexArrayOES = this.extVertexArrayObject && new BindVertexArrayOES(this);
    this.pixelStoreUnpack = new PixelStoreUnpack(this);
    this.pixelStoreUnpackPremultiplyAlpha = new PixelStoreUnpackPremultiplyAlpha(this);
    this.pixelStoreUnpackFlipY = new PixelStoreUnpackFlipY(this);
    this.extTextureFilterAnisotropic = gl.getExtension('EXT_texture_filter_anisotropic') || gl.getExtension('MOZ_EXT_texture_filter_anisotropic') || gl.getExtension('WEBKIT_EXT_texture_filter_anisotropic');
    if (this.extTextureFilterAnisotropic) {
        this.extTextureFilterAnisotropicMax = gl.getParameter(this.extTextureFilterAnisotropic.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
    }
    this.extTextureHalfFloat = gl.getExtension('OES_texture_half_float');
    if (this.extTextureHalfFloat) {
        gl.getExtension('OES_texture_half_float_linear');
        this.extRenderToTextureHalfFloat = gl.getExtension('EXT_color_buffer_half_float');
    }
    this.extTimerQuery = gl.getExtension('EXT_disjoint_timer_query');
    this.maxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE);
};
Context.prototype.setDefault = function setDefault() {
    this.unbindVAO();
    this.clearColor.setDefault();
    this.clearDepth.setDefault();
    this.clearStencil.setDefault();
    this.colorMask.setDefault();
    this.depthMask.setDefault();
    this.stencilMask.setDefault();
    this.stencilFunc.setDefault();
    this.stencilOp.setDefault();
    this.stencilTest.setDefault();
    this.depthRange.setDefault();
    this.depthTest.setDefault();
    this.depthFunc.setDefault();
    this.blend.setDefault();
    this.blendFunc.setDefault();
    this.blendColor.setDefault();
    this.blendEquation.setDefault();
    this.cullFace.setDefault();
    this.cullFaceSide.setDefault();
    this.frontFace.setDefault();
    this.program.setDefault();
    this.activeTexture.setDefault();
    this.bindFramebuffer.setDefault();
    this.pixelStoreUnpack.setDefault();
    this.pixelStoreUnpackPremultiplyAlpha.setDefault();
    this.pixelStoreUnpackFlipY.setDefault();
};
Context.prototype.setDirty = function setDirty() {
    this.clearColor.dirty = true;
    this.clearDepth.dirty = true;
    this.clearStencil.dirty = true;
    this.colorMask.dirty = true;
    this.depthMask.dirty = true;
    this.stencilMask.dirty = true;
    this.stencilFunc.dirty = true;
    this.stencilOp.dirty = true;
    this.stencilTest.dirty = true;
    this.depthRange.dirty = true;
    this.depthTest.dirty = true;
    this.depthFunc.dirty = true;
    this.blend.dirty = true;
    this.blendFunc.dirty = true;
    this.blendColor.dirty = true;
    this.blendEquation.dirty = true;
    this.cullFace.dirty = true;
    this.cullFaceSide.dirty = true;
    this.frontFace.dirty = true;
    this.program.dirty = true;
    this.activeTexture.dirty = true;
    this.viewport.dirty = true;
    this.bindFramebuffer.dirty = true;
    this.bindRenderbuffer.dirty = true;
    this.bindTexture.dirty = true;
    this.bindVertexBuffer.dirty = true;
    this.bindElementBuffer.dirty = true;
    if (this.extVertexArrayObject) {
        this.bindVertexArrayOES.dirty = true;
    }
    this.pixelStoreUnpack.dirty = true;
    this.pixelStoreUnpackPremultiplyAlpha.dirty = true;
    this.pixelStoreUnpackFlipY.dirty = true;
};
Context.prototype.createIndexBuffer = function createIndexBuffer(array, dynamicDraw) {
    return new IndexBuffer(this, array, dynamicDraw);
};
Context.prototype.createVertexBuffer = function createVertexBuffer(array, attributes, dynamicDraw) {
    return new VertexBuffer(this, array, attributes, dynamicDraw);
};
Context.prototype.createRenderbuffer = function createRenderbuffer(storageFormat, width, height) {
    var gl = this.gl;
    var rbo = gl.createRenderbuffer();
    this.bindRenderbuffer.set(rbo);
    gl.renderbufferStorage(gl.RENDERBUFFER, storageFormat, width, height);
    this.bindRenderbuffer.set(null);
    return rbo;
};
Context.prototype.createFramebuffer = function createFramebuffer(width, height, hasDepth) {
    return new Framebuffer(this, width, height, hasDepth);
};
Context.prototype.clear = function clear(ref) {
    var color = ref.color;
    var depth = ref.depth;
    var gl = this.gl;
    var mask = 0;
    if (color) {
        mask |= gl.COLOR_BUFFER_BIT;
        this.clearColor.set(color);
        this.colorMask.set([
            true,
            true,
            true,
            true
        ]);
    }
    if (typeof depth !== 'undefined') {
        mask |= gl.DEPTH_BUFFER_BIT;
        this.depthRange.set([
            0,
            1
        ]);
        this.clearDepth.set(depth);
        this.depthMask.set(true);
    }
    gl.clear(mask);
};
Context.prototype.setCullFace = function setCullFace(cullFaceMode) {
    if (cullFaceMode.enable === false) {
        this.cullFace.set(false);
    } else {
        this.cullFace.set(true);
        this.cullFaceSide.set(cullFaceMode.mode);
        this.frontFace.set(cullFaceMode.frontFace);
    }
};
Context.prototype.setDepthMode = function setDepthMode(depthMode) {
    if (depthMode.func === this.gl.ALWAYS && !depthMode.mask) {
        this.depthTest.set(false);
    } else {
        this.depthTest.set(true);
        this.depthFunc.set(depthMode.func);
        this.depthMask.set(depthMode.mask);
        this.depthRange.set(depthMode.range);
    }
};
Context.prototype.setStencilMode = function setStencilMode(stencilMode) {
    if (stencilMode.test.func === this.gl.ALWAYS && !stencilMode.mask) {
        this.stencilTest.set(false);
    } else {
        this.stencilTest.set(true);
        this.stencilMask.set(stencilMode.mask);
        this.stencilOp.set([
            stencilMode.fail,
            stencilMode.depthFail,
            stencilMode.pass
        ]);
        this.stencilFunc.set({
            func: stencilMode.test.func,
            ref: stencilMode.ref,
            mask: stencilMode.test.mask
        });
    }
};
Context.prototype.setColorMode = function setColorMode(colorMode) {
    if (performance.deepEqual(colorMode.blendFunction, ColorMode.Replace)) {
        this.blend.set(false);
    } else {
        this.blend.set(true);
        this.blendFunc.set(colorMode.blendFunction);
        this.blendColor.set(colorMode.blendColor);
    }
    this.colorMask.set(colorMode.mask);
};
Context.prototype.unbindVAO = function unbindVAO() {
    if (this.extVertexArrayObject) {
        this.bindVertexArrayOES.set(null);
    }
};

var SourceCache = function (Evented) {
    function SourceCache(id, options, dispatcher) {
        var this$1 = this;
        Evented.call(this);
        this.id = id;
        this.dispatcher = dispatcher;
        this.on('data', function (e) {
            if (e.dataType === 'source' && e.sourceDataType === 'metadata') {
                this$1._sourceLoaded = true;
            }
            if (this$1._sourceLoaded && !this$1._paused && e.dataType === 'source' && e.sourceDataType === 'content') {
                this$1.reload();
                if (this$1.transform) {
                    this$1.update(this$1.transform);
                }
            }
        });
        this.on('error', function () {
            this$1._sourceErrored = true;
        });
        this._source = create(id, options, dispatcher, this);
        this._tiles = {};
        this._cache = new TileCache(0, this._unloadTile.bind(this));
        this._timers = {};
        this._cacheTimers = {};
        this._maxTileCacheSize = null;
        this._loadedParentTiles = {};
        this._coveredTiles = {};
        this._state = new performance.SourceFeatureState();
    }
    if (Evented)
        SourceCache.__proto__ = Evented;
    SourceCache.prototype = Object.create(Evented && Evented.prototype);
    SourceCache.prototype.constructor = SourceCache;
    SourceCache.prototype.onAdd = function onAdd(map) {
        this.map = map;
        this._maxTileCacheSize = map ? map._maxTileCacheSize : null;
        if (this._source && this._source.onAdd) {
            this._source.onAdd(map);
        }
    };
    SourceCache.prototype.onRemove = function onRemove(map) {
        if (this._source && this._source.onRemove) {
            this._source.onRemove(map);
        }
    };
    SourceCache.prototype.loaded = function loaded() {
        if (this._sourceErrored) {
            return true;
        }
        if (!this._sourceLoaded) {
            return false;
        }
        if (!this._source.loaded()) {
            return false;
        }
        for (var t in this._tiles) {
            var tile = this._tiles[t];
            if (tile.state !== 'loaded' && tile.state !== 'errored') {
                return false;
            }
        }
        return true;
    };
    SourceCache.prototype.getSource = function getSource() {
        return this._source;
    };
    SourceCache.prototype.pause = function pause() {
        this._paused = true;
    };
    SourceCache.prototype.resume = function resume() {
        if (!this._paused) {
            return;
        }
        var shouldReload = this._shouldReloadOnResume;
        this._paused = false;
        this._shouldReloadOnResume = false;
        if (shouldReload) {
            this.reload();
        }
        if (this.transform) {
            this.update(this.transform);
        }
    };
    SourceCache.prototype._loadTile = function _loadTile(tile, callback) {
        return this._source.loadTile(tile, callback);
    };
    SourceCache.prototype._unloadTile = function _unloadTile(tile) {
        if (this._source.unloadTile) {
            return this._source.unloadTile(tile, function () {
            });
        }
    };
    SourceCache.prototype._abortTile = function _abortTile(tile) {
        if (this._source.abortTile) {
            return this._source.abortTile(tile, function () {
            });
        }
    };
    SourceCache.prototype.serialize = function serialize() {
        return this._source.serialize();
    };
    SourceCache.prototype.prepare = function prepare(context) {
        if (this._source.prepare) {
            this._source.prepare();
        }
        this._state.coalesceChanges(this._tiles, this.map ? this.map.painter : null);
        for (var i in this._tiles) {
            var tile = this._tiles[i];
            tile.upload(context);
            tile.prepare(this.map.style.imageManager);
        }
    };
    SourceCache.prototype.getIds = function getIds() {
        return performance.values(this._tiles).map(function (tile) {
            return tile.tileID;
        }).sort(compareTileId).map(function (id) {
            return id.key;
        });
    };
    SourceCache.prototype.getRenderableIds = function getRenderableIds(symbolLayer) {
        var this$1 = this;
        var renderables = [];
        for (var id in this._tiles) {
            if (this._isIdRenderable(id, symbolLayer)) {
                renderables.push(this._tiles[id]);
            }
        }
        if (symbolLayer) {
            return renderables.sort(function (a_, b_) {
                var a = a_.tileID;
                var b = b_.tileID;
                var rotatedA = new performance.Point(a.canonical.x, a.canonical.y)._rotate(this$1.transform.angle);
                var rotatedB = new performance.Point(b.canonical.x, b.canonical.y)._rotate(this$1.transform.angle);
                return a.overscaledZ - b.overscaledZ || rotatedB.y - rotatedA.y || rotatedB.x - rotatedA.x;
            }).map(function (tile) {
                return tile.tileID.key;
            });
        }
        return renderables.map(function (tile) {
            return tile.tileID;
        }).sort(compareTileId).map(function (id) {
            return id.key;
        });
    };
    SourceCache.prototype.hasRenderableParent = function hasRenderableParent(tileID) {
        var parentTile = this.findLoadedParent(tileID, 0);
        if (parentTile) {
            return this._isIdRenderable(parentTile.tileID.key);
        }
        return false;
    };
    SourceCache.prototype._isIdRenderable = function _isIdRenderable(id, symbolLayer) {
        return this._tiles[id] && this._tiles[id].hasData() && !this._coveredTiles[id] && (symbolLayer || !this._tiles[id].holdingForFade());
    };
    SourceCache.prototype.reload = function reload() {
        if (this._paused) {
            this._shouldReloadOnResume = true;
            return;
        }
        this._cache.reset();
        for (var i in this._tiles) {
            if (this._tiles[i].state !== 'errored') {
                this._reloadTile(i, 'reloading');
            }
        }
    };
    SourceCache.prototype._reloadTile = function _reloadTile(id, state) {
        var tile = this._tiles[id];
        if (!tile) {
            return;
        }
        if (tile.state !== 'loading') {
            tile.state = state;
        }
        this._loadTile(tile, this._tileLoaded.bind(this, tile, id, state));
    };
    SourceCache.prototype._tileLoaded = function _tileLoaded(tile, id, previousState, err) {
        if (err) {
            tile.state = 'errored';
            if (err.status !== 404) {
                this._source.fire(new performance.ErrorEvent(err, { tile: tile }));
            } else {
                this.update(this.transform);
            }
            return;
        }
        tile.timeAdded = performance.browser.now();
        if (previousState === 'expired') {
            tile.refreshedUponExpiration = true;
        }
        this._setTileReloadTimer(id, tile);
        if (this.getSource().type === 'raster-dem' && tile.dem) {
            this._backfillDEM(tile);
        }
        this._state.initializeTileState(tile, this.map ? this.map.painter : null);
        this._source.fire(new performance.Event('data', {
            dataType: 'source',
            tile: tile,
            coord: tile.tileID
        }));
    };
    SourceCache.prototype._backfillDEM = function _backfillDEM(tile) {
        var renderables = this.getRenderableIds();
        for (var i = 0; i < renderables.length; i++) {
            var borderId = renderables[i];
            if (tile.neighboringTiles && tile.neighboringTiles[borderId]) {
                var borderTile = this.getTileByID(borderId);
                fillBorder(tile, borderTile);
                fillBorder(borderTile, tile);
            }
        }
        function fillBorder(tile, borderTile) {
            tile.needsHillshadePrepare = true;
            var dx = borderTile.tileID.canonical.x - tile.tileID.canonical.x;
            var dy = borderTile.tileID.canonical.y - tile.tileID.canonical.y;
            var dim = Math.pow(2, tile.tileID.canonical.z);
            var borderId = borderTile.tileID.key;
            if (dx === 0 && dy === 0) {
                return;
            }
            if (Math.abs(dy) > 1) {
                return;
            }
            if (Math.abs(dx) > 1) {
                if (Math.abs(dx + dim) === 1) {
                    dx += dim;
                } else if (Math.abs(dx - dim) === 1) {
                    dx -= dim;
                }
            }
            if (!borderTile.dem || !tile.dem) {
                return;
            }
            tile.dem.backfillBorder(borderTile.dem, dx, dy);
            if (tile.neighboringTiles && tile.neighboringTiles[borderId]) {
                tile.neighboringTiles[borderId].backfilled = true;
            }
        }
    };
    SourceCache.prototype.getTile = function getTile(tileID) {
        return this.getTileByID(tileID.key);
    };
    SourceCache.prototype.getTileByID = function getTileByID(id) {
        return this._tiles[id];
    };
    SourceCache.prototype._retainLoadedChildren = function _retainLoadedChildren(idealTiles, zoom, maxCoveringZoom, retain) {
        for (var id in this._tiles) {
            var tile = this._tiles[id];
            if (retain[id] || !tile.hasData() || tile.tileID.overscaledZ <= zoom || tile.tileID.overscaledZ > maxCoveringZoom) {
                continue;
            }
            var topmostLoadedID = tile.tileID;
            while (tile && tile.tileID.overscaledZ > zoom + 1) {
                var parentID = tile.tileID.scaledTo(tile.tileID.overscaledZ - 1);
                tile = this._tiles[parentID.key];
                if (tile && tile.hasData()) {
                    topmostLoadedID = parentID;
                }
            }
            var tileID = topmostLoadedID;
            while (tileID.overscaledZ > zoom) {
                tileID = tileID.scaledTo(tileID.overscaledZ - 1);
                if (idealTiles[tileID.key]) {
                    retain[topmostLoadedID.key] = topmostLoadedID;
                    break;
                }
            }
        }
    };
    SourceCache.prototype.findLoadedParent = function findLoadedParent(tileID, minCoveringZoom) {
        if (tileID.key in this._loadedParentTiles) {
            var parent = this._loadedParentTiles[tileID.key];
            if (parent && parent.tileID.overscaledZ >= minCoveringZoom) {
                return parent;
            } else {
                return null;
            }
        }
        for (var z = tileID.overscaledZ - 1; z >= minCoveringZoom; z--) {
            var parentTileID = tileID.scaledTo(z);
            var tile = this._getLoadedTile(parentTileID);
            if (tile) {
                return tile;
            }
        }
    };
    SourceCache.prototype._getLoadedTile = function _getLoadedTile(tileID) {
        var tile = this._tiles[tileID.key];
        if (tile && tile.hasData()) {
            return tile;
        }
        var cachedTile = this._cache.getByKey(tileID.wrapped().key);
        return cachedTile;
    };
    SourceCache.prototype.updateCacheSize = function updateCacheSize(transform) {
        var widthInTiles = Math.ceil(transform.width / this._source.tileSize) + 1;
        var heightInTiles = Math.ceil(transform.height / this._source.tileSize) + 1;
        var approxTilesInView = widthInTiles * heightInTiles;
        var commonZoomRange = 5;
        var viewDependentMaxSize = Math.floor(approxTilesInView * commonZoomRange);
        var maxSize = typeof this._maxTileCacheSize === 'number' ? Math.min(this._maxTileCacheSize, viewDependentMaxSize) : viewDependentMaxSize;
        this._cache.setMaxSize(maxSize);
    };
    SourceCache.prototype.handleWrapJump = function handleWrapJump(lng) {
        var prevLng = this._prevLng === undefined ? lng : this._prevLng;
        var lngDifference = lng - prevLng;
        var worldDifference = lngDifference / 360;
        var wrapDelta = Math.round(worldDifference);
        this._prevLng = lng;
        if (wrapDelta) {
            var tiles = {};
            for (var key in this._tiles) {
                var tile = this._tiles[key];
                tile.tileID = tile.tileID.unwrapTo(tile.tileID.wrap + wrapDelta);
                tiles[tile.tileID.key] = tile;
            }
            this._tiles = tiles;
            for (var id in this._timers) {
                clearTimeout(this._timers[id]);
                delete this._timers[id];
            }
            for (var id$1 in this._tiles) {
                var tile$1 = this._tiles[id$1];
                this._setTileReloadTimer(id$1, tile$1);
            }
        }
    };
    SourceCache.prototype.update = function update(transform) {
        var this$1 = this;
        this.transform = transform;
        if (!this._sourceLoaded || this._paused) {
            return;
        }
        this.updateCacheSize(transform);
        this.handleWrapJump(this.transform.center.lng);
        this._coveredTiles = {};
        var idealTileIDs;
        if (!this.used) {
            idealTileIDs = [];
        } else if (this._source.tileID) {
            idealTileIDs = transform.getVisibleUnwrappedCoordinates(this._source.tileID).map(function (unwrapped) {
                return new performance.OverscaledTileID(unwrapped.canonical.z, unwrapped.wrap, unwrapped.canonical.z, unwrapped.canonical.x, unwrapped.canonical.y);
            });
        } else {
            idealTileIDs = transform.coveringTiles({
                tileSize: this._source.tileSize,
                minzoom: this._source.minzoom,
                maxzoom: this._source.maxzoom,
                roundZoom: this._source.roundZoom,
                reparseOverscaled: this._source.reparseOverscaled
            });
            if (this._source.hasTile) {
                idealTileIDs = idealTileIDs.filter(function (coord) {
                    return this$1._source.hasTile(coord);
                });
            }
        }
        var zoom = transform.coveringZoomLevel(this._source);
        var minCoveringZoom = Math.max(zoom - SourceCache.maxOverzooming, this._source.minzoom);
        var maxCoveringZoom = Math.max(zoom + SourceCache.maxUnderzooming, this._source.minzoom);
        var retain = this._updateRetainedTiles(idealTileIDs, zoom);
        if (isRasterType(this._source.type)) {
            var parentsForFading = {};
            var fadingTiles = {};
            var ids = Object.keys(retain);
            for (var i = 0, list = ids; i < list.length; i += 1) {
                var id = list[i];
                var tileID = retain[id];
                var tile = this._tiles[id];
                if (!tile || tile.fadeEndTime && tile.fadeEndTime <= performance.browser.now()) {
                    continue;
                }
                var parentTile = this.findLoadedParent(tileID, minCoveringZoom);
                if (parentTile) {
                    this._addTile(parentTile.tileID);
                    parentsForFading[parentTile.tileID.key] = parentTile.tileID;
                }
                fadingTiles[id] = tileID;
            }
            this._retainLoadedChildren(fadingTiles, zoom, maxCoveringZoom, retain);
            for (var id$1 in parentsForFading) {
                if (!retain[id$1]) {
                    this._coveredTiles[id$1] = true;
                    retain[id$1] = parentsForFading[id$1];
                }
            }
        }
        for (var retainedId in retain) {
            this._tiles[retainedId].clearFadeHold();
        }
        var remove = performance.keysDifference(this._tiles, retain);
        for (var i$1 = 0, list$1 = remove; i$1 < list$1.length; i$1 += 1) {
            var tileID$1 = list$1[i$1];
            var tile$1 = this._tiles[tileID$1];
            if (tile$1.hasSymbolBuckets && !tile$1.holdingForFade()) {
                tile$1.setHoldDuration(this.map._fadeDuration);
            } else if (!tile$1.hasSymbolBuckets || tile$1.symbolFadeFinished()) {
                this._removeTile(tileID$1);
            }
        }
        this._updateLoadedParentTileCache();
    };
    SourceCache.prototype.releaseSymbolFadeTiles = function releaseSymbolFadeTiles() {
        for (var id in this._tiles) {
            if (this._tiles[id].holdingForFade()) {
                this._removeTile(id);
            }
        }
    };
    SourceCache.prototype._updateRetainedTiles = function _updateRetainedTiles(idealTileIDs, zoom) {
        var retain = {};
        var checked = {};
        var minCoveringZoom = Math.max(zoom - SourceCache.maxOverzooming, this._source.minzoom);
        var maxCoveringZoom = Math.max(zoom + SourceCache.maxUnderzooming, this._source.minzoom);
        var missingTiles = {};
        for (var i = 0, list = idealTileIDs; i < list.length; i += 1) {
            var tileID = list[i];
            var tile = this._addTile(tileID);
            retain[tileID.key] = tileID;
            if (tile.hasData()) {
                continue;
            }
            if (zoom < this._source.maxzoom) {
                missingTiles[tileID.key] = tileID;
            }
        }
        this._retainLoadedChildren(missingTiles, zoom, maxCoveringZoom, retain);
        for (var i$1 = 0, list$1 = idealTileIDs; i$1 < list$1.length; i$1 += 1) {
            var tileID$1 = list$1[i$1];
            var tile$1 = this._tiles[tileID$1.key];
            if (tile$1.hasData()) {
                continue;
            }
            if (zoom + 1 > this._source.maxzoom) {
                var childCoord = tileID$1.children(this._source.maxzoom)[0];
                var childTile = this.getTile(childCoord);
                if (!!childTile && childTile.hasData()) {
                    retain[childCoord.key] = childCoord;
                    continue;
                }
            } else {
                var children = tileID$1.children(this._source.maxzoom);
                if (retain[children[0].key] && retain[children[1].key] && retain[children[2].key] && retain[children[3].key]) {
                    continue;
                }
            }
            var parentWasRequested = tile$1.wasRequested();
            for (var overscaledZ = tileID$1.overscaledZ - 1; overscaledZ >= minCoveringZoom; --overscaledZ) {
                var parentId = tileID$1.scaledTo(overscaledZ);
                if (checked[parentId.key]) {
                    break;
                }
                checked[parentId.key] = true;
                tile$1 = this.getTile(parentId);
                if (!tile$1 && parentWasRequested) {
                    tile$1 = this._addTile(parentId);
                }
                if (tile$1) {
                    retain[parentId.key] = parentId;
                    parentWasRequested = tile$1.wasRequested();
                    if (tile$1.hasData()) {
                        break;
                    }
                }
            }
        }
        return retain;
    };
    SourceCache.prototype._updateLoadedParentTileCache = function _updateLoadedParentTileCache() {
        this._loadedParentTiles = {};
        for (var tileKey in this._tiles) {
            var path = [];
            var parentTile = void 0;
            var currentId = this._tiles[tileKey].tileID;
            while (currentId.overscaledZ > 0) {
                if (currentId.key in this._loadedParentTiles) {
                    parentTile = this._loadedParentTiles[currentId.key];
                    break;
                }
                path.push(currentId.key);
                var parentId = currentId.scaledTo(currentId.overscaledZ - 1);
                parentTile = this._getLoadedTile(parentId);
                if (parentTile) {
                    break;
                }
                currentId = parentId;
            }
            for (var i = 0, list = path; i < list.length; i += 1) {
                var key = list[i];
                this._loadedParentTiles[key] = parentTile;
            }
        }
    };
    SourceCache.prototype._addTile = function _addTile(tileID) {
        var tile = this._tiles[tileID.key];
        if (tile) {
            return tile;
        }
        tile = this._cache.getAndRemove(tileID);
        if (tile) {
            this._setTileReloadTimer(tileID.key, tile);
            tile.tileID = tileID;
            this._state.initializeTileState(tile, this.map ? this.map.painter : null);
            if (this._cacheTimers[tileID.key]) {
                clearTimeout(this._cacheTimers[tileID.key]);
                delete this._cacheTimers[tileID.key];
                this._setTileReloadTimer(tileID.key, tile);
            }
        }
        var cached = Boolean(tile);
        if (!cached) {
            tile = new performance.Tile(tileID, this._source.tileSize * tileID.overscaleFactor());
            this._loadTile(tile, this._tileLoaded.bind(this, tile, tileID.key, tile.state));
        }
        if (!tile) {
            return null;
        }
        tile.uses++;
        this._tiles[tileID.key] = tile;
        if (!cached) {
            this._source.fire(new performance.Event('dataloading', {
                tile: tile,
                coord: tile.tileID,
                dataType: 'source'
            }));
        }
        return tile;
    };
    SourceCache.prototype._setTileReloadTimer = function _setTileReloadTimer(id, tile) {
        var this$1 = this;
        if (id in this._timers) {
            clearTimeout(this._timers[id]);
            delete this._timers[id];
        }
        var expiryTimeout = tile.getExpiryTimeout();
        if (expiryTimeout) {
            this._timers[id] = setTimeout(function () {
                this$1._reloadTile(id, 'expired');
                delete this$1._timers[id];
            }, expiryTimeout);
        }
    };
    SourceCache.prototype._removeTile = function _removeTile(id) {
        var tile = this._tiles[id];
        if (!tile) {
            return;
        }
        tile.uses--;
        delete this._tiles[id];
        if (this._timers[id]) {
            clearTimeout(this._timers[id]);
            delete this._timers[id];
        }
        if (tile.uses > 0) {
            return;
        }
        if (tile.hasData() && tile.state !== 'reloading') {
            this._cache.add(tile.tileID, tile, tile.getExpiryTimeout());
        } else {
            tile.aborted = true;
            this._abortTile(tile);
            this._unloadTile(tile);
        }
    };
    SourceCache.prototype.clearTiles = function clearTiles() {
        this._shouldReloadOnResume = false;
        this._paused = false;
        for (var id in this._tiles) {
            this._removeTile(id);
        }
        this._cache.reset();
    };
    SourceCache.prototype.tilesIn = function tilesIn(pointQueryGeometry, maxPitchScaleFactor, has3DLayer) {
        var this$1 = this;
        var tileResults = [];
        var transform = this.transform;
        if (!transform) {
            return tileResults;
        }
        var cameraPointQueryGeometry = has3DLayer ? transform.getCameraQueryGeometry(pointQueryGeometry) : pointQueryGeometry;
        var queryGeometry = pointQueryGeometry.map(function (p) {
            return transform.pointCoordinate(p);
        });
        var cameraQueryGeometry = cameraPointQueryGeometry.map(function (p) {
            return transform.pointCoordinate(p);
        });
        var ids = this.getIds();
        var minX = Infinity;
        var minY = Infinity;
        var maxX = -Infinity;
        var maxY = -Infinity;
        for (var i$1 = 0, list = cameraQueryGeometry; i$1 < list.length; i$1 += 1) {
            var p = list[i$1];
            minX = Math.min(minX, p.x);
            minY = Math.min(minY, p.y);
            maxX = Math.max(maxX, p.x);
            maxY = Math.max(maxY, p.y);
        }
        var loop = function (i) {
            var tile = this$1._tiles[ids[i]];
            if (tile.holdingForFade()) {
                return;
            }
            var tileID = tile.tileID;
            var scale = Math.pow(2, transform.zoom - tile.tileID.overscaledZ);
            var queryPadding = maxPitchScaleFactor * tile.queryPadding * performance.EXTENT / tile.tileSize / scale;
            var tileSpaceBounds = [
                tileID.getTilePoint(new performance.MercatorCoordinate(minX, minY)),
                tileID.getTilePoint(new performance.MercatorCoordinate(maxX, maxY))
            ];
            if (tileSpaceBounds[0].x - queryPadding < performance.EXTENT && tileSpaceBounds[0].y - queryPadding < performance.EXTENT && tileSpaceBounds[1].x + queryPadding >= 0 && tileSpaceBounds[1].y + queryPadding >= 0) {
                var tileSpaceQueryGeometry = queryGeometry.map(function (c) {
                    return tileID.getTilePoint(c);
                });
                var tileSpaceCameraQueryGeometry = cameraQueryGeometry.map(function (c) {
                    return tileID.getTilePoint(c);
                });
                tileResults.push({
                    tile: tile,
                    tileID: tileID,
                    queryGeometry: tileSpaceQueryGeometry,
                    cameraQueryGeometry: tileSpaceCameraQueryGeometry,
                    scale: scale
                });
            }
        };
        for (var i = 0; i < ids.length; i++)
            loop(i);
        return tileResults;
    };
    SourceCache.prototype.getVisibleCoordinates = function getVisibleCoordinates(symbolLayer) {
        var this$1 = this;
        var coords = this.getRenderableIds(symbolLayer).map(function (id) {
            return this$1._tiles[id].tileID;
        });
        for (var i = 0, list = coords; i < list.length; i += 1) {
            var coord = list[i];
            coord.posMatrix = this.transform.calculatePosMatrix(coord.toUnwrapped());
        }
        return coords;
    };
    SourceCache.prototype.hasTransition = function hasTransition() {
        if (this._source.hasTransition()) {
            return true;
        }
        if (isRasterType(this._source.type)) {
            for (var id in this._tiles) {
                var tile = this._tiles[id];
                if (tile.fadeEndTime !== undefined && tile.fadeEndTime >= performance.browser.now()) {
                    return true;
                }
            }
        }
        return false;
    };
    SourceCache.prototype.setFeatureState = function setFeatureState(sourceLayer, featureId, state) {
        sourceLayer = sourceLayer || '_geojsonTileLayer';
        this._state.updateState(sourceLayer, featureId, state);
    };
    SourceCache.prototype.removeFeatureState = function removeFeatureState(sourceLayer, featureId, key) {
        sourceLayer = sourceLayer || '_geojsonTileLayer';
        this._state.removeFeatureState(sourceLayer, featureId, key);
    };
    SourceCache.prototype.getFeatureState = function getFeatureState(sourceLayer, featureId) {
        sourceLayer = sourceLayer || '_geojsonTileLayer';
        return this._state.getState(sourceLayer, featureId);
    };
    SourceCache.prototype.setDependencies = function setDependencies(tileKey, namespace, dependencies) {
        var tile = this._tiles[tileKey];
        if (tile) {
            tile.setDependencies(namespace, dependencies);
        }
    };
    SourceCache.prototype.reloadTilesForDependencies = function reloadTilesForDependencies(namespaces, keys) {
        for (var id in this._tiles) {
            var tile = this._tiles[id];
            if (tile.hasDependency(namespaces, keys)) {
                this._reloadTile(id, 'reloading');
            }
        }
        this._cache.filter(function (tile) {
            return !tile.hasDependency(namespaces, keys);
        });
    };
    return SourceCache;
}(performance.Evented);
SourceCache.maxOverzooming = 10;
SourceCache.maxUnderzooming = 3;
function compareTileId(a, b) {
    var aWrap = Math.abs(a.wrap * 2) - +(a.wrap < 0);
    var bWrap = Math.abs(b.wrap * 2) - +(b.wrap < 0);
    return a.overscaledZ - b.overscaledZ || bWrap - aWrap || b.canonical.y - a.canonical.y || b.canonical.x - a.canonical.x;
}
function isRasterType(type) {
    return type === 'raster' || type === 'image' || type === 'video';
}

function WebWorker () {
    return new performance.window.Worker(exported.workerUrl);
}

var PRELOAD_POOL_ID = 'mapboxgl_preloaded_worker_pool';
var WorkerPool = function WorkerPool() {
    this.active = {};
};
WorkerPool.prototype.acquire = function acquire(mapId) {
    if (!this.workers) {
        this.workers = [];
        while (this.workers.length < WorkerPool.workerCount) {
            this.workers.push(new WebWorker());
        }
    }
    this.active[mapId] = true;
    return this.workers.slice();
};
WorkerPool.prototype.release = function release(mapId) {
    delete this.active[mapId];
    if (this.numActive() === 0) {
        this.workers.forEach(function (w) {
            w.terminate();
        });
        this.workers = null;
    }
};
WorkerPool.prototype.isPreloaded = function isPreloaded() {
    return !!this.active[PRELOAD_POOL_ID];
};
WorkerPool.prototype.numActive = function numActive() {
    return Object.keys(this.active).length;
};
var availableLogicalProcessors = Math.floor(performance.browser.hardwareConcurrency / 2);
WorkerPool.workerCount = Math.max(Math.min(availableLogicalProcessors, 6), 1);

var globalWorkerPool;
function getGlobalWorkerPool() {
    if (!globalWorkerPool) {
        globalWorkerPool = new WorkerPool();
    }
    return globalWorkerPool;
}
function prewarm() {
    var workerPool = getGlobalWorkerPool();
    workerPool.acquire(PRELOAD_POOL_ID);
}
function clearPrewarmedResources() {
    var pool = globalWorkerPool;
    if (pool) {
        if (pool.isPreloaded() && pool.numActive() === 1) {
            pool.release(PRELOAD_POOL_ID);
            globalWorkerPool = null;
        } else {
            console.warn('Could not clear WebWorkers since there are active Map instances that still reference it. The pre-warmed WebWorker pool can only be cleared when all map instances have been removed with map.remove()');
        }
    }
}

function deref(layer, parent) {
    var result = {};
    for (var k in layer) {
        if (k !== 'ref') {
            result[k] = layer[k];
        }
    }
    performance.refProperties.forEach(function (k) {
        if (k in parent) {
            result[k] = parent[k];
        }
    });
    return result;
}
function derefLayers(layers) {
    layers = layers.slice();
    var map = Object.create(null);
    for (var i = 0; i < layers.length; i++) {
        map[layers[i].id] = layers[i];
    }
    for (var i$1 = 0; i$1 < layers.length; i$1++) {
        if ('ref' in layers[i$1]) {
            layers[i$1] = deref(layers[i$1], map[layers[i$1].ref]);
        }
    }
    return layers;
}

function emptyStyle() {
    var style = {};
    var version = performance.styleSpec['$version'];
    for (var styleKey in performance.styleSpec['$root']) {
        var spec = performance.styleSpec['$root'][styleKey];
        if (spec.required) {
            var value = null;
            if (styleKey === 'version') {
                value = version;
            } else {
                if (spec.type === 'array') {
                    value = [];
                } else {
                    value = {};
                }
            }
            if (value != null) {
                style[styleKey] = value;
            }
        }
    }
    return style;
}

var operations = {
    setStyle: 'setStyle',
    addLayer: 'addLayer',
    removeLayer: 'removeLayer',
    setPaintProperty: 'setPaintProperty',
    setLayoutProperty: 'setLayoutProperty',
    setFilter: 'setFilter',
    addSource: 'addSource',
    removeSource: 'removeSource',
    setGeoJSONSourceData: 'setGeoJSONSourceData',
    setLayerZoomRange: 'setLayerZoomRange',
    setLayerProperty: 'setLayerProperty',
    setCenter: 'setCenter',
    setZoom: 'setZoom',
    setBearing: 'setBearing',
    setPitch: 'setPitch',
    setSprite: 'setSprite',
    setGlyphs: 'setGlyphs',
    setTransition: 'setTransition',
    setLight: 'setLight'
};
function addSource(sourceId, after, commands) {
    commands.push({
        command: operations.addSource,
        args: [
            sourceId,
            after[sourceId]
        ]
    });
}
function removeSource(sourceId, commands, sourcesRemoved) {
    commands.push({
        command: operations.removeSource,
        args: [sourceId]
    });
    sourcesRemoved[sourceId] = true;
}
function updateSource(sourceId, after, commands, sourcesRemoved) {
    removeSource(sourceId, commands, sourcesRemoved);
    addSource(sourceId, after, commands);
}
function canUpdateGeoJSON(before, after, sourceId) {
    var prop;
    for (prop in before[sourceId]) {
        if (!before[sourceId].hasOwnProperty(prop)) {
            continue;
        }
        if (prop !== 'data' && !performance.deepEqual(before[sourceId][prop], after[sourceId][prop])) {
            return false;
        }
    }
    for (prop in after[sourceId]) {
        if (!after[sourceId].hasOwnProperty(prop)) {
            continue;
        }
        if (prop !== 'data' && !performance.deepEqual(before[sourceId][prop], after[sourceId][prop])) {
            return false;
        }
    }
    return true;
}
function diffSources(before, after, commands, sourcesRemoved) {
    before = before || {};
    after = after || {};
    var sourceId;
    for (sourceId in before) {
        if (!before.hasOwnProperty(sourceId)) {
            continue;
        }
        if (!after.hasOwnProperty(sourceId)) {
            removeSource(sourceId, commands, sourcesRemoved);
        }
    }
    for (sourceId in after) {
        if (!after.hasOwnProperty(sourceId)) {
            continue;
        }
        if (!before.hasOwnProperty(sourceId)) {
            addSource(sourceId, after, commands);
        } else if (!performance.deepEqual(before[sourceId], after[sourceId])) {
            if (before[sourceId].type === 'geojson' && after[sourceId].type === 'geojson' && canUpdateGeoJSON(before, after, sourceId)) {
                commands.push({
                    command: operations.setGeoJSONSourceData,
                    args: [
                        sourceId,
                        after[sourceId].data
                    ]
                });
            } else {
                updateSource(sourceId, after, commands, sourcesRemoved);
            }
        }
    }
}
function diffLayerPropertyChanges(before, after, commands, layerId, klass, command) {
    before = before || {};
    after = after || {};
    var prop;
    for (prop in before) {
        if (!before.hasOwnProperty(prop)) {
            continue;
        }
        if (!performance.deepEqual(before[prop], after[prop])) {
            commands.push({
                command: command,
                args: [
                    layerId,
                    prop,
                    after[prop],
                    klass
                ]
            });
        }
    }
    for (prop in after) {
        if (!after.hasOwnProperty(prop) || before.hasOwnProperty(prop)) {
            continue;
        }
        if (!performance.deepEqual(before[prop], after[prop])) {
            commands.push({
                command: command,
                args: [
                    layerId,
                    prop,
                    after[prop],
                    klass
                ]
            });
        }
    }
}
function pluckId(layer) {
    return layer.id;
}
function indexById(group, layer) {
    group[layer.id] = layer;
    return group;
}
function diffLayers(before, after, commands) {
    before = before || [];
    after = after || [];
    var beforeOrder = before.map(pluckId);
    var afterOrder = after.map(pluckId);
    var beforeIndex = before.reduce(indexById, {});
    var afterIndex = after.reduce(indexById, {});
    var tracker = beforeOrder.slice();
    var clean = Object.create(null);
    var i, d, layerId, beforeLayer, afterLayer, insertBeforeLayerId, prop;
    for (i = 0, d = 0; i < beforeOrder.length; i++) {
        layerId = beforeOrder[i];
        if (!afterIndex.hasOwnProperty(layerId)) {
            commands.push({
                command: operations.removeLayer,
                args: [layerId]
            });
            tracker.splice(tracker.indexOf(layerId, d), 1);
        } else {
            d++;
        }
    }
    for (i = 0, d = 0; i < afterOrder.length; i++) {
        layerId = afterOrder[afterOrder.length - 1 - i];
        if (tracker[tracker.length - 1 - i] === layerId) {
            continue;
        }
        if (beforeIndex.hasOwnProperty(layerId)) {
            commands.push({
                command: operations.removeLayer,
                args: [layerId]
            });
            tracker.splice(tracker.lastIndexOf(layerId, tracker.length - d), 1);
        } else {
            d++;
        }
        insertBeforeLayerId = tracker[tracker.length - i];
        commands.push({
            command: operations.addLayer,
            args: [
                afterIndex[layerId],
                insertBeforeLayerId
            ]
        });
        tracker.splice(tracker.length - i, 0, layerId);
        clean[layerId] = true;
    }
    for (i = 0; i < afterOrder.length; i++) {
        layerId = afterOrder[i];
        beforeLayer = beforeIndex[layerId];
        afterLayer = afterIndex[layerId];
        if (clean[layerId] || performance.deepEqual(beforeLayer, afterLayer)) {
            continue;
        }
        if (!performance.deepEqual(beforeLayer.source, afterLayer.source) || !performance.deepEqual(beforeLayer['source-layer'], afterLayer['source-layer']) || !performance.deepEqual(beforeLayer.type, afterLayer.type)) {
            commands.push({
                command: operations.removeLayer,
                args: [layerId]
            });
            insertBeforeLayerId = tracker[tracker.lastIndexOf(layerId) + 1];
            commands.push({
                command: operations.addLayer,
                args: [
                    afterLayer,
                    insertBeforeLayerId
                ]
            });
            continue;
        }
        diffLayerPropertyChanges(beforeLayer.layout, afterLayer.layout, commands, layerId, null, operations.setLayoutProperty);
        diffLayerPropertyChanges(beforeLayer.paint, afterLayer.paint, commands, layerId, null, operations.setPaintProperty);
        if (!performance.deepEqual(beforeLayer.filter, afterLayer.filter)) {
            commands.push({
                command: operations.setFilter,
                args: [
                    layerId,
                    afterLayer.filter
                ]
            });
        }
        if (!performance.deepEqual(beforeLayer.minzoom, afterLayer.minzoom) || !performance.deepEqual(beforeLayer.maxzoom, afterLayer.maxzoom)) {
            commands.push({
                command: operations.setLayerZoomRange,
                args: [
                    layerId,
                    afterLayer.minzoom,
                    afterLayer.maxzoom
                ]
            });
        }
        for (prop in beforeLayer) {
            if (!beforeLayer.hasOwnProperty(prop)) {
                continue;
            }
            if (prop === 'layout' || prop === 'paint' || prop === 'filter' || prop === 'metadata' || prop === 'minzoom' || prop === 'maxzoom') {
                continue;
            }
            if (prop.indexOf('paint.') === 0) {
                diffLayerPropertyChanges(beforeLayer[prop], afterLayer[prop], commands, layerId, prop.slice(6), operations.setPaintProperty);
            } else if (!performance.deepEqual(beforeLayer[prop], afterLayer[prop])) {
                commands.push({
                    command: operations.setLayerProperty,
                    args: [
                        layerId,
                        prop,
                        afterLayer[prop]
                    ]
                });
            }
        }
        for (prop in afterLayer) {
            if (!afterLayer.hasOwnProperty(prop) || beforeLayer.hasOwnProperty(prop)) {
                continue;
            }
            if (prop === 'layout' || prop === 'paint' || prop === 'filter' || prop === 'metadata' || prop === 'minzoom' || prop === 'maxzoom') {
                continue;
            }
            if (prop.indexOf('paint.') === 0) {
                diffLayerPropertyChanges(beforeLayer[prop], afterLayer[prop], commands, layerId, prop.slice(6), operations.setPaintProperty);
            } else if (!performance.deepEqual(beforeLayer[prop], afterLayer[prop])) {
                commands.push({
                    command: operations.setLayerProperty,
                    args: [
                        layerId,
                        prop,
                        afterLayer[prop]
                    ]
                });
            }
        }
    }
}
function diffStyles(before, after) {
    if (!before) {
        return [{
                command: operations.setStyle,
                args: [after]
            }];
    }
    var commands = [];
    try {
        if (!performance.deepEqual(before.version, after.version)) {
            return [{
                    command: operations.setStyle,
                    args: [after]
                }];
        }
        if (!performance.deepEqual(before.center, after.center)) {
            commands.push({
                command: operations.setCenter,
                args: [after.center]
            });
        }
        if (!performance.deepEqual(before.zoom, after.zoom)) {
            commands.push({
                command: operations.setZoom,
                args: [after.zoom]
            });
        }
        if (!performance.deepEqual(before.bearing, after.bearing)) {
            commands.push({
                command: operations.setBearing,
                args: [after.bearing]
            });
        }
        if (!performance.deepEqual(before.pitch, after.pitch)) {
            commands.push({
                command: operations.setPitch,
                args: [after.pitch]
            });
        }
        if (!performance.deepEqual(before.sprite, after.sprite)) {
            commands.push({
                command: operations.setSprite,
                args: [after.sprite]
            });
        }
        if (!performance.deepEqual(before.glyphs, after.glyphs)) {
            commands.push({
                command: operations.setGlyphs,
                args: [after.glyphs]
            });
        }
        if (!performance.deepEqual(before.transition, after.transition)) {
            commands.push({
                command: operations.setTransition,
                args: [after.transition]
            });
        }
        if (!performance.deepEqual(before.light, after.light)) {
            commands.push({
                command: operations.setLight,
                args: [after.light]
            });
        }
        var sourcesRemoved = {};
        var removeOrAddSourceCommands = [];
        diffSources(before.sources, after.sources, removeOrAddSourceCommands, sourcesRemoved);
        var beforeLayers = [];
        if (before.layers) {
            before.layers.forEach(function (layer) {
                if (sourcesRemoved[layer.source]) {
                    commands.push({
                        command: operations.removeLayer,
                        args: [layer.id]
                    });
                } else {
                    beforeLayers.push(layer);
                }
            });
        }
        commands = commands.concat(removeOrAddSourceCommands);
        diffLayers(beforeLayers, after.layers, commands);
    } catch (e) {
        console.warn('Unable to compute style diff:', e);
        commands = [{
                command: operations.setStyle,
                args: [after]
            }];
    }
    return commands;
}

var PathInterpolator = function PathInterpolator(points_, padding_) {
    this.reset(points_, padding_);
};
PathInterpolator.prototype.reset = function reset(points_, padding_) {
    this.points = points_ || [];
    this._distances = [0];
    for (var i = 1; i < this.points.length; i++) {
        this._distances[i] = this._distances[i - 1] + this.points[i].dist(this.points[i - 1]);
    }
    this.length = this._distances[this._distances.length - 1];
    this.padding = Math.min(padding_ || 0, this.length * 0.5);
    this.paddedLength = this.length - this.padding * 2;
};
PathInterpolator.prototype.lerp = function lerp(t) {
    if (this.points.length === 1) {
        return this.points[0];
    }
    t = performance.clamp(t, 0, 1);
    var currentIndex = 1;
    var distOfCurrentIdx = this._distances[currentIndex];
    var distToTarget = t * this.paddedLength + this.padding;
    while (distOfCurrentIdx < distToTarget && currentIndex < this._distances.length) {
        distOfCurrentIdx = this._distances[++currentIndex];
    }
    var idxOfPrevPoint = currentIndex - 1;
    var distOfPrevIdx = this._distances[idxOfPrevPoint];
    var segmentLength = distOfCurrentIdx - distOfPrevIdx;
    var segmentT = segmentLength > 0 ? (distToTarget - distOfPrevIdx) / segmentLength : 0;
    return this.points[idxOfPrevPoint].mult(1 - segmentT).add(this.points[currentIndex].mult(segmentT));
};

var GridIndex = function GridIndex(width, height, cellSize) {
    var boxCells = this.boxCells = [];
    var circleCells = this.circleCells = [];
    this.xCellCount = Math.ceil(width / cellSize);
    this.yCellCount = Math.ceil(height / cellSize);
    for (var i = 0; i < this.xCellCount * this.yCellCount; i++) {
        boxCells.push([]);
        circleCells.push([]);
    }
    this.circleKeys = [];
    this.boxKeys = [];
    this.bboxes = [];
    this.circles = [];
    this.width = width;
    this.height = height;
    this.xScale = this.xCellCount / width;
    this.yScale = this.yCellCount / height;
    this.boxUid = 0;
    this.circleUid = 0;
};
GridIndex.prototype.keysLength = function keysLength() {
    return this.boxKeys.length + this.circleKeys.length;
};
GridIndex.prototype.insert = function insert(key, x1, y1, x2, y2) {
    this._forEachCell(x1, y1, x2, y2, this._insertBoxCell, this.boxUid++);
    this.boxKeys.push(key);
    this.bboxes.push(x1);
    this.bboxes.push(y1);
    this.bboxes.push(x2);
    this.bboxes.push(y2);
};
GridIndex.prototype.insertCircle = function insertCircle(key, x, y, radius) {
    this._forEachCell(x - radius, y - radius, x + radius, y + radius, this._insertCircleCell, this.circleUid++);
    this.circleKeys.push(key);
    this.circles.push(x);
    this.circles.push(y);
    this.circles.push(radius);
};
GridIndex.prototype._insertBoxCell = function _insertBoxCell(x1, y1, x2, y2, cellIndex, uid) {
    this.boxCells[cellIndex].push(uid);
};
GridIndex.prototype._insertCircleCell = function _insertCircleCell(x1, y1, x2, y2, cellIndex, uid) {
    this.circleCells[cellIndex].push(uid);
};
GridIndex.prototype._query = function _query(x1, y1, x2, y2, hitTest, predicate) {
    if (x2 < 0 || x1 > this.width || y2 < 0 || y1 > this.height) {
        return hitTest ? false : [];
    }
    var result = [];
    if (x1 <= 0 && y1 <= 0 && this.width <= x2 && this.height <= y2) {
        if (hitTest) {
            return true;
        }
        for (var boxUid = 0; boxUid < this.boxKeys.length; boxUid++) {
            result.push({
                key: this.boxKeys[boxUid],
                x1: this.bboxes[boxUid * 4],
                y1: this.bboxes[boxUid * 4 + 1],
                x2: this.bboxes[boxUid * 4 + 2],
                y2: this.bboxes[boxUid * 4 + 3]
            });
        }
        for (var circleUid = 0; circleUid < this.circleKeys.length; circleUid++) {
            var x = this.circles[circleUid * 3];
            var y = this.circles[circleUid * 3 + 1];
            var radius = this.circles[circleUid * 3 + 2];
            result.push({
                key: this.circleKeys[circleUid],
                x1: x - radius,
                y1: y - radius,
                x2: x + radius,
                y2: y + radius
            });
        }
        return predicate ? result.filter(predicate) : result;
    } else {
        var queryArgs = {
            hitTest: hitTest,
            seenUids: {
                box: {},
                circle: {}
            }
        };
        this._forEachCell(x1, y1, x2, y2, this._queryCell, result, queryArgs, predicate);
        return hitTest ? result.length > 0 : result;
    }
};
GridIndex.prototype._queryCircle = function _queryCircle(x, y, radius, hitTest, predicate) {
    var x1 = x - radius;
    var x2 = x + radius;
    var y1 = y - radius;
    var y2 = y + radius;
    if (x2 < 0 || x1 > this.width || y2 < 0 || y1 > this.height) {
        return hitTest ? false : [];
    }
    var result = [];
    var queryArgs = {
        hitTest: hitTest,
        circle: {
            x: x,
            y: y,
            radius: radius
        },
        seenUids: {
            box: {},
            circle: {}
        }
    };
    this._forEachCell(x1, y1, x2, y2, this._queryCellCircle, result, queryArgs, predicate);
    return hitTest ? result.length > 0 : result;
};
GridIndex.prototype.query = function query(x1, y1, x2, y2, predicate) {
    return this._query(x1, y1, x2, y2, false, predicate);
};
GridIndex.prototype.hitTest = function hitTest(x1, y1, x2, y2, predicate) {
    return this._query(x1, y1, x2, y2, true, predicate);
};
GridIndex.prototype.hitTestCircle = function hitTestCircle(x, y, radius, predicate) {
    return this._queryCircle(x, y, radius, true, predicate);
};
GridIndex.prototype._queryCell = function _queryCell(x1, y1, x2, y2, cellIndex, result, queryArgs, predicate) {
    var seenUids = queryArgs.seenUids;
    var boxCell = this.boxCells[cellIndex];
    if (boxCell !== null) {
        var bboxes = this.bboxes;
        for (var i = 0, list = boxCell; i < list.length; i += 1) {
            var boxUid = list[i];
            if (!seenUids.box[boxUid]) {
                seenUids.box[boxUid] = true;
                var offset = boxUid * 4;
                if (x1 <= bboxes[offset + 2] && y1 <= bboxes[offset + 3] && x2 >= bboxes[offset + 0] && y2 >= bboxes[offset + 1] && (!predicate || predicate(this.boxKeys[boxUid]))) {
                    if (queryArgs.hitTest) {
                        result.push(true);
                        return true;
                    } else {
                        result.push({
                            key: this.boxKeys[boxUid],
                            x1: bboxes[offset],
                            y1: bboxes[offset + 1],
                            x2: bboxes[offset + 2],
                            y2: bboxes[offset + 3]
                        });
                    }
                }
            }
        }
    }
    var circleCell = this.circleCells[cellIndex];
    if (circleCell !== null) {
        var circles = this.circles;
        for (var i$1 = 0, list$1 = circleCell; i$1 < list$1.length; i$1 += 1) {
            var circleUid = list$1[i$1];
            if (!seenUids.circle[circleUid]) {
                seenUids.circle[circleUid] = true;
                var offset$1 = circleUid * 3;
                if (this._circleAndRectCollide(circles[offset$1], circles[offset$1 + 1], circles[offset$1 + 2], x1, y1, x2, y2) && (!predicate || predicate(this.circleKeys[circleUid]))) {
                    if (queryArgs.hitTest) {
                        result.push(true);
                        return true;
                    } else {
                        var x = circles[offset$1];
                        var y = circles[offset$1 + 1];
                        var radius = circles[offset$1 + 2];
                        result.push({
                            key: this.circleKeys[circleUid],
                            x1: x - radius,
                            y1: y - radius,
                            x2: x + radius,
                            y2: y + radius
                        });
                    }
                }
            }
        }
    }
};
GridIndex.prototype._queryCellCircle = function _queryCellCircle(x1, y1, x2, y2, cellIndex, result, queryArgs, predicate) {
    var circle = queryArgs.circle;
    var seenUids = queryArgs.seenUids;
    var boxCell = this.boxCells[cellIndex];
    if (boxCell !== null) {
        var bboxes = this.bboxes;
        for (var i = 0, list = boxCell; i < list.length; i += 1) {
            var boxUid = list[i];
            if (!seenUids.box[boxUid]) {
                seenUids.box[boxUid] = true;
                var offset = boxUid * 4;
                if (this._circleAndRectCollide(circle.x, circle.y, circle.radius, bboxes[offset + 0], bboxes[offset + 1], bboxes[offset + 2], bboxes[offset + 3]) && (!predicate || predicate(this.boxKeys[boxUid]))) {
                    result.push(true);
                    return true;
                }
            }
        }
    }
    var circleCell = this.circleCells[cellIndex];
    if (circleCell !== null) {
        var circles = this.circles;
        for (var i$1 = 0, list$1 = circleCell; i$1 < list$1.length; i$1 += 1) {
            var circleUid = list$1[i$1];
            if (!seenUids.circle[circleUid]) {
                seenUids.circle[circleUid] = true;
                var offset$1 = circleUid * 3;
                if (this._circlesCollide(circles[offset$1], circles[offset$1 + 1], circles[offset$1 + 2], circle.x, circle.y, circle.radius) && (!predicate || predicate(this.circleKeys[circleUid]))) {
                    result.push(true);
                    return true;
                }
            }
        }
    }
};
GridIndex.prototype._forEachCell = function _forEachCell(x1, y1, x2, y2, fn, arg1, arg2, predicate) {
    var cx1 = this._convertToXCellCoord(x1);
    var cy1 = this._convertToYCellCoord(y1);
    var cx2 = this._convertToXCellCoord(x2);
    var cy2 = this._convertToYCellCoord(y2);
    for (var x = cx1; x <= cx2; x++) {
        for (var y = cy1; y <= cy2; y++) {
            var cellIndex = this.xCellCount * y + x;
            if (fn.call(this, x1, y1, x2, y2, cellIndex, arg1, arg2, predicate)) {
                return;
            }
        }
    }
};
GridIndex.prototype._convertToXCellCoord = function _convertToXCellCoord(x) {
    return Math.max(0, Math.min(this.xCellCount - 1, Math.floor(x * this.xScale)));
};
GridIndex.prototype._convertToYCellCoord = function _convertToYCellCoord(y) {
    return Math.max(0, Math.min(this.yCellCount - 1, Math.floor(y * this.yScale)));
};
GridIndex.prototype._circlesCollide = function _circlesCollide(x1, y1, r1, x2, y2, r2) {
    var dx = x2 - x1;
    var dy = y2 - y1;
    var bothRadii = r1 + r2;
    return bothRadii * bothRadii > dx * dx + dy * dy;
};
GridIndex.prototype._circleAndRectCollide = function _circleAndRectCollide(circleX, circleY, radius, x1, y1, x2, y2) {
    var halfRectWidth = (x2 - x1) / 2;
    var distX = Math.abs(circleX - (x1 + halfRectWidth));
    if (distX > halfRectWidth + radius) {
        return false;
    }
    var halfRectHeight = (y2 - y1) / 2;
    var distY = Math.abs(circleY - (y1 + halfRectHeight));
    if (distY > halfRectHeight + radius) {
        return false;
    }
    if (distX <= halfRectWidth || distY <= halfRectHeight) {
        return true;
    }
    var dx = distX - halfRectWidth;
    var dy = distY - halfRectHeight;
    return dx * dx + dy * dy <= radius * radius;
};

function getLabelPlaneMatrix(posMatrix, pitchWithMap, rotateWithMap, transform, pixelsToTileUnits) {
    var m = performance.create();
    if (pitchWithMap) {
        performance.scale(m, m, [
            1 / pixelsToTileUnits,
            1 / pixelsToTileUnits,
            1
        ]);
        if (!rotateWithMap) {
            performance.rotateZ(m, m, transform.angle);
        }
    } else {
        performance.multiply(m, transform.labelPlaneMatrix, posMatrix);
    }
    return m;
}
function getGlCoordMatrix(posMatrix, pitchWithMap, rotateWithMap, transform, pixelsToTileUnits) {
    if (pitchWithMap) {
        var m = performance.clone(posMatrix);
        performance.scale(m, m, [
            pixelsToTileUnits,
            pixelsToTileUnits,
            1
        ]);
        if (!rotateWithMap) {
            performance.rotateZ(m, m, -transform.angle);
        }
        return m;
    } else {
        return transform.glCoordMatrix;
    }
}
function project(point, matrix) {
    var pos = [
        point.x,
        point.y,
        0,
        1
    ];
    xyTransformMat4(pos, pos, matrix);
    var w = pos[3];
    return {
        point: new performance.Point(pos[0] / w, pos[1] / w),
        signedDistanceFromCamera: w
    };
}
function getPerspectiveRatio(cameraToCenterDistance, signedDistanceFromCamera) {
    return 0.5 + 0.5 * (cameraToCenterDistance / signedDistanceFromCamera);
}
function isVisible(anchorPos, clippingBuffer) {
    var x = anchorPos[0] / anchorPos[3];
    var y = anchorPos[1] / anchorPos[3];
    var inPaddedViewport = x >= -clippingBuffer[0] && x <= clippingBuffer[0] && y >= -clippingBuffer[1] && y <= clippingBuffer[1];
    return inPaddedViewport;
}
function updateLineLabels(bucket, posMatrix, painter, isText, labelPlaneMatrix, glCoordMatrix, pitchWithMap, keepUpright) {
    var sizeData = isText ? bucket.textSizeData : bucket.iconSizeData;
    var partiallyEvaluatedSize = performance.evaluateSizeForZoom(sizeData, painter.transform.zoom);
    var clippingBuffer = [
        256 / painter.width * 2 + 1,
        256 / painter.height * 2 + 1
    ];
    var dynamicLayoutVertexArray = isText ? bucket.text.dynamicLayoutVertexArray : bucket.icon.dynamicLayoutVertexArray;
    dynamicLayoutVertexArray.clear();
    var lineVertexArray = bucket.lineVertexArray;
    var placedSymbols = isText ? bucket.text.placedSymbolArray : bucket.icon.placedSymbolArray;
    var aspectRatio = painter.transform.width / painter.transform.height;
    var useVertical = false;
    for (var s = 0; s < placedSymbols.length; s++) {
        var symbol = placedSymbols.get(s);
        if (symbol.hidden || symbol.writingMode === performance.WritingMode.vertical && !useVertical) {
            hideGlyphs(symbol.numGlyphs, dynamicLayoutVertexArray);
            continue;
        }
        useVertical = false;
        var anchorPos = [
            symbol.anchorX,
            symbol.anchorY,
            0,
            1
        ];
        performance.transformMat4(anchorPos, anchorPos, posMatrix);
        if (!isVisible(anchorPos, clippingBuffer)) {
            hideGlyphs(symbol.numGlyphs, dynamicLayoutVertexArray);
            continue;
        }
        var cameraToAnchorDistance = anchorPos[3];
        var perspectiveRatio = getPerspectiveRatio(painter.transform.cameraToCenterDistance, cameraToAnchorDistance);
        var fontSize = performance.evaluateSizeForFeature(sizeData, partiallyEvaluatedSize, symbol);
        var pitchScaledFontSize = pitchWithMap ? fontSize / perspectiveRatio : fontSize * perspectiveRatio;
        var tileAnchorPoint = new performance.Point(symbol.anchorX, symbol.anchorY);
        var anchorPoint = project(tileAnchorPoint, labelPlaneMatrix).point;
        var projectionCache = {};
        var placeUnflipped = placeGlyphsAlongLine(symbol, pitchScaledFontSize, false, keepUpright, posMatrix, labelPlaneMatrix, glCoordMatrix, bucket.glyphOffsetArray, lineVertexArray, dynamicLayoutVertexArray, anchorPoint, tileAnchorPoint, projectionCache, aspectRatio);
        useVertical = placeUnflipped.useVertical;
        if (placeUnflipped.notEnoughRoom || useVertical || placeUnflipped.needsFlipping && placeGlyphsAlongLine(symbol, pitchScaledFontSize, true, keepUpright, posMatrix, labelPlaneMatrix, glCoordMatrix, bucket.glyphOffsetArray, lineVertexArray, dynamicLayoutVertexArray, anchorPoint, tileAnchorPoint, projectionCache, aspectRatio).notEnoughRoom) {
            hideGlyphs(symbol.numGlyphs, dynamicLayoutVertexArray);
        }
    }
    if (isText) {
        bucket.text.dynamicLayoutVertexBuffer.updateData(dynamicLayoutVertexArray);
    } else {
        bucket.icon.dynamicLayoutVertexBuffer.updateData(dynamicLayoutVertexArray);
    }
}
function placeFirstAndLastGlyph(fontScale, glyphOffsetArray, lineOffsetX, lineOffsetY, flip, anchorPoint, tileAnchorPoint, symbol, lineVertexArray, labelPlaneMatrix, projectionCache) {
    var glyphEndIndex = symbol.glyphStartIndex + symbol.numGlyphs;
    var lineStartIndex = symbol.lineStartIndex;
    var lineEndIndex = symbol.lineStartIndex + symbol.lineLength;
    var firstGlyphOffset = glyphOffsetArray.getoffsetX(symbol.glyphStartIndex);
    var lastGlyphOffset = glyphOffsetArray.getoffsetX(glyphEndIndex - 1);
    var firstPlacedGlyph = placeGlyphAlongLine(fontScale * firstGlyphOffset, lineOffsetX, lineOffsetY, flip, anchorPoint, tileAnchorPoint, symbol.segment, lineStartIndex, lineEndIndex, lineVertexArray, labelPlaneMatrix, projectionCache);
    if (!firstPlacedGlyph) {
        return null;
    }
    var lastPlacedGlyph = placeGlyphAlongLine(fontScale * lastGlyphOffset, lineOffsetX, lineOffsetY, flip, anchorPoint, tileAnchorPoint, symbol.segment, lineStartIndex, lineEndIndex, lineVertexArray, labelPlaneMatrix, projectionCache);
    if (!lastPlacedGlyph) {
        return null;
    }
    return {
        first: firstPlacedGlyph,
        last: lastPlacedGlyph
    };
}
function requiresOrientationChange(writingMode, firstPoint, lastPoint, aspectRatio) {
    if (writingMode === performance.WritingMode.horizontal) {
        var rise = Math.abs(lastPoint.y - firstPoint.y);
        var run = Math.abs(lastPoint.x - firstPoint.x) * aspectRatio;
        if (rise > run) {
            return { useVertical: true };
        }
    }
    if (writingMode === performance.WritingMode.vertical ? firstPoint.y < lastPoint.y : firstPoint.x > lastPoint.x) {
        return { needsFlipping: true };
    }
    return null;
}
function placeGlyphsAlongLine(symbol, fontSize, flip, keepUpright, posMatrix, labelPlaneMatrix, glCoordMatrix, glyphOffsetArray, lineVertexArray, dynamicLayoutVertexArray, anchorPoint, tileAnchorPoint, projectionCache, aspectRatio) {
    var fontScale = fontSize / 24;
    var lineOffsetX = symbol.lineOffsetX * fontScale;
    var lineOffsetY = symbol.lineOffsetY * fontScale;
    var placedGlyphs;
    if (symbol.numGlyphs > 1) {
        var glyphEndIndex = symbol.glyphStartIndex + symbol.numGlyphs;
        var lineStartIndex = symbol.lineStartIndex;
        var lineEndIndex = symbol.lineStartIndex + symbol.lineLength;
        var firstAndLastGlyph = placeFirstAndLastGlyph(fontScale, glyphOffsetArray, lineOffsetX, lineOffsetY, flip, anchorPoint, tileAnchorPoint, symbol, lineVertexArray, labelPlaneMatrix, projectionCache);
        if (!firstAndLastGlyph) {
            return { notEnoughRoom: true };
        }
        var firstPoint = project(firstAndLastGlyph.first.point, glCoordMatrix).point;
        var lastPoint = project(firstAndLastGlyph.last.point, glCoordMatrix).point;
        if (keepUpright && !flip) {
            var orientationChange = requiresOrientationChange(symbol.writingMode, firstPoint, lastPoint, aspectRatio);
            if (orientationChange) {
                return orientationChange;
            }
        }
        placedGlyphs = [firstAndLastGlyph.first];
        for (var glyphIndex = symbol.glyphStartIndex + 1; glyphIndex < glyphEndIndex - 1; glyphIndex++) {
            placedGlyphs.push(placeGlyphAlongLine(fontScale * glyphOffsetArray.getoffsetX(glyphIndex), lineOffsetX, lineOffsetY, flip, anchorPoint, tileAnchorPoint, symbol.segment, lineStartIndex, lineEndIndex, lineVertexArray, labelPlaneMatrix, projectionCache));
        }
        placedGlyphs.push(firstAndLastGlyph.last);
    } else {
        if (keepUpright && !flip) {
            var a = project(tileAnchorPoint, posMatrix).point;
            var tileVertexIndex = symbol.lineStartIndex + symbol.segment + 1;
            var tileSegmentEnd = new performance.Point(lineVertexArray.getx(tileVertexIndex), lineVertexArray.gety(tileVertexIndex));
            var projectedVertex = project(tileSegmentEnd, posMatrix);
            var b = projectedVertex.signedDistanceFromCamera > 0 ? projectedVertex.point : projectTruncatedLineSegment(tileAnchorPoint, tileSegmentEnd, a, 1, posMatrix);
            var orientationChange$1 = requiresOrientationChange(symbol.writingMode, a, b, aspectRatio);
            if (orientationChange$1) {
                return orientationChange$1;
            }
        }
        var singleGlyph = placeGlyphAlongLine(fontScale * glyphOffsetArray.getoffsetX(symbol.glyphStartIndex), lineOffsetX, lineOffsetY, flip, anchorPoint, tileAnchorPoint, symbol.segment, symbol.lineStartIndex, symbol.lineStartIndex + symbol.lineLength, lineVertexArray, labelPlaneMatrix, projectionCache);
        if (!singleGlyph) {
            return { notEnoughRoom: true };
        }
        placedGlyphs = [singleGlyph];
    }
    for (var i = 0, list = placedGlyphs; i < list.length; i += 1) {
        var glyph = list[i];
        performance.addDynamicAttributes(dynamicLayoutVertexArray, glyph.point, glyph.angle);
    }
    return {};
}
function projectTruncatedLineSegment(previousTilePoint, currentTilePoint, previousProjectedPoint, minimumLength, projectionMatrix) {
    var projectedUnitVertex = project(previousTilePoint.add(previousTilePoint.sub(currentTilePoint)._unit()), projectionMatrix).point;
    var projectedUnitSegment = previousProjectedPoint.sub(projectedUnitVertex);
    return previousProjectedPoint.add(projectedUnitSegment._mult(minimumLength / projectedUnitSegment.mag()));
}
function placeGlyphAlongLine(offsetX, lineOffsetX, lineOffsetY, flip, anchorPoint, tileAnchorPoint, anchorSegment, lineStartIndex, lineEndIndex, lineVertexArray, labelPlaneMatrix, projectionCache) {
    var combinedOffsetX = flip ? offsetX - lineOffsetX : offsetX + lineOffsetX;
    var dir = combinedOffsetX > 0 ? 1 : -1;
    var angle = 0;
    if (flip) {
        dir *= -1;
        angle = Math.PI;
    }
    if (dir < 0) {
        angle += Math.PI;
    }
    var currentIndex = dir > 0 ? lineStartIndex + anchorSegment : lineStartIndex + anchorSegment + 1;
    var current = anchorPoint;
    var prev = anchorPoint;
    var distanceToPrev = 0;
    var currentSegmentDistance = 0;
    var absOffsetX = Math.abs(combinedOffsetX);
    var pathVertices = [];
    while (distanceToPrev + currentSegmentDistance <= absOffsetX) {
        currentIndex += dir;
        if (currentIndex < lineStartIndex || currentIndex >= lineEndIndex) {
            return null;
        }
        prev = current;
        pathVertices.push(current);
        current = projectionCache[currentIndex];
        if (current === undefined) {
            var currentVertex = new performance.Point(lineVertexArray.getx(currentIndex), lineVertexArray.gety(currentIndex));
            var projection = project(currentVertex, labelPlaneMatrix);
            if (projection.signedDistanceFromCamera > 0) {
                current = projectionCache[currentIndex] = projection.point;
            } else {
                var previousLineVertexIndex = currentIndex - dir;
                var previousTilePoint = distanceToPrev === 0 ? tileAnchorPoint : new performance.Point(lineVertexArray.getx(previousLineVertexIndex), lineVertexArray.gety(previousLineVertexIndex));
                current = projectTruncatedLineSegment(previousTilePoint, currentVertex, prev, absOffsetX - distanceToPrev + 1, labelPlaneMatrix);
            }
        }
        distanceToPrev += currentSegmentDistance;
        currentSegmentDistance = prev.dist(current);
    }
    var segmentInterpolationT = (absOffsetX - distanceToPrev) / currentSegmentDistance;
    var prevToCurrent = current.sub(prev);
    var p = prevToCurrent.mult(segmentInterpolationT)._add(prev);
    p._add(prevToCurrent._unit()._perp()._mult(lineOffsetY * dir));
    var segmentAngle = angle + Math.atan2(current.y - prev.y, current.x - prev.x);
    pathVertices.push(p);
    return {
        point: p,
        angle: segmentAngle,
        path: pathVertices
    };
}
var hiddenGlyphAttributes = new Float32Array([
    -Infinity,
    -Infinity,
    0,
    -Infinity,
    -Infinity,
    0,
    -Infinity,
    -Infinity,
    0,
    -Infinity,
    -Infinity,
    0
]);
function hideGlyphs(num, dynamicLayoutVertexArray) {
    for (var i = 0; i < num; i++) {
        var offset = dynamicLayoutVertexArray.length;
        dynamicLayoutVertexArray.resize(offset + 4);
        dynamicLayoutVertexArray.float32.set(hiddenGlyphAttributes, offset * 3);
    }
}
function xyTransformMat4(out, a, m) {
    var x = a[0], y = a[1];
    out[0] = m[0] * x + m[4] * y + m[12];
    out[1] = m[1] * x + m[5] * y + m[13];
    out[3] = m[3] * x + m[7] * y + m[15];
    return out;
}

var viewportPadding = 100;
var CollisionIndex = function CollisionIndex(transform, grid, ignoredGrid) {
    if (grid === void 0)
        grid = new GridIndex(transform.width + 2 * viewportPadding, transform.height + 2 * viewportPadding, 25);
    if (ignoredGrid === void 0)
        ignoredGrid = new GridIndex(transform.width + 2 * viewportPadding, transform.height + 2 * viewportPadding, 25);
    this.transform = transform;
    this.grid = grid;
    this.ignoredGrid = ignoredGrid;
    this.pitchfactor = Math.cos(transform._pitch) * transform.cameraToCenterDistance;
    this.screenRightBoundary = transform.width + viewportPadding;
    this.screenBottomBoundary = transform.height + viewportPadding;
    this.gridRightBoundary = transform.width + 2 * viewportPadding;
    this.gridBottomBoundary = transform.height + 2 * viewportPadding;
};
CollisionIndex.prototype.placeCollisionBox = function placeCollisionBox(collisionBox, allowOverlap, textPixelRatio, posMatrix, collisionGroupPredicate) {
    var projectedPoint = this.projectAndGetPerspectiveRatio(posMatrix, collisionBox.anchorPointX, collisionBox.anchorPointY);
    var tileToViewport = textPixelRatio * projectedPoint.perspectiveRatio;
    var tlX = collisionBox.x1 * tileToViewport + projectedPoint.point.x;
    var tlY = collisionBox.y1 * tileToViewport + projectedPoint.point.y;
    var brX = collisionBox.x2 * tileToViewport + projectedPoint.point.x;
    var brY = collisionBox.y2 * tileToViewport + projectedPoint.point.y;
    if (!this.isInsideGrid(tlX, tlY, brX, brY) || !allowOverlap && this.grid.hitTest(tlX, tlY, brX, brY, collisionGroupPredicate)) {
        return {
            box: [],
            offscreen: false
        };
    }
    return {
        box: [
            tlX,
            tlY,
            brX,
            brY
        ],
        offscreen: this.isOffscreen(tlX, tlY, brX, brY)
    };
};
CollisionIndex.prototype.placeCollisionCircles = function placeCollisionCircles(allowOverlap, symbol, lineVertexArray, glyphOffsetArray, fontSize, posMatrix, labelPlaneMatrix, labelToScreenMatrix, showCollisionCircles, pitchWithMap, collisionGroupPredicate, circlePixelDiameter, textPixelPadding) {
    var placedCollisionCircles = [];
    var tileUnitAnchorPoint = new performance.Point(symbol.anchorX, symbol.anchorY);
    var screenAnchorPoint = project(tileUnitAnchorPoint, posMatrix);
    var perspectiveRatio = getPerspectiveRatio(this.transform.cameraToCenterDistance, screenAnchorPoint.signedDistanceFromCamera);
    var labelPlaneFontSize = pitchWithMap ? fontSize / perspectiveRatio : fontSize * perspectiveRatio;
    var labelPlaneFontScale = labelPlaneFontSize / performance.ONE_EM;
    var labelPlaneAnchorPoint = project(tileUnitAnchorPoint, labelPlaneMatrix).point;
    var projectionCache = {};
    var lineOffsetX = symbol.lineOffsetX * labelPlaneFontScale;
    var lineOffsetY = symbol.lineOffsetY * labelPlaneFontScale;
    var firstAndLastGlyph = placeFirstAndLastGlyph(labelPlaneFontScale, glyphOffsetArray, lineOffsetX, lineOffsetY, false, labelPlaneAnchorPoint, tileUnitAnchorPoint, symbol, lineVertexArray, labelPlaneMatrix, projectionCache);
    var collisionDetected = false;
    var inGrid = false;
    var entirelyOffscreen = true;
    if (firstAndLastGlyph) {
        var radius = circlePixelDiameter * 0.5 * perspectiveRatio + textPixelPadding;
        var screenPlaneMin = new performance.Point(-viewportPadding, -viewportPadding);
        var screenPlaneMax = new performance.Point(this.screenRightBoundary, this.screenBottomBoundary);
        var interpolator = new PathInterpolator();
        var first = firstAndLastGlyph.first;
        var last = firstAndLastGlyph.last;
        var projectedPath = [];
        for (var i = first.path.length - 1; i >= 1; i--) {
            projectedPath.push(first.path[i]);
        }
        for (var i$1 = 1; i$1 < last.path.length; i$1++) {
            projectedPath.push(last.path[i$1]);
        }
        var circleDist = radius * 2.5;
        if (labelToScreenMatrix) {
            var screenSpacePath = projectedPath.map(function (p) {
                return project(p, labelToScreenMatrix);
            });
            if (screenSpacePath.some(function (point) {
                    return point.signedDistanceFromCamera <= 0;
                })) {
                projectedPath = [];
            } else {
                projectedPath = screenSpacePath.map(function (p) {
                    return p.point;
                });
            }
        }
        var segments = [];
        if (projectedPath.length > 0) {
            var minPoint = projectedPath[0].clone();
            var maxPoint = projectedPath[0].clone();
            for (var i$2 = 1; i$2 < projectedPath.length; i$2++) {
                minPoint.x = Math.min(minPoint.x, projectedPath[i$2].x);
                minPoint.y = Math.min(minPoint.y, projectedPath[i$2].y);
                maxPoint.x = Math.max(maxPoint.x, projectedPath[i$2].x);
                maxPoint.y = Math.max(maxPoint.y, projectedPath[i$2].y);
            }
            if (minPoint.x >= screenPlaneMin.x && maxPoint.x <= screenPlaneMax.x && minPoint.y >= screenPlaneMin.y && maxPoint.y <= screenPlaneMax.y) {
                segments = [projectedPath];
            } else if (maxPoint.x < screenPlaneMin.x || minPoint.x > screenPlaneMax.x || maxPoint.y < screenPlaneMin.y || minPoint.y > screenPlaneMax.y) {
                segments = [];
            } else {
                segments = performance.clipLine([projectedPath], screenPlaneMin.x, screenPlaneMin.y, screenPlaneMax.x, screenPlaneMax.y);
            }
        }
        for (var i$4 = 0, list = segments; i$4 < list.length; i$4 += 1) {
            var seg = list[i$4];
            interpolator.reset(seg, radius * 0.25);
            var numCircles = 0;
            if (interpolator.length <= 0.5 * radius) {
                numCircles = 1;
            } else {
                numCircles = Math.ceil(interpolator.paddedLength / circleDist) + 1;
            }
            for (var i$3 = 0; i$3 < numCircles; i$3++) {
                var t = i$3 / Math.max(numCircles - 1, 1);
                var circlePosition = interpolator.lerp(t);
                var centerX = circlePosition.x + viewportPadding;
                var centerY = circlePosition.y + viewportPadding;
                placedCollisionCircles.push(centerX, centerY, radius, 0);
                var x1 = centerX - radius;
                var y1 = centerY - radius;
                var x2 = centerX + radius;
                var y2 = centerY + radius;
                entirelyOffscreen = entirelyOffscreen && this.isOffscreen(x1, y1, x2, y2);
                inGrid = inGrid || this.isInsideGrid(x1, y1, x2, y2);
                if (!allowOverlap) {
                    if (this.grid.hitTestCircle(centerX, centerY, radius, collisionGroupPredicate)) {
                        collisionDetected = true;
                        if (!showCollisionCircles) {
                            return {
                                circles: [],
                                offscreen: false,
                                collisionDetected: collisionDetected
                            };
                        }
                    }
                }
            }
        }
    }
    return {
        circles: !showCollisionCircles && collisionDetected || !inGrid ? [] : placedCollisionCircles,
        offscreen: entirelyOffscreen,
        collisionDetected: collisionDetected
    };
};
CollisionIndex.prototype.queryRenderedSymbols = function queryRenderedSymbols(viewportQueryGeometry) {
    if (viewportQueryGeometry.length === 0 || this.grid.keysLength() === 0 && this.ignoredGrid.keysLength() === 0) {
        return {};
    }
    var query = [];
    var minX = Infinity;
    var minY = Infinity;
    var maxX = -Infinity;
    var maxY = -Infinity;
    for (var i = 0, list = viewportQueryGeometry; i < list.length; i += 1) {
        var point = list[i];
        var gridPoint = new performance.Point(point.x + viewportPadding, point.y + viewportPadding);
        minX = Math.min(minX, gridPoint.x);
        minY = Math.min(minY, gridPoint.y);
        maxX = Math.max(maxX, gridPoint.x);
        maxY = Math.max(maxY, gridPoint.y);
        query.push(gridPoint);
    }
    var features = this.grid.query(minX, minY, maxX, maxY).concat(this.ignoredGrid.query(minX, minY, maxX, maxY));
    var seenFeatures = {};
    var result = {};
    for (var i$1 = 0, list$1 = features; i$1 < list$1.length; i$1 += 1) {
        var feature = list$1[i$1];
        var featureKey = feature.key;
        if (seenFeatures[featureKey.bucketInstanceId] === undefined) {
            seenFeatures[featureKey.bucketInstanceId] = {};
        }
        if (seenFeatures[featureKey.bucketInstanceId][featureKey.featureIndex]) {
            continue;
        }
        var bbox = [
            new performance.Point(feature.x1, feature.y1),
            new performance.Point(feature.x2, feature.y1),
            new performance.Point(feature.x2, feature.y2),
            new performance.Point(feature.x1, feature.y2)
        ];
        if (!performance.polygonIntersectsPolygon(query, bbox)) {
            continue;
        }
        seenFeatures[featureKey.bucketInstanceId][featureKey.featureIndex] = true;
        if (result[featureKey.bucketInstanceId] === undefined) {
            result[featureKey.bucketInstanceId] = [];
        }
        result[featureKey.bucketInstanceId].push(featureKey.featureIndex);
    }
    return result;
};
CollisionIndex.prototype.insertCollisionBox = function insertCollisionBox(collisionBox, ignorePlacement, bucketInstanceId, featureIndex, collisionGroupID) {
    var grid = ignorePlacement ? this.ignoredGrid : this.grid;
    var key = {
        bucketInstanceId: bucketInstanceId,
        featureIndex: featureIndex,
        collisionGroupID: collisionGroupID
    };
    grid.insert(key, collisionBox[0], collisionBox[1], collisionBox[2], collisionBox[3]);
};
CollisionIndex.prototype.insertCollisionCircles = function insertCollisionCircles(collisionCircles, ignorePlacement, bucketInstanceId, featureIndex, collisionGroupID) {
    var grid = ignorePlacement ? this.ignoredGrid : this.grid;
    var key = {
        bucketInstanceId: bucketInstanceId,
        featureIndex: featureIndex,
        collisionGroupID: collisionGroupID
    };
    for (var k = 0; k < collisionCircles.length; k += 4) {
        grid.insertCircle(key, collisionCircles[k], collisionCircles[k + 1], collisionCircles[k + 2]);
    }
};
CollisionIndex.prototype.projectAndGetPerspectiveRatio = function projectAndGetPerspectiveRatio(posMatrix, x, y) {
    var p = [
        x,
        y,
        0,
        1
    ];
    xyTransformMat4(p, p, posMatrix);
    var a = new performance.Point((p[0] / p[3] + 1) / 2 * this.transform.width + viewportPadding, (-p[1] / p[3] + 1) / 2 * this.transform.height + viewportPadding);
    return {
        point: a,
        perspectiveRatio: 0.5 + 0.5 * (this.transform.cameraToCenterDistance / p[3])
    };
};
CollisionIndex.prototype.isOffscreen = function isOffscreen(x1, y1, x2, y2) {
    return x2 < viewportPadding || x1 >= this.screenRightBoundary || y2 < viewportPadding || y1 > this.screenBottomBoundary;
};
CollisionIndex.prototype.isInsideGrid = function isInsideGrid(x1, y1, x2, y2) {
    return x2 >= 0 && x1 < this.gridRightBoundary && y2 >= 0 && y1 < this.gridBottomBoundary;
};
CollisionIndex.prototype.getViewportMatrix = function getViewportMatrix() {
    var m = performance.identity([]);
    performance.translate(m, m, [
        -viewportPadding,
        -viewportPadding,
        0
    ]);
    return m;
};

function pixelsToTileUnits (tile, pixelValue, z) {
    return pixelValue * (performance.EXTENT / (tile.tileSize * Math.pow(2, z - tile.tileID.overscaledZ)));
}

var OpacityState = function OpacityState(prevState, increment, placed, skipFade) {
    if (prevState) {
        this.opacity = Math.max(0, Math.min(1, prevState.opacity + (prevState.placed ? increment : -increment)));
    } else {
        this.opacity = skipFade && placed ? 1 : 0;
    }
    this.placed = placed;
};
OpacityState.prototype.isHidden = function isHidden() {
    return this.opacity === 0 && !this.placed;
};
var JointOpacityState = function JointOpacityState(prevState, increment, placedText, placedIcon, skipFade) {
    this.text = new OpacityState(prevState ? prevState.text : null, increment, placedText, skipFade);
    this.icon = new OpacityState(prevState ? prevState.icon : null, increment, placedIcon, skipFade);
};
JointOpacityState.prototype.isHidden = function isHidden() {
    return this.text.isHidden() && this.icon.isHidden();
};
var JointPlacement = function JointPlacement(text, icon, skipFade) {
    this.text = text;
    this.icon = icon;
    this.skipFade = skipFade;
};
var CollisionCircleArray = function CollisionCircleArray() {
    this.invProjMatrix = performance.create();
    this.viewportMatrix = performance.create();
    this.circles = [];
};
var RetainedQueryData = function RetainedQueryData(bucketInstanceId, featureIndex, sourceLayerIndex, bucketIndex, tileID) {
    this.bucketInstanceId = bucketInstanceId;
    this.featureIndex = featureIndex;
    this.sourceLayerIndex = sourceLayerIndex;
    this.bucketIndex = bucketIndex;
    this.tileID = tileID;
};
var CollisionGroups = function CollisionGroups(crossSourceCollisions) {
    this.crossSourceCollisions = crossSourceCollisions;
    this.maxGroupID = 0;
    this.collisionGroups = {};
};
CollisionGroups.prototype.get = function get(sourceID) {
    if (!this.crossSourceCollisions) {
        if (!this.collisionGroups[sourceID]) {
            var nextGroupID = ++this.maxGroupID;
            this.collisionGroups[sourceID] = {
                ID: nextGroupID,
                predicate: function (key) {
                    return key.collisionGroupID === nextGroupID;
                }
            };
        }
        return this.collisionGroups[sourceID];
    } else {
        return {
            ID: 0,
            predicate: null
        };
    }
};
function calculateVariableLayoutShift(anchor, width, height, textOffset, textBoxScale) {
    var ref = performance.getAnchorAlignment(anchor);
    var horizontalAlign = ref.horizontalAlign;
    var verticalAlign = ref.verticalAlign;
    var shiftX = -(horizontalAlign - 0.5) * width;
    var shiftY = -(verticalAlign - 0.5) * height;
    var offset = performance.evaluateVariableOffset(anchor, textOffset);
    return new performance.Point(shiftX + offset[0] * textBoxScale, shiftY + offset[1] * textBoxScale);
}
function shiftVariableCollisionBox(collisionBox, shiftX, shiftY, rotateWithMap, pitchWithMap, angle) {
    var x1 = collisionBox.x1;
    var x2 = collisionBox.x2;
    var y1 = collisionBox.y1;
    var y2 = collisionBox.y2;
    var anchorPointX = collisionBox.anchorPointX;
    var anchorPointY = collisionBox.anchorPointY;
    var rotatedOffset = new performance.Point(shiftX, shiftY);
    if (rotateWithMap) {
        rotatedOffset._rotate(pitchWithMap ? angle : -angle);
    }
    return {
        x1: x1 + rotatedOffset.x,
        y1: y1 + rotatedOffset.y,
        x2: x2 + rotatedOffset.x,
        y2: y2 + rotatedOffset.y,
        anchorPointX: anchorPointX,
        anchorPointY: anchorPointY
    };
}
var Placement = function Placement(transform, fadeDuration, crossSourceCollisions, prevPlacement) {
    this.transform = transform.clone();
    this.collisionIndex = new CollisionIndex(this.transform);
    this.placements = {};
    this.opacities = {};
    this.variableOffsets = {};
    this.stale = false;
    this.commitTime = 0;
    this.fadeDuration = fadeDuration;
    this.retainedQueryData = {};
    this.collisionGroups = new CollisionGroups(crossSourceCollisions);
    this.collisionCircleArrays = {};
    this.prevPlacement = prevPlacement;
    if (prevPlacement) {
        prevPlacement.prevPlacement = undefined;
    }
    this.placedOrientations = {};
};
Placement.prototype.getBucketParts = function getBucketParts(results, styleLayer, tile, sortAcrossTiles) {
    var symbolBucket = tile.getBucket(styleLayer);
    var bucketFeatureIndex = tile.latestFeatureIndex;
    if (!symbolBucket || !bucketFeatureIndex || styleLayer.id !== symbolBucket.layerIds[0]) {
        return;
    }
    var collisionBoxArray = tile.collisionBoxArray;
    var layout = symbolBucket.layers[0].layout;
    var scale = Math.pow(2, this.transform.zoom - tile.tileID.overscaledZ);
    var textPixelRatio = tile.tileSize / performance.EXTENT;
    var posMatrix = this.transform.calculatePosMatrix(tile.tileID.toUnwrapped());
    var pitchWithMap = layout.get('text-pitch-alignment') === 'map';
    var rotateWithMap = layout.get('text-rotation-alignment') === 'map';
    var pixelsToTiles = pixelsToTileUnits(tile, 1, this.transform.zoom);
    var textLabelPlaneMatrix = getLabelPlaneMatrix(posMatrix, pitchWithMap, rotateWithMap, this.transform, pixelsToTiles);
    var labelToScreenMatrix = null;
    if (pitchWithMap) {
        var glMatrix = getGlCoordMatrix(posMatrix, pitchWithMap, rotateWithMap, this.transform, pixelsToTiles);
        labelToScreenMatrix = performance.multiply([], this.transform.labelPlaneMatrix, glMatrix);
    }
    this.retainedQueryData[symbolBucket.bucketInstanceId] = new RetainedQueryData(symbolBucket.bucketInstanceId, bucketFeatureIndex, symbolBucket.sourceLayerIndex, symbolBucket.index, tile.tileID);
    var parameters = {
        bucket: symbolBucket,
        layout: layout,
        posMatrix: posMatrix,
        textLabelPlaneMatrix: textLabelPlaneMatrix,
        labelToScreenMatrix: labelToScreenMatrix,
        scale: scale,
        textPixelRatio: textPixelRatio,
        holdingForFade: tile.holdingForFade(),
        collisionBoxArray: collisionBoxArray,
        partiallyEvaluatedTextSize: performance.evaluateSizeForZoom(symbolBucket.textSizeData, this.transform.zoom),
        collisionGroup: this.collisionGroups.get(symbolBucket.sourceID)
    };
    if (sortAcrossTiles) {
        for (var i = 0, list = symbolBucket.sortKeyRanges; i < list.length; i += 1) {
            var range = list[i];
            var sortKey = range.sortKey;
            var symbolInstanceStart = range.symbolInstanceStart;
            var symbolInstanceEnd = range.symbolInstanceEnd;
            results.push({
                sortKey: sortKey,
                symbolInstanceStart: symbolInstanceStart,
                symbolInstanceEnd: symbolInstanceEnd,
                parameters: parameters
            });
        }
    } else {
        results.push({
            symbolInstanceStart: 0,
            symbolInstanceEnd: symbolBucket.symbolInstances.length,
            parameters: parameters
        });
    }
};
Placement.prototype.attemptAnchorPlacement = function attemptAnchorPlacement(anchor, textBox, width, height, textBoxScale, rotateWithMap, pitchWithMap, textPixelRatio, posMatrix, collisionGroup, textAllowOverlap, symbolInstance, bucket, orientation, iconBox) {
    var textOffset = [
        symbolInstance.textOffset0,
        symbolInstance.textOffset1
    ];
    var shift = calculateVariableLayoutShift(anchor, width, height, textOffset, textBoxScale);
    var placedGlyphBoxes = this.collisionIndex.placeCollisionBox(shiftVariableCollisionBox(textBox, shift.x, shift.y, rotateWithMap, pitchWithMap, this.transform.angle), textAllowOverlap, textPixelRatio, posMatrix, collisionGroup.predicate);
    if (iconBox) {
        var placedIconBoxes = this.collisionIndex.placeCollisionBox(shiftVariableCollisionBox(iconBox, shift.x, shift.y, rotateWithMap, pitchWithMap, this.transform.angle), textAllowOverlap, textPixelRatio, posMatrix, collisionGroup.predicate);
        if (placedIconBoxes.box.length === 0) {
            return;
        }
    }
    if (placedGlyphBoxes.box.length > 0) {
        var prevAnchor;
        if (this.prevPlacement && this.prevPlacement.variableOffsets[symbolInstance.crossTileID] && this.prevPlacement.placements[symbolInstance.crossTileID] && this.prevPlacement.placements[symbolInstance.crossTileID].text) {
            prevAnchor = this.prevPlacement.variableOffsets[symbolInstance.crossTileID].anchor;
        }
        this.variableOffsets[symbolInstance.crossTileID] = {
            textOffset: textOffset,
            width: width,
            height: height,
            anchor: anchor,
            textBoxScale: textBoxScale,
            prevAnchor: prevAnchor
        };
        this.markUsedJustification(bucket, anchor, symbolInstance, orientation);
        if (bucket.allowVerticalPlacement) {
            this.markUsedOrientation(bucket, orientation, symbolInstance);
            this.placedOrientations[symbolInstance.crossTileID] = orientation;
        }
        return {
            shift: shift,
            placedGlyphBoxes: placedGlyphBoxes
        };
    }
};
Placement.prototype.placeLayerBucketPart = function placeLayerBucketPart(bucketPart, seenCrossTileIDs, showCollisionBoxes) {
    var this$1 = this;
    var ref = bucketPart.parameters;
    var bucket = ref.bucket;
    var layout = ref.layout;
    var posMatrix = ref.posMatrix;
    var textLabelPlaneMatrix = ref.textLabelPlaneMatrix;
    var labelToScreenMatrix = ref.labelToScreenMatrix;
    var textPixelRatio = ref.textPixelRatio;
    var holdingForFade = ref.holdingForFade;
    var collisionBoxArray = ref.collisionBoxArray;
    var partiallyEvaluatedTextSize = ref.partiallyEvaluatedTextSize;
    var collisionGroup = ref.collisionGroup;
    var textOptional = layout.get('text-optional');
    var iconOptional = layout.get('icon-optional');
    var textAllowOverlap = layout.get('text-allow-overlap');
    var iconAllowOverlap = layout.get('icon-allow-overlap');
    var rotateWithMap = layout.get('text-rotation-alignment') === 'map';
    var pitchWithMap = layout.get('text-pitch-alignment') === 'map';
    var hasIconTextFit = layout.get('icon-text-fit') !== 'none';
    var zOrderByViewportY = layout.get('symbol-z-order') === 'viewport-y';
    var alwaysShowText = textAllowOverlap && (iconAllowOverlap || !bucket.hasIconData() || iconOptional);
    var alwaysShowIcon = iconAllowOverlap && (textAllowOverlap || !bucket.hasTextData() || textOptional);
    if (!bucket.collisionArrays && collisionBoxArray) {
        bucket.deserializeCollisionBoxes(collisionBoxArray);
    }
    var placeSymbol = function (symbolInstance, collisionArrays) {
        if (seenCrossTileIDs[symbolInstance.crossTileID]) {
            return;
        }
        if (holdingForFade) {
            this$1.placements[symbolInstance.crossTileID] = new JointPlacement(false, false, false);
            return;
        }
        var placeText = false;
        var placeIcon = false;
        var offscreen = true;
        var shift = null;
        var placed = {
            box: null,
            offscreen: null
        };
        var placedVerticalText = {
            box: null,
            offscreen: null
        };
        var placedGlyphBoxes = null;
        var placedGlyphCircles = null;
        var placedIconBoxes = null;
        var textFeatureIndex = 0;
        var verticalTextFeatureIndex = 0;
        var iconFeatureIndex = 0;
        if (collisionArrays.textFeatureIndex) {
            textFeatureIndex = collisionArrays.textFeatureIndex;
        } else if (symbolInstance.useRuntimeCollisionCircles) {
            textFeatureIndex = symbolInstance.featureIndex;
        }
        if (collisionArrays.verticalTextFeatureIndex) {
            verticalTextFeatureIndex = collisionArrays.verticalTextFeatureIndex;
        }
        var textBox = collisionArrays.textBox;
        if (textBox) {
            var updatePreviousOrientationIfNotPlaced = function (isPlaced) {
                var previousOrientation = performance.WritingMode.horizontal;
                if (bucket.allowVerticalPlacement && !isPlaced && this$1.prevPlacement) {
                    var prevPlacedOrientation = this$1.prevPlacement.placedOrientations[symbolInstance.crossTileID];
                    if (prevPlacedOrientation) {
                        this$1.placedOrientations[symbolInstance.crossTileID] = prevPlacedOrientation;
                        previousOrientation = prevPlacedOrientation;
                        this$1.markUsedOrientation(bucket, previousOrientation, symbolInstance);
                    }
                }
                return previousOrientation;
            };
            var placeTextForPlacementModes = function (placeHorizontalFn, placeVerticalFn) {
                if (bucket.allowVerticalPlacement && symbolInstance.numVerticalGlyphVertices > 0 && collisionArrays.verticalTextBox) {
                    for (var i = 0, list = bucket.writingModes; i < list.length; i += 1) {
                        var placementMode = list[i];
                        if (placementMode === performance.WritingMode.vertical) {
                            placed = placeVerticalFn();
                            placedVerticalText = placed;
                        } else {
                            placed = placeHorizontalFn();
                        }
                        if (placed && placed.box && placed.box.length) {
                            break;
                        }
                    }
                } else {
                    placed = placeHorizontalFn();
                }
            };
            if (!layout.get('text-variable-anchor')) {
                var placeBox = function (collisionTextBox, orientation) {
                    var placedFeature = this$1.collisionIndex.placeCollisionBox(collisionTextBox, textAllowOverlap, textPixelRatio, posMatrix, collisionGroup.predicate);
                    if (placedFeature && placedFeature.box && placedFeature.box.length) {
                        this$1.markUsedOrientation(bucket, orientation, symbolInstance);
                        this$1.placedOrientations[symbolInstance.crossTileID] = orientation;
                    }
                    return placedFeature;
                };
                var placeHorizontal = function () {
                    return placeBox(textBox, performance.WritingMode.horizontal);
                };
                var placeVertical = function () {
                    var verticalTextBox = collisionArrays.verticalTextBox;
                    if (bucket.allowVerticalPlacement && symbolInstance.numVerticalGlyphVertices > 0 && verticalTextBox) {
                        return placeBox(verticalTextBox, performance.WritingMode.vertical);
                    }
                    return {
                        box: null,
                        offscreen: null
                    };
                };
                placeTextForPlacementModes(placeHorizontal, placeVertical);
                updatePreviousOrientationIfNotPlaced(placed && placed.box && placed.box.length);
            } else {
                var anchors = layout.get('text-variable-anchor');
                if (this$1.prevPlacement && this$1.prevPlacement.variableOffsets[symbolInstance.crossTileID]) {
                    var prevOffsets = this$1.prevPlacement.variableOffsets[symbolInstance.crossTileID];
                    if (anchors.indexOf(prevOffsets.anchor) > 0) {
                        anchors = anchors.filter(function (anchor) {
                            return anchor !== prevOffsets.anchor;
                        });
                        anchors.unshift(prevOffsets.anchor);
                    }
                }
                var placeBoxForVariableAnchors = function (collisionTextBox, collisionIconBox, orientation) {
                    var width = collisionTextBox.x2 - collisionTextBox.x1;
                    var height = collisionTextBox.y2 - collisionTextBox.y1;
                    var textBoxScale = symbolInstance.textBoxScale;
                    var variableIconBox = hasIconTextFit && !iconAllowOverlap ? collisionIconBox : null;
                    var placedBox = {
                        box: [],
                        offscreen: false
                    };
                    var placementAttempts = textAllowOverlap ? anchors.length * 2 : anchors.length;
                    for (var i = 0; i < placementAttempts; ++i) {
                        var anchor = anchors[i % anchors.length];
                        var allowOverlap = i >= anchors.length;
                        var result = this$1.attemptAnchorPlacement(anchor, collisionTextBox, width, height, textBoxScale, rotateWithMap, pitchWithMap, textPixelRatio, posMatrix, collisionGroup, allowOverlap, symbolInstance, bucket, orientation, variableIconBox);
                        if (result) {
                            placedBox = result.placedGlyphBoxes;
                            if (placedBox && placedBox.box && placedBox.box.length) {
                                placeText = true;
                                shift = result.shift;
                                break;
                            }
                        }
                    }
                    return placedBox;
                };
                var placeHorizontal$1 = function () {
                    return placeBoxForVariableAnchors(textBox, collisionArrays.iconBox, performance.WritingMode.horizontal);
                };
                var placeVertical$1 = function () {
                    var verticalTextBox = collisionArrays.verticalTextBox;
                    var wasPlaced = placed && placed.box && placed.box.length;
                    if (bucket.allowVerticalPlacement && !wasPlaced && symbolInstance.numVerticalGlyphVertices > 0 && verticalTextBox) {
                        return placeBoxForVariableAnchors(verticalTextBox, collisionArrays.verticalIconBox, performance.WritingMode.vertical);
                    }
                    return {
                        box: null,
                        offscreen: null
                    };
                };
                placeTextForPlacementModes(placeHorizontal$1, placeVertical$1);
                if (placed) {
                    placeText = placed.box;
                    offscreen = placed.offscreen;
                }
                var prevOrientation = updatePreviousOrientationIfNotPlaced(placed && placed.box);
                if (!placeText && this$1.prevPlacement) {
                    var prevOffset = this$1.prevPlacement.variableOffsets[symbolInstance.crossTileID];
                    if (prevOffset) {
                        this$1.variableOffsets[symbolInstance.crossTileID] = prevOffset;
                        this$1.markUsedJustification(bucket, prevOffset.anchor, symbolInstance, prevOrientation);
                    }
                }
            }
        }
        placedGlyphBoxes = placed;
        placeText = placedGlyphBoxes && placedGlyphBoxes.box && placedGlyphBoxes.box.length > 0;
        offscreen = placedGlyphBoxes && placedGlyphBoxes.offscreen;
        if (symbolInstance.useRuntimeCollisionCircles) {
            var placedSymbol = bucket.text.placedSymbolArray.get(symbolInstance.centerJustifiedTextSymbolIndex);
            var fontSize = performance.evaluateSizeForFeature(bucket.textSizeData, partiallyEvaluatedTextSize, placedSymbol);
            var textPixelPadding = layout.get('text-padding');
            var circlePixelDiameter = symbolInstance.collisionCircleDiameter;
            placedGlyphCircles = this$1.collisionIndex.placeCollisionCircles(textAllowOverlap, placedSymbol, bucket.lineVertexArray, bucket.glyphOffsetArray, fontSize, posMatrix, textLabelPlaneMatrix, labelToScreenMatrix, showCollisionBoxes, pitchWithMap, collisionGroup.predicate, circlePixelDiameter, textPixelPadding);
            placeText = textAllowOverlap || placedGlyphCircles.circles.length > 0 && !placedGlyphCircles.collisionDetected;
            offscreen = offscreen && placedGlyphCircles.offscreen;
        }
        if (collisionArrays.iconFeatureIndex) {
            iconFeatureIndex = collisionArrays.iconFeatureIndex;
        }
        if (collisionArrays.iconBox) {
            var placeIconFeature = function (iconBox) {
                var shiftedIconBox = hasIconTextFit && shift ? shiftVariableCollisionBox(iconBox, shift.x, shift.y, rotateWithMap, pitchWithMap, this$1.transform.angle) : iconBox;
                return this$1.collisionIndex.placeCollisionBox(shiftedIconBox, iconAllowOverlap, textPixelRatio, posMatrix, collisionGroup.predicate);
            };
            if (placedVerticalText && placedVerticalText.box && placedVerticalText.box.length && collisionArrays.verticalIconBox) {
                placedIconBoxes = placeIconFeature(collisionArrays.verticalIconBox);
                placeIcon = placedIconBoxes.box.length > 0;
            } else {
                placedIconBoxes = placeIconFeature(collisionArrays.iconBox);
                placeIcon = placedIconBoxes.box.length > 0;
            }
            offscreen = offscreen && placedIconBoxes.offscreen;
        }
        var iconWithoutText = textOptional || symbolInstance.numHorizontalGlyphVertices === 0 && symbolInstance.numVerticalGlyphVertices === 0;
        var textWithoutIcon = iconOptional || symbolInstance.numIconVertices === 0;
        if (!iconWithoutText && !textWithoutIcon) {
            placeIcon = placeText = placeIcon && placeText;
        } else if (!textWithoutIcon) {
            placeText = placeIcon && placeText;
        } else if (!iconWithoutText) {
            placeIcon = placeIcon && placeText;
        }
        if (placeText && placedGlyphBoxes && placedGlyphBoxes.box) {
            if (placedVerticalText && placedVerticalText.box && verticalTextFeatureIndex) {
                this$1.collisionIndex.insertCollisionBox(placedGlyphBoxes.box, layout.get('text-ignore-placement'), bucket.bucketInstanceId, verticalTextFeatureIndex, collisionGroup.ID);
            } else {
                this$1.collisionIndex.insertCollisionBox(placedGlyphBoxes.box, layout.get('text-ignore-placement'), bucket.bucketInstanceId, textFeatureIndex, collisionGroup.ID);
            }
        }
        if (placeIcon && placedIconBoxes) {
            this$1.collisionIndex.insertCollisionBox(placedIconBoxes.box, layout.get('icon-ignore-placement'), bucket.bucketInstanceId, iconFeatureIndex, collisionGroup.ID);
        }
        if (placedGlyphCircles) {
            if (placeText) {
                this$1.collisionIndex.insertCollisionCircles(placedGlyphCircles.circles, layout.get('text-ignore-placement'), bucket.bucketInstanceId, textFeatureIndex, collisionGroup.ID);
            }
            if (showCollisionBoxes) {
                var id = bucket.bucketInstanceId;
                var circleArray = this$1.collisionCircleArrays[id];
                if (circleArray === undefined) {
                    circleArray = this$1.collisionCircleArrays[id] = new CollisionCircleArray();
                }
                for (var i = 0; i < placedGlyphCircles.circles.length; i += 4) {
                    circleArray.circles.push(placedGlyphCircles.circles[i + 0]);
                    circleArray.circles.push(placedGlyphCircles.circles[i + 1]);
                    circleArray.circles.push(placedGlyphCircles.circles[i + 2]);
                    circleArray.circles.push(placedGlyphCircles.collisionDetected ? 1 : 0);
                }
            }
        }
        this$1.placements[symbolInstance.crossTileID] = new JointPlacement(placeText || alwaysShowText, placeIcon || alwaysShowIcon, offscreen || bucket.justReloaded);
        seenCrossTileIDs[symbolInstance.crossTileID] = true;
    };
    if (zOrderByViewportY) {
        var symbolIndexes = bucket.getSortedSymbolIndexes(this.transform.angle);
        for (var i = symbolIndexes.length - 1; i >= 0; --i) {
            var symbolIndex = symbolIndexes[i];
            placeSymbol(bucket.symbolInstances.get(symbolIndex), bucket.collisionArrays[symbolIndex]);
        }
    } else {
        for (var i$1 = bucketPart.symbolInstanceStart; i$1 < bucketPart.symbolInstanceEnd; i$1++) {
            placeSymbol(bucket.symbolInstances.get(i$1), bucket.collisionArrays[i$1]);
        }
    }
    if (showCollisionBoxes && bucket.bucketInstanceId in this.collisionCircleArrays) {
        var circleArray = this.collisionCircleArrays[bucket.bucketInstanceId];
        performance.invert(circleArray.invProjMatrix, posMatrix);
        circleArray.viewportMatrix = this.collisionIndex.getViewportMatrix();
    }
    bucket.justReloaded = false;
};
Placement.prototype.markUsedJustification = function markUsedJustification(bucket, placedAnchor, symbolInstance, orientation) {
    var justifications = {
        'left': symbolInstance.leftJustifiedTextSymbolIndex,
        'center': symbolInstance.centerJustifiedTextSymbolIndex,
        'right': symbolInstance.rightJustifiedTextSymbolIndex
    };
    var autoIndex;
    if (orientation === performance.WritingMode.vertical) {
        autoIndex = symbolInstance.verticalPlacedTextSymbolIndex;
    } else {
        autoIndex = justifications[performance.getAnchorJustification(placedAnchor)];
    }
    var indexes = [
        symbolInstance.leftJustifiedTextSymbolIndex,
        symbolInstance.centerJustifiedTextSymbolIndex,
        symbolInstance.rightJustifiedTextSymbolIndex,
        symbolInstance.verticalPlacedTextSymbolIndex
    ];
    for (var i = 0, list = indexes; i < list.length; i += 1) {
        var index = list[i];
        if (index >= 0) {
            if (autoIndex >= 0 && index !== autoIndex) {
                bucket.text.placedSymbolArray.get(index).crossTileID = 0;
            } else {
                bucket.text.placedSymbolArray.get(index).crossTileID = symbolInstance.crossTileID;
            }
        }
    }
};
Placement.prototype.markUsedOrientation = function markUsedOrientation(bucket, orientation, symbolInstance) {
    var horizontal = orientation === performance.WritingMode.horizontal || orientation === performance.WritingMode.horizontalOnly ? orientation : 0;
    var vertical = orientation === performance.WritingMode.vertical ? orientation : 0;
    var horizontalIndexes = [
        symbolInstance.leftJustifiedTextSymbolIndex,
        symbolInstance.centerJustifiedTextSymbolIndex,
        symbolInstance.rightJustifiedTextSymbolIndex
    ];
    for (var i = 0, list = horizontalIndexes; i < list.length; i += 1) {
        var index = list[i];
        bucket.text.placedSymbolArray.get(index).placedOrientation = horizontal;
    }
    if (symbolInstance.verticalPlacedTextSymbolIndex) {
        bucket.text.placedSymbolArray.get(symbolInstance.verticalPlacedTextSymbolIndex).placedOrientation = vertical;
    }
};
Placement.prototype.commit = function commit(now) {
    this.commitTime = now;
    this.zoomAtLastRecencyCheck = this.transform.zoom;
    var prevPlacement = this.prevPlacement;
    var placementChanged = false;
    this.prevZoomAdjustment = prevPlacement ? prevPlacement.zoomAdjustment(this.transform.zoom) : 0;
    var increment = prevPlacement ? prevPlacement.symbolFadeChange(now) : 1;
    var prevOpacities = prevPlacement ? prevPlacement.opacities : {};
    var prevOffsets = prevPlacement ? prevPlacement.variableOffsets : {};
    var prevOrientations = prevPlacement ? prevPlacement.placedOrientations : {};
    for (var crossTileID in this.placements) {
        var jointPlacement = this.placements[crossTileID];
        var prevOpacity = prevOpacities[crossTileID];
        if (prevOpacity) {
            this.opacities[crossTileID] = new JointOpacityState(prevOpacity, increment, jointPlacement.text, jointPlacement.icon);
            placementChanged = placementChanged || jointPlacement.text !== prevOpacity.text.placed || jointPlacement.icon !== prevOpacity.icon.placed;
        } else {
            this.opacities[crossTileID] = new JointOpacityState(null, increment, jointPlacement.text, jointPlacement.icon, jointPlacement.skipFade);
            placementChanged = placementChanged || jointPlacement.text || jointPlacement.icon;
        }
    }
    for (var crossTileID$1 in prevOpacities) {
        var prevOpacity$1 = prevOpacities[crossTileID$1];
        if (!this.opacities[crossTileID$1]) {
            var jointOpacity = new JointOpacityState(prevOpacity$1, increment, false, false);
            if (!jointOpacity.isHidden()) {
                this.opacities[crossTileID$1] = jointOpacity;
                placementChanged = placementChanged || prevOpacity$1.text.placed || prevOpacity$1.icon.placed;
            }
        }
    }
    for (var crossTileID$2 in prevOffsets) {
        if (!this.variableOffsets[crossTileID$2] && this.opacities[crossTileID$2] && !this.opacities[crossTileID$2].isHidden()) {
            this.variableOffsets[crossTileID$2] = prevOffsets[crossTileID$2];
        }
    }
    for (var crossTileID$3 in prevOrientations) {
        if (!this.placedOrientations[crossTileID$3] && this.opacities[crossTileID$3] && !this.opacities[crossTileID$3].isHidden()) {
            this.placedOrientations[crossTileID$3] = prevOrientations[crossTileID$3];
        }
    }
    if (placementChanged) {
        this.lastPlacementChangeTime = now;
    } else if (typeof this.lastPlacementChangeTime !== 'number') {
        this.lastPlacementChangeTime = prevPlacement ? prevPlacement.lastPlacementChangeTime : now;
    }
};
Placement.prototype.updateLayerOpacities = function updateLayerOpacities(styleLayer, tiles) {
    var seenCrossTileIDs = {};
    for (var i = 0, list = tiles; i < list.length; i += 1) {
        var tile = list[i];
        var symbolBucket = tile.getBucket(styleLayer);
        if (symbolBucket && tile.latestFeatureIndex && styleLayer.id === symbolBucket.layerIds[0]) {
            this.updateBucketOpacities(symbolBucket, seenCrossTileIDs, tile.collisionBoxArray);
        }
    }
};
Placement.prototype.updateBucketOpacities = function updateBucketOpacities(bucket, seenCrossTileIDs, collisionBoxArray) {
    var this$1 = this;
    if (bucket.hasTextData()) {
        bucket.text.opacityVertexArray.clear();
    }
    if (bucket.hasIconData()) {
        bucket.icon.opacityVertexArray.clear();
    }
    if (bucket.hasIconCollisionBoxData()) {
        bucket.iconCollisionBox.collisionVertexArray.clear();
    }
    if (bucket.hasTextCollisionBoxData()) {
        bucket.textCollisionBox.collisionVertexArray.clear();
    }
    var layout = bucket.layers[0].layout;
    var duplicateOpacityState = new JointOpacityState(null, 0, false, false, true);
    var textAllowOverlap = layout.get('text-allow-overlap');
    var iconAllowOverlap = layout.get('icon-allow-overlap');
    var variablePlacement = layout.get('text-variable-anchor');
    var rotateWithMap = layout.get('text-rotation-alignment') === 'map';
    var pitchWithMap = layout.get('text-pitch-alignment') === 'map';
    var hasIconTextFit = layout.get('icon-text-fit') !== 'none';
    var defaultOpacityState = new JointOpacityState(null, 0, textAllowOverlap && (iconAllowOverlap || !bucket.hasIconData() || layout.get('icon-optional')), iconAllowOverlap && (textAllowOverlap || !bucket.hasTextData() || layout.get('text-optional')), true);
    if (!bucket.collisionArrays && collisionBoxArray && (bucket.hasIconCollisionBoxData() || bucket.hasTextCollisionBoxData())) {
        bucket.deserializeCollisionBoxes(collisionBoxArray);
    }
    var addOpacities = function (iconOrText, numVertices, opacity) {
        for (var i = 0; i < numVertices / 4; i++) {
            iconOrText.opacityVertexArray.emplaceBack(opacity);
        }
    };
    var loop = function (s) {
        var symbolInstance = bucket.symbolInstances.get(s);
        var numHorizontalGlyphVertices = symbolInstance.numHorizontalGlyphVertices;
        var numVerticalGlyphVertices = symbolInstance.numVerticalGlyphVertices;
        var crossTileID = symbolInstance.crossTileID;
        var isDuplicate = seenCrossTileIDs[crossTileID];
        var opacityState = this$1.opacities[crossTileID];
        if (isDuplicate) {
            opacityState = duplicateOpacityState;
        } else if (!opacityState) {
            opacityState = defaultOpacityState;
            this$1.opacities[crossTileID] = opacityState;
        }
        seenCrossTileIDs[crossTileID] = true;
        var hasText = numHorizontalGlyphVertices > 0 || numVerticalGlyphVertices > 0;
        var hasIcon = symbolInstance.numIconVertices > 0;
        var placedOrientation = this$1.placedOrientations[symbolInstance.crossTileID];
        var horizontalHidden = placedOrientation === performance.WritingMode.vertical;
        var verticalHidden = placedOrientation === performance.WritingMode.horizontal || placedOrientation === performance.WritingMode.horizontalOnly;
        if (hasText) {
            var packedOpacity = packOpacity(opacityState.text);
            var horizontalOpacity = horizontalHidden ? PACKED_HIDDEN_OPACITY : packedOpacity;
            addOpacities(bucket.text, numHorizontalGlyphVertices, horizontalOpacity);
            var verticalOpacity = verticalHidden ? PACKED_HIDDEN_OPACITY : packedOpacity;
            addOpacities(bucket.text, numVerticalGlyphVertices, verticalOpacity);
            var symbolHidden = opacityState.text.isHidden();
            [
                symbolInstance.rightJustifiedTextSymbolIndex,
                symbolInstance.centerJustifiedTextSymbolIndex,
                symbolInstance.leftJustifiedTextSymbolIndex
            ].forEach(function (index) {
                if (index >= 0) {
                    bucket.text.placedSymbolArray.get(index).hidden = symbolHidden || horizontalHidden ? 1 : 0;
                }
            });
            if (symbolInstance.verticalPlacedTextSymbolIndex >= 0) {
                bucket.text.placedSymbolArray.get(symbolInstance.verticalPlacedTextSymbolIndex).hidden = symbolHidden || verticalHidden ? 1 : 0;
            }
            var prevOffset = this$1.variableOffsets[symbolInstance.crossTileID];
            if (prevOffset) {
                this$1.markUsedJustification(bucket, prevOffset.anchor, symbolInstance, placedOrientation);
            }
            var prevOrientation = this$1.placedOrientations[symbolInstance.crossTileID];
            if (prevOrientation) {
                this$1.markUsedJustification(bucket, 'left', symbolInstance, prevOrientation);
                this$1.markUsedOrientation(bucket, prevOrientation, symbolInstance);
            }
        }
        if (hasIcon) {
            var packedOpacity$1 = packOpacity(opacityState.icon);
            var useHorizontal = !(hasIconTextFit && symbolInstance.verticalPlacedIconSymbolIndex && horizontalHidden);
            if (symbolInstance.placedIconSymbolIndex >= 0) {
                var horizontalOpacity$1 = useHorizontal ? packedOpacity$1 : PACKED_HIDDEN_OPACITY;
                addOpacities(bucket.icon, symbolInstance.numIconVertices, horizontalOpacity$1);
                bucket.icon.placedSymbolArray.get(symbolInstance.placedIconSymbolIndex).hidden = opacityState.icon.isHidden();
            }
            if (symbolInstance.verticalPlacedIconSymbolIndex >= 0) {
                var verticalOpacity$1 = !useHorizontal ? packedOpacity$1 : PACKED_HIDDEN_OPACITY;
                addOpacities(bucket.icon, symbolInstance.numVerticalIconVertices, verticalOpacity$1);
                bucket.icon.placedSymbolArray.get(symbolInstance.verticalPlacedIconSymbolIndex).hidden = opacityState.icon.isHidden();
            }
        }
        if (bucket.hasIconCollisionBoxData() || bucket.hasTextCollisionBoxData()) {
            var collisionArrays = bucket.collisionArrays[s];
            if (collisionArrays) {
                var shift = new performance.Point(0, 0);
                if (collisionArrays.textBox || collisionArrays.verticalTextBox) {
                    var used = true;
                    if (variablePlacement) {
                        var variableOffset = this$1.variableOffsets[crossTileID];
                        if (variableOffset) {
                            shift = calculateVariableLayoutShift(variableOffset.anchor, variableOffset.width, variableOffset.height, variableOffset.textOffset, variableOffset.textBoxScale);
                            if (rotateWithMap) {
                                shift._rotate(pitchWithMap ? this$1.transform.angle : -this$1.transform.angle);
                            }
                        } else {
                            used = false;
                        }
                    }
                    if (collisionArrays.textBox) {
                        updateCollisionVertices(bucket.textCollisionBox.collisionVertexArray, opacityState.text.placed, !used || horizontalHidden, shift.x, shift.y);
                    }
                    if (collisionArrays.verticalTextBox) {
                        updateCollisionVertices(bucket.textCollisionBox.collisionVertexArray, opacityState.text.placed, !used || verticalHidden, shift.x, shift.y);
                    }
                }
                var verticalIconUsed = Boolean(!verticalHidden && collisionArrays.verticalIconBox);
                if (collisionArrays.iconBox) {
                    updateCollisionVertices(bucket.iconCollisionBox.collisionVertexArray, opacityState.icon.placed, verticalIconUsed, hasIconTextFit ? shift.x : 0, hasIconTextFit ? shift.y : 0);
                }
                if (collisionArrays.verticalIconBox) {
                    updateCollisionVertices(bucket.iconCollisionBox.collisionVertexArray, opacityState.icon.placed, !verticalIconUsed, hasIconTextFit ? shift.x : 0, hasIconTextFit ? shift.y : 0);
                }
            }
        }
    };
    for (var s = 0; s < bucket.symbolInstances.length; s++)
        loop(s);
    bucket.sortFeatures(this.transform.angle);
    if (this.retainedQueryData[bucket.bucketInstanceId]) {
        this.retainedQueryData[bucket.bucketInstanceId].featureSortOrder = bucket.featureSortOrder;
    }
    if (bucket.hasTextData() && bucket.text.opacityVertexBuffer) {
        bucket.text.opacityVertexBuffer.updateData(bucket.text.opacityVertexArray);
    }
    if (bucket.hasIconData() && bucket.icon.opacityVertexBuffer) {
        bucket.icon.opacityVertexBuffer.updateData(bucket.icon.opacityVertexArray);
    }
    if (bucket.hasIconCollisionBoxData() && bucket.iconCollisionBox.collisionVertexBuffer) {
        bucket.iconCollisionBox.collisionVertexBuffer.updateData(bucket.iconCollisionBox.collisionVertexArray);
    }
    if (bucket.hasTextCollisionBoxData() && bucket.textCollisionBox.collisionVertexBuffer) {
        bucket.textCollisionBox.collisionVertexBuffer.updateData(bucket.textCollisionBox.collisionVertexArray);
    }
    if (bucket.bucketInstanceId in this.collisionCircleArrays) {
        var instance = this.collisionCircleArrays[bucket.bucketInstanceId];
        bucket.placementInvProjMatrix = instance.invProjMatrix;
        bucket.placementViewportMatrix = instance.viewportMatrix;
        bucket.collisionCircleArray = instance.circles;
        delete this.collisionCircleArrays[bucket.bucketInstanceId];
    }
};
Placement.prototype.symbolFadeChange = function symbolFadeChange(now) {
    return this.fadeDuration === 0 ? 1 : (now - this.commitTime) / this.fadeDuration + this.prevZoomAdjustment;
};
Placement.prototype.zoomAdjustment = function zoomAdjustment(zoom) {
    return Math.max(0, (this.transform.zoom - zoom) / 1.5);
};
Placement.prototype.hasTransitions = function hasTransitions(now) {
    return this.stale || now - this.lastPlacementChangeTime < this.fadeDuration;
};
Placement.prototype.stillRecent = function stillRecent(now, zoom) {
    var durationAdjustment = this.zoomAtLastRecencyCheck === zoom ? 1 - this.zoomAdjustment(zoom) : 1;
    this.zoomAtLastRecencyCheck = zoom;
    return this.commitTime + this.fadeDuration * durationAdjustment > now;
};
Placement.prototype.setStale = function setStale() {
    this.stale = true;
};
function updateCollisionVertices(collisionVertexArray, placed, notUsed, shiftX, shiftY) {
    collisionVertexArray.emplaceBack(placed ? 1 : 0, notUsed ? 1 : 0, shiftX || 0, shiftY || 0);
    collisionVertexArray.emplaceBack(placed ? 1 : 0, notUsed ? 1 : 0, shiftX || 0, shiftY || 0);
    collisionVertexArray.emplaceBack(placed ? 1 : 0, notUsed ? 1 : 0, shiftX || 0, shiftY || 0);
    collisionVertexArray.emplaceBack(placed ? 1 : 0, notUsed ? 1 : 0, shiftX || 0, shiftY || 0);
}
var shift25 = Math.pow(2, 25);
var shift24 = Math.pow(2, 24);
var shift17 = Math.pow(2, 17);
var shift16 = Math.pow(2, 16);
var shift9 = Math.pow(2, 9);
var shift8 = Math.pow(2, 8);
var shift1 = Math.pow(2, 1);
function packOpacity(opacityState) {
    if (opacityState.opacity === 0 && !opacityState.placed) {
        return 0;
    } else if (opacityState.opacity === 1 && opacityState.placed) {
        return 4294967295;
    }
    var targetBit = opacityState.placed ? 1 : 0;
    var opacityBits = Math.floor(opacityState.opacity * 127);
    return opacityBits * shift25 + targetBit * shift24 + opacityBits * shift17 + targetBit * shift16 + opacityBits * shift9 + targetBit * shift8 + opacityBits * shift1 + targetBit;
}
var PACKED_HIDDEN_OPACITY = 0;

var LayerPlacement = function LayerPlacement(styleLayer) {
    this._sortAcrossTiles = styleLayer.layout.get('symbol-z-order') !== 'viewport-y' && styleLayer.layout.get('symbol-sort-key').constantOr(1) !== undefined;
    this._currentTileIndex = 0;
    this._currentPartIndex = 0;
    this._seenCrossTileIDs = {};
    this._bucketParts = [];
};
LayerPlacement.prototype.continuePlacement = function continuePlacement(tiles, placement, showCollisionBoxes, styleLayer, shouldPausePlacement) {
    var bucketParts = this._bucketParts;
    while (this._currentTileIndex < tiles.length) {
        var tile = tiles[this._currentTileIndex];
        placement.getBucketParts(bucketParts, styleLayer, tile, this._sortAcrossTiles);
        this._currentTileIndex++;
        if (shouldPausePlacement()) {
            return true;
        }
    }
    if (this._sortAcrossTiles) {
        this._sortAcrossTiles = false;
        bucketParts.sort(function (a, b) {
            return a.sortKey - b.sortKey;
        });
    }
    while (this._currentPartIndex < bucketParts.length) {
        var bucketPart = bucketParts[this._currentPartIndex];
        placement.placeLayerBucketPart(bucketPart, this._seenCrossTileIDs, showCollisionBoxes);
        this._currentPartIndex++;
        if (shouldPausePlacement()) {
            return true;
        }
    }
    return false;
};
var PauseablePlacement = function PauseablePlacement(transform, order, forceFullPlacement, showCollisionBoxes, fadeDuration, crossSourceCollisions, prevPlacement) {
    this.placement = new Placement(transform, fadeDuration, crossSourceCollisions, prevPlacement);
    this._currentPlacementIndex = order.length - 1;
    this._forceFullPlacement = forceFullPlacement;
    this._showCollisionBoxes = showCollisionBoxes;
    this._done = false;
};
PauseablePlacement.prototype.isDone = function isDone() {
    return this._done;
};
PauseablePlacement.prototype.continuePlacement = function continuePlacement(order, layers, layerTiles) {
    var this$1 = this;
    var startTime = performance.browser.now();
    var shouldPausePlacement = function () {
        var elapsedTime = performance.browser.now() - startTime;
        return this$1._forceFullPlacement ? false : elapsedTime > 2;
    };
    while (this._currentPlacementIndex >= 0) {
        var layerId = order[this._currentPlacementIndex];
        var layer = layers[layerId];
        var placementZoom = this.placement.collisionIndex.transform.zoom;
        if (layer.type === 'symbol' && (!layer.minzoom || layer.minzoom <= placementZoom) && (!layer.maxzoom || layer.maxzoom > placementZoom)) {
            if (!this._inProgressLayer) {
                this._inProgressLayer = new LayerPlacement(layer);
            }
            var pausePlacement = this._inProgressLayer.continuePlacement(layerTiles[layer.source], this.placement, this._showCollisionBoxes, layer, shouldPausePlacement);
            if (pausePlacement) {
                return;
            }
            delete this._inProgressLayer;
        }
        this._currentPlacementIndex--;
    }
    this._done = true;
};
PauseablePlacement.prototype.commit = function commit(now) {
    this.placement.commit(now);
    return this.placement;
};

var roundingFactor = 512 / performance.EXTENT / 2;
var TileLayerIndex = function TileLayerIndex(tileID, symbolInstances, bucketInstanceId) {
    this.tileID = tileID;
    this.indexedSymbolInstances = {};
    this.bucketInstanceId = bucketInstanceId;
    for (var i = 0; i < symbolInstances.length; i++) {
        var symbolInstance = symbolInstances.get(i);
        var key = symbolInstance.key;
        if (!this.indexedSymbolInstances[key]) {
            this.indexedSymbolInstances[key] = [];
        }
        this.indexedSymbolInstances[key].push({
            crossTileID: symbolInstance.crossTileID,
            coord: this.getScaledCoordinates(symbolInstance, tileID)
        });
    }
};
TileLayerIndex.prototype.getScaledCoordinates = function getScaledCoordinates(symbolInstance, childTileID) {
    var zDifference = childTileID.canonical.z - this.tileID.canonical.z;
    var scale = roundingFactor / Math.pow(2, zDifference);
    return {
        x: Math.floor((childTileID.canonical.x * performance.EXTENT + symbolInstance.anchorX) * scale),
        y: Math.floor((childTileID.canonical.y * performance.EXTENT + symbolInstance.anchorY) * scale)
    };
};
TileLayerIndex.prototype.findMatches = function findMatches(symbolInstances, newTileID, zoomCrossTileIDs) {
    var tolerance = this.tileID.canonical.z < newTileID.canonical.z ? 1 : Math.pow(2, this.tileID.canonical.z - newTileID.canonical.z);
    for (var i = 0; i < symbolInstances.length; i++) {
        var symbolInstance = symbolInstances.get(i);
        if (symbolInstance.crossTileID) {
            continue;
        }
        var indexedInstances = this.indexedSymbolInstances[symbolInstance.key];
        if (!indexedInstances) {
            continue;
        }
        var scaledSymbolCoord = this.getScaledCoordinates(symbolInstance, newTileID);
        for (var i$1 = 0, list = indexedInstances; i$1 < list.length; i$1 += 1) {
            var thisTileSymbol = list[i$1];
            if (Math.abs(thisTileSymbol.coord.x - scaledSymbolCoord.x) <= tolerance && Math.abs(thisTileSymbol.coord.y - scaledSymbolCoord.y) <= tolerance && !zoomCrossTileIDs[thisTileSymbol.crossTileID]) {
                zoomCrossTileIDs[thisTileSymbol.crossTileID] = true;
                symbolInstance.crossTileID = thisTileSymbol.crossTileID;
                break;
            }
        }
    }
};
var CrossTileIDs = function CrossTileIDs() {
    this.maxCrossTileID = 0;
};
CrossTileIDs.prototype.generate = function generate() {
    return ++this.maxCrossTileID;
};
var CrossTileSymbolLayerIndex = function CrossTileSymbolLayerIndex() {
    this.indexes = {};
    this.usedCrossTileIDs = {};
    this.lng = 0;
};
CrossTileSymbolLayerIndex.prototype.handleWrapJump = function handleWrapJump(lng) {
    var wrapDelta = Math.round((lng - this.lng) / 360);
    if (wrapDelta !== 0) {
        for (var zoom in this.indexes) {
            var zoomIndexes = this.indexes[zoom];
            var newZoomIndex = {};
            for (var key in zoomIndexes) {
                var index = zoomIndexes[key];
                index.tileID = index.tileID.unwrapTo(index.tileID.wrap + wrapDelta);
                newZoomIndex[index.tileID.key] = index;
            }
            this.indexes[zoom] = newZoomIndex;
        }
    }
    this.lng = lng;
};
CrossTileSymbolLayerIndex.prototype.addBucket = function addBucket(tileID, bucket, crossTileIDs) {
    if (this.indexes[tileID.overscaledZ] && this.indexes[tileID.overscaledZ][tileID.key]) {
        if (this.indexes[tileID.overscaledZ][tileID.key].bucketInstanceId === bucket.bucketInstanceId) {
            return false;
        } else {
            this.removeBucketCrossTileIDs(tileID.overscaledZ, this.indexes[tileID.overscaledZ][tileID.key]);
        }
    }
    for (var i = 0; i < bucket.symbolInstances.length; i++) {
        var symbolInstance = bucket.symbolInstances.get(i);
        symbolInstance.crossTileID = 0;
    }
    if (!this.usedCrossTileIDs[tileID.overscaledZ]) {
        this.usedCrossTileIDs[tileID.overscaledZ] = {};
    }
    var zoomCrossTileIDs = this.usedCrossTileIDs[tileID.overscaledZ];
    for (var zoom in this.indexes) {
        var zoomIndexes = this.indexes[zoom];
        if (Number(zoom) > tileID.overscaledZ) {
            for (var id in zoomIndexes) {
                var childIndex = zoomIndexes[id];
                if (childIndex.tileID.isChildOf(tileID)) {
                    childIndex.findMatches(bucket.symbolInstances, tileID, zoomCrossTileIDs);
                }
            }
        } else {
            var parentCoord = tileID.scaledTo(Number(zoom));
            var parentIndex = zoomIndexes[parentCoord.key];
            if (parentIndex) {
                parentIndex.findMatches(bucket.symbolInstances, tileID, zoomCrossTileIDs);
            }
        }
    }
    for (var i$1 = 0; i$1 < bucket.symbolInstances.length; i$1++) {
        var symbolInstance$1 = bucket.symbolInstances.get(i$1);
        if (!symbolInstance$1.crossTileID) {
            symbolInstance$1.crossTileID = crossTileIDs.generate();
            zoomCrossTileIDs[symbolInstance$1.crossTileID] = true;
        }
    }
    if (this.indexes[tileID.overscaledZ] === undefined) {
        this.indexes[tileID.overscaledZ] = {};
    }
    this.indexes[tileID.overscaledZ][tileID.key] = new TileLayerIndex(tileID, bucket.symbolInstances, bucket.bucketInstanceId);
    return true;
};
CrossTileSymbolLayerIndex.prototype.removeBucketCrossTileIDs = function removeBucketCrossTileIDs(zoom, removedBucket) {
    for (var key in removedBucket.indexedSymbolInstances) {
        for (var i = 0, list = removedBucket.indexedSymbolInstances[key]; i < list.length; i += 1) {
            var symbolInstance = list[i];
            delete this.usedCrossTileIDs[zoom][symbolInstance.crossTileID];
        }
    }
};
CrossTileSymbolLayerIndex.prototype.removeStaleBuckets = function removeStaleBuckets(currentIDs) {
    var tilesChanged = false;
    for (var z in this.indexes) {
        var zoomIndexes = this.indexes[z];
        for (var tileKey in zoomIndexes) {
            if (!currentIDs[zoomIndexes[tileKey].bucketInstanceId]) {
                this.removeBucketCrossTileIDs(z, zoomIndexes[tileKey]);
                delete zoomIndexes[tileKey];
                tilesChanged = true;
            }
        }
    }
    return tilesChanged;
};
var CrossTileSymbolIndex = function CrossTileSymbolIndex() {
    this.layerIndexes = {};
    this.crossTileIDs = new CrossTileIDs();
    this.maxBucketInstanceId = 0;
    this.bucketsInCurrentPlacement = {};
};
CrossTileSymbolIndex.prototype.addLayer = function addLayer(styleLayer, tiles, lng) {
    var layerIndex = this.layerIndexes[styleLayer.id];
    if (layerIndex === undefined) {
        layerIndex = this.layerIndexes[styleLayer.id] = new CrossTileSymbolLayerIndex();
    }
    var symbolBucketsChanged = false;
    var currentBucketIDs = {};
    layerIndex.handleWrapJump(lng);
    for (var i = 0, list = tiles; i < list.length; i += 1) {
        var tile = list[i];
        var symbolBucket = tile.getBucket(styleLayer);
        if (!symbolBucket || styleLayer.id !== symbolBucket.layerIds[0]) {
            continue;
        }
        if (!symbolBucket.bucketInstanceId) {
            symbolBucket.bucketInstanceId = ++this.maxBucketInstanceId;
        }
        if (layerIndex.addBucket(tile.tileID, symbolBucket, this.crossTileIDs)) {
            symbolBucketsChanged = true;
        }
        currentBucketIDs[symbolBucket.bucketInstanceId] = true;
    }
    if (layerIndex.removeStaleBuckets(currentBucketIDs)) {
        symbolBucketsChanged = true;
    }
    return symbolBucketsChanged;
};
CrossTileSymbolIndex.prototype.pruneUnusedLayers = function pruneUnusedLayers(usedLayers) {
    var usedLayerMap = {};
    usedLayers.forEach(function (usedLayer) {
        usedLayerMap[usedLayer] = true;
    });
    for (var layerId in this.layerIndexes) {
        if (!usedLayerMap[layerId]) {
            delete this.layerIndexes[layerId];
        }
    }
};

var emitValidationErrors = function (evented, errors) {
    return performance.emitValidationErrors(evented, errors && errors.filter(function (error) {
        return error.identifier !== 'source.canvas';
    }));
};
var supportedDiffOperations = performance.pick(operations, [
    'addLayer',
    'removeLayer',
    'setPaintProperty',
    'setLayoutProperty',
    'setFilter',
    'addSource',
    'removeSource',
    'setLayerZoomRange',
    'setLight',
    'setTransition',
    'setGeoJSONSourceData'
]);
var ignoredDiffOperations = performance.pick(operations, [
    'setCenter',
    'setZoom',
    'setBearing',
    'setPitch'
]);
var empty = emptyStyle();
var Style = function (Evented) {
    function Style(map, options) {
        var this$1 = this;
        if (options === void 0)
            options = {};
        Evented.call(this);
        this.map = map;
        this.dispatcher = new Dispatcher(getGlobalWorkerPool(), this);
        this.imageManager = new ImageManager();
        this.imageManager.setEventedParent(this);
        this.glyphManager = new GlyphManager(map._requestManager, options.localIdeographFontFamily);
        this.lineAtlas = new LineAtlas(256, 512);
        this.crossTileSymbolIndex = new CrossTileSymbolIndex();
        this._layers = {};
        this._serializedLayers = {};
        this._order = [];
        this.sourceCaches = {};
        this.zoomHistory = new performance.ZoomHistory();
        this._loaded = false;
        this._availableImages = [];
        this._resetUpdates();
        this.dispatcher.broadcast('setReferrer', performance.getReferrer());
        var self = this;
        this._rtlTextPluginCallback = Style.registerForPluginStateChange(function (event) {
            var state = {
                pluginStatus: event.pluginStatus,
                pluginURL: event.pluginURL
            };
            self.dispatcher.broadcast('syncRTLPluginState', state, function (err, results) {
                performance.triggerPluginCompletionEvent(err);
                if (results) {
                    var allComplete = results.every(function (elem) {
                        return elem;
                    });
                    if (allComplete) {
                        for (var id in self.sourceCaches) {
                            self.sourceCaches[id].reload();
                        }
                    }
                }
            });
        });
        this.on('data', function (event) {
            if (event.dataType !== 'source' || event.sourceDataType !== 'metadata') {
                return;
            }
            var sourceCache = this$1.sourceCaches[event.sourceId];
            if (!sourceCache) {
                return;
            }
            var source = sourceCache.getSource();
            if (!source || !source.vectorLayerIds) {
                return;
            }
            for (var layerId in this$1._layers) {
                var layer = this$1._layers[layerId];
                if (layer.source === source.id) {
                    this$1._validateLayer(layer);
                }
            }
        });
    }
    if (Evented)
        Style.__proto__ = Evented;
    Style.prototype = Object.create(Evented && Evented.prototype);
    Style.prototype.constructor = Style;
    Style.prototype.loadURL = function loadURL(url, options) {
        var this$1 = this;
        if (options === void 0)
            options = {};
        this.fire(new performance.Event('dataloading', { dataType: 'style' }));
        var validate = typeof options.validate === 'boolean' ? options.validate : !performance.isMapboxURL(url);
        url = this.map._requestManager.normalizeStyleURL(url, options.accessToken);
        var request = this.map._requestManager.transformRequest(url, performance.ResourceType.Style);
        this._request = performance.getJSON(request, function (error, json) {
            this$1._request = null;
            if (error) {
                this$1.fire(new performance.ErrorEvent(error));
            } else if (json) {
                this$1._load(json, validate);
            }
        });
    };
    Style.prototype.loadJSON = function loadJSON(json, options) {
        var this$1 = this;
        if (options === void 0)
            options = {};
        this.fire(new performance.Event('dataloading', { dataType: 'style' }));
        this._request = performance.browser.frame(function () {
            this$1._request = null;
            this$1._load(json, options.validate !== false);
        });
    };
    Style.prototype.loadEmpty = function loadEmpty() {
        this.fire(new performance.Event('dataloading', { dataType: 'style' }));
        this._load(empty, false);
    };
    Style.prototype._load = function _load(json, validate) {
        if (validate && emitValidationErrors(this, performance.validateStyle(json))) {
            return;
        }
        this._loaded = true;
        this.stylesheet = json;
        for (var id in json.sources) {
            this.addSource(id, json.sources[id], { validate: false });
        }
        if (json.sprite) {
            this._loadSprite(json.sprite);
        } else {
            this.imageManager.setLoaded(true);
        }
        this.glyphManager.setURL(json.glyphs);
        var layers = derefLayers(this.stylesheet.layers);
        this._order = layers.map(function (layer) {
            return layer.id;
        });
        this._layers = {};
        this._serializedLayers = {};
        for (var i = 0, list = layers; i < list.length; i += 1) {
            var layer = list[i];
            layer = performance.createStyleLayer(layer);
            layer.setEventedParent(this, { layer: { id: layer.id } });
            this._layers[layer.id] = layer;
            this._serializedLayers[layer.id] = layer.serialize();
        }
        this.dispatcher.broadcast('setLayers', this._serializeLayers(this._order));
        this.light = new Light(this.stylesheet.light);
        this.fire(new performance.Event('data', { dataType: 'style' }));
        this.fire(new performance.Event('style.load'));
    };
    Style.prototype._loadSprite = function _loadSprite(url) {
        var this$1 = this;
        this._spriteRequest = loadSprite(url, this.map._requestManager, function (err, images) {
            this$1._spriteRequest = null;
            if (err) {
                this$1.fire(new performance.ErrorEvent(err));
            } else if (images) {
                for (var id in images) {
                    this$1.imageManager.addImage(id, images[id]);
                }
            }
            this$1.imageManager.setLoaded(true);
            this$1._availableImages = this$1.imageManager.listImages();
            this$1.dispatcher.broadcast('setImages', this$1._availableImages);
            this$1.fire(new performance.Event('data', { dataType: 'style' }));
        });
    };
    Style.prototype._validateLayer = function _validateLayer(layer) {
        var sourceCache = this.sourceCaches[layer.source];
        if (!sourceCache) {
            return;
        }
        var sourceLayer = layer.sourceLayer;
        if (!sourceLayer) {
            return;
        }
        var source = sourceCache.getSource();
        if (source.type === 'geojson' || source.vectorLayerIds && source.vectorLayerIds.indexOf(sourceLayer) === -1) {
            this.fire(new performance.ErrorEvent(new Error('Source layer "' + sourceLayer + '" ' + 'does not exist on source "' + source.id + '" ' + 'as specified by style layer "' + layer.id + '"')));
        }
    };
    Style.prototype.loaded = function loaded() {
        if (!this._loaded) {
            return false;
        }
        if (Object.keys(this._updatedSources).length) {
            return false;
        }
        for (var id in this.sourceCaches) {
            if (!this.sourceCaches[id].loaded()) {
                return false;
            }
        }
        if (!this.imageManager.isLoaded()) {
            return false;
        }
        return true;
    };
    Style.prototype._serializeLayers = function _serializeLayers(ids) {
        var serializedLayers = [];
        for (var i = 0, list = ids; i < list.length; i += 1) {
            var id = list[i];
            var layer = this._layers[id];
            if (layer.type !== 'custom') {
                serializedLayers.push(layer.serialize());
            }
        }
        return serializedLayers;
    };
    Style.prototype.hasTransitions = function hasTransitions() {
        if (this.light && this.light.hasTransition()) {
            return true;
        }
        for (var id in this.sourceCaches) {
            if (this.sourceCaches[id].hasTransition()) {
                return true;
            }
        }
        for (var id$1 in this._layers) {
            if (this._layers[id$1].hasTransition()) {
                return true;
            }
        }
        return false;
    };
    Style.prototype._checkLoaded = function _checkLoaded() {
        if (!this._loaded) {
            throw new Error('Style is not done loading');
        }
    };
    Style.prototype.update = function update(parameters) {
        if (!this._loaded) {
            return;
        }
        var changed = this._changed;
        if (this._changed) {
            var updatedIds = Object.keys(this._updatedLayers);
            var removedIds = Object.keys(this._removedLayers);
            if (updatedIds.length || removedIds.length) {
                this._updateWorkerLayers(updatedIds, removedIds);
            }
            for (var id in this._updatedSources) {
                var action = this._updatedSources[id];
                if (action === 'reload') {
                    this._reloadSource(id);
                } else if (action === 'clear') {
                    this._clearSource(id);
                }
            }
            this._updateTilesForChangedImages();
            for (var id$1 in this._updatedPaintProps) {
                this._layers[id$1].updateTransitions(parameters);
            }
            this.light.updateTransitions(parameters);
            this._resetUpdates();
        }
        var sourcesUsedBefore = {};
        for (var sourceId in this.sourceCaches) {
            var sourceCache = this.sourceCaches[sourceId];
            sourcesUsedBefore[sourceId] = sourceCache.used;
            sourceCache.used = false;
        }
        for (var i = 0, list = this._order; i < list.length; i += 1) {
            var layerId = list[i];
            var layer = this._layers[layerId];
            layer.recalculate(parameters, this._availableImages);
            if (!layer.isHidden(parameters.zoom) && layer.source) {
                this.sourceCaches[layer.source].used = true;
            }
        }
        for (var sourceId$1 in sourcesUsedBefore) {
            var sourceCache$1 = this.sourceCaches[sourceId$1];
            if (sourcesUsedBefore[sourceId$1] !== sourceCache$1.used) {
                sourceCache$1.fire(new performance.Event('data', {
                    sourceDataType: 'visibility',
                    dataType: 'source',
                    sourceId: sourceId$1
                }));
            }
        }
        this.light.recalculate(parameters);
        this.z = parameters.zoom;
        if (changed) {
            this.fire(new performance.Event('data', { dataType: 'style' }));
        }
    };
    Style.prototype._updateTilesForChangedImages = function _updateTilesForChangedImages() {
        var changedImages = Object.keys(this._changedImages);
        if (changedImages.length) {
            for (var name in this.sourceCaches) {
                this.sourceCaches[name].reloadTilesForDependencies([
                    'icons',
                    'patterns'
                ], changedImages);
            }
            this._changedImages = {};
        }
    };
    Style.prototype._updateWorkerLayers = function _updateWorkerLayers(updatedIds, removedIds) {
        this.dispatcher.broadcast('updateLayers', {
            layers: this._serializeLayers(updatedIds),
            removedIds: removedIds
        });
    };
    Style.prototype._resetUpdates = function _resetUpdates() {
        this._changed = false;
        this._updatedLayers = {};
        this._removedLayers = {};
        this._updatedSources = {};
        this._updatedPaintProps = {};
        this._changedImages = {};
    };
    Style.prototype.setState = function setState(nextState) {
        var this$1 = this;
        this._checkLoaded();
        if (emitValidationErrors(this, performance.validateStyle(nextState))) {
            return false;
        }
        nextState = performance.clone$1(nextState);
        nextState.layers = derefLayers(nextState.layers);
        var changes = diffStyles(this.serialize(), nextState).filter(function (op) {
            return !(op.command in ignoredDiffOperations);
        });
        if (changes.length === 0) {
            return false;
        }
        var unimplementedOps = changes.filter(function (op) {
            return !(op.command in supportedDiffOperations);
        });
        if (unimplementedOps.length > 0) {
            throw new Error('Unimplemented: ' + unimplementedOps.map(function (op) {
                return op.command;
            }).join(', ') + '.');
        }
        changes.forEach(function (op) {
            if (op.command === 'setTransition') {
                return;
            }
            this$1[op.command].apply(this$1, op.args);
        });
        this.stylesheet = nextState;
        return true;
    };
    Style.prototype.addImage = function addImage(id, image) {
        if (this.getImage(id)) {
            return this.fire(new performance.ErrorEvent(new Error('An image with this name already exists.')));
        }
        this.imageManager.addImage(id, image);
        this._afterImageUpdated(id);
    };
    Style.prototype.updateImage = function updateImage(id, image) {
        this.imageManager.updateImage(id, image);
    };
    Style.prototype.getImage = function getImage(id) {
        return this.imageManager.getImage(id);
    };
    Style.prototype.removeImage = function removeImage(id) {
        if (!this.getImage(id)) {
            return this.fire(new performance.ErrorEvent(new Error('No image with this name exists.')));
        }
        this.imageManager.removeImage(id);
        this._afterImageUpdated(id);
    };
    Style.prototype._afterImageUpdated = function _afterImageUpdated(id) {
        this._availableImages = this.imageManager.listImages();
        this._changedImages[id] = true;
        this._changed = true;
        this.dispatcher.broadcast('setImages', this._availableImages);
        this.fire(new performance.Event('data', { dataType: 'style' }));
    };
    Style.prototype.listImages = function listImages() {
        this._checkLoaded();
        return this.imageManager.listImages();
    };
    Style.prototype.addSource = function addSource(id, source, options) {
        var this$1 = this;
        if (options === void 0)
            options = {};
        this._checkLoaded();
        if (this.sourceCaches[id] !== undefined) {
            throw new Error('There is already a source with this ID');
        }
        if (!source.type) {
            throw new Error('The type property must be defined, but only the following properties were given: ' + Object.keys(source).join(', ') + '.');
        }
        var builtIns = [
            'vector',
            'raster',
            'geojson',
            'video',
            'image'
        ];
        var shouldValidate = builtIns.indexOf(source.type) >= 0;
        if (shouldValidate && this._validate(performance.validateStyle.source, 'sources.' + id, source, null, options)) {
            return;
        }
        if (this.map && this.map._collectResourceTiming) {
            source.collectResourceTiming = true;
        }
        var sourceCache = this.sourceCaches[id] = new SourceCache(id, source, this.dispatcher);
        sourceCache.style = this;
        sourceCache.setEventedParent(this, function () {
            return {
                isSourceLoaded: this$1.loaded(),
                source: sourceCache.serialize(),
                sourceId: id
            };
        });
        sourceCache.onAdd(this.map);
        this._changed = true;
    };
    Style.prototype.removeSource = function removeSource(id) {
        this._checkLoaded();
        if (this.sourceCaches[id] === undefined) {
            throw new Error('There is no source with this ID');
        }
        for (var layerId in this._layers) {
            if (this._layers[layerId].source === id) {
                return this.fire(new performance.ErrorEvent(new Error('Source "' + id + '" cannot be removed while layer "' + layerId + '" is using it.')));
            }
        }
        var sourceCache = this.sourceCaches[id];
        delete this.sourceCaches[id];
        delete this._updatedSources[id];
        sourceCache.fire(new performance.Event('data', {
            sourceDataType: 'metadata',
            dataType: 'source',
            sourceId: id
        }));
        sourceCache.setEventedParent(null);
        sourceCache.clearTiles();
        if (sourceCache.onRemove) {
            sourceCache.onRemove(this.map);
        }
        this._changed = true;
    };
    Style.prototype.setGeoJSONSourceData = function setGeoJSONSourceData(id, data) {
        this._checkLoaded();
        var geojsonSource = this.sourceCaches[id].getSource();
        geojsonSource.setData(data);
        this._changed = true;
    };
    Style.prototype.getSource = function getSource(id) {
        return this.sourceCaches[id] && this.sourceCaches[id].getSource();
    };
    Style.prototype.addLayer = function addLayer(layerObject, before, options) {
        if (options === void 0)
            options = {};
        this._checkLoaded();
        var id = layerObject.id;
        if (this.getLayer(id)) {
            this.fire(new performance.ErrorEvent(new Error('Layer with id "' + id + '" already exists on this map')));
            return;
        }
        var layer;
        if (layerObject.type === 'custom') {
            if (emitValidationErrors(this, performance.validateCustomStyleLayer(layerObject))) {
                return;
            }
            layer = performance.createStyleLayer(layerObject);
        } else {
            if (typeof layerObject.source === 'object') {
                this.addSource(id, layerObject.source);
                layerObject = performance.clone$1(layerObject);
                layerObject = performance.extend(layerObject, { source: id });
            }
            if (this._validate(performance.validateStyle.layer, 'layers.' + id, layerObject, { arrayIndex: -1 }, options)) {
                return;
            }
            layer = performance.createStyleLayer(layerObject);
            this._validateLayer(layer);
            layer.setEventedParent(this, { layer: { id: id } });
            this._serializedLayers[layer.id] = layer.serialize();
        }
        var index = before ? this._order.indexOf(before) : this._order.length;
        if (before && index === -1) {
            this.fire(new performance.ErrorEvent(new Error('Layer with id "' + before + '" does not exist on this map.')));
            return;
        }
        this._order.splice(index, 0, id);
        this._layerOrderChanged = true;
        this._layers[id] = layer;
        if (this._removedLayers[id] && layer.source && layer.type !== 'custom') {
            var removed = this._removedLayers[id];
            delete this._removedLayers[id];
            if (removed.type !== layer.type) {
                this._updatedSources[layer.source] = 'clear';
            } else {
                this._updatedSources[layer.source] = 'reload';
                this.sourceCaches[layer.source].pause();
            }
        }
        this._updateLayer(layer);
        if (layer.onAdd) {
            layer.onAdd(this.map);
        }
    };
    Style.prototype.moveLayer = function moveLayer(id, before) {
        this._checkLoaded();
        this._changed = true;
        var layer = this._layers[id];
        if (!layer) {
            this.fire(new performance.ErrorEvent(new Error('The layer \'' + id + '\' does not exist in the map\'s style and cannot be moved.')));
            return;
        }
        if (id === before) {
            return;
        }
        var index = this._order.indexOf(id);
        this._order.splice(index, 1);
        var newIndex = before ? this._order.indexOf(before) : this._order.length;
        if (before && newIndex === -1) {
            this.fire(new performance.ErrorEvent(new Error('Layer with id "' + before + '" does not exist on this map.')));
            return;
        }
        this._order.splice(newIndex, 0, id);
        this._layerOrderChanged = true;
    };
    Style.prototype.removeLayer = function removeLayer(id) {
        this._checkLoaded();
        var layer = this._layers[id];
        if (!layer) {
            this.fire(new performance.ErrorEvent(new Error('The layer \'' + id + '\' does not exist in the map\'s style and cannot be removed.')));
            return;
        }
        layer.setEventedParent(null);
        var index = this._order.indexOf(id);
        this._order.splice(index, 1);
        this._layerOrderChanged = true;
        this._changed = true;
        this._removedLayers[id] = layer;
        delete this._layers[id];
        delete this._serializedLayers[id];
        delete this._updatedLayers[id];
        delete this._updatedPaintProps[id];
        if (layer.onRemove) {
            layer.onRemove(this.map);
        }
    };
    Style.prototype.getLayer = function getLayer(id) {
        return this._layers[id];
    };
    Style.prototype.hasLayer = function hasLayer(id) {
        return id in this._layers;
    };
    Style.prototype.setLayerZoomRange = function setLayerZoomRange(layerId, minzoom, maxzoom) {
        this._checkLoaded();
        var layer = this.getLayer(layerId);
        if (!layer) {
            this.fire(new performance.ErrorEvent(new Error('The layer \'' + layerId + '\' does not exist in the map\'s style and cannot have zoom extent.')));
            return;
        }
        if (layer.minzoom === minzoom && layer.maxzoom === maxzoom) {
            return;
        }
        if (minzoom != null) {
            layer.minzoom = minzoom;
        }
        if (maxzoom != null) {
            layer.maxzoom = maxzoom;
        }
        this._updateLayer(layer);
    };
    Style.prototype.setFilter = function setFilter(layerId, filter, options) {
        if (options === void 0)
            options = {};
        this._checkLoaded();
        var layer = this.getLayer(layerId);
        if (!layer) {
            this.fire(new performance.ErrorEvent(new Error('The layer \'' + layerId + '\' does not exist in the map\'s style and cannot be filtered.')));
            return;
        }
        if (performance.deepEqual(layer.filter, filter)) {
            return;
        }
        if (filter === null || filter === undefined) {
            layer.filter = undefined;
            this._updateLayer(layer);
            return;
        }
        if (this._validate(performance.validateStyle.filter, 'layers.' + layer.id + '.filter', filter, null, options)) {
            return;
        }
        layer.filter = performance.clone$1(filter);
        this._updateLayer(layer);
    };
    Style.prototype.getFilter = function getFilter(layer) {
        return performance.clone$1(this.getLayer(layer).filter);
    };
    Style.prototype.setLayoutProperty = function setLayoutProperty(layerId, name, value, options) {
        if (options === void 0)
            options = {};
        this._checkLoaded();
        var layer = this.getLayer(layerId);
        if (!layer) {
            this.fire(new performance.ErrorEvent(new Error('The layer \'' + layerId + '\' does not exist in the map\'s style and cannot be styled.')));
            return;
        }
        if (performance.deepEqual(layer.getLayoutProperty(name), value)) {
            return;
        }
        layer.setLayoutProperty(name, value, options);
        this._updateLayer(layer);
    };
    Style.prototype.getLayoutProperty = function getLayoutProperty(layerId, name) {
        var layer = this.getLayer(layerId);
        if (!layer) {
            this.fire(new performance.ErrorEvent(new Error('The layer \'' + layerId + '\' does not exist in the map\'s style.')));
            return;
        }
        return layer.getLayoutProperty(name);
    };
    Style.prototype.setPaintProperty = function setPaintProperty(layerId, name, value, options) {
        if (options === void 0)
            options = {};
        this._checkLoaded();
        var layer = this.getLayer(layerId);
        if (!layer) {
            this.fire(new performance.ErrorEvent(new Error('The layer \'' + layerId + '\' does not exist in the map\'s style and cannot be styled.')));
            return;
        }
        if (performance.deepEqual(layer.getPaintProperty(name), value)) {
            return;
        }
        var requiresRelayout = layer.setPaintProperty(name, value, options);
        if (requiresRelayout) {
            this._updateLayer(layer);
        }
        this._changed = true;
        this._updatedPaintProps[layerId] = true;
    };
    Style.prototype.getPaintProperty = function getPaintProperty(layer, name) {
        return this.getLayer(layer).getPaintProperty(name);
    };
    Style.prototype.setFeatureState = function setFeatureState(target, state) {
        this._checkLoaded();
        var sourceId = target.source;
        var sourceLayer = target.sourceLayer;
        var sourceCache = this.sourceCaches[sourceId];
        if (sourceCache === undefined) {
            this.fire(new performance.ErrorEvent(new Error('The source \'' + sourceId + '\' does not exist in the map\'s style.')));
            return;
        }
        var sourceType = sourceCache.getSource().type;
        if (sourceType === 'geojson' && sourceLayer) {
            this.fire(new performance.ErrorEvent(new Error('GeoJSON sources cannot have a sourceLayer parameter.')));
            return;
        }
        if (sourceType === 'vector' && !sourceLayer) {
            this.fire(new performance.ErrorEvent(new Error('The sourceLayer parameter must be provided for vector source types.')));
            return;
        }
        if (target.id === undefined) {
            this.fire(new performance.ErrorEvent(new Error('The feature id parameter must be provided.')));
        }
        sourceCache.setFeatureState(sourceLayer, target.id, state);
    };
    Style.prototype.removeFeatureState = function removeFeatureState(target, key) {
        this._checkLoaded();
        var sourceId = target.source;
        var sourceCache = this.sourceCaches[sourceId];
        if (sourceCache === undefined) {
            this.fire(new performance.ErrorEvent(new Error('The source \'' + sourceId + '\' does not exist in the map\'s style.')));
            return;
        }
        var sourceType = sourceCache.getSource().type;
        var sourceLayer = sourceType === 'vector' ? target.sourceLayer : undefined;
        if (sourceType === 'vector' && !sourceLayer) {
            this.fire(new performance.ErrorEvent(new Error('The sourceLayer parameter must be provided for vector source types.')));
            return;
        }
        if (key && (typeof target.id !== 'string' && typeof target.id !== 'number')) {
            this.fire(new performance.ErrorEvent(new Error('A feature id is required to remove its specific state property.')));
            return;
        }
        sourceCache.removeFeatureState(sourceLayer, target.id, key);
    };
    Style.prototype.getFeatureState = function getFeatureState(target) {
        this._checkLoaded();
        var sourceId = target.source;
        var sourceLayer = target.sourceLayer;
        var sourceCache = this.sourceCaches[sourceId];
        if (sourceCache === undefined) {
            this.fire(new performance.ErrorEvent(new Error('The source \'' + sourceId + '\' does not exist in the map\'s style.')));
            return;
        }
        var sourceType = sourceCache.getSource().type;
        if (sourceType === 'vector' && !sourceLayer) {
            this.fire(new performance.ErrorEvent(new Error('The sourceLayer parameter must be provided for vector source types.')));
            return;
        }
        if (target.id === undefined) {
            this.fire(new performance.ErrorEvent(new Error('The feature id parameter must be provided.')));
        }
        return sourceCache.getFeatureState(sourceLayer, target.id);
    };
    Style.prototype.getTransition = function getTransition() {
        return performance.extend({
            duration: 300,
            delay: 0
        }, this.stylesheet && this.stylesheet.transition);
    };
    Style.prototype.serialize = function serialize() {
        return performance.filterObject({
            version: this.stylesheet.version,
            name: this.stylesheet.name,
            metadata: this.stylesheet.metadata,
            light: this.stylesheet.light,
            center: this.stylesheet.center,
            zoom: this.stylesheet.zoom,
            bearing: this.stylesheet.bearing,
            pitch: this.stylesheet.pitch,
            sprite: this.stylesheet.sprite,
            glyphs: this.stylesheet.glyphs,
            transition: this.stylesheet.transition,
            sources: performance.mapObject(this.sourceCaches, function (source) {
                return source.serialize();
            }),
            layers: this._serializeLayers(this._order)
        }, function (value) {
            return value !== undefined;
        });
    };
    Style.prototype._updateLayer = function _updateLayer(layer) {
        this._updatedLayers[layer.id] = true;
        if (layer.source && !this._updatedSources[layer.source] && this.sourceCaches[layer.source].getSource().type !== 'raster') {
            this._updatedSources[layer.source] = 'reload';
            this.sourceCaches[layer.source].pause();
        }
        this._changed = true;
    };
    Style.prototype._flattenAndSortRenderedFeatures = function _flattenAndSortRenderedFeatures(sourceResults) {
        var this$1 = this;
        var isLayer3D = function (layerId) {
            return this$1._layers[layerId].type === 'fill-extrusion';
        };
        var layerIndex = {};
        var features3D = [];
        for (var l = this._order.length - 1; l >= 0; l--) {
            var layerId = this._order[l];
            if (isLayer3D(layerId)) {
                layerIndex[layerId] = l;
                for (var i$2 = 0, list$1 = sourceResults; i$2 < list$1.length; i$2 += 1) {
                    var sourceResult = list$1[i$2];
                    var layerFeatures = sourceResult[layerId];
                    if (layerFeatures) {
                        for (var i$1 = 0, list = layerFeatures; i$1 < list.length; i$1 += 1) {
                            var featureWrapper = list[i$1];
                            features3D.push(featureWrapper);
                        }
                    }
                }
            }
        }
        features3D.sort(function (a, b) {
            return b.intersectionZ - a.intersectionZ;
        });
        var features = [];
        for (var l$1 = this._order.length - 1; l$1 >= 0; l$1--) {
            var layerId$1 = this._order[l$1];
            if (isLayer3D(layerId$1)) {
                for (var i = features3D.length - 1; i >= 0; i--) {
                    var topmost3D = features3D[i].feature;
                    if (layerIndex[topmost3D.layer.id] < l$1) {
                        break;
                    }
                    features.push(topmost3D);
                    features3D.pop();
                }
            } else {
                for (var i$4 = 0, list$3 = sourceResults; i$4 < list$3.length; i$4 += 1) {
                    var sourceResult$1 = list$3[i$4];
                    var layerFeatures$1 = sourceResult$1[layerId$1];
                    if (layerFeatures$1) {
                        for (var i$3 = 0, list$2 = layerFeatures$1; i$3 < list$2.length; i$3 += 1) {
                            var featureWrapper$1 = list$2[i$3];
                            features.push(featureWrapper$1.feature);
                        }
                    }
                }
            }
        }
        return features;
    };
    Style.prototype.queryRenderedFeatures = function queryRenderedFeatures$1(queryGeometry, params, transform) {
        if (params && params.filter) {
            this._validate(performance.validateStyle.filter, 'queryRenderedFeatures.filter', params.filter, null, params);
        }
        var includedSources = {};
        if (params && params.layers) {
            if (!Array.isArray(params.layers)) {
                this.fire(new performance.ErrorEvent(new Error('parameters.layers must be an Array.')));
                return [];
            }
            for (var i = 0, list = params.layers; i < list.length; i += 1) {
                var layerId = list[i];
                var layer = this._layers[layerId];
                if (!layer) {
                    this.fire(new performance.ErrorEvent(new Error('The layer \'' + layerId + '\' does not exist in the map\'s style and cannot be queried for features.')));
                    return [];
                }
                includedSources[layer.source] = true;
            }
        }
        var sourceResults = [];
        params.availableImages = this._availableImages;
        for (var id in this.sourceCaches) {
            if (params.layers && !includedSources[id]) {
                continue;
            }
            sourceResults.push(queryRenderedFeatures(this.sourceCaches[id], this._layers, this._serializedLayers, queryGeometry, params, transform));
        }
        if (this.placement) {
            sourceResults.push(queryRenderedSymbols(this._layers, this._serializedLayers, this.sourceCaches, queryGeometry, params, this.placement.collisionIndex, this.placement.retainedQueryData));
        }
        return this._flattenAndSortRenderedFeatures(sourceResults);
    };
    Style.prototype.querySourceFeatures = function querySourceFeatures$1(sourceID, params) {
        if (params && params.filter) {
            this._validate(performance.validateStyle.filter, 'querySourceFeatures.filter', params.filter, null, params);
        }
        var sourceCache = this.sourceCaches[sourceID];
        return sourceCache ? querySourceFeatures(sourceCache, params) : [];
    };
    Style.prototype.addSourceType = function addSourceType(name, SourceType, callback) {
        if (Style.getSourceType(name)) {
            return callback(new Error('A source type called "' + name + '" already exists.'));
        }
        Style.setSourceType(name, SourceType);
        if (!SourceType.workerSourceURL) {
            return callback(null, null);
        }
        this.dispatcher.broadcast('loadWorkerSource', {
            name: name,
            url: SourceType.workerSourceURL
        }, callback);
    };
    Style.prototype.getLight = function getLight() {
        return this.light.getLight();
    };
    Style.prototype.setLight = function setLight(lightOptions, options) {
        if (options === void 0)
            options = {};
        this._checkLoaded();
        var light = this.light.getLight();
        var _update = false;
        for (var key in lightOptions) {
            if (!performance.deepEqual(lightOptions[key], light[key])) {
                _update = true;
                break;
            }
        }
        if (!_update) {
            return;
        }
        var parameters = {
            now: performance.browser.now(),
            transition: performance.extend({
                duration: 300,
                delay: 0
            }, this.stylesheet.transition)
        };
        this.light.setLight(lightOptions, options);
        this.light.updateTransitions(parameters);
    };
    Style.prototype._validate = function _validate(validate, key, value, props, options) {
        if (options === void 0)
            options = {};
        if (options && options.validate === false) {
            return false;
        }
        return emitValidationErrors(this, validate.call(performance.validateStyle, performance.extend({
            key: key,
            style: this.serialize(),
            value: value,
            styleSpec: performance.styleSpec
        }, props)));
    };
    Style.prototype._remove = function _remove() {
        if (this._request) {
            this._request.cancel();
            this._request = null;
        }
        if (this._spriteRequest) {
            this._spriteRequest.cancel();
            this._spriteRequest = null;
        }
        performance.evented.off('pluginStateChange', this._rtlTextPluginCallback);
        for (var layerId in this._layers) {
            var layer = this._layers[layerId];
            layer.setEventedParent(null);
        }
        for (var id in this.sourceCaches) {
            this.sourceCaches[id].clearTiles();
            this.sourceCaches[id].setEventedParent(null);
        }
        this.imageManager.setEventedParent(null);
        this.setEventedParent(null);
        this.dispatcher.remove();
    };
    Style.prototype._clearSource = function _clearSource(id) {
        this.sourceCaches[id].clearTiles();
    };
    Style.prototype._reloadSource = function _reloadSource(id) {
        this.sourceCaches[id].resume();
        this.sourceCaches[id].reload();
    };
    Style.prototype._updateSources = function _updateSources(transform) {
        for (var id in this.sourceCaches) {
            this.sourceCaches[id].update(transform);
        }
    };
    Style.prototype._generateCollisionBoxes = function _generateCollisionBoxes() {
        for (var id in this.sourceCaches) {
            this._reloadSource(id);
        }
    };
    Style.prototype._updatePlacement = function _updatePlacement(transform, showCollisionBoxes, fadeDuration, crossSourceCollisions, forceFullPlacement) {
        if (forceFullPlacement === void 0)
            forceFullPlacement = false;
        var symbolBucketsChanged = false;
        var placementCommitted = false;
        var layerTiles = {};
        for (var i = 0, list = this._order; i < list.length; i += 1) {
            var layerID = list[i];
            var styleLayer = this._layers[layerID];
            if (styleLayer.type !== 'symbol') {
                continue;
            }
            if (!layerTiles[styleLayer.source]) {
                var sourceCache = this.sourceCaches[styleLayer.source];
                layerTiles[styleLayer.source] = sourceCache.getRenderableIds(true).map(function (id) {
                    return sourceCache.getTileByID(id);
                }).sort(function (a, b) {
                    return b.tileID.overscaledZ - a.tileID.overscaledZ || (a.tileID.isLessThan(b.tileID) ? -1 : 1);
                });
            }
            var layerBucketsChanged = this.crossTileSymbolIndex.addLayer(styleLayer, layerTiles[styleLayer.source], transform.center.lng);
            symbolBucketsChanged = symbolBucketsChanged || layerBucketsChanged;
        }
        this.crossTileSymbolIndex.pruneUnusedLayers(this._order);
        forceFullPlacement = forceFullPlacement || this._layerOrderChanged || fadeDuration === 0;
        if (forceFullPlacement || !this.pauseablePlacement || this.pauseablePlacement.isDone() && !this.placement.stillRecent(performance.browser.now(), transform.zoom)) {
            this.pauseablePlacement = new PauseablePlacement(transform, this._order, forceFullPlacement, showCollisionBoxes, fadeDuration, crossSourceCollisions, this.placement);
            this._layerOrderChanged = false;
        }
        if (this.pauseablePlacement.isDone()) {
            this.placement.setStale();
        } else {
            this.pauseablePlacement.continuePlacement(this._order, this._layers, layerTiles);
            if (this.pauseablePlacement.isDone()) {
                this.placement = this.pauseablePlacement.commit(performance.browser.now());
                placementCommitted = true;
            }
            if (symbolBucketsChanged) {
                this.pauseablePlacement.placement.setStale();
            }
        }
        if (placementCommitted || symbolBucketsChanged) {
            for (var i$1 = 0, list$1 = this._order; i$1 < list$1.length; i$1 += 1) {
                var layerID$1 = list$1[i$1];
                var styleLayer$1 = this._layers[layerID$1];
                if (styleLayer$1.type !== 'symbol') {
                    continue;
                }
                this.placement.updateLayerOpacities(styleLayer$1, layerTiles[styleLayer$1.source]);
            }
        }
        var needsRerender = !this.pauseablePlacement.isDone() || this.placement.hasTransitions(performance.browser.now());
        return needsRerender;
    };
    Style.prototype._releaseSymbolFadeTiles = function _releaseSymbolFadeTiles() {
        for (var id in this.sourceCaches) {
            this.sourceCaches[id].releaseSymbolFadeTiles();
        }
    };
    Style.prototype.getImages = function getImages(mapId, params, callback) {
        this.imageManager.getImages(params.icons, callback);
        this._updateTilesForChangedImages();
        var sourceCache = this.sourceCaches[params.source];
        if (sourceCache) {
            sourceCache.setDependencies(params.tileID.key, params.type, params.icons);
        }
    };
    Style.prototype.getGlyphs = function getGlyphs(mapId, params, callback) {
        this.glyphManager.getGlyphs(params.stacks, callback);
    };
    Style.prototype.getResource = function getResource(mapId, params, callback) {
        return performance.makeRequest(params, callback);
    };
    return Style;
}(performance.Evented);
Style.getSourceType = getType;
Style.setSourceType = setType;
Style.registerForPluginStateChange = performance.registerForPluginStateChange;

var posAttributes = performance.createLayout([{
        name: 'a_pos',
        type: 'Int16',
        components: 2
    }]);

var preludeFrag = "#ifdef GL_ES\nprecision mediump float;\n#else\n#if !defined(lowp)\n#define lowp\n#endif\n#if !defined(mediump)\n#define mediump\n#endif\n#if !defined(highp)\n#define highp\n#endif\n#endif";

var preludeVert = "#ifdef GL_ES\nprecision highp float;\n#else\n#if !defined(lowp)\n#define lowp\n#endif\n#if !defined(mediump)\n#define mediump\n#endif\n#if !defined(highp)\n#define highp\n#endif\n#endif\nvec2 unpack_float(const float packedValue) {int packedIntValue=int(packedValue);int v0=packedIntValue/256;return vec2(v0,packedIntValue-v0*256);}vec2 unpack_opacity(const float packedOpacity) {int intOpacity=int(packedOpacity)/2;return vec2(float(intOpacity)/127.0,mod(packedOpacity,2.0));}vec4 decode_color(const vec2 encodedColor) {return vec4(unpack_float(encodedColor[0])/255.0,unpack_float(encodedColor[1])/255.0\n);}float unpack_mix_vec2(const vec2 packedValue,const float t) {return mix(packedValue[0],packedValue[1],t);}vec4 unpack_mix_color(const vec4 packedColors,const float t) {vec4 minColor=decode_color(vec2(packedColors[0],packedColors[1]));vec4 maxColor=decode_color(vec2(packedColors[2],packedColors[3]));return mix(minColor,maxColor,t);}vec2 get_pattern_pos(const vec2 pixel_coord_upper,const vec2 pixel_coord_lower,const vec2 pattern_size,const float tile_units_to_pixels,const vec2 pos) {vec2 offset=mod(mod(mod(pixel_coord_upper,pattern_size)*256.0,pattern_size)*256.0+pixel_coord_lower,pattern_size);return (tile_units_to_pixels*pos+offset)/pattern_size;}";

var backgroundFrag = "uniform vec4 u_color;uniform float u_opacity;void main() {gl_FragColor=u_color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}";

var backgroundVert = "attribute vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}";

var backgroundPatternFrag = "uniform vec2 u_pattern_tl_a;uniform vec2 u_pattern_br_a;uniform vec2 u_pattern_tl_b;uniform vec2 u_pattern_br_b;uniform vec2 u_texsize;uniform float u_mix;uniform float u_opacity;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;void main() {vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(u_pattern_tl_a/u_texsize,u_pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(u_pattern_tl_b/u_texsize,u_pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);gl_FragColor=mix(color1,color2,u_mix)*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}";

var backgroundPatternVert = "uniform mat4 u_matrix;uniform vec2 u_pattern_size_a;uniform vec2 u_pattern_size_b;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_scale_a;uniform float u_scale_b;uniform float u_tile_units_to_pixels;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_a*u_pattern_size_a,u_tile_units_to_pixels,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_b*u_pattern_size_b,u_tile_units_to_pixels,a_pos);}";

var circleFrag = "varying vec3 v_data;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=v_data.xy;float extrude_length=length(extrude);lowp float antialiasblur=v_data.z;float antialiased_blur=-max(blur,antialiasblur);float opacity_t=smoothstep(0.0,antialiased_blur,extrude_length-1.0);float color_t=stroke_width < 0.01 ? 0.0 : smoothstep(antialiased_blur,0.0,extrude_length-radius/(radius+stroke_width));gl_FragColor=opacity_t*mix(color*opacity,stroke_color*stroke_opacity,color_t);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}";

var circleVert = "uniform mat4 u_matrix;uniform bool u_scale_with_map;uniform bool u_pitch_with_map;uniform vec2 u_extrude_scale;uniform lowp float u_device_pixel_ratio;uniform highp float u_camera_to_center_distance;attribute vec2 a_pos;varying vec3 v_data;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvoid main(void) {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=vec2(mod(a_pos,2.0)*2.0-1.0);vec2 circle_center=floor(a_pos*0.5);if (u_pitch_with_map) {vec2 corner_position=circle_center;if (u_scale_with_map) {corner_position+=extrude*(radius+stroke_width)*u_extrude_scale;} else {vec4 projected_center=u_matrix*vec4(circle_center,0,1);corner_position+=extrude*(radius+stroke_width)*u_extrude_scale*(projected_center.w/u_camera_to_center_distance);}gl_Position=u_matrix*vec4(corner_position,0,1);} else {gl_Position=u_matrix*vec4(circle_center,0,1);if (u_scale_with_map) {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*u_camera_to_center_distance;} else {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*gl_Position.w;}}lowp float antialiasblur=1.0/u_device_pixel_ratio/(radius+stroke_width);v_data=vec3(extrude.x,extrude.y,antialiasblur);}";

var clippingMaskFrag = "void main() {gl_FragColor=vec4(1.0);}";

var clippingMaskVert = "attribute vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}";

var heatmapFrag = "uniform highp float u_intensity;varying vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#define GAUSS_COEF 0.3989422804014327\nvoid main() {\n#pragma mapbox: initialize highp float weight\nfloat d=-0.5*3.0*3.0*dot(v_extrude,v_extrude);float val=weight*u_intensity*GAUSS_COEF*exp(d);gl_FragColor=vec4(val,1.0,1.0,1.0);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}";

var heatmapVert = "uniform mat4 u_matrix;uniform float u_extrude_scale;uniform float u_opacity;uniform float u_intensity;attribute vec2 a_pos;varying vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#pragma mapbox: define mediump float radius\nconst highp float ZERO=1.0/255.0/16.0;\n#define GAUSS_COEF 0.3989422804014327\nvoid main(void) {\n#pragma mapbox: initialize highp float weight\n#pragma mapbox: initialize mediump float radius\nvec2 unscaled_extrude=vec2(mod(a_pos,2.0)*2.0-1.0);float S=sqrt(-2.0*log(ZERO/weight/u_intensity/GAUSS_COEF))/3.0;v_extrude=S*unscaled_extrude;vec2 extrude=v_extrude*radius*u_extrude_scale;vec4 pos=vec4(floor(a_pos*0.5)+extrude,0,1);gl_Position=u_matrix*pos;}";

var heatmapTextureFrag = "uniform sampler2D u_image;uniform sampler2D u_color_ramp;uniform float u_opacity;varying vec2 v_pos;void main() {float t=texture2D(u_image,v_pos).r;vec4 color=texture2D(u_color_ramp,vec2(t,0.5));gl_FragColor=color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(0.0);\n#endif\n}";

var heatmapTextureVert = "uniform mat4 u_matrix;uniform vec2 u_world;attribute vec2 a_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos*u_world,0,1);v_pos.x=a_pos.x;v_pos.y=1.0-a_pos.y;}";

var collisionBoxFrag = "varying float v_placed;varying float v_notUsed;void main() {float alpha=0.5;gl_FragColor=vec4(1.0,0.0,0.0,1.0)*alpha;if (v_placed > 0.5) {gl_FragColor=vec4(0.0,0.0,1.0,0.5)*alpha;}if (v_notUsed > 0.5) {gl_FragColor*=.1;}}";

var collisionBoxVert = "attribute vec2 a_pos;attribute vec2 a_anchor_pos;attribute vec2 a_extrude;attribute vec2 a_placed;attribute vec2 a_shift;uniform mat4 u_matrix;uniform vec2 u_extrude_scale;uniform float u_camera_to_center_distance;varying float v_placed;varying float v_notUsed;void main() {vec4 projectedPoint=u_matrix*vec4(a_anchor_pos,0,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float collision_perspective_ratio=clamp(0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,4.0);gl_Position=u_matrix*vec4(a_pos,0.0,1.0);gl_Position.xy+=(a_extrude+a_shift)*u_extrude_scale*gl_Position.w*collision_perspective_ratio;v_placed=a_placed.x;v_notUsed=a_placed.y;}";

var collisionCircleFrag = "varying float v_radius;varying vec2 v_extrude;varying float v_perspective_ratio;varying float v_collision;void main() {float alpha=0.5*min(v_perspective_ratio,1.0);float stroke_radius=0.9*max(v_perspective_ratio,1.0);float distance_to_center=length(v_extrude);float distance_to_edge=abs(distance_to_center-v_radius);float opacity_t=smoothstep(-stroke_radius,0.0,-distance_to_edge);vec4 color=mix(vec4(0.0,0.0,1.0,0.5),vec4(1.0,0.0,0.0,1.0),v_collision);gl_FragColor=color*alpha*opacity_t;}";

var collisionCircleVert = "attribute vec2 a_pos;attribute float a_radius;attribute vec2 a_flags;uniform mat4 u_matrix;uniform mat4 u_inv_matrix;uniform vec2 u_viewport_size;uniform float u_camera_to_center_distance;varying float v_radius;varying vec2 v_extrude;varying float v_perspective_ratio;varying float v_collision;vec3 toTilePosition(vec2 screenPos) {vec4 rayStart=u_inv_matrix*vec4(screenPos,-1.0,1.0);vec4 rayEnd  =u_inv_matrix*vec4(screenPos, 1.0,1.0);rayStart.xyz/=rayStart.w;rayEnd.xyz  /=rayEnd.w;highp float t=(0.0-rayStart.z)/(rayEnd.z-rayStart.z);return mix(rayStart.xyz,rayEnd.xyz,t);}void main() {vec2 quadCenterPos=a_pos;float radius=a_radius;float collision=a_flags.x;float vertexIdx=a_flags.y;vec2 quadVertexOffset=vec2(mix(-1.0,1.0,float(vertexIdx >=2.0)),mix(-1.0,1.0,float(vertexIdx >=1.0 && vertexIdx <=2.0)));vec2 quadVertexExtent=quadVertexOffset*radius;vec3 tilePos=toTilePosition(quadCenterPos);vec4 clipPos=u_matrix*vec4(tilePos,1.0);highp float camera_to_anchor_distance=clipPos.w;highp float collision_perspective_ratio=clamp(0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,4.0);float padding_factor=1.2;v_radius=radius;v_extrude=quadVertexExtent*padding_factor;v_perspective_ratio=collision_perspective_ratio;v_collision=collision;gl_Position=vec4(clipPos.xyz/clipPos.w,1.0)+vec4(quadVertexExtent*padding_factor/u_viewport_size*2.0,0.0,0.0);}";

var debugFrag = "uniform highp vec4 u_color;uniform sampler2D u_overlay;varying vec2 v_uv;void main() {vec4 overlay_color=texture2D(u_overlay,v_uv);gl_FragColor=mix(u_color,overlay_color,overlay_color.a);}";

var debugVert = "attribute vec2 a_pos;varying vec2 v_uv;uniform mat4 u_matrix;uniform float u_overlay_scale;void main() {v_uv=a_pos/8192.0;gl_Position=u_matrix*vec4(a_pos*u_overlay_scale,0,1);}";

var fillFrag = "#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\ngl_FragColor=color*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}";

var fillVert = "attribute vec2 a_pos;uniform mat4 u_matrix;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=u_matrix*vec4(a_pos,0,1);}";

var fillOutlineFrag = "varying vec2 v_pos;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);gl_FragColor=outline_color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}";

var fillOutlineVert = "attribute vec2 a_pos;uniform mat4 u_matrix;uniform vec2 u_world;varying vec2 v_pos;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=u_matrix*vec4(a_pos,0,1);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;}";

var fillOutlinePatternFrag = "uniform vec2 u_texsize;uniform sampler2D u_image;uniform float u_fade;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec2 v_pos;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);float dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);gl_FragColor=mix(color1,color2,u_fade)*alpha*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}";

var fillOutlinePatternVert = "uniform mat4 u_matrix;uniform vec2 u_world;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec2 v_pos;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;gl_Position=u_matrix*vec4(a_pos,0,1);vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,a_pos);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;}";

var fillPatternFrag = "uniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);gl_FragColor=mix(color1,color2,u_fade)*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}";

var fillPatternVert = "uniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;gl_Position=u_matrix*vec4(a_pos,0,1);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileZoomRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileZoomRatio,a_pos);}";

var fillExtrusionFrag = "varying vec4 v_color;void main() {gl_FragColor=v_color;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}";

var fillExtrusionVert = "uniform mat4 u_matrix;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;uniform float u_vertical_gradient;uniform lowp float u_opacity;attribute vec2 a_pos;attribute vec4 a_normal_ed;varying vec4 v_color;\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define highp vec4 color\nvoid main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize highp vec4 color\nvec3 normal=a_normal_ed.xyz;base=max(0.0,base);height=max(0.0,height);float t=mod(normal.x,2.0);gl_Position=u_matrix*vec4(a_pos,t > 0.0 ? height : base,1);float colorvalue=color.r*0.2126+color.g*0.7152+color.b*0.0722;v_color=vec4(0.0,0.0,0.0,1.0);vec4 ambientlight=vec4(0.03,0.03,0.03,1.0);color+=ambientlight;float directional=clamp(dot(normal/16384.0,u_lightpos),0.0,1.0);directional=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_color.r+=clamp(color.r*directional*u_lightcolor.r,mix(0.0,0.3,1.0-u_lightcolor.r),1.0);v_color.g+=clamp(color.g*directional*u_lightcolor.g,mix(0.0,0.3,1.0-u_lightcolor.g),1.0);v_color.b+=clamp(color.b*directional*u_lightcolor.b,mix(0.0,0.3,1.0-u_lightcolor.b),1.0);v_color*=u_opacity;}";

var fillExtrusionPatternFrag = "uniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec4 v_lighting;\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float base\n#pragma mapbox: initialize lowp float height\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);vec4 mixedColor=mix(color1,color2,u_fade);gl_FragColor=mixedColor*v_lighting;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}";

var fillExtrusionPatternVert = "uniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_height_factor;uniform vec3 u_scale;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;attribute vec2 a_pos;attribute vec4 a_normal_ed;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec4 v_lighting;\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float base\n#pragma mapbox: initialize lowp float height\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec3 normal=a_normal_ed.xyz;float edgedistance=a_normal_ed.w;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;base=max(0.0,base);height=max(0.0,height);float t=mod(normal.x,2.0);float z=t > 0.0 ? height : base;gl_Position=u_matrix*vec4(a_pos,z,1);vec2 pos=normal.x==1.0 && normal.y==0.0 && normal.z==16384.0\n? a_pos\n: vec2(edgedistance,z*u_height_factor);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,pos);v_lighting=vec4(0.0,0.0,0.0,1.0);float directional=clamp(dot(normal/16383.0,u_lightpos),0.0,1.0);directional=mix((1.0-u_lightintensity),max((0.5+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_lighting.rgb+=clamp(directional*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_lighting*=u_opacity;}";

var hillshadePrepareFrag = "#ifdef GL_ES\nprecision highp float;\n#endif\nuniform sampler2D u_image;varying vec2 v_pos;uniform vec2 u_dimension;uniform float u_zoom;uniform vec4 u_unpack;float getElevation(vec2 coord,float bias) {vec4 data=texture2D(u_image,coord)*255.0;data.a=-1.0;return dot(data,u_unpack)/4.0;}void main() {vec2 epsilon=1.0/u_dimension;float a=getElevation(v_pos+vec2(-epsilon.x,-epsilon.y),0.0);float b=getElevation(v_pos+vec2(0,-epsilon.y),0.0);float c=getElevation(v_pos+vec2(epsilon.x,-epsilon.y),0.0);float d=getElevation(v_pos+vec2(-epsilon.x,0),0.0);float e=getElevation(v_pos,0.0);float f=getElevation(v_pos+vec2(epsilon.x,0),0.0);float g=getElevation(v_pos+vec2(-epsilon.x,epsilon.y),0.0);float h=getElevation(v_pos+vec2(0,epsilon.y),0.0);float i=getElevation(v_pos+vec2(epsilon.x,epsilon.y),0.0);float exaggerationFactor=u_zoom < 2.0 ? 0.4 : u_zoom < 4.5 ? 0.35 : 0.3;float exaggeration=u_zoom < 15.0 ? (u_zoom-15.0)*exaggerationFactor : 0.0;vec2 deriv=vec2((c+f+f+i)-(a+d+d+g),(g+h+h+i)-(a+b+b+c))/pow(2.0,exaggeration+(19.2562-u_zoom));gl_FragColor=clamp(vec4(deriv.x/2.0+0.5,deriv.y/2.0+0.5,1.0,1.0),0.0,1.0);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}";

var hillshadePrepareVert = "uniform mat4 u_matrix;uniform vec2 u_dimension;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);highp vec2 epsilon=1.0/u_dimension;float scale=(u_dimension.x-2.0)/u_dimension.x;v_pos=(a_texture_pos/8192.0)*scale+epsilon;}";

var hillshadeFrag = "uniform sampler2D u_image;varying vec2 v_pos;uniform vec2 u_latrange;uniform vec2 u_light;uniform vec4 u_shadow;uniform vec4 u_highlight;uniform vec4 u_accent;\n#define PI 3.141592653589793\nvoid main() {vec4 pixel=texture2D(u_image,v_pos);vec2 deriv=((pixel.rg*2.0)-1.0);float scaleFactor=cos(radians((u_latrange[0]-u_latrange[1])*(1.0-v_pos.y)+u_latrange[1]));float slope=atan(1.25*length(deriv)/scaleFactor);float aspect=deriv.x !=0.0 ? atan(deriv.y,-deriv.x) : PI/2.0*(deriv.y > 0.0 ? 1.0 :-1.0);float intensity=u_light.x;float azimuth=u_light.y+PI;float base=1.875-intensity*1.75;float maxValue=0.5*PI;float scaledSlope=intensity !=0.5 ? ((pow(base,slope)-1.0)/(pow(base,maxValue)-1.0))*maxValue : slope;float accent=cos(scaledSlope);vec4 accent_color=(1.0-accent)*u_accent*clamp(intensity*2.0,0.0,1.0);float shade=abs(mod((aspect+azimuth)/PI+0.5,2.0)-1.0);vec4 shade_color=mix(u_shadow,u_highlight,shade)*sin(scaledSlope)*clamp(intensity*2.0,0.0,1.0);gl_FragColor=accent_color*(1.0-shade_color.a)+shade_color;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}";

var hillshadeVert = "uniform mat4 u_matrix;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos=a_texture_pos/8192.0;}";

var lineFrag = "uniform lowp float u_device_pixel_ratio;varying vec2 v_width2;varying vec2 v_normal;varying float v_gamma_scale;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);gl_FragColor=color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}";

var lineVert = "\n#define scale 0.015873016\nattribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform vec2 u_units_to_pixels;uniform lowp float u_device_pixel_ratio;varying vec2 v_normal;varying vec2 v_width2;varying float v_gamma_scale;varying highp float v_linesofar;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;v_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*2.0;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;v_width2=vec2(outset,inset);}";

var lineGradientFrag = "uniform lowp float u_device_pixel_ratio;uniform sampler2D u_image;varying vec2 v_width2;varying vec2 v_normal;varying float v_gamma_scale;varying highp vec2 v_uv;\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);vec4 color=texture2D(u_image,v_uv);gl_FragColor=color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}";

var lineGradientVert = "\n#define scale 0.015873016\nattribute vec2 a_pos_normal;attribute vec4 a_data;attribute float a_uv_x;attribute float a_split_index;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;uniform vec2 u_units_to_pixels;uniform float u_image_height;varying vec2 v_normal;varying vec2 v_width2;varying float v_gamma_scale;varying highp vec2 v_uv;\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;highp float texel_height=1.0/u_image_height;highp float half_texel_height=0.5*texel_height;v_uv=vec2(a_uv_x,a_split_index*texel_height-half_texel_height);vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;v_width2=vec2(outset,inset);}";

var linePatternFrag = "uniform lowp float u_device_pixel_ratio;uniform vec2 u_texsize;uniform float u_fade;uniform mediump vec3 u_scale;uniform sampler2D u_image;varying vec2 v_normal;varying vec2 v_width2;varying float v_linesofar;varying float v_gamma_scale;varying float v_width;\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;vec2 pattern_size_a=vec2(display_size_a.x*fromScale/tileZoomRatio,display_size_a.y);vec2 pattern_size_b=vec2(display_size_b.x*toScale/tileZoomRatio,display_size_b.y);float aspect_a=display_size_a.y/v_width;float aspect_b=display_size_b.y/v_width;float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float x_a=mod(v_linesofar/pattern_size_a.x*aspect_a,1.0);float x_b=mod(v_linesofar/pattern_size_b.x*aspect_b,1.0);float y=0.5*v_normal.y+0.5;vec2 texel_size=1.0/u_texsize;vec2 pos_a=mix(pattern_tl_a*texel_size-texel_size,pattern_br_a*texel_size+texel_size,vec2(x_a,y));vec2 pos_b=mix(pattern_tl_b*texel_size-texel_size,pattern_br_b*texel_size+texel_size,vec2(x_b,y));vec4 color=mix(texture2D(u_image,pos_a),texture2D(u_image,pos_b),u_fade);gl_FragColor=color*alpha*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}";

var linePatternVert = "\n#define scale 0.015873016\n#define LINE_DISTANCE_SCALE 2.0\nattribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform vec2 u_units_to_pixels;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;varying vec2 v_normal;varying vec2 v_width2;varying float v_linesofar;varying float v_gamma_scale;varying float v_width;\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;v_linesofar=a_linesofar;v_width2=vec2(outset,inset);v_width=floorwidth;}";

var lineSDFFrag = "uniform lowp float u_device_pixel_ratio;uniform sampler2D u_image;uniform float u_sdfgamma;uniform float u_mix;varying vec2 v_normal;varying vec2 v_width2;varying vec2 v_tex_a;varying vec2 v_tex_b;varying float v_gamma_scale;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float sdfdist_a=texture2D(u_image,v_tex_a).a;float sdfdist_b=texture2D(u_image,v_tex_b).a;float sdfdist=mix(sdfdist_a,sdfdist_b,u_mix);alpha*=smoothstep(0.5-u_sdfgamma/floorwidth,0.5+u_sdfgamma/floorwidth,sdfdist);gl_FragColor=color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}";

var lineSDFVert = "\n#define scale 0.015873016\n#define LINE_DISTANCE_SCALE 2.0\nattribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;uniform vec2 u_patternscale_a;uniform float u_tex_y_a;uniform vec2 u_patternscale_b;uniform float u_tex_y_b;uniform vec2 u_units_to_pixels;varying vec2 v_normal;varying vec2 v_width2;varying vec2 v_tex_a;varying vec2 v_tex_b;varying float v_gamma_scale;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;v_tex_a=vec2(a_linesofar*u_patternscale_a.x/floorwidth,normal.y*u_patternscale_a.y+u_tex_y_a);v_tex_b=vec2(a_linesofar*u_patternscale_b.x/floorwidth,normal.y*u_patternscale_b.y+u_tex_y_b);v_width2=vec2(outset,inset);}";

var rasterFrag = "uniform float u_fade_t;uniform float u_opacity;uniform sampler2D u_image0;uniform sampler2D u_image1;varying vec2 v_pos0;varying vec2 v_pos1;uniform float u_brightness_low;uniform float u_brightness_high;uniform float u_saturation_factor;uniform float u_contrast_factor;uniform vec3 u_spin_weights;void main() {vec4 color0=texture2D(u_image0,v_pos0);vec4 color1=texture2D(u_image1,v_pos1);if (color0.a > 0.0) {color0.rgb=color0.rgb/color0.a;}if (color1.a > 0.0) {color1.rgb=color1.rgb/color1.a;}vec4 color=mix(color0,color1,u_fade_t);color.a*=u_opacity;vec3 rgb=color.rgb;rgb=vec3(dot(rgb,u_spin_weights.xyz),dot(rgb,u_spin_weights.zxy),dot(rgb,u_spin_weights.yzx));float average=(color.r+color.g+color.b)/3.0;rgb+=(average-rgb)*u_saturation_factor;rgb=(rgb-0.5)*u_contrast_factor+0.5;vec3 u_high_vec=vec3(u_brightness_low,u_brightness_low,u_brightness_low);vec3 u_low_vec=vec3(u_brightness_high,u_brightness_high,u_brightness_high);gl_FragColor=vec4(mix(u_high_vec,u_low_vec,rgb)*color.a,color.a);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}";

var rasterVert = "uniform mat4 u_matrix;uniform vec2 u_tl_parent;uniform float u_scale_parent;uniform float u_buffer_scale;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos0;varying vec2 v_pos1;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos0=(((a_texture_pos/8192.0)-0.5)/u_buffer_scale )+0.5;v_pos1=(v_pos0*u_scale_parent)+u_tl_parent;}";

var symbolIconFrag = "uniform sampler2D u_texture;varying vec2 v_tex;varying float v_fade_opacity;\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\nlowp float alpha=opacity*v_fade_opacity;gl_FragColor=texture2D(u_texture,v_tex)*alpha;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}";

var symbolIconVert = "const float PI=3.141592653589793;attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec4 a_pixeloffset;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform highp float u_camera_to_center_distance;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform float u_fade_change;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform vec2 u_texsize;varying vec2 v_tex;varying float v_fade_opacity;\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;vec2 a_minFontScale=a_pixeloffset.zw/256.0;highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec4 projectedPoint=u_matrix*vec4(a_pos,0,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=u_matrix*vec4(a_pos+vec2(1,0),0,1);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,0.0,1.0);gl_Position=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*max(a_minFontScale,fontScale)+a_pxoffset/16.0),0.0,1.0);v_tex=a_tex/u_texsize;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;v_fade_opacity=max(0.0,min(1.0,fade_opacity[0]+fade_change));}";

var symbolSDFFrag = "#define SDF_PX 8.0\nuniform bool u_is_halo;uniform sampler2D u_texture;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;uniform bool u_is_text;varying vec2 v_data0;varying vec3 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nfloat EDGE_GAMMA=0.105/u_device_pixel_ratio;vec2 tex=v_data0.xy;float gamma_scale=v_data1.x;float size=v_data1.y;float fade_opacity=v_data1[2];float fontScale=u_is_text ? size/24.0 : size;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;if (u_is_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width/fontScale)/SDF_PX;}lowp float dist=texture2D(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);gl_FragColor=color*(alpha*opacity*fade_opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}";

var symbolSDFVert = "const float PI=3.141592653589793;attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec4 a_pixeloffset;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;varying vec2 v_data0;varying vec3 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec4 projectedPoint=u_matrix*vec4(a_pos,0,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=u_matrix*vec4(a_pos+vec2(1,0),0,1);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,0.0,1.0);gl_Position=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*fontScale+a_pxoffset),0.0,1.0);float gamma_scale=gl_Position.w;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(1.0,fade_opacity[0]+fade_change));v_data0=a_tex/u_texsize;v_data1=vec3(gamma_scale,size,interpolated_fade_opacity);}";

var symbolTextAndIconFrag = "#define SDF_PX 8.0\n#define SDF 1.0\n#define ICON 0.0\nuniform bool u_is_halo;uniform sampler2D u_texture;uniform sampler2D u_texture_icon;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;varying vec4 v_data0;varying vec4 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nfloat fade_opacity=v_data1[2];if (v_data1.w==ICON) {vec2 tex_icon=v_data0.zw;lowp float alpha=opacity*fade_opacity;gl_FragColor=texture2D(u_texture_icon,tex_icon)*alpha;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\nreturn;}vec2 tex=v_data0.xy;float EDGE_GAMMA=0.105/u_device_pixel_ratio;float gamma_scale=v_data1.x;float size=v_data1.y;float fontScale=size/24.0;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;if (u_is_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width/fontScale)/SDF_PX;}lowp float dist=texture2D(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);gl_FragColor=color*(alpha*opacity*fade_opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}";

var symbolTextAndIconVert = "const float PI=3.141592653589793;attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec2 u_texsize_icon;varying vec4 v_data0;varying vec4 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);float is_sdf=a_size[0]-2.0*a_size_min;highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec4 projectedPoint=u_matrix*vec4(a_pos,0,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=size/24.0;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=u_matrix*vec4(a_pos+vec2(1,0),0,1);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,0.0,1.0);gl_Position=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*fontScale),0.0,1.0);float gamma_scale=gl_Position.w;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(1.0,fade_opacity[0]+fade_change));v_data0.xy=a_tex/u_texsize;v_data0.zw=a_tex/u_texsize_icon;v_data1=vec4(gamma_scale,size,interpolated_fade_opacity,is_sdf);}";

var prelude = compile(preludeFrag, preludeVert);
var background = compile(backgroundFrag, backgroundVert);
var backgroundPattern = compile(backgroundPatternFrag, backgroundPatternVert);
var circle = compile(circleFrag, circleVert);
var clippingMask = compile(clippingMaskFrag, clippingMaskVert);
var heatmap = compile(heatmapFrag, heatmapVert);
var heatmapTexture = compile(heatmapTextureFrag, heatmapTextureVert);
var collisionBox = compile(collisionBoxFrag, collisionBoxVert);
var collisionCircle = compile(collisionCircleFrag, collisionCircleVert);
var debug = compile(debugFrag, debugVert);
var fill = compile(fillFrag, fillVert);
var fillOutline = compile(fillOutlineFrag, fillOutlineVert);
var fillOutlinePattern = compile(fillOutlinePatternFrag, fillOutlinePatternVert);
var fillPattern = compile(fillPatternFrag, fillPatternVert);
var fillExtrusion = compile(fillExtrusionFrag, fillExtrusionVert);
var fillExtrusionPattern = compile(fillExtrusionPatternFrag, fillExtrusionPatternVert);
var hillshadePrepare = compile(hillshadePrepareFrag, hillshadePrepareVert);
var hillshade = compile(hillshadeFrag, hillshadeVert);
var line = compile(lineFrag, lineVert);
var lineGradient = compile(lineGradientFrag, lineGradientVert);
var linePattern = compile(linePatternFrag, linePatternVert);
var lineSDF = compile(lineSDFFrag, lineSDFVert);
var raster = compile(rasterFrag, rasterVert);
var symbolIcon = compile(symbolIconFrag, symbolIconVert);
var symbolSDF = compile(symbolSDFFrag, symbolSDFVert);
var symbolTextAndIcon = compile(symbolTextAndIconFrag, symbolTextAndIconVert);
function compile(fragmentSource, vertexSource) {
    var re = /#pragma mapbox: ([\w]+) ([\w]+) ([\w]+) ([\w]+)/g;
    var staticAttributes = vertexSource.match(/attribute ([\w]+) ([\w]+)/g);
    var fragmentUniforms = fragmentSource.match(/uniform ([\w]+) ([\w]+)([\s]*)([\w]*)/g);
    var vertexUniforms = vertexSource.match(/uniform ([\w]+) ([\w]+)([\s]*)([\w]*)/g);
    var staticUniforms = vertexUniforms ? vertexUniforms.concat(fragmentUniforms) : fragmentUniforms;
    var fragmentPragmas = {};
    fragmentSource = fragmentSource.replace(re, function (match, operation, precision, type, name) {
        fragmentPragmas[name] = true;
        if (operation === 'define') {
            return '\n#ifndef HAS_UNIFORM_u_' + name + '\nvarying ' + precision + ' ' + type + ' ' + name + ';\n#else\nuniform ' + precision + ' ' + type + ' u_' + name + ';\n#endif\n';
        } else {
            return '\n#ifdef HAS_UNIFORM_u_' + name + '\n    ' + precision + ' ' + type + ' ' + name + ' = u_' + name + ';\n#endif\n';
        }
    });
    vertexSource = vertexSource.replace(re, function (match, operation, precision, type, name) {
        var attrType = type === 'float' ? 'vec2' : 'vec4';
        var unpackType = name.match(/color/) ? 'color' : attrType;
        if (fragmentPragmas[name]) {
            if (operation === 'define') {
                return '\n#ifndef HAS_UNIFORM_u_' + name + '\nuniform lowp float u_' + name + '_t;\nattribute ' + precision + ' ' + attrType + ' a_' + name + ';\nvarying ' + precision + ' ' + type + ' ' + name + ';\n#else\nuniform ' + precision + ' ' + type + ' u_' + name + ';\n#endif\n';
            } else {
                if (unpackType === 'vec4') {
                    return '\n#ifndef HAS_UNIFORM_u_' + name + '\n    ' + name + ' = a_' + name + ';\n#else\n    ' + precision + ' ' + type + ' ' + name + ' = u_' + name + ';\n#endif\n';
                } else {
                    return '\n#ifndef HAS_UNIFORM_u_' + name + '\n    ' + name + ' = unpack_mix_' + unpackType + '(a_' + name + ', u_' + name + '_t);\n#else\n    ' + precision + ' ' + type + ' ' + name + ' = u_' + name + ';\n#endif\n';
                }
            }
        } else {
            if (operation === 'define') {
                return '\n#ifndef HAS_UNIFORM_u_' + name + '\nuniform lowp float u_' + name + '_t;\nattribute ' + precision + ' ' + attrType + ' a_' + name + ';\n#else\nuniform ' + precision + ' ' + type + ' u_' + name + ';\n#endif\n';
            } else {
                if (unpackType === 'vec4') {
                    return '\n#ifndef HAS_UNIFORM_u_' + name + '\n    ' + precision + ' ' + type + ' ' + name + ' = a_' + name + ';\n#else\n    ' + precision + ' ' + type + ' ' + name + ' = u_' + name + ';\n#endif\n';
                } else {
                    return '\n#ifndef HAS_UNIFORM_u_' + name + '\n    ' + precision + ' ' + type + ' ' + name + ' = unpack_mix_' + unpackType + '(a_' + name + ', u_' + name + '_t);\n#else\n    ' + precision + ' ' + type + ' ' + name + ' = u_' + name + ';\n#endif\n';
                }
            }
        }
    });
    return {
        fragmentSource: fragmentSource,
        vertexSource: vertexSource,
        staticAttributes: staticAttributes,
        staticUniforms: staticUniforms
    };
}

var shaders = /*#__PURE__*/Object.freeze({
__proto__: null,
prelude: prelude,
background: background,
backgroundPattern: backgroundPattern,
circle: circle,
clippingMask: clippingMask,
heatmap: heatmap,
heatmapTexture: heatmapTexture,
collisionBox: collisionBox,
collisionCircle: collisionCircle,
debug: debug,
fill: fill,
fillOutline: fillOutline,
fillOutlinePattern: fillOutlinePattern,
fillPattern: fillPattern,
fillExtrusion: fillExtrusion,
fillExtrusionPattern: fillExtrusionPattern,
hillshadePrepare: hillshadePrepare,
hillshade: hillshade,
line: line,
lineGradient: lineGradient,
linePattern: linePattern,
lineSDF: lineSDF,
raster: raster,
symbolIcon: symbolIcon,
symbolSDF: symbolSDF,
symbolTextAndIcon: symbolTextAndIcon
});

var VertexArrayObject = function VertexArrayObject() {
    this.boundProgram = null;
    this.boundLayoutVertexBuffer = null;
    this.boundPaintVertexBuffers = [];
    this.boundIndexBuffer = null;
    this.boundVertexOffset = null;
    this.boundDynamicVertexBuffer = null;
    this.vao = null;
};
VertexArrayObject.prototype.bind = function bind(context, program, layoutVertexBuffer, paintVertexBuffers, indexBuffer, vertexOffset, dynamicVertexBuffer, dynamicVertexBuffer2) {
    this.context = context;
    var paintBuffersDiffer = this.boundPaintVertexBuffers.length !== paintVertexBuffers.length;
    for (var i = 0; !paintBuffersDiffer && i < paintVertexBuffers.length; i++) {
        if (this.boundPaintVertexBuffers[i] !== paintVertexBuffers[i]) {
            paintBuffersDiffer = true;
        }
    }
    var isFreshBindRequired = !this.vao || this.boundProgram !== program || this.boundLayoutVertexBuffer !== layoutVertexBuffer || paintBuffersDiffer || this.boundIndexBuffer !== indexBuffer || this.boundVertexOffset !== vertexOffset || this.boundDynamicVertexBuffer !== dynamicVertexBuffer || this.boundDynamicVertexBuffer2 !== dynamicVertexBuffer2;
    if (!context.extVertexArrayObject || isFreshBindRequired) {
        this.freshBind(program, layoutVertexBuffer, paintVertexBuffers, indexBuffer, vertexOffset, dynamicVertexBuffer, dynamicVertexBuffer2);
    } else {
        context.bindVertexArrayOES.set(this.vao);
        if (dynamicVertexBuffer) {
            dynamicVertexBuffer.bind();
        }
        if (indexBuffer && indexBuffer.dynamicDraw) {
            indexBuffer.bind();
        }
        if (dynamicVertexBuffer2) {
            dynamicVertexBuffer2.bind();
        }
    }
};
VertexArrayObject.prototype.freshBind = function freshBind(program, layoutVertexBuffer, paintVertexBuffers, indexBuffer, vertexOffset, dynamicVertexBuffer, dynamicVertexBuffer2) {
    var numPrevAttributes;
    var numNextAttributes = program.numAttributes;
    var context = this.context;
    var gl = context.gl;
    if (context.extVertexArrayObject) {
        if (this.vao) {
            this.destroy();
        }
        this.vao = context.extVertexArrayObject.createVertexArrayOES();
        context.bindVertexArrayOES.set(this.vao);
        numPrevAttributes = 0;
        this.boundProgram = program;
        this.boundLayoutVertexBuffer = layoutVertexBuffer;
        this.boundPaintVertexBuffers = paintVertexBuffers;
        this.boundIndexBuffer = indexBuffer;
        this.boundVertexOffset = vertexOffset;
        this.boundDynamicVertexBuffer = dynamicVertexBuffer;
        this.boundDynamicVertexBuffer2 = dynamicVertexBuffer2;
    } else {
        numPrevAttributes = context.currentNumAttributes || 0;
        for (var i = numNextAttributes; i < numPrevAttributes; i++) {
            gl.disableVertexAttribArray(i);
        }
    }
    layoutVertexBuffer.enableAttributes(gl, program);
    for (var i$1 = 0, list = paintVertexBuffers; i$1 < list.length; i$1 += 1) {
        var vertexBuffer = list[i$1];
        vertexBuffer.enableAttributes(gl, program);
    }
    if (dynamicVertexBuffer) {
        dynamicVertexBuffer.enableAttributes(gl, program);
    }
    if (dynamicVertexBuffer2) {
        dynamicVertexBuffer2.enableAttributes(gl, program);
    }
    layoutVertexBuffer.bind();
    layoutVertexBuffer.setVertexAttribPointers(gl, program, vertexOffset);
    for (var i$2 = 0, list$1 = paintVertexBuffers; i$2 < list$1.length; i$2 += 1) {
        var vertexBuffer$1 = list$1[i$2];
        vertexBuffer$1.bind();
        vertexBuffer$1.setVertexAttribPointers(gl, program, vertexOffset);
    }
    if (dynamicVertexBuffer) {
        dynamicVertexBuffer.bind();
        dynamicVertexBuffer.setVertexAttribPointers(gl, program, vertexOffset);
    }
    if (indexBuffer) {
        indexBuffer.bind();
    }
    if (dynamicVertexBuffer2) {
        dynamicVertexBuffer2.bind();
        dynamicVertexBuffer2.setVertexAttribPointers(gl, program, vertexOffset);
    }
    context.currentNumAttributes = numNextAttributes;
};
VertexArrayObject.prototype.destroy = function destroy() {
    if (this.vao) {
        this.context.extVertexArrayObject.deleteVertexArrayOES(this.vao);
        this.vao = null;
    }
};

function getTokenizedAttributesAndUniforms(array) {
    var result = [];
    for (var i = 0; i < array.length; i++) {
        if (array[i] === null) {
            continue;
        }
        var token = array[i].split(' ');
        result.push(token.pop());
    }
    return result;
}
var Program$1 = function Program(context, name, source, configuration, fixedUniforms, showOverdrawInspector) {
    var gl = context.gl;
    this.program = gl.createProgram();
    var staticAttrInfo = getTokenizedAttributesAndUniforms(source.staticAttributes);
    var dynamicAttrInfo = configuration ? configuration.getBinderAttributes() : [];
    var allAttrInfo = staticAttrInfo.concat(dynamicAttrInfo);
    var staticUniformsInfo = source.staticUniforms ? getTokenizedAttributesAndUniforms(source.staticUniforms) : [];
    var dynamicUniformsInfo = configuration ? configuration.getBinderUniforms() : [];
    var uniformList = staticUniformsInfo.concat(dynamicUniformsInfo);
    var allUniformsInfo = [];
    for (var i$1 = 0, list = uniformList; i$1 < list.length; i$1 += 1) {
        var uniform = list[i$1];
        if (allUniformsInfo.indexOf(uniform) < 0) {
            allUniformsInfo.push(uniform);
        }
    }
    var defines = configuration ? configuration.defines() : [];
    if (showOverdrawInspector) {
        defines.push('#define OVERDRAW_INSPECTOR;');
    }
    var fragmentSource = defines.concat(prelude.fragmentSource, source.fragmentSource).join('\n');
    var vertexSource = defines.concat(prelude.vertexSource, source.vertexSource).join('\n');
    var fragmentShader = gl.createShader(gl.FRAGMENT_SHADER);
    if (gl.isContextLost()) {
        this.failedToCreate = true;
        return;
    }
    gl.shaderSource(fragmentShader, fragmentSource);
    gl.compileShader(fragmentShader);
    gl.attachShader(this.program, fragmentShader);
    var vertexShader = gl.createShader(gl.VERTEX_SHADER);
    if (gl.isContextLost()) {
        this.failedToCreate = true;
        return;
    }
    gl.shaderSource(vertexShader, vertexSource);
    gl.compileShader(vertexShader);
    gl.attachShader(this.program, vertexShader);
    this.attributes = {};
    var uniformLocations = {};
    this.numAttributes = allAttrInfo.length;
    for (var i = 0; i < this.numAttributes; i++) {
        if (allAttrInfo[i]) {
            gl.bindAttribLocation(this.program, i, allAttrInfo[i]);
            this.attributes[allAttrInfo[i]] = i;
        }
    }
    gl.linkProgram(this.program);
    gl.deleteShader(vertexShader);
    gl.deleteShader(fragmentShader);
    for (var it = 0; it < allUniformsInfo.length; it++) {
        var uniform$1 = allUniformsInfo[it];
        if (uniform$1 && !uniformLocations[uniform$1]) {
            var uniformLocation = gl.getUniformLocation(this.program, uniform$1);
            if (uniformLocation) {
                uniformLocations[uniform$1] = uniformLocation;
            }
        }
    }
    this.fixedUniforms = fixedUniforms(context, uniformLocations);
    this.binderUniforms = configuration ? configuration.getUniforms(context, uniformLocations) : [];
};
Program$1.prototype.draw = function draw(context, drawMode, depthMode, stencilMode, colorMode, cullFaceMode, uniformValues, layerID, layoutVertexBuffer, indexBuffer, segments, currentProperties, zoom, configuration, dynamicLayoutBuffer, dynamicLayoutBuffer2) {
    var obj;
    var gl = context.gl;
    if (this.failedToCreate) {
        return;
    }
    context.program.set(this.program);
    context.setDepthMode(depthMode);
    context.setStencilMode(stencilMode);
    context.setColorMode(colorMode);
    context.setCullFace(cullFaceMode);
    for (var name in this.fixedUniforms) {
        this.fixedUniforms[name].set(uniformValues[name]);
    }
    if (configuration) {
        configuration.setUniforms(context, this.binderUniforms, currentProperties, { zoom: zoom });
    }
    var primitiveSize = (obj = {}, obj[gl.LINES] = 2, obj[gl.TRIANGLES] = 3, obj[gl.LINE_STRIP] = 1, obj)[drawMode];
    for (var i = 0, list = segments.get(); i < list.length; i += 1) {
        var segment = list[i];
        var vaos = segment.vaos || (segment.vaos = {});
        var vao = vaos[layerID] || (vaos[layerID] = new VertexArrayObject());
        vao.bind(context, this, layoutVertexBuffer, configuration ? configuration.getPaintVertexBuffers() : [], indexBuffer, segment.vertexOffset, dynamicLayoutBuffer, dynamicLayoutBuffer2);
        gl.drawElements(drawMode, segment.primitiveLength * primitiveSize, gl.UNSIGNED_SHORT, segment.primitiveOffset * primitiveSize * 2);
    }
};

function patternUniformValues(crossfade, painter, tile) {
    var tileRatio = 1 / pixelsToTileUnits(tile, 1, painter.transform.tileZoom);
    var numTiles = Math.pow(2, tile.tileID.overscaledZ);
    var tileSizeAtNearestZoom = tile.tileSize * Math.pow(2, painter.transform.tileZoom) / numTiles;
    var pixelX = tileSizeAtNearestZoom * (tile.tileID.canonical.x + tile.tileID.wrap * numTiles);
    var pixelY = tileSizeAtNearestZoom * tile.tileID.canonical.y;
    return {
        'u_image': 0,
        'u_texsize': tile.imageAtlasTexture.size,
        'u_scale': [
            tileRatio,
            crossfade.fromScale,
            crossfade.toScale
        ],
        'u_fade': crossfade.t,
        'u_pixel_coord_upper': [
            pixelX >> 16,
            pixelY >> 16
        ],
        'u_pixel_coord_lower': [
            pixelX & 65535,
            pixelY & 65535
        ]
    };
}
function bgPatternUniformValues(image, crossfade, painter, tile) {
    var imagePosA = painter.imageManager.getPattern(image.from.toString());
    var imagePosB = painter.imageManager.getPattern(image.to.toString());
    var ref = painter.imageManager.getPixelSize();
    var width = ref.width;
    var height = ref.height;
    var numTiles = Math.pow(2, tile.tileID.overscaledZ);
    var tileSizeAtNearestZoom = tile.tileSize * Math.pow(2, painter.transform.tileZoom) / numTiles;
    var pixelX = tileSizeAtNearestZoom * (tile.tileID.canonical.x + tile.tileID.wrap * numTiles);
    var pixelY = tileSizeAtNearestZoom * tile.tileID.canonical.y;
    return {
        'u_image': 0,
        'u_pattern_tl_a': imagePosA.tl,
        'u_pattern_br_a': imagePosA.br,
        'u_pattern_tl_b': imagePosB.tl,
        'u_pattern_br_b': imagePosB.br,
        'u_texsize': [
            width,
            height
        ],
        'u_mix': crossfade.t,
        'u_pattern_size_a': imagePosA.displaySize,
        'u_pattern_size_b': imagePosB.displaySize,
        'u_scale_a': crossfade.fromScale,
        'u_scale_b': crossfade.toScale,
        'u_tile_units_to_pixels': 1 / pixelsToTileUnits(tile, 1, painter.transform.tileZoom),
        'u_pixel_coord_upper': [
            pixelX >> 16,
            pixelY >> 16
        ],
        'u_pixel_coord_lower': [
            pixelX & 65535,
            pixelY & 65535
        ]
    };
}

var fillExtrusionUniforms = function (context, locations) {
    return {
        'u_matrix': new performance.UniformMatrix4f(context, locations.u_matrix),
        'u_lightpos': new performance.Uniform3f(context, locations.u_lightpos),
        'u_lightintensity': new performance.Uniform1f(context, locations.u_lightintensity),
        'u_lightcolor': new performance.Uniform3f(context, locations.u_lightcolor),
        'u_vertical_gradient': new performance.Uniform1f(context, locations.u_vertical_gradient),
        'u_opacity': new performance.Uniform1f(context, locations.u_opacity)
    };
};
var fillExtrusionPatternUniforms = function (context, locations) {
    return {
        'u_matrix': new performance.UniformMatrix4f(context, locations.u_matrix),
        'u_lightpos': new performance.Uniform3f(context, locations.u_lightpos),
        'u_lightintensity': new performance.Uniform1f(context, locations.u_lightintensity),
        'u_lightcolor': new performance.Uniform3f(context, locations.u_lightcolor),
        'u_vertical_gradient': new performance.Uniform1f(context, locations.u_vertical_gradient),
        'u_height_factor': new performance.Uniform1f(context, locations.u_height_factor),
        'u_image': new performance.Uniform1i(context, locations.u_image),
        'u_texsize': new performance.Uniform2f(context, locations.u_texsize),
        'u_pixel_coord_upper': new performance.Uniform2f(context, locations.u_pixel_coord_upper),
        'u_pixel_coord_lower': new performance.Uniform2f(context, locations.u_pixel_coord_lower),
        'u_scale': new performance.Uniform3f(context, locations.u_scale),
        'u_fade': new performance.Uniform1f(context, locations.u_fade),
        'u_opacity': new performance.Uniform1f(context, locations.u_opacity)
    };
};
var fillExtrusionUniformValues = function (matrix, painter, shouldUseVerticalGradient, opacity) {
    var light = painter.style.light;
    var _lp = light.properties.get('position');
    var lightPos = [
        _lp.x,
        _lp.y,
        _lp.z
    ];
    var lightMat = performance.create$1();
    if (light.properties.get('anchor') === 'viewport') {
        performance.fromRotation(lightMat, -painter.transform.angle);
    }
    performance.transformMat3(lightPos, lightPos, lightMat);
    var lightColor = light.properties.get('color');
    return {
        'u_matrix': matrix,
        'u_lightpos': lightPos,
        'u_lightintensity': light.properties.get('intensity'),
        'u_lightcolor': [
            lightColor.r,
            lightColor.g,
            lightColor.b
        ],
        'u_vertical_gradient': +shouldUseVerticalGradient,
        'u_opacity': opacity
    };
};
var fillExtrusionPatternUniformValues = function (matrix, painter, shouldUseVerticalGradient, opacity, coord, crossfade, tile) {
    return performance.extend(fillExtrusionUniformValues(matrix, painter, shouldUseVerticalGradient, opacity), patternUniformValues(crossfade, painter, tile), { 'u_height_factor': -Math.pow(2, coord.overscaledZ) / tile.tileSize / 8 });
};

var fillUniforms = function (context, locations) {
    return { 'u_matrix': new performance.UniformMatrix4f(context, locations.u_matrix) };
};
var fillPatternUniforms = function (context, locations) {
    return {
        'u_matrix': new performance.UniformMatrix4f(context, locations.u_matrix),
        'u_image': new performance.Uniform1i(context, locations.u_image),
        'u_texsize': new performance.Uniform2f(context, locations.u_texsize),
        'u_pixel_coord_upper': new performance.Uniform2f(context, locations.u_pixel_coord_upper),
        'u_pixel_coord_lower': new performance.Uniform2f(context, locations.u_pixel_coord_lower),
        'u_scale': new performance.Uniform3f(context, locations.u_scale),
        'u_fade': new performance.Uniform1f(context, locations.u_fade)
    };
};
var fillOutlineUniforms = function (context, locations) {
    return {
        'u_matrix': new performance.UniformMatrix4f(context, locations.u_matrix),
        'u_world': new performance.Uniform2f(context, locations.u_world)
    };
};
var fillOutlinePatternUniforms = function (context, locations) {
    return {
        'u_matrix': new performance.UniformMatrix4f(context, locations.u_matrix),
        'u_world': new performance.Uniform2f(context, locations.u_world),
        'u_image': new performance.Uniform1i(context, locations.u_image),
        'u_texsize': new performance.Uniform2f(context, locations.u_texsize),
        'u_pixel_coord_upper': new performance.Uniform2f(context, locations.u_pixel_coord_upper),
        'u_pixel_coord_lower': new performance.Uniform2f(context, locations.u_pixel_coord_lower),
        'u_scale': new performance.Uniform3f(context, locations.u_scale),
        'u_fade': new performance.Uniform1f(context, locations.u_fade)
    };
};
var fillUniformValues = function (matrix) {
    return { 'u_matrix': matrix };
};
var fillPatternUniformValues = function (matrix, painter, crossfade, tile) {
    return performance.extend(fillUniformValues(matrix), patternUniformValues(crossfade, painter, tile));
};
var fillOutlineUniformValues = function (matrix, drawingBufferSize) {
    return {
        'u_matrix': matrix,
        'u_world': drawingBufferSize
    };
};
var fillOutlinePatternUniformValues = function (matrix, painter, crossfade, tile, drawingBufferSize) {
    return performance.extend(fillPatternUniformValues(matrix, painter, crossfade, tile), { 'u_world': drawingBufferSize });
};

var circleUniforms = function (context, locations) {
    return {
        'u_camera_to_center_distance': new performance.Uniform1f(context, locations.u_camera_to_center_distance),
        'u_scale_with_map': new performance.Uniform1i(context, locations.u_scale_with_map),
        'u_pitch_with_map': new performance.Uniform1i(context, locations.u_pitch_with_map),
        'u_extrude_scale': new performance.Uniform2f(context, locations.u_extrude_scale),
        'u_device_pixel_ratio': new performance.Uniform1f(context, locations.u_device_pixel_ratio),
        'u_matrix': new performance.UniformMatrix4f(context, locations.u_matrix)
    };
};
var circleUniformValues = function (painter, coord, tile, layer) {
    var transform = painter.transform;
    var pitchWithMap, extrudeScale;
    if (layer.paint.get('circle-pitch-alignment') === 'map') {
        var pixelRatio = pixelsToTileUnits(tile, 1, transform.zoom);
        pitchWithMap = true;
        extrudeScale = [
            pixelRatio,
            pixelRatio
        ];
    } else {
        pitchWithMap = false;
        extrudeScale = transform.pixelsToGLUnits;
    }
    return {
        'u_camera_to_center_distance': transform.cameraToCenterDistance,
        'u_scale_with_map': +(layer.paint.get('circle-pitch-scale') === 'map'),
        'u_matrix': painter.translatePosMatrix(coord.posMatrix, tile, layer.paint.get('circle-translate'), layer.paint.get('circle-translate-anchor')),
        'u_pitch_with_map': +pitchWithMap,
        'u_device_pixel_ratio': performance.browser.devicePixelRatio,
        'u_extrude_scale': extrudeScale
    };
};

var collisionUniforms = function (context, locations) {
    return {
        'u_matrix': new performance.UniformMatrix4f(context, locations.u_matrix),
        'u_camera_to_center_distance': new performance.Uniform1f(context, locations.u_camera_to_center_distance),
        'u_pixels_to_tile_units': new performance.Uniform1f(context, locations.u_pixels_to_tile_units),
        'u_extrude_scale': new performance.Uniform2f(context, locations.u_extrude_scale),
        'u_overscale_factor': new performance.Uniform1f(context, locations.u_overscale_factor)
    };
};
var collisionCircleUniforms = function (context, locations) {
    return {
        'u_matrix': new performance.UniformMatrix4f(context, locations.u_matrix),
        'u_inv_matrix': new performance.UniformMatrix4f(context, locations.u_inv_matrix),
        'u_camera_to_center_distance': new performance.Uniform1f(context, locations.u_camera_to_center_distance),
        'u_viewport_size': new performance.Uniform2f(context, locations.u_viewport_size)
    };
};
var collisionUniformValues = function (matrix, transform, tile) {
    var pixelRatio = pixelsToTileUnits(tile, 1, transform.zoom);
    var scale = Math.pow(2, transform.zoom - tile.tileID.overscaledZ);
    var overscaleFactor = tile.tileID.overscaleFactor();
    return {
        'u_matrix': matrix,
        'u_camera_to_center_distance': transform.cameraToCenterDistance,
        'u_pixels_to_tile_units': pixelRatio,
        'u_extrude_scale': [
            transform.pixelsToGLUnits[0] / (pixelRatio * scale),
            transform.pixelsToGLUnits[1] / (pixelRatio * scale)
        ],
        'u_overscale_factor': overscaleFactor
    };
};
var collisionCircleUniformValues = function (matrix, invMatrix, transform) {
    return {
        'u_matrix': matrix,
        'u_inv_matrix': invMatrix,
        'u_camera_to_center_distance': transform.cameraToCenterDistance,
        'u_viewport_size': [
            transform.width,
            transform.height
        ]
    };
};

var debugUniforms = function (context, locations) {
    return {
        'u_color': new performance.UniformColor(context, locations.u_color),
        'u_matrix': new performance.UniformMatrix4f(context, locations.u_matrix),
        'u_overlay': new performance.Uniform1i(context, locations.u_overlay),
        'u_overlay_scale': new performance.Uniform1f(context, locations.u_overlay_scale)
    };
};
var debugUniformValues = function (matrix, color, scaleRatio) {
    if (scaleRatio === void 0)
        scaleRatio = 1;
    return {
        'u_matrix': matrix,
        'u_color': color,
        'u_overlay': 0,
        'u_overlay_scale': scaleRatio
    };
};

var clippingMaskUniforms = function (context, locations) {
    return { 'u_matrix': new performance.UniformMatrix4f(context, locations.u_matrix) };
};
var clippingMaskUniformValues = function (matrix) {
    return { 'u_matrix': matrix };
};

var heatmapUniforms = function (context, locations) {
    return {
        'u_extrude_scale': new performance.Uniform1f(context, locations.u_extrude_scale),
        'u_intensity': new performance.Uniform1f(context, locations.u_intensity),
        'u_matrix': new performance.UniformMatrix4f(context, locations.u_matrix)
    };
};
var heatmapTextureUniforms = function (context, locations) {
    return {
        'u_matrix': new performance.UniformMatrix4f(context, locations.u_matrix),
        'u_world': new performance.Uniform2f(context, locations.u_world),
        'u_image': new performance.Uniform1i(context, locations.u_image),
        'u_color_ramp': new performance.Uniform1i(context, locations.u_color_ramp),
        'u_opacity': new performance.Uniform1f(context, locations.u_opacity)
    };
};
var heatmapUniformValues = function (matrix, tile, zoom, intensity) {
    return {
        'u_matrix': matrix,
        'u_extrude_scale': pixelsToTileUnits(tile, 1, zoom),
        'u_intensity': intensity
    };
};
var heatmapTextureUniformValues = function (painter, layer, textureUnit, colorRampUnit) {
    var matrix = performance.create();
    performance.ortho(matrix, 0, painter.width, painter.height, 0, 0, 1);
    var gl = painter.context.gl;
    return {
        'u_matrix': matrix,
        'u_world': [
            gl.drawingBufferWidth,
            gl.drawingBufferHeight
        ],
        'u_image': textureUnit,
        'u_color_ramp': colorRampUnit,
        'u_opacity': layer.paint.get('heatmap-opacity')
    };
};

var hillshadeUniforms = function (context, locations) {
    return {
        'u_matrix': new performance.UniformMatrix4f(context, locations.u_matrix),
        'u_image': new performance.Uniform1i(context, locations.u_image),
        'u_latrange': new performance.Uniform2f(context, locations.u_latrange),
        'u_light': new performance.Uniform2f(context, locations.u_light),
        'u_shadow': new performance.UniformColor(context, locations.u_shadow),
        'u_highlight': new performance.UniformColor(context, locations.u_highlight),
        'u_accent': new performance.UniformColor(context, locations.u_accent)
    };
};
var hillshadePrepareUniforms = function (context, locations) {
    return {
        'u_matrix': new performance.UniformMatrix4f(context, locations.u_matrix),
        'u_image': new performance.Uniform1i(context, locations.u_image),
        'u_dimension': new performance.Uniform2f(context, locations.u_dimension),
        'u_zoom': new performance.Uniform1f(context, locations.u_zoom),
        'u_unpack': new performance.Uniform4f(context, locations.u_unpack)
    };
};
var hillshadeUniformValues = function (painter, tile, layer) {
    var shadow = layer.paint.get('hillshade-shadow-color');
    var highlight = layer.paint.get('hillshade-highlight-color');
    var accent = layer.paint.get('hillshade-accent-color');
    var azimuthal = layer.paint.get('hillshade-illumination-direction') * (Math.PI / 180);
    if (layer.paint.get('hillshade-illumination-anchor') === 'viewport') {
        azimuthal -= painter.transform.angle;
    }
    var align = !painter.options.moving;
    return {
        'u_matrix': painter.transform.calculatePosMatrix(tile.tileID.toUnwrapped(), align),
        'u_image': 0,
        'u_latrange': getTileLatRange(painter, tile.tileID),
        'u_light': [
            layer.paint.get('hillshade-exaggeration'),
            azimuthal
        ],
        'u_shadow': shadow,
        'u_highlight': highlight,
        'u_accent': accent
    };
};
var hillshadeUniformPrepareValues = function (tileID, dem) {
    var stride = dem.stride;
    var matrix = performance.create();
    performance.ortho(matrix, 0, performance.EXTENT, -performance.EXTENT, 0, 0, 1);
    performance.translate(matrix, matrix, [
        0,
        -performance.EXTENT,
        0
    ]);
    return {
        'u_matrix': matrix,
        'u_image': 1,
        'u_dimension': [
            stride,
            stride
        ],
        'u_zoom': tileID.overscaledZ,
        'u_unpack': dem.getUnpackVector()
    };
};
function getTileLatRange(painter, tileID) {
    var tilesAtZoom = Math.pow(2, tileID.canonical.z);
    var y = tileID.canonical.y;
    return [
        new performance.MercatorCoordinate(0, y / tilesAtZoom).toLngLat().lat,
        new performance.MercatorCoordinate(0, (y + 1) / tilesAtZoom).toLngLat().lat
    ];
}

var lineUniforms = function (context, locations) {
    return {
        'u_matrix': new performance.UniformMatrix4f(context, locations.u_matrix),
        'u_ratio': new performance.Uniform1f(context, locations.u_ratio),
        'u_device_pixel_ratio': new performance.Uniform1f(context, locations.u_device_pixel_ratio),
        'u_units_to_pixels': new performance.Uniform2f(context, locations.u_units_to_pixels)
    };
};
var lineGradientUniforms = function (context, locations) {
    return {
        'u_matrix': new performance.UniformMatrix4f(context, locations.u_matrix),
        'u_ratio': new performance.Uniform1f(context, locations.u_ratio),
        'u_device_pixel_ratio': new performance.Uniform1f(context, locations.u_device_pixel_ratio),
        'u_units_to_pixels': new performance.Uniform2f(context, locations.u_units_to_pixels),
        'u_image': new performance.Uniform1i(context, locations.u_image),
        'u_image_height': new performance.Uniform1f(context, locations.u_image_height)
    };
};
var linePatternUniforms = function (context, locations) {
    return {
        'u_matrix': new performance.UniformMatrix4f(context, locations.u_matrix),
        'u_texsize': new performance.Uniform2f(context, locations.u_texsize),
        'u_ratio': new performance.Uniform1f(context, locations.u_ratio),
        'u_device_pixel_ratio': new performance.Uniform1f(context, locations.u_device_pixel_ratio),
        'u_image': new performance.Uniform1i(context, locations.u_image),
        'u_units_to_pixels': new performance.Uniform2f(context, locations.u_units_to_pixels),
        'u_scale': new performance.Uniform3f(context, locations.u_scale),
        'u_fade': new performance.Uniform1f(context, locations.u_fade)
    };
};
var lineSDFUniforms = function (context, locations) {
    return {
        'u_matrix': new performance.UniformMatrix4f(context, locations.u_matrix),
        'u_ratio': new performance.Uniform1f(context, locations.u_ratio),
        'u_device_pixel_ratio': new performance.Uniform1f(context, locations.u_device_pixel_ratio),
        'u_units_to_pixels': new performance.Uniform2f(context, locations.u_units_to_pixels),
        'u_patternscale_a': new performance.Uniform2f(context, locations.u_patternscale_a),
        'u_patternscale_b': new performance.Uniform2f(context, locations.u_patternscale_b),
        'u_sdfgamma': new performance.Uniform1f(context, locations.u_sdfgamma),
        'u_image': new performance.Uniform1i(context, locations.u_image),
        'u_tex_y_a': new performance.Uniform1f(context, locations.u_tex_y_a),
        'u_tex_y_b': new performance.Uniform1f(context, locations.u_tex_y_b),
        'u_mix': new performance.Uniform1f(context, locations.u_mix)
    };
};
var lineUniformValues = function (painter, tile, layer) {
    var transform = painter.transform;
    return {
        'u_matrix': calculateMatrix(painter, tile, layer),
        'u_ratio': 1 / pixelsToTileUnits(tile, 1, transform.zoom),
        'u_device_pixel_ratio': performance.browser.devicePixelRatio,
        'u_units_to_pixels': [
            1 / transform.pixelsToGLUnits[0],
            1 / transform.pixelsToGLUnits[1]
        ]
    };
};
var lineGradientUniformValues = function (painter, tile, layer, imageHeight) {
    return performance.extend(lineUniformValues(painter, tile, layer), {
        'u_image': 0,
        'u_image_height': imageHeight
    });
};
var linePatternUniformValues = function (painter, tile, layer, crossfade) {
    var transform = painter.transform;
    var tileZoomRatio = calculateTileRatio(tile, transform);
    return {
        'u_matrix': calculateMatrix(painter, tile, layer),
        'u_texsize': tile.imageAtlasTexture.size,
        'u_ratio': 1 / pixelsToTileUnits(tile, 1, transform.zoom),
        'u_device_pixel_ratio': performance.browser.devicePixelRatio,
        'u_image': 0,
        'u_scale': [
            tileZoomRatio,
            crossfade.fromScale,
            crossfade.toScale
        ],
        'u_fade': crossfade.t,
        'u_units_to_pixels': [
            1 / transform.pixelsToGLUnits[0],
            1 / transform.pixelsToGLUnits[1]
        ]
    };
};
var lineSDFUniformValues = function (painter, tile, layer, dasharray, crossfade) {
    var transform = painter.transform;
    var lineAtlas = painter.lineAtlas;
    var tileRatio = calculateTileRatio(tile, transform);
    var round = layer.layout.get('line-cap') === 'round';
    var posA = lineAtlas.getDash(dasharray.from, round);
    var posB = lineAtlas.getDash(dasharray.to, round);
    var widthA = posA.width * crossfade.fromScale;
    var widthB = posB.width * crossfade.toScale;
    return performance.extend(lineUniformValues(painter, tile, layer), {
        'u_patternscale_a': [
            tileRatio / widthA,
            -posA.height / 2
        ],
        'u_patternscale_b': [
            tileRatio / widthB,
            -posB.height / 2
        ],
        'u_sdfgamma': lineAtlas.width / (Math.min(widthA, widthB) * 256 * performance.browser.devicePixelRatio) / 2,
        'u_image': 0,
        'u_tex_y_a': posA.y,
        'u_tex_y_b': posB.y,
        'u_mix': crossfade.t
    });
};
function calculateTileRatio(tile, transform) {
    return 1 / pixelsToTileUnits(tile, 1, transform.tileZoom);
}
function calculateMatrix(painter, tile, layer) {
    return painter.translatePosMatrix(tile.tileID.posMatrix, tile, layer.paint.get('line-translate'), layer.paint.get('line-translate-anchor'));
}

var rasterUniforms = function (context, locations) {
    return {
        'u_matrix': new performance.UniformMatrix4f(context, locations.u_matrix),
        'u_tl_parent': new performance.Uniform2f(context, locations.u_tl_parent),
        'u_scale_parent': new performance.Uniform1f(context, locations.u_scale_parent),
        'u_buffer_scale': new performance.Uniform1f(context, locations.u_buffer_scale),
        'u_fade_t': new performance.Uniform1f(context, locations.u_fade_t),
        'u_opacity': new performance.Uniform1f(context, locations.u_opacity),
        'u_image0': new performance.Uniform1i(context, locations.u_image0),
        'u_image1': new performance.Uniform1i(context, locations.u_image1),
        'u_brightness_low': new performance.Uniform1f(context, locations.u_brightness_low),
        'u_brightness_high': new performance.Uniform1f(context, locations.u_brightness_high),
        'u_saturation_factor': new performance.Uniform1f(context, locations.u_saturation_factor),
        'u_contrast_factor': new performance.Uniform1f(context, locations.u_contrast_factor),
        'u_spin_weights': new performance.Uniform3f(context, locations.u_spin_weights)
    };
};
var rasterUniformValues = function (matrix, parentTL, parentScaleBy, fade, layer) {
    return {
        'u_matrix': matrix,
        'u_tl_parent': parentTL,
        'u_scale_parent': parentScaleBy,
        'u_buffer_scale': 1,
        'u_fade_t': fade.mix,
        'u_opacity': fade.opacity * layer.paint.get('raster-opacity'),
        'u_image0': 0,
        'u_image1': 1,
        'u_brightness_low': layer.paint.get('raster-brightness-min'),
        'u_brightness_high': layer.paint.get('raster-brightness-max'),
        'u_saturation_factor': saturationFactor(layer.paint.get('raster-saturation')),
        'u_contrast_factor': contrastFactor(layer.paint.get('raster-contrast')),
        'u_spin_weights': spinWeights(layer.paint.get('raster-hue-rotate'))
    };
};
function spinWeights(angle) {
    angle *= Math.PI / 180;
    var s = Math.sin(angle);
    var c = Math.cos(angle);
    return [
        (2 * c + 1) / 3,
        (-Math.sqrt(3) * s - c + 1) / 3,
        (Math.sqrt(3) * s - c + 1) / 3
    ];
}
function contrastFactor(contrast) {
    return contrast > 0 ? 1 / (1 - contrast) : 1 + contrast;
}
function saturationFactor(saturation) {
    return saturation > 0 ? 1 - 1 / (1.001 - saturation) : -saturation;
}

var symbolIconUniforms = function (context, locations) {
    return {
        'u_is_size_zoom_constant': new performance.Uniform1i(context, locations.u_is_size_zoom_constant),
        'u_is_size_feature_constant': new performance.Uniform1i(context, locations.u_is_size_feature_constant),
        'u_size_t': new performance.Uniform1f(context, locations.u_size_t),
        'u_size': new performance.Uniform1f(context, locations.u_size),
        'u_camera_to_center_distance': new performance.Uniform1f(context, locations.u_camera_to_center_distance),
        'u_pitch': new performance.Uniform1f(context, locations.u_pitch),
        'u_rotate_symbol': new performance.Uniform1i(context, locations.u_rotate_symbol),
        'u_aspect_ratio': new performance.Uniform1f(context, locations.u_aspect_ratio),
        'u_fade_change': new performance.Uniform1f(context, locations.u_fade_change),
        'u_matrix': new performance.UniformMatrix4f(context, locations.u_matrix),
        'u_label_plane_matrix': new performance.UniformMatrix4f(context, locations.u_label_plane_matrix),
        'u_coord_matrix': new performance.UniformMatrix4f(context, locations.u_coord_matrix),
        'u_is_text': new performance.Uniform1i(context, locations.u_is_text),
        'u_pitch_with_map': new performance.Uniform1i(context, locations.u_pitch_with_map),
        'u_texsize': new performance.Uniform2f(context, locations.u_texsize),
        'u_texture': new performance.Uniform1i(context, locations.u_texture)
    };
};
var symbolSDFUniforms = function (context, locations) {
    return {
        'u_is_size_zoom_constant': new performance.Uniform1i(context, locations.u_is_size_zoom_constant),
        'u_is_size_feature_constant': new performance.Uniform1i(context, locations.u_is_size_feature_constant),
        'u_size_t': new performance.Uniform1f(context, locations.u_size_t),
        'u_size': new performance.Uniform1f(context, locations.u_size),
        'u_camera_to_center_distance': new performance.Uniform1f(context, locations.u_camera_to_center_distance),
        'u_pitch': new performance.Uniform1f(context, locations.u_pitch),
        'u_rotate_symbol': new performance.Uniform1i(context, locations.u_rotate_symbol),
        'u_aspect_ratio': new performance.Uniform1f(context, locations.u_aspect_ratio),
        'u_fade_change': new performance.Uniform1f(context, locations.u_fade_change),
        'u_matrix': new performance.UniformMatrix4f(context, locations.u_matrix),
        'u_label_plane_matrix': new performance.UniformMatrix4f(context, locations.u_label_plane_matrix),
        'u_coord_matrix': new performance.UniformMatrix4f(context, locations.u_coord_matrix),
        'u_is_text': new performance.Uniform1i(context, locations.u_is_text),
        'u_pitch_with_map': new performance.Uniform1i(context, locations.u_pitch_with_map),
        'u_texsize': new performance.Uniform2f(context, locations.u_texsize),
        'u_texture': new performance.Uniform1i(context, locations.u_texture),
        'u_gamma_scale': new performance.Uniform1f(context, locations.u_gamma_scale),
        'u_device_pixel_ratio': new performance.Uniform1f(context, locations.u_device_pixel_ratio),
        'u_is_halo': new performance.Uniform1i(context, locations.u_is_halo)
    };
};
var symbolTextAndIconUniforms = function (context, locations) {
    return {
        'u_is_size_zoom_constant': new performance.Uniform1i(context, locations.u_is_size_zoom_constant),
        'u_is_size_feature_constant': new performance.Uniform1i(context, locations.u_is_size_feature_constant),
        'u_size_t': new performance.Uniform1f(context, locations.u_size_t),
        'u_size': new performance.Uniform1f(context, locations.u_size),
        'u_camera_to_center_distance': new performance.Uniform1f(context, locations.u_camera_to_center_distance),
        'u_pitch': new performance.Uniform1f(context, locations.u_pitch),
        'u_rotate_symbol': new performance.Uniform1i(context, locations.u_rotate_symbol),
        'u_aspect_ratio': new performance.Uniform1f(context, locations.u_aspect_ratio),
        'u_fade_change': new performance.Uniform1f(context, locations.u_fade_change),
        'u_matrix': new performance.UniformMatrix4f(context, locations.u_matrix),
        'u_label_plane_matrix': new performance.UniformMatrix4f(context, locations.u_label_plane_matrix),
        'u_coord_matrix': new performance.UniformMatrix4f(context, locations.u_coord_matrix),
        'u_is_text': new performance.Uniform1i(context, locations.u_is_text),
        'u_pitch_with_map': new performance.Uniform1i(context, locations.u_pitch_with_map),
        'u_texsize': new performance.Uniform2f(context, locations.u_texsize),
        'u_texsize_icon': new performance.Uniform2f(context, locations.u_texsize_icon),
        'u_texture': new performance.Uniform1i(context, locations.u_texture),
        'u_texture_icon': new performance.Uniform1i(context, locations.u_texture_icon),
        'u_gamma_scale': new performance.Uniform1f(context, locations.u_gamma_scale),
        'u_device_pixel_ratio': new performance.Uniform1f(context, locations.u_device_pixel_ratio),
        'u_is_halo': new performance.Uniform1i(context, locations.u_is_halo)
    };
};
var symbolIconUniformValues = function (functionType, size, rotateInShader, pitchWithMap, painter, matrix, labelPlaneMatrix, glCoordMatrix, isText, texSize) {
    var transform = painter.transform;
    return {
        'u_is_size_zoom_constant': +(functionType === 'constant' || functionType === 'source'),
        'u_is_size_feature_constant': +(functionType === 'constant' || functionType === 'camera'),
        'u_size_t': size ? size.uSizeT : 0,
        'u_size': size ? size.uSize : 0,
        'u_camera_to_center_distance': transform.cameraToCenterDistance,
        'u_pitch': transform.pitch / 360 * 2 * Math.PI,
        'u_rotate_symbol': +rotateInShader,
        'u_aspect_ratio': transform.width / transform.height,
        'u_fade_change': painter.options.fadeDuration ? painter.symbolFadeChange : 1,
        'u_matrix': matrix,
        'u_label_plane_matrix': labelPlaneMatrix,
        'u_coord_matrix': glCoordMatrix,
        'u_is_text': +isText,
        'u_pitch_with_map': +pitchWithMap,
        'u_texsize': texSize,
        'u_texture': 0
    };
};
var symbolSDFUniformValues = function (functionType, size, rotateInShader, pitchWithMap, painter, matrix, labelPlaneMatrix, glCoordMatrix, isText, texSize, isHalo) {
    var transform = painter.transform;
    return performance.extend(symbolIconUniformValues(functionType, size, rotateInShader, pitchWithMap, painter, matrix, labelPlaneMatrix, glCoordMatrix, isText, texSize), {
        'u_gamma_scale': pitchWithMap ? Math.cos(transform._pitch) * transform.cameraToCenterDistance : 1,
        'u_device_pixel_ratio': performance.browser.devicePixelRatio,
        'u_is_halo': +isHalo
    });
};
var symbolTextAndIconUniformValues = function (functionType, size, rotateInShader, pitchWithMap, painter, matrix, labelPlaneMatrix, glCoordMatrix, texSizeSDF, texSizeIcon) {
    return performance.extend(symbolSDFUniformValues(functionType, size, rotateInShader, pitchWithMap, painter, matrix, labelPlaneMatrix, glCoordMatrix, true, texSizeSDF, true), {
        'u_texsize_icon': texSizeIcon,
        'u_texture_icon': 1
    });
};

var backgroundUniforms = function (context, locations) {
    return {
        'u_matrix': new performance.UniformMatrix4f(context, locations.u_matrix),
        'u_opacity': new performance.Uniform1f(context, locations.u_opacity),
        'u_color': new performance.UniformColor(context, locations.u_color)
    };
};
var backgroundPatternUniforms = function (context, locations) {
    return {
        'u_matrix': new performance.UniformMatrix4f(context, locations.u_matrix),
        'u_opacity': new performance.Uniform1f(context, locations.u_opacity),
        'u_image': new performance.Uniform1i(context, locations.u_image),
        'u_pattern_tl_a': new performance.Uniform2f(context, locations.u_pattern_tl_a),
        'u_pattern_br_a': new performance.Uniform2f(context, locations.u_pattern_br_a),
        'u_pattern_tl_b': new performance.Uniform2f(context, locations.u_pattern_tl_b),
        'u_pattern_br_b': new performance.Uniform2f(context, locations.u_pattern_br_b),
        'u_texsize': new performance.Uniform2f(context, locations.u_texsize),
        'u_mix': new performance.Uniform1f(context, locations.u_mix),
        'u_pattern_size_a': new performance.Uniform2f(context, locations.u_pattern_size_a),
        'u_pattern_size_b': new performance.Uniform2f(context, locations.u_pattern_size_b),
        'u_scale_a': new performance.Uniform1f(context, locations.u_scale_a),
        'u_scale_b': new performance.Uniform1f(context, locations.u_scale_b),
        'u_pixel_coord_upper': new performance.Uniform2f(context, locations.u_pixel_coord_upper),
        'u_pixel_coord_lower': new performance.Uniform2f(context, locations.u_pixel_coord_lower),
        'u_tile_units_to_pixels': new performance.Uniform1f(context, locations.u_tile_units_to_pixels)
    };
};
var backgroundUniformValues = function (matrix, opacity, color) {
    return {
        'u_matrix': matrix,
        'u_opacity': opacity,
        'u_color': color
    };
};
var backgroundPatternUniformValues = function (matrix, opacity, painter, image, tile, crossfade) {
    return performance.extend(bgPatternUniformValues(image, crossfade, painter, tile), {
        'u_matrix': matrix,
        'u_opacity': opacity
    });
};

var programUniforms = {
    fillExtrusion: fillExtrusionUniforms,
    fillExtrusionPattern: fillExtrusionPatternUniforms,
    fill: fillUniforms,
    fillPattern: fillPatternUniforms,
    fillOutline: fillOutlineUniforms,
    fillOutlinePattern: fillOutlinePatternUniforms,
    circle: circleUniforms,
    collisionBox: collisionUniforms,
    collisionCircle: collisionCircleUniforms,
    debug: debugUniforms,
    clippingMask: clippingMaskUniforms,
    heatmap: heatmapUniforms,
    heatmapTexture: heatmapTextureUniforms,
    hillshade: hillshadeUniforms,
    hillshadePrepare: hillshadePrepareUniforms,
    line: lineUniforms,
    lineGradient: lineGradientUniforms,
    linePattern: linePatternUniforms,
    lineSDF: lineSDFUniforms,
    raster: rasterUniforms,
    symbolIcon: symbolIconUniforms,
    symbolSDF: symbolSDFUniforms,
    symbolTextAndIcon: symbolTextAndIconUniforms,
    background: backgroundUniforms,
    backgroundPattern: backgroundPatternUniforms
};

var quadTriangles;
function drawCollisionDebug(painter, sourceCache, layer, coords, translate, translateAnchor, isText) {
    var context = painter.context;
    var gl = context.gl;
    var program = painter.useProgram('collisionBox');
    var tileBatches = [];
    var circleCount = 0;
    var circleOffset = 0;
    for (var i = 0; i < coords.length; i++) {
        var coord = coords[i];
        var tile = sourceCache.getTile(coord);
        var bucket = tile.getBucket(layer);
        if (!bucket) {
            continue;
        }
        var posMatrix = coord.posMatrix;
        if (translate[0] !== 0 || translate[1] !== 0) {
            posMatrix = painter.translatePosMatrix(coord.posMatrix, tile, translate, translateAnchor);
        }
        var buffers = isText ? bucket.textCollisionBox : bucket.iconCollisionBox;
        var circleArray = bucket.collisionCircleArray;
        if (circleArray.length > 0) {
            var invTransform = performance.create();
            var transform = posMatrix;
            performance.mul(invTransform, bucket.placementInvProjMatrix, painter.transform.glCoordMatrix);
            performance.mul(invTransform, invTransform, bucket.placementViewportMatrix);
            tileBatches.push({
                circleArray: circleArray,
                circleOffset: circleOffset,
                transform: transform,
                invTransform: invTransform
            });
            circleCount += circleArray.length / 4;
            circleOffset = circleCount;
        }
        if (!buffers) {
            continue;
        }
        program.draw(context, gl.LINES, DepthMode.disabled, StencilMode.disabled, painter.colorModeForRenderPass(), CullFaceMode.disabled, collisionUniformValues(posMatrix, painter.transform, tile), layer.id, buffers.layoutVertexBuffer, buffers.indexBuffer, buffers.segments, null, painter.transform.zoom, null, null, buffers.collisionVertexBuffer);
    }
    if (!isText || !tileBatches.length) {
        return;
    }
    var circleProgram = painter.useProgram('collisionCircle');
    var vertexData = new performance.StructArrayLayout2f1f2i16();
    vertexData.resize(circleCount * 4);
    vertexData._trim();
    var vertexOffset = 0;
    for (var i$2 = 0, list = tileBatches; i$2 < list.length; i$2 += 1) {
        var batch = list[i$2];
        for (var i$1 = 0; i$1 < batch.circleArray.length / 4; i$1++) {
            var circleIdx = i$1 * 4;
            var x = batch.circleArray[circleIdx + 0];
            var y = batch.circleArray[circleIdx + 1];
            var radius = batch.circleArray[circleIdx + 2];
            var collision = batch.circleArray[circleIdx + 3];
            vertexData.emplace(vertexOffset++, x, y, radius, collision, 0);
            vertexData.emplace(vertexOffset++, x, y, radius, collision, 1);
            vertexData.emplace(vertexOffset++, x, y, radius, collision, 2);
            vertexData.emplace(vertexOffset++, x, y, radius, collision, 3);
        }
    }
    if (!quadTriangles || quadTriangles.length < circleCount * 2) {
        quadTriangles = createQuadTriangles(circleCount);
    }
    var indexBuffer = context.createIndexBuffer(quadTriangles, true);
    var vertexBuffer = context.createVertexBuffer(vertexData, performance.collisionCircleLayout.members, true);
    for (var i$3 = 0, list$1 = tileBatches; i$3 < list$1.length; i$3 += 1) {
        var batch$1 = list$1[i$3];
        var uniforms = collisionCircleUniformValues(batch$1.transform, batch$1.invTransform, painter.transform);
        circleProgram.draw(context, gl.TRIANGLES, DepthMode.disabled, StencilMode.disabled, painter.colorModeForRenderPass(), CullFaceMode.disabled, uniforms, layer.id, vertexBuffer, indexBuffer, performance.SegmentVector.simpleSegment(0, batch$1.circleOffset * 2, batch$1.circleArray.length, batch$1.circleArray.length / 2), null, painter.transform.zoom, null, null, null);
    }
    vertexBuffer.destroy();
    indexBuffer.destroy();
}
function createQuadTriangles(quadCount) {
    var triCount = quadCount * 2;
    var array = new performance.StructArrayLayout3ui6();
    array.resize(triCount);
    array._trim();
    for (var i = 0; i < triCount; i++) {
        var idx = i * 6;
        array.uint16[idx + 0] = i * 4 + 0;
        array.uint16[idx + 1] = i * 4 + 1;
        array.uint16[idx + 2] = i * 4 + 2;
        array.uint16[idx + 3] = i * 4 + 2;
        array.uint16[idx + 4] = i * 4 + 3;
        array.uint16[idx + 5] = i * 4 + 0;
    }
    return array;
}

var identityMat4 = performance.identity(new Float32Array(16));
function drawSymbols(painter, sourceCache, layer, coords, variableOffsets) {
    if (painter.renderPass !== 'translucent') {
        return;
    }
    var stencilMode = StencilMode.disabled;
    var colorMode = painter.colorModeForRenderPass();
    var variablePlacement = layer.layout.get('text-variable-anchor');
    if (variablePlacement) {
        updateVariableAnchors(coords, painter, layer, sourceCache, layer.layout.get('text-rotation-alignment'), layer.layout.get('text-pitch-alignment'), variableOffsets);
    }
    if (layer.paint.get('icon-opacity').constantOr(1) !== 0) {
        drawLayerSymbols(painter, sourceCache, layer, coords, false, layer.paint.get('icon-translate'), layer.paint.get('icon-translate-anchor'), layer.layout.get('icon-rotation-alignment'), layer.layout.get('icon-pitch-alignment'), layer.layout.get('icon-keep-upright'), stencilMode, colorMode);
    }
    if (layer.paint.get('text-opacity').constantOr(1) !== 0) {
        drawLayerSymbols(painter, sourceCache, layer, coords, true, layer.paint.get('text-translate'), layer.paint.get('text-translate-anchor'), layer.layout.get('text-rotation-alignment'), layer.layout.get('text-pitch-alignment'), layer.layout.get('text-keep-upright'), stencilMode, colorMode);
    }
    if (sourceCache.map.showCollisionBoxes) {
        drawCollisionDebug(painter, sourceCache, layer, coords, layer.paint.get('text-translate'), layer.paint.get('text-translate-anchor'), true);
        drawCollisionDebug(painter, sourceCache, layer, coords, layer.paint.get('icon-translate'), layer.paint.get('icon-translate-anchor'), false);
    }
}
function calculateVariableRenderShift(anchor, width, height, textOffset, textBoxScale, renderTextSize) {
    var ref = performance.getAnchorAlignment(anchor);
    var horizontalAlign = ref.horizontalAlign;
    var verticalAlign = ref.verticalAlign;
    var shiftX = -(horizontalAlign - 0.5) * width;
    var shiftY = -(verticalAlign - 0.5) * height;
    var variableOffset = performance.evaluateVariableOffset(anchor, textOffset);
    return new performance.Point((shiftX / textBoxScale + variableOffset[0]) * renderTextSize, (shiftY / textBoxScale + variableOffset[1]) * renderTextSize);
}
function updateVariableAnchors(coords, painter, layer, sourceCache, rotationAlignment, pitchAlignment, variableOffsets) {
    var tr = painter.transform;
    var rotateWithMap = rotationAlignment === 'map';
    var pitchWithMap = pitchAlignment === 'map';
    for (var i = 0, list = coords; i < list.length; i += 1) {
        var coord = list[i];
        var tile = sourceCache.getTile(coord);
        var bucket = tile.getBucket(layer);
        if (!bucket || !bucket.text || !bucket.text.segments.get().length) {
            continue;
        }
        var sizeData = bucket.textSizeData;
        var size = performance.evaluateSizeForZoom(sizeData, tr.zoom);
        var pixelToTileScale = pixelsToTileUnits(tile, 1, painter.transform.zoom);
        var labelPlaneMatrix = getLabelPlaneMatrix(coord.posMatrix, pitchWithMap, rotateWithMap, painter.transform, pixelToTileScale);
        var updateTextFitIcon = layer.layout.get('icon-text-fit') !== 'none' && bucket.hasIconData();
        if (size) {
            var tileScale = Math.pow(2, tr.zoom - tile.tileID.overscaledZ);
            updateVariableAnchorsForBucket(bucket, rotateWithMap, pitchWithMap, variableOffsets, performance.symbolSize, tr, labelPlaneMatrix, coord.posMatrix, tileScale, size, updateTextFitIcon);
        }
    }
}
function updateVariableAnchorsForBucket(bucket, rotateWithMap, pitchWithMap, variableOffsets, symbolSize, transform, labelPlaneMatrix, posMatrix, tileScale, size, updateTextFitIcon) {
    var placedSymbols = bucket.text.placedSymbolArray;
    var dynamicTextLayoutVertexArray = bucket.text.dynamicLayoutVertexArray;
    var dynamicIconLayoutVertexArray = bucket.icon.dynamicLayoutVertexArray;
    var placedTextShifts = {};
    dynamicTextLayoutVertexArray.clear();
    for (var s = 0; s < placedSymbols.length; s++) {
        var symbol = placedSymbols.get(s);
        var skipOrientation = bucket.allowVerticalPlacement && !symbol.placedOrientation;
        var variableOffset = !symbol.hidden && symbol.crossTileID && !skipOrientation ? variableOffsets[symbol.crossTileID] : null;
        if (!variableOffset) {
            hideGlyphs(symbol.numGlyphs, dynamicTextLayoutVertexArray);
        } else {
            var tileAnchor = new performance.Point(symbol.anchorX, symbol.anchorY);
            var projectedAnchor = project(tileAnchor, pitchWithMap ? posMatrix : labelPlaneMatrix);
            var perspectiveRatio = getPerspectiveRatio(transform.cameraToCenterDistance, projectedAnchor.signedDistanceFromCamera);
            var renderTextSize = symbolSize.evaluateSizeForFeature(bucket.textSizeData, size, symbol) * perspectiveRatio / performance.ONE_EM;
            if (pitchWithMap) {
                renderTextSize *= bucket.tilePixelRatio / tileScale;
            }
            var width = variableOffset.width;
            var height = variableOffset.height;
            var anchor = variableOffset.anchor;
            var textOffset = variableOffset.textOffset;
            var textBoxScale = variableOffset.textBoxScale;
            var shift = calculateVariableRenderShift(anchor, width, height, textOffset, textBoxScale, renderTextSize);
            var shiftedAnchor = pitchWithMap ? project(tileAnchor.add(shift), labelPlaneMatrix).point : projectedAnchor.point.add(rotateWithMap ? shift.rotate(-transform.angle) : shift);
            var angle = bucket.allowVerticalPlacement && symbol.placedOrientation === performance.WritingMode.vertical ? Math.PI / 2 : 0;
            for (var g = 0; g < symbol.numGlyphs; g++) {
                performance.addDynamicAttributes(dynamicTextLayoutVertexArray, shiftedAnchor, angle);
            }
            if (updateTextFitIcon && symbol.associatedIconIndex >= 0) {
                placedTextShifts[symbol.associatedIconIndex] = {
                    shiftedAnchor: shiftedAnchor,
                    angle: angle
                };
            }
        }
    }
    if (updateTextFitIcon) {
        dynamicIconLayoutVertexArray.clear();
        var placedIcons = bucket.icon.placedSymbolArray;
        for (var i = 0; i < placedIcons.length; i++) {
            var placedIcon = placedIcons.get(i);
            if (placedIcon.hidden) {
                hideGlyphs(placedIcon.numGlyphs, dynamicIconLayoutVertexArray);
            } else {
                var shift$1 = placedTextShifts[i];
                if (!shift$1) {
                    hideGlyphs(placedIcon.numGlyphs, dynamicIconLayoutVertexArray);
                } else {
                    for (var g$1 = 0; g$1 < placedIcon.numGlyphs; g$1++) {
                        performance.addDynamicAttributes(dynamicIconLayoutVertexArray, shift$1.shiftedAnchor, shift$1.angle);
                    }
                }
            }
        }
        bucket.icon.dynamicLayoutVertexBuffer.updateData(dynamicIconLayoutVertexArray);
    }
    bucket.text.dynamicLayoutVertexBuffer.updateData(dynamicTextLayoutVertexArray);
}
function getSymbolProgramName(isSDF, isText, bucket) {
    if (bucket.iconsInText && isText) {
        return 'symbolTextAndIcon';
    } else if (isSDF) {
        return 'symbolSDF';
    } else {
        return 'symbolIcon';
    }
}
function drawLayerSymbols(painter, sourceCache, layer, coords, isText, translate, translateAnchor, rotationAlignment, pitchAlignment, keepUpright, stencilMode, colorMode) {
    var context = painter.context;
    var gl = context.gl;
    var tr = painter.transform;
    var rotateWithMap = rotationAlignment === 'map';
    var pitchWithMap = pitchAlignment === 'map';
    var alongLine = rotateWithMap && layer.layout.get('symbol-placement') !== 'point';
    var rotateInShader = rotateWithMap && !pitchWithMap && !alongLine;
    var hasSortKey = layer.layout.get('symbol-sort-key').constantOr(1) !== undefined;
    var sortFeaturesByKey = false;
    var depthMode = painter.depthModeForSublayer(0, DepthMode.ReadOnly);
    var variablePlacement = layer.layout.get('text-variable-anchor');
    var tileRenderState = [];
    for (var i$1 = 0, list$1 = coords; i$1 < list$1.length; i$1 += 1) {
        var coord = list$1[i$1];
        var tile = sourceCache.getTile(coord);
        var bucket = tile.getBucket(layer);
        if (!bucket) {
            continue;
        }
        var buffers = isText ? bucket.text : bucket.icon;
        if (!buffers || !buffers.segments.get().length) {
            continue;
        }
        var programConfiguration = buffers.programConfigurations.get(layer.id);
        var isSDF = isText || bucket.sdfIcons;
        var sizeData = isText ? bucket.textSizeData : bucket.iconSizeData;
        var transformed = pitchWithMap || tr.pitch !== 0;
        var program = painter.useProgram(getSymbolProgramName(isSDF, isText, bucket), programConfiguration);
        var size = performance.evaluateSizeForZoom(sizeData, tr.zoom);
        var texSize = void 0;
        var texSizeIcon = [
            0,
            0
        ];
        var atlasTexture = void 0;
        var atlasInterpolation = void 0;
        var atlasTextureIcon = null;
        var atlasInterpolationIcon = void 0;
        if (isText) {
            atlasTexture = tile.glyphAtlasTexture;
            atlasInterpolation = gl.LINEAR;
            texSize = tile.glyphAtlasTexture.size;
            if (bucket.iconsInText) {
                texSizeIcon = tile.imageAtlasTexture.size;
                atlasTextureIcon = tile.imageAtlasTexture;
                var zoomDependentSize = sizeData.kind === 'composite' || sizeData.kind === 'camera';
                atlasInterpolationIcon = transformed || painter.options.rotating || painter.options.zooming || zoomDependentSize ? gl.LINEAR : gl.NEAREST;
            }
        } else {
            var iconScaled = layer.layout.get('icon-size').constantOr(0) !== 1 || bucket.iconsNeedLinear;
            atlasTexture = tile.imageAtlasTexture;
            atlasInterpolation = isSDF || painter.options.rotating || painter.options.zooming || iconScaled || transformed ? gl.LINEAR : gl.NEAREST;
            texSize = tile.imageAtlasTexture.size;
        }
        var s = pixelsToTileUnits(tile, 1, painter.transform.zoom);
        var labelPlaneMatrix = getLabelPlaneMatrix(coord.posMatrix, pitchWithMap, rotateWithMap, painter.transform, s);
        var glCoordMatrix = getGlCoordMatrix(coord.posMatrix, pitchWithMap, rotateWithMap, painter.transform, s);
        var hasVariableAnchors = variablePlacement && bucket.hasTextData();
        var updateTextFitIcon = layer.layout.get('icon-text-fit') !== 'none' && hasVariableAnchors && bucket.hasIconData();
        if (alongLine) {
            updateLineLabels(bucket, coord.posMatrix, painter, isText, labelPlaneMatrix, glCoordMatrix, pitchWithMap, keepUpright);
        }
        var matrix = painter.translatePosMatrix(coord.posMatrix, tile, translate, translateAnchor), uLabelPlaneMatrix = alongLine || isText && variablePlacement || updateTextFitIcon ? identityMat4 : labelPlaneMatrix, uglCoordMatrix = painter.translatePosMatrix(glCoordMatrix, tile, translate, translateAnchor, true);
        var hasHalo = isSDF && layer.paint.get(isText ? 'text-halo-width' : 'icon-halo-width').constantOr(1) !== 0;
        var uniformValues = void 0;
        if (isSDF) {
            if (!bucket.iconsInText) {
                uniformValues = symbolSDFUniformValues(sizeData.kind, size, rotateInShader, pitchWithMap, painter, matrix, uLabelPlaneMatrix, uglCoordMatrix, isText, texSize, true);
            } else {
                uniformValues = symbolTextAndIconUniformValues(sizeData.kind, size, rotateInShader, pitchWithMap, painter, matrix, uLabelPlaneMatrix, uglCoordMatrix, texSize, texSizeIcon);
            }
        } else {
            uniformValues = symbolIconUniformValues(sizeData.kind, size, rotateInShader, pitchWithMap, painter, matrix, uLabelPlaneMatrix, uglCoordMatrix, isText, texSize);
        }
        var state = {
            program: program,
            buffers: buffers,
            uniformValues: uniformValues,
            atlasTexture: atlasTexture,
            atlasTextureIcon: atlasTextureIcon,
            atlasInterpolation: atlasInterpolation,
            atlasInterpolationIcon: atlasInterpolationIcon,
            isSDF: isSDF,
            hasHalo: hasHalo
        };
        if (hasSortKey && bucket.canOverlap) {
            sortFeaturesByKey = true;
            var oldSegments = buffers.segments.get();
            for (var i = 0, list = oldSegments; i < list.length; i += 1) {
                var segment = list[i];
                tileRenderState.push({
                    segments: new performance.SegmentVector([segment]),
                    sortKey: segment.sortKey,
                    state: state
                });
            }
        } else {
            tileRenderState.push({
                segments: buffers.segments,
                sortKey: 0,
                state: state
            });
        }
    }
    if (sortFeaturesByKey) {
        tileRenderState.sort(function (a, b) {
            return a.sortKey - b.sortKey;
        });
    }
    for (var i$2 = 0, list$2 = tileRenderState; i$2 < list$2.length; i$2 += 1) {
        var segmentState = list$2[i$2];
        var state$1 = segmentState.state;
        context.activeTexture.set(gl.TEXTURE0);
        state$1.atlasTexture.bind(state$1.atlasInterpolation, gl.CLAMP_TO_EDGE);
        if (state$1.atlasTextureIcon) {
            context.activeTexture.set(gl.TEXTURE1);
            if (state$1.atlasTextureIcon) {
                state$1.atlasTextureIcon.bind(state$1.atlasInterpolationIcon, gl.CLAMP_TO_EDGE);
            }
        }
        if (state$1.isSDF) {
            var uniformValues$1 = state$1.uniformValues;
            if (state$1.hasHalo) {
                uniformValues$1['u_is_halo'] = 1;
                drawSymbolElements(state$1.buffers, segmentState.segments, layer, painter, state$1.program, depthMode, stencilMode, colorMode, uniformValues$1);
            }
            uniformValues$1['u_is_halo'] = 0;
        }
        drawSymbolElements(state$1.buffers, segmentState.segments, layer, painter, state$1.program, depthMode, stencilMode, colorMode, state$1.uniformValues);
    }
}
function drawSymbolElements(buffers, segments, layer, painter, program, depthMode, stencilMode, colorMode, uniformValues) {
    var context = painter.context;
    var gl = context.gl;
    program.draw(context, gl.TRIANGLES, depthMode, stencilMode, colorMode, CullFaceMode.disabled, uniformValues, layer.id, buffers.layoutVertexBuffer, buffers.indexBuffer, segments, layer.paint, painter.transform.zoom, buffers.programConfigurations.get(layer.id), buffers.dynamicLayoutVertexBuffer, buffers.opacityVertexBuffer);
}

function drawCircles(painter, sourceCache, layer, coords) {
    if (painter.renderPass !== 'translucent') {
        return;
    }
    var opacity = layer.paint.get('circle-opacity');
    var strokeWidth = layer.paint.get('circle-stroke-width');
    var strokeOpacity = layer.paint.get('circle-stroke-opacity');
    var sortFeaturesByKey = layer.layout.get('circle-sort-key').constantOr(1) !== undefined;
    if (opacity.constantOr(1) === 0 && (strokeWidth.constantOr(1) === 0 || strokeOpacity.constantOr(1) === 0)) {
        return;
    }
    var context = painter.context;
    var gl = context.gl;
    var depthMode = painter.depthModeForSublayer(0, DepthMode.ReadOnly);
    var stencilMode = StencilMode.disabled;
    var colorMode = painter.colorModeForRenderPass();
    var segmentsRenderStates = [];
    for (var i = 0; i < coords.length; i++) {
        var coord = coords[i];
        var tile = sourceCache.getTile(coord);
        var bucket = tile.getBucket(layer);
        if (!bucket) {
            continue;
        }
        var programConfiguration = bucket.programConfigurations.get(layer.id);
        var program = painter.useProgram('circle', programConfiguration);
        var layoutVertexBuffer = bucket.layoutVertexBuffer;
        var indexBuffer = bucket.indexBuffer;
        var uniformValues = circleUniformValues(painter, coord, tile, layer);
        var state = {
            programConfiguration: programConfiguration,
            program: program,
            layoutVertexBuffer: layoutVertexBuffer,
            indexBuffer: indexBuffer,
            uniformValues: uniformValues
        };
        if (sortFeaturesByKey) {
            var oldSegments = bucket.segments.get();
            for (var i$1 = 0, list = oldSegments; i$1 < list.length; i$1 += 1) {
                var segment = list[i$1];
                segmentsRenderStates.push({
                    segments: new performance.SegmentVector([segment]),
                    sortKey: segment.sortKey,
                    state: state
                });
            }
        } else {
            segmentsRenderStates.push({
                segments: bucket.segments,
                sortKey: 0,
                state: state
            });
        }
    }
    if (sortFeaturesByKey) {
        segmentsRenderStates.sort(function (a, b) {
            return a.sortKey - b.sortKey;
        });
    }
    for (var i$2 = 0, list$1 = segmentsRenderStates; i$2 < list$1.length; i$2 += 1) {
        var segmentsState = list$1[i$2];
        var ref = segmentsState.state;
        var programConfiguration$1 = ref.programConfiguration;
        var program$1 = ref.program;
        var layoutVertexBuffer$1 = ref.layoutVertexBuffer;
        var indexBuffer$1 = ref.indexBuffer;
        var uniformValues$1 = ref.uniformValues;
        var segments = segmentsState.segments;
        program$1.draw(context, gl.TRIANGLES, depthMode, stencilMode, colorMode, CullFaceMode.disabled, uniformValues$1, layer.id, layoutVertexBuffer$1, indexBuffer$1, segments, layer.paint, painter.transform.zoom, programConfiguration$1);
    }
}

function drawHeatmap(painter, sourceCache, layer, coords) {
    if (layer.paint.get('heatmap-opacity') === 0) {
        return;
    }
    if (painter.renderPass === 'offscreen') {
        var context = painter.context;
        var gl = context.gl;
        var stencilMode = StencilMode.disabled;
        var colorMode = new ColorMode([
            gl.ONE,
            gl.ONE
        ], performance.Color.transparent, [
            true,
            true,
            true,
            true
        ]);
        bindFramebuffer(context, painter, layer);
        context.clear({ color: performance.Color.transparent });
        for (var i = 0; i < coords.length; i++) {
            var coord = coords[i];
            if (sourceCache.hasRenderableParent(coord)) {
                continue;
            }
            var tile = sourceCache.getTile(coord);
            var bucket = tile.getBucket(layer);
            if (!bucket) {
                continue;
            }
            var programConfiguration = bucket.programConfigurations.get(layer.id);
            var program = painter.useProgram('heatmap', programConfiguration);
            var ref = painter.transform;
            var zoom = ref.zoom;
            program.draw(context, gl.TRIANGLES, DepthMode.disabled, stencilMode, colorMode, CullFaceMode.disabled, heatmapUniformValues(coord.posMatrix, tile, zoom, layer.paint.get('heatmap-intensity')), layer.id, bucket.layoutVertexBuffer, bucket.indexBuffer, bucket.segments, layer.paint, painter.transform.zoom, programConfiguration);
        }
        context.viewport.set([
            0,
            0,
            painter.width,
            painter.height
        ]);
    } else if (painter.renderPass === 'translucent') {
        painter.context.setColorMode(painter.colorModeForRenderPass());
        renderTextureToMap(painter, layer);
    }
}
function bindFramebuffer(context, painter, layer) {
    var gl = context.gl;
    context.activeTexture.set(gl.TEXTURE1);
    context.viewport.set([
        0,
        0,
        painter.width / 4,
        painter.height / 4
    ]);
    var fbo = layer.heatmapFbo;
    if (!fbo) {
        var texture = gl.createTexture();
        gl.bindTexture(gl.TEXTURE_2D, texture);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
        fbo = layer.heatmapFbo = context.createFramebuffer(painter.width / 4, painter.height / 4, false);
        bindTextureToFramebuffer(context, painter, texture, fbo);
    } else {
        gl.bindTexture(gl.TEXTURE_2D, fbo.colorAttachment.get());
        context.bindFramebuffer.set(fbo.framebuffer);
    }
}
function bindTextureToFramebuffer(context, painter, texture, fbo) {
    var gl = context.gl;
    var internalFormat = context.extRenderToTextureHalfFloat ? context.extTextureHalfFloat.HALF_FLOAT_OES : gl.UNSIGNED_BYTE;
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, painter.width / 4, painter.height / 4, 0, gl.RGBA, internalFormat, null);
    fbo.colorAttachment.set(texture);
}
function renderTextureToMap(painter, layer) {
    var context = painter.context;
    var gl = context.gl;
    var fbo = layer.heatmapFbo;
    if (!fbo) {
        return;
    }
    context.activeTexture.set(gl.TEXTURE0);
    gl.bindTexture(gl.TEXTURE_2D, fbo.colorAttachment.get());
    context.activeTexture.set(gl.TEXTURE1);
    var colorRampTexture = layer.colorRampTexture;
    if (!colorRampTexture) {
        colorRampTexture = layer.colorRampTexture = new performance.Texture(context, layer.colorRamp, gl.RGBA);
    }
    colorRampTexture.bind(gl.LINEAR, gl.CLAMP_TO_EDGE);
    painter.useProgram('heatmapTexture').draw(context, gl.TRIANGLES, DepthMode.disabled, StencilMode.disabled, painter.colorModeForRenderPass(), CullFaceMode.disabled, heatmapTextureUniformValues(painter, layer, 0, 1), layer.id, painter.viewportBuffer, painter.quadTriangleIndexBuffer, painter.viewportSegments, layer.paint, painter.transform.zoom);
}

function drawLine(painter, sourceCache, layer, coords) {
    if (painter.renderPass !== 'translucent') {
        return;
    }
    var opacity = layer.paint.get('line-opacity');
    var width = layer.paint.get('line-width');
    if (opacity.constantOr(1) === 0 || width.constantOr(1) === 0) {
        return;
    }
    var depthMode = painter.depthModeForSublayer(0, DepthMode.ReadOnly);
    var colorMode = painter.colorModeForRenderPass();
    var dasharray = layer.paint.get('line-dasharray');
    var patternProperty = layer.paint.get('line-pattern');
    var image = patternProperty.constantOr(1);
    var gradient = layer.paint.get('line-gradient');
    var crossfade = layer.getCrossfadeParameters();
    var programId = image ? 'linePattern' : dasharray ? 'lineSDF' : gradient ? 'lineGradient' : 'line';
    var context = painter.context;
    var gl = context.gl;
    var firstTile = true;
    for (var i = 0, list = coords; i < list.length; i += 1) {
        var coord = list[i];
        var tile = sourceCache.getTile(coord);
        if (image && !tile.patternsLoaded()) {
            continue;
        }
        var bucket = tile.getBucket(layer);
        if (!bucket) {
            continue;
        }
        var programConfiguration = bucket.programConfigurations.get(layer.id);
        var prevProgram = painter.context.program.get();
        var program = painter.useProgram(programId, programConfiguration);
        var programChanged = firstTile || program.program !== prevProgram;
        var constantPattern = patternProperty.constantOr(null);
        if (constantPattern && tile.imageAtlas) {
            var atlas = tile.imageAtlas;
            var posTo = atlas.patternPositions[constantPattern.to.toString()];
            var posFrom = atlas.patternPositions[constantPattern.from.toString()];
            if (posTo && posFrom) {
                programConfiguration.setConstantPatternPositions(posTo, posFrom);
            }
        }
        var uniformValues = image ? linePatternUniformValues(painter, tile, layer, crossfade) : dasharray ? lineSDFUniformValues(painter, tile, layer, dasharray, crossfade) : gradient ? lineGradientUniformValues(painter, tile, layer, bucket.lineClipsArray.length) : lineUniformValues(painter, tile, layer);
        if (image) {
            context.activeTexture.set(gl.TEXTURE0);
            tile.imageAtlasTexture.bind(gl.LINEAR, gl.CLAMP_TO_EDGE);
            programConfiguration.updatePaintBuffers(crossfade);
        } else if (dasharray && (programChanged || painter.lineAtlas.dirty)) {
            context.activeTexture.set(gl.TEXTURE0);
            painter.lineAtlas.bind(context);
        } else if (gradient) {
            var layerGradient = bucket.gradients[layer.id];
            var gradientTexture = layerGradient.texture;
            if (layer.gradientVersion !== layerGradient.version) {
                var textureResolution = 256;
                if (layer.stepInterpolant) {
                    var sourceMaxZoom = sourceCache.getSource().maxzoom;
                    var potentialOverzoom = coord.canonical.z === sourceMaxZoom ? Math.ceil(1 << painter.transform.maxZoom - coord.canonical.z) : 1;
                    var lineLength = bucket.maxLineLength / performance.EXTENT;
                    var maxTilePixelSize = 1024;
                    var maxTextureCoverage = lineLength * maxTilePixelSize * potentialOverzoom;
                    textureResolution = performance.clamp(performance.nextPowerOfTwo(maxTextureCoverage), 256, context.maxTextureSize);
                }
                layerGradient.gradient = performance.renderColorRamp({
                    expression: layer.gradientExpression(),
                    evaluationKey: 'lineProgress',
                    resolution: textureResolution,
                    image: layerGradient.gradient || undefined,
                    clips: bucket.lineClipsArray
                });
                if (layerGradient.texture) {
                    layerGradient.texture.update(layerGradient.gradient);
                } else {
                    layerGradient.texture = new performance.Texture(context, layerGradient.gradient, gl.RGBA);
                }
                layerGradient.version = layer.gradientVersion;
                gradientTexture = layerGradient.texture;
            }
            context.activeTexture.set(gl.TEXTURE0);
            gradientTexture.bind(layer.stepInterpolant ? gl.NEAREST : gl.LINEAR, gl.CLAMP_TO_EDGE);
        }
        program.draw(context, gl.TRIANGLES, depthMode, painter.stencilModeForClipping(coord), colorMode, CullFaceMode.disabled, uniformValues, layer.id, bucket.layoutVertexBuffer, bucket.indexBuffer, bucket.segments, layer.paint, painter.transform.zoom, programConfiguration, bucket.layoutVertexBuffer2);
        firstTile = false;
    }
}

function drawFill(painter, sourceCache, layer, coords) {
    var color = layer.paint.get('fill-color');
    var opacity = layer.paint.get('fill-opacity');
    if (opacity.constantOr(1) === 0) {
        return;
    }
    var colorMode = painter.colorModeForRenderPass();
    var pattern = layer.paint.get('fill-pattern');
    var pass = painter.opaquePassEnabledForLayer() && (!pattern.constantOr(1) && color.constantOr(performance.Color.transparent).a === 1 && opacity.constantOr(0) === 1) ? 'opaque' : 'translucent';
    if (painter.renderPass === pass) {
        var depthMode = painter.depthModeForSublayer(1, painter.renderPass === 'opaque' ? DepthMode.ReadWrite : DepthMode.ReadOnly);
        drawFillTiles(painter, sourceCache, layer, coords, depthMode, colorMode, false);
    }
    if (painter.renderPass === 'translucent' && layer.paint.get('fill-antialias')) {
        var depthMode$1 = painter.depthModeForSublayer(layer.getPaintProperty('fill-outline-color') ? 2 : 0, DepthMode.ReadOnly);
        drawFillTiles(painter, sourceCache, layer, coords, depthMode$1, colorMode, true);
    }
}
function drawFillTiles(painter, sourceCache, layer, coords, depthMode, colorMode, isOutline) {
    var gl = painter.context.gl;
    var patternProperty = layer.paint.get('fill-pattern');
    var image = patternProperty && patternProperty.constantOr(1);
    var crossfade = layer.getCrossfadeParameters();
    var drawMode, programName, uniformValues, indexBuffer, segments;
    if (!isOutline) {
        programName = image ? 'fillPattern' : 'fill';
        drawMode = gl.TRIANGLES;
    } else {
        programName = image && !layer.getPaintProperty('fill-outline-color') ? 'fillOutlinePattern' : 'fillOutline';
        drawMode = gl.LINES;
    }
    for (var i = 0, list = coords; i < list.length; i += 1) {
        var coord = list[i];
        var tile = sourceCache.getTile(coord);
        if (image && !tile.patternsLoaded()) {
            continue;
        }
        var bucket = tile.getBucket(layer);
        if (!bucket) {
            continue;
        }
        var programConfiguration = bucket.programConfigurations.get(layer.id);
        var program = painter.useProgram(programName, programConfiguration);
        if (image) {
            painter.context.activeTexture.set(gl.TEXTURE0);
            tile.imageAtlasTexture.bind(gl.LINEAR, gl.CLAMP_TO_EDGE);
            programConfiguration.updatePaintBuffers(crossfade);
        }
        var constantPattern = patternProperty.constantOr(null);
        if (constantPattern && tile.imageAtlas) {
            var atlas = tile.imageAtlas;
            var posTo = atlas.patternPositions[constantPattern.to.toString()];
            var posFrom = atlas.patternPositions[constantPattern.from.toString()];
            if (posTo && posFrom) {
                programConfiguration.setConstantPatternPositions(posTo, posFrom);
            }
        }
        var tileMatrix = painter.translatePosMatrix(coord.posMatrix, tile, layer.paint.get('fill-translate'), layer.paint.get('fill-translate-anchor'));
        if (!isOutline) {
            indexBuffer = bucket.indexBuffer;
            segments = bucket.segments;
            uniformValues = image ? fillPatternUniformValues(tileMatrix, painter, crossfade, tile) : fillUniformValues(tileMatrix);
        } else {
            indexBuffer = bucket.indexBuffer2;
            segments = bucket.segments2;
            var drawingBufferSize = [
                gl.drawingBufferWidth,
                gl.drawingBufferHeight
            ];
            uniformValues = programName === 'fillOutlinePattern' && image ? fillOutlinePatternUniformValues(tileMatrix, painter, crossfade, tile, drawingBufferSize) : fillOutlineUniformValues(tileMatrix, drawingBufferSize);
        }
        program.draw(painter.context, drawMode, depthMode, painter.stencilModeForClipping(coord), colorMode, CullFaceMode.disabled, uniformValues, layer.id, bucket.layoutVertexBuffer, indexBuffer, segments, layer.paint, painter.transform.zoom, programConfiguration);
    }
}

function draw(painter, source, layer, coords) {
    var opacity = layer.paint.get('fill-extrusion-opacity');
    if (opacity === 0) {
        return;
    }
    if (painter.renderPass === 'translucent') {
        var depthMode = new DepthMode(painter.context.gl.LEQUAL, DepthMode.ReadWrite, painter.depthRangeFor3D);
        if (opacity === 1 && !layer.paint.get('fill-extrusion-pattern').constantOr(1)) {
            var colorMode = painter.colorModeForRenderPass();
            drawExtrusionTiles(painter, source, layer, coords, depthMode, StencilMode.disabled, colorMode);
        } else {
            drawExtrusionTiles(painter, source, layer, coords, depthMode, StencilMode.disabled, ColorMode.disabled);
            drawExtrusionTiles(painter, source, layer, coords, depthMode, painter.stencilModeFor3D(), painter.colorModeForRenderPass());
        }
    }
}
function drawExtrusionTiles(painter, source, layer, coords, depthMode, stencilMode, colorMode) {
    var context = painter.context;
    var gl = context.gl;
    var patternProperty = layer.paint.get('fill-extrusion-pattern');
    var image = patternProperty.constantOr(1);
    var crossfade = layer.getCrossfadeParameters();
    var opacity = layer.paint.get('fill-extrusion-opacity');
    for (var i = 0, list = coords; i < list.length; i += 1) {
        var coord = list[i];
        var tile = source.getTile(coord);
        var bucket = tile.getBucket(layer);
        if (!bucket) {
            continue;
        }
        var programConfiguration = bucket.programConfigurations.get(layer.id);
        var program = painter.useProgram(image ? 'fillExtrusionPattern' : 'fillExtrusion', programConfiguration);
        if (image) {
            painter.context.activeTexture.set(gl.TEXTURE0);
            tile.imageAtlasTexture.bind(gl.LINEAR, gl.CLAMP_TO_EDGE);
            programConfiguration.updatePaintBuffers(crossfade);
        }
        var constantPattern = patternProperty.constantOr(null);
        if (constantPattern && tile.imageAtlas) {
            var atlas = tile.imageAtlas;
            var posTo = atlas.patternPositions[constantPattern.to.toString()];
            var posFrom = atlas.patternPositions[constantPattern.from.toString()];
            if (posTo && posFrom) {
                programConfiguration.setConstantPatternPositions(posTo, posFrom);
            }
        }
        var matrix = painter.translatePosMatrix(coord.posMatrix, tile, layer.paint.get('fill-extrusion-translate'), layer.paint.get('fill-extrusion-translate-anchor'));
        var shouldUseVerticalGradient = layer.paint.get('fill-extrusion-vertical-gradient');
        var uniformValues = image ? fillExtrusionPatternUniformValues(matrix, painter, shouldUseVerticalGradient, opacity, coord, crossfade, tile) : fillExtrusionUniformValues(matrix, painter, shouldUseVerticalGradient, opacity);
        program.draw(context, context.gl.TRIANGLES, depthMode, stencilMode, colorMode, CullFaceMode.backCCW, uniformValues, layer.id, bucket.layoutVertexBuffer, bucket.indexBuffer, bucket.segments, layer.paint, painter.transform.zoom, programConfiguration);
    }
}

function drawHillshade(painter, sourceCache, layer, tileIDs) {
    if (painter.renderPass !== 'offscreen' && painter.renderPass !== 'translucent') {
        return;
    }
    var context = painter.context;
    var depthMode = painter.depthModeForSublayer(0, DepthMode.ReadOnly);
    var colorMode = painter.colorModeForRenderPass();
    var ref = painter.renderPass === 'translucent' ? painter.stencilConfigForOverlap(tileIDs) : [
        {},
        tileIDs
    ];
    var stencilModes = ref[0];
    var coords = ref[1];
    for (var i = 0, list = coords; i < list.length; i += 1) {
        var coord = list[i];
        var tile = sourceCache.getTile(coord);
        if (tile.needsHillshadePrepare && painter.renderPass === 'offscreen') {
            prepareHillshade(painter, tile, layer, depthMode, StencilMode.disabled, colorMode);
        } else if (painter.renderPass === 'translucent') {
            renderHillshade(painter, tile, layer, depthMode, stencilModes[coord.overscaledZ], colorMode);
        }
    }
    context.viewport.set([
        0,
        0,
        painter.width,
        painter.height
    ]);
}
function renderHillshade(painter, tile, layer, depthMode, stencilMode, colorMode) {
    var context = painter.context;
    var gl = context.gl;
    var fbo = tile.fbo;
    if (!fbo) {
        return;
    }
    var program = painter.useProgram('hillshade');
    context.activeTexture.set(gl.TEXTURE0);
    gl.bindTexture(gl.TEXTURE_2D, fbo.colorAttachment.get());
    var uniformValues = hillshadeUniformValues(painter, tile, layer);
    program.draw(context, gl.TRIANGLES, depthMode, stencilMode, colorMode, CullFaceMode.disabled, uniformValues, layer.id, painter.rasterBoundsBuffer, painter.quadTriangleIndexBuffer, painter.rasterBoundsSegments);
}
function prepareHillshade(painter, tile, layer, depthMode, stencilMode, colorMode) {
    var context = painter.context;
    var gl = context.gl;
    var dem = tile.dem;
    if (dem && dem.data) {
        var tileSize = dem.dim;
        var textureStride = dem.stride;
        var pixelData = dem.getPixels();
        context.activeTexture.set(gl.TEXTURE1);
        context.pixelStoreUnpackPremultiplyAlpha.set(false);
        tile.demTexture = tile.demTexture || painter.getTileTexture(textureStride);
        if (tile.demTexture) {
            var demTexture = tile.demTexture;
            demTexture.update(pixelData, { premultiply: false });
            demTexture.bind(gl.NEAREST, gl.CLAMP_TO_EDGE);
        } else {
            tile.demTexture = new performance.Texture(context, pixelData, gl.RGBA, { premultiply: false });
            tile.demTexture.bind(gl.NEAREST, gl.CLAMP_TO_EDGE);
        }
        context.activeTexture.set(gl.TEXTURE0);
        var fbo = tile.fbo;
        if (!fbo) {
            var renderTexture = new performance.Texture(context, {
                width: tileSize,
                height: tileSize,
                data: null
            }, gl.RGBA);
            renderTexture.bind(gl.LINEAR, gl.CLAMP_TO_EDGE);
            fbo = tile.fbo = context.createFramebuffer(tileSize, tileSize, true);
            fbo.colorAttachment.set(renderTexture.texture);
        }
        context.bindFramebuffer.set(fbo.framebuffer);
        context.viewport.set([
            0,
            0,
            tileSize,
            tileSize
        ]);
        painter.useProgram('hillshadePrepare').draw(context, gl.TRIANGLES, depthMode, stencilMode, colorMode, CullFaceMode.disabled, hillshadeUniformPrepareValues(tile.tileID, dem), layer.id, painter.rasterBoundsBuffer, painter.quadTriangleIndexBuffer, painter.rasterBoundsSegments);
        tile.needsHillshadePrepare = false;
    }
}

function drawRaster(painter, sourceCache, layer, tileIDs) {
    if (painter.renderPass !== 'translucent') {
        return;
    }
    if (layer.paint.get('raster-opacity') === 0) {
        return;
    }
    if (!tileIDs.length) {
        return;
    }
    var context = painter.context;
    var gl = context.gl;
    var source = sourceCache.getSource();
    var program = painter.useProgram('raster');
    var colorMode = painter.colorModeForRenderPass();
    var ref = source instanceof ImageSource ? [
        {},
        tileIDs
    ] : painter.stencilConfigForOverlap(tileIDs);
    var stencilModes = ref[0];
    var coords = ref[1];
    var minTileZ = coords[coords.length - 1].overscaledZ;
    var align = !painter.options.moving;
    for (var i = 0, list = coords; i < list.length; i += 1) {
        var coord = list[i];
        var depthMode = painter.depthModeForSublayer(coord.overscaledZ - minTileZ, layer.paint.get('raster-opacity') === 1 ? DepthMode.ReadWrite : DepthMode.ReadOnly, gl.LESS);
        var tile = sourceCache.getTile(coord);
        var posMatrix = painter.transform.calculatePosMatrix(coord.toUnwrapped(), align);
        tile.registerFadeDuration(layer.paint.get('raster-fade-duration'));
        var parentTile = sourceCache.findLoadedParent(coord, 0), fade = getFadeValues(tile, parentTile, sourceCache, layer, painter.transform);
        var parentScaleBy = void 0, parentTL = void 0;
        var textureFilter = layer.paint.get('raster-resampling') === 'nearest' ? gl.NEAREST : gl.LINEAR;
        context.activeTexture.set(gl.TEXTURE0);
        tile.texture.bind(textureFilter, gl.CLAMP_TO_EDGE, gl.LINEAR_MIPMAP_NEAREST);
        context.activeTexture.set(gl.TEXTURE1);
        if (parentTile) {
            parentTile.texture.bind(textureFilter, gl.CLAMP_TO_EDGE, gl.LINEAR_MIPMAP_NEAREST);
            parentScaleBy = Math.pow(2, parentTile.tileID.overscaledZ - tile.tileID.overscaledZ);
            parentTL = [
                tile.tileID.canonical.x * parentScaleBy % 1,
                tile.tileID.canonical.y * parentScaleBy % 1
            ];
        } else {
            tile.texture.bind(textureFilter, gl.CLAMP_TO_EDGE, gl.LINEAR_MIPMAP_NEAREST);
        }
        var uniformValues = rasterUniformValues(posMatrix, parentTL || [
            0,
            0
        ], parentScaleBy || 1, fade, layer);
        if (source instanceof ImageSource) {
            program.draw(context, gl.TRIANGLES, depthMode, StencilMode.disabled, colorMode, CullFaceMode.disabled, uniformValues, layer.id, source.boundsBuffer, painter.quadTriangleIndexBuffer, source.boundsSegments);
        } else {
            program.draw(context, gl.TRIANGLES, depthMode, stencilModes[coord.overscaledZ], colorMode, CullFaceMode.disabled, uniformValues, layer.id, painter.rasterBoundsBuffer, painter.quadTriangleIndexBuffer, painter.rasterBoundsSegments);
        }
    }
}
function getFadeValues(tile, parentTile, sourceCache, layer, transform) {
    var fadeDuration = layer.paint.get('raster-fade-duration');
    if (fadeDuration > 0) {
        var now = performance.browser.now();
        var sinceTile = (now - tile.timeAdded) / fadeDuration;
        var sinceParent = parentTile ? (now - parentTile.timeAdded) / fadeDuration : -1;
        var source = sourceCache.getSource();
        var idealZ = transform.coveringZoomLevel({
            tileSize: source.tileSize,
            roundZoom: source.roundZoom
        });
        var fadeIn = !parentTile || Math.abs(parentTile.tileID.overscaledZ - idealZ) > Math.abs(tile.tileID.overscaledZ - idealZ);
        var childOpacity = fadeIn && tile.refreshedUponExpiration ? 1 : performance.clamp(fadeIn ? sinceTile : 1 - sinceParent, 0, 1);
        if (tile.refreshedUponExpiration && sinceTile >= 1) {
            tile.refreshedUponExpiration = false;
        }
        if (parentTile) {
            return {
                opacity: 1,
                mix: 1 - childOpacity
            };
        } else {
            return {
                opacity: childOpacity,
                mix: 0
            };
        }
    } else {
        return {
            opacity: 1,
            mix: 0
        };
    }
}

function drawBackground(painter, sourceCache, layer) {
    var color = layer.paint.get('background-color');
    var opacity = layer.paint.get('background-opacity');
    if (opacity === 0) {
        return;
    }
    var context = painter.context;
    var gl = context.gl;
    var transform = painter.transform;
    var tileSize = transform.tileSize;
    var image = layer.paint.get('background-pattern');
    if (painter.isPatternMissing(image)) {
        return;
    }
    var pass = !image && color.a === 1 && opacity === 1 && painter.opaquePassEnabledForLayer() ? 'opaque' : 'translucent';
    if (painter.renderPass !== pass) {
        return;
    }
    var stencilMode = StencilMode.disabled;
    var depthMode = painter.depthModeForSublayer(0, pass === 'opaque' ? DepthMode.ReadWrite : DepthMode.ReadOnly);
    var colorMode = painter.colorModeForRenderPass();
    var program = painter.useProgram(image ? 'backgroundPattern' : 'background');
    var tileIDs = transform.coveringTiles({ tileSize: tileSize });
    if (image) {
        context.activeTexture.set(gl.TEXTURE0);
        painter.imageManager.bind(painter.context);
    }
    var crossfade = layer.getCrossfadeParameters();
    for (var i = 0, list = tileIDs; i < list.length; i += 1) {
        var tileID = list[i];
        var matrix = painter.transform.calculatePosMatrix(tileID.toUnwrapped());
        var uniformValues = image ? backgroundPatternUniformValues(matrix, opacity, painter, image, {
            tileID: tileID,
            tileSize: tileSize
        }, crossfade) : backgroundUniformValues(matrix, opacity, color);
        program.draw(context, gl.TRIANGLES, depthMode, stencilMode, colorMode, CullFaceMode.disabled, uniformValues, layer.id, painter.tileExtentBuffer, painter.quadTriangleIndexBuffer, painter.tileExtentSegments);
    }
}

var topColor = new performance.Color(1, 0, 0, 1);
var btmColor = new performance.Color(0, 1, 0, 1);
var leftColor = new performance.Color(0, 0, 1, 1);
var rightColor = new performance.Color(1, 0, 1, 1);
var centerColor = new performance.Color(0, 1, 1, 1);
function drawDebugPadding(painter) {
    var padding = painter.transform.padding;
    var lineWidth = 3;
    drawHorizontalLine(painter, painter.transform.height - (padding.top || 0), lineWidth, topColor);
    drawHorizontalLine(painter, padding.bottom || 0, lineWidth, btmColor);
    drawVerticalLine(painter, padding.left || 0, lineWidth, leftColor);
    drawVerticalLine(painter, painter.transform.width - (padding.right || 0), lineWidth, rightColor);
    var center = painter.transform.centerPoint;
    drawCrosshair(painter, center.x, painter.transform.height - center.y, centerColor);
}
function drawCrosshair(painter, x, y, color) {
    var size = 20;
    var lineWidth = 2;
    drawDebugSSRect(painter, x - lineWidth / 2, y - size / 2, lineWidth, size, color);
    drawDebugSSRect(painter, x - size / 2, y - lineWidth / 2, size, lineWidth, color);
}
function drawHorizontalLine(painter, y, lineWidth, color) {
    drawDebugSSRect(painter, 0, y + lineWidth / 2, painter.transform.width, lineWidth, color);
}
function drawVerticalLine(painter, x, lineWidth, color) {
    drawDebugSSRect(painter, x - lineWidth / 2, 0, lineWidth, painter.transform.height, color);
}
function drawDebugSSRect(painter, x, y, width, height, color) {
    var context = painter.context;
    var gl = context.gl;
    gl.enable(gl.SCISSOR_TEST);
    gl.scissor(x * performance.browser.devicePixelRatio, y * performance.browser.devicePixelRatio, width * performance.browser.devicePixelRatio, height * performance.browser.devicePixelRatio);
    context.clear({ color: color });
    gl.disable(gl.SCISSOR_TEST);
}
function drawDebug(painter, sourceCache, coords) {
    for (var i = 0; i < coords.length; i++) {
        drawDebugTile(painter, sourceCache, coords[i]);
    }
}
function drawDebugTile(painter, sourceCache, coord) {
    var context = painter.context;
    var gl = context.gl;
    var posMatrix = coord.posMatrix;
    var program = painter.useProgram('debug');
    var depthMode = DepthMode.disabled;
    var stencilMode = StencilMode.disabled;
    var colorMode = painter.colorModeForRenderPass();
    var id = '$debug';
    context.activeTexture.set(gl.TEXTURE0);
    painter.emptyTexture.bind(gl.LINEAR, gl.CLAMP_TO_EDGE);
    program.draw(context, gl.LINE_STRIP, depthMode, stencilMode, colorMode, CullFaceMode.disabled, debugUniformValues(posMatrix, performance.Color.red), id, painter.debugBuffer, painter.tileBorderIndexBuffer, painter.debugSegments);
    var tileRawData = sourceCache.getTileByID(coord.key).latestRawTileData;
    var tileByteLength = tileRawData && tileRawData.byteLength || 0;
    var tileSizeKb = Math.floor(tileByteLength / 1024);
    var tileSize = sourceCache.getTile(coord).tileSize;
    var scaleRatio = 512 / Math.min(tileSize, 512) * (coord.overscaledZ / painter.transform.zoom) * 0.5;
    var tileIdText = coord.canonical.toString();
    if (coord.overscaledZ !== coord.canonical.z) {
        tileIdText += ' => ' + coord.overscaledZ;
    }
    var tileLabel = tileIdText + ' ' + tileSizeKb + 'kb';
    drawTextToOverlay(painter, tileLabel);
    program.draw(context, gl.TRIANGLES, depthMode, stencilMode, ColorMode.alphaBlended, CullFaceMode.disabled, debugUniformValues(posMatrix, performance.Color.transparent, scaleRatio), id, painter.debugBuffer, painter.quadTriangleIndexBuffer, painter.debugSegments);
}
function drawTextToOverlay(painter, text) {
    painter.initDebugOverlayCanvas();
    var canvas = painter.debugOverlayCanvas;
    var gl = painter.context.gl;
    var ctx2d = painter.debugOverlayCanvas.getContext('2d');
    ctx2d.clearRect(0, 0, canvas.width, canvas.height);
    ctx2d.shadowColor = 'white';
    ctx2d.shadowBlur = 2;
    ctx2d.lineWidth = 1.5;
    ctx2d.strokeStyle = 'white';
    ctx2d.textBaseline = 'top';
    ctx2d.font = 'bold ' + 36 + 'px Open Sans, sans-serif';
    ctx2d.fillText(text, 5, 5);
    ctx2d.strokeText(text, 5, 5);
    painter.debugOverlayTexture.update(canvas);
    painter.debugOverlayTexture.bind(gl.LINEAR, gl.CLAMP_TO_EDGE);
}

function drawCustom(painter, sourceCache, layer) {
    var context = painter.context;
    var implementation = layer.implementation;
    if (painter.renderPass === 'offscreen') {
        var prerender = implementation.prerender;
        if (prerender) {
            painter.setCustomLayerDefaults();
            context.setColorMode(painter.colorModeForRenderPass());
            prerender.call(implementation, context.gl, painter.transform.customLayerMatrix());
            context.setDirty();
            painter.setBaseState();
        }
    } else if (painter.renderPass === 'translucent') {
        painter.setCustomLayerDefaults();
        context.setColorMode(painter.colorModeForRenderPass());
        context.setStencilMode(StencilMode.disabled);
        var depthMode = implementation.renderingMode === '3d' ? new DepthMode(painter.context.gl.LEQUAL, DepthMode.ReadWrite, painter.depthRangeFor3D) : painter.depthModeForSublayer(0, DepthMode.ReadOnly);
        context.setDepthMode(depthMode);
        implementation.render(context.gl, painter.transform.customLayerMatrix());
        context.setDirty();
        painter.setBaseState();
        context.bindFramebuffer.set(null);
    }
}

var draw$1 = {
    symbol: drawSymbols,
    circle: drawCircles,
    heatmap: drawHeatmap,
    line: drawLine,
    fill: drawFill,
    'fill-extrusion': draw,
    hillshade: drawHillshade,
    raster: drawRaster,
    background: drawBackground,
    debug: drawDebug,
    custom: drawCustom
};
var Painter = function Painter(gl, transform) {
    this.context = new Context(gl);
    this.transform = transform;
    this._tileTextures = {};
    this.setup();
    this.numSublayers = SourceCache.maxUnderzooming + SourceCache.maxOverzooming + 1;
    this.depthEpsilon = 1 / Math.pow(2, 16);
    this.crossTileSymbolIndex = new CrossTileSymbolIndex();
    this.gpuTimers = {};
};
Painter.prototype.resize = function resize(width, height) {
    this.width = width * performance.browser.devicePixelRatio;
    this.height = height * performance.browser.devicePixelRatio;
    this.context.viewport.set([
        0,
        0,
        this.width,
        this.height
    ]);
    if (this.style) {
        for (var i = 0, list = this.style._order; i < list.length; i += 1) {
            var layerId = list[i];
            this.style._layers[layerId].resize();
        }
    }
};
Painter.prototype.setup = function setup() {
    var context = this.context;
    var tileExtentArray = new performance.StructArrayLayout2i4();
    tileExtentArray.emplaceBack(0, 0);
    tileExtentArray.emplaceBack(performance.EXTENT, 0);
    tileExtentArray.emplaceBack(0, performance.EXTENT);
    tileExtentArray.emplaceBack(performance.EXTENT, performance.EXTENT);
    this.tileExtentBuffer = context.createVertexBuffer(tileExtentArray, posAttributes.members);
    this.tileExtentSegments = performance.SegmentVector.simpleSegment(0, 0, 4, 2);
    var debugArray = new performance.StructArrayLayout2i4();
    debugArray.emplaceBack(0, 0);
    debugArray.emplaceBack(performance.EXTENT, 0);
    debugArray.emplaceBack(0, performance.EXTENT);
    debugArray.emplaceBack(performance.EXTENT, performance.EXTENT);
    this.debugBuffer = context.createVertexBuffer(debugArray, posAttributes.members);
    this.debugSegments = performance.SegmentVector.simpleSegment(0, 0, 4, 5);
    var rasterBoundsArray = new performance.StructArrayLayout4i8();
    rasterBoundsArray.emplaceBack(0, 0, 0, 0);
    rasterBoundsArray.emplaceBack(performance.EXTENT, 0, performance.EXTENT, 0);
    rasterBoundsArray.emplaceBack(0, performance.EXTENT, 0, performance.EXTENT);
    rasterBoundsArray.emplaceBack(performance.EXTENT, performance.EXTENT, performance.EXTENT, performance.EXTENT);
    this.rasterBoundsBuffer = context.createVertexBuffer(rasterBoundsArray, rasterBoundsAttributes.members);
    this.rasterBoundsSegments = performance.SegmentVector.simpleSegment(0, 0, 4, 2);
    var viewportArray = new performance.StructArrayLayout2i4();
    viewportArray.emplaceBack(0, 0);
    viewportArray.emplaceBack(1, 0);
    viewportArray.emplaceBack(0, 1);
    viewportArray.emplaceBack(1, 1);
    this.viewportBuffer = context.createVertexBuffer(viewportArray, posAttributes.members);
    this.viewportSegments = performance.SegmentVector.simpleSegment(0, 0, 4, 2);
    var tileLineStripIndices = new performance.StructArrayLayout1ui2();
    tileLineStripIndices.emplaceBack(0);
    tileLineStripIndices.emplaceBack(1);
    tileLineStripIndices.emplaceBack(3);
    tileLineStripIndices.emplaceBack(2);
    tileLineStripIndices.emplaceBack(0);
    this.tileBorderIndexBuffer = context.createIndexBuffer(tileLineStripIndices);
    var quadTriangleIndices = new performance.StructArrayLayout3ui6();
    quadTriangleIndices.emplaceBack(0, 1, 2);
    quadTriangleIndices.emplaceBack(2, 1, 3);
    this.quadTriangleIndexBuffer = context.createIndexBuffer(quadTriangleIndices);
    this.emptyTexture = new performance.Texture(context, {
        width: 1,
        height: 1,
        data: new Uint8Array([
            0,
            0,
            0,
            0
        ])
    }, context.gl.RGBA);
    var gl = this.context.gl;
    this.stencilClearMode = new StencilMode({
        func: gl.ALWAYS,
        mask: 0
    }, 0, 255, gl.ZERO, gl.ZERO, gl.ZERO);
};
Painter.prototype.clearStencil = function clearStencil() {
    var context = this.context;
    var gl = context.gl;
    this.nextStencilID = 1;
    this.currentStencilSource = undefined;
    var matrix = performance.create();
    performance.ortho(matrix, 0, this.width, this.height, 0, 0, 1);
    performance.scale(matrix, matrix, [
        gl.drawingBufferWidth,
        gl.drawingBufferHeight,
        0
    ]);
    this.useProgram('clippingMask').draw(context, gl.TRIANGLES, DepthMode.disabled, this.stencilClearMode, ColorMode.disabled, CullFaceMode.disabled, clippingMaskUniformValues(matrix), '$clipping', this.viewportBuffer, this.quadTriangleIndexBuffer, this.viewportSegments);
};
Painter.prototype._renderTileClippingMasks = function _renderTileClippingMasks(layer, tileIDs) {
    if (this.currentStencilSource === layer.source || !layer.isTileClipped() || !tileIDs || !tileIDs.length) {
        return;
    }
    this.currentStencilSource = layer.source;
    var context = this.context;
    var gl = context.gl;
    if (this.nextStencilID + tileIDs.length > 256) {
        this.clearStencil();
    }
    context.setColorMode(ColorMode.disabled);
    context.setDepthMode(DepthMode.disabled);
    var program = this.useProgram('clippingMask');
    this._tileClippingMaskIDs = {};
    for (var i = 0, list = tileIDs; i < list.length; i += 1) {
        var tileID = list[i];
        var id = this._tileClippingMaskIDs[tileID.key] = this.nextStencilID++;
        program.draw(context, gl.TRIANGLES, DepthMode.disabled, new StencilMode({
            func: gl.ALWAYS,
            mask: 0
        }, id, 255, gl.KEEP, gl.KEEP, gl.REPLACE), ColorMode.disabled, CullFaceMode.disabled, clippingMaskUniformValues(tileID.posMatrix), '$clipping', this.tileExtentBuffer, this.quadTriangleIndexBuffer, this.tileExtentSegments);
    }
};
Painter.prototype.stencilModeFor3D = function stencilModeFor3D() {
    this.currentStencilSource = undefined;
    if (this.nextStencilID + 1 > 256) {
        this.clearStencil();
    }
    var id = this.nextStencilID++;
    var gl = this.context.gl;
    return new StencilMode({
        func: gl.NOTEQUAL,
        mask: 255
    }, id, 255, gl.KEEP, gl.KEEP, gl.REPLACE);
};
Painter.prototype.stencilModeForClipping = function stencilModeForClipping(tileID) {
    var gl = this.context.gl;
    return new StencilMode({
        func: gl.EQUAL,
        mask: 255
    }, this._tileClippingMaskIDs[tileID.key], 0, gl.KEEP, gl.KEEP, gl.REPLACE);
};
Painter.prototype.stencilConfigForOverlap = function stencilConfigForOverlap(tileIDs) {
    var obj;
    var gl = this.context.gl;
    var coords = tileIDs.sort(function (a, b) {
        return b.overscaledZ - a.overscaledZ;
    });
    var minTileZ = coords[coords.length - 1].overscaledZ;
    var stencilValues = coords[0].overscaledZ - minTileZ + 1;
    if (stencilValues > 1) {
        this.currentStencilSource = undefined;
        if (this.nextStencilID + stencilValues > 256) {
            this.clearStencil();
        }
        var zToStencilMode = {};
        for (var i = 0; i < stencilValues; i++) {
            zToStencilMode[i + minTileZ] = new StencilMode({
                func: gl.GEQUAL,
                mask: 255
            }, i + this.nextStencilID, 255, gl.KEEP, gl.KEEP, gl.REPLACE);
        }
        this.nextStencilID += stencilValues;
        return [
            zToStencilMode,
            coords
        ];
    }
    return [
        (obj = {}, obj[minTileZ] = StencilMode.disabled, obj),
        coords
    ];
};
Painter.prototype.colorModeForRenderPass = function colorModeForRenderPass() {
    var gl = this.context.gl;
    if (this._showOverdrawInspector) {
        var numOverdrawSteps = 8;
        var a = 1 / numOverdrawSteps;
        return new ColorMode([
            gl.CONSTANT_COLOR,
            gl.ONE
        ], new performance.Color(a, a, a, 0), [
            true,
            true,
            true,
            true
        ]);
    } else if (this.renderPass === 'opaque') {
        return ColorMode.unblended;
    } else {
        return ColorMode.alphaBlended;
    }
};
Painter.prototype.depthModeForSublayer = function depthModeForSublayer(n, mask, func) {
    if (!this.opaquePassEnabledForLayer()) {
        return DepthMode.disabled;
    }
    var depth = 1 - ((1 + this.currentLayer) * this.numSublayers + n) * this.depthEpsilon;
    return new DepthMode(func || this.context.gl.LEQUAL, mask, [
        depth,
        depth
    ]);
};
Painter.prototype.opaquePassEnabledForLayer = function opaquePassEnabledForLayer() {
    return this.currentLayer < this.opaquePassCutoff;
};
Painter.prototype.render = function render(style, options) {
    var this$1 = this;
    this.style = style;
    this.options = options;
    this.lineAtlas = style.lineAtlas;
    this.imageManager = style.imageManager;
    this.glyphManager = style.glyphManager;
    this.symbolFadeChange = style.placement.symbolFadeChange(performance.browser.now());
    this.imageManager.beginFrame();
    var layerIds = this.style._order;
    var sourceCaches = this.style.sourceCaches;
    for (var id in sourceCaches) {
        var sourceCache = sourceCaches[id];
        if (sourceCache.used) {
            sourceCache.prepare(this.context);
        }
    }
    var coordsAscending = {};
    var coordsDescending = {};
    var coordsDescendingSymbol = {};
    for (var id$1 in sourceCaches) {
        var sourceCache$1 = sourceCaches[id$1];
        coordsAscending[id$1] = sourceCache$1.getVisibleCoordinates();
        coordsDescending[id$1] = coordsAscending[id$1].slice().reverse();
        coordsDescendingSymbol[id$1] = sourceCache$1.getVisibleCoordinates(true).reverse();
    }
    this.opaquePassCutoff = Infinity;
    for (var i = 0; i < layerIds.length; i++) {
        var layerId = layerIds[i];
        if (this.style._layers[layerId].is3D()) {
            this.opaquePassCutoff = i;
            break;
        }
    }
    this.renderPass = 'offscreen';
    for (var i$1 = 0, list = layerIds; i$1 < list.length; i$1 += 1) {
        var layerId$1 = list[i$1];
        var layer = this.style._layers[layerId$1];
        if (!layer.hasOffscreenPass() || layer.isHidden(this.transform.zoom)) {
            continue;
        }
        var coords = coordsDescending[layer.source];
        if (layer.type !== 'custom' && !coords.length) {
            continue;
        }
        this.renderLayer(this, sourceCaches[layer.source], layer, coords);
    }
    this.context.bindFramebuffer.set(null);
    this.context.clear({
        color: options.showOverdrawInspector ? performance.Color.black : performance.Color.transparent,
        depth: 1
    });
    this.clearStencil();
    this._showOverdrawInspector = options.showOverdrawInspector;
    this.depthRangeFor3D = [
        0,
        1 - (style._order.length + 2) * this.numSublayers * this.depthEpsilon
    ];
    this.renderPass = 'opaque';
    for (this.currentLayer = layerIds.length - 1; this.currentLayer >= 0; this.currentLayer--) {
        var layer$1 = this.style._layers[layerIds[this.currentLayer]];
        var sourceCache$2 = sourceCaches[layer$1.source];
        var coords$1 = coordsAscending[layer$1.source];
        this._renderTileClippingMasks(layer$1, coords$1);
        this.renderLayer(this, sourceCache$2, layer$1, coords$1);
    }
    this.renderPass = 'translucent';
    for (this.currentLayer = 0; this.currentLayer < layerIds.length; this.currentLayer++) {
        var layer$2 = this.style._layers[layerIds[this.currentLayer]];
        var sourceCache$3 = sourceCaches[layer$2.source];
        var coords$2 = (layer$2.type === 'symbol' ? coordsDescendingSymbol : coordsDescending)[layer$2.source];
        this._renderTileClippingMasks(layer$2, coordsAscending[layer$2.source]);
        this.renderLayer(this, sourceCache$3, layer$2, coords$2);
    }
    if (this.options.showTileBoundaries) {
        var selectedSource;
        var sourceCache$4;
        var layers = performance.values(this.style._layers);
        layers.forEach(function (layer) {
            if (layer.source && !layer.isHidden(this$1.transform.zoom)) {
                if (layer.source !== (sourceCache$4 && sourceCache$4.id)) {
                    sourceCache$4 = this$1.style.sourceCaches[layer.source];
                }
                if (!selectedSource || selectedSource.getSource().maxzoom < sourceCache$4.getSource().maxzoom) {
                    selectedSource = sourceCache$4;
                }
            }
        });
        if (selectedSource) {
            draw$1.debug(this, selectedSource, selectedSource.getVisibleCoordinates());
        }
    }
    if (this.options.showPadding) {
        drawDebugPadding(this);
    }
    this.context.setDefault();
};
Painter.prototype.renderLayer = function renderLayer(painter, sourceCache, layer, coords) {
    if (layer.isHidden(this.transform.zoom)) {
        return;
    }
    if (layer.type !== 'background' && layer.type !== 'custom' && !coords.length) {
        return;
    }
    this.id = layer.id;
    this.gpuTimingStart(layer);
    draw$1[layer.type](painter, sourceCache, layer, coords, this.style.placement.variableOffsets);
    this.gpuTimingEnd();
};
Painter.prototype.gpuTimingStart = function gpuTimingStart(layer) {
    if (!this.options.gpuTiming) {
        return;
    }
    var ext = this.context.extTimerQuery;
    var layerTimer = this.gpuTimers[layer.id];
    if (!layerTimer) {
        layerTimer = this.gpuTimers[layer.id] = {
            calls: 0,
            cpuTime: 0,
            query: ext.createQueryEXT()
        };
    }
    layerTimer.calls++;
    ext.beginQueryEXT(ext.TIME_ELAPSED_EXT, layerTimer.query);
};
Painter.prototype.gpuTimingEnd = function gpuTimingEnd() {
    if (!this.options.gpuTiming) {
        return;
    }
    var ext = this.context.extTimerQuery;
    ext.endQueryEXT(ext.TIME_ELAPSED_EXT);
};
Painter.prototype.collectGpuTimers = function collectGpuTimers() {
    var currentLayerTimers = this.gpuTimers;
    this.gpuTimers = {};
    return currentLayerTimers;
};
Painter.prototype.queryGpuTimers = function queryGpuTimers(gpuTimers) {
    var layers = {};
    for (var layerId in gpuTimers) {
        var gpuTimer = gpuTimers[layerId];
        var ext = this.context.extTimerQuery;
        var gpuTime = ext.getQueryObjectEXT(gpuTimer.query, ext.QUERY_RESULT_EXT) / (1000 * 1000);
        ext.deleteQueryEXT(gpuTimer.query);
        layers[layerId] = gpuTime;
    }
    return layers;
};
Painter.prototype.translatePosMatrix = function translatePosMatrix(matrix, tile, translate, translateAnchor, inViewportPixelUnitsUnits) {
    if (!translate[0] && !translate[1]) {
        return matrix;
    }
    var angle = inViewportPixelUnitsUnits ? translateAnchor === 'map' ? this.transform.angle : 0 : translateAnchor === 'viewport' ? -this.transform.angle : 0;
    if (angle) {
        var sinA = Math.sin(angle);
        var cosA = Math.cos(angle);
        translate = [
            translate[0] * cosA - translate[1] * sinA,
            translate[0] * sinA + translate[1] * cosA
        ];
    }
    var translation = [
        inViewportPixelUnitsUnits ? translate[0] : pixelsToTileUnits(tile, translate[0], this.transform.zoom),
        inViewportPixelUnitsUnits ? translate[1] : pixelsToTileUnits(tile, translate[1], this.transform.zoom),
        0
    ];
    var translatedMatrix = new Float32Array(16);
    performance.translate(translatedMatrix, matrix, translation);
    return translatedMatrix;
};
Painter.prototype.saveTileTexture = function saveTileTexture(texture) {
    var textures = this._tileTextures[texture.size[0]];
    if (!textures) {
        this._tileTextures[texture.size[0]] = [texture];
    } else {
        textures.push(texture);
    }
};
Painter.prototype.getTileTexture = function getTileTexture(size) {
    var textures = this._tileTextures[size];
    return textures && textures.length > 0 ? textures.pop() : null;
};
Painter.prototype.isPatternMissing = function isPatternMissing(image) {
    if (!image) {
        return false;
    }
    if (!image.from || !image.to) {
        return true;
    }
    var imagePosA = this.imageManager.getPattern(image.from.toString());
    var imagePosB = this.imageManager.getPattern(image.to.toString());
    return !imagePosA || !imagePosB;
};
Painter.prototype.useProgram = function useProgram(name, programConfiguration) {
    this.cache = this.cache || {};
    var key = '' + name + (programConfiguration ? programConfiguration.cacheKey : '') + (this._showOverdrawInspector ? '/overdraw' : '');
    if (!this.cache[key]) {
        this.cache[key] = new Program$1(this.context, name, shaders[name], programConfiguration, programUniforms[name], this._showOverdrawInspector);
    }
    return this.cache[key];
};
Painter.prototype.setCustomLayerDefaults = function setCustomLayerDefaults() {
    this.context.unbindVAO();
    this.context.cullFace.setDefault();
    this.context.activeTexture.setDefault();
    this.context.pixelStoreUnpack.setDefault();
    this.context.pixelStoreUnpackPremultiplyAlpha.setDefault();
    this.context.pixelStoreUnpackFlipY.setDefault();
};
Painter.prototype.setBaseState = function setBaseState() {
    var gl = this.context.gl;
    this.context.cullFace.set(false);
    this.context.viewport.set([
        0,
        0,
        this.width,
        this.height
    ]);
    this.context.blendEquation.set(gl.FUNC_ADD);
};
Painter.prototype.initDebugOverlayCanvas = function initDebugOverlayCanvas() {
    if (this.debugOverlayCanvas == null) {
        this.debugOverlayCanvas = performance.window.document.createElement('canvas');
        this.debugOverlayCanvas.width = 512;
        this.debugOverlayCanvas.height = 512;
        var gl = this.context.gl;
        this.debugOverlayTexture = new performance.Texture(this.context, this.debugOverlayCanvas, gl.RGBA);
    }
};
Painter.prototype.destroy = function destroy() {
    this.emptyTexture.destroy();
    if (this.debugOverlayTexture) {
        this.debugOverlayTexture.destroy();
    }
};

var Frustum = function Frustum(points_, planes_) {
    this.points = points_;
    this.planes = planes_;
};
Frustum.fromInvProjectionMatrix = function fromInvProjectionMatrix(invProj, worldSize, zoom) {
    var clipSpaceCorners = [
        [
            -1,
            1,
            -1,
            1
        ],
        [
            1,
            1,
            -1,
            1
        ],
        [
            1,
            -1,
            -1,
            1
        ],
        [
            -1,
            -1,
            -1,
            1
        ],
        [
            -1,
            1,
            1,
            1
        ],
        [
            1,
            1,
            1,
            1
        ],
        [
            1,
            -1,
            1,
            1
        ],
        [
            -1,
            -1,
            1,
            1
        ]
    ];
    var scale = Math.pow(2, zoom);
    var frustumCoords = clipSpaceCorners.map(function (v) {
        return performance.transformMat4([], v, invProj);
    }).map(function (v) {
        return performance.scale$1([], v, 1 / v[3] / worldSize * scale);
    });
    var frustumPlanePointIndices = [
        [
            0,
            1,
            2
        ],
        [
            6,
            5,
            4
        ],
        [
            0,
            3,
            7
        ],
        [
            2,
            1,
            5
        ],
        [
            3,
            2,
            6
        ],
        [
            0,
            4,
            5
        ]
    ];
    var frustumPlanes = frustumPlanePointIndices.map(function (p) {
        var a = performance.sub([], frustumCoords[p[0]], frustumCoords[p[1]]);
        var b = performance.sub([], frustumCoords[p[2]], frustumCoords[p[1]]);
        var n = performance.normalize([], performance.cross([], a, b));
        var d = -performance.dot(n, frustumCoords[p[1]]);
        return n.concat(d);
    });
    return new Frustum(frustumCoords, frustumPlanes);
};
var Aabb = function Aabb(min_, max_) {
    this.min = min_;
    this.max = max_;
    this.center = performance.scale$2([], performance.add([], this.min, this.max), 0.5);
};
Aabb.prototype.quadrant = function quadrant(index) {
    var split = [
        index % 2 === 0,
        index < 2
    ];
    var qMin = performance.clone$2(this.min);
    var qMax = performance.clone$2(this.max);
    for (var axis = 0; axis < split.length; axis++) {
        qMin[axis] = split[axis] ? this.min[axis] : this.center[axis];
        qMax[axis] = split[axis] ? this.center[axis] : this.max[axis];
    }
    qMax[2] = this.max[2];
    return new Aabb(qMin, qMax);
};
Aabb.prototype.distanceX = function distanceX(point) {
    var pointOnAabb = Math.max(Math.min(this.max[0], point[0]), this.min[0]);
    return pointOnAabb - point[0];
};
Aabb.prototype.distanceY = function distanceY(point) {
    var pointOnAabb = Math.max(Math.min(this.max[1], point[1]), this.min[1]);
    return pointOnAabb - point[1];
};
Aabb.prototype.intersects = function intersects(frustum) {
    var aabbPoints = [
        [
            this.min[0],
            this.min[1],
            0,
            1
        ],
        [
            this.max[0],
            this.min[1],
            0,
            1
        ],
        [
            this.max[0],
            this.max[1],
            0,
            1
        ],
        [
            this.min[0],
            this.max[1],
            0,
            1
        ]
    ];
    var fullyInside = true;
    for (var p = 0; p < frustum.planes.length; p++) {
        var plane = frustum.planes[p];
        var pointsInside = 0;
        for (var i = 0; i < aabbPoints.length; i++) {
            pointsInside += performance.dot$1(plane, aabbPoints[i]) >= 0;
        }
        if (pointsInside === 0) {
            return 0;
        }
        if (pointsInside !== aabbPoints.length) {
            fullyInside = false;
        }
    }
    if (fullyInside) {
        return 2;
    }
    for (var axis = 0; axis < 3; axis++) {
        var projMin = Number.MAX_VALUE;
        var projMax = -Number.MAX_VALUE;
        for (var p$1 = 0; p$1 < frustum.points.length; p$1++) {
            var projectedPoint = frustum.points[p$1][axis] - this.min[axis];
            projMin = Math.min(projMin, projectedPoint);
            projMax = Math.max(projMax, projectedPoint);
        }
        if (projMax < 0 || projMin > this.max[axis] - this.min[axis]) {
            return 0;
        }
    }
    return 1;
};

var EdgeInsets = function EdgeInsets(top, bottom, left, right) {
    if (top === void 0)
        top = 0;
    if (bottom === void 0)
        bottom = 0;
    if (left === void 0)
        left = 0;
    if (right === void 0)
        right = 0;
    if (isNaN(top) || top < 0 || isNaN(bottom) || bottom < 0 || isNaN(left) || left < 0 || isNaN(right) || right < 0) {
        throw new Error('Invalid value for edge-insets, top, bottom, left and right must all be numbers');
    }
    this.top = top;
    this.bottom = bottom;
    this.left = left;
    this.right = right;
};
EdgeInsets.prototype.interpolate = function interpolate(start, target, t) {
    if (target.top != null && start.top != null) {
        this.top = performance.number(start.top, target.top, t);
    }
    if (target.bottom != null && start.bottom != null) {
        this.bottom = performance.number(start.bottom, target.bottom, t);
    }
    if (target.left != null && start.left != null) {
        this.left = performance.number(start.left, target.left, t);
    }
    if (target.right != null && start.right != null) {
        this.right = performance.number(start.right, target.right, t);
    }
    return this;
};
EdgeInsets.prototype.getCenter = function getCenter(width, height) {
    var x = performance.clamp((this.left + width - this.right) / 2, 0, width);
    var y = performance.clamp((this.top + height - this.bottom) / 2, 0, height);
    return new performance.Point(x, y);
};
EdgeInsets.prototype.equals = function equals(other) {
    return this.top === other.top && this.bottom === other.bottom && this.left === other.left && this.right === other.right;
};
EdgeInsets.prototype.clone = function clone() {
    return new EdgeInsets(this.top, this.bottom, this.left, this.right);
};
EdgeInsets.prototype.toJSON = function toJSON() {
    return {
        top: this.top,
        bottom: this.bottom,
        left: this.left,
        right: this.right
    };
};

var Transform = function Transform(minZoom, maxZoom, minPitch, maxPitch, renderWorldCopies) {
    this.tileSize = 512;
    this.maxValidLatitude = 85.051129;
    this._renderWorldCopies = renderWorldCopies === undefined ? true : renderWorldCopies;
    this._minZoom = minZoom || 0;
    this._maxZoom = maxZoom || 22;
    this._minPitch = minPitch === undefined || minPitch === null ? 0 : minPitch;
    this._maxPitch = maxPitch === undefined || maxPitch === null ? 60 : maxPitch;
    this.setMaxBounds();
    this.width = 0;
    this.height = 0;
    this._center = new performance.LngLat(0, 0);
    this.zoom = 0;
    this.angle = 0;
    this._fov = 0.6435011087932844;
    this._pitch = 0;
    this._unmodified = true;
    this._edgeInsets = new EdgeInsets();
    this._posMatrixCache = {};
    this._alignedPosMatrixCache = {};
};
var prototypeAccessors = {
    minZoom: { configurable: true },
    maxZoom: { configurable: true },
    minPitch: { configurable: true },
    maxPitch: { configurable: true },
    renderWorldCopies: { configurable: true },
    worldSize: { configurable: true },
    centerOffset: { configurable: true },
    size: { configurable: true },
    bearing: { configurable: true },
    pitch: { configurable: true },
    fov: { configurable: true },
    zoom: { configurable: true },
    center: { configurable: true },
    padding: { configurable: true },
    centerPoint: { configurable: true },
    unmodified: { configurable: true },
    point: { configurable: true }
};
Transform.prototype.clone = function clone() {
    var clone = new Transform(this._minZoom, this._maxZoom, this._minPitch, this.maxPitch, this._renderWorldCopies);
    clone.tileSize = this.tileSize;
    clone.latRange = this.latRange;
    clone.width = this.width;
    clone.height = this.height;
    clone._center = this._center;
    clone.zoom = this.zoom;
    clone.angle = this.angle;
    clone._fov = this._fov;
    clone._pitch = this._pitch;
    clone._unmodified = this._unmodified;
    clone._edgeInsets = this._edgeInsets.clone();
    clone._calcMatrices();
    return clone;
};
prototypeAccessors.minZoom.get = function () {
    return this._minZoom;
};
prototypeAccessors.minZoom.set = function (zoom) {
    if (this._minZoom === zoom) {
        return;
    }
    this._minZoom = zoom;
    this.zoom = Math.max(this.zoom, zoom);
};
prototypeAccessors.maxZoom.get = function () {
    return this._maxZoom;
};
prototypeAccessors.maxZoom.set = function (zoom) {
    if (this._maxZoom === zoom) {
        return;
    }
    this._maxZoom = zoom;
    this.zoom = Math.min(this.zoom, zoom);
};
prototypeAccessors.minPitch.get = function () {
    return this._minPitch;
};
prototypeAccessors.minPitch.set = function (pitch) {
    if (this._minPitch === pitch) {
        return;
    }
    this._minPitch = pitch;
    this.pitch = Math.max(this.pitch, pitch);
};
prototypeAccessors.maxPitch.get = function () {
    return this._maxPitch;
};
prototypeAccessors.maxPitch.set = function (pitch) {
    if (this._maxPitch === pitch) {
        return;
    }
    this._maxPitch = pitch;
    this.pitch = Math.min(this.pitch, pitch);
};
prototypeAccessors.renderWorldCopies.get = function () {
    return this._renderWorldCopies;
};
prototypeAccessors.renderWorldCopies.set = function (renderWorldCopies) {
    if (renderWorldCopies === undefined) {
        renderWorldCopies = true;
    } else if (renderWorldCopies === null) {
        renderWorldCopies = false;
    }
    this._renderWorldCopies = renderWorldCopies;
};
prototypeAccessors.worldSize.get = function () {
    return this.tileSize * this.scale;
};
prototypeAccessors.centerOffset.get = function () {
    return this.centerPoint._sub(this.size._div(2));
};
prototypeAccessors.size.get = function () {
    return new performance.Point(this.width, this.height);
};
prototypeAccessors.bearing.get = function () {
    return -this.angle / Math.PI * 180;
};
prototypeAccessors.bearing.set = function (bearing) {
    var b = -performance.wrap(bearing, -180, 180) * Math.PI / 180;
    if (this.angle === b) {
        return;
    }
    this._unmodified = false;
    this.angle = b;
    this._calcMatrices();
    this.rotationMatrix = performance.create$2();
    performance.rotate(this.rotationMatrix, this.rotationMatrix, this.angle);
};
prototypeAccessors.pitch.get = function () {
    return this._pitch / Math.PI * 180;
};
prototypeAccessors.pitch.set = function (pitch) {
    var p = performance.clamp(pitch, this.minPitch, this.maxPitch) / 180 * Math.PI;
    if (this._pitch === p) {
        return;
    }
    this._unmodified = false;
    this._pitch = p;
    this._calcMatrices();
};
prototypeAccessors.fov.get = function () {
    return this._fov / Math.PI * 180;
};
prototypeAccessors.fov.set = function (fov) {
    fov = Math.max(0.01, Math.min(60, fov));
    if (this._fov === fov) {
        return;
    }
    this._unmodified = false;
    this._fov = fov / 180 * Math.PI;
    this._calcMatrices();
};
prototypeAccessors.zoom.get = function () {
    return this._zoom;
};
prototypeAccessors.zoom.set = function (zoom) {
    var z = Math.min(Math.max(zoom, this.minZoom), this.maxZoom);
    if (this._zoom === z) {
        return;
    }
    this._unmodified = false;
    this._zoom = z;
    this.scale = this.zoomScale(z);
    this.tileZoom = Math.floor(z);
    this.zoomFraction = z - this.tileZoom;
    this._constrain();
    this._calcMatrices();
};
prototypeAccessors.center.get = function () {
    return this._center;
};
prototypeAccessors.center.set = function (center) {
    if (center.lat === this._center.lat && center.lng === this._center.lng) {
        return;
    }
    this._unmodified = false;
    this._center = center;
    this._constrain();
    this._calcMatrices();
};
prototypeAccessors.padding.get = function () {
    return this._edgeInsets.toJSON();
};
prototypeAccessors.padding.set = function (padding) {
    if (this._edgeInsets.equals(padding)) {
        return;
    }
    this._unmodified = false;
    this._edgeInsets.interpolate(this._edgeInsets, padding, 1);
    this._calcMatrices();
};
prototypeAccessors.centerPoint.get = function () {
    return this._edgeInsets.getCenter(this.width, this.height);
};
Transform.prototype.isPaddingEqual = function isPaddingEqual(padding) {
    return this._edgeInsets.equals(padding);
};
Transform.prototype.interpolatePadding = function interpolatePadding(start, target, t) {
    this._unmodified = false;
    this._edgeInsets.interpolate(start, target, t);
    this._constrain();
    this._calcMatrices();
};
Transform.prototype.coveringZoomLevel = function coveringZoomLevel(options) {
    var z = (options.roundZoom ? Math.round : Math.floor)(this.zoom + this.scaleZoom(this.tileSize / options.tileSize));
    return Math.max(0, z);
};
Transform.prototype.getVisibleUnwrappedCoordinates = function getVisibleUnwrappedCoordinates(tileID) {
    var result = [new performance.UnwrappedTileID(0, tileID)];
    if (this._renderWorldCopies) {
        var utl = this.pointCoordinate(new performance.Point(0, 0));
        var utr = this.pointCoordinate(new performance.Point(this.width, 0));
        var ubl = this.pointCoordinate(new performance.Point(this.width, this.height));
        var ubr = this.pointCoordinate(new performance.Point(0, this.height));
        var w0 = Math.floor(Math.min(utl.x, utr.x, ubl.x, ubr.x));
        var w1 = Math.floor(Math.max(utl.x, utr.x, ubl.x, ubr.x));
        var extraWorldCopy = 1;
        for (var w = w0 - extraWorldCopy; w <= w1 + extraWorldCopy; w++) {
            if (w === 0) {
                continue;
            }
            result.push(new performance.UnwrappedTileID(w, tileID));
        }
    }
    return result;
};
Transform.prototype.coveringTiles = function coveringTiles(options) {
    var z = this.coveringZoomLevel(options);
    var actualZ = z;
    if (options.minzoom !== undefined && z < options.minzoom) {
        return [];
    }
    if (options.maxzoom !== undefined && z > options.maxzoom) {
        z = options.maxzoom;
    }
    var centerCoord = performance.MercatorCoordinate.fromLngLat(this.center);
    var numTiles = Math.pow(2, z);
    var centerPoint = [
        numTiles * centerCoord.x,
        numTiles * centerCoord.y,
        0
    ];
    var cameraFrustum = Frustum.fromInvProjectionMatrix(this.invProjMatrix, this.worldSize, z);
    var minZoom = options.minzoom || 0;
    if (this.pitch <= 60 && this._edgeInsets.top < 0.1) {
        minZoom = z;
    }
    var radiusOfMaxLvlLodInTiles = 3;
    var newRootTile = function (wrap) {
        return {
            aabb: new Aabb([
                wrap * numTiles,
                0,
                0
            ], [
                (wrap + 1) * numTiles,
                numTiles,
                0
            ]),
            zoom: 0,
            x: 0,
            y: 0,
            wrap: wrap,
            fullyVisible: false
        };
    };
    var stack = [];
    var result = [];
    var maxZoom = z;
    var overscaledZ = options.reparseOverscaled ? actualZ : z;
    if (this._renderWorldCopies) {
        for (var i = 1; i <= 3; i++) {
            stack.push(newRootTile(-i));
            stack.push(newRootTile(i));
        }
    }
    stack.push(newRootTile(0));
    while (stack.length > 0) {
        var it = stack.pop();
        var x = it.x;
        var y = it.y;
        var fullyVisible = it.fullyVisible;
        if (!fullyVisible) {
            var intersectResult = it.aabb.intersects(cameraFrustum);
            if (intersectResult === 0) {
                continue;
            }
            fullyVisible = intersectResult === 2;
        }
        var distanceX = it.aabb.distanceX(centerPoint);
        var distanceY = it.aabb.distanceY(centerPoint);
        var longestDim = Math.max(Math.abs(distanceX), Math.abs(distanceY));
        var distToSplit = radiusOfMaxLvlLodInTiles + (1 << maxZoom - it.zoom) - 2;
        if (it.zoom === maxZoom || longestDim > distToSplit && it.zoom >= minZoom) {
            result.push({
                tileID: new performance.OverscaledTileID(it.zoom === maxZoom ? overscaledZ : it.zoom, it.wrap, it.zoom, x, y),
                distanceSq: performance.sqrLen([
                    centerPoint[0] - 0.5 - x,
                    centerPoint[1] - 0.5 - y
                ])
            });
            continue;
        }
        for (var i$1 = 0; i$1 < 4; i$1++) {
            var childX = (x << 1) + i$1 % 2;
            var childY = (y << 1) + (i$1 >> 1);
            stack.push({
                aabb: it.aabb.quadrant(i$1),
                zoom: it.zoom + 1,
                x: childX,
                y: childY,
                wrap: it.wrap,
                fullyVisible: fullyVisible
            });
        }
    }
    return result.sort(function (a, b) {
        return a.distanceSq - b.distanceSq;
    }).map(function (a) {
        return a.tileID;
    });
};
Transform.prototype.resize = function resize(width, height) {
    this.width = width;
    this.height = height;
    this.pixelsToGLUnits = [
        2 / width,
        -2 / height
    ];
    this._constrain();
    this._calcMatrices();
};
prototypeAccessors.unmodified.get = function () {
    return this._unmodified;
};
Transform.prototype.zoomScale = function zoomScale(zoom) {
    return Math.pow(2, zoom);
};
Transform.prototype.scaleZoom = function scaleZoom(scale) {
    return Math.log(scale) / Math.LN2;
};
Transform.prototype.project = function project(lnglat) {
    var lat = performance.clamp(lnglat.lat, -this.maxValidLatitude, this.maxValidLatitude);
    return new performance.Point(performance.mercatorXfromLng(lnglat.lng) * this.worldSize, performance.mercatorYfromLat(lat) * this.worldSize);
};
Transform.prototype.unproject = function unproject(point) {
    return new performance.MercatorCoordinate(point.x / this.worldSize, point.y / this.worldSize).toLngLat();
};
prototypeAccessors.point.get = function () {
    return this.project(this.center);
};
Transform.prototype.setLocationAtPoint = function setLocationAtPoint(lnglat, point) {
    var a = this.pointCoordinate(point);
    var b = this.pointCoordinate(this.centerPoint);
    var loc = this.locationCoordinate(lnglat);
    var newCenter = new performance.MercatorCoordinate(loc.x - (a.x - b.x), loc.y - (a.y - b.y));
    this.center = this.coordinateLocation(newCenter);
    if (this._renderWorldCopies) {
        this.center = this.center.wrap();
    }
};
Transform.prototype.locationPoint = function locationPoint(lnglat) {
    return this.coordinatePoint(this.locationCoordinate(lnglat));
};
Transform.prototype.pointLocation = function pointLocation(p) {
    return this.coordinateLocation(this.pointCoordinate(p));
};
Transform.prototype.locationCoordinate = function locationCoordinate(lnglat) {
    return performance.MercatorCoordinate.fromLngLat(lnglat);
};
Transform.prototype.coordinateLocation = function coordinateLocation(coord) {
    return coord.toLngLat();
};
Transform.prototype.pointCoordinate = function pointCoordinate(p) {
    var targetZ = 0;
    var coord0 = [
        p.x,
        p.y,
        0,
        1
    ];
    var coord1 = [
        p.x,
        p.y,
        1,
        1
    ];
    performance.transformMat4(coord0, coord0, this.pixelMatrixInverse);
    performance.transformMat4(coord1, coord1, this.pixelMatrixInverse);
    var w0 = coord0[3];
    var w1 = coord1[3];
    var x0 = coord0[0] / w0;
    var x1 = coord1[0] / w1;
    var y0 = coord0[1] / w0;
    var y1 = coord1[1] / w1;
    var z0 = coord0[2] / w0;
    var z1 = coord1[2] / w1;
    var t = z0 === z1 ? 0 : (targetZ - z0) / (z1 - z0);
    return new performance.MercatorCoordinate(performance.number(x0, x1, t) / this.worldSize, performance.number(y0, y1, t) / this.worldSize);
};
Transform.prototype.coordinatePoint = function coordinatePoint(coord) {
    var p = [
        coord.x * this.worldSize,
        coord.y * this.worldSize,
        0,
        1
    ];
    performance.transformMat4(p, p, this.pixelMatrix);
    return new performance.Point(p[0] / p[3], p[1] / p[3]);
};
Transform.prototype.getBounds = function getBounds() {
    return new performance.LngLatBounds().extend(this.pointLocation(new performance.Point(0, 0))).extend(this.pointLocation(new performance.Point(this.width, 0))).extend(this.pointLocation(new performance.Point(this.width, this.height))).extend(this.pointLocation(new performance.Point(0, this.height)));
};
Transform.prototype.getMaxBounds = function getMaxBounds() {
    if (!this.latRange || this.latRange.length !== 2 || !this.lngRange || this.lngRange.length !== 2) {
        return null;
    }
    return new performance.LngLatBounds([
        this.lngRange[0],
        this.latRange[0]
    ], [
        this.lngRange[1],
        this.latRange[1]
    ]);
};
Transform.prototype.setMaxBounds = function setMaxBounds(bounds) {
    if (bounds) {
        this.lngRange = [
            bounds.getWest(),
            bounds.getEast()
        ];
        this.latRange = [
            bounds.getSouth(),
            bounds.getNorth()
        ];
        this._constrain();
    } else {
        this.lngRange = null;
        this.latRange = [
            -this.maxValidLatitude,
            this.maxValidLatitude
        ];
    }
};
Transform.prototype.calculatePosMatrix = function calculatePosMatrix(unwrappedTileID, aligned) {
    if (aligned === void 0)
        aligned = false;
    var posMatrixKey = unwrappedTileID.key;
    var cache = aligned ? this._alignedPosMatrixCache : this._posMatrixCache;
    if (cache[posMatrixKey]) {
        return cache[posMatrixKey];
    }
    var canonical = unwrappedTileID.canonical;
    var scale = this.worldSize / this.zoomScale(canonical.z);
    var unwrappedX = canonical.x + Math.pow(2, canonical.z) * unwrappedTileID.wrap;
    var posMatrix = performance.identity(new Float64Array(16));
    performance.translate(posMatrix, posMatrix, [
        unwrappedX * scale,
        canonical.y * scale,
        0
    ]);
    performance.scale(posMatrix, posMatrix, [
        scale / performance.EXTENT,
        scale / performance.EXTENT,
        1
    ]);
    performance.multiply(posMatrix, aligned ? this.alignedProjMatrix : this.projMatrix, posMatrix);
    cache[posMatrixKey] = new Float32Array(posMatrix);
    return cache[posMatrixKey];
};
Transform.prototype.customLayerMatrix = function customLayerMatrix() {
    return this.mercatorMatrix.slice();
};
Transform.prototype._constrain = function _constrain() {
    if (!this.center || !this.width || !this.height || this._constraining) {
        return;
    }
    this._constraining = true;
    var minY = -90;
    var maxY = 90;
    var minX = -180;
    var maxX = 180;
    var sy, sx, x2, y2;
    var size = this.size, unmodified = this._unmodified;
    if (this.latRange) {
        var latRange = this.latRange;
        minY = performance.mercatorYfromLat(latRange[1]) * this.worldSize;
        maxY = performance.mercatorYfromLat(latRange[0]) * this.worldSize;
        sy = maxY - minY < size.y ? size.y / (maxY - minY) : 0;
    }
    if (this.lngRange) {
        var lngRange = this.lngRange;
        minX = performance.mercatorXfromLng(lngRange[0]) * this.worldSize;
        maxX = performance.mercatorXfromLng(lngRange[1]) * this.worldSize;
        sx = maxX - minX < size.x ? size.x / (maxX - minX) : 0;
    }
    var point = this.point;
    var s = Math.max(sx || 0, sy || 0);
    if (s) {
        this.center = this.unproject(new performance.Point(sx ? (maxX + minX) / 2 : point.x, sy ? (maxY + minY) / 2 : point.y));
        this.zoom += this.scaleZoom(s);
        this._unmodified = unmodified;
        this._constraining = false;
        return;
    }
    if (this.latRange) {
        var y = point.y, h2 = size.y / 2;
        if (y - h2 < minY) {
            y2 = minY + h2;
        }
        if (y + h2 > maxY) {
            y2 = maxY - h2;
        }
    }
    if (this.lngRange) {
        var x = point.x, w2 = size.x / 2;
        if (x - w2 < minX) {
            x2 = minX + w2;
        }
        if (x + w2 > maxX) {
            x2 = maxX - w2;
        }
    }
    if (x2 !== undefined || y2 !== undefined) {
        this.center = this.unproject(new performance.Point(x2 !== undefined ? x2 : point.x, y2 !== undefined ? y2 : point.y));
    }
    this._unmodified = unmodified;
    this._constraining = false;
};
Transform.prototype._calcMatrices = function _calcMatrices() {
    if (!this.height) {
        return;
    }
    var halfFov = this._fov / 2;
    var offset = this.centerOffset;
    this.cameraToCenterDistance = 0.5 / Math.tan(halfFov) * this.height;
    var groundAngle = Math.PI / 2 + this._pitch;
    var fovAboveCenter = this._fov * (0.5 + offset.y / this.height);
    var topHalfSurfaceDistance = Math.sin(fovAboveCenter) * this.cameraToCenterDistance / Math.sin(performance.clamp(Math.PI - groundAngle - fovAboveCenter, 0.01, Math.PI - 0.01));
    var point = this.point;
    var x = point.x, y = point.y;
    var furthestDistance = Math.cos(Math.PI / 2 - this._pitch) * topHalfSurfaceDistance + this.cameraToCenterDistance;
    var farZ = furthestDistance * 1.01;
    var nearZ = this.height / 50;
    var m = new Float64Array(16);
    performance.perspective(m, this._fov, this.width / this.height, nearZ, farZ);
    m[8] = -offset.x * 2 / this.width;
    m[9] = offset.y * 2 / this.height;
    performance.scale(m, m, [
        1,
        -1,
        1
    ]);
    performance.translate(m, m, [
        0,
        0,
        -this.cameraToCenterDistance
    ]);
    performance.rotateX(m, m, this._pitch);
    performance.rotateZ(m, m, this.angle);
    performance.translate(m, m, [
        -x,
        -y,
        0
    ]);
    this.mercatorMatrix = performance.scale([], m, [
        this.worldSize,
        this.worldSize,
        this.worldSize
    ]);
    performance.scale(m, m, [
        1,
        1,
        performance.mercatorZfromAltitude(1, this.center.lat) * this.worldSize,
        1
    ]);
    this.projMatrix = m;
    this.invProjMatrix = performance.invert([], this.projMatrix);
    var xShift = this.width % 2 / 2, yShift = this.height % 2 / 2, angleCos = Math.cos(this.angle), angleSin = Math.sin(this.angle), dx = x - Math.round(x) + angleCos * xShift + angleSin * yShift, dy = y - Math.round(y) + angleCos * yShift + angleSin * xShift;
    var alignedM = new Float64Array(m);
    performance.translate(alignedM, alignedM, [
        dx > 0.5 ? dx - 1 : dx,
        dy > 0.5 ? dy - 1 : dy,
        0
    ]);
    this.alignedProjMatrix = alignedM;
    m = performance.create();
    performance.scale(m, m, [
        this.width / 2,
        -this.height / 2,
        1
    ]);
    performance.translate(m, m, [
        1,
        -1,
        0
    ]);
    this.labelPlaneMatrix = m;
    m = performance.create();
    performance.scale(m, m, [
        1,
        -1,
        1
    ]);
    performance.translate(m, m, [
        -1,
        -1,
        0
    ]);
    performance.scale(m, m, [
        2 / this.width,
        2 / this.height,
        1
    ]);
    this.glCoordMatrix = m;
    this.pixelMatrix = performance.multiply(new Float64Array(16), this.labelPlaneMatrix, this.projMatrix);
    m = performance.invert(new Float64Array(16), this.pixelMatrix);
    if (!m) {
        throw new Error('failed to invert matrix');
    }
    this.pixelMatrixInverse = m;
    this._posMatrixCache = {};
    this._alignedPosMatrixCache = {};
};
Transform.prototype.maxPitchScaleFactor = function maxPitchScaleFactor() {
    if (!this.pixelMatrixInverse) {
        return 1;
    }
    var coord = this.pointCoordinate(new performance.Point(0, 0));
    var p = [
        coord.x * this.worldSize,
        coord.y * this.worldSize,
        0,
        1
    ];
    var topPoint = performance.transformMat4(p, p, this.pixelMatrix);
    return topPoint[3] / this.cameraToCenterDistance;
};
Transform.prototype.getCameraPoint = function getCameraPoint() {
    var pitch = this._pitch;
    var yOffset = Math.tan(pitch) * (this.cameraToCenterDistance || 1);
    return this.centerPoint.add(new performance.Point(0, yOffset));
};
Transform.prototype.getCameraQueryGeometry = function getCameraQueryGeometry(queryGeometry) {
    var c = this.getCameraPoint();
    if (queryGeometry.length === 1) {
        return [
            queryGeometry[0],
            c
        ];
    } else {
        var minX = c.x;
        var minY = c.y;
        var maxX = c.x;
        var maxY = c.y;
        for (var i = 0, list = queryGeometry; i < list.length; i += 1) {
            var p = list[i];
            minX = Math.min(minX, p.x);
            minY = Math.min(minY, p.y);
            maxX = Math.max(maxX, p.x);
            maxY = Math.max(maxY, p.y);
        }
        return [
            new performance.Point(minX, minY),
            new performance.Point(maxX, minY),
            new performance.Point(maxX, maxY),
            new performance.Point(minX, maxY),
            new performance.Point(minX, minY)
        ];
    }
};
Object.defineProperties(Transform.prototype, prototypeAccessors);

function throttle(fn, time) {
    var pending = false;
    var timerId = null;
    var later = function () {
        timerId = null;
        if (pending) {
            fn();
            timerId = setTimeout(later, time);
            pending = false;
        }
    };
    return function () {
        pending = true;
        if (!timerId) {
            later();
        }
        return timerId;
    };
}

var Hash = function Hash(hashName) {
    this._hashName = hashName && encodeURIComponent(hashName);
    performance.bindAll([
        '_getCurrentHash',
        '_onHashChange',
        '_updateHash'
    ], this);
    this._updateHash = throttle(this._updateHashUnthrottled.bind(this), 30 * 1000 / 100);
};
Hash.prototype.addTo = function addTo(map) {
    this._map = map;
    performance.window.addEventListener('hashchange', this._onHashChange, false);
    this._map.on('moveend', this._updateHash);
    return this;
};
Hash.prototype.remove = function remove() {
    performance.window.removeEventListener('hashchange', this._onHashChange, false);
    this._map.off('moveend', this._updateHash);
    clearTimeout(this._updateHash());
    delete this._map;
    return this;
};
Hash.prototype.getHashString = function getHashString(mapFeedback) {
    var center = this._map.getCenter(), zoom = Math.round(this._map.getZoom() * 100) / 100, precision = Math.ceil((zoom * Math.LN2 + Math.log(512 / 360 / 0.5)) / Math.LN10), m = Math.pow(10, precision), lng = Math.round(center.lng * m) / m, lat = Math.round(center.lat * m) / m, bearing = this._map.getBearing(), pitch = this._map.getPitch();
    var hash = '';
    if (mapFeedback) {
        hash += '/' + lng + '/' + lat + '/' + zoom;
    } else {
        hash += zoom + '/' + lat + '/' + lng;
    }
    if (bearing || pitch) {
        hash += '/' + Math.round(bearing * 10) / 10;
    }
    if (pitch) {
        hash += '/' + Math.round(pitch);
    }
    if (this._hashName) {
        var hashName = this._hashName;
        var found = false;
        var parts = performance.window.location.hash.slice(1).split('&').map(function (part) {
            var key = part.split('=')[0];
            if (key === hashName) {
                found = true;
                return key + '=' + hash;
            }
            return part;
        }).filter(function (a) {
            return a;
        });
        if (!found) {
            parts.push(hashName + '=' + hash);
        }
        return '#' + parts.join('&');
    }
    return '#' + hash;
};
Hash.prototype._getCurrentHash = function _getCurrentHash() {
    var this$1 = this;
    var hash = performance.window.location.hash.replace('#', '');
    if (this._hashName) {
        var keyval;
        hash.split('&').map(function (part) {
            return part.split('=');
        }).forEach(function (part) {
            if (part[0] === this$1._hashName) {
                keyval = part;
            }
        });
        return (keyval ? keyval[1] || '' : '').split('/');
    }
    return hash.split('/');
};
Hash.prototype._onHashChange = function _onHashChange() {
    var loc = this._getCurrentHash();
    if (loc.length >= 3 && !loc.some(function (v) {
            return isNaN(v);
        })) {
        var bearing = this._map.dragRotate.isEnabled() && this._map.touchZoomRotate.isEnabled() ? +(loc[3] || 0) : this._map.getBearing();
        this._map.jumpTo({
            center: [
                +loc[2],
                +loc[1]
            ],
            zoom: +loc[0],
            bearing: bearing,
            pitch: +(loc[4] || 0)
        });
        return true;
    }
    return false;
};
Hash.prototype._updateHashUnthrottled = function _updateHashUnthrottled() {
    var location = performance.window.location.href.replace(/(#.+)?$/, this.getHashString());
    try {
        performance.window.history.replaceState(performance.window.history.state, null, location);
    } catch (SecurityError) {
    }
};

var defaultInertiaOptions = {
    linearity: 0.3,
    easing: performance.bezier(0, 0, 0.3, 1)
};
var defaultPanInertiaOptions = performance.extend({
    deceleration: 2500,
    maxSpeed: 1400
}, defaultInertiaOptions);
var defaultZoomInertiaOptions = performance.extend({
    deceleration: 20,
    maxSpeed: 1400
}, defaultInertiaOptions);
var defaultBearingInertiaOptions = performance.extend({
    deceleration: 1000,
    maxSpeed: 360
}, defaultInertiaOptions);
var defaultPitchInertiaOptions = performance.extend({
    deceleration: 1000,
    maxSpeed: 90
}, defaultInertiaOptions);
var HandlerInertia = function HandlerInertia(map) {
    this._map = map;
    this.clear();
};
HandlerInertia.prototype.clear = function clear() {
    this._inertiaBuffer = [];
};
HandlerInertia.prototype.record = function record(settings) {
    this._drainInertiaBuffer();
    this._inertiaBuffer.push({
        time: performance.browser.now(),
        settings: settings
    });
};
HandlerInertia.prototype._drainInertiaBuffer = function _drainInertiaBuffer() {
    var inertia = this._inertiaBuffer, now = performance.browser.now(), cutoff = 160;
    while (inertia.length > 0 && now - inertia[0].time > cutoff) {
        inertia.shift();
    }
};
HandlerInertia.prototype._onMoveEnd = function _onMoveEnd(panInertiaOptions) {
    this._drainInertiaBuffer();
    if (this._inertiaBuffer.length < 2) {
        return;
    }
    var deltas = {
        zoom: 0,
        bearing: 0,
        pitch: 0,
        pan: new performance.Point(0, 0),
        pinchAround: undefined,
        around: undefined
    };
    for (var i = 0, list = this._inertiaBuffer; i < list.length; i += 1) {
        var ref = list[i];
        var settings = ref.settings;
        deltas.zoom += settings.zoomDelta || 0;
        deltas.bearing += settings.bearingDelta || 0;
        deltas.pitch += settings.pitchDelta || 0;
        if (settings.panDelta) {
            deltas.pan._add(settings.panDelta);
        }
        if (settings.around) {
            deltas.around = settings.around;
        }
        if (settings.pinchAround) {
            deltas.pinchAround = settings.pinchAround;
        }
    }
    var lastEntry = this._inertiaBuffer[this._inertiaBuffer.length - 1];
    var duration = lastEntry.time - this._inertiaBuffer[0].time;
    var easeOptions = {};
    if (deltas.pan.mag()) {
        var result = calculateEasing(deltas.pan.mag(), duration, performance.extend({}, defaultPanInertiaOptions, panInertiaOptions || {}));
        easeOptions.offset = deltas.pan.mult(result.amount / deltas.pan.mag());
        easeOptions.center = this._map.transform.center;
        extendDuration(easeOptions, result);
    }
    if (deltas.zoom) {
        var result$1 = calculateEasing(deltas.zoom, duration, defaultZoomInertiaOptions);
        easeOptions.zoom = this._map.transform.zoom + result$1.amount;
        extendDuration(easeOptions, result$1);
    }
    if (deltas.bearing) {
        var result$2 = calculateEasing(deltas.bearing, duration, defaultBearingInertiaOptions);
        easeOptions.bearing = this._map.transform.bearing + performance.clamp(result$2.amount, -179, 179);
        extendDuration(easeOptions, result$2);
    }
    if (deltas.pitch) {
        var result$3 = calculateEasing(deltas.pitch, duration, defaultPitchInertiaOptions);
        easeOptions.pitch = this._map.transform.pitch + result$3.amount;
        extendDuration(easeOptions, result$3);
    }
    if (easeOptions.zoom || easeOptions.bearing) {
        var last = deltas.pinchAround === undefined ? deltas.around : deltas.pinchAround;
        easeOptions.around = last ? this._map.unproject(last) : this._map.getCenter();
    }
    this.clear();
    return performance.extend(easeOptions, { noMoveStart: true });
};
function extendDuration(easeOptions, result) {
    if (!easeOptions.duration || easeOptions.duration < result.duration) {
        easeOptions.duration = result.duration;
        easeOptions.easing = result.easing;
    }
}
function calculateEasing(amount, inertiaDuration, inertiaOptions) {
    var maxSpeed = inertiaOptions.maxSpeed;
    var linearity = inertiaOptions.linearity;
    var deceleration = inertiaOptions.deceleration;
    var speed = performance.clamp(amount * linearity / (inertiaDuration / 1000), -maxSpeed, maxSpeed);
    var duration = Math.abs(speed) / (deceleration * linearity);
    return {
        easing: inertiaOptions.easing,
        duration: duration * 1000,
        amount: speed * (duration / 2)
    };
}

var MapMouseEvent = function (Event) {
    function MapMouseEvent(type, map, originalEvent, data) {
        if (data === void 0)
            data = {};
        var point = DOM.mousePos(map.getCanvasContainer(), originalEvent);
        var lngLat = map.unproject(point);
        Event.call(this, type, performance.extend({
            point: point,
            lngLat: lngLat,
            originalEvent: originalEvent
        }, data));
        this._defaultPrevented = false;
        this.target = map;
    }
    if (Event)
        MapMouseEvent.__proto__ = Event;
    MapMouseEvent.prototype = Object.create(Event && Event.prototype);
    MapMouseEvent.prototype.constructor = MapMouseEvent;
    var prototypeAccessors = { defaultPrevented: { configurable: true } };
    MapMouseEvent.prototype.preventDefault = function preventDefault() {
        this._defaultPrevented = true;
    };
    prototypeAccessors.defaultPrevented.get = function () {
        return this._defaultPrevented;
    };
    Object.defineProperties(MapMouseEvent.prototype, prototypeAccessors);
    return MapMouseEvent;
}(performance.Event);
var MapTouchEvent = function (Event) {
    function MapTouchEvent(type, map, originalEvent) {
        var touches = type === 'touchend' ? originalEvent.changedTouches : originalEvent.touches;
        var points = DOM.touchPos(map.getCanvasContainer(), touches);
        var lngLats = points.map(function (t) {
            return map.unproject(t);
        });
        var point = points.reduce(function (prev, curr, i, arr) {
            return prev.add(curr.div(arr.length));
        }, new performance.Point(0, 0));
        var lngLat = map.unproject(point);
        Event.call(this, type, {
            points: points,
            point: point,
            lngLats: lngLats,
            lngLat: lngLat,
            originalEvent: originalEvent
        });
        this._defaultPrevented = false;
    }
    if (Event)
        MapTouchEvent.__proto__ = Event;
    MapTouchEvent.prototype = Object.create(Event && Event.prototype);
    MapTouchEvent.prototype.constructor = MapTouchEvent;
    var prototypeAccessors$1 = { defaultPrevented: { configurable: true } };
    MapTouchEvent.prototype.preventDefault = function preventDefault() {
        this._defaultPrevented = true;
    };
    prototypeAccessors$1.defaultPrevented.get = function () {
        return this._defaultPrevented;
    };
    Object.defineProperties(MapTouchEvent.prototype, prototypeAccessors$1);
    return MapTouchEvent;
}(performance.Event);
var MapWheelEvent = function (Event) {
    function MapWheelEvent(type, map, originalEvent) {
        Event.call(this, type, { originalEvent: originalEvent });
        this._defaultPrevented = false;
    }
    if (Event)
        MapWheelEvent.__proto__ = Event;
    MapWheelEvent.prototype = Object.create(Event && Event.prototype);
    MapWheelEvent.prototype.constructor = MapWheelEvent;
    var prototypeAccessors$2 = { defaultPrevented: { configurable: true } };
    MapWheelEvent.prototype.preventDefault = function preventDefault() {
        this._defaultPrevented = true;
    };
    prototypeAccessors$2.defaultPrevented.get = function () {
        return this._defaultPrevented;
    };
    Object.defineProperties(MapWheelEvent.prototype, prototypeAccessors$2);
    return MapWheelEvent;
}(performance.Event);

var MapEventHandler = function MapEventHandler(map, options) {
    this._map = map;
    this._clickTolerance = options.clickTolerance;
};
MapEventHandler.prototype.reset = function reset() {
    delete this._mousedownPos;
};
MapEventHandler.prototype.wheel = function wheel(e) {
    return this._firePreventable(new MapWheelEvent(e.type, this._map, e));
};
MapEventHandler.prototype.mousedown = function mousedown(e, point) {
    this._mousedownPos = point;
    return this._firePreventable(new MapMouseEvent(e.type, this._map, e));
};
MapEventHandler.prototype.mouseup = function mouseup(e) {
    this._map.fire(new MapMouseEvent(e.type, this._map, e));
};
MapEventHandler.prototype.click = function click(e, point) {
    if (this._mousedownPos && this._mousedownPos.dist(point) >= this._clickTolerance) {
        return;
    }
    this._map.fire(new MapMouseEvent(e.type, this._map, e));
};
MapEventHandler.prototype.dblclick = function dblclick(e) {
    return this._firePreventable(new MapMouseEvent(e.type, this._map, e));
};
MapEventHandler.prototype.mouseover = function mouseover(e) {
    this._map.fire(new MapMouseEvent(e.type, this._map, e));
};
MapEventHandler.prototype.mouseout = function mouseout(e) {
    this._map.fire(new MapMouseEvent(e.type, this._map, e));
};
MapEventHandler.prototype.touchstart = function touchstart(e) {
    return this._firePreventable(new MapTouchEvent(e.type, this._map, e));
};
MapEventHandler.prototype.touchmove = function touchmove(e) {
    this._map.fire(new MapTouchEvent(e.type, this._map, e));
};
MapEventHandler.prototype.touchend = function touchend(e) {
    this._map.fire(new MapTouchEvent(e.type, this._map, e));
};
MapEventHandler.prototype.touchcancel = function touchcancel(e) {
    this._map.fire(new MapTouchEvent(e.type, this._map, e));
};
MapEventHandler.prototype._firePreventable = function _firePreventable(mapEvent) {
    this._map.fire(mapEvent);
    if (mapEvent.defaultPrevented) {
        return {};
    }
};
MapEventHandler.prototype.isEnabled = function isEnabled() {
    return true;
};
MapEventHandler.prototype.isActive = function isActive() {
    return false;
};
MapEventHandler.prototype.enable = function enable() {
};
MapEventHandler.prototype.disable = function disable() {
};
var BlockableMapEventHandler = function BlockableMapEventHandler(map) {
    this._map = map;
};
BlockableMapEventHandler.prototype.reset = function reset() {
    this._delayContextMenu = false;
    delete this._contextMenuEvent;
};
BlockableMapEventHandler.prototype.mousemove = function mousemove(e) {
    this._map.fire(new MapMouseEvent(e.type, this._map, e));
};
BlockableMapEventHandler.prototype.mousedown = function mousedown() {
    this._delayContextMenu = true;
};
BlockableMapEventHandler.prototype.mouseup = function mouseup() {
    this._delayContextMenu = false;
    if (this._contextMenuEvent) {
        this._map.fire(new MapMouseEvent('contextmenu', this._map, this._contextMenuEvent));
        delete this._contextMenuEvent;
    }
};
BlockableMapEventHandler.prototype.contextmenu = function contextmenu(e) {
    if (this._delayContextMenu) {
        this._contextMenuEvent = e;
    } else {
        this._map.fire(new MapMouseEvent(e.type, this._map, e));
    }
    if (this._map.listens('contextmenu')) {
        e.preventDefault();
    }
};
BlockableMapEventHandler.prototype.isEnabled = function isEnabled() {
    return true;
};
BlockableMapEventHandler.prototype.isActive = function isActive() {
    return false;
};
BlockableMapEventHandler.prototype.enable = function enable() {
};
BlockableMapEventHandler.prototype.disable = function disable() {
};

var BoxZoomHandler = function BoxZoomHandler(map, options) {
    this._map = map;
    this._el = map.getCanvasContainer();
    this._container = map.getContainer();
    this._clickTolerance = options.clickTolerance || 1;
};
BoxZoomHandler.prototype.isEnabled = function isEnabled() {
    return !!this._enabled;
};
BoxZoomHandler.prototype.isActive = function isActive() {
    return !!this._active;
};
BoxZoomHandler.prototype.enable = function enable() {
    if (this.isEnabled()) {
        return;
    }
    this._enabled = true;
};
BoxZoomHandler.prototype.disable = function disable() {
    if (!this.isEnabled()) {
        return;
    }
    this._enabled = false;
};
BoxZoomHandler.prototype.mousedown = function mousedown(e, point) {
    if (!this.isEnabled()) {
        return;
    }
    if (!(e.shiftKey && e.button === 0)) {
        return;
    }
    DOM.disableDrag();
    this._startPos = this._lastPos = point;
    this._active = true;
};
BoxZoomHandler.prototype.mousemoveWindow = function mousemoveWindow(e, point) {
    if (!this._active) {
        return;
    }
    var pos = point;
    if (this._lastPos.equals(pos) || !this._box && pos.dist(this._startPos) < this._clickTolerance) {
        return;
    }
    var p0 = this._startPos;
    this._lastPos = pos;
    if (!this._box) {
        this._box = DOM.create('div', 'mapboxgl-boxzoom', this._container);
        this._container.classList.add('mapboxgl-crosshair');
        this._fireEvent('boxzoomstart', e);
    }
    var minX = Math.min(p0.x, pos.x), maxX = Math.max(p0.x, pos.x), minY = Math.min(p0.y, pos.y), maxY = Math.max(p0.y, pos.y);
    DOM.setTransform(this._box, 'translate(' + minX + 'px,' + minY + 'px)');
    this._box.style.width = maxX - minX + 'px';
    this._box.style.height = maxY - minY + 'px';
};
BoxZoomHandler.prototype.mouseupWindow = function mouseupWindow(e, point) {
    var this$1 = this;
    if (!this._active) {
        return;
    }
    if (e.button !== 0) {
        return;
    }
    var p0 = this._startPos, p1 = point;
    this.reset();
    DOM.suppressClick();
    if (p0.x === p1.x && p0.y === p1.y) {
        this._fireEvent('boxzoomcancel', e);
    } else {
        this._map.fire(new performance.Event('boxzoomend', { originalEvent: e }));
        return {
            cameraAnimation: function (map) {
                return map.fitScreenCoordinates(p0, p1, this$1._map.getBearing(), { linear: true });
            }
        };
    }
};
BoxZoomHandler.prototype.keydown = function keydown(e) {
    if (!this._active) {
        return;
    }
    if (e.keyCode === 27) {
        this.reset();
        this._fireEvent('boxzoomcancel', e);
    }
};
BoxZoomHandler.prototype.reset = function reset() {
    this._active = false;
    this._container.classList.remove('mapboxgl-crosshair');
    if (this._box) {
        DOM.remove(this._box);
        this._box = null;
    }
    DOM.enableDrag();
    delete this._startPos;
    delete this._lastPos;
};
BoxZoomHandler.prototype._fireEvent = function _fireEvent(type, e) {
    return this._map.fire(new performance.Event(type, { originalEvent: e }));
};

function indexTouches(touches, points) {
    var obj = {};
    for (var i = 0; i < touches.length; i++) {
        obj[touches[i].identifier] = points[i];
    }
    return obj;
}

function getCentroid(points) {
    var sum = new performance.Point(0, 0);
    for (var i = 0, list = points; i < list.length; i += 1) {
        var point = list[i];
        sum._add(point);
    }
    return sum.div(points.length);
}
var MAX_TAP_INTERVAL = 500;
var MAX_TOUCH_TIME = 500;
var MAX_DIST = 30;
var SingleTapRecognizer = function SingleTapRecognizer(options) {
    this.reset();
    this.numTouches = options.numTouches;
};
SingleTapRecognizer.prototype.reset = function reset() {
    delete this.centroid;
    delete this.startTime;
    delete this.touches;
    this.aborted = false;
};
SingleTapRecognizer.prototype.touchstart = function touchstart(e, points, mapTouches) {
    if (this.centroid || mapTouches.length > this.numTouches) {
        this.aborted = true;
    }
    if (this.aborted) {
        return;
    }
    if (this.startTime === undefined) {
        this.startTime = e.timeStamp;
    }
    if (mapTouches.length === this.numTouches) {
        this.centroid = getCentroid(points);
        this.touches = indexTouches(mapTouches, points);
    }
};
SingleTapRecognizer.prototype.touchmove = function touchmove(e, points, mapTouches) {
    if (this.aborted || !this.centroid) {
        return;
    }
    var newTouches = indexTouches(mapTouches, points);
    for (var id in this.touches) {
        var prevPos = this.touches[id];
        var pos = newTouches[id];
        if (!pos || pos.dist(prevPos) > MAX_DIST) {
            this.aborted = true;
        }
    }
};
SingleTapRecognizer.prototype.touchend = function touchend(e, points, mapTouches) {
    if (!this.centroid || e.timeStamp - this.startTime > MAX_TOUCH_TIME) {
        this.aborted = true;
    }
    if (mapTouches.length === 0) {
        var centroid = !this.aborted && this.centroid;
        this.reset();
        if (centroid) {
            return centroid;
        }
    }
};
var TapRecognizer = function TapRecognizer(options) {
    this.singleTap = new SingleTapRecognizer(options);
    this.numTaps = options.numTaps;
    this.reset();
};
TapRecognizer.prototype.reset = function reset() {
    this.lastTime = Infinity;
    delete this.lastTap;
    this.count = 0;
    this.singleTap.reset();
};
TapRecognizer.prototype.touchstart = function touchstart(e, points, mapTouches) {
    this.singleTap.touchstart(e, points, mapTouches);
};
TapRecognizer.prototype.touchmove = function touchmove(e, points, mapTouches) {
    this.singleTap.touchmove(e, points, mapTouches);
};
TapRecognizer.prototype.touchend = function touchend(e, points, mapTouches) {
    var tap = this.singleTap.touchend(e, points, mapTouches);
    if (tap) {
        var soonEnough = e.timeStamp - this.lastTime < MAX_TAP_INTERVAL;
        var closeEnough = !this.lastTap || this.lastTap.dist(tap) < MAX_DIST;
        if (!soonEnough || !closeEnough) {
            this.reset();
        }
        this.count++;
        this.lastTime = e.timeStamp;
        this.lastTap = tap;
        if (this.count === this.numTaps) {
            this.reset();
            return tap;
        }
    }
};

var TapZoomHandler = function TapZoomHandler() {
    this._zoomIn = new TapRecognizer({
        numTouches: 1,
        numTaps: 2
    });
    this._zoomOut = new TapRecognizer({
        numTouches: 2,
        numTaps: 1
    });
    this.reset();
};
TapZoomHandler.prototype.reset = function reset() {
    this._active = false;
    this._zoomIn.reset();
    this._zoomOut.reset();
};
TapZoomHandler.prototype.touchstart = function touchstart(e, points, mapTouches) {
    this._zoomIn.touchstart(e, points, mapTouches);
    this._zoomOut.touchstart(e, points, mapTouches);
};
TapZoomHandler.prototype.touchmove = function touchmove(e, points, mapTouches) {
    this._zoomIn.touchmove(e, points, mapTouches);
    this._zoomOut.touchmove(e, points, mapTouches);
};
TapZoomHandler.prototype.touchend = function touchend(e, points, mapTouches) {
    var this$1 = this;
    var zoomInPoint = this._zoomIn.touchend(e, points, mapTouches);
    var zoomOutPoint = this._zoomOut.touchend(e, points, mapTouches);
    if (zoomInPoint) {
        this._active = true;
        e.preventDefault();
        setTimeout(function () {
            return this$1.reset();
        }, 0);
        return {
            cameraAnimation: function (map) {
                return map.easeTo({
                    duration: 300,
                    zoom: map.getZoom() + 1,
                    around: map.unproject(zoomInPoint)
                }, { originalEvent: e });
            }
        };
    } else if (zoomOutPoint) {
        this._active = true;
        e.preventDefault();
        setTimeout(function () {
            return this$1.reset();
        }, 0);
        return {
            cameraAnimation: function (map) {
                return map.easeTo({
                    duration: 300,
                    zoom: map.getZoom() - 1,
                    around: map.unproject(zoomOutPoint)
                }, { originalEvent: e });
            }
        };
    }
};
TapZoomHandler.prototype.touchcancel = function touchcancel() {
    this.reset();
};
TapZoomHandler.prototype.enable = function enable() {
    this._enabled = true;
};
TapZoomHandler.prototype.disable = function disable() {
    this._enabled = false;
    this.reset();
};
TapZoomHandler.prototype.isEnabled = function isEnabled() {
    return this._enabled;
};
TapZoomHandler.prototype.isActive = function isActive() {
    return this._active;
};

var LEFT_BUTTON = 0;
var RIGHT_BUTTON = 2;
var BUTTONS_FLAGS = {};
BUTTONS_FLAGS[LEFT_BUTTON] = 1;
BUTTONS_FLAGS[RIGHT_BUTTON] = 2;
function buttonStillPressed(e, button) {
    var flag = BUTTONS_FLAGS[button];
    return e.buttons === undefined || (e.buttons & flag) !== flag;
}
var MouseHandler = function MouseHandler(options) {
    this.reset();
    this._clickTolerance = options.clickTolerance || 1;
};
MouseHandler.prototype.reset = function reset() {
    this._active = false;
    this._moved = false;
    delete this._lastPoint;
    delete this._eventButton;
};
MouseHandler.prototype._correctButton = function _correctButton(e, button) {
    return false;
};
MouseHandler.prototype._move = function _move(lastPoint, point) {
    return {};
};
MouseHandler.prototype.mousedown = function mousedown(e, point) {
    if (this._lastPoint) {
        return;
    }
    var eventButton = DOM.mouseButton(e);
    if (!this._correctButton(e, eventButton)) {
        return;
    }
    this._lastPoint = point;
    this._eventButton = eventButton;
};
MouseHandler.prototype.mousemoveWindow = function mousemoveWindow(e, point) {
    var lastPoint = this._lastPoint;
    if (!lastPoint) {
        return;
    }
    e.preventDefault();
    if (buttonStillPressed(e, this._eventButton)) {
        this.reset();
        return;
    }
    if (!this._moved && point.dist(lastPoint) < this._clickTolerance) {
        return;
    }
    this._moved = true;
    this._lastPoint = point;
    return this._move(lastPoint, point);
};
MouseHandler.prototype.mouseupWindow = function mouseupWindow(e) {
    if (!this._lastPoint) {
        return;
    }
    var eventButton = DOM.mouseButton(e);
    if (eventButton !== this._eventButton) {
        return;
    }
    if (this._moved) {
        DOM.suppressClick();
    }
    this.reset();
};
MouseHandler.prototype.enable = function enable() {
    this._enabled = true;
};
MouseHandler.prototype.disable = function disable() {
    this._enabled = false;
    this.reset();
};
MouseHandler.prototype.isEnabled = function isEnabled() {
    return this._enabled;
};
MouseHandler.prototype.isActive = function isActive() {
    return this._active;
};
var MousePanHandler = function (MouseHandler) {
    function MousePanHandler() {
        MouseHandler.apply(this, arguments);
    }
    if (MouseHandler)
        MousePanHandler.__proto__ = MouseHandler;
    MousePanHandler.prototype = Object.create(MouseHandler && MouseHandler.prototype);
    MousePanHandler.prototype.constructor = MousePanHandler;
    MousePanHandler.prototype.mousedown = function mousedown(e, point) {
        MouseHandler.prototype.mousedown.call(this, e, point);
        if (this._lastPoint) {
            this._active = true;
        }
    };
    MousePanHandler.prototype._correctButton = function _correctButton(e, button) {
        return button === LEFT_BUTTON && !e.ctrlKey;
    };
    MousePanHandler.prototype._move = function _move(lastPoint, point) {
        return {
            around: point,
            panDelta: point.sub(lastPoint)
        };
    };
    return MousePanHandler;
}(MouseHandler);
var MouseRotateHandler = function (MouseHandler) {
    function MouseRotateHandler() {
        MouseHandler.apply(this, arguments);
    }
    if (MouseHandler)
        MouseRotateHandler.__proto__ = MouseHandler;
    MouseRotateHandler.prototype = Object.create(MouseHandler && MouseHandler.prototype);
    MouseRotateHandler.prototype.constructor = MouseRotateHandler;
    MouseRotateHandler.prototype._correctButton = function _correctButton(e, button) {
        return button === LEFT_BUTTON && e.ctrlKey || button === RIGHT_BUTTON;
    };
    MouseRotateHandler.prototype._move = function _move(lastPoint, point) {
        var degreesPerPixelMoved = 0.8;
        var bearingDelta = (point.x - lastPoint.x) * degreesPerPixelMoved;
        if (bearingDelta) {
            this._active = true;
            return { bearingDelta: bearingDelta };
        }
    };
    MouseRotateHandler.prototype.contextmenu = function contextmenu(e) {
        e.preventDefault();
    };
    return MouseRotateHandler;
}(MouseHandler);
var MousePitchHandler = function (MouseHandler) {
    function MousePitchHandler() {
        MouseHandler.apply(this, arguments);
    }
    if (MouseHandler)
        MousePitchHandler.__proto__ = MouseHandler;
    MousePitchHandler.prototype = Object.create(MouseHandler && MouseHandler.prototype);
    MousePitchHandler.prototype.constructor = MousePitchHandler;
    MousePitchHandler.prototype._correctButton = function _correctButton(e, button) {
        return button === LEFT_BUTTON && e.ctrlKey || button === RIGHT_BUTTON;
    };
    MousePitchHandler.prototype._move = function _move(lastPoint, point) {
        var degreesPerPixelMoved = -0.5;
        var pitchDelta = (point.y - lastPoint.y) * degreesPerPixelMoved;
        if (pitchDelta) {
            this._active = true;
            return { pitchDelta: pitchDelta };
        }
    };
    MousePitchHandler.prototype.contextmenu = function contextmenu(e) {
        e.preventDefault();
    };
    return MousePitchHandler;
}(MouseHandler);

var TouchPanHandler = function TouchPanHandler(options) {
    this._minTouches = 1;
    this._clickTolerance = options.clickTolerance || 1;
    this.reset();
};
TouchPanHandler.prototype.reset = function reset() {
    this._active = false;
    this._touches = {};
    this._sum = new performance.Point(0, 0);
};
TouchPanHandler.prototype.touchstart = function touchstart(e, points, mapTouches) {
    return this._calculateTransform(e, points, mapTouches);
};
TouchPanHandler.prototype.touchmove = function touchmove(e, points, mapTouches) {
    if (!this._active || mapTouches.length < this._minTouches) {
        return;
    }
    e.preventDefault();
    return this._calculateTransform(e, points, mapTouches);
};
TouchPanHandler.prototype.touchend = function touchend(e, points, mapTouches) {
    this._calculateTransform(e, points, mapTouches);
    if (this._active && mapTouches.length < this._minTouches) {
        this.reset();
    }
};
TouchPanHandler.prototype.touchcancel = function touchcancel() {
    this.reset();
};
TouchPanHandler.prototype._calculateTransform = function _calculateTransform(e, points, mapTouches) {
    if (mapTouches.length > 0) {
        this._active = true;
    }
    var touches = indexTouches(mapTouches, points);
    var touchPointSum = new performance.Point(0, 0);
    var touchDeltaSum = new performance.Point(0, 0);
    var touchDeltaCount = 0;
    for (var identifier in touches) {
        var point = touches[identifier];
        var prevPoint = this._touches[identifier];
        if (prevPoint) {
            touchPointSum._add(point);
            touchDeltaSum._add(point.sub(prevPoint));
            touchDeltaCount++;
            touches[identifier] = point;
        }
    }
    this._touches = touches;
    if (touchDeltaCount < this._minTouches || !touchDeltaSum.mag()) {
        return;
    }
    var panDelta = touchDeltaSum.div(touchDeltaCount);
    this._sum._add(panDelta);
    if (this._sum.mag() < this._clickTolerance) {
        return;
    }
    var around = touchPointSum.div(touchDeltaCount);
    return {
        around: around,
        panDelta: panDelta
    };
};
TouchPanHandler.prototype.enable = function enable() {
    this._enabled = true;
};
TouchPanHandler.prototype.disable = function disable() {
    this._enabled = false;
    this.reset();
};
TouchPanHandler.prototype.isEnabled = function isEnabled() {
    return this._enabled;
};
TouchPanHandler.prototype.isActive = function isActive() {
    return this._active;
};

var TwoTouchHandler = function TwoTouchHandler() {
    this.reset();
};
TwoTouchHandler.prototype.reset = function reset() {
    this._active = false;
    delete this._firstTwoTouches;
};
TwoTouchHandler.prototype._start = function _start(points) {
};
TwoTouchHandler.prototype._move = function _move(points, pinchAround, e) {
    return {};
};
TwoTouchHandler.prototype.touchstart = function touchstart(e, points, mapTouches) {
    if (this._firstTwoTouches || mapTouches.length < 2) {
        return;
    }
    this._firstTwoTouches = [
        mapTouches[0].identifier,
        mapTouches[1].identifier
    ];
    this._start([
        points[0],
        points[1]
    ]);
};
TwoTouchHandler.prototype.touchmove = function touchmove(e, points, mapTouches) {
    if (!this._firstTwoTouches) {
        return;
    }
    e.preventDefault();
    var ref = this._firstTwoTouches;
    var idA = ref[0];
    var idB = ref[1];
    var a = getTouchById(mapTouches, points, idA);
    var b = getTouchById(mapTouches, points, idB);
    if (!a || !b) {
        return;
    }
    var pinchAround = this._aroundCenter ? null : a.add(b).div(2);
    return this._move([
        a,
        b
    ], pinchAround, e);
};
TwoTouchHandler.prototype.touchend = function touchend(e, points, mapTouches) {
    if (!this._firstTwoTouches) {
        return;
    }
    var ref = this._firstTwoTouches;
    var idA = ref[0];
    var idB = ref[1];
    var a = getTouchById(mapTouches, points, idA);
    var b = getTouchById(mapTouches, points, idB);
    if (a && b) {
        return;
    }
    if (this._active) {
        DOM.suppressClick();
    }
    this.reset();
};
TwoTouchHandler.prototype.touchcancel = function touchcancel() {
    this.reset();
};
TwoTouchHandler.prototype.enable = function enable(options) {
    this._enabled = true;
    this._aroundCenter = !!options && options.around === 'center';
};
TwoTouchHandler.prototype.disable = function disable() {
    this._enabled = false;
    this.reset();
};
TwoTouchHandler.prototype.isEnabled = function isEnabled() {
    return this._enabled;
};
TwoTouchHandler.prototype.isActive = function isActive() {
    return this._active;
};
function getTouchById(mapTouches, points, identifier) {
    for (var i = 0; i < mapTouches.length; i++) {
        if (mapTouches[i].identifier === identifier) {
            return points[i];
        }
    }
}
var ZOOM_THRESHOLD = 0.1;
function getZoomDelta(distance, lastDistance) {
    return Math.log(distance / lastDistance) / Math.LN2;
}
var TouchZoomHandler = function (TwoTouchHandler) {
    function TouchZoomHandler() {
        TwoTouchHandler.apply(this, arguments);
    }
    if (TwoTouchHandler)
        TouchZoomHandler.__proto__ = TwoTouchHandler;
    TouchZoomHandler.prototype = Object.create(TwoTouchHandler && TwoTouchHandler.prototype);
    TouchZoomHandler.prototype.constructor = TouchZoomHandler;
    TouchZoomHandler.prototype.reset = function reset() {
        TwoTouchHandler.prototype.reset.call(this);
        delete this._distance;
        delete this._startDistance;
    };
    TouchZoomHandler.prototype._start = function _start(points) {
        this._startDistance = this._distance = points[0].dist(points[1]);
    };
    TouchZoomHandler.prototype._move = function _move(points, pinchAround) {
        var lastDistance = this._distance;
        this._distance = points[0].dist(points[1]);
        if (!this._active && Math.abs(getZoomDelta(this._distance, this._startDistance)) < ZOOM_THRESHOLD) {
            return;
        }
        this._active = true;
        return {
            zoomDelta: getZoomDelta(this._distance, lastDistance),
            pinchAround: pinchAround
        };
    };
    return TouchZoomHandler;
}(TwoTouchHandler);
var ROTATION_THRESHOLD = 25;
function getBearingDelta(a, b) {
    return a.angleWith(b) * 180 / Math.PI;
}
var TouchRotateHandler = function (TwoTouchHandler) {
    function TouchRotateHandler() {
        TwoTouchHandler.apply(this, arguments);
    }
    if (TwoTouchHandler)
        TouchRotateHandler.__proto__ = TwoTouchHandler;
    TouchRotateHandler.prototype = Object.create(TwoTouchHandler && TwoTouchHandler.prototype);
    TouchRotateHandler.prototype.constructor = TouchRotateHandler;
    TouchRotateHandler.prototype.reset = function reset() {
        TwoTouchHandler.prototype.reset.call(this);
        delete this._minDiameter;
        delete this._startVector;
        delete this._vector;
    };
    TouchRotateHandler.prototype._start = function _start(points) {
        this._startVector = this._vector = points[0].sub(points[1]);
        this._minDiameter = points[0].dist(points[1]);
    };
    TouchRotateHandler.prototype._move = function _move(points, pinchAround) {
        var lastVector = this._vector;
        this._vector = points[0].sub(points[1]);
        if (!this._active && this._isBelowThreshold(this._vector)) {
            return;
        }
        this._active = true;
        return {
            bearingDelta: getBearingDelta(this._vector, lastVector),
            pinchAround: pinchAround
        };
    };
    TouchRotateHandler.prototype._isBelowThreshold = function _isBelowThreshold(vector) {
        this._minDiameter = Math.min(this._minDiameter, vector.mag());
        var circumference = Math.PI * this._minDiameter;
        var threshold = ROTATION_THRESHOLD / circumference * 360;
        var bearingDeltaSinceStart = getBearingDelta(vector, this._startVector);
        return Math.abs(bearingDeltaSinceStart) < threshold;
    };
    return TouchRotateHandler;
}(TwoTouchHandler);
function isVertical(vector) {
    return Math.abs(vector.y) > Math.abs(vector.x);
}
var ALLOWED_SINGLE_TOUCH_TIME = 100;
var TouchPitchHandler = function (TwoTouchHandler) {
    function TouchPitchHandler() {
        TwoTouchHandler.apply(this, arguments);
    }
    if (TwoTouchHandler)
        TouchPitchHandler.__proto__ = TwoTouchHandler;
    TouchPitchHandler.prototype = Object.create(TwoTouchHandler && TwoTouchHandler.prototype);
    TouchPitchHandler.prototype.constructor = TouchPitchHandler;
    TouchPitchHandler.prototype.reset = function reset() {
        TwoTouchHandler.prototype.reset.call(this);
        this._valid = undefined;
        delete this._firstMove;
        delete this._lastPoints;
    };
    TouchPitchHandler.prototype._start = function _start(points) {
        this._lastPoints = points;
        if (isVertical(points[0].sub(points[1]))) {
            this._valid = false;
        }
    };
    TouchPitchHandler.prototype._move = function _move(points, center, e) {
        var vectorA = points[0].sub(this._lastPoints[0]);
        var vectorB = points[1].sub(this._lastPoints[1]);
        this._valid = this.gestureBeginsVertically(vectorA, vectorB, e.timeStamp);
        if (!this._valid) {
            return;
        }
        this._lastPoints = points;
        this._active = true;
        var yDeltaAverage = (vectorA.y + vectorB.y) / 2;
        var degreesPerPixelMoved = -0.5;
        return { pitchDelta: yDeltaAverage * degreesPerPixelMoved };
    };
    TouchPitchHandler.prototype.gestureBeginsVertically = function gestureBeginsVertically(vectorA, vectorB, timeStamp) {
        if (this._valid !== undefined) {
            return this._valid;
        }
        var threshold = 2;
        var movedA = vectorA.mag() >= threshold;
        var movedB = vectorB.mag() >= threshold;
        if (!movedA && !movedB) {
            return;
        }
        if (!movedA || !movedB) {
            if (this._firstMove === undefined) {
                this._firstMove = timeStamp;
            }
            if (timeStamp - this._firstMove < ALLOWED_SINGLE_TOUCH_TIME) {
                return undefined;
            } else {
                return false;
            }
        }
        var isSameDirection = vectorA.y > 0 === vectorB.y > 0;
        return isVertical(vectorA) && isVertical(vectorB) && isSameDirection;
    };
    return TouchPitchHandler;
}(TwoTouchHandler);

var defaultOptions = {
    panStep: 100,
    bearingStep: 15,
    pitchStep: 10
};
var KeyboardHandler = function KeyboardHandler() {
    var stepOptions = defaultOptions;
    this._panStep = stepOptions.panStep;
    this._bearingStep = stepOptions.bearingStep;
    this._pitchStep = stepOptions.pitchStep;
    this._rotationDisabled = false;
};
KeyboardHandler.prototype.reset = function reset() {
    this._active = false;
};
KeyboardHandler.prototype.keydown = function keydown(e) {
    var this$1 = this;
    if (e.altKey || e.ctrlKey || e.metaKey) {
        return;
    }
    var zoomDir = 0;
    var bearingDir = 0;
    var pitchDir = 0;
    var xDir = 0;
    var yDir = 0;
    switch (e.keyCode) {
    case 61:
    case 107:
    case 171:
    case 187:
        zoomDir = 1;
        break;
    case 189:
    case 109:
    case 173:
        zoomDir = -1;
        break;
    case 37:
        if (e.shiftKey) {
            bearingDir = -1;
        } else {
            e.preventDefault();
            xDir = -1;
        }
        break;
    case 39:
        if (e.shiftKey) {
            bearingDir = 1;
        } else {
            e.preventDefault();
            xDir = 1;
        }
        break;
    case 38:
        if (e.shiftKey) {
            pitchDir = 1;
        } else {
            e.preventDefault();
            yDir = -1;
        }
        break;
    case 40:
        if (e.shiftKey) {
            pitchDir = -1;
        } else {
            e.preventDefault();
            yDir = 1;
        }
        break;
    default:
        return;
    }
    if (this._rotationDisabled) {
        bearingDir = 0;
        pitchDir = 0;
    }
    return {
        cameraAnimation: function (map) {
            var zoom = map.getZoom();
            map.easeTo({
                duration: 300,
                easeId: 'keyboardHandler',
                easing: easeOut,
                zoom: zoomDir ? Math.round(zoom) + zoomDir * (e.shiftKey ? 2 : 1) : zoom,
                bearing: map.getBearing() + bearingDir * this$1._bearingStep,
                pitch: map.getPitch() + pitchDir * this$1._pitchStep,
                offset: [
                    -xDir * this$1._panStep,
                    -yDir * this$1._panStep
                ],
                center: map.getCenter()
            }, { originalEvent: e });
        }
    };
};
KeyboardHandler.prototype.enable = function enable() {
    this._enabled = true;
};
KeyboardHandler.prototype.disable = function disable() {
    this._enabled = false;
    this.reset();
};
KeyboardHandler.prototype.isEnabled = function isEnabled() {
    return this._enabled;
};
KeyboardHandler.prototype.isActive = function isActive() {
    return this._active;
};
KeyboardHandler.prototype.disableRotation = function disableRotation() {
    this._rotationDisabled = true;
};
KeyboardHandler.prototype.enableRotation = function enableRotation() {
    this._rotationDisabled = false;
};
function easeOut(t) {
    return t * (2 - t);
}

var wheelZoomDelta = 4.000244140625;
var defaultZoomRate = 1 / 100;
var wheelZoomRate = 1 / 450;
var maxScalePerFrame = 2;
var ScrollZoomHandler = function ScrollZoomHandler(map, handler) {
    this._map = map;
    this._el = map.getCanvasContainer();
    this._handler = handler;
    this._delta = 0;
    this._defaultZoomRate = defaultZoomRate;
    this._wheelZoomRate = wheelZoomRate;
    performance.bindAll(['_onTimeout'], this);
};
ScrollZoomHandler.prototype.setZoomRate = function setZoomRate(zoomRate) {
    this._defaultZoomRate = zoomRate;
};
ScrollZoomHandler.prototype.setWheelZoomRate = function setWheelZoomRate(wheelZoomRate) {
    this._wheelZoomRate = wheelZoomRate;
};
ScrollZoomHandler.prototype.isEnabled = function isEnabled() {
    return !!this._enabled;
};
ScrollZoomHandler.prototype.isActive = function isActive() {
    return !!this._active || this._finishTimeout !== undefined;
};
ScrollZoomHandler.prototype.isZooming = function isZooming() {
    return !!this._zooming;
};
ScrollZoomHandler.prototype.enable = function enable(options) {
    if (this.isEnabled()) {
        return;
    }
    this._enabled = true;
    this._aroundCenter = options && options.around === 'center';
};
ScrollZoomHandler.prototype.disable = function disable() {
    if (!this.isEnabled()) {
        return;
    }
    this._enabled = false;
};
ScrollZoomHandler.prototype.wheel = function wheel(e) {
    if (!this.isEnabled()) {
        return;
    }
    var value = e.deltaMode === performance.window.WheelEvent.DOM_DELTA_LINE ? e.deltaY * 40 : e.deltaY;
    var now = performance.browser.now(), timeDelta = now - (this._lastWheelEventTime || 0);
    this._lastWheelEventTime = now;
    if (value !== 0 && value % wheelZoomDelta === 0) {
        this._type = 'wheel';
    } else if (value !== 0 && Math.abs(value) < 4) {
        this._type = 'trackpad';
    } else if (timeDelta > 400) {
        this._type = null;
        this._lastValue = value;
        this._timeout = setTimeout(this._onTimeout, 40, e);
    } else if (!this._type) {
        this._type = Math.abs(timeDelta * value) < 200 ? 'trackpad' : 'wheel';
        if (this._timeout) {
            clearTimeout(this._timeout);
            this._timeout = null;
            value += this._lastValue;
        }
    }
    if (e.shiftKey && value) {
        value = value / 4;
    }
    if (this._type) {
        this._lastWheelEvent = e;
        this._delta -= value;
        if (!this._active) {
            this._start(e);
        }
    }
    e.preventDefault();
};
ScrollZoomHandler.prototype._onTimeout = function _onTimeout(initialEvent) {
    this._type = 'wheel';
    this._delta -= this._lastValue;
    if (!this._active) {
        this._start(initialEvent);
    }
};
ScrollZoomHandler.prototype._start = function _start(e) {
    if (!this._delta) {
        return;
    }
    if (this._frameId) {
        this._frameId = null;
    }
    this._active = true;
    if (!this.isZooming()) {
        this._zooming = true;
    }
    if (this._finishTimeout) {
        clearTimeout(this._finishTimeout);
        delete this._finishTimeout;
    }
    var pos = DOM.mousePos(this._el, e);
    this._around = performance.LngLat.convert(this._aroundCenter ? this._map.getCenter() : this._map.unproject(pos));
    this._aroundPoint = this._map.transform.locationPoint(this._around);
    if (!this._frameId) {
        this._frameId = true;
        this._handler._triggerRenderFrame();
    }
};
ScrollZoomHandler.prototype.renderFrame = function renderFrame() {
    var this$1 = this;
    if (!this._frameId) {
        return;
    }
    this._frameId = null;
    if (!this.isActive()) {
        return;
    }
    var tr = this._map.transform;
    if (this._delta !== 0) {
        var zoomRate = this._type === 'wheel' && Math.abs(this._delta) > wheelZoomDelta ? this._wheelZoomRate : this._defaultZoomRate;
        var scale = maxScalePerFrame / (1 + Math.exp(-Math.abs(this._delta * zoomRate)));
        if (this._delta < 0 && scale !== 0) {
            scale = 1 / scale;
        }
        var fromScale = typeof this._targetZoom === 'number' ? tr.zoomScale(this._targetZoom) : tr.scale;
        this._targetZoom = Math.min(tr.maxZoom, Math.max(tr.minZoom, tr.scaleZoom(fromScale * scale)));
        if (this._type === 'wheel') {
            this._startZoom = tr.zoom;
            this._easing = this._smoothOutEasing(200);
        }
        this._delta = 0;
    }
    var targetZoom = typeof this._targetZoom === 'number' ? this._targetZoom : tr.zoom;
    var startZoom = this._startZoom;
    var easing = this._easing;
    var finished = false;
    var zoom;
    if (this._type === 'wheel' && startZoom && easing) {
        var t = Math.min((performance.browser.now() - this._lastWheelEventTime) / 200, 1);
        var k = easing(t);
        zoom = performance.number(startZoom, targetZoom, k);
        if (t < 1) {
            if (!this._frameId) {
                this._frameId = true;
            }
        } else {
            finished = true;
        }
    } else {
        zoom = targetZoom;
        finished = true;
    }
    this._active = true;
    if (finished) {
        this._active = false;
        this._finishTimeout = setTimeout(function () {
            this$1._zooming = false;
            this$1._handler._triggerRenderFrame();
            delete this$1._targetZoom;
            delete this$1._finishTimeout;
        }, 200);
    }
    return {
        noInertia: true,
        needsRenderFrame: !finished,
        zoomDelta: zoom - tr.zoom,
        around: this._aroundPoint,
        originalEvent: this._lastWheelEvent
    };
};
ScrollZoomHandler.prototype._smoothOutEasing = function _smoothOutEasing(duration) {
    var easing = performance.ease;
    if (this._prevEase) {
        var ease = this._prevEase, t = (performance.browser.now() - ease.start) / ease.duration, speed = ease.easing(t + 0.01) - ease.easing(t), x = 0.27 / Math.sqrt(speed * speed + 0.0001) * 0.01, y = Math.sqrt(0.27 * 0.27 - x * x);
        easing = performance.bezier(x, y, 0.25, 1);
    }
    this._prevEase = {
        start: performance.browser.now(),
        duration: duration,
        easing: easing
    };
    return easing;
};
ScrollZoomHandler.prototype.reset = function reset() {
    this._active = false;
};

var DoubleClickZoomHandler = function DoubleClickZoomHandler(clickZoom, TapZoom) {
    this._clickZoom = clickZoom;
    this._tapZoom = TapZoom;
};
DoubleClickZoomHandler.prototype.enable = function enable() {
    this._clickZoom.enable();
    this._tapZoom.enable();
};
DoubleClickZoomHandler.prototype.disable = function disable() {
    this._clickZoom.disable();
    this._tapZoom.disable();
};
DoubleClickZoomHandler.prototype.isEnabled = function isEnabled() {
    return this._clickZoom.isEnabled() && this._tapZoom.isEnabled();
};
DoubleClickZoomHandler.prototype.isActive = function isActive() {
    return this._clickZoom.isActive() || this._tapZoom.isActive();
};

var ClickZoomHandler = function ClickZoomHandler() {
    this.reset();
};
ClickZoomHandler.prototype.reset = function reset() {
    this._active = false;
};
ClickZoomHandler.prototype.dblclick = function dblclick(e, point) {
    e.preventDefault();
    return {
        cameraAnimation: function (map) {
            map.easeTo({
                duration: 300,
                zoom: map.getZoom() + (e.shiftKey ? -1 : 1),
                around: map.unproject(point)
            }, { originalEvent: e });
        }
    };
};
ClickZoomHandler.prototype.enable = function enable() {
    this._enabled = true;
};
ClickZoomHandler.prototype.disable = function disable() {
    this._enabled = false;
    this.reset();
};
ClickZoomHandler.prototype.isEnabled = function isEnabled() {
    return this._enabled;
};
ClickZoomHandler.prototype.isActive = function isActive() {
    return this._active;
};

var TapDragZoomHandler = function TapDragZoomHandler() {
    this._tap = new TapRecognizer({
        numTouches: 1,
        numTaps: 1
    });
    this.reset();
};
TapDragZoomHandler.prototype.reset = function reset() {
    this._active = false;
    delete this._swipePoint;
    delete this._swipeTouch;
    delete this._tapTime;
    this._tap.reset();
};
TapDragZoomHandler.prototype.touchstart = function touchstart(e, points, mapTouches) {
    if (this._swipePoint) {
        return;
    }
    if (this._tapTime && e.timeStamp - this._tapTime > MAX_TAP_INTERVAL) {
        this.reset();
    }
    if (!this._tapTime) {
        this._tap.touchstart(e, points, mapTouches);
    } else if (mapTouches.length > 0) {
        this._swipePoint = points[0];
        this._swipeTouch = mapTouches[0].identifier;
    }
};
TapDragZoomHandler.prototype.touchmove = function touchmove(e, points, mapTouches) {
    if (!this._tapTime) {
        this._tap.touchmove(e, points, mapTouches);
    } else if (this._swipePoint) {
        if (mapTouches[0].identifier !== this._swipeTouch) {
            return;
        }
        var newSwipePoint = points[0];
        var dist = newSwipePoint.y - this._swipePoint.y;
        this._swipePoint = newSwipePoint;
        e.preventDefault();
        this._active = true;
        return { zoomDelta: dist / 128 };
    }
};
TapDragZoomHandler.prototype.touchend = function touchend(e, points, mapTouches) {
    if (!this._tapTime) {
        var point = this._tap.touchend(e, points, mapTouches);
        if (point) {
            this._tapTime = e.timeStamp;
        }
    } else if (this._swipePoint) {
        if (mapTouches.length === 0) {
            this.reset();
        }
    }
};
TapDragZoomHandler.prototype.touchcancel = function touchcancel() {
    this.reset();
};
TapDragZoomHandler.prototype.enable = function enable() {
    this._enabled = true;
};
TapDragZoomHandler.prototype.disable = function disable() {
    this._enabled = false;
    this.reset();
};
TapDragZoomHandler.prototype.isEnabled = function isEnabled() {
    return this._enabled;
};
TapDragZoomHandler.prototype.isActive = function isActive() {
    return this._active;
};

var DragPanHandler = function DragPanHandler(el, mousePan, touchPan) {
    this._el = el;
    this._mousePan = mousePan;
    this._touchPan = touchPan;
};
DragPanHandler.prototype.enable = function enable(options) {
    this._inertiaOptions = options || {};
    this._mousePan.enable();
    this._touchPan.enable();
    this._el.classList.add('mapboxgl-touch-drag-pan');
};
DragPanHandler.prototype.disable = function disable() {
    this._mousePan.disable();
    this._touchPan.disable();
    this._el.classList.remove('mapboxgl-touch-drag-pan');
};
DragPanHandler.prototype.isEnabled = function isEnabled() {
    return this._mousePan.isEnabled() && this._touchPan.isEnabled();
};
DragPanHandler.prototype.isActive = function isActive() {
    return this._mousePan.isActive() || this._touchPan.isActive();
};

var DragRotateHandler = function DragRotateHandler(options, mouseRotate, mousePitch) {
    this._pitchWithRotate = options.pitchWithRotate;
    this._mouseRotate = mouseRotate;
    this._mousePitch = mousePitch;
};
DragRotateHandler.prototype.enable = function enable() {
    this._mouseRotate.enable();
    if (this._pitchWithRotate) {
        this._mousePitch.enable();
    }
};
DragRotateHandler.prototype.disable = function disable() {
    this._mouseRotate.disable();
    this._mousePitch.disable();
};
DragRotateHandler.prototype.isEnabled = function isEnabled() {
    return this._mouseRotate.isEnabled() && (!this._pitchWithRotate || this._mousePitch.isEnabled());
};
DragRotateHandler.prototype.isActive = function isActive() {
    return this._mouseRotate.isActive() || this._mousePitch.isActive();
};

var TouchZoomRotateHandler = function TouchZoomRotateHandler(el, touchZoom, touchRotate, tapDragZoom) {
    this._el = el;
    this._touchZoom = touchZoom;
    this._touchRotate = touchRotate;
    this._tapDragZoom = tapDragZoom;
    this._rotationDisabled = false;
    this._enabled = true;
};
TouchZoomRotateHandler.prototype.enable = function enable(options) {
    this._touchZoom.enable(options);
    if (!this._rotationDisabled) {
        this._touchRotate.enable(options);
    }
    this._tapDragZoom.enable();
    this._el.classList.add('mapboxgl-touch-zoom-rotate');
};
TouchZoomRotateHandler.prototype.disable = function disable() {
    this._touchZoom.disable();
    this._touchRotate.disable();
    this._tapDragZoom.disable();
    this._el.classList.remove('mapboxgl-touch-zoom-rotate');
};
TouchZoomRotateHandler.prototype.isEnabled = function isEnabled() {
    return this._touchZoom.isEnabled() && (this._rotationDisabled || this._touchRotate.isEnabled()) && this._tapDragZoom.isEnabled();
};
TouchZoomRotateHandler.prototype.isActive = function isActive() {
    return this._touchZoom.isActive() || this._touchRotate.isActive() || this._tapDragZoom.isActive();
};
TouchZoomRotateHandler.prototype.disableRotation = function disableRotation() {
    this._rotationDisabled = true;
    this._touchRotate.disable();
};
TouchZoomRotateHandler.prototype.enableRotation = function enableRotation() {
    this._rotationDisabled = false;
    if (this._touchZoom.isEnabled()) {
        this._touchRotate.enable();
    }
};

var isMoving = function (p) {
    return p.zoom || p.drag || p.pitch || p.rotate;
};
var RenderFrameEvent = function (Event) {
    function RenderFrameEvent() {
        Event.apply(this, arguments);
    }
    if (Event)
        RenderFrameEvent.__proto__ = Event;
    RenderFrameEvent.prototype = Object.create(Event && Event.prototype);
    RenderFrameEvent.prototype.constructor = RenderFrameEvent;
    return RenderFrameEvent;
}(performance.Event);
function hasChange(result) {
    return result.panDelta && result.panDelta.mag() || result.zoomDelta || result.bearingDelta || result.pitchDelta;
}
var HandlerManager = function HandlerManager(map, options) {
    this._map = map;
    this._el = this._map.getCanvasContainer();
    this._handlers = [];
    this._handlersById = {};
    this._changes = [];
    this._inertia = new HandlerInertia(map);
    this._bearingSnap = options.bearingSnap;
    this._previousActiveHandlers = {};
    this._eventsInProgress = {};
    this._addDefaultHandlers(options);
    performance.bindAll([
        'handleEvent',
        'handleWindowEvent'
    ], this);
    var el = this._el;
    this._listeners = [
        [
            el,
            'touchstart',
            { passive: true }
        ],
        [
            el,
            'touchmove',
            { passive: false }
        ],
        [
            el,
            'touchend',
            undefined
        ],
        [
            el,
            'touchcancel',
            undefined
        ],
        [
            el,
            'mousedown',
            undefined
        ],
        [
            el,
            'mousemove',
            undefined
        ],
        [
            el,
            'mouseup',
            undefined
        ],
        [
            performance.window.document,
            'mousemove',
            { capture: true }
        ],
        [
            performance.window.document,
            'mouseup',
            undefined
        ],
        [
            el,
            'mouseover',
            undefined
        ],
        [
            el,
            'mouseout',
            undefined
        ],
        [
            el,
            'dblclick',
            undefined
        ],
        [
            el,
            'click',
            undefined
        ],
        [
            el,
            'keydown',
            { capture: false }
        ],
        [
            el,
            'keyup',
            undefined
        ],
        [
            el,
            'wheel',
            { passive: false }
        ],
        [
            el,
            'contextmenu',
            undefined
        ],
        [
            performance.window,
            'blur',
            undefined
        ]
    ];
    for (var i = 0, list = this._listeners; i < list.length; i += 1) {
        var ref = list[i];
        var target = ref[0];
        var type = ref[1];
        var listenerOptions = ref[2];
        DOM.addEventListener(target, type, target === performance.window.document ? this.handleWindowEvent : this.handleEvent, listenerOptions);
    }
};
HandlerManager.prototype.destroy = function destroy() {
    for (var i = 0, list = this._listeners; i < list.length; i += 1) {
        var ref = list[i];
        var target = ref[0];
        var type = ref[1];
        var listenerOptions = ref[2];
        DOM.removeEventListener(target, type, target === performance.window.document ? this.handleWindowEvent : this.handleEvent, listenerOptions);
    }
};
HandlerManager.prototype._addDefaultHandlers = function _addDefaultHandlers(options) {
    var map = this._map;
    var el = map.getCanvasContainer();
    this._add('mapEvent', new MapEventHandler(map, options));
    var boxZoom = map.boxZoom = new BoxZoomHandler(map, options);
    this._add('boxZoom', boxZoom);
    var tapZoom = new TapZoomHandler();
    var clickZoom = new ClickZoomHandler();
    map.doubleClickZoom = new DoubleClickZoomHandler(clickZoom, tapZoom);
    this._add('tapZoom', tapZoom);
    this._add('clickZoom', clickZoom);
    var tapDragZoom = new TapDragZoomHandler();
    this._add('tapDragZoom', tapDragZoom);
    var touchPitch = map.touchPitch = new TouchPitchHandler();
    this._add('touchPitch', touchPitch);
    var mouseRotate = new MouseRotateHandler(options);
    var mousePitch = new MousePitchHandler(options);
    map.dragRotate = new DragRotateHandler(options, mouseRotate, mousePitch);
    this._add('mouseRotate', mouseRotate, ['mousePitch']);
    this._add('mousePitch', mousePitch, ['mouseRotate']);
    var mousePan = new MousePanHandler(options);
    var touchPan = new TouchPanHandler(options);
    map.dragPan = new DragPanHandler(el, mousePan, touchPan);
    this._add('mousePan', mousePan);
    this._add('touchPan', touchPan, [
        'touchZoom',
        'touchRotate'
    ]);
    var touchRotate = new TouchRotateHandler();
    var touchZoom = new TouchZoomHandler();
    map.touchZoomRotate = new TouchZoomRotateHandler(el, touchZoom, touchRotate, tapDragZoom);
    this._add('touchRotate', touchRotate, [
        'touchPan',
        'touchZoom'
    ]);
    this._add('touchZoom', touchZoom, [
        'touchPan',
        'touchRotate'
    ]);
    var scrollZoom = map.scrollZoom = new ScrollZoomHandler(map, this);
    this._add('scrollZoom', scrollZoom, ['mousePan']);
    var keyboard = map.keyboard = new KeyboardHandler();
    this._add('keyboard', keyboard);
    this._add('blockableMapEvent', new BlockableMapEventHandler(map));
    for (var i = 0, list = [
                'boxZoom',
                'doubleClickZoom',
                'tapDragZoom',
                'touchPitch',
                'dragRotate',
                'dragPan',
                'touchZoomRotate',
                'scrollZoom',
                'keyboard'
            ]; i < list.length; i += 1) {
        var name = list[i];
        if (options.interactive && options[name]) {
            map[name].enable(options[name]);
        }
    }
};
HandlerManager.prototype._add = function _add(handlerName, handler, allowed) {
    this._handlers.push({
        handlerName: handlerName,
        handler: handler,
        allowed: allowed
    });
    this._handlersById[handlerName] = handler;
};
HandlerManager.prototype.stop = function stop(allowEndAnimation) {
    if (this._updatingCamera) {
        return;
    }
    for (var i = 0, list = this._handlers; i < list.length; i += 1) {
        var ref = list[i];
        var handler = ref.handler;
        handler.reset();
    }
    this._inertia.clear();
    this._fireEvents({}, {}, allowEndAnimation);
    this._changes = [];
};
HandlerManager.prototype.isActive = function isActive() {
    for (var i = 0, list = this._handlers; i < list.length; i += 1) {
        var ref = list[i];
        var handler = ref.handler;
        if (handler.isActive()) {
            return true;
        }
    }
    return false;
};
HandlerManager.prototype.isZooming = function isZooming() {
    return !!this._eventsInProgress.zoom || this._map.scrollZoom.isZooming();
};
HandlerManager.prototype.isRotating = function isRotating() {
    return !!this._eventsInProgress.rotate;
};
HandlerManager.prototype.isMoving = function isMoving$1() {
    return Boolean(isMoving(this._eventsInProgress)) || this.isZooming();
};
HandlerManager.prototype._blockedByActive = function _blockedByActive(activeHandlers, allowed, myName) {
    for (var name in activeHandlers) {
        if (name === myName) {
            continue;
        }
        if (!allowed || allowed.indexOf(name) < 0) {
            return true;
        }
    }
    return false;
};
HandlerManager.prototype.handleWindowEvent = function handleWindowEvent(e) {
    this.handleEvent(e, e.type + 'Window');
};
HandlerManager.prototype._getMapTouches = function _getMapTouches(touches) {
    var mapTouches = [];
    for (var i = 0, list = touches; i < list.length; i += 1) {
        var t = list[i];
        var target = t.target;
        if (this._el.contains(target)) {
            mapTouches.push(t);
        }
    }
    return mapTouches;
};
HandlerManager.prototype.handleEvent = function handleEvent(e, eventName) {
    if (e.type === 'blur') {
        this.stop(true);
        return;
    }
    this._updatingCamera = true;
    var inputEvent = e.type === 'renderFrame' ? undefined : e;
    var mergedHandlerResult = { needsRenderFrame: false };
    var eventsInProgress = {};
    var activeHandlers = {};
    var mapTouches = e.touches ? this._getMapTouches(e.touches) : undefined;
    var points = mapTouches ? DOM.touchPos(this._el, mapTouches) : DOM.mousePos(this._el, e);
    for (var i = 0, list = this._handlers; i < list.length; i += 1) {
        var ref = list[i];
        var handlerName = ref.handlerName;
        var handler = ref.handler;
        var allowed = ref.allowed;
        if (!handler.isEnabled()) {
            continue;
        }
        var data = void 0;
        if (this._blockedByActive(activeHandlers, allowed, handlerName)) {
            handler.reset();
        } else {
            if (handler[eventName || e.type]) {
                data = handler[eventName || e.type](e, points, mapTouches);
                this.mergeHandlerResult(mergedHandlerResult, eventsInProgress, data, handlerName, inputEvent);
                if (data && data.needsRenderFrame) {
                    this._triggerRenderFrame();
                }
            }
        }
        if (data || handler.isActive()) {
            activeHandlers[handlerName] = handler;
        }
    }
    var deactivatedHandlers = {};
    for (var name in this._previousActiveHandlers) {
        if (!activeHandlers[name]) {
            deactivatedHandlers[name] = inputEvent;
        }
    }
    this._previousActiveHandlers = activeHandlers;
    if (Object.keys(deactivatedHandlers).length || hasChange(mergedHandlerResult)) {
        this._changes.push([
            mergedHandlerResult,
            eventsInProgress,
            deactivatedHandlers
        ]);
        this._triggerRenderFrame();
    }
    if (Object.keys(activeHandlers).length || hasChange(mergedHandlerResult)) {
        this._map._stop(true);
    }
    this._updatingCamera = false;
    var cameraAnimation = mergedHandlerResult.cameraAnimation;
    if (cameraAnimation) {
        this._inertia.clear();
        this._fireEvents({}, {}, true);
        this._changes = [];
        cameraAnimation(this._map);
    }
};
HandlerManager.prototype.mergeHandlerResult = function mergeHandlerResult(mergedHandlerResult, eventsInProgress, handlerResult, name, e) {
    if (!handlerResult) {
        return;
    }
    performance.extend(mergedHandlerResult, handlerResult);
    var eventData = {
        handlerName: name,
        originalEvent: handlerResult.originalEvent || e
    };
    if (handlerResult.zoomDelta !== undefined) {
        eventsInProgress.zoom = eventData;
    }
    if (handlerResult.panDelta !== undefined) {
        eventsInProgress.drag = eventData;
    }
    if (handlerResult.pitchDelta !== undefined) {
        eventsInProgress.pitch = eventData;
    }
    if (handlerResult.bearingDelta !== undefined) {
        eventsInProgress.rotate = eventData;
    }
};
HandlerManager.prototype._applyChanges = function _applyChanges() {
    var combined = {};
    var combinedEventsInProgress = {};
    var combinedDeactivatedHandlers = {};
    for (var i = 0, list = this._changes; i < list.length; i += 1) {
        var ref = list[i];
        var change = ref[0];
        var eventsInProgress = ref[1];
        var deactivatedHandlers = ref[2];
        if (change.panDelta) {
            combined.panDelta = (combined.panDelta || new performance.Point(0, 0))._add(change.panDelta);
        }
        if (change.zoomDelta) {
            combined.zoomDelta = (combined.zoomDelta || 0) + change.zoomDelta;
        }
        if (change.bearingDelta) {
            combined.bearingDelta = (combined.bearingDelta || 0) + change.bearingDelta;
        }
        if (change.pitchDelta) {
            combined.pitchDelta = (combined.pitchDelta || 0) + change.pitchDelta;
        }
        if (change.around !== undefined) {
            combined.around = change.around;
        }
        if (change.pinchAround !== undefined) {
            combined.pinchAround = change.pinchAround;
        }
        if (change.noInertia) {
            combined.noInertia = change.noInertia;
        }
        performance.extend(combinedEventsInProgress, eventsInProgress);
        performance.extend(combinedDeactivatedHandlers, deactivatedHandlers);
    }
    this._updateMapTransform(combined, combinedEventsInProgress, combinedDeactivatedHandlers);
    this._changes = [];
};
HandlerManager.prototype._updateMapTransform = function _updateMapTransform(combinedResult, combinedEventsInProgress, deactivatedHandlers) {
    var map = this._map;
    var tr = map.transform;
    if (!hasChange(combinedResult)) {
        return this._fireEvents(combinedEventsInProgress, deactivatedHandlers, true);
    }
    var panDelta = combinedResult.panDelta;
    var zoomDelta = combinedResult.zoomDelta;
    var bearingDelta = combinedResult.bearingDelta;
    var pitchDelta = combinedResult.pitchDelta;
    var around = combinedResult.around;
    var pinchAround = combinedResult.pinchAround;
    if (pinchAround !== undefined) {
        around = pinchAround;
    }
    map._stop(true);
    around = around || map.transform.centerPoint;
    var loc = tr.pointLocation(panDelta ? around.sub(panDelta) : around);
    if (bearingDelta) {
        tr.bearing += bearingDelta;
    }
    if (pitchDelta) {
        tr.pitch += pitchDelta;
    }
    if (zoomDelta) {
        tr.zoom += zoomDelta;
    }
    tr.setLocationAtPoint(loc, around);
    this._map._update();
    if (!combinedResult.noInertia) {
        this._inertia.record(combinedResult);
    }
    this._fireEvents(combinedEventsInProgress, deactivatedHandlers, true);
};
HandlerManager.prototype._fireEvents = function _fireEvents(newEventsInProgress, deactivatedHandlers, allowEndAnimation) {
    var this$1 = this;
    var wasMoving = isMoving(this._eventsInProgress);
    var nowMoving = isMoving(newEventsInProgress);
    var startEvents = {};
    for (var eventName in newEventsInProgress) {
        var ref = newEventsInProgress[eventName];
        var originalEvent = ref.originalEvent;
        if (!this._eventsInProgress[eventName]) {
            startEvents[eventName + 'start'] = originalEvent;
        }
        this._eventsInProgress[eventName] = newEventsInProgress[eventName];
    }
    if (!wasMoving && nowMoving) {
        this._fireEvent('movestart', nowMoving.originalEvent);
    }
    for (var name in startEvents) {
        this._fireEvent(name, startEvents[name]);
    }
    if (nowMoving) {
        this._fireEvent('move', nowMoving.originalEvent);
    }
    for (var eventName$1 in newEventsInProgress) {
        var ref$1 = newEventsInProgress[eventName$1];
        var originalEvent$1 = ref$1.originalEvent;
        this._fireEvent(eventName$1, originalEvent$1);
    }
    var endEvents = {};
    var originalEndEvent;
    for (var eventName$2 in this._eventsInProgress) {
        var ref$2 = this._eventsInProgress[eventName$2];
        var handlerName = ref$2.handlerName;
        var originalEvent$2 = ref$2.originalEvent;
        if (!this._handlersById[handlerName].isActive()) {
            delete this._eventsInProgress[eventName$2];
            originalEndEvent = deactivatedHandlers[handlerName] || originalEvent$2;
            endEvents[eventName$2 + 'end'] = originalEndEvent;
        }
    }
    for (var name$1 in endEvents) {
        this._fireEvent(name$1, endEvents[name$1]);
    }
    var stillMoving = isMoving(this._eventsInProgress);
    if (allowEndAnimation && (wasMoving || nowMoving) && !stillMoving) {
        this._updatingCamera = true;
        var inertialEase = this._inertia._onMoveEnd(this._map.dragPan._inertiaOptions);
        var shouldSnapToNorth = function (bearing) {
            return bearing !== 0 && -this$1._bearingSnap < bearing && bearing < this$1._bearingSnap;
        };
        if (inertialEase) {
            if (shouldSnapToNorth(inertialEase.bearing || this._map.getBearing())) {
                inertialEase.bearing = 0;
            }
            this._map.easeTo(inertialEase, { originalEvent: originalEndEvent });
        } else {
            this._map.fire(new performance.Event('moveend', { originalEvent: originalEndEvent }));
            if (shouldSnapToNorth(this._map.getBearing())) {
                this._map.resetNorth();
            }
        }
        this._updatingCamera = false;
    }
};
HandlerManager.prototype._fireEvent = function _fireEvent(type, e) {
    this._map.fire(new performance.Event(type, e ? { originalEvent: e } : {}));
};
HandlerManager.prototype._requestFrame = function _requestFrame() {
    var this$1 = this;
    this._map.triggerRepaint();
    return this._map._renderTaskQueue.add(function (timeStamp) {
        delete this$1._frameId;
        this$1.handleEvent(new RenderFrameEvent('renderFrame', { timeStamp: timeStamp }));
        this$1._applyChanges();
    });
};
HandlerManager.prototype._triggerRenderFrame = function _triggerRenderFrame() {
    if (this._frameId === undefined) {
        this._frameId = this._requestFrame();
    }
};

var Camera = function (Evented) {
    function Camera(transform, options) {
        Evented.call(this);
        this._moving = false;
        this._zooming = false;
        this.transform = transform;
        this._bearingSnap = options.bearingSnap;
        performance.bindAll(['_renderFrameCallback'], this);
    }
    if (Evented)
        Camera.__proto__ = Evented;
    Camera.prototype = Object.create(Evented && Evented.prototype);
    Camera.prototype.constructor = Camera;
    Camera.prototype.getCenter = function getCenter() {
        return new performance.LngLat(this.transform.center.lng, this.transform.center.lat);
    };
    Camera.prototype.setCenter = function setCenter(center, eventData) {
        return this.jumpTo({ center: center }, eventData);
    };
    Camera.prototype.panBy = function panBy(offset, options, eventData) {
        offset = performance.Point.convert(offset).mult(-1);
        return this.panTo(this.transform.center, performance.extend({ offset: offset }, options), eventData);
    };
    Camera.prototype.panTo = function panTo(lnglat, options, eventData) {
        return this.easeTo(performance.extend({ center: lnglat }, options), eventData);
    };
    Camera.prototype.getZoom = function getZoom() {
        return this.transform.zoom;
    };
    Camera.prototype.setZoom = function setZoom(zoom, eventData) {
        this.jumpTo({ zoom: zoom }, eventData);
        return this;
    };
    Camera.prototype.zoomTo = function zoomTo(zoom, options, eventData) {
        return this.easeTo(performance.extend({ zoom: zoom }, options), eventData);
    };
    Camera.prototype.zoomIn = function zoomIn(options, eventData) {
        this.zoomTo(this.getZoom() + 1, options, eventData);
        return this;
    };
    Camera.prototype.zoomOut = function zoomOut(options, eventData) {
        this.zoomTo(this.getZoom() - 1, options, eventData);
        return this;
    };
    Camera.prototype.getBearing = function getBearing() {
        return this.transform.bearing;
    };
    Camera.prototype.setBearing = function setBearing(bearing, eventData) {
        this.jumpTo({ bearing: bearing }, eventData);
        return this;
    };
    Camera.prototype.getPadding = function getPadding() {
        return this.transform.padding;
    };
    Camera.prototype.setPadding = function setPadding(padding, eventData) {
        this.jumpTo({ padding: padding }, eventData);
        return this;
    };
    Camera.prototype.rotateTo = function rotateTo(bearing, options, eventData) {
        return this.easeTo(performance.extend({ bearing: bearing }, options), eventData);
    };
    Camera.prototype.resetNorth = function resetNorth(options, eventData) {
        this.rotateTo(0, performance.extend({ duration: 1000 }, options), eventData);
        return this;
    };
    Camera.prototype.resetNorthPitch = function resetNorthPitch(options, eventData) {
        this.easeTo(performance.extend({
            bearing: 0,
            pitch: 0,
            duration: 1000
        }, options), eventData);
        return this;
    };
    Camera.prototype.snapToNorth = function snapToNorth(options, eventData) {
        if (Math.abs(this.getBearing()) < this._bearingSnap) {
            return this.resetNorth(options, eventData);
        }
        return this;
    };
    Camera.prototype.getPitch = function getPitch() {
        return this.transform.pitch;
    };
    Camera.prototype.setPitch = function setPitch(pitch, eventData) {
        this.jumpTo({ pitch: pitch }, eventData);
        return this;
    };
    Camera.prototype.cameraForBounds = function cameraForBounds(bounds, options) {
        bounds = performance.LngLatBounds.convert(bounds);
        var bearing = options && options.bearing || 0;
        return this._cameraForBoxAndBearing(bounds.getNorthWest(), bounds.getSouthEast(), bearing, options);
    };
    Camera.prototype._cameraForBoxAndBearing = function _cameraForBoxAndBearing(p0, p1, bearing, options) {
        var defaultPadding = {
            top: 0,
            bottom: 0,
            right: 0,
            left: 0
        };
        options = performance.extend({
            padding: defaultPadding,
            offset: [
                0,
                0
            ],
            maxZoom: this.transform.maxZoom
        }, options);
        if (typeof options.padding === 'number') {
            var p = options.padding;
            options.padding = {
                top: p,
                bottom: p,
                right: p,
                left: p
            };
        }
        options.padding = performance.extend(defaultPadding, options.padding);
        var tr = this.transform;
        var edgePadding = tr.padding;
        var p0world = tr.project(performance.LngLat.convert(p0));
        var p1world = tr.project(performance.LngLat.convert(p1));
        var p0rotated = p0world.rotate(-bearing * Math.PI / 180);
        var p1rotated = p1world.rotate(-bearing * Math.PI / 180);
        var upperRight = new performance.Point(Math.max(p0rotated.x, p1rotated.x), Math.max(p0rotated.y, p1rotated.y));
        var lowerLeft = new performance.Point(Math.min(p0rotated.x, p1rotated.x), Math.min(p0rotated.y, p1rotated.y));
        var size = upperRight.sub(lowerLeft);
        var scaleX = (tr.width - (edgePadding.left + edgePadding.right + options.padding.left + options.padding.right)) / size.x;
        var scaleY = (tr.height - (edgePadding.top + edgePadding.bottom + options.padding.top + options.padding.bottom)) / size.y;
        if (scaleY < 0 || scaleX < 0) {
            performance.warnOnce('Map cannot fit within canvas with the given bounds, padding, and/or offset.');
            return;
        }
        var zoom = Math.min(tr.scaleZoom(tr.scale * Math.min(scaleX, scaleY)), options.maxZoom);
        var offset = typeof options.offset.x === 'number' ? new performance.Point(options.offset.x, options.offset.y) : performance.Point.convert(options.offset);
        var paddingOffsetX = (options.padding.left - options.padding.right) / 2;
        var paddingOffsetY = (options.padding.top - options.padding.bottom) / 2;
        var paddingOffset = new performance.Point(paddingOffsetX, paddingOffsetY);
        var rotatedPaddingOffset = paddingOffset.rotate(bearing * Math.PI / 180);
        var offsetAtInitialZoom = offset.add(rotatedPaddingOffset);
        var offsetAtFinalZoom = offsetAtInitialZoom.mult(tr.scale / tr.zoomScale(zoom));
        var center = tr.unproject(p0world.add(p1world).div(2).sub(offsetAtFinalZoom));
        return {
            center: center,
            zoom: zoom,
            bearing: bearing
        };
    };
    Camera.prototype.fitBounds = function fitBounds(bounds, options, eventData) {
        return this._fitInternal(this.cameraForBounds(bounds, options), options, eventData);
    };
    Camera.prototype.fitScreenCoordinates = function fitScreenCoordinates(p0, p1, bearing, options, eventData) {
        return this._fitInternal(this._cameraForBoxAndBearing(this.transform.pointLocation(performance.Point.convert(p0)), this.transform.pointLocation(performance.Point.convert(p1)), bearing, options), options, eventData);
    };
    Camera.prototype._fitInternal = function _fitInternal(calculatedOptions, options, eventData) {
        if (!calculatedOptions) {
            return this;
        }
        options = performance.extend(calculatedOptions, options);
        delete options.padding;
        return options.linear ? this.easeTo(options, eventData) : this.flyTo(options, eventData);
    };
    Camera.prototype.jumpTo = function jumpTo(options, eventData) {
        this.stop();
        var tr = this.transform;
        var zoomChanged = false, bearingChanged = false, pitchChanged = false;
        if ('zoom' in options && tr.zoom !== +options.zoom) {
            zoomChanged = true;
            tr.zoom = +options.zoom;
        }
        if (options.center !== undefined) {
            tr.center = performance.LngLat.convert(options.center);
        }
        if ('bearing' in options && tr.bearing !== +options.bearing) {
            bearingChanged = true;
            tr.bearing = +options.bearing;
        }
        if ('pitch' in options && tr.pitch !== +options.pitch) {
            pitchChanged = true;
            tr.pitch = +options.pitch;
        }
        if (options.padding != null && !tr.isPaddingEqual(options.padding)) {
            tr.padding = options.padding;
        }
        this.fire(new performance.Event('movestart', eventData)).fire(new performance.Event('move', eventData));
        if (zoomChanged) {
            this.fire(new performance.Event('zoomstart', eventData)).fire(new performance.Event('zoom', eventData)).fire(new performance.Event('zoomend', eventData));
        }
        if (bearingChanged) {
            this.fire(new performance.Event('rotatestart', eventData)).fire(new performance.Event('rotate', eventData)).fire(new performance.Event('rotateend', eventData));
        }
        if (pitchChanged) {
            this.fire(new performance.Event('pitchstart', eventData)).fire(new performance.Event('pitch', eventData)).fire(new performance.Event('pitchend', eventData));
        }
        return this.fire(new performance.Event('moveend', eventData));
    };
    Camera.prototype.easeTo = function easeTo(options, eventData) {
        var this$1 = this;
        this._stop(false, options.easeId);
        options = performance.extend({
            offset: [
                0,
                0
            ],
            duration: 500,
            easing: performance.ease
        }, options);
        if (options.animate === false || !options.essential && performance.browser.prefersReducedMotion) {
            options.duration = 0;
        }
        var tr = this.transform, startZoom = this.getZoom(), startBearing = this.getBearing(), startPitch = this.getPitch(), startPadding = this.getPadding(), zoom = 'zoom' in options ? +options.zoom : startZoom, bearing = 'bearing' in options ? this._normalizeBearing(options.bearing, startBearing) : startBearing, pitch = 'pitch' in options ? +options.pitch : startPitch, padding = 'padding' in options ? options.padding : tr.padding;
        var offsetAsPoint = performance.Point.convert(options.offset);
        var pointAtOffset = tr.centerPoint.add(offsetAsPoint);
        var locationAtOffset = tr.pointLocation(pointAtOffset);
        var center = performance.LngLat.convert(options.center || locationAtOffset);
        this._normalizeCenter(center);
        var from = tr.project(locationAtOffset);
        var delta = tr.project(center).sub(from);
        var finalScale = tr.zoomScale(zoom - startZoom);
        var around, aroundPoint;
        if (options.around) {
            around = performance.LngLat.convert(options.around);
            aroundPoint = tr.locationPoint(around);
        }
        var currently = {
            moving: this._moving,
            zooming: this._zooming,
            rotating: this._rotating,
            pitching: this._pitching
        };
        this._zooming = this._zooming || zoom !== startZoom;
        this._rotating = this._rotating || startBearing !== bearing;
        this._pitching = this._pitching || pitch !== startPitch;
        this._padding = !tr.isPaddingEqual(padding);
        this._easeId = options.easeId;
        this._prepareEase(eventData, options.noMoveStart, currently);
        this._ease(function (k) {
            if (this$1._zooming) {
                tr.zoom = performance.number(startZoom, zoom, k);
            }
            if (this$1._rotating) {
                tr.bearing = performance.number(startBearing, bearing, k);
            }
            if (this$1._pitching) {
                tr.pitch = performance.number(startPitch, pitch, k);
            }
            if (this$1._padding) {
                tr.interpolatePadding(startPadding, padding, k);
                pointAtOffset = tr.centerPoint.add(offsetAsPoint);
            }
            if (around) {
                tr.setLocationAtPoint(around, aroundPoint);
            } else {
                var scale = tr.zoomScale(tr.zoom - startZoom);
                var base = zoom > startZoom ? Math.min(2, finalScale) : Math.max(0.5, finalScale);
                var speedup = Math.pow(base, 1 - k);
                var newCenter = tr.unproject(from.add(delta.mult(k * speedup)).mult(scale));
                tr.setLocationAtPoint(tr.renderWorldCopies ? newCenter.wrap() : newCenter, pointAtOffset);
            }
            this$1._fireMoveEvents(eventData);
        }, function (interruptingEaseId) {
            this$1._afterEase(eventData, interruptingEaseId);
        }, options);
        return this;
    };
    Camera.prototype._prepareEase = function _prepareEase(eventData, noMoveStart, currently) {
        if (currently === void 0)
            currently = {};
        this._moving = true;
        if (!noMoveStart && !currently.moving) {
            this.fire(new performance.Event('movestart', eventData));
        }
        if (this._zooming && !currently.zooming) {
            this.fire(new performance.Event('zoomstart', eventData));
        }
        if (this._rotating && !currently.rotating) {
            this.fire(new performance.Event('rotatestart', eventData));
        }
        if (this._pitching && !currently.pitching) {
            this.fire(new performance.Event('pitchstart', eventData));
        }
    };
    Camera.prototype._fireMoveEvents = function _fireMoveEvents(eventData) {
        this.fire(new performance.Event('move', eventData));
        if (this._zooming) {
            this.fire(new performance.Event('zoom', eventData));
        }
        if (this._rotating) {
            this.fire(new performance.Event('rotate', eventData));
        }
        if (this._pitching) {
            this.fire(new performance.Event('pitch', eventData));
        }
    };
    Camera.prototype._afterEase = function _afterEase(eventData, easeId) {
        if (this._easeId && easeId && this._easeId === easeId) {
            return;
        }
        delete this._easeId;
        var wasZooming = this._zooming;
        var wasRotating = this._rotating;
        var wasPitching = this._pitching;
        this._moving = false;
        this._zooming = false;
        this._rotating = false;
        this._pitching = false;
        this._padding = false;
        if (wasZooming) {
            this.fire(new performance.Event('zoomend', eventData));
        }
        if (wasRotating) {
            this.fire(new performance.Event('rotateend', eventData));
        }
        if (wasPitching) {
            this.fire(new performance.Event('pitchend', eventData));
        }
        this.fire(new performance.Event('moveend', eventData));
    };
    Camera.prototype.flyTo = function flyTo(options, eventData) {
        var this$1 = this;
        if (!options.essential && performance.browser.prefersReducedMotion) {
            var coercedOptions = performance.pick(options, [
                'center',
                'zoom',
                'bearing',
                'pitch',
                'around'
            ]);
            return this.jumpTo(coercedOptions, eventData);
        }
        this.stop();
        options = performance.extend({
            offset: [
                0,
                0
            ],
            speed: 1.2,
            curve: 1.42,
            easing: performance.ease
        }, options);
        var tr = this.transform, startZoom = this.getZoom(), startBearing = this.getBearing(), startPitch = this.getPitch(), startPadding = this.getPadding();
        var zoom = 'zoom' in options ? performance.clamp(+options.zoom, tr.minZoom, tr.maxZoom) : startZoom;
        var bearing = 'bearing' in options ? this._normalizeBearing(options.bearing, startBearing) : startBearing;
        var pitch = 'pitch' in options ? +options.pitch : startPitch;
        var padding = 'padding' in options ? options.padding : tr.padding;
        var scale = tr.zoomScale(zoom - startZoom);
        var offsetAsPoint = performance.Point.convert(options.offset);
        var pointAtOffset = tr.centerPoint.add(offsetAsPoint);
        var locationAtOffset = tr.pointLocation(pointAtOffset);
        var center = performance.LngLat.convert(options.center || locationAtOffset);
        this._normalizeCenter(center);
        var from = tr.project(locationAtOffset);
        var delta = tr.project(center).sub(from);
        var rho = options.curve;
        var w0 = Math.max(tr.width, tr.height), w1 = w0 / scale, u1 = delta.mag();
        if ('minZoom' in options) {
            var minZoom = performance.clamp(Math.min(options.minZoom, startZoom, zoom), tr.minZoom, tr.maxZoom);
            var wMax = w0 / tr.zoomScale(minZoom - startZoom);
            rho = Math.sqrt(wMax / u1 * 2);
        }
        var rho2 = rho * rho;
        function r(i) {
            var b = (w1 * w1 - w0 * w0 + (i ? -1 : 1) * rho2 * rho2 * u1 * u1) / (2 * (i ? w1 : w0) * rho2 * u1);
            return Math.log(Math.sqrt(b * b + 1) - b);
        }
        function sinh(n) {
            return (Math.exp(n) - Math.exp(-n)) / 2;
        }
        function cosh(n) {
            return (Math.exp(n) + Math.exp(-n)) / 2;
        }
        function tanh(n) {
            return sinh(n) / cosh(n);
        }
        var r0 = r(0);
        var w = function (s) {
            return cosh(r0) / cosh(r0 + rho * s);
        };
        var u = function (s) {
            return w0 * ((cosh(r0) * tanh(r0 + rho * s) - sinh(r0)) / rho2) / u1;
        };
        var S = (r(1) - r0) / rho;
        if (Math.abs(u1) < 0.000001 || !isFinite(S)) {
            if (Math.abs(w0 - w1) < 0.000001) {
                return this.easeTo(options, eventData);
            }
            var k = w1 < w0 ? -1 : 1;
            S = Math.abs(Math.log(w1 / w0)) / rho;
            u = function () {
                return 0;
            };
            w = function (s) {
                return Math.exp(k * rho * s);
            };
        }
        if ('duration' in options) {
            options.duration = +options.duration;
        } else {
            var V = 'screenSpeed' in options ? +options.screenSpeed / rho : +options.speed;
            options.duration = 1000 * S / V;
        }
        if (options.maxDuration && options.duration > options.maxDuration) {
            options.duration = 0;
        }
        this._zooming = true;
        this._rotating = startBearing !== bearing;
        this._pitching = pitch !== startPitch;
        this._padding = !tr.isPaddingEqual(padding);
        this._prepareEase(eventData, false);
        this._ease(function (k) {
            var s = k * S;
            var scale = 1 / w(s);
            tr.zoom = k === 1 ? zoom : startZoom + tr.scaleZoom(scale);
            if (this$1._rotating) {
                tr.bearing = performance.number(startBearing, bearing, k);
            }
            if (this$1._pitching) {
                tr.pitch = performance.number(startPitch, pitch, k);
            }
            if (this$1._padding) {
                tr.interpolatePadding(startPadding, padding, k);
                pointAtOffset = tr.centerPoint.add(offsetAsPoint);
            }
            var newCenter = k === 1 ? center : tr.unproject(from.add(delta.mult(u(s))).mult(scale));
            tr.setLocationAtPoint(tr.renderWorldCopies ? newCenter.wrap() : newCenter, pointAtOffset);
            this$1._fireMoveEvents(eventData);
        }, function () {
            return this$1._afterEase(eventData);
        }, options);
        return this;
    };
    Camera.prototype.isEasing = function isEasing() {
        return !!this._easeFrameId;
    };
    Camera.prototype.stop = function stop() {
        return this._stop();
    };
    Camera.prototype._stop = function _stop(allowGestures, easeId) {
        if (this._easeFrameId) {
            this._cancelRenderFrame(this._easeFrameId);
            delete this._easeFrameId;
            delete this._onEaseFrame;
        }
        if (this._onEaseEnd) {
            var onEaseEnd = this._onEaseEnd;
            delete this._onEaseEnd;
            onEaseEnd.call(this, easeId);
        }
        if (!allowGestures) {
            var handlers = this.handlers;
            if (handlers) {
                handlers.stop(false);
            }
        }
        return this;
    };
    Camera.prototype._ease = function _ease(frame, finish, options) {
        if (options.animate === false || options.duration === 0) {
            frame(1);
            finish();
        } else {
            this._easeStart = performance.browser.now();
            this._easeOptions = options;
            this._onEaseFrame = frame;
            this._onEaseEnd = finish;
            this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback);
        }
    };
    Camera.prototype._renderFrameCallback = function _renderFrameCallback() {
        var t = Math.min((performance.browser.now() - this._easeStart) / this._easeOptions.duration, 1);
        this._onEaseFrame(this._easeOptions.easing(t));
        if (t < 1) {
            this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback);
        } else {
            this.stop();
        }
    };
    Camera.prototype._normalizeBearing = function _normalizeBearing(bearing, currentBearing) {
        bearing = performance.wrap(bearing, -180, 180);
        var diff = Math.abs(bearing - currentBearing);
        if (Math.abs(bearing - 360 - currentBearing) < diff) {
            bearing -= 360;
        }
        if (Math.abs(bearing + 360 - currentBearing) < diff) {
            bearing += 360;
        }
        return bearing;
    };
    Camera.prototype._normalizeCenter = function _normalizeCenter(center) {
        var tr = this.transform;
        if (!tr.renderWorldCopies || tr.lngRange) {
            return;
        }
        var delta = center.lng - tr.center.lng;
        center.lng += delta > 180 ? -360 : delta < -180 ? 360 : 0;
    };
    return Camera;
}(performance.Evented);

var AttributionControl = function AttributionControl(options) {
    if (options === void 0)
        options = {};
    this.options = options;
    performance.bindAll([
        '_toggleAttribution',
        '_updateEditLink',
        '_updateData',
        '_updateCompact'
    ], this);
};
AttributionControl.prototype.getDefaultPosition = function getDefaultPosition() {
    return 'bottom-right';
};
AttributionControl.prototype.onAdd = function onAdd(map) {
    var compact = this.options && this.options.compact;
    this._map = map;
    this._container = DOM.create('div', 'mapboxgl-ctrl mapboxgl-ctrl-attrib');
    this._compactButton = DOM.create('button', 'mapboxgl-ctrl-attrib-button', this._container);
    this._compactButton.addEventListener('click', this._toggleAttribution);
    this._setElementTitle(this._compactButton, 'ToggleAttribution');
    this._innerContainer = DOM.create('div', 'mapboxgl-ctrl-attrib-inner', this._container);
    this._innerContainer.setAttribute('role', 'list');
    if (compact) {
        this._container.classList.add('mapboxgl-compact');
    }
    this._updateAttributions();
    this._updateEditLink();
    this._map.on('styledata', this._updateData);
    this._map.on('sourcedata', this._updateData);
    this._map.on('moveend', this._updateEditLink);
    if (compact === undefined) {
        this._map.on('resize', this._updateCompact);
        this._updateCompact();
    }
    return this._container;
};
AttributionControl.prototype.onRemove = function onRemove() {
    DOM.remove(this._container);
    this._map.off('styledata', this._updateData);
    this._map.off('sourcedata', this._updateData);
    this._map.off('moveend', this._updateEditLink);
    this._map.off('resize', this._updateCompact);
    this._map = undefined;
    this._attribHTML = undefined;
};
AttributionControl.prototype._setElementTitle = function _setElementTitle(element, title) {
    var str = this._map._getUIString('AttributionControl.' + title);
    element.title = str;
    element.setAttribute('aria-label', str);
};
AttributionControl.prototype._toggleAttribution = function _toggleAttribution() {
    if (this._container.classList.contains('mapboxgl-compact-show')) {
        this._container.classList.remove('mapboxgl-compact-show');
        this._compactButton.setAttribute('aria-pressed', 'false');
    } else {
        this._container.classList.add('mapboxgl-compact-show');
        this._compactButton.setAttribute('aria-pressed', 'true');
    }
};
AttributionControl.prototype._updateEditLink = function _updateEditLink() {
    var editLink = this._editLink;
    if (!editLink) {
        editLink = this._editLink = this._container.querySelector('.mapbox-improve-map');
    }
    var params = [
        {
            key: 'owner',
            value: this.styleOwner
        },
        {
            key: 'id',
            value: this.styleId
        },
        {
            key: 'access_token',
            value: this._map._requestManager._customAccessToken || performance.config.ACCESS_TOKEN
        }
    ];
    if (editLink) {
        var paramString = params.reduce(function (acc, next, i) {
            if (next.value) {
                acc += next.key + '=' + next.value + (i < params.length - 1 ? '&' : '');
            }
            return acc;
        }, '?');
        editLink.href = performance.config.FEEDBACK_URL + '/' + paramString + (this._map._hash ? this._map._hash.getHashString(true) : '');
        editLink.rel = 'noopener nofollow';
        this._setElementTitle(editLink, 'MapFeedback');
    }
};
AttributionControl.prototype._updateData = function _updateData(e) {
    if (e && (e.sourceDataType === 'metadata' || e.sourceDataType === 'visibility' || e.dataType === 'style')) {
        this._updateAttributions();
        this._updateEditLink();
    }
};
AttributionControl.prototype._updateAttributions = function _updateAttributions() {
    if (!this._map.style) {
        return;
    }
    var attributions = [];
    if (this.options.customAttribution) {
        if (Array.isArray(this.options.customAttribution)) {
            attributions = attributions.concat(this.options.customAttribution.map(function (attribution) {
                if (typeof attribution !== 'string') {
                    return '';
                }
                return attribution;
            }));
        } else if (typeof this.options.customAttribution === 'string') {
            attributions.push(this.options.customAttribution);
        }
    }
    if (this._map.style.stylesheet) {
        var stylesheet = this._map.style.stylesheet;
        this.styleOwner = stylesheet.owner;
        this.styleId = stylesheet.id;
    }
    var sourceCaches = this._map.style.sourceCaches;
    for (var id in sourceCaches) {
        var sourceCache = sourceCaches[id];
        if (sourceCache.used) {
            var source = sourceCache.getSource();
            if (source.attribution && attributions.indexOf(source.attribution) < 0) {
                attributions.push(source.attribution);
            }
        }
    }
    attributions.sort(function (a, b) {
        return a.length - b.length;
    });
    attributions = attributions.filter(function (attrib, i) {
        for (var j = i + 1; j < attributions.length; j++) {
            if (attributions[j].indexOf(attrib) >= 0) {
                return false;
            }
        }
        return true;
    });
    var attribHTML = attributions.join(' | ');
    if (attribHTML === this._attribHTML) {
        return;
    }
    this._attribHTML = attribHTML;
    if (attributions.length) {
        this._innerContainer.innerHTML = attribHTML;
        this._container.classList.remove('mapboxgl-attrib-empty');
    } else {
        this._container.classList.add('mapboxgl-attrib-empty');
    }
    this._editLink = null;
};
AttributionControl.prototype._updateCompact = function _updateCompact() {
    if (this._map.getCanvasContainer().offsetWidth <= 640) {
        this._container.classList.add('mapboxgl-compact');
    } else {
        this._container.classList.remove('mapboxgl-compact', 'mapboxgl-compact-show');
    }
};

var LogoControl = function LogoControl() {
    performance.bindAll(['_updateLogo'], this);
    performance.bindAll(['_updateCompact'], this);
};
LogoControl.prototype.onAdd = function onAdd(map) {
    this._map = map;
    this._container = DOM.create('div', 'mapboxgl-ctrl');
    var anchor = DOM.create('a', 'mapboxgl-ctrl-logo');
    anchor.target = '_blank';
    anchor.rel = 'noopener nofollow';
    anchor.href = 'https://www.mapbox.com/';
    anchor.setAttribute('aria-label', this._map._getUIString('LogoControl.Title'));
    anchor.setAttribute('rel', 'noopener nofollow');
    this._container.appendChild(anchor);
    this._container.style.display = 'none';
    this._map.on('sourcedata', this._updateLogo);
    this._updateLogo();
    this._map.on('resize', this._updateCompact);
    this._updateCompact();
    return this._container;
};
LogoControl.prototype.onRemove = function onRemove() {
    DOM.remove(this._container);
    this._map.off('sourcedata', this._updateLogo);
    this._map.off('resize', this._updateCompact);
};
LogoControl.prototype.getDefaultPosition = function getDefaultPosition() {
    return 'bottom-left';
};
LogoControl.prototype._updateLogo = function _updateLogo(e) {
    if (!e || e.sourceDataType === 'metadata') {
        this._container.style.display = this._logoRequired() ? 'block' : 'none';
    }
};
LogoControl.prototype._logoRequired = function _logoRequired() {
    if (!this._map.style) {
        return;
    }
    var sourceCaches = this._map.style.sourceCaches;
    for (var id in sourceCaches) {
        var source = sourceCaches[id].getSource();
        if (source.mapbox_logo) {
            return true;
        }
    }
    return false;
};
LogoControl.prototype._updateCompact = function _updateCompact() {
    var containerChildren = this._container.children;
    if (containerChildren.length) {
        var anchor = containerChildren[0];
        if (this._map.getCanvasContainer().offsetWidth < 250) {
            anchor.classList.add('mapboxgl-compact');
        } else {
            anchor.classList.remove('mapboxgl-compact');
        }
    }
};

var TaskQueue = function TaskQueue() {
    this._queue = [];
    this._id = 0;
    this._cleared = false;
    this._currentlyRunning = false;
};
TaskQueue.prototype.add = function add(callback) {
    var id = ++this._id;
    var queue = this._queue;
    queue.push({
        callback: callback,
        id: id,
        cancelled: false
    });
    return id;
};
TaskQueue.prototype.remove = function remove(id) {
    var running = this._currentlyRunning;
    var queue = running ? this._queue.concat(running) : this._queue;
    for (var i = 0, list = queue; i < list.length; i += 1) {
        var task = list[i];
        if (task.id === id) {
            task.cancelled = true;
            return;
        }
    }
};
TaskQueue.prototype.run = function run(timeStamp) {
    if (timeStamp === void 0)
        timeStamp = 0;
    var queue = this._currentlyRunning = this._queue;
    this._queue = [];
    for (var i = 0, list = queue; i < list.length; i += 1) {
        var task = list[i];
        if (task.cancelled) {
            continue;
        }
        task.callback(timeStamp);
        if (this._cleared) {
            break;
        }
    }
    this._cleared = false;
    this._currentlyRunning = false;
};
TaskQueue.prototype.clear = function clear() {
    if (this._currentlyRunning) {
        this._cleared = true;
    }
    this._queue = [];
};

var defaultLocale = {
    'AttributionControl.ToggleAttribution': 'Toggle attribution',
    'AttributionControl.MapFeedback': 'Map feedback',
    'FullscreenControl.Enter': 'Enter fullscreen',
    'FullscreenControl.Exit': 'Exit fullscreen',
    'GeolocateControl.FindMyLocation': 'Find my location',
    'GeolocateControl.LocationNotAvailable': 'Location not available',
    'LogoControl.Title': 'Mapbox logo',
    'NavigationControl.ResetBearing': 'Reset bearing to north',
    'NavigationControl.ZoomIn': 'Zoom in',
    'NavigationControl.ZoomOut': 'Zoom out',
    'ScaleControl.Feet': 'ft',
    'ScaleControl.Meters': 'm',
    'ScaleControl.Kilometers': 'km',
    'ScaleControl.Miles': 'mi',
    'ScaleControl.NauticalMiles': 'nm'
};

var HTMLImageElement = performance.window.HTMLImageElement;
var HTMLElement = performance.window.HTMLElement;
var ImageBitmap = performance.window.ImageBitmap;
var defaultMinZoom = -2;
var defaultMaxZoom = 22;
var defaultMinPitch = 0;
var defaultMaxPitch = 60;
var defaultOptions$1 = {
    center: [
        0,
        0
    ],
    zoom: 0,
    bearing: 0,
    pitch: 0,
    minZoom: defaultMinZoom,
    maxZoom: defaultMaxZoom,
    minPitch: defaultMinPitch,
    maxPitch: defaultMaxPitch,
    interactive: true,
    scrollZoom: true,
    boxZoom: true,
    dragRotate: true,
    dragPan: true,
    keyboard: true,
    doubleClickZoom: true,
    touchZoomRotate: true,
    touchPitch: true,
    bearingSnap: 7,
    clickTolerance: 3,
    pitchWithRotate: true,
    hash: false,
    attributionControl: true,
    failIfMajorPerformanceCaveat: false,
    preserveDrawingBuffer: false,
    trackResize: true,
    renderWorldCopies: true,
    refreshExpiredTiles: true,
    maxTileCacheSize: null,
    localIdeographFontFamily: 'sans-serif',
    transformRequest: null,
    accessToken: null,
    fadeDuration: 300,
    crossSourceCollisions: true
};
var Map = function (Camera) {
    function Map(options) {
        var this$1 = this;
        options = performance.extend({}, defaultOptions$1, options);
        if (options.minZoom != null && options.maxZoom != null && options.minZoom > options.maxZoom) {
            throw new Error('maxZoom must be greater than or equal to minZoom');
        }
        if (options.minPitch != null && options.maxPitch != null && options.minPitch > options.maxPitch) {
            throw new Error('maxPitch must be greater than or equal to minPitch');
        }
        if (options.minPitch != null && options.minPitch < defaultMinPitch) {
            throw new Error('minPitch must be greater than or equal to ' + defaultMinPitch);
        }
        if (options.maxPitch != null && options.maxPitch > defaultMaxPitch) {
            throw new Error('maxPitch must be less than or equal to ' + defaultMaxPitch);
        }
        var transform = new Transform(options.minZoom, options.maxZoom, options.minPitch, options.maxPitch, options.renderWorldCopies);
        Camera.call(this, transform, options);
        this._interactive = options.interactive;
        this._maxTileCacheSize = options.maxTileCacheSize;
        this._failIfMajorPerformanceCaveat = options.failIfMajorPerformanceCaveat;
        this._preserveDrawingBuffer = options.preserveDrawingBuffer;
        this._antialias = options.antialias;
        this._trackResize = options.trackResize;
        this._bearingSnap = options.bearingSnap;
        this._refreshExpiredTiles = options.refreshExpiredTiles;
        this._fadeDuration = options.fadeDuration;
        this._crossSourceCollisions = options.crossSourceCollisions;
        this._crossFadingFactor = 1;
        this._collectResourceTiming = options.collectResourceTiming;
        this._renderTaskQueue = new TaskQueue();
        this._controls = [];
        this._mapId = performance.uniqueId();
        this._locale = performance.extend({}, defaultLocale, options.locale);
        this._clickTolerance = options.clickTolerance;
        this._requestManager = new performance.RequestManager(options.transformRequest, options.accessToken);
        if (typeof options.container === 'string') {
            this._container = performance.window.document.getElementById(options.container);
            if (!this._container) {
                throw new Error('Container \'' + options.container + '\' not found.');
            }
        } else if (options.container instanceof HTMLElement) {
            this._container = options.container;
        } else {
            throw new Error('Invalid type: \'container\' must be a String or HTMLElement.');
        }
        if (options.maxBounds) {
            this.setMaxBounds(options.maxBounds);
        }
        performance.bindAll([
            '_onWindowOnline',
            '_onWindowResize',
            '_onMapScroll',
            '_contextLost',
            '_contextRestored'
        ], this);
        this._setupContainer();
        this._setupPainter();
        if (this.painter === undefined) {
            throw new Error('Failed to initialize WebGL.');
        }
        this.on('move', function () {
            return this$1._update(false);
        });
        this.on('moveend', function () {
            return this$1._update(false);
        });
        this.on('zoom', function () {
            return this$1._update(true);
        });
        if (typeof performance.window !== 'undefined') {
            performance.window.addEventListener('online', this._onWindowOnline, false);
            performance.window.addEventListener('resize', this._onWindowResize, false);
            performance.window.addEventListener('orientationchange', this._onWindowResize, false);
        }
        this.handlers = new HandlerManager(this, options);
        var hashName = typeof options.hash === 'string' && options.hash || undefined;
        this._hash = options.hash && new Hash(hashName).addTo(this);
        if (!this._hash || !this._hash._onHashChange()) {
            this.jumpTo({
                center: options.center,
                zoom: options.zoom,
                bearing: options.bearing,
                pitch: options.pitch
            });
            if (options.bounds) {
                this.resize();
                this.fitBounds(options.bounds, performance.extend({}, options.fitBoundsOptions, { duration: 0 }));
            }
        }
        this.resize();
        this._localIdeographFontFamily = options.localIdeographFontFamily;
        if (options.style) {
            this.setStyle(options.style, { localIdeographFontFamily: options.localIdeographFontFamily });
        }
        if (options.attributionControl) {
            this.addControl(new AttributionControl({ customAttribution: options.customAttribution }));
        }
        this.addControl(new LogoControl(), options.logoPosition);
        this.on('style.load', function () {
            if (this$1.transform.unmodified) {
                this$1.jumpTo(this$1.style.stylesheet);
            }
        });
        this.on('data', function (event) {
            this$1._update(event.dataType === 'style');
            this$1.fire(new performance.Event(event.dataType + 'data', event));
        });
        this.on('dataloading', function (event) {
            this$1.fire(new performance.Event(event.dataType + 'dataloading', event));
        });
    }
    if (Camera)
        Map.__proto__ = Camera;
    Map.prototype = Object.create(Camera && Camera.prototype);
    Map.prototype.constructor = Map;
    var prototypeAccessors = {
        showTileBoundaries: { configurable: true },
        showPadding: { configurable: true },
        showCollisionBoxes: { configurable: true },
        showOverdrawInspector: { configurable: true },
        repaint: { configurable: true },
        vertices: { configurable: true },
        version: { configurable: true }
    };
    Map.prototype._getMapId = function _getMapId() {
        return this._mapId;
    };
    Map.prototype.addControl = function addControl(control, position) {
        if (position === undefined) {
            if (control.getDefaultPosition) {
                position = control.getDefaultPosition();
            } else {
                position = 'top-right';
            }
        }
        if (!control || !control.onAdd) {
            return this.fire(new performance.ErrorEvent(new Error('Invalid argument to map.addControl(). Argument must be a control with onAdd and onRemove methods.')));
        }
        var controlElement = control.onAdd(this);
        this._controls.push(control);
        var positionContainer = this._controlPositions[position];
        if (position.indexOf('bottom') !== -1) {
            positionContainer.insertBefore(controlElement, positionContainer.firstChild);
        } else {
            positionContainer.appendChild(controlElement);
        }
        return this;
    };
    Map.prototype.removeControl = function removeControl(control) {
        if (!control || !control.onRemove) {
            return this.fire(new performance.ErrorEvent(new Error('Invalid argument to map.removeControl(). Argument must be a control with onAdd and onRemove methods.')));
        }
        var ci = this._controls.indexOf(control);
        if (ci > -1) {
            this._controls.splice(ci, 1);
        }
        control.onRemove(this);
        return this;
    };
    Map.prototype.hasControl = function hasControl(control) {
        return this._controls.indexOf(control) > -1;
    };
    Map.prototype.resize = function resize(eventData) {
        var dimensions = this._containerDimensions();
        var width = dimensions[0];
        var height = dimensions[1];
        this._resizeCanvas(width, height);
        this.transform.resize(width, height);
        this.painter.resize(width, height);
        var fireMoving = !this._moving;
        if (fireMoving) {
            this.stop();
            this.fire(new performance.Event('movestart', eventData)).fire(new performance.Event('move', eventData));
        }
        this.fire(new performance.Event('resize', eventData));
        if (fireMoving) {
            this.fire(new performance.Event('moveend', eventData));
        }
        return this;
    };
    Map.prototype.getBounds = function getBounds() {
        return this.transform.getBounds();
    };
    Map.prototype.getMaxBounds = function getMaxBounds() {
        return this.transform.getMaxBounds();
    };
    Map.prototype.setMaxBounds = function setMaxBounds(bounds) {
        this.transform.setMaxBounds(performance.LngLatBounds.convert(bounds));
        return this._update();
    };
    Map.prototype.setMinZoom = function setMinZoom(minZoom) {
        minZoom = minZoom === null || minZoom === undefined ? defaultMinZoom : minZoom;
        if (minZoom >= defaultMinZoom && minZoom <= this.transform.maxZoom) {
            this.transform.minZoom = minZoom;
            this._update();
            if (this.getZoom() < minZoom) {
                this.setZoom(minZoom);
            }
            return this;
        } else {
            throw new Error('minZoom must be between ' + defaultMinZoom + ' and the current maxZoom, inclusive');
        }
    };
    Map.prototype.getMinZoom = function getMinZoom() {
        return this.transform.minZoom;
    };
    Map.prototype.setMaxZoom = function setMaxZoom(maxZoom) {
        maxZoom = maxZoom === null || maxZoom === undefined ? defaultMaxZoom : maxZoom;
        if (maxZoom >= this.transform.minZoom) {
            this.transform.maxZoom = maxZoom;
            this._update();
            if (this.getZoom() > maxZoom) {
                this.setZoom(maxZoom);
            }
            return this;
        } else {
            throw new Error('maxZoom must be greater than the current minZoom');
        }
    };
    Map.prototype.getMaxZoom = function getMaxZoom() {
        return this.transform.maxZoom;
    };
    Map.prototype.setMinPitch = function setMinPitch(minPitch) {
        minPitch = minPitch === null || minPitch === undefined ? defaultMinPitch : minPitch;
        if (minPitch < defaultMinPitch) {
            throw new Error('minPitch must be greater than or equal to ' + defaultMinPitch);
        }
        if (minPitch >= defaultMinPitch && minPitch <= this.transform.maxPitch) {
            this.transform.minPitch = minPitch;
            this._update();
            if (this.getPitch() < minPitch) {
                this.setPitch(minPitch);
            }
            return this;
        } else {
            throw new Error('minPitch must be between ' + defaultMinPitch + ' and the current maxPitch, inclusive');
        }
    };
    Map.prototype.getMinPitch = function getMinPitch() {
        return this.transform.minPitch;
    };
    Map.prototype.setMaxPitch = function setMaxPitch(maxPitch) {
        maxPitch = maxPitch === null || maxPitch === undefined ? defaultMaxPitch : maxPitch;
        if (maxPitch > defaultMaxPitch) {
            throw new Error('maxPitch must be less than or equal to ' + defaultMaxPitch);
        }
        if (maxPitch >= this.transform.minPitch) {
            this.transform.maxPitch = maxPitch;
            this._update();
            if (this.getPitch() > maxPitch) {
                this.setPitch(maxPitch);
            }
            return this;
        } else {
            throw new Error('maxPitch must be greater than the current minPitch');
        }
    };
    Map.prototype.getMaxPitch = function getMaxPitch() {
        return this.transform.maxPitch;
    };
    Map.prototype.getRenderWorldCopies = function getRenderWorldCopies() {
        return this.transform.renderWorldCopies;
    };
    Map.prototype.setRenderWorldCopies = function setRenderWorldCopies(renderWorldCopies) {
        this.transform.renderWorldCopies = renderWorldCopies;
        return this._update();
    };
    Map.prototype.project = function project(lnglat) {
        return this.transform.locationPoint(performance.LngLat.convert(lnglat));
    };
    Map.prototype.unproject = function unproject(point) {
        return this.transform.pointLocation(performance.Point.convert(point));
    };
    Map.prototype.isMoving = function isMoving() {
        return this._moving || this.handlers.isMoving();
    };
    Map.prototype.isZooming = function isZooming() {
        return this._zooming || this.handlers.isZooming();
    };
    Map.prototype.isRotating = function isRotating() {
        return this._rotating || this.handlers.isRotating();
    };
    Map.prototype._createDelegatedListener = function _createDelegatedListener(type, layerId, listener) {
        var this$1 = this;
        var obj;
        if (type === 'mouseenter' || type === 'mouseover') {
            var mousein = false;
            var mousemove = function (e) {
                var features = this$1.getLayer(layerId) ? this$1.queryRenderedFeatures(e.point, { layers: [layerId] }) : [];
                if (!features.length) {
                    mousein = false;
                } else if (!mousein) {
                    mousein = true;
                    listener.call(this$1, new MapMouseEvent(type, this$1, e.originalEvent, { features: features }));
                }
            };
            var mouseout = function () {
                mousein = false;
            };
            return {
                layer: layerId,
                listener: listener,
                delegates: {
                    mousemove: mousemove,
                    mouseout: mouseout
                }
            };
        } else if (type === 'mouseleave' || type === 'mouseout') {
            var mousein$1 = false;
            var mousemove$1 = function (e) {
                var features = this$1.getLayer(layerId) ? this$1.queryRenderedFeatures(e.point, { layers: [layerId] }) : [];
                if (features.length) {
                    mousein$1 = true;
                } else if (mousein$1) {
                    mousein$1 = false;
                    listener.call(this$1, new MapMouseEvent(type, this$1, e.originalEvent));
                }
            };
            var mouseout$1 = function (e) {
                if (mousein$1) {
                    mousein$1 = false;
                    listener.call(this$1, new MapMouseEvent(type, this$1, e.originalEvent));
                }
            };
            return {
                layer: layerId,
                listener: listener,
                delegates: {
                    mousemove: mousemove$1,
                    mouseout: mouseout$1
                }
            };
        } else {
            var delegate = function (e) {
                var features = this$1.getLayer(layerId) ? this$1.queryRenderedFeatures(e.point, { layers: [layerId] }) : [];
                if (features.length) {
                    e.features = features;
                    listener.call(this$1, e);
                    delete e.features;
                }
            };
            return {
                layer: layerId,
                listener: listener,
                delegates: (obj = {}, obj[type] = delegate, obj)
            };
        }
    };
    Map.prototype.on = function on(type, layerId, listener) {
        if (listener === undefined) {
            return Camera.prototype.on.call(this, type, layerId);
        }
        var delegatedListener = this._createDelegatedListener(type, layerId, listener);
        this._delegatedListeners = this._delegatedListeners || {};
        this._delegatedListeners[type] = this._delegatedListeners[type] || [];
        this._delegatedListeners[type].push(delegatedListener);
        for (var event in delegatedListener.delegates) {
            this.on(event, delegatedListener.delegates[event]);
        }
        return this;
    };
    Map.prototype.once = function once(type, layerId, listener) {
        if (listener === undefined) {
            return Camera.prototype.once.call(this, type, layerId);
        }
        var delegatedListener = this._createDelegatedListener(type, layerId, listener);
        for (var event in delegatedListener.delegates) {
            this.once(event, delegatedListener.delegates[event]);
        }
        return this;
    };
    Map.prototype.off = function off(type, layerId, listener) {
        var this$1 = this;
        if (listener === undefined) {
            return Camera.prototype.off.call(this, type, layerId);
        }
        var removeDelegatedListener = function (delegatedListeners) {
            var listeners = delegatedListeners[type];
            for (var i = 0; i < listeners.length; i++) {
                var delegatedListener = listeners[i];
                if (delegatedListener.layer === layerId && delegatedListener.listener === listener) {
                    for (var event in delegatedListener.delegates) {
                        this$1.off(event, delegatedListener.delegates[event]);
                    }
                    listeners.splice(i, 1);
                    return this$1;
                }
            }
        };
        if (this._delegatedListeners && this._delegatedListeners[type]) {
            removeDelegatedListener(this._delegatedListeners);
        }
        return this;
    };
    Map.prototype.queryRenderedFeatures = function queryRenderedFeatures(geometry, options) {
        if (!this.style) {
            return [];
        }
        if (options === undefined && geometry !== undefined && !(geometry instanceof performance.Point) && !Array.isArray(geometry)) {
            options = geometry;
            geometry = undefined;
        }
        options = options || {};
        geometry = geometry || [
            [
                0,
                0
            ],
            [
                this.transform.width,
                this.transform.height
            ]
        ];
        var queryGeometry;
        if (geometry instanceof performance.Point || typeof geometry[0] === 'number') {
            queryGeometry = [performance.Point.convert(geometry)];
        } else {
            var tl = performance.Point.convert(geometry[0]);
            var br = performance.Point.convert(geometry[1]);
            queryGeometry = [
                tl,
                new performance.Point(br.x, tl.y),
                br,
                new performance.Point(tl.x, br.y),
                tl
            ];
        }
        return this.style.queryRenderedFeatures(queryGeometry, options, this.transform);
    };
    Map.prototype.querySourceFeatures = function querySourceFeatures(sourceId, parameters) {
        return this.style.querySourceFeatures(sourceId, parameters);
    };
    Map.prototype.setStyle = function setStyle(style, options) {
        options = performance.extend({}, { localIdeographFontFamily: this._localIdeographFontFamily }, options);
        if (options.diff !== false && options.localIdeographFontFamily === this._localIdeographFontFamily && this.style && style) {
            this._diffStyle(style, options);
            return this;
        } else {
            this._localIdeographFontFamily = options.localIdeographFontFamily;
            return this._updateStyle(style, options);
        }
    };
    Map.prototype._getUIString = function _getUIString(key) {
        var str = this._locale[key];
        if (str == null) {
            throw new Error('Missing UI string \'' + key + '\'');
        }
        return str;
    };
    Map.prototype._updateStyle = function _updateStyle(style, options) {
        if (this.style) {
            this.style.setEventedParent(null);
            this.style._remove();
        }
        if (!style) {
            delete this.style;
            return this;
        } else {
            this.style = new Style(this, options || {});
        }
        this.style.setEventedParent(this, { style: this.style });
        if (typeof style === 'string') {
            this.style.loadURL(style);
        } else {
            this.style.loadJSON(style);
        }
        return this;
    };
    Map.prototype._lazyInitEmptyStyle = function _lazyInitEmptyStyle() {
        if (!this.style) {
            this.style = new Style(this, {});
            this.style.setEventedParent(this, { style: this.style });
            this.style.loadEmpty();
        }
    };
    Map.prototype._diffStyle = function _diffStyle(style, options) {
        var this$1 = this;
        if (typeof style === 'string') {
            var url = this._requestManager.normalizeStyleURL(style);
            var request = this._requestManager.transformRequest(url, performance.ResourceType.Style);
            performance.getJSON(request, function (error, json) {
                if (error) {
                    this$1.fire(new performance.ErrorEvent(error));
                } else if (json) {
                    this$1._updateDiff(json, options);
                }
            });
        } else if (typeof style === 'object') {
            this._updateDiff(style, options);
        }
    };
    Map.prototype._updateDiff = function _updateDiff(style, options) {
        try {
            if (this.style.setState(style)) {
                this._update(true);
            }
        } catch (e) {
            performance.warnOnce('Unable to perform style diff: ' + (e.message || e.error || e) + '.  Rebuilding the style from scratch.');
            this._updateStyle(style, options);
        }
    };
    Map.prototype.getStyle = function getStyle() {
        if (this.style) {
            return this.style.serialize();
        }
    };
    Map.prototype.isStyleLoaded = function isStyleLoaded() {
        if (!this.style) {
            return performance.warnOnce('There is no style added to the map.');
        }
        return this.style.loaded();
    };
    Map.prototype.addSource = function addSource(id, source) {
        this._lazyInitEmptyStyle();
        this.style.addSource(id, source);
        return this._update(true);
    };
    Map.prototype.isSourceLoaded = function isSourceLoaded(id) {
        var source = this.style && this.style.sourceCaches[id];
        if (source === undefined) {
            this.fire(new performance.ErrorEvent(new Error('There is no source with ID \'' + id + '\'')));
            return;
        }
        return source.loaded();
    };
    Map.prototype.areTilesLoaded = function areTilesLoaded() {
        var sources = this.style && this.style.sourceCaches;
        for (var id in sources) {
            var source = sources[id];
            var tiles = source._tiles;
            for (var t in tiles) {
                var tile = tiles[t];
                if (!(tile.state === 'loaded' || tile.state === 'errored')) {
                    return false;
                }
            }
        }
        return true;
    };
    Map.prototype.addSourceType = function addSourceType(name, SourceType, callback) {
        this._lazyInitEmptyStyle();
        return this.style.addSourceType(name, SourceType, callback);
    };
    Map.prototype.removeSource = function removeSource(id) {
        this.style.removeSource(id);
        return this._update(true);
    };
    Map.prototype.getSource = function getSource(id) {
        return this.style.getSource(id);
    };
    Map.prototype.addImage = function addImage(id, image, ref) {
        if (ref === void 0)
            ref = {};
        var pixelRatio = ref.pixelRatio;
        if (pixelRatio === void 0)
            pixelRatio = 1;
        var sdf = ref.sdf;
        if (sdf === void 0)
            sdf = false;
        var stretchX = ref.stretchX;
        var stretchY = ref.stretchY;
        var content = ref.content;
        this._lazyInitEmptyStyle();
        var version = 0;
        if (image instanceof HTMLImageElement || ImageBitmap && image instanceof ImageBitmap) {
            var ref$1 = performance.browser.getImageData(image);
            var width = ref$1.width;
            var height = ref$1.height;
            var data = ref$1.data;
            this.style.addImage(id, {
                data: new performance.RGBAImage({
                    width: width,
                    height: height
                }, data),
                pixelRatio: pixelRatio,
                stretchX: stretchX,
                stretchY: stretchY,
                content: content,
                sdf: sdf,
                version: version
            });
        } else if (image.width === undefined || image.height === undefined) {
            return this.fire(new performance.ErrorEvent(new Error('Invalid arguments to map.addImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, ' + 'or object with `width`, `height`, and `data` properties with the same format as `ImageData`')));
        } else {
            var width$1 = image.width;
            var height$1 = image.height;
            var data$1 = image.data;
            var userImage = image;
            this.style.addImage(id, {
                data: new performance.RGBAImage({
                    width: width$1,
                    height: height$1
                }, new Uint8Array(data$1)),
                pixelRatio: pixelRatio,
                stretchX: stretchX,
                stretchY: stretchY,
                content: content,
                sdf: sdf,
                version: version,
                userImage: userImage
            });
            if (userImage.onAdd) {
                userImage.onAdd(this, id);
            }
        }
    };
    Map.prototype.updateImage = function updateImage(id, image) {
        var existingImage = this.style.getImage(id);
        if (!existingImage) {
            return this.fire(new performance.ErrorEvent(new Error('The map has no image with that id. If you are adding a new image use `map.addImage(...)` instead.')));
        }
        var imageData = image instanceof HTMLImageElement || ImageBitmap && image instanceof ImageBitmap ? performance.browser.getImageData(image) : image;
        var width = imageData.width;
        var height = imageData.height;
        var data = imageData.data;
        if (width === undefined || height === undefined) {
            return this.fire(new performance.ErrorEvent(new Error('Invalid arguments to map.updateImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, ' + 'or object with `width`, `height`, and `data` properties with the same format as `ImageData`')));
        }
        if (width !== existingImage.data.width || height !== existingImage.data.height) {
            return this.fire(new performance.ErrorEvent(new Error('The width and height of the updated image must be that same as the previous version of the image')));
        }
        var copy = !(image instanceof HTMLImageElement || ImageBitmap && image instanceof ImageBitmap);
        existingImage.data.replace(data, copy);
        this.style.updateImage(id, existingImage);
    };
    Map.prototype.hasImage = function hasImage(id) {
        if (!id) {
            this.fire(new performance.ErrorEvent(new Error('Missing required image id')));
            return false;
        }
        return !!this.style.getImage(id);
    };
    Map.prototype.removeImage = function removeImage(id) {
        this.style.removeImage(id);
    };
    Map.prototype.loadImage = function loadImage(url, callback) {
        performance.getImage(this._requestManager.transformRequest(url, performance.ResourceType.Image), callback);
    };
    Map.prototype.listImages = function listImages() {
        return this.style.listImages();
    };
    Map.prototype.addLayer = function addLayer(layer, beforeId) {
        this._lazyInitEmptyStyle();
        this.style.addLayer(layer, beforeId);
        return this._update(true);
    };
    Map.prototype.moveLayer = function moveLayer(id, beforeId) {
        this.style.moveLayer(id, beforeId);
        return this._update(true);
    };
    Map.prototype.removeLayer = function removeLayer(id) {
        this.style.removeLayer(id);
        return this._update(true);
    };
    Map.prototype.getLayer = function getLayer(id) {
        return this.style.getLayer(id);
    };
    Map.prototype.setLayerZoomRange = function setLayerZoomRange(layerId, minzoom, maxzoom) {
        this.style.setLayerZoomRange(layerId, minzoom, maxzoom);
        return this._update(true);
    };
    Map.prototype.setFilter = function setFilter(layerId, filter, options) {
        if (options === void 0)
            options = {};
        this.style.setFilter(layerId, filter, options);
        return this._update(true);
    };
    Map.prototype.getFilter = function getFilter(layerId) {
        return this.style.getFilter(layerId);
    };
    Map.prototype.setPaintProperty = function setPaintProperty(layerId, name, value, options) {
        if (options === void 0)
            options = {};
        this.style.setPaintProperty(layerId, name, value, options);
        return this._update(true);
    };
    Map.prototype.getPaintProperty = function getPaintProperty(layerId, name) {
        return this.style.getPaintProperty(layerId, name);
    };
    Map.prototype.setLayoutProperty = function setLayoutProperty(layerId, name, value, options) {
        if (options === void 0)
            options = {};
        this.style.setLayoutProperty(layerId, name, value, options);
        return this._update(true);
    };
    Map.prototype.getLayoutProperty = function getLayoutProperty(layerId, name) {
        return this.style.getLayoutProperty(layerId, name);
    };
    Map.prototype.setLight = function setLight(light, options) {
        if (options === void 0)
            options = {};
        this._lazyInitEmptyStyle();
        this.style.setLight(light, options);
        return this._update(true);
    };
    Map.prototype.getLight = function getLight() {
        return this.style.getLight();
    };
    Map.prototype.setFeatureState = function setFeatureState(feature, state) {
        this.style.setFeatureState(feature, state);
        return this._update();
    };
    Map.prototype.removeFeatureState = function removeFeatureState(target, key) {
        this.style.removeFeatureState(target, key);
        return this._update();
    };
    Map.prototype.getFeatureState = function getFeatureState(feature) {
        return this.style.getFeatureState(feature);
    };
    Map.prototype.getContainer = function getContainer() {
        return this._container;
    };
    Map.prototype.getCanvasContainer = function getCanvasContainer() {
        return this._canvasContainer;
    };
    Map.prototype.getCanvas = function getCanvas() {
        return this._canvas;
    };
    Map.prototype._containerDimensions = function _containerDimensions() {
        var width = 0;
        var height = 0;
        if (this._container) {
            width = this._container.clientWidth || 400;
            height = this._container.clientHeight || 300;
        }
        return [
            width,
            height
        ];
    };
    Map.prototype._detectMissingCSS = function _detectMissingCSS() {
        var computedColor = performance.window.getComputedStyle(this._missingCSSCanary).getPropertyValue('background-color');
        if (computedColor !== 'rgb(250, 128, 114)') {
            performance.warnOnce('This page appears to be missing CSS declarations for ' + 'Mapbox GL JS, which may cause the map to display incorrectly. ' + 'Please ensure your page includes mapbox-gl.css, as described ' + 'in https://www.mapbox.com/mapbox-gl-js/api/.');
        }
    };
    Map.prototype._setupContainer = function _setupContainer() {
        var container = this._container;
        container.classList.add('mapboxgl-map');
        var missingCSSCanary = this._missingCSSCanary = DOM.create('div', 'mapboxgl-canary', container);
        missingCSSCanary.style.visibility = 'hidden';
        this._detectMissingCSS();
        var canvasContainer = this._canvasContainer = DOM.create('div', 'mapboxgl-canvas-container', container);
        if (this._interactive) {
            canvasContainer.classList.add('mapboxgl-interactive');
        }
        this._canvas = DOM.create('canvas', 'mapboxgl-canvas', canvasContainer);
        this._canvas.addEventListener('webglcontextlost', this._contextLost, false);
        this._canvas.addEventListener('webglcontextrestored', this._contextRestored, false);
        this._canvas.setAttribute('tabindex', '0');
        this._canvas.setAttribute('aria-label', 'Map');
        this._canvas.setAttribute('role', 'region');
        var dimensions = this._containerDimensions();
        this._resizeCanvas(dimensions[0], dimensions[1]);
        var controlContainer = this._controlContainer = DOM.create('div', 'mapboxgl-control-container', container);
        var positions = this._controlPositions = {};
        [
            'top-left',
            'top-right',
            'bottom-left',
            'bottom-right'
        ].forEach(function (positionName) {
            positions[positionName] = DOM.create('div', 'mapboxgl-ctrl-' + positionName, controlContainer);
        });
        this._container.addEventListener('scroll', this._onMapScroll, false);
    };
    Map.prototype._resizeCanvas = function _resizeCanvas(width, height) {
        var pixelRatio = performance.browser.devicePixelRatio || 1;
        this._canvas.width = pixelRatio * width;
        this._canvas.height = pixelRatio * height;
        this._canvas.style.width = width + 'px';
        this._canvas.style.height = height + 'px';
    };
    Map.prototype._setupPainter = function _setupPainter() {
        var attributes = performance.extend({}, mapboxGlSupported.webGLContextAttributes, {
            failIfMajorPerformanceCaveat: this._failIfMajorPerformanceCaveat,
            preserveDrawingBuffer: this._preserveDrawingBuffer,
            antialias: this._antialias || false
        });
        var gl = this._canvas.getContext('webgl', attributes) || this._canvas.getContext('experimental-webgl', attributes);
        if (!gl) {
            this.fire(new performance.ErrorEvent(new Error('Failed to initialize WebGL')));
            return;
        }
        this.painter = new Painter(gl, this.transform);
        performance.webpSupported.testSupport(gl);
    };
    Map.prototype._contextLost = function _contextLost(event) {
        event.preventDefault();
        if (this._frame) {
            this._frame.cancel();
            this._frame = null;
        }
        this.fire(new performance.Event('webglcontextlost', { originalEvent: event }));
    };
    Map.prototype._contextRestored = function _contextRestored(event) {
        this._setupPainter();
        this.resize();
        this._update();
        this.fire(new performance.Event('webglcontextrestored', { originalEvent: event }));
    };
    Map.prototype._onMapScroll = function _onMapScroll(event) {
        if (event.target !== this._container) {
            return;
        }
        this._container.scrollTop = 0;
        this._container.scrollLeft = 0;
        return false;
    };
    Map.prototype.loaded = function loaded() {
        return !this._styleDirty && !this._sourcesDirty && !!this.style && this.style.loaded();
    };
    Map.prototype._update = function _update(updateStyle) {
        if (!this.style) {
            return this;
        }
        this._styleDirty = this._styleDirty || updateStyle;
        this._sourcesDirty = true;
        this.triggerRepaint();
        return this;
    };
    Map.prototype._requestRenderFrame = function _requestRenderFrame(callback) {
        this._update();
        return this._renderTaskQueue.add(callback);
    };
    Map.prototype._cancelRenderFrame = function _cancelRenderFrame(id) {
        this._renderTaskQueue.remove(id);
    };
    Map.prototype._render = function _render(paintStartTimeStamp) {
        var this$1 = this;
        var gpuTimer, frameStartTime = 0;
        var extTimerQuery = this.painter.context.extTimerQuery;
        if (this.listens('gpu-timing-frame')) {
            gpuTimer = extTimerQuery.createQueryEXT();
            extTimerQuery.beginQueryEXT(extTimerQuery.TIME_ELAPSED_EXT, gpuTimer);
            frameStartTime = performance.browser.now();
        }
        this.painter.context.setDirty();
        this.painter.setBaseState();
        this._renderTaskQueue.run(paintStartTimeStamp);
        if (this._removed) {
            return;
        }
        var crossFading = false;
        if (this.style && this._styleDirty) {
            this._styleDirty = false;
            var zoom = this.transform.zoom;
            var now = performance.browser.now();
            this.style.zoomHistory.update(zoom, now);
            var parameters = new performance.EvaluationParameters(zoom, {
                now: now,
                fadeDuration: this._fadeDuration,
                zoomHistory: this.style.zoomHistory,
                transition: this.style.getTransition()
            });
            var factor = parameters.crossFadingFactor();
            if (factor !== 1 || factor !== this._crossFadingFactor) {
                crossFading = true;
                this._crossFadingFactor = factor;
            }
            this.style.update(parameters);
        }
        if (this.style && this._sourcesDirty) {
            this._sourcesDirty = false;
            this.style._updateSources(this.transform);
        }
        this._placementDirty = this.style && this.style._updatePlacement(this.painter.transform, this.showCollisionBoxes, this._fadeDuration, this._crossSourceCollisions);
        this.painter.render(this.style, {
            showTileBoundaries: this.showTileBoundaries,
            showOverdrawInspector: this._showOverdrawInspector,
            rotating: this.isRotating(),
            zooming: this.isZooming(),
            moving: this.isMoving(),
            fadeDuration: this._fadeDuration,
            showPadding: this.showPadding,
            gpuTiming: !!this.listens('gpu-timing-layer')
        });
        this.fire(new performance.Event('render'));
        if (this.loaded() && !this._loaded) {
            this._loaded = true;
            this.fire(new performance.Event('load'));
        }
        if (this.style && (this.style.hasTransitions() || crossFading)) {
            this._styleDirty = true;
        }
        if (this.style && !this._placementDirty) {
            this.style._releaseSymbolFadeTiles();
        }
        if (this.listens('gpu-timing-frame')) {
            var renderCPUTime = performance.browser.now() - frameStartTime;
            extTimerQuery.endQueryEXT(extTimerQuery.TIME_ELAPSED_EXT, gpuTimer);
            setTimeout(function () {
                var renderGPUTime = extTimerQuery.getQueryObjectEXT(gpuTimer, extTimerQuery.QUERY_RESULT_EXT) / (1000 * 1000);
                extTimerQuery.deleteQueryEXT(gpuTimer);
                this$1.fire(new performance.Event('gpu-timing-frame', {
                    cpuTime: renderCPUTime,
                    gpuTime: renderGPUTime
                }));
            }, 50);
        }
        if (this.listens('gpu-timing-layer')) {
            var frameLayerQueries = this.painter.collectGpuTimers();
            setTimeout(function () {
                var renderedLayerTimes = this$1.painter.queryGpuTimers(frameLayerQueries);
                this$1.fire(new performance.Event('gpu-timing-layer', { layerTimes: renderedLayerTimes }));
            }, 50);
        }
        var somethingDirty = this._sourcesDirty || this._styleDirty || this._placementDirty;
        if (somethingDirty || this._repaint) {
            this.triggerRepaint();
        } else if (!this.isMoving() && this.loaded()) {
            this.fire(new performance.Event('idle'));
        }
        if (this._loaded && !this._fullyLoaded && !somethingDirty) {
            this._fullyLoaded = true;
        }
        return this;
    };
    Map.prototype.remove = function remove() {
        if (this._hash) {
            this._hash.remove();
        }
        for (var i = 0, list = this._controls; i < list.length; i += 1) {
            var control = list[i];
            control.onRemove(this);
        }
        this._controls = [];
        if (this._frame) {
            this._frame.cancel();
            this._frame = null;
        }
        this._renderTaskQueue.clear();
        this.painter.destroy();
        this.handlers.destroy();
        delete this.handlers;
        this.setStyle(null);
        if (typeof performance.window !== 'undefined') {
            performance.window.removeEventListener('resize', this._onWindowResize, false);
            performance.window.removeEventListener('orientationchange', this._onWindowResize, false);
            performance.window.removeEventListener('online', this._onWindowOnline, false);
        }
        var extension = this.painter.context.gl.getExtension('WEBGL_lose_context');
        if (extension && extension.loseContext) {
            extension.loseContext();
        }
        removeNode(this._canvasContainer);
        removeNode(this._controlContainer);
        removeNode(this._missingCSSCanary);
        this._container.classList.remove('mapboxgl-map');
        this._removed = true;
        this.fire(new performance.Event('remove'));
    };
    Map.prototype.triggerRepaint = function triggerRepaint() {
        var this$1 = this;
        if (this.style && !this._frame) {
            this._frame = performance.browser.frame(function (paintStartTimeStamp) {
                this$1._frame = null;
                this$1._render(paintStartTimeStamp);
            });
        }
    };
    Map.prototype._onWindowOnline = function _onWindowOnline() {
        this._update();
    };
    Map.prototype._onWindowResize = function _onWindowResize(event) {
        if (this._trackResize) {
            this.resize({ originalEvent: event })._update();
        }
    };
    prototypeAccessors.showTileBoundaries.get = function () {
        return !!this._showTileBoundaries;
    };
    prototypeAccessors.showTileBoundaries.set = function (value) {
        if (this._showTileBoundaries === value) {
            return;
        }
        this._showTileBoundaries = value;
        this._update();
    };
    prototypeAccessors.showPadding.get = function () {
        return !!this._showPadding;
    };
    prototypeAccessors.showPadding.set = function (value) {
        if (this._showPadding === value) {
            return;
        }
        this._showPadding = value;
        this._update();
    };
    prototypeAccessors.showCollisionBoxes.get = function () {
        return !!this._showCollisionBoxes;
    };
    prototypeAccessors.showCollisionBoxes.set = function (value) {
        if (this._showCollisionBoxes === value) {
            return;
        }
        this._showCollisionBoxes = value;
        if (value) {
            this.style._generateCollisionBoxes();
        } else {
            this._update();
        }
    };
    prototypeAccessors.showOverdrawInspector.get = function () {
        return !!this._showOverdrawInspector;
    };
    prototypeAccessors.showOverdrawInspector.set = function (value) {
        if (this._showOverdrawInspector === value) {
            return;
        }
        this._showOverdrawInspector = value;
        this._update();
    };
    prototypeAccessors.repaint.get = function () {
        return !!this._repaint;
    };
    prototypeAccessors.repaint.set = function (value) {
        if (this._repaint !== value) {
            this._repaint = value;
            this.triggerRepaint();
        }
    };
    prototypeAccessors.vertices.get = function () {
        return !!this._vertices;
    };
    prototypeAccessors.vertices.set = function (value) {
        this._vertices = value;
        this._update();
    };
    Map.prototype._setCacheLimits = function _setCacheLimits(limit, checkThreshold) {
        performance.setCacheLimits(limit, checkThreshold);
    };
    prototypeAccessors.version.get = function () {
        return performance.version;
    };
    Object.defineProperties(Map.prototype, prototypeAccessors);
    return Map;
}(Camera);
function removeNode(node) {
    if (node.parentNode) {
        node.parentNode.removeChild(node);
    }
}

var defaultOptions$2 = {
    showCompass: true,
    showZoom: true,
    visualizePitch: false
};
var NavigationControl = function NavigationControl(options) {
    var this$1 = this;
    this.options = performance.extend({}, defaultOptions$2, options);
    this._container = DOM.create('div', 'mapboxgl-ctrl mapboxgl-ctrl-group');
    this._container.addEventListener('contextmenu', function (e) {
        return e.preventDefault();
    });
    if (this.options.showZoom) {
        performance.bindAll([
            '_setButtonTitle',
            '_updateZoomButtons'
        ], this);
        this._zoomInButton = this._createButton('mapboxgl-ctrl-zoom-in', function (e) {
            return this$1._map.zoomIn({}, { originalEvent: e });
        });
        DOM.create('span', 'mapboxgl-ctrl-icon', this._zoomInButton).setAttribute('aria-hidden', true);
        this._zoomOutButton = this._createButton('mapboxgl-ctrl-zoom-out', function (e) {
            return this$1._map.zoomOut({}, { originalEvent: e });
        });
        DOM.create('span', 'mapboxgl-ctrl-icon', this._zoomOutButton).setAttribute('aria-hidden', true);
    }
    if (this.options.showCompass) {
        performance.bindAll(['_rotateCompassArrow'], this);
        this._compass = this._createButton('mapboxgl-ctrl-compass', function (e) {
            if (this$1.options.visualizePitch) {
                this$1._map.resetNorthPitch({}, { originalEvent: e });
            } else {
                this$1._map.resetNorth({}, { originalEvent: e });
            }
        });
        this._compassIcon = DOM.create('span', 'mapboxgl-ctrl-icon', this._compass);
        this._compassIcon.setAttribute('aria-hidden', true);
    }
};
NavigationControl.prototype._updateZoomButtons = function _updateZoomButtons() {
    var zoom = this._map.getZoom();
    var isMax = zoom === this._map.getMaxZoom();
    var isMin = zoom === this._map.getMinZoom();
    this._zoomInButton.disabled = isMax;
    this._zoomOutButton.disabled = isMin;
    this._zoomInButton.setAttribute('aria-disabled', isMax.toString());
    this._zoomOutButton.setAttribute('aria-disabled', isMin.toString());
};
NavigationControl.prototype._rotateCompassArrow = function _rotateCompassArrow() {
    var rotate = this.options.visualizePitch ? 'scale(' + 1 / Math.pow(Math.cos(this._map.transform.pitch * (Math.PI / 180)), 0.5) + ') rotateX(' + this._map.transform.pitch + 'deg) rotateZ(' + this._map.transform.angle * (180 / Math.PI) + 'deg)' : 'rotate(' + this._map.transform.angle * (180 / Math.PI) + 'deg)';
    this._compassIcon.style.transform = rotate;
};
NavigationControl.prototype.onAdd = function onAdd(map) {
    this._map = map;
    if (this.options.showZoom) {
        this._setButtonTitle(this._zoomInButton, 'ZoomIn');
        this._setButtonTitle(this._zoomOutButton, 'ZoomOut');
        this._map.on('zoom', this._updateZoomButtons);
        this._updateZoomButtons();
    }
    if (this.options.showCompass) {
        this._setButtonTitle(this._compass, 'ResetBearing');
        if (this.options.visualizePitch) {
            this._map.on('pitch', this._rotateCompassArrow);
        }
        this._map.on('rotate', this._rotateCompassArrow);
        this._rotateCompassArrow();
        this._handler = new MouseRotateWrapper(this._map, this._compass, this.options.visualizePitch);
    }
    return this._container;
};
NavigationControl.prototype.onRemove = function onRemove() {
    DOM.remove(this._container);
    if (this.options.showZoom) {
        this._map.off('zoom', this._updateZoomButtons);
    }
    if (this.options.showCompass) {
        if (this.options.visualizePitch) {
            this._map.off('pitch', this._rotateCompassArrow);
        }
        this._map.off('rotate', this._rotateCompassArrow);
        this._handler.off();
        delete this._handler;
    }
    delete this._map;
};
NavigationControl.prototype._createButton = function _createButton(className, fn) {
    var a = DOM.create('button', className, this._container);
    a.type = 'button';
    a.addEventListener('click', fn);
    return a;
};
NavigationControl.prototype._setButtonTitle = function _setButtonTitle(button, title) {
    var str = this._map._getUIString('NavigationControl.' + title);
    button.title = str;
    button.setAttribute('aria-label', str);
};
var MouseRotateWrapper = function MouseRotateWrapper(map, element, pitch) {
    if (pitch === void 0)
        pitch = false;
    this._clickTolerance = 10;
    this.element = element;
    this.mouseRotate = new MouseRotateHandler({ clickTolerance: map.dragRotate._mouseRotate._clickTolerance });
    this.map = map;
    if (pitch) {
        this.mousePitch = new MousePitchHandler({ clickTolerance: map.dragRotate._mousePitch._clickTolerance });
    }
    performance.bindAll([
        'mousedown',
        'mousemove',
        'mouseup',
        'touchstart',
        'touchmove',
        'touchend',
        'reset'
    ], this);
    DOM.addEventListener(element, 'mousedown', this.mousedown);
    DOM.addEventListener(element, 'touchstart', this.touchstart, { passive: false });
    DOM.addEventListener(element, 'touchmove', this.touchmove);
    DOM.addEventListener(element, 'touchend', this.touchend);
    DOM.addEventListener(element, 'touchcancel', this.reset);
};
MouseRotateWrapper.prototype.down = function down(e, point) {
    this.mouseRotate.mousedown(e, point);
    if (this.mousePitch) {
        this.mousePitch.mousedown(e, point);
    }
    DOM.disableDrag();
};
MouseRotateWrapper.prototype.move = function move(e, point) {
    var map = this.map;
    var r = this.mouseRotate.mousemoveWindow(e, point);
    if (r && r.bearingDelta) {
        map.setBearing(map.getBearing() + r.bearingDelta);
    }
    if (this.mousePitch) {
        var p = this.mousePitch.mousemoveWindow(e, point);
        if (p && p.pitchDelta) {
            map.setPitch(map.getPitch() + p.pitchDelta);
        }
    }
};
MouseRotateWrapper.prototype.off = function off() {
    var element = this.element;
    DOM.removeEventListener(element, 'mousedown', this.mousedown);
    DOM.removeEventListener(element, 'touchstart', this.touchstart, { passive: false });
    DOM.removeEventListener(element, 'touchmove', this.touchmove);
    DOM.removeEventListener(element, 'touchend', this.touchend);
    DOM.removeEventListener(element, 'touchcancel', this.reset);
    this.offTemp();
};
MouseRotateWrapper.prototype.offTemp = function offTemp() {
    DOM.enableDrag();
    DOM.removeEventListener(performance.window, 'mousemove', this.mousemove);
    DOM.removeEventListener(performance.window, 'mouseup', this.mouseup);
};
MouseRotateWrapper.prototype.mousedown = function mousedown(e) {
    this.down(performance.extend({}, e, {
        ctrlKey: true,
        preventDefault: function () {
            return e.preventDefault();
        }
    }), DOM.mousePos(this.element, e));
    DOM.addEventListener(performance.window, 'mousemove', this.mousemove);
    DOM.addEventListener(performance.window, 'mouseup', this.mouseup);
};
MouseRotateWrapper.prototype.mousemove = function mousemove(e) {
    this.move(e, DOM.mousePos(this.element, e));
};
MouseRotateWrapper.prototype.mouseup = function mouseup(e) {
    this.mouseRotate.mouseupWindow(e);
    if (this.mousePitch) {
        this.mousePitch.mouseupWindow(e);
    }
    this.offTemp();
};
MouseRotateWrapper.prototype.touchstart = function touchstart(e) {
    if (e.targetTouches.length !== 1) {
        this.reset();
    } else {
        this._startPos = this._lastPos = DOM.touchPos(this.element, e.targetTouches)[0];
        this.down({
            type: 'mousedown',
            button: 0,
            ctrlKey: true,
            preventDefault: function () {
                return e.preventDefault();
            }
        }, this._startPos);
    }
};
MouseRotateWrapper.prototype.touchmove = function touchmove(e) {
    if (e.targetTouches.length !== 1) {
        this.reset();
    } else {
        this._lastPos = DOM.touchPos(this.element, e.targetTouches)[0];
        this.move({
            preventDefault: function () {
                return e.preventDefault();
            }
        }, this._lastPos);
    }
};
MouseRotateWrapper.prototype.touchend = function touchend(e) {
    if (e.targetTouches.length === 0 && this._startPos && this._lastPos && this._startPos.dist(this._lastPos) < this._clickTolerance) {
        this.element.click();
    }
    this.reset();
};
MouseRotateWrapper.prototype.reset = function reset() {
    this.mouseRotate.reset();
    if (this.mousePitch) {
        this.mousePitch.reset();
    }
    delete this._startPos;
    delete this._lastPos;
    this.offTemp();
};

function smartWrap (lngLat, priorPos, transform) {
    lngLat = new performance.LngLat(lngLat.lng, lngLat.lat);
    if (priorPos) {
        var left = new performance.LngLat(lngLat.lng - 360, lngLat.lat);
        var right = new performance.LngLat(lngLat.lng + 360, lngLat.lat);
        var delta = transform.locationPoint(lngLat).distSqr(priorPos);
        if (transform.locationPoint(left).distSqr(priorPos) < delta) {
            lngLat = left;
        } else if (transform.locationPoint(right).distSqr(priorPos) < delta) {
            lngLat = right;
        }
    }
    while (Math.abs(lngLat.lng - transform.center.lng) > 180) {
        var pos = transform.locationPoint(lngLat);
        if (pos.x >= 0 && pos.y >= 0 && pos.x <= transform.width && pos.y <= transform.height) {
            break;
        }
        if (lngLat.lng > transform.center.lng) {
            lngLat.lng -= 360;
        } else {
            lngLat.lng += 360;
        }
    }
    return lngLat;
}

var anchorTranslate = {
    'center': 'translate(-50%,-50%)',
    'top': 'translate(-50%,0)',
    'top-left': 'translate(0,0)',
    'top-right': 'translate(-100%,0)',
    'bottom': 'translate(-50%,-100%)',
    'bottom-left': 'translate(0,-100%)',
    'bottom-right': 'translate(-100%,-100%)',
    'left': 'translate(0,-50%)',
    'right': 'translate(-100%,-50%)'
};
function applyAnchorClass(element, anchor, prefix) {
    var classList = element.classList;
    for (var key in anchorTranslate) {
        classList.remove('mapboxgl-' + prefix + '-anchor-' + key);
    }
    classList.add('mapboxgl-' + prefix + '-anchor-' + anchor);
}

var Marker = function (Evented) {
    function Marker(options, legacyOptions) {
        Evented.call(this);
        if (options instanceof performance.window.HTMLElement || legacyOptions) {
            options = performance.extend({ element: options }, legacyOptions);
        }
        performance.bindAll([
            '_update',
            '_onMove',
            '_onUp',
            '_addDragHandler',
            '_onMapClick',
            '_onKeyPress'
        ], this);
        this._anchor = options && options.anchor || 'center';
        this._color = options && options.color || '#3FB1CE';
        this._scale = options && options.scale || 1;
        this._draggable = options && options.draggable || false;
        this._clickTolerance = options && options.clickTolerance || 0;
        this._isDragging = false;
        this._state = 'inactive';
        this._rotation = options && options.rotation || 0;
        this._rotationAlignment = options && options.rotationAlignment || 'auto';
        this._pitchAlignment = options && options.pitchAlignment && options.pitchAlignment !== 'auto' ? options.pitchAlignment : this._rotationAlignment;
        if (!options || !options.element) {
            this._defaultMarker = true;
            this._element = DOM.create('div');
            this._element.setAttribute('aria-label', 'Map marker');
            var svg = DOM.createNS('http://www.w3.org/2000/svg', 'svg');
            var defaultHeight = 41;
            var defaultWidth = 27;
            svg.setAttributeNS(null, 'display', 'block');
            svg.setAttributeNS(null, 'height', defaultHeight + 'px');
            svg.setAttributeNS(null, 'width', defaultWidth + 'px');
            svg.setAttributeNS(null, 'viewBox', '0 0 ' + defaultWidth + ' ' + defaultHeight);
            var markerLarge = DOM.createNS('http://www.w3.org/2000/svg', 'g');
            markerLarge.setAttributeNS(null, 'stroke', 'none');
            markerLarge.setAttributeNS(null, 'stroke-width', '1');
            markerLarge.setAttributeNS(null, 'fill', 'none');
            markerLarge.setAttributeNS(null, 'fill-rule', 'evenodd');
            var page1 = DOM.createNS('http://www.w3.org/2000/svg', 'g');
            page1.setAttributeNS(null, 'fill-rule', 'nonzero');
            var shadow = DOM.createNS('http://www.w3.org/2000/svg', 'g');
            shadow.setAttributeNS(null, 'transform', 'translate(3.0, 29.0)');
            shadow.setAttributeNS(null, 'fill', '#000000');
            var ellipses = [
                {
                    'rx': '10.5',
                    'ry': '5.25002273'
                },
                {
                    'rx': '10.5',
                    'ry': '5.25002273'
                },
                {
                    'rx': '9.5',
                    'ry': '4.77275007'
                },
                {
                    'rx': '8.5',
                    'ry': '4.29549936'
                },
                {
                    'rx': '7.5',
                    'ry': '3.81822308'
                },
                {
                    'rx': '6.5',
                    'ry': '3.34094679'
                },
                {
                    'rx': '5.5',
                    'ry': '2.86367051'
                },
                {
                    'rx': '4.5',
                    'ry': '2.38636864'
                }
            ];
            for (var i = 0, list = ellipses; i < list.length; i += 1) {
                var data = list[i];
                var ellipse = DOM.createNS('http://www.w3.org/2000/svg', 'ellipse');
                ellipse.setAttributeNS(null, 'opacity', '0.04');
                ellipse.setAttributeNS(null, 'cx', '10.5');
                ellipse.setAttributeNS(null, 'cy', '5.80029008');
                ellipse.setAttributeNS(null, 'rx', data['rx']);
                ellipse.setAttributeNS(null, 'ry', data['ry']);
                shadow.appendChild(ellipse);
            }
            var background = DOM.createNS('http://www.w3.org/2000/svg', 'g');
            background.setAttributeNS(null, 'fill', this._color);
            var bgPath = DOM.createNS('http://www.w3.org/2000/svg', 'path');
            bgPath.setAttributeNS(null, 'd', 'M27,13.5 C27,19.074644 20.250001,27.000002 14.75,34.500002 C14.016665,35.500004 12.983335,35.500004 12.25,34.500002 C6.7499993,27.000002 0,19.222562 0,13.5 C0,6.0441559 6.0441559,0 13.5,0 C20.955844,0 27,6.0441559 27,13.5 Z');
            background.appendChild(bgPath);
            var border = DOM.createNS('http://www.w3.org/2000/svg', 'g');
            border.setAttributeNS(null, 'opacity', '0.25');
            border.setAttributeNS(null, 'fill', '#000000');
            var borderPath = DOM.createNS('http://www.w3.org/2000/svg', 'path');
            borderPath.setAttributeNS(null, 'd', 'M13.5,0 C6.0441559,0 0,6.0441559 0,13.5 C0,19.222562 6.7499993,27 12.25,34.5 C13,35.522727 14.016664,35.500004 14.75,34.5 C20.250001,27 27,19.074644 27,13.5 C27,6.0441559 20.955844,0 13.5,0 Z M13.5,1 C20.415404,1 26,6.584596 26,13.5 C26,15.898657 24.495584,19.181431 22.220703,22.738281 C19.945823,26.295132 16.705119,30.142167 13.943359,33.908203 C13.743445,34.180814 13.612715,34.322738 13.5,34.441406 C13.387285,34.322738 13.256555,34.180814 13.056641,33.908203 C10.284481,30.127985 7.4148684,26.314159 5.015625,22.773438 C2.6163816,19.232715 1,15.953538 1,13.5 C1,6.584596 6.584596,1 13.5,1 Z');
            border.appendChild(borderPath);
            var maki = DOM.createNS('http://www.w3.org/2000/svg', 'g');
            maki.setAttributeNS(null, 'transform', 'translate(6.0, 7.0)');
            maki.setAttributeNS(null, 'fill', '#FFFFFF');
            var circleContainer = DOM.createNS('http://www.w3.org/2000/svg', 'g');
            circleContainer.setAttributeNS(null, 'transform', 'translate(8.0, 8.0)');
            var circle1 = DOM.createNS('http://www.w3.org/2000/svg', 'circle');
            circle1.setAttributeNS(null, 'fill', '#000000');
            circle1.setAttributeNS(null, 'opacity', '0.25');
            circle1.setAttributeNS(null, 'cx', '5.5');
            circle1.setAttributeNS(null, 'cy', '5.5');
            circle1.setAttributeNS(null, 'r', '5.4999962');
            var circle2 = DOM.createNS('http://www.w3.org/2000/svg', 'circle');
            circle2.setAttributeNS(null, 'fill', '#FFFFFF');
            circle2.setAttributeNS(null, 'cx', '5.5');
            circle2.setAttributeNS(null, 'cy', '5.5');
            circle2.setAttributeNS(null, 'r', '5.4999962');
            circleContainer.appendChild(circle1);
            circleContainer.appendChild(circle2);
            page1.appendChild(shadow);
            page1.appendChild(background);
            page1.appendChild(border);
            page1.appendChild(maki);
            page1.appendChild(circleContainer);
            svg.appendChild(page1);
            svg.setAttributeNS(null, 'height', defaultHeight * this._scale + 'px');
            svg.setAttributeNS(null, 'width', defaultWidth * this._scale + 'px');
            this._element.appendChild(svg);
            this._offset = performance.Point.convert(options && options.offset || [
                0,
                -14
            ]);
        } else {
            this._element = options.element;
            this._offset = performance.Point.convert(options && options.offset || [
                0,
                0
            ]);
        }
        this._element.classList.add('mapboxgl-marker');
        this._element.addEventListener('dragstart', function (e) {
            e.preventDefault();
        });
        this._element.addEventListener('mousedown', function (e) {
            e.preventDefault();
        });
        applyAnchorClass(this._element, this._anchor, 'marker');
        this._popup = null;
    }
    if (Evented)
        Marker.__proto__ = Evented;
    Marker.prototype = Object.create(Evented && Evented.prototype);
    Marker.prototype.constructor = Marker;
    Marker.prototype.addTo = function addTo(map) {
        this.remove();
        this._map = map;
        map.getCanvasContainer().appendChild(this._element);
        map.on('move', this._update);
        map.on('moveend', this._update);
        this.setDraggable(this._draggable);
        this._update();
        this._map.on('click', this._onMapClick);
        return this;
    };
    Marker.prototype.remove = function remove() {
        if (this._map) {
            this._map.off('click', this._onMapClick);
            this._map.off('move', this._update);
            this._map.off('moveend', this._update);
            this._map.off('mousedown', this._addDragHandler);
            this._map.off('touchstart', this._addDragHandler);
            this._map.off('mouseup', this._onUp);
            this._map.off('touchend', this._onUp);
            this._map.off('mousemove', this._onMove);
            this._map.off('touchmove', this._onMove);
            delete this._map;
        }
        DOM.remove(this._element);
        if (this._popup) {
            this._popup.remove();
        }
        return this;
    };
    Marker.prototype.getLngLat = function getLngLat() {
        return this._lngLat;
    };
    Marker.prototype.setLngLat = function setLngLat(lnglat) {
        this._lngLat = performance.LngLat.convert(lnglat);
        this._pos = null;
        if (this._popup) {
            this._popup.setLngLat(this._lngLat);
        }
        this._update();
        return this;
    };
    Marker.prototype.getElement = function getElement() {
        return this._element;
    };
    Marker.prototype.setPopup = function setPopup(popup) {
        if (this._popup) {
            this._popup.remove();
            this._popup = null;
            this._element.removeEventListener('keypress', this._onKeyPress);
            if (!this._originalTabIndex) {
                this._element.removeAttribute('tabindex');
            }
        }
        if (popup) {
            if (!('offset' in popup.options)) {
                var markerHeight = 41 - 5.8 / 2;
                var markerRadius = 13.5;
                var linearOffset = Math.sqrt(Math.pow(markerRadius, 2) / 2);
                popup.options.offset = this._defaultMarker ? {
                    'top': [
                        0,
                        0
                    ],
                    'top-left': [
                        0,
                        0
                    ],
                    'top-right': [
                        0,
                        0
                    ],
                    'bottom': [
                        0,
                        -markerHeight
                    ],
                    'bottom-left': [
                        linearOffset,
                        (markerHeight - markerRadius + linearOffset) * -1
                    ],
                    'bottom-right': [
                        -linearOffset,
                        (markerHeight - markerRadius + linearOffset) * -1
                    ],
                    'left': [
                        markerRadius,
                        (markerHeight - markerRadius) * -1
                    ],
                    'right': [
                        -markerRadius,
                        (markerHeight - markerRadius) * -1
                    ]
                } : this._offset;
            }
            this._popup = popup;
            if (this._lngLat) {
                this._popup.setLngLat(this._lngLat);
            }
            this._originalTabIndex = this._element.getAttribute('tabindex');
            if (!this._originalTabIndex) {
                this._element.setAttribute('tabindex', '0');
            }
            this._element.addEventListener('keypress', this._onKeyPress);
        }
        return this;
    };
    Marker.prototype._onKeyPress = function _onKeyPress(e) {
        var code = e.code;
        var legacyCode = e.charCode || e.keyCode;
        if (code === 'Space' || code === 'Enter' || legacyCode === 32 || legacyCode === 13) {
            this.togglePopup();
        }
    };
    Marker.prototype._onMapClick = function _onMapClick(e) {
        var targetElement = e.originalEvent.target;
        var element = this._element;
        if (this._popup && (targetElement === element || element.contains(targetElement))) {
            this.togglePopup();
        }
    };
    Marker.prototype.getPopup = function getPopup() {
        return this._popup;
    };
    Marker.prototype.togglePopup = function togglePopup() {
        var popup = this._popup;
        if (!popup) {
            return this;
        } else if (popup.isOpen()) {
            popup.remove();
        } else {
            popup.addTo(this._map);
        }
        return this;
    };
    Marker.prototype._update = function _update(e) {
        if (!this._map) {
            return;
        }
        if (this._map.transform.renderWorldCopies) {
            this._lngLat = smartWrap(this._lngLat, this._pos, this._map.transform);
        }
        this._pos = this._map.project(this._lngLat)._add(this._offset);
        var rotation = '';
        if (this._rotationAlignment === 'viewport' || this._rotationAlignment === 'auto') {
            rotation = 'rotateZ(' + this._rotation + 'deg)';
        } else if (this._rotationAlignment === 'map') {
            rotation = 'rotateZ(' + (this._rotation - this._map.getBearing()) + 'deg)';
        }
        var pitch = '';
        if (this._pitchAlignment === 'viewport' || this._pitchAlignment === 'auto') {
            pitch = 'rotateX(0deg)';
        } else if (this._pitchAlignment === 'map') {
            pitch = 'rotateX(' + this._map.getPitch() + 'deg)';
        }
        if (!e || e.type === 'moveend') {
            this._pos = this._pos.round();
        }
        DOM.setTransform(this._element, anchorTranslate[this._anchor] + ' translate(' + this._pos.x + 'px, ' + this._pos.y + 'px) ' + pitch + ' ' + rotation);
    };
    Marker.prototype.getOffset = function getOffset() {
        return this._offset;
    };
    Marker.prototype.setOffset = function setOffset(offset) {
        this._offset = performance.Point.convert(offset);
        this._update();
        return this;
    };
    Marker.prototype._onMove = function _onMove(e) {
        if (!this._isDragging) {
            var clickTolerance = this._clickTolerance || this._map._clickTolerance;
            this._isDragging = e.point.dist(this._pointerdownPos) >= clickTolerance;
        }
        if (!this._isDragging) {
            return;
        }
        this._pos = e.point.sub(this._positionDelta);
        this._lngLat = this._map.unproject(this._pos);
        this.setLngLat(this._lngLat);
        this._element.style.pointerEvents = 'none';
        if (this._state === 'pending') {
            this._state = 'active';
            this.fire(new performance.Event('dragstart'));
        }
        this.fire(new performance.Event('drag'));
    };
    Marker.prototype._onUp = function _onUp() {
        this._element.style.pointerEvents = 'auto';
        this._positionDelta = null;
        this._pointerdownPos = null;
        this._isDragging = false;
        this._map.off('mousemove', this._onMove);
        this._map.off('touchmove', this._onMove);
        if (this._state === 'active') {
            this.fire(new performance.Event('dragend'));
        }
        this._state = 'inactive';
    };
    Marker.prototype._addDragHandler = function _addDragHandler(e) {
        if (this._element.contains(e.originalEvent.target)) {
            e.preventDefault();
            this._positionDelta = e.point.sub(this._pos).add(this._offset);
            this._pointerdownPos = e.point;
            this._state = 'pending';
            this._map.on('mousemove', this._onMove);
            this._map.on('touchmove', this._onMove);
            this._map.once('mouseup', this._onUp);
            this._map.once('touchend', this._onUp);
        }
    };
    Marker.prototype.setDraggable = function setDraggable(shouldBeDraggable) {
        this._draggable = !!shouldBeDraggable;
        if (this._map) {
            if (shouldBeDraggable) {
                this._map.on('mousedown', this._addDragHandler);
                this._map.on('touchstart', this._addDragHandler);
            } else {
                this._map.off('mousedown', this._addDragHandler);
                this._map.off('touchstart', this._addDragHandler);
            }
        }
        return this;
    };
    Marker.prototype.isDraggable = function isDraggable() {
        return this._draggable;
    };
    Marker.prototype.setRotation = function setRotation(rotation) {
        this._rotation = rotation || 0;
        this._update();
        return this;
    };
    Marker.prototype.getRotation = function getRotation() {
        return this._rotation;
    };
    Marker.prototype.setRotationAlignment = function setRotationAlignment(alignment) {
        this._rotationAlignment = alignment || 'auto';
        this._update();
        return this;
    };
    Marker.prototype.getRotationAlignment = function getRotationAlignment() {
        return this._rotationAlignment;
    };
    Marker.prototype.setPitchAlignment = function setPitchAlignment(alignment) {
        this._pitchAlignment = alignment && alignment !== 'auto' ? alignment : this._rotationAlignment;
        this._update();
        return this;
    };
    Marker.prototype.getPitchAlignment = function getPitchAlignment() {
        return this._pitchAlignment;
    };
    return Marker;
}(performance.Evented);

var defaultOptions$3 = {
    positionOptions: {
        enableHighAccuracy: false,
        maximumAge: 0,
        timeout: 6000
    },
    fitBoundsOptions: { maxZoom: 15 },
    trackUserLocation: false,
    showAccuracyCircle: true,
    showUserLocation: true
};
var supportsGeolocation;
function checkGeolocationSupport(callback) {
    if (supportsGeolocation !== undefined) {
        callback(supportsGeolocation);
    } else if (performance.window.navigator.permissions !== undefined) {
        performance.window.navigator.permissions.query({ name: 'geolocation' }).then(function (p) {
            supportsGeolocation = p.state !== 'denied';
            callback(supportsGeolocation);
        });
    } else {
        supportsGeolocation = !!performance.window.navigator.geolocation;
        callback(supportsGeolocation);
    }
}
var numberOfWatches = 0;
var noTimeout = false;
var GeolocateControl = function (Evented) {
    function GeolocateControl(options) {
        Evented.call(this);
        this.options = performance.extend({}, defaultOptions$3, options);
        performance.bindAll([
            '_onSuccess',
            '_onError',
            '_onZoom',
            '_finish',
            '_setupUI',
            '_updateCamera',
            '_updateMarker'
        ], this);
    }
    if (Evented)
        GeolocateControl.__proto__ = Evented;
    GeolocateControl.prototype = Object.create(Evented && Evented.prototype);
    GeolocateControl.prototype.constructor = GeolocateControl;
    GeolocateControl.prototype.onAdd = function onAdd(map) {
        this._map = map;
        this._container = DOM.create('div', 'mapboxgl-ctrl mapboxgl-ctrl-group');
        checkGeolocationSupport(this._setupUI);
        return this._container;
    };
    GeolocateControl.prototype.onRemove = function onRemove() {
        if (this._geolocationWatchID !== undefined) {
            performance.window.navigator.geolocation.clearWatch(this._geolocationWatchID);
            this._geolocationWatchID = undefined;
        }
        if (this.options.showUserLocation && this._userLocationDotMarker) {
            this._userLocationDotMarker.remove();
        }
        if (this.options.showAccuracyCircle && this._accuracyCircleMarker) {
            this._accuracyCircleMarker.remove();
        }
        DOM.remove(this._container);
        this._map.off('zoom', this._onZoom);
        this._map = undefined;
        numberOfWatches = 0;
        noTimeout = false;
    };
    GeolocateControl.prototype._isOutOfMapMaxBounds = function _isOutOfMapMaxBounds(position) {
        var bounds = this._map.getMaxBounds();
        var coordinates = position.coords;
        return bounds && (coordinates.longitude < bounds.getWest() || coordinates.longitude > bounds.getEast() || coordinates.latitude < bounds.getSouth() || coordinates.latitude > bounds.getNorth());
    };
    GeolocateControl.prototype._setErrorState = function _setErrorState() {
        switch (this._watchState) {
        case 'WAITING_ACTIVE':
            this._watchState = 'ACTIVE_ERROR';
            this._geolocateButton.classList.remove('mapboxgl-ctrl-geolocate-active');
            this._geolocateButton.classList.add('mapboxgl-ctrl-geolocate-active-error');
            break;
        case 'ACTIVE_LOCK':
            this._watchState = 'ACTIVE_ERROR';
            this._geolocateButton.classList.remove('mapboxgl-ctrl-geolocate-active');
            this._geolocateButton.classList.add('mapboxgl-ctrl-geolocate-active-error');
            this._geolocateButton.classList.add('mapboxgl-ctrl-geolocate-waiting');
            break;
        case 'BACKGROUND':
            this._watchState = 'BACKGROUND_ERROR';
            this._geolocateButton.classList.remove('mapboxgl-ctrl-geolocate-background');
            this._geolocateButton.classList.add('mapboxgl-ctrl-geolocate-background-error');
            this._geolocateButton.classList.add('mapboxgl-ctrl-geolocate-waiting');
            break;
        }
    };
    GeolocateControl.prototype._onSuccess = function _onSuccess(position) {
        if (!this._map) {
            return;
        }
        if (this._isOutOfMapMaxBounds(position)) {
            this._setErrorState();
            this.fire(new performance.Event('outofmaxbounds', position));
            this._updateMarker();
            this._finish();
            return;
        }
        if (this.options.trackUserLocation) {
            this._lastKnownPosition = position;
            switch (this._watchState) {
            case 'WAITING_ACTIVE':
            case 'ACTIVE_LOCK':
            case 'ACTIVE_ERROR':
                this._watchState = 'ACTIVE_LOCK';
                this._geolocateButton.classList.remove('mapboxgl-ctrl-geolocate-waiting');
                this._geolocateButton.classList.remove('mapboxgl-ctrl-geolocate-active-error');
                this._geolocateButton.classList.add('mapboxgl-ctrl-geolocate-active');
                break;
            case 'BACKGROUND':
            case 'BACKGROUND_ERROR':
                this._watchState = 'BACKGROUND';
                this._geolocateButton.classList.remove('mapboxgl-ctrl-geolocate-waiting');
                this._geolocateButton.classList.remove('mapboxgl-ctrl-geolocate-background-error');
                this._geolocateButton.classList.add('mapboxgl-ctrl-geolocate-background');
                break;
            }
        }
        if (this.options.showUserLocation && this._watchState !== 'OFF') {
            this._updateMarker(position);
        }
        if (!this.options.trackUserLocation || this._watchState === 'ACTIVE_LOCK') {
            this._updateCamera(position);
        }
        if (this.options.showUserLocation) {
            this._dotElement.classList.remove('mapboxgl-user-location-dot-stale');
        }
        this.fire(new performance.Event('geolocate', position));
        this._finish();
    };
    GeolocateControl.prototype._updateCamera = function _updateCamera(position) {
        var center = new performance.LngLat(position.coords.longitude, position.coords.latitude);
        var radius = position.coords.accuracy;
        var bearing = this._map.getBearing();
        var options = performance.extend({ bearing: bearing }, this.options.fitBoundsOptions);
        this._map.fitBounds(center.toBounds(radius), options, { geolocateSource: true });
    };
    GeolocateControl.prototype._updateMarker = function _updateMarker(position) {
        if (position) {
            var center = new performance.LngLat(position.coords.longitude, position.coords.latitude);
            this._accuracyCircleMarker.setLngLat(center).addTo(this._map);
            this._userLocationDotMarker.setLngLat(center).addTo(this._map);
            this._accuracy = position.coords.accuracy;
            if (this.options.showUserLocation && this.options.showAccuracyCircle) {
                this._updateCircleRadius();
            }
        } else {
            this._userLocationDotMarker.remove();
            this._accuracyCircleMarker.remove();
        }
    };
    GeolocateControl.prototype._updateCircleRadius = function _updateCircleRadius() {
        var y = this._map._container.clientHeight / 2;
        var a = this._map.unproject([
            0,
            y
        ]);
        var b = this._map.unproject([
            1,
            y
        ]);
        var metersPerPixel = a.distanceTo(b);
        var circleDiameter = Math.ceil(2 * this._accuracy / metersPerPixel);
        this._circleElement.style.width = circleDiameter + 'px';
        this._circleElement.style.height = circleDiameter + 'px';
    };
    GeolocateControl.prototype._onZoom = function _onZoom() {
        if (this.options.showUserLocation && this.options.showAccuracyCircle) {
            this._updateCircleRadius();
        }
    };
    GeolocateControl.prototype._onError = function _onError(error) {
        if (!this._map) {
            return;
        }
        if (this.options.trackUserLocation) {
            if (error.code === 1) {
                this._watchState = 'OFF';
                this._geolocateButton.classList.remove('mapboxgl-ctrl-geolocate-waiting');
                this._geolocateButton.classList.remove('mapboxgl-ctrl-geolocate-active');
                this._geolocateButton.classList.remove('mapboxgl-ctrl-geolocate-active-error');
                this._geolocateButton.classList.remove('mapboxgl-ctrl-geolocate-background');
                this._geolocateButton.classList.remove('mapboxgl-ctrl-geolocate-background-error');
                this._geolocateButton.disabled = true;
                var title = this._map._getUIString('GeolocateControl.LocationNotAvailable');
                this._geolocateButton.title = title;
                this._geolocateButton.setAttribute('aria-label', title);
                if (this._geolocationWatchID !== undefined) {
                    this._clearWatch();
                }
            } else if (error.code === 3 && noTimeout) {
                return;
            } else {
                this._setErrorState();
            }
        }
        if (this._watchState !== 'OFF' && this.options.showUserLocation) {
            this._dotElement.classList.add('mapboxgl-user-location-dot-stale');
        }
        this.fire(new performance.Event('error', error));
        this._finish();
    };
    GeolocateControl.prototype._finish = function _finish() {
        if (this._timeoutId) {
            clearTimeout(this._timeoutId);
        }
        this._timeoutId = undefined;
    };
    GeolocateControl.prototype._setupUI = function _setupUI(supported) {
        var this$1 = this;
        this._container.addEventListener('contextmenu', function (e) {
            return e.preventDefault();
        });
        this._geolocateButton = DOM.create('button', 'mapboxgl-ctrl-geolocate', this._container);
        DOM.create('span', 'mapboxgl-ctrl-icon', this._geolocateButton).setAttribute('aria-hidden', true);
        this._geolocateButton.type = 'button';
        if (supported === false) {
            performance.warnOnce('Geolocation support is not available so the GeolocateControl will be disabled.');
            var title = this._map._getUIString('GeolocateControl.LocationNotAvailable');
            this._geolocateButton.disabled = true;
            this._geolocateButton.title = title;
            this._geolocateButton.setAttribute('aria-label', title);
        } else {
            var title$1 = this._map._getUIString('GeolocateControl.FindMyLocation');
            this._geolocateButton.title = title$1;
            this._geolocateButton.setAttribute('aria-label', title$1);
        }
        if (this.options.trackUserLocation) {
            this._geolocateButton.setAttribute('aria-pressed', 'false');
            this._watchState = 'OFF';
        }
        if (this.options.showUserLocation) {
            this._dotElement = DOM.create('div', 'mapboxgl-user-location-dot');
            this._userLocationDotMarker = new Marker(this._dotElement);
            this._circleElement = DOM.create('div', 'mapboxgl-user-location-accuracy-circle');
            this._accuracyCircleMarker = new Marker({
                element: this._circleElement,
                pitchAlignment: 'map'
            });
            if (this.options.trackUserLocation) {
                this._watchState = 'OFF';
            }
            this._map.on('zoom', this._onZoom);
        }
        this._geolocateButton.addEventListener('click', this.trigger.bind(this));
        this._setup = true;
        if (this.options.trackUserLocation) {
            this._map.on('movestart', function (event) {
                var fromResize = event.originalEvent && event.originalEvent.type === 'resize';
                if (!event.geolocateSource && this$1._watchState === 'ACTIVE_LOCK' && !fromResize) {
                    this$1._watchState = 'BACKGROUND';
                    this$1._geolocateButton.classList.add('mapboxgl-ctrl-geolocate-background');
                    this$1._geolocateButton.classList.remove('mapboxgl-ctrl-geolocate-active');
                    this$1.fire(new performance.Event('trackuserlocationend'));
                }
            });
        }
    };
    GeolocateControl.prototype.trigger = function trigger() {
        if (!this._setup) {
            performance.warnOnce('Geolocate control triggered before added to a map');
            return false;
        }
        if (this.options.trackUserLocation) {
            switch (this._watchState) {
            case 'OFF':
                this._watchState = 'WAITING_ACTIVE';
                this.fire(new performance.Event('trackuserlocationstart'));
                break;
            case 'WAITING_ACTIVE':
            case 'ACTIVE_LOCK':
            case 'ACTIVE_ERROR':
            case 'BACKGROUND_ERROR':
                numberOfWatches--;
                noTimeout = false;
                this._watchState = 'OFF';
                this._geolocateButton.classList.remove('mapboxgl-ctrl-geolocate-waiting');
                this._geolocateButton.classList.remove('mapboxgl-ctrl-geolocate-active');
                this._geolocateButton.classList.remove('mapboxgl-ctrl-geolocate-active-error');
                this._geolocateButton.classList.remove('mapboxgl-ctrl-geolocate-background');
                this._geolocateButton.classList.remove('mapboxgl-ctrl-geolocate-background-error');
                this.fire(new performance.Event('trackuserlocationend'));
                break;
            case 'BACKGROUND':
                this._watchState = 'ACTIVE_LOCK';
                this._geolocateButton.classList.remove('mapboxgl-ctrl-geolocate-background');
                if (this._lastKnownPosition) {
                    this._updateCamera(this._lastKnownPosition);
                }
                this.fire(new performance.Event('trackuserlocationstart'));
                break;
            }
            switch (this._watchState) {
            case 'WAITING_ACTIVE':
                this._geolocateButton.classList.add('mapboxgl-ctrl-geolocate-waiting');
                this._geolocateButton.classList.add('mapboxgl-ctrl-geolocate-active');
                break;
            case 'ACTIVE_LOCK':
                this._geolocateButton.classList.add('mapboxgl-ctrl-geolocate-active');
                break;
            case 'ACTIVE_ERROR':
                this._geolocateButton.classList.add('mapboxgl-ctrl-geolocate-waiting');
                this._geolocateButton.classList.add('mapboxgl-ctrl-geolocate-active-error');
                break;
            case 'BACKGROUND':
                this._geolocateButton.classList.add('mapboxgl-ctrl-geolocate-background');
                break;
            case 'BACKGROUND_ERROR':
                this._geolocateButton.classList.add('mapboxgl-ctrl-geolocate-waiting');
                this._geolocateButton.classList.add('mapboxgl-ctrl-geolocate-background-error');
                break;
            }
            if (this._watchState === 'OFF' && this._geolocationWatchID !== undefined) {
                this._clearWatch();
            } else if (this._geolocationWatchID === undefined) {
                this._geolocateButton.classList.add('mapboxgl-ctrl-geolocate-waiting');
                this._geolocateButton.setAttribute('aria-pressed', 'true');
                numberOfWatches++;
                var positionOptions;
                if (numberOfWatches > 1) {
                    positionOptions = {
                        maximumAge: 600000,
                        timeout: 0
                    };
                    noTimeout = true;
                } else {
                    positionOptions = this.options.positionOptions;
                    noTimeout = false;
                }
                this._geolocationWatchID = performance.window.navigator.geolocation.watchPosition(this._onSuccess, this._onError, positionOptions);
            }
        } else {
            performance.window.navigator.geolocation.getCurrentPosition(this._onSuccess, this._onError, this.options.positionOptions);
            this._timeoutId = setTimeout(this._finish, 10000);
        }
        return true;
    };
    GeolocateControl.prototype._clearWatch = function _clearWatch() {
        performance.window.navigator.geolocation.clearWatch(this._geolocationWatchID);
        this._geolocationWatchID = undefined;
        this._geolocateButton.classList.remove('mapboxgl-ctrl-geolocate-waiting');
        this._geolocateButton.setAttribute('aria-pressed', 'false');
        if (this.options.showUserLocation) {
            this._updateMarker(null);
        }
    };
    return GeolocateControl;
}(performance.Evented);

var defaultOptions$4 = {
    maxWidth: 100,
    unit: 'metric'
};
var ScaleControl = function ScaleControl(options) {
    this.options = performance.extend({}, defaultOptions$4, options);
    performance.bindAll([
        '_onMove',
        'setUnit'
    ], this);
};
ScaleControl.prototype.getDefaultPosition = function getDefaultPosition() {
    return 'bottom-left';
};
ScaleControl.prototype._onMove = function _onMove() {
    updateScale(this._map, this._container, this.options);
};
ScaleControl.prototype.onAdd = function onAdd(map) {
    this._map = map;
    this._container = DOM.create('div', 'mapboxgl-ctrl mapboxgl-ctrl-scale', map.getContainer());
    this._map.on('move', this._onMove);
    this._onMove();
    return this._container;
};
ScaleControl.prototype.onRemove = function onRemove() {
    DOM.remove(this._container);
    this._map.off('move', this._onMove);
    this._map = undefined;
};
ScaleControl.prototype.setUnit = function setUnit(unit) {
    this.options.unit = unit;
    updateScale(this._map, this._container, this.options);
};
function updateScale(map, container, options) {
    var maxWidth = options && options.maxWidth || 100;
    var y = map._container.clientHeight / 2;
    var left = map.unproject([
        0,
        y
    ]);
    var right = map.unproject([
        maxWidth,
        y
    ]);
    var maxMeters = left.distanceTo(right);
    if (options && options.unit === 'imperial') {
        var maxFeet = 3.2808 * maxMeters;
        if (maxFeet > 5280) {
            var maxMiles = maxFeet / 5280;
            setScale(container, maxWidth, maxMiles, map._getUIString('ScaleControl.Miles'));
        } else {
            setScale(container, maxWidth, maxFeet, map._getUIString('ScaleControl.Feet'));
        }
    } else if (options && options.unit === 'nautical') {
        var maxNauticals = maxMeters / 1852;
        setScale(container, maxWidth, maxNauticals, map._getUIString('ScaleControl.NauticalMiles'));
    } else if (maxMeters >= 1000) {
        setScale(container, maxWidth, maxMeters / 1000, map._getUIString('ScaleControl.Kilometers'));
    } else {
        setScale(container, maxWidth, maxMeters, map._getUIString('ScaleControl.Meters'));
    }
}
function setScale(container, maxWidth, maxDistance, unit) {
    var distance = getRoundNum(maxDistance);
    var ratio = distance / maxDistance;
    container.style.width = maxWidth * ratio + 'px';
    container.innerHTML = distance + '&nbsp;' + unit;
}
function getDecimalRoundNum(d) {
    var multiplier = Math.pow(10, Math.ceil(-Math.log(d) / Math.LN10));
    return Math.round(d * multiplier) / multiplier;
}
function getRoundNum(num) {
    var pow10 = Math.pow(10, ('' + Math.floor(num)).length - 1);
    var d = num / pow10;
    d = d >= 10 ? 10 : d >= 5 ? 5 : d >= 3 ? 3 : d >= 2 ? 2 : d >= 1 ? 1 : getDecimalRoundNum(d);
    return pow10 * d;
}

var FullscreenControl = function FullscreenControl(options) {
    this._fullscreen = false;
    if (options && options.container) {
        if (options.container instanceof performance.window.HTMLElement) {
            this._container = options.container;
        } else {
            performance.warnOnce('Full screen control \'container\' must be a DOM element.');
        }
    }
    performance.bindAll([
        '_onClickFullscreen',
        '_changeIcon'
    ], this);
    if ('onfullscreenchange' in performance.window.document) {
        this._fullscreenchange = 'fullscreenchange';
    } else if ('onmozfullscreenchange' in performance.window.document) {
        this._fullscreenchange = 'mozfullscreenchange';
    } else if ('onwebkitfullscreenchange' in performance.window.document) {
        this._fullscreenchange = 'webkitfullscreenchange';
    } else if ('onmsfullscreenchange' in performance.window.document) {
        this._fullscreenchange = 'MSFullscreenChange';
    }
};
FullscreenControl.prototype.onAdd = function onAdd(map) {
    this._map = map;
    if (!this._container) {
        this._container = this._map.getContainer();
    }
    this._controlContainer = DOM.create('div', 'mapboxgl-ctrl mapboxgl-ctrl-group');
    if (this._checkFullscreenSupport()) {
        this._setupUI();
    } else {
        this._controlContainer.style.display = 'none';
        performance.warnOnce('This device does not support fullscreen mode.');
    }
    return this._controlContainer;
};
FullscreenControl.prototype.onRemove = function onRemove() {
    DOM.remove(this._controlContainer);
    this._map = null;
    performance.window.document.removeEventListener(this._fullscreenchange, this._changeIcon);
};
FullscreenControl.prototype._checkFullscreenSupport = function _checkFullscreenSupport() {
    return !!(performance.window.document.fullscreenEnabled || performance.window.document.mozFullScreenEnabled || performance.window.document.msFullscreenEnabled || performance.window.document.webkitFullscreenEnabled);
};
FullscreenControl.prototype._setupUI = function _setupUI() {
    var button = this._fullscreenButton = DOM.create('button', 'mapboxgl-ctrl-fullscreen', this._controlContainer);
    DOM.create('span', 'mapboxgl-ctrl-icon', button).setAttribute('aria-hidden', true);
    button.type = 'button';
    this._updateTitle();
    this._fullscreenButton.addEventListener('click', this._onClickFullscreen);
    performance.window.document.addEventListener(this._fullscreenchange, this._changeIcon);
};
FullscreenControl.prototype._updateTitle = function _updateTitle() {
    var title = this._getTitle();
    this._fullscreenButton.setAttribute('aria-label', title);
    this._fullscreenButton.title = title;
};
FullscreenControl.prototype._getTitle = function _getTitle() {
    return this._map._getUIString(this._isFullscreen() ? 'FullscreenControl.Exit' : 'FullscreenControl.Enter');
};
FullscreenControl.prototype._isFullscreen = function _isFullscreen() {
    return this._fullscreen;
};
FullscreenControl.prototype._changeIcon = function _changeIcon() {
    var fullscreenElement = performance.window.document.fullscreenElement || performance.window.document.mozFullScreenElement || performance.window.document.webkitFullscreenElement || performance.window.document.msFullscreenElement;
    if (fullscreenElement === this._container !== this._fullscreen) {
        this._fullscreen = !this._fullscreen;
        this._fullscreenButton.classList.toggle('mapboxgl-ctrl-shrink');
        this._fullscreenButton.classList.toggle('mapboxgl-ctrl-fullscreen');
        this._updateTitle();
    }
};
FullscreenControl.prototype._onClickFullscreen = function _onClickFullscreen() {
    if (this._isFullscreen()) {
        if (performance.window.document.exitFullscreen) {
            performance.window.document.exitFullscreen();
        } else if (performance.window.document.mozCancelFullScreen) {
            performance.window.document.mozCancelFullScreen();
        } else if (performance.window.document.msExitFullscreen) {
            performance.window.document.msExitFullscreen();
        } else if (performance.window.document.webkitCancelFullScreen) {
            performance.window.document.webkitCancelFullScreen();
        }
    } else if (this._container.requestFullscreen) {
        this._container.requestFullscreen();
    } else if (this._container.mozRequestFullScreen) {
        this._container.mozRequestFullScreen();
    } else if (this._container.msRequestFullscreen) {
        this._container.msRequestFullscreen();
    } else if (this._container.webkitRequestFullscreen) {
        this._container.webkitRequestFullscreen();
    }
};

var defaultOptions$5 = {
    closeButton: true,
    closeOnClick: true,
    focusAfterOpen: true,
    className: '',
    maxWidth: '240px'
};
var focusQuerySelector = [
    'a[href]',
    '[tabindex]:not([tabindex=\'-1\'])',
    '[contenteditable]:not([contenteditable=\'false\'])',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])'
].join(', ');
var Popup = function (Evented) {
    function Popup(options) {
        Evented.call(this);
        this.options = performance.extend(Object.create(defaultOptions$5), options);
        performance.bindAll([
            '_update',
            '_onClose',
            'remove',
            '_onMouseMove',
            '_onMouseUp',
            '_onDrag'
        ], this);
    }
    if (Evented)
        Popup.__proto__ = Evented;
    Popup.prototype = Object.create(Evented && Evented.prototype);
    Popup.prototype.constructor = Popup;
    Popup.prototype.addTo = function addTo(map) {
        if (this._map) {
            this.remove();
        }
        this._map = map;
        if (this.options.closeOnClick) {
            this._map.on('click', this._onClose);
        }
        if (this.options.closeOnMove) {
            this._map.on('move', this._onClose);
        }
        this._map.on('remove', this.remove);
        this._update();
        this._focusFirstElement();
        if (this._trackPointer) {
            this._map.on('mousemove', this._onMouseMove);
            this._map.on('mouseup', this._onMouseUp);
            if (this._container) {
                this._container.classList.add('mapboxgl-popup-track-pointer');
            }
            this._map._canvasContainer.classList.add('mapboxgl-track-pointer');
        } else {
            this._map.on('move', this._update);
        }
        this.fire(new performance.Event('open'));
        return this;
    };
    Popup.prototype.isOpen = function isOpen() {
        return !!this._map;
    };
    Popup.prototype.remove = function remove() {
        if (this._content) {
            DOM.remove(this._content);
        }
        if (this._container) {
            DOM.remove(this._container);
            delete this._container;
        }
        if (this._map) {
            this._map.off('move', this._update);
            this._map.off('move', this._onClose);
            this._map.off('click', this._onClose);
            this._map.off('remove', this.remove);
            this._map.off('mousemove', this._onMouseMove);
            this._map.off('mouseup', this._onMouseUp);
            this._map.off('drag', this._onDrag);
            delete this._map;
        }
        this.fire(new performance.Event('close'));
        return this;
    };
    Popup.prototype.getLngLat = function getLngLat() {
        return this._lngLat;
    };
    Popup.prototype.setLngLat = function setLngLat(lnglat) {
        this._lngLat = performance.LngLat.convert(lnglat);
        this._pos = null;
        this._trackPointer = false;
        this._update();
        if (this._map) {
            this._map.on('move', this._update);
            this._map.off('mousemove', this._onMouseMove);
            if (this._container) {
                this._container.classList.remove('mapboxgl-popup-track-pointer');
            }
            this._map._canvasContainer.classList.remove('mapboxgl-track-pointer');
        }
        return this;
    };
    Popup.prototype.trackPointer = function trackPointer() {
        this._trackPointer = true;
        this._pos = null;
        this._update();
        if (this._map) {
            this._map.off('move', this._update);
            this._map.on('mousemove', this._onMouseMove);
            this._map.on('drag', this._onDrag);
            if (this._container) {
                this._container.classList.add('mapboxgl-popup-track-pointer');
            }
            this._map._canvasContainer.classList.add('mapboxgl-track-pointer');
        }
        return this;
    };
    Popup.prototype.getElement = function getElement() {
        return this._container;
    };
    Popup.prototype.setText = function setText(text) {
        return this.setDOMContent(performance.window.document.createTextNode(text));
    };
    Popup.prototype.setHTML = function setHTML(html) {
        var frag = performance.window.document.createDocumentFragment();
        var temp = performance.window.document.createElement('body');
        var child;
        temp.innerHTML = html;
        while (true) {
            child = temp.firstChild;
            if (!child) {
                break;
            }
            frag.appendChild(child);
        }
        return this.setDOMContent(frag);
    };
    Popup.prototype.getMaxWidth = function getMaxWidth() {
        return this._container && this._container.style.maxWidth;
    };
    Popup.prototype.setMaxWidth = function setMaxWidth(maxWidth) {
        this.options.maxWidth = maxWidth;
        this._update();
        return this;
    };
    Popup.prototype.setDOMContent = function setDOMContent(htmlNode) {
        if (this._content) {
            while (this._content.hasChildNodes()) {
                if (this._content.firstChild) {
                    this._content.removeChild(this._content.firstChild);
                }
            }
        } else {
            this._content = DOM.create('div', 'mapboxgl-popup-content', this._container);
        }
        this._content.appendChild(htmlNode);
        this._createCloseButton();
        this._update();
        this._focusFirstElement();
        return this;
    };
    Popup.prototype.addClassName = function addClassName(className) {
        if (this._container) {
            this._container.classList.add(className);
        }
    };
    Popup.prototype.removeClassName = function removeClassName(className) {
        if (this._container) {
            this._container.classList.remove(className);
        }
    };
    Popup.prototype.setOffset = function setOffset(offset) {
        this.options.offset = offset;
        this._update();
        return this;
    };
    Popup.prototype.toggleClassName = function toggleClassName(className) {
        if (this._container) {
            return this._container.classList.toggle(className);
        }
    };
    Popup.prototype._createCloseButton = function _createCloseButton() {
        if (this.options.closeButton) {
            this._closeButton = DOM.create('button', 'mapboxgl-popup-close-button', this._content);
            this._closeButton.type = 'button';
            this._closeButton.setAttribute('aria-label', 'Close popup');
            this._closeButton.innerHTML = '&#215;';
            this._closeButton.addEventListener('click', this._onClose);
        }
    };
    Popup.prototype._onMouseUp = function _onMouseUp(event) {
        this._update(event.point);
    };
    Popup.prototype._onMouseMove = function _onMouseMove(event) {
        this._update(event.point);
    };
    Popup.prototype._onDrag = function _onDrag(event) {
        this._update(event.point);
    };
    Popup.prototype._update = function _update(cursor) {
        var this$1 = this;
        var hasPosition = this._lngLat || this._trackPointer;
        if (!this._map || !hasPosition || !this._content) {
            return;
        }
        if (!this._container) {
            this._container = DOM.create('div', 'mapboxgl-popup', this._map.getContainer());
            this._tip = DOM.create('div', 'mapboxgl-popup-tip', this._container);
            this._container.appendChild(this._content);
            if (this.options.className) {
                this.options.className.split(' ').forEach(function (name) {
                    return this$1._container.classList.add(name);
                });
            }
            if (this._trackPointer) {
                this._container.classList.add('mapboxgl-popup-track-pointer');
            }
        }
        if (this.options.maxWidth && this._container.style.maxWidth !== this.options.maxWidth) {
            this._container.style.maxWidth = this.options.maxWidth;
        }
        if (this._map.transform.renderWorldCopies && !this._trackPointer) {
            this._lngLat = smartWrap(this._lngLat, this._pos, this._map.transform);
        }
        if (this._trackPointer && !cursor) {
            return;
        }
        var pos = this._pos = this._trackPointer && cursor ? cursor : this._map.project(this._lngLat);
        var anchor = this.options.anchor;
        var offset = normalizeOffset(this.options.offset);
        if (!anchor) {
            var width = this._container.offsetWidth;
            var height = this._container.offsetHeight;
            var anchorComponents;
            if (pos.y + offset.bottom.y < height) {
                anchorComponents = ['top'];
            } else if (pos.y > this._map.transform.height - height) {
                anchorComponents = ['bottom'];
            } else {
                anchorComponents = [];
            }
            if (pos.x < width / 2) {
                anchorComponents.push('left');
            } else if (pos.x > this._map.transform.width - width / 2) {
                anchorComponents.push('right');
            }
            if (anchorComponents.length === 0) {
                anchor = 'bottom';
            } else {
                anchor = anchorComponents.join('-');
            }
        }
        var offsetedPos = pos.add(offset[anchor]).round();
        DOM.setTransform(this._container, anchorTranslate[anchor] + ' translate(' + offsetedPos.x + 'px,' + offsetedPos.y + 'px)');
        applyAnchorClass(this._container, anchor, 'popup');
    };
    Popup.prototype._focusFirstElement = function _focusFirstElement() {
        if (!this.options.focusAfterOpen || !this._container) {
            return;
        }
        var firstFocusable = this._container.querySelector(focusQuerySelector);
        if (firstFocusable) {
            firstFocusable.focus();
        }
    };
    Popup.prototype._onClose = function _onClose() {
        this.remove();
    };
    return Popup;
}(performance.Evented);
function normalizeOffset(offset) {
    if (!offset) {
        return normalizeOffset(new performance.Point(0, 0));
    } else if (typeof offset === 'number') {
        var cornerOffset = Math.round(Math.sqrt(0.5 * Math.pow(offset, 2)));
        return {
            'center': new performance.Point(0, 0),
            'top': new performance.Point(0, offset),
            'top-left': new performance.Point(cornerOffset, cornerOffset),
            'top-right': new performance.Point(-cornerOffset, cornerOffset),
            'bottom': new performance.Point(0, -offset),
            'bottom-left': new performance.Point(cornerOffset, -cornerOffset),
            'bottom-right': new performance.Point(-cornerOffset, -cornerOffset),
            'left': new performance.Point(offset, 0),
            'right': new performance.Point(-offset, 0)
        };
    } else if (offset instanceof performance.Point || Array.isArray(offset)) {
        var convertedOffset = performance.Point.convert(offset);
        return {
            'center': convertedOffset,
            'top': convertedOffset,
            'top-left': convertedOffset,
            'top-right': convertedOffset,
            'bottom': convertedOffset,
            'bottom-left': convertedOffset,
            'bottom-right': convertedOffset,
            'left': convertedOffset,
            'right': convertedOffset
        };
    } else {
        return {
            'center': performance.Point.convert(offset['center'] || [
                0,
                0
            ]),
            'top': performance.Point.convert(offset['top'] || [
                0,
                0
            ]),
            'top-left': performance.Point.convert(offset['top-left'] || [
                0,
                0
            ]),
            'top-right': performance.Point.convert(offset['top-right'] || [
                0,
                0
            ]),
            'bottom': performance.Point.convert(offset['bottom'] || [
                0,
                0
            ]),
            'bottom-left': performance.Point.convert(offset['bottom-left'] || [
                0,
                0
            ]),
            'bottom-right': performance.Point.convert(offset['bottom-right'] || [
                0,
                0
            ]),
            'left': performance.Point.convert(offset['left'] || [
                0,
                0
            ]),
            'right': performance.Point.convert(offset['right'] || [
                0,
                0
            ])
        };
    }
}

var exported = {
    version: performance.version,
    supported: mapboxGlSupported,
    setRTLTextPlugin: performance.setRTLTextPlugin,
    getRTLTextPluginStatus: performance.getRTLTextPluginStatus,
    Map: Map,
    NavigationControl: NavigationControl,
    GeolocateControl: GeolocateControl,
    AttributionControl: AttributionControl,
    ScaleControl: ScaleControl,
    FullscreenControl: FullscreenControl,
    Popup: Popup,
    Marker: Marker,
    Style: Style,
    LngLat: performance.LngLat,
    LngLatBounds: performance.LngLatBounds,
    Point: performance.Point,
    MercatorCoordinate: performance.MercatorCoordinate,
    Evented: performance.Evented,
    config: performance.config,
    prewarm: prewarm,
    clearPrewarmedResources: clearPrewarmedResources,
    get accessToken() {
        return performance.config.ACCESS_TOKEN;
    },
    set accessToken(token) {
        performance.config.ACCESS_TOKEN = token;
    },
    get baseApiUrl() {
        return performance.config.API_URL;
    },
    set baseApiUrl(url) {
        performance.config.API_URL = url;
    },
    get workerCount() {
        return WorkerPool.workerCount;
    },
    set workerCount(count) {
        WorkerPool.workerCount = count;
    },
    get maxParallelImageRequests() {
        return performance.config.MAX_PARALLEL_IMAGE_REQUESTS;
    },
    set maxParallelImageRequests(numRequests) {
        performance.config.MAX_PARALLEL_IMAGE_REQUESTS = numRequests;
    },
    clearStorage: function clearStorage(callback) {
        performance.clearTileCache(callback);
    },
    workerUrl: ''
};

return exported;

});

//

return mapboxgl;

})));
//# sourceMappingURL=mapbox-gl-unminified.js.map


/***/ }),

/***/ 27549:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(55366)

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjpudWxsLCJzb3VyY2VzIjpbIi9ob21lL3NvbGFyY2gvcGxvdGx5L3dlYmdsL3Bsb3RseS5qcy9ub2RlX21vZHVsZXMvQHBsb3RseS9wb2ludC1jbHVzdGVyL2luZGV4LmpzIl0sInNvdXJjZXNDb250ZW50IjpbIid1c2Ugc3RyaWN0J1xuXG5tb2R1bGUuZXhwb3J0cyA9IHJlcXVpcmUoJy4vcXVhZCcpXG4iXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsWUFBWTtBQUNaO0FBQ0EsTUFBTSxDQUFDLE9BQU8sR0FBRyxPQUFPLENBQUMsUUFBUSxDQUFDOyJ9

/***/ }),

/***/ 55366:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * @module  point-cluster/quad
 *
 * Bucket based quad tree clustering
 */



var search = __webpack_require__(31625)
var clamp = __webpack_require__(75144)
var rect = __webpack_require__(5137)
var getBounds = __webpack_require__(78112)
var pick = __webpack_require__(6807)
var defined = __webpack_require__(68650)
var flatten = __webpack_require__(83473)
var isObj = __webpack_require__(60201)
var dtype = __webpack_require__(10275)
var log2 = __webpack_require__(62914)

var MAX_GROUP_ID = 1073741824

module.exports = function cluster (srcPoints, options) {
	if (!options) { options = {} }

	srcPoints = flatten(srcPoints, 'float64')

	options = pick(options, {
		bounds: 'range bounds dataBox databox',
		maxDepth: 'depth maxDepth maxdepth level maxLevel maxlevel levels',
		dtype: 'type dtype format out dst output destination'
		// sort: 'sortBy sortby sort',
		// pick: 'pick levelPoint',
		// nodeSize: 'node nodeSize minNodeSize minSize size'
	})

	// let nodeSize = defined(options.nodeSize, 1)
	var maxDepth = defined(options.maxDepth, 255)
	var bounds = defined(options.bounds, getBounds(srcPoints, 2))
	if (bounds[0] === bounds[2]) { bounds[2]++ }
	if (bounds[1] === bounds[3]) { bounds[3]++ }

	var points = normalize(srcPoints, bounds)

	// init variables
	var n = srcPoints.length >>> 1
	var ids
	if (!options.dtype) { options.dtype = 'array' }

	if (typeof options.dtype === 'string') {
		ids = new (dtype(options.dtype))(n)
	}
	else if (options.dtype) {
		ids = options.dtype
		if (Array.isArray(ids)) { ids.length = n }
	}
	for (var i = 0; i < n; ++i) {
		ids[i] = i
	}

	// representative point indexes for levels
	var levels = []

	// starting indexes of subranges in sub levels, levels.length * 4
	var sublevels = []

	// unique group ids, sorted in z-curve fashion within levels by shifting bits
	var groups = []

	// level offsets in `ids`
	var offsets = []


	// sort points
	sort(0, 0, 1, ids, 0, 1)


	// return reordered ids with provided methods
	// save level offsets in output buffer
	var offset = 0
	for (var level = 0; level < levels.length; level++) {
		var levelItems = levels[level]
		if (ids.set) { ids.set(levelItems, offset) }
		else {
			for (var i$1 = 0, l = levelItems.length; i$1 < l; i$1++) {
				ids[i$1 + offset] = levelItems[i$1]
			}
		}
		var nextOffset = offset + levels[level].length
		offsets[level] = [offset, nextOffset]
		offset = nextOffset
	}

	ids.range = range

	return ids



	// FIXME: it is possible to create one typed array heap and reuse that to avoid memory blow
	function sort (x, y, diam, ids, level, group) {
		if (!ids.length) { return null }

		// save first point as level representative
		var levelItems = levels[level] || (levels[level] = [])
		var levelGroups = groups[level] || (groups[level] = [])
		var sublevel = sublevels[level] || (sublevels[level] = [])
		var offset = levelItems.length

		level++

		// max depth reached - put all items into a first group
		// alternatively - if group id overflow - avoid proceeding
		if (level > maxDepth || group > MAX_GROUP_ID) {
			for (var i = 0; i < ids.length; i++) {
				levelItems.push(ids[i])
				levelGroups.push(group)
				sublevel.push(null, null, null, null)
			}

			return offset
		}

		levelItems.push(ids[0])
		levelGroups.push(group)

		if (ids.length <= 1) {
			sublevel.push(null, null, null, null)
			return offset
		}


		var d2 = diam * .5
		var cx = x + d2, cy = y + d2

		// distribute points by 4 buckets
		var lolo = [], lohi = [], hilo = [], hihi = []

		for (var i$1 = 1, l = ids.length; i$1 < l; i$1++) {
			var idx = ids[i$1],
				x$1 = points[idx * 2],
				y$1 = points[idx * 2 + 1]
			x$1 < cx ? (y$1 < cy ? lolo.push(idx) : lohi.push(idx)) : (y$1 < cy ? hilo.push(idx) : hihi.push(idx))
		}

		group <<= 2

		sublevel.push(
			sort(x, y, d2, lolo, level, group),
			sort(x, cy, d2, lohi, level, group + 1),
			sort(cx, y, d2, hilo, level, group + 2),
			sort(cx, cy, d2, hihi, level, group + 3)
		)

		return offset
	}

	// get all points within the passed range
	function range () {
		var args = [], len = arguments.length;
		while ( len-- ) args[ len ] = arguments[ len ];

		var options

		if (isObj(args[args.length - 1])) {
			var arg = args.pop()

			// detect if that was a rect object
			if (!args.length && (arg.x != null || arg.l != null || arg.left != null)) {
				args = [arg]
				options = {}
			}

			options = pick(arg, {
				level: 'level maxLevel',
				d: 'd diam diameter r radius px pxSize pixel pixelSize maxD size minSize',
				lod: 'lod details ranges offsets'
			})
		}
		else {
			options = {}
		}

		if (!args.length) { args = bounds }

		var box = rect.apply( void 0, args )

		var ref = [
			Math.min(box.x, box.x + box.width),
			Math.min(box.y, box.y + box.height),
			Math.max(box.x, box.x + box.width),
			Math.max(box.y, box.y + box.height)
		];
		var minX = ref[0];
		var minY = ref[1];
		var maxX = ref[2];
		var maxY = ref[3];

		var ref$1 = normalize([minX, minY, maxX, maxY], bounds );
		var nminX = ref$1[0];
		var nminY = ref$1[1];
		var nmaxX = ref$1[2];
		var nmaxY = ref$1[3];

		var maxLevel = defined(options.level, levels.length)

		// limit maxLevel by px size
		if (options.d != null) {
			var d
			if (typeof options.d === 'number') { d = [options.d, options.d] }
			else if (options.d.length) { d = options.d }

			maxLevel = Math.min(
				Math.max(
					Math.ceil(-log2(Math.abs(d[0]) / (bounds[2] - bounds[0]))),
					Math.ceil(-log2(Math.abs(d[1]) / (bounds[3] - bounds[1])))
				),
				maxLevel
			)
		}
		maxLevel = Math.min(maxLevel, levels.length)

		// return levels of details
		if (options.lod) {
			return lod(nminX, nminY, nmaxX, nmaxY, maxLevel)
		}



		// do selection ids
		var selection = []

		// FIXME: probably we can do LOD here beforehead
		select( 0, 0, 1, 0, 0, 1)

		function select ( lox, loy, d, level, from, to ) {
			if (from === null || to === null) { return }

			var hix = lox + d
			var hiy = loy + d

			// if box does not intersect level - ignore
			if ( nminX > hix || nminY > hiy || nmaxX < lox || nmaxY < loy ) { return }
			if ( level >= maxLevel ) { return }
			if ( from === to ) { return }

			// if points fall into box range - take it
			var levelItems = levels[level]

			if (to === undefined) { to = levelItems.length }

			for (var i = from; i < to; i++) {
				var id = levelItems[i]

				var px = srcPoints[ id * 2 ]
				var py = srcPoints[ id * 2 + 1 ]

				if ( px >= minX && px <= maxX && py >= minY && py <= maxY ) {selection.push(id)
				}
			}

			// for every subsection do select
			var offsets = sublevels[ level ]
			var off0 = offsets[ from * 4 + 0 ]
			var off1 = offsets[ from * 4 + 1 ]
			var off2 = offsets[ from * 4 + 2 ]
			var off3 = offsets[ from * 4 + 3 ]
			var end = nextOffset(offsets, from + 1)

			var d2 = d * .5
			var nextLevel = level + 1
			select( lox, loy, d2, nextLevel, off0, off1 || off2 || off3 || end)
			select( lox, loy + d2, d2, nextLevel, off1, off2 || off3 || end)
			select( lox + d2, loy, d2, nextLevel, off2, off3 || end)
			select( lox + d2, loy + d2, d2, nextLevel, off3, end)
		}

		function nextOffset(offsets, from) {
			var offset = null, i = 0
			while(offset === null) {
				offset = offsets[ from * 4 + i ]
				i++
				if (i > offsets.length) { return null }
			}
			return offset
		}

		return selection
	}

	// get range offsets within levels to render lods appropriate for zoom level
	// TODO: it is possible to store minSize of a point to optimize neede level calc
	function lod (lox, loy, hix, hiy, maxLevel) {
		var ranges = []

		for (var level = 0; level < maxLevel; level++) {
			var levelGroups = groups[level]
			var from = offsets[level][0]

			var levelGroupStart = group(lox, loy, level)
			var levelGroupEnd = group(hix, hiy, level)

			// FIXME: utilize sublevels to speed up search range here
			var startOffset = search.ge(levelGroups, levelGroupStart)
			var endOffset = search.gt(levelGroups, levelGroupEnd, startOffset, levelGroups.length - 1)

			ranges[level] = [startOffset + from, endOffset + from]
		}

		return ranges
	}

	// get group id closest to the x,y coordinate, corresponding to a level
	function group (x, y, level) {
		var group = 1

		var cx = .5, cy = .5
		var diam = .5

		for (var i = 0; i < level; i++) {
			group <<= 2

			group += x < cx ? (y < cy ? 0 : 1) : (y < cy ? 2 : 3)

			diam *= .5

			cx += x < cx ? -diam : diam
			cy += y < cy ? -diam : diam
		}

		return group
	}
}


// normalize points by bounds
function normalize (pts, bounds) {
	var lox = bounds[0];
	var loy = bounds[1];
	var hix = bounds[2];
	var hiy = bounds[3];
	var scaleX = 1.0 / (hix - lox)
	var scaleY = 1.0 / (hiy - loy)
	var result = new Array(pts.length)

	for (var i = 0, n = pts.length / 2; i < n; i++) {
		result[2*i] = clamp((pts[2*i] - lox) * scaleX, 0, 1)
		result[2*i+1] = clamp((pts[2*i+1] - loy) * scaleY, 0, 1)
	}

	return result
}

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 16844:
/***/ (function(module) {


module.exports = absolutize

/**
 * redefine `path` with absolute coordinates
 *
 * @param {Array} path
 * @return {Array}
 */

function absolutize(path){
	var startX = 0
	var startY = 0
	var x = 0
	var y = 0

	return path.map(function(seg){
		seg = seg.slice()
		var type = seg[0]
		var command = type.toUpperCase()

		// is relative
		if (type != command) {
			seg[0] = command
			switch (type) {
				case 'a':
					seg[6] += x
					seg[7] += y
					break
				case 'v':
					seg[1] += y
					break
				case 'h':
					seg[1] += x
					break
				default:
					for (var i = 1; i < seg.length;) {
						seg[i++] += x
						seg[i++] += y
					}
			}
		}

		// update cursor state
		switch (command) {
			case 'Z':
				x = startX
				y = startY
				break
			case 'H':
				x = seg[1]
				break
			case 'V':
				y = seg[1]
				break
			case 'M':
				x = startX = seg[1]
				y = startY = seg[2]
				break
			default:
				x = seg[seg.length - 2]
				y = seg[seg.length - 1]
		}

		return seg
	})
}


/***/ }),

/***/ 78112:
/***/ (function(module) {

"use strict";


module.exports = normalize;

function normalize (arr, dim) {
	if (!arr || arr.length == null) throw Error('Argument should be an array')

	if (dim == null) dim = 1
	else dim = Math.floor(dim)

	var bounds = Array(dim * 2)

	for (var offset = 0; offset < dim; offset++) {
		var max = -Infinity, min = Infinity, i = offset, l = arr.length;

		for (; i < l; i+=dim) {
			if (arr[i] > max) max = arr[i];
			if (arr[i] < min) min = arr[i];
		}

		bounds[offset] = min
		bounds[dim + offset] = max
	}

	return bounds;
}


/***/ }),

/***/ 33055:
/***/ (function(module) {

"use strict";

module.exports = function (arr, predicate, ctx) {
	if (typeof Array.prototype.findIndex === 'function') {
		return arr.findIndex(predicate, ctx);
	}

	if (typeof predicate !== 'function') {
		throw new TypeError('predicate must be a function');
	}

	var list = Object(arr);
	var len = list.length;

	if (len === 0) {
		return -1;
	}

	for (var i = 0; i < len; i++) {
		if (predicate.call(ctx, list[i], i, list)) {
			return i;
		}
	}

	return -1;
};


/***/ }),

/***/ 90956:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var getBounds = __webpack_require__(78112)

module.exports = normalize;

function normalize (arr, dim, bounds) {
	if (!arr || arr.length == null) throw Error('Argument should be an array')

	if (dim == null) dim = 1
	if (bounds == null) bounds = getBounds(arr, dim)

	for (var offset = 0; offset < dim; offset++) {
		var max = bounds[dim + offset], min = bounds[offset], i = offset, l = arr.length;

		if (max === Infinity && min === -Infinity) {
			for (i = offset; i < l; i+=dim) {
				arr[i] = arr[i] === max ? 1 : arr[i] === min ? 0 : .5
			}
		}
		else if (max === Infinity) {
			for (i = offset; i < l; i+=dim) {
				arr[i] = arr[i] === max ? 1 : 0
			}
		}
		else if (min === -Infinity) {
			for (i = offset; i < l; i+=dim) {
				arr[i] = arr[i] === min ? 0 : 1
			}
		}
		else {
			var range = max - min
			for (i = offset; i < l; i+=dim) {
				if (!isNaN(arr[i])) {
					arr[i] = range === 0 ? .5 : (arr[i] - min) / range
				}
			}
		}
	}

	return arr;
}


/***/ }),

/***/ 27902:
/***/ (function(module) {


module.exports = function newArray(start, end) {
    var n0 = typeof start === 'number',
        n1 = typeof end === 'number'

    if (n0 && !n1) {
        end = start
        start = 0
    } else if (!n0 && !n1) {
        start = 0
        end = 0
    }

    start = start|0
    end = end|0
    var len = end-start
    if (len<0)
        throw new Error('array length must be positive')
    
    var a = new Array(len)
    for (var i=0, c=start; i<len; i++, c++)
        a[i] = c
    return a
}

/***/ }),

/***/ 85672:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(33282);
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a51ae424a513ec9a6aa3466baa0cc1d55dd4f3b

// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.



function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
var _require = __webpack_require__(34585),
  _require$codes = _require.codes,
  ERR_AMBIGUOUS_ARGUMENT = _require$codes.ERR_AMBIGUOUS_ARGUMENT,
  ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
  ERR_INVALID_ARG_VALUE = _require$codes.ERR_INVALID_ARG_VALUE,
  ERR_INVALID_RETURN_VALUE = _require$codes.ERR_INVALID_RETURN_VALUE,
  ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS;
var AssertionError = __webpack_require__(68586);
var _require2 = __webpack_require__(56557),
  inspect = _require2.inspect;
var _require$types = (__webpack_require__(56557).types),
  isPromise = _require$types.isPromise,
  isRegExp = _require$types.isRegExp;
var objectAssign = __webpack_require__(68686)();
var objectIs = __webpack_require__(9622)();
var RegExpPrototypeTest = __webpack_require__(63063)('RegExp.prototype.test');
var errorCache = new Map();
var isDeepEqual;
var isDeepStrictEqual;
var parseExpressionAt;
var findNodeAround;
var decoder;
function lazyLoadComparison() {
  var comparison = __webpack_require__(23879);
  isDeepEqual = comparison.isDeepEqual;
  isDeepStrictEqual = comparison.isDeepStrictEqual;
}

// Escape control characters but not \n and \t to keep the line breaks and
// indentation intact.
// eslint-disable-next-line no-control-regex
var escapeSequencesRegExp = /[\x00-\x08\x0b\x0c\x0e-\x1f]/g;
var meta = (/* unused pure expression or super */ null && (["\\u0000", "\\u0001", "\\u0002", "\\u0003", "\\u0004", "\\u0005", "\\u0006", "\\u0007", '\\b', '', '', "\\u000b", '\\f', '', "\\u000e", "\\u000f", "\\u0010", "\\u0011", "\\u0012", "\\u0013", "\\u0014", "\\u0015", "\\u0016", "\\u0017", "\\u0018", "\\u0019", "\\u001a", "\\u001b", "\\u001c", "\\u001d", "\\u001e", "\\u001f"]));
var escapeFn = function escapeFn(str) {
  return meta[str.charCodeAt(0)];
};
var warned = false;

// The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.

var assert = module.exports = ok;
var NO_EXCEPTION_SENTINEL = {};

// All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided. All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.

function innerFail(obj) {
  if (obj.message instanceof Error) throw obj.message;
  throw new AssertionError(obj);
}
function fail(actual, expected, message, operator, stackStartFn) {
  var argsLen = arguments.length;
  var internalMessage;
  if (argsLen === 0) {
    internalMessage = 'Failed';
  } else if (argsLen === 1) {
    message = actual;
    actual = undefined;
  } else {
    if (warned === false) {
      warned = true;
      var warn = process.emitWarning ? process.emitWarning : console.warn.bind(console);
      warn('assert.fail() with more than one argument is deprecated. ' + 'Please use assert.strictEqual() instead or only pass a message.', 'DeprecationWarning', 'DEP0094');
    }
    if (argsLen === 2) operator = '!=';
  }
  if (message instanceof Error) throw message;
  var errArgs = {
    actual: actual,
    expected: expected,
    operator: operator === undefined ? 'fail' : operator,
    stackStartFn: stackStartFn || fail
  };
  if (message !== undefined) {
    errArgs.message = message;
  }
  var err = new AssertionError(errArgs);
  if (internalMessage) {
    err.message = internalMessage;
    err.generatedMessage = true;
  }
  throw err;
}
assert.fail = fail;

// The AssertionError is defined in internal/error.
assert.AssertionError = AssertionError;
function innerOk(fn, argLen, value, message) {
  if (!value) {
    var generatedMessage = false;
    if (argLen === 0) {
      generatedMessage = true;
      message = 'No value argument passed to `assert.ok()`';
    } else if (message instanceof Error) {
      throw message;
    }
    var err = new AssertionError({
      actual: value,
      expected: true,
      message: message,
      operator: '==',
      stackStartFn: fn
    });
    err.generatedMessage = generatedMessage;
    throw err;
  }
}

// Pure assertion tests whether a value is truthy, as determined
// by !!value.
function ok() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  innerOk.apply(void 0, [ok, args.length].concat(args));
}
assert.ok = ok;

// The equality assertion tests shallow, coercive equality with ==.
/* eslint-disable no-restricted-properties */
assert.equal = function equal(actual, expected, message) {
  if (arguments.length < 2) {
    throw new ERR_MISSING_ARGS('actual', 'expected');
  }
  // eslint-disable-next-line eqeqeq
  if (actual != expected) {
    innerFail({
      actual: actual,
      expected: expected,
      message: message,
      operator: '==',
      stackStartFn: equal
    });
  }
};

// The non-equality assertion tests for whether two objects are not
// equal with !=.
assert.notEqual = function notEqual(actual, expected, message) {
  if (arguments.length < 2) {
    throw new ERR_MISSING_ARGS('actual', 'expected');
  }
  // eslint-disable-next-line eqeqeq
  if (actual == expected) {
    innerFail({
      actual: actual,
      expected: expected,
      message: message,
      operator: '!=',
      stackStartFn: notEqual
    });
  }
};

// The equivalence assertion tests a deep equality relation.
assert.deepEqual = function deepEqual(actual, expected, message) {
  if (arguments.length < 2) {
    throw new ERR_MISSING_ARGS('actual', 'expected');
  }
  if (isDeepEqual === undefined) lazyLoadComparison();
  if (!isDeepEqual(actual, expected)) {
    innerFail({
      actual: actual,
      expected: expected,
      message: message,
      operator: 'deepEqual',
      stackStartFn: deepEqual
    });
  }
};

// The non-equivalence assertion tests for any deep inequality.
assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
  if (arguments.length < 2) {
    throw new ERR_MISSING_ARGS('actual', 'expected');
  }
  if (isDeepEqual === undefined) lazyLoadComparison();
  if (isDeepEqual(actual, expected)) {
    innerFail({
      actual: actual,
      expected: expected,
      message: message,
      operator: 'notDeepEqual',
      stackStartFn: notDeepEqual
    });
  }
};
/* eslint-enable */

assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
  if (arguments.length < 2) {
    throw new ERR_MISSING_ARGS('actual', 'expected');
  }
  if (isDeepEqual === undefined) lazyLoadComparison();
  if (!isDeepStrictEqual(actual, expected)) {
    innerFail({
      actual: actual,
      expected: expected,
      message: message,
      operator: 'deepStrictEqual',
      stackStartFn: deepStrictEqual
    });
  }
};
assert.notDeepStrictEqual = notDeepStrictEqual;
function notDeepStrictEqual(actual, expected, message) {
  if (arguments.length < 2) {
    throw new ERR_MISSING_ARGS('actual', 'expected');
  }
  if (isDeepEqual === undefined) lazyLoadComparison();
  if (isDeepStrictEqual(actual, expected)) {
    innerFail({
      actual: actual,
      expected: expected,
      message: message,
      operator: 'notDeepStrictEqual',
      stackStartFn: notDeepStrictEqual
    });
  }
}
assert.strictEqual = function strictEqual(actual, expected, message) {
  if (arguments.length < 2) {
    throw new ERR_MISSING_ARGS('actual', 'expected');
  }
  if (!objectIs(actual, expected)) {
    innerFail({
      actual: actual,
      expected: expected,
      message: message,
      operator: 'strictEqual',
      stackStartFn: strictEqual
    });
  }
};
assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
  if (arguments.length < 2) {
    throw new ERR_MISSING_ARGS('actual', 'expected');
  }
  if (objectIs(actual, expected)) {
    innerFail({
      actual: actual,
      expected: expected,
      message: message,
      operator: 'notStrictEqual',
      stackStartFn: notStrictEqual
    });
  }
};
var Comparison = /*#__PURE__*/_createClass(function Comparison(obj, keys, actual) {
  var _this = this;
  _classCallCheck(this, Comparison);
  keys.forEach(function (key) {
    if (key in obj) {
      if (actual !== undefined && typeof actual[key] === 'string' && isRegExp(obj[key]) && RegExpPrototypeTest(obj[key], actual[key])) {
        _this[key] = actual[key];
      } else {
        _this[key] = obj[key];
      }
    }
  });
});
function compareExceptionKey(actual, expected, key, message, keys, fn) {
  if (!(key in actual) || !isDeepStrictEqual(actual[key], expected[key])) {
    if (!message) {
      // Create placeholder objects to create a nice output.
      var a = new Comparison(actual, keys);
      var b = new Comparison(expected, keys, actual);
      var err = new AssertionError({
        actual: a,
        expected: b,
        operator: 'deepStrictEqual',
        stackStartFn: fn
      });
      err.actual = actual;
      err.expected = expected;
      err.operator = fn.name;
      throw err;
    }
    innerFail({
      actual: actual,
      expected: expected,
      message: message,
      operator: fn.name,
      stackStartFn: fn
    });
  }
}
function expectedException(actual, expected, msg, fn) {
  if (typeof expected !== 'function') {
    if (isRegExp(expected)) return RegExpPrototypeTest(expected, actual);
    // assert.doesNotThrow does not accept objects.
    if (arguments.length === 2) {
      throw new ERR_INVALID_ARG_TYPE('expected', ['Function', 'RegExp'], expected);
    }

    // Handle primitives properly.
    if (_typeof(actual) !== 'object' || actual === null) {
      var err = new AssertionError({
        actual: actual,
        expected: expected,
        message: msg,
        operator: 'deepStrictEqual',
        stackStartFn: fn
      });
      err.operator = fn.name;
      throw err;
    }
    var keys = Object.keys(expected);
    // Special handle errors to make sure the name and the message are compared
    // as well.
    if (expected instanceof Error) {
      keys.push('name', 'message');
    } else if (keys.length === 0) {
      throw new ERR_INVALID_ARG_VALUE('error', expected, 'may not be an empty object');
    }
    if (isDeepEqual === undefined) lazyLoadComparison();
    keys.forEach(function (key) {
      if (typeof actual[key] === 'string' && isRegExp(expected[key]) && RegExpPrototypeTest(expected[key], actual[key])) {
        return;
      }
      compareExceptionKey(actual, expected, key, msg, keys, fn);
    });
    return true;
  }
  // Guard instanceof against arrow functions as they don't have a prototype.
  if (expected.prototype !== undefined && actual instanceof expected) {
    return true;
  }
  if (Error.isPrototypeOf(expected)) {
    return false;
  }
  return expected.call({}, actual) === true;
}
function getActual(fn) {
  if (typeof fn !== 'function') {
    throw new ERR_INVALID_ARG_TYPE('fn', 'Function', fn);
  }
  try {
    fn();
  } catch (e) {
    return e;
  }
  return NO_EXCEPTION_SENTINEL;
}
function checkIsPromise(obj) {
  // Accept native ES6 promises and promises that are implemented in a similar
  // way. Do not accept thenables that use a function as `obj` and that have no
  // `catch` handler.

  // TODO: thenables are checked up until they have the correct methods,
  // but according to documentation, the `then` method should receive
  // the `fulfill` and `reject` arguments as well or it may be never resolved.

  return isPromise(obj) || obj !== null && _typeof(obj) === 'object' && typeof obj.then === 'function' && typeof obj.catch === 'function';
}
function waitForActual(promiseFn) {
  return Promise.resolve().then(function () {
    var resultPromise;
    if (typeof promiseFn === 'function') {
      // Return a rejected promise if `promiseFn` throws synchronously.
      resultPromise = promiseFn();
      // Fail in case no promise is returned.
      if (!checkIsPromise(resultPromise)) {
        throw new ERR_INVALID_RETURN_VALUE('instance of Promise', 'promiseFn', resultPromise);
      }
    } else if (checkIsPromise(promiseFn)) {
      resultPromise = promiseFn;
    } else {
      throw new ERR_INVALID_ARG_TYPE('promiseFn', ['Function', 'Promise'], promiseFn);
    }
    return Promise.resolve().then(function () {
      return resultPromise;
    }).then(function () {
      return NO_EXCEPTION_SENTINEL;
    }).catch(function (e) {
      return e;
    });
  });
}
function expectsError(stackStartFn, actual, error, message) {
  if (typeof error === 'string') {
    if (arguments.length === 4) {
      throw new ERR_INVALID_ARG_TYPE('error', ['Object', 'Error', 'Function', 'RegExp'], error);
    }
    if (_typeof(actual) === 'object' && actual !== null) {
      if (actual.message === error) {
        throw new ERR_AMBIGUOUS_ARGUMENT('error/message', "The error message \"".concat(actual.message, "\" is identical to the message."));
      }
    } else if (actual === error) {
      throw new ERR_AMBIGUOUS_ARGUMENT('error/message', "The error \"".concat(actual, "\" is identical to the message."));
    }
    message = error;
    error = undefined;
  } else if (error != null && _typeof(error) !== 'object' && typeof error !== 'function') {
    throw new ERR_INVALID_ARG_TYPE('error', ['Object', 'Error', 'Function', 'RegExp'], error);
  }
  if (actual === NO_EXCEPTION_SENTINEL) {
    var details = '';
    if (error && error.name) {
      details += " (".concat(error.name, ")");
    }
    details += message ? ": ".concat(message) : '.';
    var fnType = stackStartFn.name === 'rejects' ? 'rejection' : 'exception';
    innerFail({
      actual: undefined,
      expected: error,
      operator: stackStartFn.name,
      message: "Missing expected ".concat(fnType).concat(details),
      stackStartFn: stackStartFn
    });
  }
  if (error && !expectedException(actual, error, message, stackStartFn)) {
    throw actual;
  }
}
function expectsNoError(stackStartFn, actual, error, message) {
  if (actual === NO_EXCEPTION_SENTINEL) return;
  if (typeof error === 'string') {
    message = error;
    error = undefined;
  }
  if (!error || expectedException(actual, error)) {
    var details = message ? ": ".concat(message) : '.';
    var fnType = stackStartFn.name === 'doesNotReject' ? 'rejection' : 'exception';
    innerFail({
      actual: actual,
      expected: error,
      operator: stackStartFn.name,
      message: "Got unwanted ".concat(fnType).concat(details, "\n") + "Actual message: \"".concat(actual && actual.message, "\""),
      stackStartFn: stackStartFn
    });
  }
  throw actual;
}
assert.throws = function throws(promiseFn) {
  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }
  expectsError.apply(void 0, [throws, getActual(promiseFn)].concat(args));
};
assert.rejects = function rejects(promiseFn) {
  for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }
  return waitForActual(promiseFn).then(function (result) {
    return expectsError.apply(void 0, [rejects, result].concat(args));
  });
};
assert.doesNotThrow = function doesNotThrow(fn) {
  for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    args[_key4 - 1] = arguments[_key4];
  }
  expectsNoError.apply(void 0, [doesNotThrow, getActual(fn)].concat(args));
};
assert.doesNotReject = function doesNotReject(fn) {
  for (var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
    args[_key5 - 1] = arguments[_key5];
  }
  return waitForActual(fn).then(function (result) {
    return expectsNoError.apply(void 0, [doesNotReject, result].concat(args));
  });
};
assert.ifError = function ifError(err) {
  if (err !== null && err !== undefined) {
    var message = 'ifError got unwanted exception: ';
    if (_typeof(err) === 'object' && typeof err.message === 'string') {
      if (err.message.length === 0 && err.constructor) {
        message += err.constructor.name;
      } else {
        message += err.message;
      }
    } else {
      message += inspect(err);
    }
    var newErr = new AssertionError({
      actual: err,
      expected: null,
      operator: 'ifError',
      message: message,
      stackStartFn: ifError
    });

    // Make sure we actually have a stack trace!
    var origStack = err.stack;
    if (typeof origStack === 'string') {
      // This will remove any duplicated frames from the error frames taken
      // from within `ifError` and add the original error frames to the newly
      // created ones.
      var tmp2 = origStack.split('\n');
      tmp2.shift();
      // Filter all frames existing in err.stack.
      var tmp1 = newErr.stack.split('\n');
      for (var i = 0; i < tmp2.length; i++) {
        // Find the first occurrence of the frame.
        var pos = tmp1.indexOf(tmp2[i]);
        if (pos !== -1) {
          // Only keep new frames.
          tmp1 = tmp1.slice(0, pos);
          break;
        }
      }
      newErr.stack = "".concat(tmp1.join('\n'), "\n").concat(tmp2.join('\n'));
    }
    throw newErr;
  }
};

// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a871df3dfb8ea663ef5e1f8f62701ec51384ecb
function internalMatch(string, regexp, message, fn, fnName) {
  if (!isRegExp(regexp)) {
    throw new ERR_INVALID_ARG_TYPE('regexp', 'RegExp', regexp);
  }
  var match = fnName === 'match';
  if (typeof string !== 'string' || RegExpPrototypeTest(regexp, string) !== match) {
    if (message instanceof Error) {
      throw message;
    }
    var generatedMessage = !message;

    // 'The input was expected to not match the regular expression ' +
    message = message || (typeof string !== 'string' ? 'The "string" argument must be of type string. Received type ' + "".concat(_typeof(string), " (").concat(inspect(string), ")") : (match ? 'The input did not match the regular expression ' : 'The input was expected to not match the regular expression ') + "".concat(inspect(regexp), ". Input:\n\n").concat(inspect(string), "\n"));
    var err = new AssertionError({
      actual: string,
      expected: regexp,
      message: message,
      operator: fnName,
      stackStartFn: fn
    });
    err.generatedMessage = generatedMessage;
    throw err;
  }
}
assert.match = function match(string, regexp, message) {
  internalMatch(string, regexp, message, match, 'match');
};
assert.doesNotMatch = function doesNotMatch(string, regexp, message) {
  internalMatch(string, regexp, message, doesNotMatch, 'doesNotMatch');
};

// Expose a strict only variant of assert
function strict() {
  for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    args[_key6] = arguments[_key6];
  }
  innerOk.apply(void 0, [strict, args.length].concat(args));
}
assert.strict = objectAssign(strict, assert, {
  equal: assert.strictEqual,
  deepEqual: assert.deepStrictEqual,
  notEqual: assert.notStrictEqual,
  notDeepEqual: assert.notDeepStrictEqual
});
assert.strict.strict = assert.strict;

/***/ }),

/***/ 68586:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(33282);
// Currently in sync with Node.js lib/internal/assert/assertion_error.js
// https://github.com/nodejs/node/commit/0817840f775032169ddd70c85ac059f18ffcc81c



function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _require = __webpack_require__(56557),
  inspect = _require.inspect;
var _require2 = __webpack_require__(34585),
  ERR_INVALID_ARG_TYPE = _require2.codes.ERR_INVALID_ARG_TYPE;

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function endsWith(str, search, this_len) {
  if (this_len === undefined || this_len > str.length) {
    this_len = str.length;
  }
  return str.substring(this_len - search.length, this_len) === search;
}

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/repeat
function repeat(str, count) {
  count = Math.floor(count);
  if (str.length == 0 || count == 0) return '';
  var maxCount = str.length * count;
  count = Math.floor(Math.log(count) / Math.log(2));
  while (count) {
    str += str;
    count--;
  }
  str += str.substring(0, maxCount - str.length);
  return str;
}
var blue = '';
var green = '';
var red = '';
var white = '';
var kReadableOperator = {
  deepStrictEqual: 'Expected values to be strictly deep-equal:',
  strictEqual: 'Expected values to be strictly equal:',
  strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
  deepEqual: 'Expected values to be loosely deep-equal:',
  equal: 'Expected values to be loosely equal:',
  notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
  notStrictEqual: 'Expected "actual" to be strictly unequal to:',
  notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
  notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
  notEqual: 'Expected "actual" to be loosely unequal to:',
  notIdentical: 'Values identical but not reference-equal:'
};

// Comparing short primitives should just show === / !== instead of using the
// diff.
var kMaxShortLength = 10;
function copyError(source) {
  var keys = Object.keys(source);
  var target = Object.create(Object.getPrototypeOf(source));
  keys.forEach(function (key) {
    target[key] = source[key];
  });
  Object.defineProperty(target, 'message', {
    value: source.message
  });
  return target;
}
function inspectValue(val) {
  // The util.inspect default values could be changed. This makes sure the
  // error messages contain the necessary information nevertheless.
  return inspect(val, {
    compact: false,
    customInspect: false,
    depth: 1000,
    maxArrayLength: Infinity,
    // Assert compares only enumerable properties (with a few exceptions).
    showHidden: false,
    // Having a long line as error is better than wrapping the line for
    // comparison for now.
    // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
    // have meta information about the inspected properties (i.e., know where
    // in what line the property starts and ends).
    breakLength: Infinity,
    // Assert does not detect proxies currently.
    showProxy: false,
    sorted: true,
    // Inspect getters as we also check them when comparing entries.
    getters: true
  });
}
function createErrDiff(actual, expected, operator) {
  var other = '';
  var res = '';
  var lastPos = 0;
  var end = '';
  var skipped = false;
  var actualInspected = inspectValue(actual);
  var actualLines = actualInspected.split('\n');
  var expectedLines = inspectValue(expected).split('\n');
  var i = 0;
  var indicator = '';

  // In case both values are objects explicitly mark them as not reference equal
  // for the `strictEqual` operator.
  if (operator === 'strictEqual' && _typeof(actual) === 'object' && _typeof(expected) === 'object' && actual !== null && expected !== null) {
    operator = 'strictEqualObject';
  }

  // If "actual" and "expected" fit on a single line and they are not strictly
  // equal, check further special handling.
  if (actualLines.length === 1 && expectedLines.length === 1 && actualLines[0] !== expectedLines[0]) {
    var inputLength = actualLines[0].length + expectedLines[0].length;
    // If the character length of "actual" and "expected" together is less than
    // kMaxShortLength and if neither is an object and at least one of them is
    // not `zero`, use the strict equal comparison to visualize the output.
    if (inputLength <= kMaxShortLength) {
      if ((_typeof(actual) !== 'object' || actual === null) && (_typeof(expected) !== 'object' || expected === null) && (actual !== 0 || expected !== 0)) {
        // -0 === +0
        return "".concat(kReadableOperator[operator], "\n\n") + "".concat(actualLines[0], " !== ").concat(expectedLines[0], "\n");
      }
    } else if (operator !== 'strictEqualObject') {
      // If the stderr is a tty and the input length is lower than the current
      // columns per line, add a mismatch indicator below the output. If it is
      // not a tty, use a default value of 80 characters.
      var maxLength = process.stderr && process.stderr.isTTY ? process.stderr.columns : 80;
      if (inputLength < maxLength) {
        while (actualLines[0][i] === expectedLines[0][i]) {
          i++;
        }
        // Ignore the first characters.
        if (i > 2) {
          // Add position indicator for the first mismatch in case it is a
          // single line and the input length is less than the column length.
          indicator = "\n  ".concat(repeat(' ', i), "^");
          i = 0;
        }
      }
    }
  }

  // Remove all ending lines that match (this optimizes the output for
  // readability by reducing the number of total changed lines).
  var a = actualLines[actualLines.length - 1];
  var b = expectedLines[expectedLines.length - 1];
  while (a === b) {
    if (i++ < 2) {
      end = "\n  ".concat(a).concat(end);
    } else {
      other = a;
    }
    actualLines.pop();
    expectedLines.pop();
    if (actualLines.length === 0 || expectedLines.length === 0) break;
    a = actualLines[actualLines.length - 1];
    b = expectedLines[expectedLines.length - 1];
  }
  var maxLines = Math.max(actualLines.length, expectedLines.length);
  // Strict equal with identical objects that are not identical by reference.
  // E.g., assert.deepStrictEqual({ a: Symbol() }, { a: Symbol() })
  if (maxLines === 0) {
    // We have to get the result again. The lines were all removed before.
    var _actualLines = actualInspected.split('\n');

    // Only remove lines in case it makes sense to collapse those.
    // TODO: Accept env to always show the full error.
    if (_actualLines.length > 30) {
      _actualLines[26] = "".concat(blue, "...").concat(white);
      while (_actualLines.length > 27) {
        _actualLines.pop();
      }
    }
    return "".concat(kReadableOperator.notIdentical, "\n\n").concat(_actualLines.join('\n'), "\n");
  }
  if (i > 3) {
    end = "\n".concat(blue, "...").concat(white).concat(end);
    skipped = true;
  }
  if (other !== '') {
    end = "\n  ".concat(other).concat(end);
    other = '';
  }
  var printedLines = 0;
  var msg = kReadableOperator[operator] + "\n".concat(green, "+ actual").concat(white, " ").concat(red, "- expected").concat(white);
  var skippedMsg = " ".concat(blue, "...").concat(white, " Lines skipped");
  for (i = 0; i < maxLines; i++) {
    // Only extra expected lines exist
    var cur = i - lastPos;
    if (actualLines.length < i + 1) {
      // If the last diverging line is more than one line above and the
      // current line is at least line three, add some of the former lines and
      // also add dots to indicate skipped entries.
      if (cur > 1 && i > 2) {
        if (cur > 4) {
          res += "\n".concat(blue, "...").concat(white);
          skipped = true;
        } else if (cur > 3) {
          res += "\n  ".concat(expectedLines[i - 2]);
          printedLines++;
        }
        res += "\n  ".concat(expectedLines[i - 1]);
        printedLines++;
      }
      // Mark the current line as the last diverging one.
      lastPos = i;
      // Add the expected line to the cache.
      other += "\n".concat(red, "-").concat(white, " ").concat(expectedLines[i]);
      printedLines++;
      // Only extra actual lines exist
    } else if (expectedLines.length < i + 1) {
      // If the last diverging line is more than one line above and the
      // current line is at least line three, add some of the former lines and
      // also add dots to indicate skipped entries.
      if (cur > 1 && i > 2) {
        if (cur > 4) {
          res += "\n".concat(blue, "...").concat(white);
          skipped = true;
        } else if (cur > 3) {
          res += "\n  ".concat(actualLines[i - 2]);
          printedLines++;
        }
        res += "\n  ".concat(actualLines[i - 1]);
        printedLines++;
      }
      // Mark the current line as the last diverging one.
      lastPos = i;
      // Add the actual line to the result.
      res += "\n".concat(green, "+").concat(white, " ").concat(actualLines[i]);
      printedLines++;
      // Lines diverge
    } else {
      var expectedLine = expectedLines[i];
      var actualLine = actualLines[i];
      // If the lines diverge, specifically check for lines that only diverge by
      // a trailing comma. In that case it is actually identical and we should
      // mark it as such.
      var divergingLines = actualLine !== expectedLine && (!endsWith(actualLine, ',') || actualLine.slice(0, -1) !== expectedLine);
      // If the expected line has a trailing comma but is otherwise identical,
      // add a comma at the end of the actual line. Otherwise the output could
      // look weird as in:
      //
      //   [
      //     1         // No comma at the end!
      // +   2
      //   ]
      //
      if (divergingLines && endsWith(expectedLine, ',') && expectedLine.slice(0, -1) === actualLine) {
        divergingLines = false;
        actualLine += ',';
      }
      if (divergingLines) {
        // If the last diverging line is more than one line above and the
        // current line is at least line three, add some of the former lines and
        // also add dots to indicate skipped entries.
        if (cur > 1 && i > 2) {
          if (cur > 4) {
            res += "\n".concat(blue, "...").concat(white);
            skipped = true;
          } else if (cur > 3) {
            res += "\n  ".concat(actualLines[i - 2]);
            printedLines++;
          }
          res += "\n  ".concat(actualLines[i - 1]);
          printedLines++;
        }
        // Mark the current line as the last diverging one.
        lastPos = i;
        // Add the actual line to the result and cache the expected diverging
        // line so consecutive diverging lines show up as +++--- and not +-+-+-.
        res += "\n".concat(green, "+").concat(white, " ").concat(actualLine);
        other += "\n".concat(red, "-").concat(white, " ").concat(expectedLine);
        printedLines += 2;
        // Lines are identical
      } else {
        // Add all cached information to the result before adding other things
        // and reset the cache.
        res += other;
        other = '';
        // If the last diverging line is exactly one line above or if it is the
        // very first line, add the line to the result.
        if (cur === 1 || i === 0) {
          res += "\n  ".concat(actualLine);
          printedLines++;
        }
      }
    }
    // Inspected object to big (Show ~20 rows max)
    if (printedLines > 20 && i < maxLines - 2) {
      return "".concat(msg).concat(skippedMsg, "\n").concat(res, "\n").concat(blue, "...").concat(white).concat(other, "\n") + "".concat(blue, "...").concat(white);
    }
  }
  return "".concat(msg).concat(skipped ? skippedMsg : '', "\n").concat(res).concat(other).concat(end).concat(indicator);
}
var AssertionError = /*#__PURE__*/function (_Error, _inspect$custom) {
  _inherits(AssertionError, _Error);
  var _super = _createSuper(AssertionError);
  function AssertionError(options) {
    var _this;
    _classCallCheck(this, AssertionError);
    if (_typeof(options) !== 'object' || options === null) {
      throw new ERR_INVALID_ARG_TYPE('options', 'Object', options);
    }
    var message = options.message,
      operator = options.operator,
      stackStartFn = options.stackStartFn;
    var actual = options.actual,
      expected = options.expected;
    var limit = Error.stackTraceLimit;
    Error.stackTraceLimit = 0;
    if (message != null) {
      _this = _super.call(this, String(message));
    } else {
      if (process.stderr && process.stderr.isTTY) {
        // Reset on each call to make sure we handle dynamically set environment
        // variables correct.
        if (process.stderr && process.stderr.getColorDepth && process.stderr.getColorDepth() !== 1) {
          blue = "\x1B[34m";
          green = "\x1B[32m";
          white = "\x1B[39m";
          red = "\x1B[31m";
        } else {
          blue = '';
          green = '';
          white = '';
          red = '';
        }
      }
      // Prevent the error stack from being visible by duplicating the error
      // in a very close way to the original in case both sides are actually
      // instances of Error.
      if (_typeof(actual) === 'object' && actual !== null && _typeof(expected) === 'object' && expected !== null && 'stack' in actual && actual instanceof Error && 'stack' in expected && expected instanceof Error) {
        actual = copyError(actual);
        expected = copyError(expected);
      }
      if (operator === 'deepStrictEqual' || operator === 'strictEqual') {
        _this = _super.call(this, createErrDiff(actual, expected, operator));
      } else if (operator === 'notDeepStrictEqual' || operator === 'notStrictEqual') {
        // In case the objects are equal but the operator requires unequal, show
        // the first object and say A equals B
        var base = kReadableOperator[operator];
        var res = inspectValue(actual).split('\n');

        // In case "actual" is an object, it should not be reference equal.
        if (operator === 'notStrictEqual' && _typeof(actual) === 'object' && actual !== null) {
          base = kReadableOperator.notStrictEqualObject;
        }

        // Only remove lines in case it makes sense to collapse those.
        // TODO: Accept env to always show the full error.
        if (res.length > 30) {
          res[26] = "".concat(blue, "...").concat(white);
          while (res.length > 27) {
            res.pop();
          }
        }

        // Only print a single input.
        if (res.length === 1) {
          _this = _super.call(this, "".concat(base, " ").concat(res[0]));
        } else {
          _this = _super.call(this, "".concat(base, "\n\n").concat(res.join('\n'), "\n"));
        }
      } else {
        var _res = inspectValue(actual);
        var other = '';
        var knownOperators = kReadableOperator[operator];
        if (operator === 'notDeepEqual' || operator === 'notEqual') {
          _res = "".concat(kReadableOperator[operator], "\n\n").concat(_res);
          if (_res.length > 1024) {
            _res = "".concat(_res.slice(0, 1021), "...");
          }
        } else {
          other = "".concat(inspectValue(expected));
          if (_res.length > 512) {
            _res = "".concat(_res.slice(0, 509), "...");
          }
          if (other.length > 512) {
            other = "".concat(other.slice(0, 509), "...");
          }
          if (operator === 'deepEqual' || operator === 'equal') {
            _res = "".concat(knownOperators, "\n\n").concat(_res, "\n\nshould equal\n\n");
          } else {
            other = " ".concat(operator, " ").concat(other);
          }
        }
        _this = _super.call(this, "".concat(_res).concat(other));
      }
    }
    Error.stackTraceLimit = limit;
    _this.generatedMessage = !message;
    Object.defineProperty(_assertThisInitialized(_this), 'name', {
      value: 'AssertionError [ERR_ASSERTION]',
      enumerable: false,
      writable: true,
      configurable: true
    });
    _this.code = 'ERR_ASSERTION';
    _this.actual = actual;
    _this.expected = expected;
    _this.operator = operator;
    if (Error.captureStackTrace) {
      // eslint-disable-next-line no-restricted-syntax
      Error.captureStackTrace(_assertThisInitialized(_this), stackStartFn);
    }
    // Create error message including the error code in the name.
    _this.stack;
    // Reset the name.
    _this.name = 'AssertionError';
    return _possibleConstructorReturn(_this);
  }
  _createClass(AssertionError, [{
    key: "toString",
    value: function toString() {
      return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
    }
  }, {
    key: _inspect$custom,
    value: function value(recurseTimes, ctx) {
      // This limits the `actual` and `expected` property default inspection to
      // the minimum depth. Otherwise those values would be too verbose compared
      // to the actual error message which contains a combined view of these two
      // input values.
      return inspect(this, _objectSpread(_objectSpread({}, ctx), {}, {
        customInspect: false,
        depth: 0
      }));
    }
  }]);
  return AssertionError;
}( /*#__PURE__*/_wrapNativeSuper(Error), inspect.custom);
module.exports = AssertionError;

/***/ }),

/***/ 34585:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
// Currently in sync with Node.js lib/internal/errors.js
// https://github.com/nodejs/node/commit/3b044962c48fe313905877a96b5d0894a5404f6f

/* eslint node-core/documented-errors: "error" */
/* eslint node-core/alphabetize-errors: "error" */
/* eslint node-core/prefer-util-format-errors: "error" */



// The whole point behind this internal module is to allow Node.js to no
// longer be forced to treat every error message change as a semver-major
// change. The NodeError classes here all expose a `code` property whose
// value statically and permanently identifies the error. While the error
// message may change, the code should not.
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var codes = {};

// Lazy loaded
var assert;
var util;
function createErrorType(code, message, Base) {
  if (!Base) {
    Base = Error;
  }
  function getMessage(arg1, arg2, arg3) {
    if (typeof message === 'string') {
      return message;
    } else {
      return message(arg1, arg2, arg3);
    }
  }
  var NodeError = /*#__PURE__*/function (_Base) {
    _inherits(NodeError, _Base);
    var _super = _createSuper(NodeError);
    function NodeError(arg1, arg2, arg3) {
      var _this;
      _classCallCheck(this, NodeError);
      _this = _super.call(this, getMessage(arg1, arg2, arg3));
      _this.code = code;
      return _this;
    }
    return _createClass(NodeError);
  }(Base);
  codes[code] = NodeError;
}

// https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function oneOf(expected, thing) {
  if (Array.isArray(expected)) {
    var len = expected.length;
    expected = expected.map(function (i) {
      return String(i);
    });
    if (len > 2) {
      return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
    } else if (len === 2) {
      return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
    } else {
      return "of ".concat(thing, " ").concat(expected[0]);
    }
  } else {
    return "of ".concat(thing, " ").concat(String(expected));
  }
}

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function startsWith(str, search, pos) {
  return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
}

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function endsWith(str, search, this_len) {
  if (this_len === undefined || this_len > str.length) {
    this_len = str.length;
  }
  return str.substring(this_len - search.length, this_len) === search;
}

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function includes(str, search, start) {
  if (typeof start !== 'number') {
    start = 0;
  }
  if (start + search.length > str.length) {
    return false;
  } else {
    return str.indexOf(search, start) !== -1;
  }
}
createErrorType('ERR_AMBIGUOUS_ARGUMENT', 'The "%s" argument is ambiguous. %s', TypeError);
createErrorType('ERR_INVALID_ARG_TYPE', function (name, expected, actual) {
  if (assert === undefined) assert = __webpack_require__(85672);
  assert(typeof name === 'string', "'name' must be a string");

  // determiner: 'must be' or 'must not be'
  var determiner;
  if (typeof expected === 'string' && startsWith(expected, 'not ')) {
    determiner = 'must not be';
    expected = expected.replace(/^not /, '');
  } else {
    determiner = 'must be';
  }
  var msg;
  if (endsWith(name, ' argument')) {
    // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
  } else {
    var type = includes(name, '.') ? 'property' : 'argument';
    msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
  }

  // TODO(BridgeAR): Improve the output by showing `null` and similar.
  msg += ". Received type ".concat(_typeof(actual));
  return msg;
}, TypeError);
createErrorType('ERR_INVALID_ARG_VALUE', function (name, value) {
  var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'is invalid';
  if (util === undefined) util = __webpack_require__(56557);
  var inspected = util.inspect(value);
  if (inspected.length > 128) {
    inspected = "".concat(inspected.slice(0, 128), "...");
  }
  return "The argument '".concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError, RangeError);
createErrorType('ERR_INVALID_RETURN_VALUE', function (input, name, value) {
  var type;
  if (value && value.constructor && value.constructor.name) {
    type = "instance of ".concat(value.constructor.name);
  } else {
    type = "type ".concat(_typeof(value));
  }
  return "Expected ".concat(input, " to be returned from the \"").concat(name, "\"") + " function but got ".concat(type, ".");
}, TypeError);
createErrorType('ERR_MISSING_ARGS', function () {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  if (assert === undefined) assert = __webpack_require__(85672);
  assert(args.length > 0, 'At least one arg needs to be specified');
  var msg = 'The ';
  var len = args.length;
  args = args.map(function (a) {
    return "\"".concat(a, "\"");
  });
  switch (len) {
    case 1:
      msg += "".concat(args[0], " argument");
      break;
    case 2:
      msg += "".concat(args[0], " and ").concat(args[1], " arguments");
      break;
    default:
      msg += args.slice(0, len - 1).join(', ');
      msg += ", and ".concat(args[len - 1], " arguments");
      break;
  }
  return "".concat(msg, " must be specified");
}, TypeError);
module.exports.codes = codes;

/***/ }),

/***/ 23879:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
// Currently in sync with Node.js lib/internal/util/comparisons.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9



function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var regexFlagsSupported = /a/g.flags !== undefined;
var arrayFromSet = function arrayFromSet(set) {
  var array = [];
  set.forEach(function (value) {
    return array.push(value);
  });
  return array;
};
var arrayFromMap = function arrayFromMap(map) {
  var array = [];
  map.forEach(function (value, key) {
    return array.push([key, value]);
  });
  return array;
};
var objectIs = Object.is ? Object.is : __webpack_require__(13969);
var objectGetOwnPropertySymbols = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function () {
  return [];
};
var numberIsNaN = Number.isNaN ? Number.isNaN : __webpack_require__(63057);
function uncurryThis(f) {
  return f.call.bind(f);
}
var hasOwnProperty = uncurryThis(Object.prototype.hasOwnProperty);
var propertyIsEnumerable = uncurryThis(Object.prototype.propertyIsEnumerable);
var objectToString = uncurryThis(Object.prototype.toString);
var _require$types = (__webpack_require__(56557).types),
  isAnyArrayBuffer = _require$types.isAnyArrayBuffer,
  isArrayBufferView = _require$types.isArrayBufferView,
  isDate = _require$types.isDate,
  isMap = _require$types.isMap,
  isRegExp = _require$types.isRegExp,
  isSet = _require$types.isSet,
  isNativeError = _require$types.isNativeError,
  isBoxedPrimitive = _require$types.isBoxedPrimitive,
  isNumberObject = _require$types.isNumberObject,
  isStringObject = _require$types.isStringObject,
  isBooleanObject = _require$types.isBooleanObject,
  isBigIntObject = _require$types.isBigIntObject,
  isSymbolObject = _require$types.isSymbolObject,
  isFloat32Array = _require$types.isFloat32Array,
  isFloat64Array = _require$types.isFloat64Array;
function isNonIndex(key) {
  if (key.length === 0 || key.length > 10) return true;
  for (var i = 0; i < key.length; i++) {
    var code = key.charCodeAt(i);
    if (code < 48 || code > 57) return true;
  }
  // The maximum size for an array is 2 ** 32 -1.
  return key.length === 10 && key >= Math.pow(2, 32);
}
function getOwnNonIndexProperties(value) {
  return Object.keys(value).filter(isNonIndex).concat(objectGetOwnPropertySymbols(value).filter(Object.prototype.propertyIsEnumerable.bind(value)));
}

// Taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
function compare(a, b) {
  if (a === b) {
    return 0;
  }
  var x = a.length;
  var y = b.length;
  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i];
      y = b[i];
      break;
    }
  }
  if (x < y) {
    return -1;
  }
  if (y < x) {
    return 1;
  }
  return 0;
}
var ONLY_ENUMERABLE = undefined;
var kStrict = true;
var kLoose = false;
var kNoIterator = 0;
var kIsArray = 1;
var kIsSet = 2;
var kIsMap = 3;

// Check if they have the same source and flags
function areSimilarRegExps(a, b) {
  return regexFlagsSupported ? a.source === b.source && a.flags === b.flags : RegExp.prototype.toString.call(a) === RegExp.prototype.toString.call(b);
}
function areSimilarFloatArrays(a, b) {
  if (a.byteLength !== b.byteLength) {
    return false;
  }
  for (var offset = 0; offset < a.byteLength; offset++) {
    if (a[offset] !== b[offset]) {
      return false;
    }
  }
  return true;
}
function areSimilarTypedArrays(a, b) {
  if (a.byteLength !== b.byteLength) {
    return false;
  }
  return compare(new Uint8Array(a.buffer, a.byteOffset, a.byteLength), new Uint8Array(b.buffer, b.byteOffset, b.byteLength)) === 0;
}
function areEqualArrayBuffers(buf1, buf2) {
  return buf1.byteLength === buf2.byteLength && compare(new Uint8Array(buf1), new Uint8Array(buf2)) === 0;
}
function isEqualBoxedPrimitive(val1, val2) {
  if (isNumberObject(val1)) {
    return isNumberObject(val2) && objectIs(Number.prototype.valueOf.call(val1), Number.prototype.valueOf.call(val2));
  }
  if (isStringObject(val1)) {
    return isStringObject(val2) && String.prototype.valueOf.call(val1) === String.prototype.valueOf.call(val2);
  }
  if (isBooleanObject(val1)) {
    return isBooleanObject(val2) && Boolean.prototype.valueOf.call(val1) === Boolean.prototype.valueOf.call(val2);
  }
  if (isBigIntObject(val1)) {
    return isBigIntObject(val2) && BigInt.prototype.valueOf.call(val1) === BigInt.prototype.valueOf.call(val2);
  }
  return isSymbolObject(val2) && Symbol.prototype.valueOf.call(val1) === Symbol.prototype.valueOf.call(val2);
}

// Notes: Type tags are historical [[Class]] properties that can be set by
// FunctionTemplate::SetClassName() in C++ or Symbol.toStringTag in JS
// and retrieved using Object.prototype.toString.call(obj) in JS
// See https://tc39.github.io/ecma262/#sec-object.prototype.tostring
// for a list of tags pre-defined in the spec.
// There are some unspecified tags in the wild too (e.g. typed array tags).
// Since tags can be altered, they only serve fast failures
//
// Typed arrays and buffers are checked by comparing the content in their
// underlying ArrayBuffer. This optimization requires that it's
// reasonable to interpret their underlying memory in the same way,
// which is checked by comparing their type tags.
// (e.g. a Uint8Array and a Uint16Array with the same memory content
// could still be different because they will be interpreted differently).
//
// For strict comparison, objects should have
// a) The same built-in type tags
// b) The same prototypes.

function innerDeepEqual(val1, val2, strict, memos) {
  // All identical values are equivalent, as determined by ===.
  if (val1 === val2) {
    if (val1 !== 0) return true;
    return strict ? objectIs(val1, val2) : true;
  }

  // Check more closely if val1 and val2 are equal.
  if (strict) {
    if (_typeof(val1) !== 'object') {
      return typeof val1 === 'number' && numberIsNaN(val1) && numberIsNaN(val2);
    }
    if (_typeof(val2) !== 'object' || val1 === null || val2 === null) {
      return false;
    }
    if (Object.getPrototypeOf(val1) !== Object.getPrototypeOf(val2)) {
      return false;
    }
  } else {
    if (val1 === null || _typeof(val1) !== 'object') {
      if (val2 === null || _typeof(val2) !== 'object') {
        // eslint-disable-next-line eqeqeq
        return val1 == val2;
      }
      return false;
    }
    if (val2 === null || _typeof(val2) !== 'object') {
      return false;
    }
  }
  var val1Tag = objectToString(val1);
  var val2Tag = objectToString(val2);
  if (val1Tag !== val2Tag) {
    return false;
  }
  if (Array.isArray(val1)) {
    // Check for sparse arrays and general fast path
    if (val1.length !== val2.length) {
      return false;
    }
    var keys1 = getOwnNonIndexProperties(val1, ONLY_ENUMERABLE);
    var keys2 = getOwnNonIndexProperties(val2, ONLY_ENUMERABLE);
    if (keys1.length !== keys2.length) {
      return false;
    }
    return keyCheck(val1, val2, strict, memos, kIsArray, keys1);
  }
  // [browserify] This triggers on certain types in IE (Map/Set) so we don't
  // wan't to early return out of the rest of the checks. However we can check
  // if the second value is one of these values and the first isn't.
  if (val1Tag === '[object Object]') {
    // return keyCheck(val1, val2, strict, memos, kNoIterator);
    if (!isMap(val1) && isMap(val2) || !isSet(val1) && isSet(val2)) {
      return false;
    }
  }
  if (isDate(val1)) {
    if (!isDate(val2) || Date.prototype.getTime.call(val1) !== Date.prototype.getTime.call(val2)) {
      return false;
    }
  } else if (isRegExp(val1)) {
    if (!isRegExp(val2) || !areSimilarRegExps(val1, val2)) {
      return false;
    }
  } else if (isNativeError(val1) || val1 instanceof Error) {
    // Do not compare the stack as it might differ even though the error itself
    // is otherwise identical.
    if (val1.message !== val2.message || val1.name !== val2.name) {
      return false;
    }
  } else if (isArrayBufferView(val1)) {
    if (!strict && (isFloat32Array(val1) || isFloat64Array(val1))) {
      if (!areSimilarFloatArrays(val1, val2)) {
        return false;
      }
    } else if (!areSimilarTypedArrays(val1, val2)) {
      return false;
    }
    // Buffer.compare returns true, so val1.length === val2.length. If they both
    // only contain numeric keys, we don't need to exam further than checking
    // the symbols.
    var _keys = getOwnNonIndexProperties(val1, ONLY_ENUMERABLE);
    var _keys2 = getOwnNonIndexProperties(val2, ONLY_ENUMERABLE);
    if (_keys.length !== _keys2.length) {
      return false;
    }
    return keyCheck(val1, val2, strict, memos, kNoIterator, _keys);
  } else if (isSet(val1)) {
    if (!isSet(val2) || val1.size !== val2.size) {
      return false;
    }
    return keyCheck(val1, val2, strict, memos, kIsSet);
  } else if (isMap(val1)) {
    if (!isMap(val2) || val1.size !== val2.size) {
      return false;
    }
    return keyCheck(val1, val2, strict, memos, kIsMap);
  } else if (isAnyArrayBuffer(val1)) {
    if (!areEqualArrayBuffers(val1, val2)) {
      return false;
    }
  } else if (isBoxedPrimitive(val1) && !isEqualBoxedPrimitive(val1, val2)) {
    return false;
  }
  return keyCheck(val1, val2, strict, memos, kNoIterator);
}
function getEnumerables(val, keys) {
  return keys.filter(function (k) {
    return propertyIsEnumerable(val, k);
  });
}
function keyCheck(val1, val2, strict, memos, iterationType, aKeys) {
  // For all remaining Object pairs, including Array, objects and Maps,
  // equivalence is determined by having:
  // a) The same number of owned enumerable properties
  // b) The same set of keys/indexes (although not necessarily the same order)
  // c) Equivalent values for every corresponding key/index
  // d) For Sets and Maps, equal contents
  // Note: this accounts for both named and indexed properties on Arrays.
  if (arguments.length === 5) {
    aKeys = Object.keys(val1);
    var bKeys = Object.keys(val2);

    // The pair must have the same number of owned properties.
    if (aKeys.length !== bKeys.length) {
      return false;
    }
  }

  // Cheap key test
  var i = 0;
  for (; i < aKeys.length; i++) {
    if (!hasOwnProperty(val2, aKeys[i])) {
      return false;
    }
  }
  if (strict && arguments.length === 5) {
    var symbolKeysA = objectGetOwnPropertySymbols(val1);
    if (symbolKeysA.length !== 0) {
      var count = 0;
      for (i = 0; i < symbolKeysA.length; i++) {
        var key = symbolKeysA[i];
        if (propertyIsEnumerable(val1, key)) {
          if (!propertyIsEnumerable(val2, key)) {
            return false;
          }
          aKeys.push(key);
          count++;
        } else if (propertyIsEnumerable(val2, key)) {
          return false;
        }
      }
      var symbolKeysB = objectGetOwnPropertySymbols(val2);
      if (symbolKeysA.length !== symbolKeysB.length && getEnumerables(val2, symbolKeysB).length !== count) {
        return false;
      }
    } else {
      var _symbolKeysB = objectGetOwnPropertySymbols(val2);
      if (_symbolKeysB.length !== 0 && getEnumerables(val2, _symbolKeysB).length !== 0) {
        return false;
      }
    }
  }
  if (aKeys.length === 0 && (iterationType === kNoIterator || iterationType === kIsArray && val1.length === 0 || val1.size === 0)) {
    return true;
  }

  // Use memos to handle cycles.
  if (memos === undefined) {
    memos = {
      val1: new Map(),
      val2: new Map(),
      position: 0
    };
  } else {
    // We prevent up to two map.has(x) calls by directly retrieving the value
    // and checking for undefined. The map can only contain numbers, so it is
    // safe to check for undefined only.
    var val2MemoA = memos.val1.get(val1);
    if (val2MemoA !== undefined) {
      var val2MemoB = memos.val2.get(val2);
      if (val2MemoB !== undefined) {
        return val2MemoA === val2MemoB;
      }
    }
    memos.position++;
  }
  memos.val1.set(val1, memos.position);
  memos.val2.set(val2, memos.position);
  var areEq = objEquiv(val1, val2, strict, aKeys, memos, iterationType);
  memos.val1.delete(val1);
  memos.val2.delete(val2);
  return areEq;
}
function setHasEqualElement(set, val1, strict, memo) {
  // Go looking.
  var setValues = arrayFromSet(set);
  for (var i = 0; i < setValues.length; i++) {
    var val2 = setValues[i];
    if (innerDeepEqual(val1, val2, strict, memo)) {
      // Remove the matching element to make sure we do not check that again.
      set.delete(val2);
      return true;
    }
  }
  return false;
}

// See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness#Loose_equality_using
// Sadly it is not possible to detect corresponding values properly in case the
// type is a string, number, bigint or boolean. The reason is that those values
// can match lots of different string values (e.g., 1n == '+00001').
function findLooseMatchingPrimitives(prim) {
  switch (_typeof(prim)) {
    case 'undefined':
      return null;
    case 'object':
      // Only pass in null as object!
      return undefined;
    case 'symbol':
      return false;
    case 'string':
      prim = +prim;
    // Loose equal entries exist only if the string is possible to convert to
    // a regular number and not NaN.
    // Fall through
    case 'number':
      if (numberIsNaN(prim)) {
        return false;
      }
  }
  return true;
}
function setMightHaveLoosePrim(a, b, prim) {
  var altValue = findLooseMatchingPrimitives(prim);
  if (altValue != null) return altValue;
  return b.has(altValue) && !a.has(altValue);
}
function mapMightHaveLoosePrim(a, b, prim, item, memo) {
  var altValue = findLooseMatchingPrimitives(prim);
  if (altValue != null) {
    return altValue;
  }
  var curB = b.get(altValue);
  if (curB === undefined && !b.has(altValue) || !innerDeepEqual(item, curB, false, memo)) {
    return false;
  }
  return !a.has(altValue) && innerDeepEqual(item, curB, false, memo);
}
function setEquiv(a, b, strict, memo) {
  // This is a lazily initiated Set of entries which have to be compared
  // pairwise.
  var set = null;
  var aValues = arrayFromSet(a);
  for (var i = 0; i < aValues.length; i++) {
    var val = aValues[i];
    // Note: Checking for the objects first improves the performance for object
    // heavy sets but it is a minor slow down for primitives. As they are fast
    // to check this improves the worst case scenario instead.
    if (_typeof(val) === 'object' && val !== null) {
      if (set === null) {
        set = new Set();
      }
      // If the specified value doesn't exist in the second set its an not null
      // object (or non strict only: a not matching primitive) we'll need to go
      // hunting for something thats deep-(strict-)equal to it. To make this
      // O(n log n) complexity we have to copy these values in a new set first.
      set.add(val);
    } else if (!b.has(val)) {
      if (strict) return false;

      // Fast path to detect missing string, symbol, undefined and null values.
      if (!setMightHaveLoosePrim(a, b, val)) {
        return false;
      }
      if (set === null) {
        set = new Set();
      }
      set.add(val);
    }
  }
  if (set !== null) {
    var bValues = arrayFromSet(b);
    for (var _i = 0; _i < bValues.length; _i++) {
      var _val = bValues[_i];
      // We have to check if a primitive value is already
      // matching and only if it's not, go hunting for it.
      if (_typeof(_val) === 'object' && _val !== null) {
        if (!setHasEqualElement(set, _val, strict, memo)) return false;
      } else if (!strict && !a.has(_val) && !setHasEqualElement(set, _val, strict, memo)) {
        return false;
      }
    }
    return set.size === 0;
  }
  return true;
}
function mapHasEqualEntry(set, map, key1, item1, strict, memo) {
  // To be able to handle cases like:
  //   Map([[{}, 'a'], [{}, 'b']]) vs Map([[{}, 'b'], [{}, 'a']])
  // ... we need to consider *all* matching keys, not just the first we find.
  var setValues = arrayFromSet(set);
  for (var i = 0; i < setValues.length; i++) {
    var key2 = setValues[i];
    if (innerDeepEqual(key1, key2, strict, memo) && innerDeepEqual(item1, map.get(key2), strict, memo)) {
      set.delete(key2);
      return true;
    }
  }
  return false;
}
function mapEquiv(a, b, strict, memo) {
  var set = null;
  var aEntries = arrayFromMap(a);
  for (var i = 0; i < aEntries.length; i++) {
    var _aEntries$i = _slicedToArray(aEntries[i], 2),
      key = _aEntries$i[0],
      item1 = _aEntries$i[1];
    if (_typeof(key) === 'object' && key !== null) {
      if (set === null) {
        set = new Set();
      }
      set.add(key);
    } else {
      // By directly retrieving the value we prevent another b.has(key) check in
      // almost all possible cases.
      var item2 = b.get(key);
      if (item2 === undefined && !b.has(key) || !innerDeepEqual(item1, item2, strict, memo)) {
        if (strict) return false;
        // Fast path to detect missing string, symbol, undefined and null
        // keys.
        if (!mapMightHaveLoosePrim(a, b, key, item1, memo)) return false;
        if (set === null) {
          set = new Set();
        }
        set.add(key);
      }
    }
  }
  if (set !== null) {
    var bEntries = arrayFromMap(b);
    for (var _i2 = 0; _i2 < bEntries.length; _i2++) {
      var _bEntries$_i = _slicedToArray(bEntries[_i2], 2),
        _key = _bEntries$_i[0],
        item = _bEntries$_i[1];
      if (_typeof(_key) === 'object' && _key !== null) {
        if (!mapHasEqualEntry(set, a, _key, item, strict, memo)) return false;
      } else if (!strict && (!a.has(_key) || !innerDeepEqual(a.get(_key), item, false, memo)) && !mapHasEqualEntry(set, a, _key, item, false, memo)) {
        return false;
      }
    }
    return set.size === 0;
  }
  return true;
}
function objEquiv(a, b, strict, keys, memos, iterationType) {
  // Sets and maps don't have their entries accessible via normal object
  // properties.
  var i = 0;
  if (iterationType === kIsSet) {
    if (!setEquiv(a, b, strict, memos)) {
      return false;
    }
  } else if (iterationType === kIsMap) {
    if (!mapEquiv(a, b, strict, memos)) {
      return false;
    }
  } else if (iterationType === kIsArray) {
    for (; i < a.length; i++) {
      if (hasOwnProperty(a, i)) {
        if (!hasOwnProperty(b, i) || !innerDeepEqual(a[i], b[i], strict, memos)) {
          return false;
        }
      } else if (hasOwnProperty(b, i)) {
        return false;
      } else {
        // Array is sparse.
        var keysA = Object.keys(a);
        for (; i < keysA.length; i++) {
          var key = keysA[i];
          if (!hasOwnProperty(b, key) || !innerDeepEqual(a[key], b[key], strict, memos)) {
            return false;
          }
        }
        if (keysA.length !== Object.keys(b).length) {
          return false;
        }
        return true;
      }
    }
  }

  // The pair must have equivalent values for every corresponding key.
  // Possibly expensive deep test:
  for (i = 0; i < keys.length; i++) {
    var _key2 = keys[i];
    if (!innerDeepEqual(a[_key2], b[_key2], strict, memos)) {
      return false;
    }
  }
  return true;
}
function isDeepEqual(val1, val2) {
  return innerDeepEqual(val1, val2, kLoose);
}
function isDeepStrictEqual(val1, val2) {
  return innerDeepEqual(val1, val2, kStrict);
}
module.exports = {
  isDeepEqual: isDeepEqual,
  isDeepStrictEqual: isDeepStrictEqual
};

/***/ }),

/***/ 93229:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   decode: function() { return /* binding */ decode; },
/* harmony export */   encode: function() { return /* binding */ encode; }
/* harmony export */ });
/*
 * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
 * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */
var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
// Use a lookup table to find the index.
var lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
for (var i = 0; i < chars.length; i++) {
    lookup[chars.charCodeAt(i)] = i;
}
var encode = function (arraybuffer) {
    var bytes = new Uint8Array(arraybuffer), i, len = bytes.length, base64 = '';
    for (i = 0; i < len; i += 3) {
        base64 += chars[bytes[i] >> 2];
        base64 += chars[((bytes[i] & 3) << 4) | (bytes[i + 1] >> 4)];
        base64 += chars[((bytes[i + 1] & 15) << 2) | (bytes[i + 2] >> 6)];
        base64 += chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) {
        base64 = base64.substring(0, base64.length - 1) + '=';
    }
    else if (len % 3 === 1) {
        base64 = base64.substring(0, base64.length - 2) + '==';
    }
    return base64;
};
var decode = function (base64) {
    var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
    if (base64[base64.length - 1] === '=') {
        bufferLength--;
        if (base64[base64.length - 2] === '=') {
            bufferLength--;
        }
    }
    var arraybuffer = new ArrayBuffer(bufferLength), bytes = new Uint8Array(arraybuffer);
    for (i = 0; i < len; i += 4) {
        encoded1 = lookup[base64.charCodeAt(i)];
        encoded2 = lookup[base64.charCodeAt(i + 1)];
        encoded3 = lookup[base64.charCodeAt(i + 2)];
        encoded4 = lookup[base64.charCodeAt(i + 3)];
        bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
        bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
        bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
    }
    return arraybuffer;
};


//# sourceMappingURL=base64-arraybuffer.es5.js.map


/***/ }),

/***/ 76226:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(
      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
    ))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ 31625:
/***/ (function(module) {

"use strict";


// (a, y, c, l, h) = (array, y[, cmp, lo, hi])

function ge(a, y, c, l, h) {
  var i = h + 1;
  while (l <= h) {
    var m = (l + h) >>> 1, x = a[m];
    var p = (c !== undefined) ? c(x, y) : (x - y);
    if (p >= 0) { i = m; h = m - 1 } else { l = m + 1 }
  }
  return i;
};

function gt(a, y, c, l, h) {
  var i = h + 1;
  while (l <= h) {
    var m = (l + h) >>> 1, x = a[m];
    var p = (c !== undefined) ? c(x, y) : (x - y);
    if (p > 0) { i = m; h = m - 1 } else { l = m + 1 }
  }
  return i;
};

function lt(a, y, c, l, h) {
  var i = l - 1;
  while (l <= h) {
    var m = (l + h) >>> 1, x = a[m];
    var p = (c !== undefined) ? c(x, y) : (x - y);
    if (p < 0) { i = m; l = m + 1 } else { h = m - 1 }
  }
  return i;
};

function le(a, y, c, l, h) {
  var i = l - 1;
  while (l <= h) {
    var m = (l + h) >>> 1, x = a[m];
    var p = (c !== undefined) ? c(x, y) : (x - y);
    if (p <= 0) { i = m; l = m + 1 } else { h = m - 1 }
  }
  return i;
};

function eq(a, y, c, l, h) {
  while (l <= h) {
    var m = (l + h) >>> 1, x = a[m];
    var p = (c !== undefined) ? c(x, y) : (x - y);
    if (p === 0) { return m }
    if (p <= 0) { l = m + 1 } else { h = m - 1 }
  }
  return -1;
};

function norm(a, y, c, l, h, f) {
  if (typeof c === 'function') {
    return f(a, y, c, (l === undefined) ? 0 : l | 0, (h === undefined) ? a.length - 1 : h | 0);
  }
  return f(a, y, undefined, (c === undefined) ? 0 : c | 0, (l === undefined) ? a.length - 1 : l | 0);
}

module.exports = {
  ge: function(a, y, c, l, h) { return norm(a, y, c, l, h, ge)},
  gt: function(a, y, c, l, h) { return norm(a, y, c, l, h, gt)},
  lt: function(a, y, c, l, h) { return norm(a, y, c, l, h, lt)},
  le: function(a, y, c, l, h) { return norm(a, y, c, l, h, le)},
  eq: function(a, y, c, l, h) { return norm(a, y, c, l, h, eq)}
}


/***/ }),

/***/ 54689:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/**
 * Bit twiddling hacks for JavaScript.
 *
 * Author: Mikola Lysenko
 *
 * Ported from Stanford bit twiddling hack library:
 *    http://graphics.stanford.edu/~seander/bithacks.html
 */

 "use restrict";

//Number of bits in an integer
var INT_BITS = 32;

//Constants
exports.INT_BITS  = INT_BITS;
exports.INT_MAX   =  0x7fffffff;
exports.INT_MIN   = -1<<(INT_BITS-1);

//Returns -1, 0, +1 depending on sign of x
exports.sign = function(v) {
  return (v > 0) - (v < 0);
}

//Computes absolute value of integer
exports.abs = function(v) {
  var mask = v >> (INT_BITS-1);
  return (v ^ mask) - mask;
}

//Computes minimum of integers x and y
exports.min = function(x, y) {
  return y ^ ((x ^ y) & -(x < y));
}

//Computes maximum of integers x and y
exports.max = function(x, y) {
  return x ^ ((x ^ y) & -(x < y));
}

//Checks if a number is a power of two
exports.isPow2 = function(v) {
  return !(v & (v-1)) && (!!v);
}

//Computes log base 2 of v
exports.log2 = function(v) {
  var r, shift;
  r =     (v > 0xFFFF) << 4; v >>>= r;
  shift = (v > 0xFF  ) << 3; v >>>= shift; r |= shift;
  shift = (v > 0xF   ) << 2; v >>>= shift; r |= shift;
  shift = (v > 0x3   ) << 1; v >>>= shift; r |= shift;
  return r | (v >> 1);
}

//Computes log base 10 of v
exports.log10 = function(v) {
  return  (v >= 1000000000) ? 9 : (v >= 100000000) ? 8 : (v >= 10000000) ? 7 :
          (v >= 1000000) ? 6 : (v >= 100000) ? 5 : (v >= 10000) ? 4 :
          (v >= 1000) ? 3 : (v >= 100) ? 2 : (v >= 10) ? 1 : 0;
}

//Counts number of bits
exports.popCount = function(v) {
  v = v - ((v >>> 1) & 0x55555555);
  v = (v & 0x33333333) + ((v >>> 2) & 0x33333333);
  return ((v + (v >>> 4) & 0xF0F0F0F) * 0x1010101) >>> 24;
}

//Counts number of trailing zeros
function countTrailingZeros(v) {
  var c = 32;
  v &= -v;
  if (v) c--;
  if (v & 0x0000FFFF) c -= 16;
  if (v & 0x00FF00FF) c -= 8;
  if (v & 0x0F0F0F0F) c -= 4;
  if (v & 0x33333333) c -= 2;
  if (v & 0x55555555) c -= 1;
  return c;
}
exports.countTrailingZeros = countTrailingZeros;

//Rounds to next power of 2
exports.nextPow2 = function(v) {
  v += v === 0;
  --v;
  v |= v >>> 1;
  v |= v >>> 2;
  v |= v >>> 4;
  v |= v >>> 8;
  v |= v >>> 16;
  return v + 1;
}

//Rounds down to previous power of 2
exports.prevPow2 = function(v) {
  v |= v >>> 1;
  v |= v >>> 2;
  v |= v >>> 4;
  v |= v >>> 8;
  v |= v >>> 16;
  return v - (v>>>1);
}

//Computes parity of word
exports.parity = function(v) {
  v ^= v >>> 16;
  v ^= v >>> 8;
  v ^= v >>> 4;
  v &= 0xf;
  return (0x6996 >>> v) & 1;
}

var REVERSE_TABLE = new Array(256);

(function(tab) {
  for(var i=0; i<256; ++i) {
    var v = i, r = i, s = 7;
    for (v >>>= 1; v; v >>>= 1) {
      r <<= 1;
      r |= v & 1;
      --s;
    }
    tab[i] = (r << s) & 0xff;
  }
})(REVERSE_TABLE);

//Reverse bits in a 32 bit word
exports.reverse = function(v) {
  return  (REVERSE_TABLE[ v         & 0xff] << 24) |
          (REVERSE_TABLE[(v >>> 8)  & 0xff] << 16) |
          (REVERSE_TABLE[(v >>> 16) & 0xff] << 8)  |
           REVERSE_TABLE[(v >>> 24) & 0xff];
}

//Interleave bits of 2 coordinates with 16 bits.  Useful for fast quadtree codes
exports.interleave2 = function(x, y) {
  x &= 0xFFFF;
  x = (x | (x << 8)) & 0x00FF00FF;
  x = (x | (x << 4)) & 0x0F0F0F0F;
  x = (x | (x << 2)) & 0x33333333;
  x = (x | (x << 1)) & 0x55555555;

  y &= 0xFFFF;
  y = (y | (y << 8)) & 0x00FF00FF;
  y = (y | (y << 4)) & 0x0F0F0F0F;
  y = (y | (y << 2)) & 0x33333333;
  y = (y | (y << 1)) & 0x55555555;

  return x | (y << 1);
}

//Extracts the nth interleaved component
exports.deinterleave2 = function(v, n) {
  v = (v >>> n) & 0x55555555;
  v = (v | (v >>> 1))  & 0x33333333;
  v = (v | (v >>> 2))  & 0x0F0F0F0F;
  v = (v | (v >>> 4))  & 0x00FF00FF;
  v = (v | (v >>> 16)) & 0x000FFFF;
  return (v << 16) >> 16;
}


//Interleave bits of 3 coordinates, each with 10 bits.  Useful for fast octree codes
exports.interleave3 = function(x, y, z) {
  x &= 0x3FF;
  x  = (x | (x<<16)) & 4278190335;
  x  = (x | (x<<8))  & 251719695;
  x  = (x | (x<<4))  & 3272356035;
  x  = (x | (x<<2))  & 1227133513;

  y &= 0x3FF;
  y  = (y | (y<<16)) & 4278190335;
  y  = (y | (y<<8))  & 251719695;
  y  = (y | (y<<4))  & 3272356035;
  y  = (y | (y<<2))  & 1227133513;
  x |= (y << 1);
  
  z &= 0x3FF;
  z  = (z | (z<<16)) & 4278190335;
  z  = (z | (z<<8))  & 251719695;
  z  = (z | (z<<4))  & 3272356035;
  z  = (z | (z<<2))  & 1227133513;
  
  return x | (z << 2);
}

//Extracts nth interleaved component of a 3-tuple
exports.deinterleave3 = function(v, n) {
  v = (v >>> n)       & 1227133513;
  v = (v | (v>>>2))   & 3272356035;
  v = (v | (v>>>4))   & 251719695;
  v = (v | (v>>>8))   & 4278190335;
  v = (v | (v>>>16))  & 0x3FF;
  return (v<<22)>>22;
}

//Computes next combination in colexicographic order (this is mistakenly called nextPermutation on the bit twiddling hacks page)
exports.nextCombination = function(v) {
  var t = v | (v - 1);
  return (t + 1) | (((~t & -~t) - 1) >>> (countTrailingZeros(v) + 1));
}



/***/ }),

/***/ 88772:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var clamp = __webpack_require__(75144)

module.exports = calcSDF

var INF = 1e20;

function calcSDF(src, options) {
    if (!options) options = {}

    var cutoff = options.cutoff == null ? 0.25 : options.cutoff
    var radius = options.radius == null ? 8 : options.radius
    var channel = options.channel || 0
    var w, h, size, data, intData, stride, ctx, canvas, imgData, i, l

    // handle image container
    if (ArrayBuffer.isView(src) || Array.isArray(src)) {
        if (!options.width || !options.height) throw Error('For raw data width and height should be provided by options')
        w = options.width, h = options.height
        data = src

        if (!options.stride) stride = Math.floor(src.length / w / h)
        else stride = options.stride
    }
    else {
        if (window.HTMLCanvasElement && src instanceof window.HTMLCanvasElement) {
            canvas = src
            ctx = canvas.getContext('2d')
            w = canvas.width, h = canvas.height
            imgData = ctx.getImageData(0, 0, w, h)
            data = imgData.data
            stride = 4
        }
        else if (window.CanvasRenderingContext2D && src instanceof window.CanvasRenderingContext2D) {
            canvas = src.canvas
            ctx = src
            w = canvas.width, h = canvas.height
            imgData = ctx.getImageData(0, 0, w, h)
            data = imgData.data
            stride = 4
        }
        else if (window.ImageData && src instanceof window.ImageData) {
            imgData = src
            w = src.width, h = src.height
            data = imgData.data
            stride = 4
        }
    }

    size = Math.max(w, h)

    //convert int data to floats
    if ((window.Uint8ClampedArray && data instanceof window.Uint8ClampedArray) || (window.Uint8Array && data instanceof window.Uint8Array)) {
        intData = data
        data = Array(w*h)

        for (i = 0, l = intData.length; i < l; i++) {
            data[i] = intData[i*stride + channel] / 255
        }
    }
    else {
        if (stride !== 1) throw Error('Raw data can have only 1 value per pixel')
    }

    // temporary arrays for the distance transform
    var gridOuter = Array(w * h)
    var gridInner = Array(w * h)
    var f = Array(size)
    var d = Array(size)
    var z = Array(size + 1)
    var v = Array(size)

    for (i = 0, l = w * h; i < l; i++) {
        var a = data[i]
        gridOuter[i] = a === 1 ? 0 : a === 0 ? INF : Math.pow(Math.max(0, 0.5 - a), 2)
        gridInner[i] = a === 1 ? INF : a === 0 ? 0 : Math.pow(Math.max(0, a - 0.5), 2)
    }

    edt(gridOuter, w, h, f, d, v, z)
    edt(gridInner, w, h, f, d, v, z)

    var dist = window.Float32Array ? new Float32Array(w * h) : new Array(w * h)

    for (i = 0, l = w*h; i < l; i++) {
        dist[i] = clamp(1 - ( (gridOuter[i] - gridInner[i]) / radius + cutoff), 0, 1)
    }

    return dist
}

// 2D Euclidean distance transform by Felzenszwalb & Huttenlocher https://cs.brown.edu/~pff/dt/
function edt(data, width, height, f, d, v, z) {
    for (var x = 0; x < width; x++) {
        for (var y = 0; y < height; y++) {
            f[y] = data[y * width + x]
        }
        edt1d(f, d, v, z, height)
        for (y = 0; y < height; y++) {
            data[y * width + x] = d[y]
        }
    }
    for (y = 0; y < height; y++) {
        for (x = 0; x < width; x++) {
            f[x] = data[y * width + x]
        }
        edt1d(f, d, v, z, width)
        for (x = 0; x < width; x++) {
            data[y * width + x] = Math.sqrt(d[x])
        }
    }
}

// 1D squared distance transform
function edt1d(f, d, v, z, n) {
    v[0] = 0;
    z[0] = -INF
    z[1] = +INF

    for (var q = 1, k = 0; q < n; q++) {
        var s = ((f[q] + q * q) - (f[v[k]] + v[k] * v[k])) / (2 * q - 2 * v[k])
        while (s <= z[k]) {
            k--
            s = ((f[q] + q * q) - (f[v[k]] + v[k] * v[k])) / (2 * q - 2 * v[k])
        }
        k++
        v[k] = q
        z[k] = s
        z[k + 1] = +INF
    }

    for (q = 0, k = 0; q < n; q++) {
        while (z[k + 1] < q) k++
        d[q] = (q - v[k]) * (q - v[k]) + f[v[k]]
    }
}


/***/ }),

/***/ 63063:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(71129);

var callBind = __webpack_require__(87227);

var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

module.exports = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};


/***/ }),

/***/ 87227:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(87547);
var GetIntrinsic = __webpack_require__(71129);
var setFunctionLength = __webpack_require__(73285);

var $TypeError = __webpack_require__(48631);
var $apply = GetIntrinsic('%Function.prototype.apply%');
var $call = GetIntrinsic('%Function.prototype.call%');
var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

var $defineProperty = __webpack_require__(40891);
var $max = GetIntrinsic('%Math.max%');

module.exports = function callBind(originalFunction) {
	if (typeof originalFunction !== 'function') {
		throw new $TypeError('a function is required');
	}
	var func = $reflectApply(bind, $call, arguments);
	return setFunctionLength(
		func,
		1 + $max(0, originalFunction.length - (arguments.length - 1)),
		true
	);
};

var applyBind = function applyBind() {
	return $reflectApply(bind, $apply, arguments);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}


/***/ }),

/***/ 75144:
/***/ (function(module) {

module.exports = clamp

function clamp(value, min, max) {
  return min < max
    ? (value < min ? min : value > max ? max : value)
    : (value < max ? max : value > min ? min : value)
}


/***/ }),

/***/ 46762:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/** @module  color-id */



var clamp = __webpack_require__(75144)

module.exports = toNumber
module.exports.to = toNumber
module.exports.from = fromNumber

function toNumber (rgba, normalized) {
	if(normalized == null) normalized = true

	var r = rgba[0], g = rgba[1], b = rgba[2], a = rgba[3]

	if (a == null) a = normalized ? 1 : 255

	if (normalized) {
		r *= 255
		g *= 255
		b *= 255
		a *= 255
	}

	r = clamp(r, 0, 255) & 0xFF
	g = clamp(g, 0, 255) & 0xFF
	b = clamp(b, 0, 255) & 0xFF
	a = clamp(a, 0, 255) & 0xFF

	//hi-order shift converts to -1, so we can't use <<24
	var n = (r * 0x01000000) + (g << 16) + (b << 8) + (a)

	return n
}

function fromNumber (n, normalized) {
	n = +n

	var r = n >>> 24
	var g = (n & 0x00ff0000) >>> 16
	var b = (n & 0x0000ff00) >>> 8
	var a = n & 0x000000ff

	if (normalized === false) return [r, g, b, a]

	return [r/255, g/255, b/255, a/255]
}


/***/ }),

/***/ 86040:
/***/ (function(module) {

"use strict";


module.exports = {
	"aliceblue": [240, 248, 255],
	"antiquewhite": [250, 235, 215],
	"aqua": [0, 255, 255],
	"aquamarine": [127, 255, 212],
	"azure": [240, 255, 255],
	"beige": [245, 245, 220],
	"bisque": [255, 228, 196],
	"black": [0, 0, 0],
	"blanchedalmond": [255, 235, 205],
	"blue": [0, 0, 255],
	"blueviolet": [138, 43, 226],
	"brown": [165, 42, 42],
	"burlywood": [222, 184, 135],
	"cadetblue": [95, 158, 160],
	"chartreuse": [127, 255, 0],
	"chocolate": [210, 105, 30],
	"coral": [255, 127, 80],
	"cornflowerblue": [100, 149, 237],
	"cornsilk": [255, 248, 220],
	"crimson": [220, 20, 60],
	"cyan": [0, 255, 255],
	"darkblue": [0, 0, 139],
	"darkcyan": [0, 139, 139],
	"darkgoldenrod": [184, 134, 11],
	"darkgray": [169, 169, 169],
	"darkgreen": [0, 100, 0],
	"darkgrey": [169, 169, 169],
	"darkkhaki": [189, 183, 107],
	"darkmagenta": [139, 0, 139],
	"darkolivegreen": [85, 107, 47],
	"darkorange": [255, 140, 0],
	"darkorchid": [153, 50, 204],
	"darkred": [139, 0, 0],
	"darksalmon": [233, 150, 122],
	"darkseagreen": [143, 188, 143],
	"darkslateblue": [72, 61, 139],
	"darkslategray": [47, 79, 79],
	"darkslategrey": [47, 79, 79],
	"darkturquoise": [0, 206, 209],
	"darkviolet": [148, 0, 211],
	"deeppink": [255, 20, 147],
	"deepskyblue": [0, 191, 255],
	"dimgray": [105, 105, 105],
	"dimgrey": [105, 105, 105],
	"dodgerblue": [30, 144, 255],
	"firebrick": [178, 34, 34],
	"floralwhite": [255, 250, 240],
	"forestgreen": [34, 139, 34],
	"fuchsia": [255, 0, 255],
	"gainsboro": [220, 220, 220],
	"ghostwhite": [248, 248, 255],
	"gold": [255, 215, 0],
	"goldenrod": [218, 165, 32],
	"gray": [128, 128, 128],
	"green": [0, 128, 0],
	"greenyellow": [173, 255, 47],
	"grey": [128, 128, 128],
	"honeydew": [240, 255, 240],
	"hotpink": [255, 105, 180],
	"indianred": [205, 92, 92],
	"indigo": [75, 0, 130],
	"ivory": [255, 255, 240],
	"khaki": [240, 230, 140],
	"lavender": [230, 230, 250],
	"lavenderblush": [255, 240, 245],
	"lawngreen": [124, 252, 0],
	"lemonchiffon": [255, 250, 205],
	"lightblue": [173, 216, 230],
	"lightcoral": [240, 128, 128],
	"lightcyan": [224, 255, 255],
	"lightgoldenrodyellow": [250, 250, 210],
	"lightgray": [211, 211, 211],
	"lightgreen": [144, 238, 144],
	"lightgrey": [211, 211, 211],
	"lightpink": [255, 182, 193],
	"lightsalmon": [255, 160, 122],
	"lightseagreen": [32, 178, 170],
	"lightskyblue": [135, 206, 250],
	"lightslategray": [119, 136, 153],
	"lightslategrey": [119, 136, 153],
	"lightsteelblue": [176, 196, 222],
	"lightyellow": [255, 255, 224],
	"lime": [0, 255, 0],
	"limegreen": [50, 205, 50],
	"linen": [250, 240, 230],
	"magenta": [255, 0, 255],
	"maroon": [128, 0, 0],
	"mediumaquamarine": [102, 205, 170],
	"mediumblue": [0, 0, 205],
	"mediumorchid": [186, 85, 211],
	"mediumpurple": [147, 112, 219],
	"mediumseagreen": [60, 179, 113],
	"mediumslateblue": [123, 104, 238],
	"mediumspringgreen": [0, 250, 154],
	"mediumturquoise": [72, 209, 204],
	"mediumvioletred": [199, 21, 133],
	"midnightblue": [25, 25, 112],
	"mintcream": [245, 255, 250],
	"mistyrose": [255, 228, 225],
	"moccasin": [255, 228, 181],
	"navajowhite": [255, 222, 173],
	"navy": [0, 0, 128],
	"oldlace": [253, 245, 230],
	"olive": [128, 128, 0],
	"olivedrab": [107, 142, 35],
	"orange": [255, 165, 0],
	"orangered": [255, 69, 0],
	"orchid": [218, 112, 214],
	"palegoldenrod": [238, 232, 170],
	"palegreen": [152, 251, 152],
	"paleturquoise": [175, 238, 238],
	"palevioletred": [219, 112, 147],
	"papayawhip": [255, 239, 213],
	"peachpuff": [255, 218, 185],
	"peru": [205, 133, 63],
	"pink": [255, 192, 203],
	"plum": [221, 160, 221],
	"powderblue": [176, 224, 230],
	"purple": [128, 0, 128],
	"rebeccapurple": [102, 51, 153],
	"red": [255, 0, 0],
	"rosybrown": [188, 143, 143],
	"royalblue": [65, 105, 225],
	"saddlebrown": [139, 69, 19],
	"salmon": [250, 128, 114],
	"sandybrown": [244, 164, 96],
	"seagreen": [46, 139, 87],
	"seashell": [255, 245, 238],
	"sienna": [160, 82, 45],
	"silver": [192, 192, 192],
	"skyblue": [135, 206, 235],
	"slateblue": [106, 90, 205],
	"slategray": [112, 128, 144],
	"slategrey": [112, 128, 144],
	"snow": [255, 250, 250],
	"springgreen": [0, 255, 127],
	"steelblue": [70, 130, 180],
	"tan": [210, 180, 140],
	"teal": [0, 128, 128],
	"thistle": [216, 191, 216],
	"tomato": [255, 99, 71],
	"turquoise": [64, 224, 208],
	"violet": [238, 130, 238],
	"wheat": [245, 222, 179],
	"white": [255, 255, 255],
	"whitesmoke": [245, 245, 245],
	"yellow": [255, 255, 0],
	"yellowgreen": [154, 205, 50]
};


/***/ }),

/***/ 162:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/** @module  color-normalize */



var rgba = __webpack_require__(16401)
var clamp = __webpack_require__(75144)
var dtype = __webpack_require__(10275)

module.exports = function normalize (color, type) {
	if (type === 'float' || !type) type = 'array'
	if (type === 'uint') type = 'uint8'
	if (type === 'uint_clamped') type = 'uint8_clamped'
	var Ctor = dtype(type)
	var output = new Ctor(4)

	var normalize = type !== 'uint8' && type !== 'uint8_clamped'

	// attempt to parse non-array arguments
	if (!color.length || typeof color === 'string') {
		color = rgba(color)
		color[0] /= 255
		color[1] /= 255
		color[2] /= 255
	}

	// 0, 1 are possible contradictory values for Arrays:
	// [1,1,1] input gives [1,1,1] output instead of [1/255,1/255,1/255], which may be collision if input is meant to be uint.
	// converting [1,1,1] to [1/255,1/255,1/255] in case of float input gives larger mistake since [1,1,1] float is frequent edge value, whereas [0,1,1], [1,1,1] etc. uint inputs are relatively rare
	if (isInt(color)) {
		output[0] = color[0]
		output[1] = color[1]
		output[2] = color[2]
		output[3] = color[3] != null ? color[3] : 255

		if (normalize) {
			output[0] /= 255
			output[1] /= 255
			output[2] /= 255
			output[3] /= 255
		}

		return output
	}

	if (!normalize) {
		output[0] = clamp(Math.floor(color[0] * 255), 0, 255)
		output[1] = clamp(Math.floor(color[1] * 255), 0, 255)
		output[2] = clamp(Math.floor(color[2] * 255), 0, 255)
		output[3] = color[3] == null ? 255 : clamp(Math.floor(color[3] * 255), 0, 255)
	} else {
		output[0] = color[0]
		output[1] = color[1]
		output[2] = color[2]
		output[3] = color[3] != null ? color[3] : 1
	}

	return output
}

function isInt(color) {
	if (color instanceof Uint8Array || color instanceof Uint8ClampedArray) return true

	if (Array.isArray(color) &&
		(color[0] > 1 || color[0] === 0) &&
		(color[1] > 1 || color[1] === 0) &&
		(color[2] > 1 || color[2] === 0) &&
		(!color[3] || color[3] > 1)
	) return true

	return false
}


/***/ }),

/***/ 16401:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/** @module  color-rgba */



var parse = __webpack_require__(10826)
var hsl = __webpack_require__(52132)
var clamp = __webpack_require__(75144)

module.exports = function rgba (color) {
	var values, i, l

	//attempt to parse non-array arguments
	var parsed = parse(color)

	if (!parsed.space) return []

	values = Array(3)
	values[0] = clamp(parsed.values[0], 0, 255)
	values[1] = clamp(parsed.values[1], 0, 255)
	values[2] = clamp(parsed.values[2], 0, 255)

	if (parsed.space[0] === 'h') {
		values = hsl.rgb(values)
	}

	values.push(clamp(parsed.alpha, 0, 1))

	return values
}


/***/ }),

/***/ 10826:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * @module color-parse
 */



var names = __webpack_require__(86040)

module.exports = parse

/**
 * Base hues
 * http://dev.w3.org/csswg/css-color/#typedef-named-hue
 */
//FIXME: use external hue detector
var baseHues = {
	red: 0,
	orange: 60,
	yellow: 120,
	green: 180,
	blue: 240,
	purple: 300
}

/**
 * Parse color from the string passed
 *
 * @return {Object} A space indicator `space`, an array `values` and `alpha`
 */
function parse(cstr) {
	var m, parts = [], alpha = 1, space

	if (typeof cstr === 'string') {
		cstr = cstr.toLowerCase();

		//keyword
		if (names[cstr]) {
			parts = names[cstr].slice()
			space = 'rgb'
		}

		//reserved words
		else if (cstr === 'transparent') {
			alpha = 0
			space = 'rgb'
			parts = [0, 0, 0]
		}

		//hex
		else if (/^#[A-Fa-f0-9]+$/.test(cstr)) {
			var base = cstr.slice(1)
			var size = base.length
			var isShort = size <= 4
			alpha = 1

			if (isShort) {
				parts = [
					parseInt(base[0] + base[0], 16),
					parseInt(base[1] + base[1], 16),
					parseInt(base[2] + base[2], 16)
				]
				if (size === 4) {
					alpha = parseInt(base[3] + base[3], 16) / 255
				}
			}
			else {
				parts = [
					parseInt(base[0] + base[1], 16),
					parseInt(base[2] + base[3], 16),
					parseInt(base[4] + base[5], 16)
				]
				if (size === 8) {
					alpha = parseInt(base[6] + base[7], 16) / 255
				}
			}

			if (!parts[0]) parts[0] = 0
			if (!parts[1]) parts[1] = 0
			if (!parts[2]) parts[2] = 0

			space = 'rgb'
		}

		//color space
		else if (m = /^((?:rgb|hs[lvb]|hwb|cmyk?|xy[zy]|gray|lab|lchu?v?|[ly]uv|lms)a?)\s*\(([^\)]*)\)/.exec(cstr)) {
			var name = m[1]
			var isRGB = name === 'rgb'
			var base = name.replace(/a$/, '')
			space = base
			var size = base === 'cmyk' ? 4 : base === 'gray' ? 1 : 3
			parts = m[2].trim()
				.split(/\s*[,\/]\s*|\s+/)
				.map(function (x, i) {
					//<percentage>
					if (/%$/.test(x)) {
						//alpha
						if (i === size) return parseFloat(x) / 100
						//rgb
						if (base === 'rgb') return parseFloat(x) * 255 / 100
						return parseFloat(x)
					}
					//hue
					else if (base[i] === 'h') {
						//<deg>
						if (/deg$/.test(x)) {
							return parseFloat(x)
						}
						//<base-hue>
						else if (baseHues[x] !== undefined) {
							return baseHues[x]
						}
					}
					return parseFloat(x)
				})

			if (name === base) parts.push(1)
			alpha = (isRGB) ? 1 : (parts[size] === undefined) ? 1 : parts[size]
			parts = parts.slice(0, size)
		}

		//named channels case
		else if (cstr.length > 10 && /[0-9](?:\s|\/)/.test(cstr)) {
			parts = cstr.match(/([0-9]+)/g).map(function (value) {
				return parseFloat(value)
			})

			space = cstr.match(/([a-z])/ig).join('').toLowerCase()
		}
	}

	//numeric case
	else if (!isNaN(cstr)) {
		space = 'rgb'
		parts = [cstr >>> 16, (cstr & 0x00ff00) >>> 8, cstr & 0x0000ff]
	}

	//array-like
	else if (Array.isArray(cstr) || cstr.length) {
		parts = [cstr[0], cstr[1], cstr[2]]
		space = 'rgb'
		alpha = cstr.length === 4 ? cstr[3] : 1
	}

	//object case - detects css cases of rgb and hsl
	else if (cstr instanceof Object) {
		if (cstr.r != null || cstr.red != null || cstr.R != null) {
			space = 'rgb'
			parts = [
				cstr.r || cstr.red || cstr.R || 0,
				cstr.g || cstr.green || cstr.G || 0,
				cstr.b || cstr.blue || cstr.B || 0
			]
		}
		else {
			space = 'hsl'
			parts = [
				cstr.h || cstr.hue || cstr.H || 0,
				cstr.s || cstr.saturation || cstr.S || 0,
				cstr.l || cstr.lightness || cstr.L || cstr.b || cstr.brightness
			]
		}

		alpha = cstr.a || cstr.alpha || cstr.opacity || 1

		if (cstr.opacity != null) alpha /= 100
	}

	return {
		space: space,
		values: parts,
		alpha: alpha
	}
}


/***/ }),

/***/ 52132:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * @module color-space/hsl
 */


var rgb = __webpack_require__(10520);

module.exports = {
	name: 'hsl',
	min: [0,0,0],
	max: [360,100,100],
	channel: ['hue', 'saturation', 'lightness'],
	alias: ['HSL'],

	rgb: function(hsl) {
		var h = hsl[0] / 360,
				s = hsl[1] / 100,
				l = hsl[2] / 100,
				t1, t2, t3, rgb, val;

		if (s === 0) {
			val = l * 255;
			return [val, val, val];
		}

		if (l < 0.5) {
			t2 = l * (1 + s);
		}
		else {
			t2 = l + s - l * s;
		}
		t1 = 2 * l - t2;

		rgb = [0, 0, 0];
		for (var i = 0; i < 3; i++) {
			t3 = h + 1 / 3 * - (i - 1);
			if (t3 < 0) {
				t3++;
			}
			else if (t3 > 1) {
				t3--;
			}

			if (6 * t3 < 1) {
				val = t1 + (t2 - t1) * 6 * t3;
			}
			else if (2 * t3 < 1) {
				val = t2;
			}
			else if (3 * t3 < 2) {
				val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
			}
			else {
				val = t1;
			}

			rgb[i] = val * 255;
		}

		return rgb;
	}
};


//extend rgb
rgb.hsl = function(rgb) {
	var r = rgb[0]/255,
			g = rgb[1]/255,
			b = rgb[2]/255,
			min = Math.min(r, g, b),
			max = Math.max(r, g, b),
			delta = max - min,
			h, s, l;

	if (max === min) {
		h = 0;
	}
	else if (r === max) {
		h = (g - b) / delta;
	}
	else if (g === max) {
		h = 2 + (b - r) / delta;
	}
	else if (b === max) {
		h = 4 + (r - g)/ delta;
	}

	h = Math.min(h * 60, 360);

	if (h < 0) {
		h += 360;
	}

	l = (min + max) / 2;

	if (max === min) {
		s = 0;
	}
	else if (l <= 0.5) {
		s = delta / (max + min);
	}
	else {
		s = delta / (2 - max - min);
	}

	return [h, s * 100, l * 100];
};


/***/ }),

/***/ 10520:
/***/ (function(module) {

"use strict";
/**
 * RGB space.
 *
 * @module  color-space/rgb
 */


module.exports = {
	name: 'rgb',
	min: [0,0,0],
	max: [255,255,255],
	channel: ['red', 'green', 'blue'],
	alias: ['RGB']
};


/***/ }),

/***/ 78171:
/***/ (function(module) {

module.exports = {
  AFG: 'afghan',
  ALA: '\\b\\wland',
  ALB: 'albania',
  DZA: 'algeria',
  ASM: '^(?=.*americ).*samoa',
  AND: 'andorra',
  AGO: 'angola',
  AIA: 'anguill?a',
  ATA: 'antarctica',
  ATG: 'antigua',
  ARG: 'argentin',
  ARM: 'armenia',
  ABW: '^(?!.*bonaire).*\\baruba',
  AUS: 'australia',
  AUT: '^(?!.*hungary).*austria|\\baustri.*\\bemp',
  AZE: 'azerbaijan',
  BHS: 'bahamas',
  BHR: 'bahrain',
  BGD: 'bangladesh|^(?=.*east).*paki?stan',
  BRB: 'barbados',
  BLR: 'belarus|byelo',
  BEL: '^(?!.*luxem).*belgium',
  BLZ: 'belize|^(?=.*british).*honduras',
  BEN: 'benin|dahome',
  BMU: 'bermuda',
  BTN: 'bhutan',
  BOL: 'bolivia',
  BES: '^(?=.*bonaire).*eustatius|^(?=.*carib).*netherlands|\\bbes.?islands',
  BIH: 'herzegovina|bosnia',
  BWA: 'botswana|bechuana',
  BVT: 'bouvet',
  BRA: 'brazil',
  IOT: 'british.?indian.?ocean',
  BRN: 'brunei',
  BGR: 'bulgaria',
  BFA: 'burkina|\\bfaso|upper.?volta',
  BDI: 'burundi',
  CPV: 'verde',
  KHM: 'cambodia|kampuchea|khmer',
  CMR: 'cameroon',
  CAN: 'canada',
  CYM: 'cayman',
  CAF: '\\bcentral.african.republic',
  TCD: '\\bchad',
  CHL: '\\bchile',
  CHN: '^(?!.*\\bmac)(?!.*\\bhong)(?!.*\\btai)(?!.*\\brep).*china|^(?=.*peo)(?=.*rep).*china',
  CXR: 'christmas',
  CCK: '\\bcocos|keeling',
  COL: 'colombia',
  COM: 'comoro',
  COG: '^(?!.*\\bdem)(?!.*\\bd[\\.]?r)(?!.*kinshasa)(?!.*zaire)(?!.*belg)(?!.*l.opoldville)(?!.*free).*\\bcongo',
  COK: '\\bcook',
  CRI: 'costa.?rica',
  CIV: 'ivoire|ivory',
  HRV: 'croatia',
  CUB: '\\bcuba',
  CUW: '^(?!.*bonaire).*\\bcura(c|ç)ao',
  CYP: 'cyprus',
  CSK: 'czechoslovakia',
  CZE: '^(?=.*rep).*czech|czechia|bohemia',
  COD: '\\bdem.*congo|congo.*\\bdem|congo.*\\bd[\\.]?r|\\bd[\\.]?r.*congo|belgian.?congo|congo.?free.?state|kinshasa|zaire|l.opoldville|drc|droc|rdc',
  DNK: 'denmark',
  DJI: 'djibouti',
  DMA: 'dominica(?!n)',
  DOM: 'dominican.rep',
  ECU: 'ecuador',
  EGY: 'egypt',
  SLV: 'el.?salvador',
  GNQ: 'guine.*eq|eq.*guine|^(?=.*span).*guinea',
  ERI: 'eritrea',
  EST: 'estonia',
  ETH: 'ethiopia|abyssinia',
  FLK: 'falkland|malvinas',
  FRO: 'faroe|faeroe',
  FJI: 'fiji',
  FIN: 'finland',
  FRA: '^(?!.*\\bdep)(?!.*martinique).*france|french.?republic|\\bgaul',
  GUF: '^(?=.*french).*guiana',
  PYF: 'french.?polynesia|tahiti',
  ATF: 'french.?southern',
  GAB: 'gabon',
  GMB: 'gambia',
  GEO: '^(?!.*south).*georgia',
  DDR: 'german.?democratic.?republic|democratic.?republic.*germany|east.germany',
  DEU: '^(?!.*east).*germany|^(?=.*\\bfed.*\\brep).*german',
  GHA: 'ghana|gold.?coast',
  GIB: 'gibraltar',
  GRC: 'greece|hellenic|hellas',
  GRL: 'greenland',
  GRD: 'grenada',
  GLP: 'guadeloupe',
  GUM: '\\bguam',
  GTM: 'guatemala',
  GGY: 'guernsey',
  GIN: '^(?!.*eq)(?!.*span)(?!.*bissau)(?!.*portu)(?!.*new).*guinea',
  GNB: 'bissau|^(?=.*portu).*guinea',
  GUY: 'guyana|british.?guiana',
  HTI: 'haiti',
  HMD: 'heard.*mcdonald',
  VAT: 'holy.?see|vatican|papal.?st',
  HND: '^(?!.*brit).*honduras',
  HKG: 'hong.?kong',
  HUN: '^(?!.*austr).*hungary',
  ISL: 'iceland',
  IND: 'india(?!.*ocea)',
  IDN: 'indonesia',
  IRN: '\\biran|persia',
  IRQ: '\\biraq|mesopotamia',
  IRL: '(^ireland)|(^republic.*ireland)',
  IMN: '^(?=.*isle).*\\bman',
  ISR: 'israel',
  ITA: 'italy',
  JAM: 'jamaica',
  JPN: 'japan',
  JEY: 'jersey',
  JOR: 'jordan',
  KAZ: 'kazak',
  KEN: 'kenya|british.?east.?africa|east.?africa.?prot',
  KIR: 'kiribati',
  PRK: '^(?=.*democrat|people|north|d.*p.*.r).*\\bkorea|dprk|korea.*(d.*p.*r)',
  KWT: 'kuwait',
  KGZ: 'kyrgyz|kirghiz',
  LAO: '\\blaos?\\b',
  LVA: 'latvia',
  LBN: 'lebanon',
  LSO: 'lesotho|basuto',
  LBR: 'liberia',
  LBY: 'libya',
  LIE: 'liechtenstein',
  LTU: 'lithuania',
  LUX: '^(?!.*belg).*luxem',
  MAC: 'maca(o|u)',
  MDG: 'madagascar|malagasy',
  MWI: 'malawi|nyasa',
  MYS: 'malaysia',
  MDV: 'maldive',
  MLI: '\\bmali\\b',
  MLT: '\\bmalta',
  MHL: 'marshall',
  MTQ: 'martinique',
  MRT: 'mauritania',
  MUS: 'mauritius',
  MYT: '\\bmayotte',
  MEX: '\\bmexic',
  FSM: 'fed.*micronesia|micronesia.*fed',
  MCO: 'monaco',
  MNG: 'mongolia',
  MNE: '^(?!.*serbia).*montenegro',
  MSR: 'montserrat',
  MAR: 'morocco|\\bmaroc',
  MOZ: 'mozambique',
  MMR: 'myanmar|burma',
  NAM: 'namibia',
  NRU: 'nauru',
  NPL: 'nepal',
  NLD: '^(?!.*\\bant)(?!.*\\bcarib).*netherlands',
  ANT: '^(?=.*\\bant).*(nether|dutch)',
  NCL: 'new.?caledonia',
  NZL: 'new.?zealand',
  NIC: 'nicaragua',
  NER: '\\bniger(?!ia)',
  NGA: 'nigeria',
  NIU: 'niue',
  NFK: 'norfolk',
  MNP: 'mariana',
  NOR: 'norway',
  OMN: '\\boman|trucial',
  PAK: '^(?!.*east).*paki?stan',
  PLW: 'palau',
  PSE: 'palestin|\\bgaza|west.?bank',
  PAN: 'panama',
  PNG: 'papua|new.?guinea',
  PRY: 'paraguay',
  PER: 'peru',
  PHL: 'philippines',
  PCN: 'pitcairn',
  POL: 'poland',
  PRT: 'portugal',
  PRI: 'puerto.?rico',
  QAT: 'qatar',
  KOR: '^(?!.*d.*p.*r)(?!.*democrat)(?!.*people)(?!.*north).*\\bkorea(?!.*d.*p.*r)',
  MDA: 'moldov|b(a|e)ssarabia',
  REU: 'r(e|é)union',
  ROU: 'r(o|u|ou)mania',
  RUS: '\\brussia|soviet.?union|u\\.?s\\.?s\\.?r|socialist.?republics',
  RWA: 'rwanda',
  BLM: 'barth(e|é)lemy',
  SHN: 'helena',
  KNA: 'kitts|\\bnevis',
  LCA: '\\blucia',
  MAF: '^(?=.*collectivity).*martin|^(?=.*france).*martin(?!ique)|^(?=.*french).*martin(?!ique)',
  SPM: 'miquelon',
  VCT: 'vincent',
  WSM: '^(?!.*amer).*samoa',
  SMR: 'san.?marino',
  STP: '\\bs(a|ã)o.?tom(e|é)',
  SAU: '\\bsa\\w*.?arabia',
  SEN: 'senegal',
  SRB: '^(?!.*monte).*serbia',
  SYC: 'seychell',
  SLE: 'sierra',
  SGP: 'singapore',
  SXM: '^(?!.*martin)(?!.*saba).*maarten',
  SVK: '^(?!.*cze).*slovak',
  SVN: 'slovenia',
  SLB: 'solomon',
  SOM: 'somali',
  ZAF: 'south.africa|s\\\\..?africa',
  SGS: 'south.?georgia|sandwich',
  SSD: '\\bs\\w*.?sudan',
  ESP: 'spain',
  LKA: 'sri.?lanka|ceylon',
  SDN: '^(?!.*\\bs(?!u)).*sudan',
  SUR: 'surinam|dutch.?guiana',
  SJM: 'svalbard',
  SWZ: 'swaziland',
  SWE: 'sweden',
  CHE: 'switz|swiss',
  SYR: 'syria',
  TWN: 'taiwan|taipei|formosa|^(?!.*peo)(?=.*rep).*china',
  TJK: 'tajik',
  THA: 'thailand|\\bsiam',
  MKD: 'macedonia|fyrom',
  TLS: '^(?=.*leste).*timor|^(?=.*east).*timor',
  TGO: 'togo',
  TKL: 'tokelau',
  TON: 'tonga',
  TTO: 'trinidad|tobago',
  TUN: 'tunisia',
  TUR: 'turkey',
  TKM: 'turkmen',
  TCA: 'turks',
  TUV: 'tuvalu',
  UGA: 'uganda',
  UKR: 'ukrain',
  ARE: 'emirates|^u\\.?a\\.?e\\.?$|united.?arab.?em',
  GBR: 'united.?kingdom|britain|^u\\.?k\\.?$',
  TZA: 'tanzania',
  USA: 'united.?states\\b(?!.*islands)|\\bu\\.?s\\.?a\\.?\\b|^\\s*u\\.?s\\.?\\b(?!.*islands)',
  UMI: 'minor.?outlying.?is',
  URY: 'uruguay',
  UZB: 'uzbek',
  VUT: 'vanuatu|new.?hebrides',
  VEN: 'venezuela',
  VNM: '^(?!.*republic).*viet.?nam|^(?=.*socialist).*viet.?nam',
  VGB: '^(?=.*\\bu\\.?\\s?k).*virgin|^(?=.*brit).*virgin|^(?=.*kingdom).*virgin',
  VIR: '^(?=.*\\bu\\.?\\s?s).*virgin|^(?=.*states).*virgin',
  WLF: 'futuna|wallis',
  ESH: 'western.sahara',
  YEM: '^(?!.*arab)(?!.*north)(?!.*sana)(?!.*peo)(?!.*dem)(?!.*south)(?!.*aden)(?!.*\\bp\\.?d\\.?r).*yemen',
  YMD: '^(?=.*peo).*yemen|^(?!.*rep)(?=.*dem).*yemen|^(?=.*south).*yemen|^(?=.*aden).*yemen|^(?=.*\\bp\\.?d\\.?r).*yemen',
  YUG: 'yugoslavia',
  ZMB: 'zambia|northern.?rhodesia',
  EAZ: 'zanzibar',
  ZWE: 'zimbabwe|^(?!.*northern).*rhodesia'
}


/***/ }),

/***/ 59518:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
﻿

module.exports = {
	parse: __webpack_require__(86029),
	stringify: __webpack_require__(38211)
}


/***/ }),

/***/ 87724:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var sizes = __webpack_require__(23648)

module.exports = {
	isSize: function isSize(value) {
		return /^[\d\.]/.test(value)
			|| value.indexOf('/') !== -1
			|| sizes.indexOf(value) !== -1
	}
}


/***/ }),

/***/ 86029:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var unquote = __webpack_require__(80886)
var globalKeywords = __webpack_require__(54324)
var systemFontKeywords = __webpack_require__(94316)
var fontWeightKeywords = __webpack_require__(99803)
var fontStyleKeywords = __webpack_require__(87486)
var fontStretchKeywords = __webpack_require__(2362)
var splitBy = __webpack_require__(28089)
var isSize = (__webpack_require__(87724).isSize)


module.exports = parseFont


var cache = parseFont.cache = {}


function parseFont (value) {
	if (typeof value !== 'string') throw new Error('Font argument must be a string.')

	if (cache[value]) return cache[value]

	if (value === '') {
		throw new Error('Cannot parse an empty string.')
	}

	if (systemFontKeywords.indexOf(value) !== -1) {
		return cache[value] = {system: value}
	}

	var font = {
		style: 'normal',
		variant: 'normal',
		weight: 'normal',
		stretch: 'normal',
		lineHeight: 'normal',
		size: '1rem',
		family: ['serif']
	}

	var tokens = splitBy(value, /\s+/)
	var token

	while (token = tokens.shift()) {
		if (globalKeywords.indexOf(token) !== -1) {
			['style', 'variant', 'weight', 'stretch'].forEach(function(prop) {
				font[prop] = token
			})

			return cache[value] = font
		}

		if (fontStyleKeywords.indexOf(token) !== -1) {
			font.style = token
			continue
		}

		if (token === 'normal' || token === 'small-caps') {
			font.variant = token
			continue
		}

		if (fontStretchKeywords.indexOf(token) !== -1) {
			font.stretch = token
			continue
		}

		if (fontWeightKeywords.indexOf(token) !== -1) {
			font.weight = token
			continue
		}


		if (isSize(token)) {
			var parts = splitBy(token, '/')
			font.size = parts[0]
			if (parts[1] != null) {
				font.lineHeight = parseLineHeight(parts[1])
			}
			else if (tokens[0] === '/') {
				tokens.shift()
				font.lineHeight = parseLineHeight(tokens.shift())
 			}

			if (!tokens.length) {
				throw new Error('Missing required font-family.')
			}
			font.family = splitBy(tokens.join(' '), /\s*,\s*/).map(unquote)

			return cache[value] = font
		}

		throw new Error('Unknown or unsupported font token: ' + token)
	}

	throw new Error('Missing required font-size.')
}


function parseLineHeight(value) {
	var parsed = parseFloat(value)
	if (parsed.toString() === value) {
		return parsed
	}
	return value
}


/***/ }),

/***/ 38211:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var pick = __webpack_require__(6807)
var isSize = (__webpack_require__(87724).isSize)

var globals = a2o(__webpack_require__(54324))
var systems = a2o(__webpack_require__(94316))
var weights = a2o(__webpack_require__(99803))
var styles = a2o(__webpack_require__(87486))
var stretches = a2o(__webpack_require__(2362))

var variants = {'normal': 1, 'small-caps': 1}
var fams = {
	'serif': 1,
	'sans-serif': 1,
	'monospace': 1,
	'cursive': 1,
	'fantasy': 1,
	'system-ui': 1
}

var defaults = {
	style: 'normal',
	variant: 'normal',
	weight: 'normal',
	stretch: 'normal',
	size: '1rem',
	lineHeight: 'normal',
	family: 'serif'
}

module.exports = function stringifyFont (o) {
	o = pick(o, {
		style: 'style fontstyle fontStyle font-style slope distinction',
		variant: 'variant font-variant fontVariant fontvariant var capitalization',
		weight: 'weight w font-weight fontWeight fontweight',
		stretch: 'stretch font-stretch fontStretch fontstretch width',
		size: 'size s font-size fontSize fontsize height em emSize',
		lineHeight: 'lh line-height lineHeight lineheight leading',
		family: 'font family fontFamily font-family fontfamily type typeface face',
		system: 'system reserved default global',
	})

	if (o.system) {
		if (o.system) verify(o.system, systems)
		return o.system
	}

	verify(o.style, styles)
	verify(o.variant, variants)
	verify(o.weight, weights)
	verify(o.stretch, stretches)

	// default root value is medium, but by default it's inherited
	if (o.size == null) o.size = defaults.size
	if (typeof o.size === 'number') o.size += 'px'

	if (!isSize) throw Error('Bad size value `' + o.size + '`')

	// many user-agents use serif, we don't detect that for consistency
	if (!o.family) o.family = defaults.family
	if (Array.isArray(o.family)) {
		if (!o.family.length) o.family = [defaults.family]
		o.family = o.family.map(function (f) {
			return fams[f] ? f : '"' + f + '"'
		}).join(', ')
	}

	// [ [ <'font-style'> || <font-variant-css21> || <'font-weight'> || <'font-stretch'> ]? <'font-size'> [ / <'line-height'> ]? <'font-family'> ]
	var result = []

	result.push(o.style)
	if (o.variant !== o.style) result.push(o.variant)

	if (o.weight !== o.variant &&
		o.weight !== o.style) result.push(o.weight)

	if (o.stretch !== o.weight &&
		o.stretch !== o.variant &&
		o.stretch !== o.style) result.push(o.stretch)

	result.push(o.size + (o.lineHeight == null || o.lineHeight === 'normal' || (o.lineHeight + '' === '1')  ? '' : ('/' + o.lineHeight)))
	result.push(o.family)

	return result.filter(Boolean).join(' ')
}

function verify (value, values) {
	if (value && !values[value] && !globals[value]) throw Error('Unknown keyword `' + value +'`')

	return value
}


// ['a', 'b'] -> {a: true, b: true}
function a2o (a) {
	var o = {}
	for (var i = 0; i < a.length; i++) {
		o[a[i]] = 1
	}
	return o
}


/***/ }),

/***/ 51070:
/***/ (function(module) {

"use strict";


/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/
module.exports = function (cssWithMappingToString) {
  var list = [];

  // return the list of modules as css string
  list.toString = function toString() {
    return this.map(function (item) {
      var content = "";
      var needLayer = typeof item[5] !== "undefined";
      if (item[4]) {
        content += "@supports (".concat(item[4], ") {");
      }
      if (item[2]) {
        content += "@media ".concat(item[2], " {");
      }
      if (needLayer) {
        content += "@layer".concat(item[5].length > 0 ? " ".concat(item[5]) : "", " {");
      }
      content += cssWithMappingToString(item);
      if (needLayer) {
        content += "}";
      }
      if (item[2]) {
        content += "}";
      }
      if (item[4]) {
        content += "}";
      }
      return content;
    }).join("");
  };

  // import a list of modules into the list
  list.i = function i(modules, media, dedupe, supports, layer) {
    if (typeof modules === "string") {
      modules = [[null, modules, undefined]];
    }
    var alreadyImportedModules = {};
    if (dedupe) {
      for (var k = 0; k < this.length; k++) {
        var id = this[k][0];
        if (id != null) {
          alreadyImportedModules[id] = true;
        }
      }
    }
    for (var _k = 0; _k < modules.length; _k++) {
      var item = [].concat(modules[_k]);
      if (dedupe && alreadyImportedModules[item[0]]) {
        continue;
      }
      if (typeof layer !== "undefined") {
        if (typeof item[5] === "undefined") {
          item[5] = layer;
        } else {
          item[1] = "@layer".concat(item[5].length > 0 ? " ".concat(item[5]) : "", " {").concat(item[1], "}");
          item[5] = layer;
        }
      }
      if (media) {
        if (!item[2]) {
          item[2] = media;
        } else {
          item[1] = "@media ".concat(item[2], " {").concat(item[1], "}");
          item[2] = media;
        }
      }
      if (supports) {
        if (!item[4]) {
          item[4] = "".concat(supports);
        } else {
          item[1] = "@supports (".concat(item[4], ") {").concat(item[1], "}");
          item[4] = supports;
        }
      }
      list.push(item);
    }
  };
  return list;
};

/***/ }),

/***/ 62133:
/***/ (function(module) {

"use strict";


module.exports = function (url, options) {
  if (!options) {
    options = {};
  }
  if (!url) {
    return url;
  }
  url = String(url.__esModule ? url.default : url);

  // If url is already wrapped in quotes, remove them
  if (/^['"].*['"]$/.test(url)) {
    url = url.slice(1, -1);
  }
  if (options.hash) {
    url += options.hash;
  }

  // Should url be wrapped?
  // See https://drafts.csswg.org/css-values-3/#urls
  if (/["'() \t\n]|(%20)/.test(url) || options.needQuotes) {
    return "\"".concat(url.replace(/"/g, '\\"').replace(/\n/g, "\\n"), "\"");
  }
  return url;
};

/***/ }),

/***/ 22413:
/***/ (function(module) {

"use strict";


module.exports = function (i) {
  return i[1];
};

/***/ }),

/***/ 84510:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isValue             = __webpack_require__(80299)
  , ensureValue         = __webpack_require__(9557)
  , ensurePlainFunction = __webpack_require__(6887)
  , copy                = __webpack_require__(86591)
  , normalizeOptions    = __webpack_require__(76504)
  , map                 = __webpack_require__(29854);

var bind = Function.prototype.bind
  , defineProperty = Object.defineProperty
  , hasOwnProperty = Object.prototype.hasOwnProperty
  , define;

define = function (name, desc, options) {
	var value = ensureValue(desc) && ensurePlainFunction(desc.value), dgs;
	dgs = copy(desc);
	delete dgs.writable;
	delete dgs.value;
	dgs.get = function () {
		if (!options.overwriteDefinition && hasOwnProperty.call(this, name)) return value;
		desc.value = bind.call(value, options.resolveContext ? options.resolveContext(this) : this);
		defineProperty(this, name, desc);
		return this[name];
	};
	return dgs;
};

module.exports = function (props/*, options*/) {
	var options = normalizeOptions(arguments[1]);
	if (isValue(options.resolveContext)) ensurePlainFunction(options.resolveContext);
	return map(props, function (desc, name) { return define(name, desc, options); });
};


/***/ }),

/***/ 91819:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isValue         = __webpack_require__(80299)
  , isPlainFunction = __webpack_require__(63461)
  , assign          = __webpack_require__(1920)
  , normalizeOpts   = __webpack_require__(76504)
  , contains        = __webpack_require__(2338);

var d = (module.exports = function (dscr, value/*, options*/) {
	var c, e, w, options, desc;
	if (arguments.length < 2 || typeof dscr !== "string") {
		options = value;
		value = dscr;
		dscr = null;
	} else {
		options = arguments[2];
	}
	if (isValue(dscr)) {
		c = contains.call(dscr, "c");
		e = contains.call(dscr, "e");
		w = contains.call(dscr, "w");
	} else {
		c = w = true;
		e = false;
	}

	desc = { value: value, configurable: c, enumerable: e, writable: w };
	return !options ? desc : assign(normalizeOpts(options), desc);
});

d.gs = function (dscr, get, set/*, options*/) {
	var c, e, options, desc;
	if (typeof dscr !== "string") {
		options = set;
		set = get;
		get = dscr;
		dscr = null;
	} else {
		options = arguments[3];
	}
	if (!isValue(get)) {
		get = undefined;
	} else if (!isPlainFunction(get)) {
		options = get;
		get = set = undefined;
	} else if (!isValue(set)) {
		set = undefined;
	} else if (!isPlainFunction(set)) {
		options = set;
		set = undefined;
	}
	if (isValue(dscr)) {
		c = contains.call(dscr, "c");
		e = contains.call(dscr, "e");
	} else {
		c = true;
		e = false;
	}

	desc = { get: get, set: set, configurable: c, enumerable: e };
	return !options ? desc : assign(normalizeOpts(options), desc);
};


/***/ }),

/***/ 29725:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  V_: function() { return /* reexport */ src_ascending; },
  T9: function() { return /* reexport */ max; },
  i2: function() { return /* reexport */ mean; },
  Am: function() { return /* reexport */ merge; },
  jk: function() { return /* reexport */ min; },
  y1: function() { return /* reexport */ src_range; },
  cz: function() { return /* reexport */ sum; }
});

// UNUSED EXPORTS: bisect, bisectLeft, bisectRight, bisector, cross, descending, deviation, extent, histogram, median, pairs, permute, quantile, scan, shuffle, thresholdFreedmanDiaconis, thresholdScott, thresholdSturges, tickIncrement, tickStep, ticks, transpose, variance, zip

;// CONCATENATED MODULE: ./node_modules/d3-array/src/ascending.js
/* harmony default export */ function src_ascending(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

;// CONCATENATED MODULE: ./node_modules/d3-array/src/bisector.js


/* harmony default export */ function bisector(compare) {
  if (compare.length === 1) compare = ascendingComparator(compare);
  return {
    left: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) < 0) lo = mid + 1;
        else hi = mid;
      }
      return lo;
    },
    right: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) > 0) hi = mid;
        else lo = mid + 1;
      }
      return lo;
    }
  };
}

function ascendingComparator(f) {
  return function(d, x) {
    return src_ascending(f(d), x);
  };
}

;// CONCATENATED MODULE: ./node_modules/d3-array/src/bisect.js



var ascendingBisect = bisector(src_ascending);
var bisectRight = ascendingBisect.right;
var bisectLeft = ascendingBisect.left;
/* harmony default export */ var src_bisect = ((/* unused pure expression or super */ null && (bisectRight)));

;// CONCATENATED MODULE: ./node_modules/d3-array/src/array.js
var array = Array.prototype;

var array_slice = array.slice;
var array_map = array.map;

;// CONCATENATED MODULE: ./node_modules/d3-array/src/ticks.js
var e10 = Math.sqrt(50),
    e5 = Math.sqrt(10),
    e2 = Math.sqrt(2);

/* harmony default export */ function ticks(start, stop, count) {
  var reverse,
      i = -1,
      n,
      ticks,
      step;

  stop = +stop, start = +start, count = +count;
  if (start === stop && count > 0) return [start];
  if (reverse = stop < start) n = start, start = stop, stop = n;
  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];

  if (step > 0) {
    start = Math.ceil(start / step);
    stop = Math.floor(stop / step);
    ticks = new Array(n = Math.ceil(stop - start + 1));
    while (++i < n) ticks[i] = (start + i) * step;
  } else {
    start = Math.floor(start * step);
    stop = Math.ceil(stop * step);
    ticks = new Array(n = Math.ceil(start - stop + 1));
    while (++i < n) ticks[i] = (start - i) / step;
  }

  if (reverse) ticks.reverse();

  return ticks;
}

function tickIncrement(start, stop, count) {
  var step = (stop - start) / Math.max(0, count),
      power = Math.floor(Math.log(step) / Math.LN10),
      error = step / Math.pow(10, power);
  return power >= 0
      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
}

function ticks_tickStep(start, stop, count) {
  var step0 = Math.abs(stop - start) / Math.max(0, count),
      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
      error = step0 / step1;
  if (error >= e10) step1 *= 10;
  else if (error >= e5) step1 *= 5;
  else if (error >= e2) step1 *= 2;
  return stop < start ? -step1 : step1;
}

;// CONCATENATED MODULE: ./node_modules/d3-array/src/histogram.js









/* harmony default export */ function histogram() {
  var value = identity,
      domain = extent,
      threshold = sturges;

  function histogram(data) {
    var i,
        n = data.length,
        x,
        values = new Array(n);

    for (i = 0; i < n; ++i) {
      values[i] = value(data[i], i, data);
    }

    var xz = domain(values),
        x0 = xz[0],
        x1 = xz[1],
        tz = threshold(values, x0, x1);

    // Convert number of thresholds into uniform thresholds.
    if (!Array.isArray(tz)) {
      tz = tickStep(x0, x1, tz);
      tz = range(Math.ceil(x0 / tz) * tz, x1, tz); // exclusive
    }

    // Remove any thresholds outside the domain.
    var m = tz.length;
    while (tz[0] <= x0) tz.shift(), --m;
    while (tz[m - 1] > x1) tz.pop(), --m;

    var bins = new Array(m + 1),
        bin;

    // Initialize bins.
    for (i = 0; i <= m; ++i) {
      bin = bins[i] = [];
      bin.x0 = i > 0 ? tz[i - 1] : x0;
      bin.x1 = i < m ? tz[i] : x1;
    }

    // Assign data to bins by value, ignoring any outside the domain.
    for (i = 0; i < n; ++i) {
      x = values[i];
      if (x0 <= x && x <= x1) {
        bins[bisect(tz, x, 0, m)].push(data[i]);
      }
    }

    return bins;
  }

  histogram.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : constant(_), histogram) : value;
  };

  histogram.domain = function(_) {
    return arguments.length ? (domain = typeof _ === "function" ? _ : constant([_[0], _[1]]), histogram) : domain;
  };

  histogram.thresholds = function(_) {
    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? constant(slice.call(_)) : constant(_), histogram) : threshold;
  };

  return histogram;
}

;// CONCATENATED MODULE: ./node_modules/d3-array/src/threshold/freedmanDiaconis.js





/* harmony default export */ function freedmanDiaconis(values, min, max) {
  values = map.call(values, number).sort(ascending);
  return Math.ceil((max - min) / (2 * (quantile(values, 0.75) - quantile(values, 0.25)) * Math.pow(values.length, -1 / 3)));
}

;// CONCATENATED MODULE: ./node_modules/d3-array/src/max.js
/* harmony default export */ function max(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      max;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null && value > max) {
            max = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null && value > max) {
            max = value;
          }
        }
      }
    }
  }

  return max;
}

;// CONCATENATED MODULE: ./node_modules/d3-array/src/number.js
/* harmony default export */ function src_number(x) {
  return x === null ? NaN : +x;
}

;// CONCATENATED MODULE: ./node_modules/d3-array/src/mean.js


/* harmony default export */ function mean(values, valueof) {
  var n = values.length,
      m = n,
      i = -1,
      value,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = src_number(values[i]))) sum += value;
      else --m;
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = src_number(valueof(values[i], i, values)))) sum += value;
      else --m;
    }
  }

  if (m) return sum / m;
}

;// CONCATENATED MODULE: ./node_modules/d3-array/src/merge.js
/* harmony default export */ function merge(arrays) {
  var n = arrays.length,
      m,
      i = -1,
      j = 0,
      merged,
      array;

  while (++i < n) j += arrays[i].length;
  merged = new Array(j);

  while (--n >= 0) {
    array = arrays[n];
    m = array.length;
    while (--m >= 0) {
      merged[--j] = array[m];
    }
  }

  return merged;
}

;// CONCATENATED MODULE: ./node_modules/d3-array/src/min.js
/* harmony default export */ function min(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      min;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        min = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null && min > value) {
            min = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        min = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null && min > value) {
            min = value;
          }
        }
      }
    }
  }

  return min;
}

;// CONCATENATED MODULE: ./node_modules/d3-array/src/range.js
/* harmony default export */ function src_range(start, stop, step) {
  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;

  var i = -1,
      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
      range = new Array(n);

  while (++i < n) {
    range[i] = start + i * step;
  }

  return range;
}

;// CONCATENATED MODULE: ./node_modules/d3-array/src/sum.js
/* harmony default export */ function sum(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
    }
  }

  else {
    while (++i < n) {
      if (value = +valueof(values[i], i, values)) sum += value;
    }
  }

  return sum;
}

;// CONCATENATED MODULE: ./node_modules/d3-array/src/index.js





























/***/ }),

/***/ 4575:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Tj: function() { return /* reexport */ src_map; },
  $I: function() { return /* reexport */ nest; }
});

// UNUSED EXPORTS: entries, keys, set, values

;// CONCATENATED MODULE: ./node_modules/d3-collection/src/map.js
var prefix = "$";

function Map() {}

Map.prototype = map.prototype = {
  constructor: Map,
  has: function(key) {
    return (prefix + key) in this;
  },
  get: function(key) {
    return this[prefix + key];
  },
  set: function(key, value) {
    this[prefix + key] = value;
    return this;
  },
  remove: function(key) {
    var property = prefix + key;
    return property in this && delete this[property];
  },
  clear: function() {
    for (var property in this) if (property[0] === prefix) delete this[property];
  },
  keys: function() {
    var keys = [];
    for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
    return keys;
  },
  values: function() {
    var values = [];
    for (var property in this) if (property[0] === prefix) values.push(this[property]);
    return values;
  },
  entries: function() {
    var entries = [];
    for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
    return entries;
  },
  size: function() {
    var size = 0;
    for (var property in this) if (property[0] === prefix) ++size;
    return size;
  },
  empty: function() {
    for (var property in this) if (property[0] === prefix) return false;
    return true;
  },
  each: function(f) {
    for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
  }
};

function map(object, f) {
  var map = new Map;

  // Copy constructor.
  if (object instanceof Map) object.each(function(value, key) { map.set(key, value); });

  // Index array by numeric index or specified key function.
  else if (Array.isArray(object)) {
    var i = -1,
        n = object.length,
        o;

    if (f == null) while (++i < n) map.set(i, object[i]);
    else while (++i < n) map.set(f(o = object[i], i, object), o);
  }

  // Convert object to map.
  else if (object) for (var key in object) map.set(key, object[key]);

  return map;
}

/* harmony default export */ var src_map = (map);

;// CONCATENATED MODULE: ./node_modules/d3-collection/src/nest.js


/* harmony default export */ function nest() {
  var keys = [],
      sortKeys = [],
      sortValues,
      rollup,
      nest;

  function apply(array, depth, createResult, setResult) {
    if (depth >= keys.length) {
      if (sortValues != null) array.sort(sortValues);
      return rollup != null ? rollup(array) : array;
    }

    var i = -1,
        n = array.length,
        key = keys[depth++],
        keyValue,
        value,
        valuesByKey = src_map(),
        values,
        result = createResult();

    while (++i < n) {
      if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
        values.push(value);
      } else {
        valuesByKey.set(keyValue, [value]);
      }
    }

    valuesByKey.each(function(values, key) {
      setResult(result, key, apply(values, depth, createResult, setResult));
    });

    return result;
  }

  function entries(map, depth) {
    if (++depth > keys.length) return map;
    var array, sortKey = sortKeys[depth - 1];
    if (rollup != null && depth >= keys.length) array = map.entries();
    else array = [], map.each(function(v, k) { array.push({key: k, values: entries(v, depth)}); });
    return sortKey != null ? array.sort(function(a, b) { return sortKey(a.key, b.key); }) : array;
  }

  return nest = {
    object: function(array) { return apply(array, 0, createObject, setObject); },
    map: function(array) { return apply(array, 0, createMap, setMap); },
    entries: function(array) { return entries(apply(array, 0, createMap, setMap), 0); },
    key: function(d) { keys.push(d); return nest; },
    sortKeys: function(order) { sortKeys[keys.length - 1] = order; return nest; },
    sortValues: function(order) { sortValues = order; return nest; },
    rollup: function(f) { rollup = f; return nest; }
  };
}

function createObject() {
  return {};
}

function setObject(object, key, value) {
  object[key] = value;
}

function createMap() {
  return src_map();
}

function setMap(map, key, value) {
  map.set(key, value);
}

;// CONCATENATED MODULE: ./node_modules/d3-collection/src/set.js


function Set() {}

var proto = src_map.prototype;

Set.prototype = set.prototype = {
  constructor: Set,
  has: proto.has,
  add: function(value) {
    value += "";
    this[prefix + value] = value;
    return this;
  },
  remove: proto.remove,
  clear: proto.clear,
  values: proto.keys,
  size: proto.size,
  empty: proto.empty,
  each: proto.each
};

function set(object, f) {
  var set = new Set;

  // Copy constructor.
  if (object instanceof Set) object.each(function(value) { set.add(value); });

  // Otherwise, assume it’s an array.
  else if (object) {
    var i = -1, n = object.length;
    if (f == null) while (++i < n) set.add(object[i]);
    else while (++i < n) set.add(f(object[i], i, object));
  }

  return set;
}

/* harmony default export */ var src_set = ((/* unused pure expression or super */ null && (set)));

;// CONCATENATED MODULE: ./node_modules/d3-collection/src/index.js








/***/ }),

/***/ 32702:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  forceCenter: function() { return /* reexport */ center; },
  forceCollide: function() { return /* reexport */ collide; },
  forceLink: function() { return /* reexport */ src_link; },
  forceManyBody: function() { return /* reexport */ manyBody; },
  forceRadial: function() { return /* reexport */ radial; },
  forceSimulation: function() { return /* reexport */ simulation; },
  forceX: function() { return /* reexport */ src_x; },
  forceY: function() { return /* reexport */ src_y; }
});

;// CONCATENATED MODULE: ./node_modules/d3-force/src/center.js
/* harmony default export */ function center(x, y) {
  var nodes;

  if (x == null) x = 0;
  if (y == null) y = 0;

  function force() {
    var i,
        n = nodes.length,
        node,
        sx = 0,
        sy = 0;

    for (i = 0; i < n; ++i) {
      node = nodes[i], sx += node.x, sy += node.y;
    }

    for (sx = sx / n - x, sy = sy / n - y, i = 0; i < n; ++i) {
      node = nodes[i], node.x -= sx, node.y -= sy;
    }
  }

  force.initialize = function(_) {
    nodes = _;
  };

  force.x = function(_) {
    return arguments.length ? (x = +_, force) : x;
  };

  force.y = function(_) {
    return arguments.length ? (y = +_, force) : y;
  };

  return force;
}

;// CONCATENATED MODULE: ./node_modules/d3-force/src/constant.js
/* harmony default export */ function constant(x) {
  return function() {
    return x;
  };
}

;// CONCATENATED MODULE: ./node_modules/d3-force/src/jiggle.js
/* harmony default export */ function jiggle() {
  return (Math.random() - 0.5) * 1e-6;
}

;// CONCATENATED MODULE: ./node_modules/d3-quadtree/src/add.js
/* harmony default export */ function add(d) {
  var x = +this._x.call(null, d),
      y = +this._y.call(null, d);
  return add_add(this.cover(x, y), x, y, d);
}

function add_add(tree, x, y, d) {
  if (isNaN(x) || isNaN(y)) return tree; // ignore invalid points

  var parent,
      node = tree._root,
      leaf = {data: d},
      x0 = tree._x0,
      y0 = tree._y0,
      x1 = tree._x1,
      y1 = tree._y1,
      xm,
      ym,
      xp,
      yp,
      right,
      bottom,
      i,
      j;

  // If the tree is empty, initialize the root as a leaf.
  if (!node) return tree._root = leaf, tree;

  // Find the existing leaf for the new point, or add it.
  while (node.length) {
    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
    if (parent = node, !(node = node[i = bottom << 1 | right])) return parent[i] = leaf, tree;
  }

  // Is the new point is exactly coincident with the existing point?
  xp = +tree._x.call(null, node.data);
  yp = +tree._y.call(null, node.data);
  if (x === xp && y === yp) return leaf.next = node, parent ? parent[i] = leaf : tree._root = leaf, tree;

  // Otherwise, split the leaf node until the old and new point are separated.
  do {
    parent = parent ? parent[i] = new Array(4) : tree._root = new Array(4);
    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
  } while ((i = bottom << 1 | right) === (j = (yp >= ym) << 1 | (xp >= xm)));
  return parent[j] = node, parent[i] = leaf, tree;
}

function addAll(data) {
  var d, i, n = data.length,
      x,
      y,
      xz = new Array(n),
      yz = new Array(n),
      x0 = Infinity,
      y0 = Infinity,
      x1 = -Infinity,
      y1 = -Infinity;

  // Compute the points and their extent.
  for (i = 0; i < n; ++i) {
    if (isNaN(x = +this._x.call(null, d = data[i])) || isNaN(y = +this._y.call(null, d))) continue;
    xz[i] = x;
    yz[i] = y;
    if (x < x0) x0 = x;
    if (x > x1) x1 = x;
    if (y < y0) y0 = y;
    if (y > y1) y1 = y;
  }

  // If there were no (valid) points, abort.
  if (x0 > x1 || y0 > y1) return this;

  // Expand the tree to cover the new points.
  this.cover(x0, y0).cover(x1, y1);

  // Add the new points.
  for (i = 0; i < n; ++i) {
    add_add(this, xz[i], yz[i], data[i]);
  }

  return this;
}

;// CONCATENATED MODULE: ./node_modules/d3-quadtree/src/cover.js
/* harmony default export */ function cover(x, y) {
  if (isNaN(x = +x) || isNaN(y = +y)) return this; // ignore invalid points

  var x0 = this._x0,
      y0 = this._y0,
      x1 = this._x1,
      y1 = this._y1;

  // If the quadtree has no extent, initialize them.
  // Integer extent are necessary so that if we later double the extent,
  // the existing quadrant boundaries don’t change due to floating point error!
  if (isNaN(x0)) {
    x1 = (x0 = Math.floor(x)) + 1;
    y1 = (y0 = Math.floor(y)) + 1;
  }

  // Otherwise, double repeatedly to cover.
  else {
    var z = x1 - x0,
        node = this._root,
        parent,
        i;

    while (x0 > x || x >= x1 || y0 > y || y >= y1) {
      i = (y < y0) << 1 | (x < x0);
      parent = new Array(4), parent[i] = node, node = parent, z *= 2;
      switch (i) {
        case 0: x1 = x0 + z, y1 = y0 + z; break;
        case 1: x0 = x1 - z, y1 = y0 + z; break;
        case 2: x1 = x0 + z, y0 = y1 - z; break;
        case 3: x0 = x1 - z, y0 = y1 - z; break;
      }
    }

    if (this._root && this._root.length) this._root = node;
  }

  this._x0 = x0;
  this._y0 = y0;
  this._x1 = x1;
  this._y1 = y1;
  return this;
}

;// CONCATENATED MODULE: ./node_modules/d3-quadtree/src/data.js
/* harmony default export */ function data() {
  var data = [];
  this.visit(function(node) {
    if (!node.length) do data.push(node.data); while (node = node.next)
  });
  return data;
}

;// CONCATENATED MODULE: ./node_modules/d3-quadtree/src/extent.js
/* harmony default export */ function extent(_) {
  return arguments.length
      ? this.cover(+_[0][0], +_[0][1]).cover(+_[1][0], +_[1][1])
      : isNaN(this._x0) ? undefined : [[this._x0, this._y0], [this._x1, this._y1]];
}

;// CONCATENATED MODULE: ./node_modules/d3-quadtree/src/quad.js
/* harmony default export */ function quad(node, x0, y0, x1, y1) {
  this.node = node;
  this.x0 = x0;
  this.y0 = y0;
  this.x1 = x1;
  this.y1 = y1;
}

;// CONCATENATED MODULE: ./node_modules/d3-quadtree/src/find.js


/* harmony default export */ function find(x, y, radius) {
  var data,
      x0 = this._x0,
      y0 = this._y0,
      x1,
      y1,
      x2,
      y2,
      x3 = this._x1,
      y3 = this._y1,
      quads = [],
      node = this._root,
      q,
      i;

  if (node) quads.push(new quad(node, x0, y0, x3, y3));
  if (radius == null) radius = Infinity;
  else {
    x0 = x - radius, y0 = y - radius;
    x3 = x + radius, y3 = y + radius;
    radius *= radius;
  }

  while (q = quads.pop()) {

    // Stop searching if this quadrant can’t contain a closer node.
    if (!(node = q.node)
        || (x1 = q.x0) > x3
        || (y1 = q.y0) > y3
        || (x2 = q.x1) < x0
        || (y2 = q.y1) < y0) continue;

    // Bisect the current quadrant.
    if (node.length) {
      var xm = (x1 + x2) / 2,
          ym = (y1 + y2) / 2;

      quads.push(
        new quad(node[3], xm, ym, x2, y2),
        new quad(node[2], x1, ym, xm, y2),
        new quad(node[1], xm, y1, x2, ym),
        new quad(node[0], x1, y1, xm, ym)
      );

      // Visit the closest quadrant first.
      if (i = (y >= ym) << 1 | (x >= xm)) {
        q = quads[quads.length - 1];
        quads[quads.length - 1] = quads[quads.length - 1 - i];
        quads[quads.length - 1 - i] = q;
      }
    }

    // Visit this point. (Visiting coincident points isn’t necessary!)
    else {
      var dx = x - +this._x.call(null, node.data),
          dy = y - +this._y.call(null, node.data),
          d2 = dx * dx + dy * dy;
      if (d2 < radius) {
        var d = Math.sqrt(radius = d2);
        x0 = x - d, y0 = y - d;
        x3 = x + d, y3 = y + d;
        data = node.data;
      }
    }
  }

  return data;
}

;// CONCATENATED MODULE: ./node_modules/d3-quadtree/src/remove.js
/* harmony default export */ function remove(d) {
  if (isNaN(x = +this._x.call(null, d)) || isNaN(y = +this._y.call(null, d))) return this; // ignore invalid points

  var parent,
      node = this._root,
      retainer,
      previous,
      next,
      x0 = this._x0,
      y0 = this._y0,
      x1 = this._x1,
      y1 = this._y1,
      x,
      y,
      xm,
      ym,
      right,
      bottom,
      i,
      j;

  // If the tree is empty, initialize the root as a leaf.
  if (!node) return this;

  // Find the leaf node for the point.
  // While descending, also retain the deepest parent with a non-removed sibling.
  if (node.length) while (true) {
    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
    if (!(parent = node, node = node[i = bottom << 1 | right])) return this;
    if (!node.length) break;
    if (parent[(i + 1) & 3] || parent[(i + 2) & 3] || parent[(i + 3) & 3]) retainer = parent, j = i;
  }

  // Find the point to remove.
  while (node.data !== d) if (!(previous = node, node = node.next)) return this;
  if (next = node.next) delete node.next;

  // If there are multiple coincident points, remove just the point.
  if (previous) return (next ? previous.next = next : delete previous.next), this;

  // If this is the root point, remove it.
  if (!parent) return this._root = next, this;

  // Remove this leaf.
  next ? parent[i] = next : delete parent[i];

  // If the parent now contains exactly one leaf, collapse superfluous parents.
  if ((node = parent[0] || parent[1] || parent[2] || parent[3])
      && node === (parent[3] || parent[2] || parent[1] || parent[0])
      && !node.length) {
    if (retainer) retainer[j] = node;
    else this._root = node;
  }

  return this;
}

function removeAll(data) {
  for (var i = 0, n = data.length; i < n; ++i) this.remove(data[i]);
  return this;
}

;// CONCATENATED MODULE: ./node_modules/d3-quadtree/src/root.js
/* harmony default export */ function root() {
  return this._root;
}

;// CONCATENATED MODULE: ./node_modules/d3-quadtree/src/size.js
/* harmony default export */ function size() {
  var size = 0;
  this.visit(function(node) {
    if (!node.length) do ++size; while (node = node.next)
  });
  return size;
}

;// CONCATENATED MODULE: ./node_modules/d3-quadtree/src/visit.js


/* harmony default export */ function visit(callback) {
  var quads = [], q, node = this._root, child, x0, y0, x1, y1;
  if (node) quads.push(new quad(node, this._x0, this._y0, this._x1, this._y1));
  while (q = quads.pop()) {
    if (!callback(node = q.node, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1) && node.length) {
      var xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
      if (child = node[3]) quads.push(new quad(child, xm, ym, x1, y1));
      if (child = node[2]) quads.push(new quad(child, x0, ym, xm, y1));
      if (child = node[1]) quads.push(new quad(child, xm, y0, x1, ym));
      if (child = node[0]) quads.push(new quad(child, x0, y0, xm, ym));
    }
  }
  return this;
}

;// CONCATENATED MODULE: ./node_modules/d3-quadtree/src/visitAfter.js


/* harmony default export */ function visitAfter(callback) {
  var quads = [], next = [], q;
  if (this._root) quads.push(new quad(this._root, this._x0, this._y0, this._x1, this._y1));
  while (q = quads.pop()) {
    var node = q.node;
    if (node.length) {
      var child, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1, xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
      if (child = node[0]) quads.push(new quad(child, x0, y0, xm, ym));
      if (child = node[1]) quads.push(new quad(child, xm, y0, x1, ym));
      if (child = node[2]) quads.push(new quad(child, x0, ym, xm, y1));
      if (child = node[3]) quads.push(new quad(child, xm, ym, x1, y1));
    }
    next.push(q);
  }
  while (q = next.pop()) {
    callback(q.node, q.x0, q.y0, q.x1, q.y1);
  }
  return this;
}

;// CONCATENATED MODULE: ./node_modules/d3-quadtree/src/x.js
function defaultX(d) {
  return d[0];
}

/* harmony default export */ function x(_) {
  return arguments.length ? (this._x = _, this) : this._x;
}

;// CONCATENATED MODULE: ./node_modules/d3-quadtree/src/y.js
function defaultY(d) {
  return d[1];
}

/* harmony default export */ function y(_) {
  return arguments.length ? (this._y = _, this) : this._y;
}

;// CONCATENATED MODULE: ./node_modules/d3-quadtree/src/quadtree.js













function quadtree(nodes, x, y) {
  var tree = new Quadtree(x == null ? defaultX : x, y == null ? defaultY : y, NaN, NaN, NaN, NaN);
  return nodes == null ? tree : tree.addAll(nodes);
}

function Quadtree(x, y, x0, y0, x1, y1) {
  this._x = x;
  this._y = y;
  this._x0 = x0;
  this._y0 = y0;
  this._x1 = x1;
  this._y1 = y1;
  this._root = undefined;
}

function leaf_copy(leaf) {
  var copy = {data: leaf.data}, next = copy;
  while (leaf = leaf.next) next = next.next = {data: leaf.data};
  return copy;
}

var treeProto = quadtree.prototype = Quadtree.prototype;

treeProto.copy = function() {
  var copy = new Quadtree(this._x, this._y, this._x0, this._y0, this._x1, this._y1),
      node = this._root,
      nodes,
      child;

  if (!node) return copy;

  if (!node.length) return copy._root = leaf_copy(node), copy;

  nodes = [{source: node, target: copy._root = new Array(4)}];
  while (node = nodes.pop()) {
    for (var i = 0; i < 4; ++i) {
      if (child = node.source[i]) {
        if (child.length) nodes.push({source: child, target: node.target[i] = new Array(4)});
        else node.target[i] = leaf_copy(child);
      }
    }
  }

  return copy;
};

treeProto.add = add;
treeProto.addAll = addAll;
treeProto.cover = cover;
treeProto.data = data;
treeProto.extent = extent;
treeProto.find = find;
treeProto.remove = remove;
treeProto.removeAll = removeAll;
treeProto.root = root;
treeProto.size = size;
treeProto.visit = visit;
treeProto.visitAfter = visitAfter;
treeProto.x = x;
treeProto.y = y;

;// CONCATENATED MODULE: ./node_modules/d3-force/src/collide.js




function collide_x(d) {
  return d.x + d.vx;
}

function collide_y(d) {
  return d.y + d.vy;
}

/* harmony default export */ function collide(radius) {
  var nodes,
      radii,
      strength = 1,
      iterations = 1;

  if (typeof radius !== "function") radius = constant(radius == null ? 1 : +radius);

  function force() {
    var i, n = nodes.length,
        tree,
        node,
        xi,
        yi,
        ri,
        ri2;

    for (var k = 0; k < iterations; ++k) {
      tree = quadtree(nodes, collide_x, collide_y).visitAfter(prepare);
      for (i = 0; i < n; ++i) {
        node = nodes[i];
        ri = radii[node.index], ri2 = ri * ri;
        xi = node.x + node.vx;
        yi = node.y + node.vy;
        tree.visit(apply);
      }
    }

    function apply(quad, x0, y0, x1, y1) {
      var data = quad.data, rj = quad.r, r = ri + rj;
      if (data) {
        if (data.index > node.index) {
          var x = xi - data.x - data.vx,
              y = yi - data.y - data.vy,
              l = x * x + y * y;
          if (l < r * r) {
            if (x === 0) x = jiggle(), l += x * x;
            if (y === 0) y = jiggle(), l += y * y;
            l = (r - (l = Math.sqrt(l))) / l * strength;
            node.vx += (x *= l) * (r = (rj *= rj) / (ri2 + rj));
            node.vy += (y *= l) * r;
            data.vx -= x * (r = 1 - r);
            data.vy -= y * r;
          }
        }
        return;
      }
      return x0 > xi + r || x1 < xi - r || y0 > yi + r || y1 < yi - r;
    }
  }

  function prepare(quad) {
    if (quad.data) return quad.r = radii[quad.data.index];
    for (var i = quad.r = 0; i < 4; ++i) {
      if (quad[i] && quad[i].r > quad.r) {
        quad.r = quad[i].r;
      }
    }
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length, node;
    radii = new Array(n);
    for (i = 0; i < n; ++i) node = nodes[i], radii[node.index] = +radius(node, i, nodes);
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.iterations = function(_) {
    return arguments.length ? (iterations = +_, force) : iterations;
  };

  force.strength = function(_) {
    return arguments.length ? (strength = +_, force) : strength;
  };

  force.radius = function(_) {
    return arguments.length ? (radius = typeof _ === "function" ? _ : constant(+_), initialize(), force) : radius;
  };

  return force;
}

// EXTERNAL MODULE: ./node_modules/d3-collection/src/index.js + 3 modules
var src = __webpack_require__(4575);
;// CONCATENATED MODULE: ./node_modules/d3-force/src/link.js




function index(d) {
  return d.index;
}

function link_find(nodeById, nodeId) {
  var node = nodeById.get(nodeId);
  if (!node) throw new Error("missing: " + nodeId);
  return node;
}

/* harmony default export */ function src_link(links) {
  var id = index,
      strength = defaultStrength,
      strengths,
      distance = constant(30),
      distances,
      nodes,
      count,
      bias,
      iterations = 1;

  if (links == null) links = [];

  function defaultStrength(link) {
    return 1 / Math.min(count[link.source.index], count[link.target.index]);
  }

  function force(alpha) {
    for (var k = 0, n = links.length; k < iterations; ++k) {
      for (var i = 0, link, source, target, x, y, l, b; i < n; ++i) {
        link = links[i], source = link.source, target = link.target;
        x = target.x + target.vx - source.x - source.vx || jiggle();
        y = target.y + target.vy - source.y - source.vy || jiggle();
        l = Math.sqrt(x * x + y * y);
        l = (l - distances[i]) / l * alpha * strengths[i];
        x *= l, y *= l;
        target.vx -= x * (b = bias[i]);
        target.vy -= y * b;
        source.vx += x * (b = 1 - b);
        source.vy += y * b;
      }
    }
  }

  function initialize() {
    if (!nodes) return;

    var i,
        n = nodes.length,
        m = links.length,
        nodeById = (0,src/* map */.Tj)(nodes, id),
        link;

    for (i = 0, count = new Array(n); i < m; ++i) {
      link = links[i], link.index = i;
      if (typeof link.source !== "object") link.source = link_find(nodeById, link.source);
      if (typeof link.target !== "object") link.target = link_find(nodeById, link.target);
      count[link.source.index] = (count[link.source.index] || 0) + 1;
      count[link.target.index] = (count[link.target.index] || 0) + 1;
    }

    for (i = 0, bias = new Array(m); i < m; ++i) {
      link = links[i], bias[i] = count[link.source.index] / (count[link.source.index] + count[link.target.index]);
    }

    strengths = new Array(m), initializeStrength();
    distances = new Array(m), initializeDistance();
  }

  function initializeStrength() {
    if (!nodes) return;

    for (var i = 0, n = links.length; i < n; ++i) {
      strengths[i] = +strength(links[i], i, links);
    }
  }

  function initializeDistance() {
    if (!nodes) return;

    for (var i = 0, n = links.length; i < n; ++i) {
      distances[i] = +distance(links[i], i, links);
    }
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.links = function(_) {
    return arguments.length ? (links = _, initialize(), force) : links;
  };

  force.id = function(_) {
    return arguments.length ? (id = _, force) : id;
  };

  force.iterations = function(_) {
    return arguments.length ? (iterations = +_, force) : iterations;
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : constant(+_), initializeStrength(), force) : strength;
  };

  force.distance = function(_) {
    return arguments.length ? (distance = typeof _ === "function" ? _ : constant(+_), initializeDistance(), force) : distance;
  };

  return force;
}

;// CONCATENATED MODULE: ./node_modules/d3-dispatch/src/dispatch.js
var noop = {value: function() {}};

function dispatch() {
  for (var i = 0, n = arguments.length, _ = {}, t; i < n; ++i) {
    if (!(t = arguments[i] + "") || (t in _) || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
    _[t] = [];
  }
  return new Dispatch(_);
}

function Dispatch(_) {
  this._ = _;
}

function parseTypenames(typenames, types) {
  return typenames.trim().split(/^|\s+/).map(function(t) {
    var name = "", i = t.indexOf(".");
    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
    if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
    return {type: t, name: name};
  });
}

Dispatch.prototype = dispatch.prototype = {
  constructor: Dispatch,
  on: function(typename, callback) {
    var _ = this._,
        T = parseTypenames(typename + "", _),
        t,
        i = -1,
        n = T.length;

    // If no callback was specified, return the callback of the given type and name.
    if (arguments.length < 2) {
      while (++i < n) if ((t = (typename = T[i]).type) && (t = get(_[t], typename.name))) return t;
      return;
    }

    // If a type was specified, set the callback for the given type and name.
    // Otherwise, if a null callback was specified, remove callbacks of the given name.
    if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
    while (++i < n) {
      if (t = (typename = T[i]).type) _[t] = set(_[t], typename.name, callback);
      else if (callback == null) for (t in _) _[t] = set(_[t], typename.name, null);
    }

    return this;
  },
  copy: function() {
    var copy = {}, _ = this._;
    for (var t in _) copy[t] = _[t].slice();
    return new Dispatch(copy);
  },
  call: function(type, that) {
    if ((n = arguments.length - 2) > 0) for (var args = new Array(n), i = 0, n, t; i < n; ++i) args[i] = arguments[i + 2];
    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
    for (t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
  },
  apply: function(type, that, args) {
    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
    for (var t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
  }
};

function get(type, name) {
  for (var i = 0, n = type.length, c; i < n; ++i) {
    if ((c = type[i]).name === name) {
      return c.value;
    }
  }
}

function set(type, name, callback) {
  for (var i = 0, n = type.length; i < n; ++i) {
    if (type[i].name === name) {
      type[i] = noop, type = type.slice(0, i).concat(type.slice(i + 1));
      break;
    }
  }
  if (callback != null) type.push({name: name, value: callback});
  return type;
}

/* harmony default export */ var src_dispatch = (dispatch);

;// CONCATENATED MODULE: ./node_modules/d3-timer/src/timer.js
var timer_frame = 0, // is an animation frame pending?
    timeout = 0, // is a timeout pending?
    interval = 0, // are any timers active?
    pokeDelay = 1000, // how frequently we check for clock skew
    taskHead,
    taskTail,
    clockLast = 0,
    clockNow = 0,
    clockSkew = 0,
    clock = typeof performance === "object" && performance.now ? performance : Date,
    setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) { setTimeout(f, 17); };

function now() {
  return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
}

function clearNow() {
  clockNow = 0;
}

function Timer() {
  this._call =
  this._time =
  this._next = null;
}

Timer.prototype = timer.prototype = {
  constructor: Timer,
  restart: function(callback, delay, time) {
    if (typeof callback !== "function") throw new TypeError("callback is not a function");
    time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
    if (!this._next && taskTail !== this) {
      if (taskTail) taskTail._next = this;
      else taskHead = this;
      taskTail = this;
    }
    this._call = callback;
    this._time = time;
    sleep();
  },
  stop: function() {
    if (this._call) {
      this._call = null;
      this._time = Infinity;
      sleep();
    }
  }
};

function timer(callback, delay, time) {
  var t = new Timer;
  t.restart(callback, delay, time);
  return t;
}

function timerFlush() {
  now(); // Get the current time, if not already set.
  ++timer_frame; // Pretend we’ve set an alarm, if we haven’t already.
  var t = taskHead, e;
  while (t) {
    if ((e = clockNow - t._time) >= 0) t._call.call(null, e);
    t = t._next;
  }
  --timer_frame;
}

function wake() {
  clockNow = (clockLast = clock.now()) + clockSkew;
  timer_frame = timeout = 0;
  try {
    timerFlush();
  } finally {
    timer_frame = 0;
    nap();
    clockNow = 0;
  }
}

function poke() {
  var now = clock.now(), delay = now - clockLast;
  if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
}

function nap() {
  var t0, t1 = taskHead, t2, time = Infinity;
  while (t1) {
    if (t1._call) {
      if (time > t1._time) time = t1._time;
      t0 = t1, t1 = t1._next;
    } else {
      t2 = t1._next, t1._next = null;
      t1 = t0 ? t0._next = t2 : taskHead = t2;
    }
  }
  taskTail = t0;
  sleep(time);
}

function sleep(time) {
  if (timer_frame) return; // Soonest alarm already set, or will be.
  if (timeout) timeout = clearTimeout(timeout);
  var delay = time - clockNow; // Strictly less than if we recomputed clockNow.
  if (delay > 24) {
    if (time < Infinity) timeout = setTimeout(wake, time - clock.now() - clockSkew);
    if (interval) interval = clearInterval(interval);
  } else {
    if (!interval) clockLast = clock.now(), interval = setInterval(poke, pokeDelay);
    timer_frame = 1, setFrame(wake);
  }
}

;// CONCATENATED MODULE: ./node_modules/d3-force/src/simulation.js




function simulation_x(d) {
  return d.x;
}

function simulation_y(d) {
  return d.y;
}

var initialRadius = 10,
    initialAngle = Math.PI * (3 - Math.sqrt(5));

/* harmony default export */ function simulation(nodes) {
  var simulation,
      alpha = 1,
      alphaMin = 0.001,
      alphaDecay = 1 - Math.pow(alphaMin, 1 / 300),
      alphaTarget = 0,
      velocityDecay = 0.6,
      forces = (0,src/* map */.Tj)(),
      stepper = timer(step),
      event = src_dispatch("tick", "end");

  if (nodes == null) nodes = [];

  function step() {
    tick();
    event.call("tick", simulation);
    if (alpha < alphaMin) {
      stepper.stop();
      event.call("end", simulation);
    }
  }

  function tick(iterations) {
    var i, n = nodes.length, node;

    if (iterations === undefined) iterations = 1;

    for (var k = 0; k < iterations; ++k) {
      alpha += (alphaTarget - alpha) * alphaDecay;

      forces.each(function (force) {
        force(alpha);
      });

      for (i = 0; i < n; ++i) {
        node = nodes[i];
        if (node.fx == null) node.x += node.vx *= velocityDecay;
        else node.x = node.fx, node.vx = 0;
        if (node.fy == null) node.y += node.vy *= velocityDecay;
        else node.y = node.fy, node.vy = 0;
      }
    }

    return simulation;
  }

  function initializeNodes() {
    for (var i = 0, n = nodes.length, node; i < n; ++i) {
      node = nodes[i], node.index = i;
      if (node.fx != null) node.x = node.fx;
      if (node.fy != null) node.y = node.fy;
      if (isNaN(node.x) || isNaN(node.y)) {
        var radius = initialRadius * Math.sqrt(i), angle = i * initialAngle;
        node.x = radius * Math.cos(angle);
        node.y = radius * Math.sin(angle);
      }
      if (isNaN(node.vx) || isNaN(node.vy)) {
        node.vx = node.vy = 0;
      }
    }
  }

  function initializeForce(force) {
    if (force.initialize) force.initialize(nodes);
    return force;
  }

  initializeNodes();

  return simulation = {
    tick: tick,

    restart: function() {
      return stepper.restart(step), simulation;
    },

    stop: function() {
      return stepper.stop(), simulation;
    },

    nodes: function(_) {
      return arguments.length ? (nodes = _, initializeNodes(), forces.each(initializeForce), simulation) : nodes;
    },

    alpha: function(_) {
      return arguments.length ? (alpha = +_, simulation) : alpha;
    },

    alphaMin: function(_) {
      return arguments.length ? (alphaMin = +_, simulation) : alphaMin;
    },

    alphaDecay: function(_) {
      return arguments.length ? (alphaDecay = +_, simulation) : +alphaDecay;
    },

    alphaTarget: function(_) {
      return arguments.length ? (alphaTarget = +_, simulation) : alphaTarget;
    },

    velocityDecay: function(_) {
      return arguments.length ? (velocityDecay = 1 - _, simulation) : 1 - velocityDecay;
    },

    force: function(name, _) {
      return arguments.length > 1 ? ((_ == null ? forces.remove(name) : forces.set(name, initializeForce(_))), simulation) : forces.get(name);
    },

    find: function(x, y, radius) {
      var i = 0,
          n = nodes.length,
          dx,
          dy,
          d2,
          node,
          closest;

      if (radius == null) radius = Infinity;
      else radius *= radius;

      for (i = 0; i < n; ++i) {
        node = nodes[i];
        dx = x - node.x;
        dy = y - node.y;
        d2 = dx * dx + dy * dy;
        if (d2 < radius) closest = node, radius = d2;
      }

      return closest;
    },

    on: function(name, _) {
      return arguments.length > 1 ? (event.on(name, _), simulation) : event.on(name);
    }
  };
}

;// CONCATENATED MODULE: ./node_modules/d3-force/src/manyBody.js





/* harmony default export */ function manyBody() {
  var nodes,
      node,
      alpha,
      strength = constant(-30),
      strengths,
      distanceMin2 = 1,
      distanceMax2 = Infinity,
      theta2 = 0.81;

  function force(_) {
    var i, n = nodes.length, tree = quadtree(nodes, simulation_x, simulation_y).visitAfter(accumulate);
    for (alpha = _, i = 0; i < n; ++i) node = nodes[i], tree.visit(apply);
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length, node;
    strengths = new Array(n);
    for (i = 0; i < n; ++i) node = nodes[i], strengths[node.index] = +strength(node, i, nodes);
  }

  function accumulate(quad) {
    var strength = 0, q, c, weight = 0, x, y, i;

    // For internal nodes, accumulate forces from child quadrants.
    if (quad.length) {
      for (x = y = i = 0; i < 4; ++i) {
        if ((q = quad[i]) && (c = Math.abs(q.value))) {
          strength += q.value, weight += c, x += c * q.x, y += c * q.y;
        }
      }
      quad.x = x / weight;
      quad.y = y / weight;
    }

    // For leaf nodes, accumulate forces from coincident quadrants.
    else {
      q = quad;
      q.x = q.data.x;
      q.y = q.data.y;
      do strength += strengths[q.data.index];
      while (q = q.next);
    }

    quad.value = strength;
  }

  function apply(quad, x1, _, x2) {
    if (!quad.value) return true;

    var x = quad.x - node.x,
        y = quad.y - node.y,
        w = x2 - x1,
        l = x * x + y * y;

    // Apply the Barnes-Hut approximation if possible.
    // Limit forces for very close nodes; randomize direction if coincident.
    if (w * w / theta2 < l) {
      if (l < distanceMax2) {
        if (x === 0) x = jiggle(), l += x * x;
        if (y === 0) y = jiggle(), l += y * y;
        if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
        node.vx += x * quad.value * alpha / l;
        node.vy += y * quad.value * alpha / l;
      }
      return true;
    }

    // Otherwise, process points directly.
    else if (quad.length || l >= distanceMax2) return;

    // Limit forces for very close nodes; randomize direction if coincident.
    if (quad.data !== node || quad.next) {
      if (x === 0) x = jiggle(), l += x * x;
      if (y === 0) y = jiggle(), l += y * y;
      if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
    }

    do if (quad.data !== node) {
      w = strengths[quad.data.index] * alpha / l;
      node.vx += x * w;
      node.vy += y * w;
    } while (quad = quad.next);
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : constant(+_), initialize(), force) : strength;
  };

  force.distanceMin = function(_) {
    return arguments.length ? (distanceMin2 = _ * _, force) : Math.sqrt(distanceMin2);
  };

  force.distanceMax = function(_) {
    return arguments.length ? (distanceMax2 = _ * _, force) : Math.sqrt(distanceMax2);
  };

  force.theta = function(_) {
    return arguments.length ? (theta2 = _ * _, force) : Math.sqrt(theta2);
  };

  return force;
}

;// CONCATENATED MODULE: ./node_modules/d3-force/src/radial.js


/* harmony default export */ function radial(radius, x, y) {
  var nodes,
      strength = constant(0.1),
      strengths,
      radiuses;

  if (typeof radius !== "function") radius = constant(+radius);
  if (x == null) x = 0;
  if (y == null) y = 0;

  function force(alpha) {
    for (var i = 0, n = nodes.length; i < n; ++i) {
      var node = nodes[i],
          dx = node.x - x || 1e-6,
          dy = node.y - y || 1e-6,
          r = Math.sqrt(dx * dx + dy * dy),
          k = (radiuses[i] - r) * strengths[i] * alpha / r;
      node.vx += dx * k;
      node.vy += dy * k;
    }
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length;
    strengths = new Array(n);
    radiuses = new Array(n);
    for (i = 0; i < n; ++i) {
      radiuses[i] = +radius(nodes[i], i, nodes);
      strengths[i] = isNaN(radiuses[i]) ? 0 : +strength(nodes[i], i, nodes);
    }
  }

  force.initialize = function(_) {
    nodes = _, initialize();
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : constant(+_), initialize(), force) : strength;
  };

  force.radius = function(_) {
    return arguments.length ? (radius = typeof _ === "function" ? _ : constant(+_), initialize(), force) : radius;
  };

  force.x = function(_) {
    return arguments.length ? (x = +_, force) : x;
  };

  force.y = function(_) {
    return arguments.length ? (y = +_, force) : y;
  };

  return force;
}

;// CONCATENATED MODULE: ./node_modules/d3-force/src/x.js


/* harmony default export */ function src_x(x) {
  var strength = constant(0.1),
      nodes,
      strengths,
      xz;

  if (typeof x !== "function") x = constant(x == null ? 0 : +x);

  function force(alpha) {
    for (var i = 0, n = nodes.length, node; i < n; ++i) {
      node = nodes[i], node.vx += (xz[i] - node.x) * strengths[i] * alpha;
    }
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length;
    strengths = new Array(n);
    xz = new Array(n);
    for (i = 0; i < n; ++i) {
      strengths[i] = isNaN(xz[i] = +x(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
    }
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : constant(+_), initialize(), force) : strength;
  };

  force.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : constant(+_), initialize(), force) : x;
  };

  return force;
}

;// CONCATENATED MODULE: ./node_modules/d3-force/src/y.js


/* harmony default export */ function src_y(y) {
  var strength = constant(0.1),
      nodes,
      strengths,
      yz;

  if (typeof y !== "function") y = constant(y == null ? 0 : +y);

  function force(alpha) {
    for (var i = 0, n = nodes.length, node; i < n; ++i) {
      node = nodes[i], node.vy += (yz[i] - node.y) * strengths[i] * alpha;
    }
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length;
    strengths = new Array(n);
    yz = new Array(n);
    for (i = 0; i < n; ++i) {
      strengths[i] = isNaN(yz[i] = +y(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
    }
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : constant(+_), initialize(), force) : strength;
  };

  force.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : constant(+_), initialize(), force) : y;
  };

  return force;
}

;// CONCATENATED MODULE: ./node_modules/d3-force/src/index.js










/***/ }),

/***/ 36464:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  GP: function() { return /* reexport */ format; },
  OE: function() { return /* reexport */ locale; }
});

// UNUSED EXPORTS: FormatSpecifier, formatDefaultLocale, formatPrefix, formatSpecifier, precisionFixed, precisionPrefix, precisionRound

;// CONCATENATED MODULE: ./node_modules/d3-format/src/formatDecimal.js
/* harmony default export */ function formatDecimal(x) {
  return Math.abs(x = Math.round(x)) >= 1e21
      ? x.toLocaleString("en").replace(/,/g, "")
      : x.toString(10);
}

// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimalParts(1.23) returns ["123", 0].
function formatDecimalParts(x, p) {
  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
  var i, coefficient = x.slice(0, i);

  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
  return [
    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
    +x.slice(i + 1)
  ];
}

;// CONCATENATED MODULE: ./node_modules/d3-format/src/exponent.js


/* harmony default export */ function exponent(x) {
  return x = formatDecimalParts(Math.abs(x)), x ? x[1] : NaN;
}

;// CONCATENATED MODULE: ./node_modules/d3-format/src/formatGroup.js
/* harmony default export */ function formatGroup(grouping, thousands) {
  return function(value, width) {
    var i = value.length,
        t = [],
        j = 0,
        g = grouping[0],
        length = 0;

    while (i > 0 && g > 0) {
      if (length + g + 1 > width) g = Math.max(1, width - length);
      t.push(value.substring(i -= g, i + g));
      if ((length += g + 1) > width) break;
      g = grouping[j = (j + 1) % grouping.length];
    }

    return t.reverse().join(thousands);
  };
}

;// CONCATENATED MODULE: ./node_modules/d3-format/src/formatNumerals.js
/* harmony default export */ function formatNumerals(numerals) {
  return function(value) {
    return value.replace(/[0-9]/g, function(i) {
      return numerals[+i];
    });
  };
}

;// CONCATENATED MODULE: ./node_modules/d3-format/src/formatSpecifier.js
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;

function formatSpecifier(specifier) {
  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
  var match;
  return new FormatSpecifier({
    fill: match[1],
    align: match[2],
    sign: match[3],
    symbol: match[4],
    zero: match[5],
    width: match[6],
    comma: match[7],
    precision: match[8] && match[8].slice(1),
    trim: match[9],
    type: match[10]
  });
}

formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof

function FormatSpecifier(specifier) {
  this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
  this.align = specifier.align === undefined ? ">" : specifier.align + "";
  this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
  this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
  this.zero = !!specifier.zero;
  this.width = specifier.width === undefined ? undefined : +specifier.width;
  this.comma = !!specifier.comma;
  this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
  this.trim = !!specifier.trim;
  this.type = specifier.type === undefined ? "" : specifier.type + "";
}

FormatSpecifier.prototype.toString = function() {
  return this.fill
      + this.align
      + this.sign
      + this.symbol
      + (this.zero ? "0" : "")
      + (this.width === undefined ? "" : Math.max(1, this.width | 0))
      + (this.comma ? "," : "")
      + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0))
      + (this.trim ? "~" : "")
      + this.type;
};

;// CONCATENATED MODULE: ./node_modules/d3-format/src/formatTrim.js
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
/* harmony default export */ function formatTrim(s) {
  out: for (var n = s.length, i = 1, i0 = -1, i1; i < n; ++i) {
    switch (s[i]) {
      case ".": i0 = i1 = i; break;
      case "0": if (i0 === 0) i0 = i; i1 = i; break;
      default: if (!+s[i]) break out; if (i0 > 0) i0 = 0; break;
    }
  }
  return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

;// CONCATENATED MODULE: ./node_modules/d3-format/src/formatPrefixAuto.js


var prefixExponent;

/* harmony default export */ function formatPrefixAuto(x, p) {
  var d = formatDecimalParts(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1],
      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
      n = coefficient.length;
  return i === n ? coefficient
      : i > n ? coefficient + new Array(i - n + 1).join("0")
      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
      : "0." + new Array(1 - i).join("0") + formatDecimalParts(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}

;// CONCATENATED MODULE: ./node_modules/d3-format/src/formatRounded.js


/* harmony default export */ function formatRounded(x, p) {
  var d = formatDecimalParts(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1];
  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

;// CONCATENATED MODULE: ./node_modules/d3-format/src/formatTypes.js




/* harmony default export */ var formatTypes = ({
  "%": function(x, p) { return (x * 100).toFixed(p); },
  "b": function(x) { return Math.round(x).toString(2); },
  "c": function(x) { return x + ""; },
  "d": formatDecimal,
  "e": function(x, p) { return x.toExponential(p); },
  "f": function(x, p) { return x.toFixed(p); },
  "g": function(x, p) { return x.toPrecision(p); },
  "o": function(x) { return Math.round(x).toString(8); },
  "p": function(x, p) { return formatRounded(x * 100, p); },
  "r": formatRounded,
  "s": formatPrefixAuto,
  "X": function(x) { return Math.round(x).toString(16).toUpperCase(); },
  "x": function(x) { return Math.round(x).toString(16); }
});

;// CONCATENATED MODULE: ./node_modules/d3-format/src/identity.js
/* harmony default export */ function identity(x) {
  return x;
}

;// CONCATENATED MODULE: ./node_modules/d3-format/src/locale.js









var map = Array.prototype.map,
    prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];

/* harmony default export */ function locale(locale) {
  var group = locale.grouping === undefined || locale.thousands === undefined ? identity : formatGroup(map.call(locale.grouping, Number), locale.thousands + ""),
      currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "",
      currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "",
      decimal = locale.decimal === undefined ? "." : locale.decimal + "",
      numerals = locale.numerals === undefined ? identity : formatNumerals(map.call(locale.numerals, String)),
      percent = locale.percent === undefined ? "%" : locale.percent + "",
      minus = locale.minus === undefined ? "-" : locale.minus + "",
      nan = locale.nan === undefined ? "NaN" : locale.nan + "";

  function newFormat(specifier) {
    specifier = formatSpecifier(specifier);

    var fill = specifier.fill,
        align = specifier.align,
        sign = specifier.sign,
        symbol = specifier.symbol,
        zero = specifier.zero,
        width = specifier.width,
        comma = specifier.comma,
        precision = specifier.precision,
        trim = specifier.trim,
        type = specifier.type;

    // The "n" type is an alias for ",g".
    if (type === "n") comma = true, type = "g";

    // The "" type, and any invalid type, is an alias for ".12~g".
    else if (!formatTypes[type]) precision === undefined && (precision = 12), trim = true, type = "g";

    // If zero fill is specified, padding goes after sign and before digits.
    if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";

    // Compute the prefix and suffix.
    // For SI-prefix, the suffix is lazily computed.
    var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
        suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";

    // What format function should we use?
    // Is this an integer type?
    // Can this type generate exponential notation?
    var formatType = formatTypes[type],
        maybeSuffix = /[defgprs%]/.test(type);

    // Set the default precision if not specified,
    // or clamp the specified precision to the supported range.
    // For significant precision, it must be in [1, 21].
    // For fixed precision, it must be in [0, 20].
    precision = precision === undefined ? 6
        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
        : Math.max(0, Math.min(20, precision));

    function format(value) {
      var valuePrefix = prefix,
          valueSuffix = suffix,
          i, n, c;

      if (type === "c") {
        valueSuffix = formatType(value) + valueSuffix;
        value = "";
      } else {
        value = +value;

        // Determine the sign. -0 is not less than 0, but 1 / -0 is!
        var valueNegative = value < 0 || 1 / value < 0;

        // Perform the initial formatting.
        value = isNaN(value) ? nan : formatType(Math.abs(value), precision);

        // Trim insignificant zeros.
        if (trim) value = formatTrim(value);

        // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
        if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;

        // Compute the prefix and suffix.
        valuePrefix = (valueNegative ? (sign === "(" ? sign : minus) : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
        valueSuffix = (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");

        // Break the formatted value into the integer “value” part that can be
        // grouped, and fractional or exponential “suffix” part that is not.
        if (maybeSuffix) {
          i = -1, n = value.length;
          while (++i < n) {
            if (c = value.charCodeAt(i), 48 > c || c > 57) {
              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
              value = value.slice(0, i);
              break;
            }
          }
        }
      }

      // If the fill character is not "0", grouping is applied before padding.
      if (comma && !zero) value = group(value, Infinity);

      // Compute the padding.
      var length = valuePrefix.length + value.length + valueSuffix.length,
          padding = length < width ? new Array(width - length + 1).join(fill) : "";

      // If the fill character is "0", grouping is applied after padding.
      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";

      // Reconstruct the final output based on the desired alignment.
      switch (align) {
        case "<": value = valuePrefix + value + valueSuffix + padding; break;
        case "=": value = valuePrefix + padding + value + valueSuffix; break;
        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
        default: value = padding + valuePrefix + value + valueSuffix; break;
      }

      return numerals(value);
    }

    format.toString = function() {
      return specifier + "";
    };

    return format;
  }

  function formatPrefix(specifier, value) {
    var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)),
        e = Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3,
        k = Math.pow(10, -e),
        prefix = prefixes[8 + e / 3];
    return function(value) {
      return f(k * value) + prefix;
    };
  }

  return {
    format: newFormat,
    formatPrefix: formatPrefix
  };
}

;// CONCATENATED MODULE: ./node_modules/d3-format/src/defaultLocale.js


var defaultLocale_locale;
var format;
var formatPrefix;

defaultLocale({
  decimal: ".",
  thousands: ",",
  grouping: [3],
  currency: ["$", ""],
  minus: "-"
});

function defaultLocale(definition) {
  defaultLocale_locale = locale(definition);
  format = defaultLocale_locale.format;
  formatPrefix = defaultLocale_locale.formatPrefix;
  return defaultLocale_locale;
}

;// CONCATENATED MODULE: ./node_modules/d3-format/src/index.js








/***/ }),

/***/ 75987:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  geoAiry: function() { return /* reexport */ airy; },
  geoAiryRaw: function() { return /* reexport */ airyRaw; },
  geoAitoff: function() { return /* reexport */ aitoff; },
  geoAitoffRaw: function() { return /* reexport */ aitoffRaw; },
  geoArmadillo: function() { return /* reexport */ armadillo; },
  geoArmadilloRaw: function() { return /* reexport */ armadilloRaw; },
  geoAugust: function() { return /* reexport */ august; },
  geoAugustRaw: function() { return /* reexport */ augustRaw; },
  geoBaker: function() { return /* reexport */ baker; },
  geoBakerRaw: function() { return /* reexport */ bakerRaw; },
  geoBerghaus: function() { return /* reexport */ berghaus; },
  geoBerghausRaw: function() { return /* reexport */ berghausRaw; },
  geoBertin1953: function() { return /* reexport */ bertin; },
  geoBertin1953Raw: function() { return /* reexport */ bertin1953Raw; },
  geoBoggs: function() { return /* reexport */ boggs; },
  geoBoggsRaw: function() { return /* reexport */ boggsRaw; },
  geoBonne: function() { return /* reexport */ bonne; },
  geoBonneRaw: function() { return /* reexport */ bonneRaw; },
  geoBottomley: function() { return /* reexport */ bottomley; },
  geoBottomleyRaw: function() { return /* reexport */ bottomleyRaw; },
  geoBromley: function() { return /* reexport */ bromley; },
  geoBromleyRaw: function() { return /* reexport */ bromleyRaw; },
  geoChamberlin: function() { return /* reexport */ chamberlin; },
  geoChamberlinAfrica: function() { return /* reexport */ chamberlinAfrica; },
  geoChamberlinRaw: function() { return /* reexport */ chamberlinRaw; },
  geoCollignon: function() { return /* reexport */ collignon; },
  geoCollignonRaw: function() { return /* reexport */ collignonRaw; },
  geoCraig: function() { return /* reexport */ craig; },
  geoCraigRaw: function() { return /* reexport */ craigRaw; },
  geoCraster: function() { return /* reexport */ craster; },
  geoCrasterRaw: function() { return /* reexport */ crasterRaw; },
  geoCylindricalEqualArea: function() { return /* reexport */ cylindricalEqualArea; },
  geoCylindricalEqualAreaRaw: function() { return /* reexport */ cylindricalEqualAreaRaw; },
  geoCylindricalStereographic: function() { return /* reexport */ cylindricalStereographic; },
  geoCylindricalStereographicRaw: function() { return /* reexport */ cylindricalStereographicRaw; },
  geoEckert1: function() { return /* reexport */ eckert1; },
  geoEckert1Raw: function() { return /* reexport */ eckert1Raw; },
  geoEckert2: function() { return /* reexport */ eckert2; },
  geoEckert2Raw: function() { return /* reexport */ eckert2Raw; },
  geoEckert3: function() { return /* reexport */ eckert3; },
  geoEckert3Raw: function() { return /* reexport */ eckert3Raw; },
  geoEckert4: function() { return /* reexport */ eckert4; },
  geoEckert4Raw: function() { return /* reexport */ eckert4Raw; },
  geoEckert5: function() { return /* reexport */ eckert5; },
  geoEckert5Raw: function() { return /* reexport */ eckert5Raw; },
  geoEckert6: function() { return /* reexport */ eckert6; },
  geoEckert6Raw: function() { return /* reexport */ eckert6Raw; },
  geoEisenlohr: function() { return /* reexport */ eisenlohr; },
  geoEisenlohrRaw: function() { return /* reexport */ eisenlohrRaw; },
  geoFahey: function() { return /* reexport */ fahey; },
  geoFaheyRaw: function() { return /* reexport */ faheyRaw; },
  geoFoucaut: function() { return /* reexport */ foucaut; },
  geoFoucautRaw: function() { return /* reexport */ foucautRaw; },
  geoFoucautSinusoidal: function() { return /* reexport */ foucautSinusoidal; },
  geoFoucautSinusoidalRaw: function() { return /* reexport */ foucautSinusoidalRaw; },
  geoGilbert: function() { return /* reexport */ gilbert; },
  geoGingery: function() { return /* reexport */ gingery; },
  geoGingeryRaw: function() { return /* reexport */ gingeryRaw; },
  geoGinzburg4: function() { return /* reexport */ ginzburg4; },
  geoGinzburg4Raw: function() { return /* reexport */ ginzburg4Raw; },
  geoGinzburg5: function() { return /* reexport */ ginzburg5; },
  geoGinzburg5Raw: function() { return /* reexport */ ginzburg5Raw; },
  geoGinzburg6: function() { return /* reexport */ ginzburg6; },
  geoGinzburg6Raw: function() { return /* reexport */ ginzburg6Raw; },
  geoGinzburg8: function() { return /* reexport */ ginzburg8; },
  geoGinzburg8Raw: function() { return /* reexport */ ginzburg8Raw; },
  geoGinzburg9: function() { return /* reexport */ ginzburg9; },
  geoGinzburg9Raw: function() { return /* reexport */ ginzburg9Raw; },
  geoGringorten: function() { return /* reexport */ gringorten; },
  geoGringortenQuincuncial: function() { return /* reexport */ quincuncial_gringorten; },
  geoGringortenRaw: function() { return /* reexport */ gringortenRaw; },
  geoGuyou: function() { return /* reexport */ guyou; },
  geoGuyouRaw: function() { return /* reexport */ guyouRaw; },
  geoHammer: function() { return /* reexport */ hammer; },
  geoHammerRaw: function() { return /* reexport */ hammerRaw; },
  geoHammerRetroazimuthal: function() { return /* reexport */ hammerRetroazimuthal; },
  geoHammerRetroazimuthalRaw: function() { return /* reexport */ hammerRetroazimuthalRaw; },
  geoHealpix: function() { return /* reexport */ healpix; },
  geoHealpixRaw: function() { return /* reexport */ healpixRaw; },
  geoHill: function() { return /* reexport */ hill; },
  geoHillRaw: function() { return /* reexport */ hillRaw; },
  geoHomolosine: function() { return /* reexport */ homolosine; },
  geoHomolosineRaw: function() { return /* reexport */ homolosineRaw; },
  geoHufnagel: function() { return /* reexport */ hufnagel; },
  geoHufnagelRaw: function() { return /* reexport */ hufnagelRaw; },
  geoHyperelliptical: function() { return /* reexport */ hyperelliptical; },
  geoHyperellipticalRaw: function() { return /* reexport */ hyperellipticalRaw; },
  geoInterrupt: function() { return /* reexport */ interrupted; },
  geoInterruptedBoggs: function() { return /* reexport */ interrupted_boggs; },
  geoInterruptedHomolosine: function() { return /* reexport */ interrupted_homolosine; },
  geoInterruptedMollweide: function() { return /* reexport */ interrupted_mollweide; },
  geoInterruptedMollweideHemispheres: function() { return /* reexport */ mollweideHemispheres; },
  geoInterruptedQuarticAuthalic: function() { return /* reexport */ quarticAuthalic; },
  geoInterruptedSinuMollweide: function() { return /* reexport */ interrupted_sinuMollweide; },
  geoInterruptedSinusoidal: function() { return /* reexport */ interrupted_sinusoidal; },
  geoKavrayskiy7: function() { return /* reexport */ kavrayskiy7; },
  geoKavrayskiy7Raw: function() { return /* reexport */ kavrayskiy7Raw; },
  geoLagrange: function() { return /* reexport */ lagrange; },
  geoLagrangeRaw: function() { return /* reexport */ lagrangeRaw; },
  geoLarrivee: function() { return /* reexport */ larrivee; },
  geoLarriveeRaw: function() { return /* reexport */ larriveeRaw; },
  geoLaskowski: function() { return /* reexport */ laskowski; },
  geoLaskowskiRaw: function() { return /* reexport */ laskowskiRaw; },
  geoLittrow: function() { return /* reexport */ littrow; },
  geoLittrowRaw: function() { return /* reexport */ littrowRaw; },
  geoLoximuthal: function() { return /* reexport */ loximuthal; },
  geoLoximuthalRaw: function() { return /* reexport */ loximuthalRaw; },
  geoMiller: function() { return /* reexport */ miller; },
  geoMillerRaw: function() { return /* reexport */ millerRaw; },
  geoModifiedStereographic: function() { return /* reexport */ modifiedStereographic; },
  geoModifiedStereographicAlaska: function() { return /* reexport */ modifiedStereographicAlaska; },
  geoModifiedStereographicGs48: function() { return /* reexport */ modifiedStereographicGs48; },
  geoModifiedStereographicGs50: function() { return /* reexport */ modifiedStereographicGs50; },
  geoModifiedStereographicLee: function() { return /* reexport */ modifiedStereographicLee; },
  geoModifiedStereographicMiller: function() { return /* reexport */ modifiedStereographicMiller; },
  geoModifiedStereographicRaw: function() { return /* reexport */ modifiedStereographicRaw; },
  geoMollweide: function() { return /* reexport */ mollweide; },
  geoMollweideRaw: function() { return /* reexport */ mollweideRaw; },
  geoMtFlatPolarParabolic: function() { return /* reexport */ mtFlatPolarParabolic; },
  geoMtFlatPolarParabolicRaw: function() { return /* reexport */ mtFlatPolarParabolicRaw; },
  geoMtFlatPolarQuartic: function() { return /* reexport */ mtFlatPolarQuartic; },
  geoMtFlatPolarQuarticRaw: function() { return /* reexport */ mtFlatPolarQuarticRaw; },
  geoMtFlatPolarSinusoidal: function() { return /* reexport */ mtFlatPolarSinusoidal; },
  geoMtFlatPolarSinusoidalRaw: function() { return /* reexport */ mtFlatPolarSinusoidalRaw; },
  geoNaturalEarth: function() { return /* reexport */ naturalEarth1/* default */.A; },
  geoNaturalEarth2: function() { return /* reexport */ naturalEarth2; },
  geoNaturalEarth2Raw: function() { return /* reexport */ naturalEarth2Raw; },
  geoNaturalEarthRaw: function() { return /* reexport */ naturalEarth1/* naturalEarth1Raw */.P; },
  geoNellHammer: function() { return /* reexport */ nellHammer; },
  geoNellHammerRaw: function() { return /* reexport */ nellHammerRaw; },
  geoNicolosi: function() { return /* reexport */ nicolosi; },
  geoNicolosiRaw: function() { return /* reexport */ nicolosiRaw; },
  geoPatterson: function() { return /* reexport */ patterson; },
  geoPattersonRaw: function() { return /* reexport */ pattersonRaw; },
  geoPeirceQuincuncial: function() { return /* reexport */ peirce; },
  geoPierceQuincuncial: function() { return /* reexport */ peirce; },
  geoPolyconic: function() { return /* reexport */ polyconic; },
  geoPolyconicRaw: function() { return /* reexport */ polyconicRaw; },
  geoPolyhedral: function() { return /* reexport */ polyhedral; },
  geoPolyhedralButterfly: function() { return /* reexport */ butterfly; },
  geoPolyhedralCollignon: function() { return /* reexport */ polyhedral_collignon; },
  geoPolyhedralWaterman: function() { return /* reexport */ waterman; },
  geoProject: function() { return /* reexport */ project; },
  geoQuantize: function() { return /* reexport */ quantize; },
  geoQuincuncial: function() { return /* reexport */ quincuncial; },
  geoRectangularPolyconic: function() { return /* reexport */ rectangularPolyconic; },
  geoRectangularPolyconicRaw: function() { return /* reexport */ rectangularPolyconicRaw; },
  geoRobinson: function() { return /* reexport */ robinson; },
  geoRobinsonRaw: function() { return /* reexport */ robinsonRaw; },
  geoSatellite: function() { return /* reexport */ satellite; },
  geoSatelliteRaw: function() { return /* reexport */ satelliteRaw; },
  geoSinuMollweide: function() { return /* reexport */ sinuMollweide; },
  geoSinuMollweideRaw: function() { return /* reexport */ sinuMollweideRaw; },
  geoSinusoidal: function() { return /* reexport */ sinusoidal; },
  geoSinusoidalRaw: function() { return /* reexport */ sinusoidalRaw; },
  geoStitch: function() { return /* reexport */ stitch; },
  geoTimes: function() { return /* reexport */ times; },
  geoTimesRaw: function() { return /* reexport */ timesRaw; },
  geoTwoPointAzimuthal: function() { return /* reexport */ twoPointAzimuthal; },
  geoTwoPointAzimuthalRaw: function() { return /* reexport */ twoPointAzimuthalRaw; },
  geoTwoPointAzimuthalUsa: function() { return /* reexport */ twoPointAzimuthalUsa; },
  geoTwoPointEquidistant: function() { return /* reexport */ twoPointEquidistant; },
  geoTwoPointEquidistantRaw: function() { return /* reexport */ twoPointEquidistantRaw; },
  geoTwoPointEquidistantUsa: function() { return /* reexport */ twoPointEquidistantUsa; },
  geoVanDerGrinten: function() { return /* reexport */ vanDerGrinten; },
  geoVanDerGrinten2: function() { return /* reexport */ vanDerGrinten2; },
  geoVanDerGrinten2Raw: function() { return /* reexport */ vanDerGrinten2Raw; },
  geoVanDerGrinten3: function() { return /* reexport */ vanDerGrinten3; },
  geoVanDerGrinten3Raw: function() { return /* reexport */ vanDerGrinten3Raw; },
  geoVanDerGrinten4: function() { return /* reexport */ vanDerGrinten4; },
  geoVanDerGrinten4Raw: function() { return /* reexport */ vanDerGrinten4Raw; },
  geoVanDerGrintenRaw: function() { return /* reexport */ vanDerGrintenRaw; },
  geoWagner: function() { return /* reexport */ wagner; },
  geoWagner4: function() { return /* reexport */ wagner4; },
  geoWagner4Raw: function() { return /* reexport */ wagner4Raw; },
  geoWagner6: function() { return /* reexport */ wagner6; },
  geoWagner6Raw: function() { return /* reexport */ wagner6Raw; },
  geoWagner7: function() { return /* reexport */ wagner7; },
  geoWagnerRaw: function() { return /* reexport */ wagnerRaw; },
  geoWiechel: function() { return /* reexport */ wiechel; },
  geoWiechelRaw: function() { return /* reexport */ wiechelRaw; },
  geoWinkel3: function() { return /* reexport */ winkel3; },
  geoWinkel3Raw: function() { return /* reexport */ winkel3Raw; }
});

// EXTERNAL MODULE: ./node_modules/d3-geo/src/projection/index.js + 1 modules
var src_projection = __webpack_require__(94684);
;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/math.js
var abs = Math.abs;
var atan = Math.atan;
var atan2 = Math.atan2;
var ceil = Math.ceil;
var cos = Math.cos;
var exp = Math.exp;
var floor = Math.floor;
var log = Math.log;
var max = Math.max;
var min = Math.min;
var pow = Math.pow;
var round = Math.round;
var sign = Math.sign || function(x) { return x > 0 ? 1 : x < 0 ? -1 : 0; };
var sin = Math.sin;
var tan = Math.tan;

var epsilon = 1e-6;
var epsilon2 = 1e-12;
var pi = Math.PI;
var halfPi = pi / 2;
var quarterPi = pi / 4;
var sqrt1_2 = Math.SQRT1_2;
var sqrt2 = sqrt(2);
var sqrtPi = sqrt(pi);
var tau = pi * 2;
var degrees = 180 / pi;
var radians = pi / 180;

function sinci(x) {
  return x ? x / Math.sin(x) : 1;
}

function asin(x) {
  return x > 1 ? halfPi : x < -1 ? -halfPi : Math.asin(x);
}

function acos(x) {
  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}

function sqrt(x) {
  return x > 0 ? Math.sqrt(x) : 0;
}

function tanh(x) {
  x = exp(2 * x);
  return (x - 1) / (x + 1);
}

function sinh(x) {
  return (exp(x) - exp(-x)) / 2;
}

function cosh(x) {
  return (exp(x) + exp(-x)) / 2;
}

function arsinh(x) {
  return log(x + sqrt(x * x + 1));
}

function arcosh(x) {
  return log(x + sqrt(x * x - 1));
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/airy.js



function airyRaw(beta) {
  var tanBeta_2 = tan(beta / 2),
      b = 2 * log(cos(beta / 2)) / (tanBeta_2 * tanBeta_2);

  function forward(x, y) {
    var cosx = cos(x),
        cosy = cos(y),
        siny = sin(y),
        cosz = cosy * cosx,
        k = -((1 - cosz ? log((1 + cosz) / 2) / (1 - cosz) : -0.5) + b / (1 + cosz));
    return [k * cosy * sin(x), k * siny];
  }

  forward.invert = function(x, y) {
    var r = sqrt(x * x + y * y),
        z = -beta / 2,
        i = 50, delta;
    if (!r) return [0, 0];
    do {
      var z_2 = z / 2,
          cosz_2 = cos(z_2),
          sinz_2 = sin(z_2),
          tanz_2 = sinz_2 / cosz_2,
          lnsecz_2 = -log(abs(cosz_2));
      z -= delta = (2 / tanz_2 * lnsecz_2 - b * tanz_2 - r) / (-lnsecz_2 / (sinz_2 * sinz_2) + 1 - b / (2 * cosz_2 * cosz_2)) * (cosz_2 < 0 ? 0.7 : 1);
    } while (abs(delta) > epsilon && --i > 0);
    var sinz = sin(z);
    return [atan2(x * sinz, r * cos(z)), asin(y * sinz / r)];
  };

  return forward;
}

/* harmony default export */ function airy() {
  var beta = halfPi,
      m = (0,src_projection/* projectionMutator */.U)(airyRaw),
      p = m(beta);

  p.radius = function(_) {
    return arguments.length ? m(beta = _ * radians) : beta * degrees;
  };

  return p
      .scale(179.976)
      .clipAngle(147);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/aitoff.js



function aitoffRaw(x, y) {
  var cosy = cos(y), sincia = sinci(acos(cosy * cos(x /= 2)));
  return [2 * cosy * sin(x) * sincia, sin(y) * sincia];
}

// Abort if [x, y] is not within an ellipse centered at [0, 0] with
// semi-major axis pi and semi-minor axis pi/2.
aitoffRaw.invert = function(x, y) {
  if (x * x + 4 * y * y > pi * pi + epsilon) return;
  var x1 = x, y1 = y, i = 25;
  do {
    var sinx = sin(x1),
        sinx_2 = sin(x1 / 2),
        cosx_2 = cos(x1 / 2),
        siny = sin(y1),
        cosy = cos(y1),
        sin_2y = sin(2 * y1),
        sin2y = siny * siny,
        cos2y = cosy * cosy,
        sin2x_2 = sinx_2 * sinx_2,
        c = 1 - cos2y * cosx_2 * cosx_2,
        e = c ? acos(cosy * cosx_2) * sqrt(f = 1 / c) : f = 0,
        f,
        fx = 2 * e * cosy * sinx_2 - x,
        fy = e * siny - y,
        dxdx = f * (cos2y * sin2x_2 + e * cosy * cosx_2 * sin2y),
        dxdy = f * (0.5 * sinx * sin_2y - e * 2 * siny * sinx_2),
        dydx = f * 0.25 * (sin_2y * sinx_2 - e * siny * cos2y * sinx),
        dydy = f * (sin2y * cosx_2 + e * sin2x_2 * cosy),
        z = dxdy * dydx - dydy * dxdx;
    if (!z) break;
    var dx = (fy * dxdy - fx * dydy) / z,
        dy = (fx * dydx - fy * dxdx) / z;
    x1 -= dx, y1 -= dy;
  } while ((abs(dx) > epsilon || abs(dy) > epsilon) && --i > 0);
  return [x1, y1];
};

/* harmony default export */ function aitoff() {
  return (0,src_projection/* default */.A)(aitoffRaw)
      .scale(152.63);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/armadillo.js



function armadilloRaw(phi0) {
  var sinPhi0 = sin(phi0),
      cosPhi0 = cos(phi0),
      sPhi0 = phi0 >= 0 ? 1 : -1,
      tanPhi0 = tan(sPhi0 * phi0),
      k = (1 + sinPhi0 - cosPhi0) / 2;

  function forward(lambda, phi) {
    var cosPhi = cos(phi),
        cosLambda = cos(lambda /= 2);
    return [
      (1 + cosPhi) * sin(lambda),
      (sPhi0 * phi > -atan2(cosLambda, tanPhi0) - 1e-3 ? 0 : -sPhi0 * 10) + k + sin(phi) * cosPhi0 - (1 + cosPhi) * sinPhi0 * cosLambda // TODO D3 core should allow null or [NaN, NaN] to be returned.
    ];
  }

  forward.invert = function(x, y) {
    var lambda = 0,
        phi = 0,
        i = 50;
    do {
      var cosLambda = cos(lambda),
          sinLambda = sin(lambda),
          cosPhi = cos(phi),
          sinPhi = sin(phi),
          A = 1 + cosPhi,
          fx = A * sinLambda - x,
          fy = k + sinPhi * cosPhi0 - A * sinPhi0 * cosLambda - y,
          dxdLambda = A * cosLambda / 2,
          dxdPhi = -sinLambda * sinPhi,
          dydLambda = sinPhi0 * A * sinLambda / 2,
          dydPhi = cosPhi0 * cosPhi + sinPhi0 * cosLambda * sinPhi,
          denominator = dxdPhi * dydLambda - dydPhi * dxdLambda,
          dLambda = (fy * dxdPhi - fx * dydPhi) / denominator / 2,
          dPhi = (fx * dydLambda - fy * dxdLambda) / denominator;
      if (abs(dPhi) > 2) dPhi /= 2;
      lambda -= dLambda, phi -= dPhi;
    } while ((abs(dLambda) > epsilon || abs(dPhi) > epsilon) && --i > 0);
    return sPhi0 * phi > -atan2(cos(lambda), tanPhi0) - 1e-3 ? [lambda * 2, phi] : null;
  };

  return forward;
}

/* harmony default export */ function armadillo() {
  var phi0 = 20 * radians,
      sPhi0 = phi0 >= 0 ? 1 : -1,
      tanPhi0 = tan(sPhi0 * phi0),
      m = (0,src_projection/* projectionMutator */.U)(armadilloRaw),
      p = m(phi0),
      stream_ = p.stream;

  p.parallel = function(_) {
    if (!arguments.length) return phi0 * degrees;
    tanPhi0 = tan((sPhi0 = (phi0 = _ * radians) >= 0 ? 1 : -1) * phi0);
    return m(phi0);
  };

  p.stream = function(stream) {
    var rotate = p.rotate(),
        rotateStream = stream_(stream),
        sphereStream = (p.rotate([0, 0]), stream_(stream)),
        precision = p.precision();
    p.rotate(rotate);
    rotateStream.sphere = function() {
      sphereStream.polygonStart(), sphereStream.lineStart();
      for (var lambda = sPhi0 * -180; sPhi0 * lambda < 180; lambda += sPhi0 * 90)
        sphereStream.point(lambda, sPhi0 * 90);
      if (phi0) while (sPhi0 * (lambda -= 3 * sPhi0 * precision) >= -180) {
        sphereStream.point(lambda, sPhi0 * -atan2(cos(lambda * radians / 2), tanPhi0) * degrees);
      }
      sphereStream.lineEnd(), sphereStream.polygonEnd();
    };
    return rotateStream;
  };

  return p
      .scale(218.695)
      .center([0, 28.0974]);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/august.js



function augustRaw(lambda, phi) {
  var tanPhi = tan(phi / 2),
      k = sqrt(1 - tanPhi * tanPhi),
      c = 1 + k * cos(lambda /= 2),
      x = sin(lambda) * k / c,
      y = tanPhi / c,
      x2 = x * x,
      y2 = y * y;
  return [
    4 / 3 * x * (3 + x2 - 3 * y2),
    4 / 3 * y * (3 + 3 * x2 - y2)
  ];
}

augustRaw.invert = function(x, y) {
  x *= 3 / 8, y *= 3 / 8;
  if (!x && abs(y) > 1) return null;
  var x2 = x * x,
      y2 = y * y,
      s = 1 + x2 + y2,
      sin3Eta = sqrt((s - sqrt(s * s - 4 * y * y)) / 2),
      eta = asin(sin3Eta) / 3,
      xi = sin3Eta ? arcosh(abs(y / sin3Eta)) / 3 : arsinh(abs(x)) / 3,
      cosEta = cos(eta),
      coshXi = cosh(xi),
      d = coshXi * coshXi - cosEta * cosEta;
  return [
    sign(x) * 2 * atan2(sinh(xi) * cosEta, 0.25 - d),
    sign(y) * 2 * atan2(coshXi * sin(eta), 0.25 + d)
  ];
};

/* harmony default export */ function august() {
  return (0,src_projection/* default */.A)(augustRaw)
      .scale(66.1603);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/baker.js



var sqrt8 = sqrt(8),
    phi0 = log(1 + sqrt2);

function bakerRaw(lambda, phi) {
  var phi0 = abs(phi);
  return phi0 < quarterPi
      ? [lambda, log(tan(quarterPi + phi / 2))]
      : [lambda * cos(phi0) * (2 * sqrt2 - 1 / sin(phi0)), sign(phi) * (2 * sqrt2 * (phi0 - quarterPi) - log(tan(phi0 / 2)))];
}

bakerRaw.invert = function(x, y) {
  if ((y0 = abs(y)) < phi0) return [x, 2 * atan(exp(y)) - halfPi];
  var phi = quarterPi, i = 25, delta, y0;
  do {
    var cosPhi_2 = cos(phi / 2), tanPhi_2 = tan(phi / 2);
    phi -= delta = (sqrt8 * (phi - quarterPi) - log(tanPhi_2) - y0) / (sqrt8 - cosPhi_2 * cosPhi_2 / (2 * tanPhi_2));
  } while (abs(delta) > epsilon2 && --i > 0);
  return [x / (cos(phi) * (sqrt8 - 1 / sin(phi))), sign(y) * phi];
};

/* harmony default export */ function baker() {
  return (0,src_projection/* default */.A)(bakerRaw)
      .scale(112.314);
}

// EXTERNAL MODULE: ./node_modules/d3-geo/src/projection/azimuthalEquidistant.js
var azimuthalEquidistant = __webpack_require__(61957);
;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/berghaus.js



function berghausRaw(lobes) {
  var k = 2 * pi / lobes;

  function forward(lambda, phi) {
    var p = (0,azimuthalEquidistant/* azimuthalEquidistantRaw */.j)(lambda, phi);
    if (abs(lambda) > halfPi) { // back hemisphere
      var theta = atan2(p[1], p[0]),
          r = sqrt(p[0] * p[0] + p[1] * p[1]),
          theta0 = k * round((theta - halfPi) / k) + halfPi,
          alpha = atan2(sin(theta -= theta0), 2 - cos(theta)); // angle relative to lobe end
      theta = theta0 + asin(pi / r * sin(alpha)) - alpha;
      p[0] = r * cos(theta);
      p[1] = r * sin(theta);
    }
    return p;
  }

  forward.invert = function(x, y) {
    var r = sqrt(x * x + y * y);
    if (r > halfPi) {
      var theta = atan2(y, x),
          theta0 = k * round((theta - halfPi) / k) + halfPi,
          s = theta > theta0 ? -1 : 1,
          A = r * cos(theta0 - theta),
          cotAlpha = 1 / tan(s * acos((A - pi) / sqrt(pi * (pi - 2 * A) + r * r)));
      theta = theta0 + 2 * atan((cotAlpha + s * sqrt(cotAlpha * cotAlpha - 3)) / 3);
      x = r * cos(theta), y = r * sin(theta);
    }
    return azimuthalEquidistant/* azimuthalEquidistantRaw */.j.invert(x, y);
  };

  return forward;
}

/* harmony default export */ function berghaus() {
  var lobes = 5,
      m = (0,src_projection/* projectionMutator */.U)(berghausRaw),
      p = m(lobes),
      projectionStream = p.stream,
      epsilon = 1e-2,
      cr = -cos(epsilon * radians),
      sr = sin(epsilon * radians);

  p.lobes = function(_) {
    return arguments.length ? m(lobes = +_) : lobes;
  };

  p.stream = function(stream) {
    var rotate = p.rotate(),
        rotateStream = projectionStream(stream),
        sphereStream = (p.rotate([0, 0]), projectionStream(stream));
    p.rotate(rotate);
    rotateStream.sphere = function() {
      sphereStream.polygonStart(), sphereStream.lineStart();
      for (var i = 0, delta = 360 / lobes, delta0 = 2 * pi / lobes, phi = 90 - 180 / lobes, phi0 = halfPi; i < lobes; ++i, phi -= delta, phi0 -= delta0) {
        sphereStream.point(atan2(sr * cos(phi0), cr) * degrees, asin(sr * sin(phi0)) * degrees);
        if (phi < -90) {
          sphereStream.point(-90, -180 - phi - epsilon);
          sphereStream.point(-90, -180 - phi + epsilon);
        } else {
          sphereStream.point(90, phi + epsilon);
          sphereStream.point(90, phi - epsilon);
        }
      }
      sphereStream.lineEnd(), sphereStream.polygonEnd();
    };
    return rotateStream;
  };

  return p
      .scale(87.8076)
      .center([0, 17.1875])
      .clipAngle(180 - 1e-3);
}

// EXTERNAL MODULE: ./node_modules/d3-geo/src/projection/azimuthalEqualArea.js
var azimuthalEqualArea = __webpack_require__(30729);
;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/hammer.js



function hammerRaw(A, B) {
  if (arguments.length < 2) B = A;
  if (B === 1) return azimuthalEqualArea/* azimuthalEqualAreaRaw */.n;
  if (B === Infinity) return hammerQuarticAuthalicRaw;

  function forward(lambda, phi) {
    var coordinates = (0,azimuthalEqualArea/* azimuthalEqualAreaRaw */.n)(lambda / B, phi);
    coordinates[0] *= A;
    return coordinates;
  }

  forward.invert = function(x, y) {
    var coordinates = azimuthalEqualArea/* azimuthalEqualAreaRaw */.n.invert(x / A, y);
    coordinates[0] *= B;
    return coordinates;
  };

  return forward;
}

function hammerQuarticAuthalicRaw(lambda, phi) {
  return [
    lambda * cos(phi) / cos(phi /= 2),
    2 * sin(phi)
  ];
}

hammerQuarticAuthalicRaw.invert = function(x, y) {
  var phi = 2 * asin(y / 2);
  return [
    x * cos(phi / 2) / cos(phi),
    phi
  ];
};

/* harmony default export */ function hammer() {
  var B = 2,
      m = (0,src_projection/* projectionMutator */.U)(hammerRaw),
      p = m(B);

  p.coefficient = function(_) {
    if (!arguments.length) return B;
    return m(B = +_);
  };

  return p
    .scale(169.529);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/newton.js


// Approximate Newton-Raphson
// Solve f(x) = y, start from x
function solve(f, y, x) {
  var steps = 100, delta, f0, f1;
  x = x === undefined ? 0 : +x;
  y = +y;
  do {
    f0 = f(x);
    f1 = f(x + epsilon);
    if (f0 === f1) f1 = f0 + epsilon;
    x -= delta = (-1 * epsilon * (f0 - y)) / (f0 - f1);
  } while (steps-- > 0 && abs(delta) > epsilon);
  return steps < 0 ? NaN : x;
}

// Approximate Newton-Raphson in 2D
// Solve f(a,b) = [x,y]
function solve2d(f, MAX_ITERATIONS, eps) {
  if (MAX_ITERATIONS === undefined) MAX_ITERATIONS = 40;
  if (eps === undefined) eps = epsilon2;
  return function(x, y, a, b) {
    var err2, da, db;
    a = a === undefined ? 0 : +a;
    b = b === undefined ? 0 : +b;
    for (var i = 0; i < MAX_ITERATIONS; i++) {
      var p = f(a, b),
        // diffs
        tx = p[0] - x,
        ty = p[1] - y;
      if (abs(tx) < eps && abs(ty) < eps) break; // we're there!

      // backtrack if we overshot
      var h = tx * tx + ty * ty;
      if (h > err2) {
        a -= da /= 2;
        b -= db /= 2;
        continue;
      }
      err2 = h;

      // partial derivatives
      var ea = (a > 0 ? -1 : 1) * eps,
        eb = (b > 0 ? -1 : 1) * eps,
        pa = f(a + ea, b),
        pb = f(a, b + eb),
        dxa = (pa[0] - p[0]) / ea,
        dya = (pa[1] - p[1]) / ea,
        dxb = (pb[0] - p[0]) / eb,
        dyb = (pb[1] - p[1]) / eb,
        // determinant
        D = dyb * dxa - dya * dxb,
        // newton step — or half-step for small D
        l = (abs(D) < 0.5 ? 0.5 : 1) / D;
      da = (ty * dxb - tx * dyb) * l;
      db = (tx * dya - ty * dxa) * l;
      a += da;
      b += db;
      if (abs(da) < eps && abs(db) < eps) break; // we're crawling
    }
    return [a, b];
  };
}
;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/bertin.js





// Bertin 1953 as a modified Briesemeister
// https://bl.ocks.org/Fil/5b9ee9636dfb6ffa53443c9006beb642
function bertin1953Raw() {
  var hammer = hammerRaw(1.68, 2),
      fu = 1.4, k = 12;

  function forward(lambda, phi) {

    if (lambda + phi < -fu) {
      var u = (lambda - phi + 1.6) * (lambda + phi + fu) / 8;
      lambda += u;
      phi -= 0.8 * u * sin(phi + pi / 2);
    }

    var r = hammer(lambda, phi);

    var d = (1 - cos(lambda * phi)) / k;

    if (r[1] < 0) {
      r[0] *= 1 + d;
    }
    if (r[1] > 0) {
      r[1] *= 1 + d / 1.5 * r[0] * r[0];
    }

    return r;
  }
  
  forward.invert = solve2d(forward);
  return forward;
}

/* harmony default export */ function bertin() {
  // this projection should not be rotated
  return (0,src_projection/* default */.A)(bertin1953Raw())
    .rotate([-16.5, -42])
    .scale(176.57)
    .center([7.93, 0.09]);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/mollweide.js



function mollweideBromleyTheta(cp, phi) {
  var cpsinPhi = cp * sin(phi), i = 30, delta;
  do phi -= delta = (phi + sin(phi) - cpsinPhi) / (1 + cos(phi));
  while (abs(delta) > epsilon && --i > 0);
  return phi / 2;
}

function mollweideBromleyRaw(cx, cy, cp) {

  function forward(lambda, phi) {
    return [cx * lambda * cos(phi = mollweideBromleyTheta(cp, phi)), cy * sin(phi)];
  }

  forward.invert = function(x, y) {
    return y = asin(y / cy), [x / (cx * cos(y)), asin((2 * y + sin(2 * y)) / cp)];
  };

  return forward;
}

var mollweideRaw = mollweideBromleyRaw(sqrt2 / halfPi, sqrt2, pi);

/* harmony default export */ function mollweide() {
  return (0,src_projection/* default */.A)(mollweideRaw)
      .scale(169.529);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/boggs.js




var k = 2.00276,
    w = 1.11072;

function boggsRaw(lambda, phi) {
  var theta = mollweideBromleyTheta(pi, phi);
  return [k * lambda / (1 / cos(phi) + w / cos(theta)), (phi + sqrt2 * sin(theta)) / k];
}

boggsRaw.invert = function(x, y) {
  var ky = k * y, theta = y < 0 ? -quarterPi : quarterPi, i = 25, delta, phi;
  do {
    phi = ky - sqrt2 * sin(theta);
    theta -= delta = (sin(2 * theta) + 2 * theta - pi * sin(phi)) / (2 * cos(2 * theta) + 2 + pi * cos(phi) * sqrt2 * cos(theta));
  } while (abs(delta) > epsilon && --i > 0);
  phi = ky - sqrt2 * sin(theta);
  return [x * (1 / cos(phi) + w / cos(theta)) / k, phi];
};

/* harmony default export */ function boggs() {
  return (0,src_projection/* default */.A)(boggsRaw)
      .scale(160.857);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/parallel1.js



/* harmony default export */ function parallel1(projectAt) {
  var phi0 = 0,
      m = (0,src_projection/* projectionMutator */.U)(projectAt),
      p = m(phi0);

  p.parallel = function(_) {
    return arguments.length ? m(phi0 = _ * radians) : phi0 * degrees;
  };

  return p;
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/sinusoidal.js



function sinusoidalRaw(lambda, phi) {
  return [lambda * cos(phi), phi];
}

sinusoidalRaw.invert = function(x, y) {
  return [x / cos(y), y];
};

/* harmony default export */ function sinusoidal() {
  return (0,src_projection/* default */.A)(sinusoidalRaw)
      .scale(152.63);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/bonne.js




function bonneRaw(phi0) {
  if (!phi0) return sinusoidalRaw;
  var cotPhi0 = 1 / tan(phi0);

  function forward(lambda, phi) {
    var rho = cotPhi0 + phi0 - phi,
        e = rho ? lambda * cos(phi) / rho : rho;
    return [rho * sin(e), cotPhi0 - rho * cos(e)];
  }

  forward.invert = function(x, y) {
    var rho = sqrt(x * x + (y = cotPhi0 - y) * y),
        phi = cotPhi0 + phi0 - rho;
    return [rho / cos(phi) * atan2(x, y), phi];
  };

  return forward;
}

/* harmony default export */ function bonne() {
  return parallel1(bonneRaw)
      .scale(123.082)
      .center([0, 26.1441])
      .parallel(45);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/bottomley.js



function bottomleyRaw(sinPsi) {

  function forward(lambda, phi) {
    var rho = halfPi - phi,
        eta = rho ? lambda * sinPsi * sin(rho) / rho : rho;
    return [rho * sin(eta) / sinPsi, halfPi - rho * cos(eta)];
  }

  forward.invert = function(x, y) {
    var x1 = x * sinPsi,
        y1 = halfPi - y,
        rho = sqrt(x1 * x1 + y1 * y1),
        eta = atan2(x1, y1);
    return [(rho ? rho / sin(rho) : 1) * eta / sinPsi, halfPi - rho];
  };

  return forward;
}

/* harmony default export */ function bottomley() {
  var sinPsi = 0.5,
      m = (0,src_projection/* projectionMutator */.U)(bottomleyRaw),
      p = m(sinPsi);

  p.fraction = function(_) {
    return arguments.length ? m(sinPsi = +_) : sinPsi;
  };

  return p
      .scale(158.837);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/bromley.js




var bromleyRaw = mollweideBromleyRaw(1, 4 / pi, pi);

/* harmony default export */ function bromley() {
  return (0,src_projection/* default */.A)(bromleyRaw)
      .scale(152.63);
}

// EXTERNAL MODULE: ./node_modules/d3-geo/src/centroid.js
var centroid = __webpack_require__(30021);
// EXTERNAL MODULE: ./node_modules/d3-geo/src/rotation.js
var rotation = __webpack_require__(30915);
;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/chamberlin.js




// Azimuthal distance.
function distance(dPhi, c1, s1, c2, s2, dLambda) {
  var cosdLambda = cos(dLambda), r;
  if (abs(dPhi) > 1 || abs(dLambda) > 1) {
    r = acos(s1 * s2 + c1 * c2 * cosdLambda);
  } else {
    var sindPhi = sin(dPhi / 2), sindLambda = sin(dLambda / 2);
    r = 2 * asin(sqrt(sindPhi * sindPhi + c1 * c2 * sindLambda * sindLambda));
  }
  return abs(r) > epsilon ? [r, atan2(c2 * sin(dLambda), c1 * s2 - s1 * c2 * cosdLambda)] : [0, 0];
}

// Angle opposite a, and contained between sides of lengths b and c.
function angle(b, c, a) {
  return acos((b * b + c * c - a * a) / (2 * b * c));
}

// Normalize longitude.
function longitude(lambda) {
  return lambda - 2 * pi * floor((lambda + pi) / (2 * pi));
}

function chamberlinRaw(p0, p1, p2) {
  var points = [
    [p0[0], p0[1], sin(p0[1]), cos(p0[1])],
    [p1[0], p1[1], sin(p1[1]), cos(p1[1])],
    [p2[0], p2[1], sin(p2[1]), cos(p2[1])]
  ];

  for (var a = points[2], b, i = 0; i < 3; ++i, a = b) {
    b = points[i];
    a.v = distance(b[1] - a[1], a[3], a[2], b[3], b[2], b[0] - a[0]);
    a.point = [0, 0];
  }

  var beta0 = angle(points[0].v[0], points[2].v[0], points[1].v[0]),
      beta1 = angle(points[0].v[0], points[1].v[0], points[2].v[0]),
      beta2 = pi - beta0;

  points[2].point[1] = 0;
  points[0].point[0] = -(points[1].point[0] = points[0].v[0] / 2);

  var mean = [
    points[2].point[0] = points[0].point[0] + points[2].v[0] * cos(beta0),
    2 * (points[0].point[1] = points[1].point[1] = points[2].v[0] * sin(beta0))
  ];

  function forward(lambda, phi) {
    var sinPhi = sin(phi),
        cosPhi = cos(phi),
        v = new Array(3), i;

    // Compute distance and azimuth from control points.
    for (i = 0; i < 3; ++i) {
      var p = points[i];
      v[i] = distance(phi - p[1], p[3], p[2], cosPhi, sinPhi, lambda - p[0]);
      if (!v[i][0]) return p.point;
      v[i][1] = longitude(v[i][1] - p.v[1]);
    }

    // Arithmetic mean of interception points.
    var point = mean.slice();
    for (i = 0; i < 3; ++i) {
      var j = i == 2 ? 0 : i + 1;
      var a = angle(points[i].v[0], v[i][0], v[j][0]);
      if (v[i][1] < 0) a = -a;

      if (!i) {
        point[0] += v[i][0] * cos(a);
        point[1] -= v[i][0] * sin(a);
      } else if (i == 1) {
        a = beta1 - a;
        point[0] -= v[i][0] * cos(a);
        point[1] -= v[i][0] * sin(a);
      } else {
        a = beta2 - a;
        point[0] += v[i][0] * cos(a);
        point[1] += v[i][0] * sin(a);
      }
    }

    point[0] /= 3, point[1] /= 3;
    return point;
  }

  return forward;
}

function pointRadians(p) {
  return p[0] *= radians, p[1] *= radians, p;
}

function chamberlinAfrica() {
  return chamberlin([0, 22], [45, 22], [22.5, -22])
      .scale(380)
      .center([22.5, 2]);
}

function chamberlin(p0, p1, p2) { // TODO order matters!
  var c = (0,centroid/* default */.A)({type: "MultiPoint", coordinates: [p0, p1, p2]}),
      R = [-c[0], -c[1]],
      r = (0,rotation/* default */.A)(R),
      f = chamberlinRaw(pointRadians(r(p0)), pointRadians(r(p1)), pointRadians(r(p2)));
  f.invert = solve2d(f);
  var p = (0,src_projection/* default */.A)(f).rotate(R),
      center = p.center;

  delete p.rotate;

  p.center = function(_) {
    return arguments.length ? center(r(_)) : r.invert(center());
  };

  return p
      .clipAngle(90);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/collignon.js



function collignonRaw(lambda, phi) {
  var alpha = sqrt(1 - sin(phi));
  return [(2 / sqrtPi) * lambda * alpha, sqrtPi * (1 - alpha)];
}

collignonRaw.invert = function(x, y) {
  var lambda = (lambda = y / sqrtPi - 1) * lambda;
  return [lambda > 0 ? x * sqrt(pi / lambda) / 2 : 0, asin(1 - lambda)];
};

/* harmony default export */ function collignon() {
  return (0,src_projection/* default */.A)(collignonRaw)
      .scale(95.6464)
      .center([0, 30]);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/craig.js



function craigRaw(phi0) {
  var tanPhi0 = tan(phi0);

  function forward(lambda, phi) {
    return [lambda, (lambda ? lambda / sin(lambda) : 1) * (sin(phi) * cos(lambda) - tanPhi0 * cos(phi))];
  }

  forward.invert = tanPhi0 ? function(x, y) {
    if (x) y *= sin(x) / x;
    var cosLambda = cos(x);
    return [x, 2 * atan2(sqrt(cosLambda * cosLambda + tanPhi0 * tanPhi0 - y * y) - cosLambda, tanPhi0 - y)];
  } : function(x, y) {
    return [x, asin(x ? y * tan(x) / x : y)];
  };

  return forward;
}

/* harmony default export */ function craig() {
  return parallel1(craigRaw)
      .scale(249.828)
      .clipAngle(90);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/craster.js



var sqrt3 = sqrt(3);

function crasterRaw(lambda, phi) {
  return [sqrt3 * lambda * (2 * cos(2 * phi / 3) - 1) / sqrtPi, sqrt3 * sqrtPi * sin(phi / 3)];
}

crasterRaw.invert = function(x, y) {
  var phi = 3 * asin(y / (sqrt3 * sqrtPi));
  return [sqrtPi * x / (sqrt3 * (2 * cos(2 * phi / 3) - 1)), phi];
};

/* harmony default export */ function craster() {
  return (0,src_projection/* default */.A)(crasterRaw)
      .scale(156.19);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/cylindricalEqualArea.js



function cylindricalEqualAreaRaw(phi0) {
  var cosPhi0 = cos(phi0);

  function forward(lambda, phi) {
    return [lambda * cosPhi0, sin(phi) / cosPhi0];
  }

  forward.invert = function(x, y) {
    return [x / cosPhi0, asin(y * cosPhi0)];
  };

  return forward;
}

/* harmony default export */ function cylindricalEqualArea() {
  return parallel1(cylindricalEqualAreaRaw)
      .parallel(38.58) // acos(sqrt(width / height / pi)) * radians
      .scale(195.044); // width / (sqrt(width / height / pi) * 2 * pi)
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/cylindricalStereographic.js



function cylindricalStereographicRaw(phi0) {
  var cosPhi0 = cos(phi0);

  function forward(lambda, phi) {
    return [lambda * cosPhi0, (1 + cosPhi0) * tan(phi / 2)];
  }

  forward.invert = function(x, y) {
    return [x / cosPhi0, atan(y / (1 + cosPhi0)) * 2];
  };

  return forward;
}

/* harmony default export */ function cylindricalStereographic() {
  return parallel1(cylindricalStereographicRaw)
      .scale(124.75);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/eckert1.js



function eckert1Raw(lambda, phi) {
  var alpha = sqrt(8 / (3 * pi));
  return [
    alpha * lambda * (1 - abs(phi) / pi),
    alpha * phi
  ];
}

eckert1Raw.invert = function(x, y) {
  var alpha = sqrt(8 / (3 * pi)),
      phi = y / alpha;
  return [
    x / (alpha * (1 - abs(phi) / pi)),
    phi
  ];
};

/* harmony default export */ function eckert1() {
  return (0,src_projection/* default */.A)(eckert1Raw)
      .scale(165.664);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/eckert2.js



function eckert2Raw(lambda, phi) {
  var alpha = sqrt(4 - 3 * sin(abs(phi)));
  return [
    2 / sqrt(6 * pi) * lambda * alpha,
    sign(phi) * sqrt(2 * pi / 3) * (2 - alpha)
  ];
}

eckert2Raw.invert = function(x, y) {
  var alpha = 2 - abs(y) / sqrt(2 * pi / 3);
  return [
    x * sqrt(6 * pi) / (2 * alpha),
    sign(y) * asin((4 - alpha * alpha) / 3)
  ];
};

/* harmony default export */ function eckert2() {
  return (0,src_projection/* default */.A)(eckert2Raw)
      .scale(165.664);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/eckert3.js



function eckert3Raw(lambda, phi) {
  var k = sqrt(pi * (4 + pi));
  return [
    2 / k * lambda * (1 + sqrt(1 - 4 * phi * phi / (pi * pi))),
    4 / k * phi
  ];
}

eckert3Raw.invert = function(x, y) {
  var k = sqrt(pi * (4 + pi)) / 2;
  return [
    x * k / (1 + sqrt(1 - y * y * (4 + pi) / (4 * pi))),
    y * k / 2
  ];
};

/* harmony default export */ function eckert3() {
  return (0,src_projection/* default */.A)(eckert3Raw)
      .scale(180.739);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/eckert4.js



function eckert4Raw(lambda, phi) {
  var k = (2 + halfPi) * sin(phi);
  phi /= 2;
  for (var i = 0, delta = Infinity; i < 10 && abs(delta) > epsilon; i++) {
    var cosPhi = cos(phi);
    phi -= delta = (phi + sin(phi) * (cosPhi + 2) - k) / (2 * cosPhi * (1 + cosPhi));
  }
  return [
    2 / sqrt(pi * (4 + pi)) * lambda * (1 + cos(phi)),
    2 * sqrt(pi / (4 + pi)) * sin(phi)
  ];
}

eckert4Raw.invert = function(x, y) {
  var A = y * sqrt((4 + pi) / pi) / 2,
      k = asin(A),
      c = cos(k);
  return [
    x / (2 / sqrt(pi * (4 + pi)) * (1 + c)),
    asin((k + A * (c + 2)) / (2 + halfPi))
  ];
};

/* harmony default export */ function eckert4() {
  return (0,src_projection/* default */.A)(eckert4Raw)
      .scale(180.739);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/eckert5.js



function eckert5Raw(lambda, phi) {
  return [
    lambda * (1 + cos(phi)) / sqrt(2 + pi),
    2 * phi / sqrt(2 + pi)
  ];
}

eckert5Raw.invert = function(x, y) {
  var k = sqrt(2 + pi),
      phi = y * k / 2;
  return [
    k * x / (1 + cos(phi)),
    phi
  ];
};

/* harmony default export */ function eckert5() {
  return (0,src_projection/* default */.A)(eckert5Raw)
      .scale(173.044);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/eckert6.js



function eckert6Raw(lambda, phi) {
  var k = (1 + halfPi) * sin(phi);
  for (var i = 0, delta = Infinity; i < 10 && abs(delta) > epsilon; i++) {
    phi -= delta = (phi + sin(phi) - k) / (1 + cos(phi));
  }
  k = sqrt(2 + pi);
  return [
    lambda * (1 + cos(phi)) / k,
    2 * phi / k
  ];
}

eckert6Raw.invert = function(x, y) {
  var j = 1 + halfPi,
      k = sqrt(j / 2);
  return [
    x * 2 * k / (1 + cos(y *= k)),
    asin((y + sin(y)) / j)
  ];
};

/* harmony default export */ function eckert6() {
  return (0,src_projection/* default */.A)(eckert6Raw)
      .scale(173.044);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/eisenlohr.js




var eisenlohrK = 3 + 2 * sqrt2;

function eisenlohrRaw(lambda, phi) {
  var s0 = sin(lambda /= 2),
      c0 = cos(lambda),
      k = sqrt(cos(phi)),
      c1 = cos(phi /= 2),
      t = sin(phi) / (c1 + sqrt2 * c0 * k),
      c = sqrt(2 / (1 + t * t)),
      v = sqrt((sqrt2 * c1 + (c0 + s0) * k) / (sqrt2 * c1 + (c0 - s0) * k));
  return [
    eisenlohrK * (c * (v - 1 / v) - 2 * log(v)),
    eisenlohrK * (c * t * (v + 1 / v) - 2 * atan(t))
  ];
}

eisenlohrRaw.invert = function(x, y) {
  if (!(p = augustRaw.invert(x / 1.2, y * 1.065))) return null;
  var lambda = p[0], phi = p[1], i = 20, p;
  x /= eisenlohrK, y /= eisenlohrK;
  do {
    var _0 = lambda / 2,
        _1 = phi / 2,
        s0 = sin(_0),
        c0 = cos(_0),
        s1 = sin(_1),
        c1 = cos(_1),
        cos1 = cos(phi),
        k = sqrt(cos1),
        t = s1 / (c1 + sqrt2 * c0 * k),
        t2 = t * t,
        c = sqrt(2 / (1 + t2)),
        v0 = (sqrt2 * c1 + (c0 + s0) * k),
        v1 = (sqrt2 * c1 + (c0 - s0) * k),
        v2 = v0 / v1,
        v = sqrt(v2),
        vm1v = v - 1 / v,
        vp1v = v + 1 / v,
        fx = c * vm1v - 2 * log(v) - x,
        fy = c * t * vp1v - 2 * atan(t) - y,
        deltatDeltaLambda = s1 && sqrt1_2 * k * s0 * t2 / s1,
        deltatDeltaPhi = (sqrt2 * c0 * c1 + k) / (2 * (c1 + sqrt2 * c0 * k) * (c1 + sqrt2 * c0 * k) * k),
        deltacDeltat = -0.5 * t * c * c * c,
        deltacDeltaLambda = deltacDeltat * deltatDeltaLambda,
        deltacDeltaPhi = deltacDeltat * deltatDeltaPhi,
        A = (A = 2 * c1 + sqrt2 * k * (c0 - s0)) * A * v,
        deltavDeltaLambda = (sqrt2 * c0 * c1 * k + cos1) / A,
        deltavDeltaPhi = -(sqrt2 * s0 * s1) / (k * A),
        deltaxDeltaLambda = vm1v * deltacDeltaLambda - 2 * deltavDeltaLambda / v + c * (deltavDeltaLambda + deltavDeltaLambda / v2),
        deltaxDeltaPhi = vm1v * deltacDeltaPhi - 2 * deltavDeltaPhi / v + c * (deltavDeltaPhi + deltavDeltaPhi / v2),
        deltayDeltaLambda = t * vp1v * deltacDeltaLambda - 2 * deltatDeltaLambda / (1 + t2) + c * vp1v * deltatDeltaLambda + c * t * (deltavDeltaLambda - deltavDeltaLambda / v2),
        deltayDeltaPhi = t * vp1v * deltacDeltaPhi - 2 * deltatDeltaPhi / (1 + t2) + c * vp1v * deltatDeltaPhi + c * t * (deltavDeltaPhi - deltavDeltaPhi / v2),
        denominator = deltaxDeltaPhi * deltayDeltaLambda - deltayDeltaPhi * deltaxDeltaLambda;
    if (!denominator) break;
    var deltaLambda = (fy * deltaxDeltaPhi - fx * deltayDeltaPhi) / denominator,
        deltaPhi = (fx * deltayDeltaLambda - fy * deltaxDeltaLambda) / denominator;
    lambda -= deltaLambda;
    phi = max(-halfPi, min(halfPi, phi - deltaPhi));
  } while ((abs(deltaLambda) > epsilon || abs(deltaPhi) > epsilon) && --i > 0);
  return abs(abs(phi) - halfPi) < epsilon ? [0, phi] : i && [lambda, phi];
};

/* harmony default export */ function eisenlohr() {
  return (0,src_projection/* default */.A)(eisenlohrRaw)
      .scale(62.5271);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/fahey.js



var faheyK = cos(35 * radians);

function faheyRaw(lambda, phi) {
  var t = tan(phi / 2);
  return [lambda * faheyK * sqrt(1 - t * t), (1 + faheyK) * t];
}

faheyRaw.invert = function(x, y) {
  var t = y / (1 + faheyK);
  return [x && x / (faheyK * sqrt(1 - t * t)), 2 * atan(t)];
};

/* harmony default export */ function fahey() {
  return (0,src_projection/* default */.A)(faheyRaw)
      .scale(137.152);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/foucaut.js



function foucautRaw(lambda, phi) {
  var k = phi / 2, cosk = cos(k);
  return [ 2 * lambda / sqrtPi * cos(phi) * cosk * cosk, sqrtPi * tan(k)];
}

foucautRaw.invert = function(x, y) {
  var k = atan(y / sqrtPi), cosk = cos(k), phi = 2 * k;
  return [x * sqrtPi / 2 / (cos(phi) * cosk * cosk), phi];
};

/* harmony default export */ function foucaut() {
  return (0,src_projection/* default */.A)(foucautRaw)
      .scale(135.264);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/foucautSinusoidal.js




function foucautSinusoidalRaw(alpha) {
  var beta = 1 - alpha,
      equatorial = raw(pi, 0)[0] - raw(-pi, 0)[0],
      polar = raw(0, halfPi)[1] - raw(0, -halfPi)[1],
      ratio = sqrt(2 * polar / equatorial);

  function raw(lambda, phi) {
    var cosphi = cos(phi),
        sinphi = sin(phi);
    return [
      cosphi / (beta + alpha * cosphi) * lambda,
      beta * phi + alpha * sinphi
    ];
  }

  function forward(lambda, phi) {
    var p = raw(lambda, phi);
    return [p[0] * ratio, p[1] / ratio];
  }

  function forwardMeridian(phi) {
    return forward(0, phi)[1];
  }

  forward.invert = function(x, y) {
    var phi = solve(forwardMeridian, y),
        lambda = x / ratio * (alpha + beta / cos(phi));
    return [lambda, phi];
  };

  return forward;
}

/* harmony default export */ function foucautSinusoidal() {
  var alpha = 0.5,
      m = (0,src_projection/* projectionMutator */.U)(foucautSinusoidalRaw),
      p = m(alpha);

  p.alpha = function(_) {
    return arguments.length ? m(alpha = +_) : alpha;
  };

  return p
      .scale(168.725);
}

// EXTERNAL MODULE: ./node_modules/d3-geo/src/projection/orthographic.js
var orthographic = __webpack_require__(53253);
// EXTERNAL MODULE: ./node_modules/d3-geo/src/projection/equirectangular.js
var projection_equirectangular = __webpack_require__(18139);
;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/gilbert.js



function gilbertForward(point) {
  return [point[0] / 2, asin(tan(point[1] / 2 * radians)) * degrees];
}

function gilbertInvert(point) {
  return [point[0] * 2, 2 * atan(sin(point[1] * radians)) * degrees];
}

/* harmony default export */ function gilbert(projectionType) {
  if (projectionType == null) projectionType = orthographic/* default */.A;
  var projection = projectionType(),
      equirectangular = (0,projection_equirectangular/* default */.A)().scale(degrees).precision(0).clipAngle(null).translate([0, 0]); // antimeridian cutting

  function gilbert(point) {
    return projection(gilbertForward(point));
  }

  if (projection.invert) gilbert.invert = function(point) {
    return gilbertInvert(projection.invert(point));
  };

  gilbert.stream = function(stream) {
    var s1 = projection.stream(stream), s0 = equirectangular.stream({
      point: function(lambda, phi) { s1.point(lambda / 2, asin(tan(-phi / 2 * radians)) * degrees); },
      lineStart: function() { s1.lineStart(); },
      lineEnd: function() { s1.lineEnd(); },
      polygonStart: function() { s1.polygonStart(); },
      polygonEnd: function() { s1.polygonEnd(); }
    });
    s0.sphere = s1.sphere;
    return s0;
  };

  function property(name) {
    gilbert[name] = function() {
      return arguments.length ? (projection[name].apply(projection, arguments), gilbert) : projection[name]();
    };
  }

  gilbert.rotate = function(_) {
    return arguments.length ? (equirectangular.rotate(_), gilbert) : equirectangular.rotate();
  };

  gilbert.center = function(_) {
    return arguments.length ? (projection.center(gilbertForward(_)), gilbert) : gilbertInvert(projection.center());
  };

  property("angle");
  property("clipAngle");
  property("clipExtent");
  property("fitExtent");
  property("fitHeight");
  property("fitSize");
  property("fitWidth");
  property("scale");
  property("translate");
  property("precision");

  return gilbert
      .scale(249.5);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/gingery.js



function gingeryRaw(rho, n) {
  var k = 2 * pi / n,
      rho2 = rho * rho;

  function forward(lambda, phi) {
    var p = (0,azimuthalEquidistant/* azimuthalEquidistantRaw */.j)(lambda, phi),
        x = p[0],
        y = p[1],
        r2 = x * x + y * y;

    if (r2 > rho2) {
      var r = sqrt(r2),
          theta = atan2(y, x),
          theta0 = k * round(theta / k),
          alpha = theta - theta0,
          rhoCosAlpha = rho * cos(alpha),
          k_ = (rho * sin(alpha) - alpha * sin(rhoCosAlpha)) / (halfPi - rhoCosAlpha),
          s_ = gingeryLength(alpha, k_),
          e = (pi - rho) / gingeryIntegrate(s_, rhoCosAlpha, pi);

      x = r;
      var i = 50, delta;
      do {
        x -= delta = (rho + gingeryIntegrate(s_, rhoCosAlpha, x) * e - r) / (s_(x) * e);
      } while (abs(delta) > epsilon && --i > 0);

      y = alpha * sin(x);
      if (x < halfPi) y -= k_ * (x - halfPi);

      var s = sin(theta0),
          c = cos(theta0);
      p[0] = x * c - y * s;
      p[1] = x * s + y * c;
    }
    return p;
  }

  forward.invert = function(x, y) {
    var r2 = x * x + y * y;
    if (r2 > rho2) {
      var r = sqrt(r2),
          theta = atan2(y, x),
          theta0 = k * round(theta / k),
          dTheta = theta - theta0;

      x = r * cos(dTheta);
      y = r * sin(dTheta);

      var x_halfPi = x - halfPi,
          sinx = sin(x),
          alpha = y / sinx,
          delta = x < halfPi ? Infinity : 0,
          i = 10;

      while (true) {
        var rhosinAlpha = rho * sin(alpha),
            rhoCosAlpha = rho * cos(alpha),
            sinRhoCosAlpha = sin(rhoCosAlpha),
            halfPi_RhoCosAlpha = halfPi - rhoCosAlpha,
            k_ = (rhosinAlpha - alpha * sinRhoCosAlpha) / halfPi_RhoCosAlpha,
            s_ = gingeryLength(alpha, k_);

        if (abs(delta) < epsilon2 || !--i) break;

        alpha -= delta = (alpha * sinx - k_ * x_halfPi - y) / (
          sinx - x_halfPi * 2 * (
            halfPi_RhoCosAlpha * (rhoCosAlpha + alpha * rhosinAlpha * cos(rhoCosAlpha) - sinRhoCosAlpha) -
            rhosinAlpha * (rhosinAlpha - alpha * sinRhoCosAlpha)
          ) / (halfPi_RhoCosAlpha * halfPi_RhoCosAlpha));
      }
      r = rho + gingeryIntegrate(s_, rhoCosAlpha, x) * (pi - rho) / gingeryIntegrate(s_, rhoCosAlpha, pi);
      theta = theta0 + alpha;
      x = r * cos(theta);
      y = r * sin(theta);
    }
    return azimuthalEquidistant/* azimuthalEquidistantRaw */.j.invert(x, y);
  };

  return forward;
}

function gingeryLength(alpha, k) {
  return function(x) {
    var y_ = alpha * cos(x);
    if (x < halfPi) y_ -= k;
    return sqrt(1 + y_ * y_);
  };
}

// Numerical integration: trapezoidal rule.
function gingeryIntegrate(f, a, b) {
  var n = 50,
      h = (b - a) / n,
      s = f(a) + f(b);
  for (var i = 1, x = a; i < n; ++i) s += 2 * f(x += h);
  return s * 0.5 * h;
}

/* harmony default export */ function gingery() {
  var n = 6,
      rho = 30 * radians,
      cRho = cos(rho),
      sRho = sin(rho),
      m = (0,src_projection/* projectionMutator */.U)(gingeryRaw),
      p = m(rho, n),
      stream_ = p.stream,
      epsilon = 1e-2,
      cr = -cos(epsilon * radians),
      sr = sin(epsilon * radians);

  p.radius = function(_) {
    if (!arguments.length) return rho * degrees;
    cRho = cos(rho = _ * radians);
    sRho = sin(rho);
    return m(rho, n);
  };

  p.lobes = function(_) {
    if (!arguments.length) return n;
    return m(rho, n = +_);
  };

  p.stream = function(stream) {
    var rotate = p.rotate(),
        rotateStream = stream_(stream),
        sphereStream = (p.rotate([0, 0]), stream_(stream));
    p.rotate(rotate);
    rotateStream.sphere = function() {
      sphereStream.polygonStart(), sphereStream.lineStart();
      for (var i = 0, delta = 2 * pi / n, phi = 0; i < n; ++i, phi -= delta) {
        sphereStream.point(atan2(sr * cos(phi), cr) * degrees, asin(sr * sin(phi)) * degrees);
        sphereStream.point(atan2(sRho * cos(phi - delta / 2), cRho) * degrees, asin(sRho * sin(phi - delta / 2)) * degrees);
      }
      sphereStream.lineEnd(), sphereStream.polygonEnd();
    };
    return rotateStream;
  };

  return p
      .rotate([90, -40])
      .scale(91.7095)
      .clipAngle(180 - 1e-3);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/ginzburgPolyconic.js


/* harmony default export */ function ginzburgPolyconic(a, b, c, d, e, f, g, h) {
  if (arguments.length < 8) h = 0;

  function forward(lambda, phi) {
    if (!phi) return [a * lambda / pi, 0];
    var phi2 = phi * phi,
        xB = a + phi2 * (b + phi2 * (c + phi2 * d)),
        yB = phi * (e - 1 + phi2 * (f - h + phi2 * g)),
        m = (xB * xB + yB * yB) / (2 * yB),
        alpha = lambda * asin(xB / m) / pi;
    return [m * sin(alpha), phi * (1 + phi2 * h) + m * (1 - cos(alpha))];
  }

  forward.invert = function(x, y) {
    var lambda = pi * x / a,
        phi = y,
        deltaLambda, deltaPhi, i = 50;
    do {
      var phi2 = phi * phi,
          xB = a + phi2 * (b + phi2 * (c + phi2 * d)),
          yB = phi * (e - 1 + phi2 * (f - h + phi2 * g)),
          p = xB * xB + yB * yB,
          q = 2 * yB,
          m = p / q,
          m2 = m * m,
          dAlphadLambda = asin(xB / m) / pi,
          alpha = lambda * dAlphadLambda,
          xB2 = xB * xB,
          dxBdPhi = (2 * b + phi2 * (4 * c + phi2 * 6 * d)) * phi,
          dyBdPhi = e + phi2 * (3 * f + phi2 * 5 * g),
          dpdPhi = 2 * (xB * dxBdPhi + yB * (dyBdPhi - 1)),
          dqdPhi = 2 * (dyBdPhi - 1),
          dmdPhi = (dpdPhi * q - p * dqdPhi) / (q * q),
          cosAlpha = cos(alpha),
          sinAlpha = sin(alpha),
          mcosAlpha = m * cosAlpha,
          msinAlpha = m * sinAlpha,
          dAlphadPhi = ((lambda / pi) * (1 / sqrt(1 - xB2 / m2)) * (dxBdPhi * m - xB * dmdPhi)) / m2,
          fx = msinAlpha - x,
          fy = phi * (1 + phi2 * h) + m - mcosAlpha - y,
          deltaxDeltaPhi = dmdPhi * sinAlpha + mcosAlpha * dAlphadPhi,
          deltaxDeltaLambda = mcosAlpha * dAlphadLambda,
          deltayDeltaPhi = 1 + dmdPhi - (dmdPhi * cosAlpha - msinAlpha * dAlphadPhi),
          deltayDeltaLambda = msinAlpha * dAlphadLambda,
          denominator = deltaxDeltaPhi * deltayDeltaLambda - deltayDeltaPhi * deltaxDeltaLambda;
      if (!denominator) break;
      lambda -= deltaLambda = (fy * deltaxDeltaPhi - fx * deltayDeltaPhi) / denominator;
      phi -= deltaPhi = (fx * deltayDeltaLambda - fy * deltaxDeltaLambda) / denominator;
    } while ((abs(deltaLambda) > epsilon || abs(deltaPhi) > epsilon) && --i > 0);
    return [lambda, phi];
  };

  return forward;
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/ginzburg4.js



var ginzburg4Raw = ginzburgPolyconic(2.8284, -1.6988, 0.75432, -0.18071, 1.76003, -0.38914, 0.042555);

/* harmony default export */ function ginzburg4() {
  return (0,src_projection/* default */.A)(ginzburg4Raw)
      .scale(149.995);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/ginzburg5.js



var ginzburg5Raw = ginzburgPolyconic(2.583819, -0.835827, 0.170354, -0.038094, 1.543313, -0.411435,0.082742);

/* harmony default export */ function ginzburg5() {
  return (0,src_projection/* default */.A)(ginzburg5Raw)
      .scale(153.93);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/ginzburg6.js




var ginzburg6Raw = ginzburgPolyconic(5 / 6 * pi, -0.62636, -0.0344, 0, 1.3493, -0.05524, 0, 0.045);

/* harmony default export */ function ginzburg6() {
  return (0,src_projection/* default */.A)(ginzburg6Raw)
      .scale(130.945);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/ginzburg8.js



function ginzburg8Raw(lambda, phi) {
  var lambda2 = lambda * lambda,
      phi2 = phi * phi;
  return [
    lambda * (1 - 0.162388 * phi2) * (0.87 - 0.000952426 * lambda2 * lambda2),
    phi * (1 + phi2 / 12)
  ];
}

ginzburg8Raw.invert = function(x, y) {
  var lambda = x,
      phi = y,
      i = 50, delta;
  do {
    var phi2 = phi * phi;
    phi -= delta = (phi * (1 + phi2 / 12) - y) / (1 + phi2 / 4);
  } while (abs(delta) > epsilon && --i > 0);
  i = 50;
  x /= 1 -0.162388 * phi2;
  do {
    var lambda4 = (lambda4 = lambda * lambda) * lambda4;
    lambda -= delta = (lambda * (0.87 - 0.000952426 * lambda4) - x) / (0.87 - 0.00476213 * lambda4);
  } while (abs(delta) > epsilon && --i > 0);
  return [lambda, phi];
};

/* harmony default export */ function ginzburg8() {
  return (0,src_projection/* default */.A)(ginzburg8Raw)
      .scale(131.747);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/ginzburg9.js



var ginzburg9Raw = ginzburgPolyconic(2.6516, -0.76534, 0.19123, -0.047094, 1.36289, -0.13965,0.031762);

/* harmony default export */ function ginzburg9() {
  return (0,src_projection/* default */.A)(ginzburg9Raw)
      .scale(131.087);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/square.js


/* harmony default export */ function square(project) {
  var dx = project(halfPi, 0)[0] - project(-halfPi, 0)[0];

  function projectSquare(lambda, phi) {
    var s = lambda > 0 ? -0.5 : 0.5,
        point = project(lambda + s * pi, phi);
    point[0] -= s * dx;
    return point;
  }

  if (project.invert) projectSquare.invert = function(x, y) {
    var s = x > 0 ? -0.5 : 0.5,
        location = project.invert(x + s * dx, y),
        lambda = location[0] - s * pi;
    if (lambda < -pi) lambda += 2 * pi;
    else if (lambda > pi) lambda -= 2 * pi;
    location[0] = lambda;
    return location;
  };

  return projectSquare;
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/gringorten.js




function gringortenRaw(lambda, phi) {
  var sLambda = sign(lambda),
      sPhi = sign(phi),
      cosPhi = cos(phi),
      x = cos(lambda) * cosPhi,
      y = sin(lambda) * cosPhi,
      z = sin(sPhi * phi);
  lambda = abs(atan2(y, z));
  phi = asin(x);
  if (abs(lambda - halfPi) > epsilon) lambda %= halfPi;
  var point = gringortenHexadecant(lambda > pi / 4 ? halfPi - lambda : lambda, phi);
  if (lambda > pi / 4) z = point[0], point[0] = -point[1], point[1] = -z;
  return (point[0] *= sLambda, point[1] *= -sPhi, point);
}

gringortenRaw.invert = function(x, y) {
  if (abs(x) > 1) x = sign(x) * 2 - x;
  if (abs(y) > 1) y = sign(y) * 2 - y;
  var sx = sign(x),
      sy = sign(y),
      x0 = -sx * x,
      y0 = -sy * y,
      t = y0 / x0 < 1,
      p = gringortenHexadecantInvert(t ? y0 : x0, t ? x0 : y0),
      lambda = p[0],
      phi = p[1],
      cosPhi = cos(phi);
  if (t) lambda = -halfPi - lambda;
  return [sx * (atan2(sin(lambda) * cosPhi, -sin(phi)) + pi), sy * asin(cos(lambda) * cosPhi)];
};

function gringortenHexadecant(lambda, phi) {
  if (phi === halfPi) return [0, 0];

  var sinPhi = sin(phi),
      r = sinPhi * sinPhi,
      r2 = r * r,
      j = 1 + r2,
      k = 1 + 3 * r2,
      q = 1 - r2,
      z = asin(1 / sqrt(j)),
      v = q + r * j * z,
      p2 = (1 - sinPhi) / v,
      p = sqrt(p2),
      a2 = p2 * j,
      a = sqrt(a2),
      h = p * q,
      x,
      i;

  if (lambda === 0) return [0, -(h + r * a)];

  var cosPhi = cos(phi),
      secPhi = 1 / cosPhi,
      drdPhi = 2 * sinPhi * cosPhi,
      dvdPhi = (-3 * r + z * k) * drdPhi,
      dp2dPhi = (-v * cosPhi - (1 - sinPhi) * dvdPhi) / (v * v),
      dpdPhi = (0.5 * dp2dPhi) / p,
      dhdPhi = q * dpdPhi - 2 * r * p * drdPhi,
      dra2dPhi = r * j * dp2dPhi + p2 * k * drdPhi,
      mu = -secPhi * drdPhi,
      nu = -secPhi * dra2dPhi,
      zeta = -2 * secPhi * dhdPhi,
      lambda1 = 4 * lambda / pi,
      delta;

  // Slower but accurate bisection method.
  if (lambda > 0.222 * pi || phi < pi / 4 && lambda > 0.175 * pi) {
    x = (h + r * sqrt(a2 * (1 + r2) - h * h)) / (1 + r2);
    if (lambda > pi / 4) return [x, x];
    var x1 = x, x0 = 0.5 * x;
    x = 0.5 * (x0 + x1), i = 50;
    do {
      var g = sqrt(a2 - x * x),
          f = (x * (zeta + mu * g) + nu * asin(x / a)) - lambda1;
      if (!f) break;
      if (f < 0) x0 = x;
      else x1 = x;
      x = 0.5 * (x0 + x1);
    } while (abs(x1 - x0) > epsilon && --i > 0);
  }

  // Newton-Raphson.
  else {
    x = epsilon, i = 25;
    do {
      var x2 = x * x,
          g2 = sqrt(a2 - x2),
          zetaMug = zeta + mu * g2,
          f2 = x * zetaMug + nu * asin(x / a) - lambda1,
          df = zetaMug + (nu - mu * x2) / g2;
      x -= delta = g2 ? f2 / df : 0;
    } while (abs(delta) > epsilon && --i > 0);
  }

  return [x, -h - r * sqrt(a2 - x * x)];
}

function gringortenHexadecantInvert(x, y) {
  var x0 = 0,
      x1 = 1,
      r = 0.5,
      i = 50;

  while (true) {
    var r2 = r * r,
        sinPhi = sqrt(r),
        z = asin(1 / sqrt(1 + r2)),
        v = (1 - r2) + r * (1 + r2) * z,
        p2 = (1 - sinPhi) / v,
        p = sqrt(p2),
        a2 = p2 * (1 + r2),
        h = p * (1 - r2),
        g2 = a2 - x * x,
        g = sqrt(g2),
        y0 = y + h + r * g;
    if (abs(x1 - x0) < epsilon2 || --i === 0 || y0 === 0) break;
    if (y0 > 0) x0 = r;
    else x1 = r;
    r = 0.5 * (x0 + x1);
  }

  if (!i) return null;

  var phi = asin(sinPhi),
      cosPhi = cos(phi),
      secPhi = 1 / cosPhi,
      drdPhi = 2 * sinPhi * cosPhi,
      dvdPhi = (-3 * r + z * (1 + 3 * r2)) * drdPhi,
      dp2dPhi = (-v * cosPhi - (1 - sinPhi) * dvdPhi) / (v * v),
      dpdPhi = 0.5 * dp2dPhi / p,
      dhdPhi = (1 - r2) * dpdPhi - 2 * r * p * drdPhi,
      zeta = -2 * secPhi * dhdPhi,
      mu = -secPhi * drdPhi,
      nu = -secPhi * (r * (1 + r2) * dp2dPhi + p2 * (1 + 3 * r2) * drdPhi);

  return [pi / 4 * (x * (zeta + mu * g) + nu * asin(x / sqrt(a2))), phi];
}

/* harmony default export */ function gringorten() {
  return (0,src_projection/* default */.A)(square(gringortenRaw))
      .scale(239.75);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/elliptic.js


// Returns [sn, cn, dn](u + iv|m).
function ellipticJi(u, v, m) {
  var a, b, c;
  if (!u) {
    b = ellipticJ(v, 1 - m);
    return [
      [0, b[0] / b[1]],
      [1 / b[1], 0],
      [b[2] / b[1], 0]
    ];
  }
  a = ellipticJ(u, m);
  if (!v) return [[a[0], 0], [a[1], 0], [a[2], 0]];
  b = ellipticJ(v, 1 - m);
  c = b[1] * b[1] + m * a[0] * a[0] * b[0] * b[0];
  return [
    [a[0] * b[2] / c, a[1] * a[2] * b[0] * b[1] / c],
    [a[1] * b[1] / c, -a[0] * a[2] * b[0] * b[2] / c],
    [a[2] * b[1] * b[2] / c, -m * a[0] * a[1] * b[0] / c]
  ];
}

// Returns [sn, cn, dn, ph](u|m).
function ellipticJ(u, m) {
  var ai, b, phi, t, twon;
  if (m < epsilon) {
    t = sin(u);
    b = cos(u);
    ai = m * (u - t * b) / 4;
    return [
      t - ai * b,
      b + ai * t,
      1 - m * t * t / 2,
      u - ai
    ];
  }
  if (m >= 1 - epsilon) {
    ai = (1 - m) / 4;
    b = cosh(u);
    t = tanh(u);
    phi = 1 / b;
    twon = b * sinh(u);
    return [
      t + ai * (twon - u) / (b * b),
      phi - ai * t * phi * (twon - u),
      phi + ai * t * phi * (twon + u),
      2 * atan(exp(u)) - halfPi + ai * (twon - u) / b
    ];
  }

  var a = [1, 0, 0, 0, 0, 0, 0, 0, 0],
      c = [sqrt(m), 0, 0, 0, 0, 0, 0, 0, 0],
      i = 0;
  b = sqrt(1 - m);
  twon = 1;

  while (abs(c[i] / a[i]) > epsilon && i < 8) {
    ai = a[i++];
    c[i] = (ai - b) / 2;
    a[i] = (ai + b) / 2;
    b = sqrt(ai * b);
    twon *= 2;
  }

  phi = twon * a[i] * u;
  do {
    t = c[i] * sin(b = phi) / a[i];
    phi = (asin(t) + phi) / 2;
  } while (--i);

  return [sin(phi), t = cos(phi), t / cos(phi - b), phi];
}

// Calculate F(phi+iPsi|m).
// See Abramowitz and Stegun, 17.4.11.
function ellipticFi(phi, psi, m) {
  var r = abs(phi),
      i = abs(psi),
      sinhPsi = sinh(i);
  if (r) {
    var cscPhi = 1 / sin(r),
        cotPhi2 = 1 / (tan(r) * tan(r)),
        b = -(cotPhi2 + m * (sinhPsi * sinhPsi * cscPhi * cscPhi) - 1 + m),
        c = (m - 1) * cotPhi2,
        cotLambda2 = (-b + sqrt(b * b - 4 * c)) / 2;
    return [
      ellipticF(atan(1 / sqrt(cotLambda2)), m) * sign(phi),
      ellipticF(atan(sqrt((cotLambda2 / cotPhi2 - 1) / m)), 1 - m) * sign(psi)
    ];
  }
  return [
    0,
    ellipticF(atan(sinhPsi), 1 - m) * sign(psi)
  ];
}

// Calculate F(phi|m) where m = k² = sin²α.
// See Abramowitz and Stegun, 17.6.7.
function ellipticF(phi, m) {
  if (!m) return phi;
  if (m === 1) return log(tan(phi / 2 + quarterPi));
  var a = 1,
      b = sqrt(1 - m),
      c = sqrt(m);
  for (var i = 0; abs(c) > epsilon; i++) {
    if (phi % pi) {
      var dPhi = atan(b * tan(phi) / a);
      if (dPhi < 0) dPhi += pi;
      phi += dPhi + ~~(phi / pi) * pi;
    } else phi += phi;
    c = (a + b) / 2;
    b = sqrt(a * b);
    c = ((a = c) - b) / 2;
  }
  return phi / (pow(2, i) * a);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/guyou.js





function guyouRaw(lambda, phi) {
  var k_ = (sqrt2 - 1) / (sqrt2 + 1),
      k = sqrt(1 - k_ * k_),
      K = ellipticF(halfPi, k * k),
      f = -1,
      psi = log(tan(pi / 4 + abs(phi) / 2)),
      r = exp(f * psi) / sqrt(k_),
      at = guyouComplexAtan(r * cos(f * lambda), r * sin(f * lambda)),
      t = ellipticFi(at[0], at[1], k * k);
  return [-t[1], (phi >= 0 ? 1 : -1) * (0.5 * K - t[0])];
}

function guyouComplexAtan(x, y) {
  var x2 = x * x,
      y_1 = y + 1,
      t = 1 - x2 - y * y;
  return [
   0.5 * ((x >= 0 ? halfPi : -halfPi) - atan2(t, 2 * x)),
    -0.25 * log(t * t + 4 * x2) +0.5 * log(y_1 * y_1 + x2)
  ];
}

function guyouComplexDivide(a, b) {
  var denominator = b[0] * b[0] + b[1] * b[1];
  return [
    (a[0] * b[0] + a[1] * b[1]) / denominator,
    (a[1] * b[0] - a[0] * b[1]) / denominator
  ];
}

guyouRaw.invert = function(x, y) {
  var k_ = (sqrt2 - 1) / (sqrt2 + 1),
      k = sqrt(1 - k_ * k_),
      K = ellipticF(halfPi, k * k),
      f = -1,
      j = ellipticJi(0.5 * K - y, -x, k * k),
      tn = guyouComplexDivide(j[0], j[1]),
      lambda = atan2(tn[1], tn[0]) / f;
  return [
    lambda,
    2 * atan(exp(0.5 / f * log(k_ * tn[0] * tn[0] + k_ * tn[1] * tn[1]))) - halfPi
  ];
};

/* harmony default export */ function guyou() {
  return (0,src_projection/* default */.A)(square(guyouRaw))
      .scale(151.496);
}

// EXTERNAL MODULE: ./node_modules/d3-geo/src/circle.js + 1 modules
var src_circle = __webpack_require__(39127);
;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/hammerRetroazimuthal.js



function hammerRetroazimuthalRaw(phi0) {
  var sinPhi0 = sin(phi0),
      cosPhi0 = cos(phi0),
      rotate = hammerRetroazimuthalRotation(phi0);

  rotate.invert = hammerRetroazimuthalRotation(-phi0);

  function forward(lambda, phi) {
    var p = rotate(lambda, phi);
    lambda = p[0], phi = p[1];
    var sinPhi = sin(phi),
        cosPhi = cos(phi),
        cosLambda = cos(lambda),
        z = acos(sinPhi0 * sinPhi + cosPhi0 * cosPhi * cosLambda),
        sinz = sin(z),
        K = abs(sinz) > epsilon ? z / sinz : 1;
    return [
      K * cosPhi0 * sin(lambda),
      (abs(lambda) > halfPi ? K : -K) // rotate for back hemisphere
        * (sinPhi0 * cosPhi - cosPhi0 * sinPhi * cosLambda)
    ];
  }

  forward.invert = function(x, y) {
    var rho = sqrt(x * x + y * y),
        sinz = -sin(rho),
        cosz = cos(rho),
        a = rho * cosz,
        b = -y * sinz,
        c = rho * sinPhi0,
        d = sqrt(a * a + b * b - c * c),
        phi = atan2(a * c + b * d, b * c - a * d),
        lambda = (rho > halfPi ? -1 : 1) * atan2(x * sinz, rho * cos(phi) * cosz + y * sin(phi) * sinz);
    return rotate.invert(lambda, phi);
  };

  return forward;
}

// Latitudinal rotation by phi0.
// Temporary hack until D3 supports arbitrary small-circle clipping origins.
function hammerRetroazimuthalRotation(phi0) {
  var sinPhi0 = sin(phi0),
      cosPhi0 = cos(phi0);

  return function(lambda, phi) {
    var cosPhi = cos(phi),
        x = cos(lambda) * cosPhi,
        y = sin(lambda) * cosPhi,
        z = sin(phi);
    return [
      atan2(y, x * cosPhi0 - z * sinPhi0),
      asin(z * cosPhi0 + x * sinPhi0)
    ];
  };
}

/* harmony default export */ function hammerRetroazimuthal() {
  var phi0 = 0,
      m = (0,src_projection/* projectionMutator */.U)(hammerRetroazimuthalRaw),
      p = m(phi0),
      rotate_ = p.rotate,
      stream_ = p.stream,
      circle = (0,src_circle/* default */.A)();

  p.parallel = function(_) {
    if (!arguments.length) return phi0 * degrees;
    var r = p.rotate();
    return m(phi0 = _ * radians).rotate(r);
  };

  // Temporary hack; see hammerRetroazimuthalRotation.
  p.rotate = function(_) {
    if (!arguments.length) return (_ = rotate_.call(p), _[1] += phi0 * degrees, _);
    rotate_.call(p, [_[0], _[1] - phi0 * degrees]);
    circle.center([-_[0], -_[1]]);
    return p;
  };

  p.stream = function(stream) {
    stream = stream_(stream);
    stream.sphere = function() {
      stream.polygonStart();
      var epsilon = 1e-2,
          ring = circle.radius(90 - epsilon)().coordinates[0],
          n = ring.length - 1,
          i = -1,
          p;
      stream.lineStart();
      while (++i < n) stream.point((p = ring[i])[0], p[1]);
      stream.lineEnd();
      ring = circle.radius(90 + epsilon)().coordinates[0];
      n = ring.length - 1;
      stream.lineStart();
      while (--i >= 0) stream.point((p = ring[i])[0], p[1]);
      stream.lineEnd();
      stream.polygonEnd();
    };
    return stream;
  };

  return p
      .scale(79.4187)
      .parallel(45)
      .clipAngle(180 - 1e-3);
}

// EXTERNAL MODULE: ./node_modules/d3-array/src/index.js + 14 modules
var src = __webpack_require__(29725);
// EXTERNAL MODULE: ./node_modules/d3-geo/src/stream.js
var src_stream = __webpack_require__(20465);
;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/healpix.js






var K = 3,
    healpixParallel = asin(1 - 1 / K) * degrees,
    healpixLambert = cylindricalEqualAreaRaw(0);

function healpixRaw(H) {
  var phi0 = healpixParallel * radians,
      dx = collignonRaw(pi, phi0)[0] - collignonRaw(-pi, phi0)[0],
      y0 = healpixLambert(0, phi0)[1],
      y1 = collignonRaw(0, phi0)[1],
      dy1 = sqrtPi - y1,
      k = tau / H,
      w = 4 / tau,
      h = y0 + (dy1 * dy1 * 4) / tau;

  function forward(lambda, phi) {
    var point,
        phi2 = abs(phi);
    if (phi2 > phi0) {
      var i = min(H - 1, max(0, floor((lambda + pi) / k)));
      lambda += pi * (H - 1) / H - i * k;
      point = collignonRaw(lambda, phi2);
      point[0] = point[0] * tau / dx - tau * (H - 1) / (2 * H) + i * tau / H;
      point[1] = y0 + (point[1] - y1) * 4 * dy1 / tau;
      if (phi < 0) point[1] = -point[1];
    } else {
      point = healpixLambert(lambda, phi);
    }
    point[0] *= w, point[1] /= h;
    return point;
  }

  forward.invert = function(x, y) {
    x /= w, y *= h;
    var y2 = abs(y);
    if (y2 > y0) {
      var i = min(H - 1, max(0, floor((x + pi) / k)));
      x = (x + pi * (H - 1) / H - i * k) * dx / tau;
      var point = collignonRaw.invert(x, 0.25 * (y2 - y0) * tau / dy1 + y1);
      point[0] -= pi * (H - 1) / H - i * k;
      if (y < 0) point[1] = -point[1];
      return point;
    }
    return healpixLambert.invert(x, y);
  };

  return forward;
}

function sphereTop(x, i) {
  return [x, i & 1 ? 90 - epsilon : healpixParallel];
}

function sphereBottom(x, i) {
  return [x, i & 1 ? -90 + epsilon : -healpixParallel];
}

function sphereNudge(d) {
  return [d[0] * (1 - epsilon), d[1]];
}

function sphere(step) {
  var c = [].concat(
    (0,src/* range */.y1)(-180, 180 + step / 2, step).map(sphereTop),
    (0,src/* range */.y1)(180, -180 - step / 2, -step).map(sphereBottom)
  );
  return {
    type: "Polygon",
    coordinates: [step === 180 ? c.map(sphereNudge) : c]
  };
}

/* harmony default export */ function healpix() {
  var H = 4,
      m = (0,src_projection/* projectionMutator */.U)(healpixRaw),
      p = m(H),
      stream_ = p.stream;

  p.lobes = function(_) {
    return arguments.length ? m(H = +_) : H;
  };

  p.stream = function(stream) {
    var rotate = p.rotate(),
        rotateStream = stream_(stream),
        sphereStream = (p.rotate([0, 0]), stream_(stream));
    p.rotate(rotate);
    rotateStream.sphere = function() { (0,src_stream/* default */.A)(sphere(180 / H), sphereStream); };
    return rotateStream;
  };

  return p
      .scale(239.75);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/hill.js



function hillRaw(K) {
  var L = 1 + K,
      sinBt = sin(1 / L),
      Bt = asin(sinBt),
      A = 2 * sqrt(pi / (B = pi + 4 * Bt * L)),
      B,
      rho0 = 0.5 * A * (L + sqrt(K * (2 + K))),
      K2 = K * K,
      L2 = L * L;

  function forward(lambda, phi) {
    var t = 1 - sin(phi),
        rho,
        omega;
    if (t && t < 2) {
      var theta = halfPi - phi, i = 25, delta;
      do {
        var sinTheta = sin(theta),
            cosTheta = cos(theta),
            Bt_Bt1 = Bt + atan2(sinTheta, L - cosTheta),
            C = 1 + L2 - 2 * L * cosTheta;
        theta -= delta = (theta - K2 * Bt - L * sinTheta + C * Bt_Bt1 -0.5 * t * B) / (2 * L * sinTheta * Bt_Bt1);
      } while (abs(delta) > epsilon2 && --i > 0);
      rho = A * sqrt(C);
      omega = lambda * Bt_Bt1 / pi;
    } else {
      rho = A * (K + t);
      omega = lambda * Bt / pi;
    }
    return [
      rho * sin(omega),
      rho0 - rho * cos(omega)
    ];
  }

  forward.invert = function(x, y) {
    var rho2 = x * x + (y -= rho0) * y,
        cosTheta = (1 + L2 - rho2 / (A * A)) / (2 * L),
        theta = acos(cosTheta),
        sinTheta = sin(theta),
        Bt_Bt1 = Bt + atan2(sinTheta, L - cosTheta);
    return [
      asin(x / sqrt(rho2)) * pi / Bt_Bt1,
      asin(1 - 2 * (theta - K2 * Bt - L * sinTheta + (1 + L2 - 2 * L * cosTheta) * Bt_Bt1) / B)
    ];
  };

  return forward;
}

/* harmony default export */ function hill() {
  var K = 1,
      m = (0,src_projection/* projectionMutator */.U)(hillRaw),
      p = m(K);

  p.ratio = function(_) {
    return arguments.length ? m(K = +_) : K;
  };

  return p
      .scale(167.774)
      .center([0, 18.67]);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/sinuMollweide.js




var sinuMollweidePhi = 0.7109889596207567;

var sinuMollweideY = 0.0528035274542;

function sinuMollweideRaw(lambda, phi) {
  return phi > -sinuMollweidePhi
      ? (lambda = mollweideRaw(lambda, phi), lambda[1] += sinuMollweideY, lambda)
      : sinusoidalRaw(lambda, phi);
}

sinuMollweideRaw.invert = function(x, y) {
  return y > -sinuMollweidePhi
      ? mollweideRaw.invert(x, y - sinuMollweideY)
      : sinusoidalRaw.invert(x, y);
};

/* harmony default export */ function sinuMollweide() {
  return (0,src_projection/* default */.A)(sinuMollweideRaw)
      .rotate([-20, -55])
      .scale(164.263)
      .center([0, -5.4036]);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/homolosine.js






function homolosineRaw(lambda, phi) {
  return abs(phi) > sinuMollweidePhi
      ? (lambda = mollweideRaw(lambda, phi), lambda[1] -= phi > 0 ? sinuMollweideY : -sinuMollweideY, lambda)
      : sinusoidalRaw(lambda, phi);
}

homolosineRaw.invert = function(x, y) {
  return abs(y) > sinuMollweidePhi
      ? mollweideRaw.invert(x, y + (y > 0 ? sinuMollweideY : -sinuMollweideY))
      : sinusoidalRaw.invert(x, y);
};

/* harmony default export */ function homolosine() {
  return (0,src_projection/* default */.A)(homolosineRaw)
      .scale(152.63);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/hufnagel.js




function hufnagelRaw(a, b, psiMax, ratio) {
  var k = sqrt(
      (4 * pi) /
        (2 * psiMax +
          (1 + a - b / 2) * sin(2 * psiMax) +
          ((a + b) / 2) * sin(4 * psiMax) +
          (b / 2) * sin(6 * psiMax))
    ),
    c = sqrt(
      ratio *
        sin(psiMax) *
        sqrt((1 + a * cos(2 * psiMax) + b * cos(4 * psiMax)) / (1 + a + b))
    ),
    M = psiMax * mapping(1);

  function radius(psi) {
    return sqrt(1 + a * cos(2 * psi) + b * cos(4 * psi));
  }

  function mapping(t) {
    var psi = t * psiMax;
    return (
      (2 * psi +
        (1 + a - b / 2) * sin(2 * psi) +
        ((a + b) / 2) * sin(4 * psi) +
        (b / 2) * sin(6 * psi)) /
      psiMax
    );
  }

  function inversemapping(psi) {
    return radius(psi) * sin(psi);
  }

  var forward = function(lambda, phi) {
    var psi = psiMax * solve(mapping, (M * sin(phi)) / psiMax, phi / pi);
    if (isNaN(psi)) psi = psiMax * sign(phi);
    var kr = k * radius(psi);
    return [((kr * c * lambda) / pi) * cos(psi), (kr / c) * sin(psi)];
  };

  forward.invert = function(x, y) {
    var psi = solve(inversemapping, (y * c) / k);
    return [
      (x * pi) / (cos(psi) * k * c * radius(psi)),
      asin((psiMax * mapping(psi / psiMax)) / M)
    ];
  };

  if (psiMax === 0) {
    k = sqrt(ratio / pi);
    forward = function(lambda, phi) {
      return [lambda * k, sin(phi) / k];
    };
    forward.invert = function(x, y) {
      return [x / k, asin(y * k)];
    };
  }

  return forward;
}

/* harmony default export */ function hufnagel() {
  var a = 1,
    b = 0,
    psiMax = 45 * radians,
    ratio = 2,
    mutate = (0,src_projection/* projectionMutator */.U)(hufnagelRaw),
    projection = mutate(a, b, psiMax, ratio);

  projection.a = function(_) {
    return arguments.length ? mutate((a = +_), b, psiMax, ratio) : a;
  };
  projection.b = function(_) {
    return arguments.length ? mutate(a, (b = +_), psiMax, ratio) : b;
  };
  projection.psiMax = function(_) {
    return arguments.length
      ? mutate(a, b, (psiMax = +_ * radians), ratio)
      : psiMax * degrees;
  };
  projection.ratio = function(_) {
    return arguments.length ? mutate(a, b, psiMax, (ratio = +_)) : ratio;
  };

  return projection.scale(180.739);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/integrate.js
// https://github.com/scijs/integrate-adaptive-simpson

// This algorithm adapted from pseudocode in:
// http://www.math.utk.edu/~ccollins/refs/Handouts/rich.pdf
function adsimp (f, a, b, fa, fm, fb, V0, tol, maxdepth, depth, state) {
  if (state.nanEncountered) {
    return NaN;
  }

  var h, f1, f2, sl, sr, s2, m, V1, V2, err;

  h = b - a;
  f1 = f(a + h * 0.25);
  f2 = f(b - h * 0.25);

  // Simple check for NaN:
  if (isNaN(f1)) {
    state.nanEncountered = true;
    return;
  }

  // Simple check for NaN:
  if (isNaN(f2)) {
    state.nanEncountered = true;
    return;
  }

  sl = h * (fa + 4 * f1 + fm) / 12;
  sr = h * (fm + 4 * f2 + fb) / 12;
  s2 = sl + sr;
  err = (s2 - V0) / 15;

  if (depth > maxdepth) {
    state.maxDepthCount++;
    return s2 + err;
  } else if (Math.abs(err) < tol) {
    return s2 + err;
  } else {
    m = a + h * 0.5;

    V1 = adsimp(f, a, m, fa, f1, fm, sl, tol * 0.5, maxdepth, depth + 1, state);

    if (isNaN(V1)) {
      state.nanEncountered = true;
      return NaN;
    }

    V2 = adsimp(f, m, b, fm, f2, fb, sr, tol * 0.5, maxdepth, depth + 1, state);

    if (isNaN(V2)) {
      state.nanEncountered = true;
      return NaN;
    }

    return V1 + V2;
  }
}

function integrate (f, a, b, tol, maxdepth) {
  var state = {
    maxDepthCount: 0,
    nanEncountered: false
  };

  if (tol === undefined) {
    tol = 1e-8;
  }
  if (maxdepth === undefined) {
    maxdepth = 20;
  }

  var fa = f(a);
  var fm = f(0.5 * (a + b));
  var fb = f(b);

  var V0 = (fa + 4 * fm + fb) * (b - a) / 6;

  var result = adsimp(f, a, b, fa, fm, fb, V0, tol, maxdepth, 1, state);

/*
  if (state.maxDepthCount > 0 && console && console.warn) {
    console.warn('integrate-adaptive-simpson: Warning: maximum recursion depth (' + maxdepth + ') reached ' + state.maxDepthCount + ' times');
  }

  if (state.nanEncountered && console && console.warn) {
    console.warn('integrate-adaptive-simpson: Warning: NaN encountered. Halting early.');
  }
*/

  return result;
}
;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/hyperelliptical.js




function hyperellipticalRaw(alpha, k, gamma) {

  function elliptic (f) {
    return alpha + (1 - alpha) * pow(1 - pow(f, k), 1 / k);
  }

  function z(f) {
    return integrate(elliptic, 0, f, 1e-4);
  }

  var G = 1 / z(1),
      n = 1000,
      m = (1 + 1e-8) * G,
      approx = [];
  for (var i = 0; i <= n; i++)
      approx.push(z(i / n) * m);

  function Y(sinphi) {
    var rmin = 0, rmax = n, r = n >> 1;
    do {
      if (approx[r] > sinphi) rmax = r; else rmin = r;
      r = (rmin + rmax) >> 1;
    } while (r > rmin);
    var u = approx[r + 1] - approx[r];
    if (u) u = (sinphi - approx[r + 1]) / u;
    return (r + 1 + u) / n;
  }

  var ratio = 2 * Y(1) / pi * G / gamma;

  var forward = function(lambda, phi) {
    var y = Y(abs(sin(phi))),
        x = elliptic(y) * lambda;
    y /= ratio;
    return [ x, (phi >= 0) ? y : -y ];
  };

  forward.invert = function(x, y) {
    var phi;
    y *= ratio;
    if (abs(y) < 1) phi = sign(y) * asin(z(abs(y)) * G);
    return [ x / elliptic(abs(y)), phi ];
  };

  return forward;
}

/* harmony default export */ function hyperelliptical() {
  var alpha = 0,
      k = 2.5,
      gamma = 1.183136, // affine = sqrt(2 * gamma / pi) = 0.8679
      m = (0,src_projection/* projectionMutator */.U)(hyperellipticalRaw),
      p = m(alpha, k, gamma);

  p.alpha = function(_) {
    return arguments.length ? m(alpha = +_, k, gamma) : alpha;
  };

  p.k = function(_) {
    return arguments.length ? m(alpha, k = +_, gamma) : k;
  };

  p.gamma = function(_) {
    return arguments.length ? m(alpha, k, gamma = +_) : gamma;
  };

  return p
      .scale(152.63);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/interrupted/index.js




function pointEqual(a, b) {
  return abs(a[0] - b[0]) < epsilon && abs(a[1] - b[1]) < epsilon;
}

function interpolateLine(coordinates, m) {
  var i = -1,
      n = coordinates.length,
      p0 = coordinates[0],
      p1,
      dx,
      dy,
      resampled = [];
  while (++i < n) {
    p1 = coordinates[i];
    dx = (p1[0] - p0[0]) / m;
    dy = (p1[1] - p0[1]) / m;
    for (var j = 0; j < m; ++j) resampled.push([p0[0] + j * dx, p0[1] + j * dy]);
    p0 = p1;
  }
  resampled.push(p1);
  return resampled;
}

function interpolateSphere(lobes) {
  var coordinates = [],
      lobe,
      lambda0, phi0, phi1,
      lambda2, phi2,
      i, n = lobes[0].length;

  // Northern Hemisphere
  for (i = 0; i < n; ++i) {
    lobe = lobes[0][i];
    lambda0 = lobe[0][0], phi0 = lobe[0][1], phi1 = lobe[1][1];
    lambda2 = lobe[2][0], phi2 = lobe[2][1];
    coordinates.push(interpolateLine([
      [lambda0 + epsilon, phi0 + epsilon],
      [lambda0 + epsilon, phi1 - epsilon],
      [lambda2 - epsilon, phi1 - epsilon],
      [lambda2 - epsilon, phi2 + epsilon]
    ], 30));
  }

  // Southern Hemisphere
  for (i = lobes[1].length - 1; i >= 0; --i) {
    lobe = lobes[1][i];
    lambda0 = lobe[0][0], phi0 = lobe[0][1], phi1 = lobe[1][1];
    lambda2 = lobe[2][0], phi2 = lobe[2][1];
    coordinates.push(interpolateLine([
      [lambda2 - epsilon, phi2 - epsilon],
      [lambda2 - epsilon, phi1 + epsilon],
      [lambda0 + epsilon, phi1 + epsilon],
      [lambda0 + epsilon, phi0 - epsilon]
    ], 30));
  }

  return {
    type: "Polygon",
    coordinates: [(0,src/* merge */.Am)(coordinates)]
  };
}

/* harmony default export */ function interrupted(project, lobes, inverse) {
  var sphere, bounds;

  function forward(lambda, phi) {
    var sign = phi < 0 ? -1 : +1, lobe = lobes[+(phi < 0)];
    for (var i = 0, n = lobe.length - 1; i < n && lambda > lobe[i][2][0]; ++i);
    var p = project(lambda - lobe[i][1][0], phi);
    p[0] += project(lobe[i][1][0], sign * phi > sign * lobe[i][0][1] ? lobe[i][0][1] : phi)[0];
    return p;
  }

  if (inverse) {
    forward.invert = inverse(forward);
  } else if (project.invert) {
    forward.invert = function(x, y) {
      var bound = bounds[+(y < 0)], lobe = lobes[+(y < 0)];
      for (var i = 0, n = bound.length; i < n; ++i) {
        var b = bound[i];
        if (b[0][0] <= x && x < b[1][0] && b[0][1] <= y && y < b[1][1]) {
          var p = project.invert(x - project(lobe[i][1][0], 0)[0], y);
          p[0] += lobe[i][1][0];
          return pointEqual(forward(p[0], p[1]), [x, y]) ? p : null;
        }
      }
    };
  }

  var p = (0,src_projection/* default */.A)(forward),
      stream_ = p.stream;

  p.stream = function(stream) {
    var rotate = p.rotate(),
        rotateStream = stream_(stream),
        sphereStream = (p.rotate([0, 0]), stream_(stream));
    p.rotate(rotate);
    rotateStream.sphere = function() { (0,src_stream/* default */.A)(sphere, sphereStream); };
    return rotateStream;
  };
  
  p.lobes = function(_) {
    if (!arguments.length) return lobes.map(function(lobe) {
      return lobe.map(function(l) {
        return [
          [l[0][0] * degrees, l[0][1] * degrees],
          [l[1][0] * degrees, l[1][1] * degrees],
          [l[2][0] * degrees, l[2][1] * degrees]
        ];
      });
    });

    sphere = interpolateSphere(_);

    lobes = _.map(function(lobe) {
      return lobe.map(function(l) {
        return [
          [l[0][0] * radians, l[0][1] * radians],
          [l[1][0] * radians, l[1][1] * radians],
          [l[2][0] * radians, l[2][1] * radians]
        ];
      });
    });

    bounds = lobes.map(function(lobe) {
      return lobe.map(function(l) {
        var x0 = project(l[0][0], l[0][1])[0],
            x1 = project(l[2][0], l[2][1])[0],
            y0 = project(l[1][0], l[0][1])[1],
            y1 = project(l[1][0], l[1][1])[1],
            t;
        if (y0 > y1) t = y0, y0 = y1, y1 = t;
        return [[x0, y0], [x1, y1]];
      });
    });

    return p;
  };

  if (lobes != null) p.lobes(lobes);

  return p;
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/interrupted/boggs.js



var lobes = [[ // northern hemisphere
  [[-180,   0], [-100,  90], [ -40,   0]],
  [[ -40,   0], [  30,  90], [ 180,   0]]
], [ // southern hemisphere
  [[-180,   0], [-160, -90], [-100,   0]],
  [[-100,   0], [ -60, -90], [ -20,   0]],
  [[ -20,   0], [  20, -90], [  80,   0]],
  [[  80,   0], [ 140, -90], [ 180,   0]]
]];

/* harmony default export */ function interrupted_boggs() {
  return interrupted(boggsRaw, lobes)
      .scale(160.857);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/interrupted/homolosine.js



var homolosine_lobes = [[ // northern hemisphere
  [[-180,   0], [-100,  90], [ -40,   0]],
  [[ -40,   0], [  30,  90], [ 180,   0]]
], [ // southern hemisphere
  [[-180,   0], [-160, -90], [-100,   0]],
  [[-100,   0], [ -60, -90], [ -20,   0]],
  [[ -20,   0], [  20, -90], [  80,   0]],
  [[  80,   0], [ 140, -90], [ 180,   0]]
]];

/* harmony default export */ function interrupted_homolosine() {
  return interrupted(homolosineRaw, homolosine_lobes)
      .scale(152.63);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/interrupted/mollweide.js



var mollweide_lobes = [[ // northern hemisphere
  [[-180,   0], [-100,  90], [ -40,   0]],
  [[ -40,   0], [  30,  90], [ 180,   0]]
], [ // southern hemisphere
  [[-180,   0], [-160, -90], [-100,   0]],
  [[-100,   0], [ -60, -90], [ -20,   0]],
  [[ -20,   0], [  20, -90], [  80,   0]],
  [[  80,   0], [ 140, -90], [ 180,   0]]
]];

/* harmony default export */ function interrupted_mollweide() {
  return interrupted(mollweideRaw, mollweide_lobes)
      .scale(169.529);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/interrupted/mollweideHemispheres.js



var mollweideHemispheres_lobes = [[ // northern hemisphere
  [[-180,   0], [ -90,  90], [   0,   0]],
  [[   0,   0], [  90,  90], [ 180,   0]]
], [ // southern hemisphere
  [[-180,   0], [ -90, -90], [   0,   0]],
  [[   0,   0], [  90, -90], [ 180,   0]]
]];

/* harmony default export */ function mollweideHemispheres() {
  return interrupted(mollweideRaw, mollweideHemispheres_lobes)
      .scale(169.529)
      .rotate([20, 0]);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/interrupted/sinuMollweide.js




var sinuMollweide_lobes = [[ // northern hemisphere
  [[-180,  35], [ -30,  90], [   0,  35]],
  [[   0,  35], [  30,  90], [ 180,  35]]
], [ // southern hemisphere
  [[-180, -10], [-102, -90], [ -65, -10]],
  [[ -65, -10], [   5, -90], [  77, -10]],
  [[  77, -10], [ 103, -90], [ 180, -10]]
]];

/* harmony default export */ function interrupted_sinuMollweide() {
  return interrupted(sinuMollweideRaw, sinuMollweide_lobes, solve2d)
      .rotate([-20, -55])
      .scale(164.263)
      .center([0, -5.4036]);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/interrupted/sinusoidal.js



var sinusoidal_lobes = [[ // northern hemisphere
  [[-180,   0], [-110,  90], [ -40,   0]],
  [[ -40,   0], [   0,  90], [  40,   0]],
  [[  40,   0], [ 110,  90], [ 180,   0]]
], [ // southern hemisphere
  [[-180,   0], [-110, -90], [ -40,   0]],
  [[ -40,   0], [   0, -90], [  40,   0]],
  [[  40,   0], [ 110, -90], [ 180,   0]]
]];

/* harmony default export */ function interrupted_sinusoidal() {
  return interrupted(sinusoidalRaw, sinusoidal_lobes)
      .scale(152.63)
      .rotate([-20, 0]);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/kavrayskiy7.js



function kavrayskiy7Raw(lambda, phi) {
  return [3 / tau * lambda * sqrt(pi * pi / 3 - phi * phi), phi];
}

kavrayskiy7Raw.invert = function(x, y) {
  return [tau / 3 * x / sqrt(pi * pi / 3 - y * y), y];
};

/* harmony default export */ function kavrayskiy7() {
  return (0,src_projection/* default */.A)(kavrayskiy7Raw)
      .scale(158.837);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/lagrange.js



function lagrangeRaw(n) {

  function forward(lambda, phi) {
    if (abs(abs(phi) - halfPi) < epsilon) return [0, phi < 0 ? -2 : 2];
    var sinPhi = sin(phi),
        v = pow((1 + sinPhi) / (1 - sinPhi), n / 2),
        c = 0.5 * (v + 1 / v) + cos(lambda *= n);
    return [
      2 * sin(lambda) / c,
      (v - 1 / v) / c
    ];
  }

  forward.invert = function(x, y) {
    var y0 = abs(y);
    if (abs(y0 - 2) < epsilon) return x ? null : [0, sign(y) * halfPi];
    if (y0 > 2) return null;

    x /= 2, y /= 2;
    var x2 = x * x,
        y2 = y * y,
        t = 2 * y / (1 + x2 + y2); // tanh(nPhi)
    t = pow((1 + t) / (1 - t), 1 / n);
    return [
      atan2(2 * x, 1 - x2 - y2) / n,
      asin((t - 1) / (t + 1))
    ];
  };

  return forward;
}

/* harmony default export */ function lagrange() {
  var n = 0.5,
      m = (0,src_projection/* projectionMutator */.U)(lagrangeRaw),
      p = m(n);

  p.spacing = function(_) {
    return arguments.length ? m(n = +_) : n;
  };

  return p
      .scale(124.75);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/larrivee.js



var pi_sqrt2 = pi / sqrt2;

function larriveeRaw(lambda, phi) {
  return [
    lambda * (1 + sqrt(cos(phi))) / 2,
    phi / (cos(phi / 2) * cos(lambda / 6))
  ];
}

larriveeRaw.invert = function(x, y) {
  var x0 = abs(x),
      y0 = abs(y),
      lambda = epsilon,
      phi = halfPi;
  if (y0 < pi_sqrt2) phi *= y0 / pi_sqrt2;
  else lambda += 6 * acos(pi_sqrt2 / y0);
  for (var i = 0; i < 25; i++) {
    var sinPhi = sin(phi),
        sqrtcosPhi = sqrt(cos(phi)),
        sinPhi_2 = sin(phi / 2),
        cosPhi_2 = cos(phi / 2),
        sinLambda_6 = sin(lambda / 6),
        cosLambda_6 = cos(lambda / 6),
        f0 = 0.5 * lambda * (1 + sqrtcosPhi) - x0,
        f1 = phi / (cosPhi_2 * cosLambda_6) - y0,
        df0dPhi = sqrtcosPhi ? -0.25 * lambda * sinPhi / sqrtcosPhi : 0,
        df0dLambda = 0.5 * (1 + sqrtcosPhi),
        df1dPhi = (1 + 0.5 * phi * sinPhi_2 / cosPhi_2) / (cosPhi_2 * cosLambda_6),
        df1dLambda = (phi / cosPhi_2) * (sinLambda_6 / 6) / (cosLambda_6 * cosLambda_6),
        denom = df0dPhi * df1dLambda - df1dPhi * df0dLambda,
        dPhi = (f0 * df1dLambda - f1 * df0dLambda) / denom,
        dLambda = (f1 * df0dPhi - f0 * df1dPhi) / denom;
    phi -= dPhi;
    lambda -= dLambda;
    if (abs(dPhi) < epsilon && abs(dLambda) < epsilon) break;
  }
  return [x < 0 ? -lambda : lambda, y < 0 ? -phi : phi];
};

/* harmony default export */ function larrivee() {
  return (0,src_projection/* default */.A)(larriveeRaw)
      .scale(97.2672);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/laskowski.js



function laskowskiRaw(lambda, phi) {
  var lambda2 = lambda * lambda, phi2 = phi * phi;
  return [
    lambda * (0.975534 + phi2 * (-0.119161 + lambda2 * -0.0143059 + phi2 * -0.0547009)),
    phi * (1.00384 + lambda2 * (0.0802894 + phi2 * -0.02855 + lambda2 * 0.000199025) + phi2 * (0.0998909 + phi2 * -0.0491032))
  ];
}

laskowskiRaw.invert = function(x, y) {
  var lambda = sign(x) * pi,
      phi = y / 2,
      i = 50;
  do {
    var lambda2 = lambda * lambda,
        phi2 = phi * phi,
        lambdaPhi = lambda * phi,
        fx = lambda * (0.975534 + phi2 * (-0.119161 + lambda2 * -0.0143059 + phi2 * -0.0547009)) - x,
        fy = phi * (1.00384 + lambda2 * (0.0802894 + phi2 * -0.02855 + lambda2 * 0.000199025) + phi2 * (0.0998909 + phi2 * -0.0491032)) - y,
        deltaxDeltaLambda = 0.975534 - phi2 * (0.119161 + 3 * lambda2 * 0.0143059 + phi2 * 0.0547009),
        deltaxDeltaPhi = -lambdaPhi * (2 * 0.119161 + 4 * 0.0547009 * phi2 + 2 * 0.0143059 * lambda2),
        deltayDeltaLambda = lambdaPhi * (2 * 0.0802894 + 4 * 0.000199025 * lambda2 + 2 * -0.02855 * phi2),
        deltayDeltaPhi = 1.00384 + lambda2 * (0.0802894 + 0.000199025 * lambda2) + phi2 * (3 * (0.0998909 - 0.02855 * lambda2) - 5 * 0.0491032 * phi2),
        denominator = deltaxDeltaPhi * deltayDeltaLambda - deltayDeltaPhi * deltaxDeltaLambda,
        deltaLambda = (fy * deltaxDeltaPhi - fx * deltayDeltaPhi) / denominator,
        deltaPhi = (fx * deltayDeltaLambda - fy * deltaxDeltaLambda) / denominator;
    lambda -= deltaLambda, phi -= deltaPhi;
  } while ((abs(deltaLambda) > epsilon || abs(deltaPhi) > epsilon) && --i > 0);
  return i && [lambda, phi];
};

/* harmony default export */ function laskowski() {
  return (0,src_projection/* default */.A)(laskowskiRaw)
      .scale(139.98);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/littrow.js



function littrowRaw(lambda, phi) {
  return [
    sin(lambda) / cos(phi),
    tan(phi) * cos(lambda)
  ];
}

littrowRaw.invert = function(x, y) {
  var x2 = x * x,
      y2 = y * y,
      y2_1 = y2 + 1,
      x2_y2_1 = x2 + y2_1,
      cosPhi = x
          ? sqrt1_2 * sqrt((x2_y2_1 - sqrt(x2_y2_1 * x2_y2_1 - 4 * x2)) / x2)
          : 1 / sqrt(y2_1);
  return [
    asin(x * cosPhi),
    sign(y) * acos(cosPhi)
  ];
};

/* harmony default export */ function littrow() {
  return (0,src_projection/* default */.A)(littrowRaw)
      .scale(144.049)
      .clipAngle(90 - 1e-3);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/loximuthal.js



function loximuthalRaw(phi0) {
  var cosPhi0 = cos(phi0),
      tanPhi0 = tan(quarterPi + phi0 / 2);

  function forward(lambda, phi) {
    var y = phi - phi0,
        x = abs(y) < epsilon ? lambda * cosPhi0
            : abs(x = quarterPi + phi / 2) < epsilon || abs(abs(x) - halfPi) < epsilon
            ? 0 : lambda * y / log(tan(x) / tanPhi0);
    return [x, y];
  }

  forward.invert = function(x, y) {
    var lambda,
        phi = y + phi0;
    return [
      abs(y) < epsilon ? x / cosPhi0
          : (abs(lambda = quarterPi + phi / 2) < epsilon || abs(abs(lambda) - halfPi) < epsilon) ? 0
          : x * log(tan(lambda) / tanPhi0) / y,
      phi
    ];
  };

  return forward;
}

/* harmony default export */ function loximuthal() {
  return parallel1(loximuthalRaw)
      .parallel(40)
      .scale(158.837);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/miller.js



function millerRaw(lambda, phi) {
  return [lambda, 1.25 * log(tan(quarterPi + 0.4 * phi))];
}

millerRaw.invert = function(x, y) {
  return [x, 2.5 * atan(exp(0.8 * y)) - 0.625 * pi];
};

/* harmony default export */ function miller() {
  return (0,src_projection/* default */.A)(millerRaw)
      .scale(108.318);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/modifiedStereographic.js



function modifiedStereographicRaw(C) {
  var m = C.length - 1;

  function forward(lambda, phi) {
    var cosPhi = cos(phi),
        k = 2 / (1 + cosPhi * cos(lambda)),
        zr = k * cosPhi * sin(lambda),
        zi = k * sin(phi),
        i = m,
        w = C[i],
        ar = w[0],
        ai = w[1],
        t;
    while (--i >= 0) {
      w = C[i];
      ar = w[0] + zr * (t = ar) - zi * ai;
      ai = w[1] + zr * ai + zi * t;
    }
    ar = zr * (t = ar) - zi * ai;
    ai = zr * ai + zi * t;
    return [ar, ai];
  }

  forward.invert = function(x, y) {
    var i = 20,
        zr = x,
        zi = y;
    do {
      var j = m,
          w = C[j],
          ar = w[0],
          ai = w[1],
          br = 0,
          bi = 0,
          t;

      while (--j >= 0) {
        w = C[j];
        br = ar + zr * (t = br) - zi * bi;
        bi = ai + zr * bi + zi * t;
        ar = w[0] + zr * (t = ar) - zi * ai;
        ai = w[1] + zr * ai + zi * t;
      }
      br = ar + zr * (t = br) - zi * bi;
      bi = ai + zr * bi + zi * t;
      ar = zr * (t = ar) - zi * ai - x;
      ai = zr * ai + zi * t - y;

      var denominator = br * br + bi * bi, deltar, deltai;
      zr -= deltar = (ar * br + ai * bi) / denominator;
      zi -= deltai = (ai * br - ar * bi) / denominator;
    } while (abs(deltar) + abs(deltai) > epsilon * epsilon && --i > 0);

    if (i) {
      var rho = sqrt(zr * zr + zi * zi),
          c = 2 * atan(rho * 0.5),
          sinc = sin(c);
      return [atan2(zr * sinc, rho * cos(c)), rho ? asin(zi * sinc / rho) : 0];
    }
  };

  return forward;
}

var alaska = [[0.9972523, 0], [0.0052513, -0.0041175], [0.0074606, 0.0048125], [-0.0153783, -0.1968253], [0.0636871, -0.1408027], [0.3660976, -0.2937382]],
    gs48 = [[0.98879, 0], [0, 0], [-0.050909, 0], [0, 0], [0.075528, 0]],
    gs50 = [[0.9842990, 0], [0.0211642, 0.0037608], [-0.1036018, -0.0575102], [-0.0329095, -0.0320119], [0.0499471, 0.1223335], [0.0260460, 0.0899805], [0.0007388, -0.1435792], [0.0075848, -0.1334108], [-0.0216473, 0.0776645], [-0.0225161, 0.0853673]],
    modifiedStereographic_miller = [[0.9245, 0], [0, 0], [0.01943, 0]],
    lee = [[0.721316, 0], [0, 0], [-0.00881625, -0.00617325]];

function modifiedStereographicAlaska() {
  return modifiedStereographic(alaska, [152, -64])
      .scale(1400)
      .center([-160.908, 62.4864])
      .clipAngle(30)
      .angle(7.8);
}

function modifiedStereographicGs48() {
  return modifiedStereographic(gs48, [95, -38])
      .scale(1000)
      .clipAngle(55)
      .center([-96.5563, 38.8675]);
}

function modifiedStereographicGs50() {
  return modifiedStereographic(gs50, [120, -45])
      .scale(359.513)
      .clipAngle(55)
      .center([-117.474, 53.0628]);
}

function modifiedStereographicMiller() {
  return modifiedStereographic(modifiedStereographic_miller, [-20, -18])
      .scale(209.091)
      .center([20, 16.7214])
      .clipAngle(82);
}

function modifiedStereographicLee() {
  return modifiedStereographic(lee, [165, 10])
      .scale(250)
      .clipAngle(130)
      .center([-165, -10]);
}

function modifiedStereographic(coefficients, rotate) {
  var p = (0,src_projection/* default */.A)(modifiedStereographicRaw(coefficients)).rotate(rotate).clipAngle(90),
      r = (0,rotation/* default */.A)(rotate),
      center = p.center;

  delete p.rotate;

  p.center = function(_) {
    return arguments.length ? center(r(_)) : r.invert(center());
  };

  return p;
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/mtFlatPolarParabolic.js



var sqrt6 = sqrt(6),
    sqrt7 = sqrt(7);

function mtFlatPolarParabolicRaw(lambda, phi) {
  var theta = asin(7 * sin(phi) / (3 * sqrt6));
  return [
    sqrt6 * lambda * (2 * cos(2 * theta / 3) - 1) / sqrt7,
    9 * sin(theta / 3) / sqrt7
  ];
}

mtFlatPolarParabolicRaw.invert = function(x, y) {
  var theta = 3 * asin(y * sqrt7 / 9);
  return [
    x * sqrt7 / (sqrt6 * (2 * cos(2 * theta / 3) - 1)),
    asin(sin(theta) * 3 * sqrt6 / 7)
  ];
};

/* harmony default export */ function mtFlatPolarParabolic() {
  return (0,src_projection/* default */.A)(mtFlatPolarParabolicRaw)
      .scale(164.859);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/mtFlatPolarQuartic.js



function mtFlatPolarQuarticRaw(lambda, phi) {
  var k = (1 + sqrt1_2) * sin(phi),
      theta = phi;
  for (var i = 0, delta; i < 25; i++) {
    theta -= delta = (sin(theta / 2) + sin(theta) - k) / (0.5 * cos(theta / 2) + cos(theta));
    if (abs(delta) < epsilon) break;
  }
  return [
    lambda * (1 + 2 * cos(theta) / cos(theta / 2)) / (3 * sqrt2),
    2 * sqrt(3) * sin(theta / 2) / sqrt(2 + sqrt2)
  ];
}

mtFlatPolarQuarticRaw.invert = function(x, y) {
  var sinTheta_2 = y * sqrt(2 + sqrt2) / (2 * sqrt(3)),
      theta = 2 * asin(sinTheta_2);
  return [
    3 * sqrt2 * x / (1 + 2 * cos(theta) / cos(theta / 2)),
    asin((sinTheta_2 + sin(theta)) / (1 + sqrt1_2))
  ];
};

/* harmony default export */ function mtFlatPolarQuartic() {
  return (0,src_projection/* default */.A)(mtFlatPolarQuarticRaw)
      .scale(188.209);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/mtFlatPolarSinusoidal.js



function mtFlatPolarSinusoidalRaw(lambda, phi) {
  var A = sqrt(6 / (4 + pi)),
      k = (1 + pi / 4) * sin(phi),
      theta = phi / 2;
  for (var i = 0, delta; i < 25; i++) {
    theta -= delta = (theta / 2 + sin(theta) - k) / (0.5 + cos(theta));
    if (abs(delta) < epsilon) break;
  }
  return [
    A * (0.5 + cos(theta)) * lambda / 1.5,
    A * theta
  ];
}

mtFlatPolarSinusoidalRaw.invert = function(x, y) {
  var A = sqrt(6 / (4 + pi)),
      theta = y / A;
  if (abs(abs(theta) - halfPi) < epsilon) theta = theta < 0 ? -halfPi : halfPi;
  return [
    1.5 * x / (A * (0.5 + cos(theta))),
    asin((theta / 2 + sin(theta)) / (1 + pi / 4))
  ];
};

/* harmony default export */ function mtFlatPolarSinusoidal() {
  return (0,src_projection/* default */.A)(mtFlatPolarSinusoidalRaw)
      .scale(166.518);
}

// EXTERNAL MODULE: ./node_modules/d3-geo/src/projection/naturalEarth1.js
var naturalEarth1 = __webpack_require__(57949);
;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/naturalEarth2.js



function naturalEarth2Raw(lambda, phi) {
  var phi2 = phi * phi, phi4 = phi2 * phi2, phi6 = phi2 * phi4;
  return [
    lambda * (0.84719 - 0.13063 * phi2 + phi6 * phi6 * (-0.04515 + 0.05494 * phi2 - 0.02326 * phi4 + 0.00331 * phi6)),
    phi * (1.01183 + phi4 * phi4 * (-0.02625 + 0.01926 * phi2 - 0.00396 * phi4))
  ];
}

naturalEarth2Raw.invert = function(x, y) {
  var phi = y, i = 25, delta, phi2, phi4, phi6;
  do {
    phi2 = phi * phi; phi4 = phi2 * phi2;
    phi -= delta = ((phi * (1.01183 + phi4 * phi4 * (-0.02625 + 0.01926 * phi2 - 0.00396 * phi4))) - y) /
      (1.01183 + phi4 * phi4 * ((9 * -0.02625) + (11 * 0.01926) * phi2 + (13 * -0.00396) * phi4));
  } while (abs(delta) > epsilon2 && --i > 0);
  phi2 = phi * phi; phi4 = phi2 * phi2; phi6 = phi2 * phi4;
  return [
    x / (0.84719 - 0.13063 * phi2 + phi6 * phi6 * (-0.04515 + 0.05494 * phi2 - 0.02326 * phi4 + 0.00331 * phi6)),
    phi
  ];
};

/* harmony default export */ function naturalEarth2() {
  return (0,src_projection/* default */.A)(naturalEarth2Raw)
      .scale(175.295);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/nellHammer.js



function nellHammerRaw(lambda, phi) {
  return [
    lambda * (1 + cos(phi)) / 2,
    2 * (phi - tan(phi / 2))
  ];
}

nellHammerRaw.invert = function(x, y) {
  var p = y / 2;
  for (var i = 0, delta = Infinity; i < 10 && abs(delta) > epsilon; ++i) {
    var c = cos(y / 2);
    y -= delta = (y - tan(y / 2) - p) / (1 - 0.5 / (c * c));
  }
  return [
    2 * x / (1 + cos(y)),
    y
  ];
};

/* harmony default export */ function nellHammer() {
  return (0,src_projection/* default */.A)(nellHammerRaw)
      .scale(152.63);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/interrupted/quarticAuthalic.js



var quarticAuthalic_lobes = [[ // northern hemisphere
  [[-180,  0],  [-90,  90], [   0,  0]],
  [[   0,  0], [  90,  90], [ 180, 0]]
], [ // southern hemisphere
  [[-180, 0], [-90, -90], [  0, 0]],
  [[   0, 0], [ 90, -90], [180, 0]]
]];

/* harmony default export */ function quarticAuthalic() {
  return interrupted(hammerRaw(Infinity), quarticAuthalic_lobes)
      .rotate([20, 0])
      .scale(152.63);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/nicolosi.js




// Based on Torben Jansen's implementation
// https://beta.observablehq.com/@toja/nicolosi-globular-projection
// https://beta.observablehq.com/@toja/nicolosi-globular-inverse

function nicolosiRaw(lambda, phi) {
  var sinPhi = sin(phi),
    q = cos(phi),
    s = sign(lambda);

  if (lambda === 0 || abs(phi) === halfPi) return [0, phi];
  else if (phi === 0) return [lambda, 0];
  else if (abs(lambda) === halfPi) return [lambda * q, halfPi * sinPhi];

  var b = pi / (2 * lambda) - (2 * lambda) / pi,
    c = (2 * phi) / pi,
    d = (1 - c * c) / (sinPhi - c);

  var b2 = b * b,
    d2 = d * d,
    b2d2 = 1 + b2 / d2,
    d2b2 = 1 + d2 / b2;

  var M = ((b * sinPhi) / d - b / 2) / b2d2,
    N = ((d2 * sinPhi) / b2 + d / 2) / d2b2,
    m = M * M + (q * q) / b2d2,
    n = N * N - ((d2 * sinPhi * sinPhi) / b2 + d * sinPhi - 1) / d2b2;

  return [
    halfPi * (M + sqrt(m) * s),
    halfPi * (N + sqrt(n < 0 ? 0 : n) * sign(-phi * b) * s)
  ];
}

nicolosiRaw.invert = function(x, y) {

  x /= halfPi;
  y /= halfPi;

  var x2 = x * x,
    y2 = y * y,
    x2y2 = x2 + y2,
    pi2 = pi * pi;

  return [
    x ? (x2y2 -1 + sqrt((1 - x2y2) * (1 - x2y2) + 4 * x2)) / (2 * x) * halfPi : 0,
    solve(function(phi) {
      return (
        x2y2 * (pi * sin(phi) - 2 * phi) * pi +
        4 * phi * phi * (y - sin(phi)) +
        2 * pi * phi -
        pi2 * y
      );
    }, 0)
  ];
};

/* harmony default export */ function nicolosi() {
  return (0,src_projection/* default */.A)(nicolosiRaw)
    .scale(127.267);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/patterson.js



// Based on Java implementation by Bojan Savric.
// https://github.com/OSUCartography/JMapProjLib/blob/master/src/com/jhlabs/map/proj/PattersonProjection.java

var pattersonK1 = 1.0148,
    pattersonK2 = 0.23185,
    pattersonK3 = -0.14499,
    pattersonK4 = 0.02406,
    pattersonC1 = pattersonK1,
    pattersonC2 = 5 * pattersonK2,
    pattersonC3 = 7 * pattersonK3,
    pattersonC4 = 9 * pattersonK4,
    pattersonYmax = 1.790857183;

function pattersonRaw(lambda, phi) {
  var phi2 = phi * phi;
  return [
    lambda,
    phi * (pattersonK1 + phi2 * phi2 * (pattersonK2 + phi2 * (pattersonK3 + pattersonK4 * phi2)))
  ];
}

pattersonRaw.invert = function(x, y) {
  if (y > pattersonYmax) y = pattersonYmax;
  else if (y < -pattersonYmax) y = -pattersonYmax;
  var yc = y, delta;

  do { // Newton-Raphson
    var y2 = yc * yc;
    yc -= delta = ((yc * (pattersonK1 + y2 * y2 * (pattersonK2 + y2 * (pattersonK3 + pattersonK4 * y2)))) - y) / (pattersonC1 + y2 * y2 * (pattersonC2 + y2 * (pattersonC3 + pattersonC4 * y2)));
  } while (abs(delta) > epsilon);

  return [x, yc];
};

/* harmony default export */ function patterson() {
  return (0,src_projection/* default */.A)(pattersonRaw)
      .scale(139.319);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/polyconic.js



function polyconicRaw(lambda, phi) {
  if (abs(phi) < epsilon) return [lambda, 0];
  var tanPhi = tan(phi),
      k = lambda * sin(phi);
  return [
    sin(k) / tanPhi,
    phi + (1 - cos(k)) / tanPhi
  ];
}

polyconicRaw.invert = function(x, y) {
  if (abs(y) < epsilon) return [x, 0];
  var k = x * x + y * y,
      phi = y * 0.5,
      i = 10, delta;
  do {
    var tanPhi = tan(phi),
        secPhi = 1 / cos(phi),
        j = k - 2 * y * phi + phi * phi;
    phi -= delta = (tanPhi * j + 2 * (phi - y)) / (2 + j * secPhi * secPhi + 2 * (phi - y) * tanPhi);
  } while (abs(delta) > epsilon && --i > 0);
  tanPhi = tan(phi);
  return [
    (abs(y) < abs(phi + 1 / tanPhi) ? asin(x * tanPhi) : sign(y) * sign(x) * (acos(abs(x * tanPhi)) + halfPi)) / sin(phi),
    phi
  ];
};

/* harmony default export */ function polyconic() {
  return (0,src_projection/* default */.A)(polyconicRaw)
      .scale(103.74);
}

// EXTERNAL MODULE: ./node_modules/d3-geo/src/bounds.js
var bounds = __webpack_require__(43212);
// EXTERNAL MODULE: ./node_modules/d3-geo/src/interpolate.js
var interpolate = __webpack_require__(81758);
;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/polyhedral/matrix.js


// Note: 6-element arrays are used to denote the 3x3 affine transform matrix:
// [a, b, c,
//  d, e, f,
//  0, 0, 1] - this redundant row is left out.

// Transform matrix for [a0, a1] -> [b0, b1].
/* harmony default export */ function matrix(a, b) {
  var u = subtract(a[1], a[0]),
      v = subtract(b[1], b[0]),
      phi = matrix_angle(u, v),
      s = matrix_length(u) / matrix_length(v);

  return multiply([
    1, 0, a[0][0],
    0, 1, a[0][1]
  ], multiply([
    s, 0, 0,
    0, s, 0
  ], multiply([
    cos(phi), sin(phi), 0,
    -sin(phi), cos(phi), 0
  ], [
    1, 0, -b[0][0],
    0, 1, -b[0][1]
  ])));
}

// Inverts a transform matrix.
function inverse(m) {
  var k = 1 / (m[0] * m[4] - m[1] * m[3]);
  return [
    k * m[4], -k * m[1], k * (m[1] * m[5] - m[2] * m[4]),
    -k * m[3], k * m[0], k * (m[2] * m[3] - m[0] * m[5])
  ];
}

// Multiplies two 3x2 matrices.
function multiply(a, b) {
  return [
    a[0] * b[0] + a[1] * b[3],
    a[0] * b[1] + a[1] * b[4],
    a[0] * b[2] + a[1] * b[5] + a[2],
    a[3] * b[0] + a[4] * b[3],
    a[3] * b[1] + a[4] * b[4],
    a[3] * b[2] + a[4] * b[5] + a[5]
  ];
}

// Subtracts 2D vectors.
function subtract(a, b) {
  return [a[0] - b[0], a[1] - b[1]];
}

// Magnitude of a 2D vector.
function matrix_length(v) {
  return sqrt(v[0] * v[0] + v[1] * v[1]);
}

// Angle between two 2D vectors.
function matrix_angle(a, b) {
  return atan2(a[0] * b[1] - a[1] * b[0], a[0] * b[0] + a[1] * b[1]);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/polyhedral/index.js




// Creates a polyhedral projection.
//  * root: a spanning tree of polygon faces.  Nodes are automatically
//    augmented with a transform matrix.
//  * face: a function that returns the appropriate node for a given {lambda, phi}
//    point (radians).
//  * r: rotation angle for root face [deprecated by .angle()].
/* harmony default export */ function polyhedral(root, face, r) {

  recurse(root, {transform: null});

  function recurse(node, parent) {
    node.edges = faceEdges(node.face);
    // Find shared edge.
    if (parent.face) {
      var shared = node.shared = sharedEdge(node.face, parent.face),
          m = matrix(shared.map(parent.project), shared.map(node.project));
      node.transform = parent.transform ? multiply(parent.transform, m) : m;
      // Replace shared edge in parent edges array.
      var edges = parent.edges;
      for (var i = 0, n = edges.length; i < n; ++i) {
        if (polyhedral_pointEqual(shared[0], edges[i][1]) && polyhedral_pointEqual(shared[1], edges[i][0])) edges[i] = node;
        if (polyhedral_pointEqual(shared[0], edges[i][0]) && polyhedral_pointEqual(shared[1], edges[i][1])) edges[i] = node;
      }
      edges = node.edges;
      for (i = 0, n = edges.length; i < n; ++i) {
        if (polyhedral_pointEqual(shared[0], edges[i][0]) && polyhedral_pointEqual(shared[1], edges[i][1])) edges[i] = parent;
        if (polyhedral_pointEqual(shared[0], edges[i][1]) && polyhedral_pointEqual(shared[1], edges[i][0])) edges[i] = parent;
      }
    } else {
      node.transform = parent.transform;
    }
    if (node.children) {
      node.children.forEach(function(child) {
        recurse(child, node);
      });
    }
    return node;
  }

  function forward(lambda, phi) {
    var node = face(lambda, phi),
        point = node.project([lambda * degrees, phi * degrees]),
        t;
    if (t = node.transform) {
      return [
        t[0] * point[0] + t[1] * point[1] + t[2],
        -(t[3] * point[0] + t[4] * point[1] + t[5])
      ];
    }
    point[1] = -point[1];
    return point;
  }

  // Naive inverse!  A faster solution would use bounding boxes, or even a
  // polygonal quadtree.
  if (hasInverse(root)) forward.invert = function(x, y) {
    var coordinates = faceInvert(root, [x, -y]);
    return coordinates && (coordinates[0] *= radians, coordinates[1] *= radians, coordinates);
  };

  function faceInvert(node, coordinates) {
    var invert = node.project.invert,
        t = node.transform,
        point = coordinates;
    if (t) {
      t = inverse(t);
      point = [
        t[0] * point[0] + t[1] * point[1] + t[2],
        (t[3] * point[0] + t[4] * point[1] + t[5])
      ];
    }
    if (invert && node === faceDegrees(p = invert(point))) return p;
    var p,
        children = node.children;
    for (var i = 0, n = children && children.length; i < n; ++i) {
      if (p = faceInvert(children[i], coordinates)) return p;
    }
  }

  function faceDegrees(coordinates) {
    return face(coordinates[0] * radians, coordinates[1] * radians);
  }

  var proj = (0,src_projection/* default */.A)(forward),
      stream_ = proj.stream;

  proj.stream = function(stream) {
    var rotate = proj.rotate(),
        rotateStream = stream_(stream),
        sphereStream = (proj.rotate([0, 0]), stream_(stream));
    proj.rotate(rotate);
    rotateStream.sphere = function() {
      sphereStream.polygonStart();
      sphereStream.lineStart();
      outline(sphereStream, root);
      sphereStream.lineEnd();
      sphereStream.polygonEnd();
    };
    return rotateStream;
  };

  return proj.angle(r == null ? -30 : r * degrees);
}

function outline(stream, node, parent) {
  var point,
      edges = node.edges,
      n = edges.length,
      edge,
      multiPoint = {type: "MultiPoint", coordinates: node.face},
      notPoles = node.face.filter(function(d) { return abs(d[1]) !== 90; }),
      b = (0,bounds/* default */.A)({type: "MultiPoint", coordinates: notPoles}),
      inside = false,
      j = -1,
      dx = b[1][0] - b[0][0];
  // TODO
  var c = dx === 180 || dx === 360
      ? [(b[0][0] + b[1][0]) / 2, (b[0][1] + b[1][1]) / 2]
      : (0,centroid/* default */.A)(multiPoint);
  // First find the shared edge…
  if (parent) while (++j < n) {
    if (edges[j] === parent) break;
  }
  ++j;
  for (var i = 0; i < n; ++i) {
    edge = edges[(i + j) % n];
    if (Array.isArray(edge)) {
      if (!inside) {
        stream.point((point = (0,interpolate/* default */.A)(edge[0], c)(epsilon))[0], point[1]);
        inside = true;
      }
      stream.point((point = (0,interpolate/* default */.A)(edge[1], c)(epsilon))[0], point[1]);
    } else {
      inside = false;
      if (edge !== parent) outline(stream, edge, node);
    }
  }
}

// Tests equality of two spherical points.
function polyhedral_pointEqual(a, b) {
  return a && b && a[0] === b[0] && a[1] === b[1];
}

// Finds a shared edge given two clockwise polygons.
function sharedEdge(a, b) {
  var x, y, n = a.length, found = null;
  for (var i = 0; i < n; ++i) {
    x = a[i];
    for (var j = b.length; --j >= 0;) {
      y = b[j];
      if (x[0] === y[0] && x[1] === y[1]) {
        if (found) return [found, x];
        found = x;
      }
    }
  }
}

// Converts an array of n face vertices to an array of n + 1 edges.
function faceEdges(face) {
  var n = face.length,
      edges = [];
  for (var a = face[n - 1], i = 0; i < n; ++i) edges.push([a, a = face[i]]);
  return edges;
}

function hasInverse(node) {
  return node.project.invert || node.children && node.children.some(hasInverse);
}

// EXTERNAL MODULE: ./node_modules/d3-geo/src/projection/gnomonic.js
var gnomonic = __webpack_require__(48419);
;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/polyhedral/octahedron.js
// TODO generate on-the-fly to avoid external modification.
var octahedron = [
  [0, 90],
  [-90, 0], [0, 0], [90, 0], [180, 0],
  [0, -90]
];

/* harmony default export */ var polyhedral_octahedron = ([
  [0, 2, 1],
  [0, 3, 2],
  [5, 1, 2],
  [5, 2, 3],
  [0, 1, 4],
  [0, 4, 3],
  [5, 4, 1],
  [5, 3, 4]
].map(function(face) {
  return face.map(function(i) {
    return octahedron[i];
  });
}));

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/polyhedral/butterfly.js





/* harmony default export */ function butterfly(faceProjection) {

  faceProjection = faceProjection || function(face) {
    var c = (0,centroid/* default */.A)({type: "MultiPoint", coordinates: face});
    return (0,gnomonic/* default */.A)().scale(1).translate([0, 0]).rotate([-c[0], -c[1]]);
  };

  var faces = polyhedral_octahedron.map(function(face) {
    return {face: face, project: faceProjection(face)};
  });

  [-1, 0, 0, 1, 0, 1, 4, 5].forEach(function(d, i) {
    var node = faces[d];
    node && (node.children || (node.children = [])).push(faces[i]);
  });

  return polyhedral(faces[0], function(lambda, phi) {
        return faces[lambda < -pi / 2 ? phi < 0 ? 6 : 4
            : lambda < 0 ? phi < 0 ? 2 : 0
            : lambda < pi / 2 ? phi < 0 ? 3 : 1
            : phi < 0 ? 7 : 5];
      })
      .angle(-30)
      .scale(101.858)
      .center([0, 45]);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/polyhedral/collignon.js






var kx = 2 / sqrt(3);

function collignonK(a, b) {
  var p = collignonRaw(a, b);
  return [p[0] * kx, p[1]];
}

collignonK.invert = function(x,y) {
  return collignonRaw.invert(x / kx, y);
};

/* harmony default export */ function polyhedral_collignon(faceProjection) {

  faceProjection = faceProjection || function(face) {
    var c = (0,centroid/* default */.A)({type: "MultiPoint", coordinates: face});
    return (0,src_projection/* default */.A)(collignonK).translate([0, 0]).scale(1).rotate(c[1] > 0 ? [-c[0], 0] : [180 - c[0], 180]);
  };

  var faces = polyhedral_octahedron.map(function(face) {
    return {face: face, project: faceProjection(face)};
  });

  [-1, 0, 0, 1, 0, 1, 4, 5].forEach(function(d, i) {
    var node = faces[d];
    node && (node.children || (node.children = [])).push(faces[i]);
  });

  return polyhedral(faces[0], function(lambda, phi) {
        return faces[lambda < -pi / 2 ? phi < 0 ? 6 : 4
            : lambda < 0 ? phi < 0 ? 2 : 0
            : lambda < pi / 2 ? phi < 0 ? 3 : 1
            : phi < 0 ? 7 : 5];
      })
      .angle(-30)
      .scale(121.906)
      .center([0, 48.5904]);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/polyhedral/waterman.js





/* harmony default export */ function waterman(faceProjection) {

  faceProjection = faceProjection || function(face) {
    var c = face.length === 6 ? (0,centroid/* default */.A)({type: "MultiPoint", coordinates: face}) : face[0];
    return (0,gnomonic/* default */.A)().scale(1).translate([0, 0]).rotate([-c[0], -c[1]]);
  };

  var w5 = polyhedral_octahedron.map(function(face) {
    var xyz = face.map(cartesian),
        n = xyz.length,
        a = xyz[n - 1],
        b,
        hexagon = [];
    for (var i = 0; i < n; ++i) {
      b = xyz[i];
      hexagon.push(spherical([
        a[0] * 0.9486832980505138 + b[0] * 0.31622776601683794,
        a[1] * 0.9486832980505138 + b[1] * 0.31622776601683794,
        a[2] * 0.9486832980505138 + b[2] * 0.31622776601683794
      ]), spherical([
        b[0] * 0.9486832980505138 + a[0] * 0.31622776601683794,
        b[1] * 0.9486832980505138 + a[1] * 0.31622776601683794,
        b[2] * 0.9486832980505138 + a[2] * 0.31622776601683794
      ]));
      a = b;
    }
    return hexagon;
  });

  var cornerNormals = [];

  var parents = [-1, 0, 0, 1, 0, 1, 4, 5];

  w5.forEach(function(hexagon, j) {
    var face = polyhedral_octahedron[j],
        n = face.length,
        normals = cornerNormals[j] = [];
    for (var i = 0; i < n; ++i) {
      w5.push([
        face[i],
        hexagon[(i * 2 + 2) % (2 * n)],
        hexagon[(i * 2 + 1) % (2 * n)]
      ]);
      parents.push(j);
      normals.push(cross(
        cartesian(hexagon[(i * 2 + 2) % (2 * n)]),
        cartesian(hexagon[(i * 2 + 1) % (2 * n)])
      ));
    }
  });

  var faces = w5.map(function(face) {
    return {
      project: faceProjection(face),
      face: face
    };
  });

  parents.forEach(function(d, i) {
    var parent = faces[d];
    parent && (parent.children || (parent.children = [])).push(faces[i]);
  });

  function face(lambda, phi) {
    var cosphi = cos(phi),
        p = [cosphi * cos(lambda), cosphi * sin(lambda), sin(phi)];

    var hexagon = lambda < -pi / 2 ? phi < 0 ? 6 : 4
        : lambda < 0 ? phi < 0 ? 2 : 0
        : lambda < pi / 2 ? phi < 0 ? 3 : 1
        : phi < 0 ? 7 : 5;

    var n = cornerNormals[hexagon];

    return faces[dot(n[0], p) < 0 ? 8 + 3 * hexagon
        : dot(n[1], p) < 0 ? 8 + 3 * hexagon + 1
        : dot(n[2], p) < 0 ? 8 + 3 * hexagon + 2
        : hexagon];
  }

  return polyhedral(faces[0], face)
      .angle(-30)
      .scale(110.625)
      .center([0,45]);
}

function dot(a, b) {
  for (var i = 0, n = a.length, s = 0; i < n; ++i) s += a[i] * b[i];
  return s;
}

function cross(a, b) {
  return [
    a[1] * b[2] - a[2] * b[1],
    a[2] * b[0] - a[0] * b[2],
    a[0] * b[1] - a[1] * b[0]
  ];
}

// Converts 3D Cartesian to spherical coordinates (degrees).
function spherical(cartesian) {
  return [
    atan2(cartesian[1], cartesian[0]) * degrees,
    asin(max(-1, min(1, cartesian[2]))) * degrees
  ];
}

// Converts spherical coordinates (degrees) to 3D Cartesian.
function cartesian(coordinates) {
  var lambda = coordinates[0] * radians,
      phi = coordinates[1] * radians,
      cosphi = cos(phi);
  return [
    cosphi * cos(lambda),
    cosphi * sin(lambda),
    sin(phi)
  ];
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/noop.js
/* harmony default export */ function noop() {}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/project/clockwise.js
/* harmony default export */ function clockwise(ring) {
  if ((n = ring.length) < 4) return false;
  var i = 0,
      n,
      area = ring[n - 1][1] * ring[0][0] - ring[n - 1][0] * ring[0][1];
  while (++i < n) area += ring[i - 1][1] * ring[i][0] - ring[i - 1][0] * ring[i][1];
  return area <= 0;
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/project/contains.js
/* harmony default export */ function contains(ring, point) {
  var x = point[0],
      y = point[1],
      contains = false;
  for (var i = 0, n = ring.length, j = n - 1; i < n; j = i++) {
    var pi = ring[i], xi = pi[0], yi = pi[1],
        pj = ring[j], xj = pj[0], yj = pj[1];
    if (((yi > y) ^ (yj > y)) && (x < (xj - xi) * (y - yi) / (yj - yi) + xi)) contains = !contains;
  }
  return contains;
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/project/index.js





/* harmony default export */ function project(object, projection) {
  var stream = projection.stream, project;
  if (!stream) throw new Error("invalid projection");
  switch (object && object.type) {
    case "Feature": project = projectFeature; break;
    case "FeatureCollection": project = projectFeatureCollection; break;
    default: project = projectGeometry; break;
  }
  return project(object, stream);
}

function projectFeatureCollection(o, stream) {
  return {
    type: "FeatureCollection",
    features: o.features.map(function(f) {
      return projectFeature(f, stream);
    })
  };
}

function projectFeature(o, stream) {
  return {
    type: "Feature",
    id: o.id,
    properties: o.properties,
    geometry: projectGeometry(o.geometry, stream)
  };
}

function projectGeometryCollection(o, stream) {
  return {
    type: "GeometryCollection",
    geometries: o.geometries.map(function(o) {
      return projectGeometry(o, stream);
    })
  };
}

function projectGeometry(o, stream) {
  if (!o) return null;
  if (o.type === "GeometryCollection") return projectGeometryCollection(o, stream);
  var sink;
  switch (o.type) {
    case "Point": sink = sinkPoint; break;
    case "MultiPoint": sink = sinkPoint; break;
    case "LineString": sink = sinkLine; break;
    case "MultiLineString": sink = sinkLine; break;
    case "Polygon": sink = sinkPolygon; break;
    case "MultiPolygon": sink = sinkPolygon; break;
    case "Sphere": sink = sinkPolygon; break;
    default: return null;
  }
  (0,src_stream/* default */.A)(o, stream(sink));
  return sink.result();
}

var points = [],
    lines = [];

var sinkPoint = {
  point: function(x, y) {
    points.push([x, y]);
  },
  result: function() {
    var result = !points.length ? null
        : points.length < 2 ? {type: "Point", coordinates: points[0]}
        : {type: "MultiPoint", coordinates: points};
    points = [];
    return result;
  }
};

var sinkLine = {
  lineStart: noop,
  point: function(x, y) {
    points.push([x, y]);
  },
  lineEnd: function() {
    if (points.length) lines.push(points), points = [];
  },
  result: function() {
    var result = !lines.length ? null
        : lines.length < 2 ? {type: "LineString", coordinates: lines[0]}
        : {type: "MultiLineString", coordinates: lines};
    lines = [];
    return result;
  }
};

var sinkPolygon = {
  polygonStart: noop,
  lineStart: noop,
  point: function(x, y) {
    points.push([x, y]);
  },
  lineEnd: function() {
    var n = points.length;
    if (n) {
      do points.push(points[0].slice()); while (++n < 4);
      lines.push(points), points = [];
    }
  },
  polygonEnd: noop,
  result: function() {
    if (!lines.length) return null;
    var polygons = [],
        holes = [];

    // https://github.com/d3/d3/issues/1558
    lines.forEach(function(ring) {
      if (clockwise(ring)) polygons.push([ring]);
      else holes.push(ring);
    });

    holes.forEach(function(hole) {
      var point = hole[0];
      polygons.some(function(polygon) {
        if (contains(polygon[0], point)) {
          polygon.push(hole);
          return true;
        }
      }) || polygons.push([hole]);
    });

    lines = [];

    return !polygons.length ? null
        : polygons.length > 1 ? {type: "MultiPolygon", coordinates: polygons}
        : {type: "Polygon", coordinates: polygons[0]};
  }
};

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/quincuncial/index.js



/* harmony default export */ function quincuncial(project) {
  var dx = project(halfPi, 0)[0] - project(-halfPi, 0)[0];

  function projectQuincuncial(lambda, phi) {
    var t = abs(lambda) < halfPi,
        p = project(t ? lambda : lambda > 0 ? lambda - pi : lambda + pi, phi),
        x = (p[0] - p[1]) * sqrt1_2,
        y = (p[0] + p[1]) * sqrt1_2;
    if (t) return [x, y];
    var d = dx * sqrt1_2,
        s = x > 0 ^ y > 0 ? -1 : 1;
    return [s * x - sign(y) * d, s * y - sign(x) * d];
  }

  if (project.invert) projectQuincuncial.invert = function(x0, y0) {
    var x = (x0 + y0) * sqrt1_2,
        y = (y0 - x0) * sqrt1_2,
        t = abs(x) < 0.5 * dx && abs(y) < 0.5 * dx;

    if (!t) {
      var d = dx * sqrt1_2,
          s = x > 0 ^ y > 0 ? -1 : 1,
          x1 = -s * x0 + (y > 0 ? 1 : -1) * d,
          y1 = -s * y0 + (x > 0 ? 1 : -1) * d;
      x = (-x1 - y1) * sqrt1_2;
      y = (x1 - y1) * sqrt1_2;
    }

    var p = project.invert(x, y);
    if (!t) p[0] += x > 0 ? pi : -pi;
    return p;
  };

  return (0,src_projection/* default */.A)(projectQuincuncial)
      .rotate([-90, -90, 45])
      .clipAngle(180 - 1e-3);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/quincuncial/gringorten.js



/* harmony default export */ function quincuncial_gringorten() {
  return quincuncial(gringortenRaw)
      .scale(176.423);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/quincuncial/peirce.js



/* harmony default export */ function peirce() {
  return quincuncial(guyouRaw)
      .scale(111.48);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/quantize.js
/* harmony default export */ function quantize(input, digits) {
  if (!(0 <= (digits = +digits) && digits <= 20)) throw new Error("invalid digits");

  function quantizePoint(input) {
    var n = input.length, i = 2, output = new Array(n);
    output[0] = +input[0].toFixed(digits);
    output[1] = +input[1].toFixed(digits);
    while (i < n) output[i] = input[i], ++i;
    return output;
  }

  function quantizePoints(input) {
    return input.map(quantizePoint);
  }

  function quantizePointsNoDuplicates(input) {
    var point0 = quantizePoint(input[0]);
    var output = [point0];
    for (var i = 1; i < input.length; i++) {
      var point = quantizePoint(input[i]);
      if (point.length > 2 || point[0] != point0[0] || point[1] != point0[1]) {
        output.push(point);
        point0 = point;
      }
    }
    if (output.length === 1 && input.length > 1) {
      output.push(quantizePoint(input[input.length - 1]));
    }
    return output;
  }

  function quantizePolygon(input) {
    return input.map(quantizePointsNoDuplicates);
  }

  function quantizeGeometry(input) {
    if (input == null) return input;
    var output;
    switch (input.type) {
      case "GeometryCollection": output = {type: "GeometryCollection", geometries: input.geometries.map(quantizeGeometry)}; break;
      case "Point": output = {type: "Point", coordinates: quantizePoint(input.coordinates)}; break;
      case "MultiPoint": output = {type: input.type, coordinates: quantizePoints(input.coordinates)}; break;
      case "LineString": output = {type: input.type, coordinates: quantizePointsNoDuplicates(input.coordinates)}; break;
      case "MultiLineString": case "Polygon": output = {type: input.type, coordinates: quantizePolygon(input.coordinates)}; break;
      case "MultiPolygon": output = {type: "MultiPolygon", coordinates: input.coordinates.map(quantizePolygon)}; break;
      default: return input;
    }
    if (input.bbox != null) output.bbox = input.bbox;
    return output;
  }

  function quantizeFeature(input) {
    var output = {type: "Feature", properties: input.properties, geometry: quantizeGeometry(input.geometry)};
    if (input.id != null) output.id = input.id;
    if (input.bbox != null) output.bbox = input.bbox;
    return output;
  }

  if (input != null) switch (input.type) {
    case "Feature": return quantizeFeature(input);
    case "FeatureCollection": {
      var output = {type: "FeatureCollection", features: input.features.map(quantizeFeature)};
      if (input.bbox != null) output.bbox = input.bbox;
      return output;
    }
    default: return quantizeGeometry(input);
  }

  return input;
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/rectangularPolyconic.js



function rectangularPolyconicRaw(phi0) {
  var sinPhi0 = sin(phi0);

  function forward(lambda, phi) {
    var A = sinPhi0 ? tan(lambda * sinPhi0 / 2) / sinPhi0 : lambda / 2;
    if (!phi) return [2 * A, -phi0];
    var E = 2 * atan(A * sin(phi)),
        cotPhi = 1 / tan(phi);
    return [
      sin(E) * cotPhi,
      phi + (1 - cos(E)) * cotPhi - phi0
    ];
  }

  // TODO return null for points outside outline.
  forward.invert = function(x, y) {
    if (abs(y += phi0) < epsilon) return [sinPhi0 ? 2 * atan(sinPhi0 * x / 2) / sinPhi0 : x, 0];
    var k = x * x + y * y,
        phi = 0,
        i = 10, delta;
    do {
      var tanPhi = tan(phi),
          secPhi = 1 / cos(phi),
          j = k - 2 * y * phi + phi * phi;
      phi -= delta = (tanPhi * j + 2 * (phi - y)) / (2 + j * secPhi * secPhi + 2 * (phi - y) * tanPhi);
    } while (abs(delta) > epsilon && --i > 0);
    var E = x * (tanPhi = tan(phi)),
        A = tan(abs(y) < abs(phi + 1 / tanPhi) ? asin(E) * 0.5 : acos(E) * 0.5 + pi / 4) / sin(phi);
    return [
      sinPhi0 ? 2 * atan(sinPhi0 * A) / sinPhi0 : 2 * A,
      phi
    ];
  };

  return forward;
}

/* harmony default export */ function rectangularPolyconic() {
  return parallel1(rectangularPolyconicRaw)
      .scale(131.215);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/robinson.js



var robinson_K = [
  [0.9986, -0.062],
  [1.0000, 0.0000],
  [0.9986, 0.0620],
  [0.9954, 0.1240],
  [0.9900, 0.1860],
  [0.9822, 0.2480],
  [0.9730, 0.3100],
  [0.9600, 0.3720],
  [0.9427, 0.4340],
  [0.9216, 0.4958],
  [0.8962, 0.5571],
  [0.8679, 0.6176],
  [0.8350, 0.6769],
  [0.7986, 0.7346],
  [0.7597, 0.7903],
  [0.7186, 0.8435],
  [0.6732, 0.8936],
  [0.6213, 0.9394],
  [0.5722, 0.9761],
  [0.5322, 1.0000]
];

robinson_K.forEach(function(d) {
  d[1] *= 1.0144;
});

function robinsonRaw(lambda, phi) {
  var i = min(18, abs(phi) * 36 / pi),
      i0 = floor(i),
      di = i - i0,
      ax = (k = robinson_K[i0])[0],
      ay = k[1],
      bx = (k = robinson_K[++i0])[0],
      by = k[1],
      cx = (k = robinson_K[min(19, ++i0)])[0],
      cy = k[1],
      k;
  return [
    lambda * (bx + di * (cx - ax) / 2 + di * di * (cx - 2 * bx + ax) / 2),
    (phi > 0 ? halfPi : -halfPi) * (by + di * (cy - ay) / 2 + di * di * (cy - 2 * by + ay) / 2)
  ];
}

robinsonRaw.invert = function(x, y) {
  var yy = y / halfPi,
      phi = yy * 90,
      i = min(18, abs(phi / 5)),
      i0 = max(0, floor(i));
  do {
    var ay = robinson_K[i0][1],
        by = robinson_K[i0 + 1][1],
        cy = robinson_K[min(19, i0 + 2)][1],
        u = cy - ay,
        v = cy - 2 * by + ay,
        t = 2 * (abs(yy) - by) / u,
        c = v / u,
        di = t * (1 - c * t * (1 - 2 * c * t));
    if (di >= 0 || i0 === 1) {
      phi = (y >= 0 ? 5 : -5) * (di + i);
      var j = 50, delta;
      do {
        i = min(18, abs(phi) / 5);
        i0 = floor(i);
        di = i - i0;
        ay = robinson_K[i0][1];
        by = robinson_K[i0 + 1][1];
        cy = robinson_K[min(19, i0 + 2)][1];
        phi -= (delta = (y >= 0 ? halfPi : -halfPi) * (by + di * (cy - ay) / 2 + di * di * (cy - 2 * by + ay) / 2) - y) * degrees;
      } while (abs(delta) > epsilon2 && --j > 0);
      break;
    }
  } while (--i0 >= 0);
  var ax = robinson_K[i0][0],
      bx = robinson_K[i0 + 1][0],
      cx = robinson_K[min(19, i0 + 2)][0];
  return [
    x / (bx + di * (cx - ax) / 2 + di * di * (cx - 2 * bx + ax) / 2),
    phi * radians
  ];
};

/* harmony default export */ function robinson() {
  return (0,src_projection/* default */.A)(robinsonRaw)
      .scale(152.63);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/satellite.js



function satelliteVerticalRaw(P) {
  function forward(lambda, phi) {
    var cosPhi = cos(phi),
        k = (P - 1) / (P - cosPhi * cos(lambda));
    return [
      k * cosPhi * sin(lambda),
      k * sin(phi)
    ];
  }

  forward.invert = function(x, y) {
    var rho2 = x * x + y * y,
        rho = sqrt(rho2),
        sinc = (P - sqrt(1 - rho2 * (P + 1) / (P - 1))) / ((P - 1) / rho + rho / (P - 1));
    return [
      atan2(x * sinc, rho * sqrt(1 - sinc * sinc)),
      rho ? asin(y * sinc / rho) : 0
    ];
  };

  return forward;
}

function satelliteRaw(P, omega) {
  var vertical = satelliteVerticalRaw(P);
  if (!omega) return vertical;
  var cosOmega = cos(omega),
      sinOmega = sin(omega);

  function forward(lambda, phi) {
    var coordinates = vertical(lambda, phi),
        y = coordinates[1],
        A = y * sinOmega / (P - 1) + cosOmega;
    return [
      coordinates[0] * cosOmega / A,
      y / A
    ];
  }

  forward.invert = function(x, y) {
    var k = (P - 1) / (P - 1 - y * sinOmega);
    return vertical.invert(k * x, k * y * cosOmega);
  };

  return forward;
}

/* harmony default export */ function satellite() {
  var distance = 2,
      omega = 0,
      m = (0,src_projection/* projectionMutator */.U)(satelliteRaw),
      p = m(distance, omega);

  // As a multiple of radius.
  p.distance = function(_) {
    if (!arguments.length) return distance;
    return m(distance = +_, omega);
  };

  p.tilt = function(_) {
    if (!arguments.length) return omega * degrees;
    return m(distance, omega = _ * radians);
  };

  return p
      .scale(432.147)
      .clipAngle(acos(1 / distance) * degrees - 1e-6);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/stitch.js
var stitch_epsilon = 1e-4,
    epsilonInverse = 1e4,
    x0 = -180, x0e = x0 + stitch_epsilon,
    x1 = 180, x1e = x1 - stitch_epsilon,
    y0 = -90, y0e = y0 + stitch_epsilon,
    y1 = 90, y1e = y1 - stitch_epsilon;

function nonempty(coordinates) {
  return coordinates.length > 0;
}

function stitch_quantize(x) {
  return Math.floor(x * epsilonInverse) / epsilonInverse;
}

function normalizePoint(y) {
  return y === y0 || y === y1 ? [0, y] : [x0, stitch_quantize(y)]; // pole or antimeridian?
}

function clampPoint(p) {
  var x = p[0], y = p[1], clamped = false;
  if (x <= x0e) x = x0, clamped = true;
  else if (x >= x1e) x = x1, clamped = true;
  if (y <= y0e) y = y0, clamped = true;
  else if (y >= y1e) y = y1, clamped = true;
  return clamped ? [x, y] : p;
}

function clampPoints(points) {
  return points.map(clampPoint);
}

// For each ring, detect where it crosses the antimeridian or pole.
function extractFragments(rings, polygon, fragments) {
  for (var j = 0, m = rings.length; j < m; ++j) {
    var ring = rings[j].slice();

    // By default, assume that this ring doesn’t need any stitching.
    fragments.push({index: -1, polygon: polygon, ring: ring});

    for (var i = 0, n = ring.length; i < n; ++i) {
      var point = ring[i],
          x = point[0],
          y = point[1];

      // If this is an antimeridian or polar point…
      if (x <= x0e || x >= x1e || y <= y0e || y >= y1e) {
        ring[i] = clampPoint(point);

        // Advance through any antimeridian or polar points…
        for (var k = i + 1; k < n; ++k) {
          var pointk = ring[k],
              xk = pointk[0],
              yk = pointk[1];
          if (xk > x0e && xk < x1e && yk > y0e && yk < y1e) break;
        }

        // If this was just a single antimeridian or polar point,
        // we don’t need to cut this ring into a fragment;
        // we can just leave it as-is.
        if (k === i + 1) continue;

        // Otherwise, if this is not the first point in the ring,
        // cut the current fragment so that it ends at the current point.
        // The current point is also normalized for later joining.
        if (i) {
          var fragmentBefore = {index: -1, polygon: polygon, ring: ring.slice(0, i + 1)};
          fragmentBefore.ring[fragmentBefore.ring.length - 1] = normalizePoint(y);
          fragments[fragments.length - 1] = fragmentBefore;
        }

        // If the ring started with an antimeridian fragment,
        // we can ignore that fragment entirely.
        else fragments.pop();

        // If the remainder of the ring is an antimeridian fragment,
        // move on to the next ring.
        if (k >= n) break;

        // Otherwise, add the remaining ring fragment and continue.
        fragments.push({index: -1, polygon: polygon, ring: ring = ring.slice(k - 1)});
        ring[0] = normalizePoint(ring[0][1]);
        i = -1;
        n = ring.length;
      }
    }
  }
}

// Now stitch the fragments back together into rings.
function stitchFragments(fragments) {
  var i, n = fragments.length;

  // To connect the fragments start-to-end, create a simple index by end.
  var fragmentByStart = {},
      fragmentByEnd = {},
      fragment,
      start,
      startFragment,
      end,
      endFragment;

  // For each fragment…
  for (i = 0; i < n; ++i) {
    fragment = fragments[i];
    start = fragment.ring[0];
    end = fragment.ring[fragment.ring.length - 1];

    // If this fragment is closed, add it as a standalone ring.
    if (start[0] === end[0] && start[1] === end[1]) {
      fragment.polygon.push(fragment.ring);
      fragments[i] = null;
      continue;
    }

    fragment.index = i;
    fragmentByStart[start] = fragmentByEnd[end] = fragment;
  }

  // For each open fragment…
  for (i = 0; i < n; ++i) {
    fragment = fragments[i];
    if (fragment) {
      start = fragment.ring[0];
      end = fragment.ring[fragment.ring.length - 1];
      startFragment = fragmentByEnd[start];
      endFragment = fragmentByStart[end];

      delete fragmentByStart[start];
      delete fragmentByEnd[end];

      // If this fragment is closed, add it as a standalone ring.
      if (start[0] === end[0] && start[1] === end[1]) {
        fragment.polygon.push(fragment.ring);
        continue;
      }

      if (startFragment) {
        delete fragmentByEnd[start];
        delete fragmentByStart[startFragment.ring[0]];
        startFragment.ring.pop(); // drop the shared coordinate
        fragments[startFragment.index] = null;
        fragment = {index: -1, polygon: startFragment.polygon, ring: startFragment.ring.concat(fragment.ring)};

        if (startFragment === endFragment) {
          // Connect both ends to this single fragment to create a ring.
          fragment.polygon.push(fragment.ring);
        } else {
          fragment.index = n++;
          fragments.push(fragmentByStart[fragment.ring[0]] = fragmentByEnd[fragment.ring[fragment.ring.length - 1]] = fragment);
        }
      } else if (endFragment) {
        delete fragmentByStart[end];
        delete fragmentByEnd[endFragment.ring[endFragment.ring.length - 1]];
        fragment.ring.pop(); // drop the shared coordinate
        fragment = {index: n++, polygon: endFragment.polygon, ring: fragment.ring.concat(endFragment.ring)};
        fragments[endFragment.index] = null;
        fragments.push(fragmentByStart[fragment.ring[0]] = fragmentByEnd[fragment.ring[fragment.ring.length - 1]] = fragment);
      } else {
        fragment.ring.push(fragment.ring[0]); // close ring
        fragment.polygon.push(fragment.ring);
      }
    }
  }
}

function stitchFeature(input) {
  var output = {type: "Feature", geometry: stitchGeometry(input.geometry)};
  if (input.id != null) output.id = input.id;
  if (input.bbox != null) output.bbox = input.bbox;
  if (input.properties != null) output.properties = input.properties;
  return output;
}

function stitchGeometry(input) {
  if (input == null) return input;
  var output, fragments, i, n;
  switch (input.type) {
    case "GeometryCollection": output = {type: "GeometryCollection", geometries: input.geometries.map(stitchGeometry)}; break;
    case "Point": output = {type: "Point", coordinates: clampPoint(input.coordinates)}; break;
    case "MultiPoint": case "LineString": output = {type: input.type, coordinates: clampPoints(input.coordinates)}; break;
    case "MultiLineString": output = {type: "MultiLineString", coordinates: input.coordinates.map(clampPoints)}; break;
    case "Polygon": {
      var polygon = [];
      extractFragments(input.coordinates, polygon, fragments = []);
      stitchFragments(fragments);
      output = {type: "Polygon", coordinates: polygon};
      break;
    }
    case "MultiPolygon": {
      fragments = [], i = -1, n = input.coordinates.length;
      var polygons = new Array(n);
      while (++i < n) extractFragments(input.coordinates[i], polygons[i] = [], fragments);
      stitchFragments(fragments);
      output = {type: "MultiPolygon", coordinates: polygons.filter(nonempty)};
      break;
    }
    default: return input;
  }
  if (input.bbox != null) output.bbox = input.bbox;
  return output;
}

/* harmony default export */ function stitch(input) {
  if (input == null) return input;
  switch (input.type) {
    case "Feature": return stitchFeature(input);
    case "FeatureCollection": {
      var output = {type: "FeatureCollection", features: input.features.map(stitchFeature)};
      if (input.bbox != null) output.bbox = input.bbox;
      return output;
    }
    default: return stitchGeometry(input);
  }
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/times.js



function timesRaw(lambda, phi) {
  var t = tan(phi / 2),
      s = sin(quarterPi * t);
  return [
    lambda * (0.74482 - 0.34588 * s * s),
    1.70711 * t
  ];
}

timesRaw.invert = function(x, y) {
  var t = y / 1.70711,
      s = sin(quarterPi * t);
  return [
    x / (0.74482 - 0.34588 * s * s),
    2 * atan(t)
  ];
};

/* harmony default export */ function times() {
  return (0,src_projection/* default */.A)(timesRaw)
      .scale(146.153);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/twoPoint.js



// Compute the origin as the midpoint of the two reference points.
// Rotate one of the reference points by the origin.
// Apply the spherical law of sines to compute gamma rotation.
/* harmony default export */ function twoPoint(raw, p0, p1) {
  var i = (0,interpolate/* default */.A)(p0, p1),
      o = i(0.5),
      a = (0,rotation/* default */.A)([-o[0], -o[1]])(p0),
      b = i.distance / 2,
      y = -asin(sin(a[1] * radians) / sin(b)),
      R = [-o[0], -o[1], -(a[0] > 0 ? pi - y : y) * degrees],
      p = (0,src_projection/* default */.A)(raw(b)).rotate(R),
      r = (0,rotation/* default */.A)(R),
      center = p.center;

  delete p.rotate;

  p.center = function(_) {
    return arguments.length ? center(r(_)) : r.invert(center());
  };

  return p
      .clipAngle(90);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/twoPointAzimuthal.js




function twoPointAzimuthalRaw(d) {
  var cosd = cos(d);

  function forward(lambda, phi) {
    var coordinates = (0,gnomonic/* gnomonicRaw */.T)(lambda, phi);
    coordinates[0] *= cosd;
    return coordinates;
  }

  forward.invert = function(x, y) {
    return gnomonic/* gnomonicRaw */.T.invert(x / cosd, y);
  };

  return forward;
}

function twoPointAzimuthalUsa() {
  return twoPointAzimuthal([-158, 21.5], [-77, 39])
      .clipAngle(60)
      .scale(400);
}

function twoPointAzimuthal(p0, p1) {
  return twoPoint(twoPointAzimuthalRaw, p0, p1);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/twoPointEquidistant.js




// TODO clip to ellipse
function twoPointEquidistantRaw(z0) {
  if (!(z0 *= 2)) return azimuthalEquidistant/* azimuthalEquidistantRaw */.j;
  var lambdaa = -z0 / 2,
      lambdab = -lambdaa,
      z02 = z0 * z0,
      tanLambda0 = tan(lambdab),
      S = 0.5 / sin(lambdab);

  function forward(lambda, phi) {
    var za = acos(cos(phi) * cos(lambda - lambdaa)),
        zb = acos(cos(phi) * cos(lambda - lambdab)),
        ys = phi < 0 ? -1 : 1;
    za *= za, zb *= zb;
    return [
      (za - zb) / (2 * z0),
      ys * sqrt(4 * z02 * zb - (z02 - za + zb) * (z02 - za + zb)) / (2 * z0)
    ];
  }

  forward.invert = function(x, y) {
    var y2 = y * y,
        cosza = cos(sqrt(y2 + (t = x + lambdaa) * t)),
        coszb = cos(sqrt(y2 + (t = x + lambdab) * t)),
        t,
        d;
    return [
      atan2(d = cosza - coszb, t = (cosza + coszb) * tanLambda0),
      (y < 0 ? -1 : 1) * acos(sqrt(t * t + d * d) * S)
    ];
  };

  return forward;
}

function twoPointEquidistantUsa() {
  return twoPointEquidistant([-158, 21.5], [-77, 39])
      .clipAngle(130)
      .scale(122.571);
}

function twoPointEquidistant(p0, p1) {
  return twoPoint(twoPointEquidistantRaw, p0, p1);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/vanDerGrinten.js



function vanDerGrintenRaw(lambda, phi) {
  if (abs(phi) < epsilon) return [lambda, 0];
  var sinTheta = abs(phi / halfPi),
      theta = asin(sinTheta);
  if (abs(lambda) < epsilon || abs(abs(phi) - halfPi) < epsilon) return [0, sign(phi) * pi * tan(theta / 2)];
  var cosTheta = cos(theta),
      A = abs(pi / lambda - lambda / pi) / 2,
      A2 = A * A,
      G = cosTheta / (sinTheta + cosTheta - 1),
      P = G * (2 / sinTheta - 1),
      P2 = P * P,
      P2_A2 = P2 + A2,
      G_P2 = G - P2,
      Q = A2 + G;
  return [
    sign(lambda) * pi * (A * G_P2 + sqrt(A2 * G_P2 * G_P2 - P2_A2 * (G * G - P2))) / P2_A2,
    sign(phi) * pi * (P * Q - A * sqrt((A2 + 1) * P2_A2 - Q * Q)) / P2_A2
  ];
}

vanDerGrintenRaw.invert = function(x, y) {
  if (abs(y) < epsilon) return [x, 0];
  if (abs(x) < epsilon) return [0, halfPi * sin(2 * atan(y / pi))];
  var x2 = (x /= pi) * x,
      y2 = (y /= pi) * y,
      x2_y2 = x2 + y2,
      z = x2_y2 * x2_y2,
      c1 = -abs(y) * (1 + x2_y2),
      c2 = c1 - 2 * y2 + x2,
      c3 = -2 * c1 + 1 + 2 * y2 + z,
      d = y2 / c3 + (2 * c2 * c2 * c2 / (c3 * c3 * c3) - 9 * c1 * c2 / (c3 * c3)) / 27,
      a1 = (c1 - c2 * c2 / (3 * c3)) / c3,
      m1 = 2 * sqrt(-a1 / 3),
      theta1 = acos(3 * d / (a1 * m1)) / 3;
  return [
    pi * (x2_y2 - 1 + sqrt(1 + 2 * (x2 - y2) + z)) / (2 * x),
    sign(y) * pi * (-m1 * cos(theta1 + pi / 3) - c2 / (3 * c3))
  ];
};

/* harmony default export */ function vanDerGrinten() {
  return (0,src_projection/* default */.A)(vanDerGrintenRaw)
      .scale(79.4183);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/vanDerGrinten2.js



function vanDerGrinten2Raw(lambda, phi) {
  if (abs(phi) < epsilon) return [lambda, 0];
  var sinTheta = abs(phi / halfPi),
      theta = asin(sinTheta);
  if (abs(lambda) < epsilon || abs(abs(phi) - halfPi) < epsilon) return [0, sign(phi) * pi * tan(theta / 2)];
  var cosTheta = cos(theta),
      A = abs(pi / lambda - lambda / pi) / 2,
      A2 = A * A,
      x1 = cosTheta * (sqrt(1 + A2) - A * cosTheta) / (1 + A2 * sinTheta * sinTheta);
  return [
    sign(lambda) * pi * x1,
    sign(phi) * pi * sqrt(1 - x1 * (2 * A + x1))
  ];
}

vanDerGrinten2Raw.invert = function(x, y) {
  if (!x) return [0, halfPi * sin(2 * atan(y / pi))];
  var x1 = abs(x / pi),
      A = (1 - x1 * x1 - (y /= pi) * y) / (2 * x1),
      A2 = A * A,
      B = sqrt(A2 + 1);
  return [
    sign(x) * pi * (B - A),
    sign(y) * halfPi * sin(2 * atan2(sqrt((1 - 2 * A * x1) * (A + B) - x1), sqrt(B + A + x1)))
  ];
};

/* harmony default export */ function vanDerGrinten2() {
  return (0,src_projection/* default */.A)(vanDerGrinten2Raw)
      .scale(79.4183);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/vanDerGrinten3.js



function vanDerGrinten3Raw(lambda, phi) {
  if (abs(phi) < epsilon) return [lambda, 0];
  var sinTheta = phi / halfPi,
      theta = asin(sinTheta);
  if (abs(lambda) < epsilon || abs(abs(phi) - halfPi) < epsilon) return [0, pi * tan(theta / 2)];
  var A = (pi / lambda - lambda / pi) / 2,
      y1 = sinTheta / (1 + cos(theta));
  return [
    pi * (sign(lambda) * sqrt(A * A + 1 - y1 * y1) - A),
    pi * y1
  ];
}

vanDerGrinten3Raw.invert = function(x, y) {
  if (!y) return [x, 0];
  var y1 = y / pi,
      A = (pi * pi * (1 - y1 * y1) - x * x) / (2 * pi * x);
  return [
    x ? pi * (sign(x) * sqrt(A * A + 1) - A) : 0,
    halfPi * sin(2 * atan(y1))
  ];
};

/* harmony default export */ function vanDerGrinten3() {
  return (0,src_projection/* default */.A)(vanDerGrinten3Raw)
        .scale(79.4183);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/vanDerGrinten4.js



function vanDerGrinten4Raw(lambda, phi) {
  if (!phi) return [lambda, 0];
  var phi0 = abs(phi);
  if (!lambda || phi0 === halfPi) return [0, phi];
  var B = phi0 / halfPi,
      B2 = B * B,
      C = (8 * B - B2 * (B2 + 2) - 5) / (2 * B2 * (B - 1)),
      C2 = C * C,
      BC = B * C,
      B_C2 = B2 + C2 + 2 * BC,
      B_3C = B + 3 * C,
      lambda0 = lambda / halfPi,
      lambda1 = lambda0 + 1 / lambda0,
      D = sign(abs(lambda) - halfPi) * sqrt(lambda1 * lambda1 - 4),
      D2 = D * D,
      F = B_C2 * (B2 + C2 * D2 - 1) + (1 - B2) * (B2 * (B_3C * B_3C + 4 * C2) + 12 * BC * C2 + 4 * C2 * C2),
      x1 = (D * (B_C2 + C2 - 1) + 2 * sqrt(F)) / (4 * B_C2 + D2);
  return [
    sign(lambda) * halfPi * x1,
    sign(phi) * halfPi * sqrt(1 + D * abs(x1) - x1 * x1)
  ];
}

vanDerGrinten4Raw.invert = function(x, y) {
  var delta;
  if (!x || !y) return [x, y];
  y /= pi;
  var x1 = sign(x) * x / halfPi,
      D = (x1 * x1 - 1 + 4 * y * y) / abs(x1),
      D2 = D * D,
      B = 2 * y,
      i = 50;
  do {
    var B2 = B * B,
        C = (8 * B - B2 * (B2 + 2) - 5) / (2 * B2 * (B - 1)),
        C_ = (3 * B - B2 * B - 10) / (2 * B2 * B),
        C2 = C * C,
        BC = B * C,
        B_C = B + C,
        B_C2 = B_C * B_C,
        B_3C = B + 3 * C,
        F = B_C2 * (B2 + C2 * D2 - 1) + (1 - B2) * (B2 * (B_3C * B_3C + 4 * C2) + C2 * (12 * BC + 4 * C2)),
        F_ = -2 * B_C * (4 * BC * C2 + (1 - 4 * B2 + 3 * B2 * B2) * (1 + C_) + C2 * (-6 + 14 * B2 - D2 + (-8 + 8 * B2 - 2 * D2) * C_) + BC * (-8 + 12 * B2 + (-10 + 10 * B2 - D2) * C_)),
        sqrtF = sqrt(F),
        f = D * (B_C2 + C2 - 1) + 2 * sqrtF - x1 * (4 * B_C2 + D2),
        f_ = D * (2 * C * C_ + 2 * B_C * (1 + C_)) + F_ / sqrtF - 8 * B_C * (D * (-1 + C2 + B_C2) + 2 * sqrtF) * (1 + C_) / (D2 + 4 * B_C2);
    B -= delta = f / f_;
  } while (delta > epsilon && --i > 0);
  return [
    sign(x) * (sqrt(D * D + 4) + D) * pi / 4,
    halfPi * B
  ];
};

/* harmony default export */ function vanDerGrinten4() {
  return (0,src_projection/* default */.A)(vanDerGrinten4Raw)
      .scale(127.16);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/wagner.js



function wagnerFormula(cx, cy, m1, m2, n) {
  function forward(lambda, phi) {
    var s = m1 * sin(m2 * phi),
        c0 = sqrt(1 - s * s),
        c1 = sqrt(2 / (1 + c0 * cos(lambda *= n)));
    return [
      cx * c0 * c1 * sin(lambda),
      cy * s * c1
    ];
  }

  forward.invert = function(x, y) {
    var t1 = x / cx,
        t2 = y / cy,
        p = sqrt(t1 * t1 + t2 * t2),
        c = 2 * asin(p / 2);
    return [
      atan2(x * tan(c), cx * p) / n,
      p && asin(y * sin(c) / (cy * m1 * p)) / m2
    ];
  };

  return forward;
}

function wagnerRaw(poleline, parallels, inflation, ratio) {
  // 60 is always used as reference parallel
  var phi1 = pi / 3;

  // sanitizing the input values
  // poleline and parallels may approximate but never equal 0
  poleline = max(poleline, epsilon);
  parallels = max(parallels, epsilon);
  // poleline must be <= 90; parallels may approximate but never equal 180
  poleline = min(poleline, halfPi);
  parallels = min(parallels, pi - epsilon);
  // 0 <= inflation <= 99.999
  inflation = max(inflation, 0);
  inflation = min(inflation, 100 - epsilon);
  // ratio > 0.
  // sensible values, i.e. something that renders a map which still can be
  // recognized as world map, are e.g. 20 <= ratio <= 1000.
  ratio = max(ratio, epsilon);

  // convert values from boehm notation
  // areal inflation e.g. from 0 to 1 or 20 to 1.2:
  var vinflation = inflation/100 + 1;
  // axial ratio e.g. from 200 to 2:
  var vratio  = ratio / 100;
  // the other ones are a bit more complicated...
  var m2 = acos(vinflation * cos(phi1)) / phi1,
      m1 = sin(poleline) / sin(m2 * halfPi),
      n = parallels / pi,
      k = sqrt(vratio * sin(poleline / 2) / sin(parallels / 2)),
      cx = k / sqrt(n * m1 * m2),
      cy = 1 / (k * sqrt(n * m1 * m2));

  return wagnerFormula(cx, cy, m1, m2, n);
}

function wagner() {
  // default values generate wagner8
  var poleline = 65 * radians,
      parallels = 60 * radians,
      inflation = 20,
      ratio = 200,
      mutate = (0,src_projection/* projectionMutator */.U)(wagnerRaw),
      projection = mutate(poleline, parallels, inflation, ratio);

  projection.poleline = function(_) {
    return arguments.length ? mutate(poleline = +_ * radians, parallels, inflation, ratio) : poleline * degrees;
  };

  projection.parallels = function(_) {
    return arguments.length ? mutate(poleline, parallels = +_ * radians, inflation, ratio) : parallels * degrees;
  };
  projection.inflation = function(_) {
    return arguments.length ? mutate(poleline, parallels, inflation = +_, ratio) : inflation;
  };
  projection.ratio = function(_) {
    return arguments.length ? mutate(poleline, parallels, inflation, ratio = +_) : ratio;
  };

  return projection
    .scale(163.775);
}

function wagner7() {
  return wagner()
      .poleline(65)
      .parallels(60)
      .inflation(0)
      .ratio(200)
      .scale(172.633);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/wagner4.js




var A = 4 * pi + 3 * sqrt(3),
    B = 2 * sqrt(2 * pi * sqrt(3) / A);

var wagner4Raw = mollweideBromleyRaw(B * sqrt(3) / pi, B, A / 6);

/* harmony default export */ function wagner4() {
  return (0,src_projection/* default */.A)(wagner4Raw)
      .scale(176.84);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/wagner6.js



function wagner6Raw(lambda, phi) {
  return [lambda * sqrt(1 - 3 * phi * phi / (pi * pi)), phi];
}

wagner6Raw.invert = function(x, y) {
  return [x / sqrt(1 - 3 * y * y / (pi * pi)), y];
};

/* harmony default export */ function wagner6() {
  return (0,src_projection/* default */.A)(wagner6Raw)
      .scale(152.63);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/wiechel.js



function wiechelRaw(lambda, phi) {
  var cosPhi = cos(phi),
      sinPhi = cos(lambda) * cosPhi,
      sin1_Phi = 1 - sinPhi,
      cosLambda = cos(lambda = atan2(sin(lambda) * cosPhi, -sin(phi))),
      sinLambda = sin(lambda);
  cosPhi = sqrt(1 - sinPhi * sinPhi);
  return [
    sinLambda * cosPhi - cosLambda * sin1_Phi,
    -cosLambda * cosPhi - sinLambda * sin1_Phi
  ];
}

wiechelRaw.invert = function(x, y) {
  var w = (x * x + y * y) / -2,
      k = sqrt(-w * (2 + w)),
      b = y * w + x * k,
      a = x * w - y * k,
      D = sqrt(a * a + b * b);
  return [
    atan2(k * b, D * (1 + w)),
    D ? -asin(k * a / D) : 0
  ];
};

/* harmony default export */ function wiechel() {
  return (0,src_projection/* default */.A)(wiechelRaw)
      .rotate([0, -90, 45])
      .scale(124.75)
      .clipAngle(180 - 1e-3);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/winkel3.js




function winkel3Raw(lambda, phi) {
  var coordinates = aitoffRaw(lambda, phi);
  return [
    (coordinates[0] + lambda / halfPi) / 2,
    (coordinates[1] + phi) / 2
  ];
}

winkel3Raw.invert = function(x, y) {
  var lambda = x, phi = y, i = 25;
  do {
    var cosphi = cos(phi),
        sinphi = sin(phi),
        sin_2phi = sin(2 * phi),
        sin2phi = sinphi * sinphi,
        cos2phi = cosphi * cosphi,
        sinlambda = sin(lambda),
        coslambda_2 = cos(lambda / 2),
        sinlambda_2 = sin(lambda / 2),
        sin2lambda_2 = sinlambda_2 * sinlambda_2,
        C = 1 - cos2phi * coslambda_2 * coslambda_2,
        E = C ? acos(cosphi * coslambda_2) * sqrt(F = 1 / C) : F = 0,
        F,
        fx = 0.5 * (2 * E * cosphi * sinlambda_2 + lambda / halfPi) - x,
        fy = 0.5 * (E * sinphi + phi) - y,
        dxdlambda = 0.5 * F * (cos2phi * sin2lambda_2 + E * cosphi * coslambda_2 * sin2phi) + 0.5 / halfPi,
        dxdphi = F * (sinlambda * sin_2phi / 4 - E * sinphi * sinlambda_2),
        dydlambda = 0.125 * F * (sin_2phi * sinlambda_2 - E * sinphi * cos2phi * sinlambda),
        dydphi = 0.5 * F * (sin2phi * coslambda_2 + E * sin2lambda_2 * cosphi) + 0.5,
        denominator = dxdphi * dydlambda - dydphi * dxdlambda,
        dlambda = (fy * dxdphi - fx * dydphi) / denominator,
        dphi = (fx * dydlambda - fy * dxdlambda) / denominator;
    lambda -= dlambda, phi -= dphi;
  } while ((abs(dlambda) > epsilon || abs(dphi) > epsilon) && --i > 0);
  return [lambda, phi];
};

/* harmony default export */ function winkel3() {
  return (0,src_projection/* default */.A)(winkel3Raw)
      .scale(158.837);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo-projection/src/index.js






























































 // DEPRECATED moved to d3-geo













 // DEPRECATED misspelling






















/***/ }),

/***/ 49353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
// Adds floating point numbers with twice the normal precision.
// Reference: J. R. Shewchuk, Adaptive Precision Floating-Point Arithmetic and
// Fast Robust Geometric Predicates, Discrete & Computational Geometry 18(3)
// 305–363 (1997).
// Code adapted from GeographicLib by Charles F. F. Karney,
// http://geographiclib.sourceforge.net/

/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__() {
  return new Adder;
}

function Adder() {
  this.reset();
}

Adder.prototype = {
  constructor: Adder,
  reset: function() {
    this.s = // rounded value
    this.t = 0; // exact error
  },
  add: function(y) {
    add(temp, y, this.t);
    add(this, temp.s, this.s);
    if (this.s) this.t += temp.t;
    else this.s = temp.t;
  },
  valueOf: function() {
    return this.s;
  }
};

var temp = new Adder;

function add(adder, a, b) {
  var x = adder.s = a + b,
      bv = x - a,
      av = x - bv;
  adder.t = (a - av) + (b - bv);
}


/***/ }),

/***/ 43976:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Ay: function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; },
/* harmony export */   B0: function() { return /* binding */ areaRingSum; },
/* harmony export */   Y7: function() { return /* binding */ areaStream; }
/* harmony export */ });
/* harmony import */ var _adder_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49353);
/* harmony import */ var _math_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61323);
/* harmony import */ var _noop_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53341);
/* harmony import */ var _stream_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20465);





var areaRingSum = (0,_adder_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)();

var areaSum = (0,_adder_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(),
    lambda00,
    phi00,
    lambda0,
    cosPhi0,
    sinPhi0;

var areaStream = {
  point: _noop_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A,
  lineStart: _noop_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A,
  lineEnd: _noop_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A,
  polygonStart: function() {
    areaRingSum.reset();
    areaStream.lineStart = areaRingStart;
    areaStream.lineEnd = areaRingEnd;
  },
  polygonEnd: function() {
    var areaRing = +areaRingSum;
    areaSum.add(areaRing < 0 ? _math_js__WEBPACK_IMPORTED_MODULE_2__/* .tau */ .FA + areaRing : areaRing);
    this.lineStart = this.lineEnd = this.point = _noop_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A;
  },
  sphere: function() {
    areaSum.add(_math_js__WEBPACK_IMPORTED_MODULE_2__/* .tau */ .FA);
  }
};

function areaRingStart() {
  areaStream.point = areaPointFirst;
}

function areaRingEnd() {
  areaPoint(lambda00, phi00);
}

function areaPointFirst(lambda, phi) {
  areaStream.point = areaPoint;
  lambda00 = lambda, phi00 = phi;
  lambda *= _math_js__WEBPACK_IMPORTED_MODULE_2__/* .radians */ .F2, phi *= _math_js__WEBPACK_IMPORTED_MODULE_2__/* .radians */ .F2;
  lambda0 = lambda, cosPhi0 = (0,_math_js__WEBPACK_IMPORTED_MODULE_2__/* .cos */ .gn)(phi = phi / 2 + _math_js__WEBPACK_IMPORTED_MODULE_2__/* .quarterPi */ .gz), sinPhi0 = (0,_math_js__WEBPACK_IMPORTED_MODULE_2__/* .sin */ .F8)(phi);
}

function areaPoint(lambda, phi) {
  lambda *= _math_js__WEBPACK_IMPORTED_MODULE_2__/* .radians */ .F2, phi *= _math_js__WEBPACK_IMPORTED_MODULE_2__/* .radians */ .F2;
  phi = phi / 2 + _math_js__WEBPACK_IMPORTED_MODULE_2__/* .quarterPi */ .gz; // half the angular distance from south pole

  // Spherical excess E for a spherical triangle with vertices: south pole,
  // previous point, current point.  Uses a formula derived from Cagnoli’s
  // theorem.  See Todhunter, Spherical Trig. (1871), Sec. 103, Eq. (2).
  var dLambda = lambda - lambda0,
      sdLambda = dLambda >= 0 ? 1 : -1,
      adLambda = sdLambda * dLambda,
      cosPhi = (0,_math_js__WEBPACK_IMPORTED_MODULE_2__/* .cos */ .gn)(phi),
      sinPhi = (0,_math_js__WEBPACK_IMPORTED_MODULE_2__/* .sin */ .F8)(phi),
      k = sinPhi0 * sinPhi,
      u = cosPhi0 * cosPhi + k * (0,_math_js__WEBPACK_IMPORTED_MODULE_2__/* .cos */ .gn)(adLambda),
      v = k * sdLambda * (0,_math_js__WEBPACK_IMPORTED_MODULE_2__/* .sin */ .F8)(adLambda);
  areaRingSum.add((0,_math_js__WEBPACK_IMPORTED_MODULE_2__/* .atan2 */ .FP)(v, u));

  // Advance the previous points.
  lambda0 = lambda, cosPhi0 = cosPhi, sinPhi0 = sinPhi;
}

/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__(object) {
  areaSum.reset();
  (0,_stream_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)(object, areaStream);
  return areaSum * 2;
}


/***/ }),

/***/ 43212:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
/* harmony import */ var _adder_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49353);
/* harmony import */ var _area_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43976);
/* harmony import */ var _cartesian_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20375);
/* harmony import */ var _math_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61323);
/* harmony import */ var _stream_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20465);






var lambda0, phi0, lambda1, phi1, // bounds
    lambda2, // previous lambda-coordinate
    lambda00, phi00, // first point
    p0, // previous 3D point
    deltaSum = (0,_adder_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(),
    ranges,
    range;

var boundsStream = {
  point: boundsPoint,
  lineStart: boundsLineStart,
  lineEnd: boundsLineEnd,
  polygonStart: function() {
    boundsStream.point = boundsRingPoint;
    boundsStream.lineStart = boundsRingStart;
    boundsStream.lineEnd = boundsRingEnd;
    deltaSum.reset();
    _area_js__WEBPACK_IMPORTED_MODULE_1__/* .areaStream */ .Y7.polygonStart();
  },
  polygonEnd: function() {
    _area_js__WEBPACK_IMPORTED_MODULE_1__/* .areaStream */ .Y7.polygonEnd();
    boundsStream.point = boundsPoint;
    boundsStream.lineStart = boundsLineStart;
    boundsStream.lineEnd = boundsLineEnd;
    if (_area_js__WEBPACK_IMPORTED_MODULE_1__/* .areaRingSum */ .B0 < 0) lambda0 = -(lambda1 = 180), phi0 = -(phi1 = 90);
    else if (deltaSum > _math_js__WEBPACK_IMPORTED_MODULE_2__/* .epsilon */ .Ni) phi1 = 90;
    else if (deltaSum < -_math_js__WEBPACK_IMPORTED_MODULE_2__/* .epsilon */ .Ni) phi0 = -90;
    range[0] = lambda0, range[1] = lambda1;
  },
  sphere: function() {
    lambda0 = -(lambda1 = 180), phi0 = -(phi1 = 90);
  }
};

function boundsPoint(lambda, phi) {
  ranges.push(range = [lambda0 = lambda, lambda1 = lambda]);
  if (phi < phi0) phi0 = phi;
  if (phi > phi1) phi1 = phi;
}

function linePoint(lambda, phi) {
  var p = (0,_cartesian_js__WEBPACK_IMPORTED_MODULE_3__/* .cartesian */ .jf)([lambda * _math_js__WEBPACK_IMPORTED_MODULE_2__/* .radians */ .F2, phi * _math_js__WEBPACK_IMPORTED_MODULE_2__/* .radians */ .F2]);
  if (p0) {
    var normal = (0,_cartesian_js__WEBPACK_IMPORTED_MODULE_3__/* .cartesianCross */ .r8)(p0, p),
        equatorial = [normal[1], -normal[0], 0],
        inflection = (0,_cartesian_js__WEBPACK_IMPORTED_MODULE_3__/* .cartesianCross */ .r8)(equatorial, normal);
    (0,_cartesian_js__WEBPACK_IMPORTED_MODULE_3__/* .cartesianNormalizeInPlace */ .Cx)(inflection);
    inflection = (0,_cartesian_js__WEBPACK_IMPORTED_MODULE_3__/* .spherical */ .EV)(inflection);
    var delta = lambda - lambda2,
        sign = delta > 0 ? 1 : -1,
        lambdai = inflection[0] * _math_js__WEBPACK_IMPORTED_MODULE_2__/* .degrees */ .uj * sign,
        phii,
        antimeridian = (0,_math_js__WEBPACK_IMPORTED_MODULE_2__/* .abs */ .tn)(delta) > 180;
    if (antimeridian ^ (sign * lambda2 < lambdai && lambdai < sign * lambda)) {
      phii = inflection[1] * _math_js__WEBPACK_IMPORTED_MODULE_2__/* .degrees */ .uj;
      if (phii > phi1) phi1 = phii;
    } else if (lambdai = (lambdai + 360) % 360 - 180, antimeridian ^ (sign * lambda2 < lambdai && lambdai < sign * lambda)) {
      phii = -inflection[1] * _math_js__WEBPACK_IMPORTED_MODULE_2__/* .degrees */ .uj;
      if (phii < phi0) phi0 = phii;
    } else {
      if (phi < phi0) phi0 = phi;
      if (phi > phi1) phi1 = phi;
    }
    if (antimeridian) {
      if (lambda < lambda2) {
        if (angle(lambda0, lambda) > angle(lambda0, lambda1)) lambda1 = lambda;
      } else {
        if (angle(lambda, lambda1) > angle(lambda0, lambda1)) lambda0 = lambda;
      }
    } else {
      if (lambda1 >= lambda0) {
        if (lambda < lambda0) lambda0 = lambda;
        if (lambda > lambda1) lambda1 = lambda;
      } else {
        if (lambda > lambda2) {
          if (angle(lambda0, lambda) > angle(lambda0, lambda1)) lambda1 = lambda;
        } else {
          if (angle(lambda, lambda1) > angle(lambda0, lambda1)) lambda0 = lambda;
        }
      }
    }
  } else {
    ranges.push(range = [lambda0 = lambda, lambda1 = lambda]);
  }
  if (phi < phi0) phi0 = phi;
  if (phi > phi1) phi1 = phi;
  p0 = p, lambda2 = lambda;
}

function boundsLineStart() {
  boundsStream.point = linePoint;
}

function boundsLineEnd() {
  range[0] = lambda0, range[1] = lambda1;
  boundsStream.point = boundsPoint;
  p0 = null;
}

function boundsRingPoint(lambda, phi) {
  if (p0) {
    var delta = lambda - lambda2;
    deltaSum.add((0,_math_js__WEBPACK_IMPORTED_MODULE_2__/* .abs */ .tn)(delta) > 180 ? delta + (delta > 0 ? 360 : -360) : delta);
  } else {
    lambda00 = lambda, phi00 = phi;
  }
  _area_js__WEBPACK_IMPORTED_MODULE_1__/* .areaStream */ .Y7.point(lambda, phi);
  linePoint(lambda, phi);
}

function boundsRingStart() {
  _area_js__WEBPACK_IMPORTED_MODULE_1__/* .areaStream */ .Y7.lineStart();
}

function boundsRingEnd() {
  boundsRingPoint(lambda00, phi00);
  _area_js__WEBPACK_IMPORTED_MODULE_1__/* .areaStream */ .Y7.lineEnd();
  if ((0,_math_js__WEBPACK_IMPORTED_MODULE_2__/* .abs */ .tn)(deltaSum) > _math_js__WEBPACK_IMPORTED_MODULE_2__/* .epsilon */ .Ni) lambda0 = -(lambda1 = 180);
  range[0] = lambda0, range[1] = lambda1;
  p0 = null;
}

// Finds the left-right distance between two longitudes.
// This is almost the same as (lambda1 - lambda0 + 360°) % 360°, except that we want
// the distance between ±180° to be 360°.
function angle(lambda0, lambda1) {
  return (lambda1 -= lambda0) < 0 ? lambda1 + 360 : lambda1;
}

function rangeCompare(a, b) {
  return a[0] - b[0];
}

function rangeContains(range, x) {
  return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
}

/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__(feature) {
  var i, n, a, b, merged, deltaMax, delta;

  phi1 = lambda1 = -(lambda0 = phi0 = Infinity);
  ranges = [];
  (0,_stream_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(feature, boundsStream);

  // First, sort ranges by their minimum longitudes.
  if (n = ranges.length) {
    ranges.sort(rangeCompare);

    // Then, merge any ranges that overlap.
    for (i = 1, a = ranges[0], merged = [a]; i < n; ++i) {
      b = ranges[i];
      if (rangeContains(a, b[0]) || rangeContains(a, b[1])) {
        if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
        if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
      } else {
        merged.push(a = b);
      }
    }

    // Finally, find the largest gap between the merged ranges.
    // The final bounding box will be the inverse of this gap.
    for (deltaMax = -Infinity, n = merged.length - 1, i = 0, a = merged[n]; i <= n; a = b, ++i) {
      b = merged[i];
      if ((delta = angle(a[1], b[0])) > deltaMax) deltaMax = delta, lambda0 = b[0], lambda1 = a[1];
    }
  }

  ranges = range = null;

  return lambda0 === Infinity || phi0 === Infinity
      ? [[NaN, NaN], [NaN, NaN]]
      : [[lambda0, phi0], [lambda1, phi1]];
}


/***/ }),

/***/ 20375:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Cx: function() { return /* binding */ cartesianNormalizeInPlace; },
/* harmony export */   EV: function() { return /* binding */ spherical; },
/* harmony export */   W8: function() { return /* binding */ cartesianDot; },
/* harmony export */   ep: function() { return /* binding */ cartesianAddInPlace; },
/* harmony export */   jf: function() { return /* binding */ cartesian; },
/* harmony export */   ly: function() { return /* binding */ cartesianScale; },
/* harmony export */   r8: function() { return /* binding */ cartesianCross; }
/* harmony export */ });
/* harmony import */ var _math_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61323);


function spherical(cartesian) {
  return [(0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .atan2 */ .FP)(cartesian[1], cartesian[0]), (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .asin */ .qR)(cartesian[2])];
}

function cartesian(spherical) {
  var lambda = spherical[0], phi = spherical[1], cosPhi = (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .cos */ .gn)(phi);
  return [cosPhi * (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .cos */ .gn)(lambda), cosPhi * (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .sin */ .F8)(lambda), (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .sin */ .F8)(phi)];
}

function cartesianDot(a, b) {
  return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}

function cartesianCross(a, b) {
  return [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]];
}

// TODO return a
function cartesianAddInPlace(a, b) {
  a[0] += b[0], a[1] += b[1], a[2] += b[2];
}

function cartesianScale(vector, k) {
  return [vector[0] * k, vector[1] * k, vector[2] * k];
}

// TODO return d
function cartesianNormalizeInPlace(d) {
  var l = (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .sqrt */ .RZ)(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
  d[0] /= l, d[1] /= l, d[2] /= l;
}


/***/ }),

/***/ 30021:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
/* harmony import */ var _math_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61323);
/* harmony import */ var _noop_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53341);
/* harmony import */ var _stream_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20465);




var W0, W1,
    X0, Y0, Z0,
    X1, Y1, Z1,
    X2, Y2, Z2,
    lambda00, phi00, // first point
    x0, y0, z0; // previous point

var centroidStream = {
  sphere: _noop_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A,
  point: centroidPoint,
  lineStart: centroidLineStart,
  lineEnd: centroidLineEnd,
  polygonStart: function() {
    centroidStream.lineStart = centroidRingStart;
    centroidStream.lineEnd = centroidRingEnd;
  },
  polygonEnd: function() {
    centroidStream.lineStart = centroidLineStart;
    centroidStream.lineEnd = centroidLineEnd;
  }
};

// Arithmetic mean of Cartesian vectors.
function centroidPoint(lambda, phi) {
  lambda *= _math_js__WEBPACK_IMPORTED_MODULE_1__/* .radians */ .F2, phi *= _math_js__WEBPACK_IMPORTED_MODULE_1__/* .radians */ .F2;
  var cosPhi = (0,_math_js__WEBPACK_IMPORTED_MODULE_1__/* .cos */ .gn)(phi);
  centroidPointCartesian(cosPhi * (0,_math_js__WEBPACK_IMPORTED_MODULE_1__/* .cos */ .gn)(lambda), cosPhi * (0,_math_js__WEBPACK_IMPORTED_MODULE_1__/* .sin */ .F8)(lambda), (0,_math_js__WEBPACK_IMPORTED_MODULE_1__/* .sin */ .F8)(phi));
}

function centroidPointCartesian(x, y, z) {
  ++W0;
  X0 += (x - X0) / W0;
  Y0 += (y - Y0) / W0;
  Z0 += (z - Z0) / W0;
}

function centroidLineStart() {
  centroidStream.point = centroidLinePointFirst;
}

function centroidLinePointFirst(lambda, phi) {
  lambda *= _math_js__WEBPACK_IMPORTED_MODULE_1__/* .radians */ .F2, phi *= _math_js__WEBPACK_IMPORTED_MODULE_1__/* .radians */ .F2;
  var cosPhi = (0,_math_js__WEBPACK_IMPORTED_MODULE_1__/* .cos */ .gn)(phi);
  x0 = cosPhi * (0,_math_js__WEBPACK_IMPORTED_MODULE_1__/* .cos */ .gn)(lambda);
  y0 = cosPhi * (0,_math_js__WEBPACK_IMPORTED_MODULE_1__/* .sin */ .F8)(lambda);
  z0 = (0,_math_js__WEBPACK_IMPORTED_MODULE_1__/* .sin */ .F8)(phi);
  centroidStream.point = centroidLinePoint;
  centroidPointCartesian(x0, y0, z0);
}

function centroidLinePoint(lambda, phi) {
  lambda *= _math_js__WEBPACK_IMPORTED_MODULE_1__/* .radians */ .F2, phi *= _math_js__WEBPACK_IMPORTED_MODULE_1__/* .radians */ .F2;
  var cosPhi = (0,_math_js__WEBPACK_IMPORTED_MODULE_1__/* .cos */ .gn)(phi),
      x = cosPhi * (0,_math_js__WEBPACK_IMPORTED_MODULE_1__/* .cos */ .gn)(lambda),
      y = cosPhi * (0,_math_js__WEBPACK_IMPORTED_MODULE_1__/* .sin */ .F8)(lambda),
      z = (0,_math_js__WEBPACK_IMPORTED_MODULE_1__/* .sin */ .F8)(phi),
      w = (0,_math_js__WEBPACK_IMPORTED_MODULE_1__/* .atan2 */ .FP)((0,_math_js__WEBPACK_IMPORTED_MODULE_1__/* .sqrt */ .RZ)((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
  W1 += w;
  X1 += w * (x0 + (x0 = x));
  Y1 += w * (y0 + (y0 = y));
  Z1 += w * (z0 + (z0 = z));
  centroidPointCartesian(x0, y0, z0);
}

function centroidLineEnd() {
  centroidStream.point = centroidPoint;
}

// See J. E. Brock, The Inertia Tensor for a Spherical Triangle,
// J. Applied Mechanics 42, 239 (1975).
function centroidRingStart() {
  centroidStream.point = centroidRingPointFirst;
}

function centroidRingEnd() {
  centroidRingPoint(lambda00, phi00);
  centroidStream.point = centroidPoint;
}

function centroidRingPointFirst(lambda, phi) {
  lambda00 = lambda, phi00 = phi;
  lambda *= _math_js__WEBPACK_IMPORTED_MODULE_1__/* .radians */ .F2, phi *= _math_js__WEBPACK_IMPORTED_MODULE_1__/* .radians */ .F2;
  centroidStream.point = centroidRingPoint;
  var cosPhi = (0,_math_js__WEBPACK_IMPORTED_MODULE_1__/* .cos */ .gn)(phi);
  x0 = cosPhi * (0,_math_js__WEBPACK_IMPORTED_MODULE_1__/* .cos */ .gn)(lambda);
  y0 = cosPhi * (0,_math_js__WEBPACK_IMPORTED_MODULE_1__/* .sin */ .F8)(lambda);
  z0 = (0,_math_js__WEBPACK_IMPORTED_MODULE_1__/* .sin */ .F8)(phi);
  centroidPointCartesian(x0, y0, z0);
}

function centroidRingPoint(lambda, phi) {
  lambda *= _math_js__WEBPACK_IMPORTED_MODULE_1__/* .radians */ .F2, phi *= _math_js__WEBPACK_IMPORTED_MODULE_1__/* .radians */ .F2;
  var cosPhi = (0,_math_js__WEBPACK_IMPORTED_MODULE_1__/* .cos */ .gn)(phi),
      x = cosPhi * (0,_math_js__WEBPACK_IMPORTED_MODULE_1__/* .cos */ .gn)(lambda),
      y = cosPhi * (0,_math_js__WEBPACK_IMPORTED_MODULE_1__/* .sin */ .F8)(lambda),
      z = (0,_math_js__WEBPACK_IMPORTED_MODULE_1__/* .sin */ .F8)(phi),
      cx = y0 * z - z0 * y,
      cy = z0 * x - x0 * z,
      cz = x0 * y - y0 * x,
      m = (0,_math_js__WEBPACK_IMPORTED_MODULE_1__/* .sqrt */ .RZ)(cx * cx + cy * cy + cz * cz),
      w = (0,_math_js__WEBPACK_IMPORTED_MODULE_1__/* .asin */ .qR)(m), // line weight = angle
      v = m && -w / m; // area weight multiplier
  X2 += v * cx;
  Y2 += v * cy;
  Z2 += v * cz;
  W1 += w;
  X1 += w * (x0 + (x0 = x));
  Y1 += w * (y0 + (y0 = y));
  Z1 += w * (z0 + (z0 = z));
  centroidPointCartesian(x0, y0, z0);
}

/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__(object) {
  W0 = W1 =
  X0 = Y0 = Z0 =
  X1 = Y1 = Z1 =
  X2 = Y2 = Z2 = 0;
  (0,_stream_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(object, centroidStream);

  var x = X2,
      y = Y2,
      z = Z2,
      m = x * x + y * y + z * z;

  // If the area-weighted ccentroid is undefined, fall back to length-weighted ccentroid.
  if (m < _math_js__WEBPACK_IMPORTED_MODULE_1__/* .epsilon2 */ .$t) {
    x = X1, y = Y1, z = Z1;
    // If the feature has zero length, fall back to arithmetic mean of point vectors.
    if (W1 < _math_js__WEBPACK_IMPORTED_MODULE_1__/* .epsilon */ .Ni) x = X0, y = Y0, z = Z0;
    m = x * x + y * y + z * z;
    // If the feature still has an undefined ccentroid, then return.
    if (m < _math_js__WEBPACK_IMPORTED_MODULE_1__/* .epsilon2 */ .$t) return [NaN, NaN];
  }

  return [(0,_math_js__WEBPACK_IMPORTED_MODULE_1__/* .atan2 */ .FP)(y, x) * _math_js__WEBPACK_IMPORTED_MODULE_1__/* .degrees */ .uj, (0,_math_js__WEBPACK_IMPORTED_MODULE_1__/* .asin */ .qR)(z / (0,_math_js__WEBPACK_IMPORTED_MODULE_1__/* .sqrt */ .RZ)(m)) * _math_js__WEBPACK_IMPORTED_MODULE_1__/* .degrees */ .uj];
}


/***/ }),

/***/ 39127:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  J: function() { return /* binding */ circleStream; },
  A: function() { return /* binding */ circle; }
});

// EXTERNAL MODULE: ./node_modules/d3-geo/src/cartesian.js
var cartesian = __webpack_require__(20375);
;// CONCATENATED MODULE: ./node_modules/d3-geo/src/constant.js
/* harmony default export */ function constant(x) {
  return function() {
    return x;
  };
}

// EXTERNAL MODULE: ./node_modules/d3-geo/src/math.js
var math = __webpack_require__(61323);
// EXTERNAL MODULE: ./node_modules/d3-geo/src/rotation.js
var rotation = __webpack_require__(30915);
;// CONCATENATED MODULE: ./node_modules/d3-geo/src/circle.js





// Generates a circle centered at [0°, 0°], with a given radius and precision.
function circleStream(stream, radius, delta, direction, t0, t1) {
  if (!delta) return;
  var cosRadius = (0,math/* cos */.gn)(radius),
      sinRadius = (0,math/* sin */.F8)(radius),
      step = direction * delta;
  if (t0 == null) {
    t0 = radius + direction * math/* tau */.FA;
    t1 = radius - step / 2;
  } else {
    t0 = circleRadius(cosRadius, t0);
    t1 = circleRadius(cosRadius, t1);
    if (direction > 0 ? t0 < t1 : t0 > t1) t0 += direction * math/* tau */.FA;
  }
  for (var point, t = t0; direction > 0 ? t > t1 : t < t1; t -= step) {
    point = (0,cartesian/* spherical */.EV)([cosRadius, -sinRadius * (0,math/* cos */.gn)(t), -sinRadius * (0,math/* sin */.F8)(t)]);
    stream.point(point[0], point[1]);
  }
}

// Returns the signed angle of a cartesian point relative to [cosRadius, 0, 0].
function circleRadius(cosRadius, point) {
  point = (0,cartesian/* cartesian */.jf)(point), point[0] -= cosRadius;
  (0,cartesian/* cartesianNormalizeInPlace */.Cx)(point);
  var radius = (0,math/* acos */.HQ)(-point[1]);
  return ((-point[2] < 0 ? -radius : radius) + math/* tau */.FA - math/* epsilon */.Ni) % math/* tau */.FA;
}

/* harmony default export */ function circle() {
  var center = constant([0, 0]),
      radius = constant(90),
      precision = constant(6),
      ring,
      rotate,
      stream = {point: point};

  function point(x, y) {
    ring.push(x = rotate(x, y));
    x[0] *= math/* degrees */.uj, x[1] *= math/* degrees */.uj;
  }

  function circle() {
    var c = center.apply(this, arguments),
        r = radius.apply(this, arguments) * math/* radians */.F2,
        p = precision.apply(this, arguments) * math/* radians */.F2;
    ring = [];
    rotate = (0,rotation/* rotateRadians */.y)(-c[0] * math/* radians */.F2, -c[1] * math/* radians */.F2, 0).invert;
    circleStream(stream, r, p, 1);
    c = {type: "Polygon", coordinates: [ring]};
    ring = rotate = null;
    return c;
  }

  circle.center = function(_) {
    return arguments.length ? (center = typeof _ === "function" ? _ : constant([+_[0], +_[1]]), circle) : center;
  };

  circle.radius = function(_) {
    return arguments.length ? (radius = typeof _ === "function" ? _ : constant(+_), circle) : radius;
  };

  circle.precision = function(_) {
    return arguments.length ? (precision = typeof _ === "function" ? _ : constant(+_), circle) : precision;
  };

  return circle;
}


/***/ }),

/***/ 42413:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13720);
/* harmony import */ var _math_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61323);



/* harmony default export */ __webpack_exports__.A = ((0,_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(
  function() { return true; },
  clipAntimeridianLine,
  clipAntimeridianInterpolate,
  [-_math_js__WEBPACK_IMPORTED_MODULE_1__.pi, -_math_js__WEBPACK_IMPORTED_MODULE_1__/* .halfPi */ .TW]
));

// Takes a line and cuts into visible segments. Return values: 0 - there were
// intersections or the line was empty; 1 - no intersections; 2 - there were
// intersections, and the first and last segments should be rejoined.
function clipAntimeridianLine(stream) {
  var lambda0 = NaN,
      phi0 = NaN,
      sign0 = NaN,
      clean; // no intersections

  return {
    lineStart: function() {
      stream.lineStart();
      clean = 1;
    },
    point: function(lambda1, phi1) {
      var sign1 = lambda1 > 0 ? _math_js__WEBPACK_IMPORTED_MODULE_1__.pi : -_math_js__WEBPACK_IMPORTED_MODULE_1__.pi,
          delta = (0,_math_js__WEBPACK_IMPORTED_MODULE_1__/* .abs */ .tn)(lambda1 - lambda0);
      if ((0,_math_js__WEBPACK_IMPORTED_MODULE_1__/* .abs */ .tn)(delta - _math_js__WEBPACK_IMPORTED_MODULE_1__.pi) < _math_js__WEBPACK_IMPORTED_MODULE_1__/* .epsilon */ .Ni) { // line crosses a pole
        stream.point(lambda0, phi0 = (phi0 + phi1) / 2 > 0 ? _math_js__WEBPACK_IMPORTED_MODULE_1__/* .halfPi */ .TW : -_math_js__WEBPACK_IMPORTED_MODULE_1__/* .halfPi */ .TW);
        stream.point(sign0, phi0);
        stream.lineEnd();
        stream.lineStart();
        stream.point(sign1, phi0);
        stream.point(lambda1, phi0);
        clean = 0;
      } else if (sign0 !== sign1 && delta >= _math_js__WEBPACK_IMPORTED_MODULE_1__.pi) { // line crosses antimeridian
        if ((0,_math_js__WEBPACK_IMPORTED_MODULE_1__/* .abs */ .tn)(lambda0 - sign0) < _math_js__WEBPACK_IMPORTED_MODULE_1__/* .epsilon */ .Ni) lambda0 -= sign0 * _math_js__WEBPACK_IMPORTED_MODULE_1__/* .epsilon */ .Ni; // handle degeneracies
        if ((0,_math_js__WEBPACK_IMPORTED_MODULE_1__/* .abs */ .tn)(lambda1 - sign1) < _math_js__WEBPACK_IMPORTED_MODULE_1__/* .epsilon */ .Ni) lambda1 -= sign1 * _math_js__WEBPACK_IMPORTED_MODULE_1__/* .epsilon */ .Ni;
        phi0 = clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1);
        stream.point(sign0, phi0);
        stream.lineEnd();
        stream.lineStart();
        stream.point(sign1, phi0);
        clean = 0;
      }
      stream.point(lambda0 = lambda1, phi0 = phi1);
      sign0 = sign1;
    },
    lineEnd: function() {
      stream.lineEnd();
      lambda0 = phi0 = NaN;
    },
    clean: function() {
      return 2 - clean; // if intersections, rejoin first and last segments
    }
  };
}

function clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1) {
  var cosPhi0,
      cosPhi1,
      sinLambda0Lambda1 = (0,_math_js__WEBPACK_IMPORTED_MODULE_1__/* .sin */ .F8)(lambda0 - lambda1);
  return (0,_math_js__WEBPACK_IMPORTED_MODULE_1__/* .abs */ .tn)(sinLambda0Lambda1) > _math_js__WEBPACK_IMPORTED_MODULE_1__/* .epsilon */ .Ni
      ? (0,_math_js__WEBPACK_IMPORTED_MODULE_1__/* .atan */ .rY)(((0,_math_js__WEBPACK_IMPORTED_MODULE_1__/* .sin */ .F8)(phi0) * (cosPhi1 = (0,_math_js__WEBPACK_IMPORTED_MODULE_1__/* .cos */ .gn)(phi1)) * (0,_math_js__WEBPACK_IMPORTED_MODULE_1__/* .sin */ .F8)(lambda1)
          - (0,_math_js__WEBPACK_IMPORTED_MODULE_1__/* .sin */ .F8)(phi1) * (cosPhi0 = (0,_math_js__WEBPACK_IMPORTED_MODULE_1__/* .cos */ .gn)(phi0)) * (0,_math_js__WEBPACK_IMPORTED_MODULE_1__/* .sin */ .F8)(lambda0))
          / (cosPhi0 * cosPhi1 * sinLambda0Lambda1))
      : (phi0 + phi1) / 2;
}

function clipAntimeridianInterpolate(from, to, direction, stream) {
  var phi;
  if (from == null) {
    phi = direction * _math_js__WEBPACK_IMPORTED_MODULE_1__/* .halfPi */ .TW;
    stream.point(-_math_js__WEBPACK_IMPORTED_MODULE_1__.pi, phi);
    stream.point(0, phi);
    stream.point(_math_js__WEBPACK_IMPORTED_MODULE_1__.pi, phi);
    stream.point(_math_js__WEBPACK_IMPORTED_MODULE_1__.pi, 0);
    stream.point(_math_js__WEBPACK_IMPORTED_MODULE_1__.pi, -phi);
    stream.point(0, -phi);
    stream.point(-_math_js__WEBPACK_IMPORTED_MODULE_1__.pi, -phi);
    stream.point(-_math_js__WEBPACK_IMPORTED_MODULE_1__.pi, 0);
    stream.point(-_math_js__WEBPACK_IMPORTED_MODULE_1__.pi, phi);
  } else if ((0,_math_js__WEBPACK_IMPORTED_MODULE_1__/* .abs */ .tn)(from[0] - to[0]) > _math_js__WEBPACK_IMPORTED_MODULE_1__/* .epsilon */ .Ni) {
    var lambda = from[0] < to[0] ? _math_js__WEBPACK_IMPORTED_MODULE_1__.pi : -_math_js__WEBPACK_IMPORTED_MODULE_1__.pi;
    phi = direction * lambda / 2;
    stream.point(-lambda, phi);
    stream.point(0, phi);
    stream.point(lambda, phi);
  } else {
    stream.point(to[0], to[1]);
  }
}


/***/ }),

/***/ 39608:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
/* harmony import */ var _noop_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53341);


/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__() {
  var lines = [],
      line;
  return {
    point: function(x, y, m) {
      line.push([x, y, m]);
    },
    lineStart: function() {
      lines.push(line = []);
    },
    lineEnd: _noop_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A,
    rejoin: function() {
      if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
    },
    result: function() {
      var result = lines;
      lines = [];
      line = null;
      return result;
    }
  };
}


/***/ }),

/***/ 47402:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
/* harmony import */ var _cartesian_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20375);
/* harmony import */ var _circle_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39127);
/* harmony import */ var _math_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61323);
/* harmony import */ var _pointEqual_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28759);
/* harmony import */ var _index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13720);






/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__(radius) {
  var cr = (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .cos */ .gn)(radius),
      delta = 6 * _math_js__WEBPACK_IMPORTED_MODULE_0__/* .radians */ .F2,
      smallRadius = cr > 0,
      notHemisphere = (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .abs */ .tn)(cr) > _math_js__WEBPACK_IMPORTED_MODULE_0__/* .epsilon */ .Ni; // TODO optimise for this common case

  function interpolate(from, to, direction, stream) {
    (0,_circle_js__WEBPACK_IMPORTED_MODULE_1__/* .circleStream */ .J)(stream, radius, delta, direction, from, to);
  }

  function visible(lambda, phi) {
    return (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .cos */ .gn)(lambda) * (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .cos */ .gn)(phi) > cr;
  }

  // Takes a line and cuts into visible segments. Return values used for polygon
  // clipping: 0 - there were intersections or the line was empty; 1 - no
  // intersections 2 - there were intersections, and the first and last segments
  // should be rejoined.
  function clipLine(stream) {
    var point0, // previous point
        c0, // code for previous point
        v0, // visibility of previous point
        v00, // visibility of first point
        clean; // no intersections
    return {
      lineStart: function() {
        v00 = v0 = false;
        clean = 1;
      },
      point: function(lambda, phi) {
        var point1 = [lambda, phi],
            point2,
            v = visible(lambda, phi),
            c = smallRadius
              ? v ? 0 : code(lambda, phi)
              : v ? code(lambda + (lambda < 0 ? _math_js__WEBPACK_IMPORTED_MODULE_0__.pi : -_math_js__WEBPACK_IMPORTED_MODULE_0__.pi), phi) : 0;
        if (!point0 && (v00 = v0 = v)) stream.lineStart();
        if (v !== v0) {
          point2 = intersect(point0, point1);
          if (!point2 || (0,_pointEqual_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(point0, point2) || (0,_pointEqual_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(point1, point2))
            point1[2] = 1;
        }
        if (v !== v0) {
          clean = 0;
          if (v) {
            // outside going in
            stream.lineStart();
            point2 = intersect(point1, point0);
            stream.point(point2[0], point2[1]);
          } else {
            // inside going out
            point2 = intersect(point0, point1);
            stream.point(point2[0], point2[1], 2);
            stream.lineEnd();
          }
          point0 = point2;
        } else if (notHemisphere && point0 && smallRadius ^ v) {
          var t;
          // If the codes for two points are different, or are both zero,
          // and there this segment intersects with the small circle.
          if (!(c & c0) && (t = intersect(point1, point0, true))) {
            clean = 0;
            if (smallRadius) {
              stream.lineStart();
              stream.point(t[0][0], t[0][1]);
              stream.point(t[1][0], t[1][1]);
              stream.lineEnd();
            } else {
              stream.point(t[1][0], t[1][1]);
              stream.lineEnd();
              stream.lineStart();
              stream.point(t[0][0], t[0][1], 3);
            }
          }
        }
        if (v && (!point0 || !(0,_pointEqual_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(point0, point1))) {
          stream.point(point1[0], point1[1]);
        }
        point0 = point1, v0 = v, c0 = c;
      },
      lineEnd: function() {
        if (v0) stream.lineEnd();
        point0 = null;
      },
      // Rejoin first and last segments if there were intersections and the first
      // and last points were visible.
      clean: function() {
        return clean | ((v00 && v0) << 1);
      }
    };
  }

  // Intersects the great circle between a and b with the clip circle.
  function intersect(a, b, two) {
    var pa = (0,_cartesian_js__WEBPACK_IMPORTED_MODULE_3__/* .cartesian */ .jf)(a),
        pb = (0,_cartesian_js__WEBPACK_IMPORTED_MODULE_3__/* .cartesian */ .jf)(b);

    // We have two planes, n1.p = d1 and n2.p = d2.
    // Find intersection line p(t) = c1 n1 + c2 n2 + t (n1 ⨯ n2).
    var n1 = [1, 0, 0], // normal
        n2 = (0,_cartesian_js__WEBPACK_IMPORTED_MODULE_3__/* .cartesianCross */ .r8)(pa, pb),
        n2n2 = (0,_cartesian_js__WEBPACK_IMPORTED_MODULE_3__/* .cartesianDot */ .W8)(n2, n2),
        n1n2 = n2[0], // cartesianDot(n1, n2),
        determinant = n2n2 - n1n2 * n1n2;

    // Two polar points.
    if (!determinant) return !two && a;

    var c1 =  cr * n2n2 / determinant,
        c2 = -cr * n1n2 / determinant,
        n1xn2 = (0,_cartesian_js__WEBPACK_IMPORTED_MODULE_3__/* .cartesianCross */ .r8)(n1, n2),
        A = (0,_cartesian_js__WEBPACK_IMPORTED_MODULE_3__/* .cartesianScale */ .ly)(n1, c1),
        B = (0,_cartesian_js__WEBPACK_IMPORTED_MODULE_3__/* .cartesianScale */ .ly)(n2, c2);
    (0,_cartesian_js__WEBPACK_IMPORTED_MODULE_3__/* .cartesianAddInPlace */ .ep)(A, B);

    // Solve |p(t)|^2 = 1.
    var u = n1xn2,
        w = (0,_cartesian_js__WEBPACK_IMPORTED_MODULE_3__/* .cartesianDot */ .W8)(A, u),
        uu = (0,_cartesian_js__WEBPACK_IMPORTED_MODULE_3__/* .cartesianDot */ .W8)(u, u),
        t2 = w * w - uu * ((0,_cartesian_js__WEBPACK_IMPORTED_MODULE_3__/* .cartesianDot */ .W8)(A, A) - 1);

    if (t2 < 0) return;

    var t = (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .sqrt */ .RZ)(t2),
        q = (0,_cartesian_js__WEBPACK_IMPORTED_MODULE_3__/* .cartesianScale */ .ly)(u, (-w - t) / uu);
    (0,_cartesian_js__WEBPACK_IMPORTED_MODULE_3__/* .cartesianAddInPlace */ .ep)(q, A);
    q = (0,_cartesian_js__WEBPACK_IMPORTED_MODULE_3__/* .spherical */ .EV)(q);

    if (!two) return q;

    // Two intersection points.
    var lambda0 = a[0],
        lambda1 = b[0],
        phi0 = a[1],
        phi1 = b[1],
        z;

    if (lambda1 < lambda0) z = lambda0, lambda0 = lambda1, lambda1 = z;

    var delta = lambda1 - lambda0,
        polar = (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .abs */ .tn)(delta - _math_js__WEBPACK_IMPORTED_MODULE_0__.pi) < _math_js__WEBPACK_IMPORTED_MODULE_0__/* .epsilon */ .Ni,
        meridian = polar || delta < _math_js__WEBPACK_IMPORTED_MODULE_0__/* .epsilon */ .Ni;

    if (!polar && phi1 < phi0) z = phi0, phi0 = phi1, phi1 = z;

    // Check that the first point is between a and b.
    if (meridian
        ? polar
          ? phi0 + phi1 > 0 ^ q[1] < ((0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .abs */ .tn)(q[0] - lambda0) < _math_js__WEBPACK_IMPORTED_MODULE_0__/* .epsilon */ .Ni ? phi0 : phi1)
          : phi0 <= q[1] && q[1] <= phi1
        : delta > _math_js__WEBPACK_IMPORTED_MODULE_0__.pi ^ (lambda0 <= q[0] && q[0] <= lambda1)) {
      var q1 = (0,_cartesian_js__WEBPACK_IMPORTED_MODULE_3__/* .cartesianScale */ .ly)(u, (-w + t) / uu);
      (0,_cartesian_js__WEBPACK_IMPORTED_MODULE_3__/* .cartesianAddInPlace */ .ep)(q1, A);
      return [q, (0,_cartesian_js__WEBPACK_IMPORTED_MODULE_3__/* .spherical */ .EV)(q1)];
    }
  }

  // Generates a 4-bit vector representing the location of a point relative to
  // the small circle's bounding box.
  function code(lambda, phi) {
    var r = smallRadius ? radius : _math_js__WEBPACK_IMPORTED_MODULE_0__.pi - radius,
        code = 0;
    if (lambda < -r) code |= 1; // left
    else if (lambda > r) code |= 2; // right
    if (phi < -r) code |= 4; // below
    else if (phi > r) code |= 8; // above
    return code;
  }

  return (0,_index_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(visible, clipLine, interpolate, smallRadius ? [0, -radius] : [-_math_js__WEBPACK_IMPORTED_MODULE_0__.pi, radius - _math_js__WEBPACK_IMPORTED_MODULE_0__.pi]);
}


/***/ }),

/***/ 13720:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
/* harmony import */ var _buffer_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39608);
/* harmony import */ var _rejoin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19119);
/* harmony import */ var _math_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61323);
/* harmony import */ var _polygonContains_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2274);
/* harmony import */ var d3_array__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29725);






/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__(pointVisible, clipLine, interpolate, start) {
  return function(sink) {
    var line = clipLine(sink),
        ringBuffer = (0,_buffer_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(),
        ringSink = clipLine(ringBuffer),
        polygonStarted = false,
        polygon,
        segments,
        ring;

    var clip = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: function() {
        clip.point = pointRing;
        clip.lineStart = ringStart;
        clip.lineEnd = ringEnd;
        segments = [];
        polygon = [];
      },
      polygonEnd: function() {
        clip.point = point;
        clip.lineStart = lineStart;
        clip.lineEnd = lineEnd;
        segments = (0,d3_array__WEBPACK_IMPORTED_MODULE_0__/* .merge */ .Am)(segments);
        var startInside = (0,_polygonContains_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(polygon, start);
        if (segments.length) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          (0,_rejoin_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)(segments, compareIntersection, startInside, interpolate, sink);
        } else if (startInside) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          sink.lineStart();
          interpolate(null, null, 1, sink);
          sink.lineEnd();
        }
        if (polygonStarted) sink.polygonEnd(), polygonStarted = false;
        segments = polygon = null;
      },
      sphere: function() {
        sink.polygonStart();
        sink.lineStart();
        interpolate(null, null, 1, sink);
        sink.lineEnd();
        sink.polygonEnd();
      }
    };

    function point(lambda, phi) {
      if (pointVisible(lambda, phi)) sink.point(lambda, phi);
    }

    function pointLine(lambda, phi) {
      line.point(lambda, phi);
    }

    function lineStart() {
      clip.point = pointLine;
      line.lineStart();
    }

    function lineEnd() {
      clip.point = point;
      line.lineEnd();
    }

    function pointRing(lambda, phi) {
      ring.push([lambda, phi]);
      ringSink.point(lambda, phi);
    }

    function ringStart() {
      ringSink.lineStart();
      ring = [];
    }

    function ringEnd() {
      pointRing(ring[0][0], ring[0][1]);
      ringSink.lineEnd();

      var clean = ringSink.clean(),
          ringSegments = ringBuffer.result(),
          i, n = ringSegments.length, m,
          segment,
          point;

      ring.pop();
      polygon.push(ring);
      ring = null;

      if (!n) return;

      // No intersections.
      if (clean & 1) {
        segment = ringSegments[0];
        if ((m = segment.length - 1) > 0) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          sink.lineStart();
          for (i = 0; i < m; ++i) sink.point((point = segment[i])[0], point[1]);
          sink.lineEnd();
        }
        return;
      }

      // Rejoin connected segments.
      // TODO reuse ringBuffer.rejoin()?
      if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));

      segments.push(ringSegments.filter(validSegment));
    }

    return clip;
  };
}

function validSegment(segment) {
  return segment.length > 1;
}

// Intersections are sorted along the clip edge. For both antimeridian cutting
// and circle clipping, the same comparison is used.
function compareIntersection(a, b) {
  return ((a = a.x)[0] < 0 ? a[1] - _math_js__WEBPACK_IMPORTED_MODULE_4__/* .halfPi */ .TW - _math_js__WEBPACK_IMPORTED_MODULE_4__/* .epsilon */ .Ni : _math_js__WEBPACK_IMPORTED_MODULE_4__/* .halfPi */ .TW - a[1])
       - ((b = b.x)[0] < 0 ? b[1] - _math_js__WEBPACK_IMPORTED_MODULE_4__/* .halfPi */ .TW - _math_js__WEBPACK_IMPORTED_MODULE_4__/* .epsilon */ .Ni : _math_js__WEBPACK_IMPORTED_MODULE_4__/* .halfPi */ .TW - b[1]);
}


/***/ }),

/***/ 21503:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ clipRectangle; }
});

// EXTERNAL MODULE: ./node_modules/d3-geo/src/math.js
var math = __webpack_require__(61323);
// EXTERNAL MODULE: ./node_modules/d3-geo/src/clip/buffer.js
var buffer = __webpack_require__(39608);
;// CONCATENATED MODULE: ./node_modules/d3-geo/src/clip/line.js
/* harmony default export */ function line(a, b, x0, y0, x1, y1) {
  var ax = a[0],
      ay = a[1],
      bx = b[0],
      by = b[1],
      t0 = 0,
      t1 = 1,
      dx = bx - ax,
      dy = by - ay,
      r;

  r = x0 - ax;
  if (!dx && r > 0) return;
  r /= dx;
  if (dx < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dx > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = x1 - ax;
  if (!dx && r < 0) return;
  r /= dx;
  if (dx < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dx > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  r = y0 - ay;
  if (!dy && r > 0) return;
  r /= dy;
  if (dy < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dy > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = y1 - ay;
  if (!dy && r < 0) return;
  r /= dy;
  if (dy < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dy > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  if (t0 > 0) a[0] = ax + t0 * dx, a[1] = ay + t0 * dy;
  if (t1 < 1) b[0] = ax + t1 * dx, b[1] = ay + t1 * dy;
  return true;
}

// EXTERNAL MODULE: ./node_modules/d3-geo/src/clip/rejoin.js
var rejoin = __webpack_require__(19119);
// EXTERNAL MODULE: ./node_modules/d3-array/src/index.js + 14 modules
var src = __webpack_require__(29725);
;// CONCATENATED MODULE: ./node_modules/d3-geo/src/clip/rectangle.js






var clipMax = 1e9, clipMin = -clipMax;

// TODO Use d3-polygon’s polygonContains here for the ring check?
// TODO Eliminate duplicate buffering in clipBuffer and polygon.push?

function clipRectangle(x0, y0, x1, y1) {

  function visible(x, y) {
    return x0 <= x && x <= x1 && y0 <= y && y <= y1;
  }

  function interpolate(from, to, direction, stream) {
    var a = 0, a1 = 0;
    if (from == null
        || (a = corner(from, direction)) !== (a1 = corner(to, direction))
        || comparePoint(from, to) < 0 ^ direction > 0) {
      do stream.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
      while ((a = (a + direction + 4) % 4) !== a1);
    } else {
      stream.point(to[0], to[1]);
    }
  }

  function corner(p, direction) {
    return (0,math/* abs */.tn)(p[0] - x0) < math/* epsilon */.Ni ? direction > 0 ? 0 : 3
        : (0,math/* abs */.tn)(p[0] - x1) < math/* epsilon */.Ni ? direction > 0 ? 2 : 1
        : (0,math/* abs */.tn)(p[1] - y0) < math/* epsilon */.Ni ? direction > 0 ? 1 : 0
        : direction > 0 ? 3 : 2; // abs(p[1] - y1) < epsilon
  }

  function compareIntersection(a, b) {
    return comparePoint(a.x, b.x);
  }

  function comparePoint(a, b) {
    var ca = corner(a, 1),
        cb = corner(b, 1);
    return ca !== cb ? ca - cb
        : ca === 0 ? b[1] - a[1]
        : ca === 1 ? a[0] - b[0]
        : ca === 2 ? a[1] - b[1]
        : b[0] - a[0];
  }

  return function(stream) {
    var activeStream = stream,
        bufferStream = (0,buffer/* default */.A)(),
        segments,
        polygon,
        ring,
        x__, y__, v__, // first point
        x_, y_, v_, // previous point
        first,
        clean;

    var clipStream = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: polygonStart,
      polygonEnd: polygonEnd
    };

    function point(x, y) {
      if (visible(x, y)) activeStream.point(x, y);
    }

    function polygonInside() {
      var winding = 0;

      for (var i = 0, n = polygon.length; i < n; ++i) {
        for (var ring = polygon[i], j = 1, m = ring.length, point = ring[0], a0, a1, b0 = point[0], b1 = point[1]; j < m; ++j) {
          a0 = b0, a1 = b1, point = ring[j], b0 = point[0], b1 = point[1];
          if (a1 <= y1) { if (b1 > y1 && (b0 - a0) * (y1 - a1) > (b1 - a1) * (x0 - a0)) ++winding; }
          else { if (b1 <= y1 && (b0 - a0) * (y1 - a1) < (b1 - a1) * (x0 - a0)) --winding; }
        }
      }

      return winding;
    }

    // Buffer geometry within a polygon and then clip it en masse.
    function polygonStart() {
      activeStream = bufferStream, segments = [], polygon = [], clean = true;
    }

    function polygonEnd() {
      var startInside = polygonInside(),
          cleanInside = clean && startInside,
          visible = (segments = (0,src/* merge */.Am)(segments)).length;
      if (cleanInside || visible) {
        stream.polygonStart();
        if (cleanInside) {
          stream.lineStart();
          interpolate(null, null, 1, stream);
          stream.lineEnd();
        }
        if (visible) {
          (0,rejoin/* default */.A)(segments, compareIntersection, startInside, interpolate, stream);
        }
        stream.polygonEnd();
      }
      activeStream = stream, segments = polygon = ring = null;
    }

    function lineStart() {
      clipStream.point = linePoint;
      if (polygon) polygon.push(ring = []);
      first = true;
      v_ = false;
      x_ = y_ = NaN;
    }

    // TODO rather than special-case polygons, simply handle them separately.
    // Ideally, coincident intersection points should be jittered to avoid
    // clipping issues.
    function lineEnd() {
      if (segments) {
        linePoint(x__, y__);
        if (v__ && v_) bufferStream.rejoin();
        segments.push(bufferStream.result());
      }
      clipStream.point = point;
      if (v_) activeStream.lineEnd();
    }

    function linePoint(x, y) {
      var v = visible(x, y);
      if (polygon) ring.push([x, y]);
      if (first) {
        x__ = x, y__ = y, v__ = v;
        first = false;
        if (v) {
          activeStream.lineStart();
          activeStream.point(x, y);
        }
      } else {
        if (v && v_) activeStream.point(x, y);
        else {
          var a = [x_ = Math.max(clipMin, Math.min(clipMax, x_)), y_ = Math.max(clipMin, Math.min(clipMax, y_))],
              b = [x = Math.max(clipMin, Math.min(clipMax, x)), y = Math.max(clipMin, Math.min(clipMax, y))];
          if (line(a, b, x0, y0, x1, y1)) {
            if (!v_) {
              activeStream.lineStart();
              activeStream.point(a[0], a[1]);
            }
            activeStream.point(b[0], b[1]);
            if (!v) activeStream.lineEnd();
            clean = false;
          } else if (v) {
            activeStream.lineStart();
            activeStream.point(x, y);
            clean = false;
          }
        }
      }
      x_ = x, y_ = y, v_ = v;
    }

    return clipStream;
  };
}


/***/ }),

/***/ 19119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
/* harmony import */ var _pointEqual_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28759);
/* harmony import */ var _math_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61323);



function Intersection(point, points, other, entry) {
  this.x = point;
  this.z = points;
  this.o = other; // another intersection
  this.e = entry; // is an entry?
  this.v = false; // visited
  this.n = this.p = null; // next & previous
}

// A generalized polygon clipping algorithm: given a polygon that has been cut
// into its visible line segments, and rejoins the segments by interpolating
// along the clip edge.
/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__(segments, compareIntersection, startInside, interpolate, stream) {
  var subject = [],
      clip = [],
      i,
      n;

  segments.forEach(function(segment) {
    if ((n = segment.length - 1) <= 0) return;
    var n, p0 = segment[0], p1 = segment[n], x;

    if ((0,_pointEqual_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(p0, p1)) {
      if (!p0[2] && !p1[2]) {
        stream.lineStart();
        for (i = 0; i < n; ++i) stream.point((p0 = segment[i])[0], p0[1]);
        stream.lineEnd();
        return;
      }
      // handle degenerate cases by moving the point
      p1[0] += 2 * _math_js__WEBPACK_IMPORTED_MODULE_1__/* .epsilon */ .Ni;
    }

    subject.push(x = new Intersection(p0, segment, null, true));
    clip.push(x.o = new Intersection(p0, null, x, false));
    subject.push(x = new Intersection(p1, segment, null, false));
    clip.push(x.o = new Intersection(p1, null, x, true));
  });

  if (!subject.length) return;

  clip.sort(compareIntersection);
  link(subject);
  link(clip);

  for (i = 0, n = clip.length; i < n; ++i) {
    clip[i].e = startInside = !startInside;
  }

  var start = subject[0],
      points,
      point;

  while (1) {
    // Find first unvisited intersection.
    var current = start,
        isSubject = true;
    while (current.v) if ((current = current.n) === start) return;
    points = current.z;
    stream.lineStart();
    do {
      current.v = current.o.v = true;
      if (current.e) {
        if (isSubject) {
          for (i = 0, n = points.length; i < n; ++i) stream.point((point = points[i])[0], point[1]);
        } else {
          interpolate(current.x, current.n.x, 1, stream);
        }
        current = current.n;
      } else {
        if (isSubject) {
          points = current.p.z;
          for (i = points.length - 1; i >= 0; --i) stream.point((point = points[i])[0], point[1]);
        } else {
          interpolate(current.x, current.p.x, -1, stream);
        }
        current = current.p;
      }
      current = current.o;
      points = current.z;
      isSubject = !isSubject;
    } while (!current.v);
    stream.lineEnd();
  }
}

function link(array) {
  if (!(n = array.length)) return;
  var n,
      i = 0,
      a = array[0],
      b;
  while (++i < n) {
    a.n = b = array[i];
    b.p = a;
    a = b;
  }
  a.n = b = array[0];
  b.p = a;
}


/***/ }),

/***/ 19057:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__(a, b) {

  function compose(x, y) {
    return x = a(x, y), b(x[0], x[1]);
  }

  if (a.invert && b.invert) compose.invert = function(x, y) {
    return x = b.invert(x, y), x && a.invert(x[0], x[1]);
  };

  return compose;
}


/***/ }),

/***/ 26827:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__(x) {
  return x;
}


/***/ }),

/***/ 70884:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  geoAlbers: function() { return /* reexport */ albers; },
  geoAlbersUsa: function() { return /* reexport */ albersUsa; },
  geoArea: function() { return /* reexport */ src_area/* default */.Ay; },
  geoAzimuthalEqualArea: function() { return /* reexport */ azimuthalEqualArea/* default */.A; },
  geoAzimuthalEqualAreaRaw: function() { return /* reexport */ azimuthalEqualArea/* azimuthalEqualAreaRaw */.n; },
  geoAzimuthalEquidistant: function() { return /* reexport */ azimuthalEquidistant/* default */.A; },
  geoAzimuthalEquidistantRaw: function() { return /* reexport */ azimuthalEquidistant/* azimuthalEquidistantRaw */.j; },
  geoBounds: function() { return /* reexport */ bounds/* default */.A; },
  geoCentroid: function() { return /* reexport */ centroid/* default */.A; },
  geoCircle: function() { return /* reexport */ circle/* default */.A; },
  geoClipAntimeridian: function() { return /* reexport */ antimeridian/* default */.A; },
  geoClipCircle: function() { return /* reexport */ clip_circle/* default */.A; },
  geoClipExtent: function() { return /* reexport */ extent; },
  geoClipRectangle: function() { return /* reexport */ rectangle/* default */.A; },
  geoConicConformal: function() { return /* reexport */ conicConformal; },
  geoConicConformalRaw: function() { return /* reexport */ conicConformalRaw; },
  geoConicEqualArea: function() { return /* reexport */ conicEqualArea; },
  geoConicEqualAreaRaw: function() { return /* reexport */ conicEqualAreaRaw; },
  geoConicEquidistant: function() { return /* reexport */ conicEquidistant; },
  geoConicEquidistantRaw: function() { return /* reexport */ conicEquidistantRaw; },
  geoContains: function() { return /* reexport */ contains; },
  geoDistance: function() { return /* reexport */ distance; },
  geoEqualEarth: function() { return /* reexport */ equalEarth; },
  geoEqualEarthRaw: function() { return /* reexport */ equalEarthRaw; },
  geoEquirectangular: function() { return /* reexport */ equirectangular/* default */.A; },
  geoEquirectangularRaw: function() { return /* reexport */ equirectangular/* equirectangularRaw */.f; },
  geoGnomonic: function() { return /* reexport */ gnomonic/* default */.A; },
  geoGnomonicRaw: function() { return /* reexport */ gnomonic/* gnomonicRaw */.T; },
  geoGraticule: function() { return /* reexport */ graticule; },
  geoGraticule10: function() { return /* reexport */ graticule10; },
  geoIdentity: function() { return /* reexport */ projection_identity; },
  geoInterpolate: function() { return /* reexport */ interpolate/* default */.A; },
  geoLength: function() { return /* reexport */ src_length; },
  geoMercator: function() { return /* reexport */ mercator; },
  geoMercatorRaw: function() { return /* reexport */ mercatorRaw; },
  geoNaturalEarth1: function() { return /* reexport */ naturalEarth1/* default */.A; },
  geoNaturalEarth1Raw: function() { return /* reexport */ naturalEarth1/* naturalEarth1Raw */.P; },
  geoOrthographic: function() { return /* reexport */ orthographic/* default */.A; },
  geoOrthographicRaw: function() { return /* reexport */ orthographic/* orthographicRaw */.x; },
  geoPath: function() { return /* reexport */ path; },
  geoProjection: function() { return /* reexport */ projection/* default */.A; },
  geoProjectionMutator: function() { return /* reexport */ projection/* projectionMutator */.U; },
  geoRotation: function() { return /* reexport */ rotation/* default */.A; },
  geoStereographic: function() { return /* reexport */ stereographic; },
  geoStereographicRaw: function() { return /* reexport */ stereographicRaw; },
  geoStream: function() { return /* reexport */ stream/* default */.A; },
  geoTransform: function() { return /* reexport */ src_transform/* default */.A; },
  geoTransverseMercator: function() { return /* reexport */ transverseMercator; },
  geoTransverseMercatorRaw: function() { return /* reexport */ transverseMercatorRaw; }
});

// EXTERNAL MODULE: ./node_modules/d3-geo/src/area.js
var src_area = __webpack_require__(43976);
// EXTERNAL MODULE: ./node_modules/d3-geo/src/bounds.js
var bounds = __webpack_require__(43212);
// EXTERNAL MODULE: ./node_modules/d3-geo/src/centroid.js
var centroid = __webpack_require__(30021);
// EXTERNAL MODULE: ./node_modules/d3-geo/src/circle.js + 1 modules
var circle = __webpack_require__(39127);
// EXTERNAL MODULE: ./node_modules/d3-geo/src/clip/antimeridian.js
var antimeridian = __webpack_require__(42413);
// EXTERNAL MODULE: ./node_modules/d3-geo/src/clip/circle.js
var clip_circle = __webpack_require__(47402);
// EXTERNAL MODULE: ./node_modules/d3-geo/src/clip/rectangle.js + 1 modules
var rectangle = __webpack_require__(21503);
;// CONCATENATED MODULE: ./node_modules/d3-geo/src/clip/extent.js


/* harmony default export */ function extent() {
  var x0 = 0,
      y0 = 0,
      x1 = 960,
      y1 = 500,
      cache,
      cacheStream,
      clip;

  return clip = {
    stream: function(stream) {
      return cache && cacheStream === stream ? cache : cache = (0,rectangle/* default */.A)(x0, y0, x1, y1)(cacheStream = stream);
    },
    extent: function(_) {
      return arguments.length ? (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1], cache = cacheStream = null, clip) : [[x0, y0], [x1, y1]];
    }
  };
}

// EXTERNAL MODULE: ./node_modules/d3-geo/src/polygonContains.js
var polygonContains = __webpack_require__(2274);
// EXTERNAL MODULE: ./node_modules/d3-geo/src/adder.js
var adder = __webpack_require__(49353);
// EXTERNAL MODULE: ./node_modules/d3-geo/src/math.js
var math = __webpack_require__(61323);
// EXTERNAL MODULE: ./node_modules/d3-geo/src/noop.js
var noop = __webpack_require__(53341);
// EXTERNAL MODULE: ./node_modules/d3-geo/src/stream.js
var stream = __webpack_require__(20465);
;// CONCATENATED MODULE: ./node_modules/d3-geo/src/length.js





var lengthSum = (0,adder/* default */.A)(),
    lambda0,
    sinPhi0,
    cosPhi0;

var lengthStream = {
  sphere: noop/* default */.A,
  point: noop/* default */.A,
  lineStart: lengthLineStart,
  lineEnd: noop/* default */.A,
  polygonStart: noop/* default */.A,
  polygonEnd: noop/* default */.A
};

function lengthLineStart() {
  lengthStream.point = lengthPointFirst;
  lengthStream.lineEnd = lengthLineEnd;
}

function lengthLineEnd() {
  lengthStream.point = lengthStream.lineEnd = noop/* default */.A;
}

function lengthPointFirst(lambda, phi) {
  lambda *= math/* radians */.F2, phi *= math/* radians */.F2;
  lambda0 = lambda, sinPhi0 = (0,math/* sin */.F8)(phi), cosPhi0 = (0,math/* cos */.gn)(phi);
  lengthStream.point = lengthPoint;
}

function lengthPoint(lambda, phi) {
  lambda *= math/* radians */.F2, phi *= math/* radians */.F2;
  var sinPhi = (0,math/* sin */.F8)(phi),
      cosPhi = (0,math/* cos */.gn)(phi),
      delta = (0,math/* abs */.tn)(lambda - lambda0),
      cosDelta = (0,math/* cos */.gn)(delta),
      sinDelta = (0,math/* sin */.F8)(delta),
      x = cosPhi * sinDelta,
      y = cosPhi0 * sinPhi - sinPhi0 * cosPhi * cosDelta,
      z = sinPhi0 * sinPhi + cosPhi0 * cosPhi * cosDelta;
  lengthSum.add((0,math/* atan2 */.FP)((0,math/* sqrt */.RZ)(x * x + y * y), z));
  lambda0 = lambda, sinPhi0 = sinPhi, cosPhi0 = cosPhi;
}

/* harmony default export */ function src_length(object) {
  lengthSum.reset();
  (0,stream/* default */.A)(object, lengthStream);
  return +lengthSum;
}

;// CONCATENATED MODULE: ./node_modules/d3-geo/src/distance.js


var coordinates = [null, null],
    object = {type: "LineString", coordinates: coordinates};

/* harmony default export */ function distance(a, b) {
  coordinates[0] = a;
  coordinates[1] = b;
  return src_length(object);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo/src/contains.js




var containsObjectType = {
  Feature: function(object, point) {
    return containsGeometry(object.geometry, point);
  },
  FeatureCollection: function(object, point) {
    var features = object.features, i = -1, n = features.length;
    while (++i < n) if (containsGeometry(features[i].geometry, point)) return true;
    return false;
  }
};

var containsGeometryType = {
  Sphere: function() {
    return true;
  },
  Point: function(object, point) {
    return containsPoint(object.coordinates, point);
  },
  MultiPoint: function(object, point) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) if (containsPoint(coordinates[i], point)) return true;
    return false;
  },
  LineString: function(object, point) {
    return containsLine(object.coordinates, point);
  },
  MultiLineString: function(object, point) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) if (containsLine(coordinates[i], point)) return true;
    return false;
  },
  Polygon: function(object, point) {
    return containsPolygon(object.coordinates, point);
  },
  MultiPolygon: function(object, point) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) if (containsPolygon(coordinates[i], point)) return true;
    return false;
  },
  GeometryCollection: function(object, point) {
    var geometries = object.geometries, i = -1, n = geometries.length;
    while (++i < n) if (containsGeometry(geometries[i], point)) return true;
    return false;
  }
};

function containsGeometry(geometry, point) {
  return geometry && containsGeometryType.hasOwnProperty(geometry.type)
      ? containsGeometryType[geometry.type](geometry, point)
      : false;
}

function containsPoint(coordinates, point) {
  return distance(coordinates, point) === 0;
}

function containsLine(coordinates, point) {
  var ao, bo, ab;
  for (var i = 0, n = coordinates.length; i < n; i++) {
    bo = distance(coordinates[i], point);
    if (bo === 0) return true;
    if (i > 0) {
      ab = distance(coordinates[i], coordinates[i - 1]);
      if (
        ab > 0 &&
        ao <= ab &&
        bo <= ab &&
        (ao + bo - ab) * (1 - Math.pow((ao - bo) / ab, 2)) < math/* epsilon2 */.$t * ab
      )
        return true;
    }
    ao = bo;
  }
  return false;
}

function containsPolygon(coordinates, point) {
  return !!(0,polygonContains/* default */.A)(coordinates.map(ringRadians), pointRadians(point));
}

function ringRadians(ring) {
  return ring = ring.map(pointRadians), ring.pop(), ring;
}

function pointRadians(point) {
  return [point[0] * math/* radians */.F2, point[1] * math/* radians */.F2];
}

/* harmony default export */ function contains(object, point) {
  return (object && containsObjectType.hasOwnProperty(object.type)
      ? containsObjectType[object.type]
      : containsGeometry)(object, point);
}

// EXTERNAL MODULE: ./node_modules/d3-array/src/index.js + 14 modules
var src = __webpack_require__(29725);
;// CONCATENATED MODULE: ./node_modules/d3-geo/src/graticule.js



function graticuleX(y0, y1, dy) {
  var y = (0,src/* range */.y1)(y0, y1 - math/* epsilon */.Ni, dy).concat(y1);
  return function(x) { return y.map(function(y) { return [x, y]; }); };
}

function graticuleY(x0, x1, dx) {
  var x = (0,src/* range */.y1)(x0, x1 - math/* epsilon */.Ni, dx).concat(x1);
  return function(y) { return x.map(function(x) { return [x, y]; }); };
}

function graticule() {
  var x1, x0, X1, X0,
      y1, y0, Y1, Y0,
      dx = 10, dy = dx, DX = 90, DY = 360,
      x, y, X, Y,
      precision = 2.5;

  function graticule() {
    return {type: "MultiLineString", coordinates: lines()};
  }

  function lines() {
    return (0,src/* range */.y1)((0,math/* ceil */.mk)(X0 / DX) * DX, X1, DX).map(X)
        .concat((0,src/* range */.y1)((0,math/* ceil */.mk)(Y0 / DY) * DY, Y1, DY).map(Y))
        .concat((0,src/* range */.y1)((0,math/* ceil */.mk)(x0 / dx) * dx, x1, dx).filter(function(x) { return (0,math/* abs */.tn)(x % DX) > math/* epsilon */.Ni; }).map(x))
        .concat((0,src/* range */.y1)((0,math/* ceil */.mk)(y0 / dy) * dy, y1, dy).filter(function(y) { return (0,math/* abs */.tn)(y % DY) > math/* epsilon */.Ni; }).map(y));
  }

  graticule.lines = function() {
    return lines().map(function(coordinates) { return {type: "LineString", coordinates: coordinates}; });
  };

  graticule.outline = function() {
    return {
      type: "Polygon",
      coordinates: [
        X(X0).concat(
        Y(Y1).slice(1),
        X(X1).reverse().slice(1),
        Y(Y0).reverse().slice(1))
      ]
    };
  };

  graticule.extent = function(_) {
    if (!arguments.length) return graticule.extentMinor();
    return graticule.extentMajor(_).extentMinor(_);
  };

  graticule.extentMajor = function(_) {
    if (!arguments.length) return [[X0, Y0], [X1, Y1]];
    X0 = +_[0][0], X1 = +_[1][0];
    Y0 = +_[0][1], Y1 = +_[1][1];
    if (X0 > X1) _ = X0, X0 = X1, X1 = _;
    if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
    return graticule.precision(precision);
  };

  graticule.extentMinor = function(_) {
    if (!arguments.length) return [[x0, y0], [x1, y1]];
    x0 = +_[0][0], x1 = +_[1][0];
    y0 = +_[0][1], y1 = +_[1][1];
    if (x0 > x1) _ = x0, x0 = x1, x1 = _;
    if (y0 > y1) _ = y0, y0 = y1, y1 = _;
    return graticule.precision(precision);
  };

  graticule.step = function(_) {
    if (!arguments.length) return graticule.stepMinor();
    return graticule.stepMajor(_).stepMinor(_);
  };

  graticule.stepMajor = function(_) {
    if (!arguments.length) return [DX, DY];
    DX = +_[0], DY = +_[1];
    return graticule;
  };

  graticule.stepMinor = function(_) {
    if (!arguments.length) return [dx, dy];
    dx = +_[0], dy = +_[1];
    return graticule;
  };

  graticule.precision = function(_) {
    if (!arguments.length) return precision;
    precision = +_;
    x = graticuleX(y0, y1, 90);
    y = graticuleY(x0, x1, precision);
    X = graticuleX(Y0, Y1, 90);
    Y = graticuleY(X0, X1, precision);
    return graticule;
  };

  return graticule
      .extentMajor([[-180, -90 + math/* epsilon */.Ni], [180, 90 - math/* epsilon */.Ni]])
      .extentMinor([[-180, -80 - math/* epsilon */.Ni], [180, 80 + math/* epsilon */.Ni]]);
}

function graticule10() {
  return graticule()();
}

// EXTERNAL MODULE: ./node_modules/d3-geo/src/interpolate.js
var interpolate = __webpack_require__(81758);
// EXTERNAL MODULE: ./node_modules/d3-geo/src/identity.js
var identity = __webpack_require__(26827);
;// CONCATENATED MODULE: ./node_modules/d3-geo/src/path/area.js




var areaSum = (0,adder/* default */.A)(),
    areaRingSum = (0,adder/* default */.A)(),
    x00,
    y00,
    x0,
    y0;

var areaStream = {
  point: noop/* default */.A,
  lineStart: noop/* default */.A,
  lineEnd: noop/* default */.A,
  polygonStart: function() {
    areaStream.lineStart = areaRingStart;
    areaStream.lineEnd = areaRingEnd;
  },
  polygonEnd: function() {
    areaStream.lineStart = areaStream.lineEnd = areaStream.point = noop/* default */.A;
    areaSum.add((0,math/* abs */.tn)(areaRingSum));
    areaRingSum.reset();
  },
  result: function() {
    var area = areaSum / 2;
    areaSum.reset();
    return area;
  }
};

function areaRingStart() {
  areaStream.point = areaPointFirst;
}

function areaPointFirst(x, y) {
  areaStream.point = areaPoint;
  x00 = x0 = x, y00 = y0 = y;
}

function areaPoint(x, y) {
  areaRingSum.add(y0 * x - x0 * y);
  x0 = x, y0 = y;
}

function areaRingEnd() {
  areaPoint(x00, y00);
}

/* harmony default export */ var path_area = (areaStream);

// EXTERNAL MODULE: ./node_modules/d3-geo/src/path/bounds.js
var path_bounds = __webpack_require__(33028);
;// CONCATENATED MODULE: ./node_modules/d3-geo/src/path/centroid.js


// TODO Enforce positive area for exterior, negative area for interior?

var X0 = 0,
    Y0 = 0,
    Z0 = 0,
    X1 = 0,
    Y1 = 0,
    Z1 = 0,
    X2 = 0,
    Y2 = 0,
    Z2 = 0,
    centroid_x00,
    centroid_y00,
    centroid_x0,
    centroid_y0;

var centroidStream = {
  point: centroidPoint,
  lineStart: centroidLineStart,
  lineEnd: centroidLineEnd,
  polygonStart: function() {
    centroidStream.lineStart = centroidRingStart;
    centroidStream.lineEnd = centroidRingEnd;
  },
  polygonEnd: function() {
    centroidStream.point = centroidPoint;
    centroidStream.lineStart = centroidLineStart;
    centroidStream.lineEnd = centroidLineEnd;
  },
  result: function() {
    var centroid = Z2 ? [X2 / Z2, Y2 / Z2]
        : Z1 ? [X1 / Z1, Y1 / Z1]
        : Z0 ? [X0 / Z0, Y0 / Z0]
        : [NaN, NaN];
    X0 = Y0 = Z0 =
    X1 = Y1 = Z1 =
    X2 = Y2 = Z2 = 0;
    return centroid;
  }
};

function centroidPoint(x, y) {
  X0 += x;
  Y0 += y;
  ++Z0;
}

function centroidLineStart() {
  centroidStream.point = centroidPointFirstLine;
}

function centroidPointFirstLine(x, y) {
  centroidStream.point = centroidPointLine;
  centroidPoint(centroid_x0 = x, centroid_y0 = y);
}

function centroidPointLine(x, y) {
  var dx = x - centroid_x0, dy = y - centroid_y0, z = (0,math/* sqrt */.RZ)(dx * dx + dy * dy);
  X1 += z * (centroid_x0 + x) / 2;
  Y1 += z * (centroid_y0 + y) / 2;
  Z1 += z;
  centroidPoint(centroid_x0 = x, centroid_y0 = y);
}

function centroidLineEnd() {
  centroidStream.point = centroidPoint;
}

function centroidRingStart() {
  centroidStream.point = centroidPointFirstRing;
}

function centroidRingEnd() {
  centroidPointRing(centroid_x00, centroid_y00);
}

function centroidPointFirstRing(x, y) {
  centroidStream.point = centroidPointRing;
  centroidPoint(centroid_x00 = centroid_x0 = x, centroid_y00 = centroid_y0 = y);
}

function centroidPointRing(x, y) {
  var dx = x - centroid_x0,
      dy = y - centroid_y0,
      z = (0,math/* sqrt */.RZ)(dx * dx + dy * dy);

  X1 += z * (centroid_x0 + x) / 2;
  Y1 += z * (centroid_y0 + y) / 2;
  Z1 += z;

  z = centroid_y0 * x - centroid_x0 * y;
  X2 += z * (centroid_x0 + x);
  Y2 += z * (centroid_y0 + y);
  Z2 += z * 3;
  centroidPoint(centroid_x0 = x, centroid_y0 = y);
}

/* harmony default export */ var path_centroid = (centroidStream);

;// CONCATENATED MODULE: ./node_modules/d3-geo/src/path/context.js



function PathContext(context) {
  this._context = context;
}

PathContext.prototype = {
  _radius: 4.5,
  pointRadius: function(_) {
    return this._radius = _, this;
  },
  polygonStart: function() {
    this._line = 0;
  },
  polygonEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line === 0) this._context.closePath();
    this._point = NaN;
  },
  point: function(x, y) {
    switch (this._point) {
      case 0: {
        this._context.moveTo(x, y);
        this._point = 1;
        break;
      }
      case 1: {
        this._context.lineTo(x, y);
        break;
      }
      default: {
        this._context.moveTo(x + this._radius, y);
        this._context.arc(x, y, this._radius, 0, math/* tau */.FA);
        break;
      }
    }
  },
  result: noop/* default */.A
};

;// CONCATENATED MODULE: ./node_modules/d3-geo/src/path/measure.js




var measure_lengthSum = (0,adder/* default */.A)(),
    lengthRing,
    measure_x00,
    measure_y00,
    measure_x0,
    measure_y0;

var measure_lengthStream = {
  point: noop/* default */.A,
  lineStart: function() {
    measure_lengthStream.point = measure_lengthPointFirst;
  },
  lineEnd: function() {
    if (lengthRing) measure_lengthPoint(measure_x00, measure_y00);
    measure_lengthStream.point = noop/* default */.A;
  },
  polygonStart: function() {
    lengthRing = true;
  },
  polygonEnd: function() {
    lengthRing = null;
  },
  result: function() {
    var length = +measure_lengthSum;
    measure_lengthSum.reset();
    return length;
  }
};

function measure_lengthPointFirst(x, y) {
  measure_lengthStream.point = measure_lengthPoint;
  measure_x00 = measure_x0 = x, measure_y00 = measure_y0 = y;
}

function measure_lengthPoint(x, y) {
  measure_x0 -= x, measure_y0 -= y;
  measure_lengthSum.add((0,math/* sqrt */.RZ)(measure_x0 * measure_x0 + measure_y0 * measure_y0));
  measure_x0 = x, measure_y0 = y;
}

/* harmony default export */ var measure = (measure_lengthStream);

;// CONCATENATED MODULE: ./node_modules/d3-geo/src/path/string.js
function PathString() {
  this._string = [];
}

PathString.prototype = {
  _radius: 4.5,
  _circle: string_circle(4.5),
  pointRadius: function(_) {
    if ((_ = +_) !== this._radius) this._radius = _, this._circle = null;
    return this;
  },
  polygonStart: function() {
    this._line = 0;
  },
  polygonEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line === 0) this._string.push("Z");
    this._point = NaN;
  },
  point: function(x, y) {
    switch (this._point) {
      case 0: {
        this._string.push("M", x, ",", y);
        this._point = 1;
        break;
      }
      case 1: {
        this._string.push("L", x, ",", y);
        break;
      }
      default: {
        if (this._circle == null) this._circle = string_circle(this._radius);
        this._string.push("M", x, ",", y, this._circle);
        break;
      }
    }
  },
  result: function() {
    if (this._string.length) {
      var result = this._string.join("");
      this._string = [];
      return result;
    } else {
      return null;
    }
  }
};

function string_circle(radius) {
  return "m0," + radius
      + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius
      + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius
      + "z";
}

;// CONCATENATED MODULE: ./node_modules/d3-geo/src/path/index.js









/* harmony default export */ function path(projection, context) {
  var pointRadius = 4.5,
      projectionStream,
      contextStream;

  function path(object) {
    if (object) {
      if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
      (0,stream/* default */.A)(object, projectionStream(contextStream));
    }
    return contextStream.result();
  }

  path.area = function(object) {
    (0,stream/* default */.A)(object, projectionStream(path_area));
    return path_area.result();
  };

  path.measure = function(object) {
    (0,stream/* default */.A)(object, projectionStream(measure));
    return measure.result();
  };

  path.bounds = function(object) {
    (0,stream/* default */.A)(object, projectionStream(path_bounds/* default */.A));
    return path_bounds/* default */.A.result();
  };

  path.centroid = function(object) {
    (0,stream/* default */.A)(object, projectionStream(path_centroid));
    return path_centroid.result();
  };

  path.projection = function(_) {
    return arguments.length ? (projectionStream = _ == null ? (projection = null, identity/* default */.A) : (projection = _).stream, path) : projection;
  };

  path.context = function(_) {
    if (!arguments.length) return context;
    contextStream = _ == null ? (context = null, new PathString) : new PathContext(context = _);
    if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
    return path;
  };

  path.pointRadius = function(_) {
    if (!arguments.length) return pointRadius;
    pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
    return path;
  };

  return path.projection(projection).context(context);
}

// EXTERNAL MODULE: ./node_modules/d3-geo/src/projection/index.js + 1 modules
var projection = __webpack_require__(94684);
;// CONCATENATED MODULE: ./node_modules/d3-geo/src/projection/conic.js



function conicProjection(projectAt) {
  var phi0 = 0,
      phi1 = math.pi / 3,
      m = (0,projection/* projectionMutator */.U)(projectAt),
      p = m(phi0, phi1);

  p.parallels = function(_) {
    return arguments.length ? m(phi0 = _[0] * math/* radians */.F2, phi1 = _[1] * math/* radians */.F2) : [phi0 * math/* degrees */.uj, phi1 * math/* degrees */.uj];
  };

  return p;
}

;// CONCATENATED MODULE: ./node_modules/d3-geo/src/projection/cylindricalEqualArea.js


function cylindricalEqualAreaRaw(phi0) {
  var cosPhi0 = (0,math/* cos */.gn)(phi0);

  function forward(lambda, phi) {
    return [lambda * cosPhi0, (0,math/* sin */.F8)(phi) / cosPhi0];
  }

  forward.invert = function(x, y) {
    return [x / cosPhi0, (0,math/* asin */.qR)(y * cosPhi0)];
  };

  return forward;
}

;// CONCATENATED MODULE: ./node_modules/d3-geo/src/projection/conicEqualArea.js




function conicEqualAreaRaw(y0, y1) {
  var sy0 = (0,math/* sin */.F8)(y0), n = (sy0 + (0,math/* sin */.F8)(y1)) / 2;

  // Are the parallels symmetrical around the Equator?
  if ((0,math/* abs */.tn)(n) < math/* epsilon */.Ni) return cylindricalEqualAreaRaw(y0);

  var c = 1 + sy0 * (2 * n - sy0), r0 = (0,math/* sqrt */.RZ)(c) / n;

  function project(x, y) {
    var r = (0,math/* sqrt */.RZ)(c - 2 * n * (0,math/* sin */.F8)(y)) / n;
    return [r * (0,math/* sin */.F8)(x *= n), r0 - r * (0,math/* cos */.gn)(x)];
  }

  project.invert = function(x, y) {
    var r0y = r0 - y,
        l = (0,math/* atan2 */.FP)(x, (0,math/* abs */.tn)(r0y)) * (0,math/* sign */._S)(r0y);
    if (r0y * n < 0)
      l -= math.pi * (0,math/* sign */._S)(x) * (0,math/* sign */._S)(r0y);
    return [l / n, (0,math/* asin */.qR)((c - (x * x + r0y * r0y) * n * n) / (2 * n))];
  };

  return project;
}

/* harmony default export */ function conicEqualArea() {
  return conicProjection(conicEqualAreaRaw)
      .scale(155.424)
      .center([0, 33.6442]);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo/src/projection/albers.js


/* harmony default export */ function albers() {
  return conicEqualArea()
      .parallels([29.5, 45.5])
      .scale(1070)
      .translate([480, 250])
      .rotate([96, 0])
      .center([-0.6, 38.7]);
}

// EXTERNAL MODULE: ./node_modules/d3-geo/src/projection/fit.js
var fit = __webpack_require__(7944);
;// CONCATENATED MODULE: ./node_modules/d3-geo/src/projection/albersUsa.js





// The projections must have mutually exclusive clip regions on the sphere,
// as this will avoid emitting interleaving lines and polygons.
function multiplex(streams) {
  var n = streams.length;
  return {
    point: function(x, y) { var i = -1; while (++i < n) streams[i].point(x, y); },
    sphere: function() { var i = -1; while (++i < n) streams[i].sphere(); },
    lineStart: function() { var i = -1; while (++i < n) streams[i].lineStart(); },
    lineEnd: function() { var i = -1; while (++i < n) streams[i].lineEnd(); },
    polygonStart: function() { var i = -1; while (++i < n) streams[i].polygonStart(); },
    polygonEnd: function() { var i = -1; while (++i < n) streams[i].polygonEnd(); }
  };
}

// A composite projection for the United States, configured by default for
// 960×500. The projection also works quite well at 960×600 if you change the
// scale to 1285 and adjust the translate accordingly. The set of standard
// parallels for each region comes from USGS, which is published here:
// http://egsc.usgs.gov/isb/pubs/MapProjections/projections.html#albers
/* harmony default export */ function albersUsa() {
  var cache,
      cacheStream,
      lower48 = albers(), lower48Point,
      alaska = conicEqualArea().rotate([154, 0]).center([-2, 58.5]).parallels([55, 65]), alaskaPoint, // EPSG:3338
      hawaii = conicEqualArea().rotate([157, 0]).center([-3, 19.9]).parallels([8, 18]), hawaiiPoint, // ESRI:102007
      point, pointStream = {point: function(x, y) { point = [x, y]; }};

  function albersUsa(coordinates) {
    var x = coordinates[0], y = coordinates[1];
    return point = null,
        (lower48Point.point(x, y), point)
        || (alaskaPoint.point(x, y), point)
        || (hawaiiPoint.point(x, y), point);
  }

  albersUsa.invert = function(coordinates) {
    var k = lower48.scale(),
        t = lower48.translate(),
        x = (coordinates[0] - t[0]) / k,
        y = (coordinates[1] - t[1]) / k;
    return (y >= 0.120 && y < 0.234 && x >= -0.425 && x < -0.214 ? alaska
        : y >= 0.166 && y < 0.234 && x >= -0.214 && x < -0.115 ? hawaii
        : lower48).invert(coordinates);
  };

  albersUsa.stream = function(stream) {
    return cache && cacheStream === stream ? cache : cache = multiplex([lower48.stream(cacheStream = stream), alaska.stream(stream), hawaii.stream(stream)]);
  };

  albersUsa.precision = function(_) {
    if (!arguments.length) return lower48.precision();
    lower48.precision(_), alaska.precision(_), hawaii.precision(_);
    return reset();
  };

  albersUsa.scale = function(_) {
    if (!arguments.length) return lower48.scale();
    lower48.scale(_), alaska.scale(_ * 0.35), hawaii.scale(_);
    return albersUsa.translate(lower48.translate());
  };

  albersUsa.translate = function(_) {
    if (!arguments.length) return lower48.translate();
    var k = lower48.scale(), x = +_[0], y = +_[1];

    lower48Point = lower48
        .translate(_)
        .clipExtent([[x - 0.455 * k, y - 0.238 * k], [x + 0.455 * k, y + 0.238 * k]])
        .stream(pointStream);

    alaskaPoint = alaska
        .translate([x - 0.307 * k, y + 0.201 * k])
        .clipExtent([[x - 0.425 * k + math/* epsilon */.Ni, y + 0.120 * k + math/* epsilon */.Ni], [x - 0.214 * k - math/* epsilon */.Ni, y + 0.234 * k - math/* epsilon */.Ni]])
        .stream(pointStream);

    hawaiiPoint = hawaii
        .translate([x - 0.205 * k, y + 0.212 * k])
        .clipExtent([[x - 0.214 * k + math/* epsilon */.Ni, y + 0.166 * k + math/* epsilon */.Ni], [x - 0.115 * k - math/* epsilon */.Ni, y + 0.234 * k - math/* epsilon */.Ni]])
        .stream(pointStream);

    return reset();
  };

  albersUsa.fitExtent = function(extent, object) {
    return (0,fit/* fitExtent */.sp)(albersUsa, extent, object);
  };

  albersUsa.fitSize = function(size, object) {
    return (0,fit/* fitSize */.Hv)(albersUsa, size, object);
  };

  albersUsa.fitWidth = function(width, object) {
    return (0,fit/* fitWidth */.G0)(albersUsa, width, object);
  };

  albersUsa.fitHeight = function(height, object) {
    return (0,fit/* fitHeight */.FL)(albersUsa, height, object);
  };

  function reset() {
    cache = cacheStream = null;
    return albersUsa;
  }

  return albersUsa.scale(1070);
}

// EXTERNAL MODULE: ./node_modules/d3-geo/src/projection/azimuthalEqualArea.js
var azimuthalEqualArea = __webpack_require__(30729);
// EXTERNAL MODULE: ./node_modules/d3-geo/src/projection/azimuthalEquidistant.js
var azimuthalEquidistant = __webpack_require__(61957);
// EXTERNAL MODULE: ./node_modules/d3-geo/src/rotation.js
var rotation = __webpack_require__(30915);
;// CONCATENATED MODULE: ./node_modules/d3-geo/src/projection/mercator.js




function mercatorRaw(lambda, phi) {
  return [lambda, (0,math/* log */.Rm)((0,math/* tan */.Ml)((math/* halfPi */.TW + phi) / 2))];
}

mercatorRaw.invert = function(x, y) {
  return [x, 2 * (0,math/* atan */.rY)((0,math/* exp */.oN)(y)) - math/* halfPi */.TW];
};

/* harmony default export */ function mercator() {
  return mercatorProjection(mercatorRaw)
      .scale(961 / math/* tau */.FA);
}

function mercatorProjection(project) {
  var m = (0,projection/* default */.A)(project),
      center = m.center,
      scale = m.scale,
      translate = m.translate,
      clipExtent = m.clipExtent,
      x0 = null, y0, x1, y1; // clip extent

  m.scale = function(_) {
    return arguments.length ? (scale(_), reclip()) : scale();
  };

  m.translate = function(_) {
    return arguments.length ? (translate(_), reclip()) : translate();
  };

  m.center = function(_) {
    return arguments.length ? (center(_), reclip()) : center();
  };

  m.clipExtent = function(_) {
    return arguments.length ? ((_ == null ? x0 = y0 = x1 = y1 = null : (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1])), reclip()) : x0 == null ? null : [[x0, y0], [x1, y1]];
  };

  function reclip() {
    var k = math.pi * scale(),
        t = m((0,rotation/* default */.A)(m.rotate()).invert([0, 0]));
    return clipExtent(x0 == null
        ? [[t[0] - k, t[1] - k], [t[0] + k, t[1] + k]] : project === mercatorRaw
        ? [[Math.max(t[0] - k, x0), y0], [Math.min(t[0] + k, x1), y1]]
        : [[x0, Math.max(t[1] - k, y0)], [x1, Math.min(t[1] + k, y1)]]);
  }

  return reclip();
}

;// CONCATENATED MODULE: ./node_modules/d3-geo/src/projection/conicConformal.js




function tany(y) {
  return (0,math/* tan */.Ml)((math/* halfPi */.TW + y) / 2);
}

function conicConformalRaw(y0, y1) {
  var cy0 = (0,math/* cos */.gn)(y0),
      n = y0 === y1 ? (0,math/* sin */.F8)(y0) : (0,math/* log */.Rm)(cy0 / (0,math/* cos */.gn)(y1)) / (0,math/* log */.Rm)(tany(y1) / tany(y0)),
      f = cy0 * (0,math/* pow */.n7)(tany(y0), n) / n;

  if (!n) return mercatorRaw;

  function project(x, y) {
    if (f > 0) { if (y < -math/* halfPi */.TW + math/* epsilon */.Ni) y = -math/* halfPi */.TW + math/* epsilon */.Ni; }
    else { if (y > math/* halfPi */.TW - math/* epsilon */.Ni) y = math/* halfPi */.TW - math/* epsilon */.Ni; }
    var r = f / (0,math/* pow */.n7)(tany(y), n);
    return [r * (0,math/* sin */.F8)(n * x), f - r * (0,math/* cos */.gn)(n * x)];
  }

  project.invert = function(x, y) {
    var fy = f - y, r = (0,math/* sign */._S)(n) * (0,math/* sqrt */.RZ)(x * x + fy * fy),
      l = (0,math/* atan2 */.FP)(x, (0,math/* abs */.tn)(fy)) * (0,math/* sign */._S)(fy);
    if (fy * n < 0)
      l -= math.pi * (0,math/* sign */._S)(x) * (0,math/* sign */._S)(fy);
    return [l / n, 2 * (0,math/* atan */.rY)((0,math/* pow */.n7)(f / r, 1 / n)) - math/* halfPi */.TW];
  };

  return project;
}

/* harmony default export */ function conicConformal() {
  return conicProjection(conicConformalRaw)
      .scale(109.5)
      .parallels([30, 30]);
}

// EXTERNAL MODULE: ./node_modules/d3-geo/src/projection/equirectangular.js
var equirectangular = __webpack_require__(18139);
;// CONCATENATED MODULE: ./node_modules/d3-geo/src/projection/conicEquidistant.js




function conicEquidistantRaw(y0, y1) {
  var cy0 = (0,math/* cos */.gn)(y0),
      n = y0 === y1 ? (0,math/* sin */.F8)(y0) : (cy0 - (0,math/* cos */.gn)(y1)) / (y1 - y0),
      g = cy0 / n + y0;

  if ((0,math/* abs */.tn)(n) < math/* epsilon */.Ni) return equirectangular/* equirectangularRaw */.f;

  function project(x, y) {
    var gy = g - y, nx = n * x;
    return [gy * (0,math/* sin */.F8)(nx), g - gy * (0,math/* cos */.gn)(nx)];
  }

  project.invert = function(x, y) {
    var gy = g - y,
        l = (0,math/* atan2 */.FP)(x, (0,math/* abs */.tn)(gy)) * (0,math/* sign */._S)(gy);
    if (gy * n < 0)
      l -= math.pi * (0,math/* sign */._S)(x) * (0,math/* sign */._S)(gy);
    return [l / n, g - (0,math/* sign */._S)(n) * (0,math/* sqrt */.RZ)(x * x + gy * gy)];
  };

  return project;
}

/* harmony default export */ function conicEquidistant() {
  return conicProjection(conicEquidistantRaw)
      .scale(131.154)
      .center([0, 13.9389]);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo/src/projection/equalEarth.js



var A1 = 1.340264,
    A2 = -0.081106,
    A3 = 0.000893,
    A4 = 0.003796,
    M = (0,math/* sqrt */.RZ)(3) / 2,
    iterations = 12;

function equalEarthRaw(lambda, phi) {
  var l = (0,math/* asin */.qR)(M * (0,math/* sin */.F8)(phi)), l2 = l * l, l6 = l2 * l2 * l2;
  return [
    lambda * (0,math/* cos */.gn)(l) / (M * (A1 + 3 * A2 * l2 + l6 * (7 * A3 + 9 * A4 * l2))),
    l * (A1 + A2 * l2 + l6 * (A3 + A4 * l2))
  ];
}

equalEarthRaw.invert = function(x, y) {
  var l = y, l2 = l * l, l6 = l2 * l2 * l2;
  for (var i = 0, delta, fy, fpy; i < iterations; ++i) {
    fy = l * (A1 + A2 * l2 + l6 * (A3 + A4 * l2)) - y;
    fpy = A1 + 3 * A2 * l2 + l6 * (7 * A3 + 9 * A4 * l2);
    l -= delta = fy / fpy, l2 = l * l, l6 = l2 * l2 * l2;
    if ((0,math/* abs */.tn)(delta) < math/* epsilon2 */.$t) break;
  }
  return [
    M * x * (A1 + 3 * A2 * l2 + l6 * (7 * A3 + 9 * A4 * l2)) / (0,math/* cos */.gn)(l),
    (0,math/* asin */.qR)((0,math/* sin */.F8)(l) / M)
  ];
};

/* harmony default export */ function equalEarth() {
  return (0,projection/* default */.A)(equalEarthRaw)
      .scale(177.158);
}

// EXTERNAL MODULE: ./node_modules/d3-geo/src/projection/gnomonic.js
var gnomonic = __webpack_require__(48419);
// EXTERNAL MODULE: ./node_modules/d3-geo/src/transform.js
var src_transform = __webpack_require__(913);
;// CONCATENATED MODULE: ./node_modules/d3-geo/src/projection/identity.js






/* harmony default export */ function projection_identity() {
  var k = 1, tx = 0, ty = 0, sx = 1, sy = 1, // scale, translate and reflect
      alpha = 0, ca, sa, // angle
      x0 = null, y0, x1, y1, // clip extent
      kx = 1, ky = 1,
      transform = (0,src_transform/* transformer */.G)({
        point: function(x, y) {
          var p = projection([x, y])
          this.stream.point(p[0], p[1]);
        }
      }),
      postclip = identity/* default */.A,
      cache,
      cacheStream;

  function reset() {
    kx = k * sx;
    ky = k * sy;
    cache = cacheStream = null;
    return projection;
  }

  function projection (p) {
    var x = p[0] * kx, y = p[1] * ky;
    if (alpha) {
      var t = y * ca - x * sa;
      x = x * ca + y * sa;
      y = t;
    }    
    return [x + tx, y + ty];
  }
  projection.invert = function(p) {
    var x = p[0] - tx, y = p[1] - ty;
    if (alpha) {
      var t = y * ca + x * sa;
      x = x * ca - y * sa;
      y = t;
    }
    return [x / kx, y / ky];
  };
  projection.stream = function(stream) {
    return cache && cacheStream === stream ? cache : cache = transform(postclip(cacheStream = stream));
  };
  projection.postclip = function(_) {
    return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
  };
  projection.clipExtent = function(_) {
    return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, identity/* default */.A) : (0,rectangle/* default */.A)(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [[x0, y0], [x1, y1]];
  };
  projection.scale = function(_) {
    return arguments.length ? (k = +_, reset()) : k;
  };
  projection.translate = function(_) {
    return arguments.length ? (tx = +_[0], ty = +_[1], reset()) : [tx, ty];
  }
  projection.angle = function(_) {
    return arguments.length ? (alpha = _ % 360 * math/* radians */.F2, sa = (0,math/* sin */.F8)(alpha), ca = (0,math/* cos */.gn)(alpha), reset()) : alpha * math/* degrees */.uj;
  };
  projection.reflectX = function(_) {
    return arguments.length ? (sx = _ ? -1 : 1, reset()) : sx < 0;
  };
  projection.reflectY = function(_) {
    return arguments.length ? (sy = _ ? -1 : 1, reset()) : sy < 0;
  };
  projection.fitExtent = function(extent, object) {
    return (0,fit/* fitExtent */.sp)(projection, extent, object);
  };
  projection.fitSize = function(size, object) {
    return (0,fit/* fitSize */.Hv)(projection, size, object);
  };
  projection.fitWidth = function(width, object) {
    return (0,fit/* fitWidth */.G0)(projection, width, object);
  };
  projection.fitHeight = function(height, object) {
    return (0,fit/* fitHeight */.FL)(projection, height, object);
  };

  return projection;
}

// EXTERNAL MODULE: ./node_modules/d3-geo/src/projection/naturalEarth1.js
var naturalEarth1 = __webpack_require__(57949);
// EXTERNAL MODULE: ./node_modules/d3-geo/src/projection/orthographic.js
var orthographic = __webpack_require__(53253);
// EXTERNAL MODULE: ./node_modules/d3-geo/src/projection/azimuthal.js
var azimuthal = __webpack_require__(57738);
;// CONCATENATED MODULE: ./node_modules/d3-geo/src/projection/stereographic.js




function stereographicRaw(x, y) {
  var cy = (0,math/* cos */.gn)(y), k = 1 + (0,math/* cos */.gn)(x) * cy;
  return [cy * (0,math/* sin */.F8)(x) / k, (0,math/* sin */.F8)(y) / k];
}

stereographicRaw.invert = (0,azimuthal/* azimuthalInvert */.I)(function(z) {
  return 2 * (0,math/* atan */.rY)(z);
});

/* harmony default export */ function stereographic() {
  return (0,projection/* default */.A)(stereographicRaw)
      .scale(250)
      .clipAngle(142);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo/src/projection/transverseMercator.js



function transverseMercatorRaw(lambda, phi) {
  return [(0,math/* log */.Rm)((0,math/* tan */.Ml)((math/* halfPi */.TW + phi) / 2)), -lambda];
}

transverseMercatorRaw.invert = function(x, y) {
  return [-y, 2 * (0,math/* atan */.rY)((0,math/* exp */.oN)(x)) - math/* halfPi */.TW];
};

/* harmony default export */ function transverseMercator() {
  var m = mercatorProjection(transverseMercatorRaw),
      center = m.center,
      rotate = m.rotate;

  m.center = function(_) {
    return arguments.length ? center([-_[1], _[0]]) : (_ = center(), [_[1], -_[0]]);
  };

  m.rotate = function(_) {
    return arguments.length ? rotate([_[0], _[1], _.length > 2 ? _[2] + 90 : 90]) : (_ = rotate(), [_[0], _[1], _[2] - 90]);
  };

  return rotate([0, 0, 90])
      .scale(159.155);
}

;// CONCATENATED MODULE: ./node_modules/d3-geo/src/index.js






 // DEPRECATED! Use d3.geoIdentity().clipExtent(…).





























/***/ }),

/***/ 81758:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
/* harmony import */ var _math_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61323);


/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__(a, b) {
  var x0 = a[0] * _math_js__WEBPACK_IMPORTED_MODULE_0__/* .radians */ .F2,
      y0 = a[1] * _math_js__WEBPACK_IMPORTED_MODULE_0__/* .radians */ .F2,
      x1 = b[0] * _math_js__WEBPACK_IMPORTED_MODULE_0__/* .radians */ .F2,
      y1 = b[1] * _math_js__WEBPACK_IMPORTED_MODULE_0__/* .radians */ .F2,
      cy0 = (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .cos */ .gn)(y0),
      sy0 = (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .sin */ .F8)(y0),
      cy1 = (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .cos */ .gn)(y1),
      sy1 = (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .sin */ .F8)(y1),
      kx0 = cy0 * (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .cos */ .gn)(x0),
      ky0 = cy0 * (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .sin */ .F8)(x0),
      kx1 = cy1 * (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .cos */ .gn)(x1),
      ky1 = cy1 * (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .sin */ .F8)(x1),
      d = 2 * (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .asin */ .qR)((0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .sqrt */ .RZ)((0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .haversin */ .bo)(y1 - y0) + cy0 * cy1 * (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .haversin */ .bo)(x1 - x0))),
      k = (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .sin */ .F8)(d);

  var interpolate = d ? function(t) {
    var B = (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .sin */ .F8)(t *= d) / k,
        A = (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .sin */ .F8)(d - t) / k,
        x = A * kx0 + B * kx1,
        y = A * ky0 + B * ky1,
        z = A * sy0 + B * sy1;
    return [
      (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .atan2 */ .FP)(y, x) * _math_js__WEBPACK_IMPORTED_MODULE_0__/* .degrees */ .uj,
      (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .atan2 */ .FP)(z, (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .sqrt */ .RZ)(x * x + y * y)) * _math_js__WEBPACK_IMPORTED_MODULE_0__/* .degrees */ .uj
    ];
  } : function() {
    return [x0 * _math_js__WEBPACK_IMPORTED_MODULE_0__/* .degrees */ .uj, y0 * _math_js__WEBPACK_IMPORTED_MODULE_0__/* .degrees */ .uj];
  };

  interpolate.distance = d;

  return interpolate;
}


/***/ }),

/***/ 61323:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   $t: function() { return /* binding */ epsilon2; },
/* harmony export */   F2: function() { return /* binding */ radians; },
/* harmony export */   F8: function() { return /* binding */ sin; },
/* harmony export */   FA: function() { return /* binding */ tau; },
/* harmony export */   FP: function() { return /* binding */ atan2; },
/* harmony export */   HQ: function() { return /* binding */ acos; },
/* harmony export */   Ml: function() { return /* binding */ tan; },
/* harmony export */   Ni: function() { return /* binding */ epsilon; },
/* harmony export */   RZ: function() { return /* binding */ sqrt; },
/* harmony export */   Rm: function() { return /* binding */ log; },
/* harmony export */   TW: function() { return /* binding */ halfPi; },
/* harmony export */   _S: function() { return /* binding */ sign; },
/* harmony export */   bo: function() { return /* binding */ haversin; },
/* harmony export */   gn: function() { return /* binding */ cos; },
/* harmony export */   gz: function() { return /* binding */ quarterPi; },
/* harmony export */   mk: function() { return /* binding */ ceil; },
/* harmony export */   n7: function() { return /* binding */ pow; },
/* harmony export */   oN: function() { return /* binding */ exp; },
/* harmony export */   pi: function() { return /* binding */ pi; },
/* harmony export */   qR: function() { return /* binding */ asin; },
/* harmony export */   rY: function() { return /* binding */ atan; },
/* harmony export */   tn: function() { return /* binding */ abs; },
/* harmony export */   uj: function() { return /* binding */ degrees; }
/* harmony export */ });
/* unused harmony export floor */
var epsilon = 1e-6;
var epsilon2 = 1e-12;
var pi = Math.PI;
var halfPi = pi / 2;
var quarterPi = pi / 4;
var tau = pi * 2;

var degrees = 180 / pi;
var radians = pi / 180;

var abs = Math.abs;
var atan = Math.atan;
var atan2 = Math.atan2;
var cos = Math.cos;
var ceil = Math.ceil;
var exp = Math.exp;
var floor = Math.floor;
var log = Math.log;
var pow = Math.pow;
var sin = Math.sin;
var sign = Math.sign || function(x) { return x > 0 ? 1 : x < 0 ? -1 : 0; };
var sqrt = Math.sqrt;
var tan = Math.tan;

function acos(x) {
  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}

function asin(x) {
  return x > 1 ? halfPi : x < -1 ? -halfPi : Math.asin(x);
}

function haversin(x) {
  return (x = sin(x / 2)) * x;
}


/***/ }),

/***/ 53341:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* binding */ noop; }
/* harmony export */ });
function noop() {}


/***/ }),

/***/ 33028:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _noop_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53341);


var x0 = Infinity,
    y0 = x0,
    x1 = -x0,
    y1 = x1;

var boundsStream = {
  point: boundsPoint,
  lineStart: _noop_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A,
  lineEnd: _noop_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A,
  polygonStart: _noop_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A,
  polygonEnd: _noop_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A,
  result: function() {
    var bounds = [[x0, y0], [x1, y1]];
    x1 = y1 = -(y0 = x0 = Infinity);
    return bounds;
  }
};

function boundsPoint(x, y) {
  if (x < x0) x0 = x;
  if (x > x1) x1 = x;
  if (y < y0) y0 = y;
  if (y > y1) y1 = y;
}

/* harmony default export */ __webpack_exports__.A = (boundsStream);


/***/ }),

/***/ 28759:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
/* harmony import */ var _math_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61323);


/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__(a, b) {
  return (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .abs */ .tn)(a[0] - b[0]) < _math_js__WEBPACK_IMPORTED_MODULE_0__/* .epsilon */ .Ni && (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .abs */ .tn)(a[1] - b[1]) < _math_js__WEBPACK_IMPORTED_MODULE_0__/* .epsilon */ .Ni;
}


/***/ }),

/***/ 2274:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
/* harmony import */ var _adder_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49353);
/* harmony import */ var _cartesian_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20375);
/* harmony import */ var _math_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61323);




var sum = (0,_adder_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)();

function longitude(point) {
  if ((0,_math_js__WEBPACK_IMPORTED_MODULE_1__/* .abs */ .tn)(point[0]) <= _math_js__WEBPACK_IMPORTED_MODULE_1__.pi)
    return point[0];
  else
    return (0,_math_js__WEBPACK_IMPORTED_MODULE_1__/* .sign */ ._S)(point[0]) * (((0,_math_js__WEBPACK_IMPORTED_MODULE_1__/* .abs */ .tn)(point[0]) + _math_js__WEBPACK_IMPORTED_MODULE_1__.pi) % _math_js__WEBPACK_IMPORTED_MODULE_1__/* .tau */ .FA - _math_js__WEBPACK_IMPORTED_MODULE_1__.pi);
}

/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__(polygon, point) {
  var lambda = longitude(point),
      phi = point[1],
      sinPhi = (0,_math_js__WEBPACK_IMPORTED_MODULE_1__/* .sin */ .F8)(phi),
      normal = [(0,_math_js__WEBPACK_IMPORTED_MODULE_1__/* .sin */ .F8)(lambda), -(0,_math_js__WEBPACK_IMPORTED_MODULE_1__/* .cos */ .gn)(lambda), 0],
      angle = 0,
      winding = 0;

  sum.reset();

  if (sinPhi === 1) phi = _math_js__WEBPACK_IMPORTED_MODULE_1__/* .halfPi */ .TW + _math_js__WEBPACK_IMPORTED_MODULE_1__/* .epsilon */ .Ni;
  else if (sinPhi === -1) phi = -_math_js__WEBPACK_IMPORTED_MODULE_1__/* .halfPi */ .TW - _math_js__WEBPACK_IMPORTED_MODULE_1__/* .epsilon */ .Ni;

  for (var i = 0, n = polygon.length; i < n; ++i) {
    if (!(m = (ring = polygon[i]).length)) continue;
    var ring,
        m,
        point0 = ring[m - 1],
        lambda0 = longitude(point0),
        phi0 = point0[1] / 2 + _math_js__WEBPACK_IMPORTED_MODULE_1__/* .quarterPi */ .gz,
        sinPhi0 = (0,_math_js__WEBPACK_IMPORTED_MODULE_1__/* .sin */ .F8)(phi0),
        cosPhi0 = (0,_math_js__WEBPACK_IMPORTED_MODULE_1__/* .cos */ .gn)(phi0);

    for (var j = 0; j < m; ++j, lambda0 = lambda1, sinPhi0 = sinPhi1, cosPhi0 = cosPhi1, point0 = point1) {
      var point1 = ring[j],
          lambda1 = longitude(point1),
          phi1 = point1[1] / 2 + _math_js__WEBPACK_IMPORTED_MODULE_1__/* .quarterPi */ .gz,
          sinPhi1 = (0,_math_js__WEBPACK_IMPORTED_MODULE_1__/* .sin */ .F8)(phi1),
          cosPhi1 = (0,_math_js__WEBPACK_IMPORTED_MODULE_1__/* .cos */ .gn)(phi1),
          delta = lambda1 - lambda0,
          sign = delta >= 0 ? 1 : -1,
          absDelta = sign * delta,
          antimeridian = absDelta > _math_js__WEBPACK_IMPORTED_MODULE_1__.pi,
          k = sinPhi0 * sinPhi1;

      sum.add((0,_math_js__WEBPACK_IMPORTED_MODULE_1__/* .atan2 */ .FP)(k * sign * (0,_math_js__WEBPACK_IMPORTED_MODULE_1__/* .sin */ .F8)(absDelta), cosPhi0 * cosPhi1 + k * (0,_math_js__WEBPACK_IMPORTED_MODULE_1__/* .cos */ .gn)(absDelta)));
      angle += antimeridian ? delta + sign * _math_js__WEBPACK_IMPORTED_MODULE_1__/* .tau */ .FA : delta;

      // Are the longitudes either side of the point’s meridian (lambda),
      // and are the latitudes smaller than the parallel (phi)?
      if (antimeridian ^ lambda0 >= lambda ^ lambda1 >= lambda) {
        var arc = (0,_cartesian_js__WEBPACK_IMPORTED_MODULE_2__/* .cartesianCross */ .r8)((0,_cartesian_js__WEBPACK_IMPORTED_MODULE_2__/* .cartesian */ .jf)(point0), (0,_cartesian_js__WEBPACK_IMPORTED_MODULE_2__/* .cartesian */ .jf)(point1));
        (0,_cartesian_js__WEBPACK_IMPORTED_MODULE_2__/* .cartesianNormalizeInPlace */ .Cx)(arc);
        var intersection = (0,_cartesian_js__WEBPACK_IMPORTED_MODULE_2__/* .cartesianCross */ .r8)(normal, arc);
        (0,_cartesian_js__WEBPACK_IMPORTED_MODULE_2__/* .cartesianNormalizeInPlace */ .Cx)(intersection);
        var phiArc = (antimeridian ^ delta >= 0 ? -1 : 1) * (0,_math_js__WEBPACK_IMPORTED_MODULE_1__/* .asin */ .qR)(intersection[2]);
        if (phi > phiArc || phi === phiArc && (arc[0] || arc[1])) {
          winding += antimeridian ^ delta >= 0 ? 1 : -1;
        }
      }
    }
  }

  // First, determine whether the South pole is inside or outside:
  //
  // It is inside if:
  // * the polygon winds around it in a clockwise direction.
  // * the polygon does not (cumulatively) wind around it, but has a negative
  //   (counter-clockwise) area.
  //
  // Second, count the (signed) number of times a segment crosses a lambda
  // from the point to the South pole.  If it is zero, then the point is the
  // same side as the South pole.

  return (angle < -_math_js__WEBPACK_IMPORTED_MODULE_1__/* .epsilon */ .Ni || angle < _math_js__WEBPACK_IMPORTED_MODULE_1__/* .epsilon */ .Ni && sum < -_math_js__WEBPACK_IMPORTED_MODULE_1__/* .epsilon */ .Ni) ^ (winding & 1);
}


/***/ }),

/***/ 57738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   I: function() { return /* binding */ azimuthalInvert; },
/* harmony export */   c: function() { return /* binding */ azimuthalRaw; }
/* harmony export */ });
/* harmony import */ var _math_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61323);


function azimuthalRaw(scale) {
  return function(x, y) {
    var cx = (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .cos */ .gn)(x),
        cy = (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .cos */ .gn)(y),
        k = scale(cx * cy);
    return [
      k * cy * (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .sin */ .F8)(x),
      k * (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .sin */ .F8)(y)
    ];
  }
}

function azimuthalInvert(angle) {
  return function(x, y) {
    var z = (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .sqrt */ .RZ)(x * x + y * y),
        c = angle(z),
        sc = (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .sin */ .F8)(c),
        cc = (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .cos */ .gn)(c);
    return [
      (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .atan2 */ .FP)(x * sc, z * cc),
      (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .asin */ .qR)(z && y * sc / z)
    ];
  }
}


/***/ }),

/***/ 30729:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; },
/* harmony export */   n: function() { return /* binding */ azimuthalEqualAreaRaw; }
/* harmony export */ });
/* harmony import */ var _math_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61323);
/* harmony import */ var _azimuthal_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57738);
/* harmony import */ var _index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94684);




var azimuthalEqualAreaRaw = (0,_azimuthal_js__WEBPACK_IMPORTED_MODULE_0__/* .azimuthalRaw */ .c)(function(cxcy) {
  return (0,_math_js__WEBPACK_IMPORTED_MODULE_1__/* .sqrt */ .RZ)(2 / (1 + cxcy));
});

azimuthalEqualAreaRaw.invert = (0,_azimuthal_js__WEBPACK_IMPORTED_MODULE_0__/* .azimuthalInvert */ .I)(function(z) {
  return 2 * (0,_math_js__WEBPACK_IMPORTED_MODULE_1__/* .asin */ .qR)(z / 2);
});

/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__() {
  return (0,_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(azimuthalEqualAreaRaw)
      .scale(124.75)
      .clipAngle(180 - 1e-3);
}


/***/ }),

/***/ 61957:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; },
/* harmony export */   j: function() { return /* binding */ azimuthalEquidistantRaw; }
/* harmony export */ });
/* harmony import */ var _math_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61323);
/* harmony import */ var _azimuthal_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57738);
/* harmony import */ var _index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94684);




var azimuthalEquidistantRaw = (0,_azimuthal_js__WEBPACK_IMPORTED_MODULE_0__/* .azimuthalRaw */ .c)(function(c) {
  return (c = (0,_math_js__WEBPACK_IMPORTED_MODULE_1__/* .acos */ .HQ)(c)) && c / (0,_math_js__WEBPACK_IMPORTED_MODULE_1__/* .sin */ .F8)(c);
});

azimuthalEquidistantRaw.invert = (0,_azimuthal_js__WEBPACK_IMPORTED_MODULE_0__/* .azimuthalInvert */ .I)(function(z) {
  return z;
});

/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__() {
  return (0,_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(azimuthalEquidistantRaw)
      .scale(79.4188)
      .clipAngle(180 - 1e-3);
}


/***/ }),

/***/ 18139:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; },
/* harmony export */   f: function() { return /* binding */ equirectangularRaw; }
/* harmony export */ });
/* harmony import */ var _index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94684);


function equirectangularRaw(lambda, phi) {
  return [lambda, phi];
}

equirectangularRaw.invert = equirectangularRaw;

/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__() {
  return (0,_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(equirectangularRaw)
      .scale(152.63);
}


/***/ }),

/***/ 7944:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   FL: function() { return /* binding */ fitHeight; },
/* harmony export */   G0: function() { return /* binding */ fitWidth; },
/* harmony export */   Hv: function() { return /* binding */ fitSize; },
/* harmony export */   sp: function() { return /* binding */ fitExtent; }
/* harmony export */ });
/* harmony import */ var _stream_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20465);
/* harmony import */ var _path_bounds_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33028);



function fit(projection, fitBounds, object) {
  var clip = projection.clipExtent && projection.clipExtent();
  projection.scale(150).translate([0, 0]);
  if (clip != null) projection.clipExtent(null);
  (0,_stream_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(object, projection.stream(_path_bounds_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A));
  fitBounds(_path_bounds_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.result());
  if (clip != null) projection.clipExtent(clip);
  return projection;
}

function fitExtent(projection, extent, object) {
  return fit(projection, function(b) {
    var w = extent[1][0] - extent[0][0],
        h = extent[1][1] - extent[0][1],
        k = Math.min(w / (b[1][0] - b[0][0]), h / (b[1][1] - b[0][1])),
        x = +extent[0][0] + (w - k * (b[1][0] + b[0][0])) / 2,
        y = +extent[0][1] + (h - k * (b[1][1] + b[0][1])) / 2;
    projection.scale(150 * k).translate([x, y]);
  }, object);
}

function fitSize(projection, size, object) {
  return fitExtent(projection, [[0, 0], size], object);
}

function fitWidth(projection, width, object) {
  return fit(projection, function(b) {
    var w = +width,
        k = w / (b[1][0] - b[0][0]),
        x = (w - k * (b[1][0] + b[0][0])) / 2,
        y = -k * b[0][1];
    projection.scale(150 * k).translate([x, y]);
  }, object);
}

function fitHeight(projection, height, object) {
  return fit(projection, function(b) {
    var h = +height,
        k = h / (b[1][1] - b[0][1]),
        x = -k * b[0][0],
        y = (h - k * (b[1][1] + b[0][1])) / 2;
    projection.scale(150 * k).translate([x, y]);
  }, object);
}


/***/ }),

/***/ 48419:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; },
/* harmony export */   T: function() { return /* binding */ gnomonicRaw; }
/* harmony export */ });
/* harmony import */ var _math_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61323);
/* harmony import */ var _azimuthal_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57738);
/* harmony import */ var _index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94684);




function gnomonicRaw(x, y) {
  var cy = (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .cos */ .gn)(y), k = (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .cos */ .gn)(x) * cy;
  return [cy * (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .sin */ .F8)(x) / k, (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .sin */ .F8)(y) / k];
}

gnomonicRaw.invert = (0,_azimuthal_js__WEBPACK_IMPORTED_MODULE_1__/* .azimuthalInvert */ .I)(_math_js__WEBPACK_IMPORTED_MODULE_0__/* .atan */ .rY);

/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__() {
  return (0,_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(gnomonicRaw)
      .scale(144.049)
      .clipAngle(60);
}


/***/ }),

/***/ 94684:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ projection; },
  U: function() { return /* binding */ projectionMutator; }
});

// EXTERNAL MODULE: ./node_modules/d3-geo/src/clip/antimeridian.js
var antimeridian = __webpack_require__(42413);
// EXTERNAL MODULE: ./node_modules/d3-geo/src/clip/circle.js
var circle = __webpack_require__(47402);
// EXTERNAL MODULE: ./node_modules/d3-geo/src/clip/rectangle.js + 1 modules
var rectangle = __webpack_require__(21503);
// EXTERNAL MODULE: ./node_modules/d3-geo/src/compose.js
var compose = __webpack_require__(19057);
// EXTERNAL MODULE: ./node_modules/d3-geo/src/identity.js
var identity = __webpack_require__(26827);
// EXTERNAL MODULE: ./node_modules/d3-geo/src/math.js
var math = __webpack_require__(61323);
// EXTERNAL MODULE: ./node_modules/d3-geo/src/rotation.js
var rotation = __webpack_require__(30915);
// EXTERNAL MODULE: ./node_modules/d3-geo/src/transform.js
var transform = __webpack_require__(913);
// EXTERNAL MODULE: ./node_modules/d3-geo/src/projection/fit.js
var fit = __webpack_require__(7944);
// EXTERNAL MODULE: ./node_modules/d3-geo/src/cartesian.js
var cartesian = __webpack_require__(20375);
;// CONCATENATED MODULE: ./node_modules/d3-geo/src/projection/resample.js




var maxDepth = 16, // maximum depth of subdivision
    cosMinDistance = (0,math/* cos */.gn)(30 * math/* radians */.F2); // cos(minimum angular distance)

/* harmony default export */ function resample(project, delta2) {
  return +delta2 ? resample_resample(project, delta2) : resampleNone(project);
}

function resampleNone(project) {
  return (0,transform/* transformer */.G)({
    point: function(x, y) {
      x = project(x, y);
      this.stream.point(x[0], x[1]);
    }
  });
}

function resample_resample(project, delta2) {

  function resampleLineTo(x0, y0, lambda0, a0, b0, c0, x1, y1, lambda1, a1, b1, c1, depth, stream) {
    var dx = x1 - x0,
        dy = y1 - y0,
        d2 = dx * dx + dy * dy;
    if (d2 > 4 * delta2 && depth--) {
      var a = a0 + a1,
          b = b0 + b1,
          c = c0 + c1,
          m = (0,math/* sqrt */.RZ)(a * a + b * b + c * c),
          phi2 = (0,math/* asin */.qR)(c /= m),
          lambda2 = (0,math/* abs */.tn)((0,math/* abs */.tn)(c) - 1) < math/* epsilon */.Ni || (0,math/* abs */.tn)(lambda0 - lambda1) < math/* epsilon */.Ni ? (lambda0 + lambda1) / 2 : (0,math/* atan2 */.FP)(b, a),
          p = project(lambda2, phi2),
          x2 = p[0],
          y2 = p[1],
          dx2 = x2 - x0,
          dy2 = y2 - y0,
          dz = dy * dx2 - dx * dy2;
      if (dz * dz / d2 > delta2 // perpendicular projected distance
          || (0,math/* abs */.tn)((dx * dx2 + dy * dy2) / d2 - 0.5) > 0.3 // midpoint close to an end
          || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) { // angular distance
        resampleLineTo(x0, y0, lambda0, a0, b0, c0, x2, y2, lambda2, a /= m, b /= m, c, depth, stream);
        stream.point(x2, y2);
        resampleLineTo(x2, y2, lambda2, a, b, c, x1, y1, lambda1, a1, b1, c1, depth, stream);
      }
    }
  }
  return function(stream) {
    var lambda00, x00, y00, a00, b00, c00, // first point
        lambda0, x0, y0, a0, b0, c0; // previous point

    var resampleStream = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: function() { stream.polygonStart(); resampleStream.lineStart = ringStart; },
      polygonEnd: function() { stream.polygonEnd(); resampleStream.lineStart = lineStart; }
    };

    function point(x, y) {
      x = project(x, y);
      stream.point(x[0], x[1]);
    }

    function lineStart() {
      x0 = NaN;
      resampleStream.point = linePoint;
      stream.lineStart();
    }

    function linePoint(lambda, phi) {
      var c = (0,cartesian/* cartesian */.jf)([lambda, phi]), p = project(lambda, phi);
      resampleLineTo(x0, y0, lambda0, a0, b0, c0, x0 = p[0], y0 = p[1], lambda0 = lambda, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
      stream.point(x0, y0);
    }

    function lineEnd() {
      resampleStream.point = point;
      stream.lineEnd();
    }

    function ringStart() {
      lineStart();
      resampleStream.point = ringPoint;
      resampleStream.lineEnd = ringEnd;
    }

    function ringPoint(lambda, phi) {
      linePoint(lambda00 = lambda, phi), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
      resampleStream.point = linePoint;
    }

    function ringEnd() {
      resampleLineTo(x0, y0, lambda0, a0, b0, c0, x00, y00, lambda00, a00, b00, c00, maxDepth, stream);
      resampleStream.lineEnd = lineEnd;
      lineEnd();
    }

    return resampleStream;
  };
}

;// CONCATENATED MODULE: ./node_modules/d3-geo/src/projection/index.js











var transformRadians = (0,transform/* transformer */.G)({
  point: function(x, y) {
    this.stream.point(x * math/* radians */.F2, y * math/* radians */.F2);
  }
});

function transformRotate(rotate) {
  return (0,transform/* transformer */.G)({
    point: function(x, y) {
      var r = rotate(x, y);
      return this.stream.point(r[0], r[1]);
    }
  });
}

function scaleTranslate(k, dx, dy, sx, sy) {
  function transform(x, y) {
    x *= sx; y *= sy;
    return [dx + k * x, dy - k * y];
  }
  transform.invert = function(x, y) {
    return [(x - dx) / k * sx, (dy - y) / k * sy];
  };
  return transform;
}

function scaleTranslateRotate(k, dx, dy, sx, sy, alpha) {
  var cosAlpha = (0,math/* cos */.gn)(alpha),
      sinAlpha = (0,math/* sin */.F8)(alpha),
      a = cosAlpha * k,
      b = sinAlpha * k,
      ai = cosAlpha / k,
      bi = sinAlpha / k,
      ci = (sinAlpha * dy - cosAlpha * dx) / k,
      fi = (sinAlpha * dx + cosAlpha * dy) / k;
  function transform(x, y) {
    x *= sx; y *= sy;
    return [a * x - b * y + dx, dy - b * x - a * y];
  }
  transform.invert = function(x, y) {
    return [sx * (ai * x - bi * y + ci), sy * (fi - bi * x - ai * y)];
  };
  return transform;
}

function projection(project) {
  return projectionMutator(function() { return project; })();
}

function projectionMutator(projectAt) {
  var project,
      k = 150, // scale
      x = 480, y = 250, // translate
      lambda = 0, phi = 0, // center
      deltaLambda = 0, deltaPhi = 0, deltaGamma = 0, rotate, // pre-rotate
      alpha = 0, // post-rotate angle
      sx = 1, // reflectX
      sy = 1, // reflectX
      theta = null, preclip = antimeridian/* default */.A, // pre-clip angle
      x0 = null, y0, x1, y1, postclip = identity/* default */.A, // post-clip extent
      delta2 = 0.5, // precision
      projectResample,
      projectTransform,
      projectRotateTransform,
      cache,
      cacheStream;

  function projection(point) {
    return projectRotateTransform(point[0] * math/* radians */.F2, point[1] * math/* radians */.F2);
  }

  function invert(point) {
    point = projectRotateTransform.invert(point[0], point[1]);
    return point && [point[0] * math/* degrees */.uj, point[1] * math/* degrees */.uj];
  }

  projection.stream = function(stream) {
    return cache && cacheStream === stream ? cache : cache = transformRadians(transformRotate(rotate)(preclip(projectResample(postclip(cacheStream = stream)))));
  };

  projection.preclip = function(_) {
    return arguments.length ? (preclip = _, theta = undefined, reset()) : preclip;
  };

  projection.postclip = function(_) {
    return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
  };

  projection.clipAngle = function(_) {
    return arguments.length ? (preclip = +_ ? (0,circle/* default */.A)(theta = _ * math/* radians */.F2) : (theta = null, antimeridian/* default */.A), reset()) : theta * math/* degrees */.uj;
  };

  projection.clipExtent = function(_) {
    return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, identity/* default */.A) : (0,rectangle/* default */.A)(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [[x0, y0], [x1, y1]];
  };

  projection.scale = function(_) {
    return arguments.length ? (k = +_, recenter()) : k;
  };

  projection.translate = function(_) {
    return arguments.length ? (x = +_[0], y = +_[1], recenter()) : [x, y];
  };

  projection.center = function(_) {
    return arguments.length ? (lambda = _[0] % 360 * math/* radians */.F2, phi = _[1] % 360 * math/* radians */.F2, recenter()) : [lambda * math/* degrees */.uj, phi * math/* degrees */.uj];
  };

  projection.rotate = function(_) {
    return arguments.length ? (deltaLambda = _[0] % 360 * math/* radians */.F2, deltaPhi = _[1] % 360 * math/* radians */.F2, deltaGamma = _.length > 2 ? _[2] % 360 * math/* radians */.F2 : 0, recenter()) : [deltaLambda * math/* degrees */.uj, deltaPhi * math/* degrees */.uj, deltaGamma * math/* degrees */.uj];
  };

  projection.angle = function(_) {
    return arguments.length ? (alpha = _ % 360 * math/* radians */.F2, recenter()) : alpha * math/* degrees */.uj;
  };

  projection.reflectX = function(_) {
    return arguments.length ? (sx = _ ? -1 : 1, recenter()) : sx < 0;
  };

  projection.reflectY = function(_) {
    return arguments.length ? (sy = _ ? -1 : 1, recenter()) : sy < 0;
  };

  projection.precision = function(_) {
    return arguments.length ? (projectResample = resample(projectTransform, delta2 = _ * _), reset()) : (0,math/* sqrt */.RZ)(delta2);
  };

  projection.fitExtent = function(extent, object) {
    return (0,fit/* fitExtent */.sp)(projection, extent, object);
  };

  projection.fitSize = function(size, object) {
    return (0,fit/* fitSize */.Hv)(projection, size, object);
  };

  projection.fitWidth = function(width, object) {
    return (0,fit/* fitWidth */.G0)(projection, width, object);
  };

  projection.fitHeight = function(height, object) {
    return (0,fit/* fitHeight */.FL)(projection, height, object);
  };

  function recenter() {
    var center = scaleTranslateRotate(k, 0, 0, sx, sy, alpha).apply(null, project(lambda, phi)),
        transform = (alpha ? scaleTranslateRotate : scaleTranslate)(k, x - center[0], y - center[1], sx, sy, alpha);
    rotate = (0,rotation/* rotateRadians */.y)(deltaLambda, deltaPhi, deltaGamma);
    projectTransform = (0,compose/* default */.A)(project, transform);
    projectRotateTransform = (0,compose/* default */.A)(rotate, projectTransform);
    projectResample = resample(projectTransform, delta2);
    return reset();
  }

  function reset() {
    cache = cacheStream = null;
    return projection;
  }

  return function() {
    project = projectAt.apply(this, arguments);
    projection.invert = project.invert && invert;
    return recenter();
  };
}


/***/ }),

/***/ 57949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; },
/* harmony export */   P: function() { return /* binding */ naturalEarth1Raw; }
/* harmony export */ });
/* harmony import */ var _index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94684);
/* harmony import */ var _math_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61323);



function naturalEarth1Raw(lambda, phi) {
  var phi2 = phi * phi, phi4 = phi2 * phi2;
  return [
    lambda * (0.8707 - 0.131979 * phi2 + phi4 * (-0.013791 + phi4 * (0.003971 * phi2 - 0.001529 * phi4))),
    phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4)))
  ];
}

naturalEarth1Raw.invert = function(x, y) {
  var phi = y, i = 25, delta;
  do {
    var phi2 = phi * phi, phi4 = phi2 * phi2;
    phi -= delta = (phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4))) - y) /
        (1.007226 + phi2 * (0.015085 * 3 + phi4 * (-0.044475 * 7 + 0.028874 * 9 * phi2 - 0.005916 * 11 * phi4)));
  } while ((0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .abs */ .tn)(delta) > _math_js__WEBPACK_IMPORTED_MODULE_0__/* .epsilon */ .Ni && --i > 0);
  return [
    x / (0.8707 + (phi2 = phi * phi) * (-0.131979 + phi2 * (-0.013791 + phi2 * phi2 * phi2 * (0.003971 - 0.001529 * phi2)))),
    phi
  ];
};

/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__() {
  return (0,_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(naturalEarth1Raw)
      .scale(175.295);
}


/***/ }),

/***/ 53253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; },
/* harmony export */   x: function() { return /* binding */ orthographicRaw; }
/* harmony export */ });
/* harmony import */ var _math_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61323);
/* harmony import */ var _azimuthal_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57738);
/* harmony import */ var _index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94684);




function orthographicRaw(x, y) {
  return [(0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .cos */ .gn)(y) * (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .sin */ .F8)(x), (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .sin */ .F8)(y)];
}

orthographicRaw.invert = (0,_azimuthal_js__WEBPACK_IMPORTED_MODULE_1__/* .azimuthalInvert */ .I)(_math_js__WEBPACK_IMPORTED_MODULE_0__/* .asin */ .qR);

/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__() {
  return (0,_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(orthographicRaw)
      .scale(249.5)
      .clipAngle(90 + _math_js__WEBPACK_IMPORTED_MODULE_0__/* .epsilon */ .Ni);
}


/***/ }),

/***/ 30915:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; },
/* harmony export */   y: function() { return /* binding */ rotateRadians; }
/* harmony export */ });
/* harmony import */ var _compose_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19057);
/* harmony import */ var _math_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61323);



function rotationIdentity(lambda, phi) {
  return [(0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .abs */ .tn)(lambda) > _math_js__WEBPACK_IMPORTED_MODULE_0__.pi ? lambda + Math.round(-lambda / _math_js__WEBPACK_IMPORTED_MODULE_0__/* .tau */ .FA) * _math_js__WEBPACK_IMPORTED_MODULE_0__/* .tau */ .FA : lambda, phi];
}

rotationIdentity.invert = rotationIdentity;

function rotateRadians(deltaLambda, deltaPhi, deltaGamma) {
  return (deltaLambda %= _math_js__WEBPACK_IMPORTED_MODULE_0__/* .tau */ .FA) ? (deltaPhi || deltaGamma ? (0,_compose_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(rotationLambda(deltaLambda), rotationPhiGamma(deltaPhi, deltaGamma))
    : rotationLambda(deltaLambda))
    : (deltaPhi || deltaGamma ? rotationPhiGamma(deltaPhi, deltaGamma)
    : rotationIdentity);
}

function forwardRotationLambda(deltaLambda) {
  return function(lambda, phi) {
    return lambda += deltaLambda, [lambda > _math_js__WEBPACK_IMPORTED_MODULE_0__.pi ? lambda - _math_js__WEBPACK_IMPORTED_MODULE_0__/* .tau */ .FA : lambda < -_math_js__WEBPACK_IMPORTED_MODULE_0__.pi ? lambda + _math_js__WEBPACK_IMPORTED_MODULE_0__/* .tau */ .FA : lambda, phi];
  };
}

function rotationLambda(deltaLambda) {
  var rotation = forwardRotationLambda(deltaLambda);
  rotation.invert = forwardRotationLambda(-deltaLambda);
  return rotation;
}

function rotationPhiGamma(deltaPhi, deltaGamma) {
  var cosDeltaPhi = (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .cos */ .gn)(deltaPhi),
      sinDeltaPhi = (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .sin */ .F8)(deltaPhi),
      cosDeltaGamma = (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .cos */ .gn)(deltaGamma),
      sinDeltaGamma = (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .sin */ .F8)(deltaGamma);

  function rotation(lambda, phi) {
    var cosPhi = (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .cos */ .gn)(phi),
        x = (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .cos */ .gn)(lambda) * cosPhi,
        y = (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .sin */ .F8)(lambda) * cosPhi,
        z = (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .sin */ .F8)(phi),
        k = z * cosDeltaPhi + x * sinDeltaPhi;
    return [
      (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .atan2 */ .FP)(y * cosDeltaGamma - k * sinDeltaGamma, x * cosDeltaPhi - z * sinDeltaPhi),
      (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .asin */ .qR)(k * cosDeltaGamma + y * sinDeltaGamma)
    ];
  }

  rotation.invert = function(lambda, phi) {
    var cosPhi = (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .cos */ .gn)(phi),
        x = (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .cos */ .gn)(lambda) * cosPhi,
        y = (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .sin */ .F8)(lambda) * cosPhi,
        z = (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .sin */ .F8)(phi),
        k = z * cosDeltaGamma - y * sinDeltaGamma;
    return [
      (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .atan2 */ .FP)(y * cosDeltaGamma + z * sinDeltaGamma, x * cosDeltaPhi + k * sinDeltaPhi),
      (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .asin */ .qR)(k * cosDeltaPhi - x * sinDeltaPhi)
    ];
  };

  return rotation;
}

/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__(rotate) {
  rotate = rotateRadians(rotate[0] * _math_js__WEBPACK_IMPORTED_MODULE_0__/* .radians */ .F2, rotate[1] * _math_js__WEBPACK_IMPORTED_MODULE_0__/* .radians */ .F2, rotate.length > 2 ? rotate[2] * _math_js__WEBPACK_IMPORTED_MODULE_0__/* .radians */ .F2 : 0);

  function forward(coordinates) {
    coordinates = rotate(coordinates[0] * _math_js__WEBPACK_IMPORTED_MODULE_0__/* .radians */ .F2, coordinates[1] * _math_js__WEBPACK_IMPORTED_MODULE_0__/* .radians */ .F2);
    return coordinates[0] *= _math_js__WEBPACK_IMPORTED_MODULE_0__/* .degrees */ .uj, coordinates[1] *= _math_js__WEBPACK_IMPORTED_MODULE_0__/* .degrees */ .uj, coordinates;
  }

  forward.invert = function(coordinates) {
    coordinates = rotate.invert(coordinates[0] * _math_js__WEBPACK_IMPORTED_MODULE_0__/* .radians */ .F2, coordinates[1] * _math_js__WEBPACK_IMPORTED_MODULE_0__/* .radians */ .F2);
    return coordinates[0] *= _math_js__WEBPACK_IMPORTED_MODULE_0__/* .degrees */ .uj, coordinates[1] *= _math_js__WEBPACK_IMPORTED_MODULE_0__/* .degrees */ .uj, coordinates;
  };

  return forward;
}


/***/ }),

/***/ 20465:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
function streamGeometry(geometry, stream) {
  if (geometry && streamGeometryType.hasOwnProperty(geometry.type)) {
    streamGeometryType[geometry.type](geometry, stream);
  }
}

var streamObjectType = {
  Feature: function(object, stream) {
    streamGeometry(object.geometry, stream);
  },
  FeatureCollection: function(object, stream) {
    var features = object.features, i = -1, n = features.length;
    while (++i < n) streamGeometry(features[i].geometry, stream);
  }
};

var streamGeometryType = {
  Sphere: function(object, stream) {
    stream.sphere();
  },
  Point: function(object, stream) {
    object = object.coordinates;
    stream.point(object[0], object[1], object[2]);
  },
  MultiPoint: function(object, stream) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) object = coordinates[i], stream.point(object[0], object[1], object[2]);
  },
  LineString: function(object, stream) {
    streamLine(object.coordinates, stream, 0);
  },
  MultiLineString: function(object, stream) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) streamLine(coordinates[i], stream, 0);
  },
  Polygon: function(object, stream) {
    streamPolygon(object.coordinates, stream);
  },
  MultiPolygon: function(object, stream) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) streamPolygon(coordinates[i], stream);
  },
  GeometryCollection: function(object, stream) {
    var geometries = object.geometries, i = -1, n = geometries.length;
    while (++i < n) streamGeometry(geometries[i], stream);
  }
};

function streamLine(coordinates, stream, closed) {
  var i = -1, n = coordinates.length - closed, coordinate;
  stream.lineStart();
  while (++i < n) coordinate = coordinates[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
  stream.lineEnd();
}

function streamPolygon(coordinates, stream) {
  var i = -1, n = coordinates.length;
  stream.polygonStart();
  while (++i < n) streamLine(coordinates[i], stream, 1);
  stream.polygonEnd();
}

/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__(object, stream) {
  if (object && streamObjectType.hasOwnProperty(object.type)) {
    streamObjectType[object.type](object, stream);
  } else {
    streamGeometry(object, stream);
  }
}


/***/ }),

/***/ 913:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; },
/* harmony export */   G: function() { return /* binding */ transformer; }
/* harmony export */ });
/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__(methods) {
  return {
    stream: transformer(methods)
  };
}

function transformer(methods) {
  return function(stream) {
    var s = new TransformStream;
    for (var key in methods) s[key] = methods[key];
    s.stream = stream;
    return s;
  };
}

function TransformStream() {}

TransformStream.prototype = {
  constructor: TransformStream,
  point: function(x, y) { this.stream.point(x, y); },
  sphere: function() { this.stream.sphere(); },
  lineStart: function() { this.stream.lineStart(); },
  lineEnd: function() { this.stream.lineEnd(); },
  polygonStart: function() { this.stream.polygonStart(); },
  polygonEnd: function() { this.stream.polygonEnd(); }
};


/***/ }),

/***/ 92264:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  cluster: function() { return /* reexport */ cluster; },
  hierarchy: function() { return /* reexport */ hierarchy; },
  pack: function() { return /* reexport */ pack; },
  packEnclose: function() { return /* reexport */ enclose; },
  packSiblings: function() { return /* reexport */ siblings; },
  partition: function() { return /* reexport */ partition; },
  stratify: function() { return /* reexport */ stratify; },
  tree: function() { return /* reexport */ tree; },
  treemap: function() { return /* reexport */ treemap; },
  treemapBinary: function() { return /* reexport */ binary; },
  treemapDice: function() { return /* reexport */ dice; },
  treemapResquarify: function() { return /* reexport */ resquarify; },
  treemapSlice: function() { return /* reexport */ treemap_slice; },
  treemapSliceDice: function() { return /* reexport */ sliceDice; },
  treemapSquarify: function() { return /* reexport */ squarify; }
});

;// CONCATENATED MODULE: ./node_modules/d3-hierarchy/src/cluster.js
function defaultSeparation(a, b) {
  return a.parent === b.parent ? 1 : 2;
}

function meanX(children) {
  return children.reduce(meanXReduce, 0) / children.length;
}

function meanXReduce(x, c) {
  return x + c.x;
}

function maxY(children) {
  return 1 + children.reduce(maxYReduce, 0);
}

function maxYReduce(y, c) {
  return Math.max(y, c.y);
}

function leafLeft(node) {
  var children;
  while (children = node.children) node = children[0];
  return node;
}

function leafRight(node) {
  var children;
  while (children = node.children) node = children[children.length - 1];
  return node;
}

/* harmony default export */ function cluster() {
  var separation = defaultSeparation,
      dx = 1,
      dy = 1,
      nodeSize = false;

  function cluster(root) {
    var previousNode,
        x = 0;

    // First walk, computing the initial x & y values.
    root.eachAfter(function(node) {
      var children = node.children;
      if (children) {
        node.x = meanX(children);
        node.y = maxY(children);
      } else {
        node.x = previousNode ? x += separation(node, previousNode) : 0;
        node.y = 0;
        previousNode = node;
      }
    });

    var left = leafLeft(root),
        right = leafRight(root),
        x0 = left.x - separation(left, right) / 2,
        x1 = right.x + separation(right, left) / 2;

    // Second walk, normalizing x & y to the desired size.
    return root.eachAfter(nodeSize ? function(node) {
      node.x = (node.x - root.x) * dx;
      node.y = (root.y - node.y) * dy;
    } : function(node) {
      node.x = (node.x - x0) / (x1 - x0) * dx;
      node.y = (1 - (root.y ? node.y / root.y : 1)) * dy;
    });
  }

  cluster.separation = function(x) {
    return arguments.length ? (separation = x, cluster) : separation;
  };

  cluster.size = function(x) {
    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], cluster) : (nodeSize ? null : [dx, dy]);
  };

  cluster.nodeSize = function(x) {
    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], cluster) : (nodeSize ? [dx, dy] : null);
  };

  return cluster;
}

;// CONCATENATED MODULE: ./node_modules/d3-hierarchy/src/hierarchy/count.js
function count(node) {
  var sum = 0,
      children = node.children,
      i = children && children.length;
  if (!i) sum = 1;
  else while (--i >= 0) sum += children[i].value;
  node.value = sum;
}

/* harmony default export */ function hierarchy_count() {
  return this.eachAfter(count);
}

;// CONCATENATED MODULE: ./node_modules/d3-hierarchy/src/hierarchy/each.js
/* harmony default export */ function each(callback) {
  var node = this, current, next = [node], children, i, n;
  do {
    current = next.reverse(), next = [];
    while (node = current.pop()) {
      callback(node), children = node.children;
      if (children) for (i = 0, n = children.length; i < n; ++i) {
        next.push(children[i]);
      }
    }
  } while (next.length);
  return this;
}

;// CONCATENATED MODULE: ./node_modules/d3-hierarchy/src/hierarchy/eachBefore.js
/* harmony default export */ function eachBefore(callback) {
  var node = this, nodes = [node], children, i;
  while (node = nodes.pop()) {
    callback(node), children = node.children;
    if (children) for (i = children.length - 1; i >= 0; --i) {
      nodes.push(children[i]);
    }
  }
  return this;
}

;// CONCATENATED MODULE: ./node_modules/d3-hierarchy/src/hierarchy/eachAfter.js
/* harmony default export */ function eachAfter(callback) {
  var node = this, nodes = [node], next = [], children, i, n;
  while (node = nodes.pop()) {
    next.push(node), children = node.children;
    if (children) for (i = 0, n = children.length; i < n; ++i) {
      nodes.push(children[i]);
    }
  }
  while (node = next.pop()) {
    callback(node);
  }
  return this;
}

;// CONCATENATED MODULE: ./node_modules/d3-hierarchy/src/hierarchy/sum.js
/* harmony default export */ function sum(value) {
  return this.eachAfter(function(node) {
    var sum = +value(node.data) || 0,
        children = node.children,
        i = children && children.length;
    while (--i >= 0) sum += children[i].value;
    node.value = sum;
  });
}

;// CONCATENATED MODULE: ./node_modules/d3-hierarchy/src/hierarchy/sort.js
/* harmony default export */ function sort(compare) {
  return this.eachBefore(function(node) {
    if (node.children) {
      node.children.sort(compare);
    }
  });
}

;// CONCATENATED MODULE: ./node_modules/d3-hierarchy/src/hierarchy/path.js
/* harmony default export */ function path(end) {
  var start = this,
      ancestor = leastCommonAncestor(start, end),
      nodes = [start];
  while (start !== ancestor) {
    start = start.parent;
    nodes.push(start);
  }
  var k = nodes.length;
  while (end !== ancestor) {
    nodes.splice(k, 0, end);
    end = end.parent;
  }
  return nodes;
}

function leastCommonAncestor(a, b) {
  if (a === b) return a;
  var aNodes = a.ancestors(),
      bNodes = b.ancestors(),
      c = null;
  a = aNodes.pop();
  b = bNodes.pop();
  while (a === b) {
    c = a;
    a = aNodes.pop();
    b = bNodes.pop();
  }
  return c;
}

;// CONCATENATED MODULE: ./node_modules/d3-hierarchy/src/hierarchy/ancestors.js
/* harmony default export */ function ancestors() {
  var node = this, nodes = [node];
  while (node = node.parent) {
    nodes.push(node);
  }
  return nodes;
}

;// CONCATENATED MODULE: ./node_modules/d3-hierarchy/src/hierarchy/descendants.js
/* harmony default export */ function descendants() {
  var nodes = [];
  this.each(function(node) {
    nodes.push(node);
  });
  return nodes;
}

;// CONCATENATED MODULE: ./node_modules/d3-hierarchy/src/hierarchy/leaves.js
/* harmony default export */ function leaves() {
  var leaves = [];
  this.eachBefore(function(node) {
    if (!node.children) {
      leaves.push(node);
    }
  });
  return leaves;
}

;// CONCATENATED MODULE: ./node_modules/d3-hierarchy/src/hierarchy/links.js
/* harmony default export */ function links() {
  var root = this, links = [];
  root.each(function(node) {
    if (node !== root) { // Don’t include the root’s parent, if any.
      links.push({source: node.parent, target: node});
    }
  });
  return links;
}

;// CONCATENATED MODULE: ./node_modules/d3-hierarchy/src/hierarchy/index.js












function hierarchy(data, children) {
  var root = new Node(data),
      valued = +data.value && (root.value = data.value),
      node,
      nodes = [root],
      child,
      childs,
      i,
      n;

  if (children == null) children = defaultChildren;

  while (node = nodes.pop()) {
    if (valued) node.value = +node.data.value;
    if ((childs = children(node.data)) && (n = childs.length)) {
      node.children = new Array(n);
      for (i = n - 1; i >= 0; --i) {
        nodes.push(child = node.children[i] = new Node(childs[i]));
        child.parent = node;
        child.depth = node.depth + 1;
      }
    }
  }

  return root.eachBefore(computeHeight);
}

function node_copy() {
  return hierarchy(this).eachBefore(copyData);
}

function defaultChildren(d) {
  return d.children;
}

function copyData(node) {
  node.data = node.data.data;
}

function computeHeight(node) {
  var height = 0;
  do node.height = height;
  while ((node = node.parent) && (node.height < ++height));
}

function Node(data) {
  this.data = data;
  this.depth =
  this.height = 0;
  this.parent = null;
}

Node.prototype = hierarchy.prototype = {
  constructor: Node,
  count: hierarchy_count,
  each: each,
  eachAfter: eachAfter,
  eachBefore: eachBefore,
  sum: sum,
  sort: sort,
  path: path,
  ancestors: ancestors,
  descendants: descendants,
  leaves: leaves,
  links: links,
  copy: node_copy
};

;// CONCATENATED MODULE: ./node_modules/d3-hierarchy/src/array.js
var slice = Array.prototype.slice;

function shuffle(array) {
  var m = array.length,
      t,
      i;

  while (m) {
    i = Math.random() * m-- | 0;
    t = array[m];
    array[m] = array[i];
    array[i] = t;
  }

  return array;
}

;// CONCATENATED MODULE: ./node_modules/d3-hierarchy/src/pack/enclose.js


/* harmony default export */ function enclose(circles) {
  var i = 0, n = (circles = shuffle(slice.call(circles))).length, B = [], p, e;

  while (i < n) {
    p = circles[i];
    if (e && enclosesWeak(e, p)) ++i;
    else e = encloseBasis(B = extendBasis(B, p)), i = 0;
  }

  return e;
}

function extendBasis(B, p) {
  var i, j;

  if (enclosesWeakAll(p, B)) return [p];

  // If we get here then B must have at least one element.
  for (i = 0; i < B.length; ++i) {
    if (enclosesNot(p, B[i])
        && enclosesWeakAll(encloseBasis2(B[i], p), B)) {
      return [B[i], p];
    }
  }

  // If we get here then B must have at least two elements.
  for (i = 0; i < B.length - 1; ++i) {
    for (j = i + 1; j < B.length; ++j) {
      if (enclosesNot(encloseBasis2(B[i], B[j]), p)
          && enclosesNot(encloseBasis2(B[i], p), B[j])
          && enclosesNot(encloseBasis2(B[j], p), B[i])
          && enclosesWeakAll(encloseBasis3(B[i], B[j], p), B)) {
        return [B[i], B[j], p];
      }
    }
  }

  // If we get here then something is very wrong.
  throw new Error;
}

function enclosesNot(a, b) {
  var dr = a.r - b.r, dx = b.x - a.x, dy = b.y - a.y;
  return dr < 0 || dr * dr < dx * dx + dy * dy;
}

function enclosesWeak(a, b) {
  var dr = a.r - b.r + 1e-6, dx = b.x - a.x, dy = b.y - a.y;
  return dr > 0 && dr * dr > dx * dx + dy * dy;
}

function enclosesWeakAll(a, B) {
  for (var i = 0; i < B.length; ++i) {
    if (!enclosesWeak(a, B[i])) {
      return false;
    }
  }
  return true;
}

function encloseBasis(B) {
  switch (B.length) {
    case 1: return encloseBasis1(B[0]);
    case 2: return encloseBasis2(B[0], B[1]);
    case 3: return encloseBasis3(B[0], B[1], B[2]);
  }
}

function encloseBasis1(a) {
  return {
    x: a.x,
    y: a.y,
    r: a.r
  };
}

function encloseBasis2(a, b) {
  var x1 = a.x, y1 = a.y, r1 = a.r,
      x2 = b.x, y2 = b.y, r2 = b.r,
      x21 = x2 - x1, y21 = y2 - y1, r21 = r2 - r1,
      l = Math.sqrt(x21 * x21 + y21 * y21);
  return {
    x: (x1 + x2 + x21 / l * r21) / 2,
    y: (y1 + y2 + y21 / l * r21) / 2,
    r: (l + r1 + r2) / 2
  };
}

function encloseBasis3(a, b, c) {
  var x1 = a.x, y1 = a.y, r1 = a.r,
      x2 = b.x, y2 = b.y, r2 = b.r,
      x3 = c.x, y3 = c.y, r3 = c.r,
      a2 = x1 - x2,
      a3 = x1 - x3,
      b2 = y1 - y2,
      b3 = y1 - y3,
      c2 = r2 - r1,
      c3 = r3 - r1,
      d1 = x1 * x1 + y1 * y1 - r1 * r1,
      d2 = d1 - x2 * x2 - y2 * y2 + r2 * r2,
      d3 = d1 - x3 * x3 - y3 * y3 + r3 * r3,
      ab = a3 * b2 - a2 * b3,
      xa = (b2 * d3 - b3 * d2) / (ab * 2) - x1,
      xb = (b3 * c2 - b2 * c3) / ab,
      ya = (a3 * d2 - a2 * d3) / (ab * 2) - y1,
      yb = (a2 * c3 - a3 * c2) / ab,
      A = xb * xb + yb * yb - 1,
      B = 2 * (r1 + xa * xb + ya * yb),
      C = xa * xa + ya * ya - r1 * r1,
      r = -(A ? (B + Math.sqrt(B * B - 4 * A * C)) / (2 * A) : C / B);
  return {
    x: x1 + xa + xb * r,
    y: y1 + ya + yb * r,
    r: r
  };
}

;// CONCATENATED MODULE: ./node_modules/d3-hierarchy/src/pack/siblings.js


function place(b, a, c) {
  var dx = b.x - a.x, x, a2,
      dy = b.y - a.y, y, b2,
      d2 = dx * dx + dy * dy;
  if (d2) {
    a2 = a.r + c.r, a2 *= a2;
    b2 = b.r + c.r, b2 *= b2;
    if (a2 > b2) {
      x = (d2 + b2 - a2) / (2 * d2);
      y = Math.sqrt(Math.max(0, b2 / d2 - x * x));
      c.x = b.x - x * dx - y * dy;
      c.y = b.y - x * dy + y * dx;
    } else {
      x = (d2 + a2 - b2) / (2 * d2);
      y = Math.sqrt(Math.max(0, a2 / d2 - x * x));
      c.x = a.x + x * dx - y * dy;
      c.y = a.y + x * dy + y * dx;
    }
  } else {
    c.x = a.x + c.r;
    c.y = a.y;
  }
}

function intersects(a, b) {
  var dr = a.r + b.r - 1e-6, dx = b.x - a.x, dy = b.y - a.y;
  return dr > 0 && dr * dr > dx * dx + dy * dy;
}

function score(node) {
  var a = node._,
      b = node.next._,
      ab = a.r + b.r,
      dx = (a.x * b.r + b.x * a.r) / ab,
      dy = (a.y * b.r + b.y * a.r) / ab;
  return dx * dx + dy * dy;
}

function siblings_Node(circle) {
  this._ = circle;
  this.next = null;
  this.previous = null;
}

function packEnclose(circles) {
  if (!(n = circles.length)) return 0;

  var a, b, c, n, aa, ca, i, j, k, sj, sk;

  // Place the first circle.
  a = circles[0], a.x = 0, a.y = 0;
  if (!(n > 1)) return a.r;

  // Place the second circle.
  b = circles[1], a.x = -b.r, b.x = a.r, b.y = 0;
  if (!(n > 2)) return a.r + b.r;

  // Place the third circle.
  place(b, a, c = circles[2]);

  // Initialize the front-chain using the first three circles a, b and c.
  a = new siblings_Node(a), b = new siblings_Node(b), c = new siblings_Node(c);
  a.next = c.previous = b;
  b.next = a.previous = c;
  c.next = b.previous = a;

  // Attempt to place each remaining circle…
  pack: for (i = 3; i < n; ++i) {
    place(a._, b._, c = circles[i]), c = new siblings_Node(c);

    // Find the closest intersecting circle on the front-chain, if any.
    // “Closeness” is determined by linear distance along the front-chain.
    // “Ahead” or “behind” is likewise determined by linear distance.
    j = b.next, k = a.previous, sj = b._.r, sk = a._.r;
    do {
      if (sj <= sk) {
        if (intersects(j._, c._)) {
          b = j, a.next = b, b.previous = a, --i;
          continue pack;
        }
        sj += j._.r, j = j.next;
      } else {
        if (intersects(k._, c._)) {
          a = k, a.next = b, b.previous = a, --i;
          continue pack;
        }
        sk += k._.r, k = k.previous;
      }
    } while (j !== k.next);

    // Success! Insert the new circle c between a and b.
    c.previous = a, c.next = b, a.next = b.previous = b = c;

    // Compute the new closest circle pair to the centroid.
    aa = score(a);
    while ((c = c.next) !== b) {
      if ((ca = score(c)) < aa) {
        a = c, aa = ca;
      }
    }
    b = a.next;
  }

  // Compute the enclosing circle of the front chain.
  a = [b._], c = b; while ((c = c.next) !== b) a.push(c._); c = enclose(a);

  // Translate the circles to put the enclosing circle around the origin.
  for (i = 0; i < n; ++i) a = circles[i], a.x -= c.x, a.y -= c.y;

  return c.r;
}

/* harmony default export */ function siblings(circles) {
  packEnclose(circles);
  return circles;
}

;// CONCATENATED MODULE: ./node_modules/d3-hierarchy/src/accessors.js
function optional(f) {
  return f == null ? null : required(f);
}

function required(f) {
  if (typeof f !== "function") throw new Error;
  return f;
}

;// CONCATENATED MODULE: ./node_modules/d3-hierarchy/src/constant.js
function constantZero() {
  return 0;
}

/* harmony default export */ function constant(x) {
  return function() {
    return x;
  };
}

;// CONCATENATED MODULE: ./node_modules/d3-hierarchy/src/pack/index.js




function defaultRadius(d) {
  return Math.sqrt(d.value);
}

/* harmony default export */ function pack() {
  var radius = null,
      dx = 1,
      dy = 1,
      padding = constantZero;

  function pack(root) {
    root.x = dx / 2, root.y = dy / 2;
    if (radius) {
      root.eachBefore(radiusLeaf(radius))
          .eachAfter(packChildren(padding, 0.5))
          .eachBefore(translateChild(1));
    } else {
      root.eachBefore(radiusLeaf(defaultRadius))
          .eachAfter(packChildren(constantZero, 1))
          .eachAfter(packChildren(padding, root.r / Math.min(dx, dy)))
          .eachBefore(translateChild(Math.min(dx, dy) / (2 * root.r)));
    }
    return root;
  }

  pack.radius = function(x) {
    return arguments.length ? (radius = optional(x), pack) : radius;
  };

  pack.size = function(x) {
    return arguments.length ? (dx = +x[0], dy = +x[1], pack) : [dx, dy];
  };

  pack.padding = function(x) {
    return arguments.length ? (padding = typeof x === "function" ? x : constant(+x), pack) : padding;
  };

  return pack;
}

function radiusLeaf(radius) {
  return function(node) {
    if (!node.children) {
      node.r = Math.max(0, +radius(node) || 0);
    }
  };
}

function packChildren(padding, k) {
  return function(node) {
    if (children = node.children) {
      var children,
          i,
          n = children.length,
          r = padding(node) * k || 0,
          e;

      if (r) for (i = 0; i < n; ++i) children[i].r += r;
      e = packEnclose(children);
      if (r) for (i = 0; i < n; ++i) children[i].r -= r;
      node.r = e + r;
    }
  };
}

function translateChild(k) {
  return function(node) {
    var parent = node.parent;
    node.r *= k;
    if (parent) {
      node.x = parent.x + k * node.x;
      node.y = parent.y + k * node.y;
    }
  };
}

;// CONCATENATED MODULE: ./node_modules/d3-hierarchy/src/treemap/round.js
/* harmony default export */ function treemap_round(node) {
  node.x0 = Math.round(node.x0);
  node.y0 = Math.round(node.y0);
  node.x1 = Math.round(node.x1);
  node.y1 = Math.round(node.y1);
}

;// CONCATENATED MODULE: ./node_modules/d3-hierarchy/src/treemap/dice.js
/* harmony default export */ function dice(parent, x0, y0, x1, y1) {
  var nodes = parent.children,
      node,
      i = -1,
      n = nodes.length,
      k = parent.value && (x1 - x0) / parent.value;

  while (++i < n) {
    node = nodes[i], node.y0 = y0, node.y1 = y1;
    node.x0 = x0, node.x1 = x0 += node.value * k;
  }
}

;// CONCATENATED MODULE: ./node_modules/d3-hierarchy/src/partition.js



/* harmony default export */ function partition() {
  var dx = 1,
      dy = 1,
      padding = 0,
      round = false;

  function partition(root) {
    var n = root.height + 1;
    root.x0 =
    root.y0 = padding;
    root.x1 = dx;
    root.y1 = dy / n;
    root.eachBefore(positionNode(dy, n));
    if (round) root.eachBefore(treemap_round);
    return root;
  }

  function positionNode(dy, n) {
    return function(node) {
      if (node.children) {
        dice(node, node.x0, dy * (node.depth + 1) / n, node.x1, dy * (node.depth + 2) / n);
      }
      var x0 = node.x0,
          y0 = node.y0,
          x1 = node.x1 - padding,
          y1 = node.y1 - padding;
      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
      node.x0 = x0;
      node.y0 = y0;
      node.x1 = x1;
      node.y1 = y1;
    };
  }

  partition.round = function(x) {
    return arguments.length ? (round = !!x, partition) : round;
  };

  partition.size = function(x) {
    return arguments.length ? (dx = +x[0], dy = +x[1], partition) : [dx, dy];
  };

  partition.padding = function(x) {
    return arguments.length ? (padding = +x, partition) : padding;
  };

  return partition;
}

;// CONCATENATED MODULE: ./node_modules/d3-hierarchy/src/stratify.js



var keyPrefix = "$", // Protect against keys like “__proto__”.
    preroot = {depth: -1},
    ambiguous = {};

function defaultId(d) {
  return d.id;
}

function defaultParentId(d) {
  return d.parentId;
}

/* harmony default export */ function stratify() {
  var id = defaultId,
      parentId = defaultParentId;

  function stratify(data) {
    var d,
        i,
        n = data.length,
        root,
        parent,
        node,
        nodes = new Array(n),
        nodeId,
        nodeKey,
        nodeByKey = {};

    for (i = 0; i < n; ++i) {
      d = data[i], node = nodes[i] = new Node(d);
      if ((nodeId = id(d, i, data)) != null && (nodeId += "")) {
        nodeKey = keyPrefix + (node.id = nodeId);
        nodeByKey[nodeKey] = nodeKey in nodeByKey ? ambiguous : node;
      }
    }

    for (i = 0; i < n; ++i) {
      node = nodes[i], nodeId = parentId(data[i], i, data);
      if (nodeId == null || !(nodeId += "")) {
        if (root) throw new Error("multiple roots");
        root = node;
      } else {
        parent = nodeByKey[keyPrefix + nodeId];
        if (!parent) throw new Error("missing: " + nodeId);
        if (parent === ambiguous) throw new Error("ambiguous: " + nodeId);
        if (parent.children) parent.children.push(node);
        else parent.children = [node];
        node.parent = parent;
      }
    }

    if (!root) throw new Error("no root");
    root.parent = preroot;
    root.eachBefore(function(node) { node.depth = node.parent.depth + 1; --n; }).eachBefore(computeHeight);
    root.parent = null;
    if (n > 0) throw new Error("cycle");

    return root;
  }

  stratify.id = function(x) {
    return arguments.length ? (id = required(x), stratify) : id;
  };

  stratify.parentId = function(x) {
    return arguments.length ? (parentId = required(x), stratify) : parentId;
  };

  return stratify;
}

;// CONCATENATED MODULE: ./node_modules/d3-hierarchy/src/tree.js


function tree_defaultSeparation(a, b) {
  return a.parent === b.parent ? 1 : 2;
}

// function radialSeparation(a, b) {
//   return (a.parent === b.parent ? 1 : 2) / a.depth;
// }

// This function is used to traverse the left contour of a subtree (or
// subforest). It returns the successor of v on this contour. This successor is
// either given by the leftmost child of v or by the thread of v. The function
// returns null if and only if v is on the highest level of its subtree.
function nextLeft(v) {
  var children = v.children;
  return children ? children[0] : v.t;
}

// This function works analogously to nextLeft.
function nextRight(v) {
  var children = v.children;
  return children ? children[children.length - 1] : v.t;
}

// Shifts the current subtree rooted at w+. This is done by increasing
// prelim(w+) and mod(w+) by shift.
function moveSubtree(wm, wp, shift) {
  var change = shift / (wp.i - wm.i);
  wp.c -= change;
  wp.s += shift;
  wm.c += change;
  wp.z += shift;
  wp.m += shift;
}

// All other shifts, applied to the smaller subtrees between w- and w+, are
// performed by this function. To prepare the shifts, we have to adjust
// change(w+), shift(w+), and change(w-).
function executeShifts(v) {
  var shift = 0,
      change = 0,
      children = v.children,
      i = children.length,
      w;
  while (--i >= 0) {
    w = children[i];
    w.z += shift;
    w.m += shift;
    shift += w.s + (change += w.c);
  }
}

// If vi-’s ancestor is a sibling of v, returns vi-’s ancestor. Otherwise,
// returns the specified (default) ancestor.
function nextAncestor(vim, v, ancestor) {
  return vim.a.parent === v.parent ? vim.a : ancestor;
}

function TreeNode(node, i) {
  this._ = node;
  this.parent = null;
  this.children = null;
  this.A = null; // default ancestor
  this.a = this; // ancestor
  this.z = 0; // prelim
  this.m = 0; // mod
  this.c = 0; // change
  this.s = 0; // shift
  this.t = null; // thread
  this.i = i; // number
}

TreeNode.prototype = Object.create(Node.prototype);

function treeRoot(root) {
  var tree = new TreeNode(root, 0),
      node,
      nodes = [tree],
      child,
      children,
      i,
      n;

  while (node = nodes.pop()) {
    if (children = node._.children) {
      node.children = new Array(n = children.length);
      for (i = n - 1; i >= 0; --i) {
        nodes.push(child = node.children[i] = new TreeNode(children[i], i));
        child.parent = node;
      }
    }
  }

  (tree.parent = new TreeNode(null, 0)).children = [tree];
  return tree;
}

// Node-link tree diagram using the Reingold-Tilford "tidy" algorithm
/* harmony default export */ function tree() {
  var separation = tree_defaultSeparation,
      dx = 1,
      dy = 1,
      nodeSize = null;

  function tree(root) {
    var t = treeRoot(root);

    // Compute the layout using Buchheim et al.’s algorithm.
    t.eachAfter(firstWalk), t.parent.m = -t.z;
    t.eachBefore(secondWalk);

    // If a fixed node size is specified, scale x and y.
    if (nodeSize) root.eachBefore(sizeNode);

    // If a fixed tree size is specified, scale x and y based on the extent.
    // Compute the left-most, right-most, and depth-most nodes for extents.
    else {
      var left = root,
          right = root,
          bottom = root;
      root.eachBefore(function(node) {
        if (node.x < left.x) left = node;
        if (node.x > right.x) right = node;
        if (node.depth > bottom.depth) bottom = node;
      });
      var s = left === right ? 1 : separation(left, right) / 2,
          tx = s - left.x,
          kx = dx / (right.x + s + tx),
          ky = dy / (bottom.depth || 1);
      root.eachBefore(function(node) {
        node.x = (node.x + tx) * kx;
        node.y = node.depth * ky;
      });
    }

    return root;
  }

  // Computes a preliminary x-coordinate for v. Before that, FIRST WALK is
  // applied recursively to the children of v, as well as the function
  // APPORTION. After spacing out the children by calling EXECUTE SHIFTS, the
  // node v is placed to the midpoint of its outermost children.
  function firstWalk(v) {
    var children = v.children,
        siblings = v.parent.children,
        w = v.i ? siblings[v.i - 1] : null;
    if (children) {
      executeShifts(v);
      var midpoint = (children[0].z + children[children.length - 1].z) / 2;
      if (w) {
        v.z = w.z + separation(v._, w._);
        v.m = v.z - midpoint;
      } else {
        v.z = midpoint;
      }
    } else if (w) {
      v.z = w.z + separation(v._, w._);
    }
    v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
  }

  // Computes all real x-coordinates by summing up the modifiers recursively.
  function secondWalk(v) {
    v._.x = v.z + v.parent.m;
    v.m += v.parent.m;
  }

  // The core of the algorithm. Here, a new subtree is combined with the
  // previous subtrees. Threads are used to traverse the inside and outside
  // contours of the left and right subtree up to the highest common level. The
  // vertices used for the traversals are vi+, vi-, vo-, and vo+, where the
  // superscript o means outside and i means inside, the subscript - means left
  // subtree and + means right subtree. For summing up the modifiers along the
  // contour, we use respective variables si+, si-, so-, and so+. Whenever two
  // nodes of the inside contours conflict, we compute the left one of the
  // greatest uncommon ancestors using the function ANCESTOR and call MOVE
  // SUBTREE to shift the subtree and prepare the shifts of smaller subtrees.
  // Finally, we add a new thread (if necessary).
  function apportion(v, w, ancestor) {
    if (w) {
      var vip = v,
          vop = v,
          vim = w,
          vom = vip.parent.children[0],
          sip = vip.m,
          sop = vop.m,
          sim = vim.m,
          som = vom.m,
          shift;
      while (vim = nextRight(vim), vip = nextLeft(vip), vim && vip) {
        vom = nextLeft(vom);
        vop = nextRight(vop);
        vop.a = v;
        shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
        if (shift > 0) {
          moveSubtree(nextAncestor(vim, v, ancestor), v, shift);
          sip += shift;
          sop += shift;
        }
        sim += vim.m;
        sip += vip.m;
        som += vom.m;
        sop += vop.m;
      }
      if (vim && !nextRight(vop)) {
        vop.t = vim;
        vop.m += sim - sop;
      }
      if (vip && !nextLeft(vom)) {
        vom.t = vip;
        vom.m += sip - som;
        ancestor = v;
      }
    }
    return ancestor;
  }

  function sizeNode(node) {
    node.x *= dx;
    node.y = node.depth * dy;
  }

  tree.separation = function(x) {
    return arguments.length ? (separation = x, tree) : separation;
  };

  tree.size = function(x) {
    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], tree) : (nodeSize ? null : [dx, dy]);
  };

  tree.nodeSize = function(x) {
    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], tree) : (nodeSize ? [dx, dy] : null);
  };

  return tree;
}

;// CONCATENATED MODULE: ./node_modules/d3-hierarchy/src/treemap/slice.js
/* harmony default export */ function treemap_slice(parent, x0, y0, x1, y1) {
  var nodes = parent.children,
      node,
      i = -1,
      n = nodes.length,
      k = parent.value && (y1 - y0) / parent.value;

  while (++i < n) {
    node = nodes[i], node.x0 = x0, node.x1 = x1;
    node.y0 = y0, node.y1 = y0 += node.value * k;
  }
}

;// CONCATENATED MODULE: ./node_modules/d3-hierarchy/src/treemap/squarify.js



var phi = (1 + Math.sqrt(5)) / 2;

function squarifyRatio(ratio, parent, x0, y0, x1, y1) {
  var rows = [],
      nodes = parent.children,
      row,
      nodeValue,
      i0 = 0,
      i1 = 0,
      n = nodes.length,
      dx, dy,
      value = parent.value,
      sumValue,
      minValue,
      maxValue,
      newRatio,
      minRatio,
      alpha,
      beta;

  while (i0 < n) {
    dx = x1 - x0, dy = y1 - y0;

    // Find the next non-empty node.
    do sumValue = nodes[i1++].value; while (!sumValue && i1 < n);
    minValue = maxValue = sumValue;
    alpha = Math.max(dy / dx, dx / dy) / (value * ratio);
    beta = sumValue * sumValue * alpha;
    minRatio = Math.max(maxValue / beta, beta / minValue);

    // Keep adding nodes while the aspect ratio maintains or improves.
    for (; i1 < n; ++i1) {
      sumValue += nodeValue = nodes[i1].value;
      if (nodeValue < minValue) minValue = nodeValue;
      if (nodeValue > maxValue) maxValue = nodeValue;
      beta = sumValue * sumValue * alpha;
      newRatio = Math.max(maxValue / beta, beta / minValue);
      if (newRatio > minRatio) { sumValue -= nodeValue; break; }
      minRatio = newRatio;
    }

    // Position and record the row orientation.
    rows.push(row = {value: sumValue, dice: dx < dy, children: nodes.slice(i0, i1)});
    if (row.dice) dice(row, x0, y0, x1, value ? y0 += dy * sumValue / value : y1);
    else treemap_slice(row, x0, y0, value ? x0 += dx * sumValue / value : x1, y1);
    value -= sumValue, i0 = i1;
  }

  return rows;
}

/* harmony default export */ var squarify = ((function custom(ratio) {

  function squarify(parent, x0, y0, x1, y1) {
    squarifyRatio(ratio, parent, x0, y0, x1, y1);
  }

  squarify.ratio = function(x) {
    return custom((x = +x) > 1 ? x : 1);
  };

  return squarify;
})(phi));

;// CONCATENATED MODULE: ./node_modules/d3-hierarchy/src/treemap/index.js





/* harmony default export */ function treemap() {
  var tile = squarify,
      round = false,
      dx = 1,
      dy = 1,
      paddingStack = [0],
      paddingInner = constantZero,
      paddingTop = constantZero,
      paddingRight = constantZero,
      paddingBottom = constantZero,
      paddingLeft = constantZero;

  function treemap(root) {
    root.x0 =
    root.y0 = 0;
    root.x1 = dx;
    root.y1 = dy;
    root.eachBefore(positionNode);
    paddingStack = [0];
    if (round) root.eachBefore(treemap_round);
    return root;
  }

  function positionNode(node) {
    var p = paddingStack[node.depth],
        x0 = node.x0 + p,
        y0 = node.y0 + p,
        x1 = node.x1 - p,
        y1 = node.y1 - p;
    if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
    if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
    node.x0 = x0;
    node.y0 = y0;
    node.x1 = x1;
    node.y1 = y1;
    if (node.children) {
      p = paddingStack[node.depth + 1] = paddingInner(node) / 2;
      x0 += paddingLeft(node) - p;
      y0 += paddingTop(node) - p;
      x1 -= paddingRight(node) - p;
      y1 -= paddingBottom(node) - p;
      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
      tile(node, x0, y0, x1, y1);
    }
  }

  treemap.round = function(x) {
    return arguments.length ? (round = !!x, treemap) : round;
  };

  treemap.size = function(x) {
    return arguments.length ? (dx = +x[0], dy = +x[1], treemap) : [dx, dy];
  };

  treemap.tile = function(x) {
    return arguments.length ? (tile = required(x), treemap) : tile;
  };

  treemap.padding = function(x) {
    return arguments.length ? treemap.paddingInner(x).paddingOuter(x) : treemap.paddingInner();
  };

  treemap.paddingInner = function(x) {
    return arguments.length ? (paddingInner = typeof x === "function" ? x : constant(+x), treemap) : paddingInner;
  };

  treemap.paddingOuter = function(x) {
    return arguments.length ? treemap.paddingTop(x).paddingRight(x).paddingBottom(x).paddingLeft(x) : treemap.paddingTop();
  };

  treemap.paddingTop = function(x) {
    return arguments.length ? (paddingTop = typeof x === "function" ? x : constant(+x), treemap) : paddingTop;
  };

  treemap.paddingRight = function(x) {
    return arguments.length ? (paddingRight = typeof x === "function" ? x : constant(+x), treemap) : paddingRight;
  };

  treemap.paddingBottom = function(x) {
    return arguments.length ? (paddingBottom = typeof x === "function" ? x : constant(+x), treemap) : paddingBottom;
  };

  treemap.paddingLeft = function(x) {
    return arguments.length ? (paddingLeft = typeof x === "function" ? x : constant(+x), treemap) : paddingLeft;
  };

  return treemap;
}

;// CONCATENATED MODULE: ./node_modules/d3-hierarchy/src/treemap/binary.js
/* harmony default export */ function binary(parent, x0, y0, x1, y1) {
  var nodes = parent.children,
      i, n = nodes.length,
      sum, sums = new Array(n + 1);

  for (sums[0] = sum = i = 0; i < n; ++i) {
    sums[i + 1] = sum += nodes[i].value;
  }

  partition(0, n, parent.value, x0, y0, x1, y1);

  function partition(i, j, value, x0, y0, x1, y1) {
    if (i >= j - 1) {
      var node = nodes[i];
      node.x0 = x0, node.y0 = y0;
      node.x1 = x1, node.y1 = y1;
      return;
    }

    var valueOffset = sums[i],
        valueTarget = (value / 2) + valueOffset,
        k = i + 1,
        hi = j - 1;

    while (k < hi) {
      var mid = k + hi >>> 1;
      if (sums[mid] < valueTarget) k = mid + 1;
      else hi = mid;
    }

    if ((valueTarget - sums[k - 1]) < (sums[k] - valueTarget) && i + 1 < k) --k;

    var valueLeft = sums[k] - valueOffset,
        valueRight = value - valueLeft;

    if ((x1 - x0) > (y1 - y0)) {
      var xk = (x0 * valueRight + x1 * valueLeft) / value;
      partition(i, k, valueLeft, x0, y0, xk, y1);
      partition(k, j, valueRight, xk, y0, x1, y1);
    } else {
      var yk = (y0 * valueRight + y1 * valueLeft) / value;
      partition(i, k, valueLeft, x0, y0, x1, yk);
      partition(k, j, valueRight, x0, yk, x1, y1);
    }
  }
}

;// CONCATENATED MODULE: ./node_modules/d3-hierarchy/src/treemap/sliceDice.js



/* harmony default export */ function sliceDice(parent, x0, y0, x1, y1) {
  (parent.depth & 1 ? treemap_slice : dice)(parent, x0, y0, x1, y1);
}

;// CONCATENATED MODULE: ./node_modules/d3-hierarchy/src/treemap/resquarify.js




/* harmony default export */ var resquarify = ((function custom(ratio) {

  function resquarify(parent, x0, y0, x1, y1) {
    if ((rows = parent._squarify) && (rows.ratio === ratio)) {
      var rows,
          row,
          nodes,
          i,
          j = -1,
          n,
          m = rows.length,
          value = parent.value;

      while (++j < m) {
        row = rows[j], nodes = row.children;
        for (i = row.value = 0, n = nodes.length; i < n; ++i) row.value += nodes[i].value;
        if (row.dice) dice(row, x0, y0, x1, y0 += (y1 - y0) * row.value / value);
        else treemap_slice(row, x0, y0, x0 += (x1 - x0) * row.value / value, y1);
        value -= row.value;
      }
    } else {
      parent._squarify = rows = squarifyRatio(ratio, parent, x0, y0, x1, y1);
      rows.ratio = ratio;
    }
  }

  resquarify.ratio = function(x) {
    return custom((x = +x) > 1 ? x : 1);
  };

  return resquarify;
})(phi));

;// CONCATENATED MODULE: ./node_modules/d3-hierarchy/src/index.js

















/***/ }),

/***/ 48544:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  pq: function() { return /* binding */ linkHorizontal; }
});

// UNUSED EXPORTS: linkRadial, linkVertical

;// CONCATENATED MODULE: ./node_modules/d3-path/src/path.js
var pi = Math.PI,
    tau = 2 * pi,
    epsilon = 1e-6,
    tauEpsilon = tau - epsilon;

function Path() {
  this._x0 = this._y0 = // start of current subpath
  this._x1 = this._y1 = null; // end of current subpath
  this._ = "";
}

function path() {
  return new Path;
}

Path.prototype = path.prototype = {
  constructor: Path,
  moveTo: function(x, y) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
  },
  closePath: function() {
    if (this._x1 !== null) {
      this._x1 = this._x0, this._y1 = this._y0;
      this._ += "Z";
    }
  },
  lineTo: function(x, y) {
    this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  quadraticCurveTo: function(x1, y1, x, y) {
    this._ += "Q" + (+x1) + "," + (+y1) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  bezierCurveTo: function(x1, y1, x2, y2, x, y) {
    this._ += "C" + (+x1) + "," + (+y1) + "," + (+x2) + "," + (+y2) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  arcTo: function(x1, y1, x2, y2, r) {
    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
    var x0 = this._x1,
        y0 = this._y1,
        x21 = x2 - x1,
        y21 = y2 - y1,
        x01 = x0 - x1,
        y01 = y0 - y1,
        l01_2 = x01 * x01 + y01 * y01;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x1,y1).
    if (this._x1 === null) {
      this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
    else if (!(l01_2 > epsilon));

    // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
    // Equivalently, is (x1,y1) coincident with (x2,y2)?
    // Or, is the radius zero? Line to (x1,y1).
    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) {
      this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Otherwise, draw an arc!
    else {
      var x20 = x2 - x0,
          y20 = y2 - y0,
          l21_2 = x21 * x21 + y21 * y21,
          l20_2 = x20 * x20 + y20 * y20,
          l21 = Math.sqrt(l21_2),
          l01 = Math.sqrt(l01_2),
          l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
          t01 = l / l01,
          t21 = l / l21;

      // If the start tangent is not coincident with (x0,y0), line to.
      if (Math.abs(t01 - 1) > epsilon) {
        this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
      }

      this._ += "A" + r + "," + r + ",0,0," + (+(y01 * x20 > x01 * y20)) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
    }
  },
  arc: function(x, y, r, a0, a1, ccw) {
    x = +x, y = +y, r = +r, ccw = !!ccw;
    var dx = r * Math.cos(a0),
        dy = r * Math.sin(a0),
        x0 = x + dx,
        y0 = y + dy,
        cw = 1 ^ ccw,
        da = ccw ? a0 - a1 : a1 - a0;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x0,y0).
    if (this._x1 === null) {
      this._ += "M" + x0 + "," + y0;
    }

    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
    else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) {
      this._ += "L" + x0 + "," + y0;
    }

    // Is this arc empty? We’re done.
    if (!r) return;

    // Does the angle go the wrong way? Flip the direction.
    if (da < 0) da = da % tau + tau;

    // Is this a complete circle? Draw two arcs to complete the circle.
    if (da > tauEpsilon) {
      this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
    }

    // Is this arc non-empty? Draw an arc!
    else if (da > epsilon) {
      this._ += "A" + r + "," + r + ",0," + (+(da >= pi)) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    }
  },
  rect: function(x, y, w, h) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + (+w) + "v" + (+h) + "h" + (-w) + "Z";
  },
  toString: function() {
    return this._;
  }
};

/* harmony default export */ var src_path = (path);

;// CONCATENATED MODULE: ./node_modules/d3-shape/src/array.js
var slice = Array.prototype.slice;

;// CONCATENATED MODULE: ./node_modules/d3-shape/src/constant.js
/* harmony default export */ function constant(x) {
  return function constant() {
    return x;
  };
}

;// CONCATENATED MODULE: ./node_modules/d3-shape/src/point.js
function point_x(p) {
  return p[0];
}

function point_y(p) {
  return p[1];
}

;// CONCATENATED MODULE: ./node_modules/d3-shape/src/link/index.js






function linkSource(d) {
  return d.source;
}

function linkTarget(d) {
  return d.target;
}

function link_link(curve) {
  var source = linkSource,
      target = linkTarget,
      x = point_x,
      y = point_y,
      context = null;

  function link() {
    var buffer, argv = slice.call(arguments), s = source.apply(this, argv), t = target.apply(this, argv);
    if (!context) context = buffer = src_path();
    curve(context, +x.apply(this, (argv[0] = s, argv)), +y.apply(this, argv), +x.apply(this, (argv[0] = t, argv)), +y.apply(this, argv));
    if (buffer) return context = null, buffer + "" || null;
  }

  link.source = function(_) {
    return arguments.length ? (source = _, link) : source;
  };

  link.target = function(_) {
    return arguments.length ? (target = _, link) : target;
  };

  link.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : constant(+_), link) : x;
  };

  link.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : constant(+_), link) : y;
  };

  link.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), link) : context;
  };

  return link;
}

function curveHorizontal(context, x0, y0, x1, y1) {
  context.moveTo(x0, y0);
  context.bezierCurveTo(x0 = (x0 + x1) / 2, y0, x0, y1, x1, y1);
}

function curveVertical(context, x0, y0, x1, y1) {
  context.moveTo(x0, y0);
  context.bezierCurveTo(x0, y0 = (y0 + y1) / 2, x1, y0, x1, y1);
}

function curveRadial(context, x0, y0, x1, y1) {
  var p0 = pointRadial(x0, y0),
      p1 = pointRadial(x0, y0 = (y0 + y1) / 2),
      p2 = pointRadial(x1, y0),
      p3 = pointRadial(x1, y1);
  context.moveTo(p0[0], p0[1]);
  context.bezierCurveTo(p1[0], p1[1], p2[0], p2[1], p3[0], p3[1]);
}

function linkHorizontal() {
  return link_link(curveHorizontal);
}

function linkVertical() {
  return link_link(curveVertical);
}

function linkRadial() {
  var l = link_link(curveRadial);
  l.angle = l.x, delete l.x;
  l.radius = l.y, delete l.y;
  return l;
}


/***/ }),

/***/ 42696:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  DC: function() { return /* reexport */ timeFormat; },
  de: function() { return /* reexport */ formatLocale; },
  aL: function() { return /* reexport */ utcFormat; }
});

// UNUSED EXPORTS: isoFormat, isoParse, timeFormatDefaultLocale, timeParse, utcParse

// EXTERNAL MODULE: ./node_modules/d3-time/src/utcWeek.js
var utcWeek = __webpack_require__(1681);
// EXTERNAL MODULE: ./node_modules/d3-time/src/utcDay.js
var utcDay = __webpack_require__(72543);
// EXTERNAL MODULE: ./node_modules/d3-time/src/week.js
var src_week = __webpack_require__(55735);
// EXTERNAL MODULE: ./node_modules/d3-time/src/day.js
var src_day = __webpack_require__(47265);
// EXTERNAL MODULE: ./node_modules/d3-time/src/year.js
var year = __webpack_require__(9830);
// EXTERNAL MODULE: ./node_modules/d3-time/src/utcYear.js
var utcYear = __webpack_require__(59764);
;// CONCATENATED MODULE: ./node_modules/d3-time-format/src/locale.js


function localDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
    date.setFullYear(d.y);
    return date;
  }
  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}

function utcDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
    date.setUTCFullYear(d.y);
    return date;
  }
  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}

function newDate(y, m, d) {
  return {y: y, m: m, d: d, H: 0, M: 0, S: 0, L: 0};
}

function formatLocale(locale) {
  var locale_dateTime = locale.dateTime,
      locale_date = locale.date,
      locale_time = locale.time,
      locale_periods = locale.periods,
      locale_weekdays = locale.days,
      locale_shortWeekdays = locale.shortDays,
      locale_months = locale.months,
      locale_shortMonths = locale.shortMonths;

  var periodRe = formatRe(locale_periods),
      periodLookup = formatLookup(locale_periods),
      weekdayRe = formatRe(locale_weekdays),
      weekdayLookup = formatLookup(locale_weekdays),
      shortWeekdayRe = formatRe(locale_shortWeekdays),
      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
      monthRe = formatRe(locale_months),
      monthLookup = formatLookup(locale_months),
      shortMonthRe = formatRe(locale_shortMonths),
      shortMonthLookup = formatLookup(locale_shortMonths);

  var formats = {
    "a": formatShortWeekday,
    "A": formatWeekday,
    "b": formatShortMonth,
    "B": formatMonth,
    "c": null,
    "d": formatDayOfMonth,
    "e": formatDayOfMonth,
    "f": formatMicroseconds,
    "H": formatHour24,
    "I": formatHour12,
    "j": formatDayOfYear,
    "L": formatMilliseconds,
    "m": formatMonthNumber,
    "M": formatMinutes,
    "p": formatPeriod,
    "q": formatQuarter,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatSeconds,
    "u": formatWeekdayNumberMonday,
    "U": formatWeekNumberSunday,
    "V": formatWeekNumberISO,
    "w": formatWeekdayNumberSunday,
    "W": formatWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatYear,
    "Y": formatFullYear,
    "Z": formatZone,
    "%": formatLiteralPercent
  };

  var utcFormats = {
    "a": formatUTCShortWeekday,
    "A": formatUTCWeekday,
    "b": formatUTCShortMonth,
    "B": formatUTCMonth,
    "c": null,
    "d": formatUTCDayOfMonth,
    "e": formatUTCDayOfMonth,
    "f": formatUTCMicroseconds,
    "H": formatUTCHour24,
    "I": formatUTCHour12,
    "j": formatUTCDayOfYear,
    "L": formatUTCMilliseconds,
    "m": formatUTCMonthNumber,
    "M": formatUTCMinutes,
    "p": formatUTCPeriod,
    "q": formatUTCQuarter,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatUTCSeconds,
    "u": formatUTCWeekdayNumberMonday,
    "U": formatUTCWeekNumberSunday,
    "V": formatUTCWeekNumberISO,
    "w": formatUTCWeekdayNumberSunday,
    "W": formatUTCWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatUTCYear,
    "Y": formatUTCFullYear,
    "Z": formatUTCZone,
    "%": formatLiteralPercent
  };

  var parses = {
    "a": parseShortWeekday,
    "A": parseWeekday,
    "b": parseShortMonth,
    "B": parseMonth,
    "c": parseLocaleDateTime,
    "d": parseDayOfMonth,
    "e": parseDayOfMonth,
    "f": parseMicroseconds,
    "H": parseHour24,
    "I": parseHour24,
    "j": parseDayOfYear,
    "L": parseMilliseconds,
    "m": parseMonthNumber,
    "M": parseMinutes,
    "p": parsePeriod,
    "q": parseQuarter,
    "Q": parseUnixTimestamp,
    "s": parseUnixTimestampSeconds,
    "S": parseSeconds,
    "u": parseWeekdayNumberMonday,
    "U": parseWeekNumberSunday,
    "V": parseWeekNumberISO,
    "w": parseWeekdayNumberSunday,
    "W": parseWeekNumberMonday,
    "x": parseLocaleDate,
    "X": parseLocaleTime,
    "y": parseYear,
    "Y": parseFullYear,
    "Z": parseZone,
    "%": parseLiteralPercent
  };

  // These recursive directive definitions must be deferred.
  formats.x = newFormat(locale_date, formats);
  formats.X = newFormat(locale_time, formats);
  formats.c = newFormat(locale_dateTime, formats);
  utcFormats.x = newFormat(locale_date, utcFormats);
  utcFormats.X = newFormat(locale_time, utcFormats);
  utcFormats.c = newFormat(locale_dateTime, utcFormats);

  function newFormat(specifier, formats) {
    return function(date) {
      var string = [],
          i = -1,
          j = 0,
          n = specifier.length,
          c,
          pad,
          format;

      if (!(date instanceof Date)) date = new Date(+date);

      while (++i < n) {
        if (specifier.charCodeAt(i) === 37) {
          string.push(specifier.slice(j, i));
          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
          else pad = c === "e" ? " " : "0";
          if (format = formats[c]) c = format(date, pad);
          string.push(c);
          j = i + 1;
        }
      }

      string.push(specifier.slice(j, i));
      return string.join("");
    };
  }

  function newParse(specifier, Z) {
    return function(string) {
      var d = newDate(1900, undefined, 1),
          i = parseSpecifier(d, specifier, string += "", 0),
          week, day;
      if (i != string.length) return null;

      // If a UNIX timestamp is specified, return it.
      if ("Q" in d) return new Date(d.Q);
      if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));

      // If this is utcParse, never use the local timezone.
      if (Z && !("Z" in d)) d.Z = 0;

      // The am-pm flag is 0 for AM, and 1 for PM.
      if ("p" in d) d.H = d.H % 12 + d.p * 12;

      // If the month was not specified, inherit from the quarter.
      if (d.m === undefined) d.m = "q" in d ? d.q : 0;

      // Convert day-of-week and week-of-year to day-of-year.
      if ("V" in d) {
        if (d.V < 1 || d.V > 53) return null;
        if (!("w" in d)) d.w = 1;
        if ("Z" in d) {
          week = utcDate(newDate(d.y, 0, 1)), day = week.getUTCDay();
          week = day > 4 || day === 0 ? utcWeek/* utcMonday */.rt.ceil(week) : (0,utcWeek/* utcMonday */.rt)(week);
          week = utcDay/* default */.A.offset(week, (d.V - 1) * 7);
          d.y = week.getUTCFullYear();
          d.m = week.getUTCMonth();
          d.d = week.getUTCDate() + (d.w + 6) % 7;
        } else {
          week = localDate(newDate(d.y, 0, 1)), day = week.getDay();
          week = day > 4 || day === 0 ? src_week/* monday */.By.ceil(week) : (0,src_week/* monday */.By)(week);
          week = src_day/* default */.A.offset(week, (d.V - 1) * 7);
          d.y = week.getFullYear();
          d.m = week.getMonth();
          d.d = week.getDate() + (d.w + 6) % 7;
        }
      } else if ("W" in d || "U" in d) {
        if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
        day = "Z" in d ? utcDate(newDate(d.y, 0, 1)).getUTCDay() : localDate(newDate(d.y, 0, 1)).getDay();
        d.m = 0;
        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
      }

      // If a time zone is specified, all fields are interpreted as UTC and then
      // offset according to the specified time zone.
      if ("Z" in d) {
        d.H += d.Z / 100 | 0;
        d.M += d.Z % 100;
        return utcDate(d);
      }

      // Otherwise, all fields are in local time.
      return localDate(d);
    };
  }

  function parseSpecifier(d, specifier, string, j) {
    var i = 0,
        n = specifier.length,
        m = string.length,
        c,
        parse;

    while (i < n) {
      if (j >= m) return -1;
      c = specifier.charCodeAt(i++);
      if (c === 37) {
        c = specifier.charAt(i++);
        parse = parses[c in pads ? specifier.charAt(i++) : c];
        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
      } else if (c != string.charCodeAt(j++)) {
        return -1;
      }
    }

    return j;
  }

  function parsePeriod(d, string, i) {
    var n = periodRe.exec(string.slice(i));
    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortWeekday(d, string, i) {
    var n = shortWeekdayRe.exec(string.slice(i));
    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseWeekday(d, string, i) {
    var n = weekdayRe.exec(string.slice(i));
    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortMonth(d, string, i) {
    var n = shortMonthRe.exec(string.slice(i));
    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseMonth(d, string, i) {
    var n = monthRe.exec(string.slice(i));
    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseLocaleDateTime(d, string, i) {
    return parseSpecifier(d, locale_dateTime, string, i);
  }

  function parseLocaleDate(d, string, i) {
    return parseSpecifier(d, locale_date, string, i);
  }

  function parseLocaleTime(d, string, i) {
    return parseSpecifier(d, locale_time, string, i);
  }

  function formatShortWeekday(d) {
    return locale_shortWeekdays[d.getDay()];
  }

  function formatWeekday(d) {
    return locale_weekdays[d.getDay()];
  }

  function formatShortMonth(d) {
    return locale_shortMonths[d.getMonth()];
  }

  function formatMonth(d) {
    return locale_months[d.getMonth()];
  }

  function formatPeriod(d) {
    return locale_periods[+(d.getHours() >= 12)];
  }

  function formatQuarter(d) {
    return 1 + ~~(d.getMonth() / 3);
  }

  function formatUTCShortWeekday(d) {
    return locale_shortWeekdays[d.getUTCDay()];
  }

  function formatUTCWeekday(d) {
    return locale_weekdays[d.getUTCDay()];
  }

  function formatUTCShortMonth(d) {
    return locale_shortMonths[d.getUTCMonth()];
  }

  function formatUTCMonth(d) {
    return locale_months[d.getUTCMonth()];
  }

  function formatUTCPeriod(d) {
    return locale_periods[+(d.getUTCHours() >= 12)];
  }

  function formatUTCQuarter(d) {
    return 1 + ~~(d.getUTCMonth() / 3);
  }

  return {
    format: function(specifier) {
      var f = newFormat(specifier += "", formats);
      f.toString = function() { return specifier; };
      return f;
    },
    parse: function(specifier) {
      var p = newParse(specifier += "", false);
      p.toString = function() { return specifier; };
      return p;
    },
    utcFormat: function(specifier) {
      var f = newFormat(specifier += "", utcFormats);
      f.toString = function() { return specifier; };
      return f;
    },
    utcParse: function(specifier) {
      var p = newParse(specifier += "", true);
      p.toString = function() { return specifier; };
      return p;
    }
  };
}

var pads = {"-": "", "_": " ", "0": "0"},
    numberRe = /^\s*\d+/, // note: ignores next directive
    percentRe = /^%/,
    requoteRe = /[\\^$*+?|[\]().{}]/g;

function pad(value, fill, width) {
  var sign = value < 0 ? "-" : "",
      string = (sign ? -value : value) + "",
      length = string.length;
  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}

function requote(s) {
  return s.replace(requoteRe, "\\$&");
}

function formatRe(names) {
  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
}

function formatLookup(names) {
  var map = {}, i = -1, n = names.length;
  while (++i < n) map[names[i].toLowerCase()] = i;
  return map;
}

function parseWeekdayNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.w = +n[0], i + n[0].length) : -1;
}

function parseWeekdayNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.u = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.U = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberISO(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.V = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.W = +n[0], i + n[0].length) : -1;
}

function parseFullYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 4));
  return n ? (d.y = +n[0], i + n[0].length) : -1;
}

function parseYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}

function parseZone(d, string, i) {
  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}

function parseQuarter(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}

function parseMonthNumber(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}

function parseDayOfMonth(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.d = +n[0], i + n[0].length) : -1;
}

function parseDayOfYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}

function parseHour24(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.H = +n[0], i + n[0].length) : -1;
}

function parseMinutes(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.M = +n[0], i + n[0].length) : -1;
}

function parseSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.S = +n[0], i + n[0].length) : -1;
}

function parseMilliseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.L = +n[0], i + n[0].length) : -1;
}

function parseMicroseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 6));
  return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}

function parseLiteralPercent(d, string, i) {
  var n = percentRe.exec(string.slice(i, i + 1));
  return n ? i + n[0].length : -1;
}

function parseUnixTimestamp(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.Q = +n[0], i + n[0].length) : -1;
}

function parseUnixTimestampSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.s = +n[0], i + n[0].length) : -1;
}

function formatDayOfMonth(d, p) {
  return pad(d.getDate(), p, 2);
}

function formatHour24(d, p) {
  return pad(d.getHours(), p, 2);
}

function formatHour12(d, p) {
  return pad(d.getHours() % 12 || 12, p, 2);
}

function formatDayOfYear(d, p) {
  return pad(1 + src_day/* default */.A.count((0,year/* default */.A)(d), d), p, 3);
}

function formatMilliseconds(d, p) {
  return pad(d.getMilliseconds(), p, 3);
}

function formatMicroseconds(d, p) {
  return formatMilliseconds(d, p) + "000";
}

function formatMonthNumber(d, p) {
  return pad(d.getMonth() + 1, p, 2);
}

function formatMinutes(d, p) {
  return pad(d.getMinutes(), p, 2);
}

function formatSeconds(d, p) {
  return pad(d.getSeconds(), p, 2);
}

function formatWeekdayNumberMonday(d) {
  var day = d.getDay();
  return day === 0 ? 7 : day;
}

function formatWeekNumberSunday(d, p) {
  return pad(src_week/* sunday */.fz.count((0,year/* default */.A)(d) - 1, d), p, 2);
}

function formatWeekNumberISO(d, p) {
  var day = d.getDay();
  d = (day >= 4 || day === 0) ? (0,src_week/* thursday */.dt)(d) : src_week/* thursday */.dt.ceil(d);
  return pad(src_week/* thursday */.dt.count((0,year/* default */.A)(d), d) + ((0,year/* default */.A)(d).getDay() === 4), p, 2);
}

function formatWeekdayNumberSunday(d) {
  return d.getDay();
}

function formatWeekNumberMonday(d, p) {
  return pad(src_week/* monday */.By.count((0,year/* default */.A)(d) - 1, d), p, 2);
}

function formatYear(d, p) {
  return pad(d.getFullYear() % 100, p, 2);
}

function formatFullYear(d, p) {
  return pad(d.getFullYear() % 10000, p, 4);
}

function formatZone(d) {
  var z = d.getTimezoneOffset();
  return (z > 0 ? "-" : (z *= -1, "+"))
      + pad(z / 60 | 0, "0", 2)
      + pad(z % 60, "0", 2);
}

function formatUTCDayOfMonth(d, p) {
  return pad(d.getUTCDate(), p, 2);
}

function formatUTCHour24(d, p) {
  return pad(d.getUTCHours(), p, 2);
}

function formatUTCHour12(d, p) {
  return pad(d.getUTCHours() % 12 || 12, p, 2);
}

function formatUTCDayOfYear(d, p) {
  return pad(1 + utcDay/* default */.A.count((0,utcYear/* default */.A)(d), d), p, 3);
}

function formatUTCMilliseconds(d, p) {
  return pad(d.getUTCMilliseconds(), p, 3);
}

function formatUTCMicroseconds(d, p) {
  return formatUTCMilliseconds(d, p) + "000";
}

function formatUTCMonthNumber(d, p) {
  return pad(d.getUTCMonth() + 1, p, 2);
}

function formatUTCMinutes(d, p) {
  return pad(d.getUTCMinutes(), p, 2);
}

function formatUTCSeconds(d, p) {
  return pad(d.getUTCSeconds(), p, 2);
}

function formatUTCWeekdayNumberMonday(d) {
  var dow = d.getUTCDay();
  return dow === 0 ? 7 : dow;
}

function formatUTCWeekNumberSunday(d, p) {
  return pad(utcWeek/* utcSunday */.Hl.count((0,utcYear/* default */.A)(d) - 1, d), p, 2);
}

function formatUTCWeekNumberISO(d, p) {
  var day = d.getUTCDay();
  d = (day >= 4 || day === 0) ? (0,utcWeek/* utcThursday */.pT)(d) : utcWeek/* utcThursday */.pT.ceil(d);
  return pad(utcWeek/* utcThursday */.pT.count((0,utcYear/* default */.A)(d), d) + ((0,utcYear/* default */.A)(d).getUTCDay() === 4), p, 2);
}

function formatUTCWeekdayNumberSunday(d) {
  return d.getUTCDay();
}

function formatUTCWeekNumberMonday(d, p) {
  return pad(utcWeek/* utcMonday */.rt.count((0,utcYear/* default */.A)(d) - 1, d), p, 2);
}

function formatUTCYear(d, p) {
  return pad(d.getUTCFullYear() % 100, p, 2);
}

function formatUTCFullYear(d, p) {
  return pad(d.getUTCFullYear() % 10000, p, 4);
}

function formatUTCZone() {
  return "+0000";
}

function formatLiteralPercent() {
  return "%";
}

function formatUnixTimestamp(d) {
  return +d;
}

function formatUnixTimestampSeconds(d) {
  return Math.floor(+d / 1000);
}

;// CONCATENATED MODULE: ./node_modules/d3-time-format/src/defaultLocale.js


var locale;
var timeFormat;
var timeParse;
var utcFormat;
var utcParse;

defaultLocale({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});

function defaultLocale(definition) {
  locale = formatLocale(definition);
  timeFormat = locale.format;
  timeParse = locale.parse;
  utcFormat = locale.utcFormat;
  utcParse = locale.utcParse;
  return locale;
}

;// CONCATENATED MODULE: ./node_modules/d3-time-format/src/index.js






/***/ }),

/***/ 47265:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   _: function() { return /* binding */ days; }
/* harmony export */ });
/* harmony import */ var _interval_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53398);
/* harmony import */ var _duration_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66291);



var day = (0,_interval_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(function(date) {
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setDate(date.getDate() + step);
}, function(start, end) {
  return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * _duration_js__WEBPACK_IMPORTED_MODULE_1__/* .durationMinute */ .rR) / _duration_js__WEBPACK_IMPORTED_MODULE_1__/* .durationDay */ .Nm;
}, function(date) {
  return date.getDate() - 1;
});

/* harmony default export */ __webpack_exports__.A = (day);
var days = day.range;


/***/ }),

/***/ 66291:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Fq: function() { return /* binding */ durationWeek; },
/* harmony export */   JJ: function() { return /* binding */ durationHour; },
/* harmony export */   Nm: function() { return /* binding */ durationDay; },
/* harmony export */   Tt: function() { return /* binding */ durationSecond; },
/* harmony export */   rR: function() { return /* binding */ durationMinute; }
/* harmony export */ });
var durationSecond = 1e3;
var durationMinute = 6e4;
var durationHour = 36e5;
var durationDay = 864e5;
var durationWeek = 6048e5;


/***/ }),

/***/ 50936:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  timeDay: function() { return /* reexport */ day/* default */.A; },
  timeDays: function() { return /* reexport */ day/* days */._; },
  timeFriday: function() { return /* reexport */ week/* friday */.Sh; },
  timeFridays: function() { return /* reexport */ week/* fridays */.tz; },
  timeHour: function() { return /* reexport */ src_hour; },
  timeHours: function() { return /* reexport */ hours; },
  timeInterval: function() { return /* reexport */ interval/* default */.A; },
  timeMillisecond: function() { return /* reexport */ src_millisecond; },
  timeMilliseconds: function() { return /* reexport */ milliseconds; },
  timeMinute: function() { return /* reexport */ src_minute; },
  timeMinutes: function() { return /* reexport */ minutes; },
  timeMonday: function() { return /* reexport */ week/* monday */.By; },
  timeMondays: function() { return /* reexport */ week/* mondays */.KP; },
  timeMonth: function() { return /* reexport */ src_month; },
  timeMonths: function() { return /* reexport */ months; },
  timeSaturday: function() { return /* reexport */ week/* saturday */.kS; },
  timeSaturdays: function() { return /* reexport */ week/* saturdays */.t$; },
  timeSecond: function() { return /* reexport */ src_second; },
  timeSeconds: function() { return /* reexport */ seconds; },
  timeSunday: function() { return /* reexport */ week/* sunday */.fz; },
  timeSundays: function() { return /* reexport */ week/* sundays */.se; },
  timeThursday: function() { return /* reexport */ week/* thursday */.dt; },
  timeThursdays: function() { return /* reexport */ week/* thursdays */.Q$; },
  timeTuesday: function() { return /* reexport */ week/* tuesday */.eQ; },
  timeTuesdays: function() { return /* reexport */ week/* tuesdays */.yW; },
  timeWednesday: function() { return /* reexport */ week/* wednesday */.l3; },
  timeWednesdays: function() { return /* reexport */ week/* wednesdays */.gf; },
  timeWeek: function() { return /* reexport */ week/* sunday */.fz; },
  timeWeeks: function() { return /* reexport */ week/* sundays */.se; },
  timeYear: function() { return /* reexport */ year/* default */.A; },
  timeYears: function() { return /* reexport */ year/* years */.V; },
  utcDay: function() { return /* reexport */ utcDay/* default */.A; },
  utcDays: function() { return /* reexport */ utcDay/* utcDays */.o; },
  utcFriday: function() { return /* reexport */ utcWeek/* utcFriday */.a1; },
  utcFridays: function() { return /* reexport */ utcWeek/* utcFridays */.Zn; },
  utcHour: function() { return /* reexport */ src_utcHour; },
  utcHours: function() { return /* reexport */ utcHours; },
  utcMillisecond: function() { return /* reexport */ src_millisecond; },
  utcMilliseconds: function() { return /* reexport */ milliseconds; },
  utcMinute: function() { return /* reexport */ src_utcMinute; },
  utcMinutes: function() { return /* reexport */ utcMinutes; },
  utcMonday: function() { return /* reexport */ utcWeek/* utcMonday */.rt; },
  utcMondays: function() { return /* reexport */ utcWeek/* utcMondays */.ON; },
  utcMonth: function() { return /* reexport */ src_utcMonth; },
  utcMonths: function() { return /* reexport */ utcMonths; },
  utcSaturday: function() { return /* reexport */ utcWeek/* utcSaturday */.c8; },
  utcSaturdays: function() { return /* reexport */ utcWeek/* utcSaturdays */.Xo; },
  utcSecond: function() { return /* reexport */ src_second; },
  utcSeconds: function() { return /* reexport */ seconds; },
  utcSunday: function() { return /* reexport */ utcWeek/* utcSunday */.Hl; },
  utcSundays: function() { return /* reexport */ utcWeek/* utcSundays */.aZ; },
  utcThursday: function() { return /* reexport */ utcWeek/* utcThursday */.pT; },
  utcThursdays: function() { return /* reexport */ utcWeek/* utcThursdays */.wr; },
  utcTuesday: function() { return /* reexport */ utcWeek/* utcTuesday */.sr; },
  utcTuesdays: function() { return /* reexport */ utcWeek/* utcTuesdays */.jN; },
  utcWednesday: function() { return /* reexport */ utcWeek/* utcWednesday */.z2; },
  utcWednesdays: function() { return /* reexport */ utcWeek/* utcWednesdays */.G6; },
  utcWeek: function() { return /* reexport */ utcWeek/* utcSunday */.Hl; },
  utcWeeks: function() { return /* reexport */ utcWeek/* utcSundays */.aZ; },
  utcYear: function() { return /* reexport */ utcYear/* default */.A; },
  utcYears: function() { return /* reexport */ utcYear/* utcYears */.j; }
});

// EXTERNAL MODULE: ./node_modules/d3-time/src/interval.js
var interval = __webpack_require__(53398);
;// CONCATENATED MODULE: ./node_modules/d3-time/src/millisecond.js


var millisecond = (0,interval/* default */.A)(function() {
  // noop
}, function(date, step) {
  date.setTime(+date + step);
}, function(start, end) {
  return end - start;
});

// An optimized implementation for this simple case.
millisecond.every = function(k) {
  k = Math.floor(k);
  if (!isFinite(k) || !(k > 0)) return null;
  if (!(k > 1)) return millisecond;
  return (0,interval/* default */.A)(function(date) {
    date.setTime(Math.floor(date / k) * k);
  }, function(date, step) {
    date.setTime(+date + step * k);
  }, function(start, end) {
    return (end - start) / k;
  });
};

/* harmony default export */ var src_millisecond = (millisecond);
var milliseconds = millisecond.range;

// EXTERNAL MODULE: ./node_modules/d3-time/src/duration.js
var duration = __webpack_require__(66291);
;// CONCATENATED MODULE: ./node_modules/d3-time/src/second.js



var second = (0,interval/* default */.A)(function(date) {
  date.setTime(date - date.getMilliseconds());
}, function(date, step) {
  date.setTime(+date + step * duration/* durationSecond */.Tt);
}, function(start, end) {
  return (end - start) / duration/* durationSecond */.Tt;
}, function(date) {
  return date.getUTCSeconds();
});

/* harmony default export */ var src_second = (second);
var seconds = second.range;

;// CONCATENATED MODULE: ./node_modules/d3-time/src/minute.js



var minute = (0,interval/* default */.A)(function(date) {
  date.setTime(date - date.getMilliseconds() - date.getSeconds() * duration/* durationSecond */.Tt);
}, function(date, step) {
  date.setTime(+date + step * duration/* durationMinute */.rR);
}, function(start, end) {
  return (end - start) / duration/* durationMinute */.rR;
}, function(date) {
  return date.getMinutes();
});

/* harmony default export */ var src_minute = (minute);
var minutes = minute.range;

;// CONCATENATED MODULE: ./node_modules/d3-time/src/hour.js



var hour = (0,interval/* default */.A)(function(date) {
  date.setTime(date - date.getMilliseconds() - date.getSeconds() * duration/* durationSecond */.Tt - date.getMinutes() * duration/* durationMinute */.rR);
}, function(date, step) {
  date.setTime(+date + step * duration/* durationHour */.JJ);
}, function(start, end) {
  return (end - start) / duration/* durationHour */.JJ;
}, function(date) {
  return date.getHours();
});

/* harmony default export */ var src_hour = (hour);
var hours = hour.range;

// EXTERNAL MODULE: ./node_modules/d3-time/src/day.js
var day = __webpack_require__(47265);
// EXTERNAL MODULE: ./node_modules/d3-time/src/week.js
var week = __webpack_require__(55735);
;// CONCATENATED MODULE: ./node_modules/d3-time/src/month.js


var month = (0,interval/* default */.A)(function(date) {
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setMonth(date.getMonth() + step);
}, function(start, end) {
  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
  return date.getMonth();
});

/* harmony default export */ var src_month = (month);
var months = month.range;

// EXTERNAL MODULE: ./node_modules/d3-time/src/year.js
var year = __webpack_require__(9830);
;// CONCATENATED MODULE: ./node_modules/d3-time/src/utcMinute.js



var utcMinute = (0,interval/* default */.A)(function(date) {
  date.setUTCSeconds(0, 0);
}, function(date, step) {
  date.setTime(+date + step * duration/* durationMinute */.rR);
}, function(start, end) {
  return (end - start) / duration/* durationMinute */.rR;
}, function(date) {
  return date.getUTCMinutes();
});

/* harmony default export */ var src_utcMinute = (utcMinute);
var utcMinutes = utcMinute.range;

;// CONCATENATED MODULE: ./node_modules/d3-time/src/utcHour.js



var utcHour = (0,interval/* default */.A)(function(date) {
  date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
  date.setTime(+date + step * duration/* durationHour */.JJ);
}, function(start, end) {
  return (end - start) / duration/* durationHour */.JJ;
}, function(date) {
  return date.getUTCHours();
});

/* harmony default export */ var src_utcHour = (utcHour);
var utcHours = utcHour.range;

// EXTERNAL MODULE: ./node_modules/d3-time/src/utcDay.js
var utcDay = __webpack_require__(72543);
// EXTERNAL MODULE: ./node_modules/d3-time/src/utcWeek.js
var utcWeek = __webpack_require__(1681);
;// CONCATENATED MODULE: ./node_modules/d3-time/src/utcMonth.js


var utcMonth = (0,interval/* default */.A)(function(date) {
  date.setUTCDate(1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
  return date.getUTCMonth();
});

/* harmony default export */ var src_utcMonth = (utcMonth);
var utcMonths = utcMonth.range;

// EXTERNAL MODULE: ./node_modules/d3-time/src/utcYear.js
var utcYear = __webpack_require__(59764);
;// CONCATENATED MODULE: ./node_modules/d3-time/src/index.js































/***/ }),

/***/ 53398:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* binding */ newInterval; }
/* harmony export */ });
var t0 = new Date,
    t1 = new Date;

function newInterval(floori, offseti, count, field) {

  function interval(date) {
    return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
  }

  interval.floor = function(date) {
    return floori(date = new Date(+date)), date;
  };

  interval.ceil = function(date) {
    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
  };

  interval.round = function(date) {
    var d0 = interval(date),
        d1 = interval.ceil(date);
    return date - d0 < d1 - date ? d0 : d1;
  };

  interval.offset = function(date, step) {
    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
  };

  interval.range = function(start, stop, step) {
    var range = [], previous;
    start = interval.ceil(start);
    step = step == null ? 1 : Math.floor(step);
    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
    do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
    while (previous < start && start < stop);
    return range;
  };

  interval.filter = function(test) {
    return newInterval(function(date) {
      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
    }, function(date, step) {
      if (date >= date) {
        if (step < 0) while (++step <= 0) {
          while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty
        } else while (--step >= 0) {
          while (offseti(date, +1), !test(date)) {} // eslint-disable-line no-empty
        }
      }
    });
  };

  if (count) {
    interval.count = function(start, end) {
      t0.setTime(+start), t1.setTime(+end);
      floori(t0), floori(t1);
      return Math.floor(count(t0, t1));
    };

    interval.every = function(step) {
      step = Math.floor(step);
      return !isFinite(step) || !(step > 0) ? null
          : !(step > 1) ? interval
          : interval.filter(field
              ? function(d) { return field(d) % step === 0; }
              : function(d) { return interval.count(0, d) % step === 0; });
    };
  }

  return interval;
}


/***/ }),

/***/ 72543:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   o: function() { return /* binding */ utcDays; }
/* harmony export */ });
/* harmony import */ var _interval_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53398);
/* harmony import */ var _duration_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66291);



var utcDay = (0,_interval_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(function(date) {
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
  return (end - start) / _duration_js__WEBPACK_IMPORTED_MODULE_1__/* .durationDay */ .Nm;
}, function(date) {
  return date.getUTCDate() - 1;
});

/* harmony default export */ __webpack_exports__.A = (utcDay);
var utcDays = utcDay.range;


/***/ }),

/***/ 1681:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   G6: function() { return /* binding */ utcWednesdays; },
/* harmony export */   Hl: function() { return /* binding */ utcSunday; },
/* harmony export */   ON: function() { return /* binding */ utcMondays; },
/* harmony export */   Xo: function() { return /* binding */ utcSaturdays; },
/* harmony export */   Zn: function() { return /* binding */ utcFridays; },
/* harmony export */   a1: function() { return /* binding */ utcFriday; },
/* harmony export */   aZ: function() { return /* binding */ utcSundays; },
/* harmony export */   c8: function() { return /* binding */ utcSaturday; },
/* harmony export */   jN: function() { return /* binding */ utcTuesdays; },
/* harmony export */   pT: function() { return /* binding */ utcThursday; },
/* harmony export */   rt: function() { return /* binding */ utcMonday; },
/* harmony export */   sr: function() { return /* binding */ utcTuesday; },
/* harmony export */   wr: function() { return /* binding */ utcThursdays; },
/* harmony export */   z2: function() { return /* binding */ utcWednesday; }
/* harmony export */ });
/* harmony import */ var _interval_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53398);
/* harmony import */ var _duration_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66291);



function utcWeekday(i) {
  return (0,_interval_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(function(date) {
    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step * 7);
  }, function(start, end) {
    return (end - start) / _duration_js__WEBPACK_IMPORTED_MODULE_1__/* .durationWeek */ .Fq;
  });
}

var utcSunday = utcWeekday(0);
var utcMonday = utcWeekday(1);
var utcTuesday = utcWeekday(2);
var utcWednesday = utcWeekday(3);
var utcThursday = utcWeekday(4);
var utcFriday = utcWeekday(5);
var utcSaturday = utcWeekday(6);

var utcSundays = utcSunday.range;
var utcMondays = utcMonday.range;
var utcTuesdays = utcTuesday.range;
var utcWednesdays = utcWednesday.range;
var utcThursdays = utcThursday.range;
var utcFridays = utcFriday.range;
var utcSaturdays = utcSaturday.range;


/***/ }),

/***/ 59764:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   j: function() { return /* binding */ utcYears; }
/* harmony export */ });
/* harmony import */ var _interval_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53398);


var utcYear = (0,_interval_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(function(date) {
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
  return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
  return date.getUTCFullYear();
});

// An optimized implementation for this simple case.
utcYear.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0,_interval_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(function(date) {
    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step * k);
  });
};

/* harmony default export */ __webpack_exports__.A = (utcYear);
var utcYears = utcYear.range;


/***/ }),

/***/ 55735:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   By: function() { return /* binding */ monday; },
/* harmony export */   KP: function() { return /* binding */ mondays; },
/* harmony export */   Q$: function() { return /* binding */ thursdays; },
/* harmony export */   Sh: function() { return /* binding */ friday; },
/* harmony export */   dt: function() { return /* binding */ thursday; },
/* harmony export */   eQ: function() { return /* binding */ tuesday; },
/* harmony export */   fz: function() { return /* binding */ sunday; },
/* harmony export */   gf: function() { return /* binding */ wednesdays; },
/* harmony export */   kS: function() { return /* binding */ saturday; },
/* harmony export */   l3: function() { return /* binding */ wednesday; },
/* harmony export */   se: function() { return /* binding */ sundays; },
/* harmony export */   t$: function() { return /* binding */ saturdays; },
/* harmony export */   tz: function() { return /* binding */ fridays; },
/* harmony export */   yW: function() { return /* binding */ tuesdays; }
/* harmony export */ });
/* harmony import */ var _interval_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53398);
/* harmony import */ var _duration_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66291);



function weekday(i) {
  return (0,_interval_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(function(date) {
    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setDate(date.getDate() + step * 7);
  }, function(start, end) {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * _duration_js__WEBPACK_IMPORTED_MODULE_1__/* .durationMinute */ .rR) / _duration_js__WEBPACK_IMPORTED_MODULE_1__/* .durationWeek */ .Fq;
  });
}

var sunday = weekday(0);
var monday = weekday(1);
var tuesday = weekday(2);
var wednesday = weekday(3);
var thursday = weekday(4);
var friday = weekday(5);
var saturday = weekday(6);

var sundays = sunday.range;
var mondays = monday.range;
var tuesdays = tuesday.range;
var wednesdays = wednesday.range;
var thursdays = thursday.range;
var fridays = friday.range;
var saturdays = saturday.range;


/***/ }),

/***/ 9830:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   V: function() { return /* binding */ years; }
/* harmony export */ });
/* harmony import */ var _interval_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53398);


var year = (0,_interval_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(function(date) {
  date.setMonth(0, 1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
  return end.getFullYear() - start.getFullYear();
}, function(date) {
  return date.getFullYear();
});

// An optimized implementation for this simple case.
year.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0,_interval_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(function(date) {
    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setFullYear(date.getFullYear() + step * k);
  });
};

/* harmony default export */ __webpack_exports__.A = (year);
var years = year.range;


/***/ }),

/***/ 70973:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var $defineProperty = __webpack_require__(40891);

var $SyntaxError = __webpack_require__(98800);
var $TypeError = __webpack_require__(48631);

var gopd = __webpack_require__(52991);

/** @type {import('.')} */
module.exports = function defineDataProperty(
	obj,
	property,
	value
) {
	if (!obj || (typeof obj !== 'object' && typeof obj !== 'function')) {
		throw new $TypeError('`obj` must be an object or a function`');
	}
	if (typeof property !== 'string' && typeof property !== 'symbol') {
		throw new $TypeError('`property` must be a string or a symbol`');
	}
	if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) {
		throw new $TypeError('`nonEnumerable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) {
		throw new $TypeError('`nonWritable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) {
		throw new $TypeError('`nonConfigurable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 6 && typeof arguments[6] !== 'boolean') {
		throw new $TypeError('`loose`, if provided, must be a boolean');
	}

	var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
	var nonWritable = arguments.length > 4 ? arguments[4] : null;
	var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
	var loose = arguments.length > 6 ? arguments[6] : false;

	/* @type {false | TypedPropertyDescriptor<unknown>} */
	var desc = !!gopd && gopd(obj, property);

	if ($defineProperty) {
		$defineProperty(obj, property, {
			configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
			enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
			value: value,
			writable: nonWritable === null && desc ? desc.writable : !nonWritable
		});
	} else if (loose || (!nonEnumerable && !nonWritable && !nonConfigurable)) {
		// must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
		obj[property] = value; // eslint-disable-line no-param-reassign
	} else {
		throw new $SyntaxError('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
	}
};


/***/ }),

/***/ 97936:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var keys = __webpack_require__(99433);
var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';

var toStr = Object.prototype.toString;
var concat = Array.prototype.concat;
var origDefineProperty = Object.defineProperty;

var isFunction = function (fn) {
	return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
};

var hasPropertyDescriptors = __webpack_require__(74268)();

var supportsDescriptors = origDefineProperty && hasPropertyDescriptors;

var defineProperty = function (object, name, value, predicate) {
	if (name in object) {
		if (predicate === true) {
			if (object[name] === value) {
				return;
			}
		} else if (!isFunction(predicate) || !predicate()) {
			return;
		}
	}
	if (supportsDescriptors) {
		origDefineProperty(object, name, {
			configurable: true,
			enumerable: false,
			value: value,
			writable: true
		});
	} else {
		object[name] = value; // eslint-disable-line no-param-reassign
	}
};

var defineProperties = function (object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = keys(map);
	if (hasSymbols) {
		props = concat.call(props, Object.getOwnPropertySymbols(map));
	}
	for (var i = 0; i < props.length; i += 1) {
		defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
	}
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

module.exports = defineProperties;


/***/ }),

/***/ 68650:
/***/ (function(module) {

module.exports = function () {
    for (var i = 0; i < arguments.length; i++) {
        if (arguments[i] !== undefined) return arguments[i];
    }
};


/***/ }),

/***/ 44431:
/***/ (function(module) {

"use strict";



module.exports = kerning


var canvas = kerning.canvas = document.createElement('canvas')
var ctx = canvas.getContext('2d')
var asciiPairs = createPairs([32, 126])

kerning.createPairs = createPairs
kerning.ascii = asciiPairs


function kerning (family, o) {
	if (Array.isArray(family)) family = family.join(', ')

	var table = {}, pairs, fs = 16, threshold = .05

	if (o) {
		if (o.length === 2 && typeof o[0] === 'number') {
			pairs = createPairs(o)
		}
		else if (Array.isArray(o)) {
			pairs = o
		}
		else {
			if (o.o) pairs = createPairs(o.o)
			else if (o.pairs) pairs = o.pairs

			if (o.fontSize) fs = o.fontSize
			if (o.threshold != null) threshold = o.threshold
		}
	}

	if (!pairs) pairs = asciiPairs

	ctx.font = fs + 'px ' + family

	for (var i = 0; i < pairs.length; i++) {
		var pair = pairs[i]
		var width = ctx.measureText(pair[0]).width + ctx.measureText(pair[1]).width
		var kerningWidth = ctx.measureText(pair).width
		if (Math.abs(width - kerningWidth) > fs * threshold) {
			var emWidth = (kerningWidth - width) / fs
			table[pair] = emWidth * 1000
		}
	}

	return table
}


function createPairs (range) {
	var pairs = []

    for (var i = range[0]; i <= range[1]; i++) {
		var leftChar = String.fromCharCode(i)
		for (var j = range[0]; j < range[1]; j++) {
			var rightChar = String.fromCharCode(j)
			var pair = leftChar + rightChar

			pairs.push(pair)
		}
	}

	return pairs
}


/***/ }),

/***/ 95620:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var abs = __webpack_require__(16844)
var normalize = __webpack_require__(60265)

var methods = {
  'M': 'moveTo',
  'C': 'bezierCurveTo'
}

module.exports = function(context, segments) {
  context.beginPath()

  // Make path easy to reproduce.
  normalize(abs(segments)).forEach(
    function(segment) {
      var command = segment[0]
      var args = segment.slice(1)

      // Convert the path command to a context method.
      context[methods[command]].apply(context, args)
    }
  )

  context.closePath()
}


/***/ }),

/***/ 10275:
/***/ (function(module) {

module.exports = function(dtype) {
  switch (dtype) {
    case 'int8':
      return Int8Array
    case 'int16':
      return Int16Array
    case 'int32':
      return Int32Array
    case 'uint8':
      return Uint8Array
    case 'uint16':
      return Uint16Array
    case 'uint32':
      return Uint32Array
    case 'float32':
      return Float32Array
    case 'float64':
      return Float64Array
    case 'array':
      return Array
    case 'uint8_clamped':
      return Uint8ClampedArray
  }
}


/***/ }),

/***/ 49523:
/***/ (function(module) {

"use strict";


function dupe_array(count, value, i) {
  var c = count[i]|0
  if(c <= 0) {
    return []
  }
  var result = new Array(c), j
  if(i === count.length-1) {
    for(j=0; j<c; ++j) {
      result[j] = value
    }
  } else {
    for(j=0; j<c; ++j) {
      result[j] = dupe_array(count, value, i+1)
    }
  }
  return result
}

function dupe_number(count, value) {
  var result, i
  result = new Array(count)
  for(i=0; i<count; ++i) {
    result[i] = value
  }
  return result
}

function dupe(count, value) {
  if(typeof value === "undefined") {
    value = 0
  }
  switch(typeof count) {
    case "number":
      if(count > 0) {
        return dupe_number(count|0, value)
      }
    break
    case "object":
      if(typeof (count.length) === "number") {
        return dupe_array(count, value, 0)
      }
    break
  }
  return []
}

module.exports = dupe

/***/ }),

/***/ 25782:
/***/ (function(module) {

"use strict";


module.exports = earcut;
module.exports["default"] = earcut;

function earcut(data, holeIndices, dim) {

    dim = dim || 2;

    var hasHoles = holeIndices && holeIndices.length,
        outerLen = hasHoles ? holeIndices[0] * dim : data.length,
        outerNode = linkedList(data, 0, outerLen, dim, true),
        triangles = [];

    if (!outerNode || outerNode.next === outerNode.prev) return triangles;

    var minX, minY, maxX, maxY, x, y, invSize;

    if (hasHoles) outerNode = eliminateHoles(data, holeIndices, outerNode, dim);

    // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
    if (data.length > 80 * dim) {
        minX = maxX = data[0];
        minY = maxY = data[1];

        for (var i = dim; i < outerLen; i += dim) {
            x = data[i];
            y = data[i + 1];
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
        }

        // minX, minY and invSize are later used to transform coords into integers for z-order calculation
        invSize = Math.max(maxX - minX, maxY - minY);
        invSize = invSize !== 0 ? 32767 / invSize : 0;
    }

    earcutLinked(outerNode, triangles, dim, minX, minY, invSize, 0);

    return triangles;
}

// create a circular doubly linked list from polygon points in the specified winding order
function linkedList(data, start, end, dim, clockwise) {
    var i, last;

    if (clockwise === (signedArea(data, start, end, dim) > 0)) {
        for (i = start; i < end; i += dim) last = insertNode(i, data[i], data[i + 1], last);
    } else {
        for (i = end - dim; i >= start; i -= dim) last = insertNode(i, data[i], data[i + 1], last);
    }

    if (last && equals(last, last.next)) {
        removeNode(last);
        last = last.next;
    }

    return last;
}

// eliminate colinear or duplicate points
function filterPoints(start, end) {
    if (!start) return start;
    if (!end) end = start;

    var p = start,
        again;
    do {
        again = false;

        if (!p.steiner && (equals(p, p.next) || area(p.prev, p, p.next) === 0)) {
            removeNode(p);
            p = end = p.prev;
            if (p === p.next) break;
            again = true;

        } else {
            p = p.next;
        }
    } while (again || p !== end);

    return end;
}

// main ear slicing loop which triangulates a polygon (given as a linked list)
function earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
    if (!ear) return;

    // interlink polygon nodes in z-order
    if (!pass && invSize) indexCurve(ear, minX, minY, invSize);

    var stop = ear,
        prev, next;

    // iterate through ears, slicing them one by one
    while (ear.prev !== ear.next) {
        prev = ear.prev;
        next = ear.next;

        if (invSize ? isEarHashed(ear, minX, minY, invSize) : isEar(ear)) {
            // cut off the triangle
            triangles.push(prev.i / dim | 0);
            triangles.push(ear.i / dim | 0);
            triangles.push(next.i / dim | 0);

            removeNode(ear);

            // skipping the next vertex leads to less sliver triangles
            ear = next.next;
            stop = next.next;

            continue;
        }

        ear = next;

        // if we looped through the whole remaining polygon and can't find any more ears
        if (ear === stop) {
            // try filtering points and slicing again
            if (!pass) {
                earcutLinked(filterPoints(ear), triangles, dim, minX, minY, invSize, 1);

            // if this didn't work, try curing all small self-intersections locally
            } else if (pass === 1) {
                ear = cureLocalIntersections(filterPoints(ear), triangles, dim);
                earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);

            // as a last resort, try splitting the remaining polygon into two
            } else if (pass === 2) {
                splitEarcut(ear, triangles, dim, minX, minY, invSize);
            }

            break;
        }
    }
}

// check whether a polygon node forms a valid ear with adjacent nodes
function isEar(ear) {
    var a = ear.prev,
        b = ear,
        c = ear.next;

    if (area(a, b, c) >= 0) return false; // reflex, can't be an ear

    // now make sure we don't have other points inside the potential ear
    var ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;

    // triangle bbox; min & max are calculated like this for speed
    var x0 = ax < bx ? (ax < cx ? ax : cx) : (bx < cx ? bx : cx),
        y0 = ay < by ? (ay < cy ? ay : cy) : (by < cy ? by : cy),
        x1 = ax > bx ? (ax > cx ? ax : cx) : (bx > cx ? bx : cx),
        y1 = ay > by ? (ay > cy ? ay : cy) : (by > cy ? by : cy);

    var p = c.next;
    while (p !== a) {
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 &&
            pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) &&
            area(p.prev, p, p.next) >= 0) return false;
        p = p.next;
    }

    return true;
}

function isEarHashed(ear, minX, minY, invSize) {
    var a = ear.prev,
        b = ear,
        c = ear.next;

    if (area(a, b, c) >= 0) return false; // reflex, can't be an ear

    var ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;

    // triangle bbox; min & max are calculated like this for speed
    var x0 = ax < bx ? (ax < cx ? ax : cx) : (bx < cx ? bx : cx),
        y0 = ay < by ? (ay < cy ? ay : cy) : (by < cy ? by : cy),
        x1 = ax > bx ? (ax > cx ? ax : cx) : (bx > cx ? bx : cx),
        y1 = ay > by ? (ay > cy ? ay : cy) : (by > cy ? by : cy);

    // z-order range for the current triangle bbox;
    var minZ = zOrder(x0, y0, minX, minY, invSize),
        maxZ = zOrder(x1, y1, minX, minY, invSize);

    var p = ear.prevZ,
        n = ear.nextZ;

    // look for points inside the triangle in both directions
    while (p && p.z >= minZ && n && n.z <= maxZ) {
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c &&
            pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;

        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c &&
            pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }

    // look for remaining points in decreasing z-order
    while (p && p.z >= minZ) {
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c &&
            pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
    }

    // look for remaining points in increasing z-order
    while (n && n.z <= maxZ) {
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c &&
            pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }

    return true;
}

// go through all polygon nodes and cure small local self-intersections
function cureLocalIntersections(start, triangles, dim) {
    var p = start;
    do {
        var a = p.prev,
            b = p.next.next;

        if (!equals(a, b) && intersects(a, p, p.next, b) && locallyInside(a, b) && locallyInside(b, a)) {

            triangles.push(a.i / dim | 0);
            triangles.push(p.i / dim | 0);
            triangles.push(b.i / dim | 0);

            // remove two nodes involved
            removeNode(p);
            removeNode(p.next);

            p = start = b;
        }
        p = p.next;
    } while (p !== start);

    return filterPoints(p);
}

// try splitting polygon into two and triangulate them independently
function splitEarcut(start, triangles, dim, minX, minY, invSize) {
    // look for a valid diagonal that divides the polygon into two
    var a = start;
    do {
        var b = a.next.next;
        while (b !== a.prev) {
            if (a.i !== b.i && isValidDiagonal(a, b)) {
                // split the polygon in two by the diagonal
                var c = splitPolygon(a, b);

                // filter colinear points around the cuts
                a = filterPoints(a, a.next);
                c = filterPoints(c, c.next);

                // run earcut on each half
                earcutLinked(a, triangles, dim, minX, minY, invSize, 0);
                earcutLinked(c, triangles, dim, minX, minY, invSize, 0);
                return;
            }
            b = b.next;
        }
        a = a.next;
    } while (a !== start);
}

// link every hole into the outer loop, producing a single-ring polygon without holes
function eliminateHoles(data, holeIndices, outerNode, dim) {
    var queue = [],
        i, len, start, end, list;

    for (i = 0, len = holeIndices.length; i < len; i++) {
        start = holeIndices[i] * dim;
        end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        list = linkedList(data, start, end, dim, false);
        if (list === list.next) list.steiner = true;
        queue.push(getLeftmost(list));
    }

    queue.sort(compareX);

    // process holes from left to right
    for (i = 0; i < queue.length; i++) {
        outerNode = eliminateHole(queue[i], outerNode);
    }

    return outerNode;
}

function compareX(a, b) {
    return a.x - b.x;
}

// find a bridge between vertices that connects hole with an outer ring and and link it
function eliminateHole(hole, outerNode) {
    var bridge = findHoleBridge(hole, outerNode);
    if (!bridge) {
        return outerNode;
    }

    var bridgeReverse = splitPolygon(bridge, hole);

    // filter collinear points around the cuts
    filterPoints(bridgeReverse, bridgeReverse.next);
    return filterPoints(bridge, bridge.next);
}

// David Eberly's algorithm for finding a bridge between hole and outer polygon
function findHoleBridge(hole, outerNode) {
    var p = outerNode,
        hx = hole.x,
        hy = hole.y,
        qx = -Infinity,
        m;

    // find a segment intersected by a ray from the hole's leftmost point to the left;
    // segment's endpoint with lesser x will be potential connection point
    do {
        if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
            var x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
            if (x <= hx && x > qx) {
                qx = x;
                m = p.x < p.next.x ? p : p.next;
                if (x === hx) return m; // hole touches outer segment; pick leftmost endpoint
            }
        }
        p = p.next;
    } while (p !== outerNode);

    if (!m) return null;

    // look for points inside the triangle of hole point, segment intersection and endpoint;
    // if there are no points found, we have a valid connection;
    // otherwise choose the point of the minimum angle with the ray as connection point

    var stop = m,
        mx = m.x,
        my = m.y,
        tanMin = Infinity,
        tan;

    p = m;

    do {
        if (hx >= p.x && p.x >= mx && hx !== p.x &&
                pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {

            tan = Math.abs(hy - p.y) / (hx - p.x); // tangential

            if (locallyInside(p, hole) &&
                (tan < tanMin || (tan === tanMin && (p.x > m.x || (p.x === m.x && sectorContainsSector(m, p)))))) {
                m = p;
                tanMin = tan;
            }
        }

        p = p.next;
    } while (p !== stop);

    return m;
}

// whether sector in vertex m contains sector in vertex p in the same coordinates
function sectorContainsSector(m, p) {
    return area(m.prev, m, p.prev) < 0 && area(p.next, m, m.next) < 0;
}

// interlink polygon nodes in z-order
function indexCurve(start, minX, minY, invSize) {
    var p = start;
    do {
        if (p.z === 0) p.z = zOrder(p.x, p.y, minX, minY, invSize);
        p.prevZ = p.prev;
        p.nextZ = p.next;
        p = p.next;
    } while (p !== start);

    p.prevZ.nextZ = null;
    p.prevZ = null;

    sortLinked(p);
}

// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function sortLinked(list) {
    var i, p, q, e, tail, numMerges, pSize, qSize,
        inSize = 1;

    do {
        p = list;
        list = null;
        tail = null;
        numMerges = 0;

        while (p) {
            numMerges++;
            q = p;
            pSize = 0;
            for (i = 0; i < inSize; i++) {
                pSize++;
                q = q.nextZ;
                if (!q) break;
            }
            qSize = inSize;

            while (pSize > 0 || (qSize > 0 && q)) {

                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                }

                if (tail) tail.nextZ = e;
                else list = e;

                e.prevZ = tail;
                tail = e;
            }

            p = q;
        }

        tail.nextZ = null;
        inSize *= 2;

    } while (numMerges > 1);

    return list;
}

// z-order of a point given coords and inverse of the longer side of data bbox
function zOrder(x, y, minX, minY, invSize) {
    // coords are transformed into non-negative 15-bit integer range
    x = (x - minX) * invSize | 0;
    y = (y - minY) * invSize | 0;

    x = (x | (x << 8)) & 0x00FF00FF;
    x = (x | (x << 4)) & 0x0F0F0F0F;
    x = (x | (x << 2)) & 0x33333333;
    x = (x | (x << 1)) & 0x55555555;

    y = (y | (y << 8)) & 0x00FF00FF;
    y = (y | (y << 4)) & 0x0F0F0F0F;
    y = (y | (y << 2)) & 0x33333333;
    y = (y | (y << 1)) & 0x55555555;

    return x | (y << 1);
}

// find the leftmost node of a polygon ring
function getLeftmost(start) {
    var p = start,
        leftmost = start;
    do {
        if (p.x < leftmost.x || (p.x === leftmost.x && p.y < leftmost.y)) leftmost = p;
        p = p.next;
    } while (p !== start);

    return leftmost;
}

// check if a point lies within a convex triangle
function pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
    return (cx - px) * (ay - py) >= (ax - px) * (cy - py) &&
           (ax - px) * (by - py) >= (bx - px) * (ay - py) &&
           (bx - px) * (cy - py) >= (cx - px) * (by - py);
}

// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function isValidDiagonal(a, b) {
    return a.next.i !== b.i && a.prev.i !== b.i && !intersectsPolygon(a, b) && // dones't intersect other edges
           (locallyInside(a, b) && locallyInside(b, a) && middleInside(a, b) && // locally visible
            (area(a.prev, a, b.prev) || area(a, b.prev, b)) || // does not create opposite-facing sectors
            equals(a, b) && area(a.prev, a, a.next) > 0 && area(b.prev, b, b.next) > 0); // special zero-length case
}

// signed area of a triangle
function area(p, q, r) {
    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}

// check if two points are equal
function equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}

// check if two segments intersect
function intersects(p1, q1, p2, q2) {
    var o1 = sign(area(p1, q1, p2));
    var o2 = sign(area(p1, q1, q2));
    var o3 = sign(area(p2, q2, p1));
    var o4 = sign(area(p2, q2, q1));

    if (o1 !== o2 && o3 !== o4) return true; // general case

    if (o1 === 0 && onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
    if (o2 === 0 && onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
    if (o3 === 0 && onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
    if (o4 === 0 && onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2

    return false;
}

// for collinear points p, q, r, check if point q lies on segment pr
function onSegment(p, q, r) {
    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}

function sign(num) {
    return num > 0 ? 1 : num < 0 ? -1 : 0;
}

// check if a polygon diagonal intersects any polygon segments
function intersectsPolygon(a, b) {
    var p = a;
    do {
        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i &&
                intersects(p, p.next, a, b)) return true;
        p = p.next;
    } while (p !== a);

    return false;
}

// check if a polygon diagonal is locally inside the polygon
function locallyInside(a, b) {
    return area(a.prev, a, a.next) < 0 ?
        area(a, b, a.next) >= 0 && area(a, a.prev, b) >= 0 :
        area(a, b, a.prev) < 0 || area(a, a.next, b) < 0;
}

// check if the middle point of a polygon diagonal is inside the polygon
function middleInside(a, b) {
    var p = a,
        inside = false,
        px = (a.x + b.x) / 2,
        py = (a.y + b.y) / 2;
    do {
        if (((p.y > py) !== (p.next.y > py)) && p.next.y !== p.y &&
                (px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x))
            inside = !inside;
        p = p.next;
    } while (p !== a);

    return inside;
}

// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function splitPolygon(a, b) {
    var a2 = new Node(a.i, a.x, a.y),
        b2 = new Node(b.i, b.x, b.y),
        an = a.next,
        bp = b.prev;

    a.next = b;
    b.prev = a;

    a2.next = an;
    an.prev = a2;

    b2.next = a2;
    a2.prev = b2;

    bp.next = b2;
    b2.prev = bp;

    return b2;
}

// create a node and optionally link it with previous one (in a circular doubly linked list)
function insertNode(i, x, y, last) {
    var p = new Node(i, x, y);

    if (!last) {
        p.prev = p;
        p.next = p;

    } else {
        p.next = last.next;
        p.prev = last;
        last.next.prev = p;
        last.next = p;
    }
    return p;
}

function removeNode(p) {
    p.next.prev = p.prev;
    p.prev.next = p.next;

    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}

function Node(i, x, y) {
    // vertex index in coordinates array
    this.i = i;

    // vertex coordinates
    this.x = x;
    this.y = y;

    // previous and next vertex nodes in a polygon ring
    this.prev = null;
    this.next = null;

    // z-order curve value
    this.z = 0;

    // previous and next nodes in z-order
    this.prevZ = null;
    this.nextZ = null;

    // indicates whether this is a steiner point
    this.steiner = false;
}

// return a percentage difference between the polygon area and its triangulation area;
// used to verify correctness of triangulation
earcut.deviation = function (data, holeIndices, dim, triangles) {
    var hasHoles = holeIndices && holeIndices.length;
    var outerLen = hasHoles ? holeIndices[0] * dim : data.length;

    var polygonArea = Math.abs(signedArea(data, 0, outerLen, dim));
    if (hasHoles) {
        for (var i = 0, len = holeIndices.length; i < len; i++) {
            var start = holeIndices[i] * dim;
            var end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
            polygonArea -= Math.abs(signedArea(data, start, end, dim));
        }
    }

    var trianglesArea = 0;
    for (i = 0; i < triangles.length; i += 3) {
        var a = triangles[i] * dim;
        var b = triangles[i + 1] * dim;
        var c = triangles[i + 2] * dim;
        trianglesArea += Math.abs(
            (data[a] - data[c]) * (data[b + 1] - data[a + 1]) -
            (data[a] - data[b]) * (data[c + 1] - data[a + 1]));
    }

    return polygonArea === 0 && trianglesArea === 0 ? 0 :
        Math.abs((trianglesArea - polygonArea) / polygonArea);
};

function signedArea(data, start, end, dim) {
    var sum = 0;
    for (var i = start, j = end - dim; i < end; i += dim) {
        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
        j = i;
    }
    return sum;
}

// turn a polygon in a multi-dimensional array form (e.g. as in GeoJSON) into a form Earcut accepts
earcut.flatten = function (data) {
    var dim = data[0][0].length,
        result = {vertices: [], holes: [], dimensions: dim},
        holeIndex = 0;

    for (var i = 0; i < data.length; i++) {
        for (var j = 0; j < data[i].length; j++) {
            for (var d = 0; d < dim; d++) result.vertices.push(data[i][j][d]);
        }
        if (i > 0) {
            holeIndex += data[i - 1].length;
            result.holes.push(holeIndex);
        }
    }
    return result;
};


/***/ }),

/***/ 96143:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var tarjan = __webpack_require__(26381);

module.exports = function findCircuits(edges, cb) {
    var circuits = []; // Output

    var stack = [];
    var blocked = [];
    var B = {};
    var Ak = [];
    var s;

    function unblock(u) {
        blocked[u] = false;
        if(B.hasOwnProperty(u)) {
            Object.keys(B[u]).forEach(function(w) {
                delete B[u][w];
                if(blocked[w]) {unblock(w);}
            });
        }
    }

    function circuit(v) {
        var found = false;

        stack.push(v);
        blocked[v] = true;

        // L1
        var i;
        var w;
        for(i = 0; i < Ak[v].length; i++) {
            w = Ak[v][i];
            if(w === s) {
                output(s, stack);
                found = true;
            } else if(!blocked[w]) {
                found = circuit(w);
            }
        }

        // L2
        if(found) {
            unblock(v);
        } else {
            for(i = 0; i < Ak[v].length; i++) {
                w = Ak[v][i];
                var entry = B[w];

                if(!entry) {
                    entry = {};
                    B[w] = entry;
                }

                entry[w] = true;
            }
        }
        stack.pop();
        return found;
    }

    function output(start, stack) {
        var cycle = [].concat(stack).concat(start);
        if(cb) {
            cb(circuit);
        } else {
            circuits.push(cycle);
        }
    }

    function subgraph(minId) {
      // Remove edges with indice smaller than minId
        for(var i = 0; i < edges.length; i++) {
            if(i < minId) edges[i] = [];
            edges[i] = edges[i].filter(function(i) {
                return i >= minId;
            });
        }
    }

    function adjacencyStructureSCC(from) {
        // Make subgraph starting from vertex minId
        subgraph(from);
        var g = edges;

        // Find strongly connected components using Tarjan algorithm
        var sccs = tarjan(g);

        // Filter out trivial connected components (ie. made of one node)
        var ccs = sccs.components.filter(function(scc) {
            return scc.length > 1;
        });

        // Find least vertex
        var leastVertex = Infinity;
        var leastVertexComponent;
        for(var i = 0; i < ccs.length; i++) {
            for(var j = 0; j < ccs[i].length; j++) {
                if(ccs[i][j] < leastVertex) {
                    leastVertex = ccs[i][j];
                    leastVertexComponent = i;
                }
            }
        }

        var cc = ccs[leastVertexComponent];

        if(!cc) return false;

        // Return the adjacency list of first component
        var adjList = edges.map(function(l, index) {
            if(cc.indexOf(index) === -1) return [];
            return l.filter(function(i) {
                return cc.indexOf(i) !== -1;
            });
        });

        return {
            leastVertex: leastVertex,
            adjList: adjList
        };
    }

    s = 0;
    var n = edges.length;
    while(s < n) {
        // find strong component with least vertex in
        // subgraph starting from vertex `s`
        var p = adjacencyStructureSCC(s);

        // Its least vertex
        s = p.leastVertex;
        // Its adjacency list
        Ak = p.adjList;

        if(Ak) {
            for(var i = 0; i < Ak.length; i++) {
                for(var j = 0; j < Ak[i].length; j++) {
                    var vertexId = Ak[i][j];
                    blocked[+vertexId] = false;
                    B[vertexId] = {};
                }
            }
            circuit(s);
            s = s + 1;
        } else {
            s = n;
        }

    }

    if(cb) {
        return;
    } else {
        return circuits;
    }
};


/***/ }),

/***/ 40891:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(71129);

/** @type {import('.')} */
var $defineProperty = GetIntrinsic('%Object.defineProperty%', true) || false;
if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = false;
	}
}

module.exports = $defineProperty;


/***/ }),

/***/ 35465:
/***/ (function(module) {

"use strict";


/** @type {import('./eval')} */
module.exports = EvalError;


/***/ }),

/***/ 77731:
/***/ (function(module) {

"use strict";


/** @type {import('.')} */
module.exports = Error;


/***/ }),

/***/ 30582:
/***/ (function(module) {

"use strict";


/** @type {import('./range')} */
module.exports = RangeError;


/***/ }),

/***/ 50294:
/***/ (function(module) {

"use strict";


/** @type {import('./ref')} */
module.exports = ReferenceError;


/***/ }),

/***/ 98800:
/***/ (function(module) {

"use strict";


/** @type {import('./syntax')} */
module.exports = SyntaxError;


/***/ }),

/***/ 48631:
/***/ (function(module) {

"use strict";


/** @type {import('./type')} */
module.exports = TypeError;


/***/ }),

/***/ 33149:
/***/ (function(module) {

"use strict";


/** @type {import('./uri')} */
module.exports = URIError;


/***/ }),

/***/ 91445:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
// Inspired by Google Closure:
// http://closure-library.googlecode.com/svn/docs/
// closure_goog_array_array.js.html#goog.array.clear



var value = __webpack_require__(69746);

module.exports = function () {
	value(this).length = 0;
	return this;
};


/***/ }),

/***/ 82377:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(57712)() ? Array.from : __webpack_require__(33468);


/***/ }),

/***/ 57712:
/***/ (function(module) {

"use strict";


module.exports = function () {
	var from = Array.from, arr, result;
	if (typeof from !== "function") return false;
	arr = ["raz", "dwa"];
	result = from(arr);
	return Boolean(result && result !== arr && result[1] === "dwa");
};


/***/ }),

/***/ 33468:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var iteratorSymbol = (__webpack_require__(63008).iterator)
  , isArguments    = __webpack_require__(82262)
  , isFunction     = __webpack_require__(59356)
  , toPosInt       = __webpack_require__(54653)
  , callable       = __webpack_require__(52359)
  , validValue     = __webpack_require__(69746)
  , isValue        = __webpack_require__(1974)
  , isString       = __webpack_require__(48488)
  , isArray        = Array.isArray
  , call           = Function.prototype.call
  , desc           = { configurable: true, enumerable: true, writable: true, value: null }
  , defineProperty = Object.defineProperty;

// eslint-disable-next-line complexity, max-lines-per-function
module.exports = function (arrayLike /*, mapFn, thisArg*/) {
	var mapFn = arguments[1]
	  , thisArg = arguments[2]
	  , Context
	  , i
	  , j
	  , arr
	  , length
	  , code
	  , iterator
	  , result
	  , getIterator
	  , value;

	arrayLike = Object(validValue(arrayLike));

	if (isValue(mapFn)) callable(mapFn);
	if (!this || this === Array || !isFunction(this)) {
		// Result: Plain array
		if (!mapFn) {
			if (isArguments(arrayLike)) {
				// Source: Arguments
				length = arrayLike.length;
				if (length !== 1) return Array.apply(null, arrayLike);
				arr = new Array(1);
				arr[0] = arrayLike[0];
				return arr;
			}
			if (isArray(arrayLike)) {
				// Source: Array
				arr = new Array((length = arrayLike.length));
				for (i = 0; i < length; ++i) arr[i] = arrayLike[i];
				return arr;
			}
		}
		arr = [];
	} else {
		// Result: Non plain array
		Context = this;
	}

	if (!isArray(arrayLike)) {
		if ((getIterator = arrayLike[iteratorSymbol]) !== undefined) {
			// Source: Iterator
			iterator = callable(getIterator).call(arrayLike);
			if (Context) arr = new Context();
			result = iterator.next();
			i = 0;
			while (!result.done) {
				value = mapFn ? call.call(mapFn, thisArg, result.value, i) : result.value;
				if (Context) {
					desc.value = value;
					defineProperty(arr, i, desc);
				} else {
					arr[i] = value;
				}
				result = iterator.next();
				++i;
			}
			length = i;
		} else if (isString(arrayLike)) {
			// Source: String
			length = arrayLike.length;
			if (Context) arr = new Context();
			for (i = 0, j = 0; i < length; ++i) {
				value = arrayLike[i];
				if (i + 1 < length) {
					code = value.charCodeAt(0);
					// eslint-disable-next-line max-depth
					if (code >= 0xd800 && code <= 0xdbff) value += arrayLike[++i];
				}
				value = mapFn ? call.call(mapFn, thisArg, value, j) : value;
				if (Context) {
					desc.value = value;
					defineProperty(arr, j, desc);
				} else {
					arr[j] = value;
				}
				++j;
			}
			length = j;
		}
	}
	if (length === undefined) {
		// Source: array or array-like
		length = toPosInt(arrayLike.length);
		if (Context) arr = new Context(length);
		for (i = 0; i < length; ++i) {
			value = mapFn ? call.call(mapFn, thisArg, arrayLike[i], i) : arrayLike[i];
			if (Context) {
				desc.value = value;
				defineProperty(arr, i, desc);
			} else {
				arr[i] = value;
			}
		}
	}
	if (Context) {
		desc.value = null;
		arr.length = length;
	}
	return arr;
};


/***/ }),

/***/ 82262:
/***/ (function(module) {

"use strict";


var objToString = Object.prototype.toString
  , id = objToString.call((function () { return arguments; })());

module.exports = function (value) { return objToString.call(value) === id; };


/***/ }),

/***/ 59356:
/***/ (function(module) {

"use strict";


var objToString = Object.prototype.toString
  , isFunctionStringTag = RegExp.prototype.test.bind(/^[object [A-Za-z0-9]*Function]$/);

module.exports = function (value) {
	return typeof value === "function" && isFunctionStringTag(objToString.call(value));
};


/***/ }),

/***/ 62039:
/***/ (function(module) {

"use strict";


// eslint-disable-next-line no-empty-function
module.exports = function () {};


/***/ }),

/***/ 53579:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(67394)() ? Math.sign : __webpack_require__(37122);


/***/ }),

/***/ 67394:
/***/ (function(module) {

"use strict";


module.exports = function () {
	var sign = Math.sign;
	if (typeof sign !== "function") return false;
	return sign(10) === 1 && sign(-20) === -1;
};


/***/ }),

/***/ 37122:
/***/ (function(module) {

"use strict";


module.exports = function (value) {
	value = Number(value);
	if (isNaN(value) || value === 0) return value;
	return value > 0 ? 1 : -1;
};


/***/ }),

/***/ 10226:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var sign  = __webpack_require__(53579)
  , abs   = Math.abs
  , floor = Math.floor;

module.exports = function (value) {
	if (isNaN(value)) return 0;
	value = Number(value);
	if (value === 0 || !isFinite(value)) return value;
	return sign(value) * floor(abs(value));
};


/***/ }),

/***/ 54653:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var toInteger = __webpack_require__(10226)
  , max       = Math.max;

module.exports = function (value) { return max(0, toInteger(value)); };


/***/ }),

/***/ 39395:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
// Internal method, used by iteration functions.
// Calls a function for each key-value pair found in object
// Optionally takes compareFn to iterate object in specific order



var callable                = __webpack_require__(52359)
  , value                   = __webpack_require__(69746)
  , bind                    = Function.prototype.bind
  , call                    = Function.prototype.call
  , keys                    = Object.keys
  , objPropertyIsEnumerable = Object.prototype.propertyIsEnumerable;

module.exports = function (method, defVal) {
	return function (obj, cb /*, thisArg, compareFn*/) {
		var list, thisArg = arguments[2], compareFn = arguments[3];
		obj = Object(value(obj));
		callable(cb);

		list = keys(obj);
		if (compareFn) {
			list.sort(typeof compareFn === "function" ? bind.call(compareFn, obj) : undefined);
		}
		if (typeof method !== "function") method = list[method];
		return call.call(method, list, function (key, index) {
			if (!objPropertyIsEnumerable.call(obj, key)) return defVal;
			return call.call(cb, thisArg, obj[key], key, obj, index);
		});
	};
};


/***/ }),

/***/ 1920:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(41271)() ? Object.assign : __webpack_require__(26399);


/***/ }),

/***/ 41271:
/***/ (function(module) {

"use strict";


module.exports = function () {
	var assign = Object.assign, obj;
	if (typeof assign !== "function") return false;
	obj = { foo: "raz" };
	assign(obj, { bar: "dwa" }, { trzy: "trzy" });
	return obj.foo + obj.bar + obj.trzy === "razdwatrzy";
};


/***/ }),

/***/ 26399:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var keys  = __webpack_require__(36353)
  , value = __webpack_require__(69746)
  , max   = Math.max;

module.exports = function (dest, src /*, …srcn*/) {
	var error, i, length = max(arguments.length, 2), assign;
	dest = Object(value(dest));
	assign = function (key) {
		try {
			dest[key] = src[key];
		} catch (e) {
			if (!error) error = e;
		}
	};
	for (i = 1; i < length; ++i) {
		src = arguments[i];
		keys(src).forEach(assign);
	}
	if (error !== undefined) throw error;
	return dest;
};


/***/ }),

/***/ 86591:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var aFrom  = __webpack_require__(82377)
  , assign = __webpack_require__(1920)
  , value  = __webpack_require__(69746);

module.exports = function (obj /*, propertyNames, options*/) {
	var copy = Object(value(obj)), propertyNames = arguments[1], options = Object(arguments[2]);
	if (copy !== obj && !propertyNames) return copy;
	var result = {};
	if (propertyNames) {
		aFrom(propertyNames, function (propertyName) {
			if (options.ensure || propertyName in obj) result[propertyName] = obj[propertyName];
		});
	} else {
		assign(result, obj);
	}
	return result;
};


/***/ }),

/***/ 57842:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
// Workaround for http://code.google.com/p/v8/issues/detail?id=2804



var create = Object.create, shim;

if (!__webpack_require__(90361)()) {
	shim = __webpack_require__(45765);
}

module.exports = (function () {
	var nullObject, polyProps, desc;
	if (!shim) return create;
	if (shim.level !== 1) return create;

	nullObject = {};
	polyProps = {};
	desc = { configurable: false, enumerable: false, writable: true, value: undefined };
	Object.getOwnPropertyNames(Object.prototype).forEach(function (name) {
		if (name === "__proto__") {
			polyProps[name] = {
				configurable: true,
				enumerable: false,
				writable: true,
				value: undefined
			};
			return;
		}
		polyProps[name] = desc;
	});
	Object.defineProperties(nullObject, polyProps);

	Object.defineProperty(shim, "nullPolyfill", {
		configurable: false,
		enumerable: false,
		writable: false,
		value: nullObject
	});

	return function (prototype, props) {
		return create(prototype === null ? nullObject : prototype, props);
	};
})();


/***/ }),

/***/ 82813:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(39395)("forEach");


/***/ }),

/***/ 76064:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isValue = __webpack_require__(1974);

var map = { function: true, object: true };

module.exports = function (value) { return (isValue(value) && map[typeof value]) || false; };


/***/ }),

/***/ 1974:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var _undefined = __webpack_require__(62039)(); // Support ES3 engines

module.exports = function (val) { return val !== _undefined && val !== null; };


/***/ }),

/***/ 36353:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(83800)() ? Object.keys : __webpack_require__(67044);


/***/ }),

/***/ 83800:
/***/ (function(module) {

"use strict";


module.exports = function () {
	try {
		Object.keys("primitive");
		return true;
	} catch (e) {
		return false;
	}
};


/***/ }),

/***/ 67044:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isValue = __webpack_require__(1974);

var keys = Object.keys;

module.exports = function (object) { return keys(isValue(object) ? Object(object) : object); };


/***/ }),

/***/ 29854:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var callable = __webpack_require__(52359)
  , forEach  = __webpack_require__(82813)
  , call     = Function.prototype.call;

module.exports = function (obj, cb /*, thisArg*/) {
	var result = {}, thisArg = arguments[2];
	callable(cb);
	forEach(obj, function (value, key, targetObj, index) {
		result[key] = call.call(cb, thisArg, value, key, targetObj, index);
	});
	return result;
};


/***/ }),

/***/ 76504:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isValue = __webpack_require__(1974);

var forEach = Array.prototype.forEach, create = Object.create;

var process = function (src, obj) {
	var key;
	for (key in src) obj[key] = src[key];
};

// eslint-disable-next-line no-unused-vars
module.exports = function (opts1 /*, …options*/) {
	var result = create(null);
	forEach.call(arguments, function (options) {
		if (!isValue(options)) return;
		process(Object(options), result);
	});
	return result;
};


/***/ }),

/***/ 22834:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(90361)() ? Object.setPrototypeOf : __webpack_require__(45765);


/***/ }),

/***/ 90361:
/***/ (function(module) {

"use strict";


var create = Object.create, getPrototypeOf = Object.getPrototypeOf, plainObject = {};

module.exports = function (/* CustomCreate*/) {
	var setPrototypeOf = Object.setPrototypeOf, customCreate = arguments[0] || create;
	if (typeof setPrototypeOf !== "function") return false;
	return getPrototypeOf(setPrototypeOf(customCreate(null), plainObject)) === plainObject;
};


/***/ }),

/***/ 45765:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint no-proto: "off" */

// Big thanks to @WebReflection for sorting this out
// https://gist.github.com/WebReflection/5593554



var isObject         = __webpack_require__(76064)
  , value            = __webpack_require__(69746)
  , objIsPrototypeOf = Object.prototype.isPrototypeOf
  , defineProperty   = Object.defineProperty
  , nullDesc         = { configurable: true, enumerable: false, writable: true, value: undefined }
  , validate;

validate = function (obj, prototype) {
	value(obj);
	if (prototype === null || isObject(prototype)) return obj;
	throw new TypeError("Prototype must be null or an object");
};

module.exports = (function (status) {
	var fn, set;
	if (!status) return null;
	if (status.level === 2) {
		if (status.set) {
			set = status.set;
			fn = function (obj, prototype) {
				set.call(validate(obj, prototype), prototype);
				return obj;
			};
		} else {
			fn = function (obj, prototype) {
				validate(obj, prototype).__proto__ = prototype;
				return obj;
			};
		}
	} else {
		fn = function self(obj, prototype) {
			var isNullBase;
			validate(obj, prototype);
			isNullBase = objIsPrototypeOf.call(self.nullPolyfill, obj);
			if (isNullBase) delete self.nullPolyfill.__proto__;
			if (prototype === null) prototype = self.nullPolyfill;
			obj.__proto__ = prototype;
			if (isNullBase) defineProperty(self.nullPolyfill, "__proto__", nullDesc);
			return obj;
		};
	}
	return Object.defineProperty(fn, "level", {
		configurable: false,
		enumerable: false,
		writable: false,
		value: status.level
	});
})(
	(function () {
		var tmpObj1 = Object.create(null)
		  , tmpObj2 = {}
		  , set
		  , desc = Object.getOwnPropertyDescriptor(Object.prototype, "__proto__");

		if (desc) {
			try {
				set = desc.set; // Opera crashes at this point
				set.call(tmpObj1, tmpObj2);
			} catch (ignore) {}
			if (Object.getPrototypeOf(tmpObj1) === tmpObj2) return { set: set, level: 2 };
		}

		tmpObj1.__proto__ = tmpObj2;
		if (Object.getPrototypeOf(tmpObj1) === tmpObj2) return { level: 2 };

		tmpObj1 = {};
		tmpObj1.__proto__ = tmpObj2;
		if (Object.getPrototypeOf(tmpObj1) === tmpObj2) return { level: 1 };

		return false;
	})()
);

__webpack_require__(57842);


/***/ }),

/***/ 52359:
/***/ (function(module) {

"use strict";


module.exports = function (fn) {
	if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
	return fn;
};


/***/ }),

/***/ 11004:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isObject = __webpack_require__(76064);

module.exports = function (value) {
	if (!isObject(value)) throw new TypeError(value + " is not an Object");
	return value;
};


/***/ }),

/***/ 69746:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isValue = __webpack_require__(1974);

module.exports = function (value) {
	if (!isValue(value)) throw new TypeError("Cannot use null or undefined");
	return value;
};


/***/ }),

/***/ 2338:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(65961)() ? String.prototype.contains : __webpack_require__(9461);


/***/ }),

/***/ 65961:
/***/ (function(module) {

"use strict";


var str = "razdwatrzy";

module.exports = function () {
	if (typeof str.contains !== "function") return false;
	return str.contains("dwa") === true && str.contains("foo") === false;
};


/***/ }),

/***/ 9461:
/***/ (function(module) {

"use strict";


var indexOf = String.prototype.indexOf;

module.exports = function (searchString /*, position*/) {
	return indexOf.call(this, searchString, arguments[1]) > -1;
};


/***/ }),

/***/ 48488:
/***/ (function(module) {

"use strict";


var objToString = Object.prototype.toString, id = objToString.call("");

module.exports = function (value) {
	return (
		typeof value === "string" ||
		(value &&
			typeof value === "object" &&
			(value instanceof String || objToString.call(value) === id)) ||
		false
	);
};


/***/ }),

/***/ 43497:
/***/ (function(module) {

"use strict";


var generated = Object.create(null), random = Math.random;

module.exports = function () {
	var str;
	do {
		str = random().toString(36).slice(2);
	} while (generated[str]);
	return str;
};


/***/ }),

/***/ 71343:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var setPrototypeOf = __webpack_require__(22834)
  , contains       = __webpack_require__(2338)
  , d              = __webpack_require__(91819)
  , Symbol         = __webpack_require__(63008)
  , Iterator       = __webpack_require__(85490);

var defineProperty = Object.defineProperty, ArrayIterator;

ArrayIterator = module.exports = function (arr, kind) {
	if (!(this instanceof ArrayIterator)) throw new TypeError("Constructor requires 'new'");
	Iterator.call(this, arr);
	if (!kind) kind = "value";
	else if (contains.call(kind, "key+value")) kind = "key+value";
	else if (contains.call(kind, "key")) kind = "key";
	else kind = "value";
	defineProperty(this, "__kind__", d("", kind));
};
if (setPrototypeOf) setPrototypeOf(ArrayIterator, Iterator);

// Internal %ArrayIteratorPrototype% doesn't expose its constructor
delete ArrayIterator.prototype.constructor;

ArrayIterator.prototype = Object.create(Iterator.prototype, {
	_resolve: d(function (i) {
		if (this.__kind__ === "value") return this.__list__[i];
		if (this.__kind__ === "key+value") return [i, this.__list__[i]];
		return i;
	})
});
defineProperty(ArrayIterator.prototype, Symbol.toStringTag, d("c", "Array Iterator"));


/***/ }),

/***/ 58755:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isArguments = __webpack_require__(82262)
  , callable    = __webpack_require__(52359)
  , isString    = __webpack_require__(48488)
  , get         = __webpack_require__(34494);

var isArray = Array.isArray, call = Function.prototype.call, some = Array.prototype.some;

module.exports = function (iterable, cb /*, thisArg*/) {
	var mode, thisArg = arguments[2], result, doBreak, broken, i, length, char, code;
	if (isArray(iterable) || isArguments(iterable)) mode = "array";
	else if (isString(iterable)) mode = "string";
	else iterable = get(iterable);

	callable(cb);
	doBreak = function () {
		broken = true;
	};
	if (mode === "array") {
		some.call(iterable, function (value) {
			call.call(cb, thisArg, value, doBreak);
			return broken;
		});
		return;
	}
	if (mode === "string") {
		length = iterable.length;
		for (i = 0; i < length; ++i) {
			char = iterable[i];
			if (i + 1 < length) {
				code = char.charCodeAt(0);
				if (code >= 0xd800 && code <= 0xdbff) char += iterable[++i];
			}
			call.call(cb, thisArg, char, doBreak);
			if (broken) break;
		}
		return;
	}
	result = iterable.next();

	while (!result.done) {
		call.call(cb, thisArg, result.value, doBreak);
		if (broken) return;
		result = iterable.next();
	}
};


/***/ }),

/***/ 34494:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isArguments    = __webpack_require__(82262)
  , isString       = __webpack_require__(48488)
  , ArrayIterator  = __webpack_require__(71343)
  , StringIterator = __webpack_require__(23417)
  , iterable       = __webpack_require__(82831)
  , iteratorSymbol = (__webpack_require__(63008).iterator);

module.exports = function (obj) {
	if (typeof iterable(obj)[iteratorSymbol] === "function") return obj[iteratorSymbol]();
	if (isArguments(obj)) return new ArrayIterator(obj);
	if (isString(obj)) return new StringIterator(obj);
	return new ArrayIterator(obj);
};


/***/ }),

/***/ 85490:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var clear    = __webpack_require__(91445)
  , assign   = __webpack_require__(1920)
  , callable = __webpack_require__(52359)
  , value    = __webpack_require__(69746)
  , d        = __webpack_require__(91819)
  , autoBind = __webpack_require__(84510)
  , Symbol   = __webpack_require__(63008);

var defineProperty = Object.defineProperty, defineProperties = Object.defineProperties, Iterator;

module.exports = Iterator = function (list, context) {
	if (!(this instanceof Iterator)) throw new TypeError("Constructor requires 'new'");
	defineProperties(this, {
		__list__: d("w", value(list)),
		__context__: d("w", context),
		__nextIndex__: d("w", 0)
	});
	if (!context) return;
	callable(context.on);
	context.on("_add", this._onAdd);
	context.on("_delete", this._onDelete);
	context.on("_clear", this._onClear);
};

// Internal %IteratorPrototype% doesn't expose its constructor
delete Iterator.prototype.constructor;

defineProperties(
	Iterator.prototype,
	assign(
		{
			_next: d(function () {
				var i;
				if (!this.__list__) return undefined;
				if (this.__redo__) {
					i = this.__redo__.shift();
					if (i !== undefined) return i;
				}
				if (this.__nextIndex__ < this.__list__.length) return this.__nextIndex__++;
				this._unBind();
				return undefined;
			}),
			next: d(function () {
				return this._createResult(this._next());
			}),
			_createResult: d(function (i) {
				if (i === undefined) return { done: true, value: undefined };
				return { done: false, value: this._resolve(i) };
			}),
			_resolve: d(function (i) {
				return this.__list__[i];
			}),
			_unBind: d(function () {
				this.__list__ = null;
				delete this.__redo__;
				if (!this.__context__) return;
				this.__context__.off("_add", this._onAdd);
				this.__context__.off("_delete", this._onDelete);
				this.__context__.off("_clear", this._onClear);
				this.__context__ = null;
			}),
			toString: d(function () {
				return "[object " + (this[Symbol.toStringTag] || "Object") + "]";
			})
		},
		autoBind({
			_onAdd: d(function (index) {
				if (index >= this.__nextIndex__) return;
				++this.__nextIndex__;
				if (!this.__redo__) {
					defineProperty(this, "__redo__", d("c", [index]));
					return;
				}
				this.__redo__.forEach(function (redo, i) {
					if (redo >= index) this.__redo__[i] = ++redo;
				}, this);
				this.__redo__.push(index);
			}),
			_onDelete: d(function (index) {
				var i;
				if (index >= this.__nextIndex__) return;
				--this.__nextIndex__;
				if (!this.__redo__) return;
				i = this.__redo__.indexOf(index);
				if (i !== -1) this.__redo__.splice(i, 1);
				this.__redo__.forEach(function (redo, j) {
					if (redo > index) this.__redo__[j] = --redo;
				}, this);
			}),
			_onClear: d(function () {
				if (this.__redo__) clear.call(this.__redo__);
				this.__nextIndex__ = 0;
			})
		})
	)
);

defineProperty(
	Iterator.prototype,
	Symbol.iterator,
	d(function () {
		return this;
	})
);


/***/ }),

/***/ 50567:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isArguments = __webpack_require__(82262)
  , isValue     = __webpack_require__(1974)
  , isString    = __webpack_require__(48488);

var iteratorSymbol = (__webpack_require__(63008).iterator)
  , isArray        = Array.isArray;

module.exports = function (value) {
	if (!isValue(value)) return false;
	if (isArray(value)) return true;
	if (isString(value)) return true;
	if (isArguments(value)) return true;
	return typeof value[iteratorSymbol] === "function";
};


/***/ }),

/***/ 23417:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
// Thanks @mathiasbynens
// http://mathiasbynens.be/notes/javascript-unicode#iterating-over-symbols



var setPrototypeOf = __webpack_require__(22834)
  , d              = __webpack_require__(91819)
  , Symbol         = __webpack_require__(63008)
  , Iterator       = __webpack_require__(85490);

var defineProperty = Object.defineProperty, StringIterator;

StringIterator = module.exports = function (str) {
	if (!(this instanceof StringIterator)) throw new TypeError("Constructor requires 'new'");
	str = String(str);
	Iterator.call(this, str);
	defineProperty(this, "__length__", d("", str.length));
};
if (setPrototypeOf) setPrototypeOf(StringIterator, Iterator);

// Internal %ArrayIteratorPrototype% doesn't expose its constructor
delete StringIterator.prototype.constructor;

StringIterator.prototype = Object.create(Iterator.prototype, {
	_next: d(function () {
		if (!this.__list__) return undefined;
		if (this.__nextIndex__ < this.__length__) return this.__nextIndex__++;
		this._unBind();
		return undefined;
	}),
	_resolve: d(function (i) {
		var char = this.__list__[i], code;
		if (this.__nextIndex__ === this.__length__) return char;
		code = char.charCodeAt(0);
		if (code >= 0xd800 && code <= 0xdbff) return char + this.__list__[this.__nextIndex__++];
		return char;
	})
});
defineProperty(StringIterator.prototype, Symbol.toStringTag, d("c", "String Iterator"));


/***/ }),

/***/ 82831:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isIterable = __webpack_require__(50567);

module.exports = function (value) {
	if (!isIterable(value)) throw new TypeError(value + " is not iterable");
	return value;
};


/***/ }),

/***/ 63008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(25143)()
	? (__webpack_require__(64725).Symbol)
	: __webpack_require__(81905);


/***/ }),

/***/ 25143:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var global     = __webpack_require__(64725)
  , validTypes = { object: true, symbol: true };

module.exports = function () {
	var Symbol = global.Symbol;
	var symbol;
	if (typeof Symbol !== "function") return false;
	symbol = Symbol("test symbol");
	try { String(symbol); }
	catch (e) { return false; }

	// Return 'true' also for polyfills
	if (!validTypes[typeof Symbol.iterator]) return false;
	if (!validTypes[typeof Symbol.toPrimitive]) return false;
	if (!validTypes[typeof Symbol.toStringTag]) return false;

	return true;
};


/***/ }),

/***/ 41707:
/***/ (function(module) {

"use strict";


module.exports = function (value) {
	if (!value) return false;
	if (typeof value === "symbol") return true;
	if (!value.constructor) return false;
	if (value.constructor.name !== "Symbol") return false;
	return value[value.constructor.toStringTag] === "Symbol";
};


/***/ }),

/***/ 74009:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d = __webpack_require__(91819);

var create = Object.create, defineProperty = Object.defineProperty, objPrototype = Object.prototype;

var created = create(null);
module.exports = function (desc) {
	var postfix = 0, name, ie11BugWorkaround;
	while (created[desc + (postfix || "")]) ++postfix;
	desc += postfix || "";
	created[desc] = true;
	name = "@@" + desc;
	defineProperty(
		objPrototype,
		name,
		d.gs(null, function (value) {
			// For IE11 issue see:
			// https://connect.microsoft.com/IE/feedbackdetail/view/1928508/
			//    ie11-broken-getters-on-dom-objects
			// https://github.com/medikoo/es6-symbol/issues/12
			if (ie11BugWorkaround) return;
			ie11BugWorkaround = true;
			defineProperty(this, name, d(value));
			ie11BugWorkaround = false;
		})
	);
	return name;
};


/***/ }),

/***/ 40313:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d            = __webpack_require__(91819)
  , NativeSymbol = (__webpack_require__(64725).Symbol);

module.exports = function (SymbolPolyfill) {
	return Object.defineProperties(SymbolPolyfill, {
		// To ensure proper interoperability with other native functions (e.g. Array.from)
		// fallback to eventual native implementation of given symbol
		hasInstance: d(
			"", (NativeSymbol && NativeSymbol.hasInstance) || SymbolPolyfill("hasInstance")
		),
		isConcatSpreadable: d(
			"",
			(NativeSymbol && NativeSymbol.isConcatSpreadable) ||
				SymbolPolyfill("isConcatSpreadable")
		),
		iterator: d("", (NativeSymbol && NativeSymbol.iterator) || SymbolPolyfill("iterator")),
		match: d("", (NativeSymbol && NativeSymbol.match) || SymbolPolyfill("match")),
		replace: d("", (NativeSymbol && NativeSymbol.replace) || SymbolPolyfill("replace")),
		search: d("", (NativeSymbol && NativeSymbol.search) || SymbolPolyfill("search")),
		species: d("", (NativeSymbol && NativeSymbol.species) || SymbolPolyfill("species")),
		split: d("", (NativeSymbol && NativeSymbol.split) || SymbolPolyfill("split")),
		toPrimitive: d(
			"", (NativeSymbol && NativeSymbol.toPrimitive) || SymbolPolyfill("toPrimitive")
		),
		toStringTag: d(
			"", (NativeSymbol && NativeSymbol.toStringTag) || SymbolPolyfill("toStringTag")
		),
		unscopables: d(
			"", (NativeSymbol && NativeSymbol.unscopables) || SymbolPolyfill("unscopables")
		)
	});
};


/***/ }),

/***/ 21290:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var d              = __webpack_require__(91819)
  , validateSymbol = __webpack_require__(91765);

var registry = Object.create(null);

module.exports = function (SymbolPolyfill) {
	return Object.defineProperties(SymbolPolyfill, {
		for: d(function (key) {
			if (registry[key]) return registry[key];
			return (registry[key] = SymbolPolyfill(String(key)));
		}),
		keyFor: d(function (symbol) {
			var key;
			validateSymbol(symbol);
			for (key in registry) {
				if (registry[key] === symbol) return key;
			}
			return undefined;
		})
	});
};


/***/ }),

/***/ 81905:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
// ES2015 Symbol polyfill for environments that do not (or partially) support it



var d                    = __webpack_require__(91819)
  , validateSymbol       = __webpack_require__(91765)
  , NativeSymbol         = (__webpack_require__(64725).Symbol)
  , generateName         = __webpack_require__(74009)
  , setupStandardSymbols = __webpack_require__(40313)
  , setupSymbolRegistry  = __webpack_require__(21290);

var create = Object.create
  , defineProperties = Object.defineProperties
  , defineProperty = Object.defineProperty;

var SymbolPolyfill, HiddenSymbol, isNativeSafe;

if (typeof NativeSymbol === "function") {
	try {
		String(NativeSymbol());
		isNativeSafe = true;
	} catch (ignore) {}
} else {
	NativeSymbol = null;
}

// Internal constructor (not one exposed) for creating Symbol instances.
// This one is used to ensure that `someSymbol instanceof Symbol` always return false
HiddenSymbol = function Symbol(description) {
	if (this instanceof HiddenSymbol) throw new TypeError("Symbol is not a constructor");
	return SymbolPolyfill(description);
};

// Exposed `Symbol` constructor
// (returns instances of HiddenSymbol)
module.exports = SymbolPolyfill = function Symbol(description) {
	var symbol;
	if (this instanceof Symbol) throw new TypeError("Symbol is not a constructor");
	if (isNativeSafe) return NativeSymbol(description);
	symbol = create(HiddenSymbol.prototype);
	description = description === undefined ? "" : String(description);
	return defineProperties(symbol, {
		__description__: d("", description),
		__name__: d("", generateName(description))
	});
};

setupStandardSymbols(SymbolPolyfill);
setupSymbolRegistry(SymbolPolyfill);

// Internal tweaks for real symbol producer
defineProperties(HiddenSymbol.prototype, {
	constructor: d(SymbolPolyfill),
	toString: d("", function () { return this.__name__; })
});

// Proper implementation of methods exposed on Symbol.prototype
// They won't be accessible on produced symbol instances as they derive from HiddenSymbol.prototype
defineProperties(SymbolPolyfill.prototype, {
	toString: d(function () { return "Symbol (" + validateSymbol(this).__description__ + ")"; }),
	valueOf: d(function () { return validateSymbol(this); })
});
defineProperty(
	SymbolPolyfill.prototype,
	SymbolPolyfill.toPrimitive,
	d("", function () {
		var symbol = validateSymbol(this);
		if (typeof symbol === "symbol") return symbol;
		return symbol.toString();
	})
);
defineProperty(SymbolPolyfill.prototype, SymbolPolyfill.toStringTag, d("c", "Symbol"));

// Proper implementaton of toPrimitive and toStringTag for returned symbol instances
defineProperty(
	HiddenSymbol.prototype, SymbolPolyfill.toStringTag,
	d("c", SymbolPolyfill.prototype[SymbolPolyfill.toStringTag])
);

// Note: It's important to define `toPrimitive` as last one, as some implementations
// implement `toPrimitive` natively without implementing `toStringTag` (or other specified symbols)
// And that may invoke error in definition flow:
// See: https://github.com/medikoo/es6-symbol/issues/13#issuecomment-164146149
defineProperty(
	HiddenSymbol.prototype, SymbolPolyfill.toPrimitive,
	d("c", SymbolPolyfill.prototype[SymbolPolyfill.toPrimitive])
);


/***/ }),

/***/ 91765:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isSymbol = __webpack_require__(41707);

module.exports = function (value) {
	if (!isSymbol(value)) throw new TypeError(value + " is not a symbol");
	return value;
};


/***/ }),

/***/ 93103:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(22742)() ? WeakMap : __webpack_require__(21780);


/***/ }),

/***/ 22742:
/***/ (function(module) {

"use strict";


module.exports = function () {
	var weakMap, obj;

	if (typeof WeakMap !== "function") return false;
	try {
		// WebKit doesn't support arguments and crashes
		weakMap = new WeakMap([[obj = {}, "one"], [{}, "two"], [{}, "three"]]);
	} catch (e) {
		return false;
	}
	if (String(weakMap) !== "[object WeakMap]") return false;
	if (typeof weakMap.set !== "function") return false;
	if (weakMap.set({}, 1) !== weakMap) return false;
	if (typeof weakMap.delete !== "function") return false;
	if (typeof weakMap.has !== "function") return false;
	if (weakMap.get(obj) !== "one") return false;

	return true;
};


/***/ }),

/***/ 81810:
/***/ (function(module) {

"use strict";
// Exports true if environment provides native `WeakMap` implementation, whatever that is.



module.exports = (function () {
	if (typeof WeakMap !== "function") return false;
	return Object.prototype.toString.call(new WeakMap()) === "[object WeakMap]";
}());


/***/ }),

/***/ 21780:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isValue           = __webpack_require__(1974)
  , setPrototypeOf    = __webpack_require__(22834)
  , object            = __webpack_require__(11004)
  , ensureValue       = __webpack_require__(69746)
  , randomUniq        = __webpack_require__(43497)
  , d                 = __webpack_require__(91819)
  , getIterator       = __webpack_require__(34494)
  , forOf             = __webpack_require__(58755)
  , toStringTagSymbol = (__webpack_require__(63008).toStringTag)
  , isNative          = __webpack_require__(81810)

  , isArray = Array.isArray, defineProperty = Object.defineProperty
  , objHasOwnProperty = Object.prototype.hasOwnProperty, getPrototypeOf = Object.getPrototypeOf
  , WeakMapPoly;

module.exports = WeakMapPoly = function (/* Iterable*/) {
	var iterable = arguments[0], self;

	if (!(this instanceof WeakMapPoly)) throw new TypeError("Constructor requires 'new'");
	self = isNative && setPrototypeOf && (WeakMap !== WeakMapPoly)
		? setPrototypeOf(new WeakMap(), getPrototypeOf(this)) : this;

	if (isValue(iterable)) {
		if (!isArray(iterable)) iterable = getIterator(iterable);
	}
	defineProperty(self, "__weakMapData__", d("c", "$weakMap$" + randomUniq()));
	if (!iterable) return self;
	forOf(iterable, function (val) {
		ensureValue(val);
		self.set(val[0], val[1]);
	});
	return self;
};

if (isNative) {
	if (setPrototypeOf) setPrototypeOf(WeakMapPoly, WeakMap);
	WeakMapPoly.prototype = Object.create(WeakMap.prototype, { constructor: d(WeakMapPoly) });
}

Object.defineProperties(WeakMapPoly.prototype, {
	delete: d(function (key) {
		if (objHasOwnProperty.call(object(key), this.__weakMapData__)) {
			delete key[this.__weakMapData__];
			return true;
		}
		return false;
	}),
	get: d(function (key) {
		if (!objHasOwnProperty.call(object(key), this.__weakMapData__)) return undefined;
		return key[this.__weakMapData__];
	}),
	has: d(function (key) {
		return objHasOwnProperty.call(object(key), this.__weakMapData__);
	}),
	set: d(function (key, value) {
		defineProperty(object(key), this.__weakMapData__, d("c", value));
		return this;
	}),
	toString: d(function () {
		return "[object WeakMap]";
	})
});
defineProperty(WeakMapPoly.prototype, toStringTagSymbol, d("c", "WeakMap"));


/***/ }),

/***/ 7683:
/***/ (function(module) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var R = typeof Reflect === 'object' ? Reflect : null
var ReflectApply = R && typeof R.apply === 'function'
  ? R.apply
  : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
  }

var ReflectOwnKeys
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target)
      .concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
}

function EventEmitter() {
  EventEmitter.init.call(this);
}
module.exports = EventEmitter;
module.exports.once = once;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

function checkListener(listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
}

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});

EventEmitter.init = function() {

  if (this._events === undefined ||
      this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function _getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return _getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
  var doError = (type === 'error');

  var events = this._events;
  if (events !== undefined)
    doError = (doError && events.error === undefined);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined)
    return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      ReflectApply(listeners[i], this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  checkListener(listener);

  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
        prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = _getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' +
                          existing.length + ' ' + String(type) + ' listeners ' +
                          'added. Use emitter.setMaxListeners() to ' +
                          'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    if (arguments.length === 0)
      return this.listener.call(this.target);
    return this.listener.apply(this.target, arguments);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  checkListener(listener);
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      checkListener(listener);
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      checkListener(listener);

      events = this._events;
      if (events === undefined)
        return this;

      list = events[type];
      if (list === undefined)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = Object.create(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener !== undefined)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (events === undefined)
        return this;

      // not listening for removeListener, no need to emit
      if (events.removeListener === undefined) {
        if (arguments.length === 0) {
          this._events = Object.create(null);
          this._eventsCount = 0;
        } else if (events[type] !== undefined) {
          if (--this._eventsCount === 0)
            this._events = Object.create(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners !== undefined) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (events === undefined)
    return [];

  var evlistener = events[type];
  if (evlistener === undefined)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ?
    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}

function once(emitter, name) {
  return new Promise(function (resolve, reject) {
    function errorListener(err) {
      emitter.removeListener(name, resolver);
      reject(err);
    }

    function resolver() {
      if (typeof emitter.removeListener === 'function') {
        emitter.removeListener('error', errorListener);
      }
      resolve([].slice.call(arguments));
    };

    eventTargetAgnosticAddListener(emitter, name, resolver, { once: true });
    if (name !== 'error') {
      addErrorHandlerIfEventEmitter(emitter, errorListener, { once: true });
    }
  });
}

function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
  if (typeof emitter.on === 'function') {
    eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
  }
}

function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
  if (typeof emitter.on === 'function') {
    if (flags.once) {
      emitter.once(name, listener);
    } else {
      emitter.on(name, listener);
    }
  } else if (typeof emitter.addEventListener === 'function') {
    // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
      // IE does not have builtin `{ once: true }` support so we
      // have to do it manually.
      if (flags.once) {
        emitter.removeEventListener(name, wrapListener);
      }
      listener(arg);
    });
  } else {
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
  }
}


/***/ }),

/***/ 77083:
/***/ (function(module) {

var naiveFallback = function () {
	if (typeof self === "object" && self) return self;
	if (typeof window === "object" && window) return window;
	throw new Error("Unable to resolve global `this`");
};

module.exports = (function () {
	if (this) return this;

	// Unexpected strict mode (may happen if e.g. bundled into ESM module)

	// Thanks @mathiasbynens -> https://mathiasbynens.be/notes/globalthis
	// In all ES5+ engines global object inherits from Object.prototype
	// (if you approached one that doesn't please report)
	try {
		Object.defineProperty(Object.prototype, "__global__", {
			get: function () { return this; },
			configurable: true
		});
	} catch (error) {
		// Unfortunate case of Object.prototype being sealed (via preventExtensions, seal or freeze)
		return naiveFallback();
	}
	try {
		// Safari case (window.__global__ is resolved with global context, but __global__ does not)
		if (!__global__) return naiveFallback();
		return __global__;
	} finally {
		delete Object.prototype.__global__;
	}
})();


/***/ }),

/***/ 64725:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(17804)() ? globalThis : __webpack_require__(77083);


/***/ }),

/***/ 17804:
/***/ (function(module) {

"use strict";


module.exports = function () {
	if (typeof globalThis !== "object") return false;
	if (!globalThis) return false;
	return globalThis.Array === Array;
};


/***/ }),

/***/ 10721:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * inspired by is-number <https://github.com/jonschlinkert/is-number>
 * but significantly simplified and sped up by ignoring number and string constructors
 * ie these return false:
 *   new Number(1)
 *   new String('1')
 */



var allBlankCharCodes = __webpack_require__(9914);

module.exports = function(n) {
    var type = typeof n;
    if(type === 'string') {
        var original = n;
        n = +n;
        // whitespace strings cast to zero - filter them out
        if(n===0 && allBlankCharCodes(original)) return false;
    }
    else if(type !== 'number') return false;

    return n - n < 1;
};


/***/ }),

/***/ 83473:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/*eslint new-cap:0*/
var dtype = __webpack_require__(10275)

module.exports = flattenVertexData

function flattenVertexData (data, output, offset) {
  if (!data) throw new TypeError('must specify data as first parameter')
  offset = +(offset || 0) | 0

  if (Array.isArray(data) && (data[0] && typeof data[0][0] === 'number')) {
    var dim = data[0].length
    var length = data.length * dim
    var i, j, k, l

    // no output specified, create a new typed array
    if (!output || typeof output === 'string') {
      output = new (dtype(output || 'float32'))(length + offset)
    }

    var dstLength = output.length - offset
    if (length !== dstLength) {
      throw new Error('source length ' + length + ' (' + dim + 'x' + data.length + ')' +
        ' does not match destination length ' + dstLength)
    }

    for (i = 0, k = offset; i < data.length; i++) {
      for (j = 0; j < dim; j++) {
        output[k++] = data[i][j] === null ? NaN : data[i][j]
      }
    }
  } else {
    if (!output || typeof output === 'string') {
      // no output, create a new one
      var Ctor = dtype(output || 'float32')

      // handle arrays separately due to possible nulls
      if (Array.isArray(data) || output === 'array') {
        output = new Ctor(data.length + offset)
        for (i = 0, k = offset, l = output.length; k < l; k++, i++) {
          output[k] = data[i] === null ? NaN : data[i]
        }
      } else {
        if (offset === 0) {
          output = new Ctor(data)
        } else {
          output = new Ctor(data.length + offset)

          output.set(data, offset)
        }
      }
    } else {
      // store output in existing array
      output.set(data, offset)
    }
  }

  return output
}


/***/ }),

/***/ 68950:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var stringifyFont = __webpack_require__(38211)
var defaultChars = [32, 126]

module.exports = atlas

function atlas(options) {
  options = options || {}

  var shape  = options.shape ? options.shape : options.canvas ? [options.canvas.width, options.canvas.height] : [512, 512]
  var canvas = options.canvas || document.createElement('canvas')
  var font   = options.font
  var step   = typeof options.step === 'number' ? [options.step, options.step] : options.step || [32, 32]
  var chars  = options.chars || defaultChars

  if (font && typeof font !== 'string') font = stringifyFont(font)

  if (!Array.isArray(chars)) {
    chars = String(chars).split('')
  } else
  if (chars.length === 2
    && typeof chars[0] === 'number'
    && typeof chars[1] === 'number'
  ) {
    var newchars = []

    for (var i = chars[0], j = 0; i <= chars[1]; i++) {
      newchars[j++] = String.fromCharCode(i)
    }

    chars = newchars
  }

  shape = shape.slice()
  canvas.width  = shape[0]
  canvas.height = shape[1]

  var ctx = canvas.getContext('2d')

  ctx.fillStyle = '#000'
  ctx.fillRect(0, 0, canvas.width, canvas.height)

  ctx.font = font
  ctx.textAlign = 'center'
  ctx.textBaseline = 'middle'
  ctx.fillStyle = '#fff'

  var x = step[0] / 2
  var y = step[1] / 2
  for (var i = 0; i < chars.length; i++) {
    ctx.fillText(chars[i], x, y)
    if ((x += step[0]) > shape[0] - step[0]/2) (x = step[0]/2), (y += step[1])
  }

  return canvas
}


/***/ }),

/***/ 12673:
/***/ (function(module) {

"use strict";


module.exports = measure

measure.canvas = document.createElement('canvas')
measure.cache = {}

function measure (font, o) {
	if (!o) o = {}

	if (typeof font === 'string' || Array.isArray(font)) {
		o.family = font
	}

	var family = Array.isArray(o.family) ? o.family.join(', ') : o.family
	if (!family) throw Error('`family` must be defined')

	var fs = o.size || o.fontSize || o.em || 48
	var weight = o.weight || o.fontWeight || ''
	var style = o.style || o.fontStyle || ''
	var font = [style, weight, fs].join(' ') + 'px ' + family
	var origin = o.origin || 'top'

	if (measure.cache[family]) {
		// return more precise values if cache has them
		if (fs <= measure.cache[family].em) {
			return applyOrigin(measure.cache[family], origin)
		}
	}

	var canvas = o.canvas || measure.canvas
	var ctx = canvas.getContext('2d')
	var chars = {
		upper: o.upper !== undefined ? o.upper : 'H',
		lower: o.lower !== undefined ? o.lower : 'x',
		descent: o.descent !== undefined ? o.descent : 'p',
		ascent: o.ascent !== undefined ? o.ascent : 'h',
		tittle: o.tittle !== undefined ? o.tittle : 'i',
		overshoot: o.overshoot !== undefined ? o.overshoot : 'O'
	}
	var l = Math.ceil(fs * 1.5)
	canvas.height = l
	canvas.width = l * .5
	ctx.font = font

	var char = 'H'
	var result = {
		top: 0
	}

	// measure line-height
	ctx.clearRect(0, 0, l, l)
	ctx.textBaseline = 'top'
	ctx.fillStyle = 'black'
	ctx.fillText(char, 0, 0)
	var topPx = firstTop(ctx.getImageData(0, 0, l, l))
	ctx.clearRect(0, 0, l, l)
	ctx.textBaseline = 'bottom'
	ctx.fillText(char, 0, l)
	var bottomPx = firstTop(ctx.getImageData(0, 0, l, l))
	result.lineHeight =
	result.bottom = l - bottomPx + topPx

	// measure baseline
	ctx.clearRect(0, 0, l, l)
	ctx.textBaseline = 'alphabetic'
	ctx.fillText(char, 0, l)
	var baselinePx = firstTop(ctx.getImageData(0, 0, l, l))
	var baseline = l - baselinePx - 1 + topPx
	result.baseline =
	result.alphabetic = baseline

	// measure median
	ctx.clearRect(0, 0, l, l)
	ctx.textBaseline = 'middle'
	ctx.fillText(char, 0, l * .5)
	var medianPx = firstTop(ctx.getImageData(0, 0, l, l))
	result.median =
	result.middle = l - medianPx - 1 + topPx - l * .5

	// measure hanging
	ctx.clearRect(0, 0, l, l)
	ctx.textBaseline = 'hanging'
	ctx.fillText(char, 0, l * .5)
	var hangingPx = firstTop(ctx.getImageData(0, 0, l, l))
	result.hanging = l - hangingPx - 1 + topPx - l * .5

	// measure ideographic
	ctx.clearRect(0, 0, l, l)
	ctx.textBaseline = 'ideographic'
	ctx.fillText(char, 0, l)
	var ideographicPx = firstTop(ctx.getImageData(0, 0, l, l))
	result.ideographic = l - ideographicPx - 1 + topPx

	// measure cap
	if (chars.upper) {
		ctx.clearRect(0, 0, l, l)
		ctx.textBaseline = 'top'
		ctx.fillText(chars.upper, 0, 0)
		result.upper = firstTop(ctx.getImageData(0, 0, l, l))
		result.capHeight = (result.baseline - result.upper)
	}

	// measure x
	if (chars.lower) {
		ctx.clearRect(0, 0, l, l)
		ctx.textBaseline = 'top'
		ctx.fillText(chars.lower, 0, 0)
		result.lower = firstTop(ctx.getImageData(0, 0, l, l))
		result.xHeight = (result.baseline - result.lower)
	}

	// measure tittle
	if (chars.tittle) {
		ctx.clearRect(0, 0, l, l)
		ctx.textBaseline = 'top'
		ctx.fillText(chars.tittle, 0, 0)
		result.tittle = firstTop(ctx.getImageData(0, 0, l, l))
	}

	// measure ascent
	if (chars.ascent) {
		ctx.clearRect(0, 0, l, l)
		ctx.textBaseline = 'top'
		ctx.fillText(chars.ascent, 0, 0)
		result.ascent = firstTop(ctx.getImageData(0, 0, l, l))
	}

	// measure descent
	if (chars.descent) {
		ctx.clearRect(0, 0, l, l)
		ctx.textBaseline = 'top'
		ctx.fillText(chars.descent, 0, 0)
		result.descent = firstBottom(ctx.getImageData(0, 0, l, l))
	}

	// measure overshoot
	if (chars.overshoot) {
		ctx.clearRect(0, 0, l, l)
		ctx.textBaseline = 'top'
		ctx.fillText(chars.overshoot, 0, 0)
		var overshootPx = firstBottom(ctx.getImageData(0, 0, l, l))
		result.overshoot = overshootPx - baseline
	}

	// normalize result
	for (var name in result) {
		result[name] /= fs
	}

	result.em = fs
	measure.cache[family] = result

	return applyOrigin(result, origin)
}

function applyOrigin(obj, origin) {
	var res = {}
	if (typeof origin === 'string') origin = obj[origin]
	for (var name in obj) {
		if (name === 'em') continue
		res[name] = obj[name] - origin
	}
	return res
}

function firstTop(iData) {
	var l = iData.height
	var data = iData.data
	for (var i = 3; i < data.length; i+=4) {
		if (data[i] !== 0) {
			return Math.floor((i - 3) *.25 / l)
		}
	}
}

function firstBottom(iData) {
	var l = iData.height
	var data = iData.data
	for (var i = data.length - 1; i > 0; i -= 4) {
		if (data[i] !== 0) {
			return Math.floor((i - 3) *.25 / l)
		}
	}
}


/***/ }),

/***/ 61262:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isCallable = __webpack_require__(82756);

var toStr = Object.prototype.toString;
var hasOwnProperty = Object.prototype.hasOwnProperty;

var forEachArray = function forEachArray(array, iterator, receiver) {
    for (var i = 0, len = array.length; i < len; i++) {
        if (hasOwnProperty.call(array, i)) {
            if (receiver == null) {
                iterator(array[i], i, array);
            } else {
                iterator.call(receiver, array[i], i, array);
            }
        }
    }
};

var forEachString = function forEachString(string, iterator, receiver) {
    for (var i = 0, len = string.length; i < len; i++) {
        // no such thing as a sparse string.
        if (receiver == null) {
            iterator(string.charAt(i), i, string);
        } else {
            iterator.call(receiver, string.charAt(i), i, string);
        }
    }
};

var forEachObject = function forEachObject(object, iterator, receiver) {
    for (var k in object) {
        if (hasOwnProperty.call(object, k)) {
            if (receiver == null) {
                iterator(object[k], k, object);
            } else {
                iterator.call(receiver, object[k], k, object);
            }
        }
    }
};

var forEach = function forEach(list, iterator, thisArg) {
    if (!isCallable(iterator)) {
        throw new TypeError('iterator must be a function');
    }

    var receiver;
    if (arguments.length >= 3) {
        receiver = thisArg;
    }

    if (toStr.call(list) === '[object Array]') {
        forEachArray(list, iterator, receiver);
    } else if (typeof list === 'string') {
        forEachString(list, iterator, receiver);
    } else {
        forEachObject(list, iterator, receiver);
    }
};

module.exports = forEach;


/***/ }),

/***/ 31917:
/***/ (function(module) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var toStr = Object.prototype.toString;
var max = Math.max;
var funcType = '[object Function]';

var concatty = function concatty(a, b) {
    var arr = [];

    for (var i = 0; i < a.length; i += 1) {
        arr[i] = a[i];
    }
    for (var j = 0; j < b.length; j += 1) {
        arr[j + a.length] = b[j];
    }

    return arr;
};

var slicy = function slicy(arrLike, offset) {
    var arr = [];
    for (var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) {
        arr[j] = arrLike[i];
    }
    return arr;
};

var joiny = function (arr, joiner) {
    var str = '';
    for (var i = 0; i < arr.length; i += 1) {
        str += arr[i];
        if (i + 1 < arr.length) {
            str += joiner;
        }
    }
    return str;
};

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.apply(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slicy(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                concatty(args, arguments)
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        }
        return target.apply(
            that,
            concatty(args, arguments)
        );

    };

    var boundLength = max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs[i] = '$' + i;
    }

    bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),

/***/ 87547:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(31917);

module.exports = Function.prototype.bind || implementation;


/***/ }),

/***/ 72880:
/***/ (function(module) {

module.exports = getCanvasContext
function getCanvasContext (type, opts) {
  if (typeof type !== 'string') {
    throw new TypeError('must specify type string')
  }

  opts = opts || {}

  if (typeof document === 'undefined' && !opts.canvas) {
    return null // check for Node
  }

  var canvas = opts.canvas || document.createElement('canvas')
  if (typeof opts.width === 'number') {
    canvas.width = opts.width
  }
  if (typeof opts.height === 'number') {
    canvas.height = opts.height
  }

  var attribs = opts
  var gl
  try {
    var names = [ type ]
    // prefix GL contexts
    if (type.indexOf('webgl') === 0) {
      names.push('experimental-' + type)
    }

    for (var i = 0; i < names.length; i++) {
      gl = canvas.getContext(names[i], attribs)
      if (gl) return gl
    }
  } catch (e) {
    gl = null
  }
  return (gl || null) // ensure null on fail
}


/***/ }),

/***/ 71129:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var undefined;

var $Error = __webpack_require__(77731);
var $EvalError = __webpack_require__(35465);
var $RangeError = __webpack_require__(30582);
var $ReferenceError = __webpack_require__(50294);
var $SyntaxError = __webpack_require__(98800);
var $TypeError = __webpack_require__(48631);
var $URIError = __webpack_require__(33149);

var $Function = Function;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(8771)();
var hasProto = __webpack_require__(58436)();

var getProto = Object.getPrototypeOf || (
	hasProto
		? function (x) { return x.__proto__; } // eslint-disable-line no-proto
		: null
);

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	__proto__: null,
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
	'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': $Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': $EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': $RangeError,
	'%ReferenceError%': $ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': $URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};

if (getProto) {
	try {
		null.error; // eslint-disable-line no-unused-expressions
	} catch (e) {
		// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
		var errorProto = getProto(getProto(e));
		INTRINSICS['%Error.prototype%'] = errorProto;
	}
}

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen && getProto) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	__proto__: null,
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__(87547);
var hasOwn = __webpack_require__(80753);
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);
var $exec = bind.call(Function.call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};


/***/ }),

/***/ 84840:
/***/ (function(module) {

module.exports = adjoint;

/**
 * Calculates the adjugate of a mat4
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the source matrix
 * @returns {mat4} out
 */
function adjoint(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3],
        a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7],
        a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11],
        a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];

    out[0]  =  (a11 * (a22 * a33 - a23 * a32) - a21 * (a12 * a33 - a13 * a32) + a31 * (a12 * a23 - a13 * a22));
    out[1]  = -(a01 * (a22 * a33 - a23 * a32) - a21 * (a02 * a33 - a03 * a32) + a31 * (a02 * a23 - a03 * a22));
    out[2]  =  (a01 * (a12 * a33 - a13 * a32) - a11 * (a02 * a33 - a03 * a32) + a31 * (a02 * a13 - a03 * a12));
    out[3]  = -(a01 * (a12 * a23 - a13 * a22) - a11 * (a02 * a23 - a03 * a22) + a21 * (a02 * a13 - a03 * a12));
    out[4]  = -(a10 * (a22 * a33 - a23 * a32) - a20 * (a12 * a33 - a13 * a32) + a30 * (a12 * a23 - a13 * a22));
    out[5]  =  (a00 * (a22 * a33 - a23 * a32) - a20 * (a02 * a33 - a03 * a32) + a30 * (a02 * a23 - a03 * a22));
    out[6]  = -(a00 * (a12 * a33 - a13 * a32) - a10 * (a02 * a33 - a03 * a32) + a30 * (a02 * a13 - a03 * a12));
    out[7]  =  (a00 * (a12 * a23 - a13 * a22) - a10 * (a02 * a23 - a03 * a22) + a20 * (a02 * a13 - a03 * a12));
    out[8]  =  (a10 * (a21 * a33 - a23 * a31) - a20 * (a11 * a33 - a13 * a31) + a30 * (a11 * a23 - a13 * a21));
    out[9]  = -(a00 * (a21 * a33 - a23 * a31) - a20 * (a01 * a33 - a03 * a31) + a30 * (a01 * a23 - a03 * a21));
    out[10] =  (a00 * (a11 * a33 - a13 * a31) - a10 * (a01 * a33 - a03 * a31) + a30 * (a01 * a13 - a03 * a11));
    out[11] = -(a00 * (a11 * a23 - a13 * a21) - a10 * (a01 * a23 - a03 * a21) + a20 * (a01 * a13 - a03 * a11));
    out[12] = -(a10 * (a21 * a32 - a22 * a31) - a20 * (a11 * a32 - a12 * a31) + a30 * (a11 * a22 - a12 * a21));
    out[13] =  (a00 * (a21 * a32 - a22 * a31) - a20 * (a01 * a32 - a02 * a31) + a30 * (a01 * a22 - a02 * a21));
    out[14] = -(a00 * (a11 * a32 - a12 * a31) - a10 * (a01 * a32 - a02 * a31) + a30 * (a01 * a12 - a02 * a11));
    out[15] =  (a00 * (a11 * a22 - a12 * a21) - a10 * (a01 * a22 - a02 * a21) + a20 * (a01 * a12 - a02 * a11));
    return out;
};

/***/ }),

/***/ 99698:
/***/ (function(module) {

module.exports = clone;

/**
 * Creates a new mat4 initialized with values from an existing matrix
 *
 * @param {mat4} a matrix to clone
 * @returns {mat4} a new 4x4 matrix
 */
function clone(a) {
    var out = new Float32Array(16);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    out[9] = a[9];
    out[10] = a[10];
    out[11] = a[11];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
};

/***/ }),

/***/ 57938:
/***/ (function(module) {

module.exports = copy;

/**
 * Copy the values from one mat4 to another
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the source matrix
 * @returns {mat4} out
 */
function copy(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    out[9] = a[9];
    out[10] = a[10];
    out[11] = a[11];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
};

/***/ }),

/***/ 87519:
/***/ (function(module) {

module.exports = create;

/**
 * Creates a new identity mat4
 *
 * @returns {mat4} a new 4x4 matrix
 */
function create() {
    var out = new Float32Array(16);
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
};

/***/ }),

/***/ 6900:
/***/ (function(module) {

module.exports = determinant;

/**
 * Calculates the determinant of a mat4
 *
 * @param {mat4} a the source matrix
 * @returns {Number} determinant of a
 */
function determinant(a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3],
        a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7],
        a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11],
        a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15],

        b00 = a00 * a11 - a01 * a10,
        b01 = a00 * a12 - a02 * a10,
        b02 = a00 * a13 - a03 * a10,
        b03 = a01 * a12 - a02 * a11,
        b04 = a01 * a13 - a03 * a11,
        b05 = a02 * a13 - a03 * a12,
        b06 = a20 * a31 - a21 * a30,
        b07 = a20 * a32 - a22 * a30,
        b08 = a20 * a33 - a23 * a30,
        b09 = a21 * a32 - a22 * a31,
        b10 = a21 * a33 - a23 * a31,
        b11 = a22 * a33 - a23 * a32;

    // Calculate the determinant
    return b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
};

/***/ }),

/***/ 36472:
/***/ (function(module) {

module.exports = fromQuat;

/**
 * Creates a matrix from a quaternion rotation.
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {quat4} q Rotation quaternion
 * @returns {mat4} out
 */
function fromQuat(out, q) {
    var x = q[0], y = q[1], z = q[2], w = q[3],
        x2 = x + x,
        y2 = y + y,
        z2 = z + z,

        xx = x * x2,
        yx = y * x2,
        yy = y * y2,
        zx = z * x2,
        zy = z * y2,
        zz = z * z2,
        wx = w * x2,
        wy = w * y2,
        wz = w * z2;

    out[0] = 1 - yy - zz;
    out[1] = yx + wz;
    out[2] = zx - wy;
    out[3] = 0;

    out[4] = yx - wz;
    out[5] = 1 - xx - zz;
    out[6] = zy + wx;
    out[7] = 0;

    out[8] = zx + wy;
    out[9] = zy - wx;
    out[10] = 1 - xx - yy;
    out[11] = 0;

    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;

    return out;
};

/***/ }),

/***/ 43061:
/***/ (function(module) {

module.exports = fromRotation

/**
 * Creates a matrix from a given angle around a given axis
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest)
 *     mat4.rotate(dest, dest, rad, axis)
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {Number} rad the angle to rotate the matrix by
 * @param {vec3} axis the axis to rotate around
 * @returns {mat4} out
 */
function fromRotation(out, rad, axis) {
  var s, c, t
  var x = axis[0]
  var y = axis[1]
  var z = axis[2]
  var len = Math.sqrt(x * x + y * y + z * z)

  if (Math.abs(len) < 0.000001) {
    return null
  }

  len = 1 / len
  x *= len
  y *= len
  z *= len

  s = Math.sin(rad)
  c = Math.cos(rad)
  t = 1 - c

  // Perform rotation-specific matrix multiplication
  out[0] = x * x * t + c
  out[1] = y * x * t + z * s
  out[2] = z * x * t - y * s
  out[3] = 0
  out[4] = x * y * t - z * s
  out[5] = y * y * t + c
  out[6] = z * y * t + x * s
  out[7] = 0
  out[8] = x * z * t + y * s
  out[9] = y * z * t - x * s
  out[10] = z * z * t + c
  out[11] = 0
  out[12] = 0
  out[13] = 0
  out[14] = 0
  out[15] = 1
  return out
}


/***/ }),

/***/ 33606:
/***/ (function(module) {

module.exports = fromRotationTranslation;

/**
 * Creates a matrix from a quaternion rotation and vector translation
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.translate(dest, vec);
 *     var quatMat = mat4.create();
 *     quat4.toMat4(quat, quatMat);
 *     mat4.multiply(dest, quatMat);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {quat4} q Rotation quaternion
 * @param {vec3} v Translation vector
 * @returns {mat4} out
 */
function fromRotationTranslation(out, q, v) {
    // Quaternion math
    var x = q[0], y = q[1], z = q[2], w = q[3],
        x2 = x + x,
        y2 = y + y,
        z2 = z + z,

        xx = x * x2,
        xy = x * y2,
        xz = x * z2,
        yy = y * y2,
        yz = y * z2,
        zz = z * z2,
        wx = w * x2,
        wy = w * y2,
        wz = w * z2;

    out[0] = 1 - (yy + zz);
    out[1] = xy + wz;
    out[2] = xz - wy;
    out[3] = 0;
    out[4] = xy - wz;
    out[5] = 1 - (xx + zz);
    out[6] = yz + wx;
    out[7] = 0;
    out[8] = xz + wy;
    out[9] = yz - wx;
    out[10] = 1 - (xx + yy);
    out[11] = 0;
    out[12] = v[0];
    out[13] = v[1];
    out[14] = v[2];
    out[15] = 1;
    
    return out;
};

/***/ }),

/***/ 98698:
/***/ (function(module) {

module.exports = fromScaling

/**
 * Creates a matrix from a vector scaling
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest)
 *     mat4.scale(dest, dest, vec)
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {vec3} v Scaling vector
 * @returns {mat4} out
 */
function fromScaling(out, v) {
  out[0] = v[0]
  out[1] = 0
  out[2] = 0
  out[3] = 0
  out[4] = 0
  out[5] = v[1]
  out[6] = 0
  out[7] = 0
  out[8] = 0
  out[9] = 0
  out[10] = v[2]
  out[11] = 0
  out[12] = 0
  out[13] = 0
  out[14] = 0
  out[15] = 1
  return out
}


/***/ }),

/***/ 6924:
/***/ (function(module) {

module.exports = fromTranslation

/**
 * Creates a matrix from a vector translation
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest)
 *     mat4.translate(dest, dest, vec)
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {vec3} v Translation vector
 * @returns {mat4} out
 */
function fromTranslation(out, v) {
  out[0] = 1
  out[1] = 0
  out[2] = 0
  out[3] = 0
  out[4] = 0
  out[5] = 1
  out[6] = 0
  out[7] = 0
  out[8] = 0
  out[9] = 0
  out[10] = 1
  out[11] = 0
  out[12] = v[0]
  out[13] = v[1]
  out[14] = v[2]
  out[15] = 1
  return out
}


/***/ }),

/***/ 81181:
/***/ (function(module) {

module.exports = fromXRotation

/**
 * Creates a matrix from the given angle around the X axis
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest)
 *     mat4.rotateX(dest, dest, rad)
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */
function fromXRotation(out, rad) {
    var s = Math.sin(rad),
        c = Math.cos(rad)

    // Perform axis-specific matrix multiplication
    out[0] = 1
    out[1] = 0
    out[2] = 0
    out[3] = 0
    out[4] = 0
    out[5] = c
    out[6] = s
    out[7] = 0
    out[8] = 0
    out[9] = -s
    out[10] = c
    out[11] = 0
    out[12] = 0
    out[13] = 0
    out[14] = 0
    out[15] = 1
    return out
}

/***/ }),

/***/ 95258:
/***/ (function(module) {

module.exports = fromYRotation

/**
 * Creates a matrix from the given angle around the Y axis
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest)
 *     mat4.rotateY(dest, dest, rad)
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */
function fromYRotation(out, rad) {
    var s = Math.sin(rad),
        c = Math.cos(rad)

    // Perform axis-specific matrix multiplication
    out[0] = c
    out[1] = 0
    out[2] = -s
    out[3] = 0
    out[4] = 0
    out[5] = 1
    out[6] = 0
    out[7] = 0
    out[8] = s
    out[9] = 0
    out[10] = c
    out[11] = 0
    out[12] = 0
    out[13] = 0
    out[14] = 0
    out[15] = 1
    return out
}

/***/ }),

/***/ 94815:
/***/ (function(module) {

module.exports = fromZRotation

/**
 * Creates a matrix from the given angle around the Z axis
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest)
 *     mat4.rotateZ(dest, dest, rad)
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */
function fromZRotation(out, rad) {
    var s = Math.sin(rad),
        c = Math.cos(rad)

    // Perform axis-specific matrix multiplication
    out[0] = c
    out[1] = s
    out[2] = 0
    out[3] = 0
    out[4] = -s
    out[5] = c
    out[6] = 0
    out[7] = 0
    out[8] = 0
    out[9] = 0
    out[10] = 1
    out[11] = 0
    out[12] = 0
    out[13] = 0
    out[14] = 0
    out[15] = 1
    return out
}

/***/ }),

/***/ 87301:
/***/ (function(module) {

module.exports = frustum;

/**
 * Generates a frustum matrix with the given bounds
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {Number} left Left bound of the frustum
 * @param {Number} right Right bound of the frustum
 * @param {Number} bottom Bottom bound of the frustum
 * @param {Number} top Top bound of the frustum
 * @param {Number} near Near bound of the frustum
 * @param {Number} far Far bound of the frustum
 * @returns {mat4} out
 */
function frustum(out, left, right, bottom, top, near, far) {
    var rl = 1 / (right - left),
        tb = 1 / (top - bottom),
        nf = 1 / (near - far);
    out[0] = (near * 2) * rl;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = (near * 2) * tb;
    out[6] = 0;
    out[7] = 0;
    out[8] = (right + left) * rl;
    out[9] = (top + bottom) * tb;
    out[10] = (far + near) * nf;
    out[11] = -1;
    out[12] = 0;
    out[13] = 0;
    out[14] = (far * near * 2) * nf;
    out[15] = 0;
    return out;
};

/***/ }),

/***/ 87193:
/***/ (function(module) {

module.exports = identity;

/**
 * Set a mat4 to the identity matrix
 *
 * @param {mat4} out the receiving matrix
 * @returns {mat4} out
 */
function identity(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
};

/***/ }),

/***/ 11191:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = {
  create: __webpack_require__(87519)
  , clone: __webpack_require__(99698)
  , copy: __webpack_require__(57938)
  , identity: __webpack_require__(87193)
  , transpose: __webpack_require__(10256)
  , invert: __webpack_require__(96559)
  , adjoint: __webpack_require__(84840)
  , determinant: __webpack_require__(6900)
  , multiply: __webpack_require__(14787)
  , translate: __webpack_require__(4165)
  , scale: __webpack_require__(8697)
  , rotate: __webpack_require__(32416)
  , rotateX: __webpack_require__(81066)
  , rotateY: __webpack_require__(54201)
  , rotateZ: __webpack_require__(33920)
  , fromRotation: __webpack_require__(43061)
  , fromRotationTranslation: __webpack_require__(33606)
  , fromScaling: __webpack_require__(98698)
  , fromTranslation: __webpack_require__(6924)
  , fromXRotation: __webpack_require__(81181)
  , fromYRotation: __webpack_require__(95258)
  , fromZRotation: __webpack_require__(94815)
  , fromQuat: __webpack_require__(36472)
  , frustum: __webpack_require__(87301)
  , perspective: __webpack_require__(5313)
  , perspectiveFromFieldOfView: __webpack_require__(22253)
  , ortho: __webpack_require__(4633)
  , lookAt: __webpack_require__(26645)
  , str: __webpack_require__(66992)
}


/***/ }),

/***/ 96559:
/***/ (function(module) {

module.exports = invert;

/**
 * Inverts a mat4
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the source matrix
 * @returns {mat4} out
 */
function invert(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3],
        a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7],
        a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11],
        a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15],

        b00 = a00 * a11 - a01 * a10,
        b01 = a00 * a12 - a02 * a10,
        b02 = a00 * a13 - a03 * a10,
        b03 = a01 * a12 - a02 * a11,
        b04 = a01 * a13 - a03 * a11,
        b05 = a02 * a13 - a03 * a12,
        b06 = a20 * a31 - a21 * a30,
        b07 = a20 * a32 - a22 * a30,
        b08 = a20 * a33 - a23 * a30,
        b09 = a21 * a32 - a22 * a31,
        b10 = a21 * a33 - a23 * a31,
        b11 = a22 * a33 - a23 * a32,

        // Calculate the determinant
        det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;

    if (!det) { 
        return null; 
    }
    det = 1.0 / det;

    out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
    out[1] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
    out[2] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
    out[3] = (a22 * b04 - a21 * b05 - a23 * b03) * det;
    out[4] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
    out[5] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
    out[6] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
    out[7] = (a20 * b05 - a22 * b02 + a23 * b01) * det;
    out[8] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
    out[9] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
    out[10] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
    out[11] = (a21 * b02 - a20 * b04 - a23 * b00) * det;
    out[12] = (a11 * b07 - a10 * b09 - a12 * b06) * det;
    out[13] = (a00 * b09 - a01 * b07 + a02 * b06) * det;
    out[14] = (a31 * b01 - a30 * b03 - a32 * b00) * det;
    out[15] = (a20 * b03 - a21 * b01 + a22 * b00) * det;

    return out;
};

/***/ }),

/***/ 26645:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var identity = __webpack_require__(87193);

module.exports = lookAt;

/**
 * Generates a look-at matrix with the given eye position, focal point, and up axis
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {vec3} eye Position of the viewer
 * @param {vec3} center Point the viewer is looking at
 * @param {vec3} up vec3 pointing up
 * @returns {mat4} out
 */
function lookAt(out, eye, center, up) {
    var x0, x1, x2, y0, y1, y2, z0, z1, z2, len,
        eyex = eye[0],
        eyey = eye[1],
        eyez = eye[2],
        upx = up[0],
        upy = up[1],
        upz = up[2],
        centerx = center[0],
        centery = center[1],
        centerz = center[2];

    if (Math.abs(eyex - centerx) < 0.000001 &&
        Math.abs(eyey - centery) < 0.000001 &&
        Math.abs(eyez - centerz) < 0.000001) {
        return identity(out);
    }

    z0 = eyex - centerx;
    z1 = eyey - centery;
    z2 = eyez - centerz;

    len = 1 / Math.sqrt(z0 * z0 + z1 * z1 + z2 * z2);
    z0 *= len;
    z1 *= len;
    z2 *= len;

    x0 = upy * z2 - upz * z1;
    x1 = upz * z0 - upx * z2;
    x2 = upx * z1 - upy * z0;
    len = Math.sqrt(x0 * x0 + x1 * x1 + x2 * x2);
    if (!len) {
        x0 = 0;
        x1 = 0;
        x2 = 0;
    } else {
        len = 1 / len;
        x0 *= len;
        x1 *= len;
        x2 *= len;
    }

    y0 = z1 * x2 - z2 * x1;
    y1 = z2 * x0 - z0 * x2;
    y2 = z0 * x1 - z1 * x0;

    len = Math.sqrt(y0 * y0 + y1 * y1 + y2 * y2);
    if (!len) {
        y0 = 0;
        y1 = 0;
        y2 = 0;
    } else {
        len = 1 / len;
        y0 *= len;
        y1 *= len;
        y2 *= len;
    }

    out[0] = x0;
    out[1] = y0;
    out[2] = z0;
    out[3] = 0;
    out[4] = x1;
    out[5] = y1;
    out[6] = z1;
    out[7] = 0;
    out[8] = x2;
    out[9] = y2;
    out[10] = z2;
    out[11] = 0;
    out[12] = -(x0 * eyex + x1 * eyey + x2 * eyez);
    out[13] = -(y0 * eyex + y1 * eyey + y2 * eyez);
    out[14] = -(z0 * eyex + z1 * eyey + z2 * eyez);
    out[15] = 1;

    return out;
};

/***/ }),

/***/ 14787:
/***/ (function(module) {

module.exports = multiply;

/**
 * Multiplies two mat4's
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the first operand
 * @param {mat4} b the second operand
 * @returns {mat4} out
 */
function multiply(out, a, b) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3],
        a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7],
        a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11],
        a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];

    // Cache only the current line of the second matrix
    var b0  = b[0], b1 = b[1], b2 = b[2], b3 = b[3];  
    out[0] = b0*a00 + b1*a10 + b2*a20 + b3*a30;
    out[1] = b0*a01 + b1*a11 + b2*a21 + b3*a31;
    out[2] = b0*a02 + b1*a12 + b2*a22 + b3*a32;
    out[3] = b0*a03 + b1*a13 + b2*a23 + b3*a33;

    b0 = b[4]; b1 = b[5]; b2 = b[6]; b3 = b[7];
    out[4] = b0*a00 + b1*a10 + b2*a20 + b3*a30;
    out[5] = b0*a01 + b1*a11 + b2*a21 + b3*a31;
    out[6] = b0*a02 + b1*a12 + b2*a22 + b3*a32;
    out[7] = b0*a03 + b1*a13 + b2*a23 + b3*a33;

    b0 = b[8]; b1 = b[9]; b2 = b[10]; b3 = b[11];
    out[8] = b0*a00 + b1*a10 + b2*a20 + b3*a30;
    out[9] = b0*a01 + b1*a11 + b2*a21 + b3*a31;
    out[10] = b0*a02 + b1*a12 + b2*a22 + b3*a32;
    out[11] = b0*a03 + b1*a13 + b2*a23 + b3*a33;

    b0 = b[12]; b1 = b[13]; b2 = b[14]; b3 = b[15];
    out[12] = b0*a00 + b1*a10 + b2*a20 + b3*a30;
    out[13] = b0*a01 + b1*a11 + b2*a21 + b3*a31;
    out[14] = b0*a02 + b1*a12 + b2*a22 + b3*a32;
    out[15] = b0*a03 + b1*a13 + b2*a23 + b3*a33;
    return out;
};

/***/ }),

/***/ 4633:
/***/ (function(module) {

module.exports = ortho;

/**
 * Generates a orthogonal projection matrix with the given bounds
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {number} left Left bound of the frustum
 * @param {number} right Right bound of the frustum
 * @param {number} bottom Bottom bound of the frustum
 * @param {number} top Top bound of the frustum
 * @param {number} near Near bound of the frustum
 * @param {number} far Far bound of the frustum
 * @returns {mat4} out
 */
function ortho(out, left, right, bottom, top, near, far) {
    var lr = 1 / (left - right),
        bt = 1 / (bottom - top),
        nf = 1 / (near - far);
    out[0] = -2 * lr;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = -2 * bt;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 2 * nf;
    out[11] = 0;
    out[12] = (left + right) * lr;
    out[13] = (top + bottom) * bt;
    out[14] = (far + near) * nf;
    out[15] = 1;
    return out;
};

/***/ }),

/***/ 5313:
/***/ (function(module) {

module.exports = perspective;

/**
 * Generates a perspective projection matrix with the given bounds
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {number} fovy Vertical field of view in radians
 * @param {number} aspect Aspect ratio. typically viewport width/height
 * @param {number} near Near bound of the frustum
 * @param {number} far Far bound of the frustum
 * @returns {mat4} out
 */
function perspective(out, fovy, aspect, near, far) {
    var f = 1.0 / Math.tan(fovy / 2),
        nf = 1 / (near - far);
    out[0] = f / aspect;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = f;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = (far + near) * nf;
    out[11] = -1;
    out[12] = 0;
    out[13] = 0;
    out[14] = (2 * far * near) * nf;
    out[15] = 0;
    return out;
};

/***/ }),

/***/ 22253:
/***/ (function(module) {

module.exports = perspectiveFromFieldOfView;

/**
 * Generates a perspective projection matrix with the given field of view.
 * This is primarily useful for generating projection matrices to be used
 * with the still experiemental WebVR API.
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {number} fov Object containing the following values: upDegrees, downDegrees, leftDegrees, rightDegrees
 * @param {number} near Near bound of the frustum
 * @param {number} far Far bound of the frustum
 * @returns {mat4} out
 */
function perspectiveFromFieldOfView(out, fov, near, far) {
    var upTan = Math.tan(fov.upDegrees * Math.PI/180.0),
        downTan = Math.tan(fov.downDegrees * Math.PI/180.0),
        leftTan = Math.tan(fov.leftDegrees * Math.PI/180.0),
        rightTan = Math.tan(fov.rightDegrees * Math.PI/180.0),
        xScale = 2.0 / (leftTan + rightTan),
        yScale = 2.0 / (upTan + downTan);

    out[0] = xScale;
    out[1] = 0.0;
    out[2] = 0.0;
    out[3] = 0.0;
    out[4] = 0.0;
    out[5] = yScale;
    out[6] = 0.0;
    out[7] = 0.0;
    out[8] = -((leftTan - rightTan) * xScale * 0.5);
    out[9] = ((upTan - downTan) * yScale * 0.5);
    out[10] = far / (near - far);
    out[11] = -1.0;
    out[12] = 0.0;
    out[13] = 0.0;
    out[14] = (far * near) / (near - far);
    out[15] = 0.0;
    return out;
}



/***/ }),

/***/ 32416:
/***/ (function(module) {

module.exports = rotate;

/**
 * Rotates a mat4 by the given angle
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @param {vec3} axis the axis to rotate around
 * @returns {mat4} out
 */
function rotate(out, a, rad, axis) {
    var x = axis[0], y = axis[1], z = axis[2],
        len = Math.sqrt(x * x + y * y + z * z),
        s, c, t,
        a00, a01, a02, a03,
        a10, a11, a12, a13,
        a20, a21, a22, a23,
        b00, b01, b02,
        b10, b11, b12,
        b20, b21, b22;

    if (Math.abs(len) < 0.000001) { return null; }
    
    len = 1 / len;
    x *= len;
    y *= len;
    z *= len;

    s = Math.sin(rad);
    c = Math.cos(rad);
    t = 1 - c;

    a00 = a[0]; a01 = a[1]; a02 = a[2]; a03 = a[3];
    a10 = a[4]; a11 = a[5]; a12 = a[6]; a13 = a[7];
    a20 = a[8]; a21 = a[9]; a22 = a[10]; a23 = a[11];

    // Construct the elements of the rotation matrix
    b00 = x * x * t + c; b01 = y * x * t + z * s; b02 = z * x * t - y * s;
    b10 = x * y * t - z * s; b11 = y * y * t + c; b12 = z * y * t + x * s;
    b20 = x * z * t + y * s; b21 = y * z * t - x * s; b22 = z * z * t + c;

    // Perform rotation-specific matrix multiplication
    out[0] = a00 * b00 + a10 * b01 + a20 * b02;
    out[1] = a01 * b00 + a11 * b01 + a21 * b02;
    out[2] = a02 * b00 + a12 * b01 + a22 * b02;
    out[3] = a03 * b00 + a13 * b01 + a23 * b02;
    out[4] = a00 * b10 + a10 * b11 + a20 * b12;
    out[5] = a01 * b10 + a11 * b11 + a21 * b12;
    out[6] = a02 * b10 + a12 * b11 + a22 * b12;
    out[7] = a03 * b10 + a13 * b11 + a23 * b12;
    out[8] = a00 * b20 + a10 * b21 + a20 * b22;
    out[9] = a01 * b20 + a11 * b21 + a21 * b22;
    out[10] = a02 * b20 + a12 * b21 + a22 * b22;
    out[11] = a03 * b20 + a13 * b21 + a23 * b22;

    if (a !== out) { // If the source and destination differ, copy the unchanged last row
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    }
    return out;
};

/***/ }),

/***/ 81066:
/***/ (function(module) {

module.exports = rotateX;

/**
 * Rotates a matrix by the given angle around the X axis
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */
function rotateX(out, a, rad) {
    var s = Math.sin(rad),
        c = Math.cos(rad),
        a10 = a[4],
        a11 = a[5],
        a12 = a[6],
        a13 = a[7],
        a20 = a[8],
        a21 = a[9],
        a22 = a[10],
        a23 = a[11];

    if (a !== out) { // If the source and destination differ, copy the unchanged rows
        out[0]  = a[0];
        out[1]  = a[1];
        out[2]  = a[2];
        out[3]  = a[3];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    }

    // Perform axis-specific matrix multiplication
    out[4] = a10 * c + a20 * s;
    out[5] = a11 * c + a21 * s;
    out[6] = a12 * c + a22 * s;
    out[7] = a13 * c + a23 * s;
    out[8] = a20 * c - a10 * s;
    out[9] = a21 * c - a11 * s;
    out[10] = a22 * c - a12 * s;
    out[11] = a23 * c - a13 * s;
    return out;
};

/***/ }),

/***/ 54201:
/***/ (function(module) {

module.exports = rotateY;

/**
 * Rotates a matrix by the given angle around the Y axis
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */
function rotateY(out, a, rad) {
    var s = Math.sin(rad),
        c = Math.cos(rad),
        a00 = a[0],
        a01 = a[1],
        a02 = a[2],
        a03 = a[3],
        a20 = a[8],
        a21 = a[9],
        a22 = a[10],
        a23 = a[11];

    if (a !== out) { // If the source and destination differ, copy the unchanged rows
        out[4]  = a[4];
        out[5]  = a[5];
        out[6]  = a[6];
        out[7]  = a[7];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    }

    // Perform axis-specific matrix multiplication
    out[0] = a00 * c - a20 * s;
    out[1] = a01 * c - a21 * s;
    out[2] = a02 * c - a22 * s;
    out[3] = a03 * c - a23 * s;
    out[8] = a00 * s + a20 * c;
    out[9] = a01 * s + a21 * c;
    out[10] = a02 * s + a22 * c;
    out[11] = a03 * s + a23 * c;
    return out;
};

/***/ }),

/***/ 33920:
/***/ (function(module) {

module.exports = rotateZ;

/**
 * Rotates a matrix by the given angle around the Z axis
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */
function rotateZ(out, a, rad) {
    var s = Math.sin(rad),
        c = Math.cos(rad),
        a00 = a[0],
        a01 = a[1],
        a02 = a[2],
        a03 = a[3],
        a10 = a[4],
        a11 = a[5],
        a12 = a[6],
        a13 = a[7];

    if (a !== out) { // If the source and destination differ, copy the unchanged last row
        out[8]  = a[8];
        out[9]  = a[9];
        out[10] = a[10];
        out[11] = a[11];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    }

    // Perform axis-specific matrix multiplication
    out[0] = a00 * c + a10 * s;
    out[1] = a01 * c + a11 * s;
    out[2] = a02 * c + a12 * s;
    out[3] = a03 * c + a13 * s;
    out[4] = a10 * c - a00 * s;
    out[5] = a11 * c - a01 * s;
    out[6] = a12 * c - a02 * s;
    out[7] = a13 * c - a03 * s;
    return out;
};

/***/ }),

/***/ 8697:
/***/ (function(module) {

module.exports = scale;

/**
 * Scales the mat4 by the dimensions in the given vec3
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the matrix to scale
 * @param {vec3} v the vec3 to scale the matrix by
 * @returns {mat4} out
 **/
function scale(out, a, v) {
    var x = v[0], y = v[1], z = v[2];

    out[0] = a[0] * x;
    out[1] = a[1] * x;
    out[2] = a[2] * x;
    out[3] = a[3] * x;
    out[4] = a[4] * y;
    out[5] = a[5] * y;
    out[6] = a[6] * y;
    out[7] = a[7] * y;
    out[8] = a[8] * z;
    out[9] = a[9] * z;
    out[10] = a[10] * z;
    out[11] = a[11] * z;
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
};

/***/ }),

/***/ 66992:
/***/ (function(module) {

module.exports = str;

/**
 * Returns a string representation of a mat4
 *
 * @param {mat4} mat matrix to represent as a string
 * @returns {String} string representation of the matrix
 */
function str(a) {
    return 'mat4(' + a[0] + ', ' + a[1] + ', ' + a[2] + ', ' + a[3] + ', ' +
                    a[4] + ', ' + a[5] + ', ' + a[6] + ', ' + a[7] + ', ' +
                    a[8] + ', ' + a[9] + ', ' + a[10] + ', ' + a[11] + ', ' + 
                    a[12] + ', ' + a[13] + ', ' + a[14] + ', ' + a[15] + ')';
};

/***/ }),

/***/ 4165:
/***/ (function(module) {

module.exports = translate;

/**
 * Translate a mat4 by the given vector
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the matrix to translate
 * @param {vec3} v vector to translate by
 * @returns {mat4} out
 */
function translate(out, a, v) {
    var x = v[0], y = v[1], z = v[2],
        a00, a01, a02, a03,
        a10, a11, a12, a13,
        a20, a21, a22, a23;

    if (a === out) {
        out[12] = a[0] * x + a[4] * y + a[8] * z + a[12];
        out[13] = a[1] * x + a[5] * y + a[9] * z + a[13];
        out[14] = a[2] * x + a[6] * y + a[10] * z + a[14];
        out[15] = a[3] * x + a[7] * y + a[11] * z + a[15];
    } else {
        a00 = a[0]; a01 = a[1]; a02 = a[2]; a03 = a[3];
        a10 = a[4]; a11 = a[5]; a12 = a[6]; a13 = a[7];
        a20 = a[8]; a21 = a[9]; a22 = a[10]; a23 = a[11];

        out[0] = a00; out[1] = a01; out[2] = a02; out[3] = a03;
        out[4] = a10; out[5] = a11; out[6] = a12; out[7] = a13;
        out[8] = a20; out[9] = a21; out[10] = a22; out[11] = a23;

        out[12] = a00 * x + a10 * y + a20 * z + a[12];
        out[13] = a01 * x + a11 * y + a21 * z + a[13];
        out[14] = a02 * x + a12 * y + a22 * z + a[14];
        out[15] = a03 * x + a13 * y + a23 * z + a[15];
    }

    return out;
};

/***/ }),

/***/ 10256:
/***/ (function(module) {

module.exports = transpose;

/**
 * Transpose the values of a mat4
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the source matrix
 * @returns {mat4} out
 */
function transpose(out, a) {
    // If we are transposing ourselves we can skip a few steps but have to cache some values
    if (out === a) {
        var a01 = a[1], a02 = a[2], a03 = a[3],
            a12 = a[6], a13 = a[7],
            a23 = a[11];

        out[1] = a[4];
        out[2] = a[8];
        out[3] = a[12];
        out[4] = a01;
        out[6] = a[9];
        out[7] = a[13];
        out[8] = a02;
        out[9] = a12;
        out[11] = a[14];
        out[12] = a03;
        out[13] = a13;
        out[14] = a23;
    } else {
        out[0] = a[0];
        out[1] = a[4];
        out[2] = a[8];
        out[3] = a[12];
        out[4] = a[1];
        out[5] = a[5];
        out[6] = a[9];
        out[7] = a[13];
        out[8] = a[2];
        out[9] = a[6];
        out[10] = a[10];
        out[11] = a[14];
        out[12] = a[3];
        out[13] = a[7];
        out[14] = a[11];
        out[15] = a[15];
    }
    
    return out;
};

/***/ }),

/***/ 74024:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Font = __webpack_require__(59518)
var pick = __webpack_require__(6807)
var createRegl = __webpack_require__(81330)
var createGl = __webpack_require__(38862)
var WeakMap = __webpack_require__(93103)
var rgba = __webpack_require__(162)
var fontAtlas = __webpack_require__(68950)
var pool = __webpack_require__(66127)
var parseRect = __webpack_require__(5137)
var isObj = __webpack_require__(29388)
var parseUnit = __webpack_require__(4957)
var px = __webpack_require__(44626)
var kerning = __webpack_require__(44431)
var extend = __webpack_require__(27976)
var metrics = __webpack_require__(12673)
var flatten = __webpack_require__(83473)
var ref = __webpack_require__(54689);
var nextPow2 = ref.nextPow2;

var shaderCache = new WeakMap


// Safari does not support font-stretch
var isStretchSupported = false
if (document.body) {
    var el = document.body.appendChild(document.createElement('div'))
    el.style.font = 'italic small-caps bold condensed 16px/2 cursive'
    if (getComputedStyle(el).fontStretch) {
        isStretchSupported = true
    }
    document.body.removeChild(el)
}

var GlText = function GlText (o) {
	if (isRegl(o)) {
		o = {regl: o}
		this.gl = o.regl._gl
	}
	else {
		this.gl = createGl(o)
	}

	this.shader = shaderCache.get(this.gl)

	if (!this.shader) {
		this.regl = o.regl || createRegl({ gl: this.gl })
	}
	else {
		this.regl = this.shader.regl
	}

	this.charBuffer = this.regl.buffer({ type: 'uint8', usage: 'stream' })
	this.sizeBuffer = this.regl.buffer({ type: 'float', usage: 'stream' })

	if (!this.shader) {
		this.shader = this.createShader()
		shaderCache.set(this.gl, this.shader)
	}

	this.batch = []

	// multiple options initial state
	this.fontSize = []
	this.font = []
	this.fontAtlas = []

	this.draw = this.shader.draw.bind(this)
	this.render = function () {
		// FIXME: add Safari regl report here:
		// charBuffer and width just do not trigger
		this.regl._refresh()
		this.draw(this.batch)
	}
	this.canvas = this.gl.canvas

	this.update(isObj(o) ? o : {})
};

GlText.prototype.createShader = function createShader () {
	var regl = this.regl

	var draw = regl({
		blend: {
			enable: true,
			color: [0,0,0,1],

			func: {
				srcRGB: 'src alpha',
				dstRGB: 'one minus src alpha',
				srcAlpha: 'one minus dst alpha',
				dstAlpha: 'one'
			}
		},
		stencil: {enable: false},
		depth: {enable: false},

		count: regl.prop('count'),
		offset: regl.prop('offset'),
		attributes: {
			charOffset: {
				offset: 4,
				stride: 8,
				buffer: regl.this('sizeBuffer')
			},
			width: {
				offset: 0,
				stride: 8,
				buffer: regl.this('sizeBuffer')
			},
			char: regl.this('charBuffer'),
			position: regl.this('position')
		},
		uniforms: {
			atlasSize: function (c, p) { return [p.atlas.width, p.atlas.height]; },
			atlasDim: function (c, p) { return [p.atlas.cols, p.atlas.rows]; },
			atlas: function (c, p) { return p.atlas.texture; },
			charStep: function (c, p) { return p.atlas.step; },
			em: function (c, p) { return p.atlas.em; },
			color: regl.prop('color'),
			opacity: regl.prop('opacity'),
			viewport: regl.this('viewportArray'),
			scale: regl.this('scale'),
			align: regl.prop('align'),
			baseline: regl.prop('baseline'),
			translate: regl.this('translate'),
			positionOffset: regl.prop('positionOffset')
		},
		primitive: 'points',
		viewport: regl.this('viewport'),

		vert: "\n\t\t\tprecision highp float;\n\t\t\tattribute float width, charOffset, char;\n\t\t\tattribute vec2 position;\n\t\t\tuniform float fontSize, charStep, em, align, baseline;\n\t\t\tuniform vec4 viewport;\n\t\t\tuniform vec4 color;\n\t\t\tuniform vec2 atlasSize, atlasDim, scale, translate, positionOffset;\n\t\t\tvarying vec2 charCoord, charId;\n\t\t\tvarying float charWidth;\n\t\t\tvarying vec4 fontColor;\n\t\t\tvoid main () {\n\t\t\t\tvec2 offset = floor(em * (vec2(align + charOffset, baseline)\n\t\t\t\t\t+ vec2(positionOffset.x, -positionOffset.y)))\n\t\t\t\t\t/ (viewport.zw * scale.xy);\n\n\t\t\t\tvec2 position = (position + translate) * scale;\n\t\t\t\tposition += offset * scale;\n\n\t\t\t\tcharCoord = position * viewport.zw + viewport.xy;\n\n\t\t\t\tgl_Position = vec4(position * 2. - 1., 0, 1);\n\n\t\t\t\tgl_PointSize = charStep;\n\n\t\t\t\tcharId.x = mod(char, atlasDim.x);\n\t\t\t\tcharId.y = floor(char / atlasDim.x);\n\n\t\t\t\tcharWidth = width * em;\n\n\t\t\t\tfontColor = color / 255.;\n\t\t\t}",

		frag: "\n\t\t\tprecision highp float;\n\t\t\tuniform float fontSize, charStep, opacity;\n\t\t\tuniform vec2 atlasSize;\n\t\t\tuniform vec4 viewport;\n\t\t\tuniform sampler2D atlas;\n\t\t\tvarying vec4 fontColor;\n\t\t\tvarying vec2 charCoord, charId;\n\t\t\tvarying float charWidth;\n\n\t\t\tfloat lightness(vec4 color) {\n\t\t\t\treturn color.r * 0.299 + color.g * 0.587 + color.b * 0.114;\n\t\t\t}\n\n\t\t\tvoid main () {\n\t\t\t\tvec2 uv = gl_FragCoord.xy - charCoord + charStep * .5;\n\t\t\t\tfloat halfCharStep = floor(charStep * .5 + .5);\n\n\t\t\t\t// invert y and shift by 1px (FF expecially needs that)\n\t\t\t\tuv.y = charStep - uv.y;\n\n\t\t\t\t// ignore points outside of character bounding box\n\t\t\t\tfloat halfCharWidth = ceil(charWidth * .5);\n\t\t\t\tif (floor(uv.x) > halfCharStep + halfCharWidth ||\n\t\t\t\t\tfloor(uv.x) < halfCharStep - halfCharWidth) return;\n\n\t\t\t\tuv += charId * charStep;\n\t\t\t\tuv = uv / atlasSize;\n\n\t\t\t\tvec4 color = fontColor;\n\t\t\t\tvec4 mask = texture2D(atlas, uv);\n\n\t\t\t\tfloat maskY = lightness(mask);\n\t\t\t\t// float colorY = lightness(color);\n\t\t\t\tcolor.a *= maskY;\n\t\t\t\tcolor.a *= opacity;\n\n\t\t\t\t// color.a += .1;\n\n\t\t\t\t// antialiasing, see yiq color space y-channel formula\n\t\t\t\t// color.rgb += (1. - color.rgb) * (1. - mask.rgb);\n\n\t\t\t\tgl_FragColor = color;\n\t\t\t}"
	})

	// per font-size atlas
	var atlas = {}

	return { regl: regl, draw: draw, atlas: atlas }
};

GlText.prototype.update = function update (o) {
		var this$1 = this;

	if (typeof o === 'string') { o = { text: o } }
	else if (!o) { return }

	// FIXME: make this a static transform or more general approact
	o = pick(o, {
		position: 'position positions coord coords coordinates',
		font: 'font fontFace fontface typeface cssFont css-font family fontFamily',
		fontSize: 'fontSize fontsize size font-size',
		text: 'text texts chars characters value values symbols',
		align: 'align alignment textAlign textbaseline',
		baseline: 'baseline textBaseline textbaseline',
		direction: 'dir direction textDirection',
		color: 'color colour fill fill-color fillColor textColor textcolor',
		kerning: 'kerning kern',
		range: 'range dataBox',
		viewport: 'vp viewport viewBox viewbox viewPort',
		opacity: 'opacity alpha transparency visible visibility opaque',
		offset: 'offset positionOffset padding shift indent indentation'
	}, true)


	if (o.opacity != null) {
		if (Array.isArray(o.opacity)) {
			this.opacity = o.opacity.map(function (o) { return parseFloat(o); })
		}
		else {
			this.opacity = parseFloat(o.opacity)
		}
	}

	if (o.viewport != null) {
		this.viewport = parseRect(o.viewport)

		this.viewportArray = [this.viewport.x, this.viewport.y, this.viewport.width, this.viewport.height]

	}
	if (this.viewport == null) {
		this.viewport = {
			x: 0, y: 0,
			width: this.gl.drawingBufferWidth,
			height: this.gl.drawingBufferHeight
		}
		this.viewportArray = [this.viewport.x, this.viewport.y, this.viewport.width, this.viewport.height]
	}

	if (o.kerning != null) { this.kerning = o.kerning }

	if (o.offset != null) {
		if (typeof o.offset === 'number') { o.offset = [o.offset, 0] }

		this.positionOffset = flatten(o.offset)
	}

	if (o.direction) { this.direction = o.direction }

	if (o.range) {
		this.range = o.range
		this.scale = [1 / (o.range[2] - o.range[0]), 1 / (o.range[3] - o.range[1])]
		this.translate = [-o.range[0], -o.range[1]]
	}
	if (o.scale) { this.scale = o.scale }
	if (o.translate) { this.translate = o.translate }

	// default scale corresponds to viewport
	if (!this.scale) { this.scale = [1 / this.viewport.width, 1 / this.viewport.height] }

	if (!this.translate) { this.translate = [0, 0] }

	if (!this.font.length && !o.font) { o.font = GlText.baseFontSize + 'px sans-serif' }

	// normalize font caching string
	var newFont = false, newFontSize = false

	// obtain new font data
	if (o.font) {
		(Array.isArray(o.font) ? o.font : [o.font]).forEach(function (font, i) {
			// normalize font
			if (typeof font === 'string') {
				try {
					font = Font.parse(font)
				} catch (e) {
					font = Font.parse(GlText.baseFontSize + 'px ' + font)
				}
			}
			else {
				var fontStyle = font.style
				var fontWeight = font.weight
				var fontStretch = font.stretch
				var fontVariant = font.variant
				font = Font.parse(Font.stringify(font))
				if (fontStyle) font.style = fontStyle
				if (fontWeight) font.weight = fontWeight
				if (fontStretch) font.stretch = fontStretch
				if (fontVariant) font.variant = fontVariant
			}

			var baseString = Font.stringify({
				size: GlText.baseFontSize,
				family: font.family,
				stretch: isStretchSupported ? font.stretch : undefined,
				variant: font.variant,
				weight: font.weight,
				style: font.style
			})

			var unit = parseUnit(font.size)
			var fs = Math.round(unit[0] * px(unit[1]))
			if (fs !== this$1.fontSize[i]) {
				newFontSize = true
				this$1.fontSize[i] = fs
			}

			// calc new font metrics/atlas
			if (!this$1.font[i] || baseString != this$1.font[i].baseString) {
				newFont = true

				// obtain font cache or create one
				this$1.font[i] = GlText.fonts[baseString]
				if (!this$1.font[i]) {
					var family = font.family.join(', ')
					var style = [font.style]
					if (font.style != font.variant) { style.push(font.variant) }
					if (font.variant != font.weight) { style.push(font.weight) }
					if (isStretchSupported && font.weight != font.stretch) { style.push(font.stretch) }

					this$1.font[i] = {
						baseString: baseString,

						// typeface
						family: family,
						weight: font.weight,
						stretch: font.stretch,
						style: font.style,
						variant: font.variant,

						// widths of characters
						width: {},

						// kernin pairs offsets
						kerning: {},

						metrics: metrics(family, {
							origin: 'top',
							fontSize: GlText.baseFontSize,
							fontStyle: style.join(' ')
						})
					}

					GlText.fonts[baseString] = this$1.font[i]
				}
			}
		})
	}

	// FIXME: make independend font-size
	// if (o.fontSize) {
	// let unit = parseUnit(o.fontSize)
	// let fs = Math.round(unit[0] * px(unit[1]))

	// if (fs != this.fontSize) {
	// 	newFontSize = true
	// 	this.fontSize = fs
	// }
	// }

	if (newFont || newFontSize) {
		this.font.forEach(function (font, i) {
			var fontString = Font.stringify({
				size: this$1.fontSize[i],
				family: font.family,
				stretch: isStretchSupported ? font.stretch : undefined,
				variant: font.variant,
				weight: font.weight,
				style: font.style
			})

			// calc new font size atlas
			this$1.fontAtlas[i] = this$1.shader.atlas[fontString]

			if (!this$1.fontAtlas[i]) {
				var metrics = font.metrics

				this$1.shader.atlas[fontString] =
				this$1.fontAtlas[i] = {
					fontString: fontString,
					// even step is better for rendered characters
					step: Math.ceil(this$1.fontSize[i] * metrics.bottom * .5) * 2,
					em: this$1.fontSize[i],
					cols: 0,
					rows: 0,
					height: 0,
					width: 0,
					chars: [],
					ids: {},
					texture: this$1.regl.texture()
				}
			}

			// bump atlas characters
			if (o.text == null) { o.text = this$1.text }
		})
	}

	// if multiple positions - duplicate text arguments
	// FIXME: this possibly can be done better to avoid array spawn
	if (typeof o.text === 'string' && o.position && o.position.length > 2) {
		var textArray = Array(o.position.length * .5)
		for (var i = 0; i < textArray.length; i++) {
			textArray[i] = o.text
		}
		o.text = textArray
	}

	// calculate offsets for the new font/text
	var newAtlasChars
	if (o.text != null || newFont) {
		// FIXME: ignore spaces
		// text offsets within the text buffer
		this.textOffsets = [0]

		if (Array.isArray(o.text)) {
			this.count = o.text[0].length
			this.counts = [this.count]
			for (var i$1 = 1; i$1 < o.text.length; i$1++) {
				this.textOffsets[i$1] = this.textOffsets[i$1 - 1] + o.text[i$1 - 1].length
				this.count += o.text[i$1].length
				this.counts.push(o.text[i$1].length)
			}
			this.text = o.text.join('')
		}
		else {
			this.text = o.text
			this.count = this.text.length
			this.counts = [this.count]
		}

		newAtlasChars = []

		// detect & measure new characters
		this.font.forEach(function (font, idx) {
			GlText.atlasContext.font = font.baseString

			var atlas = this$1.fontAtlas[idx]

			for (var i = 0; i < this$1.text.length; i++) {
				var char = this$1.text.charAt(i)

				if (atlas.ids[char] == null) {
					atlas.ids[char] = atlas.chars.length
					atlas.chars.push(char)
					newAtlasChars.push(char)
				}

				if (font.width[char] == null) {
					font.width[char] = GlText.atlasContext.measureText(char).width / GlText.baseFontSize

					// measure kerning pairs for the new character
					if (this$1.kerning) {
						var pairs = []
						for (var baseChar in font.width) {
							pairs.push(baseChar + char, char + baseChar)
						}
						extend(font.kerning, kerning(font.family, {
							pairs: pairs
						}))
					}
				}
			}
		})
	}

	// create single position buffer (faster than batch or multiple separate instances)
	if (o.position) {
		if (o.position.length > 2) {
			var flat = !o.position[0].length
			var positionData = pool.mallocFloat(this.count * 2)
			for (var i$2 = 0, ptr = 0; i$2 < this.counts.length; i$2++) {
				var count = this.counts[i$2]
				if (flat) {
					for (var j = 0; j < count; j++) {
						positionData[ptr++] = o.position[i$2 * 2]
						positionData[ptr++] = o.position[i$2 * 2 + 1]
					}
				}
				else {
					for (var j$1 = 0; j$1 < count; j$1++) {
						positionData[ptr++] = o.position[i$2][0]
						positionData[ptr++] = o.position[i$2][1]
					}
				}
			}
			if (this.position.call) {
				this.position({
					type: 'float',
					data: positionData
				})
			} else {
				this.position = this.regl.buffer({
					type: 'float',
					data: positionData
				})
			}
			pool.freeFloat(positionData)
		}
		else {
			if (this.position.destroy) { this.position.destroy() }
			this.position = {
				constant: o.position
			}
		}
	}

	// populate text/offset buffers if font/text has changed
	// as [charWidth, offset, charWidth, offset...]
	// that is in em units since font-size can change often
	if (o.text || newFont) {
		var charIds = pool.mallocUint8(this.count)
		var sizeData = pool.mallocFloat(this.count * 2)
		this.textWidth = []

		for (var i$3 = 0, ptr$1 = 0; i$3 < this.counts.length; i$3++) {
			var count$1 = this.counts[i$3]
			var font = this.font[i$3] || this.font[0]
			var atlas = this.fontAtlas[i$3] || this.fontAtlas[0]

			for (var j$2 = 0; j$2 < count$1; j$2++) {
				var char = this.text.charAt(ptr$1)
				var prevChar = this.text.charAt(ptr$1 - 1)

				charIds[ptr$1] = atlas.ids[char]
				sizeData[ptr$1 * 2] = font.width[char]

				if (j$2) {
					var prevWidth = sizeData[ptr$1 * 2 - 2]
					var currWidth = sizeData[ptr$1 * 2]
					var prevOffset = sizeData[ptr$1 * 2 - 1]
					var offset = prevOffset + prevWidth * .5 + currWidth * .5;

					if (this.kerning) {
						var kerning$1 = font.kerning[prevChar + char]
						if (kerning$1) {
							offset += kerning$1 * 1e-3
						}
					}

					sizeData[ptr$1 * 2 + 1] = offset
				}
				else {
					sizeData[ptr$1 * 2 + 1] = sizeData[ptr$1 * 2] * .5
				}

				ptr$1++
			}
			this.textWidth.push(
				!sizeData.length ? 0 :
				// last offset + half last width
				sizeData[ptr$1 * 2 - 2] * .5 + sizeData[ptr$1 * 2 - 1]
			)
		}


		// bump recalc align offset
		if (!o.align) { o.align = this.align }
		this.charBuffer({data: charIds, type: 'uint8', usage: 'stream'})
		this.sizeBuffer({data: sizeData, type: 'float', usage: 'stream'})
		pool.freeUint8(charIds)
		pool.freeFloat(sizeData)

		// udpate font atlas and texture
		if (newAtlasChars.length) {
			this.font.forEach(function (font, i) {
				var atlas = this$1.fontAtlas[i]

				// FIXME: insert metrics-based ratio here
				var step = atlas.step

				var maxCols = Math.floor(GlText.maxAtlasSize / step)
				var cols = Math.min(maxCols, atlas.chars.length)
				var rows = Math.ceil(atlas.chars.length / cols)

				var atlasWidth = nextPow2( cols * step )
				// let atlasHeight = Math.min(rows * step + step * .5, GlText.maxAtlasSize);
				var atlasHeight = nextPow2( rows * step );

				atlas.width = atlasWidth
				atlas.height = atlasHeight;
				atlas.rows = rows
				atlas.cols = cols

				if (!atlas.em) { return }

				atlas.texture({
					data: fontAtlas({
						canvas: GlText.atlasCanvas,
						font: atlas.fontString,
						chars: atlas.chars,
						shape: [atlasWidth, atlasHeight],
						step: [step, step]
					})
				})

			})
		}
	}

	if (o.align) {
		this.align = o.align
		this.alignOffset = this.textWidth.map(function (textWidth, i) {
			var align = !Array.isArray(this$1.align) ? this$1.align : this$1.align.length > 1 ? this$1.align[i] : this$1.align[0]

			if (typeof align === 'number') { return align }
			switch (align) {
				case 'right':
				case 'end':
					return -textWidth
				case 'center':
				case 'centre':
				case 'middle':
					return -textWidth * .5
			}

			return 0
		})
	}

	if (this.baseline == null && o.baseline == null) {
		o.baseline = 0
	}
	if (o.baseline != null) {
		this.baseline = o.baseline
		if (!Array.isArray(this.baseline)) { this.baseline = [this.baseline] }
		this.baselineOffset = this.baseline.map(function (baseline, i) {
			var m = (this$1.font[i] || this$1.font[0]).metrics
			var base = 0

			base += m.bottom * .5

			if (typeof baseline === 'number') {
				base += (baseline - m.baseline)
			}
			else {
				base += -m[baseline]
			}

			base *= -1
			return base
		})
	}

	// flatten colors to a single uint8 array
	if (o.color != null) {
		if (!o.color) { o.color = 'transparent' }

		// single color
		if (typeof o.color === 'string' || !isNaN(o.color)) {
			this.color = rgba(o.color, 'uint8')
		}
		// array
		else {
			var colorData

			// flat array
			if (typeof o.color[0] === 'number' && o.color.length > this.counts.length) {
				var l = o.color.length
				colorData = pool.mallocUint8(l)
				var sub = (o.color.subarray || o.color.slice).bind(o.color)
				for (var i$4 = 0; i$4 < l; i$4 += 4) {
					colorData.set(rgba(sub(i$4, i$4 + 4), 'uint8'), i$4)
				}
			}
			// nested array
			else {
				var l$1 = o.color.length
				colorData = pool.mallocUint8(l$1 * 4)
				for (var i$5 = 0; i$5 < l$1; i$5++) {
					colorData.set(rgba(o.color[i$5] || 0, 'uint8'), i$5 * 4)
				}
			}

			this.color = colorData
		}
	}

	// update render batch
	if (o.position || o.text || o.color || o.baseline || o.align || o.font || o.offset || o.opacity) {
		var isBatch = (this.color.length > 4)
			|| (this.baselineOffset.length > 1)
			|| (this.align && this.align.length > 1)
			|| (this.fontAtlas.length > 1)
			|| (this.positionOffset.length > 2)
		if (isBatch) {
			var length = Math.max(
				this.position.length * .5 || 0,
				this.color.length * .25 || 0,
				this.baselineOffset.length || 0,
				this.alignOffset.length || 0,
				this.font.length || 0,
				this.opacity.length || 0,
				this.positionOffset.length * .5 || 0
			)
			this.batch = Array(length)
			for (var i$6 = 0; i$6 < this.batch.length; i$6++) {
				this.batch[i$6] = {
					count: this.counts.length > 1 ? this.counts[i$6] : this.counts[0],
					offset: this.textOffsets.length > 1 ? this.textOffsets[i$6] : this.textOffsets[0],
					color: !this.color ? [0,0,0,255] : this.color.length <= 4 ? this.color : this.color.subarray(i$6 * 4, i$6 * 4 + 4),
					opacity: Array.isArray(this.opacity) ? this.opacity[i$6] : this.opacity,
					baseline: this.baselineOffset[i$6] != null ? this.baselineOffset[i$6] : this.baselineOffset[0],
					align: !this.align ? 0 : this.alignOffset[i$6] != null ? this.alignOffset[i$6] : this.alignOffset[0],
					atlas: this.fontAtlas[i$6] || this.fontAtlas[0],
					positionOffset: this.positionOffset.length > 2 ? this.positionOffset.subarray(i$6 * 2, i$6 * 2 + 2) : this.positionOffset
				}
			}
		}
		// single-color, single-baseline, single-align batch is faster to render
		else {
			if (this.count) {
				this.batch = [{
					count: this.count,
					offset: 0,
					color: this.color || [0,0,0,255],
					opacity: Array.isArray(this.opacity) ? this.opacity[0] : this.opacity,
					baseline: this.baselineOffset[0],
					align: this.alignOffset ? this.alignOffset[0] : 0,
					atlas: this.fontAtlas[0],
					positionOffset: this.positionOffset
				}]
			}
			else {
				this.batch = []
			}
		}
	}
};

GlText.prototype.destroy = function destroy () {
	// TODO: count instances of atlases and destroy all on null
};


// defaults
GlText.prototype.kerning = true
GlText.prototype.position = { constant: new Float32Array(2) }
GlText.prototype.translate = null
GlText.prototype.scale = null
GlText.prototype.font = null
GlText.prototype.text = ''
GlText.prototype.positionOffset = [0, 0]
GlText.prototype.opacity = 1
GlText.prototype.color = new Uint8Array([0, 0, 0, 255])
GlText.prototype.alignOffset = [0, 0]


// size of an atlas
GlText.maxAtlasSize = 1024

// font atlas canvas is singleton
GlText.atlasCanvas = document.createElement('canvas')
GlText.atlasContext = GlText.atlasCanvas.getContext('2d', {alpha: false})

// font-size used for metrics, atlas step calculation
GlText.baseFontSize = 64

// fonts storage
GlText.fonts = {}

// max number of different font atlases/textures cached
// FIXME: enable atlas size limitation via LRU
// GlText.atlasCacheSize = 64

function isRegl (o) {
	return typeof o === 'function' &&
	o._gl &&
	o.prop &&
	o.texture &&
	o.buffer
}


module.exports = GlText



/***/ }),

/***/ 38862:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/** @module  gl-util/context */


var pick = __webpack_require__(6807)

module.exports = function setContext (o) {
	if (!o) o = {}
	else if (typeof o === 'string') o = {container: o}

	// HTMLCanvasElement
	if (isCanvas(o)) {
		o = {container: o}
	}
	// HTMLElement
	else if (isElement(o)) {
		o = {container: o}
	}
	// WebGLContext
	else if (isContext(o)) {
		o = {gl: o}
	}
	// options object
	else {
		o = pick(o, {
			container: 'container target element el canvas holder parent parentNode wrapper use ref root node',
			gl: 'gl context webgl glContext',
			attrs: 'attributes attrs contextAttributes',
			pixelRatio: 'pixelRatio pxRatio px ratio pxratio pixelratio',
			width: 'w width',
			height: 'h height'
		}, true)
	}

	if (!o.pixelRatio) o.pixelRatio = __webpack_require__.g.pixelRatio || 1

	// make sure there is container and canvas
	if (o.gl) {
		return o.gl
	}
	if (o.canvas) {
		o.container = o.canvas.parentNode
	}
	if (o.container) {
		if (typeof o.container === 'string') {
			var c = document.querySelector(o.container)
			if (!c) throw Error('Element ' + o.container + ' is not found')
			o.container = c
		}
		if (isCanvas(o.container)) {
			o.canvas = o.container
			o.container = o.canvas.parentNode
		}
		else if (!o.canvas) {
			o.canvas = createCanvas()
			o.container.appendChild(o.canvas)
			resize(o)
		}
	}
	// blank new canvas
	else if (!o.canvas) {
		if (typeof document !== 'undefined') {
			o.container = document.body || document.documentElement
			o.canvas = createCanvas()
			o.container.appendChild(o.canvas)
			resize(o)
		}
		else {
			throw Error('Not DOM environment. Use headless-gl.')
		}
	}

	// make sure there is context
	if (!o.gl) {
		['webgl', 'experimental-webgl', 'webgl-experimental'].some(function (c) {
			try {
				o.gl = o.canvas.getContext(c, o.attrs);
			} catch (e) { /* no-op */ }
			return o.gl;
		});
	}

	return o.gl
}


function resize (o) {
	if (o.container) {
		if (o.container == document.body) {
			if (!document.body.style.width) o.canvas.width = o.width || (o.pixelRatio * __webpack_require__.g.innerWidth)
			if (!document.body.style.height) o.canvas.height = o.height || (o.pixelRatio * __webpack_require__.g.innerHeight)
		}
		else {
			var bounds = o.container.getBoundingClientRect()
			o.canvas.width = o.width || (bounds.right - bounds.left)
			o.canvas.height = o.height || (bounds.bottom - bounds.top)
		}
	}
}

function isCanvas (e) {
	return typeof e.getContext === 'function'
		&& 'width' in e
		&& 'height' in e
}

function isElement (e) {
	return typeof e.nodeName === 'string' &&
		typeof e.appendChild === 'function' &&
		typeof e.getBoundingClientRect === 'function'
}

function isContext (e) {
	return typeof e.drawArrays === 'function' ||
		typeof e.drawElements === 'function'
}

function createCanvas () {
	var canvas = document.createElement('canvas')
	canvas.style.position = 'absolute'
	canvas.style.top = 0
	canvas.style.left = 0

	return canvas
}


/***/ }),

/***/ 76765:
/***/ (function(module) {

module.exports = function(strings) {
  if (typeof strings === 'string') strings = [strings]
  var exprs = [].slice.call(arguments,1)
  var parts = []
  for (var i = 0; i < strings.length-1; i++) {
    parts.push(strings[i], exprs[i] || '')
  }
  parts.push(strings[i])
  return parts.join('')
}


/***/ }),

/***/ 52991:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(71129);

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);

if ($gOPD) {
	try {
		$gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		$gOPD = null;
	}
}

module.exports = $gOPD;


/***/ }),

/***/ 39784:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isBrowser = __webpack_require__(78253)
var hasHover

if (typeof __webpack_require__.g.matchMedia === 'function') {
	hasHover = !__webpack_require__.g.matchMedia('(hover: none)').matches
}
else {
	hasHover = isBrowser
}

module.exports = hasHover


/***/ }),

/***/ 74043:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isBrowser = __webpack_require__(78253)

function detect() {
	var supported = false

	try {
		var opts = Object.defineProperty({}, 'passive', {
			get: function() {
				supported = true
			}
		})

		window.addEventListener('test', null, opts)
		window.removeEventListener('test', null, opts)
	} catch(e) {
		supported = false
	}

	return supported
}

module.exports = isBrowser && detect()


/***/ }),

/***/ 74268:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var $defineProperty = __webpack_require__(40891);

var hasPropertyDescriptors = function hasPropertyDescriptors() {
	return !!$defineProperty;
};

hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
	// node v0.6 has a bug where array lengths can be Set but not Defined
	if (!$defineProperty) {
		return null;
	}
	try {
		return $defineProperty([], 'length', { value: 1 }).length !== 1;
	} catch (e) {
		// In Firefox 4-22, defining length on an array throws an exception.
		return true;
	}
};

module.exports = hasPropertyDescriptors;


/***/ }),

/***/ 58436:
/***/ (function(module) {

"use strict";


var test = {
	foo: {}
};

var $Object = Object;

module.exports = function hasProto() {
	return { __proto__: test }.foo === test.foo && !({ __proto__: null } instanceof $Object);
};


/***/ }),

/***/ 8771:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__(59457);

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};


/***/ }),

/***/ 59457:
/***/ (function(module) {

"use strict";


/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),

/***/ 36912:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var hasSymbols = __webpack_require__(59457);

/** @type {import('.')} */
module.exports = function hasToStringTagShams() {
	return hasSymbols() && !!Symbol.toStringTag;
};


/***/ }),

/***/ 80753:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var call = Function.prototype.call;
var $hasOwn = Object.prototype.hasOwnProperty;
var bind = __webpack_require__(87547);

/** @type {import('.')} */
module.exports = bind.call(call, $hasOwn);


/***/ }),

/***/ 27415:
/***/ (function(__unused_webpack_module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ 28062:
/***/ (function(module) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      })
    }
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      var TempCtor = function () {}
      TempCtor.prototype = superCtor.prototype
      ctor.prototype = new TempCtor()
      ctor.prototype.constructor = ctor
    }
  }
}


/***/ }),

/***/ 40280:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var hasToStringTag = __webpack_require__(36912)();
var callBound = __webpack_require__(63063);

var $toString = callBound('Object.prototype.toString');

var isStandardArguments = function isArguments(value) {
	if (hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) {
		return false;
	}
	return $toString(value) === '[object Arguments]';
};

var isLegacyArguments = function isArguments(value) {
	if (isStandardArguments(value)) {
		return true;
	}
	return value !== null &&
		typeof value === 'object' &&
		typeof value.length === 'number' &&
		value.length >= 0 &&
		$toString(value) !== '[object Array]' &&
		$toString(value.callee) === '[object Function]';
};

var supportsStandardArguments = (function () {
	return isStandardArguments(arguments);
}());

isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests

module.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;


/***/ }),

/***/ 78253:
/***/ (function(module) {

module.exports = true;

/***/ }),

/***/ 82756:
/***/ (function(module) {

"use strict";


var fnToStr = Function.prototype.toString;
var reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var badArrayLike;
var isCallableMarker;
if (typeof reflectApply === 'function' && typeof Object.defineProperty === 'function') {
	try {
		badArrayLike = Object.defineProperty({}, 'length', {
			get: function () {
				throw isCallableMarker;
			}
		});
		isCallableMarker = {};
		// eslint-disable-next-line no-throw-literal
		reflectApply(function () { throw 42; }, null, badArrayLike);
	} catch (_) {
		if (_ !== isCallableMarker) {
			reflectApply = null;
		}
	}
} else {
	reflectApply = null;
}

var constructorRegex = /^\s*class\b/;
var isES6ClassFn = function isES6ClassFunction(value) {
	try {
		var fnStr = fnToStr.call(value);
		return constructorRegex.test(fnStr);
	} catch (e) {
		return false; // not a function
	}
};

var tryFunctionObject = function tryFunctionToStr(value) {
	try {
		if (isES6ClassFn(value)) { return false; }
		fnToStr.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr = Object.prototype.toString;
var objectClass = '[object Object]';
var fnClass = '[object Function]';
var genClass = '[object GeneratorFunction]';
var ddaClass = '[object HTMLAllCollection]'; // IE 11
var ddaClass2 = '[object HTML document.all class]';
var ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`

var isIE68 = !(0 in [,]); // eslint-disable-line no-sparse-arrays, comma-spacing

var isDDA = function isDocumentDotAll() { return false; };
if (typeof document === 'object') {
	// Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
	var all = document.all;
	if (toStr.call(all) === toStr.call(document.all)) {
		isDDA = function isDocumentDotAll(value) {
			/* globals document: false */
			// in IE 6-8, typeof document.all is "object" and it's truthy
			if ((isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) {
				try {
					var str = toStr.call(value);
					return (
						str === ddaClass
						|| str === ddaClass2
						|| str === ddaClass3 // opera 12.16
						|| str === objectClass // IE 6-8
					) && value('') == null; // eslint-disable-line eqeqeq
				} catch (e) { /**/ }
			}
			return false;
		};
	}
}

module.exports = reflectApply
	? function isCallable(value) {
		if (isDDA(value)) { return true; }
		if (!value) { return false; }
		if (typeof value !== 'function' && typeof value !== 'object') { return false; }
		try {
			reflectApply(value, null, badArrayLike);
		} catch (e) {
			if (e !== isCallableMarker) { return false; }
		}
		return !isES6ClassFn(value) && tryFunctionObject(value);
	}
	: function isCallable(value) {
		if (isDDA(value)) { return true; }
		if (!value) { return false; }
		if (typeof value !== 'function' && typeof value !== 'object') { return false; }
		if (hasToStringTag) { return tryFunctionObject(value); }
		if (isES6ClassFn(value)) { return false; }
		var strClass = toStr.call(value);
		if (strClass !== fnClass && strClass !== genClass && !(/^\[object HTML/).test(strClass)) { return false; }
		return tryFunctionObject(value);
	};


/***/ }),

/***/ 80340:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;
var fnToStr = Function.prototype.toString;
var isFnRegex = /^\s*(?:function)?\*/;
var hasToStringTag = __webpack_require__(36912)();
var getProto = Object.getPrototypeOf;
var getGeneratorFunc = function () { // eslint-disable-line consistent-return
	if (!hasToStringTag) {
		return false;
	}
	try {
		return Function('return function*() {}')();
	} catch (e) {
	}
};
var GeneratorFunction;

module.exports = function isGeneratorFunction(fn) {
	if (typeof fn !== 'function') {
		return false;
	}
	if (isFnRegex.test(fnToStr.call(fn))) {
		return true;
	}
	if (!hasToStringTag) {
		var str = toStr.call(fn);
		return str === '[object GeneratorFunction]';
	}
	if (!getProto) {
		return false;
	}
	if (typeof GeneratorFunction === 'undefined') {
		var generatorFunc = getGeneratorFunc();
		GeneratorFunction = generatorFunc ? getProto(generatorFunc) : false;
	}
	return getProto(fn) === GeneratorFunction;
};


/***/ }),

/***/ 39488:
/***/ (function(module) {

"use strict";

module.exports = typeof navigator !== 'undefined' &&
	(/MSIE/.test(navigator.userAgent) || /Trident\//.test(navigator.appVersion));


/***/ }),

/***/ 73287:
/***/ (function(module) {

"use strict";


/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */

module.exports = function isNaN(value) {
	return value !== value;
};


/***/ }),

/***/ 63057:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var callBind = __webpack_require__(87227);
var define = __webpack_require__(97936);

var implementation = __webpack_require__(73287);
var getPolyfill = __webpack_require__(60758);
var shim = __webpack_require__(85684);

var polyfill = callBind(getPolyfill(), Number);

/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */

define(polyfill, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = polyfill;


/***/ }),

/***/ 60758:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(73287);

module.exports = function getPolyfill() {
	if (Number.isNaN && Number.isNaN(NaN) && !Number.isNaN('a')) {
		return Number.isNaN;
	}
	return implementation;
};


/***/ }),

/***/ 85684:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(97936);
var getPolyfill = __webpack_require__(60758);

/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */

module.exports = function shimNumberIsNaN() {
	var polyfill = getPolyfill();
	define(Number, { isNaN: polyfill }, {
		isNaN: function testIsNaN() {
			return Number.isNaN !== polyfill;
		}
	});
	return polyfill;
};


/***/ }),

/***/ 60201:
/***/ (function(module) {

"use strict";

module.exports = function (x) {
	var type = typeof x;
	return x !== null && (type === 'object' || type === 'function');
};


/***/ }),

/***/ 29388:
/***/ (function(module) {

"use strict";

var toString = Object.prototype.toString;

module.exports = function (x) {
	var prototype;
	return toString.call(x) === '[object Object]' && (prototype = Object.getPrototypeOf(x), prototype === null || prototype === Object.getPrototypeOf({}));
};


/***/ }),

/***/ 9914:
/***/ (function(module) {

"use strict";


/**
 * Is this string all whitespace?
 * This solution kind of makes my brain hurt, but it's significantly faster
 * than !str.trim() or any other solution I could find.
 *
 * whitespace codes from: http://en.wikipedia.org/wiki/Whitespace_character
 * and verified with:
 *
 *  for(var i = 0; i < 65536; i++) {
 *      var s = String.fromCharCode(i);
 *      if(+s===0 && !s.trim()) console.log(i, s);
 *  }
 *
 * which counts a couple of these as *not* whitespace, but finds nothing else
 * that *is* whitespace. Note that charCodeAt stops at 16 bits, but it appears
 * that there are no whitespace characters above this, and code points above
 * this do not map onto white space characters.
 */

module.exports = function(str){
    var l = str.length,
        a;
    for(var i = 0; i < l; i++) {
        a = str.charCodeAt(i);
        if((a < 9 || a > 13) && (a !== 32) && (a !== 133) && (a !== 160) &&
            (a !== 5760) && (a !== 6158) && (a < 8192 || a > 8205) &&
            (a !== 8232) && (a !== 8233) && (a !== 8239) && (a !== 8287) &&
            (a !== 8288) && (a !== 12288) && (a !== 65279)) {
                return false;
        }
    }
    return true;
}


/***/ }),

/***/ 13986:
/***/ (function(module) {

"use strict";


module.exports = function isPath(str) {
	if (typeof str !== 'string') return false

	str = str.trim()

	// https://www.w3.org/TR/SVG/paths.html#PathDataBNF
	if (/^[mzlhvcsqta]\s*[-+.0-9][^mlhvzcsqta]+/i.test(str) && /[\dz]$/i.test(str) && str.length > 4) return true

	return false
}


/***/ }),

/***/ 15628:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var forEach = __webpack_require__(61262);
var availableTypedArrays = __webpack_require__(70085);
var callBound = __webpack_require__(63063);

var $toString = callBound('Object.prototype.toString');
var hasToStringTag = __webpack_require__(36912)();
var gOPD = __webpack_require__(52991);

var g = typeof globalThis === 'undefined' ? __webpack_require__.g : globalThis;
var typedArrays = availableTypedArrays();

var $indexOf = callBound('Array.prototype.indexOf', true) || function indexOf(array, value) {
	for (var i = 0; i < array.length; i += 1) {
		if (array[i] === value) {
			return i;
		}
	}
	return -1;
};
var $slice = callBound('String.prototype.slice');
var toStrTags = {};
var getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
if (hasToStringTag && gOPD && getPrototypeOf) {
	forEach(typedArrays, function (typedArray) {
		var arr = new g[typedArray]();
		if (Symbol.toStringTag in arr) {
			var proto = getPrototypeOf(arr);
			var descriptor = gOPD(proto, Symbol.toStringTag);
			if (!descriptor) {
				var superProto = getPrototypeOf(proto);
				descriptor = gOPD(superProto, Symbol.toStringTag);
			}
			toStrTags[typedArray] = descriptor.get;
		}
	});
}

var tryTypedArrays = function tryAllTypedArrays(value) {
	var anyTrue = false;
	forEach(toStrTags, function (getter, typedArray) {
		if (!anyTrue) {
			try {
				anyTrue = getter.call(value) === typedArray;
			} catch (e) { /**/ }
		}
	});
	return anyTrue;
};

module.exports = function isTypedArray(value) {
	if (!value || typeof value !== 'object') { return false; }
	if (!hasToStringTag || !(Symbol.toStringTag in value)) {
		var tag = $slice($toString(value), 8, -1);
		return $indexOf(typedArrays, tag) > -1;
	}
	if (!gOPD) { return false; }
	return tryTypedArrays(value);
};


/***/ }),

/***/ 62914:
/***/ (function(module) {

"use strict";

module.exports = Math.log2 || function (x) {
	return Math.log(x) * Math.LOG2E;
};


/***/ }),

/***/ 99978:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = mouseListen

var mouse = __webpack_require__(41926)

function mouseListen (element, callback) {
  if (!callback) {
    callback = element
    element = window
  }

  var buttonState = 0
  var x = 0
  var y = 0
  var mods = {
    shift: false,
    alt: false,
    control: false,
    meta: false
  }
  var attached = false

  function updateMods (ev) {
    var changed = false
    if ('altKey' in ev) {
      changed = changed || ev.altKey !== mods.alt
      mods.alt = !!ev.altKey
    }
    if ('shiftKey' in ev) {
      changed = changed || ev.shiftKey !== mods.shift
      mods.shift = !!ev.shiftKey
    }
    if ('ctrlKey' in ev) {
      changed = changed || ev.ctrlKey !== mods.control
      mods.control = !!ev.ctrlKey
    }
    if ('metaKey' in ev) {
      changed = changed || ev.metaKey !== mods.meta
      mods.meta = !!ev.metaKey
    }
    return changed
  }

  function handleEvent (nextButtons, ev) {
    var nextX = mouse.x(ev)
    var nextY = mouse.y(ev)
    if ('buttons' in ev) {
      nextButtons = ev.buttons | 0
    }
    if (nextButtons !== buttonState ||
      nextX !== x ||
      nextY !== y ||
      updateMods(ev)) {
      buttonState = nextButtons | 0
      x = nextX || 0
      y = nextY || 0
      callback && callback(buttonState, x, y, mods)
    }
  }

  function clearState (ev) {
    handleEvent(0, ev)
  }

  function handleBlur () {
    if (buttonState ||
      x ||
      y ||
      mods.shift ||
      mods.alt ||
      mods.meta ||
      mods.control) {
      x = y = 0
      buttonState = 0
      mods.shift = mods.alt = mods.control = mods.meta = false
      callback && callback(0, 0, 0, mods)
    }
  }

  function handleMods (ev) {
    if (updateMods(ev)) {
      callback && callback(buttonState, x, y, mods)
    }
  }

  function handleMouseMove (ev) {
    if (mouse.buttons(ev) === 0) {
      handleEvent(0, ev)
    } else {
      handleEvent(buttonState, ev)
    }
  }

  function handleMouseDown (ev) {
    handleEvent(buttonState | mouse.buttons(ev), ev)
  }

  function handleMouseUp (ev) {
    handleEvent(buttonState & ~mouse.buttons(ev), ev)
  }

  function attachListeners () {
    if (attached) {
      return
    }
    attached = true

    element.addEventListener('mousemove', handleMouseMove)

    element.addEventListener('mousedown', handleMouseDown)

    element.addEventListener('mouseup', handleMouseUp)

    element.addEventListener('mouseleave', clearState)
    element.addEventListener('mouseenter', clearState)
    element.addEventListener('mouseout', clearState)
    element.addEventListener('mouseover', clearState)

    element.addEventListener('blur', handleBlur)

    element.addEventListener('keyup', handleMods)
    element.addEventListener('keydown', handleMods)
    element.addEventListener('keypress', handleMods)

    if (element !== window) {
      window.addEventListener('blur', handleBlur)

      window.addEventListener('keyup', handleMods)
      window.addEventListener('keydown', handleMods)
      window.addEventListener('keypress', handleMods)
    }
  }

  function detachListeners () {
    if (!attached) {
      return
    }
    attached = false

    element.removeEventListener('mousemove', handleMouseMove)

    element.removeEventListener('mousedown', handleMouseDown)

    element.removeEventListener('mouseup', handleMouseUp)

    element.removeEventListener('mouseleave', clearState)
    element.removeEventListener('mouseenter', clearState)
    element.removeEventListener('mouseout', clearState)
    element.removeEventListener('mouseover', clearState)

    element.removeEventListener('blur', handleBlur)

    element.removeEventListener('keyup', handleMods)
    element.removeEventListener('keydown', handleMods)
    element.removeEventListener('keypress', handleMods)

    if (element !== window) {
      window.removeEventListener('blur', handleBlur)

      window.removeEventListener('keyup', handleMods)
      window.removeEventListener('keydown', handleMods)
      window.removeEventListener('keypress', handleMods)
    }
  }

  // Attach listeners
  attachListeners()

  var result = {
    element: element
  }

  Object.defineProperties(result, {
    enabled: {
      get: function () { return attached },
      set: function (f) {
        if (f) {
          attachListeners()
        } else {
          detachListeners()
        }
      },
      enumerable: true
    },
    buttons: {
      get: function () { return buttonState },
      enumerable: true
    },
    x: {
      get: function () { return x },
      enumerable: true
    },
    y: {
      get: function () { return y },
      enumerable: true
    },
    mods: {
      get: function () { return mods },
      enumerable: true
    }
  })

  return result
}


/***/ }),

/***/ 44039:
/***/ (function(module) {

var rootPosition = { left: 0, top: 0 }

module.exports = mouseEventOffset
function mouseEventOffset (ev, target, out) {
  target = target || ev.currentTarget || ev.srcElement
  if (!Array.isArray(out)) {
    out = [ 0, 0 ]
  }
  var cx = ev.clientX || 0
  var cy = ev.clientY || 0
  var rect = getBoundingClientOffset(target)
  out[0] = cx - rect.left
  out[1] = cy - rect.top
  return out
}

function getBoundingClientOffset (element) {
  if (element === window ||
      element === document ||
      element === document.body) {
    return rootPosition
  } else {
    return element.getBoundingClientRect()
  }
}


/***/ }),

/***/ 41926:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


function mouseButtons(ev) {
  if(typeof ev === 'object') {
    if('buttons' in ev) {
      return ev.buttons
    } else if('which' in ev) {
      var b = ev.which
      if(b === 2) {
        return 4
      } else if(b === 3) {
        return 2
      } else if(b > 0) {
        return 1<<(b-1)
      }
    } else if('button' in ev) {
      var b = ev.button
      if(b === 1) {
        return 4
      } else if(b === 2) {
        return 2
      } else if(b >= 0) {
        return 1<<b
      }
    }
  }
  return 0
}
exports.buttons = mouseButtons

function mouseElement(ev) {
  return ev.target || ev.srcElement || window
}
exports.element = mouseElement

function mouseRelativeX(ev) {
  if(typeof ev === 'object') {
    if('offsetX' in ev) {
      return ev.offsetX
    }
    var target = mouseElement(ev)
    var bounds = target.getBoundingClientRect()
    return ev.clientX - bounds.left
  }
  return 0
}
exports.x = mouseRelativeX

function mouseRelativeY(ev) {
  if(typeof ev === 'object') {
    if('offsetY' in ev) {
      return ev.offsetY
    }
    var target = mouseElement(ev)
    var bounds = target.getBoundingClientRect()
    return ev.clientY - bounds.top
  }
  return 0
}
exports.y = mouseRelativeY


/***/ }),

/***/ 20573:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var toPX = __webpack_require__(44626)

module.exports = mouseWheelListen

function mouseWheelListen(element, callback, noScroll) {
  if(typeof element === 'function') {
    noScroll = !!callback
    callback = element
    element = window
  }
  var lineHeight = toPX('ex', element)
  var listener = function(ev) {
    if(noScroll) {
      ev.preventDefault()
    }
    var dx = ev.deltaX || 0
    var dy = ev.deltaY || 0
    var dz = ev.deltaZ || 0
    var mode = ev.deltaMode
    var scale = 1
    switch(mode) {
      case 1:
        scale = lineHeight
      break
      case 2:
        scale = window.innerHeight
      break
    }
    dx *= scale
    dy *= scale
    dz *= scale
    if(dx || dy || dz) {
      return callback(dx, dy, dz, ev)
    }
  }
  element.addEventListener('wheel', listener)
  return listener
}


/***/ }),

/***/ 71116:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! Native Promise Only
    v0.8.1 (c) Kyle Simpson
    MIT License: http://getify.mit-license.org
*/

(function UMD(name,context,definition){
	// special form of UMD for polyfilling across evironments
	context[name] = context[name] || definition();
	if ( true && module.exports) { module.exports = context[name]; }
	else if (true) { !(__WEBPACK_AMD_DEFINE_RESULT__ = (function $AMD$(){ return context[name]; }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)); }
})("Promise",typeof __webpack_require__.g != "undefined" ? __webpack_require__.g : this,function DEF(){
	/*jshint validthis:true */
	"use strict";

	var builtInProp, cycle, scheduling_queue,
		ToString = Object.prototype.toString,
		timer = (typeof setImmediate != "undefined") ?
			function timer(fn) { return setImmediate(fn); } :
			setTimeout
	;

	// dammit, IE8.
	try {
		Object.defineProperty({},"x",{});
		builtInProp = function builtInProp(obj,name,val,config) {
			return Object.defineProperty(obj,name,{
				value: val,
				writable: true,
				configurable: config !== false
			});
		};
	}
	catch (err) {
		builtInProp = function builtInProp(obj,name,val) {
			obj[name] = val;
			return obj;
		};
	}

	// Note: using a queue instead of array for efficiency
	scheduling_queue = (function Queue() {
		var first, last, item;

		function Item(fn,self) {
			this.fn = fn;
			this.self = self;
			this.next = void 0;
		}

		return {
			add: function add(fn,self) {
				item = new Item(fn,self);
				if (last) {
					last.next = item;
				}
				else {
					first = item;
				}
				last = item;
				item = void 0;
			},
			drain: function drain() {
				var f = first;
				first = last = cycle = void 0;

				while (f) {
					f.fn.call(f.self);
					f = f.next;
				}
			}
		};
	})();

	function schedule(fn,self) {
		scheduling_queue.add(fn,self);
		if (!cycle) {
			cycle = timer(scheduling_queue.drain);
		}
	}

	// promise duck typing
	function isThenable(o) {
		var _then, o_type = typeof o;

		if (o != null &&
			(
				o_type == "object" || o_type == "function"
			)
		) {
			_then = o.then;
		}
		return typeof _then == "function" ? _then : false;
	}

	function notify() {
		for (var i=0; i<this.chain.length; i++) {
			notifyIsolated(
				this,
				(this.state === 1) ? this.chain[i].success : this.chain[i].failure,
				this.chain[i]
			);
		}
		this.chain.length = 0;
	}

	// NOTE: This is a separate function to isolate
	// the `try..catch` so that other code can be
	// optimized better
	function notifyIsolated(self,cb,chain) {
		var ret, _then;
		try {
			if (cb === false) {
				chain.reject(self.msg);
			}
			else {
				if (cb === true) {
					ret = self.msg;
				}
				else {
					ret = cb.call(void 0,self.msg);
				}

				if (ret === chain.promise) {
					chain.reject(TypeError("Promise-chain cycle"));
				}
				else if (_then = isThenable(ret)) {
					_then.call(ret,chain.resolve,chain.reject);
				}
				else {
					chain.resolve(ret);
				}
			}
		}
		catch (err) {
			chain.reject(err);
		}
	}

	function resolve(msg) {
		var _then, self = this;

		// already triggered?
		if (self.triggered) { return; }

		self.triggered = true;

		// unwrap
		if (self.def) {
			self = self.def;
		}

		try {
			if (_then = isThenable(msg)) {
				schedule(function(){
					var def_wrapper = new MakeDefWrapper(self);
					try {
						_then.call(msg,
							function $resolve$(){ resolve.apply(def_wrapper,arguments); },
							function $reject$(){ reject.apply(def_wrapper,arguments); }
						);
					}
					catch (err) {
						reject.call(def_wrapper,err);
					}
				})
			}
			else {
				self.msg = msg;
				self.state = 1;
				if (self.chain.length > 0) {
					schedule(notify,self);
				}
			}
		}
		catch (err) {
			reject.call(new MakeDefWrapper(self),err);
		}
	}

	function reject(msg) {
		var self = this;

		// already triggered?
		if (self.triggered) { return; }

		self.triggered = true;

		// unwrap
		if (self.def) {
			self = self.def;
		}

		self.msg = msg;
		self.state = 2;
		if (self.chain.length > 0) {
			schedule(notify,self);
		}
	}

	function iteratePromises(Constructor,arr,resolver,rejecter) {
		for (var idx=0; idx<arr.length; idx++) {
			(function IIFE(idx){
				Constructor.resolve(arr[idx])
				.then(
					function $resolver$(msg){
						resolver(idx,msg);
					},
					rejecter
				);
			})(idx);
		}
	}

	function MakeDefWrapper(self) {
		this.def = self;
		this.triggered = false;
	}

	function MakeDef(self) {
		this.promise = self;
		this.state = 0;
		this.triggered = false;
		this.chain = [];
		this.msg = void 0;
	}

	function Promise(executor) {
		if (typeof executor != "function") {
			throw TypeError("Not a function");
		}

		if (this.__NPO__ !== 0) {
			throw TypeError("Not a promise");
		}

		// instance shadowing the inherited "brand"
		// to signal an already "initialized" promise
		this.__NPO__ = 1;

		var def = new MakeDef(this);

		this["then"] = function then(success,failure) {
			var o = {
				success: typeof success == "function" ? success : true,
				failure: typeof failure == "function" ? failure : false
			};
			// Note: `then(..)` itself can be borrowed to be used against
			// a different promise constructor for making the chained promise,
			// by substituting a different `this` binding.
			o.promise = new this.constructor(function extractChain(resolve,reject) {
				if (typeof resolve != "function" || typeof reject != "function") {
					throw TypeError("Not a function");
				}

				o.resolve = resolve;
				o.reject = reject;
			});
			def.chain.push(o);

			if (def.state !== 0) {
				schedule(notify,def);
			}

			return o.promise;
		};
		this["catch"] = function $catch$(failure) {
			return this.then(void 0,failure);
		};

		try {
			executor.call(
				void 0,
				function publicResolve(msg){
					resolve.call(def,msg);
				},
				function publicReject(msg) {
					reject.call(def,msg);
				}
			);
		}
		catch (err) {
			reject.call(def,err);
		}
	}

	var PromisePrototype = builtInProp({},"constructor",Promise,
		/*configurable=*/false
	);

	// Note: Android 4 cannot use `Object.defineProperty(..)` here
	Promise.prototype = PromisePrototype;

	// built-in "brand" to signal an "uninitialized" promise
	builtInProp(PromisePrototype,"__NPO__",0,
		/*configurable=*/false
	);

	builtInProp(Promise,"resolve",function Promise$resolve(msg) {
		var Constructor = this;

		// spec mandated checks
		// note: best "isPromise" check that's practical for now
		if (msg && typeof msg == "object" && msg.__NPO__ === 1) {
			return msg;
		}

		return new Constructor(function executor(resolve,reject){
			if (typeof resolve != "function" || typeof reject != "function") {
				throw TypeError("Not a function");
			}

			resolve(msg);
		});
	});

	builtInProp(Promise,"reject",function Promise$reject(msg) {
		return new this(function executor(resolve,reject){
			if (typeof resolve != "function" || typeof reject != "function") {
				throw TypeError("Not a function");
			}

			reject(msg);
		});
	});

	builtInProp(Promise,"all",function Promise$all(arr) {
		var Constructor = this;

		// spec mandated checks
		if (ToString.call(arr) != "[object Array]") {
			return Constructor.reject(TypeError("Not an array"));
		}
		if (arr.length === 0) {
			return Constructor.resolve([]);
		}

		return new Constructor(function executor(resolve,reject){
			if (typeof resolve != "function" || typeof reject != "function") {
				throw TypeError("Not a function");
			}

			var len = arr.length, msgs = Array(len), count = 0;

			iteratePromises(Constructor,arr,function resolver(idx,msg) {
				msgs[idx] = msg;
				if (++count === len) {
					resolve(msgs);
				}
			},reject);
		});
	});

	builtInProp(Promise,"race",function Promise$race(arr) {
		var Constructor = this;

		// spec mandated checks
		if (ToString.call(arr) != "[object Array]") {
			return Constructor.reject(TypeError("Not an array"));
		}

		return new Constructor(function executor(resolve,reject){
			if (typeof resolve != "function" || typeof reject != "function") {
				throw TypeError("Not a function");
			}

			iteratePromises(Constructor,arr,function resolver(idx,msg){
				resolve(msg);
			},reject);
		});
	});

	return Promise;
});


/***/ }),

/***/ 60265:
/***/ (function(module) {


var π = Math.PI
var _120 = radians(120)

module.exports = normalize

/**
 * describe `path` in terms of cubic bézier 
 * curves and move commands
 *
 * @param {Array} path
 * @return {Array}
 */

function normalize(path){
	// init state
	var prev
	var result = []
	var bezierX = 0
	var bezierY = 0
	var startX = 0
	var startY = 0
	var quadX = null
	var quadY = null
	var x = 0
	var y = 0

	for (var i = 0, len = path.length; i < len; i++) {
		var seg = path[i]
		var command = seg[0]
		switch (command) {
			case 'M':
				startX = seg[1]
				startY = seg[2]
				break
			case 'A':
				seg = arc(x, y,seg[1],seg[2],radians(seg[3]),seg[4],seg[5],seg[6],seg[7])
				// split multi part
				seg.unshift('C')
				if (seg.length > 7) {
					result.push(seg.splice(0, 7))
					seg.unshift('C')
				}
				break
			case 'S':
				// default control point
				var cx = x
				var cy = y
				if (prev == 'C' || prev == 'S') {
					cx += cx - bezierX // reflect the previous command's control
					cy += cy - bezierY // point relative to the current point
				}
				seg = ['C', cx, cy, seg[1], seg[2], seg[3], seg[4]]
				break
			case 'T':
				if (prev == 'Q' || prev == 'T') {
					quadX = x * 2 - quadX // as with 'S' reflect previous control point
					quadY = y * 2 - quadY
				} else {
					quadX = x
					quadY = y
				}
				seg = quadratic(x, y, quadX, quadY, seg[1], seg[2])
				break
			case 'Q':
				quadX = seg[1]
				quadY = seg[2]
				seg = quadratic(x, y, seg[1], seg[2], seg[3], seg[4])
				break
			case 'L':
				seg = line(x, y, seg[1], seg[2])
				break
			case 'H':
				seg = line(x, y, seg[1], y)
				break
			case 'V':
				seg = line(x, y, x, seg[1])
				break
			case 'Z':
				seg = line(x, y, startX, startY)
				break
		}

		// update state
		prev = command
		x = seg[seg.length - 2]
		y = seg[seg.length - 1]
		if (seg.length > 4) {
			bezierX = seg[seg.length - 4]
			bezierY = seg[seg.length - 3]
		} else {
			bezierX = x
			bezierY = y
		}
		result.push(seg)
	}

	return result
}

function line(x1, y1, x2, y2){
	return ['C', x1, y1, x2, y2, x2, y2]
}

function quadratic(x1, y1, cx, cy, x2, y2){
	return [
		'C',
		x1/3 + (2/3) * cx,
		y1/3 + (2/3) * cy,
		x2/3 + (2/3) * cx,
		y2/3 + (2/3) * cy,
		x2,
		y2
	]
}

// This function is ripped from 
// github.com/DmitryBaranovskiy/raphael/blob/4d97d4/raphael.js#L2216-L2304 
// which references w3.org/TR/SVG11/implnote.html#ArcImplementationNotes
// TODO: make it human readable

function arc(x1, y1, rx, ry, angle, large_arc_flag, sweep_flag, x2, y2, recursive) {
	if (!recursive) {
		var xy = rotate(x1, y1, -angle)
		x1 = xy.x
		y1 = xy.y
		xy = rotate(x2, y2, -angle)
		x2 = xy.x
		y2 = xy.y
		var x = (x1 - x2) / 2
		var y = (y1 - y2) / 2
		var h = (x * x) / (rx * rx) + (y * y) / (ry * ry)
		if (h > 1) {
			h = Math.sqrt(h)
			rx = h * rx
			ry = h * ry
		}
		var rx2 = rx * rx
		var ry2 = ry * ry
		var k = (large_arc_flag == sweep_flag ? -1 : 1)
			* Math.sqrt(Math.abs((rx2 * ry2 - rx2 * y * y - ry2 * x * x) / (rx2 * y * y + ry2 * x * x)))
		if (k == Infinity) k = 1 // neutralize
		var cx = k * rx * y / ry + (x1 + x2) / 2
		var cy = k * -ry * x / rx + (y1 + y2) / 2
		var f1 = Math.asin(((y1 - cy) / ry).toFixed(9))
		var f2 = Math.asin(((y2 - cy) / ry).toFixed(9))

		f1 = x1 < cx ? π - f1 : f1
		f2 = x2 < cx ? π - f2 : f2
		if (f1 < 0) f1 = π * 2 + f1
		if (f2 < 0) f2 = π * 2 + f2
		if (sweep_flag && f1 > f2) f1 = f1 - π * 2
		if (!sweep_flag && f2 > f1) f2 = f2 - π * 2
	} else {
		f1 = recursive[0]
		f2 = recursive[1]
		cx = recursive[2]
		cy = recursive[3]
	}
	// greater than 120 degrees requires multiple segments
	if (Math.abs(f2 - f1) > _120) {
		var f2old = f2
		var x2old = x2
		var y2old = y2
		f2 = f1 + _120 * (sweep_flag && f2 > f1 ? 1 : -1)
		x2 = cx + rx * Math.cos(f2)
		y2 = cy + ry * Math.sin(f2)
		var res = arc(x2, y2, rx, ry, angle, 0, sweep_flag, x2old, y2old, [f2, f2old, cx, cy])
	}
	var t = Math.tan((f2 - f1) / 4)
	var hx = 4 / 3 * rx * t
	var hy = 4 / 3 * ry * t
	var curve = [
		2 * x1 - (x1 + hx * Math.sin(f1)),
		2 * y1 - (y1 - hy * Math.cos(f1)),
		x2 + hx * Math.sin(f2),
		y2 - hy * Math.cos(f2),
		x2,
		y2
	]
	if (recursive) return curve
	if (res) curve = curve.concat(res)
	for (var i = 0; i < curve.length;) {
		var rot = rotate(curve[i], curve[i+1], angle)
		curve[i++] = rot.x
		curve[i++] = rot.y
	}
	return curve
}

function rotate(x, y, rad){
	return {
		x: x * Math.cos(rad) - y * Math.sin(rad),
		y: x * Math.sin(rad) + y * Math.cos(rad)
	}
}

function radians(degress){
	return degress * (π / 180)
}


/***/ }),

/***/ 27976:
/***/ (function(module) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),

/***/ 93063:
/***/ (function(module) {

"use strict";


var numberIsNaN = function (value) {
	return value !== value;
};

module.exports = function is(a, b) {
	if (a === 0 && b === 0) {
		return 1 / a === 1 / b;
	}
	if (a === b) {
		return true;
	}
	if (numberIsNaN(a) && numberIsNaN(b)) {
		return true;
	}
	return false;
};



/***/ }),

/***/ 13969:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(97936);
var callBind = __webpack_require__(87227);

var implementation = __webpack_require__(93063);
var getPolyfill = __webpack_require__(9622);
var shim = __webpack_require__(79796);

var polyfill = callBind(getPolyfill(), Object);

define(polyfill, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = polyfill;


/***/ }),

/***/ 9622:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(93063);

module.exports = function getPolyfill() {
	return typeof Object.is === 'function' ? Object.is : implementation;
};


/***/ }),

/***/ 79796:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var getPolyfill = __webpack_require__(9622);
var define = __webpack_require__(97936);

module.exports = function shimObjectIs() {
	var polyfill = getPolyfill();
	define(Object, { is: polyfill }, {
		is: function testObjectIs() {
			return Object.is !== polyfill;
		}
	});
	return polyfill;
};


/***/ }),

/***/ 61663:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var keysShim;
if (!Object.keys) {
	// modified from https://github.com/es-shims/es5-shim
	var has = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var isArgs = __webpack_require__(52385); // eslint-disable-line global-require
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
	var dontEnums = [
		'toString',
		'toLocaleString',
		'valueOf',
		'hasOwnProperty',
		'isPrototypeOf',
		'propertyIsEnumerable',
		'constructor'
	];
	var equalsConstructorPrototype = function (o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$applicationCache: true,
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$onmozfullscreenchange: true,
		$onmozfullscreenerror: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = (function () {
		/* global window */
		if (typeof window === 'undefined') { return false; }
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}());
	var equalsConstructorPrototypeIfNotBuggy = function (o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};

	keysShim = function keys(object) {
		var isObject = object !== null && typeof object === 'object';
		var isFunction = toStr.call(object) === '[object Function]';
		var isArguments = isArgs(object);
		var isString = isObject && toStr.call(object) === '[object String]';
		var theKeys = [];

		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}

		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}

		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}

		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
}
module.exports = keysShim;


/***/ }),

/***/ 99433:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var slice = Array.prototype.slice;
var isArgs = __webpack_require__(52385);

var origKeys = Object.keys;
var keysShim = origKeys ? function keys(o) { return origKeys(o); } : __webpack_require__(61663);

var originalKeys = Object.keys;

keysShim.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = (function () {
			// Safari 5.0 bug
			var args = Object.keys(arguments);
			return args && args.length === arguments.length;
		}(1, 2));
		if (!keysWorksWithArguments) {
			Object.keys = function keys(object) { // eslint-disable-line func-name-matching
				if (isArgs(object)) {
					return originalKeys(slice.call(object));
				}
				return originalKeys(object);
			};
		}
	} else {
		Object.keys = keysShim;
	}
	return Object.keys || keysShim;
};

module.exports = keysShim;


/***/ }),

/***/ 52385:
/***/ (function(module) {

"use strict";


var toStr = Object.prototype.toString;

module.exports = function isArguments(value) {
	var str = toStr.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' &&
			value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr.call(value.callee) === '[object Function]';
	}
	return isArgs;
};


/***/ }),

/***/ 96927:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


// modified from https://github.com/es-shims/es6-shim
var objectKeys = __webpack_require__(99433);
var hasSymbols = __webpack_require__(59457)();
var callBound = __webpack_require__(63063);
var toObject = Object;
var $push = callBound('Array.prototype.push');
var $propIsEnumerable = callBound('Object.prototype.propertyIsEnumerable');
var originalGetSymbols = hasSymbols ? Object.getOwnPropertySymbols : null;

// eslint-disable-next-line no-unused-vars
module.exports = function assign(target, source1) {
	if (target == null) { throw new TypeError('target must be an object'); }
	var to = toObject(target); // step 1
	if (arguments.length === 1) {
		return to; // step 2
	}
	for (var s = 1; s < arguments.length; ++s) {
		var from = toObject(arguments[s]); // step 3.a.i

		// step 3.a.ii:
		var keys = objectKeys(from);
		var getSymbols = hasSymbols && (Object.getOwnPropertySymbols || originalGetSymbols);
		if (getSymbols) {
			var syms = getSymbols(from);
			for (var j = 0; j < syms.length; ++j) {
				var key = syms[j];
				if ($propIsEnumerable(from, key)) {
					$push(keys, key);
				}
			}
		}

		// step 3.a.iii:
		for (var i = 0; i < keys.length; ++i) {
			var nextKey = keys[i];
			if ($propIsEnumerable(from, nextKey)) { // step 3.a.iii.2
				var propValue = from[nextKey]; // step 3.a.iii.2.a
				to[nextKey] = propValue; // step 3.a.iii.2.b
			}
		}
	}

	return to; // step 4
};


/***/ }),

/***/ 68686:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(96927);

var lacksProperEnumerationOrder = function () {
	if (!Object.assign) {
		return false;
	}
	/*
	 * v8, specifically in node 4.x, has a bug with incorrect property enumeration order
	 * note: this does not detect the bug unless there's 20 characters
	 */
	var str = 'abcdefghijklmnopqrst';
	var letters = str.split('');
	var map = {};
	for (var i = 0; i < letters.length; ++i) {
		map[letters[i]] = letters[i];
	}
	var obj = Object.assign({}, map);
	var actual = '';
	for (var k in obj) {
		actual += k;
	}
	return str !== actual;
};

var assignHasPendingExceptions = function () {
	if (!Object.assign || !Object.preventExtensions) {
		return false;
	}
	/*
	 * Firefox 37 still has "pending exception" logic in its Object.assign implementation,
	 * which is 72% slower than our shim, and Firefox 40's native implementation.
	 */
	var thrower = Object.preventExtensions({ 1: 2 });
	try {
		Object.assign(thrower, 'xy');
	} catch (e) {
		return thrower[1] === 'y';
	}
	return false;
};

module.exports = function getPolyfill() {
	if (!Object.assign) {
		return implementation;
	}
	if (lacksProperEnumerationOrder()) {
		return implementation;
	}
	if (assignHasPendingExceptions()) {
		return implementation;
	}
	return Object.assign;
};


/***/ }),

/***/ 59811:
/***/ (function(module) {

"use strict";


/**
 * @module parenthesis
 */

function parse (str, opts) {
	// pretend non-string parsed per-se
	if (typeof str !== 'string') return [str]

	var res = [str]

	if (typeof opts === 'string' || Array.isArray(opts)) {
		opts = {brackets: opts}
	}
	else if (!opts) opts = {}

	var brackets = opts.brackets ? (Array.isArray(opts.brackets) ? opts.brackets : [opts.brackets]) : ['{}', '[]', '()']

	var escape = opts.escape || '___'

	var flat = !!opts.flat

	brackets.forEach(function (bracket) {
		// create parenthesis regex
		var pRE = new RegExp(['\\', bracket[0], '[^\\', bracket[0], '\\', bracket[1], ']*\\', bracket[1]].join(''))

		var ids = []

		function replaceToken(token, idx, str){
			// save token to res
			var refId = res.push(token.slice(bracket[0].length, -bracket[1].length)) - 1

			ids.push(refId)

			return escape + refId + escape
		}

		res.forEach(function (str, i) {
			var prevStr

			// replace paren tokens till there’s none
			var a = 0
			while (str != prevStr) {
				prevStr = str
				str = str.replace(pRE, replaceToken)
				if (a++ > 10e3) throw Error('References have circular dependency. Please, check them.')
			}

			res[i] = str
		})

		// wrap found refs to brackets
		ids = ids.reverse()
		res = res.map(function (str) {
			ids.forEach(function (id) {
				str = str.replace(new RegExp('(\\' + escape + id + '\\' + escape + ')', 'g'), bracket[0] + '$1' + bracket[1])
			})
			return str
		})
	})

	var re = new RegExp('\\' + escape + '([0-9]+)' + '\\' + escape)

	// transform references to tree
	function nest (str, refs, escape) {
		var res = [], match

		var a = 0
		while (match = re.exec(str)) {
			if (a++ > 10e3) throw Error('Circular references in parenthesis')

			res.push(str.slice(0, match.index))

			res.push(nest(refs[match[1]], refs))

			str = str.slice(match.index + match[0].length)
		}

		res.push(str)

		return res
	}

	return flat ? res : nest(res[0], res)
}

function stringify (arg, opts) {
	if (opts && opts.flat) {
		var escape = opts && opts.escape || '___'

		var str = arg[0], prevStr

		// pretend bad string stringified with no parentheses
		if (!str) return ''


		var re = new RegExp('\\' + escape + '([0-9]+)' + '\\' + escape)

		var a = 0
		while (str != prevStr) {
			if (a++ > 10e3) throw Error('Circular references in ' + arg)
			prevStr = str
			str = str.replace(re, replaceRef)
		}

		return str
	}

	return arg.reduce(function f (prev, curr) {
		if (Array.isArray(curr)) {
			curr = curr.reduce(f, '')
		}
		return prev + curr
	}, '')

	function replaceRef(match, idx){
		if (arg[idx] == null) throw Error('Reference ' + idx + 'is undefined')
		return arg[idx]
	}
}

function parenthesis (arg, opts) {
	if (Array.isArray(arg)) {
		return stringify(arg, opts)
	}
	else {
		return parse(arg, opts)
	}
}

parenthesis.parse = parse
parenthesis.stringify = stringify

module.exports = parenthesis


/***/ }),

/***/ 5137:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var pick = __webpack_require__(6807)

module.exports = parseRect

function parseRect (arg) {
  var rect

  // direct arguments sequence
  if (arguments.length > 1) {
    arg = arguments
  }

  // svg viewbox
  if (typeof arg === 'string') {
    arg = arg.split(/\s/).map(parseFloat)
  }
  else if (typeof arg === 'number') {
    arg = [arg]
  }

  // 0, 0, 100, 100 - array-like
  if (arg.length && typeof arg[0] === 'number') {
    // [w, w]
    if (arg.length === 1) {
      rect = {
        width: arg[0],
        height: arg[0],
        x: 0, y: 0
      }
    }
    // [w, h]
    else if (arg.length === 2) {
      rect = {
        width: arg[0],
        height: arg[1],
        x: 0, y: 0
      }
    }
    // [l, t, r, b]
    else {
      rect = {
        x: arg[0],
        y: arg[1],
        width: (arg[2] - arg[0]) || 0,
        height: (arg[3] - arg[1]) || 0
      }
    }
  }
  // {x, y, w, h} or {l, t, b, r}
  else if (arg) {
    arg = pick(arg, {
      left: 'x l left Left',
      top: 'y t top Top',
      width: 'w width W Width',
      height: 'h height W Width',
      bottom: 'b bottom Bottom',
      right: 'r right Right'
    })

    rect = {
      x: arg.left || 0,
      y: arg.top || 0
    }

    if (arg.width == null) {
      if (arg.right) rect.width = arg.right - rect.x
      else rect.width = 0
    }
    else {
      rect.width = arg.width
    }

    if (arg.height == null) {
      if (arg.bottom) rect.height = arg.bottom - rect.y
      else rect.height = 0
    }
    else {
      rect.height = arg.height
    }
  }

  return rect
}


/***/ }),

/***/ 26953:
/***/ (function(module) {


module.exports = parse

/**
 * expected argument lengths
 * @type {Object}
 */

var length = {a: 7, c: 6, h: 1, l: 2, m: 2, q: 4, s: 4, t: 2, v: 1, z: 0}

/**
 * segment pattern
 * @type {RegExp}
 */

var segment = /([astvzqmhlc])([^astvzqmhlc]*)/ig

/**
 * parse an svg path data string. Generates an Array
 * of commands where each command is an Array of the
 * form `[command, arg1, arg2, ...]`
 *
 * @param {String} path
 * @return {Array}
 */

function parse(path) {
	var data = []
	path.replace(segment, function(_, command, args){
		var type = command.toLowerCase()
		args = parseValues(args)

		// overloaded moveTo
		if (type == 'm' && args.length > 2) {
			data.push([command].concat(args.splice(0, 2)))
			type = 'l'
			command = command == 'm' ? 'l' : 'L'
		}

		while (true) {
			if (args.length == length[type]) {
				args.unshift(command)
				return data.push(args)
			}
			if (args.length < length[type]) throw new Error('malformed path data')
			data.push([command].concat(args.splice(0, length[type])))
		}
	})
	return data
}

var number = /-?[0-9]*\.?[0-9]+(?:e[-+]?\d+)?/ig

function parseValues(args) {
	var numbers = args.match(number)
	return numbers ? numbers.map(Number) : []
}


/***/ }),

/***/ 4957:
/***/ (function(module) {

module.exports = function parseUnit(str, out) {
    if (!out)
        out = [ 0, '' ]

    str = String(str)
    var num = parseFloat(str, 10)
    out[0] = num
    out[1] = str.match(/[\d.\-\+]*\s*(.*)/)[1] || ''
    return out
}

/***/ }),

/***/ 71879:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(33282);
// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map


/***/ }),

/***/ 6807:
/***/ (function(module) {

"use strict";



module.exports = function pick (src, props, keepRest) {
	var result = {}, prop, i

	if (typeof props === 'string') props = toList(props)
	if (Array.isArray(props)) {
		var res = {}
		for (i = 0; i < props.length; i++) {
			res[props[i]] = true
		}
		props = res
	}

	// convert strings to lists
	for (prop in props) {
		props[prop] = toList(props[prop])
	}

	// keep-rest strategy requires unmatched props to be preserved
	var occupied = {}

	for (prop in props) {
		var aliases = props[prop]

		if (Array.isArray(aliases)) {
			for (i = 0; i < aliases.length; i++) {
				var alias = aliases[i]

				if (keepRest) {
					occupied[alias] = true
				}

				if (alias in src) {
					result[prop] = src[alias]

					if (keepRest) {
						for (var j = i; j < aliases.length; j++) {
							occupied[aliases[j]] = true
						}
					}

					break
				}
			}
		}
		else if (prop in src) {
			if (props[prop]) {
				result[prop] = src[prop]
			}

			if (keepRest) {
				occupied[prop] = true
			}
		}
	}

	if (keepRest) {
		for (prop in src) {
			if (occupied[prop]) continue
			result[prop] = src[prop]
		}
	}

	return result
}

var CACHE = {}

function toList(arg) {
	if (CACHE[arg]) return CACHE[arg]
	if (typeof arg === 'string') {
		arg = CACHE[arg] = arg.split(/\s*,\s*|\s+/)
	}
	return arg
}


/***/ }),

/***/ 52773:
/***/ (function(module) {

// ray-casting algorithm based on
// https://wrf.ecse.rpi.edu/Research/Short_Notes/pnpoly.html

module.exports = function pointInPolygonNested (point, vs, start, end) {
    var x = point[0], y = point[1];
    var inside = false;
    if (start === undefined) start = 0;
    if (end === undefined) end = vs.length;
    var len = end - start;
    for (var i = 0, j = len - 1; i < len; j = i++) {
        var xi = vs[i+start][0], yi = vs[i+start][1];
        var xj = vs[j+start][0], yj = vs[j+start][1];
        var intersect = ((yi > y) !== (yj > y))
            && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
        if (intersect) inside = !inside;
    }
    return inside;
};


/***/ }),

/***/ 11516:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/*
 * @copyright 2016 Sean Connelly (@voidqk), http://syntheti.cc
 * @license MIT
 * @preserve Project Home: https://github.com/voidqk/polybooljs
 */

var BuildLog = __webpack_require__(42391);
var Epsilon = __webpack_require__(92990);
var Intersecter = __webpack_require__(26202);
var SegmentChainer = __webpack_require__(22222);
var SegmentSelector = __webpack_require__(17527);
var GeoJSON = __webpack_require__(24491);

var buildLog = false;
var epsilon = Epsilon();

var PolyBool;
PolyBool = {
	// getter/setter for buildLog
	buildLog: function(bl){
		if (bl === true)
			buildLog = BuildLog();
		else if (bl === false)
			buildLog = false;
		return buildLog === false ? false : buildLog.list;
	},
	// getter/setter for epsilon
	epsilon: function(v){
		return epsilon.epsilon(v);
	},

	// core API
	segments: function(poly){
		var i = Intersecter(true, epsilon, buildLog);
		poly.regions.forEach(i.addRegion);
		return {
			segments: i.calculate(poly.inverted),
			inverted: poly.inverted
		};
	},
	combine: function(segments1, segments2){
		var i3 = Intersecter(false, epsilon, buildLog);
		return {
			combined: i3.calculate(
				segments1.segments, segments1.inverted,
				segments2.segments, segments2.inverted
			),
			inverted1: segments1.inverted,
			inverted2: segments2.inverted
		};
	},
	selectUnion: function(combined){
		return {
			segments: SegmentSelector.union(combined.combined, buildLog),
			inverted: combined.inverted1 || combined.inverted2
		}
	},
	selectIntersect: function(combined){
		return {
			segments: SegmentSelector.intersect(combined.combined, buildLog),
			inverted: combined.inverted1 && combined.inverted2
		}
	},
	selectDifference: function(combined){
		return {
			segments: SegmentSelector.difference(combined.combined, buildLog),
			inverted: combined.inverted1 && !combined.inverted2
		}
	},
	selectDifferenceRev: function(combined){
		return {
			segments: SegmentSelector.differenceRev(combined.combined, buildLog),
			inverted: !combined.inverted1 && combined.inverted2
		}
	},
	selectXor: function(combined){
		return {
			segments: SegmentSelector.xor(combined.combined, buildLog),
			inverted: combined.inverted1 !== combined.inverted2
		}
	},
	polygon: function(segments){
		return {
			regions: SegmentChainer(segments.segments, epsilon, buildLog),
			inverted: segments.inverted
		};
	},

	// GeoJSON converters
	polygonFromGeoJSON: function(geojson){
		return GeoJSON.toPolygon(PolyBool, geojson);
	},
	polygonToGeoJSON: function(poly){
		return GeoJSON.fromPolygon(PolyBool, epsilon, poly);
	},

	// helper functions for common operations
	union: function(poly1, poly2){
		return operate(poly1, poly2, PolyBool.selectUnion);
	},
	intersect: function(poly1, poly2){
		return operate(poly1, poly2, PolyBool.selectIntersect);
	},
	difference: function(poly1, poly2){
		return operate(poly1, poly2, PolyBool.selectDifference);
	},
	differenceRev: function(poly1, poly2){
		return operate(poly1, poly2, PolyBool.selectDifferenceRev);
	},
	xor: function(poly1, poly2){
		return operate(poly1, poly2, PolyBool.selectXor);
	}
};

function operate(poly1, poly2, selector){
	var seg1 = PolyBool.segments(poly1);
	var seg2 = PolyBool.segments(poly2);
	var comb = PolyBool.combine(seg1, seg2);
	var seg3 = selector(comb);
	return PolyBool.polygon(seg3);
}

if (typeof window === 'object')
	window.PolyBool = PolyBool;

module.exports = PolyBool;


/***/ }),

/***/ 42391:
/***/ (function(module) {

// (c) Copyright 2016, Sean Connelly (@voidqk), http://syntheti.cc
// MIT License
// Project Home: https://github.com/voidqk/polybooljs

//
// used strictly for logging the processing of the algorithm... only useful if you intend on
// looking under the covers (for pretty UI's or debugging)
//

function BuildLog(){
	var my;
	var nextSegmentId = 0;
	var curVert = false;

	function push(type, data){
		my.list.push({
			type: type,
			data: data ? JSON.parse(JSON.stringify(data)) : void 0
		});
		return my;
	}

	my = {
		list: [],
		segmentId: function(){
			return nextSegmentId++;
		},
		checkIntersection: function(seg1, seg2){
			return push('check', { seg1: seg1, seg2: seg2 });
		},
		segmentChop: function(seg, end){
			push('div_seg', { seg: seg, pt: end });
			return push('chop', { seg: seg, pt: end });
		},
		statusRemove: function(seg){
			return push('pop_seg', { seg: seg });
		},
		segmentUpdate: function(seg){
			return push('seg_update', { seg: seg });
		},
		segmentNew: function(seg, primary){
			return push('new_seg', { seg: seg, primary: primary });
		},
		segmentRemove: function(seg){
			return push('rem_seg', { seg: seg });
		},
		tempStatus: function(seg, above, below){
			return push('temp_status', { seg: seg, above: above, below: below });
		},
		rewind: function(seg){
			return push('rewind', { seg: seg });
		},
		status: function(seg, above, below){
			return push('status', { seg: seg, above: above, below: below });
		},
		vert: function(x){
			if (x === curVert)
				return my;
			curVert = x;
			return push('vert', { x: x });
		},
		log: function(data){
			if (typeof data !== 'string')
				data = JSON.stringify(data, false, '  ');
			return push('log', { txt: data });
		},
		reset: function(){
			return push('reset');
		},
		selected: function(segs){
			return push('selected', { segs: segs });
		},
		chainStart: function(seg){
			return push('chain_start', { seg: seg });
		},
		chainRemoveHead: function(index, pt){
			return push('chain_rem_head', { index: index, pt: pt });
		},
		chainRemoveTail: function(index, pt){
			return push('chain_rem_tail', { index: index, pt: pt });
		},
		chainNew: function(pt1, pt2){
			return push('chain_new', { pt1: pt1, pt2: pt2 });
		},
		chainMatch: function(index){
			return push('chain_match', { index: index });
		},
		chainClose: function(index){
			return push('chain_close', { index: index });
		},
		chainAddHead: function(index, pt){
			return push('chain_add_head', { index: index, pt: pt });
		},
		chainAddTail: function(index, pt){
			return push('chain_add_tail', { index: index, pt: pt, });
		},
		chainConnect: function(index1, index2){
			return push('chain_con', { index1: index1, index2: index2 });
		},
		chainReverse: function(index){
			return push('chain_rev', { index: index });
		},
		chainJoin: function(index1, index2){
			return push('chain_join', { index1: index1, index2: index2 });
		},
		done: function(){
			return push('done');
		}
	};
	return my;
}

module.exports = BuildLog;


/***/ }),

/***/ 92990:
/***/ (function(module) {

// (c) Copyright 2016, Sean Connelly (@voidqk), http://syntheti.cc
// MIT License
// Project Home: https://github.com/voidqk/polybooljs

//
// provides the raw computation functions that takes epsilon into account
//
// zero is defined to be between (-epsilon, epsilon) exclusive
//

function Epsilon(eps){
	if (typeof eps !== 'number')
		eps = 0.0000000001; // sane default? sure why not
	var my = {
		epsilon: function(v){
			if (typeof v === 'number')
				eps = v;
			return eps;
		},
		pointAboveOrOnLine: function(pt, left, right){
			var Ax = left[0];
			var Ay = left[1];
			var Bx = right[0];
			var By = right[1];
			var Cx = pt[0];
			var Cy = pt[1];
			return (Bx - Ax) * (Cy - Ay) - (By - Ay) * (Cx - Ax) >= -eps;
		},
		pointBetween: function(p, left, right){
			// p must be collinear with left->right
			// returns false if p == left, p == right, or left == right
			var d_py_ly = p[1] - left[1];
			var d_rx_lx = right[0] - left[0];
			var d_px_lx = p[0] - left[0];
			var d_ry_ly = right[1] - left[1];

			var dot = d_px_lx * d_rx_lx + d_py_ly * d_ry_ly;
			// if `dot` is 0, then `p` == `left` or `left` == `right` (reject)
			// if `dot` is less than 0, then `p` is to the left of `left` (reject)
			if (dot < eps)
				return false;

			var sqlen = d_rx_lx * d_rx_lx + d_ry_ly * d_ry_ly;
			// if `dot` > `sqlen`, then `p` is to the right of `right` (reject)
			// therefore, if `dot - sqlen` is greater than 0, then `p` is to the right of `right` (reject)
			if (dot - sqlen > -eps)
				return false;

			return true;
		},
		pointsSameX: function(p1, p2){
			return Math.abs(p1[0] - p2[0]) < eps;
		},
		pointsSameY: function(p1, p2){
			return Math.abs(p1[1] - p2[1]) < eps;
		},
		pointsSame: function(p1, p2){
			return my.pointsSameX(p1, p2) && my.pointsSameY(p1, p2);
		},
		pointsCompare: function(p1, p2){
			// returns -1 if p1 is smaller, 1 if p2 is smaller, 0 if equal
			if (my.pointsSameX(p1, p2))
				return my.pointsSameY(p1, p2) ? 0 : (p1[1] < p2[1] ? -1 : 1);
			return p1[0] < p2[0] ? -1 : 1;
		},
		pointsCollinear: function(pt1, pt2, pt3){
			// does pt1->pt2->pt3 make a straight line?
			// essentially this is just checking to see if the slope(pt1->pt2) === slope(pt2->pt3)
			// if slopes are equal, then they must be collinear, because they share pt2
			var dx1 = pt1[0] - pt2[0];
			var dy1 = pt1[1] - pt2[1];
			var dx2 = pt2[0] - pt3[0];
			var dy2 = pt2[1] - pt3[1];
			return Math.abs(dx1 * dy2 - dx2 * dy1) < eps;
		},
		linesIntersect: function(a0, a1, b0, b1){
			// returns false if the lines are coincident (e.g., parallel or on top of each other)
			//
			// returns an object if the lines intersect:
			//   {
			//     pt: [x, y],    where the intersection point is at
			//     alongA: where intersection point is along A,
			//     alongB: where intersection point is along B
			//   }
			//
			//  alongA and alongB will each be one of: -2, -1, 0, 1, 2
			//
			//  with the following meaning:
			//
			//    -2   intersection point is before segment's first point
			//    -1   intersection point is directly on segment's first point
			//     0   intersection point is between segment's first and second points (exclusive)
			//     1   intersection point is directly on segment's second point
			//     2   intersection point is after segment's second point
			var adx = a1[0] - a0[0];
			var ady = a1[1] - a0[1];
			var bdx = b1[0] - b0[0];
			var bdy = b1[1] - b0[1];

			var axb = adx * bdy - ady * bdx;
			if (Math.abs(axb) < eps)
				return false; // lines are coincident

			var dx = a0[0] - b0[0];
			var dy = a0[1] - b0[1];

			var A = (bdx * dy - bdy * dx) / axb;
			var B = (adx * dy - ady * dx) / axb;

			var ret = {
				alongA: 0,
				alongB: 0,
				pt: [
					a0[0] + A * adx,
					a0[1] + A * ady
				]
			};

			// categorize where intersection point is along A and B

			if (A <= -eps)
				ret.alongA = -2;
			else if (A < eps)
				ret.alongA = -1;
			else if (A - 1 <= -eps)
				ret.alongA = 0;
			else if (A - 1 < eps)
				ret.alongA = 1;
			else
				ret.alongA = 2;

			if (B <= -eps)
				ret.alongB = -2;
			else if (B < eps)
				ret.alongB = -1;
			else if (B - 1 <= -eps)
				ret.alongB = 0;
			else if (B - 1 < eps)
				ret.alongB = 1;
			else
				ret.alongB = 2;

			return ret;
		},
		pointInsideRegion: function(pt, region){
			var x = pt[0];
			var y = pt[1];
			var last_x = region[region.length - 1][0];
			var last_y = region[region.length - 1][1];
			var inside = false;
			for (var i = 0; i < region.length; i++){
				var curr_x = region[i][0];
				var curr_y = region[i][1];

				// if y is between curr_y and last_y, and
				// x is to the right of the boundary created by the line
				if ((curr_y - y > eps) != (last_y - y > eps) &&
					(last_x - curr_x) * (y - curr_y) / (last_y - curr_y) + curr_x - x > eps)
					inside = !inside

				last_x = curr_x;
				last_y = curr_y;
			}
			return inside;
		}
	};
	return my;
}

module.exports = Epsilon;


/***/ }),

/***/ 24491:
/***/ (function(module) {

// (c) Copyright 2017, Sean Connelly (@voidqk), http://syntheti.cc
// MIT License
// Project Home: https://github.com/voidqk/polybooljs

//
// convert between PolyBool polygon format and GeoJSON formats (Polygon and MultiPolygon)
//

var GeoJSON = {
	// convert a GeoJSON object to a PolyBool polygon
	toPolygon: function(PolyBool, geojson){

		// converts list of LineString's to segments
		function GeoPoly(coords){
			// check for empty coords
			if (coords.length <= 0)
				return PolyBool.segments({ inverted: false, regions: [] });

			// convert LineString to segments
			function LineString(ls){
				// remove tail which should be the same as head
				var reg = ls.slice(0, ls.length - 1);
				return PolyBool.segments({ inverted: false, regions: [reg] });
			}

			// the first LineString is considered the outside
			var out = LineString(coords[0]);

			// the rest of the LineStrings are considered interior holes, so subtract them from the
			// current result
			for (var i = 1; i < coords.length; i++)
				out = PolyBool.selectDifference(PolyBool.combine(out, LineString(coords[i])));

			return out;
		}

		if (geojson.type === 'Polygon'){
			// single polygon, so just convert it and we're done
			return PolyBool.polygon(GeoPoly(geojson.coordinates));
		}
		else if (geojson.type === 'MultiPolygon'){
			// multiple polygons, so union all the polygons together
			var out = PolyBool.segments({ inverted: false, regions: [] });
			for (var i = 0; i < geojson.coordinates.length; i++)
				out = PolyBool.selectUnion(PolyBool.combine(out, GeoPoly(geojson.coordinates[i])));
			return PolyBool.polygon(out);
		}
		throw new Error('PolyBool: Cannot convert GeoJSON object to PolyBool polygon');
	},

	// convert a PolyBool polygon to a GeoJSON object
	fromPolygon: function(PolyBool, eps, poly){
		// make sure out polygon is clean
		poly = PolyBool.polygon(PolyBool.segments(poly));

		// test if r1 is inside r2
		function regionInsideRegion(r1, r2){
			// we're guaranteed no lines intersect (because the polygon is clean), but a vertex
			// could be on the edge -- so we just average pt[0] and pt[1] to produce a point on the
			// edge of the first line, which cannot be on an edge
			return eps.pointInsideRegion([
				(r1[0][0] + r1[1][0]) * 0.5,
				(r1[0][1] + r1[1][1]) * 0.5
			], r2);
		}

		// calculate inside heirarchy
		//
		//  _____________________   _______    roots -> A       -> F
		// |          A          | |   F   |            |          |
		// |  _______   _______  | |  ___  |            +-- B      +-- G
		// | |   B   | |   C   | | | |   | |            |   |
		// | |  ___  | |  ___  | | | |   | |            |   +-- D
		// | | | D | | | | E | | | | | G | |            |
		// | | |___| | | |___| | | | |   | |            +-- C
		// | |_______| |_______| | | |___| |                |
		// |_____________________| |_______|                +-- E

		function newNode(region){
			return {
				region: region,
				children: []
			};
		}

		var roots = newNode(null);

		function addChild(root, region){
			// first check if we're inside any children
			for (var i = 0; i < root.children.length; i++){
				var child = root.children[i];
				if (regionInsideRegion(region, child.region)){
					// we are, so insert inside them instead
					addChild(child, region);
					return;
				}
			}

			// not inside any children, so check to see if any children are inside us
			var node = newNode(region);
			for (var i = 0; i < root.children.length; i++){
				var child = root.children[i];
				if (regionInsideRegion(child.region, region)){
					// oops... move the child beneath us, and remove them from root
					node.children.push(child);
					root.children.splice(i, 1);
					i--;
				}
			}

			// now we can add ourselves
			root.children.push(node);
		}

		// add all regions to the root
		for (var i = 0; i < poly.regions.length; i++){
			var region = poly.regions[i];
			if (region.length < 3) // regions must have at least 3 points (sanity check)
				continue;
			addChild(roots, region);
		}

		// with our heirarchy, we can distinguish between exterior borders, and interior holes
		// the root nodes are exterior, children are interior, children's children are exterior,
		// children's children's children are interior, etc

		// while we're at it, exteriors are counter-clockwise, and interiors are clockwise

		function forceWinding(region, clockwise){
			// first, see if we're clockwise or counter-clockwise
			// https://en.wikipedia.org/wiki/Shoelace_formula
			var winding = 0;
			var last_x = region[region.length - 1][0];
			var last_y = region[region.length - 1][1];
			var copy = [];
			for (var i = 0; i < region.length; i++){
				var curr_x = region[i][0];
				var curr_y = region[i][1];
				copy.push([curr_x, curr_y]); // create a copy while we're at it
				winding += curr_y * last_x - curr_x * last_y;
				last_x = curr_x;
				last_y = curr_y;
			}
			// this assumes Cartesian coordinates (Y is positive going up)
			var isclockwise = winding < 0;
			if (isclockwise !== clockwise)
				copy.reverse();
			// while we're here, the last point must be the first point...
			copy.push([copy[0][0], copy[0][1]]);
			return copy;
		}

		var geopolys = [];

		function addExterior(node){
			var poly = [forceWinding(node.region, false)];
			geopolys.push(poly);
			// children of exteriors are interior
			for (var i = 0; i < node.children.length; i++)
				poly.push(getInterior(node.children[i]));
		}

		function getInterior(node){
			// children of interiors are exterior
			for (var i = 0; i < node.children.length; i++)
				addExterior(node.children[i]);
			// return the clockwise interior
			return forceWinding(node.region, true);
		}

		// root nodes are exterior
		for (var i = 0; i < roots.children.length; i++)
			addExterior(roots.children[i]);

		// lastly, construct the approrpriate GeoJSON object

		if (geopolys.length <= 0) // empty GeoJSON Polygon
			return { type: 'Polygon', coordinates: [] };
		if (geopolys.length == 1) // use a GeoJSON Polygon
			return { type: 'Polygon', coordinates: geopolys[0] };
		return { // otherwise, use a GeoJSON MultiPolygon
			type: 'MultiPolygon',
			coordinates: geopolys
		};
	}
};

module.exports = GeoJSON;


/***/ }),

/***/ 26202:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// (c) Copyright 2016, Sean Connelly (@voidqk), http://syntheti.cc
// MIT License
// Project Home: https://github.com/voidqk/polybooljs

//
// this is the core work-horse
//

var LinkedList = __webpack_require__(48916);

function Intersecter(selfIntersection, eps, buildLog){
	// selfIntersection is true/false depending on the phase of the overall algorithm

	//
	// segment creation
	//

	function segmentNew(start, end){
		return {
			id: buildLog ? buildLog.segmentId() : -1,
			start: start,
			end: end,
			myFill: {
				above: null, // is there fill above us?
				below: null  // is there fill below us?
			},
			otherFill: null
		};
	}

	function segmentCopy(start, end, seg){
		return {
			id: buildLog ? buildLog.segmentId() : -1,
			start: start,
			end: end,
			myFill: {
				above: seg.myFill.above,
				below: seg.myFill.below
			},
			otherFill: null
		};
	}

	//
	// event logic
	//

	var event_root = LinkedList.create();

	function eventCompare(p1_isStart, p1_1, p1_2, p2_isStart, p2_1, p2_2){
		// compare the selected points first
		var comp = eps.pointsCompare(p1_1, p2_1);
		if (comp !== 0)
			return comp;
		// the selected points are the same

		if (eps.pointsSame(p1_2, p2_2)) // if the non-selected points are the same too...
			return 0; // then the segments are equal

		if (p1_isStart !== p2_isStart) // if one is a start and the other isn't...
			return p1_isStart ? 1 : -1; // favor the one that isn't the start

		// otherwise, we'll have to calculate which one is below the other manually
		return eps.pointAboveOrOnLine(p1_2,
			p2_isStart ? p2_1 : p2_2, // order matters
			p2_isStart ? p2_2 : p2_1
		) ? 1 : -1;
	}

	function eventAdd(ev, other_pt){
		event_root.insertBefore(ev, function(here){
			// should ev be inserted before here?
			var comp = eventCompare(
				ev  .isStart, ev  .pt,      other_pt,
				here.isStart, here.pt, here.other.pt
			);
			return comp < 0;
		});
	}

	function eventAddSegmentStart(seg, primary){
		var ev_start = LinkedList.node({
			isStart: true,
			pt: seg.start,
			seg: seg,
			primary: primary,
			other: null,
			status: null
		});
		eventAdd(ev_start, seg.end);
		return ev_start;
	}

	function eventAddSegmentEnd(ev_start, seg, primary){
		var ev_end = LinkedList.node({
			isStart: false,
			pt: seg.end,
			seg: seg,
			primary: primary,
			other: ev_start,
			status: null
		});
		ev_start.other = ev_end;
		eventAdd(ev_end, ev_start.pt);
	}

	function eventAddSegment(seg, primary){
		var ev_start = eventAddSegmentStart(seg, primary);
		eventAddSegmentEnd(ev_start, seg, primary);
		return ev_start;
	}

	function eventUpdateEnd(ev, end){
		// slides an end backwards
		//   (start)------------(end)    to:
		//   (start)---(end)

		if (buildLog)
			buildLog.segmentChop(ev.seg, end);

		ev.other.remove();
		ev.seg.end = end;
		ev.other.pt = end;
		eventAdd(ev.other, ev.pt);
	}

	function eventDivide(ev, pt){
		var ns = segmentCopy(pt, ev.seg.end, ev.seg);
		eventUpdateEnd(ev, pt);
		return eventAddSegment(ns, ev.primary);
	}

	function calculate(primaryPolyInverted, secondaryPolyInverted){
		// if selfIntersection is true then there is no secondary polygon, so that isn't used

		//
		// status logic
		//

		var status_root = LinkedList.create();

		function statusCompare(ev1, ev2){
			var a1 = ev1.seg.start;
			var a2 = ev1.seg.end;
			var b1 = ev2.seg.start;
			var b2 = ev2.seg.end;

			if (eps.pointsCollinear(a1, b1, b2)){
				if (eps.pointsCollinear(a2, b1, b2))
					return 1;//eventCompare(true, a1, a2, true, b1, b2);
				return eps.pointAboveOrOnLine(a2, b1, b2) ? 1 : -1;
			}
			return eps.pointAboveOrOnLine(a1, b1, b2) ? 1 : -1;
		}

		function statusFindSurrounding(ev){
			return status_root.findTransition(function(here){
				var comp = statusCompare(ev, here.ev);
				return comp > 0;
			});
		}

		function checkIntersection(ev1, ev2){
			// returns the segment equal to ev1, or false if nothing equal

			var seg1 = ev1.seg;
			var seg2 = ev2.seg;
			var a1 = seg1.start;
			var a2 = seg1.end;
			var b1 = seg2.start;
			var b2 = seg2.end;

			if (buildLog)
				buildLog.checkIntersection(seg1, seg2);

			var i = eps.linesIntersect(a1, a2, b1, b2);

			if (i === false){
				// segments are parallel or coincident

				// if points aren't collinear, then the segments are parallel, so no intersections
				if (!eps.pointsCollinear(a1, a2, b1))
					return false;
				// otherwise, segments are on top of each other somehow (aka coincident)

				if (eps.pointsSame(a1, b2) || eps.pointsSame(a2, b1))
					return false; // segments touch at endpoints... no intersection

				var a1_equ_b1 = eps.pointsSame(a1, b1);
				var a2_equ_b2 = eps.pointsSame(a2, b2);

				if (a1_equ_b1 && a2_equ_b2)
					return ev2; // segments are exactly equal

				var a1_between = !a1_equ_b1 && eps.pointBetween(a1, b1, b2);
				var a2_between = !a2_equ_b2 && eps.pointBetween(a2, b1, b2);

				// handy for debugging:
				// buildLog.log({
				//	a1_equ_b1: a1_equ_b1,
				//	a2_equ_b2: a2_equ_b2,
				//	a1_between: a1_between,
				//	a2_between: a2_between
				// });

				if (a1_equ_b1){
					if (a2_between){
						//  (a1)---(a2)
						//  (b1)----------(b2)
						eventDivide(ev2, a2);
					}
					else{
						//  (a1)----------(a2)
						//  (b1)---(b2)
						eventDivide(ev1, b2);
					}
					return ev2;
				}
				else if (a1_between){
					if (!a2_equ_b2){
						// make a2 equal to b2
						if (a2_between){
							//         (a1)---(a2)
							//  (b1)-----------------(b2)
							eventDivide(ev2, a2);
						}
						else{
							//         (a1)----------(a2)
							//  (b1)----------(b2)
							eventDivide(ev1, b2);
						}
					}

					//         (a1)---(a2)
					//  (b1)----------(b2)
					eventDivide(ev2, a1);
				}
			}
			else{
				// otherwise, lines intersect at i.pt, which may or may not be between the endpoints

				// is A divided between its endpoints? (exclusive)
				if (i.alongA === 0){
					if (i.alongB === -1) // yes, at exactly b1
						eventDivide(ev1, b1);
					else if (i.alongB === 0) // yes, somewhere between B's endpoints
						eventDivide(ev1, i.pt);
					else if (i.alongB === 1) // yes, at exactly b2
						eventDivide(ev1, b2);
				}

				// is B divided between its endpoints? (exclusive)
				if (i.alongB === 0){
					if (i.alongA === -1) // yes, at exactly a1
						eventDivide(ev2, a1);
					else if (i.alongA === 0) // yes, somewhere between A's endpoints (exclusive)
						eventDivide(ev2, i.pt);
					else if (i.alongA === 1) // yes, at exactly a2
						eventDivide(ev2, a2);
				}
			}
			return false;
		}

		//
		// main event loop
		//
		var segments = [];
		while (!event_root.isEmpty()){
			var ev = event_root.getHead();

			if (buildLog)
				buildLog.vert(ev.pt[0]);

			if (ev.isStart){

				if (buildLog)
					buildLog.segmentNew(ev.seg, ev.primary);

				var surrounding = statusFindSurrounding(ev);
				var above = surrounding.before ? surrounding.before.ev : null;
				var below = surrounding.after ? surrounding.after.ev : null;

				if (buildLog){
					buildLog.tempStatus(
						ev.seg,
						above ? above.seg : false,
						below ? below.seg : false
					);
				}

				function checkBothIntersections(){
					if (above){
						var eve = checkIntersection(ev, above);
						if (eve)
							return eve;
					}
					if (below)
						return checkIntersection(ev, below);
					return false;
				}

				var eve = checkBothIntersections();
				if (eve){
					// ev and eve are equal
					// we'll keep eve and throw away ev

					// merge ev.seg's fill information into eve.seg

					if (selfIntersection){
						var toggle; // are we a toggling edge?
						if (ev.seg.myFill.below === null)
							toggle = true;
						else
							toggle = ev.seg.myFill.above !== ev.seg.myFill.below;

						// merge two segments that belong to the same polygon
						// think of this as sandwiching two segments together, where `eve.seg` is
						// the bottom -- this will cause the above fill flag to toggle
						if (toggle)
							eve.seg.myFill.above = !eve.seg.myFill.above;
					}
					else{
						// merge two segments that belong to different polygons
						// each segment has distinct knowledge, so no special logic is needed
						// note that this can only happen once per segment in this phase, because we
						// are guaranteed that all self-intersections are gone
						eve.seg.otherFill = ev.seg.myFill;
					}

					if (buildLog)
						buildLog.segmentUpdate(eve.seg);

					ev.other.remove();
					ev.remove();
				}

				if (event_root.getHead() !== ev){
					// something was inserted before us in the event queue, so loop back around and
					// process it before continuing
					if (buildLog)
						buildLog.rewind(ev.seg);
					continue;
				}

				//
				// calculate fill flags
				//
				if (selfIntersection){
					var toggle; // are we a toggling edge?
					if (ev.seg.myFill.below === null) // if we are a new segment...
						toggle = true; // then we toggle
					else // we are a segment that has previous knowledge from a division
						toggle = ev.seg.myFill.above !== ev.seg.myFill.below; // calculate toggle

					// next, calculate whether we are filled below us
					if (!below){ // if nothing is below us...
						// we are filled below us if the polygon is inverted
						ev.seg.myFill.below = primaryPolyInverted;
					}
					else{
						// otherwise, we know the answer -- it's the same if whatever is below
						// us is filled above it
						ev.seg.myFill.below = below.seg.myFill.above;
					}

					// since now we know if we're filled below us, we can calculate whether
					// we're filled above us by applying toggle to whatever is below us
					if (toggle)
						ev.seg.myFill.above = !ev.seg.myFill.below;
					else
						ev.seg.myFill.above = ev.seg.myFill.below;
				}
				else{
					// now we fill in any missing transition information, since we are all-knowing
					// at this point

					if (ev.seg.otherFill === null){
						// if we don't have other information, then we need to figure out if we're
						// inside the other polygon
						var inside;
						if (!below){
							// if nothing is below us, then we're inside if the other polygon is
							// inverted
							inside =
								ev.primary ? secondaryPolyInverted : primaryPolyInverted;
						}
						else{ // otherwise, something is below us
							// so copy the below segment's other polygon's above
							if (ev.primary === below.primary)
								inside = below.seg.otherFill.above;
							else
								inside = below.seg.myFill.above;
						}
						ev.seg.otherFill = {
							above: inside,
							below: inside
						};
					}
				}

				if (buildLog){
					buildLog.status(
						ev.seg,
						above ? above.seg : false,
						below ? below.seg : false
					);
				}

				// insert the status and remember it for later removal
				ev.other.status = surrounding.insert(LinkedList.node({ ev: ev }));
			}
			else{
				var st = ev.status;

				if (st === null){
					throw new Error('PolyBool: Zero-length segment detected; your epsilon is ' +
						'probably too small or too large');
				}

				// removing the status will create two new adjacent edges, so we'll need to check
				// for those
				if (status_root.exists(st.prev) && status_root.exists(st.next))
					checkIntersection(st.prev.ev, st.next.ev);

				if (buildLog)
					buildLog.statusRemove(st.ev.seg);

				// remove the status
				st.remove();

				// if we've reached this point, we've calculated everything there is to know, so
				// save the segment for reporting
				if (!ev.primary){
					// make sure `seg.myFill` actually points to the primary polygon though
					var s = ev.seg.myFill;
					ev.seg.myFill = ev.seg.otherFill;
					ev.seg.otherFill = s;
				}
				segments.push(ev.seg);
			}

			// remove the event and continue
			event_root.getHead().remove();
		}

		if (buildLog)
			buildLog.done();

		return segments;
	}

	// return the appropriate API depending on what we're doing
	if (!selfIntersection){
		// performing combination of polygons, so only deal with already-processed segments
		return {
			calculate: function(segments1, inverted1, segments2, inverted2){
				// segmentsX come from the self-intersection API, or this API
				// invertedX is whether we treat that list of segments as an inverted polygon or not
				// returns segments that can be used for further operations
				segments1.forEach(function(seg){
					eventAddSegment(segmentCopy(seg.start, seg.end, seg), true);
				});
				segments2.forEach(function(seg){
					eventAddSegment(segmentCopy(seg.start, seg.end, seg), false);
				});
				return calculate(inverted1, inverted2);
			}
		};
	}

	// otherwise, performing self-intersection, so deal with regions
	return {
		addRegion: function(region){
			// regions are a list of points:
			//  [ [0, 0], [100, 0], [50, 100] ]
			// you can add multiple regions before running calculate
			var pt1;
			var pt2 = region[region.length - 1];
			for (var i = 0; i < region.length; i++){
				pt1 = pt2;
				pt2 = region[i];

				var forward = eps.pointsCompare(pt1, pt2);
				if (forward === 0) // points are equal, so we have a zero-length segment
					continue; // just skip it

				eventAddSegment(
					segmentNew(
						forward < 0 ? pt1 : pt2,
						forward < 0 ? pt2 : pt1
					),
					true
				);
			}
		},
		calculate: function(inverted){
			// is the polygon inverted?
			// returns segments
			return calculate(inverted, false);
		}
	};
}

module.exports = Intersecter;


/***/ }),

/***/ 48916:
/***/ (function(module) {

// (c) Copyright 2016, Sean Connelly (@voidqk), http://syntheti.cc
// MIT License
// Project Home: https://github.com/voidqk/polybooljs

//
// simple linked list implementation that allows you to traverse down nodes and save positions
//

var LinkedList = {
	create: function(){
		var my = {
			root: { root: true, next: null },
			exists: function(node){
				if (node === null || node === my.root)
					return false;
				return true;
			},
			isEmpty: function(){
				return my.root.next === null;
			},
			getHead: function(){
				return my.root.next;
			},
			insertBefore: function(node, check){
				var last = my.root;
				var here = my.root.next;
				while (here !== null){
					if (check(here)){
						node.prev = here.prev;
						node.next = here;
						here.prev.next = node;
						here.prev = node;
						return;
					}
					last = here;
					here = here.next;
				}
				last.next = node;
				node.prev = last;
				node.next = null;
			},
			findTransition: function(check){
				var prev = my.root;
				var here = my.root.next;
				while (here !== null){
					if (check(here))
						break;
					prev = here;
					here = here.next;
				}
				return {
					before: prev === my.root ? null : prev,
					after: here,
					insert: function(node){
						node.prev = prev;
						node.next = here;
						prev.next = node;
						if (here !== null)
							here.prev = node;
						return node;
					}
				};
			}
		};
		return my;
	},
	node: function(data){
		data.prev = null;
		data.next = null;
		data.remove = function(){
			data.prev.next = data.next;
			if (data.next)
				data.next.prev = data.prev;
			data.prev = null;
			data.next = null;
		};
		return data;
	}
};

module.exports = LinkedList;


/***/ }),

/***/ 22222:
/***/ (function(module) {

// (c) Copyright 2016, Sean Connelly (@voidqk), http://syntheti.cc
// MIT License
// Project Home: https://github.com/voidqk/polybooljs

//
// converts a list of segments into a list of regions, while also removing unnecessary verticies
//

function SegmentChainer(segments, eps, buildLog){
	var chains = [];
	var regions = [];

	segments.forEach(function(seg){
		var pt1 = seg.start;
		var pt2 = seg.end;
		if (eps.pointsSame(pt1, pt2)){
			console.warn('PolyBool: Warning: Zero-length segment detected; your epsilon is ' +
				'probably too small or too large');
			return;
		}

		if (buildLog)
			buildLog.chainStart(seg);

		// search for two chains that this segment matches
		var first_match = {
			index: 0,
			matches_head: false,
			matches_pt1: false
		};
		var second_match = {
			index: 0,
			matches_head: false,
			matches_pt1: false
		};
		var next_match = first_match;
		function setMatch(index, matches_head, matches_pt1){
			// return true if we've matched twice
			next_match.index = index;
			next_match.matches_head = matches_head;
			next_match.matches_pt1 = matches_pt1;
			if (next_match === first_match){
				next_match = second_match;
				return false;
			}
			next_match = null;
			return true; // we've matched twice, we're done here
		}
		for (var i = 0; i < chains.length; i++){
			var chain = chains[i];
			var head  = chain[0];
			var head2 = chain[1];
			var tail  = chain[chain.length - 1];
			var tail2 = chain[chain.length - 2];
			if (eps.pointsSame(head, pt1)){
				if (setMatch(i, true, true))
					break;
			}
			else if (eps.pointsSame(head, pt2)){
				if (setMatch(i, true, false))
					break;
			}
			else if (eps.pointsSame(tail, pt1)){
				if (setMatch(i, false, true))
					break;
			}
			else if (eps.pointsSame(tail, pt2)){
				if (setMatch(i, false, false))
					break;
			}
		}

		if (next_match === first_match){
			// we didn't match anything, so create a new chain
			chains.push([ pt1, pt2 ]);
			if (buildLog)
				buildLog.chainNew(pt1, pt2);
			return;
		}

		if (next_match === second_match){
			// we matched a single chain

			if (buildLog)
				buildLog.chainMatch(first_match.index);

			// add the other point to the apporpriate end, and check to see if we've closed the
			// chain into a loop

			var index = first_match.index;
			var pt = first_match.matches_pt1 ? pt2 : pt1; // if we matched pt1, then we add pt2, etc
			var addToHead = first_match.matches_head; // if we matched at head, then add to the head

			var chain = chains[index];
			var grow  = addToHead ? chain[0] : chain[chain.length - 1];
			var grow2 = addToHead ? chain[1] : chain[chain.length - 2];
			var oppo  = addToHead ? chain[chain.length - 1] : chain[0];
			var oppo2 = addToHead ? chain[chain.length - 2] : chain[1];

			if (eps.pointsCollinear(grow2, grow, pt)){
				// grow isn't needed because it's directly between grow2 and pt:
				// grow2 ---grow---> pt
				if (addToHead){
					if (buildLog)
						buildLog.chainRemoveHead(first_match.index, pt);
					chain.shift();
				}
				else{
					if (buildLog)
						buildLog.chainRemoveTail(first_match.index, pt);
					chain.pop();
				}
				grow = grow2; // old grow is gone... new grow is what grow2 was
			}

			if (eps.pointsSame(oppo, pt)){
				// we're closing the loop, so remove chain from chains
				chains.splice(index, 1);

				if (eps.pointsCollinear(oppo2, oppo, grow)){
					// oppo isn't needed because it's directly between oppo2 and grow:
					// oppo2 ---oppo--->grow
					if (addToHead){
						if (buildLog)
							buildLog.chainRemoveTail(first_match.index, grow);
						chain.pop();
					}
					else{
						if (buildLog)
							buildLog.chainRemoveHead(first_match.index, grow);
						chain.shift();
					}
				}

				if (buildLog)
					buildLog.chainClose(first_match.index);

				// we have a closed chain!
				regions.push(chain);
				return;
			}

			// not closing a loop, so just add it to the apporpriate side
			if (addToHead){
				if (buildLog)
					buildLog.chainAddHead(first_match.index, pt);
				chain.unshift(pt);
			}
			else{
				if (buildLog)
					buildLog.chainAddTail(first_match.index, pt);
				chain.push(pt);
			}
			return;
		}

		// otherwise, we matched two chains, so we need to combine those chains together

		function reverseChain(index){
			if (buildLog)
				buildLog.chainReverse(index);
			chains[index].reverse(); // gee, that's easy
		}

		function appendChain(index1, index2){
			// index1 gets index2 appended to it, and index2 is removed
			var chain1 = chains[index1];
			var chain2 = chains[index2];
			var tail  = chain1[chain1.length - 1];
			var tail2 = chain1[chain1.length - 2];
			var head  = chain2[0];
			var head2 = chain2[1];

			if (eps.pointsCollinear(tail2, tail, head)){
				// tail isn't needed because it's directly between tail2 and head
				// tail2 ---tail---> head
				if (buildLog)
					buildLog.chainRemoveTail(index1, tail);
				chain1.pop();
				tail = tail2; // old tail is gone... new tail is what tail2 was
			}

			if (eps.pointsCollinear(tail, head, head2)){
				// head isn't needed because it's directly between tail and head2
				// tail ---head---> head2
				if (buildLog)
					buildLog.chainRemoveHead(index2, head);
				chain2.shift();
			}

			if (buildLog)
				buildLog.chainJoin(index1, index2);
			chains[index1] = chain1.concat(chain2);
			chains.splice(index2, 1);
		}

		var F = first_match.index;
		var S = second_match.index;

		if (buildLog)
			buildLog.chainConnect(F, S);

		var reverseF = chains[F].length < chains[S].length; // reverse the shorter chain, if needed
		if (first_match.matches_head){
			if (second_match.matches_head){
				if (reverseF){
					// <<<< F <<<< --- >>>> S >>>>
					reverseChain(F);
					// >>>> F >>>> --- >>>> S >>>>
					appendChain(F, S);
				}
				else{
					// <<<< F <<<< --- >>>> S >>>>
					reverseChain(S);
					// <<<< F <<<< --- <<<< S <<<<   logically same as:
					// >>>> S >>>> --- >>>> F >>>>
					appendChain(S, F);
				}
			}
			else{
				// <<<< F <<<< --- <<<< S <<<<   logically same as:
				// >>>> S >>>> --- >>>> F >>>>
				appendChain(S, F);
			}
		}
		else{
			if (second_match.matches_head){
				// >>>> F >>>> --- >>>> S >>>>
				appendChain(F, S);
			}
			else{
				if (reverseF){
					// >>>> F >>>> --- <<<< S <<<<
					reverseChain(F);
					// <<<< F <<<< --- <<<< S <<<<   logically same as:
					// >>>> S >>>> --- >>>> F >>>>
					appendChain(S, F);
				}
				else{
					// >>>> F >>>> --- <<<< S <<<<
					reverseChain(S);
					// >>>> F >>>> --- >>>> S >>>>
					appendChain(F, S);
				}
			}
		}
	});

	return regions;
}

module.exports = SegmentChainer;


/***/ }),

/***/ 17527:
/***/ (function(module) {

// (c) Copyright 2016, Sean Connelly (@voidqk), http://syntheti.cc
// MIT License
// Project Home: https://github.com/voidqk/polybooljs

//
// filter a list of segments based on boolean operations
//

function select(segments, selection, buildLog){
	var result = [];
	segments.forEach(function(seg){
		var index =
			(seg.myFill.above ? 8 : 0) +
			(seg.myFill.below ? 4 : 0) +
			((seg.otherFill && seg.otherFill.above) ? 2 : 0) +
			((seg.otherFill && seg.otherFill.below) ? 1 : 0);
		if (selection[index] !== 0){
			// copy the segment to the results, while also calculating the fill status
			result.push({
				id: buildLog ? buildLog.segmentId() : -1,
				start: seg.start,
				end: seg.end,
				myFill: {
					above: selection[index] === 1, // 1 if filled above
					below: selection[index] === 2  // 2 if filled below
				},
				otherFill: null
			});
		}
	});

	if (buildLog)
		buildLog.selected(result);

	return result;
}

var SegmentSelector = {
	union: function(segments, buildLog){ // primary | secondary
		// above1 below1 above2 below2    Keep?               Value
		//    0      0      0      0   =>   no                  0
		//    0      0      0      1   =>   yes filled below    2
		//    0      0      1      0   =>   yes filled above    1
		//    0      0      1      1   =>   no                  0
		//    0      1      0      0   =>   yes filled below    2
		//    0      1      0      1   =>   yes filled below    2
		//    0      1      1      0   =>   no                  0
		//    0      1      1      1   =>   no                  0
		//    1      0      0      0   =>   yes filled above    1
		//    1      0      0      1   =>   no                  0
		//    1      0      1      0   =>   yes filled above    1
		//    1      0      1      1   =>   no                  0
		//    1      1      0      0   =>   no                  0
		//    1      1      0      1   =>   no                  0
		//    1      1      1      0   =>   no                  0
		//    1      1      1      1   =>   no                  0
		return select(segments, [
			0, 2, 1, 0,
			2, 2, 0, 0,
			1, 0, 1, 0,
			0, 0, 0, 0
		], buildLog);
	},
	intersect: function(segments, buildLog){ // primary & secondary
		// above1 below1 above2 below2    Keep?               Value
		//    0      0      0      0   =>   no                  0
		//    0      0      0      1   =>   no                  0
		//    0      0      1      0   =>   no                  0
		//    0      0      1      1   =>   no                  0
		//    0      1      0      0   =>   no                  0
		//    0      1      0      1   =>   yes filled below    2
		//    0      1      1      0   =>   no                  0
		//    0      1      1      1   =>   yes filled below    2
		//    1      0      0      0   =>   no                  0
		//    1      0      0      1   =>   no                  0
		//    1      0      1      0   =>   yes filled above    1
		//    1      0      1      1   =>   yes filled above    1
		//    1      1      0      0   =>   no                  0
		//    1      1      0      1   =>   yes filled below    2
		//    1      1      1      0   =>   yes filled above    1
		//    1      1      1      1   =>   no                  0
		return select(segments, [
			0, 0, 0, 0,
			0, 2, 0, 2,
			0, 0, 1, 1,
			0, 2, 1, 0
		], buildLog);
	},
	difference: function(segments, buildLog){ // primary - secondary
		// above1 below1 above2 below2    Keep?               Value
		//    0      0      0      0   =>   no                  0
		//    0      0      0      1   =>   no                  0
		//    0      0      1      0   =>   no                  0
		//    0      0      1      1   =>   no                  0
		//    0      1      0      0   =>   yes filled below    2
		//    0      1      0      1   =>   no                  0
		//    0      1      1      0   =>   yes filled below    2
		//    0      1      1      1   =>   no                  0
		//    1      0      0      0   =>   yes filled above    1
		//    1      0      0      1   =>   yes filled above    1
		//    1      0      1      0   =>   no                  0
		//    1      0      1      1   =>   no                  0
		//    1      1      0      0   =>   no                  0
		//    1      1      0      1   =>   yes filled above    1
		//    1      1      1      0   =>   yes filled below    2
		//    1      1      1      1   =>   no                  0
		return select(segments, [
			0, 0, 0, 0,
			2, 0, 2, 0,
			1, 1, 0, 0,
			0, 1, 2, 0
		], buildLog);
	},
	differenceRev: function(segments, buildLog){ // secondary - primary
		// above1 below1 above2 below2    Keep?               Value
		//    0      0      0      0   =>   no                  0
		//    0      0      0      1   =>   yes filled below    2
		//    0      0      1      0   =>   yes filled above    1
		//    0      0      1      1   =>   no                  0
		//    0      1      0      0   =>   no                  0
		//    0      1      0      1   =>   no                  0
		//    0      1      1      0   =>   yes filled above    1
		//    0      1      1      1   =>   yes filled above    1
		//    1      0      0      0   =>   no                  0
		//    1      0      0      1   =>   yes filled below    2
		//    1      0      1      0   =>   no                  0
		//    1      0      1      1   =>   yes filled below    2
		//    1      1      0      0   =>   no                  0
		//    1      1      0      1   =>   no                  0
		//    1      1      1      0   =>   no                  0
		//    1      1      1      1   =>   no                  0
		return select(segments, [
			0, 2, 1, 0,
			0, 0, 1, 1,
			0, 2, 0, 2,
			0, 0, 0, 0
		], buildLog);
	},
	xor: function(segments, buildLog){ // primary ^ secondary
		// above1 below1 above2 below2    Keep?               Value
		//    0      0      0      0   =>   no                  0
		//    0      0      0      1   =>   yes filled below    2
		//    0      0      1      0   =>   yes filled above    1
		//    0      0      1      1   =>   no                  0
		//    0      1      0      0   =>   yes filled below    2
		//    0      1      0      1   =>   no                  0
		//    0      1      1      0   =>   no                  0
		//    0      1      1      1   =>   yes filled above    1
		//    1      0      0      0   =>   yes filled above    1
		//    1      0      0      1   =>   no                  0
		//    1      0      1      0   =>   no                  0
		//    1      0      1      1   =>   yes filled below    2
		//    1      1      0      0   =>   no                  0
		//    1      1      0      1   =>   yes filled above    1
		//    1      1      1      0   =>   yes filled below    2
		//    1      1      1      1   =>   no                  0
		return select(segments, [
			0, 2, 1, 0,
			2, 0, 0, 1,
			1, 0, 0, 2,
			0, 1, 2, 0
		], buildLog);
	}
};

module.exports = SegmentSelector;


/***/ }),

/***/ 3944:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;



var Transform    = (__webpack_require__(90386).Transform);
var streamParser = __webpack_require__(79743);


function ParserStream() {
  Transform.call(this, { readableObjectMode: true });
}

// Inherit from Transform
ParserStream.prototype = Object.create(Transform.prototype);
ParserStream.prototype.constructor = ParserStream;

streamParser(ParserStream.prototype);


__webpack_unused_export__ = ParserStream;


exports.rU = function (src, start, dest) {
  for (var i = start, j = 0; j < dest.length;) {
    if (src[i++] !== dest[j++]) return false;
  }
  return true;
};

exports.VG = function (str, format) {
  var arr = [], i = 0;

  if (format && format === 'hex') {
    while (i < str.length) {
      arr.push(parseInt(str.slice(i, i + 2), 16));
      i += 2;
    }
  } else {
    for (; i < str.length; i++) {
      /* eslint-disable no-bitwise */
      arr.push(str.charCodeAt(i) & 0xFF);
    }
  }

  return arr;
};

exports.$l = function (data, offset) {
  return data[offset] | (data[offset + 1] << 8);
};

exports.bc = function (data, offset) {
  return data[offset + 1] | (data[offset] << 8);
};

exports.tF = function (data, offset) {
  return data[offset] |
    (data[offset + 1] << 8) |
    (data[offset + 2] << 16) |
    (data[offset + 3] * 0x1000000);
};

exports.bb = function (data, offset) {
  return data[offset + 3] |
    (data[offset + 2] << 8) |
    (data[offset + 1] << 16) |
    (data[offset] * 0x1000000);
};


function ProbeError(message, code, statusCode) {
  Error.call(this);

  // Include stack trace in error object
  if (Error.captureStackTrace) {
    // Chrome and NodeJS
    Error.captureStackTrace(this, this.constructor);
  } else {
    // FF, IE 10+ and Safari 6+. Fallback for others
    this.stack = (new Error()).stack || '';
  }

  this.name = this.constructor.name;

  this.message = message;
  if (code) this.code = code;
  if (statusCode) this.statusCode = statusCode;
}

// Inherit from Error
ProbeError.prototype = Object.create(Error.prototype);
ProbeError.prototype.constructor = ProbeError;


__webpack_unused_export__ = ProbeError;


/***/ }),

/***/ 19789:
/***/ (function(module) {

"use strict";

/* eslint-disable no-bitwise */
/* eslint-disable consistent-return */



//////////////////////////////////////////////////////////////////////////
// Helpers
//
function error(message, code) {
  var err = new Error(message);
  err.code = code;
  return err;
}


function utf8_decode(str) {
  try {
    return decodeURIComponent(escape(str));
  } catch (_) {
    return str;
  }
}


//////////////////////////////////////////////////////////////////////////
// Exif parser
//
// Input:
//  - jpeg_bin:   Uint8Array - jpeg file
//  - exif_start: Number     - start of TIFF header (after Exif\0\0)
//  - exif_end:   Number     - end of Exif segment
//  - on_entry:   Number     - callback
//
function ExifParser(jpeg_bin, exif_start, exif_end) {
  // Uint8Array, exif without signature (which isn't included in offsets)
  this.input      = jpeg_bin.subarray(exif_start, exif_end);

  // offset correction for `on_entry` callback
  this.start      = exif_start;

  // Check TIFF header (includes byte alignment and first IFD offset)
  var sig = String.fromCharCode.apply(null, this.input.subarray(0, 4));

  if (sig !== 'II\x2A\0' && sig !== 'MM\0\x2A') {
    throw error('invalid TIFF signature', 'EBADDATA');
  }

  // true if motorola (big endian) byte alignment, false if intel
  this.big_endian = sig[0] === 'M';
}


ExifParser.prototype.each = function (on_entry) {
  // allow premature exit
  this.aborted = false;

  var offset = this.read_uint32(4);

  this.ifds_to_read = [ {
    id:     0,
    offset: offset
  } ];

  while (this.ifds_to_read.length > 0 && !this.aborted) {
    var i = this.ifds_to_read.shift();
    if (!i.offset) continue;
    this.scan_ifd(i.id, i.offset, on_entry);
  }
};


ExifParser.prototype.read_uint16 = function (offset) {
  var d = this.input;
  if (offset + 2 > d.length) throw error('unexpected EOF', 'EBADDATA');

  return this.big_endian ?
    d[offset] * 0x100 + d[offset + 1] :
    d[offset] + d[offset + 1] * 0x100;
};


ExifParser.prototype.read_uint32 = function (offset) {
  var d = this.input;
  if (offset + 4 > d.length) throw error('unexpected EOF', 'EBADDATA');

  return this.big_endian ?
    d[offset] * 0x1000000 + d[offset + 1] * 0x10000 + d[offset + 2] * 0x100 + d[offset + 3] :
    d[offset] + d[offset + 1] * 0x100 + d[offset + 2] * 0x10000 + d[offset + 3] * 0x1000000;
};


ExifParser.prototype.is_subifd_link = function (ifd, tag) {
  return (ifd === 0 && tag === 0x8769) || // SubIFD
         (ifd === 0 && tag === 0x8825) || // GPS Info
         (ifd === 0x8769 && tag === 0xA005); // Interop IFD
};


// Returns byte length of a single component of a given format
//
ExifParser.prototype.exif_format_length = function (format) {
  switch (format) {
    case 1: // byte
    case 2: // ascii
    case 6: // sbyte
    case 7: // undefined
      return 1;

    case 3: // short
    case 8: // sshort
      return 2;

    case 4:  // long
    case 9:  // slong
    case 11: // float
      return 4;

    case 5:  // rational
    case 10: // srational
    case 12: // double
      return 8;

    default:
      // unknown type
      return 0;
  }
};


// Reads Exif data
//
ExifParser.prototype.exif_format_read = function (format, offset) {
  var v;

  switch (format) {
    case 1: // byte
    case 2: // ascii
      v = this.input[offset];
      return v;

    case 6: // sbyte
      v = this.input[offset];
      return v | (v & 0x80) * 0x1fffffe;

    case 3: // short
      v = this.read_uint16(offset);
      return v;

    case 8: // sshort
      v = this.read_uint16(offset);
      return v | (v & 0x8000) * 0x1fffe;

    case 4: // long
      v = this.read_uint32(offset);
      return v;

    case 9: // slong
      v = this.read_uint32(offset);
      return v | 0;

    case 5:  // rational
    case 10: // srational
    case 11: // float
    case 12: // double
      return null; // not implemented

    case 7: // undefined
      return null; // blob

    default:
      // unknown type
      return null;
  }
};


ExifParser.prototype.scan_ifd = function (ifd_no, offset, on_entry) {
  var entry_count = this.read_uint16(offset);

  offset += 2;

  for (var i = 0; i < entry_count; i++) {
    var tag    = this.read_uint16(offset);
    var format = this.read_uint16(offset + 2);
    var count  = this.read_uint32(offset + 4);

    var comp_length    = this.exif_format_length(format);
    var data_length    = count * comp_length;
    var data_offset    = data_length <= 4 ? offset + 8 : this.read_uint32(offset + 8);
    var is_subifd_link = false;

    if (data_offset + data_length > this.input.length) {
      throw error('unexpected EOF', 'EBADDATA');
    }

    var value = [];
    var comp_offset = data_offset;

    for (var j = 0; j < count; j++, comp_offset += comp_length) {
      var item = this.exif_format_read(format, comp_offset);
      if (item === null) {
        value = null;
        break;
      }
      value.push(item);
    }

    if (Array.isArray(value) && format === 2) {
      value = utf8_decode(String.fromCharCode.apply(null, value));
      if (value && value[value.length - 1] === '\0') value = value.slice(0, -1);
    }

    if (this.is_subifd_link(ifd_no, tag)) {
      if (Array.isArray(value) && Number.isInteger(value[0]) && value[0] > 0) {
        this.ifds_to_read.push({
          id:     tag,
          offset: value[0]
        });
        is_subifd_link = true;
      }
    }

    var entry = {
      is_big_endian:  this.big_endian,
      ifd:            ifd_no,
      tag:            tag,
      format:         format,
      count:          count,
      entry_offset:   offset + this.start,
      data_length:    data_length,
      data_offset:    data_offset + this.start,
      value:          value,
      is_subifd_link: is_subifd_link
    };

    if (on_entry(entry) === false) {
      this.aborted = true;
      return;
    }

    offset += 12;
  }

  if (ifd_no === 0) {
    this.ifds_to_read.push({
      id:     1,
      offset: this.read_uint32(offset)
    });
  }
};


module.exports.ExifParser = ExifParser;

// returns orientation stored in Exif (1-8), 0 if none was found, -1 if error
module.exports.get_orientation = function (data) {
  var orientation = 0;
  try {
    new ExifParser(data, 0, data.length).each(function (entry) {
      if (entry.ifd === 0 && entry.tag === 0x112 && Array.isArray(entry.value)) {
        orientation = entry.value[0];
        return false;
      }
    });
    return orientation;
  } catch (err) {
    return -1;
  }
};


/***/ }),

/***/ 20186:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
// Utils used to parse miaf-based files (avif/heic/heif)
//
// ISO media file spec:
// https://web.archive.org/web/20180219054429/http://l.web.umkc.edu/lizhu/teaching/2016sp.video-communication/ref/mp4.pdf
//
// ISO image file format spec:
// https://standards.iso.org/ittf/PubliclyAvailableStandards/c066067_ISO_IEC_23008-12_2017.zip
//



/* eslint-disable consistent-return */
/* eslint-disable no-bitwise */

var readUInt16BE = (__webpack_require__(3944)/* .readUInt16BE */ .bc);
var readUInt32BE = (__webpack_require__(3944)/* .readUInt32BE */ .bb);

/*
 * interface Box {
 *   size:       uint32;   // if size == 0, box lasts until EOF
 *   boxtype:    char[4];
 *   largesize?: uint64;   // only if size == 1
 *   usertype?:  char[16]; // only if boxtype == 'uuid'
 * }
 */
function unbox(data, offset) {
  if (data.length < 4 + offset) return null;

  var size = readUInt32BE(data, offset);

  // size includes first 4 bytes (length)
  if (data.length < size + offset || size < 8) return null;

  // if size === 1, real size is following uint64 (only for big boxes, not needed)
  // if size === 0, real size is until the end of the file (only for big boxes, not needed)

  return {
    boxtype: String.fromCharCode.apply(null, data.slice(offset + 4, offset + 8)),
    data:    data.slice(offset + 8, offset + size),
    end:     offset + size
  };
}


module.exports.unbox = unbox;


// parses `meta` -> `iprp` -> `ipco` box, returns:
// {
//   sizes: [ { width, height } ],
//   transforms: [ { type, value } ]
// }
function scan_ipco(data, sandbox) {
  var offset = 0;

  for (;;) {
    var box = unbox(data, offset);
    if (!box) break;

    switch (box.boxtype) {
      case 'ispe':
        sandbox.sizes.push({
          width:  readUInt32BE(box.data, 4),
          height: readUInt32BE(box.data, 8)
        });
        break;

      case 'irot':
        sandbox.transforms.push({
          type: 'irot',
          value: box.data[0] & 3
        });
        break;

      case 'imir':
        sandbox.transforms.push({
          type: 'imir',
          value: box.data[0] & 1
        });
        break;
    }

    offset = box.end;
  }
}


function readUIntBE(data, offset, size) {
  var result = 0;

  for (var i = 0; i < size; i++) {
    result = result * 256 + (data[offset + i] || 0);
  }

  return result;
}


// parses `meta` -> `iloc` box
function scan_iloc(data, sandbox) {
  var offset_size = (data[4] >> 4) & 0xF;
  var length_size = data[4] & 0xF;
  var base_offset_size = (data[5] >> 4) & 0xF;
  var item_count = readUInt16BE(data, 6);
  var offset = 8;

  for (var i = 0; i < item_count; i++) {
    var item_ID = readUInt16BE(data, offset);
    offset += 2;

    var data_reference_index = readUInt16BE(data, offset);
    offset += 2;

    var base_offset = readUIntBE(data, offset, base_offset_size);
    offset += base_offset_size;

    var extent_count = readUInt16BE(data, offset);
    offset += 2;

    if (data_reference_index === 0 && extent_count === 1) {
      var first_extent_offset = readUIntBE(data, offset, offset_size);
      var first_extent_length = readUIntBE(data, offset + offset_size, length_size);
      sandbox.item_loc[item_ID] = { length: first_extent_length, offset: first_extent_offset + base_offset };
    }

    offset += extent_count * (offset_size + length_size);
  }
}


// parses `meta` -> `iinf` box
function scan_iinf(data, sandbox) {
  var item_count = readUInt16BE(data, 4);
  var offset = 6;

  for (var i = 0; i < item_count; i++) {
    var box = unbox(data, offset);
    if (!box) break;
    if (box.boxtype === 'infe') {
      var item_id = readUInt16BE(box.data, 4);
      var item_name = '';

      for (var pos = 8; pos < box.data.length && box.data[pos]; pos++) {
        item_name += String.fromCharCode(box.data[pos]);
      }

      sandbox.item_inf[item_name] = item_id;
    }
    offset = box.end;
  }
}


// parses `meta` -> `iprp` box
function scan_iprp(data, sandbox) {
  var offset = 0;

  for (;;) {
    var box = unbox(data, offset);
    if (!box) break;
    if (box.boxtype === 'ipco') scan_ipco(box.data, sandbox);
    offset = box.end;
  }
}


// parses `meta` box
function scan_meta(data, sandbox) {
  var offset = 4; // version + flags

  for (;;) {
    var box = unbox(data, offset);
    if (!box) break;
    if (box.boxtype === 'iprp') scan_iprp(box.data, sandbox);
    if (box.boxtype === 'iloc') scan_iloc(box.data, sandbox);
    if (box.boxtype === 'iinf') scan_iinf(box.data, sandbox);
    offset = box.end;
  }
}


// get image with largest single dimension as base
function getMaxSize(sizes) {
  var maxWidthSize = sizes.reduce(function (a, b) {
    return a.width > b.width || (a.width === b.width && a.height > b.height) ? a : b;
  });

  var maxHeightSize = sizes.reduce(function (a, b) {
    return a.height > b.height || (a.height === b.height && a.width > b.width) ? a : b;
  });

  var maxSize;

  if (maxWidthSize.width > maxHeightSize.height ||
      (maxWidthSize.width === maxHeightSize.height && maxWidthSize.height > maxHeightSize.width)) {
    maxSize = maxWidthSize;
  } else {
    maxSize = maxHeightSize;
  }

  return maxSize;
}


module.exports.readSizeFromMeta = function (data) {
  var sandbox = {
    sizes: [],
    transforms: [],
    item_inf: {},
    item_loc: {}
  };

  scan_meta(data, sandbox);

  if (!sandbox.sizes.length) return;

  var maxSize = getMaxSize(sandbox.sizes);

  var orientation = 1;

  // convert imir/irot to exif orientation
  sandbox.transforms.forEach(function (transform) {
    var rotate_ccw  = { 1: 6, 2: 5, 3: 8, 4: 7, 5: 4, 6: 3, 7: 2, 8: 1 };
    var mirror_vert = { 1: 4, 2: 3, 3: 2, 4: 1, 5: 6, 6: 5, 7: 8, 8: 7 };

    if (transform.type === 'imir') {
      if (transform.value === 0) {
        // vertical flip
        orientation = mirror_vert[orientation];
      } else {
        // horizontal flip = vertical flip + 180 deg rotation
        orientation = mirror_vert[orientation];
        orientation = rotate_ccw[orientation];
        orientation = rotate_ccw[orientation];
      }
    }

    if (transform.type === 'irot') {
      // counter-clockwise rotation 90 deg 0-3 times
      for (var i = 0; i < transform.value; i++) {
        orientation = rotate_ccw[orientation];
      }
    }
  });

  var exif_location = null;

  if (sandbox.item_inf.Exif) {
    exif_location = sandbox.item_loc[sandbox.item_inf.Exif];
  }

  return {
    width: maxSize.width,
    height: maxSize.height,
    orientation: sandbox.transforms.length ? orientation : null,
    variants: sandbox.sizes,
    exif_location: exif_location
  };
};


module.exports.getMimeType = function (data) {
  var brand = String.fromCharCode.apply(null, data.slice(0, 4));
  var compat = {};

  compat[brand] = true;

  for (var i = 8; i < data.length; i += 4) {
    compat[String.fromCharCode.apply(null, data.slice(i, i + 4))] = true;
  }

  // heic and avif are superset of miaf, so they should all list mif1 as compatible
  if (!compat.mif1 && !compat.msf1 && !compat.miaf) return;

  if (brand === 'avif' || brand === 'avis' || brand === 'avio') {
    // `.avifs` and `image/avif-sequence` are removed from spec, all files have single type
    return { type: 'avif', mime: 'image/avif' };
  }

  // https://nokiatech.github.io/heif/technical.html
  if (brand === 'heic' || brand === 'heix') {
    return { type: 'heic', mime: 'image/heic' };
  }

  if (brand === 'hevc' || brand === 'hevx') {
    return { type: 'heic', mime: 'image/heic-sequence' };
  }

  if (compat.avif || compat.avis) {
    return { type: 'avif', mime: 'image/avif' };
  }

  if (compat.heic || compat.heix || compat.hevc || compat.hevx || compat.heis) {
    if (compat.msf1) {
      return { type: 'heif', mime: 'image/heif-sequence' };
    }
    return { type: 'heif', mime: 'image/heif' };
  }

  return { type: 'avif', mime: 'image/avif' };
};


/***/ }),

/***/ 31149:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
// Utils used to parse miaf-based files (avif/heic/heif)
//
//  - image collections are not supported (only last size is reported)
//  - images with metadata encoded after image data are not supported
//  - images without any `ispe` box are not supported
//

/* eslint-disable consistent-return */




var str2arr      = (__webpack_require__(3944)/* .str2arr */ .VG);
var sliceEq      = (__webpack_require__(3944)/* .sliceEq */ .rU);
var readUInt32BE = (__webpack_require__(3944)/* .readUInt32BE */ .bb);
var miaf         = __webpack_require__(20186);
var exif         = __webpack_require__(19789);

var SIG_FTYP = str2arr('ftyp');


module.exports = function (data) {
  // ISO media file (avif format) starts with ftyp box:
  // 0000 0020 6674 7970 6176 6966
  //  (length)  f t  y p  a v  i f
  //
  if (!sliceEq(data, 4, SIG_FTYP)) return;

  var firstBox = miaf.unbox(data, 0);
  if (!firstBox) return;

  var fileType = miaf.getMimeType(firstBox.data);
  if (!fileType) return;

  var meta, offset = firstBox.end;

  for (;;) {
    var box = miaf.unbox(data, offset);
    if (!box) break;
    offset = box.end;

    // mdat block SHOULD be last (but not strictly required),
    // so it's unlikely that metadata is after it
    if (box.boxtype === 'mdat') return;
    if (box.boxtype === 'meta') {
      meta = box.data;
      break;
    }
  }

  if (!meta) return;

  var imgSize = miaf.readSizeFromMeta(meta);

  if (!imgSize) return;

  var result = {
    width:    imgSize.width,
    height:   imgSize.height,
    type:     fileType.type,
    mime:     fileType.mime,
    wUnits:   'px',
    hUnits:   'px'
  };

  if (imgSize.variants.length > 1) {
    result.variants = imgSize.variants;
  }

  if (imgSize.orientation) {
    result.orientation = imgSize.orientation;
  }

  if (imgSize.exif_location &&
      imgSize.exif_location.offset + imgSize.exif_location.length <= data.length) {

    var sig_offset = readUInt32BE(data, imgSize.exif_location.offset);
    var exif_data = data.slice(
      imgSize.exif_location.offset + sig_offset + 4,
      imgSize.exif_location.offset + imgSize.exif_location.length);

    var orientation = exif.get_orientation(exif_data);

    if (orientation > 0) result.orientation = orientation;
  }

  return result;
};


/***/ }),

/***/ 78218:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


/* eslint-disable consistent-return */

var str2arr      = (__webpack_require__(3944)/* .str2arr */ .VG);
var sliceEq      = (__webpack_require__(3944)/* .sliceEq */ .rU);
var readUInt16LE = (__webpack_require__(3944)/* .readUInt16LE */ .$l);

var SIG_BM = str2arr('BM');


module.exports = function (data) {
  if (data.length < 26) return;

  if (!sliceEq(data, 0, SIG_BM)) return;

  return {
    width:  readUInt16LE(data, 18),
    height: readUInt16LE(data, 22),
    type: 'bmp',
    mime: 'image/bmp',
    wUnits: 'px',
    hUnits: 'px'
  };
};


/***/ }),

/***/ 37495:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


/* eslint-disable consistent-return */

var str2arr      = (__webpack_require__(3944)/* .str2arr */ .VG);
var sliceEq      = (__webpack_require__(3944)/* .sliceEq */ .rU);
var readUInt16LE = (__webpack_require__(3944)/* .readUInt16LE */ .$l);


var SIG_GIF87a = str2arr('GIF87a');
var SIG_GIF89a = str2arr('GIF89a');


module.exports = function (data) {
  if (data.length < 10) return;

  if (!sliceEq(data, 0, SIG_GIF87a) && !sliceEq(data, 0, SIG_GIF89a)) return;

  return {
    width:  readUInt16LE(data, 6),
    height: readUInt16LE(data, 8),
    type: 'gif',
    mime: 'image/gif',
    wUnits: 'px',
    hUnits: 'px'
  };
};


/***/ }),

/***/ 88708:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


/* eslint-disable consistent-return */

var readUInt16LE = (__webpack_require__(3944)/* .readUInt16LE */ .$l);

var HEADER = 0;
var TYPE_ICO = 1;
var INDEX_SIZE = 16;

// Format specification:
// https://en.wikipedia.org/wiki/ICO_(file_format)#Icon_resource_structure
module.exports = function (data) {
  var header = readUInt16LE(data, 0);
  var type = readUInt16LE(data, 2);
  var numImages = readUInt16LE(data, 4);

  if (header !== HEADER || type !== TYPE_ICO || !numImages) {
    return;
  }

  var variants = [];
  var maxSize = { width: 0, height: 0 };

  for (var i = 0; i < numImages; i++) {
    var width = data[6 + INDEX_SIZE * i] || 256;
    var height = data[6 + INDEX_SIZE * i + 1] || 256;
    var size = { width: width, height: height };
    variants.push(size);

    if (width > maxSize.width || height > maxSize.height) {
      maxSize = size;
    }
  }

  return {
    width: maxSize.width,
    height: maxSize.height,
    variants: variants,
    type: 'ico',
    mime: 'image/x-icon',
    wUnits: 'px',
    hUnits: 'px'
  };
};


/***/ }),

/***/ 13827:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


/* eslint-disable consistent-return */

var readUInt16BE = (__webpack_require__(3944)/* .readUInt16BE */ .bc);
var str2arr      = (__webpack_require__(3944)/* .str2arr */ .VG);
var sliceEq      = (__webpack_require__(3944)/* .sliceEq */ .rU);
var exif         = __webpack_require__(19789);


var SIG_EXIF  = str2arr('Exif\0\0');


module.exports = function (data) {
  if (data.length < 2) return;

  // first marker of the file MUST be 0xFFD8,
  // following by either 0xFFE0, 0xFFE2 or 0xFFE3
  if (data[0] !== 0xFF || data[1] !== 0xD8 || data[2] !== 0xFF) return;

  var offset = 2;

  for (;;) {
    // skip until we see 0xFF, see https://github.com/nodeca/probe-image-size/issues/68
    for (;;) {
      if (data.length - offset < 2) return;
      if (data[offset++] === 0xFF) break;
    }

    var code = data[offset++];
    var length;

    // skip padding bytes
    while (code === 0xFF) code = data[offset++];

    // standalone markers, according to JPEG 1992,
    // http://www.w3.org/Graphics/JPEG/itu-t81.pdf, see Table B.1
    if ((0xD0 <= code && code <= 0xD9) || code === 0x01) {
      length = 0;
    } else if (0xC0 <= code && code <= 0xFE) {
      // the rest of the unreserved markers
      if (data.length - offset < 2) return;

      length = readUInt16BE(data, offset) - 2;
      offset += 2;
    } else {
      // unknown markers
      return;
    }

    if (code === 0xD9 /* EOI */ || code === 0xDA /* SOS */) {
      // end of the datastream
      return;
    }

    var orientation;

    // try to get orientation from Exif segment
    if (code === 0xE1 && length >= 10 && sliceEq(data, offset, SIG_EXIF)) {
      orientation = exif.get_orientation(data.slice(offset + 6, offset + length));
    }

    if (length >= 5 &&
        (0xC0 <= code && code <= 0xCF) &&
        code !== 0xC4 && code !== 0xC8 && code !== 0xCC) {

      if (data.length - offset < length) return;

      var result = {
        width:  readUInt16BE(data, offset + 3),
        height: readUInt16BE(data, offset + 1),
        type:   'jpg',
        mime:   'image/jpeg',
        wUnits: 'px',
        hUnits: 'px'
      };

      if (orientation > 0) {
        result.orientation = orientation;
      }

      return result;
    }

    offset += length;
  }
};


/***/ }),

/***/ 46594:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


/* eslint-disable consistent-return */

var str2arr      = (__webpack_require__(3944)/* .str2arr */ .VG);
var sliceEq      = (__webpack_require__(3944)/* .sliceEq */ .rU);
var readUInt32BE = (__webpack_require__(3944)/* .readUInt32BE */ .bb);


var SIG_PNG  = str2arr('\x89PNG\r\n\x1a\n');
var SIG_IHDR = str2arr('IHDR');


module.exports = function (data) {
  if (data.length < 24) return;

  // check PNG signature
  if (!sliceEq(data, 0, SIG_PNG)) return;

  // check that first chunk is IHDR
  if (!sliceEq(data, 12, SIG_IHDR)) return;

  return {
    width:  readUInt32BE(data, 16),
    height: readUInt32BE(data, 20),
    type: 'png',
    mime: 'image/png',
    wUnits: 'px',
    hUnits: 'px'
  };
};


/***/ }),

/***/ 13198:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


/* eslint-disable consistent-return */

var str2arr      = (__webpack_require__(3944)/* .str2arr */ .VG);
var sliceEq      = (__webpack_require__(3944)/* .sliceEq */ .rU);
var readUInt32BE = (__webpack_require__(3944)/* .readUInt32BE */ .bb);


var SIG_8BPS  = str2arr('8BPS\x00\x01');


module.exports = function (data) {
  if (data.length < 6 + 16) return;

  // signature + version
  if (!sliceEq(data, 0, SIG_8BPS)) return;

  return {
    width:  readUInt32BE(data, 6 + 12),
    height: readUInt32BE(data, 6 + 8),
    type: 'psd',
    mime: 'image/vnd.adobe.photoshop',
    wUnits: 'px',
    hUnits: 'px'
  };
};


/***/ }),

/***/ 94203:
/***/ (function(module) {

"use strict";


/* eslint-disable consistent-return */

function isWhiteSpace(chr) {
  return chr === 0x20 || chr === 0x09 || chr === 0x0D || chr === 0x0A;
}

// Filter NaN, Infinity, < 0
function isFinitePositive(val) {
  return typeof val === 'number' && isFinite(val) && val > 0;
}

function canBeSvg(buf) {
  var i = 0, max = buf.length;

  // byte order mark, https://github.com/nodeca/probe-image-size/issues/57
  if (buf[0] === 0xEF && buf[1] === 0xBB && buf[2] === 0xBF) i = 3;

  while (i < max && isWhiteSpace(buf[i])) i++;

  if (i === max) return false;
  return buf[i] === 0x3c; /* < */
}


// skip `<?` (comments), `<!` (directives, cdata, doctype),
// looking for `<svg>` or `<NAMESPACE:svg>`
var SVG_HEADER_RE  = /<[-_.:a-zA-Z0-9][^>]*>/;

// test if the top level element is svg + optional namespace,
// used to skip svg embedded in html
var SVG_TAG_RE     = /^<([-_.:a-zA-Z0-9]+:)?svg\s/;

var SVG_WIDTH_RE   = /[^-]\bwidth="([^%]+?)"|[^-]\bwidth='([^%]+?)'/;
var SVG_HEIGHT_RE  = /\bheight="([^%]+?)"|\bheight='([^%]+?)'/;
var SVG_VIEWBOX_RE = /\bview[bB]ox="(.+?)"|\bview[bB]ox='(.+?)'/;
var SVG_UNITS_RE   = /in$|mm$|cm$|pt$|pc$|px$|em$|ex$/;

function svgAttrs(str) {
  var width   = str.match(SVG_WIDTH_RE);
  var height  = str.match(SVG_HEIGHT_RE);
  var viewbox = str.match(SVG_VIEWBOX_RE);

  return {
    width:   width && (width[1] || width[2]),
    height:  height && (height[1] || height[2]),
    viewbox: viewbox && (viewbox[1] || viewbox[2])
  };
}


function units(str) {
  if (!SVG_UNITS_RE.test(str)) return 'px';

  return str.match(SVG_UNITS_RE)[0];
}


module.exports = function (data) {
  if (!canBeSvg(data)) return;

  var str = '';

  for (var i = 0; i < data.length; i++) {
    // 1. We can't rely on buffer features
    // 2. Don't care about UTF16 because ascii is enougth for our goals
    str += String.fromCharCode(data[i]);
  }

  // get top level element
  var svgTag = (str.match(SVG_HEADER_RE) || [ '' ])[0];

  // test if top level element is <svg>
  if (!SVG_TAG_RE.test(svgTag)) return;

  var attrs  = svgAttrs(svgTag);
  var width  = parseFloat(attrs.width);
  var height = parseFloat(attrs.height);

  // Extract from direct values

  if (attrs.width && attrs.height) {
    if (!isFinitePositive(width) || !isFinitePositive(height)) return;

    return {
      width:  width,
      height: height,
      type:   'svg',
      mime:   'image/svg+xml',
      wUnits: units(attrs.width),
      hUnits: units(attrs.height)
    };
  }

  // Extract from viewbox

  var parts = (attrs.viewbox || '').split(' ');
  var viewbox = {
    width:  parts[2],
    height: parts[3]
  };
  var vbWidth  = parseFloat(viewbox.width);
  var vbHeight = parseFloat(viewbox.height);

  if (!isFinitePositive(vbWidth) || !isFinitePositive(vbHeight)) return;
  if (units(viewbox.width) !== units(viewbox.height)) return;

  var ratio = vbWidth / vbHeight;

  if (attrs.width) {
    if (!isFinitePositive(width)) return;

    return {
      width:  width,
      height: width / ratio,
      type:   'svg',
      mime:   'image/svg+xml',
      wUnits: units(attrs.width),
      hUnits: units(attrs.width)
    };
  }

  if (attrs.height) {
    if (!isFinitePositive(height)) return;

    return {
      width:  height * ratio,
      height: height,
      type:   'svg',
      mime:   'image/svg+xml',
      wUnits: units(attrs.height),
      hUnits: units(attrs.height)
    };
  }

  return {
    width:  vbWidth,
    height: vbHeight,
    type:   'svg',
    mime:   'image/svg+xml',
    wUnits: units(viewbox.width),
    hUnits: units(viewbox.height)
  };
};


/***/ }),

/***/ 46966:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


/* eslint-disable consistent-return */

var str2arr = (__webpack_require__(3944)/* .str2arr */ .VG);
var sliceEq = (__webpack_require__(3944)/* .sliceEq */ .rU);
var readUInt16LE = (__webpack_require__(3944)/* .readUInt16LE */ .$l);
var readUInt16BE = (__webpack_require__(3944)/* .readUInt16BE */ .bc);
var readUInt32LE = (__webpack_require__(3944)/* .readUInt32LE */ .tF);
var readUInt32BE = (__webpack_require__(3944)/* .readUInt32BE */ .bb);


var SIG_1 = str2arr('II\x2A\0');
var SIG_2 = str2arr('MM\0\x2A');


function readUInt16(buffer, offset, is_big_endian) {
  return is_big_endian ? readUInt16BE(buffer, offset) : readUInt16LE(buffer, offset);
}

function readUInt32(buffer, offset, is_big_endian) {
  return is_big_endian ? readUInt32BE(buffer, offset) : readUInt32LE(buffer, offset);
}

function readIFDValue(data, data_offset, is_big_endian) {
  var type       = readUInt16(data, data_offset + 2, is_big_endian);
  var values     = readUInt32(data, data_offset + 4, is_big_endian);

  if (values !== 1 || (type !== 3 && type !== 4)) return null;

  if (type === 3) {
    return readUInt16(data, data_offset + 8, is_big_endian);
  }

  return readUInt32(data, data_offset + 8, is_big_endian);
}

module.exports = function (data) {
  if (data.length < 8) return;

  // check TIFF signature
  if (!sliceEq(data, 0, SIG_1) && !sliceEq(data, 0, SIG_2)) return;

  var is_big_endian = (data[0] === 77 /* 'MM' */);
  var count = readUInt32(data, 4, is_big_endian) - 8;

  if (count < 0) return;

  // skip until IFD
  var offset = count + 8;

  if (data.length - offset < 2) return;

  // read number of IFD entries
  var ifd_size = readUInt16(data, offset + 0, is_big_endian) * 12;

  if (ifd_size <= 0) return;

  offset += 2;

  // read all IFD entries
  if (data.length - offset < ifd_size) return;

  var i, width, height, tag;

  for (i = 0; i < ifd_size; i += 12) {
    tag = readUInt16(data, offset + i, is_big_endian);

    if (tag === 256) {
      width = readIFDValue(data, offset + i, is_big_endian);
    } else if (tag === 257) {
      height = readIFDValue(data, offset + i, is_big_endian);
    }
  }

  if (width && height) {
    return {
      width:  width,
      height: height,
      type:   'tiff',
      mime:   'image/tiff',
      wUnits: 'px',
      hUnits: 'px'
    };
  }
};


/***/ }),

/***/ 88023:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


/* eslint-disable no-bitwise */
/* eslint-disable consistent-return */

var str2arr      = (__webpack_require__(3944)/* .str2arr */ .VG);
var sliceEq      = (__webpack_require__(3944)/* .sliceEq */ .rU);
var readUInt16LE = (__webpack_require__(3944)/* .readUInt16LE */ .$l);
var readUInt32LE = (__webpack_require__(3944)/* .readUInt32LE */ .tF);
var exif         = __webpack_require__(19789);


var SIG_RIFF = str2arr('RIFF');
var SIG_WEBP = str2arr('WEBP');


function parseVP8(data, offset) {
  if (data[offset + 3] !== 0x9D || data[offset + 4] !== 0x01 || data[offset + 5] !== 0x2A) {
    // bad code block signature
    return;
  }

  return {
    width:  readUInt16LE(data, offset + 6) & 0x3FFF,
    height: readUInt16LE(data, offset + 8) & 0x3FFF,
    type:   'webp',
    mime:   'image/webp',
    wUnits: 'px',
    hUnits: 'px'
  };
}


function parseVP8L(data, offset) {
  if (data[offset] !== 0x2F) return;

  var bits = readUInt32LE(data, offset + 1);

  return {
    width:  (bits & 0x3FFF) + 1,
    height: ((bits >> 14) & 0x3FFF) + 1,
    type:   'webp',
    mime:   'image/webp',
    wUnits: 'px',
    hUnits: 'px'
  };
}


function parseVP8X(data, offset) {
  return  {
    // TODO: replace with `data.readUIntLE(8, 3) + 1`
    //       when 0.10 support is dropped
    width:  ((data[offset + 6] << 16) | (data[offset + 5] << 8) | data[offset + 4]) + 1,
    height: ((data[offset + 9] << offset) | (data[offset + 8] << 8) | data[offset + 7]) + 1,
    type:   'webp',
    mime:   'image/webp',
    wUnits: 'px',
    hUnits: 'px'
  };
}


module.exports = function (data) {
  if (data.length < 16) return;

  // check /^RIFF....WEBPVP8([ LX])$/ signature
  if (!sliceEq(data, 0, SIG_RIFF) && !sliceEq(data, 8, SIG_WEBP)) return;

  var offset = 12;
  var result = null;
  var exif_orientation = 0;
  var fileLength = readUInt32LE(data, 4) + 8;

  if (fileLength > data.length) return;

  while (offset + 8 < fileLength) {
    if (data[offset] === 0) {
      // after each chunk of odd size there should be 0 byte of padding, skip those
      offset++;
      continue;
    }

    var header = String.fromCharCode.apply(null, data.slice(offset, offset + 4));
    var length = readUInt32LE(data, offset + 4);

    if (header === 'VP8 ' && length >= 10) {
      result = result || parseVP8(data, offset + 8);
    } else if (header === 'VP8L' && length >= 9) {
      result = result || parseVP8L(data, offset + 8);
    } else if (header === 'VP8X' && length >= 10) {
      result = result || parseVP8X(data, offset + 8);
    } else if (header === 'EXIF') {
      exif_orientation = exif.get_orientation(data.slice(offset + 8, offset + 8 + length));

      // exif is the last chunk we care about, stop after it
      offset = Infinity;
    }

    offset += 8 + length;
  }

  if (!result) return;

  if (exif_orientation > 0) {
    result.orientation = exif_orientation;
  }

  return result;
};


/***/ }),

/***/ 43751:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";



module.exports = {
  avif: __webpack_require__(31149),
  bmp:  __webpack_require__(78218),
  gif:  __webpack_require__(37495),
  ico:  __webpack_require__(88708),
  jpeg: __webpack_require__(13827),
  png:  __webpack_require__(46594),
  psd:  __webpack_require__(13198),
  svg:  __webpack_require__(94203),
  tiff: __webpack_require__(46966),
  webp: __webpack_require__(88023)
};


/***/ }),

/***/ 19490:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";



var parsers = __webpack_require__(43751);


function probeBuffer(buffer) {
  var parser_names = Object.keys(parsers);

  for (var i = 0; i < parser_names.length; i++) {
    var result = parsers[parser_names[i]](buffer);

    if (result) return result;
  }

  return null;
}


///////////////////////////////////////////////////////////////////////
// Exports
//

module.exports = function get_image_size(src) {
  return probeBuffer(src);
};

module.exports.parsers = parsers;


/***/ }),

/***/ 33282:
/***/ (function(module) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ 16494:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var now = __webpack_require__(71879)
  , root = typeof window === 'undefined' ? __webpack_require__.g : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}


/***/ }),

/***/ 29978:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var getBounds = __webpack_require__(78112)
var rgba = __webpack_require__(162)
var updateDiff = __webpack_require__(79788)
var pick = __webpack_require__(6807)
var extend = __webpack_require__(27976)
var flatten = __webpack_require__(83473)
var ref = __webpack_require__(51498);
var float32 = ref.float32;
var fract32 = ref.fract32;

module.exports = Error2D

var WEIGHTS = [
	//direction, lineWidth shift, capSize shift

	// x-error bar
	[1, 0, 0, 1, 0, 0],
	[1, 0, 0, -1, 0, 0],
	[-1, 0, 0, -1, 0, 0],

	[-1, 0, 0, -1, 0, 0],
	[-1, 0, 0, 1, 0, 0],
	[1, 0, 0, 1, 0, 0],

	// x-error right cap
	[1, 0, -1, 0, 0, 1],
	[1, 0, -1, 0, 0, -1],
	[1, 0, 1, 0, 0, -1],

	[1, 0, 1, 0, 0, -1],
	[1, 0, 1, 0, 0, 1],
	[1, 0, -1, 0, 0, 1],

	// x-error left cap
	[-1, 0, -1, 0, 0, 1],
	[-1, 0, -1, 0, 0, -1],
	[-1, 0, 1, 0, 0, -1],

	[-1, 0, 1, 0, 0, -1],
	[-1, 0, 1, 0, 0, 1],
	[-1, 0, -1, 0, 0, 1],

	// y-error bar
	[0, 1, 1, 0, 0, 0],
	[0, 1, -1, 0, 0, 0],
	[0, -1, -1, 0, 0, 0],

	[0, -1, -1, 0, 0, 0],
	[0, 1, 1, 0, 0, 0],
	[0, -1, 1, 0, 0, 0],

	// y-error top cap
	[0, 1, 0, -1, 1, 0],
	[0, 1, 0, -1, -1, 0],
	[0, 1, 0, 1, -1, 0],

	[0, 1, 0, 1, 1, 0],
	[0, 1, 0, -1, 1, 0],
	[0, 1, 0, 1, -1, 0],

	// y-error bottom cap
	[0, -1, 0, -1, 1, 0],
	[0, -1, 0, -1, -1, 0],
	[0, -1, 0, 1, -1, 0],

	[0, -1, 0, 1, 1, 0],
	[0, -1, 0, -1, 1, 0],
	[0, -1, 0, 1, -1, 0]
]


function Error2D (regl, options) {
	if (typeof regl === 'function') {
		if (!options) { options = {} }
		options.regl = regl
	}
	else {
		options = regl
	}
	if (options.length) { options.positions = options }
	regl = options.regl

	if (!regl.hasExtension('ANGLE_instanced_arrays')) {
		throw Error('regl-error2d: `ANGLE_instanced_arrays` extension should be enabled');
	}

	// persistent variables
	var gl = regl._gl, drawErrors, positionBuffer, positionFractBuffer, colorBuffer, errorBuffer, meshBuffer,
			defaults = {
				color: 'black',
				capSize: 5,
				lineWidth: 1,
				opacity: 1,
				viewport: null,
				range: null,
				offset: 0,
				count: 0,
				bounds: null,
				positions: [],
				errors: []
			}, groups = []

	//color per-point
	colorBuffer = regl.buffer({
		usage: 'dynamic',
		type: 'uint8',
		data: new Uint8Array(0)
	})
	//xy-position per-point
	positionBuffer = regl.buffer({
		usage: 'dynamic',
		type: 'float',
		data: new Uint8Array(0)
	})
	//xy-position float32-fraction
	positionFractBuffer = regl.buffer({
		usage: 'dynamic',
		type: 'float',
		data: new Uint8Array(0)
	})
	//4 errors per-point
	errorBuffer = regl.buffer({
		usage: 'dynamic',
		type: 'float',
		data: new Uint8Array(0)
	})
	//error bar mesh
	meshBuffer = regl.buffer({
		usage: 'static',
		type: 'float',
		data: WEIGHTS
	})

	update(options)

	//drawing method
	drawErrors = regl({
		vert: "\n\t\tprecision highp float;\n\n\t\tattribute vec2 position, positionFract;\n\t\tattribute vec4 error;\n\t\tattribute vec4 color;\n\n\t\tattribute vec2 direction, lineOffset, capOffset;\n\n\t\tuniform vec4 viewport;\n\t\tuniform float lineWidth, capSize;\n\t\tuniform vec2 scale, scaleFract, translate, translateFract;\n\n\t\tvarying vec4 fragColor;\n\n\t\tvoid main() {\n\t\t\tfragColor = color / 255.;\n\n\t\t\tvec2 pixelOffset = lineWidth * lineOffset + (capSize + lineWidth) * capOffset;\n\n\t\t\tvec2 dxy = -step(.5, direction.xy) * error.xz + step(direction.xy, vec2(-.5)) * error.yw;\n\n\t\t\tvec2 position = position + dxy;\n\n\t\t\tvec2 pos = (position + translate) * scale\n\t\t\t\t+ (positionFract + translateFract) * scale\n\t\t\t\t+ (position + translate) * scaleFract\n\t\t\t\t+ (positionFract + translateFract) * scaleFract;\n\n\t\t\tpos += pixelOffset / viewport.zw;\n\n\t\t\tgl_Position = vec4(pos * 2. - 1., 0, 1);\n\t\t}\n\t\t",

		frag: "\n\t\tprecision highp float;\n\n\t\tvarying vec4 fragColor;\n\n\t\tuniform float opacity;\n\n\t\tvoid main() {\n\t\t\tgl_FragColor = fragColor;\n\t\t\tgl_FragColor.a *= opacity;\n\t\t}\n\t\t",

		uniforms: {
			range: regl.prop('range'),
			lineWidth: regl.prop('lineWidth'),
			capSize: regl.prop('capSize'),
			opacity: regl.prop('opacity'),
			scale: regl.prop('scale'),
			translate: regl.prop('translate'),
			scaleFract: regl.prop('scaleFract'),
			translateFract: regl.prop('translateFract'),
			viewport: function (ctx, prop) { return [prop.viewport.x, prop.viewport.y, ctx.viewportWidth, ctx.viewportHeight]; }
		},

		attributes: {
			//dynamic attributes
			color: {
				buffer: colorBuffer,
				offset: function (ctx, prop) { return prop.offset * 4; },
				divisor: 1,
			},
			position: {
				buffer: positionBuffer,
				offset: function (ctx, prop) { return prop.offset * 8; },
				divisor: 1
			},
			positionFract: {
				buffer: positionFractBuffer,
				offset: function (ctx, prop) { return prop.offset * 8; },
				divisor: 1
			},
			error: {
				buffer: errorBuffer,
				offset: function (ctx, prop) { return prop.offset * 16; },
				divisor: 1
			},

			//static attributes
			direction: {
				buffer: meshBuffer,
				stride: 24,
				offset: 0
			},
			lineOffset: {
				buffer: meshBuffer,
				stride: 24,
				offset: 8
			},
			capOffset: {
				buffer: meshBuffer,
				stride: 24,
				offset: 16
			}
		},

		primitive: 'triangles',

		blend: {
			enable: true,
			color: [0,0,0,0],
			equation: {
				rgb: 'add',
				alpha: 'add'
			},
			func: {
				srcRGB: 'src alpha',
				dstRGB: 'one minus src alpha',
				srcAlpha: 'one minus dst alpha',
				dstAlpha: 'one'
			}
		},

		depth: {
			enable: false
		},

		scissor: {
			enable: true,
			box: regl.prop('viewport')
		},
		viewport: regl.prop('viewport'),
		stencil: false,

		instances: regl.prop('count'),
		count: WEIGHTS.length
	})

	//expose API
	extend(error2d, {
		update: update,
		draw: draw,
		destroy: destroy,
		regl: regl,
		gl: gl,
		canvas: gl.canvas,
		groups: groups
	})

	return error2d

	function error2d (opts) {
		//update
		if (opts) {
			update(opts)
		}

		//destroy
		else if (opts === null) {
			destroy()
		}

		draw()
	}


	//main draw method
	function draw (options) {
		if (typeof options === 'number') { return drawGroup(options) }

		//make options a batch
		if (options && !Array.isArray(options)) { options = [options] }


		regl._refresh()

		//render multiple polylines via regl batch
		groups.forEach(function (s, i) {
			if (!s) { return }

			if (options) {
				if (!options[i]) { s.draw = false }
				else { s.draw = true }
			}

			//ignore draw flag for one pass
			if (!s.draw) {
				s.draw = true;
				return
			}

			drawGroup(i)
		})
	}

	//draw single error group by id
	function drawGroup (s) {
		if (typeof s === 'number') { s = groups[s] }
		if (s == null) { return }

		if (!(s && s.count && s.color && s.opacity && s.positions && s.positions.length > 1)) { return }

		s.scaleRatio = [
			s.scale[0] * s.viewport.width,
			s.scale[1] * s.viewport.height
		]

		drawErrors(s)

		if (s.after) { s.after(s) }
	}

	function update (options) {
		if (!options) { return }

		//direct points argument
		if (options.length != null) {
			if (typeof options[0] === 'number') { options = [{positions: options}] }
		}

		//make options a batch
		else if (!Array.isArray(options)) { options = [options] }

		//global count of points
		var pointCount = 0, errorCount = 0

		error2d.groups = groups = options.map(function (options, i) {
			var group = groups[i]

			if (!options) { return group }
			else if (typeof options === 'function') { options = {after: options} }
			else if (typeof options[0] === 'number') { options = {positions: options} }

			//copy options to avoid mutation & handle aliases
			options = pick(options, {
				color: 'color colors fill',
				capSize: 'capSize cap capsize cap-size',
				lineWidth: 'lineWidth line-width width line thickness',
				opacity: 'opacity alpha',
				range: 'range dataBox',
				viewport: 'viewport viewBox',
				errors: 'errors error',
				positions: 'positions position data points'
			})

			if (!group) {
				groups[i] = group = {
					id: i,
					scale: null,
					translate: null,
					scaleFract: null,
					translateFract: null,
					draw: true
				}
				options = extend({}, defaults, options)
			}

			updateDiff(group, options, [{
				lineWidth: function (v) { return +v * .5; },
				capSize: function (v) { return +v * .5; },
				opacity: parseFloat,
				errors: function (errors) {
					errors = flatten(errors)

					errorCount += errors.length
					return errors
				},
				positions: function (positions, state) {
					positions = flatten(positions, 'float64')
					state.count = Math.floor(positions.length / 2)
					state.bounds = getBounds(positions, 2)
					state.offset = pointCount

					pointCount += state.count

					return positions
				}
			}, {
				color: function (colors, state) {
					var count = state.count

					if (!colors) { colors = 'transparent' }

					// 'black' or [0,0,0,0] case
					if (!Array.isArray(colors) || typeof colors[0] === 'number') {
						var color = colors
						colors = Array(count)
						for (var i = 0; i < count; i++) {
							colors[i] = color
						}
					}

					if (colors.length < count) { throw Error('Not enough colors') }

					var colorData = new Uint8Array(count * 4)

					//convert colors to float arrays
					for (var i$1 = 0; i$1 < count; i$1++) {
						var c = rgba(colors[i$1], 'uint8')
						colorData.set(c, i$1 * 4)
					}

					return colorData
				},

				range: function (range, state, options) {
					var bounds = state.bounds
					if (!range) { range = bounds }

					state.scale = [1 / (range[2] - range[0]), 1 / (range[3] - range[1])]
					state.translate = [-range[0], -range[1]]

					state.scaleFract = fract32(state.scale)
					state.translateFract = fract32(state.translate)

					return range
				},

				viewport: function (vp) {
					var viewport

					if (Array.isArray(vp)) {
						viewport = {
							x: vp[0],
							y: vp[1],
							width: vp[2] - vp[0],
							height: vp[3] - vp[1]
						}
					}
					else if (vp) {
						viewport = {
							x: vp.x || vp.left || 0,
							y: vp.y || vp.top || 0
						}

						if (vp.right) { viewport.width = vp.right - viewport.x }
						else { viewport.width = vp.w || vp.width || 0 }

						if (vp.bottom) { viewport.height = vp.bottom - viewport.y }
						else { viewport.height = vp.h || vp.height || 0 }
					}
					else {
						viewport = {
							x: 0, y: 0,
							width: gl.drawingBufferWidth,
							height: gl.drawingBufferHeight
						}
					}

					return viewport
				}
			}])

			return group
		})

		if (pointCount || errorCount) {
			var len = groups.reduce(function (acc, group, i) {
				return acc + (group ? group.count : 0)
			}, 0)

			var positionData = new Float64Array(len * 2)
			var colorData = new Uint8Array(len * 4)
			var errorData = new Float32Array(len * 4)

			groups.forEach(function (group, i) {
				if (!group) { return }
				var positions = group.positions;
				var count = group.count;
				var offset = group.offset;
				var color = group.color;
				var errors = group.errors;
				if (!count) { return }

				colorData.set(color, offset * 4)
				errorData.set(errors, offset * 4)
				positionData.set(positions, offset * 2)
			})

			var float_data = float32(positionData)
			positionBuffer(float_data)
			var frac_data = fract32(positionData, float_data)
			positionFractBuffer(frac_data)
			colorBuffer(colorData)
			errorBuffer(errorData)
		}

	}

	function destroy () {
		positionBuffer.destroy()
		positionFractBuffer.destroy()
		colorBuffer.destroy()
		errorBuffer.destroy()
		meshBuffer.destroy()
	}
}

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 49478:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";



var rgba = __webpack_require__(162)
var getBounds = __webpack_require__(78112)
var extend = __webpack_require__(27976)
var pick = __webpack_require__(6807)
var flatten = __webpack_require__(83473)
var triangulate = __webpack_require__(25782)
var normalize = __webpack_require__(90956)
var ref = __webpack_require__(51498);
var float32 = ref.float32;
var fract32 = ref.fract32;
var WeakMap = __webpack_require__(93103)
var parseRect = __webpack_require__(5137)
var findIndex = __webpack_require__(33055)

var rectVert = "\nprecision highp float;\n\nattribute vec2 aCoord, bCoord, aCoordFract, bCoordFract;\nattribute vec4 color;\nattribute float lineEnd, lineTop;\n\nuniform vec2 scale, scaleFract, translate, translateFract;\nuniform float thickness, pixelRatio, id, depth;\nuniform vec4 viewport;\n\nvarying vec4 fragColor;\nvarying vec2 tangent;\n\nvec2 project(vec2 position, vec2 positionFract, vec2 scale, vec2 scaleFract, vec2 translate, vec2 translateFract) {\n\t// the order is important\n\treturn position * scale + translate\n       + positionFract * scale + translateFract\n       + position * scaleFract\n       + positionFract * scaleFract;\n}\n\nvoid main() {\n\tfloat lineStart = 1. - lineEnd;\n\tfloat lineOffset = lineTop * 2. - 1.;\n\n\tvec2 diff = (bCoord + bCoordFract - aCoord - aCoordFract);\n\ttangent = normalize(diff * scale * viewport.zw);\n\tvec2 normal = vec2(-tangent.y, tangent.x);\n\n\tvec2 position = project(aCoord, aCoordFract, scale, scaleFract, translate, translateFract) * lineStart\n\t\t+ project(bCoord, bCoordFract, scale, scaleFract, translate, translateFract) * lineEnd\n\n\t\t+ thickness * normal * .5 * lineOffset / viewport.zw;\n\n\tgl_Position = vec4(position * 2.0 - 1.0, depth, 1);\n\n\tfragColor = color / 255.;\n}\n"

var rectFrag ="\nprecision highp float;\n\nuniform float dashLength, pixelRatio, thickness, opacity, id;\nuniform sampler2D dashTexture;\n\nvarying vec4 fragColor;\nvarying vec2 tangent;\n\nvoid main() {\n\tfloat alpha = 1.;\n\n\tfloat t = fract(dot(tangent, gl_FragCoord.xy) / dashLength) * .5 + .25;\n\tfloat dash = texture2D(dashTexture, vec2(t, .5)).r;\n\n\tgl_FragColor = fragColor;\n\tgl_FragColor.a *= alpha * opacity * dash;\n}\n"

var fillVert = "\nprecision highp float;\n\nattribute vec2 position, positionFract;\n\nuniform vec4 color;\nuniform vec2 scale, scaleFract, translate, translateFract;\nuniform float pixelRatio, id;\nuniform vec4 viewport;\nuniform float opacity;\n\nvarying vec4 fragColor;\n\nconst float MAX_LINES = 256.;\n\nvoid main() {\n\tfloat depth = (MAX_LINES - 4. - id) / (MAX_LINES);\n\n\tvec2 position = position * scale + translate\n       + positionFract * scale + translateFract\n       + position * scaleFract\n       + positionFract * scaleFract;\n\n\tgl_Position = vec4(position * 2.0 - 1.0, depth, 1);\n\n\tfragColor = color / 255.;\n\tfragColor.a *= opacity;\n}\n"

var fillFrag = "\nprecision highp float;\nvarying vec4 fragColor;\n\nvoid main() {\n\tgl_FragColor = fragColor;\n}\n"

var milterVert = "\nprecision highp float;\n\nattribute vec2 aCoord, bCoord, nextCoord, prevCoord;\nattribute vec4 aColor, bColor;\nattribute float lineEnd, lineTop;\n\nuniform vec2 scale, translate;\nuniform float thickness, pixelRatio, id, depth;\nuniform vec4 viewport;\nuniform float miterLimit, miterMode;\n\nvarying vec4 fragColor;\nvarying vec4 startCutoff, endCutoff;\nvarying vec2 tangent;\nvarying vec2 startCoord, endCoord;\nvarying float enableStartMiter, enableEndMiter;\n\nconst float REVERSE_THRESHOLD = -.875;\nconst float MIN_DIFF = 1e-6;\n\n// TODO: possible optimizations: avoid overcalculating all for vertices and calc just one instead\n// TODO: precalculate dot products, normalize things beforehead etc.\n// TODO: refactor to rectangular algorithm\n\nfloat distToLine(vec2 p, vec2 a, vec2 b) {\n\tvec2 diff = b - a;\n\tvec2 perp = normalize(vec2(-diff.y, diff.x));\n\treturn dot(p - a, perp);\n}\n\nbool isNaN( float val ){\n  return ( val < 0.0 || 0.0 < val || val == 0.0 ) ? false : true;\n}\n\nvoid main() {\n\tvec2 aCoord = aCoord, bCoord = bCoord, prevCoord = prevCoord, nextCoord = nextCoord;\n\n  vec2 adjustedScale;\n  adjustedScale.x = (abs(scale.x) < MIN_DIFF) ? MIN_DIFF : scale.x;\n  adjustedScale.y = (abs(scale.y) < MIN_DIFF) ? MIN_DIFF : scale.y;\n\n  vec2 scaleRatio = adjustedScale * viewport.zw;\n\tvec2 normalWidth = thickness / scaleRatio;\n\n\tfloat lineStart = 1. - lineEnd;\n\tfloat lineBot = 1. - lineTop;\n\n\tfragColor = (lineStart * aColor + lineEnd * bColor) / 255.;\n\n\tif (isNaN(aCoord.x) || isNaN(aCoord.y) || isNaN(bCoord.x) || isNaN(bCoord.y)) return;\n\n\tif (aCoord == prevCoord) prevCoord = aCoord + normalize(bCoord - aCoord);\n\tif (bCoord == nextCoord) nextCoord = bCoord - normalize(bCoord - aCoord);\n\n\n\tvec2 prevDiff = aCoord - prevCoord;\n\tvec2 currDiff = bCoord - aCoord;\n\tvec2 nextDiff = nextCoord - bCoord;\n\n\tvec2 prevTangent = normalize(prevDiff * scaleRatio);\n\tvec2 currTangent = normalize(currDiff * scaleRatio);\n\tvec2 nextTangent = normalize(nextDiff * scaleRatio);\n\n\tvec2 prevNormal = vec2(-prevTangent.y, prevTangent.x);\n\tvec2 currNormal = vec2(-currTangent.y, currTangent.x);\n\tvec2 nextNormal = vec2(-nextTangent.y, nextTangent.x);\n\n\tvec2 startJoinDirection = normalize(prevTangent - currTangent);\n\tvec2 endJoinDirection = normalize(currTangent - nextTangent);\n\n\t// collapsed/unidirectional segment cases\n\t// FIXME: there should be more elegant solution\n\tvec2 prevTanDiff = abs(prevTangent - currTangent);\n\tvec2 nextTanDiff = abs(nextTangent - currTangent);\n\tif (max(prevTanDiff.x, prevTanDiff.y) < MIN_DIFF) {\n\t\tstartJoinDirection = currNormal;\n\t}\n\tif (max(nextTanDiff.x, nextTanDiff.y) < MIN_DIFF) {\n\t\tendJoinDirection = currNormal;\n\t}\n\tif (aCoord == bCoord) {\n\t\tendJoinDirection = startJoinDirection;\n\t\tcurrNormal = prevNormal;\n\t\tcurrTangent = prevTangent;\n\t}\n\n\ttangent = currTangent;\n\n\t//calculate join shifts relative to normals\n\tfloat startJoinShift = dot(currNormal, startJoinDirection);\n\tfloat endJoinShift = dot(currNormal, endJoinDirection);\n\n\tfloat startMiterRatio = abs(1. / startJoinShift);\n\tfloat endMiterRatio = abs(1. / endJoinShift);\n\n\tvec2 startJoin = startJoinDirection * startMiterRatio;\n\tvec2 endJoin = endJoinDirection * endMiterRatio;\n\n\tvec2 startTopJoin, startBotJoin, endTopJoin, endBotJoin;\n\tstartTopJoin = sign(startJoinShift) * startJoin * .5;\n\tstartBotJoin = -startTopJoin;\n\n\tendTopJoin = sign(endJoinShift) * endJoin * .5;\n\tendBotJoin = -endTopJoin;\n\n\tvec2 aTopCoord = aCoord + normalWidth * startTopJoin;\n\tvec2 bTopCoord = bCoord + normalWidth * endTopJoin;\n\tvec2 aBotCoord = aCoord + normalWidth * startBotJoin;\n\tvec2 bBotCoord = bCoord + normalWidth * endBotJoin;\n\n\t//miter anti-clipping\n\tfloat baClipping = distToLine(bCoord, aCoord, aBotCoord) / dot(normalize(normalWidth * endBotJoin), normalize(normalWidth.yx * vec2(-startBotJoin.y, startBotJoin.x)));\n\tfloat abClipping = distToLine(aCoord, bCoord, bTopCoord) / dot(normalize(normalWidth * startBotJoin), normalize(normalWidth.yx * vec2(-endBotJoin.y, endBotJoin.x)));\n\n\t//prevent close to reverse direction switch\n\tbool prevReverse = dot(currTangent, prevTangent) <= REVERSE_THRESHOLD && abs(dot(currTangent, prevNormal)) * min(length(prevDiff), length(currDiff)) <  length(normalWidth * currNormal);\n\tbool nextReverse = dot(currTangent, nextTangent) <= REVERSE_THRESHOLD && abs(dot(currTangent, nextNormal)) * min(length(nextDiff), length(currDiff)) <  length(normalWidth * currNormal);\n\n\tif (prevReverse) {\n\t\t//make join rectangular\n\t\tvec2 miterShift = normalWidth * startJoinDirection * miterLimit * .5;\n\t\tfloat normalAdjust = 1. - min(miterLimit / startMiterRatio, 1.);\n\t\taBotCoord = aCoord + miterShift - normalAdjust * normalWidth * currNormal * .5;\n\t\taTopCoord = aCoord + miterShift + normalAdjust * normalWidth * currNormal * .5;\n\t}\n\telse if (!nextReverse && baClipping > 0. && baClipping < length(normalWidth * endBotJoin)) {\n\t\t//handle miter clipping\n\t\tbTopCoord -= normalWidth * endTopJoin;\n\t\tbTopCoord += normalize(endTopJoin * normalWidth) * baClipping;\n\t}\n\n\tif (nextReverse) {\n\t\t//make join rectangular\n\t\tvec2 miterShift = normalWidth * endJoinDirection * miterLimit * .5;\n\t\tfloat normalAdjust = 1. - min(miterLimit / endMiterRatio, 1.);\n\t\tbBotCoord = bCoord + miterShift - normalAdjust * normalWidth * currNormal * .5;\n\t\tbTopCoord = bCoord + miterShift + normalAdjust * normalWidth * currNormal * .5;\n\t}\n\telse if (!prevReverse && abClipping > 0. && abClipping < length(normalWidth * startBotJoin)) {\n\t\t//handle miter clipping\n\t\taBotCoord -= normalWidth * startBotJoin;\n\t\taBotCoord += normalize(startBotJoin * normalWidth) * abClipping;\n\t}\n\n\tvec2 aTopPosition = (aTopCoord) * adjustedScale + translate;\n\tvec2 aBotPosition = (aBotCoord) * adjustedScale + translate;\n\n\tvec2 bTopPosition = (bTopCoord) * adjustedScale + translate;\n\tvec2 bBotPosition = (bBotCoord) * adjustedScale + translate;\n\n\t//position is normalized 0..1 coord on the screen\n\tvec2 position = (aTopPosition * lineTop + aBotPosition * lineBot) * lineStart + (bTopPosition * lineTop + bBotPosition * lineBot) * lineEnd;\n\n\tstartCoord = aCoord * scaleRatio + translate * viewport.zw + viewport.xy;\n\tendCoord = bCoord * scaleRatio + translate * viewport.zw + viewport.xy;\n\n\tgl_Position = vec4(position  * 2.0 - 1.0, depth, 1);\n\n\tenableStartMiter = step(dot(currTangent, prevTangent), .5);\n\tenableEndMiter = step(dot(currTangent, nextTangent), .5);\n\n\t//bevel miter cutoffs\n\tif (miterMode == 1.) {\n\t\tif (enableStartMiter == 1.) {\n\t\t\tvec2 startMiterWidth = vec2(startJoinDirection) * thickness * miterLimit * .5;\n\t\t\tstartCutoff = vec4(aCoord, aCoord);\n\t\t\tstartCutoff.zw += vec2(-startJoinDirection.y, startJoinDirection.x) / scaleRatio;\n\t\t\tstartCutoff = startCutoff * scaleRatio.xyxy + translate.xyxy * viewport.zwzw;\n\t\t\tstartCutoff += viewport.xyxy;\n\t\t\tstartCutoff += startMiterWidth.xyxy;\n\t\t}\n\n\t\tif (enableEndMiter == 1.) {\n\t\t\tvec2 endMiterWidth = vec2(endJoinDirection) * thickness * miterLimit * .5;\n\t\t\tendCutoff = vec4(bCoord, bCoord);\n\t\t\tendCutoff.zw += vec2(-endJoinDirection.y, endJoinDirection.x)  / scaleRatio;\n\t\t\tendCutoff = endCutoff * scaleRatio.xyxy + translate.xyxy * viewport.zwzw;\n\t\t\tendCutoff += viewport.xyxy;\n\t\t\tendCutoff += endMiterWidth.xyxy;\n\t\t}\n\t}\n\n\t//round miter cutoffs\n\telse if (miterMode == 2.) {\n\t\tif (enableStartMiter == 1.) {\n\t\t\tvec2 startMiterWidth = vec2(startJoinDirection) * thickness * abs(dot(startJoinDirection, currNormal)) * .5;\n\t\t\tstartCutoff = vec4(aCoord, aCoord);\n\t\t\tstartCutoff.zw += vec2(-startJoinDirection.y, startJoinDirection.x) / scaleRatio;\n\t\t\tstartCutoff = startCutoff * scaleRatio.xyxy + translate.xyxy * viewport.zwzw;\n\t\t\tstartCutoff += viewport.xyxy;\n\t\t\tstartCutoff += startMiterWidth.xyxy;\n\t\t}\n\n\t\tif (enableEndMiter == 1.) {\n\t\t\tvec2 endMiterWidth = vec2(endJoinDirection) * thickness * abs(dot(endJoinDirection, currNormal)) * .5;\n\t\t\tendCutoff = vec4(bCoord, bCoord);\n\t\t\tendCutoff.zw += vec2(-endJoinDirection.y, endJoinDirection.x)  / scaleRatio;\n\t\t\tendCutoff = endCutoff * scaleRatio.xyxy + translate.xyxy * viewport.zwzw;\n\t\t\tendCutoff += viewport.xyxy;\n\t\t\tendCutoff += endMiterWidth.xyxy;\n\t\t}\n\t}\n}\n"

var milterFrag = "\nprecision highp float;\n\nuniform float dashLength, pixelRatio, thickness, opacity, id, miterMode;\nuniform sampler2D dashTexture;\n\nvarying vec4 fragColor;\nvarying vec2 tangent;\nvarying vec4 startCutoff, endCutoff;\nvarying vec2 startCoord, endCoord;\nvarying float enableStartMiter, enableEndMiter;\n\nfloat distToLine(vec2 p, vec2 a, vec2 b) {\n\tvec2 diff = b - a;\n\tvec2 perp = normalize(vec2(-diff.y, diff.x));\n\treturn dot(p - a, perp);\n}\n\nvoid main() {\n\tfloat alpha = 1., distToStart, distToEnd;\n\tfloat cutoff = thickness * .5;\n\n\t//bevel miter\n\tif (miterMode == 1.) {\n\t\tif (enableStartMiter == 1.) {\n\t\t\tdistToStart = distToLine(gl_FragCoord.xy, startCutoff.xy, startCutoff.zw);\n\t\t\tif (distToStart < -1.) {\n\t\t\t\tdiscard;\n\t\t\t\treturn;\n\t\t\t}\n\t\t\talpha *= min(max(distToStart + 1., 0.), 1.);\n\t\t}\n\n\t\tif (enableEndMiter == 1.) {\n\t\t\tdistToEnd = distToLine(gl_FragCoord.xy, endCutoff.xy, endCutoff.zw);\n\t\t\tif (distToEnd < -1.) {\n\t\t\t\tdiscard;\n\t\t\t\treturn;\n\t\t\t}\n\t\t\talpha *= min(max(distToEnd + 1., 0.), 1.);\n\t\t}\n\t}\n\n\t// round miter\n\telse if (miterMode == 2.) {\n\t\tif (enableStartMiter == 1.) {\n\t\t\tdistToStart = distToLine(gl_FragCoord.xy, startCutoff.xy, startCutoff.zw);\n\t\t\tif (distToStart < 0.) {\n\t\t\t\tfloat radius = length(gl_FragCoord.xy - startCoord);\n\n\t\t\t\tif(radius > cutoff + .5) {\n\t\t\t\t\tdiscard;\n\t\t\t\t\treturn;\n\t\t\t\t}\n\n\t\t\t\talpha -= smoothstep(cutoff - .5, cutoff + .5, radius);\n\t\t\t}\n\t\t}\n\n\t\tif (enableEndMiter == 1.) {\n\t\t\tdistToEnd = distToLine(gl_FragCoord.xy, endCutoff.xy, endCutoff.zw);\n\t\t\tif (distToEnd < 0.) {\n\t\t\t\tfloat radius = length(gl_FragCoord.xy - endCoord);\n\n\t\t\t\tif(radius > cutoff + .5) {\n\t\t\t\t\tdiscard;\n\t\t\t\t\treturn;\n\t\t\t\t}\n\n\t\t\t\talpha -= smoothstep(cutoff - .5, cutoff + .5, radius);\n\t\t\t}\n\t\t}\n\t}\n\n\tfloat t = fract(dot(tangent, gl_FragCoord.xy) / dashLength) * .5 + .25;\n\tfloat dash = texture2D(dashTexture, vec2(t, .5)).r;\n\n\tgl_FragColor = fragColor;\n\tgl_FragColor.a *= alpha * opacity * dash;\n}\n"


module.exports = Line2D


/** @constructor */
function Line2D (regl, options) {
	if (!(this instanceof Line2D)) { return new Line2D(regl, options) }

	if (typeof regl === 'function') {
		if (!options) { options = {} }
		options.regl = regl
	}
	else {
		options = regl
	}
	if (options.length) { options.positions = options }
	regl = options.regl

	if (!regl.hasExtension('ANGLE_instanced_arrays')) {
		throw Error('regl-error2d: `ANGLE_instanced_arrays` extension should be enabled');
	}

	// persistent variables
	this.gl = regl._gl
	this.regl = regl

	// list of options for lines
	this.passes = []

	// cached shaders instance
	this.shaders = Line2D.shaders.has(regl) ? Line2D.shaders.get(regl) : Line2D.shaders.set(regl, Line2D.createShaders(regl)).get(regl)


	// init defaults
	this.update(options)
}


Line2D.dashMult = 2
Line2D.maxPatternLength = 256
Line2D.precisionThreshold = 3e6
Line2D.maxPoints = 1e4
Line2D.maxLines = 2048


// cache of created draw calls per-regl instance
Line2D.shaders = new WeakMap()


// create static shaders once
Line2D.createShaders = function (regl) {
	var offsetBuffer = regl.buffer({
		usage: 'static',
		type: 'float',
		data: [0,1, 0,0, 1,1, 1,0]
	})

	var shaderOptions = {
		primitive: 'triangle strip',
		instances: regl.prop('count'),
		count: 4,
		offset: 0,

		uniforms: {
			miterMode: function (ctx, prop) { return prop.join === 'round' ? 2 : 1; },
			miterLimit: regl.prop('miterLimit'),
			scale: regl.prop('scale'),
			scaleFract: regl.prop('scaleFract'),
			translateFract: regl.prop('translateFract'),
			translate: regl.prop('translate'),
			thickness: regl.prop('thickness'),
			dashTexture: regl.prop('dashTexture'),
			opacity: regl.prop('opacity'),
			pixelRatio: regl.context('pixelRatio'),
			id: regl.prop('id'),
			dashLength: regl.prop('dashLength'),
			viewport: function (c, p) { return [p.viewport.x, p.viewport.y, c.viewportWidth, c.viewportHeight]; },
			depth: regl.prop('depth')
		},

		blend: {
			enable: true,
			color: [0,0,0,0],
			equation: {
				rgb: 'add',
				alpha: 'add'
			},
			func: {
				srcRGB: 'src alpha',
				dstRGB: 'one minus src alpha',
				srcAlpha: 'one minus dst alpha',
				dstAlpha: 'one'
			}
		},
		depth: {
			enable: function (c, p) {
				return !p.overlay
			}
		},
		stencil: {enable: false},
		scissor: {
			enable: true,
			box: regl.prop('viewport')
		},
		viewport: regl.prop('viewport')
	}


	// simplified rectangular line shader
	var drawRectLine = regl(extend({
		vert: rectVert,
		frag: rectFrag,

		attributes: {
			// if point is at the end of segment
			lineEnd: {
				buffer: offsetBuffer,
				divisor: 0,
				stride: 8,
				offset: 0
			},
			// if point is at the top of segment
			lineTop: {
				buffer: offsetBuffer,
				divisor: 0,
				stride: 8,
				offset: 4
			},
			// beginning of line coordinate
			aCoord: {
				buffer: regl.prop('positionBuffer'),
				stride: 8,
				offset: 8,
				divisor: 1
			},
			// end of line coordinate
			bCoord: {
				buffer: regl.prop('positionBuffer'),
				stride: 8,
				offset: 16,
				divisor: 1
			},
			aCoordFract: {
				buffer: regl.prop('positionFractBuffer'),
				stride: 8,
				offset: 8,
				divisor: 1
			},
			bCoordFract: {
				buffer: regl.prop('positionFractBuffer'),
				stride: 8,
				offset: 16,
				divisor: 1
			},
			color: {
				buffer: regl.prop('colorBuffer'),
				stride: 4,
				offset: 0,
				divisor: 1
			}
		}
	}, shaderOptions))

	// create regl draw
	var drawMiterLine

	try {
		drawMiterLine = regl(extend({
			// culling removes polygon creasing
			cull: {
				enable: true,
				face: 'back'
			},

			vert: milterVert,
			frag: milterFrag,

			attributes: {
				// is line end
				lineEnd: {
					buffer: offsetBuffer,
					divisor: 0,
					stride: 8,
					offset: 0
				},
				// is line top
				lineTop: {
					buffer: offsetBuffer,
					divisor: 0,
					stride: 8,
					offset: 4
				},
				// left color
				aColor: {
					buffer: regl.prop('colorBuffer'),
					stride: 4,
					offset: 0,
					divisor: 1
				},
				// right color
				bColor: {
					buffer: regl.prop('colorBuffer'),
					stride: 4,
					offset: 4,
					divisor: 1
				},
				prevCoord: {
					buffer: regl.prop('positionBuffer'),
					stride: 8,
					offset: 0,
					divisor: 1
				},
				aCoord: {
					buffer: regl.prop('positionBuffer'),
					stride: 8,
					offset: 8,
					divisor: 1
				},
				bCoord: {
					buffer: regl.prop('positionBuffer'),
					stride: 8,
					offset: 16,
					divisor: 1
				},
				nextCoord: {
					buffer: regl.prop('positionBuffer'),
					stride: 8,
					offset: 24,
					divisor: 1
				}
			}
		}, shaderOptions))
	} catch (e) {
		// IE/bad Webkit fallback
		drawMiterLine = drawRectLine
	}

	// fill shader
	var drawFill = regl({
		primitive: 'triangle',
		elements: function (ctx, prop) { return prop.triangles; },
		offset: 0,

		vert: fillVert,
		frag: fillFrag,

		uniforms: {
			scale: regl.prop('scale'),
			color: regl.prop('fill'),
			scaleFract: regl.prop('scaleFract'),
			translateFract: regl.prop('translateFract'),
			translate: regl.prop('translate'),
			opacity: regl.prop('opacity'),
			pixelRatio: regl.context('pixelRatio'),
			id: regl.prop('id'),
			viewport: function (ctx, prop) { return [prop.viewport.x, prop.viewport.y, ctx.viewportWidth, ctx.viewportHeight]; }
		},

		attributes: {
			position: {
				buffer: regl.prop('positionBuffer'),
				stride: 8,
				offset: 8
			},
			positionFract: {
				buffer: regl.prop('positionFractBuffer'),
				stride: 8,
				offset: 8
			}
		},

		blend: shaderOptions.blend,

		depth: { enable: false },
		scissor: shaderOptions.scissor,
		stencil: shaderOptions.stencil,
		viewport: shaderOptions.viewport
	})

	return {
		fill: drawFill, rect: drawRectLine, miter: drawMiterLine
	}
}


// used to for new lines instances
Line2D.defaults = {
	dashes: null,
	join: 'miter',
	miterLimit: 1,
	thickness: 10,
	cap: 'square',
	color: 'black',
	opacity: 1,
	overlay: false,
	viewport: null,
	range: null,
	close: false,
	fill: null
}


Line2D.prototype.render = function () {
	var ref;

	var args = [], len = arguments.length;
	while ( len-- ) args[ len ] = arguments[ len ];
	if (args.length) {
		(ref = this).update.apply(ref, args)
	}

	this.draw()
}


Line2D.prototype.draw = function () {
	var this$1 = this;
	var args = [], len = arguments.length;
	while ( len-- ) args[ len ] = arguments[ len ];

	// render multiple polylines via regl batch
	(args.length ? args : this.passes).forEach(function (s, i) {
		var ref;

		// render array pass as a list of passes
		if (s && Array.isArray(s)) { return (ref = this$1).draw.apply(ref, s) }

		if (typeof s === 'number') { s = this$1.passes[s] }

		if (!(s && s.count > 1 && s.opacity)) { return }

		this$1.regl._refresh()

		if (s.fill && s.triangles && s.triangles.length > 2) {
			this$1.shaders.fill(s)
		}

		if (!s.thickness) { return }

		// high scale is only available for rect mode with precision
		if (s.scale[0] * s.viewport.width > Line2D.precisionThreshold || s.scale[1] * s.viewport.height > Line2D.precisionThreshold) {
			this$1.shaders.rect(s)
		}

		// thin this.passes or too many points are rendered as simplified rect shader
		else if (s.join === 'rect' || (!s.join && (s.thickness <= 2 || s.count >= Line2D.maxPoints))) {
			this$1.shaders.rect(s)
		}
		else {
			this$1.shaders.miter(s)
		}
	})

	return this
}

Line2D.prototype.update = function (options) {
	var this$1 = this;

	if (!options) { return }

	if (options.length != null) {
		if (typeof options[0] === 'number') { options = [{positions: options}] }
	}

	// make options a batch
	else if (!Array.isArray(options)) { options = [options] }

	var ref = this;
	var regl = ref.regl;
	var gl = ref.gl;

	// process per-line settings
	options.forEach(function (o, i) {
		var state = this$1.passes[i]

		if (o === undefined) { return }

		// null-argument removes pass
		if (o === null) {
			this$1.passes[i] = null
			return
		}

		if (typeof o[0] === 'number') { o = {positions: o} }

		// handle aliases
		o = pick(o, {
			positions: 'positions points data coords',
			thickness: 'thickness lineWidth lineWidths line-width linewidth width stroke-width strokewidth strokeWidth',
			join: 'lineJoin linejoin join type mode',
			miterLimit: 'miterlimit miterLimit',
			dashes: 'dash dashes dasharray dash-array dashArray',
			color: 'color colour stroke colors colours stroke-color strokeColor',
			fill: 'fill fill-color fillColor',
			opacity: 'alpha opacity',
			overlay: 'overlay crease overlap intersect',
			close: 'closed close closed-path closePath',
			range: 'range dataBox',
			viewport: 'viewport viewBox',
			hole: 'holes hole hollow',
			splitNull: 'splitNull'
		})

		// init state
		if (!state) {
			this$1.passes[i] = state = {
				id: i,
				scale: null,
				scaleFract: null,
				translate: null,
				translateFract: null,
				count: 0,
				hole: [],
				depth: 0,

				dashLength: 1,
				dashTexture: regl.texture({
					channels: 1,
					data: new Uint8Array([255]),
					width: 1,
					height: 1,
					mag: 'linear',
					min: 'linear'
				}),

				colorBuffer: regl.buffer({
					usage: 'dynamic',
					type: 'uint8',
					data: new Uint8Array()
				}),
				positionBuffer: regl.buffer({
					usage: 'dynamic',
					type: 'float',
					data: new Uint8Array()
				}),
				positionFractBuffer: regl.buffer({
					usage: 'dynamic',
					type: 'float',
					data: new Uint8Array()
				})
			}

			o = extend({}, Line2D.defaults, o)
		}
		if (o.thickness != null) { state.thickness = parseFloat(o.thickness) }
		if (o.opacity != null) { state.opacity = parseFloat(o.opacity) }
		if (o.miterLimit != null) { state.miterLimit = parseFloat(o.miterLimit) }
		if (o.overlay != null) {
			state.overlay = !!o.overlay
			if (i < Line2D.maxLines) {
				state.depth = 2 * (Line2D.maxLines - 1 - i % Line2D.maxLines) / Line2D.maxLines - 1.;
			}
		}
		if (o.join != null) { state.join = o.join }
		if (o.hole != null) { state.hole = o.hole }
		if (o.fill != null) { state.fill = !o.fill ? null : rgba(o.fill, 'uint8') }
		if (o.viewport != null) { state.viewport = parseRect(o.viewport) }

		if (!state.viewport) {
			state.viewport = parseRect([
				gl.drawingBufferWidth,
				gl.drawingBufferHeight
			])
		}

		if (o.close != null) { state.close = o.close }

		// reset positions
		if (o.positions === null) { o.positions = [] }
		if (o.positions) {
			var positions, count

			// if positions are an object with x/y
			if (o.positions.x && o.positions.y) {
				var xPos = o.positions.x
				var yPos = o.positions.y
				count = state.count = Math.max(
					xPos.length,
					yPos.length
				)
				positions = new Float64Array(count * 2)
				for (var i$1 = 0; i$1 < count; i$1++) {
					positions[i$1 * 2] = xPos[i$1]
					positions[i$1 * 2 + 1] = yPos[i$1]
				}
			}
			else {
				positions = flatten(o.positions, 'float64')
				count = state.count = Math.floor(positions.length / 2)
			}

			var bounds = state.bounds = getBounds(positions, 2)

			// create fill positions
			// FIXME: fill positions can be set only along with positions
			if (state.fill) {
				var pos = []

				// filter bad vertices and remap triangles to ensure shape
				var ids = {}
				var lastId = 0

				for (var i$2 = 0, ptr = 0, l = state.count; i$2 < l; i$2++) {
					var x = positions[i$2*2]
					var y = positions[i$2*2 + 1]
					if (isNaN(x) || isNaN(y) || x == null || y == null) {
						x = positions[lastId*2]
						y = positions[lastId*2 + 1]
						ids[i$2] = lastId
					}
					else {
						lastId = i$2
					}
					pos[ptr++] = x
					pos[ptr++] = y
				}

				// split the input into multiple polygon at Null/NaN
				if(o.splitNull){
					// use "ids" to track the boundary of segment
					// the keys in "ids" is the end boundary of a segment, or split point

					// make sure there is at least one segment
					if(!(state.count-1 in ids)) { ids[state.count] = state.count-1 }

					var splits = Object.keys(ids).map(Number).sort(function (a, b) { return a - b; })

					var split_triangles = []
					var base = 0

					// do not split holes
					var hole_base = state.hole != null ? state.hole[0] : null
					if(hole_base != null){
						var last_id = findIndex(splits, function (e){ return e>=hole_base; })
						splits = splits.slice(0,last_id)
						splits.push(hole_base)
					}

					var loop = function ( i ) {
						// create temporary pos array with only one segment and all the holes
						var seg_pos = pos.slice(base*2, splits[i]*2).concat(
							hole_base ? pos.slice(hole_base*2) : []
						)
						var hole = (state.hole || []).map(function (e) { return e-hole_base+(splits[i]-base); } )
						var triangles = triangulate(seg_pos, hole)
						// map triangle index back to the original pos buffer
						triangles = triangles.map(
							function (e){ return e + base + ((e + base < splits[i]) ? 0 : hole_base - splits[i]); }
						)
						split_triangles.push.apply(split_triangles, triangles)

						// skip split point
						base = splits[i] + 1
					};

					for (var i$3 = 0; i$3 < splits.length; i$3++)
					loop( i$3 );
					for (var i$4 = 0, l$1 = split_triangles.length; i$4 < l$1; i$4++) {
						if (ids[split_triangles[i$4]] != null) { split_triangles[i$4] = ids[split_triangles[i$4]] }
					}

					state.triangles = split_triangles
				}
				else {
					// treat the wholw input as a single polygon
					var triangles$1 = triangulate(pos, state.hole || [])

					for (var i$5 = 0, l$2 = triangles$1.length; i$5 < l$2; i$5++) {
						if (ids[triangles$1[i$5]] != null) { triangles$1[i$5] = ids[triangles$1[i$5]] }
					}

					state.triangles = triangles$1
				}
			}

			// update position buffers
			var npos = new Float64Array(positions)
			normalize(npos, 2, bounds)

			var positionData = new Float64Array(count * 2 + 6)

			// rotate first segment join
			if (state.close) {
				if (positions[0] === positions[count*2 - 2] &&
					positions[1] === positions[count*2 - 1]) {
					positionData[0] = npos[count*2 - 4]
					positionData[1] = npos[count*2 - 3]
				}
				else {
					positionData[0] = npos[count*2 - 2]
					positionData[1] = npos[count*2 - 1]
				}
			}
			else {
				positionData[0] = npos[0]
				positionData[1] = npos[1]
			}

			positionData.set(npos, 2)

			// add last segment
			if (state.close) {
				// ignore coinciding start/end
				if (positions[0] === positions[count*2 - 2] &&
					positions[1] === positions[count*2 - 1]) {
					positionData[count*2 + 2] = npos[2]
					positionData[count*2 + 3] = npos[3]
					state.count -= 1
				}
				else {
					positionData[count*2 + 2] = npos[0]
					positionData[count*2 + 3] = npos[1]
					positionData[count*2 + 4] = npos[2]
					positionData[count*2 + 5] = npos[3]
				}
			}
			// add stub
			else {
				positionData[count*2 + 2] = npos[count*2 - 2]
				positionData[count*2 + 3] = npos[count*2 - 1]
				positionData[count*2 + 4] = npos[count*2 - 2]
				positionData[count*2 + 5] = npos[count*2 - 1]
			}

			var float_data = float32(positionData)
			state.positionBuffer(float_data)
			var frac_data = fract32(positionData, float_data)
			state.positionFractBuffer(frac_data)
		}

		if (o.range) {
			state.range = o.range
		} else if (!state.range) {
			state.range = state.bounds
		}

		if ((o.range || o.positions) && state.count) {
			var bounds$1 = state.bounds

			var boundsW = bounds$1[2] - bounds$1[0],
				boundsH = bounds$1[3] - bounds$1[1]

			var rangeW = state.range[2] - state.range[0],
				rangeH = state.range[3] - state.range[1]

			state.scale = [
				boundsW / rangeW,
				boundsH / rangeH
			]
			state.translate = [
				-state.range[0] / rangeW + bounds$1[0] / rangeW || 0,
				-state.range[1] / rangeH + bounds$1[1] / rangeH || 0
			]

			state.scaleFract = fract32(state.scale)
			state.translateFract = fract32(state.translate)
		}

		if (o.dashes) {
			var dashLength = 0., dashData

			if (!o.dashes || o.dashes.length < 2) {
				dashLength = 1.
				dashData = new Uint8Array([255, 255, 255, 255, 255, 255, 255, 255])
			}

			else {
				dashLength = 0.;
				for(var i$6 = 0; i$6 < o.dashes.length; ++i$6) {
					dashLength += o.dashes[i$6]
				}
				dashData = new Uint8Array(dashLength * Line2D.dashMult)
				var ptr$1 = 0
				var fillColor = 255

				// repeat texture two times to provide smooth 0-step
				for (var k = 0; k < 2; k++) {
					for(var i$7 = 0; i$7 < o.dashes.length; ++i$7) {
						for(var j = 0, l$3 = o.dashes[i$7] * Line2D.dashMult * .5; j < l$3; ++j) {
							dashData[ptr$1++] = fillColor
						}
						fillColor ^= 255
					}
				}
			}

			state.dashLength = dashLength
			state.dashTexture({
				channels: 1,
				data: dashData,
				width: dashData.length,
				height: 1,
				mag: 'linear',
				min: 'linear'
			}, 0, 0)
		}

		if (o.color) {
			var count$1 = state.count
			var colors = o.color

			if (!colors) { colors = 'transparent' }

			var colorData = new Uint8Array(count$1 * 4 + 4)

			// convert colors to typed arrays
			if (!Array.isArray(colors) || typeof colors[0] === 'number') {
				var c = rgba(colors, 'uint8')

				for (var i$8 = 0; i$8 < count$1 + 1; i$8++) {
					colorData.set(c, i$8 * 4)
				}
			} else {
				for (var i$9 = 0; i$9 < count$1; i$9++) {
					var c$1 = rgba(colors[i$9], 'uint8')
					colorData.set(c$1, i$9 * 4)
				}
				colorData.set(rgba(colors[0], 'uint8'), count$1 * 4)
			}

			state.colorBuffer({
				usage: 'dynamic',
				type: 'uint8',
				data: colorData
			})
		}
	})

	// remove unmentioned passes
	if (options.length < this.passes.length) {
		for (var i = options.length; i < this.passes.length; i++) {
			var pass = this.passes[i]
			if (!pass) { continue }
			pass.colorBuffer.destroy()
			pass.positionBuffer.destroy()
			pass.dashTexture.destroy()
		}
		this.passes.length = options.length
	}

	// remove null items
	var passes = []
	for (var i$1 = 0; i$1 < this.passes.length; i$1++) {
		if (this.passes[i$1] !== null) { passes.push(this.passes[i$1]) }
	}
	this.passes = passes

	return this
}

Line2D.prototype.destroy = function () {
	this.passes.forEach(function (pass) {
		pass.colorBuffer.destroy()
		pass.positionBuffer.destroy()
		pass.dashTexture.destroy()
	})

	this.passes.length = 0

	return this
}

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 62172:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var rgba = __webpack_require__(162);
var getBounds = __webpack_require__(78112);
var colorId = __webpack_require__(46762);
var cluster = __webpack_require__(27549);
var extend = __webpack_require__(27976);
var glslify = __webpack_require__(76765);
var pick = __webpack_require__(6807);
var updateDiff = __webpack_require__(79788);
var flatten = __webpack_require__(83473);
var ie = __webpack_require__(39488);
var f32 = __webpack_require__(51498);
var parseRect = __webpack_require__(5137);
var scatter = Scatter;
function Scatter(regl, options) {
  var _this = this;
  if (!(this instanceof Scatter)) return new Scatter(regl, options);
  if (typeof regl === 'function') {
    if (!options) options = {};
    options.regl = regl;
  } else {
    options = regl;
    regl = null;
  }
  if (options && options.length) options.positions = options;
  regl = options.regl;

  // persistent variables
  var gl = regl._gl,
    paletteTexture,
    palette = [],
    paletteIds = {},
    // state
    groups = [],
    // textures for marker keys
    markerTextures = [null],
    markerCache = [null];
  var maxColors = 255,
    maxSize = 100;

  // direct color buffer mode
  // IE does not support palette anyways
  this.tooManyColors = ie;

  // texture with color palette
  paletteTexture = regl.texture({
    data: new Uint8Array(maxColors * 4),
    width: maxColors,
    height: 1,
    type: 'uint8',
    format: 'rgba',
    wrapS: 'clamp',
    wrapT: 'clamp',
    mag: 'nearest',
    min: 'nearest'
  });
  extend(this, {
    regl: regl,
    gl: gl,
    groups: groups,
    markerCache: markerCache,
    markerTextures: markerTextures,
    palette: palette,
    paletteIds: paletteIds,
    paletteTexture: paletteTexture,
    maxColors: maxColors,
    maxSize: maxSize,
    canvas: gl.canvas
  });
  this.update(options);

  // common shader options
  var shaderOptions = {
    uniforms: {
      constPointSize: !!options.constPointSize,
      opacity: regl.prop('opacity'),
      paletteSize: function paletteSize(ctx, prop) {
        return [_this.tooManyColors ? 0 : maxColors, paletteTexture.height];
      },
      pixelRatio: regl.context('pixelRatio'),
      scale: regl.prop('scale'),
      scaleFract: regl.prop('scaleFract'),
      translate: regl.prop('translate'),
      translateFract: regl.prop('translateFract'),
      markerTexture: regl.prop('markerTexture'),
      paletteTexture: paletteTexture
    },
    attributes: {
      // FIXME: optimize these parts
      x: function x(ctx, prop) {
        return prop.xAttr || {
          buffer: prop.positionBuffer,
          stride: 8,
          offset: 0
        };
      },
      y: function y(ctx, prop) {
        return prop.yAttr || {
          buffer: prop.positionBuffer,
          stride: 8,
          offset: 4
        };
      },
      xFract: function xFract(ctx, prop) {
        return prop.xAttr ? {
          constant: [0, 0]
        } : {
          buffer: prop.positionFractBuffer,
          stride: 8,
          offset: 0
        };
      },
      yFract: function yFract(ctx, prop) {
        return prop.yAttr ? {
          constant: [0, 0]
        } : {
          buffer: prop.positionFractBuffer,
          stride: 8,
          offset: 4
        };
      },
      size: function size(ctx, prop) {
        return prop.size.length ? {
          buffer: prop.sizeBuffer,
          stride: 2,
          offset: 0
        } : {
          constant: [Math.round(prop.size * 255 / _this.maxSize)]
        };
      },
      borderSize: function borderSize(ctx, prop) {
        return prop.borderSize.length ? {
          buffer: prop.sizeBuffer,
          stride: 2,
          offset: 1
        } : {
          constant: [Math.round(prop.borderSize * 255 / _this.maxSize)]
        };
      },
      colorId: function colorId(ctx, prop) {
        return prop.color.length ? {
          buffer: prop.colorBuffer,
          stride: _this.tooManyColors ? 8 : 4,
          offset: 0
        } : {
          constant: _this.tooManyColors ? palette.slice(prop.color * 4, prop.color * 4 + 4) : [prop.color]
        };
      },
      borderColorId: function borderColorId(ctx, prop) {
        return prop.borderColor.length ? {
          buffer: prop.colorBuffer,
          stride: _this.tooManyColors ? 8 : 4,
          offset: _this.tooManyColors ? 4 : 2
        } : {
          constant: _this.tooManyColors ? palette.slice(prop.borderColor * 4, prop.borderColor * 4 + 4) : [prop.borderColor]
        };
      },
      isActive: function isActive(ctx, prop) {
        return prop.activation === true ? {
          constant: [1]
        } : prop.activation ? prop.activation : {
          constant: [0]
        };
      }
    },
    blend: {
      enable: true,
      color: [0, 0, 0, 1],
      // photoshop blending
      func: {
        srcRGB: 'src alpha',
        dstRGB: 'one minus src alpha',
        srcAlpha: 'one minus dst alpha',
        dstAlpha: 'one'
      }
    },
    scissor: {
      enable: true,
      box: regl.prop('viewport')
    },
    viewport: regl.prop('viewport'),
    stencil: {
      enable: false
    },
    depth: {
      enable: false
    },
    elements: regl.prop('elements'),
    count: regl.prop('count'),
    offset: regl.prop('offset'),
    primitive: 'points'
  };

  // draw sdf-marker
  var markerOptions = extend({}, shaderOptions);
  markerOptions.frag = glslify(["precision highp float;\n#define GLSLIFY 1\n\nuniform float opacity;\nuniform sampler2D markerTexture;\n\nvarying vec4 fragColor, fragBorderColor;\nvarying float fragWidth, fragBorderColorLevel, fragColorLevel;\n\nfloat smoothStep(float x, float y) {\n  return 1.0 / (1.0 + exp(50.0*(x - y)));\n}\n\nvoid main() {\n  float dist = texture2D(markerTexture, gl_PointCoord).r, delta = fragWidth;\n\n  // max-distance alpha\n  if (dist < 0.003) discard;\n\n  // null-border case\n  if (fragBorderColorLevel == fragColorLevel || fragBorderColor.a == 0.) {\n    float colorAmt = smoothstep(.5 - delta, .5 + delta, dist);\n    gl_FragColor = vec4(fragColor.rgb, colorAmt * fragColor.a * opacity);\n  }\n  else {\n    float borderColorAmt = smoothstep(fragBorderColorLevel - delta, fragBorderColorLevel + delta, dist);\n    float colorAmt = smoothstep(fragColorLevel - delta, fragColorLevel + delta, dist);\n\n    vec4 color = fragBorderColor;\n    color.a *= borderColorAmt;\n    color = mix(color, fragColor, colorAmt);\n    color.a *= opacity;\n\n    gl_FragColor = color;\n  }\n\n}\n"]);
  markerOptions.vert = glslify(["precision highp float;\n#define GLSLIFY 1\n\nattribute float x, y, xFract, yFract;\nattribute float size, borderSize;\nattribute vec4 colorId, borderColorId;\nattribute float isActive;\n\n// `invariant` effectively turns off optimizations for the position.\n// We need this because -fast-math on M1 Macs is re-ordering\n// floating point operations in a way that causes floating point\n// precision limits to put points in the wrong locations.\ninvariant gl_Position;\n\nuniform bool constPointSize;\nuniform float pixelRatio;\nuniform vec2 scale, scaleFract, translate, translateFract, paletteSize;\nuniform sampler2D paletteTexture;\n\nconst float maxSize = 100.;\nconst float borderLevel = .5;\n\nvarying vec4 fragColor, fragBorderColor;\nvarying float fragPointSize, fragBorderRadius, fragWidth, fragBorderColorLevel, fragColorLevel;\n\nfloat pointSizeScale = (constPointSize) ? 2. : pixelRatio;\n\nbool isDirect = (paletteSize.x < 1.);\n\nvec4 getColor(vec4 id) {\n  return isDirect ? id / 255. : texture2D(paletteTexture,\n    vec2(\n      (id.x + .5) / paletteSize.x,\n      (id.y + .5) / paletteSize.y\n    )\n  );\n}\n\nvoid main() {\n  // ignore inactive points\n  if (isActive == 0.) return;\n\n  vec2 position = vec2(x, y);\n  vec2 positionFract = vec2(xFract, yFract);\n\n  vec4 color = getColor(colorId);\n  vec4 borderColor = getColor(borderColorId);\n\n  float size = size * maxSize / 255.;\n  float borderSize = borderSize * maxSize / 255.;\n\n  gl_PointSize = 2. * size * pointSizeScale;\n  fragPointSize = size * pixelRatio;\n\n  vec2 pos = (position + translate) * scale\n      + (positionFract + translateFract) * scale\n      + (position + translate) * scaleFract\n      + (positionFract + translateFract) * scaleFract;\n\n  gl_Position = vec4(pos * 2. - 1., 0., 1.);\n\n  fragColor = color;\n  fragBorderColor = borderColor;\n  fragWidth = 1. / gl_PointSize;\n\n  fragBorderColorLevel = clamp(borderLevel - borderLevel * borderSize / size, 0., 1.);\n  fragColorLevel = clamp(borderLevel + (1. - borderLevel) * borderSize / size, 0., 1.);\n}\n"]);
  this.drawMarker = regl(markerOptions);

  // draw circle
  var circleOptions = extend({}, shaderOptions);
  circleOptions.frag = glslify(["precision highp float;\n#define GLSLIFY 1\n\nvarying vec4 fragColor, fragBorderColor;\nvarying float fragBorderRadius, fragWidth;\n\nuniform float opacity;\n\nfloat smoothStep(float edge0, float edge1, float x) {\n\tfloat t;\n\tt = clamp((x - edge0) / (edge1 - edge0), 0.0, 1.0);\n\treturn t * t * (3.0 - 2.0 * t);\n}\n\nvoid main() {\n\tfloat radius, alpha = 1.0, delta = fragWidth;\n\n\tradius = length(2.0 * gl_PointCoord.xy - 1.0);\n\n\tif (radius > 1.0 + delta) {\n\t\tdiscard;\n\t}\n\n\talpha -= smoothstep(1.0 - delta, 1.0 + delta, radius);\n\n\tfloat borderRadius = fragBorderRadius;\n\tfloat ratio = smoothstep(borderRadius - delta, borderRadius + delta, radius);\n\tvec4 color = mix(fragColor, fragBorderColor, ratio);\n\tcolor.a *= alpha * opacity;\n\tgl_FragColor = color;\n}\n"]);
  circleOptions.vert = glslify(["precision highp float;\n#define GLSLIFY 1\n\nattribute float x, y, xFract, yFract;\nattribute float size, borderSize;\nattribute vec4 colorId, borderColorId;\nattribute float isActive;\n\n// `invariant` effectively turns off optimizations for the position.\n// We need this because -fast-math on M1 Macs is re-ordering\n// floating point operations in a way that causes floating point\n// precision limits to put points in the wrong locations.\ninvariant gl_Position;\n\nuniform bool constPointSize;\nuniform float pixelRatio;\nuniform vec2 paletteSize, scale, scaleFract, translate, translateFract;\nuniform sampler2D paletteTexture;\n\nconst float maxSize = 100.;\n\nvarying vec4 fragColor, fragBorderColor;\nvarying float fragBorderRadius, fragWidth;\n\nfloat pointSizeScale = (constPointSize) ? 2. : pixelRatio;\n\nbool isDirect = (paletteSize.x < 1.);\n\nvec4 getColor(vec4 id) {\n  return isDirect ? id / 255. : texture2D(paletteTexture,\n    vec2(\n      (id.x + .5) / paletteSize.x,\n      (id.y + .5) / paletteSize.y\n    )\n  );\n}\n\nvoid main() {\n  // ignore inactive points\n  if (isActive == 0.) return;\n\n  vec2 position = vec2(x, y);\n  vec2 positionFract = vec2(xFract, yFract);\n\n  vec4 color = getColor(colorId);\n  vec4 borderColor = getColor(borderColorId);\n\n  float size = size * maxSize / 255.;\n  float borderSize = borderSize * maxSize / 255.;\n\n  gl_PointSize = (size + borderSize) * pointSizeScale;\n\n  vec2 pos = (position + translate) * scale\n      + (positionFract + translateFract) * scale\n      + (position + translate) * scaleFract\n      + (positionFract + translateFract) * scaleFract;\n\n  gl_Position = vec4(pos * 2. - 1., 0., 1.);\n\n  fragBorderRadius = 1. - 2. * borderSize / (size + borderSize);\n  fragColor = color;\n  fragBorderColor = borderColor.a == 0. || borderSize == 0. ? vec4(color.rgb, 0.) : borderColor;\n  fragWidth = 1. / gl_PointSize;\n}\n"]);

  // polyfill IE
  if (ie) {
    circleOptions.frag = circleOptions.frag.replace('smoothstep', 'smoothStep');
    markerOptions.frag = markerOptions.frag.replace('smoothstep', 'smoothStep');
  }
  this.drawCircle = regl(circleOptions);
}

// single pass defaults
Scatter.defaults = {
  color: 'black',
  borderColor: 'transparent',
  borderSize: 0,
  size: 12,
  opacity: 1,
  marker: undefined,
  viewport: null,
  range: null,
  pixelSize: null,
  count: 0,
  offset: 0,
  bounds: null,
  positions: [],
  snap: 1e4
};

// update & redraw
Scatter.prototype.render = function () {
  if (arguments.length) {
    this.update.apply(this, arguments);
  }
  this.draw();
  return this;
};

// draw all groups or only indicated ones
Scatter.prototype.draw = function () {
  var _this2 = this;
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var groups = this.groups;

  // if directly array passed - treat as passes
  if (args.length === 1 && Array.isArray(args[0]) && (args[0][0] === null || Array.isArray(args[0][0]))) {
    args = args[0];
  }

  // FIXME: remove once https://github.com/regl-project/regl/issues/474 resolved
  this.regl._refresh();
  if (args.length) {
    for (var i = 0; i < args.length; i++) {
      this.drawItem(i, args[i]);
    }
  }
  // draw all passes
  else {
    groups.forEach(function (group, i) {
      _this2.drawItem(i);
    });
  }
  return this;
};

// draw specific scatter group
Scatter.prototype.drawItem = function (id, els) {
  var groups = this.groups;
  var group = groups[id];

  // debug viewport
  // let { viewport } = group
  // gl.enable(gl.SCISSOR_TEST);
  // gl.scissor(viewport.x, viewport.y, viewport.width, viewport.height);
  // gl.clearColor(0, 0, 0, .5);
  // gl.clear(gl.COLOR_BUFFER_BIT);

  if (typeof els === 'number') {
    id = els;
    group = groups[els];
    els = null;
  }
  if (!(group && group.count && group.opacity)) return;

  // draw circles
  if (group.activation[0]) {
    // TODO: optimize this performance by making groups and regl.this props
    this.drawCircle(this.getMarkerDrawOptions(0, group, els));
  }

  // draw all other available markers
  var batch = [];
  for (var i = 1; i < group.activation.length; i++) {
    if (!group.activation[i] || group.activation[i] !== true && !group.activation[i].data.length) continue;
    batch.push.apply(batch, _toConsumableArray(this.getMarkerDrawOptions(i, group, els)));
  }
  if (batch.length) {
    this.drawMarker(batch);
  }
};

// get options for the marker ids
Scatter.prototype.getMarkerDrawOptions = function (markerId, group, elements) {
  var range = group.range,
    tree = group.tree,
    viewport = group.viewport,
    activation = group.activation,
    selectionBuffer = group.selectionBuffer,
    count = group.count;
  var regl = this.regl;

  // direct points
  if (!tree) {
    // if elements array - draw unclustered points
    if (elements) {
      return [extend({}, group, {
        markerTexture: this.markerTextures[markerId],
        activation: activation[markerId],
        count: elements.length,
        elements: elements,
        offset: 0
      })];
    }
    return [extend({}, group, {
      markerTexture: this.markerTextures[markerId],
      activation: activation[markerId],
      offset: 0
    })];
  }

  // clustered points
  var batch = [];
  var lod = tree.range(range, {
    lod: true,
    px: [(range[2] - range[0]) / viewport.width, (range[3] - range[1]) / viewport.height]
  });

  // enable elements by using selection buffer
  if (elements) {
    var markerActivation = activation[markerId];
    var mask = markerActivation.data;
    var data = new Uint8Array(count);
    for (var i = 0; i < elements.length; i++) {
      var id = elements[i];
      data[id] = mask ? mask[id] : 1;
    }
    selectionBuffer.subdata(data);
  }
  for (var l = lod.length; l--;) {
    var _lod$l = _slicedToArray(lod[l], 2),
      from = _lod$l[0],
      to = _lod$l[1];
    batch.push(extend({}, group, {
      markerTexture: this.markerTextures[markerId],
      activation: elements ? selectionBuffer : activation[markerId],
      offset: from,
      count: to - from
    }));
  }
  return batch;
};

// update groups options
Scatter.prototype.update = function () {
  var _this3 = this;
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }
  if (!args.length) return;

  // passes are as single array
  if (args.length === 1 && Array.isArray(args[0])) args = args[0];
  var groups = this.groups,
    gl = this.gl,
    regl = this.regl,
    maxSize = this.maxSize,
    maxColors = this.maxColors,
    palette = this.palette;
  this.groups = groups = args.map(function (options, i) {
    var group = groups[i];
    if (options === undefined) return group;
    if (options === null) options = {
      positions: null
    };else if (typeof options === 'function') options = {
      ondraw: options
    };else if (typeof options[0] === 'number') options = {
      positions: options
    };

    // copy options to avoid mutation & handle aliases
    options = pick(options, {
      positions: 'positions data points',
      snap: 'snap cluster lod tree',
      size: 'sizes size radius',
      borderSize: 'borderSizes borderSize border-size bordersize borderWidth borderWidths border-width borderwidth stroke-width strokeWidth strokewidth outline',
      color: 'colors color fill fill-color fillColor',
      borderColor: 'borderColors borderColor stroke stroke-color strokeColor',
      marker: 'markers marker shape',
      range: 'range dataBox databox',
      viewport: 'viewport viewPort viewBox viewbox',
      opacity: 'opacity alpha transparency',
      bounds: 'bound bounds boundaries limits',
      tooManyColors: 'tooManyColors palette paletteMode optimizePalette enablePalette'
    });
    if (options.positions === null) options.positions = [];
    if (options.tooManyColors != null) _this3.tooManyColors = options.tooManyColors;
    if (!group) {
      groups[i] = group = {
        id: i,
        scale: null,
        translate: null,
        scaleFract: null,
        translateFract: null,
        // buffers for active markers
        activation: [],
        // buffer for filtered markers
        selectionBuffer: regl.buffer({
          data: new Uint8Array(0),
          usage: 'stream',
          type: 'uint8'
        }),
        // buffers with data: it is faster to switch them per-pass
        // than provide one congregate buffer
        sizeBuffer: regl.buffer({
          data: new Uint8Array(0),
          usage: 'dynamic',
          type: 'uint8'
        }),
        colorBuffer: regl.buffer({
          data: new Uint8Array(0),
          usage: 'dynamic',
          type: 'uint8'
        }),
        positionBuffer: regl.buffer({
          data: new Uint8Array(0),
          usage: 'dynamic',
          type: 'float'
        }),
        positionFractBuffer: regl.buffer({
          data: new Uint8Array(0),
          usage: 'dynamic',
          type: 'float'
        })
      };
      options = extend({}, Scatter.defaults, options);
    }

    // force update triggers
    if (options.positions && !('marker' in options)) {
      options.marker = group.marker;
      delete group.marker;
    }

    // updating markers cause recalculating snapping
    if (options.marker && !('positions' in options)) {
      options.positions = group.positions;
      delete group.positions;
    }

    // global count of points
    var hasSize = 0,
      hasColor = 0;
    updateDiff(group, options, [{
      snap: true,
      size: function size(s, group) {
        if (s == null) s = Scatter.defaults.size;
        hasSize += s && s.length ? 1 : 0;
        return s;
      },
      borderSize: function borderSize(s, group) {
        if (s == null) s = Scatter.defaults.borderSize;
        hasSize += s && s.length ? 1 : 0;
        return s;
      },
      opacity: parseFloat,
      // add colors to palette, save references
      color: function color(c, group) {
        if (c == null) c = Scatter.defaults.color;
        c = _this3.updateColor(c);
        hasColor++;
        return c;
      },
      borderColor: function borderColor(c, group) {
        if (c == null) c = Scatter.defaults.borderColor;
        c = _this3.updateColor(c);
        hasColor++;
        return c;
      },
      bounds: function bounds(_bounds, group, options) {
        if (!('range' in options)) options.range = null;
        return _bounds;
      },
      positions: function positions(_positions, group, options) {
        var snap = group.snap;
        var positionBuffer = group.positionBuffer,
          positionFractBuffer = group.positionFractBuffer,
          selectionBuffer = group.selectionBuffer;

        // separate buffers for x/y coordinates
        if (_positions.x || _positions.y) {
          if (_positions.x.length) {
            group.xAttr = {
              buffer: regl.buffer(_positions.x),
              offset: 0,
              stride: 4,
              count: _positions.x.length
            };
          } else {
            group.xAttr = {
              buffer: _positions.x.buffer,
              offset: _positions.x.offset * 4 || 0,
              stride: (_positions.x.stride || 1) * 4,
              count: _positions.x.count
            };
          }
          if (_positions.y.length) {
            group.yAttr = {
              buffer: regl.buffer(_positions.y),
              offset: 0,
              stride: 4,
              count: _positions.y.length
            };
          } else {
            group.yAttr = {
              buffer: _positions.y.buffer,
              offset: _positions.y.offset * 4 || 0,
              stride: (_positions.y.stride || 1) * 4,
              count: _positions.y.count
            };
          }
          group.count = Math.max(group.xAttr.count, group.yAttr.count);
          return _positions;
        }
        _positions = flatten(_positions, 'float64');
        var count = group.count = Math.floor(_positions.length / 2);
        var bounds = group.bounds = count ? getBounds(_positions, 2) : null;

        // if range is not provided updated - recalc it
        if (!options.range && !group.range) {
          delete group.range;
          options.range = bounds;
        }

        // reset marker
        if (!options.marker && !group.marker) {
          delete group.marker;
          options.marker = null;
        }

        // build cluster tree if required
        if (snap && (snap === true || count > snap)) {
          group.tree = cluster(_positions, {
            bounds: bounds
          });
        }
        // existing tree instance
        else if (snap && snap.length) {
          group.tree = snap;
        }
        if (group.tree) {
          var opts = {
            primitive: 'points',
            usage: 'static',
            data: group.tree,
            type: 'uint32'
          };
          if (group.elements) group.elements(opts);else group.elements = regl.elements(opts);
        }

        // update position buffers
        var float_data = f32.float32(_positions);
        positionBuffer({
          data: float_data,
          usage: 'dynamic'
        });
        var frac_data = f32.fract32(_positions, float_data);
        positionFractBuffer({
          data: frac_data,
          usage: 'dynamic'
        });

        // expand selectionBuffer
        selectionBuffer({
          data: new Uint8Array(count),
          type: 'uint8',
          usage: 'stream'
        });
        return _positions;
      }
    }, {
      // create marker ids corresponding to known marker textures
      marker: function marker(markers, group, options) {
        var activation = group.activation;

        // reset marker elements
        activation.forEach(function (buffer) {
          return buffer && buffer.destroy && buffer.destroy();
        });
        activation.length = 0;

        // single sdf marker
        if (!markers || typeof markers[0] === 'number') {
          var id = _this3.addMarker(markers);
          activation[id] = true;
        }

        // per-point markers use mask buffers to enable markers in vert shader
        else {
          var markerMasks = [];
          for (var _i = 0, l = Math.min(markers.length, group.count); _i < l; _i++) {
            var _id = _this3.addMarker(markers[_i]);
            if (!markerMasks[_id]) markerMasks[_id] = new Uint8Array(group.count);

            // enable marker by default
            markerMasks[_id][_i] = 1;
          }
          for (var _id2 = 0; _id2 < markerMasks.length; _id2++) {
            if (!markerMasks[_id2]) continue;
            var opts = {
              data: markerMasks[_id2],
              type: 'uint8',
              usage: 'static'
            };
            if (!activation[_id2]) {
              activation[_id2] = regl.buffer(opts);
            } else {
              activation[_id2](opts);
            }
            activation[_id2].data = markerMasks[_id2];
          }
        }
        return markers;
      },
      range: function range(_range, group, options) {
        var bounds = group.bounds;

        // FIXME: why do we need this?
        if (!bounds) return;
        if (!_range) _range = bounds;
        group.scale = [1 / (_range[2] - _range[0]), 1 / (_range[3] - _range[1])];
        group.translate = [-_range[0], -_range[1]];
        group.scaleFract = f32.fract(group.scale);
        group.translateFract = f32.fract(group.translate);
        return _range;
      },
      viewport: function viewport(vp) {
        var rect = parseRect(vp || [gl.drawingBufferWidth, gl.drawingBufferHeight]);

        // normalize viewport to the canvas coordinates
        // rect.y = gl.drawingBufferHeight - rect.height - rect.y

        return rect;
      }
    }]);

    // update size buffer, if needed
    if (hasSize) {
      var _group = group,
        count = _group.count,
        size = _group.size,
        borderSize = _group.borderSize,
        sizeBuffer = _group.sizeBuffer;
      var sizes = new Uint8Array(count * 2);
      if (size.length || borderSize.length) {
        for (var _i2 = 0; _i2 < count; _i2++) {
          // we downscale size to allow for fractions
          sizes[_i2 * 2] = Math.round((size[_i2] == null ? size : size[_i2]) * 255 / maxSize);
          sizes[_i2 * 2 + 1] = Math.round((borderSize[_i2] == null ? borderSize : borderSize[_i2]) * 255 / maxSize);
        }
      }
      sizeBuffer({
        data: sizes,
        usage: 'dynamic'
      });
    }

    // update color buffer if needed
    if (hasColor) {
      var _group2 = group,
        _count = _group2.count,
        color = _group2.color,
        borderColor = _group2.borderColor,
        colorBuffer = _group2.colorBuffer;
      var colors;

      // if too many colors - put colors to buffer directly
      if (_this3.tooManyColors) {
        if (color.length || borderColor.length) {
          colors = new Uint8Array(_count * 8);
          for (var _i3 = 0; _i3 < _count; _i3++) {
            var _colorId = color[_i3];
            colors[_i3 * 8] = palette[_colorId * 4];
            colors[_i3 * 8 + 1] = palette[_colorId * 4 + 1];
            colors[_i3 * 8 + 2] = palette[_colorId * 4 + 2];
            colors[_i3 * 8 + 3] = palette[_colorId * 4 + 3];
            var borderColorId = borderColor[_i3];
            colors[_i3 * 8 + 4] = palette[borderColorId * 4];
            colors[_i3 * 8 + 5] = palette[borderColorId * 4 + 1];
            colors[_i3 * 8 + 6] = palette[borderColorId * 4 + 2];
            colors[_i3 * 8 + 7] = palette[borderColorId * 4 + 3];
          }
        }
      }

      // if limited amount of colors - keep palette color picking
      // that saves significant memory
      else {
        if (color.length || borderColor.length) {
          // we need slight data increase by 2 due to vec4 borderId in shader
          colors = new Uint8Array(_count * 4 + 2);
          for (var _i4 = 0; _i4 < _count; _i4++) {
            // put color coords in palette texture
            if (color[_i4] != null) {
              colors[_i4 * 4] = color[_i4] % maxColors;
              colors[_i4 * 4 + 1] = Math.floor(color[_i4] / maxColors);
            }
            if (borderColor[_i4] != null) {
              colors[_i4 * 4 + 2] = borderColor[_i4] % maxColors;
              colors[_i4 * 4 + 3] = Math.floor(borderColor[_i4] / maxColors);
            }
          }
        }
      }
      colorBuffer({
        data: colors || new Uint8Array(0),
        type: 'uint8',
        usage: 'dynamic'
      });
    }
    return group;
  });
};

// get (and create) marker texture id
Scatter.prototype.addMarker = function (sdf) {
  var markerTextures = this.markerTextures,
    regl = this.regl,
    markerCache = this.markerCache;
  var pos = sdf == null ? 0 : markerCache.indexOf(sdf);
  if (pos >= 0) return pos;

  // convert sdf to 0..255 range
  var distArr;
  if (sdf instanceof Uint8Array || sdf instanceof Uint8ClampedArray) {
    distArr = sdf;
  } else {
    distArr = new Uint8Array(sdf.length);
    for (var i = 0, l = sdf.length; i < l; i++) {
      distArr[i] = sdf[i] * 255;
    }
  }
  var radius = Math.floor(Math.sqrt(distArr.length));
  pos = markerTextures.length;
  markerCache.push(sdf);
  markerTextures.push(regl.texture({
    channels: 1,
    data: distArr,
    radius: radius,
    mag: 'linear',
    min: 'linear'
  }));
  return pos;
};

// register color to palette, return it's index or list of indexes
Scatter.prototype.updateColor = function (colors) {
  var paletteIds = this.paletteIds,
    palette = this.palette,
    maxColors = this.maxColors;
  if (!Array.isArray(colors)) {
    colors = [colors];
  }
  var idx = [];

  // if color groups - flatten them
  if (typeof colors[0] === 'number') {
    var grouped = [];
    if (Array.isArray(colors)) {
      for (var i = 0; i < colors.length; i += 4) {
        grouped.push(colors.slice(i, i + 4));
      }
    } else {
      for (var _i5 = 0; _i5 < colors.length; _i5 += 4) {
        grouped.push(colors.subarray(_i5, _i5 + 4));
      }
    }
    colors = grouped;
  }
  for (var _i6 = 0; _i6 < colors.length; _i6++) {
    var color = colors[_i6];
    color = rgba(color, 'uint8');
    var id = colorId(color, false);

    // if new color - save it
    if (paletteIds[id] == null) {
      var pos = palette.length;
      paletteIds[id] = Math.floor(pos / 4);
      palette[pos] = color[0];
      palette[pos + 1] = color[1];
      palette[pos + 2] = color[2];
      palette[pos + 3] = color[3];
    }
    idx[_i6] = paletteIds[id];
  }

  // detect if too many colors in palette
  if (!this.tooManyColors && palette.length > maxColors * 4) this.tooManyColors = true;

  // limit max color
  this.updatePalette(palette);

  // keep static index for single-color property
  return idx.length === 1 ? idx[0] : idx;
};
Scatter.prototype.updatePalette = function (palette) {
  if (this.tooManyColors) return;
  var maxColors = this.maxColors,
    paletteTexture = this.paletteTexture;
  var requiredHeight = Math.ceil(palette.length * .25 / maxColors);

  // pad data
  if (requiredHeight > 1) {
    palette = palette.slice();
    for (var i = palette.length * .25 % maxColors; i < requiredHeight * maxColors; i++) {
      palette.push(0, 0, 0, 0);
    }
  }

  // ensure height
  if (paletteTexture.height < requiredHeight) {
    paletteTexture.resize(maxColors, requiredHeight);
  }

  // update full data
  paletteTexture.subimage({
    width: Math.min(palette.length * .25, maxColors),
    height: requiredHeight,
    data: palette
  }, 0, 0);
};

// remove unused stuff
Scatter.prototype.destroy = function () {
  this.groups.forEach(function (group) {
    group.sizeBuffer.destroy();
    group.positionBuffer.destroy();
    group.positionFractBuffer.destroy();
    group.colorBuffer.destroy();
    group.activation.forEach(function (b) {
      return b && b.destroy && b.destroy();
    });
    group.selectionBuffer.destroy();
    if (group.elements) group.elements.destroy();
  });
  this.groups.length = 0;
  this.paletteTexture.destroy();
  this.markerTextures.forEach(function (txt) {
    return txt && txt.destroy && txt.destroy();
  });
  return this;
};

var extend$1 = __webpack_require__(27976);
var reglScatter2d = function reglScatter2d(regl, options) {
  var scatter$1 = new scatter(regl, options);
  var render = scatter$1.render.bind(scatter$1);

  // expose API
  extend$1(render, {
    render: render,
    update: scatter$1.update.bind(scatter$1),
    draw: scatter$1.draw.bind(scatter$1),
    destroy: scatter$1.destroy.bind(scatter$1),
    regl: scatter$1.regl,
    gl: scatter$1.gl,
    canvas: scatter$1.gl.canvas,
    groups: scatter$1.groups,
    markers: scatter$1.markerCache,
    palette: scatter$1.palette
  });
  return render;
};

module.exports = reglScatter2d;


/***/ }),

/***/ 31239:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";



var createScatter = __webpack_require__(62172)
var pick = __webpack_require__(6807)
var getBounds = __webpack_require__(78112)
var raf = __webpack_require__(16494)
var arrRange = __webpack_require__(27902)
var rect = __webpack_require__(5137)
var flatten = __webpack_require__(83473)


module.exports = SPLOM


// @constructor
function SPLOM (regl, options) {
	if (!(this instanceof SPLOM)) { return new SPLOM(regl, options) }

	// render passes
	this.traces = []

	// passes for scatter, combined across traces
	this.passes = {}

	this.regl = regl

	// main scatter drawing instance
	this.scatter = createScatter(regl)

	this.canvas = this.scatter.canvas
}


// update & draw passes once per frame
SPLOM.prototype.render = function () {
	var this$1 = this;
	var ref;

	var args = [], len = arguments.length;
	while ( len-- ) args[ len ] = arguments[ len ];
	if (args.length) {
		(ref = this).update.apply(ref, args)
	}

	if (this.regl.attributes.preserveDrawingBuffer) { return this.draw() }

	// make sure draw is not called more often than once a frame
	if (this.dirty) {
		if (this.planned == null) {
			this.planned = raf(function () {
				this$1.draw()
				this$1.dirty = true
				this$1.planned = null
			})
		}
	}
	else {
		this.draw()
		this.dirty = true
		raf(function () {
			this$1.dirty = false
		})
	}

	return this
}


// update passes
SPLOM.prototype.update = function () {
	var ref;

	var args = [], len = arguments.length;
	while ( len-- ) args[ len ] = arguments[ len ];
	if (!args.length) { return }

	for (var i = 0; i < args.length; i++) {
		this.updateItem(i, args[i])
	}

	// remove nulled passes
	this.traces = this.traces.filter(Boolean)

	// FIXME: update passes independently
	var passes = []
	var offset = 0
	for (var i$1 = 0; i$1 < this.traces.length; i$1++) {
		var trace = this.traces[i$1]
		var tracePasses = this.traces[i$1].passes
		for (var j = 0; j < tracePasses.length; j++) {
			passes.push(this.passes[tracePasses[j]])
		}
		// save offset of passes
		trace.passOffset = offset
		offset += trace.passes.length
	}

	(ref = this.scatter).update.apply(ref, passes)

	return this
}


// update trace by index, not supposed to be called directly
SPLOM.prototype.updateItem = function (i, options) {
	var ref = this;
	var regl = ref.regl;

	// remove pass if null
	if (options === null) {
		this.traces[i] = null
		return this
	}

	if (!options) { return this }

	var o = pick(options, {
		data: 'data items columns rows values dimensions samples x',
		snap: 'snap cluster',
		size: 'sizes size radius',
		color: 'colors color fill fill-color fillColor',
		opacity: 'opacity alpha transparency opaque',
		borderSize: 'borderSizes borderSize border-size bordersize borderWidth borderWidths border-width borderwidth stroke-width strokeWidth strokewidth outline',
		borderColor: 'borderColors borderColor bordercolor stroke stroke-color strokeColor',
		marker: 'markers marker shape',
		range: 'range ranges databox dataBox',
		viewport: 'viewport viewBox viewbox',
		domain: 'domain domains area areas',
		padding: 'pad padding paddings pads margin margins',
		transpose: 'transpose transposed',
		diagonal: 'diagonal diag showDiagonal',
		upper: 'upper up top upperhalf upperHalf showupperhalf showUpper showUpperHalf',
		lower: 'lower low bottom lowerhalf lowerHalf showlowerhalf showLowerHalf showLower'
	})

	// we provide regl buffer per-trace, since trace data can be changed
	var trace = (this.traces[i] || (this.traces[i] = {
		id: i,
		buffer: regl.buffer({
			usage: 'dynamic',
			type: 'float',
			data: new Uint8Array()
		}),
		color: 'black',
		marker: null,
		size: 12,
		borderColor: 'transparent',
		borderSize: 1,
		viewport:  rect([regl._gl.drawingBufferWidth, regl._gl.drawingBufferHeight]),
		padding: [0, 0, 0, 0],
		opacity: 1,
		diagonal: true,
		upper: true,
		lower: true
	}))


	// save styles
	if (o.color != null) {
		trace.color = o.color
	}
	if (o.size != null) {
		trace.size = o.size
	}
	if (o.marker != null) {
		trace.marker = o.marker
	}
	if (o.borderColor != null) {
		trace.borderColor = o.borderColor
	}
	if (o.borderSize != null) {
		trace.borderSize = o.borderSize
	}
	if (o.opacity != null) {
		trace.opacity = o.opacity
	}
	if (o.viewport) {
		trace.viewport = rect(o.viewport)
	}
	if (o.diagonal != null) { trace.diagonal = o.diagonal }
	if (o.upper != null) { trace.upper = o.upper }
	if (o.lower != null) { trace.lower = o.lower }

	// put flattened data into buffer
	if (o.data) {
		trace.buffer(flatten(o.data))
		trace.columns = o.data.length
		trace.count = o.data[0].length

		// detect bounds per-column
		trace.bounds = []

		for (var i$1 = 0; i$1 < trace.columns; i$1++) {
			trace.bounds[i$1] = getBounds(o.data[i$1], 1)
		}
	}

	// add proper range updating markers
	var multirange
	if (o.range) {
		trace.range = o.range
		multirange = trace.range && typeof trace.range[0] !== 'number'
	}

	if (o.domain) {
		trace.domain = o.domain
	}
	var multipadding = false
	if (o.padding != null) {
		// multiple paddings
		if (Array.isArray(o.padding) && o.padding.length === trace.columns && typeof o.padding[o.padding.length - 1] === 'number') {
			trace.padding = o.padding.map(getPad)
			multipadding = true
		}
		// single padding
		else {
			trace.padding = getPad(o.padding)
		}
	}

	// create passes
	var m = trace.columns
	var n = trace.count

	var w = trace.viewport.width
	var h = trace.viewport.height
	var left = trace.viewport.x
	var top = trace.viewport.y
	var iw = w / m
	var ih = h / m

	trace.passes = []

	for (var i$2 = 0; i$2 < m; i$2++) {
		for (var j = 0; j < m; j++) {
			if (!trace.diagonal && j === i$2) { continue }
			if (!trace.upper && i$2 > j) { continue }
			if (!trace.lower && i$2 < j) { continue }

			var key = passId(trace.id, i$2, j)

			var pass = this.passes[key] || (this.passes[key] = {})

			if (o.data) {
				if (o.transpose) {
					pass.positions = {
						x: {buffer: trace.buffer, offset: j, count: n, stride: m},
						y: {buffer: trace.buffer, offset: i$2, count: n, stride: m}
					}
				}
				else {
					pass.positions = {
						x: {buffer: trace.buffer, offset: j * n, count: n},
						y: {buffer: trace.buffer, offset: i$2 * n, count: n}
					}
				}

				pass.bounds = getBox(trace.bounds, i$2, j)
			}

			if (o.domain || o.viewport || o.data) {
				var pad = multipadding ? getBox(trace.padding, i$2, j) : trace.padding
				if (trace.domain) {
					var ref$1 = getBox(trace.domain, i$2, j);
					var lox = ref$1[0];
					var loy = ref$1[1];
					var hix = ref$1[2];
					var hiy = ref$1[3];

					pass.viewport = [
						left + lox * w + pad[0],
						top + loy * h + pad[1],
						left + hix * w - pad[2],
						top + hiy * h - pad[3]
					]
				}
				// consider auto-domain equipartial
				else {
					pass.viewport = [
						left + j * iw + iw * pad[0],
						top + i$2 * ih + ih * pad[1],
						left + (j + 1) * iw - iw * pad[2],
						top + (i$2 + 1) * ih - ih * pad[3]
					]
				}
			}

			if (o.color) { pass.color = trace.color }
			if (o.size) { pass.size = trace.size }
			if (o.marker) { pass.marker = trace.marker }
			if (o.borderSize) { pass.borderSize = trace.borderSize }
			if (o.borderColor) { pass.borderColor = trace.borderColor }
			if (o.opacity) { pass.opacity = trace.opacity }

			if (o.range) {
				pass.range = multirange ? getBox(trace.range, i$2, j) : trace.range || pass.bounds
			}

			trace.passes.push(key)
		}
	}

	return this
}


// draw all or passed passes
SPLOM.prototype.draw = function () {
	var ref$2;

	var args = [], len = arguments.length;
	while ( len-- ) args[ len ] = arguments[ len ];
	if (!args.length) {
		this.scatter.draw()
	}
	else {
		var idx = []
		for (var i = 0; i < args.length; i++) {
			// draw(0, 2, 5) - draw traces
			if (typeof args[i] === 'number' ) {
				var ref = this.traces[args[i]];
				var passes = ref.passes;
				var passOffset = ref.passOffset;
				idx.push.apply(idx, arrRange(passOffset, passOffset + passes.length))
			}
			// draw([0, 1, 2 ...], [3, 4, 5]) - draw points
			else if (args[i].length) {
				var els = args[i]
				var ref$1 = this.traces[i];
				var passes$1 = ref$1.passes;
				var passOffset$1 = ref$1.passOffset;
				passes$1 = passes$1.map(function (passId, i) {
					idx[passOffset$1 + i] = els
				})
			}
		}
		(ref$2 = this.scatter).draw.apply(ref$2, idx)
	}

	return this
}


// dispose resources
SPLOM.prototype.destroy = function () {
	this.traces.forEach(function (trace) {
		if (trace.buffer && trace.buffer.destroy) { trace.buffer.destroy() }
	})
	this.traces = null
	this.passes = null

	this.scatter.destroy()

	return this
}


// return pass corresponding to trace i- j- square
function passId (trace, i, j) {
	var id = (trace.id != null ? trace.id : trace)
	var n = i
	var m = j
	var key = id << 16 | (n & 0xff) << 8 | m & 0xff

	return key
}


// return bounding box corresponding to a pass
function getBox (items, i, j) {
	var ilox, iloy, ihix, ihiy, jlox, jloy, jhix, jhiy
	var iitem = items[i], jitem = items[j]

	if (iitem.length > 2) {
		ilox = iitem[0]
		ihix = iitem[2]
		iloy = iitem[1]
		ihiy = iitem[3]
	}
	else if (iitem.length) {
		ilox = iloy = iitem[0]
		ihix = ihiy = iitem[1]
	}
	else {
		ilox = iitem.x
		iloy = iitem.y
		ihix = iitem.x + iitem.width
		ihiy = iitem.y + iitem.height
	}

	if (jitem.length > 2) {
		jlox = jitem[0]
		jhix = jitem[2]
		jloy = jitem[1]
		jhiy = jitem[3]
	}
	else if (jitem.length) {
		jlox = jloy = jitem[0]
		jhix = jhiy = jitem[1]
	}
	else {
		jlox = jitem.x
		jloy = jitem.y
		jhix = jitem.x + jitem.width
		jhiy = jitem.y + jitem.height
	}

	return [ jlox, iloy, jhix, ihiy ]
}


function getPad (arg) {
	if (typeof arg === 'number') { return [arg, arg, arg, arg] }
	else if (arg.length === 2) { return [arg[0], arg[1], arg[0], arg[1]] }
	else {
		var box = rect(arg)
		return [box.x, box.y, box.x + box.width, box.y + box.height]
	}
}

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 81330:
/***/ (function(module) {

(function(da,ea){ true?module.exports=ea():0})(this,function(){function da(a,b){this.id=Db++;this.type=a;this.data=b}function ea(a){if(0===a.length)return[];var b=a.charAt(0),c=a.charAt(a.length-1);if(1<a.length&&b===c&&('"'===b||"'"===b))return['"'+a.substr(1,a.length-2).replace(/\\/g,"\\\\").replace(/"/g,'\\"')+'"'];if(b=/\[(false|true|null|\d+|'[^']*'|"[^"]*")\]/.exec(a))return ea(a.substr(0,
b.index)).concat(ea(b[1])).concat(ea(a.substr(b.index+b[0].length)));b=a.split(".");if(1===b.length)return['"'+a.replace(/\\/g,"\\\\").replace(/"/g,'\\"')+'"'];a=[];for(c=0;c<b.length;++c)a=a.concat(ea(b[c]));return a}function bb(a){return"["+ea(a).join("][")+"]"}function cb(a,b){if("function"===typeof a)return new da(0,a);if("number"===typeof a||"boolean"===typeof a)return new da(5,a);if(Array.isArray(a))return new da(6,a.map(function(a,d){return cb(a,b+"["+d+"]")}));if(a instanceof da)return a}
function Eb(){var a={"":0},b=[""];return{id:function(c){var d=a[c];if(d)return d;d=a[c]=b.length;b.push(c);return d},str:function(a){return b[a]}}}function Fb(a,b,c){function d(){var b=window.innerWidth,d=window.innerHeight;a!==document.body&&(d=f.getBoundingClientRect(),b=d.right-d.left,d=d.bottom-d.top);f.width=c*b;f.height=c*d}var f=document.createElement("canvas");O(f.style,{border:0,margin:0,padding:0,top:0,left:0,width:"100%",height:"100%"});a.appendChild(f);a===document.body&&(f.style.position=
"absolute",O(a.style,{margin:0,padding:0}));var e;a!==document.body&&"function"===typeof ResizeObserver?(e=new ResizeObserver(function(){setTimeout(d)}),e.observe(a)):window.addEventListener("resize",d,!1);d();return{canvas:f,onDestroy:function(){e?e.disconnect():window.removeEventListener("resize",d);a.removeChild(f)}}}function Gb(a,b){function c(c){try{return a.getContext(c,b)}catch(f){return null}}return c("webgl")||c("experimental-webgl")||c("webgl-experimental")}function db(a){return"string"===
typeof a?a.split():a}function eb(a){return"string"===typeof a?document.querySelector(a):a}function Hb(a){var b=a||{},c,d,f,e;a={};var m=[],q=[],u="undefined"===typeof window?1:window.devicePixelRatio,r=!1,k={},n=function(a){},t=function(){};"string"===typeof b?c=document.querySelector(b):"object"===typeof b&&("string"===typeof b.nodeName&&"function"===typeof b.appendChild&&"function"===typeof b.getBoundingClientRect?c=b:"function"===typeof b.drawArrays||"function"===typeof b.drawElements?(e=b,f=e.canvas):
("gl"in b?e=b.gl:"canvas"in b?f=eb(b.canvas):"container"in b&&(d=eb(b.container)),"attributes"in b&&(a=b.attributes),"extensions"in b&&(m=db(b.extensions)),"optionalExtensions"in b&&(q=db(b.optionalExtensions)),"onDone"in b&&(n=b.onDone),"profile"in b&&(r=!!b.profile),"pixelRatio"in b&&(u=+b.pixelRatio),"cachedCode"in b&&(k=b.cachedCode)));c&&("canvas"===c.nodeName.toLowerCase()?f=c:d=c);if(!e){if(!f){c=Fb(d||document.body,n,u);if(!c)return null;f=c.canvas;t=c.onDestroy}void 0===a.premultipliedAlpha&&
(a.premultipliedAlpha=!0);e=Gb(f,a)}return e?{gl:e,canvas:f,container:d,extensions:m,optionalExtensions:q,pixelRatio:u,profile:r,cachedCode:k,onDone:n,onDestroy:t}:(t(),n("webgl not supported, try upgrading your browser or graphics drivers http://get.webgl.org"),null)}function Ib(a,b){function c(b){b=b.toLowerCase();var c;try{c=d[b]=a.getExtension(b)}catch(f){}return!!c}for(var d={},f=0;f<b.extensions.length;++f){var e=b.extensions[f];if(!c(e))return b.onDestroy(),b.onDone('"'+e+'" extension is not supported by the current WebGL context, try upgrading your system or a different browser'),
null}b.optionalExtensions.forEach(c);return{extensions:d,restore:function(){Object.keys(d).forEach(function(a){if(d[a]&&!c(a))throw Error("(regl): error restoring extension "+a);})}}}function S(a,b){for(var c=Array(a),d=0;d<a;++d)c[d]=b(d);return c}function fb(a){var b,c;b=(65535<a)<<4;a>>>=b;c=(255<a)<<3;a>>>=c;b|=c;c=(15<a)<<2;a>>>=c;b|=c;c=(3<a)<<1;return b|c|a>>>c>>1}function gb(){function a(a){a:{for(var b=16;268435456>=b;b*=16)if(a<=b){a=b;break a}a=0}b=c[fb(a)>>2];return 0<b.length?b.pop():
new ArrayBuffer(a)}function b(a){c[fb(a.byteLength)>>2].push(a)}var c=S(8,function(){return[]});return{alloc:a,free:b,allocType:function(b,c){var e=null;switch(b){case 5120:e=new Int8Array(a(c),0,c);break;case 5121:e=new Uint8Array(a(c),0,c);break;case 5122:e=new Int16Array(a(2*c),0,c);break;case 5123:e=new Uint16Array(a(2*c),0,c);break;case 5124:e=new Int32Array(a(4*c),0,c);break;case 5125:e=new Uint32Array(a(4*c),0,c);break;case 5126:e=new Float32Array(a(4*c),0,c);break;default:return null}return e.length!==
c?e.subarray(0,c):e},freeType:function(a){b(a.buffer)}}}function fa(a){return!!a&&"object"===typeof a&&Array.isArray(a.shape)&&Array.isArray(a.stride)&&"number"===typeof a.offset&&a.shape.length===a.stride.length&&(Array.isArray(a.data)||P(a.data))}function hb(a,b,c,d,f,e){for(var m=0;m<b;++m)for(var q=a[m],u=0;u<c;++u)for(var r=q[u],k=0;k<d;++k)f[e++]=r[k]}function ib(a,b,c,d,f){for(var e=1,m=c+1;m<b.length;++m)e*=b[m];var q=b[c];if(4===b.length-c){var u=b[c+1],r=b[c+2];b=b[c+3];for(m=0;m<q;++m)hb(a[m],
u,r,b,d,f),f+=e}else for(m=0;m<q;++m)ib(a[m],b,c+1,d,f),f+=e}function Ha(a){return Ia[Object.prototype.toString.call(a)]|0}function jb(a,b){for(var c=0;c<b.length;++c)a[c]=b[c]}function kb(a,b,c,d,f,e,m){for(var q=0,u=0;u<c;++u)for(var r=0;r<d;++r)a[q++]=b[f*u+e*r+m]}function Jb(a,b,c,d){function f(b){this.id=u++;this.buffer=a.createBuffer();this.type=b;this.usage=35044;this.byteLength=0;this.dimension=1;this.dtype=5121;this.persistentData=null;c.profile&&(this.stats={size:0})}function e(b,c,d){b.byteLength=
c.byteLength;a.bufferData(b.type,c,d)}function m(a,b,c,d,h,p){a.usage=c;if(Array.isArray(b)){if(a.dtype=d||5126,0<b.length)if(Array.isArray(b[0])){h=lb(b);for(var y=d=1;y<h.length;++y)d*=h[y];a.dimension=d;b=Ua(b,h,a.dtype);e(a,b,c);p?a.persistentData=b:B.freeType(b)}else"number"===typeof b[0]?(a.dimension=h,h=B.allocType(a.dtype,b.length),jb(h,b),e(a,h,c),p?a.persistentData=h:B.freeType(h)):P(b[0])&&(a.dimension=b[0].length,a.dtype=d||Ha(b[0])||5126,b=Ua(b,[b.length,b[0].length],a.dtype),e(a,b,c),
p?a.persistentData=b:B.freeType(b))}else if(P(b))a.dtype=d||Ha(b),a.dimension=h,e(a,b,c),p&&(a.persistentData=new Uint8Array(new Uint8Array(b.buffer)));else if(fa(b)){h=b.shape;var f=b.stride,y=b.offset,w=0,z=0,k=0,m=0;1===h.length?(w=h[0],z=1,k=f[0],m=0):2===h.length&&(w=h[0],z=h[1],k=f[0],m=f[1]);a.dtype=d||Ha(b.data)||5126;a.dimension=z;h=B.allocType(a.dtype,w*z);kb(h,b.data,w,z,k,m,y);e(a,h,c);p?a.persistentData=h:B.freeType(h)}else b instanceof ArrayBuffer&&(a.dtype=5121,a.dimension=h,e(a,b,
c),p&&(a.persistentData=new Uint8Array(new Uint8Array(b))))}function q(c){b.bufferCount--;d(c);a.deleteBuffer(c.buffer);c.buffer=null;delete r[c.id]}var u=0,r={};f.prototype.bind=function(){a.bindBuffer(this.type,this.buffer)};f.prototype.destroy=function(){q(this)};var k=[];c.profile&&(b.getTotalBufferSize=function(){var a=0;Object.keys(r).forEach(function(b){a+=r[b].stats.size});return a});return{create:function(d,e,g,l){function h(b){var d=35044,n=null,g=0,e=0,f=1;Array.isArray(b)||P(b)||fa(b)||
b instanceof ArrayBuffer?n=b:"number"===typeof b?g=b|0:b&&("data"in b&&(n=b.data),"usage"in b&&(d=mb[b.usage]),"type"in b&&(e=Ja[b.type]),"dimension"in b&&(f=b.dimension|0),"length"in b&&(g=b.length|0));p.bind();n?m(p,n,d,e,f,l):(g&&a.bufferData(p.type,g,d),p.dtype=e||5121,p.usage=d,p.dimension=f,p.byteLength=g);c.profile&&(p.stats.size=p.byteLength*ja[p.dtype]);return h}b.bufferCount++;var p=new f(e);r[p.id]=p;g||h(d);h._reglType="buffer";h._buffer=p;h.subdata=function(b,c){var d=(c||0)|0,n;p.bind();
if(P(b)||b instanceof ArrayBuffer)a.bufferSubData(p.type,d,b);else if(Array.isArray(b)){if(0<b.length)if("number"===typeof b[0]){var g=B.allocType(p.dtype,b.length);jb(g,b);a.bufferSubData(p.type,d,g);B.freeType(g)}else if(Array.isArray(b[0])||P(b[0]))n=lb(b),g=Ua(b,n,p.dtype),a.bufferSubData(p.type,d,g),B.freeType(g)}else if(fa(b)){n=b.shape;var e=b.stride,l=g=0,f=0,v=0;1===n.length?(g=n[0],l=1,f=e[0],v=0):2===n.length&&(g=n[0],l=n[1],f=e[0],v=e[1]);n=Array.isArray(b.data)?p.dtype:Ha(b.data);n=B.allocType(n,
g*l);kb(n,b.data,g,l,f,v,b.offset);a.bufferSubData(p.type,d,n);B.freeType(n)}return h};c.profile&&(h.stats=p.stats);h.destroy=function(){q(p)};return h},createStream:function(a,b){var c=k.pop();c||(c=new f(a));c.bind();m(c,b,35040,0,1,!1);return c},destroyStream:function(a){k.push(a)},clear:function(){T(r).forEach(q);k.forEach(q)},getBuffer:function(a){return a&&a._buffer instanceof f?a._buffer:null},restore:function(){T(r).forEach(function(b){b.buffer=a.createBuffer();a.bindBuffer(b.type,b.buffer);
a.bufferData(b.type,b.persistentData||b.byteLength,b.usage)})},_initBuffer:m}}function Kb(a,b,c,d){function f(a){this.id=u++;q[this.id]=this;this.buffer=a;this.primType=4;this.type=this.vertCount=0}function e(d,e,g,l,h,f,y){d.buffer.bind();var k;e?((k=y)||P(e)&&(!fa(e)||P(e.data))||(k=b.oes_element_index_uint?5125:5123),c._initBuffer(d.buffer,e,g,k,3)):(a.bufferData(34963,f,g),d.buffer.dtype=k||5121,d.buffer.usage=g,d.buffer.dimension=3,d.buffer.byteLength=f);k=y;if(!y){switch(d.buffer.dtype){case 5121:case 5120:k=
5121;break;case 5123:case 5122:k=5123;break;case 5125:case 5124:k=5125}d.buffer.dtype=k}d.type=k;e=h;0>e&&(e=d.buffer.byteLength,5123===k?e>>=1:5125===k&&(e>>=2));d.vertCount=e;e=l;0>l&&(e=4,l=d.buffer.dimension,1===l&&(e=0),2===l&&(e=1),3===l&&(e=4));d.primType=e}function m(a){d.elementsCount--;delete q[a.id];a.buffer.destroy();a.buffer=null}var q={},u=0,r={uint8:5121,uint16:5123};b.oes_element_index_uint&&(r.uint32=5125);f.prototype.bind=function(){this.buffer.bind()};var k=[];return{create:function(a,
b){function g(a){if(a)if("number"===typeof a)l(a),h.primType=4,h.vertCount=a|0,h.type=5121;else{var b=null,c=35044,d=-1,f=-1,n=0,k=0;if(Array.isArray(a)||P(a)||fa(a))b=a;else if("data"in a&&(b=a.data),"usage"in a&&(c=mb[a.usage]),"primitive"in a&&(d=Ka[a.primitive]),"count"in a&&(f=a.count|0),"type"in a&&(k=r[a.type]),"length"in a)n=a.length|0;else if(n=f,5123===k||5122===k)n*=2;else if(5125===k||5124===k)n*=4;e(h,b,c,d,f,n,k)}else l(),h.primType=4,h.vertCount=0,h.type=5121;return g}var l=c.create(null,
34963,!0),h=new f(l._buffer);d.elementsCount++;g(a);g._reglType="elements";g._elements=h;g.subdata=function(a,b){l.subdata(a,b);return g};g.destroy=function(){m(h)};return g},createStream:function(a){var b=k.pop();b||(b=new f(c.create(null,34963,!0,!1)._buffer));e(b,a,35040,-1,-1,0,0);return b},destroyStream:function(a){k.push(a)},getElements:function(a){return"function"===typeof a&&a._elements instanceof f?a._elements:null},clear:function(){T(q).forEach(m)}}}function ob(a){for(var b=B.allocType(5123,
a.length),c=0;c<a.length;++c)if(isNaN(a[c]))b[c]=65535;else if(Infinity===a[c])b[c]=31744;else if(-Infinity===a[c])b[c]=64512;else{pb[0]=a[c];var d=Lb[0],f=d>>>31<<15,e=(d<<1>>>24)-127,d=d>>13&1023;b[c]=-24>e?f:-14>e?f+(d+1024>>-14-e):15<e?f+31744:f+(e+15<<10)+d}return b}function qa(a){return Array.isArray(a)||P(a)}function ra(a){return"[object "+a+"]"}function qb(a){return Array.isArray(a)&&(0===a.length||"number"===typeof a[0])}function rb(a){return Array.isArray(a)&&0!==a.length&&qa(a[0])?!0:!1}
function R(a){return Object.prototype.toString.call(a)}function Va(a){if(!a)return!1;var b=R(a);return 0<=Mb.indexOf(b)?!0:qb(a)||rb(a)||fa(a)}function sb(a,b){36193===a.type?(a.data=ob(b),B.freeType(b)):a.data=b}function La(a,b,c,d,f,e){a="undefined"!==typeof G[a]?G[a]:U[a]*ya[b];e&&(a*=6);if(f){for(d=0;1<=c;)d+=a*c*c,c/=2;return d}return a*c*d}function Nb(a,b,c,d,f,e,m){function q(){this.format=this.internalformat=6408;this.type=5121;this.flipY=this.premultiplyAlpha=this.compressed=!1;this.unpackAlignment=
1;this.colorSpace=37444;this.channels=this.height=this.width=0}function u(a,b){a.internalformat=b.internalformat;a.format=b.format;a.type=b.type;a.compressed=b.compressed;a.premultiplyAlpha=b.premultiplyAlpha;a.flipY=b.flipY;a.unpackAlignment=b.unpackAlignment;a.colorSpace=b.colorSpace;a.width=b.width;a.height=b.height;a.channels=b.channels}function r(a,b){if("object"===typeof b&&b){"premultiplyAlpha"in b&&(a.premultiplyAlpha=b.premultiplyAlpha);"flipY"in b&&(a.flipY=b.flipY);"alignment"in b&&(a.unpackAlignment=
b.alignment);"colorSpace"in b&&(a.colorSpace=Ob[b.colorSpace]);"type"in b&&(a.type=W[b.type]);var c=a.width,d=a.height,e=a.channels,h=!1;"shape"in b?(c=b.shape[0],d=b.shape[1],3===b.shape.length&&(e=b.shape[2],h=!0)):("radius"in b&&(c=d=b.radius),"width"in b&&(c=b.width),"height"in b&&(d=b.height),"channels"in b&&(e=b.channels,h=!0));a.width=c|0;a.height=d|0;a.channels=e|0;c=!1;"format"in b&&(c=b.format,d=a.internalformat=Q[c],a.format=Ea[d],c in W&&!("type"in b)&&(a.type=W[c]),c in I&&(a.compressed=
!0),c=!0);!h&&c?a.channels=U[a.format]:h&&!c&&a.channels!==Na[a.format]&&(a.format=a.internalformat=Na[a.channels])}}function k(b){a.pixelStorei(37440,b.flipY);a.pixelStorei(37441,b.premultiplyAlpha);a.pixelStorei(37443,b.colorSpace);a.pixelStorei(3317,b.unpackAlignment)}function n(){q.call(this);this.yOffset=this.xOffset=0;this.data=null;this.needsFree=!1;this.element=null;this.needsCopy=!1}function t(a,b){var c=null;Va(b)?c=b:b&&(r(a,b),"x"in b&&(a.xOffset=b.x|0),"y"in b&&(a.yOffset=b.y|0),Va(b.data)&&
(c=b.data));if(b.copy){var d=f.viewportWidth,e=f.viewportHeight;a.width=a.width||d-a.xOffset;a.height=a.height||e-a.yOffset;a.needsCopy=!0}else if(!c)a.width=a.width||1,a.height=a.height||1,a.channels=a.channels||4;else if(P(c))a.channels=a.channels||4,a.data=c,"type"in b||5121!==a.type||(a.type=Ia[Object.prototype.toString.call(c)]|0);else if(qb(c)){a.channels=a.channels||4;d=c;e=d.length;switch(a.type){case 5121:case 5123:case 5125:case 5126:e=B.allocType(a.type,e);e.set(d);a.data=e;break;case 36193:a.data=
ob(d)}a.alignment=1;a.needsFree=!0}else if(fa(c)){d=c.data;Array.isArray(d)||5121!==a.type||(a.type=Ia[Object.prototype.toString.call(d)]|0);var e=c.shape,h=c.stride,g,l,v,k;3===e.length?(v=e[2],k=h[2]):k=v=1;g=e[0];l=e[1];e=h[0];h=h[1];a.alignment=1;a.width=g;a.height=l;a.channels=v;a.format=a.internalformat=Na[v];a.needsFree=!0;g=k;c=c.offset;v=a.width;k=a.height;l=a.channels;for(var n=B.allocType(36193===a.type?5126:a.type,v*k*l),x=0,F=0;F<k;++F)for(var aa=0;aa<v;++aa)for(var Fa=0;Fa<l;++Fa)n[x++]=
d[e*aa+h*F+g*Fa+c];sb(a,n)}else if(R(c)===Wa||R(c)===Xa||R(c)===ub)R(c)===Wa||R(c)===Xa?a.element=c:a.element=c.canvas,a.width=a.element.width,a.height=a.element.height,a.channels=4;else if(R(c)===vb)a.element=c,a.width=c.width,a.height=c.height,a.channels=4;else if(R(c)===wb)a.element=c,a.width=c.naturalWidth,a.height=c.naturalHeight,a.channels=4;else if(R(c)===xb)a.element=c,a.width=c.videoWidth,a.height=c.videoHeight,a.channels=4;else if(rb(c)){d=a.width||c[0].length;e=a.height||c.length;h=a.channels;
h=qa(c[0][0])?h||c[0][0].length:h||1;g=Pa.shape(c);v=1;for(k=0;k<g.length;++k)v*=g[k];v=B.allocType(36193===a.type?5126:a.type,v);Pa.flatten(c,g,"",v);sb(a,v);a.alignment=1;a.width=d;a.height=e;a.channels=h;a.format=a.internalformat=Na[h];a.needsFree=!0}}function g(b,c,e,h,g){var v=b.element,l=b.data,f=b.internalformat,n=b.format,y=b.type,w=b.width,x=b.height;k(b);v?a.texSubImage2D(c,g,e,h,n,y,v):b.compressed?a.compressedTexSubImage2D(c,g,e,h,f,w,x,l):b.needsCopy?(d(),a.copyTexSubImage2D(c,g,e,h,
b.xOffset,b.yOffset,w,x)):a.texSubImage2D(c,g,e,h,w,x,n,y,l)}function l(){return Qa.pop()||new n}function h(a){a.needsFree&&B.freeType(a.data);n.call(a);Qa.push(a)}function p(){q.call(this);this.genMipmaps=!1;this.mipmapHint=4352;this.mipmask=0;this.images=Array(16)}function y(a,b,c){var d=a.images[0]=l();a.mipmask=1;d.width=a.width=b;d.height=a.height=c;d.channels=a.channels=4}function C(a,b){var c=null;if(Va(b))c=a.images[0]=l(),u(c,a),t(c,b),a.mipmask=1;else if(r(a,b),Array.isArray(b.mipmap))for(var d=
b.mipmap,e=0;e<d.length;++e)c=a.images[e]=l(),u(c,a),c.width>>=e,c.height>>=e,t(c,d[e]),a.mipmask|=1<<e;else c=a.images[0]=l(),u(c,a),t(c,b),a.mipmask=1;u(a,a.images[0])}function w(b,c){for(var e=b.images,h=0;h<e.length&&e[h];++h){var g=e[h],v=c,l=h,f=g.element,n=g.data,y=g.internalformat,w=g.format,x=g.type,F=g.width,aa=g.height;k(g);f?a.texImage2D(v,l,w,w,x,f):g.compressed?a.compressedTexImage2D(v,l,y,F,aa,0,n):g.needsCopy?(d(),a.copyTexImage2D(v,l,w,g.xOffset,g.yOffset,F,aa,0)):a.texImage2D(v,
l,w,F,aa,0,w,x,n||null)}}function z(){var a=S.pop()||new p;q.call(a);for(var b=a.mipmask=0;16>b;++b)a.images[b]=null;return a}function wa(a){for(var b=a.images,c=0;c<b.length;++c)b[c]&&h(b[c]),b[c]=null;S.push(a)}function E(){this.magFilter=this.minFilter=9728;this.wrapT=this.wrapS=33071;this.anisotropic=1;this.genMipmaps=!1;this.mipmapHint=4352}function nb(a,b){"min"in b&&(a.minFilter=V[b.min],0<=Pb.indexOf(a.minFilter)&&!("faces"in b)&&(a.genMipmaps=!0));"mag"in b&&(a.magFilter=na[b.mag]);var c=
a.wrapS,d=a.wrapT;if("wrap"in b){var e=b.wrap;"string"===typeof e?c=d=oa[e]:Array.isArray(e)&&(c=oa[e[0]],d=oa[e[1]])}else"wrapS"in b&&(c=oa[b.wrapS]),"wrapT"in b&&(d=oa[b.wrapT]);a.wrapS=c;a.wrapT=d;"anisotropic"in b&&(a.anisotropic=b.anisotropic);if("mipmap"in b){c=!1;switch(typeof b.mipmap){case "string":a.mipmapHint=J[b.mipmap];c=a.genMipmaps=!0;break;case "boolean":c=a.genMipmaps=b.mipmap;break;case "object":a.genMipmaps=!1,c=!0}!c||"min"in b||(a.minFilter=9984)}}function D(c,d){a.texParameteri(d,
10241,c.minFilter);a.texParameteri(d,10240,c.magFilter);a.texParameteri(d,10242,c.wrapS);a.texParameteri(d,10243,c.wrapT);b.ext_texture_filter_anisotropic&&a.texParameteri(d,34046,c.anisotropic);c.genMipmaps&&(a.hint(33170,c.mipmapHint),a.generateMipmap(d))}function v(b){q.call(this);this.mipmask=0;this.internalformat=6408;this.id=Z++;this.refCount=1;this.target=b;this.texture=a.createTexture();this.unit=-1;this.bindCount=0;this.texInfo=new E;m.profile&&(this.stats={size:0})}function ba(b){a.activeTexture(33984);
a.bindTexture(b.target,b.texture)}function za(){var b=X[0];b?a.bindTexture(b.target,b.texture):a.bindTexture(3553,null)}function A(b){var c=b.texture,d=b.unit,h=b.target;0<=d&&(a.activeTexture(33984+d),a.bindTexture(h,null),X[d]=null);a.deleteTexture(c);b.texture=null;b.params=null;b.pixels=null;b.refCount=0;delete ka[b.id];e.textureCount--}var J={"don't care":4352,"dont care":4352,nice:4354,fast:4353},oa={repeat:10497,clamp:33071,mirror:33648},na={nearest:9728,linear:9729},V=O({mipmap:9987,"nearest mipmap nearest":9984,
"linear mipmap nearest":9985,"nearest mipmap linear":9986,"linear mipmap linear":9987},na),Ob={none:0,browser:37444},W={uint8:5121,rgba4:32819,rgb565:33635,"rgb5 a1":32820},Q={alpha:6406,luminance:6409,"luminance alpha":6410,rgb:6407,rgba:6408,rgba4:32854,"rgb5 a1":32855,rgb565:36194},I={};b.ext_srgb&&(Q.srgb=35904,Q.srgba=35906);b.oes_texture_float&&(W.float32=W["float"]=5126);b.oes_texture_half_float&&(W.float16=W["half float"]=36193);b.webgl_depth_texture&&(O(Q,{depth:6402,"depth stencil":34041}),
O(W,{uint16:5123,uint32:5125,"depth stencil":34042}));b.webgl_compressed_texture_s3tc&&O(I,{"rgb s3tc dxt1":33776,"rgba s3tc dxt1":33777,"rgba s3tc dxt3":33778,"rgba s3tc dxt5":33779});b.webgl_compressed_texture_atc&&O(I,{"rgb atc":35986,"rgba atc explicit alpha":35987,"rgba atc interpolated alpha":34798});b.webgl_compressed_texture_pvrtc&&O(I,{"rgb pvrtc 4bppv1":35840,"rgb pvrtc 2bppv1":35841,"rgba pvrtc 4bppv1":35842,"rgba pvrtc 2bppv1":35843});b.webgl_compressed_texture_etc1&&(I["rgb etc1"]=36196);
var K=Array.prototype.slice.call(a.getParameter(34467));Object.keys(I).forEach(function(a){var b=I[a];0<=K.indexOf(b)&&(Q[a]=b)});var G=Object.keys(Q);c.textureFormats=G;var H=[];Object.keys(Q).forEach(function(a){H[Q[a]]=a});var xa=[];Object.keys(W).forEach(function(a){xa[W[a]]=a});var L=[];Object.keys(na).forEach(function(a){L[na[a]]=a});var pa=[];Object.keys(V).forEach(function(a){pa[V[a]]=a});var ga=[];Object.keys(oa).forEach(function(a){ga[oa[a]]=a});var Ea=G.reduce(function(a,c){var d=Q[c];
6409===d||6406===d||6409===d||6410===d||6402===d||34041===d||b.ext_srgb&&(35904===d||35906===d)?a[d]=d:32855===d||0<=c.indexOf("rgba")?a[d]=6408:a[d]=6407;return a},{}),Qa=[],S=[],Z=0,ka={},ha=c.maxTextureUnits,X=Array(ha).map(function(){return null});O(v.prototype,{bind:function(){this.bindCount+=1;var b=this.unit;if(0>b){for(var c=0;c<ha;++c){var d=X[c];if(d){if(0<d.bindCount)continue;d.unit=-1}X[c]=this;b=c;break}m.profile&&e.maxTextureUnits<b+1&&(e.maxTextureUnits=b+1);this.unit=b;a.activeTexture(33984+
b);a.bindTexture(this.target,this.texture)}return b},unbind:function(){--this.bindCount},decRef:function(){0>=--this.refCount&&A(this)}});m.profile&&(e.getTotalTextureSize=function(){var a=0;Object.keys(ka).forEach(function(b){a+=ka[b].stats.size});return a});return{create2D:function(b,c){function d(a,b){var c=f.texInfo;E.call(c);var e=z();"number"===typeof a?"number"===typeof b?y(e,a|0,b|0):y(e,a|0,a|0):a?(nb(c,a),C(e,a)):y(e,1,1);c.genMipmaps&&(e.mipmask=(e.width<<1)-1);f.mipmask=e.mipmask;u(f,
e);f.internalformat=e.internalformat;d.width=e.width;d.height=e.height;ba(f);w(e,3553);D(c,3553);za();wa(e);m.profile&&(f.stats.size=La(f.internalformat,f.type,e.width,e.height,c.genMipmaps,!1));d.format=H[f.internalformat];d.type=xa[f.type];d.mag=L[c.magFilter];d.min=pa[c.minFilter];d.wrapS=ga[c.wrapS];d.wrapT=ga[c.wrapT];return d}var f=new v(3553);ka[f.id]=f;e.textureCount++;d(b,c);d.subimage=function(a,b,c,e){b|=0;c|=0;e|=0;var v=l();u(v,f);v.width=0;v.height=0;t(v,a);v.width=v.width||(f.width>>
e)-b;v.height=v.height||(f.height>>e)-c;ba(f);g(v,3553,b,c,e);za();h(v);return d};d.resize=function(b,c){var e=b|0,h=c|0||e;if(e===f.width&&h===f.height)return d;d.width=f.width=e;d.height=f.height=h;ba(f);for(var g=0;f.mipmask>>g;++g){var v=e>>g,l=h>>g;if(!v||!l)break;a.texImage2D(3553,g,f.format,v,l,0,f.format,f.type,null)}za();m.profile&&(f.stats.size=La(f.internalformat,f.type,e,h,!1,!1));return d};d._reglType="texture2d";d._texture=f;m.profile&&(d.stats=f.stats);d.destroy=function(){f.decRef()};
return d},createCube:function(b,c,d,f,k,n){function p(a,b,c,d,e,h){var f,g=A.texInfo;E.call(g);for(f=0;6>f;++f)J[f]=z();if("number"===typeof a||!a)for(a=a|0||1,f=0;6>f;++f)y(J[f],a,a);else if("object"===typeof a)if(b)C(J[0],a),C(J[1],b),C(J[2],c),C(J[3],d),C(J[4],e),C(J[5],h);else if(nb(g,a),r(A,a),"faces"in a)for(a=a.faces,f=0;6>f;++f)u(J[f],A),C(J[f],a[f]);else for(f=0;6>f;++f)C(J[f],a);u(A,J[0]);A.mipmask=g.genMipmaps?(J[0].width<<1)-1:J[0].mipmask;A.internalformat=J[0].internalformat;p.width=
J[0].width;p.height=J[0].height;ba(A);for(f=0;6>f;++f)w(J[f],34069+f);D(g,34067);za();m.profile&&(A.stats.size=La(A.internalformat,A.type,p.width,p.height,g.genMipmaps,!0));p.format=H[A.internalformat];p.type=xa[A.type];p.mag=L[g.magFilter];p.min=pa[g.minFilter];p.wrapS=ga[g.wrapS];p.wrapT=ga[g.wrapT];for(f=0;6>f;++f)wa(J[f]);return p}var A=new v(34067);ka[A.id]=A;e.cubeCount++;var J=Array(6);p(b,c,d,f,k,n);p.subimage=function(a,b,c,d,e){c|=0;d|=0;e|=0;var f=l();u(f,A);f.width=0;f.height=0;t(f,b);
f.width=f.width||(A.width>>e)-c;f.height=f.height||(A.height>>e)-d;ba(A);g(f,34069+a,c,d,e);za();h(f);return p};p.resize=function(b){b|=0;if(b!==A.width){p.width=A.width=b;p.height=A.height=b;ba(A);for(var c=0;6>c;++c)for(var x=0;A.mipmask>>x;++x)a.texImage2D(34069+c,x,A.format,b>>x,b>>x,0,A.format,A.type,null);za();m.profile&&(A.stats.size=La(A.internalformat,A.type,p.width,p.height,!1,!0));return p}};p._reglType="textureCube";p._texture=A;m.profile&&(p.stats=A.stats);p.destroy=function(){A.decRef()};
return p},clear:function(){for(var b=0;b<ha;++b)a.activeTexture(33984+b),a.bindTexture(3553,null),X[b]=null;T(ka).forEach(A);e.cubeCount=0;e.textureCount=0},getTexture:function(a){return null},restore:function(){for(var b=0;b<ha;++b){var c=X[b];c&&(c.bindCount=0,c.unit=-1,X[b]=null)}T(ka).forEach(function(b){b.texture=a.createTexture();a.bindTexture(b.target,b.texture);for(var c=0;32>c;++c)if(0!==(b.mipmask&1<<c))if(3553===b.target)a.texImage2D(3553,c,b.internalformat,b.width>>c,b.height>>c,0,b.internalformat,
b.type,null);else for(var d=0;6>d;++d)a.texImage2D(34069+d,c,b.internalformat,b.width>>c,b.height>>c,0,b.internalformat,b.type,null);D(b.texInfo,b.target)})},refresh:function(){for(var b=0;b<ha;++b){var c=X[b];c&&(c.bindCount=0,c.unit=-1,X[b]=null);a.activeTexture(33984+b);a.bindTexture(3553,null);a.bindTexture(34067,null)}}}}function Qb(a,b,c,d,f,e){function m(a,b,c){this.target=a;this.texture=b;this.renderbuffer=c;var d=a=0;b?(a=b.width,d=b.height):c&&(a=c.width,d=c.height);this.width=a;this.height=
d}function q(a){a&&(a.texture&&a.texture._texture.decRef(),a.renderbuffer&&a.renderbuffer._renderbuffer.decRef())}function u(a,b,c){a&&(a.texture?a.texture._texture.refCount+=1:a.renderbuffer._renderbuffer.refCount+=1)}function r(b,c){c&&(c.texture?a.framebufferTexture2D(36160,b,c.target,c.texture._texture.texture,0):a.framebufferRenderbuffer(36160,b,36161,c.renderbuffer._renderbuffer.renderbuffer))}function k(a){var b=3553,c=null,d=null,e=a;"object"===typeof a&&(e=a.data,"target"in a&&(b=a.target|
0));a=e._reglType;"texture2d"===a?c=e:"textureCube"===a?c=e:"renderbuffer"===a&&(d=e,b=36161);return new m(b,c,d)}function n(a,b,c,e,g){if(c)return a=d.create2D({width:a,height:b,format:e,type:g}),a._texture.refCount=0,new m(3553,a,null);a=f.create({width:a,height:b,format:e});a._renderbuffer.refCount=0;return new m(36161,null,a)}function t(a){return a&&(a.texture||a.renderbuffer)}function g(a,b,c){a&&(a.texture?a.texture.resize(b,c):a.renderbuffer&&a.renderbuffer.resize(b,c),a.width=b,a.height=c)}
function l(){this.id=B++;D[this.id]=this;this.framebuffer=a.createFramebuffer();this.height=this.width=0;this.colorAttachments=[];this.depthStencilAttachment=this.stencilAttachment=this.depthAttachment=null}function h(a){a.colorAttachments.forEach(q);q(a.depthAttachment);q(a.stencilAttachment);q(a.depthStencilAttachment)}function p(b){a.deleteFramebuffer(b.framebuffer);b.framebuffer=null;e.framebufferCount--;delete D[b.id]}function y(b){var d;a.bindFramebuffer(36160,b.framebuffer);var e=b.colorAttachments;
for(d=0;d<e.length;++d)r(36064+d,e[d]);for(d=e.length;d<c.maxColorAttachments;++d)a.framebufferTexture2D(36160,36064+d,3553,null,0);a.framebufferTexture2D(36160,33306,3553,null,0);a.framebufferTexture2D(36160,36096,3553,null,0);a.framebufferTexture2D(36160,36128,3553,null,0);r(36096,b.depthAttachment);r(36128,b.stencilAttachment);r(33306,b.depthStencilAttachment);a.checkFramebufferStatus(36160);a.isContextLost();a.bindFramebuffer(36160,w.next?w.next.framebuffer:null);w.cur=w.next;a.getError()}function C(a,
b){function c(a,b){var e,f=0,g=0,l=!0,w=!0;e=null;var p=!0,v="rgba",m="uint8",r=1,C=null,q=null,pa=null,ga=!1;if("number"===typeof a)f=a|0,g=b|0||f;else if(a){"shape"in a?(g=a.shape,f=g[0],g=g[1]):("radius"in a&&(f=g=a.radius),"width"in a&&(f=a.width),"height"in a&&(g=a.height));if("color"in a||"colors"in a)e=a.color||a.colors,Array.isArray(e);if(!e){"colorCount"in a&&(r=a.colorCount|0);"colorTexture"in a&&(p=!!a.colorTexture,v="rgba4");if("colorType"in a&&(m=a.colorType,!p))if("half float"===m||
"float16"===m)v="rgba16f";else if("float"===m||"float32"===m)v="rgba32f";"colorFormat"in a&&(v=a.colorFormat,0<=z.indexOf(v)?p=!0:0<=wa.indexOf(v)&&(p=!1))}if("depthTexture"in a||"depthStencilTexture"in a)ga=!(!a.depthTexture&&!a.depthStencilTexture);"depth"in a&&("boolean"===typeof a.depth?l=a.depth:(C=a.depth,w=!1));"stencil"in a&&("boolean"===typeof a.stencil?w=a.stencil:(q=a.stencil,l=!1));"depthStencil"in a&&("boolean"===typeof a.depthStencil?l=w=a.depthStencil:(pa=a.depthStencil,w=l=!1))}else f=
g=1;var D=null,ba=null,E=null,B=null;if(Array.isArray(e))D=e.map(k);else if(e)D=[k(e)];else for(D=Array(r),e=0;e<r;++e)D[e]=n(f,g,p,v,m);f=f||D[0].width;g=g||D[0].height;C?ba=k(C):l&&!w&&(ba=n(f,g,ga,"depth","uint32"));q?E=k(q):w&&!l&&(E=n(f,g,!1,"stencil","uint8"));pa?B=k(pa):!C&&!q&&w&&l&&(B=n(f,g,ga,"depth stencil","depth stencil"));l=null;for(e=0;e<D.length;++e)u(D[e],f,g),D[e]&&D[e].texture&&(w=Ya[D[e].texture._texture.format]*Ra[D[e].texture._texture.type],null===l&&(l=w));u(ba,f,g);u(E,f,g);
u(B,f,g);h(d);d.width=f;d.height=g;d.colorAttachments=D;d.depthAttachment=ba;d.stencilAttachment=E;d.depthStencilAttachment=B;c.color=D.map(t);c.depth=t(ba);c.stencil=t(E);c.depthStencil=t(B);c.width=d.width;c.height=d.height;y(d);return c}var d=new l;e.framebufferCount++;c(a,b);return O(c,{resize:function(a,b){var e=Math.max(a|0,1),f=Math.max(b|0||e,1);if(e===d.width&&f===d.height)return c;for(var h=d.colorAttachments,l=0;l<h.length;++l)g(h[l],e,f);g(d.depthAttachment,e,f);g(d.stencilAttachment,
e,f);g(d.depthStencilAttachment,e,f);d.width=c.width=e;d.height=c.height=f;y(d);return c},_reglType:"framebuffer",_framebuffer:d,destroy:function(){p(d);h(d)},use:function(a){w.setFBO({framebuffer:c},a)}})}var w={cur:null,next:null,dirty:!1,setFBO:null},z=["rgba"],wa=["rgba4","rgb565","rgb5 a1"];b.ext_srgb&&wa.push("srgba");b.ext_color_buffer_half_float&&wa.push("rgba16f","rgb16f");b.webgl_color_buffer_float&&wa.push("rgba32f");var E=["uint8"];b.oes_texture_half_float&&E.push("half float","float16");
b.oes_texture_float&&E.push("float","float32");var B=0,D={};return O(w,{getFramebuffer:function(a){return"function"===typeof a&&"framebuffer"===a._reglType&&(a=a._framebuffer,a instanceof l)?a:null},create:C,createCube:function(a){function b(a){var e,f={color:null},g=0,h=null;e="rgba";var l="uint8",k=1;if("number"===typeof a)g=a|0;else if(a){"shape"in a?g=a.shape[0]:("radius"in a&&(g=a.radius|0),"width"in a?g=a.width|0:"height"in a&&(g=a.height|0));if("color"in a||"colors"in a)h=a.color||a.colors,
Array.isArray(h);h||("colorCount"in a&&(k=a.colorCount|0),"colorType"in a&&(l=a.colorType),"colorFormat"in a&&(e=a.colorFormat));"depth"in a&&(f.depth=a.depth);"stencil"in a&&(f.stencil=a.stencil);"depthStencil"in a&&(f.depthStencil=a.depthStencil)}else g=1;if(h)if(Array.isArray(h))for(a=[],e=0;e<h.length;++e)a[e]=h[e];else a=[h];else for(a=Array(k),h={radius:g,format:e,type:l},e=0;e<k;++e)a[e]=d.createCube(h);f.color=Array(a.length);for(e=0;e<a.length;++e)k=a[e],g=g||k.width,f.color[e]={target:34069,
data:a[e]};for(e=0;6>e;++e){for(k=0;k<a.length;++k)f.color[k].target=34069+e;0<e&&(f.depth=c[0].depth,f.stencil=c[0].stencil,f.depthStencil=c[0].depthStencil);if(c[e])c[e](f);else c[e]=C(f)}return O(b,{width:g,height:g,color:a})}var c=Array(6);b(a);return O(b,{faces:c,resize:function(a){var d=a|0;if(d===b.width)return b;var e=b.color;for(a=0;a<e.length;++a)e[a].resize(d);for(a=0;6>a;++a)c[a].resize(d);b.width=b.height=d;return b},_reglType:"framebufferCube",destroy:function(){c.forEach(function(a){a.destroy()})}})},
clear:function(){T(D).forEach(p)},restore:function(){w.cur=null;w.next=null;w.dirty=!0;T(D).forEach(function(b){b.framebuffer=a.createFramebuffer();y(b)})}})}function Za(){this.w=this.z=this.y=this.x=this.state=0;this.buffer=null;this.size=0;this.normalized=!1;this.type=5126;this.divisor=this.stride=this.offset=0}function Rb(a,b,c,d,f,e,m){function q(a){if(a!==p.currentVAO){var c=b.oes_vertex_array_object;a?c.bindVertexArrayOES(a.vao):c.bindVertexArrayOES(null);p.currentVAO=a}}function u(c){if(c!==
p.currentVAO){if(c)c.bindAttrs();else{for(var d=b.angle_instanced_arrays,e=0;e<g.length;++e){var f=g[e];f.buffer?(a.enableVertexAttribArray(e),f.buffer.bind(),a.vertexAttribPointer(e,f.size,f.type,f.normalized,f.stride,f.offfset),d&&f.divisor&&d.vertexAttribDivisorANGLE(e,f.divisor)):(a.disableVertexAttribArray(e),a.vertexAttrib4f(e,f.x,f.y,f.z,f.w))}m.elements?a.bindBuffer(34963,m.elements.buffer.buffer):a.bindBuffer(34963,null)}p.currentVAO=c}}function r(){T(h).forEach(function(a){a.destroy()})}
function k(){this.id=++l;this.attributes=[];this.elements=null;this.ownsElements=!1;this.offset=this.count=0;this.instances=-1;this.primitive=4;var a=b.oes_vertex_array_object;this.vao=a?a.createVertexArrayOES():null;h[this.id]=this;this.buffers=[]}function n(){b.oes_vertex_array_object&&T(h).forEach(function(a){a.refresh()})}var t=c.maxAttributes,g=Array(t);for(c=0;c<t;++c)g[c]=new Za;var l=0,h={},p={Record:Za,scope:{},state:g,currentVAO:null,targetVAO:null,restore:b.oes_vertex_array_object?n:function(){},
createVAO:function(a){function b(a){var d;Array.isArray(a)?(d=a,c.elements&&c.ownsElements&&c.elements.destroy(),c.elements=null,c.ownsElements=!1,c.offset=0,c.count=0,c.instances=-1,c.primitive=4):(a.elements?(d=a.elements,c.ownsElements?("function"===typeof d&&"elements"===d._reglType?c.elements.destroy():c.elements(d),c.ownsElements=!1):e.getElements(a.elements)?(c.elements=a.elements,c.ownsElements=!1):(c.elements=e.create(a.elements),c.ownsElements=!0)):(c.elements=null,c.ownsElements=!1),d=
a.attributes,c.offset=0,c.count=-1,c.instances=-1,c.primitive=4,c.elements&&(c.count=c.elements._elements.vertCount,c.primitive=c.elements._elements.primType),"offset"in a&&(c.offset=a.offset|0),"count"in a&&(c.count=a.count|0),"instances"in a&&(c.instances=a.instances|0),"primitive"in a&&(c.primitive=Ka[a.primitive]));a={};var g=c.attributes;g.length=d.length;for(var h=0;h<d.length;++h){var l=d[h],k=g[h]=new Za,n=l.data||l;if(Array.isArray(n)||P(n)||fa(n)){var p;c.buffers[h]&&(p=c.buffers[h],P(n)&&
p._buffer.byteLength>=n.byteLength?p.subdata(n):(p.destroy(),c.buffers[h]=null));c.buffers[h]||(p=c.buffers[h]=f.create(l,34962,!1,!0));k.buffer=f.getBuffer(p);k.size=k.buffer.dimension|0;k.normalized=!1;k.type=k.buffer.dtype;k.offset=0;k.stride=0;k.divisor=0;k.state=1;a[h]=1}else f.getBuffer(l)?(k.buffer=f.getBuffer(l),k.size=k.buffer.dimension|0,k.normalized=!1,k.type=k.buffer.dtype,k.offset=0,k.stride=0,k.divisor=0,k.state=1):f.getBuffer(l.buffer)?(k.buffer=f.getBuffer(l.buffer),k.size=(+l.size||
k.buffer.dimension)|0,k.normalized=!!l.normalized||!1,k.type="type"in l?Ja[l.type]:k.buffer.dtype,k.offset=(l.offset||0)|0,k.stride=(l.stride||0)|0,k.divisor=(l.divisor||0)|0,k.state=1):"x"in l&&(k.x=+l.x||0,k.y=+l.y||0,k.z=+l.z||0,k.w=+l.w||0,k.state=2)}for(p=0;p<c.buffers.length;++p)!a[p]&&c.buffers[p]&&(c.buffers[p].destroy(),c.buffers[p]=null);c.refresh();return b}var c=new k;d.vaoCount+=1;b.destroy=function(){for(var a=0;a<c.buffers.length;++a)c.buffers[a]&&c.buffers[a].destroy();c.buffers.length=
0;c.ownsElements&&(c.elements.destroy(),c.elements=null,c.ownsElements=!1);c.destroy()};b._vao=c;b._reglType="vao";return b(a)},getVAO:function(a){return"function"===typeof a&&a._vao?a._vao:null},destroyBuffer:function(b){for(var c=0;c<g.length;++c){var d=g[c];d.buffer===b&&(a.disableVertexAttribArray(c),d.buffer=null)}},setVAO:b.oes_vertex_array_object?q:u,clear:b.oes_vertex_array_object?r:function(){}};k.prototype.bindAttrs=function(){for(var c=b.angle_instanced_arrays,d=this.attributes,f=0;f<d.length;++f){var g=
d[f];g.buffer?(a.enableVertexAttribArray(f),a.bindBuffer(34962,g.buffer.buffer),a.vertexAttribPointer(f,g.size,g.type,g.normalized,g.stride,g.offset),c&&g.divisor&&c.vertexAttribDivisorANGLE(f,g.divisor)):(a.disableVertexAttribArray(f),a.vertexAttrib4f(f,g.x,g.y,g.z,g.w))}for(c=d.length;c<t;++c)a.disableVertexAttribArray(c);(c=e.getElements(this.elements))?a.bindBuffer(34963,c.buffer.buffer):a.bindBuffer(34963,null)};k.prototype.refresh=function(){var a=b.oes_vertex_array_object;a&&(a.bindVertexArrayOES(this.vao),
this.bindAttrs(),p.currentVAO=null,a.bindVertexArrayOES(null))};k.prototype.destroy=function(){if(this.vao){var a=b.oes_vertex_array_object;this===p.currentVAO&&(p.currentVAO=null,a.bindVertexArrayOES(null));a.deleteVertexArrayOES(this.vao);this.vao=null}this.ownsElements&&(this.elements.destroy(),this.elements=null,this.ownsElements=!1);h[this.id]&&(delete h[this.id],--d.vaoCount)};return p}function Sb(a,b,c,d){function f(a,b,c,d){this.name=a;this.id=b;this.location=c;this.info=d}function e(a,b){for(var c=
0;c<a.length;++c)if(a[c].id===b.id){a[c].location=b.location;return}a.push(b)}function m(c,d,e){e=35632===c?r:k;var f=e[d];if(!f){var g=b.str(d),f=a.createShader(c);a.shaderSource(f,g);a.compileShader(f);e[d]=f}return f}function q(a,b){this.id=g++;this.fragId=a;this.vertId=b;this.program=null;this.uniforms=[];this.attributes=[];this.refCount=1;d.profile&&(this.stats={uniformsCount:0,attributesCount:0})}function u(c,g,k){var n;n=m(35632,c.fragId);var t=m(35633,c.vertId);g=c.program=a.createProgram();
a.attachShader(g,n);a.attachShader(g,t);if(k)for(n=0;n<k.length;++n)t=k[n],a.bindAttribLocation(g,t[0],t[1]);a.linkProgram(g);t=a.getProgramParameter(g,35718);d.profile&&(c.stats.uniformsCount=t);var r=c.uniforms;for(n=0;n<t;++n)if(k=a.getActiveUniform(g,n))if(1<k.size)for(var q=0;q<k.size;++q){var u=k.name.replace("[0]","["+q+"]");e(r,new f(u,b.id(u),a.getUniformLocation(g,u),k))}else e(r,new f(k.name,b.id(k.name),a.getUniformLocation(g,k.name),k));t=a.getProgramParameter(g,35721);d.profile&&(c.stats.attributesCount=
t);c=c.attributes;for(n=0;n<t;++n)(k=a.getActiveAttrib(g,n))&&e(c,new f(k.name,b.id(k.name),a.getAttribLocation(g,k.name),k))}var r={},k={},n={},t=[],g=0;d.profile&&(c.getMaxUniformsCount=function(){var a=0;t.forEach(function(b){b.stats.uniformsCount>a&&(a=b.stats.uniformsCount)});return a},c.getMaxAttributesCount=function(){var a=0;t.forEach(function(b){b.stats.attributesCount>a&&(a=b.stats.attributesCount)});return a});return{clear:function(){var b=a.deleteShader.bind(a);T(r).forEach(b);r={};T(k).forEach(b);
k={};t.forEach(function(b){a.deleteProgram(b.program)});t.length=0;n={};c.shaderCount=0},program:function(b,d,e,f){var g=n[d];g||(g=n[d]={});var m=g[b];if(m&&(m.refCount++,!f))return m;var z=new q(d,b);c.shaderCount++;u(z,e,f);m||(g[b]=z);t.push(z);return O(z,{destroy:function(){z.refCount--;if(0>=z.refCount){a.deleteProgram(z.program);var b=t.indexOf(z);t.splice(b,1);c.shaderCount--}0>=g[z.vertId].refCount&&(a.deleteShader(k[z.vertId]),delete k[z.vertId],delete n[z.fragId][z.vertId]);Object.keys(n[z.fragId]).length||
(a.deleteShader(r[z.fragId]),delete r[z.fragId],delete n[z.fragId])}})},restore:function(){r={};k={};for(var a=0;a<t.length;++a)u(t[a],null,t[a].attributes.map(function(a){return[a.location,a.name]}))},shader:m,frag:-1,vert:-1}}function Tb(a,b,c,d,f,e,m){function q(e){var f;f=null===b.next?5121:b.next.colorAttachments[0].texture._texture.type;var n=0,t=0,g=d.framebufferWidth,l=d.framebufferHeight,h=null;P(e)?h=e:e&&(n=e.x|0,t=e.y|0,g=(e.width||d.framebufferWidth-n)|0,l=(e.height||d.framebufferHeight-
t)|0,h=e.data||null);c();e=g*l*4;h||(5121===f?h=new Uint8Array(e):5126===f&&(h=h||new Float32Array(e)));a.pixelStorei(3333,4);a.readPixels(n,t,g,l,6408,f,h);return h}function u(a){var c;b.setFBO({framebuffer:a.framebuffer},function(){c=q(a)});return c}return function(a){return a&&"framebuffer"in a?u(a):q(a)}}function Ub(a){for(var b=Array(a.length>>2),c=0;c<b.length;c++)b[c]=0;for(c=0;c<8*a.length;c+=8)b[c>>5]|=(a.charCodeAt(c/8)&255)<<24-c%32;var d=8*a.length;a=[1779033703,-1150833019,1013904242,
-1521486534,1359893119,-1694144372,528734635,1541459225];var c=Array(64),f,e,m,q,u,r,k,n,t,g,l;b[d>>5]|=128<<24-d%32;b[(d+64>>9<<4)+15]=d;for(n=0;n<b.length;n+=16){d=a[0];f=a[1];e=a[2];m=a[3];q=a[4];u=a[5];r=a[6];k=a[7];for(t=0;64>t;t++){if(16>t)c[t]=b[t+n];else{g=t;l=c[t-2];l=Y(l,17)^Y(l,19)^l>>>10;l=H(l,c[t-7]);var h;h=c[t-15];h=Y(h,7)^Y(h,18)^h>>>3;c[g]=H(H(l,h),c[t-16])}g=q;g=Y(g,6)^Y(g,11)^Y(g,25);g=H(H(H(H(k,g),q&u^~q&r),Vb[t]),c[t]);k=d;k=Y(k,2)^Y(k,13)^Y(k,22);l=H(k,d&f^d&e^f&e);k=r;r=u;u=
q;q=H(m,g);m=e;e=f;f=d;d=H(g,l)}a[0]=H(d,a[0]);a[1]=H(f,a[1]);a[2]=H(e,a[2]);a[3]=H(m,a[3]);a[4]=H(q,a[4]);a[5]=H(u,a[5]);a[6]=H(r,a[6]);a[7]=H(k,a[7])}b="";for(c=0;c<32*a.length;c+=8)b+=String.fromCharCode(a[c>>5]>>>24-c%32&255);return b}function Wb(a){for(var b="",c,d=0;d<a.length;d++)c=a.charCodeAt(d),b+="0123456789abcdef".charAt(c>>>4&15)+"0123456789abcdef".charAt(c&15);return b}function Xb(a){for(var b="",c=-1,d,f;++c<a.length;)d=a.charCodeAt(c),f=c+1<a.length?a.charCodeAt(c+1):0,55296<=d&&56319>=
d&&56320<=f&&57343>=f&&(d=65536+((d&1023)<<10)+(f&1023),c++),127>=d?b+=String.fromCharCode(d):2047>=d?b+=String.fromCharCode(192|d>>>6&31,128|d&63):65535>=d?b+=String.fromCharCode(224|d>>>12&15,128|d>>>6&63,128|d&63):2097151>=d&&(b+=String.fromCharCode(240|d>>>18&7,128|d>>>12&63,128|d>>>6&63,128|d&63));return b}function Y(a,b){return a>>>b|a<<32-b}function H(a,b){var c=(a&65535)+(b&65535);return(a>>16)+(b>>16)+(c>>16)<<16|c&65535}function Aa(a){return Array.prototype.slice.call(a)}function Ba(a){return Aa(a).join("")}
function Yb(a){function b(){var a=[],b=[];return O(function(){a.push.apply(a,Aa(arguments))},{def:function(){var c="v"+f++;b.push(c);0<arguments.length&&(a.push(c,"="),a.push.apply(a,Aa(arguments)),a.push(";"));return c},toString:function(){return Ba([0<b.length?"var "+b.join(",")+";":"",Ba(a)])}})}function c(){function a(b,e){d(b,e,"=",c.def(b,e),";")}var c=b(),d=b(),e=c.toString,f=d.toString;return O(function(){c.apply(c,Aa(arguments))},{def:c.def,entry:c,exit:d,save:a,set:function(b,d,e){a(b,d);
c(b,d,"=",e,";")},toString:function(){return e()+f()}})}var d=a&&a.cache,f=0,e=[],m=[],q=[],u=b(),r={};return{global:u,link:function(a,b){var c=b&&b.stable;if(!c)for(var d=0;d<m.length;++d)if(m[d]===a&&!q[d])return e[d];d="g"+f++;e.push(d);m.push(a);q.push(c);return d},block:b,proc:function(a,b){function d(){var a="a"+e.length;e.push(a);return a}var e=[];b=b||0;for(var f=0;f<b;++f)d();var f=c(),h=f.toString;return r[a]=O(f,{arg:d,toString:function(){return Ba(["function(",e.join(),"){",h(),"}"])}})},
scope:c,cond:function(){var a=Ba(arguments),b=c(),d=c(),e=b.toString,f=d.toString;return O(b,{then:function(){b.apply(b,Aa(arguments));return this},"else":function(){d.apply(d,Aa(arguments));return this},toString:function(){var b=f();b&&(b="else{"+b+"}");return Ba(["if(",a,"){",e(),"}",b])}})},compile:function(){var a=['"use strict";',u,"return {"];Object.keys(r).forEach(function(b){a.push('"',b,'":',r[b].toString(),",")});a.push("}");var b=Ba(a).replace(/;/g,";\n").replace(/}/g,"}\n").replace(/{/g,
"{\n"),c;if(d&&(c=Wb(Ub(Xb(b))),d[c]))return d[c].apply(null,m);b=Function.apply(null,e.concat(b));d&&(d[c]=b);return b.apply(null,m)}}}function Sa(a){return Array.isArray(a)||P(a)||fa(a)}function yb(a){return a.sort(function(a,c){return"viewport"===a?-1:"viewport"===c?1:a<c?-1:1})}function K(a,b,c,d){this.thisDep=a;this.contextDep=b;this.propDep=c;this.append=d}function la(a){return a&&!(a.thisDep||a.contextDep||a.propDep)}function E(a){return new K(!1,!1,!1,a)}function L(a,b){var c=a.type;if(0===
c)return c=a.data.length,new K(!0,1<=c,2<=c,b);if(4===c)return c=a.data,new K(c.thisDep,c.contextDep,c.propDep,b);if(5===c)return new K(!1,!1,!1,b);if(6===c){for(var d=c=!1,f=!1,e=0;e<a.data.length;++e){var m=a.data[e];1===m.type?f=!0:2===m.type?d=!0:3===m.type?c=!0:0===m.type?(c=!0,m=m.data,1<=m&&(d=!0),2<=m&&(f=!0)):4===m.type&&(c=c||m.data.thisDep,d=d||m.data.contextDep,f=f||m.data.propDep)}return new K(c,d,f,b)}return new K(3===c,2===c,1===c,b)}function Zb(a,b,c,d,f,e,m,q,u,r,k,n,t,g,l,h){function p(a){return a.replace(".",
"_")}function y(a,b,c){var d=p(a);Ma.push(a);Da[d]=ta[d]=!!c;ua[d]=b}function C(a,b,c){var d=p(a);Ma.push(a);Array.isArray(c)?(ta[d]=c.slice(),Da[d]=c.slice()):ta[d]=Da[d]=c;ma[d]=b}function w(){var a=Yb({cache:l}),c=a.link,d=a.global;a.id=ra++;a.batchId="0";var e=c(tb),f=a.shared={props:"a0"};Object.keys(tb).forEach(function(a){f[a]=d.def(e,".",a)});var g=a.next={},k=a.current={};Object.keys(ma).forEach(function(a){Array.isArray(ta[a])&&(g[a]=d.def(f.next,".",a),k[a]=d.def(f.current,".",a))});var ca=
a.constants={};Object.keys(Oa).forEach(function(a){ca[a]=d.def(JSON.stringify(Oa[a]))});a.invoke=function(b,d){switch(d.type){case 0:var e=["this",f.context,f.props,a.batchId];return b.def(c(d.data),".call(",e.slice(0,Math.max(d.data.length+1,4)),")");case 1:return b.def(f.props,d.data);case 2:return b.def(f.context,d.data);case 3:return b.def("this",d.data);case 4:return d.data.append(a,b),d.data.ref;case 5:return d.data.toString();case 6:return d.data.map(function(c){return a.invoke(b,c)})}};a.attribCache=
{};var N={};a.scopeAttrib=function(a){a=b.id(a);if(a in N)return N[a];var d=r.scope[a];d||(d=r.scope[a]=new ha);return N[a]=c(d)};return a}function z(a){var b=a["static"];a=a.dynamic;var c;if("profile"in b){var d=!!b.profile;c=E(function(a,b){return d});c.enable=d}else if("profile"in a){var e=a.profile;c=L(e,function(a,b){return a.invoke(b,e)})}return c}function B(a,b){var c=a["static"],d=a.dynamic;if("framebuffer"in c){var e=c.framebuffer;return e?(e=q.getFramebuffer(e),E(function(a,b){var c=a.link(e),
d=a.shared;b.set(d.framebuffer,".next",c);d=d.context;b.set(d,".framebufferWidth",c+".width");b.set(d,".framebufferHeight",c+".height");return c})):E(function(a,b){var c=a.shared;b.set(c.framebuffer,".next","null");c=c.context;b.set(c,".framebufferWidth",c+".drawingBufferWidth");b.set(c,".framebufferHeight",c+".drawingBufferHeight");return"null"})}if("framebuffer"in d){var f=d.framebuffer;return L(f,function(a,b){var c=a.invoke(b,f),d=a.shared,e=d.framebuffer,c=b.def(e,".getFramebuffer(",c,")");b.set(e,
".next",c);d=d.context;b.set(d,".framebufferWidth",c+"?"+c+".width:"+d+".drawingBufferWidth");b.set(d,".framebufferHeight",c+"?"+c+".height:"+d+".drawingBufferHeight");return c})}return null}function H(a,b,c){function d(a){if(a in e){var c=e[a];a=!0;var x=c.x|0,g=c.y|0,k,h;"width"in c?k=c.width|0:a=!1;"height"in c?h=c.height|0:a=!1;return new K(!a&&b&&b.thisDep,!a&&b&&b.contextDep,!a&&b&&b.propDep,function(a,b){var d=a.shared.context,e=k;"width"in c||(e=b.def(d,".","framebufferWidth","-",x));var f=
h;"height"in c||(f=b.def(d,".","framebufferHeight","-",g));return[x,g,e,f]})}if(a in f){var aa=f[a];a=L(aa,function(a,b){var c=a.invoke(b,aa),d=a.shared.context,e=b.def(c,".x|0"),f=b.def(c,".y|0"),N=b.def('"width" in ',c,"?",c,".width|0:","(",d,".","framebufferWidth","-",e,")"),c=b.def('"height" in ',c,"?",c,".height|0:","(",d,".","framebufferHeight","-",f,")");return[e,f,N,c]});b&&(a.thisDep=a.thisDep||b.thisDep,a.contextDep=a.contextDep||b.contextDep,a.propDep=a.propDep||b.propDep);return a}return b?
new K(b.thisDep,b.contextDep,b.propDep,function(a,b){var c=a.shared.context;return[0,0,b.def(c,".","framebufferWidth"),b.def(c,".","framebufferHeight")]}):null}var e=a["static"],f=a.dynamic;if(a=d("viewport")){var g=a;a=new K(a.thisDep,a.contextDep,a.propDep,function(a,b){var c=g.append(a,b),d=a.shared.context;b.set(d,".viewportWidth",c[2]);b.set(d,".viewportHeight",c[3]);return c})}return{viewport:a,scissor_box:d("scissor.box")}}function G(a,b){var c=a["static"];if("string"===typeof c.frag&&"string"===
typeof c.vert){if(0<Object.keys(b.dynamic).length)return null;var c=b["static"],d=Object.keys(c);if(0<d.length&&"number"===typeof c[d[0]]){for(var e=[],f=0;f<d.length;++f)e.push([c[d[f]]|0,d[f]]);return e}}return null}function D(a,c,d){function e(a){if(a in f){var c=b.id(f[a]);a=E(function(){return c});a.id=c;return a}if(a in g){var d=g[a];return L(d,function(a,b){var c=a.invoke(b,d);return b.def(a.shared.strings,".id(",c,")")})}return null}var f=a["static"],g=a.dynamic,h=e("frag"),ca=e("vert"),N=
null;la(h)&&la(ca)?(N=k.program(ca.id,h.id,null,d),a=E(function(a,b){return a.link(N)})):a=new K(h&&h.thisDep||ca&&ca.thisDep,h&&h.contextDep||ca&&ca.contextDep,h&&h.propDep||ca&&ca.propDep,function(a,b){var c=a.shared.shader,d;d=h?h.append(a,b):b.def(c,".","frag");var e;e=ca?ca.append(a,b):b.def(c,".","vert");return b.def(c+".program("+e+","+d+")")});return{frag:h,vert:ca,progVar:a,program:N}}function v(a,b){function c(a,b){if(a in d){var e=d[a]|0;b?g.offset=e:g.instances=e;return E(function(a,c){b&&
(a.OFFSET=e);return e})}if(a in f){var x=f[a];return L(x,function(a,c){var d=a.invoke(c,x);b&&(a.OFFSET=d);return d})}if(b){if(N)return E(function(a,b){return a.OFFSET=0});if(k)return new K(h.thisDep,h.contextDep,h.propDep,function(a,b){return b.def(a.shared.vao+".currentVAO?"+a.shared.vao+".currentVAO.offset:0")})}else if(k)return new K(h.thisDep,h.contextDep,h.propDep,function(a,b){return b.def(a.shared.vao+".currentVAO?"+a.shared.vao+".currentVAO.instances:-1")});return null}var d=a["static"],
f=a.dynamic,g={},k=!1,h=function(){if("vao"in d){var a=d.vao;null!==a&&null===r.getVAO(a)&&(a=r.createVAO(a));k=!0;g.vao=a;return E(function(b){var c=r.getVAO(a);return c?b.link(c):"null"})}if("vao"in f){k=!0;var b=f.vao;return L(b,function(a,c){var d=a.invoke(c,b);return c.def(a.shared.vao+".getVAO("+d+")")})}return null}(),N=!1,ia=function(){if("elements"in d){var a=d.elements;g.elements=a;if(Sa(a)){var b=g.elements=e.create(a,!0),a=e.getElements(b);N=!0}else a&&(a=e.getElements(a),N=!0);b=E(function(b,
c){if(a){var d=b.link(a);return b.ELEMENTS=d}return b.ELEMENTS=null});b.value=a;return b}if("elements"in f){N=!0;var c=f.elements;return L(c,function(a,b){var d=a.shared,e=d.isBufferArgs,d=d.elements,f=a.invoke(b,c),N=b.def("null"),e=b.def(e,"(",f,")"),f=a.cond(e).then(N,"=",d,".createStream(",f,");")["else"](N,"=",d,".getElements(",f,");");b.entry(f);b.exit(a.cond(e).then(d,".destroyStream(",N,");"));return a.ELEMENTS=N})}return k?new K(h.thisDep,h.contextDep,h.propDep,function(a,b){return b.def(a.shared.vao+
".currentVAO?"+a.shared.elements+".getElements("+a.shared.vao+".currentVAO.elements):null")}):null}(),va=c("offset",!0),l=function(){if("primitive"in d){var a=d.primitive;g.primitive=a;return E(function(b,c){return Ka[a]})}if("primitive"in f){var b=f.primitive;return L(b,function(a,c){var d=a.constants.primTypes,e=a.invoke(c,b);return c.def(d,"[",e,"]")})}return N?la(ia)?ia.value?E(function(a,b){return b.def(a.ELEMENTS,".primType")}):E(function(){return 4}):new K(ia.thisDep,ia.contextDep,ia.propDep,
function(a,b){var c=a.ELEMENTS;return b.def(c,"?",c,".primType:",4)}):k?new K(h.thisDep,h.contextDep,h.propDep,function(a,b){return b.def(a.shared.vao+".currentVAO?"+a.shared.vao+".currentVAO.primitive:4")}):null}(),n=function(){if("count"in d){var a=d.count|0;g.count=a;return E(function(){return a})}if("count"in f){var b=f.count;return L(b,function(a,c){return a.invoke(c,b)})}return N?la(ia)?ia?va?new K(va.thisDep,va.contextDep,va.propDep,function(a,b){return b.def(a.ELEMENTS,".vertCount-",a.OFFSET)}):
E(function(a,b){return b.def(a.ELEMENTS,".vertCount")}):E(function(){return-1}):new K(ia.thisDep||va.thisDep,ia.contextDep||va.contextDep,ia.propDep||va.propDep,function(a,b){var c=a.ELEMENTS;return a.OFFSET?b.def(c,"?",c,".vertCount-",a.OFFSET,":-1"):b.def(c,"?",c,".vertCount:-1")}):k?new K(h.thisDep,h.contextDep,h.propDep,function(a,b){return b.def(a.shared.vao,".currentVAO?",a.shared.vao,".currentVAO.count:-1")}):null}(),m=c("instances",!1);return{elements:ia,primitive:l,count:n,instances:m,offset:va,
vao:h,vaoActive:k,elementsActive:N,"static":g}}function ba(a,b){var c=a["static"],d=a.dynamic,e={};Ma.forEach(function(a){function b(N,g){if(a in c){var x=N(c[a]);e[f]=E(function(){return x})}else if(a in d){var F=d[a];e[f]=L(F,function(a,b){return g(a,b,a.invoke(b,F))})}}var f=p(a);switch(a){case "cull.enable":case "blend.enable":case "dither":case "stencil.enable":case "depth.enable":case "scissor.enable":case "polygonOffset.enable":case "sample.alpha":case "sample.enable":case "depth.mask":return b(function(a){return a},
function(a,b,c){return c});case "depth.func":return b(function(a){return $a[a]},function(a,b,c){return b.def(a.constants.compareFuncs,"[",c,"]")});case "depth.range":return b(function(a){return a},function(a,b,c){a=b.def("+",c,"[0]");b=b.def("+",c,"[1]");return[a,b]});case "blend.func":return b(function(a){return[Ga["srcRGB"in a?a.srcRGB:a.src],Ga["dstRGB"in a?a.dstRGB:a.dst],Ga["srcAlpha"in a?a.srcAlpha:a.src],Ga["dstAlpha"in a?a.dstAlpha:a.dst]]},function(a,b,c){function d(a,e){return b.def('"',
a,e,'" in ',c,"?",c,".",a,e,":",c,".",a)}a=a.constants.blendFuncs;var e=d("src","RGB"),f=d("dst","RGB"),e=b.def(a,"[",e,"]"),g=b.def(a,"[",d("src","Alpha"),"]"),f=b.def(a,"[",f,"]");a=b.def(a,"[",d("dst","Alpha"),"]");return[e,f,g,a]});case "blend.equation":return b(function(a){if("string"===typeof a)return[X[a],X[a]];if("object"===typeof a)return[X[a.rgb],X[a.alpha]]},function(a,b,c){var d=a.constants.blendEquations,e=b.def(),f=b.def();a=a.cond("typeof ",c,'==="string"');a.then(e,"=",f,"=",d,"[",
c,"];");a["else"](e,"=",d,"[",c,".rgb];",f,"=",d,"[",c,".alpha];");b(a);return[e,f]});case "blend.color":return b(function(a){return S(4,function(b){return+a[b]})},function(a,b,c){return S(4,function(a){return b.def("+",c,"[",a,"]")})});case "stencil.mask":return b(function(a){return a|0},function(a,b,c){return b.def(c,"|0")});case "stencil.func":return b(function(a){return[$a[a.cmp||"keep"],a.ref||0,"mask"in a?a.mask:-1]},function(a,b,c){a=b.def('"cmp" in ',c,"?",a.constants.compareFuncs,"[",c,".cmp]",
":",7680);var d=b.def(c,".ref|0");b=b.def('"mask" in ',c,"?",c,".mask|0:-1");return[a,d,b]});case "stencil.opFront":case "stencil.opBack":return b(function(b){return["stencil.opBack"===a?1029:1028,Ta[b.fail||"keep"],Ta[b.zfail||"keep"],Ta[b.zpass||"keep"]]},function(b,c,d){function e(a){return c.def('"',a,'" in ',d,"?",f,"[",d,".",a,"]:",7680)}var f=b.constants.stencilOps;return["stencil.opBack"===a?1029:1028,e("fail"),e("zfail"),e("zpass")]});case "polygonOffset.offset":return b(function(a){return[a.factor|
0,a.units|0]},function(a,b,c){a=b.def(c,".factor|0");b=b.def(c,".units|0");return[a,b]});case "cull.face":return b(function(a){var b=0;"front"===a?b=1028:"back"===a&&(b=1029);return b},function(a,b,c){return b.def(c,'==="front"?',1028,":",1029)});case "lineWidth":return b(function(a){return a},function(a,b,c){return c});case "frontFace":return b(function(a){return zb[a]},function(a,b,c){return b.def(c+'==="cw"?2304:2305')});case "colorMask":return b(function(a){return a.map(function(a){return!!a})},
function(a,b,c){return S(4,function(a){return"!!"+c+"["+a+"]"})});case "sample.coverage":return b(function(a){return["value"in a?a.value:1,!!a.invert]},function(a,b,c){a=b.def('"value" in ',c,"?+",c,".value:1");b=b.def("!!",c,".invert");return[a,b]})}});return e}function P(a,b){var c=a["static"],d=a.dynamic,e={};Object.keys(c).forEach(function(a){var b=c[a],d;if("number"===typeof b||"boolean"===typeof b)d=E(function(){return b});else if("function"===typeof b){var f=b._reglType;if("texture2d"===f||
"textureCube"===f)d=E(function(a){return a.link(b)});else if("framebuffer"===f||"framebufferCube"===f)d=E(function(a){return a.link(b.color[0])})}else qa(b)&&(d=E(function(a){return a.global.def("[",S(b.length,function(a){return b[a]}),"]")}));d.value=b;e[a]=d});Object.keys(d).forEach(function(a){var b=d[a];e[a]=L(b,function(a,c){return a.invoke(c,b)})});return e}function A(a,c){var d=a["static"],e=a.dynamic,g={};Object.keys(d).forEach(function(a){var c=d[a],e=b.id(a),x=new ha;if(Sa(c))x.state=1,
x.buffer=f.getBuffer(f.create(c,34962,!1,!0)),x.type=0;else{var F=f.getBuffer(c);if(F)x.state=1,x.buffer=F,x.type=0;else if("constant"in c){var h=c.constant;x.buffer="null";x.state=2;"number"===typeof h?x.x=h:Ca.forEach(function(a,b){b<h.length&&(x[a]=h[b])})}else{var F=Sa(c.buffer)?f.getBuffer(f.create(c.buffer,34962,!1,!0)):f.getBuffer(c.buffer),k=c.offset|0,l=c.stride|0,n=c.size|0,Fa=!!c.normalized,m=0;"type"in c&&(m=Ja[c.type]);c=c.divisor|0;x.buffer=F;x.state=1;x.size=n;x.normalized=Fa;x.type=
m||F.dtype;x.offset=k;x.stride=l;x.divisor=c}}g[a]=E(function(a,b){var c=a.attribCache;if(e in c)return c[e];var d={isStream:!1};Object.keys(x).forEach(function(a){d[a]=x[a]});x.buffer&&(d.buffer=a.link(x.buffer),d.type=d.type||d.buffer+".dtype");return c[e]=d})});Object.keys(e).forEach(function(a){var b=e[a];g[a]=L(b,function(a,c){function d(a){c(F[a],"=",e,".",a,"|0;")}var e=a.invoke(c,b),f=a.shared,g=a.constants,x=f.isBufferArgs,f=f.buffer,F={isStream:c.def(!1)},h=new ha;h.state=1;Object.keys(h).forEach(function(a){F[a]=
c.def(""+h[a])});var k=F.buffer,l=F.type;c("if(",x,"(",e,")){",F.isStream,"=true;",k,"=",f,".createStream(",34962,",",e,");",l,"=",k,".dtype;","}else{",k,"=",f,".getBuffer(",e,");","if(",k,"){",l,"=",k,".dtype;",'}else if("constant" in ',e,"){",F.state,"=",2,";","if(typeof "+e+'.constant === "number"){',F[Ca[0]],"=",e,".constant;",Ca.slice(1).map(function(a){return F[a]}).join("="),"=0;","}else{",Ca.map(function(a,b){return F[a]+"="+e+".constant.length>"+b+"?"+e+".constant["+b+"]:0;"}).join(""),"}}else{",
"if(",x,"(",e,".buffer)){",k,"=",f,".createStream(",34962,",",e,".buffer);","}else{",k,"=",f,".getBuffer(",e,".buffer);","}",l,'="type" in ',e,"?",g.glTypes,"[",e,".type]:",k,".dtype;",F.normalized,"=!!",e,".normalized;");d("size");d("offset");d("stride");d("divisor");c("}}");c.exit("if(",F.isStream,"){",f,".destroyStream(",k,");","}");return F})});return g}function J(a){var b=a["static"],c=a.dynamic,d={};Object.keys(b).forEach(function(a){var c=b[a];d[a]=E(function(a,b){return"number"===typeof c||
"boolean"===typeof c?""+c:a.link(c)})});Object.keys(c).forEach(function(a){var b=c[a];d[a]=L(b,function(a,c){return a.invoke(c,b)})});return d}function oa(a,b,d,e,f){function g(a){var b=l[a];b&&(m[a]=b)}var k=G(a,b),h=B(a,f),l=H(a,h,f),n=v(a,f),m=ba(a,f),q=D(a,f,k);g("viewport");g(p("scissor.box"));var t=0<Object.keys(m).length,h={framebuffer:h,draw:n,shader:q,state:m,dirty:t,scopeVAO:null,drawVAO:null,useVAO:!1,attributes:{}};h.profile=z(a,f);h.uniforms=P(d,f);h.drawVAO=h.scopeVAO=n.vao;if(!h.drawVAO&&
q.program&&!k&&c.angle_instanced_arrays&&n["static"].elements){var u=!0;a=q.program.attributes.map(function(a){a=b["static"][a];u=u&&!!a;return a});if(u&&0<a.length){var $b=r.getVAO(r.createVAO({attributes:a,elements:n["static"].elements}));h.drawVAO=new K(null,null,null,function(a,b){return a.link($b)});h.useVAO=!0}}k?h.useVAO=!0:h.attributes=A(b,f);h.context=J(e,f);return h}function na(a,b,c){var d=a.shared.context,e=a.scope();Object.keys(c).forEach(function(f){b.save(d,"."+f);var g=c[f].append(a,
b);Array.isArray(g)?e(d,".",f,"=[",g.join(),"];"):e(d,".",f,"=",g,";")});b(e)}function V(a,b,c,d){var e=a.shared,f=e.gl,g=e.framebuffer,h;R&&(h=b.def(e.extensions,".webgl_draw_buffers"));var k=a.constants,e=k.drawBuffer,k=k.backBuffer;a=c?c.append(a,b):b.def(g,".next");d||b("if(",a,"!==",g,".cur){");b("if(",a,"){",f,".bindFramebuffer(",36160,",",a,".framebuffer);");R&&b(h,".drawBuffersWEBGL(",e,"[",a,".colorAttachments.length]);");b("}else{",f,".bindFramebuffer(",36160,",null);");R&&b(h,".drawBuffersWEBGL(",
k,");");b("}",g,".cur=",a,";");d||b("}")}function T(a,b,c){var d=a.shared,e=d.gl,f=a.current,g=a.next,h=d.current,k=d.next,l=a.cond(h,".dirty");Ma.forEach(function(b){b=p(b);if(!(b in c.state)){var d,F;if(b in g){d=g[b];F=f[b];var n=S(ta[b].length,function(a){return l.def(d,"[",a,"]")});l(a.cond(n.map(function(a,b){return a+"!=="+F+"["+b+"]"}).join("||")).then(e,".",ma[b],"(",n,");",n.map(function(a,b){return F+"["+b+"]="+a}).join(";"),";"))}else d=l.def(k,".",b),n=a.cond(d,"!==",h,".",b),l(n),b in
ua?n(a.cond(d).then(e,".enable(",ua[b],");")["else"](e,".disable(",ua[b],");"),h,".",b,"=",d,";"):n(e,".",ma[b],"(",d,");",h,".",b,"=",d,";")}});0===Object.keys(c.state).length&&l(h,".dirty=false;");b(l)}function W(a,b,c,d){var e=a.shared,f=a.current,g=e.current,h=e.gl,k;yb(Object.keys(c)).forEach(function(e){var l=c[e];if(!d||d(l)){var n=l.append(a,b);if(ua[e]){var m=ua[e];la(l)?(k=a.link(n,{stable:!0}),b(a.cond(k).then(h,".enable(",m,");")["else"](h,".disable(",m,");")),b(g,".",e,"=",k,";")):(b(a.cond(n).then(h,
".enable(",m,");")["else"](h,".disable(",m,");")),b(g,".",e,"=",n,";"))}else if(qa(n)){var p=f[e];b(h,".",ma[e],"(",n,");",n.map(function(a,b){return p+"["+b+"]="+a}).join(";"),";")}else la(l)?(k=a.link(n,{stable:!0}),b(h,".",ma[e],"(",k,");",g,".",e,"=",k,";")):b(h,".",ma[e],"(",n,");",g,".",e,"=",n,";")}})}function Q(a,b){sa&&(a.instancing=b.def(a.shared.extensions,".angle_instanced_arrays"))}function I(a,b,c,d,e){function f(){return"undefined"===typeof performance?"Date.now()":"performance.now()"}
function h(a){t=b.def();a(t,"=",f(),";");"string"===typeof e?a(m,".count+=",e,";"):a(m,".count++;");g&&(d?(r=b.def(),a(r,"=",q,".getNumPendingQueries();")):a(q,".beginQuery(",m,");"))}function k(a){a(m,".cpuTime+=",f(),"-",t,";");g&&(d?a(q,".pushScopeStats(",r,",",q,".getNumPendingQueries(),",m,");"):a(q,".endQuery();"))}function l(a){var c=b.def(p,".profile");b(p,".profile=",a,";");b.exit(p,".profile=",c,";")}var n=a.shared,m=a.stats,p=n.current,q=n.timer;c=c.profile;var t,r;if(c){if(la(c)){c.enable?
(h(b),k(b.exit),l("true")):l("false");return}c=c.append(a,b);l(c)}else c=b.def(p,".profile");n=a.block();h(n);b("if(",c,"){",n,"}");a=a.block();k(a);b.exit("if(",c,"){",a,"}")}function M(a,b,c,d,e){function f(a){switch(a){case 35664:case 35667:case 35671:return 2;case 35665:case 35668:case 35672:return 3;case 35666:case 35669:case 35673:return 4;default:return 1}}function g(c,d,e){function f(){b("if(!",m,".buffer){",n,".enableVertexAttribArray(",l,");}");var c=e.type,g;g=e.size?b.def(e.size,"||",
d):d;b("if(",m,".type!==",c,"||",m,".size!==",g,"||",q.map(function(a){return m+"."+a+"!=="+e[a]}).join("||"),"){",n,".bindBuffer(",34962,",",p,".buffer);",n,".vertexAttribPointer(",[l,g,c,e.normalized,e.stride,e.offset],");",m,".type=",c,";",m,".size=",g,";",q.map(function(a){return m+"."+a+"="+e[a]+";"}).join(""),"}");sa&&(c=e.divisor,b("if(",m,".divisor!==",c,"){",a.instancing,".vertexAttribDivisorANGLE(",[l,c],");",m,".divisor=",c,";}"))}function k(){b("if(",m,".buffer){",n,".disableVertexAttribArray(",
l,");",m,".buffer=null;","}if(",Ca.map(function(a,b){return m+"."+a+"!=="+aa[b]}).join("||"),"){",n,".vertexAttrib4f(",l,",",aa,");",Ca.map(function(a,b){return m+"."+a+"="+aa[b]+";"}).join(""),"}")}var n=h.gl,l=b.def(c,".location"),m=b.def(h.attributes,"[",l,"]");c=e.state;var p=e.buffer,aa=[e.x,e.y,e.z,e.w],q=["buffer","normalized","offset","stride"];1===c?f():2===c?k():(b("if(",c,"===",1,"){"),f(),b("}else{"),k(),b("}"))}var h=a.shared;d.forEach(function(d){var h=d.name,k=c.attributes[h],l;if(k){if(!e(k))return;
l=k.append(a,b)}else{if(!e(Ab))return;var n=a.scopeAttrib(h);l={};Object.keys(new ha).forEach(function(a){l[a]=b.def(n,".",a)})}g(a.link(d),f(d.info.type),l)})}function U(a,c,d,e,f,g){for(var h=a.shared,k=h.gl,l,n=0;n<e.length;++n){var m=e[n],p=m.name,q=m.info.type,t=d.uniforms[p],m=a.link(m)+".location",r;if(t){if(!f(t))continue;if(la(t)){p=t.value;if(35678===q||35680===q)q=a.link(p._texture||p.color[0]._texture),c(k,".uniform1i(",m,",",q+".bind());"),c.exit(q,".unbind();");else if(35674===q||35675===
q||35676===q)p=a.global.def("new Float32Array(["+Array.prototype.slice.call(p)+"])"),t=2,35675===q?t=3:35676===q&&(t=4),c(k,".uniformMatrix",t,"fv(",m,",false,",p,");");else{switch(q){case 5126:l="1f";break;case 35664:l="2f";break;case 35665:l="3f";break;case 35666:l="4f";break;case 35670:l="1i";break;case 5124:l="1i";break;case 35671:l="2i";break;case 35667:l="2i";break;case 35672:l="3i";break;case 35668:l="3i";break;case 35673:l="4i";break;case 35669:l="4i"}c(k,".uniform",l,"(",m,",",qa(p)?Array.prototype.slice.call(p):
p,");")}continue}else r=t.append(a,c)}else{if(!f(Ab))continue;r=c.def(h.uniforms,"[",b.id(p),"]")}35678===q?c("if(",r,"&&",r,'._reglType==="framebuffer"){',r,"=",r,".color[0];","}"):35680===q&&c("if(",r,"&&",r,'._reglType==="framebufferCube"){',r,"=",r,".color[0];","}");p=1;switch(q){case 35678:case 35680:q=c.def(r,"._texture");c(k,".uniform1i(",m,",",q,".bind());");c.exit(q,".unbind();");continue;case 5124:case 35670:l="1i";break;case 35667:case 35671:l="2i";p=2;break;case 35668:case 35672:l="3i";
p=3;break;case 35669:case 35673:l="4i";p=4;break;case 5126:l="1f";break;case 35664:l="2f";p=2;break;case 35665:l="3f";p=3;break;case 35666:l="4f";p=4;break;case 35674:l="Matrix2fv";break;case 35675:l="Matrix3fv";break;case 35676:l="Matrix4fv"}if("M"===l.charAt(0)){c(k,".uniform",l,"(",m,",");var m=Math.pow(q-35674+2,2),u=a.global.def("new Float32Array(",m,")");Array.isArray(r)?c("false,(",S(m,function(a){return u+"["+a+"]="+r[a]}),",",u,")"):c("false,(Array.isArray(",r,")||",r," instanceof Float32Array)?",
r,":(",S(m,function(a){return u+"["+a+"]="+r+"["+a+"]"}),",",u,")");c(");")}else{if(1<p){for(var q=[],v=[],t=0;t<p;++t)Array.isArray(r)?v.push(r[t]):v.push(c.def(r+"["+t+"]")),g&&q.push(c.def());g&&c("if(!",a.batchId,"||",q.map(function(a,b){return a+"!=="+v[b]}).join("||"),"){",q.map(function(a,b){return a+"="+v[b]+";"}).join(""));c(k,".uniform",l,"(",m,",",v.join(","),");")}else g&&(q=c.def(),c("if(!",a.batchId,"||",q,"!==",r,"){",q,"=",r,";")),c(k,".uniform",l,"(",m,",",r,");");g&&c("}")}}}function Y(a,
b,c,d){function e(f){var g=n[f];return g?g.contextDep&&d.contextDynamic||g.propDep?g.append(a,c):g.append(a,b):b.def(l,".",f)}function f(){function a(){c(u,".drawElementsInstancedANGLE(",[p,t,v,q+"<<(("+v+"-5121)>>1)",r],");")}function b(){c(u,".drawArraysInstancedANGLE(",[p,q,t,r],");")}m&&"null"!==m?y?a():(c("if(",m,"){"),a(),c("}else{"),b(),c("}")):b()}function g(){function a(){c(k+".drawElements("+[p,t,v,q+"<<(("+v+"-5121)>>1)"]+");")}function b(){c(k+".drawArrays("+[p,q,t]+");")}m&&"null"!==
m?y?a():(c("if(",m,"){"),a(),c("}else{"),b(),c("}")):b()}var h=a.shared,k=h.gl,l=h.draw,n=d.draw,m=function(){var e=n.elements,f=b;if(e){if(e.contextDep&&d.contextDynamic||e.propDep)f=c;e=e.append(a,f);n.elementsActive&&f("if("+e+")"+k+".bindBuffer(34963,"+e+".buffer.buffer);")}else e=f.def(),f(e,"=",l,".","elements",";","if(",e,"){",k,".bindBuffer(",34963,",",e,".buffer.buffer);}","else if(",h.vao,".currentVAO){",e,"=",a.shared.elements+".getElements("+h.vao,".currentVAO.elements);",ja?"":"if("+
e+")"+k+".bindBuffer(34963,"+e+".buffer.buffer);","}");return e}(),p=e("primitive"),q=e("offset"),t=function(){var e=n.count,f=b;if(e){if(e.contextDep&&d.contextDynamic||e.propDep)f=c;e=e.append(a,f)}else e=f.def(l,".","count");return e}();if("number"===typeof t){if(0===t)return}else c("if(",t,"){"),c.exit("}");var r,u;sa&&(r=e("instances"),u=a.instancing);var v=m+".type",y=n.elements&&la(n.elements)&&!n.vaoActive;sa&&("number"!==typeof r||0<=r)?"string"===typeof r?(c("if(",r,">0){"),f(),c("}else if(",
r,"<0){"),g(),c("}")):f():g()}function xa(a,b,c,d,e){b=w();e=b.proc("body",e);sa&&(b.instancing=e.def(b.shared.extensions,".angle_instanced_arrays"));a(b,e,c,d);return b.compile().body}function da(a,b,c,d){Q(a,b);c.useVAO?c.drawVAO?b(a.shared.vao,".setVAO(",c.drawVAO.append(a,b),");"):b(a.shared.vao,".setVAO(",a.shared.vao,".targetVAO);"):(b(a.shared.vao,".setVAO(null);"),M(a,b,c,d.attributes,function(){return!0}));U(a,b,c,d.uniforms,function(){return!0},!1);Y(a,b,b,c)}function pa(a,b){var c=a.proc("draw",
1);Q(a,c);na(a,c,b.context);V(a,c,b.framebuffer);T(a,c,b);W(a,c,b.state);I(a,c,b,!1,!0);var d=b.shader.progVar.append(a,c);c(a.shared.gl,".useProgram(",d,".program);");if(b.shader.program)da(a,c,b,b.shader.program);else{c(a.shared.vao,".setVAO(null);");var e=a.global.def("{}"),f=c.def(d,".id"),g=c.def(e,"[",f,"]");c(a.cond(g).then(g,".call(this,a0);")["else"](g,"=",e,"[",f,"]=",a.link(function(c){return xa(da,a,b,c,1)}),"(",d,");",g,".call(this,a0);"))}0<Object.keys(b.state).length&&c(a.shared.current,
".dirty=true;");a.shared.vao&&c(a.shared.vao,".setVAO(null);")}function ga(a,b,c,d){function e(){return!0}a.batchId="a1";Q(a,b);M(a,b,c,d.attributes,e);U(a,b,c,d.uniforms,e,!1);Y(a,b,b,c)}function Ea(a,b,c,d){function e(a){return a.contextDep&&g||a.propDep}function f(a){return!e(a)}Q(a,b);var g=c.contextDep,h=b.def(),k=b.def();a.shared.props=k;a.batchId=h;var l=a.scope(),n=a.scope();b(l.entry,"for(",h,"=0;",h,"<","a1",";++",h,"){",k,"=","a0","[",h,"];",n,"}",l.exit);c.needsContext&&na(a,n,c.context);
c.needsFramebuffer&&V(a,n,c.framebuffer);W(a,n,c.state,e);c.profile&&e(c.profile)&&I(a,n,c,!1,!0);d?(c.useVAO?c.drawVAO?e(c.drawVAO)?n(a.shared.vao,".setVAO(",c.drawVAO.append(a,n),");"):l(a.shared.vao,".setVAO(",c.drawVAO.append(a,l),");"):l(a.shared.vao,".setVAO(",a.shared.vao,".targetVAO);"):(l(a.shared.vao,".setVAO(null);"),M(a,l,c,d.attributes,f),M(a,n,c,d.attributes,e)),U(a,l,c,d.uniforms,f,!1),U(a,n,c,d.uniforms,e,!0),Y(a,l,n,c)):(b=a.global.def("{}"),d=c.shader.progVar.append(a,n),k=n.def(d,
".id"),l=n.def(b,"[",k,"]"),n(a.shared.gl,".useProgram(",d,".program);","if(!",l,"){",l,"=",b,"[",k,"]=",a.link(function(b){return xa(ga,a,c,b,2)}),"(",d,");}",l,".call(this,a0[",h,"],",h,");"))}function Qa(a,b){function c(a){return a.contextDep&&e||a.propDep}var d=a.proc("batch",2);a.batchId="0";Q(a,d);var e=!1,f=!0;Object.keys(b.context).forEach(function(a){e=e||b.context[a].propDep});e||(na(a,d,b.context),f=!1);var g=b.framebuffer,h=!1;g?(g.propDep?e=h=!0:g.contextDep&&e&&(h=!0),h||V(a,d,g)):V(a,
d,null);b.state.viewport&&b.state.viewport.propDep&&(e=!0);T(a,d,b);W(a,d,b.state,function(a){return!c(a)});b.profile&&c(b.profile)||I(a,d,b,!1,"a1");b.contextDep=e;b.needsContext=f;b.needsFramebuffer=h;f=b.shader.progVar;if(f.contextDep&&e||f.propDep)Ea(a,d,b,null);else if(f=f.append(a,d),d(a.shared.gl,".useProgram(",f,".program);"),b.shader.program)Ea(a,d,b,b.shader.program);else{d(a.shared.vao,".setVAO(null);");var g=a.global.def("{}"),h=d.def(f,".id"),k=d.def(g,"[",h,"]");d(a.cond(k).then(k,".call(this,a0,a1);")["else"](k,
"=",g,"[",h,"]=",a.link(function(c){return xa(Ea,a,b,c,2)}),"(",f,");",k,".call(this,a0,a1);"))}0<Object.keys(b.state).length&&d(a.shared.current,".dirty=true;");a.shared.vao&&d(a.shared.vao,".setVAO(null);")}function ea(a,c){function d(b){var g=c.shader[b];g&&(g=g.append(a,e),isNaN(g)?e.set(f.shader,"."+b,g):e.set(f.shader,"."+b,a.link(g,{stable:!0})))}var e=a.proc("scope",3);a.batchId="a2";var f=a.shared,g=f.current;na(a,e,c.context);c.framebuffer&&c.framebuffer.append(a,e);yb(Object.keys(c.state)).forEach(function(b){var d=
c.state[b],g=d.append(a,e);qa(g)?g.forEach(function(c,d){isNaN(c)?e.set(a.next[b],"["+d+"]",c):e.set(a.next[b],"["+d+"]",a.link(c,{stable:!0}))}):la(d)?e.set(f.next,"."+b,a.link(g,{stable:!0})):e.set(f.next,"."+b,g)});I(a,e,c,!0,!0);["elements","offset","count","instances","primitive"].forEach(function(b){var d=c.draw[b];d&&(d=d.append(a,e),isNaN(d)?e.set(f.draw,"."+b,d):e.set(f.draw,"."+b,a.link(d),{stable:!0}))});Object.keys(c.uniforms).forEach(function(d){var g=c.uniforms[d].append(a,e);Array.isArray(g)&&
(g="["+g.map(function(b){return isNaN(b)?b:a.link(b,{stable:!0})})+"]");e.set(f.uniforms,"["+a.link(b.id(d),{stable:!0})+"]",g)});Object.keys(c.attributes).forEach(function(b){var d=c.attributes[b].append(a,e),f=a.scopeAttrib(b);Object.keys(new ha).forEach(function(a){e.set(f,"."+a,d[a])})});if(c.scopeVAO){var h=c.scopeVAO.append(a,e);isNaN(h)?e.set(f.vao,".targetVAO",h):e.set(f.vao,".targetVAO",a.link(h,{stable:!0}))}d("vert");d("frag");0<Object.keys(c.state).length&&(e(g,".dirty=true;"),e.exit(g,
".dirty=true;"));e("a1(",a.shared.context,",a0,",a.batchId,");")}function fa(a){if("object"===typeof a&&!qa(a)){for(var b=Object.keys(a),c=0;c<b.length;++c)if(Z.isDynamic(a[b[c]]))return!0;return!1}}function ka(a,b,c){function d(a,b){g.forEach(function(c){var d=e[c];Z.isDynamic(d)&&(d=a.invoke(b,d),b(n,".",c,"=",d,";"))})}var e=b["static"][c];if(e&&fa(e)){var f=a.global,g=Object.keys(e),h=!1,k=!1,l=!1,n=a.global.def("{}");g.forEach(function(b){var c=e[b];if(Z.isDynamic(c))"function"===typeof c&&(c=
e[b]=Z.unbox(c)),b=L(c,null),h=h||b.thisDep,l=l||b.propDep,k=k||b.contextDep;else{f(n,".",b,"=");switch(typeof c){case "number":f(c);break;case "string":f('"',c,'"');break;case "object":Array.isArray(c)&&f("[",c.join(),"]");break;default:f(a.link(c))}f(";")}});b.dynamic[c]=new Z.DynamicVariable(4,{thisDep:h,contextDep:k,propDep:l,ref:n,append:d});delete b["static"][c]}}var ha=r.Record,X={add:32774,subtract:32778,"reverse subtract":32779};c.ext_blend_minmax&&(X.min=32775,X.max=32776);var sa=c.angle_instanced_arrays,
R=c.webgl_draw_buffers,ja=c.oes_vertex_array_object,ta={dirty:!0,profile:h.profile},Da={},Ma=[],ua={},ma={};y("dither",3024);y("blend.enable",3042);C("blend.color","blendColor",[0,0,0,0]);C("blend.equation","blendEquationSeparate",[32774,32774]);C("blend.func","blendFuncSeparate",[1,0,1,0]);y("depth.enable",2929,!0);C("depth.func","depthFunc",513);C("depth.range","depthRange",[0,1]);C("depth.mask","depthMask",!0);C("colorMask","colorMask",[!0,!0,!0,!0]);y("cull.enable",2884);C("cull.face","cullFace",
1029);C("frontFace","frontFace",2305);C("lineWidth","lineWidth",1);y("polygonOffset.enable",32823);C("polygonOffset.offset","polygonOffset",[0,0]);y("sample.alpha",32926);y("sample.enable",32928);C("sample.coverage","sampleCoverage",[1,!1]);y("stencil.enable",2960);C("stencil.mask","stencilMask",-1);C("stencil.func","stencilFunc",[519,0,-1]);C("stencil.opFront","stencilOpSeparate",[1028,7680,7680,7680]);C("stencil.opBack","stencilOpSeparate",[1029,7680,7680,7680]);y("scissor.enable",3089);C("scissor.box",
"scissor",[0,0,a.drawingBufferWidth,a.drawingBufferHeight]);C("viewport","viewport",[0,0,a.drawingBufferWidth,a.drawingBufferHeight]);var tb={gl:a,context:t,strings:b,next:Da,current:ta,draw:n,elements:e,buffer:f,shader:k,attributes:r.state,vao:r,uniforms:u,framebuffer:q,extensions:c,timer:g,isBufferArgs:Sa},Oa={primTypes:Ka,compareFuncs:$a,blendFuncs:Ga,blendEquations:X,stencilOps:Ta,glTypes:Ja,orientationType:zb};R&&(Oa.backBuffer=[1029],Oa.drawBuffer=S(d.maxDrawbuffers,function(a){return 0===a?
[0]:S(a,function(a){return 36064+a})}));var ra=0;return{next:Da,current:ta,procs:function(){var a=w(),b=a.proc("poll"),e=a.proc("refresh"),f=a.block();b(f);e(f);var g=a.shared,h=g.gl,k=g.next,l=g.current;f(l,".dirty=false;");V(a,b);V(a,e,null,!0);var n;sa&&(n=a.link(sa));c.oes_vertex_array_object&&e(a.link(c.oes_vertex_array_object),".bindVertexArrayOES(null);");var g=e.def(g.attributes),m=e.def(0),p=a.cond(m,".buffer");p.then(h,".enableVertexAttribArray(i);",h,".bindBuffer(",34962,",",m,".buffer.buffer);",
h,".vertexAttribPointer(i,",m,".size,",m,".type,",m,".normalized,",m,".stride,",m,".offset);")["else"](h,".disableVertexAttribArray(i);",h,".vertexAttrib4f(i,",m,".x,",m,".y,",m,".z,",m,".w);",m,".buffer=null;");var q=a.link(d.maxAttributes,{stable:!0});e("for(var i=0;i<",q,";++i){",m,"=",g,"[i];",p,"}");sa&&e("for(var i=0;i<",q,";++i){",n,".vertexAttribDivisorANGLE(i,",g,"[i].divisor);","}");e(a.shared.vao,".currentVAO=null;",a.shared.vao,".setVAO(",a.shared.vao,".targetVAO);");Object.keys(ua).forEach(function(c){var d=
ua[c],g=f.def(k,".",c),n=a.block();n("if(",g,"){",h,".enable(",d,")}else{",h,".disable(",d,")}",l,".",c,"=",g,";");e(n);b("if(",g,"!==",l,".",c,"){",n,"}")});Object.keys(ma).forEach(function(c){var d=ma[c],g=ta[c],n,m,p=a.block();p(h,".",d,"(");qa(g)?(d=g.length,n=a.global.def(k,".",c),m=a.global.def(l,".",c),p(S(d,function(a){return n+"["+a+"]"}),");",S(d,function(a){return m+"["+a+"]="+n+"["+a+"];"}).join("")),b("if(",S(d,function(a){return n+"["+a+"]!=="+m+"["+a+"]"}).join("||"),"){",p,"}")):(n=
f.def(k,".",c),m=f.def(l,".",c),p(n,");",l,".",c,"=",n,";"),b("if(",n,"!==",m,"){",p,"}"));e(p)});return a.compile()}(),compile:function(a,b,c,d,e){var f=w();f.stats=f.link(e);Object.keys(b["static"]).forEach(function(a){ka(f,b,a)});ac.forEach(function(b){ka(f,a,b)});var g=oa(a,b,c,d,f);g.shader.program&&(g.shader.program.attributes.sort(function(a,b){return a.name<b.name?-1:1}),g.shader.program.uniforms.sort(function(a,b){return a.name<b.name?-1:1}));pa(f,g);ea(f,g);Qa(f,g);return O(f.compile(),
{destroy:function(){g.shader.program.destroy()}})}}}function Bb(a,b){for(var c=0;c<a.length;++c)if(a[c]===b)return c;return-1}var O=function(a,b){for(var c=Object.keys(b),d=0;d<c.length;++d)a[c[d]]=b[c[d]];return a},Db=0,Z={DynamicVariable:da,define:function(a,b){return new da(a,bb(b+""))},isDynamic:function(a){return"function"===typeof a&&!a._reglType||a instanceof da},unbox:cb,accessor:bb},ab={next:"function"===typeof requestAnimationFrame?function(a){return requestAnimationFrame(a)}:function(a){return setTimeout(a,
16)},cancel:"function"===typeof cancelAnimationFrame?function(a){return cancelAnimationFrame(a)}:clearTimeout},Cb="undefined"!==typeof performance&&performance.now?function(){return performance.now()}:function(){return+new Date},B=gb();B.zero=gb();var bc=function(a,b){var c=1;b.ext_texture_filter_anisotropic&&(c=a.getParameter(34047));var d=1,f=1;b.webgl_draw_buffers&&(d=a.getParameter(34852),f=a.getParameter(36063));var e=!!b.oes_texture_float;if(e){e=a.createTexture();a.bindTexture(3553,e);a.texImage2D(3553,
0,6408,1,1,0,6408,5126,null);var m=a.createFramebuffer();a.bindFramebuffer(36160,m);a.framebufferTexture2D(36160,36064,3553,e,0);a.bindTexture(3553,null);if(36053!==a.checkFramebufferStatus(36160))e=!1;else{a.viewport(0,0,1,1);a.clearColor(1,0,0,1);a.clear(16384);var q=B.allocType(5126,4);a.readPixels(0,0,1,1,6408,5126,q);a.getError()?e=!1:(a.deleteFramebuffer(m),a.deleteTexture(e),e=1===q[0]);B.freeType(q)}}q=!0;"undefined"!==typeof navigator&&(/MSIE/.test(navigator.userAgent)||/Trident\//.test(navigator.appVersion)||
/Edge/.test(navigator.userAgent))||(q=a.createTexture(),m=B.allocType(5121,36),a.activeTexture(33984),a.bindTexture(34067,q),a.texImage2D(34069,0,6408,3,3,0,6408,5121,m),B.freeType(m),a.bindTexture(34067,null),a.deleteTexture(q),q=!a.getError());return{colorBits:[a.getParameter(3410),a.getParameter(3411),a.getParameter(3412),a.getParameter(3413)],depthBits:a.getParameter(3414),stencilBits:a.getParameter(3415),subpixelBits:a.getParameter(3408),extensions:Object.keys(b).filter(function(a){return!!b[a]}),
maxAnisotropic:c,maxDrawbuffers:d,maxColorAttachments:f,pointSizeDims:a.getParameter(33901),lineWidthDims:a.getParameter(33902),maxViewportDims:a.getParameter(3386),maxCombinedTextureUnits:a.getParameter(35661),maxCubeMapSize:a.getParameter(34076),maxRenderbufferSize:a.getParameter(34024),maxTextureUnits:a.getParameter(34930),maxTextureSize:a.getParameter(3379),maxAttributes:a.getParameter(34921),maxVertexUniforms:a.getParameter(36347),maxVertexTextureUnits:a.getParameter(35660),maxVaryingVectors:a.getParameter(36348),
maxFragmentUniforms:a.getParameter(36349),glsl:a.getParameter(35724),renderer:a.getParameter(7937),vendor:a.getParameter(7936),version:a.getParameter(7938),readFloat:e,npotTextureCube:q}},P=function(a){return a instanceof Uint8Array||a instanceof Uint16Array||a instanceof Uint32Array||a instanceof Int8Array||a instanceof Int16Array||a instanceof Int32Array||a instanceof Float32Array||a instanceof Float64Array||a instanceof Uint8ClampedArray},T=function(a){return Object.keys(a).map(function(b){return a[b]})},
Pa={shape:function(a){for(var b=[];a.length;a=a[0])b.push(a.length);return b},flatten:function(a,b,c,d){var f=1;if(b.length)for(var e=0;e<b.length;++e)f*=b[e];else f=0;c=d||B.allocType(c,f);switch(b.length){case 0:break;case 1:d=b[0];for(b=0;b<d;++b)c[b]=a[b];break;case 2:d=b[0];b=b[1];for(e=f=0;e<d;++e)for(var m=a[e],q=0;q<b;++q)c[f++]=m[q];break;case 3:hb(a,b[0],b[1],b[2],c,0);break;default:ib(a,b,0,c,0)}return c}},Ia={"[object Int8Array]":5120,"[object Int16Array]":5122,"[object Int32Array]":5124,
"[object Uint8Array]":5121,"[object Uint8ClampedArray]":5121,"[object Uint16Array]":5123,"[object Uint32Array]":5125,"[object Float32Array]":5126,"[object Float64Array]":5121,"[object ArrayBuffer]":5121},Ja={int8:5120,int16:5122,int32:5124,uint8:5121,uint16:5123,uint32:5125,"float":5126,float32:5126},mb={dynamic:35048,stream:35040,"static":35044},Ua=Pa.flatten,lb=Pa.shape,ja=[];ja[5120]=1;ja[5122]=2;ja[5124]=4;ja[5121]=1;ja[5123]=2;ja[5125]=4;ja[5126]=4;var Ka={points:0,point:0,lines:1,line:1,triangles:4,
triangle:4,"line loop":2,"line strip":3,"triangle strip":5,"triangle fan":6},pb=new Float32Array(1),Lb=new Uint32Array(pb.buffer),Pb=[9984,9986,9985,9987],Na=[0,6409,6410,6407,6408],U={};U[6409]=U[6406]=U[6402]=1;U[34041]=U[6410]=2;U[6407]=U[35904]=3;U[6408]=U[35906]=4;var Wa=ra("HTMLCanvasElement"),Xa=ra("OffscreenCanvas"),ub=ra("CanvasRenderingContext2D"),vb=ra("ImageBitmap"),wb=ra("HTMLImageElement"),xb=ra("HTMLVideoElement"),Mb=Object.keys(Ia).concat([Wa,Xa,ub,vb,wb,xb]),ya=[];ya[5121]=1;ya[5126]=
4;ya[36193]=2;ya[5123]=2;ya[5125]=4;var G=[];G[32854]=2;G[32855]=2;G[36194]=2;G[34041]=4;G[33776]=.5;G[33777]=.5;G[33778]=1;G[33779]=1;G[35986]=.5;G[35987]=1;G[34798]=1;G[35840]=.5;G[35841]=.25;G[35842]=.5;G[35843]=.25;G[36196]=.5;var M=[];M[32854]=2;M[32855]=2;M[36194]=2;M[33189]=2;M[36168]=1;M[34041]=4;M[35907]=4;M[34836]=16;M[34842]=8;M[34843]=6;var cc=function(a,b,c,d,f){function e(a){this.id=r++;this.refCount=1;this.renderbuffer=a;this.format=32854;this.height=this.width=0;f.profile&&(this.stats=
{size:0})}function m(b){var c=b.renderbuffer;a.bindRenderbuffer(36161,null);a.deleteRenderbuffer(c);b.renderbuffer=null;b.refCount=0;delete k[b.id];d.renderbufferCount--}var q={rgba4:32854,rgb565:36194,"rgb5 a1":32855,depth:33189,stencil:36168,"depth stencil":34041};b.ext_srgb&&(q.srgba=35907);b.ext_color_buffer_half_float&&(q.rgba16f=34842,q.rgb16f=34843);b.webgl_color_buffer_float&&(q.rgba32f=34836);var u=[];Object.keys(q).forEach(function(a){u[q[a]]=a});var r=0,k={};e.prototype.decRef=function(){0>=
--this.refCount&&m(this)};f.profile&&(d.getTotalRenderbufferSize=function(){var a=0;Object.keys(k).forEach(function(b){a+=k[b].stats.size});return a});return{create:function(b,c){function g(b,c){var d=0,e=0,k=32854;"object"===typeof b&&b?("shape"in b?(e=b.shape,d=e[0]|0,e=e[1]|0):("radius"in b&&(d=e=b.radius|0),"width"in b&&(d=b.width|0),"height"in b&&(e=b.height|0)),"format"in b&&(k=q[b.format])):"number"===typeof b?(d=b|0,e="number"===typeof c?c|0:d):b||(d=e=1);if(d!==l.width||e!==l.height||k!==
l.format)return g.width=l.width=d,g.height=l.height=e,l.format=k,a.bindRenderbuffer(36161,l.renderbuffer),a.renderbufferStorage(36161,k,d,e),f.profile&&(l.stats.size=M[l.format]*l.width*l.height),g.format=u[l.format],g}var l=new e(a.createRenderbuffer());k[l.id]=l;d.renderbufferCount++;g(b,c);g.resize=function(b,c){var d=b|0,e=c|0||d;if(d===l.width&&e===l.height)return g;g.width=l.width=d;g.height=l.height=e;a.bindRenderbuffer(36161,l.renderbuffer);a.renderbufferStorage(36161,l.format,d,e);f.profile&&
(l.stats.size=M[l.format]*l.width*l.height);return g};g._reglType="renderbuffer";g._renderbuffer=l;f.profile&&(g.stats=l.stats);g.destroy=function(){l.decRef()};return g},clear:function(){T(k).forEach(m)},restore:function(){T(k).forEach(function(b){b.renderbuffer=a.createRenderbuffer();a.bindRenderbuffer(36161,b.renderbuffer);a.renderbufferStorage(36161,b.format,b.width,b.height)});a.bindRenderbuffer(36161,null)}}},Ya=[];Ya[6408]=4;Ya[6407]=3;var Ra=[];Ra[5121]=1;Ra[5126]=4;Ra[36193]=2;var Vb=[1116352408,
1899447441,-1245643825,-373957723,961987163,1508970993,-1841331548,-1424204075,-670586216,310598401,607225278,1426881987,1925078388,-2132889090,-1680079193,-1046744716,-459576895,-272742522,264347078,604807628,770255983,1249150122,1555081692,1996064986,-1740746414,-1473132947,-1341970488,-1084653625,-958395405,-710438585,113926993,338241895,666307205,773529912,1294757372,1396182291,1695183700,1986661051,-2117940946,-1838011259,-1564481375,-1474664885,-1035236496,-949202525,-778901479,-694614492,-200395387,
275423344,430227734,506948616,659060556,883997877,958139571,1322822218,1537002063,1747873779,1955562222,2024104815,-2067236844,-1933114872,-1866530822,-1538233109,-1090935817,-965641998],Ca=["x","y","z","w"],ac="blend.func blend.equation stencil.func stencil.opFront stencil.opBack sample.coverage viewport scissor.box polygonOffset.offset".split(" "),Ga={0:0,1:1,zero:0,one:1,"src color":768,"one minus src color":769,"src alpha":770,"one minus src alpha":771,"dst color":774,"one minus dst color":775,
"dst alpha":772,"one minus dst alpha":773,"constant color":32769,"one minus constant color":32770,"constant alpha":32771,"one minus constant alpha":32772,"src alpha saturate":776},$a={never:512,less:513,"<":513,equal:514,"=":514,"==":514,"===":514,lequal:515,"<=":515,greater:516,">":516,notequal:517,"!=":517,"!==":517,gequal:518,">=":518,always:519},Ta={0:0,zero:0,keep:7680,replace:7681,increment:7682,decrement:7683,"increment wrap":34055,"decrement wrap":34056,invert:5386},zb={cw:2304,ccw:2305},
Ab=new K(!1,!1,!1,function(){}),dc=function(a,b){function c(){this.endQueryIndex=this.startQueryIndex=-1;this.sum=0;this.stats=null}function d(a,b,d){var e=m.pop()||new c;e.startQueryIndex=a;e.endQueryIndex=b;e.sum=0;e.stats=d;q.push(e)}if(!b.ext_disjoint_timer_query)return null;var f=[],e=[],m=[],q=[],u=[],r=[];return{beginQuery:function(a){var c=f.pop()||b.ext_disjoint_timer_query.createQueryEXT();b.ext_disjoint_timer_query.beginQueryEXT(35007,c);e.push(c);d(e.length-1,e.length,a)},endQuery:function(){b.ext_disjoint_timer_query.endQueryEXT(35007)},
pushScopeStats:d,update:function(){var a,c;a=e.length;if(0!==a){r.length=Math.max(r.length,a+1);u.length=Math.max(u.length,a+1);u[0]=0;var d=r[0]=0;for(c=a=0;c<e.length;++c){var g=e[c];b.ext_disjoint_timer_query.getQueryObjectEXT(g,34919)?(d+=b.ext_disjoint_timer_query.getQueryObjectEXT(g,34918),f.push(g)):e[a++]=g;u[c+1]=d;r[c+1]=a}e.length=a;for(c=a=0;c<q.length;++c){var d=q[c],l=d.startQueryIndex,g=d.endQueryIndex;d.sum+=u[g]-u[l];l=r[l];g=r[g];g===l?(d.stats.gpuTime+=d.sum/1E6,m.push(d)):(d.startQueryIndex=
l,d.endQueryIndex=g,q[a++]=d)}q.length=a}},getNumPendingQueries:function(){return e.length},clear:function(){f.push.apply(f,e);for(var a=0;a<f.length;a++)b.ext_disjoint_timer_query.deleteQueryEXT(f[a]);e.length=0;f.length=0},restore:function(){e.length=0;f.length=0}}};return function(a){function b(){if(0===I.length)z&&z.update(),R=null;else{R=ab.next(b);k();for(var a=I.length-1;0<=a;--a){var c=I[a];c&&c(D,null,0)}g.flush();z&&z.update()}}function c(){!R&&0<I.length&&(R=ab.next(b))}function d(){R&&
(ab.cancel(b),R=null)}function f(a){a.preventDefault();d();S.forEach(function(a){a()})}function e(a){g.getError();h.restore();J.restore();G.restore();L.restore();P.restore();V.restore();A.restore();z&&z.restore();M.procs.refresh();c();T.forEach(function(a){a()})}function m(a){function b(a,c){var d={},e={};Object.keys(a).forEach(function(b){var f=a[b];if(Z.isDynamic(f))e[b]=Z.unbox(f,b);else{if(c&&Array.isArray(f))for(var g=0;g<f.length;++g)if(Z.isDynamic(f[g])){e[b]=Z.unbox(f,b);return}d[b]=f}});
return{dynamic:e,"static":d}}function c(a){for(;n.length<a;)n.push(null);return n}var d=b(a.context||{},!0),e=b(a.uniforms||{},!0),f=b(a.attributes||{},!1);a=b(function(a){function b(a){if(a in c){var d=c[a];delete c[a];Object.keys(d).forEach(function(b){c[a+"."+b]=d[b]})}}var c=O({},a);delete c.uniforms;delete c.attributes;delete c.context;delete c.vao;"stencil"in c&&c.stencil.op&&(c.stencil.opBack=c.stencil.opFront=c.stencil.op,delete c.stencil.op);b("blend");b("depth");b("cull");b("stencil");b("polygonOffset");
b("scissor");b("sample");"vao"in a&&(c.vao=a.vao);return c}(a),!1);var g={gpuTime:0,cpuTime:0,count:0},h=M.compile(a,f,e,d,g),k=h.draw,l=h.batch,m=h.scope,n=[];return O(function(a,b){var d;if("function"===typeof a)return m.call(this,null,a,0);if("function"===typeof b)if("number"===typeof a)for(d=0;d<a;++d)m.call(this,null,b,d);else if(Array.isArray(a))for(d=0;d<a.length;++d)m.call(this,a[d],b,d);else return m.call(this,a,b,0);else if("number"===typeof a){if(0<a)return l.call(this,c(a|0),a|0)}else if(Array.isArray(a)){if(a.length)return l.call(this,
a,a.length)}else return k.call(this,a)},{stats:g,destroy:function(){h.destroy()}})}function q(a,b){var c=0;M.procs.poll();var d=b.color;d&&(g.clearColor(+d[0]||0,+d[1]||0,+d[2]||0,+d[3]||0),c|=16384);"depth"in b&&(g.clearDepth(+b.depth),c|=256);"stencil"in b&&(g.clearStencil(b.stencil|0),c|=1024);g.clear(c)}function u(a){I.push(a);c();return{cancel:function(){function b(){var a=Bb(I,b);I[a]=I[I.length-1];--I.length;0>=I.length&&d()}var c=Bb(I,a);I[c]=b}}}function r(){var a=W.viewport,b=W.scissor_box;
a[0]=a[1]=b[0]=b[1]=0;D.viewportWidth=D.framebufferWidth=D.drawingBufferWidth=a[2]=b[2]=g.drawingBufferWidth;D.viewportHeight=D.framebufferHeight=D.drawingBufferHeight=a[3]=b[3]=g.drawingBufferHeight}function k(){D.tick+=1;D.time=t();r();M.procs.poll()}function n(){L.refresh();r();M.procs.refresh();z&&z.update()}function t(){return(Cb()-E)/1E3}a=Hb(a);if(!a)return null;var g=a.gl,l=g.getContextAttributes();g.isContextLost();var h=Ib(g,a);if(!h)return null;var p=Eb(),y={vaoCount:0,bufferCount:0,elementsCount:0,
framebufferCount:0,shaderCount:0,textureCount:0,cubeCount:0,renderbufferCount:0,maxTextureUnits:0},C=a.cachedCode||{},w=h.extensions,z=dc(g,w),E=Cb(),B=g.drawingBufferWidth,H=g.drawingBufferHeight,D={tick:0,time:0,viewportWidth:B,viewportHeight:H,framebufferWidth:B,framebufferHeight:H,drawingBufferWidth:B,drawingBufferHeight:H,pixelRatio:a.pixelRatio},B={elements:null,primitive:4,count:-1,offset:0,instances:-1},v=bc(g,w),G=Jb(g,y,a,function(a){return A.destroyBuffer(a)}),K=Kb(g,w,G,y),A=Rb(g,w,v,
y,G,K,B),J=Sb(g,p,y,a),L=Nb(g,w,v,function(){M.procs.poll()},D,y,a),P=cc(g,w,v,y,a),V=Qb(g,w,v,L,P,y),M=Zb(g,p,w,v,G,K,L,V,{},A,J,B,D,z,C,a),p=Tb(g,V,M.procs.poll,D,l,w,v),W=M.next,Q=g.canvas,I=[],S=[],T=[],U=[a.onDestroy],R=null;Q&&(Q.addEventListener("webglcontextlost",f,!1),Q.addEventListener("webglcontextrestored",e,!1));var Y=V.setFBO=m({framebuffer:Z.define.call(null,1,"framebuffer")});n();l=O(m,{clear:function(a){if("framebuffer"in a)if(a.framebuffer&&"framebufferCube"===a.framebuffer_reglType)for(var b=
0;6>b;++b)Y(O({framebuffer:a.framebuffer.faces[b]},a),q);else Y(a,q);else q(null,a)},prop:Z.define.bind(null,1),context:Z.define.bind(null,2),"this":Z.define.bind(null,3),draw:m({}),buffer:function(a){return G.create(a,34962,!1,!1)},elements:function(a){return K.create(a,!1)},texture:L.create2D,cube:L.createCube,renderbuffer:P.create,framebuffer:V.create,framebufferCube:V.createCube,vao:A.createVAO,attributes:l,frame:u,on:function(a,b){var c;switch(a){case "frame":return u(b);case "lost":c=S;break;
case "restore":c=T;break;case "destroy":c=U}c.push(b);return{cancel:function(){for(var a=0;a<c.length;++a)if(c[a]===b){c[a]=c[c.length-1];c.pop();break}}}},limits:v,hasExtension:function(a){return 0<=v.extensions.indexOf(a.toLowerCase())},read:p,destroy:function(){I.length=0;d();Q&&(Q.removeEventListener("webglcontextlost",f),Q.removeEventListener("webglcontextrestored",e));J.clear();V.clear();P.clear();A.clear();L.clear();K.clear();G.clear();z&&z.clear();U.forEach(function(a){a()})},_gl:g,_refresh:n,
poll:function(){k();z&&z.update()},now:t,stats:y,getCachedCode:function(){return C},preloadCachedCode:function(a){Object.entries(a).forEach(function(a){C[a[0]]=a[1]})}});a.onDone(null,l);return l}});


/***/ }),

/***/ 41041:
/***/ (function(module, exports, __webpack_require__) {

/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(45708)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.prototype = Object.create(Buffer.prototype)

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),

/***/ 73285:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(71129);
var define = __webpack_require__(70973);
var hasDescriptors = __webpack_require__(74268)();
var gOPD = __webpack_require__(52991);

var $TypeError = __webpack_require__(48631);
var $floor = GetIntrinsic('%Math.floor%');

/** @type {import('.')} */
module.exports = function setFunctionLength(fn, length) {
	if (typeof fn !== 'function') {
		throw new $TypeError('`fn` is not a function');
	}
	if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $floor(length) !== length) {
		throw new $TypeError('`length` must be a positive 32-bit integer');
	}

	var loose = arguments.length > 2 && !!arguments[2];

	var functionLengthIsConfigurable = true;
	var functionLengthIsWritable = true;
	if ('length' in fn && gOPD) {
		var desc = gOPD(fn, 'length');
		if (desc && !desc.configurable) {
			functionLengthIsConfigurable = false;
		}
		if (desc && !desc.writable) {
			functionLengthIsWritable = false;
		}
	}

	if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
		if (hasDescriptors) {
			define(/** @type {Parameters<define>[0]} */ (fn), 'length', length, true, true);
		} else {
			define(/** @type {Parameters<define>[0]} */ (fn), 'length', length);
		}
	}
	return fn;
};


/***/ }),

/***/ 90386:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

module.exports = Stream;

var EE = (__webpack_require__(7683).EventEmitter);
var inherits = __webpack_require__(28062);

inherits(Stream, EE);
Stream.Readable = __webpack_require__(44639);
Stream.Writable = __webpack_require__(84627);
Stream.Duplex = __webpack_require__(71977);
Stream.Transform = __webpack_require__(40255);
Stream.PassThrough = __webpack_require__(28765);
Stream.finished = __webpack_require__(37165)
Stream.pipeline = __webpack_require__(6772)

// Backwards-compat with node 0.4.x
Stream.Stream = Stream;



// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.

function Stream() {
  EE.call(this);
}

Stream.prototype.pipe = function(dest, options) {
  var source = this;

  function ondata(chunk) {
    if (dest.writable) {
      if (false === dest.write(chunk) && source.pause) {
        source.pause();
      }
    }
  }

  source.on('data', ondata);

  function ondrain() {
    if (source.readable && source.resume) {
      source.resume();
    }
  }

  dest.on('drain', ondrain);

  // If the 'end' option is not supplied, dest.end() will be called when
  // source gets the 'end' or 'close' events.  Only dest.end() once.
  if (!dest._isStdio && (!options || options.end !== false)) {
    source.on('end', onend);
    source.on('close', onclose);
  }

  var didOnEnd = false;
  function onend() {
    if (didOnEnd) return;
    didOnEnd = true;

    dest.end();
  }


  function onclose() {
    if (didOnEnd) return;
    didOnEnd = true;

    if (typeof dest.destroy === 'function') dest.destroy();
  }

  // don't leave dangling pipes when there are errors.
  function onerror(er) {
    cleanup();
    if (EE.listenerCount(this, 'error') === 0) {
      throw er; // Unhandled stream error in pipe.
    }
  }

  source.on('error', onerror);
  dest.on('error', onerror);

  // remove all the event listeners that were added.
  function cleanup() {
    source.removeListener('data', ondata);
    dest.removeListener('drain', ondrain);

    source.removeListener('end', onend);
    source.removeListener('close', onclose);

    source.removeListener('error', onerror);
    dest.removeListener('error', onerror);

    source.removeListener('end', cleanup);
    source.removeListener('close', cleanup);

    dest.removeListener('close', cleanup);
  }

  source.on('end', cleanup);
  source.on('close', cleanup);

  dest.on('close', cleanup);

  dest.emit('pipe', source);

  // Allow for unix-like usage: A.pipe(B).pipe(C)
  return dest;
};


/***/ }),

/***/ 44059:
/***/ (function(module) {

"use strict";


function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var codes = {};

function createErrorType(code, message, Base) {
  if (!Base) {
    Base = Error;
  }

  function getMessage(arg1, arg2, arg3) {
    if (typeof message === 'string') {
      return message;
    } else {
      return message(arg1, arg2, arg3);
    }
  }

  var NodeError =
  /*#__PURE__*/
  function (_Base) {
    _inheritsLoose(NodeError, _Base);

    function NodeError(arg1, arg2, arg3) {
      return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
    }

    return NodeError;
  }(Base);

  NodeError.prototype.name = Base.name;
  NodeError.prototype.code = code;
  codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js


function oneOf(expected, thing) {
  if (Array.isArray(expected)) {
    var len = expected.length;
    expected = expected.map(function (i) {
      return String(i);
    });

    if (len > 2) {
      return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
    } else if (len === 2) {
      return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
    } else {
      return "of ".concat(thing, " ").concat(expected[0]);
    }
  } else {
    return "of ".concat(thing, " ").concat(String(expected));
  }
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith


function startsWith(str, search, pos) {
  return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith


function endsWith(str, search, this_len) {
  if (this_len === undefined || this_len > str.length) {
    this_len = str.length;
  }

  return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes


function includes(str, search, start) {
  if (typeof start !== 'number') {
    start = 0;
  }

  if (start + search.length > str.length) {
    return false;
  } else {
    return str.indexOf(search, start) !== -1;
  }
}

createErrorType('ERR_INVALID_OPT_VALUE', function (name, value) {
  return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
createErrorType('ERR_INVALID_ARG_TYPE', function (name, expected, actual) {
  // determiner: 'must be' or 'must not be'
  var determiner;

  if (typeof expected === 'string' && startsWith(expected, 'not ')) {
    determiner = 'must not be';
    expected = expected.replace(/^not /, '');
  } else {
    determiner = 'must be';
  }

  var msg;

  if (endsWith(name, ' argument')) {
    // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
  } else {
    var type = includes(name, '.') ? 'property' : 'argument';
    msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
  }

  msg += ". Received type ".concat(typeof actual);
  return msg;
}, TypeError);
createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function (name) {
  return 'The ' + name + ' method is not implemented';
});
createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
createErrorType('ERR_STREAM_DESTROYED', function (name) {
  return 'Cannot call ' + name + ' after a stream was destroyed';
});
createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
createErrorType('ERR_UNKNOWN_ENCODING', function (arg) {
  return 'Unknown encoding: ' + arg;
}, TypeError);
createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
module.exports.F = codes;


/***/ }),

/***/ 71977:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(33282);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

/*<replacement>*/

var objectKeys = Object.keys || function (obj) {
  var keys = [];

  for (var key in obj) {
    keys.push(key);
  }

  return keys;
};
/*</replacement>*/


module.exports = Duplex;

var Readable = __webpack_require__(44639);

var Writable = __webpack_require__(84627);

__webpack_require__(28062)(Duplex, Readable);

{
  // Allow the keys array to be GC'ed.
  var keys = objectKeys(Writable.prototype);

  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}

function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);
  Readable.call(this, options);
  Writable.call(this, options);
  this.allowHalfOpen = true;

  if (options) {
    if (options.readable === false) this.readable = false;
    if (options.writable === false) this.writable = false;

    if (options.allowHalfOpen === false) {
      this.allowHalfOpen = false;
      this.once('end', onend);
    }
  }
}

Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.highWaterMark;
  }
});
Object.defineProperty(Duplex.prototype, 'writableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState && this._writableState.getBuffer();
  }
});
Object.defineProperty(Duplex.prototype, 'writableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.length;
  }
}); // the no-half-open enforcer

function onend() {
  // If the writable side ended, then we're ok.
  if (this._writableState.ended) return; // no more data can be written.
  // But allow more writes to happen in this tick.

  process.nextTick(onEndNT, this);
}

function onEndNT(self) {
  self.end();
}

Object.defineProperty(Duplex.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }

    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    } // backward compatibility, the user is explicitly
    // managing destroyed


    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});

/***/ }),

/***/ 28765:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.


module.exports = PassThrough;

var Transform = __webpack_require__(40255);

__webpack_require__(28062)(PassThrough, Transform);

function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);
  Transform.call(this, options);
}

PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};

/***/ }),

/***/ 44639:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(33282);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.


module.exports = Readable;
/*<replacement>*/

var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;
/*<replacement>*/

var EE = (__webpack_require__(7683).EventEmitter);

var EElistenerCount = function EElistenerCount(emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/


var Stream = __webpack_require__(60032);
/*</replacement>*/


var Buffer = (__webpack_require__(45708).Buffer);

var OurUint8Array = __webpack_require__.g.Uint8Array || function () {};

function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}

function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}
/*<replacement>*/


var debugUtil = __webpack_require__(77199);

var debug;

if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function debug() {};
}
/*</replacement>*/


var BufferList = __webpack_require__(29930);

var destroyImpl = __webpack_require__(52023);

var _require = __webpack_require__(31976),
    getHighWaterMark = _require.getHighWaterMark;

var _require$codes = (__webpack_require__(44059)/* .codes */ .F),
    ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
    ERR_STREAM_PUSH_AFTER_EOF = _require$codes.ERR_STREAM_PUSH_AFTER_EOF,
    ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
    ERR_STREAM_UNSHIFT_AFTER_END_EVENT = _require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT; // Lazy loaded to improve the startup performance.


var StringDecoder;
var createReadableStreamAsyncIterator;
var from;

__webpack_require__(28062)(Readable, Stream);

var errorOrDestroy = destroyImpl.errorOrDestroy;
var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];

function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn); // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.

  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}

function ReadableState(options, stream, isDuplex) {
  Duplex = Duplex || __webpack_require__(71977);
  options = options || {}; // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.

  if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex; // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away

  this.objectMode = !!options.objectMode;
  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode; // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"

  this.highWaterMark = getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex); // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()

  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false; // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.

  this.sync = true; // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.

  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;
  this.paused = true; // Should close be emitted on destroy. Defaults to true.

  this.emitClose = options.emitClose !== false; // Should .destroy() be called after 'end' (and potentially 'finish')

  this.autoDestroy = !!options.autoDestroy; // has it been destroyed

  this.destroyed = false; // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.

  this.defaultEncoding = options.defaultEncoding || 'utf8'; // the number of writers that are awaiting a drain event in .pipe()s

  this.awaitDrain = 0; // if true, a maybeReadMore has been scheduled

  this.readingMore = false;
  this.decoder = null;
  this.encoding = null;

  if (options.encoding) {
    if (!StringDecoder) StringDecoder = (__webpack_require__(54304)/* .StringDecoder */ .I);
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}

function Readable(options) {
  Duplex = Duplex || __webpack_require__(71977);
  if (!(this instanceof Readable)) return new Readable(options); // Checking for a Stream.Duplex instance is faster here instead of inside
  // the ReadableState constructor, at least with V8 6.5

  var isDuplex = this instanceof Duplex;
  this._readableState = new ReadableState(options, this, isDuplex); // legacy

  this.readable = true;

  if (options) {
    if (typeof options.read === 'function') this._read = options.read;
    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }

  Stream.call(this);
}

Object.defineProperty(Readable.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._readableState === undefined) {
      return false;
    }

    return this._readableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    } // backward compatibility, the user is explicitly
    // managing destroyed


    this._readableState.destroyed = value;
  }
});
Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;

Readable.prototype._destroy = function (err, cb) {
  cb(err);
}; // Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.


Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;

  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;

      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }

      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }

  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
}; // Unshift should *always* be something directly out of read()


Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};

function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  debug('readableAddChunk', chunk);
  var state = stream._readableState;

  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);

    if (er) {
      errorOrDestroy(stream, er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }

      if (addToFront) {
        if (state.endEmitted) errorOrDestroy(stream, new ERR_STREAM_UNSHIFT_AFTER_END_EVENT());else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        errorOrDestroy(stream, new ERR_STREAM_PUSH_AFTER_EOF());
      } else if (state.destroyed) {
        return false;
      } else {
        state.reading = false;

        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
      maybeReadMore(stream, state);
    }
  } // We can push more data if we are below the highWaterMark.
  // Also, if we have no data yet, we can stand some more bytes.
  // This is to work around cases where hwm=0, such as the repl.


  return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}

function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    state.awaitDrain = 0;
    stream.emit('data', chunk);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
    if (state.needReadable) emitReadable(stream);
  }

  maybeReadMore(stream, state);
}

function chunkInvalid(state, chunk) {
  var er;

  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new ERR_INVALID_ARG_TYPE('chunk', ['string', 'Buffer', 'Uint8Array'], chunk);
  }

  return er;
}

Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
}; // backwards compatibility.


Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = (__webpack_require__(54304)/* .StringDecoder */ .I);
  var decoder = new StringDecoder(enc);
  this._readableState.decoder = decoder; // If setEncoding(null), decoder.encoding equals utf8

  this._readableState.encoding = this._readableState.decoder.encoding; // Iterate over current buffer to convert already stored Buffers:

  var p = this._readableState.buffer.head;
  var content = '';

  while (p !== null) {
    content += decoder.write(p.data);
    p = p.next;
  }

  this._readableState.buffer.clear();

  if (content !== '') this._readableState.buffer.push(content);
  this._readableState.length = content.length;
  return this;
}; // Don't raise the hwm > 1GB


var MAX_HWM = 0x40000000;

function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }

  return n;
} // This function is designed to be inlinable, so please take care when making
// changes to the function body.


function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;

  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  } // If we're asking for more than the current hwm, then raise the hwm.


  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n; // Don't have enough

  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }

  return state.length;
} // you can override either this method, or the async _read(n) below.


Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;
  if (n !== 0) state.emittedReadable = false; // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.

  if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state); // if we've ended, and we're now clear, then finish it up.

  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  } // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.
  // if we need a readable event, then we need to do some reading.


  var doRead = state.needReadable;
  debug('need readable', doRead); // if we currently have less than the highWaterMark, then also read some

  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  } // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.


  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true; // if the length is currently zero, then we *need* a readable event.

    if (state.length === 0) state.needReadable = true; // call internal read method

    this._read(state.highWaterMark);

    state.sync = false; // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.

    if (!state.reading) n = howMuchToRead(nOrig, state);
  }

  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;

  if (ret === null) {
    state.needReadable = state.length <= state.highWaterMark;
    n = 0;
  } else {
    state.length -= n;
    state.awaitDrain = 0;
  }

  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true; // If we tried to read() past the EOF, then emit end on the next tick.

    if (nOrig !== n && state.ended) endReadable(this);
  }

  if (ret !== null) this.emit('data', ret);
  return ret;
};

function onEofChunk(stream, state) {
  debug('onEofChunk');
  if (state.ended) return;

  if (state.decoder) {
    var chunk = state.decoder.end();

    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }

  state.ended = true;

  if (state.sync) {
    // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    emitReadable(stream);
  } else {
    // emit 'readable' now to make sure it gets picked up.
    state.needReadable = false;

    if (!state.emittedReadable) {
      state.emittedReadable = true;
      emitReadable_(stream);
    }
  }
} // Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.


function emitReadable(stream) {
  var state = stream._readableState;
  debug('emitReadable', state.needReadable, state.emittedReadable);
  state.needReadable = false;

  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    process.nextTick(emitReadable_, stream);
  }
}

function emitReadable_(stream) {
  var state = stream._readableState;
  debug('emitReadable_', state.destroyed, state.length, state.ended);

  if (!state.destroyed && (state.length || state.ended)) {
    stream.emit('readable');
    state.emittedReadable = false;
  } // The stream needs another readable event if
  // 1. It is not flowing, as the flow mechanism will take
  //    care of it.
  // 2. It is not ended.
  // 3. It is below the highWaterMark, so we can schedule
  //    another readable later.


  state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
  flow(stream);
} // at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.


function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    process.nextTick(maybeReadMore_, stream, state);
  }
}

function maybeReadMore_(stream, state) {
  // Attempt to read more data if we should.
  //
  // The conditions for reading more data are (one of):
  // - Not enough data buffered (state.length < state.highWaterMark). The loop
  //   is responsible for filling the buffer with enough data if such data
  //   is available. If highWaterMark is 0 and we are not in the flowing mode
  //   we should _not_ attempt to buffer any extra data. We'll get more data
  //   when the stream consumer calls read() instead.
  // - No data in the buffer, and the stream is in flowing mode. In this mode
  //   the loop below is responsible for ensuring read() is called. Failing to
  //   call read here would abort the flow and there's no other mechanism for
  //   continuing the flow if the stream consumer has just subscribed to the
  //   'data' event.
  //
  // In addition to the above conditions to keep reading data, the following
  // conditions prevent the data from being read:
  // - The stream has ended (state.ended).
  // - There is already a pending 'read' operation (state.reading). This is a
  //   case where the the stream has called the implementation defined _read()
  //   method, but they are processing the call asynchronously and have _not_
  //   called push() with new data. In this case we skip performing more
  //   read()s. The execution ends in this method again after the _read() ends
  //   up calling push() with more data.
  while (!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)) {
    var len = state.length;
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length) // didn't get any data, stop spinning.
      break;
  }

  state.readingMore = false;
} // abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.


Readable.prototype._read = function (n) {
  errorOrDestroy(this, new ERR_METHOD_NOT_IMPLEMENTED('_read()'));
};

Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;

    case 1:
      state.pipes = [state.pipes, dest];
      break;

    default:
      state.pipes.push(dest);
      break;
  }

  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) process.nextTick(endFn);else src.once('end', endFn);
  dest.on('unpipe', onunpipe);

  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');

    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }

  function onend() {
    debug('onend');
    dest.end();
  } // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.


  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);
  var cleanedUp = false;

  function cleanup() {
    debug('cleanup'); // cleanup event handlers once the pipe is broken

    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);
    cleanedUp = true; // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.

    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }

  src.on('data', ondata);

  function ondata(chunk) {
    debug('ondata');
    var ret = dest.write(chunk);
    debug('dest.write', ret);

    if (ret === false) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', state.awaitDrain);
        state.awaitDrain++;
      }

      src.pause();
    }
  } // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.


  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) errorOrDestroy(dest, er);
  } // Make sure our error handler is attached before userland ones.


  prependListener(dest, 'error', onerror); // Both close and finish should trigger unpipe, but only once.

  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }

  dest.once('close', onclose);

  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }

  dest.once('finish', onfinish);

  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  } // tell the dest that it's being piped to


  dest.emit('pipe', src); // start the flow if it hasn't been started already.

  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }

  return dest;
};

function pipeOnDrain(src) {
  return function pipeOnDrainFunctionResult() {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;

    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}

Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = {
    hasUnpiped: false
  }; // if we're not piping anywhere, then do nothing.

  if (state.pipesCount === 0) return this; // just one destination.  most common case.

  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;
    if (!dest) dest = state.pipes; // got a match.

    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  } // slow case. multiple pipe destinations.


  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;

    for (var i = 0; i < len; i++) {
      dests[i].emit('unpipe', this, {
        hasUnpiped: false
      });
    }

    return this;
  } // try to find the right one.


  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;
  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];
  dest.emit('unpipe', this, unpipeInfo);
  return this;
}; // set up data events if they are asked for
// Ensure readable listeners eventually get something


Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);
  var state = this._readableState;

  if (ev === 'data') {
    // update readableListening so that resume() may be a no-op
    // a few lines down. This is needed to support once('readable').
    state.readableListening = this.listenerCount('readable') > 0; // Try start flowing on next tick if stream isn't explicitly paused

    if (state.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.flowing = false;
      state.emittedReadable = false;
      debug('on readable', state.length, state.reading);

      if (state.length) {
        emitReadable(this);
      } else if (!state.reading) {
        process.nextTick(nReadingNextTick, this);
      }
    }
  }

  return res;
};

Readable.prototype.addListener = Readable.prototype.on;

Readable.prototype.removeListener = function (ev, fn) {
  var res = Stream.prototype.removeListener.call(this, ev, fn);

  if (ev === 'readable') {
    // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this);
  }

  return res;
};

Readable.prototype.removeAllListeners = function (ev) {
  var res = Stream.prototype.removeAllListeners.apply(this, arguments);

  if (ev === 'readable' || ev === undefined) {
    // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this);
  }

  return res;
};

function updateReadableListening(self) {
  var state = self._readableState;
  state.readableListening = self.listenerCount('readable') > 0;

  if (state.resumeScheduled && !state.paused) {
    // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true; // crude way to check if we should resume
  } else if (self.listenerCount('data') > 0) {
    self.resume();
  }
}

function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
} // pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.


Readable.prototype.resume = function () {
  var state = this._readableState;

  if (!state.flowing) {
    debug('resume'); // we flow only if there is no one listening
    // for readable, but we still have to call
    // resume()

    state.flowing = !state.readableListening;
    resume(this, state);
  }

  state.paused = false;
  return this;
};

function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    process.nextTick(resume_, stream, state);
  }
}

function resume_(stream, state) {
  debug('resume', state.reading);

  if (!state.reading) {
    stream.read(0);
  }

  state.resumeScheduled = false;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}

Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);

  if (this._readableState.flowing !== false) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }

  this._readableState.paused = true;
  return this;
};

function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);

  while (state.flowing && stream.read() !== null) {
    ;
  }
} // wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.


Readable.prototype.wrap = function (stream) {
  var _this = this;

  var state = this._readableState;
  var paused = false;
  stream.on('end', function () {
    debug('wrapped end');

    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }

    _this.push(null);
  });
  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk); // don't skip over falsy values in objectMode

    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

    var ret = _this.push(chunk);

    if (!ret) {
      paused = true;
      stream.pause();
    }
  }); // proxy all the other methods.
  // important when wrapping filters and duplexes.

  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  } // proxy certain important events.


  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  } // when we try to consume some more bytes, simply unpause the
  // underlying stream.


  this._read = function (n) {
    debug('wrapped _read', n);

    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return this;
};

if (typeof Symbol === 'function') {
  Readable.prototype[Symbol.asyncIterator] = function () {
    if (createReadableStreamAsyncIterator === undefined) {
      createReadableStreamAsyncIterator = __webpack_require__(73726);
    }

    return createReadableStreamAsyncIterator(this);
  };
}

Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.highWaterMark;
  }
});
Object.defineProperty(Readable.prototype, 'readableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState && this._readableState.buffer;
  }
});
Object.defineProperty(Readable.prototype, 'readableFlowing', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.flowing;
  },
  set: function set(state) {
    if (this._readableState) {
      this._readableState.flowing = state;
    }
  }
}); // exposed for testing purposes only.

Readable._fromList = fromList;
Object.defineProperty(Readable.prototype, 'readableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.length;
  }
}); // Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.

function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;
  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.first();else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = state.buffer.consume(n, state.decoder);
  }
  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;
  debug('endReadable', state.endEmitted);

  if (!state.endEmitted) {
    state.ended = true;
    process.nextTick(endReadableNT, state, stream);
  }
}

function endReadableNT(state, stream) {
  debug('endReadableNT', state.endEmitted, state.length); // Check that we didn't get one last unshift.

  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');

    if (state.autoDestroy) {
      // In case of duplex streams we need a way to detect
      // if the writable side is ready for autoDestroy as well
      var wState = stream._writableState;

      if (!wState || wState.autoDestroy && wState.finished) {
        stream.destroy();
      }
    }
  }
}

if (typeof Symbol === 'function') {
  Readable.from = function (iterable, opts) {
    if (from === undefined) {
      from = __webpack_require__(37108);
    }

    return from(Readable, iterable, opts);
  };
}

function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }

  return -1;
}

/***/ }),

/***/ 40255:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.


module.exports = Transform;

var _require$codes = (__webpack_require__(44059)/* .codes */ .F),
    ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
    ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK,
    ERR_TRANSFORM_ALREADY_TRANSFORMING = _require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING,
    ERR_TRANSFORM_WITH_LENGTH_0 = _require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var Duplex = __webpack_require__(71977);

__webpack_require__(28062)(Transform, Duplex);

function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;
  var cb = ts.writecb;

  if (cb === null) {
    return this.emit('error', new ERR_MULTIPLE_CALLBACK());
  }

  ts.writechunk = null;
  ts.writecb = null;
  if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
  cb(er);
  var rs = this._readableState;
  rs.reading = false;

  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}

function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);
  Duplex.call(this, options);
  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  }; // start out asking for a readable event once data is transformed.

  this._readableState.needReadable = true; // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.

  this._readableState.sync = false;

  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;
    if (typeof options.flush === 'function') this._flush = options.flush;
  } // When the writable side finishes, then flush out anything remaining.


  this.on('prefinish', prefinish);
}

function prefinish() {
  var _this = this;

  if (typeof this._flush === 'function' && !this._readableState.destroyed) {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}

Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
}; // This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.


Transform.prototype._transform = function (chunk, encoding, cb) {
  cb(new ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
};

Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;

  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
}; // Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.


Transform.prototype._read = function (n) {
  var ts = this._transformState;

  if (ts.writechunk !== null && !ts.transforming) {
    ts.transforming = true;

    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};

Transform.prototype._destroy = function (err, cb) {
  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
  });
};

function done(stream, er, data) {
  if (er) return stream.emit('error', er);
  if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data); // TODO(BridgeAR): Write a test for these two error cases
  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided

  if (stream._writableState.length) throw new ERR_TRANSFORM_WITH_LENGTH_0();
  if (stream._transformState.transforming) throw new ERR_TRANSFORM_ALREADY_TRANSFORMING();
  return stream.push(null);
}

/***/ }),

/***/ 84627:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(33282);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.


module.exports = Writable;
/* <replacement> */

function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
} // It seems a linked list but it is not
// there will be only 2 of these for each stream


function CorkedRequest(state) {
  var _this = this;

  this.next = null;
  this.entry = null;

  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/


var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;
/*<replacement>*/

var internalUtil = {
  deprecate: __webpack_require__(71103)
};
/*</replacement>*/

/*<replacement>*/

var Stream = __webpack_require__(60032);
/*</replacement>*/


var Buffer = (__webpack_require__(45708).Buffer);

var OurUint8Array = __webpack_require__.g.Uint8Array || function () {};

function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}

function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

var destroyImpl = __webpack_require__(52023);

var _require = __webpack_require__(31976),
    getHighWaterMark = _require.getHighWaterMark;

var _require$codes = (__webpack_require__(44059)/* .codes */ .F),
    ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
    ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
    ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK,
    ERR_STREAM_CANNOT_PIPE = _require$codes.ERR_STREAM_CANNOT_PIPE,
    ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED,
    ERR_STREAM_NULL_VALUES = _require$codes.ERR_STREAM_NULL_VALUES,
    ERR_STREAM_WRITE_AFTER_END = _require$codes.ERR_STREAM_WRITE_AFTER_END,
    ERR_UNKNOWN_ENCODING = _require$codes.ERR_UNKNOWN_ENCODING;

var errorOrDestroy = destroyImpl.errorOrDestroy;

__webpack_require__(28062)(Writable, Stream);

function nop() {}

function WritableState(options, stream, isDuplex) {
  Duplex = Duplex || __webpack_require__(71977);
  options = options || {}; // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream,
  // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.

  if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex; // object stream flag to indicate whether or not this stream
  // contains buffers or objects.

  this.objectMode = !!options.objectMode;
  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode; // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()

  this.highWaterMark = getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex); // if _final has been called

  this.finalCalled = false; // drain event flag.

  this.needDrain = false; // at the start of calling end()

  this.ending = false; // when end() has been called, and returned

  this.ended = false; // when 'finish' is emitted

  this.finished = false; // has it been destroyed

  this.destroyed = false; // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.

  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode; // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.

  this.defaultEncoding = options.defaultEncoding || 'utf8'; // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.

  this.length = 0; // a flag to see when we're in the middle of a write.

  this.writing = false; // when true all writes will be buffered until .uncork() call

  this.corked = 0; // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.

  this.sync = true; // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.

  this.bufferProcessing = false; // the callback that's passed to _write(chunk,cb)

  this.onwrite = function (er) {
    onwrite(stream, er);
  }; // the callback that the user supplies to write(chunk,encoding,cb)


  this.writecb = null; // the amount that is being written when _write is called.

  this.writelen = 0;
  this.bufferedRequest = null;
  this.lastBufferedRequest = null; // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted

  this.pendingcb = 0; // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams

  this.prefinished = false; // True if the error was already emitted and should not be thrown again

  this.errorEmitted = false; // Should close be emitted on destroy. Defaults to true.

  this.emitClose = options.emitClose !== false; // Should .destroy() be called after 'finish' (and potentially 'end')

  this.autoDestroy = !!options.autoDestroy; // count buffered requests

  this.bufferedRequestCount = 0; // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two

  this.corkedRequestsFree = new CorkedRequest(this);
}

WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];

  while (current) {
    out.push(current);
    current = current.next;
  }

  return out;
};

(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function writableStateBufferGetter() {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})(); // Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.


var realHasInstance;

if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function value(object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;
      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function realHasInstance(object) {
    return object instanceof this;
  };
}

function Writable(options) {
  Duplex = Duplex || __webpack_require__(71977); // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.
  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.
  // Checking for a Stream.Duplex instance is faster here instead of inside
  // the WritableState constructor, at least with V8 6.5

  var isDuplex = this instanceof Duplex;
  if (!isDuplex && !realHasInstance.call(Writable, this)) return new Writable(options);
  this._writableState = new WritableState(options, this, isDuplex); // legacy.

  this.writable = true;

  if (options) {
    if (typeof options.write === 'function') this._write = options.write;
    if (typeof options.writev === 'function') this._writev = options.writev;
    if (typeof options.destroy === 'function') this._destroy = options.destroy;
    if (typeof options.final === 'function') this._final = options.final;
  }

  Stream.call(this);
} // Otherwise people can pipe Writable streams, which is just wrong.


Writable.prototype.pipe = function () {
  errorOrDestroy(this, new ERR_STREAM_CANNOT_PIPE());
};

function writeAfterEnd(stream, cb) {
  var er = new ERR_STREAM_WRITE_AFTER_END(); // TODO: defer error events consistently everywhere, not just the cb

  errorOrDestroy(stream, er);
  process.nextTick(cb, er);
} // Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.


function validChunk(stream, state, chunk, cb) {
  var er;

  if (chunk === null) {
    er = new ERR_STREAM_NULL_VALUES();
  } else if (typeof chunk !== 'string' && !state.objectMode) {
    er = new ERR_INVALID_ARG_TYPE('chunk', ['string', 'Buffer'], chunk);
  }

  if (er) {
    errorOrDestroy(stream, er);
    process.nextTick(cb, er);
    return false;
  }

  return true;
}

Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;

  var isBuf = !state.objectMode && _isUint8Array(chunk);

  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }

  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
  if (typeof cb !== 'function') cb = nop;
  if (state.ending) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }
  return ret;
};

Writable.prototype.cork = function () {
  this._writableState.corked++;
};

Writable.prototype.uncork = function () {
  var state = this._writableState;

  if (state.corked) {
    state.corked--;
    if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};

Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new ERR_UNKNOWN_ENCODING(encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};

Object.defineProperty(Writable.prototype, 'writableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState && this._writableState.getBuffer();
  }
});

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }

  return chunk;
}

Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.highWaterMark;
  }
}); // if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.

function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);

    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }

  var len = state.objectMode ? 1 : chunk.length;
  state.length += len;
  var ret = state.length < state.highWaterMark; // we must ensure that previous needDrain will not be reset to false.

  if (!ret) state.needDrain = true;

  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };

    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }

    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }

  return ret;
}

function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (state.destroyed) state.onwrite(new ERR_STREAM_DESTROYED('write'));else if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;

  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    process.nextTick(cb, er); // this can emit finish, and it will always happen
    // after error

    process.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    errorOrDestroy(stream, er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    errorOrDestroy(stream, er); // this can emit finish, but finish must
    // always follow error

    finishMaybe(stream, state);
  }
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;
  if (typeof cb !== 'function') throw new ERR_MULTIPLE_CALLBACK();
  onwriteStateUpdate(state);
  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state) || stream.destroyed;

    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }

    if (sync) {
      process.nextTick(afterWrite, stream, state, finished, cb);
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
} // Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.


function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
} // if there's something in the buffer waiting, then process it


function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;

  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;
    var count = 0;
    var allBuffers = true;

    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }

    buffer.allBuffers = allBuffers;
    doWrite(stream, state, true, state.length, buffer, '', holder.finish); // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite

    state.pendingcb++;
    state.lastBufferedRequest = null;

    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }

    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;
      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--; // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.

      if (state.writing) {
        break;
      }
    }

    if (entry === null) state.lastBufferedRequest = null;
  }

  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}

Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new ERR_METHOD_NOT_IMPLEMENTED('_write()'));
};

Writable.prototype._writev = null;

Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;

  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding); // .end() fully uncorks

  if (state.corked) {
    state.corked = 1;
    this.uncork();
  } // ignore unnecessary end() calls.


  if (!state.ending) endWritable(this, state, cb);
  return this;
};

Object.defineProperty(Writable.prototype, 'writableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.length;
  }
});

function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}

function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;

    if (err) {
      errorOrDestroy(stream, err);
    }

    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}

function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function' && !state.destroyed) {
      state.pendingcb++;
      state.finalCalled = true;
      process.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}

function finishMaybe(stream, state) {
  var need = needFinish(state);

  if (need) {
    prefinish(stream, state);

    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');

      if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well
        var rState = stream._readableState;

        if (!rState || rState.autoDestroy && rState.endEmitted) {
          stream.destroy();
        }
      }
    }
  }

  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);

  if (cb) {
    if (state.finished) process.nextTick(cb);else stream.once('finish', cb);
  }

  state.ended = true;
  stream.writable = false;
}

function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;

  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  } // reuse the free corkReq.


  state.corkedRequestsFree.next = corkReq;
}

Object.defineProperty(Writable.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._writableState === undefined) {
      return false;
    }

    return this._writableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    } // backward compatibility, the user is explicitly
    // managing destroyed


    this._writableState.destroyed = value;
  }
});
Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;

Writable.prototype._destroy = function (err, cb) {
  cb(err);
};

/***/ }),

/***/ 73726:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(33282);


var _Object$setPrototypeO;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var finished = __webpack_require__(37165);

var kLastResolve = Symbol('lastResolve');
var kLastReject = Symbol('lastReject');
var kError = Symbol('error');
var kEnded = Symbol('ended');
var kLastPromise = Symbol('lastPromise');
var kHandlePromise = Symbol('handlePromise');
var kStream = Symbol('stream');

function createIterResult(value, done) {
  return {
    value: value,
    done: done
  };
}

function readAndResolve(iter) {
  var resolve = iter[kLastResolve];

  if (resolve !== null) {
    var data = iter[kStream].read(); // we defer if data is null
    // we can be expecting either 'end' or
    // 'error'

    if (data !== null) {
      iter[kLastPromise] = null;
      iter[kLastResolve] = null;
      iter[kLastReject] = null;
      resolve(createIterResult(data, false));
    }
  }
}

function onReadable(iter) {
  // we wait for the next tick, because it might
  // emit an error with process.nextTick
  process.nextTick(readAndResolve, iter);
}

function wrapForNext(lastPromise, iter) {
  return function (resolve, reject) {
    lastPromise.then(function () {
      if (iter[kEnded]) {
        resolve(createIterResult(undefined, true));
        return;
      }

      iter[kHandlePromise](resolve, reject);
    }, reject);
  };
}

var AsyncIteratorPrototype = Object.getPrototypeOf(function () {});
var ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf((_Object$setPrototypeO = {
  get stream() {
    return this[kStream];
  },

  next: function next() {
    var _this = this;

    // if we have detected an error in the meanwhile
    // reject straight away
    var error = this[kError];

    if (error !== null) {
      return Promise.reject(error);
    }

    if (this[kEnded]) {
      return Promise.resolve(createIterResult(undefined, true));
    }

    if (this[kStream].destroyed) {
      // We need to defer via nextTick because if .destroy(err) is
      // called, the error will be emitted via nextTick, and
      // we cannot guarantee that there is no error lingering around
      // waiting to be emitted.
      return new Promise(function (resolve, reject) {
        process.nextTick(function () {
          if (_this[kError]) {
            reject(_this[kError]);
          } else {
            resolve(createIterResult(undefined, true));
          }
        });
      });
    } // if we have multiple next() calls
    // we will wait for the previous Promise to finish
    // this logic is optimized to support for await loops,
    // where next() is only called once at a time


    var lastPromise = this[kLastPromise];
    var promise;

    if (lastPromise) {
      promise = new Promise(wrapForNext(lastPromise, this));
    } else {
      // fast path needed to support multiple this.push()
      // without triggering the next() queue
      var data = this[kStream].read();

      if (data !== null) {
        return Promise.resolve(createIterResult(data, false));
      }

      promise = new Promise(this[kHandlePromise]);
    }

    this[kLastPromise] = promise;
    return promise;
  }
}, _defineProperty(_Object$setPrototypeO, Symbol.asyncIterator, function () {
  return this;
}), _defineProperty(_Object$setPrototypeO, "return", function _return() {
  var _this2 = this;

  // destroy(err, cb) is a private API
  // we can guarantee we have that here, because we control the
  // Readable class this is attached to
  return new Promise(function (resolve, reject) {
    _this2[kStream].destroy(null, function (err) {
      if (err) {
        reject(err);
        return;
      }

      resolve(createIterResult(undefined, true));
    });
  });
}), _Object$setPrototypeO), AsyncIteratorPrototype);

var createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
  var _Object$create;

  var iterator = Object.create(ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, _defineProperty(_Object$create, kStream, {
    value: stream,
    writable: true
  }), _defineProperty(_Object$create, kLastResolve, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kLastReject, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kError, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kEnded, {
    value: stream._readableState.endEmitted,
    writable: true
  }), _defineProperty(_Object$create, kHandlePromise, {
    value: function value(resolve, reject) {
      var data = iterator[kStream].read();

      if (data) {
        iterator[kLastPromise] = null;
        iterator[kLastResolve] = null;
        iterator[kLastReject] = null;
        resolve(createIterResult(data, false));
      } else {
        iterator[kLastResolve] = resolve;
        iterator[kLastReject] = reject;
      }
    },
    writable: true
  }), _Object$create));
  iterator[kLastPromise] = null;
  finished(stream, function (err) {
    if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
      var reject = iterator[kLastReject]; // reject if we are waiting for data in the Promise
      // returned by next() and store the error

      if (reject !== null) {
        iterator[kLastPromise] = null;
        iterator[kLastResolve] = null;
        iterator[kLastReject] = null;
        reject(err);
      }

      iterator[kError] = err;
      return;
    }

    var resolve = iterator[kLastResolve];

    if (resolve !== null) {
      iterator[kLastPromise] = null;
      iterator[kLastResolve] = null;
      iterator[kLastReject] = null;
      resolve(createIterResult(undefined, true));
    }

    iterator[kEnded] = true;
  });
  stream.on('readable', onReadable.bind(null, iterator));
  return iterator;
};

module.exports = createReadableStreamAsyncIterator;

/***/ }),

/***/ 29930:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var _require = __webpack_require__(45708),
    Buffer = _require.Buffer;

var _require2 = __webpack_require__(63779),
    inspect = _require2.inspect;

var custom = inspect && inspect.custom || 'inspect';

function copyBuffer(src, target, offset) {
  Buffer.prototype.copy.call(src, target, offset);
}

module.exports =
/*#__PURE__*/
function () {
  function BufferList() {
    _classCallCheck(this, BufferList);

    this.head = null;
    this.tail = null;
    this.length = 0;
  }

  _createClass(BufferList, [{
    key: "push",
    value: function push(v) {
      var entry = {
        data: v,
        next: null
      };
      if (this.length > 0) this.tail.next = entry;else this.head = entry;
      this.tail = entry;
      ++this.length;
    }
  }, {
    key: "unshift",
    value: function unshift(v) {
      var entry = {
        data: v,
        next: this.head
      };
      if (this.length === 0) this.tail = entry;
      this.head = entry;
      ++this.length;
    }
  }, {
    key: "shift",
    value: function shift() {
      if (this.length === 0) return;
      var ret = this.head.data;
      if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
      --this.length;
      return ret;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.head = this.tail = null;
      this.length = 0;
    }
  }, {
    key: "join",
    value: function join(s) {
      if (this.length === 0) return '';
      var p = this.head;
      var ret = '' + p.data;

      while (p = p.next) {
        ret += s + p.data;
      }

      return ret;
    }
  }, {
    key: "concat",
    value: function concat(n) {
      if (this.length === 0) return Buffer.alloc(0);
      var ret = Buffer.allocUnsafe(n >>> 0);
      var p = this.head;
      var i = 0;

      while (p) {
        copyBuffer(p.data, ret, i);
        i += p.data.length;
        p = p.next;
      }

      return ret;
    } // Consumes a specified amount of bytes or characters from the buffered data.

  }, {
    key: "consume",
    value: function consume(n, hasStrings) {
      var ret;

      if (n < this.head.data.length) {
        // `slice` is the same for buffers and strings.
        ret = this.head.data.slice(0, n);
        this.head.data = this.head.data.slice(n);
      } else if (n === this.head.data.length) {
        // First chunk is a perfect match.
        ret = this.shift();
      } else {
        // Result spans more than one buffer.
        ret = hasStrings ? this._getString(n) : this._getBuffer(n);
      }

      return ret;
    }
  }, {
    key: "first",
    value: function first() {
      return this.head.data;
    } // Consumes a specified amount of characters from the buffered data.

  }, {
    key: "_getString",
    value: function _getString(n) {
      var p = this.head;
      var c = 1;
      var ret = p.data;
      n -= ret.length;

      while (p = p.next) {
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;else ret += str.slice(0, n);
        n -= nb;

        if (n === 0) {
          if (nb === str.length) {
            ++c;
            if (p.next) this.head = p.next;else this.head = this.tail = null;
          } else {
            this.head = p;
            p.data = str.slice(nb);
          }

          break;
        }

        ++c;
      }

      this.length -= c;
      return ret;
    } // Consumes a specified amount of bytes from the buffered data.

  }, {
    key: "_getBuffer",
    value: function _getBuffer(n) {
      var ret = Buffer.allocUnsafe(n);
      var p = this.head;
      var c = 1;
      p.data.copy(ret);
      n -= p.data.length;

      while (p = p.next) {
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;

        if (n === 0) {
          if (nb === buf.length) {
            ++c;
            if (p.next) this.head = p.next;else this.head = this.tail = null;
          } else {
            this.head = p;
            p.data = buf.slice(nb);
          }

          break;
        }

        ++c;
      }

      this.length -= c;
      return ret;
    } // Make sure the linked list only shows the minimal necessary information.

  }, {
    key: custom,
    value: function value(_, options) {
      return inspect(this, _objectSpread({}, options, {
        // Only inspect one level.
        depth: 0,
        // It should not recurse.
        customInspect: false
      }));
    }
  }]);

  return BufferList;
}();

/***/ }),

/***/ 52023:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(33282);
 // undocumented cb() API, needed for core, not for public API

function destroy(err, cb) {
  var _this = this;

  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;

  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err) {
      if (!this._writableState) {
        process.nextTick(emitErrorNT, this, err);
      } else if (!this._writableState.errorEmitted) {
        this._writableState.errorEmitted = true;
        process.nextTick(emitErrorNT, this, err);
      }
    }

    return this;
  } // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks


  if (this._readableState) {
    this._readableState.destroyed = true;
  } // if this is a duplex stream mark the writable part as destroyed as well


  if (this._writableState) {
    this._writableState.destroyed = true;
  }

  this._destroy(err || null, function (err) {
    if (!cb && err) {
      if (!_this._writableState) {
        process.nextTick(emitErrorAndCloseNT, _this, err);
      } else if (!_this._writableState.errorEmitted) {
        _this._writableState.errorEmitted = true;
        process.nextTick(emitErrorAndCloseNT, _this, err);
      } else {
        process.nextTick(emitCloseNT, _this);
      }
    } else if (cb) {
      process.nextTick(emitCloseNT, _this);
      cb(err);
    } else {
      process.nextTick(emitCloseNT, _this);
    }
  });

  return this;
}

function emitErrorAndCloseNT(self, err) {
  emitErrorNT(self, err);
  emitCloseNT(self);
}

function emitCloseNT(self) {
  if (self._writableState && !self._writableState.emitClose) return;
  if (self._readableState && !self._readableState.emitClose) return;
  self.emit('close');
}

function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }

  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finalCalled = false;
    this._writableState.prefinished = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}

function emitErrorNT(self, err) {
  self.emit('error', err);
}

function errorOrDestroy(stream, err) {
  // We have tests that rely on errors being emitted
  // in the same tick, so changing this is semver major.
  // For now when you opt-in to autoDestroy we allow
  // the error to be emitted nextTick. In a future
  // semver major update we should change the default to this.
  var rState = stream._readableState;
  var wState = stream._writableState;
  if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);else stream.emit('error', err);
}

module.exports = {
  destroy: destroy,
  undestroy: undestroy,
  errorOrDestroy: errorOrDestroy
};

/***/ }),

/***/ 37165:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).


var ERR_STREAM_PREMATURE_CLOSE = (__webpack_require__(44059)/* .codes */ .F).ERR_STREAM_PREMATURE_CLOSE;

function once(callback) {
  var called = false;
  return function () {
    if (called) return;
    called = true;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    callback.apply(this, args);
  };
}

function noop() {}

function isRequest(stream) {
  return stream.setHeader && typeof stream.abort === 'function';
}

function eos(stream, opts, callback) {
  if (typeof opts === 'function') return eos(stream, null, opts);
  if (!opts) opts = {};
  callback = once(callback || noop);
  var readable = opts.readable || opts.readable !== false && stream.readable;
  var writable = opts.writable || opts.writable !== false && stream.writable;

  var onlegacyfinish = function onlegacyfinish() {
    if (!stream.writable) onfinish();
  };

  var writableEnded = stream._writableState && stream._writableState.finished;

  var onfinish = function onfinish() {
    writable = false;
    writableEnded = true;
    if (!readable) callback.call(stream);
  };

  var readableEnded = stream._readableState && stream._readableState.endEmitted;

  var onend = function onend() {
    readable = false;
    readableEnded = true;
    if (!writable) callback.call(stream);
  };

  var onerror = function onerror(err) {
    callback.call(stream, err);
  };

  var onclose = function onclose() {
    var err;

    if (readable && !readableEnded) {
      if (!stream._readableState || !stream._readableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
      return callback.call(stream, err);
    }

    if (writable && !writableEnded) {
      if (!stream._writableState || !stream._writableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
      return callback.call(stream, err);
    }
  };

  var onrequest = function onrequest() {
    stream.req.on('finish', onfinish);
  };

  if (isRequest(stream)) {
    stream.on('complete', onfinish);
    stream.on('abort', onclose);
    if (stream.req) onrequest();else stream.on('request', onrequest);
  } else if (writable && !stream._writableState) {
    // legacy streams
    stream.on('end', onlegacyfinish);
    stream.on('close', onlegacyfinish);
  }

  stream.on('end', onend);
  stream.on('finish', onfinish);
  if (opts.error !== false) stream.on('error', onerror);
  stream.on('close', onclose);
  return function () {
    stream.removeListener('complete', onfinish);
    stream.removeListener('abort', onclose);
    stream.removeListener('request', onrequest);
    if (stream.req) stream.req.removeListener('finish', onfinish);
    stream.removeListener('end', onlegacyfinish);
    stream.removeListener('close', onlegacyfinish);
    stream.removeListener('finish', onfinish);
    stream.removeListener('end', onend);
    stream.removeListener('error', onerror);
    stream.removeListener('close', onclose);
  };
}

module.exports = eos;

/***/ }),

/***/ 37108:
/***/ (function(module) {

module.exports = function () {
  throw new Error('Readable.from is not available in the browser')
};


/***/ }),

/***/ 6772:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).


var eos;

function once(callback) {
  var called = false;
  return function () {
    if (called) return;
    called = true;
    callback.apply(void 0, arguments);
  };
}

var _require$codes = (__webpack_require__(44059)/* .codes */ .F),
    ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS,
    ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED;

function noop(err) {
  // Rethrow the error if it exists to avoid swallowing it
  if (err) throw err;
}

function isRequest(stream) {
  return stream.setHeader && typeof stream.abort === 'function';
}

function destroyer(stream, reading, writing, callback) {
  callback = once(callback);
  var closed = false;
  stream.on('close', function () {
    closed = true;
  });
  if (eos === undefined) eos = __webpack_require__(37165);
  eos(stream, {
    readable: reading,
    writable: writing
  }, function (err) {
    if (err) return callback(err);
    closed = true;
    callback();
  });
  var destroyed = false;
  return function (err) {
    if (closed) return;
    if (destroyed) return;
    destroyed = true; // request.destroy just do .end - .abort is what we want

    if (isRequest(stream)) return stream.abort();
    if (typeof stream.destroy === 'function') return stream.destroy();
    callback(err || new ERR_STREAM_DESTROYED('pipe'));
  };
}

function call(fn) {
  fn();
}

function pipe(from, to) {
  return from.pipe(to);
}

function popCallback(streams) {
  if (!streams.length) return noop;
  if (typeof streams[streams.length - 1] !== 'function') return noop;
  return streams.pop();
}

function pipeline() {
  for (var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++) {
    streams[_key] = arguments[_key];
  }

  var callback = popCallback(streams);
  if (Array.isArray(streams[0])) streams = streams[0];

  if (streams.length < 2) {
    throw new ERR_MISSING_ARGS('streams');
  }

  var error;
  var destroys = streams.map(function (stream, i) {
    var reading = i < streams.length - 1;
    var writing = i > 0;
    return destroyer(stream, reading, writing, function (err) {
      if (!error) error = err;
      if (err) destroys.forEach(call);
      if (reading) return;
      destroys.forEach(call);
      callback(error);
    });
  });
  return streams.reduce(pipe);
}

module.exports = pipeline;

/***/ }),

/***/ 31976:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var ERR_INVALID_OPT_VALUE = (__webpack_require__(44059)/* .codes */ .F).ERR_INVALID_OPT_VALUE;

function highWaterMarkFrom(options, isDuplex, duplexKey) {
  return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}

function getHighWaterMark(state, options, duplexKey, isDuplex) {
  var hwm = highWaterMarkFrom(options, isDuplex, duplexKey);

  if (hwm != null) {
    if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
      var name = isDuplex ? duplexKey : 'highWaterMark';
      throw new ERR_INVALID_OPT_VALUE(name, hwm);
    }

    return Math.floor(hwm);
  } // Default value


  return state.objectMode ? 16 : 16 * 1024;
}

module.exports = {
  getHighWaterMark: getHighWaterMark
};

/***/ }),

/***/ 60032:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(7683).EventEmitter;


/***/ }),

/***/ 54304:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var Buffer = (__webpack_require__(41041).Buffer);
/*</replacement>*/

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.I = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return byte >> 6 === 0x02 ? -1 : -2;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\ufffd';
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\ufffd';
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\ufffd';
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\ufffd';
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}

/***/ }),

/***/ 79743:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var Buffer = __webpack_require__(45708)["Buffer"];

/**
 * Module dependencies.
 */

var assert = __webpack_require__(85672);
var debug = __webpack_require__(79399)('stream-parser');

/**
 * Module exports.
 */

module.exports = Parser;

/**
 * Parser states.
 */

var INIT        = -1;
var BUFFERING   = 0;
var SKIPPING    = 1;
var PASSTHROUGH = 2;

/**
 * The `Parser` stream mixin works with either `Writable` or `Transform` stream
 * instances/subclasses. Provides a convenient generic "parsing" API:
 *
 *   _bytes(n, cb) - buffers "n" bytes and then calls "cb" with the "chunk"
 *   _skipBytes(n, cb) - skips "n" bytes and then calls "cb" when done
 *
 * If you extend a `Transform` stream, then the `_passthrough()` function is also
 * added:
 *
 *   _passthrough(n, cb) - passes through "n" bytes untouched and then calls "cb"
 *
 * @param {Stream} stream Transform or Writable stream instance to extend
 * @api public
 */

function Parser (stream) {
  var isTransform = stream && 'function' == typeof stream._transform;
  var isWritable = stream && 'function' == typeof stream._write;

  if (!isTransform && !isWritable) throw new Error('must pass a Writable or Transform stream in');
  debug('extending Parser into stream');

  // Transform streams and Writable streams get `_bytes()` and `_skipBytes()`
  stream._bytes = _bytes;
  stream._skipBytes = _skipBytes;

  // only Transform streams get the `_passthrough()` function
  if (isTransform) stream._passthrough = _passthrough;

  // take control of the streams2 callback functions for this stream
  if (isTransform) {
    stream._transform = transform;
  } else {
    stream._write = write;
  }
}

function init (stream) {
  debug('initializing parser stream');

  // number of bytes left to parser for the next "chunk"
  stream._parserBytesLeft = 0;

  // array of Buffer instances that make up the next "chunk"
  stream._parserBuffers = [];

  // number of bytes parsed so far for the next "chunk"
  stream._parserBuffered = 0;

  // flag that keeps track of if what the parser should do with bytes received
  stream._parserState = INIT;

  // the callback for the next "chunk"
  stream._parserCallback = null;

  // XXX: backwards compat with the old Transform API... remove at some point..
  if ('function' == typeof stream.push) {
    stream._parserOutput = stream.push.bind(stream);
  }

  stream._parserInit = true;
}

/**
 * Buffers `n` bytes and then invokes `fn` once that amount has been collected.
 *
 * @param {Number} n the number of bytes to buffer
 * @param {Function} fn callback function to invoke when `n` bytes are buffered
 * @api public
 */

function _bytes (n, fn) {
  assert(!this._parserCallback, 'there is already a "callback" set!');
  assert(isFinite(n) && n > 0, 'can only buffer a finite number of bytes > 0, got "' + n + '"');
  if (!this._parserInit) init(this);
  debug('buffering %o bytes', n);
  this._parserBytesLeft = n;
  this._parserCallback = fn;
  this._parserState = BUFFERING;
}

/**
 * Skips over the next `n` bytes, then invokes `fn` once that amount has
 * been discarded.
 *
 * @param {Number} n the number of bytes to discard
 * @param {Function} fn callback function to invoke when `n` bytes have been skipped
 * @api public
 */

function _skipBytes (n, fn) {
  assert(!this._parserCallback, 'there is already a "callback" set!');
  assert(n > 0, 'can only skip > 0 bytes, got "' + n + '"');
  if (!this._parserInit) init(this);
  debug('skipping %o bytes', n);
  this._parserBytesLeft = n;
  this._parserCallback = fn;
  this._parserState = SKIPPING;
}

/**
 * Passes through `n` bytes to the readable side of this stream untouched,
 * then invokes `fn` once that amount has been passed through.
 *
 * @param {Number} n the number of bytes to pass through
 * @param {Function} fn callback function to invoke when `n` bytes have passed through
 * @api public
 */

function _passthrough (n, fn) {
  assert(!this._parserCallback, 'There is already a "callback" set!');
  assert(n > 0, 'can only pass through > 0 bytes, got "' + n + '"');
  if (!this._parserInit) init(this);
  debug('passing through %o bytes', n);
  this._parserBytesLeft = n;
  this._parserCallback = fn;
  this._parserState = PASSTHROUGH;
}

/**
 * The `_write()` callback function implementation.
 *
 * @api private
 */

function write (chunk, encoding, fn) {
  if (!this._parserInit) init(this);
  debug('write(%o bytes)', chunk.length);

  // XXX: old Writable stream API compat... remove at some point...
  if ('function' == typeof encoding) fn = encoding;

  data(this, chunk, null, fn);
}

/**
 * The `_transform()` callback function implementation.
 *
 * @api private
 */


function transform (chunk, output, fn) {
  if (!this._parserInit) init(this);
  debug('transform(%o bytes)', chunk.length);

  // XXX: old Transform stream API compat... remove at some point...
  if ('function' != typeof output) {
    output = this._parserOutput;
  }

  data(this, chunk, output, fn);
}

/**
 * The internal buffering/passthrough logic...
 *
 * This `_data` function get's "trampolined" to prevent stack overflows for tight
 * loops. This technique requires us to return a "thunk" function for any
 * synchronous action. Async stuff breaks the trampoline, but that's ok since it's
 * working with a new stack at that point anyway.
 *
 * @api private
 */

function _data (stream, chunk, output, fn) {
  if (stream._parserBytesLeft <= 0) {
    return fn(new Error('got data but not currently parsing anything'));
  }

  if (chunk.length <= stream._parserBytesLeft) {
    // small buffer fits within the "_parserBytesLeft" window
    return function () {
      return process(stream, chunk, output, fn);
    };
  } else {
    // large buffer needs to be sliced on "_parserBytesLeft" and processed
    return function () {
      var b = chunk.slice(0, stream._parserBytesLeft);
      return process(stream, b, output, function (err) {
        if (err) return fn(err);
        if (chunk.length > b.length) {
          return function () {
            return _data(stream, chunk.slice(b.length), output, fn);
          };
        }
      });
    };
  }
}

/**
 * The internal `process` function gets called by the `data` function when
 * something "interesting" happens. This function takes care of buffering the
 * bytes when buffering, passing through the bytes when doing that, and invoking
 * the user callback when the number of bytes has been reached.
 *
 * @api private
 */

function process (stream, chunk, output, fn) {
  stream._parserBytesLeft -= chunk.length;
  debug('%o bytes left for stream piece', stream._parserBytesLeft);

  if (stream._parserState === BUFFERING) {
    // buffer
    stream._parserBuffers.push(chunk);
    stream._parserBuffered += chunk.length;
  } else if (stream._parserState === PASSTHROUGH) {
    // passthrough
    output(chunk);
  }
  // don't need to do anything for the SKIPPING case

  if (0 === stream._parserBytesLeft) {
    // done with stream "piece", invoke the callback
    var cb = stream._parserCallback;
    if (cb && stream._parserState === BUFFERING && stream._parserBuffers.length > 1) {
      chunk = Buffer.concat(stream._parserBuffers, stream._parserBuffered);
    }
    if (stream._parserState !== BUFFERING) {
      chunk = null;
    }
    stream._parserCallback = null;
    stream._parserBuffered = 0;
    stream._parserState = INIT;
    stream._parserBuffers.splice(0); // empty

    if (cb) {
      var args = [];
      if (chunk) {
        // buffered
        args.push(chunk);
      } else {
        // passthrough
      }
      if (output) {
        // on a Transform stream, has "output" function
        args.push(output);
      }
      var async = cb.length > args.length;
      if (async) {
        args.push(trampoline(fn));
      }
      // invoke cb
      var rtn = cb.apply(stream, args);
      if (!async || fn === rtn) return fn;
    }
  } else {
    // need more bytes
    return fn;
  }
}

var data = trampoline(_data);

/**
 * Generic thunk-based "trampoline" helper function.
 *
 * @param {Function} input function
 * @return {Function} "trampolined" function
 * @api private
 */

function trampoline (fn) {
  return function () {
    var result = fn.apply(this, arguments);

    while ('function' == typeof result) {
      result = result();
    }

    return result;
  };
}


/***/ }),

/***/ 79399:
/***/ (function(module, exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(33282);
/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__(43228);
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  'lightseagreen',
  'forestgreen',
  'goldenrod',
  'dodgerblue',
  'darkorchid',
  'crimson'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
    // double check webkit in userAgent just in case we are in a worker
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit')

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = process.env.DEBUG;
  }

  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}


/***/ }),

/***/ 43228:
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__(13883);

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};

/**
 * Previous log timestamp.
 */

var prevTime;

/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0, i;

  for (i in namespace) {
    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function createDebug(namespace) {

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  return debug;
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (var i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


/***/ }),

/***/ 13883:
/***/ (function(module) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') ||
    plural(ms, h, 'hour') ||
    plural(ms, m, 'minute') ||
    plural(ms, s, 'second') ||
    ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return;
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name;
  }
  return Math.ceil(ms / n) + ' ' + name + 's';
}


/***/ }),

/***/ 28089:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var paren = __webpack_require__(59811)

module.exports = function splitBy (string, separator, o) {
	if (string == null) throw Error('First argument should be a string')
	if (separator == null) throw Error('Separator should be a string or a RegExp')

	if (!o) o = {}
	else if (typeof o === 'string' || Array.isArray(o)) {
		o = {ignore: o}
	}

	if (o.escape == null) o.escape = true
	if (o.ignore == null) o.ignore = ['[]', '()', '{}', '<>', '""', "''", '``', '“”', '«»']
	else {
		if (typeof o.ignore === 'string') {o.ignore = [o.ignore]}

		o.ignore = o.ignore.map(function (pair) {
			// '"' → '""'
			if (pair.length === 1) pair = pair + pair
			return pair
		})
	}

	var tokens = paren.parse(string, {flat: true, brackets: o.ignore})
	var str = tokens[0]

	var parts = str.split(separator)

	// join parts separated by escape
	if (o.escape) {
		var cleanParts = []
		for (var i = 0; i < parts.length; i++) {
			var prev = parts[i]
			var part = parts[i + 1]

			if (prev[prev.length - 1] === '\\' && prev[prev.length - 2] !== '\\') {
				cleanParts.push(prev + separator + part)
				i++
			}
			else {
				cleanParts.push(prev)
			}
		}
		parts = cleanParts
	}

	// open parens pack & apply unquotes, if any
	for (var i = 0; i < parts.length; i++) {
		tokens[0] = parts[i]
		parts[i] = paren.stringify(tokens, {flat: true})
	}

	return parts
}


/***/ }),

/***/ 26381:
/***/ (function(module) {

"use strict";


module.exports = stronglyConnectedComponents

function stronglyConnectedComponents(adjList) {
  var numVertices = adjList.length;
  var index = new Array(numVertices)
  var lowValue = new Array(numVertices)
  var active = new Array(numVertices)
  var child = new Array(numVertices)
  var scc = new Array(numVertices)
  var sccLinks = new Array(numVertices)
  
  //Initialize tables
  for(var i=0; i<numVertices; ++i) {
    index[i] = -1
    lowValue[i] = 0
    active[i] = false
    child[i] = 0
    scc[i] = -1
    sccLinks[i] = []
  }

  // The strongConnect function
  var count = 0
  var components = []
  var sccAdjList = []

  function strongConnect(v) {
    // To avoid running out of stack space, this emulates the recursive behaviour of the normal algorithm, effectively using T as the call stack.
    var S = [v], T = [v]
    index[v] = lowValue[v] = count
    active[v] = true
    count += 1
    while(T.length > 0) {
      v = T[T.length-1]
      var e = adjList[v]
      if (child[v] < e.length) { // If we're not done iterating over the children, first try finishing that.
        for(var i=child[v]; i<e.length; ++i) { // Start where we left off.
          var u = e[i]
          if(index[u] < 0) {
            index[u] = lowValue[u] = count
            active[u] = true
            count += 1
            S.push(u)
            T.push(u)
            break // First recurse, then continue here (with the same child!).
            // There is a slight change to Tarjan's algorithm here.
            // Normally, after having recursed, we set lowValue like we do for an active child (although some variants of the algorithm do it slightly differently).
            // Here, we only do so if the child we recursed on is still active.
            // The reasoning is that if it is no longer active, it must have had a lowValue equal to its own index, which means that it is necessarily higher than our lowValue.
          } else if (active[u]) {
            lowValue[v] = Math.min(lowValue[v], lowValue[u])|0
          }
          if (scc[u] >= 0) {
            // Node v is not yet assigned an scc, but once it is that scc can apparently reach scc[u].
            sccLinks[v].push(scc[u])
          }
        }
        child[v] = i // Remember where we left off.
      } else { // If we're done iterating over the children, check whether we have an scc.
        if(lowValue[v] === index[v]) { // TODO: It /might/ be true that T is always a prefix of S (at this point!!!), and if so, this could be used here.
          var component = []
          var links = [], linkCount = 0
          for(var i=S.length-1; i>=0; --i) {
            var w = S[i]
            active[w] = false
            component.push(w)
            links.push(sccLinks[w])
            linkCount += sccLinks[w].length
            scc[w] = components.length
            if(w === v) {
              S.length = i
              break
            }
          }
          components.push(component)
          var allLinks = new Array(linkCount)
          for(var i=0; i<links.length; i++) {
            for(var j=0; j<links[i].length; j++) {
              allLinks[--linkCount] = links[i][j]
            }
          }
          sccAdjList.push(allLinks)
        }
        T.pop() // Now we're finished exploring this particular node (normally corresponds to the return statement)
      }
    }
  }

  //Run strong connect starting from each vertex
  for(var i=0; i<numVertices; ++i) {
    if(index[i] < 0) {
      strongConnect(i)
    }
  }
  
  // Compact sccAdjList
  var newE
  for(var i=0; i<sccAdjList.length; i++) {
    var e = sccAdjList[i]
    if (e.length === 0) continue
    e.sort(function (a,b) { return a-b; })
    newE = [e[0]]
    for(var j=1; j<e.length; j++) {
      if (e[j] !== e[j-1]) {
        newE.push(e[j])
      }
    }
    sccAdjList[i] = newE
  }  

  return {components: components, adjacencyList: sccAdjList}
}


/***/ }),

/***/ 13193:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var TAU = Math.PI * 2;

var mapToEllipse = function mapToEllipse(_ref, rx, ry, cosphi, sinphi, centerx, centery) {
  var x = _ref.x,
      y = _ref.y;

  x *= rx;
  y *= ry;

  var xp = cosphi * x - sinphi * y;
  var yp = sinphi * x + cosphi * y;

  return {
    x: xp + centerx,
    y: yp + centery
  };
};

var approxUnitArc = function approxUnitArc(ang1, ang2) {
  // If 90 degree circular arc, use a constant
  // as derived from http://spencermortensen.com/articles/bezier-circle
  var a = ang2 === 1.5707963267948966 ? 0.551915024494 : ang2 === -1.5707963267948966 ? -0.551915024494 : 4 / 3 * Math.tan(ang2 / 4);

  var x1 = Math.cos(ang1);
  var y1 = Math.sin(ang1);
  var x2 = Math.cos(ang1 + ang2);
  var y2 = Math.sin(ang1 + ang2);

  return [{
    x: x1 - y1 * a,
    y: y1 + x1 * a
  }, {
    x: x2 + y2 * a,
    y: y2 - x2 * a
  }, {
    x: x2,
    y: y2
  }];
};

var vectorAngle = function vectorAngle(ux, uy, vx, vy) {
  var sign = ux * vy - uy * vx < 0 ? -1 : 1;

  var dot = ux * vx + uy * vy;

  if (dot > 1) {
    dot = 1;
  }

  if (dot < -1) {
    dot = -1;
  }

  return sign * Math.acos(dot);
};

var getArcCenter = function getArcCenter(px, py, cx, cy, rx, ry, largeArcFlag, sweepFlag, sinphi, cosphi, pxp, pyp) {
  var rxsq = Math.pow(rx, 2);
  var rysq = Math.pow(ry, 2);
  var pxpsq = Math.pow(pxp, 2);
  var pypsq = Math.pow(pyp, 2);

  var radicant = rxsq * rysq - rxsq * pypsq - rysq * pxpsq;

  if (radicant < 0) {
    radicant = 0;
  }

  radicant /= rxsq * pypsq + rysq * pxpsq;
  radicant = Math.sqrt(radicant) * (largeArcFlag === sweepFlag ? -1 : 1);

  var centerxp = radicant * rx / ry * pyp;
  var centeryp = radicant * -ry / rx * pxp;

  var centerx = cosphi * centerxp - sinphi * centeryp + (px + cx) / 2;
  var centery = sinphi * centerxp + cosphi * centeryp + (py + cy) / 2;

  var vx1 = (pxp - centerxp) / rx;
  var vy1 = (pyp - centeryp) / ry;
  var vx2 = (-pxp - centerxp) / rx;
  var vy2 = (-pyp - centeryp) / ry;

  var ang1 = vectorAngle(1, 0, vx1, vy1);
  var ang2 = vectorAngle(vx1, vy1, vx2, vy2);

  if (sweepFlag === 0 && ang2 > 0) {
    ang2 -= TAU;
  }

  if (sweepFlag === 1 && ang2 < 0) {
    ang2 += TAU;
  }

  return [centerx, centery, ang1, ang2];
};

var arcToBezier = function arcToBezier(_ref2) {
  var px = _ref2.px,
      py = _ref2.py,
      cx = _ref2.cx,
      cy = _ref2.cy,
      rx = _ref2.rx,
      ry = _ref2.ry,
      _ref2$xAxisRotation = _ref2.xAxisRotation,
      xAxisRotation = _ref2$xAxisRotation === undefined ? 0 : _ref2$xAxisRotation,
      _ref2$largeArcFlag = _ref2.largeArcFlag,
      largeArcFlag = _ref2$largeArcFlag === undefined ? 0 : _ref2$largeArcFlag,
      _ref2$sweepFlag = _ref2.sweepFlag,
      sweepFlag = _ref2$sweepFlag === undefined ? 0 : _ref2$sweepFlag;

  var curves = [];

  if (rx === 0 || ry === 0) {
    return [];
  }

  var sinphi = Math.sin(xAxisRotation * TAU / 360);
  var cosphi = Math.cos(xAxisRotation * TAU / 360);

  var pxp = cosphi * (px - cx) / 2 + sinphi * (py - cy) / 2;
  var pyp = -sinphi * (px - cx) / 2 + cosphi * (py - cy) / 2;

  if (pxp === 0 && pyp === 0) {
    return [];
  }

  rx = Math.abs(rx);
  ry = Math.abs(ry);

  var lambda = Math.pow(pxp, 2) / Math.pow(rx, 2) + Math.pow(pyp, 2) / Math.pow(ry, 2);

  if (lambda > 1) {
    rx *= Math.sqrt(lambda);
    ry *= Math.sqrt(lambda);
  }

  var _getArcCenter = getArcCenter(px, py, cx, cy, rx, ry, largeArcFlag, sweepFlag, sinphi, cosphi, pxp, pyp),
      _getArcCenter2 = _slicedToArray(_getArcCenter, 4),
      centerx = _getArcCenter2[0],
      centery = _getArcCenter2[1],
      ang1 = _getArcCenter2[2],
      ang2 = _getArcCenter2[3];

  // If 'ang2' == 90.0000000001, then `ratio` will evaluate to
  // 1.0000000001. This causes `segments` to be greater than one, which is an
  // unecessary split, and adds extra points to the bezier curve. To alleviate
  // this issue, we round to 1.0 when the ratio is close to 1.0.


  var ratio = Math.abs(ang2) / (TAU / 4);
  if (Math.abs(1.0 - ratio) < 0.0000001) {
    ratio = 1.0;
  }

  var segments = Math.max(Math.ceil(ratio), 1);

  ang2 /= segments;

  for (var i = 0; i < segments; i++) {
    curves.push(approxUnitArc(ang1, ang2));
    ang1 += ang2;
  }

  return curves.map(function (curve) {
    var _mapToEllipse = mapToEllipse(curve[0], rx, ry, cosphi, sinphi, centerx, centery),
        x1 = _mapToEllipse.x,
        y1 = _mapToEllipse.y;

    var _mapToEllipse2 = mapToEllipse(curve[1], rx, ry, cosphi, sinphi, centerx, centery),
        x2 = _mapToEllipse2.x,
        y2 = _mapToEllipse2.y;

    var _mapToEllipse3 = mapToEllipse(curve[2], rx, ry, cosphi, sinphi, centerx, centery),
        x = _mapToEllipse3.x,
        y = _mapToEllipse3.y;

    return { x1: x1, y1: y1, x2: x2, y2: y2, x: x, y: y };
  });
};

/* harmony default export */ __webpack_exports__["default"] = (arcToBezier);

/***/ }),

/***/ 97251:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var parse = __webpack_require__(26953)
var abs = __webpack_require__(16844)
var normalize = __webpack_require__(41883)
var isSvgPath = __webpack_require__(13986)
var assert = __webpack_require__(85672)

module.exports = pathBounds


function pathBounds(path) {
  // ES6 string tpl call
  if (Array.isArray(path) && path.length === 1 && typeof path[0] === 'string') path = path[0]

  // svg path string
  if (typeof path === 'string') {
    assert(isSvgPath(path), 'String is not an SVG path.')
    path = parse(path)
  }

  assert(Array.isArray(path), 'Argument should be a string or an array of path segments.')

  path = abs(path)
  path = normalize(path)

  if (!path.length) return [0, 0, 0, 0]

  var bounds = [Infinity, Infinity, -Infinity, -Infinity]

  for (var i = 0, l = path.length; i < l; i++) {
    var points = path[i].slice(1)

    for (var j = 0; j < points.length; j += 2) {
      if (points[j + 0] < bounds[0]) bounds[0] = points[j + 0]
      if (points[j + 1] < bounds[1]) bounds[1] = points[j + 1]
      if (points[j + 0] > bounds[2]) bounds[2] = points[j + 0]
      if (points[j + 1] > bounds[3]) bounds[3] = points[j + 1]
    }
  }

  return bounds
}


/***/ }),

/***/ 41883:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = normalize

var arcToCurve = __webpack_require__(13193)

function normalize(path){
  // init state
  var prev
  var result = []
  var bezierX = 0
  var bezierY = 0
  var startX = 0
  var startY = 0
  var quadX = null
  var quadY = null
  var x = 0
  var y = 0

  for (var i = 0, len = path.length; i < len; i++) {
    var seg = path[i]
    var command = seg[0]

    switch (command) {
      case 'M':
        startX = seg[1]
        startY = seg[2]
        break
      case 'A':
        var curves = arcToCurve({
          px: x,
          py: y,
          cx: seg[6],
          cy:  seg[7],
          rx: seg[1],
          ry: seg[2],
          xAxisRotation: seg[3],
          largeArcFlag: seg[4],
          sweepFlag: seg[5]
        })

        // null-curves
        if (!curves.length) continue

        for (var j = 0, c; j < curves.length; j++) {
          c = curves[j]
          seg = ['C', c.x1, c.y1, c.x2, c.y2, c.x, c.y]
          if (j < curves.length - 1) result.push(seg)
        }

        break
      case 'S':
        // default control point
        var cx = x
        var cy = y
        if (prev == 'C' || prev == 'S') {
          cx += cx - bezierX // reflect the previous command's control
          cy += cy - bezierY // point relative to the current point
        }
        seg = ['C', cx, cy, seg[1], seg[2], seg[3], seg[4]]
        break
      case 'T':
        if (prev == 'Q' || prev == 'T') {
          quadX = x * 2 - quadX // as with 'S' reflect previous control point
          quadY = y * 2 - quadY
        } else {
          quadX = x
          quadY = y
        }
        seg = quadratic(x, y, quadX, quadY, seg[1], seg[2])
        break
      case 'Q':
        quadX = seg[1]
        quadY = seg[2]
        seg = quadratic(x, y, seg[1], seg[2], seg[3], seg[4])
        break
      case 'L':
        seg = line(x, y, seg[1], seg[2])
        break
      case 'H':
        seg = line(x, y, seg[1], y)
        break
      case 'V':
        seg = line(x, y, x, seg[1])
        break
      case 'Z':
        seg = line(x, y, startX, startY)
        break
    }

    // update state
    prev = command
    x = seg[seg.length - 2]
    y = seg[seg.length - 1]
    if (seg.length > 4) {
      bezierX = seg[seg.length - 4]
      bezierY = seg[seg.length - 3]
    } else {
      bezierX = x
      bezierY = y
    }
    result.push(seg)
  }

  return result
}

function line(x1, y1, x2, y2){
  return ['C', x1, y1, x2, y2, x2, y2]
}

function quadratic(x1, y1, cx, cy, x2, y2){
  return [
    'C',
    x1/3 + (2/3) * cx,
    y1/3 + (2/3) * cy,
    x2/3 + (2/3) * cx,
    y2/3 + (2/3) * cy,
    x2,
    y2
  ]
}


/***/ }),

/***/ 96021:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var pathBounds = __webpack_require__(97251)
var parsePath = __webpack_require__(26953)
var drawPath = __webpack_require__(95620)
var isSvgPath = __webpack_require__(13986)
var bitmapSdf = __webpack_require__(88772)

var canvas = document.createElement('canvas')
var ctx = canvas.getContext('2d')


module.exports = pathSdf


function pathSdf (path, options) {
	if (!isSvgPath(path)) throw Error('Argument should be valid svg path string')

	if (!options) options = {}

	var w, h
	if (options.shape) {
		w = options.shape[0]
		h = options.shape[1]
	}
	else {
		w = canvas.width = options.w || options.width || 200
		h = canvas.height = options.h || options.height || 200
	}
	var size = Math.min(w, h)

	var stroke = options.stroke || 0

	var viewbox = options.viewbox || options.viewBox || pathBounds(path)
	var scale = [w / (viewbox[2] - viewbox[0]), h / (viewbox[3] - viewbox[1])]
	var maxScale = Math.min(scale[0] || 0, scale[1] || 0) / 2

	//clear ctx
	ctx.fillStyle = 'black'
	ctx.fillRect(0, 0, w, h)

	ctx.fillStyle = 'white'

	if (stroke)	{
		if (typeof stroke != 'number') stroke = 1
		if (stroke > 0) {
			ctx.strokeStyle = 'white'
		}
		else {
			ctx.strokeStyle = 'black'
		}

		ctx.lineWidth = Math.abs(stroke)
	}

	ctx.translate(w * .5, h * .5)
	ctx.scale(maxScale, maxScale)

	//if canvas svg paths api is available
	if (isPath2DSupported()) {
		var path2d = new Path2D(path)
		ctx.fill(path2d)
		stroke && ctx.stroke(path2d)
	}
	//fallback to bezier-curves
	else {
		var segments = parsePath(path)
		drawPath(ctx, segments)
		ctx.fill()
		stroke && ctx.stroke()
	}

	ctx.setTransform(1, 0, 0, 1, 0, 0);

	var data = bitmapSdf(ctx, {
		cutoff: options.cutoff != null ? options.cutoff : .5,
		radius: options.radius != null ? options.radius : size * .5
	})

	return data
}

var path2DSupported

function isPath2DSupported () {
	if (path2DSupported != null) return path2DSupported

	var ctx = document.createElement('canvas').getContext('2d')
	ctx.canvas.width = ctx.canvas.height = 1

	if (!window.Path2D) return path2DSupported = false

	var path = new Path2D('M0,0h1v1h-1v-1Z')

	ctx.fillStyle = 'black'
	ctx.fill(path)

	var idata = ctx.getImageData(0,0,1,1)

	return path2DSupported = idata && idata.data && idata.data[3] === 255
}


/***/ }),

/***/ 65657:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;// TinyColor v1.4.2
// https://github.com/bgrins/TinyColor
// Brian Grinstead, MIT License

(function(Math) {

var trimLeft = /^\s+/,
    trimRight = /\s+$/,
    tinyCounter = 0,
    mathRound = Math.round,
    mathMin = Math.min,
    mathMax = Math.max,
    mathRandom = Math.random;

function tinycolor (color, opts) {

    color = (color) ? color : '';
    opts = opts || { };

    // If input is already a tinycolor, return itself
    if (color instanceof tinycolor) {
       return color;
    }
    // If we are called as a function, call using new instead
    if (!(this instanceof tinycolor)) {
        return new tinycolor(color, opts);
    }

    var rgb = inputToRGB(color);
    this._originalInput = color,
    this._r = rgb.r,
    this._g = rgb.g,
    this._b = rgb.b,
    this._a = rgb.a,
    this._roundA = mathRound(100*this._a) / 100,
    this._format = opts.format || rgb.format;
    this._gradientType = opts.gradientType;

    // Don't let the range of [0,255] come back in [0,1].
    // Potentially lose a little bit of precision here, but will fix issues where
    // .5 gets interpreted as half of the total, instead of half of 1
    // If it was supposed to be 128, this was already taken care of by `inputToRgb`
    if (this._r < 1) { this._r = mathRound(this._r); }
    if (this._g < 1) { this._g = mathRound(this._g); }
    if (this._b < 1) { this._b = mathRound(this._b); }

    this._ok = rgb.ok;
    this._tc_id = tinyCounter++;
}

tinycolor.prototype = {
    isDark: function() {
        return this.getBrightness() < 128;
    },
    isLight: function() {
        return !this.isDark();
    },
    isValid: function() {
        return this._ok;
    },
    getOriginalInput: function() {
      return this._originalInput;
    },
    getFormat: function() {
        return this._format;
    },
    getAlpha: function() {
        return this._a;
    },
    getBrightness: function() {
        //http://www.w3.org/TR/AERT#color-contrast
        var rgb = this.toRgb();
        return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
    },
    getLuminance: function() {
        //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
        var rgb = this.toRgb();
        var RsRGB, GsRGB, BsRGB, R, G, B;
        RsRGB = rgb.r/255;
        GsRGB = rgb.g/255;
        BsRGB = rgb.b/255;

        if (RsRGB <= 0.03928) {R = RsRGB / 12.92;} else {R = Math.pow(((RsRGB + 0.055) / 1.055), 2.4);}
        if (GsRGB <= 0.03928) {G = GsRGB / 12.92;} else {G = Math.pow(((GsRGB + 0.055) / 1.055), 2.4);}
        if (BsRGB <= 0.03928) {B = BsRGB / 12.92;} else {B = Math.pow(((BsRGB + 0.055) / 1.055), 2.4);}
        return (0.2126 * R) + (0.7152 * G) + (0.0722 * B);
    },
    setAlpha: function(value) {
        this._a = boundAlpha(value);
        this._roundA = mathRound(100*this._a) / 100;
        return this;
    },
    toHsv: function() {
        var hsv = rgbToHsv(this._r, this._g, this._b);
        return { h: hsv.h * 360, s: hsv.s, v: hsv.v, a: this._a };
    },
    toHsvString: function() {
        var hsv = rgbToHsv(this._r, this._g, this._b);
        var h = mathRound(hsv.h * 360), s = mathRound(hsv.s * 100), v = mathRound(hsv.v * 100);
        return (this._a == 1) ?
          "hsv("  + h + ", " + s + "%, " + v + "%)" :
          "hsva(" + h + ", " + s + "%, " + v + "%, "+ this._roundA + ")";
    },
    toHsl: function() {
        var hsl = rgbToHsl(this._r, this._g, this._b);
        return { h: hsl.h * 360, s: hsl.s, l: hsl.l, a: this._a };
    },
    toHslString: function() {
        var hsl = rgbToHsl(this._r, this._g, this._b);
        var h = mathRound(hsl.h * 360), s = mathRound(hsl.s * 100), l = mathRound(hsl.l * 100);
        return (this._a == 1) ?
          "hsl("  + h + ", " + s + "%, " + l + "%)" :
          "hsla(" + h + ", " + s + "%, " + l + "%, "+ this._roundA + ")";
    },
    toHex: function(allow3Char) {
        return rgbToHex(this._r, this._g, this._b, allow3Char);
    },
    toHexString: function(allow3Char) {
        return '#' + this.toHex(allow3Char);
    },
    toHex8: function(allow4Char) {
        return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
    },
    toHex8String: function(allow4Char) {
        return '#' + this.toHex8(allow4Char);
    },
    toRgb: function() {
        return { r: mathRound(this._r), g: mathRound(this._g), b: mathRound(this._b), a: this._a };
    },
    toRgbString: function() {
        return (this._a == 1) ?
          "rgb("  + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ")" :
          "rgba(" + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ", " + this._roundA + ")";
    },
    toPercentageRgb: function() {
        return { r: mathRound(bound01(this._r, 255) * 100) + "%", g: mathRound(bound01(this._g, 255) * 100) + "%", b: mathRound(bound01(this._b, 255) * 100) + "%", a: this._a };
    },
    toPercentageRgbString: function() {
        return (this._a == 1) ?
          "rgb("  + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%)" :
          "rgba(" + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
    },
    toName: function() {
        if (this._a === 0) {
            return "transparent";
        }

        if (this._a < 1) {
            return false;
        }

        return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
    },
    toFilter: function(secondColor) {
        var hex8String = '#' + rgbaToArgbHex(this._r, this._g, this._b, this._a);
        var secondHex8String = hex8String;
        var gradientType = this._gradientType ? "GradientType = 1, " : "";

        if (secondColor) {
            var s = tinycolor(secondColor);
            secondHex8String = '#' + rgbaToArgbHex(s._r, s._g, s._b, s._a);
        }

        return "progid:DXImageTransform.Microsoft.gradient("+gradientType+"startColorstr="+hex8String+",endColorstr="+secondHex8String+")";
    },
    toString: function(format) {
        var formatSet = !!format;
        format = format || this._format;

        var formattedString = false;
        var hasAlpha = this._a < 1 && this._a >= 0;
        var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");

        if (needsAlphaFormat) {
            // Special case for "transparent", all other non-alpha formats
            // will return rgba when there is transparency.
            if (format === "name" && this._a === 0) {
                return this.toName();
            }
            return this.toRgbString();
        }
        if (format === "rgb") {
            formattedString = this.toRgbString();
        }
        if (format === "prgb") {
            formattedString = this.toPercentageRgbString();
        }
        if (format === "hex" || format === "hex6") {
            formattedString = this.toHexString();
        }
        if (format === "hex3") {
            formattedString = this.toHexString(true);
        }
        if (format === "hex4") {
            formattedString = this.toHex8String(true);
        }
        if (format === "hex8") {
            formattedString = this.toHex8String();
        }
        if (format === "name") {
            formattedString = this.toName();
        }
        if (format === "hsl") {
            formattedString = this.toHslString();
        }
        if (format === "hsv") {
            formattedString = this.toHsvString();
        }

        return formattedString || this.toHexString();
    },
    clone: function() {
        return tinycolor(this.toString());
    },

    _applyModification: function(fn, args) {
        var color = fn.apply(null, [this].concat([].slice.call(args)));
        this._r = color._r;
        this._g = color._g;
        this._b = color._b;
        this.setAlpha(color._a);
        return this;
    },
    lighten: function() {
        return this._applyModification(lighten, arguments);
    },
    brighten: function() {
        return this._applyModification(brighten, arguments);
    },
    darken: function() {
        return this._applyModification(darken, arguments);
    },
    desaturate: function() {
        return this._applyModification(desaturate, arguments);
    },
    saturate: function() {
        return this._applyModification(saturate, arguments);
    },
    greyscale: function() {
        return this._applyModification(greyscale, arguments);
    },
    spin: function() {
        return this._applyModification(spin, arguments);
    },

    _applyCombination: function(fn, args) {
        return fn.apply(null, [this].concat([].slice.call(args)));
    },
    analogous: function() {
        return this._applyCombination(analogous, arguments);
    },
    complement: function() {
        return this._applyCombination(complement, arguments);
    },
    monochromatic: function() {
        return this._applyCombination(monochromatic, arguments);
    },
    splitcomplement: function() {
        return this._applyCombination(splitcomplement, arguments);
    },
    triad: function() {
        return this._applyCombination(triad, arguments);
    },
    tetrad: function() {
        return this._applyCombination(tetrad, arguments);
    }
};

// If input is an object, force 1 into "1.0" to handle ratios properly
// String input requires "1.0" as input, so 1 will be treated as 1
tinycolor.fromRatio = function(color, opts) {
    if (typeof color == "object") {
        var newColor = {};
        for (var i in color) {
            if (color.hasOwnProperty(i)) {
                if (i === "a") {
                    newColor[i] = color[i];
                }
                else {
                    newColor[i] = convertToPercentage(color[i]);
                }
            }
        }
        color = newColor;
    }

    return tinycolor(color, opts);
};

// Given a string or object, convert that input to RGB
// Possible string inputs:
//
//     "red"
//     "#f00" or "f00"
//     "#ff0000" or "ff0000"
//     "#ff000000" or "ff000000"
//     "rgb 255 0 0" or "rgb (255, 0, 0)"
//     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
//     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
//     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
//     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
//     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
//     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
//
function inputToRGB(color) {

    var rgb = { r: 0, g: 0, b: 0 };
    var a = 1;
    var s = null;
    var v = null;
    var l = null;
    var ok = false;
    var format = false;

    if (typeof color == "string") {
        color = stringInputToObject(color);
    }

    if (typeof color == "object") {
        if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
            rgb = rgbToRgb(color.r, color.g, color.b);
            ok = true;
            format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
        }
        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
            s = convertToPercentage(color.s);
            v = convertToPercentage(color.v);
            rgb = hsvToRgb(color.h, s, v);
            ok = true;
            format = "hsv";
        }
        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
            s = convertToPercentage(color.s);
            l = convertToPercentage(color.l);
            rgb = hslToRgb(color.h, s, l);
            ok = true;
            format = "hsl";
        }

        if (color.hasOwnProperty("a")) {
            a = color.a;
        }
    }

    a = boundAlpha(a);

    return {
        ok: ok,
        format: color.format || format,
        r: mathMin(255, mathMax(rgb.r, 0)),
        g: mathMin(255, mathMax(rgb.g, 0)),
        b: mathMin(255, mathMax(rgb.b, 0)),
        a: a
    };
}


// Conversion Functions
// --------------------

// `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
// <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>

// `rgbToRgb`
// Handle bounds / percentage checking to conform to CSS color spec
// <http://www.w3.org/TR/css3-color/>
// *Assumes:* r, g, b in [0, 255] or [0, 1]
// *Returns:* { r, g, b } in [0, 255]
function rgbToRgb(r, g, b){
    return {
        r: bound01(r, 255) * 255,
        g: bound01(g, 255) * 255,
        b: bound01(b, 255) * 255
    };
}

// `rgbToHsl`
// Converts an RGB color value to HSL.
// *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
// *Returns:* { h, s, l } in [0,1]
function rgbToHsl(r, g, b) {

    r = bound01(r, 255);
    g = bound01(g, 255);
    b = bound01(b, 255);

    var max = mathMax(r, g, b), min = mathMin(r, g, b);
    var h, s, l = (max + min) / 2;

    if(max == min) {
        h = s = 0; // achromatic
    }
    else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
        }

        h /= 6;
    }

    return { h: h, s: s, l: l };
}

// `hslToRgb`
// Converts an HSL color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
function hslToRgb(h, s, l) {
    var r, g, b;

    h = bound01(h, 360);
    s = bound01(s, 100);
    l = bound01(l, 100);

    function hue2rgb(p, q, t) {
        if(t < 0) t += 1;
        if(t > 1) t -= 1;
        if(t < 1/6) return p + (q - p) * 6 * t;
        if(t < 1/2) return q;
        if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;
        return p;
    }

    if(s === 0) {
        r = g = b = l; // achromatic
    }
    else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1/3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1/3);
    }

    return { r: r * 255, g: g * 255, b: b * 255 };
}

// `rgbToHsv`
// Converts an RGB color value to HSV
// *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
// *Returns:* { h, s, v } in [0,1]
function rgbToHsv(r, g, b) {

    r = bound01(r, 255);
    g = bound01(g, 255);
    b = bound01(b, 255);

    var max = mathMax(r, g, b), min = mathMin(r, g, b);
    var h, s, v = max;

    var d = max - min;
    s = max === 0 ? 0 : d / max;

    if(max == min) {
        h = 0; // achromatic
    }
    else {
        switch(max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
        }
        h /= 6;
    }
    return { h: h, s: s, v: v };
}

// `hsvToRgb`
// Converts an HSV color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
 function hsvToRgb(h, s, v) {

    h = bound01(h, 360) * 6;
    s = bound01(s, 100);
    v = bound01(v, 100);

    var i = Math.floor(h),
        f = h - i,
        p = v * (1 - s),
        q = v * (1 - f * s),
        t = v * (1 - (1 - f) * s),
        mod = i % 6,
        r = [v, q, p, p, t, v][mod],
        g = [t, v, v, q, p, p][mod],
        b = [p, p, t, v, v, q][mod];

    return { r: r * 255, g: g * 255, b: b * 255 };
}

// `rgbToHex`
// Converts an RGB color to hex
// Assumes r, g, and b are contained in the set [0, 255]
// Returns a 3 or 6 character hex
function rgbToHex(r, g, b, allow3Char) {

    var hex = [
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16))
    ];

    // Return a 3 character hex if possible
    if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
    }

    return hex.join("");
}

// `rgbaToHex`
// Converts an RGBA color plus alpha transparency to hex
// Assumes r, g, b are contained in the set [0, 255] and
// a in [0, 1]. Returns a 4 or 8 character rgba hex
function rgbaToHex(r, g, b, a, allow4Char) {

    var hex = [
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16)),
        pad2(convertDecimalToHex(a))
    ];

    // Return a 4 character hex if possible
    if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) {
        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
    }

    return hex.join("");
}

// `rgbaToArgbHex`
// Converts an RGBA color to an ARGB Hex8 string
// Rarely used, but required for "toFilter()"
function rgbaToArgbHex(r, g, b, a) {

    var hex = [
        pad2(convertDecimalToHex(a)),
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16))
    ];

    return hex.join("");
}

// `equals`
// Can be called with any tinycolor input
tinycolor.equals = function (color1, color2) {
    if (!color1 || !color2) { return false; }
    return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
};

tinycolor.random = function() {
    return tinycolor.fromRatio({
        r: mathRandom(),
        g: mathRandom(),
        b: mathRandom()
    });
};


// Modification Functions
// ----------------------
// Thanks to less.js for some of the basics here
// <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>

function desaturate(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.s -= amount / 100;
    hsl.s = clamp01(hsl.s);
    return tinycolor(hsl);
}

function saturate(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.s += amount / 100;
    hsl.s = clamp01(hsl.s);
    return tinycolor(hsl);
}

function greyscale(color) {
    return tinycolor(color).desaturate(100);
}

function lighten (color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.l += amount / 100;
    hsl.l = clamp01(hsl.l);
    return tinycolor(hsl);
}

function brighten(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var rgb = tinycolor(color).toRgb();
    rgb.r = mathMax(0, mathMin(255, rgb.r - mathRound(255 * - (amount / 100))));
    rgb.g = mathMax(0, mathMin(255, rgb.g - mathRound(255 * - (amount / 100))));
    rgb.b = mathMax(0, mathMin(255, rgb.b - mathRound(255 * - (amount / 100))));
    return tinycolor(rgb);
}

function darken (color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.l -= amount / 100;
    hsl.l = clamp01(hsl.l);
    return tinycolor(hsl);
}

// Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
// Values outside of this range will be wrapped into this range.
function spin(color, amount) {
    var hsl = tinycolor(color).toHsl();
    var hue = (hsl.h + amount) % 360;
    hsl.h = hue < 0 ? 360 + hue : hue;
    return tinycolor(hsl);
}

// Combination Functions
// ---------------------
// Thanks to jQuery xColor for some of the ideas behind these
// <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>

function complement(color) {
    var hsl = tinycolor(color).toHsl();
    hsl.h = (hsl.h + 180) % 360;
    return tinycolor(hsl);
}

function triad(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 120) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 240) % 360, s: hsl.s, l: hsl.l })
    ];
}

function tetrad(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 90) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 180) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 270) % 360, s: hsl.s, l: hsl.l })
    ];
}

function splitcomplement(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 72) % 360, s: hsl.s, l: hsl.l}),
        tinycolor({ h: (h + 216) % 360, s: hsl.s, l: hsl.l})
    ];
}

function analogous(color, results, slices) {
    results = results || 6;
    slices = slices || 30;

    var hsl = tinycolor(color).toHsl();
    var part = 360 / slices;
    var ret = [tinycolor(color)];

    for (hsl.h = ((hsl.h - (part * results >> 1)) + 720) % 360; --results; ) {
        hsl.h = (hsl.h + part) % 360;
        ret.push(tinycolor(hsl));
    }
    return ret;
}

function monochromatic(color, results) {
    results = results || 6;
    var hsv = tinycolor(color).toHsv();
    var h = hsv.h, s = hsv.s, v = hsv.v;
    var ret = [];
    var modification = 1 / results;

    while (results--) {
        ret.push(tinycolor({ h: h, s: s, v: v}));
        v = (v + modification) % 1;
    }

    return ret;
}

// Utility Functions
// ---------------------

tinycolor.mix = function(color1, color2, amount) {
    amount = (amount === 0) ? 0 : (amount || 50);

    var rgb1 = tinycolor(color1).toRgb();
    var rgb2 = tinycolor(color2).toRgb();

    var p = amount / 100;

    var rgba = {
        r: ((rgb2.r - rgb1.r) * p) + rgb1.r,
        g: ((rgb2.g - rgb1.g) * p) + rgb1.g,
        b: ((rgb2.b - rgb1.b) * p) + rgb1.b,
        a: ((rgb2.a - rgb1.a) * p) + rgb1.a
    };

    return tinycolor(rgba);
};


// Readability Functions
// ---------------------
// <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)

// `contrast`
// Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
tinycolor.readability = function(color1, color2) {
    var c1 = tinycolor(color1);
    var c2 = tinycolor(color2);
    return (Math.max(c1.getLuminance(),c2.getLuminance())+0.05) / (Math.min(c1.getLuminance(),c2.getLuminance())+0.05);
};

// `isReadable`
// Ensure that foreground and background color combinations meet WCAG2 guidelines.
// The third argument is an optional Object.
//      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
//      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
// If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.

// *Example*
//    tinycolor.isReadable("#000", "#111") => false
//    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
tinycolor.isReadable = function(color1, color2, wcag2) {
    var readability = tinycolor.readability(color1, color2);
    var wcag2Parms, out;

    out = false;

    wcag2Parms = validateWCAG2Parms(wcag2);
    switch (wcag2Parms.level + wcag2Parms.size) {
        case "AAsmall":
        case "AAAlarge":
            out = readability >= 4.5;
            break;
        case "AAlarge":
            out = readability >= 3;
            break;
        case "AAAsmall":
            out = readability >= 7;
            break;
    }
    return out;

};

// `mostReadable`
// Given a base color and a list of possible foreground or background
// colors for that base, returns the most readable color.
// Optionally returns Black or White if the most readable color is unreadable.
// *Example*
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
tinycolor.mostReadable = function(baseColor, colorList, args) {
    var bestColor = null;
    var bestScore = 0;
    var readability;
    var includeFallbackColors, level, size ;
    args = args || {};
    includeFallbackColors = args.includeFallbackColors ;
    level = args.level;
    size = args.size;

    for (var i= 0; i < colorList.length ; i++) {
        readability = tinycolor.readability(baseColor, colorList[i]);
        if (readability > bestScore) {
            bestScore = readability;
            bestColor = tinycolor(colorList[i]);
        }
    }

    if (tinycolor.isReadable(baseColor, bestColor, {"level":level,"size":size}) || !includeFallbackColors) {
        return bestColor;
    }
    else {
        args.includeFallbackColors=false;
        return tinycolor.mostReadable(baseColor,["#fff", "#000"],args);
    }
};


// Big List of Colors
// ------------------
// <http://www.w3.org/TR/css3-color/#svg-color>
var names = tinycolor.names = {
    aliceblue: "f0f8ff",
    antiquewhite: "faebd7",
    aqua: "0ff",
    aquamarine: "7fffd4",
    azure: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "000",
    blanchedalmond: "ffebcd",
    blue: "00f",
    blueviolet: "8a2be2",
    brown: "a52a2a",
    burlywood: "deb887",
    burntsienna: "ea7e5d",
    cadetblue: "5f9ea0",
    chartreuse: "7fff00",
    chocolate: "d2691e",
    coral: "ff7f50",
    cornflowerblue: "6495ed",
    cornsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "0ff",
    darkblue: "00008b",
    darkcyan: "008b8b",
    darkgoldenrod: "b8860b",
    darkgray: "a9a9a9",
    darkgreen: "006400",
    darkgrey: "a9a9a9",
    darkkhaki: "bdb76b",
    darkmagenta: "8b008b",
    darkolivegreen: "556b2f",
    darkorange: "ff8c00",
    darkorchid: "9932cc",
    darkred: "8b0000",
    darksalmon: "e9967a",
    darkseagreen: "8fbc8f",
    darkslateblue: "483d8b",
    darkslategray: "2f4f4f",
    darkslategrey: "2f4f4f",
    darkturquoise: "00ced1",
    darkviolet: "9400d3",
    deeppink: "ff1493",
    deepskyblue: "00bfff",
    dimgray: "696969",
    dimgrey: "696969",
    dodgerblue: "1e90ff",
    firebrick: "b22222",
    floralwhite: "fffaf0",
    forestgreen: "228b22",
    fuchsia: "f0f",
    gainsboro: "dcdcdc",
    ghostwhite: "f8f8ff",
    gold: "ffd700",
    goldenrod: "daa520",
    gray: "808080",
    green: "008000",
    greenyellow: "adff2f",
    grey: "808080",
    honeydew: "f0fff0",
    hotpink: "ff69b4",
    indianred: "cd5c5c",
    indigo: "4b0082",
    ivory: "fffff0",
    khaki: "f0e68c",
    lavender: "e6e6fa",
    lavenderblush: "fff0f5",
    lawngreen: "7cfc00",
    lemonchiffon: "fffacd",
    lightblue: "add8e6",
    lightcoral: "f08080",
    lightcyan: "e0ffff",
    lightgoldenrodyellow: "fafad2",
    lightgray: "d3d3d3",
    lightgreen: "90ee90",
    lightgrey: "d3d3d3",
    lightpink: "ffb6c1",
    lightsalmon: "ffa07a",
    lightseagreen: "20b2aa",
    lightskyblue: "87cefa",
    lightslategray: "789",
    lightslategrey: "789",
    lightsteelblue: "b0c4de",
    lightyellow: "ffffe0",
    lime: "0f0",
    limegreen: "32cd32",
    linen: "faf0e6",
    magenta: "f0f",
    maroon: "800000",
    mediumaquamarine: "66cdaa",
    mediumblue: "0000cd",
    mediumorchid: "ba55d3",
    mediumpurple: "9370db",
    mediumseagreen: "3cb371",
    mediumslateblue: "7b68ee",
    mediumspringgreen: "00fa9a",
    mediumturquoise: "48d1cc",
    mediumvioletred: "c71585",
    midnightblue: "191970",
    mintcream: "f5fffa",
    mistyrose: "ffe4e1",
    moccasin: "ffe4b5",
    navajowhite: "ffdead",
    navy: "000080",
    oldlace: "fdf5e6",
    olive: "808000",
    olivedrab: "6b8e23",
    orange: "ffa500",
    orangered: "ff4500",
    orchid: "da70d6",
    palegoldenrod: "eee8aa",
    palegreen: "98fb98",
    paleturquoise: "afeeee",
    palevioletred: "db7093",
    papayawhip: "ffefd5",
    peachpuff: "ffdab9",
    peru: "cd853f",
    pink: "ffc0cb",
    plum: "dda0dd",
    powderblue: "b0e0e6",
    purple: "800080",
    rebeccapurple: "663399",
    red: "f00",
    rosybrown: "bc8f8f",
    royalblue: "4169e1",
    saddlebrown: "8b4513",
    salmon: "fa8072",
    sandybrown: "f4a460",
    seagreen: "2e8b57",
    seashell: "fff5ee",
    sienna: "a0522d",
    silver: "c0c0c0",
    skyblue: "87ceeb",
    slateblue: "6a5acd",
    slategray: "708090",
    slategrey: "708090",
    snow: "fffafa",
    springgreen: "00ff7f",
    steelblue: "4682b4",
    tan: "d2b48c",
    teal: "008080",
    thistle: "d8bfd8",
    tomato: "ff6347",
    turquoise: "40e0d0",
    violet: "ee82ee",
    wheat: "f5deb3",
    white: "fff",
    whitesmoke: "f5f5f5",
    yellow: "ff0",
    yellowgreen: "9acd32"
};

// Make it easy to access colors via `hexNames[hex]`
var hexNames = tinycolor.hexNames = flip(names);


// Utilities
// ---------

// `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
function flip(o) {
    var flipped = { };
    for (var i in o) {
        if (o.hasOwnProperty(i)) {
            flipped[o[i]] = i;
        }
    }
    return flipped;
}

// Return a valid alpha value [0,1] with all invalid values being set to 1
function boundAlpha(a) {
    a = parseFloat(a);

    if (isNaN(a) || a < 0 || a > 1) {
        a = 1;
    }

    return a;
}

// Take input from [0, n] and return it as [0, 1]
function bound01(n, max) {
    if (isOnePointZero(n)) { n = "100%"; }

    var processPercent = isPercentage(n);
    n = mathMin(max, mathMax(0, parseFloat(n)));

    // Automatically convert percentage into number
    if (processPercent) {
        n = parseInt(n * max, 10) / 100;
    }

    // Handle floating point rounding errors
    if ((Math.abs(n - max) < 0.000001)) {
        return 1;
    }

    // Convert into [0, 1] range if it isn't already
    return (n % max) / parseFloat(max);
}

// Force a number between 0 and 1
function clamp01(val) {
    return mathMin(1, mathMax(0, val));
}

// Parse a base-16 hex value into a base-10 integer
function parseIntFromHex(val) {
    return parseInt(val, 16);
}

// Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
// <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
function isOnePointZero(n) {
    return typeof n == "string" && n.indexOf('.') != -1 && parseFloat(n) === 1;
}

// Check to see if string passed in is a percentage
function isPercentage(n) {
    return typeof n === "string" && n.indexOf('%') != -1;
}

// Force a hex value to have 2 characters
function pad2(c) {
    return c.length == 1 ? '0' + c : '' + c;
}

// Replace a decimal with it's percentage value
function convertToPercentage(n) {
    if (n <= 1) {
        n = (n * 100) + "%";
    }

    return n;
}

// Converts a decimal to a hex value
function convertDecimalToHex(d) {
    return Math.round(parseFloat(d) * 255).toString(16);
}
// Converts a hex value to a decimal
function convertHexToDecimal(h) {
    return (parseIntFromHex(h) / 255);
}

var matchers = (function() {

    // <http://www.w3.org/TR/css3-values/#integers>
    var CSS_INTEGER = "[-\\+]?\\d+%?";

    // <http://www.w3.org/TR/css3-values/#number-value>
    var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";

    // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
    var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";

    // Actual matching.
    // Parentheses and commas are optional, but not required.
    // Whitespace can take the place of commas or opening paren
    var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
    var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";

    return {
        CSS_UNIT: new RegExp(CSS_UNIT),
        rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
        rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
        hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
        hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
        hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
        hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
        hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
        hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
    };
})();

// `isValidCSSUnit`
// Take in a single string / number and check to see if it looks like a CSS unit
// (see `matchers` above for definition).
function isValidCSSUnit(color) {
    return !!matchers.CSS_UNIT.exec(color);
}

// `stringInputToObject`
// Permissive string parsing.  Take in a number of formats, and output an object
// based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
function stringInputToObject(color) {

    color = color.replace(trimLeft,'').replace(trimRight, '').toLowerCase();
    var named = false;
    if (names[color]) {
        color = names[color];
        named = true;
    }
    else if (color == 'transparent') {
        return { r: 0, g: 0, b: 0, a: 0, format: "name" };
    }

    // Try to match string input using regular expressions.
    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
    // Just return an object and let the conversion functions handle that.
    // This way the result will be the same whether the tinycolor is initialized with string or object.
    var match;
    if ((match = matchers.rgb.exec(color))) {
        return { r: match[1], g: match[2], b: match[3] };
    }
    if ((match = matchers.rgba.exec(color))) {
        return { r: match[1], g: match[2], b: match[3], a: match[4] };
    }
    if ((match = matchers.hsl.exec(color))) {
        return { h: match[1], s: match[2], l: match[3] };
    }
    if ((match = matchers.hsla.exec(color))) {
        return { h: match[1], s: match[2], l: match[3], a: match[4] };
    }
    if ((match = matchers.hsv.exec(color))) {
        return { h: match[1], s: match[2], v: match[3] };
    }
    if ((match = matchers.hsva.exec(color))) {
        return { h: match[1], s: match[2], v: match[3], a: match[4] };
    }
    if ((match = matchers.hex8.exec(color))) {
        return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            a: convertHexToDecimal(match[4]),
            format: named ? "name" : "hex8"
        };
    }
    if ((match = matchers.hex6.exec(color))) {
        return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            format: named ? "name" : "hex"
        };
    }
    if ((match = matchers.hex4.exec(color))) {
        return {
            r: parseIntFromHex(match[1] + '' + match[1]),
            g: parseIntFromHex(match[2] + '' + match[2]),
            b: parseIntFromHex(match[3] + '' + match[3]),
            a: convertHexToDecimal(match[4] + '' + match[4]),
            format: named ? "name" : "hex8"
        };
    }
    if ((match = matchers.hex3.exec(color))) {
        return {
            r: parseIntFromHex(match[1] + '' + match[1]),
            g: parseIntFromHex(match[2] + '' + match[2]),
            b: parseIntFromHex(match[3] + '' + match[3]),
            format: named ? "name" : "hex"
        };
    }

    return false;
}

function validateWCAG2Parms(parms) {
    // return valid WCAG2 parms for isReadable.
    // If input parms are invalid, return {"level":"AA", "size":"small"}
    var level, size;
    parms = parms || {"level":"AA", "size":"small"};
    level = (parms.level || "AA").toUpperCase();
    size = (parms.size || "small").toLowerCase();
    if (level !== "AA" && level !== "AAA") {
        level = "AA";
    }
    if (size !== "small" && size !== "large") {
        size = "small";
    }
    return {"level":level, "size":size};
}

// Node: Export function
if ( true && module.exports) {
    module.exports = tinycolor;
}
// AMD/requirejs: Define the module
else if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {return tinycolor;}).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}
// Browser: Expose to window
else {}

})(Math);


/***/ }),

/***/ 51498:
/***/ (function(module) {

"use strict";
/* @module to-float32 */



module.exports = float32
module.exports.float32 =
module.exports.float = float32
module.exports.fract32 =
module.exports.fract = fract32

var narr = new Float32Array(1)

// Returns fractional part of float32 array
function fract32 (arr, fract) {
	if (arr.length) {
		if (arr instanceof Float32Array) return new Float32Array(arr.length);
		if (!(fract instanceof Float32Array)) fract = float32(arr)
		for (var i = 0, l = fract.length; i < l; i++) {
			fract[i] = arr[i] - fract[i]
		}
		return fract
	}

	// number
	return float32(arr - float32(arr))
}

// Make sure data is float32 array
function float32 (arr) {
	if (arr.length) {
		if (arr instanceof Float32Array) return arr
		return new Float32Array(arr);
	}

	// number
	narr[0] = arr
	return narr[0]
}


/***/ }),

/***/ 44626:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var parseUnit = __webpack_require__(4957)

module.exports = toPX

var PIXELS_PER_INCH = 96

function getPropertyInPX(element, prop) {
  var parts = parseUnit(getComputedStyle(element).getPropertyValue(prop))
  return parts[0] * toPX(parts[1], element)
}

//This brutal hack is needed
function getSizeBrutal(unit, element) {
  var testDIV = document.createElement('div')
  testDIV.style['font-size'] = '128' + unit
  element.appendChild(testDIV)
  var size = getPropertyInPX(testDIV, 'font-size') / 128
  element.removeChild(testDIV)
  return size
}

function toPX(str, element) {
  element = element || document.body
  str = (str || 'px').trim().toLowerCase()
  if(element === window || element === document) {
    element = document.body 
  }
  switch(str) {
    case '%':  //Ambiguous, not sure if we should use width or height
      return element.clientHeight / 100.0
    case 'ch':
    case 'ex':
      return getSizeBrutal(str, element)
    case 'em':
      return getPropertyInPX(element, 'font-size')
    case 'rem':
      return getPropertyInPX(document.body, 'font-size')
    case 'vw':
      return window.innerWidth/100
    case 'vh':
      return window.innerHeight/100
    case 'vmin':
      return Math.min(window.innerWidth, window.innerHeight) / 100
    case 'vmax':
      return Math.max(window.innerWidth, window.innerHeight) / 100
    case 'in':
      return PIXELS_PER_INCH
    case 'cm':
      return PIXELS_PER_INCH / 2.54
    case 'mm':
      return PIXELS_PER_INCH / 25.4
    case 'pt':
      return PIXELS_PER_INCH / 72
    case 'pc':
      return PIXELS_PER_INCH / 6
  }
  return 1
}

/***/ }),

/***/ 48640:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  N4: function() { return /* reexport */ feature; }
});

// UNUSED EXPORTS: bbox, merge, mergeArcs, mesh, meshArcs, neighbors, quantize, transform, untransform

;// CONCATENATED MODULE: ./node_modules/topojson-client/src/reverse.js
/* harmony default export */ function reverse(array, n) {
  var t, j = array.length, i = j - n;
  while (i < --j) t = array[i], array[i++] = array[j], array[j] = t;
}

;// CONCATENATED MODULE: ./node_modules/topojson-client/src/identity.js
/* harmony default export */ function identity(x) {
  return x;
}

;// CONCATENATED MODULE: ./node_modules/topojson-client/src/transform.js


/* harmony default export */ function transform(transform) {
  if (transform == null) return identity;
  var x0,
      y0,
      kx = transform.scale[0],
      ky = transform.scale[1],
      dx = transform.translate[0],
      dy = transform.translate[1];
  return function(input, i) {
    if (!i) x0 = y0 = 0;
    var j = 2, n = input.length, output = new Array(n);
    output[0] = (x0 += input[0]) * kx + dx;
    output[1] = (y0 += input[1]) * ky + dy;
    while (j < n) output[j] = input[j], ++j;
    return output;
  };
}

;// CONCATENATED MODULE: ./node_modules/topojson-client/src/feature.js



/* harmony default export */ function feature(topology, o) {
  if (typeof o === "string") o = topology.objects[o];
  return o.type === "GeometryCollection"
      ? {type: "FeatureCollection", features: o.geometries.map(function(o) { return feature_feature(topology, o); })}
      : feature_feature(topology, o);
}

function feature_feature(topology, o) {
  var id = o.id,
      bbox = o.bbox,
      properties = o.properties == null ? {} : o.properties,
      geometry = object(topology, o);
  return id == null && bbox == null ? {type: "Feature", properties: properties, geometry: geometry}
      : bbox == null ? {type: "Feature", id: id, properties: properties, geometry: geometry}
      : {type: "Feature", id: id, bbox: bbox, properties: properties, geometry: geometry};
}

function object(topology, o) {
  var transformPoint = transform(topology.transform),
      arcs = topology.arcs;

  function arc(i, points) {
    if (points.length) points.pop();
    for (var a = arcs[i < 0 ? ~i : i], k = 0, n = a.length; k < n; ++k) {
      points.push(transformPoint(a[k], k));
    }
    if (i < 0) reverse(points, n);
  }

  function point(p) {
    return transformPoint(p);
  }

  function line(arcs) {
    var points = [];
    for (var i = 0, n = arcs.length; i < n; ++i) arc(arcs[i], points);
    if (points.length < 2) points.push(points[0]); // This should never happen per the specification.
    return points;
  }

  function ring(arcs) {
    var points = line(arcs);
    while (points.length < 4) points.push(points[0]); // This may happen if an arc has only two points.
    return points;
  }

  function polygon(arcs) {
    return arcs.map(ring);
  }

  function geometry(o) {
    var type = o.type, coordinates;
    switch (type) {
      case "GeometryCollection": return {type: type, geometries: o.geometries.map(geometry)};
      case "Point": coordinates = point(o.coordinates); break;
      case "MultiPoint": coordinates = o.coordinates.map(point); break;
      case "LineString": coordinates = line(o.arcs); break;
      case "MultiLineString": coordinates = o.arcs.map(line); break;
      case "Polygon": coordinates = polygon(o.arcs); break;
      case "MultiPolygon": coordinates = o.arcs.map(polygon); break;
      default: return null;
    }
    return {type: type, coordinates: coordinates};
  }

  return geometry(o);
}

;// CONCATENATED MODULE: ./node_modules/topojson-client/src/index.js










/***/ }),

/***/ 64276:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isPrototype = __webpack_require__(31350);

module.exports = function (value) {
	if (typeof value !== "function") return false;

	if (!hasOwnProperty.call(value, "length")) return false;

	try {
		if (typeof value.length !== "number") return false;
		if (typeof value.call !== "function") return false;
		if (typeof value.apply !== "function") return false;
	} catch (error) {
		return false;
	}

	return !isPrototype(value);
};


/***/ }),

/***/ 99497:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isValue       = __webpack_require__(80299)
  , isObject      = __webpack_require__(76481)
  , stringCoerce  = __webpack_require__(58698)
  , toShortString = __webpack_require__(60461);

var resolveMessage = function (message, value) {
	return message.replace("%v", toShortString(value));
};

module.exports = function (value, defaultMessage, inputOptions) {
	if (!isObject(inputOptions)) throw new TypeError(resolveMessage(defaultMessage, value));
	if (!isValue(value)) {
		if ("default" in inputOptions) return inputOptions["default"];
		if (inputOptions.isOptional) return null;
	}
	var errorMessage = stringCoerce(inputOptions.errorMessage);
	if (!isValue(errorMessage)) errorMessage = defaultMessage;
	throw new TypeError(resolveMessage(errorMessage, value));
};


/***/ }),

/***/ 78696:
/***/ (function(module) {

"use strict";


module.exports = function (value) {
	try {
		return value.toString();
	} catch (error) {
		try { return String(value); }
		catch (error2) { return null; }
	}
};


/***/ }),

/***/ 60461:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var safeToString = __webpack_require__(78696);

var reNewLine = /[\n\r\u2028\u2029]/g;

module.exports = function (value) {
	var string = safeToString(value);
	if (string === null) return "<Non-coercible to string value>";
	// Trim if too long
	if (string.length > 100) string = string.slice(0, 99) + "…";
	// Replace eventual new lines
	string = string.replace(reNewLine, function (char) {
		switch (char) {
			case "\n":
				return "\\n";
			case "\r":
				return "\\r";
			case "\u2028":
				return "\\u2028";
			case "\u2029":
				return "\\u2029";
			/* istanbul ignore next */
			default:
				throw new Error("Unexpected character");
		}
	});
	return string;
};


/***/ }),

/***/ 76481:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isValue = __webpack_require__(80299);

// prettier-ignore
var possibleTypes = { "object": true, "function": true, "undefined": true /* document.all */ };

module.exports = function (value) {
	if (!isValue(value)) return false;
	return hasOwnProperty.call(possibleTypes, typeof value);
};


/***/ }),

/***/ 6887:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var resolveException = __webpack_require__(99497)
  , is               = __webpack_require__(63461);

module.exports = function (value/*, options*/) {
	if (is(value)) return value;
	return resolveException(value, "%v is not a plain function", arguments[1]);
};


/***/ }),

/***/ 63461:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isFunction = __webpack_require__(64276);

var classRe = /^\s*class[\s{/}]/, functionToString = Function.prototype.toString;

module.exports = function (value) {
	if (!isFunction(value)) return false;
	if (classRe.test(functionToString.call(value))) return false;
	return true;
};


/***/ }),

/***/ 31350:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isObject = __webpack_require__(76481);

module.exports = function (value) {
	if (!isObject(value)) return false;
	try {
		if (!value.constructor) return false;
		return value.constructor.prototype === value;
	} catch (error) {
		return false;
	}
};


/***/ }),

/***/ 58698:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isValue  = __webpack_require__(80299)
  , isObject = __webpack_require__(76481);

var objectToString = Object.prototype.toString;

module.exports = function (value) {
	if (!isValue(value)) return null;
	if (isObject(value)) {
		// Reject Object.prototype.toString coercion
		var valueToString = value.toString;
		if (typeof valueToString !== "function") return null;
		if (valueToString === objectToString) return null;
		// Note: It can be object coming from other realm, still as there's no ES3 and CSP compliant
		// way to resolve its realm's Object.prototype.toString it's left as not addressed edge case
	}
	try {
		return "" + value; // Ensure implicit coercion
	} catch (error) {
		return null;
	}
};


/***/ }),

/***/ 9557:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var resolveException = __webpack_require__(99497)
  , is               = __webpack_require__(80299);

module.exports = function (value/*, options*/) {
	if (is(value)) return value;
	return resolveException(value, "Cannot use %v", arguments[1]);
};


/***/ }),

/***/ 80299:
/***/ (function(module) {

"use strict";


// ES3 safe
var _undefined = void 0;

module.exports = function (value) { return value !== _undefined && value !== null; };


/***/ }),

/***/ 66127:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var bits = __webpack_require__(54689)
var dup = __webpack_require__(49523)
var Buffer = (__webpack_require__(45708).Buffer)

//Legacy pool support
if(!__webpack_require__.g.__TYPEDARRAY_POOL) {
  __webpack_require__.g.__TYPEDARRAY_POOL = {
      UINT8     : dup([32, 0])
    , UINT16    : dup([32, 0])
    , UINT32    : dup([32, 0])
    , BIGUINT64 : dup([32, 0])
    , INT8      : dup([32, 0])
    , INT16     : dup([32, 0])
    , INT32     : dup([32, 0])
    , BIGINT64  : dup([32, 0])
    , FLOAT     : dup([32, 0])
    , DOUBLE    : dup([32, 0])
    , DATA      : dup([32, 0])
    , UINT8C    : dup([32, 0])
    , BUFFER    : dup([32, 0])
  }
}

var hasUint8C = (typeof Uint8ClampedArray) !== 'undefined'
var hasBigUint64 = (typeof BigUint64Array) !== 'undefined'
var hasBigInt64 = (typeof BigInt64Array) !== 'undefined'
var POOL = __webpack_require__.g.__TYPEDARRAY_POOL

//Upgrade pool
if(!POOL.UINT8C) {
  POOL.UINT8C = dup([32, 0])
}
if(!POOL.BIGUINT64) {
  POOL.BIGUINT64 = dup([32, 0])
}
if(!POOL.BIGINT64) {
  POOL.BIGINT64 = dup([32, 0])
}
if(!POOL.BUFFER) {
  POOL.BUFFER = dup([32, 0])
}

//New technique: Only allocate from ArrayBufferView and Buffer
var DATA    = POOL.DATA
  , BUFFER  = POOL.BUFFER

exports.free = function free(array) {
  if(Buffer.isBuffer(array)) {
    BUFFER[bits.log2(array.length)].push(array)
  } else {
    if(Object.prototype.toString.call(array) !== '[object ArrayBuffer]') {
      array = array.buffer
    }
    if(!array) {
      return
    }
    var n = array.length || array.byteLength
    var log_n = bits.log2(n)|0
    DATA[log_n].push(array)
  }
}

function freeArrayBuffer(buffer) {
  if(!buffer) {
    return
  }
  var n = buffer.length || buffer.byteLength
  var log_n = bits.log2(n)
  DATA[log_n].push(buffer)
}

function freeTypedArray(array) {
  freeArrayBuffer(array.buffer)
}

exports.freeUint8 =
exports.freeUint16 =
exports.freeUint32 =
exports.freeBigUint64 =
exports.freeInt8 =
exports.freeInt16 =
exports.freeInt32 =
exports.freeBigInt64 =
exports.freeFloat32 = 
exports.freeFloat =
exports.freeFloat64 = 
exports.freeDouble = 
exports.freeUint8Clamped = 
exports.freeDataView = freeTypedArray

exports.freeArrayBuffer = freeArrayBuffer

exports.freeBuffer = function freeBuffer(array) {
  BUFFER[bits.log2(array.length)].push(array)
}

exports.malloc = function malloc(n, dtype) {
  if(dtype === undefined || dtype === 'arraybuffer') {
    return mallocArrayBuffer(n)
  } else {
    switch(dtype) {
      case 'uint8':
        return mallocUint8(n)
      case 'uint16':
        return mallocUint16(n)
      case 'uint32':
        return mallocUint32(n)
      case 'int8':
        return mallocInt8(n)
      case 'int16':
        return mallocInt16(n)
      case 'int32':
        return mallocInt32(n)
      case 'float':
      case 'float32':
        return mallocFloat(n)
      case 'double':
      case 'float64':
        return mallocDouble(n)
      case 'uint8_clamped':
        return mallocUint8Clamped(n)
      case 'bigint64':
        return mallocBigInt64(n)
      case 'biguint64':
        return mallocBigUint64(n)
      case 'buffer':
        return mallocBuffer(n)
      case 'data':
      case 'dataview':
        return mallocDataView(n)

      default:
        return null
    }
  }
  return null
}

function mallocArrayBuffer(n) {
  var n = bits.nextPow2(n)
  var log_n = bits.log2(n)
  var d = DATA[log_n]
  if(d.length > 0) {
    return d.pop()
  }
  return new ArrayBuffer(n)
}
exports.mallocArrayBuffer = mallocArrayBuffer

function mallocUint8(n) {
  return new Uint8Array(mallocArrayBuffer(n), 0, n)
}
exports.mallocUint8 = mallocUint8

function mallocUint16(n) {
  return new Uint16Array(mallocArrayBuffer(2*n), 0, n)
}
exports.mallocUint16 = mallocUint16

function mallocUint32(n) {
  return new Uint32Array(mallocArrayBuffer(4*n), 0, n)
}
exports.mallocUint32 = mallocUint32

function mallocInt8(n) {
  return new Int8Array(mallocArrayBuffer(n), 0, n)
}
exports.mallocInt8 = mallocInt8

function mallocInt16(n) {
  return new Int16Array(mallocArrayBuffer(2*n), 0, n)
}
exports.mallocInt16 = mallocInt16

function mallocInt32(n) {
  return new Int32Array(mallocArrayBuffer(4*n), 0, n)
}
exports.mallocInt32 = mallocInt32

function mallocFloat(n) {
  return new Float32Array(mallocArrayBuffer(4*n), 0, n)
}
exports.mallocFloat32 = exports.mallocFloat = mallocFloat

function mallocDouble(n) {
  return new Float64Array(mallocArrayBuffer(8*n), 0, n)
}
exports.mallocFloat64 = exports.mallocDouble = mallocDouble

function mallocUint8Clamped(n) {
  if(hasUint8C) {
    return new Uint8ClampedArray(mallocArrayBuffer(n), 0, n)
  } else {
    return mallocUint8(n)
  }
}
exports.mallocUint8Clamped = mallocUint8Clamped

function mallocBigUint64(n) {
  if(hasBigUint64) {
    return new BigUint64Array(mallocArrayBuffer(8*n), 0, n)
  } else {
    return null;
  }
}
exports.mallocBigUint64 = mallocBigUint64

function mallocBigInt64(n) {
  if (hasBigInt64) {
    return new BigInt64Array(mallocArrayBuffer(8*n), 0, n)
  } else {
    return null;
  }
}
exports.mallocBigInt64 = mallocBigInt64

function mallocDataView(n) {
  return new DataView(mallocArrayBuffer(n), 0, n)
}
exports.mallocDataView = mallocDataView

function mallocBuffer(n) {
  n = bits.nextPow2(n)
  var log_n = bits.log2(n)
  var cache = BUFFER[log_n]
  if(cache.length > 0) {
    return cache.pop()
  }
  return new Buffer(n)
}
exports.mallocBuffer = mallocBuffer

exports.clearCache = function clearCache() {
  for(var i=0; i<32; ++i) {
    POOL.UINT8[i].length = 0
    POOL.UINT16[i].length = 0
    POOL.UINT32[i].length = 0
    POOL.INT8[i].length = 0
    POOL.INT16[i].length = 0
    POOL.INT32[i].length = 0
    POOL.FLOAT[i].length = 0
    POOL.DOUBLE[i].length = 0
    POOL.BIGUINT64[i].length = 0
    POOL.BIGINT64[i].length = 0
    POOL.UINT8C[i].length = 0
    DATA[i].length = 0
    BUFFER[i].length = 0
  }
}


/***/ }),

/***/ 80886:
/***/ (function(module) {

var reg = /[\'\"]/

module.exports = function unquote(str) {
  if (!str) {
    return ''
  }
  if (reg.test(str.charAt(0))) {
    str = str.substr(1)
  }
  if (reg.test(str.charAt(str.length - 1))) {
    str = str.substr(0, str.length - 1)
  }
  return str
}


/***/ }),

/***/ 79788:
/***/ (function(module) {

"use strict";
/**
 * @module update-diff
 */



module.exports = function updateDiff (obj, diff, mappers) {
	if (!Array.isArray(mappers)) mappers = [].slice.call(arguments, 2)

	for (var i = 0, l = mappers.length; i < l; i++) {
		var dict = mappers[i]
		for (var prop in dict) {
			if (diff[prop] !== undefined && !Array.isArray(diff[prop]) && obj[prop] === diff[prop]) continue

			if (prop in diff) {
				var result

				if (dict[prop] === true) result = diff[prop]
				else if (dict[prop] === false) continue
				else if (typeof dict[prop] === 'function') {
					result = dict[prop](diff[prop], obj, diff)
					if (result === undefined) continue
				}

				obj[prop] = result
			}
		}
	}

	return obj
}


/***/ }),

/***/ 71103:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


/**
 * Module exports.
 */

module.exports = deprecate;

/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

function deprecate (fn, msg) {
  if (config('noDeprecation')) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (config('throwDeprecation')) {
        throw new Error(msg);
      } else if (config('traceDeprecation')) {
        console.trace(msg);
      } else {
        console.warn(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
}

/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

function config (name) {
  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
  try {
    if (!__webpack_require__.g.localStorage) return false;
  } catch (_) {
    return false;
  }
  var val = __webpack_require__.g.localStorage[name];
  if (null == val) return false;
  return String(val).toLowerCase() === 'true';
}


/***/ }),

/***/ 44123:
/***/ (function(module) {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}

/***/ }),

/***/ 15724:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9



var isArgumentsObject = __webpack_require__(40280);
var isGeneratorFunction = __webpack_require__(80340);
var whichTypedArray = __webpack_require__(96835);
var isTypedArray = __webpack_require__(15628);

function uncurryThis(f) {
  return f.call.bind(f);
}

var BigIntSupported = typeof BigInt !== 'undefined';
var SymbolSupported = typeof Symbol !== 'undefined';

var ObjectToString = uncurryThis(Object.prototype.toString);

var numberValue = uncurryThis(Number.prototype.valueOf);
var stringValue = uncurryThis(String.prototype.valueOf);
var booleanValue = uncurryThis(Boolean.prototype.valueOf);

if (BigIntSupported) {
  var bigIntValue = uncurryThis(BigInt.prototype.valueOf);
}

if (SymbolSupported) {
  var symbolValue = uncurryThis(Symbol.prototype.valueOf);
}

function checkBoxedPrimitive(value, prototypeValueOf) {
  if (typeof value !== 'object') {
    return false;
  }
  try {
    prototypeValueOf(value);
    return true;
  } catch(e) {
    return false;
  }
}

exports.isArgumentsObject = isArgumentsObject;
exports.isGeneratorFunction = isGeneratorFunction;
exports.isTypedArray = isTypedArray;

// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function isPromise(input) {
	return (
		(
			typeof Promise !== 'undefined' &&
			input instanceof Promise
		) ||
		(
			input !== null &&
			typeof input === 'object' &&
			typeof input.then === 'function' &&
			typeof input.catch === 'function'
		)
	);
}
exports.isPromise = isPromise;

function isArrayBufferView(value) {
  if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
    return ArrayBuffer.isView(value);
  }

  return (
    isTypedArray(value) ||
    isDataView(value)
  );
}
exports.isArrayBufferView = isArrayBufferView;


function isUint8Array(value) {
  return whichTypedArray(value) === 'Uint8Array';
}
exports.isUint8Array = isUint8Array;

function isUint8ClampedArray(value) {
  return whichTypedArray(value) === 'Uint8ClampedArray';
}
exports.isUint8ClampedArray = isUint8ClampedArray;

function isUint16Array(value) {
  return whichTypedArray(value) === 'Uint16Array';
}
exports.isUint16Array = isUint16Array;

function isUint32Array(value) {
  return whichTypedArray(value) === 'Uint32Array';
}
exports.isUint32Array = isUint32Array;

function isInt8Array(value) {
  return whichTypedArray(value) === 'Int8Array';
}
exports.isInt8Array = isInt8Array;

function isInt16Array(value) {
  return whichTypedArray(value) === 'Int16Array';
}
exports.isInt16Array = isInt16Array;

function isInt32Array(value) {
  return whichTypedArray(value) === 'Int32Array';
}
exports.isInt32Array = isInt32Array;

function isFloat32Array(value) {
  return whichTypedArray(value) === 'Float32Array';
}
exports.isFloat32Array = isFloat32Array;

function isFloat64Array(value) {
  return whichTypedArray(value) === 'Float64Array';
}
exports.isFloat64Array = isFloat64Array;

function isBigInt64Array(value) {
  return whichTypedArray(value) === 'BigInt64Array';
}
exports.isBigInt64Array = isBigInt64Array;

function isBigUint64Array(value) {
  return whichTypedArray(value) === 'BigUint64Array';
}
exports.isBigUint64Array = isBigUint64Array;

function isMapToString(value) {
  return ObjectToString(value) === '[object Map]';
}
isMapToString.working = (
  typeof Map !== 'undefined' &&
  isMapToString(new Map())
);

function isMap(value) {
  if (typeof Map === 'undefined') {
    return false;
  }

  return isMapToString.working
    ? isMapToString(value)
    : value instanceof Map;
}
exports.isMap = isMap;

function isSetToString(value) {
  return ObjectToString(value) === '[object Set]';
}
isSetToString.working = (
  typeof Set !== 'undefined' &&
  isSetToString(new Set())
);
function isSet(value) {
  if (typeof Set === 'undefined') {
    return false;
  }

  return isSetToString.working
    ? isSetToString(value)
    : value instanceof Set;
}
exports.isSet = isSet;

function isWeakMapToString(value) {
  return ObjectToString(value) === '[object WeakMap]';
}
isWeakMapToString.working = (
  typeof WeakMap !== 'undefined' &&
  isWeakMapToString(new WeakMap())
);
function isWeakMap(value) {
  if (typeof WeakMap === 'undefined') {
    return false;
  }

  return isWeakMapToString.working
    ? isWeakMapToString(value)
    : value instanceof WeakMap;
}
exports.isWeakMap = isWeakMap;

function isWeakSetToString(value) {
  return ObjectToString(value) === '[object WeakSet]';
}
isWeakSetToString.working = (
  typeof WeakSet !== 'undefined' &&
  isWeakSetToString(new WeakSet())
);
function isWeakSet(value) {
  return isWeakSetToString(value);
}
exports.isWeakSet = isWeakSet;

function isArrayBufferToString(value) {
  return ObjectToString(value) === '[object ArrayBuffer]';
}
isArrayBufferToString.working = (
  typeof ArrayBuffer !== 'undefined' &&
  isArrayBufferToString(new ArrayBuffer())
);
function isArrayBuffer(value) {
  if (typeof ArrayBuffer === 'undefined') {
    return false;
  }

  return isArrayBufferToString.working
    ? isArrayBufferToString(value)
    : value instanceof ArrayBuffer;
}
exports.isArrayBuffer = isArrayBuffer;

function isDataViewToString(value) {
  return ObjectToString(value) === '[object DataView]';
}
isDataViewToString.working = (
  typeof ArrayBuffer !== 'undefined' &&
  typeof DataView !== 'undefined' &&
  isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1))
);
function isDataView(value) {
  if (typeof DataView === 'undefined') {
    return false;
  }

  return isDataViewToString.working
    ? isDataViewToString(value)
    : value instanceof DataView;
}
exports.isDataView = isDataView;

// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var SharedArrayBufferCopy = typeof SharedArrayBuffer !== 'undefined' ? SharedArrayBuffer : undefined;
function isSharedArrayBufferToString(value) {
  return ObjectToString(value) === '[object SharedArrayBuffer]';
}
function isSharedArrayBuffer(value) {
  if (typeof SharedArrayBufferCopy === 'undefined') {
    return false;
  }

  if (typeof isSharedArrayBufferToString.working === 'undefined') {
    isSharedArrayBufferToString.working = isSharedArrayBufferToString(new SharedArrayBufferCopy());
  }

  return isSharedArrayBufferToString.working
    ? isSharedArrayBufferToString(value)
    : value instanceof SharedArrayBufferCopy;
}
exports.isSharedArrayBuffer = isSharedArrayBuffer;

function isAsyncFunction(value) {
  return ObjectToString(value) === '[object AsyncFunction]';
}
exports.isAsyncFunction = isAsyncFunction;

function isMapIterator(value) {
  return ObjectToString(value) === '[object Map Iterator]';
}
exports.isMapIterator = isMapIterator;

function isSetIterator(value) {
  return ObjectToString(value) === '[object Set Iterator]';
}
exports.isSetIterator = isSetIterator;

function isGeneratorObject(value) {
  return ObjectToString(value) === '[object Generator]';
}
exports.isGeneratorObject = isGeneratorObject;

function isWebAssemblyCompiledModule(value) {
  return ObjectToString(value) === '[object WebAssembly.Module]';
}
exports.isWebAssemblyCompiledModule = isWebAssemblyCompiledModule;

function isNumberObject(value) {
  return checkBoxedPrimitive(value, numberValue);
}
exports.isNumberObject = isNumberObject;

function isStringObject(value) {
  return checkBoxedPrimitive(value, stringValue);
}
exports.isStringObject = isStringObject;

function isBooleanObject(value) {
  return checkBoxedPrimitive(value, booleanValue);
}
exports.isBooleanObject = isBooleanObject;

function isBigIntObject(value) {
  return BigIntSupported && checkBoxedPrimitive(value, bigIntValue);
}
exports.isBigIntObject = isBigIntObject;

function isSymbolObject(value) {
  return SymbolSupported && checkBoxedPrimitive(value, symbolValue);
}
exports.isSymbolObject = isSymbolObject;

function isBoxedPrimitive(value) {
  return (
    isNumberObject(value) ||
    isStringObject(value) ||
    isBooleanObject(value) ||
    isBigIntObject(value) ||
    isSymbolObject(value)
  );
}
exports.isBoxedPrimitive = isBoxedPrimitive;

function isAnyArrayBuffer(value) {
  return typeof Uint8Array !== 'undefined' && (
    isArrayBuffer(value) ||
    isSharedArrayBuffer(value)
  );
}
exports.isAnyArrayBuffer = isAnyArrayBuffer;

['isProxy', 'isExternal', 'isModuleNamespaceObject'].forEach(function(method) {
  Object.defineProperty(exports, method, {
    enumerable: false,
    value: function() {
      throw new Error(method + ' is not supported in userland');
    }
  });
});


/***/ }),

/***/ 56557:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(33282);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors ||
  function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for (var i = 0; i < keys.length; i++) {
      descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    }
    return descriptors;
  };

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  if (typeof process !== 'undefined' && process.noDeprecation === true) {
    return fn;
  }

  // Allow for deprecating things in the process of starting up.
  if (typeof process === 'undefined') {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnvRegex = /^$/;

if (process.env.NODE_DEBUG) {
  var debugEnv = process.env.NODE_DEBUG;
  debugEnv = debugEnv.replace(/[|\\{}()[\]^$+?.]/g, '\\$&')
    .replace(/\*/g, '.*')
    .replace(/,/g, '$|^')
    .toUpperCase();
  debugEnvRegex = new RegExp('^' + debugEnv + '$', 'i');
}
exports.debuglog = function(set) {
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (debugEnvRegex.test(set)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').slice(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.slice(1, -1);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
exports.types = __webpack_require__(15724);

function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;
exports.types.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;
exports.types.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;
exports.types.isNativeError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(44123);

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__(28062);

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

var kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;

exports.promisify = function promisify(original) {
  if (typeof original !== 'function')
    throw new TypeError('The "original" argument must be of type Function');

  if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
    var fn = original[kCustomPromisifiedSymbol];
    if (typeof fn !== 'function') {
      throw new TypeError('The "util.promisify.custom" argument must be of type Function');
    }
    Object.defineProperty(fn, kCustomPromisifiedSymbol, {
      value: fn, enumerable: false, writable: false, configurable: true
    });
    return fn;
  }

  function fn() {
    var promiseResolve, promiseReject;
    var promise = new Promise(function (resolve, reject) {
      promiseResolve = resolve;
      promiseReject = reject;
    });

    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }
    args.push(function (err, value) {
      if (err) {
        promiseReject(err);
      } else {
        promiseResolve(value);
      }
    });

    try {
      original.apply(this, args);
    } catch (err) {
      promiseReject(err);
    }

    return promise;
  }

  Object.setPrototypeOf(fn, Object.getPrototypeOf(original));

  if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
    value: fn, enumerable: false, writable: false, configurable: true
  });
  return Object.defineProperties(
    fn,
    getOwnPropertyDescriptors(original)
  );
}

exports.promisify.custom = kCustomPromisifiedSymbol

function callbackifyOnRejected(reason, cb) {
  // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
  // Because `null` is a special error value in callbacks which means "no error
  // occurred", we error-wrap so the callback consumer can distinguish between
  // "the promise rejected with null" or "the promise fulfilled with undefined".
  if (!reason) {
    var newReason = new Error('Promise was rejected with a falsy value');
    newReason.reason = reason;
    reason = newReason;
  }
  return cb(reason);
}

function callbackify(original) {
  if (typeof original !== 'function') {
    throw new TypeError('The "original" argument must be of type Function');
  }

  // We DO NOT return the promise as it gives the user a false sense that
  // the promise is actually somehow related to the callback's execution
  // and that the callback throwing will reject the promise.
  function callbackified() {
    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }

    var maybeCb = args.pop();
    if (typeof maybeCb !== 'function') {
      throw new TypeError('The last argument must be of type Function');
    }
    var self = this;
    var cb = function() {
      return maybeCb.apply(self, arguments);
    };
    // In true node style we process the callback on `nextTick` with all the
    // implications (stack, `uncaughtException`, `async_hooks`)
    original.apply(this, args)
      .then(function(ret) { process.nextTick(cb.bind(null, null, ret)) },
            function(rej) { process.nextTick(callbackifyOnRejected.bind(null, rej, cb)) });
  }

  Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
  Object.defineProperties(callbackified,
                          getOwnPropertyDescriptors(original));
  return callbackified;
}
exports.callbackify = callbackify;


/***/ }),

/***/ 22248:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getContext = __webpack_require__(72880)

module.exports = function getWebGLContext (opt) {
  return getContext('webgl', opt)
}


/***/ }),

/***/ 96835:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var forEach = __webpack_require__(61262);
var availableTypedArrays = __webpack_require__(70085);
var callBind = __webpack_require__(87227);
var callBound = __webpack_require__(63063);
var gOPD = __webpack_require__(52991);

var $toString = callBound('Object.prototype.toString');
var hasToStringTag = __webpack_require__(36912)();

var g = typeof globalThis === 'undefined' ? __webpack_require__.g : globalThis;
var typedArrays = availableTypedArrays();

var $slice = callBound('String.prototype.slice');
var getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');

var $indexOf = callBound('Array.prototype.indexOf', true) || /** @type {(array: readonly unknown[], value: unknown) => keyof array} */ function indexOf(array, value) {
	for (var i = 0; i < array.length; i += 1) {
		if (array[i] === value) {
			return i;
		}
	}
	return -1;
};

/** @typedef {Int8Array | Uint8Array | Uint8ClampedArray | Int16Array | Uint16Array | Int32Array | Uint32Array | Float32Array | Float64Array | BigInt64Array | BigUint64Array} TypedArray */
/** @typedef {'Int8Array' | 'Uint8Array' | 'Uint8ClampedArray' | 'Int16Array' | 'Uint16Array' | 'Int32Array' | 'Uint32Array' | 'Float32Array' | 'Float64Array' | 'BigInt64Array' | 'BigUint64Array'} TypedArrayName */
/** @type {{ [k in `\$${TypedArrayName}`]?: (receiver: TypedArray) => string | typeof Uint8Array.prototype.slice.call | typeof Uint8Array.prototype.set.call } & { __proto__: null }} */
var cache = { __proto__: null };
if (hasToStringTag && gOPD && getPrototypeOf) {
	forEach(typedArrays, function (typedArray) {
		var arr = new g[typedArray]();
		if (Symbol.toStringTag in arr) {
			var proto = getPrototypeOf(arr);
			// @ts-expect-error TS won't narrow inside a closure
			var descriptor = gOPD(proto, Symbol.toStringTag);
			if (!descriptor) {
				var superProto = getPrototypeOf(proto);
				// @ts-expect-error TS won't narrow inside a closure
				descriptor = gOPD(superProto, Symbol.toStringTag);
			}
			// @ts-expect-error TODO: fix
			cache['$' + typedArray] = callBind(descriptor.get);
		}
	});
} else {
	forEach(typedArrays, function (typedArray) {
		var arr = new g[typedArray]();
		var fn = arr.slice || arr.set;
		if (fn) {
			// @ts-expect-error TODO: fix
			cache['$' + typedArray] = callBind(fn);
		}
	});
}

/** @type {import('.')} */
var tryTypedArrays = function tryAllTypedArrays(value) {
	/** @type {ReturnType<tryAllTypedArrays>} */ var found = false;
	forEach(
		// eslint-disable-next-line no-extra-parens
		/** @type {Record<`\$${TypedArrayName}`, typeof cache>} */ /** @type {any} */ (cache),
		/** @type {(getter: typeof cache, name: `\$${TypedArrayName}`) => void} */ function (getter, typedArray) {
			if (!found) {
				try {
				// @ts-expect-error TODO: fix
					if ('$' + getter(value) === typedArray) {
						found = $slice(typedArray, 1);
					}
				} catch (e) { /**/ }
			}
		}
	);
	return found;
};

/** @type {import('.')} */
var trySlices = function tryAllSlices(value) {
	/** @type {ReturnType<tryAllSlices>} */ var found = false;
	forEach(
		// eslint-disable-next-line no-extra-parens
		/** @type {any} */ (cache),
		/** @type {(getter: typeof cache, name: `\$${TypedArrayName}`) => void} */ function (getter, name) {
			if (!found) {
				try {
				// @ts-expect-error TODO: fix
					getter(value);
					found = $slice(name, 1);
				} catch (e) { /**/ }
			}
		}
	);
	return found;
};

/** @type {import('.')} */
module.exports = function whichTypedArray(value) {
	if (!value || typeof value !== 'object') { return false; }
	if (!hasToStringTag) {
		var tag = $slice($toString(value), 8, -1);
		if ($indexOf(typedArrays, tag) > -1) {
			return tag;
		}
		if (tag !== 'Object') {
			return false;
		}
		// node < 0.6 hits here on real Typed Arrays
		return trySlices(value);
	}
	if (!gOPD) { return null; } // unknown engine
	return tryTypedArrays(value);
};


/***/ }),

/***/ 1401:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

/*
 * World Calendars
 * https://github.com/alexcjohnson/world-calendars
 *
 * Batch-converted from kbwood/calendars
 * Many thanks to Keith Wood and all of the contributors to the original project!
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

﻿/* http://keith-wood.name/calendars.html
   Traditional Chinese calendar for jQuery v2.0.2.
   Written by Nicolas Riesco (enquiries@nicolasriesco.net) December 2016.
   Available under the MIT (http://keith-wood.name/licence.html) license. 
   Please attribute the author if you use it. */

var main = __webpack_require__(24453);
var assign = __webpack_require__(27976);


var gregorianCalendar = main.instance();

/** Implementation of the traditional Chinese calendar.
    Source of calendar tables https://github.com/isee15/Lunar-Solar-Calendar-Converter .
    @class ChineseCalendar
    @param [language=''] {string} The language code (default English) for localisation. */
function ChineseCalendar(language) {
    this.local = this.regionalOptions[language || ''] || this.regionalOptions[''];
}

ChineseCalendar.prototype = new main.baseCalendar;

assign(ChineseCalendar.prototype, {
    /** The calendar name.
        @memberof ChineseCalendar */
    name: 'Chinese',
     /** Julian date of start of Gregorian epoch: 1 January 0001 CE.
        @memberof GregorianCalendar */
    jdEpoch: 1721425.5,
    /** <code>true</code> if has a year zero, <code>false</code> if not.
        @memberof ChineseCalendar */
    hasYearZero: false,
    /** The minimum month number.
        This calendar uses month indices to account for intercalary months. 
        @memberof ChineseCalendar */
    minMonth: 0,
    /** The first month in the year.
        This calendar uses month indices to account for intercalary months. 
        @memberof ChineseCalendar */
    firstMonth: 0,
    /** The minimum day number.
        @memberof ChineseCalendar */
    minDay: 1,

    /** Localisations for the plugin.
        Entries are objects indexed by the language code ('' being the default US/English).
        Each object has the following attributes.
        @memberof ChineseCalendar
        @property name {string} The calendar name.
        @property epochs {string[]} The epoch names.
        @property monthNames {string[]} The long names of the months of the year.
        @property monthNamesShort {string[]} The short names of the months of the year.
        @property dayNames {string[]} The long names of the days of the week.
        @property dayNamesShort {string[]} The short names of the days of the week.
        @property dayNamesMin {string[]} The minimal names of the days of the week.
        @property dateFormat {string} The date format for this calendar.
                See the options on <a href="BaseCalendar.html#formatDate"><code>formatDate</code></a> for details.
        @property firstDay {number} The number of the first day of the week, starting at 0.
        @property isRTL {number} <code>true</code> if this localisation reads right-to-left. */
    regionalOptions: { // Localisations
        '': {
            name: 'Chinese',
            epochs: ['BEC', 'EC'],
            monthNumbers: function(date, padded) {
                if (typeof date === 'string') {
                    var match = date.match(MONTH_NUMBER_REGEXP);
                    return (match) ? match[0] : '';
                }

                var year = this._validateYear(date);
                var monthIndex = date.month();

                var month = '' + this.toChineseMonth(year, monthIndex);

                if (padded && month.length < 2) {
                    month = "0" + month;
                }

                if (this.isIntercalaryMonth(year, monthIndex)) {
                    month += 'i';
                }

                return month;
            },
            monthNames: function(date) {
                if (typeof date === 'string') {
                    var match = date.match(MONTH_NAME_REGEXP);
                    return (match) ? match[0] : '';
                }

                var year = this._validateYear(date);
                var monthIndex = date.month();

                var month = this.toChineseMonth(year, monthIndex);

                var monthName = ['一月','二月','三月','四月','五月','六月',
                    '七月','八月','九月','十月','十一月','十二月'][month - 1];

                if (this.isIntercalaryMonth(year, monthIndex)) {
                    monthName = '闰' + monthName;
                }

                return monthName;
            },
            monthNamesShort: function(date) {
                if (typeof date === 'string') {
                    var match = date.match(MONTH_SHORT_NAME_REGEXP);
                    return (match) ? match[0] : '';
                }

                var year = this._validateYear(date);
                var monthIndex = date.month();

                var month = this.toChineseMonth(year, monthIndex);

                var monthName = ['一','二','三','四','五','六',
                    '七','八','九','十','十一','十二'][month - 1];

                if (this.isIntercalaryMonth(year, monthIndex)) {
                    monthName = '闰' + monthName;
                }

                return monthName;
            },
            parseMonth: function(year, monthString) {
                year = this._validateYear(year);
                var month = parseInt(monthString);
                var isIntercalary;

                if (!isNaN(month)) {
                    var i = monthString[monthString.length - 1];
                    isIntercalary = (i === 'i' || i === 'I');
                } else {
                    if (monthString[0] === '闰') {
                        isIntercalary = true;
                        monthString = monthString.substring(1);
                    }
                    if (monthString[monthString.length - 1] === '月') {
                        monthString = monthString.substring(0, monthString.length - 1);
                    }
                    month = 1 +
                        ['一','二','三','四','五','六',
                        '七','八','九','十','十一','十二'].indexOf(monthString);
                }

                var monthIndex = this.toMonthIndex(year, month, isIntercalary);
                return monthIndex;
            },
            dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
            dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
            dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
            digits: null,
            dateFormat: 'yyyy/mm/dd',
            firstDay: 1,
            isRTL: false
        }
    },

    /** Check that a candidate date is from the same calendar and is valid.
        @memberof BaseCalendar
        @private
        @param year {CDate|number} The date or the year to validate.
        @param error {string} Error message if invalid.
        @return {number} The year.
        @throws Error if year out of range. */
    _validateYear: function(year, error) {
        if (year.year) {
            year = year.year();
        }

        if (typeof year !== 'number' || year < 1888 || year > 2111) {
            throw error.replace(/\{0\}/, this.local.name);
        }

        return year;
    },

    /** Retrieve the month index (i.e. accounting for intercalary months).
        @memberof ChineseCalendar
        @param year {number} The year.
        @param month {number} The month (1 for first month).
        @param [isIntercalary=false] {boolean} If month is intercalary.
        @return {number} The month index (0 for first month).
        @throws Error if an invalid month/year or a different calendar used. */
    toMonthIndex: function(year, month, isIntercalary) {
        // compute intercalary month in the year (0 if none)
        var intercalaryMonth = this.intercalaryMonth(year);

        // validate month
        var invalidIntercalaryMonth = 
            (isIntercalary && month !== intercalaryMonth);
        if (invalidIntercalaryMonth || month < 1 || month > 12) {
            throw main.local.invalidMonth
                .replace(/\{0\}/, this.local.name);
        }

        // compute month index
        var monthIndex;

        if (!intercalaryMonth) {
            monthIndex = month - 1;
        } else if(!isIntercalary && month <= intercalaryMonth) {
            monthIndex = month - 1;
        } else {
            monthIndex = month;
        }

        return monthIndex;
    },

    /** Retrieve the month (i.e. accounting for intercalary months).
        @memberof ChineseCalendar
        @param year {CDate|number} The date or the year to examine.
        @param monthIndex {number} The month index (0 for first month).
        @return {number} The month (1 for first month).
        @throws Error if an invalid month/year or a different calendar used. */
    toChineseMonth: function(year, monthIndex) {
        if (year.year) {
            year = year.year();
            monthIndex = year.month();
        }

        // compute intercalary month in the year (0 if none)
        var intercalaryMonth = this.intercalaryMonth(year);

        // validate month
        var maxMonthIndex = (intercalaryMonth) ? 12 : 11;
        if (monthIndex < 0 || monthIndex > maxMonthIndex) {
            throw main.local.invalidMonth
                .replace(/\{0\}/, this.local.name);
        }

        // compute Chinese month
        var month;

        if (!intercalaryMonth) {
            month = monthIndex + 1;
        } else if(monthIndex < intercalaryMonth) {
            month = monthIndex + 1;
        } else {
            month = monthIndex;
        }

        return month;
    },

    /** Determine the intercalary month of a year (if any).
        @memberof ChineseCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @return {number} The intercalary month number, or 0 if none.
        @throws Error if an invalid year or a different calendar used. */
    intercalaryMonth: function(year) {
        year = this._validateYear(year);

        var monthDaysTable = LUNAR_MONTH_DAYS[year - LUNAR_MONTH_DAYS[0]];
        var intercalaryMonth = monthDaysTable >> 13;

        return intercalaryMonth;
    },

    /** Determine whether this date is an intercalary month.
        @memberof ChineseCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @param [monthIndex] {number} The month index to examine.
        @return {boolean} <code>true</code> if this is an intercalary month, <code>false</code> if not.
        @throws Error if an invalid year or a different calendar used. */
    isIntercalaryMonth: function(year, monthIndex) {
        if (year.year) {
            year = year.year();
            monthIndex = year.month();
        }

        var intercalaryMonth = this.intercalaryMonth(year);

        return !!intercalaryMonth && intercalaryMonth === monthIndex;
    },

    /** Determine whether this date is in a leap year.
        @memberof ChineseCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not.
        @throws Error if an invalid year or a different calendar used. */
    leapYear: function(year) {
        return (this.intercalaryMonth(year) !== 0);
    },

    /** Determine the week of the year for a date - ISO 8601.
        @memberof ChineseCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @param [monthIndex] {number} The month index to examine.
        @param [day] {number} The day to examine.
        @return {number} The week of the year.
        @throws Error if an invalid date or a different calendar used. */
    weekOfYear: function(year, monthIndex, day) {
        // compute Chinese new year
        var validatedYear =
            this._validateYear(year, main.local.invalidyear);
        var packedDate =
            CHINESE_NEW_YEAR[validatedYear - CHINESE_NEW_YEAR[0]];

        var y = (packedDate >> 9) & 0xFFF;
        var m = (packedDate >> 5) & 0x0F;
        var d = packedDate & 0x1F;
        
        // find first Thrusday of the year
        var firstThursday;
        firstThursday = gregorianCalendar.newDate(y, m, d);
        firstThursday.add(4 - (firstThursday.dayOfWeek() || 7), 'd');

        // compute days from first Thursday
        var offset =
            this.toJD(year, monthIndex, day) - firstThursday.toJD();
        return 1 + Math.floor(offset / 7);
    },

    /** Retrieve the number of months in a year.
        @memberof ChineseCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @return {number} The number of months.
        @throws Error if an invalid year or a different calendar used. */
    monthsInYear: function(year) {
        return (this.leapYear(year)) ? 13 : 12;
    },

    /** Retrieve the number of days in a month.
        @memberof ChineseCalendar
        @param year {CDate|number} The date to examine or the year of the month.
        @param [monthIndex] {number} The month index.
        @return {number} The number of days in this month.
        @throws Error if an invalid month/year or a different calendar used. */
    daysInMonth: function(year, monthIndex) {
        if (year.year) {
            monthIndex = year.month();
            year = year.year();
        }

        year = this._validateYear(year);

        var monthDaysTable = LUNAR_MONTH_DAYS[year - LUNAR_MONTH_DAYS[0]];

        var intercalaryMonth = monthDaysTable >> 13;
        var maxMonthIndex = (intercalaryMonth) ? 12 : 11;
        if (monthIndex > maxMonthIndex) {
            throw main.local.invalidMonth
                .replace(/\{0\}/, this.local.name);
        }

        var daysInMonth = (monthDaysTable & (1 << (12 - monthIndex))) ?
            30 : 29;

        return daysInMonth;
    },

    /** Determine whether this date is a week day.
        @memberof ChineseCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @param [monthIndex] {number} The month index to examine.
        @param [day] {number} The day to examine.
        @return {boolean} <code>true</code> if a week day, <code>false</code> if not.
        @throws Error if an invalid date or a different calendar used. */
    weekDay: function(year, monthIndex, day) {
        return (this.dayOfWeek(year, monthIndex, day) || 7) < 6;
    },

    /** Retrieve the Julian date equivalent for this date,
        i.e. days since January 1, 4713 BCE Greenwich noon.
        @memberof ChineseCalendar
        @param year {CDate|number} The date to convert or the year to convert.
        @param [monthIndex] {number} The month index to convert.
        @param [day] {number} The day to convert.
        @return {number} The equivalent Julian date.
        @throws Error if an invalid date or a different calendar used. */
    toJD: function(year, monthIndex, day) {
        var date = this._validate(year, month, day, main.local.invalidDate);
        year = this._validateYear(date.year());
        monthIndex = date.month();
        day = date.day();

        var isIntercalary = this.isIntercalaryMonth(year, monthIndex);
        var month = this.toChineseMonth(year, monthIndex);

        var solar = toSolar(year, month, day, isIntercalary);

        return gregorianCalendar.toJD(solar.year, solar.month, solar.day);
    },

    /** Create a new date from a Julian date.
        @memberof ChineseCalendar
        @param jd {number} The Julian date to convert.
        @return {CDate} The equivalent date. */
    fromJD: function(jd) {
        var date = gregorianCalendar.fromJD(jd);
        var lunar = toLunar(date.year(), date.month(), date.day());
        var monthIndex = this.toMonthIndex(
            lunar.year, lunar.month, lunar.isIntercalary);
        return this.newDate(lunar.year, monthIndex, lunar.day);
    },

    /** Create a new date from a string.
        @memberof ChineseCalendar
        @param dateString {string} String representing a Chinese date
        @return {CDate} The new date.
        @throws Error if an invalid date. */
    fromString: function(dateString) {
        var match = dateString.match(DATE_REGEXP);

        var year = this._validateYear(+match[1]);

        var month = +match[2];
        var isIntercalary = !!match[3];
        var monthIndex = this.toMonthIndex(year, month, isIntercalary);

        var day = +match[4];

        return this.newDate(year, monthIndex, day);
    },

    /** Add period(s) to a date.
        Cater for no year zero.
        @memberof ChineseCalendar
        @param date {CDate} The starting date.
        @param offset {number} The number of periods to adjust by.
        @param period {string} One of 'y' for year, 'm' for month, 'w' for week, 'd' for day.
        @return {CDate} The updated date.
        @throws Error if a different calendar used. */
    add: function(date, offset, period) {
        var year = date.year();
        var monthIndex = date.month();
        var isIntercalary = this.isIntercalaryMonth(year, monthIndex);
        var month = this.toChineseMonth(year, monthIndex);

        var cdate = Object.getPrototypeOf(ChineseCalendar.prototype)
            .add.call(this, date, offset, period);

        if (period === 'y') {
            // Resync month
            var resultYear = cdate.year();
            var resultMonthIndex = cdate.month();

            // Using the fact the month index of an intercalary month
            // equals its month number:
            var resultCanBeIntercalaryMonth =
                this.isIntercalaryMonth(resultYear, month);

            var correctedMonthIndex =
                (isIntercalary && resultCanBeIntercalaryMonth) ?
                this.toMonthIndex(resultYear, month, true) :
                this.toMonthIndex(resultYear, month, false);

            if (correctedMonthIndex !== resultMonthIndex) {
                cdate.month(correctedMonthIndex);
            }
        }

        return cdate;
    },
});

// Used by ChineseCalendar.prototype.fromString
var DATE_REGEXP = /^\s*(-?\d\d\d\d|\d\d)[-/](\d?\d)([iI]?)[-/](\d?\d)/m;
var MONTH_NUMBER_REGEXP = /^\d?\d[iI]?/m;
var MONTH_NAME_REGEXP = /^闰?十?[一二三四五六七八九]?月/m;
var MONTH_SHORT_NAME_REGEXP = /^闰?十?[一二三四五六七八九]?/m;

// Chinese calendar implementation
main.calendars.chinese = ChineseCalendar;

// Chinese calendar tables from year 1888 to 2111
//
// Source:
// https://github.com/isee15/Lunar-Solar-Calendar-Converter.git

// Table of intercalary months and days per month from year 1888 to 2111
//
// bit (12 - i):        days in the i^th month
//                      (= 0 if i^th lunar month has 29 days)
//                      (= 1 if i^th lunar month has 30 days)
//                      (first month in lunar year is i = 0)
// bits (13,14,15,16):  intercalary month
//                      (= 0 if lunar year has no intercalary month)
var LUNAR_MONTH_DAYS = [1887, 0x1694, 0x16aa, 0x4ad5,
    0xab6, 0xc4b7, 0x4ae, 0xa56, 0xb52a, 0x1d2a, 0xd54, 0x75aa, 0x156a,
    0x1096d, 0x95c, 0x14ae, 0xaa4d, 0x1a4c, 0x1b2a, 0x8d55, 0xad4,
    0x135a, 0x495d, 0x95c, 0xd49b, 0x149a, 0x1a4a, 0xbaa5, 0x16a8,
    0x1ad4, 0x52da, 0x12b6, 0xe937, 0x92e, 0x1496, 0xb64b, 0xd4a,
    0xda8, 0x95b5, 0x56c, 0x12ae, 0x492f, 0x92e, 0xcc96, 0x1a94,
    0x1d4a, 0xada9, 0xb5a, 0x56c, 0x726e, 0x125c, 0xf92d, 0x192a,
    0x1a94, 0xdb4a, 0x16aa, 0xad4, 0x955b, 0x4ba, 0x125a, 0x592b,
    0x152a, 0xf695, 0xd94, 0x16aa, 0xaab5, 0x9b4, 0x14b6, 0x6a57,
    0xa56, 0x1152a, 0x1d2a, 0xd54, 0xd5aa, 0x156a, 0x96c, 0x94ae,
    0x14ae, 0xa4c, 0x7d26, 0x1b2a, 0xeb55, 0xad4, 0x12da, 0xa95d,
    0x95a, 0x149a, 0x9a4d, 0x1a4a, 0x11aa5, 0x16a8, 0x16d4, 0xd2da,
    0x12b6, 0x936, 0x9497, 0x1496, 0x1564b, 0xd4a, 0xda8, 0xd5b4,
    0x156c, 0x12ae, 0xa92f, 0x92e, 0xc96, 0x6d4a, 0x1d4a, 0x10d65,
    0xb58, 0x156c, 0xb26d, 0x125c, 0x192c, 0x9a95, 0x1a94, 0x1b4a,
    0x4b55, 0xad4, 0xf55b, 0x4ba, 0x125a, 0xb92b, 0x152a, 0x1694,
    0x96aa, 0x15aa, 0x12ab5, 0x974, 0x14b6, 0xca57, 0xa56, 0x1526,
    0x8e95, 0xd54, 0x15aa, 0x49b5, 0x96c, 0xd4ae, 0x149c, 0x1a4c,
    0xbd26, 0x1aa6, 0xb54, 0x6d6a, 0x12da, 0x1695d, 0x95a, 0x149a,
    0xda4b, 0x1a4a, 0x1aa4, 0xbb54, 0x16b4, 0xada, 0x495b, 0x936,
    0xf497, 0x1496, 0x154a, 0xb6a5, 0xda4, 0x15b4, 0x6ab6, 0x126e,
    0x1092f, 0x92e, 0xc96, 0xcd4a, 0x1d4a, 0xd64, 0x956c, 0x155c,
    0x125c, 0x792e, 0x192c, 0xfa95, 0x1a94, 0x1b4a, 0xab55, 0xad4,
    0x14da, 0x8a5d, 0xa5a, 0x1152b, 0x152a, 0x1694, 0xd6aa, 0x15aa,
    0xab4, 0x94ba, 0x14b6, 0xa56, 0x7527, 0xd26, 0xee53, 0xd54, 0x15aa,
    0xa9b5, 0x96c, 0x14ae, 0x8a4e, 0x1a4c, 0x11d26, 0x1aa4, 0x1b54,
    0xcd6a, 0xada, 0x95c, 0x949d, 0x149a, 0x1a2a, 0x5b25, 0x1aa4,
    0xfb52, 0x16b4, 0xaba, 0xa95b, 0x936, 0x1496, 0x9a4b, 0x154a,
    0x136a5, 0xda4, 0x15ac];

// Table of Chinese New Years from year 1888 to 2111
// 
// bits (0 to 4):   solar day
// bits (5 to 8):   solar month
// bits (9 to 20):  solar year
var CHINESE_NEW_YEAR = [1887, 0xec04c, 0xec23f, 0xec435, 0xec649,
    0xec83e, 0xeca51, 0xecc46, 0xece3a, 0xed04d, 0xed242, 0xed436,
    0xed64a, 0xed83f, 0xeda53, 0xedc48, 0xede3d, 0xee050, 0xee244,
    0xee439, 0xee64d, 0xee842, 0xeea36, 0xeec4a, 0xeee3e, 0xef052,
    0xef246, 0xef43a, 0xef64e, 0xef843, 0xefa37, 0xefc4b, 0xefe41,
    0xf0054, 0xf0248, 0xf043c, 0xf0650, 0xf0845, 0xf0a38, 0xf0c4d,
    0xf0e42, 0xf1037, 0xf124a, 0xf143e, 0xf1651, 0xf1846, 0xf1a3a,
    0xf1c4e, 0xf1e44, 0xf2038, 0xf224b, 0xf243f, 0xf2653, 0xf2848,
    0xf2a3b, 0xf2c4f, 0xf2e45, 0xf3039, 0xf324d, 0xf3442, 0xf3636,
    0xf384a, 0xf3a3d, 0xf3c51, 0xf3e46, 0xf403b, 0xf424e, 0xf4443,
    0xf4638, 0xf484c, 0xf4a3f, 0xf4c52, 0xf4e48, 0xf503c, 0xf524f,
    0xf5445, 0xf5639, 0xf584d, 0xf5a42, 0xf5c35, 0xf5e49, 0xf603e,
    0xf6251, 0xf6446, 0xf663b, 0xf684f, 0xf6a43, 0xf6c37, 0xf6e4b,
    0xf703f, 0xf7252, 0xf7447, 0xf763c, 0xf7850, 0xf7a45, 0xf7c39,
    0xf7e4d, 0xf8042, 0xf8254, 0xf8449, 0xf863d, 0xf8851, 0xf8a46,
    0xf8c3b, 0xf8e4f, 0xf9044, 0xf9237, 0xf944a, 0xf963f, 0xf9853,
    0xf9a47, 0xf9c3c, 0xf9e50, 0xfa045, 0xfa238, 0xfa44c, 0xfa641,
    0xfa836, 0xfaa49, 0xfac3d, 0xfae52, 0xfb047, 0xfb23a, 0xfb44e,
    0xfb643, 0xfb837, 0xfba4a, 0xfbc3f, 0xfbe53, 0xfc048, 0xfc23c,
    0xfc450, 0xfc645, 0xfc839, 0xfca4c, 0xfcc41, 0xfce36, 0xfd04a,
    0xfd23d, 0xfd451, 0xfd646, 0xfd83a, 0xfda4d, 0xfdc43, 0xfde37,
    0xfe04b, 0xfe23f, 0xfe453, 0xfe648, 0xfe83c, 0xfea4f, 0xfec44,
    0xfee38, 0xff04c, 0xff241, 0xff436, 0xff64a, 0xff83e, 0xffa51,
    0xffc46, 0xffe3a, 0x10004e, 0x100242, 0x100437, 0x10064b, 0x100841,
    0x100a53, 0x100c48, 0x100e3c, 0x10104f, 0x101244, 0x101438,
    0x10164c, 0x101842, 0x101a35, 0x101c49, 0x101e3d, 0x102051,
    0x102245, 0x10243a, 0x10264e, 0x102843, 0x102a37, 0x102c4b,
    0x102e3f, 0x103053, 0x103247, 0x10343b, 0x10364f, 0x103845,
    0x103a38, 0x103c4c, 0x103e42, 0x104036, 0x104249, 0x10443d,
    0x104651, 0x104846, 0x104a3a, 0x104c4e, 0x104e43, 0x105038,
    0x10524a, 0x10543e, 0x105652, 0x105847, 0x105a3b, 0x105c4f,
    0x105e45, 0x106039, 0x10624c, 0x106441, 0x106635, 0x106849,
    0x106a3d, 0x106c51, 0x106e47, 0x10703c, 0x10724f, 0x107444,
    0x107638, 0x10784c, 0x107a3f, 0x107c53, 0x107e48];

function toLunar(yearOrDate, monthOrResult, day, result) {
    var solarDate;
    var lunarDate;

    if(typeof yearOrDate === 'object') {
        solarDate = yearOrDate;
        lunarDate = monthOrResult || {};

    } else {
        var isValidYear = (typeof yearOrDate === 'number') &&
            (yearOrDate >= 1888) && (yearOrDate <= 2111);
        if(!isValidYear)
            throw new Error("Solar year outside range 1888-2111");

        var isValidMonth = (typeof monthOrResult === 'number') &&
            (monthOrResult >= 1) && (monthOrResult <= 12);
        if(!isValidMonth)
            throw new Error("Solar month outside range 1 - 12");

        var isValidDay = (typeof day === 'number') && (day >= 1) && (day <= 31);
        if(!isValidDay)
            throw new Error("Solar day outside range 1 - 31");

        solarDate = {
            year: yearOrDate,
            month: monthOrResult,
            day: day,
        };
        lunarDate = result || {};
    }

    // Compute Chinese new year and lunar year
    var chineseNewYearPackedDate =
        CHINESE_NEW_YEAR[solarDate.year - CHINESE_NEW_YEAR[0]];

    var packedDate = (solarDate.year << 9) | (solarDate.month << 5)
        | solarDate.day;

    lunarDate.year = (packedDate >= chineseNewYearPackedDate) ?
        solarDate.year :
        solarDate.year - 1;

    chineseNewYearPackedDate =
        CHINESE_NEW_YEAR[lunarDate.year - CHINESE_NEW_YEAR[0]];

    var y = (chineseNewYearPackedDate >> 9) & 0xFFF;
    var m = (chineseNewYearPackedDate >> 5) & 0x0F;
    var d = chineseNewYearPackedDate & 0x1F;

    // Compute days from new year
    var daysFromNewYear;

    var chineseNewYearJSDate = new Date(y, m -1, d);
    var jsDate = new Date(solarDate.year, solarDate.month - 1, solarDate.day);

    daysFromNewYear = Math.round(
        (jsDate - chineseNewYearJSDate) / (24 * 3600 * 1000));

    // Compute lunar month and day
    var monthDaysTable = LUNAR_MONTH_DAYS[lunarDate.year - LUNAR_MONTH_DAYS[0]];

    var i;
    for(i = 0; i < 13; i++) {
        var daysInMonth = (monthDaysTable & (1 << (12 - i))) ? 30 : 29;

        if (daysFromNewYear < daysInMonth) {
            break;
        }

        daysFromNewYear -= daysInMonth;
    }

    var intercalaryMonth = monthDaysTable >> 13;
    if (!intercalaryMonth || i < intercalaryMonth) {
        lunarDate.isIntercalary = false;
        lunarDate.month = 1 + i;
    } else if (i === intercalaryMonth) {
        lunarDate.isIntercalary = true;
        lunarDate.month = i;
    } else {
        lunarDate.isIntercalary = false;
        lunarDate.month = i;
    }

    lunarDate.day = 1 + daysFromNewYear;

    return lunarDate;
}

function toSolar(yearOrDate, monthOrResult, day, isIntercalaryOrResult, result) {
    var solarDate;
    var lunarDate;

    if(typeof yearOrDate === 'object') {
        lunarDate = yearOrDate;
        solarDate = monthOrResult || {};

    } else {
        var isValidYear = (typeof yearOrDate === 'number') &&
            (yearOrDate >= 1888) && (yearOrDate <= 2111);
        if(!isValidYear)
            throw new Error("Lunar year outside range 1888-2111");

        var isValidMonth = (typeof monthOrResult === 'number') &&
            (monthOrResult >= 1) && (monthOrResult <= 12);
        if(!isValidMonth)
            throw new Error("Lunar month outside range 1 - 12");

        var isValidDay = (typeof day === 'number') && (day >= 1) && (day <= 30);
        if(!isValidDay)
            throw new Error("Lunar day outside range 1 - 30");

        var isIntercalary;
        if(typeof isIntercalaryOrResult === 'object') {
            isIntercalary = false;
            solarDate = isIntercalaryOrResult;
        } else {
            isIntercalary = !!isIntercalaryOrResult;
            solarDate = result || {};
        }

        lunarDate = {
            year: yearOrDate,
            month: monthOrResult,
            day: day,
            isIntercalary: isIntercalary,
        };
    }

    // Compute days from new year
    var daysFromNewYear;

    daysFromNewYear = lunarDate.day - 1;

    var monthDaysTable = LUNAR_MONTH_DAYS[lunarDate.year - LUNAR_MONTH_DAYS[0]];
    var intercalaryMonth = monthDaysTable >> 13;

    var monthsFromNewYear;
    if (!intercalaryMonth) {
        monthsFromNewYear = lunarDate.month - 1;
    } else if (lunarDate.month > intercalaryMonth) {
        monthsFromNewYear = lunarDate.month;
    } else if (lunarDate.isIntercalary) {
        monthsFromNewYear = lunarDate.month;
    } else {
        monthsFromNewYear = lunarDate.month - 1;
    }

    for(var i = 0; i < monthsFromNewYear; i++) {
        var daysInMonth = (monthDaysTable & (1 << (12 - i))) ? 30 : 29;
        daysFromNewYear += daysInMonth;
    }

    // Compute Chinese new year
    var packedDate = CHINESE_NEW_YEAR[lunarDate.year - CHINESE_NEW_YEAR[0]];

    var y = (packedDate >> 9) & 0xFFF;
    var m = (packedDate >> 5) & 0x0F;
    var d = packedDate & 0x1F;

    // Compute solar date
    var jsDate = new Date(y, m - 1, d + daysFromNewYear);

    solarDate.year = jsDate.getFullYear();
    solarDate.month = 1 + jsDate.getMonth();
    solarDate.day = jsDate.getDate();

    return solarDate;
}



/***/ }),

/***/ 72210:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

/*
 * World Calendars
 * https://github.com/alexcjohnson/world-calendars
 *
 * Batch-converted from kbwood/calendars
 * Many thanks to Keith Wood and all of the contributors to the original project!
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

﻿/* http://keith-wood.name/calendars.html
   Coptic calendar for jQuery v2.0.2.
   Written by Keith Wood (wood.keith{at}optusnet.com.au) February 2010.
   Available under the MIT (http://keith-wood.name/licence.html) license. 
   Please attribute the author if you use it. */

var main = __webpack_require__(24453);
var assign = __webpack_require__(27976);


/** Implementation of the Coptic calendar.
    See <a href="http://en.wikipedia.org/wiki/Coptic_calendar">http://en.wikipedia.org/wiki/Coptic_calendar</a>.
    See also Calendrical Calculations: The Millennium Edition
    (<a href="http://emr.cs.iit.edu/home/reingold/calendar-book/index.shtml">http://emr.cs.iit.edu/home/reingold/calendar-book/index.shtml</a>).
    @class CopticCalendar
    @param [language=''] {string} The language code (default English) for localisation. */
function CopticCalendar(language) {
    this.local = this.regionalOptions[language || ''] || this.regionalOptions[''];
}

CopticCalendar.prototype = new main.baseCalendar;

assign(CopticCalendar.prototype, {
    /** The calendar name.
        @memberof CopticCalendar */
    name: 'Coptic',
    /** Julian date of start of Coptic epoch: 29 August 284 CE (Gregorian).
        @memberof CopticCalendar */
    jdEpoch: 1825029.5,
    /** Days per month in a common year.
        @memberof CopticCalendar */
    daysPerMonth: [30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 5],
    /** <code>true</code> if has a year zero, <code>false</code> if not.
        @memberof CopticCalendar */
    hasYearZero: false,
    /** The minimum month number.
        @memberof CopticCalendar */
    minMonth: 1,
    /** The first month in the year.
        @memberof CopticCalendar */
    firstMonth: 1,
    /** The minimum day number.
        @memberof CopticCalendar */
    minDay: 1,

    /** Localisations for the plugin.
        Entries are objects indexed by the language code ('' being the default US/English).
        Each object has the following attributes.
        @memberof CopticCalendar
        @property name {string} The calendar name.
        @property epochs {string[]} The epoch names.
        @property monthNames {string[]} The long names of the months of the year.
        @property monthNamesShort {string[]} The short names of the months of the year.
        @property dayNames {string[]} The long names of the days of the week.
        @property dayNamesShort {string[]} The short names of the days of the week.
        @property dayNamesMin {string[]} The minimal names of the days of the week.
        @property dateFormat {string} The date format for this calendar.
                See the options on <a href="BaseCalendar.html#formatDate"><code>formatDate</code></a> for details.
        @property firstDay {number} The number of the first day of the week, starting at 0.
        @property isRTL {number} <code>true</code> if this localisation reads right-to-left. */
    regionalOptions: { // Localisations
        '': {
            name: 'Coptic',
            epochs: ['BAM', 'AM'],
            monthNames: ['Thout', 'Paopi', 'Hathor', 'Koiak', 'Tobi', 'Meshir',
            'Paremhat', 'Paremoude', 'Pashons', 'Paoni', 'Epip', 'Mesori', 'Pi Kogi Enavot'],
            monthNamesShort: ['Tho', 'Pao', 'Hath', 'Koi', 'Tob', 'Mesh',
            'Pat', 'Pad', 'Pash', 'Pao', 'Epi', 'Meso', 'PiK'],
            dayNames: ['Tkyriaka', 'Pesnau', 'Pshoment', 'Peftoou', 'Ptiou', 'Psoou', 'Psabbaton'],
            dayNamesShort: ['Tky', 'Pes', 'Psh', 'Pef', 'Pti', 'Pso', 'Psa'],
            dayNamesMin: ['Tk', 'Pes', 'Psh', 'Pef', 'Pt', 'Pso', 'Psa'],
            digits: null,
            dateFormat: 'dd/mm/yyyy',
            firstDay: 0,
            isRTL: false
        }
    },

    /** Determine whether this date is in a leap year.
        @memberof CopticCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not.
        @throws Error if an invalid year or a different calendar used. */
    leapYear: function(year) {
        var date = this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
        var year = date.year() + (date.year() < 0 ? 1 : 0); // No year zero
        return year % 4 === 3 || year % 4 === -1;
    },

    /** Retrieve the number of months in a year.
        @memberof CopticCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @return {number} The number of months.
        @throws Error if an invalid year or a different calendar used. */
    monthsInYear: function(year) {
        this._validate(year, this.minMonth, this.minDay,
            main.local.invalidYear || main.regionalOptions[''].invalidYear);
        return 13;
    },

    /** Determine the week of the year for a date.
        @memberof CopticCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @param [month] {number) the month to examine.
        @param [day] {number} The day to examine.
        @return {number} The week of the year.
        @throws Error if an invalid date or a different calendar used. */
    weekOfYear: function(year, month, day) {
        // Find Sunday of this week starting on Sunday
        var checkDate = this.newDate(year, month, day);
        checkDate.add(-checkDate.dayOfWeek(), 'd');
        return Math.floor((checkDate.dayOfYear() - 1) / 7) + 1;
    },

    /** Retrieve the number of days in a month.
        @memberof CopticCalendar
        @param year {CDate|number} The date to examine or the year of the month.
        @param [month] {number} The month.
        @return {number} The number of days in this month.
        @throws Error if an invalid month/year or a different calendar used. */
    daysInMonth: function(year, month) {
        var date = this._validate(year, month, this.minDay, main.local.invalidMonth);
        return this.daysPerMonth[date.month() - 1] +
            (date.month() === 13 && this.leapYear(date.year()) ? 1 : 0);
    },

    /** Determine whether this date is a week day.
        @memberof CopticCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @param month {number} The month to examine.
        @param day {number} The day to examine.
        @return {boolean} <code>true</code> if a week day, <code>false</code> if not.
        @throws Error if an invalid date or a different calendar used. */
    weekDay: function(year, month, day) {
        return (this.dayOfWeek(year, month, day) || 7) < 6;
    },

    /** Retrieve the Julian date equivalent for this date,
        i.e. days since January 1, 4713 BCE Greenwich noon.
        @memberof CopticCalendar
        @param year {CDate|number} The date to convert or the year to convert.
        @param [month] {number) the month to convert.
        @param [day] {number} The day to convert.
        @return {number} The equivalent Julian date.
        @throws Error if an invalid date or a different calendar used. */
    toJD: function(year, month, day) {
        var date = this._validate(year, month, day, main.local.invalidDate);
        year = date.year();
        if (year < 0) { year++; } // No year zero
        return date.day() + (date.month() - 1) * 30 +
            (year - 1) * 365 + Math.floor(year / 4) + this.jdEpoch - 1;
    },

    /** Create a new date from a Julian date.
        @memberof CopticCalendar
        @param jd {number} The Julian date to convert.
        @return {CDate} The equivalent date. */
    fromJD: function(jd) {
        var c = Math.floor(jd) + 0.5 - this.jdEpoch;
        var year = Math.floor((c - Math.floor((c + 366) / 1461)) / 365) + 1;
        if (year <= 0) { year--; } // No year zero
        c = Math.floor(jd) + 0.5 - this.newDate(year, 1, 1).toJD();
        var month = Math.floor(c / 30) + 1;
        var day = c - (month - 1) * 30 + 1;
        return this.newDate(year, month, day);
    }
});

// Coptic calendar implementation
main.calendars.coptic = CopticCalendar;



/***/ }),

/***/ 28569:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

/*
 * World Calendars
 * https://github.com/alexcjohnson/world-calendars
 *
 * Batch-converted from kbwood/calendars
 * Many thanks to Keith Wood and all of the contributors to the original project!
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

﻿/* http://keith-wood.name/calendars.html
   Discworld calendar for jQuery v2.0.2.
   Written by Keith Wood (wood.keith{at}optusnet.com.au) January 2016.
   Available under the MIT (http://keith-wood.name/licence.html) license. 
   Please attribute the author if you use it. */

var main = __webpack_require__(24453);
var assign = __webpack_require__(27976);


/** Implementation of the Discworld calendar - Unseen University version.
    See also <a href="http://wiki.lspace.org/mediawiki/Discworld_calendar">http://wiki.lspace.org/mediawiki/Discworld_calendar</a>
    and <a href="http://discworld.wikia.com/wiki/Discworld_calendar">http://discworld.wikia.com/wiki/Discworld_calendar</a>.
    @class DiscworldCalendar
    @param [language=''] {string} The language code (default English) for localisation. */
function DiscworldCalendar(language) {
    this.local = this.regionalOptions[language || ''] || this.regionalOptions[''];
}

DiscworldCalendar.prototype = new main.baseCalendar;

assign(DiscworldCalendar.prototype, {
    /** The calendar name.
        @memberof DiscworldCalendar */
    name: 'Discworld',
    /** Julian date of start of Discworld epoch: 1 January 0001 CE.
        @memberof DiscworldCalendar */
    jdEpoch: 1721425.5,
    /** Days per month in a common year.
        @memberof DiscworldCalendar */
    daysPerMonth: [16, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32],
    /** <code>true</code> if has a year zero, <code>false</code> if not.
        @memberof DiscworldCalendar */
    hasYearZero: false,
    /** The minimum month number.
        @memberof DiscworldCalendar */
    minMonth: 1,
    /** The first month in the year.
        @memberof DiscworldCalendar */
    firstMonth: 1,
    /** The minimum day number.
        @memberof DiscworldCalendar */
    minDay: 1,

    /** Localisations for the plugin.
        Entries are objects indexed by the language code ('' being the default US/English).
        Each object has the following attributes.
        @memberof DiscworldCalendar
        @property name {string} The calendar name.
        @property epochs {string[]} The epoch names.
        @property monthNames {string[]} The long names of the months of the year.
        @property monthNamesShort {string[]} The short names of the months of the year.
        @property dayNames {string[]} The long names of the days of the week.
        @property dayNamesShort {string[]} The short names of the days of the week.
        @property dayNamesMin {string[]} The minimal names of the days of the week.
        @property dateFormat {string} The date format for this calendar.
                See the options on <a href="BaseCalendar.html#formatDate"><code>formatDate</code></a> for details.
        @property firstDay {number} The number of the first day of the week, starting at 0.
        @property isRTL {number} <code>true</code> if this localisation reads right-to-left. */
    regionalOptions: { // Localisations
        '': {
            name: 'Discworld',
            epochs: ['BUC', 'UC'],
            monthNames: ['Ick', 'Offle', 'February', 'March', 'April', 'May', 'June',
            'Grune', 'August', 'Spune', 'Sektober', 'Ember', 'December'],
            monthNamesShort: ['Ick', 'Off', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Gru', 'Aug', 'Spu', 'Sek', 'Emb', 'Dec'],
            dayNames: ['Sunday', 'Octeday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
            dayNamesShort: ['Sun', 'Oct', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
            dayNamesMin: ['Su', 'Oc', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
            digits: null,
            dateFormat: 'yyyy/mm/dd',
            firstDay: 2,
            isRTL: false
        }
    },

    /** Determine whether this date is in a leap year.
        @memberof DiscworldCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not.
        @throws Error if an invalid year or a different calendar used. */
    leapYear: function(year) {
        this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
        return false;
    },

    /** Retrieve the number of months in a year.
        @memberof DiscworldCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @return {number} The number of months.
        @throws Error if an invalid year or a different calendar used. */
    monthsInYear: function(year) {
        this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
        return 13;
    },

    /** Retrieve the number of days in a year.
        @memberof DiscworldCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @return {number} The number of days.
        @throws Error if an invalid year or a different calendar used. */
    daysInYear: function(year) {
        this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
        return 400;
    },

    /** Determine the week of the year for a date.
        @memberof DiscworldCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @param [month] {number} The month to examine.
        @param [day] {number} The day to examine.
        @return {number} The week of the year.
        @throws Error if an invalid date or a different calendar used. */
    weekOfYear: function(year, month, day) {
        // Find Sunday of this week starting on Sunday
        var checkDate = this.newDate(year, month, day);
        checkDate.add(-checkDate.dayOfWeek(), 'd');
        return Math.floor((checkDate.dayOfYear() - 1) / 8) + 1;
    },

    /** Retrieve the number of days in a month.
        @memberof DiscworldCalendar
        @param year {CDate|number} The date to examine or the year of the month.
        @param [month] {number} The month.
        @return {number} The number of days in this month.
        @throws Error if an invalid month/year or a different calendar used. */
    daysInMonth: function(year, month) {
        var date = this._validate(year, month, this.minDay, main.local.invalidMonth);
        return this.daysPerMonth[date.month() - 1];
    },

    /** Retrieve the number of days in a week.
        @memberof DiscworldCalendar
        @return {number} The number of days. */
    daysInWeek: function() {
        return 8;
    },

    /** Retrieve the day of the week for a date.
        @memberof DiscworldCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @param [month] {number} The month to examine.
        @param [day] {number} The day to examine.
        @return {number} The day of the week: 0 to number of days - 1.
        @throws Error if an invalid date or a different calendar used. */
    dayOfWeek: function(year, month, day) {
        var date = this._validate(year, month, day, main.local.invalidDate);
        return (date.day() + 1) % 8;
    },

    /** Determine whether this date is a week day.
        @memberof DiscworldCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @param [month] {number} The month to examine.
        @param [day] {number} The day to examine.
        @return {boolean} <code>true</code> if a week day, <code>false</code> if not.
        @throws Error if an invalid date or a different calendar used. */
    weekDay: function(year, month, day) {
        var dow = this.dayOfWeek(year, month, day);
        return (dow >= 2 && dow <= 6);
    },

    /** Retrieve additional information about a date.
        @memberof DiscworldCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @param [month] {number} The month to examine.
        @param [day] {number} The day to examine.
        @return {object} Additional information - contents depends on calendar.
        @throws Error if an invalid date or a different calendar used. */
    extraInfo: function(year, month, day) {
        var date = this._validate(year, month, day, main.local.invalidDate);
        return {century: centuries[Math.floor((date.year() - 1) / 100) + 1] || ''};
    },

    /** Retrieve the Julian date equivalent for this date,
        i.e. days since January 1, 4713 BCE Greenwich noon.
        @memberof DiscworldCalendar
        @param year {CDate|number} The date to convert or the year to convert.
        @param [month] {number} The month to convert.
        @param [day] {number} The day to convert.
        @return {number} The equivalent Julian date.
        @throws Error if an invalid date or a different calendar used. */
    toJD: function(year, month, day) {
        var date = this._validate(year, month, day, main.local.invalidDate);
        year = date.year() + (date.year() < 0 ? 1 : 0);
        month = date.month();
        day = date.day();
        return day + (month > 1 ? 16 : 0) + (month > 2 ? (month - 2) * 32 : 0) +
            (year - 1) * 400 + this.jdEpoch - 1;
    },

    /** Create a new date from a Julian date.
        @memberof DiscworldCalendar
        @param jd {number} The Julian date to convert.
        @return {CDate} The equivalent date. */
    fromJD: function(jd) {
        jd = Math.floor(jd + 0.5) - Math.floor(this.jdEpoch) - 1;
        var year = Math.floor(jd / 400) + 1;
        jd -= (year - 1) * 400;
        jd += (jd > 15 ? 16 : 0);
        var month = Math.floor(jd / 32) + 1;
        var day = jd - (month - 1) * 32 + 1;
        return this.newDate(year <= 0 ? year - 1 : year, month, day);
    }
});

// Names of the centuries
var centuries = {
    20: 'Fruitbat',
    21: 'Anchovy'
};

// Discworld calendar implementation
main.calendars.discworld = DiscworldCalendar;



/***/ }),

/***/ 81133:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

/*
 * World Calendars
 * https://github.com/alexcjohnson/world-calendars
 *
 * Batch-converted from kbwood/calendars
 * Many thanks to Keith Wood and all of the contributors to the original project!
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

﻿/* http://keith-wood.name/calendars.html
   Ethiopian calendar for jQuery v2.0.2.
   Written by Keith Wood (wood.keith{at}optusnet.com.au) February 2010.
   Available under the MIT (http://keith-wood.name/licence.html) license. 
   Please attribute the author if you use it. */

var main = __webpack_require__(24453);
var assign = __webpack_require__(27976);


/** Implementation of the Ethiopian calendar.
    See <a href="http://en.wikipedia.org/wiki/Ethiopian_calendar">http://en.wikipedia.org/wiki/Ethiopian_calendar</a>.
    See also Calendrical Calculations: The Millennium Edition
    (<a href="http://emr.cs.iit.edu/home/reingold/calendar-book/index.shtml">http://emr.cs.iit.edu/home/reingold/calendar-book/index.shtml</a>).
    @class EthiopianCalendar
    @param [language=''] {string} The language code (default English) for localisation. */
function EthiopianCalendar(language) {
    this.local = this.regionalOptions[language || ''] || this.regionalOptions[''];
}

EthiopianCalendar.prototype = new main.baseCalendar;

assign(EthiopianCalendar.prototype, {
    /** The calendar name.
        @memberof EthiopianCalendar */
    name: 'Ethiopian',
    /** Julian date of start of Ethiopian epoch: 27 August 8 CE (Gregorian).
        @memberof EthiopianCalendar */
    jdEpoch: 1724220.5,
    /** Days per month in a common year.
        @memberof EthiopianCalendar */
    daysPerMonth: [30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 5],
    /** <code>true</code> if has a year zero, <code>false</code> if not.
        @memberof EthiopianCalendar */
    hasYearZero: false,
    /** The minimum month number.
        @memberof EthiopianCalendar */
    minMonth: 1,
    /** The first month in the year.
        @memberof EthiopianCalendar */
    firstMonth: 1,
    /** The minimum day number.
        @memberof EthiopianCalendar */
    minDay: 1,

    /** Localisations for the plugin.
        Entries are objects indexed by the language code ('' being the default US/English).
        Each object has the following attributes.
        @memberof EthiopianCalendar
        @property name {string} The calendar name.
        @property epochs {string[]} The epoch names.
        @property monthNames {string[]} The long names of the months of the year.
        @property monthNamesShort {string[]} The short names of the months of the year.
        @property dayNames {string[]} The long names of the days of the week.
        @property dayNamesShort {string[]} The short names of the days of the week.
        @property dayNamesMin {string[]} The minimal names of the days of the week.
        @property dateFormat {string} The date format for this calendar.
                See the options on <a href="BaseCalendar.html#formatDate"><code>formatDate</code></a> for details.
        @property firstDay {number} The number of the first day of the week, starting at 0.
        @property isRTL {number} <code>true</code> if this localisation reads right-to-left. */
    regionalOptions: { // Localisations
        '': {
            name: 'Ethiopian',
            epochs: ['BEE', 'EE'],
            monthNames: ['Meskerem', 'Tikemet', 'Hidar', 'Tahesas', 'Tir', 'Yekatit',
            'Megabit', 'Miazia', 'Genbot', 'Sene', 'Hamle', 'Nehase', 'Pagume'],
            monthNamesShort: ['Mes', 'Tik', 'Hid', 'Tah', 'Tir', 'Yek',
            'Meg', 'Mia', 'Gen', 'Sen', 'Ham', 'Neh', 'Pag'],
            dayNames: ['Ehud', 'Segno', 'Maksegno', 'Irob', 'Hamus', 'Arb', 'Kidame'],
            dayNamesShort: ['Ehu', 'Seg', 'Mak', 'Iro', 'Ham', 'Arb', 'Kid'],
            dayNamesMin: ['Eh', 'Se', 'Ma', 'Ir', 'Ha', 'Ar', 'Ki'],
            digits: null,
            dateFormat: 'dd/mm/yyyy',
            firstDay: 0,
            isRTL: false
        }
    },

    /** Determine whether this date is in a leap year.
        @memberof EthiopianCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not.
        @throws Error if an invalid year or a different calendar used. */
    leapYear: function(year) {
        var date = this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
        var year = date.year() + (date.year() < 0 ? 1 : 0); // No year zero
        return year % 4 === 3 || year % 4 === -1;
    },

    /** Retrieve the number of months in a year.
        @memberof EthiopianCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @return {number} The number of months.
        @throws Error if an invalid year or a different calendar used. */
    monthsInYear: function(year) {
        this._validate(year, this.minMonth, this.minDay,
            main.local.invalidYear || main.regionalOptions[''].invalidYear);
        return 13;
    },

    /** Determine the week of the year for a date.
        @memberof EthiopianCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @param [month] {number} The month to examine.
        @param [day] {number} The day to examine.
        @return {number} The week of the year.
        @throws Error if an invalid date or a different calendar used. */
    weekOfYear: function(year, month, day) {
        // Find Sunday of this week starting on Sunday
        var checkDate = this.newDate(year, month, day);
        checkDate.add(-checkDate.dayOfWeek(), 'd');
        return Math.floor((checkDate.dayOfYear() - 1) / 7) + 1;
    },

    /** Retrieve the number of days in a month.
        @memberof EthiopianCalendar
        @param year {CDate|number} The date to examine or the year of the month.
        @param [month] {number} The month.
        @return {number} The number of days in this month.
        @throws Error if an invalid month/year or a different calendar used. */
    daysInMonth: function(year, month) {
        var date = this._validate(year, month, this.minDay, main.local.invalidMonth);
        return this.daysPerMonth[date.month() - 1] +
            (date.month() === 13 && this.leapYear(date.year()) ? 1 : 0);
    },

    /** Determine whether this date is a week day.
        @memberof EthiopianCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @param [month] {number} The month to examine.
        @param [day] {number} The day to examine.
        @return {boolean} <code>true</code> if a week day, <code>false</code> if not.
        @throws Error if an invalid date or a different calendar used. */
    weekDay: function(year, month, day) {
        return (this.dayOfWeek(year, month, day) || 7) < 6;
    },

    /** Retrieve the Julian date equivalent for this date,
        i.e. days since January 1, 4713 BCE Greenwich noon.
        @memberof EthiopianCalendar
        @param year {CDate|number} The date to convert or the year to convert.
        @param [month] {number} The month to convert.
        @param [day] {number} The day to convert.
        @return {number} The equivalent Julian date.
        @throws Error if an invalid date or a different calendar used. */
    toJD: function(year, month, day) {
        var date = this._validate(year, month, day, main.local.invalidDate);
        year = date.year();
        if (year < 0) { year++; } // No year zero
        return date.day() + (date.month() - 1) * 30 +
            (year - 1) * 365 + Math.floor(year / 4) + this.jdEpoch - 1;
    },

    /** Create a new date from a Julian date.
        @memberof EthiopianCalendar
        @param jd {number} the Julian date to convert.
        @return {CDate} the equivalent date. */
    fromJD: function(jd) {
        var c = Math.floor(jd) + 0.5 - this.jdEpoch;
        var year = Math.floor((c - Math.floor((c + 366) / 1461)) / 365) + 1;
        if (year <= 0) { year--; } // No year zero
        c = Math.floor(jd) + 0.5 - this.newDate(year, 1, 1).toJD();
        var month = Math.floor(c / 30) + 1;
        var day = c - (month - 1) * 30 + 1;
        return this.newDate(year, month, day);
    }
});

// Ethiopian calendar implementation
main.calendars.ethiopian = EthiopianCalendar;



/***/ }),

/***/ 78295:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

/*
 * World Calendars
 * https://github.com/alexcjohnson/world-calendars
 *
 * Batch-converted from kbwood/calendars
 * Many thanks to Keith Wood and all of the contributors to the original project!
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

﻿/* http://keith-wood.name/calendars.html
   Hebrew calendar for jQuery v2.0.2.
   Written by Keith Wood (wood.keith{at}optusnet.com.au) August 2009.
   Available under the MIT (http://keith-wood.name/licence.html) license. 
   Please attribute the author if you use it. */

var main = __webpack_require__(24453);
var assign = __webpack_require__(27976);


/** Implementation of the Hebrew civil calendar.
    Based on code from <a href="http://www.fourmilab.ch/documents/calendar/">http://www.fourmilab.ch/documents/calendar/</a>.
    See also <a href="http://en.wikipedia.org/wiki/Hebrew_calendar">http://en.wikipedia.org/wiki/Hebrew_calendar</a>.
    @class HebrewCalendar
    @param [language=''] {string} The language code (default English) for localisation. */
function HebrewCalendar(language) {
    this.local = this.regionalOptions[language || ''] || this.regionalOptions[''];
}

HebrewCalendar.prototype = new main.baseCalendar;

assign(HebrewCalendar.prototype, {
    /** The calendar name.
        @memberof HebrewCalendar */
    name: 'Hebrew',
    /** Julian date of start of Hebrew epoch: 7 October 3761 BCE.
        @memberof HebrewCalendar */
    jdEpoch: 347995.5,
    /** Days per month in a common year.
        @memberof HebrewCalendar */
    daysPerMonth: [30, 29, 30, 29, 30, 29, 30, 29, 30, 29, 30, 29, 29],
    /** <code>true</code> if has a year zero, <code>false</code> if not.
        @memberof HebrewCalendar */
    hasYearZero: false,
    /** The minimum month number.
        @memberof HebrewCalendar */
    minMonth: 1,
    /** The first month in the year.
        @memberof HebrewCalendar */
    firstMonth: 7,
    /** The minimum day number.
        @memberof HebrewCalendar */
    minDay: 1,

    /** Localisations for the plugin.
        Entries are objects indexed by the language code ('' being the default US/English).
        Each object has the following attributes.
        @memberof HebrewCalendar
        @property name {string} The calendar name.
        @property epochs {string[]} The epoch names.
        @property monthNames {string[]} The long names of the months of the year.
        @property monthNamesShort {string[]} The short names of the months of the year.
        @property dayNames {string[]} The long names of the days of the week.
        @property dayNamesShort {string[]} The short names of the days of the week.
        @property dayNamesMin {string[]} The minimal names of the days of the week.
        @property dateFormat {string} The date format for this calendar.
                See the options on <a href="BaseCalendar.html#formatDate"><code>formatDate</code></a> for details.
        @property firstDay {number} The number of the first day of the week, starting at 0.
        @property isRTL {number} <code>true</code> if this localisation reads right-to-left. */
    regionalOptions: { // Localisations
        '': {
            name: 'Hebrew',
            epochs: ['BAM', 'AM'],
            monthNames: ['Nisan', 'Iyar', 'Sivan', 'Tammuz', 'Av', 'Elul',
            'Tishrei', 'Cheshvan', 'Kislev', 'Tevet', 'Shevat', 'Adar', 'Adar II'],
            monthNamesShort: ['Nis', 'Iya', 'Siv', 'Tam', 'Av', 'Elu', 'Tis', 'Che', 'Kis', 'Tev', 'She', 'Ada', 'Ad2'],
            dayNames: ['Yom Rishon', 'Yom Sheni', 'Yom Shlishi', 'Yom Revi\'i', 'Yom Chamishi', 'Yom Shishi', 'Yom Shabbat'],
            dayNamesShort: ['Ris', 'She', 'Shl', 'Rev', 'Cha', 'Shi', 'Sha'],
            dayNamesMin: ['Ri','She','Shl','Re','Ch','Shi','Sha'],
            digits: null,
            dateFormat: 'dd/mm/yyyy',
            firstDay: 0,
            isRTL: false
        }
    },

    /** Determine whether this date is in a leap year.
        @memberof HebrewCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not.
        @throws Error if an invalid year or a different calendar used. */
    leapYear: function(year) {
        var date = this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
        return this._leapYear(date.year());
    },

    /** Determine whether this date is in a leap year.
        @memberof HebrewCalendar
        @private
        @param year {number} The year to examine.
        @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not.
        @throws Error if an invalid year or a different calendar used. */
    _leapYear: function(year) {
        year = (year < 0 ? year + 1 : year);
        return mod(year * 7 + 1, 19) < 7;
    },

    /** Retrieve the number of months in a year.
        @memberof HebrewCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @return {number} The number of months.
        @throws Error if an invalid year or a different calendar used. */
    monthsInYear: function(year) {
        this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
        return this._leapYear(year.year ? year.year() : year) ? 13 : 12;
    },

    /** Determine the week of the year for a date.
        @memberof HebrewCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @param [month] {number} The month to examine.
        @param [day] {number} The day to examine.
        @return {number} The week of the year.
        @throws Error if an invalid date or a different calendar used. */
    weekOfYear: function(year, month, day) {
        // Find Sunday of this week starting on Sunday
        var checkDate = this.newDate(year, month, day);
        checkDate.add(-checkDate.dayOfWeek(), 'd');
        return Math.floor((checkDate.dayOfYear() - 1) / 7) + 1;
    },

    /** Retrieve the number of days in a year.
        @memberof HebrewCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @return {number} The number of days.
        @throws Error if an invalid year or a different calendar used. */
    daysInYear: function(year) {
        var date = this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
        year = date.year();
        return this.toJD((year === -1 ? +1 : year + 1), 7, 1) - this.toJD(year, 7, 1);
    },

    /** Retrieve the number of days in a month.
        @memberof HebrewCalendar
        @param year {CDate|number} The date to examine or the year of the month.
        @param [month] {number} The month.
        @return {number} The number of days in this month.
        @throws Error if an invalid month/year or a different calendar used. */
    daysInMonth: function(year, month) {
        if (year.year) {
            month = year.month();
            year = year.year();
        }
        this._validate(year, month, this.minDay, main.local.invalidMonth);
        return (month === 12 && this.leapYear(year) ? 30 : // Adar I
                (month === 8 && mod(this.daysInYear(year), 10) === 5 ? 30 : // Cheshvan in shlemah year
                (month === 9 && mod(this.daysInYear(year), 10) === 3 ? 29 : // Kislev in chaserah year
                this.daysPerMonth[month - 1])));
    },

    /** Determine whether this date is a week day.
        @memberof HebrewCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @param [month] {number} The month to examine.
        @param [day] {number} The day to examine.
        @return {boolean} <code>true</code> if a week day, <code>false</code> if not.
        @throws Error if an invalid date or a different calendar used. */
    weekDay: function(year, month, day) {
        return this.dayOfWeek(year, month, day) !== 6;
    },

    /** Retrieve additional information about a date - year type.
        @memberof HebrewCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @param [month] {number} The month to examine.
        @param [day] {number} The day to examine.
        @return {object} Additional information - contents depends on calendar.
        @throws Error if an invalid date or a different calendar used. */
    extraInfo: function(year, month, day) {
        var date = this._validate(year, month, day, main.local.invalidDate);
        return {yearType: (this.leapYear(date) ? 'embolismic' : 'common') + ' ' +
            ['deficient', 'regular', 'complete'][this.daysInYear(date) % 10 - 3]};
    },

    /** Retrieve the Julian date equivalent for this date,
        i.e. days since January 1, 4713 BCE Greenwich noon.
        @memberof HebrewCalendar
        @param year {CDate)|number} The date to convert or the year to convert.
        @param [month] {number} The month to convert.
        @param [day] {number} The day to convert.
        @return {number} The equivalent Julian date.
        @throws Error if an invalid date or a different calendar used. */
    toJD: function(year, month, day) {
        var date = this._validate(year, month, day, main.local.invalidDate);
        year = date.year();
        month = date.month();
        day = date.day();
        var adjYear = (year <= 0 ? year + 1 : year);
        var jd = this.jdEpoch + this._delay1(adjYear) +
            this._delay2(adjYear) + day + 1;
        if (month < 7) {
            for (var m = 7; m <= this.monthsInYear(year); m++) {
                jd += this.daysInMonth(year, m);
            }
            for (var m = 1; m < month; m++) {
                jd += this.daysInMonth(year, m);
            }
        }
        else {
            for (var m = 7; m < month; m++) {
                jd += this.daysInMonth(year, m);
            }
        }
        return jd;
    },

    /** Test for delay of start of new year and to avoid
        Sunday, Wednesday, or Friday as start of the new year.
        @memberof HebrewCalendar
        @private
        @param year {number} The year to examine.
        @return {number} The days to offset by. */
    _delay1: function(year) {
        var months = Math.floor((235 * year - 234) / 19);
        var parts = 12084 + 13753 * months;
        var day = months * 29 + Math.floor(parts / 25920);
        if (mod(3 * (day + 1), 7) < 3) {
            day++;
        }
        return day;
    },

    /** Check for delay in start of new year due to length of adjacent years.
        @memberof HebrewCalendar
        @private
        @param year {number} The year to examine.
        @return {number} The days to offset by. */
    _delay2: function(year) {
        var last = this._delay1(year - 1);
        var present = this._delay1(year);
        var next = this._delay1(year + 1);
        return ((next - present) === 356 ? 2 : ((present - last) === 382 ? 1 : 0));
    },

    /** Create a new date from a Julian date.
        @memberof HebrewCalendar
        @param jd {number} The Julian date to convert.
        @return {CDate} The equivalent date. */
    fromJD: function(jd) {
        jd = Math.floor(jd) + 0.5;
        var year = Math.floor(((jd - this.jdEpoch) * 98496.0) / 35975351.0) - 1;
        while (jd >= this.toJD((year === -1 ? +1 : year + 1), 7, 1)) {
            year++;
        }
        var month = (jd < this.toJD(year, 1, 1)) ? 7 : 1;
        while (jd > this.toJD(year, month, this.daysInMonth(year, month))) {
            month++;
        }
        var day = jd - this.toJD(year, month, 1) + 1;
        return this.newDate(year, month, day);
    }
});

// Modulus function which works for non-integers.
function mod(a, b) {
    return a - (b * Math.floor(a / b));
}

// Hebrew calendar implementation
main.calendars.hebrew = HebrewCalendar;



/***/ }),

/***/ 25512:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

/*
 * World Calendars
 * https://github.com/alexcjohnson/world-calendars
 *
 * Batch-converted from kbwood/calendars
 * Many thanks to Keith Wood and all of the contributors to the original project!
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

﻿/* http://keith-wood.name/calendars.html
   Islamic calendar for jQuery v2.0.2.
   Written by Keith Wood (wood.keith{at}optusnet.com.au) August 2009.
   Available under the MIT (http://keith-wood.name/licence.html) license. 
   Please attribute the author if you use it. */

var main = __webpack_require__(24453);
var assign = __webpack_require__(27976);


/** Implementation of the Islamic or '16 civil' calendar.
    Based on code from <a href="http://www.iranchamber.com/calendar/converter/iranian_calendar_converter.php">http://www.iranchamber.com/calendar/converter/iranian_calendar_converter.php</a>.
    See also <a href="http://en.wikipedia.org/wiki/Islamic_calendar">http://en.wikipedia.org/wiki/Islamic_calendar</a>.
    @class IslamicCalendar
    @param [language=''] {string} The language code (default English) for localisation. */
function IslamicCalendar(language) {
    this.local = this.regionalOptions[language || ''] || this.regionalOptions[''];
}

IslamicCalendar.prototype = new main.baseCalendar;

assign(IslamicCalendar.prototype, {
    /** The calendar name.
        @memberof IslamicCalendar */
    name: 'Islamic',
    /** Julian date of start of Islamic epoch: 16 July 622 CE.
        @memberof IslamicCalendar */
    jdEpoch: 1948439.5,
    /** Days per month in a common year.
        @memberof IslamicCalendar */
    daysPerMonth: [30, 29, 30, 29, 30, 29, 30, 29, 30, 29, 30, 29],
    /** <code>true</code> if has a year zero, <code>false</code> if not.
        @memberof IslamicCalendar */
    hasYearZero: false,
    /** The minimum month number.
        @memberof IslamicCalendar */
    minMonth: 1,
    /** The first month in the year.
        @memberof IslamicCalendar */
    firstMonth: 1,
    /** The minimum day number.
        @memberof IslamicCalendar */
    minDay: 1,

    /** Localisations for the plugin.
        Entries are objects indexed by the language code ('' being the default US/English).
        Each object has the following attributes.
        @memberof IslamicCalendar
        @property name {string} The calendar name.
        @property epochs {string[]} The epoch names.
        @property monthNames {string[]} The long names of the months of the year.
        @property monthNamesShort {string[]} The short names of the months of the year.
        @property dayNames {string[]} The long names of the days of the week.
        @property dayNamesShort {string[]} The short names of the days of the week.
        @property dayNamesMin {string[]} The minimal names of the days of the week.
        @property dateFormat {string} The date format for this calendar.
                See the options on <a href="BaseCalendar.html#formatDate"><code>formatDate</code></a> for details.
        @property firstDay {number} The number of the first day of the week, starting at 0.
        @property isRTL {number} <code>true</code> if this localisation reads right-to-left. */
    regionalOptions: { // Localisations
        '': {
            name: 'Islamic',
            epochs: ['BH', 'AH'],
            monthNames: ['Muharram', 'Safar', 'Rabi\' al-awwal', 'Rabi\' al-thani', 'Jumada al-awwal', 'Jumada al-thani',
            'Rajab', 'Sha\'aban', 'Ramadan', 'Shawwal', 'Dhu al-Qi\'dah', 'Dhu al-Hijjah'],
            monthNamesShort: ['Muh', 'Saf', 'Rab1', 'Rab2', 'Jum1', 'Jum2', 'Raj', 'Sha\'', 'Ram', 'Shaw', 'DhuQ', 'DhuH'],
            dayNames: ['Yawm al-ahad', 'Yawm al-ithnayn', 'Yawm ath-thulaathaa\'',
            'Yawm al-arbi\'aa\'', 'Yawm al-khamīs', 'Yawm al-jum\'a', 'Yawm as-sabt'],
            dayNamesShort: ['Aha', 'Ith', 'Thu', 'Arb', 'Kha', 'Jum', 'Sab'],
            dayNamesMin: ['Ah','It','Th','Ar','Kh','Ju','Sa'],
            digits: null,
            dateFormat: 'yyyy/mm/dd',
            firstDay: 6,
            isRTL: false
        }
    },

    /** Determine whether this date is in a leap year.
        @memberof IslamicCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not.
        @throws Error if an invalid year or a different calendar used. */
    leapYear: function(year) {
        var date = this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
        return (date.year() * 11 + 14) % 30 < 11;
    },

    /** Determine the week of the year for a date.
        @memberof IslamicCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @param [month] {number} The month to examine.
        @param [day] {number} The day to examine.
        @return {number} The week of the year.
        @throws Error if an invalid date or a different calendar used. */
    weekOfYear: function(year, month, day) {
        // Find Sunday of this week starting on Sunday
        var checkDate = this.newDate(year, month, day);
        checkDate.add(-checkDate.dayOfWeek(), 'd');
        return Math.floor((checkDate.dayOfYear() - 1) / 7) + 1;
    },

    /** Retrieve the number of days in a year.
        @memberof IslamicCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @return {number} The number of days.
        @throws Error if an invalid year or a different calendar used. */
    daysInYear: function(year) {
        return (this.leapYear(year) ? 355 : 354);
    },

    /** Retrieve the number of days in a month.
        @memberof IslamicCalendar
        @param year {CDate|number} The date to examine or the year of the month.
        @param [month] {number} The month.
        @return {number} The number of days in this month.
        @throws Error if an invalid month/year or a different calendar used. */
    daysInMonth: function(year, month) {
        var date = this._validate(year, month, this.minDay, main.local.invalidMonth);
        return this.daysPerMonth[date.month() - 1] +
            (date.month() === 12 && this.leapYear(date.year()) ? 1 : 0);
    },

    /** Determine whether this date is a week day.
        @memberof IslamicCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @param [month] {number} The month to examine.
        @param [day] {number} The day to examine.
        @return {boolean} <code>true</code> if a week day, <code>false</code> if not.
        @throws Error if an invalid date or a different calendar used. */
    weekDay: function(year, month, day) {
        return this.dayOfWeek(year, month, day) !== 5;
    },

    /** Retrieve the Julian date equivalent for this date,
        i.e. days since January 1, 4713 BCE Greenwich noon.
        @memberof IslamicCalendar
        @param year {CDate|number} The date to convert or the year to convert.
        @param [month] {number} The month to convert.
        @param [day] {number} The day to convert.
        @return {number} The equivalent Julian date.
        @throws Error if an invalid date or a different calendar used. */
    toJD: function(year, month, day) {
        var date = this._validate(year, month, day, main.local.invalidDate);
        year = date.year();
        month = date.month();
        day = date.day();
        year = (year <= 0 ? year + 1 : year);
        return day + Math.ceil(29.5 * (month - 1)) + (year - 1) * 354 +
            Math.floor((3 + (11 * year)) / 30) + this.jdEpoch - 1;
    },

    /** Create a new date from a Julian date.
        @memberof IslamicCalendar
        @param jd {number} The Julian date to convert.
        @return {CDate} The equivalent date. */
    fromJD: function(jd) {
        jd = Math.floor(jd) + 0.5;
        var year = Math.floor((30 * (jd - this.jdEpoch) + 10646) / 10631);
        year = (year <= 0 ? year - 1 : year);
        var month = Math.min(12, Math.ceil((jd - 29 - this.toJD(year, 1, 1)) / 29.5) + 1);
        var day = jd - this.toJD(year, month, 1) + 1;
        return this.newDate(year, month, day);
    }
});

// Islamic (16 civil) calendar implementation
main.calendars.islamic = IslamicCalendar;



/***/ }),

/***/ 42645:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

/*
 * World Calendars
 * https://github.com/alexcjohnson/world-calendars
 *
 * Batch-converted from kbwood/calendars
 * Many thanks to Keith Wood and all of the contributors to the original project!
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

﻿/* http://keith-wood.name/calendars.html
   Julian calendar for jQuery v2.0.2.
   Written by Keith Wood (wood.keith{at}optusnet.com.au) August 2009.
   Available under the MIT (http://keith-wood.name/licence.html) license. 
   Please attribute the author if you use it. */

var main = __webpack_require__(24453);
var assign = __webpack_require__(27976);


/** Implementation of the Julian calendar.
    Based on code from <a href="http://www.fourmilab.ch/documents/calendar/">http://www.fourmilab.ch/documents/calendar/</a>.
    See also <a href="http://en.wikipedia.org/wiki/Julian_calendar">http://en.wikipedia.org/wiki/Julian_calendar</a>.
    @class JulianCalendar
    @augments BaseCalendar
    @param [language=''] {string} The language code (default English) for localisation. */
function JulianCalendar(language) {
    this.local = this.regionalOptions[language || ''] || this.regionalOptions[''];
}

JulianCalendar.prototype = new main.baseCalendar;

assign(JulianCalendar.prototype, {
    /** The calendar name.
        @memberof JulianCalendar */
    name: 'Julian',
    /** Julian date of start of Julian epoch: 1 January 0001 AD = 30 December 0001 BCE.
        @memberof JulianCalendar */
    jdEpoch: 1721423.5,
    /** Days per month in a common year.
        @memberof JulianCalendar */
    daysPerMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
    /** <code>true</code> if has a year zero, <code>false</code> if not.
        @memberof JulianCalendar */
    hasYearZero: false,
    /** The minimum month number.
        @memberof JulianCalendar */
    minMonth: 1,
    /** The first month in the year.
        @memberof JulianCalendar */
    firstMonth: 1,
    /** The minimum day number.
        @memberof JulianCalendar */
    minDay: 1,

    /** Localisations for the plugin.
        Entries are objects indexed by the language code ('' being the default US/English).
        Each object has the following attributes.
        @memberof JulianCalendar
        @property name {string} The calendar name.
        @property epochs {string[]} The epoch names.
        @property monthNames {string[]} The long names of the months of the year.
        @property monthNamesShort {string[]} The short names of the months of the year.
        @property dayNames {string[]} The long names of the days of the week.
        @property dayNamesShort {string[]} The short names of the days of the week.
        @property dayNamesMin {string[]} The minimal names of the days of the week.
        @property dateFormat {string} The date format for this calendar.
                See the options on <a href="BaseCalendar.html#formatDate"><code>formatDate</code></a> for details.
        @property firstDay {number} The number of the first day of the week, starting at 0.
        @property isRTL {number} <code>true</code> if this localisation reads right-to-left. */
    regionalOptions: { // Localisations
        '': {
            name: 'Julian',
            epochs: ['BC', 'AD'],
            monthNames: ['January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'],
            monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
            dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
            dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
            digits: null,
            dateFormat: 'mm/dd/yyyy',
            firstDay: 0,
            isRTL: false
        }
    },

    /** Determine whether this date is in a leap year.
        @memberof JulianCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not.
        @throws Error if an invalid year or a different calendar used. */
    leapYear: function(year) {
        var date = this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
        var year = (date.year() < 0 ? date.year() + 1 : date.year()); // No year zero
        return (year % 4) === 0;
    },

    /** Determine the week of the year for a date - ISO 8601.
        @memberof JulianCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @param [month] {number} The month to examine.
        @param [day] {number} The day to examine.
        @return {number} The week of the year.
        @throws Error if an invalid date or a different calendar used. */
    weekOfYear: function(year, month, day) {
        // Find Thursday of this week starting on Monday
        var checkDate = this.newDate(year, month, day);
        checkDate.add(4 - (checkDate.dayOfWeek() || 7), 'd');
        return Math.floor((checkDate.dayOfYear() - 1) / 7) + 1;
    },

    /** Retrieve the number of days in a month.
        @memberof JulianCalendar
        @param year {CDate|number} The date to examine or the year of the month.
        @param [month] {number} The month.
        @return {number} The number of days in this month.
        @throws Error if an invalid month/year or a different calendar used. */
    daysInMonth: function(year, month) {
        var date = this._validate(year, month, this.minDay, main.local.invalidMonth);
        return this.daysPerMonth[date.month() - 1] +
            (date.month() === 2 && this.leapYear(date.year()) ? 1 : 0);
    },

    /** Determine whether this date is a week day.
        @memberof JulianCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @param [month] {number} The month to examine.
        @param [day] {number} The day to examine.
        @return {boolean} True if a week day, false if not.
        @throws Error if an invalid date or a different calendar used. */
    weekDay: function(year, month, day) {
        return (this.dayOfWeek(year, month, day) || 7) < 6;
    },

    /** Retrieve the Julian date equivalent for this date,
        i.e. days since January 1, 4713 BCE Greenwich noon.
        @memberof JulianCalendar
        @param year {CDate|number} The date to convert or the year to convert.
        @param [month] {number} The month to convert.
        @param [day] {number} The day to convert.
        @return {number} The equivalent Julian date.
        @throws Error if an invalid date or a different calendar used. */
    toJD: function(year, month, day) {
        var date = this._validate(year, month, day, main.local.invalidDate);
        year = date.year();
        month = date.month();
        day = date.day();
        if (year < 0) { year++; } // No year zero
        // Jean Meeus algorithm, "Astronomical Algorithms", 1991
        if (month <= 2) {
            year--;
            month += 12;
        }
        return Math.floor(365.25 * (year + 4716)) +
            Math.floor(30.6001 * (month + 1)) + day - 1524.5;
    },

    /** Create a new date from a Julian date.
        @memberof JulianCalendar
        @param jd {number} The Julian date to convert.
        @return {CDate} The equivalent date. */
    fromJD: function(jd) {
        // Jean Meeus algorithm, "Astronomical Algorithms", 1991
        var a = Math.floor(jd + 0.5);
        var b = a + 1524;
        var c = Math.floor((b - 122.1) / 365.25);
        var d = Math.floor(365.25 * c);
        var e = Math.floor((b - d) / 30.6001);
        var month = e - Math.floor(e < 14 ? 1 : 13);
        var year = c - Math.floor(month > 2 ? 4716 : 4715);
        var day = b - d - Math.floor(30.6001 * e);
        if (year <= 0) { year--; } // No year zero
        return this.newDate(year, month, day);
    }
});

// Julian calendar implementation
main.calendars.julian = JulianCalendar;



/***/ }),

/***/ 62324:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

/*
 * World Calendars
 * https://github.com/alexcjohnson/world-calendars
 *
 * Batch-converted from kbwood/calendars
 * Many thanks to Keith Wood and all of the contributors to the original project!
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

﻿/* http://keith-wood.name/calendars.html
   Mayan calendar for jQuery v2.0.2.
   Written by Keith Wood (wood.keith{at}optusnet.com.au) August 2009.
   Available under the MIT (http://keith-wood.name/licence.html) license. 
   Please attribute the author if you use it. */

var main = __webpack_require__(24453);
var assign = __webpack_require__(27976);


/** Implementation of the Mayan Long Count calendar.
    See also <a href="http://en.wikipedia.org/wiki/Mayan_calendar">http://en.wikipedia.org/wiki/Mayan_calendar</a>.
    @class MayanCalendar
    @param [language=''] {string} The language code (default English) for localisation. */
function MayanCalendar(language) {
    this.local = this.regionalOptions[language || ''] || this.regionalOptions[''];
}

MayanCalendar.prototype = new main.baseCalendar;

assign(MayanCalendar.prototype, {
    /** The calendar name.
        @memberof MayanCalendar */
    name: 'Mayan',
    /** Julian date of start of Mayan epoch: 11 August 3114 BCE.
        @memberof MayanCalendar */
    jdEpoch: 584282.5,
    /** <code>true</code> if has a year zero, <code>false</code> if not.
        @memberof MayanCalendar */
    hasYearZero: true,
    /** The minimum month number.
        @memberof MayanCalendar */
    minMonth: 0,
    /** The first month in the year.
        @memberof MayanCalendar */
    firstMonth: 0,
    /** The minimum day number.
        @memberof MayanCalendar */
    minDay: 0,

    /** Localisations for the plugin.
        Entries are objects indexed by the language code ('' being the default US/English).
        Each object has the following attributes.
        @memberof MayanCalendar
        @property name {string} The calendar name.
        @property epochs {string[]} The epoch names.
        @property monthNames {string[]} The long names of the months of the year.
        @property monthNamesShort {string[]} The short names of the months of the year.
        @property dayNames {string[]} The long names of the days of the week.
        @property dayNamesShort {string[]} The short names of the days of the week.
        @property dayNamesMin {string[]} The minimal names of the days of the week.
        @property dateFormat {string} The date format for this calendar.
                See the options on <a href="BaseCalendar.html#formatDate"><code>formatDate</code></a> for details.
        @property firstDay {number} The number of the first day of the week, starting at 0.
        @property isRTL {number} <code>true</code> if this localisation reads right-to-left.
        @property haabMonths {string[]} The names of the Haab months.
        @property tzolkinMonths {string[]} The names of the Tzolkin months. */
    regionalOptions: { // Localisations
        '': {
            name: 'Mayan',
            epochs: ['', ''],
            monthNames: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
            '10', '11', '12', '13', '14', '15', '16', '17'],
            monthNamesShort: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
            '10', '11', '12', '13', '14', '15', '16', '17'],
            dayNames: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
            '10', '11', '12', '13', '14', '15', '16', '17', '18', '19'],
            dayNamesShort: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
            '10', '11', '12', '13', '14', '15', '16', '17', '18', '19'],
            dayNamesMin: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
            '10', '11', '12', '13', '14', '15', '16', '17', '18', '19'],
            digits: null,
            dateFormat: 'YYYY.m.d',
            firstDay: 0,
            isRTL: false,
            haabMonths: ['Pop', 'Uo', 'Zip', 'Zotz', 'Tzec', 'Xul', 'Yaxkin', 'Mol', 'Chen', 'Yax',
            'Zac', 'Ceh', 'Mac', 'Kankin', 'Muan', 'Pax', 'Kayab', 'Cumku', 'Uayeb'],
            tzolkinMonths: ['Imix', 'Ik', 'Akbal', 'Kan', 'Chicchan', 'Cimi', 'Manik', 'Lamat', 'Muluc', 'Oc',
            'Chuen', 'Eb', 'Ben', 'Ix', 'Men', 'Cib', 'Caban', 'Etznab', 'Cauac', 'Ahau']
        }
    },

    /** Determine whether this date is in a leap year.
        @memberof MayanCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not.
        @throws Error if an invalid year or a different calendar used. */
    leapYear: function(year) {
        this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
        return false;
    },

    /** Format the year, if not a simple sequential number.
        @memberof MayanCalendar
        @param year {CDate|number} The date to format or the year to format.
        @return {string} The formatted year.
        @throws Error if an invalid year or a different calendar used. */
    formatYear: function(year) {
        var date = this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
        year = date.year();
        var baktun = Math.floor(year / 400);
        year = year % 400;
        year += (year < 0 ? 400 : 0);
        var katun = Math.floor(year / 20);
        return baktun + '.' + katun + '.' + (year % 20);
    },

    /** Convert from the formatted year back to a single number.
        @memberof MayanCalendar
        @param years {string} The year as n.n.n.
        @return {number} The sequential year.
        @throws Error if an invalid value is supplied. */
    forYear: function(years) {
        years = years.split('.');
        if (years.length < 3) {
            throw 'Invalid Mayan year';
        }
        var year = 0;
        for (var i = 0; i < years.length; i++) {
            var y = parseInt(years[i], 10);
            if (Math.abs(y) > 19 || (i > 0 && y < 0)) {
                throw 'Invalid Mayan year';
            }
            year = year * 20 + y;
        }
        return year;
    },

    /** Retrieve the number of months in a year.
        @memberof MayanCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @return {number} The number of months.
        @throws Error if an invalid year or a different calendar used. */
    monthsInYear: function(year) {
        this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
        return 18;
    },

    /** Determine the week of the year for a date.
        @memberof MayanCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @param [month] {number} The month to examine.
        @param [day] {number} The day to examine.
        @return {number} The week of the year.
        @throws Error if an invalid date or a different calendar used. */
    weekOfYear: function(year, month, day) {
        this._validate(year, month, day, main.local.invalidDate);
        return 0;
    },

    /** Retrieve the number of days in a year.
        @memberof MayanCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @return {number} The number of days.
        @throws Error if an invalid year or a different calendar used. */
    daysInYear: function(year) {
        this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
        return 360;
    },

    /** Retrieve the number of days in a month.
        @memberof MayanCalendar
        @param year {CDate|number} The date to examine or the year of the month.
        @param [month] {number} The month.
        @return {number} The number of days in this month.
        @throws Error if an invalid month/year or a different calendar used. */
    daysInMonth: function(year, month) {
        this._validate(year, month, this.minDay, main.local.invalidMonth);
        return 20;
    },

    /** Retrieve the number of days in a week.
        @memberof MayanCalendar
        @return {number} The number of days. */
    daysInWeek: function() {
        return 5; // Just for formatting
    },

    /** Retrieve the day of the week for a date.
        @memberof MayanCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @param [month] {number} The month to examine.
        @param [day] {number} The day to examine.
        @return {number} The day of the week: 0 to number of days - 1.
        @throws Error if an invalid date or a different calendar used. */
    dayOfWeek: function(year, month, day) {
        var date = this._validate(year, month, day, main.local.invalidDate);
        return date.day();
    },

    /** Determine whether this date is a week day.
        @memberof MayanCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @param [month] {number} The month to examine.
        @param [day] {number} The day to examine.
        @return {boolean} <code>true</code> if a week day, <code>false</code> if not.
        @throws Error if an invalid date or a different calendar used. */
    weekDay: function(year, month, day) {
        this._validate(year, month, day, main.local.invalidDate);
        return true;
    },

    /** Retrieve additional information about a date - Haab and Tzolkin equivalents.
        @memberof MayanCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @param [month] {number} The month to examine.
        @param [day] {number} The day to examine.
        @return {object} Additional information - contents depends on calendar.
        @throws Error if an invalid date or a different calendar used. */
    extraInfo: function(year, month, day) {
        var date = this._validate(year, month, day, main.local.invalidDate);
        var jd = date.toJD();
        var haab = this._toHaab(jd);
        var tzolkin = this._toTzolkin(jd);
        return {haabMonthName: this.local.haabMonths[haab[0] - 1],
            haabMonth: haab[0], haabDay: haab[1],
            tzolkinDayName: this.local.tzolkinMonths[tzolkin[0] - 1],
            tzolkinDay: tzolkin[0], tzolkinTrecena: tzolkin[1]};
    },

    /** Retrieve Haab date from a Julian date.
        @memberof MayanCalendar
        @private
        @param jd  {number} The Julian date.
        @return {number[]} Corresponding Haab month and day. */
    _toHaab: function(jd) {
        jd -= this.jdEpoch;
        var day = mod(jd + 8 + ((18 - 1) * 20), 365);
        return [Math.floor(day / 20) + 1, mod(day, 20)];
    },

    /** Retrieve Tzolkin date from a Julian date.
        @memberof MayanCalendar
        @private
        @param jd {number} The Julian date.
        @return {number[]} Corresponding Tzolkin day and trecena. */
    _toTzolkin: function(jd) {
        jd -= this.jdEpoch;
        return [amod(jd + 20, 20), amod(jd + 4, 13)];
    },

    /** Retrieve the Julian date equivalent for this date,
        i.e. days since January 1, 4713 BCE Greenwich noon.
        @memberof MayanCalendar
        @param year {CDate|number} The date to convert or the year to convert.
        @param [month] {number} The month to convert.
        @param [day] {number} The day to convert.
        @return {number} The equivalent Julian date.
        @throws Error if an invalid date or a different calendar used. */
    toJD: function(year, month, day) {
        var date = this._validate(year, month, day, main.local.invalidDate);
        return date.day() + (date.month() * 20) + (date.year() * 360) + this.jdEpoch;
    },

    /** Create a new date from a Julian date.
        @memberof MayanCalendar
        @param jd {number} The Julian date to convert.
        @return {CDate} The equivalent date. */
    fromJD: function(jd) {
        jd = Math.floor(jd) + 0.5 - this.jdEpoch;
        var year = Math.floor(jd / 360);
        jd = jd % 360;
        jd += (jd < 0 ? 360 : 0);
        var month = Math.floor(jd / 20);
        var day = jd % 20;
        return this.newDate(year, month, day);
    }
});

// Modulus function which works for non-integers.
function mod(a, b) {
    return a - (b * Math.floor(a / b));
}

// Modulus function which returns numerator if modulus is zero.
function amod(a, b) {
    return mod(a - 1, b) + 1;
}

// Mayan calendar implementation
main.calendars.mayan = MayanCalendar;



/***/ }),

/***/ 91662:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

/*
 * World Calendars
 * https://github.com/alexcjohnson/world-calendars
 *
 * Batch-converted from kbwood/calendars
 * Many thanks to Keith Wood and all of the contributors to the original project!
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/* http://keith-wood.name/calendars.html
   Nanakshahi calendar for jQuery v2.0.2.
   Written by Keith Wood (wood.keith{at}optusnet.com.au) January 2016.
   Available under the MIT (http://keith-wood.name/licence.html) license. 
   Please attribute the author if you use it. */

var main = __webpack_require__(24453);
var assign = __webpack_require__(27976);


/** Implementation of the Nanakshahi calendar.
    See also <a href="https://en.wikipedia.org/wiki/Nanakshahi_calendar">https://en.wikipedia.org/wiki/Nanakshahi_calendar</a>.
    @class NanakshahiCalendar
    @param [language=''] {string} The language code (default English) for localisation. */
function NanakshahiCalendar(language) {
    this.local = this.regionalOptions[language || ''] || this.regionalOptions[''];
}

NanakshahiCalendar.prototype = new main.baseCalendar;

var gregorian = main.instance('gregorian');

assign(NanakshahiCalendar.prototype, {
    /** The calendar name.
        @memberof NanakshahiCalendar */
    name: 'Nanakshahi',
    /** Julian date of start of Nanakshahi epoch: 14 March 1469 CE.
        @memberof NanakshahiCalendar */
    jdEpoch: 2257673.5,
    /** Days per month in a common year.
        @memberof NanakshahiCalendar */
    daysPerMonth: [31, 31, 31, 31, 31, 30, 30, 30, 30, 30, 30, 30],
    /** <code>true</code> if has a year zero, <code>false</code> if not.
        @memberof NanakshahiCalendar */
    hasYearZero: false,
    /** The minimum month number.
        @memberof NanakshahiCalendar */
    minMonth: 1,
    /** The first month in the year.
        @memberof NanakshahiCalendar */
    firstMonth: 1,
    /** The minimum day number.
        @memberof NanakshahiCalendar */
    minDay: 1,

    /** Localisations for the plugin.
        Entries are objects indexed by the language code ('' being the default US/English).
        Each object has the following attributes.
        @memberof NanakshahiCalendar
        @property name {string} The calendar name.
        @property epochs {string[]} The epoch names.
        @property monthNames {string[]} The long names of the months of the year.
        @property monthNamesShort {string[]} The short names of the months of the year.
        @property dayNames {string[]} The long names of the days of the week.
        @property dayNamesShort {string[]} The short names of the days of the week.
        @property dayNamesMin {string[]} The minimal names of the days of the week.
        @property dateFormat {string} The date format for this calendar.
                See the options on <a href="BaseCalendar.html#formatDate"><code>formatDate</code></a> for details.
        @property firstDay {number} The number of the first day of the week, starting at 0.
        @property isRTL {number} <code>true</code> if this localisation reads right-to-left. */
    regionalOptions: { // Localisations
        '': {
            name: 'Nanakshahi',
            epochs: ['BN', 'AN'],
            monthNames: ['Chet', 'Vaisakh', 'Jeth', 'Harh', 'Sawan', 'Bhadon',
            'Assu', 'Katak', 'Maghar', 'Poh', 'Magh', 'Phagun'],
            monthNamesShort: ['Che', 'Vai', 'Jet', 'Har', 'Saw', 'Bha', 'Ass', 'Kat', 'Mgr', 'Poh', 'Mgh', 'Pha'],
            dayNames: ['Somvaar', 'Mangalvar', 'Budhvaar', 'Veervaar', 'Shukarvaar', 'Sanicharvaar', 'Etvaar'],
            dayNamesShort: ['Som', 'Mangal', 'Budh', 'Veer', 'Shukar', 'Sanichar', 'Et'],
            dayNamesMin: ['So', 'Ma', 'Bu', 'Ve', 'Sh', 'Sa', 'Et'],
            digits: null,
            dateFormat: 'dd-mm-yyyy',
            firstDay: 0,
            isRTL: false
        }
    },

    /** Determine whether this date is in a leap year.
        @memberof NanakshahiCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not.
        @throws Error if an invalid year or a different calendar used. */
    leapYear: function(year) {
        var date = this._validate(year, this.minMonth, this.minDay,
            main.local.invalidYear || main.regionalOptions[''].invalidYear);
        return gregorian.leapYear(date.year() + (date.year() < 1 ? 1 : 0) + 1469);
    },

    /** Determine the week of the year for a date.
        @memberof NanakshahiCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @param [month] {number} The month to examine.
        @param [day] {number} The day to examine.
        @return {number} The week of the year.
        @throws Error if an invalid date or a different calendar used. */
    weekOfYear: function(year, month, day) {
        // Find Monday of this week starting on Monday
        var checkDate = this.newDate(year, month, day);
        checkDate.add(1 - (checkDate.dayOfWeek() || 7), 'd');
        return Math.floor((checkDate.dayOfYear() - 1) / 7) + 1;
    },

    /** Retrieve the number of days in a month.
        @memberof NanakshahiCalendar
        @param year {CDate|number} The date to examine or the year of the month.
        @param [month] {number} The month.
        @return {number} The number of days in this month.
        @throws Error if an invalid month/year or a different calendar used. */
    daysInMonth: function(year, month) {
        var date = this._validate(year, month, this.minDay, main.local.invalidMonth);
        return this.daysPerMonth[date.month() - 1] +
            (date.month() === 12 && this.leapYear(date.year()) ? 1 : 0);
    },

    /** Determine whether this date is a week day.
        @memberof NanakshahiCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @param [month] {number} The month to examine.
        @param [day] {number} The day to examine.
        @return {boolean} <code>true</code> if a week day, <code>false</code> if not.
        @throws Error if an invalid date or a different calendar used. */
    weekDay: function(year, month, day) {
        return (this.dayOfWeek(year, month, day) || 7) < 6;
    },

    /** Retrieve the Julian date equivalent for this date,
        i.e. days since January 1, 4713 BCE Greenwich noon.
        @memberof NanakshahiCalendar
        @param year {CDate|number} The date to convert or the year to convert.
        @param [month] {number} The month to convert.
        @param [day] {number} The day to convert.
        @return {number} The equivalent Julian date.
        @throws Error if an invalid date or a different calendar used. */
    toJD: function(year, month, day) {
        var date = this._validate(year, month, day, main.local.invalidMonth);
        var year = date.year();
        if (year < 0) { year++; } // No year zero
        var doy = date.day();
        for (var m = 1; m < date.month(); m++) {
            doy += this.daysPerMonth[m - 1];
        }
        return doy + gregorian.toJD(year + 1468, 3, 13);
    },

    /** Create a new date from a Julian date.
        @memberof NanakshahiCalendar
        @param jd {number} The Julian date to convert.
        @return {CDate} The equivalent date. */
    fromJD: function(jd) {
        jd = Math.floor(jd + 0.5);
        var year = Math.floor((jd - (this.jdEpoch - 1)) / 366);
        while (jd >= this.toJD(year + 1, 1, 1)) {
            year++;
        }
        var day = jd - Math.floor(this.toJD(year, 1, 1) + 0.5) + 1;
        var month = 1;
        while (day > this.daysInMonth(year, month)) {
            day -= this.daysInMonth(year, month);
            month++;
        }
        return this.newDate(year, month, day);
    }
});

// Nanakshahi calendar implementation
main.calendars.nanakshahi = NanakshahiCalendar;



/***/ }),

/***/ 66445:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

/*
 * World Calendars
 * https://github.com/alexcjohnson/world-calendars
 *
 * Batch-converted from kbwood/calendars
 * Many thanks to Keith Wood and all of the contributors to the original project!
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

﻿/* http://keith-wood.name/calendars.html
   Nepali calendar for jQuery v2.0.2.
   Written by Artur Neumann (ict.projects{at}nepal.inf.org) April 2013.
   Available under the MIT (http://keith-wood.name/licence.html) license. 
   Please attribute the author if you use it. */

var main = __webpack_require__(24453);
var assign = __webpack_require__(27976);


/** Implementation of the Nepali civil calendar.
    Based on the ideas from 
    <a href="http://codeissue.com/articles/a04e050dea7468f/algorithm-to-convert-english-date-to-nepali-date-using-c-net">http://codeissue.com/articles/a04e050dea7468f/algorithm-to-convert-english-date-to-nepali-date-using-c-net</a>
    and <a href="http://birenj2ee.blogspot.com/2011/04/nepali-calendar-in-java.html">http://birenj2ee.blogspot.com/2011/04/nepali-calendar-in-java.html</a>
    See also <a href="http://en.wikipedia.org/wiki/Nepali_calendar">http://en.wikipedia.org/wiki/Nepali_calendar</a>
    and <a href="https://en.wikipedia.org/wiki/Bikram_Samwat">https://en.wikipedia.org/wiki/Bikram_Samwat</a>.
    @class NepaliCalendar
    @param [language=''] {string} The language code (default English) for localisation. */
function NepaliCalendar(language) {
    this.local = this.regionalOptions[language || ''] || this.regionalOptions[''];
}

NepaliCalendar.prototype = new main.baseCalendar;

assign(NepaliCalendar.prototype, {
    /** The calendar name.
        @memberof NepaliCalendar */
    name: 'Nepali',
    /** Julian date of start of Nepali epoch: 14 April 57 BCE.
        @memberof NepaliCalendar */
    jdEpoch: 1700709.5,
    /** Days per month in a common year.
        @memberof NepaliCalendar */
    daysPerMonth: [31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
    /** <code>true</code> if has a year zero, <code>false</code> if not.
        @memberof NepaliCalendar */
    hasYearZero: false,
    /** The minimum month number.
        @memberof NepaliCalendar */
    minMonth: 1,
    /** The first month in the year.
        @memberof NepaliCalendar */
    firstMonth: 1,
    /** The minimum day number.
        @memberof NepaliCalendar */
    minDay: 1, 
    /** The number of days in the year.
        @memberof NepaliCalendar */
    daysPerYear: 365,

    /** Localisations for the plugin.
        Entries are objects indexed by the language code ('' being the default US/English).
        Each object has the following attributes.
        @memberof NepaliCalendar
        @property name {string} The calendar name.
        @property epochs {string[]} The epoch names.
        @property monthNames {string[]} The long names of the months of the year.
        @property monthNamesShort {string[]} The short names of the months of the year.
        @property dayNames {string[]} The long names of the days of the week.
        @property dayNamesShort {string[]} The short names of the days of the week.
        @property dayNamesMin {string[]} The minimal names of the days of the week.
        @property dateFormat {string} The date format for this calendar.
                See the options on <a href="BaseCalendar.html#formatDate"><code>formatDate</code></a> for details.
        @property firstDay {number} The number of the first day of the week, starting at 0.
        @property isRTL {number} <code>true</code> if this localisation reads right-to-left. */
    regionalOptions: { // Localisations
        '': {
            name: 'Nepali',
            epochs: ['BBS', 'ABS'],
            monthNames: ['Baisakh', 'Jestha', 'Ashadh', 'Shrawan', 'Bhadra', 'Ashwin',
            'Kartik', 'Mangsir', 'Paush', 'Mangh', 'Falgun', 'Chaitra'],
            monthNamesShort: ['Bai', 'Je', 'As', 'Shra', 'Bha', 'Ash', 'Kar', 'Mang', 'Pau', 'Ma', 'Fal', 'Chai'],
            dayNames: ['Aaitabaar', 'Sombaar', 'Manglbaar', 'Budhabaar', 'Bihibaar', 'Shukrabaar', 'Shanibaar'],
            dayNamesShort: ['Aaita', 'Som', 'Mangl', 'Budha', 'Bihi', 'Shukra', 'Shani'],
            dayNamesMin: ['Aai', 'So', 'Man', 'Bu', 'Bi', 'Shu', 'Sha'],
            digits: null,
            dateFormat: 'dd/mm/yyyy',
            firstDay: 1,
            isRTL: false
        }
    },

    /** Determine whether this date is in a leap year.
        @memberof NepaliCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not.
        @throws Error if an invalid year or a different calendar used. */
    leapYear: function(year) {
        return this.daysInYear(year) !== this.daysPerYear;
    },

    /** Determine the week of the year for a date.
        @memberof NepaliCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @param [month] {number} The month to examine.
        @param [day] {number} The day to examine.
        @return {number} The week of the year.
        @throws Error if an invalid date or a different calendar used. */
    weekOfYear: function(year, month, day) {
        // Find Sunday of this week starting on Sunday
        var checkDate = this.newDate(year, month, day);
        checkDate.add(-checkDate.dayOfWeek(), 'd');
        return Math.floor((checkDate.dayOfYear() - 1) / 7) + 1;
    },

    /** Retrieve the number of days in a year.
        @memberof NepaliCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @return {number} The number of days.
        @throws Error if an invalid year or a different calendar used. */
    daysInYear: function(year) {
        var date = this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
        year = date.year();
        if (typeof this.NEPALI_CALENDAR_DATA[year] === 'undefined') {
            return this.daysPerYear;
        }
        var daysPerYear = 0;
        for (var month_number = this.minMonth; month_number <= 12; month_number++) {
            daysPerYear += this.NEPALI_CALENDAR_DATA[year][month_number];
        }
        return daysPerYear;
    },

    /** Retrieve the number of days in a month.
        @memberof NepaliCalendar
        @param year {CDate|number| The date to examine or the year of the month.
        @param [month] {number} The month.
        @return {number} The number of days in this month.
        @throws Error if an invalid month/year or a different calendar used. */
    daysInMonth: function(year, month) {
        if (year.year) {
            month = year.month();
            year = year.year();
        }
        this._validate(year, month, this.minDay, main.local.invalidMonth);
        return (typeof this.NEPALI_CALENDAR_DATA[year] === 'undefined' ?
            this.daysPerMonth[month - 1] : this.NEPALI_CALENDAR_DATA[year][month]);
    },

    /** Determine whether this date is a week day.
        @memberof NepaliCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @param [month] {number} The month to examine.
        @param [day] {number} The day to examine.
        @return {boolean} <code>true</code> if a week day, <code>false</code> if not.
        @throws Error if an invalid date or a different calendar used. */
    weekDay: function(year, month, day) {
        return this.dayOfWeek(year, month, day) !== 6;
    },

    /** Retrieve the Julian date equivalent for this date,
        i.e. days since January 1, 4713 BCE Greenwich noon.
        @memberof NepaliCalendar
        @param year {CDate|number} The date to convert or the year to convert.
        @param [month] {number} The month to convert.
        @param [day] {number} The day to convert.
        @return {number} The equivalent Julian date.
        @throws Error if an invalid date or a different calendar used. */
    toJD: function(nepaliYear, nepaliMonth, nepaliDay) {
        var date = this._validate(nepaliYear, nepaliMonth, nepaliDay, main.local.invalidDate);
        nepaliYear = date.year();
        nepaliMonth = date.month();
        nepaliDay = date.day();
        var gregorianCalendar = main.instance();
        var gregorianDayOfYear = 0; // We will add all the days that went by since
        // the 1st. January and then we can get the Gregorian Date
        var nepaliMonthToCheck = nepaliMonth;
        var nepaliYearToCheck = nepaliYear;
        this._createMissingCalendarData(nepaliYear);
        // Get the correct year
        var gregorianYear = nepaliYear - (nepaliMonthToCheck > 9 || (nepaliMonthToCheck === 9 &&
            nepaliDay >= this.NEPALI_CALENDAR_DATA[nepaliYearToCheck][0]) ? 56 : 57);
        // First we add the amount of days in the actual Nepali month as the day of year in the
        // Gregorian one because at least this days are gone since the 1st. Jan. 
        if (nepaliMonth !== 9) {
            gregorianDayOfYear = nepaliDay;
            nepaliMonthToCheck--;
        }
        // Now we loop throw all Nepali month and add the amount of days to gregorianDayOfYear 
        // we do this till we reach Paush (9th month). 1st. January always falls in this month  
        while (nepaliMonthToCheck !== 9) {
            if (nepaliMonthToCheck <= 0) {
                nepaliMonthToCheck = 12;
                nepaliYearToCheck--;
            }                
            gregorianDayOfYear += this.NEPALI_CALENDAR_DATA[nepaliYearToCheck][nepaliMonthToCheck];
            nepaliMonthToCheck--;
        }        
        // If the date that has to be converted is in Paush (month no. 9) we have to do some other calculation
        if (nepaliMonth === 9) {
            // Add the days that are passed since the first day of Paush and substract the
            // amount of days that lie between 1st. Jan and 1st Paush
            gregorianDayOfYear += nepaliDay - this.NEPALI_CALENDAR_DATA[nepaliYearToCheck][0];
            // For the first days of Paush we are now in negative values,
            // because in the end of the gregorian year we substract
            // 365 / 366 days (P.S. remember math in school + - gives -)
            if (gregorianDayOfYear < 0) {
                gregorianDayOfYear += gregorianCalendar.daysInYear(gregorianYear);
            }
        }
        else {
            gregorianDayOfYear += this.NEPALI_CALENDAR_DATA[nepaliYearToCheck][9] -
                this.NEPALI_CALENDAR_DATA[nepaliYearToCheck][0];
        }        
        return gregorianCalendar.newDate(gregorianYear, 1 ,1).add(gregorianDayOfYear, 'd').toJD();
    },
    
    /** Create a new date from a Julian date.
        @memberof NepaliCalendar
        @param jd {number} The Julian date to convert.
        @return {CDate} The equivalent date. */
    fromJD: function(jd) {
        var gregorianCalendar =  main.instance();
        var gregorianDate = gregorianCalendar.fromJD(jd);
        var gregorianYear = gregorianDate.year();
        var gregorianDayOfYear = gregorianDate.dayOfYear();
        var nepaliYear = gregorianYear + 56; //this is not final, it could be also +57 but +56 is always true for 1st Jan.
        this._createMissingCalendarData(nepaliYear);
        var nepaliMonth = 9; // Jan 1 always fall in Nepali month Paush which is the 9th month of Nepali calendar.
        // Get the Nepali day in Paush (month 9) of 1st January 
        var dayOfFirstJanInPaush = this.NEPALI_CALENDAR_DATA[nepaliYear][0];
        // Check how many days are left of Paush .
        // Days calculated from 1st Jan till the end of the actual Nepali month, 
        // we use this value to check if the gregorian Date is in the actual Nepali month.
        var daysSinceJanFirstToEndOfNepaliMonth =
            this.NEPALI_CALENDAR_DATA[nepaliYear][nepaliMonth] - dayOfFirstJanInPaush + 1;
        // If the gregorian day-of-year is smaller o equal than the sum of days between the 1st January and 
        // the end of the actual nepali month we found the correct nepali month.
        // Example: 
        // The 4th February 2011 is the gregorianDayOfYear 35 (31 days of January + 4)
        // 1st January 2011 is in the nepali year 2067, where 1st. January is in the 17th day of Paush (9th month)
        // In 2067 Paush has 30days, This means (30-17+1=14) there are 14days between 1st January and end of Paush 
        // (including 17th January)
        // The gregorianDayOfYear (35) is bigger than 14, so we check the next month
        // The next nepali month (Mangh) has 29 days 
        // 29+14=43, this is bigger than gregorianDayOfYear(35) so, we found the correct nepali month
        while (gregorianDayOfYear > daysSinceJanFirstToEndOfNepaliMonth) {
            nepaliMonth++;
            if (nepaliMonth > 12) {
                nepaliMonth = 1;
                nepaliYear++;
            }    
            daysSinceJanFirstToEndOfNepaliMonth += this.NEPALI_CALENDAR_DATA[nepaliYear][nepaliMonth];
        }
        // The last step is to calculate the nepali day-of-month
        // to continue our example from before:
        // we calculated there are 43 days from 1st. January (17 Paush) till end of Mangh (29 days)
        // when we subtract from this 43 days the day-of-year of the the Gregorian date (35),
        // we know how far the searched day is away from the end of the Nepali month.
        // So we simply subtract this number from the amount of days in this month (30) 
        var nepaliDayOfMonth = this.NEPALI_CALENDAR_DATA[nepaliYear][nepaliMonth] -
            (daysSinceJanFirstToEndOfNepaliMonth - gregorianDayOfYear);        
        return this.newDate(nepaliYear, nepaliMonth, nepaliDayOfMonth);
    },
    
    /** Creates missing data in the NEPALI_CALENDAR_DATA table.
        This data will not be correct but just give an estimated result. Mostly -/+ 1 day
        @private
        @param nepaliYear {number} The missing year number. */
    _createMissingCalendarData: function(nepaliYear) {
        var tmp_calendar_data = this.daysPerMonth.slice(0);
        tmp_calendar_data.unshift(17);
        for (var nepaliYearToCreate = (nepaliYear - 1); nepaliYearToCreate < (nepaliYear + 2); nepaliYearToCreate++) {
            if (typeof this.NEPALI_CALENDAR_DATA[nepaliYearToCreate] === 'undefined') {
                this.NEPALI_CALENDAR_DATA[nepaliYearToCreate] = tmp_calendar_data;
            }
        }
    },
    
    NEPALI_CALENDAR_DATA:  {
        // These data are from http://www.ashesh.com.np
        1970: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
        1971: [18, 31, 31, 32, 31, 32, 30, 30, 29, 30, 29, 30, 30],
        1972: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
        1973: [19, 30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
        1974: [19, 31, 31, 32, 30, 31, 31, 30, 29, 30, 29, 30, 30],
        1975: [18, 31, 31, 32, 32, 30, 31, 30, 29, 30, 29, 30, 30],
        1976: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
        1977: [18, 31, 32, 31, 32, 31, 31, 29, 30, 29, 30, 29, 31],
        1978: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
        1979: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
        1980: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
        1981: [18, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
        1982: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
        1983: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
        1984: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
        1985: [18, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
        1986: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
        1987: [18, 31, 32, 31, 32, 31, 30, 30, 29, 30, 29, 30, 30],
        1988: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
        1989: [18, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
        1990: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
        1991: [18, 31, 32, 31, 32, 31, 30, 30, 29, 30, 29, 30, 30],    
        // These data are from http://nepalicalendar.rat32.com/index.php
        1992: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
        1993: [18, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
        1994: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
        1995: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
        1996: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
        1997: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
        1998: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
        1999: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
        2000: [17, 30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
        2001: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
        2002: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
        2003: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
        2004: [17, 30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
        2005: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
        2006: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
        2007: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
        2008: [17, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 29, 31],
        2009: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
        2010: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
        2011: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
        2012: [17, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
        2013: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
        2014: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
        2015: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
        2016: [17, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
        2017: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
        2018: [18, 31, 32, 31, 32, 31, 30, 30, 29, 30, 29, 30, 30],
        2019: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
        2020: [17, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
        2021: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
        2022: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
        2023: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
        2024: [17, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
        2025: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
        2026: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
        2027: [17, 30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
        2028: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
        2029: [18, 31, 31, 32, 31, 32, 30, 30, 29, 30, 29, 30, 30],
        2030: [17, 31, 32, 31, 32, 31, 30, 30, 30, 30, 30, 30, 31],
        2031: [17, 31, 32, 31, 32, 31, 31, 31, 31, 31, 31, 31, 31],
        2032: [17, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32],
        2033: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
        2034: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
        2035: [17, 30, 32, 31, 32, 31, 31, 29, 30, 30, 29, 29, 31],
        2036: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
        2037: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
        2038: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
        2039: [17, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
        2040: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
        2041: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
        2042: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
        2043: [17, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
        2044: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
        2045: [18, 31, 32, 31, 32, 31, 30, 30, 29, 30, 29, 30, 30],
        2046: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
        2047: [17, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
        2048: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
        2049: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
        2050: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
        2051: [17, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
        2052: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
        2053: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
        2054: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
        2055: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 30, 29, 30],
        2056: [17, 31, 31, 32, 31, 32, 30, 30, 29, 30, 29, 30, 30],
        2057: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
        2058: [17, 30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
        2059: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
        2060: [17, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
        2061: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
        2062: [17, 30, 32, 31, 32, 31, 31, 29, 30, 29, 30, 29, 31],
        2063: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
        2064: [17, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
        2065: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
        2066: [17, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 29, 31],
        2067: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
        2068: [17, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
        2069: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
        2070: [17, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
        2071: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
        2072: [17, 31, 32, 31, 32, 31, 30, 30, 29, 30, 29, 30, 30],
        2073: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
        2074: [17, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
        2075: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
        2076: [16, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
        2077: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
        2078: [17, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
        2079: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
        2080: [16, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
        // These data are from http://www.ashesh.com.np/nepali-calendar/
        2081: [17, 31, 31, 32, 32, 31, 30, 30, 30, 29, 30, 30, 30],
        2082: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
        2083: [17, 31, 31, 32, 31, 31, 30, 30, 30, 29, 30, 30, 30],
        2084: [17, 31, 31, 32, 31, 31, 30, 30, 30, 29, 30, 30, 30],
        2085: [17, 31, 32, 31, 32, 31, 31, 30, 30, 29, 30, 30, 30],
        2086: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
        2087: [16, 31, 31, 32, 31, 31, 31, 30, 30, 29, 30, 30, 30],
        2088: [16, 30, 31, 32, 32, 30, 31, 30, 30, 29, 30, 30, 30],
        2089: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
        2090: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
        2091: [16, 31, 31, 32, 31, 31, 31, 30, 30, 29, 30, 30, 30],
        2092: [16, 31, 31, 32, 32, 31, 30, 30, 30, 29, 30, 30, 30],
        2093: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
        2094: [17, 31, 31, 32, 31, 31, 30, 30, 30, 29, 30, 30, 30],
        2095: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 30, 30, 30],
        2096: [17, 30, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
        2097: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
        2098: [17, 31, 31, 32, 31, 31, 31, 29, 30, 29, 30, 30, 31],
        2099: [17, 31, 31, 32, 31, 31, 31, 30, 29, 29, 30, 30, 30],
        2100: [17, 31, 32, 31, 32, 30, 31, 30, 29, 30, 29, 30, 30]    
    }
});    

// Nepali calendar implementation
main.calendars.nepali = NepaliCalendar;



/***/ }),

/***/ 50506:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

/*
 * World Calendars
 * https://github.com/alexcjohnson/world-calendars
 *
 * Batch-converted from kbwood/calendars
 * Many thanks to Keith Wood and all of the contributors to the original project!
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

﻿/* http://keith-wood.name/calendars.html
   Persian calendar for jQuery v2.0.2.
   Written by Keith Wood (wood.keith{at}optusnet.com.au) August 2009.
   Available under the MIT (http://keith-wood.name/licence.html) license. 
   Please attribute the author if you use it. */

var main = __webpack_require__(24453);
var assign = __webpack_require__(27976);


/** Implementation of the Persian or Jalali calendar.
    Based on code from <a href="http://www.iranchamber.com/calendar/converter/iranian_calendar_converter.php">http://www.iranchamber.com/calendar/converter/iranian_calendar_converter.php</a>.
    See also <a href="http://en.wikipedia.org/wiki/Iranian_calendar">http://en.wikipedia.org/wiki/Iranian_calendar</a>.
    @class PersianCalendar
    @param [language=''] {string} The language code (default English) for localisation. */
function PersianCalendar(language) {
    this.local = this.regionalOptions[language || ''] || this.regionalOptions[''];
}

PersianCalendar.prototype = new main.baseCalendar;

assign(PersianCalendar.prototype, {
    /** The calendar name.
        @memberof PersianCalendar */
    name: 'Persian',
    /** Julian date of start of Persian epoch: 19 March 622 CE.
        @memberof PersianCalendar */
    jdEpoch: 1948320.5,
    /** Days per month in a common year.
        @memberof PersianCalendar */
    daysPerMonth: [31, 31, 31, 31, 31, 31, 30, 30, 30, 30, 30, 29],
    /** <code>true</code> if has a year zero, <code>false</code> if not.
        @memberof PersianCalendar */
    hasYearZero: false,
    /** The minimum month number.
        @memberof PersianCalendar */
    minMonth: 1,
    /** The first month in the year.
        @memberof PersianCalendar */
    firstMonth: 1,
    /** The minimum day number.
        @memberof PersianCalendar */
    minDay: 1,

    /** Localisations for the plugin.
        Entries are objects indexed by the language code ('' being the default US/English).
        Each object has the following attributes.
        @memberof PersianCalendar
        @property name {string} The calendar name.
        @property epochs {string[]} The epoch names.
        @property monthNames {string[]} The long names of the months of the year.
        @property monthNamesShort {string[]} The short names of the months of the year.
        @property dayNames {string[]} The long names of the days of the week.
        @property dayNamesShort {string[]} The short names of the days of the week.
        @property dayNamesMin {string[]} The minimal names of the days of the week.
        @property dateFormat {string} The date format for this calendar.
                See the options on <a href="BaseCalendar.html#formatDate"><code>formatDate</code></a> for details.
        @property firstDay {number} The number of the first day of the week, starting at 0.
        @property isRTL {number} <code>true</code> if this localisation reads right-to-left. */
    regionalOptions: { // Localisations
        '': {
            name: 'Persian',
            epochs: ['BP', 'AP'],
            monthNames: ['Farvardin', 'Ordibehesht', 'Khordad', 'Tir', 'Mordad', 'Shahrivar',
            'Mehr', 'Aban', 'Azar', 'Day', 'Bahman', 'Esfand'],
            monthNamesShort: ['Far', 'Ord', 'Kho', 'Tir', 'Mor', 'Sha', 'Meh', 'Aba', 'Aza', 'Day', 'Bah', 'Esf'],
            dayNames: ['Yekshambe', 'Doshambe', 'Seshambe', 'Chæharshambe', 'Panjshambe', 'Jom\'e', 'Shambe'],
            dayNamesShort: ['Yek', 'Do', 'Se', 'Chæ', 'Panj', 'Jom', 'Sha'],
            dayNamesMin: ['Ye','Do','Se','Ch','Pa','Jo','Sh'],
            digits: null,
            dateFormat: 'yyyy/mm/dd',
            firstDay: 6,
            isRTL: false
        }
    },

    /** Determine whether this date is in a leap year.
        @memberof PersianCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not.
        @throws Error if an invalid year or a different calendar used. */
    leapYear: function(year) {
        var date = this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
        return (((((date.year() - (date.year() > 0 ? 474 : 473)) % 2820) +
            474 + 38) * 682) % 2816) < 682;
    },

    /** Determine the week of the year for a date.
        @memberof PersianCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @param [month] {number} The month to examine.
        @param [day] {number} The day to examine.
        @return {number} The week of the year.
        @throws Error if an invalid date or a different calendar used. */
    weekOfYear: function(year, month, day) {
        // Find Saturday of this week starting on Saturday
        var checkDate = this.newDate(year, month, day);
        checkDate.add(-((checkDate.dayOfWeek() + 1) % 7), 'd');
        return Math.floor((checkDate.dayOfYear() - 1) / 7) + 1;
    },

    /** Retrieve the number of days in a month.
        @memberof PersianCalendar
        @param year {CDate|number} The date to examine or the year of the month.
        @param [month] {number} The month.
        @return {number} The number of days in this month.
        @throws Error if an invalid month/year or a different calendar used. */
    daysInMonth: function(year, month) {
        var date = this._validate(year, month, this.minDay, main.local.invalidMonth);
        return this.daysPerMonth[date.month() - 1] +
            (date.month() === 12 && this.leapYear(date.year()) ? 1 : 0);
    },

    /** Determine whether this date is a week day.
        @memberof PersianCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @param [month] {number} The month to examine.
        @param [day] {number} The day to examine.
        @return {boolean} <code>true</code> if a week day, <code>false</code> if not.
        @throws Error if an invalid date or a different calendar used. */
    weekDay: function(year, month, day) {
        return this.dayOfWeek(year, month, day) !== 5;
    },

    /** Retrieve the Julian date equivalent for this date,
        i.e. days since January 1, 4713 BCE Greenwich noon.
        @memberof PersianCalendar
        @param year {CDate|number} The date to convert or the year to convert.
        @param [month] {number} The month to convert.
        @param [day] {number} The day to convert.
        @return {number} The equivalent Julian date.
        @throws Error if an invalid date or a different calendar used. */
    toJD: function(year, month, day) {
        var date = this._validate(year, month, day, main.local.invalidDate);
        year = date.year();
        month = date.month();
        day = date.day();
        var epBase = year - (year >= 0 ? 474 : 473);
        var epYear = 474 + mod(epBase, 2820);
        return day + (month <= 7 ? (month - 1) * 31 : (month - 1) * 30 + 6) +
            Math.floor((epYear * 682 - 110) / 2816) + (epYear - 1) * 365 +
            Math.floor(epBase / 2820) * 1029983 + this.jdEpoch - 1;
    },

    /** Create a new date from a Julian date.
        @memberof PersianCalendar
        @param jd {number} The Julian date to convert.
        @return {CDate} The equivalent date. */
    fromJD: function(jd) {
        jd = Math.floor(jd) + 0.5;
        var depoch = jd - this.toJD(475, 1, 1);
        var cycle = Math.floor(depoch / 1029983);
        var cyear = mod(depoch, 1029983);
        var ycycle = 2820;
        if (cyear !== 1029982) {
            var aux1 = Math.floor(cyear / 366);
            var aux2 = mod(cyear, 366);
            ycycle = Math.floor(((2134 * aux1) + (2816 * aux2) + 2815) / 1028522) + aux1 + 1;
        }
        var year = ycycle + (2820 * cycle) + 474;
        year = (year <= 0 ? year - 1 : year);
        var yday = jd - this.toJD(year, 1, 1) + 1;
        var month = (yday <= 186 ? Math.ceil(yday / 31) : Math.ceil((yday - 6) / 30));
        var day = jd - this.toJD(year, month, 1) + 1;
        return this.newDate(year, month, day);
    }
});

// Modulus function which works for non-integers.
function mod(a, b) {
    return a - (b * Math.floor(a / b));
}

// Persian (Jalali) calendar implementation
main.calendars.persian = PersianCalendar;
main.calendars.jalali = PersianCalendar;



/***/ }),

/***/ 84756:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

/*
 * World Calendars
 * https://github.com/alexcjohnson/world-calendars
 *
 * Batch-converted from kbwood/calendars
 * Many thanks to Keith Wood and all of the contributors to the original project!
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

﻿/* http://keith-wood.name/calendars.html
   Taiwanese (Minguo) calendar for jQuery v2.0.2.
   Written by Keith Wood (wood.keith{at}optusnet.com.au) February 2010.
   Available under the MIT (http://keith-wood.name/licence.html) license. 
   Please attribute the author if you use it. */

var main = __webpack_require__(24453);
var assign = __webpack_require__(27976);


var gregorianCalendar = main.instance();

/** Implementation of the Taiwanese calendar.
    See http://en.wikipedia.org/wiki/Minguo_calendar.
    @class TaiwanCalendar
    @param [language=''] {string} The language code (default English) for localisation. */
function TaiwanCalendar(language) {
    this.local = this.regionalOptions[language || ''] || this.regionalOptions[''];
}

TaiwanCalendar.prototype = new main.baseCalendar;

assign(TaiwanCalendar.prototype, {
    /** The calendar name.
        @memberof TaiwanCalendar */
    name: 'Taiwan',
    /** Julian date of start of Taiwan epoch: 1 January 1912 CE (Gregorian).
        @memberof TaiwanCalendar */
    jdEpoch: 2419402.5,
    /** Difference in years between Taiwan and Gregorian calendars.
        @memberof TaiwanCalendar */
    yearsOffset: 1911,
    /** Days per month in a common year.
        @memberof TaiwanCalendar */
    daysPerMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
    /** <code>true</code> if has a year zero, <code>false</code> if not.
        @memberof TaiwanCalendar */
    hasYearZero: false,
    /** The minimum month number.
        @memberof TaiwanCalendar */
    minMonth: 1,
    /** The first month in the year.
        @memberof TaiwanCalendar */
    firstMonth: 1,
    /** The minimum day number.
        @memberof TaiwanCalendar */
    minDay: 1,

    /** Localisations for the plugin.
        Entries are objects indexed by the language code ('' being the default US/English).
        Each object has the following attributes.
        @memberof TaiwanCalendar
        @property name {string} The calendar name.
        @property epochs {string[]} The epoch names.
        @property monthNames {string[]} The long names of the months of the year.
        @property monthNamesShort {string[]} The short names of the months of the year.
        @property dayNames {string[]} The long names of the days of the week.
        @property dayNamesShort {string[]} The short names of the days of the week.
        @property dayNamesMin {string[]} The minimal names of the days of the week.
        @property dateFormat {string} The date format for this calendar.
                See the options on <a href="BaseCalendar.html#formatDate"><code>formatDate</code></a> for details.
        @property firstDay {number} The number of the first day of the week, starting at 0.
        @property isRTL {number} <code>true</code> if this localisation reads right-to-left. */
    regionalOptions: { // Localisations
        '': {
            name: 'Taiwan',
            epochs: ['BROC', 'ROC'],
            monthNames: ['January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'],
            monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
            dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
            dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
            digits: null,
            dateFormat: 'yyyy/mm/dd',
            firstDay: 1,
            isRTL: false
        }
    },

    /** Determine whether this date is in a leap year.
        @memberof TaiwanCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not.
        @throws Error if an invalid year or a different calendar used. */
    leapYear: function(year) {
        var date = this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
        var year = this._t2gYear(date.year());
        return gregorianCalendar.leapYear(year);
    },

    /** Determine the week of the year for a date - ISO 8601.
        @memberof TaiwanCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @param [month] {number} The month to examine.
        @param [day] {number} The day to examine.
        @return {number} The week of the year.
        @throws Error if an invalid date or a different calendar used. */
    weekOfYear: function(year, month, day) {
        var date = this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
        var year = this._t2gYear(date.year());
        return gregorianCalendar.weekOfYear(year, date.month(), date.day());
    },

    /** Retrieve the number of days in a month.
        @memberof TaiwanCalendar
        @param year {CDate|number} The date to examine or the year of the month.
        @param [month] {number} The month.
        @return {number} The number of days in this month.
        @throws Error if an invalid month/year or a different calendar used. */
    daysInMonth: function(year, month) {
        var date = this._validate(year, month, this.minDay, main.local.invalidMonth);
        return this.daysPerMonth[date.month() - 1] +
            (date.month() === 2 && this.leapYear(date.year()) ? 1 : 0);
    },

    /** Determine whether this date is a week day.
        @memberof TaiwanCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @param [month] {number} The month to examine.
        @param [day] {number} The day to examine.
        @return {boolean} <code>true</code> if a week day, <code>false</code> if not.
        @throws Error if an invalid date or a different calendar used. */
    weekDay: function(year, month, day) {
        return (this.dayOfWeek(year, month, day) || 7) < 6;
    },

    /** Retrieve the Julian date equivalent for this date,
        i.e. days since January 1, 4713 BCE Greenwich noon.
        @memberof TaiwanCalendar
        @param year {CDate|number} The date to convert or the year to convert.
        @param [month] {number} The month to convert.
        @param [day] {number} The day to convert.
        @return {number} The equivalent Julian date.
        @throws Error if an invalid date or a different calendar used. */
    toJD: function(year, month, day) {
        var date = this._validate(year, month, day, main.local.invalidDate);
        var year = this._t2gYear(date.year());
        return gregorianCalendar.toJD(year, date.month(), date.day());
    },

    /** Create a new date from a Julian date.
        @memberof TaiwanCalendar
        @param jd {number} The Julian date to convert.
        @return {CDate} The equivalent date. */
    fromJD: function(jd) {
        var date = gregorianCalendar.fromJD(jd);
        var year = this._g2tYear(date.year());
        return this.newDate(year, date.month(), date.day());
    },

    /** Convert Taiwanese to Gregorian year.
        @memberof TaiwanCalendar
        @private
        @param year {number} The Taiwanese year.
        @return {number} The corresponding Gregorian year. */
    _t2gYear: function(year) {
        return year + this.yearsOffset + (year >= -this.yearsOffset && year <= -1 ? 1 : 0);
    },

    /** Convert Gregorian to Taiwanese year.
        @memberof TaiwanCalendar
        @private
        @param year {number} The Gregorian year.
        @return {number} The corresponding Taiwanese year. */
    _g2tYear: function(year) {
        return year - this.yearsOffset - (year >= 1 && year <= this.yearsOffset ? 1 : 0);
    }
});

// Taiwan calendar implementation
main.calendars.taiwan = TaiwanCalendar;



/***/ }),

/***/ 41858:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

/*
 * World Calendars
 * https://github.com/alexcjohnson/world-calendars
 *
 * Batch-converted from kbwood/calendars
 * Many thanks to Keith Wood and all of the contributors to the original project!
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

﻿/* http://keith-wood.name/calendars.html
   Thai calendar for jQuery v2.0.2.
   Written by Keith Wood (wood.keith{at}optusnet.com.au) February 2010.
   Available under the MIT (http://keith-wood.name/licence.html) license. 
   Please attribute the author if you use it. */

var main = __webpack_require__(24453);
var assign = __webpack_require__(27976);


var gregorianCalendar = main.instance();

/** Implementation of the Thai calendar.
    See http://en.wikipedia.org/wiki/Thai_calendar.
    @class ThaiCalendar
    @param [language=''] {string} The language code (default English) for localisation. */
function ThaiCalendar(language) {
    this.local = this.regionalOptions[language || ''] || this.regionalOptions[''];
}

ThaiCalendar.prototype = new main.baseCalendar;

assign(ThaiCalendar.prototype, {
    /** The calendar name.
        @memberof ThaiCalendar */
    name: 'Thai',
    /** Julian date of start of Thai epoch: 1 January 543 BCE (Gregorian).
        @memberof ThaiCalendar */
    jdEpoch: 1523098.5,
    /** Difference in years between Thai and Gregorian calendars.
        @memberof ThaiCalendar */
    yearsOffset: 543, 
    /** Days per month in a common year.
        @memberof ThaiCalendar */
    daysPerMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
    /** <code>true</code> if has a year zero, <code>false</code> if not.
        @memberof ThaiCalendar */
    hasYearZero: false,
    /** The minimum month number.
        @memberof ThaiCalendar */
    minMonth: 1,
    /** The first month in the year.
        @memberof ThaiCalendar */
    firstMonth: 1,
    /** The minimum day number.
        @memberof ThaiCalendar */
    minDay: 1,

    /** Localisations for the plugin.
        Entries are objects indexed by the language code ('' being the default US/English).
        Each object has the following attributes.
        @memberof ThaiCalendar
        @property name {string} The calendar name.
        @property epochs {string[]} The epoch names.
        @property monthNames {string[]} The long names of the months of the year.
        @property monthNamesShort {string[]} The short names of the months of the year.
        @property dayNames {string[]} The long names of the days of the week.
        @property dayNamesShort {string[]} The short names of the days of the week.
        @property dayNamesMin {string[]} The minimal names of the days of the week.
        @property dateFormat {string} The date format for this calendar.
                See the options on <a href="BaseCalendar.html#formatDate"><code>formatDate</code></a> for details.
        @property firstDay {number} The number of the first day of the week, starting at 0.
        @property isRTL {number} <code>true</code> if this localisation reads right-to-left. */
    regionalOptions: { // Localisations
        '': {
            name: 'Thai',
            epochs: ['BBE', 'BE'],
            monthNames: ['January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'],
            monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
            dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
            dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
            digits: null,
            dateFormat: 'dd/mm/yyyy',
            firstDay: 0,
            isRTL: false
        }
    },

    /** Determine whether this date is in a leap year.
        @memberof ThaiCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not.
        @throws Error if an invalid year or a different calendar used. */
    leapYear: function(year) {
        var date = this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
        var year = this._t2gYear(date.year());
        return gregorianCalendar.leapYear(year);
    },

    /** Determine the week of the year for a date - ISO 8601.
        @memberof ThaiCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @param [month] {number} The month to examine.
        @param [day] {number} The day to examine.
        @return {number} The week of the year.
        @throws Error if an invalid date or a different calendar used. */
    weekOfYear: function(year, month, day) {
        var date = this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
        var year = this._t2gYear(date.year());
        return gregorianCalendar.weekOfYear(year, date.month(), date.day());
    },

    /** Retrieve the number of days in a month.
        @memberof ThaiCalendar
        @param year {CDate|number} The date to examine or the year of the month.
        @param [month] {number} The month.
        @return {number} The number of days in this month.
        @throws Error if an invalid month/year or a different calendar used. */
    daysInMonth: function(year, month) {
        var date = this._validate(year, month, this.minDay, main.local.invalidMonth);
        return this.daysPerMonth[date.month() - 1] +
            (date.month() === 2 && this.leapYear(date.year()) ? 1 : 0);
    },

    /** Determine whether this date is a week day.
        @memberof ThaiCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @param [month] {number} The month to examine.
        @param [day] {number} The day to examine.
        @return {boolean} <code>true</code> if a week day, <code>false</code> if not.
        @throws Error if an invalid date or a different calendar used. */
    weekDay: function(year, month, day) {
        return (this.dayOfWeek(year, month, day) || 7) < 6;
    },

    /** Retrieve the Julian date equivalent for this date,
        i.e. days since January 1, 4713 BCE Greenwich noon.
        @memberof ThaiCalendar
        @param year {CDate|number} The date to convert or the year to convert.
        @param [month] {number} The month to convert.
        @param [day] {number} The day to convert.
        @return {number} The equivalent Julian date.
        @throws Error if an invalid date or a different calendar used. */
    toJD: function(year, month, day) {
        var date = this._validate(year, month, day, main.local.invalidDate);
        var year = this._t2gYear(date.year());
        return gregorianCalendar.toJD(year, date.month(), date.day());
    },

    /** Create a new date from a Julian date.
        @memberof ThaiCalendar
        @param jd {number} The Julian date to convert.
        @return {CDate} The equivalent date. */
    fromJD: function(jd) {
        var date = gregorianCalendar.fromJD(jd);
        var year = this._g2tYear(date.year());
        return this.newDate(year, date.month(), date.day());
    },

    /** Convert Thai to Gregorian year.
        @memberof ThaiCalendar
        @private
        @param year {number} The Thai year.
        @return {number} The corresponding Gregorian year. */
    _t2gYear: function(year) {
        return year - this.yearsOffset - (year >= 1 && year <= this.yearsOffset ? 1 : 0);
    },

    /** Convert Gregorian to Thai year.
        @memberof ThaiCalendar
        @private
        @param year {number} The Gregorian year.
        @return {number} The corresponding Thai year. */
    _g2tYear: function(year) {
        return year + this.yearsOffset + (year >= -this.yearsOffset && year <= -1 ? 1 : 0);
    }
});

// Thai calendar implementation
main.calendars.thai = ThaiCalendar;



/***/ }),

/***/ 57985:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

/*
 * World Calendars
 * https://github.com/alexcjohnson/world-calendars
 *
 * Batch-converted from kbwood/calendars
 * Many thanks to Keith Wood and all of the contributors to the original project!
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

﻿/* http://keith-wood.name/calendars.html
   UmmAlQura calendar for jQuery v2.0.2.
   Written by Amro Osama March 2013.
   Modified by Binnooh.com & www.elm.sa - 2014 - Added dates back to 1276 Hijri year.
   Available under the MIT (http://keith-wood.name/licence.html) license. 
   Please attribute the author if you use it. */

var main = __webpack_require__(24453);
var assign = __webpack_require__(27976);


/** Implementation of the UmmAlQura or 'saudi' calendar.
    See also <a href="http://en.wikipedia.org/wiki/Islamic_calendar#Saudi_Arabia.27s_Umm_al-Qura_calendar">http://en.wikipedia.org/wiki/Islamic_calendar#Saudi_Arabia.27s_Umm_al-Qura_calendar</a>.
    <a href="http://www.ummulqura.org.sa/About.aspx">http://www.ummulqura.org.sa/About.aspx</a>
    <a href="http://www.staff.science.uu.nl/~gent0113/islam/ummalqura.htm">http://www.staff.science.uu.nl/~gent0113/islam/ummalqura.htm</a>
    @class UmmAlQuraCalendar
    @param [language=''] {string} The language code (default English) for localisation. */
function UmmAlQuraCalendar(language) {
    this.local = this.regionalOptions[language || ''] || this.regionalOptions[''];
}

UmmAlQuraCalendar.prototype = new main.baseCalendar;

assign(UmmAlQuraCalendar.prototype, {
    /** The calendar name.
        @memberof UmmAlQuraCalendar */
    name: 'UmmAlQura',
    //jdEpoch: 1948440, // Julian date of start of UmmAlQura epoch: 14 March 1937 CE
    //daysPerMonth: // Days per month in a common year, replaced by a method.
    /** <code>true</code> if has a year zero, <code>false</code> if not.
        @memberof UmmAlQuraCalendar */
    hasYearZero: false,
    /** The minimum month number.
        @memberof UmmAlQuraCalendar */
    minMonth: 1,
    /** The first month in the year.
        @memberof UmmAlQuraCalendar */
    firstMonth: 1,
    /** The minimum day number.
        @memberof UmmAlQuraCalendar */
    minDay: 1,

    /** Localisations for the plugin.
        Entries are objects indexed by the language code ('' being the default US/English).
        Each object has the following attributes.
        @memberof UmmAlQuraCalendar
        @property name {string} The calendar name.
        @property epochs {string[]} The epoch names.
        @property monthNames {string[]} The long names of the months of the year.
        @property monthNamesShort {string[]} The short names of the months of the year.
        @property dayNames {string[]} The long names of the days of the week.
        @property dayNamesShort {string[]} The short names of the days of the week.
        @property dayNamesMin {string[]} The minimal names of the days of the week.
        @property dateFormat {string} The date format for this calendar.
                See the options on <a href="BaseCalendar.html#formatDate"><code>formatDate</code></a> for details.
        @property firstDay {number} The number of the first day of the week, starting at 0.
        @property isRTL {number} <code>true</code> if this localisation reads right-to-left. */
    regionalOptions: { // Localisations
        '': {
            name: 'Umm al-Qura',
            epochs: ['BH', 'AH'],
            monthNames: ['Al-Muharram', 'Safar', 'Rabi\' al-awwal', 'Rabi\' Al-Thani', 'Jumada Al-Awwal', 'Jumada Al-Thani',
            'Rajab', 'Sha\'aban', 'Ramadan', 'Shawwal', 'Dhu al-Qi\'dah', 'Dhu al-Hijjah'],
            monthNamesShort: ['Muh', 'Saf', 'Rab1', 'Rab2', 'Jum1', 'Jum2', 'Raj', 'Sha\'', 'Ram', 'Shaw', 'DhuQ', 'DhuH'],
            dayNames: ['Yawm al-Ahad', 'Yawm al-Ithnain', 'Yawm al-Thalāthā’', 'Yawm al-Arba‘ā’', 'Yawm al-Khamīs', 'Yawm al-Jum‘a', 'Yawm al-Sabt'],
            dayNamesMin: ['Ah', 'Ith', 'Th', 'Ar', 'Kh', 'Ju', 'Sa'],
            digits: null,
            dateFormat: 'yyyy/mm/dd',
            firstDay: 6,
            isRTL: true
        }
    },

    /** Determine whether this date is in a leap year.
        @memberof UmmAlQuraCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not.
        @throws Error if an invalid year or a different calendar used. */
    leapYear: function (year) {
        var date = this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
        return (this.daysInYear(date.year()) === 355);
    },

    /** Determine the week of the year for a date.
        @memberof UmmAlQuraCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @param [month] {number} The month to examine.
        @param [day] {number} The day to examine.
        @return {number} The week of the year.
        @throws Error if an invalid date or a different calendar used. */
    weekOfYear: function (year, month, day) {
        // Find Sunday of this week starting on Sunday
        var checkDate = this.newDate(year, month, day);
        checkDate.add(-checkDate.dayOfWeek(), 'd');
        return Math.floor((checkDate.dayOfYear() - 1) / 7) + 1;
    },

    /** Retrieve the number of days in a year.
        @memberof UmmAlQuraCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @return {number} The number of days.
        @throws Error if an invalid year or a different calendar used. */
    daysInYear: function (year) {
        var daysCount = 0;
        for (var i = 1; i <= 12; i++) {
            daysCount += this.daysInMonth(year, i);
        }
        return daysCount;
    },

    /** Retrieve the number of days in a month.
        @memberof UmmAlQuraCalendar
        @param year {CDate|number} The date to examine or the year of the month.
        @param [month] {number} The month.
        @return {number} The number of days in this month.
        @throws Error if an invalid month/year or a different calendar used. */
    daysInMonth: function (year, month) {
        var date = this._validate(year, month, this.minDay, main.local.invalidMonth);
        var mcjdn = date.toJD() - 2400000 + 0.5; // Modified Chronological Julian Day Number (MCJDN)
        // the MCJDN's of the start of the lunations in the Umm al-Qura calendar are stored in the 'ummalqura_dat' array
        var index = 0;
        for (var i = 0; i < ummalqura_dat.length; i++) {
            if (ummalqura_dat[i] > mcjdn) {
                return (ummalqura_dat[index] - ummalqura_dat[index - 1]);
            }
            index++;
        }
        return 30; // Unknown outside
    },

    /** Determine whether this date is a week day.
        @memberof UmmAlQuraCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @param [month] {number} The month to examine.
        @param [day] {number} The day to examine.
        @return {boolean} <code>true</code> if a week day, <code>false</code> if not.
        @throws Error if an invalid date or a different calendar used. */
    weekDay: function (year, month, day) {
        return this.dayOfWeek(year, month, day) !== 5;
    },

    /** Retrieve the Julian date equivalent for this date,
        i.e. days since January 1, 4713 BCE Greenwich noon.
        @memberof UmmAlQuraCalendar
        @param year {CDate|number} The date to convert or the year to convert.
        @param [month] {number} The month to convert.
        @param [day] {number} The day to convert.
        @return {number} The equivalent Julian date.
        @throws Error if an invalid date or a different calendar used. */
    toJD: function (year, month, day) {
        var date = this._validate(year, month, day, main.local.invalidDate);
        var index = (12 * (date.year() - 1)) + date.month() - 15292;
        var mcjdn = date.day() + ummalqura_dat[index - 1] - 1;
        return mcjdn + 2400000 - 0.5; // Modified Chronological Julian Day Number (MCJDN)
    },

    /** Create a new date from a Julian date.
        @memberof UmmAlQuraCalendar
        @param jd {number} The Julian date to convert.
        @return {CDate} The equivalent date. */
    fromJD: function (jd) {
        var mcjdn = jd - 2400000 + 0.5; // Modified Chronological Julian Day Number (MCJDN)
        // the MCJDN's of the start of the lunations in the Umm al-Qura calendar 
        // are stored in the 'ummalqura_dat' array
        var index = 0;
        for (var i = 0; i < ummalqura_dat.length; i++) {
            if (ummalqura_dat[i] > mcjdn) break;
            index++;
        }
        var lunation = index + 15292; //UmmAlQura Lunation Number
        var ii = Math.floor((lunation - 1) / 12);
        var year = ii + 1;
        var month = lunation - 12 * ii;
        var day = mcjdn - ummalqura_dat[index - 1] + 1;
        return this.newDate(year, month, day);
    },

    /** Determine whether a date is valid for this calendar.
        @memberof UmmAlQuraCalendar
        @param year {number} The year to examine.
        @param month {number} The month to examine.
        @param day {number} The day to examine.
        @return {boolean} <code>true</code> if a valid date, <code>false</code> if not. */
    isValid: function(year, month, day) {
        var valid = main.baseCalendar.prototype.isValid.apply(this, arguments);
        if (valid) {
            year = (year.year != null ? year.year : year);
            valid = (year >= 1276 && year <= 1500);
        }
        return valid;
    },

    /** Check that a candidate date is from the same calendar and is valid.
        @memberof UmmAlQuraCalendar
        @private
        @param year {CDate|number} The date to validate or the year to validate.
        @param month {number} The month to validate.
        @param day {number} The day to validate.
        @param error {string} Error message if invalid.
        @throws Error if different calendars used or invalid date. */
    _validate: function(year, month, day, error) {
        var date = main.baseCalendar.prototype._validate.apply(this, arguments);
        if (date.year < 1276 || date.year > 1500) {
            throw error.replace(/\{0\}/, this.local.name);
        }
        return date;
    }
});

// UmmAlQura calendar implementation
main.calendars.ummalqura = UmmAlQuraCalendar;

var ummalqura_dat = [
    20,    50,    79,    109,   138,   168,   197,   227,   256,   286,   315,   345,   374,   404,   433,   463,   492,   522,   551,   581, 
    611,   641,   670,   700,   729,   759,   788,   818,   847,   877,   906,   936,   965,   995,   1024,  1054,  1083,  1113,  1142,  1172,
    1201,  1231,  1260,  1290,  1320,  1350,  1379,  1409,  1438,  1468,  1497,  1527,  1556,  1586,  1615,  1645,  1674,  1704,  1733,  1763,
    1792,  1822,  1851,  1881,  1910,  1940,  1969,  1999,  2028,  2058,  2087,  2117,  2146,  2176,  2205,  2235,  2264,  2294,  2323,  2353,
    2383,  2413,  2442,  2472,  2501,  2531,  2560,  2590,  2619,  2649,  2678,  2708,  2737,  2767,  2796,  2826,  2855,  2885,  2914,  2944,
    2973,  3003,  3032,  3062,  3091,  3121,  3150,  3180,  3209,  3239,  3268,  3298,  3327,  3357,  3386,  3416,  3446,  3476,  3505,  3535,
    3564,  3594,  3623,  3653,  3682,  3712,  3741,  3771,  3800,  3830,  3859,  3889,  3918,  3948,  3977,  4007,  4036,  4066,  4095,  4125,
    4155,  4185,  4214,  4244,  4273,  4303,  4332,  4362,  4391,  4421,  4450,  4480,  4509,  4539,  4568,  4598,  4627,  4657,  4686,  4716,
    4745,  4775,  4804,  4834,  4863,  4893,  4922,  4952,  4981,  5011,  5040,  5070,  5099,  5129,  5158,  5188,  5218,  5248,  5277,  5307,
    5336,  5366,  5395,  5425,  5454,  5484,  5513,  5543,  5572,  5602,  5631,  5661,  5690,  5720,  5749,  5779,  5808,  5838,  5867,  5897,
    5926,  5956,  5985,  6015,  6044,  6074,  6103,  6133,  6162,  6192,  6221,  6251,  6281,  6311,  6340,  6370,  6399,  6429,  6458,  6488,
    6517,  6547,  6576,  6606,  6635,  6665,  6694,  6724,  6753,  6783,  6812,  6842,  6871,  6901,  6930,  6960,  6989,  7019,  7048,  7078,
    7107,  7137,  7166,  7196,  7225,  7255,  7284,  7314,  7344,  7374,  7403,  7433,  7462,  7492,  7521,  7551,  7580,  7610,  7639,  7669,
    7698,  7728,  7757,  7787,  7816,  7846,  7875,  7905,  7934,  7964,  7993,  8023,  8053,  8083,  8112,  8142,  8171,  8201,  8230,  8260,
    8289,  8319,  8348,  8378,  8407,  8437,  8466,  8496,  8525,  8555,  8584,  8614,  8643,  8673,  8702,  8732,  8761,  8791,  8821,  8850,
    8880,  8909,  8938,  8968,  8997,  9027,  9056,  9086,  9115,  9145,  9175,  9205,  9234,  9264,  9293,  9322,  9352,  9381,  9410,  9440,
    9470,  9499,  9529,  9559,  9589,  9618,  9648,  9677,  9706,  9736,  9765,  9794,  9824,  9853,  9883,  9913,  9943,  9972,  10002, 10032,
    10061, 10090, 10120, 10149, 10178, 10208, 10237, 10267, 10297, 10326, 10356, 10386, 10415, 10445, 10474, 10504, 10533, 10562, 10592, 10621,
    10651, 10680, 10710, 10740, 10770, 10799, 10829, 10858, 10888, 10917, 10947, 10976, 11005, 11035, 11064, 11094, 11124, 11153, 11183, 11213,
    11242, 11272, 11301, 11331, 11360, 11389, 11419, 11448, 11478, 11507, 11537, 11567, 11596, 11626, 11655, 11685, 11715, 11744, 11774, 11803,
    11832, 11862, 11891, 11921, 11950, 11980, 12010, 12039, 12069, 12099, 12128, 12158, 12187, 12216, 12246, 12275, 12304, 12334, 12364, 12393,
    12423, 12453, 12483, 12512, 12542, 12571, 12600, 12630, 12659, 12688, 12718, 12747, 12777, 12807, 12837, 12866, 12896, 12926, 12955, 12984,
    13014, 13043, 13072, 13102, 13131, 13161, 13191, 13220, 13250, 13280, 13310, 13339, 13368, 13398, 13427, 13456, 13486, 13515, 13545, 13574,
    13604, 13634, 13664, 13693, 13723, 13752, 13782, 13811, 13840, 13870, 13899, 13929, 13958, 13988, 14018, 14047, 14077, 14107, 14136, 14166,
    14195, 14224, 14254, 14283, 14313, 14342, 14372, 14401, 14431, 14461, 14490, 14520, 14550, 14579, 14609, 14638, 14667, 14697, 14726, 14756,
    14785, 14815, 14844, 14874, 14904, 14933, 14963, 14993, 15021, 15051, 15081, 15110, 15140, 15169, 15199, 15228, 15258, 15287, 15317, 15347,
    15377, 15406, 15436, 15465, 15494, 15524, 15553, 15582, 15612, 15641, 15671, 15701, 15731, 15760, 15790, 15820, 15849, 15878, 15908, 15937,
    15966, 15996, 16025, 16055, 16085, 16114, 16144, 16174, 16204, 16233, 16262, 16292, 16321, 16350, 16380, 16409, 16439, 16468, 16498, 16528,
    16558, 16587, 16617, 16646, 16676, 16705, 16734, 16764, 16793, 16823, 16852, 16882, 16912, 16941, 16971, 17001, 17030, 17060, 17089, 17118,
    17148, 17177, 17207, 17236, 17266, 17295, 17325, 17355, 17384, 17414, 17444, 17473, 17502, 17532, 17561, 17591, 17620, 17650, 17679, 17709,
    17738, 17768, 17798, 17827, 17857, 17886, 17916, 17945, 17975, 18004, 18034, 18063, 18093, 18122, 18152, 18181, 18211, 18241, 18270, 18300,
    18330, 18359, 18388, 18418, 18447, 18476, 18506, 18535, 18565, 18595, 18625, 18654, 18684, 18714, 18743, 18772, 18802, 18831, 18860, 18890,
    18919, 18949, 18979, 19008, 19038, 19068, 19098, 19127, 19156, 19186, 19215, 19244, 19274, 19303, 19333, 19362, 19392, 19422, 19452, 19481,
    19511, 19540, 19570, 19599, 19628, 19658, 19687, 19717, 19746, 19776, 19806, 19836, 19865, 19895, 19924, 19954, 19983, 20012, 20042, 20071,
    20101, 20130, 20160, 20190, 20219, 20249, 20279, 20308, 20338, 20367, 20396, 20426, 20455, 20485, 20514, 20544, 20573, 20603, 20633, 20662,
    20692, 20721, 20751, 20780, 20810, 20839, 20869, 20898, 20928, 20957, 20987, 21016, 21046, 21076, 21105, 21135, 21164, 21194, 21223, 21253,
    21282, 21312, 21341, 21371, 21400, 21430, 21459, 21489, 21519, 21548, 21578, 21607, 21637, 21666, 21696, 21725, 21754, 21784, 21813, 21843,
    21873, 21902, 21932, 21962, 21991, 22021, 22050, 22080, 22109, 22138, 22168, 22197, 22227, 22256, 22286, 22316, 22346, 22375, 22405, 22434,
    22464, 22493, 22522, 22552, 22581, 22611, 22640, 22670, 22700, 22730, 22759, 22789, 22818, 22848, 22877, 22906, 22936, 22965, 22994, 23024,
    23054, 23083, 23113, 23143, 23173, 23202, 23232, 23261, 23290, 23320, 23349, 23379, 23408, 23438, 23467, 23497, 23527, 23556, 23586, 23616,
    23645, 23674, 23704, 23733, 23763, 23792, 23822, 23851, 23881, 23910, 23940, 23970, 23999, 24029, 24058, 24088, 24117, 24147, 24176, 24206,
    24235, 24265, 24294, 24324, 24353, 24383, 24413, 24442, 24472, 24501, 24531, 24560, 24590, 24619, 24648, 24678, 24707, 24737, 24767, 24796,
    24826, 24856, 24885, 24915, 24944, 24974, 25003, 25032, 25062, 25091, 25121, 25150, 25180, 25210, 25240, 25269, 25299, 25328, 25358, 25387,
    25416, 25446, 25475, 25505, 25534, 25564, 25594, 25624, 25653, 25683, 25712, 25742, 25771, 25800, 25830, 25859, 25888, 25918, 25948, 25977,
    26007, 26037, 26067, 26096, 26126, 26155, 26184, 26214, 26243, 26272, 26302, 26332, 26361, 26391, 26421, 26451, 26480, 26510, 26539, 26568,
    26598, 26627, 26656, 26686, 26715, 26745, 26775, 26805, 26834, 26864, 26893, 26923, 26952, 26982, 27011, 27041, 27070, 27099, 27129, 27159,
    27188, 27218, 27248, 27277, 27307, 27336, 27366, 27395, 27425, 27454, 27484, 27513, 27542, 27572, 27602, 27631, 27661, 27691, 27720, 27750,
    27779, 27809, 27838, 27868, 27897, 27926, 27956, 27985, 28015, 28045, 28074, 28104, 28134, 28163, 28193, 28222, 28252, 28281, 28310, 28340,
    28369, 28399, 28428, 28458, 28488, 28517, 28547, 28577,
    // From 1356
    28607, 28636, 28665, 28695, 28724, 28754, 28783, 28813, 28843, 28872, 28901, 28931, 28960, 28990, 29019, 29049, 29078, 29108, 29137, 29167,
    29196, 29226, 29255, 29285, 29315, 29345, 29375, 29404, 29434, 29463, 29492, 29522, 29551, 29580, 29610, 29640, 29669, 29699, 29729, 29759,
    29788, 29818, 29847, 29876, 29906, 29935, 29964, 29994, 30023, 30053, 30082, 30112, 30141, 30171, 30200, 30230, 30259, 30289, 30318, 30348,
    30378, 30408, 30437, 30467, 30496, 30526, 30555, 30585, 30614, 30644, 30673, 30703, 30732, 30762, 30791, 30821, 30850, 30880, 30909, 30939,
    30968, 30998, 31027, 31057, 31086, 31116, 31145, 31175, 31204, 31234, 31263, 31293, 31322, 31352, 31381, 31411, 31441, 31471, 31500, 31530,
    31559, 31589, 31618, 31648, 31676, 31706, 31736, 31766, 31795, 31825, 31854, 31884, 31913, 31943, 31972, 32002, 32031, 32061, 32090, 32120,
    32150, 32180, 32209, 32239, 32268, 32298, 32327, 32357, 32386, 32416, 32445, 32475, 32504, 32534, 32563, 32593, 32622, 32652, 32681, 32711,
    32740, 32770, 32799, 32829, 32858, 32888, 32917, 32947, 32976, 33006, 33035, 33065, 33094, 33124, 33153, 33183, 33213, 33243, 33272, 33302,
    33331, 33361, 33390, 33420, 33450, 33479, 33509, 33539, 33568, 33598, 33627, 33657, 33686, 33716, 33745, 33775, 33804, 33834, 33863, 33893,
    33922, 33952, 33981, 34011, 34040, 34069, 34099, 34128, 34158, 34187, 34217, 34247, 34277, 34306, 34336, 34365, 34395, 34424, 34454, 34483,
    34512, 34542, 34571, 34601, 34631, 34660, 34690, 34719, 34749, 34778, 34808, 34837, 34867, 34896, 34926, 34955, 34985, 35015, 35044, 35074,
    35103, 35133, 35162, 35192, 35222, 35251, 35280, 35310, 35340, 35370, 35399, 35429, 35458, 35488, 35517, 35547, 35576, 35605, 35635, 35665,
    35694, 35723, 35753, 35782, 35811, 35841, 35871, 35901, 35930, 35960, 35989, 36019, 36048, 36078, 36107, 36136, 36166, 36195, 36225, 36254,
    36284, 36314, 36343, 36373, 36403, 36433, 36462, 36492, 36521, 36551, 36580, 36610, 36639, 36669, 36698, 36728, 36757, 36786, 36816, 36845,
    36875, 36904, 36934, 36963, 36993, 37022, 37052, 37081, 37111, 37141, 37170, 37200, 37229, 37259, 37288, 37318, 37347, 37377, 37406, 37436,
    37465, 37495, 37524, 37554, 37584, 37613, 37643, 37672, 37701, 37731, 37760, 37790, 37819, 37849, 37878, 37908, 37938, 37967, 37997, 38027,
    38056, 38085, 38115, 38144, 38174, 38203, 38233, 38262, 38292, 38322, 38351, 38381, 38410, 38440, 38469, 38499, 38528, 38558, 38587, 38617,
    38646, 38676, 38705, 38735, 38764, 38794, 38823, 38853, 38882, 38912, 38941, 38971, 39001, 39030, 39059, 39089, 39118, 39148, 39178, 39208,
    39237, 39267, 39297, 39326, 39355, 39385, 39414, 39444, 39473, 39503, 39532, 39562, 39592, 39621, 39650, 39680, 39709, 39739, 39768, 39798,
    39827, 39857, 39886, 39916, 39946, 39975, 40005, 40035, 40064, 40094, 40123, 40153, 40182, 40212, 40241, 40271, 40300, 40330, 40359, 40389,
    40418, 40448, 40477, 40507, 40536, 40566, 40595, 40625, 40655, 40685, 40714, 40744, 40773, 40803, 40832, 40862, 40892, 40921, 40951, 40980,
    41009, 41039, 41068, 41098, 41127, 41157, 41186, 41216, 41245, 41275, 41304, 41334, 41364, 41393, 41422, 41452, 41481, 41511, 41540, 41570,
    41599, 41629, 41658, 41688, 41718, 41748, 41777, 41807, 41836, 41865, 41894, 41924, 41953, 41983, 42012, 42042, 42072, 42102, 42131, 42161,
    42190, 42220, 42249, 42279, 42308, 42337, 42367, 42397, 42426, 42456, 42485, 42515, 42545, 42574, 42604, 42633, 42662, 42692, 42721, 42751,
    42780, 42810, 42839, 42869, 42899, 42929, 42958, 42988, 43017, 43046, 43076, 43105, 43135, 43164, 43194, 43223, 43253, 43283, 43312, 43342,
    43371, 43401, 43430, 43460, 43489, 43519, 43548, 43578, 43607, 43637, 43666, 43696, 43726, 43755, 43785, 43814, 43844, 43873, 43903, 43932,
    43962, 43991, 44021, 44050, 44080, 44109, 44139, 44169, 44198, 44228, 44258, 44287, 44317, 44346, 44375, 44405, 44434, 44464, 44493, 44523,
    44553, 44582, 44612, 44641, 44671, 44700, 44730, 44759, 44788, 44818, 44847, 44877, 44906, 44936, 44966, 44996, 45025, 45055, 45084, 45114,
    45143, 45172, 45202, 45231, 45261, 45290, 45320, 45350, 45380, 45409, 45439, 45468, 45498, 45527, 45556, 45586, 45615, 45644, 45674, 45704,
    45733, 45763, 45793, 45823, 45852, 45882, 45911, 45940, 45970, 45999, 46028, 46058, 46088, 46117, 46147, 46177, 46206, 46236, 46265, 46295,
    46324, 46354, 46383, 46413, 46442, 46472, 46501, 46531, 46560, 46590, 46620, 46649, 46679, 46708, 46738, 46767, 46797, 46826, 46856, 46885,
    46915, 46944, 46974, 47003, 47033, 47063, 47092, 47122, 47151, 47181, 47210, 47240, 47269, 47298, 47328, 47357, 47387, 47417, 47446, 47476,
    47506, 47535, 47565, 47594, 47624, 47653, 47682, 47712, 47741, 47771, 47800, 47830, 47860, 47890, 47919, 47949, 47978, 48008, 48037, 48066,
    48096, 48125, 48155, 48184, 48214, 48244, 48273, 48303, 48333, 48362, 48392, 48421, 48450, 48480, 48509, 48538, 48568, 48598, 48627, 48657,
    48687, 48717, 48746, 48776, 48805, 48834, 48864, 48893, 48922, 48952, 48982, 49011, 49041, 49071, 49100, 49130, 49160, 49189, 49218, 49248,
    49277, 49306, 49336, 49365, 49395, 49425, 49455, 49484, 49514, 49543, 49573, 49602, 49632, 49661, 49690, 49720, 49749, 49779, 49809, 49838,
    49868, 49898, 49927, 49957, 49986, 50016, 50045, 50075, 50104, 50133, 50163, 50192, 50222, 50252, 50281, 50311, 50340, 50370, 50400, 50429,
    50459, 50488, 50518, 50547, 50576, 50606, 50635, 50665, 50694, 50724, 50754, 50784, 50813, 50843, 50872, 50902, 50931, 50960, 50990, 51019,
    51049, 51078, 51108, 51138, 51167, 51197, 51227, 51256, 51286, 51315, 51345, 51374, 51403, 51433, 51462, 51492, 51522, 51552, 51582, 51611,
    51641, 51670, 51699, 51729, 51758, 51787, 51816, 51846, 51876, 51906, 51936, 51965, 51995, 52025, 52054, 52083, 52113, 52142, 52171, 52200,
    52230, 52260, 52290, 52319, 52349, 52379, 52408, 52438, 52467, 52497, 52526, 52555, 52585, 52614, 52644, 52673, 52703, 52733, 52762, 52792,
    52822, 52851, 52881, 52910, 52939, 52969, 52998, 53028, 53057, 53087, 53116, 53146, 53176, 53205, 53235, 53264, 53294, 53324, 53353, 53383,
    53412, 53441, 53471, 53500, 53530, 53559, 53589, 53619, 53648, 53678, 53708, 53737, 53767, 53796, 53825, 53855, 53884, 53913, 53943, 53973,
    54003, 54032, 54062, 54092, 54121, 54151, 54180, 54209, 54239, 54268, 54297, 54327, 54357, 54387, 54416, 54446, 54476, 54505, 54535, 54564,
    54593, 54623, 54652, 54681, 54711, 54741, 54770, 54800, 54830, 54859, 54889, 54919, 54948, 54977, 55007, 55036, 55066, 55095, 55125, 55154,
    55184, 55213, 55243, 55273, 55302, 55332, 55361, 55391, 55420, 55450, 55479, 55508, 55538, 55567, 55597, 55627, 55657, 55686, 55716, 55745,
    55775, 55804, 55834, 55863, 55892, 55922, 55951, 55981, 56011, 56040, 56070, 56100, 56129, 56159, 56188, 56218, 56247, 56276, 56306, 56335,
    56365, 56394, 56424, 56454, 56483, 56513, 56543, 56572, 56601, 56631, 56660, 56690, 56719, 56749, 56778, 56808, 56837, 56867, 56897, 56926,
    56956, 56985, 57015, 57044, 57074, 57103, 57133, 57162, 57192, 57221, 57251, 57280, 57310, 57340, 57369, 57399, 57429, 57458, 57487, 57517,
    57546, 57576, 57605, 57634, 57664, 57694, 57723, 57753, 57783, 57813, 57842, 57871, 57901, 57930, 57959, 57989, 58018, 58048, 58077, 58107,
    58137, 58167, 58196, 58226, 58255, 58285, 58314, 58343, 58373, 58402, 58432, 58461, 58491, 58521, 58551, 58580, 58610, 58639, 58669, 58698,
    58727, 58757, 58786, 58816, 58845, 58875, 58905, 58934, 58964, 58994, 59023, 59053, 59082, 59111, 59141, 59170, 59200, 59229, 59259, 59288,
    59318, 59348, 59377, 59407, 59436, 59466, 59495, 59525, 59554, 59584, 59613, 59643, 59672, 59702, 59731, 59761, 59791, 59820, 59850, 59879,
    59909, 59939, 59968, 59997, 60027, 60056, 60086, 60115, 60145, 60174, 60204, 60234, 60264, 60293, 60323, 60352, 60381, 60411, 60440, 60469,
    60499, 60528, 60558, 60588, 60618, 60648, 60677, 60707, 60736, 60765, 60795, 60824, 60853, 60883, 60912, 60942, 60972, 61002, 61031, 61061,
    61090, 61120, 61149, 61179, 61208, 61237, 61267, 61296, 61326, 61356, 61385, 61415, 61445, 61474, 61504, 61533, 61563, 61592, 61621, 61651,
    61680, 61710, 61739, 61769, 61799, 61828, 61858, 61888, 61917, 61947, 61976, 62006, 62035, 62064, 62094, 62123, 62153, 62182, 62212, 62242,
    62271, 62301, 62331, 62360, 62390, 62419, 62448, 62478, 62507, 62537, 62566, 62596, 62625, 62655, 62685, 62715, 62744, 62774, 62803, 62832,
    62862, 62891, 62921, 62950, 62980, 63009, 63039, 63069, 63099, 63128, 63157, 63187, 63216, 63246, 63275, 63305, 63334, 63363, 63393, 63423,
    63453, 63482, 63512, 63541, 63571, 63600, 63630, 63659, 63689, 63718, 63747, 63777, 63807, 63836, 63866, 63895, 63925, 63955, 63984, 64014,
    64043, 64073, 64102, 64131, 64161, 64190, 64220, 64249, 64279, 64309, 64339, 64368, 64398, 64427, 64457, 64486, 64515, 64545, 64574, 64603,
    64633, 64663, 64692, 64722, 64752, 64782, 64811, 64841, 64870, 64899, 64929, 64958, 64987, 65017, 65047, 65076, 65106, 65136, 65166, 65195,
    65225, 65254, 65283, 65313, 65342, 65371, 65401, 65431, 65460, 65490, 65520, 65549, 65579, 65608, 65638, 65667, 65697, 65726, 65755, 65785,
    65815, 65844, 65874, 65903, 65933, 65963, 65992, 66022, 66051, 66081, 66110, 66140, 66169, 66199, 66228, 66258, 66287, 66317, 66346, 66376,
    66405, 66435, 66465, 66494, 66524, 66553, 66583, 66612, 66641, 66671, 66700, 66730, 66760, 66789, 66819, 66849, 66878, 66908, 66937, 66967,
    66996, 67025, 67055, 67084, 67114, 67143, 67173, 67203, 67233, 67262, 67292, 67321, 67351, 67380, 67409, 67439, 67468, 67497, 67527, 67557,
    67587, 67617, 67646, 67676, 67705, 67735, 67764, 67793, 67823, 67852, 67882, 67911, 67941, 67971, 68000, 68030, 68060, 68089, 68119, 68148,
    68177, 68207, 68236, 68266, 68295, 68325, 68354, 68384, 68414, 68443, 68473, 68502, 68532, 68561, 68591, 68620, 68650, 68679, 68708, 68738,
    68768, 68797, 68827, 68857, 68886, 68916, 68946, 68975, 69004, 69034, 69063, 69092, 69122, 69152, 69181, 69211, 69240, 69270, 69300, 69330,
    69359, 69388, 69418, 69447, 69476, 69506, 69535, 69565, 69595, 69624, 69654, 69684, 69713, 69743, 69772, 69802, 69831, 69861, 69890, 69919,
    69949, 69978, 70008, 70038, 70067, 70097, 70126, 70156, 70186, 70215, 70245, 70274, 70303, 70333, 70362, 70392, 70421, 70451, 70481, 70510,
    70540, 70570, 70599, 70629, 70658, 70687, 70717, 70746, 70776, 70805, 70835, 70864, 70894, 70924, 70954, 70983, 71013, 71042, 71071, 71101,
    71130, 71159, 71189, 71218, 71248, 71278, 71308, 71337, 71367, 71397, 71426, 71455, 71485, 71514, 71543, 71573, 71602, 71632, 71662, 71691,
    71721, 71751, 71781, 71810, 71839, 71869, 71898, 71927, 71957, 71986, 72016, 72046, 72075, 72105, 72135, 72164, 72194, 72223, 72253, 72282,
    72311, 72341, 72370, 72400, 72429, 72459, 72489, 72518, 72548, 72577, 72607, 72637, 72666, 72695, 72725, 72754, 72784, 72813, 72843, 72872,
    72902, 72931, 72961, 72991, 73020, 73050, 73080, 73109, 73139, 73168, 73197, 73227, 73256, 73286, 73315, 73345, 73375, 73404, 73434, 73464,
    73493, 73523, 73552, 73581, 73611, 73640, 73669, 73699, 73729, 73758, 73788, 73818, 73848, 73877, 73907, 73936, 73965, 73995, 74024, 74053,
    74083, 74113, 74142, 74172, 74202, 74231, 74261, 74291, 74320, 74349, 74379, 74408, 74437, 74467, 74497, 74526, 74556, 74586, 74615, 74645,
    74675, 74704, 74733, 74763, 74792, 74822, 74851, 74881, 74910, 74940, 74969, 74999, 75029, 75058, 75088, 75117, 75147, 75176, 75206, 75235,
    75264, 75294, 75323, 75353, 75383, 75412, 75442, 75472, 75501, 75531, 75560, 75590, 75619, 75648, 75678, 75707, 75737, 75766, 75796, 75826,
    75856, 75885, 75915, 75944, 75974, 76003, 76032, 76062, 76091, 76121, 76150, 76180, 76210, 76239, 76269, 76299, 76328, 76358, 76387, 76416,
    76446, 76475, 76505, 76534, 76564, 76593, 76623, 76653, 76682, 76712, 76741, 76771, 76801, 76830, 76859, 76889, 76918, 76948, 76977, 77007,
    77036, 77066, 77096, 77125, 77155, 77185, 77214, 77243, 77273, 77302, 77332, 77361, 77390, 77420, 77450, 77479, 77509, 77539, 77569, 77598,
    77627, 77657, 77686, 77715, 77745, 77774, 77804, 77833, 77863, 77893, 77923, 77952, 77982, 78011, 78041, 78070, 78099, 78129, 78158, 78188,
    78217, 78247, 78277, 78307, 78336, 78366, 78395, 78425, 78454, 78483, 78513, 78542, 78572, 78601, 78631, 78661, 78690, 78720, 78750, 78779,
    78808, 78838, 78867, 78897, 78926, 78956, 78985, 79015, 79044, 79074, 79104, 79133, 79163, 79192, 79222, 79251, 79281, 79310, 79340, 79369,
    79399, 79428, 79458, 79487, 79517, 79546, 79576, 79606, 79635, 79665, 79695, 79724, 79753, 79783, 79812, 79841, 79871, 79900, 79930, 79960,
    79990];



/***/ }),

/***/ 24453:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/*
 * World Calendars
 * https://github.com/alexcjohnson/world-calendars
 *
 * Batch-converted from kbwood/calendars
 * Many thanks to Keith Wood and all of the contributors to the original project!
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

﻿/* http://keith-wood.name/calendars.html
   Calendars for jQuery v2.0.2.
   Written by Keith Wood (wood.keith{at}optusnet.com.au) August 2009.
   Available under the MIT (http://keith-wood.name/licence.html) license. 
   Please attribute the author if you use it. */

var assign = __webpack_require__(27976);


function Calendars() {
    this.regionalOptions = [];
    this.regionalOptions[''] = {
        invalidCalendar: 'Calendar {0} not found',
        invalidDate: 'Invalid {0} date',
        invalidMonth: 'Invalid {0} month',
        invalidYear: 'Invalid {0} year',
        differentCalendars: 'Cannot mix {0} and {1} dates'
    };
    this.local = this.regionalOptions[''];
    this.calendars = {};
    this._localCals = {};
}

/** Create the calendars plugin.
    <p>Provides support for various world calendars in a consistent manner.</p>
     @class Calendars
    @example _exports.instance('julian').newDate(2014, 12, 25) */
assign(Calendars.prototype, {

    /** Obtain a calendar implementation and localisation.
        @memberof Calendars
        @param [name='gregorian'] {string} The name of the calendar, e.g. 'gregorian', 'persian', 'islamic'.
        @param [language=''] {string} The language code to use for localisation (default is English).
        @return {Calendar} The calendar and localisation.
        @throws Error if calendar not found. */
    instance: function(name, language) {
        name = (name || 'gregorian').toLowerCase();
        language = language || '';
        var cal = this._localCals[name + '-' + language];
        if (!cal && this.calendars[name]) {
            cal = new this.calendars[name](language);
            this._localCals[name + '-' + language] = cal;
        }
        if (!cal) {
            throw (this.local.invalidCalendar || this.regionalOptions[''].invalidCalendar).
                replace(/\{0\}/, name);
        }
        return cal;
    },

    /** Create a new date - for today if no other parameters given.
        @memberof Calendars
        @param year {CDate|number} The date to copy or the year for the date.
        @param [month] {number} The month for the date.
        @param [day] {number} The day for the date.
        @param [calendar='gregorian'] {BaseCalendar|string} The underlying calendar or the name of the calendar.
        @param [language=''] {string} The language to use for localisation (default English).
        @return {CDate} The new date.
        @throws Error if an invalid date. */
    newDate: function(year, month, day, calendar, language) {
        calendar = (year != null && year.year ? year.calendar() : (typeof calendar === 'string' ?
            this.instance(calendar, language) : calendar)) || this.instance();
        return calendar.newDate(year, month, day);
    },
    
    /** A simple digit substitution function for localising numbers via the Calendar digits option.
        @member Calendars
        @param digits {string[]} The substitute digits, for 0 through 9.
        @return {function} The substitution function. */
    substituteDigits: function(digits) {
        return function(value) {
            return (value + '').replace(/[0-9]/g, function(digit) {
                return digits[digit];
            });
        }
    },
    
    /** Digit substitution function for localising Chinese style numbers via the Calendar digits option.
        @member Calendars
        @param digits {string[]} The substitute digits, for 0 through 9.
        @param powers {string[]} The characters denoting powers of 10, i.e. 1, 10, 100, 1000.
        @return {function} The substitution function. */
    substituteChineseDigits: function(digits, powers) {
        return function(value) {
            var localNumber = '';
            var power = 0;
            while (value > 0) {
                var units = value % 10;
                localNumber = (units === 0 ? '' : digits[units] + powers[power]) + localNumber;
                power++;
                value = Math.floor(value / 10);
            }
            if (localNumber.indexOf(digits[1] + powers[1]) === 0) {
                localNumber = localNumber.substr(1);
            }
            return localNumber || digits[0];
        }
    }
});

/** Generic date, based on a particular calendar.
    @class CDate
    @param calendar {BaseCalendar} The underlying calendar implementation.
    @param year {number} The year for this date.
    @param month {number} The month for this date.
    @param day {number} The day for this date.
    @return {CDate} The date object.
    @throws Error if an invalid date. */
function CDate(calendar, year, month, day) {
    this._calendar = calendar;
    this._year = year;
    this._month = month;
    this._day = day;
    if (this._calendar._validateLevel === 0 &&
            !this._calendar.isValid(this._year, this._month, this._day)) {
        throw (_exports.local.invalidDate || _exports.regionalOptions[''].invalidDate).
            replace(/\{0\}/, this._calendar.local.name);
    }
}

/** Pad a numeric value with leading zeroes.
    @private
    @param value {number} The number to format.
    @param length {number} The minimum length.
    @return {string} The formatted number. */
function pad(value, length) {
    value = '' + value;
    return '000000'.substring(0, length - value.length) + value;
}

assign(CDate.prototype, {

    /** Create a new date.
        @memberof CDate
        @param [year] {CDate|number} The date to copy or the year for the date (default this date).
        @param [month] {number} The month for the date.
        @param [day] {number} The day for the date.
        @return {CDate} The new date.
        @throws Error if an invalid date. */
    newDate: function(year, month, day) {
        return this._calendar.newDate((year == null ? this : year), month, day);
    },

    /** Set or retrieve the year for this date.
        @memberof CDate
        @param [year] {number} The year for the date.
        @return {number|CDate} The date's year (if no parameter) or the updated date.
        @throws Error if an invalid date. */
    year: function(year) {
        return (arguments.length === 0 ? this._year : this.set(year, 'y'));
    },

    /** Set or retrieve the month for this date.
        @memberof CDate
        @param [month] {number} The month for the date.
        @return {number|CDate} The date's month (if no parameter) or the updated date.
        @throws Error if an invalid date. */
    month: function(month) {
        return (arguments.length === 0 ? this._month : this.set(month, 'm'));
    },

    /** Set or retrieve the day for this date.
        @memberof CDate
        @param [day] {number} The day for the date.
        @return {number|CData} The date's day (if no parameter) or the updated date.
        @throws Error if an invalid date. */
    day: function(day) {
        return (arguments.length === 0 ? this._day : this.set(day, 'd'));
    },

    /** Set new values for this date.
        @memberof CDate
        @param year {number} The year for the date.
        @param month {number} The month for the date.
        @param day {number} The day for the date.
        @return {CDate} The updated date.
        @throws Error if an invalid date. */
    date: function(year, month, day) {
        if (!this._calendar.isValid(year, month, day)) {
            throw (_exports.local.invalidDate || _exports.regionalOptions[''].invalidDate).
                replace(/\{0\}/, this._calendar.local.name);
        }
        this._year = year;
        this._month = month;
        this._day = day;
        return this;
    },

    /** Determine whether this date is in a leap year.
        @memberof CDate
        @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not. */
    leapYear: function() {
        return this._calendar.leapYear(this);
    },

    /** Retrieve the epoch designator for this date, e.g. BCE or CE.
        @memberof CDate
        @return {string} The current epoch. */
    epoch: function() {
        return this._calendar.epoch(this);
    },

    /** Format the year, if not a simple sequential number.
        @memberof CDate
        @return {string} The formatted year. */
    formatYear: function() {
        return this._calendar.formatYear(this);
    },

    /** Retrieve the month of the year for this date,
        i.e. the month's position within a numbered year.
        @memberof CDate
        @return {number} The month of the year: <code>minMonth</code> to months per year. */
    monthOfYear: function() {
        return this._calendar.monthOfYear(this);
    },

    /** Retrieve the week of the year for this date.
        @memberof CDate
        @return {number} The week of the year: 1 to weeks per year. */
    weekOfYear: function() {
        return this._calendar.weekOfYear(this);
    },

    /** Retrieve the number of days in the year for this date.
        @memberof CDate
        @return {number} The number of days in this year. */
    daysInYear: function() {
        return this._calendar.daysInYear(this);
    },

    /** Retrieve the day of the year for this date.
        @memberof CDate
        @return {number} The day of the year: 1 to days per year. */
    dayOfYear: function() {
        return this._calendar.dayOfYear(this);
    },

    /** Retrieve the number of days in the month for this date.
        @memberof CDate
        @return {number} The number of days. */
    daysInMonth: function() {
        return this._calendar.daysInMonth(this);
    },

    /** Retrieve the day of the week for this date.
        @memberof CDate
        @return {number} The day of the week: 0 to number of days - 1. */
    dayOfWeek: function() {
        return this._calendar.dayOfWeek(this);
    },

    /** Determine whether this date is a week day.
        @memberof CDate
        @return {boolean} <code>true</code> if a week day, <code>false</code> if not. */
    weekDay: function() {
        return this._calendar.weekDay(this);
    },

    /** Retrieve additional information about this date.
        @memberof CDate
        @return {object} Additional information - contents depends on calendar. */
    extraInfo: function() {
        return this._calendar.extraInfo(this);
    },

    /** Add period(s) to a date.
        @memberof CDate
        @param offset {number} The number of periods to adjust by.
        @param period {string} One of 'y' for year, 'm' for month, 'w' for week, 'd' for day.
        @return {CDate} The updated date. */
    add: function(offset, period) {
        return this._calendar.add(this, offset, period);
    },

    /** Set a portion of the date.
        @memberof CDate
        @param value {number} The new value for the period.
        @param period {string} One of 'y' for year, 'm' for month, 'd' for day.
        @return {CDate} The updated date.
        @throws Error if not a valid date. */
    set: function(value, period) {
        return this._calendar.set(this, value, period);
    },

    /** Compare this date to another date.
        @memberof CDate
        @param date {CDate} The other date.
        @return {number} -1 if this date is before the other date,
                0 if they are equal, or +1 if this date is after the other date. */
    compareTo: function(date) {
        if (this._calendar.name !== date._calendar.name) {
            throw (_exports.local.differentCalendars || _exports.regionalOptions[''].differentCalendars).
                replace(/\{0\}/, this._calendar.local.name).replace(/\{1\}/, date._calendar.local.name);
        }
        var c = (this._year !== date._year ? this._year - date._year :
            this._month !== date._month ? this.monthOfYear() - date.monthOfYear() :
            this._day - date._day);
        return (c === 0 ? 0 : (c < 0 ? -1 : +1));
    },

    /** Retrieve the calendar backing this date.
        @memberof CDate
        @return {BaseCalendar} The calendar implementation. */
    calendar: function() {
        return this._calendar;
    },

    /** Retrieve the Julian date equivalent for this date,
        i.e. days since January 1, 4713 BCE Greenwich noon.
        @memberof CDate
        @return {number} The equivalent Julian date. */
    toJD: function() {
        return this._calendar.toJD(this);
    },

    /** Create a new date from a Julian date.
        @memberof CDate
        @param jd {number} The Julian date to convert.
        @return {CDate} The equivalent date. */
    fromJD: function(jd) {
        return this._calendar.fromJD(jd);
    },

    /** Convert this date to a standard (Gregorian) JavaScript Date.
        @memberof CDate
        @return {Date} The equivalent JavaScript date. */
    toJSDate: function() {
        return this._calendar.toJSDate(this);
    },

    /** Create a new date from a standard (Gregorian) JavaScript Date.
        @memberof CDate
        @param jsd {Date} The JavaScript date to convert.
        @return {CDate} The equivalent date. */
    fromJSDate: function(jsd) {
        return this._calendar.fromJSDate(jsd);
    },

    /** Convert to a string for display.
        @memberof CDate
        @return {string} This date as a string. */
    toString: function() {
        return (this.year() < 0 ? '-' : '') + pad(Math.abs(this.year()), 4) +
            '-' + pad(this.month(), 2) + '-' + pad(this.day(), 2);
    }
});

/** Basic functionality for all calendars.
    Other calendars should extend this:
    <pre>OtherCalendar.prototype = new BaseCalendar;</pre>
    @class BaseCalendar */
function BaseCalendar() {
    this.shortYearCutoff = '+10';
}

assign(BaseCalendar.prototype, {
    _validateLevel: 0, // "Stack" to turn validation on/off

    /** Create a new date within this calendar - today if no parameters given.
        @memberof BaseCalendar
        @param year {CDate|number} The date to duplicate or the year for the date.
        @param [month] {number} The month for the date.
        @param [day] {number} The day for the date.
        @return {CDate} The new date.
        @throws Error if not a valid date or a different calendar used. */
    newDate: function(year, month, day) {
        if (year == null) {
            return this.today();
        }
        if (year.year) {
            this._validate(year, month, day,
                _exports.local.invalidDate || _exports.regionalOptions[''].invalidDate);
            day = year.day();
            month = year.month();
            year = year.year();
        }
        return new CDate(this, year, month, day);
    },

    /** Create a new date for today.
        @memberof BaseCalendar
        @return {CDate} Today's date. */
    today: function() {
        return this.fromJSDate(new Date());
    },

    /** Retrieve the epoch designator for this date.
        @memberof BaseCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @return {string} The current epoch.
        @throws Error if an invalid year or a different calendar used. */
    epoch: function(year) {
        var date = this._validate(year, this.minMonth, this.minDay,
            _exports.local.invalidYear || _exports.regionalOptions[''].invalidYear);
        return (date.year() < 0 ? this.local.epochs[0] : this.local.epochs[1]);
    },

    /** Format the year, if not a simple sequential number
        @memberof BaseCalendar
        @param year {CDate|number} The date to format or the year to format.
        @return {string} The formatted year.
        @throws Error if an invalid year or a different calendar used. */
    formatYear: function(year) {
        var date = this._validate(year, this.minMonth, this.minDay,
            _exports.local.invalidYear || _exports.regionalOptions[''].invalidYear);
        return (date.year() < 0 ? '-' : '') + pad(Math.abs(date.year()), 4)
    },

    /** Retrieve the number of months in a year.
        @memberof BaseCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @return {number} The number of months.
        @throws Error if an invalid year or a different calendar used. */
    monthsInYear: function(year) {
        this._validate(year, this.minMonth, this.minDay,
            _exports.local.invalidYear || _exports.regionalOptions[''].invalidYear);
        return 12;
    },

    /** Calculate the month's ordinal position within the year -
        for those calendars that don't start at month 1!
        @memberof BaseCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @param month {number} The month to examine.
        @return {number} The ordinal position, starting from <code>minMonth</code>.
        @throws Error if an invalid year/month or a different calendar used. */
    monthOfYear: function(year, month) {
        var date = this._validate(year, month, this.minDay,
            _exports.local.invalidMonth || _exports.regionalOptions[''].invalidMonth);
        return (date.month() + this.monthsInYear(date) - this.firstMonth) %
            this.monthsInYear(date) + this.minMonth;
    },

    /** Calculate actual month from ordinal position, starting from minMonth.
        @memberof BaseCalendar
        @param year {number} The year to examine.
        @param ord {number} The month's ordinal position.
        @return {number} The month's number.
        @throws Error if an invalid year/month. */
    fromMonthOfYear: function(year, ord) {
        var m = (ord + this.firstMonth - 2 * this.minMonth) %
            this.monthsInYear(year) + this.minMonth;
        this._validate(year, m, this.minDay,
            _exports.local.invalidMonth || _exports.regionalOptions[''].invalidMonth);
        return m;
    },

    /** Retrieve the number of days in a year.
        @memberof BaseCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @return {number} The number of days.
        @throws Error if an invalid year or a different calendar used. */
    daysInYear: function(year) {
        var date = this._validate(year, this.minMonth, this.minDay,
            _exports.local.invalidYear || _exports.regionalOptions[''].invalidYear);
        return (this.leapYear(date) ? 366 : 365);
    },

    /** Retrieve the day of the year for a date.
        @memberof BaseCalendar
        @param year {CDate|number} The date to convert or the year to convert.
        @param [month] {number} The month to convert.
        @param [day] {number} The day to convert.
        @return {number} The day of the year.
        @throws Error if an invalid date or a different calendar used. */
    dayOfYear: function(year, month, day) {
        var date = this._validate(year, month, day,
            _exports.local.invalidDate || _exports.regionalOptions[''].invalidDate);
        return date.toJD() - this.newDate(date.year(),
            this.fromMonthOfYear(date.year(), this.minMonth), this.minDay).toJD() + 1;
    },

    /** Retrieve the number of days in a week.
        @memberof BaseCalendar
        @return {number} The number of days. */
    daysInWeek: function() {
        return 7;
    },

    /** Retrieve the day of the week for a date.
        @memberof BaseCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @param [month] {number} The month to examine.
        @param [day] {number} The day to examine.
        @return {number} The day of the week: 0 to number of days - 1.
        @throws Error if an invalid date or a different calendar used. */
    dayOfWeek: function(year, month, day) {
        var date = this._validate(year, month, day,
            _exports.local.invalidDate || _exports.regionalOptions[''].invalidDate);
        return (Math.floor(this.toJD(date)) + 2) % this.daysInWeek();
    },

    /** Retrieve additional information about a date.
        @memberof BaseCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @param [month] {number} The month to examine.
        @param [day] {number} The day to examine.
        @return {object} Additional information - contents depends on calendar.
        @throws Error if an invalid date or a different calendar used. */
    extraInfo: function(year, month, day) {
        this._validate(year, month, day,
            _exports.local.invalidDate || _exports.regionalOptions[''].invalidDate);
        return {};
    },

    /** Add period(s) to a date.
        Cater for no year zero.
        @memberof BaseCalendar
        @param date {CDate} The starting date.
        @param offset {number} The number of periods to adjust by.
        @param period {string} One of 'y' for year, 'm' for month, 'w' for week, 'd' for day.
        @return {CDate} The updated date.
        @throws Error if a different calendar used. */
    add: function(date, offset, period) {
        this._validate(date, this.minMonth, this.minDay,
            _exports.local.invalidDate || _exports.regionalOptions[''].invalidDate);
        return this._correctAdd(date, this._add(date, offset, period), offset, period);
    },

    /** Add period(s) to a date.
        @memberof BaseCalendar
        @private
        @param date {CDate} The starting date.
        @param offset {number} The number of periods to adjust by.
        @param period {string} One of 'y' for year, 'm' for month, 'w' for week, 'd' for day.
        @return {CDate} The updated date. */
    _add: function(date, offset, period) {
        this._validateLevel++;
        if (period === 'd' || period === 'w') {
            var jd = date.toJD() + offset * (period === 'w' ? this.daysInWeek() : 1);
            var d = date.calendar().fromJD(jd);
            this._validateLevel--;
            return [d.year(), d.month(), d.day()];
        }
        try {
            var y = date.year() + (period === 'y' ? offset : 0);
            var m = date.monthOfYear() + (period === 'm' ? offset : 0);
            var d = date.day();// + (period === 'd' ? offset : 0) +
                //(period === 'w' ? offset * this.daysInWeek() : 0);
            var resyncYearMonth = function(calendar) {
                while (m < calendar.minMonth) {
                    y--;
                    m += calendar.monthsInYear(y);
                }
                var yearMonths = calendar.monthsInYear(y);
                while (m > yearMonths - 1 + calendar.minMonth) {
                    y++;
                    m -= yearMonths;
                    yearMonths = calendar.monthsInYear(y);
                }
            };
            if (period === 'y') {
                if (date.month() !== this.fromMonthOfYear(y, m)) { // Hebrew
                    m = this.newDate(y, date.month(), this.minDay).monthOfYear();
                }
                m = Math.min(m, this.monthsInYear(y));
                d = Math.min(d, this.daysInMonth(y, this.fromMonthOfYear(y, m)));
            }
            else if (period === 'm') {
                resyncYearMonth(this);
                d = Math.min(d, this.daysInMonth(y, this.fromMonthOfYear(y, m)));
            }
            var ymd = [y, this.fromMonthOfYear(y, m), d];
            this._validateLevel--;
            return ymd;
        }
        catch (e) {
            this._validateLevel--;
            throw e;
        }
    },

    /** Correct a candidate date after adding period(s) to a date.
        Handle no year zero if necessary.
        @memberof BaseCalendar
        @private
        @param date {CDate} The starting date.
        @param ymd {number[]} The added date.
        @param offset {number} The number of periods to adjust by.
        @param period {string} One of 'y' for year, 'm' for month, 'w' for week, 'd' for day.
        @return {CDate} The updated date. */
    _correctAdd: function(date, ymd, offset, period) {
        if (!this.hasYearZero && (period === 'y' || period === 'm')) {
            if (ymd[0] === 0 || // In year zero
                    (date.year() > 0) !== (ymd[0] > 0)) { // Crossed year zero
                var adj = {y: [1, 1, 'y'], m: [1, this.monthsInYear(-1), 'm'],
                    w: [this.daysInWeek(), this.daysInYear(-1), 'd'],
                    d: [1, this.daysInYear(-1), 'd']}[period];
                var dir = (offset < 0 ? -1 : +1);
                ymd = this._add(date, offset * adj[0] + dir * adj[1], adj[2]);
            }
        }
        return date.date(ymd[0], ymd[1], ymd[2]);
    },

    /** Set a portion of the date.
        @memberof BaseCalendar
        @param date {CDate} The starting date.
        @param value {number} The new value for the period.
        @param period {string} One of 'y' for year, 'm' for month, 'd' for day.
        @return {CDate} The updated date.
        @throws Error if an invalid date or a different calendar used. */
    set: function(date, value, period) {
        this._validate(date, this.minMonth, this.minDay,
            _exports.local.invalidDate || _exports.regionalOptions[''].invalidDate);
        var y = (period === 'y' ? value : date.year());
        var m = (period === 'm' ? value : date.month());
        var d = (period === 'd' ? value : date.day());
        if (period === 'y' || period === 'm') {
            d = Math.min(d, this.daysInMonth(y, m));
        }
        return date.date(y, m, d);
    },

    /** Determine whether a date is valid for this calendar.
        @memberof BaseCalendar
        @param year {number} The year to examine.
        @param month {number} The month to examine.
        @param day {number} The day to examine.
        @return {boolean} <code>true</code> if a valid date, <code>false</code> if not. */
    isValid: function(year, month, day) {
        this._validateLevel++;
        var valid = (this.hasYearZero || year !== 0);
        if (valid) {
            var date = this.newDate(year, month, this.minDay);
            valid = (month >= this.minMonth && month - this.minMonth < this.monthsInYear(date)) &&
                (day >= this.minDay && day - this.minDay < this.daysInMonth(date));
        }
        this._validateLevel--;
        return valid;
    },

    /** Convert the date to a standard (Gregorian) JavaScript Date.
        @memberof BaseCalendar
        @param year {CDate|number} The date to convert or the year to convert.
        @param [month] {number} The month to convert.
        @param [day] {number} The day to convert.
        @return {Date} The equivalent JavaScript date.
        @throws Error if an invalid date or a different calendar used. */
    toJSDate: function(year, month, day) {
        var date = this._validate(year, month, day,
            _exports.local.invalidDate || _exports.regionalOptions[''].invalidDate);
        return _exports.instance().fromJD(this.toJD(date)).toJSDate();
    },

    /** Convert the date from a standard (Gregorian) JavaScript Date.
        @memberof BaseCalendar
        @param jsd {Date} The JavaScript date.
        @return {CDate} The equivalent calendar date. */
    fromJSDate: function(jsd) {
        return this.fromJD(_exports.instance().fromJSDate(jsd).toJD());
    },

    /** Check that a candidate date is from the same calendar and is valid.
        @memberof BaseCalendar
        @private
        @param year {CDate|number} The date to validate or the year to validate.
        @param [month] {number} The month to validate.
        @param [day] {number} The day to validate.
        @param error {string} Rrror message if invalid.
        @throws Error if different calendars used or invalid date. */
    _validate: function(year, month, day, error) {
        if (year.year) {
            if (this._validateLevel === 0 && this.name !== year.calendar().name) {
                throw (_exports.local.differentCalendars || _exports.regionalOptions[''].differentCalendars).
                    replace(/\{0\}/, this.local.name).replace(/\{1\}/, year.calendar().local.name);
            }
            return year;
        }
        try {
            this._validateLevel++;
            if (this._validateLevel === 1 && !this.isValid(year, month, day)) {
                throw error.replace(/\{0\}/, this.local.name);
            }
            var date = this.newDate(year, month, day);
            this._validateLevel--;
            return date;
        }
        catch (e) {
            this._validateLevel--;
            throw e;
        }
    }
});

/** Implementation of the Proleptic Gregorian Calendar.
    See <a href=":http://en.wikipedia.org/wiki/Gregorian_calendar">http://en.wikipedia.org/wiki/Gregorian_calendar</a>
    and <a href="http://en.wikipedia.org/wiki/Proleptic_Gregorian_calendar">http://en.wikipedia.org/wiki/Proleptic_Gregorian_calendar</a>.
    @class GregorianCalendar
    @augments BaseCalendar
    @param [language=''] {string} The language code (default English) for localisation. */
function GregorianCalendar(language) {
    this.local = this.regionalOptions[language] || this.regionalOptions[''];
}

GregorianCalendar.prototype = new BaseCalendar;

assign(GregorianCalendar.prototype, {
    /** The calendar name.
        @memberof GregorianCalendar */
    name: 'Gregorian',
     /** Julian date of start of Gregorian epoch: 1 January 0001 CE.
        @memberof GregorianCalendar */
    jdEpoch: 1721425.5,
     /** Days per month in a common year.
        @memberof GregorianCalendar */
    daysPerMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
     /** <code>true</code> if has a year zero, <code>false</code> if not.
        @memberof GregorianCalendar */
    hasYearZero: false,
    /** The minimum month number.
        @memberof GregorianCalendar */
    minMonth: 1,
    /** The first month in the year.
        @memberof GregorianCalendar */
    firstMonth: 1,
     /** The minimum day number.
        @memberof GregorianCalendar */
    minDay: 1,

    /** Localisations for the plugin.
        Entries are objects indexed by the language code ('' being the default US/English).
        Each object has the following attributes.
        @memberof GregorianCalendar
        @property name {string} The calendar name.
        @property epochs {string[]} The epoch names.
        @property monthNames {string[]} The long names of the months of the year.
        @property monthNamesShort {string[]} The short names of the months of the year.
        @property dayNames {string[]} The long names of the days of the week.
        @property dayNamesShort {string[]} The short names of the days of the week.
        @property dayNamesMin {string[]} The minimal names of the days of the week.
        @property dateFormat {string} The date format for this calendar.
                See the options on <a href="BaseCalendar.html#formatDate"><code>formatDate</code></a> for details.
        @property firstDay {number} The number of the first day of the week, starting at 0.
        @property isRTL {number} <code>true</code> if this localisation reads right-to-left. */
    regionalOptions: { // Localisations
        '': {
            name: 'Gregorian',
            epochs: ['BCE', 'CE'],
            monthNames: ['January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'],
            monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
            dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
            dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
            digits: null,
            dateFormat: 'mm/dd/yyyy',
            firstDay: 0,
            isRTL: false
        }
    },
    
    /** Determine whether this date is in a leap year.
        @memberof GregorianCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not.
        @throws Error if an invalid year or a different calendar used. */
    leapYear: function(year) {
        var date = this._validate(year, this.minMonth, this.minDay,
            _exports.local.invalidYear || _exports.regionalOptions[''].invalidYear);
        var year = date.year() + (date.year() < 0 ? 1 : 0); // No year zero
        return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
    },

    /** Determine the week of the year for a date - ISO 8601.
        @memberof GregorianCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @param [month] {number} The month to examine.
        @param [day] {number} The day to examine.
        @return {number} The week of the year, starting from 1.
        @throws Error if an invalid date or a different calendar used. */
    weekOfYear: function(year, month, day) {
        // Find Thursday of this week starting on Monday
        var checkDate = this.newDate(year, month, day);
        checkDate.add(4 - (checkDate.dayOfWeek() || 7), 'd');
        return Math.floor((checkDate.dayOfYear() - 1) / 7) + 1;
    },

    /** Retrieve the number of days in a month.
        @memberof GregorianCalendar
        @param year {CDate|number} The date to examine or the year of the month.
        @param [month] {number} The month.
        @return {number} The number of days in this month.
        @throws Error if an invalid month/year or a different calendar used. */
    daysInMonth: function(year, month) {
        var date = this._validate(year, month, this.minDay,
            _exports.local.invalidMonth || _exports.regionalOptions[''].invalidMonth);
        return this.daysPerMonth[date.month() - 1] +
            (date.month() === 2 && this.leapYear(date.year()) ? 1 : 0);
    },

    /** Determine whether this date is a week day.
        @memberof GregorianCalendar
        @param year {CDate|number} The date to examine or the year to examine.
        @param [month] {number} The month to examine.
        @param [day] {number} The day to examine.
        @return {boolean} <code>true</code> if a week day, <code>false</code> if not.
        @throws Error if an invalid date or a different calendar used. */
    weekDay: function(year, month, day) {
        return (this.dayOfWeek(year, month, day) || 7) < 6;
    },

    /** Retrieve the Julian date equivalent for this date,
        i.e. days since January 1, 4713 BCE Greenwich noon.
        @memberof GregorianCalendar
        @param year {CDate|number} The date to convert or the year to convert.
        @param [month] {number} The month to convert.
        @param [day] {number} The day to convert.
        @return {number} The equivalent Julian date.
        @throws Error if an invalid date or a different calendar used. */
    toJD: function(year, month, day) {
        var date = this._validate(year, month, day,
            _exports.local.invalidDate || _exports.regionalOptions[''].invalidDate);
        year = date.year();
        month = date.month();
        day = date.day();
        if (year < 0) { year++; } // No year zero
        // Jean Meeus algorithm, "Astronomical Algorithms", 1991
        if (month < 3) {
            month += 12;
            year--;
        }
        var a = Math.floor(year / 100);
        var b = 2 - a + Math.floor(a / 4);
        return Math.floor(365.25 * (year + 4716)) +
            Math.floor(30.6001 * (month + 1)) + day + b - 1524.5;
    },

    /** Create a new date from a Julian date.
        @memberof GregorianCalendar
        @param jd {number} The Julian date to convert.
        @return {CDate} The equivalent date. */
    fromJD: function(jd) {
        // Jean Meeus algorithm, "Astronomical Algorithms", 1991
        var z = Math.floor(jd + 0.5);
        var a = Math.floor((z - 1867216.25) / 36524.25);
        a = z + 1 + a - Math.floor(a / 4);
        var b = a + 1524;
        var c = Math.floor((b - 122.1) / 365.25);
        var d = Math.floor(365.25 * c);
        var e = Math.floor((b - d) / 30.6001);
        var day = b - d - Math.floor(e * 30.6001);
        var month = e - (e > 13.5 ? 13 : 1);
        var year = c - (month > 2.5 ? 4716 : 4715);
        if (year <= 0) { year--; } // No year zero
        return this.newDate(year, month, day);
    },

    /** Convert this date to a standard (Gregorian) JavaScript Date.
        @memberof GregorianCalendar
        @param year {CDate|number} The date to convert or the year to convert.
        @param [month] {number} The month to convert.
        @param [day] {number} The day to convert.
        @return {Date} The equivalent JavaScript date.
        @throws Error if an invalid date or a different calendar used. */
    toJSDate: function(year, month, day) {
        var date = this._validate(year, month, day,
            _exports.local.invalidDate || _exports.regionalOptions[''].invalidDate);
        var jsd = new Date(date.year(), date.month() - 1, date.day());
        jsd.setHours(0);
        jsd.setMinutes(0);
        jsd.setSeconds(0);
        jsd.setMilliseconds(0);
        // Hours may be non-zero on daylight saving cut-over:
        // > 12 when midnight changeover, but then cannot generate
        // midnight datetime, so jump to 1AM, otherwise reset.
        jsd.setHours(jsd.getHours() > 12 ? jsd.getHours() + 2 : 0);
        return jsd;
    },

    /** Create a new date from a standard (Gregorian) JavaScript Date.
        @memberof GregorianCalendar
        @param jsd {Date} The JavaScript date to convert.
        @return {CDate} The equivalent date. */
    fromJSDate: function(jsd) {
        return this.newDate(jsd.getFullYear(), jsd.getMonth() + 1, jsd.getDate());
    }
});

// Singleton manager
var _exports = module.exports = new Calendars();

// Date template
_exports.cdate = CDate;

// Base calendar template
_exports.baseCalendar = BaseCalendar;

// Gregorian calendar implementation
_exports.calendars.gregorian = GregorianCalendar;



/***/ }),

/***/ 23428:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

/*
 * World Calendars
 * https://github.com/alexcjohnson/world-calendars
 *
 * Batch-converted from kbwood/calendars
 * Many thanks to Keith Wood and all of the contributors to the original project!
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

﻿/* http://keith-wood.name/calendars.html
   Calendars extras for jQuery v2.0.2.
   Written by Keith Wood (wood.keith{at}optusnet.com.au) August 2009.
   Available under the MIT (http://keith-wood.name/licence.html) license. 
   Please attribute the author if you use it. */

var assign = __webpack_require__(27976);
var main = __webpack_require__(24453);


assign(main.regionalOptions[''], {
    invalidArguments: 'Invalid arguments',
    invalidFormat: 'Cannot format a date from another calendar',
    missingNumberAt: 'Missing number at position {0}',
    unknownNameAt: 'Unknown name at position {0}',
    unexpectedLiteralAt: 'Unexpected literal at position {0}',
    unexpectedText: 'Additional text found at end'
});
main.local = main.regionalOptions[''];

assign(main.cdate.prototype, {

    /** Format this date.
        Found in the <code>jquery.calendars.plus.js</code> module.
        @memberof CDate
        @param [format] {string} The date format to use (see <a href="BaseCalendar.html#formatDate"><code>formatDate</code></a>).
        @param [settings] {object} Options for the <code>formatDate</code> function.
        @return {string} The formatted date. */
    formatDate: function(format, settings) {
        if (typeof format !== 'string') {
            settings = format;
            format = '';
        }
        return this._calendar.formatDate(format || '', this, settings);
    }
});

assign(main.baseCalendar.prototype, {

    UNIX_EPOCH: main.instance().newDate(1970, 1, 1).toJD(),
    SECS_PER_DAY: 24 * 60 * 60,
    TICKS_EPOCH: main.instance().jdEpoch, // 1 January 0001 CE
    TICKS_PER_DAY: 24 * 60 * 60 * 10000000,

    /** Date form for ATOM (RFC 3339/ISO 8601).
        Found in the <code>jquery.calendars.plus.js</code> module.
        @memberof BaseCalendar */
    ATOM: 'yyyy-mm-dd',
    /** Date form for cookies.
        Found in the <code>jquery.calendars.plus.js</code> module.
        @memberof BaseCalendar */
    COOKIE: 'D, dd M yyyy',
    /** Date form for full date.
        Found in the <code>jquery.calendars.plus.js</code> module.
        @memberof BaseCalendar */
    FULL: 'DD, MM d, yyyy',
    /** Date form for ISO 8601.
        Found in the <code>jquery.calendars.plus.js</code> module.
        @memberof BaseCalendar */
    ISO_8601: 'yyyy-mm-dd',
    /** Date form for Julian date.
        Found in the <code>jquery.calendars.plus.js</code> module.
        @memberof BaseCalendar */
    JULIAN: 'J',
    /** Date form for RFC 822.
        Found in the <code>jquery.calendars.plus.js</code> module.
        @memberof BaseCalendar */
    RFC_822: 'D, d M yy',
    /** Date form for RFC 850.
        Found in the <code>jquery.calendars.plus.js</code> module.
        @memberof BaseCalendar */
    RFC_850: 'DD, dd-M-yy',
    /** Date form for RFC 1036.
        Found in the <code>jquery.calendars.plus.js</code> module.
        @memberof BaseCalendar */
    RFC_1036: 'D, d M yy',
    /** Date form for RFC 1123.
        Found in the <code>jquery.calendars.plus.js</code> module.
        @memberof BaseCalendar */
    RFC_1123: 'D, d M yyyy',
    /** Date form for RFC 2822.
        Found in the <code>jquery.calendars.plus.js</code> module.
        @memberof BaseCalendar */
    RFC_2822: 'D, d M yyyy',
    /** Date form for RSS (RFC 822).
        Found in the <code>jquery.calendars.plus.js</code> module.
        @memberof BaseCalendar */
    RSS: 'D, d M yy',
    /** Date form for Windows ticks.
        Found in the <code>jquery.calendars.plus.js</code> module.
        @memberof BaseCalendar */
    TICKS: '!',
    /** Date form for Unix timestamp.
        Found in the <code>jquery.calendars.plus.js</code> module.
        @memberof BaseCalendar */
    TIMESTAMP: '@',
    /** Date form for W3c (ISO 8601).
        Found in the <code>jquery.calendars.plus.js</code> module.
        @memberof BaseCalendar */
    W3C: 'yyyy-mm-dd',

    /** Format a date object into a string value.
        The format can be combinations of the following:
        <ul>
        <li>d  - day of month (no leading zero)</li>
        <li>dd - day of month (two digit)</li>
        <li>o  - day of year (no leading zeros)</li>
        <li>oo - day of year (three digit)</li>
        <li>D  - day name short</li>
        <li>DD - day name long</li>
        <li>w  - week of year (no leading zero)</li>
        <li>ww - week of year (two digit)</li>
        <li>m  - month of year (no leading zero)</li>
        <li>mm - month of year (two digit)</li>
        <li>M  - month name short</li>
        <li>MM - month name long</li>
        <li>yy - year (two digit)</li>
        <li>yyyy - year (four digit)</li>
        <li>YYYY - formatted year</li>
        <li>J  - Julian date (days since January 1, 4713 BCE Greenwich noon)</li>
        <li>@  - Unix timestamp (s since 01/01/1970)</li>
        <li>!  - Windows ticks (100ns since 01/01/0001)</li>
        <li>'...' - literal text</li>
        <li>'' - single quote</li>
        </ul>
        Found in the <code>jquery.calendars.plus.js</code> module.
        @memberof BaseCalendar
        @param [format] {string} The desired format of the date (defaults to calendar format).
        @param date {CDate} The date value to format.
        @param [settings] {object} Addition options, whose attributes include:
        @property [dayNamesShort] {string[]} Abbreviated names of the days from Sunday.
        @property [dayNames] {string[]} Names of the days from Sunday.
        @property [monthNamesShort] {string[]} Abbreviated names of the months.
        @property [monthNames] {string[]} Names of the months.
        @property [calculateWeek] {CalendarsPickerCalculateWeek} Function that determines week of the year.
        @property [localNumbers=false] {boolean} <code>true</code> to localise numbers (if available),
                  <code>false</code> to use normal Arabic numerals.
        @return {string} The date in the above format.
        @throws Errors if the date is from a different calendar. */
    formatDate: function(format, date, settings) {
        if (typeof format !== 'string') {
            settings = date;
            date = format;
            format = '';
        }
        if (!date) {
            return '';
        }
        if (date.calendar() !== this) {
            throw main.local.invalidFormat || main.regionalOptions[''].invalidFormat;
        }
        format = format || this.local.dateFormat;
        settings = settings || {};
        var dayNamesShort = settings.dayNamesShort || this.local.dayNamesShort;
        var dayNames = settings.dayNames || this.local.dayNames;
        var monthNumbers = settings.monthNumbers || this.local.monthNumbers;
        var monthNamesShort = settings.monthNamesShort || this.local.monthNamesShort;
        var monthNames = settings.monthNames || this.local.monthNames;
        var calculateWeek = settings.calculateWeek || this.local.calculateWeek;
        // Check whether a format character is doubled
        var doubled = function(match, step) {
            var matches = 1;
            while (iFormat + matches < format.length && format.charAt(iFormat + matches) === match) {
                matches++;
            }
            iFormat += matches - 1;
            return Math.floor(matches / (step || 1)) > 1;
        };
        // Format a number, with leading zeroes if necessary
        var formatNumber = function(match, value, len, step) {
            var num = '' + value;
            if (doubled(match, step)) {
                while (num.length < len) {
                    num = '0' + num;
                }
            }
            return num;
        };
        // Format a name, short or long as requested
        var formatName = function(match, value, shortNames, longNames) {
            return (doubled(match) ? longNames[value] : shortNames[value]);
        };
        // Format month number
        // (e.g. Chinese calendar needs to account for intercalary months)
        var calendar = this;
        var formatMonth = function(date) {
            return (typeof monthNumbers === 'function') ?
                monthNumbers.call(calendar, date, doubled('m')) :
                localiseNumbers(formatNumber('m', date.month(), 2));
        };
        // Format a month name, short or long as requested
        var formatMonthName = function(date, useLongName) {
            if (useLongName) {
                return (typeof monthNames === 'function') ?
                    monthNames.call(calendar, date) :
                    monthNames[date.month() - calendar.minMonth];
            } else {
                return (typeof monthNamesShort === 'function') ?
                    monthNamesShort.call(calendar, date) :
                    monthNamesShort[date.month() - calendar.minMonth];
            }
        };
        // Localise numbers if requested and available
        var digits = this.local.digits;
        var localiseNumbers = function(value) {
            return (settings.localNumbers && digits ? digits(value) : value);
        };
        var output = '';
        var literal = false;
        for (var iFormat = 0; iFormat < format.length; iFormat++) {
            if (literal) {
                if (format.charAt(iFormat) === "'" && !doubled("'")) {
                    literal = false;
                }
                else {
                    output += format.charAt(iFormat);
                }
            }
            else {
                switch (format.charAt(iFormat)) {
                    case 'd': output += localiseNumbers(formatNumber('d', date.day(), 2)); break;
                    case 'D': output += formatName('D', date.dayOfWeek(),
                        dayNamesShort, dayNames); break;
                    case 'o': output += formatNumber('o', date.dayOfYear(), 3); break;
                    case 'w': output += formatNumber('w', date.weekOfYear(), 2); break;
                    case 'm': output += formatMonth(date); break;
                    case 'M': output += formatMonthName(date, doubled('M')); break;
                    case 'y':
                        output += (doubled('y', 2) ? date.year() :
                            (date.year() % 100 < 10 ? '0' : '') + date.year() % 100);
                        break;
                    case 'Y':
                        doubled('Y', 2);
                        output += date.formatYear();
                        break;
                    case 'J': output += date.toJD(); break;
                    case '@': output += (date.toJD() - this.UNIX_EPOCH) * this.SECS_PER_DAY; break;
                    case '!': output += (date.toJD() - this.TICKS_EPOCH) * this.TICKS_PER_DAY; break;
                    case "'":
                        if (doubled("'")) {
                            output += "'";
                        }
                        else {
                            literal = true;
                        }
                        break;
                    default:
                        output += format.charAt(iFormat);
                }
            }
        }
        return output;
    },

    /** Parse a string value into a date object.
        See <a href="#formatDate"><code>formatDate</code></a> for the possible formats, plus:
        <ul>
        <li>* - ignore rest of string</li>
        </ul>
        Found in the <code>jquery.calendars.plus.js</code> module.
        @memberof BaseCalendar
        @param format {string} The expected format of the date ('' for default calendar format).
        @param value {string} The date in the above format.
        @param [settings] {object} Additional options whose attributes include:
        @property [shortYearCutoff] {number} The cutoff year for determining the century.
        @property [dayNamesShort] {string[]} Abbreviated names of the days from Sunday.
        @property [dayNames] {string[]} Names of the days from Sunday.
        @property [monthNamesShort] {string[]} Abbreviated names of the months.
        @property [monthNames] {string[]} Names of the months.
        @return {CDate} The extracted date value or <code>null</code> if value is blank.
        @throws Errors if the format and/or value are missing,
                if the value doesn't match the format, or if the date is invalid. */
    parseDate: function(format, value, settings) {
        if (value == null) {
            throw main.local.invalidArguments || main.regionalOptions[''].invalidArguments;
        }
        value = (typeof value === 'object' ? value.toString() : value + '');
        if (value === '') {
            return null;
        }
        format = format || this.local.dateFormat;
        settings = settings || {};
        var shortYearCutoff = settings.shortYearCutoff || this.shortYearCutoff;
        shortYearCutoff = (typeof shortYearCutoff !== 'string' ? shortYearCutoff :
            this.today().year() % 100 + parseInt(shortYearCutoff, 10));
        var dayNamesShort = settings.dayNamesShort || this.local.dayNamesShort;
        var dayNames = settings.dayNames || this.local.dayNames;
        var parseMonth = settings.parseMonth || this.local.parseMonth;
        var monthNumbers = settings.monthNumbers || this.local.monthNumbers;
        var monthNamesShort = settings.monthNamesShort || this.local.monthNamesShort;
        var monthNames = settings.monthNames || this.local.monthNames;
        var jd = -1;
        var year = -1;
        var month = -1;
        var day = -1;
        var doy = -1;
        var shortYear = false;
        var literal = false;
        // Check whether a format character is doubled
        var doubled = function(match, step) {
            var matches = 1;
            while (iFormat + matches < format.length && format.charAt(iFormat + matches) === match) {
                matches++;
            }
            iFormat += matches - 1;
            return Math.floor(matches / (step || 1)) > 1;
        };
        // Extract a number from the string value
        var getNumber = function(match, step) {
            var isDoubled = doubled(match, step);
            var size = [2, 3, isDoubled ? 4 : 2, isDoubled ? 4 : 2, 10, 11, 20]['oyYJ@!'.indexOf(match) + 1];
            var digits = new RegExp('^-?\\d{1,' + size + '}');
            var num = value.substring(iValue).match(digits);
            if (!num) {
                throw (main.local.missingNumberAt || main.regionalOptions[''].missingNumberAt).
                    replace(/\{0\}/, iValue);
            }
            iValue += num[0].length;
            return parseInt(num[0], 10);
        };
        // Extract a month number from the string value
        var calendar = this;
        var getMonthNumber = function() {
            if (typeof monthNumbers === 'function') {
                doubled('m');  // update iFormat
                var month = monthNumbers.call(calendar, value.substring(iValue));
                iValue += month.length;
                return month;
            }

            return getNumber('m');
        };
        // Extract a name from the string value and convert to an index
        var getName = function(match, shortNames, longNames, step) {
            var names = (doubled(match, step) ? longNames : shortNames);
            for (var i = 0; i < names.length; i++) {
                if (value.substr(iValue, names[i].length).toLowerCase() === names[i].toLowerCase()) {
                    iValue += names[i].length;
                    return i + calendar.minMonth;
                }
            }
            throw (main.local.unknownNameAt || main.regionalOptions[''].unknownNameAt).
                replace(/\{0\}/, iValue);
        };
        // Extract a month number from the string value
        var getMonthName = function() {
            if (typeof monthNames === 'function') {
                var month = doubled('M') ?
                    monthNames.call(calendar, value.substring(iValue)) :
                    monthNamesShort.call(calendar, value.substring(iValue));
                iValue += month.length;
                return month;
            }

            return getName('M', monthNamesShort, monthNames);
        };
        // Confirm that a literal character matches the string value
        var checkLiteral = function() {
            if (value.charAt(iValue) !== format.charAt(iFormat)) {
                throw (main.local.unexpectedLiteralAt ||
                    main.regionalOptions[''].unexpectedLiteralAt).replace(/\{0\}/, iValue);
            }
            iValue++;
        };
        var iValue = 0;
        for (var iFormat = 0; iFormat < format.length; iFormat++) {
            if (literal) {
                if (format.charAt(iFormat) === "'" && !doubled("'")) {
                    literal = false;
                }
                else {
                    checkLiteral();
                }
            }
            else {
                switch (format.charAt(iFormat)) {
                    case 'd': day = getNumber('d'); break;
                    case 'D': getName('D', dayNamesShort, dayNames); break;
                    case 'o': doy = getNumber('o'); break;
                    case 'w': getNumber('w'); break;
                    case 'm': month = getMonthNumber(); break;
                    case 'M': month = getMonthName(); break;
                    case 'y':
                        var iSave = iFormat;
                        shortYear = !doubled('y', 2);
                        iFormat = iSave;
                        year = getNumber('y', 2);
                        break;
                    case 'Y': year = getNumber('Y', 2); break;
                    case 'J':
                        jd = getNumber('J') + 0.5;
                        if (value.charAt(iValue) === '.') {
                            iValue++;
                            getNumber('J');
                        }
                        break;
                    case '@': jd = getNumber('@') / this.SECS_PER_DAY + this.UNIX_EPOCH; break;
                    case '!': jd = getNumber('!') / this.TICKS_PER_DAY + this.TICKS_EPOCH; break;
                    case '*': iValue = value.length; break;
                    case "'":
                        if (doubled("'")) {
                            checkLiteral();
                        }
                        else {
                            literal = true;
                        }
                        break;
                    default: checkLiteral();
                }
            }
        }
        if (iValue < value.length) {
            throw main.local.unexpectedText || main.regionalOptions[''].unexpectedText;
        }
        if (year === -1) {
            year = this.today().year();
        }
        else if (year < 100 && shortYear) {
            year += (shortYearCutoff === -1 ? 1900 : this.today().year() -
                this.today().year() % 100 - (year <= shortYearCutoff ? 0 : 100));
        }
        if (typeof month === 'string') {
            month = parseMonth.call(this, year, month);
        }
        if (doy > -1) {
            month = 1;
            day = doy;
            for (var dim = this.daysInMonth(year, month); day > dim; dim = this.daysInMonth(year, month)) {
                month++;
                day -= dim;
            }
        }
        return (jd > -1 ? this.fromJD(jd) : this.newDate(year, month, day));
    },

    /** A date may be specified as an exact value or a relative one.
        Found in the <code>jquery.calendars.plus.js</code> module.
        @memberof BaseCalendar
        @param dateSpec {CDate|number|string} The date as an object or string in the given format or
                an offset - numeric days from today, or string amounts and periods, e.g. '+1m +2w'.
        @param defaultDate {CDate} The date to use if no other supplied, may be <code>null</code>.
        @param currentDate {CDate} The current date as a possible basis for relative dates,
                if <code>null</code> today is used (optional)
        @param [dateFormat] {string} The expected date format - see <a href="#formatDate"><code>formatDate</code></a>.
        @param [settings] {object} Additional options whose attributes include:
        @property [shortYearCutoff] {number} The cutoff year for determining the century.
        @property [dayNamesShort] {string[]} Abbreviated names of the days from Sunday.
        @property [dayNames] {string[]} Names of the days from Sunday.
        @property [monthNamesShort] {string[]} Abbreviated names of the months.
        @property [monthNames] {string[]} Names of the months.
        @return {CDate} The decoded date. */
    determineDate: function(dateSpec, defaultDate, currentDate, dateFormat, settings) {
        if (currentDate && typeof currentDate !== 'object') {
            settings = dateFormat;
            dateFormat = currentDate;
            currentDate = null;
        }
        if (typeof dateFormat !== 'string') {
            settings = dateFormat;
            dateFormat = '';
        }
        var calendar = this;
        var offsetString = function(offset) {
            try {
                return calendar.parseDate(dateFormat, offset, settings);
            }
            catch (e) {
                // Ignore
            }
            offset = offset.toLowerCase();
            var date = (offset.match(/^c/) && currentDate ?
                currentDate.newDate() : null) || calendar.today();
            var pattern = /([+-]?[0-9]+)\s*(d|w|m|y)?/g;
            var matches = pattern.exec(offset);
            while (matches) {
                date.add(parseInt(matches[1], 10), matches[2] || 'd');
                matches = pattern.exec(offset);
            }
            return date;
        };
        defaultDate = (defaultDate ? defaultDate.newDate() : null);
        dateSpec = (dateSpec == null ? defaultDate :
            (typeof dateSpec === 'string' ? offsetString(dateSpec) : (typeof dateSpec === 'number' ?
            (isNaN(dateSpec) || dateSpec === Infinity || dateSpec === -Infinity ? defaultDate :
            calendar.today().add(dateSpec, 'd')) : calendar.newDate(dateSpec))));
        return dateSpec;
    }
});



/***/ }),

/***/ 96144:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85072);
/* harmony import */ var _style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97825);
/* harmony import */ var _style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77659);
/* harmony import */ var _style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55056);
/* harmony import */ var _style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10540);
/* harmony import */ var _style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41113);
/* harmony import */ var _style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _css_loader_dist_cjs_js_maplibre_gl_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5955);

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default());
options.setAttributes = (_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default());
options.insert = _style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
options.domAPI = (_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default());
options.insertStyleElement = (_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default());

var update = _style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(_css_loader_dist_cjs_js_maplibre_gl_css__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A, options);




       /* harmony default export */ __webpack_exports__["default"] = (_css_loader_dist_cjs_js_maplibre_gl_css__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A && _css_loader_dist_cjs_js_maplibre_gl_css__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A.locals ? _css_loader_dist_cjs_js_maplibre_gl_css__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A.locals : undefined);


/***/ }),

/***/ 85072:
/***/ (function(module) {

"use strict";


var stylesInDOM = [];
function getIndexByIdentifier(identifier) {
  var result = -1;
  for (var i = 0; i < stylesInDOM.length; i++) {
    if (stylesInDOM[i].identifier === identifier) {
      result = i;
      break;
    }
  }
  return result;
}
function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];
  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var indexByIdentifier = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3],
      supports: item[4],
      layer: item[5]
    };
    if (indexByIdentifier !== -1) {
      stylesInDOM[indexByIdentifier].references++;
      stylesInDOM[indexByIdentifier].updater(obj);
    } else {
      var updater = addElementStyle(obj, options);
      options.byIndex = i;
      stylesInDOM.splice(i, 0, {
        identifier: identifier,
        updater: updater,
        references: 1
      });
    }
    identifiers.push(identifier);
  }
  return identifiers;
}
function addElementStyle(obj, options) {
  var api = options.domAPI(options);
  api.update(obj);
  var updater = function updater(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap && newObj.supports === obj.supports && newObj.layer === obj.layer) {
        return;
      }
      api.update(obj = newObj);
    } else {
      api.remove();
    }
  };
  return updater;
}
module.exports = function (list, options) {
  options = options || {};
  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];
    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDOM[index].references--;
    }
    var newLastIdentifiers = modulesToDom(newList, options);
    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];
      var _index = getIndexByIdentifier(_identifier);
      if (stylesInDOM[_index].references === 0) {
        stylesInDOM[_index].updater();
        stylesInDOM.splice(_index, 1);
      }
    }
    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),

/***/ 77659:
/***/ (function(module) {

"use strict";


var memo = {};

/* istanbul ignore next  */
function getTarget(target) {
  if (typeof memo[target] === "undefined") {
    var styleTarget = document.querySelector(target);

    // Special case to return head of iframe instead of iframe itself
    if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
      try {
        // This will throw an exception if access to iframe is blocked
        // due to cross-origin restrictions
        styleTarget = styleTarget.contentDocument.head;
      } catch (e) {
        // istanbul ignore next
        styleTarget = null;
      }
    }
    memo[target] = styleTarget;
  }
  return memo[target];
}

/* istanbul ignore next  */
function insertBySelector(insert, style) {
  var target = getTarget(insert);
  if (!target) {
    throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
  }
  target.appendChild(style);
}
module.exports = insertBySelector;

/***/ }),

/***/ 10540:
/***/ (function(module) {

"use strict";


/* istanbul ignore next  */
function insertStyleElement(options) {
  var element = document.createElement("style");
  options.setAttributes(element, options.attributes);
  options.insert(element, options.options);
  return element;
}
module.exports = insertStyleElement;

/***/ }),

/***/ 55056:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


/* istanbul ignore next  */
function setAttributesWithoutAttributes(styleElement) {
  var nonce =  true ? __webpack_require__.nc : 0;
  if (nonce) {
    styleElement.setAttribute("nonce", nonce);
  }
}
module.exports = setAttributesWithoutAttributes;

/***/ }),

/***/ 97825:
/***/ (function(module) {

"use strict";


/* istanbul ignore next  */
function apply(styleElement, options, obj) {
  var css = "";
  if (obj.supports) {
    css += "@supports (".concat(obj.supports, ") {");
  }
  if (obj.media) {
    css += "@media ".concat(obj.media, " {");
  }
  var needLayer = typeof obj.layer !== "undefined";
  if (needLayer) {
    css += "@layer".concat(obj.layer.length > 0 ? " ".concat(obj.layer) : "", " {");
  }
  css += obj.css;
  if (needLayer) {
    css += "}";
  }
  if (obj.media) {
    css += "}";
  }
  if (obj.supports) {
    css += "}";
  }
  var sourceMap = obj.sourceMap;
  if (sourceMap && typeof btoa !== "undefined") {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  }

  // For old IE
  /* istanbul ignore if  */
  options.styleTagTransform(css, styleElement, options.options);
}
function removeStyleElement(styleElement) {
  // istanbul ignore if
  if (styleElement.parentNode === null) {
    return false;
  }
  styleElement.parentNode.removeChild(styleElement);
}

/* istanbul ignore next  */
function domAPI(options) {
  if (typeof document === "undefined") {
    return {
      update: function update() {},
      remove: function remove() {}
    };
  }
  var styleElement = options.insertStyleElement(options);
  return {
    update: function update(obj) {
      apply(styleElement, options, obj);
    },
    remove: function remove() {
      removeStyleElement(styleElement);
    }
  };
}
module.exports = domAPI;

/***/ }),

/***/ 41113:
/***/ (function(module) {

"use strict";


/* istanbul ignore next  */
function styleTagTransform(css, styleElement) {
  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css;
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild);
    }
    styleElement.appendChild(document.createTextNode(css));
  }
}
module.exports = styleTagTransform;

/***/ }),

/***/ 25446:
/***/ (function(module) {

"use strict";
module.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2722%27 height=%2722%27 fill=%27%23333%27 viewBox=%270 0 22 22%27%3E%3Cpath d=%27m1.754 13.406 4.453-4.851 3.09 3.09 3.281 3.277.969-.969-3.309-3.312 3.844-4.121 6.148 6.886h1.082v-.855l-7.207-8.07-4.84 5.187L6.169 6.57l-5.48 5.965v.871ZM.688 16.844h20.625v1.375H.688Zm0 0%27/%3E%3C/svg%3E";

/***/ }),

/***/ 56694:
/***/ (function(module) {

"use strict";
module.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2722%27 height=%2722%27 fill=%27%2333b5e5%27 viewBox=%270 0 22 22%27%3E%3Cpath d=%27m1.754 13.406 4.453-4.851 3.09 3.09 3.281 3.277.969-.969-3.309-3.312 3.844-4.121 6.148 6.886h1.082v-.855l-7.207-8.07-4.84 5.187L6.169 6.57l-5.48 5.965v.871ZM.688 16.844h20.625v1.375H.688Zm0 0%27/%3E%3C/svg%3E";

/***/ }),

/***/ 26117:
/***/ (function(module) {

"use strict";
module.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2724%27 height=%2724%27 fill-rule=%27evenodd%27 viewBox=%270 0 20 20%27%3E%3Cpath d=%27M4 10a6 6 0 1 0 12 0 6 6 0 1 0-12 0m5-3a1 1 0 1 0 2 0 1 1 0 1 0-2 0m0 3a1 1 0 1 1 2 0v3a1 1 0 1 1-2 0%27/%3E%3C/svg%3E";

/***/ }),

/***/ 66311:
/***/ (function(module) {

"use strict";
module.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2724%27 height=%2724%27 fill=%27%23fff%27 fill-rule=%27evenodd%27 viewBox=%270 0 20 20%27%3E%3Cpath d=%27M4 10a6 6 0 1 0 12 0 6 6 0 1 0-12 0m5-3a1 1 0 1 0 2 0 1 1 0 1 0-2 0m0 3a1 1 0 1 1 2 0v3a1 1 0 1 1-2 0%27/%3E%3C/svg%3E";

/***/ }),

/***/ 24420:
/***/ (function(module) {

"use strict";
module.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 fill=%27%23333%27 viewBox=%270 0 20 20%27%3E%3Cpath d=%27M10 4C9 4 9 5 9 5v.1A5 5 0 0 0 5.1 9H5s-1 0-1 1 1 1 1 1h.1A5 5 0 0 0 9 14.9v.1s0 1 1 1 1-1 1-1v-.1a5 5 0 0 0 3.9-3.9h.1s1 0 1-1-1-1-1-1h-.1A5 5 0 0 0 11 5.1V5s0-1-1-1m0 2.5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 1 1 0-7%27/%3E%3Ccircle cx=%2710%27 cy=%2710%27 r=%272%27/%3E%3C/svg%3E";

/***/ }),

/***/ 77035:
/***/ (function(module) {

"use strict";
module.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 fill=%27%23333%27 viewBox=%270 0 29 29%27%3E%3Cpath d=%27M10 13c-.75 0-1.5.75-1.5 1.5S9.25 16 10 16h9c.75 0 1.5-.75 1.5-1.5S19.75 13 19 13z%27/%3E%3C/svg%3E";

/***/ }),

/***/ 43470:
/***/ (function(module) {

"use strict";
module.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 fill=%27%23333%27 viewBox=%270 0 29 29%27%3E%3Cpath d=%27M14.5 8.5c-.75 0-1.5.75-1.5 1.5v3h-3c-.75 0-1.5.75-1.5 1.5S9.25 16 10 16h3v3c0 .75.75 1.5 1.5 1.5S16 19.75 16 19v-3h3c.75 0 1.5-.75 1.5-1.5S19.75 13 19 13h-3v-3c0-.75-.75-1.5-1.5-1.5%27/%3E%3C/svg%3E";

/***/ }),

/***/ 13490:
/***/ (function(module) {

"use strict";
module.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 fill=%27%23333%27 viewBox=%270 0 29 29%27%3E%3Cpath d=%27M24 16v5.5c0 1.75-.75 2.5-2.5 2.5H16v-1l3-1.5-4-5.5 1-1 5.5 4 1.5-3zM6 16l1.5 3 5.5-4 1 1-4 5.5 3 1.5v1H7.5C5.75 24 5 23.25 5 21.5V16zm7-11v1l-3 1.5 4 5.5-1 1-5.5-4L6 13H5V7.5C5 5.75 5.75 5 7.5 5zm11 2.5c0-1.75-.75-2.5-2.5-2.5H16v1l3 1.5-4 5.5 1 1 5.5-4 1.5 3h1z%27/%3E%3C/svg%3E";

/***/ }),

/***/ 80216:
/***/ (function(module) {

"use strict";
module.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 fill=%27%23333%27 viewBox=%270 0 29 29%27%3E%3Cpath d=%27m10.5 14 4-8 4 8z%27/%3E%3Cpath fill=%27%23ccc%27 d=%27m10.5 16 4 8 4-8z%27/%3E%3C/svg%3E";

/***/ }),

/***/ 47695:
/***/ (function(module) {

"use strict";
module.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 fill=%27%2333b5e5%27 viewBox=%270 0 20 20%27%3E%3Cpath d=%27M10 4C9 4 9 5 9 5v.1A5 5 0 0 0 5.1 9H5s-1 0-1 1 1 1 1 1h.1A5 5 0 0 0 9 14.9v.1s0 1 1 1 1-1 1-1v-.1a5 5 0 0 0 3.9-3.9h.1s1 0 1-1-1-1-1-1h-.1A5 5 0 0 0 11 5.1V5s0-1-1-1m0 2.5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 1 1 0-7%27/%3E%3C/svg%3E";

/***/ }),

/***/ 92228:
/***/ (function(module) {

"use strict";
module.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 fill=%27%2333b5e5%27 viewBox=%270 0 20 20%27%3E%3Cpath d=%27M10 4C9 4 9 5 9 5v.1A5 5 0 0 0 5.1 9H5s-1 0-1 1 1 1 1 1h.1A5 5 0 0 0 9 14.9v.1s0 1 1 1 1-1 1-1v-.1a5 5 0 0 0 3.9-3.9h.1s1 0 1-1-1-1-1-1h-.1A5 5 0 0 0 11 5.1V5s0-1-1-1m0 2.5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 1 1 0-7%27/%3E%3Ccircle cx=%2710%27 cy=%2710%27 r=%272%27/%3E%3C/svg%3E";

/***/ }),

/***/ 43737:
/***/ (function(module) {

"use strict";
module.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 fill=%27%23666%27 viewBox=%270 0 20 20%27%3E%3Cpath d=%27M10 4C9 4 9 5 9 5v.1A5 5 0 0 0 5.1 9H5s-1 0-1 1 1 1 1 1h.1A5 5 0 0 0 9 14.9v.1s0 1 1 1 1-1 1-1v-.1a5 5 0 0 0 3.9-3.9h.1s1 0 1-1-1-1-1-1h-.1A5 5 0 0 0 11 5.1V5s0-1-1-1m0 2.5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 1 1 0-7%27/%3E%3Ccircle cx=%2710%27 cy=%2710%27 r=%272%27/%3E%3Cpath fill=%27red%27 d=%27m14 5 1 1-9 9-1-1z%27/%3E%3C/svg%3E";

/***/ }),

/***/ 48460:
/***/ (function(module) {

"use strict";
module.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 fill=%27%23999%27 viewBox=%270 0 20 20%27%3E%3Cpath d=%27M10 4C9 4 9 5 9 5v.1A5 5 0 0 0 5.1 9H5s-1 0-1 1 1 1 1 1h.1A5 5 0 0 0 9 14.9v.1s0 1 1 1 1-1 1-1v-.1a5 5 0 0 0 3.9-3.9h.1s1 0 1-1-1-1-1-1h-.1A5 5 0 0 0 11 5.1V5s0-1-1-1m0 2.5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 1 1 0-7%27/%3E%3Ccircle cx=%2710%27 cy=%2710%27 r=%272%27/%3E%3Cpath fill=%27red%27 d=%27m14 5 1 1-9 9-1-1z%27/%3E%3C/svg%3E";

/***/ }),

/***/ 75796:
/***/ (function(module) {

"use strict";
module.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 fill=%27%23aaa%27 viewBox=%270 0 20 20%27%3E%3Cpath d=%27M10 4C9 4 9 5 9 5v.1A5 5 0 0 0 5.1 9H5s-1 0-1 1 1 1 1 1h.1A5 5 0 0 0 9 14.9v.1s0 1 1 1 1-1 1-1v-.1a5 5 0 0 0 3.9-3.9h.1s1 0 1-1-1-1-1-1h-.1A5 5 0 0 0 11 5.1V5s0-1-1-1m0 2.5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 1 1 0-7%27/%3E%3Ccircle cx=%2710%27 cy=%2710%27 r=%272%27/%3E%3Cpath fill=%27red%27 d=%27m14 5 1 1-9 9-1-1z%27/%3E%3C/svg%3E";

/***/ }),

/***/ 28869:
/***/ (function(module) {

"use strict";
module.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 fill=%27%23e54e33%27 viewBox=%270 0 20 20%27%3E%3Cpath d=%27M10 4C9 4 9 5 9 5v.1A5 5 0 0 0 5.1 9H5s-1 0-1 1 1 1 1 1h.1A5 5 0 0 0 9 14.9v.1s0 1 1 1 1-1 1-1v-.1a5 5 0 0 0 3.9-3.9h.1s1 0 1-1-1-1-1-1h-.1A5 5 0 0 0 11 5.1V5s0-1-1-1m0 2.5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 1 1 0-7%27/%3E%3C/svg%3E";

/***/ }),

/***/ 9819:
/***/ (function(module) {

"use strict";
module.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 fill=%27%23e58978%27 viewBox=%270 0 20 20%27%3E%3Cpath d=%27M10 4C9 4 9 5 9 5v.1A5 5 0 0 0 5.1 9H5s-1 0-1 1 1 1 1 1h.1A5 5 0 0 0 9 14.9v.1s0 1 1 1 1-1 1-1v-.1a5 5 0 0 0 3.9-3.9h.1s1 0 1-1-1-1-1-1h-.1A5 5 0 0 0 11 5.1V5s0-1-1-1m0 2.5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 1 1 0-7%27/%3E%3Ccircle cx=%2710%27 cy=%2710%27 r=%272%27/%3E%3C/svg%3E";

/***/ }),

/***/ 30557:
/***/ (function(module) {

"use strict";
module.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 fill=%27%23fff%27 viewBox=%270 0 20 20%27%3E%3Cpath d=%27M10 4C9 4 9 5 9 5v.1A5 5 0 0 0 5.1 9H5s-1 0-1 1 1 1 1 1h.1A5 5 0 0 0 9 14.9v.1s0 1 1 1 1-1 1-1v-.1a5 5 0 0 0 3.9-3.9h.1s1 0 1-1-1-1-1-1h-.1A5 5 0 0 0 11 5.1V5s0-1-1-1m0 2.5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 1 1 0-7%27/%3E%3Ccircle cx=%2710%27 cy=%2710%27 r=%272%27/%3E%3C/svg%3E";

/***/ }),

/***/ 68164:
/***/ (function(module) {

"use strict";
module.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 fill=%27%23fff%27 viewBox=%270 0 29 29%27%3E%3Cpath d=%27M10 13c-.75 0-1.5.75-1.5 1.5S9.25 16 10 16h9c.75 0 1.5-.75 1.5-1.5S19.75 13 19 13z%27/%3E%3C/svg%3E";

/***/ }),

/***/ 64665:
/***/ (function(module) {

"use strict";
module.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 fill=%27%23fff%27 viewBox=%270 0 29 29%27%3E%3Cpath d=%27M14.5 8.5c-.75 0-1.5.75-1.5 1.5v3h-3c-.75 0-1.5.75-1.5 1.5S9.25 16 10 16h3v3c0 .75.75 1.5 1.5 1.5S16 19.75 16 19v-3h3c.75 0 1.5-.75 1.5-1.5S19.75 13 19 13h-3v-3c0-.75-.75-1.5-1.5-1.5%27/%3E%3C/svg%3E";

/***/ }),

/***/ 91413:
/***/ (function(module) {

"use strict";
module.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 fill=%27%23fff%27 viewBox=%270 0 29 29%27%3E%3Cpath d=%27M18.5 16c-1.75 0-2.5.75-2.5 2.5V24h1l1.5-3 5.5 4 1-1-4-5.5 3-1.5v-1zM13 18.5c0-1.75-.75-2.5-2.5-2.5H5v1l3 1.5L4 24l1 1 5.5-4 1.5 3h1zm3-8c0 1.75.75 2.5 2.5 2.5H24v-1l-3-1.5L25 5l-1-1-5.5 4L17 5h-1zM10.5 13c1.75 0 2.5-.75 2.5-2.5V5h-1l-1.5 3L5 4 4 5l4 5.5L5 12v1z%27/%3E%3C/svg%3E";

/***/ }),

/***/ 13913:
/***/ (function(module) {

"use strict";
module.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 fill=%27%23fff%27 viewBox=%270 0 29 29%27%3E%3Cpath d=%27M24 16v5.5c0 1.75-.75 2.5-2.5 2.5H16v-1l3-1.5-4-5.5 1-1 5.5 4 1.5-3zM6 16l1.5 3 5.5-4 1 1-4 5.5 3 1.5v1H7.5C5.75 24 5 23.25 5 21.5V16zm7-11v1l-3 1.5 4 5.5-1 1-5.5-4L6 13H5V7.5C5 5.75 5.75 5 7.5 5zm11 2.5c0-1.75-.75-2.5-2.5-2.5H16v1l3 1.5-4 5.5 1 1 5.5-4 1.5 3h1z%27/%3E%3C/svg%3E";

/***/ }),

/***/ 61907:
/***/ (function(module) {

"use strict";
module.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 fill=%27%23fff%27 viewBox=%270 0 29 29%27%3E%3Cpath d=%27m10.5 14 4-8 4 8z%27/%3E%3Cpath fill=%27%23ccc%27 d=%27m10.5 16 4 8 4-8z%27/%3E%3C/svg%3E";

/***/ }),

/***/ 56539:
/***/ (function(module) {

"use strict";
module.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 viewBox=%270 0 20 20%27%3E%3Cpath d=%27M10 4C9 4 9 5 9 5v.1A5 5 0 0 0 5.1 9H5s-1 0-1 1 1 1 1 1h.1A5 5 0 0 0 9 14.9v.1s0 1 1 1 1-1 1-1v-.1a5 5 0 0 0 3.9-3.9h.1s1 0 1-1-1-1-1-1h-.1A5 5 0 0 0 11 5.1V5s0-1-1-1m0 2.5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 1 1 0-7%27/%3E%3Ccircle cx=%2710%27 cy=%2710%27 r=%272%27/%3E%3C/svg%3E";

/***/ }),

/***/ 4890:
/***/ (function(module) {

"use strict";
module.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 viewBox=%270 0 29 29%27%3E%3Cpath d=%27M10 13c-.75 0-1.5.75-1.5 1.5S9.25 16 10 16h9c.75 0 1.5-.75 1.5-1.5S19.75 13 19 13z%27/%3E%3C/svg%3E";

/***/ }),

/***/ 13363:
/***/ (function(module) {

"use strict";
module.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 viewBox=%270 0 29 29%27%3E%3Cpath d=%27M14.5 8.5c-.75 0-1.5.75-1.5 1.5v3h-3c-.75 0-1.5.75-1.5 1.5S9.25 16 10 16h3v3c0 .75.75 1.5 1.5 1.5S16 19.75 16 19v-3h3c.75 0 1.5-.75 1.5-1.5S19.75 13 19 13h-3v-3c0-.75-.75-1.5-1.5-1.5%27/%3E%3C/svg%3E";

/***/ }),

/***/ 47603:
/***/ (function(module) {

"use strict";
module.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 viewBox=%270 0 29 29%27%3E%3Cpath d=%27M18.5 16c-1.75 0-2.5.75-2.5 2.5V24h1l1.5-3 5.5 4 1-1-4-5.5 3-1.5v-1zM13 18.5c0-1.75-.75-2.5-2.5-2.5H5v1l3 1.5L4 24l1 1 5.5-4 1.5 3h1zm3-8c0 1.75.75 2.5 2.5 2.5H24v-1l-3-1.5L25 5l-1-1-5.5 4L17 5h-1zM10.5 13c1.75 0 2.5-.75 2.5-2.5V5h-1l-1.5 3L5 4 4 5l4 5.5L5 12v1z%27/%3E%3C/svg%3E";

/***/ }),

/***/ 64643:
/***/ (function(module) {

"use strict";
module.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 viewBox=%270 0 29 29%27%3E%3Cpath d=%27M24 16v5.5c0 1.75-.75 2.5-2.5 2.5H16v-1l3-1.5-4-5.5 1-1 5.5 4 1.5-3zM6 16l1.5 3 5.5-4 1 1-4 5.5 3 1.5v1H7.5C5.75 24 5 23.25 5 21.5V16zm7-11v1l-3 1.5 4 5.5-1 1-5.5-4L6 13H5V7.5C5 5.75 5.75 5 7.5 5zm11 2.5c0-1.75-.75-2.5-2.5-2.5H16v1l3 1.5-4 5.5 1 1 5.5-4 1.5 3h1z%27/%3E%3C/svg%3E";

/***/ }),

/***/ 68605:
/***/ (function(module) {

"use strict";
module.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 viewBox=%270 0 29 29%27%3E%3Cpath d=%27m10.5 14 4-8 4 8z%27/%3E%3Cpath fill=%27%23ccc%27 d=%27m10.5 16 4 8 4-8z%27/%3E%3C/svg%3E";

/***/ }),

/***/ 47914:
/***/ (function(module) {

"use strict";
module.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2788%27 height=%2723%27 fill=%27none%27%3E%3Cpath fill=%27%23000%27 fill-opacity=%27.4%27 fill-rule=%27evenodd%27 d=%27M17.408 16.796h-1.827l2.501-12.095h.198l3.324 6.533.988 2.19.988-2.19 3.258-6.533h.181l2.6 12.095h-1.81l-1.218-5.644-.362-1.71-.658 1.71-2.929 5.644h-.098l-2.914-5.644-.757-1.71-.345 1.71zm1.958-3.42-.726 3.663a1.255 1.255 0 0 1-1.232 1.011h-1.827a1.255 1.255 0 0 1-1.229-1.509l2.501-12.095a1.255 1.255 0 0 1 1.23-1.001h.197a1.25 1.25 0 0 1 1.12.685l3.19 6.273 3.125-6.263a1.25 1.25 0 0 1 1.123-.695h.181a1.255 1.255 0 0 1 1.227.991l1.443 6.71a5 5 0 0 1 .314-.787l.009-.016a4.6 4.6 0 0 1 1.777-1.887c.782-.46 1.668-.667 2.611-.667a4.6 4.6 0 0 1 1.7.32l.306.134c.21-.16.474-.256.759-.256h1.694a1.255 1.255 0 0 1 1.212.925 1.255 1.255 0 0 1 1.212-.925h1.711c.284 0 .545.094.755.252.613-.3 1.312-.45 2.075-.45 1.356 0 2.557.445 3.482 1.4q.47.48.763 1.064V4.701a1.255 1.255 0 0 1 1.255-1.255h1.86A1.255 1.255 0 0 1 54.44 4.7v9.194h2.217c.19 0 .37.043.532.118v-4.77c0-.356.147-.678.385-.906a2.42 2.42 0 0 1-.682-1.71c0-.665.267-1.253.735-1.7a2.45 2.45 0 0 1 1.722-.674 2.43 2.43 0 0 1 1.705.675q.318.302.504.683V4.7a1.255 1.255 0 0 1 1.255-1.255h1.744A1.255 1.255 0 0 1 65.812 4.7v3.335a4.8 4.8 0 0 1 1.526-.246c.938 0 1.817.214 2.59.69a4.47 4.47 0 0 1 1.67 1.743v-.98a1.255 1.255 0 0 1 1.256-1.256h1.777c.233 0 .451.064.639.174a3.4 3.4 0 0 1 1.567-.372c.346 0 .861.02 1.285.232a1.25 1.25 0 0 1 .689 1.004 4.7 4.7 0 0 1 .853-.588c.795-.44 1.675-.647 2.61-.647 1.385 0 2.65.39 3.525 1.396.836.938 1.168 2.173 1.168 3.528q-.001.515-.056 1.051a1.255 1.255 0 0 1-.947 1.09l.408.952a1.255 1.255 0 0 1-.477 1.552c-.418.268-.92.463-1.458.612-.613.171-1.304.244-2.049.244-1.06 0-2.043-.207-2.886-.698l-.015-.008c-.798-.48-1.419-1.135-1.818-1.963l-.004-.008a5.8 5.8 0 0 1-.548-2.512q0-.429.053-.843a1.3 1.3 0 0 1-.333-.086l-.166-.004c-.223 0-.426.062-.643.228-.03.024-.142.139-.142.59v3.883a1.255 1.255 0 0 1-1.256 1.256h-1.777a1.255 1.255 0 0 1-1.256-1.256V15.69l-.032.057a4.8 4.8 0 0 1-1.86 1.833 5.04 5.04 0 0 1-2.484.634 4.5 4.5 0 0 1-1.935-.424 1.25 1.25 0 0 1-.764.258h-1.71a1.255 1.255 0 0 1-1.256-1.255V7.687a2.4 2.4 0 0 1-.428.625c.253.23.412.561.412.93v7.553a1.255 1.255 0 0 1-1.256 1.255h-1.843a1.25 1.25 0 0 1-.894-.373c-.228.23-.544.373-.894.373H51.32a1.255 1.255 0 0 1-1.256-1.255v-1.251l-.061.117a4.7 4.7 0 0 1-1.782 1.884 4.77 4.77 0 0 1-2.485.67 5.6 5.6 0 0 1-1.485-.188l.009 2.764a1.255 1.255 0 0 1-1.255 1.259h-1.729a1.255 1.255 0 0 1-1.255-1.255v-3.537a1.255 1.255 0 0 1-1.167.793h-1.679a1.25 1.25 0 0 1-.77-.263 4.5 4.5 0 0 1-1.945.429c-.885 0-1.724-.21-2.495-.632l-.017-.01a5 5 0 0 1-1.081-.836 1.255 1.255 0 0 1-1.254 1.312h-1.81a1.255 1.255 0 0 1-1.228-.99l-.782-3.625-2.044 3.939a1.25 1.25 0 0 1-1.115.676h-.098a1.25 1.25 0 0 1-1.116-.68l-2.061-3.994zM35.92 16.63l.207-.114.223-.15q.493-.356.735-.785l.061-.118.033 1.332h1.678V9.242h-1.694l-.033 1.267q-.133-.329-.526-.658l-.032-.028a3.2 3.2 0 0 0-.668-.428l-.27-.12a3.3 3.3 0 0 0-1.235-.23q-1.136-.001-1.974.493a3.36 3.36 0 0 0-1.3 1.382q-.445.89-.444 2.074 0 1.2.51 2.107a3.8 3.8 0 0 0 1.382 1.381 3.9 3.9 0 0 0 1.893.477q.795 0 1.455-.33zm-2.789-5.38q-.576.675-.575 1.762 0 1.102.559 1.794.576.675 1.645.675a2.25 2.25 0 0 0 .934-.19 2.2 2.2 0 0 0 .468-.29l.178-.161a2.2 2.2 0 0 0 .397-.561q.244-.5.244-1.15v-.115q0-.708-.296-1.267l-.043-.077a2.2 2.2 0 0 0-.633-.709l-.13-.086-.047-.028a2.1 2.1 0 0 0-1.073-.285q-1.052 0-1.629.692zm2.316 2.706c.163-.17.28-.407.28-.83v-.114c0-.292-.06-.508-.15-.68a.96.96 0 0 0-.353-.389.85.85 0 0 0-.464-.127c-.4 0-.56.114-.664.239l-.01.012c-.148.174-.275.45-.275.945 0 .506.122.801.27.99.097.11.266.224.68.224.303 0 .504-.09.687-.269zm7.545 1.705a2.6 2.6 0 0 0 .331.423q.319.33.755.548l.173.074q.65.255 1.49.255 1.02 0 1.844-.493a3.45 3.45 0 0 0 1.316-1.4q.493-.904.493-2.089 0-1.909-.988-2.913-.988-1.02-2.584-1.02-.898 0-1.575.347a3 3 0 0 0-.415.262l-.199.166a3.4 3.4 0 0 0-.64.82V9.242h-1.712v11.553h1.729l-.017-5.134zm.53-1.138q.206.29.48.5l.155.11.053.034q.51.296 1.119.297 1.07 0 1.645-.675.577-.69.576-1.762 0-1.119-.576-1.777-.558-.675-1.645-.675-.435 0-.835.16a2 2 0 0 0-.284.136 2 2 0 0 0-.363.254 2.2 2.2 0 0 0-.46.569l-.082.162a2.6 2.6 0 0 0-.213 1.072v.115q0 .707.296 1.267l.135.211zm.964-.818a1.1 1.1 0 0 0 .367.385.94.94 0 0 0 .476.118c.423 0 .59-.117.687-.23.159-.194.28-.478.28-.95 0-.53-.133-.8-.266-.952l-.021-.025c-.078-.094-.231-.221-.68-.221a1 1 0 0 0-.503.135l-.012.007a.86.86 0 0 0-.335.343c-.073.133-.132.324-.132.614v.115a1.4 1.4 0 0 0 .14.66zm15.7-6.222q.347-.346.346-.856a1.05 1.05 0 0 0-.345-.79 1.18 1.18 0 0 0-.84-.329q-.51 0-.855.33a1.05 1.05 0 0 0-.346.79q0 .51.346.855.345.346.856.346.51 0 .839-.346zm4.337 9.314.033-1.332q.191.403.59.747l.098.081a4 4 0 0 0 .316.224l.223.122a3.2 3.2 0 0 0 1.44.322 3.8 3.8 0 0 0 1.875-.477 3.5 3.5 0 0 0 1.382-1.366q.527-.89.526-2.09 0-1.184-.444-2.073a3.24 3.24 0 0 0-1.283-1.399q-.823-.51-1.942-.51a3.5 3.5 0 0 0-1.527.344l-.086.043-.165.09a3 3 0 0 0-.33.214q-.432.315-.656.707a2 2 0 0 0-.099.198l.082-1.283V4.701h-1.744v12.095zm.473-2.509a2.5 2.5 0 0 0 .566.7q.117.098.245.18l.144.08a2.1 2.1 0 0 0 .975.232q1.07 0 1.645-.675.576-.69.576-1.778 0-1.102-.576-1.777-.56-.691-1.645-.692a2.2 2.2 0 0 0-1.015.235q-.22.113-.415.282l-.15.142a2.1 2.1 0 0 0-.42.594q-.223.479-.223 1.1v.115q0 .705.293 1.26zm2.616-.293c.157-.191.28-.479.28-.967 0-.51-.13-.79-.276-.961l-.021-.026c-.082-.1-.232-.225-.67-.225a.87.87 0 0 0-.681.279l-.012.011c-.154.155-.274.38-.274.807v.115c0 .285.057.499.144.669a1.1 1.1 0 0 0 .367.405c.137.082.28.123.455.123.423 0 .59-.118.686-.23zm8.266-3.013q.345-.13.724-.14l.069-.002q.493 0 .642.099l.247-1.794q-.196-.099-.717-.099a2.3 2.3 0 0 0-.545.063 2 2 0 0 0-.411.148 2.2 2.2 0 0 0-.4.249 2.5 2.5 0 0 0-.485.499 2.7 2.7 0 0 0-.32.581l-.05.137v-1.48h-1.778v7.553h1.777v-3.884q0-.546.159-.943a1.5 1.5 0 0 1 .466-.636 2.5 2.5 0 0 1 .399-.253 2 2 0 0 1 .224-.099zm9.784 2.656.05-.922q0-1.743-.856-2.698-.838-.97-2.584-.97-1.119-.001-2.007.493a3.46 3.46 0 0 0-1.4 1.382q-.493.906-.493 2.106 0 1.07.428 1.975.428.89 1.332 1.432.906.526 2.255.526.973 0 1.668-.185l.044-.012.135-.04q.613-.184.984-.421l-.542-1.267q-.3.162-.642.274l-.297.087q-.51.131-1.3.131-.954 0-1.497-.444a1.6 1.6 0 0 1-.192-.193q-.366-.44-.512-1.234l-.004-.021zm-5.427-1.256-.003.022h3.752v-.138q-.011-.727-.288-1.118a1 1 0 0 0-.156-.176q-.46-.428-1.316-.428-.986 0-1.494.604-.379.45-.494 1.234zm-27.053 2.77V4.7h-1.86v12.095h5.333V15.15zm7.103-5.908v7.553h-1.843V9.242h1.843z%27/%3E%3Cpath fill=%27%23fff%27 d=%27m19.63 11.151-.757-1.71-.345 1.71-1.12 5.644h-1.827L18.083 4.7h.197l3.325 6.533.988 2.19.988-2.19L26.839 4.7h.181l2.6 12.095h-1.81l-1.218-5.644-.362-1.71-.658 1.71-2.93 5.644h-.098l-2.913-5.644zm14.836 5.81q-1.02 0-1.893-.478a3.8 3.8 0 0 1-1.381-1.382q-.51-.906-.51-2.106 0-1.185.444-2.074a3.36 3.36 0 0 1 1.3-1.382q.839-.494 1.974-.494a3.3 3.3 0 0 1 1.234.231 3.3 3.3 0 0 1 .97.575q.396.33.527.659l.033-1.267h1.694v7.553H37.18l-.033-1.332q-.279.593-1.02 1.053a3.17 3.17 0 0 1-1.662.444zm.296-1.482q.938 0 1.58-.642.642-.66.642-1.711v-.115q0-.708-.296-1.267a2.2 2.2 0 0 0-.807-.872 2.1 2.1 0 0 0-1.119-.313q-1.053 0-1.629.692-.575.675-.575 1.76 0 1.103.559 1.795.577.675 1.645.675zm6.521-6.237h1.711v1.4q.906-1.597 2.83-1.597 1.596 0 2.584 1.02.988 1.005.988 2.914 0 1.185-.493 2.09a3.46 3.46 0 0 1-1.316 1.399 3.5 3.5 0 0 1-1.844.493q-.954 0-1.662-.329a2.67 2.67 0 0 1-1.086-.97l.017 5.134h-1.728zm4.048 6.22q1.07 0 1.645-.674.577-.69.576-1.762 0-1.119-.576-1.777-.558-.675-1.645-.675-.592 0-1.12.296-.51.28-.822.823-.296.527-.296 1.234v.115q0 .708.296 1.267.313.543.823.855.51.296 1.119.297z%27/%3E%3Cpath fill=%27%23e1e3e9%27 d=%27M51.325 4.7h1.86v10.45h3.473v1.646h-5.333zm7.12 4.542h1.843v7.553h-1.843zm.905-1.415a1.16 1.16 0 0 1-.856-.346 1.17 1.17 0 0 1-.346-.856 1.05 1.05 0 0 1 .346-.79q.346-.329.856-.329.494 0 .839.33a1.05 1.05 0 0 1 .345.79 1.16 1.16 0 0 1-.345.855q-.33.346-.84.346zm7.875 9.133a3.17 3.17 0 0 1-1.662-.444q-.723-.46-1.004-1.053l-.033 1.332h-1.71V4.701h1.743v4.657l-.082 1.283q.279-.658 1.086-1.119a3.5 3.5 0 0 1 1.778-.477q1.119 0 1.942.51a3.24 3.24 0 0 1 1.283 1.4q.445.888.444 2.072 0 1.201-.526 2.09a3.5 3.5 0 0 1-1.382 1.366 3.8 3.8 0 0 1-1.876.477zm-.296-1.481q1.069 0 1.645-.675.577-.69.577-1.778 0-1.102-.577-1.776-.56-.691-1.645-.692a2.12 2.12 0 0 0-1.58.659q-.642.641-.642 1.694v.115q0 .71.296 1.267a2.4 2.4 0 0 0 .807.872 2.1 2.1 0 0 0 1.119.313zm5.927-6.237h1.777v1.481q.263-.757.856-1.217a2.14 2.14 0 0 1 1.349-.46q.527 0 .724.098l-.247 1.794q-.149-.099-.642-.099-.774 0-1.416.494-.626.493-.626 1.58v3.883h-1.777V9.242zm9.534 7.718q-1.35 0-2.255-.526-.904-.543-1.332-1.432a4.6 4.6 0 0 1-.428-1.975q0-1.2.493-2.106a3.46 3.46 0 0 1 1.4-1.382q.889-.495 2.007-.494 1.744 0 2.584.97.855.956.856 2.7 0 .444-.05.92h-5.43q.18 1.005.708 1.45.542.443 1.497.443.79 0 1.3-.131a4 4 0 0 0 .938-.362l.542 1.267q-.411.263-1.119.46-.708.198-1.711.197zm1.596-4.558q.016-1.02-.444-1.432-.46-.428-1.316-.428-1.728 0-1.991 1.86z%27/%3E%3Cpath d=%27M5.074 15.948a.484.657 0 0 0-.486.659v1.84a.484.657 0 0 0 .486.659h4.101a.484.657 0 0 0 .486-.659v-1.84a.484.657 0 0 0-.486-.659zm3.56 1.16H5.617v.838h3.017z%27 style=%27fill:%23fff;fill-rule:evenodd;stroke-width:1.03600001%27/%3E%3Cg style=%27stroke-width:1.12603545%27%3E%3Cpath d=%27M-9.408-1.416c-3.833-.025-7.056 2.912-7.08 6.615-.02 3.08 1.653 4.832 3.107 6.268.903.892 1.721 1.74 2.32 2.902l-.525-.004c-.543-.003-.992.304-1.24.639a1.87 1.87 0 0 0-.362 1.121l-.011 1.877c-.003.402.104.787.347 1.125.244.338.688.653 1.23.656l4.142.028c.542.003.99-.306 1.238-.641a1.87 1.87 0 0 0 .363-1.121l.012-1.875a1.87 1.87 0 0 0-.348-1.127c-.243-.338-.688-.653-1.23-.656l-.518-.004c.597-1.145 1.425-1.983 2.348-2.87 1.473-1.414 3.18-3.149 3.2-6.226-.016-3.59-2.923-6.684-6.993-6.707m-.006 1.1v.002c3.274.02 5.92 2.532 5.9 5.6-.017 2.706-1.39 4.026-2.863 5.44-1.034.994-2.118 2.033-2.814 3.633-.018.041-.052.055-.075.065q-.013.004-.02.01a.34.34 0 0 1-.226.084.34.34 0 0 1-.224-.086l-.092-.077c-.699-1.615-1.768-2.669-2.781-3.67-1.454-1.435-2.797-2.762-2.78-5.478.02-3.067 2.7-5.545 5.975-5.523m-.02 2.826c-1.62-.01-2.944 1.315-2.955 2.96-.01 1.646 1.295 2.988 2.916 2.999h.002c1.621.01 2.943-1.316 2.953-2.961.011-1.646-1.294-2.988-2.916-2.998m-.005 1.1c1.017.006 1.829.83 1.822 1.89s-.83 1.874-1.848 1.867c-1.018-.006-1.829-.83-1.822-1.89s.83-1.874 1.848-1.868m-2.155 11.857 4.14.025c.271.002.49.305.487.676l-.013 1.875c-.003.37-.224.67-.495.668l-4.14-.025c-.27-.002-.487-.306-.485-.676l.012-1.875c.003-.37.224-.67.494-.668%27 style=%27color:%23000;font-style:normal;font-variant:normal;font-weight:400;font-stretch:normal;font-size:medium;line-height:normal;font-family:sans-serif;font-variant-ligatures:normal;font-variant-position:normal;font-variant-caps:normal;font-variant-numeric:normal;font-variant-alternates:normal;font-feature-settings:normal;text-indent:0;text-align:start;text-decoration:none;text-decoration-line:none;text-decoration-style:solid;text-decoration-color:%23000;letter-spacing:normal;word-spacing:normal;text-transform:none;writing-mode:lr-tb;direction:ltr;text-orientation:mixed;dominant-baseline:auto;baseline-shift:baseline;text-anchor:start;white-space:normal;shape-padding:0;clip-rule:evenodd;display:inline;overflow:visible;visibility:visible;opacity:1;isolation:auto;mix-blend-mode:normal;color-interpolation:sRGB;color-interpolation-filters:linearRGB;solid-color:%23000;solid-opacity:1;vector-effect:none;fill:%23000;fill-opacity:.4;fill-rule:evenodd;stroke:none;stroke-width:2.47727823;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1;color-rendering:auto;image-rendering:auto;shape-rendering:auto;text-rendering:auto%27 transform=%27translate%2815.553 2.85%29scale%28.88807%29%27/%3E%3Cpath d=%27M-9.415-.316C-12.69-.338-15.37 2.14-15.39 5.207c-.017 2.716 1.326 4.041 2.78 5.477 1.013 1 2.081 2.055 2.78 3.67l.092.076a.34.34 0 0 0 .225.086.34.34 0 0 0 .227-.083l.019-.01c.022-.009.057-.024.074-.064.697-1.6 1.78-2.64 2.814-3.634 1.473-1.414 2.847-2.733 2.864-5.44.02-3.067-2.627-5.58-5.901-5.601m-.057 8.784c1.621.011 2.944-1.315 2.955-2.96.01-1.646-1.295-2.988-2.916-2.999-1.622-.01-2.945 1.315-2.955 2.96s1.295 2.989 2.916 3%27 style=%27clip-rule:evenodd;fill:%23e1e3e9;fill-opacity:1;fill-rule:evenodd;stroke:none;stroke-width:2.47727823;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:.4%27 transform=%27translate%2815.553 2.85%29scale%28.88807%29%27/%3E%3Cpath d=%27M-11.594 15.465c-.27-.002-.492.297-.494.668l-.012 1.876c-.003.371.214.673.485.675l4.14.027c.271.002.492-.298.495-.668l.012-1.877c.003-.37-.215-.672-.485-.674z%27 style=%27clip-rule:evenodd;fill:%23fff;fill-opacity:1;fill-rule:evenodd;stroke:none;stroke-width:2.47727823;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:.4%27 transform=%27translate%2815.553 2.85%29scale%28.88807%29%27/%3E%3C/g%3E%3C/svg%3E";

/***/ }),

/***/ 63779:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 77199:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 61990:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", ({value: true}));// index.ts
var _helpers = __webpack_require__(85846);
var _meta = __webpack_require__(66030);
function area(geojson) {
  return _meta.geomReduce.call(void 0, 
    geojson,
    (value, geom) => {
      return value + calculateArea(geom);
    },
    0
  );
}
function calculateArea(geom) {
  let total = 0;
  let i;
  switch (geom.type) {
    case "Polygon":
      return polygonArea(geom.coordinates);
    case "MultiPolygon":
      for (i = 0; i < geom.coordinates.length; i++) {
        total += polygonArea(geom.coordinates[i]);
      }
      return total;
    case "Point":
    case "MultiPoint":
    case "LineString":
    case "MultiLineString":
      return 0;
  }
  return 0;
}
function polygonArea(coords) {
  let total = 0;
  if (coords && coords.length > 0) {
    total += Math.abs(ringArea(coords[0]));
    for (let i = 1; i < coords.length; i++) {
      total -= Math.abs(ringArea(coords[i]));
    }
  }
  return total;
}
var FACTOR = _helpers.earthRadius * _helpers.earthRadius / 2;
var PI_OVER_180 = Math.PI / 180;
function ringArea(coords) {
  const coordsLength = coords.length - 1;
  if (coordsLength <= 2)
    return 0;
  let total = 0;
  let i = 0;
  while (i < coordsLength) {
    const lower = coords[i];
    const middle = coords[i + 1 === coordsLength ? 0 : i + 1];
    const upper = coords[i + 2 >= coordsLength ? (i + 2) % coordsLength : i + 2];
    const lowerX = lower[0] * PI_OVER_180;
    const middleY = middle[1] * PI_OVER_180;
    const upperX = upper[0] * PI_OVER_180;
    total += (upperX - lowerX) * Math.sin(middleY);
    i++;
  }
  return total * FACTOR;
}
var turf_area_default = area;



exports.area = area; exports["default"] = turf_area_default;
//# sourceMappingURL=index.cjs.map

/***/ }),

/***/ 25368:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", ({value: true}));// index.ts
var _meta = __webpack_require__(66030);
function bbox(geojson, options = {}) {
  if (geojson.bbox != null && true !== options.recompute) {
    return geojson.bbox;
  }
  const result = [Infinity, Infinity, -Infinity, -Infinity];
  _meta.coordEach.call(void 0, geojson, (coord) => {
    if (result[0] > coord[0]) {
      result[0] = coord[0];
    }
    if (result[1] > coord[1]) {
      result[1] = coord[1];
    }
    if (result[2] < coord[0]) {
      result[2] = coord[0];
    }
    if (result[3] < coord[1]) {
      result[3] = coord[1];
    }
  });
  return result;
}
var turf_bbox_default = bbox;



exports.bbox = bbox; exports["default"] = turf_bbox_default;
//# sourceMappingURL=index.cjs.map

/***/ }),

/***/ 30035:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", ({value: true}));// index.ts
var _helpers = __webpack_require__(85846);
var _meta = __webpack_require__(66030);
function centroid(geojson, options = {}) {
  let xSum = 0;
  let ySum = 0;
  let len = 0;
  _meta.coordEach.call(void 0, 
    geojson,
    function(coord) {
      xSum += coord[0];
      ySum += coord[1];
      len++;
    },
    true
  );
  return _helpers.point.call(void 0, [xSum / len, ySum / len], options.properties);
}
var turf_centroid_default = centroid;



exports.centroid = centroid; exports["default"] = turf_centroid_default;
//# sourceMappingURL=index.cjs.map

/***/ }),

/***/ 85846:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
Object.defineProperty(exports, "__esModule", ({value: true}));// index.ts
var earthRadius = 63710088e-1;
var factors = {
  centimeters: earthRadius * 100,
  centimetres: earthRadius * 100,
  degrees: 360 / (2 * Math.PI),
  feet: earthRadius * 3.28084,
  inches: earthRadius * 39.37,
  kilometers: earthRadius / 1e3,
  kilometres: earthRadius / 1e3,
  meters: earthRadius,
  metres: earthRadius,
  miles: earthRadius / 1609.344,
  millimeters: earthRadius * 1e3,
  millimetres: earthRadius * 1e3,
  nauticalmiles: earthRadius / 1852,
  radians: 1,
  yards: earthRadius * 1.0936
};
var areaFactors = {
  acres: 247105e-9,
  centimeters: 1e4,
  centimetres: 1e4,
  feet: 10.763910417,
  hectares: 1e-4,
  inches: 1550.003100006,
  kilometers: 1e-6,
  kilometres: 1e-6,
  meters: 1,
  metres: 1,
  miles: 386e-9,
  nauticalmiles: 29155334959812285e-23,
  millimeters: 1e6,
  millimetres: 1e6,
  yards: 1.195990046
};
function feature(geom, properties, options = {}) {
  const feat = { type: "Feature" };
  if (options.id === 0 || options.id) {
    feat.id = options.id;
  }
  if (options.bbox) {
    feat.bbox = options.bbox;
  }
  feat.properties = properties || {};
  feat.geometry = geom;
  return feat;
}
function geometry(type, coordinates, _options = {}) {
  switch (type) {
    case "Point":
      return point(coordinates).geometry;
    case "LineString":
      return lineString(coordinates).geometry;
    case "Polygon":
      return polygon(coordinates).geometry;
    case "MultiPoint":
      return multiPoint(coordinates).geometry;
    case "MultiLineString":
      return multiLineString(coordinates).geometry;
    case "MultiPolygon":
      return multiPolygon(coordinates).geometry;
    default:
      throw new Error(type + " is invalid");
  }
}
function point(coordinates, properties, options = {}) {
  if (!coordinates) {
    throw new Error("coordinates is required");
  }
  if (!Array.isArray(coordinates)) {
    throw new Error("coordinates must be an Array");
  }
  if (coordinates.length < 2) {
    throw new Error("coordinates must be at least 2 numbers long");
  }
  if (!isNumber(coordinates[0]) || !isNumber(coordinates[1])) {
    throw new Error("coordinates must contain numbers");
  }
  const geom = {
    type: "Point",
    coordinates
  };
  return feature(geom, properties, options);
}
function points(coordinates, properties, options = {}) {
  return featureCollection(
    coordinates.map((coords) => {
      return point(coords, properties);
    }),
    options
  );
}
function polygon(coordinates, properties, options = {}) {
  for (const ring of coordinates) {
    if (ring.length < 4) {
      throw new Error(
        "Each LinearRing of a Polygon must have 4 or more Positions."
      );
    }
    if (ring[ring.length - 1].length !== ring[0].length) {
      throw new Error("First and last Position are not equivalent.");
    }
    for (let j = 0; j < ring[ring.length - 1].length; j++) {
      if (ring[ring.length - 1][j] !== ring[0][j]) {
        throw new Error("First and last Position are not equivalent.");
      }
    }
  }
  const geom = {
    type: "Polygon",
    coordinates
  };
  return feature(geom, properties, options);
}
function polygons(coordinates, properties, options = {}) {
  return featureCollection(
    coordinates.map((coords) => {
      return polygon(coords, properties);
    }),
    options
  );
}
function lineString(coordinates, properties, options = {}) {
  if (coordinates.length < 2) {
    throw new Error("coordinates must be an array of two or more positions");
  }
  const geom = {
    type: "LineString",
    coordinates
  };
  return feature(geom, properties, options);
}
function lineStrings(coordinates, properties, options = {}) {
  return featureCollection(
    coordinates.map((coords) => {
      return lineString(coords, properties);
    }),
    options
  );
}
function featureCollection(features, options = {}) {
  const fc = { type: "FeatureCollection" };
  if (options.id) {
    fc.id = options.id;
  }
  if (options.bbox) {
    fc.bbox = options.bbox;
  }
  fc.features = features;
  return fc;
}
function multiLineString(coordinates, properties, options = {}) {
  const geom = {
    type: "MultiLineString",
    coordinates
  };
  return feature(geom, properties, options);
}
function multiPoint(coordinates, properties, options = {}) {
  const geom = {
    type: "MultiPoint",
    coordinates
  };
  return feature(geom, properties, options);
}
function multiPolygon(coordinates, properties, options = {}) {
  const geom = {
    type: "MultiPolygon",
    coordinates
  };
  return feature(geom, properties, options);
}
function geometryCollection(geometries, properties, options = {}) {
  const geom = {
    type: "GeometryCollection",
    geometries
  };
  return feature(geom, properties, options);
}
function round(num, precision = 0) {
  if (precision && !(precision >= 0)) {
    throw new Error("precision must be a positive number");
  }
  const multiplier = Math.pow(10, precision || 0);
  return Math.round(num * multiplier) / multiplier;
}
function radiansToLength(radians, units = "kilometers") {
  const factor = factors[units];
  if (!factor) {
    throw new Error(units + " units is invalid");
  }
  return radians * factor;
}
function lengthToRadians(distance, units = "kilometers") {
  const factor = factors[units];
  if (!factor) {
    throw new Error(units + " units is invalid");
  }
  return distance / factor;
}
function lengthToDegrees(distance, units) {
  return radiansToDegrees(lengthToRadians(distance, units));
}
function bearingToAzimuth(bearing) {
  let angle = bearing % 360;
  if (angle < 0) {
    angle += 360;
  }
  return angle;
}
function azimuthToBearing(angle) {
  angle = angle % 360;
  if (angle > 0)
    return angle > 180 ? angle - 360 : angle;
  return angle < -180 ? angle + 360 : angle;
}
function radiansToDegrees(radians) {
  const degrees = radians % (2 * Math.PI);
  return degrees * 180 / Math.PI;
}
function degreesToRadians(degrees) {
  const radians = degrees % 360;
  return radians * Math.PI / 180;
}
function convertLength(length, originalUnit = "kilometers", finalUnit = "kilometers") {
  if (!(length >= 0)) {
    throw new Error("length must be a positive number");
  }
  return radiansToLength(lengthToRadians(length, originalUnit), finalUnit);
}
function convertArea(area, originalUnit = "meters", finalUnit = "kilometers") {
  if (!(area >= 0)) {
    throw new Error("area must be a positive number");
  }
  const startFactor = areaFactors[originalUnit];
  if (!startFactor) {
    throw new Error("invalid original units");
  }
  const finalFactor = areaFactors[finalUnit];
  if (!finalFactor) {
    throw new Error("invalid final units");
  }
  return area / startFactor * finalFactor;
}
function isNumber(num) {
  return !isNaN(num) && num !== null && !Array.isArray(num);
}
function isObject(input) {
  return input !== null && typeof input === "object" && !Array.isArray(input);
}
function validateBBox(bbox) {
  if (!bbox) {
    throw new Error("bbox is required");
  }
  if (!Array.isArray(bbox)) {
    throw new Error("bbox must be an Array");
  }
  if (bbox.length !== 4 && bbox.length !== 6) {
    throw new Error("bbox must be an Array of 4 or 6 numbers");
  }
  bbox.forEach((num) => {
    if (!isNumber(num)) {
      throw new Error("bbox must only contain numbers");
    }
  });
}
function validateId(id) {
  if (!id) {
    throw new Error("id is required");
  }
  if (["string", "number"].indexOf(typeof id) === -1) {
    throw new Error("id must be a number or a string");
  }
}































exports.areaFactors = areaFactors; exports.azimuthToBearing = azimuthToBearing; exports.bearingToAzimuth = bearingToAzimuth; exports.convertArea = convertArea; exports.convertLength = convertLength; exports.degreesToRadians = degreesToRadians; exports.earthRadius = earthRadius; exports.factors = factors; exports.feature = feature; exports.featureCollection = featureCollection; exports.geometry = geometry; exports.geometryCollection = geometryCollection; exports.isNumber = isNumber; exports.isObject = isObject; exports.lengthToDegrees = lengthToDegrees; exports.lengthToRadians = lengthToRadians; exports.lineString = lineString; exports.lineStrings = lineStrings; exports.multiLineString = multiLineString; exports.multiPoint = multiPoint; exports.multiPolygon = multiPolygon; exports.point = point; exports.points = points; exports.polygon = polygon; exports.polygons = polygons; exports.radiansToDegrees = radiansToDegrees; exports.radiansToLength = radiansToLength; exports.round = round; exports.validateBBox = validateBBox; exports.validateId = validateId;
//# sourceMappingURL=index.cjs.map

/***/ }),

/***/ 66030:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", ({value: true}));// index.js
var _helpers = __webpack_require__(85846);
function coordEach(geojson, callback, excludeWrapCoord) {
  if (geojson === null)
    return;
  var j, k, l, geometry, stopG, coords, geometryMaybeCollection, wrapShrink = 0, coordIndex = 0, isGeometryCollection, type = geojson.type, isFeatureCollection = type === "FeatureCollection", isFeature = type === "Feature", stop = isFeatureCollection ? geojson.features.length : 1;
  for (var featureIndex = 0; featureIndex < stop; featureIndex++) {
    geometryMaybeCollection = isFeatureCollection ? geojson.features[featureIndex].geometry : isFeature ? geojson.geometry : geojson;
    isGeometryCollection = geometryMaybeCollection ? geometryMaybeCollection.type === "GeometryCollection" : false;
    stopG = isGeometryCollection ? geometryMaybeCollection.geometries.length : 1;
    for (var geomIndex = 0; geomIndex < stopG; geomIndex++) {
      var multiFeatureIndex = 0;
      var geometryIndex = 0;
      geometry = isGeometryCollection ? geometryMaybeCollection.geometries[geomIndex] : geometryMaybeCollection;
      if (geometry === null)
        continue;
      coords = geometry.coordinates;
      var geomType = geometry.type;
      wrapShrink = excludeWrapCoord && (geomType === "Polygon" || geomType === "MultiPolygon") ? 1 : 0;
      switch (geomType) {
        case null:
          break;
        case "Point":
          if (callback(
            coords,
            coordIndex,
            featureIndex,
            multiFeatureIndex,
            geometryIndex
          ) === false)
            return false;
          coordIndex++;
          multiFeatureIndex++;
          break;
        case "LineString":
        case "MultiPoint":
          for (j = 0; j < coords.length; j++) {
            if (callback(
              coords[j],
              coordIndex,
              featureIndex,
              multiFeatureIndex,
              geometryIndex
            ) === false)
              return false;
            coordIndex++;
            if (geomType === "MultiPoint")
              multiFeatureIndex++;
          }
          if (geomType === "LineString")
            multiFeatureIndex++;
          break;
        case "Polygon":
        case "MultiLineString":
          for (j = 0; j < coords.length; j++) {
            for (k = 0; k < coords[j].length - wrapShrink; k++) {
              if (callback(
                coords[j][k],
                coordIndex,
                featureIndex,
                multiFeatureIndex,
                geometryIndex
              ) === false)
                return false;
              coordIndex++;
            }
            if (geomType === "MultiLineString")
              multiFeatureIndex++;
            if (geomType === "Polygon")
              geometryIndex++;
          }
          if (geomType === "Polygon")
            multiFeatureIndex++;
          break;
        case "MultiPolygon":
          for (j = 0; j < coords.length; j++) {
            geometryIndex = 0;
            for (k = 0; k < coords[j].length; k++) {
              for (l = 0; l < coords[j][k].length - wrapShrink; l++) {
                if (callback(
                  coords[j][k][l],
                  coordIndex,
                  featureIndex,
                  multiFeatureIndex,
                  geometryIndex
                ) === false)
                  return false;
                coordIndex++;
              }
              geometryIndex++;
            }
            multiFeatureIndex++;
          }
          break;
        case "GeometryCollection":
          for (j = 0; j < geometry.geometries.length; j++)
            if (coordEach(geometry.geometries[j], callback, excludeWrapCoord) === false)
              return false;
          break;
        default:
          throw new Error("Unknown Geometry Type");
      }
    }
  }
}
function coordReduce(geojson, callback, initialValue, excludeWrapCoord) {
  var previousValue = initialValue;
  coordEach(
    geojson,
    function(currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) {
      if (coordIndex === 0 && initialValue === void 0)
        previousValue = currentCoord;
      else
        previousValue = callback(
          previousValue,
          currentCoord,
          coordIndex,
          featureIndex,
          multiFeatureIndex,
          geometryIndex
        );
    },
    excludeWrapCoord
  );
  return previousValue;
}
function propEach(geojson, callback) {
  var i;
  switch (geojson.type) {
    case "FeatureCollection":
      for (i = 0; i < geojson.features.length; i++) {
        if (callback(geojson.features[i].properties, i) === false)
          break;
      }
      break;
    case "Feature":
      callback(geojson.properties, 0);
      break;
  }
}
function propReduce(geojson, callback, initialValue) {
  var previousValue = initialValue;
  propEach(geojson, function(currentProperties, featureIndex) {
    if (featureIndex === 0 && initialValue === void 0)
      previousValue = currentProperties;
    else
      previousValue = callback(previousValue, currentProperties, featureIndex);
  });
  return previousValue;
}
function featureEach(geojson, callback) {
  if (geojson.type === "Feature") {
    callback(geojson, 0);
  } else if (geojson.type === "FeatureCollection") {
    for (var i = 0; i < geojson.features.length; i++) {
      if (callback(geojson.features[i], i) === false)
        break;
    }
  }
}
function featureReduce(geojson, callback, initialValue) {
  var previousValue = initialValue;
  featureEach(geojson, function(currentFeature, featureIndex) {
    if (featureIndex === 0 && initialValue === void 0)
      previousValue = currentFeature;
    else
      previousValue = callback(previousValue, currentFeature, featureIndex);
  });
  return previousValue;
}
function coordAll(geojson) {
  var coords = [];
  coordEach(geojson, function(coord) {
    coords.push(coord);
  });
  return coords;
}
function geomEach(geojson, callback) {
  var i, j, g, geometry, stopG, geometryMaybeCollection, isGeometryCollection, featureProperties, featureBBox, featureId, featureIndex = 0, isFeatureCollection = geojson.type === "FeatureCollection", isFeature = geojson.type === "Feature", stop = isFeatureCollection ? geojson.features.length : 1;
  for (i = 0; i < stop; i++) {
    geometryMaybeCollection = isFeatureCollection ? geojson.features[i].geometry : isFeature ? geojson.geometry : geojson;
    featureProperties = isFeatureCollection ? geojson.features[i].properties : isFeature ? geojson.properties : {};
    featureBBox = isFeatureCollection ? geojson.features[i].bbox : isFeature ? geojson.bbox : void 0;
    featureId = isFeatureCollection ? geojson.features[i].id : isFeature ? geojson.id : void 0;
    isGeometryCollection = geometryMaybeCollection ? geometryMaybeCollection.type === "GeometryCollection" : false;
    stopG = isGeometryCollection ? geometryMaybeCollection.geometries.length : 1;
    for (g = 0; g < stopG; g++) {
      geometry = isGeometryCollection ? geometryMaybeCollection.geometries[g] : geometryMaybeCollection;
      if (geometry === null) {
        if (callback(
          null,
          featureIndex,
          featureProperties,
          featureBBox,
          featureId
        ) === false)
          return false;
        continue;
      }
      switch (geometry.type) {
        case "Point":
        case "LineString":
        case "MultiPoint":
        case "Polygon":
        case "MultiLineString":
        case "MultiPolygon": {
          if (callback(
            geometry,
            featureIndex,
            featureProperties,
            featureBBox,
            featureId
          ) === false)
            return false;
          break;
        }
        case "GeometryCollection": {
          for (j = 0; j < geometry.geometries.length; j++) {
            if (callback(
              geometry.geometries[j],
              featureIndex,
              featureProperties,
              featureBBox,
              featureId
            ) === false)
              return false;
          }
          break;
        }
        default:
          throw new Error("Unknown Geometry Type");
      }
    }
    featureIndex++;
  }
}
function geomReduce(geojson, callback, initialValue) {
  var previousValue = initialValue;
  geomEach(
    geojson,
    function(currentGeometry, featureIndex, featureProperties, featureBBox, featureId) {
      if (featureIndex === 0 && initialValue === void 0)
        previousValue = currentGeometry;
      else
        previousValue = callback(
          previousValue,
          currentGeometry,
          featureIndex,
          featureProperties,
          featureBBox,
          featureId
        );
    }
  );
  return previousValue;
}
function flattenEach(geojson, callback) {
  geomEach(geojson, function(geometry, featureIndex, properties, bbox, id) {
    var type = geometry === null ? null : geometry.type;
    switch (type) {
      case null:
      case "Point":
      case "LineString":
      case "Polygon":
        if (callback(
          _helpers.feature.call(void 0, geometry, properties, { bbox, id }),
          featureIndex,
          0
        ) === false)
          return false;
        return;
    }
    var geomType;
    switch (type) {
      case "MultiPoint":
        geomType = "Point";
        break;
      case "MultiLineString":
        geomType = "LineString";
        break;
      case "MultiPolygon":
        geomType = "Polygon";
        break;
    }
    for (var multiFeatureIndex = 0; multiFeatureIndex < geometry.coordinates.length; multiFeatureIndex++) {
      var coordinate = geometry.coordinates[multiFeatureIndex];
      var geom = {
        type: geomType,
        coordinates: coordinate
      };
      if (callback(_helpers.feature.call(void 0, geom, properties), featureIndex, multiFeatureIndex) === false)
        return false;
    }
  });
}
function flattenReduce(geojson, callback, initialValue) {
  var previousValue = initialValue;
  flattenEach(
    geojson,
    function(currentFeature, featureIndex, multiFeatureIndex) {
      if (featureIndex === 0 && multiFeatureIndex === 0 && initialValue === void 0)
        previousValue = currentFeature;
      else
        previousValue = callback(
          previousValue,
          currentFeature,
          featureIndex,
          multiFeatureIndex
        );
    }
  );
  return previousValue;
}
function segmentEach(geojson, callback) {
  flattenEach(geojson, function(feature2, featureIndex, multiFeatureIndex) {
    var segmentIndex = 0;
    if (!feature2.geometry)
      return;
    var type = feature2.geometry.type;
    if (type === "Point" || type === "MultiPoint")
      return;
    var previousCoords;
    var previousFeatureIndex = 0;
    var previousMultiIndex = 0;
    var prevGeomIndex = 0;
    if (coordEach(
      feature2,
      function(currentCoord, coordIndex, featureIndexCoord, multiPartIndexCoord, geometryIndex) {
        if (previousCoords === void 0 || featureIndex > previousFeatureIndex || multiPartIndexCoord > previousMultiIndex || geometryIndex > prevGeomIndex) {
          previousCoords = currentCoord;
          previousFeatureIndex = featureIndex;
          previousMultiIndex = multiPartIndexCoord;
          prevGeomIndex = geometryIndex;
          segmentIndex = 0;
          return;
        }
        var currentSegment = _helpers.lineString.call(void 0, 
          [previousCoords, currentCoord],
          feature2.properties
        );
        if (callback(
          currentSegment,
          featureIndex,
          multiFeatureIndex,
          geometryIndex,
          segmentIndex
        ) === false)
          return false;
        segmentIndex++;
        previousCoords = currentCoord;
      }
    ) === false)
      return false;
  });
}
function segmentReduce(geojson, callback, initialValue) {
  var previousValue = initialValue;
  var started = false;
  segmentEach(
    geojson,
    function(currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) {
      if (started === false && initialValue === void 0)
        previousValue = currentSegment;
      else
        previousValue = callback(
          previousValue,
          currentSegment,
          featureIndex,
          multiFeatureIndex,
          geometryIndex,
          segmentIndex
        );
      started = true;
    }
  );
  return previousValue;
}
function lineEach(geojson, callback) {
  if (!geojson)
    throw new Error("geojson is required");
  flattenEach(geojson, function(feature2, featureIndex, multiFeatureIndex) {
    if (feature2.geometry === null)
      return;
    var type = feature2.geometry.type;
    var coords = feature2.geometry.coordinates;
    switch (type) {
      case "LineString":
        if (callback(feature2, featureIndex, multiFeatureIndex, 0, 0) === false)
          return false;
        break;
      case "Polygon":
        for (var geometryIndex = 0; geometryIndex < coords.length; geometryIndex++) {
          if (callback(
            _helpers.lineString.call(void 0, coords[geometryIndex], feature2.properties),
            featureIndex,
            multiFeatureIndex,
            geometryIndex
          ) === false)
            return false;
        }
        break;
    }
  });
}
function lineReduce(geojson, callback, initialValue) {
  var previousValue = initialValue;
  lineEach(
    geojson,
    function(currentLine, featureIndex, multiFeatureIndex, geometryIndex) {
      if (featureIndex === 0 && initialValue === void 0)
        previousValue = currentLine;
      else
        previousValue = callback(
          previousValue,
          currentLine,
          featureIndex,
          multiFeatureIndex,
          geometryIndex
        );
    }
  );
  return previousValue;
}
function findSegment(geojson, options) {
  options = options || {};
  if (!_helpers.isObject.call(void 0, options))
    throw new Error("options is invalid");
  var featureIndex = options.featureIndex || 0;
  var multiFeatureIndex = options.multiFeatureIndex || 0;
  var geometryIndex = options.geometryIndex || 0;
  var segmentIndex = options.segmentIndex || 0;
  var properties = options.properties;
  var geometry;
  switch (geojson.type) {
    case "FeatureCollection":
      if (featureIndex < 0)
        featureIndex = geojson.features.length + featureIndex;
      properties = properties || geojson.features[featureIndex].properties;
      geometry = geojson.features[featureIndex].geometry;
      break;
    case "Feature":
      properties = properties || geojson.properties;
      geometry = geojson.geometry;
      break;
    case "Point":
    case "MultiPoint":
      return null;
    case "LineString":
    case "Polygon":
    case "MultiLineString":
    case "MultiPolygon":
      geometry = geojson;
      break;
    default:
      throw new Error("geojson is invalid");
  }
  if (geometry === null)
    return null;
  var coords = geometry.coordinates;
  switch (geometry.type) {
    case "Point":
    case "MultiPoint":
      return null;
    case "LineString":
      if (segmentIndex < 0)
        segmentIndex = coords.length + segmentIndex - 1;
      return _helpers.lineString.call(void 0, 
        [coords[segmentIndex], coords[segmentIndex + 1]],
        properties,
        options
      );
    case "Polygon":
      if (geometryIndex < 0)
        geometryIndex = coords.length + geometryIndex;
      if (segmentIndex < 0)
        segmentIndex = coords[geometryIndex].length + segmentIndex - 1;
      return _helpers.lineString.call(void 0, 
        [
          coords[geometryIndex][segmentIndex],
          coords[geometryIndex][segmentIndex + 1]
        ],
        properties,
        options
      );
    case "MultiLineString":
      if (multiFeatureIndex < 0)
        multiFeatureIndex = coords.length + multiFeatureIndex;
      if (segmentIndex < 0)
        segmentIndex = coords[multiFeatureIndex].length + segmentIndex - 1;
      return _helpers.lineString.call(void 0, 
        [
          coords[multiFeatureIndex][segmentIndex],
          coords[multiFeatureIndex][segmentIndex + 1]
        ],
        properties,
        options
      );
    case "MultiPolygon":
      if (multiFeatureIndex < 0)
        multiFeatureIndex = coords.length + multiFeatureIndex;
      if (geometryIndex < 0)
        geometryIndex = coords[multiFeatureIndex].length + geometryIndex;
      if (segmentIndex < 0)
        segmentIndex = coords[multiFeatureIndex][geometryIndex].length - segmentIndex - 1;
      return _helpers.lineString.call(void 0, 
        [
          coords[multiFeatureIndex][geometryIndex][segmentIndex],
          coords[multiFeatureIndex][geometryIndex][segmentIndex + 1]
        ],
        properties,
        options
      );
  }
  throw new Error("geojson is invalid");
}
function findPoint(geojson, options) {
  options = options || {};
  if (!_helpers.isObject.call(void 0, options))
    throw new Error("options is invalid");
  var featureIndex = options.featureIndex || 0;
  var multiFeatureIndex = options.multiFeatureIndex || 0;
  var geometryIndex = options.geometryIndex || 0;
  var coordIndex = options.coordIndex || 0;
  var properties = options.properties;
  var geometry;
  switch (geojson.type) {
    case "FeatureCollection":
      if (featureIndex < 0)
        featureIndex = geojson.features.length + featureIndex;
      properties = properties || geojson.features[featureIndex].properties;
      geometry = geojson.features[featureIndex].geometry;
      break;
    case "Feature":
      properties = properties || geojson.properties;
      geometry = geojson.geometry;
      break;
    case "Point":
    case "MultiPoint":
      return null;
    case "LineString":
    case "Polygon":
    case "MultiLineString":
    case "MultiPolygon":
      geometry = geojson;
      break;
    default:
      throw new Error("geojson is invalid");
  }
  if (geometry === null)
    return null;
  var coords = geometry.coordinates;
  switch (geometry.type) {
    case "Point":
      return _helpers.point.call(void 0, coords, properties, options);
    case "MultiPoint":
      if (multiFeatureIndex < 0)
        multiFeatureIndex = coords.length + multiFeatureIndex;
      return _helpers.point.call(void 0, coords[multiFeatureIndex], properties, options);
    case "LineString":
      if (coordIndex < 0)
        coordIndex = coords.length + coordIndex;
      return _helpers.point.call(void 0, coords[coordIndex], properties, options);
    case "Polygon":
      if (geometryIndex < 0)
        geometryIndex = coords.length + geometryIndex;
      if (coordIndex < 0)
        coordIndex = coords[geometryIndex].length + coordIndex;
      return _helpers.point.call(void 0, coords[geometryIndex][coordIndex], properties, options);
    case "MultiLineString":
      if (multiFeatureIndex < 0)
        multiFeatureIndex = coords.length + multiFeatureIndex;
      if (coordIndex < 0)
        coordIndex = coords[multiFeatureIndex].length + coordIndex;
      return _helpers.point.call(void 0, coords[multiFeatureIndex][coordIndex], properties, options);
    case "MultiPolygon":
      if (multiFeatureIndex < 0)
        multiFeatureIndex = coords.length + multiFeatureIndex;
      if (geometryIndex < 0)
        geometryIndex = coords[multiFeatureIndex].length + geometryIndex;
      if (coordIndex < 0)
        coordIndex = coords[multiFeatureIndex][geometryIndex].length - coordIndex;
      return _helpers.point.call(void 0, 
        coords[multiFeatureIndex][geometryIndex][coordIndex],
        properties,
        options
      );
  }
  throw new Error("geojson is invalid");
}


















exports.coordAll = coordAll; exports.coordEach = coordEach; exports.coordReduce = coordReduce; exports.featureEach = featureEach; exports.featureReduce = featureReduce; exports.findPoint = findPoint; exports.findSegment = findSegment; exports.flattenEach = flattenEach; exports.flattenReduce = flattenReduce; exports.geomEach = geomEach; exports.geomReduce = geomReduce; exports.lineEach = lineEach; exports.lineReduce = lineReduce; exports.propEach = propEach; exports.propReduce = propReduce; exports.segmentEach = segmentEach; exports.segmentReduce = segmentReduce;
//# sourceMappingURL=index.cjs.map

/***/ }),

/***/ 70085:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var /** @type {ReturnType<import('.')>} */ possibleNames = [
	'BigInt64Array',
	'BigUint64Array',
	'Float32Array',
	'Float64Array',
	'Int16Array',
	'Int32Array',
	'Int8Array',
	'Uint16Array',
	'Uint32Array',
	'Uint8Array',
	'Uint8ClampedArray'
];

var g = typeof globalThis === 'undefined' ? __webpack_require__.g : globalThis;

/** @type {import('.')} */
module.exports = function availableTypedArrays() {
	var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
	for (var i = 0; i < possibleNames.length; i++) {
		if (typeof g[possibleNames[i]] === 'function') {
			// @ts-expect-error
			out[out.length] = possibleNames[i];
		}
	}
	return out;
};


/***/ }),

/***/ 89380:
/***/ (function(module) {

/**
 * MapLibre GL JS
 * @license 3-Clause BSD. Full text of license: https://github.com/maplibre/maplibre-gl-js/blob/v4.5.2/LICENSE.txt
 */
(function (global, factory) {
 true ? module.exports = factory() :
0;
})(this, (function () { 'use strict';

/* eslint-disable */

var maplibregl = {};
var modules = {};
function define(moduleName, _dependencies, moduleFactory) {
    modules[moduleName] = moduleFactory;

    // to get the list of modules see generated dist/maplibre-gl-dev.js file (look for `define(` calls)
    if (moduleName !== 'index') {
        return;
    }

    // we assume that when an index module is initializing then other modules are loaded already
    var workerBundleString = 'var sharedModule = {}; (' + modules.shared + ')(sharedModule); (' + modules.worker + ')(sharedModule);'

    var sharedModule = {};
    // the order of arguments of a module factory depends on rollup (it decides who is whose dependency)
    // to check the correct order, see dist/maplibre-gl-dev.js file (look for `define(` calls)
    // we assume that for our 3 chunks it will generate 3 modules and their order is predefined like the following
    modules.shared(sharedModule);
    modules.index(maplibregl, sharedModule);

    if (typeof window !== 'undefined') {
        maplibregl.setWorkerUrl(window.URL.createObjectURL(new Blob([workerBundleString], { type: 'text/javascript' })));
    }

    return maplibregl;
};



define('shared', ['exports'], (function (exports) { 'use strict';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */


function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function getDefaultExportFromCjs$1 (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var pointGeometry = Point$1;

/**
 * A standalone point geometry with useful accessor, comparison, and
 * modification methods.
 *
 * @class Point
 * @param {Number} x the x-coordinate. this could be longitude or screen
 * pixels, or any other sort of unit.
 * @param {Number} y the y-coordinate. this could be latitude or screen
 * pixels, or any other sort of unit.
 * @example
 * var point = new Point(-77, 38);
 */
function Point$1(x, y) {
    this.x = x;
    this.y = y;
}

Point$1.prototype = {

    /**
     * Clone this point, returning a new point that can be modified
     * without affecting the old one.
     * @return {Point} the clone
     */
    clone: function() { return new Point$1(this.x, this.y); },

    /**
     * Add this point's x & y coordinates to another point,
     * yielding a new point.
     * @param {Point} p the other point
     * @return {Point} output point
     */
    add:     function(p) { return this.clone()._add(p); },

    /**
     * Subtract this point's x & y coordinates to from point,
     * yielding a new point.
     * @param {Point} p the other point
     * @return {Point} output point
     */
    sub:     function(p) { return this.clone()._sub(p); },

    /**
     * Multiply this point's x & y coordinates by point,
     * yielding a new point.
     * @param {Point} p the other point
     * @return {Point} output point
     */
    multByPoint:    function(p) { return this.clone()._multByPoint(p); },

    /**
     * Divide this point's x & y coordinates by point,
     * yielding a new point.
     * @param {Point} p the other point
     * @return {Point} output point
     */
    divByPoint:     function(p) { return this.clone()._divByPoint(p); },

    /**
     * Multiply this point's x & y coordinates by a factor,
     * yielding a new point.
     * @param {Point} k factor
     * @return {Point} output point
     */
    mult:    function(k) { return this.clone()._mult(k); },

    /**
     * Divide this point's x & y coordinates by a factor,
     * yielding a new point.
     * @param {Point} k factor
     * @return {Point} output point
     */
    div:     function(k) { return this.clone()._div(k); },

    /**
     * Rotate this point around the 0, 0 origin by an angle a,
     * given in radians
     * @param {Number} a angle to rotate around, in radians
     * @return {Point} output point
     */
    rotate:  function(a) { return this.clone()._rotate(a); },

    /**
     * Rotate this point around p point by an angle a,
     * given in radians
     * @param {Number} a angle to rotate around, in radians
     * @param {Point} p Point to rotate around
     * @return {Point} output point
     */
    rotateAround:  function(a,p) { return this.clone()._rotateAround(a,p); },

    /**
     * Multiply this point by a 4x1 transformation matrix
     * @param {Array<Number>} m transformation matrix
     * @return {Point} output point
     */
    matMult: function(m) { return this.clone()._matMult(m); },

    /**
     * Calculate this point but as a unit vector from 0, 0, meaning
     * that the distance from the resulting point to the 0, 0
     * coordinate will be equal to 1 and the angle from the resulting
     * point to the 0, 0 coordinate will be the same as before.
     * @return {Point} unit vector point
     */
    unit:    function() { return this.clone()._unit(); },

    /**
     * Compute a perpendicular point, where the new y coordinate
     * is the old x coordinate and the new x coordinate is the old y
     * coordinate multiplied by -1
     * @return {Point} perpendicular point
     */
    perp:    function() { return this.clone()._perp(); },

    /**
     * Return a version of this point with the x & y coordinates
     * rounded to integers.
     * @return {Point} rounded point
     */
    round:   function() { return this.clone()._round(); },

    /**
     * Return the magitude of this point: this is the Euclidean
     * distance from the 0, 0 coordinate to this point's x and y
     * coordinates.
     * @return {Number} magnitude
     */
    mag: function() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    },

    /**
     * Judge whether this point is equal to another point, returning
     * true or false.
     * @param {Point} other the other point
     * @return {boolean} whether the points are equal
     */
    equals: function(other) {
        return this.x === other.x &&
               this.y === other.y;
    },

    /**
     * Calculate the distance from this point to another point
     * @param {Point} p the other point
     * @return {Number} distance
     */
    dist: function(p) {
        return Math.sqrt(this.distSqr(p));
    },

    /**
     * Calculate the distance from this point to another point,
     * without the square root step. Useful if you're comparing
     * relative distances.
     * @param {Point} p the other point
     * @return {Number} distance
     */
    distSqr: function(p) {
        var dx = p.x - this.x,
            dy = p.y - this.y;
        return dx * dx + dy * dy;
    },

    /**
     * Get the angle from the 0, 0 coordinate to this point, in radians
     * coordinates.
     * @return {Number} angle
     */
    angle: function() {
        return Math.atan2(this.y, this.x);
    },

    /**
     * Get the angle from this point to another point, in radians
     * @param {Point} b the other point
     * @return {Number} angle
     */
    angleTo: function(b) {
        return Math.atan2(this.y - b.y, this.x - b.x);
    },

    /**
     * Get the angle between this point and another point, in radians
     * @param {Point} b the other point
     * @return {Number} angle
     */
    angleWith: function(b) {
        return this.angleWithSep(b.x, b.y);
    },

    /*
     * Find the angle of the two vectors, solving the formula for
     * the cross product a x b = |a||b|sin(θ) for θ.
     * @param {Number} x the x-coordinate
     * @param {Number} y the y-coordinate
     * @return {Number} the angle in radians
     */
    angleWithSep: function(x, y) {
        return Math.atan2(
            this.x * y - this.y * x,
            this.x * x + this.y * y);
    },

    _matMult: function(m) {
        var x = m[0] * this.x + m[1] * this.y,
            y = m[2] * this.x + m[3] * this.y;
        this.x = x;
        this.y = y;
        return this;
    },

    _add: function(p) {
        this.x += p.x;
        this.y += p.y;
        return this;
    },

    _sub: function(p) {
        this.x -= p.x;
        this.y -= p.y;
        return this;
    },

    _mult: function(k) {
        this.x *= k;
        this.y *= k;
        return this;
    },

    _div: function(k) {
        this.x /= k;
        this.y /= k;
        return this;
    },

    _multByPoint: function(p) {
        this.x *= p.x;
        this.y *= p.y;
        return this;
    },

    _divByPoint: function(p) {
        this.x /= p.x;
        this.y /= p.y;
        return this;
    },

    _unit: function() {
        this._div(this.mag());
        return this;
    },

    _perp: function() {
        var y = this.y;
        this.y = this.x;
        this.x = -y;
        return this;
    },

    _rotate: function(angle) {
        var cos = Math.cos(angle),
            sin = Math.sin(angle),
            x = cos * this.x - sin * this.y,
            y = sin * this.x + cos * this.y;
        this.x = x;
        this.y = y;
        return this;
    },

    _rotateAround: function(angle, p) {
        var cos = Math.cos(angle),
            sin = Math.sin(angle),
            x = p.x + cos * (this.x - p.x) - sin * (this.y - p.y),
            y = p.y + sin * (this.x - p.x) + cos * (this.y - p.y);
        this.x = x;
        this.y = y;
        return this;
    },

    _round: function() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        return this;
    }
};

/**
 * Construct a point from an array if necessary, otherwise if the input
 * is already a Point, or an unknown type, return it unchanged
 * @param {Array<Number>|Point|*} a any kind of input value
 * @return {Point} constructed point, or passed-through value.
 * @example
 * // this
 * var point = Point.convert([0, 1]);
 * // is equivalent to
 * var point = new Point(0, 1);
 */
Point$1.convert = function (a) {
    if (a instanceof Point$1) {
        return a;
    }
    if (Array.isArray(a)) {
        return new Point$1(a[0], a[1]);
    }
    return a;
};

var Point$2 = /*@__PURE__*/getDefaultExportFromCjs$1(pointGeometry);

var unitbezier$1 = UnitBezier$2;

function UnitBezier$2(p1x, p1y, p2x, p2y) {
    // Calculate the polynomial coefficients, implicit first and last control points are (0,0) and (1,1).
    this.cx = 3.0 * p1x;
    this.bx = 3.0 * (p2x - p1x) - this.cx;
    this.ax = 1.0 - this.cx - this.bx;

    this.cy = 3.0 * p1y;
    this.by = 3.0 * (p2y - p1y) - this.cy;
    this.ay = 1.0 - this.cy - this.by;

    this.p1x = p1x;
    this.p1y = p1y;
    this.p2x = p2x;
    this.p2y = p2y;
}

UnitBezier$2.prototype = {
    sampleCurveX: function (t) {
        // `ax t^3 + bx t^2 + cx t' expanded using Horner's rule.
        return ((this.ax * t + this.bx) * t + this.cx) * t;
    },

    sampleCurveY: function (t) {
        return ((this.ay * t + this.by) * t + this.cy) * t;
    },

    sampleCurveDerivativeX: function (t) {
        return (3.0 * this.ax * t + 2.0 * this.bx) * t + this.cx;
    },

    solveCurveX: function (x, epsilon) {
        if (epsilon === undefined) epsilon = 1e-6;

        if (x < 0.0) return 0.0;
        if (x > 1.0) return 1.0;

        var t = x;

        // First try a few iterations of Newton's method - normally very fast.
        for (var i = 0; i < 8; i++) {
            var x2 = this.sampleCurveX(t) - x;
            if (Math.abs(x2) < epsilon) return t;

            var d2 = this.sampleCurveDerivativeX(t);
            if (Math.abs(d2) < 1e-6) break;

            t = t - x2 / d2;
        }

        // Fall back to the bisection method for reliability.
        var t0 = 0.0;
        var t1 = 1.0;
        t = x;

        for (i = 0; i < 20; i++) {
            x2 = this.sampleCurveX(t);
            if (Math.abs(x2 - x) < epsilon) break;

            if (x > x2) {
                t0 = t;
            } else {
                t1 = t;
            }

            t = (t1 - t0) * 0.5 + t0;
        }

        return t;
    },

    solve: function (x, epsilon) {
        return this.sampleCurveY(this.solveCurveX(x, epsilon));
    }
};

var UnitBezier$3 = /*@__PURE__*/getDefaultExportFromCjs$1(unitbezier$1);

let supportsOffscreenCanvas;
function offscreenCanvasSupported() {
    if (supportsOffscreenCanvas == null) {
        supportsOffscreenCanvas = typeof OffscreenCanvas !== 'undefined' &&
            new OffscreenCanvas(1, 1).getContext('2d') &&
            typeof createImageBitmap === 'function';
    }
    return supportsOffscreenCanvas;
}

let offscreenCanvasDistorted;
/**
 * Some browsers don't return the exact pixels from a canvas to prevent user fingerprinting (see #3185).
 * This function writes pixels to an OffscreenCanvas and reads them back using getImageData, returning false
 * if they don't match.
 *
 * @returns true if the browser supports OffscreenCanvas but it distorts getImageData results, false otherwise.
 */
function isOffscreenCanvasDistorted() {
    if (offscreenCanvasDistorted == null) {
        offscreenCanvasDistorted = false;
        if (offscreenCanvasSupported()) {
            const size = 5;
            const canvas = new OffscreenCanvas(size, size);
            const context = canvas.getContext('2d', { willReadFrequently: true });
            if (context) {
                // fill each pixel with an RGB value that should make the byte at index i equal to i (except alpha channel):
                // [0, 1, 2, 255, 4, 5, 6, 255, 8, 9, 10, 255, ...]
                for (let i = 0; i < size * size; i++) {
                    const base = i * 4;
                    context.fillStyle = `rgb(${base},${base + 1},${base + 2})`;
                    context.fillRect(i % size, Math.floor(i / size), 1, 1);
                }
                const data = context.getImageData(0, 0, size, size).data;
                for (let i = 0; i < size * size * 4; i++) {
                    if (i % 4 !== 3 && data[i] !== i) {
                        offscreenCanvasDistorted = true;
                        break;
                    }
                }
            }
        }
    }
    return offscreenCanvasDistorted || false;
}

/**
 * For a given collection of 2D points, returns their axis-aligned bounding box,
 * in the format [minX, minY, maxX, maxY].
 */
function getAABB(points) {
    let tlX = Infinity;
    let tlY = Infinity;
    let brX = -Infinity;
    let brY = -Infinity;
    for (const p of points) {
        tlX = Math.min(tlX, p.x);
        tlY = Math.min(tlY, p.y);
        brX = Math.max(brX, p.x);
        brY = Math.max(brY, p.y);
    }
    return [tlX, tlY, brX, brY];
}
/**
 * Given a value `t` that varies between 0 and 1, return
 * an interpolation function that eases between 0 and 1 in a pleasing
 * cubic in-out fashion.
 */
function easeCubicInOut(t) {
    if (t <= 0)
        return 0;
    if (t >= 1)
        return 1;
    const t2 = t * t, t3 = t2 * t;
    return 4 * (t < 0.5 ? t3 : 3 * (t - t2) + t3 - 0.75);
}
/**
 * Given given (x, y), (x1, y1) control points for a bezier curve,
 * return a function that interpolates along that curve.
 *
 * @param p1x - control point 1 x coordinate
 * @param p1y - control point 1 y coordinate
 * @param p2x - control point 2 x coordinate
 * @param p2y - control point 2 y coordinate
 */
function bezier(p1x, p1y, p2x, p2y) {
    const bezier = new UnitBezier$3(p1x, p1y, p2x, p2y);
    return (t) => {
        return bezier.solve(t);
    };
}
/**
 * A default bezier-curve powered easing function with
 * control points (0.25, 0.1) and (0.25, 1)
 */
const defaultEasing = bezier(0.25, 0.1, 0.25, 1);
/**
 * constrain n to the given range via min + max
 *
 * @param n - value
 * @param min - the minimum value to be returned
 * @param max - the maximum value to be returned
 * @returns the clamped value
 */
function clamp$1(n, min, max) {
    return Math.min(max, Math.max(min, n));
}
/**
 * constrain n to the given range, excluding the minimum, via modular arithmetic
 *
 * @param n - value
 * @param min - the minimum value to be returned, exclusive
 * @param max - the maximum value to be returned, inclusive
 * @returns constrained number
 */
function wrap(n, min, max) {
    const d = max - min;
    const w = ((n - min) % d + d) % d + min;
    return (w === min) ? max : w;
}
/**
 * Compute the difference between the keys in one object and the keys
 * in another object.
 *
 * @returns keys difference
 */
function keysDifference(obj, other) {
    const difference = [];
    for (const i in obj) {
        if (!(i in other)) {
            difference.push(i);
        }
    }
    return difference;
}
function extend(dest, ...sources) {
    for (const src of sources) {
        for (const k in src) {
            dest[k] = src[k];
        }
    }
    return dest;
}
/**
 * Given an object and a number of properties as strings, return version
 * of that object with only those properties.
 *
 * @param src - the object
 * @param properties - an array of property names chosen
 * to appear on the resulting object.
 * @returns object with limited properties.
 * @example
 * ```ts
 * let foo = { name: 'Charlie', age: 10 };
 * let justName = pick(foo, ['name']); // justName = { name: 'Charlie' }
 * ```
 */
function pick(src, properties) {
    const result = {};
    for (let i = 0; i < properties.length; i++) {
        const k = properties[i];
        if (k in src) {
            result[k] = src[k];
        }
    }
    return result;
}
let id = 1;
/**
 * Return a unique numeric id, starting at 1 and incrementing with
 * each call.
 *
 * @returns unique numeric id.
 */
function uniqueId() {
    return id++;
}
/**
 * Return whether a given value is a power of two
 */
function isPowerOfTwo(value) {
    return (Math.log(value) / Math.LN2) % 1 === 0;
}
/**
 * Return the next power of two, or the input value if already a power of two
 */
function nextPowerOfTwo(value) {
    if (value <= 1)
        return 1;
    return Math.pow(2, Math.ceil(Math.log(value) / Math.LN2));
}
/**
 * Create an object by mapping all the values of an existing object while
 * preserving their keys.
 */
function mapObject(input, iterator, context) {
    const output = {};
    for (const key in input) {
        output[key] = iterator.call(this, input[key], key, input);
    }
    return output;
}
/**
 * Create an object by filtering out values of an existing object.
 */
function filterObject(input, iterator, context) {
    const output = {};
    for (const key in input) {
        if (iterator.call(this, input[key], key, input)) {
            output[key] = input[key];
        }
    }
    return output;
}
/**
 * Deeply compares two object literals.
 * @param a - first object literal to be compared
 * @param b - second object literal to be compared
 * @returns true if the two object literals are deeply equal, false otherwise
 */
function deepEqual$1(a, b) {
    if (Array.isArray(a)) {
        if (!Array.isArray(b) || a.length !== b.length)
            return false;
        for (let i = 0; i < a.length; i++) {
            if (!deepEqual$1(a[i], b[i]))
                return false;
        }
        return true;
    }
    if (typeof a === 'object' && a !== null && b !== null) {
        if (!(typeof b === 'object'))
            return false;
        const keys = Object.keys(a);
        if (keys.length !== Object.keys(b).length)
            return false;
        for (const key in a) {
            if (!deepEqual$1(a[key], b[key]))
                return false;
        }
        return true;
    }
    return a === b;
}
/**
 * Deeply clones two objects.
 */
function clone$1(input) {
    if (Array.isArray(input)) {
        return input.map(clone$1);
    }
    else if (typeof input === 'object' && input) {
        return mapObject(input, clone$1);
    }
    else {
        return input;
    }
}
/**
 * Check if two arrays have at least one common element.
 */
function arraysIntersect(a, b) {
    for (let l = 0; l < a.length; l++) {
        if (b.indexOf(a[l]) >= 0)
            return true;
    }
    return false;
}
/**
 * Print a warning message to the console and ensure duplicate warning messages
 * are not printed.
 */
const warnOnceHistory = {};
function warnOnce(message) {
    if (!warnOnceHistory[message]) {
        // console isn't defined in some WebWorkers, see #2558
        if (typeof console !== 'undefined')
            console.warn(message);
        warnOnceHistory[message] = true;
    }
}
/**
 * Indicates if the provided Points are in a counter clockwise (true) or clockwise (false) order
 *
 * @returns true for a counter clockwise set of points
 */
// https://bryceboe.com/2006/10/23/line-segment-intersection-algorithm/
function isCounterClockwise(a, b, c) {
    return (c.y - a.y) * (b.x - a.x) > (b.y - a.y) * (c.x - a.x);
}
/**
 * For two lines a and b in 2d space, defined by any two points along the lines,
 * find the intersection point, or return null if the lines are parallel
 *
 * @param a1 - First point on line a
 * @param a2 - Second point on line a
 * @param b1 - First point on line b
 * @param b2 - Second point on line b
 *
 * @returns the intersection point of the two lines or null if they are parallel
 */
function findLineIntersection(a1, a2, b1, b2) {
    const aDeltaY = a2.y - a1.y;
    const aDeltaX = a2.x - a1.x;
    const bDeltaY = b2.y - b1.y;
    const bDeltaX = b2.x - b1.x;
    const denominator = (bDeltaY * aDeltaX) - (bDeltaX * aDeltaY);
    if (denominator === 0) {
        // Lines are parallel
        return null;
    }
    const originDeltaY = a1.y - b1.y;
    const originDeltaX = a1.x - b1.x;
    const aInterpolation = (bDeltaX * originDeltaY - bDeltaY * originDeltaX) / denominator;
    // Find intersection by projecting out from origin of first segment
    return new Point$2(a1.x + (aInterpolation * aDeltaX), a1.y + (aInterpolation * aDeltaY));
}
/**
 * Converts spherical coordinates to cartesian coordinates.
 *
 * @param spherical - Spherical coordinates, in [radial, azimuthal, polar]
 * @returns cartesian coordinates in [x, y, z]
 */
function sphericalToCartesian([r, azimuthal, polar]) {
    // We abstract "north"/"up" (compass-wise) to be 0° when really this is 90° (π/2):
    // correct for that here
    azimuthal += 90;
    // Convert azimuthal and polar angles to radians
    azimuthal *= Math.PI / 180;
    polar *= Math.PI / 180;
    return {
        x: r * Math.cos(azimuthal) * Math.sin(polar),
        y: r * Math.sin(azimuthal) * Math.sin(polar),
        z: r * Math.cos(polar)
    };
}
/**
 *  Returns true if the when run in the web-worker context.
 *
 * @returns `true` if the when run in the web-worker context.
 */
function isWorker(self) {
    // @ts-ignore
    return typeof WorkerGlobalScope !== 'undefined' && typeof self !== 'undefined' && self instanceof WorkerGlobalScope;
}
/**
 * Parses data from 'Cache-Control' headers.
 *
 * @param cacheControl - Value of 'Cache-Control' header
 * @returns object containing parsed header info.
 */
function parseCacheControl(cacheControl) {
    // Taken from [Wreck](https://github.com/hapijs/wreck)
    const re = /(?:^|(?:\s*\,\s*))([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)(?:\=(?:([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)|(?:\"((?:[^"\\]|\\.)*)\")))?/g;
    const header = {};
    cacheControl.replace(re, ($0, $1, $2, $3) => {
        const value = $2 || $3;
        header[$1] = value ? value.toLowerCase() : true;
        return '';
    });
    if (header['max-age']) {
        const maxAge = parseInt(header['max-age'], 10);
        if (isNaN(maxAge))
            delete header['max-age'];
        else
            header['max-age'] = maxAge;
    }
    return header;
}
let _isSafari = null;
/**
 * Returns true when run in WebKit derived browsers.
 * This is used as a workaround for a memory leak in Safari caused by using Transferable objects to
 * transfer data between WebWorkers and the main thread.
 * https://github.com/mapbox/mapbox-gl-js/issues/8771
 *
 * This should be removed once the underlying Safari issue is fixed.
 *
 * @param scope - Since this function is used both on the main thread and WebWorker context,
 *      let the calling scope pass in the global scope object.
 * @returns `true` when run in WebKit derived browsers.
 */
function isSafari(scope) {
    if (_isSafari == null) {
        const userAgent = scope.navigator ? scope.navigator.userAgent : null;
        _isSafari = !!scope.safari ||
            !!(userAgent && (/\b(iPad|iPhone|iPod)\b/.test(userAgent) || (!!userAgent.match('Safari') && !userAgent.match('Chrome'))));
    }
    return _isSafari;
}
function isImageBitmap(image) {
    return typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap;
}
/**
 * Converts an ArrayBuffer to an ImageBitmap.
 *
 * Used mostly for testing purposes only, because mocking libs don't know how to work with ArrayBuffers, but work
 * perfectly fine with ImageBitmaps. Might also be used for environments (other than testing) not supporting
 * ArrayBuffers.
 *
 * @param data - Data to convert
 * @returns - A  promise resolved when the conversion is finished
 */
const arrayBufferToImageBitmap = (data) => __awaiter(void 0, void 0, void 0, function* () {
    if (data.byteLength === 0) {
        return createImageBitmap(new ImageData(1, 1));
    }
    const blob = new Blob([new Uint8Array(data)], { type: 'image/png' });
    try {
        return createImageBitmap(blob);
    }
    catch (e) {
        throw new Error(`Could not load image because of ${e.message}. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported.`);
    }
});
const transparentPngUrl = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVQYV2NgAAIAAAUAAarVyFEAAAAASUVORK5CYII=';
/**
 * Converts an ArrayBuffer to an HTMLImageElement.
 *
 * Used mostly for testing purposes only, because mocking libs don't know how to work with ArrayBuffers, but work
 * perfectly fine with ImageBitmaps. Might also be used for environments (other than testing) not supporting
 * ArrayBuffers.
 *
 * @param data - Data to convert
 * @returns - A promise resolved when the conversion is finished
 */
const arrayBufferToImage = (data) => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
            resolve(img);
            URL.revokeObjectURL(img.src);
            // prevent image dataURI memory leak in Safari;
            // but don't free the image immediately because it might be uploaded in the next frame
            // https://github.com/mapbox/mapbox-gl-js/issues/10226
            img.onload = null;
            window.requestAnimationFrame(() => { img.src = transparentPngUrl; });
        };
        img.onerror = () => reject(new Error('Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported.'));
        const blob = new Blob([new Uint8Array(data)], { type: 'image/png' });
        img.src = data.byteLength ? URL.createObjectURL(blob) : transparentPngUrl;
    });
};
/**
 * Computes the webcodecs VideoFrame API options to select a rectangle out of
 * an image and write it into the destination rectangle.
 *
 * Rect (x/y/width/height) select the overlapping rectangle from the source image
 * and layout (offset/stride) write that overlapping rectangle to the correct place
 * in the destination image.
 *
 * Offset is the byte offset in the dest image that the first pixel appears at
 * and stride is the number of bytes to the start of the next row:
 * ┌───────────┐
 * │  dest     │
 * │       ┌───┼───────┐
 * │offset→│▓▓▓│ source│
 * │       │▓▓▓│       │
 * │       └───┼───────┘
 * │stride ⇠╌╌╌│
 * │╌╌╌╌╌╌→    │
 * └───────────┘
 *
 * @param image - source image containing a width and height attribute
 * @param x - top-left x coordinate to read from the image
 * @param y - top-left y coordinate to read from the image
 * @param width - width of the rectangle to read from the image
 * @param height - height of the rectangle to read from the image
 * @returns the layout and rect options to pass into VideoFrame API
 */
function computeVideoFrameParameters(image, x, y, width, height) {
    const destRowOffset = Math.max(-x, 0) * 4;
    const firstSourceRow = Math.max(0, y);
    const firstDestRow = firstSourceRow - y;
    const offset = firstDestRow * width * 4 + destRowOffset;
    const stride = width * 4;
    const sourceLeft = Math.max(0, x);
    const sourceTop = Math.max(0, y);
    const sourceRight = Math.min(image.width, x + width);
    const sourceBottom = Math.min(image.height, y + height);
    return {
        rect: {
            x: sourceLeft,
            y: sourceTop,
            width: sourceRight - sourceLeft,
            height: sourceBottom - sourceTop
        },
        layout: [{ offset, stride }]
    };
}
/**
 * Reads pixels from an ImageBitmap/Image/canvas using webcodec VideoFrame API.
 *
 * @param data - image, imagebitmap, or canvas to parse
 * @param x - top-left x coordinate to read from the image
 * @param y - top-left y coordinate to read from the image
 * @param width - width of the rectangle to read from the image
 * @param height - height of the rectangle to read from the image
 * @returns a promise containing the parsed RGBA pixel values of the image, or the error if an error occurred
 */
function readImageUsingVideoFrame(image, x, y, width, height) {
    return __awaiter(this, void 0, void 0, function* () {
        if (typeof VideoFrame === 'undefined') {
            throw new Error('VideoFrame not supported');
        }
        const frame = new VideoFrame(image, { timestamp: 0 });
        try {
            const format = frame === null || frame === void 0 ? void 0 : frame.format;
            if (!format || !(format.startsWith('BGR') || format.startsWith('RGB'))) {
                throw new Error(`Unrecognized format ${format}`);
            }
            const swapBR = format.startsWith('BGR');
            const result = new Uint8ClampedArray(width * height * 4);
            yield frame.copyTo(result, computeVideoFrameParameters(image, x, y, width, height));
            if (swapBR) {
                for (let i = 0; i < result.length; i += 4) {
                    const tmp = result[i];
                    result[i] = result[i + 2];
                    result[i + 2] = tmp;
                }
            }
            return result;
        }
        finally {
            frame.close();
        }
    });
}
let offscreenCanvas;
let offscreenCanvasContext;
/**
 * Reads pixels from an ImageBitmap/Image/canvas using OffscreenCanvas
 *
 * @param data - image, imagebitmap, or canvas to parse
 * @param x - top-left x coordinate to read from the image
 * @param y - top-left y coordinate to read from the image
 * @param width - width of the rectangle to read from the image
 * @param height - height of the rectangle to read from the image
 * @returns a promise containing the parsed RGBA pixel values of the image, or the error if an error occurred
 */
function readImageDataUsingOffscreenCanvas(imgBitmap, x, y, width, height) {
    const origWidth = imgBitmap.width;
    const origHeight = imgBitmap.height;
    // Lazily initialize OffscreenCanvas
    if (!offscreenCanvas || !offscreenCanvasContext) {
        // Dem tiles are typically 256x256
        offscreenCanvas = new OffscreenCanvas(origWidth, origHeight);
        offscreenCanvasContext = offscreenCanvas.getContext('2d', { willReadFrequently: true });
    }
    offscreenCanvas.width = origWidth;
    offscreenCanvas.height = origHeight;
    offscreenCanvasContext.drawImage(imgBitmap, 0, 0, origWidth, origHeight);
    const imgData = offscreenCanvasContext.getImageData(x, y, width, height);
    offscreenCanvasContext.clearRect(0, 0, origWidth, origHeight);
    return imgData.data;
}
/**
 * Reads RGBA pixels from an preferring OffscreenCanvas, but falling back to VideoFrame if supported and
 * the browser is mangling OffscreenCanvas getImageData results.
 *
 * @param data - image, imagebitmap, or canvas to parse
 * @param x - top-left x coordinate to read from the image
 * @param y - top-left y coordinate to read from the image
 * @param width - width of the rectangle to read from the image
 * @param height - height of the rectangle to read from the image
 * @returns a promise containing the parsed RGBA pixel values of the image
 */
function getImageData(image, x, y, width, height) {
    return __awaiter(this, void 0, void 0, function* () {
        if (isOffscreenCanvasDistorted()) {
            try {
                return yield readImageUsingVideoFrame(image, x, y, width, height);
            }
            catch (e) {
                // fall back to OffscreenCanvas
            }
        }
        return readImageDataUsingOffscreenCanvas(image, x, y, width, height);
    });
}
/**
 * This method is used in order to register an event listener using a lambda function.
 * The return value will allow unsubscribing from the event, without the need to store the method reference.
 * @param target - The target
 * @param message - The message
 * @param listener - The listener
 * @param options - The options
 * @returns a subscription object that can be used to unsubscribe from the event
 */
function subscribe(target, message, listener, options) {
    target.addEventListener(message, listener, options);
    return {
        unsubscribe: () => {
            target.removeEventListener(message, listener, options);
        }
    };
}
/**
 * This method converts degrees to radians.
 * The return value is the radian value.
 * @param degrees - The number of degrees
 * @returns radians
 */
function degreesToRadians(degrees) {
    return degrees * Math.PI / 180;
}

/**
 * An error message to use when an operation is aborted
 */
const ABORT_ERROR = 'AbortError';
/**
 * Check if an error is an abort error
 * @param error - An error object
 * @returns - true if the error is an abort error
 */
function isAbortError(error) {
    return error.message === ABORT_ERROR;
}
/**
 * Use this when you need to create an abort error.
 * @returns An error object with the message "AbortError"
 */
function createAbortError() {
    return new Error(ABORT_ERROR);
}

const config = {
    MAX_PARALLEL_IMAGE_REQUESTS: 16,
    MAX_PARALLEL_IMAGE_REQUESTS_PER_FRAME: 8,
    MAX_TILE_CACHE_ZOOM_LEVELS: 5,
    REGISTERED_PROTOCOLS: {},
    WORKER_URL: ''
};

function getProtocol(url) {
    return config.REGISTERED_PROTOCOLS[url.substring(0, url.indexOf('://'))];
}
/**
 * Adds a custom load resource function that will be called when using a URL that starts with a custom url schema.
 * This will happen in the main thread, and workers might call it if they don't know how to handle the protocol.
 * The example below will be triggered for custom:// urls defined in the sources list in the style definitions.
 * The function passed will receive the request parameters and should return with the resulting resource,
 * for example a pbf vector tile, non-compressed, represented as ArrayBuffer.
 *
 * @param customProtocol - the protocol to hook, for example 'custom'
 * @param loadFn - the function to use when trying to fetch a tile specified by the customProtocol
 * @example
 * ```ts
 * // This will fetch a file using the fetch API (this is obviously a non interesting example...)
 * addProtocol('custom', async (params, abortController) => {
 *      const t = await fetch(`https://${params.url.split("://")[1]}`);
 *      if (t.status == 200) {
 *          const buffer = await t.arrayBuffer();
 *          return {data: buffer}
 *      } else {
 *          throw new Error(`Tile fetch error: ${t.statusText}`);
 *      }
 *  });
 * // the following is an example of a way to return an error when trying to load a tile
 * addProtocol('custom2', async (params, abortController) => {
 *      throw new Error('someErrorMessage'));
 * });
 * ```
 */
function addProtocol(customProtocol, loadFn) {
    config.REGISTERED_PROTOCOLS[customProtocol] = loadFn;
}
/**
 * Removes a previously added protocol in the main thread.
 *
 * @param customProtocol - the custom protocol to remove registration for
 * @example
 * ```ts
 * removeProtocol('custom');
 * ```
 */
function removeProtocol(customProtocol) {
    delete config.REGISTERED_PROTOCOLS[customProtocol];
}

/**
 * This is used to identify the global dispatcher id when sending a message from the worker without a target map id.
 */
const GLOBAL_DISPATCHER_ID = 'global-dispatcher';
/**
 * An error thrown when a HTTP request results in an error response.
 */
class AJAXError extends Error {
    /**
     * @param status - The response's HTTP status code.
     * @param statusText - The response's HTTP status text.
     * @param url - The request's URL.
     * @param body - The response's body.
     */
    constructor(status, statusText, url, body) {
        super(`AJAXError: ${statusText} (${status}): ${url}`);
        this.status = status;
        this.statusText = statusText;
        this.url = url;
        this.body = body;
    }
}
/**
 * Ensure that we're sending the correct referrer from blob URL worker bundles.
 * For files loaded from the local file system, `location.origin` will be set
 * to the string(!) "null" (Firefox), or "file://" (Chrome, Safari, Edge),
 * and we will set an empty referrer. Otherwise, we're using the document's URL.
 */
const getReferrer = () => isWorker(self) ?
    self.worker && self.worker.referrer :
    (window.location.protocol === 'blob:' ? window.parent : window).location.href;
/**
 * Determines whether a URL is a file:// URL. This is obviously the case if it begins
 * with file://. Relative URLs are also file:// URLs iff the original document was loaded
 * via a file:// URL.
 * @param url - The URL to check
 * @returns `true` if the URL is a file:// URL, `false` otherwise
 */
const isFileURL = url => /^file:/.test(url) || (/^file:/.test(getReferrer()) && !/^\w+:/.test(url));
function makeFetchRequest(requestParameters, abortController) {
    return __awaiter(this, void 0, void 0, function* () {
        const request = new Request(requestParameters.url, {
            method: requestParameters.method || 'GET',
            body: requestParameters.body,
            credentials: requestParameters.credentials,
            headers: requestParameters.headers,
            cache: requestParameters.cache,
            referrer: getReferrer(),
            signal: abortController.signal
        });
        // If the user has already set an Accept header, do not overwrite it here
        if (requestParameters.type === 'json' && !request.headers.has('Accept')) {
            request.headers.set('Accept', 'application/json');
        }
        const response = yield fetch(request);
        if (!response.ok) {
            const body = yield response.blob();
            throw new AJAXError(response.status, response.statusText, requestParameters.url, body);
        }
        let parsePromise;
        if ((requestParameters.type === 'arrayBuffer' || requestParameters.type === 'image')) {
            parsePromise = response.arrayBuffer();
        }
        else if (requestParameters.type === 'json') {
            parsePromise = response.json();
        }
        else {
            parsePromise = response.text();
        }
        const result = yield parsePromise;
        if (abortController.signal.aborted) {
            throw createAbortError();
        }
        return { data: result, cacheControl: response.headers.get('Cache-Control'), expires: response.headers.get('Expires') };
    });
}
function makeXMLHttpRequest(requestParameters, abortController) {
    return new Promise((resolve, reject) => {
        var _a;
        const xhr = new XMLHttpRequest();
        xhr.open(requestParameters.method || 'GET', requestParameters.url, true);
        if (requestParameters.type === 'arrayBuffer' || requestParameters.type === 'image') {
            xhr.responseType = 'arraybuffer';
        }
        for (const k in requestParameters.headers) {
            xhr.setRequestHeader(k, requestParameters.headers[k]);
        }
        if (requestParameters.type === 'json') {
            xhr.responseType = 'text';
            // Do not overwrite the user-provided Accept header
            if (!((_a = requestParameters.headers) === null || _a === void 0 ? void 0 : _a.Accept)) {
                xhr.setRequestHeader('Accept', 'application/json');
            }
        }
        xhr.withCredentials = requestParameters.credentials === 'include';
        xhr.onerror = () => {
            reject(new Error(xhr.statusText));
        };
        xhr.onload = () => {
            if (abortController.signal.aborted) {
                return;
            }
            if (((xhr.status >= 200 && xhr.status < 300) || xhr.status === 0) && xhr.response !== null) {
                let data = xhr.response;
                if (requestParameters.type === 'json') {
                    // We're manually parsing JSON here to get better error messages.
                    try {
                        data = JSON.parse(xhr.response);
                    }
                    catch (err) {
                        reject(err);
                        return;
                    }
                }
                resolve({ data, cacheControl: xhr.getResponseHeader('Cache-Control'), expires: xhr.getResponseHeader('Expires') });
            }
            else {
                const body = new Blob([xhr.response], { type: xhr.getResponseHeader('Content-Type') });
                reject(new AJAXError(xhr.status, xhr.statusText, requestParameters.url, body));
            }
        };
        abortController.signal.addEventListener('abort', () => {
            xhr.abort();
            reject(createAbortError());
        });
        xhr.send(requestParameters.body);
    });
}
/**
 * We're trying to use the Fetch API if possible. However, requests for resources with the file:// URI scheme don't work with the Fetch API.
 * In this case we unconditionally use XHR on the current thread since referrers don't matter.
 * This method can also use the registered method if `addProtocol` was called.
 * @param requestParameters - The request parameters
 * @param abortController - The abort controller allowing to cancel the request
 * @returns a promise resolving to the response, including cache control and expiry data
 */
const makeRequest = function (requestParameters, abortController) {
    if (/:\/\//.test(requestParameters.url) && !(/^https?:|^file:/.test(requestParameters.url))) {
        const protocolLoadFn = getProtocol(requestParameters.url);
        if (protocolLoadFn) {
            return protocolLoadFn(requestParameters, abortController);
        }
        if (isWorker(self) && self.worker && self.worker.actor) {
            return self.worker.actor.sendAsync({ type: "GR" /* MessageType.getResource */, data: requestParameters, targetMapId: GLOBAL_DISPATCHER_ID }, abortController);
        }
    }
    if (!isFileURL(requestParameters.url)) {
        if (fetch && Request && AbortController && Object.prototype.hasOwnProperty.call(Request.prototype, 'signal')) {
            return makeFetchRequest(requestParameters, abortController);
        }
        if (isWorker(self) && self.worker && self.worker.actor) {
            return self.worker.actor.sendAsync({ type: "GR" /* MessageType.getResource */, data: requestParameters, mustQueue: true, targetMapId: GLOBAL_DISPATCHER_ID }, abortController);
        }
    }
    return makeXMLHttpRequest(requestParameters, abortController);
};
const getJSON = (requestParameters, abortController) => {
    return makeRequest(extend(requestParameters, { type: 'json' }), abortController);
};
const getArrayBuffer = (requestParameters, abortController) => {
    return makeRequest(extend(requestParameters, { type: 'arrayBuffer' }), abortController);
};
function sameOrigin(inComingUrl) {
    // A relative URL "/foo" or "./foo" will throw exception in URL's ctor,
    // try-catch is expansive so just use a heuristic check to avoid it
    // also check data URL
    if (!inComingUrl ||
        inComingUrl.indexOf('://') <= 0 || // relative URL
        inComingUrl.indexOf('data:image/') === 0 || // data image URL
        inComingUrl.indexOf('blob:') === 0) { // blob
        return true;
    }
    const urlObj = new URL(inComingUrl);
    const locationObj = window.location;
    return urlObj.protocol === locationObj.protocol && urlObj.host === locationObj.host;
}
const getVideo = (urls) => {
    const video = window.document.createElement('video');
    video.muted = true;
    return new Promise((resolve) => {
        video.onloadstart = () => {
            resolve(video);
        };
        for (const url of urls) {
            const s = window.document.createElement('source');
            if (!sameOrigin(url)) {
                video.crossOrigin = 'Anonymous';
            }
            s.src = url;
            video.appendChild(s);
        }
    });
};

function _addEventListener(type, listener, listenerList) {
    const listenerExists = listenerList[type] && listenerList[type].indexOf(listener) !== -1;
    if (!listenerExists) {
        listenerList[type] = listenerList[type] || [];
        listenerList[type].push(listener);
    }
}
function _removeEventListener(type, listener, listenerList) {
    if (listenerList && listenerList[type]) {
        const index = listenerList[type].indexOf(listener);
        if (index !== -1) {
            listenerList[type].splice(index, 1);
        }
    }
}
/**
 * The event class
 */
class Event {
    constructor(type, data = {}) {
        extend(this, data);
        this.type = type;
    }
}
/**
 * An error event
 */
class ErrorEvent extends Event {
    constructor(error, data = {}) {
        super('error', extend({ error }, data));
    }
}
/**
 * Methods mixed in to other classes for event capabilities.
 *
 * @group Event Related
 */
class Evented {
    /**
     * Adds a listener to a specified event type.
     *
     * @param type - The event type to add a listen for.
     * @param listener - The function to be called when the event is fired.
     * The listener function is called with the data object passed to `fire`,
     * extended with `target` and `type` properties.
     */
    on(type, listener) {
        this._listeners = this._listeners || {};
        _addEventListener(type, listener, this._listeners);
        return this;
    }
    /**
     * Removes a previously registered event listener.
     *
     * @param type - The event type to remove listeners for.
     * @param listener - The listener function to remove.
     */
    off(type, listener) {
        _removeEventListener(type, listener, this._listeners);
        _removeEventListener(type, listener, this._oneTimeListeners);
        return this;
    }
    /**
     * Adds a listener that will be called only once to a specified event type.
     *
     * The listener will be called first time the event fires after the listener is registered.
     *
     * @param type - The event type to listen for.
     * @param listener - The function to be called when the event is fired the first time.
     * @returns `this` or a promise if a listener is not provided
     */
    once(type, listener) {
        if (!listener) {
            return new Promise((resolve) => this.once(type, resolve));
        }
        this._oneTimeListeners = this._oneTimeListeners || {};
        _addEventListener(type, listener, this._oneTimeListeners);
        return this;
    }
    fire(event, properties) {
        // Compatibility with (type: string, properties: Object) signature from previous versions.
        // See https://github.com/mapbox/mapbox-gl-js/issues/6522,
        //     https://github.com/mapbox/mapbox-gl-draw/issues/766
        if (typeof event === 'string') {
            event = new Event(event, properties || {});
        }
        const type = event.type;
        if (this.listens(type)) {
            event.target = this;
            // make sure adding or removing listeners inside other listeners won't cause an infinite loop
            const listeners = this._listeners && this._listeners[type] ? this._listeners[type].slice() : [];
            for (const listener of listeners) {
                listener.call(this, event);
            }
            const oneTimeListeners = this._oneTimeListeners && this._oneTimeListeners[type] ? this._oneTimeListeners[type].slice() : [];
            for (const listener of oneTimeListeners) {
                _removeEventListener(type, listener, this._oneTimeListeners);
                listener.call(this, event);
            }
            const parent = this._eventedParent;
            if (parent) {
                extend(event, typeof this._eventedParentData === 'function' ? this._eventedParentData() : this._eventedParentData);
                parent.fire(event);
            }
            // To ensure that no error events are dropped, print them to the
            // console if they have no listeners.
        }
        else if (event instanceof ErrorEvent) {
            console.error(event.error);
        }
        return this;
    }
    /**
     * Returns a true if this instance of Evented or any forwardeed instances of Evented have a listener for the specified type.
     *
     * @param type - The event type
     * @returns `true` if there is at least one registered listener for specified event type, `false` otherwise
     */
    listens(type) {
        return ((this._listeners && this._listeners[type] && this._listeners[type].length > 0) ||
            (this._oneTimeListeners && this._oneTimeListeners[type] && this._oneTimeListeners[type].length > 0) ||
            (this._eventedParent && this._eventedParent.listens(type)));
    }
    /**
     * Bubble all events fired by this instance of Evented to this parent instance of Evented.
     */
    setEventedParent(parent, data) {
        this._eventedParent = parent;
        this._eventedParentData = data;
        return this;
    }
}

var $version = 8;
var $root = {
	version: {
		required: true,
		type: "enum",
		values: [
			8
		]
	},
	name: {
		type: "string"
	},
	metadata: {
		type: "*"
	},
	center: {
		type: "array",
		value: "number"
	},
	zoom: {
		type: "number"
	},
	bearing: {
		type: "number",
		"default": 0,
		period: 360,
		units: "degrees"
	},
	pitch: {
		type: "number",
		"default": 0,
		units: "degrees"
	},
	light: {
		type: "light"
	},
	sky: {
		type: "sky"
	},
	projection: {
		type: "projection"
	},
	terrain: {
		type: "terrain"
	},
	sources: {
		required: true,
		type: "sources"
	},
	sprite: {
		type: "sprite"
	},
	glyphs: {
		type: "string"
	},
	transition: {
		type: "transition"
	},
	layers: {
		required: true,
		type: "array",
		value: "layer"
	}
};
var sources = {
	"*": {
		type: "source"
	}
};
var source = [
	"source_vector",
	"source_raster",
	"source_raster_dem",
	"source_geojson",
	"source_video",
	"source_image"
];
var source_vector = {
	type: {
		required: true,
		type: "enum",
		values: {
			vector: {
			}
		}
	},
	url: {
		type: "string"
	},
	tiles: {
		type: "array",
		value: "string"
	},
	bounds: {
		type: "array",
		value: "number",
		length: 4,
		"default": [
			-180,
			-85.051129,
			180,
			85.051129
		]
	},
	scheme: {
		type: "enum",
		values: {
			xyz: {
			},
			tms: {
			}
		},
		"default": "xyz"
	},
	minzoom: {
		type: "number",
		"default": 0
	},
	maxzoom: {
		type: "number",
		"default": 22
	},
	attribution: {
		type: "string"
	},
	promoteId: {
		type: "promoteId"
	},
	volatile: {
		type: "boolean",
		"default": false
	},
	"*": {
		type: "*"
	}
};
var source_raster = {
	type: {
		required: true,
		type: "enum",
		values: {
			raster: {
			}
		}
	},
	url: {
		type: "string"
	},
	tiles: {
		type: "array",
		value: "string"
	},
	bounds: {
		type: "array",
		value: "number",
		length: 4,
		"default": [
			-180,
			-85.051129,
			180,
			85.051129
		]
	},
	minzoom: {
		type: "number",
		"default": 0
	},
	maxzoom: {
		type: "number",
		"default": 22
	},
	tileSize: {
		type: "number",
		"default": 512,
		units: "pixels"
	},
	scheme: {
		type: "enum",
		values: {
			xyz: {
			},
			tms: {
			}
		},
		"default": "xyz"
	},
	attribution: {
		type: "string"
	},
	volatile: {
		type: "boolean",
		"default": false
	},
	"*": {
		type: "*"
	}
};
var source_raster_dem = {
	type: {
		required: true,
		type: "enum",
		values: {
			"raster-dem": {
			}
		}
	},
	url: {
		type: "string"
	},
	tiles: {
		type: "array",
		value: "string"
	},
	bounds: {
		type: "array",
		value: "number",
		length: 4,
		"default": [
			-180,
			-85.051129,
			180,
			85.051129
		]
	},
	minzoom: {
		type: "number",
		"default": 0
	},
	maxzoom: {
		type: "number",
		"default": 22
	},
	tileSize: {
		type: "number",
		"default": 512,
		units: "pixels"
	},
	attribution: {
		type: "string"
	},
	encoding: {
		type: "enum",
		values: {
			terrarium: {
			},
			mapbox: {
			},
			custom: {
			}
		},
		"default": "mapbox"
	},
	redFactor: {
		type: "number",
		"default": 1
	},
	blueFactor: {
		type: "number",
		"default": 1
	},
	greenFactor: {
		type: "number",
		"default": 1
	},
	baseShift: {
		type: "number",
		"default": 0
	},
	volatile: {
		type: "boolean",
		"default": false
	},
	"*": {
		type: "*"
	}
};
var source_geojson = {
	type: {
		required: true,
		type: "enum",
		values: {
			geojson: {
			}
		}
	},
	data: {
		required: true,
		type: "*"
	},
	maxzoom: {
		type: "number",
		"default": 18
	},
	attribution: {
		type: "string"
	},
	buffer: {
		type: "number",
		"default": 128,
		maximum: 512,
		minimum: 0
	},
	filter: {
		type: "*"
	},
	tolerance: {
		type: "number",
		"default": 0.375
	},
	cluster: {
		type: "boolean",
		"default": false
	},
	clusterRadius: {
		type: "number",
		"default": 50,
		minimum: 0
	},
	clusterMaxZoom: {
		type: "number"
	},
	clusterMinPoints: {
		type: "number"
	},
	clusterProperties: {
		type: "*"
	},
	lineMetrics: {
		type: "boolean",
		"default": false
	},
	generateId: {
		type: "boolean",
		"default": false
	},
	promoteId: {
		type: "promoteId"
	}
};
var source_video = {
	type: {
		required: true,
		type: "enum",
		values: {
			video: {
			}
		}
	},
	urls: {
		required: true,
		type: "array",
		value: "string"
	},
	coordinates: {
		required: true,
		type: "array",
		length: 4,
		value: {
			type: "array",
			length: 2,
			value: "number"
		}
	}
};
var source_image = {
	type: {
		required: true,
		type: "enum",
		values: {
			image: {
			}
		}
	},
	url: {
		required: true,
		type: "string"
	},
	coordinates: {
		required: true,
		type: "array",
		length: 4,
		value: {
			type: "array",
			length: 2,
			value: "number"
		}
	}
};
var layer = {
	id: {
		type: "string",
		required: true
	},
	type: {
		type: "enum",
		values: {
			fill: {
			},
			line: {
			},
			symbol: {
			},
			circle: {
			},
			heatmap: {
			},
			"fill-extrusion": {
			},
			raster: {
			},
			hillshade: {
			},
			background: {
			}
		},
		required: true
	},
	metadata: {
		type: "*"
	},
	source: {
		type: "string"
	},
	"source-layer": {
		type: "string"
	},
	minzoom: {
		type: "number",
		minimum: 0,
		maximum: 24
	},
	maxzoom: {
		type: "number",
		minimum: 0,
		maximum: 24
	},
	filter: {
		type: "filter"
	},
	layout: {
		type: "layout"
	},
	paint: {
		type: "paint"
	}
};
var layout$7 = [
	"layout_fill",
	"layout_line",
	"layout_circle",
	"layout_heatmap",
	"layout_fill-extrusion",
	"layout_symbol",
	"layout_raster",
	"layout_hillshade",
	"layout_background"
];
var layout_background = {
	visibility: {
		type: "enum",
		values: {
			visible: {
			},
			none: {
			}
		},
		"default": "visible",
		"property-type": "constant"
	}
};
var layout_fill = {
	"fill-sort-key": {
		type: "number",
		expression: {
			interpolated: false,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	visibility: {
		type: "enum",
		values: {
			visible: {
			},
			none: {
			}
		},
		"default": "visible",
		"property-type": "constant"
	}
};
var layout_circle = {
	"circle-sort-key": {
		type: "number",
		expression: {
			interpolated: false,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	visibility: {
		type: "enum",
		values: {
			visible: {
			},
			none: {
			}
		},
		"default": "visible",
		"property-type": "constant"
	}
};
var layout_heatmap = {
	visibility: {
		type: "enum",
		values: {
			visible: {
			},
			none: {
			}
		},
		"default": "visible",
		"property-type": "constant"
	}
};
var layout_line = {
	"line-cap": {
		type: "enum",
		values: {
			butt: {
			},
			round: {
			},
			square: {
			}
		},
		"default": "butt",
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"line-join": {
		type: "enum",
		values: {
			bevel: {
			},
			round: {
			},
			miter: {
			}
		},
		"default": "miter",
		expression: {
			interpolated: false,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	"line-miter-limit": {
		type: "number",
		"default": 2,
		requires: [
			{
				"line-join": "miter"
			}
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"line-round-limit": {
		type: "number",
		"default": 1.05,
		requires: [
			{
				"line-join": "round"
			}
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"line-sort-key": {
		type: "number",
		expression: {
			interpolated: false,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	visibility: {
		type: "enum",
		values: {
			visible: {
			},
			none: {
			}
		},
		"default": "visible",
		"property-type": "constant"
	}
};
var layout_symbol = {
	"symbol-placement": {
		type: "enum",
		values: {
			point: {
			},
			line: {
			},
			"line-center": {
			}
		},
		"default": "point",
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"symbol-spacing": {
		type: "number",
		"default": 250,
		minimum: 1,
		units: "pixels",
		requires: [
			{
				"symbol-placement": "line"
			}
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"symbol-avoid-edges": {
		type: "boolean",
		"default": false,
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"symbol-sort-key": {
		type: "number",
		expression: {
			interpolated: false,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	"symbol-z-order": {
		type: "enum",
		values: {
			auto: {
			},
			"viewport-y": {
			},
			source: {
			}
		},
		"default": "auto",
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"icon-allow-overlap": {
		type: "boolean",
		"default": false,
		requires: [
			"icon-image",
			{
				"!": "icon-overlap"
			}
		],
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"icon-overlap": {
		type: "enum",
		values: {
			never: {
			},
			always: {
			},
			cooperative: {
			}
		},
		requires: [
			"icon-image"
		],
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"icon-ignore-placement": {
		type: "boolean",
		"default": false,
		requires: [
			"icon-image"
		],
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"icon-optional": {
		type: "boolean",
		"default": false,
		requires: [
			"icon-image",
			"text-field"
		],
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"icon-rotation-alignment": {
		type: "enum",
		values: {
			map: {
			},
			viewport: {
			},
			auto: {
			}
		},
		"default": "auto",
		requires: [
			"icon-image"
		],
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"icon-size": {
		type: "number",
		"default": 1,
		minimum: 0,
		units: "factor of the original icon size",
		requires: [
			"icon-image"
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	"icon-text-fit": {
		type: "enum",
		values: {
			none: {
			},
			width: {
			},
			height: {
			},
			both: {
			}
		},
		"default": "none",
		requires: [
			"icon-image",
			"text-field"
		],
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"icon-text-fit-padding": {
		type: "array",
		value: "number",
		length: 4,
		"default": [
			0,
			0,
			0,
			0
		],
		units: "pixels",
		requires: [
			"icon-image",
			"text-field",
			{
				"icon-text-fit": [
					"both",
					"width",
					"height"
				]
			}
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"icon-image": {
		type: "resolvedImage",
		tokens: true,
		expression: {
			interpolated: false,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	"icon-rotate": {
		type: "number",
		"default": 0,
		period: 360,
		units: "degrees",
		requires: [
			"icon-image"
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	"icon-padding": {
		type: "padding",
		"default": [
			2
		],
		units: "pixels",
		requires: [
			"icon-image"
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	"icon-keep-upright": {
		type: "boolean",
		"default": false,
		requires: [
			"icon-image",
			{
				"icon-rotation-alignment": "map"
			},
			{
				"symbol-placement": [
					"line",
					"line-center"
				]
			}
		],
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"icon-offset": {
		type: "array",
		value: "number",
		length: 2,
		"default": [
			0,
			0
		],
		requires: [
			"icon-image"
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	"icon-anchor": {
		type: "enum",
		values: {
			center: {
			},
			left: {
			},
			right: {
			},
			top: {
			},
			bottom: {
			},
			"top-left": {
			},
			"top-right": {
			},
			"bottom-left": {
			},
			"bottom-right": {
			}
		},
		"default": "center",
		requires: [
			"icon-image"
		],
		expression: {
			interpolated: false,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	"icon-pitch-alignment": {
		type: "enum",
		values: {
			map: {
			},
			viewport: {
			},
			auto: {
			}
		},
		"default": "auto",
		requires: [
			"icon-image"
		],
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"text-pitch-alignment": {
		type: "enum",
		values: {
			map: {
			},
			viewport: {
			},
			auto: {
			}
		},
		"default": "auto",
		requires: [
			"text-field"
		],
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"text-rotation-alignment": {
		type: "enum",
		values: {
			map: {
			},
			viewport: {
			},
			"viewport-glyph": {
			},
			auto: {
			}
		},
		"default": "auto",
		requires: [
			"text-field"
		],
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"text-field": {
		type: "formatted",
		"default": "",
		tokens: true,
		expression: {
			interpolated: false,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	"text-font": {
		type: "array",
		value: "string",
		"default": [
			"Open Sans Regular",
			"Arial Unicode MS Regular"
		],
		requires: [
			"text-field"
		],
		expression: {
			interpolated: false,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	"text-size": {
		type: "number",
		"default": 16,
		minimum: 0,
		units: "pixels",
		requires: [
			"text-field"
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	"text-max-width": {
		type: "number",
		"default": 10,
		minimum: 0,
		units: "ems",
		requires: [
			"text-field"
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	"text-line-height": {
		type: "number",
		"default": 1.2,
		units: "ems",
		requires: [
			"text-field"
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"text-letter-spacing": {
		type: "number",
		"default": 0,
		units: "ems",
		requires: [
			"text-field"
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	"text-justify": {
		type: "enum",
		values: {
			auto: {
			},
			left: {
			},
			center: {
			},
			right: {
			}
		},
		"default": "center",
		requires: [
			"text-field"
		],
		expression: {
			interpolated: false,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	"text-radial-offset": {
		type: "number",
		units: "ems",
		"default": 0,
		requires: [
			"text-field"
		],
		"property-type": "data-driven",
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature"
			]
		}
	},
	"text-variable-anchor": {
		type: "array",
		value: "enum",
		values: {
			center: {
			},
			left: {
			},
			right: {
			},
			top: {
			},
			bottom: {
			},
			"top-left": {
			},
			"top-right": {
			},
			"bottom-left": {
			},
			"bottom-right": {
			}
		},
		requires: [
			"text-field",
			{
				"symbol-placement": [
					"point"
				]
			}
		],
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"text-variable-anchor-offset": {
		type: "variableAnchorOffsetCollection",
		requires: [
			"text-field",
			{
				"symbol-placement": [
					"point"
				]
			}
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	"text-anchor": {
		type: "enum",
		values: {
			center: {
			},
			left: {
			},
			right: {
			},
			top: {
			},
			bottom: {
			},
			"top-left": {
			},
			"top-right": {
			},
			"bottom-left": {
			},
			"bottom-right": {
			}
		},
		"default": "center",
		requires: [
			"text-field",
			{
				"!": "text-variable-anchor"
			}
		],
		expression: {
			interpolated: false,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	"text-max-angle": {
		type: "number",
		"default": 45,
		units: "degrees",
		requires: [
			"text-field",
			{
				"symbol-placement": [
					"line",
					"line-center"
				]
			}
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"text-writing-mode": {
		type: "array",
		value: "enum",
		values: {
			horizontal: {
			},
			vertical: {
			}
		},
		requires: [
			"text-field",
			{
				"symbol-placement": [
					"point"
				]
			}
		],
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"text-rotate": {
		type: "number",
		"default": 0,
		period: 360,
		units: "degrees",
		requires: [
			"text-field"
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	"text-padding": {
		type: "number",
		"default": 2,
		minimum: 0,
		units: "pixels",
		requires: [
			"text-field"
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"text-keep-upright": {
		type: "boolean",
		"default": true,
		requires: [
			"text-field",
			{
				"text-rotation-alignment": "map"
			},
			{
				"symbol-placement": [
					"line",
					"line-center"
				]
			}
		],
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"text-transform": {
		type: "enum",
		values: {
			none: {
			},
			uppercase: {
			},
			lowercase: {
			}
		},
		"default": "none",
		requires: [
			"text-field"
		],
		expression: {
			interpolated: false,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	"text-offset": {
		type: "array",
		value: "number",
		units: "ems",
		length: 2,
		"default": [
			0,
			0
		],
		requires: [
			"text-field",
			{
				"!": "text-radial-offset"
			}
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	"text-allow-overlap": {
		type: "boolean",
		"default": false,
		requires: [
			"text-field",
			{
				"!": "text-overlap"
			}
		],
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"text-overlap": {
		type: "enum",
		values: {
			never: {
			},
			always: {
			},
			cooperative: {
			}
		},
		requires: [
			"text-field"
		],
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"text-ignore-placement": {
		type: "boolean",
		"default": false,
		requires: [
			"text-field"
		],
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"text-optional": {
		type: "boolean",
		"default": false,
		requires: [
			"text-field",
			"icon-image"
		],
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	visibility: {
		type: "enum",
		values: {
			visible: {
			},
			none: {
			}
		},
		"default": "visible",
		"property-type": "constant"
	}
};
var layout_raster = {
	visibility: {
		type: "enum",
		values: {
			visible: {
			},
			none: {
			}
		},
		"default": "visible",
		"property-type": "constant"
	}
};
var layout_hillshade = {
	visibility: {
		type: "enum",
		values: {
			visible: {
			},
			none: {
			}
		},
		"default": "visible",
		"property-type": "constant"
	}
};
var filter = {
	type: "array",
	value: "*"
};
var filter_operator = {
	type: "enum",
	values: {
		"==": {
		},
		"!=": {
		},
		">": {
		},
		">=": {
		},
		"<": {
		},
		"<=": {
		},
		"in": {
		},
		"!in": {
		},
		all: {
		},
		any: {
		},
		none: {
		},
		has: {
		},
		"!has": {
		}
	}
};
var geometry_type = {
	type: "enum",
	values: {
		Point: {
		},
		LineString: {
		},
		Polygon: {
		}
	}
};
var function_stop = {
	type: "array",
	minimum: 0,
	maximum: 24,
	value: [
		"number",
		"color"
	],
	length: 2
};
var expression$1 = {
	type: "array",
	value: "*",
	minimum: 1
};
var light = {
	anchor: {
		type: "enum",
		"default": "viewport",
		values: {
			map: {
			},
			viewport: {
			}
		},
		"property-type": "data-constant",
		transition: false,
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		}
	},
	position: {
		type: "array",
		"default": [
			1.15,
			210,
			30
		],
		length: 3,
		value: "number",
		"property-type": "data-constant",
		transition: true,
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		}
	},
	color: {
		type: "color",
		"property-type": "data-constant",
		"default": "#ffffff",
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		transition: true
	},
	intensity: {
		type: "number",
		"property-type": "data-constant",
		"default": 0.5,
		minimum: 0,
		maximum: 1,
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		transition: true
	}
};
var sky = {
	"sky-color": {
		type: "color",
		"property-type": "data-constant",
		"default": "#88C6FC",
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		transition: true
	},
	"horizon-color": {
		type: "color",
		"property-type": "data-constant",
		"default": "#ffffff",
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		transition: true
	},
	"fog-color": {
		type: "color",
		"property-type": "data-constant",
		"default": "#ffffff",
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		transition: true
	},
	"fog-ground-blend": {
		type: "number",
		"property-type": "data-constant",
		"default": 0.5,
		minimum: 0,
		maximum: 1,
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		transition: true
	},
	"horizon-fog-blend": {
		type: "number",
		"property-type": "data-constant",
		"default": 0.8,
		minimum: 0,
		maximum: 1,
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		transition: true
	},
	"sky-horizon-blend": {
		type: "number",
		"property-type": "data-constant",
		"default": 0.8,
		minimum: 0,
		maximum: 1,
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		transition: true
	},
	"atmosphere-blend": {
		type: "number",
		"property-type": "data-constant",
		"default": 0.8,
		minimum: 0,
		maximum: 1,
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		transition: true
	}
};
var terrain = {
	source: {
		type: "string",
		required: true
	},
	exaggeration: {
		type: "number",
		minimum: 0,
		"default": 1
	}
};
var projection = {
	type: {
		type: "enum",
		"default": "mercator",
		values: {
			mercator: {
			},
			globe: {
			}
		}
	}
};
var paint$9 = [
	"paint_fill",
	"paint_line",
	"paint_circle",
	"paint_heatmap",
	"paint_fill-extrusion",
	"paint_symbol",
	"paint_raster",
	"paint_hillshade",
	"paint_background"
];
var paint_fill = {
	"fill-antialias": {
		type: "boolean",
		"default": true,
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"fill-opacity": {
		type: "number",
		"default": 1,
		minimum: 0,
		maximum: 1,
		transition: true,
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"fill-color": {
		type: "color",
		"default": "#000000",
		transition: true,
		requires: [
			{
				"!": "fill-pattern"
			}
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"fill-outline-color": {
		type: "color",
		transition: true,
		requires: [
			{
				"!": "fill-pattern"
			},
			{
				"fill-antialias": true
			}
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"fill-translate": {
		type: "array",
		value: "number",
		length: 2,
		"default": [
			0,
			0
		],
		transition: true,
		units: "pixels",
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"fill-translate-anchor": {
		type: "enum",
		values: {
			map: {
			},
			viewport: {
			}
		},
		"default": "map",
		requires: [
			"fill-translate"
		],
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"fill-pattern": {
		type: "resolvedImage",
		transition: true,
		expression: {
			interpolated: false,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "cross-faded-data-driven"
	}
};
var paint_line = {
	"line-opacity": {
		type: "number",
		"default": 1,
		minimum: 0,
		maximum: 1,
		transition: true,
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"line-color": {
		type: "color",
		"default": "#000000",
		transition: true,
		requires: [
			{
				"!": "line-pattern"
			}
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"line-translate": {
		type: "array",
		value: "number",
		length: 2,
		"default": [
			0,
			0
		],
		transition: true,
		units: "pixels",
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"line-translate-anchor": {
		type: "enum",
		values: {
			map: {
			},
			viewport: {
			}
		},
		"default": "map",
		requires: [
			"line-translate"
		],
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"line-width": {
		type: "number",
		"default": 1,
		minimum: 0,
		transition: true,
		units: "pixels",
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"line-gap-width": {
		type: "number",
		"default": 0,
		minimum: 0,
		transition: true,
		units: "pixels",
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"line-offset": {
		type: "number",
		"default": 0,
		transition: true,
		units: "pixels",
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"line-blur": {
		type: "number",
		"default": 0,
		minimum: 0,
		transition: true,
		units: "pixels",
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"line-dasharray": {
		type: "array",
		value: "number",
		minimum: 0,
		transition: true,
		units: "line widths",
		requires: [
			{
				"!": "line-pattern"
			}
		],
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "cross-faded"
	},
	"line-pattern": {
		type: "resolvedImage",
		transition: true,
		expression: {
			interpolated: false,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "cross-faded-data-driven"
	},
	"line-gradient": {
		type: "color",
		transition: false,
		requires: [
			{
				"!": "line-dasharray"
			},
			{
				"!": "line-pattern"
			},
			{
				source: "geojson",
				has: {
					lineMetrics: true
				}
			}
		],
		expression: {
			interpolated: true,
			parameters: [
				"line-progress"
			]
		},
		"property-type": "color-ramp"
	}
};
var paint_circle = {
	"circle-radius": {
		type: "number",
		"default": 5,
		minimum: 0,
		transition: true,
		units: "pixels",
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"circle-color": {
		type: "color",
		"default": "#000000",
		transition: true,
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"circle-blur": {
		type: "number",
		"default": 0,
		transition: true,
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"circle-opacity": {
		type: "number",
		"default": 1,
		minimum: 0,
		maximum: 1,
		transition: true,
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"circle-translate": {
		type: "array",
		value: "number",
		length: 2,
		"default": [
			0,
			0
		],
		transition: true,
		units: "pixels",
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"circle-translate-anchor": {
		type: "enum",
		values: {
			map: {
			},
			viewport: {
			}
		},
		"default": "map",
		requires: [
			"circle-translate"
		],
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"circle-pitch-scale": {
		type: "enum",
		values: {
			map: {
			},
			viewport: {
			}
		},
		"default": "map",
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"circle-pitch-alignment": {
		type: "enum",
		values: {
			map: {
			},
			viewport: {
			}
		},
		"default": "viewport",
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"circle-stroke-width": {
		type: "number",
		"default": 0,
		minimum: 0,
		transition: true,
		units: "pixels",
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"circle-stroke-color": {
		type: "color",
		"default": "#000000",
		transition: true,
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"circle-stroke-opacity": {
		type: "number",
		"default": 1,
		minimum: 0,
		maximum: 1,
		transition: true,
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	}
};
var paint_heatmap = {
	"heatmap-radius": {
		type: "number",
		"default": 30,
		minimum: 1,
		transition: true,
		units: "pixels",
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"heatmap-weight": {
		type: "number",
		"default": 1,
		minimum: 0,
		transition: false,
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"heatmap-intensity": {
		type: "number",
		"default": 1,
		minimum: 0,
		transition: true,
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"heatmap-color": {
		type: "color",
		"default": [
			"interpolate",
			[
				"linear"
			],
			[
				"heatmap-density"
			],
			0,
			"rgba(0, 0, 255, 0)",
			0.1,
			"royalblue",
			0.3,
			"cyan",
			0.5,
			"lime",
			0.7,
			"yellow",
			1,
			"red"
		],
		transition: false,
		expression: {
			interpolated: true,
			parameters: [
				"heatmap-density"
			]
		},
		"property-type": "color-ramp"
	},
	"heatmap-opacity": {
		type: "number",
		"default": 1,
		minimum: 0,
		maximum: 1,
		transition: true,
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	}
};
var paint_symbol = {
	"icon-opacity": {
		type: "number",
		"default": 1,
		minimum: 0,
		maximum: 1,
		transition: true,
		requires: [
			"icon-image"
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"icon-color": {
		type: "color",
		"default": "#000000",
		transition: true,
		requires: [
			"icon-image"
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"icon-halo-color": {
		type: "color",
		"default": "rgba(0, 0, 0, 0)",
		transition: true,
		requires: [
			"icon-image"
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"icon-halo-width": {
		type: "number",
		"default": 0,
		minimum: 0,
		transition: true,
		units: "pixels",
		requires: [
			"icon-image"
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"icon-halo-blur": {
		type: "number",
		"default": 0,
		minimum: 0,
		transition: true,
		units: "pixels",
		requires: [
			"icon-image"
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"icon-translate": {
		type: "array",
		value: "number",
		length: 2,
		"default": [
			0,
			0
		],
		transition: true,
		units: "pixels",
		requires: [
			"icon-image"
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"icon-translate-anchor": {
		type: "enum",
		values: {
			map: {
			},
			viewport: {
			}
		},
		"default": "map",
		requires: [
			"icon-image",
			"icon-translate"
		],
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"text-opacity": {
		type: "number",
		"default": 1,
		minimum: 0,
		maximum: 1,
		transition: true,
		requires: [
			"text-field"
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"text-color": {
		type: "color",
		"default": "#000000",
		transition: true,
		overridable: true,
		requires: [
			"text-field"
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"text-halo-color": {
		type: "color",
		"default": "rgba(0, 0, 0, 0)",
		transition: true,
		requires: [
			"text-field"
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"text-halo-width": {
		type: "number",
		"default": 0,
		minimum: 0,
		transition: true,
		units: "pixels",
		requires: [
			"text-field"
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"text-halo-blur": {
		type: "number",
		"default": 0,
		minimum: 0,
		transition: true,
		units: "pixels",
		requires: [
			"text-field"
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"text-translate": {
		type: "array",
		value: "number",
		length: 2,
		"default": [
			0,
			0
		],
		transition: true,
		units: "pixels",
		requires: [
			"text-field"
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"text-translate-anchor": {
		type: "enum",
		values: {
			map: {
			},
			viewport: {
			}
		},
		"default": "map",
		requires: [
			"text-field",
			"text-translate"
		],
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	}
};
var paint_raster = {
	"raster-opacity": {
		type: "number",
		"default": 1,
		minimum: 0,
		maximum: 1,
		transition: true,
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"raster-hue-rotate": {
		type: "number",
		"default": 0,
		period: 360,
		transition: true,
		units: "degrees",
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"raster-brightness-min": {
		type: "number",
		"default": 0,
		minimum: 0,
		maximum: 1,
		transition: true,
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"raster-brightness-max": {
		type: "number",
		"default": 1,
		minimum: 0,
		maximum: 1,
		transition: true,
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"raster-saturation": {
		type: "number",
		"default": 0,
		minimum: -1,
		maximum: 1,
		transition: true,
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"raster-contrast": {
		type: "number",
		"default": 0,
		minimum: -1,
		maximum: 1,
		transition: true,
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"raster-resampling": {
		type: "enum",
		values: {
			linear: {
			},
			nearest: {
			}
		},
		"default": "linear",
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"raster-fade-duration": {
		type: "number",
		"default": 300,
		minimum: 0,
		transition: false,
		units: "milliseconds",
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	}
};
var paint_hillshade = {
	"hillshade-illumination-direction": {
		type: "number",
		"default": 335,
		minimum: 0,
		maximum: 359,
		transition: false,
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"hillshade-illumination-anchor": {
		type: "enum",
		values: {
			map: {
			},
			viewport: {
			}
		},
		"default": "viewport",
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"hillshade-exaggeration": {
		type: "number",
		"default": 0.5,
		minimum: 0,
		maximum: 1,
		transition: true,
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"hillshade-shadow-color": {
		type: "color",
		"default": "#000000",
		transition: true,
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"hillshade-highlight-color": {
		type: "color",
		"default": "#FFFFFF",
		transition: true,
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"hillshade-accent-color": {
		type: "color",
		"default": "#000000",
		transition: true,
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	}
};
var paint_background = {
	"background-color": {
		type: "color",
		"default": "#000000",
		transition: true,
		requires: [
			{
				"!": "background-pattern"
			}
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"background-pattern": {
		type: "resolvedImage",
		transition: true,
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "cross-faded"
	},
	"background-opacity": {
		type: "number",
		"default": 1,
		minimum: 0,
		maximum: 1,
		transition: true,
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	}
};
var transition = {
	duration: {
		type: "number",
		"default": 300,
		minimum: 0,
		units: "milliseconds"
	},
	delay: {
		type: "number",
		"default": 0,
		minimum: 0,
		units: "milliseconds"
	}
};
var promoteId = {
	"*": {
		type: "string"
	}
};
var v8Spec = {
	$version: $version,
	$root: $root,
	sources: sources,
	source: source,
	source_vector: source_vector,
	source_raster: source_raster,
	source_raster_dem: source_raster_dem,
	source_geojson: source_geojson,
	source_video: source_video,
	source_image: source_image,
	layer: layer,
	layout: layout$7,
	layout_background: layout_background,
	layout_fill: layout_fill,
	layout_circle: layout_circle,
	layout_heatmap: layout_heatmap,
	"layout_fill-extrusion": {
	visibility: {
		type: "enum",
		values: {
			visible: {
			},
			none: {
			}
		},
		"default": "visible",
		"property-type": "constant"
	}
},
	layout_line: layout_line,
	layout_symbol: layout_symbol,
	layout_raster: layout_raster,
	layout_hillshade: layout_hillshade,
	filter: filter,
	filter_operator: filter_operator,
	geometry_type: geometry_type,
	"function": {
	expression: {
		type: "expression"
	},
	stops: {
		type: "array",
		value: "function_stop"
	},
	base: {
		type: "number",
		"default": 1,
		minimum: 0
	},
	property: {
		type: "string",
		"default": "$zoom"
	},
	type: {
		type: "enum",
		values: {
			identity: {
			},
			exponential: {
			},
			interval: {
			},
			categorical: {
			}
		},
		"default": "exponential"
	},
	colorSpace: {
		type: "enum",
		values: {
			rgb: {
			},
			lab: {
			},
			hcl: {
			}
		},
		"default": "rgb"
	},
	"default": {
		type: "*",
		required: false
	}
},
	function_stop: function_stop,
	expression: expression$1,
	light: light,
	sky: sky,
	terrain: terrain,
	projection: projection,
	paint: paint$9,
	paint_fill: paint_fill,
	"paint_fill-extrusion": {
	"fill-extrusion-opacity": {
		type: "number",
		"default": 1,
		minimum: 0,
		maximum: 1,
		transition: true,
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"fill-extrusion-color": {
		type: "color",
		"default": "#000000",
		transition: true,
		requires: [
			{
				"!": "fill-extrusion-pattern"
			}
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"fill-extrusion-translate": {
		type: "array",
		value: "number",
		length: 2,
		"default": [
			0,
			0
		],
		transition: true,
		units: "pixels",
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"fill-extrusion-translate-anchor": {
		type: "enum",
		values: {
			map: {
			},
			viewport: {
			}
		},
		"default": "map",
		requires: [
			"fill-extrusion-translate"
		],
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"fill-extrusion-pattern": {
		type: "resolvedImage",
		transition: true,
		expression: {
			interpolated: false,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "cross-faded-data-driven"
	},
	"fill-extrusion-height": {
		type: "number",
		"default": 0,
		minimum: 0,
		units: "meters",
		transition: true,
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"fill-extrusion-base": {
		type: "number",
		"default": 0,
		minimum: 0,
		units: "meters",
		transition: true,
		requires: [
			"fill-extrusion-height"
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"fill-extrusion-vertical-gradient": {
		type: "boolean",
		"default": true,
		transition: false,
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	}
},
	paint_line: paint_line,
	paint_circle: paint_circle,
	paint_heatmap: paint_heatmap,
	paint_symbol: paint_symbol,
	paint_raster: paint_raster,
	paint_hillshade: paint_hillshade,
	paint_background: paint_background,
	transition: transition,
	"property-type": {
	"data-driven": {
		type: "property-type"
	},
	"cross-faded": {
		type: "property-type"
	},
	"cross-faded-data-driven": {
		type: "property-type"
	},
	"color-ramp": {
		type: "property-type"
	},
	"data-constant": {
		type: "property-type"
	},
	constant: {
		type: "property-type"
	}
},
	promoteId: promoteId
};

const refProperties = ['type', 'source', 'source-layer', 'minzoom', 'maxzoom', 'filter', 'layout'];

function deref(layer, parent) {
    const result = {};
    for (const k in layer) {
        if (k !== 'ref') {
            result[k] = layer[k];
        }
    }
    refProperties.forEach((k) => {
        if (k in parent) {
            result[k] = parent[k];
        }
    });
    return result;
}
/**
 * Given an array of layers, some of which may contain `ref` properties
 * whose value is the `id` of another property, return a new array where
 * such layers have been augmented with the 'type', 'source', etc. properties
 * from the parent layer, and the `ref` property has been removed.
 *
 * The input is not modified. The output may contain references to portions
 * of the input.
 *
 * @private
 * @param {Array<Layer>} layers
 * @returns {Array<Layer>}
 */
function derefLayers(layers) {
    layers = layers.slice();
    const map = Object.create(null);
    for (let i = 0; i < layers.length; i++) {
        map[layers[i].id] = layers[i];
    }
    for (let i = 0; i < layers.length; i++) {
        if ('ref' in layers[i]) {
            layers[i] = deref(layers[i], map[layers[i].ref]);
        }
    }
    return layers;
}

/**
 * Deeply compares two object literals.
 *
 * @private
 */
function deepEqual(a, b) {
    if (Array.isArray(a)) {
        if (!Array.isArray(b) || a.length !== b.length)
            return false;
        for (let i = 0; i < a.length; i++) {
            if (!deepEqual(a[i], b[i]))
                return false;
        }
        return true;
    }
    if (typeof a === 'object' && a !== null && b !== null) {
        if (!(typeof b === 'object'))
            return false;
        const keys = Object.keys(a);
        if (keys.length !== Object.keys(b).length)
            return false;
        for (const key in a) {
            if (!deepEqual(a[key], b[key]))
                return false;
        }
        return true;
    }
    return a === b;
}

/**
 * The main reason for this method is to allow type check when adding a command to the array.
 * @param commands - The commands array to add to
 * @param command - The command to add
 */
function addCommand(commands, command) {
    commands.push(command);
}
function addSource(sourceId, after, commands) {
    addCommand(commands, { command: 'addSource', args: [sourceId, after[sourceId]] });
}
function removeSource(sourceId, commands, sourcesRemoved) {
    addCommand(commands, { command: 'removeSource', args: [sourceId] });
    sourcesRemoved[sourceId] = true;
}
function updateSource(sourceId, after, commands, sourcesRemoved) {
    removeSource(sourceId, commands, sourcesRemoved);
    addSource(sourceId, after, commands);
}
function canUpdateGeoJSON(before, after, sourceId) {
    let prop;
    for (prop in before[sourceId]) {
        if (!Object.prototype.hasOwnProperty.call(before[sourceId], prop))
            continue;
        if (prop !== 'data' && !deepEqual(before[sourceId][prop], after[sourceId][prop])) {
            return false;
        }
    }
    for (prop in after[sourceId]) {
        if (!Object.prototype.hasOwnProperty.call(after[sourceId], prop))
            continue;
        if (prop !== 'data' && !deepEqual(before[sourceId][prop], after[sourceId][prop])) {
            return false;
        }
    }
    return true;
}
function diffSources(before, after, commands, sourcesRemoved) {
    before = before || {};
    after = after || {};
    let sourceId;
    // look for sources to remove
    for (sourceId in before) {
        if (!Object.prototype.hasOwnProperty.call(before, sourceId))
            continue;
        if (!Object.prototype.hasOwnProperty.call(after, sourceId)) {
            removeSource(sourceId, commands, sourcesRemoved);
        }
    }
    // look for sources to add/update
    for (sourceId in after) {
        if (!Object.prototype.hasOwnProperty.call(after, sourceId))
            continue;
        if (!Object.prototype.hasOwnProperty.call(before, sourceId)) {
            addSource(sourceId, after, commands);
        }
        else if (!deepEqual(before[sourceId], after[sourceId])) {
            if (before[sourceId].type === 'geojson' && after[sourceId].type === 'geojson' && canUpdateGeoJSON(before, after, sourceId)) {
                addCommand(commands, { command: 'setGeoJSONSourceData', args: [sourceId, after[sourceId].data] });
            }
            else {
                // no update command, must remove then add
                updateSource(sourceId, after, commands, sourcesRemoved);
            }
        }
    }
}
function diffLayerPropertyChanges(before, after, commands, layerId, klass, command) {
    before = before || {};
    after = after || {};
    for (const prop in before) {
        if (!Object.prototype.hasOwnProperty.call(before, prop))
            continue;
        if (!deepEqual(before[prop], after[prop])) {
            commands.push({ command, args: [layerId, prop, after[prop], klass] });
        }
    }
    for (const prop in after) {
        if (!Object.prototype.hasOwnProperty.call(after, prop) || Object.prototype.hasOwnProperty.call(before, prop))
            continue;
        if (!deepEqual(before[prop], after[prop])) {
            commands.push({ command, args: [layerId, prop, after[prop], klass] });
        }
    }
}
function pluckId(layer) {
    return layer.id;
}
function indexById(group, layer) {
    group[layer.id] = layer;
    return group;
}
function diffLayers(before, after, commands) {
    before = before || [];
    after = after || [];
    // order of layers by id
    const beforeOrder = before.map(pluckId);
    const afterOrder = after.map(pluckId);
    // index of layer by id
    const beforeIndex = before.reduce(indexById, {});
    const afterIndex = after.reduce(indexById, {});
    // track order of layers as if they have been mutated
    const tracker = beforeOrder.slice();
    // layers that have been added do not need to be diffed
    const clean = Object.create(null);
    let layerId;
    let beforeLayer;
    let afterLayer;
    let insertBeforeLayerId;
    let prop;
    // remove layers
    for (let i = 0, d = 0; i < beforeOrder.length; i++) {
        layerId = beforeOrder[i];
        if (!Object.prototype.hasOwnProperty.call(afterIndex, layerId)) {
            addCommand(commands, { command: 'removeLayer', args: [layerId] });
            tracker.splice(tracker.indexOf(layerId, d), 1);
        }
        else {
            // limit where in tracker we need to look for a match
            d++;
        }
    }
    // add/reorder layers
    for (let i = 0, d = 0; i < afterOrder.length; i++) {
        // work backwards as insert is before an existing layer
        layerId = afterOrder[afterOrder.length - 1 - i];
        if (tracker[tracker.length - 1 - i] === layerId)
            continue;
        if (Object.prototype.hasOwnProperty.call(beforeIndex, layerId)) {
            // remove the layer before we insert at the correct position
            addCommand(commands, { command: 'removeLayer', args: [layerId] });
            tracker.splice(tracker.lastIndexOf(layerId, tracker.length - d), 1);
        }
        else {
            // limit where in tracker we need to look for a match
            d++;
        }
        // add layer at correct position
        insertBeforeLayerId = tracker[tracker.length - i];
        addCommand(commands, { command: 'addLayer', args: [afterIndex[layerId], insertBeforeLayerId] });
        tracker.splice(tracker.length - i, 0, layerId);
        clean[layerId] = true;
    }
    // update layers
    for (let i = 0; i < afterOrder.length; i++) {
        layerId = afterOrder[i];
        beforeLayer = beforeIndex[layerId];
        afterLayer = afterIndex[layerId];
        // no need to update if previously added (new or moved)
        if (clean[layerId] || deepEqual(beforeLayer, afterLayer))
            continue;
        // If source, source-layer, or type have changes, then remove the layer
        // and add it back 'from scratch'.
        if (!deepEqual(beforeLayer.source, afterLayer.source) || !deepEqual(beforeLayer['source-layer'], afterLayer['source-layer']) || !deepEqual(beforeLayer.type, afterLayer.type)) {
            addCommand(commands, { command: 'removeLayer', args: [layerId] });
            // we add the layer back at the same position it was already in, so
            // there's no need to update the `tracker`
            insertBeforeLayerId = tracker[tracker.lastIndexOf(layerId) + 1];
            addCommand(commands, { command: 'addLayer', args: [afterLayer, insertBeforeLayerId] });
            continue;
        }
        // layout, paint, filter, minzoom, maxzoom
        diffLayerPropertyChanges(beforeLayer.layout, afterLayer.layout, commands, layerId, null, 'setLayoutProperty');
        diffLayerPropertyChanges(beforeLayer.paint, afterLayer.paint, commands, layerId, null, 'setPaintProperty');
        if (!deepEqual(beforeLayer.filter, afterLayer.filter)) {
            addCommand(commands, { command: 'setFilter', args: [layerId, afterLayer.filter] });
        }
        if (!deepEqual(beforeLayer.minzoom, afterLayer.minzoom) || !deepEqual(beforeLayer.maxzoom, afterLayer.maxzoom)) {
            addCommand(commands, { command: 'setLayerZoomRange', args: [layerId, afterLayer.minzoom, afterLayer.maxzoom] });
        }
        // handle all other layer props, including paint.*
        for (prop in beforeLayer) {
            if (!Object.prototype.hasOwnProperty.call(beforeLayer, prop))
                continue;
            if (prop === 'layout' || prop === 'paint' || prop === 'filter' ||
                prop === 'metadata' || prop === 'minzoom' || prop === 'maxzoom')
                continue;
            if (prop.indexOf('paint.') === 0) {
                diffLayerPropertyChanges(beforeLayer[prop], afterLayer[prop], commands, layerId, prop.slice(6), 'setPaintProperty');
            }
            else if (!deepEqual(beforeLayer[prop], afterLayer[prop])) {
                addCommand(commands, { command: 'setLayerProperty', args: [layerId, prop, afterLayer[prop]] });
            }
        }
        for (prop in afterLayer) {
            if (!Object.prototype.hasOwnProperty.call(afterLayer, prop) || Object.prototype.hasOwnProperty.call(beforeLayer, prop))
                continue;
            if (prop === 'layout' || prop === 'paint' || prop === 'filter' ||
                prop === 'metadata' || prop === 'minzoom' || prop === 'maxzoom')
                continue;
            if (prop.indexOf('paint.') === 0) {
                diffLayerPropertyChanges(beforeLayer[prop], afterLayer[prop], commands, layerId, prop.slice(6), 'setPaintProperty');
            }
            else if (!deepEqual(beforeLayer[prop], afterLayer[prop])) {
                addCommand(commands, { command: 'setLayerProperty', args: [layerId, prop, afterLayer[prop]] });
            }
        }
    }
}
/**
 * Diff two stylesheet
 *
 * Creates semanticly aware diffs that can easily be applied at runtime.
 * Operations produced by the diff closely resemble the maplibre-gl-js API. Any
 * error creating the diff will fall back to the 'setStyle' operation.
 *
 * Example diff:
 * [
 *     { command: 'setConstant', args: ['@water', '#0000FF'] },
 *     { command: 'setPaintProperty', args: ['background', 'background-color', 'black'] }
 * ]
 *
 * @private
 * @param {*} [before] stylesheet to compare from
 * @param {*} after stylesheet to compare to
 * @returns Array list of changes
 */
function diffStyles(before, after) {
    if (!before)
        return [{ command: 'setStyle', args: [after] }];
    let commands = [];
    try {
        // Handle changes to top-level properties
        if (!deepEqual(before.version, after.version)) {
            return [{ command: 'setStyle', args: [after] }];
        }
        if (!deepEqual(before.center, after.center)) {
            commands.push({ command: 'setCenter', args: [after.center] });
        }
        if (!deepEqual(before.zoom, after.zoom)) {
            commands.push({ command: 'setZoom', args: [after.zoom] });
        }
        if (!deepEqual(before.bearing, after.bearing)) {
            commands.push({ command: 'setBearing', args: [after.bearing] });
        }
        if (!deepEqual(before.pitch, after.pitch)) {
            commands.push({ command: 'setPitch', args: [after.pitch] });
        }
        if (!deepEqual(before.sprite, after.sprite)) {
            commands.push({ command: 'setSprite', args: [after.sprite] });
        }
        if (!deepEqual(before.glyphs, after.glyphs)) {
            commands.push({ command: 'setGlyphs', args: [after.glyphs] });
        }
        if (!deepEqual(before.transition, after.transition)) {
            commands.push({ command: 'setTransition', args: [after.transition] });
        }
        if (!deepEqual(before.light, after.light)) {
            commands.push({ command: 'setLight', args: [after.light] });
        }
        if (!deepEqual(before.terrain, after.terrain)) {
            commands.push({ command: 'setTerrain', args: [after.terrain] });
        }
        if (!deepEqual(before.sky, after.sky)) {
            commands.push({ command: 'setSky', args: [after.sky] });
        }
        if (!deepEqual(before.projection, after.projection)) {
            commands.push({ command: 'setProjection', args: [after.projection] });
        }
        // Handle changes to `sources`
        // If a source is to be removed, we also--before the removeSource
        // command--need to remove all the style layers that depend on it.
        const sourcesRemoved = {};
        // First collect the {add,remove}Source commands
        const removeOrAddSourceCommands = [];
        diffSources(before.sources, after.sources, removeOrAddSourceCommands, sourcesRemoved);
        // Push a removeLayer command for each style layer that depends on a
        // source that's being removed.
        // Also, exclude any such layers them from the input to `diffLayers`
        // below, so that diffLayers produces the appropriate `addLayers`
        // command
        const beforeLayers = [];
        if (before.layers) {
            before.layers.forEach((layer) => {
                if ('source' in layer && sourcesRemoved[layer.source]) {
                    commands.push({ command: 'removeLayer', args: [layer.id] });
                }
                else {
                    beforeLayers.push(layer);
                }
            });
        }
        commands = commands.concat(removeOrAddSourceCommands);
        // Handle changes to `layers`
        diffLayers(beforeLayers, after.layers, commands);
    }
    catch (e) {
        // fall back to setStyle
        console.warn('Unable to compute style diff:', e);
        commands = [{ command: 'setStyle', args: [after] }];
    }
    return commands;
}

// Note: Do not inherit from Error. It breaks when transpiling to ES5.
class ValidationError {
    constructor(key, value, message, identifier) {
        this.message = (key ? `${key}: ` : '') + message;
        if (identifier)
            this.identifier = identifier;
        if (value !== null && value !== undefined && value.__line__) {
            this.line = value.__line__;
        }
    }
}

function extendBy(output, ...inputs) {
    for (const input of inputs) {
        for (const k in input) {
            output[k] = input[k];
        }
    }
    return output;
}

class ExpressionParsingError extends Error {
    constructor(key, message) {
        super(message);
        this.message = message;
        this.key = key;
    }
}

/**
 * Tracks `let` bindings during expression parsing.
 * @private
 */
class Scope {
    constructor(parent, bindings = []) {
        this.parent = parent;
        this.bindings = {};
        for (const [name, expression] of bindings) {
            this.bindings[name] = expression;
        }
    }
    concat(bindings) {
        return new Scope(this, bindings);
    }
    get(name) {
        if (this.bindings[name]) {
            return this.bindings[name];
        }
        if (this.parent) {
            return this.parent.get(name);
        }
        throw new Error(`${name} not found in scope.`);
    }
    has(name) {
        if (this.bindings[name])
            return true;
        return this.parent ? this.parent.has(name) : false;
    }
}

const NullType = { kind: 'null' };
const NumberType = { kind: 'number' };
const StringType = { kind: 'string' };
const BooleanType = { kind: 'boolean' };
const ColorType = { kind: 'color' };
const ObjectType = { kind: 'object' };
const ValueType = { kind: 'value' };
const ErrorType = { kind: 'error' };
const CollatorType = { kind: 'collator' };
const FormattedType = { kind: 'formatted' };
const PaddingType = { kind: 'padding' };
const ResolvedImageType = { kind: 'resolvedImage' };
const VariableAnchorOffsetCollectionType = { kind: 'variableAnchorOffsetCollection' };
function array$1(itemType, N) {
    return {
        kind: 'array',
        itemType,
        N
    };
}
function toString$1(type) {
    if (type.kind === 'array') {
        const itemType = toString$1(type.itemType);
        return typeof type.N === 'number' ?
            `array<${itemType}, ${type.N}>` :
            type.itemType.kind === 'value' ? 'array' : `array<${itemType}>`;
    }
    else {
        return type.kind;
    }
}
const valueMemberTypes = [
    NullType,
    NumberType,
    StringType,
    BooleanType,
    ColorType,
    FormattedType,
    ObjectType,
    array$1(ValueType),
    PaddingType,
    ResolvedImageType,
    VariableAnchorOffsetCollectionType
];
/**
 * Returns null if `t` is a subtype of `expected`; otherwise returns an
 * error message.
 * @private
 */
function checkSubtype(expected, t) {
    if (t.kind === 'error') {
        // Error is a subtype of every type
        return null;
    }
    else if (expected.kind === 'array') {
        if (t.kind === 'array' &&
            ((t.N === 0 && t.itemType.kind === 'value') || !checkSubtype(expected.itemType, t.itemType)) &&
            (typeof expected.N !== 'number' || expected.N === t.N)) {
            return null;
        }
    }
    else if (expected.kind === t.kind) {
        return null;
    }
    else if (expected.kind === 'value') {
        for (const memberType of valueMemberTypes) {
            if (!checkSubtype(memberType, t)) {
                return null;
            }
        }
    }
    return `Expected ${toString$1(expected)} but found ${toString$1(t)} instead.`;
}
function isValidType(provided, allowedTypes) {
    return allowedTypes.some(t => t.kind === provided.kind);
}
function isValidNativeType(provided, allowedTypes) {
    return allowedTypes.some(t => {
        if (t === 'null') {
            return provided === null;
        }
        else if (t === 'array') {
            return Array.isArray(provided);
        }
        else if (t === 'object') {
            return provided && !Array.isArray(provided) && typeof provided === 'object';
        }
        else {
            return t === typeof provided;
        }
    });
}
/**
 * Verify whether the specified type is of the same type as the specified sample.
 *
 * @param provided Type to verify
 * @param sample Sample type to reference
 * @returns `true` if both objects are of the same type, `false` otherwise
 * @example basic types
 * if (verifyType(outputType, ValueType)) {
 *     // type narrowed to:
 *     outputType.kind; // 'value'
 * }
 * @example array types
 * if (verifyType(outputType, array(NumberType))) {
 *     // type narrowed to:
 *     outputType.kind; // 'array'
 *     outputType.itemType; // NumberTypeT
 *     outputType.itemType.kind; // 'number'
 * }
 */
function verifyType(provided, sample) {
    if (provided.kind === 'array' && sample.kind === 'array') {
        return provided.itemType.kind === sample.itemType.kind && typeof provided.N === 'number';
    }
    return provided.kind === sample.kind;
}

// See https://observablehq.com/@mbostock/lab-and-rgb
const Xn = 0.96422, Yn = 1, Zn = 0.82521, t0 = 4 / 29, t1 = 6 / 29, t2 = 3 * t1 * t1, t3 = t1 * t1 * t1, deg2rad = Math.PI / 180, rad2deg = 180 / Math.PI;
function constrainAngle(angle) {
    angle = angle % 360;
    if (angle < 0) {
        angle += 360;
    }
    return angle;
}
function rgbToLab([r, g, b, alpha]) {
    r = rgb2xyz(r);
    g = rgb2xyz(g);
    b = rgb2xyz(b);
    let x, z;
    const y = xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / Yn);
    if (r === g && g === b) {
        x = z = y;
    }
    else {
        x = xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / Xn);
        z = xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / Zn);
    }
    const l = 116 * y - 16;
    return [(l < 0) ? 0 : l, 500 * (x - y), 200 * (y - z), alpha];
}
function rgb2xyz(x) {
    return (x <= 0.04045) ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}
function xyz2lab(t) {
    return (t > t3) ? Math.pow(t, 1 / 3) : t / t2 + t0;
}
function labToRgb([l, a, b, alpha]) {
    let y = (l + 16) / 116, x = isNaN(a) ? y : y + a / 500, z = isNaN(b) ? y : y - b / 200;
    y = Yn * lab2xyz(y);
    x = Xn * lab2xyz(x);
    z = Zn * lab2xyz(z);
    return [
        xyz2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), // D50 -> sRGB
        xyz2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z),
        xyz2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z),
        alpha,
    ];
}
function xyz2rgb(x) {
    x = (x <= 0.00304) ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055;
    return (x < 0) ? 0 : (x > 1) ? 1 : x; // clip to 0..1 range
}
function lab2xyz(t) {
    return (t > t1) ? t * t * t : t2 * (t - t0);
}
function rgbToHcl(rgbColor) {
    const [l, a, b, alpha] = rgbToLab(rgbColor);
    const c = Math.sqrt(a * a + b * b);
    const h = Math.round(c * 10000) ? constrainAngle(Math.atan2(b, a) * rad2deg) : NaN;
    return [h, c, l, alpha];
}
function hclToRgb([h, c, l, alpha]) {
    h = isNaN(h) ? 0 : h * deg2rad;
    return labToRgb([l, Math.cos(h) * c, Math.sin(h) * c, alpha]);
}
// https://drafts.csswg.org/css-color-4/#hsl-to-rgb
function hslToRgb([h, s, l, alpha]) {
    h = constrainAngle(h);
    s /= 100;
    l /= 100;
    function f(n) {
        const k = (n + h / 30) % 12;
        const a = s * Math.min(l, 1 - l);
        return l - a * Math.max(-1, Math.min(k - 3, 9 - k, 1));
    }
    return [f(0), f(8), f(4), alpha];
}

/**
 * CSS color parser compliant with CSS Color 4 Specification.
 * Supports: named colors, `transparent` keyword, all rgb hex notations,
 * rgb(), rgba(), hsl() and hsla() functions.
 * Does not round the parsed values to integers from the range 0..255.
 *
 * Syntax:
 *
 * <alpha-value> = <number> | <percentage>
 *         <hue> = <number> | <angle>
 *
 *         rgb() = rgb( <percentage>{3} [ / <alpha-value> ]? ) | rgb( <number>{3} [ / <alpha-value> ]? )
 *         rgb() = rgb( <percentage>#{3} , <alpha-value>? )    | rgb( <number>#{3} , <alpha-value>? )
 *
 *         hsl() = hsl( <hue> <percentage> <percentage> [ / <alpha-value> ]? )
 *         hsl() = hsl( <hue>, <percentage>, <percentage>, <alpha-value>? )
 *
 * Caveats:
 *   - <angle> - <number> with optional `deg` suffix; `grad`, `rad`, `turn` are not supported
 *   - `none` keyword is not supported
 *   - comments inside rgb()/hsl() are not supported
 *   - legacy color syntax rgba() is supported with an identical grammar and behavior to rgb()
 *   - legacy color syntax hsla() is supported with an identical grammar and behavior to hsl()
 *
 * @param input CSS color string to parse.
 * @returns Color in sRGB color space, with `red`, `green`, `blue`
 * and `alpha` channels normalized to the range 0..1,
 * or `undefined` if the input is not a valid color string.
 */
function parseCssColor(input) {
    input = input.toLowerCase().trim();
    if (input === 'transparent') {
        return [0, 0, 0, 0];
    }
    // 'white', 'black', 'blue'
    const namedColorsMatch = namedColors[input];
    if (namedColorsMatch) {
        const [r, g, b] = namedColorsMatch;
        return [r / 255, g / 255, b / 255, 1];
    }
    // #f0c, #f0cf, #ff00cc, #ff00ccff
    if (input.startsWith('#')) {
        const hexRegexp = /^#(?:[0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})$/;
        if (hexRegexp.test(input)) {
            const step = input.length < 6 ? 1 : 2;
            let i = 1;
            return [
                parseHex(input.slice(i, i += step)),
                parseHex(input.slice(i, i += step)),
                parseHex(input.slice(i, i += step)),
                parseHex(input.slice(i, i + step) || 'ff'),
            ];
        }
    }
    // rgb(128 0 0), rgb(50% 0% 0%), rgba(255,0,255,0.6), rgb(255 0 255 / 60%), rgb(100% 0% 100% /.6)
    if (input.startsWith('rgb')) {
        const rgbRegExp = /^rgba?\(\s*([\de.+-]+)(%)?(?:\s+|\s*(,)\s*)([\de.+-]+)(%)?(?:\s+|\s*(,)\s*)([\de.+-]+)(%)?(?:\s*([,\/])\s*([\de.+-]+)(%)?)?\s*\)$/;
        const rgbMatch = input.match(rgbRegExp);
        if (rgbMatch) {
            const [_, // eslint-disable-line @typescript-eslint/no-unused-vars
            r, // <numeric>
            rp, // %         (optional)
            f1, // ,         (optional)
            g, // <numeric>
            gp, // %         (optional)
            f2, // ,         (optional)
            b, // <numeric>
            bp, // %         (optional)
            f3, // ,|/       (optional)
            a, // <numeric> (optional)
            ap, // %         (optional)
            ] = rgbMatch;
            const argFormat = [f1 || ' ', f2 || ' ', f3].join('');
            if (argFormat === '  ' ||
                argFormat === '  /' ||
                argFormat === ',,' ||
                argFormat === ',,,') {
                const valFormat = [rp, gp, bp].join('');
                const maxValue = (valFormat === '%%%') ? 100 :
                    (valFormat === '') ? 255 : 0;
                if (maxValue) {
                    const rgba = [
                        clamp(+r / maxValue, 0, 1),
                        clamp(+g / maxValue, 0, 1),
                        clamp(+b / maxValue, 0, 1),
                        a ? parseAlpha(+a, ap) : 1,
                    ];
                    if (validateNumbers(rgba)) {
                        return rgba;
                    }
                    // invalid numbers
                }
                // values must be all numbers or all percentages
            }
            return; // comma optional syntax requires no commas at all
        }
    }
    // hsl(120 50% 80%), hsla(120deg,50%,80%,.9), hsl(12e1 50% 80% / 90%)
    const hslRegExp = /^hsla?\(\s*([\de.+-]+)(?:deg)?(?:\s+|\s*(,)\s*)([\de.+-]+)%(?:\s+|\s*(,)\s*)([\de.+-]+)%(?:\s*([,\/])\s*([\de.+-]+)(%)?)?\s*\)$/;
    const hslMatch = input.match(hslRegExp);
    if (hslMatch) {
        const [_, // eslint-disable-line @typescript-eslint/no-unused-vars
        h, // <numeric>
        f1, // ,         (optional)
        s, // <numeric>
        f2, // ,         (optional)
        l, // <numeric>
        f3, // ,|/       (optional)
        a, // <numeric> (optional)
        ap, // %         (optional)
        ] = hslMatch;
        const argFormat = [f1 || ' ', f2 || ' ', f3].join('');
        if (argFormat === '  ' ||
            argFormat === '  /' ||
            argFormat === ',,' ||
            argFormat === ',,,') {
            const hsla = [
                +h,
                clamp(+s, 0, 100),
                clamp(+l, 0, 100),
                a ? parseAlpha(+a, ap) : 1,
            ];
            if (validateNumbers(hsla)) {
                return hslToRgb(hsla);
            }
            // invalid numbers
        }
        // comma optional syntax requires no commas at all
    }
}
function parseHex(hex) {
    return parseInt(hex.padEnd(2, hex), 16) / 255;
}
function parseAlpha(a, asPercentage) {
    return clamp(asPercentage ? (a / 100) : a, 0, 1);
}
function clamp(n, min, max) {
    return Math.min(Math.max(min, n), max);
}
/**
 * The regular expression for numeric values is not super specific, and it may
 * happen that it will accept a value that is not a valid number. In order to
 * detect and eliminate such values this function exists.
 *
 * @param array Array of uncertain numbers.
 * @returns `true` if the specified array contains only valid numbers, `false` otherwise.
 */
function validateNumbers(array) {
    return !array.some(Number.isNaN);
}
/**
 * To generate:
 * - visit {@link https://www.w3.org/TR/css-color-4/#named-colors}
 * - run in the console:
 * @example
 * copy(`{\n${[...document.querySelector('.named-color-table tbody').children].map((tr) => `${tr.cells[2].textContent.trim()}: [${tr.cells[4].textContent.trim().split(/\s+/).join(', ')}],`).join('\n')}\n}`);
 */
const namedColors = {
    aliceblue: [240, 248, 255],
    antiquewhite: [250, 235, 215],
    aqua: [0, 255, 255],
    aquamarine: [127, 255, 212],
    azure: [240, 255, 255],
    beige: [245, 245, 220],
    bisque: [255, 228, 196],
    black: [0, 0, 0],
    blanchedalmond: [255, 235, 205],
    blue: [0, 0, 255],
    blueviolet: [138, 43, 226],
    brown: [165, 42, 42],
    burlywood: [222, 184, 135],
    cadetblue: [95, 158, 160],
    chartreuse: [127, 255, 0],
    chocolate: [210, 105, 30],
    coral: [255, 127, 80],
    cornflowerblue: [100, 149, 237],
    cornsilk: [255, 248, 220],
    crimson: [220, 20, 60],
    cyan: [0, 255, 255],
    darkblue: [0, 0, 139],
    darkcyan: [0, 139, 139],
    darkgoldenrod: [184, 134, 11],
    darkgray: [169, 169, 169],
    darkgreen: [0, 100, 0],
    darkgrey: [169, 169, 169],
    darkkhaki: [189, 183, 107],
    darkmagenta: [139, 0, 139],
    darkolivegreen: [85, 107, 47],
    darkorange: [255, 140, 0],
    darkorchid: [153, 50, 204],
    darkred: [139, 0, 0],
    darksalmon: [233, 150, 122],
    darkseagreen: [143, 188, 143],
    darkslateblue: [72, 61, 139],
    darkslategray: [47, 79, 79],
    darkslategrey: [47, 79, 79],
    darkturquoise: [0, 206, 209],
    darkviolet: [148, 0, 211],
    deeppink: [255, 20, 147],
    deepskyblue: [0, 191, 255],
    dimgray: [105, 105, 105],
    dimgrey: [105, 105, 105],
    dodgerblue: [30, 144, 255],
    firebrick: [178, 34, 34],
    floralwhite: [255, 250, 240],
    forestgreen: [34, 139, 34],
    fuchsia: [255, 0, 255],
    gainsboro: [220, 220, 220],
    ghostwhite: [248, 248, 255],
    gold: [255, 215, 0],
    goldenrod: [218, 165, 32],
    gray: [128, 128, 128],
    green: [0, 128, 0],
    greenyellow: [173, 255, 47],
    grey: [128, 128, 128],
    honeydew: [240, 255, 240],
    hotpink: [255, 105, 180],
    indianred: [205, 92, 92],
    indigo: [75, 0, 130],
    ivory: [255, 255, 240],
    khaki: [240, 230, 140],
    lavender: [230, 230, 250],
    lavenderblush: [255, 240, 245],
    lawngreen: [124, 252, 0],
    lemonchiffon: [255, 250, 205],
    lightblue: [173, 216, 230],
    lightcoral: [240, 128, 128],
    lightcyan: [224, 255, 255],
    lightgoldenrodyellow: [250, 250, 210],
    lightgray: [211, 211, 211],
    lightgreen: [144, 238, 144],
    lightgrey: [211, 211, 211],
    lightpink: [255, 182, 193],
    lightsalmon: [255, 160, 122],
    lightseagreen: [32, 178, 170],
    lightskyblue: [135, 206, 250],
    lightslategray: [119, 136, 153],
    lightslategrey: [119, 136, 153],
    lightsteelblue: [176, 196, 222],
    lightyellow: [255, 255, 224],
    lime: [0, 255, 0],
    limegreen: [50, 205, 50],
    linen: [250, 240, 230],
    magenta: [255, 0, 255],
    maroon: [128, 0, 0],
    mediumaquamarine: [102, 205, 170],
    mediumblue: [0, 0, 205],
    mediumorchid: [186, 85, 211],
    mediumpurple: [147, 112, 219],
    mediumseagreen: [60, 179, 113],
    mediumslateblue: [123, 104, 238],
    mediumspringgreen: [0, 250, 154],
    mediumturquoise: [72, 209, 204],
    mediumvioletred: [199, 21, 133],
    midnightblue: [25, 25, 112],
    mintcream: [245, 255, 250],
    mistyrose: [255, 228, 225],
    moccasin: [255, 228, 181],
    navajowhite: [255, 222, 173],
    navy: [0, 0, 128],
    oldlace: [253, 245, 230],
    olive: [128, 128, 0],
    olivedrab: [107, 142, 35],
    orange: [255, 165, 0],
    orangered: [255, 69, 0],
    orchid: [218, 112, 214],
    palegoldenrod: [238, 232, 170],
    palegreen: [152, 251, 152],
    paleturquoise: [175, 238, 238],
    palevioletred: [219, 112, 147],
    papayawhip: [255, 239, 213],
    peachpuff: [255, 218, 185],
    peru: [205, 133, 63],
    pink: [255, 192, 203],
    plum: [221, 160, 221],
    powderblue: [176, 224, 230],
    purple: [128, 0, 128],
    rebeccapurple: [102, 51, 153],
    red: [255, 0, 0],
    rosybrown: [188, 143, 143],
    royalblue: [65, 105, 225],
    saddlebrown: [139, 69, 19],
    salmon: [250, 128, 114],
    sandybrown: [244, 164, 96],
    seagreen: [46, 139, 87],
    seashell: [255, 245, 238],
    sienna: [160, 82, 45],
    silver: [192, 192, 192],
    skyblue: [135, 206, 235],
    slateblue: [106, 90, 205],
    slategray: [112, 128, 144],
    slategrey: [112, 128, 144],
    snow: [255, 250, 250],
    springgreen: [0, 255, 127],
    steelblue: [70, 130, 180],
    tan: [210, 180, 140],
    teal: [0, 128, 128],
    thistle: [216, 191, 216],
    tomato: [255, 99, 71],
    turquoise: [64, 224, 208],
    violet: [238, 130, 238],
    wheat: [245, 222, 179],
    white: [255, 255, 255],
    whitesmoke: [245, 245, 245],
    yellow: [255, 255, 0],
    yellowgreen: [154, 205, 50],
};

/**
 * Color representation used by WebGL.
 * Defined in sRGB color space and pre-blended with alpha.
 * @private
 */
class Color {
    /**
     * @param r Red component premultiplied by `alpha` 0..1
     * @param g Green component premultiplied by `alpha` 0..1
     * @param b Blue component premultiplied by `alpha` 0..1
     * @param [alpha=1] Alpha component 0..1
     * @param [premultiplied=true] Whether the `r`, `g` and `b` values have already
     * been multiplied by alpha. If `true` nothing happens if `false` then they will
     * be multiplied automatically.
     */
    constructor(r, g, b, alpha = 1, premultiplied = true) {
        this.r = r;
        this.g = g;
        this.b = b;
        this.a = alpha;
        if (!premultiplied) {
            this.r *= alpha;
            this.g *= alpha;
            this.b *= alpha;
            if (!alpha) {
                // alpha = 0 erases completely rgb channels. This behavior is not desirable
                // if this particular color is later used in color interpolation.
                // Because of that, a reference to original color is saved.
                this.overwriteGetter('rgb', [r, g, b, alpha]);
            }
        }
    }
    /**
     * Parses CSS color strings and converts colors to sRGB color space if needed.
     * Officially supported color formats:
     * - keyword, e.g. 'aquamarine' or 'steelblue'
     * - hex (with 3, 4, 6 or 8 digits), e.g. '#f0f' or '#e9bebea9'
     * - rgb and rgba, e.g. 'rgb(0,240,120)' or 'rgba(0%,94%,47%,0.1)' or 'rgb(0 240 120 / .3)'
     * - hsl and hsla, e.g. 'hsl(0,0%,83%)' or 'hsla(0,0%,83%,.5)' or 'hsl(0 0% 83% / 20%)'
     *
     * @param input CSS color string to parse.
     * @returns A `Color` instance, or `undefined` if the input is not a valid color string.
     */
    static parse(input) {
        // in zoom-and-property function input could be an instance of Color class
        if (input instanceof Color) {
            return input;
        }
        if (typeof input !== 'string') {
            return;
        }
        const rgba = parseCssColor(input);
        if (rgba) {
            return new Color(...rgba, false);
        }
    }
    /**
     * Used in color interpolation and by 'to-rgba' expression.
     *
     * @returns Gien color, with reversed alpha blending, in sRGB color space.
     */
    get rgb() {
        const { r, g, b, a } = this;
        const f = a || Infinity; // reverse alpha blending factor
        return this.overwriteGetter('rgb', [r / f, g / f, b / f, a]);
    }
    /**
     * Used in color interpolation.
     *
     * @returns Gien color, with reversed alpha blending, in HCL color space.
     */
    get hcl() {
        return this.overwriteGetter('hcl', rgbToHcl(this.rgb));
    }
    /**
     * Used in color interpolation.
     *
     * @returns Gien color, with reversed alpha blending, in LAB color space.
     */
    get lab() {
        return this.overwriteGetter('lab', rgbToLab(this.rgb));
    }
    /**
     * Lazy getter pattern. When getter is called for the first time lazy value
     * is calculated and then overwrites getter function in given object instance.
     *
     * @example:
     * const redColor = Color.parse('red');
     * let x = redColor.hcl; // this will invoke `get hcl()`, which will calculate
     * // the value of red in HCL space and invoke this `overwriteGetter` function
     * // which in turn will set a field with a key 'hcl' in the `redColor` object.
     * // In other words it will override `get hcl()` from its `Color` prototype
     * // with its own property: hcl = [calculated red value in hcl].
     * let y = redColor.hcl; // next call will no longer invoke getter but simply
     * // return the previously calculated value
     * x === y; // true - `x` is exactly the same object as `y`
     *
     * @param getterKey Getter key
     * @param lazyValue Lazily calculated value to be memoized by current instance
     * @private
     */
    overwriteGetter(getterKey, lazyValue) {
        Object.defineProperty(this, getterKey, { value: lazyValue });
        return lazyValue;
    }
    /**
     * Used by 'to-string' expression.
     *
     * @returns Serialized color in format `rgba(r,g,b,a)`
     * where r,g,b are numbers within 0..255 and alpha is number within 1..0
     *
     * @example
     * var purple = new Color.parse('purple');
     * purple.toString; // = "rgba(128,0,128,1)"
     * var translucentGreen = new Color.parse('rgba(26, 207, 26, .73)');
     * translucentGreen.toString(); // = "rgba(26,207,26,0.73)"
     */
    toString() {
        const [r, g, b, a] = this.rgb;
        return `rgba(${[r, g, b].map(n => Math.round(n * 255)).join(',')},${a})`;
    }
}
Color.black = new Color(0, 0, 0, 1);
Color.white = new Color(1, 1, 1, 1);
Color.transparent = new Color(0, 0, 0, 0);
Color.red = new Color(1, 0, 0, 1);

// Flow type declarations for Intl cribbed from
// https://github.com/facebook/flow/issues/1270
class Collator {
    constructor(caseSensitive, diacriticSensitive, locale) {
        if (caseSensitive)
            this.sensitivity = diacriticSensitive ? 'variant' : 'case';
        else
            this.sensitivity = diacriticSensitive ? 'accent' : 'base';
        this.locale = locale;
        this.collator = new Intl.Collator(this.locale ? this.locale : [], { sensitivity: this.sensitivity, usage: 'search' });
    }
    compare(lhs, rhs) {
        return this.collator.compare(lhs, rhs);
    }
    resolvedLocale() {
        // We create a Collator without "usage: search" because we don't want
        // the search options encoded in our result (e.g. "en-u-co-search")
        return new Intl.Collator(this.locale ? this.locale : [])
            .resolvedOptions().locale;
    }
}

class FormattedSection {
    constructor(text, image, scale, fontStack, textColor) {
        this.text = text;
        this.image = image;
        this.scale = scale;
        this.fontStack = fontStack;
        this.textColor = textColor;
    }
}
class Formatted {
    constructor(sections) {
        this.sections = sections;
    }
    static fromString(unformatted) {
        return new Formatted([new FormattedSection(unformatted, null, null, null, null)]);
    }
    isEmpty() {
        if (this.sections.length === 0)
            return true;
        return !this.sections.some(section => section.text.length !== 0 ||
            (section.image && section.image.name.length !== 0));
    }
    static factory(text) {
        if (text instanceof Formatted) {
            return text;
        }
        else {
            return Formatted.fromString(text);
        }
    }
    toString() {
        if (this.sections.length === 0)
            return '';
        return this.sections.map(section => section.text).join('');
    }
}

/**
 * A set of four numbers representing padding around a box. Create instances from
 * bare arrays or numeric values using the static method `Padding.parse`.
 * @private
 */
class Padding {
    constructor(values) {
        this.values = values.slice();
    }
    /**
     * Numeric padding values
     * @param input A padding value
     * @returns A `Padding` instance, or `undefined` if the input is not a valid padding value.
     */
    static parse(input) {
        if (input instanceof Padding) {
            return input;
        }
        // Backwards compatibility: bare number is treated the same as array with single value.
        // Padding applies to all four sides.
        if (typeof input === 'number') {
            return new Padding([input, input, input, input]);
        }
        if (!Array.isArray(input)) {
            return undefined;
        }
        if (input.length < 1 || input.length > 4) {
            return undefined;
        }
        for (const val of input) {
            if (typeof val !== 'number') {
                return undefined;
            }
        }
        // Expand shortcut properties into explicit 4-sided values
        switch (input.length) {
            case 1:
                input = [input[0], input[0], input[0], input[0]];
                break;
            case 2:
                input = [input[0], input[1], input[0], input[1]];
                break;
            case 3:
                input = [input[0], input[1], input[2], input[1]];
                break;
        }
        return new Padding(input);
    }
    toString() {
        return JSON.stringify(this.values);
    }
}

/** Set of valid anchor positions, as a set for validation */
const anchors = new Set(['center', 'left', 'right', 'top', 'bottom', 'top-left', 'top-right', 'bottom-left', 'bottom-right']);
/**
 * Utility class to assist managing values for text-variable-anchor-offset property. Create instances from
 * bare arrays using the static method `VariableAnchorOffsetCollection.parse`.
 * @private
 */
class VariableAnchorOffsetCollection {
    constructor(values) {
        this.values = values.slice();
    }
    static parse(input) {
        if (input instanceof VariableAnchorOffsetCollection) {
            return input;
        }
        if (!Array.isArray(input) ||
            input.length < 1 ||
            input.length % 2 !== 0) {
            return undefined;
        }
        for (let i = 0; i < input.length; i += 2) {
            // Elements in even positions should be anchor positions; Elements in odd positions should be offset values
            const anchorValue = input[i];
            const offsetValue = input[i + 1];
            if (typeof anchorValue !== 'string' || !anchors.has(anchorValue)) {
                return undefined;
            }
            if (!Array.isArray(offsetValue) || offsetValue.length !== 2 || typeof offsetValue[0] !== 'number' || typeof offsetValue[1] !== 'number') {
                return undefined;
            }
        }
        return new VariableAnchorOffsetCollection(input);
    }
    toString() {
        return JSON.stringify(this.values);
    }
}

class ResolvedImage {
    constructor(options) {
        this.name = options.name;
        this.available = options.available;
    }
    toString() {
        return this.name;
    }
    static fromString(name) {
        if (!name)
            return null; // treat empty values as no image
        return new ResolvedImage({ name, available: false });
    }
}

function validateRGBA(r, g, b, a) {
    if (!(typeof r === 'number' && r >= 0 && r <= 255 &&
        typeof g === 'number' && g >= 0 && g <= 255 &&
        typeof b === 'number' && b >= 0 && b <= 255)) {
        const value = typeof a === 'number' ? [r, g, b, a] : [r, g, b];
        return `Invalid rgba value [${value.join(', ')}]: 'r', 'g', and 'b' must be between 0 and 255.`;
    }
    if (!(typeof a === 'undefined' || (typeof a === 'number' && a >= 0 && a <= 1))) {
        return `Invalid rgba value [${[r, g, b, a].join(', ')}]: 'a' must be between 0 and 1.`;
    }
    return null;
}
function isValue(mixed) {
    if (mixed === null ||
        typeof mixed === 'string' ||
        typeof mixed === 'boolean' ||
        typeof mixed === 'number' ||
        mixed instanceof Color ||
        mixed instanceof Collator ||
        mixed instanceof Formatted ||
        mixed instanceof Padding ||
        mixed instanceof VariableAnchorOffsetCollection ||
        mixed instanceof ResolvedImage) {
        return true;
    }
    else if (Array.isArray(mixed)) {
        for (const item of mixed) {
            if (!isValue(item)) {
                return false;
            }
        }
        return true;
    }
    else if (typeof mixed === 'object') {
        for (const key in mixed) {
            if (!isValue(mixed[key])) {
                return false;
            }
        }
        return true;
    }
    else {
        return false;
    }
}
function typeOf(value) {
    if (value === null) {
        return NullType;
    }
    else if (typeof value === 'string') {
        return StringType;
    }
    else if (typeof value === 'boolean') {
        return BooleanType;
    }
    else if (typeof value === 'number') {
        return NumberType;
    }
    else if (value instanceof Color) {
        return ColorType;
    }
    else if (value instanceof Collator) {
        return CollatorType;
    }
    else if (value instanceof Formatted) {
        return FormattedType;
    }
    else if (value instanceof Padding) {
        return PaddingType;
    }
    else if (value instanceof VariableAnchorOffsetCollection) {
        return VariableAnchorOffsetCollectionType;
    }
    else if (value instanceof ResolvedImage) {
        return ResolvedImageType;
    }
    else if (Array.isArray(value)) {
        const length = value.length;
        let itemType;
        for (const item of value) {
            const t = typeOf(item);
            if (!itemType) {
                itemType = t;
            }
            else if (itemType === t) {
                continue;
            }
            else {
                itemType = ValueType;
                break;
            }
        }
        return array$1(itemType || ValueType, length);
    }
    else {
        return ObjectType;
    }
}
function toString(value) {
    const type = typeof value;
    if (value === null) {
        return '';
    }
    else if (type === 'string' || type === 'number' || type === 'boolean') {
        return String(value);
    }
    else if (value instanceof Color || value instanceof Formatted || value instanceof Padding || value instanceof VariableAnchorOffsetCollection || value instanceof ResolvedImage) {
        return value.toString();
    }
    else {
        return JSON.stringify(value);
    }
}

class Literal {
    constructor(type, value) {
        this.type = type;
        this.value = value;
    }
    static parse(args, context) {
        if (args.length !== 2)
            return context.error(`'literal' expression requires exactly one argument, but found ${args.length - 1} instead.`);
        if (!isValue(args[1]))
            return context.error('invalid value');
        const value = args[1];
        let type = typeOf(value);
        // special case: infer the item type if possible for zero-length arrays
        const expected = context.expectedType;
        if (type.kind === 'array' &&
            type.N === 0 &&
            expected &&
            expected.kind === 'array' &&
            (typeof expected.N !== 'number' || expected.N === 0)) {
            type = expected;
        }
        return new Literal(type, value);
    }
    evaluate() {
        return this.value;
    }
    eachChild() { }
    outputDefined() {
        return true;
    }
}

class RuntimeError {
    constructor(message) {
        this.name = 'ExpressionEvaluationError';
        this.message = message;
    }
    toJSON() {
        return this.message;
    }
}

const types$1 = {
    string: StringType,
    number: NumberType,
    boolean: BooleanType,
    object: ObjectType
};
class Assertion {
    constructor(type, args) {
        this.type = type;
        this.args = args;
    }
    static parse(args, context) {
        if (args.length < 2)
            return context.error('Expected at least one argument.');
        let i = 1;
        let type;
        const name = args[0];
        if (name === 'array') {
            let itemType;
            if (args.length > 2) {
                const type = args[1];
                if (typeof type !== 'string' || !(type in types$1) || type === 'object')
                    return context.error('The item type argument of "array" must be one of string, number, boolean', 1);
                itemType = types$1[type];
                i++;
            }
            else {
                itemType = ValueType;
            }
            let N;
            if (args.length > 3) {
                if (args[2] !== null &&
                    (typeof args[2] !== 'number' ||
                        args[2] < 0 ||
                        args[2] !== Math.floor(args[2]))) {
                    return context.error('The length argument to "array" must be a positive integer literal', 2);
                }
                N = args[2];
                i++;
            }
            type = array$1(itemType, N);
        }
        else {
            if (!types$1[name])
                throw new Error(`Types doesn't contain name = ${name}`);
            type = types$1[name];
        }
        const parsed = [];
        for (; i < args.length; i++) {
            const input = context.parse(args[i], i, ValueType);
            if (!input)
                return null;
            parsed.push(input);
        }
        return new Assertion(type, parsed);
    }
    evaluate(ctx) {
        for (let i = 0; i < this.args.length; i++) {
            const value = this.args[i].evaluate(ctx);
            const error = checkSubtype(this.type, typeOf(value));
            if (!error) {
                return value;
            }
            else if (i === this.args.length - 1) {
                throw new RuntimeError(`Expected value to be of type ${toString$1(this.type)}, but found ${toString$1(typeOf(value))} instead.`);
            }
        }
        throw new Error();
    }
    eachChild(fn) {
        this.args.forEach(fn);
    }
    outputDefined() {
        return this.args.every(arg => arg.outputDefined());
    }
}

const types = {
    'to-boolean': BooleanType,
    'to-color': ColorType,
    'to-number': NumberType,
    'to-string': StringType
};
/**
 * Special form for error-coalescing coercion expressions "to-number",
 * "to-color".  Since these coercions can fail at runtime, they accept multiple
 * arguments, only evaluating one at a time until one succeeds.
 *
 * @private
 */
class Coercion {
    constructor(type, args) {
        this.type = type;
        this.args = args;
    }
    static parse(args, context) {
        if (args.length < 2)
            return context.error('Expected at least one argument.');
        const name = args[0];
        if (!types[name])
            throw new Error(`Can't parse ${name} as it is not part of the known types`);
        if ((name === 'to-boolean' || name === 'to-string') && args.length !== 2)
            return context.error('Expected one argument.');
        const type = types[name];
        const parsed = [];
        for (let i = 1; i < args.length; i++) {
            const input = context.parse(args[i], i, ValueType);
            if (!input)
                return null;
            parsed.push(input);
        }
        return new Coercion(type, parsed);
    }
    evaluate(ctx) {
        switch (this.type.kind) {
            case 'boolean':
                return Boolean(this.args[0].evaluate(ctx));
            case 'color': {
                let input;
                let error;
                for (const arg of this.args) {
                    input = arg.evaluate(ctx);
                    error = null;
                    if (input instanceof Color) {
                        return input;
                    }
                    else if (typeof input === 'string') {
                        const c = ctx.parseColor(input);
                        if (c)
                            return c;
                    }
                    else if (Array.isArray(input)) {
                        if (input.length < 3 || input.length > 4) {
                            error = `Invalid rbga value ${JSON.stringify(input)}: expected an array containing either three or four numeric values.`;
                        }
                        else {
                            error = validateRGBA(input[0], input[1], input[2], input[3]);
                        }
                        if (!error) {
                            return new Color(input[0] / 255, input[1] / 255, input[2] / 255, input[3]);
                        }
                    }
                }
                throw new RuntimeError(error || `Could not parse color from value '${typeof input === 'string' ? input : JSON.stringify(input)}'`);
            }
            case 'padding': {
                let input;
                for (const arg of this.args) {
                    input = arg.evaluate(ctx);
                    const pad = Padding.parse(input);
                    if (pad) {
                        return pad;
                    }
                }
                throw new RuntimeError(`Could not parse padding from value '${typeof input === 'string' ? input : JSON.stringify(input)}'`);
            }
            case 'variableAnchorOffsetCollection': {
                let input;
                for (const arg of this.args) {
                    input = arg.evaluate(ctx);
                    const coll = VariableAnchorOffsetCollection.parse(input);
                    if (coll) {
                        return coll;
                    }
                }
                throw new RuntimeError(`Could not parse variableAnchorOffsetCollection from value '${typeof input === 'string' ? input : JSON.stringify(input)}'`);
            }
            case 'number': {
                let value = null;
                for (const arg of this.args) {
                    value = arg.evaluate(ctx);
                    if (value === null)
                        return 0;
                    const num = Number(value);
                    if (isNaN(num))
                        continue;
                    return num;
                }
                throw new RuntimeError(`Could not convert ${JSON.stringify(value)} to number.`);
            }
            case 'formatted':
                // There is no explicit 'to-formatted' but this coercion can be implicitly
                // created by properties that expect the 'formatted' type.
                return Formatted.fromString(toString(this.args[0].evaluate(ctx)));
            case 'resolvedImage':
                return ResolvedImage.fromString(toString(this.args[0].evaluate(ctx)));
            default:
                return toString(this.args[0].evaluate(ctx));
        }
    }
    eachChild(fn) {
        this.args.forEach(fn);
    }
    outputDefined() {
        return this.args.every(arg => arg.outputDefined());
    }
}

const geometryTypes = ['Unknown', 'Point', 'LineString', 'Polygon'];
class EvaluationContext {
    constructor() {
        this.globals = null;
        this.feature = null;
        this.featureState = null;
        this.formattedSection = null;
        this._parseColorCache = {};
        this.availableImages = null;
        this.canonical = null;
    }
    id() {
        return this.feature && 'id' in this.feature ? this.feature.id : null;
    }
    geometryType() {
        return this.feature ? typeof this.feature.type === 'number' ? geometryTypes[this.feature.type] : this.feature.type : null;
    }
    geometry() {
        return this.feature && 'geometry' in this.feature ? this.feature.geometry : null;
    }
    canonicalID() {
        return this.canonical;
    }
    properties() {
        return this.feature && this.feature.properties || {};
    }
    parseColor(input) {
        let cached = this._parseColorCache[input];
        if (!cached) {
            cached = this._parseColorCache[input] = Color.parse(input);
        }
        return cached;
    }
}

/**
 * State associated parsing at a given point in an expression tree.
 * @private
 */
class ParsingContext {
    constructor(registry, isConstantFunc, path = [], expectedType, scope = new Scope(), errors = []) {
        this.registry = registry;
        this.path = path;
        this.key = path.map(part => `[${part}]`).join('');
        this.scope = scope;
        this.errors = errors;
        this.expectedType = expectedType;
        this._isConstant = isConstantFunc;
    }
    /**
     * @param expr the JSON expression to parse
     * @param index the optional argument index if this expression is an argument of a parent expression that's being parsed
     * @param options
     * @param options.omitTypeAnnotations set true to omit inferred type annotations.  Caller beware: with this option set, the parsed expression's type will NOT satisfy `expectedType` if it would normally be wrapped in an inferred annotation.
     * @private
     */
    parse(expr, index, expectedType, bindings, options = {}) {
        if (index) {
            return this.concat(index, expectedType, bindings)._parse(expr, options);
        }
        return this._parse(expr, options);
    }
    _parse(expr, options) {
        if (expr === null || typeof expr === 'string' || typeof expr === 'boolean' || typeof expr === 'number') {
            expr = ['literal', expr];
        }
        function annotate(parsed, type, typeAnnotation) {
            if (typeAnnotation === 'assert') {
                return new Assertion(type, [parsed]);
            }
            else if (typeAnnotation === 'coerce') {
                return new Coercion(type, [parsed]);
            }
            else {
                return parsed;
            }
        }
        if (Array.isArray(expr)) {
            if (expr.length === 0) {
                return this.error('Expected an array with at least one element. If you wanted a literal array, use ["literal", []].');
            }
            const op = expr[0];
            if (typeof op !== 'string') {
                this.error(`Expression name must be a string, but found ${typeof op} instead. If you wanted a literal array, use ["literal", [...]].`, 0);
                return null;
            }
            const Expr = this.registry[op];
            if (Expr) {
                let parsed = Expr.parse(expr, this);
                if (!parsed)
                    return null;
                if (this.expectedType) {
                    const expected = this.expectedType;
                    const actual = parsed.type;
                    // When we expect a number, string, boolean, or array but have a value, wrap it in an assertion.
                    // When we expect a color or formatted string, but have a string or value, wrap it in a coercion.
                    // Otherwise, we do static type-checking.
                    //
                    // These behaviors are overridable for:
                    //   * The "coalesce" operator, which needs to omit type annotations.
                    //   * String-valued properties (e.g. `text-field`), where coercion is more convenient than assertion.
                    //
                    if ((expected.kind === 'string' || expected.kind === 'number' || expected.kind === 'boolean' || expected.kind === 'object' || expected.kind === 'array') && actual.kind === 'value') {
                        parsed = annotate(parsed, expected, options.typeAnnotation || 'assert');
                    }
                    else if ((expected.kind === 'color' || expected.kind === 'formatted' || expected.kind === 'resolvedImage') && (actual.kind === 'value' || actual.kind === 'string')) {
                        parsed = annotate(parsed, expected, options.typeAnnotation || 'coerce');
                    }
                    else if (expected.kind === 'padding' && (actual.kind === 'value' || actual.kind === 'number' || actual.kind === 'array')) {
                        parsed = annotate(parsed, expected, options.typeAnnotation || 'coerce');
                    }
                    else if (expected.kind === 'variableAnchorOffsetCollection' && (actual.kind === 'value' || actual.kind === 'array')) {
                        parsed = annotate(parsed, expected, options.typeAnnotation || 'coerce');
                    }
                    else if (this.checkSubtype(expected, actual)) {
                        return null;
                    }
                }
                // If an expression's arguments are all literals, we can evaluate
                // it immediately and replace it with a literal value in the
                // parsed/compiled result. Expressions that expect an image should
                // not be resolved here so we can later get the available images.
                if (!(parsed instanceof Literal) && (parsed.type.kind !== 'resolvedImage') && this._isConstant(parsed)) {
                    const ec = new EvaluationContext();
                    try {
                        parsed = new Literal(parsed.type, parsed.evaluate(ec));
                    }
                    catch (e) {
                        this.error(e.message);
                        return null;
                    }
                }
                return parsed;
            }
            return this.error(`Unknown expression "${op}". If you wanted a literal array, use ["literal", [...]].`, 0);
        }
        else if (typeof expr === 'undefined') {
            return this.error('\'undefined\' value invalid. Use null instead.');
        }
        else if (typeof expr === 'object') {
            return this.error('Bare objects invalid. Use ["literal", {...}] instead.');
        }
        else {
            return this.error(`Expected an array, but found ${typeof expr} instead.`);
        }
    }
    /**
     * Returns a copy of this context suitable for parsing the subexpression at
     * index `index`, optionally appending to 'let' binding map.
     *
     * Note that `errors` property, intended for collecting errors while
     * parsing, is copied by reference rather than cloned.
     * @private
     */
    concat(index, expectedType, bindings) {
        const path = typeof index === 'number' ? this.path.concat(index) : this.path;
        const scope = bindings ? this.scope.concat(bindings) : this.scope;
        return new ParsingContext(this.registry, this._isConstant, path, expectedType || null, scope, this.errors);
    }
    /**
     * Push a parsing (or type checking) error into the `this.errors`
     * @param error The message
     * @param keys Optionally specify the source of the error at a child
     * of the current expression at `this.key`.
     * @private
     */
    error(error, ...keys) {
        const key = `${this.key}${keys.map(k => `[${k}]`).join('')}`;
        this.errors.push(new ExpressionParsingError(key, error));
    }
    /**
     * Returns null if `t` is a subtype of `expected`; otherwise returns an
     * error message and also pushes it to `this.errors`.
     * @param expected The expected type
     * @param t The actual type
     * @returns null if `t` is a subtype of `expected`; otherwise returns an error message
     */
    checkSubtype(expected, t) {
        const error = checkSubtype(expected, t);
        if (error)
            this.error(error);
        return error;
    }
}

class Let {
    constructor(bindings, result) {
        this.type = result.type;
        this.bindings = [].concat(bindings);
        this.result = result;
    }
    evaluate(ctx) {
        return this.result.evaluate(ctx);
    }
    eachChild(fn) {
        for (const binding of this.bindings) {
            fn(binding[1]);
        }
        fn(this.result);
    }
    static parse(args, context) {
        if (args.length < 4)
            return context.error(`Expected at least 3 arguments, but found ${args.length - 1} instead.`);
        const bindings = [];
        for (let i = 1; i < args.length - 1; i += 2) {
            const name = args[i];
            if (typeof name !== 'string') {
                return context.error(`Expected string, but found ${typeof name} instead.`, i);
            }
            if (/[^a-zA-Z0-9_]/.test(name)) {
                return context.error('Variable names must contain only alphanumeric characters or \'_\'.', i);
            }
            const value = context.parse(args[i + 1], i + 1);
            if (!value)
                return null;
            bindings.push([name, value]);
        }
        const result = context.parse(args[args.length - 1], args.length - 1, context.expectedType, bindings);
        if (!result)
            return null;
        return new Let(bindings, result);
    }
    outputDefined() {
        return this.result.outputDefined();
    }
}

class Var {
    constructor(name, boundExpression) {
        this.type = boundExpression.type;
        this.name = name;
        this.boundExpression = boundExpression;
    }
    static parse(args, context) {
        if (args.length !== 2 || typeof args[1] !== 'string')
            return context.error('\'var\' expression requires exactly one string literal argument.');
        const name = args[1];
        if (!context.scope.has(name)) {
            return context.error(`Unknown variable "${name}". Make sure "${name}" has been bound in an enclosing "let" expression before using it.`, 1);
        }
        return new Var(name, context.scope.get(name));
    }
    evaluate(ctx) {
        return this.boundExpression.evaluate(ctx);
    }
    eachChild() { }
    outputDefined() {
        return false;
    }
}

class At {
    constructor(type, index, input) {
        this.type = type;
        this.index = index;
        this.input = input;
    }
    static parse(args, context) {
        if (args.length !== 3)
            return context.error(`Expected 2 arguments, but found ${args.length - 1} instead.`);
        const index = context.parse(args[1], 1, NumberType);
        const input = context.parse(args[2], 2, array$1(context.expectedType || ValueType));
        if (!index || !input)
            return null;
        const t = input.type;
        return new At(t.itemType, index, input);
    }
    evaluate(ctx) {
        const index = this.index.evaluate(ctx);
        const array = this.input.evaluate(ctx);
        if (index < 0) {
            throw new RuntimeError(`Array index out of bounds: ${index} < 0.`);
        }
        if (index >= array.length) {
            throw new RuntimeError(`Array index out of bounds: ${index} > ${array.length - 1}.`);
        }
        if (index !== Math.floor(index)) {
            throw new RuntimeError(`Array index must be an integer, but found ${index} instead.`);
        }
        return array[index];
    }
    eachChild(fn) {
        fn(this.index);
        fn(this.input);
    }
    outputDefined() {
        return false;
    }
}

class In {
    constructor(needle, haystack) {
        this.type = BooleanType;
        this.needle = needle;
        this.haystack = haystack;
    }
    static parse(args, context) {
        if (args.length !== 3) {
            return context.error(`Expected 2 arguments, but found ${args.length - 1} instead.`);
        }
        const needle = context.parse(args[1], 1, ValueType);
        const haystack = context.parse(args[2], 2, ValueType);
        if (!needle || !haystack)
            return null;
        if (!isValidType(needle.type, [BooleanType, StringType, NumberType, NullType, ValueType])) {
            return context.error(`Expected first argument to be of type boolean, string, number or null, but found ${toString$1(needle.type)} instead`);
        }
        return new In(needle, haystack);
    }
    evaluate(ctx) {
        const needle = this.needle.evaluate(ctx);
        const haystack = this.haystack.evaluate(ctx);
        if (!haystack)
            return false;
        if (!isValidNativeType(needle, ['boolean', 'string', 'number', 'null'])) {
            throw new RuntimeError(`Expected first argument to be of type boolean, string, number or null, but found ${toString$1(typeOf(needle))} instead.`);
        }
        if (!isValidNativeType(haystack, ['string', 'array'])) {
            throw new RuntimeError(`Expected second argument to be of type array or string, but found ${toString$1(typeOf(haystack))} instead.`);
        }
        return haystack.indexOf(needle) >= 0;
    }
    eachChild(fn) {
        fn(this.needle);
        fn(this.haystack);
    }
    outputDefined() {
        return true;
    }
}

class IndexOf {
    constructor(needle, haystack, fromIndex) {
        this.type = NumberType;
        this.needle = needle;
        this.haystack = haystack;
        this.fromIndex = fromIndex;
    }
    static parse(args, context) {
        if (args.length <= 2 || args.length >= 5) {
            return context.error(`Expected 3 or 4 arguments, but found ${args.length - 1} instead.`);
        }
        const needle = context.parse(args[1], 1, ValueType);
        const haystack = context.parse(args[2], 2, ValueType);
        if (!needle || !haystack)
            return null;
        if (!isValidType(needle.type, [BooleanType, StringType, NumberType, NullType, ValueType])) {
            return context.error(`Expected first argument to be of type boolean, string, number or null, but found ${toString$1(needle.type)} instead`);
        }
        if (args.length === 4) {
            const fromIndex = context.parse(args[3], 3, NumberType);
            if (!fromIndex)
                return null;
            return new IndexOf(needle, haystack, fromIndex);
        }
        else {
            return new IndexOf(needle, haystack);
        }
    }
    evaluate(ctx) {
        const needle = this.needle.evaluate(ctx);
        const haystack = this.haystack.evaluate(ctx);
        if (!isValidNativeType(needle, ['boolean', 'string', 'number', 'null'])) {
            throw new RuntimeError(`Expected first argument to be of type boolean, string, number or null, but found ${toString$1(typeOf(needle))} instead.`);
        }
        if (!isValidNativeType(haystack, ['string', 'array'])) {
            throw new RuntimeError(`Expected second argument to be of type array or string, but found ${toString$1(typeOf(haystack))} instead.`);
        }
        if (this.fromIndex) {
            const fromIndex = this.fromIndex.evaluate(ctx);
            return haystack.indexOf(needle, fromIndex);
        }
        return haystack.indexOf(needle);
    }
    eachChild(fn) {
        fn(this.needle);
        fn(this.haystack);
        if (this.fromIndex) {
            fn(this.fromIndex);
        }
    }
    outputDefined() {
        return false;
    }
}

class Match {
    constructor(inputType, outputType, input, cases, outputs, otherwise) {
        this.inputType = inputType;
        this.type = outputType;
        this.input = input;
        this.cases = cases;
        this.outputs = outputs;
        this.otherwise = otherwise;
    }
    static parse(args, context) {
        if (args.length < 5)
            return context.error(`Expected at least 4 arguments, but found only ${args.length - 1}.`);
        if (args.length % 2 !== 1)
            return context.error('Expected an even number of arguments.');
        let inputType;
        let outputType;
        if (context.expectedType && context.expectedType.kind !== 'value') {
            outputType = context.expectedType;
        }
        const cases = {};
        const outputs = [];
        for (let i = 2; i < args.length - 1; i += 2) {
            let labels = args[i];
            const value = args[i + 1];
            if (!Array.isArray(labels)) {
                labels = [labels];
            }
            const labelContext = context.concat(i);
            if (labels.length === 0) {
                return labelContext.error('Expected at least one branch label.');
            }
            for (const label of labels) {
                if (typeof label !== 'number' && typeof label !== 'string') {
                    return labelContext.error('Branch labels must be numbers or strings.');
                }
                else if (typeof label === 'number' && Math.abs(label) > Number.MAX_SAFE_INTEGER) {
                    return labelContext.error(`Branch labels must be integers no larger than ${Number.MAX_SAFE_INTEGER}.`);
                }
                else if (typeof label === 'number' && Math.floor(label) !== label) {
                    return labelContext.error('Numeric branch labels must be integer values.');
                }
                else if (!inputType) {
                    inputType = typeOf(label);
                }
                else if (labelContext.checkSubtype(inputType, typeOf(label))) {
                    return null;
                }
                if (typeof cases[String(label)] !== 'undefined') {
                    return labelContext.error('Branch labels must be unique.');
                }
                cases[String(label)] = outputs.length;
            }
            const result = context.parse(value, i, outputType);
            if (!result)
                return null;
            outputType = outputType || result.type;
            outputs.push(result);
        }
        const input = context.parse(args[1], 1, ValueType);
        if (!input)
            return null;
        const otherwise = context.parse(args[args.length - 1], args.length - 1, outputType);
        if (!otherwise)
            return null;
        if (input.type.kind !== 'value' && context.concat(1).checkSubtype(inputType, input.type)) {
            return null;
        }
        return new Match(inputType, outputType, input, cases, outputs, otherwise);
    }
    evaluate(ctx) {
        const input = this.input.evaluate(ctx);
        const output = (typeOf(input) === this.inputType && this.outputs[this.cases[input]]) || this.otherwise;
        return output.evaluate(ctx);
    }
    eachChild(fn) {
        fn(this.input);
        this.outputs.forEach(fn);
        fn(this.otherwise);
    }
    outputDefined() {
        return this.outputs.every(out => out.outputDefined()) && this.otherwise.outputDefined();
    }
}

class Case {
    constructor(type, branches, otherwise) {
        this.type = type;
        this.branches = branches;
        this.otherwise = otherwise;
    }
    static parse(args, context) {
        if (args.length < 4)
            return context.error(`Expected at least 3 arguments, but found only ${args.length - 1}.`);
        if (args.length % 2 !== 0)
            return context.error('Expected an odd number of arguments.');
        let outputType;
        if (context.expectedType && context.expectedType.kind !== 'value') {
            outputType = context.expectedType;
        }
        const branches = [];
        for (let i = 1; i < args.length - 1; i += 2) {
            const test = context.parse(args[i], i, BooleanType);
            if (!test)
                return null;
            const result = context.parse(args[i + 1], i + 1, outputType);
            if (!result)
                return null;
            branches.push([test, result]);
            outputType = outputType || result.type;
        }
        const otherwise = context.parse(args[args.length - 1], args.length - 1, outputType);
        if (!otherwise)
            return null;
        if (!outputType)
            throw new Error('Can\'t infer output type');
        return new Case(outputType, branches, otherwise);
    }
    evaluate(ctx) {
        for (const [test, expression] of this.branches) {
            if (test.evaluate(ctx)) {
                return expression.evaluate(ctx);
            }
        }
        return this.otherwise.evaluate(ctx);
    }
    eachChild(fn) {
        for (const [test, expression] of this.branches) {
            fn(test);
            fn(expression);
        }
        fn(this.otherwise);
    }
    outputDefined() {
        return this.branches.every(([_, out]) => out.outputDefined()) && this.otherwise.outputDefined();
    }
}

class Slice {
    constructor(type, input, beginIndex, endIndex) {
        this.type = type;
        this.input = input;
        this.beginIndex = beginIndex;
        this.endIndex = endIndex;
    }
    static parse(args, context) {
        if (args.length <= 2 || args.length >= 5) {
            return context.error(`Expected 3 or 4 arguments, but found ${args.length - 1} instead.`);
        }
        const input = context.parse(args[1], 1, ValueType);
        const beginIndex = context.parse(args[2], 2, NumberType);
        if (!input || !beginIndex)
            return null;
        if (!isValidType(input.type, [array$1(ValueType), StringType, ValueType])) {
            return context.error(`Expected first argument to be of type array or string, but found ${toString$1(input.type)} instead`);
        }
        if (args.length === 4) {
            const endIndex = context.parse(args[3], 3, NumberType);
            if (!endIndex)
                return null;
            return new Slice(input.type, input, beginIndex, endIndex);
        }
        else {
            return new Slice(input.type, input, beginIndex);
        }
    }
    evaluate(ctx) {
        const input = this.input.evaluate(ctx);
        const beginIndex = this.beginIndex.evaluate(ctx);
        if (!isValidNativeType(input, ['string', 'array'])) {
            throw new RuntimeError(`Expected first argument to be of type array or string, but found ${toString$1(typeOf(input))} instead.`);
        }
        if (this.endIndex) {
            const endIndex = this.endIndex.evaluate(ctx);
            return input.slice(beginIndex, endIndex);
        }
        return input.slice(beginIndex);
    }
    eachChild(fn) {
        fn(this.input);
        fn(this.beginIndex);
        if (this.endIndex) {
            fn(this.endIndex);
        }
    }
    outputDefined() {
        return false;
    }
}

/**
 * Returns the index of the last stop <= input, or 0 if it doesn't exist.
 * @private
 */
function findStopLessThanOrEqualTo(stops, input) {
    const lastIndex = stops.length - 1;
    let lowerIndex = 0;
    let upperIndex = lastIndex;
    let currentIndex = 0;
    let currentValue, nextValue;
    while (lowerIndex <= upperIndex) {
        currentIndex = Math.floor((lowerIndex + upperIndex) / 2);
        currentValue = stops[currentIndex];
        nextValue = stops[currentIndex + 1];
        if (currentValue <= input) {
            if (currentIndex === lastIndex || input < nextValue) { // Search complete
                return currentIndex;
            }
            lowerIndex = currentIndex + 1;
        }
        else if (currentValue > input) {
            upperIndex = currentIndex - 1;
        }
        else {
            throw new RuntimeError('Input is not a number.');
        }
    }
    return 0;
}

class Step {
    constructor(type, input, stops) {
        this.type = type;
        this.input = input;
        this.labels = [];
        this.outputs = [];
        for (const [label, expression] of stops) {
            this.labels.push(label);
            this.outputs.push(expression);
        }
    }
    static parse(args, context) {
        if (args.length - 1 < 4) {
            return context.error(`Expected at least 4 arguments, but found only ${args.length - 1}.`);
        }
        if ((args.length - 1) % 2 !== 0) {
            return context.error('Expected an even number of arguments.');
        }
        const input = context.parse(args[1], 1, NumberType);
        if (!input)
            return null;
        const stops = [];
        let outputType = null;
        if (context.expectedType && context.expectedType.kind !== 'value') {
            outputType = context.expectedType;
        }
        for (let i = 1; i < args.length; i += 2) {
            const label = i === 1 ? -Infinity : args[i];
            const value = args[i + 1];
            const labelKey = i;
            const valueKey = i + 1;
            if (typeof label !== 'number') {
                return context.error('Input/output pairs for "step" expressions must be defined using literal numeric values (not computed expressions) for the input values.', labelKey);
            }
            if (stops.length && stops[stops.length - 1][0] >= label) {
                return context.error('Input/output pairs for "step" expressions must be arranged with input values in strictly ascending order.', labelKey);
            }
            const parsed = context.parse(value, valueKey, outputType);
            if (!parsed)
                return null;
            outputType = outputType || parsed.type;
            stops.push([label, parsed]);
        }
        return new Step(outputType, input, stops);
    }
    evaluate(ctx) {
        const labels = this.labels;
        const outputs = this.outputs;
        if (labels.length === 1) {
            return outputs[0].evaluate(ctx);
        }
        const value = this.input.evaluate(ctx);
        if (value <= labels[0]) {
            return outputs[0].evaluate(ctx);
        }
        const stopCount = labels.length;
        if (value >= labels[stopCount - 1]) {
            return outputs[stopCount - 1].evaluate(ctx);
        }
        const index = findStopLessThanOrEqualTo(labels, value);
        return outputs[index].evaluate(ctx);
    }
    eachChild(fn) {
        fn(this.input);
        for (const expression of this.outputs) {
            fn(expression);
        }
    }
    outputDefined() {
        return this.outputs.every(out => out.outputDefined());
    }
}

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var unitbezier = UnitBezier;

function UnitBezier(p1x, p1y, p2x, p2y) {
    // Calculate the polynomial coefficients, implicit first and last control points are (0,0) and (1,1).
    this.cx = 3.0 * p1x;
    this.bx = 3.0 * (p2x - p1x) - this.cx;
    this.ax = 1.0 - this.cx - this.bx;

    this.cy = 3.0 * p1y;
    this.by = 3.0 * (p2y - p1y) - this.cy;
    this.ay = 1.0 - this.cy - this.by;

    this.p1x = p1x;
    this.p1y = p1y;
    this.p2x = p2x;
    this.p2y = p2y;
}

UnitBezier.prototype = {
    sampleCurveX: function (t) {
        // `ax t^3 + bx t^2 + cx t' expanded using Horner's rule.
        return ((this.ax * t + this.bx) * t + this.cx) * t;
    },

    sampleCurveY: function (t) {
        return ((this.ay * t + this.by) * t + this.cy) * t;
    },

    sampleCurveDerivativeX: function (t) {
        return (3.0 * this.ax * t + 2.0 * this.bx) * t + this.cx;
    },

    solveCurveX: function (x, epsilon) {
        if (epsilon === undefined) epsilon = 1e-6;

        if (x < 0.0) return 0.0;
        if (x > 1.0) return 1.0;

        var t = x;

        // First try a few iterations of Newton's method - normally very fast.
        for (var i = 0; i < 8; i++) {
            var x2 = this.sampleCurveX(t) - x;
            if (Math.abs(x2) < epsilon) return t;

            var d2 = this.sampleCurveDerivativeX(t);
            if (Math.abs(d2) < 1e-6) break;

            t = t - x2 / d2;
        }

        // Fall back to the bisection method for reliability.
        var t0 = 0.0;
        var t1 = 1.0;
        t = x;

        for (i = 0; i < 20; i++) {
            x2 = this.sampleCurveX(t);
            if (Math.abs(x2 - x) < epsilon) break;

            if (x > x2) {
                t0 = t;
            } else {
                t1 = t;
            }

            t = (t1 - t0) * 0.5 + t0;
        }

        return t;
    },

    solve: function (x, epsilon) {
        return this.sampleCurveY(this.solveCurveX(x, epsilon));
    }
};

var UnitBezier$1 = /*@__PURE__*/getDefaultExportFromCjs(unitbezier);

/**
 * Checks whether the specified color space is one of the supported interpolation color spaces.
 *
 * @param colorSpace Color space key to verify.
 * @returns `true` if the specified color space is one of the supported
 * interpolation color spaces, `false` otherwise
 */
function isSupportedInterpolationColorSpace(colorSpace) {
    return colorSpace === 'rgb' || colorSpace === 'hcl' || colorSpace === 'lab';
}
function number(from, to, t) {
    return from + t * (to - from);
}
function color(from, to, t, spaceKey = 'rgb') {
    switch (spaceKey) {
        case 'rgb': {
            const [r, g, b, alpha] = array(from.rgb, to.rgb, t);
            return new Color(r, g, b, alpha, false);
        }
        case 'hcl': {
            const [hue0, chroma0, light0, alphaF] = from.hcl;
            const [hue1, chroma1, light1, alphaT] = to.hcl;
            // https://github.com/gka/chroma.js/blob/cd1b3c0926c7a85cbdc3b1453b3a94006de91a92/src/interpolator/_hsx.js
            let hue, chroma;
            if (!isNaN(hue0) && !isNaN(hue1)) {
                let dh = hue1 - hue0;
                if (hue1 > hue0 && dh > 180) {
                    dh -= 360;
                }
                else if (hue1 < hue0 && hue0 - hue1 > 180) {
                    dh += 360;
                }
                hue = hue0 + t * dh;
            }
            else if (!isNaN(hue0)) {
                hue = hue0;
                if (light1 === 1 || light1 === 0)
                    chroma = chroma0;
            }
            else if (!isNaN(hue1)) {
                hue = hue1;
                if (light0 === 1 || light0 === 0)
                    chroma = chroma1;
            }
            else {
                hue = NaN;
            }
            const [r, g, b, alpha] = hclToRgb([
                hue,
                chroma !== null && chroma !== void 0 ? chroma : number(chroma0, chroma1, t),
                number(light0, light1, t),
                number(alphaF, alphaT, t),
            ]);
            return new Color(r, g, b, alpha, false);
        }
        case 'lab': {
            const [r, g, b, alpha] = labToRgb(array(from.lab, to.lab, t));
            return new Color(r, g, b, alpha, false);
        }
    }
}
function array(from, to, t) {
    return from.map((d, i) => {
        return number(d, to[i], t);
    });
}
function padding(from, to, t) {
    return new Padding(array(from.values, to.values, t));
}
function variableAnchorOffsetCollection(from, to, t) {
    const fromValues = from.values;
    const toValues = to.values;
    if (fromValues.length !== toValues.length) {
        throw new RuntimeError(`Cannot interpolate values of different length. from: ${from.toString()}, to: ${to.toString()}`);
    }
    const output = [];
    for (let i = 0; i < fromValues.length; i += 2) {
        // Anchor entries must match
        if (fromValues[i] !== toValues[i]) {
            throw new RuntimeError(`Cannot interpolate values containing mismatched anchors. from[${i}]: ${fromValues[i]}, to[${i}]: ${toValues[i]}`);
        }
        output.push(fromValues[i]);
        // Interpolate the offset values for each anchor
        const [fx, fy] = fromValues[i + 1];
        const [tx, ty] = toValues[i + 1];
        output.push([number(fx, tx, t), number(fy, ty, t)]);
    }
    return new VariableAnchorOffsetCollection(output);
}
const interpolate = {
    number,
    color,
    array,
    padding,
    variableAnchorOffsetCollection
};

class Interpolate {
    constructor(type, operator, interpolation, input, stops) {
        this.type = type;
        this.operator = operator;
        this.interpolation = interpolation;
        this.input = input;
        this.labels = [];
        this.outputs = [];
        for (const [label, expression] of stops) {
            this.labels.push(label);
            this.outputs.push(expression);
        }
    }
    static interpolationFactor(interpolation, input, lower, upper) {
        let t = 0;
        if (interpolation.name === 'exponential') {
            t = exponentialInterpolation(input, interpolation.base, lower, upper);
        }
        else if (interpolation.name === 'linear') {
            t = exponentialInterpolation(input, 1, lower, upper);
        }
        else if (interpolation.name === 'cubic-bezier') {
            const c = interpolation.controlPoints;
            const ub = new UnitBezier$1(c[0], c[1], c[2], c[3]);
            t = ub.solve(exponentialInterpolation(input, 1, lower, upper));
        }
        return t;
    }
    static parse(args, context) {
        let [operator, interpolation, input, ...rest] = args;
        if (!Array.isArray(interpolation) || interpolation.length === 0) {
            return context.error('Expected an interpolation type expression.', 1);
        }
        if (interpolation[0] === 'linear') {
            interpolation = { name: 'linear' };
        }
        else if (interpolation[0] === 'exponential') {
            const base = interpolation[1];
            if (typeof base !== 'number')
                return context.error('Exponential interpolation requires a numeric base.', 1, 1);
            interpolation = {
                name: 'exponential',
                base
            };
        }
        else if (interpolation[0] === 'cubic-bezier') {
            const controlPoints = interpolation.slice(1);
            if (controlPoints.length !== 4 ||
                controlPoints.some(t => typeof t !== 'number' || t < 0 || t > 1)) {
                return context.error('Cubic bezier interpolation requires four numeric arguments with values between 0 and 1.', 1);
            }
            interpolation = {
                name: 'cubic-bezier',
                controlPoints: controlPoints
            };
        }
        else {
            return context.error(`Unknown interpolation type ${String(interpolation[0])}`, 1, 0);
        }
        if (args.length - 1 < 4) {
            return context.error(`Expected at least 4 arguments, but found only ${args.length - 1}.`);
        }
        if ((args.length - 1) % 2 !== 0) {
            return context.error('Expected an even number of arguments.');
        }
        input = context.parse(input, 2, NumberType);
        if (!input)
            return null;
        const stops = [];
        let outputType = null;
        if (operator === 'interpolate-hcl' || operator === 'interpolate-lab') {
            outputType = ColorType;
        }
        else if (context.expectedType && context.expectedType.kind !== 'value') {
            outputType = context.expectedType;
        }
        for (let i = 0; i < rest.length; i += 2) {
            const label = rest[i];
            const value = rest[i + 1];
            const labelKey = i + 3;
            const valueKey = i + 4;
            if (typeof label !== 'number') {
                return context.error('Input/output pairs for "interpolate" expressions must be defined using literal numeric values (not computed expressions) for the input values.', labelKey);
            }
            if (stops.length && stops[stops.length - 1][0] >= label) {
                return context.error('Input/output pairs for "interpolate" expressions must be arranged with input values in strictly ascending order.', labelKey);
            }
            const parsed = context.parse(value, valueKey, outputType);
            if (!parsed)
                return null;
            outputType = outputType || parsed.type;
            stops.push([label, parsed]);
        }
        if (!verifyType(outputType, NumberType) &&
            !verifyType(outputType, ColorType) &&
            !verifyType(outputType, PaddingType) &&
            !verifyType(outputType, VariableAnchorOffsetCollectionType) &&
            !verifyType(outputType, array$1(NumberType))) {
            return context.error(`Type ${toString$1(outputType)} is not interpolatable.`);
        }
        return new Interpolate(outputType, operator, interpolation, input, stops);
    }
    evaluate(ctx) {
        const labels = this.labels;
        const outputs = this.outputs;
        if (labels.length === 1) {
            return outputs[0].evaluate(ctx);
        }
        const value = this.input.evaluate(ctx);
        if (value <= labels[0]) {
            return outputs[0].evaluate(ctx);
        }
        const stopCount = labels.length;
        if (value >= labels[stopCount - 1]) {
            return outputs[stopCount - 1].evaluate(ctx);
        }
        const index = findStopLessThanOrEqualTo(labels, value);
        const lower = labels[index];
        const upper = labels[index + 1];
        const t = Interpolate.interpolationFactor(this.interpolation, value, lower, upper);
        const outputLower = outputs[index].evaluate(ctx);
        const outputUpper = outputs[index + 1].evaluate(ctx);
        switch (this.operator) {
            case 'interpolate':
                return interpolate[this.type.kind](outputLower, outputUpper, t);
            case 'interpolate-hcl':
                return interpolate.color(outputLower, outputUpper, t, 'hcl');
            case 'interpolate-lab':
                return interpolate.color(outputLower, outputUpper, t, 'lab');
        }
    }
    eachChild(fn) {
        fn(this.input);
        for (const expression of this.outputs) {
            fn(expression);
        }
    }
    outputDefined() {
        return this.outputs.every(out => out.outputDefined());
    }
}
/**
 * Returns a ratio that can be used to interpolate between exponential function
 * stops.
 * How it works: Two consecutive stop values define a (scaled and shifted) exponential function `f(x) = a * base^x + b`, where `base` is the user-specified base,
 * and `a` and `b` are constants affording sufficient degrees of freedom to fit
 * the function to the given stops.
 *
 * Here's a bit of algebra that lets us compute `f(x)` directly from the stop
 * values without explicitly solving for `a` and `b`:
 *
 * First stop value: `f(x0) = y0 = a * base^x0 + b`
 * Second stop value: `f(x1) = y1 = a * base^x1 + b`
 * => `y1 - y0 = a(base^x1 - base^x0)`
 * => `a = (y1 - y0)/(base^x1 - base^x0)`
 *
 * Desired value: `f(x) = y = a * base^x + b`
 * => `f(x) = y0 + a * (base^x - base^x0)`
 *
 * From the above, we can replace the `a` in `a * (base^x - base^x0)` and do a
 * little algebra:
 * ```
 * a * (base^x - base^x0) = (y1 - y0)/(base^x1 - base^x0) * (base^x - base^x0)
 *                     = (y1 - y0) * (base^x - base^x0) / (base^x1 - base^x0)
 * ```
 *
 * If we let `(base^x - base^x0) / (base^x1 base^x0)`, then we have
 * `f(x) = y0 + (y1 - y0) * ratio`.  In other words, `ratio` may be treated as
 * an interpolation factor between the two stops' output values.
 *
 * (Note: a slightly different form for `ratio`,
 * `(base^(x-x0) - 1) / (base^(x1-x0) - 1) `, is equivalent, but requires fewer
 * expensive `Math.pow()` operations.)
 *
 * @private
*/
function exponentialInterpolation(input, base, lowerValue, upperValue) {
    const difference = upperValue - lowerValue;
    const progress = input - lowerValue;
    if (difference === 0) {
        return 0;
    }
    else if (base === 1) {
        return progress / difference;
    }
    else {
        return (Math.pow(base, progress) - 1) / (Math.pow(base, difference) - 1);
    }
}

class Coalesce {
    constructor(type, args) {
        this.type = type;
        this.args = args;
    }
    static parse(args, context) {
        if (args.length < 2) {
            return context.error('Expectected at least one argument.');
        }
        let outputType = null;
        const expectedType = context.expectedType;
        if (expectedType && expectedType.kind !== 'value') {
            outputType = expectedType;
        }
        const parsedArgs = [];
        for (const arg of args.slice(1)) {
            const parsed = context.parse(arg, 1 + parsedArgs.length, outputType, undefined, { typeAnnotation: 'omit' });
            if (!parsed)
                return null;
            outputType = outputType || parsed.type;
            parsedArgs.push(parsed);
        }
        if (!outputType)
            throw new Error('No output type');
        // Above, we parse arguments without inferred type annotation so that
        // they don't produce a runtime error for `null` input, which would
        // preempt the desired null-coalescing behavior.
        // Thus, if any of our arguments would have needed an annotation, we
        // need to wrap the enclosing coalesce expression with it instead.
        const needsAnnotation = expectedType &&
            parsedArgs.some(arg => checkSubtype(expectedType, arg.type));
        return needsAnnotation ?
            new Coalesce(ValueType, parsedArgs) :
            new Coalesce(outputType, parsedArgs);
    }
    evaluate(ctx) {
        let result = null;
        let argCount = 0;
        let requestedImageName;
        for (const arg of this.args) {
            argCount++;
            result = arg.evaluate(ctx);
            // we need to keep track of the first requested image in a coalesce statement
            // if coalesce can't find a valid image, we return the first image name so styleimagemissing can fire
            if (result && result instanceof ResolvedImage && !result.available) {
                if (!requestedImageName) {
                    requestedImageName = result.name;
                }
                result = null;
                if (argCount === this.args.length) {
                    result = requestedImageName;
                }
            }
            if (result !== null)
                break;
        }
        return result;
    }
    eachChild(fn) {
        this.args.forEach(fn);
    }
    outputDefined() {
        return this.args.every(arg => arg.outputDefined());
    }
}

function isComparableType(op, type) {
    if (op === '==' || op === '!=') {
        // equality operator
        return type.kind === 'boolean' ||
            type.kind === 'string' ||
            type.kind === 'number' ||
            type.kind === 'null' ||
            type.kind === 'value';
    }
    else {
        // ordering operator
        return type.kind === 'string' ||
            type.kind === 'number' ||
            type.kind === 'value';
    }
}
function eq(ctx, a, b) { return a === b; }
function neq(ctx, a, b) { return a !== b; }
function lt(ctx, a, b) { return a < b; }
function gt(ctx, a, b) { return a > b; }
function lteq(ctx, a, b) { return a <= b; }
function gteq(ctx, a, b) { return a >= b; }
function eqCollate(ctx, a, b, c) { return c.compare(a, b) === 0; }
function neqCollate(ctx, a, b, c) { return !eqCollate(ctx, a, b, c); }
function ltCollate(ctx, a, b, c) { return c.compare(a, b) < 0; }
function gtCollate(ctx, a, b, c) { return c.compare(a, b) > 0; }
function lteqCollate(ctx, a, b, c) { return c.compare(a, b) <= 0; }
function gteqCollate(ctx, a, b, c) { return c.compare(a, b) >= 0; }
/**
 * Special form for comparison operators, implementing the signatures:
 * - (T, T, ?Collator) => boolean
 * - (T, value, ?Collator) => boolean
 * - (value, T, ?Collator) => boolean
 *
 * For inequalities, T must be either value, string, or number. For ==/!=, it
 * can also be boolean or null.
 *
 * Equality semantics are equivalent to Javascript's strict equality (===/!==)
 * -- i.e., when the arguments' types don't match, == evaluates to false, != to
 * true.
 *
 * When types don't match in an ordering comparison, a runtime error is thrown.
 *
 * @private
 */
function makeComparison(op, compareBasic, compareWithCollator) {
    const isOrderComparison = op !== '==' && op !== '!=';
    return class Comparison {
        constructor(lhs, rhs, collator) {
            this.type = BooleanType;
            this.lhs = lhs;
            this.rhs = rhs;
            this.collator = collator;
            this.hasUntypedArgument = lhs.type.kind === 'value' || rhs.type.kind === 'value';
        }
        static parse(args, context) {
            if (args.length !== 3 && args.length !== 4)
                return context.error('Expected two or three arguments.');
            const op = args[0];
            let lhs = context.parse(args[1], 1, ValueType);
            if (!lhs)
                return null;
            if (!isComparableType(op, lhs.type)) {
                return context.concat(1).error(`"${op}" comparisons are not supported for type '${toString$1(lhs.type)}'.`);
            }
            let rhs = context.parse(args[2], 2, ValueType);
            if (!rhs)
                return null;
            if (!isComparableType(op, rhs.type)) {
                return context.concat(2).error(`"${op}" comparisons are not supported for type '${toString$1(rhs.type)}'.`);
            }
            if (lhs.type.kind !== rhs.type.kind &&
                lhs.type.kind !== 'value' &&
                rhs.type.kind !== 'value') {
                return context.error(`Cannot compare types '${toString$1(lhs.type)}' and '${toString$1(rhs.type)}'.`);
            }
            if (isOrderComparison) {
                // typing rules specific to less/greater than operators
                if (lhs.type.kind === 'value' && rhs.type.kind !== 'value') {
                    // (value, T)
                    lhs = new Assertion(rhs.type, [lhs]);
                }
                else if (lhs.type.kind !== 'value' && rhs.type.kind === 'value') {
                    // (T, value)
                    rhs = new Assertion(lhs.type, [rhs]);
                }
            }
            let collator = null;
            if (args.length === 4) {
                if (lhs.type.kind !== 'string' &&
                    rhs.type.kind !== 'string' &&
                    lhs.type.kind !== 'value' &&
                    rhs.type.kind !== 'value') {
                    return context.error('Cannot use collator to compare non-string types.');
                }
                collator = context.parse(args[3], 3, CollatorType);
                if (!collator)
                    return null;
            }
            return new Comparison(lhs, rhs, collator);
        }
        evaluate(ctx) {
            const lhs = this.lhs.evaluate(ctx);
            const rhs = this.rhs.evaluate(ctx);
            if (isOrderComparison && this.hasUntypedArgument) {
                const lt = typeOf(lhs);
                const rt = typeOf(rhs);
                // check that type is string or number, and equal
                if (lt.kind !== rt.kind || !(lt.kind === 'string' || lt.kind === 'number')) {
                    throw new RuntimeError(`Expected arguments for "${op}" to be (string, string) or (number, number), but found (${lt.kind}, ${rt.kind}) instead.`);
                }
            }
            if (this.collator && !isOrderComparison && this.hasUntypedArgument) {
                const lt = typeOf(lhs);
                const rt = typeOf(rhs);
                if (lt.kind !== 'string' || rt.kind !== 'string') {
                    return compareBasic(ctx, lhs, rhs);
                }
            }
            return this.collator ?
                compareWithCollator(ctx, lhs, rhs, this.collator.evaluate(ctx)) :
                compareBasic(ctx, lhs, rhs);
        }
        eachChild(fn) {
            fn(this.lhs);
            fn(this.rhs);
            if (this.collator) {
                fn(this.collator);
            }
        }
        outputDefined() {
            return true;
        }
    };
}
const Equals = makeComparison('==', eq, eqCollate);
const NotEquals = makeComparison('!=', neq, neqCollate);
const LessThan = makeComparison('<', lt, ltCollate);
const GreaterThan = makeComparison('>', gt, gtCollate);
const LessThanOrEqual = makeComparison('<=', lteq, lteqCollate);
const GreaterThanOrEqual = makeComparison('>=', gteq, gteqCollate);

class CollatorExpression {
    constructor(caseSensitive, diacriticSensitive, locale) {
        this.type = CollatorType;
        this.locale = locale;
        this.caseSensitive = caseSensitive;
        this.diacriticSensitive = diacriticSensitive;
    }
    static parse(args, context) {
        if (args.length !== 2)
            return context.error('Expected one argument.');
        const options = args[1];
        if (typeof options !== 'object' || Array.isArray(options))
            return context.error('Collator options argument must be an object.');
        const caseSensitive = context.parse(options['case-sensitive'] === undefined ? false : options['case-sensitive'], 1, BooleanType);
        if (!caseSensitive)
            return null;
        const diacriticSensitive = context.parse(options['diacritic-sensitive'] === undefined ? false : options['diacritic-sensitive'], 1, BooleanType);
        if (!diacriticSensitive)
            return null;
        let locale = null;
        if (options['locale']) {
            locale = context.parse(options['locale'], 1, StringType);
            if (!locale)
                return null;
        }
        return new CollatorExpression(caseSensitive, diacriticSensitive, locale);
    }
    evaluate(ctx) {
        return new Collator(this.caseSensitive.evaluate(ctx), this.diacriticSensitive.evaluate(ctx), this.locale ? this.locale.evaluate(ctx) : null);
    }
    eachChild(fn) {
        fn(this.caseSensitive);
        fn(this.diacriticSensitive);
        if (this.locale) {
            fn(this.locale);
        }
    }
    outputDefined() {
        // Technically the set of possible outputs is the combinatoric set of Collators produced
        // by all possible outputs of locale/caseSensitive/diacriticSensitive
        // But for the primary use of Collators in comparison operators, we ignore the Collator's
        // possible outputs anyway, so we can get away with leaving this false for now.
        return false;
    }
}

class NumberFormat {
    constructor(number, locale, currency, minFractionDigits, maxFractionDigits) {
        this.type = StringType;
        this.number = number;
        this.locale = locale;
        this.currency = currency;
        this.minFractionDigits = minFractionDigits;
        this.maxFractionDigits = maxFractionDigits;
    }
    static parse(args, context) {
        if (args.length !== 3)
            return context.error('Expected two arguments.');
        const number = context.parse(args[1], 1, NumberType);
        if (!number)
            return null;
        const options = args[2];
        if (typeof options !== 'object' || Array.isArray(options))
            return context.error('NumberFormat options argument must be an object.');
        let locale = null;
        if (options['locale']) {
            locale = context.parse(options['locale'], 1, StringType);
            if (!locale)
                return null;
        }
        let currency = null;
        if (options['currency']) {
            currency = context.parse(options['currency'], 1, StringType);
            if (!currency)
                return null;
        }
        let minFractionDigits = null;
        if (options['min-fraction-digits']) {
            minFractionDigits = context.parse(options['min-fraction-digits'], 1, NumberType);
            if (!minFractionDigits)
                return null;
        }
        let maxFractionDigits = null;
        if (options['max-fraction-digits']) {
            maxFractionDigits = context.parse(options['max-fraction-digits'], 1, NumberType);
            if (!maxFractionDigits)
                return null;
        }
        return new NumberFormat(number, locale, currency, minFractionDigits, maxFractionDigits);
    }
    evaluate(ctx) {
        return new Intl.NumberFormat(this.locale ? this.locale.evaluate(ctx) : [], {
            style: this.currency ? 'currency' : 'decimal',
            currency: this.currency ? this.currency.evaluate(ctx) : undefined,
            minimumFractionDigits: this.minFractionDigits ? this.minFractionDigits.evaluate(ctx) : undefined,
            maximumFractionDigits: this.maxFractionDigits ? this.maxFractionDigits.evaluate(ctx) : undefined,
        }).format(this.number.evaluate(ctx));
    }
    eachChild(fn) {
        fn(this.number);
        if (this.locale) {
            fn(this.locale);
        }
        if (this.currency) {
            fn(this.currency);
        }
        if (this.minFractionDigits) {
            fn(this.minFractionDigits);
        }
        if (this.maxFractionDigits) {
            fn(this.maxFractionDigits);
        }
    }
    outputDefined() {
        return false;
    }
}

class FormatExpression {
    constructor(sections) {
        this.type = FormattedType;
        this.sections = sections;
    }
    static parse(args, context) {
        if (args.length < 2) {
            return context.error('Expected at least one argument.');
        }
        const firstArg = args[1];
        if (!Array.isArray(firstArg) && typeof firstArg === 'object') {
            return context.error('First argument must be an image or text section.');
        }
        const sections = [];
        let nextTokenMayBeObject = false;
        for (let i = 1; i <= args.length - 1; ++i) {
            const arg = args[i];
            if (nextTokenMayBeObject && typeof arg === 'object' && !Array.isArray(arg)) {
                nextTokenMayBeObject = false;
                let scale = null;
                if (arg['font-scale']) {
                    scale = context.parse(arg['font-scale'], 1, NumberType);
                    if (!scale)
                        return null;
                }
                let font = null;
                if (arg['text-font']) {
                    font = context.parse(arg['text-font'], 1, array$1(StringType));
                    if (!font)
                        return null;
                }
                let textColor = null;
                if (arg['text-color']) {
                    textColor = context.parse(arg['text-color'], 1, ColorType);
                    if (!textColor)
                        return null;
                }
                const lastExpression = sections[sections.length - 1];
                lastExpression.scale = scale;
                lastExpression.font = font;
                lastExpression.textColor = textColor;
            }
            else {
                const content = context.parse(args[i], 1, ValueType);
                if (!content)
                    return null;
                const kind = content.type.kind;
                if (kind !== 'string' && kind !== 'value' && kind !== 'null' && kind !== 'resolvedImage')
                    return context.error('Formatted text type must be \'string\', \'value\', \'image\' or \'null\'.');
                nextTokenMayBeObject = true;
                sections.push({ content, scale: null, font: null, textColor: null });
            }
        }
        return new FormatExpression(sections);
    }
    evaluate(ctx) {
        const evaluateSection = section => {
            const evaluatedContent = section.content.evaluate(ctx);
            if (typeOf(evaluatedContent) === ResolvedImageType) {
                return new FormattedSection('', evaluatedContent, null, null, null);
            }
            return new FormattedSection(toString(evaluatedContent), null, section.scale ? section.scale.evaluate(ctx) : null, section.font ? section.font.evaluate(ctx).join(',') : null, section.textColor ? section.textColor.evaluate(ctx) : null);
        };
        return new Formatted(this.sections.map(evaluateSection));
    }
    eachChild(fn) {
        for (const section of this.sections) {
            fn(section.content);
            if (section.scale) {
                fn(section.scale);
            }
            if (section.font) {
                fn(section.font);
            }
            if (section.textColor) {
                fn(section.textColor);
            }
        }
    }
    outputDefined() {
        // Technically the combinatoric set of all children
        // Usually, this.text will be undefined anyway
        return false;
    }
}

class ImageExpression {
    constructor(input) {
        this.type = ResolvedImageType;
        this.input = input;
    }
    static parse(args, context) {
        if (args.length !== 2) {
            return context.error('Expected two arguments.');
        }
        const name = context.parse(args[1], 1, StringType);
        if (!name)
            return context.error('No image name provided.');
        return new ImageExpression(name);
    }
    evaluate(ctx) {
        const evaluatedImageName = this.input.evaluate(ctx);
        const value = ResolvedImage.fromString(evaluatedImageName);
        if (value && ctx.availableImages)
            value.available = ctx.availableImages.indexOf(evaluatedImageName) > -1;
        return value;
    }
    eachChild(fn) {
        fn(this.input);
    }
    outputDefined() {
        // The output of image is determined by the list of available images in the evaluation context
        return false;
    }
}

class Length {
    constructor(input) {
        this.type = NumberType;
        this.input = input;
    }
    static parse(args, context) {
        if (args.length !== 2)
            return context.error(`Expected 1 argument, but found ${args.length - 1} instead.`);
        const input = context.parse(args[1], 1);
        if (!input)
            return null;
        if (input.type.kind !== 'array' && input.type.kind !== 'string' && input.type.kind !== 'value')
            return context.error(`Expected argument of type string or array, but found ${toString$1(input.type)} instead.`);
        return new Length(input);
    }
    evaluate(ctx) {
        const input = this.input.evaluate(ctx);
        if (typeof input === 'string') {
            return input.length;
        }
        else if (Array.isArray(input)) {
            return input.length;
        }
        else {
            throw new RuntimeError(`Expected value to be of type string or array, but found ${toString$1(typeOf(input))} instead.`);
        }
    }
    eachChild(fn) {
        fn(this.input);
    }
    outputDefined() {
        return false;
    }
}

const EXTENT$1 = 8192;
function getTileCoordinates(p, canonical) {
    const x = mercatorXfromLng$1(p[0]);
    const y = mercatorYfromLat$1(p[1]);
    const tilesAtZoom = Math.pow(2, canonical.z);
    return [Math.round(x * tilesAtZoom * EXTENT$1), Math.round(y * tilesAtZoom * EXTENT$1)];
}
function getLngLatFromTileCoord(coord, canonical) {
    const tilesAtZoom = Math.pow(2, canonical.z);
    const x = (coord[0] / EXTENT$1 + canonical.x) / tilesAtZoom;
    const y = (coord[1] / EXTENT$1 + canonical.y) / tilesAtZoom;
    return [lngFromMercatorXfromLng(x), latFromMercatorY$1(y)];
}
function mercatorXfromLng$1(lng) {
    return (180 + lng) / 360;
}
function lngFromMercatorXfromLng(mercatorX) {
    return mercatorX * 360 - 180;
}
function mercatorYfromLat$1(lat) {
    return (180 - (180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + lat * Math.PI / 360)))) / 360;
}
function latFromMercatorY$1(mercatorY) {
    return 360 / Math.PI * Math.atan(Math.exp((180 - mercatorY * 360) * Math.PI / 180)) - 90;
}
function updateBBox(bbox, coord) {
    bbox[0] = Math.min(bbox[0], coord[0]);
    bbox[1] = Math.min(bbox[1], coord[1]);
    bbox[2] = Math.max(bbox[2], coord[0]);
    bbox[3] = Math.max(bbox[3], coord[1]);
}
function boxWithinBox(bbox1, bbox2) {
    if (bbox1[0] <= bbox2[0])
        return false;
    if (bbox1[2] >= bbox2[2])
        return false;
    if (bbox1[1] <= bbox2[1])
        return false;
    if (bbox1[3] >= bbox2[3])
        return false;
    return true;
}
function rayIntersect(p, p1, p2) {
    return ((p1[1] > p[1]) !== (p2[1] > p[1])) && (p[0] < (p2[0] - p1[0]) * (p[1] - p1[1]) / (p2[1] - p1[1]) + p1[0]);
}
function pointOnBoundary(p, p1, p2) {
    const x1 = p[0] - p1[0];
    const y1 = p[1] - p1[1];
    const x2 = p[0] - p2[0];
    const y2 = p[1] - p2[1];
    return (x1 * y2 - x2 * y1 === 0) && (x1 * x2 <= 0) && (y1 * y2 <= 0);
}
// a, b are end points for line segment1, c and d are end points for line segment2
function segmentIntersectSegment(a, b, c, d) {
    // check if two segments are parallel or not
    // precondition is end point a, b is inside polygon, if line a->b is
    // parallel to polygon edge c->d, then a->b won't intersect with c->d
    const vectorP = [b[0] - a[0], b[1] - a[1]];
    const vectorQ = [d[0] - c[0], d[1] - c[1]];
    if (perp(vectorQ, vectorP) === 0)
        return false;
    // If lines are intersecting with each other, the relative location should be:
    // a and b lie in different sides of segment c->d
    // c and d lie in different sides of segment a->b
    if (twoSided(a, b, c, d) && twoSided(c, d, a, b))
        return true;
    return false;
}
function lineIntersectPolygon(p1, p2, polygon) {
    for (const ring of polygon) {
        // loop through every edge of the ring
        for (let j = 0; j < ring.length - 1; ++j) {
            if (segmentIntersectSegment(p1, p2, ring[j], ring[j + 1])) {
                return true;
            }
        }
    }
    return false;
}
// ray casting algorithm for detecting if point is in polygon
function pointWithinPolygon(point, rings, trueIfOnBoundary = false) {
    let inside = false;
    for (const ring of rings) {
        for (let j = 0; j < ring.length - 1; j++) {
            if (pointOnBoundary(point, ring[j], ring[j + 1]))
                return trueIfOnBoundary;
            if (rayIntersect(point, ring[j], ring[j + 1]))
                inside = !inside;
        }
    }
    return inside;
}
function pointWithinPolygons(point, polygons) {
    for (const polygon of polygons) {
        if (pointWithinPolygon(point, polygon))
            return true;
    }
    return false;
}
function lineStringWithinPolygon(line, polygon) {
    // First, check if geometry points of line segments are all inside polygon
    for (const point of line) {
        if (!pointWithinPolygon(point, polygon)) {
            return false;
        }
    }
    // Second, check if there is line segment intersecting polygon edge
    for (let i = 0; i < line.length - 1; ++i) {
        if (lineIntersectPolygon(line[i], line[i + 1], polygon)) {
            return false;
        }
    }
    return true;
}
function lineStringWithinPolygons(line, polygons) {
    for (const polygon of polygons) {
        if (lineStringWithinPolygon(line, polygon))
            return true;
    }
    return false;
}
function perp(v1, v2) {
    return (v1[0] * v2[1] - v1[1] * v2[0]);
}
// check if p1 and p2 are in different sides of line segment q1->q2
function twoSided(p1, p2, q1, q2) {
    // q1->p1 (x1, y1), q1->p2 (x2, y2), q1->q2 (x3, y3)
    const x1 = p1[0] - q1[0];
    const y1 = p1[1] - q1[1];
    const x2 = p2[0] - q1[0];
    const y2 = p2[1] - q1[1];
    const x3 = q2[0] - q1[0];
    const y3 = q2[1] - q1[1];
    const det1 = (x1 * y3 - x3 * y1);
    const det2 = (x2 * y3 - x3 * y2);
    if ((det1 > 0 && det2 < 0) || (det1 < 0 && det2 > 0))
        return true;
    return false;
}

function getTilePolygon(coordinates, bbox, canonical) {
    const polygon = [];
    for (let i = 0; i < coordinates.length; i++) {
        const ring = [];
        for (let j = 0; j < coordinates[i].length; j++) {
            const coord = getTileCoordinates(coordinates[i][j], canonical);
            updateBBox(bbox, coord);
            ring.push(coord);
        }
        polygon.push(ring);
    }
    return polygon;
}
function getTilePolygons(coordinates, bbox, canonical) {
    const polygons = [];
    for (let i = 0; i < coordinates.length; i++) {
        const polygon = getTilePolygon(coordinates[i], bbox, canonical);
        polygons.push(polygon);
    }
    return polygons;
}
function updatePoint(p, bbox, polyBBox, worldSize) {
    if (p[0] < polyBBox[0] || p[0] > polyBBox[2]) {
        const halfWorldSize = worldSize * 0.5;
        let shift = (p[0] - polyBBox[0] > halfWorldSize) ? -worldSize : (polyBBox[0] - p[0] > halfWorldSize) ? worldSize : 0;
        if (shift === 0) {
            shift = (p[0] - polyBBox[2] > halfWorldSize) ? -worldSize : (polyBBox[2] - p[0] > halfWorldSize) ? worldSize : 0;
        }
        p[0] += shift;
    }
    updateBBox(bbox, p);
}
function resetBBox(bbox) {
    bbox[0] = bbox[1] = Infinity;
    bbox[2] = bbox[3] = -Infinity;
}
function getTilePoints(geometry, pointBBox, polyBBox, canonical) {
    const worldSize = Math.pow(2, canonical.z) * EXTENT$1;
    const shifts = [canonical.x * EXTENT$1, canonical.y * EXTENT$1];
    const tilePoints = [];
    for (const points of geometry) {
        for (const point of points) {
            const p = [point.x + shifts[0], point.y + shifts[1]];
            updatePoint(p, pointBBox, polyBBox, worldSize);
            tilePoints.push(p);
        }
    }
    return tilePoints;
}
function getTileLines(geometry, lineBBox, polyBBox, canonical) {
    const worldSize = Math.pow(2, canonical.z) * EXTENT$1;
    const shifts = [canonical.x * EXTENT$1, canonical.y * EXTENT$1];
    const tileLines = [];
    for (const line of geometry) {
        const tileLine = [];
        for (const point of line) {
            const p = [point.x + shifts[0], point.y + shifts[1]];
            updateBBox(lineBBox, p);
            tileLine.push(p);
        }
        tileLines.push(tileLine);
    }
    if (lineBBox[2] - lineBBox[0] <= worldSize / 2) {
        resetBBox(lineBBox);
        for (const line of tileLines) {
            for (const p of line) {
                updatePoint(p, lineBBox, polyBBox, worldSize);
            }
        }
    }
    return tileLines;
}
function pointsWithinPolygons(ctx, polygonGeometry) {
    const pointBBox = [Infinity, Infinity, -Infinity, -Infinity];
    const polyBBox = [Infinity, Infinity, -Infinity, -Infinity];
    const canonical = ctx.canonicalID();
    if (polygonGeometry.type === 'Polygon') {
        const tilePolygon = getTilePolygon(polygonGeometry.coordinates, polyBBox, canonical);
        const tilePoints = getTilePoints(ctx.geometry(), pointBBox, polyBBox, canonical);
        if (!boxWithinBox(pointBBox, polyBBox))
            return false;
        for (const point of tilePoints) {
            if (!pointWithinPolygon(point, tilePolygon))
                return false;
        }
    }
    if (polygonGeometry.type === 'MultiPolygon') {
        const tilePolygons = getTilePolygons(polygonGeometry.coordinates, polyBBox, canonical);
        const tilePoints = getTilePoints(ctx.geometry(), pointBBox, polyBBox, canonical);
        if (!boxWithinBox(pointBBox, polyBBox))
            return false;
        for (const point of tilePoints) {
            if (!pointWithinPolygons(point, tilePolygons))
                return false;
        }
    }
    return true;
}
function linesWithinPolygons(ctx, polygonGeometry) {
    const lineBBox = [Infinity, Infinity, -Infinity, -Infinity];
    const polyBBox = [Infinity, Infinity, -Infinity, -Infinity];
    const canonical = ctx.canonicalID();
    if (polygonGeometry.type === 'Polygon') {
        const tilePolygon = getTilePolygon(polygonGeometry.coordinates, polyBBox, canonical);
        const tileLines = getTileLines(ctx.geometry(), lineBBox, polyBBox, canonical);
        if (!boxWithinBox(lineBBox, polyBBox))
            return false;
        for (const line of tileLines) {
            if (!lineStringWithinPolygon(line, tilePolygon))
                return false;
        }
    }
    if (polygonGeometry.type === 'MultiPolygon') {
        const tilePolygons = getTilePolygons(polygonGeometry.coordinates, polyBBox, canonical);
        const tileLines = getTileLines(ctx.geometry(), lineBBox, polyBBox, canonical);
        if (!boxWithinBox(lineBBox, polyBBox))
            return false;
        for (const line of tileLines) {
            if (!lineStringWithinPolygons(line, tilePolygons))
                return false;
        }
    }
    return true;
}
class Within {
    constructor(geojson, geometries) {
        this.type = BooleanType;
        this.geojson = geojson;
        this.geometries = geometries;
    }
    static parse(args, context) {
        if (args.length !== 2)
            return context.error(`'within' expression requires exactly one argument, but found ${args.length - 1} instead.`);
        if (isValue(args[1])) {
            const geojson = args[1];
            if (geojson.type === 'FeatureCollection') {
                const polygonsCoords = [];
                for (const polygon of geojson.features) {
                    const { type, coordinates } = polygon.geometry;
                    if (type === 'Polygon') {
                        polygonsCoords.push(coordinates);
                    }
                    if (type === 'MultiPolygon') {
                        polygonsCoords.push(...coordinates);
                    }
                }
                if (polygonsCoords.length) {
                    const multipolygonWrapper = {
                        type: 'MultiPolygon',
                        coordinates: polygonsCoords
                    };
                    return new Within(geojson, multipolygonWrapper);
                }
            }
            else if (geojson.type === 'Feature') {
                const type = geojson.geometry.type;
                if (type === 'Polygon' || type === 'MultiPolygon') {
                    return new Within(geojson, geojson.geometry);
                }
            }
            else if (geojson.type === 'Polygon' || geojson.type === 'MultiPolygon') {
                return new Within(geojson, geojson);
            }
        }
        return context.error('\'within\' expression requires valid geojson object that contains polygon geometry type.');
    }
    evaluate(ctx) {
        if (ctx.geometry() != null && ctx.canonicalID() != null) {
            if (ctx.geometryType() === 'Point') {
                return pointsWithinPolygons(ctx, this.geometries);
            }
            else if (ctx.geometryType() === 'LineString') {
                return linesWithinPolygons(ctx, this.geometries);
            }
        }
        return false;
    }
    eachChild() { }
    outputDefined() {
        return true;
    }
}

let TinyQueue$1 = class TinyQueue {
    constructor(data = [], compare = defaultCompare$1) {
        this.data = data;
        this.length = this.data.length;
        this.compare = compare;

        if (this.length > 0) {
            for (let i = (this.length >> 1) - 1; i >= 0; i--) this._down(i);
        }
    }

    push(item) {
        this.data.push(item);
        this.length++;
        this._up(this.length - 1);
    }

    pop() {
        if (this.length === 0) return undefined;

        const top = this.data[0];
        const bottom = this.data.pop();
        this.length--;

        if (this.length > 0) {
            this.data[0] = bottom;
            this._down(0);
        }

        return top;
    }

    peek() {
        return this.data[0];
    }

    _up(pos) {
        const {data, compare} = this;
        const item = data[pos];

        while (pos > 0) {
            const parent = (pos - 1) >> 1;
            const current = data[parent];
            if (compare(item, current) >= 0) break;
            data[pos] = current;
            pos = parent;
        }

        data[pos] = item;
    }

    _down(pos) {
        const {data, compare} = this;
        const halfLength = this.length >> 1;
        const item = data[pos];

        while (pos < halfLength) {
            let left = (pos << 1) + 1;
            let best = data[left];
            const right = left + 1;

            if (right < this.length && compare(data[right], best) < 0) {
                left = right;
                best = data[right];
            }
            if (compare(best, item) >= 0) break;

            data[pos] = best;
            pos = left;
        }

        data[pos] = item;
    }
};

function defaultCompare$1(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
}

function quickselect(arr, k, left, right, compare) {
    quickselectStep(arr, k, left , right || (arr.length - 1), compare || defaultCompare);
}

function quickselectStep(arr, k, left, right, compare) {

    while (right > left) {
        if (right - left > 600) {
            var n = right - left + 1;
            var m = k - left + 1;
            var z = Math.log(n);
            var s = 0.5 * Math.exp(2 * z / 3);
            var sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            var newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            var newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            quickselectStep(arr, k, newLeft, newRight, compare);
        }

        var t = arr[k];
        var i = left;
        var j = right;

        swap$2(arr, left, k);
        if (compare(arr[right], t) > 0) swap$2(arr, left, right);

        while (i < j) {
            swap$2(arr, i, j);
            i++;
            j--;
            while (compare(arr[i], t) < 0) i++;
            while (compare(arr[j], t) > 0) j--;
        }

        if (compare(arr[left], t) === 0) swap$2(arr, left, j);
        else {
            j++;
            swap$2(arr, j, right);
        }

        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
}

function swap$2(arr, i, j) {
    var tmp = arr[i];
    arr[i] = arr[j];
    arr[j] = tmp;
}

function defaultCompare(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
}

/**
 * Classifies an array of rings into polygons with outer rings and holes
 * @param rings - the rings to classify
 * @param maxRings - the maximum number of rings to include in a polygon, use 0 to include all rings
 * @returns an array of polygons with internal rings as holes
 */
function classifyRings$1(rings, maxRings) {
    const len = rings.length;
    if (len <= 1)
        return [rings];
    const polygons = [];
    let polygon;
    let ccw;
    for (const ring of rings) {
        const area = calculateSignedArea(ring);
        if (area === 0)
            continue;
        ring.area = Math.abs(area);
        if (ccw === undefined)
            ccw = area < 0;
        if (ccw === area < 0) {
            if (polygon)
                polygons.push(polygon);
            polygon = [ring];
        }
        else {
            polygon.push(ring);
        }
    }
    if (polygon)
        polygons.push(polygon);
    // Earcut performance degrades with the # of rings in a polygon. For this
    // reason, we limit strip out all but the `maxRings` largest rings.
    if (maxRings > 1) {
        for (let j = 0; j < polygons.length; j++) {
            if (polygons[j].length <= maxRings)
                continue;
            quickselect(polygons[j], maxRings, 1, polygons[j].length - 1, compareAreas);
            polygons[j] = polygons[j].slice(0, maxRings);
        }
    }
    return polygons;
}
function compareAreas(a, b) {
    return b.area - a.area;
}
/**
 * Returns the signed area for the polygon ring.  Positive areas are exterior rings and
 * have a clockwise winding.  Negative areas are interior rings and have a counter clockwise
 * ordering.
 *
 * @param ring - Exterior or interior ring
 * @returns Signed area
 */
function calculateSignedArea(ring) {
    let sum = 0;
    for (let i = 0, len = ring.length, j = len - 1, p1, p2; i < len; j = i++) {
        p1 = ring[i];
        p2 = ring[j];
        sum += (p2.x - p1.x) * (p1.y + p2.y);
    }
    return sum;
}

// This is taken from https://github.com/mapbox/cheap-ruler/ in order to take only the relevant parts
// Values that define WGS84 ellipsoid model of the Earth
const RE = 6378.137; // equatorial radius
const FE = 1 / 298.257223563; // flattening
const E2 = FE * (2 - FE);
const RAD = Math.PI / 180;
class CheapRuler {
    constructor(lat) {
        // Curvature formulas from https://en.wikipedia.org/wiki/Earth_radius#Meridional
        const m = RAD * RE * 1000;
        const coslat = Math.cos(lat * RAD);
        const w2 = 1 / (1 - E2 * (1 - coslat * coslat));
        const w = Math.sqrt(w2);
        // multipliers for converting longitude and latitude degrees into distance
        this.kx = m * w * coslat; // based on normal radius of curvature
        this.ky = m * w * w2 * (1 - E2); // based on meridonal radius of curvature
    }
    /**
     * Given two points of the form [longitude, latitude], returns the distance.
     *
     * @param a - point [longitude, latitude]
     * @param b - point [longitude, latitude]
     * @returns distance
     * @example
     * const distance = ruler.distance([30.5, 50.5], [30.51, 50.49]);
     * //=distance
     */
    distance(a, b) {
        const dx = this.wrap(a[0] - b[0]) * this.kx;
        const dy = (a[1] - b[1]) * this.ky;
        return Math.sqrt(dx * dx + dy * dy);
    }
    /**
     * Returns an object of the form {point, index, t}, where point is closest point on the line
     * from the given point, index is the start index of the segment with the closest point,
     * and t is a parameter from 0 to 1 that indicates where the closest point is on that segment.
     *
     * @param line - an array of points that form the line
     * @param p - point [longitude, latitude]
     * @returns the nearest point, its index in the array and the proportion along the line
     * @example
     * const point = ruler.pointOnLine(line, [-67.04, 50.5]).point;
     * //=point
     */
    pointOnLine(line, p) {
        let minDist = Infinity;
        let minX, minY, minI, minT;
        for (let i = 0; i < line.length - 1; i++) {
            let x = line[i][0];
            let y = line[i][1];
            let dx = this.wrap(line[i + 1][0] - x) * this.kx;
            let dy = (line[i + 1][1] - y) * this.ky;
            let t = 0;
            if (dx !== 0 || dy !== 0) {
                t = (this.wrap(p[0] - x) * this.kx * dx + (p[1] - y) * this.ky * dy) / (dx * dx + dy * dy);
                if (t > 1) {
                    x = line[i + 1][0];
                    y = line[i + 1][1];
                }
                else if (t > 0) {
                    x += (dx / this.kx) * t;
                    y += (dy / this.ky) * t;
                }
            }
            dx = this.wrap(p[0] - x) * this.kx;
            dy = (p[1] - y) * this.ky;
            const sqDist = dx * dx + dy * dy;
            if (sqDist < minDist) {
                minDist = sqDist;
                minX = x;
                minY = y;
                minI = i;
                minT = t;
            }
        }
        return {
            point: [minX, minY],
            index: minI,
            t: Math.max(0, Math.min(1, minT))
        };
    }
    wrap(deg) {
        while (deg < -180)
            deg += 360;
        while (deg > 180)
            deg -= 360;
        return deg;
    }
}

const MinPointsSize = 100;
const MinLinePointsSize = 50;
function compareDistPair(a, b) {
    return b[0] - a[0];
}
function getRangeSize(range) {
    return range[1] - range[0] + 1;
}
function isRangeSafe(range, threshold) {
    return range[1] >= range[0] && range[1] < threshold;
}
function splitRange(range, isLine) {
    if (range[0] > range[1]) {
        return [null, null];
    }
    const size = getRangeSize(range);
    if (isLine) {
        if (size === 2) {
            return [range, null];
        }
        const size1 = Math.floor(size / 2);
        return [[range[0], range[0] + size1],
            [range[0] + size1, range[1]]];
    }
    if (size === 1) {
        return [range, null];
    }
    const size1 = Math.floor(size / 2) - 1;
    return [[range[0], range[0] + size1],
        [range[0] + size1 + 1, range[1]]];
}
function getBBox(coords, range) {
    if (!isRangeSafe(range, coords.length)) {
        return [Infinity, Infinity, -Infinity, -Infinity];
    }
    const bbox = [Infinity, Infinity, -Infinity, -Infinity];
    for (let i = range[0]; i <= range[1]; ++i) {
        updateBBox(bbox, coords[i]);
    }
    return bbox;
}
function getPolygonBBox(polygon) {
    const bbox = [Infinity, Infinity, -Infinity, -Infinity];
    for (const ring of polygon) {
        for (const coord of ring) {
            updateBBox(bbox, coord);
        }
    }
    return bbox;
}
function isValidBBox(bbox) {
    return bbox[0] !== -Infinity && bbox[1] !== -Infinity && bbox[2] !== Infinity && bbox[3] !== Infinity;
}
// Calculate the distance between two bounding boxes.
// Calculate the delta in x and y direction, and use two fake points {0.0, 0.0}
// and {dx, dy} to calculate the distance. Distance will be 0.0 if bounding box are overlapping.
function bboxToBBoxDistance(bbox1, bbox2, ruler) {
    if (!isValidBBox(bbox1) || !isValidBBox(bbox2)) {
        return NaN;
    }
    let dx = 0.0;
    let dy = 0.0;
    // bbox1 in left side
    if (bbox1[2] < bbox2[0]) {
        dx = bbox2[0] - bbox1[2];
    }
    // bbox1 in right side
    if (bbox1[0] > bbox2[2]) {
        dx = bbox1[0] - bbox2[2];
    }
    // bbox1 in above side
    if (bbox1[1] > bbox2[3]) {
        dy = bbox1[1] - bbox2[3];
    }
    // bbox1 in down side
    if (bbox1[3] < bbox2[1]) {
        dy = bbox2[1] - bbox1[3];
    }
    return ruler.distance([0.0, 0.0], [dx, dy]);
}
function pointToLineDistance(point, line, ruler) {
    const nearestPoint = ruler.pointOnLine(line, point);
    return ruler.distance(point, nearestPoint.point);
}
function segmentToSegmentDistance(p1, p2, q1, q2, ruler) {
    const dist1 = Math.min(pointToLineDistance(p1, [q1, q2], ruler), pointToLineDistance(p2, [q1, q2], ruler));
    const dist2 = Math.min(pointToLineDistance(q1, [p1, p2], ruler), pointToLineDistance(q2, [p1, p2], ruler));
    return Math.min(dist1, dist2);
}
function lineToLineDistance(line1, range1, line2, range2, ruler) {
    const rangeSafe = isRangeSafe(range1, line1.length) && isRangeSafe(range2, line2.length);
    if (!rangeSafe) {
        return Infinity;
    }
    let dist = Infinity;
    for (let i = range1[0]; i < range1[1]; ++i) {
        const p1 = line1[i];
        const p2 = line1[i + 1];
        for (let j = range2[0]; j < range2[1]; ++j) {
            const q1 = line2[j];
            const q2 = line2[j + 1];
            if (segmentIntersectSegment(p1, p2, q1, q2)) {
                return 0.0;
            }
            dist = Math.min(dist, segmentToSegmentDistance(p1, p2, q1, q2, ruler));
        }
    }
    return dist;
}
function pointsToPointsDistance(points1, range1, points2, range2, ruler) {
    const rangeSafe = isRangeSafe(range1, points1.length) && isRangeSafe(range2, points2.length);
    if (!rangeSafe) {
        return NaN;
    }
    let dist = Infinity;
    for (let i = range1[0]; i <= range1[1]; ++i) {
        for (let j = range2[0]; j <= range2[1]; ++j) {
            dist = Math.min(dist, ruler.distance(points1[i], points2[j]));
            if (dist === 0.0) {
                return dist;
            }
        }
    }
    return dist;
}
function pointToPolygonDistance(point, polygon, ruler) {
    if (pointWithinPolygon(point, polygon, true)) {
        return 0.0;
    }
    let dist = Infinity;
    for (const ring of polygon) {
        const front = ring[0];
        const back = ring[ring.length - 1];
        if (front !== back) {
            dist = Math.min(dist, pointToLineDistance(point, [back, front], ruler));
            if (dist === 0.0) {
                return dist;
            }
        }
        const nearestPoint = ruler.pointOnLine(ring, point);
        dist = Math.min(dist, ruler.distance(point, nearestPoint.point));
        if (dist === 0.0) {
            return dist;
        }
    }
    return dist;
}
function lineToPolygonDistance(line, range, polygon, ruler) {
    if (!isRangeSafe(range, line.length)) {
        return NaN;
    }
    for (let i = range[0]; i <= range[1]; ++i) {
        if (pointWithinPolygon(line[i], polygon, true)) {
            return 0.0;
        }
    }
    let dist = Infinity;
    for (let i = range[0]; i < range[1]; ++i) {
        const p1 = line[i];
        const p2 = line[i + 1];
        for (const ring of polygon) {
            for (let j = 0, len = ring.length, k = len - 1; j < len; k = j++) {
                const q1 = ring[k];
                const q2 = ring[j];
                if (segmentIntersectSegment(p1, p2, q1, q2)) {
                    return 0.0;
                }
                dist = Math.min(dist, segmentToSegmentDistance(p1, p2, q1, q2, ruler));
            }
        }
    }
    return dist;
}
function polygonIntersect(poly1, poly2) {
    for (const ring of poly1) {
        for (const point of ring) {
            if (pointWithinPolygon(point, poly2, true)) {
                return true;
            }
        }
    }
    return false;
}
function polygonToPolygonDistance(polygon1, polygon2, ruler, currentMiniDist = Infinity) {
    const bbox1 = getPolygonBBox(polygon1);
    const bbox2 = getPolygonBBox(polygon2);
    if (currentMiniDist !== Infinity && bboxToBBoxDistance(bbox1, bbox2, ruler) >= currentMiniDist) {
        return currentMiniDist;
    }
    if (boxWithinBox(bbox1, bbox2)) {
        if (polygonIntersect(polygon1, polygon2)) {
            return 0.0;
        }
    }
    else if (polygonIntersect(polygon2, polygon1)) {
        return 0.0;
    }
    let dist = Infinity;
    for (const ring1 of polygon1) {
        for (let i = 0, len1 = ring1.length, l = len1 - 1; i < len1; l = i++) {
            const p1 = ring1[l];
            const p2 = ring1[i];
            for (const ring2 of polygon2) {
                for (let j = 0, len2 = ring2.length, k = len2 - 1; j < len2; k = j++) {
                    const q1 = ring2[k];
                    const q2 = ring2[j];
                    if (segmentIntersectSegment(p1, p2, q1, q2)) {
                        return 0.0;
                    }
                    dist = Math.min(dist, segmentToSegmentDistance(p1, p2, q1, q2, ruler));
                }
            }
        }
    }
    return dist;
}
function updateQueue(distQueue, miniDist, ruler, points, polyBBox, rangeA) {
    if (!rangeA) {
        return;
    }
    const tempDist = bboxToBBoxDistance(getBBox(points, rangeA), polyBBox, ruler);
    // Insert new pair to the queue if the bbox distance is less than
    // miniDist, The pair with biggest distance will be at the top
    if (tempDist < miniDist) {
        distQueue.push([tempDist, rangeA, [0, 0]]);
    }
}
function updateQueueTwoSets(distQueue, miniDist, ruler, pointSet1, pointSet2, range1, range2) {
    if (!range1 || !range2) {
        return;
    }
    const tempDist = bboxToBBoxDistance(getBBox(pointSet1, range1), getBBox(pointSet2, range2), ruler);
    // Insert new pair to the queue if the bbox distance is less than
    // miniDist, The pair with biggest distance will be at the top
    if (tempDist < miniDist) {
        distQueue.push([tempDist, range1, range2]);
    }
}
// Divide and conquer, the time complexity is O(n*lgn), faster than Brute force
// O(n*n) Most of the time, use index for in-place processing.
function pointsToPolygonDistance(points, isLine, polygon, ruler, currentMiniDist = Infinity) {
    let miniDist = Math.min(ruler.distance(points[0], polygon[0][0]), currentMiniDist);
    if (miniDist === 0.0) {
        return miniDist;
    }
    const distQueue = new TinyQueue$1([[0, [0, points.length - 1], [0, 0]]], compareDistPair);
    const polyBBox = getPolygonBBox(polygon);
    while (distQueue.length > 0) {
        const distPair = distQueue.pop();
        if (distPair[0] >= miniDist) {
            continue;
        }
        const range = distPair[1];
        // In case the set size are relatively small, we could use brute-force directly
        const threshold = isLine ? MinLinePointsSize : MinPointsSize;
        if (getRangeSize(range) <= threshold) {
            if (!isRangeSafe(range, points.length)) {
                return NaN;
            }
            if (isLine) {
                const tempDist = lineToPolygonDistance(points, range, polygon, ruler);
                if (isNaN(tempDist) || tempDist === 0.0) {
                    return tempDist;
                }
                miniDist = Math.min(miniDist, tempDist);
            }
            else {
                for (let i = range[0]; i <= range[1]; ++i) {
                    const tempDist = pointToPolygonDistance(points[i], polygon, ruler);
                    miniDist = Math.min(miniDist, tempDist);
                    if (miniDist === 0.0) {
                        return 0.0;
                    }
                }
            }
        }
        else {
            const newRangesA = splitRange(range, isLine);
            updateQueue(distQueue, miniDist, ruler, points, polyBBox, newRangesA[0]);
            updateQueue(distQueue, miniDist, ruler, points, polyBBox, newRangesA[1]);
        }
    }
    return miniDist;
}
function pointSetToPointSetDistance(pointSet1, isLine1, pointSet2, isLine2, ruler, currentMiniDist = Infinity) {
    let miniDist = Math.min(currentMiniDist, ruler.distance(pointSet1[0], pointSet2[0]));
    if (miniDist === 0.0) {
        return miniDist;
    }
    const distQueue = new TinyQueue$1([[0, [0, pointSet1.length - 1], [0, pointSet2.length - 1]]], compareDistPair);
    while (distQueue.length > 0) {
        const distPair = distQueue.pop();
        if (distPair[0] >= miniDist) {
            continue;
        }
        const rangeA = distPair[1];
        const rangeB = distPair[2];
        const threshold1 = isLine1 ? MinLinePointsSize : MinPointsSize;
        const threshold2 = isLine2 ? MinLinePointsSize : MinPointsSize;
        // In case the set size are relatively small, we could use brute-force directly
        if (getRangeSize(rangeA) <= threshold1 && getRangeSize(rangeB) <= threshold2) {
            if (!isRangeSafe(rangeA, pointSet1.length) && isRangeSafe(rangeB, pointSet2.length)) {
                return NaN;
            }
            let tempDist;
            if (isLine1 && isLine2) {
                tempDist = lineToLineDistance(pointSet1, rangeA, pointSet2, rangeB, ruler);
                miniDist = Math.min(miniDist, tempDist);
            }
            else if (isLine1 && !isLine2) {
                const sublibe = pointSet1.slice(rangeA[0], rangeA[1] + 1);
                for (let i = rangeB[0]; i <= rangeB[1]; ++i) {
                    tempDist = pointToLineDistance(pointSet2[i], sublibe, ruler);
                    miniDist = Math.min(miniDist, tempDist);
                    if (miniDist === 0.0) {
                        return miniDist;
                    }
                }
            }
            else if (!isLine1 && isLine2) {
                const sublibe = pointSet2.slice(rangeB[0], rangeB[1] + 1);
                for (let i = rangeA[0]; i <= rangeA[1]; ++i) {
                    tempDist = pointToLineDistance(pointSet1[i], sublibe, ruler);
                    miniDist = Math.min(miniDist, tempDist);
                    if (miniDist === 0.0) {
                        return miniDist;
                    }
                }
            }
            else {
                tempDist = pointsToPointsDistance(pointSet1, rangeA, pointSet2, rangeB, ruler);
                miniDist = Math.min(miniDist, tempDist);
            }
        }
        else {
            const newRangesA = splitRange(rangeA, isLine1);
            const newRangesB = splitRange(rangeB, isLine2);
            updateQueueTwoSets(distQueue, miniDist, ruler, pointSet1, pointSet2, newRangesA[0], newRangesB[0]);
            updateQueueTwoSets(distQueue, miniDist, ruler, pointSet1, pointSet2, newRangesA[0], newRangesB[1]);
            updateQueueTwoSets(distQueue, miniDist, ruler, pointSet1, pointSet2, newRangesA[1], newRangesB[0]);
            updateQueueTwoSets(distQueue, miniDist, ruler, pointSet1, pointSet2, newRangesA[1], newRangesB[1]);
        }
    }
    return miniDist;
}
function pointToGeometryDistance(ctx, geometries) {
    const tilePoints = ctx.geometry();
    const pointPosition = tilePoints.flat().map(p => getLngLatFromTileCoord([p.x, p.y], ctx.canonical));
    if (tilePoints.length === 0) {
        return NaN;
    }
    const ruler = new CheapRuler(pointPosition[0][1]);
    let dist = Infinity;
    for (const geometry of geometries) {
        switch (geometry.type) {
            case 'Point':
                dist = Math.min(dist, pointSetToPointSetDistance(pointPosition, false, [geometry.coordinates], false, ruler, dist));
                break;
            case 'LineString':
                dist = Math.min(dist, pointSetToPointSetDistance(pointPosition, false, geometry.coordinates, true, ruler, dist));
                break;
            case 'Polygon':
                dist = Math.min(dist, pointsToPolygonDistance(pointPosition, false, geometry.coordinates, ruler, dist));
                break;
        }
        if (dist === 0.0) {
            return dist;
        }
    }
    return dist;
}
function lineStringToGeometryDistance(ctx, geometries) {
    const tileLine = ctx.geometry();
    const linePositions = tileLine.flat().map(p => getLngLatFromTileCoord([p.x, p.y], ctx.canonical));
    if (tileLine.length === 0) {
        return NaN;
    }
    const ruler = new CheapRuler(linePositions[0][1]);
    let dist = Infinity;
    for (const geometry of geometries) {
        switch (geometry.type) {
            case 'Point':
                dist = Math.min(dist, pointSetToPointSetDistance(linePositions, true, [geometry.coordinates], false, ruler, dist));
                break;
            case 'LineString':
                dist = Math.min(dist, pointSetToPointSetDistance(linePositions, true, geometry.coordinates, true, ruler, dist));
                break;
            case 'Polygon':
                dist = Math.min(dist, pointsToPolygonDistance(linePositions, true, geometry.coordinates, ruler, dist));
                break;
        }
        if (dist === 0.0) {
            return dist;
        }
    }
    return dist;
}
function polygonToGeometryDistance(ctx, geometries) {
    const tilePolygon = ctx.geometry();
    if (tilePolygon.length === 0 || tilePolygon[0].length === 0) {
        return NaN;
    }
    const polygons = classifyRings$1(tilePolygon, 0).map(polygon => {
        return polygon.map(ring => {
            return ring.map(p => getLngLatFromTileCoord([p.x, p.y], ctx.canonical));
        });
    });
    const ruler = new CheapRuler(polygons[0][0][0][1]);
    let dist = Infinity;
    for (const geometry of geometries) {
        for (const polygon of polygons) {
            switch (geometry.type) {
                case 'Point':
                    dist = Math.min(dist, pointsToPolygonDistance([geometry.coordinates], false, polygon, ruler, dist));
                    break;
                case 'LineString':
                    dist = Math.min(dist, pointsToPolygonDistance(geometry.coordinates, true, polygon, ruler, dist));
                    break;
                case 'Polygon':
                    dist = Math.min(dist, polygonToPolygonDistance(polygon, geometry.coordinates, ruler, dist));
                    break;
            }
            if (dist === 0.0) {
                return dist;
            }
        }
    }
    return dist;
}
function toSimpleGeometry(geometry) {
    if (geometry.type === 'MultiPolygon') {
        return geometry.coordinates.map(polygon => {
            return {
                type: 'Polygon',
                coordinates: polygon
            };
        });
    }
    if (geometry.type === 'MultiLineString') {
        return geometry.coordinates.map(lineString => {
            return {
                type: 'LineString',
                coordinates: lineString
            };
        });
    }
    if (geometry.type === 'MultiPoint') {
        return geometry.coordinates.map(point => {
            return {
                type: 'Point',
                coordinates: point
            };
        });
    }
    return [geometry];
}
class Distance {
    constructor(geojson, geometries) {
        this.type = NumberType;
        this.geojson = geojson;
        this.geometries = geometries;
    }
    static parse(args, context) {
        if (args.length !== 2)
            return context.error(`'distance' expression requires exactly one argument, but found ${args.length - 1} instead.`);
        if (isValue(args[1])) {
            const geojson = args[1];
            if (geojson.type === 'FeatureCollection') {
                return new Distance(geojson, geojson.features.map(feature => toSimpleGeometry(feature.geometry)).flat());
            }
            else if (geojson.type === 'Feature') {
                return new Distance(geojson, toSimpleGeometry(geojson.geometry));
            }
            else if ('type' in geojson && 'coordinates' in geojson) {
                return new Distance(geojson, toSimpleGeometry(geojson));
            }
        }
        return context.error('\'distance\' expression requires valid geojson object that contains polygon geometry type.');
    }
    evaluate(ctx) {
        if (ctx.geometry() != null && ctx.canonicalID() != null) {
            if (ctx.geometryType() === 'Point') {
                return pointToGeometryDistance(ctx, this.geometries);
            }
            else if (ctx.geometryType() === 'LineString') {
                return lineStringToGeometryDistance(ctx, this.geometries);
            }
            else if (ctx.geometryType() === 'Polygon') {
                return polygonToGeometryDistance(ctx, this.geometries);
            }
        }
        return NaN;
    }
    eachChild() { }
    outputDefined() {
        return true;
    }
}

const expressions$1 = {
    // special forms
    '==': Equals,
    '!=': NotEquals,
    '>': GreaterThan,
    '<': LessThan,
    '>=': GreaterThanOrEqual,
    '<=': LessThanOrEqual,
    'array': Assertion,
    'at': At,
    'boolean': Assertion,
    'case': Case,
    'coalesce': Coalesce,
    'collator': CollatorExpression,
    'format': FormatExpression,
    'image': ImageExpression,
    'in': In,
    'index-of': IndexOf,
    'interpolate': Interpolate,
    'interpolate-hcl': Interpolate,
    'interpolate-lab': Interpolate,
    'length': Length,
    'let': Let,
    'literal': Literal,
    'match': Match,
    'number': Assertion,
    'number-format': NumberFormat,
    'object': Assertion,
    'slice': Slice,
    'step': Step,
    'string': Assertion,
    'to-boolean': Coercion,
    'to-color': Coercion,
    'to-number': Coercion,
    'to-string': Coercion,
    'var': Var,
    'within': Within,
    'distance': Distance
};

class CompoundExpression {
    constructor(name, type, evaluate, args) {
        this.name = name;
        this.type = type;
        this._evaluate = evaluate;
        this.args = args;
    }
    evaluate(ctx) {
        return this._evaluate(ctx, this.args);
    }
    eachChild(fn) {
        this.args.forEach(fn);
    }
    outputDefined() {
        return false;
    }
    static parse(args, context) {
        const op = args[0];
        const definition = CompoundExpression.definitions[op];
        if (!definition) {
            return context.error(`Unknown expression "${op}". If you wanted a literal array, use ["literal", [...]].`, 0);
        }
        // Now check argument types against each signature
        const type = Array.isArray(definition) ?
            definition[0] : definition.type;
        const availableOverloads = Array.isArray(definition) ?
            [[definition[1], definition[2]]] :
            definition.overloads;
        const overloads = availableOverloads.filter(([signature]) => (!Array.isArray(signature) || // varags
            signature.length === args.length - 1 // correct param count
        ));
        let signatureContext = null;
        for (const [params, evaluate] of overloads) {
            // Use a fresh context for each attempted signature so that, if
            // we eventually succeed, we haven't polluted `context.errors`.
            signatureContext = new ParsingContext(context.registry, isExpressionConstant, context.path, null, context.scope);
            // First parse all the args, potentially coercing to the
            // types expected by this overload.
            const parsedArgs = [];
            let argParseFailed = false;
            for (let i = 1; i < args.length; i++) {
                const arg = args[i];
                const expectedType = Array.isArray(params) ?
                    params[i - 1] :
                    params.type;
                const parsed = signatureContext.parse(arg, 1 + parsedArgs.length, expectedType);
                if (!parsed) {
                    argParseFailed = true;
                    break;
                }
                parsedArgs.push(parsed);
            }
            if (argParseFailed) {
                // Couldn't coerce args of this overload to expected type, move
                // on to next one.
                continue;
            }
            if (Array.isArray(params)) {
                if (params.length !== parsedArgs.length) {
                    signatureContext.error(`Expected ${params.length} arguments, but found ${parsedArgs.length} instead.`);
                    continue;
                }
            }
            for (let i = 0; i < parsedArgs.length; i++) {
                const expected = Array.isArray(params) ? params[i] : params.type;
                const arg = parsedArgs[i];
                signatureContext.concat(i + 1).checkSubtype(expected, arg.type);
            }
            if (signatureContext.errors.length === 0) {
                return new CompoundExpression(op, type, evaluate, parsedArgs);
            }
        }
        if (overloads.length === 1) {
            context.errors.push(...signatureContext.errors);
        }
        else {
            const expected = overloads.length ? overloads : availableOverloads;
            const signatures = expected
                .map(([params]) => stringifySignature(params))
                .join(' | ');
            const actualTypes = [];
            // For error message, re-parse arguments without trying to
            // apply any coercions
            for (let i = 1; i < args.length; i++) {
                const parsed = context.parse(args[i], 1 + actualTypes.length);
                if (!parsed)
                    return null;
                actualTypes.push(toString$1(parsed.type));
            }
            context.error(`Expected arguments of type ${signatures}, but found (${actualTypes.join(', ')}) instead.`);
        }
        return null;
    }
    static register(registry, definitions) {
        CompoundExpression.definitions = definitions;
        for (const name in definitions) {
            registry[name] = CompoundExpression;
        }
    }
}
function rgba(ctx, [r, g, b, a]) {
    r = r.evaluate(ctx);
    g = g.evaluate(ctx);
    b = b.evaluate(ctx);
    const alpha = a ? a.evaluate(ctx) : 1;
    const error = validateRGBA(r, g, b, alpha);
    if (error)
        throw new RuntimeError(error);
    return new Color(r / 255, g / 255, b / 255, alpha, false);
}
function has(key, obj) {
    return key in obj;
}
function get(key, obj) {
    const v = obj[key];
    return typeof v === 'undefined' ? null : v;
}
function binarySearch(v, a, i, j) {
    while (i <= j) {
        const m = (i + j) >> 1;
        if (a[m] === v)
            return true;
        if (a[m] > v)
            j = m - 1;
        else
            i = m + 1;
    }
    return false;
}
function varargs(type) {
    return { type };
}
CompoundExpression.register(expressions$1, {
    'error': [
        ErrorType,
        [StringType],
        (ctx, [v]) => { throw new RuntimeError(v.evaluate(ctx)); }
    ],
    'typeof': [
        StringType,
        [ValueType],
        (ctx, [v]) => toString$1(typeOf(v.evaluate(ctx)))
    ],
    'to-rgba': [
        array$1(NumberType, 4),
        [ColorType],
        (ctx, [v]) => {
            const [r, g, b, a] = v.evaluate(ctx).rgb;
            return [r * 255, g * 255, b * 255, a];
        },
    ],
    'rgb': [
        ColorType,
        [NumberType, NumberType, NumberType],
        rgba
    ],
    'rgba': [
        ColorType,
        [NumberType, NumberType, NumberType, NumberType],
        rgba
    ],
    'has': {
        type: BooleanType,
        overloads: [
            [
                [StringType],
                (ctx, [key]) => has(key.evaluate(ctx), ctx.properties())
            ], [
                [StringType, ObjectType],
                (ctx, [key, obj]) => has(key.evaluate(ctx), obj.evaluate(ctx))
            ]
        ]
    },
    'get': {
        type: ValueType,
        overloads: [
            [
                [StringType],
                (ctx, [key]) => get(key.evaluate(ctx), ctx.properties())
            ], [
                [StringType, ObjectType],
                (ctx, [key, obj]) => get(key.evaluate(ctx), obj.evaluate(ctx))
            ]
        ]
    },
    'feature-state': [
        ValueType,
        [StringType],
        (ctx, [key]) => get(key.evaluate(ctx), ctx.featureState || {})
    ],
    'properties': [
        ObjectType,
        [],
        (ctx) => ctx.properties()
    ],
    'geometry-type': [
        StringType,
        [],
        (ctx) => ctx.geometryType()
    ],
    'id': [
        ValueType,
        [],
        (ctx) => ctx.id()
    ],
    'zoom': [
        NumberType,
        [],
        (ctx) => ctx.globals.zoom
    ],
    'heatmap-density': [
        NumberType,
        [],
        (ctx) => ctx.globals.heatmapDensity || 0
    ],
    'line-progress': [
        NumberType,
        [],
        (ctx) => ctx.globals.lineProgress || 0
    ],
    'accumulated': [
        ValueType,
        [],
        (ctx) => ctx.globals.accumulated === undefined ? null : ctx.globals.accumulated
    ],
    '+': [
        NumberType,
        varargs(NumberType),
        (ctx, args) => {
            let result = 0;
            for (const arg of args) {
                result += arg.evaluate(ctx);
            }
            return result;
        }
    ],
    '*': [
        NumberType,
        varargs(NumberType),
        (ctx, args) => {
            let result = 1;
            for (const arg of args) {
                result *= arg.evaluate(ctx);
            }
            return result;
        }
    ],
    '-': {
        type: NumberType,
        overloads: [
            [
                [NumberType, NumberType],
                (ctx, [a, b]) => a.evaluate(ctx) - b.evaluate(ctx)
            ], [
                [NumberType],
                (ctx, [a]) => -a.evaluate(ctx)
            ]
        ]
    },
    '/': [
        NumberType,
        [NumberType, NumberType],
        (ctx, [a, b]) => a.evaluate(ctx) / b.evaluate(ctx)
    ],
    '%': [
        NumberType,
        [NumberType, NumberType],
        (ctx, [a, b]) => a.evaluate(ctx) % b.evaluate(ctx)
    ],
    'ln2': [
        NumberType,
        [],
        () => Math.LN2
    ],
    'pi': [
        NumberType,
        [],
        () => Math.PI
    ],
    'e': [
        NumberType,
        [],
        () => Math.E
    ],
    '^': [
        NumberType,
        [NumberType, NumberType],
        (ctx, [b, e]) => Math.pow(b.evaluate(ctx), e.evaluate(ctx))
    ],
    'sqrt': [
        NumberType,
        [NumberType],
        (ctx, [x]) => Math.sqrt(x.evaluate(ctx))
    ],
    'log10': [
        NumberType,
        [NumberType],
        (ctx, [n]) => Math.log(n.evaluate(ctx)) / Math.LN10
    ],
    'ln': [
        NumberType,
        [NumberType],
        (ctx, [n]) => Math.log(n.evaluate(ctx))
    ],
    'log2': [
        NumberType,
        [NumberType],
        (ctx, [n]) => Math.log(n.evaluate(ctx)) / Math.LN2
    ],
    'sin': [
        NumberType,
        [NumberType],
        (ctx, [n]) => Math.sin(n.evaluate(ctx))
    ],
    'cos': [
        NumberType,
        [NumberType],
        (ctx, [n]) => Math.cos(n.evaluate(ctx))
    ],
    'tan': [
        NumberType,
        [NumberType],
        (ctx, [n]) => Math.tan(n.evaluate(ctx))
    ],
    'asin': [
        NumberType,
        [NumberType],
        (ctx, [n]) => Math.asin(n.evaluate(ctx))
    ],
    'acos': [
        NumberType,
        [NumberType],
        (ctx, [n]) => Math.acos(n.evaluate(ctx))
    ],
    'atan': [
        NumberType,
        [NumberType],
        (ctx, [n]) => Math.atan(n.evaluate(ctx))
    ],
    'min': [
        NumberType,
        varargs(NumberType),
        (ctx, args) => Math.min(...args.map(arg => arg.evaluate(ctx)))
    ],
    'max': [
        NumberType,
        varargs(NumberType),
        (ctx, args) => Math.max(...args.map(arg => arg.evaluate(ctx)))
    ],
    'abs': [
        NumberType,
        [NumberType],
        (ctx, [n]) => Math.abs(n.evaluate(ctx))
    ],
    'round': [
        NumberType,
        [NumberType],
        (ctx, [n]) => {
            const v = n.evaluate(ctx);
            // Javascript's Math.round() rounds towards +Infinity for halfway
            // values, even when they're negative. It's more common to round
            // away from 0 (e.g., this is what python and C++ do)
            return v < 0 ? -Math.round(-v) : Math.round(v);
        }
    ],
    'floor': [
        NumberType,
        [NumberType],
        (ctx, [n]) => Math.floor(n.evaluate(ctx))
    ],
    'ceil': [
        NumberType,
        [NumberType],
        (ctx, [n]) => Math.ceil(n.evaluate(ctx))
    ],
    'filter-==': [
        BooleanType,
        [StringType, ValueType],
        (ctx, [k, v]) => ctx.properties()[k.value] === v.value
    ],
    'filter-id-==': [
        BooleanType,
        [ValueType],
        (ctx, [v]) => ctx.id() === v.value
    ],
    'filter-type-==': [
        BooleanType,
        [StringType],
        (ctx, [v]) => ctx.geometryType() === v.value
    ],
    'filter-<': [
        BooleanType,
        [StringType, ValueType],
        (ctx, [k, v]) => {
            const a = ctx.properties()[k.value];
            const b = v.value;
            return typeof a === typeof b && a < b;
        }
    ],
    'filter-id-<': [
        BooleanType,
        [ValueType],
        (ctx, [v]) => {
            const a = ctx.id();
            const b = v.value;
            return typeof a === typeof b && a < b;
        }
    ],
    'filter->': [
        BooleanType,
        [StringType, ValueType],
        (ctx, [k, v]) => {
            const a = ctx.properties()[k.value];
            const b = v.value;
            return typeof a === typeof b && a > b;
        }
    ],
    'filter-id->': [
        BooleanType,
        [ValueType],
        (ctx, [v]) => {
            const a = ctx.id();
            const b = v.value;
            return typeof a === typeof b && a > b;
        }
    ],
    'filter-<=': [
        BooleanType,
        [StringType, ValueType],
        (ctx, [k, v]) => {
            const a = ctx.properties()[k.value];
            const b = v.value;
            return typeof a === typeof b && a <= b;
        }
    ],
    'filter-id-<=': [
        BooleanType,
        [ValueType],
        (ctx, [v]) => {
            const a = ctx.id();
            const b = v.value;
            return typeof a === typeof b && a <= b;
        }
    ],
    'filter->=': [
        BooleanType,
        [StringType, ValueType],
        (ctx, [k, v]) => {
            const a = ctx.properties()[k.value];
            const b = v.value;
            return typeof a === typeof b && a >= b;
        }
    ],
    'filter-id->=': [
        BooleanType,
        [ValueType],
        (ctx, [v]) => {
            const a = ctx.id();
            const b = v.value;
            return typeof a === typeof b && a >= b;
        }
    ],
    'filter-has': [
        BooleanType,
        [ValueType],
        (ctx, [k]) => k.value in ctx.properties()
    ],
    'filter-has-id': [
        BooleanType,
        [],
        (ctx) => (ctx.id() !== null && ctx.id() !== undefined)
    ],
    'filter-type-in': [
        BooleanType,
        [array$1(StringType)],
        (ctx, [v]) => v.value.indexOf(ctx.geometryType()) >= 0
    ],
    'filter-id-in': [
        BooleanType,
        [array$1(ValueType)],
        (ctx, [v]) => v.value.indexOf(ctx.id()) >= 0
    ],
    'filter-in-small': [
        BooleanType,
        [StringType, array$1(ValueType)],
        // assumes v is an array literal
        (ctx, [k, v]) => v.value.indexOf(ctx.properties()[k.value]) >= 0
    ],
    'filter-in-large': [
        BooleanType,
        [StringType, array$1(ValueType)],
        // assumes v is a array literal with values sorted in ascending order and of a single type
        (ctx, [k, v]) => binarySearch(ctx.properties()[k.value], v.value, 0, v.value.length - 1)
    ],
    'all': {
        type: BooleanType,
        overloads: [
            [
                [BooleanType, BooleanType],
                (ctx, [a, b]) => a.evaluate(ctx) && b.evaluate(ctx)
            ],
            [
                varargs(BooleanType),
                (ctx, args) => {
                    for (const arg of args) {
                        if (!arg.evaluate(ctx))
                            return false;
                    }
                    return true;
                }
            ]
        ]
    },
    'any': {
        type: BooleanType,
        overloads: [
            [
                [BooleanType, BooleanType],
                (ctx, [a, b]) => a.evaluate(ctx) || b.evaluate(ctx)
            ],
            [
                varargs(BooleanType),
                (ctx, args) => {
                    for (const arg of args) {
                        if (arg.evaluate(ctx))
                            return true;
                    }
                    return false;
                }
            ]
        ]
    },
    '!': [
        BooleanType,
        [BooleanType],
        (ctx, [b]) => !b.evaluate(ctx)
    ],
    'is-supported-script': [
        BooleanType,
        [StringType],
        // At parse time this will always return true, so we need to exclude this expression with isGlobalPropertyConstant
        (ctx, [s]) => {
            const isSupportedScript = ctx.globals && ctx.globals.isSupportedScript;
            if (isSupportedScript) {
                return isSupportedScript(s.evaluate(ctx));
            }
            return true;
        }
    ],
    'upcase': [
        StringType,
        [StringType],
        (ctx, [s]) => s.evaluate(ctx).toUpperCase()
    ],
    'downcase': [
        StringType,
        [StringType],
        (ctx, [s]) => s.evaluate(ctx).toLowerCase()
    ],
    'concat': [
        StringType,
        varargs(ValueType),
        (ctx, args) => args.map(arg => toString(arg.evaluate(ctx))).join('')
    ],
    'resolved-locale': [
        StringType,
        [CollatorType],
        (ctx, [collator]) => collator.evaluate(ctx).resolvedLocale()
    ]
});
function stringifySignature(signature) {
    if (Array.isArray(signature)) {
        return `(${signature.map(toString$1).join(', ')})`;
    }
    else {
        return `(${toString$1(signature.type)}...)`;
    }
}
function isExpressionConstant(expression) {
    if (expression instanceof Var) {
        return isExpressionConstant(expression.boundExpression);
    }
    else if (expression instanceof CompoundExpression && expression.name === 'error') {
        return false;
    }
    else if (expression instanceof CollatorExpression) {
        // Although the results of a Collator expression with fixed arguments
        // generally shouldn't change between executions, we can't serialize them
        // as constant expressions because results change based on environment.
        return false;
    }
    else if (expression instanceof Within) {
        return false;
    }
    else if (expression instanceof Distance) {
        return false;
    }
    const isTypeAnnotation = expression instanceof Coercion ||
        expression instanceof Assertion;
    let childrenConstant = true;
    expression.eachChild(child => {
        // We can _almost_ assume that if `expressions` children are constant,
        // they would already have been evaluated to Literal values when they
        // were parsed.  Type annotations are the exception, because they might
        // have been inferred and added after a child was parsed.
        // So we recurse into isConstant() for the children of type annotations,
        // but otherwise simply check whether they are Literals.
        if (isTypeAnnotation) {
            childrenConstant = childrenConstant && isExpressionConstant(child);
        }
        else {
            childrenConstant = childrenConstant && child instanceof Literal;
        }
    });
    if (!childrenConstant) {
        return false;
    }
    return isFeatureConstant(expression) &&
        isGlobalPropertyConstant(expression, ['zoom', 'heatmap-density', 'line-progress', 'accumulated', 'is-supported-script']);
}
function isFeatureConstant(e) {
    if (e instanceof CompoundExpression) {
        if (e.name === 'get' && e.args.length === 1) {
            return false;
        }
        else if (e.name === 'feature-state') {
            return false;
        }
        else if (e.name === 'has' && e.args.length === 1) {
            return false;
        }
        else if (e.name === 'properties' ||
            e.name === 'geometry-type' ||
            e.name === 'id') {
            return false;
        }
        else if (/^filter-/.test(e.name)) {
            return false;
        }
    }
    if (e instanceof Within) {
        return false;
    }
    if (e instanceof Distance) {
        return false;
    }
    let result = true;
    e.eachChild(arg => {
        if (result && !isFeatureConstant(arg)) {
            result = false;
        }
    });
    return result;
}
function isStateConstant(e) {
    if (e instanceof CompoundExpression) {
        if (e.name === 'feature-state') {
            return false;
        }
    }
    let result = true;
    e.eachChild(arg => {
        if (result && !isStateConstant(arg)) {
            result = false;
        }
    });
    return result;
}
function isGlobalPropertyConstant(e, properties) {
    if (e instanceof CompoundExpression && properties.indexOf(e.name) >= 0) {
        return false;
    }
    let result = true;
    e.eachChild((arg) => {
        if (result && !isGlobalPropertyConstant(arg, properties)) {
            result = false;
        }
    });
    return result;
}

function success(value) {
    return { result: 'success', value };
}
function error(value) {
    return { result: 'error', value };
}

function supportsPropertyExpression(spec) {
    return spec['property-type'] === 'data-driven' || spec['property-type'] === 'cross-faded-data-driven';
}
function supportsZoomExpression(spec) {
    return !!spec.expression && spec.expression.parameters.indexOf('zoom') > -1;
}
function supportsInterpolation(spec) {
    return !!spec.expression && spec.expression.interpolated;
}

function getType(val) {
    if (val instanceof Number) {
        return 'number';
    }
    else if (val instanceof String) {
        return 'string';
    }
    else if (val instanceof Boolean) {
        return 'boolean';
    }
    else if (Array.isArray(val)) {
        return 'array';
    }
    else if (val === null) {
        return 'null';
    }
    else {
        return typeof val;
    }
}

function isFunction$1(value) {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
}
function identityFunction(x) {
    return x;
}
function createFunction(parameters, propertySpec) {
    const isColor = propertySpec.type === 'color';
    const zoomAndFeatureDependent = parameters.stops && typeof parameters.stops[0][0] === 'object';
    const featureDependent = zoomAndFeatureDependent || parameters.property !== undefined;
    const zoomDependent = zoomAndFeatureDependent || !featureDependent;
    const type = parameters.type || (supportsInterpolation(propertySpec) ? 'exponential' : 'interval');
    if (isColor || propertySpec.type === 'padding') {
        const parseFn = isColor ? Color.parse : Padding.parse;
        parameters = extendBy({}, parameters);
        if (parameters.stops) {
            parameters.stops = parameters.stops.map((stop) => {
                return [stop[0], parseFn(stop[1])];
            });
        }
        if (parameters.default) {
            parameters.default = parseFn(parameters.default);
        }
        else {
            parameters.default = parseFn(propertySpec.default);
        }
    }
    if (parameters.colorSpace && !isSupportedInterpolationColorSpace(parameters.colorSpace)) {
        throw new Error(`Unknown color space: "${parameters.colorSpace}"`);
    }
    let innerFun;
    let hashedStops;
    let categoricalKeyType;
    if (type === 'exponential') {
        innerFun = evaluateExponentialFunction;
    }
    else if (type === 'interval') {
        innerFun = evaluateIntervalFunction;
    }
    else if (type === 'categorical') {
        innerFun = evaluateCategoricalFunction;
        // For categorical functions, generate an Object as a hashmap of the stops for fast searching
        hashedStops = Object.create(null);
        for (const stop of parameters.stops) {
            hashedStops[stop[0]] = stop[1];
        }
        // Infer key type based on first stop key-- used to encforce strict type checking later
        categoricalKeyType = typeof parameters.stops[0][0];
    }
    else if (type === 'identity') {
        innerFun = evaluateIdentityFunction;
    }
    else {
        throw new Error(`Unknown function type "${type}"`);
    }
    if (zoomAndFeatureDependent) {
        const featureFunctions = {};
        const zoomStops = [];
        for (let s = 0; s < parameters.stops.length; s++) {
            const stop = parameters.stops[s];
            const zoom = stop[0].zoom;
            if (featureFunctions[zoom] === undefined) {
                featureFunctions[zoom] = {
                    zoom,
                    type: parameters.type,
                    property: parameters.property,
                    default: parameters.default,
                    stops: []
                };
                zoomStops.push(zoom);
            }
            featureFunctions[zoom].stops.push([stop[0].value, stop[1]]);
        }
        const featureFunctionStops = [];
        for (const z of zoomStops) {
            featureFunctionStops.push([featureFunctions[z].zoom, createFunction(featureFunctions[z], propertySpec)]);
        }
        const interpolationType = { name: 'linear' };
        return {
            kind: 'composite',
            interpolationType,
            interpolationFactor: Interpolate.interpolationFactor.bind(undefined, interpolationType),
            zoomStops: featureFunctionStops.map(s => s[0]),
            evaluate({ zoom }, properties) {
                return evaluateExponentialFunction({
                    stops: featureFunctionStops,
                    base: parameters.base
                }, propertySpec, zoom).evaluate(zoom, properties);
            }
        };
    }
    else if (zoomDependent) {
        const interpolationType = type === 'exponential' ?
            { name: 'exponential', base: parameters.base !== undefined ? parameters.base : 1 } : null;
        return {
            kind: 'camera',
            interpolationType,
            interpolationFactor: Interpolate.interpolationFactor.bind(undefined, interpolationType),
            zoomStops: parameters.stops.map(s => s[0]),
            evaluate: ({ zoom }) => innerFun(parameters, propertySpec, zoom, hashedStops, categoricalKeyType)
        };
    }
    else {
        return {
            kind: 'source',
            evaluate(_, feature) {
                const value = feature && feature.properties ? feature.properties[parameters.property] : undefined;
                if (value === undefined) {
                    return coalesce$1(parameters.default, propertySpec.default);
                }
                return innerFun(parameters, propertySpec, value, hashedStops, categoricalKeyType);
            }
        };
    }
}
function coalesce$1(a, b, c) {
    if (a !== undefined)
        return a;
    if (b !== undefined)
        return b;
    if (c !== undefined)
        return c;
}
function evaluateCategoricalFunction(parameters, propertySpec, input, hashedStops, keyType) {
    const evaluated = typeof input === keyType ? hashedStops[input] : undefined; // Enforce strict typing on input
    return coalesce$1(evaluated, parameters.default, propertySpec.default);
}
function evaluateIntervalFunction(parameters, propertySpec, input) {
    // Edge cases
    if (getType(input) !== 'number')
        return coalesce$1(parameters.default, propertySpec.default);
    const n = parameters.stops.length;
    if (n === 1)
        return parameters.stops[0][1];
    if (input <= parameters.stops[0][0])
        return parameters.stops[0][1];
    if (input >= parameters.stops[n - 1][0])
        return parameters.stops[n - 1][1];
    const index = findStopLessThanOrEqualTo(parameters.stops.map((stop) => stop[0]), input);
    return parameters.stops[index][1];
}
function evaluateExponentialFunction(parameters, propertySpec, input) {
    const base = parameters.base !== undefined ? parameters.base : 1;
    // Edge cases
    if (getType(input) !== 'number')
        return coalesce$1(parameters.default, propertySpec.default);
    const n = parameters.stops.length;
    if (n === 1)
        return parameters.stops[0][1];
    if (input <= parameters.stops[0][0])
        return parameters.stops[0][1];
    if (input >= parameters.stops[n - 1][0])
        return parameters.stops[n - 1][1];
    const index = findStopLessThanOrEqualTo(parameters.stops.map((stop) => stop[0]), input);
    const t = interpolationFactor(input, base, parameters.stops[index][0], parameters.stops[index + 1][0]);
    const outputLower = parameters.stops[index][1];
    const outputUpper = parameters.stops[index + 1][1];
    const interp = interpolate[propertySpec.type] || identityFunction;
    if (typeof outputLower.evaluate === 'function') {
        return {
            evaluate(...args) {
                const evaluatedLower = outputLower.evaluate.apply(undefined, args);
                const evaluatedUpper = outputUpper.evaluate.apply(undefined, args);
                // Special case for fill-outline-color, which has no spec default.
                if (evaluatedLower === undefined || evaluatedUpper === undefined) {
                    return undefined;
                }
                return interp(evaluatedLower, evaluatedUpper, t, parameters.colorSpace);
            }
        };
    }
    return interp(outputLower, outputUpper, t, parameters.colorSpace);
}
function evaluateIdentityFunction(parameters, propertySpec, input) {
    switch (propertySpec.type) {
        case 'color':
            input = Color.parse(input);
            break;
        case 'formatted':
            input = Formatted.fromString(input.toString());
            break;
        case 'resolvedImage':
            input = ResolvedImage.fromString(input.toString());
            break;
        case 'padding':
            input = Padding.parse(input);
            break;
        default:
            if (getType(input) !== propertySpec.type && (propertySpec.type !== 'enum' || !propertySpec.values[input])) {
                input = undefined;
            }
    }
    return coalesce$1(input, parameters.default, propertySpec.default);
}
/**
 * Returns a ratio that can be used to interpolate between exponential function
 * stops.
 *
 * How it works:
 * Two consecutive stop values define a (scaled and shifted) exponential
 * function `f(x) = a * base^x + b`, where `base` is the user-specified base,
 * and `a` and `b` are constants affording sufficient degrees of freedom to fit
 * the function to the given stops.
 *
 * Here's a bit of algebra that lets us compute `f(x)` directly from the stop
 * values without explicitly solving for `a` and `b`:
 *
 * First stop value: `f(x0) = y0 = a * base^x0 + b`
 * Second stop value: `f(x1) = y1 = a * base^x1 + b`
 * => `y1 - y0 = a(base^x1 - base^x0)`
 * => `a = (y1 - y0)/(base^x1 - base^x0)`
 *
 * Desired value: `f(x) = y = a * base^x + b`
 * => `f(x) = y0 + a * (base^x - base^x0)`
 *
 * From the above, we can replace the `a` in `a * (base^x - base^x0)` and do a
 * little algebra:
 * ```
 * a * (base^x - base^x0) = (y1 - y0)/(base^x1 - base^x0) * (base^x - base^x0)
 *                     = (y1 - y0) * (base^x - base^x0) / (base^x1 - base^x0)
 * ```
 *
 * If we let `(base^x - base^x0) / (base^x1 base^x0)`, then we have
 * `f(x) = y0 + (y1 - y0) * ratio`.  In other words, `ratio` may be treated as
 * an interpolation factor between the two stops' output values.
 *
 * (Note: a slightly different form for `ratio`,
 * `(base^(x-x0) - 1) / (base^(x1-x0) - 1) `, is equivalent, but requires fewer
 * expensive `Math.pow()` operations.)
 *
 * @private
 */
function interpolationFactor(input, base, lowerValue, upperValue) {
    const difference = upperValue - lowerValue;
    const progress = input - lowerValue;
    if (difference === 0) {
        return 0;
    }
    else if (base === 1) {
        return progress / difference;
    }
    else {
        return (Math.pow(base, progress) - 1) / (Math.pow(base, difference) - 1);
    }
}

class StyleExpression {
    constructor(expression, propertySpec) {
        this.expression = expression;
        this._warningHistory = {};
        this._evaluator = new EvaluationContext();
        this._defaultValue = propertySpec ? getDefaultValue(propertySpec) : null;
        this._enumValues = propertySpec && propertySpec.type === 'enum' ? propertySpec.values : null;
    }
    evaluateWithoutErrorHandling(globals, feature, featureState, canonical, availableImages, formattedSection) {
        this._evaluator.globals = globals;
        this._evaluator.feature = feature;
        this._evaluator.featureState = featureState;
        this._evaluator.canonical = canonical;
        this._evaluator.availableImages = availableImages || null;
        this._evaluator.formattedSection = formattedSection;
        return this.expression.evaluate(this._evaluator);
    }
    evaluate(globals, feature, featureState, canonical, availableImages, formattedSection) {
        this._evaluator.globals = globals;
        this._evaluator.feature = feature || null;
        this._evaluator.featureState = featureState || null;
        this._evaluator.canonical = canonical;
        this._evaluator.availableImages = availableImages || null;
        this._evaluator.formattedSection = formattedSection || null;
        try {
            const val = this.expression.evaluate(this._evaluator);
            // eslint-disable-next-line no-self-compare
            if (val === null || val === undefined || (typeof val === 'number' && val !== val)) {
                return this._defaultValue;
            }
            if (this._enumValues && !(val in this._enumValues)) {
                throw new RuntimeError(`Expected value to be one of ${Object.keys(this._enumValues).map(v => JSON.stringify(v)).join(', ')}, but found ${JSON.stringify(val)} instead.`);
            }
            return val;
        }
        catch (e) {
            if (!this._warningHistory[e.message]) {
                this._warningHistory[e.message] = true;
                if (typeof console !== 'undefined') {
                    console.warn(e.message);
                }
            }
            return this._defaultValue;
        }
    }
}
function isExpression(expression) {
    return Array.isArray(expression) && expression.length > 0 &&
        typeof expression[0] === 'string' && expression[0] in expressions$1;
}
/**
 * Parse and typecheck the given style spec JSON expression.  If
 * options.defaultValue is provided, then the resulting StyleExpression's
 * `evaluate()` method will handle errors by logging a warning (once per
 * message) and returning the default value.  Otherwise, it will throw
 * evaluation errors.
 *
 * @private
 */
function createExpression(expression, propertySpec) {
    const parser = new ParsingContext(expressions$1, isExpressionConstant, [], propertySpec ? getExpectedType(propertySpec) : undefined);
    // For string-valued properties, coerce to string at the top level rather than asserting.
    const parsed = parser.parse(expression, undefined, undefined, undefined, propertySpec && propertySpec.type === 'string' ? { typeAnnotation: 'coerce' } : undefined);
    if (!parsed) {
        return error(parser.errors);
    }
    return success(new StyleExpression(parsed, propertySpec));
}
class ZoomConstantExpression {
    constructor(kind, expression) {
        this.kind = kind;
        this._styleExpression = expression;
        this.isStateDependent = kind !== 'constant' && !isStateConstant(expression.expression);
    }
    evaluateWithoutErrorHandling(globals, feature, featureState, canonical, availableImages, formattedSection) {
        return this._styleExpression.evaluateWithoutErrorHandling(globals, feature, featureState, canonical, availableImages, formattedSection);
    }
    evaluate(globals, feature, featureState, canonical, availableImages, formattedSection) {
        return this._styleExpression.evaluate(globals, feature, featureState, canonical, availableImages, formattedSection);
    }
}
class ZoomDependentExpression {
    constructor(kind, expression, zoomStops, interpolationType) {
        this.kind = kind;
        this.zoomStops = zoomStops;
        this._styleExpression = expression;
        this.isStateDependent = kind !== 'camera' && !isStateConstant(expression.expression);
        this.interpolationType = interpolationType;
    }
    evaluateWithoutErrorHandling(globals, feature, featureState, canonical, availableImages, formattedSection) {
        return this._styleExpression.evaluateWithoutErrorHandling(globals, feature, featureState, canonical, availableImages, formattedSection);
    }
    evaluate(globals, feature, featureState, canonical, availableImages, formattedSection) {
        return this._styleExpression.evaluate(globals, feature, featureState, canonical, availableImages, formattedSection);
    }
    interpolationFactor(input, lower, upper) {
        if (this.interpolationType) {
            return Interpolate.interpolationFactor(this.interpolationType, input, lower, upper);
        }
        else {
            return 0;
        }
    }
}
function isZoomExpression(expression) {
    return expression._styleExpression !== undefined;
}
function createPropertyExpression(expressionInput, propertySpec) {
    const expression = createExpression(expressionInput, propertySpec);
    if (expression.result === 'error') {
        return expression;
    }
    const parsed = expression.value.expression;
    const isFeatureConstantResult = isFeatureConstant(parsed);
    if (!isFeatureConstantResult && !supportsPropertyExpression(propertySpec)) {
        return error([new ExpressionParsingError('', 'data expressions not supported')]);
    }
    const isZoomConstant = isGlobalPropertyConstant(parsed, ['zoom']);
    if (!isZoomConstant && !supportsZoomExpression(propertySpec)) {
        return error([new ExpressionParsingError('', 'zoom expressions not supported')]);
    }
    const zoomCurve = findZoomCurve(parsed);
    if (!zoomCurve && !isZoomConstant) {
        return error([new ExpressionParsingError('', '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.')]);
    }
    else if (zoomCurve instanceof ExpressionParsingError) {
        return error([zoomCurve]);
    }
    else if (zoomCurve instanceof Interpolate && !supportsInterpolation(propertySpec)) {
        return error([new ExpressionParsingError('', '"interpolate" expressions cannot be used with this property')]);
    }
    if (!zoomCurve) {
        return success(isFeatureConstantResult ?
            new ZoomConstantExpression('constant', expression.value) :
            new ZoomConstantExpression('source', expression.value));
    }
    const interpolationType = zoomCurve instanceof Interpolate ? zoomCurve.interpolation : undefined;
    return success(isFeatureConstantResult ?
        new ZoomDependentExpression('camera', expression.value, zoomCurve.labels, interpolationType) :
        new ZoomDependentExpression('composite', expression.value, zoomCurve.labels, interpolationType));
}
// serialization wrapper for old-style stop functions normalized to the
// expression interface
class StylePropertyFunction {
    constructor(parameters, specification) {
        this._parameters = parameters;
        this._specification = specification;
        extendBy(this, createFunction(this._parameters, this._specification));
    }
    static deserialize(serialized) {
        return new StylePropertyFunction(serialized._parameters, serialized._specification);
    }
    static serialize(input) {
        return {
            _parameters: input._parameters,
            _specification: input._specification
        };
    }
}
function normalizePropertyExpression(value, specification) {
    if (isFunction$1(value)) {
        return new StylePropertyFunction(value, specification);
    }
    else if (isExpression(value)) {
        const expression = createPropertyExpression(value, specification);
        if (expression.result === 'error') {
            // this should have been caught in validation
            throw new Error(expression.value.map(err => `${err.key}: ${err.message}`).join(', '));
        }
        return expression.value;
    }
    else {
        let constant = value;
        if (specification.type === 'color' && typeof value === 'string') {
            constant = Color.parse(value);
        }
        else if (specification.type === 'padding' && (typeof value === 'number' || Array.isArray(value))) {
            constant = Padding.parse(value);
        }
        else if (specification.type === 'variableAnchorOffsetCollection' && Array.isArray(value)) {
            constant = VariableAnchorOffsetCollection.parse(value);
        }
        return {
            kind: 'constant',
            evaluate: () => constant
        };
    }
}
// Zoom-dependent expressions may only use ["zoom"] as the input to a top-level "step" or "interpolate"
// expression (collectively referred to as a "curve"). The curve may be wrapped in one or more "let" or
// "coalesce" expressions.
function findZoomCurve(expression) {
    let result = null;
    if (expression instanceof Let) {
        result = findZoomCurve(expression.result);
    }
    else if (expression instanceof Coalesce) {
        for (const arg of expression.args) {
            result = findZoomCurve(arg);
            if (result) {
                break;
            }
        }
    }
    else if ((expression instanceof Step || expression instanceof Interpolate) &&
        expression.input instanceof CompoundExpression &&
        expression.input.name === 'zoom') {
        result = expression;
    }
    if (result instanceof ExpressionParsingError) {
        return result;
    }
    expression.eachChild((child) => {
        const childResult = findZoomCurve(child);
        if (childResult instanceof ExpressionParsingError) {
            result = childResult;
        }
        else if (!result && childResult) {
            result = new ExpressionParsingError('', '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.');
        }
        else if (result && childResult && result !== childResult) {
            result = new ExpressionParsingError('', 'Only one zoom-based "step" or "interpolate" subexpression may be used in an expression.');
        }
    });
    return result;
}
function getExpectedType(spec) {
    const types = {
        color: ColorType,
        string: StringType,
        number: NumberType,
        enum: StringType,
        boolean: BooleanType,
        formatted: FormattedType,
        padding: PaddingType,
        resolvedImage: ResolvedImageType,
        variableAnchorOffsetCollection: VariableAnchorOffsetCollectionType
    };
    if (spec.type === 'array') {
        return array$1(types[spec.value] || ValueType, spec.length);
    }
    return types[spec.type];
}
function getDefaultValue(spec) {
    if (spec.type === 'color' && isFunction$1(spec.default)) {
        // Special case for heatmap-color: it uses the 'default:' to define a
        // default color ramp, but createExpression expects a simple value to fall
        // back to in case of runtime errors
        return new Color(0, 0, 0, 0);
    }
    else if (spec.type === 'color') {
        return Color.parse(spec.default) || null;
    }
    else if (spec.type === 'padding') {
        return Padding.parse(spec.default) || null;
    }
    else if (spec.type === 'variableAnchorOffsetCollection') {
        return VariableAnchorOffsetCollection.parse(spec.default) || null;
    }
    else if (spec.default === undefined) {
        return null;
    }
    else {
        return spec.default;
    }
}

function isExpressionFilter(filter) {
    if (filter === true || filter === false) {
        return true;
    }
    if (!Array.isArray(filter) || filter.length === 0) {
        return false;
    }
    switch (filter[0]) {
        case 'has':
            return filter.length >= 2 && filter[1] !== '$id' && filter[1] !== '$type';
        case 'in':
            return filter.length >= 3 && (typeof filter[1] !== 'string' || Array.isArray(filter[2]));
        case '!in':
        case '!has':
        case 'none':
            return false;
        case '==':
        case '!=':
        case '>':
        case '>=':
        case '<':
        case '<=':
            return filter.length !== 3 || (Array.isArray(filter[1]) || Array.isArray(filter[2]));
        case 'any':
        case 'all':
            for (const f of filter.slice(1)) {
                if (!isExpressionFilter(f) && typeof f !== 'boolean') {
                    return false;
                }
            }
            return true;
        default:
            return true;
    }
}
const filterSpec = {
    'type': 'boolean',
    'default': false,
    'transition': false,
    'property-type': 'data-driven',
    'expression': {
        'interpolated': false,
        'parameters': ['zoom', 'feature']
    }
};
/**
 * Given a filter expressed as nested arrays, return a new function
 * that evaluates whether a given feature (with a .properties or .tags property)
 * passes its test.
 *
 * @private
 * @param {Array} filter MapLibre filter
 * @returns {Function} filter-evaluating function
 */
function createFilter(filter) {
    if (filter === null || filter === undefined) {
        return { filter: () => true, needGeometry: false };
    }
    if (!isExpressionFilter(filter)) {
        filter = convertFilter$1(filter);
    }
    const compiled = createExpression(filter, filterSpec);
    if (compiled.result === 'error') {
        throw new Error(compiled.value.map(err => `${err.key}: ${err.message}`).join(', '));
    }
    else {
        const needGeometry = geometryNeeded(filter);
        return { filter: (globalProperties, feature, canonical) => compiled.value.evaluate(globalProperties, feature, {}, canonical),
            needGeometry };
    }
}
// Comparison function to sort numbers and strings
function compare(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
}
function geometryNeeded(filter) {
    if (!Array.isArray(filter))
        return false;
    if (filter[0] === 'within' || filter[0] === 'distance')
        return true;
    for (let index = 1; index < filter.length; index++) {
        if (geometryNeeded(filter[index]))
            return true;
    }
    return false;
}
function convertFilter$1(filter) {
    if (!filter)
        return true;
    const op = filter[0];
    if (filter.length <= 1)
        return (op !== 'any');
    const converted = op === '==' ? convertComparisonOp$1(filter[1], filter[2], '==') :
        op === '!=' ? convertNegation(convertComparisonOp$1(filter[1], filter[2], '==')) :
            op === '<' ||
                op === '>' ||
                op === '<=' ||
                op === '>=' ? convertComparisonOp$1(filter[1], filter[2], op) :
                op === 'any' ? convertDisjunctionOp(filter.slice(1)) :
                    op === 'all' ? ['all'].concat(filter.slice(1).map(convertFilter$1)) :
                        op === 'none' ? ['all'].concat(filter.slice(1).map(convertFilter$1).map(convertNegation)) :
                            op === 'in' ? convertInOp$1(filter[1], filter.slice(2)) :
                                op === '!in' ? convertNegation(convertInOp$1(filter[1], filter.slice(2))) :
                                    op === 'has' ? convertHasOp$1(filter[1]) :
                                        op === '!has' ? convertNegation(convertHasOp$1(filter[1])) :
                                            true;
    return converted;
}
function convertComparisonOp$1(property, value, op) {
    switch (property) {
        case '$type':
            return [`filter-type-${op}`, value];
        case '$id':
            return [`filter-id-${op}`, value];
        default:
            return [`filter-${op}`, property, value];
    }
}
function convertDisjunctionOp(filters) {
    return ['any'].concat(filters.map(convertFilter$1));
}
function convertInOp$1(property, values) {
    if (values.length === 0) {
        return false;
    }
    switch (property) {
        case '$type':
            return ['filter-type-in', ['literal', values]];
        case '$id':
            return ['filter-id-in', ['literal', values]];
        default:
            if (values.length > 200 && !values.some(v => typeof v !== typeof values[0])) {
                return ['filter-in-large', property, ['literal', values.sort(compare)]];
            }
            else {
                return ['filter-in-small', property, ['literal', values]];
            }
    }
}
function convertHasOp$1(property) {
    switch (property) {
        case '$type':
            return true;
        case '$id':
            return ['filter-has-id'];
        default:
            return ['filter-has', property];
    }
}
function convertNegation(filter) {
    return ['!', filter];
}

function stringify$1(obj) {
    const type = typeof obj;
    if (type === 'number' || type === 'boolean' || type === 'string' || obj === undefined || obj === null)
        return JSON.stringify(obj);
    if (Array.isArray(obj)) {
        let str = '[';
        for (const val of obj) {
            str += `${stringify$1(val)},`;
        }
        return `${str}]`;
    }
    const keys = Object.keys(obj).sort();
    let str = '{';
    for (let i = 0; i < keys.length; i++) {
        str += `${JSON.stringify(keys[i])}:${stringify$1(obj[keys[i]])},`;
    }
    return `${str}}`;
}
function getKey(layer) {
    let key = '';
    for (const k of refProperties) {
        key += `/${stringify$1(layer[k])}`;
    }
    return key;
}
/**
 * Given an array of layers, return an array of arrays of layers where all
 * layers in each group have identical layout-affecting properties. These
 * are the properties that were formerly used by explicit `ref` mechanism
 * for layers: 'type', 'source', 'source-layer', 'minzoom', 'maxzoom',
 * 'filter', and 'layout'.
 *
 * The input is not modified. The output layers are references to the
 * input layers.
 *
 * @private
 * @param {Array<Layer>} layers
 * @param {Object} [cachedKeys] - an object to keep already calculated keys.
 * @returns {Array<Array<Layer>>}
 */
function groupByLayout(layers, cachedKeys) {
    const groups = {};
    for (let i = 0; i < layers.length; i++) {
        const k = (cachedKeys && cachedKeys[layers[i].id]) || getKey(layers[i]);
        // update the cache if there is one
        if (cachedKeys)
            cachedKeys[layers[i].id] = k;
        let group = groups[k];
        if (!group) {
            group = groups[k] = [];
        }
        group.push(layers[i]);
    }
    const result = [];
    for (const k in groups) {
        result.push(groups[k]);
    }
    return result;
}

function emptyStyle() {
    const style = {};
    const version = v8Spec['$version'];
    for (const styleKey in v8Spec['$root']) {
        const spec = v8Spec['$root'][styleKey];
        if (spec.required) {
            let value = null;
            if (styleKey === 'version') {
                value = version;
            }
            else {
                if (spec.type === 'array') {
                    value = [];
                }
                else {
                    value = {};
                }
            }
            if (value != null) {
                style[styleKey] = value;
            }
        }
    }
    return style;
}

function validateConstants(options) {
    const key = options.key;
    const constants = options.value;
    if (constants) {
        return [new ValidationError(key, constants, 'constants have been deprecated as of v8')];
    }
    else {
        return [];
    }
}

// Turn jsonlint-lines-primitives objects into primitive objects
function unbundle(value) {
    if (value instanceof Number || value instanceof String || value instanceof Boolean) {
        return value.valueOf();
    }
    else {
        return value;
    }
}
function deepUnbundle(value) {
    if (Array.isArray(value)) {
        return value.map(deepUnbundle);
    }
    else if (value instanceof Object && !(value instanceof Number || value instanceof String || value instanceof Boolean)) {
        const unbundledValue = {};
        for (const key in value) {
            unbundledValue[key] = deepUnbundle(value[key]);
        }
        return unbundledValue;
    }
    return unbundle(value);
}

function validateObject(options) {
    const key = options.key;
    const object = options.value;
    const elementSpecs = options.valueSpec || {};
    const elementValidators = options.objectElementValidators || {};
    const style = options.style;
    const styleSpec = options.styleSpec;
    const validateSpec = options.validateSpec;
    let errors = [];
    const type = getType(object);
    if (type !== 'object') {
        return [new ValidationError(key, object, `object expected, ${type} found`)];
    }
    for (const objectKey in object) {
        const elementSpecKey = objectKey.split('.')[0]; // treat 'paint.*' as 'paint'
        const elementSpec = elementSpecs[elementSpecKey] || elementSpecs['*'];
        let validateElement;
        if (elementValidators[elementSpecKey]) {
            validateElement = elementValidators[elementSpecKey];
        }
        else if (elementSpecs[elementSpecKey]) {
            validateElement = validateSpec;
        }
        else if (elementValidators['*']) {
            validateElement = elementValidators['*'];
        }
        else if (elementSpecs['*']) {
            validateElement = validateSpec;
        }
        else {
            errors.push(new ValidationError(key, object[objectKey], `unknown property "${objectKey}"`));
            continue;
        }
        errors = errors.concat(validateElement({
            key: (key ? `${key}.` : key) + objectKey,
            value: object[objectKey],
            valueSpec: elementSpec,
            style,
            styleSpec,
            object,
            objectKey,
            validateSpec,
        }, object));
    }
    for (const elementSpecKey in elementSpecs) {
        // Don't check `required` when there's a custom validator for that property.
        if (elementValidators[elementSpecKey]) {
            continue;
        }
        if (elementSpecs[elementSpecKey].required && elementSpecs[elementSpecKey]['default'] === undefined && object[elementSpecKey] === undefined) {
            errors.push(new ValidationError(key, object, `missing required property "${elementSpecKey}"`));
        }
    }
    return errors;
}

function validateArray(options) {
    const array = options.value;
    const arraySpec = options.valueSpec;
    const validateSpec = options.validateSpec;
    const style = options.style;
    const styleSpec = options.styleSpec;
    const key = options.key;
    const validateArrayElement = options.arrayElementValidator || validateSpec;
    if (getType(array) !== 'array') {
        return [new ValidationError(key, array, `array expected, ${getType(array)} found`)];
    }
    if (arraySpec.length && array.length !== arraySpec.length) {
        return [new ValidationError(key, array, `array length ${arraySpec.length} expected, length ${array.length} found`)];
    }
    if (arraySpec['min-length'] && array.length < arraySpec['min-length']) {
        return [new ValidationError(key, array, `array length at least ${arraySpec['min-length']} expected, length ${array.length} found`)];
    }
    let arrayElementSpec = {
        'type': arraySpec.value,
        'values': arraySpec.values
    };
    if (styleSpec.$version < 7) {
        arrayElementSpec['function'] = arraySpec.function;
    }
    if (getType(arraySpec.value) === 'object') {
        arrayElementSpec = arraySpec.value;
    }
    let errors = [];
    for (let i = 0; i < array.length; i++) {
        errors = errors.concat(validateArrayElement({
            array,
            arrayIndex: i,
            value: array[i],
            valueSpec: arrayElementSpec,
            validateSpec: options.validateSpec,
            style,
            styleSpec,
            key: `${key}[${i}]`
        }));
    }
    return errors;
}

function validateNumber(options) {
    const key = options.key;
    const value = options.value;
    const valueSpec = options.valueSpec;
    let type = getType(value);
    // eslint-disable-next-line no-self-compare
    if (type === 'number' && value !== value) {
        type = 'NaN';
    }
    if (type !== 'number') {
        return [new ValidationError(key, value, `number expected, ${type} found`)];
    }
    if ('minimum' in valueSpec && value < valueSpec.minimum) {
        return [new ValidationError(key, value, `${value} is less than the minimum value ${valueSpec.minimum}`)];
    }
    if ('maximum' in valueSpec && value > valueSpec.maximum) {
        return [new ValidationError(key, value, `${value} is greater than the maximum value ${valueSpec.maximum}`)];
    }
    return [];
}

function validateFunction(options) {
    const functionValueSpec = options.valueSpec;
    const functionType = unbundle(options.value.type);
    let stopKeyType;
    let stopDomainValues = {};
    let previousStopDomainValue;
    let previousStopDomainZoom;
    const isZoomFunction = functionType !== 'categorical' && options.value.property === undefined;
    const isPropertyFunction = !isZoomFunction;
    const isZoomAndPropertyFunction = getType(options.value.stops) === 'array' &&
        getType(options.value.stops[0]) === 'array' &&
        getType(options.value.stops[0][0]) === 'object';
    const errors = validateObject({
        key: options.key,
        value: options.value,
        valueSpec: options.styleSpec.function,
        validateSpec: options.validateSpec,
        style: options.style,
        styleSpec: options.styleSpec,
        objectElementValidators: {
            stops: validateFunctionStops,
            default: validateFunctionDefault
        }
    });
    if (functionType === 'identity' && isZoomFunction) {
        errors.push(new ValidationError(options.key, options.value, 'missing required property "property"'));
    }
    if (functionType !== 'identity' && !options.value.stops) {
        errors.push(new ValidationError(options.key, options.value, 'missing required property "stops"'));
    }
    if (functionType === 'exponential' && options.valueSpec.expression && !supportsInterpolation(options.valueSpec)) {
        errors.push(new ValidationError(options.key, options.value, 'exponential functions not supported'));
    }
    if (options.styleSpec.$version >= 8) {
        if (isPropertyFunction && !supportsPropertyExpression(options.valueSpec)) {
            errors.push(new ValidationError(options.key, options.value, 'property functions not supported'));
        }
        else if (isZoomFunction && !supportsZoomExpression(options.valueSpec)) {
            errors.push(new ValidationError(options.key, options.value, 'zoom functions not supported'));
        }
    }
    if ((functionType === 'categorical' || isZoomAndPropertyFunction) && options.value.property === undefined) {
        errors.push(new ValidationError(options.key, options.value, '"property" property is required'));
    }
    return errors;
    function validateFunctionStops(options) {
        if (functionType === 'identity') {
            return [new ValidationError(options.key, options.value, 'identity function may not have a "stops" property')];
        }
        let errors = [];
        const value = options.value;
        errors = errors.concat(validateArray({
            key: options.key,
            value,
            valueSpec: options.valueSpec,
            validateSpec: options.validateSpec,
            style: options.style,
            styleSpec: options.styleSpec,
            arrayElementValidator: validateFunctionStop
        }));
        if (getType(value) === 'array' && value.length === 0) {
            errors.push(new ValidationError(options.key, value, 'array must have at least one stop'));
        }
        return errors;
    }
    function validateFunctionStop(options) {
        let errors = [];
        const value = options.value;
        const key = options.key;
        if (getType(value) !== 'array') {
            return [new ValidationError(key, value, `array expected, ${getType(value)} found`)];
        }
        if (value.length !== 2) {
            return [new ValidationError(key, value, `array length 2 expected, length ${value.length} found`)];
        }
        if (isZoomAndPropertyFunction) {
            if (getType(value[0]) !== 'object') {
                return [new ValidationError(key, value, `object expected, ${getType(value[0])} found`)];
            }
            if (value[0].zoom === undefined) {
                return [new ValidationError(key, value, 'object stop key must have zoom')];
            }
            if (value[0].value === undefined) {
                return [new ValidationError(key, value, 'object stop key must have value')];
            }
            if (previousStopDomainZoom && previousStopDomainZoom > unbundle(value[0].zoom)) {
                return [new ValidationError(key, value[0].zoom, 'stop zoom values must appear in ascending order')];
            }
            if (unbundle(value[0].zoom) !== previousStopDomainZoom) {
                previousStopDomainZoom = unbundle(value[0].zoom);
                previousStopDomainValue = undefined;
                stopDomainValues = {};
            }
            errors = errors.concat(validateObject({
                key: `${key}[0]`,
                value: value[0],
                valueSpec: { zoom: {} },
                validateSpec: options.validateSpec,
                style: options.style,
                styleSpec: options.styleSpec,
                objectElementValidators: { zoom: validateNumber, value: validateStopDomainValue }
            }));
        }
        else {
            errors = errors.concat(validateStopDomainValue({
                key: `${key}[0]`,
                value: value[0],
                valueSpec: {},
                validateSpec: options.validateSpec,
                style: options.style,
                styleSpec: options.styleSpec
            }, value));
        }
        if (isExpression(deepUnbundle(value[1]))) {
            return errors.concat([new ValidationError(`${key}[1]`, value[1], 'expressions are not allowed in function stops.')]);
        }
        return errors.concat(options.validateSpec({
            key: `${key}[1]`,
            value: value[1],
            valueSpec: functionValueSpec,
            validateSpec: options.validateSpec,
            style: options.style,
            styleSpec: options.styleSpec
        }));
    }
    function validateStopDomainValue(options, stop) {
        const type = getType(options.value);
        const value = unbundle(options.value);
        const reportValue = options.value !== null ? options.value : stop;
        if (!stopKeyType) {
            stopKeyType = type;
        }
        else if (type !== stopKeyType) {
            return [new ValidationError(options.key, reportValue, `${type} stop domain type must match previous stop domain type ${stopKeyType}`)];
        }
        if (type !== 'number' && type !== 'string' && type !== 'boolean') {
            return [new ValidationError(options.key, reportValue, 'stop domain value must be a number, string, or boolean')];
        }
        if (type !== 'number' && functionType !== 'categorical') {
            let message = `number expected, ${type} found`;
            if (supportsPropertyExpression(functionValueSpec) && functionType === undefined) {
                message += '\nIf you intended to use a categorical function, specify `"type": "categorical"`.';
            }
            return [new ValidationError(options.key, reportValue, message)];
        }
        if (functionType === 'categorical' && type === 'number' && (!isFinite(value) || Math.floor(value) !== value)) {
            return [new ValidationError(options.key, reportValue, `integer expected, found ${value}`)];
        }
        if (functionType !== 'categorical' && type === 'number' && previousStopDomainValue !== undefined && value < previousStopDomainValue) {
            return [new ValidationError(options.key, reportValue, 'stop domain values must appear in ascending order')];
        }
        else {
            previousStopDomainValue = value;
        }
        if (functionType === 'categorical' && value in stopDomainValues) {
            return [new ValidationError(options.key, reportValue, 'stop domain values must be unique')];
        }
        else {
            stopDomainValues[value] = true;
        }
        return [];
    }
    function validateFunctionDefault(options) {
        return options.validateSpec({
            key: options.key,
            value: options.value,
            valueSpec: functionValueSpec,
            validateSpec: options.validateSpec,
            style: options.style,
            styleSpec: options.styleSpec
        });
    }
}

function validateExpression(options) {
    const expression = (options.expressionContext === 'property' ? createPropertyExpression : createExpression)(deepUnbundle(options.value), options.valueSpec);
    if (expression.result === 'error') {
        return expression.value.map((error) => {
            return new ValidationError(`${options.key}${error.key}`, options.value, error.message);
        });
    }
    const expressionObj = expression.value.expression || expression.value._styleExpression.expression;
    if (options.expressionContext === 'property' && (options.propertyKey === 'text-font') &&
        !expressionObj.outputDefined()) {
        return [new ValidationError(options.key, options.value, `Invalid data expression for "${options.propertyKey}". Output values must be contained as literals within the expression.`)];
    }
    if (options.expressionContext === 'property' && options.propertyType === 'layout' &&
        (!isStateConstant(expressionObj))) {
        return [new ValidationError(options.key, options.value, '"feature-state" data expressions are not supported with layout properties.')];
    }
    if (options.expressionContext === 'filter' && !isStateConstant(expressionObj)) {
        return [new ValidationError(options.key, options.value, '"feature-state" data expressions are not supported with filters.')];
    }
    if (options.expressionContext && options.expressionContext.indexOf('cluster') === 0) {
        if (!isGlobalPropertyConstant(expressionObj, ['zoom', 'feature-state'])) {
            return [new ValidationError(options.key, options.value, '"zoom" and "feature-state" expressions are not supported with cluster properties.')];
        }
        if (options.expressionContext === 'cluster-initial' && !isFeatureConstant(expressionObj)) {
            return [new ValidationError(options.key, options.value, 'Feature data expressions are not supported with initial expression part of cluster properties.')];
        }
    }
    return [];
}

function validateBoolean(options) {
    const value = options.value;
    const key = options.key;
    const type = getType(value);
    if (type !== 'boolean') {
        return [new ValidationError(key, value, `boolean expected, ${type} found`)];
    }
    return [];
}

function validateColor(options) {
    const key = options.key;
    const value = options.value;
    const type = getType(value);
    if (type !== 'string') {
        return [new ValidationError(key, value, `color expected, ${type} found`)];
    }
    if (!Color.parse(String(value))) { // cast String object to string primitive
        return [new ValidationError(key, value, `color expected, "${value}" found`)];
    }
    return [];
}

function validateEnum(options) {
    const key = options.key;
    const value = options.value;
    const valueSpec = options.valueSpec;
    const errors = [];
    if (Array.isArray(valueSpec.values)) { // <=v7
        if (valueSpec.values.indexOf(unbundle(value)) === -1) {
            errors.push(new ValidationError(key, value, `expected one of [${valueSpec.values.join(', ')}], ${JSON.stringify(value)} found`));
        }
    }
    else { // >=v8
        if (Object.keys(valueSpec.values).indexOf(unbundle(value)) === -1) {
            errors.push(new ValidationError(key, value, `expected one of [${Object.keys(valueSpec.values).join(', ')}], ${JSON.stringify(value)} found`));
        }
    }
    return errors;
}

function validateFilter(options) {
    if (isExpressionFilter(deepUnbundle(options.value))) {
        return validateExpression(extendBy({}, options, {
            expressionContext: 'filter',
            valueSpec: { value: 'boolean' }
        }));
    }
    else {
        return validateNonExpressionFilter(options);
    }
}
function validateNonExpressionFilter(options) {
    const value = options.value;
    const key = options.key;
    if (getType(value) !== 'array') {
        return [new ValidationError(key, value, `array expected, ${getType(value)} found`)];
    }
    const styleSpec = options.styleSpec;
    let type;
    let errors = [];
    if (value.length < 1) {
        return [new ValidationError(key, value, 'filter array must have at least 1 element')];
    }
    errors = errors.concat(validateEnum({
        key: `${key}[0]`,
        value: value[0],
        valueSpec: styleSpec.filter_operator,
        style: options.style,
        styleSpec: options.styleSpec
    }));
    switch (unbundle(value[0])) {
        case '<':
        case '<=':
        case '>':
        case '>=':
            if (value.length >= 2 && unbundle(value[1]) === '$type') {
                errors.push(new ValidationError(key, value, `"$type" cannot be use with operator "${value[0]}"`));
            }
        /* falls through */
        case '==':
        case '!=':
            if (value.length !== 3) {
                errors.push(new ValidationError(key, value, `filter array for operator "${value[0]}" must have 3 elements`));
            }
        /* falls through */
        case 'in':
        case '!in':
            if (value.length >= 2) {
                type = getType(value[1]);
                if (type !== 'string') {
                    errors.push(new ValidationError(`${key}[1]`, value[1], `string expected, ${type} found`));
                }
            }
            for (let i = 2; i < value.length; i++) {
                type = getType(value[i]);
                if (unbundle(value[1]) === '$type') {
                    errors = errors.concat(validateEnum({
                        key: `${key}[${i}]`,
                        value: value[i],
                        valueSpec: styleSpec.geometry_type,
                        style: options.style,
                        styleSpec: options.styleSpec
                    }));
                }
                else if (type !== 'string' && type !== 'number' && type !== 'boolean') {
                    errors.push(new ValidationError(`${key}[${i}]`, value[i], `string, number, or boolean expected, ${type} found`));
                }
            }
            break;
        case 'any':
        case 'all':
        case 'none':
            for (let i = 1; i < value.length; i++) {
                errors = errors.concat(validateNonExpressionFilter({
                    key: `${key}[${i}]`,
                    value: value[i],
                    style: options.style,
                    styleSpec: options.styleSpec
                }));
            }
            break;
        case 'has':
        case '!has':
            type = getType(value[1]);
            if (value.length !== 2) {
                errors.push(new ValidationError(key, value, `filter array for "${value[0]}" operator must have 2 elements`));
            }
            else if (type !== 'string') {
                errors.push(new ValidationError(`${key}[1]`, value[1], `string expected, ${type} found`));
            }
            break;
    }
    return errors;
}

function validateProperty(options, propertyType) {
    const key = options.key;
    const validateSpec = options.validateSpec;
    const style = options.style;
    const styleSpec = options.styleSpec;
    const value = options.value;
    const propertyKey = options.objectKey;
    const layerSpec = styleSpec[`${propertyType}_${options.layerType}`];
    if (!layerSpec)
        return [];
    const transitionMatch = propertyKey.match(/^(.*)-transition$/);
    if (propertyType === 'paint' && transitionMatch && layerSpec[transitionMatch[1]] && layerSpec[transitionMatch[1]].transition) {
        return validateSpec({
            key,
            value,
            valueSpec: styleSpec.transition,
            style,
            styleSpec
        });
    }
    const valueSpec = options.valueSpec || layerSpec[propertyKey];
    if (!valueSpec) {
        return [new ValidationError(key, value, `unknown property "${propertyKey}"`)];
    }
    let tokenMatch;
    if (getType(value) === 'string' && supportsPropertyExpression(valueSpec) && !valueSpec.tokens && (tokenMatch = /^{([^}]+)}$/.exec(value))) {
        return [new ValidationError(key, value, `"${propertyKey}" does not support interpolation syntax\n` +
                `Use an identity property function instead: \`{ "type": "identity", "property": ${JSON.stringify(tokenMatch[1])} }\`.`)];
    }
    const errors = [];
    if (options.layerType === 'symbol') {
        if (propertyKey === 'text-field' && style && !style.glyphs) {
            errors.push(new ValidationError(key, value, 'use of "text-field" requires a style "glyphs" property'));
        }
        if (propertyKey === 'text-font' && isFunction$1(deepUnbundle(value)) && unbundle(value.type) === 'identity') {
            errors.push(new ValidationError(key, value, '"text-font" does not support identity functions'));
        }
    }
    return errors.concat(validateSpec({
        key: options.key,
        value,
        valueSpec,
        style,
        styleSpec,
        expressionContext: 'property',
        propertyType,
        propertyKey
    }));
}

function validatePaintProperty$1(options) {
    return validateProperty(options, 'paint');
}

function validateLayoutProperty$1(options) {
    return validateProperty(options, 'layout');
}

function validateLayer(options) {
    let errors = [];
    const layer = options.value;
    const key = options.key;
    const style = options.style;
    const styleSpec = options.styleSpec;
    if (!layer.type && !layer.ref) {
        errors.push(new ValidationError(key, layer, 'either "type" or "ref" is required'));
    }
    let type = unbundle(layer.type);
    const ref = unbundle(layer.ref);
    if (layer.id) {
        const layerId = unbundle(layer.id);
        for (let i = 0; i < options.arrayIndex; i++) {
            const otherLayer = style.layers[i];
            if (unbundle(otherLayer.id) === layerId) {
                errors.push(new ValidationError(key, layer.id, `duplicate layer id "${layer.id}", previously used at line ${otherLayer.id.__line__}`));
            }
        }
    }
    if ('ref' in layer) {
        ['type', 'source', 'source-layer', 'filter', 'layout'].forEach((p) => {
            if (p in layer) {
                errors.push(new ValidationError(key, layer[p], `"${p}" is prohibited for ref layers`));
            }
        });
        let parent;
        style.layers.forEach((layer) => {
            if (unbundle(layer.id) === ref)
                parent = layer;
        });
        if (!parent) {
            errors.push(new ValidationError(key, layer.ref, `ref layer "${ref}" not found`));
        }
        else if (parent.ref) {
            errors.push(new ValidationError(key, layer.ref, 'ref cannot reference another ref layer'));
        }
        else {
            type = unbundle(parent.type);
        }
    }
    else if (type !== 'background') {
        if (!layer.source) {
            errors.push(new ValidationError(key, layer, 'missing required property "source"'));
        }
        else {
            const source = style.sources && style.sources[layer.source];
            const sourceType = source && unbundle(source.type);
            if (!source) {
                errors.push(new ValidationError(key, layer.source, `source "${layer.source}" not found`));
            }
            else if (sourceType === 'vector' && type === 'raster') {
                errors.push(new ValidationError(key, layer.source, `layer "${layer.id}" requires a raster source`));
            }
            else if (sourceType !== 'raster-dem' && type === 'hillshade') {
                errors.push(new ValidationError(key, layer.source, `layer "${layer.id}" requires a raster-dem source`));
            }
            else if (sourceType === 'raster' && type !== 'raster') {
                errors.push(new ValidationError(key, layer.source, `layer "${layer.id}" requires a vector source`));
            }
            else if (sourceType === 'vector' && !layer['source-layer']) {
                errors.push(new ValidationError(key, layer, `layer "${layer.id}" must specify a "source-layer"`));
            }
            else if (sourceType === 'raster-dem' && type !== 'hillshade') {
                errors.push(new ValidationError(key, layer.source, 'raster-dem source can only be used with layer type \'hillshade\'.'));
            }
            else if (type === 'line' && layer.paint && layer.paint['line-gradient'] &&
                (sourceType !== 'geojson' || !source.lineMetrics)) {
                errors.push(new ValidationError(key, layer, `layer "${layer.id}" specifies a line-gradient, which requires a GeoJSON source with \`lineMetrics\` enabled.`));
            }
        }
    }
    errors = errors.concat(validateObject({
        key,
        value: layer,
        valueSpec: styleSpec.layer,
        style: options.style,
        styleSpec: options.styleSpec,
        validateSpec: options.validateSpec,
        objectElementValidators: {
            '*'() {
                return [];
            },
            // We don't want to enforce the spec's `"requires": true` for backward compatibility with refs;
            // the actual requirement is validated above. See https://github.com/mapbox/mapbox-gl-js/issues/5772.
            type() {
                return options.validateSpec({
                    key: `${key}.type`,
                    value: layer.type,
                    valueSpec: styleSpec.layer.type,
                    style: options.style,
                    styleSpec: options.styleSpec,
                    validateSpec: options.validateSpec,
                    object: layer,
                    objectKey: 'type'
                });
            },
            filter: validateFilter,
            layout(options) {
                return validateObject({
                    layer,
                    key: options.key,
                    value: options.value,
                    style: options.style,
                    styleSpec: options.styleSpec,
                    validateSpec: options.validateSpec,
                    objectElementValidators: {
                        '*'(options) {
                            return validateLayoutProperty$1(extendBy({ layerType: type }, options));
                        }
                    }
                });
            },
            paint(options) {
                return validateObject({
                    layer,
                    key: options.key,
                    value: options.value,
                    style: options.style,
                    styleSpec: options.styleSpec,
                    validateSpec: options.validateSpec,
                    objectElementValidators: {
                        '*'(options) {
                            return validatePaintProperty$1(extendBy({ layerType: type }, options));
                        }
                    }
                });
            }
        }
    }));
    return errors;
}

function validateString(options) {
    const value = options.value;
    const key = options.key;
    const type = getType(value);
    if (type !== 'string') {
        return [new ValidationError(key, value, `string expected, ${type} found`)];
    }
    return [];
}

function validateRasterDEMSource(options) {
    var _a;
    const sourceName = (_a = options.sourceName) !== null && _a !== void 0 ? _a : '';
    const rasterDEM = options.value;
    const styleSpec = options.styleSpec;
    const rasterDEMSpec = styleSpec.source_raster_dem;
    const style = options.style;
    let errors = [];
    const rootType = getType(rasterDEM);
    if (rasterDEM === undefined) {
        return errors;
    }
    else if (rootType !== 'object') {
        errors.push(new ValidationError('source_raster_dem', rasterDEM, `object expected, ${rootType} found`));
        return errors;
    }
    const encoding = unbundle(rasterDEM.encoding);
    const isCustomEncoding = encoding === 'custom';
    const customEncodingKeys = ['redFactor', 'greenFactor', 'blueFactor', 'baseShift'];
    const encodingName = options.value.encoding ? `"${options.value.encoding}"` : 'Default';
    for (const key in rasterDEM) {
        if (!isCustomEncoding && customEncodingKeys.includes(key)) {
            errors.push(new ValidationError(key, rasterDEM[key], `In "${sourceName}": "${key}" is only valid when "encoding" is set to "custom". ${encodingName} encoding found`));
        }
        else if (rasterDEMSpec[key]) {
            errors = errors.concat(options.validateSpec({
                key,
                value: rasterDEM[key],
                valueSpec: rasterDEMSpec[key],
                validateSpec: options.validateSpec,
                style,
                styleSpec
            }));
        }
        else {
            errors.push(new ValidationError(key, rasterDEM[key], `unknown property "${key}"`));
        }
    }
    return errors;
}

const objectElementValidators = {
    promoteId: validatePromoteId
};
function validateSource(options) {
    const value = options.value;
    const key = options.key;
    const styleSpec = options.styleSpec;
    const style = options.style;
    const validateSpec = options.validateSpec;
    if (!value.type) {
        return [new ValidationError(key, value, '"type" is required')];
    }
    const type = unbundle(value.type);
    let errors;
    switch (type) {
        case 'vector':
        case 'raster':
            errors = validateObject({
                key,
                value,
                valueSpec: styleSpec[`source_${type.replace('-', '_')}`],
                style: options.style,
                styleSpec,
                objectElementValidators,
                validateSpec,
            });
            return errors;
        case 'raster-dem':
            errors = validateRasterDEMSource({
                sourceName: key,
                value,
                style: options.style,
                styleSpec,
                validateSpec,
            });
            return errors;
        case 'geojson':
            errors = validateObject({
                key,
                value,
                valueSpec: styleSpec.source_geojson,
                style,
                styleSpec,
                validateSpec,
                objectElementValidators
            });
            if (value.cluster) {
                for (const prop in value.clusterProperties) {
                    const [operator, mapExpr] = value.clusterProperties[prop];
                    const reduceExpr = typeof operator === 'string' ? [operator, ['accumulated'], ['get', prop]] : operator;
                    errors.push(...validateExpression({
                        key: `${key}.${prop}.map`,
                        value: mapExpr,
                        validateSpec,
                        expressionContext: 'cluster-map'
                    }));
                    errors.push(...validateExpression({
                        key: `${key}.${prop}.reduce`,
                        value: reduceExpr,
                        validateSpec,
                        expressionContext: 'cluster-reduce'
                    }));
                }
            }
            return errors;
        case 'video':
            return validateObject({
                key,
                value,
                valueSpec: styleSpec.source_video,
                style,
                validateSpec,
                styleSpec
            });
        case 'image':
            return validateObject({
                key,
                value,
                valueSpec: styleSpec.source_image,
                style,
                validateSpec,
                styleSpec
            });
        case 'canvas':
            return [new ValidationError(key, null, 'Please use runtime APIs to add canvas sources, rather than including them in stylesheets.', 'source.canvas')];
        default:
            return validateEnum({
                key: `${key}.type`,
                value: value.type,
                valueSpec: { values: ['vector', 'raster', 'raster-dem', 'geojson', 'video', 'image'] },
                style,
                validateSpec,
                styleSpec
            });
    }
}
function validatePromoteId({ key, value }) {
    if (getType(value) === 'string') {
        return validateString({ key, value });
    }
    else {
        const errors = [];
        for (const prop in value) {
            errors.push(...validateString({ key: `${key}.${prop}`, value: value[prop] }));
        }
        return errors;
    }
}

function validateLight$1(options) {
    const light = options.value;
    const styleSpec = options.styleSpec;
    const lightSpec = styleSpec.light;
    const style = options.style;
    let errors = [];
    const rootType = getType(light);
    if (light === undefined) {
        return errors;
    }
    else if (rootType !== 'object') {
        errors = errors.concat([new ValidationError('light', light, `object expected, ${rootType} found`)]);
        return errors;
    }
    for (const key in light) {
        const transitionMatch = key.match(/^(.*)-transition$/);
        if (transitionMatch && lightSpec[transitionMatch[1]] && lightSpec[transitionMatch[1]].transition) {
            errors = errors.concat(options.validateSpec({
                key,
                value: light[key],
                valueSpec: styleSpec.transition,
                validateSpec: options.validateSpec,
                style,
                styleSpec
            }));
        }
        else if (lightSpec[key]) {
            errors = errors.concat(options.validateSpec({
                key,
                value: light[key],
                valueSpec: lightSpec[key],
                validateSpec: options.validateSpec,
                style,
                styleSpec
            }));
        }
        else {
            errors = errors.concat([new ValidationError(key, light[key], `unknown property "${key}"`)]);
        }
    }
    return errors;
}

function validateSky$1(options) {
    const sky = options.value;
    const styleSpec = options.styleSpec;
    const skySpec = styleSpec.sky;
    const style = options.style;
    const rootType = getType(sky);
    if (sky === undefined) {
        return [];
    }
    else if (rootType !== 'object') {
        return [new ValidationError('sky', sky, `object expected, ${rootType} found`)];
    }
    let errors = [];
    for (const key in sky) {
        if (skySpec[key]) {
            errors = errors.concat(options.validateSpec({
                key,
                value: sky[key],
                valueSpec: skySpec[key],
                style,
                styleSpec
            }));
        }
        else {
            errors = errors.concat([new ValidationError(key, sky[key], `unknown property "${key}"`)]);
        }
    }
    return errors;
}

function validateTerrain(options) {
    const terrain = options.value;
    const styleSpec = options.styleSpec;
    const terrainSpec = styleSpec.terrain;
    const style = options.style;
    let errors = [];
    const rootType = getType(terrain);
    if (terrain === undefined) {
        return errors;
    }
    else if (rootType !== 'object') {
        errors = errors.concat([new ValidationError('terrain', terrain, `object expected, ${rootType} found`)]);
        return errors;
    }
    for (const key in terrain) {
        if (terrainSpec[key]) {
            errors = errors.concat(options.validateSpec({
                key,
                value: terrain[key],
                valueSpec: terrainSpec[key],
                validateSpec: options.validateSpec,
                style,
                styleSpec
            }));
        }
        else {
            errors = errors.concat([new ValidationError(key, terrain[key], `unknown property "${key}"`)]);
        }
    }
    return errors;
}

function validateFormatted(options) {
    if (validateString(options).length === 0) {
        return [];
    }
    return validateExpression(options);
}

function validateImage(options) {
    if (validateString(options).length === 0) {
        return [];
    }
    return validateExpression(options);
}

function validatePadding(options) {
    const key = options.key;
    const value = options.value;
    const type = getType(value);
    if (type === 'array') {
        if (value.length < 1 || value.length > 4) {
            return [new ValidationError(key, value, `padding requires 1 to 4 values; ${value.length} values found`)];
        }
        const arrayElementSpec = {
            type: 'number'
        };
        let errors = [];
        for (let i = 0; i < value.length; i++) {
            errors = errors.concat(options.validateSpec({
                key: `${key}[${i}]`,
                value: value[i],
                validateSpec: options.validateSpec,
                valueSpec: arrayElementSpec
            }));
        }
        return errors;
    }
    else {
        return validateNumber({
            key,
            value,
            valueSpec: {}
        });
    }
}

function validateVariableAnchorOffsetCollection(options) {
    const key = options.key;
    const value = options.value;
    const type = getType(value);
    const styleSpec = options.styleSpec;
    if (type !== 'array' || value.length < 1 || value.length % 2 !== 0) {
        return [new ValidationError(key, value, 'variableAnchorOffsetCollection requires a non-empty array of even length')];
    }
    let errors = [];
    for (let i = 0; i < value.length; i += 2) {
        // Elements in even positions should be values from text-anchor enum
        errors = errors.concat(validateEnum({
            key: `${key}[${i}]`,
            value: value[i],
            valueSpec: styleSpec['layout_symbol']['text-anchor']
        }));
        // Elements in odd positions should be points (2-element numeric arrays)
        errors = errors.concat(validateArray({
            key: `${key}[${i + 1}]`,
            value: value[i + 1],
            valueSpec: {
                length: 2,
                value: 'number'
            },
            validateSpec: options.validateSpec,
            style: options.style,
            styleSpec
        }));
    }
    return errors;
}

function validateSprite(options) {
    let errors = [];
    const sprite = options.value;
    const key = options.key;
    if (!Array.isArray(sprite)) {
        return validateString({
            key,
            value: sprite
        });
    }
    else {
        const allSpriteIds = [];
        const allSpriteURLs = [];
        for (const i in sprite) {
            if (sprite[i].id && allSpriteIds.includes(sprite[i].id))
                errors.push(new ValidationError(key, sprite, `all the sprites' ids must be unique, but ${sprite[i].id} is duplicated`));
            allSpriteIds.push(sprite[i].id);
            if (sprite[i].url && allSpriteURLs.includes(sprite[i].url))
                errors.push(new ValidationError(key, sprite, `all the sprites' URLs must be unique, but ${sprite[i].url} is duplicated`));
            allSpriteURLs.push(sprite[i].url);
            const pairSpec = {
                id: {
                    type: 'string',
                    required: true,
                },
                url: {
                    type: 'string',
                    required: true,
                }
            };
            errors = errors.concat(validateObject({
                key: `${key}[${i}]`,
                value: sprite[i],
                valueSpec: pairSpec,
                validateSpec: options.validateSpec,
            }));
        }
        return errors;
    }
}

function validateProjection(options) {
    const projection = options.value;
    const styleSpec = options.styleSpec;
    const projectionSpec = styleSpec.projection;
    const style = options.style;
    const rootType = getType(projection);
    if (projection === undefined) {
        return [];
    }
    else if (rootType !== 'object') {
        return [new ValidationError('projection', projection, `object expected, ${rootType} found`)];
    }
    let errors = [];
    for (const key in projection) {
        if (projectionSpec[key]) {
            errors = errors.concat(options.validateSpec({
                key,
                value: projection[key],
                valueSpec: projectionSpec[key],
                style,
                styleSpec
            }));
        }
        else {
            errors = errors.concat([new ValidationError(key, projection[key], `unknown property "${key}"`)]);
        }
    }
    return errors;
}

const VALIDATORS = {
    '*'() {
        return [];
    },
    'array': validateArray,
    'boolean': validateBoolean,
    'number': validateNumber,
    'color': validateColor,
    'constants': validateConstants,
    'enum': validateEnum,
    'filter': validateFilter,
    'function': validateFunction,
    'layer': validateLayer,
    'object': validateObject,
    'source': validateSource,
    'light': validateLight$1,
    'sky': validateSky$1,
    'terrain': validateTerrain,
    'projection': validateProjection,
    'string': validateString,
    'formatted': validateFormatted,
    'resolvedImage': validateImage,
    'padding': validatePadding,
    'variableAnchorOffsetCollection': validateVariableAnchorOffsetCollection,
    'sprite': validateSprite,
};
/**
 * Main recursive validation function used internally.
 * You should use `validateStyleMin` in the browser or `validateStyle` in node env.
 * @param options - the options object
 * @param options.key - string representing location of validation in style tree. Used only
 * for more informative error reporting.
 * @param options.value - current value from style being evaluated. May be anything from a
 * high level object that needs to be descended into deeper or a simple
 * scalar value.
 * @param options.valueSpec - current spec being evaluated. Tracks value.
 * @param options.styleSpec - current full spec being evaluated.
 * @param options.validateSpec - the validate function itself
 * @param options.style - the style object
 * @param options.objectElementValidators - optional object of functions that will be called
 * @returns an array of errors, or an empty array if no errors are found.
 */
function validate(options) {
    const value = options.value;
    const valueSpec = options.valueSpec;
    const styleSpec = options.styleSpec;
    options.validateSpec = validate;
    if (valueSpec.expression && isFunction$1(unbundle(value))) {
        return validateFunction(options);
    }
    else if (valueSpec.expression && isExpression(deepUnbundle(value))) {
        return validateExpression(options);
    }
    else if (valueSpec.type && VALIDATORS[valueSpec.type]) {
        return VALIDATORS[valueSpec.type](options);
    }
    else {
        const valid = validateObject(extendBy({}, options, {
            valueSpec: valueSpec.type ? styleSpec[valueSpec.type] : valueSpec
        }));
        return valid;
    }
}

function validateGlyphsUrl(options) {
    const value = options.value;
    const key = options.key;
    const errors = validateString(options);
    if (errors.length)
        return errors;
    if (value.indexOf('{fontstack}') === -1) {
        errors.push(new ValidationError(key, value, '"glyphs" url must include a "{fontstack}" token'));
    }
    if (value.indexOf('{range}') === -1) {
        errors.push(new ValidationError(key, value, '"glyphs" url must include a "{range}" token'));
    }
    return errors;
}

/**
 * Validate a MapLibre style against the style specification.
 * Use this when running in the browser.
 *
 * @param style - The style to be validated.
 * @param styleSpec - The style specification to validate against.
 * If omitted, the latest style spec is used.
 * @returns an array of errors, or an empty array if no errors are found.
 * @example
 *   const validate = require('@maplibre/maplibre-gl-style-spec/').validateStyleMin;
 *   const errors = validate(style);
 */
function validateStyleMin(style, styleSpec = v8Spec) {
    let errors = [];
    errors = errors.concat(validate({
        key: '',
        value: style,
        valueSpec: styleSpec.$root,
        styleSpec,
        style,
        validateSpec: validate,
        objectElementValidators: {
            glyphs: validateGlyphsUrl,
            '*'() {
                return [];
            }
        }
    }));
    if (style['constants']) {
        errors = errors.concat(validateConstants({
            key: 'constants',
            value: style['constants'],
            style,
            styleSpec,
            validateSpec: validate,
        }));
    }
    return sortErrors(errors);
}
validateStyleMin.source = wrapCleanErrors(injectValidateSpec(validateSource));
validateStyleMin.sprite = wrapCleanErrors(injectValidateSpec(validateSprite));
validateStyleMin.glyphs = wrapCleanErrors(injectValidateSpec(validateGlyphsUrl));
validateStyleMin.light = wrapCleanErrors(injectValidateSpec(validateLight$1));
validateStyleMin.sky = wrapCleanErrors(injectValidateSpec(validateSky$1));
validateStyleMin.terrain = wrapCleanErrors(injectValidateSpec(validateTerrain));
validateStyleMin.layer = wrapCleanErrors(injectValidateSpec(validateLayer));
validateStyleMin.filter = wrapCleanErrors(injectValidateSpec(validateFilter));
validateStyleMin.paintProperty = wrapCleanErrors(injectValidateSpec(validatePaintProperty$1));
validateStyleMin.layoutProperty = wrapCleanErrors(injectValidateSpec(validateLayoutProperty$1));
function injectValidateSpec(validator) {
    return function (options) {
        return validator({
            ...options,
            validateSpec: validate,
        });
    };
}
function sortErrors(errors) {
    return [].concat(errors).sort((a, b) => {
        return a.line - b.line;
    });
}
function wrapCleanErrors(inner) {
    return function (...args) {
        return sortErrors(inner.apply(this, args));
    };
}

const validateStyle = validateStyleMin;
validateStyle.source;
const validateLight = validateStyle.light;
const validateSky = validateStyle.sky;
validateStyle.terrain;
validateStyle.filter;
const validatePaintProperty = validateStyle.paintProperty;
const validateLayoutProperty = validateStyle.layoutProperty;
function emitValidationErrors(emitter, errors) {
    let hasErrors = false;
    if (errors && errors.length) {
        for (const error of errors) {
            emitter.fire(new ErrorEvent(new Error(error.message)));
            hasErrors = true;
        }
    }
    return hasErrors;
}

/*
This file was copied from https://github.com/mapbox/grid-index and was
migrated from JavaScript to TypeScript.

Copyright (c) 2016, Mapbox

Permission to use, copy, modify, and/or distribute this software for any purpose
with or without fee is hereby granted, provided that the above copyright notice
and this permission notice appear in all copies.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY AND
FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS
OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER
TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF
THIS SOFTWARE.
*/
const NUM_PARAMS = 3;
class TransferableGridIndex {
    constructor(extent, n, padding) {
        const cells = this.cells = [];
        if (extent instanceof ArrayBuffer) {
            this.arrayBuffer = extent;
            const array = new Int32Array(this.arrayBuffer);
            extent = array[0];
            n = array[1];
            padding = array[2];
            this.d = n + 2 * padding;
            for (let k = 0; k < this.d * this.d; k++) {
                const start = array[NUM_PARAMS + k];
                const end = array[NUM_PARAMS + k + 1];
                cells.push(start === end ? null : array.subarray(start, end));
            }
            const keysOffset = array[NUM_PARAMS + cells.length];
            const bboxesOffset = array[NUM_PARAMS + cells.length + 1];
            this.keys = array.subarray(keysOffset, bboxesOffset);
            this.bboxes = array.subarray(bboxesOffset);
            this.insert = this._insertReadonly;
        }
        else {
            this.d = n + 2 * padding;
            for (let i = 0; i < this.d * this.d; i++) {
                cells.push([]);
            }
            this.keys = [];
            this.bboxes = [];
        }
        this.n = n;
        this.extent = extent;
        this.padding = padding;
        this.scale = n / extent;
        this.uid = 0;
        const p = (padding / n) * extent;
        this.min = -p;
        this.max = extent + p;
    }
    insert(key, x1, y1, x2, y2) {
        this._forEachCell(x1, y1, x2, y2, this._insertCell, this.uid++, undefined, undefined);
        this.keys.push(key);
        this.bboxes.push(x1);
        this.bboxes.push(y1);
        this.bboxes.push(x2);
        this.bboxes.push(y2);
    }
    _insertReadonly() {
        throw new Error('Cannot insert into a GridIndex created from an ArrayBuffer.');
    }
    _insertCell(x1, y1, x2, y2, cellIndex, uid) {
        this.cells[cellIndex].push(uid);
    }
    query(x1, y1, x2, y2, intersectionTest) {
        const min = this.min;
        const max = this.max;
        if (x1 <= min && y1 <= min && max <= x2 && max <= y2 && !intersectionTest) {
            // We use `Array#slice` because `this.keys` may be a `Int32Array` and
            // some browsers (Safari and IE) do not support `TypedArray#slice`
            // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/TypedArray/slice#Browser_compatibility
            return Array.prototype.slice.call(this.keys);
        }
        else {
            const result = [];
            const seenUids = {};
            this._forEachCell(x1, y1, x2, y2, this._queryCell, result, seenUids, intersectionTest);
            return result;
        }
    }
    _queryCell(x1, y1, x2, y2, cellIndex, result, seenUids, intersectionTest) {
        const cell = this.cells[cellIndex];
        if (cell !== null) {
            const keys = this.keys;
            const bboxes = this.bboxes;
            for (let u = 0; u < cell.length; u++) {
                const uid = cell[u];
                if (seenUids[uid] === undefined) {
                    const offset = uid * 4;
                    if (intersectionTest ?
                        intersectionTest(bboxes[offset + 0], bboxes[offset + 1], bboxes[offset + 2], bboxes[offset + 3]) :
                        ((x1 <= bboxes[offset + 2]) &&
                            (y1 <= bboxes[offset + 3]) &&
                            (x2 >= bboxes[offset + 0]) &&
                            (y2 >= bboxes[offset + 1]))) {
                        seenUids[uid] = true;
                        result.push(keys[uid]);
                    }
                    else {
                        seenUids[uid] = false;
                    }
                }
            }
        }
    }
    _forEachCell(x1, y1, x2, y2, fn, arg1, arg2, intersectionTest) {
        const cx1 = this._convertToCellCoord(x1);
        const cy1 = this._convertToCellCoord(y1);
        const cx2 = this._convertToCellCoord(x2);
        const cy2 = this._convertToCellCoord(y2);
        for (let x = cx1; x <= cx2; x++) {
            for (let y = cy1; y <= cy2; y++) {
                const cellIndex = this.d * y + x;
                if (intersectionTest && !intersectionTest(this._convertFromCellCoord(x), this._convertFromCellCoord(y), this._convertFromCellCoord(x + 1), this._convertFromCellCoord(y + 1)))
                    continue;
                if (fn.call(this, x1, y1, x2, y2, cellIndex, arg1, arg2, intersectionTest))
                    return;
            }
        }
    }
    _convertFromCellCoord(x) {
        return (x - this.padding) / this.scale;
    }
    _convertToCellCoord(x) {
        return Math.max(0, Math.min(this.d - 1, Math.floor(x * this.scale) + this.padding));
    }
    toArrayBuffer() {
        if (this.arrayBuffer)
            return this.arrayBuffer;
        const cells = this.cells;
        const metadataLength = NUM_PARAMS + this.cells.length + 1 + 1;
        let totalCellLength = 0;
        for (let i = 0; i < this.cells.length; i++) {
            totalCellLength += this.cells[i].length;
        }
        const array = new Int32Array(metadataLength + totalCellLength + this.keys.length + this.bboxes.length);
        array[0] = this.extent;
        array[1] = this.n;
        array[2] = this.padding;
        let offset = metadataLength;
        for (let k = 0; k < cells.length; k++) {
            const cell = cells[k];
            array[NUM_PARAMS + k] = offset;
            array.set(cell, offset);
            offset += cell.length;
        }
        array[NUM_PARAMS + cells.length] = offset;
        array.set(this.keys, offset);
        offset += this.keys.length;
        array[NUM_PARAMS + cells.length + 1] = offset;
        array.set(this.bboxes, offset);
        offset += this.bboxes.length;
        return array.buffer;
    }
    static serialize(grid, transferables) {
        const buffer = grid.toArrayBuffer();
        if (transferables) {
            transferables.push(buffer);
        }
        return { buffer };
    }
    static deserialize(serialized) {
        return new TransferableGridIndex(serialized.buffer);
    }
}

const registry = {};
/**
 * Register the given class as serializable.
 *
 * @param options - the registration options
 */
function register(name, klass, options = {}) {
    if (registry[name])
        throw new Error(`${name} is already registered.`);
    Object.defineProperty(klass, '_classRegistryKey', {
        value: name,
        writeable: false
    });
    registry[name] = {
        klass,
        omit: options.omit || [],
        shallow: options.shallow || []
    };
}
register('Object', Object);
register('TransferableGridIndex', TransferableGridIndex);
register('Color', Color);
register('Error', Error);
register('AJAXError', AJAXError);
register('ResolvedImage', ResolvedImage);
register('StylePropertyFunction', StylePropertyFunction);
register('StyleExpression', StyleExpression, { omit: ['_evaluator'] });
register('ZoomDependentExpression', ZoomDependentExpression);
register('ZoomConstantExpression', ZoomConstantExpression);
register('CompoundExpression', CompoundExpression, { omit: ['_evaluate'] });
for (const name in expressions$1) {
    if (expressions$1[name]._classRegistryKey)
        continue;
    register(`Expression_${name}`, expressions$1[name]);
}
function isArrayBuffer(value) {
    return value && typeof ArrayBuffer !== 'undefined' &&
        (value instanceof ArrayBuffer || (value.constructor && value.constructor.name === 'ArrayBuffer'));
}
function getClassRegistryKey(input) {
    const klass = input.constructor;
    return input.$name || klass._classRegistryKey;
}
function isRegistered(input) {
    if (input === null || typeof input !== 'object') {
        return false;
    }
    const classRegistryKey = getClassRegistryKey(input);
    if (classRegistryKey && classRegistryKey !== 'Object') {
        return true;
    }
    return false;
}
function isSerializeHandledByBuiltin(input) {
    return (!isRegistered(input) && (input === null ||
        input === undefined ||
        typeof input === 'boolean' ||
        typeof input === 'number' ||
        typeof input === 'string' ||
        input instanceof Boolean ||
        input instanceof Number ||
        input instanceof String ||
        input instanceof Date ||
        input instanceof RegExp ||
        input instanceof Blob ||
        input instanceof Error ||
        isArrayBuffer(input) ||
        isImageBitmap(input) ||
        ArrayBuffer.isView(input) ||
        input instanceof ImageData));
}
/**
 * Serialize the given object for transfer to or from a web worker.
 *
 * For non-builtin types, recursively serialize each property (possibly
 * omitting certain properties - see register()), and package the result along
 * with the constructor's `name` so that the appropriate constructor can be
 * looked up in `deserialize()`.
 *
 * If a `transferables` array is provided, add any transferable objects (i.e.,
 * any ArrayBuffers or ArrayBuffer views) to the list. (If a copy is needed,
 * this should happen in the client code, before using serialize().)
 */
function serialize(input, transferables) {
    if (isSerializeHandledByBuiltin(input)) {
        if (isArrayBuffer(input) || isImageBitmap(input)) {
            if (transferables) {
                transferables.push(input);
            }
        }
        if (ArrayBuffer.isView(input)) {
            const view = input;
            if (transferables) {
                transferables.push(view.buffer);
            }
        }
        if (input instanceof ImageData) {
            if (transferables) {
                transferables.push(input.data.buffer);
            }
        }
        return input;
    }
    if (Array.isArray(input)) {
        const serialized = [];
        for (const item of input) {
            serialized.push(serialize(item, transferables));
        }
        return serialized;
    }
    if (typeof input !== 'object') {
        throw new Error(`can't serialize object of type ${typeof input}`);
    }
    const classRegistryKey = getClassRegistryKey(input);
    if (!classRegistryKey) {
        throw new Error(`can't serialize object of unregistered class ${input.constructor.name}`);
    }
    if (!registry[classRegistryKey])
        throw new Error(`${classRegistryKey} is not registered.`);
    const { klass } = registry[classRegistryKey];
    const properties = klass.serialize ?
        // (Temporary workaround) allow a class to provide static
        // `serialize()` and `deserialize()` methods to bypass the generic
        // approach.
        // This temporary workaround lets us use the generic serialization
        // approach for objects whose members include instances of dynamic
        // StructArray types. Once we refactor StructArray to be static,
        // we can remove this complexity.
        klass.serialize(input, transferables) : {};
    if (!klass.serialize) {
        for (const key in input) {
            if (!input.hasOwnProperty(key))
                continue; // eslint-disable-line no-prototype-builtins
            if (registry[classRegistryKey].omit.indexOf(key) >= 0)
                continue;
            const property = input[key];
            properties[key] = registry[classRegistryKey].shallow.indexOf(key) >= 0 ?
                property :
                serialize(property, transferables);
        }
        if (input instanceof Error) {
            properties.message = input.message;
        }
    }
    else {
        if (transferables && properties === transferables[transferables.length - 1]) {
            throw new Error('statically serialized object won\'t survive transfer of $name property');
        }
    }
    if (properties.$name) {
        throw new Error('$name property is reserved for worker serialization logic.');
    }
    if (classRegistryKey !== 'Object') {
        properties.$name = classRegistryKey;
    }
    return properties;
}
function deserialize(input) {
    if (isSerializeHandledByBuiltin(input)) {
        return input;
    }
    if (Array.isArray(input)) {
        return input.map(deserialize);
    }
    if (typeof input !== 'object') {
        throw new Error(`can't deserialize object of type ${typeof input}`);
    }
    const classRegistryKey = getClassRegistryKey(input) || 'Object';
    if (!registry[classRegistryKey]) {
        throw new Error(`can't deserialize unregistered class ${classRegistryKey}`);
    }
    const { klass } = registry[classRegistryKey];
    if (!klass) {
        throw new Error(`can't deserialize unregistered class ${classRegistryKey}`);
    }
    if (klass.deserialize) {
        return klass.deserialize(input);
    }
    const result = Object.create(klass.prototype);
    for (const key of Object.keys(input)) {
        if (key === '$name')
            continue;
        const value = input[key];
        result[key] = registry[classRegistryKey].shallow.indexOf(key) >= 0 ? value : deserialize(value);
    }
    return result;
}

class ZoomHistory {
    constructor() {
        this.first = true;
    }
    update(z, now) {
        const floorZ = Math.floor(z);
        if (this.first) {
            this.first = false;
            this.lastIntegerZoom = floorZ;
            this.lastIntegerZoomTime = 0;
            this.lastZoom = z;
            this.lastFloorZoom = floorZ;
            return true;
        }
        if (this.lastFloorZoom > floorZ) {
            this.lastIntegerZoom = floorZ + 1;
            this.lastIntegerZoomTime = now;
        }
        else if (this.lastFloorZoom < floorZ) {
            this.lastIntegerZoom = floorZ;
            this.lastIntegerZoomTime = now;
        }
        if (z !== this.lastZoom) {
            this.lastZoom = z;
            this.lastFloorZoom = floorZ;
            return true;
        }
        return false;
    }
}

// The following table comes from <https://www.unicode.org/Public/12.0.0/ucd/Blocks.txt>.
// Keep it synchronized with <https://www.unicode.org/Public/UCD/latest/ucd/Blocks.txt>.
const unicodeBlockLookup = {
    // 'Basic Latin': (char) => char >= 0x0000 && char <= 0x007F,
    'Latin-1 Supplement': (char) => char >= 0x0080 && char <= 0x00FF,
    // 'Latin Extended-A': (char) => char >= 0x0100 && char <= 0x017F,
    // 'Latin Extended-B': (char) => char >= 0x0180 && char <= 0x024F,
    // 'IPA Extensions': (char) => char >= 0x0250 && char <= 0x02AF,
    // 'Spacing Modifier Letters': (char) => char >= 0x02B0 && char <= 0x02FF,
    // 'Combining Diacritical Marks': (char) => char >= 0x0300 && char <= 0x036F,
    // 'Greek and Coptic': (char) => char >= 0x0370 && char <= 0x03FF,
    // 'Cyrillic': (char) => char >= 0x0400 && char <= 0x04FF,
    // 'Cyrillic Supplement': (char) => char >= 0x0500 && char <= 0x052F,
    // 'Armenian': (char) => char >= 0x0530 && char <= 0x058F,
    //'Hebrew': (char) => char >= 0x0590 && char <= 0x05FF,
    'Arabic': (char) => char >= 0x0600 && char <= 0x06FF,
    //'Syriac': (char) => char >= 0x0700 && char <= 0x074F,
    'Arabic Supplement': (char) => char >= 0x0750 && char <= 0x077F,
    // 'Thaana': (char) => char >= 0x0780 && char <= 0x07BF,
    // 'NKo': (char) => char >= 0x07C0 && char <= 0x07FF,
    // 'Samaritan': (char) => char >= 0x0800 && char <= 0x083F,
    // 'Mandaic': (char) => char >= 0x0840 && char <= 0x085F,
    // 'Syriac Supplement': (char) => char >= 0x0860 && char <= 0x086F,
    'Arabic Extended-A': (char) => char >= 0x08A0 && char <= 0x08FF,
    // 'Devanagari': (char) => char >= 0x0900 && char <= 0x097F,
    // 'Bengali': (char) => char >= 0x0980 && char <= 0x09FF,
    // 'Gurmukhi': (char) => char >= 0x0A00 && char <= 0x0A7F,
    // 'Gujarati': (char) => char >= 0x0A80 && char <= 0x0AFF,
    // 'Oriya': (char) => char >= 0x0B00 && char <= 0x0B7F,
    // 'Tamil': (char) => char >= 0x0B80 && char <= 0x0BFF,
    // 'Telugu': (char) => char >= 0x0C00 && char <= 0x0C7F,
    // 'Kannada': (char) => char >= 0x0C80 && char <= 0x0CFF,
    // 'Malayalam': (char) => char >= 0x0D00 && char <= 0x0D7F,
    // 'Sinhala': (char) => char >= 0x0D80 && char <= 0x0DFF,
    // 'Thai': (char) => char >= 0x0E00 && char <= 0x0E7F,
    // 'Lao': (char) => char >= 0x0E80 && char <= 0x0EFF,
    // 'Tibetan': (char) => char >= 0x0F00 && char <= 0x0FFF,
    // 'Myanmar': (char) => char >= 0x1000 && char <= 0x109F,
    // 'Georgian': (char) => char >= 0x10A0 && char <= 0x10FF,
    'Hangul Jamo': (char) => char >= 0x1100 && char <= 0x11FF,
    // 'Ethiopic': (char) => char >= 0x1200 && char <= 0x137F,
    // 'Ethiopic Supplement': (char) => char >= 0x1380 && char <= 0x139F,
    // 'Cherokee': (char) => char >= 0x13A0 && char <= 0x13FF,
    'Unified Canadian Aboriginal Syllabics': (char) => char >= 0x1400 && char <= 0x167F,
    // 'Ogham': (char) => char >= 0x1680 && char <= 0x169F,
    // 'Runic': (char) => char >= 0x16A0 && char <= 0x16FF,
    // 'Tagalog': (char) => char >= 0x1700 && char <= 0x171F,
    // 'Hanunoo': (char) => char >= 0x1720 && char <= 0x173F,
    // 'Buhid': (char) => char >= 0x1740 && char <= 0x175F,
    // 'Tagbanwa': (char) => char >= 0x1760 && char <= 0x177F,
    'Khmer': (char) => char >= 0x1780 && char <= 0x17FF,
    // 'Mongolian': (char) => char >= 0x1800 && char <= 0x18AF,
    'Unified Canadian Aboriginal Syllabics Extended': (char) => char >= 0x18B0 && char <= 0x18FF,
    // 'Limbu': (char) => char >= 0x1900 && char <= 0x194F,
    // 'Tai Le': (char) => char >= 0x1950 && char <= 0x197F,
    // 'New Tai Lue': (char) => char >= 0x1980 && char <= 0x19DF,
    // 'Khmer Symbols': (char) => char >= 0x19E0 && char <= 0x19FF,
    // 'Buginese': (char) => char >= 0x1A00 && char <= 0x1A1F,
    // 'Tai Tham': (char) => char >= 0x1A20 && char <= 0x1AAF,
    // 'Combining Diacritical Marks Extended': (char) => char >= 0x1AB0 && char <= 0x1AFF,
    // 'Balinese': (char) => char >= 0x1B00 && char <= 0x1B7F,
    // 'Sundanese': (char) => char >= 0x1B80 && char <= 0x1BBF,
    // 'Batak': (char) => char >= 0x1BC0 && char <= 0x1BFF,
    // 'Lepcha': (char) => char >= 0x1C00 && char <= 0x1C4F,
    // 'Ol Chiki': (char) => char >= 0x1C50 && char <= 0x1C7F,
    // 'Cyrillic Extended-C': (char) => char >= 0x1C80 && char <= 0x1C8F,
    // 'Georgian Extended': (char) => char >= 0x1C90 && char <= 0x1CBF,
    // 'Sundanese Supplement': (char) => char >= 0x1CC0 && char <= 0x1CCF,
    // 'Vedic Extensions': (char) => char >= 0x1CD0 && char <= 0x1CFF,
    // 'Phonetic Extensions': (char) => char >= 0x1D00 && char <= 0x1D7F,
    // 'Phonetic Extensions Supplement': (char) => char >= 0x1D80 && char <= 0x1DBF,
    // 'Combining Diacritical Marks Supplement': (char) => char >= 0x1DC0 && char <= 0x1DFF,
    // 'Latin Extended Additional': (char) => char >= 0x1E00 && char <= 0x1EFF,
    // 'Greek Extended': (char) => char >= 0x1F00 && char <= 0x1FFF,
    'General Punctuation': (char) => char >= 0x2000 && char <= 0x206F,
    // 'Superscripts and Subscripts': (char) => char >= 0x2070 && char <= 0x209F,
    // 'Currency Symbols': (char) => char >= 0x20A0 && char <= 0x20CF,
    // 'Combining Diacritical Marks for Symbols': (char) => char >= 0x20D0 && char <= 0x20FF,
    'Letterlike Symbols': (char) => char >= 0x2100 && char <= 0x214F,
    'Number Forms': (char) => char >= 0x2150 && char <= 0x218F,
    // 'Arrows': (char) => char >= 0x2190 && char <= 0x21FF,
    // 'Mathematical Operators': (char) => char >= 0x2200 && char <= 0x22FF,
    'Miscellaneous Technical': (char) => char >= 0x2300 && char <= 0x23FF,
    'Control Pictures': (char) => char >= 0x2400 && char <= 0x243F,
    'Optical Character Recognition': (char) => char >= 0x2440 && char <= 0x245F,
    'Enclosed Alphanumerics': (char) => char >= 0x2460 && char <= 0x24FF,
    // 'Box Drawing': (char) => char >= 0x2500 && char <= 0x257F,
    // 'Block Elements': (char) => char >= 0x2580 && char <= 0x259F,
    'Geometric Shapes': (char) => char >= 0x25A0 && char <= 0x25FF,
    'Miscellaneous Symbols': (char) => char >= 0x2600 && char <= 0x26FF,
    // 'Dingbats': (char) => char >= 0x2700 && char <= 0x27BF,
    // 'Miscellaneous Mathematical Symbols-A': (char) => char >= 0x27C0 && char <= 0x27EF,
    // 'Supplemental Arrows-A': (char) => char >= 0x27F0 && char <= 0x27FF,
    // 'Braille Patterns': (char) => char >= 0x2800 && char <= 0x28FF,
    // 'Supplemental Arrows-B': (char) => char >= 0x2900 && char <= 0x297F,
    // 'Miscellaneous Mathematical Symbols-B': (char) => char >= 0x2980 && char <= 0x29FF,
    // 'Supplemental Mathematical Operators': (char) => char >= 0x2A00 && char <= 0x2AFF,
    'Miscellaneous Symbols and Arrows': (char) => char >= 0x2B00 && char <= 0x2BFF,
    // 'Glagolitic': (char) => char >= 0x2C00 && char <= 0x2C5F,
    // 'Latin Extended-C': (char) => char >= 0x2C60 && char <= 0x2C7F,
    // 'Coptic': (char) => char >= 0x2C80 && char <= 0x2CFF,
    // 'Georgian Supplement': (char) => char >= 0x2D00 && char <= 0x2D2F,
    // 'Tifinagh': (char) => char >= 0x2D30 && char <= 0x2D7F,
    // 'Ethiopic Extended': (char) => char >= 0x2D80 && char <= 0x2DDF,
    // 'Cyrillic Extended-A': (char) => char >= 0x2DE0 && char <= 0x2DFF,
    // 'Supplemental Punctuation': (char) => char >= 0x2E00 && char <= 0x2E7F,
    'CJK Radicals Supplement': (char) => char >= 0x2E80 && char <= 0x2EFF,
    'Kangxi Radicals': (char) => char >= 0x2F00 && char <= 0x2FDF,
    'Ideographic Description Characters': (char) => char >= 0x2FF0 && char <= 0x2FFF,
    'CJK Symbols and Punctuation': (char) => char >= 0x3000 && char <= 0x303F,
    'Hiragana': (char) => char >= 0x3040 && char <= 0x309F,
    'Katakana': (char) => char >= 0x30A0 && char <= 0x30FF,
    'Bopomofo': (char) => char >= 0x3100 && char <= 0x312F,
    'Hangul Compatibility Jamo': (char) => char >= 0x3130 && char <= 0x318F,
    'Kanbun': (char) => char >= 0x3190 && char <= 0x319F,
    'Bopomofo Extended': (char) => char >= 0x31A0 && char <= 0x31BF,
    'CJK Strokes': (char) => char >= 0x31C0 && char <= 0x31EF,
    'Katakana Phonetic Extensions': (char) => char >= 0x31F0 && char <= 0x31FF,
    'Enclosed CJK Letters and Months': (char) => char >= 0x3200 && char <= 0x32FF,
    'CJK Compatibility': (char) => char >= 0x3300 && char <= 0x33FF,
    'CJK Unified Ideographs Extension A': (char) => char >= 0x3400 && char <= 0x4DBF,
    'Yijing Hexagram Symbols': (char) => char >= 0x4DC0 && char <= 0x4DFF,
    'CJK Unified Ideographs': (char) => char >= 0x4E00 && char <= 0x9FFF,
    'Yi Syllables': (char) => char >= 0xA000 && char <= 0xA48F,
    'Yi Radicals': (char) => char >= 0xA490 && char <= 0xA4CF,
    // 'Lisu': (char) => char >= 0xA4D0 && char <= 0xA4FF,
    // 'Vai': (char) => char >= 0xA500 && char <= 0xA63F,
    // 'Cyrillic Extended-B': (char) => char >= 0xA640 && char <= 0xA69F,
    // 'Bamum': (char) => char >= 0xA6A0 && char <= 0xA6FF,
    // 'Modifier Tone Letters': (char) => char >= 0xA700 && char <= 0xA71F,
    // 'Latin Extended-D': (char) => char >= 0xA720 && char <= 0xA7FF,
    // 'Syloti Nagri': (char) => char >= 0xA800 && char <= 0xA82F,
    // 'Common Indic Number Forms': (char) => char >= 0xA830 && char <= 0xA83F,
    // 'Phags-pa': (char) => char >= 0xA840 && char <= 0xA87F,
    // 'Saurashtra': (char) => char >= 0xA880 && char <= 0xA8DF,
    // 'Devanagari Extended': (char) => char >= 0xA8E0 && char <= 0xA8FF,
    // 'Kayah Li': (char) => char >= 0xA900 && char <= 0xA92F,
    // 'Rejang': (char) => char >= 0xA930 && char <= 0xA95F,
    'Hangul Jamo Extended-A': (char) => char >= 0xA960 && char <= 0xA97F,
    // 'Javanese': (char) => char >= 0xA980 && char <= 0xA9DF,
    // 'Myanmar Extended-B': (char) => char >= 0xA9E0 && char <= 0xA9FF,
    // 'Cham': (char) => char >= 0xAA00 && char <= 0xAA5F,
    // 'Myanmar Extended-A': (char) => char >= 0xAA60 && char <= 0xAA7F,
    // 'Tai Viet': (char) => char >= 0xAA80 && char <= 0xAADF,
    // 'Meetei Mayek Extensions': (char) => char >= 0xAAE0 && char <= 0xAAFF,
    // 'Ethiopic Extended-A': (char) => char >= 0xAB00 && char <= 0xAB2F,
    // 'Latin Extended-E': (char) => char >= 0xAB30 && char <= 0xAB6F,
    // 'Cherokee Supplement': (char) => char >= 0xAB70 && char <= 0xABBF,
    // 'Meetei Mayek': (char) => char >= 0xABC0 && char <= 0xABFF,
    'Hangul Syllables': (char) => char >= 0xAC00 && char <= 0xD7AF,
    'Hangul Jamo Extended-B': (char) => char >= 0xD7B0 && char <= 0xD7FF,
    // 'High Surrogates': (char) => char >= 0xD800 && char <= 0xDB7F,
    // 'High Private Use Surrogates': (char) => char >= 0xDB80 && char <= 0xDBFF,
    // 'Low Surrogates': (char) => char >= 0xDC00 && char <= 0xDFFF,
    'Private Use Area': (char) => char >= 0xE000 && char <= 0xF8FF,
    'CJK Compatibility Ideographs': (char) => char >= 0xF900 && char <= 0xFAFF,
    // 'Alphabetic Presentation Forms': (char) => char >= 0xFB00 && char <= 0xFB4F,
    'Arabic Presentation Forms-A': (char) => char >= 0xFB50 && char <= 0xFDFF,
    // 'Variation Selectors': (char) => char >= 0xFE00 && char <= 0xFE0F,
    'Vertical Forms': (char) => char >= 0xFE10 && char <= 0xFE1F,
    // 'Combining Half Marks': (char) => char >= 0xFE20 && char <= 0xFE2F,
    'CJK Compatibility Forms': (char) => char >= 0xFE30 && char <= 0xFE4F,
    'Small Form Variants': (char) => char >= 0xFE50 && char <= 0xFE6F,
    'Arabic Presentation Forms-B': (char) => char >= 0xFE70 && char <= 0xFEFF,
    'Halfwidth and Fullwidth Forms': (char) => char >= 0xFF00 && char <= 0xFFEF
    // 'Specials': (char) => char >= 0xFFF0 && char <= 0xFFFF,
    // 'Linear B Syllabary': (char) => char >= 0x10000 && char <= 0x1007F,
    // 'Linear B Ideograms': (char) => char >= 0x10080 && char <= 0x100FF,
    // 'Aegean Numbers': (char) => char >= 0x10100 && char <= 0x1013F,
    // 'Ancient Greek Numbers': (char) => char >= 0x10140 && char <= 0x1018F,
    // 'Ancient Symbols': (char) => char >= 0x10190 && char <= 0x101CF,
    // 'Phaistos Disc': (char) => char >= 0x101D0 && char <= 0x101FF,
    // 'Lycian': (char) => char >= 0x10280 && char <= 0x1029F,
    // 'Carian': (char) => char >= 0x102A0 && char <= 0x102DF,
    // 'Coptic Epact Numbers': (char) => char >= 0x102E0 && char <= 0x102FF,
    // 'Old Italic': (char) => char >= 0x10300 && char <= 0x1032F,
    // 'Gothic': (char) => char >= 0x10330 && char <= 0x1034F,
    // 'Old Permic': (char) => char >= 0x10350 && char <= 0x1037F,
    // 'Ugaritic': (char) => char >= 0x10380 && char <= 0x1039F,
    // 'Old Persian': (char) => char >= 0x103A0 && char <= 0x103DF,
    // 'Deseret': (char) => char >= 0x10400 && char <= 0x1044F,
    // 'Shavian': (char) => char >= 0x10450 && char <= 0x1047F,
    // 'Osmanya': (char) => char >= 0x10480 && char <= 0x104AF,
    // 'Osage': (char) => char >= 0x104B0 && char <= 0x104FF,
    // 'Elbasan': (char) => char >= 0x10500 && char <= 0x1052F,
    // 'Caucasian Albanian': (char) => char >= 0x10530 && char <= 0x1056F,
    // 'Linear A': (char) => char >= 0x10600 && char <= 0x1077F,
    // 'Cypriot Syllabary': (char) => char >= 0x10800 && char <= 0x1083F,
    // 'Imperial Aramaic': (char) => char >= 0x10840 && char <= 0x1085F,
    // 'Palmyrene': (char) => char >= 0x10860 && char <= 0x1087F,
    // 'Nabataean': (char) => char >= 0x10880 && char <= 0x108AF,
    // 'Hatran': (char) => char >= 0x108E0 && char <= 0x108FF,
    // 'Phoenician': (char) => char >= 0x10900 && char <= 0x1091F,
    // 'Lydian': (char) => char >= 0x10920 && char <= 0x1093F,
    // 'Meroitic Hieroglyphs': (char) => char >= 0x10980 && char <= 0x1099F,
    // 'Meroitic Cursive': (char) => char >= 0x109A0 && char <= 0x109FF,
    // 'Kharoshthi': (char) => char >= 0x10A00 && char <= 0x10A5F,
    // 'Old South Arabian': (char) => char >= 0x10A60 && char <= 0x10A7F,
    // 'Old North Arabian': (char) => char >= 0x10A80 && char <= 0x10A9F,
    // 'Manichaean': (char) => char >= 0x10AC0 && char <= 0x10AFF,
    // 'Avestan': (char) => char >= 0x10B00 && char <= 0x10B3F,
    // 'Inscriptional Parthian': (char) => char >= 0x10B40 && char <= 0x10B5F,
    // 'Inscriptional Pahlavi': (char) => char >= 0x10B60 && char <= 0x10B7F,
    // 'Psalter Pahlavi': (char) => char >= 0x10B80 && char <= 0x10BAF,
    // 'Old Turkic': (char) => char >= 0x10C00 && char <= 0x10C4F,
    // 'Old Hungarian': (char) => char >= 0x10C80 && char <= 0x10CFF,
    // 'Hanifi Rohingya': (char) => char >= 0x10D00 && char <= 0x10D3F,
    // 'Rumi Numeral Symbols': (char) => char >= 0x10E60 && char <= 0x10E7F,
    // 'Old Sogdian': (char) => char >= 0x10F00 && char <= 0x10F2F,
    // 'Sogdian': (char) => char >= 0x10F30 && char <= 0x10F6F,
    // 'Elymaic': (char) => char >= 0x10FE0 && char <= 0x10FFF,
    // 'Brahmi': (char) => char >= 0x11000 && char <= 0x1107F,
    // 'Kaithi': (char) => char >= 0x11080 && char <= 0x110CF,
    // 'Sora Sompeng': (char) => char >= 0x110D0 && char <= 0x110FF,
    // 'Chakma': (char) => char >= 0x11100 && char <= 0x1114F,
    // 'Mahajani': (char) => char >= 0x11150 && char <= 0x1117F,
    // 'Sharada': (char) => char >= 0x11180 && char <= 0x111DF,
    // 'Sinhala Archaic Numbers': (char) => char >= 0x111E0 && char <= 0x111FF,
    // 'Khojki': (char) => char >= 0x11200 && char <= 0x1124F,
    // 'Multani': (char) => char >= 0x11280 && char <= 0x112AF,
    // 'Khudawadi': (char) => char >= 0x112B0 && char <= 0x112FF,
    // 'Grantha': (char) => char >= 0x11300 && char <= 0x1137F,
    // 'Newa': (char) => char >= 0x11400 && char <= 0x1147F,
    // 'Tirhuta': (char) => char >= 0x11480 && char <= 0x114DF,
    // 'Siddham': (char) => char >= 0x11580 && char <= 0x115FF,
    // 'Modi': (char) => char >= 0x11600 && char <= 0x1165F,
    // 'Mongolian Supplement': (char) => char >= 0x11660 && char <= 0x1167F,
    // 'Takri': (char) => char >= 0x11680 && char <= 0x116CF,
    // 'Ahom': (char) => char >= 0x11700 && char <= 0x1173F,
    // 'Dogra': (char) => char >= 0x11800 && char <= 0x1184F,
    // 'Warang Citi': (char) => char >= 0x118A0 && char <= 0x118FF,
    // 'Nandinagari': (char) => char >= 0x119A0 && char <= 0x119FF,
    // 'Zanabazar Square': (char) => char >= 0x11A00 && char <= 0x11A4F,
    // 'Soyombo': (char) => char >= 0x11A50 && char <= 0x11AAF,
    // 'Pau Cin Hau': (char) => char >= 0x11AC0 && char <= 0x11AFF,
    // 'Bhaiksuki': (char) => char >= 0x11C00 && char <= 0x11C6F,
    // 'Marchen': (char) => char >= 0x11C70 && char <= 0x11CBF,
    // 'Masaram Gondi': (char) => char >= 0x11D00 && char <= 0x11D5F,
    // 'Gunjala Gondi': (char) => char >= 0x11D60 && char <= 0x11DAF,
    // 'Makasar': (char) => char >= 0x11EE0 && char <= 0x11EFF,
    // 'Tamil Supplement': (char) => char >= 0x11FC0 && char <= 0x11FFF,
    // 'Cuneiform': (char) => char >= 0x12000 && char <= 0x123FF,
    // 'Cuneiform Numbers and Punctuation': (char) => char >= 0x12400 && char <= 0x1247F,
    // 'Early Dynastic Cuneiform': (char) => char >= 0x12480 && char <= 0x1254F,
    // 'Egyptian Hieroglyphs': (char) => char >= 0x13000 && char <= 0x1342F,
    // 'Egyptian Hieroglyph Format Controls': (char) => char >= 0x13430 && char <= 0x1343F,
    // 'Anatolian Hieroglyphs': (char) => char >= 0x14400 && char <= 0x1467F,
    // 'Bamum Supplement': (char) => char >= 0x16800 && char <= 0x16A3F,
    // 'Mro': (char) => char >= 0x16A40 && char <= 0x16A6F,
    // 'Bassa Vah': (char) => char >= 0x16AD0 && char <= 0x16AFF,
    // 'Pahawh Hmong': (char) => char >= 0x16B00 && char <= 0x16B8F,
    // 'Medefaidrin': (char) => char >= 0x16E40 && char <= 0x16E9F,
    // 'Miao': (char) => char >= 0x16F00 && char <= 0x16F9F,
    // 'Ideographic Symbols and Punctuation': (char) => char >= 0x16FE0 && char <= 0x16FFF,
    // 'Tangut': (char) => char >= 0x17000 && char <= 0x187FF,
    // 'Tangut Components': (char) => char >= 0x18800 && char <= 0x18AFF,
    // 'Kana Supplement': (char) => char >= 0x1B000 && char <= 0x1B0FF,
    // 'Kana Extended-A': (char) => char >= 0x1B100 && char <= 0x1B12F,
    // 'Small Kana Extension': (char) => char >= 0x1B130 && char <= 0x1B16F,
    // 'Nushu': (char) => char >= 0x1B170 && char <= 0x1B2FF,
    // 'Duployan': (char) => char >= 0x1BC00 && char <= 0x1BC9F,
    // 'Shorthand Format Controls': (char) => char >= 0x1BCA0 && char <= 0x1BCAF,
    // 'Byzantine Musical Symbols': (char) => char >= 0x1D000 && char <= 0x1D0FF,
    // 'Musical Symbols': (char) => char >= 0x1D100 && char <= 0x1D1FF,
    // 'Ancient Greek Musical Notation': (char) => char >= 0x1D200 && char <= 0x1D24F,
    // 'Mayan Numerals': (char) => char >= 0x1D2E0 && char <= 0x1D2FF,
    // 'Tai Xuan Jing Symbols': (char) => char >= 0x1D300 && char <= 0x1D35F,
    // 'Counting Rod Numerals': (char) => char >= 0x1D360 && char <= 0x1D37F,
    // 'Mathematical Alphanumeric Symbols': (char) => char >= 0x1D400 && char <= 0x1D7FF,
    // 'Sutton SignWriting': (char) => char >= 0x1D800 && char <= 0x1DAAF,
    // 'Glagolitic Supplement': (char) => char >= 0x1E000 && char <= 0x1E02F,
    // 'Nyiakeng Puachue Hmong': (char) => char >= 0x1E100 && char <= 0x1E14F,
    // 'Wancho': (char) => char >= 0x1E2C0 && char <= 0x1E2FF,
    // 'Mende Kikakui': (char) => char >= 0x1E800 && char <= 0x1E8DF,
    // 'Adlam': (char) => char >= 0x1E900 && char <= 0x1E95F,
    // 'Indic Siyaq Numbers': (char) => char >= 0x1EC70 && char <= 0x1ECBF,
    // 'Ottoman Siyaq Numbers': (char) => char >= 0x1ED00 && char <= 0x1ED4F,
    // 'Arabic Mathematical Alphabetic Symbols': (char) => char >= 0x1EE00 && char <= 0x1EEFF,
    // 'Mahjong Tiles': (char) => char >= 0x1F000 && char <= 0x1F02F,
    // 'Domino Tiles': (char) => char >= 0x1F030 && char <= 0x1F09F,
    // 'Playing Cards': (char) => char >= 0x1F0A0 && char <= 0x1F0FF,
    // 'Enclosed Alphanumeric Supplement': (char) => char >= 0x1F100 && char <= 0x1F1FF,
    // 'Enclosed Ideographic Supplement': (char) => char >= 0x1F200 && char <= 0x1F2FF,
    // 'Miscellaneous Symbols and Pictographs': (char) => char >= 0x1F300 && char <= 0x1F5FF,
    // 'Emoticons': (char) => char >= 0x1F600 && char <= 0x1F64F,
    // 'Ornamental Dingbats': (char) => char >= 0x1F650 && char <= 0x1F67F,
    // 'Transport and Map Symbols': (char) => char >= 0x1F680 && char <= 0x1F6FF,
    // 'Alchemical Symbols': (char) => char >= 0x1F700 && char <= 0x1F77F,
    // 'Geometric Shapes Extended': (char) => char >= 0x1F780 && char <= 0x1F7FF,
    // 'Supplemental Arrows-C': (char) => char >= 0x1F800 && char <= 0x1F8FF,
    // 'Supplemental Symbols and Pictographs': (char) => char >= 0x1F900 && char <= 0x1F9FF,
    // 'Chess Symbols': (char) => char >= 0x1FA00 && char <= 0x1FA6F,
    // 'Symbols and Pictographs Extended-A': (char) => char >= 0x1FA70 && char <= 0x1FAFF,
    // 'CJK Unified Ideographs Extension B': (char) => char >= 0x20000 && char <= 0x2A6DF,
    // 'CJK Unified Ideographs Extension C': (char) => char >= 0x2A700 && char <= 0x2B73F,
    // 'CJK Unified Ideographs Extension D': (char) => char >= 0x2B740 && char <= 0x2B81F,
    // 'CJK Unified Ideographs Extension E': (char) => char >= 0x2B820 && char <= 0x2CEAF,
    // 'CJK Unified Ideographs Extension F': (char) => char >= 0x2CEB0 && char <= 0x2EBEF,
    // 'CJK Compatibility Ideographs Supplement': (char) => char >= 0x2F800 && char <= 0x2FA1F,
    // 'Tags': (char) => char >= 0xE0000 && char <= 0xE007F,
    // 'Variation Selectors Supplement': (char) => char >= 0xE0100 && char <= 0xE01EF,
    // 'Supplementary Private Use Area-A': (char) => char >= 0xF0000 && char <= 0xFFFFF,
    // 'Supplementary Private Use Area-B': (char) => char >= 0x100000 && char <= 0x10FFFF,
};

/* eslint-disable new-cap */
function allowsVerticalWritingMode(chars) {
    for (const char of chars) {
        if (charHasUprightVerticalOrientation(char.charCodeAt(0)))
            return true;
    }
    return false;
}
function allowsLetterSpacing(chars) {
    for (const char of chars) {
        if (!charAllowsLetterSpacing(char.charCodeAt(0)))
            return false;
    }
    return true;
}
function charAllowsLetterSpacing(char) {
    if (unicodeBlockLookup['Arabic'](char))
        return false;
    if (unicodeBlockLookup['Arabic Supplement'](char))
        return false;
    if (unicodeBlockLookup['Arabic Extended-A'](char))
        return false;
    if (unicodeBlockLookup['Arabic Presentation Forms-A'](char))
        return false;
    if (unicodeBlockLookup['Arabic Presentation Forms-B'](char))
        return false;
    return true;
}
function charAllowsIdeographicBreaking(char) {
    // Return early for characters outside all ideographic ranges.
    if (char < 0x2E80)
        return false;
    if (unicodeBlockLookup['Bopomofo Extended'](char))
        return true;
    if (unicodeBlockLookup['Bopomofo'](char))
        return true;
    if (unicodeBlockLookup['CJK Compatibility Forms'](char))
        return true;
    if (unicodeBlockLookup['CJK Compatibility Ideographs'](char))
        return true;
    if (unicodeBlockLookup['CJK Compatibility'](char))
        return true;
    if (unicodeBlockLookup['CJK Radicals Supplement'](char))
        return true;
    if (unicodeBlockLookup['CJK Strokes'](char))
        return true;
    if (unicodeBlockLookup['CJK Symbols and Punctuation'](char))
        return true;
    if (unicodeBlockLookup['CJK Unified Ideographs Extension A'](char))
        return true;
    if (unicodeBlockLookup['CJK Unified Ideographs'](char))
        return true;
    if (unicodeBlockLookup['Enclosed CJK Letters and Months'](char))
        return true;
    if (unicodeBlockLookup['Halfwidth and Fullwidth Forms'](char))
        return true;
    if (unicodeBlockLookup['Hiragana'](char))
        return true;
    if (unicodeBlockLookup['Ideographic Description Characters'](char))
        return true;
    if (unicodeBlockLookup['Kangxi Radicals'](char))
        return true;
    if (unicodeBlockLookup['Katakana Phonetic Extensions'](char))
        return true;
    if (unicodeBlockLookup['Katakana'](char))
        return true;
    if (unicodeBlockLookup['Vertical Forms'](char))
        return true;
    if (unicodeBlockLookup['Yi Radicals'](char))
        return true;
    if (unicodeBlockLookup['Yi Syllables'](char))
        return true;
    return false;
}
// The following logic comes from
// <https://www.unicode.org/Public/12.0.0/ucd/VerticalOrientation.txt>.
// Keep it synchronized with
// <https://www.unicode.org/Public/UCD/latest/ucd/VerticalOrientation.txt>.
// The data file denotes with “U” or “Tu” any codepoint that may be drawn
// upright in vertical text but does not distinguish between upright and
// “neutral” characters.
// Blocks in the Unicode supplementary planes are excluded from this module due
// to <https://github.com/mapbox/mapbox-gl/issues/29>.
/**
 * Returns true if the given Unicode codepoint identifies a character with
 * upright orientation.
 *
 * A character has upright orientation if it is drawn upright (unrotated)
 * whether the line is oriented horizontally or vertically, even if both
 * adjacent characters can be rotated. For example, a Chinese character is
 * always drawn upright. An uprightly oriented character causes an adjacent
 * “neutral” character to be drawn upright as well.
 */
function charHasUprightVerticalOrientation(char) {
    if (char === 0x02EA /* modifier letter yin departing tone mark */ ||
        char === 0x02EB /* modifier letter yang departing tone mark */) {
        return true;
    }
    // Return early for characters outside all ranges whose characters remain
    // upright in vertical writing mode.
    if (char < 0x1100)
        return false;
    if (unicodeBlockLookup['Bopomofo Extended'](char))
        return true;
    if (unicodeBlockLookup['Bopomofo'](char))
        return true;
    if (unicodeBlockLookup['CJK Compatibility Forms'](char)) {
        if (!((char >= 0xFE49 /* dashed overline */ && char <= 0xFE4F) /* wavy low line */)) {
            return true;
        }
    }
    if (unicodeBlockLookup['CJK Compatibility Ideographs'](char))
        return true;
    if (unicodeBlockLookup['CJK Compatibility'](char))
        return true;
    if (unicodeBlockLookup['CJK Radicals Supplement'](char))
        return true;
    if (unicodeBlockLookup['CJK Strokes'](char))
        return true;
    if (unicodeBlockLookup['CJK Symbols and Punctuation'](char)) {
        if (!((char >= 0x3008 /* left angle bracket */ && char <= 0x3011) /* right black lenticular bracket */) &&
            !((char >= 0x3014 /* left tortoise shell bracket */ && char <= 0x301F) /* low double prime quotation mark */) &&
            char !== 0x3030 /* wavy dash */) {
            return true;
        }
    }
    if (unicodeBlockLookup['CJK Unified Ideographs Extension A'](char))
        return true;
    if (unicodeBlockLookup['CJK Unified Ideographs'](char))
        return true;
    if (unicodeBlockLookup['Enclosed CJK Letters and Months'](char))
        return true;
    if (unicodeBlockLookup['Hangul Compatibility Jamo'](char))
        return true;
    if (unicodeBlockLookup['Hangul Jamo Extended-A'](char))
        return true;
    if (unicodeBlockLookup['Hangul Jamo Extended-B'](char))
        return true;
    if (unicodeBlockLookup['Hangul Jamo'](char))
        return true;
    if (unicodeBlockLookup['Hangul Syllables'](char))
        return true;
    if (unicodeBlockLookup['Hiragana'](char))
        return true;
    if (unicodeBlockLookup['Ideographic Description Characters'](char))
        return true;
    if (unicodeBlockLookup['Kanbun'](char))
        return true;
    if (unicodeBlockLookup['Kangxi Radicals'](char))
        return true;
    if (unicodeBlockLookup['Katakana Phonetic Extensions'](char))
        return true;
    if (unicodeBlockLookup['Katakana'](char)) {
        if (char !== 0x30FC /* katakana-hiragana prolonged sound mark */) {
            return true;
        }
    }
    if (unicodeBlockLookup['Halfwidth and Fullwidth Forms'](char)) {
        if (char !== 0xFF08 /* fullwidth left parenthesis */ &&
            char !== 0xFF09 /* fullwidth right parenthesis */ &&
            char !== 0xFF0D /* fullwidth hyphen-minus */ &&
            !((char >= 0xFF1A /* fullwidth colon */ && char <= 0xFF1E) /* fullwidth greater-than sign */) &&
            char !== 0xFF3B /* fullwidth left square bracket */ &&
            char !== 0xFF3D /* fullwidth right square bracket */ &&
            char !== 0xFF3F /* fullwidth low line */ &&
            !(char >= 0xFF5B /* fullwidth left curly bracket */ && char <= 0xFFDF) &&
            char !== 0xFFE3 /* fullwidth macron */ &&
            !(char >= 0xFFE8 /* halfwidth forms light vertical */ && char <= 0xFFEF)) {
            return true;
        }
    }
    if (unicodeBlockLookup['Small Form Variants'](char)) {
        if (!((char >= 0xFE58 /* small em dash */ && char <= 0xFE5E) /* small right tortoise shell bracket */) &&
            !((char >= 0xFE63 /* small hyphen-minus */ && char <= 0xFE66) /* small equals sign */)) {
            return true;
        }
    }
    if (unicodeBlockLookup['Unified Canadian Aboriginal Syllabics'](char))
        return true;
    if (unicodeBlockLookup['Unified Canadian Aboriginal Syllabics Extended'](char))
        return true;
    if (unicodeBlockLookup['Vertical Forms'](char))
        return true;
    if (unicodeBlockLookup['Yijing Hexagram Symbols'](char))
        return true;
    if (unicodeBlockLookup['Yi Syllables'](char))
        return true;
    if (unicodeBlockLookup['Yi Radicals'](char))
        return true;
    return false;
}
/**
 * Returns true if the given Unicode codepoint identifies a character with
 * neutral orientation.
 *
 * A character has neutral orientation if it may be drawn rotated or unrotated
 * when the line is oriented vertically, depending on the orientation of the
 * adjacent characters. For example, along a vertically oriented line, the vulgar
 * fraction ½ is drawn upright among Chinese characters but rotated among Latin
 * letters. A neutrally oriented character does not influence whether an
 * adjacent character is drawn upright or rotated.
 */
function charHasNeutralVerticalOrientation(char) {
    if (unicodeBlockLookup['Latin-1 Supplement'](char)) {
        if (char === 0x00A7 /* section sign */ ||
            char === 0x00A9 /* copyright sign */ ||
            char === 0x00AE /* registered sign */ ||
            char === 0x00B1 /* plus-minus sign */ ||
            char === 0x00BC /* vulgar fraction one quarter */ ||
            char === 0x00BD /* vulgar fraction one half */ ||
            char === 0x00BE /* vulgar fraction three quarters */ ||
            char === 0x00D7 /* multiplication sign */ ||
            char === 0x00F7 /* division sign */) {
            return true;
        }
    }
    if (unicodeBlockLookup['General Punctuation'](char)) {
        if (char === 0x2016 /* double vertical line */ ||
            char === 0x2020 /* dagger */ ||
            char === 0x2021 /* double dagger */ ||
            char === 0x2030 /* per mille sign */ ||
            char === 0x2031 /* per ten thousand sign */ ||
            char === 0x203B /* reference mark */ ||
            char === 0x203C /* double exclamation mark */ ||
            char === 0x2042 /* asterism */ ||
            char === 0x2047 /* double question mark */ ||
            char === 0x2048 /* question exclamation mark */ ||
            char === 0x2049 /* exclamation question mark */ ||
            char === 0x2051 /* two asterisks aligned vertically */) {
            return true;
        }
    }
    if (unicodeBlockLookup['Letterlike Symbols'](char))
        return true;
    if (unicodeBlockLookup['Number Forms'](char))
        return true;
    if (unicodeBlockLookup['Miscellaneous Technical'](char)) {
        if ((char >= 0x2300 /* diameter sign */ && char <= 0x2307 /* wavy line */) ||
            (char >= 0x230C /* bottom right crop */ && char <= 0x231F /* bottom right corner */) ||
            (char >= 0x2324 /* up arrowhead between two horizontal bars */ && char <= 0x2328 /* keyboard */) ||
            char === 0x232B /* erase to the left */ ||
            (char >= 0x237D /* shouldered open box */ && char <= 0x239A /* clear screen symbol */) ||
            (char >= 0x23BE /* dentistry symbol light vertical and top right */ && char <= 0x23CD /* square foot */) ||
            char === 0x23CF /* eject symbol */ ||
            (char >= 0x23D1 /* metrical breve */ && char <= 0x23DB /* fuse */) ||
            (char >= 0x23E2 /* white trapezium */ && char <= 0x23FF)) {
            return true;
        }
    }
    if (unicodeBlockLookup['Control Pictures'](char) && char !== 0x2423 /* open box */)
        return true;
    if (unicodeBlockLookup['Optical Character Recognition'](char))
        return true;
    if (unicodeBlockLookup['Enclosed Alphanumerics'](char))
        return true;
    if (unicodeBlockLookup['Geometric Shapes'](char))
        return true;
    if (unicodeBlockLookup['Miscellaneous Symbols'](char)) {
        if (!((char >= 0x261A /* black left pointing index */ && char <= 0x261F) /* white down pointing index */)) {
            return true;
        }
    }
    if (unicodeBlockLookup['Miscellaneous Symbols and Arrows'](char)) {
        if ((char >= 0x2B12 /* square with top half black */ && char <= 0x2B2F /* white vertical ellipse */) ||
            (char >= 0x2B50 /* white medium star */ && char <= 0x2B59 /* heavy circled saltire */) ||
            (char >= 0x2BB8 /* upwards white arrow from bar with horizontal bar */ && char <= 0x2BEB)) {
            return true;
        }
    }
    if (unicodeBlockLookup['CJK Symbols and Punctuation'](char))
        return true;
    if (unicodeBlockLookup['Katakana'](char))
        return true;
    if (unicodeBlockLookup['Private Use Area'](char))
        return true;
    if (unicodeBlockLookup['CJK Compatibility Forms'](char))
        return true;
    if (unicodeBlockLookup['Small Form Variants'](char))
        return true;
    if (unicodeBlockLookup['Halfwidth and Fullwidth Forms'](char))
        return true;
    if (char === 0x221E /* infinity */ ||
        char === 0x2234 /* therefore */ ||
        char === 0x2235 /* because */ ||
        (char >= 0x2700 /* black safety scissors */ && char <= 0x2767 /* rotated floral heart bullet */) ||
        (char >= 0x2776 /* dingbat negative circled digit one */ && char <= 0x2793 /* dingbat negative circled sans-serif number ten */) ||
        char === 0xFFFC /* object replacement character */ ||
        char === 0xFFFD /* replacement character */) {
        return true;
    }
    return false;
}
/**
 * Returns true if the given Unicode codepoint identifies a character with
 * rotated orientation.
 *
 * A character has rotated orientation if it is drawn rotated when the line is
 * oriented vertically, even if both adjacent characters are upright. For
 * example, a Latin letter is drawn rotated along a vertical line. A rotated
 * character causes an adjacent “neutral” character to be drawn rotated as well.
 */
function charHasRotatedVerticalOrientation(char) {
    return !(charHasUprightVerticalOrientation(char) ||
        charHasNeutralVerticalOrientation(char));
}
function charInComplexShapingScript(char) {
    return unicodeBlockLookup['Arabic'](char) ||
        unicodeBlockLookup['Arabic Supplement'](char) ||
        unicodeBlockLookup['Arabic Extended-A'](char) ||
        unicodeBlockLookup['Arabic Presentation Forms-A'](char) ||
        unicodeBlockLookup['Arabic Presentation Forms-B'](char);
}
function charInRTLScript(char) {
    // Main blocks for Hebrew, Arabic, Thaana and other RTL scripts
    return (char >= 0x0590 && char <= 0x08FF) ||
        unicodeBlockLookup['Arabic Presentation Forms-A'](char) ||
        unicodeBlockLookup['Arabic Presentation Forms-B'](char);
}
function charInSupportedScript(char, canRenderRTL) {
    // This is a rough heuristic: whether we "can render" a script
    // actually depends on the properties of the font being used
    // and whether differences from the ideal rendering are considered
    // semantically significant.
    // Even in Latin script, we "can't render" combinations such as the fi
    // ligature, but we don't consider that semantically significant.
    if (!canRenderRTL && charInRTLScript(char)) {
        return false;
    }
    if ((char >= 0x0900 && char <= 0x0DFF) ||
        // Main blocks for Indic scripts and Sinhala
        (char >= 0x0F00 && char <= 0x109F) ||
        // Main blocks for Tibetan and Myanmar
        unicodeBlockLookup['Khmer'](char)) {
        // These blocks cover common scripts that require
        // complex text shaping, based on unicode script metadata:
        // https://www.unicode.org/repos/cldr/trunk/common/properties/scriptMetadata.txt
        // where "Web Rank <= 32" "Shaping Required = YES"
        return false;
    }
    return true;
}
function stringContainsRTLText(chars) {
    for (const char of chars) {
        if (charInRTLScript(char.charCodeAt(0))) {
            return true;
        }
    }
    return false;
}
function isStringInSupportedScript(chars, canRenderRTL) {
    for (const char of chars) {
        if (!charInSupportedScript(char.charCodeAt(0), canRenderRTL)) {
            return false;
        }
    }
    return true;
}

class RTLWorkerPlugin {
    constructor() {
        this.applyArabicShaping = null;
        this.processBidirectionalText = null;
        this.processStyledBidirectionalText = null;
        this.pluginStatus = 'unavailable';
        this.pluginURL = null;
    }
    setState(state) {
        this.pluginStatus = state.pluginStatus;
        this.pluginURL = state.pluginURL;
    }
    getState() {
        return {
            pluginStatus: this.pluginStatus,
            pluginURL: this.pluginURL
        };
    }
    setMethods(rtlTextPlugin) {
        this.applyArabicShaping = rtlTextPlugin.applyArabicShaping;
        this.processBidirectionalText = rtlTextPlugin.processBidirectionalText;
        this.processStyledBidirectionalText = rtlTextPlugin.processStyledBidirectionalText;
    }
    isParsed() {
        return this.applyArabicShaping != null &&
            this.processBidirectionalText != null &&
            this.processStyledBidirectionalText != null;
    }
    getPluginURL() {
        return this.pluginURL;
    }
    getRTLTextPluginStatus() {
        return this.pluginStatus;
    }
}
const rtlWorkerPlugin = new RTLWorkerPlugin();

/**
 * @internal
 * A parameter that can be evaluated to a value
 */
class EvaluationParameters {
    // "options" may also be another EvaluationParameters to copy, see CrossFadedProperty.possiblyEvaluate
    constructor(zoom, options) {
        this.zoom = zoom;
        if (options) {
            this.now = options.now;
            this.fadeDuration = options.fadeDuration;
            this.zoomHistory = options.zoomHistory;
            this.transition = options.transition;
        }
        else {
            this.now = 0;
            this.fadeDuration = 0;
            this.zoomHistory = new ZoomHistory();
            this.transition = {};
        }
    }
    isSupportedScript(str) {
        return isStringInSupportedScript(str, rtlWorkerPlugin.getRTLTextPluginStatus() === 'loaded');
    }
    crossFadingFactor() {
        if (this.fadeDuration === 0) {
            return 1;
        }
        else {
            return Math.min((this.now - this.zoomHistory.lastIntegerZoomTime) / this.fadeDuration, 1);
        }
    }
    getCrossfadeParameters() {
        const z = this.zoom;
        const fraction = z - Math.floor(z);
        const t = this.crossFadingFactor();
        return z > this.zoomHistory.lastIntegerZoom ?
            { fromScale: 2, toScale: 1, t: fraction + (1 - fraction) * t } :
            { fromScale: 0.5, toScale: 1, t: 1 - (1 - t) * fraction };
    }
}

/**
 * @internal
 *  `PropertyValue` represents the value part of a property key-value unit. It's used to represent both
 *  paint and layout property values, and regardless of whether or not their property supports data-driven
 *  expressions.
 *
 *  `PropertyValue` stores the raw input value as seen in a style or a runtime styling API call, i.e. one of the
 *  following:
 *
 *    * A constant value of the type appropriate for the property
 *    * A function which produces a value of that type (but functions are quasi-deprecated in favor of expressions)
 *    * An expression which produces a value of that type
 *    * "undefined"/"not present", in which case the property is assumed to take on its default value.
 *
 *  In addition to storing the original input value, `PropertyValue` also stores a normalized representation,
 *  effectively treating functions as if they are expressions, and constant or default values as if they are
 *  (constant) expressions.
 */
class PropertyValue {
    constructor(property, value) {
        this.property = property;
        this.value = value;
        this.expression = normalizePropertyExpression(value === undefined ? property.specification.default : value, property.specification);
    }
    isDataDriven() {
        return this.expression.kind === 'source' || this.expression.kind === 'composite';
    }
    possiblyEvaluate(parameters, canonical, availableImages) {
        return this.property.possiblyEvaluate(this, parameters, canonical, availableImages);
    }
}
/**
 * @internal
 * Paint properties are _transitionable_: they can change in a fluid manner, interpolating or cross-fading between
 * old and new value. The duration of the transition, and the delay before it begins, is configurable.
 *
 * `TransitionablePropertyValue` is a compositional class that stores both the property value and that transition
 * configuration.
 *
 * A `TransitionablePropertyValue` can calculate the next step in the evaluation chain for paint property values:
 * `TransitioningPropertyValue`.
 */
class TransitionablePropertyValue {
    constructor(property) {
        this.property = property;
        this.value = new PropertyValue(property, undefined);
    }
    transitioned(parameters, prior) {
        return new TransitioningPropertyValue(this.property, this.value, prior, extend({}, parameters.transition, this.transition), parameters.now);
    }
    untransitioned() {
        return new TransitioningPropertyValue(this.property, this.value, null, {}, 0);
    }
}
/**
 * @internal
 * `Transitionable` stores a map of all (property name, `TransitionablePropertyValue`) pairs for paint properties of a
 * given layer type. It can calculate the `TransitioningPropertyValue`s for all of them at once, producing a
 * `Transitioning` instance for the same set of properties.
 */
class Transitionable {
    constructor(properties) {
        this._properties = properties;
        this._values = Object.create(properties.defaultTransitionablePropertyValues);
    }
    getValue(name) {
        return clone$1(this._values[name].value.value);
    }
    setValue(name, value) {
        if (!Object.prototype.hasOwnProperty.call(this._values, name)) {
            this._values[name] = new TransitionablePropertyValue(this._values[name].property);
        }
        // Note that we do not _remove_ an own property in the case where a value is being reset
        // to the default: the transition might still be non-default.
        this._values[name].value = new PropertyValue(this._values[name].property, value === null ? undefined : clone$1(value));
    }
    getTransition(name) {
        return clone$1(this._values[name].transition);
    }
    setTransition(name, value) {
        if (!Object.prototype.hasOwnProperty.call(this._values, name)) {
            this._values[name] = new TransitionablePropertyValue(this._values[name].property);
        }
        this._values[name].transition = clone$1(value) || undefined;
    }
    serialize() {
        const result = {};
        for (const property of Object.keys(this._values)) {
            const value = this.getValue(property);
            if (value !== undefined) {
                result[property] = value;
            }
            const transition = this.getTransition(property);
            if (transition !== undefined) {
                result[`${property}-transition`] = transition;
            }
        }
        return result;
    }
    transitioned(parameters, prior) {
        const result = new Transitioning(this._properties);
        for (const property of Object.keys(this._values)) {
            result._values[property] = this._values[property].transitioned(parameters, prior._values[property]);
        }
        return result;
    }
    untransitioned() {
        const result = new Transitioning(this._properties);
        for (const property of Object.keys(this._values)) {
            result._values[property] = this._values[property].untransitioned();
        }
        return result;
    }
}
/**
 * @internal
 * `TransitioningPropertyValue` implements the first of two intermediate steps in the evaluation chain of a paint
 * property value. In this step, transitions between old and new values are handled: as long as the transition is in
 * progress, `TransitioningPropertyValue` maintains a reference to the prior value, and interpolates between it and
 * the new value based on the current time and the configured transition duration and delay. The product is the next
 * step in the evaluation chain: the "possibly evaluated" result type `R`. See below for more on this concept.
 */
class TransitioningPropertyValue {
    constructor(property, value, prior, transition, now) {
        this.property = property;
        this.value = value;
        this.begin = now + transition.delay || 0;
        this.end = this.begin + transition.duration || 0;
        if (property.specification.transition && (transition.delay || transition.duration)) {
            this.prior = prior;
        }
    }
    possiblyEvaluate(parameters, canonical, availableImages) {
        const now = parameters.now || 0;
        const finalValue = this.value.possiblyEvaluate(parameters, canonical, availableImages);
        const prior = this.prior;
        if (!prior) {
            // No prior value.
            return finalValue;
        }
        else if (now > this.end) {
            // Transition from prior value is now complete.
            this.prior = null;
            return finalValue;
        }
        else if (this.value.isDataDriven()) {
            // Transitions to data-driven properties are not supported.
            // We snap immediately to the data-driven value so that, when we perform layout,
            // we see the data-driven function and can use it to populate vertex buffers.
            this.prior = null;
            return finalValue;
        }
        else if (now < this.begin) {
            // Transition hasn't started yet.
            return prior.possiblyEvaluate(parameters, canonical, availableImages);
        }
        else {
            // Interpolate between recursively-calculated prior value and final.
            const t = (now - this.begin) / (this.end - this.begin);
            return this.property.interpolate(prior.possiblyEvaluate(parameters, canonical, availableImages), finalValue, easeCubicInOut(t));
        }
    }
}
/**
 * @internal
 * `Transitioning` stores a map of all (property name, `TransitioningPropertyValue`) pairs for paint properties of a
 * given layer type. It can calculate the possibly-evaluated values for all of them at once, producing a
 * `PossiblyEvaluated` instance for the same set of properties.
 */
class Transitioning {
    constructor(properties) {
        this._properties = properties;
        this._values = Object.create(properties.defaultTransitioningPropertyValues);
    }
    possiblyEvaluate(parameters, canonical, availableImages) {
        const result = new PossiblyEvaluated(this._properties);
        for (const property of Object.keys(this._values)) {
            result._values[property] = this._values[property].possiblyEvaluate(parameters, canonical, availableImages);
        }
        return result;
    }
    hasTransition() {
        for (const property of Object.keys(this._values)) {
            if (this._values[property].prior) {
                return true;
            }
        }
        return false;
    }
}
// ------- Layout -------
/**
 * Because layout properties are not transitionable, they have a simpler representation and evaluation chain than
 * paint properties: `PropertyValue`s are possibly evaluated, producing possibly evaluated values, which are then
 * fully evaluated.
 *
 * `Layout` stores a map of all (property name, `PropertyValue`) pairs for layout properties of a
 * given layer type. It can calculate the possibly-evaluated values for all of them at once, producing a
 * `PossiblyEvaluated` instance for the same set of properties.
 */
class Layout {
    constructor(properties) {
        this._properties = properties;
        this._values = Object.create(properties.defaultPropertyValues);
    }
    hasValue(name) {
        return this._values[name].value !== undefined;
    }
    getValue(name) {
        return clone$1(this._values[name].value);
    }
    setValue(name, value) {
        this._values[name] = new PropertyValue(this._values[name].property, value === null ? undefined : clone$1(value));
    }
    serialize() {
        const result = {};
        for (const property of Object.keys(this._values)) {
            const value = this.getValue(property);
            if (value !== undefined) {
                result[property] = value;
            }
        }
        return result;
    }
    possiblyEvaluate(parameters, canonical, availableImages) {
        const result = new PossiblyEvaluated(this._properties);
        for (const property of Object.keys(this._values)) {
            result._values[property] = this._values[property].possiblyEvaluate(parameters, canonical, availableImages);
        }
        return result;
    }
}
/**
 * @internal
 * `PossiblyEvaluatedPropertyValue` is used for data-driven paint and layout property values. It holds a
 * `PossiblyEvaluatedValue` and the `GlobalProperties` that were used to generate it. You're not allowed to supply
 * a different set of `GlobalProperties` when performing the final evaluation because they would be ignored in the
 * case where the input value was a constant or camera function.
 */
class PossiblyEvaluatedPropertyValue {
    constructor(property, value, parameters) {
        this.property = property;
        this.value = value;
        this.parameters = parameters;
    }
    isConstant() {
        return this.value.kind === 'constant';
    }
    constantOr(value) {
        if (this.value.kind === 'constant') {
            return this.value.value;
        }
        else {
            return value;
        }
    }
    evaluate(feature, featureState, canonical, availableImages) {
        return this.property.evaluate(this.value, this.parameters, feature, featureState, canonical, availableImages);
    }
}
/**
 * @internal
 * `PossiblyEvaluated` stores a map of all (property name, `R`) pairs for paint or layout properties of a
 * given layer type.
 */
class PossiblyEvaluated {
    constructor(properties) {
        this._properties = properties;
        this._values = Object.create(properties.defaultPossiblyEvaluatedValues);
    }
    get(name) {
        return this._values[name];
    }
}
/**
 * @internal
 * An implementation of `Property` for properties that do not permit data-driven (source or composite) expressions.
 * This restriction allows us to declare statically that the result of possibly evaluating this kind of property
 * is in fact always the scalar type `T`, and can be used without further evaluating the value on a per-feature basis.
 */
class DataConstantProperty {
    constructor(specification) {
        this.specification = specification;
    }
    possiblyEvaluate(value, parameters) {
        if (value.isDataDriven())
            throw new Error('Value should not be data driven');
        return value.expression.evaluate(parameters);
    }
    interpolate(a, b, t) {
        const interpolationType = this.specification.type;
        const interpolationFn = interpolate[interpolationType];
        if (interpolationFn) {
            return interpolationFn(a, b, t);
        }
        else {
            return a;
        }
    }
}
/**
 * @internal
 * An implementation of `Property` for properties that permit data-driven (source or composite) expressions.
 * The result of possibly evaluating this kind of property is `PossiblyEvaluatedPropertyValue<T>`; obtaining
 * a scalar value `T` requires further evaluation on a per-feature basis.
 */
class DataDrivenProperty {
    constructor(specification, overrides) {
        this.specification = specification;
        this.overrides = overrides;
    }
    possiblyEvaluate(value, parameters, canonical, availableImages) {
        if (value.expression.kind === 'constant' || value.expression.kind === 'camera') {
            return new PossiblyEvaluatedPropertyValue(this, { kind: 'constant', value: value.expression.evaluate(parameters, null, {}, canonical, availableImages) }, parameters);
        }
        else {
            return new PossiblyEvaluatedPropertyValue(this, value.expression, parameters);
        }
    }
    interpolate(a, b, t) {
        // If either possibly-evaluated value is non-constant, give up: we aren't able to interpolate data-driven values.
        if (a.value.kind !== 'constant' || b.value.kind !== 'constant') {
            return a;
        }
        // Special case hack solely for fill-outline-color. The undefined value is subsequently handled in
        // FillStyleLayer#recalculate, which sets fill-outline-color to the fill-color value if the former
        // is a PossiblyEvaluatedPropertyValue containing a constant undefined value. In addition to the
        // return value here, the other source of a PossiblyEvaluatedPropertyValue containing a constant
        // undefined value is the "default value" for fill-outline-color held in
        // `Properties#defaultPossiblyEvaluatedValues`, which serves as the prototype of
        // `PossiblyEvaluated#_values`.
        if (a.value.value === undefined || b.value.value === undefined) {
            return new PossiblyEvaluatedPropertyValue(this, { kind: 'constant', value: undefined }, a.parameters);
        }
        const interpolationType = this.specification.type;
        const interpolationFn = interpolate[interpolationType];
        if (interpolationFn) {
            const interpolatedValue = interpolationFn(a.value.value, b.value.value, t);
            return new PossiblyEvaluatedPropertyValue(this, { kind: 'constant', value: interpolatedValue }, a.parameters);
        }
        else {
            return a;
        }
    }
    evaluate(value, parameters, feature, featureState, canonical, availableImages) {
        if (value.kind === 'constant') {
            return value.value;
        }
        else {
            return value.evaluate(parameters, feature, featureState, canonical, availableImages);
        }
    }
}
/**
 * @internal
 * An implementation of `Property` for  data driven `line-pattern` which are transitioned by cross-fading
 * rather than interpolation.
 */
class CrossFadedDataDrivenProperty extends DataDrivenProperty {
    possiblyEvaluate(value, parameters, canonical, availableImages) {
        if (value.value === undefined) {
            return new PossiblyEvaluatedPropertyValue(this, { kind: 'constant', value: undefined }, parameters);
        }
        else if (value.expression.kind === 'constant') {
            const evaluatedValue = value.expression.evaluate(parameters, null, {}, canonical, availableImages);
            const isImageExpression = value.property.specification.type === 'resolvedImage';
            const constantValue = isImageExpression && typeof evaluatedValue !== 'string' ? evaluatedValue.name : evaluatedValue;
            const constant = this._calculate(constantValue, constantValue, constantValue, parameters);
            return new PossiblyEvaluatedPropertyValue(this, { kind: 'constant', value: constant }, parameters);
        }
        else if (value.expression.kind === 'camera') {
            const cameraVal = this._calculate(value.expression.evaluate({ zoom: parameters.zoom - 1.0 }), value.expression.evaluate({ zoom: parameters.zoom }), value.expression.evaluate({ zoom: parameters.zoom + 1.0 }), parameters);
            return new PossiblyEvaluatedPropertyValue(this, { kind: 'constant', value: cameraVal }, parameters);
        }
        else {
            // source or composite expression
            return new PossiblyEvaluatedPropertyValue(this, value.expression, parameters);
        }
    }
    evaluate(value, globals, feature, featureState, canonical, availableImages) {
        if (value.kind === 'source') {
            const constant = value.evaluate(globals, feature, featureState, canonical, availableImages);
            return this._calculate(constant, constant, constant, globals);
        }
        else if (value.kind === 'composite') {
            return this._calculate(value.evaluate({ zoom: Math.floor(globals.zoom) - 1.0 }, feature, featureState), value.evaluate({ zoom: Math.floor(globals.zoom) }, feature, featureState), value.evaluate({ zoom: Math.floor(globals.zoom) + 1.0 }, feature, featureState), globals);
        }
        else {
            return value.value;
        }
    }
    _calculate(min, mid, max, parameters) {
        const z = parameters.zoom;
        return z > parameters.zoomHistory.lastIntegerZoom ? { from: min, to: mid } : { from: max, to: mid };
    }
    interpolate(a) {
        return a;
    }
}
/**
 * @internal
 * An implementation of `Property` for `*-pattern` and `line-dasharray`, which are transitioned by cross-fading
 * rather than interpolation.
 */
class CrossFadedProperty {
    constructor(specification) {
        this.specification = specification;
    }
    possiblyEvaluate(value, parameters, canonical, availableImages) {
        if (value.value === undefined) {
            return undefined;
        }
        else if (value.expression.kind === 'constant') {
            const constant = value.expression.evaluate(parameters, null, {}, canonical, availableImages);
            return this._calculate(constant, constant, constant, parameters);
        }
        else {
            return this._calculate(value.expression.evaluate(new EvaluationParameters(Math.floor(parameters.zoom - 1.0), parameters)), value.expression.evaluate(new EvaluationParameters(Math.floor(parameters.zoom), parameters)), value.expression.evaluate(new EvaluationParameters(Math.floor(parameters.zoom + 1.0), parameters)), parameters);
        }
    }
    _calculate(min, mid, max, parameters) {
        const z = parameters.zoom;
        return z > parameters.zoomHistory.lastIntegerZoom ? { from: min, to: mid } : { from: max, to: mid };
    }
    interpolate(a) {
        return a;
    }
}
/**
 * @internal
 * An implementation of `Property` for `heatmap-color` and `line-gradient`. Interpolation is a no-op, and
 * evaluation returns a boolean value in order to indicate its presence, but the real
 * evaluation happens in StyleLayer classes.
 */
class ColorRampProperty {
    constructor(specification) {
        this.specification = specification;
    }
    possiblyEvaluate(value, parameters, canonical, availableImages) {
        return !!value.expression.evaluate(parameters, null, {}, canonical, availableImages);
    }
    interpolate() { return false; }
}
/**
 * @internal
 * `Properties` holds objects containing default values for the layout or paint property set of a given
 * layer type. These objects are immutable, and they are used as the prototypes for the `_values` members of
 * `Transitionable`, `Transitioning`, `Layout`, and `PossiblyEvaluated`. This allows these classes to avoid
 * doing work in the common case where a property has no explicit value set and should be considered to take
 * on the default value: using `for (const property of Object.keys(this._values))`, they can iterate over
 * only the _own_ properties of `_values`, skipping repeated calculation of transitions and possible/final
 * evaluations for defaults, the result of which will always be the same.
 */
class Properties {
    constructor(properties) {
        this.properties = properties;
        this.defaultPropertyValues = {};
        this.defaultTransitionablePropertyValues = {};
        this.defaultTransitioningPropertyValues = {};
        this.defaultPossiblyEvaluatedValues = {};
        this.overridableProperties = [];
        for (const property in properties) {
            const prop = properties[property];
            if (prop.specification.overridable) {
                this.overridableProperties.push(property);
            }
            const defaultPropertyValue = this.defaultPropertyValues[property] =
                new PropertyValue(prop, undefined);
            const defaultTransitionablePropertyValue = this.defaultTransitionablePropertyValues[property] =
                new TransitionablePropertyValue(prop);
            this.defaultTransitioningPropertyValues[property] =
                defaultTransitionablePropertyValue.untransitioned();
            this.defaultPossiblyEvaluatedValues[property] =
                defaultPropertyValue.possiblyEvaluate({});
        }
    }
}
register('DataDrivenProperty', DataDrivenProperty);
register('DataConstantProperty', DataConstantProperty);
register('CrossFadedDataDrivenProperty', CrossFadedDataDrivenProperty);
register('CrossFadedProperty', CrossFadedProperty);
register('ColorRampProperty', ColorRampProperty);

const TRANSITION_SUFFIX = '-transition';
/**
 * A base class for style layers
 */
class StyleLayer extends Evented {
    constructor(layer, properties) {
        super();
        this.id = layer.id;
        this.type = layer.type;
        this._featureFilter = { filter: () => true, needGeometry: false };
        if (layer.type === 'custom')
            return;
        layer = layer;
        this.metadata = layer.metadata;
        this.minzoom = layer.minzoom;
        this.maxzoom = layer.maxzoom;
        if (layer.type !== 'background') {
            this.source = layer.source;
            this.sourceLayer = layer['source-layer'];
            this.filter = layer.filter;
        }
        if (properties.layout) {
            this._unevaluatedLayout = new Layout(properties.layout);
        }
        if (properties.paint) {
            this._transitionablePaint = new Transitionable(properties.paint);
            for (const property in layer.paint) {
                this.setPaintProperty(property, layer.paint[property], { validate: false });
            }
            for (const property in layer.layout) {
                this.setLayoutProperty(property, layer.layout[property], { validate: false });
            }
            this._transitioningPaint = this._transitionablePaint.untransitioned();
            //$FlowFixMe
            this.paint = new PossiblyEvaluated(properties.paint);
        }
    }
    getCrossfadeParameters() {
        return this._crossfadeParameters;
    }
    getLayoutProperty(name) {
        if (name === 'visibility') {
            return this.visibility;
        }
        return this._unevaluatedLayout.getValue(name);
    }
    setLayoutProperty(name, value, options = {}) {
        if (value !== null && value !== undefined) {
            const key = `layers.${this.id}.layout.${name}`;
            if (this._validate(validateLayoutProperty, key, name, value, options)) {
                return;
            }
        }
        if (name === 'visibility') {
            this.visibility = value;
            return;
        }
        this._unevaluatedLayout.setValue(name, value);
    }
    getPaintProperty(name) {
        if (name.endsWith(TRANSITION_SUFFIX)) {
            return this._transitionablePaint.getTransition(name.slice(0, -TRANSITION_SUFFIX.length));
        }
        else {
            return this._transitionablePaint.getValue(name);
        }
    }
    setPaintProperty(name, value, options = {}) {
        if (value !== null && value !== undefined) {
            const key = `layers.${this.id}.paint.${name}`;
            if (this._validate(validatePaintProperty, key, name, value, options)) {
                return false;
            }
        }
        if (name.endsWith(TRANSITION_SUFFIX)) {
            this._transitionablePaint.setTransition(name.slice(0, -TRANSITION_SUFFIX.length), value || undefined);
            return false;
        }
        else {
            const transitionable = this._transitionablePaint._values[name];
            const isCrossFadedProperty = transitionable.property.specification['property-type'] === 'cross-faded-data-driven';
            const wasDataDriven = transitionable.value.isDataDriven();
            const oldValue = transitionable.value;
            this._transitionablePaint.setValue(name, value);
            this._handleSpecialPaintPropertyUpdate(name);
            const newValue = this._transitionablePaint._values[name].value;
            const isDataDriven = newValue.isDataDriven();
            // if a cross-faded value is changed, we need to make sure the new icons get added to each tile's iconAtlas
            // so a call to _updateLayer is necessary, and we return true from this function so it gets called in
            // Style#setPaintProperty
            return isDataDriven || wasDataDriven || isCrossFadedProperty || this._handleOverridablePaintPropertyUpdate(name, oldValue, newValue);
        }
    }
    _handleSpecialPaintPropertyUpdate(_) {
        // No-op; can be overridden by derived classes.
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _handleOverridablePaintPropertyUpdate(name, oldValue, newValue) {
        // No-op; can be overridden by derived classes.
        return false;
    }
    isHidden(zoom) {
        if (this.minzoom && zoom < this.minzoom)
            return true;
        if (this.maxzoom && zoom >= this.maxzoom)
            return true;
        return this.visibility === 'none';
    }
    updateTransitions(parameters) {
        this._transitioningPaint = this._transitionablePaint.transitioned(parameters, this._transitioningPaint);
    }
    hasTransition() {
        return this._transitioningPaint.hasTransition();
    }
    recalculate(parameters, availableImages) {
        if (parameters.getCrossfadeParameters) {
            this._crossfadeParameters = parameters.getCrossfadeParameters();
        }
        if (this._unevaluatedLayout) {
            this.layout = this._unevaluatedLayout.possiblyEvaluate(parameters, undefined, availableImages);
        }
        this.paint = this._transitioningPaint.possiblyEvaluate(parameters, undefined, availableImages);
    }
    serialize() {
        const output = {
            'id': this.id,
            'type': this.type,
            'source': this.source,
            'source-layer': this.sourceLayer,
            'metadata': this.metadata,
            'minzoom': this.minzoom,
            'maxzoom': this.maxzoom,
            'filter': this.filter,
            'layout': this._unevaluatedLayout && this._unevaluatedLayout.serialize(),
            'paint': this._transitionablePaint && this._transitionablePaint.serialize()
        };
        if (this.visibility) {
            output.layout = output.layout || {};
            output.layout.visibility = this.visibility;
        }
        return filterObject(output, (value, key) => {
            return value !== undefined &&
                !(key === 'layout' && !Object.keys(value).length) &&
                !(key === 'paint' && !Object.keys(value).length);
        });
    }
    _validate(validate, key, name, value, options = {}) {
        if (options && options.validate === false) {
            return false;
        }
        return emitValidationErrors(this, validate.call(validateStyle, {
            key,
            layerType: this.type,
            objectKey: name,
            value,
            styleSpec: v8Spec,
            // Workaround for https://github.com/mapbox/mapbox-gl-js/issues/2407
            style: { glyphs: true, sprite: true }
        }));
    }
    is3D() {
        return false;
    }
    isTileClipped() {
        return false;
    }
    hasOffscreenPass() {
        return false;
    }
    resize() {
        // noop
    }
    isStateDependent() {
        for (const property in this.paint._values) {
            const value = this.paint.get(property);
            if (!(value instanceof PossiblyEvaluatedPropertyValue) || !supportsPropertyExpression(value.property.specification)) {
                continue;
            }
            if ((value.value.kind === 'source' || value.value.kind === 'composite') &&
                value.value.isStateDependent) {
                return true;
            }
        }
        return false;
    }
}

// Note: all "sizes" are measured in bytes
/**
 * @internal
 * A view type size
 */
const viewTypes = {
    'Int8': Int8Array,
    'Uint8': Uint8Array,
    'Int16': Int16Array,
    'Uint16': Uint16Array,
    'Int32': Int32Array,
    'Uint32': Uint32Array,
    'Float32': Float32Array
};
/** @internal */
class Struct {
    /**
     * @param structArray - The StructArray the struct is stored in
     * @param index - The index of the struct in the StructArray.
     */
    constructor(structArray, index) {
        this._structArray = structArray;
        this._pos1 = index * this.size;
        this._pos2 = this._pos1 / 2;
        this._pos4 = this._pos1 / 4;
        this._pos8 = this._pos1 / 8;
    }
}
const DEFAULT_CAPACITY = 128;
const RESIZE_MULTIPLIER = 5;
/**
 * @internal
 * `StructArray` provides an abstraction over `ArrayBuffer` and `TypedArray`
 * making it behave like an array of typed structs.
 *
 * Conceptually, a StructArray is comprised of elements, i.e., instances of its
 * associated struct type. Each particular struct type, together with an
 * alignment size, determines the memory layout of a StructArray whose elements
 * are of that type.  Thus, for each such layout that we need, we have
 * a corresponding StructArrayLayout class, inheriting from StructArray and
 * implementing `emplaceBack()` and `_refreshViews()`.
 *
 * In some cases, where we need to access particular elements of a StructArray,
 * we implement a more specific subclass that inherits from one of the
 * StructArrayLayouts and adds a `get(i): T` accessor that returns a structured
 * object whose properties are proxies into the underlying memory space for the
 * i-th element.  This affords the convenience of working with (seemingly) plain
 * Javascript objects without the overhead of serializing/deserializing them
 * into ArrayBuffers for efficient web worker transfer.
 */
class StructArray {
    constructor() {
        this.isTransferred = false;
        this.capacity = -1;
        this.resize(0);
    }
    /**
     * Serialize a StructArray instance.  Serializes both the raw data and the
     * metadata needed to reconstruct the StructArray base class during
     * deserialization.
     */
    static serialize(array, transferables) {
        array._trim();
        if (transferables) {
            array.isTransferred = true;
            transferables.push(array.arrayBuffer);
        }
        return {
            length: array.length,
            arrayBuffer: array.arrayBuffer,
        };
    }
    static deserialize(input) {
        const structArray = Object.create(this.prototype);
        structArray.arrayBuffer = input.arrayBuffer;
        structArray.length = input.length;
        structArray.capacity = input.arrayBuffer.byteLength / structArray.bytesPerElement;
        structArray._refreshViews();
        return structArray;
    }
    /**
     * Resize the array to discard unused capacity.
     */
    _trim() {
        if (this.length !== this.capacity) {
            this.capacity = this.length;
            this.arrayBuffer = this.arrayBuffer.slice(0, this.length * this.bytesPerElement);
            this._refreshViews();
        }
    }
    /**
     * Resets the length of the array to 0 without de-allocating capacity.
     */
    clear() {
        this.length = 0;
    }
    /**
     * Resize the array.
     * If `n` is greater than the current length then additional elements with undefined values are added.
     * If `n` is less than the current length then the array will be reduced to the first `n` elements.
     * @param n - The new size of the array.
     */
    resize(n) {
        this.reserve(n);
        this.length = n;
    }
    /**
     * Indicate a planned increase in size, so that any necessary allocation may
     * be done once, ahead of time.
     * @param n - The expected size of the array.
     */
    reserve(n) {
        if (n > this.capacity) {
            this.capacity = Math.max(n, Math.floor(this.capacity * RESIZE_MULTIPLIER), DEFAULT_CAPACITY);
            this.arrayBuffer = new ArrayBuffer(this.capacity * this.bytesPerElement);
            const oldUint8Array = this.uint8;
            this._refreshViews();
            if (oldUint8Array)
                this.uint8.set(oldUint8Array);
        }
    }
    /**
     * Create TypedArray views for the current ArrayBuffer.
     */
    _refreshViews() {
        throw new Error('_refreshViews() must be implemented by each concrete StructArray layout');
    }
}
/**
 * Given a list of member fields, create a full StructArrayLayout, in
 * particular calculating the correct byte offset for each field.  This data
 * is used at build time to generate StructArrayLayout_*#emplaceBack() and
 * other accessors, and at runtime for binding vertex buffer attributes.
 */
function createLayout(members, alignment = 1) {
    let offset = 0;
    let maxSize = 0;
    const layoutMembers = members.map((member) => {
        const typeSize = sizeOf(member.type);
        const memberOffset = offset = align$1(offset, Math.max(alignment, typeSize));
        const components = member.components || 1;
        maxSize = Math.max(maxSize, typeSize);
        offset += typeSize * components;
        return {
            name: member.name,
            type: member.type,
            components,
            offset: memberOffset,
        };
    });
    const size = align$1(offset, Math.max(maxSize, alignment));
    return {
        members: layoutMembers,
        size,
        alignment
    };
}
function sizeOf(type) {
    return viewTypes[type].BYTES_PER_ELEMENT;
}
function align$1(offset, size) {
    return Math.ceil(offset / size) * size;
}

// This file is generated. Edit build/generate-struct-arrays.ts, then run `npm run codegen`.
/**
 * @internal
 * Implementation of the StructArray layout:
 * [0] - Int16[2]
 *
 */
class StructArrayLayout2i4 extends StructArray {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer);
        this.int16 = new Int16Array(this.arrayBuffer);
    }
    emplaceBack(v0, v1) {
        const i = this.length;
        this.resize(i + 1);
        return this.emplace(i, v0, v1);
    }
    emplace(i, v0, v1) {
        const o2 = i * 2;
        this.int16[o2 + 0] = v0;
        this.int16[o2 + 1] = v1;
        return i;
    }
}
StructArrayLayout2i4.prototype.bytesPerElement = 4;
register('StructArrayLayout2i4', StructArrayLayout2i4);
/**
 * @internal
 * Implementation of the StructArray layout:
 * [0] - Int16[3]
 *
 */
class StructArrayLayout3i6 extends StructArray {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer);
        this.int16 = new Int16Array(this.arrayBuffer);
    }
    emplaceBack(v0, v1, v2) {
        const i = this.length;
        this.resize(i + 1);
        return this.emplace(i, v0, v1, v2);
    }
    emplace(i, v0, v1, v2) {
        const o2 = i * 3;
        this.int16[o2 + 0] = v0;
        this.int16[o2 + 1] = v1;
        this.int16[o2 + 2] = v2;
        return i;
    }
}
StructArrayLayout3i6.prototype.bytesPerElement = 6;
register('StructArrayLayout3i6', StructArrayLayout3i6);
/**
 * @internal
 * Implementation of the StructArray layout:
 * [0] - Int16[4]
 *
 */
class StructArrayLayout4i8 extends StructArray {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer);
        this.int16 = new Int16Array(this.arrayBuffer);
    }
    emplaceBack(v0, v1, v2, v3) {
        const i = this.length;
        this.resize(i + 1);
        return this.emplace(i, v0, v1, v2, v3);
    }
    emplace(i, v0, v1, v2, v3) {
        const o2 = i * 4;
        this.int16[o2 + 0] = v0;
        this.int16[o2 + 1] = v1;
        this.int16[o2 + 2] = v2;
        this.int16[o2 + 3] = v3;
        return i;
    }
}
StructArrayLayout4i8.prototype.bytesPerElement = 8;
register('StructArrayLayout4i8', StructArrayLayout4i8);
/**
 * @internal
 * Implementation of the StructArray layout:
 * [0] - Int16[2]
 * [4] - Int16[4]
 *
 */
class StructArrayLayout2i4i12 extends StructArray {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer);
        this.int16 = new Int16Array(this.arrayBuffer);
    }
    emplaceBack(v0, v1, v2, v3, v4, v5) {
        const i = this.length;
        this.resize(i + 1);
        return this.emplace(i, v0, v1, v2, v3, v4, v5);
    }
    emplace(i, v0, v1, v2, v3, v4, v5) {
        const o2 = i * 6;
        this.int16[o2 + 0] = v0;
        this.int16[o2 + 1] = v1;
        this.int16[o2 + 2] = v2;
        this.int16[o2 + 3] = v3;
        this.int16[o2 + 4] = v4;
        this.int16[o2 + 5] = v5;
        return i;
    }
}
StructArrayLayout2i4i12.prototype.bytesPerElement = 12;
register('StructArrayLayout2i4i12', StructArrayLayout2i4i12);
/**
 * @internal
 * Implementation of the StructArray layout:
 * [0] - Int16[2]
 * [4] - Uint8[4]
 *
 */
class StructArrayLayout2i4ub8 extends StructArray {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer);
        this.int16 = new Int16Array(this.arrayBuffer);
    }
    emplaceBack(v0, v1, v2, v3, v4, v5) {
        const i = this.length;
        this.resize(i + 1);
        return this.emplace(i, v0, v1, v2, v3, v4, v5);
    }
    emplace(i, v0, v1, v2, v3, v4, v5) {
        const o2 = i * 4;
        const o1 = i * 8;
        this.int16[o2 + 0] = v0;
        this.int16[o2 + 1] = v1;
        this.uint8[o1 + 4] = v2;
        this.uint8[o1 + 5] = v3;
        this.uint8[o1 + 6] = v4;
        this.uint8[o1 + 7] = v5;
        return i;
    }
}
StructArrayLayout2i4ub8.prototype.bytesPerElement = 8;
register('StructArrayLayout2i4ub8', StructArrayLayout2i4ub8);
/**
 * @internal
 * Implementation of the StructArray layout:
 * [0] - Float32[2]
 *
 */
class StructArrayLayout2f8 extends StructArray {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer);
        this.float32 = new Float32Array(this.arrayBuffer);
    }
    emplaceBack(v0, v1) {
        const i = this.length;
        this.resize(i + 1);
        return this.emplace(i, v0, v1);
    }
    emplace(i, v0, v1) {
        const o4 = i * 2;
        this.float32[o4 + 0] = v0;
        this.float32[o4 + 1] = v1;
        return i;
    }
}
StructArrayLayout2f8.prototype.bytesPerElement = 8;
register('StructArrayLayout2f8', StructArrayLayout2f8);
/**
 * @internal
 * Implementation of the StructArray layout:
 * [0] - Uint16[10]
 *
 */
class StructArrayLayout10ui20 extends StructArray {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer);
        this.uint16 = new Uint16Array(this.arrayBuffer);
    }
    emplaceBack(v0, v1, v2, v3, v4, v5, v6, v7, v8, v9) {
        const i = this.length;
        this.resize(i + 1);
        return this.emplace(i, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9);
    }
    emplace(i, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9) {
        const o2 = i * 10;
        this.uint16[o2 + 0] = v0;
        this.uint16[o2 + 1] = v1;
        this.uint16[o2 + 2] = v2;
        this.uint16[o2 + 3] = v3;
        this.uint16[o2 + 4] = v4;
        this.uint16[o2 + 5] = v5;
        this.uint16[o2 + 6] = v6;
        this.uint16[o2 + 7] = v7;
        this.uint16[o2 + 8] = v8;
        this.uint16[o2 + 9] = v9;
        return i;
    }
}
StructArrayLayout10ui20.prototype.bytesPerElement = 20;
register('StructArrayLayout10ui20', StructArrayLayout10ui20);
/**
 * @internal
 * Implementation of the StructArray layout:
 * [0] - Int16[4]
 * [8] - Uint16[4]
 * [16] - Int16[4]
 *
 */
class StructArrayLayout4i4ui4i24 extends StructArray {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer);
        this.int16 = new Int16Array(this.arrayBuffer);
        this.uint16 = new Uint16Array(this.arrayBuffer);
    }
    emplaceBack(v0, v1, v2, v3, v4, v5, v6, v7, v8, v9, v10, v11) {
        const i = this.length;
        this.resize(i + 1);
        return this.emplace(i, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9, v10, v11);
    }
    emplace(i, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9, v10, v11) {
        const o2 = i * 12;
        this.int16[o2 + 0] = v0;
        this.int16[o2 + 1] = v1;
        this.int16[o2 + 2] = v2;
        this.int16[o2 + 3] = v3;
        this.uint16[o2 + 4] = v4;
        this.uint16[o2 + 5] = v5;
        this.uint16[o2 + 6] = v6;
        this.uint16[o2 + 7] = v7;
        this.int16[o2 + 8] = v8;
        this.int16[o2 + 9] = v9;
        this.int16[o2 + 10] = v10;
        this.int16[o2 + 11] = v11;
        return i;
    }
}
StructArrayLayout4i4ui4i24.prototype.bytesPerElement = 24;
register('StructArrayLayout4i4ui4i24', StructArrayLayout4i4ui4i24);
/**
 * @internal
 * Implementation of the StructArray layout:
 * [0] - Float32[3]
 *
 */
class StructArrayLayout3f12 extends StructArray {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer);
        this.float32 = new Float32Array(this.arrayBuffer);
    }
    emplaceBack(v0, v1, v2) {
        const i = this.length;
        this.resize(i + 1);
        return this.emplace(i, v0, v1, v2);
    }
    emplace(i, v0, v1, v2) {
        const o4 = i * 3;
        this.float32[o4 + 0] = v0;
        this.float32[o4 + 1] = v1;
        this.float32[o4 + 2] = v2;
        return i;
    }
}
StructArrayLayout3f12.prototype.bytesPerElement = 12;
register('StructArrayLayout3f12', StructArrayLayout3f12);
/**
 * @internal
 * Implementation of the StructArray layout:
 * [0] - Uint32[1]
 *
 */
class StructArrayLayout1ul4 extends StructArray {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer);
        this.uint32 = new Uint32Array(this.arrayBuffer);
    }
    emplaceBack(v0) {
        const i = this.length;
        this.resize(i + 1);
        return this.emplace(i, v0);
    }
    emplace(i, v0) {
        const o4 = i * 1;
        this.uint32[o4 + 0] = v0;
        return i;
    }
}
StructArrayLayout1ul4.prototype.bytesPerElement = 4;
register('StructArrayLayout1ul4', StructArrayLayout1ul4);
/**
 * @internal
 * Implementation of the StructArray layout:
 * [0] - Int16[6]
 * [12] - Uint32[1]
 * [16] - Uint16[2]
 *
 */
class StructArrayLayout6i1ul2ui20 extends StructArray {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer);
        this.int16 = new Int16Array(this.arrayBuffer);
        this.uint32 = new Uint32Array(this.arrayBuffer);
        this.uint16 = new Uint16Array(this.arrayBuffer);
    }
    emplaceBack(v0, v1, v2, v3, v4, v5, v6, v7, v8) {
        const i = this.length;
        this.resize(i + 1);
        return this.emplace(i, v0, v1, v2, v3, v4, v5, v6, v7, v8);
    }
    emplace(i, v0, v1, v2, v3, v4, v5, v6, v7, v8) {
        const o2 = i * 10;
        const o4 = i * 5;
        this.int16[o2 + 0] = v0;
        this.int16[o2 + 1] = v1;
        this.int16[o2 + 2] = v2;
        this.int16[o2 + 3] = v3;
        this.int16[o2 + 4] = v4;
        this.int16[o2 + 5] = v5;
        this.uint32[o4 + 3] = v6;
        this.uint16[o2 + 8] = v7;
        this.uint16[o2 + 9] = v8;
        return i;
    }
}
StructArrayLayout6i1ul2ui20.prototype.bytesPerElement = 20;
register('StructArrayLayout6i1ul2ui20', StructArrayLayout6i1ul2ui20);
/**
 * @internal
 * Implementation of the StructArray layout:
 * [0] - Int16[2]
 * [4] - Int16[2]
 * [8] - Int16[2]
 *
 */
class StructArrayLayout2i2i2i12 extends StructArray {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer);
        this.int16 = new Int16Array(this.arrayBuffer);
    }
    emplaceBack(v0, v1, v2, v3, v4, v5) {
        const i = this.length;
        this.resize(i + 1);
        return this.emplace(i, v0, v1, v2, v3, v4, v5);
    }
    emplace(i, v0, v1, v2, v3, v4, v5) {
        const o2 = i * 6;
        this.int16[o2 + 0] = v0;
        this.int16[o2 + 1] = v1;
        this.int16[o2 + 2] = v2;
        this.int16[o2 + 3] = v3;
        this.int16[o2 + 4] = v4;
        this.int16[o2 + 5] = v5;
        return i;
    }
}
StructArrayLayout2i2i2i12.prototype.bytesPerElement = 12;
register('StructArrayLayout2i2i2i12', StructArrayLayout2i2i2i12);
/**
 * @internal
 * Implementation of the StructArray layout:
 * [0] - Float32[2]
 * [8] - Float32[1]
 * [12] - Int16[2]
 *
 */
class StructArrayLayout2f1f2i16 extends StructArray {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer);
        this.float32 = new Float32Array(this.arrayBuffer);
        this.int16 = new Int16Array(this.arrayBuffer);
    }
    emplaceBack(v0, v1, v2, v3, v4) {
        const i = this.length;
        this.resize(i + 1);
        return this.emplace(i, v0, v1, v2, v3, v4);
    }
    emplace(i, v0, v1, v2, v3, v4) {
        const o4 = i * 4;
        const o2 = i * 8;
        this.float32[o4 + 0] = v0;
        this.float32[o4 + 1] = v1;
        this.float32[o4 + 2] = v2;
        this.int16[o2 + 6] = v3;
        this.int16[o2 + 7] = v4;
        return i;
    }
}
StructArrayLayout2f1f2i16.prototype.bytesPerElement = 16;
register('StructArrayLayout2f1f2i16', StructArrayLayout2f1f2i16);
/**
 * @internal
 * Implementation of the StructArray layout:
 * [0] - Uint8[2]
 * [4] - Float32[2]
 * [12] - Int16[2]
 *
 */
class StructArrayLayout2ub2f2i16 extends StructArray {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer);
        this.float32 = new Float32Array(this.arrayBuffer);
        this.int16 = new Int16Array(this.arrayBuffer);
    }
    emplaceBack(v0, v1, v2, v3, v4, v5) {
        const i = this.length;
        this.resize(i + 1);
        return this.emplace(i, v0, v1, v2, v3, v4, v5);
    }
    emplace(i, v0, v1, v2, v3, v4, v5) {
        const o1 = i * 16;
        const o4 = i * 4;
        const o2 = i * 8;
        this.uint8[o1 + 0] = v0;
        this.uint8[o1 + 1] = v1;
        this.float32[o4 + 1] = v2;
        this.float32[o4 + 2] = v3;
        this.int16[o2 + 6] = v4;
        this.int16[o2 + 7] = v5;
        return i;
    }
}
StructArrayLayout2ub2f2i16.prototype.bytesPerElement = 16;
register('StructArrayLayout2ub2f2i16', StructArrayLayout2ub2f2i16);
/**
 * @internal
 * Implementation of the StructArray layout:
 * [0] - Uint16[3]
 *
 */
class StructArrayLayout3ui6 extends StructArray {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer);
        this.uint16 = new Uint16Array(this.arrayBuffer);
    }
    emplaceBack(v0, v1, v2) {
        const i = this.length;
        this.resize(i + 1);
        return this.emplace(i, v0, v1, v2);
    }
    emplace(i, v0, v1, v2) {
        const o2 = i * 3;
        this.uint16[o2 + 0] = v0;
        this.uint16[o2 + 1] = v1;
        this.uint16[o2 + 2] = v2;
        return i;
    }
}
StructArrayLayout3ui6.prototype.bytesPerElement = 6;
register('StructArrayLayout3ui6', StructArrayLayout3ui6);
/**
 * @internal
 * Implementation of the StructArray layout:
 * [0] - Int16[2]
 * [4] - Uint16[2]
 * [8] - Uint32[3]
 * [20] - Uint16[3]
 * [28] - Float32[2]
 * [36] - Uint8[3]
 * [40] - Uint32[1]
 * [44] - Int16[1]
 *
 */
class StructArrayLayout2i2ui3ul3ui2f3ub1ul1i48 extends StructArray {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer);
        this.int16 = new Int16Array(this.arrayBuffer);
        this.uint16 = new Uint16Array(this.arrayBuffer);
        this.uint32 = new Uint32Array(this.arrayBuffer);
        this.float32 = new Float32Array(this.arrayBuffer);
    }
    emplaceBack(v0, v1, v2, v3, v4, v5, v6, v7, v8, v9, v10, v11, v12, v13, v14, v15, v16) {
        const i = this.length;
        this.resize(i + 1);
        return this.emplace(i, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9, v10, v11, v12, v13, v14, v15, v16);
    }
    emplace(i, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9, v10, v11, v12, v13, v14, v15, v16) {
        const o2 = i * 24;
        const o4 = i * 12;
        const o1 = i * 48;
        this.int16[o2 + 0] = v0;
        this.int16[o2 + 1] = v1;
        this.uint16[o2 + 2] = v2;
        this.uint16[o2 + 3] = v3;
        this.uint32[o4 + 2] = v4;
        this.uint32[o4 + 3] = v5;
        this.uint32[o4 + 4] = v6;
        this.uint16[o2 + 10] = v7;
        this.uint16[o2 + 11] = v8;
        this.uint16[o2 + 12] = v9;
        this.float32[o4 + 7] = v10;
        this.float32[o4 + 8] = v11;
        this.uint8[o1 + 36] = v12;
        this.uint8[o1 + 37] = v13;
        this.uint8[o1 + 38] = v14;
        this.uint32[o4 + 10] = v15;
        this.int16[o2 + 22] = v16;
        return i;
    }
}
StructArrayLayout2i2ui3ul3ui2f3ub1ul1i48.prototype.bytesPerElement = 48;
register('StructArrayLayout2i2ui3ul3ui2f3ub1ul1i48', StructArrayLayout2i2ui3ul3ui2f3ub1ul1i48);
/**
 * @internal
 * Implementation of the StructArray layout:
 * [0] - Int16[8]
 * [16] - Uint16[15]
 * [48] - Uint32[1]
 * [52] - Float32[2]
 * [60] - Uint16[2]
 *
 */
class StructArrayLayout8i15ui1ul2f2ui64 extends StructArray {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer);
        this.int16 = new Int16Array(this.arrayBuffer);
        this.uint16 = new Uint16Array(this.arrayBuffer);
        this.uint32 = new Uint32Array(this.arrayBuffer);
        this.float32 = new Float32Array(this.arrayBuffer);
    }
    emplaceBack(v0, v1, v2, v3, v4, v5, v6, v7, v8, v9, v10, v11, v12, v13, v14, v15, v16, v17, v18, v19, v20, v21, v22, v23, v24, v25, v26, v27) {
        const i = this.length;
        this.resize(i + 1);
        return this.emplace(i, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9, v10, v11, v12, v13, v14, v15, v16, v17, v18, v19, v20, v21, v22, v23, v24, v25, v26, v27);
    }
    emplace(i, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9, v10, v11, v12, v13, v14, v15, v16, v17, v18, v19, v20, v21, v22, v23, v24, v25, v26, v27) {
        const o2 = i * 32;
        const o4 = i * 16;
        this.int16[o2 + 0] = v0;
        this.int16[o2 + 1] = v1;
        this.int16[o2 + 2] = v2;
        this.int16[o2 + 3] = v3;
        this.int16[o2 + 4] = v4;
        this.int16[o2 + 5] = v5;
        this.int16[o2 + 6] = v6;
        this.int16[o2 + 7] = v7;
        this.uint16[o2 + 8] = v8;
        this.uint16[o2 + 9] = v9;
        this.uint16[o2 + 10] = v10;
        this.uint16[o2 + 11] = v11;
        this.uint16[o2 + 12] = v12;
        this.uint16[o2 + 13] = v13;
        this.uint16[o2 + 14] = v14;
        this.uint16[o2 + 15] = v15;
        this.uint16[o2 + 16] = v16;
        this.uint16[o2 + 17] = v17;
        this.uint16[o2 + 18] = v18;
        this.uint16[o2 + 19] = v19;
        this.uint16[o2 + 20] = v20;
        this.uint16[o2 + 21] = v21;
        this.uint16[o2 + 22] = v22;
        this.uint32[o4 + 12] = v23;
        this.float32[o4 + 13] = v24;
        this.float32[o4 + 14] = v25;
        this.uint16[o2 + 30] = v26;
        this.uint16[o2 + 31] = v27;
        return i;
    }
}
StructArrayLayout8i15ui1ul2f2ui64.prototype.bytesPerElement = 64;
register('StructArrayLayout8i15ui1ul2f2ui64', StructArrayLayout8i15ui1ul2f2ui64);
/**
 * @internal
 * Implementation of the StructArray layout:
 * [0] - Float32[1]
 *
 */
class StructArrayLayout1f4 extends StructArray {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer);
        this.float32 = new Float32Array(this.arrayBuffer);
    }
    emplaceBack(v0) {
        const i = this.length;
        this.resize(i + 1);
        return this.emplace(i, v0);
    }
    emplace(i, v0) {
        const o4 = i * 1;
        this.float32[o4 + 0] = v0;
        return i;
    }
}
StructArrayLayout1f4.prototype.bytesPerElement = 4;
register('StructArrayLayout1f4', StructArrayLayout1f4);
/**
 * @internal
 * Implementation of the StructArray layout:
 * [0] - Uint16[1]
 * [4] - Float32[2]
 *
 */
class StructArrayLayout1ui2f12 extends StructArray {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer);
        this.uint16 = new Uint16Array(this.arrayBuffer);
        this.float32 = new Float32Array(this.arrayBuffer);
    }
    emplaceBack(v0, v1, v2) {
        const i = this.length;
        this.resize(i + 1);
        return this.emplace(i, v0, v1, v2);
    }
    emplace(i, v0, v1, v2) {
        const o2 = i * 6;
        const o4 = i * 3;
        this.uint16[o2 + 0] = v0;
        this.float32[o4 + 1] = v1;
        this.float32[o4 + 2] = v2;
        return i;
    }
}
StructArrayLayout1ui2f12.prototype.bytesPerElement = 12;
register('StructArrayLayout1ui2f12', StructArrayLayout1ui2f12);
/**
 * @internal
 * Implementation of the StructArray layout:
 * [0] - Uint32[1]
 * [4] - Uint16[2]
 *
 */
class StructArrayLayout1ul2ui8 extends StructArray {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer);
        this.uint32 = new Uint32Array(this.arrayBuffer);
        this.uint16 = new Uint16Array(this.arrayBuffer);
    }
    emplaceBack(v0, v1, v2) {
        const i = this.length;
        this.resize(i + 1);
        return this.emplace(i, v0, v1, v2);
    }
    emplace(i, v0, v1, v2) {
        const o4 = i * 2;
        const o2 = i * 4;
        this.uint32[o4 + 0] = v0;
        this.uint16[o2 + 2] = v1;
        this.uint16[o2 + 3] = v2;
        return i;
    }
}
StructArrayLayout1ul2ui8.prototype.bytesPerElement = 8;
register('StructArrayLayout1ul2ui8', StructArrayLayout1ul2ui8);
/**
 * @internal
 * Implementation of the StructArray layout:
 * [0] - Uint16[2]
 *
 */
class StructArrayLayout2ui4 extends StructArray {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer);
        this.uint16 = new Uint16Array(this.arrayBuffer);
    }
    emplaceBack(v0, v1) {
        const i = this.length;
        this.resize(i + 1);
        return this.emplace(i, v0, v1);
    }
    emplace(i, v0, v1) {
        const o2 = i * 2;
        this.uint16[o2 + 0] = v0;
        this.uint16[o2 + 1] = v1;
        return i;
    }
}
StructArrayLayout2ui4.prototype.bytesPerElement = 4;
register('StructArrayLayout2ui4', StructArrayLayout2ui4);
/**
 * @internal
 * Implementation of the StructArray layout:
 * [0] - Uint16[1]
 *
 */
class StructArrayLayout1ui2 extends StructArray {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer);
        this.uint16 = new Uint16Array(this.arrayBuffer);
    }
    emplaceBack(v0) {
        const i = this.length;
        this.resize(i + 1);
        return this.emplace(i, v0);
    }
    emplace(i, v0) {
        const o2 = i * 1;
        this.uint16[o2 + 0] = v0;
        return i;
    }
}
StructArrayLayout1ui2.prototype.bytesPerElement = 2;
register('StructArrayLayout1ui2', StructArrayLayout1ui2);
/**
 * @internal
 * Implementation of the StructArray layout:
 * [0] - Float32[4]
 *
 */
class StructArrayLayout4f16 extends StructArray {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer);
        this.float32 = new Float32Array(this.arrayBuffer);
    }
    emplaceBack(v0, v1, v2, v3) {
        const i = this.length;
        this.resize(i + 1);
        return this.emplace(i, v0, v1, v2, v3);
    }
    emplace(i, v0, v1, v2, v3) {
        const o4 = i * 4;
        this.float32[o4 + 0] = v0;
        this.float32[o4 + 1] = v1;
        this.float32[o4 + 2] = v2;
        this.float32[o4 + 3] = v3;
        return i;
    }
}
StructArrayLayout4f16.prototype.bytesPerElement = 16;
register('StructArrayLayout4f16', StructArrayLayout4f16);
/** @internal */
class CollisionBoxStruct extends Struct {
    get anchorPointX() { return this._structArray.int16[this._pos2 + 0]; }
    get anchorPointY() { return this._structArray.int16[this._pos2 + 1]; }
    get x1() { return this._structArray.int16[this._pos2 + 2]; }
    get y1() { return this._structArray.int16[this._pos2 + 3]; }
    get x2() { return this._structArray.int16[this._pos2 + 4]; }
    get y2() { return this._structArray.int16[this._pos2 + 5]; }
    get featureIndex() { return this._structArray.uint32[this._pos4 + 3]; }
    get sourceLayerIndex() { return this._structArray.uint16[this._pos2 + 8]; }
    get bucketIndex() { return this._structArray.uint16[this._pos2 + 9]; }
    get anchorPoint() { return new Point$2(this.anchorPointX, this.anchorPointY); }
}
CollisionBoxStruct.prototype.size = 20;
/** @internal */
class CollisionBoxArray extends StructArrayLayout6i1ul2ui20 {
    /**
     * Return the CollisionBoxStruct at the given location in the array.
     * @param index The index of the element.
     */
    get(index) {
        return new CollisionBoxStruct(this, index);
    }
}
register('CollisionBoxArray', CollisionBoxArray);
/** @internal */
class PlacedSymbolStruct extends Struct {
    get anchorX() { return this._structArray.int16[this._pos2 + 0]; }
    get anchorY() { return this._structArray.int16[this._pos2 + 1]; }
    get glyphStartIndex() { return this._structArray.uint16[this._pos2 + 2]; }
    get numGlyphs() { return this._structArray.uint16[this._pos2 + 3]; }
    get vertexStartIndex() { return this._structArray.uint32[this._pos4 + 2]; }
    get lineStartIndex() { return this._structArray.uint32[this._pos4 + 3]; }
    get lineLength() { return this._structArray.uint32[this._pos4 + 4]; }
    get segment() { return this._structArray.uint16[this._pos2 + 10]; }
    get lowerSize() { return this._structArray.uint16[this._pos2 + 11]; }
    get upperSize() { return this._structArray.uint16[this._pos2 + 12]; }
    get lineOffsetX() { return this._structArray.float32[this._pos4 + 7]; }
    get lineOffsetY() { return this._structArray.float32[this._pos4 + 8]; }
    get writingMode() { return this._structArray.uint8[this._pos1 + 36]; }
    get placedOrientation() { return this._structArray.uint8[this._pos1 + 37]; }
    set placedOrientation(x) { this._structArray.uint8[this._pos1 + 37] = x; }
    get hidden() { return this._structArray.uint8[this._pos1 + 38]; }
    set hidden(x) { this._structArray.uint8[this._pos1 + 38] = x; }
    get crossTileID() { return this._structArray.uint32[this._pos4 + 10]; }
    set crossTileID(x) { this._structArray.uint32[this._pos4 + 10] = x; }
    get associatedIconIndex() { return this._structArray.int16[this._pos2 + 22]; }
}
PlacedSymbolStruct.prototype.size = 48;
/** @internal */
class PlacedSymbolArray extends StructArrayLayout2i2ui3ul3ui2f3ub1ul1i48 {
    /**
     * Return the PlacedSymbolStruct at the given location in the array.
     * @param index The index of the element.
     */
    get(index) {
        return new PlacedSymbolStruct(this, index);
    }
}
register('PlacedSymbolArray', PlacedSymbolArray);
/** @internal */
class SymbolInstanceStruct extends Struct {
    get anchorX() { return this._structArray.int16[this._pos2 + 0]; }
    get anchorY() { return this._structArray.int16[this._pos2 + 1]; }
    get rightJustifiedTextSymbolIndex() { return this._structArray.int16[this._pos2 + 2]; }
    get centerJustifiedTextSymbolIndex() { return this._structArray.int16[this._pos2 + 3]; }
    get leftJustifiedTextSymbolIndex() { return this._structArray.int16[this._pos2 + 4]; }
    get verticalPlacedTextSymbolIndex() { return this._structArray.int16[this._pos2 + 5]; }
    get placedIconSymbolIndex() { return this._structArray.int16[this._pos2 + 6]; }
    get verticalPlacedIconSymbolIndex() { return this._structArray.int16[this._pos2 + 7]; }
    get key() { return this._structArray.uint16[this._pos2 + 8]; }
    get textBoxStartIndex() { return this._structArray.uint16[this._pos2 + 9]; }
    get textBoxEndIndex() { return this._structArray.uint16[this._pos2 + 10]; }
    get verticalTextBoxStartIndex() { return this._structArray.uint16[this._pos2 + 11]; }
    get verticalTextBoxEndIndex() { return this._structArray.uint16[this._pos2 + 12]; }
    get iconBoxStartIndex() { return this._structArray.uint16[this._pos2 + 13]; }
    get iconBoxEndIndex() { return this._structArray.uint16[this._pos2 + 14]; }
    get verticalIconBoxStartIndex() { return this._structArray.uint16[this._pos2 + 15]; }
    get verticalIconBoxEndIndex() { return this._structArray.uint16[this._pos2 + 16]; }
    get featureIndex() { return this._structArray.uint16[this._pos2 + 17]; }
    get numHorizontalGlyphVertices() { return this._structArray.uint16[this._pos2 + 18]; }
    get numVerticalGlyphVertices() { return this._structArray.uint16[this._pos2 + 19]; }
    get numIconVertices() { return this._structArray.uint16[this._pos2 + 20]; }
    get numVerticalIconVertices() { return this._structArray.uint16[this._pos2 + 21]; }
    get useRuntimeCollisionCircles() { return this._structArray.uint16[this._pos2 + 22]; }
    get crossTileID() { return this._structArray.uint32[this._pos4 + 12]; }
    set crossTileID(x) { this._structArray.uint32[this._pos4 + 12] = x; }
    get textBoxScale() { return this._structArray.float32[this._pos4 + 13]; }
    get collisionCircleDiameter() { return this._structArray.float32[this._pos4 + 14]; }
    get textAnchorOffsetStartIndex() { return this._structArray.uint16[this._pos2 + 30]; }
    get textAnchorOffsetEndIndex() { return this._structArray.uint16[this._pos2 + 31]; }
}
SymbolInstanceStruct.prototype.size = 64;
/** @internal */
class SymbolInstanceArray extends StructArrayLayout8i15ui1ul2f2ui64 {
    /**
     * Return the SymbolInstanceStruct at the given location in the array.
     * @param index The index of the element.
     */
    get(index) {
        return new SymbolInstanceStruct(this, index);
    }
}
register('SymbolInstanceArray', SymbolInstanceArray);
/** @internal */
class GlyphOffsetArray extends StructArrayLayout1f4 {
    getoffsetX(index) { return this.float32[index * 1 + 0]; }
}
register('GlyphOffsetArray', GlyphOffsetArray);
/** @internal */
class SymbolLineVertexArray extends StructArrayLayout3i6 {
    getx(index) { return this.int16[index * 3 + 0]; }
    gety(index) { return this.int16[index * 3 + 1]; }
    gettileUnitDistanceFromAnchor(index) { return this.int16[index * 3 + 2]; }
}
register('SymbolLineVertexArray', SymbolLineVertexArray);
/** @internal */
class TextAnchorOffsetStruct extends Struct {
    get textAnchor() { return this._structArray.uint16[this._pos2 + 0]; }
    get textOffset0() { return this._structArray.float32[this._pos4 + 1]; }
    get textOffset1() { return this._structArray.float32[this._pos4 + 2]; }
}
TextAnchorOffsetStruct.prototype.size = 12;
/** @internal */
class TextAnchorOffsetArray extends StructArrayLayout1ui2f12 {
    /**
     * Return the TextAnchorOffsetStruct at the given location in the array.
     * @param index The index of the element.
     */
    get(index) {
        return new TextAnchorOffsetStruct(this, index);
    }
}
register('TextAnchorOffsetArray', TextAnchorOffsetArray);
/** @internal */
class FeatureIndexStruct extends Struct {
    get featureIndex() { return this._structArray.uint32[this._pos4 + 0]; }
    get sourceLayerIndex() { return this._structArray.uint16[this._pos2 + 2]; }
    get bucketIndex() { return this._structArray.uint16[this._pos2 + 3]; }
}
FeatureIndexStruct.prototype.size = 8;
/** @internal */
class FeatureIndexArray extends StructArrayLayout1ul2ui8 {
    /**
     * Return the FeatureIndexStruct at the given location in the array.
     * @param index The index of the element.
     */
    get(index) {
        return new FeatureIndexStruct(this, index);
    }
}
register('FeatureIndexArray', FeatureIndexArray);
class PosArray extends StructArrayLayout2i4 {
}
class Pos3dArray extends StructArrayLayout3i6 {
}
class RasterBoundsArray extends StructArrayLayout4i8 {
}
class CircleLayoutArray extends StructArrayLayout2i4 {
}
class FillLayoutArray extends StructArrayLayout2i4 {
}
class FillExtrusionLayoutArray extends StructArrayLayout2i4i12 {
}
class LineLayoutArray extends StructArrayLayout2i4ub8 {
}
class LineExtLayoutArray extends StructArrayLayout2f8 {
}
class PatternLayoutArray extends StructArrayLayout10ui20 {
}
class SymbolLayoutArray extends StructArrayLayout4i4ui4i24 {
}
class SymbolDynamicLayoutArray extends StructArrayLayout3f12 {
}
class SymbolOpacityArray extends StructArrayLayout1ul4 {
}
class CollisionBoxLayoutArray extends StructArrayLayout2i2i2i12 {
}
class CollisionCircleLayoutArray extends StructArrayLayout2f1f2i16 {
}
class CollisionVertexArray extends StructArrayLayout2ub2f2i16 {
}
class QuadTriangleArray extends StructArrayLayout3ui6 {
}
class TriangleIndexArray extends StructArrayLayout3ui6 {
}
class LineIndexArray extends StructArrayLayout2ui4 {
}
class LineStripIndexArray extends StructArrayLayout1ui2 {
}

const layout$6 = createLayout([
    { name: 'a_pos', components: 2, type: 'Int16' }
], 4);
const { members: members$4, size: size$4, alignment: alignment$4 } = layout$6;

/**
 * @internal
 * Used for calculations on vector segments
 */
class SegmentVector {
    constructor(segments = []) {
        this.segments = segments;
    }
    prepareSegment(numVertices, layoutVertexArray, indexArray, sortKey) {
        let segment = this.segments[this.segments.length - 1];
        if (numVertices > SegmentVector.MAX_VERTEX_ARRAY_LENGTH)
            warnOnce(`Max vertices per segment is ${SegmentVector.MAX_VERTEX_ARRAY_LENGTH}: bucket requested ${numVertices}`);
        if (!segment || segment.vertexLength + numVertices > SegmentVector.MAX_VERTEX_ARRAY_LENGTH || segment.sortKey !== sortKey) {
            segment = {
                vertexOffset: layoutVertexArray.length,
                primitiveOffset: indexArray.length,
                vertexLength: 0,
                primitiveLength: 0
            };
            if (sortKey !== undefined)
                segment.sortKey = sortKey;
            this.segments.push(segment);
        }
        return segment;
    }
    get() {
        return this.segments;
    }
    destroy() {
        for (const segment of this.segments) {
            for (const k in segment.vaos) {
                segment.vaos[k].destroy();
            }
        }
    }
    static simpleSegment(vertexOffset, primitiveOffset, vertexLength, primitiveLength) {
        return new SegmentVector([{
                vertexOffset,
                primitiveOffset,
                vertexLength,
                primitiveLength,
                vaos: {},
                sortKey: 0
            }]);
    }
}
/**
 * The maximum size of a vertex array. This limit is imposed by WebGL's 16 bit
 * addressing of vertex buffers.
 */
SegmentVector.MAX_VERTEX_ARRAY_LENGTH = Math.pow(2, 16) - 1;
register('SegmentVector', SegmentVector);

/**
 * Packs two numbers, interpreted as 8-bit unsigned integers, into a single
 * float.  Unpack them in the shader using the `unpack_float()` function,
 * defined in _prelude.vertex.glsl
 */
function packUint8ToFloat(a, b) {
    // coerce a and b to 8-bit ints
    a = clamp$1(Math.floor(a), 0, 255);
    b = clamp$1(Math.floor(b), 0, 255);
    return 256 * a + b;
}

const patternAttributes = createLayout([
    // [tl.x, tl.y, br.x, br.y]
    { name: 'a_pattern_from', components: 4, type: 'Uint16' },
    { name: 'a_pattern_to', components: 4, type: 'Uint16' },
    { name: 'a_pixel_ratio_from', components: 1, type: 'Uint16' },
    { name: 'a_pixel_ratio_to', components: 1, type: 'Uint16' },
]);

var murmurhashJs = {exports: {}};

var murmurhash3_gc = {exports: {}};

/**
 * JS Implementation of MurmurHash3 (r136) (as of May 20, 2011)
 * 
 * @author <a href="mailto:gary.court@gmail.com">Gary Court</a>
 * @see http://github.com/garycourt/murmurhash-js
 * @author <a href="mailto:aappleby@gmail.com">Austin Appleby</a>
 * @see http://sites.google.com/site/murmurhash/
 * 
 * @param {string} key ASCII only
 * @param {number} seed Positive integer only
 * @return {number} 32-bit positive integer hash 
 */

(function (module) {
	function murmurhash3_32_gc(key, seed) {
		var remainder, bytes, h1, h1b, c1, c2, k1, i;
		
		remainder = key.length & 3; // key.length % 4
		bytes = key.length - remainder;
		h1 = seed;
		c1 = 0xcc9e2d51;
		c2 = 0x1b873593;
		i = 0;
		
		while (i < bytes) {
		  	k1 = 
		  	  ((key.charCodeAt(i) & 0xff)) |
		  	  ((key.charCodeAt(++i) & 0xff) << 8) |
		  	  ((key.charCodeAt(++i) & 0xff) << 16) |
		  	  ((key.charCodeAt(++i) & 0xff) << 24);
			++i;
			
			k1 = ((((k1 & 0xffff) * c1) + ((((k1 >>> 16) * c1) & 0xffff) << 16))) & 0xffffffff;
			k1 = (k1 << 15) | (k1 >>> 17);
			k1 = ((((k1 & 0xffff) * c2) + ((((k1 >>> 16) * c2) & 0xffff) << 16))) & 0xffffffff;

			h1 ^= k1;
	        h1 = (h1 << 13) | (h1 >>> 19);
			h1b = ((((h1 & 0xffff) * 5) + ((((h1 >>> 16) * 5) & 0xffff) << 16))) & 0xffffffff;
			h1 = (((h1b & 0xffff) + 0x6b64) + ((((h1b >>> 16) + 0xe654) & 0xffff) << 16));
		}
		
		k1 = 0;
		
		switch (remainder) {
			case 3: k1 ^= (key.charCodeAt(i + 2) & 0xff) << 16;
			case 2: k1 ^= (key.charCodeAt(i + 1) & 0xff) << 8;
			case 1: k1 ^= (key.charCodeAt(i) & 0xff);
			
			k1 = (((k1 & 0xffff) * c1) + ((((k1 >>> 16) * c1) & 0xffff) << 16)) & 0xffffffff;
			k1 = (k1 << 15) | (k1 >>> 17);
			k1 = (((k1 & 0xffff) * c2) + ((((k1 >>> 16) * c2) & 0xffff) << 16)) & 0xffffffff;
			h1 ^= k1;
		}
		
		h1 ^= key.length;

		h1 ^= h1 >>> 16;
		h1 = (((h1 & 0xffff) * 0x85ebca6b) + ((((h1 >>> 16) * 0x85ebca6b) & 0xffff) << 16)) & 0xffffffff;
		h1 ^= h1 >>> 13;
		h1 = ((((h1 & 0xffff) * 0xc2b2ae35) + ((((h1 >>> 16) * 0xc2b2ae35) & 0xffff) << 16))) & 0xffffffff;
		h1 ^= h1 >>> 16;

		return h1 >>> 0;
	}

	{
	  module.exports = murmurhash3_32_gc;
	} 
} (murmurhash3_gc));

var murmurhash3_gcExports = murmurhash3_gc.exports;

var murmurhash2_gc = {exports: {}};

/**
 * JS Implementation of MurmurHash2
 * 
 * @author <a href="mailto:gary.court@gmail.com">Gary Court</a>
 * @see http://github.com/garycourt/murmurhash-js
 * @author <a href="mailto:aappleby@gmail.com">Austin Appleby</a>
 * @see http://sites.google.com/site/murmurhash/
 * 
 * @param {string} str ASCII only
 * @param {number} seed Positive integer only
 * @return {number} 32-bit positive integer hash
 */

(function (module) {
	function murmurhash2_32_gc(str, seed) {
	  var
	    l = str.length,
	    h = seed ^ l,
	    i = 0,
	    k;
	  
	  while (l >= 4) {
	  	k = 
	  	  ((str.charCodeAt(i) & 0xff)) |
	  	  ((str.charCodeAt(++i) & 0xff) << 8) |
	  	  ((str.charCodeAt(++i) & 0xff) << 16) |
	  	  ((str.charCodeAt(++i) & 0xff) << 24);
	    
	    k = (((k & 0xffff) * 0x5bd1e995) + ((((k >>> 16) * 0x5bd1e995) & 0xffff) << 16));
	    k ^= k >>> 24;
	    k = (((k & 0xffff) * 0x5bd1e995) + ((((k >>> 16) * 0x5bd1e995) & 0xffff) << 16));

		h = (((h & 0xffff) * 0x5bd1e995) + ((((h >>> 16) * 0x5bd1e995) & 0xffff) << 16)) ^ k;

	    l -= 4;
	    ++i;
	  }
	  
	  switch (l) {
	  case 3: h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
	  case 2: h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
	  case 1: h ^= (str.charCodeAt(i) & 0xff);
	          h = (((h & 0xffff) * 0x5bd1e995) + ((((h >>> 16) * 0x5bd1e995) & 0xffff) << 16));
	  }

	  h ^= h >>> 13;
	  h = (((h & 0xffff) * 0x5bd1e995) + ((((h >>> 16) * 0x5bd1e995) & 0xffff) << 16));
	  h ^= h >>> 15;

	  return h >>> 0;
	}

	{
	  module.exports = murmurhash2_32_gc;
	} 
} (murmurhash2_gc));

var murmurhash2_gcExports = murmurhash2_gc.exports;

var murmur3 = murmurhash3_gcExports;
var murmur2 = murmurhash2_gcExports;

murmurhashJs.exports = murmur3;
murmurhashJs.exports.murmur3 = murmur3;
murmurhashJs.exports.murmur2 = murmur2;

var murmurhashJsExports = murmurhashJs.exports;
var murmur3$1 = /*@__PURE__*/getDefaultExportFromCjs$1(murmurhashJsExports);

// A transferable data structure that maps feature ids to their indices and buffer offsets
class FeaturePositionMap {
    constructor() {
        this.ids = [];
        this.positions = [];
        this.indexed = false;
    }
    add(id, index, start, end) {
        this.ids.push(getNumericId(id));
        this.positions.push(index, start, end);
    }
    getPositions(id) {
        if (!this.indexed)
            throw new Error('Trying to get index, but feature positions are not indexed');
        const intId = getNumericId(id);
        // binary search for the first occurrence of id in this.ids;
        // relies on ids/positions being sorted by id, which happens in serialization
        let i = 0;
        let j = this.ids.length - 1;
        while (i < j) {
            const m = (i + j) >> 1;
            if (this.ids[m] >= intId) {
                j = m;
            }
            else {
                i = m + 1;
            }
        }
        const positions = [];
        while (this.ids[i] === intId) {
            const index = this.positions[3 * i];
            const start = this.positions[3 * i + 1];
            const end = this.positions[3 * i + 2];
            positions.push({ index, start, end });
            i++;
        }
        return positions;
    }
    static serialize(map, transferables) {
        const ids = new Float64Array(map.ids);
        const positions = new Uint32Array(map.positions);
        sort$1(ids, positions, 0, ids.length - 1);
        if (transferables) {
            transferables.push(ids.buffer, positions.buffer);
        }
        return { ids, positions };
    }
    static deserialize(obj) {
        const map = new FeaturePositionMap();
        // after transferring, we only use these arrays statically (no pushes),
        // so TypedArray vs Array distinction that flow points out doesn't matter
        map.ids = obj.ids;
        map.positions = obj.positions;
        map.indexed = true;
        return map;
    }
}
function getNumericId(value) {
    const numValue = +value;
    if (!isNaN(numValue) && numValue <= Number.MAX_SAFE_INTEGER) {
        return numValue;
    }
    return murmur3$1(String(value));
}
// custom quicksort that sorts ids, indices and offsets together (by ids)
// uses Hoare partitioning & manual tail call optimization to avoid worst case scenarios
function sort$1(ids, positions, left, right) {
    while (left < right) {
        const pivot = ids[(left + right) >> 1];
        let i = left - 1;
        let j = right + 1;
        while (true) {
            do
                i++;
            while (ids[i] < pivot);
            do
                j--;
            while (ids[j] > pivot);
            if (i >= j)
                break;
            swap$1(ids, i, j);
            swap$1(positions, 3 * i, 3 * j);
            swap$1(positions, 3 * i + 1, 3 * j + 1);
            swap$1(positions, 3 * i + 2, 3 * j + 2);
        }
        if (j - left < right - j) {
            sort$1(ids, positions, left, j);
            left = j + 1;
        }
        else {
            sort$1(ids, positions, j + 1, right);
            right = j;
        }
    }
}
function swap$1(arr, i, j) {
    const tmp = arr[i];
    arr[i] = arr[j];
    arr[j] = tmp;
}
register('FeaturePositionMap', FeaturePositionMap);

/**
 * @internal
 * A base uniform abstract class
 */
class Uniform {
    constructor(context, location) {
        this.gl = context.gl;
        this.location = location;
    }
}
class Uniform1i extends Uniform {
    constructor(context, location) {
        super(context, location);
        this.current = 0;
    }
    set(v) {
        if (this.current !== v) {
            this.current = v;
            this.gl.uniform1i(this.location, v);
        }
    }
}
class Uniform1f extends Uniform {
    constructor(context, location) {
        super(context, location);
        this.current = 0;
    }
    set(v) {
        if (this.current !== v) {
            this.current = v;
            this.gl.uniform1f(this.location, v);
        }
    }
}
class Uniform2f extends Uniform {
    constructor(context, location) {
        super(context, location);
        this.current = [0, 0];
    }
    set(v) {
        if (v[0] !== this.current[0] || v[1] !== this.current[1]) {
            this.current = v;
            this.gl.uniform2f(this.location, v[0], v[1]);
        }
    }
}
class Uniform3f extends Uniform {
    constructor(context, location) {
        super(context, location);
        this.current = [0, 0, 0];
    }
    set(v) {
        if (v[0] !== this.current[0] || v[1] !== this.current[1] || v[2] !== this.current[2]) {
            this.current = v;
            this.gl.uniform3f(this.location, v[0], v[1], v[2]);
        }
    }
}
class Uniform4f extends Uniform {
    constructor(context, location) {
        super(context, location);
        this.current = [0, 0, 0, 0];
    }
    set(v) {
        if (v[0] !== this.current[0] || v[1] !== this.current[1] ||
            v[2] !== this.current[2] || v[3] !== this.current[3]) {
            this.current = v;
            this.gl.uniform4f(this.location, v[0], v[1], v[2], v[3]);
        }
    }
}
class UniformColor extends Uniform {
    constructor(context, location) {
        super(context, location);
        this.current = Color.transparent;
    }
    set(v) {
        if (v.r !== this.current.r || v.g !== this.current.g ||
            v.b !== this.current.b || v.a !== this.current.a) {
            this.current = v;
            this.gl.uniform4f(this.location, v.r, v.g, v.b, v.a);
        }
    }
}
const emptyMat4 = new Float32Array(16);
class UniformMatrix4f extends Uniform {
    constructor(context, location) {
        super(context, location);
        this.current = emptyMat4;
    }
    set(v) {
        // The vast majority of matrix comparisons that will trip this set
        // happen at i=12 or i=0, so we check those first to avoid lots of
        // unnecessary iteration:
        if (v[12] !== this.current[12] || v[0] !== this.current[0]) {
            this.current = v;
            this.gl.uniformMatrix4fv(this.location, false, v);
            return;
        }
        for (let i = 1; i < 16; i++) {
            if (v[i] !== this.current[i]) {
                this.current = v;
                this.gl.uniformMatrix4fv(this.location, false, v);
                break;
            }
        }
    }
}

function packColor(color) {
    return [
        packUint8ToFloat(255 * color.r, 255 * color.g),
        packUint8ToFloat(255 * color.b, 255 * color.a)
    ];
}
class ConstantBinder {
    constructor(value, names, type) {
        this.value = value;
        this.uniformNames = names.map(name => `u_${name}`);
        this.type = type;
    }
    setUniform(uniform, globals, currentValue) {
        uniform.set(currentValue.constantOr(this.value));
    }
    getBinding(context, location, _) {
        return (this.type === 'color') ?
            new UniformColor(context, location) :
            new Uniform1f(context, location);
    }
}
class CrossFadedConstantBinder {
    constructor(value, names) {
        this.uniformNames = names.map(name => `u_${name}`);
        this.patternFrom = null;
        this.patternTo = null;
        this.pixelRatioFrom = 1.0;
        this.pixelRatioTo = 1.0;
    }
    setConstantPatternPositions(posTo, posFrom) {
        this.pixelRatioFrom = posFrom.pixelRatio;
        this.pixelRatioTo = posTo.pixelRatio;
        this.patternFrom = posFrom.tlbr;
        this.patternTo = posTo.tlbr;
    }
    setUniform(uniform, globals, currentValue, uniformName) {
        const pos = uniformName === 'u_pattern_to' ? this.patternTo :
            uniformName === 'u_pattern_from' ? this.patternFrom :
                uniformName === 'u_pixel_ratio_to' ? this.pixelRatioTo :
                    uniformName === 'u_pixel_ratio_from' ? this.pixelRatioFrom : null;
        if (pos)
            uniform.set(pos);
    }
    getBinding(context, location, name) {
        return name.substr(0, 9) === 'u_pattern' ?
            new Uniform4f(context, location) :
            new Uniform1f(context, location);
    }
}
class SourceExpressionBinder {
    constructor(expression, names, type, PaintVertexArray) {
        this.expression = expression;
        this.type = type;
        this.maxValue = 0;
        this.paintVertexAttributes = names.map((name) => ({
            name: `a_${name}`,
            type: 'Float32',
            components: type === 'color' ? 2 : 1,
            offset: 0
        }));
        this.paintVertexArray = new PaintVertexArray();
    }
    populatePaintArray(newLength, feature, imagePositions, canonical, formattedSection) {
        const start = this.paintVertexArray.length;
        const value = this.expression.evaluate(new EvaluationParameters(0), feature, {}, canonical, [], formattedSection);
        this.paintVertexArray.resize(newLength);
        this._setPaintValue(start, newLength, value);
    }
    updatePaintArray(start, end, feature, featureState) {
        const value = this.expression.evaluate({ zoom: 0 }, feature, featureState);
        this._setPaintValue(start, end, value);
    }
    _setPaintValue(start, end, value) {
        if (this.type === 'color') {
            const color = packColor(value);
            for (let i = start; i < end; i++) {
                this.paintVertexArray.emplace(i, color[0], color[1]);
            }
        }
        else {
            for (let i = start; i < end; i++) {
                this.paintVertexArray.emplace(i, value);
            }
            this.maxValue = Math.max(this.maxValue, Math.abs(value));
        }
    }
    upload(context) {
        if (this.paintVertexArray && this.paintVertexArray.arrayBuffer) {
            if (this.paintVertexBuffer && this.paintVertexBuffer.buffer) {
                this.paintVertexBuffer.updateData(this.paintVertexArray);
            }
            else {
                this.paintVertexBuffer = context.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent);
            }
        }
    }
    destroy() {
        if (this.paintVertexBuffer) {
            this.paintVertexBuffer.destroy();
        }
    }
}
class CompositeExpressionBinder {
    constructor(expression, names, type, useIntegerZoom, zoom, PaintVertexArray) {
        this.expression = expression;
        this.uniformNames = names.map(name => `u_${name}_t`);
        this.type = type;
        this.useIntegerZoom = useIntegerZoom;
        this.zoom = zoom;
        this.maxValue = 0;
        this.paintVertexAttributes = names.map((name) => ({
            name: `a_${name}`,
            type: 'Float32',
            components: type === 'color' ? 4 : 2,
            offset: 0
        }));
        this.paintVertexArray = new PaintVertexArray();
    }
    populatePaintArray(newLength, feature, imagePositions, canonical, formattedSection) {
        const min = this.expression.evaluate(new EvaluationParameters(this.zoom), feature, {}, canonical, [], formattedSection);
        const max = this.expression.evaluate(new EvaluationParameters(this.zoom + 1), feature, {}, canonical, [], formattedSection);
        const start = this.paintVertexArray.length;
        this.paintVertexArray.resize(newLength);
        this._setPaintValue(start, newLength, min, max);
    }
    updatePaintArray(start, end, feature, featureState) {
        const min = this.expression.evaluate({ zoom: this.zoom }, feature, featureState);
        const max = this.expression.evaluate({ zoom: this.zoom + 1 }, feature, featureState);
        this._setPaintValue(start, end, min, max);
    }
    _setPaintValue(start, end, min, max) {
        if (this.type === 'color') {
            const minColor = packColor(min);
            const maxColor = packColor(max);
            for (let i = start; i < end; i++) {
                this.paintVertexArray.emplace(i, minColor[0], minColor[1], maxColor[0], maxColor[1]);
            }
        }
        else {
            for (let i = start; i < end; i++) {
                this.paintVertexArray.emplace(i, min, max);
            }
            this.maxValue = Math.max(this.maxValue, Math.abs(min), Math.abs(max));
        }
    }
    upload(context) {
        if (this.paintVertexArray && this.paintVertexArray.arrayBuffer) {
            if (this.paintVertexBuffer && this.paintVertexBuffer.buffer) {
                this.paintVertexBuffer.updateData(this.paintVertexArray);
            }
            else {
                this.paintVertexBuffer = context.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent);
            }
        }
    }
    destroy() {
        if (this.paintVertexBuffer) {
            this.paintVertexBuffer.destroy();
        }
    }
    setUniform(uniform, globals) {
        const currentZoom = this.useIntegerZoom ? Math.floor(globals.zoom) : globals.zoom;
        const factor = clamp$1(this.expression.interpolationFactor(currentZoom, this.zoom, this.zoom + 1), 0, 1);
        uniform.set(factor);
    }
    getBinding(context, location, _) {
        return new Uniform1f(context, location);
    }
}
class CrossFadedCompositeBinder {
    constructor(expression, type, useIntegerZoom, zoom, PaintVertexArray, layerId) {
        this.expression = expression;
        this.type = type;
        this.useIntegerZoom = useIntegerZoom;
        this.zoom = zoom;
        this.layerId = layerId;
        this.zoomInPaintVertexArray = new PaintVertexArray();
        this.zoomOutPaintVertexArray = new PaintVertexArray();
    }
    populatePaintArray(length, feature, imagePositions) {
        const start = this.zoomInPaintVertexArray.length;
        this.zoomInPaintVertexArray.resize(length);
        this.zoomOutPaintVertexArray.resize(length);
        this._setPaintValues(start, length, feature.patterns && feature.patterns[this.layerId], imagePositions);
    }
    updatePaintArray(start, end, feature, featureState, imagePositions) {
        this._setPaintValues(start, end, feature.patterns && feature.patterns[this.layerId], imagePositions);
    }
    _setPaintValues(start, end, patterns, positions) {
        if (!positions || !patterns)
            return;
        const { min, mid, max } = patterns;
        const imageMin = positions[min];
        const imageMid = positions[mid];
        const imageMax = positions[max];
        if (!imageMin || !imageMid || !imageMax)
            return;
        // We populate two paint arrays because, for cross-faded properties, we don't know which direction
        // we're cross-fading to at layout time. In order to keep vertex attributes to a minimum and not pass
        // unnecessary vertex data to the shaders, we determine which to upload at draw time.
        for (let i = start; i < end; i++) {
            this.zoomInPaintVertexArray.emplace(i, imageMid.tl[0], imageMid.tl[1], imageMid.br[0], imageMid.br[1], imageMin.tl[0], imageMin.tl[1], imageMin.br[0], imageMin.br[1], imageMid.pixelRatio, imageMin.pixelRatio);
            this.zoomOutPaintVertexArray.emplace(i, imageMid.tl[0], imageMid.tl[1], imageMid.br[0], imageMid.br[1], imageMax.tl[0], imageMax.tl[1], imageMax.br[0], imageMax.br[1], imageMid.pixelRatio, imageMax.pixelRatio);
        }
    }
    upload(context) {
        if (this.zoomInPaintVertexArray && this.zoomInPaintVertexArray.arrayBuffer && this.zoomOutPaintVertexArray && this.zoomOutPaintVertexArray.arrayBuffer) {
            this.zoomInPaintVertexBuffer = context.createVertexBuffer(this.zoomInPaintVertexArray, patternAttributes.members, this.expression.isStateDependent);
            this.zoomOutPaintVertexBuffer = context.createVertexBuffer(this.zoomOutPaintVertexArray, patternAttributes.members, this.expression.isStateDependent);
        }
    }
    destroy() {
        if (this.zoomOutPaintVertexBuffer)
            this.zoomOutPaintVertexBuffer.destroy();
        if (this.zoomInPaintVertexBuffer)
            this.zoomInPaintVertexBuffer.destroy();
    }
}
/**
 * @internal
 * ProgramConfiguration contains the logic for binding style layer properties and tile
 * layer feature data into GL program uniforms and vertex attributes.
 *
 * Non-data-driven property values are bound to shader uniforms. Data-driven property
 * values are bound to vertex attributes. In order to support a uniform GLSL syntax over
 * both, [Mapbox GL Shaders](https://github.com/mapbox/mapbox-gl-shaders) defines a `#pragma`
 * abstraction, which ProgramConfiguration is responsible for implementing. At runtime,
 * it examines the attributes of a particular layer, combines this with fixed knowledge
 * about how layers of the particular type are implemented, and determines which uniforms
 * and vertex attributes will be required. It can then substitute the appropriate text
 * into the shader source code, create and link a program, and bind the uniforms and
 * vertex attributes in preparation for drawing.
 *
 * When a vector tile is parsed, this same configuration information is used to
 * populate the attribute buffers needed for data-driven styling using the zoom
 * level and feature property data.
 */
class ProgramConfiguration {
    constructor(layer, zoom, filterProperties) {
        this.binders = {};
        this._buffers = [];
        const keys = [];
        for (const property in layer.paint._values) {
            if (!filterProperties(property))
                continue;
            const value = layer.paint.get(property);
            if (!(value instanceof PossiblyEvaluatedPropertyValue) || !supportsPropertyExpression(value.property.specification)) {
                continue;
            }
            const names = paintAttributeNames(property, layer.type);
            const expression = value.value;
            const type = value.property.specification.type;
            const useIntegerZoom = value.property.useIntegerZoom;
            const propType = value.property.specification['property-type'];
            const isCrossFaded = propType === 'cross-faded' || propType === 'cross-faded-data-driven';
            if (expression.kind === 'constant') {
                this.binders[property] = isCrossFaded ?
                    new CrossFadedConstantBinder(expression.value, names) :
                    new ConstantBinder(expression.value, names, type);
                keys.push(`/u_${property}`);
            }
            else if (expression.kind === 'source' || isCrossFaded) {
                const StructArrayLayout = layoutType(property, type, 'source');
                this.binders[property] = isCrossFaded ?
                    new CrossFadedCompositeBinder(expression, type, useIntegerZoom, zoom, StructArrayLayout, layer.id) :
                    new SourceExpressionBinder(expression, names, type, StructArrayLayout);
                keys.push(`/a_${property}`);
            }
            else {
                const StructArrayLayout = layoutType(property, type, 'composite');
                this.binders[property] = new CompositeExpressionBinder(expression, names, type, useIntegerZoom, zoom, StructArrayLayout);
                keys.push(`/z_${property}`);
            }
        }
        this.cacheKey = keys.sort().join('');
    }
    getMaxValue(property) {
        const binder = this.binders[property];
        return binder instanceof SourceExpressionBinder || binder instanceof CompositeExpressionBinder ? binder.maxValue : 0;
    }
    populatePaintArrays(newLength, feature, imagePositions, canonical, formattedSection) {
        for (const property in this.binders) {
            const binder = this.binders[property];
            if (binder instanceof SourceExpressionBinder || binder instanceof CompositeExpressionBinder || binder instanceof CrossFadedCompositeBinder)
                binder.populatePaintArray(newLength, feature, imagePositions, canonical, formattedSection);
        }
    }
    setConstantPatternPositions(posTo, posFrom) {
        for (const property in this.binders) {
            const binder = this.binders[property];
            if (binder instanceof CrossFadedConstantBinder)
                binder.setConstantPatternPositions(posTo, posFrom);
        }
    }
    updatePaintArrays(featureStates, featureMap, vtLayer, layer, imagePositions) {
        let dirty = false;
        for (const id in featureStates) {
            const positions = featureMap.getPositions(id);
            for (const pos of positions) {
                const feature = vtLayer.feature(pos.index);
                for (const property in this.binders) {
                    const binder = this.binders[property];
                    if ((binder instanceof SourceExpressionBinder || binder instanceof CompositeExpressionBinder ||
                        binder instanceof CrossFadedCompositeBinder) && binder.expression.isStateDependent === true) {
                        //AHM: Remove after https://github.com/mapbox/mapbox-gl-js/issues/6255
                        const value = layer.paint.get(property);
                        binder.expression = value.value;
                        binder.updatePaintArray(pos.start, pos.end, feature, featureStates[id], imagePositions);
                        dirty = true;
                    }
                }
            }
        }
        return dirty;
    }
    defines() {
        const result = [];
        for (const property in this.binders) {
            const binder = this.binders[property];
            if (binder instanceof ConstantBinder || binder instanceof CrossFadedConstantBinder) {
                result.push(...binder.uniformNames.map(name => `#define HAS_UNIFORM_${name}`));
            }
        }
        return result;
    }
    getBinderAttributes() {
        const result = [];
        for (const property in this.binders) {
            const binder = this.binders[property];
            if (binder instanceof SourceExpressionBinder || binder instanceof CompositeExpressionBinder) {
                for (let i = 0; i < binder.paintVertexAttributes.length; i++) {
                    result.push(binder.paintVertexAttributes[i].name);
                }
            }
            else if (binder instanceof CrossFadedCompositeBinder) {
                for (let i = 0; i < patternAttributes.members.length; i++) {
                    result.push(patternAttributes.members[i].name);
                }
            }
        }
        return result;
    }
    getBinderUniforms() {
        const uniforms = [];
        for (const property in this.binders) {
            const binder = this.binders[property];
            if (binder instanceof ConstantBinder || binder instanceof CrossFadedConstantBinder || binder instanceof CompositeExpressionBinder) {
                for (const uniformName of binder.uniformNames) {
                    uniforms.push(uniformName);
                }
            }
        }
        return uniforms;
    }
    getPaintVertexBuffers() {
        return this._buffers;
    }
    getUniforms(context, locations) {
        const uniforms = [];
        for (const property in this.binders) {
            const binder = this.binders[property];
            if (binder instanceof ConstantBinder || binder instanceof CrossFadedConstantBinder || binder instanceof CompositeExpressionBinder) {
                for (const name of binder.uniformNames) {
                    if (locations[name]) {
                        const binding = binder.getBinding(context, locations[name], name);
                        uniforms.push({ name, property, binding });
                    }
                }
            }
        }
        return uniforms;
    }
    setUniforms(context, binderUniforms, properties, globals) {
        // Uniform state bindings are owned by the Program, but we set them
        // from within the ProgramConfiguration's binder members.
        for (const { name, property, binding } of binderUniforms) {
            this.binders[property].setUniform(binding, globals, properties.get(property), name);
        }
    }
    updatePaintBuffers(crossfade) {
        this._buffers = [];
        for (const property in this.binders) {
            const binder = this.binders[property];
            if (crossfade && binder instanceof CrossFadedCompositeBinder) {
                const patternVertexBuffer = crossfade.fromScale === 2 ? binder.zoomInPaintVertexBuffer : binder.zoomOutPaintVertexBuffer;
                if (patternVertexBuffer)
                    this._buffers.push(patternVertexBuffer);
            }
            else if ((binder instanceof SourceExpressionBinder || binder instanceof CompositeExpressionBinder) && binder.paintVertexBuffer) {
                this._buffers.push(binder.paintVertexBuffer);
            }
        }
    }
    upload(context) {
        for (const property in this.binders) {
            const binder = this.binders[property];
            if (binder instanceof SourceExpressionBinder || binder instanceof CompositeExpressionBinder || binder instanceof CrossFadedCompositeBinder)
                binder.upload(context);
        }
        this.updatePaintBuffers();
    }
    destroy() {
        for (const property in this.binders) {
            const binder = this.binders[property];
            if (binder instanceof SourceExpressionBinder || binder instanceof CompositeExpressionBinder || binder instanceof CrossFadedCompositeBinder)
                binder.destroy();
        }
    }
}
class ProgramConfigurationSet {
    constructor(layers, zoom, filterProperties = () => true) {
        this.programConfigurations = {};
        for (const layer of layers) {
            this.programConfigurations[layer.id] = new ProgramConfiguration(layer, zoom, filterProperties);
        }
        this.needsUpload = false;
        this._featureMap = new FeaturePositionMap();
        this._bufferOffset = 0;
    }
    populatePaintArrays(length, feature, index, imagePositions, canonical, formattedSection) {
        for (const key in this.programConfigurations) {
            this.programConfigurations[key].populatePaintArrays(length, feature, imagePositions, canonical, formattedSection);
        }
        if (feature.id !== undefined) {
            this._featureMap.add(feature.id, index, this._bufferOffset, length);
        }
        this._bufferOffset = length;
        this.needsUpload = true;
    }
    updatePaintArrays(featureStates, vtLayer, layers, imagePositions) {
        for (const layer of layers) {
            this.needsUpload = this.programConfigurations[layer.id].updatePaintArrays(featureStates, this._featureMap, vtLayer, layer, imagePositions) || this.needsUpload;
        }
    }
    get(layerId) {
        return this.programConfigurations[layerId];
    }
    upload(context) {
        if (!this.needsUpload)
            return;
        for (const layerId in this.programConfigurations) {
            this.programConfigurations[layerId].upload(context);
        }
        this.needsUpload = false;
    }
    destroy() {
        for (const layerId in this.programConfigurations) {
            this.programConfigurations[layerId].destroy();
        }
    }
}
function paintAttributeNames(property, type) {
    const attributeNameExceptions = {
        'text-opacity': ['opacity'],
        'icon-opacity': ['opacity'],
        'text-color': ['fill_color'],
        'icon-color': ['fill_color'],
        'text-halo-color': ['halo_color'],
        'icon-halo-color': ['halo_color'],
        'text-halo-blur': ['halo_blur'],
        'icon-halo-blur': ['halo_blur'],
        'text-halo-width': ['halo_width'],
        'icon-halo-width': ['halo_width'],
        'line-gap-width': ['gapwidth'],
        'line-pattern': ['pattern_to', 'pattern_from', 'pixel_ratio_to', 'pixel_ratio_from'],
        'fill-pattern': ['pattern_to', 'pattern_from', 'pixel_ratio_to', 'pixel_ratio_from'],
        'fill-extrusion-pattern': ['pattern_to', 'pattern_from', 'pixel_ratio_to', 'pixel_ratio_from'],
    };
    return attributeNameExceptions[property] || [property.replace(`${type}-`, '').replace(/-/g, '_')];
}
function getLayoutException(property) {
    const propertyExceptions = {
        'line-pattern': {
            'source': PatternLayoutArray,
            'composite': PatternLayoutArray
        },
        'fill-pattern': {
            'source': PatternLayoutArray,
            'composite': PatternLayoutArray
        },
        'fill-extrusion-pattern': {
            'source': PatternLayoutArray,
            'composite': PatternLayoutArray
        }
    };
    return propertyExceptions[property];
}
function layoutType(property, type, binderType) {
    const defaultLayouts = {
        'color': {
            'source': StructArrayLayout2f8,
            'composite': StructArrayLayout4f16
        },
        'number': {
            'source': StructArrayLayout1f4,
            'composite': StructArrayLayout2f8
        }
    };
    const layoutException = getLayoutException(property);
    return layoutException && layoutException[binderType] || defaultLayouts[type][binderType];
}
register('ConstantBinder', ConstantBinder);
register('CrossFadedConstantBinder', CrossFadedConstantBinder);
register('SourceExpressionBinder', SourceExpressionBinder);
register('CrossFadedCompositeBinder', CrossFadedCompositeBinder);
register('CompositeExpressionBinder', CompositeExpressionBinder);
register('ProgramConfiguration', ProgramConfiguration, { omit: ['_buffers'] });
register('ProgramConfigurationSet', ProgramConfigurationSet);

/**
 * The maximum value of a coordinate in the internal tile coordinate system. Coordinates of
 * all source features normalized to this extent upon load.
 *
 * The value is a consequence of the following:
 *
 * * Vertex buffer store positions as signed 16 bit integers.
 * * One bit is lost for signedness to support tile buffers.
 * * One bit is lost because the line vertex buffer used to pack 1 bit of other data into the int.
 * * One bit is lost to support features extending past the extent on the right edge of the tile.
 * * This leaves us with 2^13 = 8192
 */
const EXTENT = 8192;

// These bounds define the minimum and maximum supported coordinate values.
// While visible coordinates are within [0, EXTENT], tiles may theoretically
// contain coordinates within [-Infinity, Infinity]. Our range is limited by the
// number of bits used to represent the coordinate.
const BITS = 15;
const MAX = Math.pow(2, BITS - 1) - 1;
const MIN = -MAX - 1;
/**
 * Loads a geometry from a VectorTileFeature and scales it to the common extent
 * used internally.
 * @param feature - the vector tile feature to load
 */
function loadGeometry(feature) {
    const scale = EXTENT / feature.extent;
    const geometry = feature.loadGeometry();
    for (let r = 0; r < geometry.length; r++) {
        const ring = geometry[r];
        for (let p = 0; p < ring.length; p++) {
            const point = ring[p];
            // round here because mapbox-gl-native uses integers to represent
            // points and we need to do the same to avoid renering differences.
            const x = Math.round(point.x * scale);
            const y = Math.round(point.y * scale);
            point.x = clamp$1(x, MIN, MAX);
            point.y = clamp$1(y, MIN, MAX);
            if (x < point.x || x > point.x + 1 || y < point.y || y > point.y + 1) {
                // warn when exceeding allowed extent except for the 1-px-off case
                // https://github.com/mapbox/mapbox-gl-js/issues/8992
                warnOnce('Geometry exceeds allowed extent, reduce your vector tile buffer size');
            }
        }
    }
    return geometry;
}

/**
 * Construct a new feature based on a VectorTileFeature for expression evaluation, the geometry of which
 * will be loaded based on necessity.
 * @param feature - the feature to evaluate
 * @param needGeometry - if set to true this will load the geometry
 */
function toEvaluationFeature(feature, needGeometry) {
    return { type: feature.type,
        id: feature.id,
        properties: feature.properties,
        geometry: needGeometry ? loadGeometry(feature) : [] };
}

function addCircleVertex(layoutVertexArray, x, y, extrudeX, extrudeY) {
    layoutVertexArray.emplaceBack((x * 2) + ((extrudeX + 1) / 2), (y * 2) + ((extrudeY + 1) / 2));
}
/**
 * @internal
 * Circles are represented by two triangles.
 *
 * Each corner has a pos that is the center of the circle and an extrusion
 * vector that is where it points.
 */
class CircleBucket {
    constructor(options) {
        this.zoom = options.zoom;
        this.overscaling = options.overscaling;
        this.layers = options.layers;
        this.layerIds = this.layers.map(layer => layer.id);
        this.index = options.index;
        this.hasPattern = false;
        this.layoutVertexArray = new CircleLayoutArray();
        this.indexArray = new TriangleIndexArray();
        this.segments = new SegmentVector();
        this.programConfigurations = new ProgramConfigurationSet(options.layers, options.zoom);
        this.stateDependentLayerIds = this.layers.filter((l) => l.isStateDependent()).map((l) => l.id);
    }
    populate(features, options, canonical) {
        const styleLayer = this.layers[0];
        const bucketFeatures = [];
        let circleSortKey = null;
        let sortFeaturesByKey = false;
        // Heatmap layers are handled in this bucket and have no evaluated properties, so we check our access
        if (styleLayer.type === 'circle') {
            circleSortKey = styleLayer.layout.get('circle-sort-key');
            sortFeaturesByKey = !circleSortKey.isConstant();
        }
        for (const { feature, id, index, sourceLayerIndex } of features) {
            const needGeometry = this.layers[0]._featureFilter.needGeometry;
            const evaluationFeature = toEvaluationFeature(feature, needGeometry);
            if (!this.layers[0]._featureFilter.filter(new EvaluationParameters(this.zoom), evaluationFeature, canonical))
                continue;
            const sortKey = sortFeaturesByKey ?
                circleSortKey.evaluate(evaluationFeature, {}, canonical) :
                undefined;
            const bucketFeature = {
                id,
                properties: feature.properties,
                type: feature.type,
                sourceLayerIndex,
                index,
                geometry: needGeometry ? evaluationFeature.geometry : loadGeometry(feature),
                patterns: {},
                sortKey
            };
            bucketFeatures.push(bucketFeature);
        }
        if (sortFeaturesByKey) {
            bucketFeatures.sort((a, b) => a.sortKey - b.sortKey);
        }
        for (const bucketFeature of bucketFeatures) {
            const { geometry, index, sourceLayerIndex } = bucketFeature;
            const feature = features[index].feature;
            this.addFeature(bucketFeature, geometry, index, canonical);
            options.featureIndex.insert(feature, geometry, index, sourceLayerIndex, this.index);
        }
    }
    update(states, vtLayer, imagePositions) {
        if (!this.stateDependentLayers.length)
            return;
        this.programConfigurations.updatePaintArrays(states, vtLayer, this.stateDependentLayers, imagePositions);
    }
    isEmpty() {
        return this.layoutVertexArray.length === 0;
    }
    uploadPending() {
        return !this.uploaded || this.programConfigurations.needsUpload;
    }
    upload(context) {
        if (!this.uploaded) {
            this.layoutVertexBuffer = context.createVertexBuffer(this.layoutVertexArray, members$4);
            this.indexBuffer = context.createIndexBuffer(this.indexArray);
        }
        this.programConfigurations.upload(context);
        this.uploaded = true;
    }
    destroy() {
        if (!this.layoutVertexBuffer)
            return;
        this.layoutVertexBuffer.destroy();
        this.indexBuffer.destroy();
        this.programConfigurations.destroy();
        this.segments.destroy();
    }
    addFeature(feature, geometry, index, canonical) {
        for (const ring of geometry) {
            for (const point of ring) {
                const x = point.x;
                const y = point.y;
                // Do not include points that are outside the tile boundaries.
                if (x < 0 || x >= EXTENT || y < 0 || y >= EXTENT)
                    continue;
                // this geometry will be of the Point type, and we'll derive
                // two triangles from it.
                //
                // ┌─────────┐
                // │ 3     2 │
                // │         │
                // │ 0     1 │
                // └─────────┘
                const segment = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray, feature.sortKey);
                const index = segment.vertexLength;
                addCircleVertex(this.layoutVertexArray, x, y, -1, -1);
                addCircleVertex(this.layoutVertexArray, x, y, 1, -1);
                addCircleVertex(this.layoutVertexArray, x, y, 1, 1);
                addCircleVertex(this.layoutVertexArray, x, y, -1, 1);
                this.indexArray.emplaceBack(index, index + 1, index + 2);
                this.indexArray.emplaceBack(index, index + 3, index + 2);
                segment.vertexLength += 4;
                segment.primitiveLength += 2;
            }
        }
        this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, feature, index, {}, canonical);
    }
}
register('CircleBucket', CircleBucket, { omit: ['layers'] });

function polygonIntersectsPolygon(polygonA, polygonB) {
    for (let i = 0; i < polygonA.length; i++) {
        if (polygonContainsPoint(polygonB, polygonA[i]))
            return true;
    }
    for (let i = 0; i < polygonB.length; i++) {
        if (polygonContainsPoint(polygonA, polygonB[i]))
            return true;
    }
    if (lineIntersectsLine(polygonA, polygonB))
        return true;
    return false;
}
function polygonIntersectsBufferedPoint(polygon, point, radius) {
    if (polygonContainsPoint(polygon, point))
        return true;
    if (pointIntersectsBufferedLine(point, polygon, radius))
        return true;
    return false;
}
function polygonIntersectsMultiPolygon(polygon, multiPolygon) {
    if (polygon.length === 1) {
        return multiPolygonContainsPoint(multiPolygon, polygon[0]);
    }
    for (let m = 0; m < multiPolygon.length; m++) {
        const ring = multiPolygon[m];
        for (let n = 0; n < ring.length; n++) {
            if (polygonContainsPoint(polygon, ring[n]))
                return true;
        }
    }
    for (let i = 0; i < polygon.length; i++) {
        if (multiPolygonContainsPoint(multiPolygon, polygon[i]))
            return true;
    }
    for (let k = 0; k < multiPolygon.length; k++) {
        if (lineIntersectsLine(polygon, multiPolygon[k]))
            return true;
    }
    return false;
}
function polygonIntersectsBufferedMultiLine(polygon, multiLine, radius) {
    for (let i = 0; i < multiLine.length; i++) {
        const line = multiLine[i];
        if (polygon.length >= 3) {
            for (let k = 0; k < line.length; k++) {
                if (polygonContainsPoint(polygon, line[k]))
                    return true;
            }
        }
        if (lineIntersectsBufferedLine(polygon, line, radius))
            return true;
    }
    return false;
}
function lineIntersectsBufferedLine(lineA, lineB, radius) {
    if (lineA.length > 1) {
        if (lineIntersectsLine(lineA, lineB))
            return true;
        // Check whether any point in either line is within radius of the other line
        for (let j = 0; j < lineB.length; j++) {
            if (pointIntersectsBufferedLine(lineB[j], lineA, radius))
                return true;
        }
    }
    for (let k = 0; k < lineA.length; k++) {
        if (pointIntersectsBufferedLine(lineA[k], lineB, radius))
            return true;
    }
    return false;
}
function lineIntersectsLine(lineA, lineB) {
    if (lineA.length === 0 || lineB.length === 0)
        return false;
    for (let i = 0; i < lineA.length - 1; i++) {
        const a0 = lineA[i];
        const a1 = lineA[i + 1];
        for (let j = 0; j < lineB.length - 1; j++) {
            const b0 = lineB[j];
            const b1 = lineB[j + 1];
            if (lineSegmentIntersectsLineSegment(a0, a1, b0, b1))
                return true;
        }
    }
    return false;
}
function lineSegmentIntersectsLineSegment(a0, a1, b0, b1) {
    return isCounterClockwise(a0, b0, b1) !== isCounterClockwise(a1, b0, b1) &&
        isCounterClockwise(a0, a1, b0) !== isCounterClockwise(a0, a1, b1);
}
function pointIntersectsBufferedLine(p, line, radius) {
    const radiusSquared = radius * radius;
    if (line.length === 1)
        return p.distSqr(line[0]) < radiusSquared;
    for (let i = 1; i < line.length; i++) {
        // Find line segments that have a distance <= radius^2 to p
        // In that case, we treat the line as "containing point p".
        const v = line[i - 1], w = line[i];
        if (distToSegmentSquared(p, v, w) < radiusSquared)
            return true;
    }
    return false;
}
// Code from https://stackoverflow.com/a/1501725/331379.
function distToSegmentSquared(p, v, w) {
    const l2 = v.distSqr(w);
    if (l2 === 0)
        return p.distSqr(v);
    const t = ((p.x - v.x) * (w.x - v.x) + (p.y - v.y) * (w.y - v.y)) / l2;
    if (t < 0)
        return p.distSqr(v);
    if (t > 1)
        return p.distSqr(w);
    return p.distSqr(w.sub(v)._mult(t)._add(v));
}
// point in polygon ray casting algorithm
function multiPolygonContainsPoint(rings, p) {
    let c = false, ring, p1, p2;
    for (let k = 0; k < rings.length; k++) {
        ring = rings[k];
        for (let i = 0, j = ring.length - 1; i < ring.length; j = i++) {
            p1 = ring[i];
            p2 = ring[j];
            if (((p1.y > p.y) !== (p2.y > p.y)) && (p.x < (p2.x - p1.x) * (p.y - p1.y) / (p2.y - p1.y) + p1.x)) {
                c = !c;
            }
        }
    }
    return c;
}
function polygonContainsPoint(ring, p) {
    let c = false;
    for (let i = 0, j = ring.length - 1; i < ring.length; j = i++) {
        const p1 = ring[i];
        const p2 = ring[j];
        if (((p1.y > p.y) !== (p2.y > p.y)) && (p.x < (p2.x - p1.x) * (p.y - p1.y) / (p2.y - p1.y) + p1.x)) {
            c = !c;
        }
    }
    return c;
}
function polygonIntersectsBox(ring, boxX1, boxY1, boxX2, boxY2) {
    for (const p of ring) {
        if (boxX1 <= p.x &&
            boxY1 <= p.y &&
            boxX2 >= p.x &&
            boxY2 >= p.y)
            return true;
    }
    const corners = [
        new Point$2(boxX1, boxY1),
        new Point$2(boxX1, boxY2),
        new Point$2(boxX2, boxY2),
        new Point$2(boxX2, boxY1)
    ];
    if (ring.length > 2) {
        for (const corner of corners) {
            if (polygonContainsPoint(ring, corner))
                return true;
        }
    }
    for (let i = 0; i < ring.length - 1; i++) {
        const p1 = ring[i];
        const p2 = ring[i + 1];
        if (edgeIntersectsBox(p1, p2, corners))
            return true;
    }
    return false;
}
function edgeIntersectsBox(e1, e2, corners) {
    const tl = corners[0];
    const br = corners[2];
    // the edge and box do not intersect in either the x or y dimensions
    if (((e1.x < tl.x) && (e2.x < tl.x)) ||
        ((e1.x > br.x) && (e2.x > br.x)) ||
        ((e1.y < tl.y) && (e2.y < tl.y)) ||
        ((e1.y > br.y) && (e2.y > br.y)))
        return false;
    // check if all corners of the box are on the same side of the edge
    const dir = isCounterClockwise(e1, e2, corners[0]);
    return dir !== isCounterClockwise(e1, e2, corners[1]) ||
        dir !== isCounterClockwise(e1, e2, corners[2]) ||
        dir !== isCounterClockwise(e1, e2, corners[3]);
}

function getMaximumPaintValue(property, layer, bucket) {
    const value = layer.paint.get(property).value;
    if (value.kind === 'constant') {
        return value.value;
    }
    else {
        return bucket.programConfigurations.get(layer.id).getMaxValue(property);
    }
}
function translateDistance(translate) {
    return Math.sqrt(translate[0] * translate[0] + translate[1] * translate[1]);
}
function translate$1(queryGeometry, translate, translateAnchor, bearing, pixelsToTileUnits) {
    if (!translate[0] && !translate[1]) {
        return queryGeometry;
    }
    const pt = Point$2.convert(translate)._mult(pixelsToTileUnits);
    if (translateAnchor === 'viewport') {
        pt._rotate(-bearing);
    }
    const translated = [];
    for (let i = 0; i < queryGeometry.length; i++) {
        const point = queryGeometry[i];
        translated.push(point.sub(pt));
    }
    return translated;
}
function offsetLine(rings, offset) {
    const newRings = [];
    for (let ringIndex = 0; ringIndex < rings.length; ringIndex++) {
        const ring = rings[ringIndex];
        const newRing = [];
        for (let index = 0; index < ring.length; index++) {
            const a = ring[index - 1];
            const b = ring[index];
            const c = ring[index + 1];
            const aToB = index === 0 ? new Point$2(0, 0) : b.sub(a)._unit()._perp();
            const bToC = index === ring.length - 1 ? new Point$2(0, 0) : c.sub(b)._unit()._perp();
            const extrude = aToB._add(bToC)._unit();
            const cosHalfAngle = extrude.x * bToC.x + extrude.y * bToC.y;
            if (cosHalfAngle !== 0) {
                extrude._mult(1 / cosHalfAngle);
            }
            newRing.push(extrude._mult(offset)._add(b));
        }
        newRings.push(newRing);
    }
    return newRings;
}

// This file is generated. Edit build/generate-style-code.ts, then run 'npm run codegen'.
/* eslint-disable */
let layout$5;
const getLayout$3 = () => layout$5 = layout$5 || new Properties({
    "circle-sort-key": new DataDrivenProperty(v8Spec["layout_circle"]["circle-sort-key"]),
});
let paint$8;
const getPaint$8 = () => paint$8 = paint$8 || new Properties({
    "circle-radius": new DataDrivenProperty(v8Spec["paint_circle"]["circle-radius"]),
    "circle-color": new DataDrivenProperty(v8Spec["paint_circle"]["circle-color"]),
    "circle-blur": new DataDrivenProperty(v8Spec["paint_circle"]["circle-blur"]),
    "circle-opacity": new DataDrivenProperty(v8Spec["paint_circle"]["circle-opacity"]),
    "circle-translate": new DataConstantProperty(v8Spec["paint_circle"]["circle-translate"]),
    "circle-translate-anchor": new DataConstantProperty(v8Spec["paint_circle"]["circle-translate-anchor"]),
    "circle-pitch-scale": new DataConstantProperty(v8Spec["paint_circle"]["circle-pitch-scale"]),
    "circle-pitch-alignment": new DataConstantProperty(v8Spec["paint_circle"]["circle-pitch-alignment"]),
    "circle-stroke-width": new DataDrivenProperty(v8Spec["paint_circle"]["circle-stroke-width"]),
    "circle-stroke-color": new DataDrivenProperty(v8Spec["paint_circle"]["circle-stroke-color"]),
    "circle-stroke-opacity": new DataDrivenProperty(v8Spec["paint_circle"]["circle-stroke-opacity"]),
});
var properties$8 = ({ get paint() { return getPaint$8(); }, get layout() { return getLayout$3(); } });

/**
 * Common utilities
 * @module glMatrix
 */
// Configuration Constants
var EPSILON = 0.000001;
var ARRAY_TYPE = typeof Float32Array !== 'undefined' ? Float32Array : Array;
if (!Math.hypot) Math.hypot = function () {
  var y = 0,
      i = arguments.length;

  while (i--) {
    y += arguments[i] * arguments[i];
  }

  return Math.sqrt(y);
};

/**
 * 4x4 Matrix<br>Format: column-major, when typed out it looks like row-major<br>The matrices are being post multiplied.
 * @module mat4
 */

/**
 * Creates a new identity mat4
 *
 * @returns {mat4} a new 4x4 matrix
 */

function create$1() {
  var out = new ARRAY_TYPE(16);

  if (ARRAY_TYPE != Float32Array) {
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
  }

  out[0] = 1;
  out[5] = 1;
  out[10] = 1;
  out[15] = 1;
  return out;
}
/**
 * Creates a new mat4 initialized with values from an existing matrix
 *
 * @param {ReadonlyMat4} a matrix to clone
 * @returns {mat4} a new 4x4 matrix
 */

function clone(a) {
  var out = new ARRAY_TYPE(16);
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  out[3] = a[3];
  out[4] = a[4];
  out[5] = a[5];
  out[6] = a[6];
  out[7] = a[7];
  out[8] = a[8];
  out[9] = a[9];
  out[10] = a[10];
  out[11] = a[11];
  out[12] = a[12];
  out[13] = a[13];
  out[14] = a[14];
  out[15] = a[15];
  return out;
}
/**
 * Copy the values from one mat4 to another
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the source matrix
 * @returns {mat4} out
 */

function copy(out, a) {
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  out[3] = a[3];
  out[4] = a[4];
  out[5] = a[5];
  out[6] = a[6];
  out[7] = a[7];
  out[8] = a[8];
  out[9] = a[9];
  out[10] = a[10];
  out[11] = a[11];
  out[12] = a[12];
  out[13] = a[13];
  out[14] = a[14];
  out[15] = a[15];
  return out;
}
/**
 * Set a mat4 to the identity matrix
 *
 * @param {mat4} out the receiving matrix
 * @returns {mat4} out
 */

function identity(out) {
  out[0] = 1;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = 1;
  out[6] = 0;
  out[7] = 0;
  out[8] = 0;
  out[9] = 0;
  out[10] = 1;
  out[11] = 0;
  out[12] = 0;
  out[13] = 0;
  out[14] = 0;
  out[15] = 1;
  return out;
}
/**
 * Inverts a mat4
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the source matrix
 * @returns {mat4} out
 */

function invert(out, a) {
  var a00 = a[0],
      a01 = a[1],
      a02 = a[2],
      a03 = a[3];
  var a10 = a[4],
      a11 = a[5],
      a12 = a[6],
      a13 = a[7];
  var a20 = a[8],
      a21 = a[9],
      a22 = a[10],
      a23 = a[11];
  var a30 = a[12],
      a31 = a[13],
      a32 = a[14],
      a33 = a[15];
  var b00 = a00 * a11 - a01 * a10;
  var b01 = a00 * a12 - a02 * a10;
  var b02 = a00 * a13 - a03 * a10;
  var b03 = a01 * a12 - a02 * a11;
  var b04 = a01 * a13 - a03 * a11;
  var b05 = a02 * a13 - a03 * a12;
  var b06 = a20 * a31 - a21 * a30;
  var b07 = a20 * a32 - a22 * a30;
  var b08 = a20 * a33 - a23 * a30;
  var b09 = a21 * a32 - a22 * a31;
  var b10 = a21 * a33 - a23 * a31;
  var b11 = a22 * a33 - a23 * a32; // Calculate the determinant

  var det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;

  if (!det) {
    return null;
  }

  det = 1.0 / det;
  out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
  out[1] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
  out[2] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
  out[3] = (a22 * b04 - a21 * b05 - a23 * b03) * det;
  out[4] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
  out[5] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
  out[6] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
  out[7] = (a20 * b05 - a22 * b02 + a23 * b01) * det;
  out[8] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
  out[9] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
  out[10] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
  out[11] = (a21 * b02 - a20 * b04 - a23 * b00) * det;
  out[12] = (a11 * b07 - a10 * b09 - a12 * b06) * det;
  out[13] = (a00 * b09 - a01 * b07 + a02 * b06) * det;
  out[14] = (a31 * b01 - a30 * b03 - a32 * b00) * det;
  out[15] = (a20 * b03 - a21 * b01 + a22 * b00) * det;
  return out;
}
/**
 * Multiplies two mat4s
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the first operand
 * @param {ReadonlyMat4} b the second operand
 * @returns {mat4} out
 */

function multiply$1(out, a, b) {
  var a00 = a[0],
      a01 = a[1],
      a02 = a[2],
      a03 = a[3];
  var a10 = a[4],
      a11 = a[5],
      a12 = a[6],
      a13 = a[7];
  var a20 = a[8],
      a21 = a[9],
      a22 = a[10],
      a23 = a[11];
  var a30 = a[12],
      a31 = a[13],
      a32 = a[14],
      a33 = a[15]; // Cache only the current line of the second matrix

  var b0 = b[0],
      b1 = b[1],
      b2 = b[2],
      b3 = b[3];
  out[0] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
  out[1] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
  out[2] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
  out[3] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
  b0 = b[4];
  b1 = b[5];
  b2 = b[6];
  b3 = b[7];
  out[4] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
  out[5] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
  out[6] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
  out[7] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
  b0 = b[8];
  b1 = b[9];
  b2 = b[10];
  b3 = b[11];
  out[8] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
  out[9] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
  out[10] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
  out[11] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
  b0 = b[12];
  b1 = b[13];
  b2 = b[14];
  b3 = b[15];
  out[12] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
  out[13] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
  out[14] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
  out[15] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
  return out;
}
/**
 * Translate a mat4 by the given vector
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the matrix to translate
 * @param {ReadonlyVec3} v vector to translate by
 * @returns {mat4} out
 */

function translate(out, a, v) {
  var x = v[0],
      y = v[1],
      z = v[2];
  var a00, a01, a02, a03;
  var a10, a11, a12, a13;
  var a20, a21, a22, a23;

  if (a === out) {
    out[12] = a[0] * x + a[4] * y + a[8] * z + a[12];
    out[13] = a[1] * x + a[5] * y + a[9] * z + a[13];
    out[14] = a[2] * x + a[6] * y + a[10] * z + a[14];
    out[15] = a[3] * x + a[7] * y + a[11] * z + a[15];
  } else {
    a00 = a[0];
    a01 = a[1];
    a02 = a[2];
    a03 = a[3];
    a10 = a[4];
    a11 = a[5];
    a12 = a[6];
    a13 = a[7];
    a20 = a[8];
    a21 = a[9];
    a22 = a[10];
    a23 = a[11];
    out[0] = a00;
    out[1] = a01;
    out[2] = a02;
    out[3] = a03;
    out[4] = a10;
    out[5] = a11;
    out[6] = a12;
    out[7] = a13;
    out[8] = a20;
    out[9] = a21;
    out[10] = a22;
    out[11] = a23;
    out[12] = a00 * x + a10 * y + a20 * z + a[12];
    out[13] = a01 * x + a11 * y + a21 * z + a[13];
    out[14] = a02 * x + a12 * y + a22 * z + a[14];
    out[15] = a03 * x + a13 * y + a23 * z + a[15];
  }

  return out;
}
/**
 * Scales the mat4 by the dimensions in the given vec3 not using vectorization
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the matrix to scale
 * @param {ReadonlyVec3} v the vec3 to scale the matrix by
 * @returns {mat4} out
 **/

function scale(out, a, v) {
  var x = v[0],
      y = v[1],
      z = v[2];
  out[0] = a[0] * x;
  out[1] = a[1] * x;
  out[2] = a[2] * x;
  out[3] = a[3] * x;
  out[4] = a[4] * y;
  out[5] = a[5] * y;
  out[6] = a[6] * y;
  out[7] = a[7] * y;
  out[8] = a[8] * z;
  out[9] = a[9] * z;
  out[10] = a[10] * z;
  out[11] = a[11] * z;
  out[12] = a[12];
  out[13] = a[13];
  out[14] = a[14];
  out[15] = a[15];
  return out;
}
/**
 * Rotates a matrix by the given angle around the X axis
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */

function rotateX(out, a, rad) {
  var s = Math.sin(rad);
  var c = Math.cos(rad);
  var a10 = a[4];
  var a11 = a[5];
  var a12 = a[6];
  var a13 = a[7];
  var a20 = a[8];
  var a21 = a[9];
  var a22 = a[10];
  var a23 = a[11];

  if (a !== out) {
    // If the source and destination differ, copy the unchanged rows
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
  } // Perform axis-specific matrix multiplication


  out[4] = a10 * c + a20 * s;
  out[5] = a11 * c + a21 * s;
  out[6] = a12 * c + a22 * s;
  out[7] = a13 * c + a23 * s;
  out[8] = a20 * c - a10 * s;
  out[9] = a21 * c - a11 * s;
  out[10] = a22 * c - a12 * s;
  out[11] = a23 * c - a13 * s;
  return out;
}
/**
 * Rotates a matrix by the given angle around the Z axis
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */

function rotateZ(out, a, rad) {
  var s = Math.sin(rad);
  var c = Math.cos(rad);
  var a00 = a[0];
  var a01 = a[1];
  var a02 = a[2];
  var a03 = a[3];
  var a10 = a[4];
  var a11 = a[5];
  var a12 = a[6];
  var a13 = a[7];

  if (a !== out) {
    // If the source and destination differ, copy the unchanged last row
    out[8] = a[8];
    out[9] = a[9];
    out[10] = a[10];
    out[11] = a[11];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
  } // Perform axis-specific matrix multiplication


  out[0] = a00 * c + a10 * s;
  out[1] = a01 * c + a11 * s;
  out[2] = a02 * c + a12 * s;
  out[3] = a03 * c + a13 * s;
  out[4] = a10 * c - a00 * s;
  out[5] = a11 * c - a01 * s;
  out[6] = a12 * c - a02 * s;
  out[7] = a13 * c - a03 * s;
  return out;
}
/**
 * Creates a matrix from a vector scaling
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.scale(dest, dest, vec);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {ReadonlyVec3} v Scaling vector
 * @returns {mat4} out
 */

function fromScaling(out, v) {
  out[0] = v[0];
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = v[1];
  out[6] = 0;
  out[7] = 0;
  out[8] = 0;
  out[9] = 0;
  out[10] = v[2];
  out[11] = 0;
  out[12] = 0;
  out[13] = 0;
  out[14] = 0;
  out[15] = 1;
  return out;
}
/**
 * Generates a perspective projection matrix with the given bounds.
 * The near/far clip planes correspond to a normalized device coordinate Z range of [-1, 1],
 * which matches WebGL/OpenGL's clip volume.
 * Passing null/undefined/no value for far will generate infinite projection matrix.
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {number} fovy Vertical field of view in radians
 * @param {number} aspect Aspect ratio. typically viewport width/height
 * @param {number} near Near bound of the frustum
 * @param {number} far Far bound of the frustum, can be null or Infinity
 * @returns {mat4} out
 */

function perspectiveNO(out, fovy, aspect, near, far) {
  var f = 1.0 / Math.tan(fovy / 2),
      nf;
  out[0] = f / aspect;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = f;
  out[6] = 0;
  out[7] = 0;
  out[8] = 0;
  out[9] = 0;
  out[11] = -1;
  out[12] = 0;
  out[13] = 0;
  out[15] = 0;

  if (far != null && far !== Infinity) {
    nf = 1 / (near - far);
    out[10] = (far + near) * nf;
    out[14] = 2 * far * near * nf;
  } else {
    out[10] = -1;
    out[14] = -2 * near;
  }

  return out;
}
/**
 * Alias for {@link mat4.perspectiveNO}
 * @function
 */

var perspective = perspectiveNO;
/**
 * Generates a orthogonal projection matrix with the given bounds.
 * The near/far clip planes correspond to a normalized device coordinate Z range of [-1, 1],
 * which matches WebGL/OpenGL's clip volume.
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {number} left Left bound of the frustum
 * @param {number} right Right bound of the frustum
 * @param {number} bottom Bottom bound of the frustum
 * @param {number} top Top bound of the frustum
 * @param {number} near Near bound of the frustum
 * @param {number} far Far bound of the frustum
 * @returns {mat4} out
 */

function orthoNO(out, left, right, bottom, top, near, far) {
  var lr = 1 / (left - right);
  var bt = 1 / (bottom - top);
  var nf = 1 / (near - far);
  out[0] = -2 * lr;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = -2 * bt;
  out[6] = 0;
  out[7] = 0;
  out[8] = 0;
  out[9] = 0;
  out[10] = 2 * nf;
  out[11] = 0;
  out[12] = (left + right) * lr;
  out[13] = (top + bottom) * bt;
  out[14] = (far + near) * nf;
  out[15] = 1;
  return out;
}
/**
 * Alias for {@link mat4.orthoNO}
 * @function
 */

var ortho = orthoNO;
/**
 * Returns whether or not the matrices have exactly the same elements in the same position (when compared with ===)
 *
 * @param {ReadonlyMat4} a The first matrix.
 * @param {ReadonlyMat4} b The second matrix.
 * @returns {Boolean} True if the matrices are equal, false otherwise.
 */

function exactEquals(a, b) {
  return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3] && a[4] === b[4] && a[5] === b[5] && a[6] === b[6] && a[7] === b[7] && a[8] === b[8] && a[9] === b[9] && a[10] === b[10] && a[11] === b[11] && a[12] === b[12] && a[13] === b[13] && a[14] === b[14] && a[15] === b[15];
}
/**
 * Returns whether or not the matrices have approximately the same elements in the same position.
 *
 * @param {ReadonlyMat4} a The first matrix.
 * @param {ReadonlyMat4} b The second matrix.
 * @returns {Boolean} True if the matrices are equal, false otherwise.
 */

function equals$1(a, b) {
  var a0 = a[0],
      a1 = a[1],
      a2 = a[2],
      a3 = a[3];
  var a4 = a[4],
      a5 = a[5],
      a6 = a[6],
      a7 = a[7];
  var a8 = a[8],
      a9 = a[9],
      a10 = a[10],
      a11 = a[11];
  var a12 = a[12],
      a13 = a[13],
      a14 = a[14],
      a15 = a[15];
  var b0 = b[0],
      b1 = b[1],
      b2 = b[2],
      b3 = b[3];
  var b4 = b[4],
      b5 = b[5],
      b6 = b[6],
      b7 = b[7];
  var b8 = b[8],
      b9 = b[9],
      b10 = b[10],
      b11 = b[11];
  var b12 = b[12],
      b13 = b[13],
      b14 = b[14],
      b15 = b[15];
  return Math.abs(a0 - b0) <= EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2)) && Math.abs(a3 - b3) <= EPSILON * Math.max(1.0, Math.abs(a3), Math.abs(b3)) && Math.abs(a4 - b4) <= EPSILON * Math.max(1.0, Math.abs(a4), Math.abs(b4)) && Math.abs(a5 - b5) <= EPSILON * Math.max(1.0, Math.abs(a5), Math.abs(b5)) && Math.abs(a6 - b6) <= EPSILON * Math.max(1.0, Math.abs(a6), Math.abs(b6)) && Math.abs(a7 - b7) <= EPSILON * Math.max(1.0, Math.abs(a7), Math.abs(b7)) && Math.abs(a8 - b8) <= EPSILON * Math.max(1.0, Math.abs(a8), Math.abs(b8)) && Math.abs(a9 - b9) <= EPSILON * Math.max(1.0, Math.abs(a9), Math.abs(b9)) && Math.abs(a10 - b10) <= EPSILON * Math.max(1.0, Math.abs(a10), Math.abs(b10)) && Math.abs(a11 - b11) <= EPSILON * Math.max(1.0, Math.abs(a11), Math.abs(b11)) && Math.abs(a12 - b12) <= EPSILON * Math.max(1.0, Math.abs(a12), Math.abs(b12)) && Math.abs(a13 - b13) <= EPSILON * Math.max(1.0, Math.abs(a13), Math.abs(b13)) && Math.abs(a14 - b14) <= EPSILON * Math.max(1.0, Math.abs(a14), Math.abs(b14)) && Math.abs(a15 - b15) <= EPSILON * Math.max(1.0, Math.abs(a15), Math.abs(b15));
}
/**
 * Alias for {@link mat4.multiply}
 * @function
 */

var mul$1 = multiply$1;

/**
 * 4 Dimensional Vector
 * @module vec4
 */

/**
 * Creates a new, empty vec4
 *
 * @returns {vec4} a new 4D vector
 */

function create() {
  var out = new ARRAY_TYPE(4);

  if (ARRAY_TYPE != Float32Array) {
    out[0] = 0;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
  }

  return out;
}
/**
 * Multiplies two vec4's
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a the first operand
 * @param {ReadonlyVec4} b the second operand
 * @returns {vec4} out
 */

function multiply(out, a, b) {
  out[0] = a[0] * b[0];
  out[1] = a[1] * b[1];
  out[2] = a[2] * b[2];
  out[3] = a[3] * b[3];
  return out;
}
/**
 * Calculates the dot product of two vec4's
 *
 * @param {ReadonlyVec4} a the first operand
 * @param {ReadonlyVec4} b the second operand
 * @returns {Number} dot product of a and b
 */

function dot$1(a, b) {
  return a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3];
}
/**
 * Transforms the vec4 with a mat4.
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a the vector to transform
 * @param {ReadonlyMat4} m matrix to transform with
 * @returns {vec4} out
 */

function transformMat4(out, a, m) {
  var x = a[0],
      y = a[1],
      z = a[2],
      w = a[3];
  out[0] = m[0] * x + m[4] * y + m[8] * z + m[12] * w;
  out[1] = m[1] * x + m[5] * y + m[9] * z + m[13] * w;
  out[2] = m[2] * x + m[6] * y + m[10] * z + m[14] * w;
  out[3] = m[3] * x + m[7] * y + m[11] * z + m[15] * w;
  return out;
}
/**
 * Alias for {@link vec4.multiply}
 * @function
 */

var mul = multiply;
/**
 * Perform some operation over an array of vec4s.
 *
 * @param {Array} a the array of vectors to iterate over
 * @param {Number} stride Number of elements between the start of each vec4. If 0 assumes tightly packed
 * @param {Number} offset Number of elements to skip at the beginning of the array
 * @param {Number} count Number of vec4s to iterate over. If 0 iterates over entire array
 * @param {Function} fn Function to call for each vector in the array
 * @param {Object} [arg] additional argument to pass to fn
 * @returns {Array} a
 * @function
 */

(function () {
  var vec = create();
  return function (a, stride, offset, count, fn, arg) {
    var i, l;

    if (!stride) {
      stride = 4;
    }

    if (!offset) {
      offset = 0;
    }

    if (count) {
      l = Math.min(count * stride + offset, a.length);
    } else {
      l = a.length;
    }

    for (i = offset; i < l; i += stride) {
      vec[0] = a[i];
      vec[1] = a[i + 1];
      vec[2] = a[i + 2];
      vec[3] = a[i + 3];
      fn(vec, vec, arg);
      a[i] = vec[0];
      a[i + 1] = vec[1];
      a[i + 2] = vec[2];
      a[i + 3] = vec[3];
    }

    return a;
  };
})();

/**
 * A style layer that defines a circle
 */
class CircleStyleLayer extends StyleLayer {
    constructor(layer) {
        super(layer, properties$8);
    }
    createBucket(parameters) {
        return new CircleBucket(parameters);
    }
    queryRadius(bucket) {
        const circleBucket = bucket;
        return getMaximumPaintValue('circle-radius', this, circleBucket) +
            getMaximumPaintValue('circle-stroke-width', this, circleBucket) +
            translateDistance(this.paint.get('circle-translate'));
    }
    queryIntersectsFeature(queryGeometry, feature, featureState, geometry, zoom, transform, pixelsToTileUnits, pixelPosMatrix) {
        const translatedPolygon = translate$1(queryGeometry, this.paint.get('circle-translate'), this.paint.get('circle-translate-anchor'), transform.angle, pixelsToTileUnits);
        const radius = this.paint.get('circle-radius').evaluate(feature, featureState);
        const stroke = this.paint.get('circle-stroke-width').evaluate(feature, featureState);
        const size = radius + stroke;
        // For pitch-alignment: map, compare feature geometry to query geometry in the plane of the tile
        // // Otherwise, compare geometry in the plane of the viewport
        // // A circle with fixed scaling relative to the viewport gets larger in tile space as it moves into the distance
        // // A circle with fixed scaling relative to the map gets smaller in viewport space as it moves into the distance
        const alignWithMap = this.paint.get('circle-pitch-alignment') === 'map';
        const transformedPolygon = alignWithMap ? translatedPolygon : projectQueryGeometry$1(translatedPolygon, pixelPosMatrix);
        const transformedSize = alignWithMap ? size * pixelsToTileUnits : size;
        for (const ring of geometry) {
            for (const point of ring) {
                const transformedPoint = alignWithMap ? point : projectPoint(point, pixelPosMatrix);
                let adjustedSize = transformedSize;
                const projectedCenter = transformMat4([], [point.x, point.y, 0, 1], pixelPosMatrix);
                if (this.paint.get('circle-pitch-scale') === 'viewport' && this.paint.get('circle-pitch-alignment') === 'map') {
                    adjustedSize *= projectedCenter[3] / transform.cameraToCenterDistance;
                }
                else if (this.paint.get('circle-pitch-scale') === 'map' && this.paint.get('circle-pitch-alignment') === 'viewport') {
                    adjustedSize *= transform.cameraToCenterDistance / projectedCenter[3];
                }
                if (polygonIntersectsBufferedPoint(transformedPolygon, transformedPoint, adjustedSize))
                    return true;
            }
        }
        return false;
    }
}
function projectPoint(p, pixelPosMatrix) {
    const point = transformMat4([], [p.x, p.y, 0, 1], pixelPosMatrix);
    return new Point$2(point[0] / point[3], point[1] / point[3]);
}
function projectQueryGeometry$1(queryGeometry, pixelPosMatrix) {
    return queryGeometry.map((p) => {
        return projectPoint(p, pixelPosMatrix);
    });
}

class HeatmapBucket extends CircleBucket {
}
register('HeatmapBucket', HeatmapBucket, { omit: ['layers'] });

// This file is generated. Edit build/generate-style-code.ts, then run 'npm run codegen'.
/* eslint-disable */
let paint$7;
const getPaint$7 = () => paint$7 = paint$7 || new Properties({
    "heatmap-radius": new DataDrivenProperty(v8Spec["paint_heatmap"]["heatmap-radius"]),
    "heatmap-weight": new DataDrivenProperty(v8Spec["paint_heatmap"]["heatmap-weight"]),
    "heatmap-intensity": new DataConstantProperty(v8Spec["paint_heatmap"]["heatmap-intensity"]),
    "heatmap-color": new ColorRampProperty(v8Spec["paint_heatmap"]["heatmap-color"]),
    "heatmap-opacity": new DataConstantProperty(v8Spec["paint_heatmap"]["heatmap-opacity"]),
});
var properties$7 = ({ get paint() { return getPaint$7(); } });

function createImage(image, { width, height }, channels, data) {
    if (!data) {
        data = new Uint8Array(width * height * channels);
    }
    else if (data instanceof Uint8ClampedArray) {
        data = new Uint8Array(data.buffer);
    }
    else if (data.length !== width * height * channels) {
        throw new RangeError(`mismatched image size. expected: ${data.length} but got: ${width * height * channels}`);
    }
    image.width = width;
    image.height = height;
    image.data = data;
    return image;
}
function resizeImage(image, { width, height }, channels) {
    if (width === image.width && height === image.height) {
        return;
    }
    const newImage = createImage({}, { width, height }, channels);
    copyImage(image, newImage, { x: 0, y: 0 }, { x: 0, y: 0 }, {
        width: Math.min(image.width, width),
        height: Math.min(image.height, height)
    }, channels);
    image.width = width;
    image.height = height;
    image.data = newImage.data;
}
function copyImage(srcImg, dstImg, srcPt, dstPt, size, channels) {
    if (size.width === 0 || size.height === 0) {
        return dstImg;
    }
    if (size.width > srcImg.width ||
        size.height > srcImg.height ||
        srcPt.x > srcImg.width - size.width ||
        srcPt.y > srcImg.height - size.height) {
        throw new RangeError('out of range source coordinates for image copy');
    }
    if (size.width > dstImg.width ||
        size.height > dstImg.height ||
        dstPt.x > dstImg.width - size.width ||
        dstPt.y > dstImg.height - size.height) {
        throw new RangeError('out of range destination coordinates for image copy');
    }
    const srcData = srcImg.data;
    const dstData = dstImg.data;
    if (srcData === dstData)
        throw new Error('srcData equals dstData, so image is already copied');
    for (let y = 0; y < size.height; y++) {
        const srcOffset = ((srcPt.y + y) * srcImg.width + srcPt.x) * channels;
        const dstOffset = ((dstPt.y + y) * dstImg.width + dstPt.x) * channels;
        for (let i = 0; i < size.width * channels; i++) {
            dstData[dstOffset + i] = srcData[srcOffset + i];
        }
    }
    return dstImg;
}
/**
 * An image with alpha color value
 */
class AlphaImage {
    constructor(size, data) {
        createImage(this, size, 1, data);
    }
    resize(size) {
        resizeImage(this, size, 1);
    }
    clone() {
        return new AlphaImage({ width: this.width, height: this.height }, new Uint8Array(this.data));
    }
    static copy(srcImg, dstImg, srcPt, dstPt, size) {
        copyImage(srcImg, dstImg, srcPt, dstPt, size, 1);
    }
}
/**
 * An object to store image data not premultiplied, because ImageData is not premultiplied.
 * UNPACK_PREMULTIPLY_ALPHA_WEBGL must be used when uploading to a texture.
 */
class RGBAImage {
    constructor(size, data) {
        createImage(this, size, 4, data);
    }
    resize(size) {
        resizeImage(this, size, 4);
    }
    replace(data, copy) {
        if (copy) {
            this.data.set(data);
        }
        else if (data instanceof Uint8ClampedArray) {
            this.data = new Uint8Array(data.buffer);
        }
        else {
            this.data = data;
        }
    }
    clone() {
        return new RGBAImage({ width: this.width, height: this.height }, new Uint8Array(this.data));
    }
    static copy(srcImg, dstImg, srcPt, dstPt, size) {
        copyImage(srcImg, dstImg, srcPt, dstPt, size, 4);
    }
}
register('AlphaImage', AlphaImage);
register('RGBAImage', RGBAImage);

/**
 * Given an expression that should evaluate to a color ramp,
 * return a RGBA image representing that ramp expression.
 */
function renderColorRamp(params) {
    const evaluationGlobals = {};
    const width = params.resolution || 256;
    const height = params.clips ? params.clips.length : 1;
    const image = params.image || new RGBAImage({ width, height });
    if (!isPowerOfTwo(width))
        throw new Error(`width is not a power of 2 - ${width}`);
    const renderPixel = (stride, index, progress) => {
        evaluationGlobals[params.evaluationKey] = progress;
        const pxColor = params.expression.evaluate(evaluationGlobals);
        // the colors are being unpremultiplied because Color uses
        // premultiplied values, and the Texture class expects unpremultiplied ones
        image.data[stride + index + 0] = Math.floor(pxColor.r * 255 / pxColor.a);
        image.data[stride + index + 1] = Math.floor(pxColor.g * 255 / pxColor.a);
        image.data[stride + index + 2] = Math.floor(pxColor.b * 255 / pxColor.a);
        image.data[stride + index + 3] = Math.floor(pxColor.a * 255);
    };
    if (!params.clips) {
        for (let i = 0, j = 0; i < width; i++, j += 4) {
            const progress = i / (width - 1);
            renderPixel(0, j, progress);
        }
    }
    else {
        for (let clip = 0, stride = 0; clip < height; ++clip, stride += width * 4) {
            for (let i = 0, j = 0; i < width; i++, j += 4) {
                // Remap progress between clips
                const progress = i / (width - 1);
                const { start, end } = params.clips[clip];
                const evaluationProgress = start * (1 - progress) + end * progress;
                renderPixel(stride, j, evaluationProgress);
            }
        }
    }
    return image;
}

/**
 * A style layer that defines a heatmap
 */
class HeatmapStyleLayer extends StyleLayer {
    createBucket(options) {
        return new HeatmapBucket(options);
    }
    constructor(layer) {
        super(layer, properties$7);
        // make sure color ramp texture is generated for default heatmap color too
        this._updateColorRamp();
    }
    _handleSpecialPaintPropertyUpdate(name) {
        if (name === 'heatmap-color') {
            this._updateColorRamp();
        }
    }
    _updateColorRamp() {
        const expression = this._transitionablePaint._values['heatmap-color'].value.expression;
        this.colorRamp = renderColorRamp({
            expression,
            evaluationKey: 'heatmapDensity',
            image: this.colorRamp
        });
        this.colorRampTexture = null;
    }
    resize() {
        if (this.heatmapFbo) {
            this.heatmapFbo.destroy();
            this.heatmapFbo = null;
        }
    }
    queryRadius() {
        return 0;
    }
    queryIntersectsFeature() {
        return false;
    }
    hasOffscreenPass() {
        return this.paint.get('heatmap-opacity') !== 0 && this.visibility !== 'none';
    }
}

// This file is generated. Edit build/generate-style-code.ts, then run 'npm run codegen'.
/* eslint-disable */
let paint$6;
const getPaint$6 = () => paint$6 = paint$6 || new Properties({
    "hillshade-illumination-direction": new DataConstantProperty(v8Spec["paint_hillshade"]["hillshade-illumination-direction"]),
    "hillshade-illumination-anchor": new DataConstantProperty(v8Spec["paint_hillshade"]["hillshade-illumination-anchor"]),
    "hillshade-exaggeration": new DataConstantProperty(v8Spec["paint_hillshade"]["hillshade-exaggeration"]),
    "hillshade-shadow-color": new DataConstantProperty(v8Spec["paint_hillshade"]["hillshade-shadow-color"]),
    "hillshade-highlight-color": new DataConstantProperty(v8Spec["paint_hillshade"]["hillshade-highlight-color"]),
    "hillshade-accent-color": new DataConstantProperty(v8Spec["paint_hillshade"]["hillshade-accent-color"]),
});
var properties$6 = ({ get paint() { return getPaint$6(); } });

class HillshadeStyleLayer extends StyleLayer {
    constructor(layer) {
        super(layer, properties$6);
    }
    hasOffscreenPass() {
        return this.paint.get('hillshade-exaggeration') !== 0 && this.visibility !== 'none';
    }
}

const layout$4 = createLayout([
    { name: 'a_pos', components: 2, type: 'Int16' }
], 4);
const { members: members$3, size: size$3, alignment: alignment$3 } = layout$4;

function earcut(data, holeIndices, dim = 2) {

    const hasHoles = holeIndices && holeIndices.length;
    const outerLen = hasHoles ? holeIndices[0] * dim : data.length;
    let outerNode = linkedList(data, 0, outerLen, dim, true);
    const triangles = [];

    if (!outerNode || outerNode.next === outerNode.prev) return triangles;

    let minX, minY, invSize;

    if (hasHoles) outerNode = eliminateHoles(data, holeIndices, outerNode, dim);

    // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
    if (data.length > 80 * dim) {
        minX = Infinity;
        minY = Infinity;
        let maxX = -Infinity;
        let maxY = -Infinity;

        for (let i = dim; i < outerLen; i += dim) {
            const x = data[i];
            const y = data[i + 1];
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
        }

        // minX, minY and invSize are later used to transform coords into integers for z-order calculation
        invSize = Math.max(maxX - minX, maxY - minY);
        invSize = invSize !== 0 ? 32767 / invSize : 0;
    }

    earcutLinked(outerNode, triangles, dim, minX, minY, invSize, 0);

    return triangles;
}

// create a circular doubly linked list from polygon points in the specified winding order
function linkedList(data, start, end, dim, clockwise) {
    let last;

    if (clockwise === (signedArea$1(data, start, end, dim) > 0)) {
        for (let i = start; i < end; i += dim) last = insertNode(i / dim | 0, data[i], data[i + 1], last);
    } else {
        for (let i = end - dim; i >= start; i -= dim) last = insertNode(i / dim | 0, data[i], data[i + 1], last);
    }

    if (last && equals(last, last.next)) {
        removeNode(last);
        last = last.next;
    }

    return last;
}

// eliminate colinear or duplicate points
function filterPoints(start, end) {
    if (!start) return start;
    if (!end) end = start;

    let p = start,
        again;
    do {
        again = false;

        if (!p.steiner && (equals(p, p.next) || area(p.prev, p, p.next) === 0)) {
            removeNode(p);
            p = end = p.prev;
            if (p === p.next) break;
            again = true;

        } else {
            p = p.next;
        }
    } while (again || p !== end);

    return end;
}

// main ear slicing loop which triangulates a polygon (given as a linked list)
function earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
    if (!ear) return;

    // interlink polygon nodes in z-order
    if (!pass && invSize) indexCurve(ear, minX, minY, invSize);

    let stop = ear;

    // iterate through ears, slicing them one by one
    while (ear.prev !== ear.next) {
        const prev = ear.prev;
        const next = ear.next;

        if (invSize ? isEarHashed(ear, minX, minY, invSize) : isEar(ear)) {
            triangles.push(prev.i, ear.i, next.i); // cut off the triangle

            removeNode(ear);

            // skipping the next vertex leads to less sliver triangles
            ear = next.next;
            stop = next.next;

            continue;
        }

        ear = next;

        // if we looped through the whole remaining polygon and can't find any more ears
        if (ear === stop) {
            // try filtering points and slicing again
            if (!pass) {
                earcutLinked(filterPoints(ear), triangles, dim, minX, minY, invSize, 1);

            // if this didn't work, try curing all small self-intersections locally
            } else if (pass === 1) {
                ear = cureLocalIntersections(filterPoints(ear), triangles);
                earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);

            // as a last resort, try splitting the remaining polygon into two
            } else if (pass === 2) {
                splitEarcut(ear, triangles, dim, minX, minY, invSize);
            }

            break;
        }
    }
}

// check whether a polygon node forms a valid ear with adjacent nodes
function isEar(ear) {
    const a = ear.prev,
        b = ear,
        c = ear.next;

    if (area(a, b, c) >= 0) return false; // reflex, can't be an ear

    // now make sure we don't have other points inside the potential ear
    const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;

    // triangle bbox; min & max are calculated like this for speed
    const x0 = ax < bx ? (ax < cx ? ax : cx) : (bx < cx ? bx : cx),
        y0 = ay < by ? (ay < cy ? ay : cy) : (by < cy ? by : cy),
        x1 = ax > bx ? (ax > cx ? ax : cx) : (bx > cx ? bx : cx),
        y1 = ay > by ? (ay > cy ? ay : cy) : (by > cy ? by : cy);

    let p = c.next;
    while (p !== a) {
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 &&
            pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) &&
            area(p.prev, p, p.next) >= 0) return false;
        p = p.next;
    }

    return true;
}

function isEarHashed(ear, minX, minY, invSize) {
    const a = ear.prev,
        b = ear,
        c = ear.next;

    if (area(a, b, c) >= 0) return false; // reflex, can't be an ear

    const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;

    // triangle bbox; min & max are calculated like this for speed
    const x0 = ax < bx ? (ax < cx ? ax : cx) : (bx < cx ? bx : cx),
        y0 = ay < by ? (ay < cy ? ay : cy) : (by < cy ? by : cy),
        x1 = ax > bx ? (ax > cx ? ax : cx) : (bx > cx ? bx : cx),
        y1 = ay > by ? (ay > cy ? ay : cy) : (by > cy ? by : cy);

    // z-order range for the current triangle bbox;
    const minZ = zOrder(x0, y0, minX, minY, invSize),
        maxZ = zOrder(x1, y1, minX, minY, invSize);

    let p = ear.prevZ,
        n = ear.nextZ;

    // look for points inside the triangle in both directions
    while (p && p.z >= minZ && n && n.z <= maxZ) {
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c &&
            pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;

        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c &&
            pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }

    // look for remaining points in decreasing z-order
    while (p && p.z >= minZ) {
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c &&
            pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
    }

    // look for remaining points in increasing z-order
    while (n && n.z <= maxZ) {
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c &&
            pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }

    return true;
}

// go through all polygon nodes and cure small local self-intersections
function cureLocalIntersections(start, triangles) {
    let p = start;
    do {
        const a = p.prev,
            b = p.next.next;

        if (!equals(a, b) && intersects(a, p, p.next, b) && locallyInside(a, b) && locallyInside(b, a)) {

            triangles.push(a.i, p.i, b.i);

            // remove two nodes involved
            removeNode(p);
            removeNode(p.next);

            p = start = b;
        }
        p = p.next;
    } while (p !== start);

    return filterPoints(p);
}

// try splitting polygon into two and triangulate them independently
function splitEarcut(start, triangles, dim, minX, minY, invSize) {
    // look for a valid diagonal that divides the polygon into two
    let a = start;
    do {
        let b = a.next.next;
        while (b !== a.prev) {
            if (a.i !== b.i && isValidDiagonal(a, b)) {
                // split the polygon in two by the diagonal
                let c = splitPolygon(a, b);

                // filter colinear points around the cuts
                a = filterPoints(a, a.next);
                c = filterPoints(c, c.next);

                // run earcut on each half
                earcutLinked(a, triangles, dim, minX, minY, invSize, 0);
                earcutLinked(c, triangles, dim, minX, minY, invSize, 0);
                return;
            }
            b = b.next;
        }
        a = a.next;
    } while (a !== start);
}

// link every hole into the outer loop, producing a single-ring polygon without holes
function eliminateHoles(data, holeIndices, outerNode, dim) {
    const queue = [];

    for (let i = 0, len = holeIndices.length; i < len; i++) {
        const start = holeIndices[i] * dim;
        const end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        const list = linkedList(data, start, end, dim, false);
        if (list === list.next) list.steiner = true;
        queue.push(getLeftmost(list));
    }

    queue.sort(compareX);

    // process holes from left to right
    for (let i = 0; i < queue.length; i++) {
        outerNode = eliminateHole(queue[i], outerNode);
    }

    return outerNode;
}

function compareX(a, b) {
    return a.x - b.x;
}

// find a bridge between vertices that connects hole with an outer ring and and link it
function eliminateHole(hole, outerNode) {
    const bridge = findHoleBridge(hole, outerNode);
    if (!bridge) {
        return outerNode;
    }

    const bridgeReverse = splitPolygon(bridge, hole);

    // filter collinear points around the cuts
    filterPoints(bridgeReverse, bridgeReverse.next);
    return filterPoints(bridge, bridge.next);
}

// David Eberly's algorithm for finding a bridge between hole and outer polygon
function findHoleBridge(hole, outerNode) {
    let p = outerNode;
    const hx = hole.x;
    const hy = hole.y;
    let qx = -Infinity;
    let m;

    // find a segment intersected by a ray from the hole's leftmost point to the left;
    // segment's endpoint with lesser x will be potential connection point
    do {
        if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
            const x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
            if (x <= hx && x > qx) {
                qx = x;
                m = p.x < p.next.x ? p : p.next;
                if (x === hx) return m; // hole touches outer segment; pick leftmost endpoint
            }
        }
        p = p.next;
    } while (p !== outerNode);

    if (!m) return null;

    // look for points inside the triangle of hole point, segment intersection and endpoint;
    // if there are no points found, we have a valid connection;
    // otherwise choose the point of the minimum angle with the ray as connection point

    const stop = m;
    const mx = m.x;
    const my = m.y;
    let tanMin = Infinity;

    p = m;

    do {
        if (hx >= p.x && p.x >= mx && hx !== p.x &&
                pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {

            const tan = Math.abs(hy - p.y) / (hx - p.x); // tangential

            if (locallyInside(p, hole) &&
                (tan < tanMin || (tan === tanMin && (p.x > m.x || (p.x === m.x && sectorContainsSector(m, p)))))) {
                m = p;
                tanMin = tan;
            }
        }

        p = p.next;
    } while (p !== stop);

    return m;
}

// whether sector in vertex m contains sector in vertex p in the same coordinates
function sectorContainsSector(m, p) {
    return area(m.prev, m, p.prev) < 0 && area(p.next, m, m.next) < 0;
}

// interlink polygon nodes in z-order
function indexCurve(start, minX, minY, invSize) {
    let p = start;
    do {
        if (p.z === 0) p.z = zOrder(p.x, p.y, minX, minY, invSize);
        p.prevZ = p.prev;
        p.nextZ = p.next;
        p = p.next;
    } while (p !== start);

    p.prevZ.nextZ = null;
    p.prevZ = null;

    sortLinked(p);
}

// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function sortLinked(list) {
    let numMerges;
    let inSize = 1;

    do {
        let p = list;
        let e;
        list = null;
        let tail = null;
        numMerges = 0;

        while (p) {
            numMerges++;
            let q = p;
            let pSize = 0;
            for (let i = 0; i < inSize; i++) {
                pSize++;
                q = q.nextZ;
                if (!q) break;
            }
            let qSize = inSize;

            while (pSize > 0 || (qSize > 0 && q)) {

                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                }

                if (tail) tail.nextZ = e;
                else list = e;

                e.prevZ = tail;
                tail = e;
            }

            p = q;
        }

        tail.nextZ = null;
        inSize *= 2;

    } while (numMerges > 1);

    return list;
}

// z-order of a point given coords and inverse of the longer side of data bbox
function zOrder(x, y, minX, minY, invSize) {
    // coords are transformed into non-negative 15-bit integer range
    x = (x - minX) * invSize | 0;
    y = (y - minY) * invSize | 0;

    x = (x | (x << 8)) & 0x00FF00FF;
    x = (x | (x << 4)) & 0x0F0F0F0F;
    x = (x | (x << 2)) & 0x33333333;
    x = (x | (x << 1)) & 0x55555555;

    y = (y | (y << 8)) & 0x00FF00FF;
    y = (y | (y << 4)) & 0x0F0F0F0F;
    y = (y | (y << 2)) & 0x33333333;
    y = (y | (y << 1)) & 0x55555555;

    return x | (y << 1);
}

// find the leftmost node of a polygon ring
function getLeftmost(start) {
    let p = start,
        leftmost = start;
    do {
        if (p.x < leftmost.x || (p.x === leftmost.x && p.y < leftmost.y)) leftmost = p;
        p = p.next;
    } while (p !== start);

    return leftmost;
}

// check if a point lies within a convex triangle
function pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
    return (cx - px) * (ay - py) >= (ax - px) * (cy - py) &&
           (ax - px) * (by - py) >= (bx - px) * (ay - py) &&
           (bx - px) * (cy - py) >= (cx - px) * (by - py);
}

// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function isValidDiagonal(a, b) {
    return a.next.i !== b.i && a.prev.i !== b.i && !intersectsPolygon(a, b) && // dones't intersect other edges
           (locallyInside(a, b) && locallyInside(b, a) && middleInside(a, b) && // locally visible
            (area(a.prev, a, b.prev) || area(a, b.prev, b)) || // does not create opposite-facing sectors
            equals(a, b) && area(a.prev, a, a.next) > 0 && area(b.prev, b, b.next) > 0); // special zero-length case
}

// signed area of a triangle
function area(p, q, r) {
    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}

// check if two points are equal
function equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}

// check if two segments intersect
function intersects(p1, q1, p2, q2) {
    const o1 = sign(area(p1, q1, p2));
    const o2 = sign(area(p1, q1, q2));
    const o3 = sign(area(p2, q2, p1));
    const o4 = sign(area(p2, q2, q1));

    if (o1 !== o2 && o3 !== o4) return true; // general case

    if (o1 === 0 && onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
    if (o2 === 0 && onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
    if (o3 === 0 && onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
    if (o4 === 0 && onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2

    return false;
}

// for collinear points p, q, r, check if point q lies on segment pr
function onSegment(p, q, r) {
    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}

function sign(num) {
    return num > 0 ? 1 : num < 0 ? -1 : 0;
}

// check if a polygon diagonal intersects any polygon segments
function intersectsPolygon(a, b) {
    let p = a;
    do {
        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i &&
                intersects(p, p.next, a, b)) return true;
        p = p.next;
    } while (p !== a);

    return false;
}

// check if a polygon diagonal is locally inside the polygon
function locallyInside(a, b) {
    return area(a.prev, a, a.next) < 0 ?
        area(a, b, a.next) >= 0 && area(a, a.prev, b) >= 0 :
        area(a, b, a.prev) < 0 || area(a, a.next, b) < 0;
}

// check if the middle point of a polygon diagonal is inside the polygon
function middleInside(a, b) {
    let p = a;
    let inside = false;
    const px = (a.x + b.x) / 2;
    const py = (a.y + b.y) / 2;
    do {
        if (((p.y > py) !== (p.next.y > py)) && p.next.y !== p.y &&
                (px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x))
            inside = !inside;
        p = p.next;
    } while (p !== a);

    return inside;
}

// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function splitPolygon(a, b) {
    const a2 = createNode(a.i, a.x, a.y),
        b2 = createNode(b.i, b.x, b.y),
        an = a.next,
        bp = b.prev;

    a.next = b;
    b.prev = a;

    a2.next = an;
    an.prev = a2;

    b2.next = a2;
    a2.prev = b2;

    bp.next = b2;
    b2.prev = bp;

    return b2;
}

// create a node and optionally link it with previous one (in a circular doubly linked list)
function insertNode(i, x, y, last) {
    const p = createNode(i, x, y);

    if (!last) {
        p.prev = p;
        p.next = p;

    } else {
        p.next = last.next;
        p.prev = last;
        last.next.prev = p;
        last.next = p;
    }
    return p;
}

function removeNode(p) {
    p.next.prev = p.prev;
    p.prev.next = p.next;

    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}

function createNode(i, x, y) {
    return {
        i, // vertex index in coordinates array
        x, y, // vertex coordinates
        prev: null, // previous and next vertex nodes in a polygon ring
        next: null,
        z: 0, // z-order curve value
        prevZ: null, // previous and next nodes in z-order
        nextZ: null,
        steiner: false // indicates whether this is a steiner point
    };
}

function signedArea$1(data, start, end, dim) {
    let sum = 0;
    for (let i = start, j = end - dim; i < end; i += dim) {
        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
        j = i;
    }
    return sum;
}

function hasPattern(type, layers, options) {
    const patterns = options.patternDependencies;
    let hasPattern = false;
    for (const layer of layers) {
        const patternProperty = layer.paint.get(`${type}-pattern`);
        if (!patternProperty.isConstant()) {
            hasPattern = true;
        }
        const constantPattern = patternProperty.constantOr(null);
        if (constantPattern) {
            hasPattern = true;
            patterns[constantPattern.to] = true;
            patterns[constantPattern.from] = true;
        }
    }
    return hasPattern;
}
function addPatternDependencies(type, layers, patternFeature, zoom, options) {
    const patterns = options.patternDependencies;
    for (const layer of layers) {
        const patternProperty = layer.paint.get(`${type}-pattern`);
        const patternPropertyValue = patternProperty.value;
        if (patternPropertyValue.kind !== 'constant') {
            let min = patternPropertyValue.evaluate({ zoom: zoom - 1 }, patternFeature, {}, options.availableImages);
            let mid = patternPropertyValue.evaluate({ zoom }, patternFeature, {}, options.availableImages);
            let max = patternPropertyValue.evaluate({ zoom: zoom + 1 }, patternFeature, {}, options.availableImages);
            min = min && min.name ? min.name : min;
            mid = mid && mid.name ? mid.name : mid;
            max = max && max.name ? max.name : max;
            // add to patternDependencies
            patterns[min] = true;
            patterns[mid] = true;
            patterns[max] = true;
            // save for layout
            patternFeature.patterns[layer.id] = { min, mid, max };
        }
    }
    return patternFeature;
}

const EARCUT_MAX_RINGS$1 = 500;
class FillBucket {
    constructor(options) {
        this.zoom = options.zoom;
        this.overscaling = options.overscaling;
        this.layers = options.layers;
        this.layerIds = this.layers.map(layer => layer.id);
        this.index = options.index;
        this.hasPattern = false;
        this.patternFeatures = [];
        this.layoutVertexArray = new FillLayoutArray();
        this.indexArray = new TriangleIndexArray();
        this.indexArray2 = new LineIndexArray();
        this.programConfigurations = new ProgramConfigurationSet(options.layers, options.zoom);
        this.segments = new SegmentVector();
        this.segments2 = new SegmentVector();
        this.stateDependentLayerIds = this.layers.filter((l) => l.isStateDependent()).map((l) => l.id);
    }
    populate(features, options, canonical) {
        this.hasPattern = hasPattern('fill', this.layers, options);
        const fillSortKey = this.layers[0].layout.get('fill-sort-key');
        const sortFeaturesByKey = !fillSortKey.isConstant();
        const bucketFeatures = [];
        for (const { feature, id, index, sourceLayerIndex } of features) {
            const needGeometry = this.layers[0]._featureFilter.needGeometry;
            const evaluationFeature = toEvaluationFeature(feature, needGeometry);
            if (!this.layers[0]._featureFilter.filter(new EvaluationParameters(this.zoom), evaluationFeature, canonical))
                continue;
            const sortKey = sortFeaturesByKey ?
                fillSortKey.evaluate(evaluationFeature, {}, canonical, options.availableImages) :
                undefined;
            const bucketFeature = {
                id,
                properties: feature.properties,
                type: feature.type,
                sourceLayerIndex,
                index,
                geometry: needGeometry ? evaluationFeature.geometry : loadGeometry(feature),
                patterns: {},
                sortKey
            };
            bucketFeatures.push(bucketFeature);
        }
        if (sortFeaturesByKey) {
            bucketFeatures.sort((a, b) => a.sortKey - b.sortKey);
        }
        for (const bucketFeature of bucketFeatures) {
            const { geometry, index, sourceLayerIndex } = bucketFeature;
            if (this.hasPattern) {
                const patternFeature = addPatternDependencies('fill', this.layers, bucketFeature, this.zoom, options);
                // pattern features are added only once the pattern is loaded into the image atlas
                // so are stored during populate until later updated with positions by tile worker in addFeatures
                this.patternFeatures.push(patternFeature);
            }
            else {
                this.addFeature(bucketFeature, geometry, index, canonical, {});
            }
            const feature = features[index].feature;
            options.featureIndex.insert(feature, geometry, index, sourceLayerIndex, this.index);
        }
    }
    update(states, vtLayer, imagePositions) {
        if (!this.stateDependentLayers.length)
            return;
        this.programConfigurations.updatePaintArrays(states, vtLayer, this.stateDependentLayers, imagePositions);
    }
    addFeatures(options, canonical, imagePositions) {
        for (const feature of this.patternFeatures) {
            this.addFeature(feature, feature.geometry, feature.index, canonical, imagePositions);
        }
    }
    isEmpty() {
        return this.layoutVertexArray.length === 0;
    }
    uploadPending() {
        return !this.uploaded || this.programConfigurations.needsUpload;
    }
    upload(context) {
        if (!this.uploaded) {
            this.layoutVertexBuffer = context.createVertexBuffer(this.layoutVertexArray, members$3);
            this.indexBuffer = context.createIndexBuffer(this.indexArray);
            this.indexBuffer2 = context.createIndexBuffer(this.indexArray2);
        }
        this.programConfigurations.upload(context);
        this.uploaded = true;
    }
    destroy() {
        if (!this.layoutVertexBuffer)
            return;
        this.layoutVertexBuffer.destroy();
        this.indexBuffer.destroy();
        this.indexBuffer2.destroy();
        this.programConfigurations.destroy();
        this.segments.destroy();
        this.segments2.destroy();
    }
    addFeature(feature, geometry, index, canonical, imagePositions) {
        for (const polygon of classifyRings$1(geometry, EARCUT_MAX_RINGS$1)) {
            let numVertices = 0;
            for (const ring of polygon) {
                numVertices += ring.length;
            }
            const triangleSegment = this.segments.prepareSegment(numVertices, this.layoutVertexArray, this.indexArray);
            const triangleIndex = triangleSegment.vertexLength;
            const flattened = [];
            const holeIndices = [];
            for (const ring of polygon) {
                if (ring.length === 0) {
                    continue;
                }
                if (ring !== polygon[0]) {
                    holeIndices.push(flattened.length / 2);
                }
                const lineSegment = this.segments2.prepareSegment(ring.length, this.layoutVertexArray, this.indexArray2);
                const lineIndex = lineSegment.vertexLength;
                this.layoutVertexArray.emplaceBack(ring[0].x, ring[0].y);
                this.indexArray2.emplaceBack(lineIndex + ring.length - 1, lineIndex);
                flattened.push(ring[0].x);
                flattened.push(ring[0].y);
                for (let i = 1; i < ring.length; i++) {
                    this.layoutVertexArray.emplaceBack(ring[i].x, ring[i].y);
                    this.indexArray2.emplaceBack(lineIndex + i - 1, lineIndex + i);
                    flattened.push(ring[i].x);
                    flattened.push(ring[i].y);
                }
                lineSegment.vertexLength += ring.length;
                lineSegment.primitiveLength += ring.length;
            }
            const indices = earcut(flattened, holeIndices);
            for (let i = 0; i < indices.length; i += 3) {
                this.indexArray.emplaceBack(triangleIndex + indices[i], triangleIndex + indices[i + 1], triangleIndex + indices[i + 2]);
            }
            triangleSegment.vertexLength += numVertices;
            triangleSegment.primitiveLength += indices.length / 3;
        }
        this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, feature, index, imagePositions, canonical);
    }
}
register('FillBucket', FillBucket, { omit: ['layers', 'patternFeatures'] });

// This file is generated. Edit build/generate-style-code.ts, then run 'npm run codegen'.
/* eslint-disable */
let layout$3;
const getLayout$2 = () => layout$3 = layout$3 || new Properties({
    "fill-sort-key": new DataDrivenProperty(v8Spec["layout_fill"]["fill-sort-key"]),
});
let paint$5;
const getPaint$5 = () => paint$5 = paint$5 || new Properties({
    "fill-antialias": new DataConstantProperty(v8Spec["paint_fill"]["fill-antialias"]),
    "fill-opacity": new DataDrivenProperty(v8Spec["paint_fill"]["fill-opacity"]),
    "fill-color": new DataDrivenProperty(v8Spec["paint_fill"]["fill-color"]),
    "fill-outline-color": new DataDrivenProperty(v8Spec["paint_fill"]["fill-outline-color"]),
    "fill-translate": new DataConstantProperty(v8Spec["paint_fill"]["fill-translate"]),
    "fill-translate-anchor": new DataConstantProperty(v8Spec["paint_fill"]["fill-translate-anchor"]),
    "fill-pattern": new CrossFadedDataDrivenProperty(v8Spec["paint_fill"]["fill-pattern"]),
});
var properties$5 = ({ get paint() { return getPaint$5(); }, get layout() { return getLayout$2(); } });

class FillStyleLayer extends StyleLayer {
    constructor(layer) {
        super(layer, properties$5);
    }
    recalculate(parameters, availableImages) {
        super.recalculate(parameters, availableImages);
        const outlineColor = this.paint._values['fill-outline-color'];
        if (outlineColor.value.kind === 'constant' && outlineColor.value.value === undefined) {
            this.paint._values['fill-outline-color'] = this.paint._values['fill-color'];
        }
    }
    createBucket(parameters) {
        return new FillBucket(parameters);
    }
    queryRadius() {
        return translateDistance(this.paint.get('fill-translate'));
    }
    queryIntersectsFeature(queryGeometry, feature, featureState, geometry, zoom, transform, pixelsToTileUnits) {
        const translatedPolygon = translate$1(queryGeometry, this.paint.get('fill-translate'), this.paint.get('fill-translate-anchor'), transform.angle, pixelsToTileUnits);
        return polygonIntersectsMultiPolygon(translatedPolygon, geometry);
    }
    isTileClipped() {
        return true;
    }
}

const layout$2 = createLayout([
    { name: 'a_pos', components: 2, type: 'Int16' },
    { name: 'a_normal_ed', components: 4, type: 'Int16' },
], 4);
const centroidAttributes = createLayout([
    { name: 'a_centroid', components: 2, type: 'Int16' }
], 4);
const { members: members$2, size: size$2, alignment: alignment$2 } = layout$2;

var vectorTile = {};

var Point = pointGeometry;

var vectortilefeature = VectorTileFeature$1;

function VectorTileFeature$1(pbf, end, extent, keys, values) {
    // Public
    this.properties = {};
    this.extent = extent;
    this.type = 0;

    // Private
    this._pbf = pbf;
    this._geometry = -1;
    this._keys = keys;
    this._values = values;

    pbf.readFields(readFeature, this, end);
}

function readFeature(tag, feature, pbf) {
    if (tag == 1) feature.id = pbf.readVarint();
    else if (tag == 2) readTag(pbf, feature);
    else if (tag == 3) feature.type = pbf.readVarint();
    else if (tag == 4) feature._geometry = pbf.pos;
}

function readTag(pbf, feature) {
    var end = pbf.readVarint() + pbf.pos;

    while (pbf.pos < end) {
        var key = feature._keys[pbf.readVarint()],
            value = feature._values[pbf.readVarint()];
        feature.properties[key] = value;
    }
}

VectorTileFeature$1.types = ['Unknown', 'Point', 'LineString', 'Polygon'];

VectorTileFeature$1.prototype.loadGeometry = function() {
    var pbf = this._pbf;
    pbf.pos = this._geometry;

    var end = pbf.readVarint() + pbf.pos,
        cmd = 1,
        length = 0,
        x = 0,
        y = 0,
        lines = [],
        line;

    while (pbf.pos < end) {
        if (length <= 0) {
            var cmdLen = pbf.readVarint();
            cmd = cmdLen & 0x7;
            length = cmdLen >> 3;
        }

        length--;

        if (cmd === 1 || cmd === 2) {
            x += pbf.readSVarint();
            y += pbf.readSVarint();

            if (cmd === 1) { // moveTo
                if (line) lines.push(line);
                line = [];
            }

            line.push(new Point(x, y));

        } else if (cmd === 7) {

            // Workaround for https://github.com/mapbox/mapnik-vector-tile/issues/90
            if (line) {
                line.push(line[0].clone()); // closePolygon
            }

        } else {
            throw new Error('unknown command ' + cmd);
        }
    }

    if (line) lines.push(line);

    return lines;
};

VectorTileFeature$1.prototype.bbox = function() {
    var pbf = this._pbf;
    pbf.pos = this._geometry;

    var end = pbf.readVarint() + pbf.pos,
        cmd = 1,
        length = 0,
        x = 0,
        y = 0,
        x1 = Infinity,
        x2 = -Infinity,
        y1 = Infinity,
        y2 = -Infinity;

    while (pbf.pos < end) {
        if (length <= 0) {
            var cmdLen = pbf.readVarint();
            cmd = cmdLen & 0x7;
            length = cmdLen >> 3;
        }

        length--;

        if (cmd === 1 || cmd === 2) {
            x += pbf.readSVarint();
            y += pbf.readSVarint();
            if (x < x1) x1 = x;
            if (x > x2) x2 = x;
            if (y < y1) y1 = y;
            if (y > y2) y2 = y;

        } else if (cmd !== 7) {
            throw new Error('unknown command ' + cmd);
        }
    }

    return [x1, y1, x2, y2];
};

VectorTileFeature$1.prototype.toGeoJSON = function(x, y, z) {
    var size = this.extent * Math.pow(2, z),
        x0 = this.extent * x,
        y0 = this.extent * y,
        coords = this.loadGeometry(),
        type = VectorTileFeature$1.types[this.type],
        i, j;

    function project(line) {
        for (var j = 0; j < line.length; j++) {
            var p = line[j], y2 = 180 - (p.y + y0) * 360 / size;
            line[j] = [
                (p.x + x0) * 360 / size - 180,
                360 / Math.PI * Math.atan(Math.exp(y2 * Math.PI / 180)) - 90
            ];
        }
    }

    switch (this.type) {
    case 1:
        var points = [];
        for (i = 0; i < coords.length; i++) {
            points[i] = coords[i][0];
        }
        coords = points;
        project(coords);
        break;

    case 2:
        for (i = 0; i < coords.length; i++) {
            project(coords[i]);
        }
        break;

    case 3:
        coords = classifyRings(coords);
        for (i = 0; i < coords.length; i++) {
            for (j = 0; j < coords[i].length; j++) {
                project(coords[i][j]);
            }
        }
        break;
    }

    if (coords.length === 1) {
        coords = coords[0];
    } else {
        type = 'Multi' + type;
    }

    var result = {
        type: "Feature",
        geometry: {
            type: type,
            coordinates: coords
        },
        properties: this.properties
    };

    if ('id' in this) {
        result.id = this.id;
    }

    return result;
};

// classifies an array of rings into polygons with outer rings and holes

function classifyRings(rings) {
    var len = rings.length;

    if (len <= 1) return [rings];

    var polygons = [],
        polygon,
        ccw;

    for (var i = 0; i < len; i++) {
        var area = signedArea(rings[i]);
        if (area === 0) continue;

        if (ccw === undefined) ccw = area < 0;

        if (ccw === area < 0) {
            if (polygon) polygons.push(polygon);
            polygon = [rings[i]];

        } else {
            polygon.push(rings[i]);
        }
    }
    if (polygon) polygons.push(polygon);

    return polygons;
}

function signedArea(ring) {
    var sum = 0;
    for (var i = 0, len = ring.length, j = len - 1, p1, p2; i < len; j = i++) {
        p1 = ring[i];
        p2 = ring[j];
        sum += (p2.x - p1.x) * (p1.y + p2.y);
    }
    return sum;
}

var VectorTileFeature = vectortilefeature;

var vectortilelayer = VectorTileLayer$1;

function VectorTileLayer$1(pbf, end) {
    // Public
    this.version = 1;
    this.name = null;
    this.extent = 4096;
    this.length = 0;

    // Private
    this._pbf = pbf;
    this._keys = [];
    this._values = [];
    this._features = [];

    pbf.readFields(readLayer, this, end);

    this.length = this._features.length;
}

function readLayer(tag, layer, pbf) {
    if (tag === 15) layer.version = pbf.readVarint();
    else if (tag === 1) layer.name = pbf.readString();
    else if (tag === 5) layer.extent = pbf.readVarint();
    else if (tag === 2) layer._features.push(pbf.pos);
    else if (tag === 3) layer._keys.push(pbf.readString());
    else if (tag === 4) layer._values.push(readValueMessage(pbf));
}

function readValueMessage(pbf) {
    var value = null,
        end = pbf.readVarint() + pbf.pos;

    while (pbf.pos < end) {
        var tag = pbf.readVarint() >> 3;

        value = tag === 1 ? pbf.readString() :
            tag === 2 ? pbf.readFloat() :
            tag === 3 ? pbf.readDouble() :
            tag === 4 ? pbf.readVarint64() :
            tag === 5 ? pbf.readVarint() :
            tag === 6 ? pbf.readSVarint() :
            tag === 7 ? pbf.readBoolean() : null;
    }

    return value;
}

// return feature `i` from this layer as a `VectorTileFeature`
VectorTileLayer$1.prototype.feature = function(i) {
    if (i < 0 || i >= this._features.length) throw new Error('feature index out of bounds');

    this._pbf.pos = this._features[i];

    var end = this._pbf.readVarint() + this._pbf.pos;
    return new VectorTileFeature(this._pbf, end, this.extent, this._keys, this._values);
};

var VectorTileLayer = vectortilelayer;

var vectortile = VectorTile;

function VectorTile(pbf, end) {
    this.layers = pbf.readFields(readTile, {}, end);
}

function readTile(tag, layers, pbf) {
    if (tag === 3) {
        var layer = new VectorTileLayer(pbf, pbf.readVarint() + pbf.pos);
        if (layer.length) layers[layer.name] = layer;
    }
}

vectorTile.VectorTile = vectortile;
vectorTile.VectorTileFeature = vectortilefeature;
vectorTile.VectorTileLayer = vectortilelayer;

const vectorTileFeatureTypes$2 = vectorTile.VectorTileFeature.types;
const EARCUT_MAX_RINGS = 500;
const FACTOR = Math.pow(2, 13);
function addVertex$1(vertexArray, x, y, nx, ny, nz, t, e) {
    vertexArray.emplaceBack(
    // a_pos
    x, y, 
    // a_normal_ed: 3-component normal and 1-component edgedistance
    Math.floor(nx * FACTOR) * 2 + t, ny * FACTOR * 2, nz * FACTOR * 2, 
    // edgedistance (used for wrapping patterns around extrusion sides)
    Math.round(e));
}
class FillExtrusionBucket {
    constructor(options) {
        this.zoom = options.zoom;
        this.overscaling = options.overscaling;
        this.layers = options.layers;
        this.layerIds = this.layers.map(layer => layer.id);
        this.index = options.index;
        this.hasPattern = false;
        this.layoutVertexArray = new FillExtrusionLayoutArray();
        this.centroidVertexArray = new PosArray();
        this.indexArray = new TriangleIndexArray();
        this.programConfigurations = new ProgramConfigurationSet(options.layers, options.zoom);
        this.segments = new SegmentVector();
        this.stateDependentLayerIds = this.layers.filter((l) => l.isStateDependent()).map((l) => l.id);
    }
    populate(features, options, canonical) {
        this.features = [];
        this.hasPattern = hasPattern('fill-extrusion', this.layers, options);
        for (const { feature, id, index, sourceLayerIndex } of features) {
            const needGeometry = this.layers[0]._featureFilter.needGeometry;
            const evaluationFeature = toEvaluationFeature(feature, needGeometry);
            if (!this.layers[0]._featureFilter.filter(new EvaluationParameters(this.zoom), evaluationFeature, canonical))
                continue;
            const bucketFeature = {
                id,
                sourceLayerIndex,
                index,
                geometry: needGeometry ? evaluationFeature.geometry : loadGeometry(feature),
                properties: feature.properties,
                type: feature.type,
                patterns: {}
            };
            if (this.hasPattern) {
                this.features.push(addPatternDependencies('fill-extrusion', this.layers, bucketFeature, this.zoom, options));
            }
            else {
                this.addFeature(bucketFeature, bucketFeature.geometry, index, canonical, {});
            }
            options.featureIndex.insert(feature, bucketFeature.geometry, index, sourceLayerIndex, this.index, true);
        }
    }
    addFeatures(options, canonical, imagePositions) {
        for (const feature of this.features) {
            const { geometry } = feature;
            this.addFeature(feature, geometry, feature.index, canonical, imagePositions);
        }
    }
    update(states, vtLayer, imagePositions) {
        if (!this.stateDependentLayers.length)
            return;
        this.programConfigurations.updatePaintArrays(states, vtLayer, this.stateDependentLayers, imagePositions);
    }
    isEmpty() {
        return this.layoutVertexArray.length === 0 && this.centroidVertexArray.length === 0;
    }
    uploadPending() {
        return !this.uploaded || this.programConfigurations.needsUpload;
    }
    upload(context) {
        if (!this.uploaded) {
            this.layoutVertexBuffer = context.createVertexBuffer(this.layoutVertexArray, members$2);
            this.centroidVertexBuffer = context.createVertexBuffer(this.centroidVertexArray, centroidAttributes.members, true);
            this.indexBuffer = context.createIndexBuffer(this.indexArray);
        }
        this.programConfigurations.upload(context);
        this.uploaded = true;
    }
    destroy() {
        if (!this.layoutVertexBuffer)
            return;
        this.layoutVertexBuffer.destroy();
        this.indexBuffer.destroy();
        this.programConfigurations.destroy();
        this.segments.destroy();
        this.centroidVertexBuffer.destroy();
    }
    addFeature(feature, geometry, index, canonical, imagePositions) {
        for (const polygon of classifyRings$1(geometry, EARCUT_MAX_RINGS)) {
            const centroid = { x: 0, y: 0, vertexCount: 0 };
            let numVertices = 0;
            for (const ring of polygon) {
                numVertices += ring.length;
            }
            let segment = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray);
            for (const ring of polygon) {
                if (ring.length === 0) {
                    continue;
                }
                if (isEntirelyOutside(ring)) {
                    continue;
                }
                let edgeDistance = 0;
                for (let p = 0; p < ring.length; p++) {
                    const p1 = ring[p];
                    if (p >= 1) {
                        const p2 = ring[p - 1];
                        if (!isBoundaryEdge(p1, p2)) {
                            if (segment.vertexLength + 4 > SegmentVector.MAX_VERTEX_ARRAY_LENGTH) {
                                segment = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray);
                            }
                            const perp = p1.sub(p2)._perp()._unit();
                            const dist = p2.dist(p1);
                            if (edgeDistance + dist > 32768)
                                edgeDistance = 0;
                            addVertex$1(this.layoutVertexArray, p1.x, p1.y, perp.x, perp.y, 0, 0, edgeDistance);
                            addVertex$1(this.layoutVertexArray, p1.x, p1.y, perp.x, perp.y, 0, 1, edgeDistance);
                            centroid.x += 2 * p1.x;
                            centroid.y += 2 * p1.y;
                            centroid.vertexCount += 2;
                            edgeDistance += dist;
                            addVertex$1(this.layoutVertexArray, p2.x, p2.y, perp.x, perp.y, 0, 0, edgeDistance);
                            addVertex$1(this.layoutVertexArray, p2.x, p2.y, perp.x, perp.y, 0, 1, edgeDistance);
                            centroid.x += 2 * p2.x;
                            centroid.y += 2 * p2.y;
                            centroid.vertexCount += 2;
                            const bottomRight = segment.vertexLength;
                            // ┌──────┐
                            // │ 0  1 │ Counter-clockwise winding order.
                            // │      │ Triangle 1: 0 => 2 => 1
                            // │ 2  3 │ Triangle 2: 1 => 2 => 3
                            // └──────┘
                            this.indexArray.emplaceBack(bottomRight, bottomRight + 2, bottomRight + 1);
                            this.indexArray.emplaceBack(bottomRight + 1, bottomRight + 2, bottomRight + 3);
                            segment.vertexLength += 4;
                            segment.primitiveLength += 2;
                        }
                    }
                }
            }
            if (segment.vertexLength + numVertices > SegmentVector.MAX_VERTEX_ARRAY_LENGTH) {
                segment = this.segments.prepareSegment(numVertices, this.layoutVertexArray, this.indexArray);
            }
            //Only triangulate and draw the area of the feature if it is a polygon
            //Other feature types (e.g. LineString) do not have area, so triangulation is pointless / undefined
            if (vectorTileFeatureTypes$2[feature.type] !== 'Polygon')
                continue;
            const flattened = [];
            const holeIndices = [];
            const triangleIndex = segment.vertexLength;
            for (const ring of polygon) {
                if (ring.length === 0) {
                    continue;
                }
                if (ring !== polygon[0]) {
                    holeIndices.push(flattened.length / 2);
                }
                for (let i = 0; i < ring.length; i++) {
                    const p = ring[i];
                    addVertex$1(this.layoutVertexArray, p.x, p.y, 0, 0, 1, 1, 0);
                    centroid.x += p.x;
                    centroid.y += p.y;
                    centroid.vertexCount += 1;
                    flattened.push(p.x);
                    flattened.push(p.y);
                }
            }
            const indices = earcut(flattened, holeIndices);
            for (let j = 0; j < indices.length; j += 3) {
                // Counter-clockwise winding order.
                this.indexArray.emplaceBack(triangleIndex + indices[j], triangleIndex + indices[j + 2], triangleIndex + indices[j + 1]);
            }
            segment.primitiveLength += indices.length / 3;
            segment.vertexLength += numVertices;
            // remember polygon centroid to calculate elevation in GPU
            for (let i = 0; i < centroid.vertexCount; i++) {
                const averageX = Math.floor(centroid.x / centroid.vertexCount);
                const averageY = Math.floor(centroid.y / centroid.vertexCount);
                this.centroidVertexArray.emplaceBack(averageX, averageY);
            }
        }
        this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, feature, index, imagePositions, canonical);
    }
}
register('FillExtrusionBucket', FillExtrusionBucket, { omit: ['layers', 'features'] });
function isBoundaryEdge(p1, p2) {
    return (p1.x === p2.x && (p1.x < 0 || p1.x > EXTENT)) ||
        (p1.y === p2.y && (p1.y < 0 || p1.y > EXTENT));
}
function isEntirelyOutside(ring) {
    return ring.every(p => p.x < 0) ||
        ring.every(p => p.x > EXTENT) ||
        ring.every(p => p.y < 0) ||
        ring.every(p => p.y > EXTENT);
}

// This file is generated. Edit build/generate-style-code.ts, then run 'npm run codegen'.
/* eslint-disable */
let paint$4;
const getPaint$4 = () => paint$4 = paint$4 || new Properties({
    "fill-extrusion-opacity": new DataConstantProperty(v8Spec["paint_fill-extrusion"]["fill-extrusion-opacity"]),
    "fill-extrusion-color": new DataDrivenProperty(v8Spec["paint_fill-extrusion"]["fill-extrusion-color"]),
    "fill-extrusion-translate": new DataConstantProperty(v8Spec["paint_fill-extrusion"]["fill-extrusion-translate"]),
    "fill-extrusion-translate-anchor": new DataConstantProperty(v8Spec["paint_fill-extrusion"]["fill-extrusion-translate-anchor"]),
    "fill-extrusion-pattern": new CrossFadedDataDrivenProperty(v8Spec["paint_fill-extrusion"]["fill-extrusion-pattern"]),
    "fill-extrusion-height": new DataDrivenProperty(v8Spec["paint_fill-extrusion"]["fill-extrusion-height"]),
    "fill-extrusion-base": new DataDrivenProperty(v8Spec["paint_fill-extrusion"]["fill-extrusion-base"]),
    "fill-extrusion-vertical-gradient": new DataConstantProperty(v8Spec["paint_fill-extrusion"]["fill-extrusion-vertical-gradient"]),
});
var properties$4 = ({ get paint() { return getPaint$4(); } });

class FillExtrusionStyleLayer extends StyleLayer {
    constructor(layer) {
        super(layer, properties$4);
    }
    createBucket(parameters) {
        return new FillExtrusionBucket(parameters);
    }
    queryRadius() {
        return translateDistance(this.paint.get('fill-extrusion-translate'));
    }
    is3D() {
        return true;
    }
    queryIntersectsFeature(queryGeometry, feature, featureState, geometry, zoom, transform, pixelsToTileUnits, pixelPosMatrix) {
        const translatedPolygon = translate$1(queryGeometry, this.paint.get('fill-extrusion-translate'), this.paint.get('fill-extrusion-translate-anchor'), transform.angle, pixelsToTileUnits);
        const height = this.paint.get('fill-extrusion-height').evaluate(feature, featureState);
        const base = this.paint.get('fill-extrusion-base').evaluate(feature, featureState);
        const projectedQueryGeometry = projectQueryGeometry(translatedPolygon, pixelPosMatrix, transform, 0);
        const projected = projectExtrusion(geometry, base, height, pixelPosMatrix);
        const projectedBase = projected[0];
        const projectedTop = projected[1];
        return checkIntersection(projectedBase, projectedTop, projectedQueryGeometry);
    }
}
function dot(a, b) {
    return a.x * b.x + a.y * b.y;
}
function getIntersectionDistance(projectedQueryGeometry, projectedFace) {
    if (projectedQueryGeometry.length === 1) {
        // For point queries calculate the z at which the point intersects the face
        // using barycentric coordinates.
        // Find the barycentric coordinates of the projected point within the first
        // triangle of the face, using only the xy plane. It doesn't matter if the
        // point is outside the first triangle because all the triangles in the face
        // are in the same plane.
        //
        // Check whether points are coincident and use other points if they are.
        let i = 0;
        const a = projectedFace[i++];
        let b;
        while (!b || a.equals(b)) {
            b = projectedFace[i++];
            if (!b)
                return Infinity;
        }
        // Loop until point `c` is not colinear with points `a` and `b`.
        for (; i < projectedFace.length; i++) {
            const c = projectedFace[i];
            const p = projectedQueryGeometry[0];
            const ab = b.sub(a);
            const ac = c.sub(a);
            const ap = p.sub(a);
            const dotABAB = dot(ab, ab);
            const dotABAC = dot(ab, ac);
            const dotACAC = dot(ac, ac);
            const dotAPAB = dot(ap, ab);
            const dotAPAC = dot(ap, ac);
            const denom = dotABAB * dotACAC - dotABAC * dotABAC;
            const v = (dotACAC * dotAPAB - dotABAC * dotAPAC) / denom;
            const w = (dotABAB * dotAPAC - dotABAC * dotAPAB) / denom;
            const u = 1 - v - w;
            // Use the barycentric weighting along with the original triangle z coordinates to get the point of intersection.
            const distance = a.z * u + b.z * v + c.z * w;
            if (isFinite(distance))
                return distance;
        }
        return Infinity;
    }
    else {
        // The counts as closest is less clear when the query is a box. This
        // returns the distance to the nearest point on the face, whether it is
        // within the query or not. It could be more correct to return the
        // distance to the closest point within the query box but this would be
        // more complicated and expensive to calculate with little benefit.
        let closestDistance = Infinity;
        for (const p of projectedFace) {
            closestDistance = Math.min(closestDistance, p.z);
        }
        return closestDistance;
    }
}
function checkIntersection(projectedBase, projectedTop, projectedQueryGeometry) {
    let closestDistance = Infinity;
    if (polygonIntersectsMultiPolygon(projectedQueryGeometry, projectedTop)) {
        closestDistance = getIntersectionDistance(projectedQueryGeometry, projectedTop[0]);
    }
    for (let r = 0; r < projectedTop.length; r++) {
        const ringTop = projectedTop[r];
        const ringBase = projectedBase[r];
        for (let p = 0; p < ringTop.length - 1; p++) {
            const topA = ringTop[p];
            const topB = ringTop[p + 1];
            const baseA = ringBase[p];
            const baseB = ringBase[p + 1];
            const face = [topA, topB, baseB, baseA, topA];
            if (polygonIntersectsPolygon(projectedQueryGeometry, face)) {
                closestDistance = Math.min(closestDistance, getIntersectionDistance(projectedQueryGeometry, face));
            }
        }
    }
    return closestDistance === Infinity ? false : closestDistance;
}
/*
 * Project the geometry using matrix `m`. This is essentially doing
 * `vec4.transformMat4([], [p.x, p.y, z, 1], m)` but the multiplication
 * is inlined so that parts of the projection that are the same across
 * different points can only be done once. This produced a measurable
 * performance improvement.
 */
function projectExtrusion(geometry, zBase, zTop, m) {
    const projectedBase = [];
    const projectedTop = [];
    const baseXZ = m[8] * zBase;
    const baseYZ = m[9] * zBase;
    const baseZZ = m[10] * zBase;
    const baseWZ = m[11] * zBase;
    const topXZ = m[8] * zTop;
    const topYZ = m[9] * zTop;
    const topZZ = m[10] * zTop;
    const topWZ = m[11] * zTop;
    for (const r of geometry) {
        const ringBase = [];
        const ringTop = [];
        for (const p of r) {
            const x = p.x;
            const y = p.y;
            const sX = m[0] * x + m[4] * y + m[12];
            const sY = m[1] * x + m[5] * y + m[13];
            const sZ = m[2] * x + m[6] * y + m[14];
            const sW = m[3] * x + m[7] * y + m[15];
            const baseX = sX + baseXZ;
            const baseY = sY + baseYZ;
            const baseZ = sZ + baseZZ;
            const baseW = sW + baseWZ;
            const topX = sX + topXZ;
            const topY = sY + topYZ;
            const topZ = sZ + topZZ;
            const topW = sW + topWZ;
            const b = new Point$2(baseX / baseW, baseY / baseW);
            b.z = baseZ / baseW;
            ringBase.push(b);
            const t = new Point$2(topX / topW, topY / topW);
            t.z = topZ / topW;
            ringTop.push(t);
        }
        projectedBase.push(ringBase);
        projectedTop.push(ringTop);
    }
    return [projectedBase, projectedTop];
}
function projectQueryGeometry(queryGeometry, pixelPosMatrix, transform, z) {
    const projectedQueryGeometry = [];
    for (const p of queryGeometry) {
        const v = [p.x, p.y, z, 1];
        transformMat4(v, v, pixelPosMatrix);
        projectedQueryGeometry.push(new Point$2(v[0] / v[3], v[1] / v[3]));
    }
    return projectedQueryGeometry;
}

const lineLayoutAttributes = createLayout([
    { name: 'a_pos_normal', components: 2, type: 'Int16' },
    { name: 'a_data', components: 4, type: 'Uint8' }
], 4);
const { members: members$1, size: size$1, alignment: alignment$1 } = lineLayoutAttributes;

const lineLayoutAttributesExt = createLayout([
    { name: 'a_uv_x', components: 1, type: 'Float32' },
    { name: 'a_split_index', components: 1, type: 'Float32' },
]);
const { members, size, alignment } = lineLayoutAttributesExt;

const vectorTileFeatureTypes$1 = vectorTile.VectorTileFeature.types;
// NOTE ON EXTRUDE SCALE:
// scale the extrusion vector so that the normal length is this value.
// contains the "texture" normals (-1..1). this is distinct from the extrude
// normals for line joins, because the x-value remains 0 for the texture
// normal array, while the extrude normal actually moves the vertex to create
// the acute/bevelled line join.
const EXTRUDE_SCALE = 63;
/*
 * Sharp corners cause dashed lines to tilt because the distance along the line
 * is the same at both the inner and outer corners. To improve the appearance of
 * dashed lines we add extra points near sharp corners so that a smaller part
 * of the line is tilted.
 *
 * COS_HALF_SHARP_CORNER controls how sharp a corner has to be for us to add an
 * extra vertex. The default is 75 degrees.
 *
 * The newly created vertices are placed SHARP_CORNER_OFFSET pixels from the corner.
 */
const COS_HALF_SHARP_CORNER = Math.cos(75 / 2 * (Math.PI / 180));
const SHARP_CORNER_OFFSET = 15;
// Angle per triangle for approximating round line joins.
const DEG_PER_TRIANGLE = 20;
// The number of bits that is used to store the line distance in the buffer.
const LINE_DISTANCE_BUFFER_BITS = 15;
// We don't have enough bits for the line distance as we'd like to have, so
// use this value to scale the line distance (in tile units) down to a smaller
// value. This lets us store longer distances while sacrificing precision.
const LINE_DISTANCE_SCALE = 1 / 2;
// The maximum line distance, in tile units, that fits in the buffer.
const MAX_LINE_DISTANCE = Math.pow(2, LINE_DISTANCE_BUFFER_BITS - 1) / LINE_DISTANCE_SCALE;
/**
 * @internal
 * Line bucket class
 */
class LineBucket {
    constructor(options) {
        this.zoom = options.zoom;
        this.overscaling = options.overscaling;
        this.layers = options.layers;
        this.layerIds = this.layers.map(layer => layer.id);
        this.index = options.index;
        this.hasPattern = false;
        this.patternFeatures = [];
        this.lineClipsArray = [];
        this.gradients = {};
        this.layers.forEach(layer => {
            this.gradients[layer.id] = {};
        });
        this.layoutVertexArray = new LineLayoutArray();
        this.layoutVertexArray2 = new LineExtLayoutArray();
        this.indexArray = new TriangleIndexArray();
        this.programConfigurations = new ProgramConfigurationSet(options.layers, options.zoom);
        this.segments = new SegmentVector();
        this.maxLineLength = 0;
        this.stateDependentLayerIds = this.layers.filter((l) => l.isStateDependent()).map((l) => l.id);
    }
    populate(features, options, canonical) {
        this.hasPattern = hasPattern('line', this.layers, options);
        const lineSortKey = this.layers[0].layout.get('line-sort-key');
        const sortFeaturesByKey = !lineSortKey.isConstant();
        const bucketFeatures = [];
        for (const { feature, id, index, sourceLayerIndex } of features) {
            const needGeometry = this.layers[0]._featureFilter.needGeometry;
            const evaluationFeature = toEvaluationFeature(feature, needGeometry);
            if (!this.layers[0]._featureFilter.filter(new EvaluationParameters(this.zoom), evaluationFeature, canonical))
                continue;
            const sortKey = sortFeaturesByKey ?
                lineSortKey.evaluate(evaluationFeature, {}, canonical) :
                undefined;
            const bucketFeature = {
                id,
                properties: feature.properties,
                type: feature.type,
                sourceLayerIndex,
                index,
                geometry: needGeometry ? evaluationFeature.geometry : loadGeometry(feature),
                patterns: {},
                sortKey
            };
            bucketFeatures.push(bucketFeature);
        }
        if (sortFeaturesByKey) {
            bucketFeatures.sort((a, b) => {
                return (a.sortKey) - (b.sortKey);
            });
        }
        for (const bucketFeature of bucketFeatures) {
            const { geometry, index, sourceLayerIndex } = bucketFeature;
            if (this.hasPattern) {
                const patternBucketFeature = addPatternDependencies('line', this.layers, bucketFeature, this.zoom, options);
                // pattern features are added only once the pattern is loaded into the image atlas
                // so are stored during populate until later updated with positions by tile worker in addFeatures
                this.patternFeatures.push(patternBucketFeature);
            }
            else {
                this.addFeature(bucketFeature, geometry, index, canonical, {});
            }
            const feature = features[index].feature;
            options.featureIndex.insert(feature, geometry, index, sourceLayerIndex, this.index);
        }
    }
    update(states, vtLayer, imagePositions) {
        if (!this.stateDependentLayers.length)
            return;
        this.programConfigurations.updatePaintArrays(states, vtLayer, this.stateDependentLayers, imagePositions);
    }
    addFeatures(options, canonical, imagePositions) {
        for (const feature of this.patternFeatures) {
            this.addFeature(feature, feature.geometry, feature.index, canonical, imagePositions);
        }
    }
    isEmpty() {
        return this.layoutVertexArray.length === 0;
    }
    uploadPending() {
        return !this.uploaded || this.programConfigurations.needsUpload;
    }
    upload(context) {
        if (!this.uploaded) {
            if (this.layoutVertexArray2.length !== 0) {
                this.layoutVertexBuffer2 = context.createVertexBuffer(this.layoutVertexArray2, members);
            }
            this.layoutVertexBuffer = context.createVertexBuffer(this.layoutVertexArray, members$1);
            this.indexBuffer = context.createIndexBuffer(this.indexArray);
        }
        this.programConfigurations.upload(context);
        this.uploaded = true;
    }
    destroy() {
        if (!this.layoutVertexBuffer)
            return;
        this.layoutVertexBuffer.destroy();
        this.indexBuffer.destroy();
        this.programConfigurations.destroy();
        this.segments.destroy();
    }
    lineFeatureClips(feature) {
        if (!!feature.properties && Object.prototype.hasOwnProperty.call(feature.properties, 'mapbox_clip_start') && Object.prototype.hasOwnProperty.call(feature.properties, 'mapbox_clip_end')) {
            const start = +feature.properties['mapbox_clip_start'];
            const end = +feature.properties['mapbox_clip_end'];
            return { start, end };
        }
    }
    addFeature(feature, geometry, index, canonical, imagePositions) {
        const layout = this.layers[0].layout;
        const join = layout.get('line-join').evaluate(feature, {});
        const cap = layout.get('line-cap');
        const miterLimit = layout.get('line-miter-limit');
        const roundLimit = layout.get('line-round-limit');
        this.lineClips = this.lineFeatureClips(feature);
        for (const line of geometry) {
            this.addLine(line, feature, join, cap, miterLimit, roundLimit);
        }
        this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, feature, index, imagePositions, canonical);
    }
    addLine(vertices, feature, join, cap, miterLimit, roundLimit) {
        this.distance = 0;
        this.scaledDistance = 0;
        this.totalDistance = 0;
        if (this.lineClips) {
            this.lineClipsArray.push(this.lineClips);
            // Calculate the total distance, in tile units, of this tiled line feature
            for (let i = 0; i < vertices.length - 1; i++) {
                this.totalDistance += vertices[i].dist(vertices[i + 1]);
            }
            this.updateScaledDistance();
            this.maxLineLength = Math.max(this.maxLineLength, this.totalDistance);
        }
        const isPolygon = vectorTileFeatureTypes$1[feature.type] === 'Polygon';
        // If the line has duplicate vertices at the ends, adjust start/length to remove them.
        let len = vertices.length;
        while (len >= 2 && vertices[len - 1].equals(vertices[len - 2])) {
            len--;
        }
        let first = 0;
        while (first < len - 1 && vertices[first].equals(vertices[first + 1])) {
            first++;
        }
        // Ignore invalid geometry.
        if (len < (isPolygon ? 3 : 2))
            return;
        if (join === 'bevel')
            miterLimit = 1.05;
        const sharpCornerOffset = this.overscaling <= 16 ?
            SHARP_CORNER_OFFSET * EXTENT / (512 * this.overscaling) :
            0;
        // we could be more precise, but it would only save a negligible amount of space
        const segment = this.segments.prepareSegment(len * 10, this.layoutVertexArray, this.indexArray);
        let currentVertex;
        let prevVertex;
        let nextVertex;
        let prevNormal;
        let nextNormal;
        // the last two vertices added
        this.e1 = this.e2 = -1;
        if (isPolygon) {
            currentVertex = vertices[len - 2];
            nextNormal = vertices[first].sub(currentVertex)._unit()._perp();
        }
        for (let i = first; i < len; i++) {
            nextVertex = i === len - 1 ?
                (isPolygon ? vertices[first + 1] : undefined) : // if it's a polygon, treat the last vertex like the first
                vertices[i + 1]; // just the next vertex
            // if two consecutive vertices exist, skip the current one
            if (nextVertex && vertices[i].equals(nextVertex))
                continue;
            if (nextNormal)
                prevNormal = nextNormal;
            if (currentVertex)
                prevVertex = currentVertex;
            currentVertex = vertices[i];
            // Calculate the normal towards the next vertex in this line. In case
            // there is no next vertex, pretend that the line is continuing straight,
            // meaning that we are just using the previous normal.
            nextNormal = nextVertex ? nextVertex.sub(currentVertex)._unit()._perp() : prevNormal;
            // If we still don't have a previous normal, this is the beginning of a
            // non-closed line, so we're doing a straight "join".
            prevNormal = prevNormal || nextNormal;
            // Determine the normal of the join extrusion. It is the angle bisector
            // of the segments between the previous line and the next line.
            // In the case of 180° angles, the prev and next normals cancel each other out:
            // prevNormal + nextNormal = (0, 0), its magnitude is 0, so the unit vector would be
            // undefined. In that case, we're keeping the joinNormal at (0, 0), so that the cosHalfAngle
            // below will also become 0 and miterLength will become Infinity.
            let joinNormal = prevNormal.add(nextNormal);
            if (joinNormal.x !== 0 || joinNormal.y !== 0) {
                joinNormal._unit();
            }
            /*  joinNormal     prevNormal
             *             ↖      ↑
             *                .________. prevVertex
             *                |
             * nextNormal  ←  |  currentVertex
             *                |
             *     nextVertex !
             *
             */
            // calculate cosines of the angle (and its half) using dot product
            const cosAngle = prevNormal.x * nextNormal.x + prevNormal.y * nextNormal.y;
            const cosHalfAngle = joinNormal.x * nextNormal.x + joinNormal.y * nextNormal.y;
            // Calculate the length of the miter (the ratio of the miter to the width)
            // as the inverse of cosine of the angle between next and join normals
            const miterLength = cosHalfAngle !== 0 ? 1 / cosHalfAngle : Infinity;
            // approximate angle from cosine
            const approxAngle = 2 * Math.sqrt(2 - 2 * cosHalfAngle);
            const isSharpCorner = cosHalfAngle < COS_HALF_SHARP_CORNER && prevVertex && nextVertex;
            const lineTurnsLeft = prevNormal.x * nextNormal.y - prevNormal.y * nextNormal.x > 0;
            if (isSharpCorner && i > first) {
                const prevSegmentLength = currentVertex.dist(prevVertex);
                if (prevSegmentLength > 2 * sharpCornerOffset) {
                    const newPrevVertex = currentVertex.sub(currentVertex.sub(prevVertex)._mult(sharpCornerOffset / prevSegmentLength)._round());
                    this.updateDistance(prevVertex, newPrevVertex);
                    this.addCurrentVertex(newPrevVertex, prevNormal, 0, 0, segment);
                    prevVertex = newPrevVertex;
                }
            }
            // The join if a middle vertex, otherwise the cap.
            const middleVertex = prevVertex && nextVertex;
            let currentJoin = middleVertex ? join : isPolygon ? 'butt' : cap;
            if (middleVertex && currentJoin === 'round') {
                if (miterLength < roundLimit) {
                    currentJoin = 'miter';
                }
                else if (miterLength <= 2) {
                    currentJoin = 'fakeround';
                }
            }
            if (currentJoin === 'miter' && miterLength > miterLimit) {
                currentJoin = 'bevel';
            }
            if (currentJoin === 'bevel') {
                // The maximum extrude length is 128 / 63 = 2 times the width of the line
                // so if miterLength >= 2 we need to draw a different type of bevel here.
                if (miterLength > 2)
                    currentJoin = 'flipbevel';
                // If the miterLength is really small and the line bevel wouldn't be visible,
                // just draw a miter join to save a triangle.
                if (miterLength < miterLimit)
                    currentJoin = 'miter';
            }
            // Calculate how far along the line the currentVertex is
            if (prevVertex)
                this.updateDistance(prevVertex, currentVertex);
            if (currentJoin === 'miter') {
                joinNormal._mult(miterLength);
                this.addCurrentVertex(currentVertex, joinNormal, 0, 0, segment);
            }
            else if (currentJoin === 'flipbevel') {
                // miter is too big, flip the direction to make a beveled join
                if (miterLength > 100) {
                    // Almost parallel lines
                    joinNormal = nextNormal.mult(-1);
                }
                else {
                    const bevelLength = miterLength * prevNormal.add(nextNormal).mag() / prevNormal.sub(nextNormal).mag();
                    joinNormal._perp()._mult(bevelLength * (lineTurnsLeft ? -1 : 1));
                }
                this.addCurrentVertex(currentVertex, joinNormal, 0, 0, segment);
                this.addCurrentVertex(currentVertex, joinNormal.mult(-1), 0, 0, segment);
            }
            else if (currentJoin === 'bevel' || currentJoin === 'fakeround') {
                const offset = -Math.sqrt(miterLength * miterLength - 1);
                const offsetA = lineTurnsLeft ? offset : 0;
                const offsetB = lineTurnsLeft ? 0 : offset;
                // Close previous segment with a bevel
                if (prevVertex) {
                    this.addCurrentVertex(currentVertex, prevNormal, offsetA, offsetB, segment);
                }
                if (currentJoin === 'fakeround') {
                    // The join angle is sharp enough that a round join would be visible.
                    // Bevel joins fill the gap between segments with a single pie slice triangle.
                    // Create a round join by adding multiple pie slices. The join isn't actually round, but
                    // it looks like it is at the sizes we render lines at.
                    // pick the number of triangles for approximating round join by based on the angle between normals
                    const n = Math.round((approxAngle * 180 / Math.PI) / DEG_PER_TRIANGLE);
                    for (let m = 1; m < n; m++) {
                        let t = m / n;
                        if (t !== 0.5) {
                            // approximate spherical interpolation https://observablehq.com/@mourner/approximating-geometric-slerp
                            const t2 = t - 0.5;
                            const A = 1.0904 + cosAngle * (-3.2452 + cosAngle * (3.55645 - cosAngle * 1.43519));
                            const B = 0.848013 + cosAngle * (-1.06021 + cosAngle * 0.215638);
                            t = t + t * t2 * (t - 1) * (A * t2 * t2 + B);
                        }
                        const extrude = nextNormal.sub(prevNormal)._mult(t)._add(prevNormal)._unit()._mult(lineTurnsLeft ? -1 : 1);
                        this.addHalfVertex(currentVertex, extrude.x, extrude.y, false, lineTurnsLeft, 0, segment);
                    }
                }
                if (nextVertex) {
                    // Start next segment
                    this.addCurrentVertex(currentVertex, nextNormal, -offsetA, -offsetB, segment);
                }
            }
            else if (currentJoin === 'butt') {
                this.addCurrentVertex(currentVertex, joinNormal, 0, 0, segment); // butt cap
            }
            else if (currentJoin === 'square') {
                const offset = prevVertex ? 1 : -1; // closing or starting square cap
                this.addCurrentVertex(currentVertex, joinNormal, offset, offset, segment);
            }
            else if (currentJoin === 'round') {
                if (prevVertex) {
                    // Close previous segment with butt
                    this.addCurrentVertex(currentVertex, prevNormal, 0, 0, segment);
                    // Add round cap or linejoin at end of segment
                    this.addCurrentVertex(currentVertex, prevNormal, 1, 1, segment, true);
                }
                if (nextVertex) {
                    // Add round cap before first segment
                    this.addCurrentVertex(currentVertex, nextNormal, -1, -1, segment, true);
                    // Start next segment with a butt
                    this.addCurrentVertex(currentVertex, nextNormal, 0, 0, segment);
                }
            }
            if (isSharpCorner && i < len - 1) {
                const nextSegmentLength = currentVertex.dist(nextVertex);
                if (nextSegmentLength > 2 * sharpCornerOffset) {
                    const newCurrentVertex = currentVertex.add(nextVertex.sub(currentVertex)._mult(sharpCornerOffset / nextSegmentLength)._round());
                    this.updateDistance(currentVertex, newCurrentVertex);
                    this.addCurrentVertex(newCurrentVertex, nextNormal, 0, 0, segment);
                    currentVertex = newCurrentVertex;
                }
            }
        }
    }
    /**
     * Add two vertices to the buffers.
     *
     * @param p - the line vertex to add buffer vertices for
     * @param normal - vertex normal
     * @param endLeft - extrude to shift the left vertex along the line
     * @param endRight - extrude to shift the left vertex along the line
     * @param segment - the segment object to add the vertex to
     * @param round - whether this is a round cap
     */
    addCurrentVertex(p, normal, endLeft, endRight, segment, round = false) {
        // left and right extrude vectors, perpendicularly shifted by endLeft/endRight
        const leftX = normal.x + normal.y * endLeft;
        const leftY = normal.y - normal.x * endLeft;
        const rightX = -normal.x + normal.y * endRight;
        const rightY = -normal.y - normal.x * endRight;
        this.addHalfVertex(p, leftX, leftY, round, false, endLeft, segment);
        this.addHalfVertex(p, rightX, rightY, round, true, -endRight, segment);
        // There is a maximum "distance along the line" that we can store in the buffers.
        // When we get close to the distance, reset it to zero and add the vertex again with
        // a distance of zero. The max distance is determined by the number of bits we allocate
        // to `linesofar`.
        if (this.distance > MAX_LINE_DISTANCE / 2 && this.totalDistance === 0) {
            this.distance = 0;
            this.updateScaledDistance();
            this.addCurrentVertex(p, normal, endLeft, endRight, segment, round);
        }
    }
    addHalfVertex({ x, y }, extrudeX, extrudeY, round, up, dir, segment) {
        const totalDistance = this.lineClips ? this.scaledDistance * (MAX_LINE_DISTANCE - 1) : this.scaledDistance;
        // scale down so that we can store longer distances while sacrificing precision.
        const linesofarScaled = totalDistance * LINE_DISTANCE_SCALE;
        this.layoutVertexArray.emplaceBack(
        // a_pos_normal
        // Encode round/up the least significant bits
        (x << 1) + (round ? 1 : 0), (y << 1) + (up ? 1 : 0), 
        // a_data
        // add 128 to store a byte in an unsigned byte
        Math.round(EXTRUDE_SCALE * extrudeX) + 128, Math.round(EXTRUDE_SCALE * extrudeY) + 128, 
        // Encode the -1/0/1 direction value into the first two bits of .z of a_data.
        // Combine it with the lower 6 bits of `linesofarScaled` (shifted by 2 bits to make
        // room for the direction value). The upper 8 bits of `linesofarScaled` are placed in
        // the `w` component.
        ((dir === 0 ? 0 : (dir < 0 ? -1 : 1)) + 1) | ((linesofarScaled & 0x3F) << 2), linesofarScaled >> 6);
        // Constructs a second vertex buffer with higher precision line progress
        if (this.lineClips) {
            const progressRealigned = this.scaledDistance - this.lineClips.start;
            const endClipRealigned = this.lineClips.end - this.lineClips.start;
            const uvX = progressRealigned / endClipRealigned;
            this.layoutVertexArray2.emplaceBack(uvX, this.lineClipsArray.length);
        }
        const e = segment.vertexLength++;
        if (this.e1 >= 0 && this.e2 >= 0) {
            this.indexArray.emplaceBack(this.e1, this.e2, e);
            segment.primitiveLength++;
        }
        if (up) {
            this.e2 = e;
        }
        else {
            this.e1 = e;
        }
    }
    updateScaledDistance() {
        // Knowing the ratio of the full linestring covered by this tiled feature, as well
        // as the total distance (in tile units) of this tiled feature, and the distance
        // (in tile units) of the current vertex, we can determine the relative distance
        // of this vertex along the full linestring feature and scale it to [0, 2^15)
        this.scaledDistance = this.lineClips ?
            this.lineClips.start + (this.lineClips.end - this.lineClips.start) * this.distance / this.totalDistance :
            this.distance;
    }
    updateDistance(prev, next) {
        this.distance += prev.dist(next);
        this.updateScaledDistance();
    }
}
register('LineBucket', LineBucket, { omit: ['layers', 'patternFeatures'] });

// This file is generated. Edit build/generate-style-code.ts, then run 'npm run codegen'.
/* eslint-disable */
let layout$1;
const getLayout$1 = () => layout$1 = layout$1 || new Properties({
    "line-cap": new DataConstantProperty(v8Spec["layout_line"]["line-cap"]),
    "line-join": new DataDrivenProperty(v8Spec["layout_line"]["line-join"]),
    "line-miter-limit": new DataConstantProperty(v8Spec["layout_line"]["line-miter-limit"]),
    "line-round-limit": new DataConstantProperty(v8Spec["layout_line"]["line-round-limit"]),
    "line-sort-key": new DataDrivenProperty(v8Spec["layout_line"]["line-sort-key"]),
});
let paint$3;
const getPaint$3 = () => paint$3 = paint$3 || new Properties({
    "line-opacity": new DataDrivenProperty(v8Spec["paint_line"]["line-opacity"]),
    "line-color": new DataDrivenProperty(v8Spec["paint_line"]["line-color"]),
    "line-translate": new DataConstantProperty(v8Spec["paint_line"]["line-translate"]),
    "line-translate-anchor": new DataConstantProperty(v8Spec["paint_line"]["line-translate-anchor"]),
    "line-width": new DataDrivenProperty(v8Spec["paint_line"]["line-width"]),
    "line-gap-width": new DataDrivenProperty(v8Spec["paint_line"]["line-gap-width"]),
    "line-offset": new DataDrivenProperty(v8Spec["paint_line"]["line-offset"]),
    "line-blur": new DataDrivenProperty(v8Spec["paint_line"]["line-blur"]),
    "line-dasharray": new CrossFadedProperty(v8Spec["paint_line"]["line-dasharray"]),
    "line-pattern": new CrossFadedDataDrivenProperty(v8Spec["paint_line"]["line-pattern"]),
    "line-gradient": new ColorRampProperty(v8Spec["paint_line"]["line-gradient"]),
});
var properties$3 = ({ get paint() { return getPaint$3(); }, get layout() { return getLayout$1(); } });

class LineFloorwidthProperty extends DataDrivenProperty {
    possiblyEvaluate(value, parameters) {
        parameters = new EvaluationParameters(Math.floor(parameters.zoom), {
            now: parameters.now,
            fadeDuration: parameters.fadeDuration,
            zoomHistory: parameters.zoomHistory,
            transition: parameters.transition
        });
        return super.possiblyEvaluate(value, parameters);
    }
    evaluate(value, globals, feature, featureState) {
        globals = extend({}, globals, { zoom: Math.floor(globals.zoom) });
        return super.evaluate(value, globals, feature, featureState);
    }
}
let lineFloorwidthProperty;
class LineStyleLayer extends StyleLayer {
    constructor(layer) {
        super(layer, properties$3);
        this.gradientVersion = 0;
        if (!lineFloorwidthProperty) {
            lineFloorwidthProperty =
                new LineFloorwidthProperty(properties$3.paint.properties['line-width'].specification);
            lineFloorwidthProperty.useIntegerZoom = true;
        }
    }
    _handleSpecialPaintPropertyUpdate(name) {
        if (name === 'line-gradient') {
            const expression = this.gradientExpression();
            if (isZoomExpression(expression)) {
                this.stepInterpolant = expression._styleExpression.expression instanceof Step;
            }
            else {
                this.stepInterpolant = false;
            }
            this.gradientVersion = (this.gradientVersion + 1) % Number.MAX_SAFE_INTEGER;
        }
    }
    gradientExpression() {
        return this._transitionablePaint._values['line-gradient'].value.expression;
    }
    recalculate(parameters, availableImages) {
        super.recalculate(parameters, availableImages);
        this.paint._values['line-floorwidth'] =
            lineFloorwidthProperty.possiblyEvaluate(this._transitioningPaint._values['line-width'].value, parameters);
    }
    createBucket(parameters) {
        return new LineBucket(parameters);
    }
    queryRadius(bucket) {
        const lineBucket = bucket;
        const width = getLineWidth(getMaximumPaintValue('line-width', this, lineBucket), getMaximumPaintValue('line-gap-width', this, lineBucket));
        const offset = getMaximumPaintValue('line-offset', this, lineBucket);
        return width / 2 + Math.abs(offset) + translateDistance(this.paint.get('line-translate'));
    }
    queryIntersectsFeature(queryGeometry, feature, featureState, geometry, zoom, transform, pixelsToTileUnits) {
        const translatedPolygon = translate$1(queryGeometry, this.paint.get('line-translate'), this.paint.get('line-translate-anchor'), transform.angle, pixelsToTileUnits);
        const halfWidth = pixelsToTileUnits / 2 * getLineWidth(this.paint.get('line-width').evaluate(feature, featureState), this.paint.get('line-gap-width').evaluate(feature, featureState));
        const lineOffset = this.paint.get('line-offset').evaluate(feature, featureState);
        if (lineOffset) {
            geometry = offsetLine(geometry, lineOffset * pixelsToTileUnits);
        }
        return polygonIntersectsBufferedMultiLine(translatedPolygon, geometry, halfWidth);
    }
    isTileClipped() {
        return true;
    }
}
function getLineWidth(lineWidth, lineGapWidth) {
    if (lineGapWidth > 0) {
        return lineGapWidth + 2 * lineWidth;
    }
    else {
        return lineWidth;
    }
}

const symbolLayoutAttributes = createLayout([
    { name: 'a_pos_offset', components: 4, type: 'Int16' },
    { name: 'a_data', components: 4, type: 'Uint16' },
    { name: 'a_pixeloffset', components: 4, type: 'Int16' }
], 4);
const dynamicLayoutAttributes = createLayout([
    { name: 'a_projected_pos', components: 3, type: 'Float32' }
], 4);
createLayout([
    { name: 'a_fade_opacity', components: 1, type: 'Uint32' }
], 4);
const collisionVertexAttributes = createLayout([
    { name: 'a_placed', components: 2, type: 'Uint8' },
    { name: 'a_shift', components: 2, type: 'Float32' },
    { name: 'a_box_real', components: 2, type: 'Int16' },
]);
createLayout([
    // the box is centered around the anchor point
    { type: 'Int16', name: 'anchorPointX' },
    { type: 'Int16', name: 'anchorPointY' },
    // distances to the edges from the anchor
    { type: 'Int16', name: 'x1' },
    { type: 'Int16', name: 'y1' },
    { type: 'Int16', name: 'x2' },
    { type: 'Int16', name: 'y2' },
    // the index of the feature in the original vectortile
    { type: 'Uint32', name: 'featureIndex' },
    // the source layer the feature appears in
    { type: 'Uint16', name: 'sourceLayerIndex' },
    // the bucket the feature appears in
    { type: 'Uint16', name: 'bucketIndex' },
]);
const collisionBoxLayout = createLayout([
    { name: 'a_pos', components: 2, type: 'Int16' },
    { name: 'a_anchor_pos', components: 2, type: 'Int16' },
    { name: 'a_extrude', components: 2, type: 'Int16' }
], 4);
const collisionCircleLayout = createLayout([
    { name: 'a_pos', components: 2, type: 'Float32' },
    { name: 'a_radius', components: 1, type: 'Float32' },
    { name: 'a_flags', components: 2, type: 'Int16' }
], 4);
createLayout([
    { name: 'triangle', components: 3, type: 'Uint16' },
]);
createLayout([
    { type: 'Int16', name: 'anchorX' },
    { type: 'Int16', name: 'anchorY' },
    { type: 'Uint16', name: 'glyphStartIndex' },
    { type: 'Uint16', name: 'numGlyphs' },
    { type: 'Uint32', name: 'vertexStartIndex' },
    { type: 'Uint32', name: 'lineStartIndex' },
    { type: 'Uint32', name: 'lineLength' },
    { type: 'Uint16', name: 'segment' },
    { type: 'Uint16', name: 'lowerSize' },
    { type: 'Uint16', name: 'upperSize' },
    { type: 'Float32', name: 'lineOffsetX' },
    { type: 'Float32', name: 'lineOffsetY' },
    { type: 'Uint8', name: 'writingMode' },
    { type: 'Uint8', name: 'placedOrientation' },
    { type: 'Uint8', name: 'hidden' },
    { type: 'Uint32', name: 'crossTileID' },
    { type: 'Int16', name: 'associatedIconIndex' }
]);
createLayout([
    { type: 'Int16', name: 'anchorX' },
    { type: 'Int16', name: 'anchorY' },
    { type: 'Int16', name: 'rightJustifiedTextSymbolIndex' },
    { type: 'Int16', name: 'centerJustifiedTextSymbolIndex' },
    { type: 'Int16', name: 'leftJustifiedTextSymbolIndex' },
    { type: 'Int16', name: 'verticalPlacedTextSymbolIndex' },
    { type: 'Int16', name: 'placedIconSymbolIndex' },
    { type: 'Int16', name: 'verticalPlacedIconSymbolIndex' },
    { type: 'Uint16', name: 'key' },
    { type: 'Uint16', name: 'textBoxStartIndex' },
    { type: 'Uint16', name: 'textBoxEndIndex' },
    { type: 'Uint16', name: 'verticalTextBoxStartIndex' },
    { type: 'Uint16', name: 'verticalTextBoxEndIndex' },
    { type: 'Uint16', name: 'iconBoxStartIndex' },
    { type: 'Uint16', name: 'iconBoxEndIndex' },
    { type: 'Uint16', name: 'verticalIconBoxStartIndex' },
    { type: 'Uint16', name: 'verticalIconBoxEndIndex' },
    { type: 'Uint16', name: 'featureIndex' },
    { type: 'Uint16', name: 'numHorizontalGlyphVertices' },
    { type: 'Uint16', name: 'numVerticalGlyphVertices' },
    { type: 'Uint16', name: 'numIconVertices' },
    { type: 'Uint16', name: 'numVerticalIconVertices' },
    { type: 'Uint16', name: 'useRuntimeCollisionCircles' },
    { type: 'Uint32', name: 'crossTileID' },
    { type: 'Float32', name: 'textBoxScale' },
    { type: 'Float32', name: 'collisionCircleDiameter' },
    { type: 'Uint16', name: 'textAnchorOffsetStartIndex' },
    { type: 'Uint16', name: 'textAnchorOffsetEndIndex' }
]);
createLayout([
    { type: 'Float32', name: 'offsetX' }
]);
createLayout([
    { type: 'Int16', name: 'x' },
    { type: 'Int16', name: 'y' },
    { type: 'Int16', name: 'tileUnitDistanceFromAnchor' }
]);
createLayout([
    { type: 'Uint16', name: 'textAnchor' },
    { type: 'Float32', components: 2, name: 'textOffset' }
]);

function transformTextInternal(text, layer, feature) {
    const transform = layer.layout.get('text-transform').evaluate(feature, {});
    if (transform === 'uppercase') {
        text = text.toLocaleUpperCase();
    }
    else if (transform === 'lowercase') {
        text = text.toLocaleLowerCase();
    }
    if (rtlWorkerPlugin.applyArabicShaping) {
        text = rtlWorkerPlugin.applyArabicShaping(text);
    }
    return text;
}
function transformText(text, layer, feature) {
    text.sections.forEach(section => {
        section.text = transformTextInternal(section.text, layer, feature);
    });
    return text;
}

function mergeLines(features) {
    const leftIndex = {};
    const rightIndex = {};
    const mergedFeatures = [];
    let mergedIndex = 0;
    function add(k) {
        mergedFeatures.push(features[k]);
        mergedIndex++;
    }
    function mergeFromRight(leftKey, rightKey, geom) {
        const i = rightIndex[leftKey];
        delete rightIndex[leftKey];
        rightIndex[rightKey] = i;
        mergedFeatures[i].geometry[0].pop();
        mergedFeatures[i].geometry[0] = mergedFeatures[i].geometry[0].concat(geom[0]);
        return i;
    }
    function mergeFromLeft(leftKey, rightKey, geom) {
        const i = leftIndex[rightKey];
        delete leftIndex[rightKey];
        leftIndex[leftKey] = i;
        mergedFeatures[i].geometry[0].shift();
        mergedFeatures[i].geometry[0] = geom[0].concat(mergedFeatures[i].geometry[0]);
        return i;
    }
    function getKey(text, geom, onRight) {
        const point = onRight ? geom[0][geom[0].length - 1] : geom[0][0];
        return `${text}:${point.x}:${point.y}`;
    }
    for (let k = 0; k < features.length; k++) {
        const feature = features[k];
        const geom = feature.geometry;
        const text = feature.text ? feature.text.toString() : null;
        if (!text) {
            add(k);
            continue;
        }
        const leftKey = getKey(text, geom), rightKey = getKey(text, geom, true);
        if ((leftKey in rightIndex) && (rightKey in leftIndex) && (rightIndex[leftKey] !== leftIndex[rightKey])) {
            // found lines with the same text adjacent to both ends of the current line, merge all three
            const j = mergeFromLeft(leftKey, rightKey, geom);
            const i = mergeFromRight(leftKey, rightKey, mergedFeatures[j].geometry);
            delete leftIndex[leftKey];
            delete rightIndex[rightKey];
            rightIndex[getKey(text, mergedFeatures[i].geometry, true)] = i;
            mergedFeatures[j].geometry = null;
        }
        else if (leftKey in rightIndex) {
            // found mergeable line adjacent to the start of the current line, merge
            mergeFromRight(leftKey, rightKey, geom);
        }
        else if (rightKey in leftIndex) {
            // found mergeable line adjacent to the end of the current line, merge
            mergeFromLeft(leftKey, rightKey, geom);
        }
        else {
            // no adjacent lines, add as a new item
            add(k);
            leftIndex[leftKey] = mergedIndex - 1;
            rightIndex[rightKey] = mergedIndex - 1;
        }
    }
    return mergedFeatures.filter((f) => f.geometry);
}

const verticalizedCharacterMap = {
    '!': '︕',
    '#': '＃',
    '$': '＄',
    '%': '％',
    '&': '＆',
    '(': '︵',
    ')': '︶',
    '*': '＊',
    '+': '＋',
    ',': '︐',
    '-': '︲',
    '.': '・',
    '/': '／',
    ':': '︓',
    ';': '︔',
    '<': '︿',
    '=': '＝',
    '>': '﹀',
    '?': '︖',
    '@': '＠',
    '[': '﹇',
    '\\': '＼',
    ']': '﹈',
    '^': '＾',
    '_': '︳',
    '`': '｀',
    '{': '︷',
    '|': '―',
    '}': '︸',
    '~': '～',
    '¢': '￠',
    '£': '￡',
    '¥': '￥',
    '¦': '￤',
    '¬': '￢',
    '¯': '￣',
    '–': '︲',
    '—': '︱',
    '‘': '﹃',
    '’': '﹄',
    '“': '﹁',
    '”': '﹂',
    '…': '︙',
    '‧': '・',
    '₩': '￦',
    '、': '︑',
    '。': '︒',
    '〈': '︿',
    '〉': '﹀',
    '《': '︽',
    '》': '︾',
    '「': '﹁',
    '」': '﹂',
    '『': '﹃',
    '』': '﹄',
    '【': '︻',
    '】': '︼',
    '〔': '︹',
    '〕': '︺',
    '〖': '︗',
    '〗': '︘',
    '！': '︕',
    '（': '︵',
    '）': '︶',
    '，': '︐',
    '－': '︲',
    '．': '・',
    '：': '︓',
    '；': '︔',
    '＜': '︿',
    '＞': '﹀',
    '？': '︖',
    '［': '﹇',
    '］': '﹈',
    '＿': '︳',
    '｛': '︷',
    '｜': '―',
    '｝': '︸',
    '｟': '︵',
    '｠': '︶',
    '｡': '︒',
    '｢': '﹁',
    '｣': '﹂'
};
function verticalizePunctuation(input) {
    let output = '';
    for (let i = 0; i < input.length; i++) {
        const nextCharCode = input.charCodeAt(i + 1) || null;
        const prevCharCode = input.charCodeAt(i - 1) || null;
        const canReplacePunctuation = ((!nextCharCode || !charHasRotatedVerticalOrientation(nextCharCode) || verticalizedCharacterMap[input[i + 1]]) &&
            (!prevCharCode || !charHasRotatedVerticalOrientation(prevCharCode) || verticalizedCharacterMap[input[i - 1]]));
        if (canReplacePunctuation && verticalizedCharacterMap[input[i]]) {
            output += verticalizedCharacterMap[input[i]];
        }
        else {
            output += input[i];
        }
    }
    return output;
}

// ONE_EM constant used to go between "em" units used in style spec and "points" used internally for layout
var ONE_EM = 24;

var ieee754$1 = {};

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */

ieee754$1.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m;
  var eLen = (nBytes * 8) - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = -7;
  var i = isLE ? (nBytes - 1) : 0;
  var d = isLE ? -1 : 1;
  var s = buffer[offset + i];

  i += d;

  e = s & ((1 << (-nBits)) - 1);
  s >>= (-nBits);
  nBits += eLen;
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1);
  e >>= (-nBits);
  nBits += mLen;
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen);
    e = e - eBias;
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
};

ieee754$1.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c;
  var eLen = (nBytes * 8) - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0);
  var i = isLE ? 0 : (nBytes - 1);
  var d = isLE ? 1 : -1;
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0;

  value = Math.abs(value);

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0;
    e = eMax;
  } else {
    e = Math.floor(Math.log(value) / Math.LN2);
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * Math.pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }

    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
      e = 0;
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m;
  eLen += mLen;
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128;
};

var pbf = Pbf;

var ieee754 = ieee754$1;

function Pbf(buf) {
    this.buf = ArrayBuffer.isView && ArrayBuffer.isView(buf) ? buf : new Uint8Array(buf || 0);
    this.pos = 0;
    this.type = 0;
    this.length = this.buf.length;
}

Pbf.Varint  = 0; // varint: int32, int64, uint32, uint64, sint32, sint64, bool, enum
Pbf.Fixed64 = 1; // 64-bit: double, fixed64, sfixed64
Pbf.Bytes   = 2; // length-delimited: string, bytes, embedded messages, packed repeated fields
Pbf.Fixed32 = 5; // 32-bit: float, fixed32, sfixed32

var SHIFT_LEFT_32 = (1 << 16) * (1 << 16),
    SHIFT_RIGHT_32 = 1 / SHIFT_LEFT_32;

// Threshold chosen based on both benchmarking and knowledge about browser string
// data structures (which currently switch structure types at 12 bytes or more)
var TEXT_DECODER_MIN_LENGTH = 12;
var utf8TextDecoder = typeof TextDecoder === 'undefined' ? null : new TextDecoder('utf-8');

Pbf.prototype = {

    destroy: function() {
        this.buf = null;
    },

    // === READING =================================================================

    readFields: function(readField, result, end) {
        end = end || this.length;

        while (this.pos < end) {
            var val = this.readVarint(),
                tag = val >> 3,
                startPos = this.pos;

            this.type = val & 0x7;
            readField(tag, result, this);

            if (this.pos === startPos) this.skip(val);
        }
        return result;
    },

    readMessage: function(readField, result) {
        return this.readFields(readField, result, this.readVarint() + this.pos);
    },

    readFixed32: function() {
        var val = readUInt32(this.buf, this.pos);
        this.pos += 4;
        return val;
    },

    readSFixed32: function() {
        var val = readInt32(this.buf, this.pos);
        this.pos += 4;
        return val;
    },

    // 64-bit int handling is based on github.com/dpw/node-buffer-more-ints (MIT-licensed)

    readFixed64: function() {
        var val = readUInt32(this.buf, this.pos) + readUInt32(this.buf, this.pos + 4) * SHIFT_LEFT_32;
        this.pos += 8;
        return val;
    },

    readSFixed64: function() {
        var val = readUInt32(this.buf, this.pos) + readInt32(this.buf, this.pos + 4) * SHIFT_LEFT_32;
        this.pos += 8;
        return val;
    },

    readFloat: function() {
        var val = ieee754.read(this.buf, this.pos, true, 23, 4);
        this.pos += 4;
        return val;
    },

    readDouble: function() {
        var val = ieee754.read(this.buf, this.pos, true, 52, 8);
        this.pos += 8;
        return val;
    },

    readVarint: function(isSigned) {
        var buf = this.buf,
            val, b;

        b = buf[this.pos++]; val  =  b & 0x7f;        if (b < 0x80) return val;
        b = buf[this.pos++]; val |= (b & 0x7f) << 7;  if (b < 0x80) return val;
        b = buf[this.pos++]; val |= (b & 0x7f) << 14; if (b < 0x80) return val;
        b = buf[this.pos++]; val |= (b & 0x7f) << 21; if (b < 0x80) return val;
        b = buf[this.pos];   val |= (b & 0x0f) << 28;

        return readVarintRemainder(val, isSigned, this);
    },

    readVarint64: function() { // for compatibility with v2.0.1
        return this.readVarint(true);
    },

    readSVarint: function() {
        var num = this.readVarint();
        return num % 2 === 1 ? (num + 1) / -2 : num / 2; // zigzag encoding
    },

    readBoolean: function() {
        return Boolean(this.readVarint());
    },

    readString: function() {
        var end = this.readVarint() + this.pos;
        var pos = this.pos;
        this.pos = end;

        if (end - pos >= TEXT_DECODER_MIN_LENGTH && utf8TextDecoder) {
            // longer strings are fast with the built-in browser TextDecoder API
            return readUtf8TextDecoder(this.buf, pos, end);
        }
        // short strings are fast with our custom implementation
        return readUtf8(this.buf, pos, end);
    },

    readBytes: function() {
        var end = this.readVarint() + this.pos,
            buffer = this.buf.subarray(this.pos, end);
        this.pos = end;
        return buffer;
    },

    // verbose for performance reasons; doesn't affect gzipped size

    readPackedVarint: function(arr, isSigned) {
        if (this.type !== Pbf.Bytes) return arr.push(this.readVarint(isSigned));
        var end = readPackedEnd(this);
        arr = arr || [];
        while (this.pos < end) arr.push(this.readVarint(isSigned));
        return arr;
    },
    readPackedSVarint: function(arr) {
        if (this.type !== Pbf.Bytes) return arr.push(this.readSVarint());
        var end = readPackedEnd(this);
        arr = arr || [];
        while (this.pos < end) arr.push(this.readSVarint());
        return arr;
    },
    readPackedBoolean: function(arr) {
        if (this.type !== Pbf.Bytes) return arr.push(this.readBoolean());
        var end = readPackedEnd(this);
        arr = arr || [];
        while (this.pos < end) arr.push(this.readBoolean());
        return arr;
    },
    readPackedFloat: function(arr) {
        if (this.type !== Pbf.Bytes) return arr.push(this.readFloat());
        var end = readPackedEnd(this);
        arr = arr || [];
        while (this.pos < end) arr.push(this.readFloat());
        return arr;
    },
    readPackedDouble: function(arr) {
        if (this.type !== Pbf.Bytes) return arr.push(this.readDouble());
        var end = readPackedEnd(this);
        arr = arr || [];
        while (this.pos < end) arr.push(this.readDouble());
        return arr;
    },
    readPackedFixed32: function(arr) {
        if (this.type !== Pbf.Bytes) return arr.push(this.readFixed32());
        var end = readPackedEnd(this);
        arr = arr || [];
        while (this.pos < end) arr.push(this.readFixed32());
        return arr;
    },
    readPackedSFixed32: function(arr) {
        if (this.type !== Pbf.Bytes) return arr.push(this.readSFixed32());
        var end = readPackedEnd(this);
        arr = arr || [];
        while (this.pos < end) arr.push(this.readSFixed32());
        return arr;
    },
    readPackedFixed64: function(arr) {
        if (this.type !== Pbf.Bytes) return arr.push(this.readFixed64());
        var end = readPackedEnd(this);
        arr = arr || [];
        while (this.pos < end) arr.push(this.readFixed64());
        return arr;
    },
    readPackedSFixed64: function(arr) {
        if (this.type !== Pbf.Bytes) return arr.push(this.readSFixed64());
        var end = readPackedEnd(this);
        arr = arr || [];
        while (this.pos < end) arr.push(this.readSFixed64());
        return arr;
    },

    skip: function(val) {
        var type = val & 0x7;
        if (type === Pbf.Varint) while (this.buf[this.pos++] > 0x7f) {}
        else if (type === Pbf.Bytes) this.pos = this.readVarint() + this.pos;
        else if (type === Pbf.Fixed32) this.pos += 4;
        else if (type === Pbf.Fixed64) this.pos += 8;
        else throw new Error('Unimplemented type: ' + type);
    },

    // === WRITING =================================================================

    writeTag: function(tag, type) {
        this.writeVarint((tag << 3) | type);
    },

    realloc: function(min) {
        var length = this.length || 16;

        while (length < this.pos + min) length *= 2;

        if (length !== this.length) {
            var buf = new Uint8Array(length);
            buf.set(this.buf);
            this.buf = buf;
            this.length = length;
        }
    },

    finish: function() {
        this.length = this.pos;
        this.pos = 0;
        return this.buf.subarray(0, this.length);
    },

    writeFixed32: function(val) {
        this.realloc(4);
        writeInt32(this.buf, val, this.pos);
        this.pos += 4;
    },

    writeSFixed32: function(val) {
        this.realloc(4);
        writeInt32(this.buf, val, this.pos);
        this.pos += 4;
    },

    writeFixed64: function(val) {
        this.realloc(8);
        writeInt32(this.buf, val & -1, this.pos);
        writeInt32(this.buf, Math.floor(val * SHIFT_RIGHT_32), this.pos + 4);
        this.pos += 8;
    },

    writeSFixed64: function(val) {
        this.realloc(8);
        writeInt32(this.buf, val & -1, this.pos);
        writeInt32(this.buf, Math.floor(val * SHIFT_RIGHT_32), this.pos + 4);
        this.pos += 8;
    },

    writeVarint: function(val) {
        val = +val || 0;

        if (val > 0xfffffff || val < 0) {
            writeBigVarint(val, this);
            return;
        }

        this.realloc(4);

        this.buf[this.pos++] =           val & 0x7f  | (val > 0x7f ? 0x80 : 0); if (val <= 0x7f) return;
        this.buf[this.pos++] = ((val >>>= 7) & 0x7f) | (val > 0x7f ? 0x80 : 0); if (val <= 0x7f) return;
        this.buf[this.pos++] = ((val >>>= 7) & 0x7f) | (val > 0x7f ? 0x80 : 0); if (val <= 0x7f) return;
        this.buf[this.pos++] =   (val >>> 7) & 0x7f;
    },

    writeSVarint: function(val) {
        this.writeVarint(val < 0 ? -val * 2 - 1 : val * 2);
    },

    writeBoolean: function(val) {
        this.writeVarint(Boolean(val));
    },

    writeString: function(str) {
        str = String(str);
        this.realloc(str.length * 4);

        this.pos++; // reserve 1 byte for short string length

        var startPos = this.pos;
        // write the string directly to the buffer and see how much was written
        this.pos = writeUtf8(this.buf, str, this.pos);
        var len = this.pos - startPos;

        if (len >= 0x80) makeRoomForExtraLength(startPos, len, this);

        // finally, write the message length in the reserved place and restore the position
        this.pos = startPos - 1;
        this.writeVarint(len);
        this.pos += len;
    },

    writeFloat: function(val) {
        this.realloc(4);
        ieee754.write(this.buf, val, this.pos, true, 23, 4);
        this.pos += 4;
    },

    writeDouble: function(val) {
        this.realloc(8);
        ieee754.write(this.buf, val, this.pos, true, 52, 8);
        this.pos += 8;
    },

    writeBytes: function(buffer) {
        var len = buffer.length;
        this.writeVarint(len);
        this.realloc(len);
        for (var i = 0; i < len; i++) this.buf[this.pos++] = buffer[i];
    },

    writeRawMessage: function(fn, obj) {
        this.pos++; // reserve 1 byte for short message length

        // write the message directly to the buffer and see how much was written
        var startPos = this.pos;
        fn(obj, this);
        var len = this.pos - startPos;

        if (len >= 0x80) makeRoomForExtraLength(startPos, len, this);

        // finally, write the message length in the reserved place and restore the position
        this.pos = startPos - 1;
        this.writeVarint(len);
        this.pos += len;
    },

    writeMessage: function(tag, fn, obj) {
        this.writeTag(tag, Pbf.Bytes);
        this.writeRawMessage(fn, obj);
    },

    writePackedVarint:   function(tag, arr) { if (arr.length) this.writeMessage(tag, writePackedVarint, arr);   },
    writePackedSVarint:  function(tag, arr) { if (arr.length) this.writeMessage(tag, writePackedSVarint, arr);  },
    writePackedBoolean:  function(tag, arr) { if (arr.length) this.writeMessage(tag, writePackedBoolean, arr);  },
    writePackedFloat:    function(tag, arr) { if (arr.length) this.writeMessage(tag, writePackedFloat, arr);    },
    writePackedDouble:   function(tag, arr) { if (arr.length) this.writeMessage(tag, writePackedDouble, arr);   },
    writePackedFixed32:  function(tag, arr) { if (arr.length) this.writeMessage(tag, writePackedFixed32, arr);  },
    writePackedSFixed32: function(tag, arr) { if (arr.length) this.writeMessage(tag, writePackedSFixed32, arr); },
    writePackedFixed64:  function(tag, arr) { if (arr.length) this.writeMessage(tag, writePackedFixed64, arr);  },
    writePackedSFixed64: function(tag, arr) { if (arr.length) this.writeMessage(tag, writePackedSFixed64, arr); },

    writeBytesField: function(tag, buffer) {
        this.writeTag(tag, Pbf.Bytes);
        this.writeBytes(buffer);
    },
    writeFixed32Field: function(tag, val) {
        this.writeTag(tag, Pbf.Fixed32);
        this.writeFixed32(val);
    },
    writeSFixed32Field: function(tag, val) {
        this.writeTag(tag, Pbf.Fixed32);
        this.writeSFixed32(val);
    },
    writeFixed64Field: function(tag, val) {
        this.writeTag(tag, Pbf.Fixed64);
        this.writeFixed64(val);
    },
    writeSFixed64Field: function(tag, val) {
        this.writeTag(tag, Pbf.Fixed64);
        this.writeSFixed64(val);
    },
    writeVarintField: function(tag, val) {
        this.writeTag(tag, Pbf.Varint);
        this.writeVarint(val);
    },
    writeSVarintField: function(tag, val) {
        this.writeTag(tag, Pbf.Varint);
        this.writeSVarint(val);
    },
    writeStringField: function(tag, str) {
        this.writeTag(tag, Pbf.Bytes);
        this.writeString(str);
    },
    writeFloatField: function(tag, val) {
        this.writeTag(tag, Pbf.Fixed32);
        this.writeFloat(val);
    },
    writeDoubleField: function(tag, val) {
        this.writeTag(tag, Pbf.Fixed64);
        this.writeDouble(val);
    },
    writeBooleanField: function(tag, val) {
        this.writeVarintField(tag, Boolean(val));
    }
};

function readVarintRemainder(l, s, p) {
    var buf = p.buf,
        h, b;

    b = buf[p.pos++]; h  = (b & 0x70) >> 4;  if (b < 0x80) return toNum(l, h, s);
    b = buf[p.pos++]; h |= (b & 0x7f) << 3;  if (b < 0x80) return toNum(l, h, s);
    b = buf[p.pos++]; h |= (b & 0x7f) << 10; if (b < 0x80) return toNum(l, h, s);
    b = buf[p.pos++]; h |= (b & 0x7f) << 17; if (b < 0x80) return toNum(l, h, s);
    b = buf[p.pos++]; h |= (b & 0x7f) << 24; if (b < 0x80) return toNum(l, h, s);
    b = buf[p.pos++]; h |= (b & 0x01) << 31; if (b < 0x80) return toNum(l, h, s);

    throw new Error('Expected varint not more than 10 bytes');
}

function readPackedEnd(pbf) {
    return pbf.type === Pbf.Bytes ?
        pbf.readVarint() + pbf.pos : pbf.pos + 1;
}

function toNum(low, high, isSigned) {
    if (isSigned) {
        return high * 0x100000000 + (low >>> 0);
    }

    return ((high >>> 0) * 0x100000000) + (low >>> 0);
}

function writeBigVarint(val, pbf) {
    var low, high;

    if (val >= 0) {
        low  = (val % 0x100000000) | 0;
        high = (val / 0x100000000) | 0;
    } else {
        low  = ~(-val % 0x100000000);
        high = ~(-val / 0x100000000);

        if (low ^ 0xffffffff) {
            low = (low + 1) | 0;
        } else {
            low = 0;
            high = (high + 1) | 0;
        }
    }

    if (val >= 0x10000000000000000 || val < -0x10000000000000000) {
        throw new Error('Given varint doesn\'t fit into 10 bytes');
    }

    pbf.realloc(10);

    writeBigVarintLow(low, high, pbf);
    writeBigVarintHigh(high, pbf);
}

function writeBigVarintLow(low, high, pbf) {
    pbf.buf[pbf.pos++] = low & 0x7f | 0x80; low >>>= 7;
    pbf.buf[pbf.pos++] = low & 0x7f | 0x80; low >>>= 7;
    pbf.buf[pbf.pos++] = low & 0x7f | 0x80; low >>>= 7;
    pbf.buf[pbf.pos++] = low & 0x7f | 0x80; low >>>= 7;
    pbf.buf[pbf.pos]   = low & 0x7f;
}

function writeBigVarintHigh(high, pbf) {
    var lsb = (high & 0x07) << 4;

    pbf.buf[pbf.pos++] |= lsb         | ((high >>>= 3) ? 0x80 : 0); if (!high) return;
    pbf.buf[pbf.pos++]  = high & 0x7f | ((high >>>= 7) ? 0x80 : 0); if (!high) return;
    pbf.buf[pbf.pos++]  = high & 0x7f | ((high >>>= 7) ? 0x80 : 0); if (!high) return;
    pbf.buf[pbf.pos++]  = high & 0x7f | ((high >>>= 7) ? 0x80 : 0); if (!high) return;
    pbf.buf[pbf.pos++]  = high & 0x7f | ((high >>>= 7) ? 0x80 : 0); if (!high) return;
    pbf.buf[pbf.pos++]  = high & 0x7f;
}

function makeRoomForExtraLength(startPos, len, pbf) {
    var extraLen =
        len <= 0x3fff ? 1 :
        len <= 0x1fffff ? 2 :
        len <= 0xfffffff ? 3 : Math.floor(Math.log(len) / (Math.LN2 * 7));

    // if 1 byte isn't enough for encoding message length, shift the data to the right
    pbf.realloc(extraLen);
    for (var i = pbf.pos - 1; i >= startPos; i--) pbf.buf[i + extraLen] = pbf.buf[i];
}

function writePackedVarint(arr, pbf)   { for (var i = 0; i < arr.length; i++) pbf.writeVarint(arr[i]);   }
function writePackedSVarint(arr, pbf)  { for (var i = 0; i < arr.length; i++) pbf.writeSVarint(arr[i]);  }
function writePackedFloat(arr, pbf)    { for (var i = 0; i < arr.length; i++) pbf.writeFloat(arr[i]);    }
function writePackedDouble(arr, pbf)   { for (var i = 0; i < arr.length; i++) pbf.writeDouble(arr[i]);   }
function writePackedBoolean(arr, pbf)  { for (var i = 0; i < arr.length; i++) pbf.writeBoolean(arr[i]);  }
function writePackedFixed32(arr, pbf)  { for (var i = 0; i < arr.length; i++) pbf.writeFixed32(arr[i]);  }
function writePackedSFixed32(arr, pbf) { for (var i = 0; i < arr.length; i++) pbf.writeSFixed32(arr[i]); }
function writePackedFixed64(arr, pbf)  { for (var i = 0; i < arr.length; i++) pbf.writeFixed64(arr[i]);  }
function writePackedSFixed64(arr, pbf) { for (var i = 0; i < arr.length; i++) pbf.writeSFixed64(arr[i]); }

// Buffer code below from https://github.com/feross/buffer, MIT-licensed

function readUInt32(buf, pos) {
    return ((buf[pos]) |
        (buf[pos + 1] << 8) |
        (buf[pos + 2] << 16)) +
        (buf[pos + 3] * 0x1000000);
}

function writeInt32(buf, val, pos) {
    buf[pos] = val;
    buf[pos + 1] = (val >>> 8);
    buf[pos + 2] = (val >>> 16);
    buf[pos + 3] = (val >>> 24);
}

function readInt32(buf, pos) {
    return ((buf[pos]) |
        (buf[pos + 1] << 8) |
        (buf[pos + 2] << 16)) +
        (buf[pos + 3] << 24);
}

function readUtf8(buf, pos, end) {
    var str = '';
    var i = pos;

    while (i < end) {
        var b0 = buf[i];
        var c = null; // codepoint
        var bytesPerSequence =
            b0 > 0xEF ? 4 :
            b0 > 0xDF ? 3 :
            b0 > 0xBF ? 2 : 1;

        if (i + bytesPerSequence > end) break;

        var b1, b2, b3;

        if (bytesPerSequence === 1) {
            if (b0 < 0x80) {
                c = b0;
            }
        } else if (bytesPerSequence === 2) {
            b1 = buf[i + 1];
            if ((b1 & 0xC0) === 0x80) {
                c = (b0 & 0x1F) << 0x6 | (b1 & 0x3F);
                if (c <= 0x7F) {
                    c = null;
                }
            }
        } else if (bytesPerSequence === 3) {
            b1 = buf[i + 1];
            b2 = buf[i + 2];
            if ((b1 & 0xC0) === 0x80 && (b2 & 0xC0) === 0x80) {
                c = (b0 & 0xF) << 0xC | (b1 & 0x3F) << 0x6 | (b2 & 0x3F);
                if (c <= 0x7FF || (c >= 0xD800 && c <= 0xDFFF)) {
                    c = null;
                }
            }
        } else if (bytesPerSequence === 4) {
            b1 = buf[i + 1];
            b2 = buf[i + 2];
            b3 = buf[i + 3];
            if ((b1 & 0xC0) === 0x80 && (b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80) {
                c = (b0 & 0xF) << 0x12 | (b1 & 0x3F) << 0xC | (b2 & 0x3F) << 0x6 | (b3 & 0x3F);
                if (c <= 0xFFFF || c >= 0x110000) {
                    c = null;
                }
            }
        }

        if (c === null) {
            c = 0xFFFD;
            bytesPerSequence = 1;

        } else if (c > 0xFFFF) {
            c -= 0x10000;
            str += String.fromCharCode(c >>> 10 & 0x3FF | 0xD800);
            c = 0xDC00 | c & 0x3FF;
        }

        str += String.fromCharCode(c);
        i += bytesPerSequence;
    }

    return str;
}

function readUtf8TextDecoder(buf, pos, end) {
    return utf8TextDecoder.decode(buf.subarray(pos, end));
}

function writeUtf8(buf, str, pos) {
    for (var i = 0, c, lead; i < str.length; i++) {
        c = str.charCodeAt(i); // code point

        if (c > 0xD7FF && c < 0xE000) {
            if (lead) {
                if (c < 0xDC00) {
                    buf[pos++] = 0xEF;
                    buf[pos++] = 0xBF;
                    buf[pos++] = 0xBD;
                    lead = c;
                    continue;
                } else {
                    c = lead - 0xD800 << 10 | c - 0xDC00 | 0x10000;
                    lead = null;
                }
            } else {
                if (c > 0xDBFF || (i + 1 === str.length)) {
                    buf[pos++] = 0xEF;
                    buf[pos++] = 0xBF;
                    buf[pos++] = 0xBD;
                } else {
                    lead = c;
                }
                continue;
            }
        } else if (lead) {
            buf[pos++] = 0xEF;
            buf[pos++] = 0xBF;
            buf[pos++] = 0xBD;
            lead = null;
        }

        if (c < 0x80) {
            buf[pos++] = c;
        } else {
            if (c < 0x800) {
                buf[pos++] = c >> 0x6 | 0xC0;
            } else {
                if (c < 0x10000) {
                    buf[pos++] = c >> 0xC | 0xE0;
                } else {
                    buf[pos++] = c >> 0x12 | 0xF0;
                    buf[pos++] = c >> 0xC & 0x3F | 0x80;
                }
                buf[pos++] = c >> 0x6 & 0x3F | 0x80;
            }
            buf[pos++] = c & 0x3F | 0x80;
        }
    }
    return pos;
}

var Protobuf = /*@__PURE__*/getDefaultExportFromCjs$1(pbf);

const border$1 = 3;
function readFontstacks(tag, glyphs, pbf) {
    if (tag === 1) {
        pbf.readMessage(readFontstack, glyphs);
    }
}
function readFontstack(tag, glyphs, pbf) {
    if (tag === 3) {
        const { id, bitmap, width, height, left, top, advance } = pbf.readMessage(readGlyph, {});
        glyphs.push({
            id,
            bitmap: new AlphaImage({
                width: width + 2 * border$1,
                height: height + 2 * border$1
            }, bitmap),
            metrics: { width, height, left, top, advance }
        });
    }
}
function readGlyph(tag, glyph, pbf) {
    if (tag === 1)
        glyph.id = pbf.readVarint();
    else if (tag === 2)
        glyph.bitmap = pbf.readBytes();
    else if (tag === 3)
        glyph.width = pbf.readVarint();
    else if (tag === 4)
        glyph.height = pbf.readVarint();
    else if (tag === 5)
        glyph.left = pbf.readSVarint();
    else if (tag === 6)
        glyph.top = pbf.readSVarint();
    else if (tag === 7)
        glyph.advance = pbf.readVarint();
}
function parseGlyphPbf(data) {
    return new Protobuf(data).readFields(readFontstacks, []);
}
const GLYPH_PBF_BORDER = border$1;

function potpack(boxes) {

    // calculate total box area and maximum box width
    let area = 0;
    let maxWidth = 0;

    for (const box of boxes) {
        area += box.w * box.h;
        maxWidth = Math.max(maxWidth, box.w);
    }

    // sort the boxes for insertion by height, descending
    boxes.sort((a, b) => b.h - a.h);

    // aim for a squarish resulting container,
    // slightly adjusted for sub-100% space utilization
    const startWidth = Math.max(Math.ceil(Math.sqrt(area / 0.95)), maxWidth);

    // start with a single empty space, unbounded at the bottom
    const spaces = [{x: 0, y: 0, w: startWidth, h: Infinity}];

    let width = 0;
    let height = 0;

    for (const box of boxes) {
        // look through spaces backwards so that we check smaller spaces first
        for (let i = spaces.length - 1; i >= 0; i--) {
            const space = spaces[i];

            // look for empty spaces that can accommodate the current box
            if (box.w > space.w || box.h > space.h) continue;

            // found the space; add the box to its top-left corner
            // |-------|-------|
            // |  box  |       |
            // |_______|       |
            // |         space |
            // |_______________|
            box.x = space.x;
            box.y = space.y;

            height = Math.max(height, box.y + box.h);
            width = Math.max(width, box.x + box.w);

            if (box.w === space.w && box.h === space.h) {
                // space matches the box exactly; remove it
                const last = spaces.pop();
                if (i < spaces.length) spaces[i] = last;

            } else if (box.h === space.h) {
                // space matches the box height; update it accordingly
                // |-------|---------------|
                // |  box  | updated space |
                // |_______|_______________|
                space.x += box.w;
                space.w -= box.w;

            } else if (box.w === space.w) {
                // space matches the box width; update it accordingly
                // |---------------|
                // |      box      |
                // |_______________|
                // | updated space |
                // |_______________|
                space.y += box.h;
                space.h -= box.h;

            } else {
                // otherwise the box splits the space into two spaces
                // |-------|-----------|
                // |  box  | new space |
                // |_______|___________|
                // | updated space     |
                // |___________________|
                spaces.push({
                    x: space.x + box.w,
                    y: space.y,
                    w: space.w - box.w,
                    h: box.h
                });
                space.y += box.h;
                space.h -= box.h;
            }
            break;
        }
    }

    return {
        w: width, // container width
        h: height, // container height
        fill: (area / (width * height)) || 0 // space utilization
    };
}

/* eslint-disable key-spacing */
const IMAGE_PADDING = 1;
class ImagePosition {
    constructor(paddedRect, { pixelRatio, version, stretchX, stretchY, content, textFitWidth, textFitHeight }) {
        this.paddedRect = paddedRect;
        this.pixelRatio = pixelRatio;
        this.stretchX = stretchX;
        this.stretchY = stretchY;
        this.content = content;
        this.version = version;
        this.textFitWidth = textFitWidth;
        this.textFitHeight = textFitHeight;
    }
    get tl() {
        return [
            this.paddedRect.x + IMAGE_PADDING,
            this.paddedRect.y + IMAGE_PADDING
        ];
    }
    get br() {
        return [
            this.paddedRect.x + this.paddedRect.w - IMAGE_PADDING,
            this.paddedRect.y + this.paddedRect.h - IMAGE_PADDING
        ];
    }
    get tlbr() {
        return this.tl.concat(this.br);
    }
    get displaySize() {
        return [
            (this.paddedRect.w - IMAGE_PADDING * 2) / this.pixelRatio,
            (this.paddedRect.h - IMAGE_PADDING * 2) / this.pixelRatio
        ];
    }
}
/**
 * A class holding all the images
 */
class ImageAtlas {
    constructor(icons, patterns) {
        const iconPositions = {}, patternPositions = {};
        this.haveRenderCallbacks = [];
        const bins = [];
        this.addImages(icons, iconPositions, bins);
        this.addImages(patterns, patternPositions, bins);
        const { w, h } = potpack(bins);
        const image = new RGBAImage({ width: w || 1, height: h || 1 });
        for (const id in icons) {
            const src = icons[id];
            const bin = iconPositions[id].paddedRect;
            RGBAImage.copy(src.data, image, { x: 0, y: 0 }, { x: bin.x + IMAGE_PADDING, y: bin.y + IMAGE_PADDING }, src.data);
        }
        for (const id in patterns) {
            const src = patterns[id];
            const bin = patternPositions[id].paddedRect;
            const x = bin.x + IMAGE_PADDING, y = bin.y + IMAGE_PADDING, w = src.data.width, h = src.data.height;
            RGBAImage.copy(src.data, image, { x: 0, y: 0 }, { x, y }, src.data);
            // Add 1 pixel wrapped padding on each side of the image.
            RGBAImage.copy(src.data, image, { x: 0, y: h - 1 }, { x, y: y - 1 }, { width: w, height: 1 }); // T
            RGBAImage.copy(src.data, image, { x: 0, y: 0 }, { x, y: y + h }, { width: w, height: 1 }); // B
            RGBAImage.copy(src.data, image, { x: w - 1, y: 0 }, { x: x - 1, y }, { width: 1, height: h }); // L
            RGBAImage.copy(src.data, image, { x: 0, y: 0 }, { x: x + w, y }, { width: 1, height: h }); // R
        }
        this.image = image;
        this.iconPositions = iconPositions;
        this.patternPositions = patternPositions;
    }
    addImages(images, positions, bins) {
        for (const id in images) {
            const src = images[id];
            const bin = {
                x: 0,
                y: 0,
                w: src.data.width + 2 * IMAGE_PADDING,
                h: src.data.height + 2 * IMAGE_PADDING,
            };
            bins.push(bin);
            positions[id] = new ImagePosition(bin, src);
            if (src.hasRenderCallback) {
                this.haveRenderCallbacks.push(id);
            }
        }
    }
    patchUpdatedImages(imageManager, texture) {
        imageManager.dispatchRenderCallbacks(this.haveRenderCallbacks);
        for (const name in imageManager.updatedImages) {
            this.patchUpdatedImage(this.iconPositions[name], imageManager.getImage(name), texture);
            this.patchUpdatedImage(this.patternPositions[name], imageManager.getImage(name), texture);
        }
    }
    patchUpdatedImage(position, image, texture) {
        if (!position || !image)
            return;
        if (position.version === image.version)
            return;
        position.version = image.version;
        const [x, y] = position.tl;
        texture.update(image.data, undefined, { x, y });
    }
}
register('ImagePosition', ImagePosition);
register('ImageAtlas', ImageAtlas);

exports.ai = void 0;
(function (WritingMode) {
    WritingMode[WritingMode["none"] = 0] = "none";
    WritingMode[WritingMode["horizontal"] = 1] = "horizontal";
    WritingMode[WritingMode["vertical"] = 2] = "vertical";
    WritingMode[WritingMode["horizontalOnly"] = 3] = "horizontalOnly";
})(exports.ai || (exports.ai = {}));
const SHAPING_DEFAULT_OFFSET = -17;
function isEmpty(positionedLines) {
    for (const line of positionedLines) {
        if (line.positionedGlyphs.length !== 0) {
            return false;
        }
    }
    return true;
}
// Max number of images in label is 6401 U+E000–U+F8FF that covers
// Basic Multilingual Plane Unicode Private Use Area (PUA).
const PUAbegin = 0xE000;
const PUAend = 0xF8FF;
class SectionOptions {
    constructor() {
        this.scale = 1.0;
        this.fontStack = '';
        this.imageName = null;
    }
    static forText(scale, fontStack) {
        const textOptions = new SectionOptions();
        textOptions.scale = scale || 1;
        textOptions.fontStack = fontStack;
        return textOptions;
    }
    static forImage(imageName) {
        const imageOptions = new SectionOptions();
        imageOptions.imageName = imageName;
        return imageOptions;
    }
}
class TaggedString {
    constructor() {
        this.text = '';
        this.sectionIndex = [];
        this.sections = [];
        this.imageSectionID = null;
    }
    static fromFeature(text, defaultFontStack) {
        const result = new TaggedString();
        for (let i = 0; i < text.sections.length; i++) {
            const section = text.sections[i];
            if (!section.image) {
                result.addTextSection(section, defaultFontStack);
            }
            else {
                result.addImageSection(section);
            }
        }
        return result;
    }
    length() {
        return this.text.length;
    }
    getSection(index) {
        return this.sections[this.sectionIndex[index]];
    }
    getSectionIndex(index) {
        return this.sectionIndex[index];
    }
    getCharCode(index) {
        return this.text.charCodeAt(index);
    }
    verticalizePunctuation() {
        this.text = verticalizePunctuation(this.text);
    }
    trim() {
        let beginningWhitespace = 0;
        for (let i = 0; i < this.text.length && whitespace[this.text.charCodeAt(i)]; i++) {
            beginningWhitespace++;
        }
        let trailingWhitespace = this.text.length;
        for (let i = this.text.length - 1; i >= 0 && i >= beginningWhitespace && whitespace[this.text.charCodeAt(i)]; i--) {
            trailingWhitespace--;
        }
        this.text = this.text.substring(beginningWhitespace, trailingWhitespace);
        this.sectionIndex = this.sectionIndex.slice(beginningWhitespace, trailingWhitespace);
    }
    substring(start, end) {
        const substring = new TaggedString();
        substring.text = this.text.substring(start, end);
        substring.sectionIndex = this.sectionIndex.slice(start, end);
        substring.sections = this.sections;
        return substring;
    }
    toString() {
        return this.text;
    }
    getMaxScale() {
        return this.sectionIndex.reduce((max, index) => Math.max(max, this.sections[index].scale), 0);
    }
    addTextSection(section, defaultFontStack) {
        this.text += section.text;
        this.sections.push(SectionOptions.forText(section.scale, section.fontStack || defaultFontStack));
        const index = this.sections.length - 1;
        for (let i = 0; i < section.text.length; ++i) {
            this.sectionIndex.push(index);
        }
    }
    addImageSection(section) {
        const imageName = section.image ? section.image.name : '';
        if (imageName.length === 0) {
            warnOnce('Can\'t add FormattedSection with an empty image.');
            return;
        }
        const nextImageSectionCharCode = this.getNextImageSectionCharCode();
        if (!nextImageSectionCharCode) {
            warnOnce(`Reached maximum number of images ${PUAend - PUAbegin + 2}`);
            return;
        }
        this.text += String.fromCharCode(nextImageSectionCharCode);
        this.sections.push(SectionOptions.forImage(imageName));
        this.sectionIndex.push(this.sections.length - 1);
    }
    getNextImageSectionCharCode() {
        if (!this.imageSectionID) {
            this.imageSectionID = PUAbegin;
            return this.imageSectionID;
        }
        if (this.imageSectionID >= PUAend)
            return null;
        return ++this.imageSectionID;
    }
}
function breakLines(input, lineBreakPoints) {
    const lines = [];
    const text = input.text;
    let start = 0;
    for (const lineBreak of lineBreakPoints) {
        lines.push(input.substring(start, lineBreak));
        start = lineBreak;
    }
    if (start < text.length) {
        lines.push(input.substring(start, text.length));
    }
    return lines;
}
function shapeText(text, glyphMap, glyphPositions, imagePositions, defaultFontStack, maxWidth, lineHeight, textAnchor, textJustify, spacing, translate, writingMode, allowVerticalPlacement, layoutTextSize, layoutTextSizeThisZoom) {
    const logicalInput = TaggedString.fromFeature(text, defaultFontStack);
    if (writingMode === exports.ai.vertical) {
        logicalInput.verticalizePunctuation();
    }
    let lines;
    const { processBidirectionalText, processStyledBidirectionalText } = rtlWorkerPlugin;
    if (processBidirectionalText && logicalInput.sections.length === 1) {
        // Bidi doesn't have to be style-aware
        lines = [];
        const untaggedLines = processBidirectionalText(logicalInput.toString(), determineLineBreaks(logicalInput, spacing, maxWidth, glyphMap, imagePositions, layoutTextSize));
        for (const line of untaggedLines) {
            const taggedLine = new TaggedString();
            taggedLine.text = line;
            taggedLine.sections = logicalInput.sections;
            for (let i = 0; i < line.length; i++) {
                taggedLine.sectionIndex.push(0);
            }
            lines.push(taggedLine);
        }
    }
    else if (processStyledBidirectionalText) {
        // Need version of mapbox-gl-rtl-text with style support for combining RTL text
        // with formatting
        lines = [];
        const processedLines = processStyledBidirectionalText(logicalInput.text, logicalInput.sectionIndex, determineLineBreaks(logicalInput, spacing, maxWidth, glyphMap, imagePositions, layoutTextSize));
        for (const line of processedLines) {
            const taggedLine = new TaggedString();
            taggedLine.text = line[0];
            taggedLine.sectionIndex = line[1];
            taggedLine.sections = logicalInput.sections;
            lines.push(taggedLine);
        }
    }
    else {
        lines = breakLines(logicalInput, determineLineBreaks(logicalInput, spacing, maxWidth, glyphMap, imagePositions, layoutTextSize));
    }
    const positionedLines = [];
    const shaping = {
        positionedLines,
        text: logicalInput.toString(),
        top: translate[1],
        bottom: translate[1],
        left: translate[0],
        right: translate[0],
        writingMode,
        iconsInText: false,
        verticalizable: false
    };
    shapeLines(shaping, glyphMap, glyphPositions, imagePositions, lines, lineHeight, textAnchor, textJustify, writingMode, spacing, allowVerticalPlacement, layoutTextSizeThisZoom);
    if (isEmpty(positionedLines))
        return false;
    return shaping;
}
// using computed properties due to https://github.com/facebook/flow/issues/380
/* eslint no-useless-computed-key: 0 */
const whitespace = {
    [0x09]: true, // tab
    [0x0a]: true, // newline
    [0x0b]: true, // vertical tab
    [0x0c]: true, // form feed
    [0x0d]: true, // carriage return
    [0x20]: true, // space
};
const breakable = {
    [0x0a]: true, // newline
    [0x20]: true, // space
    [0x26]: true, // ampersand
    [0x29]: true, // right parenthesis
    [0x2b]: true, // plus sign
    [0x2d]: true, // hyphen-minus
    [0x2f]: true, // solidus
    [0xad]: true, // soft hyphen
    [0xb7]: true, // middle dot
    [0x200b]: true, // zero-width space
    [0x2010]: true, // hyphen
    [0x2013]: true, // en dash
    [0x2027]: true // interpunct
    // Many other characters may be reasonable breakpoints
    // Consider "neutral orientation" characters at scriptDetection.charHasNeutralVerticalOrientation
    // See https://github.com/mapbox/mapbox-gl-js/issues/3658
};
// Allow breaks depending on the following character
const breakableBefore = {
    [0x28]: true, // left parenthesis
};
function getGlyphAdvance(codePoint, section, glyphMap, imagePositions, spacing, layoutTextSize) {
    if (!section.imageName) {
        const positions = glyphMap[section.fontStack];
        const glyph = positions && positions[codePoint];
        if (!glyph)
            return 0;
        return glyph.metrics.advance * section.scale + spacing;
    }
    else {
        const imagePosition = imagePositions[section.imageName];
        if (!imagePosition)
            return 0;
        return imagePosition.displaySize[0] * section.scale * ONE_EM / layoutTextSize + spacing;
    }
}
function determineAverageLineWidth(logicalInput, spacing, maxWidth, glyphMap, imagePositions, layoutTextSize) {
    let totalWidth = 0;
    for (let index = 0; index < logicalInput.length(); index++) {
        const section = logicalInput.getSection(index);
        totalWidth += getGlyphAdvance(logicalInput.getCharCode(index), section, glyphMap, imagePositions, spacing, layoutTextSize);
    }
    const lineCount = Math.max(1, Math.ceil(totalWidth / maxWidth));
    return totalWidth / lineCount;
}
function calculateBadness(lineWidth, targetWidth, penalty, isLastBreak) {
    const raggedness = Math.pow(lineWidth - targetWidth, 2);
    if (isLastBreak) {
        // Favor finals lines shorter than average over longer than average
        if (lineWidth < targetWidth) {
            return raggedness / 2;
        }
        else {
            return raggedness * 2;
        }
    }
    return raggedness + Math.abs(penalty) * penalty;
}
function calculatePenalty(codePoint, nextCodePoint, penalizableIdeographicBreak) {
    let penalty = 0;
    // Force break on newline
    if (codePoint === 0x0a) {
        penalty -= 10000;
    }
    // Penalize breaks between characters that allow ideographic breaking because
    // they are less preferable than breaks at spaces (or zero width spaces).
    if (penalizableIdeographicBreak) {
        penalty += 150;
    }
    // Penalize open parenthesis at end of line
    if (codePoint === 0x28 || codePoint === 0xff08) {
        penalty += 50;
    }
    // Penalize close parenthesis at beginning of line
    if (nextCodePoint === 0x29 || nextCodePoint === 0xff09) {
        penalty += 50;
    }
    return penalty;
}
function evaluateBreak(breakIndex, breakX, targetWidth, potentialBreaks, penalty, isLastBreak) {
    // We could skip evaluating breaks where the line length (breakX - priorBreak.x) > maxWidth
    //  ...but in fact we allow lines longer than maxWidth (if there's no break points)
    //  ...and when targetWidth and maxWidth are close, strictly enforcing maxWidth can give
    //     more lopsided results.
    let bestPriorBreak = null;
    let bestBreakBadness = calculateBadness(breakX, targetWidth, penalty, isLastBreak);
    for (const potentialBreak of potentialBreaks) {
        const lineWidth = breakX - potentialBreak.x;
        const breakBadness = calculateBadness(lineWidth, targetWidth, penalty, isLastBreak) + potentialBreak.badness;
        if (breakBadness <= bestBreakBadness) {
            bestPriorBreak = potentialBreak;
            bestBreakBadness = breakBadness;
        }
    }
    return {
        index: breakIndex,
        x: breakX,
        priorBreak: bestPriorBreak,
        badness: bestBreakBadness
    };
}
function leastBadBreaks(lastLineBreak) {
    if (!lastLineBreak) {
        return [];
    }
    return leastBadBreaks(lastLineBreak.priorBreak).concat(lastLineBreak.index);
}
function determineLineBreaks(logicalInput, spacing, maxWidth, glyphMap, imagePositions, layoutTextSize) {
    if (!logicalInput)
        return [];
    const potentialLineBreaks = [];
    const targetWidth = determineAverageLineWidth(logicalInput, spacing, maxWidth, glyphMap, imagePositions, layoutTextSize);
    const hasServerSuggestedBreakpoints = logicalInput.text.indexOf('\u200b') >= 0;
    let currentX = 0;
    for (let i = 0; i < logicalInput.length(); i++) {
        const section = logicalInput.getSection(i);
        const codePoint = logicalInput.getCharCode(i);
        if (!whitespace[codePoint])
            currentX += getGlyphAdvance(codePoint, section, glyphMap, imagePositions, spacing, layoutTextSize);
        // Ideographic characters, spaces, and word-breaking punctuation that often appear without
        // surrounding spaces.
        if ((i < logicalInput.length() - 1)) {
            const ideographicBreak = charAllowsIdeographicBreaking(codePoint);
            if (breakable[codePoint] || ideographicBreak || section.imageName || (i !== logicalInput.length() - 2 && breakableBefore[logicalInput.getCharCode(i + 1)])) {
                potentialLineBreaks.push(evaluateBreak(i + 1, currentX, targetWidth, potentialLineBreaks, calculatePenalty(codePoint, logicalInput.getCharCode(i + 1), ideographicBreak && hasServerSuggestedBreakpoints), false));
            }
        }
    }
    return leastBadBreaks(evaluateBreak(logicalInput.length(), currentX, targetWidth, potentialLineBreaks, 0, true));
}
function getAnchorAlignment(anchor) {
    let horizontalAlign = 0.5, verticalAlign = 0.5;
    switch (anchor) {
        case 'right':
        case 'top-right':
        case 'bottom-right':
            horizontalAlign = 1;
            break;
        case 'left':
        case 'top-left':
        case 'bottom-left':
            horizontalAlign = 0;
            break;
    }
    switch (anchor) {
        case 'bottom':
        case 'bottom-right':
        case 'bottom-left':
            verticalAlign = 1;
            break;
        case 'top':
        case 'top-right':
        case 'top-left':
            verticalAlign = 0;
            break;
    }
    return { horizontalAlign, verticalAlign };
}
function shapeLines(shaping, glyphMap, glyphPositions, imagePositions, lines, lineHeight, textAnchor, textJustify, writingMode, spacing, allowVerticalPlacement, layoutTextSizeThisZoom) {
    let x = 0;
    let y = SHAPING_DEFAULT_OFFSET;
    let maxLineLength = 0;
    let maxLineHeight = 0;
    const justify = textJustify === 'right' ? 1 :
        textJustify === 'left' ? 0 : 0.5;
    let lineIndex = 0;
    for (const line of lines) {
        line.trim();
        const lineMaxScale = line.getMaxScale();
        const maxLineOffset = (lineMaxScale - 1) * ONE_EM;
        const positionedLine = { positionedGlyphs: [], lineOffset: 0 };
        shaping.positionedLines[lineIndex] = positionedLine;
        const positionedGlyphs = positionedLine.positionedGlyphs;
        let lineOffset = 0.0;
        if (!line.length()) {
            y += lineHeight; // Still need a line feed after empty line
            ++lineIndex;
            continue;
        }
        for (let i = 0; i < line.length(); i++) {
            const section = line.getSection(i);
            const sectionIndex = line.getSectionIndex(i);
            const codePoint = line.getCharCode(i);
            let baselineOffset = 0.0;
            let metrics = null;
            let rect = null;
            let imageName = null;
            let verticalAdvance = ONE_EM;
            const vertical = !(writingMode === exports.ai.horizontal ||
                // Don't verticalize glyphs that have no upright orientation if vertical placement is disabled.
                (!allowVerticalPlacement && !charHasUprightVerticalOrientation(codePoint)) ||
                // If vertical placement is enabled, don't verticalize glyphs that
                // are from complex text layout script, or whitespaces.
                (allowVerticalPlacement && (whitespace[codePoint] || charInComplexShapingScript(codePoint))));
            if (!section.imageName) {
                const positions = glyphPositions[section.fontStack];
                const glyphPosition = positions && positions[codePoint];
                if (glyphPosition && glyphPosition.rect) {
                    rect = glyphPosition.rect;
                    metrics = glyphPosition.metrics;
                }
                else {
                    const glyphs = glyphMap[section.fontStack];
                    const glyph = glyphs && glyphs[codePoint];
                    if (!glyph)
                        continue;
                    metrics = glyph.metrics;
                }
                // We don't know the baseline, but since we're laying out
                // at 24 points, we can calculate how much it will move when
                // we scale up or down.
                baselineOffset = (lineMaxScale - section.scale) * ONE_EM;
            }
            else {
                const imagePosition = imagePositions[section.imageName];
                if (!imagePosition)
                    continue;
                imageName = section.imageName;
                shaping.iconsInText = shaping.iconsInText || true;
                rect = imagePosition.paddedRect;
                const size = imagePosition.displaySize;
                // If needed, allow to set scale factor for an image using
                // alias "image-scale" that could be alias for "font-scale"
                // when FormattedSection is an image section.
                section.scale = section.scale * ONE_EM / layoutTextSizeThisZoom;
                metrics = { width: size[0],
                    height: size[1],
                    left: IMAGE_PADDING,
                    top: -GLYPH_PBF_BORDER,
                    advance: vertical ? size[1] : size[0] };
                // Difference between one EM and an image size.
                // Aligns bottom of an image to a baseline level.
                const imageOffset = ONE_EM - size[1] * section.scale;
                baselineOffset = maxLineOffset + imageOffset;
                verticalAdvance = metrics.advance;
                // Difference between height of an image and one EM at max line scale.
                // Pushes current line down if an image size is over 1 EM at max line scale.
                const offset = vertical ? size[0] * section.scale - ONE_EM * lineMaxScale :
                    size[1] * section.scale - ONE_EM * lineMaxScale;
                if (offset > 0 && offset > lineOffset) {
                    lineOffset = offset;
                }
            }
            if (!vertical) {
                positionedGlyphs.push({ glyph: codePoint, imageName, x, y: y + baselineOffset, vertical, scale: section.scale, fontStack: section.fontStack, sectionIndex, metrics, rect });
                x += metrics.advance * section.scale + spacing;
            }
            else {
                shaping.verticalizable = true;
                positionedGlyphs.push({ glyph: codePoint, imageName, x, y: y + baselineOffset, vertical, scale: section.scale, fontStack: section.fontStack, sectionIndex, metrics, rect });
                x += verticalAdvance * section.scale + spacing;
            }
        }
        // Only justify if we placed at least one glyph
        if (positionedGlyphs.length !== 0) {
            const lineLength = x - spacing;
            maxLineLength = Math.max(lineLength, maxLineLength);
            justifyLine(positionedGlyphs, 0, positionedGlyphs.length - 1, justify, lineOffset);
        }
        x = 0;
        const currentLineHeight = lineHeight * lineMaxScale + lineOffset;
        positionedLine.lineOffset = Math.max(lineOffset, maxLineOffset);
        y += currentLineHeight;
        maxLineHeight = Math.max(currentLineHeight, maxLineHeight);
        ++lineIndex;
    }
    // Calculate the bounding box and justify / align text block.
    const height = y - SHAPING_DEFAULT_OFFSET;
    const { horizontalAlign, verticalAlign } = getAnchorAlignment(textAnchor);
    align(shaping.positionedLines, justify, horizontalAlign, verticalAlign, maxLineLength, maxLineHeight, lineHeight, height, lines.length);
    shaping.top += -verticalAlign * height;
    shaping.bottom = shaping.top + height;
    shaping.left += -horizontalAlign * maxLineLength;
    shaping.right = shaping.left + maxLineLength;
}
// justify right = 1, left = 0, center = 0.5
function justifyLine(positionedGlyphs, start, end, justify, lineOffset) {
    if (!justify && !lineOffset)
        return;
    const lastPositionedGlyph = positionedGlyphs[end];
    const lastAdvance = lastPositionedGlyph.metrics.advance * lastPositionedGlyph.scale;
    const lineIndent = (positionedGlyphs[end].x + lastAdvance) * justify;
    for (let j = start; j <= end; j++) {
        positionedGlyphs[j].x -= lineIndent;
        positionedGlyphs[j].y += lineOffset;
    }
}
function align(positionedLines, justify, horizontalAlign, verticalAlign, maxLineLength, maxLineHeight, lineHeight, blockHeight, lineCount) {
    const shiftX = (justify - horizontalAlign) * maxLineLength;
    let shiftY = 0;
    if (maxLineHeight !== lineHeight) {
        shiftY = -blockHeight * verticalAlign - SHAPING_DEFAULT_OFFSET;
    }
    else {
        shiftY = (-verticalAlign * lineCount + 0.5) * lineHeight;
    }
    for (const line of positionedLines) {
        for (const positionedGlyph of line.positionedGlyphs) {
            positionedGlyph.x += shiftX;
            positionedGlyph.y += shiftY;
        }
    }
}
function shapeIcon(image, iconOffset, iconAnchor) {
    const { horizontalAlign, verticalAlign } = getAnchorAlignment(iconAnchor);
    const dx = iconOffset[0];
    const dy = iconOffset[1];
    const x1 = dx - image.displaySize[0] * horizontalAlign;
    const x2 = x1 + image.displaySize[0];
    const y1 = dy - image.displaySize[1] * verticalAlign;
    const y2 = y1 + image.displaySize[1];
    return { image, top: y1, bottom: y2, left: x1, right: x2 };
}
/**
 * Called after a PositionedIcon has already been run through fitIconToText,
 * but needs further adjustment to apply textFitWidth and textFitHeight.
 * @param shapedIcon - The icon that will be adjusted.
 * @returns Extents of the shapedIcon with text fit adjustments if necessary.
 */
function applyTextFit(shapedIcon) {
    var _a, _b;
    // Assume shapedIcon.image is set or this wouldn't be called.
    // Size of the icon after it was adjusted using stretchX and Y
    let iconLeft = shapedIcon.left;
    let iconTop = shapedIcon.top;
    let iconWidth = shapedIcon.right - iconLeft;
    let iconHeight = shapedIcon.bottom - iconTop;
    // Size of the original content area
    const contentWidth = shapedIcon.image.content[2] - shapedIcon.image.content[0];
    const contentHeight = shapedIcon.image.content[3] - shapedIcon.image.content[1];
    const textFitWidth = (_a = shapedIcon.image.textFitWidth) !== null && _a !== void 0 ? _a : "stretchOrShrink" /* TextFit.stretchOrShrink */;
    const textFitHeight = (_b = shapedIcon.image.textFitHeight) !== null && _b !== void 0 ? _b : "stretchOrShrink" /* TextFit.stretchOrShrink */;
    const contentAspectRatio = contentWidth / contentHeight;
    // Scale to the proportional axis first note that height takes precedence if
    // both axes are set to proportional.
    if (textFitHeight === "proportional" /* TextFit.proportional */) {
        if ((textFitWidth === "stretchOnly" /* TextFit.stretchOnly */ && iconWidth / iconHeight < contentAspectRatio) || textFitWidth === "proportional" /* TextFit.proportional */) {
            // Push the width of the icon back out to match the content aspect ratio
            const newIconWidth = Math.ceil(iconHeight * contentAspectRatio);
            iconLeft *= newIconWidth / iconWidth;
            iconWidth = newIconWidth;
        }
    }
    else if (textFitWidth === "proportional" /* TextFit.proportional */) {
        if (textFitHeight === "stretchOnly" /* TextFit.stretchOnly */ && contentAspectRatio !== 0 && iconWidth / iconHeight > contentAspectRatio) {
            // Push the height of the icon back out to match the content aspect ratio
            const newIconHeight = Math.ceil(iconWidth / contentAspectRatio);
            iconTop *= newIconHeight / iconHeight;
            iconHeight = newIconHeight;
        }
    }
    else ;
    return { x1: iconLeft, y1: iconTop, x2: iconLeft + iconWidth, y2: iconTop + iconHeight };
}
function fitIconToText(shapedIcon, shapedText, textFit, padding, iconOffset, fontScale) {
    const image = shapedIcon.image;
    let collisionPadding;
    if (image.content) {
        const content = image.content;
        const pixelRatio = image.pixelRatio || 1;
        collisionPadding = [
            content[0] / pixelRatio,
            content[1] / pixelRatio,
            image.displaySize[0] - content[2] / pixelRatio,
            image.displaySize[1] - content[3] / pixelRatio
        ];
    }
    // We don't respect the icon-anchor, because icon-text-fit is set. Instead,
    // the icon will be centered on the text, then stretched in the given
    // dimensions.
    const textLeft = shapedText.left * fontScale;
    const textRight = shapedText.right * fontScale;
    let top, right, bottom, left;
    if (textFit === 'width' || textFit === 'both') {
        // Stretched horizontally to the text width
        left = iconOffset[0] + textLeft - padding[3];
        right = iconOffset[0] + textRight + padding[1];
    }
    else {
        // Centered on the text
        left = iconOffset[0] + (textLeft + textRight - image.displaySize[0]) / 2;
        right = left + image.displaySize[0];
    }
    const textTop = shapedText.top * fontScale;
    const textBottom = shapedText.bottom * fontScale;
    if (textFit === 'height' || textFit === 'both') {
        // Stretched vertically to the text height
        top = iconOffset[1] + textTop - padding[0];
        bottom = iconOffset[1] + textBottom + padding[2];
    }
    else {
        // Centered on the text
        top = iconOffset[1] + (textTop + textBottom - image.displaySize[1]) / 2;
        bottom = top + image.displaySize[1];
    }
    return { image, top, right, bottom, left, collisionPadding };
}

const MAX_GLYPH_ICON_SIZE = 255;
const SIZE_PACK_FACTOR = 128;
const MAX_PACKED_SIZE = MAX_GLYPH_ICON_SIZE * SIZE_PACK_FACTOR;
// For {text,icon}-size, get the bucket-level data that will be needed by
// the painter to set symbol-size-related uniforms
function getSizeData(tileZoom, value) {
    const { expression } = value;
    if (expression.kind === 'constant') {
        const layoutSize = expression.evaluate(new EvaluationParameters(tileZoom + 1));
        return { kind: 'constant', layoutSize };
    }
    else if (expression.kind === 'source') {
        return { kind: 'source' };
    }
    else {
        const { zoomStops, interpolationType } = expression;
        // calculate covering zoom stops for zoom-dependent values
        let lower = 0;
        while (lower < zoomStops.length && zoomStops[lower] <= tileZoom)
            lower++;
        lower = Math.max(0, lower - 1);
        let upper = lower;
        while (upper < zoomStops.length && zoomStops[upper] < tileZoom + 1)
            upper++;
        upper = Math.min(zoomStops.length - 1, upper);
        const minZoom = zoomStops[lower];
        const maxZoom = zoomStops[upper];
        // We'd like to be able to use CameraExpression or CompositeExpression in these
        // return types rather than ExpressionSpecification, but the former are not
        // transferrable across Web Worker boundaries.
        if (expression.kind === 'composite') {
            return { kind: 'composite', minZoom, maxZoom, interpolationType };
        }
        // for camera functions, also save off the function values
        // evaluated at the covering zoom levels
        const minSize = expression.evaluate(new EvaluationParameters(minZoom));
        const maxSize = expression.evaluate(new EvaluationParameters(maxZoom));
        return { kind: 'camera', minZoom, maxZoom, minSize, maxSize, interpolationType };
    }
}
function evaluateSizeForFeature(sizeData, { uSize, uSizeT }, { lowerSize, upperSize }) {
    if (sizeData.kind === 'source') {
        return lowerSize / SIZE_PACK_FACTOR;
    }
    else if (sizeData.kind === 'composite') {
        return interpolate.number(lowerSize / SIZE_PACK_FACTOR, upperSize / SIZE_PACK_FACTOR, uSizeT);
    }
    return uSize;
}
function evaluateSizeForZoom(sizeData, zoom) {
    let uSizeT = 0;
    let uSize = 0;
    if (sizeData.kind === 'constant') {
        uSize = sizeData.layoutSize;
    }
    else if (sizeData.kind !== 'source') {
        const { interpolationType, minZoom, maxZoom } = sizeData;
        // Even though we could get the exact value of the camera function
        // at z = tr.zoom, we intentionally do not: instead, we interpolate
        // between the camera function values at a pair of zoom stops covering
        // [tileZoom, tileZoom + 1] in order to be consistent with this
        // restriction on composite functions
        const t = !interpolationType ? 0 : clamp$1(Interpolate.interpolationFactor(interpolationType, zoom, minZoom, maxZoom), 0, 1);
        if (sizeData.kind === 'camera') {
            uSize = interpolate.number(sizeData.minSize, sizeData.maxSize, t);
        }
        else {
            uSizeT = t;
        }
    }
    return { uSizeT, uSize };
}

function getOverlapMode(layout, overlapProp, allowOverlapProp) {
    let result = 'never';
    const overlap = layout.get(overlapProp);
    if (overlap) {
        // if -overlap is set, use it
        result = overlap;
    }
    else if (layout.get(allowOverlapProp)) {
        // fall back to -allow-overlap, with false='never', true='always'
        result = 'always';
    }
    return result;
}

const vectorTileFeatureTypes = vectorTile.VectorTileFeature.types;
// Opacity arrays are frequently updated but don't contain a lot of information, so we pack them
// tight. Each Uint32 is actually four duplicate Uint8s for the four corners of a glyph
// 7 bits are for the current opacity, and the lowest bit is the target opacity
// actually defined in symbol_attributes.js
// const placementOpacityAttributes = [
//     { name: 'a_fade_opacity', components: 1, type: 'Uint32' }
// ];
const shaderOpacityAttributes = [
    { name: 'a_fade_opacity', components: 1, type: 'Uint8', offset: 0 }
];
function addVertex(array, anchorX, anchorY, ox, oy, tx, ty, sizeVertex, isSDF, pixelOffsetX, pixelOffsetY, minFontScaleX, minFontScaleY) {
    const aSizeX = sizeVertex ? Math.min(MAX_PACKED_SIZE, Math.round(sizeVertex[0])) : 0;
    const aSizeY = sizeVertex ? Math.min(MAX_PACKED_SIZE, Math.round(sizeVertex[1])) : 0;
    array.emplaceBack(
    // a_pos_offset
    anchorX, anchorY, Math.round(ox * 32), Math.round(oy * 32), 
    // a_data
    tx, // x coordinate of symbol on glyph atlas texture
    ty, // y coordinate of symbol on glyph atlas texture
    (aSizeX << 1) + (isSDF ? 1 : 0), aSizeY, pixelOffsetX * 16, pixelOffsetY * 16, minFontScaleX * 256, minFontScaleY * 256);
}
function addDynamicAttributes(dynamicLayoutVertexArray, p, angle) {
    dynamicLayoutVertexArray.emplaceBack(p.x, p.y, angle);
    dynamicLayoutVertexArray.emplaceBack(p.x, p.y, angle);
    dynamicLayoutVertexArray.emplaceBack(p.x, p.y, angle);
    dynamicLayoutVertexArray.emplaceBack(p.x, p.y, angle);
}
function containsRTLText(formattedText) {
    for (const section of formattedText.sections) {
        if (stringContainsRTLText(section.text)) {
            return true;
        }
    }
    return false;
}
class SymbolBuffers {
    constructor(programConfigurations) {
        this.layoutVertexArray = new SymbolLayoutArray();
        this.indexArray = new TriangleIndexArray();
        this.programConfigurations = programConfigurations;
        this.segments = new SegmentVector();
        this.dynamicLayoutVertexArray = new SymbolDynamicLayoutArray();
        this.opacityVertexArray = new SymbolOpacityArray();
        this.hasVisibleVertices = false;
        this.placedSymbolArray = new PlacedSymbolArray();
    }
    isEmpty() {
        return this.layoutVertexArray.length === 0 &&
            this.indexArray.length === 0 &&
            this.dynamicLayoutVertexArray.length === 0 &&
            this.opacityVertexArray.length === 0;
    }
    upload(context, dynamicIndexBuffer, upload, update) {
        if (this.isEmpty()) {
            return;
        }
        if (upload) {
            this.layoutVertexBuffer = context.createVertexBuffer(this.layoutVertexArray, symbolLayoutAttributes.members);
            this.indexBuffer = context.createIndexBuffer(this.indexArray, dynamicIndexBuffer);
            this.dynamicLayoutVertexBuffer = context.createVertexBuffer(this.dynamicLayoutVertexArray, dynamicLayoutAttributes.members, true);
            this.opacityVertexBuffer = context.createVertexBuffer(this.opacityVertexArray, shaderOpacityAttributes, true);
            // This is a performance hack so that we can write to opacityVertexArray with uint32s
            // even though the shaders read uint8s
            this.opacityVertexBuffer.itemSize = 1;
        }
        if (upload || update) {
            this.programConfigurations.upload(context);
        }
    }
    destroy() {
        if (!this.layoutVertexBuffer)
            return;
        this.layoutVertexBuffer.destroy();
        this.indexBuffer.destroy();
        this.programConfigurations.destroy();
        this.segments.destroy();
        this.dynamicLayoutVertexBuffer.destroy();
        this.opacityVertexBuffer.destroy();
    }
}
register('SymbolBuffers', SymbolBuffers);
class CollisionBuffers {
    constructor(LayoutArray, layoutAttributes, IndexArray) {
        this.layoutVertexArray = new LayoutArray();
        this.layoutAttributes = layoutAttributes;
        this.indexArray = new IndexArray();
        this.segments = new SegmentVector();
        this.collisionVertexArray = new CollisionVertexArray();
    }
    upload(context) {
        this.layoutVertexBuffer = context.createVertexBuffer(this.layoutVertexArray, this.layoutAttributes);
        this.indexBuffer = context.createIndexBuffer(this.indexArray);
        this.collisionVertexBuffer = context.createVertexBuffer(this.collisionVertexArray, collisionVertexAttributes.members, true);
    }
    destroy() {
        if (!this.layoutVertexBuffer)
            return;
        this.layoutVertexBuffer.destroy();
        this.indexBuffer.destroy();
        this.segments.destroy();
        this.collisionVertexBuffer.destroy();
    }
}
register('CollisionBuffers', CollisionBuffers);
/**
 * @internal
 * Unlike other buckets, which simply implement #addFeature with type-specific
 * logic for (essentially) triangulating feature geometries, SymbolBucket
 * requires specialized behavior:
 *
 * 1. WorkerTile#parse(), the logical owner of the bucket creation process,
 *    calls SymbolBucket#populate(), which resolves text and icon tokens on
 *    each feature, adds each glyphs and symbols needed to the passed-in
 *    collections options.glyphDependencies and options.iconDependencies, and
 *    stores the feature data for use in subsequent step (this.features).
 *
 * 2. WorkerTile asynchronously requests from the main thread all of the glyphs
 *    and icons needed (by this bucket and any others). When glyphs and icons
 *    have been received, the WorkerTile creates a CollisionIndex and invokes:
 *
 * 3. performSymbolLayout(bucket, stacks, icons) perform texts shaping and
 *    layout on a Symbol Bucket. This step populates:
 *      `this.symbolInstances`: metadata on generated symbols
 *      `this.collisionBoxArray`: collision data for use by foreground
 *      `this.text`: SymbolBuffers for text symbols
 *      `this.icons`: SymbolBuffers for icons
 *      `this.iconCollisionBox`: Debug SymbolBuffers for icon collision boxes
 *      `this.textCollisionBox`: Debug SymbolBuffers for text collision boxes
 *    The results are sent to the foreground for rendering
 *
 * 4. placement.ts is run on the foreground,
 *    and uses the CollisionIndex along with current camera settings to determine
 *    which symbols can actually show on the map. Collided symbols are hidden
 *    using a dynamic "OpacityVertexArray".
 */
class SymbolBucket {
    constructor(options) {
        this.collisionBoxArray = options.collisionBoxArray;
        this.zoom = options.zoom;
        this.overscaling = options.overscaling;
        this.layers = options.layers;
        this.layerIds = this.layers.map(layer => layer.id);
        this.index = options.index;
        this.pixelRatio = options.pixelRatio;
        this.sourceLayerIndex = options.sourceLayerIndex;
        this.hasPattern = false;
        this.hasRTLText = false;
        this.sortKeyRanges = [];
        this.collisionCircleArray = [];
        this.placementInvProjMatrix = identity([]);
        this.placementViewportMatrix = identity([]);
        const layer = this.layers[0];
        const unevaluatedLayoutValues = layer._unevaluatedLayout._values;
        this.textSizeData = getSizeData(this.zoom, unevaluatedLayoutValues['text-size']);
        this.iconSizeData = getSizeData(this.zoom, unevaluatedLayoutValues['icon-size']);
        const layout = this.layers[0].layout;
        const sortKey = layout.get('symbol-sort-key');
        const zOrder = layout.get('symbol-z-order');
        this.canOverlap =
            getOverlapMode(layout, 'text-overlap', 'text-allow-overlap') !== 'never' ||
                getOverlapMode(layout, 'icon-overlap', 'icon-allow-overlap') !== 'never' ||
                layout.get('text-ignore-placement') ||
                layout.get('icon-ignore-placement');
        this.sortFeaturesByKey = zOrder !== 'viewport-y' && !sortKey.isConstant();
        const zOrderByViewportY = zOrder === 'viewport-y' || (zOrder === 'auto' && !this.sortFeaturesByKey);
        this.sortFeaturesByY = zOrderByViewportY && this.canOverlap;
        if (layout.get('symbol-placement') === 'point') {
            this.writingModes = layout.get('text-writing-mode').map(wm => exports.ai[wm]);
        }
        this.stateDependentLayerIds = this.layers.filter((l) => l.isStateDependent()).map((l) => l.id);
        this.sourceID = options.sourceID;
    }
    createArrays() {
        this.text = new SymbolBuffers(new ProgramConfigurationSet(this.layers, this.zoom, property => /^text/.test(property)));
        this.icon = new SymbolBuffers(new ProgramConfigurationSet(this.layers, this.zoom, property => /^icon/.test(property)));
        this.glyphOffsetArray = new GlyphOffsetArray();
        this.lineVertexArray = new SymbolLineVertexArray();
        this.symbolInstances = new SymbolInstanceArray();
        this.textAnchorOffsets = new TextAnchorOffsetArray();
    }
    calculateGlyphDependencies(text, stack, textAlongLine, allowVerticalPlacement, doesAllowVerticalWritingMode) {
        for (let i = 0; i < text.length; i++) {
            stack[text.charCodeAt(i)] = true;
            if ((textAlongLine || allowVerticalPlacement) && doesAllowVerticalWritingMode) {
                const verticalChar = verticalizedCharacterMap[text.charAt(i)];
                if (verticalChar) {
                    stack[verticalChar.charCodeAt(0)] = true;
                }
            }
        }
    }
    populate(features, options, canonical) {
        const layer = this.layers[0];
        const layout = layer.layout;
        const textFont = layout.get('text-font');
        const textField = layout.get('text-field');
        const iconImage = layout.get('icon-image');
        const hasText = (textField.value.kind !== 'constant' ||
            (textField.value.value instanceof Formatted && !textField.value.value.isEmpty()) ||
            textField.value.value.toString().length > 0) &&
            (textFont.value.kind !== 'constant' || textFont.value.value.length > 0);
        // we should always resolve the icon-image value if the property was defined in the style
        // this allows us to fire the styleimagemissing event if image evaluation returns null
        // the only way to distinguish between null returned from a coalesce statement with no valid images
        // and null returned because icon-image wasn't defined is to check whether or not iconImage.parameters is an empty object
        const hasIcon = iconImage.value.kind !== 'constant' || !!iconImage.value.value || Object.keys(iconImage.parameters).length > 0;
        const symbolSortKey = layout.get('symbol-sort-key');
        this.features = [];
        if (!hasText && !hasIcon) {
            return;
        }
        const icons = options.iconDependencies;
        const stacks = options.glyphDependencies;
        const availableImages = options.availableImages;
        const globalProperties = new EvaluationParameters(this.zoom);
        for (const { feature, id, index, sourceLayerIndex } of features) {
            const needGeometry = layer._featureFilter.needGeometry;
            const evaluationFeature = toEvaluationFeature(feature, needGeometry);
            if (!layer._featureFilter.filter(globalProperties, evaluationFeature, canonical)) {
                continue;
            }
            if (!needGeometry)
                evaluationFeature.geometry = loadGeometry(feature);
            let text;
            if (hasText) {
                // Expression evaluation will automatically coerce to Formatted
                // but plain string token evaluation skips that pathway so do the
                // conversion here.
                const resolvedTokens = layer.getValueAndResolveTokens('text-field', evaluationFeature, canonical, availableImages);
                const formattedText = Formatted.factory(resolvedTokens);
                // on this instance: if hasRTLText is already true, all future calls to containsRTLText can be skipped.
                const bucketHasRTLText = this.hasRTLText = (this.hasRTLText || containsRTLText(formattedText));
                if (!bucketHasRTLText || // non-rtl text so can proceed safely
                    rtlWorkerPlugin.getRTLTextPluginStatus() === 'unavailable' || // We don't intend to lazy-load the rtl text plugin, so proceed with incorrect shaping
                    bucketHasRTLText && rtlWorkerPlugin.isParsed() // Use the rtlText plugin to shape text
                ) {
                    text = transformText(formattedText, layer, evaluationFeature);
                }
            }
            let icon;
            if (hasIcon) {
                // Expression evaluation will automatically coerce to Image
                // but plain string token evaluation skips that pathway so do the
                // conversion here.
                const resolvedTokens = layer.getValueAndResolveTokens('icon-image', evaluationFeature, canonical, availableImages);
                if (resolvedTokens instanceof ResolvedImage) {
                    icon = resolvedTokens;
                }
                else {
                    icon = ResolvedImage.fromString(resolvedTokens);
                }
            }
            if (!text && !icon) {
                continue;
            }
            const sortKey = this.sortFeaturesByKey ?
                symbolSortKey.evaluate(evaluationFeature, {}, canonical) :
                undefined;
            const symbolFeature = {
                id,
                text,
                icon,
                index,
                sourceLayerIndex,
                geometry: evaluationFeature.geometry,
                properties: feature.properties,
                type: vectorTileFeatureTypes[feature.type],
                sortKey
            };
            this.features.push(symbolFeature);
            if (icon) {
                icons[icon.name] = true;
            }
            if (text) {
                const fontStack = textFont.evaluate(evaluationFeature, {}, canonical).join(',');
                const textAlongLine = layout.get('text-rotation-alignment') !== 'viewport' && layout.get('symbol-placement') !== 'point';
                this.allowVerticalPlacement = this.writingModes && this.writingModes.indexOf(exports.ai.vertical) >= 0;
                for (const section of text.sections) {
                    if (!section.image) {
                        const doesAllowVerticalWritingMode = allowsVerticalWritingMode(text.toString());
                        const sectionFont = section.fontStack || fontStack;
                        const sectionStack = stacks[sectionFont] = stacks[sectionFont] || {};
                        this.calculateGlyphDependencies(section.text, sectionStack, textAlongLine, this.allowVerticalPlacement, doesAllowVerticalWritingMode);
                    }
                    else {
                        // Add section image to the list of dependencies.
                        icons[section.image.name] = true;
                    }
                }
            }
        }
        if (layout.get('symbol-placement') === 'line') {
            // Merge adjacent lines with the same text to improve labelling.
            // It's better to place labels on one long line than on many short segments.
            this.features = mergeLines(this.features);
        }
        if (this.sortFeaturesByKey) {
            this.features.sort((a, b) => {
                // a.sortKey is always a number when sortFeaturesByKey is true
                return a.sortKey - b.sortKey;
            });
        }
    }
    update(states, vtLayer, imagePositions) {
        if (!this.stateDependentLayers.length)
            return;
        this.text.programConfigurations.updatePaintArrays(states, vtLayer, this.layers, imagePositions);
        this.icon.programConfigurations.updatePaintArrays(states, vtLayer, this.layers, imagePositions);
    }
    isEmpty() {
        // When the bucket encounters only rtl-text but the plugin isn't loaded, no symbol instances will be created.
        // In order for the bucket to be serialized, and not discarded as an empty bucket both checks are necessary.
        return this.symbolInstances.length === 0 && !this.hasRTLText;
    }
    uploadPending() {
        return !this.uploaded || this.text.programConfigurations.needsUpload || this.icon.programConfigurations.needsUpload;
    }
    upload(context) {
        if (!this.uploaded && this.hasDebugData()) {
            this.textCollisionBox.upload(context);
            this.iconCollisionBox.upload(context);
        }
        this.text.upload(context, this.sortFeaturesByY, !this.uploaded, this.text.programConfigurations.needsUpload);
        this.icon.upload(context, this.sortFeaturesByY, !this.uploaded, this.icon.programConfigurations.needsUpload);
        this.uploaded = true;
    }
    destroyDebugData() {
        this.textCollisionBox.destroy();
        this.iconCollisionBox.destroy();
    }
    destroy() {
        this.text.destroy();
        this.icon.destroy();
        if (this.hasDebugData()) {
            this.destroyDebugData();
        }
    }
    addToLineVertexArray(anchor, line) {
        const lineStartIndex = this.lineVertexArray.length;
        if (anchor.segment !== undefined) {
            let sumForwardLength = anchor.dist(line[anchor.segment + 1]);
            let sumBackwardLength = anchor.dist(line[anchor.segment]);
            const vertices = {};
            for (let i = anchor.segment + 1; i < line.length; i++) {
                vertices[i] = { x: line[i].x, y: line[i].y, tileUnitDistanceFromAnchor: sumForwardLength };
                if (i < line.length - 1) {
                    sumForwardLength += line[i + 1].dist(line[i]);
                }
            }
            for (let i = anchor.segment || 0; i >= 0; i--) {
                vertices[i] = { x: line[i].x, y: line[i].y, tileUnitDistanceFromAnchor: sumBackwardLength };
                if (i > 0) {
                    sumBackwardLength += line[i - 1].dist(line[i]);
                }
            }
            for (let i = 0; i < line.length; i++) {
                const vertex = vertices[i];
                this.lineVertexArray.emplaceBack(vertex.x, vertex.y, vertex.tileUnitDistanceFromAnchor);
            }
        }
        return {
            lineStartIndex,
            lineLength: this.lineVertexArray.length - lineStartIndex
        };
    }
    addSymbols(arrays, quads, sizeVertex, lineOffset, alongLine, feature, writingMode, labelAnchor, lineStartIndex, lineLength, associatedIconIndex, canonical) {
        const indexArray = arrays.indexArray;
        const layoutVertexArray = arrays.layoutVertexArray;
        const segment = arrays.segments.prepareSegment(4 * quads.length, layoutVertexArray, indexArray, this.canOverlap ? feature.sortKey : undefined);
        const glyphOffsetArrayStart = this.glyphOffsetArray.length;
        const vertexStartIndex = segment.vertexLength;
        const angle = (this.allowVerticalPlacement && writingMode === exports.ai.vertical) ? Math.PI / 2 : 0;
        const sections = feature.text && feature.text.sections;
        for (let i = 0; i < quads.length; i++) {
            const { tl, tr, bl, br, tex, pixelOffsetTL, pixelOffsetBR, minFontScaleX, minFontScaleY, glyphOffset, isSDF, sectionIndex } = quads[i];
            const index = segment.vertexLength;
            const y = glyphOffset[1];
            addVertex(layoutVertexArray, labelAnchor.x, labelAnchor.y, tl.x, y + tl.y, tex.x, tex.y, sizeVertex, isSDF, pixelOffsetTL.x, pixelOffsetTL.y, minFontScaleX, minFontScaleY);
            addVertex(layoutVertexArray, labelAnchor.x, labelAnchor.y, tr.x, y + tr.y, tex.x + tex.w, tex.y, sizeVertex, isSDF, pixelOffsetBR.x, pixelOffsetTL.y, minFontScaleX, minFontScaleY);
            addVertex(layoutVertexArray, labelAnchor.x, labelAnchor.y, bl.x, y + bl.y, tex.x, tex.y + tex.h, sizeVertex, isSDF, pixelOffsetTL.x, pixelOffsetBR.y, minFontScaleX, minFontScaleY);
            addVertex(layoutVertexArray, labelAnchor.x, labelAnchor.y, br.x, y + br.y, tex.x + tex.w, tex.y + tex.h, sizeVertex, isSDF, pixelOffsetBR.x, pixelOffsetBR.y, minFontScaleX, minFontScaleY);
            addDynamicAttributes(arrays.dynamicLayoutVertexArray, labelAnchor, angle);
            indexArray.emplaceBack(index, index + 1, index + 2);
            indexArray.emplaceBack(index + 1, index + 2, index + 3);
            segment.vertexLength += 4;
            segment.primitiveLength += 2;
            this.glyphOffsetArray.emplaceBack(glyphOffset[0]);
            if (i === quads.length - 1 || sectionIndex !== quads[i + 1].sectionIndex) {
                arrays.programConfigurations.populatePaintArrays(layoutVertexArray.length, feature, feature.index, {}, canonical, sections && sections[sectionIndex]);
            }
        }
        arrays.placedSymbolArray.emplaceBack(labelAnchor.x, labelAnchor.y, glyphOffsetArrayStart, this.glyphOffsetArray.length - glyphOffsetArrayStart, vertexStartIndex, lineStartIndex, lineLength, labelAnchor.segment, sizeVertex ? sizeVertex[0] : 0, sizeVertex ? sizeVertex[1] : 0, lineOffset[0], lineOffset[1], writingMode, 
        // placedOrientation is null initially; will be updated to horizontal(1)/vertical(2) if placed
        0, false, 
        // The crossTileID is only filled/used on the foreground for dynamic text anchors
        0, associatedIconIndex);
    }
    _addCollisionDebugVertex(layoutVertexArray, collisionVertexArray, point, anchorX, anchorY, extrude) {
        collisionVertexArray.emplaceBack(0, 0);
        return layoutVertexArray.emplaceBack(
        // pos
        point.x, point.y, 
        // a_anchor_pos
        anchorX, anchorY, 
        // extrude
        Math.round(extrude.x), Math.round(extrude.y));
    }
    addCollisionDebugVertices(x1, y1, x2, y2, arrays, boxAnchorPoint, symbolInstance) {
        const segment = arrays.segments.prepareSegment(4, arrays.layoutVertexArray, arrays.indexArray);
        const index = segment.vertexLength;
        const layoutVertexArray = arrays.layoutVertexArray;
        const collisionVertexArray = arrays.collisionVertexArray;
        const anchorX = symbolInstance.anchorX;
        const anchorY = symbolInstance.anchorY;
        this._addCollisionDebugVertex(layoutVertexArray, collisionVertexArray, boxAnchorPoint, anchorX, anchorY, new Point$2(x1, y1));
        this._addCollisionDebugVertex(layoutVertexArray, collisionVertexArray, boxAnchorPoint, anchorX, anchorY, new Point$2(x2, y1));
        this._addCollisionDebugVertex(layoutVertexArray, collisionVertexArray, boxAnchorPoint, anchorX, anchorY, new Point$2(x2, y2));
        this._addCollisionDebugVertex(layoutVertexArray, collisionVertexArray, boxAnchorPoint, anchorX, anchorY, new Point$2(x1, y2));
        segment.vertexLength += 4;
        const indexArray = arrays.indexArray;
        indexArray.emplaceBack(index, index + 1);
        indexArray.emplaceBack(index + 1, index + 2);
        indexArray.emplaceBack(index + 2, index + 3);
        indexArray.emplaceBack(index + 3, index);
        segment.primitiveLength += 4;
    }
    addDebugCollisionBoxes(startIndex, endIndex, symbolInstance, isText) {
        for (let b = startIndex; b < endIndex; b++) {
            const box = this.collisionBoxArray.get(b);
            const x1 = box.x1;
            const y1 = box.y1;
            const x2 = box.x2;
            const y2 = box.y2;
            this.addCollisionDebugVertices(x1, y1, x2, y2, isText ? this.textCollisionBox : this.iconCollisionBox, box.anchorPoint, symbolInstance);
        }
    }
    generateCollisionDebugBuffers() {
        if (this.hasDebugData()) {
            this.destroyDebugData();
        }
        this.textCollisionBox = new CollisionBuffers(CollisionBoxLayoutArray, collisionBoxLayout.members, LineIndexArray);
        this.iconCollisionBox = new CollisionBuffers(CollisionBoxLayoutArray, collisionBoxLayout.members, LineIndexArray);
        for (let i = 0; i < this.symbolInstances.length; i++) {
            const symbolInstance = this.symbolInstances.get(i);
            this.addDebugCollisionBoxes(symbolInstance.textBoxStartIndex, symbolInstance.textBoxEndIndex, symbolInstance, true);
            this.addDebugCollisionBoxes(symbolInstance.verticalTextBoxStartIndex, symbolInstance.verticalTextBoxEndIndex, symbolInstance, true);
            this.addDebugCollisionBoxes(symbolInstance.iconBoxStartIndex, symbolInstance.iconBoxEndIndex, symbolInstance, false);
            this.addDebugCollisionBoxes(symbolInstance.verticalIconBoxStartIndex, symbolInstance.verticalIconBoxEndIndex, symbolInstance, false);
        }
    }
    // These flat arrays are meant to be quicker to iterate over than the source
    // CollisionBoxArray
    _deserializeCollisionBoxesForSymbol(collisionBoxArray, textStartIndex, textEndIndex, verticalTextStartIndex, verticalTextEndIndex, iconStartIndex, iconEndIndex, verticalIconStartIndex, verticalIconEndIndex) {
        const collisionArrays = {};
        for (let k = textStartIndex; k < textEndIndex; k++) {
            const box = collisionBoxArray.get(k);
            collisionArrays.textBox = { x1: box.x1, y1: box.y1, x2: box.x2, y2: box.y2, anchorPointX: box.anchorPointX, anchorPointY: box.anchorPointY };
            collisionArrays.textFeatureIndex = box.featureIndex;
            break; // Only one box allowed per instance
        }
        for (let k = verticalTextStartIndex; k < verticalTextEndIndex; k++) {
            const box = collisionBoxArray.get(k);
            collisionArrays.verticalTextBox = { x1: box.x1, y1: box.y1, x2: box.x2, y2: box.y2, anchorPointX: box.anchorPointX, anchorPointY: box.anchorPointY };
            collisionArrays.verticalTextFeatureIndex = box.featureIndex;
            break; // Only one box allowed per instance
        }
        for (let k = iconStartIndex; k < iconEndIndex; k++) {
            // An icon can only have one box now, so this indexing is a bit vestigial...
            const box = collisionBoxArray.get(k);
            collisionArrays.iconBox = { x1: box.x1, y1: box.y1, x2: box.x2, y2: box.y2, anchorPointX: box.anchorPointX, anchorPointY: box.anchorPointY };
            collisionArrays.iconFeatureIndex = box.featureIndex;
            break; // Only one box allowed per instance
        }
        for (let k = verticalIconStartIndex; k < verticalIconEndIndex; k++) {
            // An icon can only have one box now, so this indexing is a bit vestigial...
            const box = collisionBoxArray.get(k);
            collisionArrays.verticalIconBox = { x1: box.x1, y1: box.y1, x2: box.x2, y2: box.y2, anchorPointX: box.anchorPointX, anchorPointY: box.anchorPointY };
            collisionArrays.verticalIconFeatureIndex = box.featureIndex;
            break; // Only one box allowed per instance
        }
        return collisionArrays;
    }
    deserializeCollisionBoxes(collisionBoxArray) {
        this.collisionArrays = [];
        for (let i = 0; i < this.symbolInstances.length; i++) {
            const symbolInstance = this.symbolInstances.get(i);
            this.collisionArrays.push(this._deserializeCollisionBoxesForSymbol(collisionBoxArray, symbolInstance.textBoxStartIndex, symbolInstance.textBoxEndIndex, symbolInstance.verticalTextBoxStartIndex, symbolInstance.verticalTextBoxEndIndex, symbolInstance.iconBoxStartIndex, symbolInstance.iconBoxEndIndex, symbolInstance.verticalIconBoxStartIndex, symbolInstance.verticalIconBoxEndIndex));
        }
    }
    hasTextData() {
        return this.text.segments.get().length > 0;
    }
    hasIconData() {
        return this.icon.segments.get().length > 0;
    }
    hasDebugData() {
        return this.textCollisionBox && this.iconCollisionBox;
    }
    hasTextCollisionBoxData() {
        return this.hasDebugData() && this.textCollisionBox.segments.get().length > 0;
    }
    hasIconCollisionBoxData() {
        return this.hasDebugData() && this.iconCollisionBox.segments.get().length > 0;
    }
    addIndicesForPlacedSymbol(iconOrText, placedSymbolIndex) {
        const placedSymbol = iconOrText.placedSymbolArray.get(placedSymbolIndex);
        const endIndex = placedSymbol.vertexStartIndex + placedSymbol.numGlyphs * 4;
        for (let vertexIndex = placedSymbol.vertexStartIndex; vertexIndex < endIndex; vertexIndex += 4) {
            iconOrText.indexArray.emplaceBack(vertexIndex, vertexIndex + 1, vertexIndex + 2);
            iconOrText.indexArray.emplaceBack(vertexIndex + 1, vertexIndex + 2, vertexIndex + 3);
        }
    }
    getSortedSymbolIndexes(angle) {
        if (this.sortedAngle === angle && this.symbolInstanceIndexes !== undefined) {
            return this.symbolInstanceIndexes;
        }
        const sin = Math.sin(angle);
        const cos = Math.cos(angle);
        const rotatedYs = [];
        const featureIndexes = [];
        const result = [];
        for (let i = 0; i < this.symbolInstances.length; ++i) {
            result.push(i);
            const symbolInstance = this.symbolInstances.get(i);
            rotatedYs.push(Math.round(sin * symbolInstance.anchorX + cos * symbolInstance.anchorY) | 0);
            featureIndexes.push(symbolInstance.featureIndex);
        }
        result.sort((aIndex, bIndex) => {
            return (rotatedYs[aIndex] - rotatedYs[bIndex]) ||
                (featureIndexes[bIndex] - featureIndexes[aIndex]);
        });
        return result;
    }
    addToSortKeyRanges(symbolInstanceIndex, sortKey) {
        const last = this.sortKeyRanges[this.sortKeyRanges.length - 1];
        if (last && last.sortKey === sortKey) {
            last.symbolInstanceEnd = symbolInstanceIndex + 1;
        }
        else {
            this.sortKeyRanges.push({
                sortKey,
                symbolInstanceStart: symbolInstanceIndex,
                symbolInstanceEnd: symbolInstanceIndex + 1
            });
        }
    }
    sortFeatures(angle) {
        if (!this.sortFeaturesByY)
            return;
        if (this.sortedAngle === angle)
            return;
        // The current approach to sorting doesn't sort across segments so don't try.
        // Sorting within segments separately seemed not to be worth the complexity.
        if (this.text.segments.get().length > 1 || this.icon.segments.get().length > 1)
            return;
        // If the symbols are allowed to overlap sort them by their vertical screen position.
        // The index array buffer is rewritten to reference the (unchanged) vertices in the
        // sorted order.
        // To avoid sorting the actual symbolInstance array we sort an array of indexes.
        this.symbolInstanceIndexes = this.getSortedSymbolIndexes(angle);
        this.sortedAngle = angle;
        this.text.indexArray.clear();
        this.icon.indexArray.clear();
        this.featureSortOrder = [];
        for (const i of this.symbolInstanceIndexes) {
            const symbolInstance = this.symbolInstances.get(i);
            this.featureSortOrder.push(symbolInstance.featureIndex);
            [
                symbolInstance.rightJustifiedTextSymbolIndex,
                symbolInstance.centerJustifiedTextSymbolIndex,
                symbolInstance.leftJustifiedTextSymbolIndex
            ].forEach((index, i, array) => {
                // Only add a given index the first time it shows up,
                // to avoid duplicate opacity entries when multiple justifications
                // share the same glyphs.
                if (index >= 0 && array.indexOf(index) === i) {
                    this.addIndicesForPlacedSymbol(this.text, index);
                }
            });
            if (symbolInstance.verticalPlacedTextSymbolIndex >= 0) {
                this.addIndicesForPlacedSymbol(this.text, symbolInstance.verticalPlacedTextSymbolIndex);
            }
            if (symbolInstance.placedIconSymbolIndex >= 0) {
                this.addIndicesForPlacedSymbol(this.icon, symbolInstance.placedIconSymbolIndex);
            }
            if (symbolInstance.verticalPlacedIconSymbolIndex >= 0) {
                this.addIndicesForPlacedSymbol(this.icon, symbolInstance.verticalPlacedIconSymbolIndex);
            }
        }
        if (this.text.indexBuffer)
            this.text.indexBuffer.updateData(this.text.indexArray);
        if (this.icon.indexBuffer)
            this.icon.indexBuffer.updateData(this.icon.indexArray);
    }
}
register('SymbolBucket', SymbolBucket, {
    omit: ['layers', 'collisionBoxArray', 'features', 'compareText']
});
// this constant is based on the size of StructArray indexes used in a symbol
// bucket--namely, glyphOffsetArrayStart
// eg the max valid UInt16 is 65,535
// See https://github.com/mapbox/mapbox-gl-js/issues/2907 for motivation
// lineStartIndex and textBoxStartIndex could potentially be concerns
// but we expect there to be many fewer boxes/lines than glyphs
SymbolBucket.MAX_GLYPHS = 65535;
SymbolBucket.addDynamicAttributes = addDynamicAttributes;

/**
 * Replace tokens in a string template with values in an object
 *
 * @param properties - a key/value relationship between tokens and replacements
 * @param text - the template string
 * @returns the template with tokens replaced
 */
function resolveTokens(properties, text) {
    return text.replace(/{([^{}]+)}/g, (match, key) => {
        return properties && key in properties ? String(properties[key]) : '';
    });
}

// This file is generated. Edit build/generate-style-code.ts, then run 'npm run codegen'.
/* eslint-disable */
let layout;
const getLayout = () => layout = layout || new Properties({
    "symbol-placement": new DataConstantProperty(v8Spec["layout_symbol"]["symbol-placement"]),
    "symbol-spacing": new DataConstantProperty(v8Spec["layout_symbol"]["symbol-spacing"]),
    "symbol-avoid-edges": new DataConstantProperty(v8Spec["layout_symbol"]["symbol-avoid-edges"]),
    "symbol-sort-key": new DataDrivenProperty(v8Spec["layout_symbol"]["symbol-sort-key"]),
    "symbol-z-order": new DataConstantProperty(v8Spec["layout_symbol"]["symbol-z-order"]),
    "icon-allow-overlap": new DataConstantProperty(v8Spec["layout_symbol"]["icon-allow-overlap"]),
    "icon-overlap": new DataConstantProperty(v8Spec["layout_symbol"]["icon-overlap"]),
    "icon-ignore-placement": new DataConstantProperty(v8Spec["layout_symbol"]["icon-ignore-placement"]),
    "icon-optional": new DataConstantProperty(v8Spec["layout_symbol"]["icon-optional"]),
    "icon-rotation-alignment": new DataConstantProperty(v8Spec["layout_symbol"]["icon-rotation-alignment"]),
    "icon-size": new DataDrivenProperty(v8Spec["layout_symbol"]["icon-size"]),
    "icon-text-fit": new DataConstantProperty(v8Spec["layout_symbol"]["icon-text-fit"]),
    "icon-text-fit-padding": new DataConstantProperty(v8Spec["layout_symbol"]["icon-text-fit-padding"]),
    "icon-image": new DataDrivenProperty(v8Spec["layout_symbol"]["icon-image"]),
    "icon-rotate": new DataDrivenProperty(v8Spec["layout_symbol"]["icon-rotate"]),
    "icon-padding": new DataDrivenProperty(v8Spec["layout_symbol"]["icon-padding"]),
    "icon-keep-upright": new DataConstantProperty(v8Spec["layout_symbol"]["icon-keep-upright"]),
    "icon-offset": new DataDrivenProperty(v8Spec["layout_symbol"]["icon-offset"]),
    "icon-anchor": new DataDrivenProperty(v8Spec["layout_symbol"]["icon-anchor"]),
    "icon-pitch-alignment": new DataConstantProperty(v8Spec["layout_symbol"]["icon-pitch-alignment"]),
    "text-pitch-alignment": new DataConstantProperty(v8Spec["layout_symbol"]["text-pitch-alignment"]),
    "text-rotation-alignment": new DataConstantProperty(v8Spec["layout_symbol"]["text-rotation-alignment"]),
    "text-field": new DataDrivenProperty(v8Spec["layout_symbol"]["text-field"]),
    "text-font": new DataDrivenProperty(v8Spec["layout_symbol"]["text-font"]),
    "text-size": new DataDrivenProperty(v8Spec["layout_symbol"]["text-size"]),
    "text-max-width": new DataDrivenProperty(v8Spec["layout_symbol"]["text-max-width"]),
    "text-line-height": new DataConstantProperty(v8Spec["layout_symbol"]["text-line-height"]),
    "text-letter-spacing": new DataDrivenProperty(v8Spec["layout_symbol"]["text-letter-spacing"]),
    "text-justify": new DataDrivenProperty(v8Spec["layout_symbol"]["text-justify"]),
    "text-radial-offset": new DataDrivenProperty(v8Spec["layout_symbol"]["text-radial-offset"]),
    "text-variable-anchor": new DataConstantProperty(v8Spec["layout_symbol"]["text-variable-anchor"]),
    "text-variable-anchor-offset": new DataDrivenProperty(v8Spec["layout_symbol"]["text-variable-anchor-offset"]),
    "text-anchor": new DataDrivenProperty(v8Spec["layout_symbol"]["text-anchor"]),
    "text-max-angle": new DataConstantProperty(v8Spec["layout_symbol"]["text-max-angle"]),
    "text-writing-mode": new DataConstantProperty(v8Spec["layout_symbol"]["text-writing-mode"]),
    "text-rotate": new DataDrivenProperty(v8Spec["layout_symbol"]["text-rotate"]),
    "text-padding": new DataConstantProperty(v8Spec["layout_symbol"]["text-padding"]),
    "text-keep-upright": new DataConstantProperty(v8Spec["layout_symbol"]["text-keep-upright"]),
    "text-transform": new DataDrivenProperty(v8Spec["layout_symbol"]["text-transform"]),
    "text-offset": new DataDrivenProperty(v8Spec["layout_symbol"]["text-offset"]),
    "text-allow-overlap": new DataConstantProperty(v8Spec["layout_symbol"]["text-allow-overlap"]),
    "text-overlap": new DataConstantProperty(v8Spec["layout_symbol"]["text-overlap"]),
    "text-ignore-placement": new DataConstantProperty(v8Spec["layout_symbol"]["text-ignore-placement"]),
    "text-optional": new DataConstantProperty(v8Spec["layout_symbol"]["text-optional"]),
});
let paint$2;
const getPaint$2 = () => paint$2 = paint$2 || new Properties({
    "icon-opacity": new DataDrivenProperty(v8Spec["paint_symbol"]["icon-opacity"]),
    "icon-color": new DataDrivenProperty(v8Spec["paint_symbol"]["icon-color"]),
    "icon-halo-color": new DataDrivenProperty(v8Spec["paint_symbol"]["icon-halo-color"]),
    "icon-halo-width": new DataDrivenProperty(v8Spec["paint_symbol"]["icon-halo-width"]),
    "icon-halo-blur": new DataDrivenProperty(v8Spec["paint_symbol"]["icon-halo-blur"]),
    "icon-translate": new DataConstantProperty(v8Spec["paint_symbol"]["icon-translate"]),
    "icon-translate-anchor": new DataConstantProperty(v8Spec["paint_symbol"]["icon-translate-anchor"]),
    "text-opacity": new DataDrivenProperty(v8Spec["paint_symbol"]["text-opacity"]),
    "text-color": new DataDrivenProperty(v8Spec["paint_symbol"]["text-color"], { runtimeType: ColorType, getOverride: (o) => o.textColor, hasOverride: (o) => !!o.textColor }),
    "text-halo-color": new DataDrivenProperty(v8Spec["paint_symbol"]["text-halo-color"]),
    "text-halo-width": new DataDrivenProperty(v8Spec["paint_symbol"]["text-halo-width"]),
    "text-halo-blur": new DataDrivenProperty(v8Spec["paint_symbol"]["text-halo-blur"]),
    "text-translate": new DataConstantProperty(v8Spec["paint_symbol"]["text-translate"]),
    "text-translate-anchor": new DataConstantProperty(v8Spec["paint_symbol"]["text-translate-anchor"]),
});
var properties$2 = ({ get paint() { return getPaint$2(); }, get layout() { return getLayout(); } });

// This is an internal expression class. It is only used in GL JS and
// has GL JS dependencies which can break the standalone style-spec module
class FormatSectionOverride {
    constructor(defaultValue) {
        if (defaultValue.property.overrides === undefined)
            throw new Error('overrides must be provided to instantiate FormatSectionOverride class');
        this.type = defaultValue.property.overrides ? defaultValue.property.overrides.runtimeType : NullType;
        this.defaultValue = defaultValue;
    }
    evaluate(ctx) {
        if (ctx.formattedSection) {
            const overrides = this.defaultValue.property.overrides;
            if (overrides && overrides.hasOverride(ctx.formattedSection)) {
                return overrides.getOverride(ctx.formattedSection);
            }
        }
        if (ctx.feature && ctx.featureState) {
            return this.defaultValue.evaluate(ctx.feature, ctx.featureState);
        }
        return this.defaultValue.property.specification.default;
    }
    eachChild(fn) {
        if (!this.defaultValue.isConstant()) {
            const expr = this.defaultValue.value;
            fn(expr._styleExpression.expression);
        }
    }
    // Cannot be statically evaluated, as the output depends on the evaluation context.
    outputDefined() {
        return false;
    }
    serialize() {
        return null;
    }
}
register('FormatSectionOverride', FormatSectionOverride, { omit: ['defaultValue'] });

class SymbolStyleLayer extends StyleLayer {
    constructor(layer) {
        super(layer, properties$2);
    }
    recalculate(parameters, availableImages) {
        super.recalculate(parameters, availableImages);
        if (this.layout.get('icon-rotation-alignment') === 'auto') {
            if (this.layout.get('symbol-placement') !== 'point') {
                this.layout._values['icon-rotation-alignment'] = 'map';
            }
            else {
                this.layout._values['icon-rotation-alignment'] = 'viewport';
            }
        }
        if (this.layout.get('text-rotation-alignment') === 'auto') {
            if (this.layout.get('symbol-placement') !== 'point') {
                this.layout._values['text-rotation-alignment'] = 'map';
            }
            else {
                this.layout._values['text-rotation-alignment'] = 'viewport';
            }
        }
        // If unspecified, `*-pitch-alignment` inherits `*-rotation-alignment`
        if (this.layout.get('text-pitch-alignment') === 'auto') {
            this.layout._values['text-pitch-alignment'] = this.layout.get('text-rotation-alignment') === 'map' ? 'map' : 'viewport';
        }
        if (this.layout.get('icon-pitch-alignment') === 'auto') {
            this.layout._values['icon-pitch-alignment'] = this.layout.get('icon-rotation-alignment');
        }
        if (this.layout.get('symbol-placement') === 'point') {
            const writingModes = this.layout.get('text-writing-mode');
            if (writingModes) {
                // remove duplicates, preserving order
                const deduped = [];
                for (const m of writingModes) {
                    if (deduped.indexOf(m) < 0)
                        deduped.push(m);
                }
                this.layout._values['text-writing-mode'] = deduped;
            }
            else {
                this.layout._values['text-writing-mode'] = ['horizontal'];
            }
        }
        this._setPaintOverrides();
    }
    getValueAndResolveTokens(name, feature, canonical, availableImages) {
        const value = this.layout.get(name).evaluate(feature, {}, canonical, availableImages);
        const unevaluated = this._unevaluatedLayout._values[name];
        if (!unevaluated.isDataDriven() && !isExpression(unevaluated.value) && value) {
            return resolveTokens(feature.properties, value);
        }
        return value;
    }
    createBucket(parameters) {
        return new SymbolBucket(parameters);
    }
    queryRadius() {
        return 0;
    }
    queryIntersectsFeature() {
        throw new Error('Should take a different path in FeatureIndex');
    }
    _setPaintOverrides() {
        for (const overridable of properties$2.paint.overridableProperties) {
            if (!SymbolStyleLayer.hasPaintOverride(this.layout, overridable)) {
                continue;
            }
            const overridden = this.paint.get(overridable);
            const override = new FormatSectionOverride(overridden);
            const styleExpression = new StyleExpression(override, overridden.property.specification);
            let expression = null;
            if (overridden.value.kind === 'constant' || overridden.value.kind === 'source') {
                expression = new ZoomConstantExpression('source', styleExpression);
            }
            else {
                expression = new ZoomDependentExpression('composite', styleExpression, overridden.value.zoomStops);
            }
            this.paint._values[overridable] = new PossiblyEvaluatedPropertyValue(overridden.property, expression, overridden.parameters);
        }
    }
    _handleOverridablePaintPropertyUpdate(name, oldValue, newValue) {
        if (!this.layout || oldValue.isDataDriven() || newValue.isDataDriven()) {
            return false;
        }
        return SymbolStyleLayer.hasPaintOverride(this.layout, name);
    }
    static hasPaintOverride(layout, propertyName) {
        const textField = layout.get('text-field');
        const property = properties$2.paint.properties[propertyName];
        let hasOverrides = false;
        const checkSections = (sections) => {
            for (const section of sections) {
                if (property.overrides && property.overrides.hasOverride(section)) {
                    hasOverrides = true;
                    return;
                }
            }
        };
        if (textField.value.kind === 'constant' && textField.value.value instanceof Formatted) {
            checkSections(textField.value.value.sections);
        }
        else if (textField.value.kind === 'source') {
            const checkExpression = (expression) => {
                if (hasOverrides)
                    return;
                if (expression instanceof Literal && typeOf(expression.value) === FormattedType) {
                    const formatted = expression.value;
                    checkSections(formatted.sections);
                }
                else if (expression instanceof FormatExpression) {
                    checkSections(expression.sections);
                }
                else {
                    expression.eachChild(checkExpression);
                }
            };
            const expr = textField.value;
            if (expr._styleExpression) {
                checkExpression(expr._styleExpression.expression);
            }
        }
        return hasOverrides;
    }
}
function getIconPadding(layout, feature, canonical, pixelRatio = 1) {
    // Support text-padding in addition to icon-padding? Unclear how to apply asymmetric text-padding to the radius for collision circles.
    const result = layout.get('icon-padding').evaluate(feature, {}, canonical);
    const values = result && result.values;
    return [
        values[0] * pixelRatio,
        values[1] * pixelRatio,
        values[2] * pixelRatio,
        values[3] * pixelRatio,
    ];
}

// This file is generated. Edit build/generate-style-code.ts, then run 'npm run codegen'.
/* eslint-disable */
let paint$1;
const getPaint$1 = () => paint$1 = paint$1 || new Properties({
    "background-color": new DataConstantProperty(v8Spec["paint_background"]["background-color"]),
    "background-pattern": new CrossFadedProperty(v8Spec["paint_background"]["background-pattern"]),
    "background-opacity": new DataConstantProperty(v8Spec["paint_background"]["background-opacity"]),
});
var properties$1 = ({ get paint() { return getPaint$1(); } });

class BackgroundStyleLayer extends StyleLayer {
    constructor(layer) {
        super(layer, properties$1);
    }
}

// This file is generated. Edit build/generate-style-code.ts, then run 'npm run codegen'.
/* eslint-disable */
let paint;
const getPaint = () => paint = paint || new Properties({
    "raster-opacity": new DataConstantProperty(v8Spec["paint_raster"]["raster-opacity"]),
    "raster-hue-rotate": new DataConstantProperty(v8Spec["paint_raster"]["raster-hue-rotate"]),
    "raster-brightness-min": new DataConstantProperty(v8Spec["paint_raster"]["raster-brightness-min"]),
    "raster-brightness-max": new DataConstantProperty(v8Spec["paint_raster"]["raster-brightness-max"]),
    "raster-saturation": new DataConstantProperty(v8Spec["paint_raster"]["raster-saturation"]),
    "raster-contrast": new DataConstantProperty(v8Spec["paint_raster"]["raster-contrast"]),
    "raster-resampling": new DataConstantProperty(v8Spec["paint_raster"]["raster-resampling"]),
    "raster-fade-duration": new DataConstantProperty(v8Spec["paint_raster"]["raster-fade-duration"]),
});
var properties = ({ get paint() { return getPaint(); } });

class RasterStyleLayer extends StyleLayer {
    constructor(layer) {
        super(layer, properties);
    }
}

function validateCustomStyleLayer(layerObject) {
    const errors = [];
    const id = layerObject.id;
    if (id === undefined) {
        errors.push({
            message: `layers.${id}: missing required property "id"`
        });
    }
    if (layerObject.render === undefined) {
        errors.push({
            message: `layers.${id}: missing required method "render"`
        });
    }
    if (layerObject.renderingMode &&
        layerObject.renderingMode !== '2d' &&
        layerObject.renderingMode !== '3d') {
        errors.push({
            message: `layers.${id}: property "renderingMode" must be either "2d" or "3d"`
        });
    }
    return errors;
}
class CustomStyleLayer extends StyleLayer {
    constructor(implementation) {
        super(implementation, {});
        this.onAdd = (map) => {
            if (this.implementation.onAdd) {
                this.implementation.onAdd(map, map.painter.context.gl);
            }
        };
        this.onRemove = (map) => {
            if (this.implementation.onRemove) {
                this.implementation.onRemove(map, map.painter.context.gl);
            }
        };
        this.implementation = implementation;
    }
    is3D() {
        return this.implementation.renderingMode === '3d';
    }
    hasOffscreenPass() {
        return this.implementation.prerender !== undefined;
    }
    recalculate() { }
    updateTransitions() { }
    hasTransition() { return false; }
    serialize() {
        throw new Error('Custom layers cannot be serialized');
    }
}

function createStyleLayer(layer) {
    if (layer.type === 'custom') {
        return new CustomStyleLayer(layer);
    }
    switch (layer.type) {
        case 'background':
            return new BackgroundStyleLayer(layer);
        case 'circle':
            return new CircleStyleLayer(layer);
        case 'fill':
            return new FillStyleLayer(layer);
        case 'fill-extrusion':
            return new FillExtrusionStyleLayer(layer);
        case 'heatmap':
            return new HeatmapStyleLayer(layer);
        case 'hillshade':
            return new HillshadeStyleLayer(layer);
        case 'line':
            return new LineStyleLayer(layer);
        case 'raster':
            return new RasterStyleLayer(layer);
        case 'symbol':
            return new SymbolStyleLayer(layer);
    }
}

/**
 * Invokes the wrapped function in a non-blocking way when trigger() is called.
 * Invocation requests are ignored until the function was actually invoked.
 */
class ThrottledInvoker {
    constructor(methodToThrottle) {
        this._methodToThrottle = methodToThrottle;
        this._triggered = false;
        if (typeof MessageChannel !== 'undefined') {
            this._channel = new MessageChannel();
            this._channel.port2.onmessage = () => {
                this._triggered = false;
                this._methodToThrottle();
            };
        }
    }
    trigger() {
        if (this._triggered) {
            return;
        }
        this._triggered = true;
        if (this._channel) {
            this._channel.port1.postMessage(true);
        }
        else {
            setTimeout(() => {
                this._triggered = false;
                this._methodToThrottle();
            }, 0);
        }
    }
    remove() {
        delete this._channel;
        this._methodToThrottle = () => { };
    }
}

/**
 * An implementation of the [Actor design pattern](https://en.wikipedia.org/wiki/Actor_model)
 * that maintains the relationship between asynchronous tasks and the objects
 * that spin them off - in this case, tasks like parsing parts of styles,
 * owned by the styles
 */
class Actor {
    /**
     * @param target - The target
     * @param mapId - A unique identifier for the Map instance using this Actor.
     */
    constructor(target, mapId) {
        this.target = target;
        this.mapId = mapId;
        this.resolveRejects = {};
        this.tasks = {};
        this.taskQueue = [];
        this.abortControllers = {};
        this.messageHandlers = {};
        this.invoker = new ThrottledInvoker(() => this.process());
        this.subscription = subscribe(this.target, 'message', (message) => this.receive(message), false);
        this.globalScope = isWorker(self) ? target : window;
    }
    registerMessageHandler(type, handler) {
        this.messageHandlers[type] = handler;
    }
    /**
     * Sends a message from a main-thread map to a Worker or from a Worker back to
     * a main-thread map instance.
     * @param message - the message to send
     * @param abortController - an optional AbortController to abort the request
     * @returns a promise that will be resolved with the response data
     */
    sendAsync(message, abortController) {
        return new Promise((resolve, reject) => {
            // We're using a string ID instead of numbers because they are being used as object keys
            // anyway, and thus stringified implicitly. We use random IDs because an actor may receive
            // message from multiple other actors which could run in different execution context. A
            // linearly increasing ID could produce collisions.
            const id = Math.round((Math.random() * 1e18)).toString(36).substring(0, 10);
            this.resolveRejects[id] = {
                resolve,
                reject
            };
            if (abortController) {
                abortController.signal.addEventListener('abort', () => {
                    delete this.resolveRejects[id];
                    const cancelMessage = {
                        id,
                        type: '<cancel>',
                        origin: location.origin,
                        targetMapId: message.targetMapId,
                        sourceMapId: this.mapId
                    };
                    this.target.postMessage(cancelMessage);
                    // In case of abort the current behavior is to keep the promise pending.
                }, { once: true });
            }
            const buffers = [];
            const messageToPost = Object.assign(Object.assign({}, message), { id, sourceMapId: this.mapId, origin: location.origin, data: serialize(message.data, buffers) });
            this.target.postMessage(messageToPost, { transfer: buffers });
        });
    }
    receive(message) {
        const data = message.data;
        const id = data.id;
        if (data.origin !== 'file://' && location.origin !== 'file://' && data.origin !== 'resource://android' && location.origin !== 'resource://android' && data.origin !== location.origin) {
            return;
        }
        if (data.targetMapId && this.mapId !== data.targetMapId) {
            return;
        }
        if (data.type === '<cancel>') {
            // Remove the original request from the queue. This is only possible if it
            // hasn't been kicked off yet. The id will remain in the queue, but because
            // there is no associated task, it will be dropped once it's time to execute it.
            delete this.tasks[id];
            const abortController = this.abortControllers[id];
            delete this.abortControllers[id];
            if (abortController) {
                abortController.abort();
            }
            return;
        }
        if (isWorker(self) || data.mustQueue) {
            // In workers, store the tasks that we need to process before actually processing them. This
            // is necessary because we want to keep receiving messages, and in particular,
            // <cancel> messages. Some tasks may take a while in the worker thread, so before
            // executing the next task in our queue, postMessage preempts this and <cancel>
            // messages can be processed. We're using a MessageChannel object to get throttle the
            // process() flow to one at a time.
            this.tasks[id] = data;
            this.taskQueue.push(id);
            this.invoker.trigger();
            return;
        }
        // In the main thread, process messages immediately so that other work does not slip in
        // between getting partial data back from workers.
        this.processTask(id, data);
    }
    process() {
        if (this.taskQueue.length === 0) {
            return;
        }
        const id = this.taskQueue.shift();
        const task = this.tasks[id];
        delete this.tasks[id];
        // Schedule another process call if we know there's more to process _before_ invoking the
        // current task. This is necessary so that processing continues even if the current task
        // doesn't execute successfully.
        if (this.taskQueue.length > 0) {
            this.invoker.trigger();
        }
        if (!task) {
            // If the task ID doesn't have associated task data anymore, it was canceled.
            return;
        }
        this.processTask(id, task);
    }
    processTask(id, task) {
        return __awaiter(this, void 0, void 0, function* () {
            if (task.type === '<response>') {
                // The `completeTask` function in the counterpart actor has been called, and we are now
                // resolving or rejecting the promise in the originating actor, if there is one.
                const resolveReject = this.resolveRejects[id];
                delete this.resolveRejects[id];
                if (!resolveReject) {
                    // If we get a response, but don't have a resolve or reject, the request was canceled.
                    return;
                }
                if (task.error) {
                    resolveReject.reject(deserialize(task.error));
                }
                else {
                    resolveReject.resolve(deserialize(task.data));
                }
                return;
            }
            if (!this.messageHandlers[task.type]) {
                this.completeTask(id, new Error(`Could not find a registered handler for ${task.type}, map ID: ${this.mapId}, available handlers: ${Object.keys(this.messageHandlers).join(', ')}`));
                return;
            }
            const params = deserialize(task.data);
            const abortController = new AbortController();
            this.abortControllers[id] = abortController;
            try {
                const data = yield this.messageHandlers[task.type](task.sourceMapId, params, abortController);
                this.completeTask(id, null, data);
            }
            catch (err) {
                this.completeTask(id, err);
            }
        });
    }
    completeTask(id, err, data) {
        const buffers = [];
        delete this.abortControllers[id];
        const responseMessage = {
            id,
            type: '<response>',
            sourceMapId: this.mapId,
            origin: location.origin,
            error: err ? serialize(err) : null,
            data: serialize(data, buffers)
        };
        this.target.postMessage(responseMessage, { transfer: buffers });
    }
    remove() {
        this.invoker.remove();
        this.subscription.unsubscribe();
    }
}

/*
* Approximate radius of the earth in meters.
* Uses the WGS-84 approximation. The radius at the equator is ~6378137 and at the poles is ~6356752. https://en.wikipedia.org/wiki/World_Geodetic_System#WGS84
* 6371008.8 is one published "average radius" see https://en.wikipedia.org/wiki/Earth_radius#Mean_radius, or ftp://athena.fsv.cvut.cz/ZFG/grs80-Moritz.pdf p.4
*/
const earthRadius = 6371008.8;
/**
 * A `LngLat` object represents a given longitude and latitude coordinate, measured in degrees.
 * These coordinates are based on the [WGS84 (EPSG:4326) standard](https://en.wikipedia.org/wiki/World_Geodetic_System#WGS84).
 *
 * MapLibre GL JS uses longitude, latitude coordinate order (as opposed to latitude, longitude) to match the
 * [GeoJSON specification](https://tools.ietf.org/html/rfc7946).
 *
 * Note that any MapLibre GL JS method that accepts a `LngLat` object as an argument or option
 * can also accept an `Array` of two numbers and will perform an implicit conversion.
 * This flexible type is documented as {@link LngLatLike}.
 *
 * @group Geography and Geometry
 *
 * @example
 * ```ts
 * let ll = new LngLat(-123.9749, 40.7736);
 * ll.lng; // = -123.9749
 * ```
 * @see [Get coordinates of the mouse pointer](https://maplibre.org/maplibre-gl-js/docs/examples/mouse-position/)
 * @see [Display a popup](https://maplibre.org/maplibre-gl-js/docs/examples/popup/)
 * @see [Create a timeline animation](https://maplibre.org/maplibre-gl-js/docs/examples/timeline-animation/)
 */
class LngLat {
    /**
     * @param lng - Longitude, measured in degrees.
     * @param lat - Latitude, measured in degrees.
     */
    constructor(lng, lat) {
        if (isNaN(lng) || isNaN(lat)) {
            throw new Error(`Invalid LngLat object: (${lng}, ${lat})`);
        }
        this.lng = +lng;
        this.lat = +lat;
        if (this.lat > 90 || this.lat < -90) {
            throw new Error('Invalid LngLat latitude value: must be between -90 and 90');
        }
    }
    /**
     * Returns a new `LngLat` object whose longitude is wrapped to the range (-180, 180).
     *
     * @returns The wrapped `LngLat` object.
     * @example
     * ```ts
     * let ll = new LngLat(286.0251, 40.7736);
     * let wrapped = ll.wrap();
     * wrapped.lng; // = -73.9749
     * ```
     */
    wrap() {
        return new LngLat(wrap(this.lng, -180, 180), this.lat);
    }
    /**
     * Returns the coordinates represented as an array of two numbers.
     *
     * @returns The coordinates represented as an array of longitude and latitude.
     * @example
     * ```ts
     * let ll = new LngLat(-73.9749, 40.7736);
     * ll.toArray(); // = [-73.9749, 40.7736]
     * ```
     */
    toArray() {
        return [this.lng, this.lat];
    }
    /**
     * Returns the coordinates represent as a string.
     *
     * @returns The coordinates represented as a string of the format `'LngLat(lng, lat)'`.
     * @example
     * ```ts
     * let ll = new LngLat(-73.9749, 40.7736);
     * ll.toString(); // = "LngLat(-73.9749, 40.7736)"
     * ```
     */
    toString() {
        return `LngLat(${this.lng}, ${this.lat})`;
    }
    /**
     * Returns the approximate distance between a pair of coordinates in meters
     * Uses the Haversine Formula (from R.W. Sinnott, "Virtues of the Haversine", Sky and Telescope, vol. 68, no. 2, 1984, p. 159)
     *
     * @param lngLat - coordinates to compute the distance to
     * @returns Distance in meters between the two coordinates.
     * @example
     * ```ts
     * let new_york = new LngLat(-74.0060, 40.7128);
     * let los_angeles = new LngLat(-118.2437, 34.0522);
     * new_york.distanceTo(los_angeles); // = 3935751.690893987, "true distance" using a non-spherical approximation is ~3966km
     * ```
     */
    distanceTo(lngLat) {
        const rad = Math.PI / 180;
        const lat1 = this.lat * rad;
        const lat2 = lngLat.lat * rad;
        const a = Math.sin(lat1) * Math.sin(lat2) + Math.cos(lat1) * Math.cos(lat2) * Math.cos((lngLat.lng - this.lng) * rad);
        const maxMeters = earthRadius * Math.acos(Math.min(a, 1));
        return maxMeters;
    }
    /**
     * Converts an array of two numbers or an object with `lng` and `lat` or `lon` and `lat` properties
     * to a `LngLat` object.
     *
     * If a `LngLat` object is passed in, the function returns it unchanged.
     *
     * @param input - An array of two numbers or object to convert, or a `LngLat` object to return.
     * @returns A new `LngLat` object, if a conversion occurred, or the original `LngLat` object.
     * @example
     * ```ts
     * let arr = [-73.9749, 40.7736];
     * let ll = LngLat.convert(arr);
     * ll;   // = LngLat {lng: -73.9749, lat: 40.7736}
     * ```
     */
    static convert(input) {
        if (input instanceof LngLat) {
            return input;
        }
        if (Array.isArray(input) && (input.length === 2 || input.length === 3)) {
            return new LngLat(Number(input[0]), Number(input[1]));
        }
        if (!Array.isArray(input) && typeof input === 'object' && input !== null) {
            return new LngLat(
            // flow can't refine this to have one of lng or lat, so we have to cast to any
            Number('lng' in input ? input.lng : input.lon), Number(input.lat));
        }
        throw new Error('`LngLatLike` argument must be specified as a LngLat instance, an object {lng: <lng>, lat: <lat>}, an object {lon: <lng>, lat: <lat>}, or an array of [<lng>, <lat>]');
    }
}

/*
 * The average circumference of the world in meters.
 */
const earthCircumference = 2 * Math.PI * earthRadius; // meters
/*
 * The circumference at a line of latitude in meters.
 */
function circumferenceAtLatitude(latitude) {
    return earthCircumference * Math.cos(latitude * Math.PI / 180);
}
function mercatorXfromLng(lng) {
    return (180 + lng) / 360;
}
function mercatorYfromLat(lat) {
    return (180 - (180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + lat * Math.PI / 360)))) / 360;
}
function mercatorZfromAltitude(altitude, lat) {
    return altitude / circumferenceAtLatitude(lat);
}
function lngFromMercatorX(x) {
    return x * 360 - 180;
}
function latFromMercatorY(y) {
    const y2 = 180 - y * 360;
    return 360 / Math.PI * Math.atan(Math.exp(y2 * Math.PI / 180)) - 90;
}
function altitudeFromMercatorZ(z, y) {
    return z * circumferenceAtLatitude(latFromMercatorY(y));
}
/**
 * Determine the Mercator scale factor for a given latitude, see
 * https://en.wikipedia.org/wiki/Mercator_projection#Scale_factor
 *
 * At the equator the scale factor will be 1, which increases at higher latitudes.
 *
 * @param lat - Latitude
 * @returns scale factor
 */
function mercatorScale(lat) {
    return 1 / Math.cos(lat * Math.PI / 180);
}
/**
 * A `MercatorCoordinate` object represents a projected three dimensional position.
 *
 * `MercatorCoordinate` uses the web mercator projection ([EPSG:3857](https://epsg.io/3857)) with slightly different units:
 *
 * - the size of 1 unit is the width of the projected world instead of the "mercator meter"
 * - the origin of the coordinate space is at the north-west corner instead of the middle
 *
 * For example, `MercatorCoordinate(0, 0, 0)` is the north-west corner of the mercator world and
 * `MercatorCoordinate(1, 1, 0)` is the south-east corner. If you are familiar with
 * [vector tiles](https://github.com/mapbox/vector-tile-spec) it may be helpful to think
 * of the coordinate space as the `0/0/0` tile with an extent of `1`.
 *
 * The `z` dimension of `MercatorCoordinate` is conformal. A cube in the mercator coordinate space would be rendered as a cube.
 *
 * @group Geography and Geometry
 *
 * @example
 * ```ts
 * let nullIsland = new MercatorCoordinate(0.5, 0.5, 0);
 * ```
 * @see [Add a custom style layer](https://maplibre.org/maplibre-gl-js/docs/examples/custom-style-layer/)
 */
class MercatorCoordinate {
    /**
     * @param x - The x component of the position.
     * @param y - The y component of the position.
     * @param z - The z component of the position.
     */
    constructor(x, y, z = 0) {
        this.x = +x;
        this.y = +y;
        this.z = +z;
    }
    /**
     * Project a `LngLat` to a `MercatorCoordinate`.
     *
     * @param lngLatLike - The location to project.
     * @param altitude - The altitude in meters of the position.
     * @returns The projected mercator coordinate.
     * @example
     * ```ts
     * let coord = MercatorCoordinate.fromLngLat({ lng: 0, lat: 0}, 0);
     * coord; // MercatorCoordinate(0.5, 0.5, 0)
     * ```
     */
    static fromLngLat(lngLatLike, altitude = 0) {
        const lngLat = LngLat.convert(lngLatLike);
        return new MercatorCoordinate(mercatorXfromLng(lngLat.lng), mercatorYfromLat(lngLat.lat), mercatorZfromAltitude(altitude, lngLat.lat));
    }
    /**
     * Returns the `LngLat` for the coordinate.
     *
     * @returns The `LngLat` object.
     * @example
     * ```ts
     * let coord = new MercatorCoordinate(0.5, 0.5, 0);
     * let lngLat = coord.toLngLat(); // LngLat(0, 0)
     * ```
     */
    toLngLat() {
        return new LngLat(lngFromMercatorX(this.x), latFromMercatorY(this.y));
    }
    /**
     * Returns the altitude in meters of the coordinate.
     *
     * @returns The altitude in meters.
     * @example
     * ```ts
     * let coord = new MercatorCoordinate(0, 0, 0.02);
     * coord.toAltitude(); // 6914.281956295339
     * ```
     */
    toAltitude() {
        return altitudeFromMercatorZ(this.z, this.y);
    }
    /**
     * Returns the distance of 1 meter in `MercatorCoordinate` units at this latitude.
     *
     * For coordinates in real world units using meters, this naturally provides the scale
     * to transform into `MercatorCoordinate`s.
     *
     * @returns Distance of 1 meter in `MercatorCoordinate` units.
     */
    meterInMercatorCoordinateUnits() {
        // 1 meter / circumference at equator in meters * Mercator projection scale factor at this latitude
        return 1 / earthCircumference * mercatorScale(latFromMercatorY(this.y));
    }
}

/**
 * getTileBBox
 *
 * @param    {Number}  x  Tile coordinate x
 * @param    {Number}  y  Tile coordinate y
 * @param    {Number}  z  Tile zoom
 * @returns  {String}  String of the bounding box
 */
function getTileBBox(x, y, z) {
    // for Google/OSM tile scheme we need to alter the y
    y = (Math.pow(2, z) - y - 1);

    var min = getMercCoords(x * 256, y * 256, z),
        max = getMercCoords((x + 1) * 256, (y + 1) * 256, z);

    return min[0] + ',' + min[1] + ',' + max[0] + ',' + max[1];
}


/**
 * getMercCoords
 *
 * @param    {Number}  x  Pixel coordinate x
 * @param    {Number}  y  Pixel coordinate y
 * @param    {Number}  z  Tile zoom
 * @returns  {Array}   [x, y]
 */
function getMercCoords(x, y, z) {
    var resolution = (2 * Math.PI * 6378137 / 256) / Math.pow(2, z),
        merc_x = (x * resolution - 2 * Math.PI  * 6378137 / 2.0),
        merc_y = (y * resolution - 2 * Math.PI  * 6378137 / 2.0);

    return [merc_x, merc_y];
}

/**
 * A canonical way to define a tile ID
 */
class CanonicalTileID {
    constructor(z, x, y) {
        if (z < 0 || z > 25 || y < 0 || y >= Math.pow(2, z) || x < 0 || x >= Math.pow(2, z)) {
            throw new Error(`x=${x}, y=${y}, z=${z} outside of bounds. 0<=x<${Math.pow(2, z)}, 0<=y<${Math.pow(2, z)} 0<=z<=25 `);
        }
        this.z = z;
        this.x = x;
        this.y = y;
        this.key = calculateKey(0, z, z, x, y);
    }
    equals(id) {
        return this.z === id.z && this.x === id.x && this.y === id.y;
    }
    // given a list of urls, choose a url template and return a tile URL
    url(urls, pixelRatio, scheme) {
        const bbox = getTileBBox(this.x, this.y, this.z);
        const quadkey = getQuadkey(this.z, this.x, this.y);
        return urls[(this.x + this.y) % urls.length]
            .replace(/{prefix}/g, (this.x % 16).toString(16) + (this.y % 16).toString(16))
            .replace(/{z}/g, String(this.z))
            .replace(/{x}/g, String(this.x))
            .replace(/{y}/g, String(scheme === 'tms' ? (Math.pow(2, this.z) - this.y - 1) : this.y))
            .replace(/{ratio}/g, pixelRatio > 1 ? '@2x' : '')
            .replace(/{quadkey}/g, quadkey)
            .replace(/{bbox-epsg-3857}/g, bbox);
    }
    isChildOf(parent) {
        const dz = this.z - parent.z;
        return dz > 0 && parent.x === (this.x >> dz) && parent.y === (this.y >> dz);
    }
    getTilePoint(coord) {
        const tilesAtZoom = Math.pow(2, this.z);
        return new Point$2((coord.x * tilesAtZoom - this.x) * EXTENT, (coord.y * tilesAtZoom - this.y) * EXTENT);
    }
    toString() {
        return `${this.z}/${this.x}/${this.y}`;
    }
}
/**
 * @internal
 * An unwrapped tile identifier
 */
class UnwrappedTileID {
    constructor(wrap, canonical) {
        this.wrap = wrap;
        this.canonical = canonical;
        this.key = calculateKey(wrap, canonical.z, canonical.z, canonical.x, canonical.y);
    }
}
/**
 * An overscaled tile identifier
 */
class OverscaledTileID {
    constructor(overscaledZ, wrap, z, x, y) {
        if (overscaledZ < z)
            throw new Error(`overscaledZ should be >= z; overscaledZ = ${overscaledZ}; z = ${z}`);
        this.overscaledZ = overscaledZ;
        this.wrap = wrap;
        this.canonical = new CanonicalTileID(z, +x, +y);
        this.key = calculateKey(wrap, overscaledZ, z, x, y);
    }
    clone() {
        return new OverscaledTileID(this.overscaledZ, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y);
    }
    equals(id) {
        return this.overscaledZ === id.overscaledZ && this.wrap === id.wrap && this.canonical.equals(id.canonical);
    }
    scaledTo(targetZ) {
        if (targetZ > this.overscaledZ)
            throw new Error(`targetZ > this.overscaledZ; targetZ = ${targetZ}; overscaledZ = ${this.overscaledZ}`);
        const zDifference = this.canonical.z - targetZ;
        if (targetZ > this.canonical.z) {
            return new OverscaledTileID(targetZ, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y);
        }
        else {
            return new OverscaledTileID(targetZ, this.wrap, targetZ, this.canonical.x >> zDifference, this.canonical.y >> zDifference);
        }
    }
    /*
     * calculateScaledKey is an optimization:
     * when withWrap == true, implements the same as this.scaledTo(z).key,
     * when withWrap == false, implements the same as this.scaledTo(z).wrapped().key.
     */
    calculateScaledKey(targetZ, withWrap) {
        if (targetZ > this.overscaledZ)
            throw new Error(`targetZ > this.overscaledZ; targetZ = ${targetZ}; overscaledZ = ${this.overscaledZ}`);
        const zDifference = this.canonical.z - targetZ;
        if (targetZ > this.canonical.z) {
            return calculateKey(this.wrap * +withWrap, targetZ, this.canonical.z, this.canonical.x, this.canonical.y);
        }
        else {
            return calculateKey(this.wrap * +withWrap, targetZ, targetZ, this.canonical.x >> zDifference, this.canonical.y >> zDifference);
        }
    }
    isChildOf(parent) {
        if (parent.wrap !== this.wrap) {
            // We can't be a child if we're in a different world copy
            return false;
        }
        const zDifference = this.canonical.z - parent.canonical.z;
        // We're first testing for z == 0, to avoid a 32 bit shift, which is undefined.
        return parent.overscaledZ === 0 || (parent.overscaledZ < this.overscaledZ &&
            parent.canonical.x === (this.canonical.x >> zDifference) &&
            parent.canonical.y === (this.canonical.y >> zDifference));
    }
    children(sourceMaxZoom) {
        if (this.overscaledZ >= sourceMaxZoom) {
            // return a single tile coord representing a an overscaled tile
            return [new OverscaledTileID(this.overscaledZ + 1, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y)];
        }
        const z = this.canonical.z + 1;
        const x = this.canonical.x * 2;
        const y = this.canonical.y * 2;
        return [
            new OverscaledTileID(z, this.wrap, z, x, y),
            new OverscaledTileID(z, this.wrap, z, x + 1, y),
            new OverscaledTileID(z, this.wrap, z, x, y + 1),
            new OverscaledTileID(z, this.wrap, z, x + 1, y + 1)
        ];
    }
    isLessThan(rhs) {
        if (this.wrap < rhs.wrap)
            return true;
        if (this.wrap > rhs.wrap)
            return false;
        if (this.overscaledZ < rhs.overscaledZ)
            return true;
        if (this.overscaledZ > rhs.overscaledZ)
            return false;
        if (this.canonical.x < rhs.canonical.x)
            return true;
        if (this.canonical.x > rhs.canonical.x)
            return false;
        if (this.canonical.y < rhs.canonical.y)
            return true;
        return false;
    }
    wrapped() {
        return new OverscaledTileID(this.overscaledZ, 0, this.canonical.z, this.canonical.x, this.canonical.y);
    }
    unwrapTo(wrap) {
        return new OverscaledTileID(this.overscaledZ, wrap, this.canonical.z, this.canonical.x, this.canonical.y);
    }
    overscaleFactor() {
        return Math.pow(2, this.overscaledZ - this.canonical.z);
    }
    toUnwrapped() {
        return new UnwrappedTileID(this.wrap, this.canonical);
    }
    toString() {
        return `${this.overscaledZ}/${this.canonical.x}/${this.canonical.y}`;
    }
    getTilePoint(coord) {
        return this.canonical.getTilePoint(new MercatorCoordinate(coord.x - this.wrap, coord.y));
    }
}
function calculateKey(wrap, overscaledZ, z, x, y) {
    wrap *= 2;
    if (wrap < 0)
        wrap = wrap * -1 - 1;
    const dim = 1 << z;
    return (dim * dim * wrap + dim * y + x).toString(36) + z.toString(36) + overscaledZ.toString(36);
}
function getQuadkey(z, x, y) {
    let quadkey = '', mask;
    for (let i = z; i > 0; i--) {
        mask = 1 << (i - 1);
        quadkey += ((x & mask ? 1 : 0) + (y & mask ? 2 : 0));
    }
    return quadkey;
}
register('CanonicalTileID', CanonicalTileID);
register('OverscaledTileID', OverscaledTileID, { omit: ['posMatrix'] });

/**
 * DEMData is a data structure for decoding, backfilling, and storing elevation data for processing in the hillshade shaders
 * data can be populated either from a pngraw image tile or from serialized data sent back from a worker. When data is initially
 * loaded from a image tile, we decode the pixel values using the appropriate decoding formula, but we store the
 * elevation data as an Int32 value. we add 65536 (2^16) to eliminate negative values and enable the use of
 * integer overflow when creating the texture used in the hillshadePrepare step.
 *
 * DEMData also handles the backfilling of data from a tile's neighboring tiles. This is necessary because we use a pixel's 8
 * surrounding pixel values to compute the slope at that pixel, and we cannot accurately calculate the slope at pixels on a
 * tile's edge without backfilling from neighboring tiles.
 */
class DEMData {
    /**
     * Constructs a `DEMData` object
     * @param uid - the tile's unique id
     * @param data - RGBAImage data has uniform 1px padding on all sides: square tile edge size defines stride
    // and dim is calculated as stride - 2.
     * @param encoding - the encoding type of the data
     * @param redFactor - the red channel factor used to unpack the data, used for `custom` encoding only
     * @param greenFactor - the green channel factor used to unpack the data, used for `custom` encoding only
     * @param blueFactor - the blue channel factor used to unpack the data, used for `custom` encoding only
     * @param baseShift - the base shift used to unpack the data, used for `custom` encoding only
     */
    constructor(uid, data, encoding, redFactor = 1.0, greenFactor = 1.0, blueFactor = 1.0, baseShift = 0.0) {
        this.uid = uid;
        if (data.height !== data.width)
            throw new RangeError('DEM tiles must be square');
        if (encoding && !['mapbox', 'terrarium', 'custom'].includes(encoding)) {
            warnOnce(`"${encoding}" is not a valid encoding type. Valid types include "mapbox", "terrarium" and "custom".`);
            return;
        }
        this.stride = data.height;
        const dim = this.dim = data.height - 2;
        this.data = new Uint32Array(data.data.buffer);
        switch (encoding) {
            case 'terrarium':
                // unpacking formula for mapzen terrarium:
                // https://aws.amazon.com/public-datasets/terrain/
                this.redFactor = 256.0;
                this.greenFactor = 1.0;
                this.blueFactor = 1.0 / 256.0;
                this.baseShift = 32768.0;
                break;
            case 'custom':
                this.redFactor = redFactor;
                this.greenFactor = greenFactor;
                this.blueFactor = blueFactor;
                this.baseShift = baseShift;
                break;
            case 'mapbox':
            default:
                // unpacking formula for mapbox.terrain-rgb:
                // https://www.mapbox.com/help/access-elevation-data/#mapbox-terrain-rgb
                this.redFactor = 6553.6;
                this.greenFactor = 25.6;
                this.blueFactor = 0.1;
                this.baseShift = 10000.0;
                break;
        }
        // in order to avoid flashing seams between tiles, here we are initially populating a 1px border of pixels around the image
        // with the data of the nearest pixel from the image. this data is eventually replaced when the tile's neighboring
        // tiles are loaded and the accurate data can be backfilled using DEMData#backfillBorder
        for (let x = 0; x < dim; x++) {
            // left vertical border
            this.data[this._idx(-1, x)] = this.data[this._idx(0, x)];
            // right vertical border
            this.data[this._idx(dim, x)] = this.data[this._idx(dim - 1, x)];
            // left horizontal border
            this.data[this._idx(x, -1)] = this.data[this._idx(x, 0)];
            // right horizontal border
            this.data[this._idx(x, dim)] = this.data[this._idx(x, dim - 1)];
        }
        // corners
        this.data[this._idx(-1, -1)] = this.data[this._idx(0, 0)];
        this.data[this._idx(dim, -1)] = this.data[this._idx(dim - 1, 0)];
        this.data[this._idx(-1, dim)] = this.data[this._idx(0, dim - 1)];
        this.data[this._idx(dim, dim)] = this.data[this._idx(dim - 1, dim - 1)];
        // calculate min/max values
        this.min = Number.MAX_SAFE_INTEGER;
        this.max = Number.MIN_SAFE_INTEGER;
        for (let x = 0; x < dim; x++) {
            for (let y = 0; y < dim; y++) {
                const ele = this.get(x, y);
                if (ele > this.max)
                    this.max = ele;
                if (ele < this.min)
                    this.min = ele;
            }
        }
    }
    get(x, y) {
        const pixels = new Uint8Array(this.data.buffer);
        const index = this._idx(x, y) * 4;
        return this.unpack(pixels[index], pixels[index + 1], pixels[index + 2]);
    }
    getUnpackVector() {
        return [this.redFactor, this.greenFactor, this.blueFactor, this.baseShift];
    }
    _idx(x, y) {
        if (x < -1 || x >= this.dim + 1 || y < -1 || y >= this.dim + 1)
            throw new RangeError('out of range source coordinates for DEM data');
        return (y + 1) * this.stride + (x + 1);
    }
    unpack(r, g, b) {
        return (r * this.redFactor + g * this.greenFactor + b * this.blueFactor - this.baseShift);
    }
    getPixels() {
        return new RGBAImage({ width: this.stride, height: this.stride }, new Uint8Array(this.data.buffer));
    }
    backfillBorder(borderTile, dx, dy) {
        if (this.dim !== borderTile.dim)
            throw new Error('dem dimension mismatch');
        let xMin = dx * this.dim, xMax = dx * this.dim + this.dim, yMin = dy * this.dim, yMax = dy * this.dim + this.dim;
        switch (dx) {
            case -1:
                xMin = xMax - 1;
                break;
            case 1:
                xMax = xMin + 1;
                break;
        }
        switch (dy) {
            case -1:
                yMin = yMax - 1;
                break;
            case 1:
                yMax = yMin + 1;
                break;
        }
        const ox = -dx * this.dim;
        const oy = -dy * this.dim;
        for (let y = yMin; y < yMax; y++) {
            for (let x = xMin; x < xMax; x++) {
                this.data[this._idx(x, y)] = borderTile.data[this._idx(x + ox, y + oy)];
            }
        }
    }
}
register('DEMData', DEMData);

class DictionaryCoder {
    constructor(strings) {
        this._stringToNumber = {};
        this._numberToString = [];
        for (let i = 0; i < strings.length; i++) {
            const string = strings[i];
            this._stringToNumber[string] = i;
            this._numberToString[i] = string;
        }
    }
    encode(string) {
        return this._stringToNumber[string];
    }
    decode(n) {
        if (n >= this._numberToString.length)
            throw new Error(`Out of bounds. Index requested n=${n} can't be >= this._numberToString.length ${this._numberToString.length}`);
        return this._numberToString[n];
    }
}

/**
 * A geojson feature
 */
class GeoJSONFeature {
    constructor(vectorTileFeature, z, x, y, id) {
        this.type = 'Feature';
        this._vectorTileFeature = vectorTileFeature;
        vectorTileFeature._z = z;
        vectorTileFeature._x = x;
        vectorTileFeature._y = y;
        this.properties = vectorTileFeature.properties;
        this.id = id;
    }
    get geometry() {
        if (this._geometry === undefined) {
            this._geometry = this._vectorTileFeature.toGeoJSON(this._vectorTileFeature._x, this._vectorTileFeature._y, this._vectorTileFeature._z).geometry;
        }
        return this._geometry;
    }
    set geometry(g) {
        this._geometry = g;
    }
    toJSON() {
        const json = {
            geometry: this.geometry
        };
        for (const i in this) {
            if (i === '_geometry' || i === '_vectorTileFeature')
                continue;
            json[i] = (this)[i];
        }
        return json;
    }
}

/**
 * An in memory index class to allow fast interaction with features
 */
class FeatureIndex {
    constructor(tileID, promoteId) {
        this.tileID = tileID;
        this.x = tileID.canonical.x;
        this.y = tileID.canonical.y;
        this.z = tileID.canonical.z;
        this.grid = new TransferableGridIndex(EXTENT, 16, 0);
        this.grid3D = new TransferableGridIndex(EXTENT, 16, 0);
        this.featureIndexArray = new FeatureIndexArray();
        this.promoteId = promoteId;
    }
    insert(feature, geometry, featureIndex, sourceLayerIndex, bucketIndex, is3D) {
        const key = this.featureIndexArray.length;
        this.featureIndexArray.emplaceBack(featureIndex, sourceLayerIndex, bucketIndex);
        const grid = is3D ? this.grid3D : this.grid;
        for (let r = 0; r < geometry.length; r++) {
            const ring = geometry[r];
            const bbox = [Infinity, Infinity, -Infinity, -Infinity];
            for (let i = 0; i < ring.length; i++) {
                const p = ring[i];
                bbox[0] = Math.min(bbox[0], p.x);
                bbox[1] = Math.min(bbox[1], p.y);
                bbox[2] = Math.max(bbox[2], p.x);
                bbox[3] = Math.max(bbox[3], p.y);
            }
            if (bbox[0] < EXTENT &&
                bbox[1] < EXTENT &&
                bbox[2] >= 0 &&
                bbox[3] >= 0) {
                grid.insert(key, bbox[0], bbox[1], bbox[2], bbox[3]);
            }
        }
    }
    loadVTLayers() {
        if (!this.vtLayers) {
            this.vtLayers = new vectorTile.VectorTile(new Protobuf(this.rawTileData)).layers;
            this.sourceLayerCoder = new DictionaryCoder(this.vtLayers ? Object.keys(this.vtLayers).sort() : ['_geojsonTileLayer']);
        }
        return this.vtLayers;
    }
    // Finds non-symbol features in this tile at a particular position.
    query(args, styleLayers, serializedLayers, sourceFeatureState) {
        this.loadVTLayers();
        const params = args.params || {}, pixelsToTileUnits = EXTENT / args.tileSize / args.scale, filter = createFilter(params.filter);
        const queryGeometry = args.queryGeometry;
        const queryPadding = args.queryPadding * pixelsToTileUnits;
        const bounds = getBounds(queryGeometry);
        const matching = this.grid.query(bounds.minX - queryPadding, bounds.minY - queryPadding, bounds.maxX + queryPadding, bounds.maxY + queryPadding);
        const cameraBounds = getBounds(args.cameraQueryGeometry);
        const matching3D = this.grid3D.query(cameraBounds.minX - queryPadding, cameraBounds.minY - queryPadding, cameraBounds.maxX + queryPadding, cameraBounds.maxY + queryPadding, (bx1, by1, bx2, by2) => {
            return polygonIntersectsBox(args.cameraQueryGeometry, bx1 - queryPadding, by1 - queryPadding, bx2 + queryPadding, by2 + queryPadding);
        });
        for (const key of matching3D) {
            matching.push(key);
        }
        matching.sort(topDownFeatureComparator);
        const result = {};
        let previousIndex;
        for (let k = 0; k < matching.length; k++) {
            const index = matching[k];
            // don't check the same feature more than once
            if (index === previousIndex)
                continue;
            previousIndex = index;
            const match = this.featureIndexArray.get(index);
            let featureGeometry = null;
            this.loadMatchingFeature(result, match.bucketIndex, match.sourceLayerIndex, match.featureIndex, filter, params.layers, params.availableImages, styleLayers, serializedLayers, sourceFeatureState, (feature, styleLayer, featureState) => {
                if (!featureGeometry) {
                    featureGeometry = loadGeometry(feature);
                }
                return styleLayer.queryIntersectsFeature(queryGeometry, feature, featureState, featureGeometry, this.z, args.transform, pixelsToTileUnits, args.pixelPosMatrix);
            });
        }
        return result;
    }
    loadMatchingFeature(result, bucketIndex, sourceLayerIndex, featureIndex, filter, filterLayerIDs, availableImages, styleLayers, serializedLayers, sourceFeatureState, intersectionTest) {
        const layerIDs = this.bucketLayerIDs[bucketIndex];
        if (filterLayerIDs && !arraysIntersect(filterLayerIDs, layerIDs))
            return;
        const sourceLayerName = this.sourceLayerCoder.decode(sourceLayerIndex);
        const sourceLayer = this.vtLayers[sourceLayerName];
        const feature = sourceLayer.feature(featureIndex);
        if (filter.needGeometry) {
            const evaluationFeature = toEvaluationFeature(feature, true);
            if (!filter.filter(new EvaluationParameters(this.tileID.overscaledZ), evaluationFeature, this.tileID.canonical)) {
                return;
            }
        }
        else if (!filter.filter(new EvaluationParameters(this.tileID.overscaledZ), feature)) {
            return;
        }
        const id = this.getId(feature, sourceLayerName);
        for (let l = 0; l < layerIDs.length; l++) {
            const layerID = layerIDs[l];
            if (filterLayerIDs && filterLayerIDs.indexOf(layerID) < 0) {
                continue;
            }
            const styleLayer = styleLayers[layerID];
            if (!styleLayer)
                continue;
            let featureState = {};
            if (id && sourceFeatureState) {
                // `feature-state` expression evaluation requires feature state to be available
                featureState = sourceFeatureState.getState(styleLayer.sourceLayer || '_geojsonTileLayer', id);
            }
            const serializedLayer = extend({}, serializedLayers[layerID]);
            serializedLayer.paint = evaluateProperties(serializedLayer.paint, styleLayer.paint, feature, featureState, availableImages);
            serializedLayer.layout = evaluateProperties(serializedLayer.layout, styleLayer.layout, feature, featureState, availableImages);
            const intersectionZ = !intersectionTest || intersectionTest(feature, styleLayer, featureState);
            if (!intersectionZ) {
                // Only applied for non-symbol features
                continue;
            }
            const geojsonFeature = new GeoJSONFeature(feature, this.z, this.x, this.y, id);
            geojsonFeature.layer = serializedLayer;
            let layerResult = result[layerID];
            if (layerResult === undefined) {
                layerResult = result[layerID] = [];
            }
            layerResult.push({ featureIndex, feature: geojsonFeature, intersectionZ });
        }
    }
    // Given a set of symbol indexes that have already been looked up,
    // return a matching set of GeoJSONFeatures
    lookupSymbolFeatures(symbolFeatureIndexes, serializedLayers, bucketIndex, sourceLayerIndex, filterSpec, filterLayerIDs, availableImages, styleLayers) {
        const result = {};
        this.loadVTLayers();
        const filter = createFilter(filterSpec);
        for (const symbolFeatureIndex of symbolFeatureIndexes) {
            this.loadMatchingFeature(result, bucketIndex, sourceLayerIndex, symbolFeatureIndex, filter, filterLayerIDs, availableImages, styleLayers, serializedLayers);
        }
        return result;
    }
    hasLayer(id) {
        for (const layerIDs of this.bucketLayerIDs) {
            for (const layerID of layerIDs) {
                if (id === layerID)
                    return true;
            }
        }
        return false;
    }
    getId(feature, sourceLayerId) {
        let id = feature.id;
        if (this.promoteId) {
            const propName = typeof this.promoteId === 'string' ? this.promoteId : this.promoteId[sourceLayerId];
            id = feature.properties[propName];
            if (typeof id === 'boolean')
                id = Number(id);
        }
        return id;
    }
}
register('FeatureIndex', FeatureIndex, { omit: ['rawTileData', 'sourceLayerCoder'] });
function evaluateProperties(serializedProperties, styleLayerProperties, feature, featureState, availableImages) {
    return mapObject(serializedProperties, (property, key) => {
        const prop = styleLayerProperties instanceof PossiblyEvaluated ? styleLayerProperties.get(key) : null;
        return prop && prop.evaluate ? prop.evaluate(feature, featureState, availableImages) : prop;
    });
}
function getBounds(geometry) {
    let minX = Infinity;
    let minY = Infinity;
    let maxX = -Infinity;
    let maxY = -Infinity;
    for (const p of geometry) {
        minX = Math.min(minX, p.x);
        minY = Math.min(minY, p.y);
        maxX = Math.max(maxX, p.x);
        maxY = Math.max(maxY, p.y);
    }
    return { minX, minY, maxX, maxY };
}
function topDownFeatureComparator(a, b) {
    return b - a;
}

/**
 * Returns the part of a multiline that intersects with the provided rectangular box.
 *
 * @param lines - the lines to check
 * @param x1 - the left edge of the box
 * @param y1 - the top edge of the box
 * @param x2 - the right edge of the box
 * @param y2 - the bottom edge of the box
 * @returns lines
 */
function clipLine(lines, x1, y1, x2, y2) {
    const clippedLines = [];
    for (let l = 0; l < lines.length; l++) {
        const line = lines[l];
        let clippedLine;
        for (let i = 0; i < line.length - 1; i++) {
            let p0 = line[i];
            let p1 = line[i + 1];
            if (p0.x < x1 && p1.x < x1) {
                continue;
            }
            else if (p0.x < x1) {
                p0 = new Point$2(x1, p0.y + (p1.y - p0.y) * ((x1 - p0.x) / (p1.x - p0.x)))._round();
            }
            else if (p1.x < x1) {
                p1 = new Point$2(x1, p0.y + (p1.y - p0.y) * ((x1 - p0.x) / (p1.x - p0.x)))._round();
            }
            if (p0.y < y1 && p1.y < y1) {
                continue;
            }
            else if (p0.y < y1) {
                p0 = new Point$2(p0.x + (p1.x - p0.x) * ((y1 - p0.y) / (p1.y - p0.y)), y1)._round();
            }
            else if (p1.y < y1) {
                p1 = new Point$2(p0.x + (p1.x - p0.x) * ((y1 - p0.y) / (p1.y - p0.y)), y1)._round();
            }
            if (p0.x >= x2 && p1.x >= x2) {
                continue;
            }
            else if (p0.x >= x2) {
                p0 = new Point$2(x2, p0.y + (p1.y - p0.y) * ((x2 - p0.x) / (p1.x - p0.x)))._round();
            }
            else if (p1.x >= x2) {
                p1 = new Point$2(x2, p0.y + (p1.y - p0.y) * ((x2 - p0.x) / (p1.x - p0.x)))._round();
            }
            if (p0.y >= y2 && p1.y >= y2) {
                continue;
            }
            else if (p0.y >= y2) {
                p0 = new Point$2(p0.x + (p1.x - p0.x) * ((y2 - p0.y) / (p1.y - p0.y)), y2)._round();
            }
            else if (p1.y >= y2) {
                p1 = new Point$2(p0.x + (p1.x - p0.x) * ((y2 - p0.y) / (p1.y - p0.y)), y2)._round();
            }
            if (!clippedLine || !p0.equals(clippedLine[clippedLine.length - 1])) {
                clippedLine = [p0];
                clippedLines.push(clippedLine);
            }
            clippedLine.push(p1);
        }
    }
    return clippedLines;
}

class Anchor extends Point$2 {
    constructor(x, y, angle, segment) {
        super(x, y);
        this.angle = angle;
        if (segment !== undefined) {
            this.segment = segment;
        }
    }
    clone() {
        return new Anchor(this.x, this.y, this.angle, this.segment);
    }
}
register('Anchor', Anchor);

/**
 * Labels placed around really sharp angles aren't readable. Check if any
 * part of the potential label has a combined angle that is too big.
 *
 * @param line - The line to check
 * @param anchor - The point on the line around which the label is anchored.
 * @param labelLength - The length of the label in geometry units.
 * @param windowSize - The check fails if the combined angles within a part of the line that is `windowSize` long is too big.
 * @param maxAngle - The maximum combined angle that any window along the label is allowed to have.
 *
 * @returns whether the label should be placed
 */
function checkMaxAngle(line, anchor, labelLength, windowSize, maxAngle) {
    // horizontal labels and labels with length 0 always pass
    if (anchor.segment === undefined || labelLength === 0)
        return true;
    let p = anchor;
    let index = anchor.segment + 1;
    let anchorDistance = 0;
    // move backwards along the line to the first segment the label appears on
    while (anchorDistance > -labelLength / 2) {
        index--;
        // there isn't enough room for the label after the beginning of the line
        if (index < 0)
            return false;
        anchorDistance -= line[index].dist(p);
        p = line[index];
    }
    anchorDistance += line[index].dist(line[index + 1]);
    index++;
    // store recent corners and their total angle difference
    const recentCorners = [];
    let recentAngleDelta = 0;
    // move forwards by the length of the label and check angles along the way
    while (anchorDistance < labelLength / 2) {
        const prev = line[index - 1];
        const current = line[index];
        const next = line[index + 1];
        // there isn't enough room for the label before the end of the line
        if (!next)
            return false;
        let angleDelta = prev.angleTo(current) - current.angleTo(next);
        // restrict angle to -pi..pi range
        angleDelta = Math.abs(((angleDelta + 3 * Math.PI) % (Math.PI * 2)) - Math.PI);
        recentCorners.push({
            distance: anchorDistance,
            angleDelta
        });
        recentAngleDelta += angleDelta;
        // remove corners that are far enough away from the list of recent anchors
        while (anchorDistance - recentCorners[0].distance > windowSize) {
            recentAngleDelta -= recentCorners.shift().angleDelta;
        }
        // the sum of angles within the window area exceeds the maximum allowed value. check fails.
        if (recentAngleDelta > maxAngle)
            return false;
        index++;
        anchorDistance += current.dist(next);
    }
    // no part of the line had an angle greater than the maximum allowed. check passes.
    return true;
}

function getLineLength(line) {
    let lineLength = 0;
    for (let k = 0; k < line.length - 1; k++) {
        lineLength += line[k].dist(line[k + 1]);
    }
    return lineLength;
}
function getAngleWindowSize(shapedText, glyphSize, boxScale) {
    return shapedText ?
        3 / 5 * glyphSize * boxScale :
        0;
}
function getShapedLabelLength(shapedText, shapedIcon) {
    return Math.max(shapedText ? shapedText.right - shapedText.left : 0, shapedIcon ? shapedIcon.right - shapedIcon.left : 0);
}
function getCenterAnchor(line, maxAngle, shapedText, shapedIcon, glyphSize, boxScale) {
    const angleWindowSize = getAngleWindowSize(shapedText, glyphSize, boxScale);
    const labelLength = getShapedLabelLength(shapedText, shapedIcon) * boxScale;
    let prevDistance = 0;
    const centerDistance = getLineLength(line) / 2;
    for (let i = 0; i < line.length - 1; i++) {
        const a = line[i], b = line[i + 1];
        const segmentDistance = a.dist(b);
        if (prevDistance + segmentDistance > centerDistance) {
            // The center is on this segment
            const t = (centerDistance - prevDistance) / segmentDistance, x = interpolate.number(a.x, b.x, t), y = interpolate.number(a.y, b.y, t);
            const anchor = new Anchor(x, y, b.angleTo(a), i);
            anchor._round();
            if (!angleWindowSize || checkMaxAngle(line, anchor, labelLength, angleWindowSize, maxAngle)) {
                return anchor;
            }
            else {
                return;
            }
        }
        prevDistance += segmentDistance;
    }
}
function getAnchors(line, spacing, maxAngle, shapedText, shapedIcon, glyphSize, boxScale, overscaling, tileExtent) {
    // Resample a line to get anchor points for labels and check that each
    // potential label passes text-max-angle check and has enough room to fit
    // on the line.
    const angleWindowSize = getAngleWindowSize(shapedText, glyphSize, boxScale);
    const shapedLabelLength = getShapedLabelLength(shapedText, shapedIcon);
    const labelLength = shapedLabelLength * boxScale;
    // Is the line continued from outside the tile boundary?
    const isLineContinued = line[0].x === 0 || line[0].x === tileExtent || line[0].y === 0 || line[0].y === tileExtent;
    // Is the label long, relative to the spacing?
    // If so, adjust the spacing so there is always a minimum space of `spacing / 4` between label edges.
    if (spacing - labelLength < spacing / 4) {
        spacing = labelLength + spacing / 4;
    }
    // Offset the first anchor by:
    // Either half the label length plus a fixed extra offset if the line is not continued
    // Or half the spacing if the line is continued.
    // For non-continued lines, add a bit of fixed extra offset to avoid collisions at T intersections.
    const fixedExtraOffset = glyphSize * 2;
    const offset = !isLineContinued ?
        ((shapedLabelLength / 2 + fixedExtraOffset) * boxScale * overscaling) % spacing :
        (spacing / 2 * overscaling) % spacing;
    return resample(line, offset, spacing, angleWindowSize, maxAngle, labelLength, isLineContinued, false, tileExtent);
}
function resample(line, offset, spacing, angleWindowSize, maxAngle, labelLength, isLineContinued, placeAtMiddle, tileExtent) {
    const halfLabelLength = labelLength / 2;
    const lineLength = getLineLength(line);
    let distance = 0, markedDistance = offset - spacing;
    let anchors = [];
    for (let i = 0; i < line.length - 1; i++) {
        const a = line[i], b = line[i + 1];
        const segmentDist = a.dist(b), angle = b.angleTo(a);
        while (markedDistance + spacing < distance + segmentDist) {
            markedDistance += spacing;
            const t = (markedDistance - distance) / segmentDist, x = interpolate.number(a.x, b.x, t), y = interpolate.number(a.y, b.y, t);
            // Check that the point is within the tile boundaries and that
            // the label would fit before the beginning and end of the line
            // if placed at this point.
            if (x >= 0 && x < tileExtent && y >= 0 && y < tileExtent &&
                markedDistance - halfLabelLength >= 0 &&
                markedDistance + halfLabelLength <= lineLength) {
                const anchor = new Anchor(x, y, angle, i);
                anchor._round();
                if (!angleWindowSize || checkMaxAngle(line, anchor, labelLength, angleWindowSize, maxAngle)) {
                    anchors.push(anchor);
                }
            }
        }
        distance += segmentDist;
    }
    if (!placeAtMiddle && !anchors.length && !isLineContinued) {
        // The first attempt at finding anchors at which labels can be placed failed.
        // Try again, but this time just try placing one anchor at the middle of the line.
        // This has the most effect for short lines in overscaled tiles, since the
        // initial offset used in overscaled tiles is calculated to align labels with positions in
        // parent tiles instead of placing the label as close to the beginning as possible.
        anchors = resample(line, distance / 2, spacing, angleWindowSize, maxAngle, labelLength, isLineContinued, true, tileExtent);
    }
    return anchors;
}

// If you have a 10px icon that isn't perfectly aligned to the pixel grid it will cover 11 actual
// pixels. The quad needs to be padded to account for this, otherwise they'll look slightly clipped
// on one edge in some cases.
const border = IMAGE_PADDING;
/**
 * Create the quads used for rendering an icon.
 */
function getIconQuads(shapedIcon, iconRotate, isSDFIcon, hasIconTextFit) {
    const quads = [];
    const image = shapedIcon.image;
    const pixelRatio = image.pixelRatio;
    const imageWidth = image.paddedRect.w - 2 * border;
    const imageHeight = image.paddedRect.h - 2 * border;
    let icon = {
        x1: shapedIcon.left,
        y1: shapedIcon.top,
        x2: shapedIcon.right,
        y2: shapedIcon.bottom
    };
    const stretchX = image.stretchX || [[0, imageWidth]];
    const stretchY = image.stretchY || [[0, imageHeight]];
    const reduceRanges = (sum, range) => sum + range[1] - range[0];
    const stretchWidth = stretchX.reduce(reduceRanges, 0);
    const stretchHeight = stretchY.reduce(reduceRanges, 0);
    const fixedWidth = imageWidth - stretchWidth;
    const fixedHeight = imageHeight - stretchHeight;
    let stretchOffsetX = 0;
    let stretchContentWidth = stretchWidth;
    let stretchOffsetY = 0;
    let stretchContentHeight = stretchHeight;
    let fixedOffsetX = 0;
    let fixedContentWidth = fixedWidth;
    let fixedOffsetY = 0;
    let fixedContentHeight = fixedHeight;
    if (image.content && hasIconTextFit) {
        const content = image.content;
        const contentWidth = content[2] - content[0];
        const contentHeight = content[3] - content[1];
        // Constrict content area to fit target aspect ratio
        if (image.textFitWidth || image.textFitHeight) {
            icon = applyTextFit(shapedIcon);
        }
        stretchOffsetX = sumWithinRange(stretchX, 0, content[0]);
        stretchOffsetY = sumWithinRange(stretchY, 0, content[1]);
        stretchContentWidth = sumWithinRange(stretchX, content[0], content[2]);
        stretchContentHeight = sumWithinRange(stretchY, content[1], content[3]);
        fixedOffsetX = content[0] - stretchOffsetX;
        fixedOffsetY = content[1] - stretchOffsetY;
        fixedContentWidth = contentWidth - stretchContentWidth;
        fixedContentHeight = contentHeight - stretchContentHeight;
    }
    const iconLeft = icon.x1;
    const iconTop = icon.y1;
    const iconWidth = icon.x2 - iconLeft;
    const iconHeight = icon.y2 - iconTop;
    const makeBox = (left, top, right, bottom) => {
        const leftEm = getEmOffset(left.stretch - stretchOffsetX, stretchContentWidth, iconWidth, iconLeft);
        const leftPx = getPxOffset(left.fixed - fixedOffsetX, fixedContentWidth, left.stretch, stretchWidth);
        const topEm = getEmOffset(top.stretch - stretchOffsetY, stretchContentHeight, iconHeight, iconTop);
        const topPx = getPxOffset(top.fixed - fixedOffsetY, fixedContentHeight, top.stretch, stretchHeight);
        const rightEm = getEmOffset(right.stretch - stretchOffsetX, stretchContentWidth, iconWidth, iconLeft);
        const rightPx = getPxOffset(right.fixed - fixedOffsetX, fixedContentWidth, right.stretch, stretchWidth);
        const bottomEm = getEmOffset(bottom.stretch - stretchOffsetY, stretchContentHeight, iconHeight, iconTop);
        const bottomPx = getPxOffset(bottom.fixed - fixedOffsetY, fixedContentHeight, bottom.stretch, stretchHeight);
        const tl = new Point$2(leftEm, topEm);
        const tr = new Point$2(rightEm, topEm);
        const br = new Point$2(rightEm, bottomEm);
        const bl = new Point$2(leftEm, bottomEm);
        const pixelOffsetTL = new Point$2(leftPx / pixelRatio, topPx / pixelRatio);
        const pixelOffsetBR = new Point$2(rightPx / pixelRatio, bottomPx / pixelRatio);
        const angle = iconRotate * Math.PI / 180;
        if (angle) {
            const sin = Math.sin(angle), cos = Math.cos(angle), matrix = [cos, -sin, sin, cos];
            tl._matMult(matrix);
            tr._matMult(matrix);
            bl._matMult(matrix);
            br._matMult(matrix);
        }
        const x1 = left.stretch + left.fixed;
        const x2 = right.stretch + right.fixed;
        const y1 = top.stretch + top.fixed;
        const y2 = bottom.stretch + bottom.fixed;
        const subRect = {
            x: image.paddedRect.x + border + x1,
            y: image.paddedRect.y + border + y1,
            w: x2 - x1,
            h: y2 - y1
        };
        const minFontScaleX = fixedContentWidth / pixelRatio / iconWidth;
        const minFontScaleY = fixedContentHeight / pixelRatio / iconHeight;
        // Icon quad is padded, so texture coordinates also need to be padded.
        return { tl, tr, bl, br, tex: subRect, writingMode: undefined, glyphOffset: [0, 0], sectionIndex: 0, pixelOffsetTL, pixelOffsetBR, minFontScaleX, minFontScaleY, isSDF: isSDFIcon };
    };
    if (!hasIconTextFit || (!image.stretchX && !image.stretchY)) {
        quads.push(makeBox({ fixed: 0, stretch: -1 }, { fixed: 0, stretch: -1 }, { fixed: 0, stretch: imageWidth + 1 }, { fixed: 0, stretch: imageHeight + 1 }));
    }
    else {
        const xCuts = stretchZonesToCuts(stretchX, fixedWidth, stretchWidth);
        const yCuts = stretchZonesToCuts(stretchY, fixedHeight, stretchHeight);
        for (let xi = 0; xi < xCuts.length - 1; xi++) {
            const x1 = xCuts[xi];
            const x2 = xCuts[xi + 1];
            for (let yi = 0; yi < yCuts.length - 1; yi++) {
                const y1 = yCuts[yi];
                const y2 = yCuts[yi + 1];
                quads.push(makeBox(x1, y1, x2, y2));
            }
        }
    }
    return quads;
}
function sumWithinRange(ranges, min, max) {
    let sum = 0;
    for (const range of ranges) {
        sum += Math.max(min, Math.min(max, range[1])) - Math.max(min, Math.min(max, range[0]));
    }
    return sum;
}
function stretchZonesToCuts(stretchZones, fixedSize, stretchSize) {
    const cuts = [{ fixed: -border, stretch: 0 }];
    for (const [c1, c2] of stretchZones) {
        const last = cuts[cuts.length - 1];
        cuts.push({
            fixed: c1 - last.stretch,
            stretch: last.stretch
        });
        cuts.push({
            fixed: c1 - last.stretch,
            stretch: last.stretch + (c2 - c1)
        });
    }
    cuts.push({
        fixed: fixedSize + border,
        stretch: stretchSize
    });
    return cuts;
}
function getEmOffset(stretchOffset, stretchSize, iconSize, iconOffset) {
    return stretchOffset / stretchSize * iconSize + iconOffset;
}
function getPxOffset(fixedOffset, fixedSize, stretchOffset, stretchSize) {
    return fixedOffset - fixedSize * stretchOffset / stretchSize;
}
/**
 * Create the quads used for rendering a text label.
 */
function getGlyphQuads(anchor, shaping, textOffset, layer, alongLine, feature, imageMap, allowVerticalPlacement) {
    const textRotate = layer.layout.get('text-rotate').evaluate(feature, {}) * Math.PI / 180;
    const quads = [];
    for (const line of shaping.positionedLines) {
        for (const positionedGlyph of line.positionedGlyphs) {
            if (!positionedGlyph.rect)
                continue;
            const textureRect = positionedGlyph.rect || {};
            // The rects have an additional buffer that is not included in their size.
            const glyphPadding = 1.0;
            let rectBuffer = GLYPH_PBF_BORDER + glyphPadding;
            let isSDF = true;
            let pixelRatio = 1.0;
            let lineOffset = 0.0;
            const rotateVerticalGlyph = (alongLine || allowVerticalPlacement) && positionedGlyph.vertical;
            const halfAdvance = positionedGlyph.metrics.advance * positionedGlyph.scale / 2;
            // Align images and scaled glyphs in the middle of a vertical line.
            if (allowVerticalPlacement && shaping.verticalizable) {
                const scaledGlyphOffset = (positionedGlyph.scale - 1) * ONE_EM;
                const imageOffset = (ONE_EM - positionedGlyph.metrics.width * positionedGlyph.scale) / 2;
                lineOffset = line.lineOffset / 2 - (positionedGlyph.imageName ? -imageOffset : scaledGlyphOffset);
            }
            if (positionedGlyph.imageName) {
                const image = imageMap[positionedGlyph.imageName];
                isSDF = image.sdf;
                pixelRatio = image.pixelRatio;
                rectBuffer = IMAGE_PADDING / pixelRatio;
            }
            const glyphOffset = alongLine ?
                [positionedGlyph.x + halfAdvance, positionedGlyph.y] :
                [0, 0];
            let builtInOffset = alongLine ?
                [0, 0] :
                [positionedGlyph.x + halfAdvance + textOffset[0], positionedGlyph.y + textOffset[1] - lineOffset];
            let verticalizedLabelOffset = [0, 0];
            if (rotateVerticalGlyph) {
                // Vertical POI labels that are rotated 90deg CW and whose glyphs must preserve upright orientation
                // need to be rotated 90deg CCW. After a quad is rotated, it is translated to the original built-in offset.
                verticalizedLabelOffset = builtInOffset;
                builtInOffset = [0, 0];
            }
            const textureScale = positionedGlyph.metrics.isDoubleResolution ? 2 : 1;
            const x1 = (positionedGlyph.metrics.left - rectBuffer) * positionedGlyph.scale - halfAdvance + builtInOffset[0];
            const y1 = (-positionedGlyph.metrics.top - rectBuffer) * positionedGlyph.scale + builtInOffset[1];
            const x2 = x1 + textureRect.w / textureScale * positionedGlyph.scale / pixelRatio;
            const y2 = y1 + textureRect.h / textureScale * positionedGlyph.scale / pixelRatio;
            const tl = new Point$2(x1, y1);
            const tr = new Point$2(x2, y1);
            const bl = new Point$2(x1, y2);
            const br = new Point$2(x2, y2);
            if (rotateVerticalGlyph) {
                // Vertical-supporting glyphs are laid out in 24x24 point boxes (1 square em)
                // In horizontal orientation, the y values for glyphs are below the midline
                // and we use a "yOffset" of -17 to pull them up to the middle.
                // By rotating counter-clockwise around the point at the center of the left
                // edge of a 24x24 layout box centered below the midline, we align the center
                // of the glyphs with the horizontal midline, so the yOffset is no longer
                // necessary, but we also pull the glyph to the left along the x axis.
                // The y coordinate includes baseline yOffset, thus needs to be accounted
                // for when glyph is rotated and translated.
                const center = new Point$2(-halfAdvance, halfAdvance - SHAPING_DEFAULT_OFFSET);
                const verticalRotation = -Math.PI / 2;
                // xHalfWidthOffsetCorrection is a difference between full-width and half-width
                // advance, should be 0 for full-width glyphs and will pull up half-width glyphs.
                const xHalfWidthOffsetCorrection = ONE_EM / 2 - halfAdvance;
                const yImageOffsetCorrection = positionedGlyph.imageName ? xHalfWidthOffsetCorrection : 0.0;
                const halfWidthOffsetCorrection = new Point$2(5 - SHAPING_DEFAULT_OFFSET - xHalfWidthOffsetCorrection, -yImageOffsetCorrection);
                const verticalOffsetCorrection = new Point$2(...verticalizedLabelOffset);
                tl._rotateAround(verticalRotation, center)._add(halfWidthOffsetCorrection)._add(verticalOffsetCorrection);
                tr._rotateAround(verticalRotation, center)._add(halfWidthOffsetCorrection)._add(verticalOffsetCorrection);
                bl._rotateAround(verticalRotation, center)._add(halfWidthOffsetCorrection)._add(verticalOffsetCorrection);
                br._rotateAround(verticalRotation, center)._add(halfWidthOffsetCorrection)._add(verticalOffsetCorrection);
            }
            if (textRotate) {
                const sin = Math.sin(textRotate), cos = Math.cos(textRotate), matrix = [cos, -sin, sin, cos];
                tl._matMult(matrix);
                tr._matMult(matrix);
                bl._matMult(matrix);
                br._matMult(matrix);
            }
            const pixelOffsetTL = new Point$2(0, 0);
            const pixelOffsetBR = new Point$2(0, 0);
            const minFontScaleX = 0;
            const minFontScaleY = 0;
            quads.push({ tl, tr, bl, br, tex: textureRect, writingMode: shaping.writingMode, glyphOffset, sectionIndex: positionedGlyph.sectionIndex, isSDF, pixelOffsetTL, pixelOffsetBR, minFontScaleX, minFontScaleY });
        }
    }
    return quads;
}

/**
 * A CollisionFeature represents the area of the tile covered by a single label.
 * It is used with CollisionIndex to check if the label overlaps with any
 * previous labels. A CollisionFeature is mostly just a set of CollisionBox
 * objects.
 */
class CollisionFeature {
    /**
     * Create a CollisionFeature, adding its collision box data to the given collisionBoxArray in the process.
     * For line aligned labels a collision circle diameter is computed instead.
     *
     * @param anchor - The point along the line around which the label is anchored.
     * @param shaped - The text or icon shaping results.
     * @param boxScale - A magic number used to convert from glyph metrics units to geometry units.
     * @param padding - The amount of padding to add around the label edges.
     * @param alignLine - Whether the label is aligned with the line or the viewport.
     */
    constructor(collisionBoxArray, anchor, featureIndex, sourceLayerIndex, bucketIndex, shaped, boxScale, padding, alignLine, rotate) {
        var _a;
        this.boxStartIndex = collisionBoxArray.length;
        if (alignLine) {
            // Compute height of the shape in glyph metrics and apply collision padding.
            // Note that the pixel based 'text-padding' is applied at runtime
            let top = shaped.top;
            let bottom = shaped.bottom;
            const collisionPadding = shaped.collisionPadding;
            if (collisionPadding) {
                top -= collisionPadding[1];
                bottom += collisionPadding[3];
            }
            let height = bottom - top;
            if (height > 0) {
                // set minimum box height to avoid very many small labels
                height = Math.max(10, height);
                this.circleDiameter = height;
            }
        }
        else {
            const icon = ((_a = shaped.image) === null || _a === void 0 ? void 0 : _a.content) && (shaped.image.textFitWidth || shaped.image.textFitHeight) ?
                applyTextFit(shaped) :
                {
                    x1: shaped.left,
                    y1: shaped.top,
                    x2: shaped.right,
                    y2: shaped.bottom
                };
            // margin is in CSS order: [top, right, bottom, left]
            icon.y1 = icon.y1 * boxScale - padding[0];
            icon.y2 = icon.y2 * boxScale + padding[2];
            icon.x1 = icon.x1 * boxScale - padding[3];
            icon.x2 = icon.x2 * boxScale + padding[1];
            const collisionPadding = shaped.collisionPadding;
            if (collisionPadding) {
                icon.x1 -= collisionPadding[0] * boxScale;
                icon.y1 -= collisionPadding[1] * boxScale;
                icon.x2 += collisionPadding[2] * boxScale;
                icon.y2 += collisionPadding[3] * boxScale;
            }
            if (rotate) {
                // Account for *-rotate in point collision boxes
                // See https://github.com/mapbox/mapbox-gl-js/issues/6075
                // Doesn't account for icon-text-fit
                const tl = new Point$2(icon.x1, icon.y1);
                const tr = new Point$2(icon.x2, icon.y1);
                const bl = new Point$2(icon.x1, icon.y2);
                const br = new Point$2(icon.x2, icon.y2);
                const rotateRadians = rotate * Math.PI / 180;
                tl._rotate(rotateRadians);
                tr._rotate(rotateRadians);
                bl._rotate(rotateRadians);
                br._rotate(rotateRadians);
                // Collision features require an "on-axis" geometry,
                // so take the envelope of the rotated geometry
                // (may be quite large for wide labels rotated 45 degrees)
                icon.x1 = Math.min(tl.x, tr.x, bl.x, br.x);
                icon.x2 = Math.max(tl.x, tr.x, bl.x, br.x);
                icon.y1 = Math.min(tl.y, tr.y, bl.y, br.y);
                icon.y2 = Math.max(tl.y, tr.y, bl.y, br.y);
            }
            collisionBoxArray.emplaceBack(anchor.x, anchor.y, icon.x1, icon.y1, icon.x2, icon.y2, featureIndex, sourceLayerIndex, bucketIndex);
        }
        this.boxEndIndex = collisionBoxArray.length;
    }
}

class TinyQueue {
    constructor(data = [], compare = (a, b) => (a < b ? -1 : a > b ? 1 : 0)) {
        this.data = data;
        this.length = this.data.length;
        this.compare = compare;

        if (this.length > 0) {
            for (let i = (this.length >> 1) - 1; i >= 0; i--) this._down(i);
        }
    }

    push(item) {
        this.data.push(item);
        this._up(this.length++);
    }

    pop() {
        if (this.length === 0) return undefined;

        const top = this.data[0];
        const bottom = this.data.pop();

        if (--this.length > 0) {
            this.data[0] = bottom;
            this._down(0);
        }

        return top;
    }

    peek() {
        return this.data[0];
    }

    _up(pos) {
        const {data, compare} = this;
        const item = data[pos];

        while (pos > 0) {
            const parent = (pos - 1) >> 1;
            const current = data[parent];
            if (compare(item, current) >= 0) break;
            data[pos] = current;
            pos = parent;
        }

        data[pos] = item;
    }

    _down(pos) {
        const {data, compare} = this;
        const halfLength = this.length >> 1;
        const item = data[pos];

        while (pos < halfLength) {
            let bestChild = (pos << 1) + 1; // initially it is the left child
            const right = bestChild + 1;

            if (right < this.length && compare(data[right], data[bestChild]) < 0) {
                bestChild = right;
            }
            if (compare(data[bestChild], item) >= 0) break;

            data[pos] = data[bestChild];
            pos = bestChild;
        }

        data[pos] = item;
    }
}

/**
 * Finds an approximation of a polygon's Pole Of Inaccessibility https://en.wikipedia.org/wiki/Pole_of_inaccessibility
 * This is a copy of https://github.com/mapbox/polylabel adapted to use Points
 *
 * @param polygonRings - first item in array is the outer ring followed optionally by the list of holes, should be an element of the result of util/classify_rings
 * @param precision - Specified in input coordinate units. If 0 returns after first run, if `> 0` repeatedly narrows the search space until the radius of the area searched for the best pole is less than precision
 * @param debug - Print some statistics to the console during execution
 * @returns Pole of Inaccessibility.
 */
function findPoleOfInaccessibility(polygonRings, precision = 1, debug = false) {
    // find the bounding box of the outer ring
    let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
    const outerRing = polygonRings[0];
    for (let i = 0; i < outerRing.length; i++) {
        const p = outerRing[i];
        if (!i || p.x < minX)
            minX = p.x;
        if (!i || p.y < minY)
            minY = p.y;
        if (!i || p.x > maxX)
            maxX = p.x;
        if (!i || p.y > maxY)
            maxY = p.y;
    }
    const width = maxX - minX;
    const height = maxY - minY;
    const cellSize = Math.min(width, height);
    let h = cellSize / 2;
    // a priority queue of cells in order of their "potential" (max distance to polygon)
    const cellQueue = new TinyQueue([], compareMax);
    if (cellSize === 0)
        return new Point$2(minX, minY);
    // cover polygon with initial cells
    for (let x = minX; x < maxX; x += cellSize) {
        for (let y = minY; y < maxY; y += cellSize) {
            cellQueue.push(new Cell(x + h, y + h, h, polygonRings));
        }
    }
    // take centroid as the first best guess
    let bestCell = getCentroidCell(polygonRings);
    let numProbes = cellQueue.length;
    while (cellQueue.length) {
        // pick the most promising cell from the queue
        const cell = cellQueue.pop();
        // update the best cell if we found a better one
        if (cell.d > bestCell.d || !bestCell.d) {
            bestCell = cell;
            if (debug)
                console.log('found best %d after %d probes', Math.round(1e4 * cell.d) / 1e4, numProbes);
        }
        // do not drill down further if there's no chance of a better solution
        if (cell.max - bestCell.d <= precision)
            continue;
        // split the cell into four cells
        h = cell.h / 2;
        cellQueue.push(new Cell(cell.p.x - h, cell.p.y - h, h, polygonRings));
        cellQueue.push(new Cell(cell.p.x + h, cell.p.y - h, h, polygonRings));
        cellQueue.push(new Cell(cell.p.x - h, cell.p.y + h, h, polygonRings));
        cellQueue.push(new Cell(cell.p.x + h, cell.p.y + h, h, polygonRings));
        numProbes += 4;
    }
    if (debug) {
        console.log(`num probes: ${numProbes}`);
        console.log(`best distance: ${bestCell.d}`);
    }
    return bestCell.p;
}
function compareMax(a, b) {
    return b.max - a.max;
}
function Cell(x, y, h, polygon) {
    this.p = new Point$2(x, y);
    this.h = h; // half the cell size
    this.d = pointToPolygonDist(this.p, polygon); // distance from cell center to polygon
    this.max = this.d + this.h * Math.SQRT2; // max distance to polygon within a cell
}
// signed distance from point to polygon outline (negative if point is outside)
function pointToPolygonDist(p, polygon) {
    let inside = false;
    let minDistSq = Infinity;
    for (let k = 0; k < polygon.length; k++) {
        const ring = polygon[k];
        for (let i = 0, len = ring.length, j = len - 1; i < len; j = i++) {
            const a = ring[i];
            const b = ring[j];
            if ((a.y > p.y !== b.y > p.y) &&
                (p.x < (b.x - a.x) * (p.y - a.y) / (b.y - a.y) + a.x))
                inside = !inside;
            minDistSq = Math.min(minDistSq, distToSegmentSquared(p, a, b));
        }
    }
    return (inside ? 1 : -1) * Math.sqrt(minDistSq);
}
// get polygon centroid
function getCentroidCell(polygon) {
    let area = 0;
    let x = 0;
    let y = 0;
    const points = polygon[0];
    for (let i = 0, len = points.length, j = len - 1; i < len; j = i++) {
        const a = points[i];
        const b = points[j];
        const f = a.x * b.y - b.x * a.y;
        x += (a.x + b.x) * f;
        y += (a.y + b.y) * f;
        area += f * 3;
    }
    return new Cell(x / area, y / area, 0, polygon);
}

exports.ar = void 0;
(function (TextAnchorEnum) {
    TextAnchorEnum[TextAnchorEnum["center"] = 1] = "center";
    TextAnchorEnum[TextAnchorEnum["left"] = 2] = "left";
    TextAnchorEnum[TextAnchorEnum["right"] = 3] = "right";
    TextAnchorEnum[TextAnchorEnum["top"] = 4] = "top";
    TextAnchorEnum[TextAnchorEnum["bottom"] = 5] = "bottom";
    TextAnchorEnum[TextAnchorEnum["top-left"] = 6] = "top-left";
    TextAnchorEnum[TextAnchorEnum["top-right"] = 7] = "top-right";
    TextAnchorEnum[TextAnchorEnum["bottom-left"] = 8] = "bottom-left";
    TextAnchorEnum[TextAnchorEnum["bottom-right"] = 9] = "bottom-right";
})(exports.ar || (exports.ar = {}));
// The radial offset is to the edge of the text box
// In the horizontal direction, the edge of the text box is where glyphs start
// But in the vertical direction, the glyphs appear to "start" at the baseline
// We don't actually load baseline data, but we assume an offset of ONE_EM - 17
// (see "yOffset" in shaping.js)
const baselineOffset = 7;
const INVALID_TEXT_OFFSET = Number.POSITIVE_INFINITY;
function evaluateVariableOffset(anchor, offset) {
    function fromRadialOffset(anchor, radialOffset) {
        let x = 0, y = 0;
        if (radialOffset < 0)
            radialOffset = 0; // Ignore negative offset.
        // solve for r where r^2 + r^2 = radialOffset^2
        const hypotenuse = radialOffset / Math.SQRT2;
        switch (anchor) {
            case 'top-right':
            case 'top-left':
                y = hypotenuse - baselineOffset;
                break;
            case 'bottom-right':
            case 'bottom-left':
                y = -hypotenuse + baselineOffset;
                break;
            case 'bottom':
                y = -radialOffset + baselineOffset;
                break;
            case 'top':
                y = radialOffset - baselineOffset;
                break;
        }
        switch (anchor) {
            case 'top-right':
            case 'bottom-right':
                x = -hypotenuse;
                break;
            case 'top-left':
            case 'bottom-left':
                x = hypotenuse;
                break;
            case 'left':
                x = radialOffset;
                break;
            case 'right':
                x = -radialOffset;
                break;
        }
        return [x, y];
    }
    function fromTextOffset(anchor, offsetX, offsetY) {
        let x = 0, y = 0;
        // Use absolute offset values.
        offsetX = Math.abs(offsetX);
        offsetY = Math.abs(offsetY);
        switch (anchor) {
            case 'top-right':
            case 'top-left':
            case 'top':
                y = offsetY - baselineOffset;
                break;
            case 'bottom-right':
            case 'bottom-left':
            case 'bottom':
                y = -offsetY + baselineOffset;
                break;
        }
        switch (anchor) {
            case 'top-right':
            case 'bottom-right':
            case 'right':
                x = -offsetX;
                break;
            case 'top-left':
            case 'bottom-left':
            case 'left':
                x = offsetX;
                break;
        }
        return [x, y];
    }
    return (offset[1] !== INVALID_TEXT_OFFSET) ? fromTextOffset(anchor, offset[0], offset[1]) : fromRadialOffset(anchor, offset[0]);
}
// Helper to support both text-variable-anchor and text-variable-anchor-offset. Offset values converted from EMs to PXs
function getTextVariableAnchorOffset(layer, feature, canonical) {
    var _a;
    const layout = layer.layout;
    // If style specifies text-variable-anchor-offset, just return it
    const variableAnchorOffset = (_a = layout.get('text-variable-anchor-offset')) === null || _a === void 0 ? void 0 : _a.evaluate(feature, {}, canonical);
    if (variableAnchorOffset) {
        const sourceValues = variableAnchorOffset.values;
        const destValues = [];
        // Convert offsets from EM to PX, and apply baseline shift
        for (let i = 0; i < sourceValues.length; i += 2) {
            const anchor = destValues[i] = sourceValues[i];
            const offset = sourceValues[i + 1].map(t => t * ONE_EM);
            if (anchor.startsWith('top')) {
                offset[1] -= baselineOffset;
            }
            else if (anchor.startsWith('bottom')) {
                offset[1] += baselineOffset;
            }
            destValues[i + 1] = offset;
        }
        return new VariableAnchorOffsetCollection(destValues);
    }
    // If style specifies text-variable-anchor, convert to the new format
    const variableAnchor = layout.get('text-variable-anchor');
    if (variableAnchor) {
        let textOffset;
        const unevaluatedLayout = layer._unevaluatedLayout;
        // The style spec says don't use `text-offset` and `text-radial-offset` together
        // but doesn't actually specify what happens if you use both. We go with the radial offset.
        if (unevaluatedLayout.getValue('text-radial-offset') !== undefined) {
            textOffset = [layout.get('text-radial-offset').evaluate(feature, {}, canonical) * ONE_EM, INVALID_TEXT_OFFSET];
        }
        else {
            textOffset = layout.get('text-offset').evaluate(feature, {}, canonical).map(t => t * ONE_EM);
        }
        const anchorOffsets = [];
        for (const anchor of variableAnchor) {
            anchorOffsets.push(anchor, evaluateVariableOffset(anchor, textOffset));
        }
        return new VariableAnchorOffsetCollection(anchorOffsets);
    }
    return null;
}

function performSymbolLayout(args) {
    args.bucket.createArrays();
    const tileSize = 512 * args.bucket.overscaling;
    args.bucket.tilePixelRatio = EXTENT / tileSize;
    args.bucket.compareText = {};
    args.bucket.iconsNeedLinear = false;
    const layer = args.bucket.layers[0];
    const layout = layer.layout;
    const unevaluatedLayoutValues = layer._unevaluatedLayout._values;
    const sizes = {
        // Filled in below, if *SizeData.kind is 'composite'
        // compositeIconSizes: undefined,
        // compositeTextSizes: undefined,
        layoutIconSize: unevaluatedLayoutValues['icon-size'].possiblyEvaluate(new EvaluationParameters(args.bucket.zoom + 1), args.canonical),
        layoutTextSize: unevaluatedLayoutValues['text-size'].possiblyEvaluate(new EvaluationParameters(args.bucket.zoom + 1), args.canonical),
        textMaxSize: unevaluatedLayoutValues['text-size'].possiblyEvaluate(new EvaluationParameters(18))
    };
    if (args.bucket.textSizeData.kind === 'composite') {
        const { minZoom, maxZoom } = args.bucket.textSizeData;
        sizes.compositeTextSizes = [
            unevaluatedLayoutValues['text-size'].possiblyEvaluate(new EvaluationParameters(minZoom), args.canonical),
            unevaluatedLayoutValues['text-size'].possiblyEvaluate(new EvaluationParameters(maxZoom), args.canonical)
        ];
    }
    if (args.bucket.iconSizeData.kind === 'composite') {
        const { minZoom, maxZoom } = args.bucket.iconSizeData;
        sizes.compositeIconSizes = [
            unevaluatedLayoutValues['icon-size'].possiblyEvaluate(new EvaluationParameters(minZoom), args.canonical),
            unevaluatedLayoutValues['icon-size'].possiblyEvaluate(new EvaluationParameters(maxZoom), args.canonical)
        ];
    }
    const lineHeight = layout.get('text-line-height') * ONE_EM;
    const textAlongLine = layout.get('text-rotation-alignment') !== 'viewport' && layout.get('symbol-placement') !== 'point';
    const keepUpright = layout.get('text-keep-upright');
    const textSize = layout.get('text-size');
    for (const feature of args.bucket.features) {
        const fontstack = layout.get('text-font').evaluate(feature, {}, args.canonical).join(',');
        const layoutTextSizeThisZoom = textSize.evaluate(feature, {}, args.canonical);
        const layoutTextSize = sizes.layoutTextSize.evaluate(feature, {}, args.canonical);
        const layoutIconSize = sizes.layoutIconSize.evaluate(feature, {}, args.canonical);
        const shapedTextOrientations = {
            horizontal: {},
            vertical: undefined
        };
        const text = feature.text;
        let textOffset = [0, 0];
        if (text) {
            const unformattedText = text.toString();
            const spacing = layout.get('text-letter-spacing').evaluate(feature, {}, args.canonical) * ONE_EM;
            const spacingIfAllowed = allowsLetterSpacing(unformattedText) ? spacing : 0;
            const textAnchor = layout.get('text-anchor').evaluate(feature, {}, args.canonical);
            const variableAnchorOffset = getTextVariableAnchorOffset(layer, feature, args.canonical);
            if (!variableAnchorOffset) {
                const radialOffset = layout.get('text-radial-offset').evaluate(feature, {}, args.canonical);
                // Layers with variable anchors use the `text-radial-offset` property and the [x, y] offset vector
                // is calculated at placement time instead of layout time
                if (radialOffset) {
                    // The style spec says don't use `text-offset` and `text-radial-offset` together
                    // but doesn't actually specify what happens if you use both. We go with the radial offset.
                    textOffset = evaluateVariableOffset(textAnchor, [radialOffset * ONE_EM, INVALID_TEXT_OFFSET]);
                }
                else {
                    textOffset = layout.get('text-offset').evaluate(feature, {}, args.canonical).map(t => t * ONE_EM);
                }
            }
            let textJustify = textAlongLine ?
                'center' :
                layout.get('text-justify').evaluate(feature, {}, args.canonical);
            const symbolPlacement = layout.get('symbol-placement');
            const maxWidth = symbolPlacement === 'point' ?
                layout.get('text-max-width').evaluate(feature, {}, args.canonical) * ONE_EM :
                Infinity;
            const addVerticalShapingForPointLabelIfNeeded = () => {
                if (args.bucket.allowVerticalPlacement && allowsVerticalWritingMode(unformattedText)) {
                    // Vertical POI label placement is meant to be used for scripts that support vertical
                    // writing mode, thus, default left justification is used. If Latin
                    // scripts would need to be supported, this should take into account other justifications.
                    shapedTextOrientations.vertical = shapeText(text, args.glyphMap, args.glyphPositions, args.imagePositions, fontstack, maxWidth, lineHeight, textAnchor, 'left', spacingIfAllowed, textOffset, exports.ai.vertical, true, layoutTextSize, layoutTextSizeThisZoom);
                }
            };
            // If this layer uses text-variable-anchor, generate shapings for all justification possibilities.
            if (!textAlongLine && variableAnchorOffset) {
                const justifications = new Set();
                if (textJustify === 'auto') {
                    for (let i = 0; i < variableAnchorOffset.values.length; i += 2) {
                        justifications.add(getAnchorJustification(variableAnchorOffset.values[i]));
                    }
                }
                else {
                    justifications.add(textJustify);
                }
                let singleLine = false;
                for (const justification of justifications) {
                    if (shapedTextOrientations.horizontal[justification])
                        continue;
                    if (singleLine) {
                        // If the shaping for the first justification was only a single line, we
                        // can re-use it for the other justifications
                        shapedTextOrientations.horizontal[justification] = shapedTextOrientations.horizontal[0];
                    }
                    else {
                        // If using text-variable-anchor for the layer, we use a center anchor for all shapings and apply
                        // the offsets for the anchor in the placement step.
                        const shaping = shapeText(text, args.glyphMap, args.glyphPositions, args.imagePositions, fontstack, maxWidth, lineHeight, 'center', justification, spacingIfAllowed, textOffset, exports.ai.horizontal, false, layoutTextSize, layoutTextSizeThisZoom);
                        if (shaping) {
                            shapedTextOrientations.horizontal[justification] = shaping;
                            singleLine = shaping.positionedLines.length === 1;
                        }
                    }
                }
                addVerticalShapingForPointLabelIfNeeded();
            }
            else {
                if (textJustify === 'auto') {
                    textJustify = getAnchorJustification(textAnchor);
                }
                // Horizontal point or line label.
                const shaping = shapeText(text, args.glyphMap, args.glyphPositions, args.imagePositions, fontstack, maxWidth, lineHeight, textAnchor, textJustify, spacingIfAllowed, textOffset, exports.ai.horizontal, false, layoutTextSize, layoutTextSizeThisZoom);
                if (shaping)
                    shapedTextOrientations.horizontal[textJustify] = shaping;
                // Vertical point label (if allowVerticalPlacement is enabled).
                addVerticalShapingForPointLabelIfNeeded();
                // Verticalized line label.
                if (allowsVerticalWritingMode(unformattedText) && textAlongLine && keepUpright) {
                    shapedTextOrientations.vertical = shapeText(text, args.glyphMap, args.glyphPositions, args.imagePositions, fontstack, maxWidth, lineHeight, textAnchor, textJustify, spacingIfAllowed, textOffset, exports.ai.vertical, false, layoutTextSize, layoutTextSizeThisZoom);
                }
            }
        }
        let shapedIcon;
        let isSDFIcon = false;
        if (feature.icon && feature.icon.name) {
            const image = args.imageMap[feature.icon.name];
            if (image) {
                shapedIcon = shapeIcon(args.imagePositions[feature.icon.name], layout.get('icon-offset').evaluate(feature, {}, args.canonical), layout.get('icon-anchor').evaluate(feature, {}, args.canonical));
                // null/undefined SDF property treated same as default (false)
                isSDFIcon = !!image.sdf;
                if (args.bucket.sdfIcons === undefined) {
                    args.bucket.sdfIcons = isSDFIcon;
                }
                else if (args.bucket.sdfIcons !== isSDFIcon) {
                    warnOnce('Style sheet warning: Cannot mix SDF and non-SDF icons in one buffer');
                }
                if (image.pixelRatio !== args.bucket.pixelRatio) {
                    args.bucket.iconsNeedLinear = true;
                }
                else if (layout.get('icon-rotate').constantOr(1) !== 0) {
                    args.bucket.iconsNeedLinear = true;
                }
            }
        }
        const shapedText = getDefaultHorizontalShaping(shapedTextOrientations.horizontal) || shapedTextOrientations.vertical;
        args.bucket.iconsInText = shapedText ? shapedText.iconsInText : false;
        if (shapedText || shapedIcon) {
            addFeature(args.bucket, feature, shapedTextOrientations, shapedIcon, args.imageMap, sizes, layoutTextSize, layoutIconSize, textOffset, isSDFIcon, args.canonical);
        }
    }
    if (args.showCollisionBoxes) {
        args.bucket.generateCollisionDebugBuffers();
    }
}
// Choose the justification that matches the direction of the TextAnchor
function getAnchorJustification(anchor) {
    switch (anchor) {
        case 'right':
        case 'top-right':
        case 'bottom-right':
            return 'right';
        case 'left':
        case 'top-left':
        case 'bottom-left':
            return 'left';
    }
    return 'center';
}
/**
 * Given a feature and its shaped text and icon data, add a 'symbol
 * instance' for each _possible_ placement of the symbol feature.
 * (At render timePlaceSymbols#place() selects which of these instances to
 * show or hide based on collisions with symbols in other layers.)
 */
function addFeature(bucket, feature, shapedTextOrientations, shapedIcon, imageMap, sizes, layoutTextSize, layoutIconSize, textOffset, isSDFIcon, canonical) {
    // To reduce the number of labels that jump around when zooming we need
    // to use a text-size value that is the same for all zoom levels.
    // bucket calculates text-size at a high zoom level so that all tiles can
    // use the same value when calculating anchor positions.
    let textMaxSize = sizes.textMaxSize.evaluate(feature, {});
    if (textMaxSize === undefined) {
        textMaxSize = layoutTextSize;
    }
    const layout = bucket.layers[0].layout;
    const iconOffset = layout.get('icon-offset').evaluate(feature, {}, canonical);
    const defaultHorizontalShaping = getDefaultHorizontalShaping(shapedTextOrientations.horizontal);
    const glyphSize = 24, fontScale = layoutTextSize / glyphSize, textBoxScale = bucket.tilePixelRatio * fontScale, textMaxBoxScale = bucket.tilePixelRatio * textMaxSize / glyphSize, iconBoxScale = bucket.tilePixelRatio * layoutIconSize, symbolMinDistance = bucket.tilePixelRatio * layout.get('symbol-spacing'), textPadding = layout.get('text-padding') * bucket.tilePixelRatio, iconPadding = getIconPadding(layout, feature, canonical, bucket.tilePixelRatio), textMaxAngle = layout.get('text-max-angle') / 180 * Math.PI, textAlongLine = layout.get('text-rotation-alignment') !== 'viewport' && layout.get('symbol-placement') !== 'point', iconAlongLine = layout.get('icon-rotation-alignment') === 'map' && layout.get('symbol-placement') !== 'point', symbolPlacement = layout.get('symbol-placement'), textRepeatDistance = symbolMinDistance / 2;
    const iconTextFit = layout.get('icon-text-fit');
    let verticallyShapedIcon;
    // Adjust shaped icon size when icon-text-fit is used.
    if (shapedIcon && iconTextFit !== 'none') {
        if (bucket.allowVerticalPlacement && shapedTextOrientations.vertical) {
            verticallyShapedIcon = fitIconToText(shapedIcon, shapedTextOrientations.vertical, iconTextFit, layout.get('icon-text-fit-padding'), iconOffset, fontScale);
        }
        if (defaultHorizontalShaping) {
            shapedIcon = fitIconToText(shapedIcon, defaultHorizontalShaping, iconTextFit, layout.get('icon-text-fit-padding'), iconOffset, fontScale);
        }
    }
    const addSymbolAtAnchor = (line, anchor) => {
        if (anchor.x < 0 || anchor.x >= EXTENT || anchor.y < 0 || anchor.y >= EXTENT) {
            // Symbol layers are drawn across tile boundaries, We filter out symbols
            // outside our tile boundaries (which may be included in vector tile buffers)
            // to prevent double-drawing symbols.
            return;
        }
        addSymbol(bucket, anchor, line, shapedTextOrientations, shapedIcon, imageMap, verticallyShapedIcon, bucket.layers[0], bucket.collisionBoxArray, feature.index, feature.sourceLayerIndex, bucket.index, textBoxScale, [textPadding, textPadding, textPadding, textPadding], textAlongLine, textOffset, iconBoxScale, iconPadding, iconAlongLine, iconOffset, feature, sizes, isSDFIcon, canonical, layoutTextSize);
    };
    if (symbolPlacement === 'line') {
        for (const line of clipLine(feature.geometry, 0, 0, EXTENT, EXTENT)) {
            const anchors = getAnchors(line, symbolMinDistance, textMaxAngle, shapedTextOrientations.vertical || defaultHorizontalShaping, shapedIcon, glyphSize, textMaxBoxScale, bucket.overscaling, EXTENT);
            for (const anchor of anchors) {
                const shapedText = defaultHorizontalShaping;
                if (!shapedText || !anchorIsTooClose(bucket, shapedText.text, textRepeatDistance, anchor)) {
                    addSymbolAtAnchor(line, anchor);
                }
            }
        }
    }
    else if (symbolPlacement === 'line-center') {
        // No clipping, multiple lines per feature are allowed
        // "lines" with only one point are ignored as in clipLines
        for (const line of feature.geometry) {
            if (line.length > 1) {
                const anchor = getCenterAnchor(line, textMaxAngle, shapedTextOrientations.vertical || defaultHorizontalShaping, shapedIcon, glyphSize, textMaxBoxScale);
                if (anchor) {
                    addSymbolAtAnchor(line, anchor);
                }
            }
        }
    }
    else if (feature.type === 'Polygon') {
        for (const polygon of classifyRings$1(feature.geometry, 0)) {
            // 16 here represents 2 pixels
            const poi = findPoleOfInaccessibility(polygon, 16);
            addSymbolAtAnchor(polygon[0], new Anchor(poi.x, poi.y, 0));
        }
    }
    else if (feature.type === 'LineString') {
        // https://github.com/mapbox/mapbox-gl-js/issues/3808
        for (const line of feature.geometry) {
            addSymbolAtAnchor(line, new Anchor(line[0].x, line[0].y, 0));
        }
    }
    else if (feature.type === 'Point') {
        for (const points of feature.geometry) {
            for (const point of points) {
                addSymbolAtAnchor([point], new Anchor(point.x, point.y, 0));
            }
        }
    }
}
function addTextVariableAnchorOffsets(textAnchorOffsets, variableAnchorOffset) {
    const startIndex = textAnchorOffsets.length;
    const values = variableAnchorOffset === null || variableAnchorOffset === void 0 ? void 0 : variableAnchorOffset.values;
    if ((values === null || values === void 0 ? void 0 : values.length) > 0) {
        for (let i = 0; i < values.length; i += 2) {
            const anchor = exports.ar[values[i]];
            const offset = values[i + 1];
            textAnchorOffsets.emplaceBack(anchor, offset[0], offset[1]);
        }
    }
    return [startIndex, textAnchorOffsets.length];
}
function addTextVertices(bucket, anchor, shapedText, imageMap, layer, textAlongLine, feature, textOffset, lineArray, writingMode, placementTypes, placedTextSymbolIndices, placedIconIndex, sizes, canonical) {
    const glyphQuads = getGlyphQuads(anchor, shapedText, textOffset, layer, textAlongLine, feature, imageMap, bucket.allowVerticalPlacement);
    const sizeData = bucket.textSizeData;
    let textSizeData = null;
    if (sizeData.kind === 'source') {
        textSizeData = [
            SIZE_PACK_FACTOR * layer.layout.get('text-size').evaluate(feature, {})
        ];
        if (textSizeData[0] > MAX_PACKED_SIZE) {
            warnOnce(`${bucket.layerIds[0]}: Value for "text-size" is >= ${MAX_GLYPH_ICON_SIZE}. Reduce your "text-size".`);
        }
    }
    else if (sizeData.kind === 'composite') {
        textSizeData = [
            SIZE_PACK_FACTOR * sizes.compositeTextSizes[0].evaluate(feature, {}, canonical),
            SIZE_PACK_FACTOR * sizes.compositeTextSizes[1].evaluate(feature, {}, canonical)
        ];
        if (textSizeData[0] > MAX_PACKED_SIZE || textSizeData[1] > MAX_PACKED_SIZE) {
            warnOnce(`${bucket.layerIds[0]}: Value for "text-size" is >= ${MAX_GLYPH_ICON_SIZE}. Reduce your "text-size".`);
        }
    }
    bucket.addSymbols(bucket.text, glyphQuads, textSizeData, textOffset, textAlongLine, feature, writingMode, anchor, lineArray.lineStartIndex, lineArray.lineLength, placedIconIndex, canonical);
    // The placedSymbolArray is used at render time in drawTileSymbols
    // These indices allow access to the array at collision detection time
    for (const placementType of placementTypes) {
        placedTextSymbolIndices[placementType] = bucket.text.placedSymbolArray.length - 1;
    }
    return glyphQuads.length * 4;
}
function getDefaultHorizontalShaping(horizontalShaping) {
    // We don't care which shaping we get because this is used for collision purposes
    // and all the justifications have the same collision box
    for (const justification in horizontalShaping) {
        return horizontalShaping[justification];
    }
    return null;
}
/**
 * Add a single label & icon placement.
 */
function addSymbol(bucket, anchor, line, shapedTextOrientations, shapedIcon, imageMap, verticallyShapedIcon, layer, collisionBoxArray, featureIndex, sourceLayerIndex, bucketIndex, textBoxScale, textPadding, textAlongLine, textOffset, iconBoxScale, iconPadding, iconAlongLine, iconOffset, feature, sizes, isSDFIcon, canonical, layoutTextSize) {
    const lineArray = bucket.addToLineVertexArray(anchor, line);
    let textCollisionFeature, iconCollisionFeature, verticalTextCollisionFeature, verticalIconCollisionFeature;
    let numIconVertices = 0;
    let numVerticalIconVertices = 0;
    let numHorizontalGlyphVertices = 0;
    let numVerticalGlyphVertices = 0;
    let placedIconSymbolIndex = -1;
    let verticalPlacedIconSymbolIndex = -1;
    const placedTextSymbolIndices = {};
    let key = murmur3$1('');
    if (bucket.allowVerticalPlacement && shapedTextOrientations.vertical) {
        const textRotation = layer.layout.get('text-rotate').evaluate(feature, {}, canonical);
        const verticalTextRotation = textRotation + 90.0;
        const verticalShaping = shapedTextOrientations.vertical;
        verticalTextCollisionFeature = new CollisionFeature(collisionBoxArray, anchor, featureIndex, sourceLayerIndex, bucketIndex, verticalShaping, textBoxScale, textPadding, textAlongLine, verticalTextRotation);
        if (verticallyShapedIcon) {
            verticalIconCollisionFeature = new CollisionFeature(collisionBoxArray, anchor, featureIndex, sourceLayerIndex, bucketIndex, verticallyShapedIcon, iconBoxScale, iconPadding, textAlongLine, verticalTextRotation);
        }
    }
    //Place icon first, so text can have a reference to its index in the placed symbol array.
    //Text symbols can lazily shift at render-time because of variable anchor placement.
    //If the style specifies an `icon-text-fit` then the icon would have to shift along with it.
    // For more info check `updateVariableAnchors` in `draw_symbol.js` .
    if (shapedIcon) {
        const iconRotate = layer.layout.get('icon-rotate').evaluate(feature, {});
        const hasIconTextFit = layer.layout.get('icon-text-fit') !== 'none';
        const iconQuads = getIconQuads(shapedIcon, iconRotate, isSDFIcon, hasIconTextFit);
        const verticalIconQuads = verticallyShapedIcon ? getIconQuads(verticallyShapedIcon, iconRotate, isSDFIcon, hasIconTextFit) : undefined;
        iconCollisionFeature = new CollisionFeature(collisionBoxArray, anchor, featureIndex, sourceLayerIndex, bucketIndex, shapedIcon, iconBoxScale, iconPadding, /*align boxes to line*/ false, iconRotate);
        numIconVertices = iconQuads.length * 4;
        const sizeData = bucket.iconSizeData;
        let iconSizeData = null;
        if (sizeData.kind === 'source') {
            iconSizeData = [
                SIZE_PACK_FACTOR * layer.layout.get('icon-size').evaluate(feature, {})
            ];
            if (iconSizeData[0] > MAX_PACKED_SIZE) {
                warnOnce(`${bucket.layerIds[0]}: Value for "icon-size" is >= ${MAX_GLYPH_ICON_SIZE}. Reduce your "icon-size".`);
            }
        }
        else if (sizeData.kind === 'composite') {
            iconSizeData = [
                SIZE_PACK_FACTOR * sizes.compositeIconSizes[0].evaluate(feature, {}, canonical),
                SIZE_PACK_FACTOR * sizes.compositeIconSizes[1].evaluate(feature, {}, canonical)
            ];
            if (iconSizeData[0] > MAX_PACKED_SIZE || iconSizeData[1] > MAX_PACKED_SIZE) {
                warnOnce(`${bucket.layerIds[0]}: Value for "icon-size" is >= ${MAX_GLYPH_ICON_SIZE}. Reduce your "icon-size".`);
            }
        }
        bucket.addSymbols(bucket.icon, iconQuads, iconSizeData, iconOffset, iconAlongLine, feature, exports.ai.none, anchor, lineArray.lineStartIndex, lineArray.lineLength, 
        // The icon itself does not have an associated symbol since the text isn't placed yet
        -1, canonical);
        placedIconSymbolIndex = bucket.icon.placedSymbolArray.length - 1;
        if (verticalIconQuads) {
            numVerticalIconVertices = verticalIconQuads.length * 4;
            bucket.addSymbols(bucket.icon, verticalIconQuads, iconSizeData, iconOffset, iconAlongLine, feature, exports.ai.vertical, anchor, lineArray.lineStartIndex, lineArray.lineLength, 
            // The icon itself does not have an associated symbol since the text isn't placed yet
            -1, canonical);
            verticalPlacedIconSymbolIndex = bucket.icon.placedSymbolArray.length - 1;
        }
    }
    const justifications = Object.keys(shapedTextOrientations.horizontal);
    for (const justification of justifications) {
        const shaping = shapedTextOrientations.horizontal[justification];
        if (!textCollisionFeature) {
            key = murmur3$1(shaping.text);
            const textRotate = layer.layout.get('text-rotate').evaluate(feature, {}, canonical);
            // As a collision approximation, we can use either the vertical or any of the horizontal versions of the feature
            // We're counting on all versions having similar dimensions
            textCollisionFeature = new CollisionFeature(collisionBoxArray, anchor, featureIndex, sourceLayerIndex, bucketIndex, shaping, textBoxScale, textPadding, textAlongLine, textRotate);
        }
        const singleLine = shaping.positionedLines.length === 1;
        numHorizontalGlyphVertices += addTextVertices(bucket, anchor, shaping, imageMap, layer, textAlongLine, feature, textOffset, lineArray, shapedTextOrientations.vertical ? exports.ai.horizontal : exports.ai.horizontalOnly, singleLine ? justifications : [justification], placedTextSymbolIndices, placedIconSymbolIndex, sizes, canonical);
        if (singleLine) {
            break;
        }
    }
    if (shapedTextOrientations.vertical) {
        numVerticalGlyphVertices += addTextVertices(bucket, anchor, shapedTextOrientations.vertical, imageMap, layer, textAlongLine, feature, textOffset, lineArray, exports.ai.vertical, ['vertical'], placedTextSymbolIndices, verticalPlacedIconSymbolIndex, sizes, canonical);
    }
    const textBoxStartIndex = textCollisionFeature ? textCollisionFeature.boxStartIndex : bucket.collisionBoxArray.length;
    const textBoxEndIndex = textCollisionFeature ? textCollisionFeature.boxEndIndex : bucket.collisionBoxArray.length;
    const verticalTextBoxStartIndex = verticalTextCollisionFeature ? verticalTextCollisionFeature.boxStartIndex : bucket.collisionBoxArray.length;
    const verticalTextBoxEndIndex = verticalTextCollisionFeature ? verticalTextCollisionFeature.boxEndIndex : bucket.collisionBoxArray.length;
    const iconBoxStartIndex = iconCollisionFeature ? iconCollisionFeature.boxStartIndex : bucket.collisionBoxArray.length;
    const iconBoxEndIndex = iconCollisionFeature ? iconCollisionFeature.boxEndIndex : bucket.collisionBoxArray.length;
    const verticalIconBoxStartIndex = verticalIconCollisionFeature ? verticalIconCollisionFeature.boxStartIndex : bucket.collisionBoxArray.length;
    const verticalIconBoxEndIndex = verticalIconCollisionFeature ? verticalIconCollisionFeature.boxEndIndex : bucket.collisionBoxArray.length;
    // Check if runtime collision circles should be used for any of the collision features.
    // It is enough to choose the tallest feature shape as circles are always placed on a line.
    // All measurements are in glyph metrics and later converted into pixels using proper font size "layoutTextSize"
    let collisionCircleDiameter = -1;
    const getCollisionCircleHeight = (feature, prevHeight) => {
        if (feature && feature.circleDiameter)
            return Math.max(feature.circleDiameter, prevHeight);
        return prevHeight;
    };
    collisionCircleDiameter = getCollisionCircleHeight(textCollisionFeature, collisionCircleDiameter);
    collisionCircleDiameter = getCollisionCircleHeight(verticalTextCollisionFeature, collisionCircleDiameter);
    collisionCircleDiameter = getCollisionCircleHeight(iconCollisionFeature, collisionCircleDiameter);
    collisionCircleDiameter = getCollisionCircleHeight(verticalIconCollisionFeature, collisionCircleDiameter);
    const useRuntimeCollisionCircles = (collisionCircleDiameter > -1) ? 1 : 0;
    // Convert circle collision height into pixels
    if (useRuntimeCollisionCircles)
        collisionCircleDiameter *= layoutTextSize / ONE_EM;
    if (bucket.glyphOffsetArray.length >= SymbolBucket.MAX_GLYPHS)
        warnOnce('Too many glyphs being rendered in a tile. See https://github.com/mapbox/mapbox-gl-js/issues/2907');
    if (feature.sortKey !== undefined) {
        bucket.addToSortKeyRanges(bucket.symbolInstances.length, feature.sortKey);
    }
    const variableAnchorOffset = getTextVariableAnchorOffset(layer, feature, canonical);
    const [textAnchorOffsetStartIndex, textAnchorOffsetEndIndex] = addTextVariableAnchorOffsets(bucket.textAnchorOffsets, variableAnchorOffset);
    bucket.symbolInstances.emplaceBack(anchor.x, anchor.y, placedTextSymbolIndices.right >= 0 ? placedTextSymbolIndices.right : -1, placedTextSymbolIndices.center >= 0 ? placedTextSymbolIndices.center : -1, placedTextSymbolIndices.left >= 0 ? placedTextSymbolIndices.left : -1, placedTextSymbolIndices.vertical || -1, placedIconSymbolIndex, verticalPlacedIconSymbolIndex, key, textBoxStartIndex, textBoxEndIndex, verticalTextBoxStartIndex, verticalTextBoxEndIndex, iconBoxStartIndex, iconBoxEndIndex, verticalIconBoxStartIndex, verticalIconBoxEndIndex, featureIndex, numHorizontalGlyphVertices, numVerticalGlyphVertices, numIconVertices, numVerticalIconVertices, useRuntimeCollisionCircles, 0, textBoxScale, collisionCircleDiameter, textAnchorOffsetStartIndex, textAnchorOffsetEndIndex);
}
function anchorIsTooClose(bucket, text, repeatDistance, anchor) {
    const compareText = bucket.compareText;
    if (!(text in compareText)) {
        compareText[text] = [];
    }
    else {
        const otherAnchors = compareText[text];
        for (let k = otherAnchors.length - 1; k >= 0; k--) {
            if (anchor.dist(otherAnchors[k]) < repeatDistance) {
                // If it's within repeatDistance of one anchor, stop looking
                return true;
            }
        }
    }
    // If anchor is not within repeatDistance of any other anchor, add to array
    compareText[text].push(anchor);
    return false;
}

const ARRAY_TYPES = [
    Int8Array, Uint8Array, Uint8ClampedArray, Int16Array, Uint16Array,
    Int32Array, Uint32Array, Float32Array, Float64Array
];

/** @typedef {Int8ArrayConstructor | Uint8ArrayConstructor | Uint8ClampedArrayConstructor | Int16ArrayConstructor | Uint16ArrayConstructor | Int32ArrayConstructor | Uint32ArrayConstructor | Float32ArrayConstructor | Float64ArrayConstructor} TypedArrayConstructor */

const VERSION = 1; // serialized format version
const HEADER_SIZE = 8;

class KDBush {

    /**
     * Creates an index from raw `ArrayBuffer` data.
     * @param {ArrayBuffer} data
     */
    static from(data) {
        if (!(data instanceof ArrayBuffer)) {
            throw new Error('Data must be an instance of ArrayBuffer.');
        }
        const [magic, versionAndType] = new Uint8Array(data, 0, 2);
        if (magic !== 0xdb) {
            throw new Error('Data does not appear to be in a KDBush format.');
        }
        const version = versionAndType >> 4;
        if (version !== VERSION) {
            throw new Error(`Got v${version} data when expected v${VERSION}.`);
        }
        const ArrayType = ARRAY_TYPES[versionAndType & 0x0f];
        if (!ArrayType) {
            throw new Error('Unrecognized array type.');
        }
        const [nodeSize] = new Uint16Array(data, 2, 1);
        const [numItems] = new Uint32Array(data, 4, 1);

        return new KDBush(numItems, nodeSize, ArrayType, data);
    }

    /**
     * Creates an index that will hold a given number of items.
     * @param {number} numItems
     * @param {number} [nodeSize=64] Size of the KD-tree node (64 by default).
     * @param {TypedArrayConstructor} [ArrayType=Float64Array] The array type used for coordinates storage (`Float64Array` by default).
     * @param {ArrayBuffer} [data] (For internal use only)
     */
    constructor(numItems, nodeSize = 64, ArrayType = Float64Array, data) {
        if (isNaN(numItems) || numItems < 0) throw new Error(`Unpexpected numItems value: ${numItems}.`);

        this.numItems = +numItems;
        this.nodeSize = Math.min(Math.max(+nodeSize, 2), 65535);
        this.ArrayType = ArrayType;
        this.IndexArrayType = numItems < 65536 ? Uint16Array : Uint32Array;

        const arrayTypeIndex = ARRAY_TYPES.indexOf(this.ArrayType);
        const coordsByteSize = numItems * 2 * this.ArrayType.BYTES_PER_ELEMENT;
        const idsByteSize = numItems * this.IndexArrayType.BYTES_PER_ELEMENT;
        const padCoords = (8 - idsByteSize % 8) % 8;

        if (arrayTypeIndex < 0) {
            throw new Error(`Unexpected typed array class: ${ArrayType}.`);
        }

        if (data && (data instanceof ArrayBuffer)) { // reconstruct an index from a buffer
            this.data = data;
            this.ids = new this.IndexArrayType(this.data, HEADER_SIZE, numItems);
            this.coords = new this.ArrayType(this.data, HEADER_SIZE + idsByteSize + padCoords, numItems * 2);
            this._pos = numItems * 2;
            this._finished = true;
        } else { // initialize a new index
            this.data = new ArrayBuffer(HEADER_SIZE + coordsByteSize + idsByteSize + padCoords);
            this.ids = new this.IndexArrayType(this.data, HEADER_SIZE, numItems);
            this.coords = new this.ArrayType(this.data, HEADER_SIZE + idsByteSize + padCoords, numItems * 2);
            this._pos = 0;
            this._finished = false;

            // set header
            new Uint8Array(this.data, 0, 2).set([0xdb, (VERSION << 4) + arrayTypeIndex]);
            new Uint16Array(this.data, 2, 1)[0] = nodeSize;
            new Uint32Array(this.data, 4, 1)[0] = numItems;
        }
    }

    /**
     * Add a point to the index.
     * @param {number} x
     * @param {number} y
     * @returns {number} An incremental index associated with the added item (starting from `0`).
     */
    add(x, y) {
        const index = this._pos >> 1;
        this.ids[index] = index;
        this.coords[this._pos++] = x;
        this.coords[this._pos++] = y;
        return index;
    }

    /**
     * Perform indexing of the added points.
     */
    finish() {
        const numAdded = this._pos >> 1;
        if (numAdded !== this.numItems) {
            throw new Error(`Added ${numAdded} items when expected ${this.numItems}.`);
        }
        // kd-sort both arrays for efficient search
        sort(this.ids, this.coords, this.nodeSize, 0, this.numItems - 1, 0);

        this._finished = true;
        return this;
    }

    /**
     * Search the index for items within a given bounding box.
     * @param {number} minX
     * @param {number} minY
     * @param {number} maxX
     * @param {number} maxY
     * @returns {number[]} An array of indices correponding to the found items.
     */
    range(minX, minY, maxX, maxY) {
        if (!this._finished) throw new Error('Data not yet indexed - call index.finish().');

        const {ids, coords, nodeSize} = this;
        const stack = [0, ids.length - 1, 0];
        const result = [];

        // recursively search for items in range in the kd-sorted arrays
        while (stack.length) {
            const axis = stack.pop() || 0;
            const right = stack.pop() || 0;
            const left = stack.pop() || 0;

            // if we reached "tree node", search linearly
            if (right - left <= nodeSize) {
                for (let i = left; i <= right; i++) {
                    const x = coords[2 * i];
                    const y = coords[2 * i + 1];
                    if (x >= minX && x <= maxX && y >= minY && y <= maxY) result.push(ids[i]);
                }
                continue;
            }

            // otherwise find the middle index
            const m = (left + right) >> 1;

            // include the middle item if it's in range
            const x = coords[2 * m];
            const y = coords[2 * m + 1];
            if (x >= minX && x <= maxX && y >= minY && y <= maxY) result.push(ids[m]);

            // queue search in halves that intersect the query
            if (axis === 0 ? minX <= x : minY <= y) {
                stack.push(left);
                stack.push(m - 1);
                stack.push(1 - axis);
            }
            if (axis === 0 ? maxX >= x : maxY >= y) {
                stack.push(m + 1);
                stack.push(right);
                stack.push(1 - axis);
            }
        }

        return result;
    }

    /**
     * Search the index for items within a given radius.
     * @param {number} qx
     * @param {number} qy
     * @param {number} r Query radius.
     * @returns {number[]} An array of indices correponding to the found items.
     */
    within(qx, qy, r) {
        if (!this._finished) throw new Error('Data not yet indexed - call index.finish().');

        const {ids, coords, nodeSize} = this;
        const stack = [0, ids.length - 1, 0];
        const result = [];
        const r2 = r * r;

        // recursively search for items within radius in the kd-sorted arrays
        while (stack.length) {
            const axis = stack.pop() || 0;
            const right = stack.pop() || 0;
            const left = stack.pop() || 0;

            // if we reached "tree node", search linearly
            if (right - left <= nodeSize) {
                for (let i = left; i <= right; i++) {
                    if (sqDist(coords[2 * i], coords[2 * i + 1], qx, qy) <= r2) result.push(ids[i]);
                }
                continue;
            }

            // otherwise find the middle index
            const m = (left + right) >> 1;

            // include the middle item if it's in range
            const x = coords[2 * m];
            const y = coords[2 * m + 1];
            if (sqDist(x, y, qx, qy) <= r2) result.push(ids[m]);

            // queue search in halves that intersect the query
            if (axis === 0 ? qx - r <= x : qy - r <= y) {
                stack.push(left);
                stack.push(m - 1);
                stack.push(1 - axis);
            }
            if (axis === 0 ? qx + r >= x : qy + r >= y) {
                stack.push(m + 1);
                stack.push(right);
                stack.push(1 - axis);
            }
        }

        return result;
    }
}

/**
 * @param {Uint16Array | Uint32Array} ids
 * @param {InstanceType<TypedArrayConstructor>} coords
 * @param {number} nodeSize
 * @param {number} left
 * @param {number} right
 * @param {number} axis
 */
function sort(ids, coords, nodeSize, left, right, axis) {
    if (right - left <= nodeSize) return;

    const m = (left + right) >> 1; // middle index

    // sort ids and coords around the middle index so that the halves lie
    // either left/right or top/bottom correspondingly (taking turns)
    select(ids, coords, m, left, right, axis);

    // recursively kd-sort first half and second half on the opposite axis
    sort(ids, coords, nodeSize, left, m - 1, 1 - axis);
    sort(ids, coords, nodeSize, m + 1, right, 1 - axis);
}

/**
 * Custom Floyd-Rivest selection algorithm: sort ids and coords so that
 * [left..k-1] items are smaller than k-th item (on either x or y axis)
 * @param {Uint16Array | Uint32Array} ids
 * @param {InstanceType<TypedArrayConstructor>} coords
 * @param {number} k
 * @param {number} left
 * @param {number} right
 * @param {number} axis
 */
function select(ids, coords, k, left, right, axis) {

    while (right > left) {
        if (right - left > 600) {
            const n = right - left + 1;
            const m = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            select(ids, coords, k, newLeft, newRight, axis);
        }

        const t = coords[2 * k + axis];
        let i = left;
        let j = right;

        swapItem(ids, coords, left, k);
        if (coords[2 * right + axis] > t) swapItem(ids, coords, left, right);

        while (i < j) {
            swapItem(ids, coords, i, j);
            i++;
            j--;
            while (coords[2 * i + axis] < t) i++;
            while (coords[2 * j + axis] > t) j--;
        }

        if (coords[2 * left + axis] === t) swapItem(ids, coords, left, j);
        else {
            j++;
            swapItem(ids, coords, j, right);
        }

        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
}

/**
 * @param {Uint16Array | Uint32Array} ids
 * @param {InstanceType<TypedArrayConstructor>} coords
 * @param {number} i
 * @param {number} j
 */
function swapItem(ids, coords, i, j) {
    swap(ids, i, j);
    swap(coords, 2 * i, 2 * j);
    swap(coords, 2 * i + 1, 2 * j + 1);
}

/**
 * @param {InstanceType<TypedArrayConstructor>} arr
 * @param {number} i
 * @param {number} j
 */
function swap(arr, i, j) {
    const tmp = arr[i];
    arr[i] = arr[j];
    arr[j] = tmp;
}

/**
 * @param {number} ax
 * @param {number} ay
 * @param {number} bx
 * @param {number} by
 */
function sqDist(ax, ay, bx, by) {
    const dx = ax - bx;
    const dy = ay - by;
    return dx * dx + dy * dy;
}

exports.bf = void 0;
(function (PerformanceMarkers) {
    PerformanceMarkers["create"] = "create";
    PerformanceMarkers["load"] = "load";
    PerformanceMarkers["fullLoad"] = "fullLoad";
})(exports.bf || (exports.bf = {}));
let lastFrameTime = null;
let frameTimes = [];
const minFramerateTarget = 60;
const frameTimeTarget = 1000 / minFramerateTarget;
const loadTimeKey = 'loadTime';
const fullLoadTimeKey = 'fullLoadTime';
const PerformanceUtils = {
    mark(marker) {
        performance.mark(marker);
    },
    frame(timestamp) {
        const currTimestamp = timestamp;
        if (lastFrameTime != null) {
            const frameTime = currTimestamp - lastFrameTime;
            frameTimes.push(frameTime);
        }
        lastFrameTime = currTimestamp;
    },
    clearMetrics() {
        lastFrameTime = null;
        frameTimes = [];
        performance.clearMeasures(loadTimeKey);
        performance.clearMeasures(fullLoadTimeKey);
        for (const marker in exports.bf) {
            performance.clearMarks(exports.bf[marker]);
        }
    },
    getPerformanceMetrics() {
        performance.measure(loadTimeKey, exports.bf.create, exports.bf.load);
        performance.measure(fullLoadTimeKey, exports.bf.create, exports.bf.fullLoad);
        const loadTime = performance.getEntriesByName(loadTimeKey)[0].duration;
        const fullLoadTime = performance.getEntriesByName(fullLoadTimeKey)[0].duration;
        const totalFrames = frameTimes.length;
        const avgFrameTime = frameTimes.reduce((prev, curr) => prev + curr, 0) / totalFrames / 1000;
        const fps = 1 / avgFrameTime;
        // count frames that missed our framerate target
        const droppedFrames = frameTimes
            .filter((frameTime) => frameTime > frameTimeTarget)
            .reduce((acc, curr) => {
            return acc + (curr - frameTimeTarget) / frameTimeTarget;
        }, 0);
        const percentDroppedFrames = (droppedFrames / (totalFrames + droppedFrames)) * 100;
        return {
            loadTime,
            fullLoadTime,
            fps,
            percentDroppedFrames,
            totalFrames
        };
    }
};
/**
 * @internal
 * Safe wrapper for the performance resource timing API in web workers with graceful degradation
 */
class RequestPerformance {
    constructor(request) {
        this._marks = {
            start: [request.url, 'start'].join('#'),
            end: [request.url, 'end'].join('#'),
            measure: request.url.toString()
        };
        performance.mark(this._marks.start);
    }
    finish() {
        performance.mark(this._marks.end);
        let resourceTimingData = performance.getEntriesByName(this._marks.measure);
        // fallback if web worker implementation of perf.getEntriesByName returns empty
        if (resourceTimingData.length === 0) {
            performance.measure(this._marks.measure, this._marks.start, this._marks.end);
            resourceTimingData = performance.getEntriesByName(this._marks.measure);
            // cleanup
            performance.clearMarks(this._marks.start);
            performance.clearMarks(this._marks.end);
            performance.clearMeasures(this._marks.measure);
        }
        return resourceTimingData;
    }
}

exports.$ = RasterBoundsArray;
exports.A = ARRAY_TYPE;
exports.B = validateSky;
exports.C = isSafari;
exports.D = DataConstantProperty;
exports.E = Evented;
exports.F = Actor;
exports.G = GLOBAL_DISPATCHER_ID;
exports.H = create$1;
exports.I = ImagePosition;
exports.J = translate;
exports.K = scale;
exports.L = multiply$1;
exports.M = pick;
exports.N = LngLat;
exports.O = mercatorXfromLng;
exports.P = Point$2;
exports.Q = mercatorYfromLat;
exports.R = RGBAImage;
exports.S = OverscaledTileID;
exports.T = Transitionable;
exports.U = offscreenCanvasSupported;
exports.V = isOffscreenCanvasDistorted;
exports.W = readImageUsingVideoFrame;
exports.X = EXTENT;
exports.Y = createLayout;
exports.Z = MercatorCoordinate;
exports._ = __awaiter;
exports.a = config;
exports.a$ = equals$1;
exports.a0 = SegmentVector;
exports.a1 = CanonicalTileID;
exports.a2 = ValidationError;
exports.a3 = getVideo;
exports.a4 = uniqueId;
exports.a5 = CollisionBoxArray;
exports.a6 = SymbolBucket;
exports.a7 = createFilter;
exports.a8 = toEvaluationFeature;
exports.a9 = EvaluationParameters;
exports.aA = derefLayers;
exports.aB = createStyleLayer;
exports.aC = clone$1;
exports.aD = diffStyles;
exports.aE = validateCustomStyleLayer;
exports.aF = deepEqual$1;
exports.aG = mapObject;
exports.aH = filterObject;
exports.aI = Uniform1i;
exports.aJ = Uniform1f;
exports.aK = UniformMatrix4f;
exports.aL = Uniform4f;
exports.aM = UniformColor;
exports.aN = Color;
exports.aO = Uniform3f;
exports.aP = Uniform2f;
exports.aQ = ortho;
exports.aR = mul$1;
exports.aS = CollisionCircleLayoutArray;
exports.aT = collisionCircleLayout;
exports.aU = QuadTriangleArray;
exports.aV = nextPowerOfTwo;
exports.aW = renderColorRamp;
exports.aX = PosArray;
exports.aY = TriangleIndexArray;
exports.aZ = LineStripIndexArray;
exports.a_ = exactEquals;
exports.aa = GeoJSONFeature;
exports.ab = parseCacheControl;
exports.ac = keysDifference;
exports.ad = clamp$1;
exports.ae = rotateZ;
exports.af = clone;
exports.ag = transformMat4;
exports.ah = evaluateSizeForZoom;
exports.aj = evaluateSizeForFeature;
exports.ak = addDynamicAttributes;
exports.al = findLineIntersection;
exports.am = clipLine;
exports.an = polygonIntersectsPolygon;
exports.ao = identity;
exports.ap = getAABB;
exports.aq = ONE_EM;
exports.as = getOverlapMode;
exports.at = invert;
exports.au = getAnchorJustification;
exports.av = getAnchorAlignment;
exports.aw = KDBush;
exports.ax = emptyStyle;
exports.ay = ZoomHistory;
exports.az = getReferrer;
exports.b = isImageBitmap;
exports.b0 = copy;
exports.b1 = mul;
exports.b2 = dot$1;
exports.b3 = wrap;
exports.b4 = UnwrappedTileID;
exports.b5 = mercatorZfromAltitude;
exports.b6 = perspective;
exports.b7 = rotateX;
exports.b8 = bezier;
exports.b9 = defaultEasing;
exports.bA = isAbortError;
exports.bB = createExpression;
exports.bC = rtlWorkerPlugin;
exports.ba = degreesToRadians;
exports.bb = fromScaling;
exports.bc = Pos3dArray;
exports.bd = earthRadius;
exports.be = PerformanceUtils;
exports.bg = AJAXError;
exports.bh = addProtocol;
exports.bi = removeProtocol;
exports.bj = groupByLayout;
exports.bk = register;
exports.bl = DictionaryCoder;
exports.bm = FeatureIndex;
exports.bn = ImageAtlas;
exports.bo = performSymbolLayout;
exports.bp = LineBucket;
exports.bq = FillBucket;
exports.br = FillExtrusionBucket;
exports.bs = vectorTile;
exports.bt = Protobuf;
exports.bu = RequestPerformance;
exports.bv = getImageData;
exports.bw = DEMData;
exports.bx = getDefaultExportFromCjs$1;
exports.by = pointGeometry;
exports.bz = pbf;
exports.c = createAbortError;
exports.d = arrayBufferToImageBitmap;
exports.e = extend;
exports.f = arrayBufferToImage;
exports.g = getProtocol;
exports.h = getJSON;
exports.i = isWorker;
exports.j = ErrorEvent;
exports.k = Event;
exports.l = getArrayBuffer;
exports.m = makeRequest;
exports.n = parseGlyphPbf;
exports.o = AlphaImage;
exports.p = potpack;
exports.q = Properties;
exports.r = validateLight;
exports.s = sameOrigin;
exports.t = emitValidationErrors;
exports.u = unicodeBlockLookup;
exports.v = v8Spec;
exports.w = warnOnce;
exports.x = validateStyle;
exports.y = sphericalToCartesian;
exports.z = interpolate;

}));

define('worker', ['./shared'], (function (performance) { 'use strict';

class StyleLayerIndex {
    constructor(layerConfigs) {
        this.keyCache = {};
        if (layerConfigs) {
            this.replace(layerConfigs);
        }
    }
    replace(layerConfigs) {
        this._layerConfigs = {};
        this._layers = {};
        this.update(layerConfigs, []);
    }
    update(layerConfigs, removedIds) {
        for (const layerConfig of layerConfigs) {
            this._layerConfigs[layerConfig.id] = layerConfig;
            const layer = this._layers[layerConfig.id] = performance.aB(layerConfig);
            layer._featureFilter = performance.a7(layer.filter);
            if (this.keyCache[layerConfig.id])
                delete this.keyCache[layerConfig.id];
        }
        for (const id of removedIds) {
            delete this.keyCache[id];
            delete this._layerConfigs[id];
            delete this._layers[id];
        }
        this.familiesBySource = {};
        const groups = performance.bj(Object.values(this._layerConfigs), this.keyCache);
        for (const layerConfigs of groups) {
            const layers = layerConfigs.map((layerConfig) => this._layers[layerConfig.id]);
            const layer = layers[0];
            if (layer.visibility === 'none') {
                continue;
            }
            const sourceId = layer.source || '';
            let sourceGroup = this.familiesBySource[sourceId];
            if (!sourceGroup) {
                sourceGroup = this.familiesBySource[sourceId] = {};
            }
            const sourceLayerId = layer.sourceLayer || '_geojsonTileLayer';
            let sourceLayerFamilies = sourceGroup[sourceLayerId];
            if (!sourceLayerFamilies) {
                sourceLayerFamilies = sourceGroup[sourceLayerId] = [];
            }
            sourceLayerFamilies.push(layers);
        }
    }
}

const padding = 1;
class GlyphAtlas {
    constructor(stacks) {
        const positions = {};
        const bins = [];
        for (const stack in stacks) {
            const glyphs = stacks[stack];
            const stackPositions = positions[stack] = {};
            for (const id in glyphs) {
                const src = glyphs[+id];
                if (!src || src.bitmap.width === 0 || src.bitmap.height === 0)
                    continue;
                const bin = {
                    x: 0,
                    y: 0,
                    w: src.bitmap.width + 2 * padding,
                    h: src.bitmap.height + 2 * padding
                };
                bins.push(bin);
                stackPositions[id] = { rect: bin, metrics: src.metrics };
            }
        }
        const { w, h } = performance.p(bins);
        const image = new performance.o({ width: w || 1, height: h || 1 });
        for (const stack in stacks) {
            const glyphs = stacks[stack];
            for (const id in glyphs) {
                const src = glyphs[+id];
                if (!src || src.bitmap.width === 0 || src.bitmap.height === 0)
                    continue;
                const bin = positions[stack][id].rect;
                performance.o.copy(src.bitmap, image, { x: 0, y: 0 }, { x: bin.x + padding, y: bin.y + padding }, src.bitmap);
            }
        }
        this.image = image;
        this.positions = positions;
    }
}
performance.bk('GlyphAtlas', GlyphAtlas);

class WorkerTile {
    constructor(params) {
        this.tileID = new performance.S(params.tileID.overscaledZ, params.tileID.wrap, params.tileID.canonical.z, params.tileID.canonical.x, params.tileID.canonical.y);
        this.uid = params.uid;
        this.zoom = params.zoom;
        this.pixelRatio = params.pixelRatio;
        this.tileSize = params.tileSize;
        this.source = params.source;
        this.overscaling = this.tileID.overscaleFactor();
        this.showCollisionBoxes = params.showCollisionBoxes;
        this.collectResourceTiming = !!params.collectResourceTiming;
        this.returnDependencies = !!params.returnDependencies;
        this.promoteId = params.promoteId;
        this.inFlightDependencies = [];
    }
    parse(data, layerIndex, availableImages, actor) {
        return performance._(this, void 0, void 0, function* () {
            this.status = 'parsing';
            this.data = data;
            this.collisionBoxArray = new performance.a5();
            const sourceLayerCoder = new performance.bl(Object.keys(data.layers).sort());
            const featureIndex = new performance.bm(this.tileID, this.promoteId);
            featureIndex.bucketLayerIDs = [];
            const buckets = {};
            const options = {
                featureIndex,
                iconDependencies: {},
                patternDependencies: {},
                glyphDependencies: {},
                availableImages
            };
            const layerFamilies = layerIndex.familiesBySource[this.source];
            for (const sourceLayerId in layerFamilies) {
                const sourceLayer = data.layers[sourceLayerId];
                if (!sourceLayer) {
                    continue;
                }
                if (sourceLayer.version === 1) {
                    performance.w(`Vector tile source "${this.source}" layer "${sourceLayerId}" ` +
                        'does not use vector tile spec v2 and therefore may have some rendering errors.');
                }
                const sourceLayerIndex = sourceLayerCoder.encode(sourceLayerId);
                const features = [];
                for (let index = 0; index < sourceLayer.length; index++) {
                    const feature = sourceLayer.feature(index);
                    const id = featureIndex.getId(feature, sourceLayerId);
                    features.push({ feature, id, index, sourceLayerIndex });
                }
                for (const family of layerFamilies[sourceLayerId]) {
                    const layer = family[0];
                    if (layer.source !== this.source) {
                        performance.w(`layer.source = ${layer.source} does not equal this.source = ${this.source}`);
                    }
                    if (layer.minzoom && this.zoom < Math.floor(layer.minzoom))
                        continue;
                    if (layer.maxzoom && this.zoom >= layer.maxzoom)
                        continue;
                    if (layer.visibility === 'none')
                        continue;
                    recalculateLayers(family, this.zoom, availableImages);
                    const bucket = buckets[layer.id] = layer.createBucket({
                        index: featureIndex.bucketLayerIDs.length,
                        layers: family,
                        zoom: this.zoom,
                        pixelRatio: this.pixelRatio,
                        overscaling: this.overscaling,
                        collisionBoxArray: this.collisionBoxArray,
                        sourceLayerIndex,
                        sourceID: this.source
                    });
                    bucket.populate(features, options, this.tileID.canonical);
                    featureIndex.bucketLayerIDs.push(family.map((l) => l.id));
                }
            }
            // options.glyphDependencies looks like: {"SomeFontName":{"10":true,"32":true}}
            // this line makes an object like: {"SomeFontName":[10,32]}
            const stacks = performance.aG(options.glyphDependencies, (glyphs) => Object.keys(glyphs).map(Number));
            this.inFlightDependencies.forEach((request) => request === null || request === void 0 ? void 0 : request.abort());
            this.inFlightDependencies = [];
            let getGlyphsPromise = Promise.resolve({});
            if (Object.keys(stacks).length) {
                const abortController = new AbortController();
                this.inFlightDependencies.push(abortController);
                getGlyphsPromise = actor.sendAsync({ type: "GG" /* MessageType.getGlyphs */, data: { stacks, source: this.source, tileID: this.tileID, type: 'glyphs' } }, abortController);
            }
            const icons = Object.keys(options.iconDependencies);
            let getIconsPromise = Promise.resolve({});
            if (icons.length) {
                const abortController = new AbortController();
                this.inFlightDependencies.push(abortController);
                getIconsPromise = actor.sendAsync({ type: "GI" /* MessageType.getImages */, data: { icons, source: this.source, tileID: this.tileID, type: 'icons' } }, abortController);
            }
            const patterns = Object.keys(options.patternDependencies);
            let getPatternsPromise = Promise.resolve({});
            if (patterns.length) {
                const abortController = new AbortController();
                this.inFlightDependencies.push(abortController);
                getPatternsPromise = actor.sendAsync({ type: "GI" /* MessageType.getImages */, data: { icons: patterns, source: this.source, tileID: this.tileID, type: 'patterns' } }, abortController);
            }
            const [glyphMap, iconMap, patternMap] = yield Promise.all([getGlyphsPromise, getIconsPromise, getPatternsPromise]);
            const glyphAtlas = new GlyphAtlas(glyphMap);
            const imageAtlas = new performance.bn(iconMap, patternMap);
            for (const key in buckets) {
                const bucket = buckets[key];
                if (bucket instanceof performance.a6) {
                    recalculateLayers(bucket.layers, this.zoom, availableImages);
                    performance.bo({
                        bucket,
                        glyphMap,
                        glyphPositions: glyphAtlas.positions,
                        imageMap: iconMap,
                        imagePositions: imageAtlas.iconPositions,
                        showCollisionBoxes: this.showCollisionBoxes,
                        canonical: this.tileID.canonical
                    });
                }
                else if (bucket.hasPattern &&
                    (bucket instanceof performance.bp ||
                        bucket instanceof performance.bq ||
                        bucket instanceof performance.br)) {
                    recalculateLayers(bucket.layers, this.zoom, availableImages);
                    bucket.addFeatures(options, this.tileID.canonical, imageAtlas.patternPositions);
                }
            }
            this.status = 'done';
            return {
                buckets: Object.values(buckets).filter(b => !b.isEmpty()),
                featureIndex,
                collisionBoxArray: this.collisionBoxArray,
                glyphAtlasImage: glyphAtlas.image,
                imageAtlas,
                // Only used for benchmarking:
                glyphMap: this.returnDependencies ? glyphMap : null,
                iconMap: this.returnDependencies ? iconMap : null,
                glyphPositions: this.returnDependencies ? glyphAtlas.positions : null
            };
        });
    }
}
function recalculateLayers(layers, zoom, availableImages) {
    // Layers are shared and may have been used by a WorkerTile with a different zoom.
    const parameters = new performance.a9(zoom);
    for (const layer of layers) {
        layer.recalculate(parameters, availableImages);
    }
}

/**
 * The {@link WorkerSource} implementation that supports {@link VectorTileSource}.
 * This class is designed to be easily reused to support custom source types
 * for data formats that can be parsed/converted into an in-memory VectorTile
 * representation. To do so, override its `loadVectorTile` method.
 */
class VectorTileWorkerSource {
    /**
     * @param loadVectorData - Optional method for custom loading of a VectorTile
     * object based on parameters passed from the main-thread Source. See
     * {@link VectorTileWorkerSource#loadTile}. The default implementation simply
     * loads the pbf at `params.url`.
     */
    constructor(actor, layerIndex, availableImages) {
        this.actor = actor;
        this.layerIndex = layerIndex;
        this.availableImages = availableImages;
        this.fetching = {};
        this.loading = {};
        this.loaded = {};
    }
    /**
     * Loads a vector tile
     */
    loadVectorTile(params, abortController) {
        return performance._(this, void 0, void 0, function* () {
            const response = yield performance.l(params.request, abortController);
            try {
                const vectorTile = new performance.bs.VectorTile(new performance.bt(response.data));
                return {
                    vectorTile,
                    rawData: response.data,
                    cacheControl: response.cacheControl,
                    expires: response.expires
                };
            }
            catch (ex) {
                const bytes = new Uint8Array(response.data);
                const isGzipped = bytes[0] === 0x1f && bytes[1] === 0x8b;
                let errorMessage = `Unable to parse the tile at ${params.request.url}, `;
                if (isGzipped) {
                    errorMessage += 'please make sure the data is not gzipped and that you have configured the relevant header in the server';
                }
                else {
                    errorMessage += `got error: ${ex.message}`;
                }
                throw new Error(errorMessage);
            }
        });
    }
    /**
     * Implements {@link WorkerSource#loadTile}. Delegates to
     * {@link VectorTileWorkerSource#loadVectorData} (which by default expects
     * a `params.url` property) for fetching and producing a VectorTile object.
     */
    loadTile(params) {
        return performance._(this, void 0, void 0, function* () {
            const tileUid = params.uid;
            const perf = (params && params.request && params.request.collectResourceTiming) ?
                new performance.bu(params.request) : false;
            const workerTile = new WorkerTile(params);
            this.loading[tileUid] = workerTile;
            const abortController = new AbortController();
            workerTile.abort = abortController;
            try {
                const response = yield this.loadVectorTile(params, abortController);
                delete this.loading[tileUid];
                if (!response) {
                    return null;
                }
                const rawTileData = response.rawData;
                const cacheControl = {};
                if (response.expires)
                    cacheControl.expires = response.expires;
                if (response.cacheControl)
                    cacheControl.cacheControl = response.cacheControl;
                const resourceTiming = {};
                if (perf) {
                    const resourceTimingData = perf.finish();
                    // it's necessary to eval the result of getEntriesByName() here via parse/stringify
                    // late evaluation in the main thread causes TypeError: illegal invocation
                    if (resourceTimingData)
                        resourceTiming.resourceTiming = JSON.parse(JSON.stringify(resourceTimingData));
                }
                workerTile.vectorTile = response.vectorTile;
                const parsePromise = workerTile.parse(response.vectorTile, this.layerIndex, this.availableImages, this.actor);
                this.loaded[tileUid] = workerTile;
                // keep the original fetching state so that reload tile can pick it up if the original parse is cancelled by reloads' parse
                this.fetching[tileUid] = { rawTileData, cacheControl, resourceTiming };
                try {
                    const result = yield parsePromise;
                    // Transferring a copy of rawTileData because the worker needs to retain its copy.
                    return performance.e({ rawTileData: rawTileData.slice(0) }, result, cacheControl, resourceTiming);
                }
                finally {
                    delete this.fetching[tileUid];
                }
            }
            catch (err) {
                delete this.loading[tileUid];
                workerTile.status = 'done';
                this.loaded[tileUid] = workerTile;
                throw err;
            }
        });
    }
    /**
     * Implements {@link WorkerSource#reloadTile}.
     */
    reloadTile(params) {
        return performance._(this, void 0, void 0, function* () {
            const uid = params.uid;
            if (!this.loaded || !this.loaded[uid]) {
                throw new Error('Should not be trying to reload a tile that was never loaded or has been removed');
            }
            const workerTile = this.loaded[uid];
            workerTile.showCollisionBoxes = params.showCollisionBoxes;
            if (workerTile.status === 'parsing') {
                const result = yield workerTile.parse(workerTile.vectorTile, this.layerIndex, this.availableImages, this.actor);
                // if we have cancelled the original parse, make sure to pass the rawTileData from the original fetch
                let parseResult;
                if (this.fetching[uid]) {
                    const { rawTileData, cacheControl, resourceTiming } = this.fetching[uid];
                    delete this.fetching[uid];
                    parseResult = performance.e({ rawTileData: rawTileData.slice(0) }, result, cacheControl, resourceTiming);
                }
                else {
                    parseResult = result;
                }
                return parseResult;
            }
            // if there was no vector tile data on the initial load, don't try and re-parse tile
            if (workerTile.status === 'done' && workerTile.vectorTile) {
                // this seems like a missing case where cache control is lost? see #3309
                return workerTile.parse(workerTile.vectorTile, this.layerIndex, this.availableImages, this.actor);
            }
        });
    }
    /**
     * Implements {@link WorkerSource#abortTile}.
     */
    abortTile(params) {
        return performance._(this, void 0, void 0, function* () {
            const loading = this.loading;
            const uid = params.uid;
            if (loading && loading[uid] && loading[uid].abort) {
                loading[uid].abort.abort();
                delete loading[uid];
            }
        });
    }
    /**
     * Implements {@link WorkerSource#removeTile}.
     */
    removeTile(params) {
        return performance._(this, void 0, void 0, function* () {
            if (this.loaded && this.loaded[params.uid]) {
                delete this.loaded[params.uid];
            }
        });
    }
}

class RasterDEMTileWorkerSource {
    constructor() {
        this.loaded = {};
    }
    loadTile(params) {
        return performance._(this, void 0, void 0, function* () {
            const { uid, encoding, rawImageData, redFactor, greenFactor, blueFactor, baseShift } = params;
            const width = rawImageData.width + 2;
            const height = rawImageData.height + 2;
            const imagePixels = performance.b(rawImageData) ?
                new performance.R({ width, height }, yield performance.bv(rawImageData, -1, -1, width, height)) :
                rawImageData;
            const dem = new performance.bw(uid, imagePixels, encoding, redFactor, greenFactor, blueFactor, baseShift);
            this.loaded = this.loaded || {};
            this.loaded[uid] = dem;
            return dem;
        });
    }
    removeTile(params) {
        const loaded = this.loaded, uid = params.uid;
        if (loaded && loaded[uid]) {
            delete loaded[uid];
        }
    }
}

var geojsonRewind = rewind$1;

function rewind$1(gj, outer) {
    var type = gj && gj.type, i;

    if (type === 'FeatureCollection') {
        for (i = 0; i < gj.features.length; i++) rewind$1(gj.features[i], outer);

    } else if (type === 'GeometryCollection') {
        for (i = 0; i < gj.geometries.length; i++) rewind$1(gj.geometries[i], outer);

    } else if (type === 'Feature') {
        rewind$1(gj.geometry, outer);

    } else if (type === 'Polygon') {
        rewindRings(gj.coordinates, outer);

    } else if (type === 'MultiPolygon') {
        for (i = 0; i < gj.coordinates.length; i++) rewindRings(gj.coordinates[i], outer);
    }

    return gj;
}

function rewindRings(rings, outer) {
    if (rings.length === 0) return;

    rewindRing(rings[0], outer);
    for (var i = 1; i < rings.length; i++) {
        rewindRing(rings[i], !outer);
    }
}

function rewindRing(ring, dir) {
    var area = 0, err = 0;
    for (var i = 0, len = ring.length, j = len - 1; i < len; j = i++) {
        var k = (ring[i][0] - ring[j][0]) * (ring[j][1] + ring[i][1]);
        var m = area + k;
        err += Math.abs(area) >= Math.abs(k) ? area - m + k : k - m + area;
        area = m;
    }
    if (area + err >= 0 !== !!dir) ring.reverse();
}

var rewind$2 = /*@__PURE__*/performance.bx(geojsonRewind);

const toGeoJSON = performance.bs.VectorTileFeature.prototype.toGeoJSON;
let FeatureWrapper$1 = class FeatureWrapper {
    constructor(feature) {
        this._feature = feature;
        this.extent = performance.X;
        this.type = feature.type;
        this.properties = feature.tags;
        // If the feature has a top-level `id` property, copy it over, but only
        // if it can be coerced to an integer, because this wrapper is used for
        // serializing geojson feature data into vector tile PBF data, and the
        // vector tile spec only supports integer values for feature ids --
        // allowing non-integer values here results in a non-compliant PBF
        // that causes an exception when it is parsed with vector-tile-js
        if ('id' in feature && !isNaN(feature.id)) {
            this.id = parseInt(feature.id, 10);
        }
    }
    loadGeometry() {
        if (this._feature.type === 1) {
            const geometry = [];
            for (const point of this._feature.geometry) {
                geometry.push([new performance.P(point[0], point[1])]);
            }
            return geometry;
        }
        else {
            const geometry = [];
            for (const ring of this._feature.geometry) {
                const newRing = [];
                for (const point of ring) {
                    newRing.push(new performance.P(point[0], point[1]));
                }
                geometry.push(newRing);
            }
            return geometry;
        }
    }
    toGeoJSON(x, y, z) {
        return toGeoJSON.call(this, x, y, z);
    }
};
let GeoJSONWrapper$2 = class GeoJSONWrapper {
    constructor(features) {
        this.layers = { '_geojsonTileLayer': this };
        this.name = '_geojsonTileLayer';
        this.extent = performance.X;
        this.length = features.length;
        this._features = features;
    }
    feature(i) {
        return new FeatureWrapper$1(this._features[i]);
    }
};

var vtPbf = {exports: {}};

var Point = performance.by;
var VectorTileFeature = performance.bs.VectorTileFeature;

var geojson_wrapper = GeoJSONWrapper$1;

// conform to vectortile api
function GeoJSONWrapper$1 (features, options) {
  this.options = options || {};
  this.features = features;
  this.length = features.length;
}

GeoJSONWrapper$1.prototype.feature = function (i) {
  return new FeatureWrapper(this.features[i], this.options.extent)
};

function FeatureWrapper (feature, extent) {
  this.id = typeof feature.id === 'number' ? feature.id : undefined;
  this.type = feature.type;
  this.rawGeometry = feature.type === 1 ? [feature.geometry] : feature.geometry;
  this.properties = feature.tags;
  this.extent = extent || 4096;
}

FeatureWrapper.prototype.loadGeometry = function () {
  var rings = this.rawGeometry;
  this.geometry = [];

  for (var i = 0; i < rings.length; i++) {
    var ring = rings[i];
    var newRing = [];
    for (var j = 0; j < ring.length; j++) {
      newRing.push(new Point(ring[j][0], ring[j][1]));
    }
    this.geometry.push(newRing);
  }
  return this.geometry
};

FeatureWrapper.prototype.bbox = function () {
  if (!this.geometry) this.loadGeometry();

  var rings = this.geometry;
  var x1 = Infinity;
  var x2 = -Infinity;
  var y1 = Infinity;
  var y2 = -Infinity;

  for (var i = 0; i < rings.length; i++) {
    var ring = rings[i];

    for (var j = 0; j < ring.length; j++) {
      var coord = ring[j];

      x1 = Math.min(x1, coord.x);
      x2 = Math.max(x2, coord.x);
      y1 = Math.min(y1, coord.y);
      y2 = Math.max(y2, coord.y);
    }
  }

  return [x1, y1, x2, y2]
};

FeatureWrapper.prototype.toGeoJSON = VectorTileFeature.prototype.toGeoJSON;

var Pbf = performance.bz;
var GeoJSONWrapper = geojson_wrapper;

vtPbf.exports = fromVectorTileJs;
vtPbf.exports.fromVectorTileJs = fromVectorTileJs;
vtPbf.exports.fromGeojsonVt = fromGeojsonVt;
vtPbf.exports.GeoJSONWrapper = GeoJSONWrapper;

/**
 * Serialize a vector-tile-js-created tile to pbf
 *
 * @param {Object} tile
 * @return {Buffer} uncompressed, pbf-serialized tile data
 */
function fromVectorTileJs (tile) {
  var out = new Pbf();
  writeTile(tile, out);
  return out.finish()
}

/**
 * Serialized a geojson-vt-created tile to pbf.
 *
 * @param {Object} layers - An object mapping layer names to geojson-vt-created vector tile objects
 * @param {Object} [options] - An object specifying the vector-tile specification version and extent that were used to create `layers`.
 * @param {Number} [options.version=1] - Version of vector-tile spec used
 * @param {Number} [options.extent=4096] - Extent of the vector tile
 * @return {Buffer} uncompressed, pbf-serialized tile data
 */
function fromGeojsonVt (layers, options) {
  options = options || {};
  var l = {};
  for (var k in layers) {
    l[k] = new GeoJSONWrapper(layers[k].features, options);
    l[k].name = k;
    l[k].version = options.version;
    l[k].extent = options.extent;
  }
  return fromVectorTileJs({ layers: l })
}

function writeTile (tile, pbf) {
  for (var key in tile.layers) {
    pbf.writeMessage(3, writeLayer, tile.layers[key]);
  }
}

function writeLayer (layer, pbf) {
  pbf.writeVarintField(15, layer.version || 1);
  pbf.writeStringField(1, layer.name || '');
  pbf.writeVarintField(5, layer.extent || 4096);

  var i;
  var context = {
    keys: [],
    values: [],
    keycache: {},
    valuecache: {}
  };

  for (i = 0; i < layer.length; i++) {
    context.feature = layer.feature(i);
    pbf.writeMessage(2, writeFeature, context);
  }

  var keys = context.keys;
  for (i = 0; i < keys.length; i++) {
    pbf.writeStringField(3, keys[i]);
  }

  var values = context.values;
  for (i = 0; i < values.length; i++) {
    pbf.writeMessage(4, writeValue, values[i]);
  }
}

function writeFeature (context, pbf) {
  var feature = context.feature;

  if (feature.id !== undefined) {
    pbf.writeVarintField(1, feature.id);
  }

  pbf.writeMessage(2, writeProperties, context);
  pbf.writeVarintField(3, feature.type);
  pbf.writeMessage(4, writeGeometry, feature);
}

function writeProperties (context, pbf) {
  var feature = context.feature;
  var keys = context.keys;
  var values = context.values;
  var keycache = context.keycache;
  var valuecache = context.valuecache;

  for (var key in feature.properties) {
    var value = feature.properties[key];

    var keyIndex = keycache[key];
    if (value === null) continue // don't encode null value properties

    if (typeof keyIndex === 'undefined') {
      keys.push(key);
      keyIndex = keys.length - 1;
      keycache[key] = keyIndex;
    }
    pbf.writeVarint(keyIndex);

    var type = typeof value;
    if (type !== 'string' && type !== 'boolean' && type !== 'number') {
      value = JSON.stringify(value);
    }
    var valueKey = type + ':' + value;
    var valueIndex = valuecache[valueKey];
    if (typeof valueIndex === 'undefined') {
      values.push(value);
      valueIndex = values.length - 1;
      valuecache[valueKey] = valueIndex;
    }
    pbf.writeVarint(valueIndex);
  }
}

function command (cmd, length) {
  return (length << 3) + (cmd & 0x7)
}

function zigzag (num) {
  return (num << 1) ^ (num >> 31)
}

function writeGeometry (feature, pbf) {
  var geometry = feature.loadGeometry();
  var type = feature.type;
  var x = 0;
  var y = 0;
  var rings = geometry.length;
  for (var r = 0; r < rings; r++) {
    var ring = geometry[r];
    var count = 1;
    if (type === 1) {
      count = ring.length;
    }
    pbf.writeVarint(command(1, count)); // moveto
    // do not write polygon closing path as lineto
    var lineCount = type === 3 ? ring.length - 1 : ring.length;
    for (var i = 0; i < lineCount; i++) {
      if (i === 1 && type !== 1) {
        pbf.writeVarint(command(2, lineCount - 1)); // lineto
      }
      var dx = ring[i].x - x;
      var dy = ring[i].y - y;
      pbf.writeVarint(zigzag(dx));
      pbf.writeVarint(zigzag(dy));
      x += dx;
      y += dy;
    }
    if (type === 3) {
      pbf.writeVarint(command(7, 1)); // closepath
    }
  }
}

function writeValue (value, pbf) {
  var type = typeof value;
  if (type === 'string') {
    pbf.writeStringField(1, value);
  } else if (type === 'boolean') {
    pbf.writeBooleanField(7, value);
  } else if (type === 'number') {
    if (value % 1 !== 0) {
      pbf.writeDoubleField(3, value);
    } else if (value < 0) {
      pbf.writeSVarintField(6, value);
    } else {
      pbf.writeVarintField(5, value);
    }
  }
}

var vtPbfExports = vtPbf.exports;
var vtpbf = /*@__PURE__*/performance.bx(vtPbfExports);

const defaultOptions$1 = {
    minZoom: 0,   // min zoom to generate clusters on
    maxZoom: 16,  // max zoom level to cluster the points on
    minPoints: 2, // minimum points to form a cluster
    radius: 40,   // cluster radius in pixels
    extent: 512,  // tile extent (radius is calculated relative to it)
    nodeSize: 64, // size of the KD-tree leaf node, affects performance
    log: false,   // whether to log timing info

    // whether to generate numeric ids for input features (in vector tiles)
    generateId: false,

    // a reduce function for calculating custom cluster properties
    reduce: null, // (accumulated, props) => { accumulated.sum += props.sum; }

    // properties to use for individual points when running the reducer
    map: props => props // props => ({sum: props.my_value})
};

const fround = Math.fround || (tmp => ((x) => { tmp[0] = +x; return tmp[0]; }))(new Float32Array(1));

const OFFSET_ZOOM = 2;
const OFFSET_ID = 3;
const OFFSET_PARENT = 4;
const OFFSET_NUM = 5;
const OFFSET_PROP = 6;

class Supercluster {
    constructor(options) {
        this.options = Object.assign(Object.create(defaultOptions$1), options);
        this.trees = new Array(this.options.maxZoom + 1);
        this.stride = this.options.reduce ? 7 : 6;
        this.clusterProps = [];
    }

    load(points) {
        const {log, minZoom, maxZoom} = this.options;

        if (log) console.time('total time');

        const timerId = `prepare ${  points.length  } points`;
        if (log) console.time(timerId);

        this.points = points;

        // generate a cluster object for each point and index input points into a KD-tree
        const data = [];

        for (let i = 0; i < points.length; i++) {
            const p = points[i];
            if (!p.geometry) continue;

            const [lng, lat] = p.geometry.coordinates;
            const x = fround(lngX(lng));
            const y = fround(latY(lat));
            // store internal point/cluster data in flat numeric arrays for performance
            data.push(
                x, y, // projected point coordinates
                Infinity, // the last zoom the point was processed at
                i, // index of the source feature in the original input array
                -1, // parent cluster id
                1 // number of points in a cluster
            );
            if (this.options.reduce) data.push(0); // noop
        }
        let tree = this.trees[maxZoom + 1] = this._createTree(data);

        if (log) console.timeEnd(timerId);

        // cluster points on max zoom, then cluster the results on previous zoom, etc.;
        // results in a cluster hierarchy across zoom levels
        for (let z = maxZoom; z >= minZoom; z--) {
            const now = +Date.now();

            // create a new set of clusters for the zoom and index them with a KD-tree
            tree = this.trees[z] = this._createTree(this._cluster(tree, z));

            if (log) console.log('z%d: %d clusters in %dms', z, tree.numItems, +Date.now() - now);
        }

        if (log) console.timeEnd('total time');

        return this;
    }

    getClusters(bbox, zoom) {
        let minLng = ((bbox[0] + 180) % 360 + 360) % 360 - 180;
        const minLat = Math.max(-90, Math.min(90, bbox[1]));
        let maxLng = bbox[2] === 180 ? 180 : ((bbox[2] + 180) % 360 + 360) % 360 - 180;
        const maxLat = Math.max(-90, Math.min(90, bbox[3]));

        if (bbox[2] - bbox[0] >= 360) {
            minLng = -180;
            maxLng = 180;
        } else if (minLng > maxLng) {
            const easternHem = this.getClusters([minLng, minLat, 180, maxLat], zoom);
            const westernHem = this.getClusters([-180, minLat, maxLng, maxLat], zoom);
            return easternHem.concat(westernHem);
        }

        const tree = this.trees[this._limitZoom(zoom)];
        const ids = tree.range(lngX(minLng), latY(maxLat), lngX(maxLng), latY(minLat));
        const data = tree.data;
        const clusters = [];
        for (const id of ids) {
            const k = this.stride * id;
            clusters.push(data[k + OFFSET_NUM] > 1 ? getClusterJSON(data, k, this.clusterProps) : this.points[data[k + OFFSET_ID]]);
        }
        return clusters;
    }

    getChildren(clusterId) {
        const originId = this._getOriginId(clusterId);
        const originZoom = this._getOriginZoom(clusterId);
        const errorMsg = 'No cluster with the specified id.';

        const tree = this.trees[originZoom];
        if (!tree) throw new Error(errorMsg);

        const data = tree.data;
        if (originId * this.stride >= data.length) throw new Error(errorMsg);

        const r = this.options.radius / (this.options.extent * Math.pow(2, originZoom - 1));
        const x = data[originId * this.stride];
        const y = data[originId * this.stride + 1];
        const ids = tree.within(x, y, r);
        const children = [];
        for (const id of ids) {
            const k = id * this.stride;
            if (data[k + OFFSET_PARENT] === clusterId) {
                children.push(data[k + OFFSET_NUM] > 1 ? getClusterJSON(data, k, this.clusterProps) : this.points[data[k + OFFSET_ID]]);
            }
        }

        if (children.length === 0) throw new Error(errorMsg);

        return children;
    }

    getLeaves(clusterId, limit, offset) {
        limit = limit || 10;
        offset = offset || 0;

        const leaves = [];
        this._appendLeaves(leaves, clusterId, limit, offset, 0);

        return leaves;
    }

    getTile(z, x, y) {
        const tree = this.trees[this._limitZoom(z)];
        const z2 = Math.pow(2, z);
        const {extent, radius} = this.options;
        const p = radius / extent;
        const top = (y - p) / z2;
        const bottom = (y + 1 + p) / z2;

        const tile = {
            features: []
        };

        this._addTileFeatures(
            tree.range((x - p) / z2, top, (x + 1 + p) / z2, bottom),
            tree.data, x, y, z2, tile);

        if (x === 0) {
            this._addTileFeatures(
                tree.range(1 - p / z2, top, 1, bottom),
                tree.data, z2, y, z2, tile);
        }
        if (x === z2 - 1) {
            this._addTileFeatures(
                tree.range(0, top, p / z2, bottom),
                tree.data, -1, y, z2, tile);
        }

        return tile.features.length ? tile : null;
    }

    getClusterExpansionZoom(clusterId) {
        let expansionZoom = this._getOriginZoom(clusterId) - 1;
        while (expansionZoom <= this.options.maxZoom) {
            const children = this.getChildren(clusterId);
            expansionZoom++;
            if (children.length !== 1) break;
            clusterId = children[0].properties.cluster_id;
        }
        return expansionZoom;
    }

    _appendLeaves(result, clusterId, limit, offset, skipped) {
        const children = this.getChildren(clusterId);

        for (const child of children) {
            const props = child.properties;

            if (props && props.cluster) {
                if (skipped + props.point_count <= offset) {
                    // skip the whole cluster
                    skipped += props.point_count;
                } else {
                    // enter the cluster
                    skipped = this._appendLeaves(result, props.cluster_id, limit, offset, skipped);
                    // exit the cluster
                }
            } else if (skipped < offset) {
                // skip a single point
                skipped++;
            } else {
                // add a single point
                result.push(child);
            }
            if (result.length === limit) break;
        }

        return skipped;
    }

    _createTree(data) {
        const tree = new performance.aw(data.length / this.stride | 0, this.options.nodeSize, Float32Array);
        for (let i = 0; i < data.length; i += this.stride) tree.add(data[i], data[i + 1]);
        tree.finish();
        tree.data = data;
        return tree;
    }

    _addTileFeatures(ids, data, x, y, z2, tile) {
        for (const i of ids) {
            const k = i * this.stride;
            const isCluster = data[k + OFFSET_NUM] > 1;

            let tags, px, py;
            if (isCluster) {
                tags = getClusterProperties(data, k, this.clusterProps);
                px = data[k];
                py = data[k + 1];
            } else {
                const p = this.points[data[k + OFFSET_ID]];
                tags = p.properties;
                const [lng, lat] = p.geometry.coordinates;
                px = lngX(lng);
                py = latY(lat);
            }

            const f = {
                type: 1,
                geometry: [[
                    Math.round(this.options.extent * (px * z2 - x)),
                    Math.round(this.options.extent * (py * z2 - y))
                ]],
                tags
            };

            // assign id
            let id;
            if (isCluster || this.options.generateId) {
                // optionally generate id for points
                id = data[k + OFFSET_ID];
            } else {
                // keep id if already assigned
                id = this.points[data[k + OFFSET_ID]].id;
            }

            if (id !== undefined) f.id = id;

            tile.features.push(f);
        }
    }

    _limitZoom(z) {
        return Math.max(this.options.minZoom, Math.min(Math.floor(+z), this.options.maxZoom + 1));
    }

    _cluster(tree, zoom) {
        const {radius, extent, reduce, minPoints} = this.options;
        const r = radius / (extent * Math.pow(2, zoom));
        const data = tree.data;
        const nextData = [];
        const stride = this.stride;

        // loop through each point
        for (let i = 0; i < data.length; i += stride) {
            // if we've already visited the point at this zoom level, skip it
            if (data[i + OFFSET_ZOOM] <= zoom) continue;
            data[i + OFFSET_ZOOM] = zoom;

            // find all nearby points
            const x = data[i];
            const y = data[i + 1];
            const neighborIds = tree.within(data[i], data[i + 1], r);

            const numPointsOrigin = data[i + OFFSET_NUM];
            let numPoints = numPointsOrigin;

            // count the number of points in a potential cluster
            for (const neighborId of neighborIds) {
                const k = neighborId * stride;
                // filter out neighbors that are already processed
                if (data[k + OFFSET_ZOOM] > zoom) numPoints += data[k + OFFSET_NUM];
            }

            // if there were neighbors to merge, and there are enough points to form a cluster
            if (numPoints > numPointsOrigin && numPoints >= minPoints) {
                let wx = x * numPointsOrigin;
                let wy = y * numPointsOrigin;

                let clusterProperties;
                let clusterPropIndex = -1;

                // encode both zoom and point index on which the cluster originated -- offset by total length of features
                const id = ((i / stride | 0) << 5) + (zoom + 1) + this.points.length;

                for (const neighborId of neighborIds) {
                    const k = neighborId * stride;

                    if (data[k + OFFSET_ZOOM] <= zoom) continue;
                    data[k + OFFSET_ZOOM] = zoom; // save the zoom (so it doesn't get processed twice)

                    const numPoints2 = data[k + OFFSET_NUM];
                    wx += data[k] * numPoints2; // accumulate coordinates for calculating weighted center
                    wy += data[k + 1] * numPoints2;

                    data[k + OFFSET_PARENT] = id;

                    if (reduce) {
                        if (!clusterProperties) {
                            clusterProperties = this._map(data, i, true);
                            clusterPropIndex = this.clusterProps.length;
                            this.clusterProps.push(clusterProperties);
                        }
                        reduce(clusterProperties, this._map(data, k));
                    }
                }

                data[i + OFFSET_PARENT] = id;
                nextData.push(wx / numPoints, wy / numPoints, Infinity, id, -1, numPoints);
                if (reduce) nextData.push(clusterPropIndex);

            } else { // left points as unclustered
                for (let j = 0; j < stride; j++) nextData.push(data[i + j]);

                if (numPoints > 1) {
                    for (const neighborId of neighborIds) {
                        const k = neighborId * stride;
                        if (data[k + OFFSET_ZOOM] <= zoom) continue;
                        data[k + OFFSET_ZOOM] = zoom;
                        for (let j = 0; j < stride; j++) nextData.push(data[k + j]);
                    }
                }
            }
        }

        return nextData;
    }

    // get index of the point from which the cluster originated
    _getOriginId(clusterId) {
        return (clusterId - this.points.length) >> 5;
    }

    // get zoom of the point from which the cluster originated
    _getOriginZoom(clusterId) {
        return (clusterId - this.points.length) % 32;
    }

    _map(data, i, clone) {
        if (data[i + OFFSET_NUM] > 1) {
            const props = this.clusterProps[data[i + OFFSET_PROP]];
            return clone ? Object.assign({}, props) : props;
        }
        const original = this.points[data[i + OFFSET_ID]].properties;
        const result = this.options.map(original);
        return clone && result === original ? Object.assign({}, result) : result;
    }
}

function getClusterJSON(data, i, clusterProps) {
    return {
        type: 'Feature',
        id: data[i + OFFSET_ID],
        properties: getClusterProperties(data, i, clusterProps),
        geometry: {
            type: 'Point',
            coordinates: [xLng(data[i]), yLat(data[i + 1])]
        }
    };
}

function getClusterProperties(data, i, clusterProps) {
    const count = data[i + OFFSET_NUM];
    const abbrev =
        count >= 10000 ? `${Math.round(count / 1000)  }k` :
        count >= 1000 ? `${Math.round(count / 100) / 10  }k` : count;
    const propIndex = data[i + OFFSET_PROP];
    const properties = propIndex === -1 ? {} : Object.assign({}, clusterProps[propIndex]);
    return Object.assign(properties, {
        cluster: true,
        cluster_id: data[i + OFFSET_ID],
        point_count: count,
        point_count_abbreviated: abbrev
    });
}

// longitude/latitude to spherical mercator in [0..1] range
function lngX(lng) {
    return lng / 360 + 0.5;
}
function latY(lat) {
    const sin = Math.sin(lat * Math.PI / 180);
    const y = (0.5 - 0.25 * Math.log((1 + sin) / (1 - sin)) / Math.PI);
    return y < 0 ? 0 : y > 1 ? 1 : y;
}

// spherical mercator to longitude/latitude
function xLng(x) {
    return (x - 0.5) * 360;
}
function yLat(y) {
    const y2 = (180 - y * 360) * Math.PI / 180;
    return 360 * Math.atan(Math.exp(y2)) / Math.PI - 90;
}

// calculate simplification data using optimized Douglas-Peucker algorithm

function simplify(coords, first, last, sqTolerance) {
    let maxSqDist = sqTolerance;
    const mid = first + ((last - first) >> 1);
    let minPosToMid = last - first;
    let index;

    const ax = coords[first];
    const ay = coords[first + 1];
    const bx = coords[last];
    const by = coords[last + 1];

    for (let i = first + 3; i < last; i += 3) {
        const d = getSqSegDist(coords[i], coords[i + 1], ax, ay, bx, by);

        if (d > maxSqDist) {
            index = i;
            maxSqDist = d;

        } else if (d === maxSqDist) {
            // a workaround to ensure we choose a pivot close to the middle of the list,
            // reducing recursion depth, for certain degenerate inputs
            // https://github.com/mapbox/geojson-vt/issues/104
            const posToMid = Math.abs(i - mid);
            if (posToMid < minPosToMid) {
                index = i;
                minPosToMid = posToMid;
            }
        }
    }

    if (maxSqDist > sqTolerance) {
        if (index - first > 3) simplify(coords, first, index, sqTolerance);
        coords[index + 2] = maxSqDist;
        if (last - index > 3) simplify(coords, index, last, sqTolerance);
    }
}

// square distance from a point to a segment
function getSqSegDist(px, py, x, y, bx, by) {

    let dx = bx - x;
    let dy = by - y;

    if (dx !== 0 || dy !== 0) {

        const t = ((px - x) * dx + (py - y) * dy) / (dx * dx + dy * dy);

        if (t > 1) {
            x = bx;
            y = by;

        } else if (t > 0) {
            x += dx * t;
            y += dy * t;
        }
    }

    dx = px - x;
    dy = py - y;

    return dx * dx + dy * dy;
}

function createFeature(id, type, geom, tags) {
    const feature = {
        id: id == null ? null : id,
        type,
        geometry: geom,
        tags,
        minX: Infinity,
        minY: Infinity,
        maxX: -Infinity,
        maxY: -Infinity
    };

    if (type === 'Point' || type === 'MultiPoint' || type === 'LineString') {
        calcLineBBox(feature, geom);

    } else if (type === 'Polygon') {
        // the outer ring (ie [0]) contains all inner rings
        calcLineBBox(feature, geom[0]);

    } else if (type === 'MultiLineString') {
        for (const line of geom) {
            calcLineBBox(feature, line);
        }

    } else if (type === 'MultiPolygon') {
        for (const polygon of geom) {
            // the outer ring (ie [0]) contains all inner rings
            calcLineBBox(feature, polygon[0]);
        }
    }

    return feature;
}

function calcLineBBox(feature, geom) {
    for (let i = 0; i < geom.length; i += 3) {
        feature.minX = Math.min(feature.minX, geom[i]);
        feature.minY = Math.min(feature.minY, geom[i + 1]);
        feature.maxX = Math.max(feature.maxX, geom[i]);
        feature.maxY = Math.max(feature.maxY, geom[i + 1]);
    }
}

// converts GeoJSON feature into an intermediate projected JSON vector format with simplification data

function convert(data, options) {
    const features = [];
    if (data.type === 'FeatureCollection') {
        for (let i = 0; i < data.features.length; i++) {
            convertFeature(features, data.features[i], options, i);
        }

    } else if (data.type === 'Feature') {
        convertFeature(features, data, options);

    } else {
        // single geometry or a geometry collection
        convertFeature(features, {geometry: data}, options);
    }

    return features;
}

function convertFeature(features, geojson, options, index) {
    if (!geojson.geometry) return;

    const coords = geojson.geometry.coordinates;
    if (coords && coords.length === 0) return;

    const type = geojson.geometry.type;
    const tolerance = Math.pow(options.tolerance / ((1 << options.maxZoom) * options.extent), 2);
    let geometry = [];
    let id = geojson.id;
    if (options.promoteId) {
        id = geojson.properties[options.promoteId];
    } else if (options.generateId) {
        id = index || 0;
    }
    if (type === 'Point') {
        convertPoint(coords, geometry);

    } else if (type === 'MultiPoint') {
        for (const p of coords) {
            convertPoint(p, geometry);
        }

    } else if (type === 'LineString') {
        convertLine(coords, geometry, tolerance, false);

    } else if (type === 'MultiLineString') {
        if (options.lineMetrics) {
            // explode into linestrings to be able to track metrics
            for (const line of coords) {
                geometry = [];
                convertLine(line, geometry, tolerance, false);
                features.push(createFeature(id, 'LineString', geometry, geojson.properties));
            }
            return;
        } else {
            convertLines(coords, geometry, tolerance, false);
        }

    } else if (type === 'Polygon') {
        convertLines(coords, geometry, tolerance, true);

    } else if (type === 'MultiPolygon') {
        for (const polygon of coords) {
            const newPolygon = [];
            convertLines(polygon, newPolygon, tolerance, true);
            geometry.push(newPolygon);
        }
    } else if (type === 'GeometryCollection') {
        for (const singleGeometry of geojson.geometry.geometries) {
            convertFeature(features, {
                id,
                geometry: singleGeometry,
                properties: geojson.properties
            }, options, index);
        }
        return;
    } else {
        throw new Error('Input data is not a valid GeoJSON object.');
    }

    features.push(createFeature(id, type, geometry, geojson.properties));
}

function convertPoint(coords, out) {
    out.push(projectX(coords[0]), projectY(coords[1]), 0);
}

function convertLine(ring, out, tolerance, isPolygon) {
    let x0, y0;
    let size = 0;

    for (let j = 0; j < ring.length; j++) {
        const x = projectX(ring[j][0]);
        const y = projectY(ring[j][1]);

        out.push(x, y, 0);

        if (j > 0) {
            if (isPolygon) {
                size += (x0 * y - x * y0) / 2; // area
            } else {
                size += Math.sqrt(Math.pow(x - x0, 2) + Math.pow(y - y0, 2)); // length
            }
        }
        x0 = x;
        y0 = y;
    }

    const last = out.length - 3;
    out[2] = 1;
    simplify(out, 0, last, tolerance);
    out[last + 2] = 1;

    out.size = Math.abs(size);
    out.start = 0;
    out.end = out.size;
}

function convertLines(rings, out, tolerance, isPolygon) {
    for (let i = 0; i < rings.length; i++) {
        const geom = [];
        convertLine(rings[i], geom, tolerance, isPolygon);
        out.push(geom);
    }
}

function projectX(x) {
    return x / 360 + 0.5;
}

function projectY(y) {
    const sin = Math.sin(y * Math.PI / 180);
    const y2 = 0.5 - 0.25 * Math.log((1 + sin) / (1 - sin)) / Math.PI;
    return y2 < 0 ? 0 : y2 > 1 ? 1 : y2;
}

/* clip features between two vertical or horizontal axis-parallel lines:
 *     |        |
 *  ___|___     |     /
 * /   |   \____|____/
 *     |        |
 *
 * k1 and k2 are the line coordinates
 * axis: 0 for x, 1 for y
 * minAll and maxAll: minimum and maximum coordinate value for all features
 */
function clip(features, scale, k1, k2, axis, minAll, maxAll, options) {
    k1 /= scale;
    k2 /= scale;

    if (minAll >= k1 && maxAll < k2) return features; // trivial accept
    else if (maxAll < k1 || minAll >= k2) return null; // trivial reject

    const clipped = [];

    for (const feature of features) {
        const geometry = feature.geometry;
        let type = feature.type;

        const min = axis === 0 ? feature.minX : feature.minY;
        const max = axis === 0 ? feature.maxX : feature.maxY;

        if (min >= k1 && max < k2) { // trivial accept
            clipped.push(feature);
            continue;
        } else if (max < k1 || min >= k2) { // trivial reject
            continue;
        }

        let newGeometry = [];

        if (type === 'Point' || type === 'MultiPoint') {
            clipPoints(geometry, newGeometry, k1, k2, axis);

        } else if (type === 'LineString') {
            clipLine(geometry, newGeometry, k1, k2, axis, false, options.lineMetrics);

        } else if (type === 'MultiLineString') {
            clipLines(geometry, newGeometry, k1, k2, axis, false);

        } else if (type === 'Polygon') {
            clipLines(geometry, newGeometry, k1, k2, axis, true);

        } else if (type === 'MultiPolygon') {
            for (const polygon of geometry) {
                const newPolygon = [];
                clipLines(polygon, newPolygon, k1, k2, axis, true);
                if (newPolygon.length) {
                    newGeometry.push(newPolygon);
                }
            }
        }

        if (newGeometry.length) {
            if (options.lineMetrics && type === 'LineString') {
                for (const line of newGeometry) {
                    clipped.push(createFeature(feature.id, type, line, feature.tags));
                }
                continue;
            }

            if (type === 'LineString' || type === 'MultiLineString') {
                if (newGeometry.length === 1) {
                    type = 'LineString';
                    newGeometry = newGeometry[0];
                } else {
                    type = 'MultiLineString';
                }
            }
            if (type === 'Point' || type === 'MultiPoint') {
                type = newGeometry.length === 3 ? 'Point' : 'MultiPoint';
            }

            clipped.push(createFeature(feature.id, type, newGeometry, feature.tags));
        }
    }

    return clipped.length ? clipped : null;
}

function clipPoints(geom, newGeom, k1, k2, axis) {
    for (let i = 0; i < geom.length; i += 3) {
        const a = geom[i + axis];

        if (a >= k1 && a <= k2) {
            addPoint(newGeom, geom[i], geom[i + 1], geom[i + 2]);
        }
    }
}

function clipLine(geom, newGeom, k1, k2, axis, isPolygon, trackMetrics) {

    let slice = newSlice(geom);
    const intersect = axis === 0 ? intersectX : intersectY;
    let len = geom.start;
    let segLen, t;

    for (let i = 0; i < geom.length - 3; i += 3) {
        const ax = geom[i];
        const ay = geom[i + 1];
        const az = geom[i + 2];
        const bx = geom[i + 3];
        const by = geom[i + 4];
        const a = axis === 0 ? ax : ay;
        const b = axis === 0 ? bx : by;
        let exited = false;

        if (trackMetrics) segLen = Math.sqrt(Math.pow(ax - bx, 2) + Math.pow(ay - by, 2));

        if (a < k1) {
            // ---|-->  | (line enters the clip region from the left)
            if (b > k1) {
                t = intersect(slice, ax, ay, bx, by, k1);
                if (trackMetrics) slice.start = len + segLen * t;
            }
        } else if (a > k2) {
            // |  <--|--- (line enters the clip region from the right)
            if (b < k2) {
                t = intersect(slice, ax, ay, bx, by, k2);
                if (trackMetrics) slice.start = len + segLen * t;
            }
        } else {
            addPoint(slice, ax, ay, az);
        }
        if (b < k1 && a >= k1) {
            // <--|---  | or <--|-----|--- (line exits the clip region on the left)
            t = intersect(slice, ax, ay, bx, by, k1);
            exited = true;
        }
        if (b > k2 && a <= k2) {
            // |  ---|--> or ---|-----|--> (line exits the clip region on the right)
            t = intersect(slice, ax, ay, bx, by, k2);
            exited = true;
        }

        if (!isPolygon && exited) {
            if (trackMetrics) slice.end = len + segLen * t;
            newGeom.push(slice);
            slice = newSlice(geom);
        }

        if (trackMetrics) len += segLen;
    }

    // add the last point
    let last = geom.length - 3;
    const ax = geom[last];
    const ay = geom[last + 1];
    const az = geom[last + 2];
    const a = axis === 0 ? ax : ay;
    if (a >= k1 && a <= k2) addPoint(slice, ax, ay, az);

    // close the polygon if its endpoints are not the same after clipping
    last = slice.length - 3;
    if (isPolygon && last >= 3 && (slice[last] !== slice[0] || slice[last + 1] !== slice[1])) {
        addPoint(slice, slice[0], slice[1], slice[2]);
    }

    // add the final slice
    if (slice.length) {
        newGeom.push(slice);
    }
}

function newSlice(line) {
    const slice = [];
    slice.size = line.size;
    slice.start = line.start;
    slice.end = line.end;
    return slice;
}

function clipLines(geom, newGeom, k1, k2, axis, isPolygon) {
    for (const line of geom) {
        clipLine(line, newGeom, k1, k2, axis, isPolygon, false);
    }
}

function addPoint(out, x, y, z) {
    out.push(x, y, z);
}

function intersectX(out, ax, ay, bx, by, x) {
    const t = (x - ax) / (bx - ax);
    addPoint(out, x, ay + (by - ay) * t, 1);
    return t;
}

function intersectY(out, ax, ay, bx, by, y) {
    const t = (y - ay) / (by - ay);
    addPoint(out, ax + (bx - ax) * t, y, 1);
    return t;
}

function wrap(features, options) {
    const buffer = options.buffer / options.extent;
    let merged = features;
    const left  = clip(features, 1, -1 - buffer, buffer,     0, -1, 2, options); // left world copy
    const right = clip(features, 1,  1 - buffer, 2 + buffer, 0, -1, 2, options); // right world copy

    if (left || right) {
        merged = clip(features, 1, -buffer, 1 + buffer, 0, -1, 2, options) || []; // center world copy

        if (left) merged = shiftFeatureCoords(left, 1).concat(merged); // merge left into center
        if (right) merged = merged.concat(shiftFeatureCoords(right, -1)); // merge right into center
    }

    return merged;
}

function shiftFeatureCoords(features, offset) {
    const newFeatures = [];

    for (let i = 0; i < features.length; i++) {
        const feature = features[i];
        const type = feature.type;

        let newGeometry;

        if (type === 'Point' || type === 'MultiPoint' || type === 'LineString') {
            newGeometry = shiftCoords(feature.geometry, offset);

        } else if (type === 'MultiLineString' || type === 'Polygon') {
            newGeometry = [];
            for (const line of feature.geometry) {
                newGeometry.push(shiftCoords(line, offset));
            }
        } else if (type === 'MultiPolygon') {
            newGeometry = [];
            for (const polygon of feature.geometry) {
                const newPolygon = [];
                for (const line of polygon) {
                    newPolygon.push(shiftCoords(line, offset));
                }
                newGeometry.push(newPolygon);
            }
        }

        newFeatures.push(createFeature(feature.id, type, newGeometry, feature.tags));
    }

    return newFeatures;
}

function shiftCoords(points, offset) {
    const newPoints = [];
    newPoints.size = points.size;

    if (points.start !== undefined) {
        newPoints.start = points.start;
        newPoints.end = points.end;
    }

    for (let i = 0; i < points.length; i += 3) {
        newPoints.push(points[i] + offset, points[i + 1], points[i + 2]);
    }
    return newPoints;
}

// Transforms the coordinates of each feature in the given tile from
// mercator-projected space into (extent x extent) tile space.
function transformTile(tile, extent) {
    if (tile.transformed) return tile;

    const z2 = 1 << tile.z;
    const tx = tile.x;
    const ty = tile.y;

    for (const feature of tile.features) {
        const geom = feature.geometry;
        const type = feature.type;

        feature.geometry = [];

        if (type === 1) {
            for (let j = 0; j < geom.length; j += 2) {
                feature.geometry.push(transformPoint(geom[j], geom[j + 1], extent, z2, tx, ty));
            }
        } else {
            for (let j = 0; j < geom.length; j++) {
                const ring = [];
                for (let k = 0; k < geom[j].length; k += 2) {
                    ring.push(transformPoint(geom[j][k], geom[j][k + 1], extent, z2, tx, ty));
                }
                feature.geometry.push(ring);
            }
        }
    }

    tile.transformed = true;

    return tile;
}

function transformPoint(x, y, extent, z2, tx, ty) {
    return [
        Math.round(extent * (x * z2 - tx)),
        Math.round(extent * (y * z2 - ty))];
}

function createTile(features, z, tx, ty, options) {
    const tolerance = z === options.maxZoom ? 0 : options.tolerance / ((1 << z) * options.extent);
    const tile = {
        features: [],
        numPoints: 0,
        numSimplified: 0,
        numFeatures: features.length,
        source: null,
        x: tx,
        y: ty,
        z,
        transformed: false,
        minX: 2,
        minY: 1,
        maxX: -1,
        maxY: 0
    };
    for (const feature of features) {
        addFeature(tile, feature, tolerance, options);
    }
    return tile;
}

function addFeature(tile, feature, tolerance, options) {
    const geom = feature.geometry;
    const type = feature.type;
    const simplified = [];

    tile.minX = Math.min(tile.minX, feature.minX);
    tile.minY = Math.min(tile.minY, feature.minY);
    tile.maxX = Math.max(tile.maxX, feature.maxX);
    tile.maxY = Math.max(tile.maxY, feature.maxY);

    if (type === 'Point' || type === 'MultiPoint') {
        for (let i = 0; i < geom.length; i += 3) {
            simplified.push(geom[i], geom[i + 1]);
            tile.numPoints++;
            tile.numSimplified++;
        }

    } else if (type === 'LineString') {
        addLine(simplified, geom, tile, tolerance, false, false);

    } else if (type === 'MultiLineString' || type === 'Polygon') {
        for (let i = 0; i < geom.length; i++) {
            addLine(simplified, geom[i], tile, tolerance, type === 'Polygon', i === 0);
        }

    } else if (type === 'MultiPolygon') {

        for (let k = 0; k < geom.length; k++) {
            const polygon = geom[k];
            for (let i = 0; i < polygon.length; i++) {
                addLine(simplified, polygon[i], tile, tolerance, true, i === 0);
            }
        }
    }

    if (simplified.length) {
        let tags = feature.tags || null;

        if (type === 'LineString' && options.lineMetrics) {
            tags = {};
            for (const key in feature.tags) tags[key] = feature.tags[key];
            tags['mapbox_clip_start'] = geom.start / geom.size;
            tags['mapbox_clip_end'] = geom.end / geom.size;
        }

        const tileFeature = {
            geometry: simplified,
            type: type === 'Polygon' || type === 'MultiPolygon' ? 3 :
            (type === 'LineString' || type === 'MultiLineString' ? 2 : 1),
            tags
        };
        if (feature.id !== null) {
            tileFeature.id = feature.id;
        }
        tile.features.push(tileFeature);
    }
}

function addLine(result, geom, tile, tolerance, isPolygon, isOuter) {
    const sqTolerance = tolerance * tolerance;

    if (tolerance > 0 && (geom.size < (isPolygon ? sqTolerance : tolerance))) {
        tile.numPoints += geom.length / 3;
        return;
    }

    const ring = [];

    for (let i = 0; i < geom.length; i += 3) {
        if (tolerance === 0 || geom[i + 2] > sqTolerance) {
            tile.numSimplified++;
            ring.push(geom[i], geom[i + 1]);
        }
        tile.numPoints++;
    }

    if (isPolygon) rewind(ring, isOuter);

    result.push(ring);
}

function rewind(ring, clockwise) {
    let area = 0;
    for (let i = 0, len = ring.length, j = len - 2; i < len; j = i, i += 2) {
        area += (ring[i] - ring[j]) * (ring[i + 1] + ring[j + 1]);
    }
    if (area > 0 === clockwise) {
        for (let i = 0, len = ring.length; i < len / 2; i += 2) {
            const x = ring[i];
            const y = ring[i + 1];
            ring[i] = ring[len - 2 - i];
            ring[i + 1] = ring[len - 1 - i];
            ring[len - 2 - i] = x;
            ring[len - 1 - i] = y;
        }
    }
}

const defaultOptions = {
    maxZoom: 14,            // max zoom to preserve detail on
    indexMaxZoom: 5,        // max zoom in the tile index
    indexMaxPoints: 100000, // max number of points per tile in the tile index
    tolerance: 3,           // simplification tolerance (higher means simpler)
    extent: 4096,           // tile extent
    buffer: 64,             // tile buffer on each side
    lineMetrics: false,     // whether to calculate line metrics
    promoteId: null,        // name of a feature property to be promoted to feature.id
    generateId: false,      // whether to generate feature ids. Cannot be used with promoteId
    debug: 0                // logging level (0, 1 or 2)
};

class GeoJSONVT {
    constructor(data, options) {
        options = this.options = extend(Object.create(defaultOptions), options);

        const debug = options.debug;

        if (debug) console.time('preprocess data');

        if (options.maxZoom < 0 || options.maxZoom > 24) throw new Error('maxZoom should be in the 0-24 range');
        if (options.promoteId && options.generateId) throw new Error('promoteId and generateId cannot be used together.');

        // projects and adds simplification info
        let features = convert(data, options);

        // tiles and tileCoords are part of the public API
        this.tiles = {};
        this.tileCoords = [];

        if (debug) {
            console.timeEnd('preprocess data');
            console.log('index: maxZoom: %d, maxPoints: %d', options.indexMaxZoom, options.indexMaxPoints);
            console.time('generate tiles');
            this.stats = {};
            this.total = 0;
        }

        // wraps features (ie extreme west and extreme east)
        features = wrap(features, options);

        // start slicing from the top tile down
        if (features.length) this.splitTile(features, 0, 0, 0);

        if (debug) {
            if (features.length) console.log('features: %d, points: %d', this.tiles[0].numFeatures, this.tiles[0].numPoints);
            console.timeEnd('generate tiles');
            console.log('tiles generated:', this.total, JSON.stringify(this.stats));
        }
    }

    // splits features from a parent tile to sub-tiles.
    // z, x, and y are the coordinates of the parent tile
    // cz, cx, and cy are the coordinates of the target tile
    //
    // If no target tile is specified, splitting stops when we reach the maximum
    // zoom or the number of points is low as specified in the options.
    splitTile(features, z, x, y, cz, cx, cy) {

        const stack = [features, z, x, y];
        const options = this.options;
        const debug = options.debug;

        // avoid recursion by using a processing queue
        while (stack.length) {
            y = stack.pop();
            x = stack.pop();
            z = stack.pop();
            features = stack.pop();

            const z2 = 1 << z;
            const id = toID(z, x, y);
            let tile = this.tiles[id];

            if (!tile) {
                if (debug > 1) console.time('creation');

                tile = this.tiles[id] = createTile(features, z, x, y, options);
                this.tileCoords.push({z, x, y});

                if (debug) {
                    if (debug > 1) {
                        console.log('tile z%d-%d-%d (features: %d, points: %d, simplified: %d)',
                            z, x, y, tile.numFeatures, tile.numPoints, tile.numSimplified);
                        console.timeEnd('creation');
                    }
                    const key = `z${  z}`;
                    this.stats[key] = (this.stats[key] || 0) + 1;
                    this.total++;
                }
            }

            // save reference to original geometry in tile so that we can drill down later if we stop now
            tile.source = features;

            // if it's the first-pass tiling
            if (cz == null) {
                // stop tiling if we reached max zoom, or if the tile is too simple
                if (z === options.indexMaxZoom || tile.numPoints <= options.indexMaxPoints) continue;
            // if a drilldown to a specific tile
            } else if (z === options.maxZoom || z === cz) {
                // stop tiling if we reached base zoom or our target tile zoom
                continue;
            } else if (cz != null) {
                // stop tiling if it's not an ancestor of the target tile
                const zoomSteps = cz - z;
                if (x !== cx >> zoomSteps || y !== cy >> zoomSteps) continue;
            }

            // if we slice further down, no need to keep source geometry
            tile.source = null;

            if (features.length === 0) continue;

            if (debug > 1) console.time('clipping');

            // values we'll use for clipping
            const k1 = 0.5 * options.buffer / options.extent;
            const k2 = 0.5 - k1;
            const k3 = 0.5 + k1;
            const k4 = 1 + k1;

            let tl = null;
            let bl = null;
            let tr = null;
            let br = null;

            let left  = clip(features, z2, x - k1, x + k3, 0, tile.minX, tile.maxX, options);
            let right = clip(features, z2, x + k2, x + k4, 0, tile.minX, tile.maxX, options);
            features = null;

            if (left) {
                tl = clip(left, z2, y - k1, y + k3, 1, tile.minY, tile.maxY, options);
                bl = clip(left, z2, y + k2, y + k4, 1, tile.minY, tile.maxY, options);
                left = null;
            }

            if (right) {
                tr = clip(right, z2, y - k1, y + k3, 1, tile.minY, tile.maxY, options);
                br = clip(right, z2, y + k2, y + k4, 1, tile.minY, tile.maxY, options);
                right = null;
            }

            if (debug > 1) console.timeEnd('clipping');

            stack.push(tl || [], z + 1, x * 2,     y * 2);
            stack.push(bl || [], z + 1, x * 2,     y * 2 + 1);
            stack.push(tr || [], z + 1, x * 2 + 1, y * 2);
            stack.push(br || [], z + 1, x * 2 + 1, y * 2 + 1);
        }
    }

    getTile(z, x, y) {
        z = +z;
        x = +x;
        y = +y;

        const options = this.options;
        const {extent, debug} = options;

        if (z < 0 || z > 24) return null;

        const z2 = 1 << z;
        x = (x + z2) & (z2 - 1); // wrap tile x coordinate

        const id = toID(z, x, y);
        if (this.tiles[id]) return transformTile(this.tiles[id], extent);

        if (debug > 1) console.log('drilling down to z%d-%d-%d', z, x, y);

        let z0 = z;
        let x0 = x;
        let y0 = y;
        let parent;

        while (!parent && z0 > 0) {
            z0--;
            x0 = x0 >> 1;
            y0 = y0 >> 1;
            parent = this.tiles[toID(z0, x0, y0)];
        }

        if (!parent || !parent.source) return null;

        // if we found a parent tile containing the original geometry, we can drill down from it
        if (debug > 1) {
            console.log('found parent tile z%d-%d-%d', z0, x0, y0);
            console.time('drilling down');
        }
        this.splitTile(parent.source, z0, x0, y0, z, x, y);
        if (debug > 1) console.timeEnd('drilling down');

        return this.tiles[id] ? transformTile(this.tiles[id], extent) : null;
    }
}

function toID(z, x, y) {
    return (((1 << z) * y + x) * 32) + z;
}

function extend(dest, src) {
    for (const i in src) dest[i] = src[i];
    return dest;
}

function geojsonvt(data, options) {
    return new GeoJSONVT(data, options);
}

function getFeatureId(feature, promoteId) {
    return promoteId ? feature.properties[promoteId] : feature.id;
}
function isUpdateableGeoJSON(data, promoteId) {
    // null can be updated
    if (data == null) {
        return true;
    }
    // a single feature with an id can be updated, need to explicitly check against null because 0 is a valid feature id that is falsy
    if (data.type === 'Feature') {
        return getFeatureId(data, promoteId) != null;
    }
    // a feature collection can be updated if every feature has an id, and the ids are all unique
    // this prevents us from silently dropping features if ids get reused
    if (data.type === 'FeatureCollection') {
        const seenIds = new Set();
        for (const feature of data.features) {
            const id = getFeatureId(feature, promoteId);
            if (id == null) {
                return false;
            }
            if (seenIds.has(id)) {
                return false;
            }
            seenIds.add(id);
        }
        return true;
    }
    return false;
}
function toUpdateable(data, promoteId) {
    const result = new Map();
    if (data == null) ;
    else if (data.type === 'Feature') {
        result.set(getFeatureId(data, promoteId), data);
    }
    else {
        for (const feature of data.features) {
            result.set(getFeatureId(feature, promoteId), feature);
        }
    }
    return result;
}
// mutates updateable
function applySourceDiff(updateable, diff, promoteId) {
    var _a, _b, _c, _d;
    if (diff.removeAll) {
        updateable.clear();
    }
    if (diff.remove) {
        for (const id of diff.remove) {
            updateable.delete(id);
        }
    }
    if (diff.add) {
        for (const feature of diff.add) {
            const id = getFeatureId(feature, promoteId);
            if (id != null) {
                updateable.set(id, feature);
            }
        }
    }
    if (diff.update) {
        for (const update of diff.update) {
            let feature = updateable.get(update.id);
            if (feature == null) {
                continue;
            }
            // be careful to clone the feature and/or properties objects to avoid mutating our input
            const cloneFeature = update.newGeometry || update.removeAllProperties;
            // note: removeAllProperties gives us a new properties object, so we can skip the clone step
            const cloneProperties = !update.removeAllProperties && (((_a = update.removeProperties) === null || _a === void 0 ? void 0 : _a.length) > 0 || ((_b = update.addOrUpdateProperties) === null || _b === void 0 ? void 0 : _b.length) > 0);
            if (cloneFeature || cloneProperties) {
                feature = Object.assign({}, feature);
                updateable.set(update.id, feature);
                if (cloneProperties) {
                    feature.properties = Object.assign({}, feature.properties);
                }
            }
            if (update.newGeometry) {
                feature.geometry = update.newGeometry;
            }
            if (update.removeAllProperties) {
                feature.properties = {};
            }
            else if (((_c = update.removeProperties) === null || _c === void 0 ? void 0 : _c.length) > 0) {
                for (const prop of update.removeProperties) {
                    if (Object.prototype.hasOwnProperty.call(feature.properties, prop)) {
                        delete feature.properties[prop];
                    }
                }
            }
            if (((_d = update.addOrUpdateProperties) === null || _d === void 0 ? void 0 : _d.length) > 0) {
                for (const { key, value } of update.addOrUpdateProperties) {
                    feature.properties[key] = value;
                }
            }
        }
    }
}

/**
 * The {@link WorkerSource} implementation that supports {@link GeoJSONSource}.
 * This class is designed to be easily reused to support custom source types
 * for data formats that can be parsed/converted into an in-memory GeoJSON
 * representation. To do so, create it with
 * `new GeoJSONWorkerSource(actor, layerIndex, customLoadGeoJSONFunction)`.
 * For a full example, see [mapbox-gl-topojson](https://github.com/developmentseed/mapbox-gl-topojson).
 */
class GeoJSONWorkerSource extends VectorTileWorkerSource {
    constructor() {
        super(...arguments);
        this._dataUpdateable = new Map();
    }
    loadVectorTile(params, _abortController) {
        return performance._(this, void 0, void 0, function* () {
            const canonical = params.tileID.canonical;
            if (!this._geoJSONIndex) {
                throw new Error('Unable to parse the data into a cluster or geojson');
            }
            const geoJSONTile = this._geoJSONIndex.getTile(canonical.z, canonical.x, canonical.y);
            if (!geoJSONTile) {
                return null;
            }
            const geojsonWrapper = new GeoJSONWrapper$2(geoJSONTile.features);
            // Encode the geojson-vt tile into binary vector tile form.  This
            // is a convenience that allows `FeatureIndex` to operate the same way
            // across `VectorTileSource` and `GeoJSONSource` data.
            let pbf = vtpbf(geojsonWrapper);
            if (pbf.byteOffset !== 0 || pbf.byteLength !== pbf.buffer.byteLength) {
                // Compatibility with node Buffer (https://github.com/mapbox/pbf/issues/35)
                pbf = new Uint8Array(pbf);
            }
            return {
                vectorTile: geojsonWrapper,
                rawData: pbf.buffer
            };
        });
    }
    /**
     * Fetches (if appropriate), parses, and index geojson data into tiles. This
     * preparatory method must be called before {@link GeoJSONWorkerSource#loadTile}
     * can correctly serve up tiles.
     *
     * Defers to {@link GeoJSONWorkerSource#loadAndProcessGeoJSON} for the pre-processing.
     *
     * When a `loadData` request comes in while a previous one is being processed,
     * the previous one is aborted.
     *
     * @param params - the parameters
     * @returns a promise that resolves when the data is loaded and parsed into a GeoJSON object
     */
    loadData(params) {
        return performance._(this, void 0, void 0, function* () {
            var _a;
            (_a = this._pendingRequest) === null || _a === void 0 ? void 0 : _a.abort();
            const perf = (params && params.request && params.request.collectResourceTiming) ?
                new performance.bu(params.request) : false;
            this._pendingRequest = new AbortController();
            try {
                this._pendingData = this.loadAndProcessGeoJSON(params, this._pendingRequest);
                this._geoJSONIndex = params.cluster ?
                    new Supercluster(getSuperclusterOptions(params)).load((yield this._pendingData).features) :
                    geojsonvt(yield this._pendingData, params.geojsonVtOptions);
                this.loaded = {};
                const result = {};
                if (perf) {
                    const resourceTimingData = perf.finish();
                    // it's necessary to eval the result of getEntriesByName() here via parse/stringify
                    // late evaluation in the main thread causes TypeError: illegal invocation
                    if (resourceTimingData) {
                        result.resourceTiming = {};
                        result.resourceTiming[params.source] = JSON.parse(JSON.stringify(resourceTimingData));
                    }
                }
                return result;
            }
            catch (err) {
                delete this._pendingRequest;
                if (performance.bA(err)) {
                    return { abandoned: true };
                }
                throw err;
            }
        });
    }
    /**
     * Allows to get the source's actual GeoJSON.
     *
     * @returns a promise which is resolved with the source's actual GeoJSON
     */
    getData() {
        return performance._(this, void 0, void 0, function* () {
            return this._pendingData;
        });
    }
    /**
    * Implements {@link WorkerSource#reloadTile}.
    *
    * If the tile is loaded, uses the implementation in VectorTileWorkerSource.
    * Otherwise, such as after a setData() call, we load the tile fresh.
    *
    * @param params - the parameters
    * @returns A promise that resolves when the tile is reloaded
    */
    reloadTile(params) {
        const loaded = this.loaded, uid = params.uid;
        if (loaded && loaded[uid]) {
            return super.reloadTile(params);
        }
        else {
            return this.loadTile(params);
        }
    }
    /**
     * Fetch, parse and process GeoJSON according to the given params.
     *
     * Defers to {@link GeoJSONWorkerSource#loadGeoJSON} for the fetching and parsing.
     *
     * @param params - the parameters
     * @param abortController - the abort controller that allows aborting this operation
     * @returns a promise that is resolved with the processes GeoJSON
     */
    loadAndProcessGeoJSON(params, abortController) {
        return performance._(this, void 0, void 0, function* () {
            let data = yield this.loadGeoJSON(params, abortController);
            delete this._pendingRequest;
            if (typeof data !== 'object') {
                throw new Error(`Input data given to '${params.source}' is not a valid GeoJSON object.`);
            }
            rewind$2(data, true);
            if (params.filter) {
                const compiled = performance.bB(params.filter, { type: 'boolean', 'property-type': 'data-driven', overridable: false, transition: false });
                if (compiled.result === 'error')
                    throw new Error(compiled.value.map(err => `${err.key}: ${err.message}`).join(', '));
                const features = data.features.filter(feature => compiled.value.evaluate({ zoom: 0 }, feature));
                data = { type: 'FeatureCollection', features };
            }
            return data;
        });
    }
    /**
     * Fetch and parse GeoJSON according to the given params.
     *
     * GeoJSON is loaded and parsed from `params.url` if it exists, or else
     * expected as a literal (string or object) `params.data`.
     *
     * @param params - the parameters
     * @param abortController - the abort controller that allows aborting this operation
     * @returns a promise that resolves when the data is loaded
     */
    loadGeoJSON(params, abortController) {
        return performance._(this, void 0, void 0, function* () {
            const { promoteId } = params;
            if (params.request) {
                const response = yield performance.h(params.request, abortController);
                this._dataUpdateable = isUpdateableGeoJSON(response.data, promoteId) ? toUpdateable(response.data, promoteId) : undefined;
                return response.data;
            }
            if (typeof params.data === 'string') {
                try {
                    const parsed = JSON.parse(params.data);
                    this._dataUpdateable = isUpdateableGeoJSON(parsed, promoteId) ? toUpdateable(parsed, promoteId) : undefined;
                    return parsed;
                }
                catch (e) {
                    throw new Error(`Input data given to '${params.source}' is not a valid GeoJSON object.`);
                }
            }
            if (!params.dataDiff) {
                throw new Error(`Input data given to '${params.source}' is not a valid GeoJSON object.`);
            }
            if (!this._dataUpdateable) {
                throw new Error(`Cannot update existing geojson data in ${params.source}`);
            }
            applySourceDiff(this._dataUpdateable, params.dataDiff, promoteId);
            return { type: 'FeatureCollection', features: Array.from(this._dataUpdateable.values()) };
        });
    }
    removeSource(_params) {
        return performance._(this, void 0, void 0, function* () {
            if (this._pendingRequest) {
                this._pendingRequest.abort();
            }
        });
    }
    getClusterExpansionZoom(params) {
        return this._geoJSONIndex.getClusterExpansionZoom(params.clusterId);
    }
    getClusterChildren(params) {
        return this._geoJSONIndex.getChildren(params.clusterId);
    }
    getClusterLeaves(params) {
        return this._geoJSONIndex.getLeaves(params.clusterId, params.limit, params.offset);
    }
}
function getSuperclusterOptions({ superclusterOptions, clusterProperties }) {
    if (!clusterProperties || !superclusterOptions)
        return superclusterOptions;
    const mapExpressions = {};
    const reduceExpressions = {};
    const globals = { accumulated: null, zoom: 0 };
    const feature = { properties: null };
    const propertyNames = Object.keys(clusterProperties);
    for (const key of propertyNames) {
        const [operator, mapExpression] = clusterProperties[key];
        const mapExpressionParsed = performance.bB(mapExpression);
        const reduceExpressionParsed = performance.bB(typeof operator === 'string' ? [operator, ['accumulated'], ['get', key]] : operator);
        mapExpressions[key] = mapExpressionParsed.value;
        reduceExpressions[key] = reduceExpressionParsed.value;
    }
    superclusterOptions.map = (pointProperties) => {
        feature.properties = pointProperties;
        const properties = {};
        for (const key of propertyNames) {
            properties[key] = mapExpressions[key].evaluate(globals, feature);
        }
        return properties;
    };
    superclusterOptions.reduce = (accumulated, clusterProperties) => {
        feature.properties = clusterProperties;
        for (const key of propertyNames) {
            globals.accumulated = accumulated[key];
            accumulated[key] = reduceExpressions[key].evaluate(globals, feature);
        }
    };
    return superclusterOptions;
}

/**
 * The Worker class responsible for background thread related execution
 */
class Worker {
    constructor(self) {
        this.self = self;
        this.actor = new performance.F(self);
        this.layerIndexes = {};
        this.availableImages = {};
        this.workerSources = {};
        this.demWorkerSources = {};
        this.externalWorkerSourceTypes = {};
        this.self.registerWorkerSource = (name, WorkerSource) => {
            if (this.externalWorkerSourceTypes[name]) {
                throw new Error(`Worker source with name "${name}" already registered.`);
            }
            this.externalWorkerSourceTypes[name] = WorkerSource;
        };
        this.self.addProtocol = performance.bh;
        this.self.removeProtocol = performance.bi;
        // This is invoked by the RTL text plugin when the download via the `importScripts` call has finished, and the code has been parsed.
        this.self.registerRTLTextPlugin = (rtlTextPlugin) => {
            if (performance.bC.isParsed()) {
                throw new Error('RTL text plugin already registered.');
            }
            performance.bC.setMethods(rtlTextPlugin);
        };
        this.actor.registerMessageHandler("LDT" /* MessageType.loadDEMTile */, (mapId, params) => {
            return this._getDEMWorkerSource(mapId, params.source).loadTile(params);
        });
        this.actor.registerMessageHandler("RDT" /* MessageType.removeDEMTile */, (mapId, params) => performance._(this, void 0, void 0, function* () {
            this._getDEMWorkerSource(mapId, params.source).removeTile(params);
        }));
        this.actor.registerMessageHandler("GCEZ" /* MessageType.getClusterExpansionZoom */, (mapId, params) => performance._(this, void 0, void 0, function* () {
            return this._getWorkerSource(mapId, params.type, params.source).getClusterExpansionZoom(params);
        }));
        this.actor.registerMessageHandler("GCC" /* MessageType.getClusterChildren */, (mapId, params) => performance._(this, void 0, void 0, function* () {
            return this._getWorkerSource(mapId, params.type, params.source).getClusterChildren(params);
        }));
        this.actor.registerMessageHandler("GCL" /* MessageType.getClusterLeaves */, (mapId, params) => performance._(this, void 0, void 0, function* () {
            return this._getWorkerSource(mapId, params.type, params.source).getClusterLeaves(params);
        }));
        this.actor.registerMessageHandler("LD" /* MessageType.loadData */, (mapId, params) => {
            return this._getWorkerSource(mapId, params.type, params.source).loadData(params);
        });
        this.actor.registerMessageHandler("GD" /* MessageType.getData */, (mapId, params) => {
            return this._getWorkerSource(mapId, params.type, params.source).getData();
        });
        this.actor.registerMessageHandler("LT" /* MessageType.loadTile */, (mapId, params) => {
            return this._getWorkerSource(mapId, params.type, params.source).loadTile(params);
        });
        this.actor.registerMessageHandler("RT" /* MessageType.reloadTile */, (mapId, params) => {
            return this._getWorkerSource(mapId, params.type, params.source).reloadTile(params);
        });
        this.actor.registerMessageHandler("AT" /* MessageType.abortTile */, (mapId, params) => {
            return this._getWorkerSource(mapId, params.type, params.source).abortTile(params);
        });
        this.actor.registerMessageHandler("RMT" /* MessageType.removeTile */, (mapId, params) => {
            return this._getWorkerSource(mapId, params.type, params.source).removeTile(params);
        });
        this.actor.registerMessageHandler("RS" /* MessageType.removeSource */, (mapId, params) => performance._(this, void 0, void 0, function* () {
            if (!this.workerSources[mapId] ||
                !this.workerSources[mapId][params.type] ||
                !this.workerSources[mapId][params.type][params.source]) {
                return;
            }
            const worker = this.workerSources[mapId][params.type][params.source];
            delete this.workerSources[mapId][params.type][params.source];
            if (worker.removeSource !== undefined) {
                worker.removeSource(params);
            }
        }));
        this.actor.registerMessageHandler("RM" /* MessageType.removeMap */, (mapId) => performance._(this, void 0, void 0, function* () {
            delete this.layerIndexes[mapId];
            delete this.availableImages[mapId];
            delete this.workerSources[mapId];
            delete this.demWorkerSources[mapId];
        }));
        this.actor.registerMessageHandler("SR" /* MessageType.setReferrer */, (_mapId, params) => performance._(this, void 0, void 0, function* () {
            this.referrer = params;
        }));
        this.actor.registerMessageHandler("SRPS" /* MessageType.syncRTLPluginState */, (mapId, params) => {
            return this._syncRTLPluginState(mapId, params);
        });
        this.actor.registerMessageHandler("IS" /* MessageType.importScript */, (_mapId, params) => performance._(this, void 0, void 0, function* () {
            this.self.importScripts(params);
        }));
        this.actor.registerMessageHandler("SI" /* MessageType.setImages */, (mapId, params) => {
            return this._setImages(mapId, params);
        });
        this.actor.registerMessageHandler("UL" /* MessageType.updateLayers */, (mapId, params) => performance._(this, void 0, void 0, function* () {
            this._getLayerIndex(mapId).update(params.layers, params.removedIds);
        }));
        this.actor.registerMessageHandler("SL" /* MessageType.setLayers */, (mapId, params) => performance._(this, void 0, void 0, function* () {
            this._getLayerIndex(mapId).replace(params);
        }));
    }
    _setImages(mapId, images) {
        return performance._(this, void 0, void 0, function* () {
            this.availableImages[mapId] = images;
            for (const workerSource in this.workerSources[mapId]) {
                const ws = this.workerSources[mapId][workerSource];
                for (const source in ws) {
                    ws[source].availableImages = images;
                }
            }
        });
    }
    _syncRTLPluginState(mapId, incomingState) {
        return performance._(this, void 0, void 0, function* () {
            // Parsed plugin cannot be changed, so just return its current state.
            if (performance.bC.isParsed()) {
                return performance.bC.getState();
            }
            if (incomingState.pluginStatus !== 'loading') {
                // simply sync and done
                performance.bC.setState(incomingState);
                return incomingState;
            }
            const urlToLoad = incomingState.pluginURL;
            this.self.importScripts(urlToLoad);
            const complete = performance.bC.isParsed();
            if (complete) {
                const loadedState = {
                    pluginStatus: 'loaded',
                    pluginURL: urlToLoad
                };
                performance.bC.setState(loadedState);
                return loadedState;
            }
            // error case
            performance.bC.setState({
                pluginStatus: 'error',
                pluginURL: ''
            });
            throw new Error(`RTL Text Plugin failed to import scripts from ${urlToLoad}`);
        });
    }
    _getAvailableImages(mapId) {
        let availableImages = this.availableImages[mapId];
        if (!availableImages) {
            availableImages = [];
        }
        return availableImages;
    }
    _getLayerIndex(mapId) {
        let layerIndexes = this.layerIndexes[mapId];
        if (!layerIndexes) {
            layerIndexes = this.layerIndexes[mapId] = new StyleLayerIndex();
        }
        return layerIndexes;
    }
    /**
     * This is basically a lazy initialization of a worker per mapId and sourceType and sourceName
     * @param mapId - the mapId
     * @param sourceType - the source type - 'vector' for example
     * @param sourceName - the source name - 'osm' for example
     * @returns a new instance or a cached one
     */
    _getWorkerSource(mapId, sourceType, sourceName) {
        if (!this.workerSources[mapId])
            this.workerSources[mapId] = {};
        if (!this.workerSources[mapId][sourceType])
            this.workerSources[mapId][sourceType] = {};
        if (!this.workerSources[mapId][sourceType][sourceName]) {
            // use a wrapped actor so that we can attach a target mapId param
            // to any messages invoked by the WorkerSource, this is very important when there are multiple maps
            const actor = {
                sendAsync: (message, abortController) => {
                    message.targetMapId = mapId;
                    return this.actor.sendAsync(message, abortController);
                }
            };
            switch (sourceType) {
                case 'vector':
                    this.workerSources[mapId][sourceType][sourceName] = new VectorTileWorkerSource(actor, this._getLayerIndex(mapId), this._getAvailableImages(mapId));
                    break;
                case 'geojson':
                    this.workerSources[mapId][sourceType][sourceName] = new GeoJSONWorkerSource(actor, this._getLayerIndex(mapId), this._getAvailableImages(mapId));
                    break;
                default:
                    this.workerSources[mapId][sourceType][sourceName] = new (this.externalWorkerSourceTypes[sourceType])(actor, this._getLayerIndex(mapId), this._getAvailableImages(mapId));
                    break;
            }
        }
        return this.workerSources[mapId][sourceType][sourceName];
    }
    /**
     * This is basically a lazy initialization of a worker per mapId and source
     * @param mapId - the mapId
     * @param sourceType - the source type - 'raster-dem' for example
     * @returns a new instance or a cached one
     */
    _getDEMWorkerSource(mapId, sourceType) {
        if (!this.demWorkerSources[mapId])
            this.demWorkerSources[mapId] = {};
        if (!this.demWorkerSources[mapId][sourceType]) {
            this.demWorkerSources[mapId][sourceType] = new RasterDEMTileWorkerSource();
        }
        return this.demWorkerSources[mapId][sourceType];
    }
}
if (performance.i(self)) {
    self.worker = new Worker(self);
}

return Worker;

}));

define('index', ['exports', './shared'], (function (exports, performance$1) { 'use strict';

var name = "maplibre-gl";
var description = "BSD licensed community fork of mapbox-gl, a WebGL interactive maps library";
var version$2 = "4.5.2";
var main = "dist/maplibre-gl.js";
var style = "dist/maplibre-gl.css";
var license = "BSD-3-Clause";
var homepage = "https://maplibre.org/";
var funding = "https://github.com/maplibre/maplibre-gl-js?sponsor=1";
var bugs = {
	url: "https://github.com/maplibre/maplibre-gl-js/issues/"
};
var repository = {
	type: "git",
	url: "git://github.com/maplibre/maplibre-gl-js.git"
};
var types = "dist/maplibre-gl.d.ts";
var type = "module";
var dependencies = {
	"@mapbox/geojson-rewind": "^0.5.2",
	"@mapbox/jsonlint-lines-primitives": "^2.0.2",
	"@mapbox/point-geometry": "^0.1.0",
	"@mapbox/tiny-sdf": "^2.0.6",
	"@mapbox/unitbezier": "^0.0.1",
	"@mapbox/vector-tile": "^1.3.1",
	"@mapbox/whoots-js": "^3.1.0",
	"@maplibre/maplibre-gl-style-spec": "^20.3.0",
	"@types/geojson": "^7946.0.14",
	"@types/geojson-vt": "3.2.5",
	"@types/mapbox__point-geometry": "^0.1.4",
	"@types/mapbox__vector-tile": "^1.3.4",
	"@types/pbf": "^3.0.5",
	"@types/supercluster": "^7.1.3",
	earcut: "^3.0.0",
	"geojson-vt": "^4.0.2",
	"gl-matrix": "^3.4.3",
	"global-prefix": "^3.0.0",
	kdbush: "^4.0.2",
	"murmurhash-js": "^1.0.0",
	pbf: "^3.3.0",
	potpack: "^2.0.0",
	quickselect: "^3.0.0",
	supercluster: "^8.0.1",
	tinyqueue: "^3.0.0",
	"vt-pbf": "^3.1.3"
};
var devDependencies = {
	autoprefixer: "^10.4.20",
	"@mapbox/mapbox-gl-rtl-text": "^0.3.0",
	"@mapbox/mvt-fixtures": "^3.10.0",
	"@rollup/plugin-commonjs": "^26.0.1",
	"@rollup/plugin-json": "^6.1.0",
	"@rollup/plugin-node-resolve": "^15.2.3",
	"@rollup/plugin-replace": "^5.0.7",
	"@rollup/plugin-strip": "^3.0.4",
	"@rollup/plugin-terser": "^0.4.4",
	"@rollup/plugin-typescript": "^11.1.6",
	"@types/benchmark": "^2.1.5",
	"@types/cssnano": "^5.0.0",
	"@types/d3": "^7.4.3",
	"@types/diff": "^5.2.1",
	"@types/earcut": "^2.1.4",
	"@types/eslint": "^8.56.7",
	"@types/gl": "^6.0.5",
	"@types/glob": "^8.1.0",
	"@types/jest": "^29.5.12",
	"@types/jsdom": "^21.1.7",
	"@types/minimist": "^1.2.5",
	"@types/murmurhash-js": "^1.0.6",
	"@types/nise": "^1.4.5",
	"@types/node": "^22.1.0",
	"@types/offscreencanvas": "^2019.7.3",
	"@types/pixelmatch": "^5.2.6",
	"@types/pngjs": "^6.0.5",
	"@types/react": "^18.3.3",
	"@types/react-dom": "^18.3.0",
	"@types/request": "^2.48.12",
	"@types/shuffle-seed": "^1.1.3",
	"@types/window-or-global": "^1.0.6",
	"@typescript-eslint/eslint-plugin": "^7.18.0",
	"@typescript-eslint/parser": "^7.18.0",
	address: "^2.0.3",
	benchmark: "^2.1.4",
	canvas: "^2.11.2",
	cssnano: "^7.0.4",
	d3: "^7.9.0",
	"d3-queue": "^3.0.7",
	"devtools-protocol": "^0.0.1339468",
	diff: "^5.2.0",
	"dts-bundle-generator": "^9.5.1",
	eslint: "^8.57.0",
	"eslint-config-mourner": "^3.0.0",
	"eslint-plugin-html": "^8.1.1",
	"eslint-plugin-import": "^2.29.1",
	"eslint-plugin-jest": "^28.8.0",
	"eslint-plugin-react": "^7.35.0",
	"eslint-plugin-tsdoc": "0.3.0",
	expect: "^29.7.0",
	glob: "^11.0.0",
	"is-builtin-module": "^4.0.0",
	jest: "^29.7.0",
	"jest-environment-jsdom": "^29.7.0",
	"jest-junit": "^16.0.0",
	"jest-monocart-coverage": "^1.1.1",
	"jest-webgl-canvas-mock": "^2.5.3",
	jsdom: "^24.1.1",
	"junit-report-builder": "^5.0.0",
	minimist: "^1.2.8",
	"mock-geolocation": "^1.0.11",
	"monocart-coverage-reports": "^2.10.2",
	nise: "^6.0.0",
	"npm-font-open-sans": "^1.1.0",
	"npm-run-all": "^4.1.5",
	"pdf-merger-js": "^5.1.2",
	pixelmatch: "^6.0.0",
	pngjs: "^7.0.0",
	postcss: "^8.4.41",
	"postcss-cli": "^11.0.0",
	"postcss-inline-svg": "^6.0.0",
	"pretty-bytes": "^6.1.1",
	puppeteer: "^23.0.2",
	react: "^18.3.1",
	"react-dom": "^18.3.1",
	rollup: "^4.20.0",
	"rollup-plugin-sourcemaps": "^0.6.3",
	rw: "^1.3.3",
	semver: "^7.6.3",
	"shuffle-seed": "^1.1.6",
	"source-map-explorer": "^2.5.3",
	st: "^3.0.0",
	stylelint: "^16.8.1",
	"stylelint-config-standard": "^36.0.1",
	"ts-jest": "^29.2.4",
	"ts-node": "^10.9.2",
	tslib: "^2.6.3",
	typedoc: "^0.26.5",
	"typedoc-plugin-markdown": "^4.2.3",
	"typedoc-plugin-missing-exports": "^3.0.0",
	typescript: "^5.5.4"
};
var overrides = {
	"postcss-inline-svg": {
		"css-select": "^5.1.0",
		"dom-serializer": "^2.0.0",
		htmlparser2: "^8.0.1",
		"postcss-value-parser": "^4.2.0"
	}
};
var scripts = {
	"generate-dist-package": "node --no-warnings --loader ts-node/esm build/generate-dist-package.js",
	"generate-shaders": "node --no-warnings --loader ts-node/esm build/generate-shaders.ts",
	"generate-struct-arrays": "node --no-warnings --loader ts-node/esm build/generate-struct-arrays.ts",
	"generate-style-code": "node --no-warnings --loader ts-node/esm build/generate-style-code.ts",
	"generate-typings": "dts-bundle-generator --export-referenced-types --umd-module-name=maplibregl -o ./dist/maplibre-gl.d.ts ./src/index.ts",
	"generate-docs": "typedoc && node --no-warnings --loader ts-node/esm build/generate-docs.ts",
	"generate-images": "node --no-warnings --loader ts-node/esm build/generate-doc-images.ts",
	"build-dist": "npm run build-css && npm run generate-typings && npm run build-dev && npm run build-csp-dev && npm run build-prod && npm run build-prod-unminified && npm run build-csp",
	"build-dev": "rollup --configPlugin @rollup/plugin-typescript -c --environment BUILD:dev",
	"watch-dev": "rollup --configPlugin @rollup/plugin-typescript -c --environment BUILD:dev --watch",
	"build-prod": "rollup --configPlugin @rollup/plugin-typescript -c --environment BUILD:production,MINIFY:true",
	"build-prod-unminified": "rollup --configPlugin @rollup/plugin-typescript -c --environment BUILD:production",
	"build-csp": "rollup --configPlugin @rollup/plugin-typescript -c rollup.config.csp.ts --environment BUILD:production,MINIFY:true",
	"build-csp-dev": "rollup --configPlugin @rollup/plugin-typescript -c rollup.config.csp.ts --environment BUILD:dev",
	"build-css": "postcss -o dist/maplibre-gl.css src/css/maplibre-gl.css",
	"watch-css": "postcss --watch -o dist/maplibre-gl.css src/css/maplibre-gl.css",
	"build-benchmarks": "npm run build-dev && rollup --configPlugin @rollup/plugin-typescript -c test/bench/rollup_config_benchmarks.ts",
	"watch-benchmarks": "rollup --configPlugin @rollup/plugin-typescript -c test/bench/rollup_config_benchmarks.ts --watch",
	"start-server": "st --no-cache -H 0.0.0.0 --port 9966 .",
	"start-docs": "docker run --rm -it -p 8000:8000 -v ${PWD}:/docs squidfunk/mkdocs-material",
	start: "run-p watch-css watch-dev start-server",
	"start-bench": "run-p watch-css watch-benchmarks start-server",
	lint: "eslint --cache --ext .ts,.tsx,.js,.html --ignore-path .gitignore .",
	"lint-css": "stylelint **/*.css --fix -f verbose",
	test: "run-p lint lint-css test-render jest",
	jest: "jest",
	"test-build": "jest --selectProjects=build --reporters=default",
	"test-build-ci": "jest --selectProjects=build",
	"test-integration": "jest --selectProjects=integration --reporters=default",
	"test-integration-ci": "jest --coverage --selectProjects=integration",
	"test-render": "node --no-warnings --loader ts-node/esm test/integration/render/run_render_tests.ts",
	"test-unit": "jest --selectProjects=unit --reporters=default",
	"test-unit-ci": "jest --coverage --selectProjects unit",
	"test-watch-roots": "jest --watch",
	codegen: "run-p --print-label generate-dist-package generate-style-code generate-struct-arrays generate-shaders && npm run generate-typings",
	benchmark: "node --no-warnings --loader ts-node/esm test/bench/run-benchmarks.ts",
	"gl-stats": "node --no-warnings --loader ts-node/esm test/bench/gl-stats.ts",
	prepare: "npm run codegen",
	typecheck: "tsc --noEmit && tsc --project tsconfig.dist.json",
	tsnode: "node --experimental-loader=ts-node/esm --no-warnings"
};
var files = [
	"build/",
	"dist/*",
	"src/"
];
var engines = {
	npm: ">=8.1.0",
	node: ">=16.14.0"
};
var packageJSON = {
	name: name,
	description: description,
	version: version$2,
	main: main,
	style: style,
	license: license,
	homepage: homepage,
	funding: funding,
	bugs: bugs,
	repository: repository,
	types: types,
	type: type,
	dependencies: dependencies,
	devDependencies: devDependencies,
	overrides: overrides,
	scripts: scripts,
	files: files,
	engines: engines
};

const now = typeof performance !== 'undefined' && performance && performance.now ?
    performance.now.bind(performance) :
    Date.now.bind(Date);
let linkEl;
let reducedMotionQuery;
/** */
const browser = {
    /**
     * Provides a function that outputs milliseconds: either performance.now()
     * or a fallback to Date.now()
     */
    now,
    frameAsync(abortController) {
        return new Promise((resolve, reject) => {
            const frame = requestAnimationFrame(resolve);
            abortController.signal.addEventListener('abort', () => {
                cancelAnimationFrame(frame);
                reject(performance$1.c());
            });
        });
    },
    getImageData(img, padding = 0) {
        const context = this.getImageCanvasContext(img);
        return context.getImageData(-padding, -padding, img.width + 2 * padding, img.height + 2 * padding);
    },
    getImageCanvasContext(img) {
        const canvas = window.document.createElement('canvas');
        const context = canvas.getContext('2d', { willReadFrequently: true });
        if (!context) {
            throw new Error('failed to create canvas 2d context');
        }
        canvas.width = img.width;
        canvas.height = img.height;
        context.drawImage(img, 0, 0, img.width, img.height);
        return context;
    },
    resolveURL(path) {
        if (!linkEl)
            linkEl = document.createElement('a');
        linkEl.href = path;
        return linkEl.href;
    },
    hardwareConcurrency: typeof navigator !== 'undefined' && navigator.hardwareConcurrency || 4,
    get prefersReducedMotion() {
        // In case your test crashes when checking matchMedia, call setMatchMedia from 'src/util/test/util'
        if (!matchMedia)
            return false;
        //Lazily initialize media query
        if (reducedMotionQuery == null) {
            reducedMotionQuery = matchMedia('(prefers-reduced-motion: reduce)');
        }
        return reducedMotionQuery.matches;
    },
};

class DOM {
    static testProp(props) {
        if (!DOM.docStyle)
            return props[0];
        for (let i = 0; i < props.length; i++) {
            if (props[i] in DOM.docStyle) {
                return props[i];
            }
        }
        return props[0];
    }
    static create(tagName, className, container) {
        const el = window.document.createElement(tagName);
        if (className !== undefined)
            el.className = className;
        if (container)
            container.appendChild(el);
        return el;
    }
    static createNS(namespaceURI, tagName) {
        const el = window.document.createElementNS(namespaceURI, tagName);
        return el;
    }
    static disableDrag() {
        if (DOM.docStyle && DOM.selectProp) {
            DOM.userSelect = DOM.docStyle[DOM.selectProp];
            DOM.docStyle[DOM.selectProp] = 'none';
        }
    }
    static enableDrag() {
        if (DOM.docStyle && DOM.selectProp) {
            DOM.docStyle[DOM.selectProp] = DOM.userSelect;
        }
    }
    static setTransform(el, value) {
        el.style[DOM.transformProp] = value;
    }
    static addEventListener(target, type, callback, options = {}) {
        if ('passive' in options) {
            target.addEventListener(type, callback, options);
        }
        else {
            target.addEventListener(type, callback, options.capture);
        }
    }
    static removeEventListener(target, type, callback, options = {}) {
        if ('passive' in options) {
            target.removeEventListener(type, callback, options);
        }
        else {
            target.removeEventListener(type, callback, options.capture);
        }
    }
    // Suppress the next click, but only if it's immediate.
    static suppressClickInternal(e) {
        e.preventDefault();
        e.stopPropagation();
        window.removeEventListener('click', DOM.suppressClickInternal, true);
    }
    static suppressClick() {
        window.addEventListener('click', DOM.suppressClickInternal, true);
        window.setTimeout(() => {
            window.removeEventListener('click', DOM.suppressClickInternal, true);
        }, 0);
    }
    static getScale(element) {
        const rect = element.getBoundingClientRect();
        return {
            x: (rect.width / element.offsetWidth) || 1,
            y: (rect.height / element.offsetHeight) || 1,
            boundingClientRect: rect,
        };
    }
    static getPoint(el, scale, e) {
        const rect = scale.boundingClientRect;
        return new performance$1.P(
        // rect.left/top values are in page scale (like clientX/Y),
        // whereas clientLeft/Top (border width) values are the original values (before CSS scale applies).
        ((e.clientX - rect.left) / scale.x) - el.clientLeft, ((e.clientY - rect.top) / scale.y) - el.clientTop);
    }
    static mousePos(el, e) {
        const scale = DOM.getScale(el);
        return DOM.getPoint(el, scale, e);
    }
    static touchPos(el, touches) {
        const points = [];
        const scale = DOM.getScale(el);
        for (let i = 0; i < touches.length; i++) {
            points.push(DOM.getPoint(el, scale, touches[i]));
        }
        return points;
    }
    static mouseButton(e) {
        return e.button;
    }
    static remove(node) {
        if (node.parentNode) {
            node.parentNode.removeChild(node);
        }
    }
}
DOM.docStyle = typeof window !== 'undefined' && window.document && window.document.documentElement.style;
DOM.selectProp = DOM.testProp(['userSelect', 'MozUserSelect', 'WebkitUserSelect', 'msUserSelect']);
DOM.transformProp = DOM.testProp(['transform', 'WebkitTransform']);

const webpSupported = {
    supported: false,
    testSupport
};
let glForTesting;
let webpCheckComplete = false;
let webpImgTest;
let webpImgTestOnloadComplete = false;
if (typeof document !== 'undefined') {
    webpImgTest = document.createElement('img');
    webpImgTest.onload = () => {
        if (glForTesting)
            testWebpTextureUpload(glForTesting);
        glForTesting = null;
        webpImgTestOnloadComplete = true;
    };
    webpImgTest.onerror = () => {
        webpCheckComplete = true;
        glForTesting = null;
    };
    webpImgTest.src = 'data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAQAAAAfQ//73v/+BiOh/AAA=';
}
function testSupport(gl) {
    if (webpCheckComplete || !webpImgTest)
        return;
    // HTMLImageElement.complete is set when an image is done loading it's source
    // regardless of whether the load was successful or not.
    // It's possible for an error to set HTMLImageElement.complete to true which would trigger
    // testWebpTextureUpload and mistakenly set exported.supported to true in browsers which don't support webp
    // To avoid this, we set a flag in the image's onload handler and only call testWebpTextureUpload
    // after a successful image load event.
    if (webpImgTestOnloadComplete) {
        testWebpTextureUpload(gl);
    }
    else {
        glForTesting = gl;
    }
}
function testWebpTextureUpload(gl) {
    // Edge 18 supports WebP but not uploading a WebP image to a gl texture
    // Test support for this before allowing WebP images.
    // https://github.com/mapbox/mapbox-gl-js/issues/7671
    const texture = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D, texture);
    try {
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, webpImgTest);
        // The error does not get triggered in Edge if the context is lost
        if (gl.isContextLost())
            return;
        webpSupported.supported = true;
    }
    catch (e) {
        // Catch "Unspecified Error." in Edge 18.
    }
    gl.deleteTexture(texture);
    webpCheckComplete = true;
}

/**
 * By default, the image queue is self driven, meaning as soon as one requested item is processed,
 * it will move on to next one as quickly as it can while limiting
 * the number of concurrent requests to MAX_PARALLEL_IMAGE_REQUESTS. The default behavior
 * ensures that static views of the map can be rendered with minimal delay.
 *
 * However, the default behavior can prevent dynamic views of the map from rendering
 * smoothly in that many requests can finish in one render frame, putting too much pressure on GPU.
 *
 * When the view of the map is moving dynamically, smoother frame rates can be achieved
 * by throttling the number of items processed by the queue per frame. This can be
 * accomplished by using {@link addThrottleControl} to allow the caller to
 * use a lambda function to determine when the queue should be throttled (e.g. when isMoving())
 * and manually calling {@link processQueue} in the render loop.
 */
var ImageRequest;
(function (ImageRequest) {
    let imageRequestQueue;
    let currentParallelImageRequests;
    let throttleControlCallbackHandleCounter;
    let throttleControlCallbacks;
    /**
     * Reset the image request queue, removing all pending requests.
     */
    ImageRequest.resetRequestQueue = () => {
        imageRequestQueue = [];
        currentParallelImageRequests = 0;
        throttleControlCallbackHandleCounter = 0;
        throttleControlCallbacks = {};
    };
    /**
     * Install a callback to control when image queue throttling is desired.
     * (e.g. when the map view is moving)
     * @param callback - The callback function to install
     * @returns handle that identifies the installed callback.
     */
    ImageRequest.addThrottleControl = (callback) => {
        const handle = throttleControlCallbackHandleCounter++;
        throttleControlCallbacks[handle] = callback;
        return handle;
    };
    /**
     * Remove a previously installed callback by passing in the handle returned
     * by {@link addThrottleControl}.
     * @param callbackHandle - The handle for the callback to remove.
     */
    ImageRequest.removeThrottleControl = (callbackHandle) => {
        delete throttleControlCallbacks[callbackHandle];
        // Try updating the queue
        processQueue();
    };
    /**
     * Check to see if any of the installed callbacks are requesting the queue
     * to be throttled.
     * @returns `true` if any callback is causing the queue to be throttled.
     */
    const isThrottled = () => {
        for (const key of Object.keys(throttleControlCallbacks)) {
            if (throttleControlCallbacks[key]()) {
                return true;
            }
        }
        return false;
    };
    /**
     * Request to load an image.
     * @param requestParameters - Request parameters.
     * @param abortController - allows to abort the request.
     * @param supportImageRefresh - `true`, if the image request need to support refresh based on cache headers.
     * @returns - A promise resolved when the image is loaded.
     */
    ImageRequest.getImage = (requestParameters, abortController, supportImageRefresh = true) => {
        return new Promise((resolve, reject) => {
            if (webpSupported.supported) {
                if (!requestParameters.headers) {
                    requestParameters.headers = {};
                }
                requestParameters.headers.accept = 'image/webp,*/*';
            }
            performance$1.e(requestParameters, { type: 'image' });
            const request = {
                abortController,
                requestParameters,
                supportImageRefresh,
                state: 'queued',
                onError: (error) => {
                    reject(error);
                },
                onSuccess: (response) => {
                    resolve(response);
                }
            };
            imageRequestQueue.push(request);
            processQueue();
        });
    };
    const arrayBufferToCanvasImageSource = (data) => {
        const imageBitmapSupported = typeof createImageBitmap === 'function';
        if (imageBitmapSupported) {
            return performance$1.d(data);
        }
        else {
            return performance$1.f(data);
        }
    };
    const doImageRequest = (itemInQueue) => performance$1._(this, void 0, void 0, function* () {
        itemInQueue.state = 'running';
        const { requestParameters, supportImageRefresh, onError, onSuccess, abortController } = itemInQueue;
        // - If refreshExpiredTiles is false, then we can use HTMLImageElement to download raster images.
        // - Fetch/XHR (via MakeRequest API) will be used to download images for following scenarios:
        //      1. Style image sprite will had a issue with HTMLImageElement as described
        //          here: https://github.com/mapbox/mapbox-gl-js/issues/1470
        //      2. If refreshExpiredTiles is true (default), then in order to read the image cache header,
        //          fetch/XHR request will be required
        // - For any special case handling like use of AddProtocol, worker initiated request or additional headers
        //      let makeRequest handle it.
        // - HtmlImageElement request automatically adds accept header for all the browser supported images
        const canUseHTMLImageElement = supportImageRefresh === false &&
            !performance$1.i(self) &&
            !performance$1.g(requestParameters.url) &&
            (!requestParameters.headers ||
                Object.keys(requestParameters.headers).reduce((acc, item) => acc && item === 'accept', true));
        currentParallelImageRequests++;
        const getImagePromise = canUseHTMLImageElement ?
            getImageUsingHtmlImage(requestParameters, abortController) :
            performance$1.m(requestParameters, abortController);
        try {
            const response = yield getImagePromise;
            delete itemInQueue.abortController;
            itemInQueue.state = 'completed';
            if (response.data instanceof HTMLImageElement || performance$1.b(response.data)) {
                // User using addProtocol can directly return HTMLImageElement/ImageBitmap type
                // If HtmlImageElement is used to get image then response type will be HTMLImageElement
                onSuccess(response);
            }
            else if (response.data) {
                const img = yield arrayBufferToCanvasImageSource(response.data);
                onSuccess({ data: img, cacheControl: response.cacheControl, expires: response.expires });
            }
        }
        catch (err) {
            delete itemInQueue.abortController;
            onError(err);
        }
        finally {
            currentParallelImageRequests--;
            processQueue();
        }
    });
    /**
     * Process some number of items in the image request queue.
     */
    const processQueue = () => {
        const maxImageRequests = isThrottled() ?
            performance$1.a.MAX_PARALLEL_IMAGE_REQUESTS_PER_FRAME :
            performance$1.a.MAX_PARALLEL_IMAGE_REQUESTS;
        // limit concurrent image loads to help with raster sources performance on big screens
        for (let numImageRequests = currentParallelImageRequests; numImageRequests < maxImageRequests && imageRequestQueue.length > 0; numImageRequests++) {
            const topItemInQueue = imageRequestQueue.shift();
            if (topItemInQueue.abortController.signal.aborted) {
                numImageRequests--;
                continue;
            }
            doImageRequest(topItemInQueue);
        }
    };
    const getImageUsingHtmlImage = (requestParameters, abortController) => {
        return new Promise((resolve, reject) => {
            const image = new Image();
            const url = requestParameters.url;
            const credentials = requestParameters.credentials;
            if (credentials && credentials === 'include') {
                image.crossOrigin = 'use-credentials';
            }
            else if ((credentials && credentials === 'same-origin') || !performance$1.s(url)) {
                image.crossOrigin = 'anonymous';
            }
            abortController.signal.addEventListener('abort', () => {
                // Set src to '' to actually cancel the request
                image.src = '';
                reject(performance$1.c());
            });
            image.fetchPriority = 'high';
            image.onload = () => {
                image.onerror = image.onload = null;
                resolve({ data: image });
            };
            image.onerror = () => {
                image.onerror = image.onload = null;
                if (abortController.signal.aborted) {
                    return;
                }
                reject(new Error('Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported.'));
            };
            image.src = url;
        });
    };
})(ImageRequest || (ImageRequest = {}));
ImageRequest.resetRequestQueue();

class RequestManager {
    constructor(transformRequestFn) {
        this._transformRequestFn = transformRequestFn;
    }
    transformRequest(url, type) {
        if (this._transformRequestFn) {
            return this._transformRequestFn(url, type) || { url };
        }
        return { url };
    }
    setTransformRequest(transformRequest) {
        this._transformRequestFn = transformRequest;
    }
}

/**
 * 2x2 Matrix
 * @module mat2
 */

/**
 * Creates a new identity mat2
 *
 * @returns {mat2} a new 2x2 matrix
 */

function create$4() {
  var out = new performance$1.A(4);

  if (performance$1.A != Float32Array) {
    out[1] = 0;
    out[2] = 0;
  }

  out[0] = 1;
  out[3] = 1;
  return out;
}
/**
 * Rotates a mat2 by the given angle
 *
 * @param {mat2} out the receiving matrix
 * @param {ReadonlyMat2} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat2} out
 */

function rotate(out, a, rad) {
  var a0 = a[0],
      a1 = a[1],
      a2 = a[2],
      a3 = a[3];
  var s = Math.sin(rad);
  var c = Math.cos(rad);
  out[0] = a0 * c + a2 * s;
  out[1] = a1 * c + a3 * s;
  out[2] = a0 * -s + a2 * c;
  out[3] = a1 * -s + a3 * c;
  return out;
}

/**
 * 3x3 Matrix
 * @module mat3
 */

/**
 * Creates a new identity mat3
 *
 * @returns {mat3} a new 3x3 matrix
 */

function create$3() {
  var out = new performance$1.A(9);

  if (performance$1.A != Float32Array) {
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[5] = 0;
    out[6] = 0;
    out[7] = 0;
  }

  out[0] = 1;
  out[4] = 1;
  out[8] = 1;
  return out;
}
/**
 * Creates a matrix from a given angle
 * This is equivalent to (but much faster than):
 *
 *     mat3.identity(dest);
 *     mat3.rotate(dest, dest, rad);
 *
 * @param {mat3} out mat3 receiving operation result
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat3} out
 */

function fromRotation(out, rad) {
  var s = Math.sin(rad),
      c = Math.cos(rad);
  out[0] = c;
  out[1] = s;
  out[2] = 0;
  out[3] = -s;
  out[4] = c;
  out[5] = 0;
  out[6] = 0;
  out[7] = 0;
  out[8] = 1;
  return out;
}

/**
 * 3 Dimensional Vector
 * @module vec3
 */

/**
 * Creates a new, empty vec3
 *
 * @returns {vec3} a new 3D vector
 */

function create$2() {
  var out = new performance$1.A(3);

  if (performance$1.A != Float32Array) {
    out[0] = 0;
    out[1] = 0;
    out[2] = 0;
  }

  return out;
}
/**
 * Creates a new vec3 initialized with values from an existing vector
 *
 * @param {ReadonlyVec3} a vector to clone
 * @returns {vec3} a new 3D vector
 */

function clone(a) {
  var out = new performance$1.A(3);
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  return out;
}
/**
 * Adds two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {vec3} out
 */

function add(out, a, b) {
  out[0] = a[0] + b[0];
  out[1] = a[1] + b[1];
  out[2] = a[2] + b[2];
  return out;
}
/**
 * Subtracts vector b from vector a
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {vec3} out
 */

function subtract(out, a, b) {
  out[0] = a[0] - b[0];
  out[1] = a[1] - b[1];
  out[2] = a[2] - b[2];
  return out;
}
/**
 * Scales a vec3 by a scalar number
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the vector to scale
 * @param {Number} b amount to scale the vector by
 * @returns {vec3} out
 */

function scale(out, a, b) {
  out[0] = a[0] * b;
  out[1] = a[1] * b;
  out[2] = a[2] * b;
  return out;
}
/**
 * Normalize a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a vector to normalize
 * @returns {vec3} out
 */

function normalize(out, a) {
  var x = a[0];
  var y = a[1];
  var z = a[2];
  var len = x * x + y * y + z * z;

  if (len > 0) {
    //TODO: evaluate use of glm_invsqrt here?
    len = 1 / Math.sqrt(len);
  }

  out[0] = a[0] * len;
  out[1] = a[1] * len;
  out[2] = a[2] * len;
  return out;
}
/**
 * Calculates the dot product of two vec3's
 *
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {Number} dot product of a and b
 */

function dot(a, b) {
  return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}
/**
 * Computes the cross product of two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {vec3} out
 */

function cross(out, a, b) {
  var ax = a[0],
      ay = a[1],
      az = a[2];
  var bx = b[0],
      by = b[1],
      bz = b[2];
  out[0] = ay * bz - az * by;
  out[1] = az * bx - ax * bz;
  out[2] = ax * by - ay * bx;
  return out;
}
/**
 * Transforms the vec3 with a mat3.
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the vector to transform
 * @param {ReadonlyMat3} m the 3x3 matrix to transform with
 * @returns {vec3} out
 */

function transformMat3(out, a, m) {
  var x = a[0],
      y = a[1],
      z = a[2];
  out[0] = x * m[0] + y * m[3] + z * m[6];
  out[1] = x * m[1] + y * m[4] + z * m[7];
  out[2] = x * m[2] + y * m[5] + z * m[8];
  return out;
}
/**
 * Alias for {@link vec3.subtract}
 * @function
 */

var sub = subtract;
/**
 * Perform some operation over an array of vec3s.
 *
 * @param {Array} a the array of vectors to iterate over
 * @param {Number} stride Number of elements between the start of each vec3. If 0 assumes tightly packed
 * @param {Number} offset Number of elements to skip at the beginning of the array
 * @param {Number} count Number of vec3s to iterate over. If 0 iterates over entire array
 * @param {Function} fn Function to call for each vector in the array
 * @param {Object} [arg] additional argument to pass to fn
 * @returns {Array} a
 * @function
 */

(function () {
  var vec = create$2();
  return function (a, stride, offset, count, fn, arg) {
    var i, l;

    if (!stride) {
      stride = 3;
    }

    if (!offset) {
      offset = 0;
    }

    if (count) {
      l = Math.min(count * stride + offset, a.length);
    } else {
      l = a.length;
    }

    for (i = offset; i < l; i += stride) {
      vec[0] = a[i];
      vec[1] = a[i + 1];
      vec[2] = a[i + 2];
      fn(vec, vec, arg);
      a[i] = vec[0];
      a[i + 1] = vec[1];
      a[i + 2] = vec[2];
    }

    return a;
  };
})();

/**
 * 2 Dimensional Vector
 * @module vec2
 */

/**
 * Creates a new, empty vec2
 *
 * @returns {vec2} a new 2D vector
 */

function create$1() {
  var out = new performance$1.A(2);

  if (performance$1.A != Float32Array) {
    out[0] = 0;
    out[1] = 0;
  }

  return out;
}
/**
 * Calculates the squared length of a vec2
 *
 * @param {ReadonlyVec2} a vector to calculate squared length of
 * @returns {Number} squared length of a
 */

function squaredLength(a) {
  var x = a[0],
      y = a[1];
  return x * x + y * y;
}
/**
 * Transforms the vec2 with a mat4
 * 3rd vector component is implicitly '0'
 * 4th vector component is implicitly '1'
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a the vector to transform
 * @param {ReadonlyMat4} m matrix to transform with
 * @returns {vec2} out
 */

function transformMat4(out, a, m) {
  var x = a[0];
  var y = a[1];
  out[0] = m[0] * x + m[4] * y + m[12];
  out[1] = m[1] * x + m[5] * y + m[13];
  return out;
}
/**
 * Alias for {@link vec2.squaredLength}
 * @function
 */

var sqrLen = squaredLength;
/**
 * Perform some operation over an array of vec2s.
 *
 * @param {Array} a the array of vectors to iterate over
 * @param {Number} stride Number of elements between the start of each vec2. If 0 assumes tightly packed
 * @param {Number} offset Number of elements to skip at the beginning of the array
 * @param {Number} count Number of vec2s to iterate over. If 0 iterates over entire array
 * @param {Function} fn Function to call for each vector in the array
 * @param {Object} [arg] additional argument to pass to fn
 * @returns {Array} a
 * @function
 */

(function () {
  var vec = create$1();
  return function (a, stride, offset, count, fn, arg) {
    var i, l;

    if (!stride) {
      stride = 2;
    }

    if (!offset) {
      offset = 0;
    }

    if (count) {
      l = Math.min(count * stride + offset, a.length);
    } else {
      l = a.length;
    }

    for (i = offset; i < l; i += stride) {
      vec[0] = a[i];
      vec[1] = a[i + 1];
      fn(vec, vec, arg);
      a[i] = vec[0];
      a[i + 1] = vec[1];
    }

    return a;
  };
})();

/**
 * Takes a SpriteSpecification value and returns it in its array form. If `undefined` is passed as an input value, an
 * empty array is returned.
 * duplicated entries with identical id/url will be removed in returned array
 * @param sprite - optional sprite to coerce
 * @returns an empty array in case `undefined` is passed; id-url pairs otherwise
 */
function coerceSpriteToArray(sprite) {
    const resultArray = [];
    if (typeof sprite === 'string') {
        resultArray.push({ id: 'default', url: sprite });
    }
    else if (sprite && sprite.length > 0) {
        const dedupArray = [];
        for (const { id, url } of sprite) {
            const key = `${id}${url}`;
            if (dedupArray.indexOf(key) === -1) {
                dedupArray.push(key);
                resultArray.push({ id, url });
            }
        }
    }
    return resultArray;
}

function normalizeSpriteURL(url, format, extension) {
    const split = url.split('?');
    split[0] += `${format}${extension}`;
    return split.join('?');
}
function loadSprite(originalSprite, requestManager, pixelRatio, abortController) {
    return performance$1._(this, void 0, void 0, function* () {
        const spriteArray = coerceSpriteToArray(originalSprite);
        const format = pixelRatio > 1 ? '@2x' : '';
        const jsonsMap = {};
        const imagesMap = {};
        for (const { id, url } of spriteArray) {
            const jsonRequestParameters = requestManager.transformRequest(normalizeSpriteURL(url, format, '.json'), "SpriteJSON" /* ResourceType.SpriteJSON */);
            jsonsMap[id] = performance$1.h(jsonRequestParameters, abortController);
            const imageRequestParameters = requestManager.transformRequest(normalizeSpriteURL(url, format, '.png'), "SpriteImage" /* ResourceType.SpriteImage */);
            imagesMap[id] = ImageRequest.getImage(imageRequestParameters, abortController);
        }
        yield Promise.all([...Object.values(jsonsMap), ...Object.values(imagesMap)]);
        return doOnceCompleted(jsonsMap, imagesMap);
    });
}
/**
 * @param jsonsMap - JSON data map
 * @param imagesMap - image data map
 */
function doOnceCompleted(jsonsMap, imagesMap) {
    return performance$1._(this, void 0, void 0, function* () {
        const result = {};
        for (const spriteName in jsonsMap) {
            result[spriteName] = {};
            const context = browser.getImageCanvasContext((yield imagesMap[spriteName]).data);
            const json = (yield jsonsMap[spriteName]).data;
            for (const id in json) {
                const { width, height, x, y, sdf, pixelRatio, stretchX, stretchY, content, textFitWidth, textFitHeight } = json[id];
                const spriteData = { width, height, x, y, context };
                result[spriteName][id] = { data: null, pixelRatio, sdf, stretchX, stretchY, content, textFitWidth, textFitHeight, spriteData };
            }
        }
        return result;
    });
}

/**
 * @internal
 * A `Texture` GL related object
 */
class Texture {
    constructor(context, image, format, options) {
        this.context = context;
        this.format = format;
        this.texture = context.gl.createTexture();
        this.update(image, options);
    }
    update(image, options, position) {
        const { width, height } = image;
        const resize = (!this.size || this.size[0] !== width || this.size[1] !== height) && !position;
        const { context } = this;
        const { gl } = context;
        this.useMipmap = Boolean(options && options.useMipmap);
        gl.bindTexture(gl.TEXTURE_2D, this.texture);
        context.pixelStoreUnpackFlipY.set(false);
        context.pixelStoreUnpack.set(1);
        context.pixelStoreUnpackPremultiplyAlpha.set(this.format === gl.RGBA && (!options || options.premultiply !== false));
        if (resize) {
            this.size = [width, height];
            if (image instanceof HTMLImageElement || image instanceof HTMLCanvasElement || image instanceof HTMLVideoElement || image instanceof ImageData || performance$1.b(image)) {
                gl.texImage2D(gl.TEXTURE_2D, 0, this.format, this.format, gl.UNSIGNED_BYTE, image);
            }
            else {
                gl.texImage2D(gl.TEXTURE_2D, 0, this.format, width, height, 0, this.format, gl.UNSIGNED_BYTE, image.data);
            }
        }
        else {
            const { x, y } = position || { x: 0, y: 0 };
            if (image instanceof HTMLImageElement || image instanceof HTMLCanvasElement || image instanceof HTMLVideoElement || image instanceof ImageData || performance$1.b(image)) {
                gl.texSubImage2D(gl.TEXTURE_2D, 0, x, y, gl.RGBA, gl.UNSIGNED_BYTE, image);
            }
            else {
                gl.texSubImage2D(gl.TEXTURE_2D, 0, x, y, width, height, gl.RGBA, gl.UNSIGNED_BYTE, image.data);
            }
        }
        if (this.useMipmap && this.isSizePowerOfTwo()) {
            gl.generateMipmap(gl.TEXTURE_2D);
        }
    }
    bind(filter, wrap, minFilter) {
        const { context } = this;
        const { gl } = context;
        gl.bindTexture(gl.TEXTURE_2D, this.texture);
        if (minFilter === gl.LINEAR_MIPMAP_NEAREST && !this.isSizePowerOfTwo()) {
            minFilter = gl.LINEAR;
        }
        if (filter !== this.filter) {
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, filter);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, minFilter || filter);
            this.filter = filter;
        }
        if (wrap !== this.wrap) {
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, wrap);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, wrap);
            this.wrap = wrap;
        }
    }
    isSizePowerOfTwo() {
        return this.size[0] === this.size[1] && (Math.log(this.size[0]) / Math.LN2) % 1 === 0;
    }
    destroy() {
        const { gl } = this.context;
        gl.deleteTexture(this.texture);
        this.texture = null;
    }
}

function renderStyleImage(image) {
    const { userImage } = image;
    if (userImage && userImage.render) {
        const updated = userImage.render();
        if (updated) {
            image.data.replace(new Uint8Array(userImage.data.buffer));
            return true;
        }
    }
    return false;
}

/* eslint-disable key-spacing */
/**
 * When copied into the atlas texture, image data is padded by one pixel on each side. Icon
 * images are padded with fully transparent pixels, while pattern images are padded with a
 * copy of the image data wrapped from the opposite side. In both cases, this ensures the
 * correct behavior of GL_LINEAR texture sampling mode.
 */
const padding = 1;
/**
 * ImageManager does three things:
 *
 * 1. Tracks requests for icon images from tile workers and sends responses when the requests are fulfilled.
 * 2. Builds a texture atlas for pattern images.
 * 3. Rerenders renderable images once per frame
 *
 * These are disparate responsibilities and should eventually be handled by different classes. When we implement
 * data-driven support for `*-pattern`, we'll likely use per-bucket pattern atlases, and that would be a good time
 * to refactor this.
*/
class ImageManager extends performance$1.E {
    constructor() {
        super();
        this.images = {};
        this.updatedImages = {};
        this.callbackDispatchedThisFrame = {};
        this.loaded = false;
        this.requestors = [];
        this.patterns = {};
        this.atlasImage = new performance$1.R({ width: 1, height: 1 });
        this.dirty = true;
    }
    isLoaded() {
        return this.loaded;
    }
    setLoaded(loaded) {
        if (this.loaded === loaded) {
            return;
        }
        this.loaded = loaded;
        if (loaded) {
            for (const { ids, promiseResolve } of this.requestors) {
                promiseResolve(this._getImagesForIds(ids));
            }
            this.requestors = [];
        }
    }
    getImage(id) {
        const image = this.images[id];
        // Extract sprite image data on demand
        if (image && !image.data && image.spriteData) {
            const spriteData = image.spriteData;
            image.data = new performance$1.R({
                width: spriteData.width,
                height: spriteData.height
            }, spriteData.context.getImageData(spriteData.x, spriteData.y, spriteData.width, spriteData.height).data);
            image.spriteData = null;
        }
        return image;
    }
    addImage(id, image) {
        if (this.images[id])
            throw new Error(`Image id ${id} already exist, use updateImage instead`);
        if (this._validate(id, image)) {
            this.images[id] = image;
        }
    }
    _validate(id, image) {
        let valid = true;
        const data = image.data || image.spriteData;
        if (!this._validateStretch(image.stretchX, data && data.width)) {
            this.fire(new performance$1.j(new Error(`Image "${id}" has invalid "stretchX" value`)));
            valid = false;
        }
        if (!this._validateStretch(image.stretchY, data && data.height)) {
            this.fire(new performance$1.j(new Error(`Image "${id}" has invalid "stretchY" value`)));
            valid = false;
        }
        if (!this._validateContent(image.content, image)) {
            this.fire(new performance$1.j(new Error(`Image "${id}" has invalid "content" value`)));
            valid = false;
        }
        return valid;
    }
    _validateStretch(stretch, size) {
        if (!stretch)
            return true;
        let last = 0;
        for (const part of stretch) {
            if (part[0] < last || part[1] < part[0] || size < part[1])
                return false;
            last = part[1];
        }
        return true;
    }
    _validateContent(content, image) {
        if (!content)
            return true;
        if (content.length !== 4)
            return false;
        const spriteData = image.spriteData;
        const width = (spriteData && spriteData.width) || image.data.width;
        const height = (spriteData && spriteData.height) || image.data.height;
        if (content[0] < 0 || width < content[0])
            return false;
        if (content[1] < 0 || height < content[1])
            return false;
        if (content[2] < 0 || width < content[2])
            return false;
        if (content[3] < 0 || height < content[3])
            return false;
        if (content[2] < content[0])
            return false;
        if (content[3] < content[1])
            return false;
        return true;
    }
    updateImage(id, image, validate = true) {
        const oldImage = this.getImage(id);
        if (validate && (oldImage.data.width !== image.data.width || oldImage.data.height !== image.data.height)) {
            throw new Error(`size mismatch between old image (${oldImage.data.width}x${oldImage.data.height}) and new image (${image.data.width}x${image.data.height}).`);
        }
        image.version = oldImage.version + 1;
        this.images[id] = image;
        this.updatedImages[id] = true;
    }
    removeImage(id) {
        const image = this.images[id];
        delete this.images[id];
        delete this.patterns[id];
        if (image.userImage && image.userImage.onRemove) {
            image.userImage.onRemove();
        }
    }
    listImages() {
        return Object.keys(this.images);
    }
    getImages(ids) {
        return new Promise((resolve, _reject) => {
            // If the sprite has been loaded, or if all the icon dependencies are already present
            // (i.e. if they've been added via runtime styling), then notify the requestor immediately.
            // Otherwise, delay notification until the sprite is loaded. At that point, if any of the
            // dependencies are still unavailable, we'll just assume they are permanently missing.
            let hasAllDependencies = true;
            if (!this.isLoaded()) {
                for (const id of ids) {
                    if (!this.images[id]) {
                        hasAllDependencies = false;
                    }
                }
            }
            if (this.isLoaded() || hasAllDependencies) {
                resolve(this._getImagesForIds(ids));
            }
            else {
                this.requestors.push({ ids, promiseResolve: resolve });
            }
        });
    }
    _getImagesForIds(ids) {
        const response = {};
        for (const id of ids) {
            let image = this.getImage(id);
            if (!image) {
                this.fire(new performance$1.k('styleimagemissing', { id }));
                //Try to acquire image again in case styleimagemissing has populated it
                image = this.getImage(id);
            }
            if (image) {
                // Clone the image so that our own copy of its ArrayBuffer doesn't get transferred.
                response[id] = {
                    data: image.data.clone(),
                    pixelRatio: image.pixelRatio,
                    sdf: image.sdf,
                    version: image.version,
                    stretchX: image.stretchX,
                    stretchY: image.stretchY,
                    content: image.content,
                    textFitWidth: image.textFitWidth,
                    textFitHeight: image.textFitHeight,
                    hasRenderCallback: Boolean(image.userImage && image.userImage.render)
                };
            }
            else {
                performance$1.w(`Image "${id}" could not be loaded. Please make sure you have added the image with map.addImage() or a "sprite" property in your style. You can provide missing images by listening for the "styleimagemissing" map event.`);
            }
        }
        return response;
    }
    // Pattern stuff
    getPixelSize() {
        const { width, height } = this.atlasImage;
        return { width, height };
    }
    getPattern(id) {
        const pattern = this.patterns[id];
        const image = this.getImage(id);
        if (!image) {
            return null;
        }
        if (pattern && pattern.position.version === image.version) {
            return pattern.position;
        }
        if (!pattern) {
            const w = image.data.width + padding * 2;
            const h = image.data.height + padding * 2;
            const bin = { w, h, x: 0, y: 0 };
            const position = new performance$1.I(bin, image);
            this.patterns[id] = { bin, position };
        }
        else {
            pattern.position.version = image.version;
        }
        this._updatePatternAtlas();
        return this.patterns[id].position;
    }
    bind(context) {
        const gl = context.gl;
        if (!this.atlasTexture) {
            this.atlasTexture = new Texture(context, this.atlasImage, gl.RGBA);
        }
        else if (this.dirty) {
            this.atlasTexture.update(this.atlasImage);
            this.dirty = false;
        }
        this.atlasTexture.bind(gl.LINEAR, gl.CLAMP_TO_EDGE);
    }
    _updatePatternAtlas() {
        const bins = [];
        for (const id in this.patterns) {
            bins.push(this.patterns[id].bin);
        }
        const { w, h } = performance$1.p(bins);
        const dst = this.atlasImage;
        dst.resize({ width: w || 1, height: h || 1 });
        for (const id in this.patterns) {
            const { bin } = this.patterns[id];
            const x = bin.x + padding;
            const y = bin.y + padding;
            const src = this.getImage(id).data;
            const w = src.width;
            const h = src.height;
            performance$1.R.copy(src, dst, { x: 0, y: 0 }, { x, y }, { width: w, height: h });
            // Add 1 pixel wrapped padding on each side of the image.
            performance$1.R.copy(src, dst, { x: 0, y: h - 1 }, { x, y: y - 1 }, { width: w, height: 1 }); // T
            performance$1.R.copy(src, dst, { x: 0, y: 0 }, { x, y: y + h }, { width: w, height: 1 }); // B
            performance$1.R.copy(src, dst, { x: w - 1, y: 0 }, { x: x - 1, y }, { width: 1, height: h }); // L
            performance$1.R.copy(src, dst, { x: 0, y: 0 }, { x: x + w, y }, { width: 1, height: h }); // R
        }
        this.dirty = true;
    }
    beginFrame() {
        this.callbackDispatchedThisFrame = {};
    }
    dispatchRenderCallbacks(ids) {
        for (const id of ids) {
            // the callback for the image was already dispatched for a different frame
            if (this.callbackDispatchedThisFrame[id])
                continue;
            this.callbackDispatchedThisFrame[id] = true;
            const image = this.getImage(id);
            if (!image)
                performance$1.w(`Image with ID: "${id}" was not found`);
            const updated = renderStyleImage(image);
            if (updated) {
                this.updateImage(id, image);
            }
        }
    }
}

function loadGlyphRange(fontstack, range, urlTemplate, requestManager) {
    return performance$1._(this, void 0, void 0, function* () {
        const begin = range * 256;
        const end = begin + 255;
        const request = requestManager.transformRequest(urlTemplate.replace('{fontstack}', fontstack).replace('{range}', `${begin}-${end}`), "Glyphs" /* ResourceType.Glyphs */);
        const response = yield performance$1.l(request, new AbortController());
        if (!response || !response.data) {
            throw new Error(`Could not load glyph range. range: ${range}, ${begin}-${end}`);
        }
        const glyphs = {};
        for (const glyph of performance$1.n(response.data)) {
            glyphs[glyph.id] = glyph;
        }
        return glyphs;
    });
}

const INF = 1e20;

class TinySDF {
    constructor({
        fontSize = 24,
        buffer = 3,
        radius = 8,
        cutoff = 0.25,
        fontFamily = 'sans-serif',
        fontWeight = 'normal',
        fontStyle = 'normal'
    } = {}) {
        this.buffer = buffer;
        this.cutoff = cutoff;
        this.radius = radius;

        // make the canvas size big enough to both have the specified buffer around the glyph
        // for "halo", and account for some glyphs possibly being larger than their font size
        const size = this.size = fontSize + buffer * 4;

        const canvas = this._createCanvas(size);
        const ctx = this.ctx = canvas.getContext('2d', {willReadFrequently: true});
        ctx.font = `${fontStyle} ${fontWeight} ${fontSize}px ${fontFamily}`;

        ctx.textBaseline = 'alphabetic';
        ctx.textAlign = 'left'; // Necessary so that RTL text doesn't have different alignment
        ctx.fillStyle = 'black';

        // temporary arrays for the distance transform
        this.gridOuter = new Float64Array(size * size);
        this.gridInner = new Float64Array(size * size);
        this.f = new Float64Array(size);
        this.z = new Float64Array(size + 1);
        this.v = new Uint16Array(size);
    }

    _createCanvas(size) {
        const canvas = document.createElement('canvas');
        canvas.width = canvas.height = size;
        return canvas;
    }

    draw(char) {
        const {
            width: glyphAdvance,
            actualBoundingBoxAscent,
            actualBoundingBoxDescent,
            actualBoundingBoxLeft,
            actualBoundingBoxRight
        } = this.ctx.measureText(char);

        // The integer/pixel part of the top alignment is encoded in metrics.glyphTop
        // The remainder is implicitly encoded in the rasterization
        const glyphTop = Math.ceil(actualBoundingBoxAscent);
        const glyphLeft = 0;

        // If the glyph overflows the canvas size, it will be clipped at the bottom/right
        const glyphWidth = Math.max(0, Math.min(this.size - this.buffer, Math.ceil(actualBoundingBoxRight - actualBoundingBoxLeft)));
        const glyphHeight = Math.min(this.size - this.buffer, glyphTop + Math.ceil(actualBoundingBoxDescent));

        const width = glyphWidth + 2 * this.buffer;
        const height = glyphHeight + 2 * this.buffer;

        const len = Math.max(width * height, 0);
        const data = new Uint8ClampedArray(len);
        const glyph = {data, width, height, glyphWidth, glyphHeight, glyphTop, glyphLeft, glyphAdvance};
        if (glyphWidth === 0 || glyphHeight === 0) return glyph;

        const {ctx, buffer, gridInner, gridOuter} = this;
        ctx.clearRect(buffer, buffer, glyphWidth, glyphHeight);
        ctx.fillText(char, buffer, buffer + glyphTop);
        const imgData = ctx.getImageData(buffer, buffer, glyphWidth, glyphHeight);

        // Initialize grids outside the glyph range to alpha 0
        gridOuter.fill(INF, 0, len);
        gridInner.fill(0, 0, len);

        for (let y = 0; y < glyphHeight; y++) {
            for (let x = 0; x < glyphWidth; x++) {
                const a = imgData.data[4 * (y * glyphWidth + x) + 3] / 255; // alpha value
                if (a === 0) continue; // empty pixels

                const j = (y + buffer) * width + x + buffer;

                if (a === 1) { // fully drawn pixels
                    gridOuter[j] = 0;
                    gridInner[j] = INF;

                } else { // aliased pixels
                    const d = 0.5 - a;
                    gridOuter[j] = d > 0 ? d * d : 0;
                    gridInner[j] = d < 0 ? d * d : 0;
                }
            }
        }

        edt(gridOuter, 0, 0, width, height, width, this.f, this.v, this.z);
        edt(gridInner, buffer, buffer, glyphWidth, glyphHeight, width, this.f, this.v, this.z);

        for (let i = 0; i < len; i++) {
            const d = Math.sqrt(gridOuter[i]) - Math.sqrt(gridInner[i]);
            data[i] = Math.round(255 - 255 * (d / this.radius + this.cutoff));
        }

        return glyph;
    }
}

// 2D Euclidean squared distance transform by Felzenszwalb & Huttenlocher https://cs.brown.edu/~pff/papers/dt-final.pdf
function edt(data, x0, y0, width, height, gridSize, f, v, z) {
    for (let x = x0; x < x0 + width; x++) edt1d(data, y0 * gridSize + x, gridSize, height, f, v, z);
    for (let y = y0; y < y0 + height; y++) edt1d(data, y * gridSize + x0, 1, width, f, v, z);
}

// 1D squared distance transform
function edt1d(grid, offset, stride, length, f, v, z) {
    v[0] = 0;
    z[0] = -INF;
    z[1] = INF;
    f[0] = grid[offset];

    for (let q = 1, k = 0, s = 0; q < length; q++) {
        f[q] = grid[offset + q * stride];
        const q2 = q * q;
        do {
            const r = v[k];
            s = (f[q] - f[r] + q2 - r * r) / (q - r) / 2;
        } while (s <= z[k] && --k > -1);

        k++;
        v[k] = q;
        z[k] = s;
        z[k + 1] = INF;
    }

    for (let q = 0, k = 0; q < length; q++) {
        while (z[k + 1] < q) k++;
        const r = v[k];
        const qr = q - r;
        grid[offset + q * stride] = f[r] + qr * qr;
    }
}

class GlyphManager {
    constructor(requestManager, localIdeographFontFamily) {
        this.requestManager = requestManager;
        this.localIdeographFontFamily = localIdeographFontFamily;
        this.entries = {};
    }
    setURL(url) {
        this.url = url;
    }
    getGlyphs(glyphs) {
        return performance$1._(this, void 0, void 0, function* () {
            const glyphsPromises = [];
            for (const stack in glyphs) {
                for (const id of glyphs[stack]) {
                    glyphsPromises.push(this._getAndCacheGlyphsPromise(stack, id));
                }
            }
            const updatedGlyphs = yield Promise.all(glyphsPromises);
            const result = {};
            for (const { stack, id, glyph } of updatedGlyphs) {
                if (!result[stack]) {
                    result[stack] = {};
                }
                // Clone the glyph so that our own copy of its ArrayBuffer doesn't get transferred.
                result[stack][id] = glyph && {
                    id: glyph.id,
                    bitmap: glyph.bitmap.clone(),
                    metrics: glyph.metrics
                };
            }
            return result;
        });
    }
    _getAndCacheGlyphsPromise(stack, id) {
        return performance$1._(this, void 0, void 0, function* () {
            let entry = this.entries[stack];
            if (!entry) {
                entry = this.entries[stack] = {
                    glyphs: {},
                    requests: {},
                    ranges: {}
                };
            }
            let glyph = entry.glyphs[id];
            if (glyph !== undefined) {
                return { stack, id, glyph };
            }
            glyph = this._tinySDF(entry, stack, id);
            if (glyph) {
                entry.glyphs[id] = glyph;
                return { stack, id, glyph };
            }
            const range = Math.floor(id / 256);
            if (range * 256 > 65535) {
                throw new Error('glyphs > 65535 not supported');
            }
            if (entry.ranges[range]) {
                return { stack, id, glyph };
            }
            if (!this.url) {
                throw new Error('glyphsUrl is not set');
            }
            if (!entry.requests[range]) {
                const promise = GlyphManager.loadGlyphRange(stack, range, this.url, this.requestManager);
                entry.requests[range] = promise;
            }
            const response = yield entry.requests[range];
            for (const id in response) {
                if (!this._doesCharSupportLocalGlyph(+id)) {
                    entry.glyphs[+id] = response[+id];
                }
            }
            entry.ranges[range] = true;
            return { stack, id, glyph: response[id] || null };
        });
    }
    _doesCharSupportLocalGlyph(id) {
        /* eslint-disable new-cap */
        return !!this.localIdeographFontFamily &&
            (performance$1.u['CJK Unified Ideographs'](id) ||
                performance$1.u['Hangul Syllables'](id) ||
                performance$1.u['Hiragana'](id) ||
                performance$1.u['Katakana'](id));
        /* eslint-enable new-cap */
    }
    _tinySDF(entry, stack, id) {
        const fontFamily = this.localIdeographFontFamily;
        if (!fontFamily) {
            return;
        }
        if (!this._doesCharSupportLocalGlyph(id)) {
            return;
        }
        // Client-generated glyphs are rendered at 2x texture scale,
        // because CJK glyphs are more detailed than others.
        const textureScale = 2;
        let tinySDF = entry.tinySDF;
        if (!tinySDF) {
            let fontWeight = '400';
            if (/bold/i.test(stack)) {
                fontWeight = '900';
            }
            else if (/medium/i.test(stack)) {
                fontWeight = '500';
            }
            else if (/light/i.test(stack)) {
                fontWeight = '200';
            }
            tinySDF = entry.tinySDF = new GlyphManager.TinySDF({
                fontSize: 24 * textureScale,
                buffer: 3 * textureScale,
                radius: 8 * textureScale,
                cutoff: 0.25,
                fontFamily,
                fontWeight
            });
        }
        const char = tinySDF.draw(String.fromCharCode(id));
        /**
         * TinySDF's "top" is the distance from the alphabetic baseline to the top of the glyph.
         * Server-generated fonts specify "top" relative to an origin above the em box (the origin
         * comes from FreeType, but I'm unclear on exactly how it's derived)
         * ref: https://github.com/mapbox/sdf-glyph-foundry
         *
         * Server fonts don't yet include baseline information, so we can't line up exactly with them
         * (and they don't line up with each other)
         * ref: https://github.com/mapbox/node-fontnik/pull/160
         *
         * To approximately align TinySDF glyphs with server-provided glyphs, we use this baseline adjustment
         * factor calibrated to be in between DIN Pro and Arial Unicode (but closer to Arial Unicode)
         */
        const topAdjustment = 27.5;
        const leftAdjustment = 0.5;
        return {
            id,
            bitmap: new performance$1.o({ width: char.width || 30 * textureScale, height: char.height || 30 * textureScale }, char.data),
            metrics: {
                width: char.glyphWidth / textureScale || 24,
                height: char.glyphHeight / textureScale || 24,
                left: (char.glyphLeft / textureScale + leftAdjustment) || 0,
                top: char.glyphTop / textureScale - topAdjustment || -8,
                advance: char.glyphAdvance / textureScale || 24,
                isDoubleResolution: true
            }
        };
    }
}
// exposed as statics to enable stubbing in unit tests
GlyphManager.loadGlyphRange = loadGlyphRange;
GlyphManager.TinySDF = TinySDF;

class LightPositionProperty {
    constructor() {
        this.specification = performance$1.v.light.position;
    }
    possiblyEvaluate(value, parameters) {
        return performance$1.y(value.expression.evaluate(parameters));
    }
    interpolate(a, b, t) {
        return {
            x: performance$1.z.number(a.x, b.x, t),
            y: performance$1.z.number(a.y, b.y, t),
            z: performance$1.z.number(a.z, b.z, t),
        };
    }
}
const TRANSITION_SUFFIX$1 = '-transition';
let lightProperties;
/*
 * Represents the light used to light extruded features.
 */
class Light extends performance$1.E {
    constructor(lightOptions) {
        super();
        lightProperties = lightProperties || new performance$1.q({
            'anchor': new performance$1.D(performance$1.v.light.anchor),
            'position': new LightPositionProperty(),
            'color': new performance$1.D(performance$1.v.light.color),
            'intensity': new performance$1.D(performance$1.v.light.intensity),
        });
        this._transitionable = new performance$1.T(lightProperties);
        this.setLight(lightOptions);
        this._transitioning = this._transitionable.untransitioned();
    }
    getLight() {
        return this._transitionable.serialize();
    }
    setLight(light, options = {}) {
        if (this._validate(performance$1.r, light, options)) {
            return;
        }
        for (const name in light) {
            const value = light[name];
            if (name.endsWith(TRANSITION_SUFFIX$1)) {
                this._transitionable.setTransition(name.slice(0, -TRANSITION_SUFFIX$1.length), value);
            }
            else {
                this._transitionable.setValue(name, value);
            }
        }
    }
    updateTransitions(parameters) {
        this._transitioning = this._transitionable.transitioned(parameters, this._transitioning);
    }
    hasTransition() {
        return this._transitioning.hasTransition();
    }
    recalculate(parameters) {
        this.properties = this._transitioning.possiblyEvaluate(parameters);
    }
    _validate(validate, value, options) {
        if (options && options.validate === false) {
            return false;
        }
        return performance$1.t(this, validate.call(performance$1.x, {
            value,
            // Workaround for https://github.com/mapbox/mapbox-gl-js/issues/2407
            style: { glyphs: true, sprite: true },
            styleSpec: performance$1.v
        }));
    }
}

const properties = new performance$1.q({
    'sky-color': new performance$1.D(performance$1.v.sky['sky-color']),
    'horizon-color': new performance$1.D(performance$1.v.sky['horizon-color']),
    'fog-color': new performance$1.D(performance$1.v.sky['fog-color']),
    'fog-ground-blend': new performance$1.D(performance$1.v.sky['fog-ground-blend']),
    'horizon-fog-blend': new performance$1.D(performance$1.v.sky['horizon-fog-blend']),
    'sky-horizon-blend': new performance$1.D(performance$1.v.sky['sky-horizon-blend']),
    'atmosphere-blend': new performance$1.D(performance$1.v.sky['atmosphere-blend'])
});
const TRANSITION_SUFFIX = '-transition';
class Sky extends performance$1.E {
    constructor(sky) {
        super();
        this._transitionable = new performance$1.T(properties);
        this.setSky(sky);
        this._transitioning = this._transitionable.untransitioned();
    }
    setSky(sky, options = {}) {
        if (this._validate(performance$1.B, sky, options))
            return;
        for (const name in sky) {
            const value = sky[name];
            if (name.endsWith(TRANSITION_SUFFIX)) {
                this._transitionable.setTransition(name.slice(0, -TRANSITION_SUFFIX.length), value);
            }
            else {
                this._transitionable.setValue(name, value);
            }
        }
    }
    getSky() {
        return this._transitionable.serialize();
    }
    updateTransitions(parameters) {
        this._transitioning = this._transitionable.transitioned(parameters, this._transitioning);
    }
    hasTransition() {
        return this._transitioning.hasTransition();
    }
    recalculate(parameters) {
        this.properties = this._transitioning.possiblyEvaluate(parameters);
    }
    _validate(validate, value, options = {}) {
        if ((options === null || options === void 0 ? void 0 : options.validate) === false) {
            return false;
        }
        return performance$1.t(this, validate.call(performance$1.x, performance$1.e({
            value,
            // Workaround for https://github.com/mapbox/mapbox-gl-js/issues/2407
            style: { glyphs: true, sprite: true },
            styleSpec: performance$1.v
        })));
    }
    /**
     * Currently fog is a very simple implementation, and should only used
     * to create an atmosphere near the horizon.
     * But because the fog is drawn from the far-clipping-plane to
     * map-center, and because the fog does nothing know about the horizon,
     * this method does a fadeout in respect of pitch. So, when the horizon
     * gets out of view, which is at about pitch 70, this methods calculates
     * the corresponding opacity values. Below pitch 60 the fog is completely
     * invisible.
     */
    calculateFogBlendOpacity(pitch) {
        if (pitch < 60)
            return 0; // disable
        if (pitch < 70)
            return (pitch - 60) / 10; // fade in
        return 1;
    }
}

/**
 * @internal
 * A LineAtlas lets us reuse rendered dashed lines
 * by writing many of them to a texture and then fetching their positions
 * using {@link LineAtlas#getDash}.
 *
 * @param width - the width
 * @param height - the height
 */
class LineAtlas {
    constructor(width, height) {
        this.width = width;
        this.height = height;
        this.nextRow = 0;
        this.data = new Uint8Array(this.width * this.height);
        this.dashEntry = {};
    }
    /**
     * Get or create a dash line pattern.
     *
     * @param dasharray - the key (represented by numbers) to get the dash texture
     * @param round - whether to add circle caps in between dash segments
     * @returns position of dash texture in {@link DashEntry}
     */
    getDash(dasharray, round) {
        const key = dasharray.join(',') + String(round);
        if (!this.dashEntry[key]) {
            this.dashEntry[key] = this.addDash(dasharray, round);
        }
        return this.dashEntry[key];
    }
    getDashRanges(dasharray, lineAtlasWidth, stretch) {
        // If dasharray has an odd length, both the first and last parts
        // are dashes and should be joined seamlessly.
        const oddDashArray = dasharray.length % 2 === 1;
        const ranges = [];
        let left = oddDashArray ? -dasharray[dasharray.length - 1] * stretch : 0;
        let right = dasharray[0] * stretch;
        let isDash = true;
        ranges.push({ left, right, isDash, zeroLength: dasharray[0] === 0 });
        let currentDashLength = dasharray[0];
        for (let i = 1; i < dasharray.length; i++) {
            isDash = !isDash;
            const dashLength = dasharray[i];
            left = currentDashLength * stretch;
            currentDashLength += dashLength;
            right = currentDashLength * stretch;
            ranges.push({ left, right, isDash, zeroLength: dashLength === 0 });
        }
        return ranges;
    }
    addRoundDash(ranges, stretch, n) {
        const halfStretch = stretch / 2;
        for (let y = -n; y <= n; y++) {
            const row = this.nextRow + n + y;
            const index = this.width * row;
            let currIndex = 0;
            let range = ranges[currIndex];
            for (let x = 0; x < this.width; x++) {
                if (x / range.right > 1) {
                    range = ranges[++currIndex];
                }
                const distLeft = Math.abs(x - range.left);
                const distRight = Math.abs(x - range.right);
                const minDist = Math.min(distLeft, distRight);
                let signedDistance;
                const distMiddle = y / n * (halfStretch + 1);
                if (range.isDash) {
                    const distEdge = halfStretch - Math.abs(distMiddle);
                    signedDistance = Math.sqrt(minDist * minDist + distEdge * distEdge);
                }
                else {
                    signedDistance = halfStretch - Math.sqrt(minDist * minDist + distMiddle * distMiddle);
                }
                this.data[index + x] = Math.max(0, Math.min(255, signedDistance + 128));
            }
        }
    }
    addRegularDash(ranges) {
        // Collapse any zero-length range
        // Collapse neighbouring same-type parts into a single part
        for (let i = ranges.length - 1; i >= 0; --i) {
            const part = ranges[i];
            const next = ranges[i + 1];
            if (part.zeroLength) {
                ranges.splice(i, 1);
            }
            else if (next && next.isDash === part.isDash) {
                next.left = part.left;
                ranges.splice(i, 1);
            }
        }
        // Combine the first and last parts if possible
        const first = ranges[0];
        const last = ranges[ranges.length - 1];
        if (first.isDash === last.isDash) {
            first.left = last.left - this.width;
            last.right = first.right + this.width;
        }
        const index = this.width * this.nextRow;
        let currIndex = 0;
        let range = ranges[currIndex];
        for (let x = 0; x < this.width; x++) {
            if (x / range.right > 1) {
                range = ranges[++currIndex];
            }
            const distLeft = Math.abs(x - range.left);
            const distRight = Math.abs(x - range.right);
            const minDist = Math.min(distLeft, distRight);
            const signedDistance = range.isDash ? minDist : -minDist;
            this.data[index + x] = Math.max(0, Math.min(255, signedDistance + 128));
        }
    }
    addDash(dasharray, round) {
        const n = round ? 7 : 0;
        const height = 2 * n + 1;
        if (this.nextRow + height > this.height) {
            performance$1.w('LineAtlas out of space');
            return null;
        }
        let length = 0;
        for (let i = 0; i < dasharray.length; i++) {
            length += dasharray[i];
        }
        if (length !== 0) {
            const stretch = this.width / length;
            const ranges = this.getDashRanges(dasharray, this.width, stretch);
            if (round) {
                this.addRoundDash(ranges, stretch, n);
            }
            else {
                this.addRegularDash(ranges);
            }
        }
        const dashEntry = {
            y: (this.nextRow + n + 0.5) / this.height,
            height: 2 * n / this.height,
            width: length
        };
        this.nextRow += height;
        this.dirty = true;
        return dashEntry;
    }
    bind(context) {
        const gl = context.gl;
        if (!this.texture) {
            this.texture = gl.createTexture();
            gl.bindTexture(gl.TEXTURE_2D, this.texture);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.REPEAT);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.REPEAT);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
            gl.texImage2D(gl.TEXTURE_2D, 0, gl.ALPHA, this.width, this.height, 0, gl.ALPHA, gl.UNSIGNED_BYTE, this.data);
        }
        else {
            gl.bindTexture(gl.TEXTURE_2D, this.texture);
            if (this.dirty) {
                this.dirty = false;
                gl.texSubImage2D(gl.TEXTURE_2D, 0, 0, 0, this.width, this.height, gl.ALPHA, gl.UNSIGNED_BYTE, this.data);
            }
        }
    }
}

function workerFactory() {
    return new Worker(performance$1.a.WORKER_URL);
}

const PRELOAD_POOL_ID = 'maplibre_preloaded_worker_pool';
/**
 * Constructs a worker pool.
 */
class WorkerPool {
    constructor() {
        this.active = {};
    }
    acquire(mapId) {
        if (!this.workers) {
            // Lazily look up the value of getWorkerCount so that
            // client code has had a chance to set it.
            this.workers = [];
            while (this.workers.length < WorkerPool.workerCount) {
                this.workers.push(workerFactory());
            }
        }
        this.active[mapId] = true;
        return this.workers.slice();
    }
    release(mapId) {
        delete this.active[mapId];
        if (this.numActive() === 0) {
            this.workers.forEach((w) => {
                w.terminate();
            });
            this.workers = null;
        }
    }
    isPreloaded() {
        return !!this.active[PRELOAD_POOL_ID];
    }
    numActive() {
        return Object.keys(this.active).length;
    }
}
// Based on results from A/B testing: https://github.com/maplibre/maplibre-gl-js/pull/2354
const availableLogicalProcessors = Math.floor(browser.hardwareConcurrency / 2);
WorkerPool.workerCount = performance$1.C(globalThis) ? Math.max(Math.min(availableLogicalProcessors, 3), 1) : 1;

let globalWorkerPool;
/**
 * Creates (if necessary) and returns the single, global WorkerPool instance
 * to be shared across each Map
 */
function getGlobalWorkerPool() {
    if (!globalWorkerPool) {
        globalWorkerPool = new WorkerPool();
    }
    return globalWorkerPool;
}
/**
 * Initializes resources like WebWorkers that can be shared across maps to lower load
 * times in some situations. `setWorkerUrl()` and `setWorkerCount()`, if being
 * used, must be set before `prewarm()` is called to have an effect.
 *
 * By default, the lifecycle of these resources is managed automatically, and they are
 * lazily initialized when a Map is first created. By invoking `prewarm()`, these
 * resources will be created ahead of time, and will not be cleared when the last Map
 * is removed from the page. This allows them to be re-used by new Map instances that
 * are created later. They can be manually cleared by calling
 * `clearPrewarmedResources()`. This is only necessary if your web page remains
 * active but stops using maps altogether.
 *
 * This is primarily useful when using GL-JS maps in a single page app, wherein a user
 * would navigate between various views that can cause Map instances to constantly be
 * created and destroyed.
 *
 * @example
 * ```ts
 * prewarm()
 * ```
 */
function prewarm() {
    const workerPool = getGlobalWorkerPool();
    workerPool.acquire(PRELOAD_POOL_ID);
}
/**
 * Clears up resources that have previously been created by `prewarm()`.
 * Note that this is typically not necessary. You should only call this function
 * if you expect the user of your app to not return to a Map view at any point
 * in your application.
 *
 * @example
 * ```ts
 * clearPrewarmedResources()
 * ```
 */
function clearPrewarmedResources() {
    const pool = globalWorkerPool;
    if (pool) {
        // Remove the pool only if all maps that referenced the preloaded global worker pool have been removed.
        if (pool.isPreloaded() && pool.numActive() === 1) {
            pool.release(PRELOAD_POOL_ID);
            globalWorkerPool = null;
        }
        else {
            console.warn('Could not clear WebWorkers since there are active Map instances that still reference it. The pre-warmed WebWorker pool can only be cleared when all map instances have been removed with map.remove()');
        }
    }
}

/**
 * Responsible for sending messages from a {@link Source} to an associated
 * {@link WorkerSource}.
 */
class Dispatcher {
    constructor(workerPool, mapId) {
        this.workerPool = workerPool;
        this.actors = [];
        this.currentActor = 0;
        this.id = mapId;
        const workers = this.workerPool.acquire(mapId);
        for (let i = 0; i < workers.length; i++) {
            const worker = workers[i];
            const actor = new performance$1.F(worker, mapId);
            actor.name = `Worker ${i}`;
            this.actors.push(actor);
        }
        if (!this.actors.length)
            throw new Error('No actors found');
    }
    /**
     * Broadcast a message to all Workers.
     */
    broadcast(type, data) {
        const promises = [];
        for (const actor of this.actors) {
            promises.push(actor.sendAsync({ type, data }));
        }
        return Promise.all(promises);
    }
    /**
     * Acquires an actor to dispatch messages to. The actors are distributed in round-robin fashion.
     * @returns An actor object backed by a web worker for processing messages.
     */
    getActor() {
        this.currentActor = (this.currentActor + 1) % this.actors.length;
        return this.actors[this.currentActor];
    }
    remove(mapRemoved = true) {
        this.actors.forEach((actor) => { actor.remove(); });
        this.actors = [];
        if (mapRemoved)
            this.workerPool.release(this.id);
    }
    registerMessageHandler(type, handler) {
        for (const actor of this.actors) {
            actor.registerMessageHandler(type, handler);
        }
    }
}
let globalDispatcher;
function getGlobalDispatcher() {
    if (!globalDispatcher) {
        globalDispatcher = new Dispatcher(getGlobalWorkerPool(), performance$1.G);
        globalDispatcher.registerMessageHandler("GR" /* MessageType.getResource */, (_mapId, params, abortController) => {
            return performance$1.m(params, abortController);
        });
    }
    return globalDispatcher;
}

/*
 * Returns a matrix that can be used to convert from tile coordinates to viewport pixel coordinates.
 */
function getPixelPosMatrix(transform, tileID) {
    const t = performance$1.H();
    performance$1.J(t, t, [1, 1, 0]);
    performance$1.K(t, t, [transform.width * 0.5, transform.height * 0.5, 1]);
    return performance$1.L(t, t, transform.calculatePosMatrix(tileID.toUnwrapped()));
}
function queryIncludes3DLayer(layers, styleLayers, sourceID) {
    if (layers) {
        for (const layerID of layers) {
            const layer = styleLayers[layerID];
            if (layer && layer.source === sourceID && layer.type === 'fill-extrusion') {
                return true;
            }
        }
    }
    else {
        for (const key in styleLayers) {
            const layer = styleLayers[key];
            if (layer.source === sourceID && layer.type === 'fill-extrusion') {
                return true;
            }
        }
    }
    return false;
}
function queryRenderedFeatures(sourceCache, styleLayers, serializedLayers, queryGeometry, params, transform) {
    const has3DLayer = queryIncludes3DLayer(params && params.layers, styleLayers, sourceCache.id);
    const maxPitchScaleFactor = transform.maxPitchScaleFactor();
    const tilesIn = sourceCache.tilesIn(queryGeometry, maxPitchScaleFactor, has3DLayer);
    tilesIn.sort(sortTilesIn);
    const renderedFeatureLayers = [];
    for (const tileIn of tilesIn) {
        renderedFeatureLayers.push({
            wrappedTileID: tileIn.tileID.wrapped().key,
            queryResults: tileIn.tile.queryRenderedFeatures(styleLayers, serializedLayers, sourceCache._state, tileIn.queryGeometry, tileIn.cameraQueryGeometry, tileIn.scale, params, transform, maxPitchScaleFactor, getPixelPosMatrix(sourceCache.transform, tileIn.tileID))
        });
    }
    const result = mergeRenderedFeatureLayers(renderedFeatureLayers);
    // Merge state from SourceCache into the results
    for (const layerID in result) {
        result[layerID].forEach((featureWrapper) => {
            const feature = featureWrapper.feature;
            const state = sourceCache.getFeatureState(feature.layer['source-layer'], feature.id);
            feature.source = feature.layer.source;
            if (feature.layer['source-layer']) {
                feature.sourceLayer = feature.layer['source-layer'];
            }
            feature.state = state;
        });
    }
    return result;
}
function queryRenderedSymbols(styleLayers, serializedLayers, sourceCaches, queryGeometry, params, collisionIndex, retainedQueryData) {
    const result = {};
    const renderedSymbols = collisionIndex.queryRenderedSymbols(queryGeometry);
    const bucketQueryData = [];
    for (const bucketInstanceId of Object.keys(renderedSymbols).map(Number)) {
        bucketQueryData.push(retainedQueryData[bucketInstanceId]);
    }
    bucketQueryData.sort(sortTilesIn);
    for (const queryData of bucketQueryData) {
        const bucketSymbols = queryData.featureIndex.lookupSymbolFeatures(renderedSymbols[queryData.bucketInstanceId], serializedLayers, queryData.bucketIndex, queryData.sourceLayerIndex, params.filter, params.layers, params.availableImages, styleLayers);
        for (const layerID in bucketSymbols) {
            const resultFeatures = result[layerID] = result[layerID] || [];
            const layerSymbols = bucketSymbols[layerID];
            layerSymbols.sort((a, b) => {
                // Match topDownFeatureComparator from FeatureIndex, but using
                // most recent sorting of features from bucket.sortFeatures
                const featureSortOrder = queryData.featureSortOrder;
                if (featureSortOrder) {
                    // queryRenderedSymbols documentation says we'll return features in
                    // "top-to-bottom" rendering order (aka last-to-first).
                    // Actually there can be multiple symbol instances per feature, so
                    // we sort each feature based on the first matching symbol instance.
                    const sortedA = featureSortOrder.indexOf(a.featureIndex);
                    const sortedB = featureSortOrder.indexOf(b.featureIndex);
                    return sortedB - sortedA;
                }
                else {
                    // Bucket hasn't been re-sorted based on angle, so use the
                    // reverse of the order the features appeared in the data.
                    return b.featureIndex - a.featureIndex;
                }
            });
            for (const symbolFeature of layerSymbols) {
                resultFeatures.push(symbolFeature);
            }
        }
    }
    // Merge state from SourceCache into the results
    for (const layerName in result) {
        result[layerName].forEach((featureWrapper) => {
            const feature = featureWrapper.feature;
            const layer = styleLayers[layerName];
            const sourceCache = sourceCaches[layer.source];
            const state = sourceCache.getFeatureState(feature.layer['source-layer'], feature.id);
            feature.source = feature.layer.source;
            if (feature.layer['source-layer']) {
                feature.sourceLayer = feature.layer['source-layer'];
            }
            feature.state = state;
        });
    }
    return result;
}
function querySourceFeatures(sourceCache, params) {
    const tiles = sourceCache.getRenderableIds().map((id) => {
        return sourceCache.getTileByID(id);
    });
    const result = [];
    const dataTiles = {};
    for (let i = 0; i < tiles.length; i++) {
        const tile = tiles[i];
        const dataID = tile.tileID.canonical.key;
        if (!dataTiles[dataID]) {
            dataTiles[dataID] = true;
            tile.querySourceFeatures(result, params);
        }
    }
    return result;
}
function sortTilesIn(a, b) {
    const idA = a.tileID;
    const idB = b.tileID;
    return (idA.overscaledZ - idB.overscaledZ) || (idA.canonical.y - idB.canonical.y) || (idA.wrap - idB.wrap) || (idA.canonical.x - idB.canonical.x);
}
function mergeRenderedFeatureLayers(tiles) {
    // Merge results from all tiles, but if two tiles share the same
    // wrapped ID, don't duplicate features between the two tiles
    const result = {};
    const wrappedIDLayerMap = {};
    for (const tile of tiles) {
        const queryResults = tile.queryResults;
        const wrappedID = tile.wrappedTileID;
        const wrappedIDLayers = wrappedIDLayerMap[wrappedID] = wrappedIDLayerMap[wrappedID] || {};
        for (const layerID in queryResults) {
            const tileFeatures = queryResults[layerID];
            const wrappedIDFeatures = wrappedIDLayers[layerID] = wrappedIDLayers[layerID] || {};
            const resultFeatures = result[layerID] = result[layerID] || [];
            for (const tileFeature of tileFeatures) {
                if (!wrappedIDFeatures[tileFeature.featureIndex]) {
                    wrappedIDFeatures[tileFeature.featureIndex] = true;
                    resultFeatures.push(tileFeature);
                }
            }
        }
    }
    return result;
}

function loadTileJson(options, requestManager, abortController) {
    return performance$1._(this, void 0, void 0, function* () {
        let tileJSON = options;
        if (options.url) {
            const response = yield performance$1.h(requestManager.transformRequest(options.url, "Source" /* ResourceType.Source */), abortController);
            tileJSON = response.data;
        }
        else {
            yield browser.frameAsync(abortController);
        }
        if (!tileJSON) {
            return null;
        }
        const result = performance$1.M(
        // explicit source options take precedence over TileJSON
        performance$1.e(tileJSON, options), ['tiles', 'minzoom', 'maxzoom', 'attribution', 'bounds', 'scheme', 'tileSize', 'encoding']);
        if ('vector_layers' in tileJSON && tileJSON.vector_layers) {
            result.vectorLayerIds = tileJSON.vector_layers.map((layer) => { return layer.id; });
        }
        return result;
    });
}

/**
 * A `LngLatBounds` object represents a geographical bounding box,
 * defined by its southwest and northeast points in longitude and latitude.
 *
 * If no arguments are provided to the constructor, a `null` bounding box is created.
 *
 * Note that any Mapbox GL method that accepts a `LngLatBounds` object as an argument or option
 * can also accept an `Array` of two {@link LngLatLike} constructs and will perform an implicit conversion.
 * This flexible type is documented as {@link LngLatBoundsLike}.
 *
 * @group Geography and Geometry
 *
 * @example
 * ```ts
 * let sw = new LngLat(-73.9876, 40.7661);
 * let ne = new LngLat(-73.9397, 40.8002);
 * let llb = new LngLatBounds(sw, ne);
 * ```
 */
class LngLatBounds {
    /**
     * @param sw - The southwest corner of the bounding box.
     * OR array of 4 numbers in the order of  west, south, east, north
     * OR array of 2 LngLatLike: [sw,ne]
     * @param ne - The northeast corner of the bounding box.
     * @example
     * ```ts
     * let sw = new LngLat(-73.9876, 40.7661);
     * let ne = new LngLat(-73.9397, 40.8002);
     * let llb = new LngLatBounds(sw, ne);
     * ```
     * OR
     * ```ts
     * let llb = new LngLatBounds([-73.9876, 40.7661, -73.9397, 40.8002]);
     * ```
     * OR
     * ```ts
     * let llb = new LngLatBounds([sw, ne]);
     * ```
     */
    constructor(sw, ne) {
        if (!sw) ;
        else if (ne) {
            this.setSouthWest(sw).setNorthEast(ne);
        }
        else if (Array.isArray(sw)) {
            if (sw.length === 4) {
                // 4 element array: west, south, east, north
                this.setSouthWest([sw[0], sw[1]]).setNorthEast([sw[2], sw[3]]);
            }
            else {
                this.setSouthWest(sw[0]).setNorthEast(sw[1]);
            }
        }
    }
    /**
     * Set the northeast corner of the bounding box
     *
     * @param ne - a {@link LngLatLike} object describing the northeast corner of the bounding box.
     */
    setNorthEast(ne) {
        this._ne = ne instanceof performance$1.N ? new performance$1.N(ne.lng, ne.lat) : performance$1.N.convert(ne);
        return this;
    }
    /**
     * Set the southwest corner of the bounding box
     *
     * @param sw - a {@link LngLatLike} object describing the southwest corner of the bounding box.
     */
    setSouthWest(sw) {
        this._sw = sw instanceof performance$1.N ? new performance$1.N(sw.lng, sw.lat) : performance$1.N.convert(sw);
        return this;
    }
    /**
     * Extend the bounds to include a given LngLatLike or LngLatBoundsLike.
     *
     * @param obj - object to extend to
     */
    extend(obj) {
        const sw = this._sw, ne = this._ne;
        let sw2, ne2;
        if (obj instanceof performance$1.N) {
            sw2 = obj;
            ne2 = obj;
        }
        else if (obj instanceof LngLatBounds) {
            sw2 = obj._sw;
            ne2 = obj._ne;
            if (!sw2 || !ne2)
                return this;
        }
        else {
            if (Array.isArray(obj)) {
                if (obj.length === 4 || obj.every(Array.isArray)) {
                    const lngLatBoundsObj = obj;
                    return this.extend(LngLatBounds.convert(lngLatBoundsObj));
                }
                else {
                    const lngLatObj = obj;
                    return this.extend(performance$1.N.convert(lngLatObj));
                }
            }
            else if (obj && ('lng' in obj || 'lon' in obj) && 'lat' in obj) {
                return this.extend(performance$1.N.convert(obj));
            }
            return this;
        }
        if (!sw && !ne) {
            this._sw = new performance$1.N(sw2.lng, sw2.lat);
            this._ne = new performance$1.N(ne2.lng, ne2.lat);
        }
        else {
            sw.lng = Math.min(sw2.lng, sw.lng);
            sw.lat = Math.min(sw2.lat, sw.lat);
            ne.lng = Math.max(ne2.lng, ne.lng);
            ne.lat = Math.max(ne2.lat, ne.lat);
        }
        return this;
    }
    /**
     * Returns the geographical coordinate equidistant from the bounding box's corners.
     *
     * @returns The bounding box's center.
     * @example
     * ```ts
     * let llb = new LngLatBounds([-73.9876, 40.7661], [-73.9397, 40.8002]);
     * llb.getCenter(); // = LngLat {lng: -73.96365, lat: 40.78315}
     * ```
     */
    getCenter() {
        return new performance$1.N((this._sw.lng + this._ne.lng) / 2, (this._sw.lat + this._ne.lat) / 2);
    }
    /**
     * Returns the southwest corner of the bounding box.
     *
     * @returns The southwest corner of the bounding box.
     */
    getSouthWest() { return this._sw; }
    /**
     * Returns the northeast corner of the bounding box.
     *
     * @returns The northeast corner of the bounding box.
     */
    getNorthEast() { return this._ne; }
    /**
     * Returns the northwest corner of the bounding box.
     *
     * @returns The northwest corner of the bounding box.
     */
    getNorthWest() { return new performance$1.N(this.getWest(), this.getNorth()); }
    /**
     * Returns the southeast corner of the bounding box.
     *
     * @returns The southeast corner of the bounding box.
     */
    getSouthEast() { return new performance$1.N(this.getEast(), this.getSouth()); }
    /**
     * Returns the west edge of the bounding box.
     *
     * @returns The west edge of the bounding box.
     */
    getWest() { return this._sw.lng; }
    /**
     * Returns the south edge of the bounding box.
     *
     * @returns The south edge of the bounding box.
     */
    getSouth() { return this._sw.lat; }
    /**
     * Returns the east edge of the bounding box.
     *
     * @returns The east edge of the bounding box.
     */
    getEast() { return this._ne.lng; }
    /**
     * Returns the north edge of the bounding box.
     *
     * @returns The north edge of the bounding box.
     */
    getNorth() { return this._ne.lat; }
    /**
     * Returns the bounding box represented as an array.
     *
     * @returns The bounding box represented as an array, consisting of the
     * southwest and northeast coordinates of the bounding represented as arrays of numbers.
     * @example
     * ```ts
     * let llb = new LngLatBounds([-73.9876, 40.7661], [-73.9397, 40.8002]);
     * llb.toArray(); // = [[-73.9876, 40.7661], [-73.9397, 40.8002]]
     * ```
     */
    toArray() {
        return [this._sw.toArray(), this._ne.toArray()];
    }
    /**
     * Return the bounding box represented as a string.
     *
     * @returns The bounding box represents as a string of the format
     * `'LngLatBounds(LngLat(lng, lat), LngLat(lng, lat))'`.
     * @example
     * ```ts
     * let llb = new LngLatBounds([-73.9876, 40.7661], [-73.9397, 40.8002]);
     * llb.toString(); // = "LngLatBounds(LngLat(-73.9876, 40.7661), LngLat(-73.9397, 40.8002))"
     * ```
     */
    toString() {
        return `LngLatBounds(${this._sw.toString()}, ${this._ne.toString()})`;
    }
    /**
     * Check if the bounding box is an empty/`null`-type box.
     *
     * @returns True if bounds have been defined, otherwise false.
     */
    isEmpty() {
        return !(this._sw && this._ne);
    }
    /**
     * Check if the point is within the bounding box.
     *
     * @param lnglat - geographic point to check against.
     * @returns `true` if the point is within the bounding box.
     * @example
     * ```ts
     * let llb = new LngLatBounds(
     *   new LngLat(-73.9876, 40.7661),
     *   new LngLat(-73.9397, 40.8002)
     * );
     *
     * let ll = new LngLat(-73.9567, 40.7789);
     *
     * console.log(llb.contains(ll)); // = true
     * ```
     */
    contains(lnglat) {
        const { lng, lat } = performance$1.N.convert(lnglat);
        const containsLatitude = this._sw.lat <= lat && lat <= this._ne.lat;
        let containsLongitude = this._sw.lng <= lng && lng <= this._ne.lng;
        if (this._sw.lng > this._ne.lng) { // wrapped coordinates
            containsLongitude = this._sw.lng >= lng && lng >= this._ne.lng;
        }
        return containsLatitude && containsLongitude;
    }
    /**
     * Converts an array to a `LngLatBounds` object.
     *
     * If a `LngLatBounds` object is passed in, the function returns it unchanged.
     *
     * Internally, the function calls `LngLat#convert` to convert arrays to `LngLat` values.
     *
     * @param input - An array of two coordinates to convert, or a `LngLatBounds` object to return.
     * @returns A new `LngLatBounds` object, if a conversion occurred, or the original `LngLatBounds` object.
     * @example
     * ```ts
     * let arr = [[-73.9876, 40.7661], [-73.9397, 40.8002]];
     * let llb = LngLatBounds.convert(arr); // = LngLatBounds {_sw: LngLat {lng: -73.9876, lat: 40.7661}, _ne: LngLat {lng: -73.9397, lat: 40.8002}}
     * ```
     */
    static convert(input) {
        if (input instanceof LngLatBounds)
            return input;
        if (!input)
            return input;
        return new LngLatBounds(input);
    }
    /**
     * Returns a `LngLatBounds` from the coordinates extended by a given `radius`. The returned `LngLatBounds` completely contains the `radius`.
     *
     * @param center - center coordinates of the new bounds.
     * @param radius - Distance in meters from the coordinates to extend the bounds.
     * @returns A new `LngLatBounds` object representing the coordinates extended by the `radius`.
     * @example
     * ```ts
     * let center = new LngLat(-73.9749, 40.7736);
     * LngLatBounds.fromLngLat(100).toArray(); // = [[-73.97501862141328, 40.77351016847229], [-73.97478137858673, 40.77368983152771]]
     * ```
     */
    static fromLngLat(center, radius = 0) {
        const earthCircumferenceInMetersAtEquator = 40075017;
        const latAccuracy = 360 * radius / earthCircumferenceInMetersAtEquator, lngAccuracy = latAccuracy / Math.cos((Math.PI / 180) * center.lat);
        return new LngLatBounds(new performance$1.N(center.lng - lngAccuracy, center.lat - latAccuracy), new performance$1.N(center.lng + lngAccuracy, center.lat + latAccuracy));
    }
}

class TileBounds {
    constructor(bounds, minzoom, maxzoom) {
        this.bounds = LngLatBounds.convert(this.validateBounds(bounds));
        this.minzoom = minzoom || 0;
        this.maxzoom = maxzoom || 24;
    }
    validateBounds(bounds) {
        // make sure the bounds property contains valid longitude and latitudes
        if (!Array.isArray(bounds) || bounds.length !== 4)
            return [-180, -90, 180, 90];
        return [Math.max(-180, bounds[0]), Math.max(-90, bounds[1]), Math.min(180, bounds[2]), Math.min(90, bounds[3])];
    }
    contains(tileID) {
        const worldSize = Math.pow(2, tileID.z);
        const level = {
            minX: Math.floor(performance$1.O(this.bounds.getWest()) * worldSize),
            minY: Math.floor(performance$1.Q(this.bounds.getNorth()) * worldSize),
            maxX: Math.ceil(performance$1.O(this.bounds.getEast()) * worldSize),
            maxY: Math.ceil(performance$1.Q(this.bounds.getSouth()) * worldSize)
        };
        const hit = tileID.x >= level.minX && tileID.x < level.maxX && tileID.y >= level.minY && tileID.y < level.maxY;
        return hit;
    }
}

/**
 * A source containing vector tiles in [Mapbox Vector Tile format](https://docs.mapbox.com/vector-tiles/reference/).
 * (See the [Style Specification](https://maplibre.org/maplibre-style-spec/) for detailed documentation of options.)
 *
 * @group Sources
 *
 * @example
 * ```ts
 * map.addSource('some id', {
 *     type: 'vector',
 *     url: 'https://demotiles.maplibre.org/tiles/tiles.json'
 * });
 * ```
 *
 * @example
 * ```ts
 * map.addSource('some id', {
 *     type: 'vector',
 *     tiles: ['https://d25uarhxywzl1j.cloudfront.net/v0.1/{z}/{x}/{y}.mvt'],
 *     minzoom: 6,
 *     maxzoom: 14
 * });
 * ```
 *
 * @example
 * ```ts
 * map.getSource('some id').setUrl("https://demotiles.maplibre.org/tiles/tiles.json");
 * ```
 *
 * @example
 * ```ts
 * map.getSource('some id').setTiles(['https://d25uarhxywzl1j.cloudfront.net/v0.1/{z}/{x}/{y}.mvt']);
 * ```
 * @see [Add a vector tile source](https://maplibre.org/maplibre-gl-js/docs/examples/vector-source/)
 */
class VectorTileSource extends performance$1.E {
    constructor(id, options, dispatcher, eventedParent) {
        super();
        this.id = id;
        this.dispatcher = dispatcher;
        this.type = 'vector';
        this.minzoom = 0;
        this.maxzoom = 22;
        this.scheme = 'xyz';
        this.tileSize = 512;
        this.reparseOverscaled = true;
        this.isTileClipped = true;
        this._loaded = false;
        performance$1.e(this, performance$1.M(options, ['url', 'scheme', 'tileSize', 'promoteId']));
        this._options = performance$1.e({ type: 'vector' }, options);
        this._collectResourceTiming = options.collectResourceTiming;
        if (this.tileSize !== 512) {
            throw new Error('vector tile sources must have a tileSize of 512');
        }
        this.setEventedParent(eventedParent);
    }
    load() {
        return performance$1._(this, void 0, void 0, function* () {
            this._loaded = false;
            this.fire(new performance$1.k('dataloading', { dataType: 'source' }));
            this._tileJSONRequest = new AbortController();
            try {
                const tileJSON = yield loadTileJson(this._options, this.map._requestManager, this._tileJSONRequest);
                this._tileJSONRequest = null;
                this._loaded = true;
                this.map.style.sourceCaches[this.id].clearTiles();
                if (tileJSON) {
                    performance$1.e(this, tileJSON);
                    if (tileJSON.bounds)
                        this.tileBounds = new TileBounds(tileJSON.bounds, this.minzoom, this.maxzoom);
                    // `content` is included here to prevent a race condition where `Style#_updateSources` is called
                    // before the TileJSON arrives. this makes sure the tiles needed are loaded once TileJSON arrives
                    // ref: https://github.com/mapbox/mapbox-gl-js/pull/4347#discussion_r104418088
                    this.fire(new performance$1.k('data', { dataType: 'source', sourceDataType: 'metadata' }));
                    this.fire(new performance$1.k('data', { dataType: 'source', sourceDataType: 'content' }));
                }
            }
            catch (err) {
                this._tileJSONRequest = null;
                this.fire(new performance$1.j(err));
            }
        });
    }
    loaded() {
        return this._loaded;
    }
    hasTile(tileID) {
        return !this.tileBounds || this.tileBounds.contains(tileID.canonical);
    }
    onAdd(map) {
        this.map = map;
        this.load();
    }
    setSourceProperty(callback) {
        if (this._tileJSONRequest) {
            this._tileJSONRequest.abort();
        }
        callback();
        this.load();
    }
    /**
     * Sets the source `tiles` property and re-renders the map.
     *
     * @param tiles - An array of one or more tile source URLs, as in the TileJSON spec.
     */
    setTiles(tiles) {
        this.setSourceProperty(() => {
            this._options.tiles = tiles;
        });
        return this;
    }
    /**
     * Sets the source `url` property and re-renders the map.
     *
     * @param url - A URL to a TileJSON resource. Supported protocols are `http:` and `https:`.
     */
    setUrl(url) {
        this.setSourceProperty(() => {
            this.url = url;
            this._options.url = url;
        });
        return this;
    }
    onRemove() {
        if (this._tileJSONRequest) {
            this._tileJSONRequest.abort();
            this._tileJSONRequest = null;
        }
    }
    serialize() {
        return performance$1.e({}, this._options);
    }
    loadTile(tile) {
        return performance$1._(this, void 0, void 0, function* () {
            const url = tile.tileID.canonical.url(this.tiles, this.map.getPixelRatio(), this.scheme);
            const params = {
                request: this.map._requestManager.transformRequest(url, "Tile" /* ResourceType.Tile */),
                uid: tile.uid,
                tileID: tile.tileID,
                zoom: tile.tileID.overscaledZ,
                tileSize: this.tileSize * tile.tileID.overscaleFactor(),
                type: this.type,
                source: this.id,
                pixelRatio: this.map.getPixelRatio(),
                showCollisionBoxes: this.map.showCollisionBoxes,
                promoteId: this.promoteId
            };
            params.request.collectResourceTiming = this._collectResourceTiming;
            let messageType = "RT" /* MessageType.reloadTile */;
            if (!tile.actor || tile.state === 'expired') {
                tile.actor = this.dispatcher.getActor();
                messageType = "LT" /* MessageType.loadTile */;
            }
            else if (tile.state === 'loading') {
                return new Promise((resolve, reject) => {
                    tile.reloadPromise = { resolve, reject };
                });
            }
            tile.abortController = new AbortController();
            try {
                const data = yield tile.actor.sendAsync({ type: messageType, data: params }, tile.abortController);
                delete tile.abortController;
                if (tile.aborted) {
                    return;
                }
                this._afterTileLoadWorkerResponse(tile, data);
            }
            catch (err) {
                delete tile.abortController;
                if (tile.aborted) {
                    return;
                }
                if (err && err.status !== 404) {
                    throw err;
                }
                this._afterTileLoadWorkerResponse(tile, null);
            }
        });
    }
    _afterTileLoadWorkerResponse(tile, data) {
        if (data && data.resourceTiming) {
            tile.resourceTiming = data.resourceTiming;
        }
        if (data && this.map._refreshExpiredTiles) {
            tile.setExpiryData(data);
        }
        tile.loadVectorData(data, this.map.painter);
        if (tile.reloadPromise) {
            const reloadPromise = tile.reloadPromise;
            tile.reloadPromise = null;
            this.loadTile(tile).then(reloadPromise.resolve).catch(reloadPromise.reject);
        }
    }
    abortTile(tile) {
        return performance$1._(this, void 0, void 0, function* () {
            if (tile.abortController) {
                tile.abortController.abort();
                delete tile.abortController;
            }
            if (tile.actor) {
                yield tile.actor.sendAsync({
                    type: "AT" /* MessageType.abortTile */,
                    data: { uid: tile.uid, type: this.type, source: this.id }
                });
            }
        });
    }
    unloadTile(tile) {
        return performance$1._(this, void 0, void 0, function* () {
            tile.unloadVectorData();
            if (tile.actor) {
                yield tile.actor.sendAsync({
                    type: "RMT" /* MessageType.removeTile */,
                    data: {
                        uid: tile.uid,
                        type: this.type,
                        source: this.id
                    }
                });
            }
        });
    }
    hasTransition() {
        return false;
    }
}

/**
 * A source containing raster tiles (See the [Style Specification](https://maplibre.org/maplibre-style-spec/) for detailed documentation of options.)
 *
 * @group Sources
 *
 * @example
 * ```ts
 * map.addSource('raster-source', {
 *     'type': 'raster',
 *     'tiles': ['https://tiles.stadiamaps.com/tiles/stamen_watercolor/{z}/{x}/{y}.jpg'],
 *     'tileSize': 256,
 * });
 * ```
 *
 * @example
 * ```ts
 * map.addSource('wms-test-source', {
 *      'type': 'raster',
 * // use the tiles option to specify a WMS tile source URL
 *      'tiles': [
 *          'https://img.nj.gov/imagerywms/Natural2015?bbox={bbox-epsg-3857}&format=image/png&service=WMS&version=1.1.1&request=GetMap&srs=EPSG:3857&transparent=true&width=256&height=256&layers=Natural2015'
 *      ],
 *      'tileSize': 256
 * });
 * ```
 * @see [Add a raster tile source](https://maplibre.org/maplibre-gl-js/docs/examples/map-tiles/)
 * @see [Add a WMS source](https://maplibre.org/maplibre-gl-js/docs/examples/wms/)
 * @see [Display a satellite map](https://maplibre.org/maplibre-gl-js/docs/examples/satellite-map/)
 */
class RasterTileSource extends performance$1.E {
    constructor(id, options, dispatcher, eventedParent) {
        super();
        this.id = id;
        this.dispatcher = dispatcher;
        this.setEventedParent(eventedParent);
        this.type = 'raster';
        this.minzoom = 0;
        this.maxzoom = 22;
        this.roundZoom = true;
        this.scheme = 'xyz';
        this.tileSize = 512;
        this._loaded = false;
        this._options = performance$1.e({ type: 'raster' }, options);
        performance$1.e(this, performance$1.M(options, ['url', 'scheme', 'tileSize']));
    }
    load() {
        return performance$1._(this, void 0, void 0, function* () {
            this._loaded = false;
            this.fire(new performance$1.k('dataloading', { dataType: 'source' }));
            this._tileJSONRequest = new AbortController();
            try {
                const tileJSON = yield loadTileJson(this._options, this.map._requestManager, this._tileJSONRequest);
                this._tileJSONRequest = null;
                this._loaded = true;
                if (tileJSON) {
                    performance$1.e(this, tileJSON);
                    if (tileJSON.bounds)
                        this.tileBounds = new TileBounds(tileJSON.bounds, this.minzoom, this.maxzoom);
                    // `content` is included here to prevent a race condition where `Style#_updateSources` is called
                    // before the TileJSON arrives. this makes sure the tiles needed are loaded once TileJSON arrives
                    // ref: https://github.com/mapbox/mapbox-gl-js/pull/4347#discussion_r104418088
                    this.fire(new performance$1.k('data', { dataType: 'source', sourceDataType: 'metadata' }));
                    this.fire(new performance$1.k('data', { dataType: 'source', sourceDataType: 'content' }));
                }
            }
            catch (err) {
                this._tileJSONRequest = null;
                this.fire(new performance$1.j(err));
            }
        });
    }
    loaded() {
        return this._loaded;
    }
    onAdd(map) {
        this.map = map;
        this.load();
    }
    onRemove() {
        if (this._tileJSONRequest) {
            this._tileJSONRequest.abort();
            this._tileJSONRequest = null;
        }
    }
    setSourceProperty(callback) {
        if (this._tileJSONRequest) {
            this._tileJSONRequest.abort();
            this._tileJSONRequest = null;
        }
        callback();
        this.load();
    }
    /**
     * Sets the source `tiles` property and re-renders the map.
     *
     * @param tiles - An array of one or more tile source URLs, as in the raster tiles spec (See the [Style Specification](https://maplibre.org/maplibre-style-spec/)
     */
    setTiles(tiles) {
        this.setSourceProperty(() => {
            this._options.tiles = tiles;
        });
        return this;
    }
    /**
     * Sets the source `url` property and re-renders the map.
     *
     * @param url - A URL to a TileJSON resource. Supported protocols are `http:` and `https:`.
     */
    setUrl(url) {
        this.setSourceProperty(() => {
            this.url = url;
            this._options.url = url;
        });
        return this;
    }
    serialize() {
        return performance$1.e({}, this._options);
    }
    hasTile(tileID) {
        return !this.tileBounds || this.tileBounds.contains(tileID.canonical);
    }
    loadTile(tile) {
        return performance$1._(this, void 0, void 0, function* () {
            const url = tile.tileID.canonical.url(this.tiles, this.map.getPixelRatio(), this.scheme);
            tile.abortController = new AbortController();
            try {
                const response = yield ImageRequest.getImage(this.map._requestManager.transformRequest(url, "Tile" /* ResourceType.Tile */), tile.abortController, this.map._refreshExpiredTiles);
                delete tile.abortController;
                if (tile.aborted) {
                    tile.state = 'unloaded';
                    return;
                }
                if (response && response.data) {
                    if (this.map._refreshExpiredTiles && response.cacheControl && response.expires) {
                        tile.setExpiryData({ cacheControl: response.cacheControl, expires: response.expires });
                    }
                    const context = this.map.painter.context;
                    const gl = context.gl;
                    const img = response.data;
                    tile.texture = this.map.painter.getTileTexture(img.width);
                    if (tile.texture) {
                        tile.texture.update(img, { useMipmap: true });
                    }
                    else {
                        tile.texture = new Texture(context, img, gl.RGBA, { useMipmap: true });
                        tile.texture.bind(gl.LINEAR, gl.CLAMP_TO_EDGE, gl.LINEAR_MIPMAP_NEAREST);
                    }
                    tile.state = 'loaded';
                }
            }
            catch (err) {
                delete tile.abortController;
                if (tile.aborted) {
                    tile.state = 'unloaded';
                }
                else if (err) {
                    tile.state = 'errored';
                    throw err;
                }
            }
        });
    }
    abortTile(tile) {
        return performance$1._(this, void 0, void 0, function* () {
            if (tile.abortController) {
                tile.abortController.abort();
                delete tile.abortController;
            }
        });
    }
    unloadTile(tile) {
        return performance$1._(this, void 0, void 0, function* () {
            if (tile.texture) {
                this.map.painter.saveTileTexture(tile.texture);
            }
        });
    }
    hasTransition() {
        return false;
    }
}

/**
 * A source containing raster DEM tiles (See the [Style Specification](https://maplibre.org/maplibre-style-spec/) for detailed documentation of options.)
 * This source can be used to show hillshading and 3D terrain
 *
 * @group Sources
 *
 * @example
 * ```ts
 * map.addSource('raster-dem-source', {
 *      type: 'raster-dem',
 *      url: 'https://demotiles.maplibre.org/terrain-tiles/tiles.json',
 *      tileSize: 256
 * });
 * ```
 * @see [3D Terrain](https://maplibre.org/maplibre-gl-js/docs/examples/3d-terrain/)
 */
class RasterDEMTileSource extends RasterTileSource {
    constructor(id, options, dispatcher, eventedParent) {
        super(id, options, dispatcher, eventedParent);
        this.type = 'raster-dem';
        this.maxzoom = 22;
        this._options = performance$1.e({ type: 'raster-dem' }, options);
        this.encoding = options.encoding || 'mapbox';
        this.redFactor = options.redFactor;
        this.greenFactor = options.greenFactor;
        this.blueFactor = options.blueFactor;
        this.baseShift = options.baseShift;
    }
    loadTile(tile) {
        return performance$1._(this, void 0, void 0, function* () {
            const url = tile.tileID.canonical.url(this.tiles, this.map.getPixelRatio(), this.scheme);
            const request = this.map._requestManager.transformRequest(url, "Tile" /* ResourceType.Tile */);
            tile.neighboringTiles = this._getNeighboringTiles(tile.tileID);
            tile.abortController = new AbortController();
            try {
                const response = yield ImageRequest.getImage(request, tile.abortController, this.map._refreshExpiredTiles);
                delete tile.abortController;
                if (tile.aborted) {
                    tile.state = 'unloaded';
                    return;
                }
                if (response && response.data) {
                    const img = response.data;
                    if (this.map._refreshExpiredTiles && response.cacheControl && response.expires) {
                        tile.setExpiryData({ cacheControl: response.cacheControl, expires: response.expires });
                    }
                    const transfer = performance$1.b(img) && performance$1.U();
                    const rawImageData = transfer ? img : yield this.readImageNow(img);
                    const params = {
                        type: this.type,
                        uid: tile.uid,
                        source: this.id,
                        rawImageData,
                        encoding: this.encoding,
                        redFactor: this.redFactor,
                        greenFactor: this.greenFactor,
                        blueFactor: this.blueFactor,
                        baseShift: this.baseShift
                    };
                    if (!tile.actor || tile.state === 'expired') {
                        tile.actor = this.dispatcher.getActor();
                        /* eslint-disable require-atomic-updates */
                        const data = yield tile.actor.sendAsync({ type: "LDT" /* MessageType.loadDEMTile */, data: params });
                        tile.dem = data;
                        tile.needsHillshadePrepare = true;
                        tile.needsTerrainPrepare = true;
                        tile.state = 'loaded';
                        /* eslint-enable require-atomic-updates */
                    }
                }
            }
            catch (err) {
                delete tile.abortController;
                if (tile.aborted) {
                    tile.state = 'unloaded';
                }
                else if (err) {
                    tile.state = 'errored';
                    throw err;
                }
            }
        });
    }
    readImageNow(img) {
        return performance$1._(this, void 0, void 0, function* () {
            if (typeof VideoFrame !== 'undefined' && performance$1.V()) {
                const width = img.width + 2;
                const height = img.height + 2;
                try {
                    return new performance$1.R({ width, height }, yield performance$1.W(img, -1, -1, width, height));
                }
                catch (e) {
                    // fall-back to browser canvas decoding
                }
            }
            return browser.getImageData(img, 1);
        });
    }
    _getNeighboringTiles(tileID) {
        const canonical = tileID.canonical;
        const dim = Math.pow(2, canonical.z);
        const px = (canonical.x - 1 + dim) % dim;
        const pxw = canonical.x === 0 ? tileID.wrap - 1 : tileID.wrap;
        const nx = (canonical.x + 1 + dim) % dim;
        const nxw = canonical.x + 1 === dim ? tileID.wrap + 1 : tileID.wrap;
        const neighboringTiles = {};
        // add adjacent tiles
        neighboringTiles[new performance$1.S(tileID.overscaledZ, pxw, canonical.z, px, canonical.y).key] = { backfilled: false };
        neighboringTiles[new performance$1.S(tileID.overscaledZ, nxw, canonical.z, nx, canonical.y).key] = { backfilled: false };
        // Add upper neighboringTiles
        if (canonical.y > 0) {
            neighboringTiles[new performance$1.S(tileID.overscaledZ, pxw, canonical.z, px, canonical.y - 1).key] = { backfilled: false };
            neighboringTiles[new performance$1.S(tileID.overscaledZ, tileID.wrap, canonical.z, canonical.x, canonical.y - 1).key] = { backfilled: false };
            neighboringTiles[new performance$1.S(tileID.overscaledZ, nxw, canonical.z, nx, canonical.y - 1).key] = { backfilled: false };
        }
        // Add lower neighboringTiles
        if (canonical.y + 1 < dim) {
            neighboringTiles[new performance$1.S(tileID.overscaledZ, pxw, canonical.z, px, canonical.y + 1).key] = { backfilled: false };
            neighboringTiles[new performance$1.S(tileID.overscaledZ, tileID.wrap, canonical.z, canonical.x, canonical.y + 1).key] = { backfilled: false };
            neighboringTiles[new performance$1.S(tileID.overscaledZ, nxw, canonical.z, nx, canonical.y + 1).key] = { backfilled: false };
        }
        return neighboringTiles;
    }
    unloadTile(tile) {
        return performance$1._(this, void 0, void 0, function* () {
            if (tile.demTexture)
                this.map.painter.saveTileTexture(tile.demTexture);
            if (tile.fbo) {
                tile.fbo.destroy();
                delete tile.fbo;
            }
            if (tile.dem)
                delete tile.dem;
            delete tile.neighboringTiles;
            tile.state = 'unloaded';
            if (tile.actor) {
                yield tile.actor.sendAsync({ type: "RDT" /* MessageType.removeDEMTile */, data: { type: this.type, uid: tile.uid, source: this.id } });
            }
        });
    }
}

/**
 * A source containing GeoJSON.
 * (See the [Style Specification](https://maplibre.org/maplibre-style-spec/#sources-geojson) for detailed documentation of options.)
 *
 * @group Sources
 *
 * @example
 * ```ts
 * map.addSource('some id', {
 *     type: 'geojson',
 *     data: 'https://d2ad6b4ur7yvpq.cloudfront.net/naturalearth-3.3.0/ne_10m_ports.geojson'
 * });
 * ```
 *
 * @example
 * ```ts
 * map.addSource('some id', {
 *    type: 'geojson',
 *    data: {
 *        "type": "FeatureCollection",
 *        "features": [{
 *            "type": "Feature",
 *            "properties": {},
 *            "geometry": {
 *                "type": "Point",
 *                "coordinates": [
 *                    -76.53063297271729,
 *                    39.18174077994108
 *                ]
 *            }
 *        }]
 *    }
 * });
 * ```
 *
 * @example
 * ```ts
 * map.getSource('some id').setData({
 *   "type": "FeatureCollection",
 *   "features": [{
 *       "type": "Feature",
 *       "properties": { "name": "Null Island" },
 *       "geometry": {
 *           "type": "Point",
 *           "coordinates": [ 0, 0 ]
 *       }
 *   }]
 * });
 * ```
 * @see [Draw GeoJSON points](https://maplibre.org/maplibre-gl-js/docs/examples/geojson-markers/)
 * @see [Add a GeoJSON line](https://maplibre.org/maplibre-gl-js/docs/examples/geojson-line/)
 * @see [Create a heatmap from points](https://maplibre.org/maplibre-gl-js/docs/examples/heatmap-layer/)
 * @see [Create and style clusters](https://maplibre.org/maplibre-gl-js/docs/examples/cluster/)
 */
class GeoJSONSource extends performance$1.E {
    /** @internal */
    constructor(id, options, dispatcher, eventedParent) {
        super();
        this.id = id;
        // `type` is a property rather than a constant to make it easy for 3rd
        // parties to use GeoJSONSource to build their own source types.
        this.type = 'geojson';
        this.minzoom = 0;
        this.maxzoom = 18;
        this.tileSize = 512;
        this.isTileClipped = true;
        this.reparseOverscaled = true;
        this._removed = false;
        this._pendingLoads = 0;
        this.actor = dispatcher.getActor();
        this.setEventedParent(eventedParent);
        this._data = options.data;
        this._options = performance$1.e({}, options);
        this._collectResourceTiming = options.collectResourceTiming;
        if (options.maxzoom !== undefined)
            this.maxzoom = options.maxzoom;
        if (options.type)
            this.type = options.type;
        if (options.attribution)
            this.attribution = options.attribution;
        this.promoteId = options.promoteId;
        const scale = performance$1.X / this.tileSize;
        // sent to the worker, along with `url: ...` or `data: literal geojson`,
        // so that it can load/parse/index the geojson data
        // extending with `options.workerOptions` helps to make it easy for
        // third-party sources to hack/reuse GeoJSONSource.
        this.workerOptions = performance$1.e({
            source: this.id,
            cluster: options.cluster || false,
            geojsonVtOptions: {
                buffer: (options.buffer !== undefined ? options.buffer : 128) * scale,
                tolerance: (options.tolerance !== undefined ? options.tolerance : 0.375) * scale,
                extent: performance$1.X,
                maxZoom: this.maxzoom,
                lineMetrics: options.lineMetrics || false,
                generateId: options.generateId || false
            },
            superclusterOptions: {
                maxZoom: options.clusterMaxZoom !== undefined ? options.clusterMaxZoom : this.maxzoom - 1,
                minPoints: Math.max(2, options.clusterMinPoints || 2),
                extent: performance$1.X,
                radius: (options.clusterRadius || 50) * scale,
                log: false,
                generateId: options.generateId || false
            },
            clusterProperties: options.clusterProperties,
            filter: options.filter
        }, options.workerOptions);
        // send the promoteId to the worker to have more flexible updates, but only if it is a string
        if (typeof this.promoteId === 'string') {
            this.workerOptions.promoteId = this.promoteId;
        }
    }
    load() {
        return performance$1._(this, void 0, void 0, function* () {
            yield this._updateWorkerData();
        });
    }
    onAdd(map) {
        this.map = map;
        this.load();
    }
    /**
     * Sets the GeoJSON data and re-renders the map.
     *
     * @param data - A GeoJSON data object or a URL to one. The latter is preferable in the case of large GeoJSON files.
     */
    setData(data) {
        this._data = data;
        this._updateWorkerData();
        return this;
    }
    /**
     * Updates the source's GeoJSON, and re-renders the map.
     *
     * For sources with lots of features, this method can be used to make updates more quickly.
     *
     * This approach requires unique IDs for every feature in the source. The IDs can either be specified on the feature,
     * or by using the promoteId option to specify which property should be used as the ID.
     *
     * It is an error to call updateData on a source that did not have unique IDs for each of its features already.
     *
     * Updates are applied on a best-effort basis, updating an ID that does not exist will not result in an error.
     *
     * @param diff - The changes that need to be applied.
     */
    updateData(diff) {
        this._updateWorkerData(diff);
        return this;
    }
    /**
     * Allows to get the source's actual GeoJSON data.
     *
     * @returns a promise which resolves to the source's actual GeoJSON data
     */
    getData() {
        return performance$1._(this, void 0, void 0, function* () {
            const options = performance$1.e({ type: this.type }, this.workerOptions);
            return this.actor.sendAsync({ type: "GD" /* MessageType.getData */, data: options });
        });
    }
    /**
     * To disable/enable clustering on the source options
     * @param options - The options to set
     * @example
     * ```ts
     * map.getSource('some id').setClusterOptions({cluster: false});
     * map.getSource('some id').setClusterOptions({cluster: false, clusterRadius: 50, clusterMaxZoom: 14});
     * ```
     */
    setClusterOptions(options) {
        this.workerOptions.cluster = options.cluster;
        if (options) {
            if (options.clusterRadius !== undefined)
                this.workerOptions.superclusterOptions.radius = options.clusterRadius;
            if (options.clusterMaxZoom !== undefined)
                this.workerOptions.superclusterOptions.maxZoom = options.clusterMaxZoom;
        }
        this._updateWorkerData();
        return this;
    }
    /**
     * For clustered sources, fetches the zoom at which the given cluster expands.
     *
     * @param clusterId - The value of the cluster's `cluster_id` property.
     * @returns a promise that is resolved with the zoom number
     */
    getClusterExpansionZoom(clusterId) {
        return this.actor.sendAsync({ type: "GCEZ" /* MessageType.getClusterExpansionZoom */, data: { type: this.type, clusterId, source: this.id } });
    }
    /**
     * For clustered sources, fetches the children of the given cluster on the next zoom level (as an array of GeoJSON features).
     *
     * @param clusterId - The value of the cluster's `cluster_id` property.
     * @returns a promise that is resolved when the features are retrieved
     */
    getClusterChildren(clusterId) {
        return this.actor.sendAsync({ type: "GCC" /* MessageType.getClusterChildren */, data: { type: this.type, clusterId, source: this.id } });
    }
    /**
     * For clustered sources, fetches the original points that belong to the cluster (as an array of GeoJSON features).
     *
     * @param clusterId - The value of the cluster's `cluster_id` property.
     * @param limit - The maximum number of features to return.
     * @param offset - The number of features to skip (e.g. for pagination).
     * @returns a promise that is resolved when the features are retrieved
     * @example
     * Retrieve cluster leaves on click
     * ```ts
     * map.on('click', 'clusters', (e) => {
     *   let features = map.queryRenderedFeatures(e.point, {
     *     layers: ['clusters']
     *   });
     *
     *   let clusterId = features[0].properties.cluster_id;
     *   let pointCount = features[0].properties.point_count;
     *   let clusterSource = map.getSource('clusters');
     *
     *   const features = await clusterSource.getClusterLeaves(clusterId, pointCount);
     *   // Print cluster leaves in the console
     *   console.log('Cluster leaves:', features);
     * });
     * ```
     */
    getClusterLeaves(clusterId, limit, offset) {
        return this.actor.sendAsync({ type: "GCL" /* MessageType.getClusterLeaves */, data: {
                type: this.type,
                source: this.id,
                clusterId,
                limit,
                offset
            } });
    }
    /**
     * Responsible for invoking WorkerSource's geojson.loadData target, which
     * handles loading the geojson data and preparing to serve it up as tiles,
     * using geojson-vt or supercluster as appropriate.
     * @param diff - the diff object
     */
    _updateWorkerData(diff) {
        return performance$1._(this, void 0, void 0, function* () {
            const options = performance$1.e({ type: this.type }, this.workerOptions);
            if (diff) {
                options.dataDiff = diff;
            }
            else if (typeof this._data === 'string') {
                options.request = this.map._requestManager.transformRequest(browser.resolveURL(this._data), "Source" /* ResourceType.Source */);
                options.request.collectResourceTiming = this._collectResourceTiming;
            }
            else {
                options.data = JSON.stringify(this._data);
            }
            this._pendingLoads++;
            this.fire(new performance$1.k('dataloading', { dataType: 'source' }));
            try {
                const result = yield this.actor.sendAsync({ type: "LD" /* MessageType.loadData */, data: options });
                this._pendingLoads--;
                if (this._removed || result.abandoned) {
                    this.fire(new performance$1.k('dataabort', { dataType: 'source' }));
                    return;
                }
                let resourceTiming = null;
                if (result.resourceTiming && result.resourceTiming[this.id]) {
                    resourceTiming = result.resourceTiming[this.id].slice(0);
                }
                const data = { dataType: 'source' };
                if (this._collectResourceTiming && resourceTiming && resourceTiming.length > 0) {
                    performance$1.e(data, { resourceTiming });
                }
                // although GeoJSON sources contain no metadata, we fire this event to let the SourceCache
                // know its ok to start requesting tiles.
                this.fire(new performance$1.k('data', Object.assign(Object.assign({}, data), { sourceDataType: 'metadata' })));
                this.fire(new performance$1.k('data', Object.assign(Object.assign({}, data), { sourceDataType: 'content' })));
            }
            catch (err) {
                this._pendingLoads--;
                if (this._removed) {
                    this.fire(new performance$1.k('dataabort', { dataType: 'source' }));
                    return;
                }
                this.fire(new performance$1.j(err));
            }
        });
    }
    loaded() {
        return this._pendingLoads === 0;
    }
    loadTile(tile) {
        return performance$1._(this, void 0, void 0, function* () {
            const message = !tile.actor ? "LT" /* MessageType.loadTile */ : "RT" /* MessageType.reloadTile */;
            tile.actor = this.actor;
            const params = {
                type: this.type,
                uid: tile.uid,
                tileID: tile.tileID,
                zoom: tile.tileID.overscaledZ,
                maxZoom: this.maxzoom,
                tileSize: this.tileSize,
                source: this.id,
                pixelRatio: this.map.getPixelRatio(),
                showCollisionBoxes: this.map.showCollisionBoxes,
                promoteId: this.promoteId
            };
            tile.abortController = new AbortController();
            const data = yield this.actor.sendAsync({ type: message, data: params }, tile.abortController);
            delete tile.abortController;
            tile.unloadVectorData();
            if (!tile.aborted) {
                tile.loadVectorData(data, this.map.painter, message === "RT" /* MessageType.reloadTile */);
            }
        });
    }
    abortTile(tile) {
        return performance$1._(this, void 0, void 0, function* () {
            if (tile.abortController) {
                tile.abortController.abort();
                delete tile.abortController;
            }
            tile.aborted = true;
        });
    }
    unloadTile(tile) {
        return performance$1._(this, void 0, void 0, function* () {
            tile.unloadVectorData();
            yield this.actor.sendAsync({ type: "RMT" /* MessageType.removeTile */, data: { uid: tile.uid, type: this.type, source: this.id } });
        });
    }
    onRemove() {
        this._removed = true;
        this.actor.sendAsync({ type: "RS" /* MessageType.removeSource */, data: { type: this.type, source: this.id } });
    }
    serialize() {
        return performance$1.e({}, this._options, {
            type: this.type,
            data: this._data
        });
    }
    hasTransition() {
        return false;
    }
}

var rasterBoundsAttributes = performance$1.Y([
    { name: 'a_pos', type: 'Int16', components: 2 },
    { name: 'a_texture_pos', type: 'Int16', components: 2 }
]);

/**
 * A data source containing an image.
 * (See the [Style Specification](https://maplibre.org/maplibre-style-spec/#sources-image) for detailed documentation of options.)
 *
 * @group Sources
 *
 * @example
 * ```ts
 * // add to map
 * map.addSource('some id', {
 *    type: 'image',
 *    url: 'https://www.maplibre.org/images/foo.png',
 *    coordinates: [
 *        [-76.54, 39.18],
 *        [-76.52, 39.18],
 *        [-76.52, 39.17],
 *        [-76.54, 39.17]
 *    ]
 * });
 *
 * // update coordinates
 * let mySource = map.getSource('some id');
 * mySource.setCoordinates([
 *     [-76.54335737228394, 39.18579907229748],
 *     [-76.52803659439087, 39.1838364847587],
 *     [-76.5295386314392, 39.17683392507606],
 *     [-76.54520273208618, 39.17876344106642]
 * ]);
 *
 * // update url and coordinates simultaneously
 * mySource.updateImage({
 *    url: 'https://www.maplibre.org/images/bar.png',
 *    coordinates: [
 *        [-76.54335737228394, 39.18579907229748],
 *        [-76.52803659439087, 39.1838364847587],
 *        [-76.5295386314392, 39.17683392507606],
 *        [-76.54520273208618, 39.17876344106642]
 *    ]
 * })
 *
 * map.removeSource('some id');  // remove
 * ```
 */
class ImageSource extends performance$1.E {
    /** @internal */
    constructor(id, options, dispatcher, eventedParent) {
        super();
        this.id = id;
        this.dispatcher = dispatcher;
        this.coordinates = options.coordinates;
        this.type = 'image';
        this.minzoom = 0;
        this.maxzoom = 22;
        this.tileSize = 512;
        this.tiles = {};
        this._loaded = false;
        this.setEventedParent(eventedParent);
        this.options = options;
    }
    load(newCoordinates) {
        return performance$1._(this, void 0, void 0, function* () {
            this._loaded = false;
            this.fire(new performance$1.k('dataloading', { dataType: 'source' }));
            this.url = this.options.url;
            this._request = new AbortController();
            try {
                const image = yield ImageRequest.getImage(this.map._requestManager.transformRequest(this.url, "Image" /* ResourceType.Image */), this._request);
                this._request = null;
                this._loaded = true;
                if (image && image.data) {
                    this.image = image.data;
                    if (newCoordinates) {
                        this.coordinates = newCoordinates;
                    }
                    this._finishLoading();
                }
            }
            catch (err) {
                this._request = null;
                this._loaded = true;
                this.fire(new performance$1.j(err));
            }
        });
    }
    loaded() {
        return this._loaded;
    }
    /**
     * Updates the image URL and, optionally, the coordinates. To avoid having the image flash after changing,
     * set the `raster-fade-duration` paint property on the raster layer to 0.
     *
     * @param options - The options object.
     */
    updateImage(options) {
        if (!options.url) {
            return this;
        }
        if (this._request) {
            this._request.abort();
            this._request = null;
        }
        this.options.url = options.url;
        this.load(options.coordinates).finally(() => { this.texture = null; });
        return this;
    }
    _finishLoading() {
        if (this.map) {
            this.setCoordinates(this.coordinates);
            this.fire(new performance$1.k('data', { dataType: 'source', sourceDataType: 'metadata' }));
        }
    }
    onAdd(map) {
        this.map = map;
        this.load();
    }
    onRemove() {
        if (this._request) {
            this._request.abort();
            this._request = null;
        }
    }
    /**
     * Sets the image's coordinates and re-renders the map.
     *
     * @param coordinates - Four geographical coordinates,
     * represented as arrays of longitude and latitude numbers, which define the corners of the image.
     * The coordinates start at the top left corner of the image and proceed in clockwise order.
     * They do not have to represent a rectangle.
     */
    setCoordinates(coordinates) {
        this.coordinates = coordinates;
        // Calculate which mercator tile is suitable for rendering the video in
        // and create a buffer with the corner coordinates. These coordinates
        // may be outside the tile, because raster tiles aren't clipped when rendering.
        // transform the geo coordinates into (zoom 0) tile space coordinates
        const cornerCoords = coordinates.map(performance$1.Z.fromLngLat);
        // Compute the coordinates of the tile we'll use to hold this image's
        // render data
        this.tileID = getCoordinatesCenterTileID(cornerCoords);
        // Constrain min/max zoom to our tile's zoom level in order to force
        // SourceCache to request this tile (no matter what the map's zoom
        // level)
        this.minzoom = this.maxzoom = this.tileID.z;
        // Transform the corner coordinates into the coordinate space of our
        // tile.
        const tileCoords = cornerCoords.map((coord) => this.tileID.getTilePoint(coord)._round());
        this._boundsArray = new performance$1.$();
        this._boundsArray.emplaceBack(tileCoords[0].x, tileCoords[0].y, 0, 0);
        this._boundsArray.emplaceBack(tileCoords[1].x, tileCoords[1].y, performance$1.X, 0);
        this._boundsArray.emplaceBack(tileCoords[3].x, tileCoords[3].y, 0, performance$1.X);
        this._boundsArray.emplaceBack(tileCoords[2].x, tileCoords[2].y, performance$1.X, performance$1.X);
        if (this.boundsBuffer) {
            this.boundsBuffer.destroy();
            delete this.boundsBuffer;
        }
        this.fire(new performance$1.k('data', { dataType: 'source', sourceDataType: 'content' }));
        return this;
    }
    prepare() {
        if (Object.keys(this.tiles).length === 0 || !this.image) {
            return;
        }
        const context = this.map.painter.context;
        const gl = context.gl;
        if (!this.boundsBuffer) {
            this.boundsBuffer = context.createVertexBuffer(this._boundsArray, rasterBoundsAttributes.members);
        }
        if (!this.boundsSegments) {
            this.boundsSegments = performance$1.a0.simpleSegment(0, 0, 4, 2);
        }
        if (!this.texture) {
            this.texture = new Texture(context, this.image, gl.RGBA);
            this.texture.bind(gl.LINEAR, gl.CLAMP_TO_EDGE);
        }
        let newTilesLoaded = false;
        for (const w in this.tiles) {
            const tile = this.tiles[w];
            if (tile.state !== 'loaded') {
                tile.state = 'loaded';
                tile.texture = this.texture;
                newTilesLoaded = true;
            }
        }
        if (newTilesLoaded) {
            this.fire(new performance$1.k('data', { dataType: 'source', sourceDataType: 'idle', sourceId: this.id }));
        }
    }
    loadTile(tile) {
        return performance$1._(this, void 0, void 0, function* () {
            // We have a single tile -- whose coordinates are this.tileID -- that
            // covers the image we want to render.  If that's the one being
            // requested, set it up with the image; otherwise, mark the tile as
            // `errored` to indicate that we have no data for it.
            // If the world wraps, we may have multiple "wrapped" copies of the
            // single tile.
            if (this.tileID && this.tileID.equals(tile.tileID.canonical)) {
                this.tiles[String(tile.tileID.wrap)] = tile;
                tile.buckets = {};
            }
            else {
                tile.state = 'errored';
            }
        });
    }
    serialize() {
        return {
            type: 'image',
            url: this.options.url,
            coordinates: this.coordinates
        };
    }
    hasTransition() {
        return false;
    }
}
/**
 * Given a list of coordinates, get their center as a coordinate.
 *
 * @returns centerpoint
 * @internal
 */
function getCoordinatesCenterTileID(coords) {
    let minX = Infinity;
    let minY = Infinity;
    let maxX = -Infinity;
    let maxY = -Infinity;
    for (const coord of coords) {
        minX = Math.min(minX, coord.x);
        minY = Math.min(minY, coord.y);
        maxX = Math.max(maxX, coord.x);
        maxY = Math.max(maxY, coord.y);
    }
    const dx = maxX - minX;
    const dy = maxY - minY;
    const dMax = Math.max(dx, dy);
    const zoom = Math.max(0, Math.floor(-Math.log(dMax) / Math.LN2));
    const tilesAtZoom = Math.pow(2, zoom);
    return new performance$1.a1(zoom, Math.floor((minX + maxX) / 2 * tilesAtZoom), Math.floor((minY + maxY) / 2 * tilesAtZoom));
}

/**
 * A data source containing video.
 * (See the [Style Specification](https://maplibre.org/maplibre-style-spec/#sources-video) for detailed documentation of options.)
 *
 * @group Sources
 *
 * @example
 * ```ts
 * // add to map
 * map.addSource('some id', {
 *    type: 'video',
 *    url: [
 *        'https://www.mapbox.com/blog/assets/baltimore-smoke.mp4',
 *        'https://www.mapbox.com/blog/assets/baltimore-smoke.webm'
 *    ],
 *    coordinates: [
 *        [-76.54, 39.18],
 *        [-76.52, 39.18],
 *        [-76.52, 39.17],
 *        [-76.54, 39.17]
 *    ]
 * });
 *
 * // update
 * let mySource = map.getSource('some id');
 * mySource.setCoordinates([
 *     [-76.54335737228394, 39.18579907229748],
 *     [-76.52803659439087, 39.1838364847587],
 *     [-76.5295386314392, 39.17683392507606],
 *     [-76.54520273208618, 39.17876344106642]
 * ]);
 *
 * map.removeSource('some id');  // remove
 * ```
 * @see [Add a video](https://maplibre.org/maplibre-gl-js/docs/examples/video-on-a-map/)
 *
 * Note that when rendered as a raster layer, the layer's `raster-fade-duration` property will cause the video to fade in.
 * This happens when playback is started, paused and resumed, or when the video's coordinates are updated. To avoid this behavior,
 * set the layer's `raster-fade-duration` property to `0`.
 */
class VideoSource extends ImageSource {
    constructor(id, options, dispatcher, eventedParent) {
        super(id, options, dispatcher, eventedParent);
        this.roundZoom = true;
        this.type = 'video';
        this.options = options;
    }
    load() {
        return performance$1._(this, void 0, void 0, function* () {
            this._loaded = false;
            const options = this.options;
            this.urls = [];
            for (const url of options.urls) {
                this.urls.push(this.map._requestManager.transformRequest(url, "Source" /* ResourceType.Source */).url);
            }
            try {
                const video = yield performance$1.a3(this.urls);
                this._loaded = true;
                if (!video) {
                    return;
                }
                this.video = video;
                this.video.loop = true;
                // Start repainting when video starts playing. hasTransition() will then return
                // true to trigger additional frames as long as the videos continues playing.
                this.video.addEventListener('playing', () => {
                    this.map.triggerRepaint();
                });
                if (this.map) {
                    this.video.play();
                }
                this._finishLoading();
            }
            catch (err) {
                this.fire(new performance$1.j(err));
            }
        });
    }
    /**
     * Pauses the video.
     */
    pause() {
        if (this.video) {
            this.video.pause();
        }
    }
    /**
     * Plays the video.
     */
    play() {
        if (this.video) {
            this.video.play();
        }
    }
    /**
     * Sets playback to a timestamp, in seconds.
     */
    seek(seconds) {
        if (this.video) {
            const seekableRange = this.video.seekable;
            if (seconds < seekableRange.start(0) || seconds > seekableRange.end(0)) {
                this.fire(new performance$1.j(new performance$1.a2(`sources.${this.id}`, null, `Playback for this video can be set only between the ${seekableRange.start(0)} and ${seekableRange.end(0)}-second mark.`)));
            }
            else
                this.video.currentTime = seconds;
        }
    }
    /**
     * Returns the HTML `video` element.
     *
     * @returns The HTML `video` element.
     */
    getVideo() {
        return this.video;
    }
    onAdd(map) {
        if (this.map)
            return;
        this.map = map;
        this.load();
        if (this.video) {
            this.video.play();
            this.setCoordinates(this.coordinates);
        }
    }
    /**
     * Sets the video's coordinates and re-renders the map.
     */
    prepare() {
        if (Object.keys(this.tiles).length === 0 || this.video.readyState < 2) {
            return; // not enough data for current position
        }
        const context = this.map.painter.context;
        const gl = context.gl;
        if (!this.boundsBuffer) {
            this.boundsBuffer = context.createVertexBuffer(this._boundsArray, rasterBoundsAttributes.members);
        }
        if (!this.boundsSegments) {
            this.boundsSegments = performance$1.a0.simpleSegment(0, 0, 4, 2);
        }
        if (!this.texture) {
            this.texture = new Texture(context, this.video, gl.RGBA);
            this.texture.bind(gl.LINEAR, gl.CLAMP_TO_EDGE);
        }
        else if (!this.video.paused) {
            this.texture.bind(gl.LINEAR, gl.CLAMP_TO_EDGE);
            gl.texSubImage2D(gl.TEXTURE_2D, 0, 0, 0, gl.RGBA, gl.UNSIGNED_BYTE, this.video);
        }
        let newTilesLoaded = false;
        for (const w in this.tiles) {
            const tile = this.tiles[w];
            if (tile.state !== 'loaded') {
                tile.state = 'loaded';
                tile.texture = this.texture;
                newTilesLoaded = true;
            }
        }
        if (newTilesLoaded) {
            this.fire(new performance$1.k('data', { dataType: 'source', sourceDataType: 'idle', sourceId: this.id }));
        }
    }
    serialize() {
        return {
            type: 'video',
            urls: this.urls,
            coordinates: this.coordinates
        };
    }
    hasTransition() {
        return this.video && !this.video.paused;
    }
}

/**
 * A data source containing the contents of an HTML canvas. See {@link CanvasSourceSpecification} for detailed documentation of options.
 *
 * @group Sources
 *
 * @example
 * ```ts
 * // add to map
 * map.addSource('some id', {
 *    type: 'canvas',
 *    canvas: 'idOfMyHTMLCanvas',
 *    animate: true,
 *    coordinates: [
 *        [-76.54, 39.18],
 *        [-76.52, 39.18],
 *        [-76.52, 39.17],
 *        [-76.54, 39.17]
 *    ]
 * });
 *
 * // update
 * let mySource = map.getSource('some id');
 * mySource.setCoordinates([
 *     [-76.54335737228394, 39.18579907229748],
 *     [-76.52803659439087, 39.1838364847587],
 *     [-76.5295386314392, 39.17683392507606],
 *     [-76.54520273208618, 39.17876344106642]
 * ]);
 *
 * map.removeSource('some id');  // remove
 * ```
 */
class CanvasSource extends ImageSource {
    /** @internal */
    constructor(id, options, dispatcher, eventedParent) {
        super(id, options, dispatcher, eventedParent);
        // We build in some validation here, since canvas sources aren't included in the style spec:
        if (!options.coordinates) {
            this.fire(new performance$1.j(new performance$1.a2(`sources.${id}`, null, 'missing required property "coordinates"')));
        }
        else if (!Array.isArray(options.coordinates) || options.coordinates.length !== 4 ||
            options.coordinates.some(c => !Array.isArray(c) || c.length !== 2 || c.some(l => typeof l !== 'number'))) {
            this.fire(new performance$1.j(new performance$1.a2(`sources.${id}`, null, '"coordinates" property must be an array of 4 longitude/latitude array pairs')));
        }
        if (options.animate && typeof options.animate !== 'boolean') {
            this.fire(new performance$1.j(new performance$1.a2(`sources.${id}`, null, 'optional "animate" property must be a boolean value')));
        }
        if (!options.canvas) {
            this.fire(new performance$1.j(new performance$1.a2(`sources.${id}`, null, 'missing required property "canvas"')));
        }
        else if (typeof options.canvas !== 'string' && !(options.canvas instanceof HTMLCanvasElement)) {
            this.fire(new performance$1.j(new performance$1.a2(`sources.${id}`, null, '"canvas" must be either a string representing the ID of the canvas element from which to read, or an HTMLCanvasElement instance')));
        }
        this.options = options;
        this.animate = options.animate !== undefined ? options.animate : true;
    }
    load() {
        return performance$1._(this, void 0, void 0, function* () {
            this._loaded = true;
            if (!this.canvas) {
                this.canvas = (this.options.canvas instanceof HTMLCanvasElement) ?
                    this.options.canvas :
                    document.getElementById(this.options.canvas);
                // cast to HTMLCanvasElement in else of ternary
                // should we do a safety check and throw if it's not actually HTMLCanvasElement?
            }
            this.width = this.canvas.width;
            this.height = this.canvas.height;
            if (this._hasInvalidDimensions()) {
                this.fire(new performance$1.j(new Error('Canvas dimensions cannot be less than or equal to zero.')));
                return;
            }
            this.play = function () {
                this._playing = true;
                this.map.triggerRepaint();
            };
            this.pause = function () {
                if (this._playing) {
                    this.prepare();
                    this._playing = false;
                }
            };
            this._finishLoading();
        });
    }
    /**
     * Returns the HTML `canvas` element.
     *
     * @returns The HTML `canvas` element.
     */
    getCanvas() {
        return this.canvas;
    }
    onAdd(map) {
        this.map = map;
        this.load();
        if (this.canvas) {
            if (this.animate)
                this.play();
        }
    }
    onRemove() {
        this.pause();
    }
    prepare() {
        let resize = false;
        if (this.canvas.width !== this.width) {
            this.width = this.canvas.width;
            resize = true;
        }
        if (this.canvas.height !== this.height) {
            this.height = this.canvas.height;
            resize = true;
        }
        if (this._hasInvalidDimensions())
            return;
        if (Object.keys(this.tiles).length === 0)
            return; // not enough data for current position
        const context = this.map.painter.context;
        const gl = context.gl;
        if (!this.boundsBuffer) {
            this.boundsBuffer = context.createVertexBuffer(this._boundsArray, rasterBoundsAttributes.members);
        }
        if (!this.boundsSegments) {
            this.boundsSegments = performance$1.a0.simpleSegment(0, 0, 4, 2);
        }
        if (!this.texture) {
            this.texture = new Texture(context, this.canvas, gl.RGBA, { premultiply: true });
        }
        else if (resize || this._playing) {
            this.texture.update(this.canvas, { premultiply: true });
        }
        let newTilesLoaded = false;
        for (const w in this.tiles) {
            const tile = this.tiles[w];
            if (tile.state !== 'loaded') {
                tile.state = 'loaded';
                tile.texture = this.texture;
                newTilesLoaded = true;
            }
        }
        if (newTilesLoaded) {
            this.fire(new performance$1.k('data', { dataType: 'source', sourceDataType: 'idle', sourceId: this.id }));
        }
    }
    serialize() {
        return {
            type: 'canvas',
            coordinates: this.coordinates
        };
    }
    hasTransition() {
        return this._playing;
    }
    _hasInvalidDimensions() {
        for (const x of [this.canvas.width, this.canvas.height]) {
            if (isNaN(x) || x <= 0)
                return true;
        }
        return false;
    }
}

const registeredSources = {};
/**
 * Creates a tiled data source instance given an options object.
 *
 * @param id - The id for the source. Must not be used by any existing source.
 * @param specification - Source options, specific to the source type (except for `options.type`, which is always required).
 * @param source - A source definition object compliant with
 * [`maplibre-gl-style-spec`](https://maplibre.org/maplibre-style-spec/#sources) or, for a third-party source type,
  * with that type's requirements.
 * @param dispatcher - A {@link Dispatcher} instance, which can be used to send messages to the workers.
 * @returns a newly created source
 */
const create = (id, specification, dispatcher, eventedParent) => {
    const Class = getSourceType(specification.type);
    const source = new Class(id, specification, dispatcher, eventedParent);
    if (source.id !== id) {
        throw new Error(`Expected Source id to be ${id} instead of ${source.id}`);
    }
    return source;
};
const getSourceType = (name) => {
    switch (name) {
        case 'geojson':
            return GeoJSONSource;
        case 'image':
            return ImageSource;
        case 'raster':
            return RasterTileSource;
        case 'raster-dem':
            return RasterDEMTileSource;
        case 'vector':
            return VectorTileSource;
        case 'video':
            return VideoSource;
        case 'canvas':
            return CanvasSource;
    }
    return registeredSources[name];
};
const setSourceType = (name, type) => {
    registeredSources[name] = type;
};
/**
 * Adds a custom source type, making it available for use with {@link Map#addSource}.
 * @param name - The name of the source type; source definition objects use this name in the `{type: ...}` field.
 * @param SourceType - A {@link SourceClass} - which is a constructor for the `Source` interface.
 * @returns a promise that is resolved when the source type is ready or rejected with an error.
 */
const addSourceType = (name, SourceType) => performance$1._(void 0, void 0, void 0, function* () {
    if (getSourceType(name)) {
        throw new Error(`A source type called "${name}" already exists.`);
    }
    setSourceType(name, SourceType);
});

function deserialize(input, style) {
    const output = {};
    // Guard against the case where the map's style has been set to null while
    // this bucket has been parsing.
    if (!style)
        return output;
    for (const bucket of input) {
        const layers = bucket.layerIds
            .map((id) => style.getLayer(id))
            .filter(Boolean);
        if (layers.length === 0) {
            continue;
        }
        // look up StyleLayer objects from layer ids (since we don't
        // want to waste time serializing/copying them from the worker)
        bucket.layers = layers;
        if (bucket.stateDependentLayerIds) {
            bucket.stateDependentLayers = bucket.stateDependentLayerIds.map((lId) => layers.filter((l) => l.id === lId)[0]);
        }
        for (const layer of layers) {
            output[layer.id] = bucket;
        }
    }
    return output;
}

const RTLPluginLoadedEventName = 'RTLPluginLoaded';

class RTLMainThreadPlugin extends performance$1.E {
    constructor() {
        super(...arguments);
        this.status = 'unavailable';
        this.url = null;
        this.dispatcher = getGlobalDispatcher();
    }
    /** Sync RTL plugin state by broadcasting a message to the worker */
    _syncState(statusToSend) {
        this.status = statusToSend;
        return this.dispatcher.broadcast("SRPS" /* MessageType.syncRTLPluginState */, { pluginStatus: statusToSend, pluginURL: this.url })
            .catch((e) => {
            this.status = 'error';
            throw e;
        });
    }
    /** This one is exposed to outside */
    getRTLTextPluginStatus() {
        return this.status;
    }
    clearRTLTextPlugin() {
        this.status = 'unavailable';
        this.url = null;
    }
    setRTLTextPlugin(url_1) {
        return performance$1._(this, arguments, void 0, function* (url, deferred = false) {
            if (this.url) {
                // error
                throw new Error('setRTLTextPlugin cannot be called multiple times.');
            }
            this.url = browser.resolveURL(url);
            if (!this.url) {
                throw new Error(`requested url ${url} is invalid`);
            }
            if (this.status === 'unavailable') {
                // from initial state:
                if (deferred) {
                    this.status = 'deferred';
                    // fire and forget: in this case it does not need wait for the broadcasting result
                    // it is important to sync the deferred status once because
                    // symbol_bucket will be checking it in worker
                    this._syncState(this.status);
                }
                else {
                    return this._requestImport();
                }
            }
            else if (this.status === 'requested') {
                return this._requestImport();
            }
        });
    }
    /** Send a message to worker which will import the RTL plugin script */
    _requestImport() {
        return performance$1._(this, void 0, void 0, function* () {
            // all errors/exceptions will be handled by _syncState
            yield this._syncState('loading');
            this.status = 'loaded';
            this.fire(new performance$1.k(RTLPluginLoadedEventName));
        });
    }
    /** Start a lazy loading process of RTL plugin */
    lazyLoad() {
        if (this.status === 'unavailable') {
            this.status = 'requested';
        }
        else if (this.status === 'deferred') {
            this._requestImport();
        }
    }
}
let rtlMainThreadPlugin = null;
function rtlMainThreadPluginFactory() {
    if (!rtlMainThreadPlugin) {
        rtlMainThreadPlugin = new RTLMainThreadPlugin();
    }
    return rtlMainThreadPlugin;
}

const CLOCK_SKEW_RETRY_TIMEOUT = 30000;
/**
 * A tile object is the combination of a Coordinate, which defines
 * its place, as well as a unique ID and data tracking for its content
 */
class Tile {
    /**
     * @param tileID - the tile ID
     * @param size - The tile size
     */
    constructor(tileID, size) {
        this.timeAdded = 0;
        this.fadeEndTime = 0;
        this.tileID = tileID;
        this.uid = performance$1.a4();
        this.uses = 0;
        this.tileSize = size;
        this.buckets = {};
        this.expirationTime = null;
        this.queryPadding = 0;
        this.hasSymbolBuckets = false;
        this.hasRTLText = false;
        this.dependencies = {};
        this.rtt = [];
        this.rttCoords = {};
        // Counts the number of times a response was already expired when
        // received. We're using this to add a delay when making a new request
        // so we don't have to keep retrying immediately in case of a server
        // serving expired tiles.
        this.expiredRequestCount = 0;
        this.state = 'loading';
    }
    registerFadeDuration(duration) {
        const fadeEndTime = duration + this.timeAdded;
        if (fadeEndTime < this.fadeEndTime) {
            return;
        }
        this.fadeEndTime = fadeEndTime;
    }
    wasRequested() {
        return this.state === 'errored' || this.state === 'loaded' || this.state === 'reloading';
    }
    clearTextures(painter) {
        if (this.demTexture)
            painter.saveTileTexture(this.demTexture);
        this.demTexture = null;
    }
    /**
     * Given a data object with a 'buffers' property, load it into
     * this tile's elementGroups and buffers properties and set loaded
     * to true. If the data is null, like in the case of an empty
     * GeoJSON tile, no-op but still set loaded to true.
     * @param data - The data from the worker
     * @param painter - the painter
     * @param justReloaded - `true` to just reload
     */
    loadVectorData(data, painter, justReloaded) {
        if (this.hasData()) {
            this.unloadVectorData();
        }
        this.state = 'loaded';
        // empty GeoJSON tile
        if (!data) {
            this.collisionBoxArray = new performance$1.a5();
            return;
        }
        if (data.featureIndex) {
            this.latestFeatureIndex = data.featureIndex;
            if (data.rawTileData) {
                // Only vector tiles have rawTileData, and they won't update it for
                // 'reloadTile'
                this.latestRawTileData = data.rawTileData;
                this.latestFeatureIndex.rawTileData = data.rawTileData;
            }
            else if (this.latestRawTileData) {
                // If rawTileData hasn't updated, hold onto a pointer to the last
                // one we received
                this.latestFeatureIndex.rawTileData = this.latestRawTileData;
            }
        }
        this.collisionBoxArray = data.collisionBoxArray;
        this.buckets = deserialize(data.buckets, painter.style);
        this.hasSymbolBuckets = false;
        for (const id in this.buckets) {
            const bucket = this.buckets[id];
            if (bucket instanceof performance$1.a6) {
                this.hasSymbolBuckets = true;
                if (justReloaded) {
                    bucket.justReloaded = true;
                }
                else {
                    break;
                }
            }
        }
        this.hasRTLText = false;
        if (this.hasSymbolBuckets) {
            for (const id in this.buckets) {
                const bucket = this.buckets[id];
                if (bucket instanceof performance$1.a6) {
                    if (bucket.hasRTLText) {
                        this.hasRTLText = true;
                        rtlMainThreadPluginFactory().lazyLoad();
                        break;
                    }
                }
            }
        }
        this.queryPadding = 0;
        for (const id in this.buckets) {
            const bucket = this.buckets[id];
            this.queryPadding = Math.max(this.queryPadding, painter.style.getLayer(id).queryRadius(bucket));
        }
        if (data.imageAtlas) {
            this.imageAtlas = data.imageAtlas;
        }
        if (data.glyphAtlasImage) {
            this.glyphAtlasImage = data.glyphAtlasImage;
        }
    }
    /**
     * Release any data or WebGL resources referenced by this tile.
     */
    unloadVectorData() {
        for (const id in this.buckets) {
            this.buckets[id].destroy();
        }
        this.buckets = {};
        if (this.imageAtlasTexture) {
            this.imageAtlasTexture.destroy();
        }
        if (this.imageAtlas) {
            this.imageAtlas = null;
        }
        if (this.glyphAtlasTexture) {
            this.glyphAtlasTexture.destroy();
        }
        this.latestFeatureIndex = null;
        this.state = 'unloaded';
    }
    getBucket(layer) {
        return this.buckets[layer.id];
    }
    upload(context) {
        for (const id in this.buckets) {
            const bucket = this.buckets[id];
            if (bucket.uploadPending()) {
                bucket.upload(context);
            }
        }
        const gl = context.gl;
        if (this.imageAtlas && !this.imageAtlas.uploaded) {
            this.imageAtlasTexture = new Texture(context, this.imageAtlas.image, gl.RGBA);
            this.imageAtlas.uploaded = true;
        }
        if (this.glyphAtlasImage) {
            this.glyphAtlasTexture = new Texture(context, this.glyphAtlasImage, gl.ALPHA);
            this.glyphAtlasImage = null;
        }
    }
    prepare(imageManager) {
        if (this.imageAtlas) {
            this.imageAtlas.patchUpdatedImages(imageManager, this.imageAtlasTexture);
        }
    }
    // Queries non-symbol features rendered for this tile.
    // Symbol features are queried globally
    queryRenderedFeatures(layers, serializedLayers, sourceFeatureState, queryGeometry, cameraQueryGeometry, scale, params, transform, maxPitchScaleFactor, pixelPosMatrix) {
        if (!this.latestFeatureIndex || !this.latestFeatureIndex.rawTileData)
            return {};
        return this.latestFeatureIndex.query({
            queryGeometry,
            cameraQueryGeometry,
            scale,
            tileSize: this.tileSize,
            pixelPosMatrix,
            transform,
            params,
            queryPadding: this.queryPadding * maxPitchScaleFactor
        }, layers, serializedLayers, sourceFeatureState);
    }
    querySourceFeatures(result, params) {
        const featureIndex = this.latestFeatureIndex;
        if (!featureIndex || !featureIndex.rawTileData)
            return;
        const vtLayers = featureIndex.loadVTLayers();
        const sourceLayer = params && params.sourceLayer ? params.sourceLayer : '';
        const layer = vtLayers._geojsonTileLayer || vtLayers[sourceLayer];
        if (!layer)
            return;
        const filter = performance$1.a7(params && params.filter);
        const { z, x, y } = this.tileID.canonical;
        const coord = { z, x, y };
        for (let i = 0; i < layer.length; i++) {
            const feature = layer.feature(i);
            if (filter.needGeometry) {
                const evaluationFeature = performance$1.a8(feature, true);
                if (!filter.filter(new performance$1.a9(this.tileID.overscaledZ), evaluationFeature, this.tileID.canonical))
                    continue;
            }
            else if (!filter.filter(new performance$1.a9(this.tileID.overscaledZ), feature)) {
                continue;
            }
            const id = featureIndex.getId(feature, sourceLayer);
            const geojsonFeature = new performance$1.aa(feature, z, x, y, id);
            geojsonFeature.tile = coord;
            result.push(geojsonFeature);
        }
    }
    hasData() {
        return this.state === 'loaded' || this.state === 'reloading' || this.state === 'expired';
    }
    patternsLoaded() {
        return this.imageAtlas && !!Object.keys(this.imageAtlas.patternPositions).length;
    }
    setExpiryData(data) {
        const prior = this.expirationTime;
        if (data.cacheControl) {
            const parsedCC = performance$1.ab(data.cacheControl);
            if (parsedCC['max-age'])
                this.expirationTime = Date.now() + parsedCC['max-age'] * 1000;
        }
        else if (data.expires) {
            this.expirationTime = new Date(data.expires).getTime();
        }
        if (this.expirationTime) {
            const now = Date.now();
            let isExpired = false;
            if (this.expirationTime > now) {
                isExpired = false;
            }
            else if (!prior) {
                isExpired = true;
            }
            else if (this.expirationTime < prior) {
                // Expiring date is going backwards:
                // fall back to exponential backoff
                isExpired = true;
            }
            else {
                const delta = this.expirationTime - prior;
                if (!delta) {
                    // Server is serving the same expired resource over and over: fall
                    // back to exponential backoff.
                    isExpired = true;
                }
                else {
                    // Assume that either the client or the server clock is wrong and
                    // try to interpolate a valid expiration date (from the client POV)
                    // observing a minimum timeout.
                    this.expirationTime = now + Math.max(delta, CLOCK_SKEW_RETRY_TIMEOUT);
                }
            }
            if (isExpired) {
                this.expiredRequestCount++;
                this.state = 'expired';
            }
            else {
                this.expiredRequestCount = 0;
            }
        }
    }
    getExpiryTimeout() {
        if (this.expirationTime) {
            if (this.expiredRequestCount) {
                return 1000 * (1 << Math.min(this.expiredRequestCount - 1, 31));
            }
            else {
                // Max value for `setTimeout` implementations is a 32 bit integer; cap this accordingly
                return Math.min(this.expirationTime - new Date().getTime(), Math.pow(2, 31) - 1);
            }
        }
    }
    setFeatureState(states, painter) {
        if (!this.latestFeatureIndex ||
            !this.latestFeatureIndex.rawTileData ||
            Object.keys(states).length === 0) {
            return;
        }
        const vtLayers = this.latestFeatureIndex.loadVTLayers();
        for (const id in this.buckets) {
            if (!painter.style.hasLayer(id))
                continue;
            const bucket = this.buckets[id];
            // Buckets are grouped by common source-layer
            const sourceLayerId = bucket.layers[0]['sourceLayer'] || '_geojsonTileLayer';
            const sourceLayer = vtLayers[sourceLayerId];
            const sourceLayerStates = states[sourceLayerId];
            if (!sourceLayer || !sourceLayerStates || Object.keys(sourceLayerStates).length === 0)
                continue;
            bucket.update(sourceLayerStates, sourceLayer, this.imageAtlas && this.imageAtlas.patternPositions || {});
            const layer = painter && painter.style && painter.style.getLayer(id);
            if (layer) {
                this.queryPadding = Math.max(this.queryPadding, layer.queryRadius(bucket));
            }
        }
    }
    holdingForFade() {
        return this.symbolFadeHoldUntil !== undefined;
    }
    symbolFadeFinished() {
        return !this.symbolFadeHoldUntil || this.symbolFadeHoldUntil < browser.now();
    }
    clearFadeHold() {
        this.symbolFadeHoldUntil = undefined;
    }
    setHoldDuration(duration) {
        this.symbolFadeHoldUntil = browser.now() + duration;
    }
    setDependencies(namespace, dependencies) {
        const index = {};
        for (const dep of dependencies) {
            index[dep] = true;
        }
        this.dependencies[namespace] = index;
    }
    hasDependency(namespaces, keys) {
        for (const namespace of namespaces) {
            const dependencies = this.dependencies[namespace];
            if (dependencies) {
                for (const key of keys) {
                    if (dependencies[key]) {
                        return true;
                    }
                }
            }
        }
        return false;
    }
}

/**
 * @internal
 * A [least-recently-used cache](https://en.wikipedia.org/wiki/Cache_algorithms)
 * with hash lookup made possible by keeping a list of keys in parallel to
 * an array of dictionary of values
 */
class TileCache {
    /**
     * @param max - number of permitted values
     * @param onRemove - callback called with items when they expire
     */
    constructor(max, onRemove) {
        this.max = max;
        this.onRemove = onRemove;
        this.reset();
    }
    /**
     * Clear the cache
     *
     * @returns this cache
     */
    reset() {
        for (const key in this.data) {
            for (const removedData of this.data[key]) {
                if (removedData.timeout)
                    clearTimeout(removedData.timeout);
                this.onRemove(removedData.value);
            }
        }
        this.data = {};
        this.order = [];
        return this;
    }
    /**
     * Add a key, value combination to the cache, trimming its size if this pushes
     * it over max length.
     *
     * @param tileID - lookup key for the item
     * @param data - tile data
     *
     * @returns this cache
     */
    add(tileID, data, expiryTimeout) {
        const key = tileID.wrapped().key;
        if (this.data[key] === undefined) {
            this.data[key] = [];
        }
        const dataWrapper = {
            value: data,
            timeout: undefined
        };
        if (expiryTimeout !== undefined) {
            dataWrapper.timeout = setTimeout(() => {
                this.remove(tileID, dataWrapper);
            }, expiryTimeout);
        }
        this.data[key].push(dataWrapper);
        this.order.push(key);
        if (this.order.length > this.max) {
            const removedData = this._getAndRemoveByKey(this.order[0]);
            if (removedData)
                this.onRemove(removedData);
        }
        return this;
    }
    /**
     * Determine whether the value attached to `key` is present
     *
     * @param tileID - the key to be looked-up
     * @returns whether the cache has this value
     */
    has(tileID) {
        return tileID.wrapped().key in this.data;
    }
    /**
     * Get the value attached to a specific key and remove data from cache.
     * If the key is not found, returns `null`
     *
     * @param tileID - the key to look up
     * @returns the tile data, or null if it isn't found
     */
    getAndRemove(tileID) {
        if (!this.has(tileID)) {
            return null;
        }
        return this._getAndRemoveByKey(tileID.wrapped().key);
    }
    /*
     * Get and remove the value with the specified key.
     */
    _getAndRemoveByKey(key) {
        const data = this.data[key].shift();
        if (data.timeout)
            clearTimeout(data.timeout);
        if (this.data[key].length === 0) {
            delete this.data[key];
        }
        this.order.splice(this.order.indexOf(key), 1);
        return data.value;
    }
    /*
     * Get the value with the specified (wrapped tile) key.
     */
    getByKey(key) {
        const data = this.data[key];
        return data ? data[0].value : null;
    }
    /**
     * Get the value attached to a specific key without removing data
     * from the cache. If the key is not found, returns `null`
     *
     * @param tileID - the key to look up
     * @returns the tile data, or null if it isn't found
     */
    get(tileID) {
        if (!this.has(tileID)) {
            return null;
        }
        const data = this.data[tileID.wrapped().key][0];
        return data.value;
    }
    /**
     * Remove a key/value combination from the cache.
     *
     * @param tileID - the key for the pair to delete
     * @param value - If a value is provided, remove that exact version of the value.
     * @returns this cache
     */
    remove(tileID, value) {
        if (!this.has(tileID)) {
            return this;
        }
        const key = tileID.wrapped().key;
        const dataIndex = value === undefined ? 0 : this.data[key].indexOf(value);
        const data = this.data[key][dataIndex];
        this.data[key].splice(dataIndex, 1);
        if (data.timeout)
            clearTimeout(data.timeout);
        if (this.data[key].length === 0) {
            delete this.data[key];
        }
        this.onRemove(data.value);
        this.order.splice(this.order.indexOf(key), 1);
        return this;
    }
    /**
     * Change the max size of the cache.
     *
     * @param max - the max size of the cache
     * @returns this cache
     */
    setMaxSize(max) {
        this.max = max;
        while (this.order.length > this.max) {
            const removedData = this._getAndRemoveByKey(this.order[0]);
            if (removedData)
                this.onRemove(removedData);
        }
        return this;
    }
    /**
     * Remove entries that do not pass a filter function. Used for removing
     * stale tiles from the cache.
     *
     * @param filterFn - Determines whether the tile is filtered. If the supplied function returns false, the tile will be filtered out.
     */
    filter(filterFn) {
        const removed = [];
        for (const key in this.data) {
            for (const entry of this.data[key]) {
                if (!filterFn(entry.value)) {
                    removed.push(entry);
                }
            }
        }
        for (const r of removed) {
            this.remove(r.value.tileID, r);
        }
    }
}

/**
 * @internal
 * SourceFeatureState manages the state and pending changes
 * to features in a source, separated by source layer.
 * stateChanges and deletedStates batch all changes to the tile (updates and removes, respectively)
 * between coalesce() events. addFeatureState() and removeFeatureState() also update their counterpart's
 * list of changes, such that coalesce() can apply the proper state changes while agnostic to the order of operations.
 * In deletedStates, all null's denote complete removal of state at that scope
*/
class SourceFeatureState {
    constructor() {
        this.state = {};
        this.stateChanges = {};
        this.deletedStates = {};
    }
    updateState(sourceLayer, featureId, newState) {
        const feature = String(featureId);
        this.stateChanges[sourceLayer] = this.stateChanges[sourceLayer] || {};
        this.stateChanges[sourceLayer][feature] = this.stateChanges[sourceLayer][feature] || {};
        performance$1.e(this.stateChanges[sourceLayer][feature], newState);
        if (this.deletedStates[sourceLayer] === null) {
            this.deletedStates[sourceLayer] = {};
            for (const ft in this.state[sourceLayer]) {
                if (ft !== feature)
                    this.deletedStates[sourceLayer][ft] = null;
            }
        }
        else {
            const featureDeletionQueued = this.deletedStates[sourceLayer] && this.deletedStates[sourceLayer][feature] === null;
            if (featureDeletionQueued) {
                this.deletedStates[sourceLayer][feature] = {};
                for (const prop in this.state[sourceLayer][feature]) {
                    if (!newState[prop])
                        this.deletedStates[sourceLayer][feature][prop] = null;
                }
            }
            else {
                for (const key in newState) {
                    const deletionInQueue = this.deletedStates[sourceLayer] && this.deletedStates[sourceLayer][feature] && this.deletedStates[sourceLayer][feature][key] === null;
                    if (deletionInQueue)
                        delete this.deletedStates[sourceLayer][feature][key];
                }
            }
        }
    }
    removeFeatureState(sourceLayer, featureId, key) {
        const sourceLayerDeleted = this.deletedStates[sourceLayer] === null;
        if (sourceLayerDeleted)
            return;
        const feature = String(featureId);
        this.deletedStates[sourceLayer] = this.deletedStates[sourceLayer] || {};
        if (key && featureId !== undefined) {
            if (this.deletedStates[sourceLayer][feature] !== null) {
                this.deletedStates[sourceLayer][feature] = this.deletedStates[sourceLayer][feature] || {};
                this.deletedStates[sourceLayer][feature][key] = null;
            }
        }
        else if (featureId !== undefined) {
            const updateInQueue = this.stateChanges[sourceLayer] && this.stateChanges[sourceLayer][feature];
            if (updateInQueue) {
                this.deletedStates[sourceLayer][feature] = {};
                for (key in this.stateChanges[sourceLayer][feature])
                    this.deletedStates[sourceLayer][feature][key] = null;
            }
            else {
                this.deletedStates[sourceLayer][feature] = null;
            }
        }
        else {
            this.deletedStates[sourceLayer] = null;
        }
    }
    getState(sourceLayer, featureId) {
        const feature = String(featureId);
        const base = this.state[sourceLayer] || {};
        const changes = this.stateChanges[sourceLayer] || {};
        const reconciledState = performance$1.e({}, base[feature], changes[feature]);
        //return empty object if the whole source layer is awaiting deletion
        if (this.deletedStates[sourceLayer] === null)
            return {};
        else if (this.deletedStates[sourceLayer]) {
            const featureDeletions = this.deletedStates[sourceLayer][featureId];
            if (featureDeletions === null)
                return {};
            for (const prop in featureDeletions)
                delete reconciledState[prop];
        }
        return reconciledState;
    }
    initializeTileState(tile, painter) {
        tile.setFeatureState(this.state, painter);
    }
    coalesceChanges(tiles, painter) {
        //track changes with full state objects, but only for features that got modified
        const featuresChanged = {};
        for (const sourceLayer in this.stateChanges) {
            this.state[sourceLayer] = this.state[sourceLayer] || {};
            const layerStates = {};
            for (const feature in this.stateChanges[sourceLayer]) {
                if (!this.state[sourceLayer][feature])
                    this.state[sourceLayer][feature] = {};
                performance$1.e(this.state[sourceLayer][feature], this.stateChanges[sourceLayer][feature]);
                layerStates[feature] = this.state[sourceLayer][feature];
            }
            featuresChanged[sourceLayer] = layerStates;
        }
        for (const sourceLayer in this.deletedStates) {
            this.state[sourceLayer] = this.state[sourceLayer] || {};
            const layerStates = {};
            if (this.deletedStates[sourceLayer] === null) {
                for (const ft in this.state[sourceLayer]) {
                    layerStates[ft] = {};
                    this.state[sourceLayer][ft] = {};
                }
            }
            else {
                for (const feature in this.deletedStates[sourceLayer]) {
                    const deleteWholeFeatureState = this.deletedStates[sourceLayer][feature] === null;
                    if (deleteWholeFeatureState)
                        this.state[sourceLayer][feature] = {};
                    else {
                        for (const key of Object.keys(this.deletedStates[sourceLayer][feature])) {
                            delete this.state[sourceLayer][feature][key];
                        }
                    }
                    layerStates[feature] = this.state[sourceLayer][feature];
                }
            }
            featuresChanged[sourceLayer] = featuresChanged[sourceLayer] || {};
            performance$1.e(featuresChanged[sourceLayer], layerStates);
        }
        this.stateChanges = {};
        this.deletedStates = {};
        if (Object.keys(featuresChanged).length === 0)
            return;
        for (const id in tiles) {
            const tile = tiles[id];
            tile.setFeatureState(featuresChanged, painter);
        }
    }
}

/**
 * @internal
 * `SourceCache` is responsible for
 *
 *  - creating an instance of `Source`
 *  - forwarding events from `Source`
 *  - caching tiles loaded from an instance of `Source`
 *  - loading the tiles needed to render a given viewport
 *  - unloading the cached tiles not needed to render a given viewport
 */
class SourceCache extends performance$1.E {
    constructor(id, options, dispatcher) {
        super();
        this.id = id;
        this.dispatcher = dispatcher;
        this.on('data', (e) => this._dataHandler(e));
        this.on('dataloading', () => {
            this._sourceErrored = false;
        });
        this.on('error', () => {
            // Only set _sourceErrored if the source does not have pending loads.
            this._sourceErrored = this._source.loaded();
        });
        this._source = create(id, options, dispatcher, this);
        this._tiles = {};
        this._cache = new TileCache(0, (tile) => this._unloadTile(tile));
        this._timers = {};
        this._cacheTimers = {};
        this._maxTileCacheSize = null;
        this._maxTileCacheZoomLevels = null;
        this._loadedParentTiles = {};
        this._coveredTiles = {};
        this._state = new SourceFeatureState();
        this._didEmitContent = false;
        this._updated = false;
    }
    onAdd(map) {
        this.map = map;
        this._maxTileCacheSize = map ? map._maxTileCacheSize : null;
        this._maxTileCacheZoomLevels = map ? map._maxTileCacheZoomLevels : null;
        if (this._source && this._source.onAdd) {
            this._source.onAdd(map);
        }
    }
    onRemove(map) {
        this.clearTiles();
        if (this._source && this._source.onRemove) {
            this._source.onRemove(map);
        }
    }
    /**
     * Return true if no tile data is pending, tiles will not change unless
     * an additional API call is received.
     */
    loaded() {
        if (this._sourceErrored) {
            return true;
        }
        if (!this._sourceLoaded) {
            return false;
        }
        if (!this._source.loaded()) {
            return false;
        }
        if ((this.used !== undefined || this.usedForTerrain !== undefined) && !this.used && !this.usedForTerrain) {
            return true;
        }
        // do not consider as loaded if the update hasn't been called yet (we do not know if we will have any tiles to fetch)
        if (!this._updated) {
            return false;
        }
        for (const t in this._tiles) {
            const tile = this._tiles[t];
            if (tile.state !== 'loaded' && tile.state !== 'errored')
                return false;
        }
        return true;
    }
    getSource() {
        return this._source;
    }
    pause() {
        this._paused = true;
    }
    resume() {
        if (!this._paused)
            return;
        const shouldReload = this._shouldReloadOnResume;
        this._paused = false;
        this._shouldReloadOnResume = false;
        if (shouldReload)
            this.reload();
        if (this.transform)
            this.update(this.transform, this.terrain);
    }
    _loadTile(tile, id, state) {
        return performance$1._(this, void 0, void 0, function* () {
            try {
                yield this._source.loadTile(tile);
                this._tileLoaded(tile, id, state);
            }
            catch (err) {
                tile.state = 'errored';
                if (err.status !== 404) {
                    this._source.fire(new performance$1.j(err, { tile }));
                }
                else {
                    // continue to try loading parent/children tiles if a tile doesn't exist (404)
                    this.update(this.transform, this.terrain);
                }
            }
        });
    }
    _unloadTile(tile) {
        if (this._source.unloadTile)
            this._source.unloadTile(tile);
    }
    _abortTile(tile) {
        if (this._source.abortTile)
            this._source.abortTile(tile);
        this._source.fire(new performance$1.k('dataabort', { tile, coord: tile.tileID, dataType: 'source' }));
    }
    serialize() {
        return this._source.serialize();
    }
    prepare(context) {
        if (this._source.prepare) {
            this._source.prepare();
        }
        this._state.coalesceChanges(this._tiles, this.map ? this.map.painter : null);
        for (const i in this._tiles) {
            const tile = this._tiles[i];
            tile.upload(context);
            tile.prepare(this.map.style.imageManager);
        }
    }
    /**
     * Return all tile ids ordered with z-order, and cast to numbers
     */
    getIds() {
        return Object.values(this._tiles).map((tile) => tile.tileID).sort(compareTileId).map(id => id.key);
    }
    getRenderableIds(symbolLayer) {
        const renderables = [];
        for (const id in this._tiles) {
            if (this._isIdRenderable(id, symbolLayer))
                renderables.push(this._tiles[id]);
        }
        if (symbolLayer) {
            return renderables.sort((a_, b_) => {
                const a = a_.tileID;
                const b = b_.tileID;
                const rotatedA = (new performance$1.P(a.canonical.x, a.canonical.y))._rotate(this.transform.angle);
                const rotatedB = (new performance$1.P(b.canonical.x, b.canonical.y))._rotate(this.transform.angle);
                return a.overscaledZ - b.overscaledZ || rotatedB.y - rotatedA.y || rotatedB.x - rotatedA.x;
            }).map(tile => tile.tileID.key);
        }
        return renderables.map(tile => tile.tileID).sort(compareTileId).map(id => id.key);
    }
    hasRenderableParent(tileID) {
        const parentTile = this.findLoadedParent(tileID, 0);
        if (parentTile) {
            return this._isIdRenderable(parentTile.tileID.key);
        }
        return false;
    }
    _isIdRenderable(id, symbolLayer) {
        return this._tiles[id] && this._tiles[id].hasData() &&
            !this._coveredTiles[id] && (symbolLayer || !this._tiles[id].holdingForFade());
    }
    reload() {
        if (this._paused) {
            this._shouldReloadOnResume = true;
            return;
        }
        this._cache.reset();
        for (const i in this._tiles) {
            if (this._tiles[i].state !== 'errored')
                this._reloadTile(i, 'reloading');
        }
    }
    _reloadTile(id, state) {
        return performance$1._(this, void 0, void 0, function* () {
            const tile = this._tiles[id];
            // this potentially does not address all underlying
            // issues https://github.com/mapbox/mapbox-gl-js/issues/4252
            // - hard to tell without repro steps
            if (!tile)
                return;
            // The difference between "loading" tiles and "reloading" or "expired"
            // tiles is that "reloading"/"expired" tiles are "renderable".
            // Therefore, a "loading" tile cannot become a "reloading" tile without
            // first becoming a "loaded" tile.
            if (tile.state !== 'loading') {
                tile.state = state;
            }
            yield this._loadTile(tile, id, state);
        });
    }
    _tileLoaded(tile, id, previousState) {
        tile.timeAdded = browser.now();
        if (previousState === 'expired')
            tile.refreshedUponExpiration = true;
        this._setTileReloadTimer(id, tile);
        if (this.getSource().type === 'raster-dem' && tile.dem)
            this._backfillDEM(tile);
        this._state.initializeTileState(tile, this.map ? this.map.painter : null);
        if (!tile.aborted) {
            this._source.fire(new performance$1.k('data', { dataType: 'source', tile, coord: tile.tileID }));
        }
    }
    /**
     * For raster terrain source, backfill DEM to eliminate visible tile boundaries
     */
    _backfillDEM(tile) {
        const renderables = this.getRenderableIds();
        for (let i = 0; i < renderables.length; i++) {
            const borderId = renderables[i];
            if (tile.neighboringTiles && tile.neighboringTiles[borderId]) {
                const borderTile = this.getTileByID(borderId);
                fillBorder(tile, borderTile);
                fillBorder(borderTile, tile);
            }
        }
        function fillBorder(tile, borderTile) {
            tile.needsHillshadePrepare = true;
            tile.needsTerrainPrepare = true;
            let dx = borderTile.tileID.canonical.x - tile.tileID.canonical.x;
            const dy = borderTile.tileID.canonical.y - tile.tileID.canonical.y;
            const dim = Math.pow(2, tile.tileID.canonical.z);
            const borderId = borderTile.tileID.key;
            if (dx === 0 && dy === 0)
                return;
            if (Math.abs(dy) > 1) {
                return;
            }
            if (Math.abs(dx) > 1) {
                // Adjust the delta coordinate for world wraparound.
                if (Math.abs(dx + dim) === 1) {
                    dx += dim;
                }
                else if (Math.abs(dx - dim) === 1) {
                    dx -= dim;
                }
            }
            if (!borderTile.dem || !tile.dem)
                return;
            tile.dem.backfillBorder(borderTile.dem, dx, dy);
            if (tile.neighboringTiles && tile.neighboringTiles[borderId])
                tile.neighboringTiles[borderId].backfilled = true;
        }
    }
    /**
     * Get a specific tile by TileID
     */
    getTile(tileID) {
        return this.getTileByID(tileID.key);
    }
    /**
     * Get a specific tile by id
     */
    getTileByID(id) {
        return this._tiles[id];
    }
    /**
     * For a given set of tiles, retain children that are loaded and have a zoom
     * between `zoom` (exclusive) and `maxCoveringZoom` (inclusive)
     */
    _retainLoadedChildren(idealTiles, zoom, maxCoveringZoom, retain) {
        for (const id in this._tiles) {
            let tile = this._tiles[id];
            // only consider renderable tiles up to maxCoveringZoom
            if (retain[id] ||
                !tile.hasData() ||
                tile.tileID.overscaledZ <= zoom ||
                tile.tileID.overscaledZ > maxCoveringZoom)
                continue;
            // loop through parents and retain the topmost loaded one if found
            let topmostLoadedID = tile.tileID;
            while (tile && tile.tileID.overscaledZ > zoom + 1) {
                const parentID = tile.tileID.scaledTo(tile.tileID.overscaledZ - 1);
                tile = this._tiles[parentID.key];
                if (tile && tile.hasData()) {
                    topmostLoadedID = parentID;
                }
            }
            // loop through ancestors of the topmost loaded child to see if there's one that needed it
            let tileID = topmostLoadedID;
            while (tileID.overscaledZ > zoom) {
                tileID = tileID.scaledTo(tileID.overscaledZ - 1);
                if (idealTiles[tileID.key]) {
                    // found a parent that needed a loaded child; retain that child
                    retain[topmostLoadedID.key] = topmostLoadedID;
                    break;
                }
            }
        }
    }
    /**
     * Find a loaded parent of the given tile (up to minCoveringZoom)
     */
    findLoadedParent(tileID, minCoveringZoom) {
        if (tileID.key in this._loadedParentTiles) {
            const parent = this._loadedParentTiles[tileID.key];
            if (parent && parent.tileID.overscaledZ >= minCoveringZoom) {
                return parent;
            }
            else {
                return null;
            }
        }
        for (let z = tileID.overscaledZ - 1; z >= minCoveringZoom; z--) {
            const parentTileID = tileID.scaledTo(z);
            const tile = this._getLoadedTile(parentTileID);
            if (tile) {
                return tile;
            }
        }
    }
    /**
     * Find a loaded sibling of the given tile
     */
    findLoadedSibling(tileID) {
        // If a tile with this ID already exists, return it
        return this._getLoadedTile(tileID);
    }
    _getLoadedTile(tileID) {
        const tile = this._tiles[tileID.key];
        if (tile && tile.hasData()) {
            return tile;
        }
        // TileCache ignores wrap in lookup.
        const cachedTile = this._cache.getByKey(tileID.wrapped().key);
        return cachedTile;
    }
    /**
     * Resizes the tile cache based on the current viewport's size
     * or the maxTileCacheSize option passed during map creation
     *
     * Larger viewports use more tiles and need larger caches. Larger viewports
     * are more likely to be found on devices with more memory and on pages where
     * the map is more important.
     */
    updateCacheSize(transform) {
        const widthInTiles = Math.ceil(transform.width / this._source.tileSize) + 1;
        const heightInTiles = Math.ceil(transform.height / this._source.tileSize) + 1;
        const approxTilesInView = widthInTiles * heightInTiles;
        const commonZoomRange = this._maxTileCacheZoomLevels === null ?
            performance$1.a.MAX_TILE_CACHE_ZOOM_LEVELS : this._maxTileCacheZoomLevels;
        const viewDependentMaxSize = Math.floor(approxTilesInView * commonZoomRange);
        const maxSize = typeof this._maxTileCacheSize === 'number' ?
            Math.min(this._maxTileCacheSize, viewDependentMaxSize) : viewDependentMaxSize;
        this._cache.setMaxSize(maxSize);
    }
    handleWrapJump(lng) {
        // On top of the regular z/x/y values, TileIDs have a `wrap` value that specify
        // which cppy of the world the tile belongs to. For example, at `lng: 10` you
        // might render z/x/y/0 while at `lng: 370` you would render z/x/y/1.
        //
        // When lng values get wrapped (going from `lng: 370` to `long: 10`) you expect
        // to see the same thing on the screen (370 degrees and 10 degrees is the same
        // place in the world) but all the TileIDs will have different wrap values.
        //
        // In order to make this transition seamless, we calculate the rounded difference of
        // "worlds" between the last frame and the current frame. If the map panned by
        // a world, then we can assign all the tiles new TileIDs with updated wrap values.
        // For example, assign z/x/y/1 a new id: z/x/y/0. It is the same tile, just rendered
        // in a different position.
        //
        // This enables us to reuse the tiles at more ideal locations and prevent flickering.
        const prevLng = this._prevLng === undefined ? lng : this._prevLng;
        const lngDifference = lng - prevLng;
        const worldDifference = lngDifference / 360;
        const wrapDelta = Math.round(worldDifference);
        this._prevLng = lng;
        if (wrapDelta) {
            const tiles = {};
            for (const key in this._tiles) {
                const tile = this._tiles[key];
                tile.tileID = tile.tileID.unwrapTo(tile.tileID.wrap + wrapDelta);
                tiles[tile.tileID.key] = tile;
            }
            this._tiles = tiles;
            // Reset tile reload timers
            for (const id in this._timers) {
                clearTimeout(this._timers[id]);
                delete this._timers[id];
            }
            for (const id in this._tiles) {
                const tile = this._tiles[id];
                this._setTileReloadTimer(id, tile);
            }
        }
    }
    _updateCoveredAndRetainedTiles(retain, minCoveringZoom, maxCoveringZoom, zoom, idealTileIDs, terrain) {
        const tilesForFading = {};
        const fadingTiles = {};
        const ids = Object.keys(retain);
        const now = browser.now();
        for (const id of ids) {
            const tileID = retain[id];
            const tile = this._tiles[id];
            // when fadeEndTime is 0, the tile is created but registerFadeDuration
            // has not been called, therefore must be kept in fadingTiles dictionary
            // for next round of rendering
            if (!tile || (tile.fadeEndTime !== 0 && tile.fadeEndTime <= now)) {
                continue;
            }
            // if the tile is loaded but still fading in, find parents to cross-fade with it
            const parentTile = this.findLoadedParent(tileID, minCoveringZoom);
            const siblingTile = this.findLoadedSibling(tileID);
            const fadeTileRef = parentTile || siblingTile || null;
            if (fadeTileRef) {
                this._addTile(fadeTileRef.tileID);
                tilesForFading[fadeTileRef.tileID.key] = fadeTileRef.tileID;
            }
            fadingTiles[id] = tileID;
        }
        // for tiles that are still fading in, also find children to cross-fade with
        this._retainLoadedChildren(fadingTiles, zoom, maxCoveringZoom, retain);
        for (const id in tilesForFading) {
            if (!retain[id]) {
                // If a tile is only needed for fading, mark it as covered so that it isn't rendered on it's own.
                this._coveredTiles[id] = true;
                retain[id] = tilesForFading[id];
            }
        }
        // disable fading logic in terrain3D mode to avoid rendering two tiles on the same place
        if (terrain) {
            const idealRasterTileIDs = {};
            const missingTileIDs = {};
            for (const tileID of idealTileIDs) {
                if (this._tiles[tileID.key].hasData())
                    idealRasterTileIDs[tileID.key] = tileID;
                else
                    missingTileIDs[tileID.key] = tileID;
            }
            // search for a complete set of children for each missing tile
            for (const key in missingTileIDs) {
                const children = missingTileIDs[key].children(this._source.maxzoom);
                if (this._tiles[children[0].key] && this._tiles[children[1].key] && this._tiles[children[2].key] && this._tiles[children[3].key]) {
                    idealRasterTileIDs[children[0].key] = retain[children[0].key] = children[0];
                    idealRasterTileIDs[children[1].key] = retain[children[1].key] = children[1];
                    idealRasterTileIDs[children[2].key] = retain[children[2].key] = children[2];
                    idealRasterTileIDs[children[3].key] = retain[children[3].key] = children[3];
                    delete missingTileIDs[key];
                }
            }
            // search for parent or sibling for each missing tile
            for (const key in missingTileIDs) {
                const tileID = missingTileIDs[key];
                const parentTile = this.findLoadedParent(tileID, this._source.minzoom);
                const siblingTile = this.findLoadedSibling(tileID);
                const fadeTileRef = parentTile || siblingTile || null;
                if (fadeTileRef) {
                    idealRasterTileIDs[fadeTileRef.tileID.key] = retain[fadeTileRef.tileID.key] = fadeTileRef.tileID;
                    // remove idealTiles which would be rendered twice
                    for (const key in idealRasterTileIDs) {
                        if (idealRasterTileIDs[key].isChildOf(fadeTileRef.tileID))
                            delete idealRasterTileIDs[key];
                    }
                }
            }
            // cover all tiles which are not needed
            for (const key in this._tiles) {
                if (!idealRasterTileIDs[key])
                    this._coveredTiles[key] = true;
            }
        }
    }
    /**
     * Removes tiles that are outside the viewport and adds new tiles that
     * are inside the viewport.
     */
    update(transform, terrain) {
        if (!this._sourceLoaded || this._paused) {
            return;
        }
        this.transform = transform;
        this.terrain = terrain;
        this.updateCacheSize(transform);
        this.handleWrapJump(this.transform.center.lng);
        // Covered is a list of retained tiles who's areas are fully covered by other,
        // better, retained tiles. They are not drawn separately.
        this._coveredTiles = {};
        let idealTileIDs;
        if (!this.used && !this.usedForTerrain) {
            idealTileIDs = [];
        }
        else if (this._source.tileID) {
            idealTileIDs = transform.getVisibleUnwrappedCoordinates(this._source.tileID)
                .map((unwrapped) => new performance$1.S(unwrapped.canonical.z, unwrapped.wrap, unwrapped.canonical.z, unwrapped.canonical.x, unwrapped.canonical.y));
        }
        else {
            idealTileIDs = transform.coveringTiles({
                tileSize: this.usedForTerrain ? this.tileSize : this._source.tileSize,
                minzoom: this._source.minzoom,
                maxzoom: this._source.maxzoom,
                roundZoom: this.usedForTerrain ? false : this._source.roundZoom,
                reparseOverscaled: this._source.reparseOverscaled,
                terrain
            });
            if (this._source.hasTile) {
                idealTileIDs = idealTileIDs.filter((coord) => this._source.hasTile(coord));
            }
        }
        // Determine the overzooming/underzooming amounts.
        const zoom = transform.coveringZoomLevel(this._source);
        const minCoveringZoom = Math.max(zoom - SourceCache.maxOverzooming, this._source.minzoom);
        const maxCoveringZoom = Math.max(zoom + SourceCache.maxUnderzooming, this._source.minzoom);
        // When sourcecache is used for terrain also load parent tiles to avoid flickering when zooming out
        if (this.usedForTerrain) {
            const parents = {};
            for (const tileID of idealTileIDs) {
                if (tileID.canonical.z > this._source.minzoom) {
                    const parent = tileID.scaledTo(tileID.canonical.z - 1);
                    parents[parent.key] = parent;
                    // load very low zoom to calculate tile visibility in transform.coveringTiles and high zoomlevels correct
                    const parent2 = tileID.scaledTo(Math.max(this._source.minzoom, Math.min(tileID.canonical.z, 5)));
                    parents[parent2.key] = parent2;
                }
            }
            idealTileIDs = idealTileIDs.concat(Object.values(parents));
        }
        const noPendingDataEmissions = idealTileIDs.length === 0 && !this._updated && this._didEmitContent;
        this._updated = true;
        // if we won't have any tiles to fetch and content is already emitted
        // there will be no more data emissions, so we need to emit the event with isSourceLoaded = true
        if (noPendingDataEmissions) {
            this.fire(new performance$1.k('data', { sourceDataType: 'idle', dataType: 'source', sourceId: this.id }));
        }
        // Retain is a list of tiles that we shouldn't delete, even if they are not
        // the most ideal tile for the current viewport. This may include tiles like
        // parent or child tiles that are *already* loaded.
        const retain = this._updateRetainedTiles(idealTileIDs, zoom);
        if (isRasterType(this._source.type)) {
            this._updateCoveredAndRetainedTiles(retain, minCoveringZoom, maxCoveringZoom, zoom, idealTileIDs, terrain);
        }
        for (const retainedId in retain) {
            // Make sure retained tiles always clear any existing fade holds
            // so that if they're removed again their fade timer starts fresh.
            this._tiles[retainedId].clearFadeHold();
        }
        // Remove the tiles we don't need anymore.
        const remove = performance$1.ac(this._tiles, retain);
        for (const tileID of remove) {
            const tile = this._tiles[tileID];
            if (tile.hasSymbolBuckets && !tile.holdingForFade()) {
                tile.setHoldDuration(this.map._fadeDuration);
            }
            else if (!tile.hasSymbolBuckets || tile.symbolFadeFinished()) {
                this._removeTile(tileID);
            }
        }
        // Construct caches of loaded parents & siblings
        this._updateLoadedParentTileCache();
        this._updateLoadedSiblingTileCache();
    }
    releaseSymbolFadeTiles() {
        for (const id in this._tiles) {
            if (this._tiles[id].holdingForFade()) {
                this._removeTile(id);
            }
        }
    }
    _updateRetainedTiles(idealTileIDs, zoom) {
        var _a;
        const retain = {};
        const checked = {};
        const minCoveringZoom = Math.max(zoom - SourceCache.maxOverzooming, this._source.minzoom);
        const maxCoveringZoom = Math.max(zoom + SourceCache.maxUnderzooming, this._source.minzoom);
        const missingTiles = {};
        for (const tileID of idealTileIDs) {
            const tile = this._addTile(tileID);
            // retain the tile even if it's not loaded because it's an ideal tile.
            retain[tileID.key] = tileID;
            if (tile.hasData())
                continue;
            if (zoom < this._source.maxzoom) {
                // save missing tiles that potentially have loaded children
                missingTiles[tileID.key] = tileID;
            }
        }
        // retain any loaded children of ideal tiles up to maxCoveringZoom
        this._retainLoadedChildren(missingTiles, zoom, maxCoveringZoom, retain);
        for (const tileID of idealTileIDs) {
            let tile = this._tiles[tileID.key];
            if (tile.hasData())
                continue;
            // The tile we require is not yet loaded or does not exist;
            // Attempt to find children that fully cover it.
            if (zoom + 1 > this._source.maxzoom) {
                // We're looking for an overzoomed child tile.
                const childCoord = tileID.children(this._source.maxzoom)[0];
                const childTile = this.getTile(childCoord);
                if (!!childTile && childTile.hasData()) {
                    retain[childCoord.key] = childCoord;
                    continue; // tile is covered by overzoomed child
                }
            }
            else {
                // check if all 4 immediate children are loaded (i.e. the missing ideal tile is covered)
                const children = tileID.children(this._source.maxzoom);
                if (retain[children[0].key] &&
                    retain[children[1].key] &&
                    retain[children[2].key] &&
                    retain[children[3].key])
                    continue; // tile is covered by children
            }
            // We couldn't find child tiles that entirely cover the ideal tile; look for parents now.
            // As we ascend up the tile pyramid of the ideal tile, we check whether the parent
            // tile has been previously requested (and errored because we only loop over tiles with no data)
            // in order to determine if we need to request its parent.
            let parentWasRequested = tile.wasRequested();
            for (let overscaledZ = tileID.overscaledZ - 1; overscaledZ >= minCoveringZoom; --overscaledZ) {
                const parentId = tileID.scaledTo(overscaledZ);
                // Break parent tile ascent if this route has been previously checked by another child.
                if (checked[parentId.key])
                    break;
                checked[parentId.key] = true;
                tile = this.getTile(parentId);
                if (!tile && parentWasRequested) {
                    tile = this._addTile(parentId);
                }
                if (tile) {
                    const hasData = tile.hasData();
                    if (hasData || !((_a = this.map) === null || _a === void 0 ? void 0 : _a.cancelPendingTileRequestsWhileZooming) || parentWasRequested) {
                        retain[parentId.key] = parentId;
                    }
                    // Save the current values, since they're the parent of the next iteration
                    // of the parent tile ascent loop.
                    parentWasRequested = tile.wasRequested();
                    if (hasData)
                        break;
                }
            }
        }
        return retain;
    }
    _updateLoadedParentTileCache() {
        this._loadedParentTiles = {};
        for (const tileKey in this._tiles) {
            const path = [];
            let parentTile;
            let currentId = this._tiles[tileKey].tileID;
            // Find the closest loaded ancestor by traversing the tile tree towards the root and
            // caching results along the way
            while (currentId.overscaledZ > 0) {
                // Do we have a cached result from previous traversals?
                if (currentId.key in this._loadedParentTiles) {
                    parentTile = this._loadedParentTiles[currentId.key];
                    break;
                }
                path.push(currentId.key);
                // Is the parent loaded?
                const parentId = currentId.scaledTo(currentId.overscaledZ - 1);
                parentTile = this._getLoadedTile(parentId);
                if (parentTile) {
                    break;
                }
                currentId = parentId;
            }
            // Cache the result of this traversal to all newly visited tiles
            for (const key of path) {
                this._loadedParentTiles[key] = parentTile;
            }
        }
    }
    /**
     * Update the cache of loaded sibling tiles
     *
     * Sibling tiles are tiles that share the same zoom level and
     * x/y position but have different wrap values
     * Maintaining sibling tile cache allows fading from old to new tiles
     * of the same position and zoom level
     */
    _updateLoadedSiblingTileCache() {
        this._loadedSiblingTiles = {};
        for (const tileKey in this._tiles) {
            const currentId = this._tiles[tileKey].tileID;
            const siblingTile = this._getLoadedTile(currentId);
            this._loadedSiblingTiles[currentId.key] = siblingTile;
        }
    }
    /**
     * Add a tile, given its coordinate, to the pyramid.
     */
    _addTile(tileID) {
        let tile = this._tiles[tileID.key];
        if (tile)
            return tile;
        tile = this._cache.getAndRemove(tileID);
        if (tile) {
            this._setTileReloadTimer(tileID.key, tile);
            // set the tileID because the cached tile could have had a different wrap value
            tile.tileID = tileID;
            this._state.initializeTileState(tile, this.map ? this.map.painter : null);
            if (this._cacheTimers[tileID.key]) {
                clearTimeout(this._cacheTimers[tileID.key]);
                delete this._cacheTimers[tileID.key];
                this._setTileReloadTimer(tileID.key, tile);
            }
        }
        const cached = tile;
        if (!tile) {
            tile = new Tile(tileID, this._source.tileSize * tileID.overscaleFactor());
            this._loadTile(tile, tileID.key, tile.state);
        }
        tile.uses++;
        this._tiles[tileID.key] = tile;
        if (!cached) {
            this._source.fire(new performance$1.k('dataloading', { tile, coord: tile.tileID, dataType: 'source' }));
        }
        return tile;
    }
    _setTileReloadTimer(id, tile) {
        if (id in this._timers) {
            clearTimeout(this._timers[id]);
            delete this._timers[id];
        }
        const expiryTimeout = tile.getExpiryTimeout();
        if (expiryTimeout) {
            this._timers[id] = setTimeout(() => {
                this._reloadTile(id, 'expired');
                delete this._timers[id];
            }, expiryTimeout);
        }
    }
    /**
     * Remove a tile, given its id, from the pyramid
     */
    _removeTile(id) {
        const tile = this._tiles[id];
        if (!tile)
            return;
        tile.uses--;
        delete this._tiles[id];
        if (this._timers[id]) {
            clearTimeout(this._timers[id]);
            delete this._timers[id];
        }
        if (tile.uses > 0)
            return;
        if (tile.hasData() && tile.state !== 'reloading') {
            this._cache.add(tile.tileID, tile, tile.getExpiryTimeout());
        }
        else {
            tile.aborted = true;
            this._abortTile(tile);
            this._unloadTile(tile);
        }
    }
    /** @internal */
    _dataHandler(e) {
        const eventSourceDataType = e.sourceDataType;
        if (e.dataType === 'source' && eventSourceDataType === 'metadata') {
            this._sourceLoaded = true;
        }
        // for sources with mutable data, this event fires when the underlying data
        // to a source is changed. (i.e. GeoJSONSource#setData and ImageSource#serCoordinates)
        if (this._sourceLoaded && !this._paused && e.dataType === 'source' && eventSourceDataType === 'content') {
            this.reload();
            if (this.transform) {
                this.update(this.transform, this.terrain);
            }
            this._didEmitContent = true;
        }
    }
    /**
     * Remove all tiles from this pyramid
     */
    clearTiles() {
        this._shouldReloadOnResume = false;
        this._paused = false;
        for (const id in this._tiles)
            this._removeTile(id);
        this._cache.reset();
    }
    /**
     * Search through our current tiles and attempt to find the tiles that
     * cover the given bounds.
     * @param pointQueryGeometry - coordinates of the corners of bounding rectangle
     * @returns result items have `{tile, minX, maxX, minY, maxY}`, where min/max bounding values are the given bounds transformed in into the coordinate space of this tile.
     */
    tilesIn(pointQueryGeometry, maxPitchScaleFactor, has3DLayer) {
        const tileResults = [];
        const transform = this.transform;
        if (!transform)
            return tileResults;
        const cameraPointQueryGeometry = has3DLayer ?
            transform.getCameraQueryGeometry(pointQueryGeometry) :
            pointQueryGeometry;
        const queryGeometry = pointQueryGeometry.map((p) => transform.pointCoordinate(p, this.terrain));
        const cameraQueryGeometry = cameraPointQueryGeometry.map((p) => transform.pointCoordinate(p, this.terrain));
        const ids = this.getIds();
        let minX = Infinity;
        let minY = Infinity;
        let maxX = -Infinity;
        let maxY = -Infinity;
        for (const p of cameraQueryGeometry) {
            minX = Math.min(minX, p.x);
            minY = Math.min(minY, p.y);
            maxX = Math.max(maxX, p.x);
            maxY = Math.max(maxY, p.y);
        }
        for (let i = 0; i < ids.length; i++) {
            const tile = this._tiles[ids[i]];
            if (tile.holdingForFade()) {
                // Tiles held for fading are covered by tiles that are closer to ideal
                continue;
            }
            const tileID = tile.tileID;
            const scale = Math.pow(2, transform.zoom - tile.tileID.overscaledZ);
            const queryPadding = maxPitchScaleFactor * tile.queryPadding * performance$1.X / tile.tileSize / scale;
            const tileSpaceBounds = [
                tileID.getTilePoint(new performance$1.Z(minX, minY)),
                tileID.getTilePoint(new performance$1.Z(maxX, maxY))
            ];
            if (tileSpaceBounds[0].x - queryPadding < performance$1.X && tileSpaceBounds[0].y - queryPadding < performance$1.X &&
                tileSpaceBounds[1].x + queryPadding >= 0 && tileSpaceBounds[1].y + queryPadding >= 0) {
                const tileSpaceQueryGeometry = queryGeometry.map((c) => tileID.getTilePoint(c));
                const tileSpaceCameraQueryGeometry = cameraQueryGeometry.map((c) => tileID.getTilePoint(c));
                tileResults.push({
                    tile,
                    tileID,
                    queryGeometry: tileSpaceQueryGeometry,
                    cameraQueryGeometry: tileSpaceCameraQueryGeometry,
                    scale
                });
            }
        }
        return tileResults;
    }
    getVisibleCoordinates(symbolLayer) {
        const coords = this.getRenderableIds(symbolLayer).map((id) => this._tiles[id].tileID);
        for (const coord of coords) {
            coord.posMatrix = this.transform.calculatePosMatrix(coord.toUnwrapped());
        }
        return coords;
    }
    hasTransition() {
        if (this._source.hasTransition()) {
            return true;
        }
        if (isRasterType(this._source.type)) {
            const now = browser.now();
            for (const id in this._tiles) {
                const tile = this._tiles[id];
                if (tile.fadeEndTime >= now) {
                    return true;
                }
            }
        }
        return false;
    }
    /**
     * Set the value of a particular state for a feature
     */
    setFeatureState(sourceLayer, featureId, state) {
        sourceLayer = sourceLayer || '_geojsonTileLayer';
        this._state.updateState(sourceLayer, featureId, state);
    }
    /**
     * Resets the value of a particular state key for a feature
     */
    removeFeatureState(sourceLayer, featureId, key) {
        sourceLayer = sourceLayer || '_geojsonTileLayer';
        this._state.removeFeatureState(sourceLayer, featureId, key);
    }
    /**
     * Get the entire state object for a feature
     */
    getFeatureState(sourceLayer, featureId) {
        sourceLayer = sourceLayer || '_geojsonTileLayer';
        return this._state.getState(sourceLayer, featureId);
    }
    /**
     * Sets the set of keys that the tile depends on. This allows tiles to
     * be reloaded when their dependencies change.
     */
    setDependencies(tileKey, namespace, dependencies) {
        const tile = this._tiles[tileKey];
        if (tile) {
            tile.setDependencies(namespace, dependencies);
        }
    }
    /**
     * Reloads all tiles that depend on the given keys.
     */
    reloadTilesForDependencies(namespaces, keys) {
        for (const id in this._tiles) {
            const tile = this._tiles[id];
            if (tile.hasDependency(namespaces, keys)) {
                this._reloadTile(id, 'reloading');
            }
        }
        this._cache.filter(tile => !tile.hasDependency(namespaces, keys));
    }
}
SourceCache.maxOverzooming = 10;
SourceCache.maxUnderzooming = 3;
function compareTileId(a, b) {
    // Different copies of the world are sorted based on their distance to the center.
    // Wrap values are converted to unsigned distances by reserving odd number for copies
    // with negative wrap and even numbers for copies with positive wrap.
    const aWrap = Math.abs(a.wrap * 2) - +(a.wrap < 0);
    const bWrap = Math.abs(b.wrap * 2) - +(b.wrap < 0);
    return a.overscaledZ - b.overscaledZ || bWrap - aWrap || b.canonical.y - a.canonical.y || b.canonical.x - a.canonical.x;
}
function isRasterType(type) {
    return type === 'raster' || type === 'image' || type === 'video';
}

class PathInterpolator {
    constructor(points_, padding_) {
        this.reset(points_, padding_);
    }
    reset(points_, padding_) {
        this.points = points_ || [];
        // Compute cumulative distance from first point to every other point in the segment.
        // Last entry in the array is total length of the path
        this._distances = [0.0];
        for (let i = 1; i < this.points.length; i++) {
            this._distances[i] = this._distances[i - 1] + this.points[i].dist(this.points[i - 1]);
        }
        this.length = this._distances[this._distances.length - 1];
        this.padding = Math.min(padding_ || 0, this.length * 0.5);
        this.paddedLength = this.length - this.padding * 2.0;
    }
    lerp(t) {
        if (this.points.length === 1) {
            return this.points[0];
        }
        t = performance$1.ad(t, 0, 1);
        // Find the correct segment [p0, p1] where p0 <= x < p1
        let currentIndex = 1;
        let distOfCurrentIdx = this._distances[currentIndex];
        const distToTarget = t * this.paddedLength + this.padding;
        while (distOfCurrentIdx < distToTarget && currentIndex < this._distances.length) {
            distOfCurrentIdx = this._distances[++currentIndex];
        }
        // Interpolate between the two points of the segment
        const idxOfPrevPoint = currentIndex - 1;
        const distOfPrevIdx = this._distances[idxOfPrevPoint];
        const segmentLength = distOfCurrentIdx - distOfPrevIdx;
        const segmentT = segmentLength > 0 ? (distToTarget - distOfPrevIdx) / segmentLength : 0;
        return this.points[idxOfPrevPoint].mult(1.0 - segmentT).add(this.points[currentIndex].mult(segmentT));
    }
}

function overlapAllowed(overlapA, overlapB) {
    let allowed = true;
    if (overlapA === 'always') ;
    else if (overlapA === 'never' || overlapB === 'never') {
        // symbol A using 'never' overlap - can't overlap anything
        // symbol A using 'cooperative' overlap - can overlap 'always' or 'cooperative' symbol; can't overlap 'never'
        allowed = false;
    }
    return allowed;
}
/**
 * @internal
 * GridIndex is a data structure for testing the intersection of
 * circles and rectangles in a 2d plane.
 * It is optimized for rapid insertion and querying.
 * GridIndex splits the plane into a set of "cells" and keeps track
 * of which geometries intersect with each cell. At query time,
 * full geometry comparisons are only done for items that share
 * at least one cell. As long as the geometries are relatively
 * uniformly distributed across the plane, this greatly reduces
 * the number of comparisons necessary.
 */
class GridIndex {
    constructor(width, height, cellSize) {
        const boxCells = this.boxCells = [];
        const circleCells = this.circleCells = [];
        // More cells -> fewer geometries to check per cell, but items tend
        // to be split across more cells.
        // Sweet spot allows most small items to fit in one cell
        this.xCellCount = Math.ceil(width / cellSize);
        this.yCellCount = Math.ceil(height / cellSize);
        for (let i = 0; i < this.xCellCount * this.yCellCount; i++) {
            boxCells.push([]);
            circleCells.push([]);
        }
        this.circleKeys = [];
        this.boxKeys = [];
        this.bboxes = [];
        this.circles = [];
        this.width = width;
        this.height = height;
        this.xScale = this.xCellCount / width;
        this.yScale = this.yCellCount / height;
        this.boxUid = 0;
        this.circleUid = 0;
    }
    keysLength() {
        return this.boxKeys.length + this.circleKeys.length;
    }
    insert(key, x1, y1, x2, y2) {
        this._forEachCell(x1, y1, x2, y2, this._insertBoxCell, this.boxUid++);
        this.boxKeys.push(key);
        this.bboxes.push(x1);
        this.bboxes.push(y1);
        this.bboxes.push(x2);
        this.bboxes.push(y2);
    }
    insertCircle(key, x, y, radius) {
        // Insert circle into grid for all cells in the circumscribing square
        // It's more than necessary (by a factor of 4/PI), but fast to insert
        this._forEachCell(x - radius, y - radius, x + radius, y + radius, this._insertCircleCell, this.circleUid++);
        this.circleKeys.push(key);
        this.circles.push(x);
        this.circles.push(y);
        this.circles.push(radius);
    }
    _insertBoxCell(x1, y1, x2, y2, cellIndex, uid) {
        this.boxCells[cellIndex].push(uid);
    }
    _insertCircleCell(x1, y1, x2, y2, cellIndex, uid) {
        this.circleCells[cellIndex].push(uid);
    }
    _query(x1, y1, x2, y2, hitTest, overlapMode, predicate) {
        if (x2 < 0 || x1 > this.width || y2 < 0 || y1 > this.height) {
            return [];
        }
        const result = [];
        if (x1 <= 0 && y1 <= 0 && this.width <= x2 && this.height <= y2) {
            if (hitTest) {
                // Covers the entire grid, so collides with everything
                return [{
                        key: null,
                        x1,
                        y1,
                        x2,
                        y2
                    }];
            }
            for (let boxUid = 0; boxUid < this.boxKeys.length; boxUid++) {
                result.push({
                    key: this.boxKeys[boxUid],
                    x1: this.bboxes[boxUid * 4],
                    y1: this.bboxes[boxUid * 4 + 1],
                    x2: this.bboxes[boxUid * 4 + 2],
                    y2: this.bboxes[boxUid * 4 + 3]
                });
            }
            for (let circleUid = 0; circleUid < this.circleKeys.length; circleUid++) {
                const x = this.circles[circleUid * 3];
                const y = this.circles[circleUid * 3 + 1];
                const radius = this.circles[circleUid * 3 + 2];
                result.push({
                    key: this.circleKeys[circleUid],
                    x1: x - radius,
                    y1: y - radius,
                    x2: x + radius,
                    y2: y + radius
                });
            }
        }
        else {
            const queryArgs = {
                hitTest,
                overlapMode,
                seenUids: { box: {}, circle: {} }
            };
            this._forEachCell(x1, y1, x2, y2, this._queryCell, result, queryArgs, predicate);
        }
        return result;
    }
    query(x1, y1, x2, y2) {
        return this._query(x1, y1, x2, y2, false, null);
    }
    hitTest(x1, y1, x2, y2, overlapMode, predicate) {
        return this._query(x1, y1, x2, y2, true, overlapMode, predicate).length > 0;
    }
    hitTestCircle(x, y, radius, overlapMode, predicate) {
        // Insert circle into grid for all cells in the circumscribing square
        // It's more than necessary (by a factor of 4/PI), but fast to insert
        const x1 = x - radius;
        const x2 = x + radius;
        const y1 = y - radius;
        const y2 = y + radius;
        if (x2 < 0 || x1 > this.width || y2 < 0 || y1 > this.height) {
            return false;
        }
        // Box query early exits if the bounding box is larger than the grid, but we don't do
        // the equivalent calculation for circle queries because early exit is less likely
        // and the calculation is more expensive
        const result = [];
        const queryArgs = {
            hitTest: true,
            overlapMode,
            circle: { x, y, radius },
            seenUids: { box: {}, circle: {} }
        };
        this._forEachCell(x1, y1, x2, y2, this._queryCellCircle, result, queryArgs, predicate);
        return result.length > 0;
    }
    _queryCell(x1, y1, x2, y2, cellIndex, result, queryArgs, predicate) {
        const { seenUids, hitTest, overlapMode } = queryArgs;
        const boxCell = this.boxCells[cellIndex];
        if (boxCell !== null) {
            const bboxes = this.bboxes;
            for (const boxUid of boxCell) {
                if (!seenUids.box[boxUid]) {
                    seenUids.box[boxUid] = true;
                    const offset = boxUid * 4;
                    const key = this.boxKeys[boxUid];
                    if ((x1 <= bboxes[offset + 2]) &&
                        (y1 <= bboxes[offset + 3]) &&
                        (x2 >= bboxes[offset + 0]) &&
                        (y2 >= bboxes[offset + 1]) &&
                        (!predicate || predicate(key))) {
                        if (!hitTest || !overlapAllowed(overlapMode, key.overlapMode)) {
                            result.push({
                                key,
                                x1: bboxes[offset],
                                y1: bboxes[offset + 1],
                                x2: bboxes[offset + 2],
                                y2: bboxes[offset + 3]
                            });
                            if (hitTest) {
                                // true return value stops the query after first match
                                return true;
                            }
                        }
                    }
                }
            }
        }
        const circleCell = this.circleCells[cellIndex];
        if (circleCell !== null) {
            const circles = this.circles;
            for (const circleUid of circleCell) {
                if (!seenUids.circle[circleUid]) {
                    seenUids.circle[circleUid] = true;
                    const offset = circleUid * 3;
                    const key = this.circleKeys[circleUid];
                    if (this._circleAndRectCollide(circles[offset], circles[offset + 1], circles[offset + 2], x1, y1, x2, y2) &&
                        (!predicate || predicate(key))) {
                        if (!hitTest || !overlapAllowed(overlapMode, key.overlapMode)) {
                            const x = circles[offset];
                            const y = circles[offset + 1];
                            const radius = circles[offset + 2];
                            result.push({
                                key,
                                x1: x - radius,
                                y1: y - radius,
                                x2: x + radius,
                                y2: y + radius
                            });
                            if (hitTest) {
                                // true return value stops the query after first match
                                return true;
                            }
                        }
                    }
                }
            }
        }
        // false return to continue query
        return false;
    }
    _queryCellCircle(x1, y1, x2, y2, cellIndex, result, queryArgs, predicate) {
        const { circle, seenUids, overlapMode } = queryArgs;
        const boxCell = this.boxCells[cellIndex];
        if (boxCell !== null) {
            const bboxes = this.bboxes;
            for (const boxUid of boxCell) {
                if (!seenUids.box[boxUid]) {
                    seenUids.box[boxUid] = true;
                    const offset = boxUid * 4;
                    const key = this.boxKeys[boxUid];
                    if (this._circleAndRectCollide(circle.x, circle.y, circle.radius, bboxes[offset + 0], bboxes[offset + 1], bboxes[offset + 2], bboxes[offset + 3]) &&
                        (!predicate || predicate(key)) &&
                        !overlapAllowed(overlapMode, key.overlapMode)) {
                        result.push(true);
                        return true;
                    }
                }
            }
        }
        const circleCell = this.circleCells[cellIndex];
        if (circleCell !== null) {
            const circles = this.circles;
            for (const circleUid of circleCell) {
                if (!seenUids.circle[circleUid]) {
                    seenUids.circle[circleUid] = true;
                    const offset = circleUid * 3;
                    const key = this.circleKeys[circleUid];
                    if (this._circlesCollide(circles[offset], circles[offset + 1], circles[offset + 2], circle.x, circle.y, circle.radius) &&
                        (!predicate || predicate(key)) &&
                        !overlapAllowed(overlapMode, key.overlapMode)) {
                        result.push(true);
                        return true;
                    }
                }
            }
        }
    }
    _forEachCell(x1, y1, x2, y2, fn, arg1, arg2, predicate) {
        const cx1 = this._convertToXCellCoord(x1);
        const cy1 = this._convertToYCellCoord(y1);
        const cx2 = this._convertToXCellCoord(x2);
        const cy2 = this._convertToYCellCoord(y2);
        for (let x = cx1; x <= cx2; x++) {
            for (let y = cy1; y <= cy2; y++) {
                const cellIndex = this.xCellCount * y + x;
                if (fn.call(this, x1, y1, x2, y2, cellIndex, arg1, arg2, predicate))
                    return;
            }
        }
    }
    _convertToXCellCoord(x) {
        return Math.max(0, Math.min(this.xCellCount - 1, Math.floor(x * this.xScale)));
    }
    _convertToYCellCoord(y) {
        return Math.max(0, Math.min(this.yCellCount - 1, Math.floor(y * this.yScale)));
    }
    _circlesCollide(x1, y1, r1, x2, y2, r2) {
        const dx = x2 - x1;
        const dy = y2 - y1;
        const bothRadii = r1 + r2;
        return (bothRadii * bothRadii) > (dx * dx + dy * dy);
    }
    _circleAndRectCollide(circleX, circleY, radius, x1, y1, x2, y2) {
        const halfRectWidth = (x2 - x1) / 2;
        const distX = Math.abs(circleX - (x1 + halfRectWidth));
        if (distX > (halfRectWidth + radius)) {
            return false;
        }
        const halfRectHeight = (y2 - y1) / 2;
        const distY = Math.abs(circleY - (y1 + halfRectHeight));
        if (distY > (halfRectHeight + radius)) {
            return false;
        }
        if (distX <= halfRectWidth || distY <= halfRectHeight) {
            return true;
        }
        const dx = distX - halfRectWidth;
        const dy = distY - halfRectHeight;
        return (dx * dx + dy * dy <= (radius * radius));
    }
}

/*
 * # Overview of coordinate spaces
 *
 * ## Tile coordinate spaces
 * Each label has an anchor. Some labels have corresponding line geometries.
 * The points for both anchors and lines are stored in tile units. Each tile has it's own
 * coordinate space going from (0, 0) at the top left to (EXTENT, EXTENT) at the bottom right.
 *
 * ## Clip space (GL coordinate space)
 * At the end of everything, the vertex shader needs to produce a position in clip space,
 * which is (-1, 1) at the top left and (1, -1) in the bottom right.
 * In the depth buffer, values are between 0 (near plane) to 1 (far plane).
 *
 * ## Map pixel coordinate spaces
 * Each tile has a pixel coordinate space. It's just the tile units scaled so that one unit is
 * whatever counts as 1 pixel at the current zoom.
 * This space is used for pitch-alignment=map, rotation-alignment=map
 *
 * ## Rotated map pixel coordinate spaces
 * Like the above, but rotated so axis of the space are aligned with the viewport instead of the tile.
 * This space is used for pitch-alignment=map, rotation-alignment=viewport
 *
 * ## Viewport pixel coordinate space
 * (0, 0) is at the top left of the canvas and (pixelWidth, pixelHeight) is at the bottom right corner
 * of the canvas. This space is used for pitch-alignment=viewport
 *
 *
 * # Vertex projection
 * It goes roughly like this:
 * 1. project the anchor and line from tile units into the correct label coordinate space
 *      - map pixel space           pitch-alignment=map         rotation-alignment=map
 *      - rotated map pixel space   pitch-alignment=map         rotation-alignment=viewport
 *      - viewport pixel space      pitch-alignment=viewport    rotation-alignment=*
 * 2. if the label follows a line, find the point along the line that is the correct distance from the anchor.
 * 3. add the glyph's corner offset to the point from step 3
 * 4. convert from the label coordinate space to clip space
 *
 * For horizontal labels we want to do step 1 in the shader for performance reasons (no cpu work).
 *      This is what `u_label_plane_matrix` is used for.
 * For labels aligned with lines we have to steps 1 and 2 on the cpu since we need access to the line geometry.
 *      This is what `updateLineLabels(...)` does.
 *      Since the conversion is handled on the cpu we just set `u_label_plane_matrix` to an identity matrix.
 *
 * Steps 3 and 4 are done in the shaders for all labels.
 */
/*
 * Returns a matrix for converting from tile units to the correct label coordinate space.
 */
function getLabelPlaneMatrix(posMatrix, pitchWithMap, rotateWithMap, transform, pixelsToTileUnits) {
    const m = performance$1.H();
    if (pitchWithMap) {
        performance$1.K(m, m, [1 / pixelsToTileUnits, 1 / pixelsToTileUnits, 1]);
        if (!rotateWithMap) {
            performance$1.ae(m, m, transform.angle);
        }
    }
    else {
        performance$1.L(m, transform.labelPlaneMatrix, posMatrix);
    }
    return m;
}
/*
 * Returns a matrix for converting from the correct label coordinate space to clip space.
 */
function getGlCoordMatrix(posMatrix, pitchWithMap, rotateWithMap, transform, pixelsToTileUnits) {
    if (pitchWithMap) {
        const m = performance$1.af(posMatrix);
        performance$1.K(m, m, [pixelsToTileUnits, pixelsToTileUnits, 1]);
        if (!rotateWithMap) {
            performance$1.ae(m, m, -transform.angle);
        }
        return m;
    }
    else {
        return transform.glCoordMatrix;
    }
}
function project(point, matrix, getElevation) {
    let pos;
    if (getElevation) { // slow because of handle z-index
        pos = [point.x, point.y, getElevation(point.x, point.y), 1];
        performance$1.ag(pos, pos, matrix);
    }
    else { // fast because of ignore z-index
        pos = [point.x, point.y, 0, 1];
        xyTransformMat4(pos, pos, matrix);
    }
    const w = pos[3];
    return {
        point: new performance$1.P(pos[0] / w, pos[1] / w),
        signedDistanceFromCamera: w,
        isOccluded: false
    };
}
function getPerspectiveRatio(cameraToCenterDistance, signedDistanceFromCamera) {
    return 0.5 + 0.5 * (cameraToCenterDistance / signedDistanceFromCamera);
}
function isVisible(p, clippingBuffer) {
    const inPaddedViewport = (p.x >= -clippingBuffer[0] &&
        p.x <= clippingBuffer[0] &&
        p.y >= -clippingBuffer[1] &&
        p.y <= clippingBuffer[1]);
    return inPaddedViewport;
}
/*
 *  Update the `dynamicLayoutVertexBuffer` for the buffer with the correct glyph positions for the current map view.
 *  This is only run on labels that are aligned with lines. Horizontal labels are handled entirely in the shader.
 */
function updateLineLabels(bucket, posMatrix, painter, isText, labelPlaneMatrix, glCoordMatrix, pitchWithMap, keepUpright, rotateToLine, projection, unwrappedTileID, viewportWidth, viewportHeight, translation, getElevation) {
    const sizeData = isText ? bucket.textSizeData : bucket.iconSizeData;
    const partiallyEvaluatedSize = performance$1.ah(sizeData, painter.transform.zoom);
    const clippingBuffer = [256 / painter.width * 2 + 1, 256 / painter.height * 2 + 1];
    const dynamicLayoutVertexArray = isText ?
        bucket.text.dynamicLayoutVertexArray :
        bucket.icon.dynamicLayoutVertexArray;
    dynamicLayoutVertexArray.clear();
    const lineVertexArray = bucket.lineVertexArray;
    const placedSymbols = isText ? bucket.text.placedSymbolArray : bucket.icon.placedSymbolArray;
    const aspectRatio = painter.transform.width / painter.transform.height;
    let useVertical = false;
    for (let s = 0; s < placedSymbols.length; s++) {
        const symbol = placedSymbols.get(s);
        // Don't do calculations for vertical glyphs unless the previous symbol was horizontal
        // and we determined that vertical glyphs were necessary.
        // Also don't do calculations for symbols that are collided and fully faded out
        if (symbol.hidden || symbol.writingMode === performance$1.ai.vertical && !useVertical) {
            hideGlyphs(symbol.numGlyphs, dynamicLayoutVertexArray);
            continue;
        }
        // Awkward... but we're counting on the paired "vertical" symbol coming immediately after its horizontal counterpart
        useVertical = false;
        const anchorPos = project(new performance$1.P(symbol.anchorX, symbol.anchorY), posMatrix, getElevation);
        // Don't bother calculating the correct point for invisible labels.
        if (!isVisible(anchorPos.point, clippingBuffer)) {
            hideGlyphs(symbol.numGlyphs, dynamicLayoutVertexArray);
            continue;
        }
        const cameraToAnchorDistance = anchorPos.signedDistanceFromCamera;
        const perspectiveRatio = getPerspectiveRatio(painter.transform.cameraToCenterDistance, cameraToAnchorDistance);
        const fontSize = performance$1.aj(sizeData, partiallyEvaluatedSize, symbol);
        const pitchScaledFontSize = pitchWithMap ? fontSize / perspectiveRatio : fontSize * perspectiveRatio;
        const tileAnchorPoint = new performance$1.P(symbol.anchorX, symbol.anchorY);
        const projectionCache = { projections: {}, offsets: {}, cachedAnchorPoint: undefined, anyProjectionOccluded: false };
        const projectionContext = {
            getElevation,
            labelPlaneMatrix,
            lineVertexArray,
            pitchWithMap,
            projectionCache,
            projection,
            tileAnchorPoint,
            unwrappedTileID,
            width: viewportWidth,
            height: viewportHeight,
            translation
        };
        const placeUnflipped = placeGlyphsAlongLine(projectionContext, symbol, pitchScaledFontSize, false /*unflipped*/, keepUpright, posMatrix, glCoordMatrix, bucket.glyphOffsetArray, dynamicLayoutVertexArray, aspectRatio, rotateToLine);
        useVertical = placeUnflipped.useVertical;
        if (placeUnflipped.notEnoughRoom || useVertical ||
            (placeUnflipped.needsFlipping &&
                placeGlyphsAlongLine(projectionContext, symbol, pitchScaledFontSize, true /*flipped*/, keepUpright, posMatrix, glCoordMatrix, bucket.glyphOffsetArray, dynamicLayoutVertexArray, aspectRatio, rotateToLine).notEnoughRoom)) {
            hideGlyphs(symbol.numGlyphs, dynamicLayoutVertexArray);
        }
    }
    if (isText) {
        bucket.text.dynamicLayoutVertexBuffer.updateData(dynamicLayoutVertexArray);
    }
    else {
        bucket.icon.dynamicLayoutVertexBuffer.updateData(dynamicLayoutVertexArray);
    }
}
/*
 * Place the first and last glyph of a line label, projected to the label plane.
 * This function is called both during collision detection (to determine the label's size)
 * and during line label rendering (to make sure the label fits on the line geometry with
 * the current camera position, which may differ from the position used during collision detection).
 *
 * Calling this function has the effect of populating the "projectionCache" with all projected
 * vertex locations the label will need, making future calls to placeGlyphAlongLine (for all the
 * intermediate glyphs) much cheaper.
 *
 * Returns null if the label can't fit on the geometry
 */
function placeFirstAndLastGlyph(fontScale, glyphOffsetArray, lineOffsetX, lineOffsetY, flip, symbol, rotateToLine, projectionContext) {
    const glyphEndIndex = symbol.glyphStartIndex + symbol.numGlyphs;
    const lineStartIndex = symbol.lineStartIndex;
    const lineEndIndex = symbol.lineStartIndex + symbol.lineLength;
    const firstGlyphOffset = glyphOffsetArray.getoffsetX(symbol.glyphStartIndex);
    const lastGlyphOffset = glyphOffsetArray.getoffsetX(glyphEndIndex - 1);
    const firstPlacedGlyph = placeGlyphAlongLine(fontScale * firstGlyphOffset, lineOffsetX, lineOffsetY, flip, symbol.segment, lineStartIndex, lineEndIndex, projectionContext, rotateToLine);
    if (!firstPlacedGlyph)
        return null;
    const lastPlacedGlyph = placeGlyphAlongLine(fontScale * lastGlyphOffset, lineOffsetX, lineOffsetY, flip, symbol.segment, lineStartIndex, lineEndIndex, projectionContext, rotateToLine);
    if (!lastPlacedGlyph)
        return null;
    if (projectionContext.projectionCache.anyProjectionOccluded) {
        return null;
    }
    return { first: firstPlacedGlyph, last: lastPlacedGlyph };
}
function requiresOrientationChange(writingMode, firstPoint, lastPoint, aspectRatio) {
    if (writingMode === performance$1.ai.horizontal) {
        // On top of choosing whether to flip, choose whether to render this version of the glyphs or the alternate
        // vertical glyphs. We can't just filter out vertical glyphs in the horizontal range because the horizontal
        // and vertical versions can have slightly different projections which could lead to angles where both or
        // neither showed.
        const rise = Math.abs(lastPoint.y - firstPoint.y);
        const run = Math.abs(lastPoint.x - firstPoint.x) * aspectRatio;
        if (rise > run) {
            return { useVertical: true };
        }
    }
    if (writingMode === performance$1.ai.vertical ? firstPoint.y < lastPoint.y : firstPoint.x > lastPoint.x) {
        // Includes "horizontalOnly" case for labels without vertical glyphs
        return { needsFlipping: true };
    }
    return null;
}
/*
* Place first and last glyph along the line projected to label plane, and if they fit
* iterate through all the intermediate glyphs, calculating their label plane positions
* from the projected line.
*
* Finally, add resulting glyph position calculations to dynamicLayoutVertexArray for
* upload to the GPU
*/
function placeGlyphsAlongLine(projectionContext, symbol, fontSize, flip, keepUpright, posMatrix, glCoordMatrix, glyphOffsetArray, dynamicLayoutVertexArray, aspectRatio, rotateToLine) {
    const fontScale = fontSize / 24;
    const lineOffsetX = symbol.lineOffsetX * fontScale;
    const lineOffsetY = symbol.lineOffsetY * fontScale;
    let placedGlyphs;
    if (symbol.numGlyphs > 1) {
        const glyphEndIndex = symbol.glyphStartIndex + symbol.numGlyphs;
        const lineStartIndex = symbol.lineStartIndex;
        const lineEndIndex = symbol.lineStartIndex + symbol.lineLength;
        // Place the first and the last glyph in the label first, so we can figure out
        // the overall orientation of the label and determine whether it needs to be flipped in keepUpright mode
        const firstAndLastGlyph = placeFirstAndLastGlyph(fontScale, glyphOffsetArray, lineOffsetX, lineOffsetY, flip, symbol, rotateToLine, projectionContext);
        if (!firstAndLastGlyph) {
            return { notEnoughRoom: true };
        }
        const firstPoint = project(firstAndLastGlyph.first.point, glCoordMatrix, projectionContext.getElevation).point;
        const lastPoint = project(firstAndLastGlyph.last.point, glCoordMatrix, projectionContext.getElevation).point;
        if (keepUpright && !flip) {
            const orientationChange = requiresOrientationChange(symbol.writingMode, firstPoint, lastPoint, aspectRatio);
            if (orientationChange) {
                return orientationChange;
            }
        }
        placedGlyphs = [firstAndLastGlyph.first];
        for (let glyphIndex = symbol.glyphStartIndex + 1; glyphIndex < glyphEndIndex - 1; glyphIndex++) {
            // Since first and last glyph fit on the line, we're sure that the rest of the glyphs can be placed
            placedGlyphs.push(placeGlyphAlongLine(fontScale * glyphOffsetArray.getoffsetX(glyphIndex), lineOffsetX, lineOffsetY, flip, symbol.segment, lineStartIndex, lineEndIndex, projectionContext, rotateToLine));
        }
        placedGlyphs.push(firstAndLastGlyph.last);
    }
    else {
        // Only a single glyph to place
        // So, determine whether to flip based on projected angle of the line segment it's on
        if (keepUpright && !flip) {
            const a = project(projectionContext.tileAnchorPoint, posMatrix, projectionContext.getElevation).point;
            const tileVertexIndex = (symbol.lineStartIndex + symbol.segment + 1);
            const tileSegmentEnd = new performance$1.P(projectionContext.lineVertexArray.getx(tileVertexIndex), projectionContext.lineVertexArray.gety(tileVertexIndex));
            const projectedVertex = project(tileSegmentEnd, posMatrix, projectionContext.getElevation);
            // We know the anchor will be in the viewport, but the end of the line segment may be
            // behind the plane of the camera, in which case we can use a point at any arbitrary (closer)
            // point on the segment.
            const b = (projectedVertex.signedDistanceFromCamera > 0) ?
                projectedVertex.point :
                projectTruncatedLineSegmentToLabelPlane(projectionContext.tileAnchorPoint, tileSegmentEnd, a, 1, posMatrix, projectionContext);
            const orientationChange = requiresOrientationChange(symbol.writingMode, a, b, aspectRatio);
            if (orientationChange) {
                return orientationChange;
            }
        }
        const singleGlyph = placeGlyphAlongLine(fontScale * glyphOffsetArray.getoffsetX(symbol.glyphStartIndex), lineOffsetX, lineOffsetY, flip, symbol.segment, symbol.lineStartIndex, symbol.lineStartIndex + symbol.lineLength, projectionContext, rotateToLine);
        if (!singleGlyph || projectionContext.projectionCache.anyProjectionOccluded)
            return { notEnoughRoom: true };
        placedGlyphs = [singleGlyph];
    }
    for (const glyph of placedGlyphs) {
        performance$1.ak(dynamicLayoutVertexArray, glyph.point, glyph.angle);
    }
    return {};
}
/**
 * Takes a line and direction from `previousTilePoint` to `currentTilePoint`,
 * projects it to *label plane*,
 * and returns a projected point along this projected line that is `minimumLength` distance away from `previousProjectedPoint`.
 * @param previousTilePoint - Line start point, in tile coordinates.
 * @param currentTilePoint - Line end point, in tile coordinates.
 * @param previousProjectedPoint - Projection of `previousTilePoint` into *label plane*.
 * @param minimumLength - Distance in the projected space along the line for the returned point.
 * @param projectionMatrix - Matrix to use during projection.
 * @param projectionContext - Projection context, used only for terrain's `getElevation`.
 */
function projectTruncatedLineSegmentToLabelPlane(previousTilePoint, currentTilePoint, previousProjectedPoint, minimumLength, projectionMatrix, projectionContext) {
    return _projectTruncatedLineSegment(previousTilePoint, currentTilePoint, previousProjectedPoint, minimumLength, projectionMatrix, projectionContext);
}
/**
 * Takes a line and direction from `previousTilePoint` to `currentTilePoint`,
 * projects it to *viewport*,
 * and returns a projected point along this projected line that is `minimumLength` distance away from `previousProjectedPoint`.
 * @param previousTilePoint - Line start point, in tile coordinates.
 * @param currentTilePoint - Line end point, in tile coordinates.
 * @param previousProjectedPoint - Projection of `previousTilePoint` into *viewport*.
 * @param minimumLength - Distance in the projected space along the line for the returned point.
 * @param projectionContext - Projection context, used for terrain's `getElevation`, and either the `labelPlaneMatrix` or the map's special projection (mostly for globe).
 */
function projectTruncatedLineSegmentToViewport(previousTilePoint, currentTilePoint, previousProjectedPoint, minimumLength, projectionContext) {
    return _projectTruncatedLineSegment(previousTilePoint, currentTilePoint, previousProjectedPoint, minimumLength, undefined, projectionContext);
}
/**
 * Do not use directly, use {@link projectTruncatedLineSegmentToLabelPlane} or {@link projectTruncatedLineSegmentToViewport} instead,
 * depending on the target space.
 *
 * Projects a "virtual" vertex along a line segment.
 * If `projectionMatrix` is not undefined, does a simple projection using this matrix.
 * Otherwise, either projects to label plane using the `labelPlaneMatrix`
 * or projects to viewport using the special map projection (mostly for globe) by calling {@link projectTileCoordinatesToViewport}.
 */
function _projectTruncatedLineSegment(previousTilePoint, currentTilePoint, previousProjectedPoint, minimumLength, projectionMatrix, projectionContext) {
    // We are assuming "previousTilePoint" won't project to a point within one unit of the camera plane
    // If it did, that would mean our label extended all the way out from within the viewport to a (very distant)
    // point near the plane of the camera. We wouldn't be able to render the label anyway once it crossed the
    // plane of the camera.
    const unitVertexToBeProjected = previousTilePoint.add(previousTilePoint.sub(currentTilePoint)._unit());
    const projectedUnitVertex = projectionMatrix !== undefined ?
        project(unitVertexToBeProjected, projectionMatrix, projectionContext.getElevation).point :
        projectTileCoordinatesToViewport(unitVertexToBeProjected.x, unitVertexToBeProjected.y, projectionContext).point;
    const projectedUnitSegment = previousProjectedPoint.sub(projectedUnitVertex);
    return previousProjectedPoint.add(projectedUnitSegment._mult(minimumLength / projectedUnitSegment.mag()));
}
/**
 * Transform a vertex from tile coordinates to label plane coordinates
 * @param index - index of vertex to project
 * @param projectionContext - necessary data to project a vertex
 * @returns the vertex projected to the label plane
 */
function projectLineVertexToViewport(index, projectionContext, syntheticVertexArgs) {
    const cache = projectionContext.projectionCache;
    if (cache.projections[index]) {
        return cache.projections[index];
    }
    const currentVertex = new performance$1.P(projectionContext.lineVertexArray.getx(index), projectionContext.lineVertexArray.gety(index));
    const projection = projectTileCoordinatesToViewport(currentVertex.x, currentVertex.y, projectionContext);
    if (projection.signedDistanceFromCamera > 0) {
        cache.projections[index] = projection.point;
        cache.anyProjectionOccluded = cache.anyProjectionOccluded || projection.isOccluded;
        return projection.point;
    }
    // The vertex is behind the plane of the camera, so we can't project it
    // Instead, we'll create a vertex along the line that's far enough to include the glyph
    const previousLineVertexIndex = index - syntheticVertexArgs.direction;
    const previousTilePoint = syntheticVertexArgs.distanceFromAnchor === 0 ?
        projectionContext.tileAnchorPoint :
        new performance$1.P(projectionContext.lineVertexArray.getx(previousLineVertexIndex), projectionContext.lineVertexArray.gety(previousLineVertexIndex));
    // Don't cache because the new vertex might not be far enough out for future glyphs on the same segment
    const minimumLength = syntheticVertexArgs.absOffsetX - syntheticVertexArgs.distanceFromAnchor + 1;
    return projectTruncatedLineSegmentToViewport(previousTilePoint, currentVertex, syntheticVertexArgs.previousVertex, minimumLength, projectionContext);
}
function projectTileCoordinatesToViewport(x, y, projectionContext) {
    const translatedX = x + projectionContext.translation[0];
    const translatedY = y + projectionContext.translation[1];
    let projection;
    if (!projectionContext.pitchWithMap && projectionContext.projection.useSpecialProjectionForSymbols) {
        projection = projectionContext.projection.projectTileCoordinates(translatedX, translatedY, projectionContext.unwrappedTileID, projectionContext.getElevation);
        projection.point.x = (projection.point.x * 0.5 + 0.5) * projectionContext.width;
        projection.point.y = (-projection.point.y * 0.5 + 0.5) * projectionContext.height;
    }
    else {
        projection = project(new performance$1.P(translatedX, translatedY), projectionContext.labelPlaneMatrix, projectionContext.getElevation);
        projection.isOccluded = false;
    }
    return projection;
}
/**
 * Calculate the normal vector for a line segment
 * @param segmentVector - will be mutated as a tiny optimization
 * @param offset - magnitude of resulting vector
 * @param direction - direction of line traversal
 * @returns a normal vector from the segment, with magnitude equal to offset amount
 */
function transformToOffsetNormal(segmentVector, offset, direction) {
    return segmentVector._unit()._perp()._mult(offset * direction);
}
/**
 * Construct offset line segments for the current segment and the next segment, then extend/shrink
 * the segments until they intersect. If the segments are parallel, then they will touch with no modification.
 *
 * @param index - Index of the current vertex
 * @param prevToCurrentOffsetNormal - Normal vector of the line segment from the previous vertex to the current vertex
 * @param currentVertex - Current (non-offset) vertex projected to the label plane
 * @param lineStartIndex - Beginning index for the line this label is on
 * @param lineEndIndex - End index for the line this label is on
 * @param offsetPreviousVertex - The previous vertex projected to the label plane, and then offset along the previous segments normal
 * @param lineOffsetY - Magnitude of the offset
 * @param projectionContext - Necessary data for tile-to-label-plane projection
 * @returns The point at which the current and next line segments intersect, once offset and extended/shrunk to their meeting point
 */
function findOffsetIntersectionPoint(index, prevToCurrentOffsetNormal, currentVertex, lineStartIndex, lineEndIndex, offsetPreviousVertex, lineOffsetY, projectionContext, syntheticVertexArgs) {
    if (projectionContext.projectionCache.offsets[index]) {
        return projectionContext.projectionCache.offsets[index];
    }
    const offsetCurrentVertex = currentVertex.add(prevToCurrentOffsetNormal);
    if (index + syntheticVertexArgs.direction < lineStartIndex || index + syntheticVertexArgs.direction >= lineEndIndex) {
        // This is the end of the line, no intersection to calculate
        projectionContext.projectionCache.offsets[index] = offsetCurrentVertex;
        return offsetCurrentVertex;
    }
    // Offset the vertices for the next segment
    const nextVertex = projectLineVertexToViewport(index + syntheticVertexArgs.direction, projectionContext, syntheticVertexArgs);
    const currentToNextOffsetNormal = transformToOffsetNormal(nextVertex.sub(currentVertex), lineOffsetY, syntheticVertexArgs.direction);
    const offsetNextSegmentBegin = currentVertex.add(currentToNextOffsetNormal);
    const offsetNextSegmentEnd = nextVertex.add(currentToNextOffsetNormal);
    // find the intersection of these two lines
    // if the lines are parallel, offsetCurrent/offsetNextBegin will touch
    projectionContext.projectionCache.offsets[index] = performance$1.al(offsetPreviousVertex, offsetCurrentVertex, offsetNextSegmentBegin, offsetNextSegmentEnd) || offsetCurrentVertex;
    return projectionContext.projectionCache.offsets[index];
}
/*
 * Place a single glyph along its line, projected into the label plane, by iterating outward
 * from the anchor point until the distance traversed in the label plane equals the glyph's
 * offsetX. Returns null if the glyph can't fit on the line geometry.
 */
function placeGlyphAlongLine(offsetX, lineOffsetX, lineOffsetY, flip, anchorSegment, lineStartIndex, lineEndIndex, projectionContext, rotateToLine) {
    const combinedOffsetX = flip ?
        offsetX - lineOffsetX :
        offsetX + lineOffsetX;
    let direction = combinedOffsetX > 0 ? 1 : -1;
    let angle = 0;
    if (flip) {
        // The label needs to be flipped to keep text upright.
        // Iterate in the reverse direction.
        direction *= -1;
        angle = Math.PI;
    }
    if (direction < 0)
        angle += Math.PI;
    let currentIndex = direction > 0 ?
        lineStartIndex + anchorSegment :
        lineStartIndex + anchorSegment + 1;
    // Project anchor point to proper label plane and cache it
    let anchorPoint;
    if (projectionContext.projectionCache.cachedAnchorPoint) {
        anchorPoint = projectionContext.projectionCache.cachedAnchorPoint;
    }
    else {
        anchorPoint = projectTileCoordinatesToViewport(projectionContext.tileAnchorPoint.x, projectionContext.tileAnchorPoint.y, projectionContext).point;
        projectionContext.projectionCache.cachedAnchorPoint = anchorPoint;
    }
    let currentVertex = anchorPoint;
    let previousVertex = anchorPoint;
    // offsetPrev and intersectionPoint are analogous to previousVertex and currentVertex
    // but if there's a line offset they are calculated in parallel as projection happens
    let offsetIntersectionPoint;
    let offsetPreviousVertex;
    let distanceFromAnchor = 0;
    let currentSegmentDistance = 0;
    const absOffsetX = Math.abs(combinedOffsetX);
    const pathVertices = [];
    let currentLineSegment;
    while (distanceFromAnchor + currentSegmentDistance <= absOffsetX) {
        currentIndex += direction;
        // offset does not fit on the projected line
        if (currentIndex < lineStartIndex || currentIndex >= lineEndIndex)
            return null;
        // accumulate values from last iteration
        distanceFromAnchor += currentSegmentDistance;
        previousVertex = currentVertex;
        offsetPreviousVertex = offsetIntersectionPoint;
        const syntheticVertexArgs = {
            absOffsetX,
            direction,
            distanceFromAnchor,
            previousVertex
        };
        // find next vertex in viewport space
        currentVertex = projectLineVertexToViewport(currentIndex, projectionContext, syntheticVertexArgs);
        if (lineOffsetY === 0) {
            // Store vertices for collision detection and update current segment geometry
            pathVertices.push(previousVertex);
            currentLineSegment = currentVertex.sub(previousVertex);
        }
        else {
            // Calculate the offset for this section
            let prevToCurrentOffsetNormal;
            const prevToCurrent = currentVertex.sub(previousVertex);
            if (prevToCurrent.mag() === 0) {
                // We are starting with our anchor point directly on the vertex, so look one vertex ahead
                // to calculate a normal
                const nextVertex = projectLineVertexToViewport(currentIndex + direction, projectionContext, syntheticVertexArgs);
                prevToCurrentOffsetNormal = transformToOffsetNormal(nextVertex.sub(currentVertex), lineOffsetY, direction);
            }
            else {
                prevToCurrentOffsetNormal = transformToOffsetNormal(prevToCurrent, lineOffsetY, direction);
            }
            // Initialize offsetPrev on our first iteration, after that it will be pre-calculated
            if (!offsetPreviousVertex)
                offsetPreviousVertex = previousVertex.add(prevToCurrentOffsetNormal);
            offsetIntersectionPoint = findOffsetIntersectionPoint(currentIndex, prevToCurrentOffsetNormal, currentVertex, lineStartIndex, lineEndIndex, offsetPreviousVertex, lineOffsetY, projectionContext, syntheticVertexArgs);
            pathVertices.push(offsetPreviousVertex);
            currentLineSegment = offsetIntersectionPoint.sub(offsetPreviousVertex);
        }
        currentSegmentDistance = currentLineSegment.mag();
    }
    // The point is on the current segment. Interpolate to find it.
    const segmentInterpolationT = (absOffsetX - distanceFromAnchor) / currentSegmentDistance;
    const p = currentLineSegment._mult(segmentInterpolationT)._add(offsetPreviousVertex || previousVertex);
    const segmentAngle = angle + Math.atan2(currentVertex.y - previousVertex.y, currentVertex.x - previousVertex.x);
    pathVertices.push(p);
    return {
        point: p,
        angle: rotateToLine ? segmentAngle : 0.0,
        path: pathVertices
    };
}
const hiddenGlyphAttributes = new Float32Array([-Infinity, -Infinity, 0, -Infinity, -Infinity, 0, -Infinity, -Infinity, 0, -Infinity, -Infinity, 0]);
// Hide them by moving them offscreen. We still need to add them to the buffer
// because the dynamic buffer is paired with a static buffer that doesn't get updated.
function hideGlyphs(num, dynamicLayoutVertexArray) {
    for (let i = 0; i < num; i++) {
        const offset = dynamicLayoutVertexArray.length;
        dynamicLayoutVertexArray.resize(offset + 4);
        // Since all hidden glyphs have the same attributes, we can build up the array faster with a single call to Float32Array.set
        // for each set of four vertices, instead of calling addDynamicAttributes for each vertex.
        dynamicLayoutVertexArray.float32.set(hiddenGlyphAttributes, offset * 3);
    }
}
// For line label layout, we're not using z output and our w input is always 1
// This custom matrix transformation ignores those components to make projection faster
function xyTransformMat4(out, a, m) {
    const x = a[0], y = a[1];
    out[0] = m[0] * x + m[4] * y + m[12];
    out[1] = m[1] * x + m[5] * y + m[13];
    out[3] = m[3] * x + m[7] * y + m[15];
    return out;
}

// When a symbol crosses the edge that causes it to be included in
// collision detection, it will cause changes in the symbols around
// it. This constant specifies how many pixels to pad the edge of
// the viewport for collision detection so that the bulk of the changes
// occur offscreen. Making this constant greater increases label
// stability, but it's expensive.
const viewportPadding = 100;
/**
 * @internal
 * A collision index used to prevent symbols from overlapping. It keep tracks of
 * where previous symbols have been placed and is used to check if a new
 * symbol overlaps with any previously added symbols.
 *
 * There are two steps to insertion: first placeCollisionBox/Circles checks if
 * there's room for a symbol, then insertCollisionBox/Circles actually puts the
 * symbol in the index. The two step process allows paired symbols to be inserted
 * together even if they overlap.
 */
class CollisionIndex {
    constructor(transform, projection, grid = new GridIndex(transform.width + 2 * viewportPadding, transform.height + 2 * viewportPadding, 25), ignoredGrid = new GridIndex(transform.width + 2 * viewportPadding, transform.height + 2 * viewportPadding, 25)) {
        this.transform = transform;
        this.mapProjection = projection;
        this.grid = grid;
        this.ignoredGrid = ignoredGrid;
        this.pitchFactor = Math.cos(transform._pitch) * transform.cameraToCenterDistance;
        this.screenRightBoundary = transform.width + viewportPadding;
        this.screenBottomBoundary = transform.height + viewportPadding;
        this.gridRightBoundary = transform.width + 2 * viewportPadding;
        this.gridBottomBoundary = transform.height + 2 * viewportPadding;
        this.perspectiveRatioCutoff = 0.6;
    }
    placeCollisionBox(collisionBox, overlapMode, textPixelRatio, posMatrix, unwrappedTileID, pitchWithMap, rotateWithMap, translation, collisionGroupPredicate, getElevation, shift) {
        const x = collisionBox.anchorPointX + translation[0];
        const y = collisionBox.anchorPointY + translation[1];
        const projectedPoint = this.projectAndGetPerspectiveRatio(posMatrix, x, y, unwrappedTileID, getElevation);
        const projectedBox = this._projectCollisionBox(collisionBox, textPixelRatio, posMatrix, unwrappedTileID, pitchWithMap, rotateWithMap, translation, projectedPoint, getElevation, shift);
        const [tlX, tlY, brX, brY] = projectedBox.box;
        const projectionOccluded = this.mapProjection.useSpecialProjectionForSymbols ? (pitchWithMap ? projectedBox.allPointsOccluded : this.mapProjection.isOccluded(x, y, unwrappedTileID)) : false;
        if (projectionOccluded || projectedPoint.perspectiveRatio < this.perspectiveRatioCutoff || !this.isInsideGrid(tlX, tlY, brX, brY) ||
            (overlapMode !== 'always' && this.grid.hitTest(tlX, tlY, brX, brY, overlapMode, collisionGroupPredicate))) {
            return {
                box: [tlX, tlY, brX, brY],
                placeable: false,
                offscreen: false
            };
        }
        return {
            box: [tlX, tlY, brX, brY],
            placeable: true,
            offscreen: this.isOffscreen(tlX, tlY, brX, brY)
        };
    }
    placeCollisionCircles(overlapMode, symbol, lineVertexArray, glyphOffsetArray, fontSize, posMatrix, unwrappedTileID, labelPlaneMatrix, labelToScreenMatrix, showCollisionCircles, pitchWithMap, collisionGroupPredicate, circlePixelDiameter, textPixelPadding, translation, getElevation) {
        const placedCollisionCircles = [];
        const tileUnitAnchorPoint = new performance$1.P(symbol.anchorX, symbol.anchorY);
        const perspectiveRatio = this.getPerspectiveRatio(posMatrix, tileUnitAnchorPoint.x, tileUnitAnchorPoint.y, unwrappedTileID, getElevation);
        const labelPlaneFontSize = pitchWithMap ? fontSize / perspectiveRatio : fontSize * perspectiveRatio;
        const labelPlaneFontScale = labelPlaneFontSize / performance$1.aq;
        const projectionCache = { projections: {}, offsets: {}, cachedAnchorPoint: undefined, anyProjectionOccluded: false };
        const lineOffsetX = symbol.lineOffsetX * labelPlaneFontScale;
        const lineOffsetY = symbol.lineOffsetY * labelPlaneFontScale;
        const projectionContext = {
            getElevation,
            labelPlaneMatrix,
            lineVertexArray,
            pitchWithMap,
            projectionCache,
            projection: this.mapProjection,
            tileAnchorPoint: tileUnitAnchorPoint,
            unwrappedTileID,
            width: this.transform.width,
            height: this.transform.height,
            translation
        };
        const firstAndLastGlyph = placeFirstAndLastGlyph(labelPlaneFontScale, glyphOffsetArray, lineOffsetX, lineOffsetY, 
        /*flip*/ false, symbol, false, projectionContext);
        let collisionDetected = false;
        let inGrid = false;
        let entirelyOffscreen = true;
        if (firstAndLastGlyph) {
            const radius = circlePixelDiameter * 0.5 * perspectiveRatio + textPixelPadding;
            const screenPlaneMin = new performance$1.P(-viewportPadding, -viewportPadding);
            const screenPlaneMax = new performance$1.P(this.screenRightBoundary, this.screenBottomBoundary);
            const interpolator = new PathInterpolator();
            // Construct a projected path from projected line vertices. Anchor points are ignored and removed
            const first = firstAndLastGlyph.first;
            const last = firstAndLastGlyph.last;
            let projectedPath = [];
            for (let i = first.path.length - 1; i >= 1; i--) {
                projectedPath.push(first.path[i]);
            }
            for (let i = 1; i < last.path.length; i++) {
                projectedPath.push(last.path[i]);
            }
            // Tolerate a slightly longer distance than one diameter between two adjacent circles
            const circleDist = radius * 2.5;
            // The path might need to be converted into screen space if a pitched map is used as the label space
            if (labelToScreenMatrix) {
                const screenSpacePath = this.projectPathToScreenSpace(projectedPath, projectionContext, labelToScreenMatrix);
                // Do not try to place collision circles if even one of the points is behind the camera.
                // This is a plausible scenario with big camera pitch angles
                if (screenSpacePath.some(point => point.signedDistanceFromCamera <= 0)) {
                    projectedPath = [];
                }
                else {
                    projectedPath = screenSpacePath.map(p => p.point);
                }
            }
            let segments = [];
            if (projectedPath.length > 0) {
                // Quickly check if the path is fully inside or outside of the padded collision region.
                // For overlapping paths we'll only create collision circles for the visible segments
                const minPoint = projectedPath[0].clone();
                const maxPoint = projectedPath[0].clone();
                for (let i = 1; i < projectedPath.length; i++) {
                    minPoint.x = Math.min(minPoint.x, projectedPath[i].x);
                    minPoint.y = Math.min(minPoint.y, projectedPath[i].y);
                    maxPoint.x = Math.max(maxPoint.x, projectedPath[i].x);
                    maxPoint.y = Math.max(maxPoint.y, projectedPath[i].y);
                }
                if (minPoint.x >= screenPlaneMin.x && maxPoint.x <= screenPlaneMax.x &&
                    minPoint.y >= screenPlaneMin.y && maxPoint.y <= screenPlaneMax.y) {
                    // Quad fully visible
                    segments = [projectedPath];
                }
                else if (maxPoint.x < screenPlaneMin.x || minPoint.x > screenPlaneMax.x ||
                    maxPoint.y < screenPlaneMin.y || minPoint.y > screenPlaneMax.y) {
                    // Not visible
                    segments = [];
                }
                else {
                    segments = performance$1.am([projectedPath], screenPlaneMin.x, screenPlaneMin.y, screenPlaneMax.x, screenPlaneMax.y);
                }
            }
            for (const seg of segments) {
                // interpolate positions for collision circles. Add a small padding to both ends of the segment
                interpolator.reset(seg, radius * 0.25);
                let numCircles = 0;
                if (interpolator.length <= 0.5 * radius) {
                    numCircles = 1;
                }
                else {
                    numCircles = Math.ceil(interpolator.paddedLength / circleDist) + 1;
                }
                for (let i = 0; i < numCircles; i++) {
                    const t = i / Math.max(numCircles - 1, 1);
                    const circlePosition = interpolator.lerp(t);
                    // add viewport padding to the position and perform initial collision check
                    const centerX = circlePosition.x + viewportPadding;
                    const centerY = circlePosition.y + viewportPadding;
                    placedCollisionCircles.push(centerX, centerY, radius, 0);
                    const x1 = centerX - radius;
                    const y1 = centerY - radius;
                    const x2 = centerX + radius;
                    const y2 = centerY + radius;
                    entirelyOffscreen = entirelyOffscreen && this.isOffscreen(x1, y1, x2, y2);
                    inGrid = inGrid || this.isInsideGrid(x1, y1, x2, y2);
                    if (overlapMode !== 'always' && this.grid.hitTestCircle(centerX, centerY, radius, overlapMode, collisionGroupPredicate)) {
                        // Don't early exit if we're showing the debug circles because we still want to calculate
                        // which circles are in use
                        collisionDetected = true;
                        if (!showCollisionCircles) {
                            return {
                                circles: [],
                                offscreen: false,
                                collisionDetected
                            };
                        }
                    }
                }
            }
        }
        return {
            circles: ((!showCollisionCircles && collisionDetected) || !inGrid || perspectiveRatio < this.perspectiveRatioCutoff) ? [] : placedCollisionCircles,
            offscreen: entirelyOffscreen,
            collisionDetected
        };
    }
    projectPathToScreenSpace(projectedPath, projectionContext, labelToScreenMatrix) {
        return projectedPath.map(p => project(p, labelToScreenMatrix, projectionContext.getElevation));
    }
    /**
     * Because the geometries in the CollisionIndex are an approximation of the shape of
     * symbols on the map, we use the CollisionIndex to look up the symbol part of
     * `queryRenderedFeatures`.
     */
    queryRenderedSymbols(viewportQueryGeometry) {
        if (viewportQueryGeometry.length === 0 || (this.grid.keysLength() === 0 && this.ignoredGrid.keysLength() === 0)) {
            return {};
        }
        const query = [];
        let minX = Infinity;
        let minY = Infinity;
        let maxX = -Infinity;
        let maxY = -Infinity;
        for (const point of viewportQueryGeometry) {
            const gridPoint = new performance$1.P(point.x + viewportPadding, point.y + viewportPadding);
            minX = Math.min(minX, gridPoint.x);
            minY = Math.min(minY, gridPoint.y);
            maxX = Math.max(maxX, gridPoint.x);
            maxY = Math.max(maxY, gridPoint.y);
            query.push(gridPoint);
        }
        const features = this.grid.query(minX, minY, maxX, maxY)
            .concat(this.ignoredGrid.query(minX, minY, maxX, maxY));
        const seenFeatures = {};
        const result = {};
        for (const feature of features) {
            const featureKey = feature.key;
            // Skip already seen features.
            if (seenFeatures[featureKey.bucketInstanceId] === undefined) {
                seenFeatures[featureKey.bucketInstanceId] = {};
            }
            if (seenFeatures[featureKey.bucketInstanceId][featureKey.featureIndex]) {
                continue;
            }
            // Check if query intersects with the feature box
            // "Collision Circles" for line labels are treated as boxes here
            // Since there's no actual collision taking place, the circle vs. square
            // distinction doesn't matter as much, and box geometry is easier
            // to work with.
            const bbox = [
                new performance$1.P(feature.x1, feature.y1),
                new performance$1.P(feature.x2, feature.y1),
                new performance$1.P(feature.x2, feature.y2),
                new performance$1.P(feature.x1, feature.y2)
            ];
            if (!performance$1.an(query, bbox)) {
                continue;
            }
            seenFeatures[featureKey.bucketInstanceId][featureKey.featureIndex] = true;
            if (result[featureKey.bucketInstanceId] === undefined) {
                result[featureKey.bucketInstanceId] = [];
            }
            result[featureKey.bucketInstanceId].push(featureKey.featureIndex);
        }
        return result;
    }
    insertCollisionBox(collisionBox, overlapMode, ignorePlacement, bucketInstanceId, featureIndex, collisionGroupID) {
        const grid = ignorePlacement ? this.ignoredGrid : this.grid;
        const key = { bucketInstanceId, featureIndex, collisionGroupID, overlapMode };
        grid.insert(key, collisionBox[0], collisionBox[1], collisionBox[2], collisionBox[3]);
    }
    insertCollisionCircles(collisionCircles, overlapMode, ignorePlacement, bucketInstanceId, featureIndex, collisionGroupID) {
        const grid = ignorePlacement ? this.ignoredGrid : this.grid;
        const key = { bucketInstanceId, featureIndex, collisionGroupID, overlapMode };
        for (let k = 0; k < collisionCircles.length; k += 4) {
            grid.insertCircle(key, collisionCircles[k], collisionCircles[k + 1], collisionCircles[k + 2]);
        }
    }
    projectAndGetPerspectiveRatio(posMatrix, x, y, unwrappedTileID, getElevation) {
        const projected = this.mapProjection.useSpecialProjectionForSymbols ?
            this.mapProjection.projectTileCoordinates(x, y, unwrappedTileID, getElevation) :
            project(new performance$1.P(x, y), posMatrix, getElevation);
        return {
            point: new performance$1.P((((projected.point.x + 1) / 2) * this.transform.width) + viewportPadding, (((-projected.point.y + 1) / 2) * this.transform.height) + viewportPadding),
            // See perspective ratio comment in symbol_sdf.vertex
            // We're doing collision detection in viewport space so we need
            // to scale down boxes in the distance
            perspectiveRatio: 0.5 + 0.5 * (this.transform.cameraToCenterDistance / projected.signedDistanceFromCamera),
            isOccluded: projected.isOccluded,
            signedDistanceFromCamera: projected.signedDistanceFromCamera
        };
    }
    getPerspectiveRatio(posMatrix, x, y, unwrappedTileID, getElevation) {
        // We don't care about the actual projected point, just its W component.
        const projected = this.mapProjection.useSpecialProjectionForSymbols ?
            this.mapProjection.projectTileCoordinates(x, y, unwrappedTileID, getElevation) :
            project(new performance$1.P(x, y), posMatrix, getElevation);
        return 0.5 + 0.5 * (this.transform.cameraToCenterDistance / projected.signedDistanceFromCamera);
    }
    isOffscreen(x1, y1, x2, y2) {
        return x2 < viewportPadding || x1 >= this.screenRightBoundary || y2 < viewportPadding || y1 > this.screenBottomBoundary;
    }
    isInsideGrid(x1, y1, x2, y2) {
        return x2 >= 0 && x1 < this.gridRightBoundary && y2 >= 0 && y1 < this.gridBottomBoundary;
    }
    /*
    * Returns a matrix for transforming collision shapes to viewport coordinate space.
    * Use this function to render e.g. collision circles on the screen.
    *   example transformation: clipPos = glCoordMatrix * viewportMatrix * circle_pos
    */
    getViewportMatrix() {
        const m = performance$1.ao([]);
        performance$1.J(m, m, [-viewportPadding, -viewportPadding, 0.0]);
        return m;
    }
    /**
     * Applies all layout+paint properties of the given box in order to find as good approximation of its screen-space bounding box as possible.
     */
    _projectCollisionBox(collisionBox, textPixelRatio, posMatrix, unwrappedTileID, pitchWithMap, rotateWithMap, translation, projectedPoint, getElevation, shift) {
        const tileToViewport = textPixelRatio * projectedPoint.perspectiveRatio;
        // These vectors are valid both for screen space viewport-rotation-aligned texts and for pitch-align: map texts that are map-rotation-aligned.
        let vecEast = new performance$1.P(1, 0);
        let vecSouth = new performance$1.P(0, 1);
        const translatedAnchor = new performance$1.P(collisionBox.anchorPointX + translation[0], collisionBox.anchorPointY + translation[1]);
        if (rotateWithMap && !pitchWithMap) {
            // Handles screen space texts that are always aligned east-west.
            const projectedEast = this.projectAndGetPerspectiveRatio(posMatrix, translatedAnchor.x + 1, translatedAnchor.y, unwrappedTileID, getElevation).point;
            const toEast = projectedEast.sub(projectedPoint.point).unit();
            const angle = Math.atan(toEast.y / toEast.x) + (toEast.x < 0 ? Math.PI : 0);
            const sin = Math.sin(angle);
            const cos = Math.cos(angle);
            vecEast = new performance$1.P(cos, sin);
            vecSouth = new performance$1.P(-sin, cos);
        }
        else if (!rotateWithMap && pitchWithMap) {
            // Handles pitch-align: map texts that are always aligned with the viewport's X axis.
            const angle = -this.transform.angle;
            const sin = Math.sin(angle);
            const cos = Math.cos(angle);
            vecEast = new performance$1.P(cos, sin);
            vecSouth = new performance$1.P(-sin, cos);
        }
        // Configuration for screen space offsets
        let basePoint = projectedPoint.point;
        let distanceMultiplier = tileToViewport;
        if (pitchWithMap) {
            // Configuration for tile space (map-pitch-aligned) offsets
            basePoint = translatedAnchor;
            const zoomFraction = this.transform.zoom - Math.floor(this.transform.zoom);
            distanceMultiplier = Math.pow(2, -zoomFraction);
            distanceMultiplier *= this.mapProjection.getPitchedTextCorrection(this.transform, translatedAnchor, unwrappedTileID);
            // This next correction can't be applied when variable anchors are in use.
            if (!shift) {
                // Shader applies a perspective size correction, we need to apply the same correction.
                // For non-pitchWithMap texts, this is handled above by multiplying `textPixelRatio` with `projectedPoint.perspectiveRatio`,
                // which is equivalent to the non-pitchWithMap branch of the GLSL code.
                // Here, we compute and apply the pitchWithMap branch.
                // See the computation of `perspective_ratio` in the symbol vertex shaders for the GLSL code.
                const distanceRatio = projectedPoint.signedDistanceFromCamera / this.transform.cameraToCenterDistance;
                const perspectiveRatio = performance$1.ad(0.5 + 0.5 * distanceRatio, 0.0, 4.0); // Same clamp as what is used in the shader.
                distanceMultiplier *= perspectiveRatio;
            }
        }
        if (shift) {
            // Variable anchors are in use
            basePoint = basePoint.add(vecEast.mult(shift.x * distanceMultiplier)).add(vecSouth.mult(shift.y * distanceMultiplier));
        }
        const offsetXmin = collisionBox.x1 * distanceMultiplier;
        const offsetXmax = collisionBox.x2 * distanceMultiplier;
        const offsetXhalf = (offsetXmin + offsetXmax) / 2;
        const offsetYmin = collisionBox.y1 * distanceMultiplier;
        const offsetYmax = collisionBox.y2 * distanceMultiplier;
        const offsetYhalf = (offsetYmin + offsetYmax) / 2;
        // 0--1--2
        // |     |
        // 7     3
        // |     |
        // 6--5--4
        const offsetsArray = [
            { offsetX: offsetXmin, offsetY: offsetYmin },
            { offsetX: offsetXhalf, offsetY: offsetYmin },
            { offsetX: offsetXmax, offsetY: offsetYmin },
            { offsetX: offsetXmax, offsetY: offsetYhalf },
            { offsetX: offsetXmax, offsetY: offsetYmax },
            { offsetX: offsetXhalf, offsetY: offsetYmax },
            { offsetX: offsetXmin, offsetY: offsetYmax },
            { offsetX: offsetXmin, offsetY: offsetYhalf }
        ];
        let points = [];
        for (const { offsetX, offsetY } of offsetsArray) {
            points.push(new performance$1.P(basePoint.x + vecEast.x * offsetX + vecSouth.x * offsetY, basePoint.y + vecEast.y * offsetX + vecSouth.y * offsetY));
        }
        // Is any point of the collision shape visible on the globe (on beyond horizon)?
        let anyPointVisible = false;
        if (pitchWithMap) {
            const projected = points.map(p => this.projectAndGetPerspectiveRatio(posMatrix, p.x, p.y, unwrappedTileID, getElevation));
            // Is at least one of the projected points NOT behind the horizon?
            anyPointVisible = projected.some(p => !p.isOccluded);
            points = projected.map(p => p.point);
        }
        else {
            // Labels that are not pitchWithMap cannot ever hide behind the horizon.
            anyPointVisible = true;
        }
        return {
            box: performance$1.ap(points),
            allPointsOccluded: !anyPointVisible
        };
    }
}

/**
 * Converts a pixel value at a the given zoom level to tile units.
 *
 * The shaders mostly calculate everything in tile units so style
 * properties need to be converted from pixels to tile units using this.
 *
 * For example, a translation by 30 pixels at zoom 6.5 will be a
 * translation by pixelsToTileUnits(30, 6.5) tile units.
 *
 * @returns value in tile units
 */
function pixelsToTileUnits(tile, pixelValue, z) {
    return pixelValue * (performance$1.X / (tile.tileSize * Math.pow(2, z - tile.tileID.overscaledZ)));
}

class OpacityState {
    constructor(prevState, increment, placed, skipFade) {
        if (prevState) {
            this.opacity = Math.max(0, Math.min(1, prevState.opacity + (prevState.placed ? increment : -increment)));
        }
        else {
            this.opacity = (skipFade && placed) ? 1 : 0;
        }
        this.placed = placed;
    }
    isHidden() {
        return this.opacity === 0 && !this.placed;
    }
}
class JointOpacityState {
    constructor(prevState, increment, placedText, placedIcon, skipFade) {
        this.text = new OpacityState(prevState ? prevState.text : null, increment, placedText, skipFade);
        this.icon = new OpacityState(prevState ? prevState.icon : null, increment, placedIcon, skipFade);
    }
    isHidden() {
        return this.text.isHidden() && this.icon.isHidden();
    }
}
class JointPlacement {
    constructor(text, icon, skipFade) {
        this.text = text;
        this.icon = icon;
        this.skipFade = skipFade;
    }
}
class CollisionCircleArray {
    constructor() {
        this.invProjMatrix = performance$1.H();
        this.viewportMatrix = performance$1.H();
        this.circles = [];
    }
}
class RetainedQueryData {
    constructor(bucketInstanceId, featureIndex, sourceLayerIndex, bucketIndex, tileID) {
        this.bucketInstanceId = bucketInstanceId;
        this.featureIndex = featureIndex;
        this.sourceLayerIndex = sourceLayerIndex;
        this.bucketIndex = bucketIndex;
        this.tileID = tileID;
    }
}
class CollisionGroups {
    constructor(crossSourceCollisions) {
        this.crossSourceCollisions = crossSourceCollisions;
        this.maxGroupID = 0;
        this.collisionGroups = {};
    }
    get(sourceID) {
        // The predicate/groupID mechanism allows for arbitrary grouping,
        // but the current interface defines one source == one group when
        // crossSourceCollisions == true.
        if (!this.crossSourceCollisions) {
            if (!this.collisionGroups[sourceID]) {
                const nextGroupID = ++this.maxGroupID;
                this.collisionGroups[sourceID] = {
                    ID: nextGroupID,
                    predicate: (key) => {
                        return key.collisionGroupID === nextGroupID;
                    }
                };
            }
            return this.collisionGroups[sourceID];
        }
        else {
            return { ID: 0, predicate: null };
        }
    }
}
function calculateVariableLayoutShift(anchor, width, height, textOffset, textBoxScale) {
    const { horizontalAlign, verticalAlign } = performance$1.av(anchor);
    const shiftX = -(horizontalAlign - 0.5) * width;
    const shiftY = -(verticalAlign - 0.5) * height;
    return new performance$1.P(shiftX + textOffset[0] * textBoxScale, shiftY + textOffset[1] * textBoxScale);
}
class Placement {
    constructor(transform, projection, terrain, fadeDuration, crossSourceCollisions, prevPlacement) {
        this.transform = transform.clone();
        this.terrain = terrain;
        this.collisionIndex = new CollisionIndex(this.transform, projection);
        this.placements = {};
        this.opacities = {};
        this.variableOffsets = {};
        this.stale = false;
        this.commitTime = 0;
        this.fadeDuration = fadeDuration;
        this.retainedQueryData = {};
        this.collisionGroups = new CollisionGroups(crossSourceCollisions);
        this.collisionCircleArrays = {};
        this.collisionBoxArrays = new Map();
        this.prevPlacement = prevPlacement;
        if (prevPlacement) {
            prevPlacement.prevPlacement = undefined; // Only hold on to one placement back
        }
        this.placedOrientations = {};
    }
    _getTerrainElevationFunc(tileID) {
        const terrain = this.terrain;
        return terrain ? (x, y) => terrain.getElevation(tileID, x, y) : null;
    }
    getBucketParts(results, styleLayer, tile, sortAcrossTiles) {
        const symbolBucket = tile.getBucket(styleLayer);
        const bucketFeatureIndex = tile.latestFeatureIndex;
        if (!symbolBucket || !bucketFeatureIndex || styleLayer.id !== symbolBucket.layerIds[0])
            return;
        const collisionBoxArray = tile.collisionBoxArray;
        const layout = symbolBucket.layers[0].layout;
        const paint = symbolBucket.layers[0].paint;
        const scale = Math.pow(2, this.transform.zoom - tile.tileID.overscaledZ);
        const textPixelRatio = tile.tileSize / performance$1.X;
        const unwrappedTileID = tile.tileID.toUnwrapped();
        const posMatrix = this.transform.calculatePosMatrix(unwrappedTileID);
        const pitchWithMap = layout.get('text-pitch-alignment') === 'map';
        const rotateWithMap = layout.get('text-rotation-alignment') === 'map';
        const pixelsToTiles = pixelsToTileUnits(tile, 1, this.transform.zoom);
        const translationText = this.collisionIndex.mapProjection.translatePosition(this.transform, tile, paint.get('text-translate'), paint.get('text-translate-anchor'));
        const translationIcon = this.collisionIndex.mapProjection.translatePosition(this.transform, tile, paint.get('icon-translate'), paint.get('icon-translate-anchor'));
        const textLabelPlaneMatrix = getLabelPlaneMatrix(posMatrix, pitchWithMap, rotateWithMap, this.transform, pixelsToTiles);
        let labelToScreenMatrix = null;
        if (pitchWithMap) {
            const glMatrix = getGlCoordMatrix(posMatrix, pitchWithMap, rotateWithMap, this.transform, pixelsToTiles);
            labelToScreenMatrix = performance$1.L([], this.transform.labelPlaneMatrix, glMatrix);
        }
        // As long as this placement lives, we have to hold onto this bucket's
        // matching FeatureIndex/data for querying purposes
        this.retainedQueryData[symbolBucket.bucketInstanceId] = new RetainedQueryData(symbolBucket.bucketInstanceId, bucketFeatureIndex, symbolBucket.sourceLayerIndex, symbolBucket.index, tile.tileID);
        const parameters = {
            bucket: symbolBucket,
            layout,
            translationText,
            translationIcon,
            posMatrix,
            unwrappedTileID,
            textLabelPlaneMatrix,
            labelToScreenMatrix,
            scale,
            textPixelRatio,
            holdingForFade: tile.holdingForFade(),
            collisionBoxArray,
            partiallyEvaluatedTextSize: performance$1.ah(symbolBucket.textSizeData, this.transform.zoom),
            collisionGroup: this.collisionGroups.get(symbolBucket.sourceID)
        };
        if (sortAcrossTiles) {
            for (const range of symbolBucket.sortKeyRanges) {
                const { sortKey, symbolInstanceStart, symbolInstanceEnd } = range;
                results.push({ sortKey, symbolInstanceStart, symbolInstanceEnd, parameters });
            }
        }
        else {
            results.push({
                symbolInstanceStart: 0,
                symbolInstanceEnd: symbolBucket.symbolInstances.length,
                parameters
            });
        }
    }
    attemptAnchorPlacement(textAnchorOffset, textBox, width, height, textBoxScale, rotateWithMap, pitchWithMap, textPixelRatio, posMatrix, unwrappedTileID, collisionGroup, textOverlapMode, symbolInstance, bucket, orientation, translationText, translationIcon, iconBox, getElevation) {
        const anchor = performance$1.ar[textAnchorOffset.textAnchor];
        const textOffset = [textAnchorOffset.textOffset0, textAnchorOffset.textOffset1];
        const shift = calculateVariableLayoutShift(anchor, width, height, textOffset, textBoxScale);
        const placedGlyphBoxes = this.collisionIndex.placeCollisionBox(textBox, textOverlapMode, textPixelRatio, posMatrix, unwrappedTileID, pitchWithMap, rotateWithMap, translationText, collisionGroup.predicate, getElevation, shift);
        if (iconBox) {
            const placedIconBoxes = this.collisionIndex.placeCollisionBox(iconBox, textOverlapMode, textPixelRatio, posMatrix, unwrappedTileID, pitchWithMap, rotateWithMap, translationIcon, collisionGroup.predicate, getElevation, shift);
            if (!placedIconBoxes.placeable)
                return;
        }
        if (placedGlyphBoxes.placeable) {
            let prevAnchor;
            // If this label was placed in the previous placement, record the anchor position
            // to allow us to animate the transition
            if (this.prevPlacement &&
                this.prevPlacement.variableOffsets[symbolInstance.crossTileID] &&
                this.prevPlacement.placements[symbolInstance.crossTileID] &&
                this.prevPlacement.placements[symbolInstance.crossTileID].text) {
                prevAnchor = this.prevPlacement.variableOffsets[symbolInstance.crossTileID].anchor;
            }
            if (symbolInstance.crossTileID === 0)
                throw new Error('symbolInstance.crossTileID can\'t be 0');
            this.variableOffsets[symbolInstance.crossTileID] = {
                textOffset,
                width,
                height,
                anchor,
                textBoxScale,
                prevAnchor
            };
            this.markUsedJustification(bucket, anchor, symbolInstance, orientation);
            if (bucket.allowVerticalPlacement) {
                this.markUsedOrientation(bucket, orientation, symbolInstance);
                this.placedOrientations[symbolInstance.crossTileID] = orientation;
            }
            return { shift, placedGlyphBoxes };
        }
    }
    placeLayerBucketPart(bucketPart, seenCrossTileIDs, showCollisionBoxes) {
        const { bucket, layout, translationText, translationIcon, posMatrix, unwrappedTileID, textLabelPlaneMatrix, labelToScreenMatrix, textPixelRatio, holdingForFade, collisionBoxArray, partiallyEvaluatedTextSize, collisionGroup } = bucketPart.parameters;
        const textOptional = layout.get('text-optional');
        const iconOptional = layout.get('icon-optional');
        const textOverlapMode = performance$1.as(layout, 'text-overlap', 'text-allow-overlap');
        const textAlwaysOverlap = textOverlapMode === 'always';
        const iconOverlapMode = performance$1.as(layout, 'icon-overlap', 'icon-allow-overlap');
        const iconAlwaysOverlap = iconOverlapMode === 'always';
        const rotateWithMap = layout.get('text-rotation-alignment') === 'map';
        const pitchWithMap = layout.get('text-pitch-alignment') === 'map';
        const hasIconTextFit = layout.get('icon-text-fit') !== 'none';
        const zOrderByViewportY = layout.get('symbol-z-order') === 'viewport-y';
        // This logic is similar to the "defaultOpacityState" logic below in updateBucketOpacities
        // If we know a symbol is always supposed to show, force it to be marked visible even if
        // it wasn't placed into the collision index (because some or all of it was outside the range
        // of the collision grid).
        // There is a subtle edge case here we're accepting:
        //  Symbol A has text-allow-overlap: true, icon-allow-overlap: true, icon-optional: false
        //  A's icon is outside the grid, so doesn't get placed
        //  A's text would be inside grid, but doesn't get placed because of icon-optional: false
        //  We still show A because of the allow-overlap settings.
        //  Symbol B has allow-overlap: false, and gets placed where A's text would be
        //  On panning in, there is a short period when Symbol B and Symbol A will overlap
        //  This is the reverse of our normal policy of "fade in on pan", but should look like any other
        //  collision and hopefully not be too noticeable.
        // See https://github.com/mapbox/mapbox-gl-js/issues/7172
        const alwaysShowText = textAlwaysOverlap && (iconAlwaysOverlap || !bucket.hasIconData() || iconOptional);
        const alwaysShowIcon = iconAlwaysOverlap && (textAlwaysOverlap || !bucket.hasTextData() || textOptional);
        if (!bucket.collisionArrays && collisionBoxArray) {
            bucket.deserializeCollisionBoxes(collisionBoxArray);
        }
        const tileID = this.retainedQueryData[bucket.bucketInstanceId].tileID;
        const getElevation = this._getTerrainElevationFunc(tileID);
        const placeSymbol = (symbolInstance, collisionArrays, symbolIndex) => {
            var _a, _b;
            if (seenCrossTileIDs[symbolInstance.crossTileID])
                return;
            if (holdingForFade) {
                // Mark all symbols from this tile as "not placed", but don't add to seenCrossTileIDs, because we don't
                // know yet if we have a duplicate in a parent tile that _should_ be placed.
                this.placements[symbolInstance.crossTileID] = new JointPlacement(false, false, false);
                return;
            }
            let placeText = false;
            let placeIcon = false;
            let offscreen = true;
            let shift = null;
            let placed = { box: null, placeable: false, offscreen: null };
            let placedVerticalText = { box: null, placeable: false, offscreen: null };
            let placedGlyphBoxes = null;
            let placedGlyphCircles = null;
            let placedIconBoxes = null;
            let textFeatureIndex = 0;
            let verticalTextFeatureIndex = 0;
            let iconFeatureIndex = 0;
            if (collisionArrays.textFeatureIndex) {
                textFeatureIndex = collisionArrays.textFeatureIndex;
            }
            else if (symbolInstance.useRuntimeCollisionCircles) {
                textFeatureIndex = symbolInstance.featureIndex;
            }
            if (collisionArrays.verticalTextFeatureIndex) {
                verticalTextFeatureIndex = collisionArrays.verticalTextFeatureIndex;
            }
            const textBox = collisionArrays.textBox;
            if (textBox) {
                const updatePreviousOrientationIfNotPlaced = (isPlaced) => {
                    let previousOrientation = performance$1.ai.horizontal;
                    if (bucket.allowVerticalPlacement && !isPlaced && this.prevPlacement) {
                        const prevPlacedOrientation = this.prevPlacement.placedOrientations[symbolInstance.crossTileID];
                        if (prevPlacedOrientation) {
                            this.placedOrientations[symbolInstance.crossTileID] = prevPlacedOrientation;
                            previousOrientation = prevPlacedOrientation;
                            this.markUsedOrientation(bucket, previousOrientation, symbolInstance);
                        }
                    }
                    return previousOrientation;
                };
                const placeTextForPlacementModes = (placeHorizontalFn, placeVerticalFn) => {
                    if (bucket.allowVerticalPlacement && symbolInstance.numVerticalGlyphVertices > 0 && collisionArrays.verticalTextBox) {
                        for (const placementMode of bucket.writingModes) {
                            if (placementMode === performance$1.ai.vertical) {
                                placed = placeVerticalFn();
                                placedVerticalText = placed;
                            }
                            else {
                                placed = placeHorizontalFn();
                            }
                            if (placed && placed.placeable)
                                break;
                        }
                    }
                    else {
                        placed = placeHorizontalFn();
                    }
                };
                const textAnchorOffsetStart = symbolInstance.textAnchorOffsetStartIndex;
                const textAnchorOffsetEnd = symbolInstance.textAnchorOffsetEndIndex;
                // If start+end indices match, text-variable-anchor is not in play.
                if (textAnchorOffsetEnd === textAnchorOffsetStart) {
                    const placeBox = (collisionTextBox, orientation) => {
                        const placedFeature = this.collisionIndex.placeCollisionBox(collisionTextBox, textOverlapMode, textPixelRatio, posMatrix, unwrappedTileID, pitchWithMap, rotateWithMap, translationText, collisionGroup.predicate, getElevation);
                        if (placedFeature && placedFeature.placeable) {
                            this.markUsedOrientation(bucket, orientation, symbolInstance);
                            this.placedOrientations[symbolInstance.crossTileID] = orientation;
                        }
                        return placedFeature;
                    };
                    const placeHorizontal = () => {
                        return placeBox(textBox, performance$1.ai.horizontal);
                    };
                    const placeVertical = () => {
                        const verticalTextBox = collisionArrays.verticalTextBox;
                        if (bucket.allowVerticalPlacement && symbolInstance.numVerticalGlyphVertices > 0 && verticalTextBox) {
                            return placeBox(verticalTextBox, performance$1.ai.vertical);
                        }
                        return { box: null, offscreen: null };
                    };
                    placeTextForPlacementModes(placeHorizontal, placeVertical);
                    updatePreviousOrientationIfNotPlaced(placed && placed.placeable);
                }
                else {
                    // If this symbol was in the last placement, prefer placement using same anchor, if it's still available
                    let prevAnchor = performance$1.ar[(_b = (_a = this.prevPlacement) === null || _a === void 0 ? void 0 : _a.variableOffsets[symbolInstance.crossTileID]) === null || _b === void 0 ? void 0 : _b.anchor];
                    const placeBoxForVariableAnchors = (collisionTextBox, collisionIconBox, orientation) => {
                        const width = collisionTextBox.x2 - collisionTextBox.x1;
                        const height = collisionTextBox.y2 - collisionTextBox.y1;
                        const textBoxScale = symbolInstance.textBoxScale;
                        const variableIconBox = hasIconTextFit && (iconOverlapMode === 'never') ? collisionIconBox : null;
                        let placedBox = null;
                        let placementPasses = (textOverlapMode === 'never') ? 1 : 2;
                        let overlapMode = 'never';
                        if (prevAnchor) {
                            placementPasses++;
                        }
                        for (let pass = 0; pass < placementPasses; pass++) {
                            for (let i = textAnchorOffsetStart; i < textAnchorOffsetEnd; i++) {
                                const textAnchorOffset = bucket.textAnchorOffsets.get(i);
                                if (prevAnchor && textAnchorOffset.textAnchor !== prevAnchor) {
                                    continue;
                                }
                                const result = this.attemptAnchorPlacement(textAnchorOffset, collisionTextBox, width, height, textBoxScale, rotateWithMap, pitchWithMap, textPixelRatio, posMatrix, unwrappedTileID, collisionGroup, overlapMode, symbolInstance, bucket, orientation, translationText, translationIcon, variableIconBox, getElevation);
                                if (result) {
                                    placedBox = result.placedGlyphBoxes;
                                    if (placedBox && placedBox.placeable) {
                                        placeText = true;
                                        shift = result.shift;
                                        return placedBox;
                                    }
                                }
                            }
                            if (prevAnchor) {
                                prevAnchor = null;
                            }
                            else {
                                overlapMode = textOverlapMode;
                            }
                        }
                        if (showCollisionBoxes && !placedBox) {
                            // No box was successfully placed
                            // Generate bounds for a fake centered box, so that we can at least display something for collision debug.
                            const placedFakeGlyphBox = this.collisionIndex.placeCollisionBox(textBox, 'always', // Skips expensive collision check with already placed boxes
                            textPixelRatio, posMatrix, unwrappedTileID, pitchWithMap, rotateWithMap, translationText, collisionGroup.predicate, getElevation, new performance$1.P(0, 0));
                            placedBox = {
                                box: placedFakeGlyphBox.box,
                                offscreen: false,
                                placeable: false
                            };
                        }
                        return placedBox;
                    };
                    const placeHorizontal = () => {
                        return placeBoxForVariableAnchors(textBox, collisionArrays.iconBox, performance$1.ai.horizontal);
                    };
                    const placeVertical = () => {
                        const verticalTextBox = collisionArrays.verticalTextBox;
                        const wasPlaced = placed && placed.placeable;
                        if (bucket.allowVerticalPlacement && !wasPlaced && symbolInstance.numVerticalGlyphVertices > 0 && verticalTextBox) {
                            return placeBoxForVariableAnchors(verticalTextBox, collisionArrays.verticalIconBox, performance$1.ai.vertical);
                        }
                        return { box: null, occluded: true, offscreen: null };
                    };
                    placeTextForPlacementModes(placeHorizontal, placeVertical);
                    if (placed) {
                        placeText = placed.placeable;
                        offscreen = placed.offscreen;
                    }
                    const prevOrientation = updatePreviousOrientationIfNotPlaced(placed && placed.placeable);
                    // If we didn't get placed, we still need to copy our position from the last placement for
                    // fade animations
                    if (!placeText && this.prevPlacement) {
                        const prevOffset = this.prevPlacement.variableOffsets[symbolInstance.crossTileID];
                        if (prevOffset) {
                            this.variableOffsets[symbolInstance.crossTileID] = prevOffset;
                            this.markUsedJustification(bucket, prevOffset.anchor, symbolInstance, prevOrientation);
                        }
                    }
                }
            }
            placedGlyphBoxes = placed;
            placeText = placedGlyphBoxes && placedGlyphBoxes.placeable;
            offscreen = placedGlyphBoxes && placedGlyphBoxes.offscreen;
            if (symbolInstance.useRuntimeCollisionCircles) {
                const placedSymbol = bucket.text.placedSymbolArray.get(symbolInstance.centerJustifiedTextSymbolIndex);
                const fontSize = performance$1.aj(bucket.textSizeData, partiallyEvaluatedTextSize, placedSymbol);
                const textPixelPadding = layout.get('text-padding');
                const circlePixelDiameter = symbolInstance.collisionCircleDiameter;
                placedGlyphCircles = this.collisionIndex.placeCollisionCircles(textOverlapMode, placedSymbol, bucket.lineVertexArray, bucket.glyphOffsetArray, fontSize, posMatrix, unwrappedTileID, textLabelPlaneMatrix, labelToScreenMatrix, showCollisionBoxes, pitchWithMap, collisionGroup.predicate, circlePixelDiameter, textPixelPadding, translationText, getElevation);
                if (placedGlyphCircles.circles.length && placedGlyphCircles.collisionDetected && !showCollisionBoxes) {
                    performance$1.w('Collisions detected, but collision boxes are not shown');
                }
                // If text-overlap is set to 'always', force "placedCircles" to true
                // In theory there should always be at least one circle placed
                // in this case, but for now quirks in text-anchor
                // and text-offset may prevent that from being true.
                placeText = textAlwaysOverlap || (placedGlyphCircles.circles.length > 0 && !placedGlyphCircles.collisionDetected);
                offscreen = offscreen && placedGlyphCircles.offscreen;
            }
            if (collisionArrays.iconFeatureIndex) {
                iconFeatureIndex = collisionArrays.iconFeatureIndex;
            }
            if (collisionArrays.iconBox) {
                const placeIconFeature = iconBox => {
                    return this.collisionIndex.placeCollisionBox(iconBox, iconOverlapMode, textPixelRatio, posMatrix, unwrappedTileID, pitchWithMap, rotateWithMap, translationIcon, collisionGroup.predicate, getElevation, (hasIconTextFit && shift) ? shift : undefined);
                };
                if (placedVerticalText && placedVerticalText.placeable && collisionArrays.verticalIconBox) {
                    placedIconBoxes = placeIconFeature(collisionArrays.verticalIconBox);
                    placeIcon = placedIconBoxes.placeable;
                }
                else {
                    placedIconBoxes = placeIconFeature(collisionArrays.iconBox);
                    placeIcon = placedIconBoxes.placeable;
                }
                offscreen = offscreen && placedIconBoxes.offscreen;
            }
            const iconWithoutText = textOptional ||
                (symbolInstance.numHorizontalGlyphVertices === 0 && symbolInstance.numVerticalGlyphVertices === 0);
            const textWithoutIcon = iconOptional || symbolInstance.numIconVertices === 0;
            // Combine the scales for icons and text.
            if (!iconWithoutText && !textWithoutIcon) {
                placeIcon = placeText = placeIcon && placeText;
            }
            else if (!textWithoutIcon) {
                placeText = placeIcon && placeText;
            }
            else if (!iconWithoutText) {
                placeIcon = placeIcon && placeText;
            }
            const hasTextBox = placeText && placedGlyphBoxes.placeable;
            const hasIconBox = placeIcon && placedIconBoxes.placeable;
            if (hasTextBox) {
                if (placedVerticalText && placedVerticalText.placeable && verticalTextFeatureIndex) {
                    this.collisionIndex.insertCollisionBox(placedGlyphBoxes.box, textOverlapMode, layout.get('text-ignore-placement'), bucket.bucketInstanceId, verticalTextFeatureIndex, collisionGroup.ID);
                }
                else {
                    this.collisionIndex.insertCollisionBox(placedGlyphBoxes.box, textOverlapMode, layout.get('text-ignore-placement'), bucket.bucketInstanceId, textFeatureIndex, collisionGroup.ID);
                }
            }
            if (hasIconBox) {
                this.collisionIndex.insertCollisionBox(placedIconBoxes.box, iconOverlapMode, layout.get('icon-ignore-placement'), bucket.bucketInstanceId, iconFeatureIndex, collisionGroup.ID);
            }
            if (placedGlyphCircles) {
                if (placeText) {
                    this.collisionIndex.insertCollisionCircles(placedGlyphCircles.circles, textOverlapMode, layout.get('text-ignore-placement'), bucket.bucketInstanceId, textFeatureIndex, collisionGroup.ID);
                }
            }
            if (showCollisionBoxes) {
                this.storeCollisionData(bucket.bucketInstanceId, symbolIndex, collisionArrays, placedGlyphBoxes, placedIconBoxes, placedGlyphCircles);
            }
            if (symbolInstance.crossTileID === 0)
                throw new Error('symbolInstance.crossTileID can\'t be 0');
            if (bucket.bucketInstanceId === 0)
                throw new Error('bucket.bucketInstanceId can\'t be 0');
            this.placements[symbolInstance.crossTileID] = new JointPlacement(placeText || alwaysShowText, placeIcon || alwaysShowIcon, offscreen || bucket.justReloaded);
            seenCrossTileIDs[symbolInstance.crossTileID] = true;
        };
        if (zOrderByViewportY) {
            if (bucketPart.symbolInstanceStart !== 0)
                throw new Error('bucket.bucketInstanceId should be 0');
            const symbolIndexes = bucket.getSortedSymbolIndexes(this.transform.angle);
            for (let i = symbolIndexes.length - 1; i >= 0; --i) {
                const symbolIndex = symbolIndexes[i];
                placeSymbol(bucket.symbolInstances.get(symbolIndex), bucket.collisionArrays[symbolIndex], symbolIndex);
            }
        }
        else {
            for (let i = bucketPart.symbolInstanceStart; i < bucketPart.symbolInstanceEnd; i++) {
                placeSymbol(bucket.symbolInstances.get(i), bucket.collisionArrays[i], i);
            }
        }
        if (showCollisionBoxes && bucket.bucketInstanceId in this.collisionCircleArrays) {
            const circleArray = this.collisionCircleArrays[bucket.bucketInstanceId];
            // Store viewport and inverse projection matrices per bucket
            performance$1.at(circleArray.invProjMatrix, posMatrix);
            circleArray.viewportMatrix = this.collisionIndex.getViewportMatrix();
        }
        bucket.justReloaded = false;
    }
    storeCollisionData(bucketInstanceId, symbolIndex, collisionArrays, placedGlyphBoxes, placedIconBoxes, placedGlyphCircles) {
        if (collisionArrays.textBox || collisionArrays.iconBox) {
            // Store the actually used collision box for debug draw
            let boxArray;
            if (this.collisionBoxArrays.has(bucketInstanceId)) {
                boxArray = this.collisionBoxArrays.get(bucketInstanceId);
            }
            else {
                boxArray = new Map();
                this.collisionBoxArrays.set(bucketInstanceId, boxArray);
            }
            let realCollisionBox;
            if (boxArray.has(symbolIndex)) {
                realCollisionBox = boxArray.get(symbolIndex);
            }
            else {
                realCollisionBox = {
                    text: null,
                    icon: null
                };
                boxArray.set(symbolIndex, realCollisionBox);
            }
            if (collisionArrays.textBox) {
                realCollisionBox.text = placedGlyphBoxes.box;
            }
            if (collisionArrays.iconBox) {
                realCollisionBox.icon = placedIconBoxes.box;
            }
        }
        if (placedGlyphCircles) {
            let circleArray = this.collisionCircleArrays[bucketInstanceId];
            // Group collision circles together by bucket. Circles can't be pushed forward for rendering yet as the symbol placement
            // for a bucket is not guaranteed to be complete before the commit-function has been called
            if (circleArray === undefined)
                circleArray = this.collisionCircleArrays[bucketInstanceId] = new CollisionCircleArray();
            for (let i = 0; i < placedGlyphCircles.circles.length; i += 4) {
                circleArray.circles.push(placedGlyphCircles.circles[i + 0]); // x
                circleArray.circles.push(placedGlyphCircles.circles[i + 1]); // y
                circleArray.circles.push(placedGlyphCircles.circles[i + 2]); // radius
                circleArray.circles.push(placedGlyphCircles.collisionDetected ? 1 : 0); // collisionDetected-flag
            }
        }
    }
    markUsedJustification(bucket, placedAnchor, symbolInstance, orientation) {
        const justifications = {
            'left': symbolInstance.leftJustifiedTextSymbolIndex,
            'center': symbolInstance.centerJustifiedTextSymbolIndex,
            'right': symbolInstance.rightJustifiedTextSymbolIndex
        };
        let autoIndex;
        if (orientation === performance$1.ai.vertical) {
            autoIndex = symbolInstance.verticalPlacedTextSymbolIndex;
        }
        else {
            autoIndex = justifications[performance$1.au(placedAnchor)];
        }
        const indexes = [
            symbolInstance.leftJustifiedTextSymbolIndex,
            symbolInstance.centerJustifiedTextSymbolIndex,
            symbolInstance.rightJustifiedTextSymbolIndex,
            symbolInstance.verticalPlacedTextSymbolIndex
        ];
        for (const index of indexes) {
            if (index >= 0) {
                if (autoIndex >= 0 && index !== autoIndex) {
                    // There are multiple justifications and this one isn't it: shift offscreen
                    bucket.text.placedSymbolArray.get(index).crossTileID = 0;
                }
                else {
                    // Either this is the chosen justification or the justification is hardwired: use this one
                    bucket.text.placedSymbolArray.get(index).crossTileID = symbolInstance.crossTileID;
                }
            }
        }
    }
    markUsedOrientation(bucket, orientation, symbolInstance) {
        const horizontal = (orientation === performance$1.ai.horizontal || orientation === performance$1.ai.horizontalOnly) ? orientation : 0;
        const vertical = orientation === performance$1.ai.vertical ? orientation : 0;
        const horizontalIndexes = [
            symbolInstance.leftJustifiedTextSymbolIndex,
            symbolInstance.centerJustifiedTextSymbolIndex,
            symbolInstance.rightJustifiedTextSymbolIndex
        ];
        for (const index of horizontalIndexes) {
            bucket.text.placedSymbolArray.get(index).placedOrientation = horizontal;
        }
        if (symbolInstance.verticalPlacedTextSymbolIndex) {
            bucket.text.placedSymbolArray.get(symbolInstance.verticalPlacedTextSymbolIndex).placedOrientation = vertical;
        }
    }
    commit(now) {
        this.commitTime = now;
        this.zoomAtLastRecencyCheck = this.transform.zoom;
        const prevPlacement = this.prevPlacement;
        let placementChanged = false;
        this.prevZoomAdjustment = prevPlacement ? prevPlacement.zoomAdjustment(this.transform.zoom) : 0;
        const increment = prevPlacement ? prevPlacement.symbolFadeChange(now) : 1;
        const prevOpacities = prevPlacement ? prevPlacement.opacities : {};
        const prevOffsets = prevPlacement ? prevPlacement.variableOffsets : {};
        const prevOrientations = prevPlacement ? prevPlacement.placedOrientations : {};
        // add the opacities from the current placement, and copy their current values from the previous placement
        for (const crossTileID in this.placements) {
            const jointPlacement = this.placements[crossTileID];
            const prevOpacity = prevOpacities[crossTileID];
            if (prevOpacity) {
                this.opacities[crossTileID] = new JointOpacityState(prevOpacity, increment, jointPlacement.text, jointPlacement.icon);
                placementChanged = placementChanged ||
                    jointPlacement.text !== prevOpacity.text.placed ||
                    jointPlacement.icon !== prevOpacity.icon.placed;
            }
            else {
                this.opacities[crossTileID] = new JointOpacityState(null, increment, jointPlacement.text, jointPlacement.icon, jointPlacement.skipFade);
                placementChanged = placementChanged || jointPlacement.text || jointPlacement.icon;
            }
        }
        // copy and update values from the previous placement that aren't in the current placement but haven't finished fading
        for (const crossTileID in prevOpacities) {
            const prevOpacity = prevOpacities[crossTileID];
            if (!this.opacities[crossTileID]) {
                const jointOpacity = new JointOpacityState(prevOpacity, increment, false, false);
                if (!jointOpacity.isHidden()) {
                    this.opacities[crossTileID] = jointOpacity;
                    placementChanged = placementChanged || prevOpacity.text.placed || prevOpacity.icon.placed;
                }
            }
        }
        for (const crossTileID in prevOffsets) {
            if (!this.variableOffsets[crossTileID] && this.opacities[crossTileID] && !this.opacities[crossTileID].isHidden()) {
                this.variableOffsets[crossTileID] = prevOffsets[crossTileID];
            }
        }
        for (const crossTileID in prevOrientations) {
            if (!this.placedOrientations[crossTileID] && this.opacities[crossTileID] && !this.opacities[crossTileID].isHidden()) {
                this.placedOrientations[crossTileID] = prevOrientations[crossTileID];
            }
        }
        // this.lastPlacementChangeTime is the time of the last commit() that
        // resulted in a placement change -- in other words, the start time of
        // the last symbol fade animation
        if (prevPlacement && prevPlacement.lastPlacementChangeTime === undefined) {
            throw new Error('Last placement time for previous placement is not defined');
        }
        if (placementChanged) {
            this.lastPlacementChangeTime = now;
        }
        else if (typeof this.lastPlacementChangeTime !== 'number') {
            this.lastPlacementChangeTime = prevPlacement ? prevPlacement.lastPlacementChangeTime : now;
        }
    }
    updateLayerOpacities(styleLayer, tiles) {
        const seenCrossTileIDs = {};
        for (const tile of tiles) {
            const symbolBucket = tile.getBucket(styleLayer);
            if (symbolBucket && tile.latestFeatureIndex && styleLayer.id === symbolBucket.layerIds[0]) {
                this.updateBucketOpacities(symbolBucket, tile.tileID, seenCrossTileIDs, tile.collisionBoxArray);
            }
        }
    }
    updateBucketOpacities(bucket, tileID, seenCrossTileIDs, collisionBoxArray) {
        if (bucket.hasTextData()) {
            bucket.text.opacityVertexArray.clear();
            bucket.text.hasVisibleVertices = false;
        }
        if (bucket.hasIconData()) {
            bucket.icon.opacityVertexArray.clear();
            bucket.icon.hasVisibleVertices = false;
        }
        if (bucket.hasIconCollisionBoxData())
            bucket.iconCollisionBox.collisionVertexArray.clear();
        if (bucket.hasTextCollisionBoxData())
            bucket.textCollisionBox.collisionVertexArray.clear();
        const layer = bucket.layers[0];
        const layout = layer.layout;
        const duplicateOpacityState = new JointOpacityState(null, 0, false, false, true);
        const textAllowOverlap = layout.get('text-allow-overlap');
        const iconAllowOverlap = layout.get('icon-allow-overlap');
        const hasVariablePlacement = layer._unevaluatedLayout.hasValue('text-variable-anchor') || layer._unevaluatedLayout.hasValue('text-variable-anchor-offset');
        const rotateWithMap = layout.get('text-rotation-alignment') === 'map';
        const pitchWithMap = layout.get('text-pitch-alignment') === 'map';
        const hasIconTextFit = layout.get('icon-text-fit') !== 'none';
        // If allow-overlap is true, we can show symbols before placement runs on them
        // But we have to wait for placement if we potentially depend on a paired icon/text
        // with allow-overlap: false.
        // See https://github.com/mapbox/mapbox-gl-js/issues/7032
        const defaultOpacityState = new JointOpacityState(null, 0, textAllowOverlap && (iconAllowOverlap || !bucket.hasIconData() || layout.get('icon-optional')), iconAllowOverlap && (textAllowOverlap || !bucket.hasTextData() || layout.get('text-optional')), true);
        if (!bucket.collisionArrays && collisionBoxArray && ((bucket.hasIconCollisionBoxData() || bucket.hasTextCollisionBoxData()))) {
            bucket.deserializeCollisionBoxes(collisionBoxArray);
        }
        const addOpacities = (iconOrText, numVertices, opacity) => {
            for (let i = 0; i < numVertices / 4; i++) {
                iconOrText.opacityVertexArray.emplaceBack(opacity);
            }
            iconOrText.hasVisibleVertices = iconOrText.hasVisibleVertices || (opacity !== PACKED_HIDDEN_OPACITY);
        };
        const boxArrays = this.collisionBoxArrays.get(bucket.bucketInstanceId);
        for (let s = 0; s < bucket.symbolInstances.length; s++) {
            const symbolInstance = bucket.symbolInstances.get(s);
            const { numHorizontalGlyphVertices, numVerticalGlyphVertices, crossTileID } = symbolInstance;
            const isDuplicate = seenCrossTileIDs[crossTileID];
            let opacityState = this.opacities[crossTileID];
            if (isDuplicate) {
                opacityState = duplicateOpacityState;
            }
            else if (!opacityState) {
                opacityState = defaultOpacityState;
                // store the state so that future placements use it as a starting point
                this.opacities[crossTileID] = opacityState;
            }
            seenCrossTileIDs[crossTileID] = true;
            const hasText = numHorizontalGlyphVertices > 0 || numVerticalGlyphVertices > 0;
            const hasIcon = symbolInstance.numIconVertices > 0;
            const placedOrientation = this.placedOrientations[symbolInstance.crossTileID];
            const horizontalHidden = placedOrientation === performance$1.ai.vertical;
            const verticalHidden = placedOrientation === performance$1.ai.horizontal || placedOrientation === performance$1.ai.horizontalOnly;
            if (hasText) {
                const packedOpacity = packOpacity(opacityState.text);
                // Vertical text fades in/out on collision the same way as corresponding
                // horizontal text. Switch between vertical/horizontal should be instantaneous
                const horizontalOpacity = horizontalHidden ? PACKED_HIDDEN_OPACITY : packedOpacity;
                addOpacities(bucket.text, numHorizontalGlyphVertices, horizontalOpacity);
                const verticalOpacity = verticalHidden ? PACKED_HIDDEN_OPACITY : packedOpacity;
                addOpacities(bucket.text, numVerticalGlyphVertices, verticalOpacity);
                // If this label is completely faded, mark it so that we don't have to calculate
                // its position at render time. If this layer has variable placement, shift the various
                // symbol instances appropriately so that symbols from buckets that have yet to be placed
                // offset appropriately.
                const symbolHidden = opacityState.text.isHidden();
                [
                    symbolInstance.rightJustifiedTextSymbolIndex,
                    symbolInstance.centerJustifiedTextSymbolIndex,
                    symbolInstance.leftJustifiedTextSymbolIndex
                ].forEach(index => {
                    if (index >= 0) {
                        bucket.text.placedSymbolArray.get(index).hidden = symbolHidden || horizontalHidden ? 1 : 0;
                    }
                });
                if (symbolInstance.verticalPlacedTextSymbolIndex >= 0) {
                    bucket.text.placedSymbolArray.get(symbolInstance.verticalPlacedTextSymbolIndex).hidden = symbolHidden || verticalHidden ? 1 : 0;
                }
                const prevOffset = this.variableOffsets[symbolInstance.crossTileID];
                if (prevOffset) {
                    this.markUsedJustification(bucket, prevOffset.anchor, symbolInstance, placedOrientation);
                }
                const prevOrientation = this.placedOrientations[symbolInstance.crossTileID];
                if (prevOrientation) {
                    this.markUsedJustification(bucket, 'left', symbolInstance, prevOrientation);
                    this.markUsedOrientation(bucket, prevOrientation, symbolInstance);
                }
            }
            if (hasIcon) {
                const packedOpacity = packOpacity(opacityState.icon);
                const useHorizontal = !(hasIconTextFit && symbolInstance.verticalPlacedIconSymbolIndex && horizontalHidden);
                if (symbolInstance.placedIconSymbolIndex >= 0) {
                    const horizontalOpacity = useHorizontal ? packedOpacity : PACKED_HIDDEN_OPACITY;
                    addOpacities(bucket.icon, symbolInstance.numIconVertices, horizontalOpacity);
                    bucket.icon.placedSymbolArray.get(symbolInstance.placedIconSymbolIndex).hidden =
                        opacityState.icon.isHidden();
                }
                if (symbolInstance.verticalPlacedIconSymbolIndex >= 0) {
                    const verticalOpacity = !useHorizontal ? packedOpacity : PACKED_HIDDEN_OPACITY;
                    addOpacities(bucket.icon, symbolInstance.numVerticalIconVertices, verticalOpacity);
                    bucket.icon.placedSymbolArray.get(symbolInstance.verticalPlacedIconSymbolIndex).hidden =
                        opacityState.icon.isHidden();
                }
            }
            const realBoxes = (boxArrays && boxArrays.has(s)) ? boxArrays.get(s) : {
                text: null,
                icon: null
            };
            if (bucket.hasIconCollisionBoxData() || bucket.hasTextCollisionBoxData()) {
                const collisionArrays = bucket.collisionArrays[s];
                if (collisionArrays) {
                    let shift = new performance$1.P(0, 0);
                    if (collisionArrays.textBox || collisionArrays.verticalTextBox) {
                        let used = true;
                        if (hasVariablePlacement) {
                            const variableOffset = this.variableOffsets[crossTileID];
                            if (variableOffset) {
                                // This will show either the currently placed position or the last
                                // successfully placed position (so you can visualize what collision
                                // just made the symbol disappear, and the most likely place for the
                                // symbol to come back)
                                shift = calculateVariableLayoutShift(variableOffset.anchor, variableOffset.width, variableOffset.height, variableOffset.textOffset, variableOffset.textBoxScale);
                                if (rotateWithMap) {
                                    shift._rotate(pitchWithMap ? this.transform.angle : -this.transform.angle);
                                }
                            }
                            else {
                                // No offset -> this symbol hasn't been placed since coming on-screen
                                // No single box is particularly meaningful and all of them would be too noisy
                                // Use the center box just to show something's there, but mark it "not used"
                                used = false;
                            }
                        }
                        if (collisionArrays.textBox || collisionArrays.verticalTextBox) {
                            let hidden;
                            if (collisionArrays.textBox) {
                                hidden = horizontalHidden;
                            }
                            if (collisionArrays.verticalTextBox) {
                                hidden = verticalHidden;
                            }
                            updateCollisionVertices(bucket.textCollisionBox.collisionVertexArray, opacityState.text.placed, !used || hidden, realBoxes.text, shift.x, shift.y);
                        }
                    }
                    if (collisionArrays.iconBox || collisionArrays.verticalIconBox) {
                        const verticalIconUsed = Boolean(!verticalHidden && collisionArrays.verticalIconBox);
                        let hidden;
                        if (collisionArrays.iconBox) {
                            hidden = verticalIconUsed;
                        }
                        if (collisionArrays.verticalIconBox) {
                            hidden = !verticalIconUsed;
                        }
                        updateCollisionVertices(bucket.iconCollisionBox.collisionVertexArray, opacityState.icon.placed, hidden, realBoxes.icon, hasIconTextFit ? shift.x : 0, hasIconTextFit ? shift.y : 0);
                    }
                }
            }
        }
        bucket.sortFeatures(this.transform.angle);
        if (this.retainedQueryData[bucket.bucketInstanceId]) {
            this.retainedQueryData[bucket.bucketInstanceId].featureSortOrder = bucket.featureSortOrder;
        }
        if (bucket.hasTextData() && bucket.text.opacityVertexBuffer) {
            bucket.text.opacityVertexBuffer.updateData(bucket.text.opacityVertexArray);
        }
        if (bucket.hasIconData() && bucket.icon.opacityVertexBuffer) {
            bucket.icon.opacityVertexBuffer.updateData(bucket.icon.opacityVertexArray);
        }
        if (bucket.hasIconCollisionBoxData() && bucket.iconCollisionBox.collisionVertexBuffer) {
            bucket.iconCollisionBox.collisionVertexBuffer.updateData(bucket.iconCollisionBox.collisionVertexArray);
        }
        if (bucket.hasTextCollisionBoxData() && bucket.textCollisionBox.collisionVertexBuffer) {
            bucket.textCollisionBox.collisionVertexBuffer.updateData(bucket.textCollisionBox.collisionVertexArray);
        }
        if (bucket.text.opacityVertexArray.length !== bucket.text.layoutVertexArray.length / 4)
            throw new Error(`bucket.text.opacityVertexArray.length (= ${bucket.text.opacityVertexArray.length}) !== bucket.text.layoutVertexArray.length (= ${bucket.text.layoutVertexArray.length}) / 4`);
        if (bucket.icon.opacityVertexArray.length !== bucket.icon.layoutVertexArray.length / 4)
            throw new Error(`bucket.icon.opacityVertexArray.length (= ${bucket.icon.opacityVertexArray.length}) !== bucket.icon.layoutVertexArray.length (= ${bucket.icon.layoutVertexArray.length}) / 4`);
        // Push generated collision circles to the bucket for debug rendering
        if (bucket.bucketInstanceId in this.collisionCircleArrays) {
            const instance = this.collisionCircleArrays[bucket.bucketInstanceId];
            bucket.placementInvProjMatrix = instance.invProjMatrix;
            bucket.placementViewportMatrix = instance.viewportMatrix;
            bucket.collisionCircleArray = instance.circles;
            delete this.collisionCircleArrays[bucket.bucketInstanceId];
        }
    }
    symbolFadeChange(now) {
        return this.fadeDuration === 0 ?
            1 :
            ((now - this.commitTime) / this.fadeDuration + this.prevZoomAdjustment);
    }
    zoomAdjustment(zoom) {
        // When zooming out quickly, labels can overlap each other. This
        // adjustment is used to reduce the interval between placement calculations
        // and to reduce the fade duration when zooming out quickly. Discovering the
        // collisions more quickly and fading them more quickly reduces the unwanted effect.
        return Math.max(0, (this.transform.zoom - zoom) / 1.5);
    }
    hasTransitions(now) {
        return this.stale ||
            now - this.lastPlacementChangeTime < this.fadeDuration;
    }
    stillRecent(now, zoom) {
        // The adjustment makes placement more frequent when zooming.
        // This condition applies the adjustment only after the map has
        // stopped zooming. This avoids adding extra jank while zooming.
        const durationAdjustment = this.zoomAtLastRecencyCheck === zoom ?
            (1 - this.zoomAdjustment(zoom)) :
            1;
        this.zoomAtLastRecencyCheck = zoom;
        return this.commitTime + this.fadeDuration * durationAdjustment > now;
    }
    setStale() {
        this.stale = true;
    }
}
function updateCollisionVertices(collisionVertexArray, placed, notUsed, realBox, shiftX, shiftY) {
    if (!realBox || realBox.length === 0) {
        realBox = [0, 0, 0, 0];
    }
    const tlX = realBox[0] - viewportPadding;
    const tlY = realBox[1] - viewportPadding;
    const brX = realBox[2] - viewportPadding;
    const brY = realBox[3] - viewportPadding;
    collisionVertexArray.emplaceBack(placed ? 1 : 0, notUsed ? 1 : 0, shiftX || 0, shiftY || 0, tlX, tlY);
    collisionVertexArray.emplaceBack(placed ? 1 : 0, notUsed ? 1 : 0, shiftX || 0, shiftY || 0, brX, tlY);
    collisionVertexArray.emplaceBack(placed ? 1 : 0, notUsed ? 1 : 0, shiftX || 0, shiftY || 0, brX, brY);
    collisionVertexArray.emplaceBack(placed ? 1 : 0, notUsed ? 1 : 0, shiftX || 0, shiftY || 0, tlX, brY);
}
// All four vertices for a glyph will have the same opacity state
// So we pack the opacity into a uint8, and then repeat it four times
// to make a single uint32 that we can upload for each glyph in the
// label.
const shift25 = Math.pow(2, 25);
const shift24 = Math.pow(2, 24);
const shift17 = Math.pow(2, 17);
const shift16 = Math.pow(2, 16);
const shift9 = Math.pow(2, 9);
const shift8 = Math.pow(2, 8);
const shift1 = Math.pow(2, 1);
function packOpacity(opacityState) {
    if (opacityState.opacity === 0 && !opacityState.placed) {
        return 0;
    }
    else if (opacityState.opacity === 1 && opacityState.placed) {
        return 4294967295;
    }
    const targetBit = opacityState.placed ? 1 : 0;
    const opacityBits = Math.floor(opacityState.opacity * 127);
    return opacityBits * shift25 + targetBit * shift24 +
        opacityBits * shift17 + targetBit * shift16 +
        opacityBits * shift9 + targetBit * shift8 +
        opacityBits * shift1 + targetBit;
}
const PACKED_HIDDEN_OPACITY = 0;

function createProjection() {
    return {
        isOccluded(_x, _y, _t) {
            return false;
        },
        getPitchedTextCorrection(_transform, _anchor, _tile) {
            return 1.0;
        },
        get useSpecialProjectionForSymbols() { return false; },
        projectTileCoordinates(_x, _y, _t, _ele) {
            // This function should only be used when useSpecialProjectionForSymbols is set to true.
            throw new Error('Not implemented.');
        },
        translatePosition(transform, tile, translate, translateAnchor) {
            return translatePosition(transform, tile, translate, translateAnchor);
        },
        getCircleRadiusCorrection(_) {
            return 1.0;
        }
    };
}
/**
 * Returns a translation in tile units that correctly incorporates the view angle and the *-translate and *-translate-anchor properties.
 * @param inViewportPixelUnitsUnits - True when the units accepted by the matrix are in viewport pixels instead of tile units.
 *
 * Temporarily imported from globe branch.
 */
function translatePosition(transform, tile, translate, translateAnchor, inViewportPixelUnitsUnits = false) {
    if (!translate[0] && !translate[1])
        return [0, 0];
    const angle = inViewportPixelUnitsUnits ?
        (translateAnchor === 'map' ? transform.angle : 0) :
        (translateAnchor === 'viewport' ? -transform.angle : 0);
    if (angle) {
        const sinA = Math.sin(angle);
        const cosA = Math.cos(angle);
        translate = [
            translate[0] * cosA - translate[1] * sinA,
            translate[0] * sinA + translate[1] * cosA
        ];
    }
    return [
        inViewportPixelUnitsUnits ? translate[0] : pixelsToTileUnits(tile, translate[0], transform.zoom),
        inViewportPixelUnitsUnits ? translate[1] : pixelsToTileUnits(tile, translate[1], transform.zoom)
    ];
}

class LayerPlacement {
    constructor(styleLayer) {
        this._sortAcrossTiles = styleLayer.layout.get('symbol-z-order') !== 'viewport-y' &&
            !styleLayer.layout.get('symbol-sort-key').isConstant();
        this._currentTileIndex = 0;
        this._currentPartIndex = 0;
        this._seenCrossTileIDs = {};
        this._bucketParts = [];
    }
    continuePlacement(tiles, placement, showCollisionBoxes, styleLayer, shouldPausePlacement) {
        const bucketParts = this._bucketParts;
        while (this._currentTileIndex < tiles.length) {
            const tile = tiles[this._currentTileIndex];
            placement.getBucketParts(bucketParts, styleLayer, tile, this._sortAcrossTiles);
            this._currentTileIndex++;
            if (shouldPausePlacement()) {
                return true;
            }
        }
        if (this._sortAcrossTiles) {
            this._sortAcrossTiles = false;
            bucketParts.sort((a, b) => a.sortKey - b.sortKey);
        }
        while (this._currentPartIndex < bucketParts.length) {
            const bucketPart = bucketParts[this._currentPartIndex];
            placement.placeLayerBucketPart(bucketPart, this._seenCrossTileIDs, showCollisionBoxes);
            this._currentPartIndex++;
            if (shouldPausePlacement()) {
                return true;
            }
        }
        return false;
    }
}
class PauseablePlacement {
    constructor(transform, terrain, order, forceFullPlacement, showCollisionBoxes, fadeDuration, crossSourceCollisions, prevPlacement) {
        this.placement = new Placement(transform, createProjection(), terrain, fadeDuration, crossSourceCollisions, prevPlacement);
        this._currentPlacementIndex = order.length - 1;
        this._forceFullPlacement = forceFullPlacement;
        this._showCollisionBoxes = showCollisionBoxes;
        this._done = false;
    }
    isDone() {
        return this._done;
    }
    continuePlacement(order, layers, layerTiles) {
        const startTime = browser.now();
        const shouldPausePlacement = () => {
            return this._forceFullPlacement ? false : (browser.now() - startTime) > 2;
        };
        while (this._currentPlacementIndex >= 0) {
            const layerId = order[this._currentPlacementIndex];
            const layer = layers[layerId];
            const placementZoom = this.placement.collisionIndex.transform.zoom;
            if (layer.type === 'symbol' &&
                (!layer.minzoom || layer.minzoom <= placementZoom) &&
                (!layer.maxzoom || layer.maxzoom > placementZoom)) {
                if (!this._inProgressLayer) {
                    this._inProgressLayer = new LayerPlacement(layer);
                }
                const pausePlacement = this._inProgressLayer.continuePlacement(layerTiles[layer.source], this.placement, this._showCollisionBoxes, layer, shouldPausePlacement);
                if (pausePlacement) {
                    // We didn't finish placing all layers within 2ms,
                    // but we can keep rendering with a partial placement
                    // We'll resume here on the next frame
                    return;
                }
                delete this._inProgressLayer;
            }
            this._currentPlacementIndex--;
        }
        this._done = true;
    }
    commit(now) {
        this.placement.commit(now);
        return this.placement;
    }
}

/*
    The CrossTileSymbolIndex generally works on the assumption that
    a conceptual "unique symbol" can be identified by the text of
    the label combined with the anchor point. The goal is to assign
    these conceptual "unique symbols" a shared crossTileID that can be
    used by Placement to keep fading opacity states consistent and to
    deduplicate labels.

    The CrossTileSymbolIndex indexes all the current symbol instances and
    their crossTileIDs. When a symbol bucket gets added or updated, the
    index assigns a crossTileID to each of it's symbol instances by either
    matching it with an existing id or assigning a new one.
*/
// Round anchor positions to roughly 4 pixel grid
const roundingFactor = 512 / performance$1.X / 2;
const KDBUSH_THRESHHOLD = 128;
class TileLayerIndex {
    constructor(tileID, symbolInstances, bucketInstanceId) {
        this.tileID = tileID;
        this.bucketInstanceId = bucketInstanceId;
        this._symbolsByKey = {};
        // group the symbolInstances by key
        const symbolInstancesByKey = new Map();
        for (let i = 0; i < symbolInstances.length; i++) {
            const symbolInstance = symbolInstances.get(i);
            const key = symbolInstance.key;
            const instances = symbolInstancesByKey.get(key);
            if (instances) {
                // This tile may have multiple symbol instances with the same key
                // Store each one along with its coordinates
                instances.push(symbolInstance);
            }
            else {
                symbolInstancesByKey.set(key, [symbolInstance]);
            }
        }
        // index the SymbolInstances in this each bucket
        for (const [key, symbols] of symbolInstancesByKey) {
            const positions = symbols.map(symbolInstance => ({ x: Math.floor(symbolInstance.anchorX * roundingFactor), y: Math.floor(symbolInstance.anchorY * roundingFactor) }));
            const crossTileIDs = symbols.map(v => v.crossTileID);
            const entry = { positions, crossTileIDs };
            // once we get too many symbols for a given key, it becomes much faster to index it before queries
            if (entry.positions.length > KDBUSH_THRESHHOLD) {
                const index = new performance$1.aw(entry.positions.length, 16, Uint16Array);
                for (const { x, y } of entry.positions)
                    index.add(x, y);
                index.finish();
                // clear all references to the original positions data
                delete entry.positions;
                entry.index = index;
            }
            this._symbolsByKey[key] = entry;
        }
    }
    // Converts the coordinates of the input symbol instance into coordinates that be can compared
    // against other symbols in this index. Coordinates are:
    // (1) local-tile-based (so after correction we get x,y values relative to our local anchorX/Y)
    // (2) converted to the z-scale of this TileLayerIndex
    // (3) down-sampled by "roundingFactor" from tile coordinate precision in order to be
    //     more tolerant of small differences between tiles.
    getScaledCoordinates(symbolInstance, childTileID) {
        const { x: localX, y: localY, z: localZ } = this.tileID.canonical;
        const { x, y, z } = childTileID.canonical;
        const zDifference = z - localZ;
        const scale = roundingFactor / Math.pow(2, zDifference);
        const xWorld = (x * performance$1.X + symbolInstance.anchorX) * scale;
        const yWorld = (y * performance$1.X + symbolInstance.anchorY) * scale;
        const xOffset = localX * performance$1.X * roundingFactor;
        const yOffset = localY * performance$1.X * roundingFactor;
        const result = {
            x: Math.floor(xWorld - xOffset),
            y: Math.floor(yWorld - yOffset)
        };
        return result;
    }
    findMatches(symbolInstances, newTileID, zoomCrossTileIDs) {
        const tolerance = this.tileID.canonical.z < newTileID.canonical.z ? 1 : Math.pow(2, this.tileID.canonical.z - newTileID.canonical.z);
        for (let i = 0; i < symbolInstances.length; i++) {
            const symbolInstance = symbolInstances.get(i);
            if (symbolInstance.crossTileID) {
                // already has a match, skip
                continue;
            }
            const entry = this._symbolsByKey[symbolInstance.key];
            if (!entry) {
                // No symbol with this key in this bucket
                continue;
            }
            const scaledSymbolCoord = this.getScaledCoordinates(symbolInstance, newTileID);
            if (entry.index) {
                // Return any symbol with the same keys whose coordinates are within 1
                // grid unit. (with a 4px grid, this covers a 12px by 12px area)
                const indexes = entry.index.range(scaledSymbolCoord.x - tolerance, scaledSymbolCoord.y - tolerance, scaledSymbolCoord.x + tolerance, scaledSymbolCoord.y + tolerance).sort();
                for (const i of indexes) {
                    const crossTileID = entry.crossTileIDs[i];
                    if (!zoomCrossTileIDs[crossTileID]) {
                        // Once we've marked ourselves duplicate against this parent symbol,
                        // don't let any other symbols at the same zoom level duplicate against
                        // the same parent (see issue #5993)
                        zoomCrossTileIDs[crossTileID] = true;
                        symbolInstance.crossTileID = crossTileID;
                        break;
                    }
                }
            }
            else if (entry.positions) {
                for (let i = 0; i < entry.positions.length; i++) {
                    const thisTileSymbol = entry.positions[i];
                    const crossTileID = entry.crossTileIDs[i];
                    // Return any symbol with the same keys whose coordinates are within 1
                    // grid unit. (with a 4px grid, this covers a 12px by 12px area)
                    if (Math.abs(thisTileSymbol.x - scaledSymbolCoord.x) <= tolerance &&
                        Math.abs(thisTileSymbol.y - scaledSymbolCoord.y) <= tolerance &&
                        !zoomCrossTileIDs[crossTileID]) {
                        // Once we've marked ourselves duplicate against this parent symbol,
                        // don't let any other symbols at the same zoom level duplicate against
                        // the same parent (see issue #5993)
                        zoomCrossTileIDs[crossTileID] = true;
                        symbolInstance.crossTileID = crossTileID;
                        break;
                    }
                }
            }
        }
    }
    getCrossTileIDsLists() {
        return Object.values(this._symbolsByKey).map(({ crossTileIDs }) => crossTileIDs);
    }
}
class CrossTileIDs {
    constructor() {
        this.maxCrossTileID = 0;
    }
    generate() {
        return ++this.maxCrossTileID;
    }
}
class CrossTileSymbolLayerIndex {
    constructor() {
        this.indexes = {};
        this.usedCrossTileIDs = {};
        this.lng = 0;
    }
    /*
     * Sometimes when a user pans across the antimeridian the longitude value gets wrapped.
     * To prevent labels from flashing out and in we adjust the tileID values in the indexes
     * so that they match the new wrapped version of the map.
     */
    handleWrapJump(lng) {
        const wrapDelta = Math.round((lng - this.lng) / 360);
        if (wrapDelta !== 0) {
            for (const zoom in this.indexes) {
                const zoomIndexes = this.indexes[zoom];
                const newZoomIndex = {};
                for (const key in zoomIndexes) {
                    // change the tileID's wrap and add it to a new index
                    const index = zoomIndexes[key];
                    index.tileID = index.tileID.unwrapTo(index.tileID.wrap + wrapDelta);
                    newZoomIndex[index.tileID.key] = index;
                }
                this.indexes[zoom] = newZoomIndex;
            }
        }
        this.lng = lng;
    }
    addBucket(tileID, bucket, crossTileIDs) {
        if (this.indexes[tileID.overscaledZ] &&
            this.indexes[tileID.overscaledZ][tileID.key]) {
            if (this.indexes[tileID.overscaledZ][tileID.key].bucketInstanceId ===
                bucket.bucketInstanceId) {
                return false;
            }
            else {
                // We're replacing this bucket with an updated version
                // Remove the old bucket's "used crossTileIDs" now so that
                // the new bucket can claim them.
                // The old index entries themselves stick around until
                // 'removeStaleBuckets' is called.
                this.removeBucketCrossTileIDs(tileID.overscaledZ, this.indexes[tileID.overscaledZ][tileID.key]);
            }
        }
        for (let i = 0; i < bucket.symbolInstances.length; i++) {
            const symbolInstance = bucket.symbolInstances.get(i);
            symbolInstance.crossTileID = 0;
        }
        if (!this.usedCrossTileIDs[tileID.overscaledZ]) {
            this.usedCrossTileIDs[tileID.overscaledZ] = {};
        }
        const zoomCrossTileIDs = this.usedCrossTileIDs[tileID.overscaledZ];
        for (const zoom in this.indexes) {
            const zoomIndexes = this.indexes[zoom];
            if (Number(zoom) > tileID.overscaledZ) {
                for (const id in zoomIndexes) {
                    const childIndex = zoomIndexes[id];
                    if (childIndex.tileID.isChildOf(tileID)) {
                        childIndex.findMatches(bucket.symbolInstances, tileID, zoomCrossTileIDs);
                    }
                }
            }
            else {
                const parentCoord = tileID.scaledTo(Number(zoom));
                const parentIndex = zoomIndexes[parentCoord.key];
                if (parentIndex) {
                    parentIndex.findMatches(bucket.symbolInstances, tileID, zoomCrossTileIDs);
                }
            }
        }
        for (let i = 0; i < bucket.symbolInstances.length; i++) {
            const symbolInstance = bucket.symbolInstances.get(i);
            if (!symbolInstance.crossTileID) {
                // symbol did not match any known symbol, assign a new id
                symbolInstance.crossTileID = crossTileIDs.generate();
                zoomCrossTileIDs[symbolInstance.crossTileID] = true;
            }
        }
        if (this.indexes[tileID.overscaledZ] === undefined) {
            this.indexes[tileID.overscaledZ] = {};
        }
        this.indexes[tileID.overscaledZ][tileID.key] = new TileLayerIndex(tileID, bucket.symbolInstances, bucket.bucketInstanceId);
        return true;
    }
    removeBucketCrossTileIDs(zoom, removedBucket) {
        for (const crossTileIDs of removedBucket.getCrossTileIDsLists()) {
            for (const crossTileID of crossTileIDs) {
                delete this.usedCrossTileIDs[zoom][crossTileID];
            }
        }
    }
    removeStaleBuckets(currentIDs) {
        let tilesChanged = false;
        for (const z in this.indexes) {
            const zoomIndexes = this.indexes[z];
            for (const tileKey in zoomIndexes) {
                if (!currentIDs[zoomIndexes[tileKey].bucketInstanceId]) {
                    this.removeBucketCrossTileIDs(z, zoomIndexes[tileKey]);
                    delete zoomIndexes[tileKey];
                    tilesChanged = true;
                }
            }
        }
        return tilesChanged;
    }
}
class CrossTileSymbolIndex {
    constructor() {
        this.layerIndexes = {};
        this.crossTileIDs = new CrossTileIDs();
        this.maxBucketInstanceId = 0;
        this.bucketsInCurrentPlacement = {};
    }
    addLayer(styleLayer, tiles, lng) {
        let layerIndex = this.layerIndexes[styleLayer.id];
        if (layerIndex === undefined) {
            layerIndex = this.layerIndexes[styleLayer.id] = new CrossTileSymbolLayerIndex();
        }
        let symbolBucketsChanged = false;
        const currentBucketIDs = {};
        layerIndex.handleWrapJump(lng);
        for (const tile of tiles) {
            const symbolBucket = tile.getBucket(styleLayer);
            if (!symbolBucket || styleLayer.id !== symbolBucket.layerIds[0])
                continue;
            if (!symbolBucket.bucketInstanceId) {
                symbolBucket.bucketInstanceId = ++this.maxBucketInstanceId;
            }
            if (layerIndex.addBucket(tile.tileID, symbolBucket, this.crossTileIDs)) {
                symbolBucketsChanged = true;
            }
            currentBucketIDs[symbolBucket.bucketInstanceId] = true;
        }
        if (layerIndex.removeStaleBuckets(currentBucketIDs)) {
            symbolBucketsChanged = true;
        }
        return symbolBucketsChanged;
    }
    pruneUnusedLayers(usedLayers) {
        const usedLayerMap = {};
        usedLayers.forEach((usedLayer) => {
            usedLayerMap[usedLayer] = true;
        });
        for (const layerId in this.layerIndexes) {
            if (!usedLayerMap[layerId]) {
                delete this.layerIndexes[layerId];
            }
        }
    }
}

// We're skipping validation errors with the `source.canvas` identifier in order
// to continue to allow canvas sources to be added at runtime/updated in
// smart setStyle (see https://github.com/mapbox/mapbox-gl-js/pull/6424):
const emitValidationErrors = (evented, errors) => performance$1.t(evented, errors && errors.filter(error => error.identifier !== 'source.canvas'));
const empty = performance$1.ax();
/**
 * The Style base class
 */
class Style extends performance$1.E {
    constructor(map, options = {}) {
        super();
        this._rtlPluginLoaded = () => {
            for (const id in this.sourceCaches) {
                const sourceType = this.sourceCaches[id].getSource().type;
                if (sourceType === 'vector' || sourceType === 'geojson') {
                    // Non-vector sources don't have any symbols buckets to reload when the RTL text plugin loads
                    // They also load more quickly, so they're more likely to have already displaying tiles
                    // that would be unnecessarily booted by the plugin load event
                    this.sourceCaches[id].reload(); // Should be a no-op if the plugin loads before any tiles load
                }
            }
        };
        this.map = map;
        this.dispatcher = new Dispatcher(getGlobalWorkerPool(), map._getMapId());
        this.dispatcher.registerMessageHandler("GG" /* MessageType.getGlyphs */, (mapId, params) => {
            return this.getGlyphs(mapId, params);
        });
        this.dispatcher.registerMessageHandler("GI" /* MessageType.getImages */, (mapId, params) => {
            return this.getImages(mapId, params);
        });
        this.imageManager = new ImageManager();
        this.imageManager.setEventedParent(this);
        this.glyphManager = new GlyphManager(map._requestManager, options.localIdeographFontFamily);
        this.lineAtlas = new LineAtlas(256, 512);
        this.crossTileSymbolIndex = new CrossTileSymbolIndex();
        this._spritesImagesIds = {};
        this._layers = {};
        this._order = [];
        this.sourceCaches = {};
        this.zoomHistory = new performance$1.ay();
        this._loaded = false;
        this._availableImages = [];
        this._resetUpdates();
        this.dispatcher.broadcast("SR" /* MessageType.setReferrer */, performance$1.az());
        rtlMainThreadPluginFactory().on(RTLPluginLoadedEventName, this._rtlPluginLoaded);
        this.on('data', (event) => {
            if (event.dataType !== 'source' || event.sourceDataType !== 'metadata') {
                return;
            }
            const sourceCache = this.sourceCaches[event.sourceId];
            if (!sourceCache) {
                return;
            }
            const source = sourceCache.getSource();
            if (!source || !source.vectorLayerIds) {
                return;
            }
            for (const layerId in this._layers) {
                const layer = this._layers[layerId];
                if (layer.source === source.id) {
                    this._validateLayer(layer);
                }
            }
        });
    }
    loadURL(url, options = {}, previousStyle) {
        this.fire(new performance$1.k('dataloading', { dataType: 'style' }));
        options.validate = typeof options.validate === 'boolean' ?
            options.validate : true;
        const request = this.map._requestManager.transformRequest(url, "Style" /* ResourceType.Style */);
        this._loadStyleRequest = new AbortController();
        const abortController = this._loadStyleRequest;
        performance$1.h(request, this._loadStyleRequest).then((response) => {
            this._loadStyleRequest = null;
            this._load(response.data, options, previousStyle);
        }).catch((error) => {
            this._loadStyleRequest = null;
            if (error && !abortController.signal.aborted) { // ignore abort
                this.fire(new performance$1.j(error));
            }
        });
    }
    loadJSON(json, options = {}, previousStyle) {
        this.fire(new performance$1.k('dataloading', { dataType: 'style' }));
        this._frameRequest = new AbortController();
        browser.frameAsync(this._frameRequest).then(() => {
            this._frameRequest = null;
            options.validate = options.validate !== false;
            this._load(json, options, previousStyle);
        }).catch(() => { }); // ignore abort
    }
    loadEmpty() {
        this.fire(new performance$1.k('dataloading', { dataType: 'style' }));
        this._load(empty, { validate: false });
    }
    _load(json, options, previousStyle) {
        var _a;
        const nextState = options.transformStyle ? options.transformStyle(previousStyle, json) : json;
        if (options.validate && emitValidationErrors(this, performance$1.x(nextState))) {
            return;
        }
        this._loaded = true;
        this.stylesheet = nextState;
        for (const id in nextState.sources) {
            this.addSource(id, nextState.sources[id], { validate: false });
        }
        if (nextState.sprite) {
            this._loadSprite(nextState.sprite);
        }
        else {
            this.imageManager.setLoaded(true);
        }
        this.glyphManager.setURL(nextState.glyphs);
        this._createLayers();
        this.light = new Light(this.stylesheet.light);
        this.sky = new Sky(this.stylesheet.sky);
        this.map.setTerrain((_a = this.stylesheet.terrain) !== null && _a !== void 0 ? _a : null);
        this.fire(new performance$1.k('data', { dataType: 'style' }));
        this.fire(new performance$1.k('style.load'));
    }
    _createLayers() {
        const dereferencedLayers = performance$1.aA(this.stylesheet.layers);
        // Broadcast layers to workers first, so that expensive style processing (createStyleLayer)
        // can happen in parallel on both main and worker threads.
        this.dispatcher.broadcast("SL" /* MessageType.setLayers */, dereferencedLayers);
        this._order = dereferencedLayers.map((layer) => layer.id);
        this._layers = {};
        // reset serialization field, to be populated only when needed
        this._serializedLayers = null;
        for (const layer of dereferencedLayers) {
            const styledLayer = performance$1.aB(layer);
            styledLayer.setEventedParent(this, { layer: { id: layer.id } });
            this._layers[layer.id] = styledLayer;
        }
    }
    _loadSprite(sprite, isUpdate = false, completion = undefined) {
        this.imageManager.setLoaded(false);
        this._spriteRequest = new AbortController();
        let err;
        loadSprite(sprite, this.map._requestManager, this.map.getPixelRatio(), this._spriteRequest).then((images) => {
            this._spriteRequest = null;
            if (images) {
                for (const spriteId in images) {
                    this._spritesImagesIds[spriteId] = [];
                    // remove old sprite's loaded images (for the same sprite id) that are not in new sprite
                    const imagesToRemove = this._spritesImagesIds[spriteId] ? this._spritesImagesIds[spriteId].filter(id => !(id in images)) : [];
                    for (const id of imagesToRemove) {
                        this.imageManager.removeImage(id);
                        this._changedImages[id] = true;
                    }
                    for (const id in images[spriteId]) {
                        // don't prefix images of the "default" sprite
                        const imageId = spriteId === 'default' ? id : `${spriteId}:${id}`;
                        // save all the sprite's images' ids to be able to delete them in `removeSprite`
                        this._spritesImagesIds[spriteId].push(imageId);
                        if (imageId in this.imageManager.images) {
                            this.imageManager.updateImage(imageId, images[spriteId][id], false);
                        }
                        else {
                            this.imageManager.addImage(imageId, images[spriteId][id]);
                        }
                        if (isUpdate) {
                            this._changedImages[imageId] = true;
                        }
                    }
                }
            }
        }).catch((error) => {
            this._spriteRequest = null;
            err = error;
            this.fire(new performance$1.j(err));
        }).finally(() => {
            this.imageManager.setLoaded(true);
            this._availableImages = this.imageManager.listImages();
            if (isUpdate) {
                this._changed = true;
            }
            this.dispatcher.broadcast("SI" /* MessageType.setImages */, this._availableImages);
            this.fire(new performance$1.k('data', { dataType: 'style' }));
            if (completion) {
                completion(err);
            }
        });
    }
    _unloadSprite() {
        for (const id of Object.values(this._spritesImagesIds).flat()) {
            this.imageManager.removeImage(id);
            this._changedImages[id] = true;
        }
        this._spritesImagesIds = {};
        this._availableImages = this.imageManager.listImages();
        this._changed = true;
        this.dispatcher.broadcast("SI" /* MessageType.setImages */, this._availableImages);
        this.fire(new performance$1.k('data', { dataType: 'style' }));
    }
    _validateLayer(layer) {
        const sourceCache = this.sourceCaches[layer.source];
        if (!sourceCache) {
            return;
        }
        const sourceLayer = layer.sourceLayer;
        if (!sourceLayer) {
            return;
        }
        const source = sourceCache.getSource();
        if (source.type === 'geojson' || (source.vectorLayerIds && source.vectorLayerIds.indexOf(sourceLayer) === -1)) {
            this.fire(new performance$1.j(new Error(`Source layer "${sourceLayer}" ` +
                `does not exist on source "${source.id}" ` +
                `as specified by style layer "${layer.id}".`)));
        }
    }
    loaded() {
        if (!this._loaded)
            return false;
        if (Object.keys(this._updatedSources).length)
            return false;
        for (const id in this.sourceCaches)
            if (!this.sourceCaches[id].loaded())
                return false;
        if (!this.imageManager.isLoaded())
            return false;
        return true;
    }
    /**
     * @hidden
     * take an array of string IDs, and based on this._layers, generate an array of LayerSpecification
     * @param ids - an array of string IDs, for which serialized layers will be generated. If omitted, all serialized layers will be returned
     * @returns generated result
     */
    _serializeByIds(ids) {
        const serializedLayersDictionary = this._serializedAllLayers();
        if (!ids || ids.length === 0) {
            return Object.values(serializedLayersDictionary);
        }
        const serializedLayers = [];
        for (const id of ids) {
            // this check will skip all custom layers
            if (serializedLayersDictionary[id]) {
                serializedLayers.push(serializedLayersDictionary[id]);
            }
        }
        return serializedLayers;
    }
    /**
     * @hidden
     * Lazy initialization of this._serializedLayers dictionary and return it
     * @returns this._serializedLayers dictionary
     */
    _serializedAllLayers() {
        let serializedLayers = this._serializedLayers;
        if (serializedLayers) {
            return serializedLayers;
        }
        serializedLayers = this._serializedLayers = {};
        const allLayerIds = Object.keys(this._layers);
        for (const layerId of allLayerIds) {
            const layer = this._layers[layerId];
            if (layer.type !== 'custom') {
                serializedLayers[layerId] = layer.serialize();
            }
        }
        return serializedLayers;
    }
    hasTransitions() {
        if (this.light && this.light.hasTransition()) {
            return true;
        }
        if (this.sky && this.sky.hasTransition()) {
            return true;
        }
        for (const id in this.sourceCaches) {
            if (this.sourceCaches[id].hasTransition()) {
                return true;
            }
        }
        for (const id in this._layers) {
            if (this._layers[id].hasTransition()) {
                return true;
            }
        }
        return false;
    }
    _checkLoaded() {
        if (!this._loaded) {
            throw new Error('Style is not done loading.');
        }
    }
    /**
     * @internal
     * Apply queued style updates in a batch and recalculate zoom-dependent paint properties.
     */
    update(parameters) {
        if (!this._loaded) {
            return;
        }
        const changed = this._changed;
        if (changed) {
            const updatedIds = Object.keys(this._updatedLayers);
            const removedIds = Object.keys(this._removedLayers);
            if (updatedIds.length || removedIds.length) {
                this._updateWorkerLayers(updatedIds, removedIds);
            }
            for (const id in this._updatedSources) {
                const action = this._updatedSources[id];
                if (action === 'reload') {
                    this._reloadSource(id);
                }
                else if (action === 'clear') {
                    this._clearSource(id);
                }
                else {
                    throw new Error(`Invalid action ${action}`);
                }
            }
            this._updateTilesForChangedImages();
            this._updateTilesForChangedGlyphs();
            for (const id in this._updatedPaintProps) {
                this._layers[id].updateTransitions(parameters);
            }
            this.light.updateTransitions(parameters);
            this.sky.updateTransitions(parameters);
            this._resetUpdates();
        }
        const sourcesUsedBefore = {};
        // save 'used' status to sourcesUsedBefore object and reset all sourceCaches 'used' field to false
        for (const sourceCacheId in this.sourceCaches) {
            const sourceCache = this.sourceCaches[sourceCacheId];
            // sourceCache.used could be undefined, and sourcesUsedBefore[sourceCacheId] is also 'undefined'
            sourcesUsedBefore[sourceCacheId] = sourceCache.used;
            sourceCache.used = false;
        }
        // loop all layers and find layers that are not hidden at parameters.zoom
        // and set used to true in sourceCaches dictionary for the sources of these layers
        for (const layerId of this._order) {
            const layer = this._layers[layerId];
            layer.recalculate(parameters, this._availableImages);
            if (!layer.isHidden(parameters.zoom) && layer.source) {
                this.sourceCaches[layer.source].used = true;
            }
        }
        // cross check sourcesUsedBefore against updated this.sourceCaches dictionary
        // if "used" field is different fire visibility event
        for (const sourcesUsedBeforeId in sourcesUsedBefore) {
            const sourceCache = this.sourceCaches[sourcesUsedBeforeId];
            // (undefine !== false) will evaluate to true and fire an useless visibility event
            // need force "falsy" values to boolean to avoid the case above
            if (!!sourcesUsedBefore[sourcesUsedBeforeId] !== !!sourceCache.used) {
                sourceCache.fire(new performance$1.k('data', {
                    sourceDataType: 'visibility',
                    dataType: 'source',
                    sourceId: sourcesUsedBeforeId
                }));
            }
        }
        this.light.recalculate(parameters);
        this.sky.recalculate(parameters);
        this.z = parameters.zoom;
        if (changed) {
            this.fire(new performance$1.k('data', { dataType: 'style' }));
        }
    }
    /*
     * Apply any queued image changes.
     */
    _updateTilesForChangedImages() {
        const changedImages = Object.keys(this._changedImages);
        if (changedImages.length) {
            for (const name in this.sourceCaches) {
                this.sourceCaches[name].reloadTilesForDependencies(['icons', 'patterns'], changedImages);
            }
            this._changedImages = {};
        }
    }
    _updateTilesForChangedGlyphs() {
        if (this._glyphsDidChange) {
            for (const name in this.sourceCaches) {
                this.sourceCaches[name].reloadTilesForDependencies(['glyphs'], ['']);
            }
            this._glyphsDidChange = false;
        }
    }
    _updateWorkerLayers(updatedIds, removedIds) {
        this.dispatcher.broadcast("UL" /* MessageType.updateLayers */, {
            layers: this._serializeByIds(updatedIds),
            removedIds
        });
    }
    _resetUpdates() {
        this._changed = false;
        this._updatedLayers = {};
        this._removedLayers = {};
        this._updatedSources = {};
        this._updatedPaintProps = {};
        this._changedImages = {};
        this._glyphsDidChange = false;
    }
    /**
     * Update this style's state to match the given style JSON, performing only
     * the necessary mutations.
     *
     * May throw an Error ('Unimplemented: METHOD') if the mapbox-gl-style-spec
     * diff algorithm produces an operation that is not supported.
     *
     * @returns true if any changes were made; false otherwise
     */
    setState(nextState, options = {}) {
        var _a;
        this._checkLoaded();
        const serializedStyle = this.serialize();
        nextState = options.transformStyle ? options.transformStyle(serializedStyle, nextState) : nextState;
        const validate = (_a = options.validate) !== null && _a !== void 0 ? _a : true;
        if (validate && emitValidationErrors(this, performance$1.x(nextState)))
            return false;
        nextState = performance$1.aC(nextState);
        nextState.layers = performance$1.aA(nextState.layers);
        const changes = performance$1.aD(serializedStyle, nextState);
        const operations = this._getOperationsToPerform(changes);
        if (operations.unimplemented.length > 0) {
            throw new Error(`Unimplemented: ${operations.unimplemented.join(', ')}.`);
        }
        if (operations.operations.length === 0) {
            return false;
        }
        for (const styleChangeOperation of operations.operations) {
            styleChangeOperation();
        }
        this.stylesheet = nextState;
        // reset serialization field, to be populated only when needed
        this._serializedLayers = null;
        return true;
    }
    _getOperationsToPerform(diff) {
        const operations = [];
        const unimplemented = [];
        for (const op of diff) {
            switch (op.command) {
                case 'setCenter':
                case 'setZoom':
                case 'setBearing':
                case 'setPitch':
                    continue;
                case 'addLayer':
                    operations.push(() => this.addLayer.apply(this, op.args));
                    break;
                case 'removeLayer':
                    operations.push(() => this.removeLayer.apply(this, op.args));
                    break;
                case 'setPaintProperty':
                    operations.push(() => this.setPaintProperty.apply(this, op.args));
                    break;
                case 'setLayoutProperty':
                    operations.push(() => this.setLayoutProperty.apply(this, op.args));
                    break;
                case 'setFilter':
                    operations.push(() => this.setFilter.apply(this, op.args));
                    break;
                case 'addSource':
                    operations.push(() => this.addSource.apply(this, op.args));
                    break;
                case 'removeSource':
                    operations.push(() => this.removeSource.apply(this, op.args));
                    break;
                case 'setLayerZoomRange':
                    operations.push(() => this.setLayerZoomRange.apply(this, op.args));
                    break;
                case 'setLight':
                    operations.push(() => this.setLight.apply(this, op.args));
                    break;
                case 'setGeoJSONSourceData':
                    operations.push(() => this.setGeoJSONSourceData.apply(this, op.args));
                    break;
                case 'setGlyphs':
                    operations.push(() => this.setGlyphs.apply(this, op.args));
                    break;
                case 'setSprite':
                    operations.push(() => this.setSprite.apply(this, op.args));
                    break;
                case 'setSky':
                    operations.push(() => this.setSky.apply(this, op.args));
                    break;
                case 'setTerrain':
                    operations.push(() => this.map.setTerrain.apply(this, op.args));
                    break;
                case 'setTransition':
                    operations.push(() => { });
                    break;
                default:
                    unimplemented.push(op.command);
                    break;
            }
        }
        return {
            operations,
            unimplemented
        };
    }
    addImage(id, image) {
        if (this.getImage(id)) {
            return this.fire(new performance$1.j(new Error(`An image named "${id}" already exists.`)));
        }
        this.imageManager.addImage(id, image);
        this._afterImageUpdated(id);
    }
    updateImage(id, image) {
        this.imageManager.updateImage(id, image);
    }
    getImage(id) {
        return this.imageManager.getImage(id);
    }
    removeImage(id) {
        if (!this.getImage(id)) {
            return this.fire(new performance$1.j(new Error(`An image named "${id}" does not exist.`)));
        }
        this.imageManager.removeImage(id);
        this._afterImageUpdated(id);
    }
    _afterImageUpdated(id) {
        this._availableImages = this.imageManager.listImages();
        this._changedImages[id] = true;
        this._changed = true;
        this.dispatcher.broadcast("SI" /* MessageType.setImages */, this._availableImages);
        this.fire(new performance$1.k('data', { dataType: 'style' }));
    }
    listImages() {
        this._checkLoaded();
        return this.imageManager.listImages();
    }
    addSource(id, source, options = {}) {
        this._checkLoaded();
        if (this.sourceCaches[id] !== undefined) {
            throw new Error(`Source "${id}" already exists.`);
        }
        if (!source.type) {
            throw new Error(`The type property must be defined, but only the following properties were given: ${Object.keys(source).join(', ')}.`);
        }
        const builtIns = ['vector', 'raster', 'geojson', 'video', 'image'];
        const shouldValidate = builtIns.indexOf(source.type) >= 0;
        if (shouldValidate && this._validate(performance$1.x.source, `sources.${id}`, source, null, options))
            return;
        if (this.map && this.map._collectResourceTiming)
            source.collectResourceTiming = true;
        const sourceCache = this.sourceCaches[id] = new SourceCache(id, source, this.dispatcher);
        sourceCache.style = this;
        sourceCache.setEventedParent(this, () => ({
            isSourceLoaded: sourceCache.loaded(),
            source: sourceCache.serialize(),
            sourceId: id
        }));
        sourceCache.onAdd(this.map);
        this._changed = true;
    }
    /**
     * Remove a source from this stylesheet, given its id.
     * @param id - id of the source to remove
     * @throws if no source is found with the given ID
     */
    removeSource(id) {
        this._checkLoaded();
        if (this.sourceCaches[id] === undefined) {
            throw new Error('There is no source with this ID');
        }
        for (const layerId in this._layers) {
            if (this._layers[layerId].source === id) {
                return this.fire(new performance$1.j(new Error(`Source "${id}" cannot be removed while layer "${layerId}" is using it.`)));
            }
        }
        const sourceCache = this.sourceCaches[id];
        delete this.sourceCaches[id];
        delete this._updatedSources[id];
        sourceCache.fire(new performance$1.k('data', { sourceDataType: 'metadata', dataType: 'source', sourceId: id }));
        sourceCache.setEventedParent(null);
        sourceCache.onRemove(this.map);
        this._changed = true;
    }
    /**
     * Set the data of a GeoJSON source, given its id.
     * @param id - id of the source
     * @param data - GeoJSON source
     */
    setGeoJSONSourceData(id, data) {
        this._checkLoaded();
        if (this.sourceCaches[id] === undefined)
            throw new Error(`There is no source with this ID=${id}`);
        const geojsonSource = this.sourceCaches[id].getSource();
        if (geojsonSource.type !== 'geojson')
            throw new Error(`geojsonSource.type is ${geojsonSource.type}, which is !== 'geojson`);
        geojsonSource.setData(data);
        this._changed = true;
    }
    /**
     * Get a source by ID.
     * @param id - ID of the desired source
     * @returns source
     */
    getSource(id) {
        return this.sourceCaches[id] && this.sourceCaches[id].getSource();
    }
    /**
     * Add a layer to the map style. The layer will be inserted before the layer with
     * ID `before`, or appended if `before` is omitted.
     * @param layerObject - The style layer to add.
     * @param before - ID of an existing layer to insert before
     * @param options - Style setter options.
     */
    addLayer(layerObject, before, options = {}) {
        this._checkLoaded();
        const id = layerObject.id;
        if (this.getLayer(id)) {
            this.fire(new performance$1.j(new Error(`Layer "${id}" already exists on this map.`)));
            return;
        }
        let layer;
        if (layerObject.type === 'custom') {
            if (emitValidationErrors(this, performance$1.aE(layerObject)))
                return;
            layer = performance$1.aB(layerObject);
        }
        else {
            if ('source' in layerObject && typeof layerObject.source === 'object') {
                this.addSource(id, layerObject.source);
                layerObject = performance$1.aC(layerObject);
                layerObject = performance$1.e(layerObject, { source: id });
            }
            // this layer is not in the style.layers array, so we pass an impossible array index
            if (this._validate(performance$1.x.layer, `layers.${id}`, layerObject, { arrayIndex: -1 }, options))
                return;
            layer = performance$1.aB(layerObject);
            this._validateLayer(layer);
            layer.setEventedParent(this, { layer: { id } });
        }
        const index = before ? this._order.indexOf(before) : this._order.length;
        if (before && index === -1) {
            this.fire(new performance$1.j(new Error(`Cannot add layer "${id}" before non-existing layer "${before}".`)));
            return;
        }
        this._order.splice(index, 0, id);
        this._layerOrderChanged = true;
        this._layers[id] = layer;
        if (this._removedLayers[id] && layer.source && layer.type !== 'custom') {
            // If, in the current batch, we have already removed this layer
            // and we are now re-adding it with a different `type`, then we
            // need to clear (rather than just reload) the underlying source's
            // tiles.  Otherwise, tiles marked 'reloading' will have buckets /
            // buffers that are set up for the _previous_ version of this
            // layer, causing, e.g.:
            // https://github.com/mapbox/mapbox-gl-js/issues/3633
            const removed = this._removedLayers[id];
            delete this._removedLayers[id];
            if (removed.type !== layer.type) {
                this._updatedSources[layer.source] = 'clear';
            }
            else {
                this._updatedSources[layer.source] = 'reload';
                this.sourceCaches[layer.source].pause();
            }
        }
        this._updateLayer(layer);
        if (layer.onAdd) {
            layer.onAdd(this.map);
        }
    }
    /**
     * Moves a layer to a different z-position. The layer will be inserted before the layer with
     * ID `before`, or appended if `before` is omitted.
     * @param id - ID of the layer to move
     * @param before - ID of an existing layer to insert before
     */
    moveLayer(id, before) {
        this._checkLoaded();
        this._changed = true;
        const layer = this._layers[id];
        if (!layer) {
            this.fire(new performance$1.j(new Error(`The layer '${id}' does not exist in the map's style and cannot be moved.`)));
            return;
        }
        if (id === before) {
            return;
        }
        const index = this._order.indexOf(id);
        this._order.splice(index, 1);
        const newIndex = before ? this._order.indexOf(before) : this._order.length;
        if (before && newIndex === -1) {
            this.fire(new performance$1.j(new Error(`Cannot move layer "${id}" before non-existing layer "${before}".`)));
            return;
        }
        this._order.splice(newIndex, 0, id);
        this._layerOrderChanged = true;
    }
    /**
     * Remove the layer with the given id from the style.
     * A {@link ErrorEvent} event will be fired if no such layer exists.
     *
     * @param id - id of the layer to remove
     */
    removeLayer(id) {
        this._checkLoaded();
        const layer = this._layers[id];
        if (!layer) {
            this.fire(new performance$1.j(new Error(`Cannot remove non-existing layer "${id}".`)));
            return;
        }
        layer.setEventedParent(null);
        const index = this._order.indexOf(id);
        this._order.splice(index, 1);
        this._layerOrderChanged = true;
        this._changed = true;
        this._removedLayers[id] = layer;
        delete this._layers[id];
        if (this._serializedLayers) {
            delete this._serializedLayers[id];
        }
        delete this._updatedLayers[id];
        delete this._updatedPaintProps[id];
        if (layer.onRemove) {
            layer.onRemove(this.map);
        }
    }
    /**
     * Return the style layer object with the given `id`.
     *
     * @param id - id of the desired layer
     * @returns a layer, if one with the given `id` exists
     */
    getLayer(id) {
        return this._layers[id];
    }
    /**
     * Return the ids of all layers currently in the style, including custom layers, in order.
     *
     * @returns ids of layers, in order
     */
    getLayersOrder() {
        return [...this._order];
    }
    /**
     * Checks if a specific layer is present within the style.
     *
     * @param id - the id of the desired layer
     * @returns a boolean specifying if the given layer is present
     */
    hasLayer(id) {
        return id in this._layers;
    }
    setLayerZoomRange(layerId, minzoom, maxzoom) {
        this._checkLoaded();
        const layer = this.getLayer(layerId);
        if (!layer) {
            this.fire(new performance$1.j(new Error(`Cannot set the zoom range of non-existing layer "${layerId}".`)));
            return;
        }
        if (layer.minzoom === minzoom && layer.maxzoom === maxzoom)
            return;
        if (minzoom != null) {
            layer.minzoom = minzoom;
        }
        if (maxzoom != null) {
            layer.maxzoom = maxzoom;
        }
        this._updateLayer(layer);
    }
    setFilter(layerId, filter, options = {}) {
        this._checkLoaded();
        const layer = this.getLayer(layerId);
        if (!layer) {
            this.fire(new performance$1.j(new Error(`Cannot filter non-existing layer "${layerId}".`)));
            return;
        }
        if (performance$1.aF(layer.filter, filter)) {
            return;
        }
        if (filter === null || filter === undefined) {
            layer.filter = undefined;
            this._updateLayer(layer);
            return;
        }
        if (this._validate(performance$1.x.filter, `layers.${layer.id}.filter`, filter, null, options)) {
            return;
        }
        layer.filter = performance$1.aC(filter);
        this._updateLayer(layer);
    }
    /**
     * Get a layer's filter object
     * @param layer - the layer to inspect
     * @returns the layer's filter, if any
     */
    getFilter(layer) {
        return performance$1.aC(this.getLayer(layer).filter);
    }
    setLayoutProperty(layerId, name, value, options = {}) {
        this._checkLoaded();
        const layer = this.getLayer(layerId);
        if (!layer) {
            this.fire(new performance$1.j(new Error(`Cannot style non-existing layer "${layerId}".`)));
            return;
        }
        if (performance$1.aF(layer.getLayoutProperty(name), value))
            return;
        layer.setLayoutProperty(name, value, options);
        this._updateLayer(layer);
    }
    /**
     * Get a layout property's value from a given layer
     * @param layerId - the layer to inspect
     * @param name - the name of the layout property
     * @returns the property value
     */
    getLayoutProperty(layerId, name) {
        const layer = this.getLayer(layerId);
        if (!layer) {
            this.fire(new performance$1.j(new Error(`Cannot get style of non-existing layer "${layerId}".`)));
            return;
        }
        return layer.getLayoutProperty(name);
    }
    setPaintProperty(layerId, name, value, options = {}) {
        this._checkLoaded();
        const layer = this.getLayer(layerId);
        if (!layer) {
            this.fire(new performance$1.j(new Error(`Cannot style non-existing layer "${layerId}".`)));
            return;
        }
        if (performance$1.aF(layer.getPaintProperty(name), value))
            return;
        const requiresRelayout = layer.setPaintProperty(name, value, options);
        if (requiresRelayout) {
            this._updateLayer(layer);
        }
        this._changed = true;
        this._updatedPaintProps[layerId] = true;
        // reset serialization field, to be populated only when needed
        this._serializedLayers = null;
    }
    getPaintProperty(layer, name) {
        return this.getLayer(layer).getPaintProperty(name);
    }
    setFeatureState(target, state) {
        this._checkLoaded();
        const sourceId = target.source;
        const sourceLayer = target.sourceLayer;
        const sourceCache = this.sourceCaches[sourceId];
        if (sourceCache === undefined) {
            this.fire(new performance$1.j(new Error(`The source '${sourceId}' does not exist in the map's style.`)));
            return;
        }
        const sourceType = sourceCache.getSource().type;
        if (sourceType === 'geojson' && sourceLayer) {
            this.fire(new performance$1.j(new Error('GeoJSON sources cannot have a sourceLayer parameter.')));
            return;
        }
        if (sourceType === 'vector' && !sourceLayer) {
            this.fire(new performance$1.j(new Error('The sourceLayer parameter must be provided for vector source types.')));
            return;
        }
        if (target.id === undefined) {
            this.fire(new performance$1.j(new Error('The feature id parameter must be provided.')));
        }
        sourceCache.setFeatureState(sourceLayer, target.id, state);
    }
    removeFeatureState(target, key) {
        this._checkLoaded();
        const sourceId = target.source;
        const sourceCache = this.sourceCaches[sourceId];
        if (sourceCache === undefined) {
            this.fire(new performance$1.j(new Error(`The source '${sourceId}' does not exist in the map's style.`)));
            return;
        }
        const sourceType = sourceCache.getSource().type;
        const sourceLayer = sourceType === 'vector' ? target.sourceLayer : undefined;
        if (sourceType === 'vector' && !sourceLayer) {
            this.fire(new performance$1.j(new Error('The sourceLayer parameter must be provided for vector source types.')));
            return;
        }
        if (key && (typeof target.id !== 'string' && typeof target.id !== 'number')) {
            this.fire(new performance$1.j(new Error('A feature id is required to remove its specific state property.')));
            return;
        }
        sourceCache.removeFeatureState(sourceLayer, target.id, key);
    }
    getFeatureState(target) {
        this._checkLoaded();
        const sourceId = target.source;
        const sourceLayer = target.sourceLayer;
        const sourceCache = this.sourceCaches[sourceId];
        if (sourceCache === undefined) {
            this.fire(new performance$1.j(new Error(`The source '${sourceId}' does not exist in the map's style.`)));
            return;
        }
        const sourceType = sourceCache.getSource().type;
        if (sourceType === 'vector' && !sourceLayer) {
            this.fire(new performance$1.j(new Error('The sourceLayer parameter must be provided for vector source types.')));
            return;
        }
        if (target.id === undefined) {
            this.fire(new performance$1.j(new Error('The feature id parameter must be provided.')));
        }
        return sourceCache.getFeatureState(sourceLayer, target.id);
    }
    getTransition() {
        return performance$1.e({ duration: 300, delay: 0 }, this.stylesheet && this.stylesheet.transition);
    }
    serialize() {
        // We return undefined before we're loaded, following the pattern of Map.getStyle() before
        // the Style object is initialized.
        // Internally, Style._validate() calls Style.serialize() but callers are responsible for
        // calling Style._checkLoaded() first if their validation requires the style to be loaded.
        if (!this._loaded)
            return;
        const sources = performance$1.aG(this.sourceCaches, (source) => source.serialize());
        const layers = this._serializeByIds(this._order);
        const terrain = this.map.getTerrain() || undefined;
        const myStyleSheet = this.stylesheet;
        return performance$1.aH({
            version: myStyleSheet.version,
            name: myStyleSheet.name,
            metadata: myStyleSheet.metadata,
            light: myStyleSheet.light,
            sky: myStyleSheet.sky,
            center: myStyleSheet.center,
            zoom: myStyleSheet.zoom,
            bearing: myStyleSheet.bearing,
            pitch: myStyleSheet.pitch,
            sprite: myStyleSheet.sprite,
            glyphs: myStyleSheet.glyphs,
            transition: myStyleSheet.transition,
            sources,
            layers,
            terrain
        }, (value) => { return value !== undefined; });
    }
    _updateLayer(layer) {
        this._updatedLayers[layer.id] = true;
        if (layer.source && !this._updatedSources[layer.source] &&
            //Skip for raster layers (https://github.com/mapbox/mapbox-gl-js/issues/7865)
            this.sourceCaches[layer.source].getSource().type !== 'raster') {
            this._updatedSources[layer.source] = 'reload';
            this.sourceCaches[layer.source].pause();
        }
        // upon updating, serialized layer dictionary should be reset.
        // When needed, it will be populated with the correct copy again.
        this._serializedLayers = null;
        this._changed = true;
    }
    _flattenAndSortRenderedFeatures(sourceResults) {
        // Feature order is complicated.
        // The order between features in two 2D layers is always determined by layer order.
        // The order between features in two 3D layers is always determined by depth.
        // The order between a feature in a 2D layer and a 3D layer is tricky:
        //      Most often layer order determines the feature order in this case. If
        //      a line layer is above a extrusion layer the line feature will be rendered
        //      above the extrusion. If the line layer is below the extrusion layer,
        //      it will be rendered below it.
        //
        //      There is a weird case though.
        //      You have layers in this order: extrusion_layer_a, line_layer, extrusion_layer_b
        //      Each layer has a feature that overlaps the other features.
        //      The feature in extrusion_layer_a is closer than the feature in extrusion_layer_b so it is rendered above.
        //      The feature in line_layer is rendered above extrusion_layer_a.
        //      This means that that the line_layer feature is above the extrusion_layer_b feature despite
        //      it being in an earlier layer.
        const isLayer3D = layerId => this._layers[layerId].type === 'fill-extrusion';
        const layerIndex = {};
        const features3D = [];
        for (let l = this._order.length - 1; l >= 0; l--) {
            const layerId = this._order[l];
            if (isLayer3D(layerId)) {
                layerIndex[layerId] = l;
                for (const sourceResult of sourceResults) {
                    const layerFeatures = sourceResult[layerId];
                    if (layerFeatures) {
                        for (const featureWrapper of layerFeatures) {
                            features3D.push(featureWrapper);
                        }
                    }
                }
            }
        }
        features3D.sort((a, b) => {
            return b.intersectionZ - a.intersectionZ;
        });
        const features = [];
        for (let l = this._order.length - 1; l >= 0; l--) {
            const layerId = this._order[l];
            if (isLayer3D(layerId)) {
                // add all 3D features that are in or above the current layer
                for (let i = features3D.length - 1; i >= 0; i--) {
                    const topmost3D = features3D[i].feature;
                    if (layerIndex[topmost3D.layer.id] < l)
                        break;
                    features.push(topmost3D);
                    features3D.pop();
                }
            }
            else {
                for (const sourceResult of sourceResults) {
                    const layerFeatures = sourceResult[layerId];
                    if (layerFeatures) {
                        for (const featureWrapper of layerFeatures) {
                            features.push(featureWrapper.feature);
                        }
                    }
                }
            }
        }
        return features;
    }
    queryRenderedFeatures(queryGeometry, params, transform) {
        if (params && params.filter) {
            this._validate(performance$1.x.filter, 'queryRenderedFeatures.filter', params.filter, null, params);
        }
        const includedSources = {};
        if (params && params.layers) {
            if (!Array.isArray(params.layers)) {
                this.fire(new performance$1.j(new Error('parameters.layers must be an Array.')));
                return [];
            }
            for (const layerId of params.layers) {
                const layer = this._layers[layerId];
                if (!layer) {
                    // this layer is not in the style.layers array
                    this.fire(new performance$1.j(new Error(`The layer '${layerId}' does not exist in the map's style and cannot be queried for features.`)));
                    return [];
                }
                includedSources[layer.source] = true;
            }
        }
        const sourceResults = [];
        params.availableImages = this._availableImages;
        // LayerSpecification is serialized StyleLayer, and this casting is safe.
        const serializedLayers = this._serializedAllLayers();
        for (const id in this.sourceCaches) {
            if (params.layers && !includedSources[id])
                continue;
            sourceResults.push(queryRenderedFeatures(this.sourceCaches[id], this._layers, serializedLayers, queryGeometry, params, transform));
        }
        if (this.placement) {
            // If a placement has run, query against its CollisionIndex
            // for symbol results, and treat it as an extra source to merge
            sourceResults.push(queryRenderedSymbols(this._layers, serializedLayers, this.sourceCaches, queryGeometry, params, this.placement.collisionIndex, this.placement.retainedQueryData));
        }
        return this._flattenAndSortRenderedFeatures(sourceResults);
    }
    querySourceFeatures(sourceID, params) {
        if (params && params.filter) {
            this._validate(performance$1.x.filter, 'querySourceFeatures.filter', params.filter, null, params);
        }
        const sourceCache = this.sourceCaches[sourceID];
        return sourceCache ? querySourceFeatures(sourceCache, params) : [];
    }
    getLight() {
        return this.light.getLight();
    }
    setLight(lightOptions, options = {}) {
        this._checkLoaded();
        const light = this.light.getLight();
        let _update = false;
        for (const key in lightOptions) {
            if (!performance$1.aF(lightOptions[key], light[key])) {
                _update = true;
                break;
            }
        }
        if (!_update)
            return;
        const parameters = {
            now: browser.now(),
            transition: performance$1.e({
                duration: 300,
                delay: 0
            }, this.stylesheet.transition)
        };
        this.light.setLight(lightOptions, options);
        this.light.updateTransitions(parameters);
    }
    getSky() {
        var _a;
        return (_a = this.stylesheet) === null || _a === void 0 ? void 0 : _a.sky;
    }
    setSky(skyOptions, options = {}) {
        const sky = this.sky.getSky();
        let update = false;
        if (!skyOptions) {
            if (sky) {
                update = true;
            }
        }
        for (const key in skyOptions) {
            if (!performance$1.aF(skyOptions[key], sky[key])) {
                update = true;
                break;
            }
        }
        if (!update)
            return;
        const parameters = {
            now: browser.now(),
            transition: performance$1.e({
                duration: 300,
                delay: 0
            }, this.stylesheet.transition)
        };
        this.stylesheet.sky = skyOptions;
        this.sky.setSky(skyOptions, options);
        this.sky.updateTransitions(parameters);
    }
    _validate(validate, key, value, props, options = {}) {
        if (options && options.validate === false) {
            return false;
        }
        return emitValidationErrors(this, validate.call(performance$1.x, performance$1.e({
            key,
            style: this.serialize(),
            value,
            styleSpec: performance$1.v
        }, props)));
    }
    _remove(mapRemoved = true) {
        if (this._frameRequest) {
            this._frameRequest.abort();
            this._frameRequest = null;
        }
        if (this._loadStyleRequest) {
            this._loadStyleRequest.abort();
            this._loadStyleRequest = null;
        }
        if (this._spriteRequest) {
            this._spriteRequest.abort();
            this._spriteRequest = null;
        }
        rtlMainThreadPluginFactory().off(RTLPluginLoadedEventName, this._rtlPluginLoaded);
        for (const layerId in this._layers) {
            const layer = this._layers[layerId];
            layer.setEventedParent(null);
        }
        for (const id in this.sourceCaches) {
            const sourceCache = this.sourceCaches[id];
            sourceCache.setEventedParent(null);
            sourceCache.onRemove(this.map);
        }
        this.imageManager.setEventedParent(null);
        this.setEventedParent(null);
        if (mapRemoved) {
            this.dispatcher.broadcast("RM" /* MessageType.removeMap */, undefined);
        }
        this.dispatcher.remove(mapRemoved);
    }
    _clearSource(id) {
        this.sourceCaches[id].clearTiles();
    }
    _reloadSource(id) {
        this.sourceCaches[id].resume();
        this.sourceCaches[id].reload();
    }
    _updateSources(transform) {
        for (const id in this.sourceCaches) {
            this.sourceCaches[id].update(transform, this.map.terrain);
        }
    }
    _generateCollisionBoxes() {
        for (const id in this.sourceCaches) {
            this._reloadSource(id);
        }
    }
    _updatePlacement(transform, showCollisionBoxes, fadeDuration, crossSourceCollisions, forceFullPlacement = false) {
        let symbolBucketsChanged = false;
        let placementCommitted = false;
        const layerTiles = {};
        for (const layerID of this._order) {
            const styleLayer = this._layers[layerID];
            if (styleLayer.type !== 'symbol')
                continue;
            if (!layerTiles[styleLayer.source]) {
                const sourceCache = this.sourceCaches[styleLayer.source];
                layerTiles[styleLayer.source] = sourceCache.getRenderableIds(true)
                    .map((id) => sourceCache.getTileByID(id))
                    .sort((a, b) => (b.tileID.overscaledZ - a.tileID.overscaledZ) || (a.tileID.isLessThan(b.tileID) ? -1 : 1));
            }
            const layerBucketsChanged = this.crossTileSymbolIndex.addLayer(styleLayer, layerTiles[styleLayer.source], transform.center.lng);
            symbolBucketsChanged = symbolBucketsChanged || layerBucketsChanged;
        }
        this.crossTileSymbolIndex.pruneUnusedLayers(this._order);
        // Anything that changes our "in progress" layer and tile indices requires us
        // to start over. When we start over, we do a full placement instead of incremental
        // to prevent starvation.
        // We need to restart placement to keep layer indices in sync.
        // Also force full placement when fadeDuration === 0 to ensure that newly loaded
        // tiles will fully display symbols in their first frame
        forceFullPlacement = forceFullPlacement || this._layerOrderChanged || fadeDuration === 0;
        if (forceFullPlacement || !this.pauseablePlacement || (this.pauseablePlacement.isDone() && !this.placement.stillRecent(browser.now(), transform.zoom))) {
            this.pauseablePlacement = new PauseablePlacement(transform, this.map.terrain, this._order, forceFullPlacement, showCollisionBoxes, fadeDuration, crossSourceCollisions, this.placement);
            this._layerOrderChanged = false;
        }
        if (this.pauseablePlacement.isDone()) {
            // the last placement finished running, but the next one hasn’t
            // started yet because of the `stillRecent` check immediately
            // above, so mark it stale to ensure that we request another
            // render frame
            this.placement.setStale();
        }
        else {
            this.pauseablePlacement.continuePlacement(this._order, this._layers, layerTiles);
            if (this.pauseablePlacement.isDone()) {
                this.placement = this.pauseablePlacement.commit(browser.now());
                placementCommitted = true;
            }
            if (symbolBucketsChanged) {
                // since the placement gets split over multiple frames it is possible
                // these buckets were processed before they were changed and so the
                // placement is already stale while it is in progress
                this.pauseablePlacement.placement.setStale();
            }
        }
        if (placementCommitted || symbolBucketsChanged) {
            for (const layerID of this._order) {
                const styleLayer = this._layers[layerID];
                if (styleLayer.type !== 'symbol')
                    continue;
                this.placement.updateLayerOpacities(styleLayer, layerTiles[styleLayer.source]);
            }
        }
        // needsRender is false when we have just finished a placement that didn't change the visibility of any symbols
        const needsRerender = !this.pauseablePlacement.isDone() || this.placement.hasTransitions(browser.now());
        return needsRerender;
    }
    _releaseSymbolFadeTiles() {
        for (const id in this.sourceCaches) {
            this.sourceCaches[id].releaseSymbolFadeTiles();
        }
    }
    // Callbacks from web workers
    getImages(mapId, params) {
        return performance$1._(this, void 0, void 0, function* () {
            const images = yield this.imageManager.getImages(params.icons);
            // Apply queued image changes before setting the tile's dependencies so that the tile
            // is not reloaded unnecessarily. Without this forced update the reload could happen in cases
            // like this one:
            // - icons contains "my-image"
            // - imageManager.getImages(...) triggers `onstyleimagemissing`
            // - the user adds "my-image" within the callback
            // - addImage adds "my-image" to this._changedImages
            // - the next frame triggers a reload of this tile even though it already has the latest version
            this._updateTilesForChangedImages();
            const sourceCache = this.sourceCaches[params.source];
            if (sourceCache) {
                sourceCache.setDependencies(params.tileID.key, params.type, params.icons);
            }
            return images;
        });
    }
    getGlyphs(mapId, params) {
        return performance$1._(this, void 0, void 0, function* () {
            const glypgs = yield this.glyphManager.getGlyphs(params.stacks);
            const sourceCache = this.sourceCaches[params.source];
            if (sourceCache) {
                // we are not setting stacks as dependencies since for now
                // we just need to know which tiles have glyph dependencies
                sourceCache.setDependencies(params.tileID.key, params.type, ['']);
            }
            return glypgs;
        });
    }
    getGlyphsUrl() {
        return this.stylesheet.glyphs || null;
    }
    setGlyphs(glyphsUrl, options = {}) {
        this._checkLoaded();
        if (glyphsUrl && this._validate(performance$1.x.glyphs, 'glyphs', glyphsUrl, null, options)) {
            return;
        }
        this._glyphsDidChange = true;
        this.stylesheet.glyphs = glyphsUrl;
        this.glyphManager.entries = {};
        this.glyphManager.setURL(glyphsUrl);
    }
    /**
     * Add a sprite.
     *
     * @param id - The id of the desired sprite
     * @param url - The url to load the desired sprite from
     * @param options - The style setter options
     * @param completion - The completion handler
     */
    addSprite(id, url, options = {}, completion) {
        this._checkLoaded();
        const spriteToAdd = [{ id, url }];
        const updatedSprite = [
            ...coerceSpriteToArray(this.stylesheet.sprite),
            ...spriteToAdd
        ];
        if (this._validate(performance$1.x.sprite, 'sprite', updatedSprite, null, options))
            return;
        this.stylesheet.sprite = updatedSprite;
        this._loadSprite(spriteToAdd, true, completion);
    }
    /**
     * Remove a sprite by its id. When the last sprite is removed, the whole `this.stylesheet.sprite` object becomes
     * `undefined`. This falsy `undefined` value later prevents attempts to load the sprite when it's absent.
     *
     * @param id - the id of the sprite to remove
     */
    removeSprite(id) {
        this._checkLoaded();
        const internalSpriteRepresentation = coerceSpriteToArray(this.stylesheet.sprite);
        if (!internalSpriteRepresentation.find(sprite => sprite.id === id)) {
            this.fire(new performance$1.j(new Error(`Sprite "${id}" doesn't exists on this map.`)));
            return;
        }
        if (this._spritesImagesIds[id]) {
            for (const imageId of this._spritesImagesIds[id]) {
                this.imageManager.removeImage(imageId);
                this._changedImages[imageId] = true;
            }
        }
        internalSpriteRepresentation.splice(internalSpriteRepresentation.findIndex(sprite => sprite.id === id), 1);
        this.stylesheet.sprite = internalSpriteRepresentation.length > 0 ? internalSpriteRepresentation : undefined;
        delete this._spritesImagesIds[id];
        this._availableImages = this.imageManager.listImages();
        this._changed = true;
        this.dispatcher.broadcast("SI" /* MessageType.setImages */, this._availableImages);
        this.fire(new performance$1.k('data', { dataType: 'style' }));
    }
    /**
     * Get the current sprite value.
     *
     * @returns empty array when no sprite is set; id-url pairs otherwise
     */
    getSprite() {
        return coerceSpriteToArray(this.stylesheet.sprite);
    }
    /**
     * Set a new value for the style's sprite.
     *
     * @param sprite - new sprite value
     * @param options - style setter options
     * @param completion - the completion handler
     */
    setSprite(sprite, options = {}, completion) {
        this._checkLoaded();
        if (sprite && this._validate(performance$1.x.sprite, 'sprite', sprite, null, options)) {
            return;
        }
        this.stylesheet.sprite = sprite;
        if (sprite) {
            this._loadSprite(sprite, true, completion);
        }
        else {
            this._unloadSprite();
            if (completion) {
                completion(null);
            }
        }
    }
}

var posAttributes = performance$1.Y([
    { name: 'a_pos', type: 'Int16', components: 2 }
]);

// This file is generated. Edit build/generate-shaders.ts, then run `npm run codegen`.
var preludeFrag = '#ifdef GL_ES\nprecision mediump float;\n#else\n#if !defined(lowp)\n#define lowp\n#endif\n#if !defined(mediump)\n#define mediump\n#endif\n#if !defined(highp)\n#define highp\n#endif\n#endif\n';

// This file is generated. Edit build/generate-shaders.ts, then run `npm run codegen`.
var preludeVert = '#ifdef GL_ES\nprecision highp float;\n#else\n#if !defined(lowp)\n#define lowp\n#endif\n#if !defined(mediump)\n#define mediump\n#endif\n#if !defined(highp)\n#define highp\n#endif\n#endif\nvec2 unpack_float(const float packedValue) {int packedIntValue=int(packedValue);int v0=packedIntValue/256;return vec2(v0,packedIntValue-v0*256);}vec2 unpack_opacity(const float packedOpacity) {int intOpacity=int(packedOpacity)/2;return vec2(float(intOpacity)/127.0,mod(packedOpacity,2.0));}vec4 decode_color(const vec2 encodedColor) {return vec4(unpack_float(encodedColor[0])/255.0,unpack_float(encodedColor[1])/255.0\n);}float unpack_mix_vec2(const vec2 packedValue,const float t) {return mix(packedValue[0],packedValue[1],t);}vec4 unpack_mix_color(const vec4 packedColors,const float t) {vec4 minColor=decode_color(vec2(packedColors[0],packedColors[1]));vec4 maxColor=decode_color(vec2(packedColors[2],packedColors[3]));return mix(minColor,maxColor,t);}vec2 get_pattern_pos(const vec2 pixel_coord_upper,const vec2 pixel_coord_lower,const vec2 pattern_size,const float tile_units_to_pixels,const vec2 pos) {vec2 offset=mod(mod(mod(pixel_coord_upper,pattern_size)*256.0,pattern_size)*256.0+pixel_coord_lower,pattern_size);return (tile_units_to_pixels*pos+offset)/pattern_size;}\n#ifdef TERRAIN3D\nuniform sampler2D u_terrain;uniform float u_terrain_dim;uniform mat4 u_terrain_matrix;uniform vec4 u_terrain_unpack;uniform float u_terrain_exaggeration;uniform highp sampler2D u_depth;\n#endif\nconst highp vec4 bitSh=vec4(256.*256.*256.,256.*256.,256.,1.);const highp vec4 bitShifts=vec4(1.)/bitSh;highp float unpack(highp vec4 color) {return dot(color,bitShifts);}highp float depthOpacity(vec3 frag) {\n#ifdef TERRAIN3D\nhighp float d=unpack(texture2D(u_depth,frag.xy*0.5+0.5))+0.0001-frag.z;return 1.0-max(0.0,min(1.0,-d*500.0));\n#else\nreturn 1.0;\n#endif\n}float calculate_visibility(vec4 pos) {\n#ifdef TERRAIN3D\nvec3 frag=pos.xyz/pos.w;highp float d=depthOpacity(frag);if (d > 0.95) return 1.0;return (d+depthOpacity(frag+vec3(0.0,0.01,0.0)))/2.0;\n#else\nreturn 1.0;\n#endif\n}float ele(vec2 pos) {\n#ifdef TERRAIN3D\nvec4 rgb=(texture2D(u_terrain,pos)*255.0)*u_terrain_unpack;return rgb.r+rgb.g+rgb.b-u_terrain_unpack.a;\n#else\nreturn 0.0;\n#endif\n}float get_elevation(vec2 pos) {\n#ifdef TERRAIN3D\nvec2 coord=(u_terrain_matrix*vec4(pos,0.0,1.0)).xy*u_terrain_dim+1.0;vec2 f=fract(coord);vec2 c=(floor(coord)+0.5)/(u_terrain_dim+2.0);float d=1.0/(u_terrain_dim+2.0);float tl=ele(c);float tr=ele(c+vec2(d,0.0));float bl=ele(c+vec2(0.0,d));float br=ele(c+vec2(d,d));float elevation=mix(mix(tl,tr,f.x),mix(bl,br,f.x),f.y);return elevation*u_terrain_exaggeration;\n#else\nreturn 0.0;\n#endif\n}';

// This file is generated. Edit build/generate-shaders.ts, then run `npm run codegen`.
var backgroundFrag = 'uniform vec4 u_color;uniform float u_opacity;void main() {gl_FragColor=u_color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}';

// This file is generated. Edit build/generate-shaders.ts, then run `npm run codegen`.
var backgroundVert = 'attribute vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}';

// This file is generated. Edit build/generate-shaders.ts, then run `npm run codegen`.
var backgroundPatternFrag = 'uniform vec2 u_pattern_tl_a;uniform vec2 u_pattern_br_a;uniform vec2 u_pattern_tl_b;uniform vec2 u_pattern_br_b;uniform vec2 u_texsize;uniform float u_mix;uniform float u_opacity;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;void main() {vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(u_pattern_tl_a/u_texsize,u_pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(u_pattern_tl_b/u_texsize,u_pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);gl_FragColor=mix(color1,color2,u_mix)*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}';

// This file is generated. Edit build/generate-shaders.ts, then run `npm run codegen`.
var backgroundPatternVert = 'uniform mat4 u_matrix;uniform vec2 u_pattern_size_a;uniform vec2 u_pattern_size_b;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_scale_a;uniform float u_scale_b;uniform float u_tile_units_to_pixels;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_a*u_pattern_size_a,u_tile_units_to_pixels,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_b*u_pattern_size_b,u_tile_units_to_pixels,a_pos);}';

// This file is generated. Edit build/generate-shaders.ts, then run `npm run codegen`.
var circleFrag = 'varying vec3 v_data;varying float v_visibility;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=v_data.xy;float extrude_length=length(extrude);lowp float antialiasblur=v_data.z;float antialiased_blur=-max(blur,antialiasblur);float opacity_t=smoothstep(0.0,antialiased_blur,extrude_length-1.0);float color_t=stroke_width < 0.01 ? 0.0 : smoothstep(antialiased_blur,0.0,extrude_length-radius/(radius+stroke_width));gl_FragColor=v_visibility*opacity_t*mix(color*opacity,stroke_color*stroke_opacity,color_t);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}';

// This file is generated. Edit build/generate-shaders.ts, then run `npm run codegen`.
var circleVert = 'uniform mat4 u_matrix;uniform bool u_scale_with_map;uniform bool u_pitch_with_map;uniform vec2 u_extrude_scale;uniform lowp float u_device_pixel_ratio;uniform highp float u_camera_to_center_distance;attribute vec2 a_pos;varying vec3 v_data;varying float v_visibility;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvoid main(void) {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=vec2(mod(a_pos,2.0)*2.0-1.0);vec2 circle_center=floor(a_pos*0.5);float ele=get_elevation(circle_center);v_visibility=calculate_visibility(u_matrix*vec4(circle_center,ele,1.0));if (u_pitch_with_map) {vec2 corner_position=circle_center;if (u_scale_with_map) {corner_position+=extrude*(radius+stroke_width)*u_extrude_scale;} else {vec4 projected_center=u_matrix*vec4(circle_center,0,1);corner_position+=extrude*(radius+stroke_width)*u_extrude_scale*(projected_center.w/u_camera_to_center_distance);}gl_Position=u_matrix*vec4(corner_position,ele,1);} else {gl_Position=u_matrix*vec4(circle_center,ele,1);if (u_scale_with_map) {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*u_camera_to_center_distance;} else {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*gl_Position.w;}}lowp float antialiasblur=1.0/u_device_pixel_ratio/(radius+stroke_width);v_data=vec3(extrude.x,extrude.y,antialiasblur);}';

// This file is generated. Edit build/generate-shaders.ts, then run `npm run codegen`.
var clippingMaskFrag = 'void main() {gl_FragColor=vec4(1.0);}';

// This file is generated. Edit build/generate-shaders.ts, then run `npm run codegen`.
var clippingMaskVert = 'attribute vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}';

// This file is generated. Edit build/generate-shaders.ts, then run `npm run codegen`.
var heatmapFrag = 'uniform highp float u_intensity;varying vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#define GAUSS_COEF 0.3989422804014327\nvoid main() {\n#pragma mapbox: initialize highp float weight\nfloat d=-0.5*3.0*3.0*dot(v_extrude,v_extrude);float val=weight*u_intensity*GAUSS_COEF*exp(d);gl_FragColor=vec4(val,1.0,1.0,1.0);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}';

// This file is generated. Edit build/generate-shaders.ts, then run `npm run codegen`.
var heatmapVert = 'uniform mat4 u_matrix;uniform float u_extrude_scale;uniform float u_opacity;uniform float u_intensity;attribute vec2 a_pos;varying vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#pragma mapbox: define mediump float radius\nconst highp float ZERO=1.0/255.0/16.0;\n#define GAUSS_COEF 0.3989422804014327\nvoid main(void) {\n#pragma mapbox: initialize highp float weight\n#pragma mapbox: initialize mediump float radius\nvec2 unscaled_extrude=vec2(mod(a_pos,2.0)*2.0-1.0);float S=sqrt(-2.0*log(ZERO/weight/u_intensity/GAUSS_COEF))/3.0;v_extrude=S*unscaled_extrude;vec2 extrude=v_extrude*radius*u_extrude_scale;vec4 pos=vec4(floor(a_pos*0.5)+extrude,0,1);gl_Position=u_matrix*pos;}';

// This file is generated. Edit build/generate-shaders.ts, then run `npm run codegen`.
var heatmapTextureFrag = 'uniform sampler2D u_image;uniform sampler2D u_color_ramp;uniform float u_opacity;varying vec2 v_pos;void main() {float t=texture2D(u_image,v_pos).r;vec4 color=texture2D(u_color_ramp,vec2(t,0.5));gl_FragColor=color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(0.0);\n#endif\n}';

// This file is generated. Edit build/generate-shaders.ts, then run `npm run codegen`.
var heatmapTextureVert = 'uniform mat4 u_matrix;uniform vec2 u_world;attribute vec2 a_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos*u_world,0,1);v_pos.x=a_pos.x;v_pos.y=1.0-a_pos.y;}';

// This file is generated. Edit build/generate-shaders.ts, then run `npm run codegen`.
var collisionBoxFrag = 'varying float v_placed;varying float v_notUsed;void main() {float alpha=0.5;gl_FragColor=vec4(1.0,0.0,0.0,1.0)*alpha;if (v_placed > 0.5) {gl_FragColor=vec4(0.0,0.0,1.0,0.5)*alpha;}if (v_notUsed > 0.5) {gl_FragColor*=.1;}}';

// This file is generated. Edit build/generate-shaders.ts, then run `npm run codegen`.
var collisionBoxVert = 'attribute vec2 a_anchor_pos;attribute vec2 a_placed;attribute vec2 a_box_real;uniform mat4 u_matrix;uniform vec2 u_pixel_extrude_scale;varying float v_placed;varying float v_notUsed;vec4 projectTileWithElevation(vec2 posInTile,float elevation) {return u_matrix*vec4(posInTile,elevation,1.0);}void main() {gl_Position=projectTileWithElevation(a_anchor_pos,get_elevation(a_anchor_pos));gl_Position.xy=((a_box_real+0.5)*u_pixel_extrude_scale*2.0-1.0)*vec2(1.0,-1.0)*gl_Position.w;if (gl_Position.z/gl_Position.w < 1.1) {gl_Position.z=0.5;}v_placed=a_placed.x;v_notUsed=a_placed.y;}';

// This file is generated. Edit build/generate-shaders.ts, then run `npm run codegen`.
var collisionCircleFrag = 'varying float v_radius;varying vec2 v_extrude;varying float v_perspective_ratio;varying float v_collision;void main() {float alpha=0.5*min(v_perspective_ratio,1.0);float stroke_radius=0.9*max(v_perspective_ratio,1.0);float distance_to_center=length(v_extrude);float distance_to_edge=abs(distance_to_center-v_radius);float opacity_t=smoothstep(-stroke_radius,0.0,-distance_to_edge);vec4 color=mix(vec4(0.0,0.0,1.0,0.5),vec4(1.0,0.0,0.0,1.0),v_collision);gl_FragColor=color*alpha*opacity_t;}';

// This file is generated. Edit build/generate-shaders.ts, then run `npm run codegen`.
var collisionCircleVert = 'attribute vec2 a_pos;attribute float a_radius;attribute vec2 a_flags;uniform mat4 u_matrix;uniform mat4 u_inv_matrix;uniform vec2 u_viewport_size;uniform float u_camera_to_center_distance;varying float v_radius;varying vec2 v_extrude;varying float v_perspective_ratio;varying float v_collision;vec3 toTilePosition(vec2 screenPos) {vec4 rayStart=u_inv_matrix*vec4(screenPos,-1.0,1.0);vec4 rayEnd  =u_inv_matrix*vec4(screenPos, 1.0,1.0);rayStart.xyz/=rayStart.w;rayEnd.xyz  /=rayEnd.w;highp float t=(0.0-rayStart.z)/(rayEnd.z-rayStart.z);return mix(rayStart.xyz,rayEnd.xyz,t);}void main() {vec2 quadCenterPos=a_pos;float radius=a_radius;float collision=a_flags.x;float vertexIdx=a_flags.y;vec2 quadVertexOffset=vec2(mix(-1.0,1.0,float(vertexIdx >=2.0)),mix(-1.0,1.0,float(vertexIdx >=1.0 && vertexIdx <=2.0)));vec2 quadVertexExtent=quadVertexOffset*radius;vec3 tilePos=toTilePosition(quadCenterPos);vec4 clipPos=u_matrix*vec4(tilePos,1.0);highp float camera_to_anchor_distance=clipPos.w;highp float collision_perspective_ratio=clamp(0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,4.0);float padding_factor=1.2;v_radius=radius;v_extrude=quadVertexExtent*padding_factor;v_perspective_ratio=collision_perspective_ratio;v_collision=collision;gl_Position=vec4(clipPos.xyz/clipPos.w,1.0)+vec4(quadVertexExtent*padding_factor/u_viewport_size*2.0,0.0,0.0);}';

// This file is generated. Edit build/generate-shaders.ts, then run `npm run codegen`.
var debugFrag = 'uniform highp vec4 u_color;uniform sampler2D u_overlay;varying vec2 v_uv;void main() {vec4 overlay_color=texture2D(u_overlay,v_uv);gl_FragColor=mix(u_color,overlay_color,overlay_color.a);}';

// This file is generated. Edit build/generate-shaders.ts, then run `npm run codegen`.
var debugVert = 'attribute vec2 a_pos;varying vec2 v_uv;uniform mat4 u_matrix;uniform float u_overlay_scale;void main() {v_uv=a_pos/8192.0;gl_Position=u_matrix*vec4(a_pos*u_overlay_scale,get_elevation(a_pos),1);}';

// This file is generated. Edit build/generate-shaders.ts, then run `npm run codegen`.
var fillFrag = '#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\ngl_FragColor=color*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}';

// This file is generated. Edit build/generate-shaders.ts, then run `npm run codegen`.
var fillVert = 'attribute vec2 a_pos;uniform mat4 u_matrix;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=u_matrix*vec4(a_pos,0,1);}';

// This file is generated. Edit build/generate-shaders.ts, then run `npm run codegen`.
var fillOutlineFrag = 'varying vec2 v_pos;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);gl_FragColor=outline_color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}';

// This file is generated. Edit build/generate-shaders.ts, then run `npm run codegen`.
var fillOutlineVert = 'attribute vec2 a_pos;uniform mat4 u_matrix;uniform vec2 u_world;varying vec2 v_pos;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=u_matrix*vec4(a_pos,0,1);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;}';

// This file is generated. Edit build/generate-shaders.ts, then run `npm run codegen`.
var fillOutlinePatternFrag = 'uniform vec2 u_texsize;uniform sampler2D u_image;uniform float u_fade;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec2 v_pos;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);float dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);gl_FragColor=mix(color1,color2,u_fade)*alpha*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}';

// This file is generated. Edit build/generate-shaders.ts, then run `npm run codegen`.
var fillOutlinePatternVert = 'uniform mat4 u_matrix;uniform vec2 u_world;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec2 v_pos;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;gl_Position=u_matrix*vec4(a_pos,0,1);vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,a_pos);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;}';

// This file is generated. Edit build/generate-shaders.ts, then run `npm run codegen`.
var fillPatternFrag = '#ifdef GL_ES\nprecision highp float;\n#endif\nuniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);gl_FragColor=mix(color1,color2,u_fade)*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}';

// This file is generated. Edit build/generate-shaders.ts, then run `npm run codegen`.
var fillPatternVert = 'uniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;gl_Position=u_matrix*vec4(a_pos,0,1);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileZoomRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileZoomRatio,a_pos);}';

// This file is generated. Edit build/generate-shaders.ts, then run `npm run codegen`.
var fillExtrusionFrag = 'varying vec4 v_color;void main() {gl_FragColor=v_color;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}';

// This file is generated. Edit build/generate-shaders.ts, then run `npm run codegen`.
var fillExtrusionVert = 'uniform mat4 u_matrix;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;uniform float u_vertical_gradient;uniform lowp float u_opacity;attribute vec2 a_pos;attribute vec4 a_normal_ed;\n#ifdef TERRAIN3D\nattribute vec2 a_centroid;\n#endif\nvarying vec4 v_color;\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define highp vec4 color\nvoid main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize highp vec4 color\nvec3 normal=a_normal_ed.xyz;\n#ifdef TERRAIN3D\nfloat height_terrain3d_offset=get_elevation(a_centroid);float base_terrain3d_offset=height_terrain3d_offset-(base > 0.0 ? 0.0 : 10.0);\n#else\nfloat height_terrain3d_offset=0.0;float base_terrain3d_offset=0.0;\n#endif\nbase=max(0.0,base)+base_terrain3d_offset;height=max(0.0,height)+height_terrain3d_offset;float t=mod(normal.x,2.0);gl_Position=u_matrix*vec4(a_pos,t > 0.0 ? height : base,1);float colorvalue=color.r*0.2126+color.g*0.7152+color.b*0.0722;v_color=vec4(0.0,0.0,0.0,1.0);vec4 ambientlight=vec4(0.03,0.03,0.03,1.0);color+=ambientlight;float directional=clamp(dot(normal/16384.0,u_lightpos),0.0,1.0);directional=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_color.r+=clamp(color.r*directional*u_lightcolor.r,mix(0.0,0.3,1.0-u_lightcolor.r),1.0);v_color.g+=clamp(color.g*directional*u_lightcolor.g,mix(0.0,0.3,1.0-u_lightcolor.g),1.0);v_color.b+=clamp(color.b*directional*u_lightcolor.b,mix(0.0,0.3,1.0-u_lightcolor.b),1.0);v_color*=u_opacity;}';

// This file is generated. Edit build/generate-shaders.ts, then run `npm run codegen`.
var fillExtrusionPatternFrag = 'uniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec4 v_lighting;\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float base\n#pragma mapbox: initialize lowp float height\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);vec4 mixedColor=mix(color1,color2,u_fade);gl_FragColor=mixedColor*v_lighting;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}';

// This file is generated. Edit build/generate-shaders.ts, then run `npm run codegen`.
var fillExtrusionPatternVert = 'uniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_height_factor;uniform vec3 u_scale;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;attribute vec2 a_pos;attribute vec4 a_normal_ed;\n#ifdef TERRAIN3D\nattribute vec2 a_centroid;\n#endif\nvarying vec2 v_pos_a;varying vec2 v_pos_b;varying vec4 v_lighting;\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float base\n#pragma mapbox: initialize lowp float height\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec3 normal=a_normal_ed.xyz;float edgedistance=a_normal_ed.w;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;\n#ifdef TERRAIN3D\nfloat height_terrain3d_offset=get_elevation(a_centroid);float base_terrain3d_offset=height_terrain3d_offset-(base > 0.0 ? 0.0 : 10.0);\n#else\nfloat height_terrain3d_offset=0.0;float base_terrain3d_offset=0.0;\n#endif\nbase=max(0.0,base)+base_terrain3d_offset;height=max(0.0,height)+height_terrain3d_offset;float t=mod(normal.x,2.0);float z=t > 0.0 ? height : base;gl_Position=u_matrix*vec4(a_pos,z,1);vec2 pos=normal.x==1.0 && normal.y==0.0 && normal.z==16384.0\n? a_pos\n: vec2(edgedistance,z*u_height_factor);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,pos);v_lighting=vec4(0.0,0.0,0.0,1.0);float directional=clamp(dot(normal/16383.0,u_lightpos),0.0,1.0);directional=mix((1.0-u_lightintensity),max((0.5+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_lighting.rgb+=clamp(directional*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_lighting*=u_opacity;}';

// This file is generated. Edit build/generate-shaders.ts, then run `npm run codegen`.
var hillshadePrepareFrag = '#ifdef GL_ES\nprecision highp float;\n#endif\nuniform sampler2D u_image;varying vec2 v_pos;uniform vec2 u_dimension;uniform float u_zoom;uniform vec4 u_unpack;float getElevation(vec2 coord,float bias) {vec4 data=texture2D(u_image,coord)*255.0;data.a=-1.0;return dot(data,u_unpack)/4.0;}void main() {vec2 epsilon=1.0/u_dimension;float a=getElevation(v_pos+vec2(-epsilon.x,-epsilon.y),0.0);float b=getElevation(v_pos+vec2(0,-epsilon.y),0.0);float c=getElevation(v_pos+vec2(epsilon.x,-epsilon.y),0.0);float d=getElevation(v_pos+vec2(-epsilon.x,0),0.0);float e=getElevation(v_pos,0.0);float f=getElevation(v_pos+vec2(epsilon.x,0),0.0);float g=getElevation(v_pos+vec2(-epsilon.x,epsilon.y),0.0);float h=getElevation(v_pos+vec2(0,epsilon.y),0.0);float i=getElevation(v_pos+vec2(epsilon.x,epsilon.y),0.0);float exaggerationFactor=u_zoom < 2.0 ? 0.4 : u_zoom < 4.5 ? 0.35 : 0.3;float exaggeration=u_zoom < 15.0 ? (u_zoom-15.0)*exaggerationFactor : 0.0;vec2 deriv=vec2((c+f+f+i)-(a+d+d+g),(g+h+h+i)-(a+b+b+c))/pow(2.0,exaggeration+(19.2562-u_zoom));gl_FragColor=clamp(vec4(deriv.x/2.0+0.5,deriv.y/2.0+0.5,1.0,1.0),0.0,1.0);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}';

// This file is generated. Edit build/generate-shaders.ts, then run `npm run codegen`.
var hillshadePrepareVert = 'uniform mat4 u_matrix;uniform vec2 u_dimension;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);highp vec2 epsilon=1.0/u_dimension;float scale=(u_dimension.x-2.0)/u_dimension.x;v_pos=(a_texture_pos/8192.0)*scale+epsilon;}';

// This file is generated. Edit build/generate-shaders.ts, then run `npm run codegen`.
var hillshadeFrag = 'uniform sampler2D u_image;varying vec2 v_pos;uniform vec2 u_latrange;uniform vec2 u_light;uniform vec4 u_shadow;uniform vec4 u_highlight;uniform vec4 u_accent;\n#define PI 3.141592653589793\nvoid main() {vec4 pixel=texture2D(u_image,v_pos);vec2 deriv=((pixel.rg*2.0)-1.0);float scaleFactor=cos(radians((u_latrange[0]-u_latrange[1])*(1.0-v_pos.y)+u_latrange[1]));float slope=atan(1.25*length(deriv)/scaleFactor);float aspect=deriv.x !=0.0 ? atan(deriv.y,-deriv.x) : PI/2.0*(deriv.y > 0.0 ? 1.0 :-1.0);float intensity=u_light.x;float azimuth=u_light.y+PI;float base=1.875-intensity*1.75;float maxValue=0.5*PI;float scaledSlope=intensity !=0.5 ? ((pow(base,slope)-1.0)/(pow(base,maxValue)-1.0))*maxValue : slope;float accent=cos(scaledSlope);vec4 accent_color=(1.0-accent)*u_accent*clamp(intensity*2.0,0.0,1.0);float shade=abs(mod((aspect+azimuth)/PI+0.5,2.0)-1.0);vec4 shade_color=mix(u_shadow,u_highlight,shade)*sin(scaledSlope)*clamp(intensity*2.0,0.0,1.0);gl_FragColor=accent_color*(1.0-shade_color.a)+shade_color;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}';

// This file is generated. Edit build/generate-shaders.ts, then run `npm run codegen`.
var hillshadeVert = 'uniform mat4 u_matrix;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos=a_texture_pos/8192.0;}';

// This file is generated. Edit build/generate-shaders.ts, then run `npm run codegen`.
var lineFrag = 'uniform lowp float u_device_pixel_ratio;varying vec2 v_width2;varying vec2 v_normal;varying float v_gamma_scale;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);gl_FragColor=color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}';

// This file is generated. Edit build/generate-shaders.ts, then run `npm run codegen`.
var lineVert = '\n#define scale 0.015873016\nattribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform vec2 u_units_to_pixels;uniform lowp float u_device_pixel_ratio;varying vec2 v_normal;varying vec2 v_width2;varying float v_gamma_scale;varying highp float v_linesofar;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;v_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*2.0;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nv_width2=vec2(outset,inset);}';

// This file is generated. Edit build/generate-shaders.ts, then run `npm run codegen`.
var lineGradientFrag = 'uniform lowp float u_device_pixel_ratio;uniform sampler2D u_image;varying vec2 v_width2;varying vec2 v_normal;varying float v_gamma_scale;varying highp vec2 v_uv;\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);vec4 color=texture2D(u_image,v_uv);gl_FragColor=color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}';

// This file is generated. Edit build/generate-shaders.ts, then run `npm run codegen`.
var lineGradientVert = '\n#define scale 0.015873016\nattribute vec2 a_pos_normal;attribute vec4 a_data;attribute float a_uv_x;attribute float a_split_index;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;uniform vec2 u_units_to_pixels;uniform float u_image_height;varying vec2 v_normal;varying vec2 v_width2;varying float v_gamma_scale;varying highp vec2 v_uv;\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;highp float texel_height=1.0/u_image_height;highp float half_texel_height=0.5*texel_height;v_uv=vec2(a_uv_x,a_split_index*texel_height-half_texel_height);vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nv_width2=vec2(outset,inset);}';

// This file is generated. Edit build/generate-shaders.ts, then run `npm run codegen`.
var linePatternFrag = '#ifdef GL_ES\nprecision highp float;\n#endif\nuniform lowp float u_device_pixel_ratio;uniform vec2 u_texsize;uniform float u_fade;uniform mediump vec3 u_scale;uniform sampler2D u_image;varying vec2 v_normal;varying vec2 v_width2;varying float v_linesofar;varying float v_gamma_scale;varying float v_width;\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;vec2 pattern_size_a=vec2(display_size_a.x*fromScale/tileZoomRatio,display_size_a.y);vec2 pattern_size_b=vec2(display_size_b.x*toScale/tileZoomRatio,display_size_b.y);float aspect_a=display_size_a.y/v_width;float aspect_b=display_size_b.y/v_width;float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float x_a=mod(v_linesofar/pattern_size_a.x*aspect_a,1.0);float x_b=mod(v_linesofar/pattern_size_b.x*aspect_b,1.0);float y=0.5*v_normal.y+0.5;vec2 texel_size=1.0/u_texsize;vec2 pos_a=mix(pattern_tl_a*texel_size-texel_size,pattern_br_a*texel_size+texel_size,vec2(x_a,y));vec2 pos_b=mix(pattern_tl_b*texel_size-texel_size,pattern_br_b*texel_size+texel_size,vec2(x_b,y));vec4 color=mix(texture2D(u_image,pos_a),texture2D(u_image,pos_b),u_fade);gl_FragColor=color*alpha*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}';

// This file is generated. Edit build/generate-shaders.ts, then run `npm run codegen`.
var linePatternVert = '\n#define scale 0.015873016\n#define LINE_DISTANCE_SCALE 2.0\nattribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform vec2 u_units_to_pixels;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;varying vec2 v_normal;varying vec2 v_width2;varying float v_linesofar;varying float v_gamma_scale;varying float v_width;\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nv_linesofar=a_linesofar;v_width2=vec2(outset,inset);v_width=floorwidth;}';

// This file is generated. Edit build/generate-shaders.ts, then run `npm run codegen`.
var lineSDFFrag = 'uniform lowp float u_device_pixel_ratio;uniform sampler2D u_image;uniform float u_sdfgamma;uniform float u_mix;varying vec2 v_normal;varying vec2 v_width2;varying vec2 v_tex_a;varying vec2 v_tex_b;varying float v_gamma_scale;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float sdfdist_a=texture2D(u_image,v_tex_a).a;float sdfdist_b=texture2D(u_image,v_tex_b).a;float sdfdist=mix(sdfdist_a,sdfdist_b,u_mix);alpha*=smoothstep(0.5-u_sdfgamma/floorwidth,0.5+u_sdfgamma/floorwidth,sdfdist);gl_FragColor=color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}';

// This file is generated. Edit build/generate-shaders.ts, then run `npm run codegen`.
var lineSDFVert = '\n#define scale 0.015873016\n#define LINE_DISTANCE_SCALE 2.0\nattribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;uniform vec2 u_patternscale_a;uniform float u_tex_y_a;uniform vec2 u_patternscale_b;uniform float u_tex_y_b;uniform vec2 u_units_to_pixels;varying vec2 v_normal;varying vec2 v_width2;varying vec2 v_tex_a;varying vec2 v_tex_b;varying float v_gamma_scale;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nv_tex_a=vec2(a_linesofar*u_patternscale_a.x/floorwidth,normal.y*u_patternscale_a.y+u_tex_y_a);v_tex_b=vec2(a_linesofar*u_patternscale_b.x/floorwidth,normal.y*u_patternscale_b.y+u_tex_y_b);v_width2=vec2(outset,inset);}';

// This file is generated. Edit build/generate-shaders.ts, then run `npm run codegen`.
var rasterFrag = 'uniform float u_fade_t;uniform float u_opacity;uniform sampler2D u_image0;uniform sampler2D u_image1;varying vec2 v_pos0;varying vec2 v_pos1;uniform float u_brightness_low;uniform float u_brightness_high;uniform float u_saturation_factor;uniform float u_contrast_factor;uniform vec3 u_spin_weights;void main() {vec4 color0=texture2D(u_image0,v_pos0);vec4 color1=texture2D(u_image1,v_pos1);if (color0.a > 0.0) {color0.rgb=color0.rgb/color0.a;}if (color1.a > 0.0) {color1.rgb=color1.rgb/color1.a;}vec4 color=mix(color0,color1,u_fade_t);color.a*=u_opacity;vec3 rgb=color.rgb;rgb=vec3(dot(rgb,u_spin_weights.xyz),dot(rgb,u_spin_weights.zxy),dot(rgb,u_spin_weights.yzx));float average=(color.r+color.g+color.b)/3.0;rgb+=(average-rgb)*u_saturation_factor;rgb=(rgb-0.5)*u_contrast_factor+0.5;vec3 u_high_vec=vec3(u_brightness_low,u_brightness_low,u_brightness_low);vec3 u_low_vec=vec3(u_brightness_high,u_brightness_high,u_brightness_high);gl_FragColor=vec4(mix(u_high_vec,u_low_vec,rgb)*color.a,color.a);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}';

// This file is generated. Edit build/generate-shaders.ts, then run `npm run codegen`.
var rasterVert = 'uniform mat4 u_matrix;uniform vec2 u_tl_parent;uniform float u_scale_parent;uniform float u_buffer_scale;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos0;varying vec2 v_pos1;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos0=(((a_texture_pos/8192.0)-0.5)/u_buffer_scale )+0.5;v_pos1=(v_pos0*u_scale_parent)+u_tl_parent;}';

// This file is generated. Edit build/generate-shaders.ts, then run `npm run codegen`.
var symbolIconFrag = 'uniform sampler2D u_texture;varying vec2 v_tex;varying float v_fade_opacity;\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\nlowp float alpha=opacity*v_fade_opacity;gl_FragColor=texture2D(u_texture,v_tex)*alpha;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}';

// This file is generated. Edit build/generate-shaders.ts, then run `npm run codegen`.
var symbolIconVert = 'attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec4 a_pixeloffset;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform highp float u_camera_to_center_distance;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform float u_fade_change;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform vec2 u_texsize;uniform bool u_is_along_line;uniform bool u_is_variable_anchor;uniform vec2 u_translation;uniform float u_pitched_scale;varying vec2 v_tex;varying float v_fade_opacity;vec4 projectTileWithElevation(vec2 posInTile,float elevation) {return u_matrix*vec4(posInTile,elevation,1.0);}\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;vec2 a_minFontScale=a_pixeloffset.zw/256.0;float ele=get_elevation(a_pos);highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 translated_a_pos=a_pos+u_translation;vec4 projectedPoint=projectTileWithElevation(translated_a_pos,ele);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=projectTileWithElevation(translated_a_pos+vec2(1,0),ele);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos;if (u_is_along_line || u_is_variable_anchor) {projected_pos=vec4(a_projected_pos.xy,ele,1.0);} else if (u_pitch_with_map) {projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy+u_translation,ele,1.0);} else {projected_pos=u_label_plane_matrix*projectTileWithElevation(a_projected_pos.xy+u_translation,ele);}float z=float(u_pitch_with_map)*projected_pos.z/projected_pos.w;float projectionScaling=1.0;vec4 finalPos=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*max(a_minFontScale,fontScale)+a_pxoffset/16.0)*projectionScaling,z,1.0);if(u_pitch_with_map) {finalPos=projectTileWithElevation(finalPos.xy,finalPos.z);}gl_Position=finalPos;v_tex=a_tex/u_texsize;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float visibility=calculate_visibility(projectedPoint);v_fade_opacity=max(0.0,min(visibility,fade_opacity[0]+fade_change));}';

// This file is generated. Edit build/generate-shaders.ts, then run `npm run codegen`.
var symbolSDFFrag = '#define SDF_PX 8.0\nuniform bool u_is_halo;uniform sampler2D u_texture;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;uniform bool u_is_text;varying vec2 v_data0;varying vec3 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nfloat EDGE_GAMMA=0.105/u_device_pixel_ratio;vec2 tex=v_data0.xy;float gamma_scale=v_data1.x;float size=v_data1.y;float fade_opacity=v_data1[2];float fontScale=u_is_text ? size/24.0 : size;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float inner_edge=(256.0-64.0)/256.0;if (u_is_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);inner_edge=inner_edge+gamma*gamma_scale;}lowp float dist=texture2D(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(inner_edge-gamma_scaled,inner_edge+gamma_scaled,dist);if (u_is_halo) {lowp float halo_edge=(6.0-halo_width/fontScale)/SDF_PX;alpha=min(smoothstep(halo_edge-gamma_scaled,halo_edge+gamma_scaled,dist),1.0-alpha);}gl_FragColor=color*(alpha*opacity*fade_opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}';

// This file is generated. Edit build/generate-shaders.ts, then run `npm run codegen`.
var symbolSDFVert = 'attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec4 a_pixeloffset;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform bool u_is_along_line;uniform bool u_is_variable_anchor;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec2 u_translation;uniform float u_pitched_scale;varying vec2 v_data0;varying vec3 v_data1;vec4 projectTileWithElevation(vec2 posInTile,float elevation) {return u_matrix*vec4(posInTile,elevation,1.0);}\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;float ele=get_elevation(a_pos);highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 translated_a_pos=a_pos+u_translation;vec4 projectedPoint=projectTileWithElevation(translated_a_pos,ele);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=projectTileWithElevation(translated_a_pos+vec2(1,0),ele);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos;if (u_is_along_line || u_is_variable_anchor) {projected_pos=vec4(a_projected_pos.xy,ele,1.0);} else if (u_pitch_with_map) {projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy+u_translation,ele,1.0);} else {projected_pos=u_label_plane_matrix*projectTileWithElevation(a_projected_pos.xy+u_translation,ele);}float z=float(u_pitch_with_map)*projected_pos.z/projected_pos.w;float projectionScaling=1.0;vec4 finalPos=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*fontScale+a_pxoffset)*projectionScaling,z,1.0);if(u_pitch_with_map) {finalPos=projectTileWithElevation(finalPos.xy,finalPos.z);}float gamma_scale=finalPos.w;gl_Position=finalPos;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float visibility=calculate_visibility(projectedPoint);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(visibility,fade_opacity[0]+fade_change));v_data0=a_tex/u_texsize;v_data1=vec3(gamma_scale,size,interpolated_fade_opacity);}';

// This file is generated. Edit build/generate-shaders.ts, then run `npm run codegen`.
var symbolTextAndIconFrag = '#define SDF_PX 8.0\n#define SDF 1.0\n#define ICON 0.0\nuniform bool u_is_halo;uniform sampler2D u_texture;uniform sampler2D u_texture_icon;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;varying vec4 v_data0;varying vec4 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nfloat fade_opacity=v_data1[2];if (v_data1.w==ICON) {vec2 tex_icon=v_data0.zw;lowp float alpha=opacity*fade_opacity;gl_FragColor=texture2D(u_texture_icon,tex_icon)*alpha;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\nreturn;}vec2 tex=v_data0.xy;float EDGE_GAMMA=0.105/u_device_pixel_ratio;float gamma_scale=v_data1.x;float size=v_data1.y;float fontScale=size/24.0;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;if (u_is_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width/fontScale)/SDF_PX;}lowp float dist=texture2D(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);gl_FragColor=color*(alpha*opacity*fade_opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}';

// This file is generated. Edit build/generate-shaders.ts, then run `npm run codegen`.
var symbolTextAndIconVert = 'attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec2 u_texsize_icon;uniform bool u_is_along_line;uniform bool u_is_variable_anchor;uniform vec2 u_translation;uniform float u_pitched_scale;varying vec4 v_data0;varying vec4 v_data1;vec4 projectTileWithElevation(vec2 posInTile,float elevation) {return u_matrix*vec4(posInTile,elevation,1.0);}\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);float is_sdf=a_size[0]-2.0*a_size_min;float ele=get_elevation(a_pos);highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 translated_a_pos=a_pos+u_translation;vec4 projectedPoint=projectTileWithElevation(translated_a_pos,ele);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=size/24.0;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=projectTileWithElevation(translated_a_pos+vec2(1,0),ele);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos;if (u_is_along_line || u_is_variable_anchor) {projected_pos=vec4(a_projected_pos.xy,ele,1.0);} else if (u_pitch_with_map) {projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy+u_translation,ele,1.0);} else {projected_pos=u_label_plane_matrix*projectTileWithElevation(a_projected_pos.xy+u_translation,ele);}float z=float(u_pitch_with_map)*projected_pos.z/projected_pos.w;float projectionScaling=1.0;vec4 finalPos=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*fontScale)*projectionScaling,z,1.0);if(u_pitch_with_map) {finalPos=projectTileWithElevation(finalPos.xy,finalPos.z);}float gamma_scale=finalPos.w;gl_Position=finalPos;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float visibility=calculate_visibility(projectedPoint);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(visibility,fade_opacity[0]+fade_change));v_data0.xy=a_tex/u_texsize;v_data0.zw=a_tex/u_texsize_icon;v_data1=vec4(gamma_scale,size,interpolated_fade_opacity,is_sdf);}';

// This file is generated. Edit build/generate-shaders.ts, then run `npm run codegen`.
var terrainDepthFrag = 'varying float v_depth;const highp vec4 bitSh=vec4(256.*256.*256.,256.*256.,256.,1.);const highp vec4 bitMsk=vec4(0.,vec3(1./256.0));highp vec4 pack(highp float value) {highp vec4 comp=fract(value*bitSh);comp-=comp.xxyz*bitMsk;return comp;}void main() {gl_FragColor=pack(v_depth);}';

// This file is generated. Edit build/generate-shaders.ts, then run `npm run codegen`.
var terrainCoordsFrag = 'precision mediump float;uniform sampler2D u_texture;uniform float u_terrain_coords_id;varying vec2 v_texture_pos;void main() {vec4 rgba=texture2D(u_texture,v_texture_pos);gl_FragColor=vec4(rgba.r,rgba.g,rgba.b,u_terrain_coords_id);}';

// This file is generated. Edit build/generate-shaders.ts, then run `npm run codegen`.
var terrainFrag = 'uniform sampler2D u_texture;uniform vec4 u_fog_color;uniform vec4 u_horizon_color;uniform float u_fog_ground_blend;uniform float u_fog_ground_blend_opacity;uniform float u_horizon_fog_blend;varying vec2 v_texture_pos;varying float v_fog_depth;const float gamma=2.2;vec4 gammaToLinear(vec4 color) {return pow(color,vec4(gamma));}vec4 linearToGamma(vec4 color) {return pow(color,vec4(1.0/gamma));}void main() {vec4 surface_color=texture2D(u_texture,v_texture_pos);if (v_fog_depth > u_fog_ground_blend) {vec4 surface_color_linear=gammaToLinear(surface_color);float blend_color=smoothstep(0.0,1.0,max((v_fog_depth-u_horizon_fog_blend)/(1.0-u_horizon_fog_blend),0.0));vec4 fog_horizon_color_linear=mix(gammaToLinear(u_fog_color),gammaToLinear(u_horizon_color),blend_color);float factor_fog=max(v_fog_depth-u_fog_ground_blend,0.0)/(1.0-u_fog_ground_blend);gl_FragColor=linearToGamma(mix(surface_color_linear,fog_horizon_color_linear,pow(factor_fog,2.0)*u_fog_ground_blend_opacity));} else {gl_FragColor=surface_color;}}';

// This file is generated. Edit build/generate-shaders.ts, then run `npm run codegen`.
var terrainDepthVert = 'attribute vec3 a_pos3d;uniform mat4 u_matrix;uniform float u_ele_delta;varying float v_depth;void main() {float ele=get_elevation(a_pos3d.xy);float ele_delta=a_pos3d.z==1.0 ? u_ele_delta : 0.0;gl_Position=u_matrix*vec4(a_pos3d.xy,ele-ele_delta,1.0);v_depth=gl_Position.z/gl_Position.w;}';

// This file is generated. Edit build/generate-shaders.ts, then run `npm run codegen`.
var terrainCoordsVert = 'attribute vec3 a_pos3d;uniform mat4 u_matrix;uniform float u_ele_delta;varying vec2 v_texture_pos;void main() {float ele=get_elevation(a_pos3d.xy);float ele_delta=a_pos3d.z==1.0 ? u_ele_delta : 0.0;v_texture_pos=a_pos3d.xy/8192.0;gl_Position=u_matrix*vec4(a_pos3d.xy,ele-ele_delta,1.0);}';

// This file is generated. Edit build/generate-shaders.ts, then run `npm run codegen`.
var terrainVert = 'attribute vec3 a_pos3d;uniform mat4 u_matrix;uniform mat4 u_fog_matrix;uniform float u_ele_delta;varying vec2 v_texture_pos;varying float v_fog_depth;void main() {float ele=get_elevation(a_pos3d.xy);float ele_delta=a_pos3d.z==1.0 ? u_ele_delta : 0.0;v_texture_pos=a_pos3d.xy/8192.0;gl_Position=u_matrix*vec4(a_pos3d.xy,ele-ele_delta,1.0);vec4 pos=u_fog_matrix*vec4(a_pos3d.xy,ele,1.0);v_fog_depth=pos.z/pos.w*0.5+0.5;}';

// This file is generated. Edit build/generate-shaders.ts, then run `npm run codegen`.
var skyFrag = 'uniform vec4 u_sky_color;uniform vec4 u_horizon_color;uniform float u_horizon;uniform float u_sky_horizon_blend;void main() {float y=gl_FragCoord.y;if (y > u_horizon) {float blend=y-u_horizon;if (blend < u_sky_horizon_blend) {gl_FragColor=mix(u_sky_color,u_horizon_color,pow(1.0-blend/u_sky_horizon_blend,2.0));} else {gl_FragColor=u_sky_color;}}}';

// This file is generated. Edit build/generate-shaders.ts, then run `npm run codegen`.
var skyVert = 'attribute vec2 a_pos;void main() {gl_Position=vec4(a_pos,1.0,1.0);}';

// Disable Flow annotations here because Flow doesn't support importing GLSL files
const shaders = {
    prelude: compile(preludeFrag, preludeVert),
    background: compile(backgroundFrag, backgroundVert),
    backgroundPattern: compile(backgroundPatternFrag, backgroundPatternVert),
    circle: compile(circleFrag, circleVert),
    clippingMask: compile(clippingMaskFrag, clippingMaskVert),
    heatmap: compile(heatmapFrag, heatmapVert),
    heatmapTexture: compile(heatmapTextureFrag, heatmapTextureVert),
    collisionBox: compile(collisionBoxFrag, collisionBoxVert),
    collisionCircle: compile(collisionCircleFrag, collisionCircleVert),
    debug: compile(debugFrag, debugVert),
    fill: compile(fillFrag, fillVert),
    fillOutline: compile(fillOutlineFrag, fillOutlineVert),
    fillOutlinePattern: compile(fillOutlinePatternFrag, fillOutlinePatternVert),
    fillPattern: compile(fillPatternFrag, fillPatternVert),
    fillExtrusion: compile(fillExtrusionFrag, fillExtrusionVert),
    fillExtrusionPattern: compile(fillExtrusionPatternFrag, fillExtrusionPatternVert),
    hillshadePrepare: compile(hillshadePrepareFrag, hillshadePrepareVert),
    hillshade: compile(hillshadeFrag, hillshadeVert),
    line: compile(lineFrag, lineVert),
    lineGradient: compile(lineGradientFrag, lineGradientVert),
    linePattern: compile(linePatternFrag, linePatternVert),
    lineSDF: compile(lineSDFFrag, lineSDFVert),
    raster: compile(rasterFrag, rasterVert),
    symbolIcon: compile(symbolIconFrag, symbolIconVert),
    symbolSDF: compile(symbolSDFFrag, symbolSDFVert),
    symbolTextAndIcon: compile(symbolTextAndIconFrag, symbolTextAndIconVert),
    terrain: compile(terrainFrag, terrainVert),
    terrainDepth: compile(terrainDepthFrag, terrainDepthVert),
    terrainCoords: compile(terrainCoordsFrag, terrainCoordsVert),
    sky: compile(skyFrag, skyVert)
};
// Expand #pragmas to #ifdefs.
function compile(fragmentSource, vertexSource) {
    const re = /#pragma mapbox: ([\w]+) ([\w]+) ([\w]+) ([\w]+)/g;
    const staticAttributes = vertexSource.match(/attribute ([\w]+) ([\w]+)/g);
    const fragmentUniforms = fragmentSource.match(/uniform ([\w]+) ([\w]+)([\s]*)([\w]*)/g);
    const vertexUniforms = vertexSource.match(/uniform ([\w]+) ([\w]+)([\s]*)([\w]*)/g);
    const staticUniforms = vertexUniforms ? vertexUniforms.concat(fragmentUniforms) : fragmentUniforms;
    const fragmentPragmas = {};
    fragmentSource = fragmentSource.replace(re, (match, operation, precision, type, name) => {
        fragmentPragmas[name] = true;
        if (operation === 'define') {
            return `
#ifndef HAS_UNIFORM_u_${name}
varying ${precision} ${type} ${name};
#else
uniform ${precision} ${type} u_${name};
#endif
`;
        }
        else /* if (operation === 'initialize') */ {
            return `
#ifdef HAS_UNIFORM_u_${name}
    ${precision} ${type} ${name} = u_${name};
#endif
`;
        }
    });
    vertexSource = vertexSource.replace(re, (match, operation, precision, type, name) => {
        const attrType = type === 'float' ? 'vec2' : 'vec4';
        const unpackType = name.match(/color/) ? 'color' : attrType;
        if (fragmentPragmas[name]) {
            if (operation === 'define') {
                return `
#ifndef HAS_UNIFORM_u_${name}
uniform lowp float u_${name}_t;
attribute ${precision} ${attrType} a_${name};
varying ${precision} ${type} ${name};
#else
uniform ${precision} ${type} u_${name};
#endif
`;
            }
            else /* if (operation === 'initialize') */ {
                if (unpackType === 'vec4') {
                    // vec4 attributes are only used for cross-faded properties, and are not packed
                    return `
#ifndef HAS_UNIFORM_u_${name}
    ${name} = a_${name};
#else
    ${precision} ${type} ${name} = u_${name};
#endif
`;
                }
                else {
                    return `
#ifndef HAS_UNIFORM_u_${name}
    ${name} = unpack_mix_${unpackType}(a_${name}, u_${name}_t);
#else
    ${precision} ${type} ${name} = u_${name};
#endif
`;
                }
            }
        }
        else {
            if (operation === 'define') {
                return `
#ifndef HAS_UNIFORM_u_${name}
uniform lowp float u_${name}_t;
attribute ${precision} ${attrType} a_${name};
#else
uniform ${precision} ${type} u_${name};
#endif
`;
            }
            else /* if (operation === 'initialize') */ {
                if (unpackType === 'vec4') {
                    // vec4 attributes are only used for cross-faded properties, and are not packed
                    return `
#ifndef HAS_UNIFORM_u_${name}
    ${precision} ${type} ${name} = a_${name};
#else
    ${precision} ${type} ${name} = u_${name};
#endif
`;
                }
                else /* */ {
                    return `
#ifndef HAS_UNIFORM_u_${name}
    ${precision} ${type} ${name} = unpack_mix_${unpackType}(a_${name}, u_${name}_t);
#else
    ${precision} ${type} ${name} = u_${name};
#endif
`;
                }
            }
        }
    });
    return { fragmentSource, vertexSource, staticAttributes, staticUniforms };
}

/**
 * @internal
 * A vertex array object used to pass data to the webgl code
 */
class VertexArrayObject {
    constructor() {
        this.boundProgram = null;
        this.boundLayoutVertexBuffer = null;
        this.boundPaintVertexBuffers = [];
        this.boundIndexBuffer = null;
        this.boundVertexOffset = null;
        this.boundDynamicVertexBuffer = null;
        this.vao = null;
    }
    bind(context, program, layoutVertexBuffer, paintVertexBuffers, indexBuffer, vertexOffset, dynamicVertexBuffer, dynamicVertexBuffer2, dynamicVertexBuffer3) {
        this.context = context;
        let paintBuffersDiffer = this.boundPaintVertexBuffers.length !== paintVertexBuffers.length;
        for (let i = 0; !paintBuffersDiffer && i < paintVertexBuffers.length; i++) {
            if (this.boundPaintVertexBuffers[i] !== paintVertexBuffers[i]) {
                paintBuffersDiffer = true;
            }
        }
        const isFreshBindRequired = (!this.vao ||
            this.boundProgram !== program ||
            this.boundLayoutVertexBuffer !== layoutVertexBuffer ||
            paintBuffersDiffer ||
            this.boundIndexBuffer !== indexBuffer ||
            this.boundVertexOffset !== vertexOffset ||
            this.boundDynamicVertexBuffer !== dynamicVertexBuffer ||
            this.boundDynamicVertexBuffer2 !== dynamicVertexBuffer2 ||
            this.boundDynamicVertexBuffer3 !== dynamicVertexBuffer3);
        if (isFreshBindRequired) {
            this.freshBind(program, layoutVertexBuffer, paintVertexBuffers, indexBuffer, vertexOffset, dynamicVertexBuffer, dynamicVertexBuffer2, dynamicVertexBuffer3);
        }
        else {
            context.bindVertexArray.set(this.vao);
            if (dynamicVertexBuffer) {
                // The buffer may have been updated. Rebind to upload data.
                dynamicVertexBuffer.bind();
            }
            if (indexBuffer && indexBuffer.dynamicDraw) {
                indexBuffer.bind();
            }
            if (dynamicVertexBuffer2) {
                dynamicVertexBuffer2.bind();
            }
            if (dynamicVertexBuffer3) {
                dynamicVertexBuffer3.bind();
            }
        }
    }
    freshBind(program, layoutVertexBuffer, paintVertexBuffers, indexBuffer, vertexOffset, dynamicVertexBuffer, dynamicVertexBuffer2, dynamicVertexBuffer3) {
        const numNextAttributes = program.numAttributes;
        const context = this.context;
        const gl = context.gl;
        if (this.vao)
            this.destroy();
        this.vao = context.createVertexArray();
        context.bindVertexArray.set(this.vao);
        // store the arguments so that we can verify them when the vao is bound again
        this.boundProgram = program;
        this.boundLayoutVertexBuffer = layoutVertexBuffer;
        this.boundPaintVertexBuffers = paintVertexBuffers;
        this.boundIndexBuffer = indexBuffer;
        this.boundVertexOffset = vertexOffset;
        this.boundDynamicVertexBuffer = dynamicVertexBuffer;
        this.boundDynamicVertexBuffer2 = dynamicVertexBuffer2;
        this.boundDynamicVertexBuffer3 = dynamicVertexBuffer3;
        layoutVertexBuffer.enableAttributes(gl, program);
        for (const vertexBuffer of paintVertexBuffers) {
            vertexBuffer.enableAttributes(gl, program);
        }
        if (dynamicVertexBuffer) {
            dynamicVertexBuffer.enableAttributes(gl, program);
        }
        if (dynamicVertexBuffer2) {
            dynamicVertexBuffer2.enableAttributes(gl, program);
        }
        if (dynamicVertexBuffer3) {
            dynamicVertexBuffer3.enableAttributes(gl, program);
        }
        layoutVertexBuffer.bind();
        layoutVertexBuffer.setVertexAttribPointers(gl, program, vertexOffset);
        for (const vertexBuffer of paintVertexBuffers) {
            vertexBuffer.bind();
            vertexBuffer.setVertexAttribPointers(gl, program, vertexOffset);
        }
        if (dynamicVertexBuffer) {
            dynamicVertexBuffer.bind();
            dynamicVertexBuffer.setVertexAttribPointers(gl, program, vertexOffset);
        }
        if (indexBuffer) {
            indexBuffer.bind();
        }
        if (dynamicVertexBuffer2) {
            dynamicVertexBuffer2.bind();
            dynamicVertexBuffer2.setVertexAttribPointers(gl, program, vertexOffset);
        }
        if (dynamicVertexBuffer3) {
            dynamicVertexBuffer3.bind();
            dynamicVertexBuffer3.setVertexAttribPointers(gl, program, vertexOffset);
        }
        context.currentNumAttributes = numNextAttributes;
    }
    destroy() {
        if (this.vao) {
            this.context.deleteVertexArray(this.vao);
            this.vao = null;
        }
    }
}

const terrainPreludeUniforms = (context, locations) => ({
    'u_depth': new performance$1.aI(context, locations.u_depth),
    'u_terrain': new performance$1.aI(context, locations.u_terrain),
    'u_terrain_dim': new performance$1.aJ(context, locations.u_terrain_dim),
    'u_terrain_matrix': new performance$1.aK(context, locations.u_terrain_matrix),
    'u_terrain_unpack': new performance$1.aL(context, locations.u_terrain_unpack),
    'u_terrain_exaggeration': new performance$1.aJ(context, locations.u_terrain_exaggeration)
});
const terrainUniforms = (context, locations) => ({
    'u_matrix': new performance$1.aK(context, locations.u_matrix),
    'u_texture': new performance$1.aI(context, locations.u_texture),
    'u_ele_delta': new performance$1.aJ(context, locations.u_ele_delta),
    'u_fog_matrix': new performance$1.aK(context, locations.u_fog_matrix),
    'u_fog_color': new performance$1.aM(context, locations.u_fog_color),
    'u_fog_ground_blend': new performance$1.aJ(context, locations.u_fog_ground_blend),
    'u_fog_ground_blend_opacity': new performance$1.aJ(context, locations.u_fog_ground_blend_opacity),
    'u_horizon_color': new performance$1.aM(context, locations.u_horizon_color),
    'u_horizon_fog_blend': new performance$1.aJ(context, locations.u_horizon_fog_blend)
});
const terrainDepthUniforms = (context, locations) => ({
    'u_matrix': new performance$1.aK(context, locations.u_matrix),
    'u_ele_delta': new performance$1.aJ(context, locations.u_ele_delta)
});
const terrainCoordsUniforms = (context, locations) => ({
    'u_matrix': new performance$1.aK(context, locations.u_matrix),
    'u_texture': new performance$1.aI(context, locations.u_texture),
    'u_terrain_coords_id': new performance$1.aJ(context, locations.u_terrain_coords_id),
    'u_ele_delta': new performance$1.aJ(context, locations.u_ele_delta)
});
const terrainUniformValues = (matrix, eleDelta, fogMatrix, sky, pitch) => ({
    'u_matrix': matrix,
    'u_texture': 0,
    'u_ele_delta': eleDelta,
    'u_fog_matrix': fogMatrix,
    'u_fog_color': sky ? sky.properties.get('fog-color') : performance$1.aN.white,
    'u_fog_ground_blend': sky ? sky.properties.get('fog-ground-blend') : 1,
    'u_fog_ground_blend_opacity': sky ? sky.calculateFogBlendOpacity(pitch) : 0,
    'u_horizon_color': sky ? sky.properties.get('horizon-color') : performance$1.aN.white,
    'u_horizon_fog_blend': sky ? sky.properties.get('horizon-fog-blend') : 1
});
const terrainDepthUniformValues = (matrix, eleDelta) => ({
    'u_matrix': matrix,
    'u_ele_delta': eleDelta
});
const terrainCoordsUniformValues = (matrix, coordsId, eleDelta) => ({
    'u_matrix': matrix,
    'u_terrain_coords_id': coordsId / 255,
    'u_texture': 0,
    'u_ele_delta': eleDelta
});

function getTokenizedAttributesAndUniforms(array) {
    const result = [];
    for (let i = 0; i < array.length; i++) {
        if (array[i] === null)
            continue;
        const token = array[i].split(' ');
        result.push(token.pop());
    }
    return result;
}
/**
 * @internal
 * A webgl program to execute in the GPU space
 */
class Program {
    constructor(context, source, configuration, fixedUniforms, showOverdrawInspector, terrain) {
        const gl = context.gl;
        this.program = gl.createProgram();
        const staticAttrInfo = getTokenizedAttributesAndUniforms(source.staticAttributes);
        const dynamicAttrInfo = configuration ? configuration.getBinderAttributes() : [];
        const allAttrInfo = staticAttrInfo.concat(dynamicAttrInfo);
        const preludeUniformsInfo = shaders.prelude.staticUniforms ? getTokenizedAttributesAndUniforms(shaders.prelude.staticUniforms) : [];
        const staticUniformsInfo = source.staticUniforms ? getTokenizedAttributesAndUniforms(source.staticUniforms) : [];
        const dynamicUniformsInfo = configuration ? configuration.getBinderUniforms() : [];
        // remove duplicate uniforms
        const uniformList = preludeUniformsInfo.concat(staticUniformsInfo).concat(dynamicUniformsInfo);
        const allUniformsInfo = [];
        for (const uniform of uniformList) {
            if (allUniformsInfo.indexOf(uniform) < 0)
                allUniformsInfo.push(uniform);
        }
        const defines = configuration ? configuration.defines() : [];
        if (showOverdrawInspector) {
            defines.push('#define OVERDRAW_INSPECTOR;');
        }
        if (terrain) {
            defines.push('#define TERRAIN3D;');
        }
        const fragmentSource = defines.concat(shaders.prelude.fragmentSource, source.fragmentSource).join('\n');
        const vertexSource = defines.concat(shaders.prelude.vertexSource, source.vertexSource).join('\n');
        const fragmentShader = gl.createShader(gl.FRAGMENT_SHADER);
        if (gl.isContextLost()) {
            this.failedToCreate = true;
            return;
        }
        gl.shaderSource(fragmentShader, fragmentSource);
        gl.compileShader(fragmentShader);
        if (!gl.getShaderParameter(fragmentShader, gl.COMPILE_STATUS)) {
            throw new Error(`Could not compile fragment shader: ${gl.getShaderInfoLog(fragmentShader)}`);
        }
        gl.attachShader(this.program, fragmentShader);
        const vertexShader = gl.createShader(gl.VERTEX_SHADER);
        if (gl.isContextLost()) {
            this.failedToCreate = true;
            return;
        }
        gl.shaderSource(vertexShader, vertexSource);
        gl.compileShader(vertexShader);
        if (!gl.getShaderParameter(vertexShader, gl.COMPILE_STATUS)) {
            throw new Error(`Could not compile vertex shader: ${gl.getShaderInfoLog(vertexShader)}`);
        }
        gl.attachShader(this.program, vertexShader);
        this.attributes = {};
        const uniformLocations = {};
        this.numAttributes = allAttrInfo.length;
        for (let i = 0; i < this.numAttributes; i++) {
            if (allAttrInfo[i]) {
                gl.bindAttribLocation(this.program, i, allAttrInfo[i]);
                this.attributes[allAttrInfo[i]] = i;
            }
        }
        gl.linkProgram(this.program);
        if (!gl.getProgramParameter(this.program, gl.LINK_STATUS)) {
            throw new Error(`Program failed to link: ${gl.getProgramInfoLog(this.program)}`);
        }
        gl.deleteShader(vertexShader);
        gl.deleteShader(fragmentShader);
        for (let it = 0; it < allUniformsInfo.length; it++) {
            const uniform = allUniformsInfo[it];
            if (uniform && !uniformLocations[uniform]) {
                const uniformLocation = gl.getUniformLocation(this.program, uniform);
                if (uniformLocation) {
                    uniformLocations[uniform] = uniformLocation;
                }
            }
        }
        this.fixedUniforms = fixedUniforms(context, uniformLocations);
        this.terrainUniforms = terrainPreludeUniforms(context, uniformLocations);
        this.binderUniforms = configuration ? configuration.getUniforms(context, uniformLocations) : [];
    }
    draw(context, drawMode, depthMode, stencilMode, colorMode, cullFaceMode, uniformValues, terrain, layerID, layoutVertexBuffer, indexBuffer, segments, currentProperties, zoom, configuration, dynamicLayoutBuffer, dynamicLayoutBuffer2, dynamicLayoutBuffer3) {
        const gl = context.gl;
        if (this.failedToCreate)
            return;
        context.program.set(this.program);
        context.setDepthMode(depthMode);
        context.setStencilMode(stencilMode);
        context.setColorMode(colorMode);
        context.setCullFace(cullFaceMode);
        // set variables used by the 3d functions defined in _prelude.vertex.glsl
        if (terrain) {
            context.activeTexture.set(gl.TEXTURE2);
            gl.bindTexture(gl.TEXTURE_2D, terrain.depthTexture);
            context.activeTexture.set(gl.TEXTURE3);
            gl.bindTexture(gl.TEXTURE_2D, terrain.texture);
            for (const name in this.terrainUniforms) {
                this.terrainUniforms[name].set(terrain[name]);
            }
        }
        for (const name in this.fixedUniforms) {
            this.fixedUniforms[name].set(uniformValues[name]);
        }
        if (configuration) {
            configuration.setUniforms(context, this.binderUniforms, currentProperties, { zoom: zoom });
        }
        let primitiveSize = 0;
        switch (drawMode) {
            case gl.LINES:
                primitiveSize = 2;
                break;
            case gl.TRIANGLES:
                primitiveSize = 3;
                break;
            case gl.LINE_STRIP:
                primitiveSize = 1;
                break;
        }
        for (const segment of segments.get()) {
            const vaos = segment.vaos || (segment.vaos = {});
            const vao = vaos[layerID] || (vaos[layerID] = new VertexArrayObject());
            vao.bind(context, this, layoutVertexBuffer, configuration ? configuration.getPaintVertexBuffers() : [], indexBuffer, segment.vertexOffset, dynamicLayoutBuffer, dynamicLayoutBuffer2, dynamicLayoutBuffer3);
            gl.drawElements(drawMode, segment.primitiveLength * primitiveSize, gl.UNSIGNED_SHORT, segment.primitiveOffset * primitiveSize * 2);
        }
    }
}

function patternUniformValues(crossfade, painter, tile) {
    const tileRatio = 1 / pixelsToTileUnits(tile, 1, painter.transform.tileZoom);
    const numTiles = Math.pow(2, tile.tileID.overscaledZ);
    const tileSizeAtNearestZoom = tile.tileSize * Math.pow(2, painter.transform.tileZoom) / numTiles;
    const pixelX = tileSizeAtNearestZoom * (tile.tileID.canonical.x + tile.tileID.wrap * numTiles);
    const pixelY = tileSizeAtNearestZoom * tile.tileID.canonical.y;
    return {
        'u_image': 0,
        'u_texsize': tile.imageAtlasTexture.size,
        'u_scale': [tileRatio, crossfade.fromScale, crossfade.toScale],
        'u_fade': crossfade.t,
        // split the pixel coord into two pairs of 16 bit numbers. The glsl spec only guarantees 16 bits of precision.
        'u_pixel_coord_upper': [pixelX >> 16, pixelY >> 16],
        'u_pixel_coord_lower': [pixelX & 0xFFFF, pixelY & 0xFFFF]
    };
}
function bgPatternUniformValues(image, crossfade, painter, tile) {
    const imagePosA = painter.imageManager.getPattern(image.from.toString());
    const imagePosB = painter.imageManager.getPattern(image.to.toString());
    const { width, height } = painter.imageManager.getPixelSize();
    const numTiles = Math.pow(2, tile.tileID.overscaledZ);
    const tileSizeAtNearestZoom = tile.tileSize * Math.pow(2, painter.transform.tileZoom) / numTiles;
    const pixelX = tileSizeAtNearestZoom * (tile.tileID.canonical.x + tile.tileID.wrap * numTiles);
    const pixelY = tileSizeAtNearestZoom * tile.tileID.canonical.y;
    return {
        'u_image': 0,
        'u_pattern_tl_a': imagePosA.tl,
        'u_pattern_br_a': imagePosA.br,
        'u_pattern_tl_b': imagePosB.tl,
        'u_pattern_br_b': imagePosB.br,
        'u_texsize': [width, height],
        'u_mix': crossfade.t,
        'u_pattern_size_a': imagePosA.displaySize,
        'u_pattern_size_b': imagePosB.displaySize,
        'u_scale_a': crossfade.fromScale,
        'u_scale_b': crossfade.toScale,
        'u_tile_units_to_pixels': 1 / pixelsToTileUnits(tile, 1, painter.transform.tileZoom),
        // split the pixel coord into two pairs of 16 bit numbers. The glsl spec only guarantees 16 bits of precision.
        'u_pixel_coord_upper': [pixelX >> 16, pixelY >> 16],
        'u_pixel_coord_lower': [pixelX & 0xFFFF, pixelY & 0xFFFF]
    };
}

const fillExtrusionUniforms = (context, locations) => ({
    'u_matrix': new performance$1.aK(context, locations.u_matrix),
    'u_lightpos': new performance$1.aO(context, locations.u_lightpos),
    'u_lightintensity': new performance$1.aJ(context, locations.u_lightintensity),
    'u_lightcolor': new performance$1.aO(context, locations.u_lightcolor),
    'u_vertical_gradient': new performance$1.aJ(context, locations.u_vertical_gradient),
    'u_opacity': new performance$1.aJ(context, locations.u_opacity)
});
const fillExtrusionPatternUniforms = (context, locations) => ({
    'u_matrix': new performance$1.aK(context, locations.u_matrix),
    'u_lightpos': new performance$1.aO(context, locations.u_lightpos),
    'u_lightintensity': new performance$1.aJ(context, locations.u_lightintensity),
    'u_lightcolor': new performance$1.aO(context, locations.u_lightcolor),
    'u_vertical_gradient': new performance$1.aJ(context, locations.u_vertical_gradient),
    'u_height_factor': new performance$1.aJ(context, locations.u_height_factor),
    // pattern uniforms
    'u_image': new performance$1.aI(context, locations.u_image),
    'u_texsize': new performance$1.aP(context, locations.u_texsize),
    'u_pixel_coord_upper': new performance$1.aP(context, locations.u_pixel_coord_upper),
    'u_pixel_coord_lower': new performance$1.aP(context, locations.u_pixel_coord_lower),
    'u_scale': new performance$1.aO(context, locations.u_scale),
    'u_fade': new performance$1.aJ(context, locations.u_fade),
    'u_opacity': new performance$1.aJ(context, locations.u_opacity)
});
const fillExtrusionUniformValues = (matrix, painter, shouldUseVerticalGradient, opacity) => {
    const light = painter.style.light;
    const _lp = light.properties.get('position');
    const lightPos = [_lp.x, _lp.y, _lp.z];
    const lightMat = create$3();
    if (light.properties.get('anchor') === 'viewport') {
        fromRotation(lightMat, -painter.transform.angle);
    }
    transformMat3(lightPos, lightPos, lightMat);
    const lightColor = light.properties.get('color');
    return {
        'u_matrix': matrix,
        'u_lightpos': lightPos,
        'u_lightintensity': light.properties.get('intensity'),
        'u_lightcolor': [lightColor.r, lightColor.g, lightColor.b],
        'u_vertical_gradient': +shouldUseVerticalGradient,
        'u_opacity': opacity
    };
};
const fillExtrusionPatternUniformValues = (matrix, painter, shouldUseVerticalGradient, opacity, coord, crossfade, tile) => {
    return performance$1.e(fillExtrusionUniformValues(matrix, painter, shouldUseVerticalGradient, opacity), patternUniformValues(crossfade, painter, tile), {
        'u_height_factor': -Math.pow(2, coord.overscaledZ) / tile.tileSize / 8
    });
};

const fillUniforms = (context, locations) => ({
    'u_matrix': new performance$1.aK(context, locations.u_matrix)
});
const fillPatternUniforms = (context, locations) => ({
    'u_matrix': new performance$1.aK(context, locations.u_matrix),
    'u_image': new performance$1.aI(context, locations.u_image),
    'u_texsize': new performance$1.aP(context, locations.u_texsize),
    'u_pixel_coord_upper': new performance$1.aP(context, locations.u_pixel_coord_upper),
    'u_pixel_coord_lower': new performance$1.aP(context, locations.u_pixel_coord_lower),
    'u_scale': new performance$1.aO(context, locations.u_scale),
    'u_fade': new performance$1.aJ(context, locations.u_fade)
});
const fillOutlineUniforms = (context, locations) => ({
    'u_matrix': new performance$1.aK(context, locations.u_matrix),
    'u_world': new performance$1.aP(context, locations.u_world)
});
const fillOutlinePatternUniforms = (context, locations) => ({
    'u_matrix': new performance$1.aK(context, locations.u_matrix),
    'u_world': new performance$1.aP(context, locations.u_world),
    'u_image': new performance$1.aI(context, locations.u_image),
    'u_texsize': new performance$1.aP(context, locations.u_texsize),
    'u_pixel_coord_upper': new performance$1.aP(context, locations.u_pixel_coord_upper),
    'u_pixel_coord_lower': new performance$1.aP(context, locations.u_pixel_coord_lower),
    'u_scale': new performance$1.aO(context, locations.u_scale),
    'u_fade': new performance$1.aJ(context, locations.u_fade)
});
const fillUniformValues = (matrix) => ({
    'u_matrix': matrix
});
const fillPatternUniformValues = (matrix, painter, crossfade, tile) => performance$1.e(fillUniformValues(matrix), patternUniformValues(crossfade, painter, tile));
const fillOutlineUniformValues = (matrix, drawingBufferSize) => ({
    'u_matrix': matrix,
    'u_world': drawingBufferSize
});
const fillOutlinePatternUniformValues = (matrix, painter, crossfade, tile, drawingBufferSize) => performance$1.e(fillPatternUniformValues(matrix, painter, crossfade, tile), {
    'u_world': drawingBufferSize
});

const circleUniforms = (context, locations) => ({
    'u_camera_to_center_distance': new performance$1.aJ(context, locations.u_camera_to_center_distance),
    'u_scale_with_map': new performance$1.aI(context, locations.u_scale_with_map),
    'u_pitch_with_map': new performance$1.aI(context, locations.u_pitch_with_map),
    'u_extrude_scale': new performance$1.aP(context, locations.u_extrude_scale),
    'u_device_pixel_ratio': new performance$1.aJ(context, locations.u_device_pixel_ratio),
    'u_matrix': new performance$1.aK(context, locations.u_matrix)
});
const circleUniformValues = (painter, coord, tile, layer) => {
    const transform = painter.transform;
    let pitchWithMap, extrudeScale;
    if (layer.paint.get('circle-pitch-alignment') === 'map') {
        const pixelRatio = pixelsToTileUnits(tile, 1, transform.zoom);
        pitchWithMap = true;
        extrudeScale = [pixelRatio, pixelRatio];
    }
    else {
        pitchWithMap = false;
        extrudeScale = transform.pixelsToGLUnits;
    }
    return {
        'u_camera_to_center_distance': transform.cameraToCenterDistance,
        'u_scale_with_map': +(layer.paint.get('circle-pitch-scale') === 'map'),
        'u_matrix': painter.translatePosMatrix(coord.posMatrix, tile, layer.paint.get('circle-translate'), layer.paint.get('circle-translate-anchor')),
        'u_pitch_with_map': +(pitchWithMap),
        'u_device_pixel_ratio': painter.pixelRatio,
        'u_extrude_scale': extrudeScale
    };
};

const collisionUniforms = (context, locations) => ({
    'u_matrix': new performance$1.aK(context, locations.u_matrix),
    'u_pixel_extrude_scale': new performance$1.aP(context, locations.u_pixel_extrude_scale)
});
const collisionCircleUniforms = (context, locations) => ({
    'u_matrix': new performance$1.aK(context, locations.u_matrix),
    'u_inv_matrix': new performance$1.aK(context, locations.u_inv_matrix),
    'u_camera_to_center_distance': new performance$1.aJ(context, locations.u_camera_to_center_distance),
    'u_viewport_size': new performance$1.aP(context, locations.u_viewport_size)
});
const collisionUniformValues = (transform, matrix) => {
    return {
        'u_matrix': matrix,
        'u_pixel_extrude_scale': [1.0 / transform.width, 1.0 / transform.height],
    };
};
const collisionCircleUniformValues = (matrix, invMatrix, transform) => {
    return {
        'u_matrix': matrix,
        'u_inv_matrix': invMatrix,
        'u_camera_to_center_distance': transform.cameraToCenterDistance,
        'u_viewport_size': [transform.width, transform.height]
    };
};

const debugUniforms = (context, locations) => ({
    'u_color': new performance$1.aM(context, locations.u_color),
    'u_matrix': new performance$1.aK(context, locations.u_matrix),
    'u_overlay': new performance$1.aI(context, locations.u_overlay),
    'u_overlay_scale': new performance$1.aJ(context, locations.u_overlay_scale)
});
const debugUniformValues = (matrix, color, scaleRatio = 1) => ({
    'u_matrix': matrix,
    'u_color': color,
    'u_overlay': 0,
    'u_overlay_scale': scaleRatio
});

const clippingMaskUniforms = (context, locations) => ({
    'u_matrix': new performance$1.aK(context, locations.u_matrix)
});
const clippingMaskUniformValues = (matrix) => ({
    'u_matrix': matrix
});

const heatmapUniforms = (context, locations) => ({
    'u_extrude_scale': new performance$1.aJ(context, locations.u_extrude_scale),
    'u_intensity': new performance$1.aJ(context, locations.u_intensity),
    'u_matrix': new performance$1.aK(context, locations.u_matrix)
});
const heatmapTextureUniforms = (context, locations) => ({
    'u_matrix': new performance$1.aK(context, locations.u_matrix),
    'u_world': new performance$1.aP(context, locations.u_world),
    'u_image': new performance$1.aI(context, locations.u_image),
    'u_color_ramp': new performance$1.aI(context, locations.u_color_ramp),
    'u_opacity': new performance$1.aJ(context, locations.u_opacity)
});
const heatmapUniformValues = (matrix, tile, zoom, intensity) => ({
    'u_matrix': matrix,
    'u_extrude_scale': pixelsToTileUnits(tile, 1, zoom),
    'u_intensity': intensity
});
const heatmapTextureUniformValues = (painter, layer, textureUnit, colorRampUnit) => {
    const matrix = performance$1.H();
    performance$1.aQ(matrix, 0, painter.width, painter.height, 0, 0, 1);
    const gl = painter.context.gl;
    return {
        'u_matrix': matrix,
        'u_world': [gl.drawingBufferWidth, gl.drawingBufferHeight],
        'u_image': textureUnit,
        'u_color_ramp': colorRampUnit,
        'u_opacity': layer.paint.get('heatmap-opacity')
    };
};

const hillshadeUniforms = (context, locations) => ({
    'u_matrix': new performance$1.aK(context, locations.u_matrix),
    'u_image': new performance$1.aI(context, locations.u_image),
    'u_latrange': new performance$1.aP(context, locations.u_latrange),
    'u_light': new performance$1.aP(context, locations.u_light),
    'u_shadow': new performance$1.aM(context, locations.u_shadow),
    'u_highlight': new performance$1.aM(context, locations.u_highlight),
    'u_accent': new performance$1.aM(context, locations.u_accent)
});
const hillshadePrepareUniforms = (context, locations) => ({
    'u_matrix': new performance$1.aK(context, locations.u_matrix),
    'u_image': new performance$1.aI(context, locations.u_image),
    'u_dimension': new performance$1.aP(context, locations.u_dimension),
    'u_zoom': new performance$1.aJ(context, locations.u_zoom),
    'u_unpack': new performance$1.aL(context, locations.u_unpack)
});
const hillshadeUniformValues = (painter, tile, layer, coord) => {
    const shadow = layer.paint.get('hillshade-shadow-color');
    const highlight = layer.paint.get('hillshade-highlight-color');
    const accent = layer.paint.get('hillshade-accent-color');
    let azimuthal = layer.paint.get('hillshade-illumination-direction') * (Math.PI / 180);
    // modify azimuthal angle by map rotation if light is anchored at the viewport
    if (layer.paint.get('hillshade-illumination-anchor') === 'viewport') {
        azimuthal -= painter.transform.angle;
    }
    const align = !painter.options.moving;
    return {
        'u_matrix': coord ? coord.posMatrix : painter.transform.calculatePosMatrix(tile.tileID.toUnwrapped(), align),
        'u_image': 0,
        'u_latrange': getTileLatRange(painter, tile.tileID),
        'u_light': [layer.paint.get('hillshade-exaggeration'), azimuthal],
        'u_shadow': shadow,
        'u_highlight': highlight,
        'u_accent': accent
    };
};
const hillshadeUniformPrepareValues = (tileID, dem) => {
    const stride = dem.stride;
    const matrix = performance$1.H();
    // Flip rendering at y axis.
    performance$1.aQ(matrix, 0, performance$1.X, -performance$1.X, 0, 0, 1);
    performance$1.J(matrix, matrix, [0, -performance$1.X, 0]);
    return {
        'u_matrix': matrix,
        'u_image': 1,
        'u_dimension': [stride, stride],
        'u_zoom': tileID.overscaledZ,
        'u_unpack': dem.getUnpackVector()
    };
};
function getTileLatRange(painter, tileID) {
    // for scaling the magnitude of a points slope by its latitude
    const tilesAtZoom = Math.pow(2, tileID.canonical.z);
    const y = tileID.canonical.y;
    return [
        new performance$1.Z(0, y / tilesAtZoom).toLngLat().lat,
        new performance$1.Z(0, (y + 1) / tilesAtZoom).toLngLat().lat
    ];
}

const lineUniforms = (context, locations) => ({
    'u_matrix': new performance$1.aK(context, locations.u_matrix),
    'u_ratio': new performance$1.aJ(context, locations.u_ratio),
    'u_device_pixel_ratio': new performance$1.aJ(context, locations.u_device_pixel_ratio),
    'u_units_to_pixels': new performance$1.aP(context, locations.u_units_to_pixels)
});
const lineGradientUniforms = (context, locations) => ({
    'u_matrix': new performance$1.aK(context, locations.u_matrix),
    'u_ratio': new performance$1.aJ(context, locations.u_ratio),
    'u_device_pixel_ratio': new performance$1.aJ(context, locations.u_device_pixel_ratio),
    'u_units_to_pixels': new performance$1.aP(context, locations.u_units_to_pixels),
    'u_image': new performance$1.aI(context, locations.u_image),
    'u_image_height': new performance$1.aJ(context, locations.u_image_height)
});
const linePatternUniforms = (context, locations) => ({
    'u_matrix': new performance$1.aK(context, locations.u_matrix),
    'u_texsize': new performance$1.aP(context, locations.u_texsize),
    'u_ratio': new performance$1.aJ(context, locations.u_ratio),
    'u_device_pixel_ratio': new performance$1.aJ(context, locations.u_device_pixel_ratio),
    'u_image': new performance$1.aI(context, locations.u_image),
    'u_units_to_pixels': new performance$1.aP(context, locations.u_units_to_pixels),
    'u_scale': new performance$1.aO(context, locations.u_scale),
    'u_fade': new performance$1.aJ(context, locations.u_fade)
});
const lineSDFUniforms = (context, locations) => ({
    'u_matrix': new performance$1.aK(context, locations.u_matrix),
    'u_ratio': new performance$1.aJ(context, locations.u_ratio),
    'u_device_pixel_ratio': new performance$1.aJ(context, locations.u_device_pixel_ratio),
    'u_units_to_pixels': new performance$1.aP(context, locations.u_units_to_pixels),
    'u_patternscale_a': new performance$1.aP(context, locations.u_patternscale_a),
    'u_patternscale_b': new performance$1.aP(context, locations.u_patternscale_b),
    'u_sdfgamma': new performance$1.aJ(context, locations.u_sdfgamma),
    'u_image': new performance$1.aI(context, locations.u_image),
    'u_tex_y_a': new performance$1.aJ(context, locations.u_tex_y_a),
    'u_tex_y_b': new performance$1.aJ(context, locations.u_tex_y_b),
    'u_mix': new performance$1.aJ(context, locations.u_mix)
});
const lineUniformValues = (painter, tile, layer, coord) => {
    const transform = painter.transform;
    return {
        'u_matrix': calculateMatrix(painter, tile, layer, coord),
        'u_ratio': 1 / pixelsToTileUnits(tile, 1, transform.zoom),
        'u_device_pixel_ratio': painter.pixelRatio,
        'u_units_to_pixels': [
            1 / transform.pixelsToGLUnits[0],
            1 / transform.pixelsToGLUnits[1]
        ]
    };
};
const lineGradientUniformValues = (painter, tile, layer, imageHeight, coord) => {
    return performance$1.e(lineUniformValues(painter, tile, layer, coord), {
        'u_image': 0,
        'u_image_height': imageHeight,
    });
};
const linePatternUniformValues = (painter, tile, layer, crossfade, coord) => {
    const transform = painter.transform;
    const tileZoomRatio = calculateTileRatio(tile, transform);
    return {
        'u_matrix': calculateMatrix(painter, tile, layer, coord),
        'u_texsize': tile.imageAtlasTexture.size,
        // camera zoom ratio
        'u_ratio': 1 / pixelsToTileUnits(tile, 1, transform.zoom),
        'u_device_pixel_ratio': painter.pixelRatio,
        'u_image': 0,
        'u_scale': [tileZoomRatio, crossfade.fromScale, crossfade.toScale],
        'u_fade': crossfade.t,
        'u_units_to_pixels': [
            1 / transform.pixelsToGLUnits[0],
            1 / transform.pixelsToGLUnits[1]
        ]
    };
};
const lineSDFUniformValues = (painter, tile, layer, dasharray, crossfade, coord) => {
    const transform = painter.transform;
    const lineAtlas = painter.lineAtlas;
    const tileRatio = calculateTileRatio(tile, transform);
    const round = layer.layout.get('line-cap') === 'round';
    const posA = lineAtlas.getDash(dasharray.from, round);
    const posB = lineAtlas.getDash(dasharray.to, round);
    const widthA = posA.width * crossfade.fromScale;
    const widthB = posB.width * crossfade.toScale;
    return performance$1.e(lineUniformValues(painter, tile, layer, coord), {
        'u_patternscale_a': [tileRatio / widthA, -posA.height / 2],
        'u_patternscale_b': [tileRatio / widthB, -posB.height / 2],
        'u_sdfgamma': lineAtlas.width / (Math.min(widthA, widthB) * 256 * painter.pixelRatio) / 2,
        'u_image': 0,
        'u_tex_y_a': posA.y,
        'u_tex_y_b': posB.y,
        'u_mix': crossfade.t
    });
};
function calculateTileRatio(tile, transform) {
    return 1 / pixelsToTileUnits(tile, 1, transform.tileZoom);
}
function calculateMatrix(painter, tile, layer, coord) {
    return painter.translatePosMatrix(coord ? coord.posMatrix : tile.tileID.posMatrix, tile, layer.paint.get('line-translate'), layer.paint.get('line-translate-anchor'));
}

const rasterUniforms = (context, locations) => ({
    'u_matrix': new performance$1.aK(context, locations.u_matrix),
    'u_tl_parent': new performance$1.aP(context, locations.u_tl_parent),
    'u_scale_parent': new performance$1.aJ(context, locations.u_scale_parent),
    'u_buffer_scale': new performance$1.aJ(context, locations.u_buffer_scale),
    'u_fade_t': new performance$1.aJ(context, locations.u_fade_t),
    'u_opacity': new performance$1.aJ(context, locations.u_opacity),
    'u_image0': new performance$1.aI(context, locations.u_image0),
    'u_image1': new performance$1.aI(context, locations.u_image1),
    'u_brightness_low': new performance$1.aJ(context, locations.u_brightness_low),
    'u_brightness_high': new performance$1.aJ(context, locations.u_brightness_high),
    'u_saturation_factor': new performance$1.aJ(context, locations.u_saturation_factor),
    'u_contrast_factor': new performance$1.aJ(context, locations.u_contrast_factor),
    'u_spin_weights': new performance$1.aO(context, locations.u_spin_weights)
});
const rasterUniformValues = (matrix, parentTL, parentScaleBy, fade, layer) => ({
    'u_matrix': matrix,
    'u_tl_parent': parentTL,
    'u_scale_parent': parentScaleBy,
    'u_buffer_scale': 1,
    'u_fade_t': fade.mix,
    'u_opacity': fade.opacity * layer.paint.get('raster-opacity'),
    'u_image0': 0,
    'u_image1': 1,
    'u_brightness_low': layer.paint.get('raster-brightness-min'),
    'u_brightness_high': layer.paint.get('raster-brightness-max'),
    'u_saturation_factor': saturationFactor(layer.paint.get('raster-saturation')),
    'u_contrast_factor': contrastFactor(layer.paint.get('raster-contrast')),
    'u_spin_weights': spinWeights(layer.paint.get('raster-hue-rotate'))
});
function spinWeights(angle) {
    angle *= Math.PI / 180;
    const s = Math.sin(angle);
    const c = Math.cos(angle);
    return [
        (2 * c + 1) / 3,
        (-Math.sqrt(3) * s - c + 1) / 3,
        (Math.sqrt(3) * s - c + 1) / 3
    ];
}
function contrastFactor(contrast) {
    return contrast > 0 ?
        1 / (1 - contrast) :
        1 + contrast;
}
function saturationFactor(saturation) {
    return saturation > 0 ?
        1 - 1 / (1.001 - saturation) :
        -saturation;
}

const symbolIconUniforms = (context, locations) => ({
    'u_is_size_zoom_constant': new performance$1.aI(context, locations.u_is_size_zoom_constant),
    'u_is_size_feature_constant': new performance$1.aI(context, locations.u_is_size_feature_constant),
    'u_size_t': new performance$1.aJ(context, locations.u_size_t),
    'u_size': new performance$1.aJ(context, locations.u_size),
    'u_camera_to_center_distance': new performance$1.aJ(context, locations.u_camera_to_center_distance),
    'u_pitch': new performance$1.aJ(context, locations.u_pitch),
    'u_rotate_symbol': new performance$1.aI(context, locations.u_rotate_symbol),
    'u_aspect_ratio': new performance$1.aJ(context, locations.u_aspect_ratio),
    'u_fade_change': new performance$1.aJ(context, locations.u_fade_change),
    'u_matrix': new performance$1.aK(context, locations.u_matrix),
    'u_label_plane_matrix': new performance$1.aK(context, locations.u_label_plane_matrix),
    'u_coord_matrix': new performance$1.aK(context, locations.u_coord_matrix),
    'u_is_text': new performance$1.aI(context, locations.u_is_text),
    'u_pitch_with_map': new performance$1.aI(context, locations.u_pitch_with_map),
    'u_is_along_line': new performance$1.aI(context, locations.u_is_along_line),
    'u_is_variable_anchor': new performance$1.aI(context, locations.u_is_variable_anchor),
    'u_texsize': new performance$1.aP(context, locations.u_texsize),
    'u_texture': new performance$1.aI(context, locations.u_texture),
    'u_translation': new performance$1.aP(context, locations.u_translation),
    'u_pitched_scale': new performance$1.aJ(context, locations.u_pitched_scale),
});
const symbolSDFUniforms = (context, locations) => ({
    'u_is_size_zoom_constant': new performance$1.aI(context, locations.u_is_size_zoom_constant),
    'u_is_size_feature_constant': new performance$1.aI(context, locations.u_is_size_feature_constant),
    'u_size_t': new performance$1.aJ(context, locations.u_size_t),
    'u_size': new performance$1.aJ(context, locations.u_size),
    'u_camera_to_center_distance': new performance$1.aJ(context, locations.u_camera_to_center_distance),
    'u_pitch': new performance$1.aJ(context, locations.u_pitch),
    'u_rotate_symbol': new performance$1.aI(context, locations.u_rotate_symbol),
    'u_aspect_ratio': new performance$1.aJ(context, locations.u_aspect_ratio),
    'u_fade_change': new performance$1.aJ(context, locations.u_fade_change),
    'u_matrix': new performance$1.aK(context, locations.u_matrix),
    'u_label_plane_matrix': new performance$1.aK(context, locations.u_label_plane_matrix),
    'u_coord_matrix': new performance$1.aK(context, locations.u_coord_matrix),
    'u_is_text': new performance$1.aI(context, locations.u_is_text),
    'u_pitch_with_map': new performance$1.aI(context, locations.u_pitch_with_map),
    'u_is_along_line': new performance$1.aI(context, locations.u_is_along_line),
    'u_is_variable_anchor': new performance$1.aI(context, locations.u_is_variable_anchor),
    'u_texsize': new performance$1.aP(context, locations.u_texsize),
    'u_texture': new performance$1.aI(context, locations.u_texture),
    'u_gamma_scale': new performance$1.aJ(context, locations.u_gamma_scale),
    'u_device_pixel_ratio': new performance$1.aJ(context, locations.u_device_pixel_ratio),
    'u_is_halo': new performance$1.aI(context, locations.u_is_halo),
    'u_translation': new performance$1.aP(context, locations.u_translation),
    'u_pitched_scale': new performance$1.aJ(context, locations.u_pitched_scale),
});
const symbolTextAndIconUniforms = (context, locations) => ({
    'u_is_size_zoom_constant': new performance$1.aI(context, locations.u_is_size_zoom_constant),
    'u_is_size_feature_constant': new performance$1.aI(context, locations.u_is_size_feature_constant),
    'u_size_t': new performance$1.aJ(context, locations.u_size_t),
    'u_size': new performance$1.aJ(context, locations.u_size),
    'u_camera_to_center_distance': new performance$1.aJ(context, locations.u_camera_to_center_distance),
    'u_pitch': new performance$1.aJ(context, locations.u_pitch),
    'u_rotate_symbol': new performance$1.aI(context, locations.u_rotate_symbol),
    'u_aspect_ratio': new performance$1.aJ(context, locations.u_aspect_ratio),
    'u_fade_change': new performance$1.aJ(context, locations.u_fade_change),
    'u_matrix': new performance$1.aK(context, locations.u_matrix),
    'u_label_plane_matrix': new performance$1.aK(context, locations.u_label_plane_matrix),
    'u_coord_matrix': new performance$1.aK(context, locations.u_coord_matrix),
    'u_is_text': new performance$1.aI(context, locations.u_is_text),
    'u_pitch_with_map': new performance$1.aI(context, locations.u_pitch_with_map),
    'u_is_along_line': new performance$1.aI(context, locations.u_is_along_line),
    'u_is_variable_anchor': new performance$1.aI(context, locations.u_is_variable_anchor),
    'u_texsize': new performance$1.aP(context, locations.u_texsize),
    'u_texsize_icon': new performance$1.aP(context, locations.u_texsize_icon),
    'u_texture': new performance$1.aI(context, locations.u_texture),
    'u_texture_icon': new performance$1.aI(context, locations.u_texture_icon),
    'u_gamma_scale': new performance$1.aJ(context, locations.u_gamma_scale),
    'u_device_pixel_ratio': new performance$1.aJ(context, locations.u_device_pixel_ratio),
    'u_is_halo': new performance$1.aI(context, locations.u_is_halo),
    'u_translation': new performance$1.aP(context, locations.u_translation),
    'u_pitched_scale': new performance$1.aJ(context, locations.u_pitched_scale),
});
const symbolIconUniformValues = (functionType, size, rotateInShader, pitchWithMap, isAlongLine, isVariableAnchor, painter, matrix, labelPlaneMatrix, glCoordMatrix, translation, isText, texSize, pitchedScale) => {
    const transform = painter.transform;
    return {
        'u_is_size_zoom_constant': +(functionType === 'constant' || functionType === 'source'),
        'u_is_size_feature_constant': +(functionType === 'constant' || functionType === 'camera'),
        'u_size_t': size ? size.uSizeT : 0,
        'u_size': size ? size.uSize : 0,
        'u_camera_to_center_distance': transform.cameraToCenterDistance,
        'u_pitch': transform.pitch / 360 * 2 * Math.PI,
        'u_rotate_symbol': +rotateInShader,
        'u_aspect_ratio': transform.width / transform.height,
        'u_fade_change': painter.options.fadeDuration ? painter.symbolFadeChange : 1,
        'u_matrix': matrix,
        'u_label_plane_matrix': labelPlaneMatrix,
        'u_coord_matrix': glCoordMatrix,
        'u_is_text': +isText,
        'u_pitch_with_map': +pitchWithMap,
        'u_is_along_line': isAlongLine,
        'u_is_variable_anchor': isVariableAnchor,
        'u_texsize': texSize,
        'u_texture': 0,
        'u_translation': translation,
        'u_pitched_scale': pitchedScale
    };
};
const symbolSDFUniformValues = (functionType, size, rotateInShader, pitchWithMap, isAlongLine, isVariableAnchor, painter, matrix, labelPlaneMatrix, glCoordMatrix, translation, isText, texSize, isHalo, pitchedScale) => {
    const transform = painter.transform;
    return performance$1.e(symbolIconUniformValues(functionType, size, rotateInShader, pitchWithMap, isAlongLine, isVariableAnchor, painter, matrix, labelPlaneMatrix, glCoordMatrix, translation, isText, texSize, pitchedScale), {
        'u_gamma_scale': (pitchWithMap ? Math.cos(transform._pitch) * transform.cameraToCenterDistance : 1),
        'u_device_pixel_ratio': painter.pixelRatio,
        'u_is_halo': +isHalo
    });
};
const symbolTextAndIconUniformValues = (functionType, size, rotateInShader, pitchWithMap, isAlongLine, isVariableAnchor, painter, matrix, labelPlaneMatrix, glCoordMatrix, translation, texSizeSDF, texSizeIcon, pitchedScale) => {
    return performance$1.e(symbolSDFUniformValues(functionType, size, rotateInShader, pitchWithMap, isAlongLine, isVariableAnchor, painter, matrix, labelPlaneMatrix, glCoordMatrix, translation, true, texSizeSDF, true, pitchedScale), {
        'u_texsize_icon': texSizeIcon,
        'u_texture_icon': 1
    });
};

const backgroundUniforms = (context, locations) => ({
    'u_matrix': new performance$1.aK(context, locations.u_matrix),
    'u_opacity': new performance$1.aJ(context, locations.u_opacity),
    'u_color': new performance$1.aM(context, locations.u_color)
});
const backgroundPatternUniforms = (context, locations) => ({
    'u_matrix': new performance$1.aK(context, locations.u_matrix),
    'u_opacity': new performance$1.aJ(context, locations.u_opacity),
    'u_image': new performance$1.aI(context, locations.u_image),
    'u_pattern_tl_a': new performance$1.aP(context, locations.u_pattern_tl_a),
    'u_pattern_br_a': new performance$1.aP(context, locations.u_pattern_br_a),
    'u_pattern_tl_b': new performance$1.aP(context, locations.u_pattern_tl_b),
    'u_pattern_br_b': new performance$1.aP(context, locations.u_pattern_br_b),
    'u_texsize': new performance$1.aP(context, locations.u_texsize),
    'u_mix': new performance$1.aJ(context, locations.u_mix),
    'u_pattern_size_a': new performance$1.aP(context, locations.u_pattern_size_a),
    'u_pattern_size_b': new performance$1.aP(context, locations.u_pattern_size_b),
    'u_scale_a': new performance$1.aJ(context, locations.u_scale_a),
    'u_scale_b': new performance$1.aJ(context, locations.u_scale_b),
    'u_pixel_coord_upper': new performance$1.aP(context, locations.u_pixel_coord_upper),
    'u_pixel_coord_lower': new performance$1.aP(context, locations.u_pixel_coord_lower),
    'u_tile_units_to_pixels': new performance$1.aJ(context, locations.u_tile_units_to_pixels)
});
const backgroundUniformValues = (matrix, opacity, color) => ({
    'u_matrix': matrix,
    'u_opacity': opacity,
    'u_color': color
});
const backgroundPatternUniformValues = (matrix, opacity, painter, image, tile, crossfade) => performance$1.e(bgPatternUniformValues(image, crossfade, painter, tile), {
    'u_matrix': matrix,
    'u_opacity': opacity
});

const skyUniforms = (context, locations) => ({
    'u_sky_color': new performance$1.aM(context, locations.u_sky_color),
    'u_horizon_color': new performance$1.aM(context, locations.u_horizon_color),
    'u_horizon': new performance$1.aJ(context, locations.u_horizon),
    'u_sky_horizon_blend': new performance$1.aJ(context, locations.u_sky_horizon_blend),
});
const skyUniformValues = (sky, transform, pixelRatio) => ({
    'u_sky_color': sky.properties.get('sky-color'),
    'u_horizon_color': sky.properties.get('horizon-color'),
    'u_horizon': (transform.height / 2 + transform.getHorizon()) * pixelRatio,
    'u_sky_horizon_blend': (sky.properties.get('sky-horizon-blend') * transform.height / 2) * pixelRatio,
});

const programUniforms = {
    fillExtrusion: fillExtrusionUniforms,
    fillExtrusionPattern: fillExtrusionPatternUniforms,
    fill: fillUniforms,
    fillPattern: fillPatternUniforms,
    fillOutline: fillOutlineUniforms,
    fillOutlinePattern: fillOutlinePatternUniforms,
    circle: circleUniforms,
    collisionBox: collisionUniforms,
    collisionCircle: collisionCircleUniforms,
    debug: debugUniforms,
    clippingMask: clippingMaskUniforms,
    heatmap: heatmapUniforms,
    heatmapTexture: heatmapTextureUniforms,
    hillshade: hillshadeUniforms,
    hillshadePrepare: hillshadePrepareUniforms,
    line: lineUniforms,
    lineGradient: lineGradientUniforms,
    linePattern: linePatternUniforms,
    lineSDF: lineSDFUniforms,
    raster: rasterUniforms,
    symbolIcon: symbolIconUniforms,
    symbolSDF: symbolSDFUniforms,
    symbolTextAndIcon: symbolTextAndIconUniforms,
    background: backgroundUniforms,
    backgroundPattern: backgroundPatternUniforms,
    terrain: terrainUniforms,
    terrainDepth: terrainDepthUniforms,
    terrainCoords: terrainCoordsUniforms,
    sky: skyUniforms
};

/**
 * @internal
 * an index buffer class
 */
class IndexBuffer {
    constructor(context, array, dynamicDraw) {
        this.context = context;
        const gl = context.gl;
        this.buffer = gl.createBuffer();
        this.dynamicDraw = Boolean(dynamicDraw);
        // The bound index buffer is part of vertex array object state. We don't want to
        // modify whatever VAO happens to be currently bound, so make sure the default
        // vertex array provided by the context is bound instead.
        this.context.unbindVAO();
        context.bindElementBuffer.set(this.buffer);
        gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, array.arrayBuffer, this.dynamicDraw ? gl.DYNAMIC_DRAW : gl.STATIC_DRAW);
        if (!this.dynamicDraw) {
            delete array.arrayBuffer;
        }
    }
    bind() {
        this.context.bindElementBuffer.set(this.buffer);
    }
    updateData(array) {
        const gl = this.context.gl;
        if (!this.dynamicDraw)
            throw new Error('Attempted to update data while not in dynamic mode.');
        // The right VAO will get this buffer re-bound later in VertexArrayObject#bind
        // See https://github.com/mapbox/mapbox-gl-js/issues/5620
        this.context.unbindVAO();
        this.bind();
        gl.bufferSubData(gl.ELEMENT_ARRAY_BUFFER, 0, array.arrayBuffer);
    }
    destroy() {
        const gl = this.context.gl;
        if (this.buffer) {
            gl.deleteBuffer(this.buffer);
            delete this.buffer;
        }
    }
}

/**
 * An Enum for AttributeType
 */
const AttributeType = {
    Int8: 'BYTE',
    Uint8: 'UNSIGNED_BYTE',
    Int16: 'SHORT',
    Uint16: 'UNSIGNED_SHORT',
    Int32: 'INT',
    Uint32: 'UNSIGNED_INT',
    Float32: 'FLOAT'
};
/**
 * @internal
 * The `VertexBuffer` class turns a `StructArray` into a WebGL buffer. Each member of the StructArray's
 * Struct type is converted to a WebGL attribute.
 */
class VertexBuffer {
    /**
     * @param dynamicDraw - Whether this buffer will be repeatedly updated.
     */
    constructor(context, array, attributes, dynamicDraw) {
        this.length = array.length;
        this.attributes = attributes;
        this.itemSize = array.bytesPerElement;
        this.dynamicDraw = dynamicDraw;
        this.context = context;
        const gl = context.gl;
        this.buffer = gl.createBuffer();
        context.bindVertexBuffer.set(this.buffer);
        gl.bufferData(gl.ARRAY_BUFFER, array.arrayBuffer, this.dynamicDraw ? gl.DYNAMIC_DRAW : gl.STATIC_DRAW);
        if (!this.dynamicDraw) {
            delete array.arrayBuffer;
        }
    }
    bind() {
        this.context.bindVertexBuffer.set(this.buffer);
    }
    updateData(array) {
        if (array.length !== this.length)
            throw new Error(`Length of new data is ${array.length}, which doesn't match current length of ${this.length}`);
        const gl = this.context.gl;
        this.bind();
        gl.bufferSubData(gl.ARRAY_BUFFER, 0, array.arrayBuffer);
    }
    enableAttributes(gl, program) {
        for (let j = 0; j < this.attributes.length; j++) {
            const member = this.attributes[j];
            const attribIndex = program.attributes[member.name];
            if (attribIndex !== undefined) {
                gl.enableVertexAttribArray(attribIndex);
            }
        }
    }
    /**
     * Set the attribute pointers in a WebGL context
     * @param gl - The WebGL context
     * @param program - The active WebGL program
     * @param vertexOffset - Index of the starting vertex of the segment
     */
    setVertexAttribPointers(gl, program, vertexOffset) {
        for (let j = 0; j < this.attributes.length; j++) {
            const member = this.attributes[j];
            const attribIndex = program.attributes[member.name];
            if (attribIndex !== undefined) {
                gl.vertexAttribPointer(attribIndex, member.components, gl[AttributeType[member.type]], false, this.itemSize, member.offset + (this.itemSize * (vertexOffset || 0)));
            }
        }
    }
    /**
     * Destroy the GL buffer bound to the given WebGL context
     */
    destroy() {
        const gl = this.context.gl;
        if (this.buffer) {
            gl.deleteBuffer(this.buffer);
            delete this.buffer;
        }
    }
}

const cache = new WeakMap();
function isWebGL2(gl) {
    var _a;
    if (cache.has(gl)) {
        return cache.get(gl);
    }
    else {
        const value = (_a = gl.getParameter(gl.VERSION)) === null || _a === void 0 ? void 0 : _a.startsWith('WebGL 2.0');
        cache.set(gl, value);
        return value;
    }
}

class BaseValue {
    constructor(context) {
        this.gl = context.gl;
        this.default = this.getDefault();
        this.current = this.default;
        this.dirty = false;
    }
    get() {
        return this.current;
    }
    set(value) {
        // overridden in child classes;
    }
    getDefault() {
        return this.default; // overridden in child classes
    }
    setDefault() {
        this.set(this.default);
    }
}
class ClearColor extends BaseValue {
    getDefault() {
        return performance$1.aN.transparent;
    }
    set(v) {
        const c = this.current;
        if (v.r === c.r && v.g === c.g && v.b === c.b && v.a === c.a && !this.dirty)
            return;
        this.gl.clearColor(v.r, v.g, v.b, v.a);
        this.current = v;
        this.dirty = false;
    }
}
class ClearDepth extends BaseValue {
    getDefault() {
        return 1;
    }
    set(v) {
        if (v === this.current && !this.dirty)
            return;
        this.gl.clearDepth(v);
        this.current = v;
        this.dirty = false;
    }
}
class ClearStencil extends BaseValue {
    getDefault() {
        return 0;
    }
    set(v) {
        if (v === this.current && !this.dirty)
            return;
        this.gl.clearStencil(v);
        this.current = v;
        this.dirty = false;
    }
}
class ColorMask extends BaseValue {
    getDefault() {
        return [true, true, true, true];
    }
    set(v) {
        const c = this.current;
        if (v[0] === c[0] && v[1] === c[1] && v[2] === c[2] && v[3] === c[3] && !this.dirty)
            return;
        this.gl.colorMask(v[0], v[1], v[2], v[3]);
        this.current = v;
        this.dirty = false;
    }
}
class DepthMask extends BaseValue {
    getDefault() {
        return true;
    }
    set(v) {
        if (v === this.current && !this.dirty)
            return;
        this.gl.depthMask(v);
        this.current = v;
        this.dirty = false;
    }
}
class StencilMask extends BaseValue {
    getDefault() {
        return 0xFF;
    }
    set(v) {
        if (v === this.current && !this.dirty)
            return;
        this.gl.stencilMask(v);
        this.current = v;
        this.dirty = false;
    }
}
class StencilFunc extends BaseValue {
    getDefault() {
        return {
            func: this.gl.ALWAYS,
            ref: 0,
            mask: 0xFF
        };
    }
    set(v) {
        const c = this.current;
        if (v.func === c.func && v.ref === c.ref && v.mask === c.mask && !this.dirty)
            return;
        this.gl.stencilFunc(v.func, v.ref, v.mask);
        this.current = v;
        this.dirty = false;
    }
}
class StencilOp extends BaseValue {
    getDefault() {
        const gl = this.gl;
        return [gl.KEEP, gl.KEEP, gl.KEEP];
    }
    set(v) {
        const c = this.current;
        if (v[0] === c[0] && v[1] === c[1] && v[2] === c[2] && !this.dirty)
            return;
        this.gl.stencilOp(v[0], v[1], v[2]);
        this.current = v;
        this.dirty = false;
    }
}
class StencilTest extends BaseValue {
    getDefault() {
        return false;
    }
    set(v) {
        if (v === this.current && !this.dirty)
            return;
        const gl = this.gl;
        if (v) {
            gl.enable(gl.STENCIL_TEST);
        }
        else {
            gl.disable(gl.STENCIL_TEST);
        }
        this.current = v;
        this.dirty = false;
    }
}
class DepthRange extends BaseValue {
    getDefault() {
        return [0, 1];
    }
    set(v) {
        const c = this.current;
        if (v[0] === c[0] && v[1] === c[1] && !this.dirty)
            return;
        this.gl.depthRange(v[0], v[1]);
        this.current = v;
        this.dirty = false;
    }
}
class DepthTest extends BaseValue {
    getDefault() {
        return false;
    }
    set(v) {
        if (v === this.current && !this.dirty)
            return;
        const gl = this.gl;
        if (v) {
            gl.enable(gl.DEPTH_TEST);
        }
        else {
            gl.disable(gl.DEPTH_TEST);
        }
        this.current = v;
        this.dirty = false;
    }
}
class DepthFunc extends BaseValue {
    getDefault() {
        return this.gl.LESS;
    }
    set(v) {
        if (v === this.current && !this.dirty)
            return;
        this.gl.depthFunc(v);
        this.current = v;
        this.dirty = false;
    }
}
class Blend extends BaseValue {
    getDefault() {
        return false;
    }
    set(v) {
        if (v === this.current && !this.dirty)
            return;
        const gl = this.gl;
        if (v) {
            gl.enable(gl.BLEND);
        }
        else {
            gl.disable(gl.BLEND);
        }
        this.current = v;
        this.dirty = false;
    }
}
class BlendFunc extends BaseValue {
    getDefault() {
        const gl = this.gl;
        return [gl.ONE, gl.ZERO];
    }
    set(v) {
        const c = this.current;
        if (v[0] === c[0] && v[1] === c[1] && !this.dirty)
            return;
        this.gl.blendFunc(v[0], v[1]);
        this.current = v;
        this.dirty = false;
    }
}
class BlendColor extends BaseValue {
    getDefault() {
        return performance$1.aN.transparent;
    }
    set(v) {
        const c = this.current;
        if (v.r === c.r && v.g === c.g && v.b === c.b && v.a === c.a && !this.dirty)
            return;
        this.gl.blendColor(v.r, v.g, v.b, v.a);
        this.current = v;
        this.dirty = false;
    }
}
class BlendEquation extends BaseValue {
    getDefault() {
        return this.gl.FUNC_ADD;
    }
    set(v) {
        if (v === this.current && !this.dirty)
            return;
        this.gl.blendEquation(v);
        this.current = v;
        this.dirty = false;
    }
}
class CullFace extends BaseValue {
    getDefault() {
        return false;
    }
    set(v) {
        if (v === this.current && !this.dirty)
            return;
        const gl = this.gl;
        if (v) {
            gl.enable(gl.CULL_FACE);
        }
        else {
            gl.disable(gl.CULL_FACE);
        }
        this.current = v;
        this.dirty = false;
    }
}
class CullFaceSide extends BaseValue {
    getDefault() {
        return this.gl.BACK;
    }
    set(v) {
        if (v === this.current && !this.dirty)
            return;
        this.gl.cullFace(v);
        this.current = v;
        this.dirty = false;
    }
}
class FrontFace extends BaseValue {
    getDefault() {
        return this.gl.CCW;
    }
    set(v) {
        if (v === this.current && !this.dirty)
            return;
        this.gl.frontFace(v);
        this.current = v;
        this.dirty = false;
    }
}
class ProgramValue extends BaseValue {
    getDefault() {
        return null;
    }
    set(v) {
        if (v === this.current && !this.dirty)
            return;
        this.gl.useProgram(v);
        this.current = v;
        this.dirty = false;
    }
}
class ActiveTextureUnit extends BaseValue {
    getDefault() {
        return this.gl.TEXTURE0;
    }
    set(v) {
        if (v === this.current && !this.dirty)
            return;
        this.gl.activeTexture(v);
        this.current = v;
        this.dirty = false;
    }
}
class Viewport extends BaseValue {
    getDefault() {
        const gl = this.gl;
        return [0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight];
    }
    set(v) {
        const c = this.current;
        if (v[0] === c[0] && v[1] === c[1] && v[2] === c[2] && v[3] === c[3] && !this.dirty)
            return;
        this.gl.viewport(v[0], v[1], v[2], v[3]);
        this.current = v;
        this.dirty = false;
    }
}
class BindFramebuffer extends BaseValue {
    getDefault() {
        return null;
    }
    set(v) {
        if (v === this.current && !this.dirty)
            return;
        const gl = this.gl;
        gl.bindFramebuffer(gl.FRAMEBUFFER, v);
        this.current = v;
        this.dirty = false;
    }
}
class BindRenderbuffer extends BaseValue {
    getDefault() {
        return null;
    }
    set(v) {
        if (v === this.current && !this.dirty)
            return;
        const gl = this.gl;
        gl.bindRenderbuffer(gl.RENDERBUFFER, v);
        this.current = v;
        this.dirty = false;
    }
}
class BindTexture extends BaseValue {
    getDefault() {
        return null;
    }
    set(v) {
        if (v === this.current && !this.dirty)
            return;
        const gl = this.gl;
        gl.bindTexture(gl.TEXTURE_2D, v);
        this.current = v;
        this.dirty = false;
    }
}
class BindVertexBuffer extends BaseValue {
    getDefault() {
        return null;
    }
    set(v) {
        if (v === this.current && !this.dirty)
            return;
        const gl = this.gl;
        gl.bindBuffer(gl.ARRAY_BUFFER, v);
        this.current = v;
        this.dirty = false;
    }
}
class BindElementBuffer extends BaseValue {
    getDefault() {
        return null;
    }
    set(v) {
        // Always rebind
        const gl = this.gl;
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, v);
        this.current = v;
        this.dirty = false;
    }
}
class BindVertexArray extends BaseValue {
    getDefault() {
        return null;
    }
    set(v) {
        var _a;
        if (v === this.current && !this.dirty)
            return;
        const gl = this.gl;
        if (isWebGL2(gl)) {
            gl.bindVertexArray(v);
        }
        else {
            (_a = gl.getExtension('OES_vertex_array_object')) === null || _a === void 0 ? void 0 : _a.bindVertexArrayOES(v);
        }
        this.current = v;
        this.dirty = false;
    }
}
class PixelStoreUnpack extends BaseValue {
    getDefault() {
        return 4;
    }
    set(v) {
        if (v === this.current && !this.dirty)
            return;
        const gl = this.gl;
        gl.pixelStorei(gl.UNPACK_ALIGNMENT, v);
        this.current = v;
        this.dirty = false;
    }
}
class PixelStoreUnpackPremultiplyAlpha extends BaseValue {
    getDefault() {
        return false;
    }
    set(v) {
        if (v === this.current && !this.dirty)
            return;
        const gl = this.gl;
        gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, v);
        this.current = v;
        this.dirty = false;
    }
}
class PixelStoreUnpackFlipY extends BaseValue {
    getDefault() {
        return false;
    }
    set(v) {
        if (v === this.current && !this.dirty)
            return;
        const gl = this.gl;
        gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, v);
        this.current = v;
        this.dirty = false;
    }
}
class FramebufferAttachment extends BaseValue {
    constructor(context, parent) {
        super(context);
        this.context = context;
        this.parent = parent;
    }
    getDefault() {
        return null;
    }
}
class ColorAttachment extends FramebufferAttachment {
    setDirty() {
        this.dirty = true;
    }
    set(v) {
        if (v === this.current && !this.dirty)
            return;
        this.context.bindFramebuffer.set(this.parent);
        // note: it's possible to attach a renderbuffer to the color
        // attachment point, but thus far MBGL only uses textures for color
        const gl = this.gl;
        gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, v, 0);
        this.current = v;
        this.dirty = false;
    }
}
class DepthAttachment extends FramebufferAttachment {
    set(v) {
        if (v === this.current && !this.dirty)
            return;
        this.context.bindFramebuffer.set(this.parent);
        // note: it's possible to attach a texture to the depth attachment
        // point, but thus far MBGL only uses renderbuffers for depth
        const gl = this.gl;
        gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.DEPTH_ATTACHMENT, gl.RENDERBUFFER, v);
        this.current = v;
        this.dirty = false;
    }
}
class DepthStencilAttachment extends FramebufferAttachment {
    set(v) {
        if (v === this.current && !this.dirty)
            return;
        this.context.bindFramebuffer.set(this.parent);
        // note: it's possible to attach a texture to the depth attachment
        // point, but thus far MBGL only uses renderbuffers for depth
        const gl = this.gl;
        gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.DEPTH_STENCIL_ATTACHMENT, gl.RENDERBUFFER, v);
        this.current = v;
        this.dirty = false;
    }
}

/**
 * @internal
 * A framebuffer holder object
 */
class Framebuffer {
    constructor(context, width, height, hasDepth, hasStencil) {
        this.context = context;
        this.width = width;
        this.height = height;
        const gl = context.gl;
        const fbo = this.framebuffer = gl.createFramebuffer();
        this.colorAttachment = new ColorAttachment(context, fbo);
        if (hasDepth) {
            this.depthAttachment = hasStencil ? new DepthStencilAttachment(context, fbo) : new DepthAttachment(context, fbo);
        }
        else if (hasStencil) {
            throw new Error('Stencil cannot be set without depth');
        }
        if (gl.checkFramebufferStatus(gl.FRAMEBUFFER) !== gl.FRAMEBUFFER_COMPLETE) {
            throw new Error('Framebuffer is not complete');
        }
    }
    destroy() {
        const gl = this.context.gl;
        const texture = this.colorAttachment.get();
        if (texture)
            gl.deleteTexture(texture);
        if (this.depthAttachment) {
            const renderbuffer = this.depthAttachment.get();
            if (renderbuffer)
                gl.deleteRenderbuffer(renderbuffer);
        }
        gl.deleteFramebuffer(this.framebuffer);
    }
}

const ZERO = 0x0000;
const ONE = 0x0001;
const ONE_MINUS_SRC_ALPHA = 0x0303;
class ColorMode {
    constructor(blendFunction, blendColor, mask) {
        this.blendFunction = blendFunction;
        this.blendColor = blendColor;
        this.mask = mask;
    }
}
ColorMode.Replace = [ONE, ZERO];
ColorMode.disabled = new ColorMode(ColorMode.Replace, performance$1.aN.transparent, [false, false, false, false]);
ColorMode.unblended = new ColorMode(ColorMode.Replace, performance$1.aN.transparent, [true, true, true, true]);
ColorMode.alphaBlended = new ColorMode([ONE, ONE_MINUS_SRC_ALPHA], performance$1.aN.transparent, [true, true, true, true]);

/**
 * @internal
 * A webgl wrapper class to allow injection, mocking and abstaction
 */
class Context {
    constructor(gl) {
        var _a, _b;
        this.gl = gl;
        this.clearColor = new ClearColor(this);
        this.clearDepth = new ClearDepth(this);
        this.clearStencil = new ClearStencil(this);
        this.colorMask = new ColorMask(this);
        this.depthMask = new DepthMask(this);
        this.stencilMask = new StencilMask(this);
        this.stencilFunc = new StencilFunc(this);
        this.stencilOp = new StencilOp(this);
        this.stencilTest = new StencilTest(this);
        this.depthRange = new DepthRange(this);
        this.depthTest = new DepthTest(this);
        this.depthFunc = new DepthFunc(this);
        this.blend = new Blend(this);
        this.blendFunc = new BlendFunc(this);
        this.blendColor = new BlendColor(this);
        this.blendEquation = new BlendEquation(this);
        this.cullFace = new CullFace(this);
        this.cullFaceSide = new CullFaceSide(this);
        this.frontFace = new FrontFace(this);
        this.program = new ProgramValue(this);
        this.activeTexture = new ActiveTextureUnit(this);
        this.viewport = new Viewport(this);
        this.bindFramebuffer = new BindFramebuffer(this);
        this.bindRenderbuffer = new BindRenderbuffer(this);
        this.bindTexture = new BindTexture(this);
        this.bindVertexBuffer = new BindVertexBuffer(this);
        this.bindElementBuffer = new BindElementBuffer(this);
        this.bindVertexArray = new BindVertexArray(this);
        this.pixelStoreUnpack = new PixelStoreUnpack(this);
        this.pixelStoreUnpackPremultiplyAlpha = new PixelStoreUnpackPremultiplyAlpha(this);
        this.pixelStoreUnpackFlipY = new PixelStoreUnpackFlipY(this);
        this.extTextureFilterAnisotropic = (gl.getExtension('EXT_texture_filter_anisotropic') ||
            gl.getExtension('MOZ_EXT_texture_filter_anisotropic') ||
            gl.getExtension('WEBKIT_EXT_texture_filter_anisotropic'));
        if (this.extTextureFilterAnisotropic) {
            this.extTextureFilterAnisotropicMax = gl.getParameter(this.extTextureFilterAnisotropic.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
        }
        this.maxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE);
        if (isWebGL2(gl)) {
            this.HALF_FLOAT = gl.HALF_FLOAT;
            const extColorBufferHalfFloat = gl.getExtension('EXT_color_buffer_half_float');
            this.RGBA16F = (_a = gl.RGBA16F) !== null && _a !== void 0 ? _a : extColorBufferHalfFloat === null || extColorBufferHalfFloat === void 0 ? void 0 : extColorBufferHalfFloat.RGBA16F_EXT;
            this.RGB16F = (_b = gl.RGB16F) !== null && _b !== void 0 ? _b : extColorBufferHalfFloat === null || extColorBufferHalfFloat === void 0 ? void 0 : extColorBufferHalfFloat.RGB16F_EXT;
            gl.getExtension('EXT_color_buffer_float');
        }
        else {
            gl.getExtension('EXT_color_buffer_half_float');
            gl.getExtension('OES_texture_half_float_linear');
            const extTextureHalfFloat = gl.getExtension('OES_texture_half_float');
            this.HALF_FLOAT = extTextureHalfFloat === null || extTextureHalfFloat === void 0 ? void 0 : extTextureHalfFloat.HALF_FLOAT_OES;
        }
    }
    setDefault() {
        this.unbindVAO();
        this.clearColor.setDefault();
        this.clearDepth.setDefault();
        this.clearStencil.setDefault();
        this.colorMask.setDefault();
        this.depthMask.setDefault();
        this.stencilMask.setDefault();
        this.stencilFunc.setDefault();
        this.stencilOp.setDefault();
        this.stencilTest.setDefault();
        this.depthRange.setDefault();
        this.depthTest.setDefault();
        this.depthFunc.setDefault();
        this.blend.setDefault();
        this.blendFunc.setDefault();
        this.blendColor.setDefault();
        this.blendEquation.setDefault();
        this.cullFace.setDefault();
        this.cullFaceSide.setDefault();
        this.frontFace.setDefault();
        this.program.setDefault();
        this.activeTexture.setDefault();
        this.bindFramebuffer.setDefault();
        this.pixelStoreUnpack.setDefault();
        this.pixelStoreUnpackPremultiplyAlpha.setDefault();
        this.pixelStoreUnpackFlipY.setDefault();
    }
    setDirty() {
        this.clearColor.dirty = true;
        this.clearDepth.dirty = true;
        this.clearStencil.dirty = true;
        this.colorMask.dirty = true;
        this.depthMask.dirty = true;
        this.stencilMask.dirty = true;
        this.stencilFunc.dirty = true;
        this.stencilOp.dirty = true;
        this.stencilTest.dirty = true;
        this.depthRange.dirty = true;
        this.depthTest.dirty = true;
        this.depthFunc.dirty = true;
        this.blend.dirty = true;
        this.blendFunc.dirty = true;
        this.blendColor.dirty = true;
        this.blendEquation.dirty = true;
        this.cullFace.dirty = true;
        this.cullFaceSide.dirty = true;
        this.frontFace.dirty = true;
        this.program.dirty = true;
        this.activeTexture.dirty = true;
        this.viewport.dirty = true;
        this.bindFramebuffer.dirty = true;
        this.bindRenderbuffer.dirty = true;
        this.bindTexture.dirty = true;
        this.bindVertexBuffer.dirty = true;
        this.bindElementBuffer.dirty = true;
        this.bindVertexArray.dirty = true;
        this.pixelStoreUnpack.dirty = true;
        this.pixelStoreUnpackPremultiplyAlpha.dirty = true;
        this.pixelStoreUnpackFlipY.dirty = true;
    }
    createIndexBuffer(array, dynamicDraw) {
        return new IndexBuffer(this, array, dynamicDraw);
    }
    createVertexBuffer(array, attributes, dynamicDraw) {
        return new VertexBuffer(this, array, attributes, dynamicDraw);
    }
    createRenderbuffer(storageFormat, width, height) {
        const gl = this.gl;
        const rbo = gl.createRenderbuffer();
        this.bindRenderbuffer.set(rbo);
        gl.renderbufferStorage(gl.RENDERBUFFER, storageFormat, width, height);
        this.bindRenderbuffer.set(null);
        return rbo;
    }
    createFramebuffer(width, height, hasDepth, hasStencil) {
        return new Framebuffer(this, width, height, hasDepth, hasStencil);
    }
    clear({ color, depth, stencil }) {
        const gl = this.gl;
        let mask = 0;
        if (color) {
            mask |= gl.COLOR_BUFFER_BIT;
            this.clearColor.set(color);
            this.colorMask.set([true, true, true, true]);
        }
        if (typeof depth !== 'undefined') {
            mask |= gl.DEPTH_BUFFER_BIT;
            // Workaround for platforms where clearDepth doesn't seem to work
            // without resetting the depthRange. See https://github.com/mapbox/mapbox-gl-js/issues/3437
            this.depthRange.set([0, 1]);
            this.clearDepth.set(depth);
            this.depthMask.set(true);
        }
        if (typeof stencil !== 'undefined') {
            mask |= gl.STENCIL_BUFFER_BIT;
            this.clearStencil.set(stencil);
            this.stencilMask.set(0xFF);
        }
        gl.clear(mask);
    }
    setCullFace(cullFaceMode) {
        if (cullFaceMode.enable === false) {
            this.cullFace.set(false);
        }
        else {
            this.cullFace.set(true);
            this.cullFaceSide.set(cullFaceMode.mode);
            this.frontFace.set(cullFaceMode.frontFace);
        }
    }
    setDepthMode(depthMode) {
        if (depthMode.func === this.gl.ALWAYS && !depthMode.mask) {
            this.depthTest.set(false);
        }
        else {
            this.depthTest.set(true);
            this.depthFunc.set(depthMode.func);
            this.depthMask.set(depthMode.mask);
            this.depthRange.set(depthMode.range);
        }
    }
    setStencilMode(stencilMode) {
        if (stencilMode.test.func === this.gl.ALWAYS && !stencilMode.mask) {
            this.stencilTest.set(false);
        }
        else {
            this.stencilTest.set(true);
            this.stencilMask.set(stencilMode.mask);
            this.stencilOp.set([stencilMode.fail, stencilMode.depthFail, stencilMode.pass]);
            this.stencilFunc.set({
                func: stencilMode.test.func,
                ref: stencilMode.ref,
                mask: stencilMode.test.mask
            });
        }
    }
    setColorMode(colorMode) {
        if (performance$1.aF(colorMode.blendFunction, ColorMode.Replace)) {
            this.blend.set(false);
        }
        else {
            this.blend.set(true);
            this.blendFunc.set(colorMode.blendFunction);
            this.blendColor.set(colorMode.blendColor);
        }
        this.colorMask.set(colorMode.mask);
    }
    createVertexArray() {
        var _a;
        if (isWebGL2(this.gl))
            return this.gl.createVertexArray();
        return (_a = this.gl.getExtension('OES_vertex_array_object')) === null || _a === void 0 ? void 0 : _a.createVertexArrayOES();
    }
    deleteVertexArray(x) {
        var _a;
        if (isWebGL2(this.gl))
            return this.gl.deleteVertexArray(x);
        return (_a = this.gl.getExtension('OES_vertex_array_object')) === null || _a === void 0 ? void 0 : _a.deleteVertexArrayOES(x);
    }
    unbindVAO() {
        // Unbinding the VAO prevents other things (custom layers, new buffer creation) from
        // unintentionally changing the state of the last VAO used.
        this.bindVertexArray.set(null);
    }
}

const ALWAYS$1 = 0x0207;
class DepthMode {
    constructor(depthFunc, depthMask, depthRange) {
        this.func = depthFunc;
        this.mask = depthMask;
        this.range = depthRange;
    }
}
DepthMode.ReadOnly = false;
DepthMode.ReadWrite = true;
DepthMode.disabled = new DepthMode(ALWAYS$1, DepthMode.ReadOnly, [0, 1]);

const ALWAYS = 0x0207;
const KEEP = 0x1E00;
class StencilMode {
    constructor(test, ref, mask, fail, depthFail, pass) {
        this.test = test;
        this.ref = ref;
        this.mask = mask;
        this.fail = fail;
        this.depthFail = depthFail;
        this.pass = pass;
    }
}
StencilMode.disabled = new StencilMode({ func: ALWAYS, mask: 0 }, 0, 0, KEEP, KEEP, KEEP);

const BACK = 0x0405;
const CCW = 0x0901;
class CullFaceMode {
    constructor(enable, mode, frontFace) {
        this.enable = enable;
        this.mode = mode;
        this.frontFace = frontFace;
    }
}
CullFaceMode.disabled = new CullFaceMode(false, BACK, CCW);
CullFaceMode.backCCW = new CullFaceMode(true, BACK, CCW);

let quadTriangles;
function drawCollisionDebug(painter, sourceCache, layer, coords, isText) {
    const context = painter.context;
    const gl = context.gl;
    const program = painter.useProgram('collisionBox');
    const tileBatches = [];
    let circleCount = 0;
    let circleOffset = 0;
    for (let i = 0; i < coords.length; i++) {
        const coord = coords[i];
        const tile = sourceCache.getTile(coord);
        const bucket = tile.getBucket(layer);
        if (!bucket)
            continue;
        const buffers = isText ? bucket.textCollisionBox : bucket.iconCollisionBox;
        // Get collision circle data of this bucket
        const circleArray = bucket.collisionCircleArray;
        if (circleArray.length > 0) {
            // We need to know the projection matrix that was used for projecting collision circles to the screen.
            // This might vary between buckets as the symbol placement is a continuous process. This matrix is
            // required for transforming points from previous screen space to the current one
            const invTransform = performance$1.H();
            performance$1.aR(invTransform, bucket.placementInvProjMatrix, painter.transform.glCoordMatrix);
            performance$1.aR(invTransform, invTransform, bucket.placementViewportMatrix);
            tileBatches.push({
                circleArray,
                circleOffset,
                transform: coord.posMatrix, // Ignore translation
                invTransform,
                coord
            });
            circleCount += circleArray.length / 4; // 4 values per circle
            circleOffset = circleCount;
        }
        // Draw collision boxes
        if (!buffers) {
            continue;
        }
        program.draw(context, gl.LINES, DepthMode.disabled, StencilMode.disabled, painter.colorModeForRenderPass(), CullFaceMode.disabled, collisionUniformValues(painter.transform, coord.posMatrix), painter.style.map.terrain && painter.style.map.terrain.getTerrainData(coord), layer.id, buffers.layoutVertexBuffer, buffers.indexBuffer, buffers.segments, null, painter.transform.zoom, null, null, buffers.collisionVertexBuffer);
    }
    if (!isText || !tileBatches.length) {
        return;
    }
    // Render collision circles
    const circleProgram = painter.useProgram('collisionCircle');
    // Construct vertex data
    const vertexData = new performance$1.aS();
    vertexData.resize(circleCount * 4);
    vertexData._trim();
    let vertexOffset = 0;
    for (const batch of tileBatches) {
        for (let i = 0; i < batch.circleArray.length / 4; i++) {
            const circleIdx = i * 4;
            const x = batch.circleArray[circleIdx + 0];
            const y = batch.circleArray[circleIdx + 1];
            const radius = batch.circleArray[circleIdx + 2];
            const collision = batch.circleArray[circleIdx + 3];
            // 4 floats per vertex, 4 vertices per quad
            vertexData.emplace(vertexOffset++, x, y, radius, collision, 0);
            vertexData.emplace(vertexOffset++, x, y, radius, collision, 1);
            vertexData.emplace(vertexOffset++, x, y, radius, collision, 2);
            vertexData.emplace(vertexOffset++, x, y, radius, collision, 3);
        }
    }
    if (!quadTriangles || quadTriangles.length < circleCount * 2) {
        quadTriangles = createQuadTriangles(circleCount);
    }
    const indexBuffer = context.createIndexBuffer(quadTriangles, true);
    const vertexBuffer = context.createVertexBuffer(vertexData, performance$1.aT.members, true);
    // Render batches
    for (const batch of tileBatches) {
        const uniforms = collisionCircleUniformValues(batch.transform, batch.invTransform, painter.transform);
        circleProgram.draw(context, gl.TRIANGLES, DepthMode.disabled, StencilMode.disabled, painter.colorModeForRenderPass(), CullFaceMode.disabled, uniforms, painter.style.map.terrain && painter.style.map.terrain.getTerrainData(batch.coord), layer.id, vertexBuffer, indexBuffer, performance$1.a0.simpleSegment(0, batch.circleOffset * 2, batch.circleArray.length, batch.circleArray.length / 2), null, painter.transform.zoom, null, null, null);
    }
    vertexBuffer.destroy();
    indexBuffer.destroy();
}
function createQuadTriangles(quadCount) {
    const triCount = quadCount * 2;
    const array = new performance$1.aU();
    array.resize(triCount);
    array._trim();
    // Two triangles and 4 vertices per quad.
    for (let i = 0; i < triCount; i++) {
        const idx = i * 6;
        array.uint16[idx + 0] = i * 4 + 0;
        array.uint16[idx + 1] = i * 4 + 1;
        array.uint16[idx + 2] = i * 4 + 2;
        array.uint16[idx + 3] = i * 4 + 2;
        array.uint16[idx + 4] = i * 4 + 3;
        array.uint16[idx + 5] = i * 4 + 0;
    }
    return array;
}

const identityMat4 = performance$1.ao(new Float32Array(16));
function drawSymbols(painter, sourceCache, layer, coords, variableOffsets) {
    if (painter.renderPass !== 'translucent')
        return;
    // Disable the stencil test so that labels aren't clipped to tile boundaries.
    const stencilMode = StencilMode.disabled;
    const colorMode = painter.colorModeForRenderPass();
    const hasVariablePlacement = layer._unevaluatedLayout.hasValue('text-variable-anchor') || layer._unevaluatedLayout.hasValue('text-variable-anchor-offset');
    //Compute variable-offsets before painting since icons and text data positioning
    //depend on each other in this case.
    if (hasVariablePlacement) {
        updateVariableAnchors(coords, painter, layer, sourceCache, layer.layout.get('text-rotation-alignment'), layer.layout.get('text-pitch-alignment'), layer.paint.get('text-translate'), layer.paint.get('text-translate-anchor'), variableOffsets);
    }
    if (layer.paint.get('icon-opacity').constantOr(1) !== 0) {
        drawLayerSymbols(painter, sourceCache, layer, coords, false, layer.paint.get('icon-translate'), layer.paint.get('icon-translate-anchor'), layer.layout.get('icon-rotation-alignment'), layer.layout.get('icon-pitch-alignment'), layer.layout.get('icon-keep-upright'), stencilMode, colorMode);
    }
    if (layer.paint.get('text-opacity').constantOr(1) !== 0) {
        drawLayerSymbols(painter, sourceCache, layer, coords, true, layer.paint.get('text-translate'), layer.paint.get('text-translate-anchor'), layer.layout.get('text-rotation-alignment'), layer.layout.get('text-pitch-alignment'), layer.layout.get('text-keep-upright'), stencilMode, colorMode);
    }
    if (sourceCache.map.showCollisionBoxes) {
        drawCollisionDebug(painter, sourceCache, layer, coords, true);
        drawCollisionDebug(painter, sourceCache, layer, coords, false);
    }
}
function calculateVariableRenderShift(anchor, width, height, textOffset, textBoxScale, renderTextSize) {
    const { horizontalAlign, verticalAlign } = performance$1.av(anchor);
    const shiftX = -(horizontalAlign - 0.5) * width;
    const shiftY = -(verticalAlign - 0.5) * height;
    return new performance$1.P((shiftX / textBoxScale + textOffset[0]) * renderTextSize, (shiftY / textBoxScale + textOffset[1]) * renderTextSize);
}
function updateVariableAnchors(coords, painter, layer, sourceCache, rotationAlignment, pitchAlignment, translate, translateAnchor, variableOffsets) {
    const transform = painter.transform;
    const projection = createProjection();
    const rotateWithMap = rotationAlignment === 'map';
    const pitchWithMap = pitchAlignment === 'map';
    for (const coord of coords) {
        const tile = sourceCache.getTile(coord);
        const bucket = tile.getBucket(layer);
        if (!bucket || !bucket.text || !bucket.text.segments.get().length)
            continue;
        const sizeData = bucket.textSizeData;
        const size = performance$1.ah(sizeData, transform.zoom);
        const pixelToTileScale = pixelsToTileUnits(tile, 1, painter.transform.zoom);
        const labelPlaneMatrix = getLabelPlaneMatrix(coord.posMatrix, pitchWithMap, rotateWithMap, painter.transform, pixelToTileScale);
        const updateTextFitIcon = layer.layout.get('icon-text-fit') !== 'none' && bucket.hasIconData();
        if (size) {
            const tileScale = Math.pow(2, transform.zoom - tile.tileID.overscaledZ);
            const getElevation = painter.style.map.terrain ? (x, y) => painter.style.map.terrain.getElevation(coord, x, y) : null;
            const translation = projection.translatePosition(transform, tile, translate, translateAnchor);
            updateVariableAnchorsForBucket(bucket, rotateWithMap, pitchWithMap, variableOffsets, transform, labelPlaneMatrix, coord.posMatrix, tileScale, size, updateTextFitIcon, projection, translation, coord.toUnwrapped(), getElevation);
        }
    }
}
function getShiftedAnchor(projectedAnchorPoint, projectionContext, rotateWithMap, shift, transformAngle, pitchedTextShiftCorrection) {
    // Usual case is that we take the projected anchor and add the pixel-based shift
    // calculated earlier. In the (somewhat weird) case of pitch-aligned text, we add an equivalent
    // tile-unit based shift to the anchor before projecting to the label plane.
    const translatedAnchor = projectionContext.tileAnchorPoint.add(new performance$1.P(projectionContext.translation[0], projectionContext.translation[1]));
    if (projectionContext.pitchWithMap) {
        let adjustedShift = shift.mult(pitchedTextShiftCorrection);
        if (!rotateWithMap) {
            adjustedShift = adjustedShift.rotate(-transformAngle);
        }
        const tileAnchorShifted = translatedAnchor.add(adjustedShift);
        return project(tileAnchorShifted, projectionContext.labelPlaneMatrix, projectionContext.getElevation).point;
    }
    else {
        if (rotateWithMap) {
            // Compute the angle with which to rotate the anchor, so that it is aligned with
            // the map's actual east-west axis. Very similar to what is done in the shader.
            const projectedAnchorRight = projectTileCoordinatesToViewport(projectionContext.tileAnchorPoint.x + 1, projectionContext.tileAnchorPoint.y, projectionContext);
            const east = projectedAnchorRight.point.sub(projectedAnchorPoint);
            const angle = Math.atan(east.y / east.x) + (east.x < 0 ? Math.PI : 0);
            return projectedAnchorPoint.add(shift.rotate(angle));
        }
        else {
            return projectedAnchorPoint.add(shift);
        }
    }
}
function updateVariableAnchorsForBucket(bucket, rotateWithMap, pitchWithMap, variableOffsets, transform, labelPlaneMatrix, posMatrix, tileScale, size, updateTextFitIcon, projection, translation, unwrappedTileID, getElevation) {
    const placedSymbols = bucket.text.placedSymbolArray;
    const dynamicTextLayoutVertexArray = bucket.text.dynamicLayoutVertexArray;
    const dynamicIconLayoutVertexArray = bucket.icon.dynamicLayoutVertexArray;
    const placedTextShifts = {};
    dynamicTextLayoutVertexArray.clear();
    for (let s = 0; s < placedSymbols.length; s++) {
        const symbol = placedSymbols.get(s);
        const skipOrientation = bucket.allowVerticalPlacement && !symbol.placedOrientation;
        const variableOffset = (!symbol.hidden && symbol.crossTileID && !skipOrientation) ? variableOffsets[symbol.crossTileID] : null;
        if (!variableOffset) {
            // These symbols are from a justification that is not being used, or a label that wasn't placed
            // so we don't need to do the extra math to figure out what incremental shift to apply.
            hideGlyphs(symbol.numGlyphs, dynamicTextLayoutVertexArray);
        }
        else {
            const tileAnchor = new performance$1.P(symbol.anchorX, symbol.anchorY);
            const projectionContext = {
                getElevation,
                width: transform.width,
                height: transform.height,
                labelPlaneMatrix,
                lineVertexArray: null,
                pitchWithMap,
                projection,
                projectionCache: null,
                tileAnchorPoint: tileAnchor,
                translation,
                unwrappedTileID
            };
            const projectedAnchor = pitchWithMap ?
                project(tileAnchor, posMatrix, getElevation) :
                projectTileCoordinatesToViewport(tileAnchor.x, tileAnchor.y, projectionContext);
            const perspectiveRatio = getPerspectiveRatio(transform.cameraToCenterDistance, projectedAnchor.signedDistanceFromCamera);
            let renderTextSize = performance$1.aj(bucket.textSizeData, size, symbol) * perspectiveRatio / performance$1.aq;
            if (pitchWithMap) {
                // Go from size in pixels to equivalent size in tile units
                renderTextSize *= bucket.tilePixelRatio / tileScale;
            }
            const { width, height, anchor, textOffset, textBoxScale } = variableOffset;
            const shift = calculateVariableRenderShift(anchor, width, height, textOffset, textBoxScale, renderTextSize);
            const pitchedTextCorrection = projection.getPitchedTextCorrection(transform, tileAnchor.add(new performance$1.P(translation[0], translation[1])), unwrappedTileID);
            const shiftedAnchor = getShiftedAnchor(projectedAnchor.point, projectionContext, rotateWithMap, shift, transform.angle, pitchedTextCorrection);
            const angle = (bucket.allowVerticalPlacement && symbol.placedOrientation === performance$1.ai.vertical) ? Math.PI / 2 : 0;
            for (let g = 0; g < symbol.numGlyphs; g++) {
                performance$1.ak(dynamicTextLayoutVertexArray, shiftedAnchor, angle);
            }
            //Only offset horizontal text icons
            if (updateTextFitIcon && symbol.associatedIconIndex >= 0) {
                placedTextShifts[symbol.associatedIconIndex] = { shiftedAnchor, angle };
            }
        }
    }
    if (updateTextFitIcon) {
        dynamicIconLayoutVertexArray.clear();
        const placedIcons = bucket.icon.placedSymbolArray;
        for (let i = 0; i < placedIcons.length; i++) {
            const placedIcon = placedIcons.get(i);
            if (placedIcon.hidden) {
                hideGlyphs(placedIcon.numGlyphs, dynamicIconLayoutVertexArray);
            }
            else {
                const shift = placedTextShifts[i];
                if (!shift) {
                    hideGlyphs(placedIcon.numGlyphs, dynamicIconLayoutVertexArray);
                }
                else {
                    for (let g = 0; g < placedIcon.numGlyphs; g++) {
                        performance$1.ak(dynamicIconLayoutVertexArray, shift.shiftedAnchor, shift.angle);
                    }
                }
            }
        }
        bucket.icon.dynamicLayoutVertexBuffer.updateData(dynamicIconLayoutVertexArray);
    }
    bucket.text.dynamicLayoutVertexBuffer.updateData(dynamicTextLayoutVertexArray);
}
function getSymbolProgramName(isSDF, isText, bucket) {
    if (bucket.iconsInText && isText) {
        return 'symbolTextAndIcon';
    }
    else if (isSDF) {
        return 'symbolSDF';
    }
    else {
        return 'symbolIcon';
    }
}
function drawLayerSymbols(painter, sourceCache, layer, coords, isText, translate, translateAnchor, rotationAlignment, pitchAlignment, keepUpright, stencilMode, colorMode) {
    const context = painter.context;
    const gl = context.gl;
    const tr = painter.transform;
    const projection = createProjection();
    const rotateWithMap = rotationAlignment === 'map';
    const pitchWithMap = pitchAlignment === 'map';
    const alongLine = rotationAlignment !== 'viewport' && layer.layout.get('symbol-placement') !== 'point';
    // Line label rotation happens in `updateLineLabels`
    // Pitched point labels are automatically rotated by the labelPlaneMatrix projection
    // Unpitched point labels need to have their rotation applied after projection
    const rotateInShader = rotateWithMap && !pitchWithMap && !alongLine;
    const isViewportLine = !pitchWithMap && alongLine;
    const hasSortKey = !layer.layout.get('symbol-sort-key').isConstant();
    let sortFeaturesByKey = false;
    const depthMode = painter.depthModeForSublayer(0, DepthMode.ReadOnly);
    const hasVariablePlacement = layer._unevaluatedLayout.hasValue('text-variable-anchor') || layer._unevaluatedLayout.hasValue('text-variable-anchor-offset');
    const tileRenderState = [];
    const pitchedTextRescaling = projection.getCircleRadiusCorrection(tr);
    for (const coord of coords) {
        const tile = sourceCache.getTile(coord);
        const bucket = tile.getBucket(layer);
        if (!bucket)
            continue;
        const buffers = isText ? bucket.text : bucket.icon;
        if (!buffers || !buffers.segments.get().length || !buffers.hasVisibleVertices)
            continue;
        const programConfiguration = buffers.programConfigurations.get(layer.id);
        const isSDF = isText || bucket.sdfIcons;
        const sizeData = isText ? bucket.textSizeData : bucket.iconSizeData;
        const transformed = pitchWithMap || tr.pitch !== 0;
        const program = painter.useProgram(getSymbolProgramName(isSDF, isText, bucket), programConfiguration);
        const size = performance$1.ah(sizeData, tr.zoom);
        const terrainData = painter.style.map.terrain && painter.style.map.terrain.getTerrainData(coord);
        let texSize;
        let texSizeIcon = [0, 0];
        let atlasTexture;
        let atlasInterpolation;
        let atlasTextureIcon = null;
        let atlasInterpolationIcon;
        if (isText) {
            atlasTexture = tile.glyphAtlasTexture;
            atlasInterpolation = gl.LINEAR;
            texSize = tile.glyphAtlasTexture.size;
            if (bucket.iconsInText) {
                texSizeIcon = tile.imageAtlasTexture.size;
                atlasTextureIcon = tile.imageAtlasTexture;
                const zoomDependentSize = sizeData.kind === 'composite' || sizeData.kind === 'camera';
                atlasInterpolationIcon = transformed || painter.options.rotating || painter.options.zooming || zoomDependentSize ? gl.LINEAR : gl.NEAREST;
            }
        }
        else {
            const iconScaled = layer.layout.get('icon-size').constantOr(0) !== 1 || bucket.iconsNeedLinear;
            atlasTexture = tile.imageAtlasTexture;
            atlasInterpolation = isSDF || painter.options.rotating || painter.options.zooming || iconScaled || transformed ?
                gl.LINEAR :
                gl.NEAREST;
            texSize = tile.imageAtlasTexture.size;
        }
        const s = pixelsToTileUnits(tile, 1, painter.transform.zoom);
        const baseMatrix = isViewportLine ? coord.posMatrix : identityMat4;
        const labelPlaneMatrix = getLabelPlaneMatrix(baseMatrix, pitchWithMap, rotateWithMap, painter.transform, s);
        const glCoordMatrixForShader = getGlCoordMatrix(baseMatrix, pitchWithMap, rotateWithMap, painter.transform, s);
        const glCoordMatrixForSymbolPlacement = getGlCoordMatrix(coord.posMatrix, pitchWithMap, rotateWithMap, painter.transform, s);
        const translation = projection.translatePosition(painter.transform, tile, translate, translateAnchor);
        const hasVariableAnchors = hasVariablePlacement && bucket.hasTextData();
        const updateTextFitIcon = layer.layout.get('icon-text-fit') !== 'none' &&
            hasVariableAnchors &&
            bucket.hasIconData();
        if (alongLine) {
            const getElevation = painter.style.map.terrain ? (x, y) => painter.style.map.terrain.getElevation(coord, x, y) : null;
            const rotateToLine = layer.layout.get('text-rotation-alignment') === 'map';
            updateLineLabels(bucket, coord.posMatrix, painter, isText, labelPlaneMatrix, glCoordMatrixForSymbolPlacement, pitchWithMap, keepUpright, rotateToLine, projection, coord.toUnwrapped(), tr.width, tr.height, translation, getElevation);
        }
        const matrix = coord.posMatrix; // formerly also incorporated translate and translate-anchor
        const shaderVariableAnchor = (isText && hasVariablePlacement) || updateTextFitIcon;
        const noLabelPlane = (alongLine || shaderVariableAnchor);
        const uLabelPlaneMatrix = noLabelPlane ? identityMat4 : labelPlaneMatrix;
        const uglCoordMatrix = glCoordMatrixForShader; // formerly also incorporated translate and translate-anchor
        const hasHalo = isSDF && layer.paint.get(isText ? 'text-halo-width' : 'icon-halo-width').constantOr(1) !== 0;
        let uniformValues;
        if (isSDF) {
            if (!bucket.iconsInText) {
                uniformValues = symbolSDFUniformValues(sizeData.kind, size, rotateInShader, pitchWithMap, alongLine, shaderVariableAnchor, painter, matrix, uLabelPlaneMatrix, uglCoordMatrix, translation, isText, texSize, true, pitchedTextRescaling);
            }
            else {
                uniformValues = symbolTextAndIconUniformValues(sizeData.kind, size, rotateInShader, pitchWithMap, alongLine, shaderVariableAnchor, painter, matrix, uLabelPlaneMatrix, uglCoordMatrix, translation, texSize, texSizeIcon, pitchedTextRescaling);
            }
        }
        else {
            uniformValues = symbolIconUniformValues(sizeData.kind, size, rotateInShader, pitchWithMap, alongLine, shaderVariableAnchor, painter, matrix, uLabelPlaneMatrix, uglCoordMatrix, translation, isText, texSize, pitchedTextRescaling);
        }
        const state = {
            program,
            buffers,
            uniformValues,
            atlasTexture,
            atlasTextureIcon,
            atlasInterpolation,
            atlasInterpolationIcon,
            isSDF,
            hasHalo
        };
        if (hasSortKey && bucket.canOverlap) {
            sortFeaturesByKey = true;
            const oldSegments = buffers.segments.get();
            for (const segment of oldSegments) {
                tileRenderState.push({
                    segments: new performance$1.a0([segment]),
                    sortKey: segment.sortKey,
                    state,
                    terrainData
                });
            }
        }
        else {
            tileRenderState.push({
                segments: buffers.segments,
                sortKey: 0,
                state,
                terrainData
            });
        }
    }
    if (sortFeaturesByKey) {
        tileRenderState.sort((a, b) => a.sortKey - b.sortKey);
    }
    for (const segmentState of tileRenderState) {
        const state = segmentState.state;
        context.activeTexture.set(gl.TEXTURE0);
        state.atlasTexture.bind(state.atlasInterpolation, gl.CLAMP_TO_EDGE);
        if (state.atlasTextureIcon) {
            context.activeTexture.set(gl.TEXTURE1);
            if (state.atlasTextureIcon) {
                state.atlasTextureIcon.bind(state.atlasInterpolationIcon, gl.CLAMP_TO_EDGE);
            }
        }
        if (state.isSDF) {
            const uniformValues = state.uniformValues;
            if (state.hasHalo) {
                uniformValues['u_is_halo'] = 1;
                drawSymbolElements(state.buffers, segmentState.segments, layer, painter, state.program, depthMode, stencilMode, colorMode, uniformValues, segmentState.terrainData);
            }
            uniformValues['u_is_halo'] = 0;
        }
        drawSymbolElements(state.buffers, segmentState.segments, layer, painter, state.program, depthMode, stencilMode, colorMode, state.uniformValues, segmentState.terrainData);
    }
}
function drawSymbolElements(buffers, segments, layer, painter, program, depthMode, stencilMode, colorMode, uniformValues, terrainData) {
    const context = painter.context;
    const gl = context.gl;
    program.draw(context, gl.TRIANGLES, depthMode, stencilMode, colorMode, CullFaceMode.disabled, uniformValues, terrainData, layer.id, buffers.layoutVertexBuffer, buffers.indexBuffer, segments, layer.paint, painter.transform.zoom, buffers.programConfigurations.get(layer.id), buffers.dynamicLayoutVertexBuffer, buffers.opacityVertexBuffer);
}

function drawCircles(painter, sourceCache, layer, coords) {
    if (painter.renderPass !== 'translucent')
        return;
    const opacity = layer.paint.get('circle-opacity');
    const strokeWidth = layer.paint.get('circle-stroke-width');
    const strokeOpacity = layer.paint.get('circle-stroke-opacity');
    const sortFeaturesByKey = !layer.layout.get('circle-sort-key').isConstant();
    if (opacity.constantOr(1) === 0 && (strokeWidth.constantOr(1) === 0 || strokeOpacity.constantOr(1) === 0)) {
        return;
    }
    const context = painter.context;
    const gl = context.gl;
    const depthMode = painter.depthModeForSublayer(0, DepthMode.ReadOnly);
    // Turn off stencil testing to allow circles to be drawn across boundaries,
    // so that large circles are not clipped to tiles
    const stencilMode = StencilMode.disabled;
    const colorMode = painter.colorModeForRenderPass();
    const segmentsRenderStates = [];
    for (let i = 0; i < coords.length; i++) {
        const coord = coords[i];
        const tile = sourceCache.getTile(coord);
        const bucket = tile.getBucket(layer);
        if (!bucket)
            continue;
        const programConfiguration = bucket.programConfigurations.get(layer.id);
        const program = painter.useProgram('circle', programConfiguration);
        const layoutVertexBuffer = bucket.layoutVertexBuffer;
        const indexBuffer = bucket.indexBuffer;
        const terrainData = painter.style.map.terrain && painter.style.map.terrain.getTerrainData(coord);
        const uniformValues = circleUniformValues(painter, coord, tile, layer);
        const state = {
            programConfiguration,
            program,
            layoutVertexBuffer,
            indexBuffer,
            uniformValues,
            terrainData
        };
        if (sortFeaturesByKey) {
            const oldSegments = bucket.segments.get();
            for (const segment of oldSegments) {
                segmentsRenderStates.push({
                    segments: new performance$1.a0([segment]),
                    sortKey: segment.sortKey,
                    state
                });
            }
        }
        else {
            segmentsRenderStates.push({
                segments: bucket.segments,
                sortKey: 0,
                state
            });
        }
    }
    if (sortFeaturesByKey) {
        segmentsRenderStates.sort((a, b) => a.sortKey - b.sortKey);
    }
    for (const segmentsState of segmentsRenderStates) {
        const { programConfiguration, program, layoutVertexBuffer, indexBuffer, uniformValues, terrainData } = segmentsState.state;
        const segments = segmentsState.segments;
        program.draw(context, gl.TRIANGLES, depthMode, stencilMode, colorMode, CullFaceMode.disabled, uniformValues, terrainData, layer.id, layoutVertexBuffer, indexBuffer, segments, layer.paint, painter.transform.zoom, programConfiguration);
    }
}

function drawHeatmap(painter, sourceCache, layer, coords) {
    if (layer.paint.get('heatmap-opacity') === 0) {
        return;
    }
    if (painter.renderPass === 'offscreen') {
        const context = painter.context;
        const gl = context.gl;
        // Allow kernels to be drawn across boundaries, so that
        // large kernels are not clipped to tiles
        const stencilMode = StencilMode.disabled;
        // Turn on additive blending for kernels, which is a key aspect of kernel density estimation formula
        const colorMode = new ColorMode([gl.ONE, gl.ONE], performance$1.aN.transparent, [true, true, true, true]);
        bindFramebuffer(context, painter, layer);
        context.clear({ color: performance$1.aN.transparent });
        for (let i = 0; i < coords.length; i++) {
            const coord = coords[i];
            // Skip tiles that have uncovered parents to avoid flickering; we don't need
            // to use complex tile masking here because the change between zoom levels is subtle,
            // so it's fine to simply render the parent until all its 4 children are loaded
            if (sourceCache.hasRenderableParent(coord))
                continue;
            const tile = sourceCache.getTile(coord);
            const bucket = tile.getBucket(layer);
            if (!bucket)
                continue;
            const programConfiguration = bucket.programConfigurations.get(layer.id);
            const program = painter.useProgram('heatmap', programConfiguration);
            const { zoom } = painter.transform;
            program.draw(context, gl.TRIANGLES, DepthMode.disabled, stencilMode, colorMode, CullFaceMode.disabled, heatmapUniformValues(coord.posMatrix, tile, zoom, layer.paint.get('heatmap-intensity')), null, layer.id, bucket.layoutVertexBuffer, bucket.indexBuffer, bucket.segments, layer.paint, painter.transform.zoom, programConfiguration);
        }
        context.viewport.set([0, 0, painter.width, painter.height]);
    }
    else if (painter.renderPass === 'translucent') {
        painter.context.setColorMode(painter.colorModeForRenderPass());
        renderTextureToMap(painter, layer);
    }
}
function bindFramebuffer(context, painter, layer) {
    const gl = context.gl;
    context.activeTexture.set(gl.TEXTURE1);
    // Use a 4x downscaled screen texture for better performance
    context.viewport.set([0, 0, painter.width / 4, painter.height / 4]);
    let fbo = layer.heatmapFbo;
    if (!fbo) {
        const texture = gl.createTexture();
        gl.bindTexture(gl.TEXTURE_2D, texture);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
        fbo = layer.heatmapFbo = context.createFramebuffer(painter.width / 4, painter.height / 4, false, false);
        bindTextureToFramebuffer(context, painter, texture, fbo);
    }
    else {
        gl.bindTexture(gl.TEXTURE_2D, fbo.colorAttachment.get());
        context.bindFramebuffer.set(fbo.framebuffer);
    }
}
function bindTextureToFramebuffer(context, painter, texture, fbo) {
    var _a, _b;
    const gl = context.gl;
    // Use the higher precision half-float texture where available (producing much smoother looking heatmaps);
    // Otherwise, fall back to a low precision texture
    const numType = (_a = context.HALF_FLOAT) !== null && _a !== void 0 ? _a : gl.UNSIGNED_BYTE;
    const internalFormat = (_b = context.RGBA16F) !== null && _b !== void 0 ? _b : gl.RGBA;
    gl.texImage2D(gl.TEXTURE_2D, 0, internalFormat, painter.width / 4, painter.height / 4, 0, gl.RGBA, numType, null);
    fbo.colorAttachment.set(texture);
}
function renderTextureToMap(painter, layer) {
    const context = painter.context;
    const gl = context.gl;
    // Here we bind two different textures from which we'll sample in drawing
    // heatmaps: the kernel texture, prepared in the offscreen pass, and a
    // color ramp texture.
    const fbo = layer.heatmapFbo;
    if (!fbo)
        return;
    context.activeTexture.set(gl.TEXTURE0);
    gl.bindTexture(gl.TEXTURE_2D, fbo.colorAttachment.get());
    context.activeTexture.set(gl.TEXTURE1);
    let colorRampTexture = layer.colorRampTexture;
    if (!colorRampTexture) {
        colorRampTexture = layer.colorRampTexture = new Texture(context, layer.colorRamp, gl.RGBA);
    }
    colorRampTexture.bind(gl.LINEAR, gl.CLAMP_TO_EDGE);
    painter.useProgram('heatmapTexture').draw(context, gl.TRIANGLES, DepthMode.disabled, StencilMode.disabled, painter.colorModeForRenderPass(), CullFaceMode.disabled, heatmapTextureUniformValues(painter, layer, 0, 1), null, layer.id, painter.viewportBuffer, painter.quadTriangleIndexBuffer, painter.viewportSegments, layer.paint, painter.transform.zoom);
}

function drawLine(painter, sourceCache, layer, coords) {
    if (painter.renderPass !== 'translucent')
        return;
    const opacity = layer.paint.get('line-opacity');
    const width = layer.paint.get('line-width');
    if (opacity.constantOr(1) === 0 || width.constantOr(1) === 0)
        return;
    const depthMode = painter.depthModeForSublayer(0, DepthMode.ReadOnly);
    const colorMode = painter.colorModeForRenderPass();
    const dasharray = layer.paint.get('line-dasharray');
    const patternProperty = layer.paint.get('line-pattern');
    const image = patternProperty.constantOr(1);
    const gradient = layer.paint.get('line-gradient');
    const crossfade = layer.getCrossfadeParameters();
    const programId = image ? 'linePattern' :
        dasharray ? 'lineSDF' :
            gradient ? 'lineGradient' : 'line';
    const context = painter.context;
    const gl = context.gl;
    let firstTile = true;
    for (const coord of coords) {
        const tile = sourceCache.getTile(coord);
        if (image && !tile.patternsLoaded())
            continue;
        const bucket = tile.getBucket(layer);
        if (!bucket)
            continue;
        const programConfiguration = bucket.programConfigurations.get(layer.id);
        const prevProgram = painter.context.program.get();
        const program = painter.useProgram(programId, programConfiguration);
        const programChanged = firstTile || program.program !== prevProgram;
        const terrainData = painter.style.map.terrain && painter.style.map.terrain.getTerrainData(coord);
        const constantPattern = patternProperty.constantOr(null);
        if (constantPattern && tile.imageAtlas) {
            const atlas = tile.imageAtlas;
            const posTo = atlas.patternPositions[constantPattern.to.toString()];
            const posFrom = atlas.patternPositions[constantPattern.from.toString()];
            if (posTo && posFrom)
                programConfiguration.setConstantPatternPositions(posTo, posFrom);
        }
        const terrainCoord = terrainData ? coord : null;
        const uniformValues = image ? linePatternUniformValues(painter, tile, layer, crossfade, terrainCoord) :
            dasharray ? lineSDFUniformValues(painter, tile, layer, dasharray, crossfade, terrainCoord) :
                gradient ? lineGradientUniformValues(painter, tile, layer, bucket.lineClipsArray.length, terrainCoord) :
                    lineUniformValues(painter, tile, layer, terrainCoord);
        if (image) {
            context.activeTexture.set(gl.TEXTURE0);
            tile.imageAtlasTexture.bind(gl.LINEAR, gl.CLAMP_TO_EDGE);
            programConfiguration.updatePaintBuffers(crossfade);
        }
        else if (dasharray && (programChanged || painter.lineAtlas.dirty)) {
            context.activeTexture.set(gl.TEXTURE0);
            painter.lineAtlas.bind(context);
        }
        else if (gradient) {
            const layerGradient = bucket.gradients[layer.id];
            let gradientTexture = layerGradient.texture;
            if (layer.gradientVersion !== layerGradient.version) {
                let textureResolution = 256;
                if (layer.stepInterpolant) {
                    const sourceMaxZoom = sourceCache.getSource().maxzoom;
                    const potentialOverzoom = coord.canonical.z === sourceMaxZoom ?
                        Math.ceil(1 << (painter.transform.maxZoom - coord.canonical.z)) : 1;
                    const lineLength = bucket.maxLineLength / performance$1.X;
                    // Logical pixel tile size is 512px, and 1024px right before current zoom + 1
                    const maxTilePixelSize = 1024;
                    // Maximum possible texture coverage heuristic, bound by hardware max texture size
                    const maxTextureCoverage = lineLength * maxTilePixelSize * potentialOverzoom;
                    textureResolution = performance$1.ad(performance$1.aV(maxTextureCoverage), 256, context.maxTextureSize);
                }
                layerGradient.gradient = performance$1.aW({
                    expression: layer.gradientExpression(),
                    evaluationKey: 'lineProgress',
                    resolution: textureResolution,
                    image: layerGradient.gradient || undefined,
                    clips: bucket.lineClipsArray
                });
                if (layerGradient.texture) {
                    layerGradient.texture.update(layerGradient.gradient);
                }
                else {
                    layerGradient.texture = new Texture(context, layerGradient.gradient, gl.RGBA);
                }
                layerGradient.version = layer.gradientVersion;
                gradientTexture = layerGradient.texture;
            }
            context.activeTexture.set(gl.TEXTURE0);
            gradientTexture.bind(layer.stepInterpolant ? gl.NEAREST : gl.LINEAR, gl.CLAMP_TO_EDGE);
        }
        program.draw(context, gl.TRIANGLES, depthMode, painter.stencilModeForClipping(coord), colorMode, CullFaceMode.disabled, uniformValues, terrainData, layer.id, bucket.layoutVertexBuffer, bucket.indexBuffer, bucket.segments, layer.paint, painter.transform.zoom, programConfiguration, bucket.layoutVertexBuffer2);
        firstTile = false;
        // once refactored so that bound texture state is managed, we'll also be able to remove this firstTile/programChanged logic
    }
}

/**
 * A simple helper shared by draw_fill and draw_fill_extrusions to find the correct pattern positions AND update program.
 * For transitionable properties, especially 'fill-pattern' and 'fill-extrusion-pattern', while rendering certain frames
 * tile.imageAtlas has been updated by worker to hold the new pattern only, but rendering code is still looking for the previous image.
 * The mismatch was causing setConstantPatternPositions method not being called and pixelRatio was always the
 * default of 1, instead of actual values set by original map.addImage.
 *
 * @param programConfiguration - to be used to set pattern position and device pixel ratio.
 * @param propertyName - 'fill-pattern' or 'fill-extrusion-pattern' property key
 * @param constantPattern - either 'fill-pattern' or 'fill-extrusion-pattern' property value
 * @param tile - current tile being drawn
 * @param layer - current layer being rendered
 */
function updatePatternPositionsInProgram(programConfiguration, propertyName, constantPattern, tile, layer) {
    if (!constantPattern || !tile || !tile.imageAtlas) {
        return;
    }
    const patternPositions = tile.imageAtlas.patternPositions;
    let posTo = patternPositions[constantPattern.to.toString()];
    let posFrom = patternPositions[constantPattern.from.toString()];
    // https://github.com/maplibre/maplibre-gl-js/issues/3377
    if (!posTo && posFrom)
        posTo = posFrom;
    if (!posFrom && posTo)
        posFrom = posTo;
    // try again in case patternPositions has been updated by worker
    if (!posTo || !posFrom) {
        const transitioned = layer.getPaintProperty(propertyName);
        posTo = patternPositions[transitioned];
        posFrom = patternPositions[transitioned];
    }
    if (posTo && posFrom) {
        programConfiguration.setConstantPatternPositions(posTo, posFrom);
    }
}

function drawFill(painter, sourceCache, layer, coords) {
    const color = layer.paint.get('fill-color');
    const opacity = layer.paint.get('fill-opacity');
    if (opacity.constantOr(1) === 0) {
        return;
    }
    const colorMode = painter.colorModeForRenderPass();
    const pattern = layer.paint.get('fill-pattern');
    const pass = painter.opaquePassEnabledForLayer() &&
        (!pattern.constantOr(1) &&
            color.constantOr(performance$1.aN.transparent).a === 1 &&
            opacity.constantOr(0) === 1) ? 'opaque' : 'translucent';
    // Draw fill
    if (painter.renderPass === pass) {
        const depthMode = painter.depthModeForSublayer(1, painter.renderPass === 'opaque' ? DepthMode.ReadWrite : DepthMode.ReadOnly);
        drawFillTiles(painter, sourceCache, layer, coords, depthMode, colorMode, false);
    }
    // Draw stroke
    if (painter.renderPass === 'translucent' && layer.paint.get('fill-antialias')) {
        // If we defined a different color for the fill outline, we are
        // going to ignore the bits in 0x07 and just care about the global
        // clipping mask.
        // Otherwise, we only want to drawFill the antialiased parts that are
        // *outside* the current shape. This is important in case the fill
        // or stroke color is translucent. If we wouldn't clip to outside
        // the current shape, some pixels from the outline stroke overlapped
        // the (non-antialiased) fill.
        const depthMode = painter.depthModeForSublayer(layer.getPaintProperty('fill-outline-color') ? 2 : 0, DepthMode.ReadOnly);
        drawFillTiles(painter, sourceCache, layer, coords, depthMode, colorMode, true);
    }
}
function drawFillTiles(painter, sourceCache, layer, coords, depthMode, colorMode, isOutline) {
    const gl = painter.context.gl;
    const fillPropertyName = 'fill-pattern';
    const patternProperty = layer.paint.get(fillPropertyName);
    const image = patternProperty && patternProperty.constantOr(1);
    const crossfade = layer.getCrossfadeParameters();
    let drawMode, programName, uniformValues, indexBuffer, segments;
    if (!isOutline) {
        programName = image ? 'fillPattern' : 'fill';
        drawMode = gl.TRIANGLES;
    }
    else {
        programName = image && !layer.getPaintProperty('fill-outline-color') ? 'fillOutlinePattern' : 'fillOutline';
        drawMode = gl.LINES;
    }
    const constantPattern = patternProperty.constantOr(null);
    for (const coord of coords) {
        const tile = sourceCache.getTile(coord);
        if (image && !tile.patternsLoaded())
            continue;
        const bucket = tile.getBucket(layer);
        if (!bucket)
            continue;
        const programConfiguration = bucket.programConfigurations.get(layer.id);
        const program = painter.useProgram(programName, programConfiguration);
        const terrainData = painter.style.map.terrain && painter.style.map.terrain.getTerrainData(coord);
        if (image) {
            painter.context.activeTexture.set(gl.TEXTURE0);
            tile.imageAtlasTexture.bind(gl.LINEAR, gl.CLAMP_TO_EDGE);
            programConfiguration.updatePaintBuffers(crossfade);
        }
        updatePatternPositionsInProgram(programConfiguration, fillPropertyName, constantPattern, tile, layer);
        const terrainCoord = terrainData ? coord : null;
        const posMatrix = terrainCoord ? terrainCoord.posMatrix : coord.posMatrix;
        const tileMatrix = painter.translatePosMatrix(posMatrix, tile, layer.paint.get('fill-translate'), layer.paint.get('fill-translate-anchor'));
        if (!isOutline) {
            indexBuffer = bucket.indexBuffer;
            segments = bucket.segments;
            uniformValues = image ?
                fillPatternUniformValues(tileMatrix, painter, crossfade, tile) :
                fillUniformValues(tileMatrix);
        }
        else {
            indexBuffer = bucket.indexBuffer2;
            segments = bucket.segments2;
            const drawingBufferSize = [gl.drawingBufferWidth, gl.drawingBufferHeight];
            uniformValues = (programName === 'fillOutlinePattern' && image) ?
                fillOutlinePatternUniformValues(tileMatrix, painter, crossfade, tile, drawingBufferSize) :
                fillOutlineUniformValues(tileMatrix, drawingBufferSize);
        }
        program.draw(painter.context, drawMode, depthMode, painter.stencilModeForClipping(coord), colorMode, CullFaceMode.disabled, uniformValues, terrainData, layer.id, bucket.layoutVertexBuffer, indexBuffer, segments, layer.paint, painter.transform.zoom, programConfiguration);
    }
}

function drawFillExtrusion(painter, source, layer, coords) {
    const opacity = layer.paint.get('fill-extrusion-opacity');
    if (opacity === 0) {
        return;
    }
    if (painter.renderPass === 'translucent') {
        const depthMode = new DepthMode(painter.context.gl.LEQUAL, DepthMode.ReadWrite, painter.depthRangeFor3D);
        if (opacity === 1 && !layer.paint.get('fill-extrusion-pattern').constantOr(1)) {
            const colorMode = painter.colorModeForRenderPass();
            drawExtrusionTiles(painter, source, layer, coords, depthMode, StencilMode.disabled, colorMode);
        }
        else {
            // Draw transparent buildings in two passes so that only the closest surface is drawn.
            // First draw all the extrusions into only the depth buffer. No colors are drawn.
            drawExtrusionTiles(painter, source, layer, coords, depthMode, StencilMode.disabled, ColorMode.disabled);
            // Then draw all the extrusions a second type, only coloring fragments if they have the
            // same depth value as the closest fragment in the previous pass. Use the stencil buffer
            // to prevent the second draw in cases where we have coincident polygons.
            drawExtrusionTiles(painter, source, layer, coords, depthMode, painter.stencilModeFor3D(), painter.colorModeForRenderPass());
        }
    }
}
function drawExtrusionTiles(painter, source, layer, coords, depthMode, stencilMode, colorMode) {
    const context = painter.context;
    const gl = context.gl;
    const fillPropertyName = 'fill-extrusion-pattern';
    const patternProperty = layer.paint.get(fillPropertyName);
    const image = patternProperty.constantOr(1);
    const crossfade = layer.getCrossfadeParameters();
    const opacity = layer.paint.get('fill-extrusion-opacity');
    const constantPattern = patternProperty.constantOr(null);
    for (const coord of coords) {
        const tile = source.getTile(coord);
        const bucket = tile.getBucket(layer);
        if (!bucket)
            continue;
        const terrainData = painter.style.map.terrain && painter.style.map.terrain.getTerrainData(coord);
        const programConfiguration = bucket.programConfigurations.get(layer.id);
        const program = painter.useProgram(image ? 'fillExtrusionPattern' : 'fillExtrusion', programConfiguration);
        if (image) {
            painter.context.activeTexture.set(gl.TEXTURE0);
            tile.imageAtlasTexture.bind(gl.LINEAR, gl.CLAMP_TO_EDGE);
            programConfiguration.updatePaintBuffers(crossfade);
        }
        updatePatternPositionsInProgram(programConfiguration, fillPropertyName, constantPattern, tile, layer);
        const matrix = painter.translatePosMatrix(coord.posMatrix, tile, layer.paint.get('fill-extrusion-translate'), layer.paint.get('fill-extrusion-translate-anchor'));
        const shouldUseVerticalGradient = layer.paint.get('fill-extrusion-vertical-gradient');
        const uniformValues = image ?
            fillExtrusionPatternUniformValues(matrix, painter, shouldUseVerticalGradient, opacity, coord, crossfade, tile) :
            fillExtrusionUniformValues(matrix, painter, shouldUseVerticalGradient, opacity);
        program.draw(context, context.gl.TRIANGLES, depthMode, stencilMode, colorMode, CullFaceMode.backCCW, uniformValues, terrainData, layer.id, bucket.layoutVertexBuffer, bucket.indexBuffer, bucket.segments, layer.paint, painter.transform.zoom, programConfiguration, painter.style.map.terrain && bucket.centroidVertexBuffer);
    }
}

function drawHillshade(painter, sourceCache, layer, tileIDs) {
    if (painter.renderPass !== 'offscreen' && painter.renderPass !== 'translucent')
        return;
    const context = painter.context;
    const depthMode = painter.depthModeForSublayer(0, DepthMode.ReadOnly);
    const colorMode = painter.colorModeForRenderPass();
    const [stencilModes, coords] = painter.renderPass === 'translucent' ?
        painter.stencilConfigForOverlap(tileIDs) : [{}, tileIDs];
    for (const coord of coords) {
        const tile = sourceCache.getTile(coord);
        if (typeof tile.needsHillshadePrepare !== 'undefined' && tile.needsHillshadePrepare && painter.renderPass === 'offscreen') {
            prepareHillshade(painter, tile, layer, depthMode, StencilMode.disabled, colorMode);
        }
        else if (painter.renderPass === 'translucent') {
            renderHillshade(painter, coord, tile, layer, depthMode, stencilModes[coord.overscaledZ], colorMode);
        }
    }
    context.viewport.set([0, 0, painter.width, painter.height]);
}
function renderHillshade(painter, coord, tile, layer, depthMode, stencilMode, colorMode) {
    const context = painter.context;
    const gl = context.gl;
    const fbo = tile.fbo;
    if (!fbo)
        return;
    const program = painter.useProgram('hillshade');
    const terrainData = painter.style.map.terrain && painter.style.map.terrain.getTerrainData(coord);
    context.activeTexture.set(gl.TEXTURE0);
    gl.bindTexture(gl.TEXTURE_2D, fbo.colorAttachment.get());
    const terrainCoord = terrainData ? coord : null;
    program.draw(context, gl.TRIANGLES, depthMode, stencilMode, colorMode, CullFaceMode.disabled, hillshadeUniformValues(painter, tile, layer, terrainCoord), terrainData, layer.id, painter.rasterBoundsBuffer, painter.quadTriangleIndexBuffer, painter.rasterBoundsSegments);
}
// hillshade rendering is done in two steps. the prepare step first calculates the slope of the terrain in the x and y
// directions for each pixel, and saves those values to a framebuffer texture in the r and g channels.
function prepareHillshade(painter, tile, layer, depthMode, stencilMode, colorMode) {
    const context = painter.context;
    const gl = context.gl;
    const dem = tile.dem;
    if (dem && dem.data) {
        const tileSize = dem.dim;
        const textureStride = dem.stride;
        const pixelData = dem.getPixels();
        context.activeTexture.set(gl.TEXTURE1);
        context.pixelStoreUnpackPremultiplyAlpha.set(false);
        tile.demTexture = tile.demTexture || painter.getTileTexture(textureStride);
        if (tile.demTexture) {
            const demTexture = tile.demTexture;
            demTexture.update(pixelData, { premultiply: false });
            demTexture.bind(gl.NEAREST, gl.CLAMP_TO_EDGE);
        }
        else {
            tile.demTexture = new Texture(context, pixelData, gl.RGBA, { premultiply: false });
            tile.demTexture.bind(gl.NEAREST, gl.CLAMP_TO_EDGE);
        }
        context.activeTexture.set(gl.TEXTURE0);
        let fbo = tile.fbo;
        if (!fbo) {
            const renderTexture = new Texture(context, { width: tileSize, height: tileSize, data: null }, gl.RGBA);
            renderTexture.bind(gl.LINEAR, gl.CLAMP_TO_EDGE);
            fbo = tile.fbo = context.createFramebuffer(tileSize, tileSize, true, false);
            fbo.colorAttachment.set(renderTexture.texture);
        }
        context.bindFramebuffer.set(fbo.framebuffer);
        context.viewport.set([0, 0, tileSize, tileSize]);
        painter.useProgram('hillshadePrepare').draw(context, gl.TRIANGLES, depthMode, stencilMode, colorMode, CullFaceMode.disabled, hillshadeUniformPrepareValues(tile.tileID, dem), null, layer.id, painter.rasterBoundsBuffer, painter.quadTriangleIndexBuffer, painter.rasterBoundsSegments);
        tile.needsHillshadePrepare = false;
    }
}

function drawRaster(painter, sourceCache, layer, tileIDs) {
    if (painter.renderPass !== 'translucent')
        return;
    if (layer.paint.get('raster-opacity') === 0)
        return;
    if (!tileIDs.length)
        return;
    const context = painter.context;
    const gl = context.gl;
    const source = sourceCache.getSource();
    const program = painter.useProgram('raster');
    const colorMode = painter.colorModeForRenderPass();
    const [stencilModes, coords] = source instanceof ImageSource ? [{}, tileIDs] :
        painter.stencilConfigForOverlap(tileIDs);
    const minTileZ = coords[coords.length - 1].overscaledZ;
    const align = !painter.options.moving;
    for (const coord of coords) {
        // Set the lower zoom level to sublayer 0, and higher zoom levels to higher sublayers
        // Use gl.LESS to prevent double drawing in areas where tiles overlap.
        const depthMode = painter.depthModeForSublayer(coord.overscaledZ - minTileZ, layer.paint.get('raster-opacity') === 1 ? DepthMode.ReadWrite : DepthMode.ReadOnly, gl.LESS);
        const tile = sourceCache.getTile(coord);
        tile.registerFadeDuration(layer.paint.get('raster-fade-duration'));
        const parentTile = sourceCache.findLoadedParent(coord, 0);
        const siblingTile = sourceCache.findLoadedSibling(coord);
        // Prefer parent tile if present
        const fadeTileReference = parentTile || siblingTile || null;
        const fade = getFadeValues(tile, fadeTileReference, sourceCache, layer, painter.transform, painter.style.map.terrain);
        let parentScaleBy, parentTL;
        const textureFilter = layer.paint.get('raster-resampling') === 'nearest' ? gl.NEAREST : gl.LINEAR;
        context.activeTexture.set(gl.TEXTURE0);
        tile.texture.bind(textureFilter, gl.CLAMP_TO_EDGE, gl.LINEAR_MIPMAP_NEAREST);
        context.activeTexture.set(gl.TEXTURE1);
        if (parentTile) {
            parentTile.texture.bind(textureFilter, gl.CLAMP_TO_EDGE, gl.LINEAR_MIPMAP_NEAREST);
            parentScaleBy = Math.pow(2, parentTile.tileID.overscaledZ - tile.tileID.overscaledZ);
            parentTL = [tile.tileID.canonical.x * parentScaleBy % 1, tile.tileID.canonical.y * parentScaleBy % 1];
        }
        else {
            tile.texture.bind(textureFilter, gl.CLAMP_TO_EDGE, gl.LINEAR_MIPMAP_NEAREST);
        }
        // Enable anisotropic filtering only when the pitch is greater than 20 degrees
        // to preserve image sharpness on flat or slightly tilted maps.
        if (tile.texture.useMipmap && context.extTextureFilterAnisotropic && painter.transform.pitch > 20) {
            gl.texParameterf(gl.TEXTURE_2D, context.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, context.extTextureFilterAnisotropicMax);
        }
        const terrainData = painter.style.map.terrain && painter.style.map.terrain.getTerrainData(coord);
        const terrainCoord = terrainData ? coord : null;
        const posMatrix = terrainCoord ? terrainCoord.posMatrix : painter.transform.calculatePosMatrix(coord.toUnwrapped(), align);
        const uniformValues = rasterUniformValues(posMatrix, parentTL || [0, 0], parentScaleBy || 1, fade, layer);
        if (source instanceof ImageSource) {
            program.draw(context, gl.TRIANGLES, depthMode, StencilMode.disabled, colorMode, CullFaceMode.disabled, uniformValues, terrainData, layer.id, source.boundsBuffer, painter.quadTriangleIndexBuffer, source.boundsSegments);
        }
        else {
            program.draw(context, gl.TRIANGLES, depthMode, stencilModes[coord.overscaledZ], colorMode, CullFaceMode.disabled, uniformValues, terrainData, layer.id, painter.rasterBoundsBuffer, painter.quadTriangleIndexBuffer, painter.rasterBoundsSegments);
        }
    }
}
function getFadeValues(tile, parentTile, sourceCache, layer, transform, terrain) {
    const fadeDuration = layer.paint.get('raster-fade-duration');
    if (!terrain && fadeDuration > 0) {
        const now = browser.now();
        const sinceTile = (now - tile.timeAdded) / fadeDuration;
        const sinceParent = parentTile ? (now - parentTile.timeAdded) / fadeDuration : -1;
        const source = sourceCache.getSource();
        const idealZ = transform.coveringZoomLevel({
            tileSize: source.tileSize,
            roundZoom: source.roundZoom
        });
        // if no parent or parent is older, fade in; if parent is younger, fade out
        const fadeIn = !parentTile || Math.abs(parentTile.tileID.overscaledZ - idealZ) > Math.abs(tile.tileID.overscaledZ - idealZ);
        const childOpacity = (fadeIn && tile.refreshedUponExpiration) ? 1 : performance$1.ad(fadeIn ? sinceTile : 1 - sinceParent, 0, 1);
        // we don't crossfade tiles that were just refreshed upon expiring:
        // once they're old enough to pass the crossfading threshold
        // (fadeDuration), unset the `refreshedUponExpiration` flag so we don't
        // incorrectly fail to crossfade them when zooming
        if (tile.refreshedUponExpiration && sinceTile >= 1)
            tile.refreshedUponExpiration = false;
        if (parentTile) {
            return {
                opacity: 1,
                mix: 1 - childOpacity
            };
        }
        else {
            return {
                opacity: childOpacity,
                mix: 0
            };
        }
    }
    else {
        return {
            opacity: 1,
            mix: 0
        };
    }
}

function drawBackground(painter, sourceCache, layer, coords) {
    const color = layer.paint.get('background-color');
    const opacity = layer.paint.get('background-opacity');
    if (opacity === 0)
        return;
    const context = painter.context;
    const gl = context.gl;
    const transform = painter.transform;
    const tileSize = transform.tileSize;
    const image = layer.paint.get('background-pattern');
    if (painter.isPatternMissing(image))
        return;
    const pass = (!image && color.a === 1 && opacity === 1 && painter.opaquePassEnabledForLayer()) ? 'opaque' : 'translucent';
    if (painter.renderPass !== pass)
        return;
    const stencilMode = StencilMode.disabled;
    const depthMode = painter.depthModeForSublayer(0, pass === 'opaque' ? DepthMode.ReadWrite : DepthMode.ReadOnly);
    const colorMode = painter.colorModeForRenderPass();
    const program = painter.useProgram(image ? 'backgroundPattern' : 'background');
    const tileIDs = coords ? coords : transform.coveringTiles({ tileSize, terrain: painter.style.map.terrain });
    if (image) {
        context.activeTexture.set(gl.TEXTURE0);
        painter.imageManager.bind(painter.context);
    }
    const crossfade = layer.getCrossfadeParameters();
    for (const tileID of tileIDs) {
        const matrix = coords ? tileID.posMatrix : painter.transform.calculatePosMatrix(tileID.toUnwrapped());
        const uniformValues = image ?
            backgroundPatternUniformValues(matrix, opacity, painter, image, { tileID, tileSize }, crossfade) :
            backgroundUniformValues(matrix, opacity, color);
        const terrainData = painter.style.map.terrain && painter.style.map.terrain.getTerrainData(tileID);
        program.draw(context, gl.TRIANGLES, depthMode, stencilMode, colorMode, CullFaceMode.disabled, uniformValues, terrainData, layer.id, painter.tileExtentBuffer, painter.quadTriangleIndexBuffer, painter.tileExtentSegments);
    }
}

const topColor = new performance$1.aN(1, 0, 0, 1);
const btmColor = new performance$1.aN(0, 1, 0, 1);
const leftColor = new performance$1.aN(0, 0, 1, 1);
const rightColor = new performance$1.aN(1, 0, 1, 1);
const centerColor = new performance$1.aN(0, 1, 1, 1);
function drawDebugPadding(painter) {
    const padding = painter.transform.padding;
    const lineWidth = 3;
    // Top
    drawHorizontalLine(painter, painter.transform.height - (padding.top || 0), lineWidth, topColor);
    // Bottom
    drawHorizontalLine(painter, padding.bottom || 0, lineWidth, btmColor);
    // Left
    drawVerticalLine(painter, padding.left || 0, lineWidth, leftColor);
    // Right
    drawVerticalLine(painter, painter.transform.width - (padding.right || 0), lineWidth, rightColor);
    // Center
    const center = painter.transform.centerPoint;
    drawCrosshair(painter, center.x, painter.transform.height - center.y, centerColor);
}
function drawCrosshair(painter, x, y, color) {
    const size = 20;
    const lineWidth = 2;
    //Vertical line
    drawDebugSSRect(painter, x - lineWidth / 2, y - size / 2, lineWidth, size, color);
    //Horizontal line
    drawDebugSSRect(painter, x - size / 2, y - lineWidth / 2, size, lineWidth, color);
}
function drawHorizontalLine(painter, y, lineWidth, color) {
    drawDebugSSRect(painter, 0, y + lineWidth / 2, painter.transform.width, lineWidth, color);
}
function drawVerticalLine(painter, x, lineWidth, color) {
    drawDebugSSRect(painter, x - lineWidth / 2, 0, lineWidth, painter.transform.height, color);
}
function drawDebugSSRect(painter, x, y, width, height, color) {
    const context = painter.context;
    const gl = context.gl;
    gl.enable(gl.SCISSOR_TEST);
    gl.scissor(x * painter.pixelRatio, y * painter.pixelRatio, width * painter.pixelRatio, height * painter.pixelRatio);
    context.clear({ color });
    gl.disable(gl.SCISSOR_TEST);
}
function drawDebug(painter, sourceCache, coords) {
    for (let i = 0; i < coords.length; i++) {
        drawDebugTile(painter, sourceCache, coords[i]);
    }
}
function drawDebugTile(painter, sourceCache, coord) {
    const context = painter.context;
    const gl = context.gl;
    const posMatrix = coord.posMatrix;
    const program = painter.useProgram('debug');
    const depthMode = DepthMode.disabled;
    const stencilMode = StencilMode.disabled;
    const colorMode = painter.colorModeForRenderPass();
    const id = '$debug';
    const terrainData = painter.style.map.terrain && painter.style.map.terrain.getTerrainData(coord);
    context.activeTexture.set(gl.TEXTURE0);
    const tileRawData = sourceCache.getTileByID(coord.key).latestRawTileData;
    const tileByteLength = (tileRawData && tileRawData.byteLength) || 0;
    const tileSizeKb = Math.floor(tileByteLength / 1024);
    const tileSize = sourceCache.getTile(coord).tileSize;
    const scaleRatio = (512 / Math.min(tileSize, 512) * (coord.overscaledZ / painter.transform.zoom)) * 0.5;
    let tileIdText = coord.canonical.toString();
    if (coord.overscaledZ !== coord.canonical.z) {
        tileIdText += ` => ${coord.overscaledZ}`;
    }
    const tileLabel = `${tileIdText} ${tileSizeKb}kB`;
    drawTextToOverlay(painter, tileLabel);
    program.draw(context, gl.TRIANGLES, depthMode, stencilMode, ColorMode.alphaBlended, CullFaceMode.disabled, debugUniformValues(posMatrix, performance$1.aN.transparent, scaleRatio), null, id, painter.debugBuffer, painter.quadTriangleIndexBuffer, painter.debugSegments);
    program.draw(context, gl.LINE_STRIP, depthMode, stencilMode, colorMode, CullFaceMode.disabled, debugUniformValues(posMatrix, performance$1.aN.red), terrainData, id, painter.debugBuffer, painter.tileBorderIndexBuffer, painter.debugSegments);
}
function drawTextToOverlay(painter, text) {
    painter.initDebugOverlayCanvas();
    const canvas = painter.debugOverlayCanvas;
    const gl = painter.context.gl;
    const ctx2d = painter.debugOverlayCanvas.getContext('2d');
    ctx2d.clearRect(0, 0, canvas.width, canvas.height);
    ctx2d.shadowColor = 'white';
    ctx2d.shadowBlur = 2;
    ctx2d.lineWidth = 1.5;
    ctx2d.strokeStyle = 'white';
    ctx2d.textBaseline = 'top';
    ctx2d.font = `bold ${36}px Open Sans, sans-serif`;
    ctx2d.fillText(text, 5, 5);
    ctx2d.strokeText(text, 5, 5);
    painter.debugOverlayTexture.update(canvas);
    painter.debugOverlayTexture.bind(gl.LINEAR, gl.CLAMP_TO_EDGE);
}
function selectDebugSource(style, zoom) {
    // Use vector source with highest maxzoom
    // Else use source with highest maxzoom of any type
    let selectedSource = null;
    const layers = Object.values(style._layers);
    const sources = layers.flatMap((layer) => {
        if (layer.source && !layer.isHidden(zoom)) {
            const sourceCache = style.sourceCaches[layer.source];
            return [sourceCache];
        }
        else {
            return [];
        }
    });
    const vectorSources = sources.filter((source) => source.getSource().type === 'vector');
    const otherSources = sources.filter((source) => source.getSource().type !== 'vector');
    const considerSource = (source) => {
        if (!selectedSource || (selectedSource.getSource().maxzoom < source.getSource().maxzoom)) {
            selectedSource = source;
        }
    };
    vectorSources.forEach((source) => considerSource(source));
    if (!selectedSource) {
        otherSources.forEach((source) => considerSource(source));
    }
    return selectedSource;
}

function drawCustom(painter, sourceCache, layer) {
    const context = painter.context;
    const implementation = layer.implementation;
    if (painter.renderPass === 'offscreen') {
        const prerender = implementation.prerender;
        if (prerender) {
            painter.setCustomLayerDefaults();
            context.setColorMode(painter.colorModeForRenderPass());
            prerender.call(implementation, context.gl, painter.transform.customLayerMatrix());
            context.setDirty();
            painter.setBaseState();
        }
    }
    else if (painter.renderPass === 'translucent') {
        painter.setCustomLayerDefaults();
        context.setColorMode(painter.colorModeForRenderPass());
        context.setStencilMode(StencilMode.disabled);
        const depthMode = implementation.renderingMode === '3d' ?
            new DepthMode(painter.context.gl.LEQUAL, DepthMode.ReadWrite, painter.depthRangeFor3D) :
            painter.depthModeForSublayer(0, DepthMode.ReadOnly);
        context.setDepthMode(depthMode);
        implementation.render(context.gl, painter.transform.customLayerMatrix(), { farZ: painter.transform.farZ, nearZ: painter.transform.nearZ, fov: painter.transform._fov, modelViewProjectionMatrix: painter.transform.modelViewProjectionMatrix, projectionMatrix: painter.transform.projectionMatrix });
        context.setDirty();
        painter.setBaseState();
        context.bindFramebuffer.set(null);
    }
}

/**
 * Redraw the Depth Framebuffer
 * @param painter - the painter
 * @param terrain - the terrain
 */
function drawDepth(painter, terrain) {
    const context = painter.context;
    const gl = context.gl;
    const colorMode = ColorMode.unblended;
    const depthMode = new DepthMode(gl.LEQUAL, DepthMode.ReadWrite, [0, 1]);
    const mesh = terrain.getTerrainMesh();
    const tiles = terrain.sourceCache.getRenderableTiles();
    const program = painter.useProgram('terrainDepth');
    context.bindFramebuffer.set(terrain.getFramebuffer('depth').framebuffer);
    context.viewport.set([0, 0, painter.width / devicePixelRatio, painter.height / devicePixelRatio]);
    context.clear({ color: performance$1.aN.transparent, depth: 1 });
    for (const tile of tiles) {
        const terrainData = terrain.getTerrainData(tile.tileID);
        const posMatrix = painter.transform.calculatePosMatrix(tile.tileID.toUnwrapped());
        const uniformValues = terrainDepthUniformValues(posMatrix, terrain.getMeshFrameDelta(painter.transform.zoom));
        program.draw(context, gl.TRIANGLES, depthMode, StencilMode.disabled, colorMode, CullFaceMode.backCCW, uniformValues, terrainData, 'terrain', mesh.vertexBuffer, mesh.indexBuffer, mesh.segments);
    }
    context.bindFramebuffer.set(null);
    context.viewport.set([0, 0, painter.width, painter.height]);
}
/**
 * Redraw the Coords Framebuffers
 * @param painter - the painter
 * @param terrain - the terrain
 */
function drawCoords(painter, terrain) {
    const context = painter.context;
    const gl = context.gl;
    const colorMode = ColorMode.unblended;
    const depthMode = new DepthMode(gl.LEQUAL, DepthMode.ReadWrite, [0, 1]);
    const mesh = terrain.getTerrainMesh();
    const coords = terrain.getCoordsTexture();
    const tiles = terrain.sourceCache.getRenderableTiles();
    // draw tile-coords into framebuffer
    const program = painter.useProgram('terrainCoords');
    context.bindFramebuffer.set(terrain.getFramebuffer('coords').framebuffer);
    context.viewport.set([0, 0, painter.width / devicePixelRatio, painter.height / devicePixelRatio]);
    context.clear({ color: performance$1.aN.transparent, depth: 1 });
    terrain.coordsIndex = [];
    for (const tile of tiles) {
        const terrainData = terrain.getTerrainData(tile.tileID);
        context.activeTexture.set(gl.TEXTURE0);
        gl.bindTexture(gl.TEXTURE_2D, coords.texture);
        const posMatrix = painter.transform.calculatePosMatrix(tile.tileID.toUnwrapped());
        const uniformValues = terrainCoordsUniformValues(posMatrix, 255 - terrain.coordsIndex.length, terrain.getMeshFrameDelta(painter.transform.zoom));
        program.draw(context, gl.TRIANGLES, depthMode, StencilMode.disabled, colorMode, CullFaceMode.backCCW, uniformValues, terrainData, 'terrain', mesh.vertexBuffer, mesh.indexBuffer, mesh.segments);
        terrain.coordsIndex.push(tile.tileID.key);
    }
    context.bindFramebuffer.set(null);
    context.viewport.set([0, 0, painter.width, painter.height]);
}
function drawTerrain(painter, terrain, tiles) {
    const context = painter.context;
    const gl = context.gl;
    const colorMode = painter.colorModeForRenderPass();
    const depthMode = new DepthMode(gl.LEQUAL, DepthMode.ReadWrite, painter.depthRangeFor3D);
    const program = painter.useProgram('terrain');
    const mesh = terrain.getTerrainMesh();
    context.bindFramebuffer.set(null);
    context.viewport.set([0, 0, painter.width, painter.height]);
    for (const tile of tiles) {
        const texture = painter.renderToTexture.getTexture(tile);
        const terrainData = terrain.getTerrainData(tile.tileID);
        context.activeTexture.set(gl.TEXTURE0);
        gl.bindTexture(gl.TEXTURE_2D, texture.texture);
        const posMatrix = painter.transform.calculatePosMatrix(tile.tileID.toUnwrapped());
        const eleDelta = terrain.getMeshFrameDelta(painter.transform.zoom);
        const fogMatrix = painter.transform.calculateFogMatrix(tile.tileID.toUnwrapped());
        const uniformValues = terrainUniformValues(posMatrix, eleDelta, fogMatrix, painter.style.sky, painter.transform.pitch);
        program.draw(context, gl.TRIANGLES, depthMode, StencilMode.disabled, colorMode, CullFaceMode.backCCW, uniformValues, terrainData, 'terrain', mesh.vertexBuffer, mesh.indexBuffer, mesh.segments);
    }
}

class Mesh {
    constructor(vertexBuffer, indexBuffer, segments) {
        this.vertexBuffer = vertexBuffer;
        this.indexBuffer = indexBuffer;
        this.segments = segments;
    }
    destroy() {
        this.vertexBuffer.destroy();
        this.indexBuffer.destroy();
        this.segments.destroy();
        this.vertexBuffer = null;
        this.indexBuffer = null;
        this.segments = null;
    }
}

function drawSky(painter, sky) {
    const context = painter.context;
    const gl = context.gl;
    const skyUniforms = skyUniformValues(sky, painter.style.map.transform, painter.pixelRatio);
    const depthMode = new DepthMode(gl.LEQUAL, DepthMode.ReadWrite, [0, 1]);
    const stencilMode = StencilMode.disabled;
    const colorMode = painter.colorModeForRenderPass();
    const program = painter.useProgram('sky');
    if (!sky.mesh) {
        const vertexArray = new performance$1.aX();
        vertexArray.emplaceBack(-1, -1);
        vertexArray.emplaceBack(1, -1);
        vertexArray.emplaceBack(1, 1);
        vertexArray.emplaceBack(-1, 1);
        const indexArray = new performance$1.aY();
        indexArray.emplaceBack(0, 1, 2);
        indexArray.emplaceBack(0, 2, 3);
        sky.mesh = new Mesh(context.createVertexBuffer(vertexArray, posAttributes.members), context.createIndexBuffer(indexArray), performance$1.a0.simpleSegment(0, 0, vertexArray.length, indexArray.length));
    }
    program.draw(context, gl.TRIANGLES, depthMode, stencilMode, colorMode, CullFaceMode.disabled, skyUniforms, undefined, 'sky', sky.mesh.vertexBuffer, sky.mesh.indexBuffer, sky.mesh.segments);
}

/**
 * @internal
 * Initialize a new painter object.
 */
class Painter {
    constructor(gl, transform) {
        this.context = new Context(gl);
        this.transform = transform;
        this._tileTextures = {};
        this.terrainFacilitator = { dirty: true, matrix: performance$1.ao(new Float64Array(16)), renderTime: 0 };
        this.setup();
        // Within each layer there are multiple distinct z-planes that can be drawn to.
        // This is implemented using the WebGL depth buffer.
        this.numSublayers = SourceCache.maxUnderzooming + SourceCache.maxOverzooming + 1;
        this.depthEpsilon = 1 / Math.pow(2, 16);
        this.crossTileSymbolIndex = new CrossTileSymbolIndex();
    }
    /*
     * Update the GL viewport, projection matrix, and transforms to compensate
     * for a new width and height value.
     */
    resize(width, height, pixelRatio) {
        this.width = Math.floor(width * pixelRatio);
        this.height = Math.floor(height * pixelRatio);
        this.pixelRatio = pixelRatio;
        this.context.viewport.set([0, 0, this.width, this.height]);
        if (this.style) {
            for (const layerId of this.style._order) {
                this.style._layers[layerId].resize();
            }
        }
    }
    setup() {
        const context = this.context;
        const tileExtentArray = new performance$1.aX();
        tileExtentArray.emplaceBack(0, 0);
        tileExtentArray.emplaceBack(performance$1.X, 0);
        tileExtentArray.emplaceBack(0, performance$1.X);
        tileExtentArray.emplaceBack(performance$1.X, performance$1.X);
        this.tileExtentBuffer = context.createVertexBuffer(tileExtentArray, posAttributes.members);
        this.tileExtentSegments = performance$1.a0.simpleSegment(0, 0, 4, 2);
        const debugArray = new performance$1.aX();
        debugArray.emplaceBack(0, 0);
        debugArray.emplaceBack(performance$1.X, 0);
        debugArray.emplaceBack(0, performance$1.X);
        debugArray.emplaceBack(performance$1.X, performance$1.X);
        this.debugBuffer = context.createVertexBuffer(debugArray, posAttributes.members);
        this.debugSegments = performance$1.a0.simpleSegment(0, 0, 4, 5);
        const rasterBoundsArray = new performance$1.$();
        rasterBoundsArray.emplaceBack(0, 0, 0, 0);
        rasterBoundsArray.emplaceBack(performance$1.X, 0, performance$1.X, 0);
        rasterBoundsArray.emplaceBack(0, performance$1.X, 0, performance$1.X);
        rasterBoundsArray.emplaceBack(performance$1.X, performance$1.X, performance$1.X, performance$1.X);
        this.rasterBoundsBuffer = context.createVertexBuffer(rasterBoundsArray, rasterBoundsAttributes.members);
        this.rasterBoundsSegments = performance$1.a0.simpleSegment(0, 0, 4, 2);
        const viewportArray = new performance$1.aX();
        viewportArray.emplaceBack(0, 0);
        viewportArray.emplaceBack(1, 0);
        viewportArray.emplaceBack(0, 1);
        viewportArray.emplaceBack(1, 1);
        this.viewportBuffer = context.createVertexBuffer(viewportArray, posAttributes.members);
        this.viewportSegments = performance$1.a0.simpleSegment(0, 0, 4, 2);
        const tileLineStripIndices = new performance$1.aZ();
        tileLineStripIndices.emplaceBack(0);
        tileLineStripIndices.emplaceBack(1);
        tileLineStripIndices.emplaceBack(3);
        tileLineStripIndices.emplaceBack(2);
        tileLineStripIndices.emplaceBack(0);
        this.tileBorderIndexBuffer = context.createIndexBuffer(tileLineStripIndices);
        const quadTriangleIndices = new performance$1.aY();
        quadTriangleIndices.emplaceBack(0, 1, 2);
        quadTriangleIndices.emplaceBack(2, 1, 3);
        this.quadTriangleIndexBuffer = context.createIndexBuffer(quadTriangleIndices);
        const gl = this.context.gl;
        this.stencilClearMode = new StencilMode({ func: gl.ALWAYS, mask: 0 }, 0x0, 0xFF, gl.ZERO, gl.ZERO, gl.ZERO);
    }
    /*
     * Reset the drawing canvas by clearing the stencil buffer so that we can draw
     * new tiles at the same location, while retaining previously drawn pixels.
     */
    clearStencil() {
        const context = this.context;
        const gl = context.gl;
        this.nextStencilID = 1;
        this.currentStencilSource = undefined;
        // As a temporary workaround for https://github.com/mapbox/mapbox-gl-js/issues/5490,
        // pending an upstream fix, we draw a fullscreen stencil=0 clipping mask here,
        // effectively clearing the stencil buffer: once an upstream patch lands, remove
        // this function in favor of context.clear({ stencil: 0x0 })
        const matrix = performance$1.H();
        performance$1.aQ(matrix, 0, this.width, this.height, 0, 0, 1);
        performance$1.K(matrix, matrix, [gl.drawingBufferWidth, gl.drawingBufferHeight, 0]);
        this.useProgram('clippingMask').draw(context, gl.TRIANGLES, DepthMode.disabled, this.stencilClearMode, ColorMode.disabled, CullFaceMode.disabled, clippingMaskUniformValues(matrix), null, '$clipping', this.viewportBuffer, this.quadTriangleIndexBuffer, this.viewportSegments);
    }
    _renderTileClippingMasks(layer, tileIDs) {
        if (this.currentStencilSource === layer.source || !layer.isTileClipped() || !tileIDs || !tileIDs.length)
            return;
        this.currentStencilSource = layer.source;
        const context = this.context;
        const gl = context.gl;
        if (this.nextStencilID + tileIDs.length > 256) {
            // we'll run out of fresh IDs so we need to clear and start from scratch
            this.clearStencil();
        }
        context.setColorMode(ColorMode.disabled);
        context.setDepthMode(DepthMode.disabled);
        const program = this.useProgram('clippingMask');
        this._tileClippingMaskIDs = {};
        for (const tileID of tileIDs) {
            const id = this._tileClippingMaskIDs[tileID.key] = this.nextStencilID++;
            const terrainData = this.style.map.terrain && this.style.map.terrain.getTerrainData(tileID);
            program.draw(context, gl.TRIANGLES, DepthMode.disabled, 
            // Tests will always pass, and ref value will be written to stencil buffer.
            new StencilMode({ func: gl.ALWAYS, mask: 0 }, id, 0xFF, gl.KEEP, gl.KEEP, gl.REPLACE), ColorMode.disabled, CullFaceMode.disabled, clippingMaskUniformValues(tileID.posMatrix), terrainData, '$clipping', this.tileExtentBuffer, this.quadTriangleIndexBuffer, this.tileExtentSegments);
        }
    }
    stencilModeFor3D() {
        this.currentStencilSource = undefined;
        if (this.nextStencilID + 1 > 256) {
            this.clearStencil();
        }
        const id = this.nextStencilID++;
        const gl = this.context.gl;
        return new StencilMode({ func: gl.NOTEQUAL, mask: 0xFF }, id, 0xFF, gl.KEEP, gl.KEEP, gl.REPLACE);
    }
    stencilModeForClipping(tileID) {
        const gl = this.context.gl;
        return new StencilMode({ func: gl.EQUAL, mask: 0xFF }, this._tileClippingMaskIDs[tileID.key], 0x00, gl.KEEP, gl.KEEP, gl.REPLACE);
    }
    /*
     * Sort coordinates by Z as drawing tiles is done in Z-descending order.
     * All children with the same Z write the same stencil value.  Children
     * stencil values are greater than parent's.  This is used only for raster
     * and raster-dem tiles, which are already clipped to tile boundaries, to
     * mask area of tile overlapped by children tiles.
     * Stencil ref values continue range used in _tileClippingMaskIDs.
     *
     * Returns [StencilMode for tile overscaleZ map, sortedCoords].
     */
    stencilConfigForOverlap(tileIDs) {
        const gl = this.context.gl;
        const coords = tileIDs.sort((a, b) => b.overscaledZ - a.overscaledZ);
        const minTileZ = coords[coords.length - 1].overscaledZ;
        const stencilValues = coords[0].overscaledZ - minTileZ + 1;
        if (stencilValues > 1) {
            this.currentStencilSource = undefined;
            if (this.nextStencilID + stencilValues > 256) {
                this.clearStencil();
            }
            const zToStencilMode = {};
            for (let i = 0; i < stencilValues; i++) {
                zToStencilMode[i + minTileZ] = new StencilMode({ func: gl.GEQUAL, mask: 0xFF }, i + this.nextStencilID, 0xFF, gl.KEEP, gl.KEEP, gl.REPLACE);
            }
            this.nextStencilID += stencilValues;
            return [zToStencilMode, coords];
        }
        return [{ [minTileZ]: StencilMode.disabled }, coords];
    }
    colorModeForRenderPass() {
        const gl = this.context.gl;
        if (this._showOverdrawInspector) {
            const numOverdrawSteps = 8;
            const a = 1 / numOverdrawSteps;
            return new ColorMode([gl.CONSTANT_COLOR, gl.ONE], new performance$1.aN(a, a, a, 0), [true, true, true, true]);
        }
        else if (this.renderPass === 'opaque') {
            return ColorMode.unblended;
        }
        else {
            return ColorMode.alphaBlended;
        }
    }
    depthModeForSublayer(n, mask, func) {
        if (!this.opaquePassEnabledForLayer())
            return DepthMode.disabled;
        const depth = 1 - ((1 + this.currentLayer) * this.numSublayers + n) * this.depthEpsilon;
        return new DepthMode(func || this.context.gl.LEQUAL, mask, [depth, depth]);
    }
    /*
     * The opaque pass and 3D layers both use the depth buffer.
     * Layers drawn above 3D layers need to be drawn using the
     * painter's algorithm so that they appear above 3D features.
     * This returns true for layers that can be drawn using the
     * opaque pass.
     */
    opaquePassEnabledForLayer() {
        return this.currentLayer < this.opaquePassCutoff;
    }
    render(style, options) {
        var _a;
        this.style = style;
        this.options = options;
        this.lineAtlas = style.lineAtlas;
        this.imageManager = style.imageManager;
        this.glyphManager = style.glyphManager;
        this.symbolFadeChange = style.placement.symbolFadeChange(browser.now());
        this.imageManager.beginFrame();
        const layerIds = this.style._order;
        const sourceCaches = this.style.sourceCaches;
        const coordsAscending = {};
        const coordsDescending = {};
        const coordsDescendingSymbol = {};
        for (const id in sourceCaches) {
            const sourceCache = sourceCaches[id];
            if (sourceCache.used) {
                sourceCache.prepare(this.context);
            }
            coordsAscending[id] = sourceCache.getVisibleCoordinates();
            coordsDescending[id] = coordsAscending[id].slice().reverse();
            coordsDescendingSymbol[id] = sourceCache.getVisibleCoordinates(true).reverse();
        }
        this.opaquePassCutoff = Infinity;
        for (let i = 0; i < layerIds.length; i++) {
            const layerId = layerIds[i];
            if (this.style._layers[layerId].is3D()) {
                this.opaquePassCutoff = i;
                break;
            }
        }
        this.maybeDrawDepthAndCoords(false);
        if (this.renderToTexture) {
            this.renderToTexture.prepareForRender(this.style, this.transform.zoom);
            // this is disabled, because render-to-texture is rendering all layers from bottom to top.
            this.opaquePassCutoff = 0;
        }
        // Offscreen pass ===============================================
        // We first do all rendering that requires rendering to a separate
        // framebuffer, and then save those for rendering back to the map
        // later: in doing this we avoid doing expensive framebuffer restores.
        this.renderPass = 'offscreen';
        for (const layerId of layerIds) {
            const layer = this.style._layers[layerId];
            if (!layer.hasOffscreenPass() || layer.isHidden(this.transform.zoom))
                continue;
            const coords = coordsDescending[layer.source];
            if (layer.type !== 'custom' && !coords.length)
                continue;
            this.renderLayer(this, sourceCaches[layer.source], layer, coords);
        }
        // Rebind the main framebuffer now that all offscreen layers have been rendered:
        this.context.bindFramebuffer.set(null);
        // Clear buffers in preparation for drawing to the main framebuffer
        this.context.clear({ color: options.showOverdrawInspector ? performance$1.aN.black : performance$1.aN.transparent, depth: 1 });
        this.clearStencil();
        // draw sky first to not overwrite symbols
        if ((_a = this.style.stylesheet) === null || _a === void 0 ? void 0 : _a.sky)
            drawSky(this, this.style.sky);
        this._showOverdrawInspector = options.showOverdrawInspector;
        this.depthRangeFor3D = [0, 1 - ((style._order.length + 2) * this.numSublayers * this.depthEpsilon)];
        // Opaque pass ===============================================
        // Draw opaque layers top-to-bottom first.
        if (!this.renderToTexture) {
            this.renderPass = 'opaque';
            for (this.currentLayer = layerIds.length - 1; this.currentLayer >= 0; this.currentLayer--) {
                const layer = this.style._layers[layerIds[this.currentLayer]];
                const sourceCache = sourceCaches[layer.source];
                const coords = coordsAscending[layer.source];
                this._renderTileClippingMasks(layer, coords);
                this.renderLayer(this, sourceCache, layer, coords);
            }
        }
        // Translucent pass ===============================================
        // Draw all other layers bottom-to-top.
        this.renderPass = 'translucent';
        for (this.currentLayer = 0; this.currentLayer < layerIds.length; this.currentLayer++) {
            const layer = this.style._layers[layerIds[this.currentLayer]];
            const sourceCache = sourceCaches[layer.source];
            if (this.renderToTexture && this.renderToTexture.renderLayer(layer))
                continue;
            // For symbol layers in the translucent pass, we add extra tiles to the renderable set
            // for cross-tile symbol fading. Symbol layers don't use tile clipping, so no need to render
            // separate clipping masks
            const coords = (layer.type === 'symbol' ? coordsDescendingSymbol : coordsDescending)[layer.source];
            this._renderTileClippingMasks(layer, coordsAscending[layer.source]);
            this.renderLayer(this, sourceCache, layer, coords);
        }
        if (this.options.showTileBoundaries) {
            const selectedSource = selectDebugSource(this.style, this.transform.zoom);
            if (selectedSource) {
                drawDebug(this, selectedSource, selectedSource.getVisibleCoordinates());
            }
        }
        if (this.options.showPadding) {
            drawDebugPadding(this);
        }
        // Set defaults for most GL values so that anyone using the state after the render
        // encounters more expected values.
        this.context.setDefault();
    }
    /**
     * Update the depth and coords framebuffers, if the contents of those frame buffers is out of date.
     * If requireExact is false, then the contents of those frame buffers is not updated if it is close
     * to accurate (that is, the camera has not moved much since it was updated last).
     */
    maybeDrawDepthAndCoords(requireExact) {
        if (!this.style || !this.style.map || !this.style.map.terrain) {
            return;
        }
        const prevMatrix = this.terrainFacilitator.matrix;
        const currMatrix = this.transform.modelViewProjectionMatrix;
        // Update coords/depth-framebuffer on camera movement, or tile reloading
        let doUpdate = this.terrainFacilitator.dirty;
        doUpdate || (doUpdate = requireExact ? !performance$1.a_(prevMatrix, currMatrix) : !performance$1.a$(prevMatrix, currMatrix));
        doUpdate || (doUpdate = this.style.map.terrain.sourceCache.tilesAfterTime(this.terrainFacilitator.renderTime).length > 0);
        if (!doUpdate) {
            return;
        }
        performance$1.b0(prevMatrix, currMatrix);
        this.terrainFacilitator.renderTime = Date.now();
        this.terrainFacilitator.dirty = false;
        drawDepth(this, this.style.map.terrain);
        drawCoords(this, this.style.map.terrain);
    }
    renderLayer(painter, sourceCache, layer, coords) {
        if (layer.isHidden(this.transform.zoom))
            return;
        if (layer.type !== 'background' && layer.type !== 'custom' && !(coords || []).length)
            return;
        this.id = layer.id;
        switch (layer.type) {
            case 'symbol':
                drawSymbols(painter, sourceCache, layer, coords, this.style.placement.variableOffsets);
                break;
            case 'circle':
                drawCircles(painter, sourceCache, layer, coords);
                break;
            case 'heatmap':
                drawHeatmap(painter, sourceCache, layer, coords);
                break;
            case 'line':
                drawLine(painter, sourceCache, layer, coords);
                break;
            case 'fill':
                drawFill(painter, sourceCache, layer, coords);
                break;
            case 'fill-extrusion':
                drawFillExtrusion(painter, sourceCache, layer, coords);
                break;
            case 'hillshade':
                drawHillshade(painter, sourceCache, layer, coords);
                break;
            case 'raster':
                drawRaster(painter, sourceCache, layer, coords);
                break;
            case 'background':
                drawBackground(painter, sourceCache, layer, coords);
                break;
            case 'custom':
                drawCustom(painter, sourceCache, layer);
                break;
        }
    }
    /**
     * Transform a matrix to incorporate the *-translate and *-translate-anchor properties into it.
     * @param inViewportPixelUnitsUnits - True when the units accepted by the matrix are in viewport pixels instead of tile units.
     * @returns matrix
     */
    translatePosMatrix(matrix, tile, translate, translateAnchor, inViewportPixelUnitsUnits) {
        if (!translate[0] && !translate[1])
            return matrix;
        const angle = inViewportPixelUnitsUnits ?
            (translateAnchor === 'map' ? this.transform.angle : 0) :
            (translateAnchor === 'viewport' ? -this.transform.angle : 0);
        if (angle) {
            const sinA = Math.sin(angle);
            const cosA = Math.cos(angle);
            translate = [
                translate[0] * cosA - translate[1] * sinA,
                translate[0] * sinA + translate[1] * cosA
            ];
        }
        const translation = [
            inViewportPixelUnitsUnits ? translate[0] : pixelsToTileUnits(tile, translate[0], this.transform.zoom),
            inViewportPixelUnitsUnits ? translate[1] : pixelsToTileUnits(tile, translate[1], this.transform.zoom),
            0
        ];
        const translatedMatrix = new Float32Array(16);
        performance$1.J(translatedMatrix, matrix, translation);
        return translatedMatrix;
    }
    saveTileTexture(texture) {
        const textures = this._tileTextures[texture.size[0]];
        if (!textures) {
            this._tileTextures[texture.size[0]] = [texture];
        }
        else {
            textures.push(texture);
        }
    }
    getTileTexture(size) {
        const textures = this._tileTextures[size];
        return textures && textures.length > 0 ? textures.pop() : null;
    }
    /**
     * Checks whether a pattern image is needed, and if it is, whether it is not loaded.
     *
     * @returns true if a needed image is missing and rendering needs to be skipped.
     */
    isPatternMissing(image) {
        if (!image)
            return false;
        if (!image.from || !image.to)
            return true;
        const imagePosA = this.imageManager.getPattern(image.from.toString());
        const imagePosB = this.imageManager.getPattern(image.to.toString());
        return !imagePosA || !imagePosB;
    }
    useProgram(name, programConfiguration) {
        this.cache = this.cache || {};
        const key = name +
            (programConfiguration ? programConfiguration.cacheKey : '') +
            (this._showOverdrawInspector ? '/overdraw' : '') +
            (this.style.map.terrain ? '/terrain' : '');
        if (!this.cache[key]) {
            this.cache[key] = new Program(this.context, shaders[name], programConfiguration, programUniforms[name], this._showOverdrawInspector, this.style.map.terrain);
        }
        return this.cache[key];
    }
    /*
     * Reset some GL state to default values to avoid hard-to-debug bugs
     * in custom layers.
     */
    setCustomLayerDefaults() {
        // Prevent custom layers from unintentionally modify the last VAO used.
        // All other state is state is restored on it's own, but for VAOs it's
        // simpler to unbind so that we don't have to track the state of VAOs.
        this.context.unbindVAO();
        // The default values for this state is meaningful and often expected.
        // Leaving this state dirty could cause a lot of confusion for users.
        this.context.cullFace.setDefault();
        this.context.activeTexture.setDefault();
        this.context.pixelStoreUnpack.setDefault();
        this.context.pixelStoreUnpackPremultiplyAlpha.setDefault();
        this.context.pixelStoreUnpackFlipY.setDefault();
    }
    /*
     * Set GL state that is shared by all layers.
     */
    setBaseState() {
        const gl = this.context.gl;
        this.context.cullFace.set(false);
        this.context.viewport.set([0, 0, this.width, this.height]);
        this.context.blendEquation.set(gl.FUNC_ADD);
    }
    initDebugOverlayCanvas() {
        if (this.debugOverlayCanvas == null) {
            this.debugOverlayCanvas = document.createElement('canvas');
            this.debugOverlayCanvas.width = 512;
            this.debugOverlayCanvas.height = 512;
            const gl = this.context.gl;
            this.debugOverlayTexture = new Texture(this.context, this.debugOverlayCanvas, gl.RGBA);
        }
    }
    destroy() {
        if (this.debugOverlayTexture) {
            this.debugOverlayTexture.destroy();
        }
    }
    /*
     * Return true if drawing buffer size is != from requested size.
     * That means that we've reached GL limits somehow.
     * Note: drawing buffer size changes only when canvas size changes
     */
    overLimit() {
        const { drawingBufferWidth, drawingBufferHeight } = this.context.gl;
        return this.width !== drawingBufferWidth || this.height !== drawingBufferHeight;
    }
}

class Frustum {
    constructor(points, planes) {
        this.points = points;
        this.planes = planes;
    }
    static fromInvProjectionMatrix(invProj, worldSize, zoom) {
        const clipSpaceCorners = [
            [-1, 1, -1, 1],
            [1, 1, -1, 1],
            [1, -1, -1, 1],
            [-1, -1, -1, 1],
            [-1, 1, 1, 1],
            [1, 1, 1, 1],
            [1, -1, 1, 1],
            [-1, -1, 1, 1]
        ];
        const scale = Math.pow(2, zoom);
        // Transform frustum corner points from clip space to tile space, Z to meters
        const frustumCoords = clipSpaceCorners.map(v => {
            v = performance$1.ag([], v, invProj);
            const s = 1.0 / v[3] / worldSize * scale;
            return performance$1.b1(v, v, [s, s, 1.0 / v[3], s]);
        });
        const frustumPlanePointIndices = [
            [0, 1, 2], // near
            [6, 5, 4], // far
            [0, 3, 7], // left
            [2, 1, 5], // right
            [3, 2, 6], // bottom
            [0, 4, 5] // top
        ];
        const frustumPlanes = frustumPlanePointIndices.map((p) => {
            const a = sub([], frustumCoords[p[0]], frustumCoords[p[1]]);
            const b = sub([], frustumCoords[p[2]], frustumCoords[p[1]]);
            const n = normalize([], cross([], a, b));
            const d = -dot(n, frustumCoords[p[1]]);
            return n.concat(d);
        });
        return new Frustum(frustumCoords, frustumPlanes);
    }
}
class Aabb {
    constructor(min_, max_) {
        this.min = min_;
        this.max = max_;
        this.center = scale([], add([], this.min, this.max), 0.5);
    }
    quadrant(index) {
        const split = [(index % 2) === 0, index < 2];
        const qMin = clone(this.min);
        const qMax = clone(this.max);
        for (let axis = 0; axis < split.length; axis++) {
            qMin[axis] = split[axis] ? this.min[axis] : this.center[axis];
            qMax[axis] = split[axis] ? this.center[axis] : this.max[axis];
        }
        // Elevation is always constant, hence quadrant.max.z = this.max.z
        qMax[2] = this.max[2];
        return new Aabb(qMin, qMax);
    }
    distanceX(point) {
        const pointOnAabb = Math.max(Math.min(this.max[0], point[0]), this.min[0]);
        return pointOnAabb - point[0];
    }
    distanceY(point) {
        const pointOnAabb = Math.max(Math.min(this.max[1], point[1]), this.min[1]);
        return pointOnAabb - point[1];
    }
    // Performs a frustum-aabb intersection test. Returns 0 if there's no intersection,
    // 1 if shapes are intersecting and 2 if the aabb if fully inside the frustum.
    intersects(frustum) {
        // Execute separating axis test between two convex objects to find intersections
        // Each frustum plane together with 3 major axes define the separating axes
        const aabbPoints = [
            [this.min[0], this.min[1], this.min[2], 1],
            [this.max[0], this.min[1], this.min[2], 1],
            [this.max[0], this.max[1], this.min[2], 1],
            [this.min[0], this.max[1], this.min[2], 1],
            [this.min[0], this.min[1], this.max[2], 1],
            [this.max[0], this.min[1], this.max[2], 1],
            [this.max[0], this.max[1], this.max[2], 1],
            [this.min[0], this.max[1], this.max[2], 1]
        ];
        let fullyInside = true;
        for (let p = 0; p < frustum.planes.length; p++) {
            const plane = frustum.planes[p];
            let pointsInside = 0;
            for (let i = 0; i < aabbPoints.length; i++) {
                if (performance$1.b2(plane, aabbPoints[i]) >= 0) {
                    pointsInside++;
                }
            }
            if (pointsInside === 0)
                return 0;
            if (pointsInside !== aabbPoints.length)
                fullyInside = false;
        }
        if (fullyInside)
            return 2;
        for (let axis = 0; axis < 3; axis++) {
            let projMin = Number.MAX_VALUE;
            let projMax = -Number.MAX_VALUE;
            for (let p = 0; p < frustum.points.length; p++) {
                const projectedPoint = frustum.points[p][axis] - this.min[axis];
                projMin = Math.min(projMin, projectedPoint);
                projMax = Math.max(projMax, projectedPoint);
            }
            if (projMax < 0 || projMin > this.max[axis] - this.min[axis])
                return 0;
        }
        return 1;
    }
}

/**
 * An `EdgeInset` object represents screen space padding applied to the edges of the viewport.
 * This shifts the apprent center or the vanishing point of the map. This is useful for adding floating UI elements
 * on top of the map and having the vanishing point shift as UI elements resize.
 *
 * @group Geography and Geometry
 */
class EdgeInsets {
    constructor(top = 0, bottom = 0, left = 0, right = 0) {
        if (isNaN(top) || top < 0 ||
            isNaN(bottom) || bottom < 0 ||
            isNaN(left) || left < 0 ||
            isNaN(right) || right < 0) {
            throw new Error('Invalid value for edge-insets, top, bottom, left and right must all be numbers');
        }
        this.top = top;
        this.bottom = bottom;
        this.left = left;
        this.right = right;
    }
    /**
     * Interpolates the inset in-place.
     * This maintains the current inset value for any inset not present in `target`.
     * @param start - interpolation start
     * @param target - interpolation target
     * @param t - interpolation step/weight
     * @returns the insets
     */
    interpolate(start, target, t) {
        if (target.top != null && start.top != null)
            this.top = performance$1.z.number(start.top, target.top, t);
        if (target.bottom != null && start.bottom != null)
            this.bottom = performance$1.z.number(start.bottom, target.bottom, t);
        if (target.left != null && start.left != null)
            this.left = performance$1.z.number(start.left, target.left, t);
        if (target.right != null && start.right != null)
            this.right = performance$1.z.number(start.right, target.right, t);
        return this;
    }
    /**
     * Utility method that computes the new apprent center or vanishing point after applying insets.
     * This is in pixels and with the top left being (0.0) and +y being downwards.
     *
     * @param width - the width
     * @param height - the height
     * @returns the point
     */
    getCenter(width, height) {
        // Clamp insets so they never overflow width/height and always calculate a valid center
        const x = performance$1.ad((this.left + width - this.right) / 2, 0, width);
        const y = performance$1.ad((this.top + height - this.bottom) / 2, 0, height);
        return new performance$1.P(x, y);
    }
    equals(other) {
        return this.top === other.top &&
            this.bottom === other.bottom &&
            this.left === other.left &&
            this.right === other.right;
    }
    clone() {
        return new EdgeInsets(this.top, this.bottom, this.left, this.right);
    }
    /**
     * Returns the current state as json, useful when you want to have a
     * read-only representation of the inset.
     *
     * @returns state as json
     */
    toJSON() {
        return {
            top: this.top,
            bottom: this.bottom,
            left: this.left,
            right: this.right
        };
    }
}

const MAX_VALID_LATITUDE = 85.051129;
/**
 * @internal
 * A single transform, generally used for a single tile to be
 * scaled, rotated, and zoomed.
 */
class Transform {
    constructor(minZoom, maxZoom, minPitch, maxPitch, renderWorldCopies) {
        this.tileSize = 512; // constant
        this._renderWorldCopies = renderWorldCopies === undefined ? true : !!renderWorldCopies;
        this._minZoom = minZoom || 0;
        this._maxZoom = maxZoom || 22;
        this._minPitch = (minPitch === undefined || minPitch === null) ? 0 : minPitch;
        this._maxPitch = (maxPitch === undefined || maxPitch === null) ? 60 : maxPitch;
        this.setMaxBounds();
        this.width = 0;
        this.height = 0;
        this._center = new performance$1.N(0, 0);
        this._elevation = 0;
        this.zoom = 0;
        this.angle = 0;
        this._fov = 0.6435011087932844;
        this._pitch = 0;
        this._unmodified = true;
        this._edgeInsets = new EdgeInsets();
        this._posMatrixCache = {};
        this._alignedPosMatrixCache = {};
        this._fogMatrixCache = {};
        this.minElevationForCurrentTile = 0;
    }
    clone() {
        const clone = new Transform(this._minZoom, this._maxZoom, this._minPitch, this.maxPitch, this._renderWorldCopies);
        clone.apply(this);
        return clone;
    }
    apply(that) {
        this.tileSize = that.tileSize;
        this.latRange = that.latRange;
        this.width = that.width;
        this.height = that.height;
        this._center = that._center;
        this._elevation = that._elevation;
        this.minElevationForCurrentTile = that.minElevationForCurrentTile;
        this.zoom = that.zoom;
        this.angle = that.angle;
        this._fov = that._fov;
        this._pitch = that._pitch;
        this._unmodified = that._unmodified;
        this._edgeInsets = that._edgeInsets.clone();
        this._calcMatrices();
    }
    get minZoom() { return this._minZoom; }
    set minZoom(zoom) {
        if (this._minZoom === zoom)
            return;
        this._minZoom = zoom;
        this.zoom = Math.max(this.zoom, zoom);
    }
    get maxZoom() { return this._maxZoom; }
    set maxZoom(zoom) {
        if (this._maxZoom === zoom)
            return;
        this._maxZoom = zoom;
        this.zoom = Math.min(this.zoom, zoom);
    }
    get minPitch() { return this._minPitch; }
    set minPitch(pitch) {
        if (this._minPitch === pitch)
            return;
        this._minPitch = pitch;
        this.pitch = Math.max(this.pitch, pitch);
    }
    get maxPitch() { return this._maxPitch; }
    set maxPitch(pitch) {
        if (this._maxPitch === pitch)
            return;
        this._maxPitch = pitch;
        this.pitch = Math.min(this.pitch, pitch);
    }
    get renderWorldCopies() { return this._renderWorldCopies; }
    set renderWorldCopies(renderWorldCopies) {
        if (renderWorldCopies === undefined) {
            renderWorldCopies = true;
        }
        else if (renderWorldCopies === null) {
            renderWorldCopies = false;
        }
        this._renderWorldCopies = renderWorldCopies;
    }
    get worldSize() {
        return this.tileSize * this.scale;
    }
    get centerOffset() {
        return this.centerPoint._sub(this.size._div(2));
    }
    get size() {
        return new performance$1.P(this.width, this.height);
    }
    get bearing() {
        return -this.angle / Math.PI * 180;
    }
    set bearing(bearing) {
        const b = -performance$1.b3(bearing, -180, 180) * Math.PI / 180;
        if (this.angle === b)
            return;
        this._unmodified = false;
        this.angle = b;
        this._calcMatrices();
        // 2x2 matrix for rotating points
        this.rotationMatrix = create$4();
        rotate(this.rotationMatrix, this.rotationMatrix, this.angle);
    }
    get pitch() {
        return this._pitch / Math.PI * 180;
    }
    set pitch(pitch) {
        const p = performance$1.ad(pitch, this.minPitch, this.maxPitch) / 180 * Math.PI;
        if (this._pitch === p)
            return;
        this._unmodified = false;
        this._pitch = p;
        this._calcMatrices();
    }
    get fov() {
        return this._fov / Math.PI * 180;
    }
    set fov(fov) {
        fov = Math.max(0.01, Math.min(60, fov));
        if (this._fov === fov)
            return;
        this._unmodified = false;
        this._fov = fov / 180 * Math.PI;
        this._calcMatrices();
    }
    get zoom() { return this._zoom; }
    set zoom(zoom) {
        const constrainedZoom = Math.min(Math.max(zoom, this.minZoom), this.maxZoom);
        if (this._zoom === constrainedZoom)
            return;
        this._unmodified = false;
        this._zoom = constrainedZoom;
        this.tileZoom = Math.max(0, Math.floor(constrainedZoom));
        this.scale = this.zoomScale(constrainedZoom);
        this._constrain();
        this._calcMatrices();
    }
    get center() { return this._center; }
    set center(center) {
        if (center.lat === this._center.lat && center.lng === this._center.lng)
            return;
        this._unmodified = false;
        this._center = center;
        this._constrain();
        this._calcMatrices();
    }
    /**
     * Elevation at current center point, meters above sea level
     */
    get elevation() { return this._elevation; }
    set elevation(elevation) {
        if (elevation === this._elevation)
            return;
        this._elevation = elevation;
        this._constrain();
        this._calcMatrices();
    }
    get padding() { return this._edgeInsets.toJSON(); }
    set padding(padding) {
        if (this._edgeInsets.equals(padding))
            return;
        this._unmodified = false;
        //Update edge-insets in place
        this._edgeInsets.interpolate(this._edgeInsets, padding, 1);
        this._calcMatrices();
    }
    /**
     * The center of the screen in pixels with the top-left corner being (0,0)
     * and +y axis pointing downwards. This accounts for padding.
     */
    get centerPoint() {
        return this._edgeInsets.getCenter(this.width, this.height);
    }
    /**
     * Returns if the padding params match
     *
     * @param padding - the padding to check against
     * @returns true if they are equal, false otherwise
     */
    isPaddingEqual(padding) {
        return this._edgeInsets.equals(padding);
    }
    /**
     * Helper method to update edge-insets in place
     *
     * @param start - the starting padding
     * @param target - the target padding
     * @param t - the step/weight
     */
    interpolatePadding(start, target, t) {
        this._unmodified = false;
        this._edgeInsets.interpolate(start, target, t);
        this._constrain();
        this._calcMatrices();
    }
    /**
     * Return a zoom level that will cover all tiles the transform
     * @param options - the options
     * @returns zoom level An integer zoom level at which all tiles will be visible.
     */
    coveringZoomLevel(options) {
        const z = (options.roundZoom ? Math.round : Math.floor)(this.zoom + this.scaleZoom(this.tileSize / options.tileSize));
        // At negative zoom levels load tiles from z0 because negative tile zoom levels don't exist.
        return Math.max(0, z);
    }
    /**
     * Return any "wrapped" copies of a given tile coordinate that are visible
     * in the current view.
     */
    getVisibleUnwrappedCoordinates(tileID) {
        const result = [new performance$1.b4(0, tileID)];
        if (this._renderWorldCopies) {
            const utl = this.pointCoordinate(new performance$1.P(0, 0));
            const utr = this.pointCoordinate(new performance$1.P(this.width, 0));
            const ubl = this.pointCoordinate(new performance$1.P(this.width, this.height));
            const ubr = this.pointCoordinate(new performance$1.P(0, this.height));
            const w0 = Math.floor(Math.min(utl.x, utr.x, ubl.x, ubr.x));
            const w1 = Math.floor(Math.max(utl.x, utr.x, ubl.x, ubr.x));
            // Add an extra copy of the world on each side to properly render ImageSources and CanvasSources.
            // Both sources draw outside the tile boundaries of the tile that "contains them" so we need
            // to add extra copies on both sides in case offscreen tiles need to draw into on-screen ones.
            const extraWorldCopy = 1;
            for (let w = w0 - extraWorldCopy; w <= w1 + extraWorldCopy; w++) {
                if (w === 0)
                    continue;
                result.push(new performance$1.b4(w, tileID));
            }
        }
        return result;
    }
    /**
     * Return all coordinates that could cover this transform for a covering
     * zoom level.
     * @param options - the options
     * @returns OverscaledTileIDs
     */
    coveringTiles(options) {
        var _a, _b;
        let z = this.coveringZoomLevel(options);
        const actualZ = z;
        if (options.minzoom !== undefined && z < options.minzoom)
            return [];
        if (options.maxzoom !== undefined && z > options.maxzoom)
            z = options.maxzoom;
        const cameraCoord = this.pointCoordinate(this.getCameraPoint());
        const centerCoord = performance$1.Z.fromLngLat(this.center);
        const numTiles = Math.pow(2, z);
        const cameraPoint = [numTiles * cameraCoord.x, numTiles * cameraCoord.y, 0];
        const centerPoint = [numTiles * centerCoord.x, numTiles * centerCoord.y, 0];
        const cameraFrustum = Frustum.fromInvProjectionMatrix(this.invModelViewProjectionMatrix, this.worldSize, z);
        // No change of LOD behavior for pitch lower than 60 and when there is no top padding: return only tile ids from the requested zoom level
        let minZoom = options.minzoom || 0;
        // Use 0.1 as an epsilon to avoid for explicit == 0.0 floating point checks
        if (!options.terrain && this.pitch <= 60.0 && this._edgeInsets.top < 0.1)
            minZoom = z;
        // There should always be a certain number of maximum zoom level tiles surrounding the center location in 2D or in front of the camera in 3D
        const radiusOfMaxLvlLodInTiles = options.terrain ? 2 / Math.min(this.tileSize, options.tileSize) * this.tileSize : 3;
        const newRootTile = (wrap) => {
            return {
                aabb: new Aabb([wrap * numTiles, 0, 0], [(wrap + 1) * numTiles, numTiles, 0]),
                zoom: 0,
                x: 0,
                y: 0,
                wrap,
                fullyVisible: false
            };
        };
        // Do a depth-first traversal to find visible tiles and proper levels of detail
        const stack = [];
        const result = [];
        const maxZoom = z;
        const overscaledZ = options.reparseOverscaled ? actualZ : z;
        if (this._renderWorldCopies) {
            // Render copy of the globe thrice on both sides
            for (let i = 1; i <= 3; i++) {
                stack.push(newRootTile(-i));
                stack.push(newRootTile(i));
            }
        }
        stack.push(newRootTile(0));
        while (stack.length > 0) {
            const it = stack.pop();
            const x = it.x;
            const y = it.y;
            let fullyVisible = it.fullyVisible;
            // Visibility of a tile is not required if any of its ancestor if fully inside the frustum
            if (!fullyVisible) {
                const intersectResult = it.aabb.intersects(cameraFrustum);
                if (intersectResult === 0)
                    continue;
                fullyVisible = intersectResult === 2;
            }
            const refPoint = options.terrain ? cameraPoint : centerPoint;
            const distanceX = it.aabb.distanceX(refPoint);
            const distanceY = it.aabb.distanceY(refPoint);
            const longestDim = Math.max(Math.abs(distanceX), Math.abs(distanceY));
            // We're using distance based heuristics to determine if a tile should be split into quadrants or not.
            // radiusOfMaxLvlLodInTiles defines that there's always a certain number of maxLevel tiles next to the map center.
            // Using the fact that a parent node in quadtree is twice the size of its children (per dimension)
            // we can define distance thresholds for each relative level:
            // f(k) = offset + 2 + 4 + 8 + 16 + ... + 2^k. This is the same as "offset+2^(k+1)-2"
            const distToSplit = radiusOfMaxLvlLodInTiles + (1 << (maxZoom - it.zoom)) - 2;
            // Have we reached the target depth or is the tile too far away to be any split further?
            if (it.zoom === maxZoom || (longestDim > distToSplit && it.zoom >= minZoom)) {
                const dz = maxZoom - it.zoom, dx = cameraPoint[0] - 0.5 - (x << dz), dy = cameraPoint[1] - 0.5 - (y << dz);
                result.push({
                    tileID: new performance$1.S(it.zoom === maxZoom ? overscaledZ : it.zoom, it.wrap, it.zoom, x, y),
                    distanceSq: sqrLen([centerPoint[0] - 0.5 - x, centerPoint[1] - 0.5 - y]),
                    // this variable is currently not used, but may be important to reduce the amount of loaded tiles
                    tileDistanceToCamera: Math.sqrt(dx * dx + dy * dy)
                });
                continue;
            }
            for (let i = 0; i < 4; i++) {
                const childX = (x << 1) + (i % 2);
                const childY = (y << 1) + (i >> 1);
                const childZ = it.zoom + 1;
                let quadrant = it.aabb.quadrant(i);
                if (options.terrain) {
                    const tileID = new performance$1.S(childZ, it.wrap, childZ, childX, childY);
                    const minMax = options.terrain.getMinMaxElevation(tileID);
                    const minElevation = (_a = minMax.minElevation) !== null && _a !== void 0 ? _a : this.elevation;
                    const maxElevation = (_b = minMax.maxElevation) !== null && _b !== void 0 ? _b : this.elevation;
                    quadrant = new Aabb([quadrant.min[0], quadrant.min[1], minElevation], [quadrant.max[0], quadrant.max[1], maxElevation]);
                }
                stack.push({ aabb: quadrant, zoom: childZ, x: childX, y: childY, wrap: it.wrap, fullyVisible });
            }
        }
        return result.sort((a, b) => a.distanceSq - b.distanceSq).map(a => a.tileID);
    }
    resize(width, height) {
        this.width = width;
        this.height = height;
        this.pixelsToGLUnits = [2 / width, -2 / height];
        this._constrain();
        this._calcMatrices();
    }
    get unmodified() { return this._unmodified; }
    zoomScale(zoom) { return Math.pow(2, zoom); }
    scaleZoom(scale) { return Math.log(scale) / Math.LN2; }
    /**
     * Convert from LngLat to world coordinates (Mercator coordinates scaled by 512)
     * @param lnglat - the lngLat
     * @returns Point
     */
    project(lnglat) {
        const lat = performance$1.ad(lnglat.lat, -MAX_VALID_LATITUDE, MAX_VALID_LATITUDE);
        return new performance$1.P(performance$1.O(lnglat.lng) * this.worldSize, performance$1.Q(lat) * this.worldSize);
    }
    /**
     * Convert from world coordinates ([0, 512],[0, 512]) to LngLat ([-180, 180], [-90, 90])
     * @param point - world coordinate
     * @returns LngLat
     */
    unproject(point) {
        return new performance$1.Z(point.x / this.worldSize, point.y / this.worldSize).toLngLat();
    }
    get point() { return this.project(this.center); }
    /**
     * get the camera position in LngLat and altitudes in meter
     * @returns An object with lngLat & altitude.
     */
    getCameraPosition() {
        const lngLat = this.pointLocation(this.getCameraPoint());
        const altitude = Math.cos(this._pitch) * this.cameraToCenterDistance / this._pixelPerMeter;
        return { lngLat, altitude: altitude + this.elevation };
    }
    /**
     * This method works in combination with freezeElevation activated.
     * freezeElevation is enabled during map-panning because during this the camera should sit in constant height.
     * After panning finished, call this method to recalculate the zoomlevel for the current camera-height in current terrain.
     * @param terrain - the terrain
     */
    recalculateZoom(terrain) {
        const origElevation = this.elevation;
        const origAltitude = Math.cos(this._pitch) * this.cameraToCenterDistance / this._pixelPerMeter;
        // find position the camera is looking on
        const center = this.pointLocation(this.centerPoint, terrain);
        const elevation = terrain.getElevationForLngLatZoom(center, this.tileZoom);
        const deltaElevation = this.elevation - elevation;
        if (!deltaElevation)
            return;
        // The camera's altitude off the ground + the ground's elevation = a constant:
        // this means the camera stays at the same total height.
        const requiredAltitude = origAltitude + origElevation - elevation;
        // Since altitude = Math.cos(this._pitch) * this.cameraToCenterDistance / pixelPerMeter:
        const requiredPixelPerMeter = Math.cos(this._pitch) * this.cameraToCenterDistance / requiredAltitude;
        // Since pixelPerMeter = mercatorZfromAltitude(1, center.lat) * worldSize:
        const requiredWorldSize = requiredPixelPerMeter / performance$1.b5(1, center.lat);
        // Since worldSize = this.tileSize * scale:
        const requiredScale = requiredWorldSize / this.tileSize;
        const zoom = this.scaleZoom(requiredScale);
        // update matrices
        this._elevation = elevation;
        this._center = center;
        this.zoom = zoom;
    }
    setLocationAtPoint(lnglat, point) {
        const a = this.pointCoordinate(point);
        const b = this.pointCoordinate(this.centerPoint);
        const loc = this.locationCoordinate(lnglat);
        const newCenter = new performance$1.Z(loc.x - (a.x - b.x), loc.y - (a.y - b.y));
        this.center = this.coordinateLocation(newCenter);
        if (this._renderWorldCopies) {
            this.center = this.center.wrap();
        }
    }
    /**
     * Given a LngLat location, return the screen point that corresponds to it
     * @param lnglat - location
     * @param terrain - optional terrain
     * @returns screen point
     */
    locationPoint(lnglat, terrain) {
        return terrain ?
            this.coordinatePoint(this.locationCoordinate(lnglat), terrain.getElevationForLngLatZoom(lnglat, this.tileZoom), this.pixelMatrix3D) :
            this.coordinatePoint(this.locationCoordinate(lnglat));
    }
    /**
     * Given a point on screen, return its lnglat
     * @param p - screen point
     * @param terrain - optional terrain
     * @returns lnglat location
     */
    pointLocation(p, terrain) {
        return this.coordinateLocation(this.pointCoordinate(p, terrain));
    }
    /**
     * Given a geographical lnglat, return an unrounded
     * coordinate that represents it at low zoom level.
     * @param lnglat - the location
     * @returns The mercator coordinate
     */
    locationCoordinate(lnglat) {
        return performance$1.Z.fromLngLat(lnglat);
    }
    /**
     * Given a Coordinate, return its geographical position.
     * @param coord - mercator coordinates
     * @returns lng and lat
     */
    coordinateLocation(coord) {
        return coord && coord.toLngLat();
    }
    /**
     * Given a Point, return its mercator coordinate.
     * @param p - the point
     * @param terrain - optional terrain
     * @returns lnglat
     */
    pointCoordinate(p, terrain) {
        // get point-coordinate from terrain coordinates framebuffer
        if (terrain) {
            const coordinate = terrain.pointCoordinate(p);
            if (coordinate != null) {
                return coordinate;
            }
        }
        // calculate point-coordinate on flat earth
        const targetZ = 0;
        // since we don't know the correct projected z value for the point,
        // unproject two points to get a line and then find the point on that
        // line with z=0
        const coord0 = [p.x, p.y, 0, 1];
        const coord1 = [p.x, p.y, 1, 1];
        performance$1.ag(coord0, coord0, this.pixelMatrixInverse);
        performance$1.ag(coord1, coord1, this.pixelMatrixInverse);
        const w0 = coord0[3];
        const w1 = coord1[3];
        const x0 = coord0[0] / w0;
        const x1 = coord1[0] / w1;
        const y0 = coord0[1] / w0;
        const y1 = coord1[1] / w1;
        const z0 = coord0[2] / w0;
        const z1 = coord1[2] / w1;
        const t = z0 === z1 ? 0 : (targetZ - z0) / (z1 - z0);
        return new performance$1.Z(performance$1.z.number(x0, x1, t) / this.worldSize, performance$1.z.number(y0, y1, t) / this.worldSize);
    }
    /**
     * Given a coordinate, return the screen point that corresponds to it
     * @param coord - the coordinates
     * @param elevation - the elevation
     * @param pixelMatrix - the pixel matrix
     * @returns screen point
     */
    coordinatePoint(coord, elevation = 0, pixelMatrix = this.pixelMatrix) {
        const p = [coord.x * this.worldSize, coord.y * this.worldSize, elevation, 1];
        performance$1.ag(p, p, pixelMatrix);
        return new performance$1.P(p[0] / p[3], p[1] / p[3]);
    }
    /**
     * Returns the map's geographical bounds. When the bearing or pitch is non-zero, the visible region is not
     * an axis-aligned rectangle, and the result is the smallest bounds that encompasses the visible region.
     * @returns Returns a {@link LngLatBounds} object describing the map's geographical bounds.
     */
    getBounds() {
        const top = Math.max(0, this.height / 2 - this.getHorizon());
        return new LngLatBounds()
            .extend(this.pointLocation(new performance$1.P(0, top)))
            .extend(this.pointLocation(new performance$1.P(this.width, top)))
            .extend(this.pointLocation(new performance$1.P(this.width, this.height)))
            .extend(this.pointLocation(new performance$1.P(0, this.height)));
    }
    /**
     * Returns the maximum geographical bounds the map is constrained to, or `null` if none set.
     * @returns max bounds
     */
    getMaxBounds() {
        if (!this.latRange || this.latRange.length !== 2 ||
            !this.lngRange || this.lngRange.length !== 2)
            return null;
        return new LngLatBounds([this.lngRange[0], this.latRange[0]], [this.lngRange[1], this.latRange[1]]);
    }
    /**
     * Calculate pixel height of the visible horizon in relation to map-center (e.g. height/2),
     * multiplied by a static factor to simulate the earth-radius.
     * The calculated value is the horizontal line from the camera-height to sea-level.
     * @returns Horizon above center in pixels.
     */
    getHorizon() {
        return Math.tan(Math.PI / 2 - this._pitch) * this.cameraToCenterDistance * 0.85;
    }
    /**
     * Sets or clears the map's geographical constraints.
     * @param bounds - A {@link LngLatBounds} object describing the new geographic boundaries of the map.
     */
    setMaxBounds(bounds) {
        if (bounds) {
            this.lngRange = [bounds.getWest(), bounds.getEast()];
            this.latRange = [bounds.getSouth(), bounds.getNorth()];
            this._constrain();
        }
        else {
            this.lngRange = null;
            this.latRange = [-MAX_VALID_LATITUDE, MAX_VALID_LATITUDE];
        }
    }
    calculateTileMatrix(unwrappedTileID) {
        const canonical = unwrappedTileID.canonical;
        const scale = this.worldSize / this.zoomScale(canonical.z);
        const unwrappedX = canonical.x + Math.pow(2, canonical.z) * unwrappedTileID.wrap;
        const worldMatrix = performance$1.ao(new Float64Array(16));
        performance$1.J(worldMatrix, worldMatrix, [unwrappedX * scale, canonical.y * scale, 0]);
        performance$1.K(worldMatrix, worldMatrix, [scale / performance$1.X, scale / performance$1.X, 1]);
        return worldMatrix;
    }
    /**
     * Calculate the posMatrix that, given a tile coordinate, would be used to display the tile on a map.
     * @param unwrappedTileID - the tile ID
     */
    calculatePosMatrix(unwrappedTileID, aligned = false) {
        const posMatrixKey = unwrappedTileID.key;
        const cache = aligned ? this._alignedPosMatrixCache : this._posMatrixCache;
        if (cache[posMatrixKey]) {
            return cache[posMatrixKey];
        }
        const posMatrix = this.calculateTileMatrix(unwrappedTileID);
        performance$1.L(posMatrix, aligned ? this.alignedModelViewProjectionMatrix : this.modelViewProjectionMatrix, posMatrix);
        cache[posMatrixKey] = new Float32Array(posMatrix);
        return cache[posMatrixKey];
    }
    /**
     * Calculate the fogMatrix that, given a tile coordinate, would be used to calculate fog on the map.
     * @param unwrappedTileID - the tile ID
     * @private
     */
    calculateFogMatrix(unwrappedTileID) {
        const posMatrixKey = unwrappedTileID.key;
        const cache = this._fogMatrixCache;
        if (cache[posMatrixKey]) {
            return cache[posMatrixKey];
        }
        const fogMatrix = this.calculateTileMatrix(unwrappedTileID);
        performance$1.L(fogMatrix, this.fogMatrix, fogMatrix);
        cache[posMatrixKey] = new Float32Array(fogMatrix);
        return cache[posMatrixKey];
    }
    customLayerMatrix() {
        return this.mercatorMatrix.slice();
    }
    /**
     * Get center lngLat and zoom to ensure that
     * 1) everything beyond the bounds is excluded
     * 2) a given lngLat is as near the center as possible
     * Bounds are those set by maxBounds or North & South "Poles" and, if only 1 globe is displayed, antimeridian.
     */
    getConstrained(lngLat, zoom) {
        zoom = performance$1.ad(+zoom, this.minZoom, this.maxZoom);
        const result = {
            center: new performance$1.N(lngLat.lng, lngLat.lat),
            zoom
        };
        let lngRange = this.lngRange;
        if (!this._renderWorldCopies && lngRange === null) {
            const almost180 = 180 - 1e-10;
            lngRange = [-almost180, almost180];
        }
        const worldSize = this.tileSize * this.zoomScale(result.zoom); // A world size for the requested zoom level, not the current world size
        let minY = 0;
        let maxY = worldSize;
        let minX = 0;
        let maxX = worldSize;
        let scaleY = 0;
        let scaleX = 0;
        const { x: screenWidth, y: screenHeight } = this.size;
        if (this.latRange) {
            const latRange = this.latRange;
            minY = performance$1.Q(latRange[1]) * worldSize;
            maxY = performance$1.Q(latRange[0]) * worldSize;
            const shouldZoomIn = maxY - minY < screenHeight;
            if (shouldZoomIn)
                scaleY = screenHeight / (maxY - minY);
        }
        if (lngRange) {
            minX = performance$1.b3(performance$1.O(lngRange[0]) * worldSize, 0, worldSize);
            maxX = performance$1.b3(performance$1.O(lngRange[1]) * worldSize, 0, worldSize);
            if (maxX < minX)
                maxX += worldSize;
            const shouldZoomIn = maxX - minX < screenWidth;
            if (shouldZoomIn)
                scaleX = screenWidth / (maxX - minX);
        }
        const { x: originalX, y: originalY } = this.project.call({ worldSize }, lngLat);
        let modifiedX, modifiedY;
        const scale = Math.max(scaleX || 0, scaleY || 0);
        if (scale) {
            // zoom in to exclude all beyond the given lng/lat ranges
            const newPoint = new performance$1.P(scaleX ? (maxX + minX) / 2 : originalX, scaleY ? (maxY + minY) / 2 : originalY);
            result.center = this.unproject.call({ worldSize }, newPoint).wrap();
            result.zoom += this.scaleZoom(scale);
            return result;
        }
        if (this.latRange) {
            const h2 = screenHeight / 2;
            if (originalY - h2 < minY)
                modifiedY = minY + h2;
            if (originalY + h2 > maxY)
                modifiedY = maxY - h2;
        }
        if (lngRange) {
            const centerX = (minX + maxX) / 2;
            let wrappedX = originalX;
            if (this._renderWorldCopies) {
                wrappedX = performance$1.b3(originalX, centerX - worldSize / 2, centerX + worldSize / 2);
            }
            const w2 = screenWidth / 2;
            if (wrappedX - w2 < minX)
                modifiedX = minX + w2;
            if (wrappedX + w2 > maxX)
                modifiedX = maxX - w2;
        }
        // pan the map if the screen goes off the range
        if (modifiedX !== undefined || modifiedY !== undefined) {
            const newPoint = new performance$1.P(modifiedX !== null && modifiedX !== void 0 ? modifiedX : originalX, modifiedY !== null && modifiedY !== void 0 ? modifiedY : originalY);
            result.center = this.unproject.call({ worldSize }, newPoint).wrap();
        }
        return result;
    }
    _constrain() {
        if (!this.center || !this.width || !this.height || this._constraining)
            return;
        this._constraining = true;
        const unmodified = this._unmodified;
        const { center, zoom } = this.getConstrained(this.center, this.zoom);
        this.center = center;
        this.zoom = zoom;
        this._unmodified = unmodified;
        this._constraining = false;
    }
    _calcMatrices() {
        if (!this.height)
            return;
        const halfFov = this._fov / 2;
        const offset = this.centerOffset;
        const x = this.point.x, y = this.point.y;
        this.cameraToCenterDistance = 0.5 / Math.tan(halfFov) * this.height;
        this._pixelPerMeter = performance$1.b5(1, this.center.lat) * this.worldSize;
        let m = performance$1.ao(new Float64Array(16));
        performance$1.K(m, m, [this.width / 2, -this.height / 2, 1]);
        performance$1.J(m, m, [1, -1, 0]);
        this.labelPlaneMatrix = m;
        m = performance$1.ao(new Float64Array(16));
        performance$1.K(m, m, [1, -1, 1]);
        performance$1.J(m, m, [-1, -1, 0]);
        performance$1.K(m, m, [2 / this.width, 2 / this.height, 1]);
        this.glCoordMatrix = m;
        // Calculate the camera to sea-level distance in pixel in respect of terrain
        const cameraToSeaLevelDistance = this.cameraToCenterDistance + this._elevation * this._pixelPerMeter / Math.cos(this._pitch);
        // In case of negative minimum elevation (e.g. the dead see, under the sea maps) use a lower plane for calculation
        const minElevation = Math.min(this.elevation, this.minElevationForCurrentTile);
        const cameraToLowestPointDistance = cameraToSeaLevelDistance - minElevation * this._pixelPerMeter / Math.cos(this._pitch);
        const lowestPlane = minElevation < 0 ? cameraToLowestPointDistance : cameraToSeaLevelDistance;
        // Find the distance from the center point [width/2 + offset.x, height/2 + offset.y] to the
        // center top point [width/2 + offset.x, 0] in Z units, using the law of sines.
        // 1 Z unit is equivalent to 1 horizontal px at the center of the map
        // (the distance between[width/2, height/2] and [width/2 + 1, height/2])
        const groundAngle = Math.PI / 2 + this._pitch;
        const fovAboveCenter = this._fov * (0.5 + offset.y / this.height);
        const topHalfSurfaceDistance = Math.sin(fovAboveCenter) * lowestPlane / Math.sin(performance$1.ad(Math.PI - groundAngle - fovAboveCenter, 0.01, Math.PI - 0.01));
        // Find the distance from the center point to the horizon
        const horizon = this.getHorizon();
        const horizonAngle = Math.atan(horizon / this.cameraToCenterDistance);
        const fovCenterToHorizon = 2 * horizonAngle * (0.5 + offset.y / (horizon * 2));
        const topHalfSurfaceDistanceHorizon = Math.sin(fovCenterToHorizon) * lowestPlane / Math.sin(performance$1.ad(Math.PI - groundAngle - fovCenterToHorizon, 0.01, Math.PI - 0.01));
        // Calculate z distance of the farthest fragment that should be rendered.
        // Add a bit extra to avoid precision problems when a fragment's distance is exactly `furthestDistance`
        const topHalfMinDistance = Math.min(topHalfSurfaceDistance, topHalfSurfaceDistanceHorizon);
        this.farZ = (Math.cos(Math.PI / 2 - this._pitch) * topHalfMinDistance + lowestPlane) * 1.01;
        // The larger the value of nearZ is
        // - the more depth precision is available for features (good)
        // - clipping starts appearing sooner when the camera is close to 3d features (bad)
        //
        // Other values work for mapbox-gl-js but deck.gl was encountering precision issues
        // when rendering custom layers. This value was experimentally chosen and
        // seems to solve z-fighting issues in deck.gl while not clipping buildings too close to the camera.
        this.nearZ = this.height / 50;
        // matrix for conversion from location to clip space(-1 .. 1)
        m = new Float64Array(16);
        performance$1.b6(m, this._fov, this.width / this.height, this.nearZ, this.farZ);
        // Apply center of perspective offset
        m[8] = -offset.x * 2 / this.width;
        m[9] = offset.y * 2 / this.height;
        this.projectionMatrix = performance$1.af(m);
        performance$1.K(m, m, [1, -1, 1]);
        performance$1.J(m, m, [0, 0, -this.cameraToCenterDistance]);
        performance$1.b7(m, m, this._pitch);
        performance$1.ae(m, m, this.angle);
        performance$1.J(m, m, [-x, -y, 0]);
        // The mercatorMatrix can be used to transform points from mercator coordinates
        // ([0, 0] nw, [1, 1] se) to clip space.
        this.mercatorMatrix = performance$1.K([], m, [this.worldSize, this.worldSize, this.worldSize]);
        // scale vertically to meters per pixel (inverse of ground resolution):
        performance$1.K(m, m, [1, 1, this._pixelPerMeter]);
        // matrix for conversion from world space to screen coordinates in 2D
        this.pixelMatrix = performance$1.L(new Float64Array(16), this.labelPlaneMatrix, m);
        // matrix for conversion from world space to clip space (-1 .. 1)
        performance$1.J(m, m, [0, 0, -this.elevation]); // elevate camera over terrain
        this.modelViewProjectionMatrix = m;
        this.invModelViewProjectionMatrix = performance$1.at([], m);
        // create a fog matrix, same es proj-matrix but with near clipping-plane in mapcenter
        // needed to calculate a correct z-value for fog calculation, because projMatrix z value is not
        this.fogMatrix = new Float64Array(16);
        performance$1.b6(this.fogMatrix, this._fov, this.width / this.height, cameraToSeaLevelDistance, this.farZ);
        this.fogMatrix[8] = -offset.x * 2 / this.width;
        this.fogMatrix[9] = offset.y * 2 / this.height;
        performance$1.K(this.fogMatrix, this.fogMatrix, [1, -1, 1]);
        performance$1.J(this.fogMatrix, this.fogMatrix, [0, 0, -this.cameraToCenterDistance]);
        performance$1.b7(this.fogMatrix, this.fogMatrix, this._pitch);
        performance$1.ae(this.fogMatrix, this.fogMatrix, this.angle);
        performance$1.J(this.fogMatrix, this.fogMatrix, [-x, -y, 0]);
        performance$1.K(this.fogMatrix, this.fogMatrix, [1, 1, this._pixelPerMeter]);
        performance$1.J(this.fogMatrix, this.fogMatrix, [0, 0, -this.elevation]); // elevate camera over terrain
        // matrix for conversion from world space to screen coordinates in 3D
        this.pixelMatrix3D = performance$1.L(new Float64Array(16), this.labelPlaneMatrix, m);
        // Make a second projection matrix that is aligned to a pixel grid for rendering raster tiles.
        // We're rounding the (floating point) x/y values to achieve to avoid rendering raster images to fractional
        // coordinates. Additionally, we adjust by half a pixel in either direction in case that viewport dimension
        // is an odd integer to preserve rendering to the pixel grid. We're rotating this shift based on the angle
        // of the transformation so that 0°, 90°, 180°, and 270° rasters are crisp, and adjust the shift so that
        // it is always <= 0.5 pixels.
        const xShift = (this.width % 2) / 2, yShift = (this.height % 2) / 2, angleCos = Math.cos(this.angle), angleSin = Math.sin(this.angle), dx = x - Math.round(x) + angleCos * xShift + angleSin * yShift, dy = y - Math.round(y) + angleCos * yShift + angleSin * xShift;
        const alignedM = new Float64Array(m);
        performance$1.J(alignedM, alignedM, [dx > 0.5 ? dx - 1 : dx, dy > 0.5 ? dy - 1 : dy, 0]);
        this.alignedModelViewProjectionMatrix = alignedM;
        // inverse matrix for conversion from screen coordinates to location
        m = performance$1.at(new Float64Array(16), this.pixelMatrix);
        if (!m)
            throw new Error('failed to invert matrix');
        this.pixelMatrixInverse = m;
        this._posMatrixCache = {};
        this._alignedPosMatrixCache = {};
        this._fogMatrixCache = {};
    }
    maxPitchScaleFactor() {
        // calcMatrices hasn't run yet
        if (!this.pixelMatrixInverse)
            return 1;
        const coord = this.pointCoordinate(new performance$1.P(0, 0));
        const p = [coord.x * this.worldSize, coord.y * this.worldSize, 0, 1];
        const topPoint = performance$1.ag(p, p, this.pixelMatrix);
        return topPoint[3] / this.cameraToCenterDistance;
    }
    /**
     * The camera looks at the map from a 3D (lng, lat, altitude) location. Let's use `cameraLocation`
     * as the name for the location under the camera and on the surface of the earth (lng, lat, 0).
     * `cameraPoint` is the projected position of the `cameraLocation`.
     *
     * This point is useful to us because only fill-extrusions that are between `cameraPoint` and
     * the query point on the surface of the earth can extend and intersect the query.
     *
     * When the map is not pitched the `cameraPoint` is equivalent to the center of the map because
     * the camera is right above the center of the map.
     */
    getCameraPoint() {
        const pitch = this._pitch;
        const yOffset = Math.tan(pitch) * (this.cameraToCenterDistance || 1);
        return this.centerPoint.add(new performance$1.P(0, yOffset));
    }
    /**
     * When the map is pitched, some of the 3D features that intersect a query will not intersect
     * the query at the surface of the earth. Instead the feature may be closer and only intersect
     * the query because it extrudes into the air.
     * @param queryGeometry - For point queries, the line from the query point to the "camera point",
     * for other geometries, the envelope of the query geometry and the "camera point"
     * @returns a geometry that includes all of the original query as well as all possible ares of the
     * screen where the *base* of a visible extrusion could be.
     *
     */
    getCameraQueryGeometry(queryGeometry) {
        const c = this.getCameraPoint();
        if (queryGeometry.length === 1) {
            return [queryGeometry[0], c];
        }
        else {
            let minX = c.x;
            let minY = c.y;
            let maxX = c.x;
            let maxY = c.y;
            for (const p of queryGeometry) {
                minX = Math.min(minX, p.x);
                minY = Math.min(minY, p.y);
                maxX = Math.max(maxX, p.x);
                maxY = Math.max(maxY, p.y);
            }
            return [
                new performance$1.P(minX, minY),
                new performance$1.P(maxX, minY),
                new performance$1.P(maxX, maxY),
                new performance$1.P(minX, maxY),
                new performance$1.P(minX, minY)
            ];
        }
    }
    /**
     * Return the distance to the camera in clip space from a LngLat.
     * This can be compared to the value from the depth buffer (terrain.depthAtPoint)
     * to determine whether a point is occluded.
     * @param lngLat - the point
     * @param elevation - the point's elevation
     * @returns depth value in clip space (between 0 and 1)
     */
    lngLatToCameraDepth(lngLat, elevation) {
        const coord = this.locationCoordinate(lngLat);
        const p = [coord.x * this.worldSize, coord.y * this.worldSize, elevation, 1];
        performance$1.ag(p, p, this.modelViewProjectionMatrix);
        return (p[2] / p[3]);
    }
}

/**
 * Throttle the given function to run at most every `period` milliseconds.
 */
function throttle(fn, time) {
    let pending = false;
    let timerId = null;
    let lastCallContext = null;
    let lastCallArgs;
    const later = () => {
        timerId = null;
        if (pending) {
            fn.apply(lastCallContext, lastCallArgs);
            timerId = setTimeout(later, time);
            pending = false;
        }
    };
    return (...args) => {
        pending = true;
        lastCallContext = this;
        lastCallArgs = args;
        if (!timerId) {
            later();
        }
        return timerId;
    };
}

/**
 * Adds the map's position to its page's location hash.
 * Passed as an option to the map object.
 *
 * @group Markers and Controls
 */
class Hash {
    constructor(hashName) {
        this._getCurrentHash = () => {
            // Get the current hash from location, stripped from its number sign
            const hash = window.location.hash.replace('#', '');
            if (this._hashName) {
                // Split the parameter-styled hash into parts and find the value we need
                let keyval;
                hash.split('&').map(part => part.split('=')).forEach(part => {
                    if (part[0] === this._hashName) {
                        keyval = part;
                    }
                });
                return (keyval ? keyval[1] || '' : '').split('/');
            }
            return hash.split('/');
        };
        this._onHashChange = () => {
            const loc = this._getCurrentHash();
            if (loc.length >= 3 && !loc.some(v => isNaN(v))) {
                const bearing = this._map.dragRotate.isEnabled() && this._map.touchZoomRotate.isEnabled() ? +(loc[3] || 0) : this._map.getBearing();
                this._map.jumpTo({
                    center: [+loc[2], +loc[1]],
                    zoom: +loc[0],
                    bearing,
                    pitch: +(loc[4] || 0)
                });
                return true;
            }
            return false;
        };
        this._updateHashUnthrottled = () => {
            // Replace if already present, else append the updated hash string
            const location = window.location.href.replace(/(#.+)?$/, this.getHashString());
            window.history.replaceState(window.history.state, null, location);
        };
        this._removeHash = () => {
            const currentHash = this._getCurrentHash();
            if (currentHash.length === 0) {
                return;
            }
            const baseHash = currentHash.join('/');
            let targetHash = baseHash;
            if (targetHash.split('&').length > 0) {
                targetHash = targetHash.split('&')[0]; // #3/1/2&foo=bar -> #3/1/2
            }
            if (this._hashName) {
                targetHash = `${this._hashName}=${baseHash}`;
            }
            let replaceString = window.location.hash.replace(targetHash, '');
            if (replaceString.startsWith('#&')) {
                replaceString = replaceString.slice(0, 1) + replaceString.slice(2);
            }
            else if (replaceString === '#') {
                replaceString = '';
            }
            let location = window.location.href.replace(/(#.+)?$/, replaceString);
            location = location.replace('&&', '&');
            window.history.replaceState(window.history.state, null, location);
        };
        /**
         * Mobile Safari doesn't allow updating the hash more than 100 times per 30 seconds.
         */
        this._updateHash = throttle(this._updateHashUnthrottled, 30 * 1000 / 100);
        this._hashName = hashName && encodeURIComponent(hashName);
    }
    /**
     * Map element to listen for coordinate changes
     *
     * @param map - The map object
     */
    addTo(map) {
        this._map = map;
        addEventListener('hashchange', this._onHashChange, false);
        this._map.on('moveend', this._updateHash);
        return this;
    }
    /**
     * Removes hash
     */
    remove() {
        removeEventListener('hashchange', this._onHashChange, false);
        this._map.off('moveend', this._updateHash);
        clearTimeout(this._updateHash());
        this._removeHash();
        delete this._map;
        return this;
    }
    getHashString(mapFeedback) {
        const center = this._map.getCenter(), zoom = Math.round(this._map.getZoom() * 100) / 100, 
        // derived from equation: 512px * 2^z / 360 / 10^d < 0.5px
        precision = Math.ceil((zoom * Math.LN2 + Math.log(512 / 360 / 0.5)) / Math.LN10), m = Math.pow(10, precision), lng = Math.round(center.lng * m) / m, lat = Math.round(center.lat * m) / m, bearing = this._map.getBearing(), pitch = this._map.getPitch();
        let hash = '';
        if (mapFeedback) {
            // new map feedback site has some constraints that don't allow
            // us to use the same hash format as we do for the Map hash option.
            hash += `/${lng}/${lat}/${zoom}`;
        }
        else {
            hash += `${zoom}/${lat}/${lng}`;
        }
        if (bearing || pitch)
            hash += (`/${Math.round(bearing * 10) / 10}`);
        if (pitch)
            hash += (`/${Math.round(pitch)}`);
        if (this._hashName) {
            const hashName = this._hashName;
            let found = false;
            const parts = window.location.hash.slice(1).split('&').map(part => {
                const key = part.split('=')[0];
                if (key === hashName) {
                    found = true;
                    return `${key}=${hash}`;
                }
                return part;
            }).filter(a => a);
            if (!found) {
                parts.push(`${hashName}=${hash}`);
            }
            return `#${parts.join('&')}`;
        }
        return `#${hash}`;
    }
}

const defaultInertiaOptions = {
    linearity: 0.3,
    easing: performance$1.b8(0, 0, 0.3, 1),
};
const defaultPanInertiaOptions = performance$1.e({
    deceleration: 2500,
    maxSpeed: 1400
}, defaultInertiaOptions);
const defaultZoomInertiaOptions = performance$1.e({
    deceleration: 20,
    maxSpeed: 1400
}, defaultInertiaOptions);
const defaultBearingInertiaOptions = performance$1.e({
    deceleration: 1000,
    maxSpeed: 360
}, defaultInertiaOptions);
const defaultPitchInertiaOptions = performance$1.e({
    deceleration: 1000,
    maxSpeed: 90
}, defaultInertiaOptions);
class HandlerInertia {
    constructor(map) {
        this._map = map;
        this.clear();
    }
    clear() {
        this._inertiaBuffer = [];
    }
    record(settings) {
        this._drainInertiaBuffer();
        this._inertiaBuffer.push({ time: browser.now(), settings });
    }
    _drainInertiaBuffer() {
        const inertia = this._inertiaBuffer, now = browser.now(), cutoff = 160; //msec
        while (inertia.length > 0 && now - inertia[0].time > cutoff)
            inertia.shift();
    }
    _onMoveEnd(panInertiaOptions) {
        this._drainInertiaBuffer();
        if (this._inertiaBuffer.length < 2) {
            return;
        }
        const deltas = {
            zoom: 0,
            bearing: 0,
            pitch: 0,
            pan: new performance$1.P(0, 0),
            pinchAround: undefined,
            around: undefined
        };
        for (const { settings } of this._inertiaBuffer) {
            deltas.zoom += settings.zoomDelta || 0;
            deltas.bearing += settings.bearingDelta || 0;
            deltas.pitch += settings.pitchDelta || 0;
            if (settings.panDelta)
                deltas.pan._add(settings.panDelta);
            if (settings.around)
                deltas.around = settings.around;
            if (settings.pinchAround)
                deltas.pinchAround = settings.pinchAround;
        }
        const lastEntry = this._inertiaBuffer[this._inertiaBuffer.length - 1];
        const duration = (lastEntry.time - this._inertiaBuffer[0].time);
        const easeOptions = {};
        if (deltas.pan.mag()) {
            const result = calculateEasing(deltas.pan.mag(), duration, performance$1.e({}, defaultPanInertiaOptions, panInertiaOptions || {}));
            easeOptions.offset = deltas.pan.mult(result.amount / deltas.pan.mag());
            easeOptions.center = this._map.transform.center;
            extendDuration(easeOptions, result);
        }
        if (deltas.zoom) {
            const result = calculateEasing(deltas.zoom, duration, defaultZoomInertiaOptions);
            easeOptions.zoom = this._map.transform.zoom + result.amount;
            extendDuration(easeOptions, result);
        }
        if (deltas.bearing) {
            const result = calculateEasing(deltas.bearing, duration, defaultBearingInertiaOptions);
            easeOptions.bearing = this._map.transform.bearing + performance$1.ad(result.amount, -179, 179);
            extendDuration(easeOptions, result);
        }
        if (deltas.pitch) {
            const result = calculateEasing(deltas.pitch, duration, defaultPitchInertiaOptions);
            easeOptions.pitch = this._map.transform.pitch + result.amount;
            extendDuration(easeOptions, result);
        }
        if (easeOptions.zoom || easeOptions.bearing) {
            const last = deltas.pinchAround === undefined ? deltas.around : deltas.pinchAround;
            easeOptions.around = last ? this._map.unproject(last) : this._map.getCenter();
        }
        this.clear();
        return performance$1.e(easeOptions, {
            noMoveStart: true
        });
    }
}
// Unfortunately zoom, bearing, etc can't have different durations and easings so
// we need to choose one. We use the longest duration and it's corresponding easing.
function extendDuration(easeOptions, result) {
    if (!easeOptions.duration || easeOptions.duration < result.duration) {
        easeOptions.duration = result.duration;
        easeOptions.easing = result.easing;
    }
}
function calculateEasing(amount, inertiaDuration, inertiaOptions) {
    const { maxSpeed, linearity, deceleration } = inertiaOptions;
    const speed = performance$1.ad(amount * linearity / (inertiaDuration / 1000), -maxSpeed, maxSpeed);
    const duration = Math.abs(speed) / (deceleration * linearity);
    return {
        easing: inertiaOptions.easing,
        duration: duration * 1000,
        amount: speed * (duration / 2)
    };
}

/**
 * `MapMouseEvent` is the event type for mouse-related map events.
 *
 * @group Event Related
 *
 * @example
 * ```ts
 * // The `click` event is an example of a `MapMouseEvent`.
 * // Set up an event listener on the map.
 * map.on('click', (e) => {
 *   // The event object (e) contains information like the
 *   // coordinates of the point on the map that was clicked.
 *   console.log('A click event has occurred at ' + e.lngLat);
 * });
 * ```
 */
class MapMouseEvent extends performance$1.k {
    /**
     * Prevents subsequent default processing of the event by the map.
     *
     * Calling this method will prevent the following default map behaviors:
     *
     *   * On `mousedown` events, the behavior of {@link DragPanHandler}
     *   * On `mousedown` events, the behavior of {@link DragRotateHandler}
     *   * On `mousedown` events, the behavior of {@link BoxZoomHandler}
     *   * On `dblclick` events, the behavior of {@link DoubleClickZoomHandler}
     *
     */
    preventDefault() {
        this._defaultPrevented = true;
    }
    /**
     * `true` if `preventDefault` has been called.
     */
    get defaultPrevented() {
        return this._defaultPrevented;
    }
    constructor(type, map, originalEvent, data = {}) {
        const point = DOM.mousePos(map.getCanvas(), originalEvent);
        const lngLat = map.unproject(point);
        super(type, performance$1.e({ point, lngLat, originalEvent }, data));
        this._defaultPrevented = false;
        this.target = map;
    }
}
/**
 * `MapTouchEvent` is the event type for touch-related map events.
 *
 * @group Event Related
 */
class MapTouchEvent extends performance$1.k {
    /**
     * Prevents subsequent default processing of the event by the map.
     *
     * Calling this method will prevent the following default map behaviors:
     *
     *   * On `touchstart` events, the behavior of {@link DragPanHandler}
     *   * On `touchstart` events, the behavior of {@link TwoFingersTouchZoomRotateHandler}
     *
     */
    preventDefault() {
        this._defaultPrevented = true;
    }
    /**
     * `true` if `preventDefault` has been called.
     */
    get defaultPrevented() {
        return this._defaultPrevented;
    }
    constructor(type, map, originalEvent) {
        const touches = type === 'touchend' ? originalEvent.changedTouches : originalEvent.touches;
        const points = DOM.touchPos(map.getCanvasContainer(), touches);
        const lngLats = points.map((t) => map.unproject(t));
        const point = points.reduce((prev, curr, i, arr) => {
            return prev.add(curr.div(arr.length));
        }, new performance$1.P(0, 0));
        const lngLat = map.unproject(point);
        super(type, { points, point, lngLats, lngLat, originalEvent });
        this._defaultPrevented = false;
    }
}
/**
 * `MapWheelEvent` is the event type for the `wheel` map event.
 *
 * @group Event Related
 */
class MapWheelEvent extends performance$1.k {
    /**
     * Prevents subsequent default processing of the event by the map.
     *
     * Calling this method will prevent the behavior of {@link ScrollZoomHandler}.
     */
    preventDefault() {
        this._defaultPrevented = true;
    }
    /**
     * `true` if `preventDefault` has been called.
     */
    get defaultPrevented() {
        return this._defaultPrevented;
    }
    /** */
    constructor(type, map, originalEvent) {
        super(type, { originalEvent });
        this._defaultPrevented = false;
    }
}

class MapEventHandler {
    constructor(map, options) {
        this._map = map;
        this._clickTolerance = options.clickTolerance;
    }
    reset() {
        delete this._mousedownPos;
    }
    wheel(e) {
        // If mapEvent.preventDefault() is called by the user, prevent handlers such as:
        // - ScrollZoom
        return this._firePreventable(new MapWheelEvent(e.type, this._map, e));
    }
    mousedown(e, point) {
        this._mousedownPos = point;
        // If mapEvent.preventDefault() is called by the user, prevent handlers such as:
        // - MousePan
        // - MouseRotate
        // - MousePitch
        // - DblclickHandler
        return this._firePreventable(new MapMouseEvent(e.type, this._map, e));
    }
    mouseup(e) {
        this._map.fire(new MapMouseEvent(e.type, this._map, e));
    }
    click(e, point) {
        if (this._mousedownPos && this._mousedownPos.dist(point) >= this._clickTolerance)
            return;
        this._map.fire(new MapMouseEvent(e.type, this._map, e));
    }
    dblclick(e) {
        // If mapEvent.preventDefault() is called by the user, prevent handlers such as:
        // - DblClickZoom
        return this._firePreventable(new MapMouseEvent(e.type, this._map, e));
    }
    mouseover(e) {
        this._map.fire(new MapMouseEvent(e.type, this._map, e));
    }
    mouseout(e) {
        this._map.fire(new MapMouseEvent(e.type, this._map, e));
    }
    touchstart(e) {
        // If mapEvent.preventDefault() is called by the user, prevent handlers such as:
        // - TouchPan
        // - TouchZoom
        // - TouchRotate
        // - TouchPitch
        // - TapZoom
        // - SwipeZoom
        return this._firePreventable(new MapTouchEvent(e.type, this._map, e));
    }
    touchmove(e) {
        this._map.fire(new MapTouchEvent(e.type, this._map, e));
    }
    touchend(e) {
        this._map.fire(new MapTouchEvent(e.type, this._map, e));
    }
    touchcancel(e) {
        this._map.fire(new MapTouchEvent(e.type, this._map, e));
    }
    _firePreventable(mapEvent) {
        this._map.fire(mapEvent);
        if (mapEvent.defaultPrevented) {
            // returning an object marks the handler as active and resets other handlers
            return {};
        }
    }
    isEnabled() {
        return true;
    }
    isActive() {
        return false;
    }
    enable() { }
    disable() { }
}
class BlockableMapEventHandler {
    constructor(map) {
        this._map = map;
    }
    reset() {
        this._delayContextMenu = false;
        this._ignoreContextMenu = true;
        delete this._contextMenuEvent;
    }
    mousemove(e) {
        // mousemove map events should not be fired when interaction handlers (pan, rotate, etc) are active
        this._map.fire(new MapMouseEvent(e.type, this._map, e));
    }
    mousedown() {
        this._delayContextMenu = true;
        this._ignoreContextMenu = false;
    }
    mouseup() {
        this._delayContextMenu = false;
        if (this._contextMenuEvent) {
            this._map.fire(new MapMouseEvent('contextmenu', this._map, this._contextMenuEvent));
            delete this._contextMenuEvent;
        }
    }
    contextmenu(e) {
        if (this._delayContextMenu) {
            // Mac: contextmenu fired on mousedown; we save it until mouseup for consistency's sake
            this._contextMenuEvent = e;
        }
        else if (!this._ignoreContextMenu) {
            // Windows: contextmenu fired on mouseup, so fire event now
            this._map.fire(new MapMouseEvent(e.type, this._map, e));
        }
        // prevent browser context menu when necessary
        if (this._map.listens('contextmenu')) {
            e.preventDefault();
        }
    }
    isEnabled() {
        return true;
    }
    isActive() {
        return false;
    }
    enable() { }
    disable() { }
}

/**
 * @internal
 * Shared utilities for the Handler classes to access the correct camera state.
 * If Camera.transformCameraUpdate is specified or terrain is enabled, the
 * "desired state" of camera may differ from the state used for rendering. The
 * handlers need the "desired state" to track accumulated changes.
 */
class TransformProvider {
    constructor(map) {
        this._map = map;
    }
    get transform() {
        return this._map._requestedCameraState || this._map.transform;
    }
    get center() {
        return { lng: this.transform.center.lng, lat: this.transform.center.lat };
    }
    get zoom() {
        return this.transform.zoom;
    }
    get pitch() {
        return this.transform.pitch;
    }
    get bearing() {
        return this.transform.bearing;
    }
    unproject(point) {
        return this.transform.pointLocation(performance$1.P.convert(point), this._map.terrain);
    }
}

/**
 * The `BoxZoomHandler` allows the user to zoom the map to fit within a bounding box.
 * The bounding box is defined by clicking and holding `shift` while dragging the cursor.
 *
 * @group Handlers
 */
class BoxZoomHandler {
    /** @internal */
    constructor(map, options) {
        this._map = map;
        this._tr = new TransformProvider(map);
        this._el = map.getCanvasContainer();
        this._container = map.getContainer();
        this._clickTolerance = options.clickTolerance || 1;
    }
    /**
     * Returns a Boolean indicating whether the "box zoom" interaction is enabled.
     *
     * @returns `true` if the "box zoom" interaction is enabled.
     */
    isEnabled() {
        return !!this._enabled;
    }
    /**
     * Returns a Boolean indicating whether the "box zoom" interaction is active, i.e. currently being used.
     *
     * @returns `true` if the "box zoom" interaction is active.
     */
    isActive() {
        return !!this._active;
    }
    /**
     * Enables the "box zoom" interaction.
     *
     * @example
     * ```ts
     * map.boxZoom.enable();
     * ```
     */
    enable() {
        if (this.isEnabled())
            return;
        this._enabled = true;
    }
    /**
     * Disables the "box zoom" interaction.
     *
     * @example
     * ```ts
     * map.boxZoom.disable();
     * ```
     */
    disable() {
        if (!this.isEnabled())
            return;
        this._enabled = false;
    }
    mousedown(e, point) {
        if (!this.isEnabled())
            return;
        if (!(e.shiftKey && e.button === 0))
            return;
        DOM.disableDrag();
        this._startPos = this._lastPos = point;
        this._active = true;
    }
    mousemoveWindow(e, point) {
        if (!this._active)
            return;
        const pos = point;
        if (this._lastPos.equals(pos) || (!this._box && pos.dist(this._startPos) < this._clickTolerance)) {
            return;
        }
        const p0 = this._startPos;
        this._lastPos = pos;
        if (!this._box) {
            this._box = DOM.create('div', 'maplibregl-boxzoom', this._container);
            this._container.classList.add('maplibregl-crosshair');
            this._fireEvent('boxzoomstart', e);
        }
        const minX = Math.min(p0.x, pos.x), maxX = Math.max(p0.x, pos.x), minY = Math.min(p0.y, pos.y), maxY = Math.max(p0.y, pos.y);
        DOM.setTransform(this._box, `translate(${minX}px,${minY}px)`);
        this._box.style.width = `${maxX - minX}px`;
        this._box.style.height = `${maxY - minY}px`;
    }
    mouseupWindow(e, point) {
        if (!this._active)
            return;
        if (e.button !== 0)
            return;
        const p0 = this._startPos, p1 = point;
        this.reset();
        DOM.suppressClick();
        if (p0.x === p1.x && p0.y === p1.y) {
            this._fireEvent('boxzoomcancel', e);
        }
        else {
            this._map.fire(new performance$1.k('boxzoomend', { originalEvent: e }));
            return {
                cameraAnimation: map => map.fitScreenCoordinates(p0, p1, this._tr.bearing, { linear: true })
            };
        }
    }
    keydown(e) {
        if (!this._active)
            return;
        if (e.keyCode === 27) {
            this.reset();
            this._fireEvent('boxzoomcancel', e);
        }
    }
    reset() {
        this._active = false;
        this._container.classList.remove('maplibregl-crosshair');
        if (this._box) {
            DOM.remove(this._box);
            this._box = null;
        }
        DOM.enableDrag();
        delete this._startPos;
        delete this._lastPos;
    }
    _fireEvent(type, e) {
        return this._map.fire(new performance$1.k(type, { originalEvent: e }));
    }
}

function indexTouches(touches, points) {
    if (touches.length !== points.length)
        throw new Error(`The number of touches and points are not equal - touches ${touches.length}, points ${points.length}`);
    const obj = {};
    for (let i = 0; i < touches.length; i++) {
        obj[touches[i].identifier] = points[i];
    }
    return obj;
}

function getCentroid(points) {
    const sum = new performance$1.P(0, 0);
    for (const point of points) {
        sum._add(point);
    }
    return sum.div(points.length);
}
const MAX_TAP_INTERVAL = 500;
const MAX_TOUCH_TIME = 500;
const MAX_DIST = 30;
class SingleTapRecognizer {
    constructor(options) {
        this.reset();
        this.numTouches = options.numTouches;
    }
    reset() {
        delete this.centroid;
        delete this.startTime;
        delete this.touches;
        this.aborted = false;
    }
    touchstart(e, points, mapTouches) {
        if (this.centroid || mapTouches.length > this.numTouches) {
            this.aborted = true;
        }
        if (this.aborted) {
            return;
        }
        if (this.startTime === undefined) {
            this.startTime = e.timeStamp;
        }
        if (mapTouches.length === this.numTouches) {
            this.centroid = getCentroid(points);
            this.touches = indexTouches(mapTouches, points);
        }
    }
    touchmove(e, points, mapTouches) {
        if (this.aborted || !this.centroid)
            return;
        const newTouches = indexTouches(mapTouches, points);
        for (const id in this.touches) {
            const prevPos = this.touches[id];
            const pos = newTouches[id];
            if (!pos || pos.dist(prevPos) > MAX_DIST) {
                this.aborted = true;
            }
        }
    }
    touchend(e, points, mapTouches) {
        if (!this.centroid || e.timeStamp - this.startTime > MAX_TOUCH_TIME) {
            this.aborted = true;
        }
        if (mapTouches.length === 0) {
            const centroid = !this.aborted && this.centroid;
            this.reset();
            if (centroid)
                return centroid;
        }
    }
}
class TapRecognizer {
    constructor(options) {
        this.singleTap = new SingleTapRecognizer(options);
        this.numTaps = options.numTaps;
        this.reset();
    }
    reset() {
        this.lastTime = Infinity;
        delete this.lastTap;
        this.count = 0;
        this.singleTap.reset();
    }
    touchstart(e, points, mapTouches) {
        this.singleTap.touchstart(e, points, mapTouches);
    }
    touchmove(e, points, mapTouches) {
        this.singleTap.touchmove(e, points, mapTouches);
    }
    touchend(e, points, mapTouches) {
        const tap = this.singleTap.touchend(e, points, mapTouches);
        if (tap) {
            const soonEnough = e.timeStamp - this.lastTime < MAX_TAP_INTERVAL;
            const closeEnough = !this.lastTap || this.lastTap.dist(tap) < MAX_DIST;
            if (!soonEnough || !closeEnough) {
                this.reset();
            }
            this.count++;
            this.lastTime = e.timeStamp;
            this.lastTap = tap;
            if (this.count === this.numTaps) {
                this.reset();
                return tap;
            }
        }
    }
}

/**
 * A `TapZoomHandler` allows the user to zoom the map at a point by double tapping
 */
class TapZoomHandler {
    constructor(map) {
        this._tr = new TransformProvider(map);
        this._zoomIn = new TapRecognizer({
            numTouches: 1,
            numTaps: 2
        });
        this._zoomOut = new TapRecognizer({
            numTouches: 2,
            numTaps: 1
        });
        this.reset();
    }
    reset() {
        this._active = false;
        this._zoomIn.reset();
        this._zoomOut.reset();
    }
    touchstart(e, points, mapTouches) {
        this._zoomIn.touchstart(e, points, mapTouches);
        this._zoomOut.touchstart(e, points, mapTouches);
    }
    touchmove(e, points, mapTouches) {
        this._zoomIn.touchmove(e, points, mapTouches);
        this._zoomOut.touchmove(e, points, mapTouches);
    }
    touchend(e, points, mapTouches) {
        const zoomInPoint = this._zoomIn.touchend(e, points, mapTouches);
        const zoomOutPoint = this._zoomOut.touchend(e, points, mapTouches);
        const tr = this._tr;
        if (zoomInPoint) {
            this._active = true;
            e.preventDefault();
            setTimeout(() => this.reset(), 0);
            return {
                cameraAnimation: (map) => map.easeTo({
                    duration: 300,
                    zoom: tr.zoom + 1,
                    around: tr.unproject(zoomInPoint)
                }, { originalEvent: e })
            };
        }
        else if (zoomOutPoint) {
            this._active = true;
            e.preventDefault();
            setTimeout(() => this.reset(), 0);
            return {
                cameraAnimation: (map) => map.easeTo({
                    duration: 300,
                    zoom: tr.zoom - 1,
                    around: tr.unproject(zoomOutPoint)
                }, { originalEvent: e })
            };
        }
    }
    touchcancel() {
        this.reset();
    }
    enable() {
        this._enabled = true;
    }
    disable() {
        this._enabled = false;
        this.reset();
    }
    isEnabled() {
        return this._enabled;
    }
    isActive() {
        return this._active;
    }
}

/**
 * A generic class to create handlers for drag events, from both mouse and touch events.
 */
class DragHandler {
    constructor(options) {
        this._enabled = !!options.enable;
        this._moveStateManager = options.moveStateManager;
        this._clickTolerance = options.clickTolerance || 1;
        this._moveFunction = options.move;
        this._activateOnStart = !!options.activateOnStart;
        options.assignEvents(this);
        this.reset();
    }
    reset(e) {
        this._active = false;
        this._moved = false;
        delete this._lastPoint;
        this._moveStateManager.endMove(e);
    }
    _move(...params) {
        const move = this._moveFunction(...params);
        if (move.bearingDelta || move.pitchDelta || move.around || move.panDelta) {
            this._active = true;
            return move;
        }
    }
    dragStart(e, point) {
        if (!this.isEnabled() || this._lastPoint)
            return;
        if (!this._moveStateManager.isValidStartEvent(e))
            return;
        this._moveStateManager.startMove(e);
        this._lastPoint = point['length'] ? point[0] : point;
        if (this._activateOnStart && this._lastPoint)
            this._active = true;
    }
    dragMove(e, point) {
        if (!this.isEnabled())
            return;
        const lastPoint = this._lastPoint;
        if (!lastPoint)
            return;
        e.preventDefault();
        if (!this._moveStateManager.isValidMoveEvent(e)) {
            this.reset(e);
            return;
        }
        const movePoint = point['length'] ? point[0] : point;
        if (!this._moved && movePoint.dist(lastPoint) < this._clickTolerance)
            return;
        this._moved = true;
        this._lastPoint = movePoint;
        return this._move(lastPoint, movePoint);
    }
    dragEnd(e) {
        if (!this.isEnabled() || !this._lastPoint)
            return;
        if (!this._moveStateManager.isValidEndEvent(e))
            return;
        if (this._moved)
            DOM.suppressClick();
        this.reset(e);
    }
    enable() {
        this._enabled = true;
    }
    disable() {
        this._enabled = false;
        this.reset();
    }
    isEnabled() {
        return this._enabled;
    }
    isActive() {
        return this._active;
    }
    getClickTolerance() {
        return this._clickTolerance;
    }
}

const LEFT_BUTTON$1 = 0;
const RIGHT_BUTTON$1 = 2;
// the values for each button in MouseEvent.buttons
const BUTTONS_FLAGS = {
    [LEFT_BUTTON$1]: 1,
    [RIGHT_BUTTON$1]: 2
};
function buttonNoLongerPressed(e, button) {
    const flag = BUTTONS_FLAGS[button];
    return e.buttons === undefined || (e.buttons & flag) !== flag;
}
class MouseMoveStateManager {
    constructor(options) {
        this._correctEvent = options.checkCorrectEvent;
    }
    startMove(e) {
        const eventButton = DOM.mouseButton(e);
        this._eventButton = eventButton;
    }
    endMove(_e) {
        delete this._eventButton;
    }
    isValidStartEvent(e) {
        return this._correctEvent(e);
    }
    isValidMoveEvent(e) {
        // Some browsers don't fire a `mouseup` when the mouseup occurs outside
        // the window or iframe:
        // https://github.com/mapbox/mapbox-gl-js/issues/4622
        //
        // If the button is no longer pressed during this `mousemove` it may have
        // been released outside of the window or iframe.
        return !buttonNoLongerPressed(e, this._eventButton);
    }
    isValidEndEvent(e) {
        const eventButton = DOM.mouseButton(e);
        return eventButton === this._eventButton;
    }
}
class OneFingerTouchMoveStateManager {
    constructor() {
        this._firstTouch = undefined;
    }
    _isOneFingerTouch(e) {
        return e.targetTouches.length === 1;
    }
    _isSameTouchEvent(e) {
        return e.targetTouches[0].identifier === this._firstTouch;
    }
    startMove(e) {
        const firstTouch = e.targetTouches[0].identifier;
        this._firstTouch = firstTouch;
    }
    endMove(_e) {
        delete this._firstTouch;
    }
    isValidStartEvent(e) {
        return this._isOneFingerTouch(e);
    }
    isValidMoveEvent(e) {
        return this._isOneFingerTouch(e) && this._isSameTouchEvent(e);
    }
    isValidEndEvent(e) {
        return this._isOneFingerTouch(e) && this._isSameTouchEvent(e);
    }
}

const LEFT_BUTTON = 0;
const RIGHT_BUTTON = 2;
const assignEvents$1 = (handler) => {
    handler.mousedown = handler.dragStart;
    handler.mousemoveWindow = handler.dragMove;
    handler.mouseup = handler.dragEnd;
    handler.contextmenu = (e) => {
        e.preventDefault();
    };
};
const generateMousePanHandler = ({ enable, clickTolerance, }) => {
    const mouseMoveStateManager = new MouseMoveStateManager({
        checkCorrectEvent: (e) => DOM.mouseButton(e) === LEFT_BUTTON && !e.ctrlKey,
    });
    return new DragHandler({
        clickTolerance,
        move: (lastPoint, point) => ({ around: point, panDelta: point.sub(lastPoint) }),
        activateOnStart: true,
        moveStateManager: mouseMoveStateManager,
        enable,
        assignEvents: assignEvents$1,
    });
};
const generateMouseRotationHandler = ({ enable, clickTolerance, bearingDegreesPerPixelMoved = 0.8 }) => {
    const mouseMoveStateManager = new MouseMoveStateManager({
        checkCorrectEvent: (e) => (DOM.mouseButton(e) === LEFT_BUTTON && e.ctrlKey) ||
            (DOM.mouseButton(e) === RIGHT_BUTTON),
    });
    return new DragHandler({
        clickTolerance,
        move: (lastPoint, point) => ({ bearingDelta: (point.x - lastPoint.x) * bearingDegreesPerPixelMoved }),
        // prevent browser context menu when necessary; we don't allow it with rotation
        // because we can't discern rotation gesture start from contextmenu on Mac
        moveStateManager: mouseMoveStateManager,
        enable,
        assignEvents: assignEvents$1,
    });
};
const generateMousePitchHandler = ({ enable, clickTolerance, pitchDegreesPerPixelMoved = -0.5 }) => {
    const mouseMoveStateManager = new MouseMoveStateManager({
        checkCorrectEvent: (e) => (DOM.mouseButton(e) === LEFT_BUTTON && e.ctrlKey) ||
            (DOM.mouseButton(e) === RIGHT_BUTTON),
    });
    return new DragHandler({
        clickTolerance,
        move: (lastPoint, point) => ({ pitchDelta: (point.y - lastPoint.y) * pitchDegreesPerPixelMoved }),
        // prevent browser context menu when necessary; we don't allow it with rotation
        // because we can't discern rotation gesture start from contextmenu on Mac
        moveStateManager: mouseMoveStateManager,
        enable,
        assignEvents: assignEvents$1,
    });
};

/**
 * A `TouchPanHandler` allows the user to pan the map using touch gestures.
 */
class TouchPanHandler {
    constructor(options, map) {
        this._clickTolerance = options.clickTolerance || 1;
        this._map = map;
        this.reset();
    }
    reset() {
        this._active = false;
        this._touches = {};
        this._sum = new performance$1.P(0, 0);
    }
    _shouldBePrevented(touchesCount) {
        const minTouches = this._map.cooperativeGestures.isEnabled() ? 2 : 1;
        return touchesCount < minTouches;
    }
    touchstart(e, points, mapTouches) {
        return this._calculateTransform(e, points, mapTouches);
    }
    touchmove(e, points, mapTouches) {
        if (!this._active)
            return;
        if (this._shouldBePrevented(mapTouches.length)) {
            this._map.cooperativeGestures.notifyGestureBlocked('touch_pan', e);
            return;
        }
        e.preventDefault();
        return this._calculateTransform(e, points, mapTouches);
    }
    touchend(e, points, mapTouches) {
        this._calculateTransform(e, points, mapTouches);
        if (this._active && this._shouldBePrevented(mapTouches.length)) {
            this.reset();
        }
    }
    touchcancel() {
        this.reset();
    }
    _calculateTransform(e, points, mapTouches) {
        if (mapTouches.length > 0)
            this._active = true;
        const touches = indexTouches(mapTouches, points);
        const touchPointSum = new performance$1.P(0, 0);
        const touchDeltaSum = new performance$1.P(0, 0);
        let touchDeltaCount = 0;
        for (const identifier in touches) {
            const point = touches[identifier];
            const prevPoint = this._touches[identifier];
            if (prevPoint) {
                touchPointSum._add(point);
                touchDeltaSum._add(point.sub(prevPoint));
                touchDeltaCount++;
                touches[identifier] = point;
            }
        }
        this._touches = touches;
        if (this._shouldBePrevented(touchDeltaCount) || !touchDeltaSum.mag())
            return;
        const panDelta = touchDeltaSum.div(touchDeltaCount);
        this._sum._add(panDelta);
        if (this._sum.mag() < this._clickTolerance)
            return;
        const around = touchPointSum.div(touchDeltaCount);
        return {
            around,
            panDelta
        };
    }
    enable() {
        this._enabled = true;
    }
    disable() {
        this._enabled = false;
        this.reset();
    }
    isEnabled() {
        return this._enabled;
    }
    isActive() {
        return this._active;
    }
}

/**
 * The `TwoFingersTouchHandler`s allows the user to zoom, pitch and rotate the map using two fingers
 *
 */
class TwoFingersTouchHandler {
    /** @internal */
    constructor() {
        this.reset();
    }
    reset() {
        this._active = false;
        delete this._firstTwoTouches;
    }
    touchstart(e, points, mapTouches) {
        //log('touchstart', points, e.target.innerHTML, e.targetTouches.length ? e.targetTouches[0].target.innerHTML: undefined);
        if (this._firstTwoTouches || mapTouches.length < 2)
            return;
        this._firstTwoTouches = [
            mapTouches[0].identifier,
            mapTouches[1].identifier
        ];
        // implemented by child classes
        this._start([points[0], points[1]]);
    }
    touchmove(e, points, mapTouches) {
        if (!this._firstTwoTouches)
            return;
        e.preventDefault();
        const [idA, idB] = this._firstTwoTouches;
        const a = getTouchById(mapTouches, points, idA);
        const b = getTouchById(mapTouches, points, idB);
        if (!a || !b)
            return;
        const pinchAround = this._aroundCenter ? null : a.add(b).div(2);
        // implemented by child classes
        return this._move([a, b], pinchAround, e);
    }
    touchend(e, points, mapTouches) {
        if (!this._firstTwoTouches)
            return;
        const [idA, idB] = this._firstTwoTouches;
        const a = getTouchById(mapTouches, points, idA);
        const b = getTouchById(mapTouches, points, idB);
        if (a && b)
            return;
        if (this._active)
            DOM.suppressClick();
        this.reset();
    }
    touchcancel() {
        this.reset();
    }
    /**
     * Enables the "drag to pitch" interaction.
     *
     * @example
     * ```ts
     * map.touchPitch.enable();
     * ```
     */
    enable(options) {
        this._enabled = true;
        this._aroundCenter = !!options && options.around === 'center';
    }
    /**
     * Disables the "drag to pitch" interaction.
     *
     * @example
     * ```ts
     * map.touchPitch.disable();
     * ```
     */
    disable() {
        this._enabled = false;
        this.reset();
    }
    /**
     * Returns a Boolean indicating whether the "drag to pitch" interaction is enabled.
     *
     * @returns  `true` if the "drag to pitch" interaction is enabled.
     */
    isEnabled() {
        return !!this._enabled;
    }
    /**
     * Returns a Boolean indicating whether the "drag to pitch" interaction is active, i.e. currently being used.
     *
     * @returns `true` if the "drag to pitch" interaction is active.
     */
    isActive() {
        return !!this._active;
    }
}
function getTouchById(mapTouches, points, identifier) {
    for (let i = 0; i < mapTouches.length; i++) {
        if (mapTouches[i].identifier === identifier)
            return points[i];
    }
    return undefined;
}
/* ZOOM */
const ZOOM_THRESHOLD = 0.1;
function getZoomDelta(distance, lastDistance) {
    return Math.log(distance / lastDistance) / Math.LN2;
}
/**
 * The `TwoFingersTouchHandler`s allows the user to zoom the map two fingers
 *
 * @group Handlers
 */
class TwoFingersTouchZoomHandler extends TwoFingersTouchHandler {
    reset() {
        super.reset();
        delete this._distance;
        delete this._startDistance;
    }
    _start(points) {
        this._startDistance = this._distance = points[0].dist(points[1]);
    }
    _move(points, pinchAround) {
        const lastDistance = this._distance;
        this._distance = points[0].dist(points[1]);
        if (!this._active && Math.abs(getZoomDelta(this._distance, this._startDistance)) < ZOOM_THRESHOLD)
            return;
        this._active = true;
        return {
            zoomDelta: getZoomDelta(this._distance, lastDistance),
            pinchAround
        };
    }
}
/* ROTATE */
const ROTATION_THRESHOLD = 25; // pixels along circumference of touch circle
function getBearingDelta(a, b) {
    return a.angleWith(b) * 180 / Math.PI;
}
/**
 * The `TwoFingersTouchHandler`s allows the user to rotate the map two fingers
 *
 * @group Handlers
 */
class TwoFingersTouchRotateHandler extends TwoFingersTouchHandler {
    reset() {
        super.reset();
        delete this._minDiameter;
        delete this._startVector;
        delete this._vector;
    }
    _start(points) {
        this._startVector = this._vector = points[0].sub(points[1]);
        this._minDiameter = points[0].dist(points[1]);
    }
    _move(points, pinchAround, _e) {
        const lastVector = this._vector;
        this._vector = points[0].sub(points[1]);
        if (!this._active && this._isBelowThreshold(this._vector))
            return;
        this._active = true;
        return {
            bearingDelta: getBearingDelta(this._vector, lastVector),
            pinchAround
        };
    }
    _isBelowThreshold(vector) {
        /*
         * The threshold before a rotation actually happens is configured in
         * pixels along the circumference of the circle formed by the two fingers.
         * This makes the threshold in degrees larger when the fingers are close
         * together and smaller when the fingers are far apart.
         *
         * Use the smallest diameter from the whole gesture to reduce sensitivity
         * when pinching in and out.
         */
        this._minDiameter = Math.min(this._minDiameter, vector.mag());
        const circumference = Math.PI * this._minDiameter;
        const threshold = ROTATION_THRESHOLD / circumference * 360;
        const bearingDeltaSinceStart = getBearingDelta(vector, this._startVector);
        return Math.abs(bearingDeltaSinceStart) < threshold;
    }
}
/* PITCH */
function isVertical(vector) {
    return Math.abs(vector.y) > Math.abs(vector.x);
}
const ALLOWED_SINGLE_TOUCH_TIME = 100;
/**
 * The `TwoFingersTouchPitchHandler` allows the user to pitch the map by dragging up and down with two fingers.
 *
 * @group Handlers
 */
class TwoFingersTouchPitchHandler extends TwoFingersTouchHandler {
    constructor(map) {
        super();
        this._currentTouchCount = 0;
        this._map = map;
    }
    reset() {
        super.reset();
        this._valid = undefined;
        delete this._firstMove;
        delete this._lastPoints;
    }
    touchstart(e, points, mapTouches) {
        super.touchstart(e, points, mapTouches);
        this._currentTouchCount = mapTouches.length;
    }
    _start(points) {
        this._lastPoints = points;
        if (isVertical(points[0].sub(points[1]))) {
            // fingers are more horizontal than vertical
            this._valid = false;
        }
    }
    _move(points, center, e) {
        // If cooperative gestures is enabled, we need a 3-finger minimum for this gesture to register
        if (this._map.cooperativeGestures.isEnabled() && this._currentTouchCount < 3) {
            return;
        }
        const vectorA = points[0].sub(this._lastPoints[0]);
        const vectorB = points[1].sub(this._lastPoints[1]);
        this._valid = this.gestureBeginsVertically(vectorA, vectorB, e.timeStamp);
        if (!this._valid)
            return;
        this._lastPoints = points;
        this._active = true;
        const yDeltaAverage = (vectorA.y + vectorB.y) / 2;
        const degreesPerPixelMoved = -0.5;
        return {
            pitchDelta: yDeltaAverage * degreesPerPixelMoved
        };
    }
    gestureBeginsVertically(vectorA, vectorB, timeStamp) {
        if (this._valid !== undefined)
            return this._valid;
        const threshold = 2;
        const movedA = vectorA.mag() >= threshold;
        const movedB = vectorB.mag() >= threshold;
        // neither finger has moved a meaningful amount, wait
        if (!movedA && !movedB)
            return;
        // One finger has moved and the other has not.
        // If enough time has passed, decide it is not a pitch.
        if (!movedA || !movedB) {
            if (this._firstMove === undefined) {
                this._firstMove = timeStamp;
            }
            if (timeStamp - this._firstMove < ALLOWED_SINGLE_TOUCH_TIME) {
                // still waiting for a movement from the second finger
                return undefined;
            }
            else {
                return false;
            }
        }
        const isSameDirection = vectorA.y > 0 === vectorB.y > 0;
        return isVertical(vectorA) && isVertical(vectorB) && isSameDirection;
    }
}

const defaultOptions$5 = {
    panStep: 100,
    bearingStep: 15,
    pitchStep: 10
};
/**
 * The `KeyboardHandler` allows the user to zoom, rotate, and pan the map using
 * the following keyboard shortcuts:
 *
 * - `=` / `+`: Increase the zoom level by 1.
 * - `Shift-=` / `Shift-+`: Increase the zoom level by 2.
 * - `-`: Decrease the zoom level by 1.
 * - `Shift--`: Decrease the zoom level by 2.
 * - Arrow keys: Pan by 100 pixels.
 * - `Shift+⇢`: Increase the rotation by 15 degrees.
 * - `Shift+⇠`: Decrease the rotation by 15 degrees.
 * - `Shift+⇡`: Increase the pitch by 10 degrees.
 * - `Shift+⇣`: Decrease the pitch by 10 degrees.
 *
 * @group Handlers
 */
class KeyboardHandler {
    /** @internal */
    constructor(map) {
        this._tr = new TransformProvider(map);
        const stepOptions = defaultOptions$5;
        this._panStep = stepOptions.panStep;
        this._bearingStep = stepOptions.bearingStep;
        this._pitchStep = stepOptions.pitchStep;
        this._rotationDisabled = false;
    }
    reset() {
        this._active = false;
    }
    keydown(e) {
        if (e.altKey || e.ctrlKey || e.metaKey)
            return;
        let zoomDir = 0;
        let bearingDir = 0;
        let pitchDir = 0;
        let xDir = 0;
        let yDir = 0;
        switch (e.keyCode) {
            case 61:
            case 107:
            case 171:
            case 187:
                zoomDir = 1;
                break;
            case 189:
            case 109:
            case 173:
                zoomDir = -1;
                break;
            case 37:
                if (e.shiftKey) {
                    bearingDir = -1;
                }
                else {
                    e.preventDefault();
                    xDir = -1;
                }
                break;
            case 39:
                if (e.shiftKey) {
                    bearingDir = 1;
                }
                else {
                    e.preventDefault();
                    xDir = 1;
                }
                break;
            case 38:
                if (e.shiftKey) {
                    pitchDir = 1;
                }
                else {
                    e.preventDefault();
                    yDir = -1;
                }
                break;
            case 40:
                if (e.shiftKey) {
                    pitchDir = -1;
                }
                else {
                    e.preventDefault();
                    yDir = 1;
                }
                break;
            default:
                return;
        }
        if (this._rotationDisabled) {
            bearingDir = 0;
            pitchDir = 0;
        }
        return {
            cameraAnimation: (map) => {
                const tr = this._tr;
                map.easeTo({
                    duration: 300,
                    easeId: 'keyboardHandler',
                    easing: easeOut,
                    zoom: zoomDir ? Math.round(tr.zoom) + zoomDir * (e.shiftKey ? 2 : 1) : tr.zoom,
                    bearing: tr.bearing + bearingDir * this._bearingStep,
                    pitch: tr.pitch + pitchDir * this._pitchStep,
                    offset: [-xDir * this._panStep, -yDir * this._panStep],
                    center: tr.center
                }, { originalEvent: e });
            }
        };
    }
    /**
     * Enables the "keyboard rotate and zoom" interaction.
     *
     * @example
     * ```ts
     * map.keyboard.enable();
     * ```
     */
    enable() {
        this._enabled = true;
    }
    /**
     * Disables the "keyboard rotate and zoom" interaction.
     *
     * @example
     * ```ts
     * map.keyboard.disable();
     * ```
     */
    disable() {
        this._enabled = false;
        this.reset();
    }
    /**
     * Returns a Boolean indicating whether the "keyboard rotate and zoom"
     * interaction is enabled.
     *
     * @returns `true` if the "keyboard rotate and zoom"
     * interaction is enabled.
     */
    isEnabled() {
        return this._enabled;
    }
    /**
     * Returns true if the handler is enabled and has detected the start of a
     * zoom/rotate gesture.
     *
     * @returns `true` if the handler is enabled and has detected the
     * start of a zoom/rotate gesture.
     */
    isActive() {
        return this._active;
    }
    /**
     * Disables the "keyboard pan/rotate" interaction, leaving the
     * "keyboard zoom" interaction enabled.
     *
     * @example
     * ```ts
     * map.keyboard.disableRotation();
     * ```
     */
    disableRotation() {
        this._rotationDisabled = true;
    }
    /**
     * Enables the "keyboard pan/rotate" interaction.
     *
     * @example
     * ```ts
     * map.keyboard.enable();
     * map.keyboard.enableRotation();
     * ```
     */
    enableRotation() {
        this._rotationDisabled = false;
    }
}
function easeOut(t) {
    return t * (2 - t);
}

// deltaY value for mouse scroll wheel identification
const wheelZoomDelta = 4.000244140625;
// These magic numbers control the rate of zoom. Trackpad events fire at a greater
// frequency than mouse scroll wheel, so reduce the zoom rate per wheel tick
const defaultZoomRate = 1 / 100;
const wheelZoomRate = 1 / 450;
// upper bound on how much we scale the map in any single render frame; this
// is used to limit zoom rate in the case of very fast scrolling
const maxScalePerFrame = 2;
/**
 * The `ScrollZoomHandler` allows the user to zoom the map by scrolling.
 *
 * @group Handlers
 */
class ScrollZoomHandler {
    /** @internal */
    constructor(map, triggerRenderFrame) {
        this._onTimeout = (initialEvent) => {
            this._type = 'wheel';
            this._delta -= this._lastValue;
            if (!this._active) {
                this._start(initialEvent);
            }
        };
        this._map = map;
        this._tr = new TransformProvider(map);
        this._triggerRenderFrame = triggerRenderFrame;
        this._delta = 0;
        this._defaultZoomRate = defaultZoomRate;
        this._wheelZoomRate = wheelZoomRate;
    }
    /**
     * Set the zoom rate of a trackpad
     * @param zoomRate - 1/100 The rate used to scale trackpad movement to a zoom value.
     * @example
     * Speed up trackpad zoom
     * ```ts
     * map.scrollZoom.setZoomRate(1/25);
     * ```
     */
    setZoomRate(zoomRate) {
        this._defaultZoomRate = zoomRate;
    }
    /**
     * Set the zoom rate of a mouse wheel
     * @param wheelZoomRate - 1/450 The rate used to scale mouse wheel movement to a zoom value.
     * @example
     * Slow down zoom of mouse wheel
     * ```ts
     * map.scrollZoom.setWheelZoomRate(1/600);
     * ```
     */
    setWheelZoomRate(wheelZoomRate) {
        this._wheelZoomRate = wheelZoomRate;
    }
    /**
     * Returns a Boolean indicating whether the "scroll to zoom" interaction is enabled.
     * @returns `true` if the "scroll to zoom" interaction is enabled.
     */
    isEnabled() {
        return !!this._enabled;
    }
    /*
    * Active state is turned on and off with every scroll wheel event and is set back to false before the map
    * render is called, so _active is not a good candidate for determining if a scroll zoom animation is in
    * progress.
    */
    isActive() {
        return !!this._active || this._finishTimeout !== undefined;
    }
    isZooming() {
        return !!this._zooming;
    }
    /**
     * Enables the "scroll to zoom" interaction.
     *
     * @param options - Options object.
     * @example
     * ```ts
     * map.scrollZoom.enable();
     * map.scrollZoom.enable({ around: 'center' })
     * ```
     */
    enable(options) {
        if (this.isEnabled())
            return;
        this._enabled = true;
        this._aroundCenter = !!options && options.around === 'center';
    }
    /**
     * Disables the "scroll to zoom" interaction.
     *
     * @example
     * ```ts
     * map.scrollZoom.disable();
     * ```
     */
    disable() {
        if (!this.isEnabled())
            return;
        this._enabled = false;
    }
    /**
     * Determines whether or not the gesture is blocked due to cooperativeGestures.
     */
    _shouldBePrevented(e) {
        if (!this._map.cooperativeGestures.isEnabled()) {
            return false;
        }
        const isTrackpadPinch = e.ctrlKey;
        const isBypassed = isTrackpadPinch || this._map.cooperativeGestures.isBypassed(e);
        return !isBypassed;
    }
    wheel(e) {
        if (!this.isEnabled())
            return;
        if (this._shouldBePrevented(e)) {
            this._map.cooperativeGestures.notifyGestureBlocked('wheel_zoom', e);
            return;
        }
        let value = e.deltaMode === WheelEvent.DOM_DELTA_LINE ? e.deltaY * 40 : e.deltaY;
        const now = browser.now(), timeDelta = now - (this._lastWheelEventTime || 0);
        this._lastWheelEventTime = now;
        if (value !== 0 && (value % wheelZoomDelta) === 0) {
            // This one is definitely a mouse wheel event.
            this._type = 'wheel';
        }
        else if (value !== 0 && Math.abs(value) < 4) {
            // This one is definitely a trackpad event because it is so small.
            this._type = 'trackpad';
        }
        else if (timeDelta > 400) {
            // This is likely a new scroll action.
            this._type = null;
            this._lastValue = value;
            // Start a timeout in case this was a singular event, and delay it by up to 40ms.
            this._timeout = setTimeout(this._onTimeout, 40, e);
        }
        else if (!this._type) {
            // This is a repeating event, but we don't know the type of event just yet.
            // If the delta per time is small, we assume it's a fast trackpad; otherwise we switch into wheel mode.
            this._type = (Math.abs(timeDelta * value) < 200) ? 'trackpad' : 'wheel';
            // Make sure our delayed event isn't fired again, because we accumulate
            // the previous event (which was less than 40ms ago) into this event.
            if (this._timeout) {
                clearTimeout(this._timeout);
                this._timeout = null;
                value += this._lastValue;
            }
        }
        // Slow down zoom if shift key is held for more precise zooming
        if (e.shiftKey && value)
            value = value / 4;
        // Only fire the callback if we actually know what type of scrolling device the user uses.
        if (this._type) {
            this._lastWheelEvent = e;
            this._delta -= value;
            if (!this._active) {
                this._start(e);
            }
        }
        e.preventDefault();
    }
    _start(e) {
        if (!this._delta)
            return;
        if (this._frameId) {
            this._frameId = null;
        }
        this._active = true;
        if (!this.isZooming()) {
            this._zooming = true;
        }
        if (this._finishTimeout) {
            clearTimeout(this._finishTimeout);
            delete this._finishTimeout;
        }
        const pos = DOM.mousePos(this._map.getCanvas(), e);
        const tr = this._tr;
        if (pos.y > tr.transform.height / 2 - tr.transform.getHorizon()) {
            this._around = performance$1.N.convert(this._aroundCenter ? tr.center : tr.unproject(pos));
        }
        else {
            // Do not use current cursor position if above the horizon to avoid 'unproject' this point
            // as it is not mapped into 'coords' framebuffer or inversible with 'pixelMatrixInverse'.
            this._around = performance$1.N.convert(tr.center);
        }
        this._aroundPoint = tr.transform.locationPoint(this._around);
        if (!this._frameId) {
            this._frameId = true;
            this._triggerRenderFrame();
        }
    }
    renderFrame() {
        if (!this._frameId)
            return;
        this._frameId = null;
        if (!this.isActive())
            return;
        const tr = this._tr.transform;
        // if we've had scroll events since the last render frame, consume the
        // accumulated delta, and update the target zoom level accordingly
        if (this._delta !== 0) {
            // For trackpad events and single mouse wheel ticks, use the default zoom rate
            const zoomRate = (this._type === 'wheel' && Math.abs(this._delta) > wheelZoomDelta) ? this._wheelZoomRate : this._defaultZoomRate;
            // Scale by sigmoid of scroll wheel delta.
            let scale = maxScalePerFrame / (1 + Math.exp(-Math.abs(this._delta * zoomRate)));
            if (this._delta < 0 && scale !== 0) {
                scale = 1 / scale;
            }
            const fromScale = typeof this._targetZoom === 'number' ? tr.zoomScale(this._targetZoom) : tr.scale;
            this._targetZoom = Math.min(tr.maxZoom, Math.max(tr.minZoom, tr.scaleZoom(fromScale * scale)));
            // if this is a mouse wheel, refresh the starting zoom and easing
            // function we're using to smooth out the zooming between wheel
            // events
            if (this._type === 'wheel') {
                this._startZoom = tr.zoom;
                this._easing = this._smoothOutEasing(200);
            }
            this._delta = 0;
        }
        const targetZoom = typeof this._targetZoom === 'number' ?
            this._targetZoom : tr.zoom;
        const startZoom = this._startZoom;
        const easing = this._easing;
        let finished = false;
        let zoom;
        const lastWheelEventTimeDiff = browser.now() - this._lastWheelEventTime;
        if (this._type === 'wheel' && startZoom && easing && lastWheelEventTimeDiff) {
            const t = Math.min(lastWheelEventTimeDiff / 200, 1);
            const k = easing(t);
            zoom = performance$1.z.number(startZoom, targetZoom, k);
            if (t < 1) {
                if (!this._frameId) {
                    this._frameId = true;
                }
            }
            else {
                finished = true;
            }
        }
        else {
            zoom = targetZoom;
            finished = true;
        }
        this._active = true;
        if (finished) {
            this._active = false;
            this._finishTimeout = setTimeout(() => {
                this._zooming = false;
                this._triggerRenderFrame();
                delete this._targetZoom;
                delete this._finishTimeout;
            }, 200);
        }
        return {
            noInertia: true,
            needsRenderFrame: !finished,
            zoomDelta: zoom - tr.zoom,
            around: this._aroundPoint,
            originalEvent: this._lastWheelEvent
        };
    }
    _smoothOutEasing(duration) {
        let easing = performance$1.b9;
        if (this._prevEase) {
            const currentEase = this._prevEase;
            const t = (browser.now() - currentEase.start) / currentEase.duration;
            const speed = currentEase.easing(t + 0.01) - currentEase.easing(t);
            // Quick hack to make new bezier that is continuous with last
            const x = 0.27 / Math.sqrt(speed * speed + 0.0001) * 0.01;
            const y = Math.sqrt(0.27 * 0.27 - x * x);
            easing = performance$1.b8(x, y, 0.25, 1);
        }
        this._prevEase = {
            start: browser.now(),
            duration,
            easing
        };
        return easing;
    }
    reset() {
        this._active = false;
        this._zooming = false;
        delete this._targetZoom;
        if (this._finishTimeout) {
            clearTimeout(this._finishTimeout);
            delete this._finishTimeout;
        }
    }
}

/**
 * The `DoubleClickZoomHandler` allows the user to zoom the map at a point by
 * double clicking or double tapping.
 *
 * @group Handlers
 */
class DoubleClickZoomHandler {
    /** @internal */
    constructor(clickZoom, TapZoom) {
        this._clickZoom = clickZoom;
        this._tapZoom = TapZoom;
    }
    /**
     * Enables the "double click to zoom" interaction.
     *
     * @example
     * ```ts
     * map.doubleClickZoom.enable();
     * ```
     */
    enable() {
        this._clickZoom.enable();
        this._tapZoom.enable();
    }
    /**
     * Disables the "double click to zoom" interaction.
     *
     * @example
     * ```ts
     * map.doubleClickZoom.disable();
     * ```
     */
    disable() {
        this._clickZoom.disable();
        this._tapZoom.disable();
    }
    /**
     * Returns a Boolean indicating whether the "double click to zoom" interaction is enabled.
     *
     * @returns `true` if the "double click to zoom" interaction is enabled.
     */
    isEnabled() {
        return this._clickZoom.isEnabled() && this._tapZoom.isEnabled();
    }
    /**
     * Returns a Boolean indicating whether the "double click to zoom" interaction is active, i.e. currently being used.
     *
     * @returns `true` if the "double click to zoom" interaction is active.
     */
    isActive() {
        return this._clickZoom.isActive() || this._tapZoom.isActive();
    }
}

/**
 * The `ClickZoomHandler` allows the user to zoom the map at a point by double clicking
 * It is used by other handlers
 */
class ClickZoomHandler {
    /** @internal */
    constructor(map) {
        this._tr = new TransformProvider(map);
        this.reset();
    }
    reset() {
        this._active = false;
    }
    dblclick(e, point) {
        e.preventDefault();
        return {
            cameraAnimation: (map) => {
                map.easeTo({
                    duration: 300,
                    zoom: this._tr.zoom + (e.shiftKey ? -1 : 1),
                    around: this._tr.unproject(point)
                }, { originalEvent: e });
            }
        };
    }
    enable() {
        this._enabled = true;
    }
    disable() {
        this._enabled = false;
        this.reset();
    }
    isEnabled() {
        return this._enabled;
    }
    isActive() {
        return this._active;
    }
}

/**
 * A `TapDragZoomHandler` allows the user to zoom the map at a point by double tapping. It also allows the user pan the map by dragging.
 */
class TapDragZoomHandler {
    constructor() {
        this._tap = new TapRecognizer({
            numTouches: 1,
            numTaps: 1
        });
        this.reset();
    }
    reset() {
        this._active = false;
        delete this._swipePoint;
        delete this._swipeTouch;
        delete this._tapTime;
        delete this._tapPoint;
        this._tap.reset();
    }
    touchstart(e, points, mapTouches) {
        if (this._swipePoint)
            return;
        if (!this._tapTime) {
            this._tap.touchstart(e, points, mapTouches);
        }
        else {
            const swipePoint = points[0];
            const soonEnough = e.timeStamp - this._tapTime < MAX_TAP_INTERVAL;
            const closeEnough = this._tapPoint.dist(swipePoint) < MAX_DIST;
            if (!soonEnough || !closeEnough) {
                this.reset();
            }
            else if (mapTouches.length > 0) {
                this._swipePoint = swipePoint;
                this._swipeTouch = mapTouches[0].identifier;
            }
        }
    }
    touchmove(e, points, mapTouches) {
        if (!this._tapTime) {
            this._tap.touchmove(e, points, mapTouches);
        }
        else if (this._swipePoint) {
            if (mapTouches[0].identifier !== this._swipeTouch) {
                return;
            }
            const newSwipePoint = points[0];
            const dist = newSwipePoint.y - this._swipePoint.y;
            this._swipePoint = newSwipePoint;
            e.preventDefault();
            this._active = true;
            return {
                zoomDelta: dist / 128
            };
        }
    }
    touchend(e, points, mapTouches) {
        if (!this._tapTime) {
            const point = this._tap.touchend(e, points, mapTouches);
            if (point) {
                this._tapTime = e.timeStamp;
                this._tapPoint = point;
            }
        }
        else if (this._swipePoint) {
            if (mapTouches.length === 0) {
                this.reset();
            }
        }
    }
    touchcancel() {
        this.reset();
    }
    enable() {
        this._enabled = true;
    }
    disable() {
        this._enabled = false;
        this.reset();
    }
    isEnabled() {
        return this._enabled;
    }
    isActive() {
        return this._active;
    }
}

/**
 * The `DragPanHandler` allows the user to pan the map by clicking and dragging
 * the cursor.
 *
 * @group Handlers
 */
class DragPanHandler {
    /** @internal */
    constructor(el, mousePan, touchPan) {
        this._el = el;
        this._mousePan = mousePan;
        this._touchPan = touchPan;
    }
    /**
     * Enables the "drag to pan" interaction.
     *
     * @param options - Options object
     * @example
     * ```ts
     *   map.dragPan.enable();
     *   map.dragPan.enable({
     *      linearity: 0.3,
     *      easing: bezier(0, 0, 0.3, 1),
     *      maxSpeed: 1400,
     *      deceleration: 2500,
     *   });
     * ```
     */
    enable(options) {
        this._inertiaOptions = options || {};
        this._mousePan.enable();
        this._touchPan.enable();
        this._el.classList.add('maplibregl-touch-drag-pan');
    }
    /**
     * Disables the "drag to pan" interaction.
     *
     * @example
     * ```ts
     * map.dragPan.disable();
     * ```
     */
    disable() {
        this._mousePan.disable();
        this._touchPan.disable();
        this._el.classList.remove('maplibregl-touch-drag-pan');
    }
    /**
     * Returns a Boolean indicating whether the "drag to pan" interaction is enabled.
     *
     * @returns `true` if the "drag to pan" interaction is enabled.
     */
    isEnabled() {
        return this._mousePan.isEnabled() && this._touchPan.isEnabled();
    }
    /**
     * Returns a Boolean indicating whether the "drag to pan" interaction is active, i.e. currently being used.
     *
     * @returns `true` if the "drag to pan" interaction is active.
     */
    isActive() {
        return this._mousePan.isActive() || this._touchPan.isActive();
    }
}

/**
 * The `DragRotateHandler` allows the user to rotate the map by clicking and
 * dragging the cursor while holding the right mouse button or `ctrl` key.
 *
 * @group Handlers
 */
class DragRotateHandler {
    /** @internal */
    constructor(options, mouseRotate, mousePitch) {
        this._pitchWithRotate = options.pitchWithRotate;
        this._mouseRotate = mouseRotate;
        this._mousePitch = mousePitch;
    }
    /**
     * Enables the "drag to rotate" interaction.
     *
     * @example
     * ```ts
     * map.dragRotate.enable();
     * ```
     */
    enable() {
        this._mouseRotate.enable();
        if (this._pitchWithRotate)
            this._mousePitch.enable();
    }
    /**
     * Disables the "drag to rotate" interaction.
     *
     * @example
     * ```ts
     * map.dragRotate.disable();
     * ```
     */
    disable() {
        this._mouseRotate.disable();
        this._mousePitch.disable();
    }
    /**
     * Returns a Boolean indicating whether the "drag to rotate" interaction is enabled.
     *
     * @returns `true` if the "drag to rotate" interaction is enabled.
     */
    isEnabled() {
        return this._mouseRotate.isEnabled() && (!this._pitchWithRotate || this._mousePitch.isEnabled());
    }
    /**
     * Returns a Boolean indicating whether the "drag to rotate" interaction is active, i.e. currently being used.
     *
     * @returns `true` if the "drag to rotate" interaction is active.
     */
    isActive() {
        return this._mouseRotate.isActive() || this._mousePitch.isActive();
    }
}

/**
 * The `TwoFingersTouchZoomRotateHandler` allows the user to zoom and rotate the map by
 * pinching on a touchscreen.
 *
 * They can zoom with one finger by double tapping and dragging. On the second tap,
 * hold the finger down and drag up or down to zoom in or out.
 *
 * @group Handlers
 */
class TwoFingersTouchZoomRotateHandler {
    /** @internal */
    constructor(el, touchZoom, touchRotate, tapDragZoom) {
        this._el = el;
        this._touchZoom = touchZoom;
        this._touchRotate = touchRotate;
        this._tapDragZoom = tapDragZoom;
        this._rotationDisabled = false;
        this._enabled = true;
    }
    /**
     * Enables the "pinch to rotate and zoom" interaction.
     *
     * @param options - Options object.
     *
     * @example
     * ```ts
     * map.touchZoomRotate.enable();
     * map.touchZoomRotate.enable({ around: 'center' });
     * ```
     */
    enable(options) {
        this._touchZoom.enable(options);
        if (!this._rotationDisabled)
            this._touchRotate.enable(options);
        this._tapDragZoom.enable();
        this._el.classList.add('maplibregl-touch-zoom-rotate');
    }
    /**
     * Disables the "pinch to rotate and zoom" interaction.
     *
     * @example
     * ```ts
     * map.touchZoomRotate.disable();
     * ```
     */
    disable() {
        this._touchZoom.disable();
        this._touchRotate.disable();
        this._tapDragZoom.disable();
        this._el.classList.remove('maplibregl-touch-zoom-rotate');
    }
    /**
     * Returns a Boolean indicating whether the "pinch to rotate and zoom" interaction is enabled.
     *
     * @returns `true` if the "pinch to rotate and zoom" interaction is enabled.
     */
    isEnabled() {
        return this._touchZoom.isEnabled() &&
            (this._rotationDisabled || this._touchRotate.isEnabled()) &&
            this._tapDragZoom.isEnabled();
    }
    /**
     * Returns true if the handler is enabled and has detected the start of a zoom/rotate gesture.
     *
     * @returns `true` if the handler is active, `false` otherwise
     */
    isActive() {
        return this._touchZoom.isActive() || this._touchRotate.isActive() || this._tapDragZoom.isActive();
    }
    /**
     * Disables the "pinch to rotate" interaction, leaving the "pinch to zoom"
     * interaction enabled.
     *
     * @example
     * ```ts
     * map.touchZoomRotate.disableRotation();
     * ```
     */
    disableRotation() {
        this._rotationDisabled = true;
        this._touchRotate.disable();
    }
    /**
     * Enables the "pinch to rotate" interaction.
     *
     * @example
     * ```ts
     * map.touchZoomRotate.enable();
     * map.touchZoomRotate.enableRotation();
     * ```
     */
    enableRotation() {
        this._rotationDisabled = false;
        if (this._touchZoom.isEnabled())
            this._touchRotate.enable();
    }
}

/**
 * A `CooperativeGestureHandler` is a control that adds cooperative gesture info when user tries to zoom in/out.
 *
 * When the CooperativeGestureHandler blocks a gesture, it will emit a `cooperativegestureprevented` event.
 *
 * @group Handlers
 *
 * @example
 * ```ts
 * const map = new Map({
 *   cooperativeGestures: true
 * });
 * ```
 * @see [Example: cooperative gestures](https://maplibre.org/maplibre-gl-js/docs/examples/cooperative-gestures/)
 **/
class CooperativeGesturesHandler {
    constructor(map, options) {
        /**
         * This is the key that will allow to bypass the cooperative gesture protection
         */
        this._bypassKey = navigator.userAgent.indexOf('Mac') !== -1 ? 'metaKey' : 'ctrlKey';
        this._map = map;
        this._options = options;
        this._enabled = false;
    }
    isActive() {
        return false;
    }
    reset() { }
    _setupUI() {
        if (this._container)
            return;
        const mapCanvasContainer = this._map.getCanvasContainer();
        // Add a cooperative gestures class (enable touch-action: pan-x pan-y;)
        mapCanvasContainer.classList.add('maplibregl-cooperative-gestures');
        this._container = DOM.create('div', 'maplibregl-cooperative-gesture-screen', mapCanvasContainer);
        let desktopMessage = this._map._getUIString('CooperativeGesturesHandler.WindowsHelpText');
        if (this._bypassKey === 'metaKey') {
            desktopMessage = this._map._getUIString('CooperativeGesturesHandler.MacHelpText');
        }
        const mobileMessage = this._map._getUIString('CooperativeGesturesHandler.MobileHelpText');
        // Create and append the desktop message div
        const desktopDiv = document.createElement('div');
        desktopDiv.className = 'maplibregl-desktop-message';
        desktopDiv.textContent = desktopMessage;
        this._container.appendChild(desktopDiv);
        // Create and append the mobile message div
        const mobileDiv = document.createElement('div');
        mobileDiv.className = 'maplibregl-mobile-message';
        mobileDiv.textContent = mobileMessage;
        this._container.appendChild(mobileDiv);
        // Remove cooperative gesture screen from the accessibility tree since screenreaders cannot interact with the map using gestures
        this._container.setAttribute('aria-hidden', 'true');
    }
    _destroyUI() {
        if (this._container) {
            DOM.remove(this._container);
            const mapCanvasContainer = this._map.getCanvasContainer();
            mapCanvasContainer.classList.remove('maplibregl-cooperative-gestures');
        }
        delete this._container;
    }
    enable() {
        this._setupUI();
        this._enabled = true;
    }
    disable() {
        this._enabled = false;
        this._destroyUI();
    }
    isEnabled() {
        return this._enabled;
    }
    isBypassed(event) {
        return event[this._bypassKey];
    }
    notifyGestureBlocked(gestureType, originalEvent) {
        if (!this._enabled)
            return;
        // notify subscribers that a cooperative gesture was prevented
        this._map.fire(new performance$1.k('cooperativegestureprevented', { gestureType, originalEvent }));
        // Alert user how to scroll/pan
        this._container.classList.add('maplibregl-show');
        setTimeout(() => {
            this._container.classList.remove('maplibregl-show');
        }, 100);
    }
}

const isMoving = (p) => p.zoom || p.drag || p.pitch || p.rotate;
class RenderFrameEvent extends performance$1.k {
}
function hasChange(result) {
    return (result.panDelta && result.panDelta.mag()) || result.zoomDelta || result.bearingDelta || result.pitchDelta;
}
class HandlerManager {
    constructor(map, options) {
        this.handleWindowEvent = (e) => {
            this.handleEvent(e, `${e.type}Window`);
        };
        this.handleEvent = (e, eventName) => {
            if (e.type === 'blur') {
                this.stop(true);
                return;
            }
            this._updatingCamera = true;
            const inputEvent = e.type === 'renderFrame' ? undefined : e;
            /*
             * We don't call e.preventDefault() for any events by default.
             * Handlers are responsible for calling it where necessary.
             */
            const mergedHandlerResult = { needsRenderFrame: false };
            const eventsInProgress = {};
            const activeHandlers = {};
            const eventTouches = e.touches;
            const mapTouches = eventTouches ? this._getMapTouches(eventTouches) : undefined;
            const points = mapTouches ?
                DOM.touchPos(this._map.getCanvas(), mapTouches) :
                DOM.mousePos(this._map.getCanvas(), e);
            for (const { handlerName, handler, allowed } of this._handlers) {
                if (!handler.isEnabled())
                    continue;
                let data;
                if (this._blockedByActive(activeHandlers, allowed, handlerName)) {
                    handler.reset();
                }
                else {
                    if (handler[eventName || e.type]) {
                        data = handler[eventName || e.type](e, points, mapTouches);
                        this.mergeHandlerResult(mergedHandlerResult, eventsInProgress, data, handlerName, inputEvent);
                        if (data && data.needsRenderFrame) {
                            this._triggerRenderFrame();
                        }
                    }
                }
                if (data || handler.isActive()) {
                    activeHandlers[handlerName] = handler;
                }
            }
            const deactivatedHandlers = {};
            for (const name in this._previousActiveHandlers) {
                if (!activeHandlers[name]) {
                    deactivatedHandlers[name] = inputEvent;
                }
            }
            this._previousActiveHandlers = activeHandlers;
            if (Object.keys(deactivatedHandlers).length || hasChange(mergedHandlerResult)) {
                this._changes.push([mergedHandlerResult, eventsInProgress, deactivatedHandlers]);
                this._triggerRenderFrame();
            }
            if (Object.keys(activeHandlers).length || hasChange(mergedHandlerResult)) {
                this._map._stop(true);
            }
            this._updatingCamera = false;
            const { cameraAnimation } = mergedHandlerResult;
            if (cameraAnimation) {
                this._inertia.clear();
                this._fireEvents({}, {}, true);
                this._changes = [];
                cameraAnimation(this._map);
            }
        };
        this._map = map;
        this._el = this._map.getCanvasContainer();
        this._handlers = [];
        this._handlersById = {};
        this._changes = [];
        this._inertia = new HandlerInertia(map);
        this._bearingSnap = options.bearingSnap;
        this._previousActiveHandlers = {};
        // Track whether map is currently moving, to compute start/move/end events
        this._eventsInProgress = {};
        this._addDefaultHandlers(options);
        const el = this._el;
        this._listeners = [
            // This needs to be `passive: true` so that a double tap fires two
            // pairs of touchstart/end events in iOS Safari 13. If this is set to
            // `passive: false` then the second pair of events is only fired if
            // preventDefault() is called on the first touchstart. Calling preventDefault()
            // undesirably prevents click events.
            [el, 'touchstart', { passive: true }],
            // This needs to be `passive: false` so that scrolls and pinches can be
            // prevented in browsers that don't support `touch-actions: none`, for example iOS Safari 12.
            [el, 'touchmove', { passive: false }],
            [el, 'touchend', undefined],
            [el, 'touchcancel', undefined],
            [el, 'mousedown', undefined],
            [el, 'mousemove', undefined],
            [el, 'mouseup', undefined],
            // Bind window-level event listeners for move and up/end events. In the absence of
            // the pointer capture API, which is not supported by all necessary platforms,
            // window-level event listeners give us the best shot at capturing events that
            // fall outside the map canvas element. Use `{capture: true}` for the move event
            // to prevent map move events from being fired during a drag.
            [document, 'mousemove', { capture: true }],
            [document, 'mouseup', undefined],
            [el, 'mouseover', undefined],
            [el, 'mouseout', undefined],
            [el, 'dblclick', undefined],
            [el, 'click', undefined],
            [el, 'keydown', { capture: false }],
            [el, 'keyup', undefined],
            [el, 'wheel', { passive: false }],
            [el, 'contextmenu', undefined],
            [window, 'blur', undefined]
        ];
        for (const [target, type, listenerOptions] of this._listeners) {
            DOM.addEventListener(target, type, target === document ? this.handleWindowEvent : this.handleEvent, listenerOptions);
        }
    }
    destroy() {
        for (const [target, type, listenerOptions] of this._listeners) {
            DOM.removeEventListener(target, type, target === document ? this.handleWindowEvent : this.handleEvent, listenerOptions);
        }
    }
    _addDefaultHandlers(options) {
        const map = this._map;
        const el = map.getCanvasContainer();
        this._add('mapEvent', new MapEventHandler(map, options));
        const boxZoom = map.boxZoom = new BoxZoomHandler(map, options);
        this._add('boxZoom', boxZoom);
        if (options.interactive && options.boxZoom) {
            boxZoom.enable();
        }
        const cooperativeGestures = map.cooperativeGestures = new CooperativeGesturesHandler(map, options.cooperativeGestures);
        this._add('cooperativeGestures', cooperativeGestures);
        if (options.cooperativeGestures) {
            cooperativeGestures.enable();
        }
        const tapZoom = new TapZoomHandler(map);
        const clickZoom = new ClickZoomHandler(map);
        map.doubleClickZoom = new DoubleClickZoomHandler(clickZoom, tapZoom);
        this._add('tapZoom', tapZoom);
        this._add('clickZoom', clickZoom);
        if (options.interactive && options.doubleClickZoom) {
            map.doubleClickZoom.enable();
        }
        const tapDragZoom = new TapDragZoomHandler();
        this._add('tapDragZoom', tapDragZoom);
        const touchPitch = map.touchPitch = new TwoFingersTouchPitchHandler(map);
        this._add('touchPitch', touchPitch);
        if (options.interactive && options.touchPitch) {
            map.touchPitch.enable(options.touchPitch);
        }
        const mouseRotate = generateMouseRotationHandler(options);
        const mousePitch = generateMousePitchHandler(options);
        map.dragRotate = new DragRotateHandler(options, mouseRotate, mousePitch);
        this._add('mouseRotate', mouseRotate, ['mousePitch']);
        this._add('mousePitch', mousePitch, ['mouseRotate']);
        if (options.interactive && options.dragRotate) {
            map.dragRotate.enable();
        }
        const mousePan = generateMousePanHandler(options);
        const touchPan = new TouchPanHandler(options, map);
        map.dragPan = new DragPanHandler(el, mousePan, touchPan);
        this._add('mousePan', mousePan);
        this._add('touchPan', touchPan, ['touchZoom', 'touchRotate']);
        if (options.interactive && options.dragPan) {
            map.dragPan.enable(options.dragPan);
        }
        const touchRotate = new TwoFingersTouchRotateHandler();
        const touchZoom = new TwoFingersTouchZoomHandler();
        map.touchZoomRotate = new TwoFingersTouchZoomRotateHandler(el, touchZoom, touchRotate, tapDragZoom);
        this._add('touchRotate', touchRotate, ['touchPan', 'touchZoom']);
        this._add('touchZoom', touchZoom, ['touchPan', 'touchRotate']);
        if (options.interactive && options.touchZoomRotate) {
            map.touchZoomRotate.enable(options.touchZoomRotate);
        }
        const scrollZoom = map.scrollZoom = new ScrollZoomHandler(map, () => this._triggerRenderFrame());
        this._add('scrollZoom', scrollZoom, ['mousePan']);
        if (options.interactive && options.scrollZoom) {
            map.scrollZoom.enable(options.scrollZoom);
        }
        const keyboard = map.keyboard = new KeyboardHandler(map);
        this._add('keyboard', keyboard);
        if (options.interactive && options.keyboard) {
            map.keyboard.enable();
        }
        this._add('blockableMapEvent', new BlockableMapEventHandler(map));
    }
    _add(handlerName, handler, allowed) {
        this._handlers.push({ handlerName, handler, allowed });
        this._handlersById[handlerName] = handler;
    }
    stop(allowEndAnimation) {
        // do nothing if this method was triggered by a gesture update
        if (this._updatingCamera)
            return;
        for (const { handler } of this._handlers) {
            handler.reset();
        }
        this._inertia.clear();
        this._fireEvents({}, {}, allowEndAnimation);
        this._changes = [];
    }
    isActive() {
        for (const { handler } of this._handlers) {
            if (handler.isActive())
                return true;
        }
        return false;
    }
    isZooming() {
        return !!this._eventsInProgress.zoom || this._map.scrollZoom.isZooming();
    }
    isRotating() {
        return !!this._eventsInProgress.rotate;
    }
    isMoving() {
        return Boolean(isMoving(this._eventsInProgress)) || this.isZooming();
    }
    _blockedByActive(activeHandlers, allowed, myName) {
        for (const name in activeHandlers) {
            if (name === myName)
                continue;
            if (!allowed || allowed.indexOf(name) < 0) {
                return true;
            }
        }
        return false;
    }
    _getMapTouches(touches) {
        const mapTouches = [];
        for (const t of touches) {
            const target = t.target;
            if (this._el.contains(target)) {
                mapTouches.push(t);
            }
        }
        return mapTouches;
    }
    mergeHandlerResult(mergedHandlerResult, eventsInProgress, handlerResult, name, e) {
        if (!handlerResult)
            return;
        performance$1.e(mergedHandlerResult, handlerResult);
        const eventData = { handlerName: name, originalEvent: handlerResult.originalEvent || e };
        // track which handler changed which camera property
        if (handlerResult.zoomDelta !== undefined) {
            eventsInProgress.zoom = eventData;
        }
        if (handlerResult.panDelta !== undefined) {
            eventsInProgress.drag = eventData;
        }
        if (handlerResult.pitchDelta !== undefined) {
            eventsInProgress.pitch = eventData;
        }
        if (handlerResult.bearingDelta !== undefined) {
            eventsInProgress.rotate = eventData;
        }
    }
    _applyChanges() {
        const combined = {};
        const combinedEventsInProgress = {};
        const combinedDeactivatedHandlers = {};
        for (const [change, eventsInProgress, deactivatedHandlers] of this._changes) {
            if (change.panDelta)
                combined.panDelta = (combined.panDelta || new performance$1.P(0, 0))._add(change.panDelta);
            if (change.zoomDelta)
                combined.zoomDelta = (combined.zoomDelta || 0) + change.zoomDelta;
            if (change.bearingDelta)
                combined.bearingDelta = (combined.bearingDelta || 0) + change.bearingDelta;
            if (change.pitchDelta)
                combined.pitchDelta = (combined.pitchDelta || 0) + change.pitchDelta;
            if (change.around !== undefined)
                combined.around = change.around;
            if (change.pinchAround !== undefined)
                combined.pinchAround = change.pinchAround;
            if (change.noInertia)
                combined.noInertia = change.noInertia;
            performance$1.e(combinedEventsInProgress, eventsInProgress);
            performance$1.e(combinedDeactivatedHandlers, deactivatedHandlers);
        }
        this._updateMapTransform(combined, combinedEventsInProgress, combinedDeactivatedHandlers);
        this._changes = [];
    }
    _updateMapTransform(combinedResult, combinedEventsInProgress, deactivatedHandlers) {
        const map = this._map;
        const tr = map._getTransformForUpdate();
        const terrain = map.terrain;
        if (!hasChange(combinedResult) && !(terrain && this._terrainMovement)) {
            return this._fireEvents(combinedEventsInProgress, deactivatedHandlers, true);
        }
        let { panDelta, zoomDelta, bearingDelta, pitchDelta, around, pinchAround } = combinedResult;
        if (pinchAround !== undefined) {
            around = pinchAround;
        }
        // stop any ongoing camera animations (easeTo, flyTo)
        map._stop(true);
        around = around || map.transform.centerPoint;
        const loc = tr.pointLocation(panDelta ? around.sub(panDelta) : around);
        if (bearingDelta)
            tr.bearing += bearingDelta;
        if (pitchDelta)
            tr.pitch += pitchDelta;
        if (zoomDelta)
            tr.zoom += zoomDelta;
        if (!terrain) {
            tr.setLocationAtPoint(loc, around);
        }
        else {
            // when 3d-terrain is enabled act a little different:
            //    - dragging do not drag the picked point itself, instead it drags the map by pixel-delta.
            //      With this approach it is no longer possible to pick a point from somewhere near
            //      the horizon to the center in one move.
            //      So this logic avoids the problem, that in such cases you easily loose orientation.
            if (!this._terrainMovement &&
                (combinedEventsInProgress.drag || combinedEventsInProgress.zoom)) {
                // When starting to drag or move, flag it and register moveend to clear flagging
                this._terrainMovement = true;
                this._map._elevationFreeze = true;
                tr.setLocationAtPoint(loc, around);
            }
            else if (combinedEventsInProgress.drag && this._terrainMovement) {
                // drag map
                tr.center = tr.pointLocation(tr.centerPoint.sub(panDelta));
            }
            else {
                tr.setLocationAtPoint(loc, around);
            }
        }
        map._applyUpdatedTransform(tr);
        this._map._update();
        if (!combinedResult.noInertia)
            this._inertia.record(combinedResult);
        this._fireEvents(combinedEventsInProgress, deactivatedHandlers, true);
    }
    _fireEvents(newEventsInProgress, deactivatedHandlers, allowEndAnimation) {
        const wasMoving = isMoving(this._eventsInProgress);
        const nowMoving = isMoving(newEventsInProgress);
        const startEvents = {};
        for (const eventName in newEventsInProgress) {
            const { originalEvent } = newEventsInProgress[eventName];
            if (!this._eventsInProgress[eventName]) {
                startEvents[`${eventName}start`] = originalEvent;
            }
            this._eventsInProgress[eventName] = newEventsInProgress[eventName];
        }
        // fire start events only after this._eventsInProgress has been updated
        if (!wasMoving && nowMoving) {
            this._fireEvent('movestart', nowMoving.originalEvent);
        }
        for (const name in startEvents) {
            this._fireEvent(name, startEvents[name]);
        }
        if (nowMoving) {
            this._fireEvent('move', nowMoving.originalEvent);
        }
        for (const eventName in newEventsInProgress) {
            const { originalEvent } = newEventsInProgress[eventName];
            this._fireEvent(eventName, originalEvent);
        }
        const endEvents = {};
        let originalEndEvent;
        for (const eventName in this._eventsInProgress) {
            const { handlerName, originalEvent } = this._eventsInProgress[eventName];
            if (!this._handlersById[handlerName].isActive()) {
                delete this._eventsInProgress[eventName];
                originalEndEvent = deactivatedHandlers[handlerName] || originalEvent;
                endEvents[`${eventName}end`] = originalEndEvent;
            }
        }
        for (const name in endEvents) {
            this._fireEvent(name, endEvents[name]);
        }
        const stillMoving = isMoving(this._eventsInProgress);
        const finishedMoving = (wasMoving || nowMoving) && !stillMoving;
        if (finishedMoving && this._terrainMovement) {
            this._map._elevationFreeze = false;
            this._terrainMovement = false;
            const tr = this._map._getTransformForUpdate();
            tr.recalculateZoom(this._map.terrain);
            this._map._applyUpdatedTransform(tr);
        }
        if (allowEndAnimation && finishedMoving) {
            this._updatingCamera = true;
            const inertialEase = this._inertia._onMoveEnd(this._map.dragPan._inertiaOptions);
            const shouldSnapToNorth = bearing => bearing !== 0 && -this._bearingSnap < bearing && bearing < this._bearingSnap;
            if (inertialEase && (inertialEase.essential || !browser.prefersReducedMotion)) {
                if (shouldSnapToNorth(inertialEase.bearing || this._map.getBearing())) {
                    inertialEase.bearing = 0;
                }
                inertialEase.freezeElevation = true;
                this._map.easeTo(inertialEase, { originalEvent: originalEndEvent });
            }
            else {
                this._map.fire(new performance$1.k('moveend', { originalEvent: originalEndEvent }));
                if (shouldSnapToNorth(this._map.getBearing())) {
                    this._map.resetNorth();
                }
            }
            this._updatingCamera = false;
        }
    }
    _fireEvent(type, e) {
        this._map.fire(new performance$1.k(type, e ? { originalEvent: e } : {}));
    }
    _requestFrame() {
        this._map.triggerRepaint();
        return this._map._renderTaskQueue.add(timeStamp => {
            delete this._frameId;
            this.handleEvent(new RenderFrameEvent('renderFrame', { timeStamp }));
            this._applyChanges();
        });
    }
    _triggerRenderFrame() {
        if (this._frameId === undefined) {
            this._frameId = this._requestFrame();
        }
    }
}

class Camera extends performance$1.E {
    constructor(transform, options) {
        super();
        // Callback for map._requestRenderFrame
        this._renderFrameCallback = () => {
            const t = Math.min((browser.now() - this._easeStart) / this._easeOptions.duration, 1);
            this._onEaseFrame(this._easeOptions.easing(t));
            // if _stop is called during _onEaseFrame from _fireMoveEvents we should avoid a new _requestRenderFrame, checking it by ensuring _easeFrameId was not deleted
            if (t < 1 && this._easeFrameId) {
                this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback);
            }
            else {
                this.stop();
            }
        };
        this._moving = false;
        this._zooming = false;
        this.transform = transform;
        this._bearingSnap = options.bearingSnap;
        this.on('moveend', () => {
            delete this._requestedCameraState;
        });
    }
    /**
     * Returns the map's geographical centerpoint.
     *
     * @returns The map's geographical centerpoint.
     * @example
     * Return a LngLat object such as `{lng: 0, lat: 0}`
     * ```ts
     * let center = map.getCenter();
     * // access longitude and latitude values directly
     * let {lng, lat} = map.getCenter();
     * ```
     */
    getCenter() { return new performance$1.N(this.transform.center.lng, this.transform.center.lat); }
    /**
     * Sets the map's geographical centerpoint. Equivalent to `jumpTo({center: center})`.
     *
     * Triggers the following events: `movestart` and `moveend`.
     *
     * @param center - The centerpoint to set.
     * @param eventData - Additional properties to be added to event objects of events triggered by this method.
     * @example
     * ```ts
     * map.setCenter([-74, 38]);
     * ```
     */
    setCenter(center, eventData) {
        return this.jumpTo({ center }, eventData);
    }
    /**
     * Pans the map by the specified offset.
     *
     * Triggers the following events: `movestart` and `moveend`.
     *
     * @param offset - `x` and `y` coordinates by which to pan the map.
     * @param options - Options object
     * @param eventData - Additional properties to be added to event objects of events triggered by this method.
     * @see [Navigate the map with game-like controls](https://maplibre.org/maplibre-gl-js/docs/examples/game-controls/)
     */
    panBy(offset, options, eventData) {
        offset = performance$1.P.convert(offset).mult(-1);
        return this.panTo(this.transform.center, performance$1.e({ offset }, options), eventData);
    }
    /**
     * Pans the map to the specified location with an animated transition.
     *
     * Triggers the following events: `movestart` and `moveend`.
     *
     * @param lnglat - The location to pan the map to.
     * @param options - Options describing the destination and animation of the transition.
     * @param eventData - Additional properties to be added to event objects of events triggered by this method.
     * @example
     * ```ts
     * map.panTo([-74, 38]);
     * // Specify that the panTo animation should last 5000 milliseconds.
     * map.panTo([-74, 38], {duration: 5000});
     * ```
     * @see [Update a feature in realtime](https://maplibre.org/maplibre-gl-js/docs/examples/live-update-feature/)
     */
    panTo(lnglat, options, eventData) {
        return this.easeTo(performance$1.e({
            center: lnglat
        }, options), eventData);
    }
    /**
     * Returns the map's current zoom level.
     *
     * @returns The map's current zoom level.
     * @example
     * ```ts
     * map.getZoom();
     * ```
     */
    getZoom() { return this.transform.zoom; }
    /**
     * Sets the map's zoom level. Equivalent to `jumpTo({zoom: zoom})`.
     *
     * Triggers the following events: `movestart`, `move`, `moveend`, `zoomstart`, `zoom`, and `zoomend`.
     *
     * @param zoom - The zoom level to set (0-20).
     * @param eventData - Additional properties to be added to event objects of events triggered by this method.
     * @example
     * Zoom to the zoom level 5 without an animated transition
     * ```ts
     * map.setZoom(5);
     * ```
     */
    setZoom(zoom, eventData) {
        this.jumpTo({ zoom }, eventData);
        return this;
    }
    /**
     * Zooms the map to the specified zoom level, with an animated transition.
     *
     * Triggers the following events: `movestart`, `move`, `moveend`, `zoomstart`, `zoom`, and `zoomend`.
     *
     * @param zoom - The zoom level to transition to.
     * @param options - Options object
     * @param eventData - Additional properties to be added to event objects of events triggered by this method.
     * @example
     * ```ts
     * // Zoom to the zoom level 5 without an animated transition
     * map.zoomTo(5);
     * // Zoom to the zoom level 8 with an animated transition
     * map.zoomTo(8, {
     *   duration: 2000,
     *   offset: [100, 50]
     * });
     * ```
     */
    zoomTo(zoom, options, eventData) {
        return this.easeTo(performance$1.e({
            zoom
        }, options), eventData);
    }
    /**
     * Increases the map's zoom level by 1.
     *
     * Triggers the following events: `movestart`, `move`, `moveend`, `zoomstart`, `zoom`, and `zoomend`.
     *
     * @param options - Options object
     * @param eventData - Additional properties to be added to event objects of events triggered by this method.
     * @example
     * Zoom the map in one level with a custom animation duration
     * ```ts
     * map.zoomIn({duration: 1000});
     * ```
     */
    zoomIn(options, eventData) {
        this.zoomTo(this.getZoom() + 1, options, eventData);
        return this;
    }
    /**
     * Decreases the map's zoom level by 1.
     *
     * Triggers the following events: `movestart`, `move`, `moveend`, `zoomstart`, `zoom`, and `zoomend`.
     *
     * @param options - Options object
     * @param eventData - Additional properties to be added to event objects of events triggered by this method.
     * @example
     * Zoom the map out one level with a custom animation offset
     * ```ts
     * map.zoomOut({offset: [80, 60]});
     * ```
     */
    zoomOut(options, eventData) {
        this.zoomTo(this.getZoom() - 1, options, eventData);
        return this;
    }
    /**
     * Returns the map's current bearing. The bearing is the compass direction that is "up"; for example, a bearing
     * of 90° orients the map so that east is up.
     *
     * @returns The map's current bearing.
     * @see [Navigate the map with game-like controls](https://maplibre.org/maplibre-gl-js/docs/examples/game-controls/)
     */
    getBearing() { return this.transform.bearing; }
    /**
     * Sets the map's bearing (rotation). The bearing is the compass direction that is "up"; for example, a bearing
     * of 90° orients the map so that east is up.
     *
     * Equivalent to `jumpTo({bearing: bearing})`.
     *
     * Triggers the following events: `movestart`, `moveend`, and `rotate`.
     *
     * @param bearing - The desired bearing.
     * @param eventData - Additional properties to be added to event objects of events triggered by this method.
     * @example
     * Rotate the map to 90 degrees
     * ```ts
     * map.setBearing(90);
     * ```
     */
    setBearing(bearing, eventData) {
        this.jumpTo({ bearing }, eventData);
        return this;
    }
    /**
     * Returns the current padding applied around the map viewport.
     *
     * @returns The current padding around the map viewport.
     */
    getPadding() { return this.transform.padding; }
    /**
     * Sets the padding in pixels around the viewport.
     *
     * Equivalent to `jumpTo({padding: padding})`.
     *
     * Triggers the following events: `movestart` and `moveend`.
     *
     * @param padding - The desired padding.
     * @param eventData - Additional properties to be added to event objects of events triggered by this method.
     * @example
     * Sets a left padding of 300px, and a top padding of 50px
     * ```ts
     * map.setPadding({ left: 300, top: 50 });
     * ```
     */
    setPadding(padding, eventData) {
        this.jumpTo({ padding }, eventData);
        return this;
    }
    /**
     * Rotates the map to the specified bearing, with an animated transition. The bearing is the compass direction
     * that is "up"; for example, a bearing of 90° orients the map so that east is up.
     *
     * Triggers the following events: `movestart`, `moveend`, and `rotate`.
     *
     * @param bearing - The desired bearing.
     * @param options - Options object
     * @param eventData - Additional properties to be added to event objects of events triggered by this method.
     */
    rotateTo(bearing, options, eventData) {
        return this.easeTo(performance$1.e({
            bearing
        }, options), eventData);
    }
    /**
     * Rotates the map so that north is up (0° bearing), with an animated transition.
     *
     * Triggers the following events: `movestart`, `moveend`, and `rotate`.
     *
     * @param options - Options object
     * @param eventData - Additional properties to be added to event objects of events triggered by this method.
     */
    resetNorth(options, eventData) {
        this.rotateTo(0, performance$1.e({ duration: 1000 }, options), eventData);
        return this;
    }
    /**
     * Rotates and pitches the map so that north is up (0° bearing) and pitch is 0°, with an animated transition.
     *
     * Triggers the following events: `movestart`, `move`, `moveend`, `pitchstart`, `pitch`, `pitchend`, and `rotate`.
     *
     * @param options - Options object
     * @param eventData - Additional properties to be added to event objects of events triggered by this method.
     */
    resetNorthPitch(options, eventData) {
        this.easeTo(performance$1.e({
            bearing: 0,
            pitch: 0,
            duration: 1000
        }, options), eventData);
        return this;
    }
    /**
     * Snaps the map so that north is up (0° bearing), if the current bearing is close enough to it (i.e. within the
     * `bearingSnap` threshold).
     *
     * Triggers the following events: `movestart`, `moveend`, and `rotate`.
     *
     * @param options - Options object
     * @param eventData - Additional properties to be added to event objects of events triggered by this method.
     */
    snapToNorth(options, eventData) {
        if (Math.abs(this.getBearing()) < this._bearingSnap) {
            return this.resetNorth(options, eventData);
        }
        return this;
    }
    /**
     * Returns the map's current pitch (tilt).
     *
     * @returns The map's current pitch, measured in degrees away from the plane of the screen.
     */
    getPitch() { return this.transform.pitch; }
    /**
     * Sets the map's pitch (tilt). Equivalent to `jumpTo({pitch: pitch})`.
     *
     * Triggers the following events: `movestart`, `moveend`, `pitchstart`, and `pitchend`.
     *
     * @param pitch - The pitch to set, measured in degrees away from the plane of the screen (0-60).
     * @param eventData - Additional properties to be added to event objects of events triggered by this method.
     */
    setPitch(pitch, eventData) {
        this.jumpTo({ pitch }, eventData);
        return this;
    }
    /**
     * @param bounds - Calculate the center for these bounds in the viewport and use
     * the highest zoom level up to and including `Map#getMaxZoom()` that fits
     * in the viewport. LngLatBounds represent a box that is always axis-aligned with bearing 0.
     * @param options - Options object
     * @returns If map is able to fit to provided bounds, returns `center`, `zoom`, and `bearing`.
     * If map is unable to fit, method will warn and return undefined.
     * @example
     * ```ts
     * let bbox = [[-79, 43], [-73, 45]];
     * let newCameraTransform = map.cameraForBounds(bbox, {
     *   padding: {top: 10, bottom:25, left: 15, right: 5}
     * });
     * ```
     */
    cameraForBounds(bounds, options) {
        bounds = LngLatBounds.convert(bounds);
        const bearing = options && options.bearing || 0;
        return this._cameraForBoxAndBearing(bounds.getNorthWest(), bounds.getSouthEast(), bearing, options);
    }
    /**
     * @internal
     * Calculate the center of these two points in the viewport and use
     * the highest zoom level up to and including `Map#getMaxZoom()` that fits
     * the points in the viewport at the specified bearing.
     * @param p0 - First point
     * @param p1 - Second point
     * @param bearing - Desired map bearing at end of animation, in degrees
     * @param options - the camera options
     * @returns If map is able to fit to provided bounds, returns `center`, `zoom`, and `bearing`.
     *      If map is unable to fit, method will warn and return undefined.
     * @example
     * ```ts
     * let p0 = [-79, 43];
     * let p1 = [-73, 45];
     * let bearing = 90;
     * let newCameraTransform = map._cameraForBoxAndBearing(p0, p1, bearing, {
     *   padding: {top: 10, bottom:25, left: 15, right: 5}
     * });
     * ```
     */
    _cameraForBoxAndBearing(p0, p1, bearing, options) {
        const defaultPadding = {
            top: 0,
            bottom: 0,
            right: 0,
            left: 0
        };
        options = performance$1.e({
            padding: defaultPadding,
            offset: [0, 0],
            maxZoom: this.transform.maxZoom
        }, options);
        if (typeof options.padding === 'number') {
            const p = options.padding;
            options.padding = {
                top: p,
                bottom: p,
                right: p,
                left: p
            };
        }
        options.padding = performance$1.e(defaultPadding, options.padding);
        const tr = this.transform;
        const edgePadding = tr.padding;
        // Consider all corners of the rotated bounding box derived from the given points
        // when find the camera position that fits the given points.
        const bounds = new LngLatBounds(p0, p1);
        const nwWorld = tr.project(bounds.getNorthWest());
        const neWorld = tr.project(bounds.getNorthEast());
        const seWorld = tr.project(bounds.getSouthEast());
        const swWorld = tr.project(bounds.getSouthWest());
        const bearingRadians = performance$1.ba(-bearing);
        const nwRotatedWorld = nwWorld.rotate(bearingRadians);
        const neRotatedWorld = neWorld.rotate(bearingRadians);
        const seRotatedWorld = seWorld.rotate(bearingRadians);
        const swRotatedWorld = swWorld.rotate(bearingRadians);
        const upperRight = new performance$1.P(Math.max(nwRotatedWorld.x, neRotatedWorld.x, swRotatedWorld.x, seRotatedWorld.x), Math.max(nwRotatedWorld.y, neRotatedWorld.y, swRotatedWorld.y, seRotatedWorld.y));
        const lowerLeft = new performance$1.P(Math.min(nwRotatedWorld.x, neRotatedWorld.x, swRotatedWorld.x, seRotatedWorld.x), Math.min(nwRotatedWorld.y, neRotatedWorld.y, swRotatedWorld.y, seRotatedWorld.y));
        // Calculate zoom: consider the original bbox and padding.
        const size = upperRight.sub(lowerLeft);
        const scaleX = (tr.width - (edgePadding.left + edgePadding.right + options.padding.left + options.padding.right)) / size.x;
        const scaleY = (tr.height - (edgePadding.top + edgePadding.bottom + options.padding.top + options.padding.bottom)) / size.y;
        if (scaleY < 0 || scaleX < 0) {
            performance$1.w('Map cannot fit within canvas with the given bounds, padding, and/or offset.');
            return undefined;
        }
        const zoom = Math.min(tr.scaleZoom(tr.scale * Math.min(scaleX, scaleY)), options.maxZoom);
        // Calculate center: apply the zoom, the configured offset, as well as offset that exists as a result of padding.
        const offset = performance$1.P.convert(options.offset);
        const paddingOffsetX = (options.padding.left - options.padding.right) / 2;
        const paddingOffsetY = (options.padding.top - options.padding.bottom) / 2;
        const paddingOffset = new performance$1.P(paddingOffsetX, paddingOffsetY);
        const rotatedPaddingOffset = paddingOffset.rotate(performance$1.ba(bearing));
        const offsetAtInitialZoom = offset.add(rotatedPaddingOffset);
        const offsetAtFinalZoom = offsetAtInitialZoom.mult(tr.scale / tr.zoomScale(zoom));
        const center = tr.unproject(
        // either world diagonal can be used (NW-SE or NE-SW)
        nwWorld.add(seWorld).div(2).sub(offsetAtFinalZoom));
        return {
            center,
            zoom,
            bearing
        };
    }
    /**
     * Pans and zooms the map to contain its visible area within the specified geographical bounds.
     * This function will also reset the map's bearing to 0 if bearing is nonzero.
     *
     * Triggers the following events: `movestart` and `moveend`.
     *
     * @param bounds - Center these bounds in the viewport and use the highest
     * zoom level up to and including `Map#getMaxZoom()` that fits them in the viewport.
     * @param options - Options supports all properties from {@link AnimationOptions} and {@link CameraOptions} in addition to the fields below.
     * @param eventData - Additional properties to be added to event objects of events triggered by this method.
     * @example
     * ```ts
     * let bbox = [[-79, 43], [-73, 45]];
     * map.fitBounds(bbox, {
     *   padding: {top: 10, bottom:25, left: 15, right: 5}
     * });
     * ```
     * @see [Fit a map to a bounding box](https://maplibre.org/maplibre-gl-js/docs/examples/fitbounds/)
     */
    fitBounds(bounds, options, eventData) {
        return this._fitInternal(this.cameraForBounds(bounds, options), options, eventData);
    }
    /**
     * Pans, rotates and zooms the map to to fit the box made by points p0 and p1
     * once the map is rotated to the specified bearing. To zoom without rotating,
     * pass in the current map bearing.
     *
     * Triggers the following events: `movestart`, `move`, `moveend`, `zoomstart`, `zoom`, `zoomend` and `rotate`.
     *
     * @param p0 - First point on screen, in pixel coordinates
     * @param p1 - Second point on screen, in pixel coordinates
     * @param bearing - Desired map bearing at end of animation, in degrees
     * @param options - Options object
     * @param eventData - Additional properties to be added to event objects of events triggered by this method.
     * @example
     * ```ts
     * let p0 = [220, 400];
     * let p1 = [500, 900];
     * map.fitScreenCoordinates(p0, p1, map.getBearing(), {
     *   padding: {top: 10, bottom:25, left: 15, right: 5}
     * });
     * ```
     * @see Used by {@link BoxZoomHandler}
     */
    fitScreenCoordinates(p0, p1, bearing, options, eventData) {
        return this._fitInternal(this._cameraForBoxAndBearing(this.transform.pointLocation(performance$1.P.convert(p0)), this.transform.pointLocation(performance$1.P.convert(p1)), bearing, options), options, eventData);
    }
    _fitInternal(calculatedOptions, options, eventData) {
        // cameraForBounds warns + returns undefined if unable to fit:
        if (!calculatedOptions)
            return this;
        options = performance$1.e(calculatedOptions, options);
        // Explicitly remove the padding field because, calculatedOptions already accounts for padding by setting zoom and center accordingly.
        delete options.padding;
        return options.linear ?
            this.easeTo(options, eventData) :
            this.flyTo(options, eventData);
    }
    /**
     * Changes any combination of center, zoom, bearing, and pitch, without
     * an animated transition. The map will retain its current values for any
     * details not specified in `options`.
     *
     * Triggers the following events: `movestart`, `move`, `moveend`, `zoomstart`, `zoom`, `zoomend`, `pitchstart`,
     * `pitch`, `pitchend`, and `rotate`.
     *
     * @param options - Options object
     * @param eventData - Additional properties to be added to event objects of events triggered by this method.
     * @example
     * ```ts
     * // jump to coordinates at current zoom
     * map.jumpTo({center: [0, 0]});
     * // jump with zoom, pitch, and bearing options
     * map.jumpTo({
     *   center: [0, 0],
     *   zoom: 8,
     *   pitch: 45,
     *   bearing: 90
     * });
     * ```
     * @see [Jump to a series of locations](https://maplibre.org/maplibre-gl-js/docs/examples/jump-to/)
     * @see [Update a feature in realtime](https://maplibre.org/maplibre-gl-js/docs/examples/live-update-feature/)
     */
    jumpTo(options, eventData) {
        this.stop();
        const tr = this._getTransformForUpdate();
        let zoomChanged = false, bearingChanged = false, pitchChanged = false;
        if ('zoom' in options && tr.zoom !== +options.zoom) {
            zoomChanged = true;
            tr.zoom = +options.zoom;
        }
        if (options.center !== undefined) {
            tr.center = performance$1.N.convert(options.center);
        }
        if ('bearing' in options && tr.bearing !== +options.bearing) {
            bearingChanged = true;
            tr.bearing = +options.bearing;
        }
        if ('pitch' in options && tr.pitch !== +options.pitch) {
            pitchChanged = true;
            tr.pitch = +options.pitch;
        }
        if (options.padding != null && !tr.isPaddingEqual(options.padding)) {
            tr.padding = options.padding;
        }
        this._applyUpdatedTransform(tr);
        this.fire(new performance$1.k('movestart', eventData))
            .fire(new performance$1.k('move', eventData));
        if (zoomChanged) {
            this.fire(new performance$1.k('zoomstart', eventData))
                .fire(new performance$1.k('zoom', eventData))
                .fire(new performance$1.k('zoomend', eventData));
        }
        if (bearingChanged) {
            this.fire(new performance$1.k('rotatestart', eventData))
                .fire(new performance$1.k('rotate', eventData))
                .fire(new performance$1.k('rotateend', eventData));
        }
        if (pitchChanged) {
            this.fire(new performance$1.k('pitchstart', eventData))
                .fire(new performance$1.k('pitch', eventData))
                .fire(new performance$1.k('pitchend', eventData));
        }
        return this.fire(new performance$1.k('moveend', eventData));
    }
    /**
     * Calculates pitch, zoom and bearing for looking at `newCenter` with the camera position being `newCenter`
     * and returns them as {@link CameraOptions}.
     * @param from - The camera to look from
     * @param altitudeFrom - The altitude of the camera to look from
     * @param to - The center to look at
     * @param altitudeTo - Optional altitude of the center to look at. If none given the ground height will be used.
     * @returns the calculated camera options
     */
    calculateCameraOptionsFromTo(from, altitudeFrom, to, altitudeTo = 0) {
        const fromMerc = performance$1.Z.fromLngLat(from, altitudeFrom);
        const toMerc = performance$1.Z.fromLngLat(to, altitudeTo);
        const dx = toMerc.x - fromMerc.x;
        const dy = toMerc.y - fromMerc.y;
        const dz = toMerc.z - fromMerc.z;
        const distance3D = Math.hypot(dx, dy, dz);
        if (distance3D === 0)
            throw new Error('Can\'t calculate camera options with same From and To');
        const groundDistance = Math.hypot(dx, dy);
        const zoom = this.transform.scaleZoom(this.transform.cameraToCenterDistance / distance3D / this.transform.tileSize);
        const bearing = (Math.atan2(dx, -dy) * 180) / Math.PI;
        let pitch = (Math.acos(groundDistance / distance3D) * 180) / Math.PI;
        pitch = dz < 0 ? 90 - pitch : 90 + pitch;
        return {
            center: toMerc.toLngLat(),
            zoom,
            pitch,
            bearing
        };
    }
    /**
     * Changes any combination of `center`, `zoom`, `bearing`, `pitch`, and `padding` with an animated transition
     * between old and new values. The map will retain its current values for any
     * details not specified in `options`.
     *
     * Note: The transition will happen instantly if the user has enabled
     * the `reduced motion` accessibility feature enabled in their operating system,
     * unless `options` includes `essential: true`.
     *
     * Triggers the following events: `movestart`, `move`, `moveend`, `zoomstart`, `zoom`, `zoomend`, `pitchstart`,
     * `pitch`, `pitchend`, and `rotate`.
     *
     * @param options - Options describing the destination and animation of the transition.
     * Accepts {@link CameraOptions} and {@link AnimationOptions}.
     * @param eventData - Additional properties to be added to event objects of events triggered by this method.
     * @see [Navigate the map with game-like controls](https://maplibre.org/maplibre-gl-js/docs/examples/game-controls/)
     */
    easeTo(options, eventData) {
        var _a;
        this._stop(false, options.easeId);
        options = performance$1.e({
            offset: [0, 0],
            duration: 500,
            easing: performance$1.b9
        }, options);
        if (options.animate === false || (!options.essential && browser.prefersReducedMotion))
            options.duration = 0;
        const tr = this._getTransformForUpdate(), startZoom = tr.zoom, startBearing = tr.bearing, startPitch = tr.pitch, startPadding = tr.padding, bearing = 'bearing' in options ? this._normalizeBearing(options.bearing, startBearing) : startBearing, pitch = 'pitch' in options ? +options.pitch : startPitch, padding = 'padding' in options ? options.padding : tr.padding;
        const offsetAsPoint = performance$1.P.convert(options.offset);
        let pointAtOffset = tr.centerPoint.add(offsetAsPoint);
        const locationAtOffset = tr.pointLocation(pointAtOffset);
        const { center, zoom } = tr.getConstrained(performance$1.N.convert(options.center || locationAtOffset), (_a = options.zoom) !== null && _a !== void 0 ? _a : startZoom);
        this._normalizeCenter(center, tr);
        const from = tr.project(locationAtOffset);
        const delta = tr.project(center).sub(from);
        const finalScale = tr.zoomScale(zoom - startZoom);
        let around, aroundPoint;
        if (options.around) {
            around = performance$1.N.convert(options.around);
            aroundPoint = tr.locationPoint(around);
        }
        const currently = {
            moving: this._moving,
            zooming: this._zooming,
            rotating: this._rotating,
            pitching: this._pitching
        };
        this._zooming = this._zooming || (zoom !== startZoom);
        this._rotating = this._rotating || (startBearing !== bearing);
        this._pitching = this._pitching || (pitch !== startPitch);
        this._padding = !tr.isPaddingEqual(padding);
        this._easeId = options.easeId;
        this._prepareEase(eventData, options.noMoveStart, currently);
        if (this.terrain)
            this._prepareElevation(center);
        this._ease((k) => {
            if (this._zooming) {
                tr.zoom = performance$1.z.number(startZoom, zoom, k);
            }
            if (this._rotating) {
                tr.bearing = performance$1.z.number(startBearing, bearing, k);
            }
            if (this._pitching) {
                tr.pitch = performance$1.z.number(startPitch, pitch, k);
            }
            if (this._padding) {
                tr.interpolatePadding(startPadding, padding, k);
                // When padding is being applied, Transform#centerPoint is changing continuously,
                // thus we need to recalculate offsetPoint every frame
                pointAtOffset = tr.centerPoint.add(offsetAsPoint);
            }
            if (this.terrain && !options.freezeElevation)
                this._updateElevation(k);
            if (around) {
                tr.setLocationAtPoint(around, aroundPoint);
            }
            else {
                const scale = tr.zoomScale(tr.zoom - startZoom);
                const base = zoom > startZoom ?
                    Math.min(2, finalScale) :
                    Math.max(0.5, finalScale);
                const speedup = Math.pow(base, 1 - k);
                const newCenter = tr.unproject(from.add(delta.mult(k * speedup)).mult(scale));
                tr.setLocationAtPoint(tr.renderWorldCopies ? newCenter.wrap() : newCenter, pointAtOffset);
            }
            this._applyUpdatedTransform(tr);
            this._fireMoveEvents(eventData);
        }, (interruptingEaseId) => {
            if (this.terrain && options.freezeElevation)
                this._finalizeElevation();
            this._afterEase(eventData, interruptingEaseId);
        }, options);
        return this;
    }
    _prepareEase(eventData, noMoveStart, currently = {}) {
        this._moving = true;
        if (!noMoveStart && !currently.moving) {
            this.fire(new performance$1.k('movestart', eventData));
        }
        if (this._zooming && !currently.zooming) {
            this.fire(new performance$1.k('zoomstart', eventData));
        }
        if (this._rotating && !currently.rotating) {
            this.fire(new performance$1.k('rotatestart', eventData));
        }
        if (this._pitching && !currently.pitching) {
            this.fire(new performance$1.k('pitchstart', eventData));
        }
    }
    _prepareElevation(center) {
        this._elevationCenter = center;
        this._elevationStart = this.transform.elevation;
        this._elevationTarget = this.terrain.getElevationForLngLatZoom(center, this.transform.tileZoom);
        this._elevationFreeze = true;
    }
    _updateElevation(k) {
        this.transform.minElevationForCurrentTile = this.terrain.getMinTileElevationForLngLatZoom(this._elevationCenter, this.transform.tileZoom);
        const elevation = this.terrain.getElevationForLngLatZoom(this._elevationCenter, this.transform.tileZoom);
        // target terrain updated during flight, slowly move camera to new height
        if (k < 1 && elevation !== this._elevationTarget) {
            const pitch1 = this._elevationTarget - this._elevationStart;
            const pitch2 = (elevation - (pitch1 * k + this._elevationStart)) / (1 - k);
            this._elevationStart += k * (pitch1 - pitch2);
            this._elevationTarget = elevation;
        }
        this.transform.elevation = performance$1.z.number(this._elevationStart, this._elevationTarget, k);
    }
    _finalizeElevation() {
        this._elevationFreeze = false;
        this.transform.recalculateZoom(this.terrain);
    }
    /**
     * @internal
     * Called when the camera is about to be manipulated.
     * If `transformCameraUpdate` is specified or terrain is enabled, a copy of
     * the current transform is created to track the accumulated changes.
     * This underlying transform represents the "desired state" proposed by input handlers / animations / UI controls.
     * It may differ from the state used for rendering (`this.transform`).
     * @returns Transform to apply changes to
     */
    _getTransformForUpdate() {
        if (!this.transformCameraUpdate && !this.terrain)
            return this.transform;
        if (!this._requestedCameraState) {
            this._requestedCameraState = this.transform.clone();
        }
        return this._requestedCameraState;
    }
    /**
     * @internal
     * Checks the given transform for the camera being below terrain surface and
     * returns new pitch and zoom to fix that.
     *
     * With the new pitch and zoom, the camera will be at the same ground
     * position but at higher altitude. It will still point to the same spot on
     * the map.
     *
     * @param tr - The transform to check.
     */
    _elevateCameraIfInsideTerrain(tr) {
        const camera = tr.getCameraPosition();
        const minAltitude = this.terrain.getElevationForLngLatZoom(camera.lngLat, tr.zoom);
        if (camera.altitude < minAltitude) {
            const newCamera = this.calculateCameraOptionsFromTo(camera.lngLat, minAltitude, tr.center, tr.elevation);
            return {
                pitch: newCamera.pitch,
                zoom: newCamera.zoom,
            };
        }
        return {};
    }
    /**
     * @internal
     * Called after the camera is done being manipulated.
     * @param tr - the requested camera end state
     * If the camera is inside terrain, it gets elevated.
     * Call `transformCameraUpdate` if present, and then apply the "approved" changes.
     */
    _applyUpdatedTransform(tr) {
        const modifiers = [];
        if (this.terrain) {
            modifiers.push(tr => this._elevateCameraIfInsideTerrain(tr));
        }
        if (this.transformCameraUpdate) {
            modifiers.push(tr => this.transformCameraUpdate(tr));
        }
        if (!modifiers.length) {
            return;
        }
        const finalTransform = tr.clone();
        for (const modifier of modifiers) {
            const nextTransform = finalTransform.clone();
            const { center, zoom, pitch, bearing, elevation } = modifier(nextTransform);
            if (center)
                nextTransform.center = center;
            if (zoom !== undefined)
                nextTransform.zoom = zoom;
            if (pitch !== undefined)
                nextTransform.pitch = pitch;
            if (bearing !== undefined)
                nextTransform.bearing = bearing;
            if (elevation !== undefined)
                nextTransform.elevation = elevation;
            finalTransform.apply(nextTransform);
        }
        this.transform.apply(finalTransform);
    }
    _fireMoveEvents(eventData) {
        this.fire(new performance$1.k('move', eventData));
        if (this._zooming) {
            this.fire(new performance$1.k('zoom', eventData));
        }
        if (this._rotating) {
            this.fire(new performance$1.k('rotate', eventData));
        }
        if (this._pitching) {
            this.fire(new performance$1.k('pitch', eventData));
        }
    }
    _afterEase(eventData, easeId) {
        // if this easing is being stopped to start another easing with
        // the same id then don't fire any events to avoid extra start/stop events
        if (this._easeId && easeId && this._easeId === easeId) {
            return;
        }
        delete this._easeId;
        const wasZooming = this._zooming;
        const wasRotating = this._rotating;
        const wasPitching = this._pitching;
        this._moving = false;
        this._zooming = false;
        this._rotating = false;
        this._pitching = false;
        this._padding = false;
        if (wasZooming) {
            this.fire(new performance$1.k('zoomend', eventData));
        }
        if (wasRotating) {
            this.fire(new performance$1.k('rotateend', eventData));
        }
        if (wasPitching) {
            this.fire(new performance$1.k('pitchend', eventData));
        }
        this.fire(new performance$1.k('moveend', eventData));
    }
    /**
     * Changes any combination of center, zoom, bearing, and pitch, animating the transition along a curve that
     * evokes flight. The animation seamlessly incorporates zooming and panning to help
     * the user maintain her bearings even after traversing a great distance.
     *
     * Note: The animation will be skipped, and this will behave equivalently to `jumpTo`
     * if the user has the `reduced motion` accessibility feature enabled in their operating system,
     * unless 'options' includes `essential: true`.
     *
     * Triggers the following events: `movestart`, `move`, `moveend`, `zoomstart`, `zoom`, `zoomend`, `pitchstart`,
     * `pitch`, `pitchend`, and `rotate`.
     *
     * @param options - Options describing the destination and animation of the transition.
     * Accepts {@link CameraOptions}, {@link AnimationOptions},
     * and the following additional options.
     * @param eventData - Additional properties to be added to event objects of events triggered by this method.
     * @example
     * ```ts
     * // fly with default options to null island
     * map.flyTo({center: [0, 0], zoom: 9});
     * // using flyTo options
     * map.flyTo({
     *   center: [0, 0],
     *   zoom: 9,
     *   speed: 0.2,
     *   curve: 1,
     *   easing(t) {
     *     return t;
     *   }
     * });
     * ```
     * @see [Fly to a location](https://maplibre.org/maplibre-gl-js/docs/examples/flyto/)
     * @see [Slowly fly to a location](https://maplibre.org/maplibre-gl-js/docs/examples/flyto-options/)
     * @see [Fly to a location based on scroll position](https://maplibre.org/maplibre-gl-js/docs/examples/scroll-fly-to/)
     */
    flyTo(options, eventData) {
        var _a;
        // Fall through to jumpTo if user has set prefers-reduced-motion
        if (!options.essential && browser.prefersReducedMotion) {
            const coercedOptions = performance$1.M(options, ['center', 'zoom', 'bearing', 'pitch', 'around']);
            return this.jumpTo(coercedOptions, eventData);
        }
        // This method implements an “optimal path” animation, as detailed in:
        //
        // Van Wijk, Jarke J.; Nuij, Wim A. A. “Smooth and efficient zooming and panning.” INFOVIS
        //   ’03. pp. 15–22. <https://www.win.tue.nl/~vanwijk/zoompan.pdf#page=5>.
        //
        // Where applicable, local variable documentation begins with the associated variable or
        // function in van Wijk (2003).
        this.stop();
        options = performance$1.e({
            offset: [0, 0],
            speed: 1.2,
            curve: 1.42,
            easing: performance$1.b9
        }, options);
        const tr = this._getTransformForUpdate(), startZoom = tr.zoom, startBearing = tr.bearing, startPitch = tr.pitch, startPadding = tr.padding;
        const bearing = 'bearing' in options ? this._normalizeBearing(options.bearing, startBearing) : startBearing;
        const pitch = 'pitch' in options ? +options.pitch : startPitch;
        const padding = 'padding' in options ? options.padding : tr.padding;
        const offsetAsPoint = performance$1.P.convert(options.offset);
        let pointAtOffset = tr.centerPoint.add(offsetAsPoint);
        const locationAtOffset = tr.pointLocation(pointAtOffset);
        const { center, zoom } = tr.getConstrained(performance$1.N.convert(options.center || locationAtOffset), (_a = options.zoom) !== null && _a !== void 0 ? _a : startZoom);
        this._normalizeCenter(center, tr);
        const scale = tr.zoomScale(zoom - startZoom);
        const from = tr.project(locationAtOffset);
        const delta = tr.project(center).sub(from);
        let rho = options.curve;
        // w₀: Initial visible span, measured in pixels at the initial scale.
        const w0 = Math.max(tr.width, tr.height), 
        // w₁: Final visible span, measured in pixels with respect to the initial scale.
        w1 = w0 / scale, 
        // Length of the flight path as projected onto the ground plane, measured in pixels from
        // the world image origin at the initial scale.
        u1 = delta.mag();
        if ('minZoom' in options) {
            const minZoom = performance$1.ad(Math.min(options.minZoom, startZoom, zoom), tr.minZoom, tr.maxZoom);
            // w<sub>m</sub>: Maximum visible span, measured in pixels with respect to the initial
            // scale.
            const wMax = w0 / tr.zoomScale(minZoom - startZoom);
            rho = Math.sqrt(wMax / u1 * 2);
        }
        // ρ²
        const rho2 = rho * rho;
        /**
         * rᵢ: Returns the zoom-out factor at one end of the animation.
         *
         * @param descent - `true` for the descent, `false` for the ascent
         */
        function zoomOutFactor(descent) {
            const b = (w1 * w1 - w0 * w0 + (descent ? -1 : 1) * rho2 * rho2 * u1 * u1) / (2 * (descent ? w1 : w0) * rho2 * u1);
            return Math.log(Math.sqrt(b * b + 1) - b);
        }
        function sinh(n) { return (Math.exp(n) - Math.exp(-n)) / 2; }
        function cosh(n) { return (Math.exp(n) + Math.exp(-n)) / 2; }
        function tanh(n) { return sinh(n) / cosh(n); }
        // r₀: Zoom-out factor during ascent.
        const r0 = zoomOutFactor(false);
        // w(s): Returns the visible span on the ground, measured in pixels with respect to the
        // initial scale. Assumes an angular field of view of 2 arctan ½ ≈ 53°.
        let w = function (s) {
            return (cosh(r0) / cosh(r0 + rho * s));
        };
        // u(s): Returns the distance along the flight path as projected onto the ground plane,
        // measured in pixels from the world image origin at the initial scale.
        let u = function (s) {
            return w0 * ((cosh(r0) * tanh(r0 + rho * s) - sinh(r0)) / rho2) / u1;
        };
        // S: Total length of the flight path, measured in ρ-screenfuls.
        let S = (zoomOutFactor(true) - r0) / rho;
        // When u₀ = u₁, the optimal path doesn’t require both ascent and descent.
        if (Math.abs(u1) < 0.000001 || !isFinite(S)) {
            // Perform a more or less instantaneous transition if the path is too short.
            if (Math.abs(w0 - w1) < 0.000001)
                return this.easeTo(options, eventData);
            const k = w1 < w0 ? -1 : 1;
            S = Math.abs(Math.log(w1 / w0)) / rho;
            u = () => 0;
            w = (s) => Math.exp(k * rho * s);
        }
        if ('duration' in options) {
            options.duration = +options.duration;
        }
        else {
            const V = 'screenSpeed' in options ? +options.screenSpeed / rho : +options.speed;
            options.duration = 1000 * S / V;
        }
        if (options.maxDuration && options.duration > options.maxDuration) {
            options.duration = 0;
        }
        this._zooming = true;
        this._rotating = (startBearing !== bearing);
        this._pitching = (pitch !== startPitch);
        this._padding = !tr.isPaddingEqual(padding);
        this._prepareEase(eventData, false);
        if (this.terrain)
            this._prepareElevation(center);
        this._ease((k) => {
            // s: The distance traveled along the flight path, measured in ρ-screenfuls.
            const s = k * S;
            const scale = 1 / w(s);
            tr.zoom = k === 1 ? zoom : startZoom + tr.scaleZoom(scale);
            if (this._rotating) {
                tr.bearing = performance$1.z.number(startBearing, bearing, k);
            }
            if (this._pitching) {
                tr.pitch = performance$1.z.number(startPitch, pitch, k);
            }
            if (this._padding) {
                tr.interpolatePadding(startPadding, padding, k);
                // When padding is being applied, Transform#centerPoint is changing continuously,
                // thus we need to recalculate offsetPoint every frame
                pointAtOffset = tr.centerPoint.add(offsetAsPoint);
            }
            if (this.terrain && !options.freezeElevation)
                this._updateElevation(k);
            const newCenter = k === 1 ? center : tr.unproject(from.add(delta.mult(u(s))).mult(scale));
            tr.setLocationAtPoint(tr.renderWorldCopies ? newCenter.wrap() : newCenter, pointAtOffset);
            this._applyUpdatedTransform(tr);
            this._fireMoveEvents(eventData);
        }, () => {
            if (this.terrain && options.freezeElevation)
                this._finalizeElevation();
            this._afterEase(eventData);
        }, options);
        return this;
    }
    isEasing() {
        return !!this._easeFrameId;
    }
    /**
     * Stops any animated transition underway.
     */
    stop() {
        return this._stop();
    }
    _stop(allowGestures, easeId) {
        var _a;
        if (this._easeFrameId) {
            this._cancelRenderFrame(this._easeFrameId);
            delete this._easeFrameId;
            delete this._onEaseFrame;
        }
        if (this._onEaseEnd) {
            // The _onEaseEnd function might emit events which trigger new
            // animation, which sets a new _onEaseEnd. Ensure we don't delete
            // it unintentionally.
            const onEaseEnd = this._onEaseEnd;
            delete this._onEaseEnd;
            onEaseEnd.call(this, easeId);
        }
        if (!allowGestures) {
            (_a = this.handlers) === null || _a === void 0 ? void 0 : _a.stop(false);
        }
        return this;
    }
    _ease(frame, finish, options) {
        if (options.animate === false || options.duration === 0) {
            frame(1);
            finish();
        }
        else {
            this._easeStart = browser.now();
            this._easeOptions = options;
            this._onEaseFrame = frame;
            this._onEaseEnd = finish;
            this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback);
        }
    }
    // convert bearing so that it's numerically close to the current one so that it interpolates properly
    _normalizeBearing(bearing, currentBearing) {
        bearing = performance$1.b3(bearing, -180, 180);
        const diff = Math.abs(bearing - currentBearing);
        if (Math.abs(bearing - 360 - currentBearing) < diff)
            bearing -= 360;
        if (Math.abs(bearing + 360 - currentBearing) < diff)
            bearing += 360;
        return bearing;
    }
    // If a path crossing the antimeridian would be shorter, extend the final coordinate so that
    // interpolating between the two endpoints will cross it.
    _normalizeCenter(center, tr) {
        if (!tr.renderWorldCopies || tr.lngRange)
            return;
        const delta = center.lng - tr.center.lng;
        center.lng +=
            delta > 180 ? -360 :
                delta < -180 ? 360 : 0;
    }
    /**
     * Get the elevation difference between a given point
     * and a point that is currently in the middle of the screen.
     * This method should be used for proper positioning of custom 3d objects, as explained [here](https://maplibre.org/maplibre-gl-js/docs/examples/add-3d-model-with-terrain/)
     * Returns null if terrain is not enabled.
     * This method is subject to change in Maplibre GL JS v5.
     * @param lngLatLike - [x,y] or LngLat coordinates of the location
     * @returns elevation offset in meters
     */
    queryTerrainElevation(lngLatLike) {
        if (!this.terrain) {
            return null;
        }
        const elevation = this.terrain.getElevationForLngLatZoom(performance$1.N.convert(lngLatLike), this.transform.tileZoom);
        return elevation - this.transform.elevation;
    }
}

const defaultAttributionControlOptions = {
    compact: true,
    customAttribution: '<a href="https://maplibre.org/" target="_blank">MapLibre</a>'
};
/**
 * An `AttributionControl` control presents the map's attribution information. By default, the attribution control is expanded (regardless of map width).
 * @group Markers and Controls
 * @example
 * ```ts
 * let map = new Map({attributionControl: false})
 *     .addControl(new AttributionControl({
 *         compact: true
 *     }));
 * ```
 */
class AttributionControl {
    /**
     * @param options - the attribution options
     */
    constructor(options = defaultAttributionControlOptions) {
        this._toggleAttribution = () => {
            if (this._container.classList.contains('maplibregl-compact')) {
                if (this._container.classList.contains('maplibregl-compact-show')) {
                    this._container.setAttribute('open', '');
                    this._container.classList.remove('maplibregl-compact-show');
                }
                else {
                    this._container.classList.add('maplibregl-compact-show');
                    this._container.removeAttribute('open');
                }
            }
        };
        this._updateData = (e) => {
            if (e && (e.sourceDataType === 'metadata' || e.sourceDataType === 'visibility' || e.dataType === 'style' || e.type === 'terrain')) {
                this._updateAttributions();
            }
        };
        this._updateCompact = () => {
            if (this._map.getCanvasContainer().offsetWidth <= 640 || this._compact) {
                if (this._compact === false) {
                    this._container.setAttribute('open', '');
                }
                else if (!this._container.classList.contains('maplibregl-compact') && !this._container.classList.contains('maplibregl-attrib-empty')) {
                    this._container.setAttribute('open', '');
                    this._container.classList.add('maplibregl-compact', 'maplibregl-compact-show');
                }
            }
            else {
                this._container.setAttribute('open', '');
                if (this._container.classList.contains('maplibregl-compact')) {
                    this._container.classList.remove('maplibregl-compact', 'maplibregl-compact-show');
                }
            }
        };
        this._updateCompactMinimize = () => {
            if (this._container.classList.contains('maplibregl-compact')) {
                if (this._container.classList.contains('maplibregl-compact-show')) {
                    this._container.classList.remove('maplibregl-compact-show');
                }
            }
        };
        this.options = options;
    }
    getDefaultPosition() {
        return 'bottom-right';
    }
    /** {@inheritDoc IControl.onAdd} */
    onAdd(map) {
        this._map = map;
        this._compact = this.options.compact;
        this._container = DOM.create('details', 'maplibregl-ctrl maplibregl-ctrl-attrib');
        this._compactButton = DOM.create('summary', 'maplibregl-ctrl-attrib-button', this._container);
        this._compactButton.addEventListener('click', this._toggleAttribution);
        this._setElementTitle(this._compactButton, 'ToggleAttribution');
        this._innerContainer = DOM.create('div', 'maplibregl-ctrl-attrib-inner', this._container);
        this._updateAttributions();
        this._updateCompact();
        this._map.on('styledata', this._updateData);
        this._map.on('sourcedata', this._updateData);
        this._map.on('terrain', this._updateData);
        this._map.on('resize', this._updateCompact);
        this._map.on('drag', this._updateCompactMinimize);
        return this._container;
    }
    /** {@inheritDoc IControl.onRemove} */
    onRemove() {
        DOM.remove(this._container);
        this._map.off('styledata', this._updateData);
        this._map.off('sourcedata', this._updateData);
        this._map.off('terrain', this._updateData);
        this._map.off('resize', this._updateCompact);
        this._map.off('drag', this._updateCompactMinimize);
        this._map = undefined;
        this._compact = undefined;
        this._attribHTML = undefined;
    }
    _setElementTitle(element, title) {
        const str = this._map._getUIString(`AttributionControl.${title}`);
        element.title = str;
        element.setAttribute('aria-label', str);
    }
    _updateAttributions() {
        if (!this._map.style)
            return;
        let attributions = [];
        if (this.options.customAttribution) {
            if (Array.isArray(this.options.customAttribution)) {
                attributions = attributions.concat(this.options.customAttribution.map(attribution => {
                    if (typeof attribution !== 'string')
                        return '';
                    return attribution;
                }));
            }
            else if (typeof this.options.customAttribution === 'string') {
                attributions.push(this.options.customAttribution);
            }
        }
        if (this._map.style.stylesheet) {
            const stylesheet = this._map.style.stylesheet;
            this.styleOwner = stylesheet.owner;
            this.styleId = stylesheet.id;
        }
        const sourceCaches = this._map.style.sourceCaches;
        for (const id in sourceCaches) {
            const sourceCache = sourceCaches[id];
            if (sourceCache.used || sourceCache.usedForTerrain) {
                const source = sourceCache.getSource();
                if (source.attribution && attributions.indexOf(source.attribution) < 0) {
                    attributions.push(source.attribution);
                }
            }
        }
        // remove any entries that are whitespace
        attributions = attributions.filter(e => String(e).trim());
        // remove any entries that are substrings of another entry.
        // first sort by length so that substrings come first
        attributions.sort((a, b) => a.length - b.length);
        attributions = attributions.filter((attrib, i) => {
            for (let j = i + 1; j < attributions.length; j++) {
                if (attributions[j].indexOf(attrib) >= 0) {
                    return false;
                }
            }
            return true;
        });
        // check if attribution string is different to minimize DOM changes
        const attribHTML = attributions.join(' | ');
        if (attribHTML === this._attribHTML)
            return;
        this._attribHTML = attribHTML;
        if (attributions.length) {
            this._innerContainer.innerHTML = attribHTML;
            this._container.classList.remove('maplibregl-attrib-empty');
        }
        else {
            this._container.classList.add('maplibregl-attrib-empty');
        }
        this._updateCompact();
        // remove old DOM node from _editLink
        this._editLink = null;
    }
}

/**
 * A `LogoControl` is a control that adds the watermark.
 *
 * @group Markers and Controls
 *
 * @example
 * ```ts
 * map.addControl(new LogoControl({compact: false}));
 * ```
 **/
class LogoControl {
    /**
     * @param options - the control's options
     */
    constructor(options = {}) {
        this._updateCompact = () => {
            const containerChildren = this._container.children;
            if (containerChildren.length) {
                const anchor = containerChildren[0];
                if (this._map.getCanvasContainer().offsetWidth <= 640 || this._compact) {
                    if (this._compact !== false) {
                        anchor.classList.add('maplibregl-compact');
                    }
                }
                else {
                    anchor.classList.remove('maplibregl-compact');
                }
            }
        };
        this.options = options;
    }
    getDefaultPosition() {
        return 'bottom-left';
    }
    /** {@inheritDoc IControl.onAdd} */
    onAdd(map) {
        this._map = map;
        this._compact = this.options && this.options.compact;
        this._container = DOM.create('div', 'maplibregl-ctrl');
        const anchor = DOM.create('a', 'maplibregl-ctrl-logo');
        anchor.target = '_blank';
        anchor.rel = 'noopener nofollow';
        anchor.href = 'https://maplibre.org/';
        anchor.setAttribute('aria-label', this._map._getUIString('LogoControl.Title'));
        anchor.setAttribute('rel', 'noopener nofollow');
        this._container.appendChild(anchor);
        this._container.style.display = 'block';
        this._map.on('resize', this._updateCompact);
        this._updateCompact();
        return this._container;
    }
    /** {@inheritDoc IControl.onRemove} */
    onRemove() {
        DOM.remove(this._container);
        this._map.off('resize', this._updateCompact);
        this._map = undefined;
        this._compact = undefined;
    }
}

class TaskQueue {
    constructor() {
        this._queue = [];
        this._id = 0;
        this._cleared = false;
        this._currentlyRunning = false;
    }
    add(callback) {
        const id = ++this._id;
        const queue = this._queue;
        queue.push({ callback, id, cancelled: false });
        return id;
    }
    remove(id) {
        const running = this._currentlyRunning;
        const queue = running ? this._queue.concat(running) : this._queue;
        for (const task of queue) {
            if (task.id === id) {
                task.cancelled = true;
                return;
            }
        }
    }
    run(timeStamp = 0) {
        if (this._currentlyRunning)
            throw new Error('Attempting to run(), but is already running.');
        const queue = this._currentlyRunning = this._queue;
        // Tasks queued by callbacks in the current queue should be executed
        // on the next run, not the current run.
        this._queue = [];
        for (const task of queue) {
            if (task.cancelled)
                continue;
            task.callback(timeStamp);
            if (this._cleared)
                break;
        }
        this._cleared = false;
        this._currentlyRunning = false;
    }
    clear() {
        if (this._currentlyRunning) {
            this._cleared = true;
        }
        this._queue = [];
    }
}

var pos3dAttributes = performance$1.Y([
    { name: 'a_pos3d', type: 'Int16', components: 3 }
]);

/**
 * @internal
 * This class is a helper for the Terrain-class, it:
 *
 * - loads raster-dem tiles
 * - manages all renderToTexture tiles.
 * - caches previous rendered tiles.
 * - finds all necessary renderToTexture tiles for a OverscaledTileID area
 * - finds the corresponding raster-dem tile for OverscaledTileID
 */
class TerrainSourceCache extends performance$1.E {
    constructor(sourceCache) {
        super();
        this.sourceCache = sourceCache;
        this._tiles = {};
        this._renderableTilesKeys = [];
        this._sourceTileCache = {};
        this.minzoom = 0;
        this.maxzoom = 22;
        this.tileSize = 512;
        this.deltaZoom = 1;
        sourceCache.usedForTerrain = true;
        sourceCache.tileSize = this.tileSize * 2 ** this.deltaZoom;
    }
    destruct() {
        this.sourceCache.usedForTerrain = false;
        this.sourceCache.tileSize = null;
    }
    /**
     * Load Terrain Tiles, create internal render-to-texture tiles, free GPU memory.
     * @param transform - the operation to do
     * @param terrain - the terrain
     */
    update(transform, terrain) {
        // load raster-dem tiles for the current scene.
        this.sourceCache.update(transform, terrain);
        // create internal render-to-texture tiles for the current scene.
        this._renderableTilesKeys = [];
        const keys = {};
        for (const tileID of transform.coveringTiles({
            tileSize: this.tileSize,
            minzoom: this.minzoom,
            maxzoom: this.maxzoom,
            reparseOverscaled: false,
            terrain
        })) {
            keys[tileID.key] = true;
            this._renderableTilesKeys.push(tileID.key);
            if (!this._tiles[tileID.key]) {
                tileID.posMatrix = new Float64Array(16);
                performance$1.aQ(tileID.posMatrix, 0, performance$1.X, 0, performance$1.X, 0, 1);
                this._tiles[tileID.key] = new Tile(tileID, this.tileSize);
            }
        }
        // free unused tiles
        for (const key in this._tiles) {
            if (!keys[key])
                delete this._tiles[key];
        }
    }
    /**
     * Free render to texture cache
     * @param tileID - optional, free only corresponding to tileID.
     */
    freeRtt(tileID) {
        for (const key in this._tiles) {
            const tile = this._tiles[key];
            if (!tileID || tile.tileID.equals(tileID) || tile.tileID.isChildOf(tileID) || tileID.isChildOf(tile.tileID))
                tile.rtt = [];
        }
    }
    /**
     * get a list of tiles, which are loaded and should be rendered in the current scene
     * @returns the renderable tiles
     */
    getRenderableTiles() {
        return this._renderableTilesKeys.map(key => this.getTileByID(key));
    }
    /**
     * get terrain tile by the TileID key
     * @param id - the tile id
     * @returns the tile
     */
    getTileByID(id) {
        return this._tiles[id];
    }
    /**
     * Searches for the corresponding current renderable terrain-tiles
     * @param tileID - the tile to look for
     * @returns the tiles that were found
     */
    getTerrainCoords(tileID) {
        const coords = {};
        for (const key of this._renderableTilesKeys) {
            const _tileID = this._tiles[key].tileID;
            if (_tileID.canonical.equals(tileID.canonical)) {
                const coord = tileID.clone();
                coord.posMatrix = new Float64Array(16);
                performance$1.aQ(coord.posMatrix, 0, performance$1.X, 0, performance$1.X, 0, 1);
                coords[key] = coord;
            }
            else if (_tileID.canonical.isChildOf(tileID.canonical)) {
                const coord = tileID.clone();
                coord.posMatrix = new Float64Array(16);
                const dz = _tileID.canonical.z - tileID.canonical.z;
                const dx = _tileID.canonical.x - (_tileID.canonical.x >> dz << dz);
                const dy = _tileID.canonical.y - (_tileID.canonical.y >> dz << dz);
                const size = performance$1.X >> dz;
                performance$1.aQ(coord.posMatrix, 0, size, 0, size, 0, 1);
                performance$1.J(coord.posMatrix, coord.posMatrix, [-dx * size, -dy * size, 0]);
                coords[key] = coord;
            }
            else if (tileID.canonical.isChildOf(_tileID.canonical)) {
                const coord = tileID.clone();
                coord.posMatrix = new Float64Array(16);
                const dz = tileID.canonical.z - _tileID.canonical.z;
                const dx = tileID.canonical.x - (tileID.canonical.x >> dz << dz);
                const dy = tileID.canonical.y - (tileID.canonical.y >> dz << dz);
                const size = performance$1.X >> dz;
                performance$1.aQ(coord.posMatrix, 0, performance$1.X, 0, performance$1.X, 0, 1);
                performance$1.J(coord.posMatrix, coord.posMatrix, [dx * size, dy * size, 0]);
                performance$1.K(coord.posMatrix, coord.posMatrix, [1 / (2 ** dz), 1 / (2 ** dz), 0]);
                coords[key] = coord;
            }
        }
        return coords;
    }
    /**
     * find the covering raster-dem tile
     * @param tileID - the tile to look for
     * @param searchForDEM - Optional parameter to search for (parent) sourcetiles with loaded dem.
     * @returns the tile
     */
    getSourceTile(tileID, searchForDEM) {
        const source = this.sourceCache._source;
        let z = tileID.overscaledZ - this.deltaZoom;
        if (z > source.maxzoom)
            z = source.maxzoom;
        if (z < source.minzoom)
            return null;
        // cache for tileID to terrain-tileID
        if (!this._sourceTileCache[tileID.key])
            this._sourceTileCache[tileID.key] = tileID.scaledTo(z).key;
        let tile = this.sourceCache.getTileByID(this._sourceTileCache[tileID.key]);
        // during tile-loading phase look if parent tiles (with loaded dem) are available.
        if (!(tile && tile.dem) && searchForDEM)
            while (z >= source.minzoom && !(tile && tile.dem))
                tile = this.sourceCache.getTileByID(tileID.scaledTo(z--).key);
        return tile;
    }
    /**
     * get a list of tiles, loaded after a specific time. This is used to update depth & coords framebuffers.
     * @param time - the time
     * @returns the relevant tiles
     */
    tilesAfterTime(time = Date.now()) {
        return Object.values(this._tiles).filter(t => t.timeAdded >= time);
    }
}

/**
 * @internal
 * This is the main class which handles most of the 3D Terrain logic. It has the following topics:
 *
 * 1. loads raster-dem tiles via the internal sourceCache this.sourceCache
 * 2. creates a depth-framebuffer, which is used to calculate the visibility of coordinates
 * 3. creates a coords-framebuffer, which is used the get to tile-coordinate for a screen-pixel
 * 4. stores all render-to-texture tiles in the this.sourceCache._tiles
 * 5. calculates the elevation for a specific tile-coordinate
 * 6. creates a terrain-mesh
 *
 * A note about the GPU resource-usage:
 *
 * Framebuffers:
 *
 * - one for the depth & coords framebuffer with the size of the map-div.
 * - one for rendering a tile to texture with the size of tileSize (= 512x512).
 *
 * Textures:
 *
 * - one texture for an empty raster-dem tile with size 1x1
 * - one texture for an empty depth-buffer, when terrain is disabled with size 1x1
 * - one texture for an each loaded raster-dem with size of the source.tileSize
 * - one texture for the coords-framebuffer with the size of the map-div.
 * - one texture for the depth-framebuffer with the size of the map-div.
 * - one texture for the encoded tile-coords with the size 2*tileSize (=1024x1024)
 * - finally for each render-to-texture tile (= this._tiles) a set of textures
 * for each render stack (The stack-concept is documented in painter.ts).
 *
 * Normally there exists 1-3 Textures per tile, depending on the stylesheet.
 * Each Textures has the size 2*tileSize (= 1024x1024). Also there exists a
 * cache of the last 150 newest rendered tiles.
 *
 */
class Terrain {
    constructor(painter, sourceCache, options) {
        this.painter = painter;
        this.sourceCache = new TerrainSourceCache(sourceCache);
        this.options = options;
        this.exaggeration = typeof options.exaggeration === 'number' ? options.exaggeration : 1.0;
        this.qualityFactor = 2;
        this.meshSize = 128;
        this._demMatrixCache = {};
        this.coordsIndex = [];
        this._coordsTextureSize = 1024;
    }
    /**
     * get the elevation-value from original dem-data for a given tile-coordinate
     * @param tileID - the tile to get elevation for
     * @param x - between 0 .. EXTENT
     * @param y - between 0 .. EXTENT
     * @param extent - optional, default 8192
     * @returns the elevation
     */
    getDEMElevation(tileID, x, y, extent = performance$1.X) {
        var _a;
        if (!(x >= 0 && x < extent && y >= 0 && y < extent))
            return 0;
        const terrain = this.getTerrainData(tileID);
        const dem = (_a = terrain.tile) === null || _a === void 0 ? void 0 : _a.dem;
        if (!dem)
            return 0;
        const pos = transformMat4([], [x / extent * performance$1.X, y / extent * performance$1.X], terrain.u_terrain_matrix);
        const coord = [pos[0] * dem.dim, pos[1] * dem.dim];
        // bilinear interpolation
        const cx = Math.floor(coord[0]), cy = Math.floor(coord[1]), tx = coord[0] - cx, ty = coord[1] - cy;
        return (dem.get(cx, cy) * (1 - tx) * (1 - ty) +
            dem.get(cx + 1, cy) * (tx) * (1 - ty) +
            dem.get(cx, cy + 1) * (1 - tx) * (ty) +
            dem.get(cx + 1, cy + 1) * (tx) * (ty));
    }
    /**
     * Get the elevation for given {@link LngLat} in respect of exaggeration.
     * @param lnglat - the location
     * @param zoom - the zoom
     * @returns the elevation
     */
    getElevationForLngLatZoom(lnglat, zoom) {
        const { tileID, mercatorX, mercatorY } = this._getOverscaledTileIDFromLngLatZoom(lnglat, zoom);
        return this.getElevation(tileID, mercatorX % performance$1.X, mercatorY % performance$1.X, performance$1.X);
    }
    /**
     * Get the elevation for given coordinate in respect of exaggeration.
     * @param tileID - the tile id
     * @param x - between 0 .. EXTENT
     * @param y - between 0 .. EXTENT
     * @param extent - optional, default 8192
     * @returns the elevation
     */
    getElevation(tileID, x, y, extent = performance$1.X) {
        return this.getDEMElevation(tileID, x, y, extent) * this.exaggeration;
    }
    /**
     * returns a Terrain Object for a tile. Unless the tile corresponds to data (e.g. tile is loading), return a flat dem object
     * @param tileID - the tile to get the terrain for
     * @returns the terrain data to use in the program
     */
    getTerrainData(tileID) {
        // create empty DEM Objects, which will used while raster-dem tiles are loading.
        // creates an empty depth-buffer texture which is needed, during the initialization process of the 3d mesh..
        if (!this._emptyDemTexture) {
            const context = this.painter.context;
            const image = new performance$1.R({ width: 1, height: 1 }, new Uint8Array(1 * 4));
            this._emptyDepthTexture = new Texture(context, image, context.gl.RGBA, { premultiply: false });
            this._emptyDemUnpack = [0, 0, 0, 0];
            this._emptyDemTexture = new Texture(context, new performance$1.R({ width: 1, height: 1 }), context.gl.RGBA, { premultiply: false });
            this._emptyDemTexture.bind(context.gl.NEAREST, context.gl.CLAMP_TO_EDGE);
            this._emptyDemMatrix = performance$1.ao([]);
        }
        // find covering dem tile and prepare demTexture
        const sourceTile = this.sourceCache.getSourceTile(tileID, true);
        if (sourceTile && sourceTile.dem && (!sourceTile.demTexture || sourceTile.needsTerrainPrepare)) {
            const context = this.painter.context;
            sourceTile.demTexture = this.painter.getTileTexture(sourceTile.dem.stride);
            if (sourceTile.demTexture)
                sourceTile.demTexture.update(sourceTile.dem.getPixels(), { premultiply: false });
            else
                sourceTile.demTexture = new Texture(context, sourceTile.dem.getPixels(), context.gl.RGBA, { premultiply: false });
            sourceTile.demTexture.bind(context.gl.NEAREST, context.gl.CLAMP_TO_EDGE);
            sourceTile.needsTerrainPrepare = false;
        }
        // create matrix for lookup in dem data
        const matrixKey = sourceTile && (sourceTile + sourceTile.tileID.key) + tileID.key;
        if (matrixKey && !this._demMatrixCache[matrixKey]) {
            const maxzoom = this.sourceCache.sourceCache._source.maxzoom;
            let dz = tileID.canonical.z - sourceTile.tileID.canonical.z;
            if (tileID.overscaledZ > tileID.canonical.z) {
                if (tileID.canonical.z >= maxzoom)
                    dz = tileID.canonical.z - maxzoom;
                else
                    performance$1.w('cannot calculate elevation if elevation maxzoom > source.maxzoom');
            }
            const dx = tileID.canonical.x - (tileID.canonical.x >> dz << dz);
            const dy = tileID.canonical.y - (tileID.canonical.y >> dz << dz);
            const demMatrix = performance$1.bb(new Float64Array(16), [1 / (performance$1.X << dz), 1 / (performance$1.X << dz), 0]);
            performance$1.J(demMatrix, demMatrix, [dx * performance$1.X, dy * performance$1.X, 0]);
            this._demMatrixCache[tileID.key] = { matrix: demMatrix, coord: tileID };
        }
        // return uniform values & textures
        return {
            'u_depth': 2,
            'u_terrain': 3,
            'u_terrain_dim': sourceTile && sourceTile.dem && sourceTile.dem.dim || 1,
            'u_terrain_matrix': matrixKey ? this._demMatrixCache[tileID.key].matrix : this._emptyDemMatrix,
            'u_terrain_unpack': sourceTile && sourceTile.dem && sourceTile.dem.getUnpackVector() || this._emptyDemUnpack,
            'u_terrain_exaggeration': this.exaggeration,
            texture: (sourceTile && sourceTile.demTexture || this._emptyDemTexture).texture,
            depthTexture: (this._fboDepthTexture || this._emptyDepthTexture).texture,
            tile: sourceTile
        };
    }
    /**
     * get a framebuffer as big as the map-div, which will be used to render depth & coords into a texture
     * @param texture - the texture
     * @returns the frame buffer
     */
    getFramebuffer(texture) {
        const painter = this.painter;
        const width = painter.width / devicePixelRatio;
        const height = painter.height / devicePixelRatio;
        if (this._fbo && (this._fbo.width !== width || this._fbo.height !== height)) {
            this._fbo.destroy();
            this._fboCoordsTexture.destroy();
            this._fboDepthTexture.destroy();
            delete this._fbo;
            delete this._fboDepthTexture;
            delete this._fboCoordsTexture;
        }
        if (!this._fboCoordsTexture) {
            this._fboCoordsTexture = new Texture(painter.context, { width, height, data: null }, painter.context.gl.RGBA, { premultiply: false });
            this._fboCoordsTexture.bind(painter.context.gl.NEAREST, painter.context.gl.CLAMP_TO_EDGE);
        }
        if (!this._fboDepthTexture) {
            this._fboDepthTexture = new Texture(painter.context, { width, height, data: null }, painter.context.gl.RGBA, { premultiply: false });
            this._fboDepthTexture.bind(painter.context.gl.NEAREST, painter.context.gl.CLAMP_TO_EDGE);
        }
        if (!this._fbo) {
            this._fbo = painter.context.createFramebuffer(width, height, true, false);
            this._fbo.depthAttachment.set(painter.context.createRenderbuffer(painter.context.gl.DEPTH_COMPONENT16, width, height));
        }
        this._fbo.colorAttachment.set(texture === 'coords' ? this._fboCoordsTexture.texture : this._fboDepthTexture.texture);
        return this._fbo;
    }
    /**
     * create coords texture, needed to grab coordinates from canvas
     * encode coords coordinate into 4 bytes:
     *   - 8 lower bits for x
     *   - 8 lower bits for y
     *   - 4 higher bits for x
     *   - 4 higher bits for y
     *   - 8 bits for coordsIndex (1 .. 255) (= number of terraintile), is later setted in draw_terrain uniform value
     * @returns the texture
     */
    getCoordsTexture() {
        const context = this.painter.context;
        if (this._coordsTexture)
            return this._coordsTexture;
        const data = new Uint8Array(this._coordsTextureSize * this._coordsTextureSize * 4);
        for (let y = 0, i = 0; y < this._coordsTextureSize; y++)
            for (let x = 0; x < this._coordsTextureSize; x++, i += 4) {
                data[i + 0] = x & 255;
                data[i + 1] = y & 255;
                data[i + 2] = ((x >> 8) << 4) | (y >> 8);
                data[i + 3] = 0;
            }
        const image = new performance$1.R({ width: this._coordsTextureSize, height: this._coordsTextureSize }, new Uint8Array(data.buffer));
        const texture = new Texture(context, image, context.gl.RGBA, { premultiply: false });
        texture.bind(context.gl.NEAREST, context.gl.CLAMP_TO_EDGE);
        this._coordsTexture = texture;
        return texture;
    }
    /**
     * Reads a pixel from the coords-framebuffer and translate this to mercator.
     * @param p - Screen-Coordinate
     * @returns mercator coordinate for a screen pixel
     */
    pointCoordinate(p) {
        // First, ensure the coords framebuffer is up to date.
        this.painter.maybeDrawDepthAndCoords(true);
        const rgba = new Uint8Array(4);
        const context = this.painter.context, gl = context.gl;
        const px = Math.round(p.x * this.painter.pixelRatio / devicePixelRatio);
        const py = Math.round(p.y * this.painter.pixelRatio / devicePixelRatio);
        const fbHeight = Math.round(this.painter.height / devicePixelRatio);
        // grab coordinate pixel from coordinates framebuffer
        context.bindFramebuffer.set(this.getFramebuffer('coords').framebuffer);
        gl.readPixels(px, fbHeight - py - 1, 1, 1, gl.RGBA, gl.UNSIGNED_BYTE, rgba);
        context.bindFramebuffer.set(null);
        // decode coordinates (encoding see getCoordsTexture)
        const x = rgba[0] + ((rgba[2] >> 4) << 8);
        const y = rgba[1] + ((rgba[2] & 15) << 8);
        const tileID = this.coordsIndex[255 - rgba[3]];
        const tile = tileID && this.sourceCache.getTileByID(tileID);
        if (!tile)
            return null;
        const coordsSize = this._coordsTextureSize;
        const worldSize = (1 << tile.tileID.canonical.z) * coordsSize;
        return new performance$1.Z((tile.tileID.canonical.x * coordsSize + x) / worldSize + tile.tileID.wrap, (tile.tileID.canonical.y * coordsSize + y) / worldSize, this.getElevation(tile.tileID, x, y, coordsSize));
    }
    /**
     * Reads the depth value from the depth-framebuffer at a given screen pixel
     * @param p - Screen coordinate
     * @returns depth value in clip space (between 0 and 1)
     */
    depthAtPoint(p) {
        const rgba = new Uint8Array(4);
        const context = this.painter.context, gl = context.gl;
        context.bindFramebuffer.set(this.getFramebuffer('depth').framebuffer);
        gl.readPixels(p.x, this.painter.height / devicePixelRatio - p.y - 1, 1, 1, gl.RGBA, gl.UNSIGNED_BYTE, rgba);
        context.bindFramebuffer.set(null);
        // decode coordinates (encoding see terran_depth.fragment.glsl)
        const depthValue = (rgba[0] / (256 * 256 * 256) + rgba[1] / (256 * 256) + rgba[2] / 256 + rgba[3]) / 256;
        return depthValue;
    }
    /**
     * create a regular mesh which will be used by all terrain-tiles
     * @returns the created regular mesh
     */
    getTerrainMesh() {
        if (this._mesh)
            return this._mesh;
        const context = this.painter.context;
        const vertexArray = new performance$1.bc();
        const indexArray = new performance$1.aY();
        const meshSize = this.meshSize;
        const delta = performance$1.X / meshSize;
        const meshSize2 = meshSize * meshSize;
        for (let y = 0; y <= meshSize; y++)
            for (let x = 0; x <= meshSize; x++)
                vertexArray.emplaceBack(x * delta, y * delta, 0);
        for (let y = 0; y < meshSize2; y += meshSize + 1)
            for (let x = 0; x < meshSize; x++) {
                indexArray.emplaceBack(x + y, meshSize + x + y + 1, meshSize + x + y + 2);
                indexArray.emplaceBack(x + y, meshSize + x + y + 2, x + y + 1);
            }
        // add an extra frame around the mesh to avoid stiching on tile boundaries with different zoomlevels
        // first code-block is for top-bottom frame and second for left-right frame
        const offsetTop = vertexArray.length, offsetBottom = offsetTop + (meshSize + 1) * 2;
        for (const y of [0, 1])
            for (let x = 0; x <= meshSize; x++)
                for (const z of [0, 1])
                    vertexArray.emplaceBack(x * delta, y * performance$1.X, z);
        for (let x = 0; x < meshSize * 2; x += 2) {
            indexArray.emplaceBack(offsetBottom + x, offsetBottom + x + 1, offsetBottom + x + 3);
            indexArray.emplaceBack(offsetBottom + x, offsetBottom + x + 3, offsetBottom + x + 2);
            indexArray.emplaceBack(offsetTop + x, offsetTop + x + 3, offsetTop + x + 1);
            indexArray.emplaceBack(offsetTop + x, offsetTop + x + 2, offsetTop + x + 3);
        }
        const offsetLeft = vertexArray.length, offsetRight = offsetLeft + (meshSize + 1) * 2;
        for (const x of [0, 1])
            for (let y = 0; y <= meshSize; y++)
                for (const z of [0, 1])
                    vertexArray.emplaceBack(x * performance$1.X, y * delta, z);
        for (let y = 0; y < meshSize * 2; y += 2) {
            indexArray.emplaceBack(offsetLeft + y, offsetLeft + y + 1, offsetLeft + y + 3);
            indexArray.emplaceBack(offsetLeft + y, offsetLeft + y + 3, offsetLeft + y + 2);
            indexArray.emplaceBack(offsetRight + y, offsetRight + y + 3, offsetRight + y + 1);
            indexArray.emplaceBack(offsetRight + y, offsetRight + y + 2, offsetRight + y + 3);
        }
        this._mesh = new Mesh(context.createVertexBuffer(vertexArray, pos3dAttributes.members), context.createIndexBuffer(indexArray), performance$1.a0.simpleSegment(0, 0, vertexArray.length, indexArray.length));
        return this._mesh;
    }
    /**
     * Calculates a height of the frame around the terrain-mesh to avoid stiching between
     * tile boundaries in different zoomlevels.
     * @param zoom - current zoomlevel
     * @returns the elevation delta in meters
     */
    getMeshFrameDelta(zoom) {
        // divide by 5 is evaluated by trial & error to get a frame in the right height
        return 2 * Math.PI * performance$1.bd / Math.pow(2, zoom) / 5;
    }
    getMinTileElevationForLngLatZoom(lnglat, zoom) {
        var _a;
        const { tileID } = this._getOverscaledTileIDFromLngLatZoom(lnglat, zoom);
        return (_a = this.getMinMaxElevation(tileID).minElevation) !== null && _a !== void 0 ? _a : 0;
    }
    /**
     * Get the minimum and maximum elevation contained in a tile. This includes any
     * exaggeration included in the terrain.
     *
     * @param tileID - ID of the tile to be used as a source for the min/max elevation
     * @returns the minimum and maximum elevation found in the tile, including the terrain's
     * exaggeration
     */
    getMinMaxElevation(tileID) {
        const tile = this.getTerrainData(tileID).tile;
        const minMax = { minElevation: null, maxElevation: null };
        if (tile && tile.dem) {
            minMax.minElevation = tile.dem.min * this.exaggeration;
            minMax.maxElevation = tile.dem.max * this.exaggeration;
        }
        return minMax;
    }
    _getOverscaledTileIDFromLngLatZoom(lnglat, zoom) {
        const mercatorCoordinate = performance$1.Z.fromLngLat(lnglat.wrap());
        const worldSize = (1 << zoom) * performance$1.X;
        const mercatorX = mercatorCoordinate.x * worldSize;
        const mercatorY = mercatorCoordinate.y * worldSize;
        const tileX = Math.floor(mercatorX / performance$1.X), tileY = Math.floor(mercatorY / performance$1.X);
        const tileID = new performance$1.S(zoom, 0, zoom, tileX, tileY);
        return {
            tileID,
            mercatorX,
            mercatorY
        };
    }
}

/**
 * @internal
 * `RenderPool` is a resource pool for textures and framebuffers
 */
class RenderPool {
    constructor(_context, _size, _tileSize) {
        this._context = _context;
        this._size = _size;
        this._tileSize = _tileSize;
        this._objects = [];
        this._recentlyUsed = [];
        this._stamp = 0;
    }
    destruct() {
        for (const obj of this._objects) {
            obj.texture.destroy();
            obj.fbo.destroy();
        }
    }
    _createObject(id) {
        const fbo = this._context.createFramebuffer(this._tileSize, this._tileSize, true, true);
        const texture = new Texture(this._context, { width: this._tileSize, height: this._tileSize, data: null }, this._context.gl.RGBA);
        texture.bind(this._context.gl.LINEAR, this._context.gl.CLAMP_TO_EDGE);
        fbo.depthAttachment.set(this._context.createRenderbuffer(this._context.gl.DEPTH_STENCIL, this._tileSize, this._tileSize));
        fbo.colorAttachment.set(texture.texture);
        return { id, fbo, texture, stamp: -1, inUse: false };
    }
    getObjectForId(id) {
        return this._objects[id];
    }
    useObject(obj) {
        obj.inUse = true;
        this._recentlyUsed = this._recentlyUsed.filter(id => obj.id !== id);
        this._recentlyUsed.push(obj.id);
    }
    stampObject(obj) {
        obj.stamp = ++this._stamp;
    }
    getOrCreateFreeObject() {
        // check for free existing object
        for (const id of this._recentlyUsed) {
            if (!this._objects[id].inUse)
                return this._objects[id];
        }
        if (this._objects.length >= this._size)
            throw new Error('No free RenderPool available, call freeAllObjects() required!');
        // create new object
        const obj = this._createObject(this._objects.length);
        this._objects.push(obj);
        return obj;
    }
    freeObject(obj) {
        obj.inUse = false;
    }
    freeAllObjects() {
        for (const obj of this._objects)
            this.freeObject(obj);
    }
    isFull() {
        if (this._objects.length < this._size) {
            return false;
        }
        return this._objects.some(o => !o.inUse) === false;
    }
}

/**
 * lookup table which layers should rendered to texture
 */
const LAYERS = {
    background: true,
    fill: true,
    line: true,
    raster: true,
    hillshade: true
};
/**
 * @internal
 * A helper class to help define what should be rendered to texture and how
 */
class RenderToTexture {
    constructor(painter, terrain) {
        this.painter = painter;
        this.terrain = terrain;
        this.pool = new RenderPool(painter.context, 30, terrain.sourceCache.tileSize * terrain.qualityFactor);
    }
    destruct() {
        this.pool.destruct();
    }
    getTexture(tile) {
        return this.pool.getObjectForId(tile.rtt[this._stacks.length - 1].id).texture;
    }
    prepareForRender(style, zoom) {
        this._stacks = [];
        this._prevType = null;
        this._rttTiles = [];
        this._renderableTiles = this.terrain.sourceCache.getRenderableTiles();
        this._renderableLayerIds = style._order.filter(id => !style._layers[id].isHidden(zoom));
        this._coordsDescendingInv = {};
        for (const id in style.sourceCaches) {
            this._coordsDescendingInv[id] = {};
            const tileIDs = style.sourceCaches[id].getVisibleCoordinates();
            for (const tileID of tileIDs) {
                const keys = this.terrain.sourceCache.getTerrainCoords(tileID);
                for (const key in keys) {
                    if (!this._coordsDescendingInv[id][key])
                        this._coordsDescendingInv[id][key] = [];
                    this._coordsDescendingInv[id][key].push(keys[key]);
                }
            }
        }
        this._coordsDescendingInvStr = {};
        for (const id of style._order) {
            const layer = style._layers[id], source = layer.source;
            if (LAYERS[layer.type]) {
                if (!this._coordsDescendingInvStr[source]) {
                    this._coordsDescendingInvStr[source] = {};
                    for (const key in this._coordsDescendingInv[source])
                        this._coordsDescendingInvStr[source][key] = this._coordsDescendingInv[source][key].map(c => c.key).sort().join();
                }
            }
        }
        // check tiles to render
        for (const tile of this._renderableTiles) {
            for (const source in this._coordsDescendingInvStr) {
                // rerender if there are more coords to render than in the last rendering
                const coords = this._coordsDescendingInvStr[source][tile.tileID.key];
                if (coords && coords !== tile.rttCoords[source])
                    tile.rtt = [];
            }
        }
    }
    /**
     * due that switching textures is relatively slow, the render
     * layer-by-layer context is not practicable. To bypass this problem
     * this lines of code stack all layers and later render all at once.
     * Because of the stylesheet possibility to mixing render-to-texture layers
     * and 'live'-layers (f.e. symbols) it is necessary to create more stacks. For example
     * a symbol-layer is in between of fill-layers.
     * @param layer - the layer to render
     * @returns if true layer is rendered to texture, otherwise false
     */
    renderLayer(layer) {
        if (layer.isHidden(this.painter.transform.zoom))
            return false;
        const type = layer.type;
        const painter = this.painter;
        const isLastLayer = this._renderableLayerIds[this._renderableLayerIds.length - 1] === layer.id;
        // remember background, fill, line & raster layer to render into a stack
        if (LAYERS[type]) {
            // create a new stack if previous layer was not rendered to texture (f.e. symbols)
            if (!this._prevType || !LAYERS[this._prevType])
                this._stacks.push([]);
            // push current render-to-texture layer to render-stack
            this._prevType = type;
            this._stacks[this._stacks.length - 1].push(layer.id);
            // rendering is done later, all in once
            if (!isLastLayer)
                return true;
        }
        // in case a stack is finished render all collected stack-layers into a texture
        if (LAYERS[this._prevType] || (LAYERS[type] && isLastLayer)) {
            this._prevType = type;
            const stack = this._stacks.length - 1, layers = this._stacks[stack] || [];
            for (const tile of this._renderableTiles) {
                // if render pool is full draw current tiles to screen and free pool
                if (this.pool.isFull()) {
                    drawTerrain(this.painter, this.terrain, this._rttTiles);
                    this._rttTiles = [];
                    this.pool.freeAllObjects();
                }
                this._rttTiles.push(tile);
                // check for cached PoolObject
                if (tile.rtt[stack]) {
                    const obj = this.pool.getObjectForId(tile.rtt[stack].id);
                    if (obj.stamp === tile.rtt[stack].stamp) {
                        this.pool.useObject(obj);
                        continue;
                    }
                }
                // get free PoolObject
                const obj = this.pool.getOrCreateFreeObject();
                this.pool.useObject(obj);
                this.pool.stampObject(obj);
                tile.rtt[stack] = { id: obj.id, stamp: obj.stamp };
                // prepare PoolObject for rendering
                painter.context.bindFramebuffer.set(obj.fbo.framebuffer);
                painter.context.clear({ color: performance$1.aN.transparent, stencil: 0 });
                painter.currentStencilSource = undefined;
                for (let l = 0; l < layers.length; l++) {
                    const layer = painter.style._layers[layers[l]];
                    const coords = layer.source ? this._coordsDescendingInv[layer.source][tile.tileID.key] : [tile.tileID];
                    painter.context.viewport.set([0, 0, obj.fbo.width, obj.fbo.height]);
                    painter._renderTileClippingMasks(layer, coords);
                    painter.renderLayer(painter, painter.style.sourceCaches[layer.source], layer, coords);
                    if (layer.source)
                        tile.rttCoords[layer.source] = this._coordsDescendingInvStr[layer.source][tile.tileID.key];
                }
            }
            drawTerrain(this.painter, this.terrain, this._rttTiles);
            this._rttTiles = [];
            this.pool.freeAllObjects();
            return LAYERS[type];
        }
        return false;
    }
}

const defaultLocale = {
    'AttributionControl.ToggleAttribution': 'Toggle attribution',
    'AttributionControl.MapFeedback': 'Map feedback',
    'FullscreenControl.Enter': 'Enter fullscreen',
    'FullscreenControl.Exit': 'Exit fullscreen',
    'GeolocateControl.FindMyLocation': 'Find my location',
    'GeolocateControl.LocationNotAvailable': 'Location not available',
    'LogoControl.Title': 'MapLibre logo',
    'Map.Title': 'Map',
    'Marker.Title': 'Map marker',
    'NavigationControl.ResetBearing': 'Reset bearing to north',
    'NavigationControl.ZoomIn': 'Zoom in',
    'NavigationControl.ZoomOut': 'Zoom out',
    'Popup.Close': 'Close popup',
    'ScaleControl.Feet': 'ft',
    'ScaleControl.Meters': 'm',
    'ScaleControl.Kilometers': 'km',
    'ScaleControl.Miles': 'mi',
    'ScaleControl.NauticalMiles': 'nm',
    'TerrainControl.Enable': 'Enable terrain',
    'TerrainControl.Disable': 'Disable terrain',
    'CooperativeGesturesHandler.WindowsHelpText': 'Use Ctrl + scroll to zoom the map',
    'CooperativeGesturesHandler.MacHelpText': 'Use ⌘ + scroll to zoom the map',
    'CooperativeGesturesHandler.MobileHelpText': 'Use two fingers to move the map',
};

const version$1 = packageJSON.version;
const defaultMinZoom = -2;
const defaultMaxZoom = 22;
// the default values, but also the valid range
const defaultMinPitch = 0;
const defaultMaxPitch = 60;
// use this variable to check maxPitch for validity
const maxPitchThreshold = 85;
const defaultOptions$4 = {
    hash: false,
    interactive: true,
    bearingSnap: 7,
    attributionControl: defaultAttributionControlOptions,
    maplibreLogo: false,
    failIfMajorPerformanceCaveat: false,
    preserveDrawingBuffer: false,
    refreshExpiredTiles: true,
    scrollZoom: true,
    minZoom: defaultMinZoom,
    maxZoom: defaultMaxZoom,
    minPitch: defaultMinPitch,
    maxPitch: defaultMaxPitch,
    boxZoom: true,
    dragRotate: true,
    dragPan: true,
    keyboard: true,
    doubleClickZoom: true,
    touchZoomRotate: true,
    touchPitch: true,
    cooperativeGestures: false,
    trackResize: true,
    center: [0, 0],
    zoom: 0,
    bearing: 0,
    pitch: 0,
    renderWorldCopies: true,
    maxTileCacheSize: null,
    maxTileCacheZoomLevels: performance$1.a.MAX_TILE_CACHE_ZOOM_LEVELS,
    transformRequest: null,
    transformCameraUpdate: null,
    fadeDuration: 300,
    crossSourceCollisions: true,
    clickTolerance: 3,
    localIdeographFontFamily: 'sans-serif',
    pitchWithRotate: true,
    validateStyle: true,
    /**Because GL MAX_TEXTURE_SIZE is usually at least 4096px. */
    maxCanvasSize: [4096, 4096],
    cancelPendingTileRequestsWhileZooming: true
};
/**
 * The `Map` object represents the map on your page. It exposes methods
 * and properties that enable you to programmatically change the map,
 * and fires events as users interact with it.
 *
 * You create a `Map` by specifying a `container` and other options, see {@link MapOptions} for the full list.
 * Then MapLibre GL JS initializes the map on the page and returns your `Map` object.
 *
 * @group Main
 *
 * @example
 * ```ts
 * let map = new Map({
 *   container: 'map',
 *   center: [-122.420679, 37.772537],
 *   zoom: 13,
 *   style: style_object,
 *   hash: true,
 *   transformRequest: (url, resourceType)=> {
 *     if(resourceType === 'Source' && url.startsWith('http://myHost')) {
 *       return {
 *        url: url.replace('http', 'https'),
 *        headers: { 'my-custom-header': true},
 *        credentials: 'include'  // Include cookies for cross-origin requests
 *      }
 *     }
 *   }
 * });
 * ```
 * @see [Display a map](https://maplibre.org/maplibre-gl-js/docs/examples/simple-map/)
 */
let Map$1 = class Map extends Camera {
    constructor(options) {
        performance$1.be.mark(performance$1.bf.create);
        const resolvedOptions = Object.assign(Object.assign({}, defaultOptions$4), options);
        if (resolvedOptions.minZoom != null && resolvedOptions.maxZoom != null && resolvedOptions.minZoom > resolvedOptions.maxZoom) {
            throw new Error('maxZoom must be greater than or equal to minZoom');
        }
        if (resolvedOptions.minPitch != null && resolvedOptions.maxPitch != null && resolvedOptions.minPitch > resolvedOptions.maxPitch) {
            throw new Error('maxPitch must be greater than or equal to minPitch');
        }
        if (resolvedOptions.minPitch != null && resolvedOptions.minPitch < defaultMinPitch) {
            throw new Error(`minPitch must be greater than or equal to ${defaultMinPitch}`);
        }
        if (resolvedOptions.maxPitch != null && resolvedOptions.maxPitch > maxPitchThreshold) {
            throw new Error(`maxPitch must be less than or equal to ${maxPitchThreshold}`);
        }
        const transform = new Transform(resolvedOptions.minZoom, resolvedOptions.maxZoom, resolvedOptions.minPitch, resolvedOptions.maxPitch, resolvedOptions.renderWorldCopies);
        super(transform, { bearingSnap: resolvedOptions.bearingSnap });
        this._idleTriggered = false;
        this._crossFadingFactor = 1;
        this._renderTaskQueue = new TaskQueue();
        this._controls = [];
        this._mapId = performance$1.a4();
        this._contextLost = (event) => {
            event.preventDefault();
            if (this._frameRequest) {
                this._frameRequest.abort();
                this._frameRequest = null;
            }
            this.fire(new performance$1.k('webglcontextlost', { originalEvent: event }));
        };
        this._contextRestored = (event) => {
            this._setupPainter();
            this.resize();
            this._update();
            this.fire(new performance$1.k('webglcontextrestored', { originalEvent: event }));
        };
        this._onMapScroll = (event) => {
            if (event.target !== this._container)
                return;
            // Revert any scroll which would move the canvas outside of the view
            this._container.scrollTop = 0;
            this._container.scrollLeft = 0;
            return false;
        };
        this._onWindowOnline = () => {
            this._update();
        };
        this._interactive = resolvedOptions.interactive;
        this._maxTileCacheSize = resolvedOptions.maxTileCacheSize;
        this._maxTileCacheZoomLevels = resolvedOptions.maxTileCacheZoomLevels;
        this._failIfMajorPerformanceCaveat = resolvedOptions.failIfMajorPerformanceCaveat === true;
        this._preserveDrawingBuffer = resolvedOptions.preserveDrawingBuffer === true;
        this._antialias = resolvedOptions.antialias === true;
        this._trackResize = resolvedOptions.trackResize === true;
        this._bearingSnap = resolvedOptions.bearingSnap;
        this._refreshExpiredTiles = resolvedOptions.refreshExpiredTiles === true;
        this._fadeDuration = resolvedOptions.fadeDuration;
        this._crossSourceCollisions = resolvedOptions.crossSourceCollisions === true;
        this._collectResourceTiming = resolvedOptions.collectResourceTiming === true;
        this._locale = Object.assign(Object.assign({}, defaultLocale), resolvedOptions.locale);
        this._clickTolerance = resolvedOptions.clickTolerance;
        this._overridePixelRatio = resolvedOptions.pixelRatio;
        this._maxCanvasSize = resolvedOptions.maxCanvasSize;
        this.transformCameraUpdate = resolvedOptions.transformCameraUpdate;
        this.cancelPendingTileRequestsWhileZooming = resolvedOptions.cancelPendingTileRequestsWhileZooming === true;
        this._imageQueueHandle = ImageRequest.addThrottleControl(() => this.isMoving());
        this._requestManager = new RequestManager(resolvedOptions.transformRequest);
        if (typeof resolvedOptions.container === 'string') {
            this._container = document.getElementById(resolvedOptions.container);
            if (!this._container) {
                throw new Error(`Container '${resolvedOptions.container}' not found.`);
            }
        }
        else if (resolvedOptions.container instanceof HTMLElement) {
            this._container = resolvedOptions.container;
        }
        else {
            throw new Error('Invalid type: \'container\' must be a String or HTMLElement.');
        }
        if (resolvedOptions.maxBounds) {
            this.setMaxBounds(resolvedOptions.maxBounds);
        }
        this._setupContainer();
        this._setupPainter();
        this.on('move', () => this._update(false))
            .on('moveend', () => this._update(false))
            .on('zoom', () => this._update(true))
            .on('terrain', () => {
            this.painter.terrainFacilitator.dirty = true;
            this._update(true);
        })
            .once('idle', () => { this._idleTriggered = true; });
        if (typeof window !== 'undefined') {
            addEventListener('online', this._onWindowOnline, false);
            let initialResizeEventCaptured = false;
            const throttledResizeCallback = throttle((entries) => {
                if (this._trackResize && !this._removed) {
                    this.resize(entries)._update();
                }
            }, 50);
            this._resizeObserver = new ResizeObserver((entries) => {
                if (!initialResizeEventCaptured) {
                    initialResizeEventCaptured = true;
                    return;
                }
                throttledResizeCallback(entries);
            });
            this._resizeObserver.observe(this._container);
        }
        this.handlers = new HandlerManager(this, resolvedOptions);
        const hashName = (typeof resolvedOptions.hash === 'string' && resolvedOptions.hash) || undefined;
        this._hash = resolvedOptions.hash && (new Hash(hashName)).addTo(this);
        // don't set position from options if set through hash
        if (!this._hash || !this._hash._onHashChange()) {
            this.jumpTo({
                center: resolvedOptions.center,
                zoom: resolvedOptions.zoom,
                bearing: resolvedOptions.bearing,
                pitch: resolvedOptions.pitch
            });
            if (resolvedOptions.bounds) {
                this.resize();
                this.fitBounds(resolvedOptions.bounds, performance$1.e({}, resolvedOptions.fitBoundsOptions, { duration: 0 }));
            }
        }
        this.resize();
        this._localIdeographFontFamily = resolvedOptions.localIdeographFontFamily;
        this._validateStyle = resolvedOptions.validateStyle;
        if (resolvedOptions.style)
            this.setStyle(resolvedOptions.style, { localIdeographFontFamily: resolvedOptions.localIdeographFontFamily });
        if (resolvedOptions.attributionControl)
            this.addControl(new AttributionControl(typeof resolvedOptions.attributionControl === 'boolean' ? undefined : resolvedOptions.attributionControl));
        if (resolvedOptions.maplibreLogo)
            this.addControl(new LogoControl(), resolvedOptions.logoPosition);
        this.on('style.load', () => {
            if (this.transform.unmodified) {
                this.jumpTo(this.style.stylesheet);
            }
        });
        this.on('data', (event) => {
            this._update(event.dataType === 'style');
            this.fire(new performance$1.k(`${event.dataType}data`, event));
        });
        this.on('dataloading', (event) => {
            this.fire(new performance$1.k(`${event.dataType}dataloading`, event));
        });
        this.on('dataabort', (event) => {
            this.fire(new performance$1.k('sourcedataabort', event));
        });
    }
    /**
     * @internal
     * Returns a unique number for this map instance which is used for the MapLoadEvent
     * to make sure we only fire one event per instantiated map object.
     * @returns the uniq map ID
     */
    _getMapId() {
        return this._mapId;
    }
    /**
     * Adds an {@link IControl} to the map, calling `control.onAdd(this)`.
     *
     * An {@link ErrorEvent} will be fired if the image parameter is invald.
     *
     * @param control - The {@link IControl} to add.
     * @param position - position on the map to which the control will be added.
     * Valid values are `'top-left'`, `'top-right'`, `'bottom-left'`, and `'bottom-right'`. Defaults to `'top-right'`.
     * @example
     * Add zoom and rotation controls to the map.
     * ```ts
     * map.addControl(new NavigationControl());
     * ```
     * @see [Display map navigation controls](https://maplibre.org/maplibre-gl-js/docs/examples/navigation/)
     */
    addControl(control, position) {
        if (position === undefined) {
            if (control.getDefaultPosition) {
                position = control.getDefaultPosition();
            }
            else {
                position = 'top-right';
            }
        }
        if (!control || !control.onAdd) {
            return this.fire(new performance$1.j(new Error('Invalid argument to map.addControl(). Argument must be a control with onAdd and onRemove methods.')));
        }
        const controlElement = control.onAdd(this);
        this._controls.push(control);
        const positionContainer = this._controlPositions[position];
        if (position.indexOf('bottom') !== -1) {
            positionContainer.insertBefore(controlElement, positionContainer.firstChild);
        }
        else {
            positionContainer.appendChild(controlElement);
        }
        return this;
    }
    /**
     * Removes the control from the map.
     *
     * An {@link ErrorEvent} will be fired if the image parameter is invald.
     *
     * @param control - The {@link IControl} to remove.
     * @example
     * ```ts
     * // Define a new navigation control.
     * let navigation = new NavigationControl();
     * // Add zoom and rotation controls to the map.
     * map.addControl(navigation);
     * // Remove zoom and rotation controls from the map.
     * map.removeControl(navigation);
     * ```
     */
    removeControl(control) {
        if (!control || !control.onRemove) {
            return this.fire(new performance$1.j(new Error('Invalid argument to map.removeControl(). Argument must be a control with onAdd and onRemove methods.')));
        }
        const ci = this._controls.indexOf(control);
        if (ci > -1)
            this._controls.splice(ci, 1);
        control.onRemove(this);
        return this;
    }
    /**
     * Checks if a control exists on the map.
     *
     * @param control - The {@link IControl} to check.
     * @returns true if map contains control.
     * @example
     * ```ts
     * // Define a new navigation control.
     * let navigation = new NavigationControl();
     * // Add zoom and rotation controls to the map.
     * map.addControl(navigation);
     * // Check that the navigation control exists on the map.
     * map.hasControl(navigation);
     * ```
     */
    hasControl(control) {
        return this._controls.indexOf(control) > -1;
    }
    calculateCameraOptionsFromTo(from, altitudeFrom, to, altitudeTo) {
        if (altitudeTo == null && this.terrain) {
            altitudeTo = this.terrain.getElevationForLngLatZoom(to, this.transform.tileZoom);
        }
        return super.calculateCameraOptionsFromTo(from, altitudeFrom, to, altitudeTo);
    }
    /**
     * Resizes the map according to the dimensions of its
     * `container` element.
     *
     * Checks if the map container size changed and updates the map if it has changed.
     * This method must be called after the map's `container` is resized programmatically
     * or when the map is shown after being initially hidden with CSS.
     *
     * Triggers the following events: `movestart`, `move`, `moveend`, and `resize`.
     *
     * @param eventData - Additional properties to be passed to `movestart`, `move`, `resize`, and `moveend`
     * events that get triggered as a result of resize. This can be useful for differentiating the
     * source of an event (for example, user-initiated or programmatically-triggered events).
     * @example
     * Resize the map when the map container is shown after being initially hidden with CSS.
     * ```ts
     * let mapDiv = document.getElementById('map');
     * if (mapDiv.style.visibility === true) map.resize();
     * ```
     */
    resize(eventData) {
        var _a;
        const dimensions = this._containerDimensions();
        const width = dimensions[0];
        const height = dimensions[1];
        const clampedPixelRatio = this._getClampedPixelRatio(width, height);
        this._resizeCanvas(width, height, clampedPixelRatio);
        this.painter.resize(width, height, clampedPixelRatio);
        // check if we've reached GL limits, in that case further clamps pixelRatio
        if (this.painter.overLimit()) {
            const gl = this.painter.context.gl;
            // store updated _maxCanvasSize value
            this._maxCanvasSize = [gl.drawingBufferWidth, gl.drawingBufferHeight];
            const clampedPixelRatio = this._getClampedPixelRatio(width, height);
            this._resizeCanvas(width, height, clampedPixelRatio);
            this.painter.resize(width, height, clampedPixelRatio);
        }
        this.transform.resize(width, height);
        (_a = this._requestedCameraState) === null || _a === void 0 ? void 0 : _a.resize(width, height);
        const fireMoving = !this._moving;
        if (fireMoving) {
            this.stop();
            this.fire(new performance$1.k('movestart', eventData))
                .fire(new performance$1.k('move', eventData));
        }
        this.fire(new performance$1.k('resize', eventData));
        if (fireMoving)
            this.fire(new performance$1.k('moveend', eventData));
        return this;
    }
    /**
     * @internal
     * Return the map's pixel ratio eventually scaled down to respect maxCanvasSize.
     * Internally you should use this and not getPixelRatio().
     */
    _getClampedPixelRatio(width, height) {
        const { 0: maxCanvasWidth, 1: maxCanvasHeight } = this._maxCanvasSize;
        const pixelRatio = this.getPixelRatio();
        const canvasWidth = width * pixelRatio;
        const canvasHeight = height * pixelRatio;
        const widthScaleFactor = canvasWidth > maxCanvasWidth ? (maxCanvasWidth / canvasWidth) : 1;
        const heightScaleFactor = canvasHeight > maxCanvasHeight ? (maxCanvasHeight / canvasHeight) : 1;
        return Math.min(widthScaleFactor, heightScaleFactor) * pixelRatio;
    }
    /**
     * Returns the map's pixel ratio.
     * Note that the pixel ratio actually applied may be lower to respect maxCanvasSize.
     * @returns The pixel ratio.
     */
    getPixelRatio() {
        var _a;
        return (_a = this._overridePixelRatio) !== null && _a !== void 0 ? _a : devicePixelRatio;
    }
    /**
     * Sets the map's pixel ratio. This allows to override `devicePixelRatio`.
     * After this call, the canvas' `width` attribute will be `container.clientWidth * pixelRatio`
     * and its height attribute will be `container.clientHeight * pixelRatio`.
     * Set this to null to disable `devicePixelRatio` override.
     * Note that the pixel ratio actually applied may be lower to respect maxCanvasSize.
     * @param pixelRatio - The pixel ratio.
     */
    setPixelRatio(pixelRatio) {
        this._overridePixelRatio = pixelRatio;
        this.resize();
    }
    /**
     * Returns the map's geographical bounds. When the bearing or pitch is non-zero, the visible region is not
     * an axis-aligned rectangle, and the result is the smallest bounds that encompasses the visible region.
     * @returns The geographical bounds of the map as {@link LngLatBounds}.
     * @example
     * ```ts
     * let bounds = map.getBounds();
     * ```
     */
    getBounds() {
        return this.transform.getBounds();
    }
    /**
     * Returns the maximum geographical bounds the map is constrained to, or `null` if none set.
     * @returns The map object.
     * @example
     * ```ts
     * let maxBounds = map.getMaxBounds();
     * ```
     */
    getMaxBounds() {
        return this.transform.getMaxBounds();
    }
    /**
     * Sets or clears the map's geographical bounds.
     *
     * Pan and zoom operations are constrained within these bounds.
     * If a pan or zoom is performed that would
     * display regions outside these bounds, the map will
     * instead display a position and zoom level
     * as close as possible to the operation's request while still
     * remaining within the bounds.
     *
     * @param bounds - The maximum bounds to set. If `null` or `undefined` is provided, the function removes the map's maximum bounds.
     * @example
     * Define bounds that conform to the `LngLatBoundsLike` object as set the max bounds.
     * ```ts
     * let bounds = [
     *   [-74.04728, 40.68392], // [west, south]
     *   [-73.91058, 40.87764]  // [east, north]
     * ];
     * map.setMaxBounds(bounds);
     * ```
     */
    setMaxBounds(bounds) {
        this.transform.setMaxBounds(LngLatBounds.convert(bounds));
        return this._update();
    }
    /**
     * Sets or clears the map's minimum zoom level.
     * If the map's current zoom level is lower than the new minimum,
     * the map will zoom to the new minimum.
     *
     * It is not always possible to zoom out and reach the set `minZoom`.
     * Other factors such as map height may restrict zooming. For example,
     * if the map is 512px tall it will not be possible to zoom below zoom 0
     * no matter what the `minZoom` is set to.
     *
     * A {@link ErrorEvent} event will be fired if minZoom is out of bounds.
     *
     * @param minZoom - The minimum zoom level to set (-2 - 24).
     * If `null` or `undefined` is provided, the function removes the current minimum zoom (i.e. sets it to -2).
     * @example
     * ```ts
     * map.setMinZoom(12.25);
     * ```
     */
    setMinZoom(minZoom) {
        minZoom = minZoom === null || minZoom === undefined ? defaultMinZoom : minZoom;
        if (minZoom >= defaultMinZoom && minZoom <= this.transform.maxZoom) {
            this.transform.minZoom = minZoom;
            this._update();
            if (this.getZoom() < minZoom)
                this.setZoom(minZoom);
            return this;
        }
        else
            throw new Error(`minZoom must be between ${defaultMinZoom} and the current maxZoom, inclusive`);
    }
    /**
     * Returns the map's minimum allowable zoom level.
     *
     * @returns minZoom
     * @example
     * ```ts
     * let minZoom = map.getMinZoom();
     * ```
     */
    getMinZoom() { return this.transform.minZoom; }
    /**
     * Sets or clears the map's maximum zoom level.
     * If the map's current zoom level is higher than the new maximum,
     * the map will zoom to the new maximum.
     *
     * A {@link ErrorEvent} event will be fired if minZoom is out of bounds.
     *
     * @param maxZoom - The maximum zoom level to set.
     * If `null` or `undefined` is provided, the function removes the current maximum zoom (sets it to 22).
     * @example
     * ```ts
     * map.setMaxZoom(18.75);
     * ```
     */
    setMaxZoom(maxZoom) {
        maxZoom = maxZoom === null || maxZoom === undefined ? defaultMaxZoom : maxZoom;
        if (maxZoom >= this.transform.minZoom) {
            this.transform.maxZoom = maxZoom;
            this._update();
            if (this.getZoom() > maxZoom)
                this.setZoom(maxZoom);
            return this;
        }
        else
            throw new Error('maxZoom must be greater than the current minZoom');
    }
    /**
     * Returns the map's maximum allowable zoom level.
     *
     * @returns The maxZoom
     * @example
     * ```ts
     * let maxZoom = map.getMaxZoom();
     * ```
     */
    getMaxZoom() { return this.transform.maxZoom; }
    /**
     * Sets or clears the map's minimum pitch.
     * If the map's current pitch is lower than the new minimum,
     * the map will pitch to the new minimum.
     *
     * A {@link ErrorEvent} event will be fired if minPitch is out of bounds.
     *
     * @param minPitch - The minimum pitch to set (0-85). Values greater than 60 degrees are experimental and may result in rendering issues. If you encounter any, please raise an issue with details in the MapLibre project.
     * If `null` or `undefined` is provided, the function removes the current minimum pitch (i.e. sets it to 0).
     */
    setMinPitch(minPitch) {
        minPitch = minPitch === null || minPitch === undefined ? defaultMinPitch : minPitch;
        if (minPitch < defaultMinPitch) {
            throw new Error(`minPitch must be greater than or equal to ${defaultMinPitch}`);
        }
        if (minPitch >= defaultMinPitch && minPitch <= this.transform.maxPitch) {
            this.transform.minPitch = minPitch;
            this._update();
            if (this.getPitch() < minPitch)
                this.setPitch(minPitch);
            return this;
        }
        else
            throw new Error(`minPitch must be between ${defaultMinPitch} and the current maxPitch, inclusive`);
    }
    /**
     * Returns the map's minimum allowable pitch.
     *
     * @returns The minPitch
     */
    getMinPitch() { return this.transform.minPitch; }
    /**
     * Sets or clears the map's maximum pitch.
     * If the map's current pitch is higher than the new maximum,
     * the map will pitch to the new maximum.
     *
     * A {@link ErrorEvent} event will be fired if maxPitch is out of bounds.
     *
     * @param maxPitch - The maximum pitch to set (0-85). Values greater than 60 degrees are experimental and may result in rendering issues. If you encounter any, please raise an issue with details in the MapLibre project.
     * If `null` or `undefined` is provided, the function removes the current maximum pitch (sets it to 60).
     */
    setMaxPitch(maxPitch) {
        maxPitch = maxPitch === null || maxPitch === undefined ? defaultMaxPitch : maxPitch;
        if (maxPitch > maxPitchThreshold) {
            throw new Error(`maxPitch must be less than or equal to ${maxPitchThreshold}`);
        }
        if (maxPitch >= this.transform.minPitch) {
            this.transform.maxPitch = maxPitch;
            this._update();
            if (this.getPitch() > maxPitch)
                this.setPitch(maxPitch);
            return this;
        }
        else
            throw new Error('maxPitch must be greater than the current minPitch');
    }
    /**
     * Returns the map's maximum allowable pitch.
     *
     * @returns The maxPitch
     */
    getMaxPitch() { return this.transform.maxPitch; }
    /**
     * Returns the state of `renderWorldCopies`. If `true`, multiple copies of the world will be rendered side by side beyond -180 and 180 degrees longitude. If set to `false`:
     *
     * - When the map is zoomed out far enough that a single representation of the world does not fill the map's entire
     * container, there will be blank space beyond 180 and -180 degrees longitude.
     * - Features that cross 180 and -180 degrees longitude will be cut in two (with one portion on the right edge of the
     * map and the other on the left edge of the map) at every zoom level.
     * @returns The renderWorldCopies
     * @example
     * ```ts
     * let worldCopiesRendered = map.getRenderWorldCopies();
     * ```
     * @see [Render world copies](https://maplibre.org/maplibre-gl-js/docs/examples/render-world-copies/)
     */
    getRenderWorldCopies() { return this.transform.renderWorldCopies; }
    /**
     * Sets the state of `renderWorldCopies`.
     *
     * @param renderWorldCopies - If `true`, multiple copies of the world will be rendered side by side beyond -180 and 180 degrees longitude. If set to `false`:
     *
     * - When the map is zoomed out far enough that a single representation of the world does not fill the map's entire
     * container, there will be blank space beyond 180 and -180 degrees longitude.
     * - Features that cross 180 and -180 degrees longitude will be cut in two (with one portion on the right edge of the
     * map and the other on the left edge of the map) at every zoom level.
     *
     * `undefined` is treated as `true`, `null` is treated as `false`.
     * @example
     * ```ts
     * map.setRenderWorldCopies(true);
     * ```
     * @see [Render world copies](https://maplibre.org/maplibre-gl-js/docs/examples/render-world-copies/)
     */
    setRenderWorldCopies(renderWorldCopies) {
        this.transform.renderWorldCopies = renderWorldCopies;
        return this._update();
    }
    /**
     * Returns a [Point](https://github.com/mapbox/point-geometry) representing pixel coordinates, relative to the map's `container`,
     * that correspond to the specified geographical location.
     *
     * @param lnglat - The geographical location to project.
     * @returns The [Point](https://github.com/mapbox/point-geometry) corresponding to `lnglat`, relative to the map's `container`.
     * @example
     * ```ts
     * let coordinate = [-122.420679, 37.772537];
     * let point = map.project(coordinate);
     * ```
     */
    project(lnglat) {
        return this.transform.locationPoint(performance$1.N.convert(lnglat), this.style && this.terrain);
    }
    /**
     * Returns a {@link LngLat} representing geographical coordinates that correspond
     * to the specified pixel coordinates.
     *
     * @param point - The pixel coordinates to unproject.
     * @returns The {@link LngLat} corresponding to `point`.
     * @example
     * ```ts
     * map.on('click', (e) => {
     *   // When the map is clicked, get the geographic coordinate.
     *   let coordinate = map.unproject(e.point);
     * });
     * ```
     */
    unproject(point) {
        return this.transform.pointLocation(performance$1.P.convert(point), this.terrain);
    }
    /**
     * Returns true if the map is panning, zooming, rotating, or pitching due to a camera animation or user gesture.
     * @returns true if the map is moving.
     * @example
     * ```ts
     * let isMoving = map.isMoving();
     * ```
     */
    isMoving() {
        var _a;
        return this._moving || ((_a = this.handlers) === null || _a === void 0 ? void 0 : _a.isMoving());
    }
    /**
     * Returns true if the map is zooming due to a camera animation or user gesture.
     * @returns true if the map is zooming.
     * @example
     * ```ts
     * let isZooming = map.isZooming();
     * ```
     */
    isZooming() {
        var _a;
        return this._zooming || ((_a = this.handlers) === null || _a === void 0 ? void 0 : _a.isZooming());
    }
    /**
     * Returns true if the map is rotating due to a camera animation or user gesture.
     * @returns true if the map is rotating.
     * @example
     * ```ts
     * map.isRotating();
     * ```
     */
    isRotating() {
        var _a;
        return this._rotating || ((_a = this.handlers) === null || _a === void 0 ? void 0 : _a.isRotating());
    }
    _createDelegatedListener(type, layerId, listener) {
        if (type === 'mouseenter' || type === 'mouseover') {
            let mousein = false;
            const mousemove = (e) => {
                const features = this.getLayer(layerId) ? this.queryRenderedFeatures(e.point, { layers: [layerId] }) : [];
                if (!features.length) {
                    mousein = false;
                }
                else if (!mousein) {
                    mousein = true;
                    listener.call(this, new MapMouseEvent(type, this, e.originalEvent, { features }));
                }
            };
            const mouseout = () => {
                mousein = false;
            };
            return { layer: layerId, listener, delegates: { mousemove, mouseout } };
        }
        else if (type === 'mouseleave' || type === 'mouseout') {
            let mousein = false;
            const mousemove = (e) => {
                const features = this.getLayer(layerId) ? this.queryRenderedFeatures(e.point, { layers: [layerId] }) : [];
                if (features.length) {
                    mousein = true;
                }
                else if (mousein) {
                    mousein = false;
                    listener.call(this, new MapMouseEvent(type, this, e.originalEvent));
                }
            };
            const mouseout = (e) => {
                if (mousein) {
                    mousein = false;
                    listener.call(this, new MapMouseEvent(type, this, e.originalEvent));
                }
            };
            return { layer: layerId, listener, delegates: { mousemove, mouseout } };
        }
        else {
            const delegate = (e) => {
                const features = this.getLayer(layerId) ? this.queryRenderedFeatures(e.point, { layers: [layerId] }) : [];
                if (features.length) {
                    // Here we need to mutate the original event, so that preventDefault works as expected.
                    e.features = features;
                    listener.call(this, e);
                    delete e.features;
                }
            };
            return { layer: layerId, listener, delegates: { [type]: delegate } };
        }
    }
    on(type, layerIdOrListener, listener) {
        if (listener === undefined) {
            return super.on(type, layerIdOrListener);
        }
        const delegatedListener = this._createDelegatedListener(type, layerIdOrListener, listener);
        this._delegatedListeners = this._delegatedListeners || {};
        this._delegatedListeners[type] = this._delegatedListeners[type] || [];
        this._delegatedListeners[type].push(delegatedListener);
        for (const event in delegatedListener.delegates) {
            this.on(event, delegatedListener.delegates[event]);
        }
        return this;
    }
    once(type, layerIdOrListener, listener) {
        if (listener === undefined) {
            return super.once(type, layerIdOrListener);
        }
        const delegatedListener = this._createDelegatedListener(type, layerIdOrListener, listener);
        for (const event in delegatedListener.delegates) {
            this.once(event, delegatedListener.delegates[event]);
        }
        return this;
    }
    off(type, layerIdOrListener, listener) {
        if (listener === undefined) {
            return super.off(type, layerIdOrListener);
        }
        const removeDelegatedListener = (delegatedListeners) => {
            const listeners = delegatedListeners[type];
            for (let i = 0; i < listeners.length; i++) {
                const delegatedListener = listeners[i];
                if (delegatedListener.layer === layerIdOrListener && delegatedListener.listener === listener) {
                    for (const event in delegatedListener.delegates) {
                        this.off(event, delegatedListener.delegates[event]);
                    }
                    listeners.splice(i, 1);
                    return this;
                }
            }
        };
        if (this._delegatedListeners && this._delegatedListeners[type]) {
            removeDelegatedListener(this._delegatedListeners);
        }
        return this;
    }
    /**
     * Returns an array of MapGeoJSONFeature objects
     * representing visible features that satisfy the query parameters.
     *
     * @param geometryOrOptions - (optional) The geometry of the query region:
     * either a single point or southwest and northeast points describing a bounding box.
     * Omitting this parameter (i.e. calling {@link Map#queryRenderedFeatures} with zero arguments,
     * or with only a `options` argument) is equivalent to passing a bounding box encompassing the entire
     * map viewport.
     * The geometryOrOptions can receive a {@link QueryRenderedFeaturesOptions} only to support a situation where the function receives only one parameter which is the options parameter.
     * @param options - (optional) Options object.
     *
     * @returns An array of MapGeoJSONFeature objects.
     *
     * The `properties` value of each returned feature object contains the properties of its source feature. For GeoJSON sources, only
     * string and numeric property values are supported (i.e. `null`, `Array`, and `Object` values are not supported).
     *
     * Each feature includes top-level `layer`, `source`, and `sourceLayer` properties. The `layer` property is an object
     * representing the style layer to  which the feature belongs. Layout and paint properties in this object contain values
     * which are fully evaluated for the given zoom level and feature.
     *
     * Only features that are currently rendered are included. Some features will **not** be included, like:
     *
     * - Features from layers whose `visibility` property is `"none"`.
     * - Features from layers whose zoom range excludes the current zoom level.
     * - Symbol features that have been hidden due to text or icon collision.
     *
     * Features from all other layers are included, including features that may have no visible
     * contribution to the rendered result; for example, because the layer's opacity or color alpha component is set to
     * 0.
     *
     * The topmost rendered feature appears first in the returned array, and subsequent features are sorted by
     * descending z-order. Features that are rendered multiple times (due to wrapping across the antemeridian at low
     * zoom levels) are returned only once (though subject to the following caveat).
     *
     * Because features come from tiled vector data or GeoJSON data that is converted to tiles internally, feature
     * geometries may be split or duplicated across tile boundaries and, as a result, features may appear multiple
     * times in query results. For example, suppose there is a highway running through the bounding rectangle of a query.
     * The results of the query will be those parts of the highway that lie within the map tiles covering the bounding
     * rectangle, even if the highway extends into other tiles, and the portion of the highway within each map tile
     * will be returned as a separate feature. Similarly, a point feature near a tile boundary may appear in multiple
     * tiles due to tile buffering.
     *
     * @example
     * Find all features at a point
     * ```ts
     * let features = map.queryRenderedFeatures(
     *   [20, 35],
     *   { layers: ['my-layer-name'] }
     * );
     * ```
     *
     * @example
     * Find all features within a static bounding box
     * ```ts
     * let features = map.queryRenderedFeatures(
     *   [[10, 20], [30, 50]],
     *   { layers: ['my-layer-name'] }
     * );
     * ```
     *
     * @example
     * Find all features within a bounding box around a point
     * ```ts
     * let width = 10;
     * let height = 20;
     * let features = map.queryRenderedFeatures([
     *   [point.x - width / 2, point.y - height / 2],
     *   [point.x + width / 2, point.y + height / 2]
     * ], { layers: ['my-layer-name'] });
     * ```
     *
     * @example
     * Query all rendered features from a single layer
     * ```ts
     * let features = map.queryRenderedFeatures({ layers: ['my-layer-name'] });
     * ```
     * @see [Get features under the mouse pointer](https://maplibre.org/maplibre-gl-js/docs/examples/queryrenderedfeatures/)
     */
    queryRenderedFeatures(geometryOrOptions, options) {
        if (!this.style) {
            return [];
        }
        let queryGeometry;
        const isGeometry = geometryOrOptions instanceof performance$1.P || Array.isArray(geometryOrOptions);
        const geometry = isGeometry ? geometryOrOptions : [[0, 0], [this.transform.width, this.transform.height]];
        options = options || (isGeometry ? {} : geometryOrOptions) || {};
        if (geometry instanceof performance$1.P || typeof geometry[0] === 'number') {
            queryGeometry = [performance$1.P.convert(geometry)];
        }
        else {
            const tl = performance$1.P.convert(geometry[0]);
            const br = performance$1.P.convert(geometry[1]);
            queryGeometry = [tl, new performance$1.P(br.x, tl.y), br, new performance$1.P(tl.x, br.y), tl];
        }
        return this.style.queryRenderedFeatures(queryGeometry, options, this.transform);
    }
    /**
     * Returns an array of MapGeoJSONFeature objects
     * representing features within the specified vector tile or GeoJSON source that satisfy the query parameters.
     *
     * @param sourceId - The ID of the vector tile or GeoJSON source to query.
     * @param parameters - The options object.
     * @returns An array of MapGeoJSONFeature objects.
     *
     * In contrast to {@link Map#queryRenderedFeatures}, this function returns all features matching the query parameters,
     * whether or not they are rendered by the current style (i.e. visible). The domain of the query includes all currently-loaded
     * vector tiles and GeoJSON source tiles: this function does not check tiles outside the currently
     * visible viewport.
     *
     * Because features come from tiled vector data or GeoJSON data that is converted to tiles internally, feature
     * geometries may be split or duplicated across tile boundaries and, as a result, features may appear multiple
     * times in query results. For example, suppose there is a highway running through the bounding rectangle of a query.
     * The results of the query will be those parts of the highway that lie within the map tiles covering the bounding
     * rectangle, even if the highway extends into other tiles, and the portion of the highway within each map tile
     * will be returned as a separate feature. Similarly, a point feature near a tile boundary may appear in multiple
     * tiles due to tile buffering.
     *
     * @example
     * Find all features in one source layer in a vector source
     * ```ts
     * let features = map.querySourceFeatures('your-source-id', {
     *   sourceLayer: 'your-source-layer'
     * });
     * ```
     *
     */
    querySourceFeatures(sourceId, parameters) {
        return this.style.querySourceFeatures(sourceId, parameters);
    }
    /**
     * Updates the map's MapLibre style object with a new value.
     *
     * If a style is already set when this is used and options.diff is set to true, the map renderer will attempt to compare the given style
     * against the map's current state and perform only the changes necessary to make the map style match the desired state. Changes in sprites
     * (images used for icons and patterns) and glyphs (fonts for label text) **cannot** be diffed. If the sprites or fonts used in the current
     * style and the given style are different in any way, the map renderer will force a full update, removing the current style and building
     * the given one from scratch.
     *
     *
     * @param style - A JSON object conforming to the schema described in the
     * [MapLibre Style Specification](https://maplibre.org/maplibre-style-spec/), or a URL to such JSON.
     * @param options - The options object.
     *
     * @example
     * ```ts
     * map.setStyle("https://demotiles.maplibre.org/style.json");
     *
     * map.setStyle('https://demotiles.maplibre.org/style.json', {
     *   transformStyle: (previousStyle, nextStyle) => ({
     *       ...nextStyle,
     *       sources: {
     *           ...nextStyle.sources,
     *           // copy a source from previous style
     *           'osm': previousStyle.sources.osm
     *       },
     *       layers: [
     *           // background layer
     *           nextStyle.layers[0],
     *           // copy a layer from previous style
     *           previousStyle.layers[0],
     *           // other layers from the next style
     *           ...nextStyle.layers.slice(1).map(layer => {
     *               // hide the layers we don't need from demotiles style
     *               if (layer.id.startsWith('geolines')) {
     *                   layer.layout = {...layer.layout || {}, visibility: 'none'};
     *               // filter out US polygons
     *               } else if (layer.id.startsWith('coastline') || layer.id.startsWith('countries')) {
     *                   layer.filter = ['!=', ['get', 'ADM0_A3'], 'USA'];
     *               }
     *               return layer;
     *           })
     *       ]
     *   })
     * });
     * ```
     */
    setStyle(style, options) {
        options = performance$1.e({}, {
            localIdeographFontFamily: this._localIdeographFontFamily,
            validate: this._validateStyle
        }, options);
        if ((options.diff !== false && options.localIdeographFontFamily === this._localIdeographFontFamily) && this.style && style) {
            this._diffStyle(style, options);
            return this;
        }
        else {
            this._localIdeographFontFamily = options.localIdeographFontFamily;
            return this._updateStyle(style, options);
        }
    }
    /**
     *  Updates the requestManager's transform request with a new function
     *
     * @param transformRequest - A callback run before the Map makes a request for an external URL. The callback can be used to modify the url, set headers, or set the credentials property for cross-origin requests.
     * Expected to return an object with a `url` property and optionally `headers` and `credentials` properties
     *
     * @example
     * ```ts
     * map.setTransformRequest((url: string, resourceType: string) => {});
     * ```
     */
    setTransformRequest(transformRequest) {
        this._requestManager.setTransformRequest(transformRequest);
        return this;
    }
    _getUIString(key) {
        const str = this._locale[key];
        if (str == null) {
            throw new Error(`Missing UI string '${key}'`);
        }
        return str;
    }
    _updateStyle(style, options) {
        // transformStyle relies on having previous style serialized, if it is not loaded yet, delay _updateStyle until previous style is loaded
        if (options.transformStyle && this.style && !this.style._loaded) {
            this.style.once('style.load', () => this._updateStyle(style, options));
            return;
        }
        const previousStyle = this.style && options.transformStyle ? this.style.serialize() : undefined;
        if (this.style) {
            this.style.setEventedParent(null);
            // Only release workers when map is getting disposed
            this.style._remove(!style);
        }
        if (!style) {
            delete this.style;
            return this;
        }
        else {
            this.style = new Style(this, options || {});
        }
        this.style.setEventedParent(this, { style: this.style });
        if (typeof style === 'string') {
            this.style.loadURL(style, options, previousStyle);
        }
        else {
            this.style.loadJSON(style, options, previousStyle);
        }
        return this;
    }
    _lazyInitEmptyStyle() {
        if (!this.style) {
            this.style = new Style(this, {});
            this.style.setEventedParent(this, { style: this.style });
            this.style.loadEmpty();
        }
    }
    _diffStyle(style, options) {
        if (typeof style === 'string') {
            const url = style;
            const request = this._requestManager.transformRequest(url, "Style" /* ResourceType.Style */);
            performance$1.h(request, new AbortController()).then((response) => {
                this._updateDiff(response.data, options);
            }).catch((error) => {
                if (error) {
                    this.fire(new performance$1.j(error));
                }
            });
        }
        else if (typeof style === 'object') {
            this._updateDiff(style, options);
        }
    }
    _updateDiff(style, options) {
        try {
            if (this.style.setState(style, options)) {
                this._update(true);
            }
        }
        catch (e) {
            performance$1.w(`Unable to perform style diff: ${e.message || e.error || e}.  Rebuilding the style from scratch.`);
            this._updateStyle(style, options);
        }
    }
    /**
     * Returns the map's MapLibre style object, a JSON object which can be used to recreate the map's style.
     *
     * @returns The map's style JSON object.
     *
     * @example
     * ```ts
     * let styleJson = map.getStyle();
     * ```
     *
     */
    getStyle() {
        if (this.style) {
            return this.style.serialize();
        }
    }
    /**
     * Returns a Boolean indicating whether the map's style is fully loaded.
     *
     * @returns A Boolean indicating whether the style is fully loaded.
     *
     * @example
     * ```ts
     * let styleLoadStatus = map.isStyleLoaded();
     * ```
     */
    isStyleLoaded() {
        if (!this.style)
            return performance$1.w('There is no style added to the map.');
        return this.style.loaded();
    }
    /**
     * Adds a source to the map's style.
     *
     * Events triggered:
     *
     * Triggers the `source.add` event.
     *
     * @param id - The ID of the source to add. Must not conflict with existing sources.
     * @param source - The source object, conforming to the
     * MapLibre Style Specification's [source definition](https://maplibre.org/maplibre-style-spec/sources) or
     * {@link CanvasSourceSpecification}.
     * @example
     * ```ts
     * map.addSource('my-data', {
     *   type: 'vector',
     *   url: 'https://demotiles.maplibre.org/tiles/tiles.json'
     * });
     * ```
     * @example
     * ```ts
     * map.addSource('my-data', {
     *   "type": "geojson",
     *   "data": {
     *     "type": "Feature",
     *     "geometry": {
     *       "type": "Point",
     *       "coordinates": [-77.0323, 38.9131]
     *     },
     *     "properties": {
     *       "title": "Mapbox DC",
     *       "marker-symbol": "monument"
     *     }
     *   }
     * });
     * ```
     * @see GeoJSON source: [Add live realtime data](https://maplibre.org/maplibre-gl-js/docs/examples/live-geojson/)
     */
    addSource(id, source) {
        this._lazyInitEmptyStyle();
        this.style.addSource(id, source);
        return this._update(true);
    }
    /**
     * Returns a Boolean indicating whether the source is loaded. Returns `true` if the source with
     * the given ID in the map's style has no outstanding network requests, otherwise `false`.
     *
     * A {@link ErrorEvent} event will be fired if there is no source wit the specified ID.
     *
     * @param id - The ID of the source to be checked.
     * @returns A Boolean indicating whether the source is loaded.
     * @example
     * ```ts
     * let sourceLoaded = map.isSourceLoaded('bathymetry-data');
     * ```
     */
    isSourceLoaded(id) {
        const source = this.style && this.style.sourceCaches[id];
        if (source === undefined) {
            this.fire(new performance$1.j(new Error(`There is no source with ID '${id}'`)));
            return;
        }
        return source.loaded();
    }
    /**
     * Loads a 3D terrain mesh, based on a "raster-dem" source.
     *
     * Triggers the `terrain` event.
     *
     * @param options - Options object.
     * @example
     * ```ts
     * map.setTerrain({ source: 'terrain' });
     * ```
     */
    setTerrain(options) {
        this.style._checkLoaded();
        // clear event handlers
        if (this._terrainDataCallback)
            this.style.off('data', this._terrainDataCallback);
        if (!options) {
            // remove terrain
            if (this.terrain)
                this.terrain.sourceCache.destruct();
            this.terrain = null;
            if (this.painter.renderToTexture)
                this.painter.renderToTexture.destruct();
            this.painter.renderToTexture = null;
            this.transform.minElevationForCurrentTile = 0;
            this.transform.elevation = 0;
        }
        else {
            // add terrain
            const sourceCache = this.style.sourceCaches[options.source];
            if (!sourceCache)
                throw new Error(`cannot load terrain, because there exists no source with ID: ${options.source}`);
            // Update terrain tiles when adding new terrain
            if (this.terrain === null)
                sourceCache.reload();
            // Warn once if user is using the same source for hillshade and terrain
            for (const index in this.style._layers) {
                const thisLayer = this.style._layers[index];
                if (thisLayer.type === 'hillshade' && thisLayer.source === options.source) {
                    performance$1.w('You are using the same source for a hillshade layer and for 3D terrain. Please consider using two separate sources to improve rendering quality.');
                }
            }
            this.terrain = new Terrain(this.painter, sourceCache, options);
            this.painter.renderToTexture = new RenderToTexture(this.painter, this.terrain);
            this.transform.minElevationForCurrentTile = this.terrain.getMinTileElevationForLngLatZoom(this.transform.center, this.transform.tileZoom);
            this.transform.elevation = this.terrain.getElevationForLngLatZoom(this.transform.center, this.transform.tileZoom);
            this._terrainDataCallback = e => {
                if (e.dataType === 'style') {
                    this.terrain.sourceCache.freeRtt();
                }
                else if (e.dataType === 'source' && e.tile) {
                    if (e.sourceId === options.source && !this._elevationFreeze) {
                        this.transform.minElevationForCurrentTile = this.terrain.getMinTileElevationForLngLatZoom(this.transform.center, this.transform.tileZoom);
                        this.transform.elevation = this.terrain.getElevationForLngLatZoom(this.transform.center, this.transform.tileZoom);
                    }
                    this.terrain.sourceCache.freeRtt(e.tile.tileID);
                }
            };
            this.style.on('data', this._terrainDataCallback);
        }
        this.fire(new performance$1.k('terrain', { terrain: options }));
        return this;
    }
    /**
     * Get the terrain-options if terrain is loaded
     * @returns the TerrainSpecification passed to setTerrain
     * @example
     * ```ts
     * map.getTerrain(); // { source: 'terrain' };
     * ```
     */
    getTerrain() {
        var _a, _b;
        return (_b = (_a = this.terrain) === null || _a === void 0 ? void 0 : _a.options) !== null && _b !== void 0 ? _b : null;
    }
    /**
     * Returns a Boolean indicating whether all tiles in the viewport from all sources on
     * the style are loaded.
     *
     * @returns A Boolean indicating whether all tiles are loaded.
     * @example
     * ```ts
     * let tilesLoaded = map.areTilesLoaded();
     * ```
     */
    areTilesLoaded() {
        const sources = this.style && this.style.sourceCaches;
        for (const id in sources) {
            const source = sources[id];
            const tiles = source._tiles;
            for (const t in tiles) {
                const tile = tiles[t];
                if (!(tile.state === 'loaded' || tile.state === 'errored'))
                    return false;
            }
        }
        return true;
    }
    /**
     * Removes a source from the map's style.
     *
     * @param id - The ID of the source to remove.
     * @example
     * ```ts
     * map.removeSource('bathymetry-data');
     * ```
     */
    removeSource(id) {
        this.style.removeSource(id);
        return this._update(true);
    }
    /**
     * Returns the source with the specified ID in the map's style.
     *
     * This method is often used to update a source using the instance members for the relevant
     * source type as defined in classes that derive from {@link Source}.
     * For example, setting the `data` for a GeoJSON source or updating the `url` and `coordinates`
     * of an image source.
     *
     * @param id - The ID of the source to get.
     * @returns The style source with the specified ID or `undefined` if the ID
     * corresponds to no existing sources.
     * The shape of the object varies by source type.
     * A list of options for each source type is available on the MapLibre Style Specification's
     * [Sources](https://maplibre.org/maplibre-style-spec/sources/) page.
     * @example
     * ```ts
     * let sourceObject = map.getSource('points');
     * ```
     * @see [Create a draggable point](https://maplibre.org/maplibre-gl-js/docs/examples/drag-a-point/)
     * @see [Animate a point](https://maplibre.org/maplibre-gl-js/docs/examples/animate-point-along-line/)
     * @see [Add live realtime data](https://maplibre.org/maplibre-gl-js/docs/examples/live-geojson/)
     */
    getSource(id) {
        return this.style.getSource(id);
    }
    /**
     * Add an image to the style. This image can be displayed on the map like any other icon in the style's
     * sprite using the image's ID with
     * [`icon-image`](https://maplibre.org/maplibre-style-spec/layers/#layout-symbol-icon-image),
     * [`background-pattern`](https://maplibre.org/maplibre-style-spec/layers/#paint-background-background-pattern),
     * [`fill-pattern`](https://maplibre.org/maplibre-style-spec/layers/#paint-fill-fill-pattern),
     * or [`line-pattern`](https://maplibre.org/maplibre-style-spec/layers/#paint-line-line-pattern).
     *
     * A {@link ErrorEvent} event will be fired if the image parameter is invalid or there is not enough space in the sprite to add this image.
     *
     * @param id - The ID of the image.
     * @param image - The image as an `HTMLImageElement`, `ImageData`, `ImageBitmap` or object with `width`, `height`, and `data`
     * properties with the same format as `ImageData`.
     * @param options - Options object.
     * @example
     * ```ts
     * // If the style's sprite does not already contain an image with ID 'cat',
     * // add the image 'cat-icon.png' to the style's sprite with the ID 'cat'.
     * const image = await map.loadImage('https://upload.wikimedia.org/wikipedia/commons/thumb/6/60/Cat_silhouette.svg/400px-Cat_silhouette.svg.png');
     * if (!map.hasImage('cat')) map.addImage('cat', image.data);
     *
     * // Add a stretchable image that can be used with `icon-text-fit`
     * // In this example, the image is 600px wide by 400px high.
     * const image = await map.loadImage('https://upload.wikimedia.org/wikipedia/commons/8/89/Black_and_White_Boxed_%28bordered%29.png');
     * if (map.hasImage('border-image')) return;
     * map.addImage('border-image', image.data, {
     *     content: [16, 16, 300, 384], // place text over left half of image, avoiding the 16px border
     *     stretchX: [[16, 584]], // stretch everything horizontally except the 16px border
     *     stretchY: [[16, 384]], // stretch everything vertically except the 16px border
     * });
     * ```
     * @see Use `HTMLImageElement`: [Add an icon to the map](https://maplibre.org/maplibre-gl-js/docs/examples/add-image/)
     * @see Use `ImageData`: [Add a generated icon to the map](https://maplibre.org/maplibre-gl-js/docs/examples/add-image-generated/)
     */
    addImage(id, image, options = {}) {
        const { pixelRatio = 1, sdf = false, stretchX, stretchY, content, textFitWidth, textFitHeight } = options;
        this._lazyInitEmptyStyle();
        const version = 0;
        if (image instanceof HTMLImageElement || performance$1.b(image)) {
            const { width, height, data } = browser.getImageData(image);
            this.style.addImage(id, { data: new performance$1.R({ width, height }, data), pixelRatio, stretchX, stretchY, content, textFitWidth, textFitHeight, sdf, version });
        }
        else if (image.width === undefined || image.height === undefined) {
            return this.fire(new performance$1.j(new Error('Invalid arguments to map.addImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, ' +
                'or object with `width`, `height`, and `data` properties with the same format as `ImageData`')));
        }
        else {
            const { width, height, data } = image;
            const userImage = image;
            this.style.addImage(id, {
                data: new performance$1.R({ width, height }, new Uint8Array(data)),
                pixelRatio,
                stretchX,
                stretchY,
                content,
                textFitWidth,
                textFitHeight,
                sdf,
                version,
                userImage
            });
            if (userImage.onAdd) {
                userImage.onAdd(this, id);
            }
            return this;
        }
    }
    /**
     * Update an existing image in a style. This image can be displayed on the map like any other icon in the style's
     * sprite using the image's ID with
     * [`icon-image`](https://maplibre.org/maplibre-style-spec/layers/#layout-symbol-icon-image),
     * [`background-pattern`](https://maplibre.org/maplibre-style-spec/layers/#paint-background-background-pattern),
     * [`fill-pattern`](https://maplibre.org/maplibre-style-spec/layers/#paint-fill-fill-pattern),
     * or [`line-pattern`](https://maplibre.org/maplibre-style-spec/layers/#paint-line-line-pattern).
     *
     * An {@link ErrorEvent} will be fired if the image parameter is invald.
     *
     * @param id - The ID of the image.
     * @param image - The image as an `HTMLImageElement`, `ImageData`, `ImageBitmap` or object with `width`, `height`, and `data`
     * properties with the same format as `ImageData`.
     * @example
     * ```ts
     * // If an image with the ID 'cat' already exists in the style's sprite,
     * // replace that image with a new image, 'other-cat-icon.png'.
     * if (map.hasImage('cat')) map.updateImage('cat', './other-cat-icon.png');
     * ```
     */
    updateImage(id, image) {
        const existingImage = this.style.getImage(id);
        if (!existingImage) {
            return this.fire(new performance$1.j(new Error('The map has no image with that id. If you are adding a new image use `map.addImage(...)` instead.')));
        }
        const imageData = (image instanceof HTMLImageElement || performance$1.b(image)) ?
            browser.getImageData(image) :
            image;
        const { width, height, data } = imageData;
        if (width === undefined || height === undefined) {
            return this.fire(new performance$1.j(new Error('Invalid arguments to map.updateImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, ' +
                'or object with `width`, `height`, and `data` properties with the same format as `ImageData`')));
        }
        if (width !== existingImage.data.width || height !== existingImage.data.height) {
            return this.fire(new performance$1.j(new Error('The width and height of the updated image must be that same as the previous version of the image')));
        }
        const copy = !(image instanceof HTMLImageElement || performance$1.b(image));
        existingImage.data.replace(data, copy);
        this.style.updateImage(id, existingImage);
        return this;
    }
    /**
     * Returns an image, specified by ID, currently available in the map.
     * This includes both images from the style's original sprite
     * and any images that have been added at runtime using {@link Map#addImage}.
     *
     * @param id - The ID of the image.
     * @returns An image in the map with the specified ID.
     *
     * @example
     * ```ts
     * let coffeeShopIcon = map.getImage("coffee_cup");
     * ```
     */
    getImage(id) {
        return this.style.getImage(id);
    }
    /**
     * Check whether or not an image with a specific ID exists in the style. This checks both images
     * in the style's original sprite and any images
     * that have been added at runtime using {@link Map#addImage}.
     *
     * An {@link ErrorEvent} will be fired if the image parameter is invald.
     *
     * @param id - The ID of the image.
     *
     * @returns A Boolean indicating whether the image exists.
     * @example
     * Check if an image with the ID 'cat' exists in the style's sprite.
     * ```ts
     * let catIconExists = map.hasImage('cat');
     * ```
     */
    hasImage(id) {
        if (!id) {
            this.fire(new performance$1.j(new Error('Missing required image id')));
            return false;
        }
        return !!this.style.getImage(id);
    }
    /**
     * Remove an image from a style. This can be an image from the style's original
     * sprite or any images
     * that have been added at runtime using {@link Map#addImage}.
     *
     * @param id - The ID of the image.
     *
     * @example
     * ```ts
     * // If an image with the ID 'cat' exists in
     * // the style's sprite, remove it.
     * if (map.hasImage('cat')) map.removeImage('cat');
     * ```
     */
    removeImage(id) {
        this.style.removeImage(id);
    }
    /**
     * Load an image from an external URL to be used with {@link Map#addImage}. External
     * domains must support [CORS](https://developer.mozilla.org/en-US/docs/Web/HTTP/Access_control_CORS).
     *
     * @param url - The URL of the image file. Image file must be in png, webp, or jpg format.
     * @returns a promise that is resolved when the image is loaded
     *
     * @example
     * Load an image from an external URL.
     * ```ts
     * const response = await map.loadImage('https://picsum.photos/50/50');
     * // Add the loaded image to the style's sprite with the ID 'photo'.
     * map.addImage('photo', response.data);
     * ```
     * @see [Add an icon to the map](https://maplibre.org/maplibre-gl-js/docs/examples/add-image/)
     */
    loadImage(url) {
        return ImageRequest.getImage(this._requestManager.transformRequest(url, "Image" /* ResourceType.Image */), new AbortController());
    }
    /**
     * Returns an Array of strings containing the IDs of all images currently available in the map.
     * This includes both images from the style's original sprite
     * and any images that have been added at runtime using {@link Map#addImage}.
     *
     * @returns An Array of strings containing the names of all sprites/images currently available in the map.
     *
     * @example
     * ```ts
     * let allImages = map.listImages();
     * ```
     */
    listImages() {
        return this.style.listImages();
    }
    /**
     * Adds a [MapLibre style layer](https://maplibre.org/maplibre-style-spec/layers)
     * to the map's style.
     *
     * A layer defines how data from a specified source will be styled. Read more about layer types
     * and available paint and layout properties in the [MapLibre Style Specification](https://maplibre.org/maplibre-style-spec/layers).
     *
     * @param layer - The layer to add,
     * conforming to either the MapLibre Style Specification's [layer definition](https://maplibre.org/maplibre-style-spec/layers) or,
     * less commonly, the {@link CustomLayerInterface} specification. Can also be a layer definition with an embedded source definition.
     * The MapLibre Style Specification's layer definition is appropriate for most layers.
     *
     * @param beforeId - The ID of an existing layer to insert the new layer before,
     * resulting in the new layer appearing visually beneath the existing layer.
     * If this argument is not specified, the layer will be appended to the end of the layers array
     * and appear visually above all other layers.
     *
     * @example
     * Add a circle layer with a vector source
     * ```ts
     * map.addLayer({
     *   id: 'points-of-interest',
     *   source: {
     *     type: 'vector',
     *     url: 'https://demotiles.maplibre.org/tiles/tiles.json'
     *   },
     *   'source-layer': 'poi_label',
     *   type: 'circle',
     *   paint: {
     *     // MapLibre Style Specification paint properties
     *   },
     *   layout: {
     *     // MapLibre Style Specification layout properties
     *   }
     * });
     * ```
     *
     * @example
     * Define a source before using it to create a new layer
     * ```ts
     * map.addSource('state-data', {
     *   type: 'geojson',
     *   data: 'path/to/data.geojson'
     * });
     *
     * map.addLayer({
     *   id: 'states',
     *   // References the GeoJSON source defined above
     *   // and does not require a `source-layer`
     *   source: 'state-data',
     *   type: 'symbol',
     *   layout: {
     *     // Set the label content to the
     *     // feature's `name` property
     *     text-field: ['get', 'name']
     *   }
     * });
     * ```
     *
     * @example
     * Add a new symbol layer before an existing layer
     * ```ts
     * map.addLayer({
     *   id: 'states',
     *   // References a source that's already been defined
     *   source: 'state-data',
     *   type: 'symbol',
     *   layout: {
     *     // Set the label content to the
     *     // feature's `name` property
     *     text-field: ['get', 'name']
     *   }
     * // Add the layer before the existing `cities` layer
     * }, 'cities');
     * ```
     * @see [Create and style clusters](https://maplibre.org/maplibre-gl-js/docs/examples/cluster/)
     * @see [Add a vector tile source](https://maplibre.org/maplibre-gl-js/docs/examples/vector-source/)
     * @see [Add a WMS source](https://maplibre.org/maplibre-gl-js/docs/examples/wms/)
     */
    addLayer(layer, beforeId) {
        this._lazyInitEmptyStyle();
        this.style.addLayer(layer, beforeId);
        return this._update(true);
    }
    /**
     * Moves a layer to a different z-position.
     *
     * @param id - The ID of the layer to move.
     * @param beforeId - The ID of an existing layer to insert the new layer before. When viewing the map, the `id` layer will appear beneath the `beforeId` layer. If `beforeId` is omitted, the layer will be appended to the end of the layers array and appear above all other layers on the map.
     *
     * @example
     * Move a layer with ID 'polygon' before the layer with ID 'country-label'. The `polygon` layer will appear beneath the `country-label` layer on the map.
     * ```ts
     * map.moveLayer('polygon', 'country-label');
     * ```
     */
    moveLayer(id, beforeId) {
        this.style.moveLayer(id, beforeId);
        return this._update(true);
    }
    /**
     * Removes the layer with the given ID from the map's style.
     *
     * An {@link ErrorEvent} will be fired if the image parameter is invald.
     *
     * @param id - The ID of the layer to remove
     *
     * @example
     * If a layer with ID 'state-data' exists, remove it.
     * ```ts
     * if (map.getLayer('state-data')) map.removeLayer('state-data');
     * ```
     */
    removeLayer(id) {
        this.style.removeLayer(id);
        return this._update(true);
    }
    /**
     * Returns the layer with the specified ID in the map's style.
     *
     * @param id - The ID of the layer to get.
     * @returns The layer with the specified ID, or `undefined`
     * if the ID corresponds to no existing layers.
     *
     * @example
     * ```ts
     * let stateDataLayer = map.getLayer('state-data');
     * ```
     * @see [Filter symbols by toggling a list](https://maplibre.org/maplibre-gl-js/docs/examples/filter-markers/)
     * @see [Filter symbols by text input](https://maplibre.org/maplibre-gl-js/docs/examples/filter-markers-by-input/)
     */
    getLayer(id) {
        return this.style.getLayer(id);
    }
    /**
     * Return the ids of all layers currently in the style, including custom layers, in order.
     *
     * @returns ids of layers, in order
     *
     * @example
     * ```ts
     * const orderedLayerIds = map.getLayersOrder();
     * ```
     */
    getLayersOrder() {
        return this.style.getLayersOrder();
    }
    /**
     * Sets the zoom extent for the specified style layer. The zoom extent includes the
     * [minimum zoom level](https://maplibre.org/maplibre-style-spec/layers/#minzoom)
     * and [maximum zoom level](https://maplibre.org/maplibre-style-spec/layers/#maxzoom))
     * at which the layer will be rendered.
     *
     * Note: For style layers using vector sources, style layers cannot be rendered at zoom levels lower than the
     * minimum zoom level of the _source layer_ because the data does not exist at those zoom levels. If the minimum
     * zoom level of the source layer is higher than the minimum zoom level defined in the style layer, the style
     * layer will not be rendered at all zoom levels in the zoom range.
     *
     * @param layerId - The ID of the layer to which the zoom extent will be applied.
     * @param minzoom - The minimum zoom to set (0-24).
     * @param maxzoom - The maximum zoom to set (0-24).
     *
     * @example
     * ```ts
     * map.setLayerZoomRange('my-layer', 2, 5);
     * ```
     */
    setLayerZoomRange(layerId, minzoom, maxzoom) {
        this.style.setLayerZoomRange(layerId, minzoom, maxzoom);
        return this._update(true);
    }
    /**
     * Sets the filter for the specified style layer.
     *
     * Filters control which features a style layer renders from its source.
     * Any feature for which the filter expression evaluates to `true` will be
     * rendered on the map. Those that are false will be hidden.
     *
     * Use `setFilter` to show a subset of your source data.
     *
     * To clear the filter, pass `null` or `undefined` as the second parameter.
     *
     * @param layerId - The ID of the layer to which the filter will be applied.
     * @param filter - The filter, conforming to the MapLibre Style Specification's
     * [filter definition](https://maplibre.org/maplibre-style-spec/layers/#filter).  If `null` or `undefined` is provided, the function removes any existing filter from the layer.
     * @param options - Options object.
     *
     * @example
     * Display only features with the 'name' property 'USA'
     * ```ts
     * map.setFilter('my-layer', ['==', ['get', 'name'], 'USA']);
     * ```
     * @example
     * Display only features with five or more 'available-spots'
     * ```ts
     * map.setFilter('bike-docks', ['>=', ['get', 'available-spots'], 5]);
     * ```
     * @example
     * Remove the filter for the 'bike-docks' style layer
     * ```ts
     * map.setFilter('bike-docks', null);
     * ```
     * @see [Create a timeline animation](https://maplibre.org/maplibre-gl-js/docs/examples/timeline-animation/)
     */
    setFilter(layerId, filter, options = {}) {
        this.style.setFilter(layerId, filter, options);
        return this._update(true);
    }
    /**
     * Returns the filter applied to the specified style layer.
     *
     * @param layerId - The ID of the style layer whose filter to get.
     * @returns The layer's filter.
     */
    getFilter(layerId) {
        return this.style.getFilter(layerId);
    }
    /**
     * Sets the value of a paint property in the specified style layer.
     *
     * @param layerId - The ID of the layer to set the paint property in.
     * @param name - The name of the paint property to set.
     * @param value - The value of the paint property to set.
     * Must be of a type appropriate for the property, as defined in the [MapLibre Style Specification](https://maplibre.org/maplibre-style-spec/).
     * Pass `null` to unset the existing value.
     * @param options - Options object.
     * @example
     * ```ts
     * map.setPaintProperty('my-layer', 'fill-color', '#faafee');
     * ```
     * @see [Change a layer's color with buttons](https://maplibre.org/maplibre-gl-js/docs/examples/color-switcher/)
     * @see [Create a draggable point](https://maplibre.org/maplibre-gl-js/docs/examples/drag-a-point/)
     */
    setPaintProperty(layerId, name, value, options = {}) {
        this.style.setPaintProperty(layerId, name, value, options);
        return this._update(true);
    }
    /**
     * Returns the value of a paint property in the specified style layer.
     *
     * @param layerId - The ID of the layer to get the paint property from.
     * @param name - The name of a paint property to get.
     * @returns The value of the specified paint property.
     */
    getPaintProperty(layerId, name) {
        return this.style.getPaintProperty(layerId, name);
    }
    /**
     * Sets the value of a layout property in the specified style layer.
     *
     * @param layerId - The ID of the layer to set the layout property in.
     * @param name - The name of the layout property to set.
     * @param value - The value of the layout property. Must be of a type appropriate for the property, as defined in the [MapLibre Style Specification](https://maplibre.org/maplibre-style-spec/).
     * @param options - The options object.
     * @example
     * ```ts
     * map.setLayoutProperty('my-layer', 'visibility', 'none');
     * ```
     */
    setLayoutProperty(layerId, name, value, options = {}) {
        this.style.setLayoutProperty(layerId, name, value, options);
        return this._update(true);
    }
    /**
     * Returns the value of a layout property in the specified style layer.
     *
     * @param layerId - The ID of the layer to get the layout property from.
     * @param name - The name of the layout property to get.
     * @returns The value of the specified layout property.
     */
    getLayoutProperty(layerId, name) {
        return this.style.getLayoutProperty(layerId, name);
    }
    /**
     * Sets the value of the style's glyphs property.
     *
     * @param glyphsUrl - Glyph URL to set. Must conform to the [MapLibre Style Specification](https://maplibre.org/maplibre-style-spec/glyphs/).
     * @param options - Options object.
     * @example
     * ```ts
     * map.setGlyphs('https://demotiles.maplibre.org/font/{fontstack}/{range}.pbf');
     * ```
     */
    setGlyphs(glyphsUrl, options = {}) {
        this._lazyInitEmptyStyle();
        this.style.setGlyphs(glyphsUrl, options);
        return this._update(true);
    }
    /**
     * Returns the value of the style's glyphs URL
     *
     * @returns glyphs Style's glyphs url
     */
    getGlyphs() {
        return this.style.getGlyphsUrl();
    }
    /**
     * Adds a sprite to the map's style. Fires the `style` event.
     *
     * @param id - The ID of the sprite to add. Must not conflict with existing sprites.
     * @param url - The URL to load the sprite from
     * @param options - Options object.
     * @example
     * ```ts
     * map.addSprite('sprite-two', 'http://example.com/sprite-two');
     * ```
     */
    addSprite(id, url, options = {}) {
        this._lazyInitEmptyStyle();
        this.style.addSprite(id, url, options, (err) => {
            if (!err) {
                this._update(true);
            }
        });
        return this;
    }
    /**
     * Removes the sprite from the map's style. Fires the `style` event.
     *
     * @param id - The ID of the sprite to remove. If the sprite is declared as a single URL, the ID must be "default".
     * @example
     * ```ts
     * map.removeSprite('sprite-two');
     * map.removeSprite('default');
     * ```
     */
    removeSprite(id) {
        this._lazyInitEmptyStyle();
        this.style.removeSprite(id);
        return this._update(true);
    }
    /**
     * Returns the as-is value of the style's sprite.
     *
     * @returns style's sprite list of id-url pairs
     */
    getSprite() {
        return this.style.getSprite();
    }
    /**
     * Sets the value of the style's sprite property.
     *
     * @param spriteUrl - Sprite URL to set.
     * @param options - Options object.
     * @example
     * ```ts
     * map.setSprite('YOUR_SPRITE_URL');
     * ```
     */
    setSprite(spriteUrl, options = {}) {
        this._lazyInitEmptyStyle();
        this.style.setSprite(spriteUrl, options, (err) => {
            if (!err) {
                this._update(true);
            }
        });
        return this;
    }
    /**
     * Sets the any combination of light values.
     *
     * @param light - Light properties to set. Must conform to the [MapLibre Style Specification](https://maplibre.org/maplibre-style-spec/light).
     * @param options - Options object.
     *
     * @example
     * ```ts
     * let layerVisibility = map.getLayoutProperty('my-layer', 'visibility');
     * ```
     */
    setLight(light, options = {}) {
        this._lazyInitEmptyStyle();
        this.style.setLight(light, options);
        return this._update(true);
    }
    /**
     * Returns the value of the light object.
     *
     * @returns light Light properties of the style.
     */
    getLight() {
        return this.style.getLight();
    }
    /**
     * Loads sky and fog defined by {@link SkySpecification} onto the map.
     * Note: The fog only shows when using the terrain 3D feature.
     * @param sky - Sky properties to set. Must conform to the [MapLibre Style Specification](https://maplibre.org/maplibre-gl-js-docs/style-spec/#sky).
     * @returns `this`
     * @example
     * ```ts
     * map.setSky({ 'sky-color': '#00f' });
     * ```
     */
    setSky(sky) {
        this._lazyInitEmptyStyle();
        this.style.setSky(sky);
        return this._update(true);
    }
    /**
     * Returns the value of the sky object.
     *
     * @returns sky Sky properties of the style.
     */
    getSky() {
        return this.style.getSky();
    }
    /**
     * Sets the `state` of a feature.
     * A feature's `state` is a set of user-defined key-value pairs that are assigned to a feature at runtime.
     * When using this method, the `state` object is merged with any existing key-value pairs in the feature's state.
     * Features are identified by their `feature.id` attribute, which can be any number or string.
     *
     * This method can only be used with sources that have a `feature.id` attribute. The `feature.id` attribute can be defined in three ways:
     *
     * - For vector or GeoJSON sources, including an `id` attribute in the original data file.
     * - For vector or GeoJSON sources, using the [`promoteId`](https://maplibre.org/maplibre-style-spec/sources/#vector-promoteId) option at the time the source is defined.
     * - For GeoJSON sources, using the [`generateId`](https://maplibre.org/maplibre-style-spec/sources/#geojson-generateId) option to auto-assign an `id` based on the feature's index in the source data. If you change feature data using `map.getSource('some id').setData(..)`, you may need to re-apply state taking into account updated `id` values.
     *
     * _Note: You can use the [`feature-state` expression](https://maplibre.org/maplibre-style-spec/expressions/#feature-state) to access the values in a feature's state object for the purposes of styling._
     *
     * @param feature - Feature identifier. Feature objects returned from
     * {@link Map#queryRenderedFeatures} or event handlers can be used as feature identifiers.
     * @param state - A set of key-value pairs. The values should be valid JSON types.
     *
     * @example
     * ```ts
     * // When the mouse moves over the `my-layer` layer, update
     * // the feature state for the feature under the mouse
     * map.on('mousemove', 'my-layer', (e) => {
     *   if (e.features.length > 0) {
     *     map.setFeatureState({
     *       source: 'my-source',
     *       sourceLayer: 'my-source-layer',
     *       id: e.features[0].id,
     *     }, {
     *       hover: true
     *     });
     *   }
     * });
     * ```
     * @see [Create a hover effect](https://maplibre.org/maplibre-gl-js/docs/examples/hover-styles/)
     */
    setFeatureState(feature, state) {
        this.style.setFeatureState(feature, state);
        return this._update();
    }
    /**
     * Removes the `state` of a feature, setting it back to the default behavior.
     * If only a `target.source` is specified, it will remove the state for all features from that source.
     * If `target.id` is also specified, it will remove all keys for that feature's state.
     * If `key` is also specified, it removes only that key from that feature's state.
     * Features are identified by their `feature.id` attribute, which can be any number or string.
     *
     * @param target - Identifier of where to remove state. It can be a source, a feature, or a specific key of feature.
     * Feature objects returned from {@link Map#queryRenderedFeatures} or event handlers can be used as feature identifiers.
     * @param key - (optional) The key in the feature state to reset.
     * @example
     * Reset the entire state object for all features in the `my-source` source
     * ```ts
     * map.removeFeatureState({
     *   source: 'my-source'
     * });
     * ```
     *
     * @example
     * When the mouse leaves the `my-layer` layer,
     * reset the entire state object for the
     * feature under the mouse
     * ```ts
     * map.on('mouseleave', 'my-layer', (e) => {
     *   map.removeFeatureState({
     *     source: 'my-source',
     *     sourceLayer: 'my-source-layer',
     *     id: e.features[0].id
     *   });
     * });
     * ```
     *
     * @example
     * When the mouse leaves the `my-layer` layer,
     * reset only the `hover` key-value pair in the
     * state for the feature under the mouse
     * ```ts
     * map.on('mouseleave', 'my-layer', (e) => {
     *   map.removeFeatureState({
     *     source: 'my-source',
     *     sourceLayer: 'my-source-layer',
     *     id: e.features[0].id
     *   }, 'hover');
     * });
     * ```
     */
    removeFeatureState(target, key) {
        this.style.removeFeatureState(target, key);
        return this._update();
    }
    /**
     * Gets the `state` of a feature.
     * A feature's `state` is a set of user-defined key-value pairs that are assigned to a feature at runtime.
     * Features are identified by their `feature.id` attribute, which can be any number or string.
     *
     * _Note: To access the values in a feature's state object for the purposes of styling the feature, use the [`feature-state` expression](https://maplibre.org/maplibre-style-spec/expressions/#feature-state)._
     *
     * @param feature - Feature identifier. Feature objects returned from
     * {@link Map#queryRenderedFeatures} or event handlers can be used as feature identifiers.
     * @returns The state of the feature: a set of key-value pairs that was assigned to the feature at runtime.
     *
     * @example
     * When the mouse moves over the `my-layer` layer,
     * get the feature state for the feature under the mouse
     * ```ts
     * map.on('mousemove', 'my-layer', (e) => {
     *   if (e.features.length > 0) {
     *     map.getFeatureState({
     *       source: 'my-source',
     *       sourceLayer: 'my-source-layer',
     *       id: e.features[0].id
     *     });
     *   }
     * });
     * ```
     */
    getFeatureState(feature) {
        return this.style.getFeatureState(feature);
    }
    /**
     * Returns the map's containing HTML element.
     *
     * @returns The map's container.
     */
    getContainer() {
        return this._container;
    }
    /**
     * Returns the HTML element containing the map's `<canvas>` element.
     *
     * If you want to add non-GL overlays to the map, you should append them to this element.
     *
     * This is the element to which event bindings for map interactivity (such as panning and zooming) are
     * attached. It will receive bubbled events from child elements such as the `<canvas>`, but not from
     * map controls.
     *
     * @returns The container of the map's `<canvas>`.
     * @see [Create a draggable point](https://maplibre.org/maplibre-gl-js/docs/examples/drag-a-point/)
     */
    getCanvasContainer() {
        return this._canvasContainer;
    }
    /**
     * Returns the map's `<canvas>` element.
     *
     * @returns The map's `<canvas>` element.
     * @see [Measure distances](https://maplibre.org/maplibre-gl-js/docs/examples/measure/)
     * @see [Display a popup on hover](https://maplibre.org/maplibre-gl-js/docs/examples/popup-on-hover/)
     * @see [Center the map on a clicked symbol](https://maplibre.org/maplibre-gl-js/docs/examples/center-on-symbol/)
     */
    getCanvas() {
        return this._canvas;
    }
    _containerDimensions() {
        let width = 0;
        let height = 0;
        if (this._container) {
            width = this._container.clientWidth || 400;
            height = this._container.clientHeight || 300;
        }
        return [width, height];
    }
    _setupContainer() {
        const container = this._container;
        container.classList.add('maplibregl-map');
        const canvasContainer = this._canvasContainer = DOM.create('div', 'maplibregl-canvas-container', container);
        if (this._interactive) {
            canvasContainer.classList.add('maplibregl-interactive');
        }
        this._canvas = DOM.create('canvas', 'maplibregl-canvas', canvasContainer);
        this._canvas.addEventListener('webglcontextlost', this._contextLost, false);
        this._canvas.addEventListener('webglcontextrestored', this._contextRestored, false);
        this._canvas.setAttribute('tabindex', this._interactive ? '0' : '-1');
        this._canvas.setAttribute('aria-label', this._getUIString('Map.Title'));
        this._canvas.setAttribute('role', 'region');
        const dimensions = this._containerDimensions();
        const clampedPixelRatio = this._getClampedPixelRatio(dimensions[0], dimensions[1]);
        this._resizeCanvas(dimensions[0], dimensions[1], clampedPixelRatio);
        const controlContainer = this._controlContainer = DOM.create('div', 'maplibregl-control-container', container);
        const positions = this._controlPositions = {};
        ['top-left', 'top-right', 'bottom-left', 'bottom-right'].forEach((positionName) => {
            positions[positionName] = DOM.create('div', `maplibregl-ctrl-${positionName} `, controlContainer);
        });
        this._container.addEventListener('scroll', this._onMapScroll, false);
    }
    _resizeCanvas(width, height, pixelRatio) {
        // Request the required canvas size taking the pixelratio into account.
        this._canvas.width = Math.floor(pixelRatio * width);
        this._canvas.height = Math.floor(pixelRatio * height);
        // Maintain the same canvas size, potentially downscaling it for HiDPI displays
        this._canvas.style.width = `${width}px`;
        this._canvas.style.height = `${height}px`;
    }
    _setupPainter() {
        const attributes = {
            alpha: true,
            stencil: true,
            depth: true,
            failIfMajorPerformanceCaveat: this._failIfMajorPerformanceCaveat,
            preserveDrawingBuffer: this._preserveDrawingBuffer,
            antialias: this._antialias || false
        };
        let webglcontextcreationerrorDetailObject = null;
        this._canvas.addEventListener('webglcontextcreationerror', (args) => {
            webglcontextcreationerrorDetailObject = { requestedAttributes: attributes };
            if (args) {
                webglcontextcreationerrorDetailObject.statusMessage = args.statusMessage;
                webglcontextcreationerrorDetailObject.type = args.type;
            }
        }, { once: true });
        const gl = this._canvas.getContext('webgl2', attributes) ||
            this._canvas.getContext('webgl', attributes);
        if (!gl) {
            const msg = 'Failed to initialize WebGL';
            if (webglcontextcreationerrorDetailObject) {
                webglcontextcreationerrorDetailObject.message = msg;
                throw new Error(JSON.stringify(webglcontextcreationerrorDetailObject));
            }
            else {
                throw new Error(msg);
            }
        }
        this.painter = new Painter(gl, this.transform);
        webpSupported.testSupport(gl);
    }
    /**
     * Returns a Boolean indicating whether the map is fully loaded.
     *
     * Returns `false` if the style is not yet fully loaded,
     * or if there has been a change to the sources or style that
     * has not yet fully loaded.
     *
     * @returns A Boolean indicating whether the map is fully loaded.
     */
    loaded() {
        return !this._styleDirty && !this._sourcesDirty && !!this.style && this.style.loaded();
    }
    /**
     * @internal
     * Update this map's style and sources, and re-render the map.
     *
     * @param updateStyle - mark the map's style for reprocessing as
     * well as its sources
     */
    _update(updateStyle) {
        if (!this.style || !this.style._loaded)
            return this;
        this._styleDirty = this._styleDirty || updateStyle;
        this._sourcesDirty = true;
        this.triggerRepaint();
        return this;
    }
    /**
     * @internal
     * Request that the given callback be executed during the next render
     * frame.  Schedule a render frame if one is not already scheduled.
     *
     * @returns An id that can be used to cancel the callback
     */
    _requestRenderFrame(callback) {
        this._update();
        return this._renderTaskQueue.add(callback);
    }
    _cancelRenderFrame(id) {
        this._renderTaskQueue.remove(id);
    }
    /**
     * @internal
     * Call when a (re-)render of the map is required:
     *
     * - The style has changed (`setPaintProperty()`, etc.)
     * - Source data has changed (e.g. tiles have finished loading)
     * - The map has is moving (or just finished moving)
     * - A transition is in progress
     *
     * @param paintStartTimeStamp - The time when the animation frame began executing.
     */
    _render(paintStartTimeStamp) {
        const fadeDuration = this._idleTriggered ? this._fadeDuration : 0;
        // A custom layer may have used the context asynchronously. Mark the state as dirty.
        this.painter.context.setDirty();
        this.painter.setBaseState();
        this._renderTaskQueue.run(paintStartTimeStamp);
        // A task queue callback may have fired a user event which may have removed the map
        if (this._removed)
            return;
        let crossFading = false;
        // If the style has changed, the map is being zoomed, or a transition or fade is in progress:
        //  - Apply style changes (in a batch)
        //  - Recalculate paint properties.
        if (this.style && this._styleDirty) {
            this._styleDirty = false;
            const zoom = this.transform.zoom;
            const now = browser.now();
            this.style.zoomHistory.update(zoom, now);
            const parameters = new performance$1.a9(zoom, {
                now,
                fadeDuration,
                zoomHistory: this.style.zoomHistory,
                transition: this.style.getTransition()
            });
            const factor = parameters.crossFadingFactor();
            if (factor !== 1 || factor !== this._crossFadingFactor) {
                crossFading = true;
                this._crossFadingFactor = factor;
            }
            this.style.update(parameters);
        }
        // If we are in _render for any reason other than an in-progress paint
        // transition, update source caches to check for and load any tiles we
        // need for the current transform
        if (this.style && this._sourcesDirty) {
            this._sourcesDirty = false;
            this.style._updateSources(this.transform);
        }
        // update terrain stuff
        if (this.terrain) {
            this.terrain.sourceCache.update(this.transform, this.terrain);
            this.transform.minElevationForCurrentTile = this.terrain.getMinTileElevationForLngLatZoom(this.transform.center, this.transform.tileZoom);
            if (!this._elevationFreeze) {
                this.transform.elevation = this.terrain.getElevationForLngLatZoom(this.transform.center, this.transform.tileZoom);
            }
        }
        else {
            this.transform.minElevationForCurrentTile = 0;
            this.transform.elevation = 0;
        }
        this._placementDirty = this.style && this.style._updatePlacement(this.painter.transform, this.showCollisionBoxes, fadeDuration, this._crossSourceCollisions);
        // Actually draw
        this.painter.render(this.style, {
            showTileBoundaries: this.showTileBoundaries,
            showOverdrawInspector: this._showOverdrawInspector,
            rotating: this.isRotating(),
            zooming: this.isZooming(),
            moving: this.isMoving(),
            fadeDuration,
            showPadding: this.showPadding,
        });
        this.fire(new performance$1.k('render'));
        if (this.loaded() && !this._loaded) {
            this._loaded = true;
            performance$1.be.mark(performance$1.bf.load);
            this.fire(new performance$1.k('load'));
        }
        if (this.style && (this.style.hasTransitions() || crossFading)) {
            this._styleDirty = true;
        }
        if (this.style && !this._placementDirty) {
            // Since no fade operations are in progress, we can release
            // all tiles held for fading. If we didn't do this, the tiles
            // would just sit in the SourceCaches until the next render
            this.style._releaseSymbolFadeTiles();
        }
        // Schedule another render frame if it's needed.
        //
        // Even though `_styleDirty` and `_sourcesDirty` are reset in this
        // method, synchronous events fired during Style#update or
        // Style#_updateSources could have caused them to be set again.
        const somethingDirty = this._sourcesDirty || this._styleDirty || this._placementDirty;
        if (somethingDirty || this._repaint) {
            this.triggerRepaint();
        }
        else if (!this.isMoving() && this.loaded()) {
            this.fire(new performance$1.k('idle'));
        }
        if (this._loaded && !this._fullyLoaded && !somethingDirty) {
            this._fullyLoaded = true;
            performance$1.be.mark(performance$1.bf.fullLoad);
        }
        return this;
    }
    /**
     * Force a synchronous redraw of the map.
     * @example
     * ```ts
     * map.redraw();
     * ```
     */
    redraw() {
        if (this.style) {
            // cancel the scheduled update
            if (this._frameRequest) {
                this._frameRequest.abort();
                this._frameRequest = null;
            }
            this._render(0);
        }
        return this;
    }
    /**
     * Clean up and release all internal resources associated with this map.
     *
     * This includes DOM elements, event bindings, web workers, and WebGL resources.
     *
     * Use this method when you are done using the map and wish to ensure that it no
     * longer consumes browser resources. Afterwards, you must not call any other
     * methods on the map.
     */
    remove() {
        var _a;
        if (this._hash)
            this._hash.remove();
        for (const control of this._controls)
            control.onRemove(this);
        this._controls = [];
        if (this._frameRequest) {
            this._frameRequest.abort();
            this._frameRequest = null;
        }
        this._renderTaskQueue.clear();
        this.painter.destroy();
        this.handlers.destroy();
        delete this.handlers;
        this.setStyle(null);
        if (typeof window !== 'undefined') {
            removeEventListener('online', this._onWindowOnline, false);
        }
        ImageRequest.removeThrottleControl(this._imageQueueHandle);
        (_a = this._resizeObserver) === null || _a === void 0 ? void 0 : _a.disconnect();
        const extension = this.painter.context.gl.getExtension('WEBGL_lose_context');
        if (extension === null || extension === void 0 ? void 0 : extension.loseContext)
            extension.loseContext();
        this._canvas.removeEventListener('webglcontextrestored', this._contextRestored, false);
        this._canvas.removeEventListener('webglcontextlost', this._contextLost, false);
        DOM.remove(this._canvasContainer);
        DOM.remove(this._controlContainer);
        this._container.classList.remove('maplibregl-map');
        performance$1.be.clearMetrics();
        this._removed = true;
        this.fire(new performance$1.k('remove'));
    }
    /**
     * Trigger the rendering of a single frame. Use this method with custom layers to
     * repaint the map when the layer changes. Calling this multiple times before the
     * next frame is rendered will still result in only a single frame being rendered.
     * @example
     * ```ts
     * map.triggerRepaint();
     * ```
     * @see [Add a 3D model](https://maplibre.org/maplibre-gl-js/docs/examples/add-3d-model/)
     * @see [Add an animated icon to the map](https://maplibre.org/maplibre-gl-js/docs/examples/add-image-animated/)
     */
    triggerRepaint() {
        if (this.style && !this._frameRequest) {
            this._frameRequest = new AbortController();
            browser.frameAsync(this._frameRequest).then((paintStartTimeStamp) => {
                performance$1.be.frame(paintStartTimeStamp);
                this._frameRequest = null;
                this._render(paintStartTimeStamp);
            }).catch(() => { }); // ignore abort error
        }
    }
    /**
     * Gets and sets a Boolean indicating whether the map will render an outline
     * around each tile and the tile ID. These tile boundaries are useful for
     * debugging.
     *
     * The uncompressed file size of the first vector source is drawn in the top left
     * corner of each tile, next to the tile ID.
     *
     * @example
     * ```ts
     * map.showTileBoundaries = true;
     * ```
     */
    get showTileBoundaries() { return !!this._showTileBoundaries; }
    set showTileBoundaries(value) {
        if (this._showTileBoundaries === value)
            return;
        this._showTileBoundaries = value;
        this._update();
    }
    /**
     * Gets and sets a Boolean indicating whether the map will visualize
     * the padding offsets.
     */
    get showPadding() { return !!this._showPadding; }
    set showPadding(value) {
        if (this._showPadding === value)
            return;
        this._showPadding = value;
        this._update();
    }
    /**
     * Gets and sets a Boolean indicating whether the map will render boxes
     * around all symbols in the data source, revealing which symbols
     * were rendered or which were hidden due to collisions.
     * This information is useful for debugging.
     */
    get showCollisionBoxes() { return !!this._showCollisionBoxes; }
    set showCollisionBoxes(value) {
        if (this._showCollisionBoxes === value)
            return;
        this._showCollisionBoxes = value;
        if (value) {
            // When we turn collision boxes on we have to generate them for existing tiles
            // When we turn them off, there's no cost to leaving existing boxes in place
            this.style._generateCollisionBoxes();
        }
        else {
            // Otherwise, call an update to remove collision boxes
            this._update();
        }
    }
    /**
     * Gets and sets a Boolean indicating whether the map should color-code
     * each fragment to show how many times it has been shaded.
     * White fragments have been shaded 8 or more times.
     * Black fragments have been shaded 0 times.
     * This information is useful for debugging.
     */
    get showOverdrawInspector() { return !!this._showOverdrawInspector; }
    set showOverdrawInspector(value) {
        if (this._showOverdrawInspector === value)
            return;
        this._showOverdrawInspector = value;
        this._update();
    }
    /**
     * Gets and sets a Boolean indicating whether the map will
     * continuously repaint. This information is useful for analyzing performance.
     */
    get repaint() { return !!this._repaint; }
    set repaint(value) {
        if (this._repaint !== value) {
            this._repaint = value;
            this.triggerRepaint();
        }
    }
    // show vertices
    get vertices() { return !!this._vertices; }
    set vertices(value) { this._vertices = value; this._update(); }
    /**
     * Returns the package version of the library
     * @returns Package version of the library
     */
    get version() {
        return version$1;
    }
    /**
     * Returns the elevation for the point where the camera is looking.
     * This value corresponds to:
     * "meters above sea level" * "exaggeration"
     * @returns The elevation.
     */
    getCameraTargetElevation() {
        return this.transform.elevation;
    }
};

const assignEvents = (handler) => {
    handler.touchstart = handler.dragStart;
    handler.touchmoveWindow = handler.dragMove;
    handler.touchend = handler.dragEnd;
};
const generateOneFingerTouchRotationHandler = ({ enable, clickTolerance, bearingDegreesPerPixelMoved = 0.8 }) => {
    const touchMoveStateManager = new OneFingerTouchMoveStateManager();
    return new DragHandler({
        clickTolerance,
        move: (lastPoint, point) => ({ bearingDelta: (point.x - lastPoint.x) * bearingDegreesPerPixelMoved }),
        moveStateManager: touchMoveStateManager,
        enable,
        assignEvents,
    });
};
const generateOneFingerTouchPitchHandler = ({ enable, clickTolerance, pitchDegreesPerPixelMoved = -0.5 }) => {
    const touchMoveStateManager = new OneFingerTouchMoveStateManager();
    return new DragHandler({
        clickTolerance,
        move: (lastPoint, point) => ({ pitchDelta: (point.y - lastPoint.y) * pitchDegreesPerPixelMoved }),
        moveStateManager: touchMoveStateManager,
        enable,
        assignEvents,
    });
};

const defaultOptions$3 = {
    showCompass: true,
    showZoom: true,
    visualizePitch: false
};
/**
 * A `NavigationControl` control contains zoom buttons and a compass.
 *
 * @group Markers and Controls
 *
 * @example
 * ```ts
 * let nav = new NavigationControl();
 * map.addControl(nav, 'top-left');
 * ```
 * @see [Display map navigation controls](https://maplibre.org/maplibre-gl-js/docs/examples/navigation/)
 */
class NavigationControl {
    /**
     * @param options - the control's options
     */
    constructor(options) {
        this._updateZoomButtons = () => {
            const zoom = this._map.getZoom();
            const isMax = zoom === this._map.getMaxZoom();
            const isMin = zoom === this._map.getMinZoom();
            this._zoomInButton.disabled = isMax;
            this._zoomOutButton.disabled = isMin;
            this._zoomInButton.setAttribute('aria-disabled', isMax.toString());
            this._zoomOutButton.setAttribute('aria-disabled', isMin.toString());
        };
        this._rotateCompassArrow = () => {
            const rotate = this.options.visualizePitch ?
                `scale(${1 / Math.pow(Math.cos(this._map.transform.pitch * (Math.PI / 180)), 0.5)}) rotateX(${this._map.transform.pitch}deg) rotateZ(${this._map.transform.angle * (180 / Math.PI)}deg)` :
                `rotate(${this._map.transform.angle * (180 / Math.PI)}deg)`;
            this._compassIcon.style.transform = rotate;
        };
        this._setButtonTitle = (button, title) => {
            const str = this._map._getUIString(`NavigationControl.${title}`);
            button.title = str;
            button.setAttribute('aria-label', str);
        };
        this.options = performance$1.e({}, defaultOptions$3, options);
        this._container = DOM.create('div', 'maplibregl-ctrl maplibregl-ctrl-group');
        this._container.addEventListener('contextmenu', (e) => e.preventDefault());
        if (this.options.showZoom) {
            this._zoomInButton = this._createButton('maplibregl-ctrl-zoom-in', (e) => this._map.zoomIn({}, { originalEvent: e }));
            DOM.create('span', 'maplibregl-ctrl-icon', this._zoomInButton).setAttribute('aria-hidden', 'true');
            this._zoomOutButton = this._createButton('maplibregl-ctrl-zoom-out', (e) => this._map.zoomOut({}, { originalEvent: e }));
            DOM.create('span', 'maplibregl-ctrl-icon', this._zoomOutButton).setAttribute('aria-hidden', 'true');
        }
        if (this.options.showCompass) {
            this._compass = this._createButton('maplibregl-ctrl-compass', (e) => {
                if (this.options.visualizePitch) {
                    this._map.resetNorthPitch({}, { originalEvent: e });
                }
                else {
                    this._map.resetNorth({}, { originalEvent: e });
                }
            });
            this._compassIcon = DOM.create('span', 'maplibregl-ctrl-icon', this._compass);
            this._compassIcon.setAttribute('aria-hidden', 'true');
        }
    }
    /** {@inheritDoc IControl.onAdd} */
    onAdd(map) {
        this._map = map;
        if (this.options.showZoom) {
            this._setButtonTitle(this._zoomInButton, 'ZoomIn');
            this._setButtonTitle(this._zoomOutButton, 'ZoomOut');
            this._map.on('zoom', this._updateZoomButtons);
            this._updateZoomButtons();
        }
        if (this.options.showCompass) {
            this._setButtonTitle(this._compass, 'ResetBearing');
            if (this.options.visualizePitch) {
                this._map.on('pitch', this._rotateCompassArrow);
            }
            this._map.on('rotate', this._rotateCompassArrow);
            this._rotateCompassArrow();
            this._handler = new MouseRotateWrapper(this._map, this._compass, this.options.visualizePitch);
        }
        return this._container;
    }
    /** {@inheritDoc IControl.onRemove} */
    onRemove() {
        DOM.remove(this._container);
        if (this.options.showZoom) {
            this._map.off('zoom', this._updateZoomButtons);
        }
        if (this.options.showCompass) {
            if (this.options.visualizePitch) {
                this._map.off('pitch', this._rotateCompassArrow);
            }
            this._map.off('rotate', this._rotateCompassArrow);
            this._handler.off();
            delete this._handler;
        }
        delete this._map;
    }
    _createButton(className, fn) {
        const a = DOM.create('button', className, this._container);
        a.type = 'button';
        a.addEventListener('click', fn);
        return a;
    }
}
class MouseRotateWrapper {
    constructor(map, element, pitch = false) {
        this.mousedown = (e) => {
            this.startMouse(performance$1.e({}, e, { ctrlKey: true, preventDefault: () => e.preventDefault() }), DOM.mousePos(this.element, e));
            DOM.addEventListener(window, 'mousemove', this.mousemove);
            DOM.addEventListener(window, 'mouseup', this.mouseup);
        };
        this.mousemove = (e) => {
            this.moveMouse(e, DOM.mousePos(this.element, e));
        };
        this.mouseup = (e) => {
            this.mouseRotate.dragEnd(e);
            if (this.mousePitch)
                this.mousePitch.dragEnd(e);
            this.offTemp();
        };
        this.touchstart = (e) => {
            if (e.targetTouches.length !== 1) {
                this.reset();
            }
            else {
                this._startPos = this._lastPos = DOM.touchPos(this.element, e.targetTouches)[0];
                this.startTouch(e, this._startPos);
                DOM.addEventListener(window, 'touchmove', this.touchmove, { passive: false });
                DOM.addEventListener(window, 'touchend', this.touchend);
            }
        };
        this.touchmove = (e) => {
            if (e.targetTouches.length !== 1) {
                this.reset();
            }
            else {
                this._lastPos = DOM.touchPos(this.element, e.targetTouches)[0];
                this.moveTouch(e, this._lastPos);
            }
        };
        this.touchend = (e) => {
            if (e.targetTouches.length === 0 &&
                this._startPos &&
                this._lastPos &&
                this._startPos.dist(this._lastPos) < this._clickTolerance) {
                this.element.click();
            }
            delete this._startPos;
            delete this._lastPos;
            this.offTemp();
        };
        this.reset = () => {
            this.mouseRotate.reset();
            if (this.mousePitch)
                this.mousePitch.reset();
            this.touchRotate.reset();
            if (this.touchPitch)
                this.touchPitch.reset();
            delete this._startPos;
            delete this._lastPos;
            this.offTemp();
        };
        this._clickTolerance = 10;
        const mapRotateTolerance = map.dragRotate._mouseRotate.getClickTolerance();
        const mapPitchTolerance = map.dragRotate._mousePitch.getClickTolerance();
        this.element = element;
        this.mouseRotate = generateMouseRotationHandler({ clickTolerance: mapRotateTolerance, enable: true });
        this.touchRotate = generateOneFingerTouchRotationHandler({ clickTolerance: mapRotateTolerance, enable: true });
        this.map = map;
        if (pitch) {
            this.mousePitch = generateMousePitchHandler({ clickTolerance: mapPitchTolerance, enable: true });
            this.touchPitch = generateOneFingerTouchPitchHandler({ clickTolerance: mapPitchTolerance, enable: true });
        }
        DOM.addEventListener(element, 'mousedown', this.mousedown);
        DOM.addEventListener(element, 'touchstart', this.touchstart, { passive: false });
        DOM.addEventListener(element, 'touchcancel', this.reset);
    }
    startMouse(e, point) {
        this.mouseRotate.dragStart(e, point);
        if (this.mousePitch)
            this.mousePitch.dragStart(e, point);
        DOM.disableDrag();
    }
    startTouch(e, point) {
        this.touchRotate.dragStart(e, point);
        if (this.touchPitch)
            this.touchPitch.dragStart(e, point);
        DOM.disableDrag();
    }
    moveMouse(e, point) {
        const map = this.map;
        const { bearingDelta } = this.mouseRotate.dragMove(e, point) || {};
        if (bearingDelta)
            map.setBearing(map.getBearing() + bearingDelta);
        if (this.mousePitch) {
            const { pitchDelta } = this.mousePitch.dragMove(e, point) || {};
            if (pitchDelta)
                map.setPitch(map.getPitch() + pitchDelta);
        }
    }
    moveTouch(e, point) {
        const map = this.map;
        const { bearingDelta } = this.touchRotate.dragMove(e, point) || {};
        if (bearingDelta)
            map.setBearing(map.getBearing() + bearingDelta);
        if (this.touchPitch) {
            const { pitchDelta } = this.touchPitch.dragMove(e, point) || {};
            if (pitchDelta)
                map.setPitch(map.getPitch() + pitchDelta);
        }
    }
    off() {
        const element = this.element;
        DOM.removeEventListener(element, 'mousedown', this.mousedown);
        DOM.removeEventListener(element, 'touchstart', this.touchstart, { passive: false });
        DOM.removeEventListener(window, 'touchmove', this.touchmove, { passive: false });
        DOM.removeEventListener(window, 'touchend', this.touchend);
        DOM.removeEventListener(element, 'touchcancel', this.reset);
        this.offTemp();
    }
    offTemp() {
        DOM.enableDrag();
        DOM.removeEventListener(window, 'mousemove', this.mousemove);
        DOM.removeEventListener(window, 'mouseup', this.mouseup);
        DOM.removeEventListener(window, 'touchmove', this.touchmove, { passive: false });
        DOM.removeEventListener(window, 'touchend', this.touchend);
    }
}

let supportsGeolocation;
function checkGeolocationSupport() {
    return performance$1._(this, arguments, void 0, function* (forceRecalculation = false) {
        if (supportsGeolocation !== undefined && !forceRecalculation) {
            return supportsGeolocation;
        }
        if (window.navigator.permissions === undefined) {
            supportsGeolocation = !!window.navigator.geolocation;
            return supportsGeolocation;
        }
        // navigator.permissions has incomplete browser support
        // https://caniuse.com/#feat=permissions-api
        // Test for the case where a browser disables Geolocation because of an
        // insecure origin
        try {
            const permissions = yield window.navigator.permissions.query({ name: 'geolocation' });
            supportsGeolocation = permissions.state !== 'denied'; // eslint-disable-line require-atomic-updates
        }
        catch (_a) {
            // Fix for iOS16 which rejects query but still supports geolocation
            supportsGeolocation = !!window.navigator.geolocation; // eslint-disable-line require-atomic-updates
        }
        return supportsGeolocation;
    });
}

/**
 * Given a LngLat, prior projected position, and a transform, return a new LngLat shifted
 * n × 360° east or west for some n ≥ 0 such that:
 *
 * * the projected location of the result is on screen, if possible, and secondarily:
 * * the difference between the projected location of the result and the prior position
 *   is minimized.
 *
 * The object is to preserve perceived object constancy for Popups and Markers as much as
 * possible; they should avoid shifting large distances across the screen, even when the
 * map center changes by ±360° due to automatic wrapping, and when about to go off screen,
 * should wrap just enough to avoid doing so.
 */
function smartWrap(lngLat, priorPos, transform) {
    const originalLngLat = new performance$1.N(lngLat.lng, lngLat.lat);
    lngLat = new performance$1.N(lngLat.lng, lngLat.lat);
    // First, try shifting one world in either direction, and see if either is closer to the
    // prior position. This preserves object constancy when the map center is auto-wrapped
    // during animations.
    if (priorPos) {
        const left = new performance$1.N(lngLat.lng - 360, lngLat.lat);
        const right = new performance$1.N(lngLat.lng + 360, lngLat.lat);
        const delta = transform.locationPoint(lngLat).distSqr(priorPos);
        if (transform.locationPoint(left).distSqr(priorPos) < delta) {
            lngLat = left;
        }
        else if (transform.locationPoint(right).distSqr(priorPos) < delta) {
            lngLat = right;
        }
    }
    // Second, wrap toward the center until the new position is on screen, or we can't get
    // any closer.
    while (Math.abs(lngLat.lng - transform.center.lng) > 180) {
        const pos = transform.locationPoint(lngLat);
        if (pos.x >= 0 && pos.y >= 0 && pos.x <= transform.width && pos.y <= transform.height) {
            break;
        }
        if (lngLat.lng > transform.center.lng) {
            lngLat.lng -= 360;
        }
        else {
            lngLat.lng += 360;
        }
    }
    // Apply the change only if new coord is below horizon
    if (lngLat.lng !== originalLngLat.lng &&
        transform.locationPoint(lngLat).y > (transform.height / 2 - transform.getHorizon())) {
        return lngLat;
    }
    return originalLngLat;
}

const anchorTranslate = {
    'center': 'translate(-50%,-50%)',
    'top': 'translate(-50%,0)',
    'top-left': 'translate(0,0)',
    'top-right': 'translate(-100%,0)',
    'bottom': 'translate(-50%,-100%)',
    'bottom-left': 'translate(0,-100%)',
    'bottom-right': 'translate(-100%,-100%)',
    'left': 'translate(0,-50%)',
    'right': 'translate(-100%,-50%)'
};
function applyAnchorClass(element, anchor, prefix) {
    const classList = element.classList;
    for (const key in anchorTranslate) {
        classList.remove(`maplibregl-${prefix}-anchor-${key}`);
    }
    classList.add(`maplibregl-${prefix}-anchor-${anchor}`);
}

/**
 * Creates a marker component
 *
 * @group Markers and Controls
 *
 * @example
 * ```ts
 * let marker = new Marker()
 *   .setLngLat([30.5, 50.5])
 *   .addTo(map);
 * ```
 *
 * @example
 * Set options
 * ```ts
 * let marker = new Marker({
 *     color: "#FFFFFF",
 *     draggable: true
 *   }).setLngLat([30.5, 50.5])
 *   .addTo(map);
 * ```
 * @see [Add custom icons with Markers](https://maplibre.org/maplibre-gl-js/docs/examples/custom-marker-icons/)
 * @see [Create a draggable Marker](https://maplibre.org/maplibre-gl-js/docs/examples/drag-a-marker/)
 *
 * ## Events
 *
 * **Event** `dragstart` of type {@link Event} will be fired when dragging starts.
 *
 * **Event** `drag` of type {@link Event} will be fired while dragging.
 *
 * **Event** `dragend` of type {@link Event} will be fired when the marker is finished being dragged.
 */
class Marker extends performance$1.E {
    /**
     * @param options - the options
     */
    constructor(options) {
        super();
        this._onKeyPress = (e) => {
            const code = e.code;
            const legacyCode = e.charCode || e.keyCode;
            if ((code === 'Space') || (code === 'Enter') ||
                (legacyCode === 32) || (legacyCode === 13) // space or enter
            ) {
                this.togglePopup();
            }
        };
        this._onMapClick = (e) => {
            const targetElement = e.originalEvent.target;
            const element = this._element;
            if (this._popup && (targetElement === element || element.contains(targetElement))) {
                this.togglePopup();
            }
        };
        this._update = (e) => {
            var _a;
            if (!this._map)
                return;
            const isFullyLoaded = this._map.loaded() && !this._map.isMoving();
            if ((e === null || e === void 0 ? void 0 : e.type) === 'terrain' || ((e === null || e === void 0 ? void 0 : e.type) === 'render' && !isFullyLoaded)) {
                this._map.once('render', this._update);
            }
            if (this._map.transform.renderWorldCopies) {
                this._lngLat = smartWrap(this._lngLat, this._flatPos, this._map.transform);
            }
            else {
                this._lngLat = (_a = this._lngLat) === null || _a === void 0 ? void 0 : _a.wrap();
            }
            this._flatPos = this._pos = this._map.project(this._lngLat)._add(this._offset);
            if (this._map.terrain) {
                // flat position is saved because smartWrap needs non-elevated points
                this._flatPos = this._map.transform.locationPoint(this._lngLat)._add(this._offset);
            }
            let rotation = '';
            if (this._rotationAlignment === 'viewport' || this._rotationAlignment === 'auto') {
                rotation = `rotateZ(${this._rotation}deg)`;
            }
            else if (this._rotationAlignment === 'map') {
                rotation = `rotateZ(${this._rotation - this._map.getBearing()}deg)`;
            }
            let pitch = '';
            if (this._pitchAlignment === 'viewport' || this._pitchAlignment === 'auto') {
                pitch = 'rotateX(0deg)';
            }
            else if (this._pitchAlignment === 'map') {
                pitch = `rotateX(${this._map.getPitch()}deg)`;
            }
            // because rounding the coordinates at every `move` event causes stuttered zooming
            // we only round them when _update is called with `moveend` or when its called with
            // no arguments (when the Marker is initialized or Marker#setLngLat is invoked).
            if (!this._subpixelPositioning && (!e || e.type === 'moveend')) {
                this._pos = this._pos.round();
            }
            DOM.setTransform(this._element, `${anchorTranslate[this._anchor]} translate(${this._pos.x}px, ${this._pos.y}px) ${pitch} ${rotation}`);
            browser.frameAsync(new AbortController()).then(() => {
                this._updateOpacity(e && e.type === 'moveend');
            }).catch(() => { });
        };
        this._onMove = (e) => {
            if (!this._isDragging) {
                const clickTolerance = this._clickTolerance || this._map._clickTolerance;
                this._isDragging = e.point.dist(this._pointerdownPos) >= clickTolerance;
            }
            if (!this._isDragging)
                return;
            this._pos = e.point.sub(this._positionDelta);
            this._lngLat = this._map.unproject(this._pos);
            this.setLngLat(this._lngLat);
            // suppress click event so that popups don't toggle on drag
            this._element.style.pointerEvents = 'none';
            // make sure dragstart only fires on the first move event after mousedown.
            // this can't be on mousedown because that event doesn't necessarily
            // imply that a drag is about to happen.
            if (this._state === 'pending') {
                this._state = 'active';
                this.fire(new performance$1.k('dragstart'));
            }
            this.fire(new performance$1.k('drag'));
        };
        this._onUp = () => {
            // revert to normal pointer event handling
            this._element.style.pointerEvents = 'auto';
            this._positionDelta = null;
            this._pointerdownPos = null;
            this._isDragging = false;
            this._map.off('mousemove', this._onMove);
            this._map.off('touchmove', this._onMove);
            // only fire dragend if it was preceded by at least one drag event
            if (this._state === 'active') {
                this.fire(new performance$1.k('dragend'));
            }
            this._state = 'inactive';
        };
        this._addDragHandler = (e) => {
            if (this._element.contains(e.originalEvent.target)) {
                e.preventDefault();
                // We need to calculate the pixel distance between the click point
                // and the marker position, with the offset accounted for. Then we
                // can subtract this distance from the mousemove event's position
                // to calculate the new marker position.
                // If we don't do this, the marker 'jumps' to the click position
                // creating a jarring UX effect.
                this._positionDelta = e.point.sub(this._pos).add(this._offset);
                this._pointerdownPos = e.point;
                this._state = 'pending';
                this._map.on('mousemove', this._onMove);
                this._map.on('touchmove', this._onMove);
                this._map.once('mouseup', this._onUp);
                this._map.once('touchend', this._onUp);
            }
        };
        this._anchor = options && options.anchor || 'center';
        this._color = options && options.color || '#3FB1CE';
        this._scale = options && options.scale || 1;
        this._draggable = options && options.draggable || false;
        this._clickTolerance = options && options.clickTolerance || 0;
        this._subpixelPositioning = options && options.subpixelPositioning || false;
        this._isDragging = false;
        this._state = 'inactive';
        this._rotation = options && options.rotation || 0;
        this._rotationAlignment = options && options.rotationAlignment || 'auto';
        this._pitchAlignment = options && options.pitchAlignment && options.pitchAlignment !== 'auto' ? options.pitchAlignment : this._rotationAlignment;
        this.setOpacity(); // set default opacity
        this.setOpacity(options === null || options === void 0 ? void 0 : options.opacity, options === null || options === void 0 ? void 0 : options.opacityWhenCovered);
        if (!options || !options.element) {
            this._defaultMarker = true;
            this._element = DOM.create('div');
            // create default map marker SVG
            const svg = DOM.createNS('http://www.w3.org/2000/svg', 'svg');
            const defaultHeight = 41;
            const defaultWidth = 27;
            svg.setAttributeNS(null, 'display', 'block');
            svg.setAttributeNS(null, 'height', `${defaultHeight}px`);
            svg.setAttributeNS(null, 'width', `${defaultWidth}px`);
            svg.setAttributeNS(null, 'viewBox', `0 0 ${defaultWidth} ${defaultHeight}`);
            const markerLarge = DOM.createNS('http://www.w3.org/2000/svg', 'g');
            markerLarge.setAttributeNS(null, 'stroke', 'none');
            markerLarge.setAttributeNS(null, 'stroke-width', '1');
            markerLarge.setAttributeNS(null, 'fill', 'none');
            markerLarge.setAttributeNS(null, 'fill-rule', 'evenodd');
            const page1 = DOM.createNS('http://www.w3.org/2000/svg', 'g');
            page1.setAttributeNS(null, 'fill-rule', 'nonzero');
            const shadow = DOM.createNS('http://www.w3.org/2000/svg', 'g');
            shadow.setAttributeNS(null, 'transform', 'translate(3.0, 29.0)');
            shadow.setAttributeNS(null, 'fill', '#000000');
            const ellipses = [
                { 'rx': '10.5', 'ry': '5.25002273' },
                { 'rx': '10.5', 'ry': '5.25002273' },
                { 'rx': '9.5', 'ry': '4.77275007' },
                { 'rx': '8.5', 'ry': '4.29549936' },
                { 'rx': '7.5', 'ry': '3.81822308' },
                { 'rx': '6.5', 'ry': '3.34094679' },
                { 'rx': '5.5', 'ry': '2.86367051' },
                { 'rx': '4.5', 'ry': '2.38636864' }
            ];
            for (const data of ellipses) {
                const ellipse = DOM.createNS('http://www.w3.org/2000/svg', 'ellipse');
                ellipse.setAttributeNS(null, 'opacity', '0.04');
                ellipse.setAttributeNS(null, 'cx', '10.5');
                ellipse.setAttributeNS(null, 'cy', '5.80029008');
                ellipse.setAttributeNS(null, 'rx', data['rx']);
                ellipse.setAttributeNS(null, 'ry', data['ry']);
                shadow.appendChild(ellipse);
            }
            const background = DOM.createNS('http://www.w3.org/2000/svg', 'g');
            background.setAttributeNS(null, 'fill', this._color);
            const bgPath = DOM.createNS('http://www.w3.org/2000/svg', 'path');
            bgPath.setAttributeNS(null, 'd', 'M27,13.5 C27,19.074644 20.250001,27.000002 14.75,34.500002 C14.016665,35.500004 12.983335,35.500004 12.25,34.500002 C6.7499993,27.000002 0,19.222562 0,13.5 C0,6.0441559 6.0441559,0 13.5,0 C20.955844,0 27,6.0441559 27,13.5 Z');
            background.appendChild(bgPath);
            const border = DOM.createNS('http://www.w3.org/2000/svg', 'g');
            border.setAttributeNS(null, 'opacity', '0.25');
            border.setAttributeNS(null, 'fill', '#000000');
            const borderPath = DOM.createNS('http://www.w3.org/2000/svg', 'path');
            borderPath.setAttributeNS(null, 'd', 'M13.5,0 C6.0441559,0 0,6.0441559 0,13.5 C0,19.222562 6.7499993,27 12.25,34.5 C13,35.522727 14.016664,35.500004 14.75,34.5 C20.250001,27 27,19.074644 27,13.5 C27,6.0441559 20.955844,0 13.5,0 Z M13.5,1 C20.415404,1 26,6.584596 26,13.5 C26,15.898657 24.495584,19.181431 22.220703,22.738281 C19.945823,26.295132 16.705119,30.142167 13.943359,33.908203 C13.743445,34.180814 13.612715,34.322738 13.5,34.441406 C13.387285,34.322738 13.256555,34.180814 13.056641,33.908203 C10.284481,30.127985 7.4148684,26.314159 5.015625,22.773438 C2.6163816,19.232715 1,15.953538 1,13.5 C1,6.584596 6.584596,1 13.5,1 Z');
            border.appendChild(borderPath);
            const maki = DOM.createNS('http://www.w3.org/2000/svg', 'g');
            maki.setAttributeNS(null, 'transform', 'translate(6.0, 7.0)');
            maki.setAttributeNS(null, 'fill', '#FFFFFF');
            const circleContainer = DOM.createNS('http://www.w3.org/2000/svg', 'g');
            circleContainer.setAttributeNS(null, 'transform', 'translate(8.0, 8.0)');
            const circle1 = DOM.createNS('http://www.w3.org/2000/svg', 'circle');
            circle1.setAttributeNS(null, 'fill', '#000000');
            circle1.setAttributeNS(null, 'opacity', '0.25');
            circle1.setAttributeNS(null, 'cx', '5.5');
            circle1.setAttributeNS(null, 'cy', '5.5');
            circle1.setAttributeNS(null, 'r', '5.4999962');
            const circle2 = DOM.createNS('http://www.w3.org/2000/svg', 'circle');
            circle2.setAttributeNS(null, 'fill', '#FFFFFF');
            circle2.setAttributeNS(null, 'cx', '5.5');
            circle2.setAttributeNS(null, 'cy', '5.5');
            circle2.setAttributeNS(null, 'r', '5.4999962');
            circleContainer.appendChild(circle1);
            circleContainer.appendChild(circle2);
            page1.appendChild(shadow);
            page1.appendChild(background);
            page1.appendChild(border);
            page1.appendChild(maki);
            page1.appendChild(circleContainer);
            svg.appendChild(page1);
            svg.setAttributeNS(null, 'height', `${defaultHeight * this._scale}px`);
            svg.setAttributeNS(null, 'width', `${defaultWidth * this._scale}px`);
            this._element.appendChild(svg);
            // if no element and no offset option given apply an offset for the default marker
            // the -14 as the y value of the default marker offset was determined as follows
            //
            // the marker tip is at the center of the shadow ellipse from the default svg
            // the y value of the center of the shadow ellipse relative to the svg top left is "shadow transform translate-y (29.0) + ellipse cy (5.80029008)"
            // offset to the svg center "height (41 / 2)" gives (29.0 + 5.80029008) - (41 / 2) and rounded for an integer pixel offset gives 14
            // negative is used to move the marker up from the center so the tip is at the Marker lngLat
            this._offset = performance$1.P.convert(options && options.offset || [0, -14]);
        }
        else {
            this._element = options.element;
            this._offset = performance$1.P.convert(options && options.offset || [0, 0]);
        }
        this._element.classList.add('maplibregl-marker');
        this._element.addEventListener('dragstart', (e) => {
            e.preventDefault();
        });
        this._element.addEventListener('mousedown', (e) => {
            // prevent focusing on click
            e.preventDefault();
        });
        applyAnchorClass(this._element, this._anchor, 'marker');
        if (options && options.className) {
            for (const name of options.className.split(' ')) {
                this._element.classList.add(name);
            }
        }
        this._popup = null;
    }
    /**
     * Attaches the `Marker` to a `Map` object.
     * @param map - The MapLibre GL JS map to add the marker to.
     * @example
     * ```ts
     * let marker = new Marker()
     *   .setLngLat([30.5, 50.5])
     *   .addTo(map); // add the marker to the map
     * ```
     */
    addTo(map) {
        this.remove();
        this._map = map;
        this._element.setAttribute('aria-label', map._getUIString('Marker.Title'));
        map.getCanvasContainer().appendChild(this._element);
        map.on('move', this._update);
        map.on('moveend', this._update);
        map.on('terrain', this._update);
        this.setDraggable(this._draggable);
        this._update();
        // If we attached the `click` listener to the marker element, the popup
        // would close once the event propagated to `map` due to the
        // `Popup#_onClickClose` listener.
        this._map.on('click', this._onMapClick);
        return this;
    }
    /**
     * Removes the marker from a map
     * @example
     * ```ts
     * let marker = new Marker().addTo(map);
     * marker.remove();
     * ```
     */
    remove() {
        if (this._opacityTimeout) {
            clearTimeout(this._opacityTimeout);
            delete this._opacityTimeout;
        }
        if (this._map) {
            this._map.off('click', this._onMapClick);
            this._map.off('move', this._update);
            this._map.off('moveend', this._update);
            this._map.off('terrain', this._update);
            this._map.off('mousedown', this._addDragHandler);
            this._map.off('touchstart', this._addDragHandler);
            this._map.off('mouseup', this._onUp);
            this._map.off('touchend', this._onUp);
            this._map.off('mousemove', this._onMove);
            this._map.off('touchmove', this._onMove);
            delete this._map;
        }
        DOM.remove(this._element);
        if (this._popup)
            this._popup.remove();
        return this;
    }
    /**
     * Get the marker's geographical location.
     *
     * The longitude of the result may differ by a multiple of 360 degrees from the longitude previously
     * set by `setLngLat` because `Marker` wraps the anchor longitude across copies of the world to keep
     * the marker on screen.
     *
     * @returns A {@link LngLat} describing the marker's location.
     * @example
     * ```ts
     * // Store the marker's longitude and latitude coordinates in a variable
     * let lngLat = marker.getLngLat();
     * // Print the marker's longitude and latitude values in the console
     * console.log('Longitude: ' + lngLat.lng + ', Latitude: ' + lngLat.lat )
     * ```
     * @see [Create a draggable Marker](https://maplibre.org/maplibre-gl-js/docs/examples/drag-a-marker/)
     */
    getLngLat() {
        return this._lngLat;
    }
    /**
     * Set the marker's geographical position and move it.
     * @param lnglat - A {@link LngLat} describing where the marker should be located.
     * @example
     * Create a new marker, set the longitude and latitude, and add it to the map
     * ```ts
     * new Marker()
     *   .setLngLat([-65.017, -16.457])
     *   .addTo(map);
     * ```
     * @see [Add custom icons with Markers](https://maplibre.org/maplibre-gl-js/docs/examples/custom-marker-icons/)
     * @see [Create a draggable Marker](https://maplibre.org/maplibre-gl-js/docs/examples/drag-a-marker/)
     */
    setLngLat(lnglat) {
        this._lngLat = performance$1.N.convert(lnglat);
        this._pos = null;
        if (this._popup)
            this._popup.setLngLat(this._lngLat);
        this._update();
        return this;
    }
    /**
     * Returns the `Marker`'s HTML element.
     * @returns element
     */
    getElement() {
        return this._element;
    }
    /**
     * Binds a {@link Popup} to the {@link Marker}.
     * @param popup - An instance of the {@link Popup} class. If undefined or null, any popup
     * set on this {@link Marker} instance is unset.
     * @example
     * ```ts
     * let marker = new Marker()
     *  .setLngLat([0, 0])
     *  .setPopup(new Popup().setHTML("<h1>Hello World!</h1>")) // add popup
     *  .addTo(map);
     * ```
     * @see [Attach a popup to a marker instance](https://maplibre.org/maplibre-gl-js/docs/examples/set-popup/)
     */
    setPopup(popup) {
        if (this._popup) {
            this._popup.remove();
            this._popup = null;
            this._element.removeEventListener('keypress', this._onKeyPress);
            if (!this._originalTabIndex) {
                this._element.removeAttribute('tabindex');
            }
        }
        if (popup) {
            if (!('offset' in popup.options)) {
                const markerHeight = 41 - (5.8 / 2);
                const markerRadius = 13.5;
                const linearOffset = Math.abs(markerRadius) / Math.SQRT2;
                popup.options.offset = this._defaultMarker ? {
                    'top': [0, 0],
                    'top-left': [0, 0],
                    'top-right': [0, 0],
                    'bottom': [0, -markerHeight],
                    'bottom-left': [linearOffset, (markerHeight - markerRadius + linearOffset) * -1],
                    'bottom-right': [-linearOffset, (markerHeight - markerRadius + linearOffset) * -1],
                    'left': [markerRadius, (markerHeight - markerRadius) * -1],
                    'right': [-markerRadius, (markerHeight - markerRadius) * -1]
                } : this._offset;
            }
            this._popup = popup;
            this._originalTabIndex = this._element.getAttribute('tabindex');
            if (!this._originalTabIndex) {
                this._element.setAttribute('tabindex', '0');
            }
            this._element.addEventListener('keypress', this._onKeyPress);
        }
        return this;
    }
    /**
      * Set the option to allow subpixel positioning of the marker by passing a boolean
      *
      * @param value - when set to `true`, subpixel positioning is enabled for the marker.
      *
      * @example
      * ```ts
      * let marker = new Marker()
      * marker.setSubpixelPositioning(true);
      * ```
      */
    setSubpixelPositioning(value) {
        this._subpixelPositioning = value;
        return this;
    }
    /**
     * Returns the {@link Popup} instance that is bound to the {@link Marker}.
     * @returns popup
     * @example
     * ```ts
     * let marker = new Marker()
     *  .setLngLat([0, 0])
     *  .setPopup(new Popup().setHTML("<h1>Hello World!</h1>"))
     *  .addTo(map);
     *
     * console.log(marker.getPopup()); // return the popup instance
     * ```
     */
    getPopup() {
        return this._popup;
    }
    /**
     * Opens or closes the {@link Popup} instance that is bound to the {@link Marker}, depending on the current state of the {@link Popup}.
     * @example
     * ```ts
     * let marker = new Marker()
     *  .setLngLat([0, 0])
     *  .setPopup(new Popup().setHTML("<h1>Hello World!</h1>"))
     *  .addTo(map);
     *
     * marker.togglePopup(); // toggle popup open or closed
     * ```
     */
    togglePopup() {
        const popup = this._popup;
        if (this._element.style.opacity === this._opacityWhenCovered)
            return this;
        if (!popup)
            return this;
        else if (popup.isOpen())
            popup.remove();
        else {
            popup.setLngLat(this._lngLat);
            popup.addTo(this._map);
        }
        return this;
    }
    _updateOpacity(force = false) {
        var _a, _b;
        const terrain = (_a = this._map) === null || _a === void 0 ? void 0 : _a.terrain;
        if (!terrain) {
            if (this._element.style.opacity !== this._opacity) {
                this._element.style.opacity = this._opacity;
            }
            return;
        }
        if (force) {
            this._opacityTimeout = null;
        }
        else {
            if (this._opacityTimeout) {
                return;
            }
            this._opacityTimeout = setTimeout(() => {
                this._opacityTimeout = null;
            }, 100);
        }
        const map = this._map;
        // Read depth framebuffer, getting position of terrain in line of sight to marker
        const terrainDistance = map.terrain.depthAtPoint(this._pos);
        // Transform marker position to clip space
        const elevation = map.terrain.getElevationForLngLatZoom(this._lngLat, map.transform.tileZoom);
        const markerDistance = map.transform.lngLatToCameraDepth(this._lngLat, elevation);
        const forgiveness = .006;
        if (markerDistance - terrainDistance < forgiveness) {
            this._element.style.opacity = this._opacity;
            return;
        }
        // If the base is obscured, use the offset to check if the marker's center is obscured.
        const metersToCenter = -this._offset.y / map.transform._pixelPerMeter;
        const elevationToCenter = Math.sin(map.getPitch() * Math.PI / 180) * metersToCenter;
        const terrainDistanceCenter = map.terrain.depthAtPoint(new performance$1.P(this._pos.x, this._pos.y - this._offset.y));
        const markerDistanceCenter = map.transform.lngLatToCameraDepth(this._lngLat, elevation + elevationToCenter);
        // Display at full opacity if center is visible.
        const centerIsInvisible = markerDistanceCenter - terrainDistanceCenter > forgiveness;
        if (((_b = this._popup) === null || _b === void 0 ? void 0 : _b.isOpen()) && centerIsInvisible)
            this._popup.remove();
        this._element.style.opacity = centerIsInvisible ? this._opacityWhenCovered : this._opacity;
    }
    /**
     * Get the marker's offset.
     * @returns The marker's screen coordinates in pixels.
     */
    getOffset() {
        return this._offset;
    }
    /**
     * Sets the offset of the marker
     * @param offset - The offset in pixels as a {@link PointLike} object to apply relative to the element's center. Negatives indicate left and up.
     */
    setOffset(offset) {
        this._offset = performance$1.P.convert(offset);
        this._update();
        return this;
    }
    /**
     * Adds a CSS class to the marker element.
     *
     * @param className - on-empty string with CSS class name to add to marker element
     *
     * @example
     * ```
     * let marker = new Marker()
     * marker.addClassName('some-class')
     * ```
     */
    addClassName(className) {
        this._element.classList.add(className);
    }
    /**
     * Removes a CSS class from the marker element.
     *
     * @param className - Non-empty string with CSS class name to remove from marker element
     *
     * @example
     * ```ts
     * let marker = new Marker()
     * marker.removeClassName('some-class')
     * ```
     */
    removeClassName(className) {
        this._element.classList.remove(className);
    }
    /**
     * Add or remove the given CSS class on the marker element, depending on whether the element currently has that class.
     *
     * @param className - Non-empty string with CSS class name to add/remove
     *
     * @returns if the class was removed return false, if class was added, then return true
     *
     * @example
     * ```ts
     * let marker = new Marker()
     * marker.toggleClassName('toggleClass')
     * ```
     */
    toggleClassName(className) {
        return this._element.classList.toggle(className);
    }
    /**
     * Sets the `draggable` property and functionality of the marker
     * @param shouldBeDraggable - Turns drag functionality on/off
     */
    setDraggable(shouldBeDraggable) {
        this._draggable = !!shouldBeDraggable; // convert possible undefined value to false
        // handle case where map may not exist yet
        // e.g. when setDraggable is called before addTo
        if (this._map) {
            if (shouldBeDraggable) {
                this._map.on('mousedown', this._addDragHandler);
                this._map.on('touchstart', this._addDragHandler);
            }
            else {
                this._map.off('mousedown', this._addDragHandler);
                this._map.off('touchstart', this._addDragHandler);
            }
        }
        return this;
    }
    /**
     * Returns true if the marker can be dragged
     * @returns True if the marker is draggable.
     */
    isDraggable() {
        return this._draggable;
    }
    /**
     * Sets the `rotation` property of the marker.
     * @param rotation - The rotation angle of the marker (clockwise, in degrees), relative to its respective {@link Marker#setRotationAlignment} setting.
     */
    setRotation(rotation) {
        this._rotation = rotation || 0;
        this._update();
        return this;
    }
    /**
     * Returns the current rotation angle of the marker (in degrees).
     * @returns The current rotation angle of the marker.
     */
    getRotation() {
        return this._rotation;
    }
    /**
     * Sets the `rotationAlignment` property of the marker.
     * @param alignment - Sets the `rotationAlignment` property of the marker. defaults to 'auto'
     */
    setRotationAlignment(alignment) {
        this._rotationAlignment = alignment || 'auto';
        this._update();
        return this;
    }
    /**
     * Returns the current `rotationAlignment` property of the marker.
     * @returns The current rotational alignment of the marker.
     */
    getRotationAlignment() {
        return this._rotationAlignment;
    }
    /**
     * Sets the `pitchAlignment` property of the marker.
     * @param alignment - Sets the `pitchAlignment` property of the marker. If alignment is 'auto', it will automatically match `rotationAlignment`.
     */
    setPitchAlignment(alignment) {
        this._pitchAlignment = alignment && alignment !== 'auto' ? alignment : this._rotationAlignment;
        this._update();
        return this;
    }
    /**
     * Returns the current `pitchAlignment` property of the marker.
     * @returns The current pitch alignment of the marker in degrees.
     */
    getPitchAlignment() {
        return this._pitchAlignment;
    }
    /**
     * Sets the `opacity` and `opacityWhenCovered` properties of the marker.
     * When called without arguments, resets opacity and opacityWhenCovered to defaults
     * @param opacity - Sets the `opacity` property of the marker.
     * @param opacityWhenCovered - Sets the `opacityWhenCovered` property of the marker.
     */
    setOpacity(opacity, opacityWhenCovered) {
        if (opacity === undefined && opacityWhenCovered === undefined) {
            this._opacity = '1';
            this._opacityWhenCovered = '0.2';
        }
        if (opacity !== undefined) {
            this._opacity = opacity;
        }
        if (opacityWhenCovered !== undefined) {
            this._opacityWhenCovered = opacityWhenCovered;
        }
        if (this._map) {
            this._updateOpacity(true);
        }
        return this;
    }
}

const defaultOptions$2 = {
    positionOptions: {
        enableHighAccuracy: false,
        maximumAge: 0,
        timeout: 6000 /* 6 sec */
    },
    fitBoundsOptions: {
        maxZoom: 15
    },
    trackUserLocation: false,
    showAccuracyCircle: true,
    showUserLocation: true
};
let numberOfWatches = 0;
let noTimeout = false;
/**
 * A `GeolocateControl` control provides a button that uses the browser's geolocation
 * API to locate the user on the map.
 *
 * Not all browsers support geolocation,
 * and some users may disable the feature. Geolocation support for modern
 * browsers including Chrome requires sites to be served over HTTPS. If
 * geolocation support is not available, the `GeolocateControl` will show
 * as disabled.
 *
 * The zoom level applied will depend on the accuracy of the geolocation provided by the device.
 *
 * The `GeolocateControl` has two modes. If `trackUserLocation` is `false` (default) the control acts as a button, which when pressed will set the map's camera to target the user location. If the user moves, the map won't update. This is most suited for the desktop. If `trackUserLocation` is `true` the control acts as a toggle button that when active the user's location is actively monitored for changes. In this mode the `GeolocateControl` has three interaction states:
 * * active - the map's camera automatically updates as the user's location changes, keeping the location dot in the center. Initial state and upon clicking the `GeolocateControl` button.
 * * passive - the user's location dot automatically updates, but the map's camera does not. Occurs upon the user initiating a map movement.
 * * disabled - occurs if Geolocation is not available, disabled or denied.
 *
 * These interaction states can't be controlled programmatically, rather they are set based on user interactions.
 *
 * ## State Diagram
 * ![GeolocateControl state diagram](https://github.com/maplibre/maplibre-gl-js/assets/3269297/78e720e5-d781-4da8-9803-a7a0e6aaaa9f)
 *
 * @group Markers and Controls
 *
 * @example
 * ```ts
 * map.addControl(new GeolocateControl({
 *     positionOptions: {
 *         enableHighAccuracy: true
 *     },
 *     trackUserLocation: true
 * }));
 * ```
 * @see [Locate the user](https://maplibre.org/maplibre-gl-js/docs/examples/locate-user/)
 *
 * ## Events
 *
 * **Event** `trackuserlocationend` of type {@link Event} will be fired when the `GeolocateControl` changes to the background state, which happens when a user changes the camera during an active position lock. This only applies when `trackUserLocation` is `true`. In the background state, the dot on the map will update with location updates but the camera will not.
 *
 * **Event** `trackuserlocationstart` of type {@link Event} will be fired when the `GeolocateControl` changes to the active lock state, which happens either upon first obtaining a successful Geolocation API position for the user (a `geolocate` event will follow), or the user clicks the geolocate button when in the background state which uses the last known position to recenter the map and enter active lock state (no `geolocate` event will follow unless the users's location changes).
 *
 * **Event** `userlocationlostfocus` of type {@link Event} will be fired when the `GeolocateControl` changes to the background state, which happens when a user changes the camera during an active position lock. This only applies when `trackUserLocation` is `true`. In the background state, the dot on the map will update with location updates but the camera will not.
 *
 * **Event** `userlocationfocus` of type {@link Event} will be fired when the `GeolocateControl` changes to the active lock state, which happens upon the user clicks the geolocate button when in the background state which uses the last known position to recenter the map and enter active lock state.
 *
 * **Event** `geolocate` of type {@link Event} will be fired on each Geolocation API position update which returned as success.
 * `data` - The returned [Position](https://developer.mozilla.org/en-US/docs/Web/API/Position) object from the callback in [Geolocation.getCurrentPosition()](https://developer.mozilla.org/en-US/docs/Web/API/Geolocation/getCurrentPosition) or [Geolocation.watchPosition()](https://developer.mozilla.org/en-US/docs/Web/API/Geolocation/watchPosition).
 *
 * **Event** `error` of type {@link Event} will be fired on each Geolocation API position update which returned as an error.
 * `data` - The returned [PositionError](https://developer.mozilla.org/en-US/docs/Web/API/PositionError) object from the callback in [Geolocation.getCurrentPosition()](https://developer.mozilla.org/en-US/docs/Web/API/Geolocation/getCurrentPosition) or [Geolocation.watchPosition()](https://developer.mozilla.org/en-US/docs/Web/API/Geolocation/watchPosition).
 *
 * **Event** `outofmaxbounds` of type {@link Event} will be fired on each Geolocation API position update which returned as success but user position is out of map `maxBounds`.
 * `data` - The returned [Position](https://developer.mozilla.org/en-US/docs/Web/API/Position) object from the callback in [Geolocation.getCurrentPosition()](https://developer.mozilla.org/en-US/docs/Web/API/Geolocation/getCurrentPosition) or [Geolocation.watchPosition()](https://developer.mozilla.org/en-US/docs/Web/API/Geolocation/watchPosition).
 *
 * @example
 * ```ts
 * // Initialize the geolocate control.
 * let geolocate = new GeolocateControl({
 *   positionOptions: {
 *       enableHighAccuracy: true
 *   },
 *   trackUserLocation: true
 * });
 * // Add the control to the map.
 * map.addControl(geolocate);
 * // Set an event listener that fires
 * // when a trackuserlocationend event occurs.
 * geolocate.on('trackuserlocationend', () => {
 *   console.log('A trackuserlocationend event has occurred.')
 * });
 * ```
 *
 * @example
 * ```ts
 * // Initialize the geolocate control.
 * let geolocate = new GeolocateControl({
 *   positionOptions: {
 *       enableHighAccuracy: true
 *   },
 *   trackUserLocation: true
 * });
 * // Add the control to the map.
 * map.addControl(geolocate);
 * // Set an event listener that fires
 * // when a trackuserlocationstart event occurs.
 * geolocate.on('trackuserlocationstart', () => {
 *   console.log('A trackuserlocationstart event has occurred.')
 * });
 * ```
 *
 * @example
 * ```ts
 * // Initialize the geolocate control.
 * let geolocate = new GeolocateControl({
 *   positionOptions: {
 *       enableHighAccuracy: true
 *   },
 *   trackUserLocation: true
 * });
 * // Add the control to the map.
 * map.addControl(geolocate);
 * // Set an event listener that fires
 * // when an userlocationlostfocus event occurs.
 * geolocate.on('userlocationlostfocus', function() {
 *   console.log('An userlocationlostfocus event has occurred.')
 * });
 * ```
 *
 * @example
 * ```ts
 * // Initialize the geolocate control.
 * let geolocate = new GeolocateControl({
 *   positionOptions: {
 *       enableHighAccuracy: true
 *   },
 *   trackUserLocation: true
 * });
 * // Add the control to the map.
 * map.addControl(geolocate);
 * // Set an event listener that fires
 * // when an userlocationfocus event occurs.
 * geolocate.on('userlocationfocus', function() {
 *   console.log('An userlocationfocus event has occurred.')
 * });
 * ```
 *
 * @example
 * ```ts
 * // Initialize the geolocate control.
 * let geolocate = new GeolocateControl({
 *   positionOptions: {
 *       enableHighAccuracy: true
 *   },
 *   trackUserLocation: true
 * });
 * // Add the control to the map.
 * map.addControl(geolocate);
 * // Set an event listener that fires
 * // when a geolocate event occurs.
 * geolocate.on('geolocate', () => {
 *   console.log('A geolocate event has occurred.')
 * });
 * ```
 *
 * @example
 * ```ts
 * // Initialize the geolocate control.
 * let geolocate = new GeolocateControl({
 *   positionOptions: {
 *       enableHighAccuracy: true
 *   },
 *   trackUserLocation: true
 * });
 * // Add the control to the map.
 * map.addControl(geolocate);
 * // Set an event listener that fires
 * // when an error event occurs.
 * geolocate.on('error', () => {
 *   console.log('An error event has occurred.')
 * });
 * ```
 *
 * @example
 * ```ts
 * // Initialize the geolocate control.
 * let geolocate = new GeolocateControl({
 *   positionOptions: {
 *       enableHighAccuracy: true
 *   },
 *   trackUserLocation: true
 * });
 * // Add the control to the map.
 * map.addControl(geolocate);
 * // Set an event listener that fires
 * // when an outofmaxbounds event occurs.
 * geolocate.on('outofmaxbounds', () => {
 *   console.log('An outofmaxbounds event has occurred.')
 * });
 * ```
 */
class GeolocateControl extends performance$1.E {
    /**
     * @param options - the control's options
     */
    constructor(options) {
        super();
        /**
         * When the Geolocation API returns a new location, update the `GeolocateControl`.
         *
         * @param position - the Geolocation API Position
         */
        this._onSuccess = (position) => {
            if (!this._map) {
                // control has since been removed
                return;
            }
            if (this._isOutOfMapMaxBounds(position)) {
                this._setErrorState();
                this.fire(new performance$1.k('outofmaxbounds', position));
                this._updateMarker();
                this._finish();
                return;
            }
            if (this.options.trackUserLocation) {
                // keep a record of the position so that if the state is BACKGROUND and the user
                // clicks the button, we can move to ACTIVE_LOCK immediately without waiting for
                // watchPosition to trigger _onSuccess
                this._lastKnownPosition = position;
                switch (this._watchState) {
                    case 'WAITING_ACTIVE':
                    case 'ACTIVE_LOCK':
                    case 'ACTIVE_ERROR':
                        this._watchState = 'ACTIVE_LOCK';
                        this._geolocateButton.classList.remove('maplibregl-ctrl-geolocate-waiting');
                        this._geolocateButton.classList.remove('maplibregl-ctrl-geolocate-active-error');
                        this._geolocateButton.classList.add('maplibregl-ctrl-geolocate-active');
                        break;
                    case 'BACKGROUND':
                    case 'BACKGROUND_ERROR':
                        this._watchState = 'BACKGROUND';
                        this._geolocateButton.classList.remove('maplibregl-ctrl-geolocate-waiting');
                        this._geolocateButton.classList.remove('maplibregl-ctrl-geolocate-background-error');
                        this._geolocateButton.classList.add('maplibregl-ctrl-geolocate-background');
                        break;
                    default:
                        throw new Error(`Unexpected watchState ${this._watchState}`);
                }
            }
            // if showUserLocation and the watch state isn't off then update the marker location
            if (this.options.showUserLocation && this._watchState !== 'OFF') {
                this._updateMarker(position);
            }
            // if in normal mode (not watch mode), or if in watch mode and the state is active watch
            // then update the camera
            if (!this.options.trackUserLocation || this._watchState === 'ACTIVE_LOCK') {
                this._updateCamera(position);
            }
            if (this.options.showUserLocation) {
                this._dotElement.classList.remove('maplibregl-user-location-dot-stale');
            }
            this.fire(new performance$1.k('geolocate', position));
            this._finish();
        };
        /**
         * Update the camera location to center on the current position
         *
         * @param position - the Geolocation API Position
         */
        this._updateCamera = (position) => {
            const center = new performance$1.N(position.coords.longitude, position.coords.latitude);
            const radius = position.coords.accuracy;
            const bearing = this._map.getBearing();
            const options = performance$1.e({ bearing }, this.options.fitBoundsOptions);
            const newBounds = LngLatBounds.fromLngLat(center, radius);
            this._map.fitBounds(newBounds, options, {
                geolocateSource: true // tag this camera change so it won't cause the control to change to background state
            });
        };
        /**
         * Update the user location dot Marker to the current position
         *
         * @param position - the Geolocation API Position
         */
        this._updateMarker = (position) => {
            if (position) {
                const center = new performance$1.N(position.coords.longitude, position.coords.latitude);
                this._accuracyCircleMarker.setLngLat(center).addTo(this._map);
                this._userLocationDotMarker.setLngLat(center).addTo(this._map);
                this._accuracy = position.coords.accuracy;
                if (this.options.showUserLocation && this.options.showAccuracyCircle) {
                    this._updateCircleRadius();
                }
            }
            else {
                this._userLocationDotMarker.remove();
                this._accuracyCircleMarker.remove();
            }
        };
        this._onZoom = () => {
            if (this.options.showUserLocation && this.options.showAccuracyCircle) {
                this._updateCircleRadius();
            }
        };
        this._onError = (error) => {
            if (!this._map) {
                // control has since been removed
                return;
            }
            if (this.options.trackUserLocation) {
                if (error.code === 1) {
                    // PERMISSION_DENIED
                    this._watchState = 'OFF';
                    this._geolocateButton.classList.remove('maplibregl-ctrl-geolocate-waiting');
                    this._geolocateButton.classList.remove('maplibregl-ctrl-geolocate-active');
                    this._geolocateButton.classList.remove('maplibregl-ctrl-geolocate-active-error');
                    this._geolocateButton.classList.remove('maplibregl-ctrl-geolocate-background');
                    this._geolocateButton.classList.remove('maplibregl-ctrl-geolocate-background-error');
                    this._geolocateButton.disabled = true;
                    const title = this._map._getUIString('GeolocateControl.LocationNotAvailable');
                    this._geolocateButton.title = title;
                    this._geolocateButton.setAttribute('aria-label', title);
                    if (this._geolocationWatchID !== undefined) {
                        this._clearWatch();
                    }
                }
                else if (error.code === 3 && noTimeout) {
                    // this represents a forced error state
                    // this was triggered to force immediate geolocation when a watch is already present
                    // see https://github.com/mapbox/mapbox-gl-js/issues/8214
                    // and https://w3c.github.io/geolocation-api/#example-5-forcing-the-user-agent-to-return-a-fresh-cached-position
                    return;
                }
                else {
                    this._setErrorState();
                }
            }
            if (this._watchState !== 'OFF' && this.options.showUserLocation) {
                this._dotElement.classList.add('maplibregl-user-location-dot-stale');
            }
            this.fire(new performance$1.k('error', error));
            this._finish();
        };
        this._finish = () => {
            if (this._timeoutId) {
                clearTimeout(this._timeoutId);
            }
            this._timeoutId = undefined;
        };
        this._setupUI = () => {
            // the control could have been removed before reaching here
            if (!this._map) {
                return;
            }
            this._container.addEventListener('contextmenu', (e) => e.preventDefault());
            this._geolocateButton = DOM.create('button', 'maplibregl-ctrl-geolocate', this._container);
            DOM.create('span', 'maplibregl-ctrl-icon', this._geolocateButton).setAttribute('aria-hidden', 'true');
            this._geolocateButton.type = 'button';
            this._geolocateButton.disabled = true;
        };
        this._finishSetupUI = (supported) => {
            // this method is called asynchronously during onAdd
            if (!this._map) {
                // control has since been removed
                return;
            }
            if (supported === false) {
                performance$1.w('Geolocation support is not available so the GeolocateControl will be disabled.');
                const title = this._map._getUIString('GeolocateControl.LocationNotAvailable');
                this._geolocateButton.disabled = true;
                this._geolocateButton.title = title;
                this._geolocateButton.setAttribute('aria-label', title);
            }
            else {
                const title = this._map._getUIString('GeolocateControl.FindMyLocation');
                this._geolocateButton.disabled = false;
                this._geolocateButton.title = title;
                this._geolocateButton.setAttribute('aria-label', title);
            }
            if (this.options.trackUserLocation) {
                this._geolocateButton.setAttribute('aria-pressed', 'false');
                this._watchState = 'OFF';
            }
            // when showUserLocation is enabled, keep the Geolocate button disabled until the device location marker is setup on the map
            if (this.options.showUserLocation) {
                this._dotElement = DOM.create('div', 'maplibregl-user-location-dot');
                this._userLocationDotMarker = new Marker({ element: this._dotElement });
                this._circleElement = DOM.create('div', 'maplibregl-user-location-accuracy-circle');
                this._accuracyCircleMarker = new Marker({ element: this._circleElement, pitchAlignment: 'map' });
                if (this.options.trackUserLocation)
                    this._watchState = 'OFF';
                this._map.on('zoom', this._onZoom);
            }
            this._geolocateButton.addEventListener('click', () => this.trigger());
            this._setup = true;
            // when the camera is changed (and it's not as a result of the Geolocation Control) change
            // the watch mode to background watch, so that the marker is updated but not the camera.
            if (this.options.trackUserLocation) {
                this._map.on('movestart', (event) => {
                    const fromResize = event.originalEvent && event.originalEvent.type === 'resize';
                    if (!event.geolocateSource && this._watchState === 'ACTIVE_LOCK' && !fromResize) {
                        this._watchState = 'BACKGROUND';
                        this._geolocateButton.classList.add('maplibregl-ctrl-geolocate-background');
                        this._geolocateButton.classList.remove('maplibregl-ctrl-geolocate-active');
                        this.fire(new performance$1.k('trackuserlocationend'));
                        this.fire(new performance$1.k('userlocationlostfocus'));
                    }
                });
            }
        };
        this.options = performance$1.e({}, defaultOptions$2, options);
    }
    /** {@inheritDoc IControl.onAdd} */
    onAdd(map) {
        this._map = map;
        this._container = DOM.create('div', 'maplibregl-ctrl maplibregl-ctrl-group');
        this._setupUI();
        checkGeolocationSupport().then((supported) => this._finishSetupUI(supported));
        return this._container;
    }
    /** {@inheritDoc IControl.onRemove} */
    onRemove() {
        // clear the geolocation watch if exists
        if (this._geolocationWatchID !== undefined) {
            window.navigator.geolocation.clearWatch(this._geolocationWatchID);
            this._geolocationWatchID = undefined;
        }
        // clear the markers from the map
        if (this.options.showUserLocation && this._userLocationDotMarker) {
            this._userLocationDotMarker.remove();
        }
        if (this.options.showAccuracyCircle && this._accuracyCircleMarker) {
            this._accuracyCircleMarker.remove();
        }
        DOM.remove(this._container);
        this._map.off('zoom', this._onZoom);
        this._map = undefined;
        numberOfWatches = 0;
        noTimeout = false;
    }
    /**
     * Check if the Geolocation API Position is outside the map's `maxBounds`.
     *
     * @param position - the Geolocation API Position
     * @returns `true` if position is outside the map's `maxBounds`, otherwise returns `false`.
     */
    _isOutOfMapMaxBounds(position) {
        const bounds = this._map.getMaxBounds();
        const coordinates = position.coords;
        return bounds && (coordinates.longitude < bounds.getWest() ||
            coordinates.longitude > bounds.getEast() ||
            coordinates.latitude < bounds.getSouth() ||
            coordinates.latitude > bounds.getNorth());
    }
    _setErrorState() {
        switch (this._watchState) {
            case 'WAITING_ACTIVE':
                this._watchState = 'ACTIVE_ERROR';
                this._geolocateButton.classList.remove('maplibregl-ctrl-geolocate-active');
                this._geolocateButton.classList.add('maplibregl-ctrl-geolocate-active-error');
                break;
            case 'ACTIVE_LOCK':
                this._watchState = 'ACTIVE_ERROR';
                this._geolocateButton.classList.remove('maplibregl-ctrl-geolocate-active');
                this._geolocateButton.classList.add('maplibregl-ctrl-geolocate-active-error');
                this._geolocateButton.classList.add('maplibregl-ctrl-geolocate-waiting');
                // turn marker grey
                break;
            case 'BACKGROUND':
                this._watchState = 'BACKGROUND_ERROR';
                this._geolocateButton.classList.remove('maplibregl-ctrl-geolocate-background');
                this._geolocateButton.classList.add('maplibregl-ctrl-geolocate-background-error');
                this._geolocateButton.classList.add('maplibregl-ctrl-geolocate-waiting');
                // turn marker grey
                break;
            case 'ACTIVE_ERROR':
                break;
            default:
                throw new Error(`Unexpected watchState ${this._watchState}`);
        }
    }
    _updateCircleRadius() {
        const bounds = this._map.getBounds();
        const southEastPoint = bounds.getSouthEast();
        const northEastPoint = bounds.getNorthEast();
        const mapHeightInMeters = southEastPoint.distanceTo(northEastPoint);
        const mapHeightInPixels = this._map._container.clientHeight;
        const circleDiameter = Math.ceil(2 * (this._accuracy / (mapHeightInMeters / mapHeightInPixels)));
        this._circleElement.style.width = `${circleDiameter}px`;
        this._circleElement.style.height = `${circleDiameter}px`;
    }
    /**
     * Programmatically request and move the map to the user's location.
     *
     * @returns `false` if called before control was added to a map, otherwise returns `true`.
     * @example
     * ```ts
     * // Initialize the geolocate control.
     * let geolocate = new GeolocateControl({
     *  positionOptions: {
     *    enableHighAccuracy: true
     *  },
     *  trackUserLocation: true
     * });
     * // Add the control to the map.
     * map.addControl(geolocate);
     * map.on('load', () => {
     *   geolocate.trigger();
     * });
     * ```
     */
    trigger() {
        if (!this._setup) {
            performance$1.w('Geolocate control triggered before added to a map');
            return false;
        }
        if (this.options.trackUserLocation) {
            // update watchState and do any outgoing state cleanup
            switch (this._watchState) {
                case 'OFF':
                    // turn on the Geolocate Control
                    this._watchState = 'WAITING_ACTIVE';
                    this.fire(new performance$1.k('trackuserlocationstart'));
                    break;
                case 'WAITING_ACTIVE':
                case 'ACTIVE_LOCK':
                case 'ACTIVE_ERROR':
                case 'BACKGROUND_ERROR':
                    // turn off the Geolocate Control
                    numberOfWatches--;
                    noTimeout = false;
                    this._watchState = 'OFF';
                    this._geolocateButton.classList.remove('maplibregl-ctrl-geolocate-waiting');
                    this._geolocateButton.classList.remove('maplibregl-ctrl-geolocate-active');
                    this._geolocateButton.classList.remove('maplibregl-ctrl-geolocate-active-error');
                    this._geolocateButton.classList.remove('maplibregl-ctrl-geolocate-background');
                    this._geolocateButton.classList.remove('maplibregl-ctrl-geolocate-background-error');
                    this.fire(new performance$1.k('trackuserlocationend'));
                    break;
                case 'BACKGROUND':
                    this._watchState = 'ACTIVE_LOCK';
                    this._geolocateButton.classList.remove('maplibregl-ctrl-geolocate-background');
                    // set camera to last known location
                    if (this._lastKnownPosition)
                        this._updateCamera(this._lastKnownPosition);
                    this.fire(new performance$1.k('trackuserlocationstart'));
                    this.fire(new performance$1.k('userlocationfocus'));
                    break;
                default:
                    throw new Error(`Unexpected watchState ${this._watchState}`);
            }
            // incoming state setup
            switch (this._watchState) {
                case 'WAITING_ACTIVE':
                    this._geolocateButton.classList.add('maplibregl-ctrl-geolocate-waiting');
                    this._geolocateButton.classList.add('maplibregl-ctrl-geolocate-active');
                    break;
                case 'ACTIVE_LOCK':
                    this._geolocateButton.classList.add('maplibregl-ctrl-geolocate-active');
                    break;
                case 'OFF':
                    break;
                default:
                    throw new Error(`Unexpected watchState ${this._watchState}`);
            }
            // manage geolocation.watchPosition / geolocation.clearWatch
            if (this._watchState === 'OFF' && this._geolocationWatchID !== undefined) {
                // clear watchPosition as we've changed to an OFF state
                this._clearWatch();
            }
            else if (this._geolocationWatchID === undefined) {
                // enable watchPosition since watchState is not OFF and there is no watchPosition already running
                this._geolocateButton.classList.add('maplibregl-ctrl-geolocate-waiting');
                this._geolocateButton.setAttribute('aria-pressed', 'true');
                numberOfWatches++;
                let positionOptions;
                if (numberOfWatches > 1) {
                    positionOptions = { maximumAge: 600000, timeout: 0 };
                    noTimeout = true;
                }
                else {
                    positionOptions = this.options.positionOptions;
                    noTimeout = false;
                }
                this._geolocationWatchID = window.navigator.geolocation.watchPosition(this._onSuccess, this._onError, positionOptions);
            }
        }
        else {
            window.navigator.geolocation.getCurrentPosition(this._onSuccess, this._onError, this.options.positionOptions);
            // This timeout ensures that we still call finish() even if
            // the user declines to share their location in Firefox
            this._timeoutId = setTimeout(this._finish, 10000 /* 10sec */);
        }
        return true;
    }
    _clearWatch() {
        window.navigator.geolocation.clearWatch(this._geolocationWatchID);
        this._geolocationWatchID = undefined;
        this._geolocateButton.classList.remove('maplibregl-ctrl-geolocate-waiting');
        this._geolocateButton.setAttribute('aria-pressed', 'false');
        if (this.options.showUserLocation) {
            this._updateMarker(null);
        }
    }
}

const defaultOptions$1 = {
    maxWidth: 100,
    unit: 'metric'
};
/**
 * A `ScaleControl` control displays the ratio of a distance on the map to the corresponding distance on the ground.
 *
 * @group Markers and Controls
 *
 * @example
 * ```ts
 * let scale = new ScaleControl({
 *     maxWidth: 80,
 *     unit: 'imperial'
 * });
 * map.addControl(scale);
 *
 * scale.setUnit('metric');
 * ```
 */
class ScaleControl {
    /**
     * @param options - the control's options
     */
    constructor(options) {
        this._onMove = () => {
            updateScale(this._map, this._container, this.options);
        };
        /**
         * Set the scale's unit of the distance
         *
         * @param unit - Unit of the distance (`'imperial'`, `'metric'` or `'nautical'`).
         */
        this.setUnit = (unit) => {
            this.options.unit = unit;
            updateScale(this._map, this._container, this.options);
        };
        this.options = Object.assign(Object.assign({}, defaultOptions$1), options);
    }
    getDefaultPosition() {
        return 'bottom-left';
    }
    /** {@inheritDoc IControl.onAdd} */
    onAdd(map) {
        this._map = map;
        this._container = DOM.create('div', 'maplibregl-ctrl maplibregl-ctrl-scale', map.getContainer());
        this._map.on('move', this._onMove);
        this._onMove();
        return this._container;
    }
    /** {@inheritDoc IControl.onRemove} */
    onRemove() {
        DOM.remove(this._container);
        this._map.off('move', this._onMove);
        this._map = undefined;
    }
}
function updateScale(map, container, options) {
    // A horizontal scale is imagined to be present at center of the map
    // container with maximum length (Default) as 100px.
    // Using spherical law of cosines approximation, the real distance is
    // found between the two coordinates.
    const maxWidth = options && options.maxWidth || 100;
    const y = map._container.clientHeight / 2;
    const left = map.unproject([0, y]);
    const right = map.unproject([maxWidth, y]);
    const maxMeters = left.distanceTo(right);
    // The real distance corresponding to 100px scale length is rounded off to
    // near pretty number and the scale length for the same is found out.
    // Default unit of the scale is based on User's locale.
    if (options && options.unit === 'imperial') {
        const maxFeet = 3.2808 * maxMeters;
        if (maxFeet > 5280) {
            const maxMiles = maxFeet / 5280;
            setScale(container, maxWidth, maxMiles, map._getUIString('ScaleControl.Miles'));
        }
        else {
            setScale(container, maxWidth, maxFeet, map._getUIString('ScaleControl.Feet'));
        }
    }
    else if (options && options.unit === 'nautical') {
        const maxNauticals = maxMeters / 1852;
        setScale(container, maxWidth, maxNauticals, map._getUIString('ScaleControl.NauticalMiles'));
    }
    else if (maxMeters >= 1000) {
        setScale(container, maxWidth, maxMeters / 1000, map._getUIString('ScaleControl.Kilometers'));
    }
    else {
        setScale(container, maxWidth, maxMeters, map._getUIString('ScaleControl.Meters'));
    }
}
function setScale(container, maxWidth, maxDistance, unit) {
    const distance = getRoundNum(maxDistance);
    const ratio = distance / maxDistance;
    container.style.width = `${maxWidth * ratio}px`;
    container.innerHTML = `${distance}&nbsp;${unit}`;
}
function getDecimalRoundNum(d) {
    const multiplier = Math.pow(10, Math.ceil(-Math.log(d) / Math.LN10));
    return Math.round(d * multiplier) / multiplier;
}
function getRoundNum(num) {
    const pow10 = Math.pow(10, (`${Math.floor(num)}`).length - 1);
    let d = num / pow10;
    d = d >= 10 ? 10 :
        d >= 5 ? 5 :
            d >= 3 ? 3 :
                d >= 2 ? 2 :
                    d >= 1 ? 1 : getDecimalRoundNum(d);
    return pow10 * d;
}

/**
 * A `FullscreenControl` control contains a button for toggling the map in and out of fullscreen mode.
 * When [requestFullscreen](https://developer.mozilla.org/en-US/docs/Web/API/Element/requestFullscreen) is not supported, fullscreen is handled via CSS properties.
 * The map's `cooperativeGestures` option is temporarily disabled while the map
 * is in fullscreen mode, and is restored when the map exist fullscreen mode.
 *
 * @group Markers and Controls
 * @param options - the full screen control options
 *
 * @example
 * ```ts
 * map.addControl(new FullscreenControl({container: document.querySelector('body')}));
 * ```
 * @see [View a fullscreen map](https://maplibre.org/maplibre-gl-js/docs/examples/fullscreen/)
 *
 * ## Events
 *
 * **Event** `fullscreenstart` of type {@link Event} will be fired when fullscreen mode has started.
 *
 * **Event** `fullscreenend` of type {@link Event} will be fired when fullscreen mode has ended.
 */
class FullscreenControl extends performance$1.E {
    /**
     * @param options - the control's options
     */
    constructor(options = {}) {
        super();
        this._onFullscreenChange = () => {
            var _a;
            let fullscreenElement = window.document.fullscreenElement ||
                window.document.mozFullScreenElement ||
                window.document.webkitFullscreenElement ||
                window.document.msFullscreenElement;
            while ((_a = fullscreenElement === null || fullscreenElement === void 0 ? void 0 : fullscreenElement.shadowRoot) === null || _a === void 0 ? void 0 : _a.fullscreenElement) {
                fullscreenElement = fullscreenElement.shadowRoot.fullscreenElement;
            }
            if ((fullscreenElement === this._container) !== this._fullscreen) {
                this._handleFullscreenChange();
            }
        };
        this._onClickFullscreen = () => {
            if (this._isFullscreen()) {
                this._exitFullscreen();
            }
            else {
                this._requestFullscreen();
            }
        };
        this._fullscreen = false;
        if (options && options.container) {
            if (options.container instanceof HTMLElement) {
                this._container = options.container;
            }
            else {
                performance$1.w('Full screen control \'container\' must be a DOM element.');
            }
        }
        if ('onfullscreenchange' in document) {
            this._fullscreenchange = 'fullscreenchange';
        }
        else if ('onmozfullscreenchange' in document) {
            this._fullscreenchange = 'mozfullscreenchange';
        }
        else if ('onwebkitfullscreenchange' in document) {
            this._fullscreenchange = 'webkitfullscreenchange';
        }
        else if ('onmsfullscreenchange' in document) {
            this._fullscreenchange = 'MSFullscreenChange';
        }
    }
    /** {@inheritDoc IControl.onAdd} */
    onAdd(map) {
        this._map = map;
        if (!this._container)
            this._container = this._map.getContainer();
        this._controlContainer = DOM.create('div', 'maplibregl-ctrl maplibregl-ctrl-group');
        this._setupUI();
        return this._controlContainer;
    }
    /** {@inheritDoc IControl.onRemove} */
    onRemove() {
        DOM.remove(this._controlContainer);
        this._map = null;
        window.document.removeEventListener(this._fullscreenchange, this._onFullscreenChange);
    }
    _setupUI() {
        const button = this._fullscreenButton = DOM.create('button', (('maplibregl-ctrl-fullscreen')), this._controlContainer);
        DOM.create('span', 'maplibregl-ctrl-icon', button).setAttribute('aria-hidden', 'true');
        button.type = 'button';
        this._updateTitle();
        this._fullscreenButton.addEventListener('click', this._onClickFullscreen);
        window.document.addEventListener(this._fullscreenchange, this._onFullscreenChange);
    }
    _updateTitle() {
        const title = this._getTitle();
        this._fullscreenButton.setAttribute('aria-label', title);
        this._fullscreenButton.title = title;
    }
    _getTitle() {
        return this._map._getUIString(this._isFullscreen() ? 'FullscreenControl.Exit' : 'FullscreenControl.Enter');
    }
    _isFullscreen() {
        return this._fullscreen;
    }
    _handleFullscreenChange() {
        this._fullscreen = !this._fullscreen;
        this._fullscreenButton.classList.toggle('maplibregl-ctrl-shrink');
        this._fullscreenButton.classList.toggle('maplibregl-ctrl-fullscreen');
        this._updateTitle();
        if (this._fullscreen) {
            this.fire(new performance$1.k('fullscreenstart'));
            this._prevCooperativeGesturesEnabled = this._map.cooperativeGestures.isEnabled();
            this._map.cooperativeGestures.disable();
        }
        else {
            this.fire(new performance$1.k('fullscreenend'));
            if (this._prevCooperativeGesturesEnabled) {
                this._map.cooperativeGestures.enable();
            }
        }
    }
    _exitFullscreen() {
        if (window.document.exitFullscreen) {
            window.document.exitFullscreen();
        }
        else if (window.document.mozCancelFullScreen) {
            window.document.mozCancelFullScreen();
        }
        else if (window.document.msExitFullscreen) {
            window.document.msExitFullscreen();
        }
        else if (window.document.webkitCancelFullScreen) {
            window.document.webkitCancelFullScreen();
        }
        else {
            this._togglePseudoFullScreen();
        }
    }
    _requestFullscreen() {
        if (this._container.requestFullscreen) {
            this._container.requestFullscreen();
        }
        else if (this._container.mozRequestFullScreen) {
            this._container.mozRequestFullScreen();
        }
        else if (this._container.msRequestFullscreen) {
            this._container.msRequestFullscreen();
        }
        else if (this._container.webkitRequestFullscreen) {
            this._container.webkitRequestFullscreen();
        }
        else {
            this._togglePseudoFullScreen();
        }
    }
    _togglePseudoFullScreen() {
        this._container.classList.toggle('maplibregl-pseudo-fullscreen');
        this._handleFullscreenChange();
        this._map.resize();
    }
}

/**
 * A `TerrainControl` control contains a button for turning the terrain on and off.
 *
 * @group Markers and Controls
 *
 * @example
 * ```ts
 * let map = new Map({TerrainControl: false})
 *     .addControl(new TerrainControl({
 *         source: "terrain"
 *     }));
 * ```
 */
class TerrainControl {
    /**
     * @param options - the control's options
     */
    constructor(options) {
        this._toggleTerrain = () => {
            if (this._map.getTerrain()) {
                this._map.setTerrain(null);
            }
            else {
                this._map.setTerrain(this.options);
            }
            this._updateTerrainIcon();
        };
        this._updateTerrainIcon = () => {
            this._terrainButton.classList.remove('maplibregl-ctrl-terrain');
            this._terrainButton.classList.remove('maplibregl-ctrl-terrain-enabled');
            if (this._map.terrain) {
                this._terrainButton.classList.add('maplibregl-ctrl-terrain-enabled');
                this._terrainButton.title = this._map._getUIString('TerrainControl.Disable');
            }
            else {
                this._terrainButton.classList.add('maplibregl-ctrl-terrain');
                this._terrainButton.title = this._map._getUIString('TerrainControl.Enable');
            }
        };
        this.options = options;
    }
    /** {@inheritDoc IControl.onAdd} */
    onAdd(map) {
        this._map = map;
        this._container = DOM.create('div', 'maplibregl-ctrl maplibregl-ctrl-group');
        this._terrainButton = DOM.create('button', 'maplibregl-ctrl-terrain', this._container);
        DOM.create('span', 'maplibregl-ctrl-icon', this._terrainButton).setAttribute('aria-hidden', 'true');
        this._terrainButton.type = 'button';
        this._terrainButton.addEventListener('click', this._toggleTerrain);
        this._updateTerrainIcon();
        this._map.on('terrain', this._updateTerrainIcon);
        return this._container;
    }
    /** {@inheritDoc IControl.onRemove} */
    onRemove() {
        DOM.remove(this._container);
        this._map.off('terrain', this._updateTerrainIcon);
        this._map = undefined;
    }
}

const defaultOptions = {
    closeButton: true,
    closeOnClick: true,
    focusAfterOpen: true,
    className: '',
    maxWidth: '240px',
    subpixelPositioning: false
};
const focusQuerySelector = [
    'a[href]',
    '[tabindex]:not([tabindex=\'-1\'])',
    '[contenteditable]:not([contenteditable=\'false\'])',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
].join(', ');
/**
 * A popup component.
 *
 * @group Markers and Controls
 *
 *
 * @example
 * Create a popup
 * ```ts
 * let popup = new Popup();
 * // Set an event listener that will fire
 * // any time the popup is opened
 * popup.on('open', () => {
 *   console.log('popup was opened');
 * });
 * ```
 *
 * @example
 * Create a popup
 * ```ts
 * let popup = new Popup();
 * // Set an event listener that will fire
 * // any time the popup is closed
 * popup.on('close', () => {
 *   console.log('popup was closed');
 * });
 * ```
 *
 * @example
 * ```ts
 * let markerHeight = 50, markerRadius = 10, linearOffset = 25;
 * let popupOffsets = {
 *  'top': [0, 0],
 *  'top-left': [0,0],
 *  'top-right': [0,0],
 *  'bottom': [0, -markerHeight],
 *  'bottom-left': [linearOffset, (markerHeight - markerRadius + linearOffset) * -1],
 *  'bottom-right': [-linearOffset, (markerHeight - markerRadius + linearOffset) * -1],
 *  'left': [markerRadius, (markerHeight - markerRadius) * -1],
 *  'right': [-markerRadius, (markerHeight - markerRadius) * -1]
 *  };
 * let popup = new Popup({offset: popupOffsets, className: 'my-class'})
 *   .setLngLat(e.lngLat)
 *   .setHTML("<h1>Hello World!</h1>")
 *   .setMaxWidth("300px")
 *   .addTo(map);
 * ```
 * @see [Display a popup](https://maplibre.org/maplibre-gl-js/docs/examples/popup/)
 * @see [Display a popup on hover](https://maplibre.org/maplibre-gl-js/docs/examples/popup-on-hover/)
 * @see [Display a popup on click](https://maplibre.org/maplibre-gl-js/docs/examples/popup-on-click/)
 * @see [Attach a popup to a marker instance](https://maplibre.org/maplibre-gl-js/docs/examples/set-popup/)
 *
 * ## Events
 *
 * **Event** `open` of type {@link Event} will be fired when the popup is opened manually or programmatically.
 *
 * **Event** `close` of type {@link Event} will be fired when the popup is closed manually or programmatically.
 */
class Popup extends performance$1.E {
    /**
     * @param options - the options
     */
    constructor(options) {
        super();
        /**
         * Removes the popup from the map it has been added to.
         *
         * @example
         * ```ts
         * let popup = new Popup().addTo(map);
         * popup.remove();
         * ```
         */
        this.remove = () => {
            if (this._content) {
                DOM.remove(this._content);
            }
            if (this._container) {
                DOM.remove(this._container);
                delete this._container;
            }
            if (this._map) {
                this._map.off('move', this._update);
                this._map.off('move', this._onClose);
                this._map.off('click', this._onClose);
                this._map.off('remove', this.remove);
                this._map.off('mousemove', this._onMouseMove);
                this._map.off('mouseup', this._onMouseUp);
                this._map.off('drag', this._onDrag);
                this._map._canvasContainer.classList.remove('maplibregl-track-pointer');
                delete this._map;
                this.fire(new performance$1.k('close'));
            }
            return this;
        };
        this._onMouseUp = (event) => {
            this._update(event.point);
        };
        this._onMouseMove = (event) => {
            this._update(event.point);
        };
        this._onDrag = (event) => {
            this._update(event.point);
        };
        this._update = (cursor) => {
            var _a;
            const hasPosition = this._lngLat || this._trackPointer;
            if (!this._map || !hasPosition || !this._content) {
                return;
            }
            if (!this._container) {
                this._container = DOM.create('div', 'maplibregl-popup', this._map.getContainer());
                this._tip = DOM.create('div', 'maplibregl-popup-tip', this._container);
                this._container.appendChild(this._content);
                if (this.options.className) {
                    for (const name of this.options.className.split(' ')) {
                        this._container.classList.add(name);
                    }
                }
                if (this._closeButton) {
                    this._closeButton.setAttribute('aria-label', this._map._getUIString('Popup.Close'));
                }
                if (this._trackPointer) {
                    this._container.classList.add('maplibregl-popup-track-pointer');
                }
            }
            if (this.options.maxWidth && this._container.style.maxWidth !== this.options.maxWidth) {
                this._container.style.maxWidth = this.options.maxWidth;
            }
            if (this._map.transform.renderWorldCopies && !this._trackPointer) {
                this._lngLat = smartWrap(this._lngLat, this._flatPos, this._map.transform);
            }
            else {
                this._lngLat = (_a = this._lngLat) === null || _a === void 0 ? void 0 : _a.wrap();
            }
            if (this._trackPointer && !cursor)
                return;
            const pos = this._flatPos = this._pos = this._trackPointer && cursor ? cursor : this._map.project(this._lngLat);
            if (this._map.terrain) {
                // flat position is saved because smartWrap needs non-elevated points
                this._flatPos = this._trackPointer && cursor ? cursor : this._map.transform.locationPoint(this._lngLat);
            }
            let anchor = this.options.anchor;
            const offset = normalizeOffset(this.options.offset);
            if (!anchor) {
                const width = this._container.offsetWidth;
                const height = this._container.offsetHeight;
                let anchorComponents;
                if (pos.y + offset.bottom.y < height) {
                    anchorComponents = ['top'];
                }
                else if (pos.y > this._map.transform.height - height) {
                    anchorComponents = ['bottom'];
                }
                else {
                    anchorComponents = [];
                }
                if (pos.x < width / 2) {
                    anchorComponents.push('left');
                }
                else if (pos.x > this._map.transform.width - width / 2) {
                    anchorComponents.push('right');
                }
                if (anchorComponents.length === 0) {
                    anchor = 'bottom';
                }
                else {
                    anchor = anchorComponents.join('-');
                }
            }
            let offsetedPos = pos.add(offset[anchor]);
            if (!this.options.subpixelPositioning) {
                offsetedPos = offsetedPos.round();
            }
            DOM.setTransform(this._container, `${anchorTranslate[anchor]} translate(${offsetedPos.x}px,${offsetedPos.y}px)`);
            applyAnchorClass(this._container, anchor, 'popup');
        };
        this._onClose = () => {
            this.remove();
        };
        this.options = performance$1.e(Object.create(defaultOptions), options);
    }
    /**
     * Adds the popup to a map.
     *
     * @param map - The MapLibre GL JS map to add the popup to.
     * @example
     * ```ts
     * new Popup()
     *   .setLngLat([0, 0])
     *   .setHTML("<h1>Null Island</h1>")
     *   .addTo(map);
     * ```
     * @see [Display a popup](https://maplibre.org/maplibre-gl-js/docs/examples/popup/)
     * @see [Display a popup on hover](https://maplibre.org/maplibre-gl-js/docs/examples/popup-on-hover/)
     * @see [Display a popup on click](https://maplibre.org/maplibre-gl-js/docs/examples/popup-on-click/)
     * @see [Show polygon information on click](https://maplibre.org/maplibre-gl-js/docs/examples/polygon-popup-on-click/)
     */
    addTo(map) {
        if (this._map)
            this.remove();
        this._map = map;
        if (this.options.closeOnClick) {
            this._map.on('click', this._onClose);
        }
        if (this.options.closeOnMove) {
            this._map.on('move', this._onClose);
        }
        this._map.on('remove', this.remove);
        this._update();
        this._focusFirstElement();
        if (this._trackPointer) {
            this._map.on('mousemove', this._onMouseMove);
            this._map.on('mouseup', this._onMouseUp);
            if (this._container) {
                this._container.classList.add('maplibregl-popup-track-pointer');
            }
            this._map._canvasContainer.classList.add('maplibregl-track-pointer');
        }
        else {
            this._map.on('move', this._update);
        }
        this.fire(new performance$1.k('open'));
        return this;
    }
    /**
     * @returns `true` if the popup is open, `false` if it is closed.
     */
    isOpen() {
        return !!this._map;
    }
    /**
     * Returns the geographical location of the popup's anchor.
     *
     * The longitude of the result may differ by a multiple of 360 degrees from the longitude previously
     * set by `setLngLat` because `Popup` wraps the anchor longitude across copies of the world to keep
     * the popup on screen.
     *
     * @returns The geographical location of the popup's anchor.
     */
    getLngLat() {
        return this._lngLat;
    }
    /**
     * Sets the geographical location of the popup's anchor, and moves the popup to it. Replaces trackPointer() behavior.
     *
     * @param lnglat - The geographical location to set as the popup's anchor.
     */
    setLngLat(lnglat) {
        this._lngLat = performance$1.N.convert(lnglat);
        this._pos = null;
        this._flatPos = null;
        this._trackPointer = false;
        this._update();
        if (this._map) {
            this._map.on('move', this._update);
            this._map.off('mousemove', this._onMouseMove);
            if (this._container) {
                this._container.classList.remove('maplibregl-popup-track-pointer');
            }
            this._map._canvasContainer.classList.remove('maplibregl-track-pointer');
        }
        return this;
    }
    /**
     * Tracks the popup anchor to the cursor position on screens with a pointer device (it will be hidden on touchscreens). Replaces the `setLngLat` behavior.
     * For most use cases, set `closeOnClick` and `closeButton` to `false`.
     * @example
     * ```ts
     * let popup = new Popup({ closeOnClick: false, closeButton: false })
     *   .setHTML("<h1>Hello World!</h1>")
     *   .trackPointer()
     *   .addTo(map);
     * ```
     */
    trackPointer() {
        this._trackPointer = true;
        this._pos = null;
        this._flatPos = null;
        this._update();
        if (this._map) {
            this._map.off('move', this._update);
            this._map.on('mousemove', this._onMouseMove);
            this._map.on('drag', this._onDrag);
            if (this._container) {
                this._container.classList.add('maplibregl-popup-track-pointer');
            }
            this._map._canvasContainer.classList.add('maplibregl-track-pointer');
        }
        return this;
    }
    /**
     * Returns the `Popup`'s HTML element.
     * @example
     * Change the `Popup` element's font size
     * ```ts
     * let popup = new Popup()
     *   .setLngLat([-96, 37.8])
     *   .setHTML("<p>Hello World!</p>")
     *   .addTo(map);
     * let popupElem = popup.getElement();
     * popupElem.style.fontSize = "25px";
     * ```
     * @returns element
     */
    getElement() {
        return this._container;
    }
    /**
     * Sets the popup's content to a string of text.
     *
     * This function creates a [Text](https://developer.mozilla.org/en-US/docs/Web/API/Text) node in the DOM,
     * so it cannot insert raw HTML. Use this method for security against XSS
     * if the popup content is user-provided.
     *
     * @param text - Textual content for the popup.
     * @example
     * ```ts
     * let popup = new Popup()
     *   .setLngLat(e.lngLat)
     *   .setText('Hello, world!')
     *   .addTo(map);
     * ```
     */
    setText(text) {
        return this.setDOMContent(document.createTextNode(text));
    }
    /**
     * Sets the popup's content to the HTML provided as a string.
     *
     * This method does not perform HTML filtering or sanitization, and must be
     * used only with trusted content. Consider {@link Popup#setText} if
     * the content is an untrusted text string.
     *
     * @param html - A string representing HTML content for the popup.
     * @example
     * ```ts
     * let popup = new Popup()
     *   .setLngLat(e.lngLat)
     *   .setHTML("<h1>Hello World!</h1>")
     *   .addTo(map);
     * ```
     * @see [Display a popup](https://maplibre.org/maplibre-gl-js/docs/examples/popup/)
     * @see [Display a popup on hover](https://maplibre.org/maplibre-gl-js/docs/examples/popup-on-hover/)
     * @see [Display a popup on click](https://maplibre.org/maplibre-gl-js/docs/examples/popup-on-click/)
     * @see [Attach a popup to a marker instance](https://maplibre.org/maplibre-gl-js/docs/examples/set-popup/)
     */
    setHTML(html) {
        const frag = document.createDocumentFragment();
        const temp = document.createElement('body');
        let child;
        temp.innerHTML = html;
        while (true) {
            child = temp.firstChild;
            if (!child)
                break;
            frag.appendChild(child);
        }
        return this.setDOMContent(frag);
    }
    /**
     * Returns the popup's maximum width.
     *
     * @returns The maximum width of the popup.
     */
    getMaxWidth() {
        var _a;
        return (_a = this._container) === null || _a === void 0 ? void 0 : _a.style.maxWidth;
    }
    /**
     * Sets the popup's maximum width. This is setting the CSS property `max-width`.
     * Available values can be found here: https://developer.mozilla.org/en-US/docs/Web/CSS/max-width
     *
     * @param maxWidth - A string representing the value for the maximum width.
     */
    setMaxWidth(maxWidth) {
        this.options.maxWidth = maxWidth;
        this._update();
        return this;
    }
    /**
     * Sets the popup's content to the element provided as a DOM node.
     *
     * @param htmlNode - A DOM node to be used as content for the popup.
     * @example
     * Create an element with the popup content
     * ```ts
     * let div = document.createElement('div');
     * div.innerHTML = 'Hello, world!';
     * let popup = new Popup()
     *   .setLngLat(e.lngLat)
     *   .setDOMContent(div)
     *   .addTo(map);
     * ```
     */
    setDOMContent(htmlNode) {
        if (this._content) {
            // Clear out children first.
            while (this._content.hasChildNodes()) {
                if (this._content.firstChild) {
                    this._content.removeChild(this._content.firstChild);
                }
            }
        }
        else {
            this._content = DOM.create('div', 'maplibregl-popup-content', this._container);
        }
        // The close button should be the last tabbable element inside the popup for a good keyboard UX.
        this._content.appendChild(htmlNode);
        this._createCloseButton();
        this._update();
        this._focusFirstElement();
        return this;
    }
    /**
     * Adds a CSS class to the popup container element.
     *
     * @param className - Non-empty string with CSS class name to add to popup container
     *
     * @example
     * ```ts
     * let popup = new Popup()
     * popup.addClassName('some-class')
     * ```
     */
    addClassName(className) {
        if (this._container) {
            this._container.classList.add(className);
        }
        return this;
    }
    /**
     * Removes a CSS class from the popup container element.
     *
     * @param className - Non-empty string with CSS class name to remove from popup container
     *
     * @example
     * ```ts
     * let popup = new Popup()
     * popup.removeClassName('some-class')
     * ```
     */
    removeClassName(className) {
        if (this._container) {
            this._container.classList.remove(className);
        }
        return this;
    }
    /**
     * Sets the popup's offset.
     *
     * @param offset - Sets the popup's offset.
     */
    setOffset(offset) {
        this.options.offset = offset;
        this._update();
        return this;
    }
    /**
     * Add or remove the given CSS class on the popup container, depending on whether the container currently has that class.
     *
     * @param className - Non-empty string with CSS class name to add/remove
     *
     * @returns if the class was removed return false, if class was added, then return true, undefined if there is no container
     *
     * @example
     * ```ts
     * let popup = new Popup()
     * popup.toggleClassName('toggleClass')
     * ```
     */
    toggleClassName(className) {
        if (this._container) {
            return this._container.classList.toggle(className);
        }
    }
    /**
     * Set the option to allow subpixel positioning of the popup by passing a boolean
     *
     * @param value - When boolean is true, subpixel positioning is enabled for the popup.
     *
     * @example
     * ```ts
     * let popup = new Popup()
     * popup.setSubpixelPositioning(true);
     * ```
     */
    setSubpixelPositioning(value) {
        this.options.subpixelPositioning = value;
    }
    _createCloseButton() {
        if (this.options.closeButton) {
            this._closeButton = DOM.create('button', 'maplibregl-popup-close-button', this._content);
            this._closeButton.type = 'button';
            this._closeButton.innerHTML = '&#215;';
            this._closeButton.addEventListener('click', this._onClose);
        }
    }
    _focusFirstElement() {
        if (!this.options.focusAfterOpen || !this._container)
            return;
        const firstFocusable = this._container.querySelector(focusQuerySelector);
        if (firstFocusable)
            firstFocusable.focus();
    }
}
function normalizeOffset(offset) {
    if (!offset) {
        return normalizeOffset(new performance$1.P(0, 0));
    }
    else if (typeof offset === 'number') {
        // input specifies a radius from which to calculate offsets at all positions
        const cornerOffset = Math.round(Math.abs(offset) / Math.SQRT2);
        return {
            'center': new performance$1.P(0, 0),
            'top': new performance$1.P(0, offset),
            'top-left': new performance$1.P(cornerOffset, cornerOffset),
            'top-right': new performance$1.P(-cornerOffset, cornerOffset),
            'bottom': new performance$1.P(0, -offset),
            'bottom-left': new performance$1.P(cornerOffset, -cornerOffset),
            'bottom-right': new performance$1.P(-cornerOffset, -cornerOffset),
            'left': new performance$1.P(offset, 0),
            'right': new performance$1.P(-offset, 0)
        };
    }
    else if (offset instanceof performance$1.P || Array.isArray(offset)) {
        // input specifies a single offset to be applied to all positions
        const convertedOffset = performance$1.P.convert(offset);
        return {
            'center': convertedOffset,
            'top': convertedOffset,
            'top-left': convertedOffset,
            'top-right': convertedOffset,
            'bottom': convertedOffset,
            'bottom-left': convertedOffset,
            'bottom-right': convertedOffset,
            'left': convertedOffset,
            'right': convertedOffset
        };
    }
    else {
        // input specifies an offset per position
        return {
            'center': performance$1.P.convert(offset['center'] || [0, 0]),
            'top': performance$1.P.convert(offset['top'] || [0, 0]),
            'top-left': performance$1.P.convert(offset['top-left'] || [0, 0]),
            'top-right': performance$1.P.convert(offset['top-right'] || [0, 0]),
            'bottom': performance$1.P.convert(offset['bottom'] || [0, 0]),
            'bottom-left': performance$1.P.convert(offset['bottom-left'] || [0, 0]),
            'bottom-right': performance$1.P.convert(offset['bottom-right'] || [0, 0]),
            'left': performance$1.P.convert(offset['left'] || [0, 0]),
            'right': performance$1.P.convert(offset['right'] || [0, 0])
        };
    }
}

const version = packageJSON.version;
/**
 * Sets the map's [RTL text plugin](https://www.mapbox.com/mapbox-gl-js/plugins/#mapbox-gl-rtl-text).
 * Necessary for supporting the Arabic and Hebrew languages, which are written right-to-left.
 *
 * @param pluginURL - URL pointing to the Mapbox RTL text plugin source.
 * @param lazy - If set to `true`, maplibre will defer loading the plugin until rtl text is encountered,
 * rtl text will then be rendered only after the plugin finishes loading.
 * @example
 * ```ts
 * setRTLTextPlugin('https://unpkg.com/@mapbox/mapbox-gl-rtl-text@0.2.3/mapbox-gl-rtl-text.js', false);
 * ```
 * @see [Add support for right-to-left scripts](https://maplibre.org/maplibre-gl-js/docs/examples/mapbox-gl-rtl-text/)
 */
function setRTLTextPlugin(pluginURL, lazy) {
    return rtlMainThreadPluginFactory().setRTLTextPlugin(pluginURL, lazy);
}
/**
 * Gets the map's [RTL text plugin](https://www.mapbox.com/mapbox-gl-js/plugins/#mapbox-gl-rtl-text) status.
 * The status can be `unavailable` (i.e. not requested or removed), `loading`, `loaded` or `error`.
 * If the status is `loaded` and the plugin is requested again, an error will be thrown.
 *
 * @example
 * ```ts
 * const pluginStatus = getRTLTextPluginStatus();
 * ```
 */
function getRTLTextPluginStatus() {
    return rtlMainThreadPluginFactory().getRTLTextPluginStatus();
}
/**
 * Returns the package version of the library
 * @returns Package version of the library
 */
function getVersion() { return version; }
/**
 * Gets the number of web workers instantiated on a page with GL JS maps.
 * By default, workerCount is 1 except for Safari browser where it is set to half the number of CPU cores (capped at 3).
 * Make sure to set this property before creating any map instances for it to have effect.
 *
 * @returns Number of workers currently configured.
 * @example
 * ```ts
 * const workerCount = getWorkerCount()
 * ```
 */
function getWorkerCount() { return WorkerPool.workerCount; }
/**
 * Sets the number of web workers instantiated on a page with GL JS maps.
 * By default, workerCount is 1 except for Safari browser where it is set to half the number of CPU cores (capped at 3).
 * Make sure to set this property before creating any map instances for it to have effect.
 *
 * @example
 * ```ts
 * setWorkerCount(2);
 * ```
 */
function setWorkerCount(count) { WorkerPool.workerCount = count; }
/**
 * Gets and sets the maximum number of images (raster tiles, sprites, icons) to load in parallel,
 * which affects performance in raster-heavy maps. 16 by default.
 *
 * @returns Number of parallel requests currently configured.
 * @example
 * ```ts
 * getMaxParallelImageRequests();
 * ```
 */
function getMaxParallelImageRequests() { return performance$1.a.MAX_PARALLEL_IMAGE_REQUESTS; }
/**
 * Sets the maximum number of images (raster tiles, sprites, icons) to load in parallel,
 * which affects performance in raster-heavy maps. 16 by default.
 *
 * @example
 * ```ts
 * setMaxParallelImageRequests(10);
 * ```
 */
function setMaxParallelImageRequests(numRequests) { performance$1.a.MAX_PARALLEL_IMAGE_REQUESTS = numRequests; }
/**
 * Gets the worker url
 * @returns The worker url
 */
function getWorkerUrl() { return performance$1.a.WORKER_URL; }
/**
 * Sets the worker url
 */
function setWorkerUrl(value) { performance$1.a.WORKER_URL = value; }
/**
 * Allows loading javascript code in the worker thread.
 * *Note* that since this is using some very internal classes and flows it is considered experimental and can break at any point.
 *
 * It can be useful for the following examples:
 * 1. Using `self.addProtocol` in the worker thread - note that you might need to also register the protocol on the main thread.
 * 2. Using `self.registerWorkerSource(workerSource: WorkerSource)` to register a worker source, which should come with `addSourceType` usually.
 * 3. using `self.actor.registerMessageHandler` to override some internal worker operations
 * @param workerUrl - the worker url e.g. a url of a javascript file to load in the worker
 * @returns
 *
 * @example
 * ```ts
 * // below is an example of sending a js file to the worker to load the method there
 * // Note that you'll need to call the global function `addProtocol` in the worker to register the protocol there.
 * // add-protocol-worker.js
 * async function loadFn(params, abortController) {
 *     const t = await fetch(`https://${params.url.split("://")[1]}`);
 *     if (t.status == 200) {
 *         const buffer = await t.arrayBuffer();
 *         return {data: buffer}
 *     } else {
 *         throw new Error(`Tile fetch error: ${t.statusText}`);
 *     }
 * }
 * self.addProtocol('custom', loadFn);
 *
 * // main.js
 * importScriptInWorkers('add-protocol-worker.js');
 * ```
 */
function importScriptInWorkers(workerUrl) { return getGlobalDispatcher().broadcast("IS" /* MessageType.importScript */, workerUrl); }

exports.AJAXError = performance$1.bg;
exports.Evented = performance$1.E;
exports.LngLat = performance$1.N;
exports.MercatorCoordinate = performance$1.Z;
exports.Point = performance$1.P;
exports.addProtocol = performance$1.bh;
exports.config = performance$1.a;
exports.removeProtocol = performance$1.bi;
exports.AttributionControl = AttributionControl;
exports.BoxZoomHandler = BoxZoomHandler;
exports.CanvasSource = CanvasSource;
exports.CooperativeGesturesHandler = CooperativeGesturesHandler;
exports.DoubleClickZoomHandler = DoubleClickZoomHandler;
exports.DragPanHandler = DragPanHandler;
exports.DragRotateHandler = DragRotateHandler;
exports.EdgeInsets = EdgeInsets;
exports.FullscreenControl = FullscreenControl;
exports.GeoJSONSource = GeoJSONSource;
exports.GeolocateControl = GeolocateControl;
exports.Hash = Hash;
exports.ImageSource = ImageSource;
exports.KeyboardHandler = KeyboardHandler;
exports.LngLatBounds = LngLatBounds;
exports.LogoControl = LogoControl;
exports.Map = Map$1;
exports.MapMouseEvent = MapMouseEvent;
exports.MapTouchEvent = MapTouchEvent;
exports.MapWheelEvent = MapWheelEvent;
exports.Marker = Marker;
exports.NavigationControl = NavigationControl;
exports.Popup = Popup;
exports.RasterDEMTileSource = RasterDEMTileSource;
exports.RasterTileSource = RasterTileSource;
exports.ScaleControl = ScaleControl;
exports.ScrollZoomHandler = ScrollZoomHandler;
exports.Style = Style;
exports.TerrainControl = TerrainControl;
exports.TwoFingersTouchPitchHandler = TwoFingersTouchPitchHandler;
exports.TwoFingersTouchRotateHandler = TwoFingersTouchRotateHandler;
exports.TwoFingersTouchZoomHandler = TwoFingersTouchZoomHandler;
exports.TwoFingersTouchZoomRotateHandler = TwoFingersTouchZoomRotateHandler;
exports.VectorTileSource = VectorTileSource;
exports.VideoSource = VideoSource;
exports.addSourceType = addSourceType;
exports.clearPrewarmedResources = clearPrewarmedResources;
exports.getMaxParallelImageRequests = getMaxParallelImageRequests;
exports.getRTLTextPluginStatus = getRTLTextPluginStatus;
exports.getVersion = getVersion;
exports.getWorkerCount = getWorkerCount;
exports.getWorkerUrl = getWorkerUrl;
exports.importScriptInWorkers = importScriptInWorkers;
exports.prewarm = prewarm;
exports.setMaxParallelImageRequests = setMaxParallelImageRequests;
exports.setRTLTextPlugin = setRTLTextPlugin;
exports.setWorkerCount = setWorkerCount;
exports.setWorkerUrl = setWorkerUrl;

}));

//
// Our custom intro provides a specialized "define()" function, called by the
// AMD modules below, that sets up the worker blob URL and then executes the
// main module, storing its exported value as 'maplibregl'


var maplibregl$1 = maplibregl;

return maplibregl$1;

}));
//# sourceMappingURL=maplibre-gl-unminified.js.map


/***/ }),

/***/ 88640:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  GW: function() { return /* reexport */ value; },
  Dj: function() { return /* reexport */ number; }
});

// UNUSED EXPORTS: interpolateArray, interpolateBasis, interpolateBasisClosed, interpolateCubehelix, interpolateCubehelixLong, interpolateDate, interpolateDiscrete, interpolateHcl, interpolateHclLong, interpolateHsl, interpolateHslLong, interpolateHue, interpolateLab, interpolateNumberArray, interpolateObject, interpolateRgb, interpolateRgbBasis, interpolateRgbBasisClosed, interpolateRound, interpolateString, interpolateTransformCss, interpolateTransformSvg, interpolateZoom, piecewise, quantize

;// CONCATENATED MODULE: ./node_modules/d3-color/src/define.js
/* harmony default export */ function src_define(constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
}
function extend(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition) prototype[key] = definition[key];
  return prototype;
}
;// CONCATENATED MODULE: ./node_modules/d3-color/src/color.js

function Color() {}
var _darker = 0.7;

var _brighter = 1 / _darker;

var reI = "\\s*([+-]?\\d+)\\s*",
  reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*",
  reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
  reHex = /^#([0-9a-f]{3,8})$/,
  reRgbInteger = new RegExp("^rgb\\(".concat(reI, ",").concat(reI, ",").concat(reI, "\\)$")),
  reRgbPercent = new RegExp("^rgb\\(".concat(reP, ",").concat(reP, ",").concat(reP, "\\)$")),
  reRgbaInteger = new RegExp("^rgba\\(".concat(reI, ",").concat(reI, ",").concat(reI, ",").concat(reN, "\\)$")),
  reRgbaPercent = new RegExp("^rgba\\(".concat(reP, ",").concat(reP, ",").concat(reP, ",").concat(reN, "\\)$")),
  reHslPercent = new RegExp("^hsl\\(".concat(reN, ",").concat(reP, ",").concat(reP, "\\)$")),
  reHslaPercent = new RegExp("^hsla\\(".concat(reN, ",").concat(reP, ",").concat(reP, ",").concat(reN, "\\)$"));
var named = {
  aliceblue: 0xf0f8ff,
  antiquewhite: 0xfaebd7,
  aqua: 0x00ffff,
  aquamarine: 0x7fffd4,
  azure: 0xf0ffff,
  beige: 0xf5f5dc,
  bisque: 0xffe4c4,
  black: 0x000000,
  blanchedalmond: 0xffebcd,
  blue: 0x0000ff,
  blueviolet: 0x8a2be2,
  brown: 0xa52a2a,
  burlywood: 0xdeb887,
  cadetblue: 0x5f9ea0,
  chartreuse: 0x7fff00,
  chocolate: 0xd2691e,
  coral: 0xff7f50,
  cornflowerblue: 0x6495ed,
  cornsilk: 0xfff8dc,
  crimson: 0xdc143c,
  cyan: 0x00ffff,
  darkblue: 0x00008b,
  darkcyan: 0x008b8b,
  darkgoldenrod: 0xb8860b,
  darkgray: 0xa9a9a9,
  darkgreen: 0x006400,
  darkgrey: 0xa9a9a9,
  darkkhaki: 0xbdb76b,
  darkmagenta: 0x8b008b,
  darkolivegreen: 0x556b2f,
  darkorange: 0xff8c00,
  darkorchid: 0x9932cc,
  darkred: 0x8b0000,
  darksalmon: 0xe9967a,
  darkseagreen: 0x8fbc8f,
  darkslateblue: 0x483d8b,
  darkslategray: 0x2f4f4f,
  darkslategrey: 0x2f4f4f,
  darkturquoise: 0x00ced1,
  darkviolet: 0x9400d3,
  deeppink: 0xff1493,
  deepskyblue: 0x00bfff,
  dimgray: 0x696969,
  dimgrey: 0x696969,
  dodgerblue: 0x1e90ff,
  firebrick: 0xb22222,
  floralwhite: 0xfffaf0,
  forestgreen: 0x228b22,
  fuchsia: 0xff00ff,
  gainsboro: 0xdcdcdc,
  ghostwhite: 0xf8f8ff,
  gold: 0xffd700,
  goldenrod: 0xdaa520,
  gray: 0x808080,
  green: 0x008000,
  greenyellow: 0xadff2f,
  grey: 0x808080,
  honeydew: 0xf0fff0,
  hotpink: 0xff69b4,
  indianred: 0xcd5c5c,
  indigo: 0x4b0082,
  ivory: 0xfffff0,
  khaki: 0xf0e68c,
  lavender: 0xe6e6fa,
  lavenderblush: 0xfff0f5,
  lawngreen: 0x7cfc00,
  lemonchiffon: 0xfffacd,
  lightblue: 0xadd8e6,
  lightcoral: 0xf08080,
  lightcyan: 0xe0ffff,
  lightgoldenrodyellow: 0xfafad2,
  lightgray: 0xd3d3d3,
  lightgreen: 0x90ee90,
  lightgrey: 0xd3d3d3,
  lightpink: 0xffb6c1,
  lightsalmon: 0xffa07a,
  lightseagreen: 0x20b2aa,
  lightskyblue: 0x87cefa,
  lightslategray: 0x778899,
  lightslategrey: 0x778899,
  lightsteelblue: 0xb0c4de,
  lightyellow: 0xffffe0,
  lime: 0x00ff00,
  limegreen: 0x32cd32,
  linen: 0xfaf0e6,
  magenta: 0xff00ff,
  maroon: 0x800000,
  mediumaquamarine: 0x66cdaa,
  mediumblue: 0x0000cd,
  mediumorchid: 0xba55d3,
  mediumpurple: 0x9370db,
  mediumseagreen: 0x3cb371,
  mediumslateblue: 0x7b68ee,
  mediumspringgreen: 0x00fa9a,
  mediumturquoise: 0x48d1cc,
  mediumvioletred: 0xc71585,
  midnightblue: 0x191970,
  mintcream: 0xf5fffa,
  mistyrose: 0xffe4e1,
  moccasin: 0xffe4b5,
  navajowhite: 0xffdead,
  navy: 0x000080,
  oldlace: 0xfdf5e6,
  olive: 0x808000,
  olivedrab: 0x6b8e23,
  orange: 0xffa500,
  orangered: 0xff4500,
  orchid: 0xda70d6,
  palegoldenrod: 0xeee8aa,
  palegreen: 0x98fb98,
  paleturquoise: 0xafeeee,
  palevioletred: 0xdb7093,
  papayawhip: 0xffefd5,
  peachpuff: 0xffdab9,
  peru: 0xcd853f,
  pink: 0xffc0cb,
  plum: 0xdda0dd,
  powderblue: 0xb0e0e6,
  purple: 0x800080,
  rebeccapurple: 0x663399,
  red: 0xff0000,
  rosybrown: 0xbc8f8f,
  royalblue: 0x4169e1,
  saddlebrown: 0x8b4513,
  salmon: 0xfa8072,
  sandybrown: 0xf4a460,
  seagreen: 0x2e8b57,
  seashell: 0xfff5ee,
  sienna: 0xa0522d,
  silver: 0xc0c0c0,
  skyblue: 0x87ceeb,
  slateblue: 0x6a5acd,
  slategray: 0x708090,
  slategrey: 0x708090,
  snow: 0xfffafa,
  springgreen: 0x00ff7f,
  steelblue: 0x4682b4,
  tan: 0xd2b48c,
  teal: 0x008080,
  thistle: 0xd8bfd8,
  tomato: 0xff6347,
  turquoise: 0x40e0d0,
  violet: 0xee82ee,
  wheat: 0xf5deb3,
  white: 0xffffff,
  whitesmoke: 0xf5f5f5,
  yellow: 0xffff00,
  yellowgreen: 0x9acd32
};
src_define(Color, color, {
  copy: function copy(channels) {
    return Object.assign(new this.constructor(), this, channels);
  },
  displayable: function displayable() {
    return this.rgb().displayable();
  },
  hex: color_formatHex,
  // Deprecated! Use color.formatHex.
  formatHex: color_formatHex,
  formatHex8: color_formatHex8,
  formatHsl: color_formatHsl,
  formatRgb: color_formatRgb,
  toString: color_formatRgb
});
function color_formatHex() {
  return this.rgb().formatHex();
}
function color_formatHex8() {
  return this.rgb().formatHex8();
}
function color_formatHsl() {
  return hslConvert(this).formatHsl();
}
function color_formatRgb() {
  return this.rgb().formatRgb();
}
function color(format) {
  var m, l;
  format = (format + "").trim().toLowerCase();
  return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
  : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
  : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
  : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
  : null // invalid hex
  ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
  : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
  : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
  : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
  : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
  : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
  : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
  : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
  if (a <= 0) r = g = b = NaN;
  return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Rgb();
  o = o.rgb();
  return new Rgb(o.r, o.g, o.b, o.opacity);
}
function color_rgb(r, g, b, opacity) {
  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
  this.r = +r;
  this.g = +g;
  this.b = +b;
  this.opacity = +opacity;
}
src_define(Rgb, color_rgb, extend(Color, {
  brighter: function brighter(k) {
    k = k == null ? _brighter : Math.pow(_brighter, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  darker: function darker(k) {
    k = k == null ? _darker : Math.pow(_darker, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  rgb: function rgb() {
    return this;
  },
  clamp: function clamp() {
    return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
  },
  displayable: function displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: rgb_formatHex,
  // Deprecated! Use color.formatHex.
  formatHex: rgb_formatHex,
  formatHex8: rgb_formatHex8,
  formatRgb: rgb_formatRgb,
  toString: rgb_formatRgb
}));
function rgb_formatHex() {
  return "#".concat(hex(this.r)).concat(hex(this.g)).concat(hex(this.b));
}
function rgb_formatHex8() {
  return "#".concat(hex(this.r)).concat(hex(this.g)).concat(hex(this.b)).concat(hex((isNaN(this.opacity) ? 1 : this.opacity) * 255));
}
function rgb_formatRgb() {
  var a = clampa(this.opacity);
  return "".concat(a === 1 ? "rgb(" : "rgba(").concat(clampi(this.r), ", ").concat(clampi(this.g), ", ").concat(clampi(this.b)).concat(a === 1 ? ")" : ", ".concat(a, ")"));
}
function clampa(opacity) {
  return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
  return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
  value = clampi(value);
  return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
  if (a <= 0) h = s = l = NaN;else if (l <= 0 || l >= 1) h = s = NaN;else if (s <= 0) h = NaN;
  return new Hsl(h, s, l, a);
}
function hslConvert(o) {
  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Hsl();
  if (o instanceof Hsl) return o;
  o = o.rgb();
  var r = o.r / 255,
    g = o.g / 255,
    b = o.b / 255,
    min = Math.min(r, g, b),
    max = Math.max(r, g, b),
    h = NaN,
    s = max - min,
    l = (max + min) / 2;
  if (s) {
    if (r === max) h = (g - b) / s + (g < b) * 6;else if (g === max) h = (b - r) / s + 2;else h = (r - g) / s + 4;
    s /= l < 0.5 ? max + min : 2 - max - min;
    h *= 60;
  } else {
    s = l > 0 && l < 1 ? 0 : h;
  }
  return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}
src_define(Hsl, hsl, extend(Color, {
  brighter: function brighter(k) {
    k = k == null ? _brighter : Math.pow(_brighter, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function darker(k) {
    k = k == null ? _darker : Math.pow(_darker, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function rgb() {
    var h = this.h % 360 + (this.h < 0) * 360,
      s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
      l = this.l,
      m2 = l + (l < 0.5 ? l : 1 - l) * s,
      m1 = 2 * l - m2;
    return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
  },
  clamp: function clamp() {
    return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
  },
  displayable: function displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl: function formatHsl() {
    var a = clampa(this.opacity);
    return "".concat(a === 1 ? "hsl(" : "hsla(").concat(clamph(this.h), ", ").concat(clampt(this.s) * 100, "%, ").concat(clampt(this.l) * 100, "%").concat(a === 1 ? ")" : ", ".concat(a, ")"));
  }
}));
function clamph(value) {
  value = (value || 0) % 360;
  return value < 0 ? value + 360 : value;
}
function clampt(value) {
  return Math.max(0, Math.min(1, value || 0));
}

/* From FvD 13.37, CSS Color Module Level 3 */
function hsl2rgb(h, m1, m2) {
  return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}
;// CONCATENATED MODULE: ./node_modules/d3-interpolate/src/basis.js
function basis(t1, v0, v1, v2, v3) {
  var t2 = t1 * t1,
    t3 = t2 * t1;
  return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
/* harmony default export */ function src_basis(values) {
  var n = values.length - 1;
  return function (t) {
    var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
      v1 = values[i],
      v2 = values[i + 1],
      v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
      v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
    return basis((t - i / n) * n, v0, v1, v2, v3);
  };
}
;// CONCATENATED MODULE: ./node_modules/d3-interpolate/src/basisClosed.js

/* harmony default export */ function basisClosed(values) {
  var n = values.length;
  return function (t) {
    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
      v0 = values[(i + n - 1) % n],
      v1 = values[i % n],
      v2 = values[(i + 1) % n],
      v3 = values[(i + 2) % n];
    return basis((t - i / n) * n, v0, v1, v2, v3);
  };
}
;// CONCATENATED MODULE: ./node_modules/d3-interpolate/src/constant.js
/* harmony default export */ var src_constant = (function (x) {
  return function () {
    return x;
  };
});
;// CONCATENATED MODULE: ./node_modules/d3-interpolate/src/color.js

function linear(a, d) {
  return function (t) {
    return a + t * d;
  };
}
function exponential(a, b, y) {
  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function (t) {
    return Math.pow(a + t * b, y);
  };
}
function hue(a, b) {
  var d = b - a;
  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : constant(isNaN(a) ? b : a);
}
function gamma(y) {
  return (y = +y) === 1 ? nogamma : function (a, b) {
    return b - a ? exponential(a, b, y) : src_constant(isNaN(a) ? b : a);
  };
}
function nogamma(a, b) {
  var d = b - a;
  return d ? linear(a, d) : src_constant(isNaN(a) ? b : a);
}
;// CONCATENATED MODULE: ./node_modules/d3-interpolate/src/rgb.js




/* harmony default export */ var rgb = ((function rgbGamma(y) {
  var color = gamma(y);
  function rgb(start, end) {
    var r = color((start = color_rgb(start)).r, (end = color_rgb(end)).r),
      g = color(start.g, end.g),
      b = color(start.b, end.b),
      opacity = nogamma(start.opacity, end.opacity);
    return function (t) {
      start.r = r(t);
      start.g = g(t);
      start.b = b(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
  rgb.gamma = rgbGamma;
  return rgb;
})(1));
function rgbSpline(spline) {
  return function (colors) {
    var n = colors.length,
      r = new Array(n),
      g = new Array(n),
      b = new Array(n),
      i,
      color;
    for (i = 0; i < n; ++i) {
      color = color_rgb(colors[i]);
      r[i] = color.r || 0;
      g[i] = color.g || 0;
      b[i] = color.b || 0;
    }
    r = spline(r);
    g = spline(g);
    b = spline(b);
    color.opacity = 1;
    return function (t) {
      color.r = r(t);
      color.g = g(t);
      color.b = b(t);
      return color + "";
    };
  };
}
var rgbBasis = rgbSpline(src_basis);
var rgbBasisClosed = rgbSpline(basisClosed);
;// CONCATENATED MODULE: ./node_modules/d3-interpolate/src/array.js


/* harmony default export */ function array(a, b) {
  return (isNumberArray(b) ? numberArray : genericArray)(a, b);
}
function genericArray(a, b) {
  var nb = b ? b.length : 0,
    na = a ? Math.min(nb, a.length) : 0,
    x = new Array(na),
    c = new Array(nb),
    i;
  for (i = 0; i < na; ++i) x[i] = value(a[i], b[i]);
  for (; i < nb; ++i) c[i] = b[i];
  return function (t) {
    for (i = 0; i < na; ++i) c[i] = x[i](t);
    return c;
  };
}
;// CONCATENATED MODULE: ./node_modules/d3-interpolate/src/date.js
/* harmony default export */ function date(a, b) {
  var d = new Date();
  return a = +a, b = +b, function (t) {
    return d.setTime(a * (1 - t) + b * t), d;
  };
}
;// CONCATENATED MODULE: ./node_modules/d3-interpolate/src/number.js
/* harmony default export */ function number(a, b) {
  return a = +a, b = +b, function (t) {
    return a * (1 - t) + b * t;
  };
}
;// CONCATENATED MODULE: ./node_modules/d3-interpolate/src/object.js
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }

/* harmony default export */ function object(a, b) {
  var i = {},
    c = {},
    k;
  if (a === null || _typeof(a) !== "object") a = {};
  if (b === null || _typeof(b) !== "object") b = {};
  for (k in b) {
    if (k in a) {
      i[k] = value(a[k], b[k]);
    } else {
      c[k] = b[k];
    }
  }
  return function (t) {
    for (k in i) c[k] = i[k](t);
    return c;
  };
}
;// CONCATENATED MODULE: ./node_modules/d3-interpolate/src/string.js

var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
  reB = new RegExp(reA.source, "g");
function zero(b) {
  return function () {
    return b;
  };
}
function one(b) {
  return function (t) {
    return b(t) + "";
  };
}
/* harmony default export */ function string(a, b) {
  var bi = reA.lastIndex = reB.lastIndex = 0,
    // scan index for next number in b
    am,
    // current match in a
    bm,
    // current match in b
    bs,
    // string preceding current number in b, if any
    i = -1,
    // index in s
    s = [],
    // string constants and placeholders
    q = []; // number interpolators

  // Coerce inputs to strings.
  a = a + "", b = b + "";

  // Interpolate pairs of numbers in a & b.
  while ((am = reA.exec(a)) && (bm = reB.exec(b))) {
    if ((bs = bm.index) > bi) {
      // a string precedes the next number in b
      bs = b.slice(bi, bs);
      if (s[i]) s[i] += bs; // coalesce with previous string
      else s[++i] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) {
      // numbers in a & b match
      if (s[i]) s[i] += bm; // coalesce with previous string
      else s[++i] = bm;
    } else {
      // interpolate non-matching numbers
      s[++i] = null;
      q.push({
        i: i,
        x: number(am, bm)
      });
    }
    bi = reB.lastIndex;
  }

  // Add remains of b.
  if (bi < b.length) {
    bs = b.slice(bi);
    if (s[i]) s[i] += bs; // coalesce with previous string
    else s[++i] = bs;
  }

  // Special optimization for only a single match.
  // Otherwise, interpolate each of the numbers and rejoin the string.
  return s.length < 2 ? q[0] ? one(q[0].x) : zero(b) : (b = q.length, function (t) {
    for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
    return s.join("");
  });
}
;// CONCATENATED MODULE: ./node_modules/d3-interpolate/src/numberArray.js
/* harmony default export */ function src_numberArray(a, b) {
  if (!b) b = [];
  var n = a ? Math.min(b.length, a.length) : 0,
    c = b.slice(),
    i;
  return function (t) {
    for (i = 0; i < n; ++i) c[i] = a[i] * (1 - t) + b[i] * t;
    return c;
  };
}
function numberArray_isNumberArray(x) {
  return ArrayBuffer.isView(x) && !(x instanceof DataView);
}
;// CONCATENATED MODULE: ./node_modules/d3-interpolate/src/value.js
function value_typeof(o) { "@babel/helpers - typeof"; return value_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, value_typeof(o); }









/* harmony default export */ function value(a, b) {
  var t = value_typeof(b),
    c;
  return b == null || t === "boolean" ? src_constant(b) : (t === "number" ? number : t === "string" ? (c = color(b)) ? (b = c, rgb) : string : b instanceof color ? rgb : b instanceof Date ? date : numberArray_isNumberArray(b) ? src_numberArray : Array.isArray(b) ? genericArray : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object : number)(a, b);
}
;// CONCATENATED MODULE: ./node_modules/d3-interpolate/src/index.js






















/***/ }),

/***/ 23648:
/***/ (function(module) {

"use strict";
module.exports = /*#__PURE__*/JSON.parse('["xx-small","x-small","small","medium","large","x-large","xx-large","larger","smaller"]');

/***/ }),

/***/ 2362:
/***/ (function(module) {

"use strict";
module.exports = /*#__PURE__*/JSON.parse('["normal","condensed","semi-condensed","extra-condensed","ultra-condensed","expanded","semi-expanded","extra-expanded","ultra-expanded"]');

/***/ }),

/***/ 87486:
/***/ (function(module) {

"use strict";
module.exports = /*#__PURE__*/JSON.parse('["normal","italic","oblique"]');

/***/ }),

/***/ 99803:
/***/ (function(module) {

"use strict";
module.exports = /*#__PURE__*/JSON.parse('["normal","bold","bolder","lighter","100","200","300","400","500","600","700","800","900"]');

/***/ }),

/***/ 54324:
/***/ (function(module) {

"use strict";
module.exports = /*#__PURE__*/JSON.parse('["inherit","initial","unset"]');

/***/ }),

/***/ 94316:
/***/ (function(module) {

"use strict";
module.exports = /*#__PURE__*/JSON.parse('["caption","icon","menu","message-box","small-caption","status-bar"]');

/***/ }),

/***/ 37071:
/***/ (function(module) {

"use strict";
module.exports = /*#__PURE__*/JSON.parse('{"version":8,"name":"orto","metadata":{"maputnik:renderer":"mlgljs"},"center":[1.537786,41.837539],"zoom":12,"bearing":0,"pitch":0,"light":{"anchor":"viewport","color":"white","intensity":0.4,"position":[1.15,45,30]},"sources":{"ortoEsri":{"type":"raster","tiles":["https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"],"tileSize":256,"maxzoom":18,"attribution":"ESRI &copy; <a href=\'http://www.esri.com\'>ESRI</a>"},"ortoInstaMaps":{"type":"raster","tiles":["https://tilemaps.icgc.cat/mapfactory/wmts/orto_8_12/CAT3857/{z}/{x}/{y}.png"],"tileSize":256,"maxzoom":13},"ortoICGC":{"type":"raster","tiles":["https://geoserveis.icgc.cat/icc_mapesmultibase/noutm/wmts/orto/GRID3857/{z}/{x}/{y}.jpeg"],"tileSize":256,"minzoom":13.1,"maxzoom":20},"openmaptiles":{"type":"vector","url":"https://geoserveis.icgc.cat/contextmaps/basemap.json"}},"sprite":"https://geoserveis.icgc.cat/contextmaps/sprites/sprite@1","glyphs":"https://geoserveis.icgc.cat/contextmaps/glyphs/{fontstack}/{range}.pbf","layers":[{"id":"background","type":"background","paint":{"background-color":"#F4F9F4"}},{"id":"ortoEsri","type":"raster","source":"ortoEsri","maxzoom":16,"layout":{"visibility":"visible"}},{"id":"ortoICGC","type":"raster","source":"ortoICGC","minzoom":13.1,"maxzoom":19,"layout":{"visibility":"visible"}},{"id":"ortoInstaMaps","type":"raster","source":"ortoInstaMaps","maxzoom":13,"layout":{"visibility":"visible"}},{"id":"waterway_tunnel","type":"line","source":"openmaptiles","source-layer":"waterway","minzoom":14,"filter":["all",["in","class","river","stream","canal"],["==","brunnel","tunnel"]],"layout":{"line-cap":"round"},"paint":{"line-color":"#a0c8f0","line-width":{"base":1.3,"stops":[[13,0.5],[20,6]]},"line-dasharray":[2,4]}},{"id":"waterway-other","type":"line","metadata":{"mapbox:group":"1444849382550.77"},"source":"openmaptiles","source-layer":"waterway","filter":["!in","class","canal","river","stream"],"layout":{"line-cap":"round"},"paint":{"line-color":"#a0c8f0","line-width":{"base":1.3,"stops":[[13,0.5],[20,2]]}}},{"id":"waterway-stream-canal","type":"line","metadata":{"mapbox:group":"1444849382550.77"},"source":"openmaptiles","source-layer":"waterway","filter":["all",["in","class","canal","stream"],["!=","brunnel","tunnel"]],"layout":{"line-cap":"round"},"paint":{"line-color":"#a0c8f0","line-width":{"base":1.3,"stops":[[13,0.5],[20,6]]}}},{"id":"waterway-river","type":"line","metadata":{"mapbox:group":"1444849382550.77"},"source":"openmaptiles","source-layer":"waterway","filter":["all",["==","class","river"],["!=","brunnel","tunnel"]],"layout":{"line-cap":"round"},"paint":{"line-color":"#a0c8f0","line-width":{"base":1.2,"stops":[[10,0.8],[20,4]]},"line-opacity":0.5}},{"id":"water-offset","type":"fill","metadata":{"mapbox:group":"1444849382550.77"},"source":"openmaptiles","source-layer":"water","maxzoom":8,"filter":["==","$type","Polygon"],"layout":{"visibility":"visible"},"paint":{"fill-opacity":0,"fill-color":"#a0c8f0","fill-translate":{"base":1,"stops":[[6,[2,0]],[8,[0,0]]]}}},{"id":"water","type":"fill","metadata":{"mapbox:group":"1444849382550.77"},"source":"openmaptiles","source-layer":"water","layout":{"visibility":"visible"},"paint":{"fill-color":"hsl(210, 67%, 85%)","fill-opacity":0}},{"id":"water-pattern","type":"fill","metadata":{"mapbox:group":"1444849382550.77"},"source":"openmaptiles","source-layer":"water","layout":{"visibility":"visible"},"paint":{"fill-translate":[0,2.5],"fill-pattern":"wave","fill-opacity":1}},{"id":"landcover-ice-shelf","type":"fill","metadata":{"mapbox:group":"1444849382550.77"},"source":"openmaptiles","source-layer":"landcover","filter":["==","subclass","ice_shelf"],"layout":{"visibility":"visible"},"paint":{"fill-color":"#fff","fill-opacity":{"base":1,"stops":[[0,0.9],[10,0.3]]}}},{"id":"tunnel-service-track-casing","type":"line","metadata":{"mapbox:group":"1444849354174.1904"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","brunnel","tunnel"],["in","class","service","track"]],"layout":{"line-join":"round"},"paint":{"line-color":"#cfcdca","line-dasharray":[0.5,0.25],"line-width":{"base":1.2,"stops":[[15,1],[16,4],[20,11]]}}},{"id":"tunnel-minor-casing","type":"line","metadata":{"mapbox:group":"1444849354174.1904"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","brunnel","tunnel"],["==","class","minor"]],"layout":{"line-join":"round"},"paint":{"line-color":"#cfcdca","line-opacity":{"stops":[[12,0],[12.5,1]]},"line-width":{"base":1.2,"stops":[[12,0.5],[13,1],[14,4],[20,15]]}}},{"id":"tunnel-secondary-tertiary-casing","type":"line","metadata":{"mapbox:group":"1444849354174.1904"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","brunnel","tunnel"],["in","class","secondary","tertiary"]],"layout":{"line-join":"round"},"paint":{"line-color":"#e9ac77","line-opacity":1,"line-width":{"base":1.2,"stops":[[8,1.5],[20,17]]}}},{"id":"tunnel-trunk-primary-casing","type":"line","metadata":{"mapbox:group":"1444849354174.1904"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","brunnel","tunnel"],["in","class","primary","trunk"]],"layout":{"line-join":"round"},"paint":{"line-color":"#e9ac77","line-width":{"base":1.2,"stops":[[5,0.4],[6,0.6],[7,1.5],[20,22]]},"line-opacity":0.7}},{"id":"tunnel-motorway-casing","type":"line","metadata":{"mapbox:group":"1444849354174.1904"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","brunnel","tunnel"],["==","class","motorway"]],"layout":{"line-join":"round","visibility":"visible"},"paint":{"line-color":"#e9ac77","line-dasharray":[0.5,0.25],"line-width":{"base":1.2,"stops":[[5,0.4],[6,0.6],[7,1.5],[20,22]]},"line-opacity":0.5}},{"id":"tunnel-path","type":"line","metadata":{"mapbox:group":"1444849354174.1904"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","$type","LineString"],["all",["==","brunnel","tunnel"],["==","class","path"]]],"paint":{"line-color":"#cba","line-dasharray":[1.5,0.75],"line-width":{"base":1.2,"stops":[[15,1.2],[20,4]]}}},{"id":"tunnel-service-track","type":"line","metadata":{"mapbox:group":"1444849354174.1904"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","brunnel","tunnel"],["in","class","service","track"]],"layout":{"line-join":"round"},"paint":{"line-color":"#fff","line-width":{"base":1.2,"stops":[[15.5,0],[16,2],[20,7.5]]}}},{"id":"tunnel-minor","type":"line","metadata":{"mapbox:group":"1444849354174.1904"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","brunnel","tunnel"],["==","class","minor_road"]],"layout":{"line-join":"round"},"paint":{"line-color":"#fff","line-opacity":1,"line-width":{"base":1.2,"stops":[[13.5,0],[14,2.5],[20,11.5]]}}},{"id":"tunnel-secondary-tertiary","type":"line","metadata":{"mapbox:group":"1444849354174.1904"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","brunnel","tunnel"],["in","class","secondary","tertiary"]],"layout":{"line-join":"round"},"paint":{"line-color":"#fff4c6","line-width":{"base":1.2,"stops":[[6.5,0],[7,0.5],[20,10]]}}},{"id":"tunnel-trunk-primary","type":"line","metadata":{"mapbox:group":"1444849354174.1904"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","brunnel","tunnel"],["in","class","primary","trunk"]],"layout":{"line-join":"round"},"paint":{"line-color":"#fff4c6","line-width":{"base":1.2,"stops":[[6.5,0],[7,0.5],[20,18]]},"line-opacity":0.5}},{"id":"tunnel-motorway","type":"line","metadata":{"mapbox:group":"1444849354174.1904"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","brunnel","tunnel"],["==","class","motorway"]],"layout":{"line-join":"round","visibility":"visible"},"paint":{"line-color":"#ffdaa6","line-width":{"base":1.2,"stops":[[6.5,0],[7,0.5],[20,18]]},"line-opacity":0.5}},{"id":"tunnel-railway","type":"line","metadata":{"mapbox:group":"1444849354174.1904"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","brunnel","tunnel"],["==","class","rail"]],"paint":{"line-color":"#bbb","line-width":{"base":1.4,"stops":[[14,0.4],[15,0.75],[20,2]]},"line-dasharray":[2,2]}},{"id":"ferry","type":"line","source":"openmaptiles","source-layer":"transportation","filter":["all",["in","class","ferry"]],"layout":{"line-join":"round","visibility":"visible"},"paint":{"line-color":"rgba(108, 159, 182, 1)","line-width":1.1,"line-dasharray":[2,2]}},{"id":"aeroway-taxiway-casing","type":"line","metadata":{"mapbox:group":"1444849345966.4436"},"source":"openmaptiles","source-layer":"aeroway","minzoom":12,"filter":["all",["in","class","taxiway"]],"layout":{"line-cap":"round","line-join":"round","visibility":"visible"},"paint":{"line-color":"rgba(153, 153, 153, 1)","line-width":{"base":1.5,"stops":[[11,2],[17,12]]},"line-opacity":1}},{"id":"aeroway-runway-casing","type":"line","metadata":{"mapbox:group":"1444849345966.4436"},"source":"openmaptiles","source-layer":"aeroway","minzoom":12,"filter":["all",["in","class","runway"]],"layout":{"line-cap":"round","line-join":"round","visibility":"visible"},"paint":{"line-color":"rgba(153, 153, 153, 1)","line-width":{"base":1.5,"stops":[[11,5],[17,55]]},"line-opacity":1}},{"id":"aeroway-taxiway","type":"line","metadata":{"mapbox:group":"1444849345966.4436"},"source":"openmaptiles","source-layer":"aeroway","minzoom":4,"filter":["all",["in","class","taxiway"],["==","$type","LineString"]],"layout":{"line-cap":"round","line-join":"round","visibility":"visible"},"paint":{"line-color":"rgba(255, 255, 255, 1)","line-width":{"base":1.5,"stops":[[11,1],[17,10]]},"line-opacity":{"base":1,"stops":[[11,0],[12,1]]}}},{"id":"aeroway-runway","type":"line","metadata":{"mapbox:group":"1444849345966.4436"},"source":"openmaptiles","source-layer":"aeroway","minzoom":4,"filter":["all",["in","class","runway"],["==","$type","LineString"]],"layout":{"line-cap":"round","line-join":"round","visibility":"visible"},"paint":{"line-color":"rgba(255, 255, 255, 1)","line-width":{"base":1.5,"stops":[[11,4],[17,50]]},"line-opacity":{"base":1,"stops":[[11,0],[12,1]]}}},{"id":"highway-motorway-link-casing","type":"line","metadata":{"mapbox:group":"1444849345966.4436"},"source":"openmaptiles","source-layer":"transportation","minzoom":12,"filter":["all",["!in","brunnel","bridge","tunnel"],["==","class","motorway_link"]],"layout":{"line-cap":"round","line-join":"round"},"paint":{"line-color":"#e9ac77","line-opacity":1,"line-width":{"base":1.2,"stops":[[12,1],[13,3],[14,4],[20,15]]}}},{"id":"highway-link-casing","type":"line","metadata":{"mapbox:group":"1444849345966.4436"},"source":"openmaptiles","source-layer":"transportation","minzoom":13,"filter":["all",["!in","brunnel","bridge","tunnel"],["in","class","primary_link","secondary_link","tertiary_link","trunk_link"]],"layout":{"line-cap":"round","line-join":"round","visibility":"visible"},"paint":{"line-color":"#e9ac77","line-opacity":1,"line-width":{"base":1.2,"stops":[[12,1],[13,3],[14,4],[20,15]]}}},{"id":"highway-minor-casing","type":"line","metadata":{"mapbox:group":"1444849345966.4436"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","$type","LineString"],["all",["!=","brunnel","tunnel"],["in","class","minor","service","track"]]],"layout":{"line-cap":"round","line-join":"round"},"paint":{"line-color":"#cfcdca","line-opacity":{"stops":[[12,0],[12.5,0]]},"line-width":{"base":1.2,"stops":[[12,0.5],[13,1],[14,4],[20,15]]}}},{"id":"highway-secondary-tertiary-casing","type":"line","metadata":{"mapbox:group":"1444849345966.4436"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["!in","brunnel","bridge","tunnel"],["in","class","secondary","tertiary"]],"layout":{"line-cap":"butt","line-join":"round","visibility":"visible"},"paint":{"line-color":"#e9ac77","line-opacity":0.5,"line-width":{"base":1.2,"stops":[[8,1.5],[20,17]]}}},{"id":"highway-primary-casing","type":"line","metadata":{"mapbox:group":"1444849345966.4436"},"source":"openmaptiles","source-layer":"transportation","minzoom":5,"filter":["all",["!in","brunnel","bridge","tunnel"],["in","class","primary"]],"layout":{"line-cap":"butt","line-join":"round","visibility":"visible"},"paint":{"line-color":"#e9ac77","line-opacity":{"stops":[[7,0],[8,0.6]]},"line-width":{"base":1.2,"stops":[[7,0],[8,0.6],[9,1.5],[20,22]]}}},{"id":"highway-trunk-casing","type":"line","metadata":{"mapbox:group":"1444849345966.4436"},"source":"openmaptiles","source-layer":"transportation","minzoom":5,"filter":["all",["!in","brunnel","bridge","tunnel"],["in","class","trunk"]],"layout":{"line-cap":"butt","line-join":"round","visibility":"visible"},"paint":{"line-color":"#e9ac77","line-opacity":{"stops":[[5,0],[6,0.5]]},"line-width":{"base":1.2,"stops":[[5,0],[6,0.6],[7,1.5],[20,22]]}}},{"id":"highway-motorway-casing","type":"line","metadata":{"mapbox:group":"1444849345966.4436"},"source":"openmaptiles","source-layer":"transportation","minzoom":4,"filter":["all",["!in","brunnel","bridge","tunnel"],["==","class","motorway"]],"layout":{"line-cap":"butt","line-join":"round","visibility":"visible"},"paint":{"line-color":"#e9ac77","line-width":{"base":1.2,"stops":[[4,0],[5,0.4],[6,0.6],[7,1.5],[20,22]]},"line-opacity":{"stops":[[4,0],[5,0.5]]}}},{"id":"highway-path","type":"line","metadata":{"mapbox:group":"1444849345966.4436"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","$type","LineString"],["all",["!in","brunnel","bridge","tunnel"],["==","class","path"]]],"paint":{"line-color":"#cba","line-dasharray":[1.5,0.75],"line-width":{"base":1.2,"stops":[[15,1.2],[20,4]]}}},{"id":"highway-motorway-link","type":"line","metadata":{"mapbox:group":"1444849345966.4436"},"source":"openmaptiles","source-layer":"transportation","minzoom":12,"filter":["all",["!in","brunnel","bridge","tunnel"],["==","class","motorway_link"]],"layout":{"line-cap":"round","line-join":"round"},"paint":{"line-color":"#fc8","line-width":{"base":1.2,"stops":[[12.5,0],[13,1.5],[14,2.5],[20,11.5]]}}},{"id":"highway-link","type":"line","metadata":{"mapbox:group":"1444849345966.4436"},"source":"openmaptiles","source-layer":"transportation","minzoom":13,"filter":["all",["!in","brunnel","bridge","tunnel"],["in","class","primary_link","secondary_link","tertiary_link","trunk_link"]],"layout":{"line-cap":"round","line-join":"round","visibility":"visible"},"paint":{"line-color":"#fea","line-width":{"base":1.2,"stops":[[12.5,0],[13,1.5],[14,2.5],[20,11.5]]}}},{"id":"highway-minor","type":"line","metadata":{"mapbox:group":"1444849345966.4436"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","$type","LineString"],["all",["!=","brunnel","tunnel"],["in","class","minor","service","track"]]],"layout":{"line-cap":"round","line-join":"round"},"paint":{"line-color":"#fff","line-opacity":0.5,"line-width":{"base":1.2,"stops":[[13.5,0],[14,2.5],[20,11.5]]}}},{"id":"highway-secondary-tertiary","type":"line","metadata":{"mapbox:group":"1444849345966.4436"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["!in","brunnel","bridge","tunnel"],["in","class","secondary","tertiary"]],"layout":{"line-cap":"round","line-join":"round","visibility":"visible"},"paint":{"line-color":"#fea","line-width":{"base":1.2,"stops":[[6.5,0],[8,0.5],[20,13]]},"line-opacity":0.5}},{"id":"highway-primary","type":"line","metadata":{"mapbox:group":"1444849345966.4436"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","$type","LineString"],["all",["!in","brunnel","bridge","tunnel"],["in","class","primary"]]],"layout":{"line-cap":"round","line-join":"round","visibility":"visible"},"paint":{"line-color":"#fea","line-width":{"base":1.2,"stops":[[8.5,0],[9,0.5],[20,18]]},"line-opacity":0}},{"id":"highway-trunk","type":"line","metadata":{"mapbox:group":"1444849345966.4436"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","$type","LineString"],["all",["!in","brunnel","bridge","tunnel"],["in","class","trunk"]]],"layout":{"line-cap":"round","line-join":"round","visibility":"visible"},"paint":{"line-color":"#fea","line-width":{"base":1.2,"stops":[[6.5,0],[7,0.5],[20,18]]},"line-opacity":0.5}},{"id":"highway-motorway","type":"line","metadata":{"mapbox:group":"1444849345966.4436"},"source":"openmaptiles","source-layer":"transportation","minzoom":5,"filter":["all",["==","$type","LineString"],["all",["!in","brunnel","bridge","tunnel"],["==","class","motorway"]]],"layout":{"line-cap":"round","line-join":"round","visibility":"visible"},"paint":{"line-color":"#fc8","line-width":{"base":1.2,"stops":[[6.5,0],[7,0.5],[20,18]]},"line-opacity":0.5}},{"id":"railway-transit","type":"line","metadata":{"mapbox:group":"1444849345966.4436"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","$type","LineString"],["all",["==","class","transit"],["!in","brunnel","tunnel"]]],"layout":{"visibility":"visible"},"paint":{"line-color":"hsla(0, 0%, 73%, 0.77)","line-width":{"base":1.4,"stops":[[14,0.4],[20,1]]}}},{"id":"railway-transit-hatching","type":"line","metadata":{"mapbox:group":"1444849345966.4436"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","$type","LineString"],["all",["==","class","transit"],["!in","brunnel","tunnel"]]],"layout":{"visibility":"visible"},"paint":{"line-color":"hsla(0, 0%, 73%, 0.68)","line-dasharray":[0.2,8],"line-width":{"base":1.4,"stops":[[14.5,0],[15,2],[20,6]]}}},{"id":"railway-service","type":"line","metadata":{"mapbox:group":"1444849345966.4436"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","$type","LineString"],["all",["==","class","rail"],["has","service"]]],"paint":{"line-color":"hsla(0, 0%, 73%, 0.77)","line-width":{"base":1.4,"stops":[[14,0.4],[20,1]]}}},{"id":"railway-service-hatching","type":"line","metadata":{"mapbox:group":"1444849345966.4436"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","$type","LineString"],["all",["==","class","rail"],["has","service"]]],"layout":{"visibility":"visible"},"paint":{"line-color":"hsla(0, 0%, 73%, 0.68)","line-dasharray":[0.2,8],"line-width":{"base":1.4,"stops":[[14.5,0],[15,2],[20,6]]}}},{"id":"railway","type":"line","metadata":{"mapbox:group":"1444849345966.4436"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","$type","LineString"],["all",["!has","service"],["!in","brunnel","bridge","tunnel"],["==","class","rail"]]],"paint":{"line-color":"#bbb","line-width":{"base":1.4,"stops":[[14,0.4],[15,0.75],[20,2]]}}},{"id":"railway-hatching","type":"line","metadata":{"mapbox:group":"1444849345966.4436"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","$type","LineString"],["all",["!has","service"],["!in","brunnel","bridge","tunnel"],["==","class","rail"]]],"paint":{"line-color":"#bbb","line-dasharray":[0.2,8],"line-width":{"base":1.4,"stops":[[14.5,0],[15,3],[20,8]]}}},{"id":"bridge-motorway-link-casing","type":"line","metadata":{"mapbox:group":"1444849334699.1902"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","brunnel","bridge"],["==","class","motorway_link"]],"layout":{"line-join":"round"},"paint":{"line-color":"#e9ac77","line-opacity":1,"line-width":{"base":1.2,"stops":[[12,1],[13,3],[14,4],[20,15]]}}},{"id":"bridge-link-casing","type":"line","metadata":{"mapbox:group":"1444849334699.1902"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","brunnel","bridge"],["in","class","primary_link","secondary_link","tertiary_link","trunk_link"]],"layout":{"line-join":"round"},"paint":{"line-color":"#e9ac77","line-opacity":1,"line-width":{"base":1.2,"stops":[[12,1],[13,3],[14,4],[20,15]]}}},{"id":"bridge-secondary-tertiary-casing","type":"line","metadata":{"mapbox:group":"1444849334699.1902"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","brunnel","bridge"],["in","class","secondary","tertiary"]],"layout":{"line-join":"round"},"paint":{"line-color":"#e9ac77","line-opacity":1,"line-width":{"base":1.2,"stops":[[8,1.5],[20,28]]}}},{"id":"bridge-trunk-primary-casing","type":"line","metadata":{"mapbox:group":"1444849334699.1902"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","brunnel","bridge"],["in","class","primary","trunk"]],"layout":{"line-join":"round"},"paint":{"line-color":"hsl(28, 76%, 67%)","line-width":{"base":1.2,"stops":[[5,0.4],[6,0.6],[7,1.5],[20,26]]}}},{"id":"bridge-motorway-casing","type":"line","metadata":{"mapbox:group":"1444849334699.1902"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","brunnel","bridge"],["==","class","motorway"]],"layout":{"line-join":"round"},"paint":{"line-color":"#e9ac77","line-width":{"base":1.2,"stops":[[5,0.4],[6,0.6],[7,1.5],[20,22]]},"line-opacity":0.5}},{"id":"bridge-path-casing","type":"line","metadata":{"mapbox:group":"1444849334699.1902"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","$type","LineString"],["all",["==","brunnel","bridge"],["==","class","path"]]],"paint":{"line-color":"#f8f4f0","line-width":{"base":1.2,"stops":[[15,1.2],[20,18]]}}},{"id":"bridge-path","type":"line","metadata":{"mapbox:group":"1444849334699.1902"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","$type","LineString"],["all",["==","brunnel","bridge"],["==","class","path"]]],"paint":{"line-color":"#cba","line-width":{"base":1.2,"stops":[[15,1.2],[20,4]]},"line-dasharray":[1.5,0.75]}},{"id":"bridge-motorway-link","type":"line","metadata":{"mapbox:group":"1444849334699.1902"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","brunnel","bridge"],["==","class","motorway_link"]],"layout":{"line-join":"round"},"paint":{"line-color":"#fc8","line-width":{"base":1.2,"stops":[[12.5,0],[13,1.5],[14,2.5],[20,11.5]]}}},{"id":"bridge-link","type":"line","metadata":{"mapbox:group":"1444849334699.1902"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","brunnel","bridge"],["in","class","primary_link","secondary_link","tertiary_link","trunk_link"]],"layout":{"line-join":"round"},"paint":{"line-color":"#fea","line-width":{"base":1.2,"stops":[[12.5,0],[13,1.5],[14,2.5],[20,11.5]]}}},{"id":"bridge-secondary-tertiary","type":"line","metadata":{"mapbox:group":"1444849334699.1902"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","brunnel","bridge"],["in","class","secondary","tertiary"]],"layout":{"line-join":"round"},"paint":{"line-color":"#fea","line-width":{"base":1.2,"stops":[[6.5,0],[7,0.5],[20,20]]}}},{"id":"bridge-trunk-primary","type":"line","metadata":{"mapbox:group":"1444849334699.1902"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","brunnel","bridge"],["in","class","primary","trunk"]],"layout":{"line-join":"round"},"paint":{"line-color":"#fea","line-width":{"base":1.2,"stops":[[6.5,0],[7,0.5],[20,18]]}}},{"id":"bridge-motorway","type":"line","metadata":{"mapbox:group":"1444849334699.1902"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","brunnel","bridge"],["==","class","motorway"]],"layout":{"line-join":"round"},"paint":{"line-color":"#fc8","line-width":{"base":1.2,"stops":[[6.5,0],[7,0.5],[20,18]]},"line-opacity":0.5}},{"id":"bridge-railway","type":"line","metadata":{"mapbox:group":"1444849334699.1902"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","brunnel","bridge"],["==","class","rail"]],"paint":{"line-color":"#bbb","line-width":{"base":1.4,"stops":[[14,0.4],[15,0.75],[20,2]]}}},{"id":"bridge-railway-hatching","type":"line","metadata":{"mapbox:group":"1444849334699.1902"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","brunnel","bridge"],["==","class","rail"]],"paint":{"line-color":"#bbb","line-dasharray":[0.2,8],"line-width":{"base":1.4,"stops":[[14.5,0],[15,3],[20,8]]}}},{"id":"cablecar","type":"line","source":"openmaptiles","source-layer":"transportation","minzoom":13,"filter":["==","class","cable_car"],"layout":{"visibility":"visible","line-cap":"round"},"paint":{"line-color":"hsl(0, 0%, 70%)","line-width":{"base":1,"stops":[[11,1],[19,2.5]]}}},{"id":"cablecar-dash","type":"line","source":"openmaptiles","source-layer":"transportation","minzoom":13,"filter":["==","class","cable_car"],"layout":{"visibility":"visible","line-cap":"round"},"paint":{"line-color":"hsl(0, 0%, 70%)","line-width":{"base":1,"stops":[[11,3],[19,5.5]]},"line-dasharray":[2,3]}},{"id":"boundary-land-level-4","type":"line","source":"openmaptiles","source-layer":"boundary","filter":["all",[">=","admin_level",4],["<=","admin_level",8],["!=","maritime",1]],"layout":{"line-join":"round"},"paint":{"line-color":"#9e9cab","line-dasharray":[3,1,1,1],"line-width":{"base":1.4,"stops":[[4,0.4],[5,1],[12,3]]},"line-opacity":0.6}},{"id":"boundary-land-level-2","type":"line","source":"openmaptiles","source-layer":"boundary","filter":["all",["==","admin_level",2],["!=","maritime",1],["!=","disputed",1]],"layout":{"line-cap":"round","line-join":"round"},"paint":{"line-color":"hsl(248, 7%, 66%)","line-width":{"base":1,"stops":[[0,0.6],[4,1.4],[5,2],[12,2]]}}},{"id":"boundary-land-disputed","type":"line","source":"openmaptiles","source-layer":"boundary","filter":["all",["!=","maritime",1],["==","disputed",1]],"layout":{"line-cap":"round","line-join":"round"},"paint":{"line-color":"hsl(248, 7%, 70%)","line-dasharray":[1,3],"line-width":{"base":1,"stops":[[0,0.6],[4,1.4],[5,2],[12,8]]}}},{"id":"boundary-water","type":"line","source":"openmaptiles","source-layer":"boundary","filter":["all",["in","admin_level",2,4],["==","maritime",1]],"layout":{"line-cap":"round","line-join":"round"},"paint":{"line-color":"rgba(154, 189, 214, 1)","line-width":{"base":1,"stops":[[0,0.6],[4,1],[5,1],[12,1]]},"line-opacity":{"stops":[[6,0],[10,0]]}}},{"id":"waterway-name","type":"symbol","source":"openmaptiles","source-layer":"waterway","minzoom":13,"filter":["all",["==","$type","LineString"],["has","name"]],"layout":{"text-font":["Noto Sans Italic"],"text-size":14,"text-field":"{name:latin} {name:nonlatin}","text-max-width":5,"text-rotation-alignment":"map","symbol-placement":"line","text-letter-spacing":0.2,"symbol-spacing":350},"paint":{"text-color":"#74aee9","text-halo-width":1.5,"text-halo-color":"rgba(255,255,255,0.7)"}},{"id":"water-name-lakeline","type":"symbol","source":"openmaptiles","source-layer":"water_name","filter":["==","$type","LineString"],"layout":{"text-font":["Noto Sans Italic"],"text-size":14,"text-field":"{name:latin}\\n{name:nonlatin}","text-max-width":5,"text-rotation-alignment":"map","symbol-placement":"line","symbol-spacing":350,"text-letter-spacing":0.2},"paint":{"text-color":"#74aee9","text-halo-width":1.5,"text-halo-color":"rgba(255,255,255,0.7)"}},{"id":"water-name-ocean","type":"symbol","source":"openmaptiles","source-layer":"water_name","filter":["all",["==","$type","Point"],["==","class","ocean"]],"layout":{"text-font":["Noto Sans Italic"],"text-size":14,"text-field":"{name:latin}","text-max-width":5,"text-rotation-alignment":"map","symbol-placement":"point","symbol-spacing":350,"text-letter-spacing":0.2},"paint":{"text-color":"#74aee9","text-halo-width":1.5,"text-halo-color":"rgba(255,255,255,0.7)"}},{"id":"water-name-other","type":"symbol","source":"openmaptiles","source-layer":"water_name","filter":["all",["==","$type","Point"],["!in","class","ocean"]],"layout":{"text-font":["Noto Sans Italic"],"text-size":{"stops":[[0,10],[6,14]]},"text-field":"{name:latin}\\n{name:nonlatin}","text-max-width":5,"text-rotation-alignment":"map","symbol-placement":"point","symbol-spacing":350,"text-letter-spacing":0.2,"visibility":"visible"},"paint":{"text-color":"#74aee9","text-halo-width":1.5,"text-halo-color":"rgba(255,255,255,0.7)"}},{"id":"poi-level-3","type":"symbol","source":"openmaptiles","source-layer":"poi","minzoom":16,"filter":["all",["==","$type","Point"],[">=","rank",25]],"layout":{"text-padding":2,"text-font":["Noto Sans Regular"],"text-anchor":"top","icon-image":"{class}_11","text-field":"{name:latin}\\n{name:nonlatin}","text-offset":[0,0.6],"text-size":12,"text-max-width":9},"paint":{"text-halo-blur":0.5,"text-color":"#666","text-halo-width":1,"text-halo-color":"#ffffff"}},{"id":"poi-level-2","type":"symbol","source":"openmaptiles","source-layer":"poi","minzoom":15,"filter":["all",["==","$type","Point"],["<=","rank",24],[">=","rank",15]],"layout":{"text-padding":2,"text-font":["Noto Sans Regular"],"text-anchor":"top","icon-image":"{class}_11","text-field":"{name:latin}\\n{name:nonlatin}","text-offset":[0,0.6],"text-size":12,"text-max-width":9},"paint":{"text-halo-blur":0.5,"text-color":"#666","text-halo-width":1,"text-halo-color":"#ffffff"}},{"id":"poi-level-1","type":"symbol","source":"openmaptiles","source-layer":"poi","minzoom":14,"filter":["all",["==","$type","Point"],["<=","rank",14],["has","name"]],"layout":{"text-padding":2,"text-font":["Noto Sans Regular"],"text-anchor":"top","icon-image":"{class}_11","text-field":"{name:latin}\\n{name:nonlatin}","text-offset":[0,0.6],"text-size":11,"text-max-width":9},"paint":{"text-halo-blur":0.5,"text-color":"rgba(191, 228, 172, 1)","text-halo-width":1,"text-halo-color":"rgba(30, 29, 29, 1)"}},{"id":"poi-railway","type":"symbol","source":"openmaptiles","source-layer":"poi","minzoom":13,"filter":["all",["==","$type","Point"],["has","name"],["==","class","railway"],["==","subclass","station"]],"layout":{"text-padding":2,"text-font":["Noto Sans Regular"],"text-anchor":"top","icon-image":"{class}_11","text-field":"{name:latin}\\n{name:nonlatin}","text-offset":[0,0.6],"text-size":12,"text-max-width":9,"icon-optional":false,"icon-ignore-placement":false,"icon-allow-overlap":false,"text-ignore-placement":false,"text-allow-overlap":false,"text-optional":true},"paint":{"text-halo-blur":0.5,"text-color":"#666","text-halo-width":1,"text-halo-color":"#ffffff"}},{"id":"road_oneway","type":"symbol","source":"openmaptiles","source-layer":"transportation","minzoom":15,"filter":["all",["==","oneway",1],["in","class","motorway","trunk","primary","secondary","tertiary","minor","service"]],"layout":{"symbol-placement":"line","icon-image":"oneway","symbol-spacing":75,"icon-padding":2,"icon-rotation-alignment":"map","icon-rotate":90,"icon-size":{"stops":[[15,0.5],[19,1]]}},"paint":{"icon-opacity":0.5}},{"id":"road_oneway_opposite","type":"symbol","source":"openmaptiles","source-layer":"transportation","minzoom":15,"filter":["all",["==","oneway",-1],["in","class","motorway","trunk","primary","secondary","tertiary","minor","service"]],"layout":{"symbol-placement":"line","icon-image":"oneway","symbol-spacing":75,"icon-padding":2,"icon-rotation-alignment":"map","icon-rotate":-90,"icon-size":{"stops":[[15,0.5],[19,1]]}},"paint":{"icon-opacity":0.5}},{"id":"highway-name-path","type":"symbol","source":"openmaptiles","source-layer":"transportation_name","minzoom":15.5,"filter":["==","class","path"],"layout":{"text-size":{"base":1,"stops":[[13,12],[14,13]]},"text-font":["Noto Sans Regular"],"text-field":"{name:latin} {name:nonlatin}","symbol-placement":"line","text-rotation-alignment":"map"},"paint":{"text-halo-color":"#f8f4f0","text-color":"hsl(30, 23%, 62%)","text-halo-width":0.5}},{"id":"highway-name-minor","type":"symbol","source":"openmaptiles","source-layer":"transportation_name","minzoom":15,"filter":["all",["==","$type","LineString"],["in","class","minor","service","track"]],"layout":{"text-size":{"base":1,"stops":[[13,12],[14,13]]},"text-font":["Noto Sans Regular"],"text-field":"{name:latin} {name:nonlatin}","symbol-placement":"line","text-rotation-alignment":"map"},"paint":{"text-halo-blur":0.5,"text-color":"#765","text-halo-width":1}},{"id":"highway-name-major","type":"symbol","source":"openmaptiles","source-layer":"transportation_name","minzoom":12.2,"filter":["in","class","primary","secondary","tertiary","trunk"],"layout":{"text-size":{"base":1,"stops":[[13,12],[14,13]]},"text-font":["Noto Sans Regular"],"text-field":"{name:latin} {name:nonlatin}","symbol-placement":"line","text-rotation-alignment":"map"},"paint":{"text-halo-blur":0.5,"text-color":"#765","text-halo-width":1}},{"id":"highway-shield","type":"symbol","source":"openmaptiles","source-layer":"transportation_name","minzoom":8,"filter":["all",["<=","ref_length",6],["==","$type","LineString"],["!in","network","us-interstate","us-highway","us-state"]],"layout":{"text-size":10,"icon-image":"road_{ref_length}","icon-rotation-alignment":"viewport","symbol-spacing":200,"text-font":["Noto Sans Regular"],"symbol-placement":{"base":1,"stops":[[10,"point"],[11,"line"]]},"text-rotation-alignment":"viewport","icon-size":1,"text-field":"{ref}"},"paint":{"text-opacity":1,"text-color":"rgba(20, 19, 19, 1)","text-halo-color":"rgba(230, 221, 221, 0)","text-halo-width":2,"icon-color":"rgba(183, 18, 18, 1)","icon-opacity":0.3,"icon-halo-color":"rgba(183, 55, 55, 0)"}},{"id":"highway-shield-us-interstate","type":"symbol","source":"openmaptiles","source-layer":"transportation_name","minzoom":7,"filter":["all",["<=","ref_length",6],["==","$type","LineString"],["in","network","us-interstate"]],"layout":{"text-size":10,"icon-image":"{network}_{ref_length}","icon-rotation-alignment":"viewport","symbol-spacing":200,"text-font":["Noto Sans Regular"],"symbol-placement":{"base":1,"stops":[[7,"point"],[7,"line"],[8,"line"]]},"text-rotation-alignment":"viewport","icon-size":1,"text-field":"{ref}"},"paint":{"text-color":"rgba(0, 0, 0, 1)"}},{"id":"highway-shield-us-other","type":"symbol","source":"openmaptiles","source-layer":"transportation_name","minzoom":9,"filter":["all",["<=","ref_length",6],["==","$type","LineString"],["in","network","us-highway","us-state"]],"layout":{"text-size":10,"icon-image":"{network}_{ref_length}","icon-rotation-alignment":"viewport","symbol-spacing":200,"text-font":["Noto Sans Regular"],"symbol-placement":{"base":1,"stops":[[10,"point"],[11,"line"]]},"text-rotation-alignment":"viewport","icon-size":1,"text-field":"{ref}"},"paint":{"text-color":"rgba(0, 0, 0, 1)"}},{"id":"place-other","type":"symbol","metadata":{"mapbox:group":"1444849242106.713"},"source":"openmaptiles","source-layer":"place","minzoom":12,"filter":["!in","class","city","town","village","country","continent"],"layout":{"text-letter-spacing":0.1,"text-size":{"base":1.2,"stops":[[12,10],[15,14]]},"text-font":["Noto Sans Bold"],"text-field":"{name:latin}\\n{name:nonlatin}","text-transform":"uppercase","text-max-width":9,"visibility":"visible"},"paint":{"text-color":"rgba(255,255,255,1)","text-halo-width":1.2,"text-halo-color":"rgba(57, 28, 28, 1)"}},{"id":"place-village","type":"symbol","metadata":{"mapbox:group":"1444849242106.713"},"source":"openmaptiles","source-layer":"place","minzoom":10,"filter":["==","class","village"],"layout":{"text-font":["Noto Sans Regular"],"text-size":{"base":1.2,"stops":[[10,12],[15,16]]},"text-field":"{name:latin}\\n{name:nonlatin}","text-max-width":8,"visibility":"visible"},"paint":{"text-color":"rgba(255, 255, 255, 1)","text-halo-width":1.2,"text-halo-color":"rgba(10, 9, 9, 0.8)"}},{"id":"place-town","type":"symbol","metadata":{"mapbox:group":"1444849242106.713"},"source":"openmaptiles","source-layer":"place","filter":["==","class","town"],"layout":{"text-font":["Noto Sans Regular"],"text-size":{"base":1.2,"stops":[[10,14],[15,24]]},"text-field":"{name:latin}\\n{name:nonlatin}","text-max-width":8,"visibility":"visible"},"paint":{"text-color":"rgba(255, 255, 255, 1)","text-halo-width":1.2,"text-halo-color":"rgba(22, 22, 22, 0.8)"}},{"id":"place-city","type":"symbol","metadata":{"mapbox:group":"1444849242106.713"},"source":"openmaptiles","source-layer":"place","filter":["all",["!=","capital",2],["==","class","city"]],"layout":{"text-font":["Noto Sans Regular"],"text-size":{"base":1.2,"stops":[[7,14],[11,24]]},"text-field":"{name:latin}\\n{name:nonlatin}","text-max-width":8,"visibility":"visible"},"paint":{"text-color":"rgba(0, 0, 0, 1)","text-halo-width":1.2,"text-halo-color":"rgba(255,255,255,0.8)"}},{"id":"place-city-capital","type":"symbol","metadata":{"mapbox:group":"1444849242106.713"},"source":"openmaptiles","source-layer":"place","filter":["all",["==","capital",2],["==","class","city"]],"layout":{"text-font":["Noto Sans Regular"],"text-size":{"base":1.2,"stops":[[7,14],[11,24]]},"text-field":"{name:latin}\\n{name:nonlatin}","text-max-width":8,"icon-image":"star_11","text-offset":[0.4,0],"icon-size":0.8,"text-anchor":"left","visibility":"visible"},"paint":{"text-color":"#333","text-halo-width":1.2,"text-halo-color":"rgba(255,255,255,0.8)"}},{"id":"place-country-other","type":"symbol","metadata":{"mapbox:group":"1444849242106.713"},"source":"openmaptiles","source-layer":"place","filter":["all",["==","class","country"],[">=","rank",3],["!has","iso_a2"]],"layout":{"text-font":["Noto Sans Italic"],"text-field":"{name:latin}","text-size":{"stops":[[3,11],[7,17]]},"text-transform":"uppercase","text-max-width":6.25,"visibility":"visible"},"paint":{"text-halo-blur":1,"text-color":"#334","text-halo-width":2,"text-halo-color":"rgba(255,255,255,0.8)"}},{"id":"place-country-3","type":"symbol","metadata":{"mapbox:group":"1444849242106.713"},"source":"openmaptiles","source-layer":"place","filter":["all",["==","class","country"],[">=","rank",3],["has","iso_a2"]],"layout":{"text-font":["Noto Sans Bold"],"text-field":"{name:latin}","text-size":{"stops":[[3,11],[7,17]]},"text-transform":"uppercase","text-max-width":6.25,"visibility":"visible"},"paint":{"text-halo-blur":1,"text-color":"#334","text-halo-width":2,"text-halo-color":"rgba(255,255,255,0.8)"}},{"id":"place-country-2","type":"symbol","metadata":{"mapbox:group":"1444849242106.713"},"source":"openmaptiles","source-layer":"place","filter":["all",["==","class","country"],["==","rank",2],["has","iso_a2"]],"layout":{"text-font":["Noto Sans Bold"],"text-field":"{name:latin}","text-size":{"stops":[[2,11],[5,17]]},"text-transform":"uppercase","text-max-width":6.25,"visibility":"visible"},"paint":{"text-halo-blur":1,"text-color":"#334","text-halo-width":2,"text-halo-color":"rgba(255,255,255,0.8)"}},{"id":"place-country-1","type":"symbol","metadata":{"mapbox:group":"1444849242106.713"},"source":"openmaptiles","source-layer":"place","filter":["all",["==","class","country"],["==","rank",1],["has","iso_a2"]],"layout":{"text-font":["Noto Sans Bold"],"text-field":"{name:latin}","text-size":{"stops":[[1,11],[4,17]]},"text-transform":"uppercase","text-max-width":6.25,"visibility":"visible"},"paint":{"text-halo-blur":1,"text-color":"#334","text-halo-width":2,"text-halo-color":"rgba(255,255,255,0.8)"}},{"id":"place-continent","type":"symbol","metadata":{"mapbox:group":"1444849242106.713"},"source":"openmaptiles","source-layer":"place","maxzoom":1,"filter":["==","class","continent"],"layout":{"text-font":["Noto Sans Bold"],"text-field":"{name:latin}","text-size":14,"text-max-width":6.25,"text-transform":"uppercase","visibility":"visible"},"paint":{"text-halo-blur":1,"text-color":"#334","text-halo-width":2,"text-halo-color":"rgba(255,255,255,0.8)"}}],"id":"qebnlkra6"}');

/***/ }),

/***/ 51962:
/***/ (function(module) {

"use strict";
module.exports = /*#__PURE__*/JSON.parse('{"version":8,"name":"orto","metadata":{},"center":[1.537786,41.837539],"zoom":12,"bearing":0,"pitch":0,"light":{"anchor":"viewport","color":"white","intensity":0.4,"position":[1.15,45,30]},"sources":{"ortoEsri":{"type":"raster","tiles":["https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"],"tileSize":256,"maxzoom":18,"attribution":"ESRI &copy; <a href=\'http://www.esri.com\'>ESRI</a>"},"ortoInstaMaps":{"type":"raster","tiles":["https://tilemaps.icgc.cat/mapfactory/wmts/orto_8_12/CAT3857/{z}/{x}/{y}.png"],"tileSize":256,"maxzoom":13},"ortoICGC":{"type":"raster","tiles":["https://geoserveis.icgc.cat/icc_mapesmultibase/noutm/wmts/orto/GRID3857/{z}/{x}/{y}.jpeg"],"tileSize":256,"minzoom":13.1,"maxzoom":20},"openmaptiles":{"type":"vector","url":"https://geoserveis.icgc.cat/contextmaps/basemap.json"}},"sprite":"https://geoserveis.icgc.cat/contextmaps/sprites/sprite@1","glyphs":"https://geoserveis.icgc.cat/contextmaps/glyphs/{fontstack}/{range}.pbf","layers":[{"id":"background","type":"background","paint":{"background-color":"#F4F9F4"}},{"id":"ortoEsri","type":"raster","source":"ortoEsri","maxzoom":16,"layout":{"visibility":"visible"}},{"id":"ortoICGC","type":"raster","source":"ortoICGC","minzoom":13.1,"maxzoom":19,"layout":{"visibility":"visible"}},{"id":"ortoInstaMaps","type":"raster","source":"ortoInstaMaps","maxzoom":13,"layout":{"visibility":"visible"}}]}');

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	!function() {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	!function() {
/******/ 		__webpack_require__.b = document.baseURI || self.location.href;
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			792: 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		// no on chunks loaded
/******/ 		
/******/ 		// no jsonp function
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/nonce */
/******/ 	!function() {
/******/ 		__webpack_require__.nc = undefined;
/******/ 	}();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module is referenced by other modules so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__(20260);
/******/ 	
/******/ 	return __webpack_exports__;
/******/ })()
;
});